
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("76Weg", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ff35acd8df483e6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $hGgHi = parcelRequire("hGgHi");

var $imZsD = parcelRequire("imZsD");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $AeWM3 = parcelRequire("AeWM3");

var $aWb5p = parcelRequire("aWb5p");

var $jD5no = parcelRequire("jD5no");

var $lf2Au = parcelRequire("lf2Au");

var $x9xyg = parcelRequire("x9xyg");

var $j2mQS = parcelRequire("j2mQS");

var $bRUzT = parcelRequire("bRUzT");

var $9pe79 = parcelRequire("9pe79");

var $4R6GH = parcelRequire("4R6GH");

var $97Kan = parcelRequire("97Kan");

var $joFsm = parcelRequire("joFsm");

var $3HwlS = parcelRequire("3HwlS");

var $2NMNM = parcelRequire("2NMNM");

var $8PRuf = parcelRequire("8PRuf");


var $hN2XX = parcelRequire("hN2XX");

var $bicfN = parcelRequire("bicfN");

var $1bQGJ = parcelRequire("1bQGJ");

var $10Ngv = parcelRequire("10Ngv");

var $9s7RG = parcelRequire("9s7RG");

var $5kotP = parcelRequire("5kotP");

var $guzeq = parcelRequire("guzeq");

var $cinXQ = parcelRequire("cinXQ");

var $81CEh = parcelRequire("81CEh");

var $3FUwR = parcelRequire("3FUwR");

var $5qbje = parcelRequire("5qbje");

var $gUpx5 = parcelRequire("gUpx5");

var $8hVbJ = parcelRequire("8hVbJ");

var $3lZ6i = parcelRequire("3lZ6i");

var $a7yHf = parcelRequire("a7yHf");

var $bNDq8 = parcelRequire("bNDq8");

var $c7Xu8 = parcelRequire("c7Xu8");

var $bI3co = parcelRequire("bI3co");

var $lHBhO = parcelRequire("lHBhO");

var $c1MAf = parcelRequire("c1MAf");

var $gshHs = parcelRequire("gshHs");

var $hzdKw = parcelRequire("hzdKw");

var $9OvEV = parcelRequire("9OvEV");

var $dM9vk = parcelRequire("dM9vk");

var $8UYjN = parcelRequire("8UYjN");
/**
 * Set performance marks for rendering performance
 */ function $5ff35acd8df483e6$var$measureRender() {
    (0, $x9xyg.setMark)('render:start');
    requestAnimationFrame(()=>{
        (0, $x9xyg.setMark)('render:end');
        (0, $x9xyg.setMeasure)('render', 'render:start', 'render:end');
    });
}
// eslint-disable-next-line jira/react/no-class-components
class $5ff35acd8df483e6$var$Backlog extends (0, $5uXOq.Component) {
    static{
        // go/jfe-eslint
        // eslint-disable-next-line react/sort-comp
        this.defaultProps = {
            isServer: false,
            isCompanyManaged: false,
            initialState: {}
        };
    }
    static getAppPropsFromProps(props) {
        return {
            locale: props.locale,
            baseUrl: props.baseUrl,
            rapidViewId: props.rapidViewId,
            isCompanyManaged: props.isCompanyManaged ?? false,
            xsrfToken: props.xsrfToken,
            projectKey: props.projectKey,
            projectId: props.projectId,
            projectName: props.projectName,
            cloudId: props.cloudId,
            atlassianAccountId: props.atlassianAccountId
        };
    }
    constructor(props){
        super(props), this.prefetchedData = null, this.hasRendered = false, this.onGetLocation = ()=>this.props.location, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onPush = (path, state)=>{
            this.props.push(path, state);
        };
        const { isCompanyManaged: isCompanyManaged } = props;
        const metric = isCompanyManaged ? (0, $8hVbJ.uifBacklogNewUiPageLoad) : (0, $8hVbJ.nextGenBacklogPageLoad);
        metric.mark((0, $8hVbJ.PAGE_LOAD_MARK_CONSTRUCTOR_START));
        metric.mark((0, $8hVbJ.PAGE_LOAD_MARK_REDUX_START));
        const rootEpic = (0, $cinXQ.default)(props.isServer, props.isCompanyManaged, ()=>this.props.location, props.push, props.replace, (0, $AeWM3.getClient)(props.baseUrl, (0, $aWb5p.default), props.xsrfToken));
        (0, $x9xyg.setMark)((0, $8PRuf.jswCreateReduxStoreStartMark));
        const createStoreOptions = {
            rootEpic: (0, $j2mQS.disposableEpic)(rootEpic),
            dependencies: {
                isCompanyManaged: isCompanyManaged,
                storeFieldsActions: props.storeFieldsActions,
                refetchVersionsForProjects: props.refetchVersionsForProjects,
                createAnalyticsEvent: props.createAnalyticsEvent
            }
        };
        this.store = (0, $c1MAf.createStoreWithCache)(props.rapidViewId, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        props.initialState ?? {}, {
            ...createStoreOptions,
            disableStoreCaches: props.disableStoreCaches ?? false
        });
        (0, $x9xyg.setMark)((0, $8PRuf.jswCreateReduxStoreEndMark));
        (0, $x9xyg.setMeasure)('create-redux-store', (0, $8PRuf.jswCreateReduxStoreStartMark), (0, $8PRuf.jswCreateReduxStoreEndMark));
        this.store.dispatch((0, $3lZ6i.initializeAppProps)($5ff35acd8df483e6$var$Backlog.getAppPropsFromProps(props)));
        // Fire multiple requests to get data for the board. GraphQL please save us.
        (0, $x9xyg.measureFunc)('loadAppData', ()=>{
            if (props.isCompanyManaged) {
                if ((0, $4R6GH.fg)('indexeddb_cache_for_backlog')) {
                    if (props.prefetchCmpBacklogDataPromise) props.prefetchCmpBacklogDataPromise.then((data)=>{
                        this.store.dispatch((0, $3lZ6i.loadAppData)({
                            prefetchCmpBacklogData: data
                        }));
                    });
                    else this.store.dispatch((0, $3lZ6i.loadAppData)());
                } else if (props.prefetchedJiraPlanRestDataPromise && !(0, $4R6GH.fg)('prioritise_resolved_data_for_backlog')) // TODO: Handle error
                props.prefetchedJiraPlanRestDataPromise.then((data)=>{
                    this.store.dispatch((0, $3lZ6i.loadAppData)({
                        prefetchedJiraPlanRestData: data
                    }));
                });
                else if (props.prefetchedJiraPlanRestData) this.store.dispatch((0, $3lZ6i.loadAppData)({
                    prefetchedJiraPlanRestData: props.prefetchedJiraPlanRestData
                }));
                else if (props.prefetchedJiraPlanRestDataPromise && (0, $4R6GH.fg)('prioritise_resolved_data_for_backlog')) // TODO: Handle error
                props.prefetchedJiraPlanRestDataPromise.then((data)=>{
                    this.store.dispatch((0, $3lZ6i.loadAppData)({
                        prefetchedJiraPlanRestData: data
                    }));
                });
                else this.store.dispatch((0, $3lZ6i.loadAppData)());
            } else if (props.prefetchedData) {
                this.prefetchedData = props.prefetchedData;
                this.store.dispatch((0, $3lZ6i.loadAppData)({
                    prefetchedData: props.prefetchedData
                }));
            } else this.store.dispatch((0, $3lZ6i.loadAppData)());
        });
        (0, $x9xyg.measureFunc)('loadConfigData', ()=>{
            // TODO Preload config data in TMP
            if (!(0, $4R6GH.fg)('jsw-backlog-preload-config-data') || !isCompanyManaged) this.store.dispatch((0, $3lZ6i.loadConfigData)());
            if (isCompanyManaged && this.props.prefetchCmpConfigDataPromise && this.props.prefetchCmpGlobalConfigDataPromise && (0, $4R6GH.fg)('jsw-backlog-preload-config-data')) Promise.all([
                this.props.prefetchCmpConfigDataPromise,
                this.props.prefetchCmpGlobalConfigDataPromise
            ]).then(([configData, globalConfigData])=>{
                if (configData && globalConfigData) this.store.dispatch((0, $3lZ6i.loadConfigDataModelSuccess)((0, $8UYjN.transformer)(configData.result, globalConfigData.result, this.props.isCompanyManaged)));
                else throw new Error('Failed to load config data');
            });
            this.store.dispatch((0, $c7Xu8.loadPriorities)());
            // This isn't required on the server, so it shouldn't be requested.
            if (!false) this.store.dispatch((0, $bI3co.requestCurrentUser)());
        });
        (0, $x9xyg.measureFunc)('setCollapsedCardLists', ()=>{
            const lists = (0, $3FUwR.getBacklogSettings)(Number(props.rapidViewId)).collapsedCardLists;
            if (lists) {
                const listsIds = Object.keys(lists);
                if (listsIds.length > 0) this.store.dispatch((0, $a7yHf.setCollapsedCardLists)(listsIds));
            }
        });
        (0, $x9xyg.measureFunc)('setCollapsedCardGroups', ()=>{
            const groups = (0, $3FUwR.getBacklogCardGroupSettings)(Number(props.rapidViewId));
            if (groups) {
                const groupIds = Object.keys(groups);
                if (groupIds.length > 0) this.store.dispatch((0, $a7yHf.setCollapsedCardGroups)(groupIds));
            }
        });
        (0, $x9xyg.measureFunc)('setExpandedCardGroups', ()=>{
            const groups = (0, $3FUwR.getBacklogCardGroupSettings)(Number(props.rapidViewId));
            if (groups) {
                const groupIds = Object.keys(groups);
                if (groupIds.length > 0) this.store.dispatch((0, $a7yHf.setExpandedCardGroups)(groupIds));
            }
        });
        (0, $x9xyg.measureFunc)('toggleHiddenLabels', ()=>{
            if (isCompanyManaged) {
                const willHideEpicLabels = (0, $81CEh.getHideEpics)(props.rapidViewId);
                this.store.dispatch((0, $bNDq8.toggleCardEpicFields)(willHideEpicLabels));
                const willToggleStatusLabels = (0, $81CEh.getHideStatuses)(props.rapidViewId);
                this.store.dispatch((0, $bNDq8.toggleCardStatusFields)(willToggleStatusLabels));
                const willToggleVersionLabels = (0, $81CEh.getHideVersions)(props.rapidViewId);
                this.store.dispatch((0, $bNDq8.toggleCardVersionFields)(willToggleVersionLabels));
            }
        });
        (0, $x9xyg.measureFunc)('setIncludeSubtasksInWorkloadModal', ()=>{
            if (isCompanyManaged) {
                const includeSubtasksLocal = (0, $3FUwR.getWorkloadSubtaskSettings)();
                this.store.dispatch((0, $lHBhO.setIncludeSubtasksAction)(includeSubtasksLocal));
            }
        });
        metric.mark((0, $8hVbJ.PAGE_LOAD_MARK_REDUX_END));
        metric.mark((0, $8hVbJ.PAGE_LOAD_MARK_CONSTRUCTOR_END));
    }
    componentDidMount() {
        this.hasRendered = true;
        (0, $5qbje.removeLocationLegacyPanelQueryParameters)(this.props.location, this.props.push);
    }
    componentDidUpdate(prevProps) {
        const prevAppProps = $5ff35acd8df483e6$var$Backlog.getAppPropsFromProps(prevProps);
        const appProps = $5ff35acd8df483e6$var$Backlog.getAppPropsFromProps(this.props);
        if (this.props.isCompanyManaged && prevProps.rapidViewId !== this.props.rapidViewId && (0, $4R6GH.fg)('backlog-reset-data-when-data-updates')) this.store.dispatch((0, $3lZ6i.loadAppData)({
            prefetchedJiraPlanRestData: this.props.prefetchedJiraPlanRestData
        }));
        // If our resource cache data is different, load it up!!!
        // We fire a refresh on cached mount and it will proc this lifecycle event
        // See src/packages/spa-apps/nextgen-backlog/src/resources-cache-refresh
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(prevProps.prefetchedData, this.props.prefetchedData)) // if this has a source key, and the key is the one we get from the resources
        // cache updater. Don't process it.
        {
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(this.props.prefetchedData) && (!((0, $8631d6ce464ccf2e$export$889129cf7f70997b) in this.props.prefetchedData) || this.props.prefetchedData[0, $8631d6ce464ccf2e$export$889129cf7f70997b] !== (0, $8631d6ce464ccf2e$export$b7dfe28569b170a1))) {
                // fires an analytics event to track that the cache is stale and will be updated
                (0, $hN2XX.triggerCacheRefreshAnalytics)((0, $8631d6ce464ccf2e$export$dedbdcc35e955187));
                this.store.dispatch((0, $3lZ6i.loadAppData)({
                    prefetchedData: this.props.prefetchedData
                }));
            }
        }
        if ((0, $9pe79.default)(prevAppProps, appProps)) return;
        this.store.dispatch((0, $3lZ6i.initializeAppProps)(appProps));
    }
    componentWillUnmount() {
        if (this.store && this.store.dispatch) this.store.dispatch((0, $bRUzT.DISPOSE_ACTION));
        (0, $c1MAf.unmountCachedStore)();
    }
    renderContent() {
        const { rapidViewId: rapidViewId, isCacheHit: isCacheHit, customFiltersQueryRef: customFiltersQueryRef, versionFilterRelayQueryRef: versionFilterRelayQueryRef, prefetchedJiraPlanRestData: prefetchedJiraPlanRestData, prefetchCmpBacklogData: prefetchCmpBacklogData } = this.props;
        const inner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dM9vk.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OvEV.default), {
            isCacheHit: isCacheHit,
            prefetchedData: this.prefetchedData,
            prefetchedPlanData: (0, $4R6GH.fg)('indexeddb_cache_for_backlog') ? prefetchCmpBacklogData?.result : prefetchedJiraPlanRestData,
            getLocation: this.onGetLocation,
            push: this.onPush,
            customFiltersQueryRef: customFiltersQueryRef,
            versionFilterRelayQueryRef: versionFilterRelayQueryRef
        })));
        const AppStyleComponent = (0, $3HwlS.getWillShowNav4)() ? $5ff35acd8df483e6$var$ContentAppStyle : (0, $lf2Au.default);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AppStyleComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gshHs.default), {
            boardId: Number(rapidViewId)
        }, inner), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $97Kan.FlagsDispatcher), {
            mapper: (0, $5kotP.flagsMapper)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bicfN.default), {
            origin: (0, $8631d6ce464ccf2e$export$dedbdcc35e955187)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $joFsm.default), {
            getCustomData: (0, $gUpx5.getCustomDataForMemoryAnalyticsFromUrl)
        }));
    }
    render() {
        const { isCompanyManaged: isCompanyManaged } = this.props;
        const metric = isCompanyManaged ? (0, $8hVbJ.uifBacklogNewUiPageLoad) : (0, $8hVbJ.nextGenBacklogPageLoad);
        if (!this.hasRendered) {
            (0, $x9xyg.setMark)((0, $8PRuf.jswRenderStartMark));
            metric.mark((0, $8hVbJ.PAGE_LOAD_MARK_RENDER_START));
            $5ff35acd8df483e6$var$measureRender();
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
            id: (0, $guzeq.APP_ID),
            teamName: (0, $guzeq.TEAM_NAME),
            packageName: (0, $guzeq.PACKAGE_NAME),
            store: this.store,
            fallback: "page"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c1MAf.BacklogReduxProvider), {
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hzdKw.default), {
            bindToOnJiraGlobalIssueCreateClose: this.props.bindToOnJiraGlobalIssueCreateClose
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $AeWM3.ApolloClientProvider), {
            client: (0, $aWb5p.default)
        }, this.renderContent())));
    }
}
const $5ff35acd8df483e6$var$BacklogWrapper = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>{
    const storeFieldsActions = (0, $10Ngv.useStoreFields)();
    const refetchVersions = (0, $9s7RG.useVersionsRefetch)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5ff35acd8df483e6$var$Backlog, {
        ...props,
        storeFieldsActions: storeFieldsActions,
        refetchVersionsForProjects: refetchVersions,
        createAnalyticsEvent: createAnalyticsEvent
    });
});
// withRouter types are wrong
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $5ff35acd8df483e6$var$BacklogWithRouter = (0, $1bQGJ.withRouter)($5ff35acd8df483e6$var$BacklogWrapper);
var $5ff35acd8df483e6$export$2e2bcd8739ae039 = $5ff35acd8df483e6$var$BacklogWithRouter;
const $5ff35acd8df483e6$var$ContentAppStyle = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $5ff35acd8df483e6$var$contentStyle
    }, children);
const $5ff35acd8df483e6$var$contentStyle = (0, $8CUq3.xcss)({
    font: 'font.body',
    height: 'inherit',
    display: 'contents'
});

});
parcelRegister("AeWM3", function(module, exports) {

$parcel$export(module.exports, "resetCache", () => $63ae5caf575c2d55$export$6e5dca841bdf93e3);
$parcel$export(module.exports, "resetCacheAsync", () => $63ae5caf575c2d55$export$cd62f60830f74ae2);
$parcel$export(module.exports, "getClient", () => $63ae5caf575c2d55$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "ApolloClientProvider", () => $63ae5caf575c2d55$export$8e363dbef886ff17);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $bvsgq = parcelRequire("bvsgq");

var $9OXo1 = parcelRequire("9OXo1");
const $63ae5caf575c2d55$var$CLIENTS_CACHE = {};
const $63ae5caf575c2d55$export$6e5dca841bdf93e3 = (clientId)=>{
    // we need to `clearStore` directly to the InMemoryCache instance
    $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId]?.clearStore();
    delete $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
};
const $63ae5caf575c2d55$export$cd62f60830f74ae2 = async (clientId)=>{
    // we need to `clearStore` directly to the InMemoryCache instance
    const client = $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
    delete $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
    await client?.clearStore();
};
const $63ae5caf575c2d55$export$44dd3e9494f887fc = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys($63ae5caf575c2d55$var$CLIENTS_CACHE).reduce((acc, key)=>Object.assign(acc, {
            [`apollo-cache/${key}`]: $63ae5caf575c2d55$var$CLIENTS_CACHE[key].extract()
        }), {});
const $63ae5caf575c2d55$export$6bb76d6eba7e258c = (baseUrl, { clientId: clientId, clientCreator: clientCreator }, xsrfToken)=>{
    let client = $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
    if (!client) {
        client = clientCreator(baseUrl, xsrfToken);
        $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId] = client;
    }
    return client;
};
class $63ae5caf575c2d55$export$8e363dbef886ff17 extends (0, $5uXOq.Component) {
    getClient(baseUrl, xsrfToken) {
        return $63ae5caf575c2d55$export$6bb76d6eba7e258c(baseUrl, this.props.client, xsrfToken != null ? xsrfToken : undefined);
    }
    render() {
        const { children: children } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(this.props, 'client.clientId')) throw new Error('Please provide a client configuration');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
            const client = this.getClient(tenantContext.baseUrl, tenantContext.xsrfToken);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bvsgq.ApolloProvider), {
                client: client
            }, children);
        });
    }
}

});
parcelRegister("bvsgq", function(module, exports) {

$parcel$export(module.exports, "getApolloContext", () => $02296d7a3662bd2d$export$a47505d961ee3a1);
$parcel$export(module.exports, "ApolloProvider", () => $02296d7a3662bd2d$export$c16b04c8a9956446);
$parcel$export(module.exports, "DocumentType", () => $02296d7a3662bd2d$export$d1d99cf900472499);
$parcel$export(module.exports, "operationName", () => $02296d7a3662bd2d$export$5db520940cf00715);
$parcel$export(module.exports, "parser", () => $02296d7a3662bd2d$export$8f49e4af10703ce3);

var $5uXOq = parcelRequire("5uXOq");

var $1DiV8 = parcelRequire("1DiV8");
var $02296d7a3662bd2d$var$apolloContext;
function $02296d7a3662bd2d$export$a47505d961ee3a1() {
    if (!$02296d7a3662bd2d$var$apolloContext) $02296d7a3662bd2d$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({});
    return $02296d7a3662bd2d$var$apolloContext;
}
function $02296d7a3662bd2d$export$c2ee824bcc89ca6a() {
    $02296d7a3662bd2d$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({});
}
var $02296d7a3662bd2d$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = $02296d7a3662bd2d$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ApolloContext.Consumer, null, function(context) {
        if (context === void 0) context = {};
        if (client && context.client !== client) context = Object.assign({}, context, {
            client: client
        });
        (0, $1DiV8.invariant)(context.client, 5);
        return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ApolloContext.Provider, {
            value: context
        }, children);
    });
};
var $02296d7a3662bd2d$export$ed5ceab8c2bb5ce4 = function(props) {
    var ApolloContext = $02296d7a3662bd2d$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ApolloContext.Consumer, null, function(context) {
        (0, $1DiV8.invariant)(context && context.client, 6);
        return props.children(context.client);
    });
};
var $02296d7a3662bd2d$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($02296d7a3662bd2d$export$d1d99cf900472499 || ($02296d7a3662bd2d$export$d1d99cf900472499 = {}));
var $02296d7a3662bd2d$var$cache = new Map();
function $02296d7a3662bd2d$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $02296d7a3662bd2d$export$d1d99cf900472499.Query:
            name = 'Query';
            break;
        case $02296d7a3662bd2d$export$d1d99cf900472499.Mutation:
            name = 'Mutation';
            break;
        case $02296d7a3662bd2d$export$d1d99cf900472499.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function $02296d7a3662bd2d$export$8f49e4af10703ce3(document) {
    var cached = $02296d7a3662bd2d$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $1DiV8.invariant)(!!document && !!document.kind, 1);
    var fragments = document.definitions.filter(function(x) {
        return x.kind === 'FragmentDefinition';
    });
    var queries = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'query';
    });
    var mutations = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'mutation';
    });
    var subscriptions = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'subscription';
    });
    (0, $1DiV8.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
    (0, $1DiV8.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3);
    type = queries.length ? $02296d7a3662bd2d$export$d1d99cf900472499.Query : $02296d7a3662bd2d$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $02296d7a3662bd2d$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $1DiV8.invariant)(definitions.length === 1, 4);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
    else name = 'data';
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $02296d7a3662bd2d$var$cache.set(document, payload);
    return payload;
}

});


parcelRegister("aWb5p", function(module, exports) {

$parcel$export(module.exports, "default", () => $de6560d9e86b64da$export$2e2bcd8739ae039);

var $9XE6b = parcelRequire("9XE6b");

var $ivfDv = parcelRequire("ivfDv");

var $e3a3O = parcelRequire("e3a3O");

var $clSzL = parcelRequire("clSzL");

var $43WKH = parcelRequire("43WKH");

var $h4ppL = parcelRequire("h4ppL");

var $JPsIz = parcelRequire("JPsIz");

var $lC4FX = parcelRequire("lC4FX");

var $cuKXc = parcelRequire("cuKXc");

var $4tcSU = parcelRequire("4tcSU");

var $04zaL = parcelRequire("04zaL");

var $dxpxC = parcelRequire("dxpxC");

var $5uTwE = parcelRequire("5uTwE");



const $de6560d9e86b64da$var$retryLink = new (0, $lC4FX.RetryLink)({
    attempts: {
        max: 2,
        retryIf: (networkError, operation)=>{
            const { operationName: operationName } = operation;
            const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(networkError, [
                'statusCode'
            ], null);
            // retry once when SWAG Node is dead.
            const shouldRetry = [
                502,
                503,
                504
            ].includes(Number(statusCode));
            if (shouldRetry) (0, $04zaL.logApolloRetry)({
                queryName: operationName,
                statusCode: statusCode
            });
            return shouldRetry;
        }
    }
});
const $de6560d9e86b64da$var$errorLink = (0, $h4ppL.onError)(({ operation: operation, graphQLErrors: graphQLErrors, networkError: networkError })=>{
    const { operationName: operationName } = operation;
    if (graphQLErrors) {
        if (Array.isArray(graphQLErrors)) graphQLErrors.map(({ path: path, extensions: extensions })=>{
            const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(extensions, [
                'statusCode'
            ], null);
            const errorType = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(extensions, [
                'errorType'
            ], null);
            return (0, $04zaL.logApolloError)(path, statusCode, operationName, errorType);
        });
        else (0, $04zaL.logRestParsingError)('Unexpected error message format', JSON.stringify(graphQLErrors));
    }
    if (networkError) {
        const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(networkError, [
            'statusCode'
        ], null);
        (0, $04zaL.logApolloNetworkError)(networkError.toString(), statusCode, operationName);
    }
});
// Exporting fragmentMatcher to use it in StoryBook examples
const $de6560d9e86b64da$var$fragmentMatcher = new (0, $ivfDv.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: (/*@__PURE__*/$parcel$interopDefault($5uTwE))
});
const $de6560d9e86b64da$var$cacheConfig = {
    cacheRedirects: {
        Query: {
            ...(0, $cuKXc.fragmentCacheRedirect)()
        }
    },
    freezeResults: true,
    fragmentMatcher: $de6560d9e86b64da$var$fragmentMatcher
};
const $de6560d9e86b64da$var$cache = new (0, $ivfDv.InMemoryCache)($de6560d9e86b64da$var$cacheConfig);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $de6560d9e86b64da$var$customFetch = (uri, options)=>{
    const body = options && options.body ? JSON.parse(options.body) : null;
    return fetch(`${uri}?operation=${body ? body.operationName : 'unknown'}`, options);
};
const $de6560d9e86b64da$var$xsrfLink = ()=>(0, $43WKH.setContext)((operation, previousContext)=>{
        const { headers: headers } = previousContext;
        // set empty xsrfToken for SSR as cookies are unavailable
        const xsrfToken = false ? '' : (0, $4tcSU.default)();
        if (!xsrfToken) return previousContext;
        return {
            ...previousContext,
            headers: {
                ...headers,
                'atl-xsrf-token': xsrfToken
            }
        };
    });
const $de6560d9e86b64da$var$clientCreator = (baseUrl)=>new (0, $e3a3O.ApolloClient)({
        name: 'SWAG',
        link: (0, $clSzL.ApolloLink).from([
            $de6560d9e86b64da$var$retryLink,
            $de6560d9e86b64da$var$xsrfLink(),
            $de6560d9e86b64da$var$errorLink,
            (0, $dxpxC.UFOLoggerLink),
            (0, $cuKXc.fragmentLinkState)($de6560d9e86b64da$var$cache),
            new (0, $JPsIz.HttpLink)({
                uri: `${baseUrl}/jsw2/graphql`,
                credentials: 'same-origin',
                fetch: $de6560d9e86b64da$var$customFetch
            })
        ]),
        cache: $de6560d9e86b64da$var$cache,
        assumeImmutableResults: true
    });
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$de6560d9e86b64da$export$2e2bcd8739ae039 = {
    clientId: 'SWAG',
    clientCreator: $de6560d9e86b64da$var$clientCreator
};

});
parcelRegister("ivfDv", function(module, exports) {

$parcel$export(module.exports, "IntrospectionFragmentMatcher", () => $d7874048ca668ecb$export$3b71c6b829c99d21);
$parcel$export(module.exports, "defaultDataIdFromObject", () => $d7874048ca668ecb$export$bd03c5a9c99d6bce);
$parcel$export(module.exports, "InMemoryCache", () => $d7874048ca668ecb$export$467265324939f47f);

var $3VFsf = parcelRequire("3VFsf");

var $hzuXv = parcelRequire("hzuXv");

var $jojW6 = parcelRequire("jojW6");
var $bqMzA = parcelRequire("bqMzA");

var $gLy2H = parcelRequire("gLy2H");

var $1DiV8 = parcelRequire("1DiV8");
var $d7874048ca668ecb$var$haveWarned = false;
function $d7874048ca668ecb$var$shouldWarn() {
    var answer = !$d7874048ca668ecb$var$haveWarned;
    if (!(0, $jojW6.isTest)()) $d7874048ca668ecb$var$haveWarned = true;
    return answer;
}
var $d7874048ca668ecb$export$5d3fcf53267091de = function() {
    function HeuristicFragmentMatcher() {}
    HeuristicFragmentMatcher.prototype.ensureReady = function() {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function() {
        return true;
    };
    HeuristicFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        if (!__typename) {
            $d7874048ca668ecb$var$shouldWarn();
            return 'heuristic';
        }
        if (__typename === typeCondition) return true;
        $d7874048ca668ecb$var$shouldWarn();
        return 'heuristic';
    };
    return HeuristicFragmentMatcher;
}();
var $d7874048ca668ecb$export$3b71c6b829c99d21 = function() {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        } else this.isReady = false;
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        (0, $1DiV8.invariant)(this.isReady, 1);
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        (0, $1DiV8.invariant)(__typename, 2);
        if (__typename === typeCondition) return true;
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) return true;
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function(introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function(type) {
            if (type.kind === 'UNION' || type.kind === 'INTERFACE') typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                return implementingType.name;
            });
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}();
var $d7874048ca668ecb$var$hasOwn = Object.prototype.hasOwnProperty;
var $d7874048ca668ecb$var$DepTrackingCache = function() {
    function DepTrackingCache(data) {
        var _this = this;
        if (data === void 0) data = Object.create(null);
        this.data = data;
        this.depend = (0, $gLy2H.wrap)(function(dataId) {
            return _this.data[dataId];
        }, {
            disposable: true,
            makeCacheKey: function(dataId) {
                return dataId;
            }
        });
    }
    DepTrackingCache.prototype.toObject = function() {
        return this.data;
    };
    DepTrackingCache.prototype.get = function(dataId) {
        this.depend(dataId);
        return this.data[dataId];
    };
    DepTrackingCache.prototype.set = function(dataId, value) {
        var oldValue = this.data[dataId];
        if (value !== oldValue) {
            this.data[dataId] = value;
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.delete = function(dataId) {
        if ($d7874048ca668ecb$var$hasOwn.call(this.data, dataId)) {
            delete this.data[dataId];
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.clear = function() {
        this.replace(null);
    };
    DepTrackingCache.prototype.replace = function(newData) {
        var _this = this;
        if (newData) {
            Object.keys(newData).forEach(function(dataId) {
                _this.set(dataId, newData[dataId]);
            });
            Object.keys(this.data).forEach(function(dataId) {
                if (!$d7874048ca668ecb$var$hasOwn.call(newData, dataId)) _this.delete(dataId);
            });
        } else Object.keys(this.data).forEach(function(dataId) {
            _this.delete(dataId);
        });
    };
    return DepTrackingCache;
}();
function $d7874048ca668ecb$var$defaultNormalizedCacheFactory(seed) {
    return new $d7874048ca668ecb$var$DepTrackingCache(seed);
}
var $d7874048ca668ecb$export$628ef07ba8965f12 = function() {
    function StoreReader(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new (0, $gLy2H.KeyTrie)((0, $jojW6.canUseWeakMap)) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
        var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
        this.freezeResults = freezeResults;
        this.executeStoreQuery = (0, $gLy2H.wrap)(function(options) {
            return executeStoreQuery.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                if (contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
            }
        });
        this.executeSelectionSet = (0, $gLy2H.wrap)(function(options) {
            return executeSelectionSet.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
            }
        });
        this.executeSubSelectedArray = (0, $gLy2H.wrap)(function(options) {
            return executeSubSelectedArray.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
            }
        });
    }
    StoreReader.prototype.readQueryFromStore = function(options) {
        return this.diffQueryAgainstStore((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
            returnPartialData: false
        })).result;
    };
    StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
        var queryDefinition = (0, $jojW6.getQueryDefinition)(query);
        variables = (0, $jojW6.assign)({}, (0, $jojW6.getDefaultValues)(queryDefinition), variables);
        var context = {
            store: store,
            dataIdFromObject: config && config.dataIdFromObject,
            cacheRedirects: config && config.cacheRedirects || {}
        };
        var execResult = this.executeStoreQuery({
            query: query,
            rootValue: {
                type: 'id',
                id: rootId,
                generated: true,
                typename: 'Query'
            },
            contextValue: context,
            variableValues: variables,
            fragmentMatcher: fragmentMatcherFunction
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) execResult.missing.forEach(function(info) {
            if (info.tolerable) return;
            throw new (0, $1DiV8.InvariantError)(8);
        });
        if (previousResult) {
            if ((0, $bqMzA.equal)(previousResult, execResult.result)) execResult.result = previousResult;
        }
        return {
            result: execResult.result,
            complete: !hasMissingFields
        };
    };
    StoreReader.prototype.executeStoreQuery = function(_a) {
        var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? $d7874048ca668ecb$var$defaultFragmentMatcher : _b;
        var mainDefinition = (0, $jojW6.getMainDefinition)(query);
        var fragments = (0, $jojW6.getFragmentDefinitions)(query);
        var fragmentMap = (0, $jojW6.createFragmentMap)(fragments);
        var execContext = {
            query: query,
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            fragmentMatcher: fragmentMatcher
        };
        return this.executeSelectionSet({
            selectionSet: mainDefinition.selectionSet,
            rootValue: rootValue,
            execContext: execContext
        });
    };
    StoreReader.prototype.executeSelectionSet = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var finalResult = {
            result: null
        };
        var objectsToMerge = [];
        var object = contextValue.store.get(rootValue.id);
        var typename = object && object.__typename || rootValue.id === 'ROOT_QUERY' && 'Query' || void 0;
        function handleMissing(result) {
            var _a;
            if (result.missing) {
                finalResult.missing = finalResult.missing || [];
                (_a = finalResult.missing).push.apply(_a, result.missing);
            }
            return result.result;
        }
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $jojW6.shouldInclude)(selection, variables)) return;
            if ((0, $jojW6.isField)(selection)) {
                var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                if (typeof fieldResult !== 'undefined') objectsToMerge.push((_a = {}, _a[(0, $jojW6.resultKeyNameFromField)(selection)] = fieldResult, _a));
            } else {
                var fragment = void 0;
                if ((0, $jojW6.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) throw new (0, $1DiV8.InvariantError)(9);
                }
                var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                if (match) {
                    var fragmentExecResult = _this.executeSelectionSet({
                        selectionSet: fragment.selectionSet,
                        rootValue: rootValue,
                        execContext: execContext
                    });
                    if (match === 'heuristic' && fragmentExecResult.missing) fragmentExecResult = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, fragmentExecResult), {
                        missing: fragmentExecResult.missing.map(function(info) {
                            return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, info), {
                                tolerable: true
                            });
                        })
                    });
                    objectsToMerge.push(handleMissing(fragmentExecResult));
                }
            }
        });
        finalResult.result = (0, $jojW6.mergeDeepArray)(objectsToMerge);
        this.freezeResults;
        return finalResult;
    };
    StoreReader.prototype.executeField = function(object, typename, field, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue;
        var fieldName = field.name.value;
        var args = (0, $jojW6.argumentsObjectFromField)(field, variables);
        var info = {
            resultKey: (0, $jojW6.resultKeyNameFromField)(field),
            directives: (0, $jojW6.getDirectiveInfoFromField)(field, variables)
        };
        var readStoreResult = $d7874048ca668ecb$var$readStoreResolver(object, typename, fieldName, args, contextValue, info);
        if (Array.isArray(readStoreResult.result)) return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
            field: field,
            array: readStoreResult.result,
            execContext: execContext
        }));
        if (!field.selectionSet) {
            $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, readStoreResult.result);
            this.freezeResults;
            return readStoreResult;
        }
        if (readStoreResult.result == null) return readStoreResult;
        return this.combineExecResults(readStoreResult, this.executeSelectionSet({
            selectionSet: field.selectionSet,
            rootValue: readStoreResult.result,
            execContext: execContext
        }));
    };
    StoreReader.prototype.combineExecResults = function() {
        var execResults = [];
        for(var _i = 0; _i < arguments.length; _i++)execResults[_i] = arguments[_i];
        var missing;
        execResults.forEach(function(execResult) {
            if (execResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, execResult.missing);
            }
        });
        return {
            result: execResults.pop().result,
            missing: missing
        };
    };
    StoreReader.prototype.executeSubSelectedArray = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, execContext = _a.execContext;
        var missing;
        function handleMissing(childResult) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            return childResult.result;
        }
        array = array.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                execContext: execContext
            }));
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: item,
                execContext: execContext
            }));
            $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, item);
            return item;
        });
        this.freezeResults;
        return {
            result: array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, value) {
    if (!field.selectionSet && (0, $jojW6.isIdValue)(value)) throw new (0, $1DiV8.InvariantError)(10);
}
function $d7874048ca668ecb$var$defaultFragmentMatcher() {
    return true;
}
function $d7874048ca668ecb$export$7a4899fe13f33235(idValue) {
    (0, $1DiV8.invariant)((0, $jojW6.isIdValue)(idValue), 11);
}
function $d7874048ca668ecb$var$readStoreResolver(object, typename, fieldName, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    var storeKeyName = fieldName;
    if (args || directives) storeKeyName = (0, $jojW6.getStoreKeyName)(storeKeyName, args, directives);
    var fieldValue = void 0;
    if (object) {
        fieldValue = object[storeKeyName];
        if (typeof fieldValue === 'undefined' && context.cacheRedirects && typeof typename === 'string') {
            var type = context.cacheRedirects[typename];
            if (type) {
                var resolver = type[fieldName];
                if (resolver) fieldValue = resolver(object, args, {
                    getCacheKey: function(storeObj) {
                        var id = context.dataIdFromObject(storeObj);
                        return id && (0, $jojW6.toIdValue)({
                            id: id,
                            typename: storeObj.__typename
                        });
                    }
                });
            }
        }
    }
    if (typeof fieldValue === 'undefined') return {
        result: fieldValue,
        missing: [
            {
                object: object,
                fieldName: storeKeyName,
                tolerable: false
            }
        ]
    };
    if ((0, $jojW6.isJsonValue)(fieldValue)) fieldValue = fieldValue.json;
    return {
        result: fieldValue
    };
}
var $d7874048ca668ecb$export$ee7258b8691956a3 = function() {
    function ObjectCache(data) {
        if (data === void 0) data = Object.create(null);
        this.data = data;
    }
    ObjectCache.prototype.toObject = function() {
        return this.data;
    };
    ObjectCache.prototype.get = function(dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function(dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function(dataId) {
        this.data[dataId] = void 0;
    };
    ObjectCache.prototype.clear = function() {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function(newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}();
function $d7874048ca668ecb$export$7e2b40d1002de152(seed) {
    return new $d7874048ca668ecb$export$ee7258b8691956a3(seed);
}
var $d7874048ca668ecb$export$de4e6870dc6ac801 = function(_super) {
    (0, $3VFsf.__extends)(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WriteError';
        return _this;
    }
    return WriteError;
}(Error);
function $d7874048ca668ecb$export$fb86e3236e77e3(error, document) {
    var enhancedError = new $d7874048ca668ecb$export$de4e6870dc6ac801("Error writing result to store for query:\n " + JSON.stringify(document));
    enhancedError.message += '\n' + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
var $d7874048ca668ecb$export$eb8361c5d132fb8f = function() {
    function StoreWriter() {}
    StoreWriter.prototype.writeQueryToStore = function(_a) {
        var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? $d7874048ca668ecb$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        return this.writeResultToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            document: query,
            store: store,
            variables: variables,
            dataIdFromObject: dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
    };
    StoreWriter.prototype.writeResultToStore = function(_a) {
        var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? $d7874048ca668ecb$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var operationDefinition = (0, $jojW6.getOperationDefinition)(document);
        try {
            return this.writeSelectionSetToStore({
                result: result,
                dataId: dataId,
                selectionSet: operationDefinition.selectionSet,
                context: {
                    store: store,
                    processedData: {},
                    variables: (0, $jojW6.assign)({}, (0, $jojW6.getDefaultValues)(operationDefinition), variables),
                    dataIdFromObject: dataIdFromObject,
                    fragmentMap: (0, $jojW6.createFragmentMap)((0, $jojW6.getFragmentDefinitions)(document)),
                    fragmentMatcherFunction: fragmentMatcherFunction
                }
            });
        } catch (e) {
            throw $d7874048ca668ecb$export$fb86e3236e77e3(e, document);
        }
    };
    StoreWriter.prototype.writeSelectionSetToStore = function(_a) {
        var _this = this;
        var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
        var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $jojW6.shouldInclude)(selection, variables)) return;
            if ((0, $jojW6.isField)(selection)) {
                var resultFieldKey = (0, $jojW6.resultKeyNameFromField)(selection);
                var value = result[resultFieldKey];
                if (typeof value !== 'undefined') _this.writeFieldToStore({
                    dataId: dataId,
                    value: value,
                    field: selection,
                    context: context
                });
                else {
                    var isDefered = false;
                    var isClient = false;
                    if (selection.directives && selection.directives.length) {
                        isDefered = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'defer';
                        });
                        isClient = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'client';
                        });
                    }
                    !isDefered && !isClient && context.fragmentMatcherFunction;
                }
            } else {
                var fragment = void 0;
                if ((0, $jojW6.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = (fragmentMap || {})[selection.name.value];
                    (0, $1DiV8.invariant)(fragment, 3);
                }
                var matches = true;
                if (context.fragmentMatcherFunction && fragment.typeCondition) {
                    var id = dataId || 'self';
                    var idValue = (0, $jojW6.toIdValue)({
                        id: id,
                        typename: undefined
                    });
                    var fakeContext = {
                        store: new $d7874048ca668ecb$export$ee7258b8691956a3((_a = {}, _a[id] = result, _a)),
                        cacheRedirects: {}
                    };
                    var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                    !(0, $jojW6.isProduction)() && match;
                    matches = !!match;
                }
                if (matches) _this.writeSelectionSetToStore({
                    result: result,
                    selectionSet: fragment.selectionSet,
                    dataId: dataId,
                    context: context
                });
            }
        });
        return store;
    };
    StoreWriter.prototype.writeFieldToStore = function(_a) {
        var _b;
        var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
        var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
        var storeValue;
        var storeObject;
        var storeFieldName = (0, $jojW6.storeKeyNameFromField)(field, variables);
        if (!field.selectionSet || value === null) storeValue = value != null && typeof value === 'object' ? {
            type: 'json',
            json: value
        } : value;
        else if (Array.isArray(value)) {
            var generatedId = dataId + "." + storeFieldName;
            storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
        } else {
            var valueDataId = dataId + "." + storeFieldName;
            var generated = true;
            if (!$d7874048ca668ecb$var$isGeneratedId(valueDataId)) valueDataId = '$' + valueDataId;
            if (dataIdFromObject) {
                var semanticId = dataIdFromObject(value);
                (0, $1DiV8.invariant)(!semanticId || !$d7874048ca668ecb$var$isGeneratedId(semanticId), 4);
                if (semanticId || typeof semanticId === 'number' && semanticId === 0) {
                    valueDataId = semanticId;
                    generated = false;
                }
            }
            if (!$d7874048ca668ecb$var$isDataProcessed(valueDataId, field, context.processedData)) this.writeSelectionSetToStore({
                dataId: valueDataId,
                result: value,
                selectionSet: field.selectionSet,
                context: context
            });
            var typename = value.__typename;
            storeValue = (0, $jojW6.toIdValue)({
                id: valueDataId,
                typename: typename
            }, generated);
            storeObject = store.get(dataId);
            var escapedId = storeObject && storeObject[storeFieldName];
            if (escapedId !== storeValue && (0, $jojW6.isIdValue)(escapedId)) {
                var hadTypename = escapedId.typename !== undefined;
                var hasTypename = typename !== undefined;
                var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                (0, $1DiV8.invariant)(!generated || escapedId.generated || typenameChanged, 5);
                (0, $1DiV8.invariant)(!hadTypename || hasTypename, 6);
                if (escapedId.generated) {
                    if (typenameChanged) {
                        if (!generated) store.delete(escapedId.id);
                    } else $d7874048ca668ecb$var$mergeWithGenerated(escapedId.id, storeValue.id, store);
                }
            }
        }
        storeObject = store.get(dataId);
        if (!storeObject || !(0, $bqMzA.equal)(storeValue, storeObject[storeFieldName])) store.set(dataId, (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
    };
    StoreWriter.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
        var _this = this;
        return value.map(function(item, index) {
            if (item === null) return null;
            var itemDataId = generatedId + "." + index;
            if (Array.isArray(item)) return _this.processArrayValue(item, itemDataId, selectionSet, context);
            var generated = true;
            if (context.dataIdFromObject) {
                var semanticId = context.dataIdFromObject(item);
                if (semanticId) {
                    itemDataId = semanticId;
                    generated = false;
                }
            }
            if (!$d7874048ca668ecb$var$isDataProcessed(itemDataId, selectionSet, context.processedData)) _this.writeSelectionSetToStore({
                dataId: itemDataId,
                result: item,
                selectionSet: selectionSet,
                context: context
            });
            return (0, $jojW6.toIdValue)({
                id: itemDataId,
                typename: item.__typename
            }, generated);
        });
    };
    return StoreWriter;
}();
function $d7874048ca668ecb$var$isGeneratedId(id) {
    return id[0] === '$';
}
function $d7874048ca668ecb$var$mergeWithGenerated(generatedKey, realKey, cache) {
    if (generatedKey === realKey) return false;
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    var madeChanges = false;
    Object.keys(generated).forEach(function(key) {
        var value = generated[key];
        var realValue = real[key];
        if ((0, $jojW6.isIdValue)(value) && $d7874048ca668ecb$var$isGeneratedId(value.id) && (0, $jojW6.isIdValue)(realValue) && !(0, $bqMzA.equal)(value, realValue) && $d7874048ca668ecb$var$mergeWithGenerated(value.id, realValue.id, cache)) madeChanges = true;
    });
    cache.delete(generatedKey);
    var newRealValue = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, generated), real);
    if ((0, $bqMzA.equal)(newRealValue, real)) return madeChanges;
    cache.set(realKey, newRealValue);
    return true;
}
function $d7874048ca668ecb$var$isDataProcessed(dataId, field, processedData) {
    if (!processedData) return false;
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) return true;
        else processedData[dataId].push(field);
    } else processedData[dataId] = [
        field
    ];
    return false;
}
var $d7874048ca668ecb$var$defaultConfig = {
    fragmentMatcher: new $d7874048ca668ecb$export$5d3fcf53267091de(),
    dataIdFromObject: $d7874048ca668ecb$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    freezeResults: false
};
function $d7874048ca668ecb$export$bd03c5a9c99d6bce(result) {
    if (result.__typename) {
        if (result.id !== undefined) return result.__typename + ":" + result.id;
        if (result._id !== undefined) return result.__typename + ":" + result._id;
    }
    return null;
}
var $d7874048ca668ecb$var$hasOwn$1 = Object.prototype.hasOwnProperty;
var $d7874048ca668ecb$var$OptimisticCacheLayer = function(_super) {
    (0, $3VFsf.__extends)(OptimisticCacheLayer, _super);
    function OptimisticCacheLayer(optimisticId, parent, transaction) {
        var _this = _super.call(this, Object.create(null)) || this;
        _this.optimisticId = optimisticId;
        _this.parent = parent;
        _this.transaction = transaction;
        return _this;
    }
    OptimisticCacheLayer.prototype.toObject = function() {
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.parent.toObject()), this.data);
    };
    OptimisticCacheLayer.prototype.get = function(dataId) {
        return $d7874048ca668ecb$var$hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
    };
    return OptimisticCacheLayer;
}($d7874048ca668ecb$export$ee7258b8691956a3);
var $d7874048ca668ecb$export$467265324939f47f = function(_super) {
    (0, $3VFsf.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.cacheKeyRoot = new (0, $gLy2H.KeyTrie)((0, $jojW6.canUseWeakMap));
        _this.silenceBroadcast = false;
        _this.config = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, $d7874048ca668ecb$var$defaultConfig), config);
        if (_this.config.customResolvers) _this.config.cacheRedirects = _this.config.customResolvers;
        if (_this.config.cacheResolvers) _this.config.cacheRedirects = _this.config.cacheResolvers;
        _this.addTypename = !!_this.config.addTypename;
        _this.data = _this.config.resultCaching ? new $d7874048ca668ecb$var$DepTrackingCache() : new $d7874048ca668ecb$export$ee7258b8691956a3();
        _this.optimisticData = _this.data;
        _this.storeWriter = new $d7874048ca668ecb$export$eb8361c5d132fb8f();
        _this.storeReader = new $d7874048ca668ecb$export$628ef07ba8965f12({
            cacheKeyRoot: _this.cacheKeyRoot,
            freezeResults: config.freezeResults
        });
        var cache = _this;
        var maybeBroadcastWatch = cache.maybeBroadcastWatch;
        _this.maybeBroadcastWatch = (0, $gLy2H.wrap)(function(c) {
            return maybeBroadcastWatch.call(_this, c);
        }, {
            makeCacheKey: function(c) {
                if (c.optimistic) return;
                if (c.previousResult) return;
                if (cache.data instanceof $d7874048ca668ecb$var$DepTrackingCache) return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
            }
        });
        return _this;
    }
    InMemoryCache.prototype.restore = function(data) {
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).toObject();
    };
    InMemoryCache.prototype.read = function(options) {
        if (typeof options.rootId === 'string' && typeof this.data.get(options.rootId) === 'undefined') return null;
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.readQueryFromStore({
            store: options.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
            rootId: options.rootId,
            fragmentMatcherFunction: fragmentMatcherFunction,
            previousResult: options.previousResult,
            config: this.config
        }) || null;
    };
    InMemoryCache.prototype.write = function(write) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        this.storeWriter.writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function(query) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.diffQueryAgainstStore({
            store: query.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: fragmentMatcherFunction,
            config: this.config
        });
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        this.watches.add(watch);
        return function() {
            _this.watches.delete(watch);
        };
    };
    InMemoryCache.prototype.evict = function(query) {
        throw new (0, $1DiV8.InvariantError)(7);
    };
    InMemoryCache.prototype.reset = function() {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var toReapply = [];
        var removedCount = 0;
        var layer = this.optimisticData;
        while(layer instanceof $d7874048ca668ecb$var$OptimisticCacheLayer){
            if (layer.optimisticId === idToRemove) ++removedCount;
            else toReapply.push(layer);
            layer = layer.parent;
        }
        if (removedCount > 0) {
            this.optimisticData = layer;
            while(toReapply.length > 0){
                var layer_1 = toReapply.pop();
                this.performTransaction(layer_1.transaction, layer_1.optimisticId);
            }
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
        var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
        this.silenceBroadcast = true;
        if (typeof optimisticId === 'string') this.data = this.optimisticData = new $d7874048ca668ecb$var$OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
        try {
            transaction(this);
        } finally{
            this.silenceBroadcast = silenceBroadcast;
            this.data = data;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function(transaction, id) {
        return this.performTransaction(transaction, id);
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0, $jojW6.addTypenameToDocument)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function() {
        var _this = this;
        if (!this.silenceBroadcast) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c);
        });
    };
    InMemoryCache.prototype.maybeBroadcastWatch = function(c) {
        c.callback(this.diff({
            query: c.query,
            variables: c.variables,
            previousResult: c.previousResult && c.previousResult(),
            optimistic: c.optimistic
        }));
    };
    return InMemoryCache;
}((0, $hzuXv.ApolloCache));

});
parcelRegister("hzuXv", function(module, exports) {

$parcel$export(module.exports, "ApolloCache", () => $ccadb856bf057658$export$5fc74f25506aa9c);

var $jojW6 = parcelRequire("jojW6");
function $ccadb856bf057658$var$queryFromPojo(obj) {
    var op = {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $ccadb856bf057658$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            op
        ]
    };
    return out;
}
function $ccadb856bf057658$var$fragmentFromPojo(obj, typename) {
    var frag = {
        kind: 'FragmentDefinition',
        typeCondition: {
            kind: 'NamedType',
            name: {
                kind: 'Name',
                value: typename || '__FakeType'
            }
        },
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $ccadb856bf057658$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            frag
        ]
    };
    return out;
}
function $ccadb856bf057658$var$selectionSetFromObj(obj) {
    if (typeof obj === 'number' || typeof obj === 'boolean' || typeof obj === 'string' || typeof obj === 'undefined' || obj === null) return null;
    if (Array.isArray(obj)) return $ccadb856bf057658$var$selectionSetFromObj(obj[0]);
    var selections = [];
    Object.keys(obj).forEach(function(key) {
        var nestedSelSet = $ccadb856bf057658$var$selectionSetFromObj(obj[key]);
        var field = {
            kind: 'Field',
            name: {
                kind: 'Name',
                value: key
            },
            selectionSet: nestedSelSet || undefined
        };
        selections.push(field);
    });
    var selectionSet = {
        kind: 'SelectionSet',
        selections: selections
    };
    return selectionSet;
}
var $ccadb856bf057658$var$justTypenameQuery = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: null,
                        name: {
                            kind: 'Name',
                            value: '__typename'
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null
                    }
                ]
            }
        }
    ]
};
var $ccadb856bf057658$export$5fc74f25506aa9c = function() {
    function ApolloCache() {}
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: (0, $jojW6.getFragmentQueryDocument)(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.writeQuery = function(options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables
        });
    };
    ApolloCache.prototype.writeFragment = function(options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: (0, $jojW6.getFragmentQueryDocument)(options.fragment, options.fragmentName)
        });
    };
    ApolloCache.prototype.writeData = function(_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== 'undefined') {
            var typenameResult = null;
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: $ccadb856bf057658$var$justTypenameQuery
                });
            } catch (e) {}
            var __typename = typenameResult && typenameResult.__typename || '__ClientData';
            var dataToWrite = Object.assign({
                __typename: __typename
            }, data);
            this.writeFragment({
                id: id,
                fragment: $ccadb856bf057658$var$fragmentFromPojo(dataToWrite, __typename),
                data: dataToWrite
            });
        } else this.writeQuery({
            query: $ccadb856bf057658$var$queryFromPojo(data),
            data: data
        });
    };
    return ApolloCache;
}();
var $ccadb856bf057658$export$94affb487e701bf2;
$ccadb856bf057658$export$94affb487e701bf2 || ($ccadb856bf057658$export$94affb487e701bf2 = {});

});

parcelRegister("gLy2H", function(module, exports) {

$parcel$export(module.exports, "KeyTrie", () => $c34b71496108423e$export$6bd8d8299be3ac82);
$parcel$export(module.exports, "wrap", () => $c34b71496108423e$export$4997ffc0176396a6);

var $jFbNy = parcelRequire("jFbNy");
function $c34b71496108423e$var$defaultDispose() {}
var $c34b71496108423e$var$Cache = /** @class */ function() {
    function Cache(max, dispose) {
        if (max === void 0) max = Infinity;
        if (dispose === void 0) dispose = $c34b71496108423e$var$defaultDispose;
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function(key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function(key) {
        var entry = this.getEntry(key);
        return entry && entry.value;
    };
    Cache.prototype.getEntry = function(key) {
        var entry = this.map.get(key);
        if (entry && entry !== this.newest) {
            var older = entry.older, newer = entry.newer;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            entry.older = this.newest;
            entry.older.newer = entry;
            entry.newer = null;
            this.newest = entry;
            if (entry === this.oldest) this.oldest = newer;
        }
        return entry;
    };
    Cache.prototype.set = function(key, value) {
        var entry = this.getEntry(key);
        if (entry) return entry.value = value;
        entry = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = entry;
        this.newest = entry;
        this.oldest = this.oldest || entry;
        this.map.set(key, entry);
        return entry.value;
    };
    Cache.prototype.clean = function() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    };
    Cache.prototype.delete = function(key) {
        var entry = this.map.get(key);
        if (entry) {
            if (entry === this.newest) this.newest = entry.older;
            if (entry === this.oldest) this.oldest = entry.newer;
            if (entry.newer) entry.newer.older = entry.older;
            if (entry.older) entry.older.newer = entry.newer;
            this.map.delete(key);
            this.dispose(entry.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}();
var $c34b71496108423e$var$parentEntrySlot = new (0, $jFbNy.Slot)();
var $c34b71496108423e$var$reusableEmptyArray = [];
var $c34b71496108423e$var$emptySetPool = [];
var $c34b71496108423e$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $c34b71496108423e$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $c34b71496108423e$var$valueIs(a, b) {
    var len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $c34b71496108423e$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $c34b71496108423e$var$valueCopy(value) {
    return value.slice(0);
}
var $c34b71496108423e$var$Entry = /** @class */ function() {
    function Entry(fn, args) {
        this.fn = fn;
        this.args = args;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        ++Entry.count;
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function() {
        $c34b71496108423e$var$assert(!this.recomputing, "already recomputing");
        if (!$c34b71496108423e$var$rememberParent(this) && $c34b71496108423e$var$maybeReportOrphan(this)) // The recipient of the entry.reportOrphan callback decided to dispose
        // of this orphan entry by calling entry.dispose(), so we don't need to
        // (and should not) proceed with the recomputation.
        return void 0;
        return $c34b71496108423e$var$mightBeDirty(this) ? $c34b71496108423e$var$reallyRecompute(this) : $c34b71496108423e$var$valueGet(this.value);
    };
    Entry.prototype.setDirty = function() {
        if (this.dirty) return;
        this.dirty = true;
        this.value.length = 0;
        $c34b71496108423e$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        $c34b71496108423e$var$maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function() {
        var _this = this;
        $c34b71496108423e$var$forgetChildren(this).forEach($c34b71496108423e$var$maybeReportOrphan);
        $c34b71496108423e$var$maybeUnsubscribe(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        this.parents.forEach(function(parent) {
            parent.setDirty();
            $c34b71496108423e$var$forgetChild(parent, _this);
        });
    };
    Entry.count = 0;
    return Entry;
}();
function $c34b71496108423e$var$rememberParent(child) {
    var parent = $c34b71496108423e$var$parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($c34b71496108423e$var$mightBeDirty(child)) $c34b71496108423e$var$reportDirtyChild(parent, child);
        else $c34b71496108423e$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $c34b71496108423e$var$reallyRecompute(entry) {
    // Since this recomputation is likely to re-remember some of this
    // entry's children, we forget our children here but do not call
    // maybeReportOrphan until after the recomputation finishes.
    var originalChildren = $c34b71496108423e$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    $c34b71496108423e$var$parentEntrySlot.withValue(entry, $c34b71496108423e$var$recomputeNewValue, [
        entry
    ]);
    if ($c34b71496108423e$var$maybeSubscribe(entry)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $c34b71496108423e$var$setClean(entry);
    // Now that we've had a chance to re-remember any children that were
    // involved in the recomputation, we can safely report any orphan
    // children that remain.
    originalChildren.forEach($c34b71496108423e$var$maybeReportOrphan);
    return $c34b71496108423e$var$valueGet(entry.value);
}
function $c34b71496108423e$var$recomputeNewValue(entry) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, entry.args);
    } catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $c34b71496108423e$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $c34b71496108423e$var$setClean(entry) {
    entry.dirty = false;
    if ($c34b71496108423e$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $c34b71496108423e$var$reportClean(entry);
}
function $c34b71496108423e$var$reportDirty(child) {
    child.parents.forEach(function(parent) {
        return $c34b71496108423e$var$reportDirtyChild(parent, child);
    });
}
function $c34b71496108423e$var$reportClean(child) {
    child.parents.forEach(function(parent) {
        return $c34b71496108423e$var$reportCleanChild(parent, child);
    });
}
// Let a parent Entry know that one of its children may be dirty.
function $c34b71496108423e$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $c34b71496108423e$var$assert(parent.childValues.has(child));
    $c34b71496108423e$var$assert($c34b71496108423e$var$mightBeDirty(child));
    if (!parent.dirtyChildren) parent.dirtyChildren = $c34b71496108423e$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    $c34b71496108423e$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $c34b71496108423e$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $c34b71496108423e$var$assert(parent.childValues.has(child));
    $c34b71496108423e$var$assert(!$c34b71496108423e$var$mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $c34b71496108423e$var$valueCopy(child.value));
    else if (!$c34b71496108423e$var$valueIs(childValue, child.value)) parent.setDirty();
    $c34b71496108423e$var$removeDirtyChild(parent, child);
    if ($c34b71496108423e$var$mightBeDirty(parent)) return;
    $c34b71496108423e$var$reportClean(parent);
}
function $c34b71496108423e$var$removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($c34b71496108423e$var$emptySetPool.length < $c34b71496108423e$var$POOL_TARGET_SIZE) $c34b71496108423e$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// If the given entry has a reportOrphan method, and no remaining parents,
// call entry.reportOrphan and return true iff it returns true. The
// reportOrphan function should return true to indicate entry.dispose()
// has been called, and the entry has been removed from any other caches
// (see index.js for the only current example).
function $c34b71496108423e$var$maybeReportOrphan(entry) {
    return entry.parents.size === 0 && typeof entry.reportOrphan === "function" && entry.reportOrphan() === true;
}
// Removes all children from this entry and returns an array of the
// removed children.
function $c34b71496108423e$var$forgetChildren(parent) {
    var children = $c34b71496108423e$var$reusableEmptyArray;
    if (parent.childValues.size > 0) {
        children = [];
        parent.childValues.forEach(function(_value, child) {
            $c34b71496108423e$var$forgetChild(parent, child);
            children.push(child);
        });
    }
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $c34b71496108423e$var$assert(parent.dirtyChildren === null);
    return children;
}
function $c34b71496108423e$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $c34b71496108423e$var$removeDirtyChild(parent, child);
}
function $c34b71496108423e$var$maybeSubscribe(entry) {
    if (typeof entry.subscribe === "function") try {
        $c34b71496108423e$var$maybeUnsubscribe(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, entry.args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
function $c34b71496108423e$var$maybeUnsubscribe(entry) {
    var unsubscribe = entry.unsubscribe;
    if (typeof unsubscribe === "function") {
        entry.unsubscribe = void 0;
        unsubscribe();
    }
}
// A trie data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var $c34b71496108423e$export$6bd8d8299be3ac82 = /** @class */ function() {
    function KeyTrie(weakness) {
        this.weakness = weakness;
    }
    KeyTrie.prototype.lookup = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
        return this.lookupArray(array);
    };
    KeyTrie.prototype.lookupArray = function(array) {
        var node = this;
        array.forEach(function(key) {
            return node = node.getChildTrie(key);
        });
        return node.data || (node.data = Object.create(null));
    };
    KeyTrie.prototype.getChildTrie = function(key) {
        var map = this.weakness && $c34b71496108423e$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child) map.set(key, child = new KeyTrie(this.weakness));
        return child;
    };
    return KeyTrie;
}();
function $c34b71496108423e$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var $c34b71496108423e$var$keyTrie = new $c34b71496108423e$export$6bd8d8299be3ac82(typeof WeakMap === "function");
function $c34b71496108423e$export$cd3144f8dd136006() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $c34b71496108423e$var$keyTrie.lookupArray(args);
}
var $c34b71496108423e$var$caches = new Set();
function $c34b71496108423e$export$4997ffc0176396a6(originalFunction, options) {
    if (options === void 0) options = Object.create(null);
    var cache = new $c34b71496108423e$var$Cache(options.max || Math.pow(2, 16), function(entry) {
        return entry.dispose();
    });
    var disposable = !!options.disposable;
    var makeCacheKey = options.makeCacheKey || $c34b71496108423e$export$cd3144f8dd136006;
    function optimistic() {
        if (disposable && !$c34b71496108423e$var$parentEntrySlot.hasValue()) // If there's no current parent computation, and this wrapped
        // function is disposable (meaning we don't care about entry.value,
        // just dependency tracking), then we can short-cut everything else
        // in this function, because entry.recompute() is going to recycle
        // the entry object without recomputing anything, anyway.
        return void 0;
        var key = makeCacheKey.apply(null, arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        var args = Array.prototype.slice.call(arguments);
        var entry = cache.get(key);
        if (entry) entry.args = args;
        else {
            entry = new $c34b71496108423e$var$Entry(originalFunction, args);
            cache.set(key, entry);
            entry.subscribe = options.subscribe;
            if (disposable) entry.reportOrphan = function() {
                return cache.delete(key);
            };
        }
        var value = entry.recompute();
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $c34b71496108423e$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!$c34b71496108423e$var$parentEntrySlot.hasValue()) {
            $c34b71496108423e$var$caches.forEach(function(cache) {
                return cache.clean();
            });
            $c34b71496108423e$var$caches.clear();
        }
        // If options.disposable is truthy, the caller of wrap is telling us
        // they don't care about the result of entry.recompute(), so we should
        // avoid returning the value, so it won't be accidentally used.
        return disposable ? void 0 : value;
    }
    optimistic.dirty = function() {
        var key = makeCacheKey.apply(null, arguments);
        var child = key !== void 0 && cache.get(key);
        if (child) child.setDirty();
    };
    return optimistic;
}

});
parcelRegister("jFbNy", function(module, exports) {

$parcel$export(module.exports, "Slot", () => $e50aff8f879ebe36$export$8c6ed5c666ac1360);
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var $e50aff8f879ebe36$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var $e50aff8f879ebe36$var$MISSING_VALUE = {};
var $e50aff8f879ebe36$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var $e50aff8f879ebe36$var$makeSlotClass = function() {
    return /** @class */ function() {
        function Slot() {
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $e50aff8f879ebe36$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        Slot.prototype.hasValue = function() {
            for(var context_1 = $e50aff8f879ebe36$var$currentContext; context_1; context_1 = context_1.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === $e50aff8f879ebe36$var$MISSING_VALUE) break;
                if (context_1 !== $e50aff8f879ebe36$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $e50aff8f879ebe36$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($e50aff8f879ebe36$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $e50aff8f879ebe36$var$currentContext.slots[this.id] = $e50aff8f879ebe36$var$MISSING_VALUE;
            return false;
        };
        Slot.prototype.getValue = function() {
            if (this.hasValue()) return $e50aff8f879ebe36$var$currentContext.slots[this.id];
        };
        Slot.prototype.withValue = function(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            var _a;
            var slots = (_a = {
                __proto__: null
            }, _a[this.id] = value, _a);
            var parent = $e50aff8f879ebe36$var$currentContext;
            $e50aff8f879ebe36$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $e50aff8f879ebe36$var$currentContext = parent;
            }
        };
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        Slot.bind = function(callback) {
            var context = $e50aff8f879ebe36$var$currentContext;
            return function() {
                var saved = $e50aff8f879ebe36$var$currentContext;
                try {
                    $e50aff8f879ebe36$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $e50aff8f879ebe36$var$currentContext = saved;
                }
            };
        };
        // Immediately run a callback function without any captured context.
        Slot.noContext = function(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($e50aff8f879ebe36$var$currentContext) {
                var saved = $e50aff8f879ebe36$var$currentContext;
                try {
                    $e50aff8f879ebe36$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $e50aff8f879ebe36$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        };
        return Slot;
    }();
};
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var $e50aff8f879ebe36$var$globalKey = "@wry/context:Slot";
var $e50aff8f879ebe36$var$host = Array;
var $e50aff8f879ebe36$export$8c6ed5c666ac1360 = $e50aff8f879ebe36$var$host[$e50aff8f879ebe36$var$globalKey] || function() {
    var Slot = $e50aff8f879ebe36$var$makeSlotClass();
    try {
        Object.defineProperty($e50aff8f879ebe36$var$host, $e50aff8f879ebe36$var$globalKey, {
            value: $e50aff8f879ebe36$var$host[$e50aff8f879ebe36$var$globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false
        });
    } finally{
        return Slot;
    }
}();
var $e50aff8f879ebe36$export$2385a24977818dd0 = $e50aff8f879ebe36$export$8c6ed5c666ac1360.bind, $e50aff8f879ebe36$export$9fa6f2e300a97f8 = $e50aff8f879ebe36$export$8c6ed5c666ac1360.noContext;
function $e50aff8f879ebe36$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($e50aff8f879ebe36$export$2385a24977818dd0(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function $e50aff8f879ebe36$export$d5d7536e965c82da(genFn) {
    return function() {
        var gen = genFn.apply(this, arguments);
        var boundNext = $e50aff8f879ebe36$export$2385a24977818dd0(gen.next);
        var boundThrow = $e50aff8f879ebe36$export$2385a24977818dd0(gen.throw);
        return new Promise(function(resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if ($e50aff8f879ebe36$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            var invokeNext = function(value) {
                return invoke(boundNext, value);
            };
            var invokeThrow = function(error) {
                return invoke(boundThrow, error);
            };
            invokeNext();
        });
    };
}
function $e50aff8f879ebe36$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var $e50aff8f879ebe36$var$wrappedFibers = [];
function $e50aff8f879ebe36$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($e50aff8f879ebe36$var$wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function(obj, method) {
            var fn = obj[method];
            obj[method] = function() {
                return $e50aff8f879ebe36$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $e50aff8f879ebe36$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}

});



parcelRegister("43WKH", function(module, exports) {

$parcel$export(module.exports, "setContext", () => $2f550436daecafe0$export$2f04de43fe27971a);

var $3VFsf = parcelRequire("3VFsf");

var $clSzL = parcelRequire("clSzL");
function $2f550436daecafe0$export$2f04de43fe27971a(setter) {
    return new (0, $clSzL.ApolloLink)(function(operation, forward) {
        var request = (0, $3VFsf.__rest)(operation, []);
        return new (0, $clSzL.Observable)(function(observer) {
            var handle;
            Promise.resolve(request).then(function(req) {
                return setter(req, operation.getContext());
            }).then(operation.setContext).then(function() {
                handle = forward(operation).subscribe({
                    next: observer.next.bind(observer),
                    error: observer.error.bind(observer),
                    complete: observer.complete.bind(observer)
                });
            }).catch(observer.error.bind(observer));
            return function() {
                if (handle) handle.unsubscribe();
            };
        });
    });
}

});

parcelRegister("h4ppL", function(module, exports) {

$parcel$export(module.exports, "onError", () => $c6d6862dd229df53$export$2288787135a8f66e);

var $3VFsf = parcelRequire("3VFsf");

var $clSzL = parcelRequire("clSzL");
function $c6d6862dd229df53$export$2288787135a8f66e(errorHandler) {
    return new (0, $clSzL.ApolloLink)(function(operation, forward) {
        return new (0, $clSzL.Observable)(function(observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function(result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function(networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            graphQLErrors: networkError && networkError.result && networkError.result.errors,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function() {
                        if (!retriedResult) observer.complete.bind(observer)();
                    }
                });
            } catch (e) {
                errorHandler({
                    networkError: e,
                    operation: operation,
                    forward: forward
                });
                observer.error(e);
            }
            return function() {
                if (sub) sub.unsubscribe();
                if (retriedSub) sub.unsubscribe();
            };
        });
    });
}
var $c6d6862dd229df53$export$d2c8415987899609 = function(_super) {
    (0, $3VFsf.__extends)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = $c6d6862dd229df53$export$2288787135a8f66e(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}((0, $clSzL.ApolloLink));

});

parcelRegister("JPsIz", function(module, exports) {

$parcel$export(module.exports, "HttpLink", () => $089c1f6736cf7295$export$f4bbf1aec241cc1);

var $3VFsf = parcelRequire("3VFsf");

var $clSzL = parcelRequire("clSzL");

var $f0Elb = parcelRequire("f0Elb");
var $089c1f6736cf7295$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, abortErrorDoesNotCauseError = linkOptions.abortErrorDoesNotCauseError, requestOptions = (0, $3VFsf.__rest)(linkOptions, [
        "uri",
        "fetch",
        "includeExtensions",
        "useGETForQueries",
        "abortErrorDoesNotCauseError"
    ]);
    (0, $f0Elb.checkFetcher)(fetcher);
    if (!fetcher) fetcher = fetch;
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $clSzL.ApolloLink)(function(operation) {
        var chosenURI = (0, $f0Elb.selectURI)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
            if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
        }
        var contextHeaders = (0, $3VFsf.__assign)({}, clientAwarenessHeaders, context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        var _b = (0, $f0Elb.selectHttpOptionsAndBody)(operation, (0, $f0Elb.fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
        var controller;
        if (!options.signal) {
            var _c = (0, $f0Elb.createSignalIfSupported)(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller) options.signal = signal;
        }
        var definitionIsMutation = function(d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
        if (options.method === 'GET') {
            var _d = $089c1f6736cf7295$var$rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) return (0, $clSzL.fromError)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $f0Elb.serializeFetchParameter)(body, 'Payload');
        } catch (parseError) {
            return (0, $clSzL.fromError)(parseError);
        }
        return new (0, $clSzL.Observable)(function(observer) {
            fetcher(chosenURI, options).then(function(response) {
                operation.setContext({
                    response: response
                });
                return response;
            }).then((0, $f0Elb.parseAndCheckHttpResponse)(operation)).then(function(result) {
                observer.next(result);
                observer.complete();
                return result;
            }).catch(function(err) {
                if (err.name === 'AbortError' && !abortErrorDoesNotCauseError) return;
                if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                observer.error(err);
            });
            return function() {
                if (controller) controller.abort();
            };
        });
    });
};
function $089c1f6736cf7295$var$rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) addQueryParam('query', body.query);
    if (body.operationName) addQueryParam('operationName', body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $f0Elb.serializeFetchParameter)(body.variables, 'Variables map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $f0Elb.serializeFetchParameter)(body.extensions, 'Extensions map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return {
        newURI: newURI
    };
}
var $089c1f6736cf7295$export$f4bbf1aec241cc1 = function(_super) {
    (0, $3VFsf.__extends)(HttpLink, _super);
    function HttpLink(opts) {
        return _super.call(this, $089c1f6736cf7295$export$95180a16573d6675(opts).request) || this;
    }
    return HttpLink;
}((0, $clSzL.ApolloLink));

});
parcelRegister("f0Elb", function(module, exports) {

$parcel$export(module.exports, "fallbackHttpConfig", () => $aed625edf13c57eb$export$dd86f00dc866e75d);
$parcel$export(module.exports, "parseAndCheckHttpResponse", () => $aed625edf13c57eb$export$d4051215bea0639f);
$parcel$export(module.exports, "checkFetcher", () => $aed625edf13c57eb$export$8423f0cd3773115e);
$parcel$export(module.exports, "createSignalIfSupported", () => $aed625edf13c57eb$export$f5853cd1fc39aea6);
$parcel$export(module.exports, "selectHttpOptionsAndBody", () => $aed625edf13c57eb$export$a00ebfd5f1eebfb1);
$parcel$export(module.exports, "serializeFetchParameter", () => $aed625edf13c57eb$export$5f8e80ac52052e28);
$parcel$export(module.exports, "selectURI", () => $aed625edf13c57eb$export$63ccc2571850f81a);

var $3VFsf = parcelRequire("3VFsf");

var $1c8Um = parcelRequire("1c8Um");

var $1DiV8 = parcelRequire("1DiV8");
var $aed625edf13c57eb$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false
};
var $aed625edf13c57eb$var$defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json'
};
var $aed625edf13c57eb$var$defaultOptions = {
    method: 'POST'
};
var $aed625edf13c57eb$export$dd86f00dc866e75d = {
    http: $aed625edf13c57eb$var$defaultHttpOptions,
    headers: $aed625edf13c57eb$var$defaultHeaders,
    options: $aed625edf13c57eb$var$defaultOptions
};
var $aed625edf13c57eb$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
var $aed625edf13c57eb$export$d4051215bea0639f = function(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                var parseError = err;
                parseError.name = 'ServerParseError';
                parseError.response = response;
                parseError.statusCode = response.status;
                parseError.bodyText = bodyText;
                return Promise.reject(parseError);
            }
        }).then(function(result) {
            if (response.status >= 300) $aed625edf13c57eb$export$c33ef9219f27efd7(response, result, "Response not successful: Received status code " + response.status);
            if (!Array.isArray(result) && !result.hasOwnProperty('data') && !result.hasOwnProperty('errors')) $aed625edf13c57eb$export$c33ef9219f27efd7(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName) + "'.");
            return result;
        });
    };
};
var $aed625edf13c57eb$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        var library = 'unfetch';
        if (typeof window === 'undefined') library = 'node-fetch';
        throw new (0, $1DiV8.InvariantError)(1);
    }
};
var $aed625edf13c57eb$export$f5853cd1fc39aea6 = function() {
    if (typeof AbortController === 'undefined') return {
        controller: false,
        signal: false
    };
    var controller = new AbortController();
    var signal = controller.signal;
    return {
        controller: controller,
        signal: signal
    };
};
var $aed625edf13c57eb$export$a00ebfd5f1eebfb1 = function(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = (0, $3VFsf.__assign)({}, fallbackConfig.options, {
        headers: fallbackConfig.headers,
        credentials: fallbackConfig.credentials
    });
    var http = fallbackConfig.http;
    configs.forEach(function(config) {
        options = (0, $3VFsf.__assign)({}, options, config.options, {
            headers: (0, $3VFsf.__assign)({}, options.headers, config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $3VFsf.__assign)({}, http, config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    if (http.includeQuery) body.query = (0, $1c8Um.print)(query);
    return {
        options: options,
        body: body
    };
};
var $aed625edf13c57eb$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = new (0, $1DiV8.InvariantError)(2);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
var $aed625edf13c57eb$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === 'function') return fallbackURI(operation);
    else return fallbackURI || '/graphql';
};

});


parcelRegister("lC4FX", function(module, exports) {

$parcel$export(module.exports, "RetryLink", () => $fbc0c610016bf5c5$export$943d544ad120494a);

var $3VFsf = parcelRequire("3VFsf");

var $clSzL = parcelRequire("clSzL");
function $fbc0c610016bf5c5$var$buildDelayFunction(delayOptions) {
    var _a = delayOptions || {}, _b = _a.initial, initial = _b === void 0 ? 300 : _b, _c = _a.jitter, jitter = _c === void 0 ? true : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d;
    var baseDelay = jitter ? initial : initial / 2;
    return function delayFunction(count) {
        var delay = Math.min(max, baseDelay * Math.pow(2, count));
        if (jitter) delay = Math.random() * delay;
        return delay;
    };
}
function $fbc0c610016bf5c5$var$buildRetryFunction(retryOptions) {
    var _a = retryOptions || {}, retryIf = _a.retryIf, _b = _a.max, max = _b === void 0 ? 5 : _b;
    return function retryFunction(count, operation, error) {
        if (count >= max) return false;
        return retryIf ? retryIf(error, operation) : !!error;
    };
}
var $fbc0c610016bf5c5$var$RetryableOperation = function() {
    function RetryableOperation(operation, nextLink, delayFor, retryIf) {
        var _this = this;
        this.operation = operation;
        this.nextLink = nextLink;
        this.delayFor = delayFor;
        this.retryIf = retryIf;
        this.retryCount = 0;
        this.values = [];
        this.complete = false;
        this.canceled = false;
        this.observers = [];
        this.currentSubscription = null;
        this.onNext = function(value) {
            _this.values.push(value);
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.next(value);
            }
        };
        this.onComplete = function() {
            _this.complete = true;
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.complete();
            }
        };
        this.onError = function(error) {
            return (0, $3VFsf.__awaiter)(_this, void 0, void 0, function() {
                var shouldRetry, _i, _a, observer;
                return (0, $3VFsf.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            this.retryCount += 1;
                            return [
                                4,
                                this.retryIf(this.retryCount, this.operation, error)
                            ];
                        case 1:
                            shouldRetry = _b.sent();
                            if (shouldRetry) {
                                this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                                return [
                                    2
                                ];
                            }
                            this.error = error;
                            for(_i = 0, _a = this.observers; _i < _a.length; _i++){
                                observer = _a[_i];
                                if (!observer) continue;
                                observer.error(error);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
        };
    }
    RetryableOperation.prototype.subscribe = function(observer) {
        if (this.canceled) throw new Error("Subscribing to a retryable link that was canceled is not supported");
        this.observers.push(observer);
        for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var value = _a[_i];
            observer.next(value);
        }
        if (this.complete) observer.complete();
        else if (this.error) observer.error(this.error);
    };
    RetryableOperation.prototype.unsubscribe = function(observer) {
        var index = this.observers.indexOf(observer);
        if (index < 0) throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
        this.observers[index] = null;
        if (this.observers.every(function(o) {
            return o === null;
        })) this.cancel();
    };
    RetryableOperation.prototype.start = function() {
        if (this.currentSubscription) return;
        this.try();
    };
    RetryableOperation.prototype.cancel = function() {
        if (this.currentSubscription) this.currentSubscription.unsubscribe();
        clearTimeout(this.timerId);
        this.timerId = null;
        this.currentSubscription = null;
        this.canceled = true;
    };
    RetryableOperation.prototype.try = function() {
        this.currentSubscription = this.nextLink(this.operation).subscribe({
            next: this.onNext,
            error: this.onError,
            complete: this.onComplete
        });
    };
    RetryableOperation.prototype.scheduleRetry = function(delay) {
        var _this = this;
        if (this.timerId) throw new Error("RetryLink BUG! Encountered overlapping retries");
        this.timerId = setTimeout(function() {
            _this.timerId = null;
            _this.try();
        }, delay);
    };
    return RetryableOperation;
}();
var $fbc0c610016bf5c5$export$943d544ad120494a = function(_super) {
    (0, $3VFsf.__extends)(RetryLink, _super);
    function RetryLink(options) {
        var _this = _super.call(this) || this;
        var _a = options || {}, attempts = _a.attempts, delay = _a.delay;
        _this.delayFor = typeof delay === 'function' ? delay : $fbc0c610016bf5c5$var$buildDelayFunction(delay);
        _this.retryIf = typeof attempts === 'function' ? attempts : $fbc0c610016bf5c5$var$buildRetryFunction(attempts);
        return _this;
    }
    RetryLink.prototype.request = function(operation, nextLink) {
        var retryable = new $fbc0c610016bf5c5$var$RetryableOperation(operation, nextLink, this.delayFor, this.retryIf);
        retryable.start();
        return new (0, $clSzL.Observable)(function(observer) {
            retryable.subscribe(observer);
            return function() {
                retryable.unsubscribe(observer);
            };
        });
    };
    return RetryLink;
}((0, $clSzL.ApolloLink));

});

parcelRegister("cuKXc", function(module, exports) {

$parcel$export(module.exports, "fragmentCacheRedirect", () => $918cb5692ff82562$export$5133c88128301697);
$parcel$export(module.exports, "fragmentLinkState", () => $918cb5692ff82562$export$3f9ecfb4d42ab23d);

var $jojW6 = parcelRequire("jojW6");

var $9HlP2 = parcelRequire("9HlP2");

var $ivfDv = parcelRequire("ivfDv");
function $918cb5692ff82562$export$5133c88128301697(dataIdFromObject) {
    if (dataIdFromObject === void 0) dataIdFromObject = (0, $ivfDv.defaultDataIdFromObject);
    return {
        getFragment: function(_, _a) {
            var id = _a.id, __typename = _a.__typename;
            return (0, $jojW6.toIdValue)(dataIdFromObject({
                __typename: __typename,
                id: id
            }));
        }
    };
}
function $918cb5692ff82562$export$3f9ecfb4d42ab23d(apolloCache) {
    return (0, $9HlP2.withClientState)({
        cache: apolloCache,
        resolvers: {
            Query: {
                getFragment: function(_, _a, _b) {
                    var __typename = _a.__typename, id = _a.id;
                    var cache = _b.cache;
                    var fragmentId = cache.config.dataIdFromObject({
                        __typename: __typename,
                        id: id
                    });
                    return cache.data.data[fragmentId];
                }
            }
        }
    });
}

});
parcelRegister("9HlP2", function(module, exports) {

$parcel$export(module.exports, "withClientState", () => $70f90ea50d538958$export$a13f755900e15d9e);

var $clSzL = parcelRequire("clSzL");

var $jojW6 = parcelRequire("jojW6");

var $jWd7i = parcelRequire("jWd7i");

var $b2p88 = parcelRequire("b2p88");
var $70f90ea50d538958$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $70f90ea50d538958$var$graphql = $jWd7i.graphql;
var $70f90ea50d538958$var$capitalizeFirstLetter = function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
var $70f90ea50d538958$export$a13f755900e15d9e = function(clientStateConfig) {
    if (clientStateConfig === void 0) clientStateConfig = {
        resolvers: {},
        defaults: {}
    };
    var defaults = clientStateConfig.defaults, cache = clientStateConfig.cache, typeDefs = clientStateConfig.typeDefs, fragmentMatcher = clientStateConfig.fragmentMatcher;
    if (cache && defaults) cache.writeData({
        data: defaults
    });
    return new (function(_super) {
        $70f90ea50d538958$var$__extends(StateLink, _super);
        function StateLink() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        StateLink.prototype.writeDefaults = function() {
            if (cache && defaults) cache.writeData({
                data: defaults
            });
        };
        StateLink.prototype.request = function(operation, forward) {
            if (forward === void 0) forward = function() {
                return (0, $clSzL.Observable).of({
                    data: {}
                });
            };
            if (typeDefs) {
                var directives_1 = 'directive @client on FIELD';
                var definition_1 = (0, $b2p88.normalizeTypeDefs)(typeDefs);
                operation.setContext(function(_a) {
                    var _b = _a.schemas, schemas = _b === void 0 ? [] : _b;
                    return {
                        schemas: schemas.concat([
                            {
                                definition: definition_1,
                                directives: directives_1
                            }
                        ])
                    };
                });
            }
            var isClient = (0, $jojW6.hasDirectives)([
                'client'
            ], operation.query);
            if (!isClient) return forward(operation);
            var resolvers = typeof clientStateConfig.resolvers === 'function' ? clientStateConfig.resolvers() : clientStateConfig.resolvers;
            var server = (0, $b2p88.removeClientSetsFromDocument)(operation.query);
            var query = operation.query;
            var type = $70f90ea50d538958$var$capitalizeFirstLetter(((0, $jojW6.getMainDefinition)(query) || {}).operation) || 'Query';
            var resolver = function(fieldName, rootValue, args, context, info) {
                if (rootValue === void 0) rootValue = {};
                var resultKey = info.resultKey;
                var aliasedNode = rootValue[resultKey];
                var preAliasingNode = rootValue[fieldName];
                var aliasNeeded = resultKey !== fieldName;
                if (aliasedNode !== undefined || preAliasingNode !== undefined) return aliasedNode || preAliasingNode;
                var resolverMap = resolvers[rootValue.__typename || type];
                if (resolverMap) {
                    var resolve = resolverMap[fieldName];
                    if (resolve) return resolve(rootValue, args, context, info);
                }
                return (aliasNeeded ? aliasedNode : preAliasingNode) || (defaults || {})[fieldName];
            };
            if (server) operation.query = server;
            var obs = server && forward ? forward(operation) : (0, $clSzL.Observable).of({
                data: {}
            });
            return new (0, $clSzL.Observable)(function(observer) {
                var complete = false;
                var handlingNext = false;
                obs.subscribe({
                    next: function(_a) {
                        var data = _a.data, errors = _a.errors;
                        var observerErrorHandler = observer.error.bind(observer);
                        var context = operation.getContext();
                        handlingNext = true;
                        $70f90ea50d538958$var$graphql(resolver, query, data, context, operation.variables, {
                            fragmentMatcher: fragmentMatcher
                        }).then(function(nextData) {
                            observer.next({
                                data: nextData,
                                errors: errors
                            });
                            if (complete) observer.complete();
                            handlingNext = false;
                        }).catch(observerErrorHandler);
                    },
                    error: observer.error.bind(observer),
                    complete: function() {
                        if (!handlingNext) observer.complete();
                        complete = true;
                    }
                });
            });
        };
        return StateLink;
    }((0, $clSzL.ApolloLink)))();
};

});
parcelRegister("jWd7i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3VFsf = parcelRequire("3VFsf");

var $jojW6 = parcelRequire("jojW6");

var $jDjTr = parcelRequire("jDjTr");
function $e83d9bca6fb9481d$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $jojW6.getMainDefinition(document);
    var fragments = $jojW6.getFragmentDefinitions(document);
    var fragmentMap = $jojW6.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $e83d9bca6fb9481d$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $e83d9bca6fb9481d$var$graphql;
function $e83d9bca6fb9481d$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    return $3VFsf.__awaiter(this, void 0, void 0, function() {
        var fragmentMap, contextValue, variables, result, execute;
        var _this = this;
        return $3VFsf.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
                    result = {};
                    execute = function(selection) {
                        return $3VFsf.__awaiter(_this, void 0, void 0, function() {
                            var fieldResult, resultFieldKey, fragment, typeCondition, fragmentResult;
                            return $3VFsf.__generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!$jojW6.shouldInclude(selection, variables)) return [
                                            2
                                        ];
                                        if (!$jojW6.isField(selection)) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            $e83d9bca6fb9481d$var$executeField(selection, rootValue, execContext)
                                        ];
                                    case 1:
                                        fieldResult = _a.sent();
                                        resultFieldKey = $jojW6.resultKeyNameFromField(selection);
                                        if (fieldResult !== undefined) {
                                            if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                                            else $jDjTr.merge(result[resultFieldKey], fieldResult);
                                        }
                                        return [
                                            2
                                        ];
                                    case 2:
                                        if ($jojW6.isInlineFragment(selection)) fragment = selection;
                                        else {
                                            fragment = fragmentMap[selection.name.value];
                                            if (!fragment) throw new Error("No fragment named " + selection.name.value);
                                        }
                                        typeCondition = fragment.typeCondition.name.value;
                                        if (!execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) return [
                                            3,
                                            4
                                        ];
                                        return [
                                            4,
                                            $e83d9bca6fb9481d$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext)
                                        ];
                                    case 3:
                                        fragmentResult = _a.sent();
                                        $jDjTr.merge(result, fragmentResult);
                                        _a.label = 4;
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    };
                    return [
                        4,
                        Promise.all(selectionSet.selections.map(execute))
                    ];
                case 1:
                    _a.sent();
                    if (execContext.resultMapper) return [
                        2,
                        execContext.resultMapper(result, rootValue)
                    ];
                    return [
                        2,
                        result
                    ];
            }
        });
    });
}
function $e83d9bca6fb9481d$var$executeField(field, rootValue, execContext) {
    return $3VFsf.__awaiter(this, void 0, void 0, function() {
        var variables, contextValue, resolver, fieldName, args, info, result;
        return $3VFsf.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
                    fieldName = field.name.value;
                    args = $jojW6.argumentsObjectFromField(field, variables);
                    info = {
                        isLeaf: !field.selectionSet,
                        resultKey: $jojW6.resultKeyNameFromField(field),
                        directives: $jojW6.getDirectiveInfoFromField(field, variables),
                        field: field
                    };
                    return [
                        4,
                        resolver(fieldName, rootValue, args, contextValue, info)
                    ];
                case 1:
                    result = _a.sent();
                    if (!field.selectionSet) return [
                        2,
                        result
                    ];
                    if (result == null) return [
                        2,
                        result
                    ];
                    if (Array.isArray(result)) return [
                        2,
                        $e83d9bca6fb9481d$var$executeSubSelectedArray(field, result, execContext)
                    ];
                    return [
                        2,
                        $e83d9bca6fb9481d$var$executeSelectionSet(field.selectionSet, result, execContext)
                    ];
            }
        });
    });
}
function $e83d9bca6fb9481d$var$executeSubSelectedArray(field, result, execContext) {
    return Promise.all(result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $e83d9bca6fb9481d$var$executeSubSelectedArray(field, item, execContext);
        return $e83d9bca6fb9481d$var$executeSelectionSet(field.selectionSet, item, execContext);
    }));
}

});
parcelRegister("jDjTr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jojW6 = parcelRequire("jojW6");
function $e4b11739b667b187$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (variableValues === void 0) variableValues = {};
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $jojW6.getMainDefinition(document);
    var fragments = $jojW6.getFragmentDefinitions(document);
    var fragmentMap = $jojW6.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $e4b11739b667b187$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $e4b11739b667b187$var$graphql;
function $e4b11739b667b187$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
    var result = {};
    selectionSet.selections.forEach(function(selection) {
        if (variables && !$jojW6.shouldInclude(selection, variables)) return;
        if ($jojW6.isField(selection)) {
            var fieldResult = $e4b11739b667b187$var$executeField(selection, rootValue, execContext);
            var resultFieldKey = $jojW6.resultKeyNameFromField(selection);
            if (fieldResult !== undefined) {
                if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                else $e4b11739b667b187$var$merge(result[resultFieldKey], fieldResult);
            }
        } else {
            var fragment = void 0;
            if ($jojW6.isInlineFragment(selection)) fragment = selection;
            else {
                fragment = fragmentMap[selection.name.value];
                if (!fragment) throw new Error("No fragment named " + selection.name.value);
            }
            var typeCondition = fragment.typeCondition.name.value;
            if (execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) {
                var fragmentResult = $e4b11739b667b187$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext);
                $e4b11739b667b187$var$merge(result, fragmentResult);
            }
        }
    });
    if (execContext.resultMapper) return execContext.resultMapper(result, rootValue);
    return result;
}
function $e4b11739b667b187$var$executeField(field, rootValue, execContext) {
    var variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
    var fieldName = field.name.value;
    var args = $jojW6.argumentsObjectFromField(field, variables);
    var info = {
        isLeaf: !field.selectionSet,
        resultKey: $jojW6.resultKeyNameFromField(field),
        directives: $jojW6.getDirectiveInfoFromField(field, variables),
        field: field
    };
    var result = resolver(fieldName, rootValue, args, contextValue, info);
    if (!field.selectionSet) return result;
    if (result == null) return result;
    if (Array.isArray(result)) return $e4b11739b667b187$var$executeSubSelectedArray(field, result, execContext);
    return $e4b11739b667b187$var$executeSelectionSet(field.selectionSet, result, execContext);
}
function $e4b11739b667b187$var$executeSubSelectedArray(field, result, execContext) {
    return result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $e4b11739b667b187$var$executeSubSelectedArray(field, item, execContext);
        return $e4b11739b667b187$var$executeSelectionSet(field.selectionSet, item, execContext);
    });
}
var $e4b11739b667b187$var$hasOwn = Object.prototype.hasOwnProperty;
function $e4b11739b667b187$var$merge(dest, src) {
    if (src !== null && typeof src === 'object') Object.keys(src).forEach(function(key) {
        var srcVal = src[key];
        if (!$e4b11739b667b187$var$hasOwn.call(dest, key)) dest[key] = srcVal;
        else $e4b11739b667b187$var$merge(dest[key], srcVal);
    });
}
module.exports.merge = $e4b11739b667b187$var$merge;

});


parcelRegister("b2p88", function(module, exports) {

$parcel$export(module.exports, "removeClientSetsFromDocument", () => $80935fed9657b3c7$export$8eae69e876ee321e);
$parcel$export(module.exports, "normalizeTypeDefs", () => $80935fed9657b3c7$export$467f9c465e4ace4e);

var $1c8Um = parcelRequire("1c8Um");

var $jojW6 = parcelRequire("jojW6");
var $80935fed9657b3c7$var$connectionRemoveConfig = {
    test: function(directive) {
        return directive.name.value === 'client';
    },
    remove: true
};
var $80935fed9657b3c7$var$removed = new Map();
function $80935fed9657b3c7$export$8eae69e876ee321e(query) {
    var cached = $80935fed9657b3c7$var$removed.get(query);
    if (cached) return cached;
    (0, $jojW6.checkDocument)(query);
    var docClone = (0, $jojW6.removeDirectivesFromDocument)([
        $80935fed9657b3c7$var$connectionRemoveConfig
    ], query);
    $80935fed9657b3c7$var$removed.set(query, docClone);
    return docClone;
}
function $80935fed9657b3c7$export$467f9c465e4ace4e(typeDefs) {
    var defs = Array.isArray(typeDefs) ? typeDefs : [
        typeDefs
    ];
    return defs.map(function(typeDef) {
        return typeof typeDef === 'string' ? typeDef : (0, $1c8Um.print)(typeDef);
    }).map(function(str) {
        return str.trim();
    }).join('\n');
}

});



parcelRegister("dxpxC", function(module, exports) {

$parcel$export(module.exports, "UFOLoggerLink", () => $4350c2bcf1320fcf$export$fb326ed954631f3f);

var $clSzL = parcelRequire("clSzL");

var $bFU4G = parcelRequire("bFU4G");
const $4350c2bcf1320fcf$export$fb326ed954631f3f = new (0, $clSzL.ApolloLink)((operation, forward)=>{
    const networkStart = performance.now();
    return forward(operation).map((response)=>{
        const networkComplete = performance.now();
        const operationName = operation.operationName ?? 'unnamed';
        (0, $bFU4G.addSpanToAll)('graphql', operationName, [
            {
                name: 'network'
            }
        ], networkStart, networkComplete);
        return response;
    });
});

});

parcelRegister("5uTwE", function(module, exports) {
module.exports = JSON.parse("{\"__schema\":{\"types\":[{\"kind\":\"UNION\",\"name\":\"Admin\",\"possibleTypes\":[{\"name\":\"JiraGroup\"},{\"name\":\"JiraUser\"}]},{\"kind\":\"UNION\",\"name\":\"BoardFeatureView\",\"possibleTypes\":[{\"name\":\"BasicBoardFeatureView\"},{\"name\":\"EstimationBoardFeatureView\"}]},{\"kind\":\"UNION\",\"name\":\"BoardLocation\",\"possibleTypes\":[{\"name\":\"Project\"},{\"name\":\"UserLocation\"}]}]}}");

});


parcelRegister("j2mQS", function(module, exports) {

$parcel$export(module.exports, "disposableEpic", () => $1c9d4320a4bfd294$export$e6b812e492b046b8);
parcelRequire("7qVV7");

const $1c9d4320a4bfd294$export$e6b812e492b046b8 = (rootEpic)=>(action$, store, dependencies)=>rootEpic(action$, store, dependencies).takeUntil(action$.ofType((0, $167b7959815986d2$export$58387e80544dbf03)));

});
const $167b7959815986d2$export$58387e80544dbf03 = 'COMMON/REDUX_DISPOSABLE/DISPOSE_ACTION';


parcelRegister("bRUzT", function(module, exports) {

$parcel$export(module.exports, "DISPOSE_ACTION", () => $b69e8859fbb50550$export$78be82e7e063a3fb);

const $b69e8859fbb50550$export$78be82e7e063a3fb = {
    type: (0, $167b7959815986d2$export$58387e80544dbf03)
};

});

parcelRegister("97Kan", function(module, exports) {

$parcel$export(module.exports, "FlagsDispatcher", () => $4ddeb9f500a62e17$export$9e60e3d40b6e758f);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $fpHHI = parcelRequire("fpHHI");
const $4ddeb9f500a62e17$export$9e60e3d40b6e758f = ({ store: store, mapper: mapper })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fpHHI.Dispatcher), {
        store: store,
        mapper: mapper,
        showFlag: (0, $pa9q9.showFlag),
        dismissFlag: (0, $pa9q9.dismissFlag)
    });

});
parcelRegister("fpHHI", function(module, exports) {

$parcel$export(module.exports, "Dispatcher", () => $eef6139685bfb64e$export$ab054a1ef92eeb01);

var $5uXOq = parcelRequire("5uXOq");

var $1kijq = parcelRequire("1kijq");
const $eef6139685bfb64e$export$ab054a1ef92eeb01 = (props)=>{
    const { store: store, ...dispatcherProps } = props;
    const [lastStore, setLastStore] = (0, $5uXOq.useState)(store);
    if (store !== lastStore) setLastStore(store);
    const DispatcherComponent = (0, $5uXOq.useMemo)(()=>(0, $1kijq.createDispatcher)(store), [
        store
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DispatcherComponent, dispatcherProps);
};

});
parcelRegister("1kijq", function(module, exports) {

$parcel$export(module.exports, "createDispatcher", () => $c324e875f8c6fe8f$export$7b259d28468da15b);

var $5uXOq = parcelRequire("5uXOq");

var $kVVL1 = parcelRequire("kVVL1");

var $pa9q9 = parcelRequire("pa9q9");
const $c324e875f8c6fe8f$export$81c2f3c810206fa9 = (store)=>{
    if (!store) throw new Error('Store not available through direct injection or Provider context');
    if (!('addActionListener' in store) || !('removeActionListener' in store) || typeof store.addActionListener !== 'function' || typeof store.removeActionListener !== 'function') throw new Error("Your store doesn't support action listeners; please use the Tangerine store initialiser.");
    return store;
};
const $c324e875f8c6fe8f$export$8a44987212de21b = (store, result, showFlag, dismissFlag)=>{
    if (!result) return;
    if ((0, $pa9q9.isDismissFlag)(result)) dismissFlag(result);
    else if ((0, $pa9q9.isFlagComponent)(result)) {
        const FlagComponent = result;
        const FlagComponentWithProvider = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kVVL1.Provider), {
                store: store
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FlagComponent, props));
        showFlag(FlagComponentWithProvider);
    } else showFlag(result);
};
const $c324e875f8c6fe8f$export$2bedce6f5250e28d = (action, state, store, mapper, showFlag, dismissFlag)=>{
    // handle batch middleware
    if ((0, $pa9q9.isBatchAction)(action)) action.payload.forEach((childAction)=>{
        if (childAction.type && typeof childAction.type === 'string') {
            const childResult = mapper(childAction, state);
            $c324e875f8c6fe8f$export$8a44987212de21b(store, childResult, showFlag, dismissFlag);
        }
    });
    else {
        const result = mapper(action, state);
        $c324e875f8c6fe8f$export$8a44987212de21b(store, result, showFlag, dismissFlag);
    }
};
const $c324e875f8c6fe8f$var$Dispatcher8 = (props)=>{
    const { store: storeUnchecked, mapper: mapper, showFlag: showFlag, dismissFlag: dismissFlag } = props;
    const store = (0, $5uXOq.useMemo)(()=>$c324e875f8c6fe8f$export$81c2f3c810206fa9(storeUnchecked), [
        storeUnchecked
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const handleAction = (action, state)=>{
            $c324e875f8c6fe8f$export$2bedce6f5250e28d(action, state, store, mapper, showFlag, dismissFlag);
        };
        store.addActionListener(handleAction);
        return ()=>store.removeActionListener(handleAction);
    }, [
        store,
        mapper,
        showFlag,
        dismissFlag
    ]);
    return null;
};
const $c324e875f8c6fe8f$var$Dispatcher8DefaultStore = (props)=>{
    const store = (0, $kVVL1.useStore)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c324e875f8c6fe8f$var$Dispatcher8, {
        ...props,
        store: store
    });
};
const $c324e875f8c6fe8f$export$7b259d28468da15b = (customStore)=>{
    const Dispatcher8CustomStore = (props)=>customStore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c324e875f8c6fe8f$var$Dispatcher8, {
            ...props,
            store: customStore
        }) : null;
    return customStore ? Dispatcher8CustomStore : $c324e875f8c6fe8f$var$Dispatcher8DefaultStore;
};

});



parcelRegister("joFsm", function(module, exports) {

$parcel$export(module.exports, "default", () => $45670090ce80d9dc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $5jlQc = parcelRequire("5jlQc");
const $45670090ce80d9dc$var$MemoryObserver = ({ getCustomData: getCustomData })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        const memoryReporter = new (0, $5jlQc.PollingMemoryReporter)(createAnalyticsEvent, getCustomData);
        memoryReporter.start();
        memoryReporter.setBucketTimeouts();
        return ()=>{
            memoryReporter.stop();
            memoryReporter.clearBucketTimeouts();
        };
    }, [
        createAnalyticsEvent,
        getCustomData
    ]);
    return null;
};
var $45670090ce80d9dc$export$2e2bcd8739ae039 = $45670090ce80d9dc$var$MemoryObserver;

});
parcelRegister("5jlQc", function(module, exports) {

$parcel$export(module.exports, "PollingMemoryReporter", () => $621c8fa9757e42da$export$3e76404af7b93e06);

var $2YZCu = parcelRequire("2YZCu");

var $8zOmE = parcelRequire("8zOmE");

var $4wNtT = parcelRequire("4wNtT");

var $aA83m = parcelRequire("aA83m");
const $621c8fa9757e42da$var$minMs = 60000; // number of ms in a minute
const $621c8fa9757e42da$export$54912f9240c8e5db = 20 * $621c8fa9757e42da$var$minMs;
const $621c8fa9757e42da$export$9f536c7d89257714 = [
    2 * $621c8fa9757e42da$var$minMs,
    10 * $621c8fa9757e42da$var$minMs
];
const $621c8fa9757e42da$export$c63950c55adb1607 = (createAnalyticsEvent, getCustomData)=>{
    try {
        const memoryUsageReport = (0, $aA83m.getMemoryUsageReport)();
        if (memoryUsageReport == null) return;
        const { sessionTime: sessionTime, performanceMemoryEntry: { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } } = memoryUsageReport;
        const customData = getCustomData ? getCustomData() : {};
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'memory tracked', {
            bucket: (0, $4wNtT.memoryBucketHandler).getBucket(usedJSHeapSize),
            sessionTime: sessionTime,
            sessionTimeBucket: (0, $4wNtT.sessionTimeBucketHandler).getBucket(sessionTime),
            jsHeapSizeLimit: jsHeapSizeLimit,
            totalJSHeapSize: totalJSHeapSize,
            usedJSHeapSize: usedJSHeapSize,
            ...customData
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('observability.memory-metrics.measure-and-report-memory', 'Failed to poll for memory usage');
    }
};
class $621c8fa9757e42da$export$3e76404af7b93e06 {
    constructor(createAnalyticsEvent, getCustomData){
        this.pollInterval = null;
        this.bucketTimeouts = null;
        this.report = ()=>{
            $621c8fa9757e42da$export$c63950c55adb1607(this.createAnalyticsEvent, this.getCustomData);
        };
        this.onVisibilityChange = ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const isHidden = window.document?.hidden === true;
            if (isHidden) this.stop();
            else {
                this.stop();
                this.start();
            }
        };
        this.createAnalyticsEvent = createAnalyticsEvent;
        this.getCustomData = getCustomData;
    }
    start() {
        if (this.pollInterval != null) return;
        this.report();
        // @ts-expect-error - TS2322 - Type 'Timer' is not assignable to type 'number'.
        this.pollInterval = setInterval(()=>{
            if (this.pollInterval == null) return;
            this.report();
        }, $621c8fa9757e42da$export$54912f9240c8e5db);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('visibilitychange', this.onVisibilityChange);
    }
    stop() {
        if (this.pollInterval != null) {
            clearInterval(this.pollInterval);
            this.pollInterval = null;
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
    }
    setBucketTimeouts() {
        this.bucketTimeouts = $621c8fa9757e42da$export$9f536c7d89257714.map((ms)=>setTimeout(()=>{
                this.report();
            }, ms));
    }
    clearBucketTimeouts() {
        this.bucketTimeouts?.forEach((timeout)=>{
            clearTimeout(timeout);
        });
    }
}

});
parcelRegister("4wNtT", function(module, exports) {

$parcel$export(module.exports, "memoryBucketHandler", () => $2459a841a83bbb5c$export$26aac2ead17b35e5);
$parcel$export(module.exports, "sessionTimeBucketHandler", () => $2459a841a83bbb5c$export$af08fe8a31c89520);
class $2459a841a83bbb5c$export$a9fa854dd2f29162 {
    constructor(buckets, options){
        this.buckets = buckets;
        this.formatLabel = options?.formatLabel ?? ((low, high)=>`${low}-${high ?? 'Inf'}`);
    }
    /**
	 * Returns the lowest matching bucket for this measurement.
	 *
	 * For example, if buckets are [0, 10, 20, 30] and the measurement is 15,
	 * this function will return 10 meaning this measurement is in the 10-20
	 * range.
	 */ getBucket(measurement) {
        const bucketIndex = this.buckets.findIndex((bucket)=>measurement < bucket);
        if (bucketIndex < 0) return this.formatLabel(this.buckets[this.buckets.length - 1]);
        return this.formatLabel(this.buckets[bucketIndex - 1], this.buckets[bucketIndex]);
    }
}
const $2459a841a83bbb5c$var$mbBytes = 1048576; // number of bytes in a MB
const $2459a841a83bbb5c$var$minMs = 60000; // number of ms in a minute
const $2459a841a83bbb5c$export$26aac2ead17b35e5 = new $2459a841a83bbb5c$export$a9fa854dd2f29162([
    0,
    100 * $2459a841a83bbb5c$var$mbBytes,
    200 * $2459a841a83bbb5c$var$mbBytes,
    400 * $2459a841a83bbb5c$var$mbBytes,
    800 * $2459a841a83bbb5c$var$mbBytes,
    1600 * $2459a841a83bbb5c$var$mbBytes,
    3200 * $2459a841a83bbb5c$var$mbBytes
], {
    formatLabel: (lowBucket, highBucket)=>`${lowBucket / $2459a841a83bbb5c$var$mbBytes}-${highBucket != null ? highBucket / $2459a841a83bbb5c$var$mbBytes : 'Inf'}MB`
});
const $2459a841a83bbb5c$export$af08fe8a31c89520 = new $2459a841a83bbb5c$export$a9fa854dd2f29162([
    0,
    2 * $2459a841a83bbb5c$var$minMs,
    5 * $2459a841a83bbb5c$var$minMs,
    10 * $2459a841a83bbb5c$var$minMs,
    20 * $2459a841a83bbb5c$var$minMs
], {
    formatLabel: (lowBucket, highBucket)=>`${lowBucket / $2459a841a83bbb5c$var$minMs}-${highBucket != null ? highBucket / $2459a841a83bbb5c$var$minMs : 'Inf'}MIN`
});

});



const $8631d6ce464ccf2e$export$9b8283d5878d2491 = 'BOARD';
const $8631d6ce464ccf2e$export$dedbdcc35e955187 = 'BACKLOG';
const $8631d6ce464ccf2e$export$ffff0a2c60bf4822 = 'ROADMAPS';
const $8631d6ce464ccf2e$export$78244dbb77cfa6b6 = 'UNKNOWN';
const $8631d6ce464ccf2e$export$b7dfe28569b170a1 = 'RESOURCES_CACHE_UPDATER_SOURCE';
const $8631d6ce464ccf2e$export$889129cf7f70997b = 'resourcesCacheSource';

parcelRegister("hN2XX", function(module, exports) {

$parcel$export(module.exports, "default", () => $43e79ffcea087bf1$export$2e2bcd8739ae039);
$parcel$export(module.exports, "triggerCacheRefreshAnalytics", () => $43e79ffcea087bf1$export$e78b5ce2eed37743);

var $cab1K = parcelRequire("cab1K");
// Standard observer pattern, when the board/backlog/roadmap is mounted and loaded cache,
// but cache is stale and is updated by live data, this will be triggered
const $43e79ffcea087bf1$var$ResourcesCacheRefreshAnalytics = new (0, $cab1K.Subject)();
var $43e79ffcea087bf1$export$2e2bcd8739ae039 = $43e79ffcea087bf1$var$ResourcesCacheRefreshAnalytics;
const $43e79ffcea087bf1$export$e78b5ce2eed37743 = (origin)=>{
    $43e79ffcea087bf1$var$ResourcesCacheRefreshAnalytics.next(origin);
};

});

parcelRegister("bicfN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c2dc8c17f1f21ea3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $i2Rm5 = parcelRequire("i2Rm5");

var $ddxdb = parcelRequire("ddxdb");

var $4NXqP = parcelRequire("4NXqP");

var $k3C5L = parcelRequire("k3C5L");
const $c2dc8c17f1f21ea3$var$ResourcesCacheWrapper = ({ origin: origin })=>{
    (0, $ddxdb.default)(origin);
    (0, $k3C5L.default)();
    (0, $4NXqP.default)(origin);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
};
const $c2dc8c17f1f21ea3$var$ResourcesCacheWrapperWithBoundary = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i2Rm5.ErrorBoundaryFlag), {
        id: "jira-software-resource-invalidator"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c2dc8c17f1f21ea3$var$ResourcesCacheWrapper, props));
var $c2dc8c17f1f21ea3$export$2e2bcd8739ae039 = $c2dc8c17f1f21ea3$var$ResourcesCacheWrapperWithBoundary;

});
parcelRegister("ddxdb", function(module, exports) {

$parcel$export(module.exports, "default", () => $18c7e4eef3bac87c$export$2e2bcd8739ae039);
/* eslint-disable react-hooks/exhaustive-deps */ 
var $5uXOq = parcelRequire("5uXOq");
parcelRequire("7mHDu");
parcelRequire("1oQta");

var $8Uumt = parcelRequire("8Uumt");

var $koeKL = parcelRequire("koeKL");

var $doZTA = parcelRequire("doZTA");

var $b0yad = parcelRequire("b0yad");

var $8asTe = parcelRequire("8asTe");

var $77kqL = parcelRequire("77kqL");
/*
 * This hook is for handling when a change is performed that should invalidate the cache of another
 * resource. In the current case, the BOARD and BACKLOG caches are intertwined such that a major change
 * in the BOARD will invalidate the BACKLOG.
 */ const $18c7e4eef3bac87c$var$useResourcesCacheInvalidation = (origin)=>{
    const [resourcesRef] = (0, $8asTe.default)();
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const cloudId = (0, $koeKL.useCloudId)();
    const [{ match: match }] = (0, $doZTA.useRouter)();
    const boardId = match.params.boardId || '';
    (0, $5uXOq.useEffect)(()=>{
        // We don't want to refresh every time we have a change. Instead we only tell it to refresh its cache
        // AFTER we leave. The reason for doing this is we get a fresh cached version AFTER we've done all
        // our actions (and we minimise the number of API calls)
        let needToClearResourcesCacheOnExit = false;
        // We only need to proc this once and then we don't care about any further invalidation events
        const subscription = (0, $b0yad.default).filter((val)=>val === origin).take(1).subscribe(()=>{
            // If we get an invalidation specific to this page, we flush out the caches of
            // all other pages we have cached that could be impacted
            Object.keys(resourcesRef.current).filter((key)=>key !== origin).forEach((key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<CacheInvalidationType, Resource>>'.
                resourcesRef.current[key].clear();
            });
            // Invalidate the boardScope resource in the Relay store
            (0, $77kqL.invalidateRelayStore)(environment, cloudId, boardId);
            // If we are allowed to refresh this cache on exit, set the flag for it
            if (origin in resourcesRef.current) needToClearResourcesCacheOnExit = true;
        });
        return ()=>{
            subscription.unsubscribe();
            if (needToClearResourcesCacheOnExit && origin in resourcesRef.current) {
                // Clear out this cache after we leave so when we come back we get a more up to date version.
                resourcesRef.current[origin].clear();
                // Invalidate the boardScope resource in the Relay store
                (0, $77kqL.invalidateRelayStore)(environment, cloudId, boardId);
            }
        };
    }, [
        origin,
        resourcesRef,
        environment,
        cloudId,
        boardId
    ]);
    return [
        (0, $b0yad.default)
    ];
};
var $18c7e4eef3bac87c$export$2e2bcd8739ae039 = $18c7e4eef3bac87c$var$useResourcesCacheInvalidation;

});
parcelRegister("b0yad", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d7966c085fcd143$export$2e2bcd8739ae039);
$parcel$export(module.exports, "triggerResourceCacheInvalidation", () => $0d7966c085fcd143$export$76c3549b2288ab5d);
$parcel$export(module.exports, "addInvalidationReason", () => $0d7966c085fcd143$export$77045c8772786aca);
$parcel$export(module.exports, "getAndClearInvalidationReasons", () => $0d7966c085fcd143$export$c5ab3b0612bd31b4);

var $cab1K = parcelRequire("cab1K");


var $h8O2U = parcelRequire("h8O2U");
const $0d7966c085fcd143$var$invalidationTracker = new (0, $h8O2U.CacheInvalidationTracker)();
// Standard observer pattern, the middleware in board/backlog will invoke this
// when it comes across a matching redux mutation that requires the cache
// to be purged
const $0d7966c085fcd143$var$ResourcesCacheInvalidationSubject = new (0, $cab1K.Subject)();
var $0d7966c085fcd143$export$2e2bcd8739ae039 = $0d7966c085fcd143$var$ResourcesCacheInvalidationSubject;
const $0d7966c085fcd143$export$76c3549b2288ab5d = (origin, reason = (0, $8631d6ce464ccf2e$export$78244dbb77cfa6b6))=>{
    $0d7966c085fcd143$var$ResourcesCacheInvalidationSubject.next(origin);
    $0d7966c085fcd143$var$invalidationTracker.addReason(origin, reason);
};
const $0d7966c085fcd143$export$77045c8772786aca = (origin, reason)=>{
    $0d7966c085fcd143$var$invalidationTracker.addReason(origin, reason);
};
const $0d7966c085fcd143$export$c5ab3b0612bd31b4 = (origin)=>$0d7966c085fcd143$var$invalidationTracker.getAndClearReasons(origin);

});
parcelRegister("h8O2U", function(module, exports) {

$parcel$export(module.exports, "CacheInvalidationTracker", () => $42c3911f8f33a9e0$export$71900622f425a7c3);

class $42c3911f8f33a9e0$export$71900622f425a7c3 {
    /**
	 * Pushes an invalidation reason to be tracked on the next cache-miss.
	 */ addReason(origin, reason = (0, $8631d6ce464ccf2e$export$78244dbb77cfa6b6)) {
        const reasonString = `${origin}:${reason}`;
        Object.keys(this.reasons).forEach((key)=>{
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<CacheInvalidationType, Set<string>>>'.
            if (this.reasons[key].size >= 10) return;
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<CacheInvalidationType, Set<string>>>'.
            this.reasons[key].add(reasonString);
        });
    }
    /**
	 * Fetch invalidation reasons from the reasons set.
	 *
	 * If an experience does not read / clear reasons there's still only a bounded number of strings
	 * (10) that will be added into the Set; e.g. it's not a memory concern.
	 *
	 * The reasons are sorted.
	 */ getAndClearReasons(origin) {
        const reasonsSet = this.reasons[origin];
        const reasons = Array.from(reasonsSet);
        reasons.sort();
        reasonsSet.clear();
        return reasons;
    }
    constructor(){
        /**
	 * Holds reasons cache has been invalidated as a set of strings, for example:
	 *
	 * * BOARD:state.ISSUE_MOVE
	 * * BACKLOG:CREATE_SPRINT
	 *
	 * Reasons are kept separately for each page because they'll be cleared when the page is loaded.
	 *
	 * The reasoning can be exemplified by:
	 *
	 * * Visit board
	 * * Visit backlog
	 * * Visit roadmaps
	 * * Visit backlog - Load from cache
	 * * Make a BACKLOG:CARD_MOVE invalidation reason in backlog
	 *   * All 3 caches are now cleared
	 * * Visit board - reason is BACKLOG:CARD_MOVE - reasons are cleared;
	 * * Visit roadmaps - reason is BACKLOG:CARD_MOVE - reasons are cleared;
	 * * Visit backlog - reason is BACKLOG:CARD_MOVE - reasons are cleared;
	 * * Make a BACKLOG:SPRINT_COMPLETE invalidation reason in backlog
	 * * Visit board - reason is BACKLOG:SPRINT_COMPLETE **only**
	 */ this.reasons = {
            [(0, $8631d6ce464ccf2e$export$9b8283d5878d2491)]: new Set(),
            [(0, $8631d6ce464ccf2e$export$dedbdcc35e955187)]: new Set(),
            [(0, $8631d6ce464ccf2e$export$ffff0a2c60bf4822)]: new Set(),
            [(0, $8631d6ce464ccf2e$export$78244dbb77cfa6b6)]: new Set()
        };
    }
}

});


parcelRegister("8asTe", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c43deb1cb1e63c2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5qQ9I = parcelRequire("5qQ9I");

var $bAB30 = parcelRequire("bAB30");

var $jsFU4 = parcelRequire("jsFU4");

var $2YP9W = parcelRequire("2YP9W");

// We only ever want refresh and update in this component
// @ts-expect-error - TS7031 - Binding element 'update' implicitly has an 'any' type. | TS7031 - Binding element 'refresh' implicitly has an 'any' type. | TS7031 - Binding element 'clear' implicitly has an 'any' type.
const $7c43deb1cb1e63c2$var$buildResource = ({ update: update, refresh: refresh, clear: clear })=>({
        update: update,
        refresh: refresh,
        clear: clear
    });
/*
 * Simple hook that wraps the commonly used JSW resources in a dictionary and returns them
 */ const $7c43deb1cb1e63c2$var$useResourcesCacheTracker = ()=>{
    const boardResource = (0, $2YP9W.useResource)((0, $5qQ9I.boardResource));
    const backlogResource = (0, $2YP9W.useResource)((0, $bAB30.backlogResource));
    const roadmapResource = (0, $2YP9W.useResource)((0, $jsFU4.nextGenRoadmapResource));
    // Store the retrieved objects in an internal state. The reason for doing this is because when our routes
    // change, the objects returned from useResource appear to change as well. We don't want/need that.
    const resourcesByOriginByRef = (0, $5uXOq.useRef)({});
    (0, $5uXOq.useEffect)(()=>{
        resourcesByOriginByRef.current = {
            [(0, $b982f18ac4600ef5$export$9b8283d5878d2491)]: $7c43deb1cb1e63c2$var$buildResource(boardResource),
            [(0, $b982f18ac4600ef5$export$dedbdcc35e955187)]: $7c43deb1cb1e63c2$var$buildResource(backlogResource),
            [(0, $b982f18ac4600ef5$export$ffff0a2c60bf4822)]: $7c43deb1cb1e63c2$var$buildResource(roadmapResource)
        };
    }, [
        boardResource,
        backlogResource,
        roadmapResource
    ]);
    // @ts-expect-error - TS2322 - Type 'MutableRefObject<{}>' is not assignable to type 'ResourcesDictionary'.
    return [
        resourcesByOriginByRef
    ];
};
var $7c43deb1cb1e63c2$export$2e2bcd8739ae039 = $7c43deb1cb1e63c2$var$useResourcesCacheTracker;

});
parcelRegister("5qQ9I", function(module, exports) {

$parcel$export(module.exports, "boardResource", () => $21d99b29ea940c83$export$286b76e0f2661cfb);
$parcel$export(module.exports, "customFiltersResource", () => $21d99b29ea940c83$export$3e390340716755de);
$parcel$export(module.exports, "boardFilterRefinementResource", () => $21d99b29ea940c83$export$283d16e3e02421f0);
$parcel$export(module.exports, "boardRelayResource", () => $21d99b29ea940c83$export$81ac23db76b1f935);
// eslint-disable-next-line jira/import-whitelist -- Unclear how to change the config whilst we transition to flat config

var $6s1PB = parcelRequire("6s1PB");

var $dXq4S = parcelRequire("dXq4S");

var $ao2h1 = parcelRequire("ao2h1");

var $6mTNg = parcelRequire("6mTNg");

var $9fgCw = parcelRequire("9fgCw");

var $ke2kk = parcelRequire("ke2kk");

var $gNStA = parcelRequire("gNStA");

var $2M1hQ = parcelRequire("2M1hQ");


const $21d99b29ea940c83$export$286b76e0f2661cfb = (0, $gNStA.browserOnlyResourceWithCondition)(()=>false, (0, $2M1hQ.createResource)({
    type: (0, $a00fc8fb83f2948a$export$a38ac7339e3f31db),
    getKey: ({ match: match })=>match.params.boardId || '',
    getDataLoader: ()=>(parcelRequire("dhimE")),
    // SSR doesn't care about this and we can't check FFs here because its not in the render path
    maxAge: 3600000
}));
const $21d99b29ea940c83$export$3e390340716755de = (0, $gNStA.browserOnlyResourceWithCondition)(()=>false, (0, $ao2h1.createRelayResource)({
    type: (0, $a00fc8fb83f2948a$export$b48bcc76a0105016),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $9fgCw.default),
            variables: {
                boardId: (0, $dXq4S.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
}));
const $21d99b29ea940c83$export$283d16e3e02421f0 = (0, $gNStA.resourceWithCondition2)(()=>(0, $6s1PB.expVal)('filter_refinement_in_tmp_board', 'isEnabled', false), (0, $ao2h1.createRelayResource)({
    type: (0, $a00fc8fb83f2948a$export$339da8fd7fc0a8e9),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $ke2kk.default),
            variables: {
                cloudId: tenantContext.cloudId,
                boardId: (0, $dXq4S.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                }),
                filterRefinementScope: {
                    board: {
                        boardId: Number(match.params.boardId)
                    }
                }
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    isBrowserOnly: true
}));
const $21d99b29ea940c83$export$81ac23db76b1f935 = (0, $gNStA.browserOnlyResourceWithCondition)(()=>false, (0, $ao2h1.createRelayResource)({
    type: (0, $a00fc8fb83f2948a$export$5cef388780439aec),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $6mTNg.default),
            variables: {
                boardId: (0, $dXq4S.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
}));

});
parcelRegister("6mTNg", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddc6b6eeb5cc2255$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<916f92cb49153da25a6abe2a4d651185>>
 * @relayHash 1b45667561f9430ea4e961757485983b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ab366f74068bb048193650cda464a839daec6f71dd9d1e7ee8874e9f9959ba67
const $ddc6b6eeb5cc2255$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "ab366f74068bb048193650cda464a839daec6f71dd9d1e7ee8874e9f9959ba67",
        "metadata": {},
        "name": "boardWithRouterRelayQuery",
        "operationKind": "query",
        "text": null
    }
};
var $ddc6b6eeb5cc2255$export$2e2bcd8739ae039 = $ddc6b6eeb5cc2255$var$node;

});

parcelRegister("9fgCw", function(module, exports) {

$parcel$export(module.exports, "default", () => $59a4f75157ae0306$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3e40c06e874adef0395c5788a7d119a9>>
 * @relayHash fa277d121f8f09e75035802d7ede6889
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a079984b25df71d288de249187cdd59463b205124f1a0a13756db6b3207ef56b
const $59a4f75157ae0306$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "a079984b25df71d288de249187cdd59463b205124f1a0a13756db6b3207ef56b",
        "metadata": {},
        "name": "viewBoardCustomFiltersQuery",
        "operationKind": "query",
        "text": null
    }
};
var $59a4f75157ae0306$export$2e2bcd8739ae039 = $59a4f75157ae0306$var$node;

});

parcelRegister("ke2kk", function(module, exports) {

$parcel$export(module.exports, "default", () => $32c6ecabe578696e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b2791ce93d3a0a0e17fee486ad965601>>
 * @relayHash 5c749d389bf268ee9226560ad568adcf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9283dbd6d43bd23893ba0d1fb905c533d07635b370710c93db0ea67cb8b41e06
const $32c6ecabe578696e$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "9283dbd6d43bd23893ba0d1fb905c533d07635b370710c93db0ea67cb8b41e06",
        "metadata": {},
        "name": "boardFilterRefinementQuery",
        "operationKind": "query",
        "text": null
    }
};
var $32c6ecabe578696e$export$2e2bcd8739ae039 = $32c6ecabe578696e$var$node;

});

const $a00fc8fb83f2948a$export$a38ac7339e3f31db = 'NEXTGEN_BOARD';
const $a00fc8fb83f2948a$export$b48bcc76a0105016 = 'NEXTGEN_BOARD_CUSTOM_FILTERS';
const $a00fc8fb83f2948a$export$5cef388780439aec = 'NEXTGEN_BOARD_RELAY';
const $a00fc8fb83f2948a$export$339da8fd7fc0a8e9 = 'NEXTGEN_BOARD_FILTER_REFINEMENT';

parcelRegister("dhimE", function(module, exports) {

let $9aab1baa202b1068$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $9aab1baa202b1068$var$load("kVX56"),
    $9aab1baa202b1068$var$load("j6VPG")
]).then(()=>parcelRequire('11pNz'));

});


parcelRegister("bAB30", function(module, exports) {

$parcel$export(module.exports, "backlogResource", () => $d3029439c7d3b0b0$export$31d171ba71468137);

var $gNStA = parcelRequire("gNStA");

var $2M1hQ = parcelRequire("2M1hQ");


const $d3029439c7d3b0b0$export$31d171ba71468137 = (0, $gNStA.browserOnlyResourceWithCondition)(()=>false, (0, $2M1hQ.createResource)({
    type: (0, $fe839261f35d1611$export$a0ef589381533a7c),
    getKey: ({ match: match })=>match.params.boardId || '',
    getDataLoader: ()=>Promise.resolve((parcelRequire("lq5RB"))),
    // SSR doesn't care about this and we can't check FFs here because its not in the render path
    maxAge: 3600000
}));

});
const $fe839261f35d1611$export$faa68b3df5415bcb = 'NEXTGEN_BACKLOG_CUSTOM_FILTERS';
const $fe839261f35d1611$export$a0ef589381533a7c = 'NEXTGEN_BACKLOG';


parcelRegister("jsFU4", function(module, exports) {

$parcel$export(module.exports, "nextGenRoadmapResource", () => $0b5ed5206b5a609e$export$2750f87d68dfb02a);

var $2M1hQ = parcelRequire("2M1hQ");


const $0b5ed5206b5a609e$export$2750f87d68dfb02a = (0, $2M1hQ.createResource)({
    type: (0, $87d7efe6336d8b83$export$75dfa03544a19422),
    getKey: ({ match: match })=>match.params.boardId || '',
    getDataLoader: ()=>(parcelRequire("9QR9m")),
    // SSR doesn't care about this and we can't check FFs here because its not in the render path
    maxAge: 3600000,
    isBrowserOnly: true
});

});
const $87d7efe6336d8b83$export$75dfa03544a19422 = 'ROADMAP';
const $87d7efe6336d8b83$export$e3b1cd17bd82de3d = 'CLASSIC_ROADMAP';
const $87d7efe6336d8b83$export$e905b9170ecbb599 = 'BOARD_CONTEXT_ROADMAP_SETTINGS';

parcelRegister("9QR9m", function(module, exports) {

let $72c232e3722805ed$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $72c232e3722805ed$var$load("kVX56"),
    $72c232e3722805ed$var$load("hjzlf")
]).then(()=>parcelRequire('d0ZST'));

});


const $b982f18ac4600ef5$export$9b8283d5878d2491 = 'BOARD';
const $b982f18ac4600ef5$export$dedbdcc35e955187 = 'BACKLOG';
const $b982f18ac4600ef5$export$ffff0a2c60bf4822 = 'ROADMAPS';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b982f18ac4600ef5$var$UNKNOWN = 'UNKNOWN';


parcelRegister("77kqL", function(module, exports) {

$parcel$export(module.exports, "invalidateRelayStore", () => $27e06e0f0fab949e$export$fac5cf9145049c1c);

var $dXq4S = parcelRequire("dXq4S");
const $27e06e0f0fab949e$export$fac5cf9145049c1c = (environment, cloudId, boardId)=>{
    const boardAri = (0, $dXq4S.createAri)({
        resourceOwner: 'jira-software',
        cloudId: cloudId,
        resourceType: 'board',
        resourceId: boardId
    });
    environment.commitUpdate((store)=>{
        const boardScopeRecord = store.getRoot().getLinkedRecord('boardScope', {
            boardId: boardAri
        });
        if (boardScopeRecord) boardScopeRecord.invalidateRecord();
    });
};

});


parcelRegister("4NXqP", function(module, exports) {

$parcel$export(module.exports, "default", () => $0697b27d8d29769e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("1oQta");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $hN2XX = parcelRequire("hN2XX");
/*
 * This hook is for firing an analytics event to track whether the cache is stale
 * It will be fired when we load a cache but the cache is stale and later gets updated
 */ const $0697b27d8d29769e$var$useCacheRefreshAnalytics = (origin)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        const subscription = (0, $hN2XX.default).filter((val)=>val === origin).subscribe(()=>{
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'resourcesCacheInvalidator updatedStaleData', {
                origin: origin
            });
        });
        return ()=>{
            subscription.unsubscribe();
        };
    }, [
        createAnalyticsEvent,
        origin
    ]);
    return [
        (0, $hN2XX.default)
    ];
};
var $0697b27d8d29769e$export$2e2bcd8739ae039 = $0697b27d8d29769e$var$useCacheRefreshAnalytics;

});

parcelRegister("k3C5L", function(module, exports) {

$parcel$export(module.exports, "default", () => $47581646a47d84d9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");
parcelRequire("1oQta");


var $gBFyV = parcelRequire("gBFyV");

var $8asTe = parcelRequire("8asTe");
/*
 * Note this is only really used to handle real-time updates or any other methods of updating the cache
 */ const $47581646a47d84d9$var$useResourcesCacheUpdater = ()=>{
    // Use a local resources cache to track all the useResource instances for each key
    const [resourcesByRef] = (0, $8asTe.default)();
    (0, $5uXOq.useEffect)(()=>{
        // We only need to proc this once and then we don't care about any further invalidation events
        const subscription = (0, $gBFyV.default).filter((msg)=>!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(msg.origin)).subscribe((msg)=>{
            // Only handle this update if we have the resources in our dictionary
            if (msg.origin in resourcesByRef.current) {
                if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(msg.payload)) resourcesByRef.current[msg.origin].clear();
                else // @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS2345 - Argument of type '(currentData: any) => any' is not assignable to parameter of type '() => null'. | TS7006 - Parameter 'currentData' implicitly has an 'any' type.
                resourcesByRef.current[msg.origin].update((currentData)=>({
                        ...currentData,
                        ...msg.payload,
                        // Metadata to tell us where this actually came from
                        [(0, $8631d6ce464ccf2e$export$889129cf7f70997b)]: (0, $8631d6ce464ccf2e$export$b7dfe28569b170a1)
                    }));
            }
        });
        return ()=>{
            subscription.unsubscribe();
        };
    }, [
        resourcesByRef
    ]);
    return [
        (0, $gBFyV.default)
    ];
};
var $47581646a47d84d9$export$2e2bcd8739ae039 = $47581646a47d84d9$var$useResourcesCacheUpdater;

});
parcelRegister("gBFyV", function(module, exports) {

$parcel$export(module.exports, "default", () => $48bba9321b275587$export$2e2bcd8739ae039);

var $cab1K = parcelRequire("cab1K");
var // Standard observer pattern, the middleware in board/backlog will invoke this
// when it comes across a matching redux mutation that requires the cache
// to be updated
// eslint-disable-next-line jira/import/no-anonymous-default-export
$48bba9321b275587$export$2e2bcd8739ae039 = new (0, $cab1K.Subject)();

});



parcelRegister("10Ngv", function(module, exports) {

$parcel$export(module.exports, "getExtractedFields", () => $c9327b9d7a8ceb5b$export$44c042f94120778f);
$parcel$export(module.exports, "useStoreFields", () => $c9327b9d7a8ceb5b$export$52c92ba3608fca57);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $x9xyg = parcelRequire("x9xyg");

var $3fAi8 = parcelRequire("3fAi8");

var $9zRWV = parcelRequire("9zRWV");

var $kzhoX = parcelRequire("kzhoX");
const $c9327b9d7a8ceb5b$export$44c042f94120778f = (0, $8QpSo.default)((extractedCustomFields)=>Object.values(extractedCustomFields).reduce((extractedFields, extractedCustomFieldId)=>{
        const extractedCustomField = extractedCustomFieldId || '';
        if (extractedCustomField) extractedFields.push(extractedCustomField);
        return extractedFields;
    }, [
        ...(0, $9zRWV.extractedFixedFields)
    ]));
const $c9327b9d7a8ceb5b$export$52c92ba3608fca57 = ({ issueParents: issueParents } = {})=>{
    const [, fieldsValueActions] = (0, $3fAi8.useFieldsValuesActions)();
    const storeFieldsActions = (0, $5uXOq.useMemo)(()=>{
        const storeFieldsFromCardCreateData = (cardCreateData, fieldConfigs)=>{
            (0, $kzhoX.mergeFieldsFromCardCreateData)(cardCreateData, fieldsValueActions, fieldConfigs, issueParents);
        };
        const storeFieldsFromFetchIssuesData = (issues, epicIssueType)=>{
            (0, $x9xyg.measureFunc)('storeFieldsFromFetchIssuesData', ()=>{
                (0, $kzhoX.mergeFieldsFromFetchIssuesData)(issues, fieldsValueActions, epicIssueType);
            });
        };
        const storeFieldsFromPrefetchedData = (prefetchedData, fieldConfigs)=>(0, $x9xyg.measureFunc)('storeFieldsFromPrefetchedData', ()=>{
                (0, $kzhoX.mergeFieldsFromPrefetchedData)(prefetchedData, fieldsValueActions, fieldConfigs);
            });
        const storeFieldsFromPrefetchedPlanData = (prefetchedJiraPlanRestData, epicIssueType)=>(0, $x9xyg.measureFunc)('storeFieldsFromPrefetchedJiraPlanRestData', ()=>{
                (0, $kzhoX.mergeFieldsFromPrefetchedJiraPlanData)(prefetchedJiraPlanRestData, fieldsValueActions, epicIssueType);
            });
        return {
            storeFieldsFromCardCreateData: storeFieldsFromCardCreateData,
            storeFieldsFromFetchIssuesData: storeFieldsFromFetchIssuesData,
            storeFieldsFromPrefetchedData: storeFieldsFromPrefetchedData,
            storeFieldsFromPrefetchedPlanData: storeFieldsFromPrefetchedPlanData
        };
    }, [
        fieldsValueActions,
        issueParents
    ]);
    return storeFieldsActions;
};

});
parcelRegister("3fAi8", function(module, exports) {

$parcel$export(module.exports, "useFieldValue", () => $ddbc380ab4ee430c$export$b79fae7fbe3ac392);
$parcel$export(module.exports, "useFieldsValues", () => $ddbc380ab4ee430c$export$25b73e671fe7a8fa);
$parcel$export(module.exports, "useMultiFieldValuesForIssues", () => $ddbc380ab4ee430c$export$915cdeec521b54f7);
$parcel$export(module.exports, "FieldValueSubscriber", () => $ddbc380ab4ee430c$export$4e5f1f4ed08d155e);
$parcel$export(module.exports, "useFieldsValuesActions", () => $ddbc380ab4ee430c$export$612d9bcb0c9d8976);

var $5uXOq = parcelRequire("5uXOq");

var $1UikQ = parcelRequire("1UikQ");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");
const $ddbc380ab4ee430c$var$setIssue = (issueKey, fields)=>({ setState: setState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: fields
        });
    };
const $ddbc380ab4ee430c$var$setIssues = (issues)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState(newIssues);
    };
const $ddbc380ab4ee430c$var$setFieldValue = (issueKey, fieldKey, value)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: value
            }
        });
    };
const $ddbc380ab4ee430c$var$getFieldValue = (issueKey, fieldKey)=>({ getState: getState })=>{
        const issueFieldValues = getState()[issueKey];
        return issueFieldValues && issueFieldValues[fieldKey];
    };
const $ddbc380ab4ee430c$var$mergeIssue = (issueKey, fields)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, getState()[issueKey], fields)
        });
    };
const $ddbc380ab4ee430c$export$11aa02e14fdf7753 = (issues)=>({ setState: setState, getState: getState })=>{
        if (issues.length === 0) return;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, getState(), newIssues));
    };
const $ddbc380ab4ee430c$var$actions = {
    setFieldValue: $ddbc380ab4ee430c$var$setFieldValue,
    getFieldValue: $ddbc380ab4ee430c$var$getFieldValue,
    setIssue: $ddbc380ab4ee430c$var$setIssue,
    mergeIssue: $ddbc380ab4ee430c$var$mergeIssue,
    setIssues: $ddbc380ab4ee430c$var$setIssues,
    mergeIssues: $ddbc380ab4ee430c$export$11aa02e14fdf7753
};
// this is a global store
const $ddbc380ab4ee430c$var$store = (0, $iXqE5.createStore)({
    name: 'issue-fields',
    initialState: {},
    actions: $ddbc380ab4ee430c$var$actions
});
const $ddbc380ab4ee430c$var$getFieldValueSelector = (state, { issueKey: issueKey, fieldKey: fieldKey })=>{
    const issueFieldValues = state[issueKey];
    return issueFieldValues && issueFieldValues[fieldKey];
};
const $ddbc380ab4ee430c$var$getFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKey: fieldKey })=>(issueKeys || []).map((issueKey)=>$ddbc380ab4ee430c$var$getFieldValueSelector(state, {
            fieldKey: fieldKey,
            issueKey: issueKey
        }));
const $ddbc380ab4ee430c$var$getMultiFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKeys: fieldKeys })=>(issueKeys || []).reduce((accumulator, issueKey)=>{
        if (!state[issueKey]) return accumulator;
        const fieldValue = fieldKeys.reduce((acc, fieldKey)=>{
            acc[fieldKey] = $ddbc380ab4ee430c$var$getFieldValueSelector(state, {
                fieldKey: fieldKey,
                issueKey: issueKey
            });
            return acc;
        }, {});
        accumulator[issueKey] = fieldValue;
        return accumulator;
    }, {});
const $ddbc380ab4ee430c$var$getAllFields = (state, issueKey)=>state[issueKey];
const $ddbc380ab4ee430c$export$b79fae7fbe3ac392 = (0, $3sQ5x.createHook)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getFieldValueSelector
});
const $ddbc380ab4ee430c$export$25b73e671fe7a8fa = (0, $3sQ5x.createHook)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getAllFields
});
const $ddbc380ab4ee430c$export$ac289b84121829df = (0, $3sQ5x.createHook)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getFieldValuesForIssuesSelector
});
const $ddbc380ab4ee430c$export$915cdeec521b54f7 = (0, $3sQ5x.createHook)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getMultiFieldValuesForIssuesSelector
});
const $ddbc380ab4ee430c$export$4e5f1f4ed08d155e = (0, $51nlc.createSubscriber)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getFieldValueSelector
});
const $ddbc380ab4ee430c$var$useFieldValueStoreActions = (0, $3sQ5x.createHook)($ddbc380ab4ee430c$var$store, {
    selector: null
});
const $ddbc380ab4ee430c$export$612d9bcb0c9d8976 = ()=>{
    const [, fieldValueStoreActions] = $ddbc380ab4ee430c$var$useFieldValueStoreActions();
    const fieldsValuesActions = (0, $5uXOq.useMemo)(()=>{
        const setIssueAction = (issueKey, fields)=>fieldValueStoreActions.setIssue(issueKey, fields);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const setFieldValueAction = (issueKey, fieldKey, value)=>fieldValueStoreActions.setFieldValue(issueKey, fieldKey, value);
        const getFieldValueAction = (issueKey, fieldKey)=>fieldValueStoreActions.getFieldValue(issueKey, fieldKey);
        const mergeIssueAction = (issueKey, fields)=>fieldValueStoreActions.mergeIssue(issueKey, fields);
        const setIssuesAction = (issues)=>fieldValueStoreActions.setIssues(issues);
        const mergeIssuesAction = (issues)=>fieldValueStoreActions.mergeIssues(issues);
        return {
            setIssue: setIssueAction,
            setFieldValue: setFieldValueAction,
            getFieldValue: getFieldValueAction,
            mergeIssue: mergeIssueAction,
            setIssues: setIssuesAction,
            mergeIssues: mergeIssuesAction
        };
    }, [
        fieldValueStoreActions
    ]);
    return [
        null,
        fieldsValuesActions
    ];
};

});

parcelRegister("9zRWV", function(module, exports) {

$parcel$export(module.exports, "extractedFixedFields", () => $fe0974115005346b$export$302ef72acec731a7);

var $5fc53 = parcelRequire("5fc53");

const $fe0974115005346b$export$302ef72acec731a7 = [
    (0, $e9be48d6d2c01760$export$5fbd3b15555b9ef2),
    (0, $e9be48d6d2c01760$export$4420b7468f889692),
    (0, $e9be48d6d2c01760$export$e18419056f3d184a),
    (0, $5fc53.PRIORITY_TYPE),
    (0, $5fc53.PARENT_TYPE),
    (0, $5fc53.HIERARCHY_LEVEL_ABOVE)
];

});
const $e9be48d6d2c01760$export$e18419056f3d184a = 'assignee';
const $e9be48d6d2c01760$export$45cafdfd629c3ca1 = 'reporter';
const $e9be48d6d2c01760$export$d5bc879e3b748593 = 'description';
const $e9be48d6d2c01760$export$a68dbc90211df1a8 = 'fixVersions';
const $e9be48d6d2c01760$export$93605f2a09aa8d26 = 'labels';
const $e9be48d6d2c01760$export$4420b7468f889692 = 'status';
const $e9be48d6d2c01760$export$e7cf1830fe735d1f = 'summary';
const $e9be48d6d2c01760$export$5fbd3b15555b9ef2 = 'timeoriginalestimate';
const $e9be48d6d2c01760$export$a5fc282ab2bf9b89 = 'issuelinks';
const $e9be48d6d2c01760$export$b52547457d714bc0 = 'epic-issues';
const $e9be48d6d2c01760$export$3cca6e37a5823d5a = 'children-issues';
const $e9be48d6d2c01760$export$98a935eb30de54ab = 'components';
const $e9be48d6d2c01760$export$f7a17147527dd688 = 'flag';


parcelRegister("kzhoX", function(module, exports) {

$parcel$export(module.exports, "mergeFieldsFromCardCreateData", () => $15fdca5a32d65b6b$export$d2f0044e31dbf46e);
$parcel$export(module.exports, "mergeFieldsFromFetchIssuesData", () => $15fdca5a32d65b6b$export$934909337e38984d);
$parcel$export(module.exports, "mergeFieldsFromPrefetchedData", () => $15fdca5a32d65b6b$export$ccb35cdb8dc761f5);
$parcel$export(module.exports, "mergeFieldsFromPrefetchedJiraPlanData", () => $15fdca5a32d65b6b$export$6503472ec8a310fa);

var $kPH5D = parcelRequire("kPH5D");

var $4Xk2W = parcelRequire("4Xk2W");

var $dPSWJ = parcelRequire("dPSWJ");

var $iHPnC = parcelRequire("iHPnC");

var $fhSLy = parcelRequire("fhSLy");

var $7Fute = parcelRequire("7Fute");

var $44VbI = parcelRequire("44VbI");

var $g4tDr = parcelRequire("g4tDr");

var $5fc53 = parcelRequire("5fc53");


var $dpWCZ = parcelRequire("dpWCZ");

var $f01qr = parcelRequire("f01qr");
const $15fdca5a32d65b6b$var$toFieldAccessibleValues = (fields = [])=>(0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))((0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))((0, (/*@__PURE__*/$parcel$interopDefault($kPH5D)))(fields, ({ isFieldAccessible: isFieldAccessible })=>isFieldAccessible), ({ fieldKey: fieldKey })=>fieldKey), ({ fieldValue: fieldValue })=>fieldValue);
const $15fdca5a32d65b6b$export$599b8b9cc9396260 = ({ issue: { assignee: assignee, status: status, summary: summary }, priority: priority, parentId: parentId, ...restOfTheCard }, { storyPointFieldId: storyPointFieldId }, issueParents)=>{
    const estimate = 'estimate' in restOfTheCard ? restOfTheCard.estimate : null;
    // NOTE: Pre-populated fields should follow the same logic as how they are handled in syncing (src/packages/software/backlog/src/view/all-fields-sync/field-sync)
    const StoryPointKey = storyPointFieldId || '';
    const parentValue = parentId && issueParents?.length ? issueParents.find(({ id: id })=>Number(id) === Number(parentId)) : null;
    const issueParentType = issueParents?.length ? issueParents[0].issueType : null;
    const fields = [
        {
            isFieldAccessible: Boolean(estimate),
            fieldKey: (0, $e9be48d6d2c01760$export$5fbd3b15555b9ef2),
            fieldValue: estimate?.originalEstimate?.value ?? null
        },
        {
            isFieldAccessible: Boolean(StoryPointKey && estimate),
            fieldKey: StoryPointKey,
            fieldValue: estimate?.storyPoints ?? null
        },
        {
            isFieldAccessible: Boolean(status && status.id),
            fieldKey: (0, $e9be48d6d2c01760$export$4420b7468f889692),
            fieldValue: (0, $44VbI.getStatusShape)(status.id, status.name, status.category)
        },
        {
            isFieldAccessible: Boolean(assignee && assignee.accountId),
            fieldKey: (0, $e9be48d6d2c01760$export$e18419056f3d184a),
            fieldValue: (0, $fhSLy.getUserShape)(assignee?.accountId || '', assignee?.displayName || '', assignee?.avatarUrl)
        },
        {
            isFieldAccessible: Boolean(priority && priority.name),
            fieldKey: (0, $5fc53.PRIORITY_TYPE),
            fieldValue: priority
        },
        {
            isFieldAccessible: Boolean(parentValue && parentId),
            fieldKey: (0, $5fc53.PARENT_TYPE),
            fieldValue: parentValue ? (0, $7Fute.getParentShape)(parentValue.id, parentValue.key, parentValue.summary, {
                id: parentValue.issueType?.id,
                name: parentValue.issueType?.name,
                iconUrl: parentValue.issueType?.iconUrl ?? ''
            }) : null
        },
        {
            isFieldAccessible: Boolean(issueParentType),
            fieldKey: (0, $5fc53.HIERARCHY_LEVEL_ABOVE),
            fieldValue: issueParentType ? (0, $7Fute.getHierarchyShape)({
                id: issueParentType.id,
                name: issueParentType.name,
                iconUrl: issueParentType.iconUrl
            }) : null
        },
        {
            isFieldAccessible: Boolean(summary),
            fieldKey: (0, $e9be48d6d2c01760$export$e7cf1830fe735d1f),
            fieldValue: summary ?? null
        }
    ];
    return $15fdca5a32d65b6b$var$toFieldAccessibleValues(fields);
};
const $15fdca5a32d65b6b$export$de671f46cd9f407c = (issue, epicIssueType)=>{
    const { summary: summary, status: status, assigneeAccountId: assigneeAccountId, assigneeName: assigneeName, avatarUrl: avatarUrl, priorityName: priorityName, priorityUrl: priorityUrl, estimateStatistic: estimateStatistic } = issue;
    const epicField = (0, $dpWCZ.hasEpicField)(issue) && (0, $g4tDr.isBaseHierarchyLevel)(issue.typeHierarchyLevel) ? issue.epicField : null;
    const fields = [
        {
            isFieldAccessible: Boolean(estimateStatistic?.statFieldId),
            fieldKey: estimateStatistic?.statFieldId ?? '',
            fieldValue: estimateStatistic?.statFieldValue?.value ?? null
        },
        {
            isFieldAccessible: Boolean(status?.id),
            fieldKey: (0, $e9be48d6d2c01760$export$4420b7468f889692),
            fieldValue: (0, $44VbI.getStatusShape)(status.id, status.name, status.statusCategory.key)
        },
        {
            isFieldAccessible: Boolean(assigneeAccountId && assigneeName && avatarUrl),
            fieldKey: (0, $e9be48d6d2c01760$export$e18419056f3d184a),
            fieldValue: (0, $fhSLy.getUserShape)(assigneeAccountId || '', assigneeName || '', avatarUrl)
        },
        {
            isFieldAccessible: Boolean(priorityName && priorityUrl),
            fieldKey: (0, $5fc53.PRIORITY_TYPE),
            fieldValue: {
                name: priorityName,
                iconUrl: priorityUrl
            }
        },
        {
            isFieldAccessible: Boolean((0, $g4tDr.isBaseHierarchyLevel)(issue.typeHierarchyLevel)),
            fieldKey: (0, $5fc53.PARENT_TYPE),
            fieldValue: epicField ? (0, $7Fute.getParentShape)((0, $f01qr.getIdFromAri)(String(epicField.issueId)), epicField.epicKey, epicField.summary || epicField.text, {
                id: epicField.issueTypeId,
                name: epicField.label,
                iconUrl: epicField.issueTypeIconUrl
            }, (0, $iHPnC.asColor)(epicField.color || epicField.epicColor)) : null
        },
        {
            isFieldAccessible: Boolean((0, $g4tDr.isBaseHierarchyLevel)(issue.typeHierarchyLevel)),
            fieldKey: (0, $5fc53.HIERARCHY_LEVEL_ABOVE),
            fieldValue: epicField || epicIssueType ? (0, $7Fute.getHierarchyShape)({
                id: epicField?.issueTypeId ?? epicIssueType?.id,
                name: epicField?.label ?? epicIssueType?.name,
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                iconUrl: epicField?.issueTypeIconUrl ?? epicIssueType.iconUrl
            }) : null
        },
        {
            isFieldAccessible: Boolean(summary),
            fieldKey: (0, $e9be48d6d2c01760$export$e7cf1830fe735d1f),
            fieldValue: summary ?? null
        }
    ];
    return $15fdca5a32d65b6b$var$toFieldAccessibleValues(fields);
};
const $15fdca5a32d65b6b$export$d2f0044e31dbf46e = (cardCreateData, { mergeIssues: mergeIssues }, fieldConfigs, issueParents)=>{
    if (!cardCreateData?.planModeCardCreate) return;
    const { newCards: newCards } = cardCreateData.planModeCardCreate;
    if (newCards && newCards.length) {
        const issuesWithFields = newCards.map((card)=>{
            const fieldValues = $15fdca5a32d65b6b$export$599b8b9cc9396260(card, fieldConfigs, issueParents);
            return {
                [card.issue.key]: fieldValues
            };
        });
        mergeIssues(issuesWithFields);
    }
};
const $15fdca5a32d65b6b$export$934909337e38984d = (issues, { mergeIssues: mergeIssues }, epicIssueType)=>{
    if (issues && issues.length) {
        const issuesWithFields = issues.map((issue)=>{
            const fieldValues = $15fdca5a32d65b6b$export$de671f46cd9f407c(issue, epicIssueType);
            return {
                [issue.key]: fieldValues
            };
        });
        mergeIssues(issuesWithFields);
    }
};
const $15fdca5a32d65b6b$export$ccb35cdb8dc761f5 = (prefetchedData, { mergeIssues: mergeIssues }, fieldConfigs)=>{
    if (!prefetchedData?.boardScope) return;
    const { backlog: { cards: backlogCards }, board: { cards: boardCards, issueParents: issueParents }, sprints: sprints } = prefetchedData.boardScope;
    const cards = sprints.reduce((allCards, { cards: sprintCards })=>[
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...allCards,
            ...sprintCards
        ], [
        ...backlogCards,
        ...boardCards
    ]);
    if (cards.length) {
        const issuesWithFields = cards.map((card)=>{
            const fieldValues = $15fdca5a32d65b6b$export$599b8b9cc9396260(card, fieldConfigs, issueParents);
            return {
                [card.issue.key]: fieldValues
            };
        });
        mergeIssues(issuesWithFields);
    }
};
const $15fdca5a32d65b6b$export$6503472ec8a310fa = (prefetchedJiraPlanRestData, fieldValueServiceActions, epicIssueType)=>{
    if (!prefetchedJiraPlanRestData) return;
    const { issues: issues } = prefetchedJiraPlanRestData;
    $15fdca5a32d65b6b$export$934909337e38984d(issues, fieldValueServiceActions, epicIssueType);
};

});
parcelRegister("kPH5D", function(module, exports) {

var $2GdQn = parcelRequire("2GdQn");

var $8BRGu = parcelRequire("8BRGu");

var $bxDef = parcelRequire("bxDef");

var $8LQ84 = parcelRequire("8LQ84");
/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */ function $f2a9fed894a6616c$var$filter(collection, predicate) {
    var func = $8LQ84(collection) ? $2GdQn : $8BRGu;
    return func(collection, $bxDef(predicate, 3));
}
module.exports = $f2a9fed894a6616c$var$filter;

});
parcelRegister("8BRGu", function(module, exports) {

var $e7pfQ = parcelRequire("e7pfQ");
/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $644b6c0ae483a6c5$var$baseFilter(collection, predicate) {
    var result = [];
    $e7pfQ(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) result.push(value);
    });
    return result;
}
module.exports = $644b6c0ae483a6c5$var$baseFilter;

});


parcelRegister("iHPnC", function(module, exports) {

$parcel$export(module.exports, "asColor", () => $e626bf77f0e696c5$export$b74af6529f09947);
$parcel$export(module.exports, "asServerColor", () => $e626bf77f0e696c5$export$442690a499ee9598);
$parcel$export(module.exports, "asClassicEpicColor", () => $e626bf77f0e696c5$export$eb754032c0b9698c);
$parcel$export(module.exports, "transformColorToTheme", () => $e626bf77f0e696c5$export$37c9bd72afe7f286);
$parcel$export(module.exports, "getValueFromColor", () => $e626bf77f0e696c5$export$a00423580059ae28);
$parcel$export(module.exports, "getColorFromValue", () => $e626bf77f0e696c5$export$6d14528e40cbe34b);
$parcel$export(module.exports, "toFrontendColor", () => $e626bf77f0e696c5$export$574e4dbf3c01f0ad);
$parcel$export(module.exports, "toBackendColor", () => $e626bf77f0e696c5$export$47af25386a01de1);
$parcel$export(module.exports, "classicToFrontendColor", () => $e626bf77f0e696c5$export$8f81207f7ac5fb9a);
$parcel$export(module.exports, "classicToBackendColor", () => $e626bf77f0e696c5$export$28fb68bb1de025d5);
$parcel$export(module.exports, "getDefaultColorPalette", () => $e626bf77f0e696c5$export$f6e067d5c418081a);
$parcel$export(module.exports, "getLozengeThemeByColor", () => $e626bf77f0e696c5$export$949dc67535a8ff2);
$parcel$export(module.exports, "getRandomColor", () => $e626bf77f0e696c5$export$e4369cabd7e84cd9);

var $ggSx2 = parcelRequire("ggSx2");

var $7SCny = parcelRequire("7SCny");

var $heWHN = parcelRequire("heWHN");

var $ehxiD = parcelRequire("ehxiD");
const $e626bf77f0e696c5$export$b74af6529f09947 = (color)=>{
    if (color == null) return (0, $7SCny.Colors).PURPLE;
    if (color in (0, $7SCny.Colors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $heWHN.MAP_FROM_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_SERVER_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_AGILE_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color];
    return (0, $7SCny.Colors).PURPLE;
};
const $e626bf77f0e696c5$export$442690a499ee9598 = (color)=>{
    if (color == null) return (0, $7SCny.ServerColors).SERVER_PURPLE;
    if (color in (0, $7SCny.ServerColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_AGILE_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)[(0, $heWHN.MAP_FROM_AGILE_COLOR)[color]];
    if (color in (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)) return (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    return (0, $7SCny.ServerColors).SERVER_PURPLE;
};
const $e626bf77f0e696c5$export$eb754032c0b9698c = (color)=>{
    if (color === null) return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $7SCny.Colors).PURPLE];
    if (color in (0, $7SCny.ClassicEpicColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $heWHN.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $heWHN.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_AGILE_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $heWHN.MAP_FROM_AGILE_COLOR)[color]];
    // i.e: ghx-label-7
    return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $7SCny.Colors).PURPLE];
};
const $e626bf77f0e696c5$export$1a0a4af71e00cea4 = (color)=>{
    if (color === null) return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $7SCny.Colors).PURPLE];
    if (color in (0, $7SCny.AgileColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $heWHN.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)) return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    // i.e: color_7
    return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $7SCny.Colors).PURPLE];
};
const $e626bf77f0e696c5$export$37c9bd72afe7f286 = (transformation, colorSchemaExtension)=>{
    const newColorSchema = {
        ...(0, $heWHN.BASE_COLOR_SCHEMA),
        ...colorSchemaExtension
    };
    const extendedColors = (colorSchemaExtension ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys(colorSchemaExtension) : []).concat(Object.keys((0, $7SCny.Colors)));
    return extendedColors.reduce((obj, color)=>Object.assign(obj, {
            [color]: transformation(newColorSchema[color])
        }), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {});
};
const $e626bf77f0e696c5$export$a00423580059ae28 = (color)=>(0, $heWHN.MAP_COLORS_TO_VALUE)[color] || (0, $heWHN.MAP_COLORS_TO_VALUE)[0, $7SCny.PURPLE];
const $e626bf77f0e696c5$export$6d14528e40cbe34b = (value)=>// NOTE: lodash invert coerce the output to Dictionary<string> instead of using a polymorphic type
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Color'.
    (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))((0, $heWHN.MAP_COLORS_TO_VALUE))[value] || (0, $7SCny.PURPLE);
const $e626bf77f0e696c5$export$574e4dbf3c01f0ad = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $heWHN.MAP_FROM_SERVER_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_COLOR)[colorStr] : (0, $7SCny.PURPLE);
const $e626bf77f0e696c5$export$47af25386a01de1 = (color)=>(0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)[color];
const $e626bf77f0e696c5$export$8f81207f7ac5fb9a = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[colorStr] : (0, $7SCny.PURPLE);
const $e626bf77f0e696c5$export$28fb68bb1de025d5 = (color)=>(0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
/**
 * Return default color palette
 */ const $e626bf77f0e696c5$var$paletteColorValues = $e626bf77f0e696c5$export$37c9bd72afe7f286((colorSchema)=>colorSchema.primary);
const $e626bf77f0e696c5$export$f6e067d5c418081a = (formatMessage)=>[
        {
            label: formatMessage((0, $ehxiD.default).purpleLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).PURPLE]
        },
        {
            label: formatMessage((0, $ehxiD.default).blueLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).BLUE]
        },
        {
            label: formatMessage((0, $ehxiD.default).greenLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).GREEN]
        },
        {
            label: formatMessage((0, $ehxiD.default).tealLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).TEAL]
        },
        {
            label: formatMessage((0, $ehxiD.default).yellowLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).YELLOW]
        },
        {
            label: formatMessage((0, $ehxiD.default).orangeLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).ORANGE]
        },
        {
            label: formatMessage((0, $ehxiD.default).greyLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).GREY]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkPurpleLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).DARK_PURPLE]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkBlueLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).DARK_BLUE]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkGreenLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).DARK_GREEN]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkTealLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).DARK_TEAL]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkYellowLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).DARK_YELLOW]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkOrangeLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).DARK_ORANGE]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkGreyLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).DARK_GREY]
        }
    ];
const $e626bf77f0e696c5$export$9b822862d986dfdf = $e626bf77f0e696c5$export$37c9bd72afe7f286((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $e626bf77f0e696c5$export$949dc67535a8ff2 = (color = (0, $heWHN.DEFAULT_EPIC_COLOR))=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $e626bf77f0e696c5$export$9b822862d986dfdf[color] ?? $e626bf77f0e696c5$export$9b822862d986dfdf[0, $heWHN.DEFAULT_EPIC_COLOR];
const $e626bf77f0e696c5$export$e4369cabd7e84cd9 = ()=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const colorKeys = Object.keys((0, $7SCny.Colors));
    return colorKeys[Math.floor(Math.random() * colorKeys.length)];
};

});
parcelRegister("ggSx2", function(module, exports) {

var $cxSdl = parcelRequire("cxSdl");

var $fxKlj = parcelRequire("fxKlj");

var $etyzk = parcelRequire("etyzk");
/** Used for built-in method references. */ var $bd8870e21c3833a0$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $bd8870e21c3833a0$var$nativeObjectToString = $bd8870e21c3833a0$var$objectProto.toString;
/**
 * Creates an object composed of the inverted keys and values of `object`.
 * If `object` contains duplicate values, subsequent values overwrite
 * property assignments of previous values.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Object
 * @param {Object} object The object to invert.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invert(object);
 * // => { '1': 'c', '2': 'b' }
 */ var $bd8870e21c3833a0$var$invert = $fxKlj(function(result, value, key) {
    if (value != null && typeof value.toString != 'function') value = $bd8870e21c3833a0$var$nativeObjectToString.call(value);
    result[value] = key;
}, $cxSdl($etyzk));
module.exports = $bd8870e21c3833a0$var$invert;

});
parcelRegister("fxKlj", function(module, exports) {

var $d1nCg = parcelRequire("d1nCg");
/**
 * Creates a function like `_.invertBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} toIteratee The function to resolve iteratees.
 * @returns {Function} Returns the new inverter function.
 */ function $b50de2cb57eb155c$var$createInverter(setter, toIteratee) {
    return function(object, iteratee) {
        return $d1nCg(object, setter, toIteratee(iteratee), {});
    };
}
module.exports = $b50de2cb57eb155c$var$createInverter;

});
parcelRegister("d1nCg", function(module, exports) {

var $hDnyx = parcelRequire("hDnyx");
/**
 * The base implementation of `_.invert` and `_.invertBy` which inverts
 * `object` with values transformed by `iteratee` and set by `setter`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform values.
 * @param {Object} accumulator The initial inverted object.
 * @returns {Function} Returns `accumulator`.
 */ function $97adb007e27dc709$var$baseInverter(object, setter, iteratee, accumulator) {
    $hDnyx(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
    });
    return accumulator;
}
module.exports = $97adb007e27dc709$var$baseInverter;

});



parcelRegister("7SCny", function(module, exports) {

$parcel$export(module.exports, "PURPLE", () => $8e4230f608d6b965$export$7ffdeca4b2f927a2);
$parcel$export(module.exports, "DARK_PURPLE", () => $8e4230f608d6b965$export$c815fe495e8174a0);
$parcel$export(module.exports, "BLUE", () => $8e4230f608d6b965$export$738c3b9a44c87ecc);
$parcel$export(module.exports, "DARK_BLUE", () => $8e4230f608d6b965$export$1225f83626261b80);
$parcel$export(module.exports, "GREEN", () => $8e4230f608d6b965$export$48d4b2cd5bc0e88b);
$parcel$export(module.exports, "DARK_GREEN", () => $8e4230f608d6b965$export$c6f4cf2e5768eb78);
$parcel$export(module.exports, "TEAL", () => $8e4230f608d6b965$export$d0446fe88325854e);
$parcel$export(module.exports, "DARK_TEAL", () => $8e4230f608d6b965$export$bb848c92687e69dc);
$parcel$export(module.exports, "YELLOW", () => $8e4230f608d6b965$export$aab610c505c06a8f);
$parcel$export(module.exports, "DARK_YELLOW", () => $8e4230f608d6b965$export$466af87757d343a2);
$parcel$export(module.exports, "ORANGE", () => $8e4230f608d6b965$export$3de5e29ed1757f9b);
$parcel$export(module.exports, "DARK_ORANGE", () => $8e4230f608d6b965$export$da02e4820b6ab753);
$parcel$export(module.exports, "GREY", () => $8e4230f608d6b965$export$7d278ca694634874);
$parcel$export(module.exports, "DARK_GREY", () => $8e4230f608d6b965$export$26453300bfc61cb8);
$parcel$export(module.exports, "COLORS", () => $8e4230f608d6b965$export$56d196d2844d1ca1);
$parcel$export(module.exports, "SERVER_PURPLE", () => $8e4230f608d6b965$export$792af22a0198af8d);
$parcel$export(module.exports, "SERVER_DARK_PURPLE", () => $8e4230f608d6b965$export$588af712afdcb006);
$parcel$export(module.exports, "SERVER_BLUE", () => $8e4230f608d6b965$export$84c4918645391802);
$parcel$export(module.exports, "SERVER_DARK_BLUE", () => $8e4230f608d6b965$export$b8f1f5838352a33a);
$parcel$export(module.exports, "SERVER_GREEN", () => $8e4230f608d6b965$export$9384b7e350ee6542);
$parcel$export(module.exports, "SERVER_DARK_GREEN", () => $8e4230f608d6b965$export$87d3fb8d8656d38b);
$parcel$export(module.exports, "SERVER_TEAL", () => $8e4230f608d6b965$export$b0b4ce3e99e66aae);
$parcel$export(module.exports, "SERVER_DARK_TEAL", () => $8e4230f608d6b965$export$a89b77a449bd223e);
$parcel$export(module.exports, "SERVER_YELLOW", () => $8e4230f608d6b965$export$9a33b5e3cde94885);
$parcel$export(module.exports, "SERVER_DARK_YELLOW", () => $8e4230f608d6b965$export$33253d7862bceb8a);
$parcel$export(module.exports, "SERVER_ORANGE", () => $8e4230f608d6b965$export$6609c2b23fc42f39);
$parcel$export(module.exports, "SERVER_DARK_ORANGE", () => $8e4230f608d6b965$export$cd994662b5911917);
$parcel$export(module.exports, "SERVER_GREY", () => $8e4230f608d6b965$export$1793d43e13e078c5);
$parcel$export(module.exports, "SERVER_DARK_GREY", () => $8e4230f608d6b965$export$487a6e9145526564);
$parcel$export(module.exports, "GHX_LABEL_1", () => $8e4230f608d6b965$export$e4bdf2d4c4bbb15e);
$parcel$export(module.exports, "GHX_LABEL_2", () => $8e4230f608d6b965$export$8f5c1c5512278dc6);
$parcel$export(module.exports, "GHX_LABEL_3", () => $8e4230f608d6b965$export$94ac87c81ed074a7);
$parcel$export(module.exports, "GHX_LABEL_4", () => $8e4230f608d6b965$export$6bc9ab1f489f76f7);
$parcel$export(module.exports, "GHX_LABEL_5", () => $8e4230f608d6b965$export$610a2c132b6fcf96);
$parcel$export(module.exports, "GHX_LABEL_6", () => $8e4230f608d6b965$export$8e4997dba71f1c40);
$parcel$export(module.exports, "GHX_LABEL_7", () => $8e4230f608d6b965$export$18a545b4e69b27b4);
$parcel$export(module.exports, "GHX_LABEL_8", () => $8e4230f608d6b965$export$27fff1a0d295292a);
$parcel$export(module.exports, "GHX_LABEL_9", () => $8e4230f608d6b965$export$e57aa662a56724e1);
$parcel$export(module.exports, "GHX_LABEL_10", () => $8e4230f608d6b965$export$4b0d63e2c3be2072);
$parcel$export(module.exports, "GHX_LABEL_11", () => $8e4230f608d6b965$export$457ecb9560f2bf83);
$parcel$export(module.exports, "GHX_LABEL_12", () => $8e4230f608d6b965$export$a866db37165a696c);
$parcel$export(module.exports, "GHX_LABEL_13", () => $8e4230f608d6b965$export$9b18447c1168a1b6);
$parcel$export(module.exports, "GHX_LABEL_14", () => $8e4230f608d6b965$export$93b9ad4020e271b7);
$parcel$export(module.exports, "AGILE_COLOR_1", () => $8e4230f608d6b965$export$5cd2af17b34de3e3);
$parcel$export(module.exports, "AGILE_COLOR_2", () => $8e4230f608d6b965$export$987671fa69482a7b);
$parcel$export(module.exports, "AGILE_COLOR_3", () => $8e4230f608d6b965$export$70ba8a5b1f4c7446);
$parcel$export(module.exports, "AGILE_COLOR_4", () => $8e4230f608d6b965$export$fcd1c42d8d3ebd36);
$parcel$export(module.exports, "AGILE_COLOR_5", () => $8e4230f608d6b965$export$f80a5bd2fa0ba256);
$parcel$export(module.exports, "AGILE_COLOR_6", () => $8e4230f608d6b965$export$37ad5ce8d2aeaf78);
$parcel$export(module.exports, "AGILE_COLOR_7", () => $8e4230f608d6b965$export$9dc62d5d151cb355);
$parcel$export(module.exports, "AGILE_COLOR_8", () => $8e4230f608d6b965$export$1ed15b30f5663f92);
$parcel$export(module.exports, "AGILE_COLOR_9", () => $8e4230f608d6b965$export$5d23a84d55ac1644);
$parcel$export(module.exports, "AGILE_COLOR_10", () => $8e4230f608d6b965$export$bf08c9a6ed42e349);
$parcel$export(module.exports, "AGILE_COLOR_11", () => $8e4230f608d6b965$export$66c5d8f0b5ff279c);
$parcel$export(module.exports, "AGILE_COLOR_12", () => $8e4230f608d6b965$export$da30755a37c3a597);
$parcel$export(module.exports, "AGILE_COLOR_13", () => $8e4230f608d6b965$export$721cf84faff6bf19);
$parcel$export(module.exports, "AGILE_COLOR_14", () => $8e4230f608d6b965$export$4b8f8666bd7b61dd);
$parcel$export(module.exports, "Colors", () => $8e4230f608d6b965$export$c537fa0d021d010b);
$parcel$export(module.exports, "ServerColors", () => $8e4230f608d6b965$export$d33d39828a18210a);
$parcel$export(module.exports, "ClassicEpicColors", () => $8e4230f608d6b965$export$f476e6e43e0101e7);
$parcel$export(module.exports, "AgileColors", () => $8e4230f608d6b965$export$4b7407b8700035bd);
/**
 * @fileoverview This file was moved from `@atlassian/jira-issue-epic-color-types`
 * so that these types do not require atlaskit dependencies.
 *
 * Color constants
 */ const $8e4230f608d6b965$export$7ffdeca4b2f927a2 = 'PURPLE';
const $8e4230f608d6b965$export$c815fe495e8174a0 = 'DARK_PURPLE';
const $8e4230f608d6b965$export$738c3b9a44c87ecc = 'BLUE';
const $8e4230f608d6b965$export$1225f83626261b80 = 'DARK_BLUE';
const $8e4230f608d6b965$export$48d4b2cd5bc0e88b = 'GREEN';
const $8e4230f608d6b965$export$c6f4cf2e5768eb78 = 'DARK_GREEN';
const $8e4230f608d6b965$export$d0446fe88325854e = 'TEAL';
const $8e4230f608d6b965$export$bb848c92687e69dc = 'DARK_TEAL';
const $8e4230f608d6b965$export$aab610c505c06a8f = 'YELLOW';
const $8e4230f608d6b965$export$466af87757d343a2 = 'DARK_YELLOW';
const $8e4230f608d6b965$export$3de5e29ed1757f9b = 'ORANGE';
const $8e4230f608d6b965$export$da02e4820b6ab753 = 'DARK_ORANGE';
const $8e4230f608d6b965$export$7d278ca694634874 = 'GREY';
const $8e4230f608d6b965$export$26453300bfc61cb8 = 'DARK_GREY';
const $8e4230f608d6b965$export$56d196d2844d1ca1 = [
    $8e4230f608d6b965$export$7ffdeca4b2f927a2,
    $8e4230f608d6b965$export$c815fe495e8174a0,
    $8e4230f608d6b965$export$738c3b9a44c87ecc,
    $8e4230f608d6b965$export$1225f83626261b80,
    $8e4230f608d6b965$export$48d4b2cd5bc0e88b,
    $8e4230f608d6b965$export$c6f4cf2e5768eb78,
    $8e4230f608d6b965$export$d0446fe88325854e,
    $8e4230f608d6b965$export$bb848c92687e69dc,
    $8e4230f608d6b965$export$aab610c505c06a8f,
    $8e4230f608d6b965$export$466af87757d343a2,
    $8e4230f608d6b965$export$3de5e29ed1757f9b,
    $8e4230f608d6b965$export$da02e4820b6ab753,
    $8e4230f608d6b965$export$7d278ca694634874,
    $8e4230f608d6b965$export$26453300bfc61cb8
];
const $8e4230f608d6b965$export$792af22a0198af8d = 'purple';
const $8e4230f608d6b965$export$588af712afdcb006 = 'dark_purple';
const $8e4230f608d6b965$export$84c4918645391802 = 'blue';
const $8e4230f608d6b965$export$b8f1f5838352a33a = 'dark_blue';
const $8e4230f608d6b965$export$9384b7e350ee6542 = 'green';
const $8e4230f608d6b965$export$87d3fb8d8656d38b = 'dark_green';
const $8e4230f608d6b965$export$b0b4ce3e99e66aae = 'teal';
const $8e4230f608d6b965$export$a89b77a449bd223e = 'dark_teal';
const $8e4230f608d6b965$export$9a33b5e3cde94885 = 'yellow';
const $8e4230f608d6b965$export$33253d7862bceb8a = 'dark_yellow';
const $8e4230f608d6b965$export$6609c2b23fc42f39 = 'orange';
const $8e4230f608d6b965$export$cd994662b5911917 = 'dark_orange';
const $8e4230f608d6b965$export$1793d43e13e078c5 = 'grey';
const $8e4230f608d6b965$export$487a6e9145526564 = 'dark_grey';
const $8e4230f608d6b965$export$e4bdf2d4c4bbb15e = 'ghx-label-1';
const $8e4230f608d6b965$export$8f5c1c5512278dc6 = 'ghx-label-2';
const $8e4230f608d6b965$export$94ac87c81ed074a7 = 'ghx-label-3';
const $8e4230f608d6b965$export$6bc9ab1f489f76f7 = 'ghx-label-4';
const $8e4230f608d6b965$export$610a2c132b6fcf96 = 'ghx-label-5';
const $8e4230f608d6b965$export$8e4997dba71f1c40 = 'ghx-label-6';
const $8e4230f608d6b965$export$18a545b4e69b27b4 = 'ghx-label-7';
const $8e4230f608d6b965$export$27fff1a0d295292a = 'ghx-label-8';
const $8e4230f608d6b965$export$e57aa662a56724e1 = 'ghx-label-9';
const $8e4230f608d6b965$export$4b0d63e2c3be2072 = 'ghx-label-10';
const $8e4230f608d6b965$export$457ecb9560f2bf83 = 'ghx-label-11';
const $8e4230f608d6b965$export$a866db37165a696c = 'ghx-label-12';
const $8e4230f608d6b965$export$9b18447c1168a1b6 = 'ghx-label-13';
const $8e4230f608d6b965$export$93b9ad4020e271b7 = 'ghx-label-14';
const $8e4230f608d6b965$export$5cd2af17b34de3e3 = 'color_1';
const $8e4230f608d6b965$export$987671fa69482a7b = 'color_2';
const $8e4230f608d6b965$export$70ba8a5b1f4c7446 = 'color_3';
const $8e4230f608d6b965$export$fcd1c42d8d3ebd36 = 'color_4';
const $8e4230f608d6b965$export$f80a5bd2fa0ba256 = 'color_5';
const $8e4230f608d6b965$export$37ad5ce8d2aeaf78 = 'color_6';
const $8e4230f608d6b965$export$9dc62d5d151cb355 = 'color_7';
const $8e4230f608d6b965$export$1ed15b30f5663f92 = 'color_8';
const $8e4230f608d6b965$export$5d23a84d55ac1644 = 'color_9';
const $8e4230f608d6b965$export$bf08c9a6ed42e349 = 'color_10';
const $8e4230f608d6b965$export$66c5d8f0b5ff279c = 'color_11';
const $8e4230f608d6b965$export$da30755a37c3a597 = 'color_12';
const $8e4230f608d6b965$export$721cf84faff6bf19 = 'color_13';
const $8e4230f608d6b965$export$4b8f8666bd7b61dd = 'color_14';
const $8e4230f608d6b965$export$c537fa0d021d010b = {
    PURPLE: $8e4230f608d6b965$export$7ffdeca4b2f927a2,
    DARK_PURPLE: $8e4230f608d6b965$export$c815fe495e8174a0,
    BLUE: $8e4230f608d6b965$export$738c3b9a44c87ecc,
    DARK_BLUE: $8e4230f608d6b965$export$1225f83626261b80,
    GREEN: $8e4230f608d6b965$export$48d4b2cd5bc0e88b,
    DARK_GREEN: $8e4230f608d6b965$export$c6f4cf2e5768eb78,
    TEAL: $8e4230f608d6b965$export$d0446fe88325854e,
    DARK_TEAL: $8e4230f608d6b965$export$bb848c92687e69dc,
    YELLOW: $8e4230f608d6b965$export$aab610c505c06a8f,
    DARK_YELLOW: $8e4230f608d6b965$export$466af87757d343a2,
    ORANGE: $8e4230f608d6b965$export$3de5e29ed1757f9b,
    DARK_ORANGE: $8e4230f608d6b965$export$da02e4820b6ab753,
    GREY: $8e4230f608d6b965$export$7d278ca694634874,
    DARK_GREY: $8e4230f608d6b965$export$26453300bfc61cb8
};
const $8e4230f608d6b965$export$d33d39828a18210a = {
    SERVER_PURPLE: $8e4230f608d6b965$export$792af22a0198af8d,
    SERVER_DARK_PURPLE: $8e4230f608d6b965$export$588af712afdcb006,
    SERVER_BLUE: $8e4230f608d6b965$export$84c4918645391802,
    SERVER_DARK_BLUE: $8e4230f608d6b965$export$b8f1f5838352a33a,
    SERVER_GREEN: $8e4230f608d6b965$export$9384b7e350ee6542,
    SERVER_DARK_GREEN: $8e4230f608d6b965$export$87d3fb8d8656d38b,
    SERVER_TEAL: $8e4230f608d6b965$export$b0b4ce3e99e66aae,
    SERVER_DARK_TEAL: $8e4230f608d6b965$export$a89b77a449bd223e,
    SERVER_YELLOW: $8e4230f608d6b965$export$9a33b5e3cde94885,
    SERVER_DARK_YELLOW: $8e4230f608d6b965$export$33253d7862bceb8a,
    SERVER_ORANGE: $8e4230f608d6b965$export$6609c2b23fc42f39,
    SERVER_DARK_ORANGE: $8e4230f608d6b965$export$cd994662b5911917,
    SERVER_GREY: $8e4230f608d6b965$export$1793d43e13e078c5,
    SERVER_DARK_GREY: $8e4230f608d6b965$export$487a6e9145526564
};
const $8e4230f608d6b965$export$f476e6e43e0101e7 = {
    GHX_LABEL_1: $8e4230f608d6b965$export$e4bdf2d4c4bbb15e,
    GHX_LABEL_2: $8e4230f608d6b965$export$8f5c1c5512278dc6,
    GHX_LABEL_3: $8e4230f608d6b965$export$94ac87c81ed074a7,
    GHX_LABEL_4: $8e4230f608d6b965$export$6bc9ab1f489f76f7,
    GHX_LABEL_5: $8e4230f608d6b965$export$610a2c132b6fcf96,
    GHX_LABEL_6: $8e4230f608d6b965$export$8e4997dba71f1c40,
    GHX_LABEL_7: $8e4230f608d6b965$export$18a545b4e69b27b4,
    GHX_LABEL_8: $8e4230f608d6b965$export$27fff1a0d295292a,
    GHX_LABEL_9: $8e4230f608d6b965$export$e57aa662a56724e1,
    GHX_LABEL_10: $8e4230f608d6b965$export$4b0d63e2c3be2072,
    GHX_LABEL_11: $8e4230f608d6b965$export$457ecb9560f2bf83,
    GHX_LABEL_12: $8e4230f608d6b965$export$a866db37165a696c,
    GHX_LABEL_13: $8e4230f608d6b965$export$9b18447c1168a1b6,
    GHX_LABEL_14: $8e4230f608d6b965$export$93b9ad4020e271b7
};
const $8e4230f608d6b965$export$4b7407b8700035bd = {
    AGILE_COLOR_1: $8e4230f608d6b965$export$5cd2af17b34de3e3,
    AGILE_COLOR_2: $8e4230f608d6b965$export$987671fa69482a7b,
    AGILE_COLOR_3: $8e4230f608d6b965$export$70ba8a5b1f4c7446,
    AGILE_COLOR_4: $8e4230f608d6b965$export$fcd1c42d8d3ebd36,
    AGILE_COLOR_5: $8e4230f608d6b965$export$f80a5bd2fa0ba256,
    AGILE_COLOR_6: $8e4230f608d6b965$export$37ad5ce8d2aeaf78,
    AGILE_COLOR_7: $8e4230f608d6b965$export$9dc62d5d151cb355,
    AGILE_COLOR_8: $8e4230f608d6b965$export$1ed15b30f5663f92,
    AGILE_COLOR_9: $8e4230f608d6b965$export$5d23a84d55ac1644,
    AGILE_COLOR_10: $8e4230f608d6b965$export$bf08c9a6ed42e349,
    AGILE_COLOR_11: $8e4230f608d6b965$export$66c5d8f0b5ff279c,
    AGILE_COLOR_12: $8e4230f608d6b965$export$da30755a37c3a597,
    AGILE_COLOR_13: $8e4230f608d6b965$export$721cf84faff6bf19,
    AGILE_COLOR_14: $8e4230f608d6b965$export$4b8f8666bd7b61dd
};

});

parcelRegister("heWHN", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_EPIC_COLOR", () => $3a4ee6f2b0ce40ab$export$c2357bec51c5cf5b);
$parcel$export(module.exports, "MAP_COLORS_TO_VALUE", () => $3a4ee6f2b0ce40ab$export$db33d74b098e3da9);
$parcel$export(module.exports, "MAP_COLORS_TO_TOKEN", () => $3a4ee6f2b0ce40ab$export$fc5fe4213a5703f1);
$parcel$export(module.exports, "MAP_VALUE_TO_COLOR", () => $3a4ee6f2b0ce40ab$export$a6cb26e106674600);
$parcel$export(module.exports, "MAP_FROM_SERVER_COLOR", () => $3a4ee6f2b0ce40ab$export$43264b0781f10167);
$parcel$export(module.exports, "MAP_FROM_CLIENT_SERVER_COLOR", () => $3a4ee6f2b0ce40ab$export$aedca9f3a1ee43d7);
$parcel$export(module.exports, "MAP_FROM_SERVER_CLASSIC_COLOR", () => $3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc);
$parcel$export(module.exports, "MAP_FROM_CLIENT_CLASSIC_COLOR", () => $3a4ee6f2b0ce40ab$export$c13af2d9629c53d8);
$parcel$export(module.exports, "MAP_FROM_AGILE_COLOR", () => $3a4ee6f2b0ce40ab$export$994d3ffa39be04fd);
$parcel$export(module.exports, "MAP_FROM_CLIENT_AGILE_COLOR", () => $3a4ee6f2b0ce40ab$export$db17671bf37971e7);
$parcel$export(module.exports, "MAP_COLOR_TO_AK_COLOR", () => $3a4ee6f2b0ce40ab$export$82fc3b0b98905453);
$parcel$export(module.exports, "BASE_COLOR_SCHEMA", () => $3a4ee6f2b0ce40ab$export$92b6aebfb522f0d9);

var $ggSx2 = parcelRequire("ggSx2");


var $7SCny = parcelRequire("7SCny");
const $3a4ee6f2b0ce40ab$export$c2357bec51c5cf5b = 'PURPLE';
const $3a4ee6f2b0ce40ab$export$db33d74b098e3da9 = {
    [(0, $7SCny.PURPLE)]: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
    [(0, $7SCny.BLUE)]: "var(--ds-background-accent-blue-subtle, #579DFF)",
    [(0, $7SCny.GREEN)]: "var(--ds-background-accent-green-subtle, #4BCE97)",
    [(0, $7SCny.TEAL)]: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    [(0, $7SCny.YELLOW)]: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
    [(0, $7SCny.ORANGE)]: "var(--ds-background-accent-red-subtle, #F87168)",
    [(0, $7SCny.GREY)]: "var(--ds-background-accent-gray-subtle, #8590A2)",
    [(0, $7SCny.DARK_PURPLE)]: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
    [(0, $7SCny.DARK_BLUE)]: "var(--ds-background-accent-blue-bolder, #0C66E4)",
    [(0, $7SCny.DARK_GREEN)]: "var(--ds-background-accent-green-bolder, #1F845A)",
    [(0, $7SCny.DARK_TEAL)]: "var(--ds-background-accent-teal-bolder, #227D9B)",
    [(0, $7SCny.DARK_YELLOW)]: "var(--ds-background-accent-orange-bolder, #C25100)",
    [(0, $7SCny.DARK_ORANGE)]: "var(--ds-background-accent-red-bolder, #C9372C)",
    [(0, $7SCny.DARK_GREY)]: "var(--ds-background-accent-gray-bolder, #626F86)"
};
const $3a4ee6f2b0ce40ab$export$fc5fe4213a5703f1 = {
    [(0, $829f609a65d26a98$exports).P200]: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
    [(0, $829f609a65d26a98$exports).B200]: "var(--ds-background-accent-blue-subtle, #579DFF)",
    [(0, $829f609a65d26a98$exports).G200]: "var(--ds-background-accent-green-subtle, #4BCE97)",
    [(0, $829f609a65d26a98$exports).T200]: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    [(0, $829f609a65d26a98$exports).Y200]: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
    [(0, $829f609a65d26a98$exports).R200]: "var(--ds-background-accent-red-subtle, #F87168)",
    [(0, $829f609a65d26a98$exports).N200]: "var(--ds-background-accent-gray-subtle, #8590A2)",
    [(0, $829f609a65d26a98$exports).P400]: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
    [(0, $829f609a65d26a98$exports).B400]: "var(--ds-background-accent-blue-bolder, #0C66E4)",
    [(0, $829f609a65d26a98$exports).G400]: "var(--ds-background-accent-green-bolder, #1F845A)",
    [(0, $829f609a65d26a98$exports).T400]: "var(--ds-background-accent-teal-bolder, #227D9B)",
    [(0, $829f609a65d26a98$exports).Y400]: "var(--ds-background-accent-orange-bolder, #C25100)",
    [(0, $829f609a65d26a98$exports).R400]: "var(--ds-background-accent-red-bolder, #C9372C)",
    [(0, $829f609a65d26a98$exports).N700]: "var(--ds-background-accent-gray-bolder, #626F86)"
};
const $3a4ee6f2b0ce40ab$export$a6cb26e106674600 = (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$db33d74b098e3da9);
const $3a4ee6f2b0ce40ab$export$43264b0781f10167 = {
    [(0, $7SCny.SERVER_PURPLE)]: (0, $7SCny.PURPLE),
    [(0, $7SCny.SERVER_DARK_PURPLE)]: (0, $7SCny.DARK_PURPLE),
    [(0, $7SCny.SERVER_BLUE)]: (0, $7SCny.BLUE),
    [(0, $7SCny.SERVER_DARK_BLUE)]: (0, $7SCny.DARK_BLUE),
    [(0, $7SCny.SERVER_GREEN)]: (0, $7SCny.GREEN),
    [(0, $7SCny.SERVER_DARK_GREEN)]: (0, $7SCny.DARK_GREEN),
    [(0, $7SCny.SERVER_TEAL)]: (0, $7SCny.TEAL),
    [(0, $7SCny.SERVER_DARK_TEAL)]: (0, $7SCny.DARK_TEAL),
    [(0, $7SCny.SERVER_YELLOW)]: (0, $7SCny.YELLOW),
    [(0, $7SCny.SERVER_DARK_YELLOW)]: (0, $7SCny.DARK_YELLOW),
    [(0, $7SCny.SERVER_ORANGE)]: (0, $7SCny.ORANGE),
    [(0, $7SCny.SERVER_DARK_ORANGE)]: (0, $7SCny.DARK_ORANGE),
    [(0, $7SCny.SERVER_GREY)]: (0, $7SCny.GREY),
    [(0, $7SCny.SERVER_DARK_GREY)]: (0, $7SCny.DARK_GREY)
};
const $3a4ee6f2b0ce40ab$export$aedca9f3a1ee43d7 = (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$43264b0781f10167);
const $3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc = {
    [(0, $7SCny.GHX_LABEL_1)]: (0, $7SCny.DARK_GREY),
    [(0, $7SCny.GHX_LABEL_2)]: (0, $7SCny.DARK_YELLOW),
    [(0, $7SCny.GHX_LABEL_3)]: (0, $7SCny.YELLOW),
    [(0, $7SCny.GHX_LABEL_4)]: (0, $7SCny.DARK_BLUE),
    [(0, $7SCny.GHX_LABEL_5)]: (0, $7SCny.DARK_TEAL),
    [(0, $7SCny.GHX_LABEL_6)]: (0, $7SCny.GREEN),
    [(0, $7SCny.GHX_LABEL_7)]: (0, $7SCny.PURPLE),
    [(0, $7SCny.GHX_LABEL_8)]: (0, $7SCny.DARK_PURPLE),
    [(0, $7SCny.GHX_LABEL_9)]: (0, $7SCny.ORANGE),
    [(0, $7SCny.GHX_LABEL_10)]: (0, $7SCny.BLUE),
    [(0, $7SCny.GHX_LABEL_11)]: (0, $7SCny.TEAL),
    [(0, $7SCny.GHX_LABEL_12)]: (0, $7SCny.GREY),
    [(0, $7SCny.GHX_LABEL_13)]: (0, $7SCny.DARK_GREEN),
    [(0, $7SCny.GHX_LABEL_14)]: (0, $7SCny.DARK_ORANGE)
};
const $3a4ee6f2b0ce40ab$export$c13af2d9629c53d8 = (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc);
const $3a4ee6f2b0ce40ab$export$994d3ffa39be04fd = {
    [(0, $7SCny.AGILE_COLOR_1)]: (0, $7SCny.DARK_GREY),
    [(0, $7SCny.AGILE_COLOR_2)]: (0, $7SCny.DARK_YELLOW),
    [(0, $7SCny.AGILE_COLOR_3)]: (0, $7SCny.YELLOW),
    [(0, $7SCny.AGILE_COLOR_4)]: (0, $7SCny.DARK_BLUE),
    [(0, $7SCny.AGILE_COLOR_5)]: (0, $7SCny.DARK_TEAL),
    [(0, $7SCny.AGILE_COLOR_6)]: (0, $7SCny.GREEN),
    [(0, $7SCny.AGILE_COLOR_7)]: (0, $7SCny.PURPLE),
    [(0, $7SCny.AGILE_COLOR_8)]: (0, $7SCny.DARK_PURPLE),
    [(0, $7SCny.AGILE_COLOR_9)]: (0, $7SCny.ORANGE),
    [(0, $7SCny.AGILE_COLOR_10)]: (0, $7SCny.BLUE),
    [(0, $7SCny.AGILE_COLOR_11)]: (0, $7SCny.TEAL),
    [(0, $7SCny.AGILE_COLOR_12)]: (0, $7SCny.GREY),
    [(0, $7SCny.AGILE_COLOR_13)]: (0, $7SCny.DARK_GREEN),
    [(0, $7SCny.AGILE_COLOR_14)]: (0, $7SCny.DARK_ORANGE)
};
const $3a4ee6f2b0ce40ab$export$db17671bf37971e7 = (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$994d3ffa39be04fd);
const $3a4ee6f2b0ce40ab$export$1fdd5a248b5f697c = {
    [(0, $7SCny.GHX_LABEL_1)]: (0, $7SCny.AGILE_COLOR_1),
    [(0, $7SCny.GHX_LABEL_2)]: (0, $7SCny.AGILE_COLOR_2),
    [(0, $7SCny.GHX_LABEL_3)]: (0, $7SCny.AGILE_COLOR_3),
    [(0, $7SCny.GHX_LABEL_4)]: (0, $7SCny.AGILE_COLOR_4),
    [(0, $7SCny.GHX_LABEL_5)]: (0, $7SCny.AGILE_COLOR_5),
    [(0, $7SCny.GHX_LABEL_6)]: (0, $7SCny.AGILE_COLOR_6),
    [(0, $7SCny.GHX_LABEL_7)]: (0, $7SCny.AGILE_COLOR_7),
    [(0, $7SCny.GHX_LABEL_8)]: (0, $7SCny.AGILE_COLOR_8),
    [(0, $7SCny.GHX_LABEL_9)]: (0, $7SCny.AGILE_COLOR_9),
    [(0, $7SCny.GHX_LABEL_10)]: (0, $7SCny.AGILE_COLOR_10),
    [(0, $7SCny.GHX_LABEL_11)]: (0, $7SCny.AGILE_COLOR_11),
    [(0, $7SCny.GHX_LABEL_12)]: (0, $7SCny.AGILE_COLOR_12),
    [(0, $7SCny.GHX_LABEL_13)]: (0, $7SCny.AGILE_COLOR_13),
    [(0, $7SCny.GHX_LABEL_14)]: (0, $7SCny.AGILE_COLOR_14)
};
const $3a4ee6f2b0ce40ab$export$82fc3b0b98905453 = {
    [(0, $7SCny.DARK_GREY)]: 'grey',
    [(0, $7SCny.DARK_YELLOW)]: 'yellow',
    [(0, $7SCny.YELLOW)]: 'yellowLight',
    [(0, $7SCny.DARK_BLUE)]: 'blue',
    [(0, $7SCny.DARK_TEAL)]: 'teal',
    [(0, $7SCny.GREEN)]: 'greenLight',
    [(0, $7SCny.PURPLE)]: 'purpleLight',
    [(0, $7SCny.DARK_PURPLE)]: 'purple',
    [(0, $7SCny.ORANGE)]: 'redLight',
    [(0, $7SCny.BLUE)]: 'blueLight',
    [(0, $7SCny.TEAL)]: 'tealLight',
    [(0, $7SCny.GREY)]: 'greyLight',
    [(0, $7SCny.DARK_GREEN)]: 'green',
    [(0, $7SCny.DARK_ORANGE)]: 'red'
};
const $3a4ee6f2b0ce40ab$export$703aca53c431bb88 = {
    [(0, $7SCny.AGILE_COLOR_1)]: 'grey',
    [(0, $7SCny.AGILE_COLOR_2)]: 'yellow',
    [(0, $7SCny.AGILE_COLOR_3)]: 'yellowLight',
    [(0, $7SCny.AGILE_COLOR_4)]: 'blue',
    [(0, $7SCny.AGILE_COLOR_5)]: 'teal',
    [(0, $7SCny.AGILE_COLOR_6)]: 'greenLight',
    [(0, $7SCny.AGILE_COLOR_7)]: 'purpleLight',
    [(0, $7SCny.AGILE_COLOR_8)]: 'purple',
    [(0, $7SCny.AGILE_COLOR_9)]: 'redLight',
    [(0, $7SCny.AGILE_COLOR_10)]: 'blueLight',
    [(0, $7SCny.AGILE_COLOR_11)]: 'tealLight',
    [(0, $7SCny.AGILE_COLOR_12)]: 'greyLight',
    [(0, $7SCny.AGILE_COLOR_13)]: 'green',
    [(0, $7SCny.AGILE_COLOR_14)]: 'red'
};
const $3a4ee6f2b0ce40ab$export$92b6aebfb522f0d9 = {
    [(0, $7SCny.PURPLE)]: {
        primary: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
        secondary: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
        text: "var(--ds-text-accent-purple, #5E4DB2)",
        textBackground: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        border: "var(--ds-border-accent-purple, #8270DB)",
        line: "var(--ds-border-accent-purple, #8270DB)",
        primaryGradient: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        hasContrastSecondaryGradient: true
    },
    [(0, $7SCny.BLUE)]: {
        primary: "var(--ds-background-accent-blue-subtle, #579DFF)",
        secondary: "var(--ds-background-accent-blue-bolder, #0C66E4)",
        text: "var(--ds-text-accent-blue, #0055CC)",
        textBackground: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        border: "var(--ds-border-accent-blue, #1D7AFC)",
        line: "var(--ds-border-accent-blue, #1D7AFC)",
        primaryGradient: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        hasContrastSecondaryGradient: true
    },
    [(0, $7SCny.GREEN)]: {
        primary: "var(--ds-background-accent-green-subtle, #4BCE97)",
        secondary: "var(--ds-background-accent-green-bolder, #1F845A)",
        text: "var(--ds-text-accent-green, #216E4E)",
        textBackground: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        border: "var(--ds-border-accent-green, #22A06B)",
        line: "var(--ds-border-accent-green, #22A06B)",
        primaryGradient: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        hasContrastSecondaryGradient: true
    },
    [(0, $7SCny.TEAL)]: {
        primary: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
        secondary: "var(--ds-background-accent-teal-bolder, #227D9B)",
        text: "var(--ds-text-accent-teal, #206A83)",
        textBackground: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        border: "var(--ds-border-accent-teal, #2898BD)",
        line: "var(--ds-border-accent-teal, #2898BD)",
        primaryGradient: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        hasContrastSecondaryGradient: true
    },
    [(0, $7SCny.YELLOW)]: {
        primary: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
        secondary: "var(--ds-background-accent-yellow-bolder, #946F00)",
        text: "var(--ds-text-accent-yellow, #7F5F01)",
        textBackground: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        border: "var(--ds-border-accent-yellow, #B38600)",
        line: "var(--ds-border-accent-yellow, #B38600)",
        primaryGradient: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        hasContrastSecondaryGradient: true
    },
    [(0, $7SCny.ORANGE)]: {
        primary: "var(--ds-background-accent-red-subtle, #F87168)",
        secondary: "var(--ds-background-accent-red-bolder, #C9372C)",
        text: "var(--ds-text-accent-red, #AE2E24)",
        textBackground: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        border: "var(--ds-border-accent-red, #E2483D)",
        line: "var(--ds-border-accent-red, #E2483D)",
        primaryGradient: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        hasContrastSecondaryGradient: true
    },
    [(0, $7SCny.GREY)]: {
        primary: "var(--ds-background-accent-gray-subtle, #8590A2)",
        secondary: "var(--ds-background-accent-gray-bolder, #626F86)",
        text: "var(--ds-text-accent-gray, #44546F)",
        textBackground: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        border: "var(--ds-border-accent-gray, #758195)",
        line: "var(--ds-border-accent-gray, #758195)",
        primaryGradient: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        hasContrastSecondaryGradient: true
    },
    [(0, $7SCny.DARK_PURPLE)]: {
        primary: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
        secondary: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
        border: "var(--ds-border-accent-purple, #8270DB)",
        line: "var(--ds-border-accent-purple, #8270DB)",
        primaryGradient: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
        hasContrastSecondaryGradient: false
    },
    [(0, $7SCny.DARK_BLUE)]: {
        primary: "var(--ds-background-accent-blue-bolder, #0C66E4)",
        secondary: "var(--ds-background-accent-blue-subtle, #579DFF)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-blue-bolder, #0C66E4)",
        border: "var(--ds-border-accent-blue, #1D7AFC)",
        line: "var(--ds-border-accent-blue, #1D7AFC)",
        primaryGradient: "var(--ds-background-accent-blue-subtle, #579DFF)",
        hasContrastSecondaryGradient: false
    },
    [(0, $7SCny.DARK_GREEN)]: {
        primary: "var(--ds-background-accent-green-bolder, #1F845A)",
        secondary: "var(--ds-background-accent-green-subtle, #4BCE97)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-green-bolder, #1F845A)",
        border: "var(--ds-border-accent-green, #22A06B)",
        line: "var(--ds-border-accent-green, #22A06B)",
        primaryGradient: "var(--ds-background-accent-green-subtle, #4BCE97)",
        hasContrastSecondaryGradient: false
    },
    [(0, $7SCny.DARK_TEAL)]: {
        primary: "var(--ds-background-accent-teal-bolder, #227D9B)",
        secondary: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-teal-bolder, #227D9B)",
        border: "var(--ds-border-accent-teal, #2898BD)",
        line: "var(--ds-border-accent-teal, #2898BD)",
        primaryGradient: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
        hasContrastSecondaryGradient: false
    },
    [(0, $7SCny.DARK_YELLOW)]: {
        primary: "var(--ds-background-accent-orange-bolder, #C25100)",
        secondary: "var(--ds-background-accent-orange-subtle, #FEA362)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-orange-bolder, #C25100)",
        border: "var(--ds-background-accent-orange-subtle, #FEA362)",
        line: "var(--ds-border-accent-orange, #E56910)",
        primaryGradient: "var(--ds-background-accent-orange-subtle, #FEA362)",
        hasContrastSecondaryGradient: false
    },
    [(0, $7SCny.DARK_ORANGE)]: {
        primary: "var(--ds-background-accent-red-bolder, #C9372C)",
        secondary: "var(--ds-background-accent-red-subtle, #F87168)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-red-bolder, #C9372C)",
        border: "var(--ds-background-accent-red-subtle, #F87168)",
        line: "var(--ds-border-accent-red, #E2483D)",
        primaryGradient: "var(--ds-background-accent-red-subtle, #F87168)",
        hasContrastSecondaryGradient: false
    },
    [(0, $7SCny.DARK_GREY)]: {
        primary: "var(--ds-background-accent-gray-bolder, #626F86)",
        secondary: "var(--ds-background-accent-gray-subtle, #8590A2)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-gray-bolder, #626F86)",
        border: "var(--ds-background-accent-gray-subtle, #8590A2)",
        line: "var(--ds-border-accent-gray, #758195)",
        primaryGradient: "var(--ds-background-accent-gray-subtle, #8590A2)",
        hasContrastSecondaryGradient: false
    }
};

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';


parcelRegister("ehxiD", function(module, exports) {

$parcel$export(module.exports, "default", () => $50b7e3d933c7b9f7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $50b7e3d933c7b9f7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    purpleLabel: {
        "id": "issue-epic-color.common.purple-label",
        "defaultMessage": "purple"
    },
    blueLabel: {
        "id": "issue-epic-color.common.blue-label",
        "defaultMessage": "blue"
    },
    greenLabel: {
        "id": "issue-epic-color.common.green-label",
        "defaultMessage": "green"
    },
    tealLabel: {
        "id": "issue-epic-color.common.teal-label",
        "defaultMessage": "teal"
    },
    yellowLabel: {
        "id": "issue-epic-color.common.yellow-label",
        "defaultMessage": "yellow"
    },
    orangeLabel: {
        "id": "issue-epic-color.common.orange-label",
        "defaultMessage": "orange"
    },
    greyLabel: {
        "id": "issue-epic-color.common.grey-label",
        "defaultMessage": "grey"
    },
    darkPurpleLabel: {
        "id": "issue-epic-color.common.dark-purple-label",
        "defaultMessage": "dark purple"
    },
    darkBlueLabel: {
        "id": "issue-epic-color.common.dark-blue-label",
        "defaultMessage": "dark blue"
    },
    darkGreenLabel: {
        "id": "issue-epic-color.common.dark-green-label",
        "defaultMessage": "dark green"
    },
    darkTealLabel: {
        "id": "issue-epic-color.common.dark-teal-label",
        "defaultMessage": "dark teal"
    },
    darkYellowLabel: {
        "id": "issue-epic-color.common.dark-yellow-label",
        "defaultMessage": "dark yellow"
    },
    darkOrangeLabel: {
        "id": "issue-epic-color.common.dark-orange-label",
        "defaultMessage": "dark orange"
    },
    darkGreyLabel: {
        "id": "issue-epic-color.common.dark-grey-label",
        "defaultMessage": "dark grey"
    }
});

});


parcelRegister("fhSLy", function(module, exports) {

$parcel$export(module.exports, "getUnassignedUser", () => $bdabf260f25df73f$export$42c5a0b65ef9ee80);
$parcel$export(module.exports, "getAutomaticUserOption", () => $bdabf260f25df73f$export$8d7a63500893c8c);
$parcel$export(module.exports, "getInvitePeopleOption", () => $bdabf260f25df73f$export$84a82764cf0a696e);
$parcel$export(module.exports, "getUserOptionFromUser", () => $bdabf260f25df73f$export$16086438354dcc85);
$parcel$export(module.exports, "getUserFromUserOption", () => $bdabf260f25df73f$export$78a8bcc5bd21caa2);
$parcel$export(module.exports, "getUserAvatarUrl", () => $bdabf260f25df73f$export$7d801d84202c7743);
$parcel$export(module.exports, "getUserShape", () => $bdabf260f25df73f$export$322b6ab8c29a006e);

var $7lGt2 = parcelRequire("7lGt2");

var $gRwYv = parcelRequire("gRwYv");

const $bdabf260f25df73f$export$42c5a0b65ef9ee80 = ({ formatMessage: formatMessage })=>({
        accountId: (0, $c1e3a0a8493b8e86$export$bdab9bfb39981463),
        displayName: formatMessage((0, $7lGt2.default).unassignedOption),
        avatarUrls: {}
    });
const $bdabf260f25df73f$export$8d7a63500893c8c = ({ formatMessage: formatMessage })=>({
        accountId: (0, $c1e3a0a8493b8e86$export$f5d5f6bb902f1027),
        displayName: formatMessage((0, $7lGt2.default).automaticOption),
        avatarUrls: {}
    });
const $bdabf260f25df73f$export$84a82764cf0a696e = ({ formatMessage: formatMessage }, isAdmin)=>({
        accountId: (0, $c1e3a0a8493b8e86$export$d875316cb0cd94f7),
        displayName: formatMessage(isAdmin ? (0, $7lGt2.default).invitePeopleOptionAdmin : (0, $7lGt2.default).invitePeopleOption),
        avatarUrls: {
            '48x48': (0, (/*@__PURE__*/$parcel$interopDefault($gRwYv)))
        }
    });
const $bdabf260f25df73f$export$16086438354dcc85 = ({ accountId: accountId, displayName: displayName, avatarUrls: avatarUrls, emailAddress: emailAddress })=>({
        id: accountId || '',
        name: displayName,
        avatarUrl: avatarUrls['48x48'],
        // @ts-expect-error Will be part of JIV-13488; `user.emailAddress` returned by the REST API can be null depending on their privacy settings
        byline: emailAddress
    });
const $bdabf260f25df73f$export$78a8bcc5bd21caa2 = ({ id: id, name: name, avatarUrl: avatarUrl })=>({
        accountId: id,
        displayName: name,
        avatarUrls: {
            '48x48': avatarUrl
        }
    });
const $bdabf260f25df73f$export$7d801d84202c7743 = ({ avatarUrls: avatarUrls })=>avatarUrls['48x48'];
const $bdabf260f25df73f$export$322b6ab8c29a006e = (accountId, displayName, avatarUrl)=>({
        accountId: accountId,
        displayName: displayName,
        avatarUrls: {
            '48x48': avatarUrl
        }
    });

});
parcelRegister("7lGt2", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2aaed3328149e1d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e2aaed3328149e1d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    unassignedOption: {
        "id": "issue-field-assignee.unassigned-option",
        "defaultMessage": "Unassigned"
    },
    automaticOption: {
        "id": "issue-field-assignee.automatic-option",
        "defaultMessage": "Automatic"
    },
    assignToMe: {
        "id": "issue-field-assignee.assign-to-me",
        "defaultMessage": "Assign to me"
    },
    searchForAssignee: {
        "id": "issue-field-assignee.search-for-assignee",
        "defaultMessage": "Search for assignee"
    },
    invitePeopleOption: {
        "id": "issue-field-assignee.invite-people-option",
        "defaultMessage": "Add teammate to Jira"
    },
    invitePeopleOptionAdmin: {
        "id": "issue-field-assignee.invite-people-option-admin",
        "defaultMessage": "Invite teammate to Jira"
    }
});

});

parcelRegister("gRwYv", function(module, exports) {
module.exports = new URL("add.b8fea212.png", import.meta.url).toString();

});

const $c1e3a0a8493b8e86$export$bdab9bfb39981463 = '__UNASSIGNED_ID__';
const $c1e3a0a8493b8e86$export$d875316cb0cd94f7 = '__INVITE_PEOPLE_ID__';
const $c1e3a0a8493b8e86$export$f5d5f6bb902f1027 = '-1';


parcelRegister("7Fute", function(module, exports) {

$parcel$export(module.exports, "getLozengeThemeByColor", () => $92894d61150c3ebf$export$949dc67535a8ff2);
$parcel$export(module.exports, "getParentShape", () => $92894d61150c3ebf$export$1a0682c86bbf9e96);
$parcel$export(module.exports, "getHierarchyShape", () => $92894d61150c3ebf$export$5f81302d25451851);
$parcel$export(module.exports, "formatOptionList", () => $92894d61150c3ebf$export$48f827b6d0c5862);
$parcel$export(module.exports, "transformToEpic", () => $92894d61150c3ebf$export$11773371cf35c9f8);

var $iHPnC = parcelRequire("iHPnC");

var $k8qVk = parcelRequire("k8qVk");
const $92894d61150c3ebf$export$9b822862d986dfdf = (0, $iHPnC.transformColorToTheme)((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $92894d61150c3ebf$export$949dc67535a8ff2 = (color = (0, $k8qVk.DEFAULT_EPIC_COLOR))=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $92894d61150c3ebf$export$9b822862d986dfdf[color] ?? $92894d61150c3ebf$export$9b822862d986dfdf[0, $k8qVk.DEFAULT_EPIC_COLOR];
const $92894d61150c3ebf$export$1a0682c86bbf9e96 = (id, key, summary, issuetype, color)=>({
        id: id,
        key: key,
        color: color,
        fields: {
            summary: summary,
            issuetype: issuetype
        }
    });
const $92894d61150c3ebf$export$5f81302d25451851 = ({ id: id, name: name, iconUrl: iconUrl })=>({
        name: 'Epic',
        level: 1,
        issueTypeIds: [
            Number(id)
        ],
        issueTypes: [
            {
                id: id,
                name: name,
                iconUrl: iconUrl
            }
        ]
    });
const $92894d61150c3ebf$export$48f827b6d0c5862 = (unformattedOptions, currentParent, label)=>{
    const filteredOptions = unformattedOptions.filter((option)=>option.key !== currentParent);
    const parentList = filteredOptions.slice(0, (0, $k8qVk.MAX_SUGGESTIONS)).map((option)=>({
            label: `${option.key} ${option.fields.summary}`,
            value: option.fields.summary,
            iconUrl: option.fields.issuetype.iconUrl,
            ...option
        }));
    return {
        options: parentList.length > 0 ? [
            {
                label: label,
                options: parentList
            }
        ] : [],
        hasMoreOptions: filteredOptions.length > (0, $k8qVk.MAX_SUGGESTIONS)
    };
};
const $92894d61150c3ebf$export$11773371cf35c9f8 = ({ id: id, key: key, summary: summary, color: color, issueType: { id: issueTypeId, name: issueTypeName, iconUrl: iconUrl } })=>({
        id: id,
        key: key,
        summary: summary,
        color: color,
        issueType: {
            id: issueTypeId,
            name: issueTypeName,
            iconUrl: iconUrl
        }
    });

});
parcelRegister("k8qVk", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $93cb8f2923e7410b$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "DEFAULT_EPIC_COLOR", () => $93cb8f2923e7410b$export$c2357bec51c5cf5b);
$parcel$export(module.exports, "MAX_SUGGESTIONS", () => $93cb8f2923e7410b$export$eb8d067f048699c8);
$parcel$export(module.exports, "MENU_WIDTH", () => $93cb8f2923e7410b$export$2467bcf8f6d5c6b6);
$parcel$export(module.exports, "MENU_EMPTY_WIDTH", () => $93cb8f2923e7410b$export$84f510916a7dff2e);
$parcel$export(module.exports, "LONG_LABEL_LIMIT", () => $93cb8f2923e7410b$export$29ec59bc4d551a41);
$parcel$export(module.exports, "PARENT_SWITCHER_LOZENGE_TEST_ID", () => $93cb8f2923e7410b$export$680faa54dc6da799);
$parcel$export(module.exports, "PARENT_SWITCHER_LOADING_SPINNER_TEST_ID", () => $93cb8f2923e7410b$export$11e2185ebbcf7235);
$parcel$export(module.exports, "PARENT_SWITCHER_SUGGESTED_PARENTS_ACTIONS_TEST_ID", () => $93cb8f2923e7410b$export$2aa213773f04da8f);
$parcel$export(module.exports, "PARENT_SWITCHER_LABEL_TEST_ID", () => $93cb8f2923e7410b$export$bccc9d1ffeb474d3);
$parcel$export(module.exports, "PARENT_SWITCHER_ADD_PARENT_BUTTON_TEST_ID", () => $93cb8f2923e7410b$export$cc185b35b5eb5c92);
$parcel$export(module.exports, "PARENT_SWITCHER_SUGGESTED_PARENTS_REMOVE_PARENT_TEST_ID", () => $93cb8f2923e7410b$export$31b523708d2a8acb);
$parcel$export(module.exports, "PARENT_SWITCHER_SUGGESTED_PARENTS_VIEW_ALL_PARENTS_TEST_ID", () => $93cb8f2923e7410b$export$ac3a223c1d7cac9a);
$parcel$export(module.exports, "PARENT_SWITCHER_SUGGESTED_PARENTS_EMPTY_TEST_ID", () => $93cb8f2923e7410b$export$beb7535f4921d585);
$parcel$export(module.exports, "PARENT_SWITCHER_OPEN_ISSUE_CREATE_LINK_TEST_ID", () => $93cb8f2923e7410b$export$a019f396c99849dc);

var $7SCny = parcelRequire("7SCny");

var $3XO6n = parcelRequire("3XO6n");
const $93cb8f2923e7410b$export$b8b9d90f9e5bd72b = (0, $3XO6n.toPackageName)('jiraParentSwitcherField');
const $93cb8f2923e7410b$export$c2357bec51c5cf5b = (0, $7SCny.PURPLE);
const $93cb8f2923e7410b$export$eb8d067f048699c8 = 5;
const $93cb8f2923e7410b$export$2467bcf8f6d5c6b6 = 345;
const $93cb8f2923e7410b$export$84f510916a7dff2e = 180;
const $93cb8f2923e7410b$export$29ec59bc4d551a41 = 40;
const $93cb8f2923e7410b$export$680faa54dc6da799 = 'issue-field-parent-switcher.common.ui.epic-lozenge.epic-lozenge';
const $93cb8f2923e7410b$export$2082958b673f1f66 = 'issue-field-parent-switcher.common.ui.epic-tag.tag';
const $93cb8f2923e7410b$export$11813783c408cdf1 = `[data-testid="${$93cb8f2923e7410b$export$680faa54dc6da799}"]`;
const $93cb8f2923e7410b$export$11e2185ebbcf7235 = 'issue-field-parent-switcher.ui.edit.suggested-parents-dropdown.loading-content.parent-switcher-suggested-parents-loading-spinner';
const $93cb8f2923e7410b$export$2aa213773f04da8f = 'issue-field-parent-switcher.ui.edit.suggested-parents-dropdown.actions';
const $93cb8f2923e7410b$export$bccc9d1ffeb474d3 = 'issue-field-parent.edit-view.options.';
const $93cb8f2923e7410b$export$cc185b35b5eb5c92 = 'issue-field-parent-switcher.ui.edit.suggested-parents-dropdown.add-parent-button';
const $93cb8f2923e7410b$export$31b523708d2a8acb = 'issue-field-parent-switcher.ui.edit.suggested-parents-dropdown.remove-parent';
const $93cb8f2923e7410b$export$986b8ef30a6bdca7 = `[data-testid="${$93cb8f2923e7410b$export$31b523708d2a8acb}"]`;
const $93cb8f2923e7410b$export$ac3a223c1d7cac9a = 'issue-field-parent-switcher.ui.edit.view-all-parents';
const $93cb8f2923e7410b$export$6494872dab91ac11 = `[data-testid="${$93cb8f2923e7410b$export$ac3a223c1d7cac9a}"]`;
const $93cb8f2923e7410b$export$beb7535f4921d585 = 'issue-field-parent-switcher.ui.edit.empty-container';
const $93cb8f2923e7410b$export$c0432cfce03a69a8 = `[data-testid="${$93cb8f2923e7410b$export$beb7535f4921d585}"]`;
const $93cb8f2923e7410b$export$a019f396c99849dc = 'issue-field-parent-switcher.ui.edit.suggested-parents-dropdown.empty-content.open-issue-create';

});


parcelRegister("44VbI", function(module, exports) {

$parcel$export(module.exports, "isOnlyGlobalTransitions", () => $d665573e03a66c7e$export$10992041bf7e444a);
$parcel$export(module.exports, "getFilteredOrderedTransitions", () => $d665573e03a66c7e$export$707115549202b9e4);
$parcel$export(module.exports, "getLoopedTransitionsForStatus", () => $d665573e03a66c7e$export$38146914a8d06579);
$parcel$export(module.exports, "transformOptions", () => $d665573e03a66c7e$export$8f4ed8ef83bcbf04);
$parcel$export(module.exports, "getStatusShape", () => $d665573e03a66c7e$export$e2dafe47b17b2cfc);

var $8QpSo = parcelRequire("8QpSo");

var $gULOk = parcelRequire("gULOk");
const $d665573e03a66c7e$var$isGlobalSelfTransition = (transition, currentStatusId)=>transition.isGlobal && transition.to.id === currentStatusId;
const $d665573e03a66c7e$var$isInitialSelfTransition = (transition, currentStatusId)=>transition.isInitial && transition.to.id === currentStatusId;
const $d665573e03a66c7e$var$isLoopedTransitionToSelf = (transition, currentStatusId)=>transition.to.id === currentStatusId && transition.isLooped === true;
const $d665573e03a66c7e$var$filterLoopedTransitionsToSelf = (0, $8QpSo.default)((transitions, currentStatusId)=>transitions.filter((transition)=>!$d665573e03a66c7e$var$isLoopedTransitionToSelf(transition, currentStatusId) && !$d665573e03a66c7e$var$isGlobalSelfTransition(transition, currentStatusId) && !$d665573e03a66c7e$var$isInitialSelfTransition(transition, currentStatusId)));
const $d665573e03a66c7e$export$10992041bf7e444a = (transitions)=>transitions.every((t)=>t.isGlobal);
const $d665573e03a66c7e$export$707115549202b9e4 = (transitions, currentStatusId)=>$d665573e03a66c7e$var$filterLoopedTransitionsToSelf(transitions || [], currentStatusId);
const $d665573e03a66c7e$export$38146914a8d06579 = (0, $8QpSo.default)((transitions, currentStatusId)=>(transitions || []).filter((transition)=>$d665573e03a66c7e$var$isLoopedTransitionToSelf(transition, currentStatusId)));
const $d665573e03a66c7e$var$formatOptions = (options)=>options.map((t)=>({
            label: t.to.name,
            value: t.id,
            transition: t
        }));
const $d665573e03a66c7e$var$memoizedTranformOptions = (0, $8QpSo.default)($d665573e03a66c7e$var$formatOptions);
const $d665573e03a66c7e$export$8f4ed8ef83bcbf04 = (options)=>$d665573e03a66c7e$var$memoizedTranformOptions(options);
const $d665573e03a66c7e$export$e2dafe47b17b2cfc = (id, name, category)=>{
    const statusCategoryId = (0, $gULOk.StatusCategoryIds)[category] || (0, $gULOk.StatusCategoryIds)[(0, $gULOk.StatusCategoryTypes).UNDEFINED];
    return {
        id: id,
        name: name,
        statusCategory: {
            id: statusCategoryId,
            name: name
        }
    };
};

});
parcelRegister("gULOk", function(module, exports) {

$parcel$export(module.exports, "UNDEFINED", () => $e77315bf13f8b83b$export$6db089fe7b26f5b6);
$parcel$export(module.exports, "TODO", () => $e77315bf13f8b83b$export$aa456a5030160740);
$parcel$export(module.exports, "IN_PROGRESS", () => $e77315bf13f8b83b$export$5a9ac66c2785cc13);
$parcel$export(module.exports, "DONE", () => $e77315bf13f8b83b$export$71efb3495f6084f2);
$parcel$export(module.exports, "STATUS_CATEGORIES", () => $e77315bf13f8b83b$export$d9119300f9d9a815);
$parcel$export(module.exports, "StatusCategoryTypes", () => $e77315bf13f8b83b$export$5d42a08d46cffe7);
$parcel$export(module.exports, "StatusCategoryIds", () => $e77315bf13f8b83b$export$3f42f49c284d5b58);
$parcel$export(module.exports, "statusCategoryKeys", () => $e77315bf13f8b83b$export$f3f919dc0f56d9eb);
$parcel$export(module.exports, "statusCategoryForId", () => $e77315bf13f8b83b$export$3e9e3002956ff4fb);
$parcel$export(module.exports, "categoryIdForStatusCategory", () => $e77315bf13f8b83b$export$7b16b0022aac2d46);
$parcel$export(module.exports, "isValidStatusCategoryKey", () => $e77315bf13f8b83b$export$d928f247c903643a);
const $e77315bf13f8b83b$export$6db089fe7b26f5b6 = 'UNDEFINED';
const $e77315bf13f8b83b$export$aa456a5030160740 = 'TODO';
const $e77315bf13f8b83b$export$5a9ac66c2785cc13 = 'IN_PROGRESS';
const $e77315bf13f8b83b$export$71efb3495f6084f2 = 'DONE';
const $e77315bf13f8b83b$export$d9119300f9d9a815 = [
    $e77315bf13f8b83b$export$6db089fe7b26f5b6,
    $e77315bf13f8b83b$export$aa456a5030160740,
    $e77315bf13f8b83b$export$5a9ac66c2785cc13,
    $e77315bf13f8b83b$export$71efb3495f6084f2
];
const $e77315bf13f8b83b$var$statusCategories = [
    {
        id: '1',
        statusCategory: $e77315bf13f8b83b$export$6db089fe7b26f5b6
    },
    {
        id: '2',
        statusCategory: $e77315bf13f8b83b$export$aa456a5030160740
    },
    {
        id: '4',
        statusCategory: $e77315bf13f8b83b$export$5a9ac66c2785cc13
    },
    {
        id: '3',
        statusCategory: $e77315bf13f8b83b$export$71efb3495f6084f2
    }
];
const $e77315bf13f8b83b$export$5d42a08d46cffe7 = Object.freeze({
    NEW: 'new',
    INDETERMINATE: 'indeterminate',
    DONE: 'done',
    UNDEFINED: 'undefined'
});
const $e77315bf13f8b83b$export$3f42f49c284d5b58 = Object.freeze({
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.UNDEFINED]: 1,
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.NEW]: 2,
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.DONE]: 3,
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.INDETERMINATE]: 4
});
const $e77315bf13f8b83b$export$f3f919dc0f56d9eb = Object.values($e77315bf13f8b83b$export$5d42a08d46cffe7);
const $e77315bf13f8b83b$export$3e9e3002956ff4fb = (statusCategoryId)=>{
    const value = $e77315bf13f8b83b$var$statusCategories.find((sc)=>sc.id === String(statusCategoryId));
    return value ? value.statusCategory : $e77315bf13f8b83b$export$6db089fe7b26f5b6;
};
const $e77315bf13f8b83b$export$7b16b0022aac2d46 = (statusCategory)=>{
    const value = $e77315bf13f8b83b$var$statusCategories.find((sc)=>sc.statusCategory === statusCategory);
    return Number(value ? value.id : '1');
};
const $e77315bf13f8b83b$export$d928f247c903643a = (key)=>$e77315bf13f8b83b$export$f3f919dc0f56d9eb.some((statusCategoryKey)=>statusCategoryKey === key);

});


parcelRegister("g4tDr", function(module, exports) {

$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_GOAL", () => $03dd5f7faa501890$export$2294cfc7730248df);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_STRATEGY", () => $03dd5f7faa501890$export$961a1d6da881600c);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_INITIATIVE", () => $03dd5f7faa501890$export$e11dea67b88ee556);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_EPIC", () => $03dd5f7faa501890$export$9ad20e435294162a);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_BASE", () => $03dd5f7faa501890$export$a454b3474c5ee5f5);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_SUBTASK", () => $03dd5f7faa501890$export$b69c1b48ce8f83de);
$parcel$export(module.exports, "BASE_HIERARCHY_TYPE", () => $03dd5f7faa501890$export$ba7c785763a2a58f);
$parcel$export(module.exports, "CHILD_HIERARCHY_TYPE", () => $03dd5f7faa501890$export$e09d07f2dcff2603);
$parcel$export(module.exports, "PARENT_HIERARCHY_TYPE", () => $03dd5f7faa501890$export$1165245f61159842);
$parcel$export(module.exports, "EPIC_PARENT_HIERARCHY_TYPE", () => $03dd5f7faa501890$export$8a96a83b3f957e58);
$parcel$export(module.exports, "toHierarchyLevel", () => $03dd5f7faa501890$export$c0c893ca5ccae9dd);
$parcel$export(module.exports, "isBaseHierarchyLevel", () => $03dd5f7faa501890$export$bcf91a9d8c5b0f58);
$parcel$export(module.exports, "isEpicHierarchyLevel", () => $03dd5f7faa501890$export$e415cf60723c7aae);
$parcel$export(module.exports, "isSubtaskHierarchyLevel", () => $03dd5f7faa501890$export$41f00a40e2ebd6e8);
$parcel$export(module.exports, "getHierarchyLevelType", () => $03dd5f7faa501890$export$556b686fea6fb229);
$parcel$export(module.exports, "getHierarchyLevelTypeSplitEpicFromCustom", () => $03dd5f7faa501890$export$638ac52227e67c8);
const $03dd5f7faa501890$export$2294cfc7730248df = 4;
const $03dd5f7faa501890$export$961a1d6da881600c = 3;
const $03dd5f7faa501890$export$e11dea67b88ee556 = 2;
const $03dd5f7faa501890$export$9ad20e435294162a = 1;
const $03dd5f7faa501890$export$a454b3474c5ee5f5 = 0;
const $03dd5f7faa501890$export$b69c1b48ce8f83de = -1;
const $03dd5f7faa501890$export$ba7c785763a2a58f = 'BASE';
const $03dd5f7faa501890$export$e09d07f2dcff2603 = 'CHILD';
const $03dd5f7faa501890$export$1165245f61159842 = 'PARENT';
const $03dd5f7faa501890$export$8a96a83b3f957e58 = 'EPIC';
const $03dd5f7faa501890$export$c0c893ca5ccae9dd = (level)=>level;
const $03dd5f7faa501890$export$bcf91a9d8c5b0f58 = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return true;
    return numericLevel === $03dd5f7faa501890$export$a454b3474c5ee5f5;
};
const $03dd5f7faa501890$export$e415cf60723c7aae = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return false;
    return numericLevel === $03dd5f7faa501890$export$9ad20e435294162a;
};
const $03dd5f7faa501890$export$41f00a40e2ebd6e8 = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return false;
    return numericLevel === $03dd5f7faa501890$export$b69c1b48ce8f83de;
};
const $03dd5f7faa501890$export$556b686fea6fb229 = (hierarchyLevel)=>{
    if (Number(hierarchyLevel) > 0) return $03dd5f7faa501890$export$1165245f61159842;
    if (Number(hierarchyLevel) < 0) return $03dd5f7faa501890$export$e09d07f2dcff2603;
    return $03dd5f7faa501890$export$ba7c785763a2a58f;
};
const $03dd5f7faa501890$export$638ac52227e67c8 = (hierarchyLevel)=>{
    if (Number(hierarchyLevel) === 1) return $03dd5f7faa501890$export$8a96a83b3f957e58;
    if (Number(hierarchyLevel) > 1) return $03dd5f7faa501890$export$1165245f61159842;
    if (Number(hierarchyLevel) < 0) return $03dd5f7faa501890$export$e09d07f2dcff2603;
    return $03dd5f7faa501890$export$ba7c785763a2a58f;
};

});

parcelRegister("dpWCZ", function(module, exports) {

$parcel$export(module.exports, "hasEpicField", () => $95a38fe46100fd22$export$c4f57165afac73d9);
$parcel$export(module.exports, "isEpicField", () => $95a38fe46100fd22$export$3d4ac06796ffcbf4);
function $95a38fe46100fd22$export$c4f57165afac73d9(issue) {
    return issue && 'epicField' in issue;
}
function $95a38fe46100fd22$export$3d4ac06796ffcbf4(value) {
    return value && 'issueId' in value;
}

});

parcelRegister("f01qr", function(module, exports) {

$parcel$export(module.exports, "getCardListId", () => $a60ef25f21c3c03d$export$e65113cd51859079);
$parcel$export(module.exports, "sendFailToMoveAnalytic", () => $a60ef25f21c3c03d$export$a3cba232834b9a4c);
$parcel$export(module.exports, "sendSuccessToMoveAnalytic", () => $a60ef25f21c3c03d$export$8b6d119d11f4d263);
$parcel$export(module.exports, "getIdFromAri", () => $a60ef25f21c3c03d$export$79640a85913af5aa);
$parcel$export(module.exports, "isObjectArrayEqual", () => $a60ef25f21c3c03d$export$65067f0a588374c3);
$parcel$export(module.exports, "toShortCustomFieldId", () => $a60ef25f21c3c03d$export$36c037bc7f404c2);
$parcel$export(module.exports, "toArray", () => $a60ef25f21c3c03d$export$45b10814cc054894);
$parcel$export(module.exports, "getEndAnalyticsSprintActionTaken", () => $a60ef25f21c3c03d$export$2918b4b4b35c5a29);
$parcel$export(module.exports, "getCardDescriptionAsADF", () => $a60ef25f21c3c03d$export$2bd89a8dd7b6386a);

var $gccSB = parcelRequire("gccSB");

var $ajpes = parcelRequire("ajpes");

var $hGgHi = parcelRequire("hGgHi");

var $6Kx1w = parcelRequire("6Kx1w");

var $kz2lw = parcelRequire("kz2lw");

var $bPWvi = parcelRequire("bPWvi");
var $50sdg = parcelRequire("50sdg");

var $fZneA = parcelRequire("fZneA");

var $dXq4S = parcelRequire("dXq4S");

var $8zOmE = parcelRequire("8zOmE");

var $guzeq = parcelRequire("guzeq");

var $2lpqS = parcelRequire("2lpqS");
const $a60ef25f21c3c03d$export$e65113cd51859079 = (cardListId)=>{
    if (cardListId && cardListId.startsWith((0, $2lpqS.HEADER_DROPPABLE_ID_PREFIX))) return cardListId.substr((0, $2lpqS.HEADER_DROPPABLE_ID_PREFIX).length);
    if (cardListId && cardListId.startsWith((0, $2lpqS.CARD_GROUP_DROPPABLE_TYPE))) return cardListId.split('::')[2];
    if (cardListId && cardListId.startsWith((0, $2lpqS.TRANSITION_ZONE_DROPPABLE_TYPE))) return cardListId.split('::')[1];
    return cardListId;
};
const $a60ef25f21c3c03d$export$9067d4d6678cd6bc = (droppableId)=>droppableId.startsWith((0, $2lpqS.TRANSITION_ZONE_DROPPABLE_TYPE));
const $a60ef25f21c3c03d$var$getDndOperation = (srcDroppableId, destDroppableId, cardListId, isActiveSprint)=>{
    if (srcDroppableId === destDroppableId) return 0, $2lpqS.DND_OPERATION_MOVE_INSIDE_LIST;
    if (cardListId === (0, $guzeq.BACKLOG)) return 0, $2lpqS.DND_OPERATION_MOVE_TO_BACKLOG;
    if (cardListId === (0, $guzeq.BOARD)) return 0, $2lpqS.DND_OPERATION_MOVE_TO_BOARD;
    if (isActiveSprint(cardListId)) return 0, $2lpqS.DND_OPERATION_MOVE_TO_ACTIVE_SPRINT;
    return 0, $2lpqS.DND_OPERATION_MOVE_TO_FUTURE_SPRINT;
};
const $a60ef25f21c3c03d$var$getDndSource = (srcDroppableId, destDroppableId, isActiveSprint)=>{
    if (srcDroppableId === (0, $guzeq.BACKLOG)) return 0, $2lpqS.DND_DROP_ZONES_BACKLOG;
    if (srcDroppableId === (0, $guzeq.BOARD)) return 0, $2lpqS.DND_DROP_ZONES_BOARD;
    if (isActiveSprint(srcDroppableId)) return 0, $2lpqS.DND_DROP_ZONES_ACTIVE_SPRINT;
    return 0, $2lpqS.DND_DROP_ZONES_FUTURE_SPRINT;
};
const $a60ef25f21c3c03d$var$getDndDestination = (cardListId, isActiveSprint)=>{
    if (cardListId === (0, $guzeq.BACKLOG)) return 0, $2lpqS.DND_DROP_ZONES_BACKLOG;
    if (cardListId === (0, $guzeq.BOARD)) return 0, $2lpqS.DND_DROP_ZONES_BOARD;
    if (isActiveSprint(cardListId)) return 0, $2lpqS.DND_DROP_ZONES_ACTIVE_SPRINT;
    return 0, $2lpqS.DND_DROP_ZONES_FUTURE_SPRINT;
};
const $a60ef25f21c3c03d$export$a3cba232834b9a4c = (analyticsEvent, cardIds, error, cardListId, isActiveSprint)=>{
    const srcDroppableId = analyticsEvent.payload?.attributes?.source ?? '';
    const destDroppableId = analyticsEvent.payload?.attributes?.target ?? '';
    const dndSource = $a60ef25f21c3c03d$var$getDndSource(srcDroppableId, destDroppableId, isActiveSprint);
    const dndDestination = $a60ef25f21c3c03d$var$getDndDestination(cardListId, isActiveSprint);
    const dndTarget = analyticsEvent.payload?.attributes?.type ?? (0, $2lpqS.DND_TARGET_BACKLOG_CARD);
    const operation = $a60ef25f21c3c03d$var$getDndOperation(srcDroppableId, destDroppableId, cardListId, isActiveSprint);
    (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'cards moveFailed', {
        numCards: cardIds.length,
        errorMessage: error.message,
        operation: operation,
        dndDestination: dndDestination,
        dndSource: dndSource,
        dndTarget: dndTarget,
        isClientFetchError: (0, $fZneA.isClientFetchError)(error)
    });
};
const $a60ef25f21c3c03d$export$8b6d119d11f4d263 = (cardId, analyticsEvent, cardListId, isActiveSprint)=>{
    const srcDroppableId = analyticsEvent.payload?.attributes?.source ?? '';
    const destDroppableId = analyticsEvent.payload?.attributes?.target ?? '';
    const dndSource = $a60ef25f21c3c03d$var$getDndSource(srcDroppableId, destDroppableId, isActiveSprint);
    const dndDestination = $a60ef25f21c3c03d$var$getDndDestination(cardListId, isActiveSprint);
    const dndTarget = analyticsEvent.payload?.attributes?.type ?? (0, $2lpqS.DND_TARGET_BACKLOG_CARD);
    const operation = $a60ef25f21c3c03d$var$getDndOperation(srcDroppableId, destDroppableId, cardListId, isActiveSprint);
    (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'backlog updated', String(cardId), {
        operation: operation,
        dndDestination: dndDestination,
        dndSource: dndSource,
        dndTarget: dndTarget
    });
};
const $a60ef25f21c3c03d$export$79640a85913af5aa = (ari)=>{
    const possibleAri = (0, $dXq4S.toAri)(ari);
    if (possibleAri) return (0, $dXq4S.getAriConfig)(possibleAri).resourceId;
    return ari;
};
const $a60ef25f21c3c03d$export$65067f0a588374c3 = (a, b)=>(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))((0, (/*@__PURE__*/$parcel$interopDefault($6Kx1w)))(a, b, (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))));
const $a60ef25f21c3c03d$export$36c037bc7f404c2 = (customFieldId)=>{
    if (!(0, $2lpqS.CUSTOM_FIELD_ID_REGEX).test(customFieldId ?? '')) return undefined;
    const fieldId = customFieldId?.match((0, $2lpqS.CUSTOM_FIELD_ID_REGEX))?.[1];
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(fieldId)) return undefined;
    return `cf[${fieldId}]`;
};
const $a60ef25f21c3c03d$export$45b10814cc054894 = (x)=>Array.isArray(x) ? x : x.split(',');
const $a60ef25f21c3c03d$export$2918b4b4b35c5a29 = (oldValId, newValId)=>{
    if (oldValId === newValId) return;
    if (oldValId === (0, $guzeq.BACKLOG)) return newValId === (0, $guzeq.BOARD) ? (0, $2lpqS.END_ANALYTICS_BACKLOG_TO_BOARD) : (0, $2lpqS.END_ANALYTICS_ADD);
    // if oldValId is BOARD, newValId would not be sprints
    if (oldValId === (0, $guzeq.BOARD)) return 0, $2lpqS.END_ANALYTICS_BOARD_TO_BACKLOG;
    if (newValId === (0, $guzeq.BACKLOG)) return 0, $2lpqS.END_ANALYTICS_REMOVE;
    return 0, $2lpqS.END_ANALYTICS_MOVE_BETWEEN_SPRINTS;
};
const $a60ef25f21c3c03d$export$2bd89a8dd7b6386a = (content)=>{
    // empty doc node for no content
    if (!content) return (0, $kz2lw.getEmptyADF)();
    if (typeof content === 'string') return (0, $bPWvi.doc)((0, $50sdg.paragraph)(content));
    return content;
};

});
parcelRegister("6Kx1w", function(module, exports) {

var $2GdQn = parcelRequire("2GdQn");

var $g7i7g = parcelRequire("g7i7g");

var $7txx8 = parcelRequire("7txx8");

var $f3SOL = parcelRequire("f3SOL");

var $hYfgW = parcelRequire("hYfgW");
/**
 * This method is like `_.xor` except that it accepts `comparator` which is
 * invoked to compare elements of `arrays`. The order of result values is
 * determined by the order they occur in the arrays. The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.xorWith(objects, others, _.isEqual);
 * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
 */ var $4ea0a7c2fafe415b$var$xorWith = $g7i7g(function(arrays) {
    var comparator = $hYfgW(arrays);
    comparator = typeof comparator == 'function' ? comparator : undefined;
    return $7txx8($2GdQn(arrays, $f3SOL), undefined, comparator);
});
module.exports = $4ea0a7c2fafe415b$var$xorWith;

});
parcelRegister("7txx8", function(module, exports) {

var $55pzo = parcelRequire("55pzo");

var $ekcP3 = parcelRequire("ekcP3");

var $7CoLY = parcelRequire("7CoLY");
/**
 * The base implementation of methods like `_.xor`, without support for
 * iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of values.
 */ function $571540db172adafd$var$baseXor(arrays, iteratee, comparator) {
    var length = arrays.length;
    if (length < 2) return length ? $7CoLY(arrays[0]) : [];
    var index = -1, result = Array(length);
    while(++index < length){
        var array = arrays[index], othIndex = -1;
        while(++othIndex < length)if (othIndex != index) result[index] = $55pzo(result[index] || array, arrays[othIndex], iteratee, comparator);
    }
    return $7CoLY($ekcP3(result, 1), iteratee, comparator);
}
module.exports = $571540db172adafd$var$baseXor;

});


parcelRegister("kz2lw", function(module, exports) {

$parcel$export(module.exports, "getEmptyADF", () => $06167b6274ea84aa$export$d109ab46c9575565);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $ebjue = parcelRequire("ebjue");
const $06167b6274ea84aa$export$d109ab46c9575565 = ()=>({
        type: 'doc',
        version: 1,
        content: []
    });

});
parcelRegister("ebjue", function(module, exports) {

$parcel$export(module.exports, "isEmpty", () => $9e55b7d6fded4629$export$dd1bc94b04021eeb);
const $9e55b7d6fded4629$export$dd1bc94b04021eeb = (node)=>!node?.content?.length;

});


parcelRegister("bPWvi", function(module, exports) {

$parcel$export(module.exports, "doc", () => $c17b5e301ceeeae8$export$2a111da947c407d2);
const $c17b5e301ceeeae8$export$2a111da947c407d2 = (...content)=>({
        type: 'doc',
        version: 1,
        content: content
    });

});

parcelRegister("50sdg", function(module, exports) {

$parcel$export(module.exports, "paragraph", () => $b5360ede7330200d$export$9c206ddddb32a9b);

var $3lRhe = parcelRequire("3lRhe");
const $b5360ede7330200d$export$9c206ddddb32a9b = (...content)=>({
        type: 'paragraph',
        content: (0, $3lRhe.createTextNodes)(content)
    });

});
parcelRegister("3lRhe", function(module, exports) {

$parcel$export(module.exports, "createTextNodes", () => $4fbd120aea0a69b1$export$3a269a5941b62f04);

var $gBTcG = parcelRequire("gBTcG");
function $4fbd120aea0a69b1$export$3a269a5941b62f04(nodes) {
    return nodes.map($4fbd120aea0a69b1$export$72b9432ea0656b50);
}
function $4fbd120aea0a69b1$export$72b9432ea0656b50(str) {
    return typeof str === 'string' ? (0, $gBTcG.text)(str) : str;
}

});
parcelRegister("gBTcG", function(module, exports) {

$parcel$export(module.exports, "text", () => $9654feec8f8dd4ec$export$6f093cfa640b7166);
const $9654feec8f8dd4ec$export$6f093cfa640b7166 = (text)=>({
        type: 'text',
        text: text
    });

});



parcelRegister("guzeq", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_DATE_DISPLAY_FORMAT", () => $34991cd92e3fb74d$export$faf85b5ed93b0538);
$parcel$export(module.exports, "BACKLOG", () => $34991cd92e3fb74d$export$dedbdcc35e955187);
$parcel$export(module.exports, "BOARD", () => $34991cd92e3fb74d$export$9b8283d5878d2491);
$parcel$export(module.exports, "SPRINT", () => $34991cd92e3fb74d$export$a316570a0dbfd2b0);
$parcel$export(module.exports, "INACTIVE_SPRINT", () => $34991cd92e3fb74d$export$88abd69a9006b2b);
$parcel$export(module.exports, "ACTIVE_SPRINT", () => $34991cd92e3fb74d$export$2f9f63c9e8b8a7fc);
$parcel$export(module.exports, "TOP_OF_LIST", () => $34991cd92e3fb74d$export$1a271033d96c4e9a);
$parcel$export(module.exports, "BOTTOM_OF_LIST", () => $34991cd92e3fb74d$export$fe366e1b5f8f6917);
$parcel$export(module.exports, "BOTTOM_OF_CARD_GROUP", () => $34991cd92e3fb74d$export$29472abe5c298701);
$parcel$export(module.exports, "BEFORE_CARD", () => $34991cd92e3fb74d$export$6ee6fb5615cbbfaf);
$parcel$export(module.exports, "TRANSITION_ZONE", () => $34991cd92e3fb74d$export$825ad5563e6c16b4);
$parcel$export(module.exports, "NONE", () => $34991cd92e3fb74d$export$c53d0f541b41b88e);
$parcel$export(module.exports, "ISSUE_LIST", () => $34991cd92e3fb74d$export$7be7e0393bed6707);
$parcel$export(module.exports, "SPRINT_STATE_FUTURE", () => $34991cd92e3fb74d$export$1dec7a5987befb9f);
$parcel$export(module.exports, "SPRINT_STATE_ACTIVE", () => $34991cd92e3fb74d$export$91f438b1afe47b53);
$parcel$export(module.exports, "SPRINT_MOVE_TO_TOP", () => $34991cd92e3fb74d$export$c557f656e9558605);
$parcel$export(module.exports, "SPRINT_MOVE_UP", () => $34991cd92e3fb74d$export$d44a21a036e6d362);
$parcel$export(module.exports, "SPRINT_MOVE_DOWN", () => $34991cd92e3fb74d$export$c3959a41530f5d37);
$parcel$export(module.exports, "SPRINT_MOVE_TO_BOTTOM", () => $34991cd92e3fb74d$export$40b71d704f7a26b4);
$parcel$export(module.exports, "DEFAULT_PARENT_ISSUE_TYPE_NAME", () => $34991cd92e3fb74d$export$cb17e3c17bc50301);
$parcel$export(module.exports, "ESTIMATION_ROLLUP_BADGE_MAX", () => $34991cd92e3fb74d$export$b79b504ff88a1727);
$parcel$export(module.exports, "BACKLOG_LONG_TASKS_DND_MARK_NAME", () => $34991cd92e3fb74d$export$bb1ee0864c80dcde);
$parcel$export(module.exports, "SPRINT_BACKLOG_STRATEGY", () => $34991cd92e3fb74d$export$3fa2dca6095ef23a);
$parcel$export(module.exports, "ISSUE_LIST_BACKLOG_STRATEGY", () => $34991cd92e3fb74d$export$946ee3a604b332d2);
$parcel$export(module.exports, "KANBAN_BACKLOG_STRATEGY", () => $34991cd92e3fb74d$export$869ee62868d7be07);
$parcel$export(module.exports, "REFRESH_SOURCE_FAILURE", () => $34991cd92e3fb74d$export$d9d2fe902bd6d9a7);
$parcel$export(module.exports, "REFRESH_SOURCE_REALTIME", () => $34991cd92e3fb74d$export$af001fd9213b0b63);
$parcel$export(module.exports, "REFRESH_SOURCE_KANBAN_CARD_MOVE_SUCCESS", () => $34991cd92e3fb74d$export$9af8a111003cd702);
$parcel$export(module.exports, "REFRESH_SOURCE_GLOBAL_ISSUE_CREATE", () => $34991cd92e3fb74d$export$8cabdc85b8691f12);
$parcel$export(module.exports, "REFRESH_SOURCE_SPRINT_COMPLETE", () => $34991cd92e3fb74d$export$600567015cf0b58e);
$parcel$export(module.exports, "REFRESH_SOURCE_STATUS_REMAPPED", () => $34991cd92e3fb74d$export$443de2b93e4aa6c6);
$parcel$export(module.exports, "REFRESH_SOURCE_ON_MOUNT", () => $34991cd92e3fb74d$export$26392593c7297db8);
$parcel$export(module.exports, "REFRESH_SOURCE_ACTIVE_TAB", () => $34991cd92e3fb74d$export$968a5895f5ee4e93);
$parcel$export(module.exports, "REFRESH_SOURCE_POLLING", () => $34991cd92e3fb74d$export$8125ab02c04ac8e7);
$parcel$export(module.exports, "APP_ID", () => $34991cd92e3fb74d$export$d76071d5de2774fc);
$parcel$export(module.exports, "TEAM_NAME", () => $34991cd92e3fb74d$export$d57b6b390e78d90f);
$parcel$export(module.exports, "PACKAGE_NAME", () => $34991cd92e3fb74d$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "EDIT_BOARD_CONFIG", () => $34991cd92e3fb74d$export$b893894941c14e43);
$parcel$export(module.exports, "DELETE_ISSUE", () => $34991cd92e3fb74d$export$4e8756b18ce4cf17);
$parcel$export(module.exports, "CREATE_ISSUE", () => $34991cd92e3fb74d$export$a84692caf5a334ea);
$parcel$export(module.exports, "MANAGE_SPRINT", () => $34991cd92e3fb74d$export$47e89ba04d79d88d);
$parcel$export(module.exports, "EDIT_ISSUE", () => $34991cd92e3fb74d$export$52f11126cce982f0);
$parcel$export(module.exports, "VIEW_BOARD", () => $34991cd92e3fb74d$export$6fca44a139cecd72);
$parcel$export(module.exports, "ADMINISTER_BOARD", () => $34991cd92e3fb74d$export$120f9058cc2d23b7);
$parcel$export(module.exports, "BULK_CHANGE", () => $34991cd92e3fb74d$export$66cb530046350ea5);
$parcel$export(module.exports, "ASSIGN_ISSUE", () => $34991cd92e3fb74d$export$e3e5ec492e10f340);
$parcel$export(module.exports, "TRANSITION_ISSUE", () => $34991cd92e3fb74d$export$627a3f8561c04066);
$parcel$export(module.exports, "ARCHIVE_ISSUE", () => $34991cd92e3fb74d$export$84886e19f4ac5f8e);
$parcel$export(module.exports, "ISSUE_COUNT_ID", () => $34991cd92e3fb74d$export$e371c88c3137ffb);
$parcel$export(module.exports, "ESTIMATION_TYPE_ID_PREFIX", () => $34991cd92e3fb74d$export$81b5ed4ed651b2bc);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE_FIELD_ID", () => $34991cd92e3fb74d$export$d02889a654103c98);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE_ID", () => $34991cd92e3fb74d$export$4c2cf346f4d818c5);
$parcel$export(module.exports, "NUMERIC_ESTIMATE_FIELD_ID_PREFIX", () => $34991cd92e3fb74d$export$4091097a73cc5002);
$parcel$export(module.exports, "ISSUE_COUNT", () => $34991cd92e3fb74d$export$8775696968c9b13c);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE", () => $34991cd92e3fb74d$export$bfb354504bb547a0);
$parcel$export(module.exports, "STORY_POINTS", () => $34991cd92e3fb74d$export$405b6d72f2d243a9);
$parcel$export(module.exports, "REMAINING_TIME_ESTIMATE", () => $34991cd92e3fb74d$export$612ef20a8c97681f);
$parcel$export(module.exports, "statisticFieldToEstimateType", () => $34991cd92e3fb74d$export$674f0c6f9382fdff);
$parcel$export(module.exports, "statisticFieldPrefixes", () => $34991cd92e3fb74d$export$69ce8a2ab6160d00);
$parcel$export(module.exports, "GROUP_TYPE", () => $34991cd92e3fb74d$export$d5d0dfb4a0060b5a);
const $34991cd92e3fb74d$export$faf85b5ed93b0538 = 'd MMM';
const $34991cd92e3fb74d$export$dedbdcc35e955187 = 'BACKLOG';
const $34991cd92e3fb74d$export$9b8283d5878d2491 = 'BOARD';
const $34991cd92e3fb74d$export$a316570a0dbfd2b0 = 'SPRINT';
const $34991cd92e3fb74d$export$88abd69a9006b2b = 'INACTIVE_SPRINT';
const $34991cd92e3fb74d$export$2f9f63c9e8b8a7fc = 'ACTIVE_SPRINT';
const $34991cd92e3fb74d$export$1a271033d96c4e9a = 'TOP_OF_LIST';
const $34991cd92e3fb74d$export$fe366e1b5f8f6917 = 'BOTTOM_OF_LIST';
const $34991cd92e3fb74d$export$29472abe5c298701 = 'BOTTOM_OF_CARD_GROUP';
const $34991cd92e3fb74d$export$6ee6fb5615cbbfaf = 'BEFORE_CARD';
const $34991cd92e3fb74d$export$825ad5563e6c16b4 = 'TRANSITION_ZONE';
const $34991cd92e3fb74d$export$c53d0f541b41b88e = 'NONE';
const $34991cd92e3fb74d$export$7be7e0393bed6707 = 'ISSUE_LIST';
const $34991cd92e3fb74d$export$1dec7a5987befb9f = 'FUTURE';
const $34991cd92e3fb74d$export$91f438b1afe47b53 = 'ACTIVE';
const $34991cd92e3fb74d$export$c557f656e9558605 = 'SPRINT_MOVE_TO_TOP';
const $34991cd92e3fb74d$export$d44a21a036e6d362 = 'SPRINT_MOVE_UP';
const $34991cd92e3fb74d$export$c3959a41530f5d37 = 'SPRINT_MOVE_DOWN';
const $34991cd92e3fb74d$export$40b71d704f7a26b4 = 'SPRINT_MOVE_TO_BOTTOM';
const $34991cd92e3fb74d$export$cb17e3c17bc50301 = 'Epic';
const $34991cd92e3fb74d$export$b79b504ff88a1727 = 999;
const $34991cd92e3fb74d$export$bb1ee0864c80dcde = 'backlog.long-tasks-dnd';
const $34991cd92e3fb74d$export$d7ca4ead68e4382c = 'NONE';
const $34991cd92e3fb74d$export$3fa2dca6095ef23a = 'SPRINT';
const $34991cd92e3fb74d$export$946ee3a604b332d2 = 'ISSUE_LIST';
const $34991cd92e3fb74d$export$869ee62868d7be07 = 'KANBAN_BACKLOG';
const $34991cd92e3fb74d$export$d9d2fe902bd6d9a7 = 'FAILURE';
const $34991cd92e3fb74d$export$af001fd9213b0b63 = 'REALTIME';
const $34991cd92e3fb74d$export$9af8a111003cd702 = 'KANBAN_CARD_MOVE_SUCCESS';
const $34991cd92e3fb74d$export$8cabdc85b8691f12 = 'GLOBAL_ISSUE_CREATE';
const $34991cd92e3fb74d$export$600567015cf0b58e = 'SPRINT_COMPLETE';
const $34991cd92e3fb74d$export$443de2b93e4aa6c6 = 'STATUS_REMAPPED';
const $34991cd92e3fb74d$export$26392593c7297db8 = 'ON_MOUNT';
const $34991cd92e3fb74d$export$968a5895f5ee4e93 = 'ACTIVE_TAB';
const $34991cd92e3fb74d$export$8125ab02c04ac8e7 = 'POLLING';
const $34991cd92e3fb74d$export$66e48a348bf0e91e = 'ADD_ISSUE_TYPE_MODAL';
const $34991cd92e3fb74d$export$d76071d5de2774fc = 'software.backlog';
const $34991cd92e3fb74d$export$d57b6b390e78d90f = 'a4t-tanuki';
const $34991cd92e3fb74d$export$b8b9d90f9e5bd72b = '@atlassian/jira-software-backlog';
const $34991cd92e3fb74d$export$b893894941c14e43 = 'EDIT_BOARD_CONFIG';
const $34991cd92e3fb74d$export$4e8756b18ce4cf17 = 'DELETE_ISSUE';
const $34991cd92e3fb74d$export$a84692caf5a334ea = 'CREATE_ISSUE';
const $34991cd92e3fb74d$export$47e89ba04d79d88d = 'MANAGE_SPRINT';
const $34991cd92e3fb74d$export$52f11126cce982f0 = 'EDIT_ISSUE';
const $34991cd92e3fb74d$export$6fca44a139cecd72 = 'VIEW_BOARD';
const $34991cd92e3fb74d$export$120f9058cc2d23b7 = 'ADMINISTER_BOARD';
const $34991cd92e3fb74d$export$66cb530046350ea5 = 'BULK_CHANGE';
const $34991cd92e3fb74d$export$e3e5ec492e10f340 = 'ASSIGN_ISSUE';
const $34991cd92e3fb74d$export$627a3f8561c04066 = 'TRANSITION_ISSUE';
const $34991cd92e3fb74d$export$84886e19f4ac5f8e = 'ARCHIVE_ISSUE';
const $34991cd92e3fb74d$export$e371c88c3137ffb = 'issueCount_';
const $34991cd92e3fb74d$export$81b5ed4ed651b2bc = 'field_';
const $34991cd92e3fb74d$export$d02889a654103c98 = 'field_timeoriginalestimate';
const $34991cd92e3fb74d$export$4c2cf346f4d818c5 = 'timeoriginalestimate';
const $34991cd92e3fb74d$var$STORY_POINTS_ID = 'field_customfield_';
const $34991cd92e3fb74d$export$4091097a73cc5002 = 'customfield_';
const $34991cd92e3fb74d$export$8775696968c9b13c = 'ISSUE_COUNT';
const $34991cd92e3fb74d$export$bfb354504bb547a0 = 'ORIGINAL_ESTIMATE';
const $34991cd92e3fb74d$export$405b6d72f2d243a9 = 'STORY_POINTS';
const $34991cd92e3fb74d$export$612ef20a8c97681f = 'timeestimate';
const $34991cd92e3fb74d$export$674f0c6f9382fdff = {
    [$34991cd92e3fb74d$export$e371c88c3137ffb]: $34991cd92e3fb74d$export$8775696968c9b13c,
    [$34991cd92e3fb74d$export$d02889a654103c98]: $34991cd92e3fb74d$export$bfb354504bb547a0,
    [$34991cd92e3fb74d$var$STORY_POINTS_ID]: $34991cd92e3fb74d$export$405b6d72f2d243a9
};
const $34991cd92e3fb74d$export$69ce8a2ab6160d00 = [
    $34991cd92e3fb74d$export$e371c88c3137ffb,
    $34991cd92e3fb74d$export$d02889a654103c98,
    $34991cd92e3fb74d$var$STORY_POINTS_ID
];
const $34991cd92e3fb74d$export$31089ea8b3e502e3 = 'card';
const $34991cd92e3fb74d$export$d5d0dfb4a0060b5a = 'group';

});

parcelRegister("2lpqS", function(module, exports) {

$parcel$export(module.exports, "HEADER_DROPPABLE_ID_PREFIX", () => $e859f81c51db2b78$export$5e2fff92b27c1bb8);
$parcel$export(module.exports, "CARD_LIST_DROPPABLE_TYPE", () => $e859f81c51db2b78$export$afbd2d45ce529690);
$parcel$export(module.exports, "CARD_GROUP_DROPPABLE_TYPE", () => $e859f81c51db2b78$export$849c01670da437ac);
$parcel$export(module.exports, "TRANSITION_ZONE_DROPPABLE_TYPE", () => $e859f81c51db2b78$export$6e35851fe8cf8301);
$parcel$export(module.exports, "UNASSIGNED_EPIC_ID", () => $e859f81c51db2b78$export$794f07be04aca3fe);
$parcel$export(module.exports, "DND_DROP_ZONES_ACTIVE_SPRINT", () => $e859f81c51db2b78$export$adbf9ce386bc3037);
$parcel$export(module.exports, "DND_DROP_ZONES_FUTURE_SPRINT", () => $e859f81c51db2b78$export$bb216fa10db6b6bb);
$parcel$export(module.exports, "DND_DROP_ZONES_BOARD", () => $e859f81c51db2b78$export$338b523135b4db48);
$parcel$export(module.exports, "DND_DROP_ZONES_BACKLOG", () => $e859f81c51db2b78$export$f6bf4fdaad3caf69);
$parcel$export(module.exports, "DND_TARGET_BACKLOG_CARD", () => $e859f81c51db2b78$export$695859afe4db61d7);
$parcel$export(module.exports, "DND_TARGET_DIVIDER", () => $e859f81c51db2b78$export$62679ec8251801eb);
$parcel$export(module.exports, "DND_OPERATION_MOVE_INSIDE_LIST", () => $e859f81c51db2b78$export$7ade48b3d11b4061);
$parcel$export(module.exports, "DND_OPERATION_MOVE_TO_ACTIVE_SPRINT", () => $e859f81c51db2b78$export$1ffb6fb519522507);
$parcel$export(module.exports, "DND_OPERATION_MOVE_TO_FUTURE_SPRINT", () => $e859f81c51db2b78$export$f1ed61bbffc6eb2c);
$parcel$export(module.exports, "DND_OPERATION_MOVE_TO_BACKLOG", () => $e859f81c51db2b78$export$dc9b10088e3cd5b6);
$parcel$export(module.exports, "DND_OPERATION_MOVE_TO_BOARD", () => $e859f81c51db2b78$export$5b4e8a4b9c2dd508);
$parcel$export(module.exports, "END_ANALYTICS_BOARD_TO_BACKLOG", () => $e859f81c51db2b78$export$62fb2a114279723f);
$parcel$export(module.exports, "END_ANALYTICS_BACKLOG_TO_BOARD", () => $e859f81c51db2b78$export$3ea6f7062a9fdfaa);
$parcel$export(module.exports, "END_ANALYTICS_ADD", () => $e859f81c51db2b78$export$322559f654431a48);
$parcel$export(module.exports, "END_ANALYTICS_REMOVE", () => $e859f81c51db2b78$export$d57498e034486b43);
$parcel$export(module.exports, "END_ANALYTICS_MOVE_BETWEEN_SPRINTS", () => $e859f81c51db2b78$export$d1be44161c65679f);
$parcel$export(module.exports, "CARD_ROW_HEIGHT", () => $e859f81c51db2b78$export$6be26aedd8f95d5e);
$parcel$export(module.exports, "COMPACT_CARD_ROW_HEIGHT", () => $e859f81c51db2b78$export$9207e617cac36dce);
$parcel$export(module.exports, "EXTRA_CARD_ROW_HEIGHT", () => $e859f81c51db2b78$export$85b6f126b8e736d4);
$parcel$export(module.exports, "INLINE_CARD_CREATE_ROW_HEIGHT", () => $e859f81c51db2b78$export$226ce682b3342af4);
$parcel$export(module.exports, "LABELS_FIELD_SEPARATOR", () => $e859f81c51db2b78$export$e74bc8e59eb08066);
$parcel$export(module.exports, "CUSTOM_FIELD_ID_REGEX", () => $e859f81c51db2b78$export$cb26d91c4e639201);
$parcel$export(module.exports, "UNASSIGNED_USER", () => $e859f81c51db2b78$export$299e0e1e1265f5e9);

const $e859f81c51db2b78$export$5e2fff92b27c1bb8 = 'HEADER-DROP-';
const $e859f81c51db2b78$export$afbd2d45ce529690 = 'CARD';
const $e859f81c51db2b78$export$849c01670da437ac = 'CARD-GROUP';
const $e859f81c51db2b78$export$6e35851fe8cf8301 = 'TRANSITION-ZONE';
const $e859f81c51db2b78$export$794f07be04aca3fe = 0;
const $e859f81c51db2b78$export$adbf9ce386bc3037 = 'activeSprint';
const $e859f81c51db2b78$export$bb216fa10db6b6bb = 'futureSprint';
const $e859f81c51db2b78$export$3df2915b3d2a36e = 'sprint';
const $e859f81c51db2b78$export$338b523135b4db48 = 'board';
const $e859f81c51db2b78$export$f6bf4fdaad3caf69 = 'backlog';
const $e859f81c51db2b78$export$67e35e305110c91d = 'epicPanel';
const $e859f81c51db2b78$export$f95492d2a4f371d0 = 'versionPanel';
const $e859f81c51db2b78$export$2a5a5a3183150769 = 'cardGroup';
const $e859f81c51db2b78$export$695859afe4db61d7 = 'backlogCard';
const $e859f81c51db2b78$export$b1b86bcaf2a12330 = 'epicPanelCard';
const $e859f81c51db2b78$export$2e29fc7afa544ab5 = 'versionPanelCard';
const $e859f81c51db2b78$export$62679ec8251801eb = 'divider';
const $e859f81c51db2b78$export$a080ee3f8cb7aa62 = 'moveListToList';
const $e859f81c51db2b78$export$7ade48b3d11b4061 = 'moveInsideList';
const $e859f81c51db2b78$export$1ffb6fb519522507 = 'moveToActiveSprint';
const $e859f81c51db2b78$export$f1ed61bbffc6eb2c = 'moveToFutureSprint';
const $e859f81c51db2b78$export$dc9b10088e3cd5b6 = 'moveToBacklog';
const $e859f81c51db2b78$export$5b4e8a4b9c2dd508 = 'moveToBoard';
const $e859f81c51db2b78$export$41f0d8a4d1ec169b = 'cardParentSet';
const $e859f81c51db2b78$export$bc493dacb9d33787 = 'epicRankUpdate';
const $e859f81c51db2b78$export$62fb2a114279723f = 'moveFromBoardToBacklog';
const $e859f81c51db2b78$export$3ea6f7062a9fdfaa = 'moveFromBacklogToBoard';
const $e859f81c51db2b78$export$322559f654431a48 = 'add';
const $e859f81c51db2b78$export$d57498e034486b43 = 'remove';
const $e859f81c51db2b78$export$d1be44161c65679f = 'moveBetweenSprints';
const $e859f81c51db2b78$export$6be26aedd8f95d5e = 40;
const $e859f81c51db2b78$export$9207e617cac36dce = 32;
const $e859f81c51db2b78$export$85b6f126b8e736d4 = 30;
const $e859f81c51db2b78$export$226ce682b3342af4 = 40;
const $e859f81c51db2b78$export$e74bc8e59eb08066 = ', ';
const $e859f81c51db2b78$export$cb26d91c4e639201 = /^customfield_([0-9]+)$/;
const $e859f81c51db2b78$export$299e0e1e1265f5e9 = {
    id: (0, $15a528573ccd89ae$export$12e572fd459c10dc),
    displayName: '',
    avatarUrl: ''
};

});
const $15a528573ccd89ae$export$d597759d33be802e = 'TEXT';
const $15a528573ccd89ae$export$f8f7545d2bb78afb = 'ASSIGNEE';
const $15a528573ccd89ae$export$37aee82a3cb1e8f7 = 'LABEL';
const $15a528573ccd89ae$export$2a4f270075a033de = 'ISSUE_PARENT';
const $15a528573ccd89ae$export$401f4b6eda6a369c = 'ISSUE_PROJECT';
const $15a528573ccd89ae$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $15a528573ccd89ae$export$a4ad2735b021c132 = 'VERSION';
const $15a528573ccd89ae$export$af1e30ebbae9df3b = 'COMPONENT';
const $15a528573ccd89ae$export$f863b019d19144f4 = 'STATUS_CATEGORY';
const $15a528573ccd89ae$export$a316570a0dbfd2b0 = 'SPRINT';
const $15a528573ccd89ae$export$e50006273435e7d4 = 'STATUS';
const $15a528573ccd89ae$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $15a528573ccd89ae$export$68d693c35a8d8866 = 'CUSTOM_FILTER';
const $15a528573ccd89ae$export$1ea95b94fb0c51d9 = 'QUICK_FILTER';
const $15a528573ccd89ae$export$871e58afc769b358 = 'GOAL';
const $15a528573ccd89ae$export$6c4d37c7f376a1de = 'CLEAR';
const $15a528573ccd89ae$export$db362e2d293fe52e = 'DEPENDENCIES';
const $15a528573ccd89ae$export$dc9697aa7b3a6d6f = 'JQL';
const $15a528573ccd89ae$export$12e572fd459c10dc = 'unassigned';
const $15a528573ccd89ae$export$ac95b4b2317d4b33 = 'unassigned';
const $15a528573ccd89ae$export$81ef49afbbead0a1 = 'label unassigned';
const $15a528573ccd89ae$export$4b7c755e61199a36 = 'unassigned';
const $15a528573ccd89ae$export$c9408e3fb31ddc71 = 'offline';
const $15a528573ccd89ae$export$7a105aa475396c65 = 'online';





parcelRegister("9s7RG", function(module, exports) {

$parcel$export(module.exports, "useVersionsRefetch", () => $f222005a4baea078$export$869337d912ff312a);

var $4G03t = parcelRequire("4G03t");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $93BDy = parcelRequire("93BDy");
const $f222005a4baea078$export$869337d912ff312a = ()=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const boardAri = (0, $93BDy.useBoardAri)();
    return (0, $5uXOq.useCallback)((jiraProjectIds)=>(0, $8Uumt.fetchQuery)(environment, (0, $4G03t.default), {
            jiraProjectIds: jiraProjectIds,
            boardId: boardAri
        }), [
        boardAri,
        environment
    ]);
};

});
parcelRegister("4G03t", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0c70024d36539ad$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<71e0c934669eacf72bb382209e1e2b1c>>
 * @relayHash 41352733a919bb6e174a21d1321a952c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6f6f114dd8fcdf6f1814c902179bb28dbc7a6e7f69f1152e95a83a5510408968

var $i7FzY = parcelRequire("i7FzY");

var $iWXRl = parcelRequire("iWXRl");
const $c0c70024d36539ad$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "boardId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraProjectIds"
    }, v2 = {
        "kind": "Literal",
        "name": "filter",
        "value": [
            "UNRELEASED"
        ]
    }, v3 = {
        "kind": "Variable",
        "name": "jiraProjectIds",
        "variableName": "jiraProjectIds"
    }, v4 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v7 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v8 = [
        v2 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 500
        },
        v3 /*: any*/ 
    ], v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "kind": "ScalarField",
        "name": "id"
    }, v11 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ], v12 = [
        {
            "alias": "editProjectConfig",
            "args": [
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "EDIT_PROJECT_CONFIG"
                }
            ],
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": v11 /*: any*/ ,
            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useVersionsRefetchQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "alias": "versionsForProjects",
                                "args": [
                                    v2 /*: any*/ ,
                                    v3 /*: any*/ 
                                ],
                                "concreteType": "JiraVersionConnection",
                                "kind": "LinkedField",
                                "name": "__versionBacklogPanelRelay_versionsForProjects_connection",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraVersionEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "versionPanel_softwareVersionBacklogPanelRelay_jiraVersionEdges"
                                            },
                                            {
                                                "concreteType": "JiraVersion",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v4 /*: any*/ ,
                                                    v5 /*: any*/ 
                                                ]
                                            },
                                            v6 /*: any*/ 
                                        ]
                                    },
                                    v7 /*: any*/ 
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.versionsForProjects"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcvisualrefresheap2relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcismanageversionspermissionenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "useVersionsRefetchQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "concreteType": "JiraVersionConnection",
                            "kind": "LinkedField",
                            "name": "versionsForProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraVersionEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraVersion",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "description"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "status"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "startDate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "releaseDate"
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "boardId",
                                                            "variableName": "boardId"
                                                        }
                                                    ],
                                                    "concreteType": "JiraVersionStatistics",
                                                    "kind": "LinkedField",
                                                    "name": "statistics",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "doneEstimate"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "totalEstimate"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "percentageCompleted"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "notEstimated"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "done"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "totalIssueCount"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "toDo"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "inProgress"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "project",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        v10 /*: any*/ ,
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcismanageversionspermissionenabledrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": false,
                                                            "selections": v12 /*: any*/ 
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcismanageversionspermissionenabledrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "alias": "canManageVersions",
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "type",
                                                                            "value": "MANAGE_VERSIONS"
                                                                        }
                                                                    ],
                                                                    "concreteType": "JiraProjectAction",
                                                                    "kind": "LinkedField",
                                                                    "name": "action",
                                                                    "plural": false,
                                                                    "selections": v11 /*: any*/ ,
                                                                    "storageKey": "action(type:\"MANAGE_VERSIONS\")"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcvisualrefresheap2relayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": v12 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__id"
                                                        }
                                                    ]
                                                },
                                                v10 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        },
                                        v6 /*: any*/ 
                                    ]
                                },
                                v7 /*: any*/ 
                            ]
                        },
                        {
                            "args": v8 /*: any*/ ,
                            "filters": [
                                "jiraProjectIds",
                                "filter"
                            ],
                            "handle": "connection",
                            "key": "versionBacklogPanelRelay_versionsForProjects",
                            "kind": "LinkedHandle",
                            "name": "versionsForProjects"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6f6f114dd8fcdf6f1814c902179bb28dbc7a6e7f69f1152e95a83a5510408968",
            "metadata": {
                "connection": [
                    {
                        "count": null,
                        "cursor": null,
                        "direction": "forward",
                        "path": [
                            "jira",
                            "versionsForProjects"
                        ]
                    }
                ]
            },
            "name": "useVersionsRefetchQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcvisualrefresheap2relayprovider": (0, $iWXRl.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcismanageversionspermissionenabledrelayprovider": (0, $i7FzY.default)
            }
        }
    };
}();
$c0c70024d36539ad$var$node.hash = "49947aa3f8615f5dcdee393f6d3fd187";
var $c0c70024d36539ad$export$2e2bcd8739ae039 = $c0c70024d36539ad$var$node;

});
parcelRegister("i7FzY", function(module, exports) {

$parcel$export(module.exports, "default", () => $f737ff18c0579680$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $f737ff18c0579680$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('vmc-11-manage-versions-permission');
    }
};

});

parcelRegister("iWXRl", function(module, exports) {

$parcel$export(module.exports, "default", () => $6555d355a0c222e8$export$2e2bcd8739ae039);

var $dCm1o = parcelRequire("dCm1o");
var $6555d355a0c222e8$export$2e2bcd8739ae039 = {
    get () {
        return (0, $dCm1o.isVisualRefreshEnabled)();
    }
};

});


parcelRegister("93BDy", function(module, exports) {

$parcel$export(module.exports, "useBoardAri", () => $7ad70603ab4b6b31$export$f53dd1c04c0f3767);

var $dXq4S = parcelRequire("dXq4S");

var $koeKL = parcelRequire("koeKL");

var $doZTA = parcelRequire("doZTA");
const $7ad70603ab4b6b31$export$f53dd1c04c0f3767 = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const [{ match: match }] = (0, $doZTA.useRouter)();
    return (0, $dXq4S.createAri)({
        resourceOwner: 'jira-software',
        cloudId: cloudId,
        resourceType: 'board',
        resourceId: String(match.params.boardId)
    });
};

});


parcelRegister("5kotP", function(module, exports) {

$parcel$export(module.exports, "flagsMapper", () => $2643af30ba48de1c$export$4de5eb17326eea98);

var $5uXOq = parcelRequire("5uXOq");

var $alNv9 = parcelRequire("alNv9");

var $9XE6b = parcelRequire("9XE6b");

var $467lJ = parcelRequire("467lJ");

var $6c57g = parcelRequire("6c57g");

var $4cr9K = parcelRequire("4cr9K");

var $4tEQ4 = parcelRequire("4tEQ4");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $avYIL = parcelRequire("avYIL");

var $hf5c2 = parcelRequire("hf5c2");

var $8MHVw = parcelRequire("8MHVw");

var $6GNN7 = parcelRequire("6GNN7");

var $e978U = parcelRequire("e978U");

var $c0C8a = parcelRequire("c0C8a");

var $60s5X = parcelRequire("60s5X");

var $dpfT9 = parcelRequire("dpfT9");

var $7VNNI = parcelRequire("7VNNI");

var $2A04N = parcelRequire("2A04N");

var $9KRJk = parcelRequire("9KRJk");

var $aLVM6 = parcelRequire("aLVM6");

var $i9g1N = parcelRequire("i9g1N");

var $kzCvy = parcelRequire("kzCvy");

var $dS41P = parcelRequire("dS41P");

var $cen46 = parcelRequire("cen46");

var $t6MXq = parcelRequire("t6MXq");

var $jRU2X = parcelRequire("jRU2X");

var $ffuah = parcelRequire("ffuah");
const $2643af30ba48de1c$export$4de5eb17326eea98 = (action)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(action, [
        'meta',
        'optimistic',
        'type'
    ], null) === (0, $alNv9.REVERT) && (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(action, [
        'meta',
        'showGenericFlag'
    ], null) === true) return (0, $467lJ.default).genericError();
    switch(action.type){
        case 0, $hf5c2.CARD_CREATE_FILTERED:
            return (props)=>// @ts-expect-error - TS2322 - Type '{ card: Card; id: string | number; onDismissed: ((id: string | number) => void) & ((id: string | number) => void); }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<Component<Omit<{ onPrimaryActionClick: (cardId: any) => void; }, "onPrimaryActionClick">, any, any>> & Readonly<...> & Readonly<...>'.
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7VNNI.default), {
                    ...props,
                    card: action.payload
                });
        case 0, $hf5c2.CARD_CREATE_FILTERED_V2:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpfT9.default), {
                    ...props,
                    cardIds: action.payload
                });
        case 0, $6GNN7.CARD_DRAG_DISALLOWED:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aLVM6.CardDragDisallowedFlag), props);
        case 0, $e978U.FLAG_SPRINT_STARTED:
            return (0, $t6MXq.showSprintStartedFlag)();
        case 0, $4cr9K.SHOW_ERROR_FLAG_FROM_SWAG:
            return (0, $4tEQ4.extractFlagFromAction)(action);
        case 0, $hf5c2.CARD_CREATE_UNMAPPED_WITH_ISSUE_LINK:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2A04N.default), {
                    ...props,
                    cardKeys: action.payload.cardsIdentifiers.map((cardIds)=>cardIds.key),
                    ...(0, $4R6GH.fg)('show-create-success-flag-once-in-backlog-page') ? {
                        isAutoDismissed: false
                    } : {}
                });
        case 0, $hf5c2.CARD_CREATE_UNMAPPED:
            return (props)=>{
                const { payload: { cardKeys: cardKeys, numIssues: numIssues, issueTypeName: issueTypeName } } = action;
                if (cardKeys) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2A04N.default), {
                    ...props,
                    cardKeys: cardKeys
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9KRJk.default), {
                    ...props,
                    numIssues: numIssues,
                    issueTypeName: issueTypeName
                });
            };
        case 0, $8MHVw.FILTERED_CARD_FAILURE:
        case 0, $8MHVw.REFILTER_FAILURE:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS41P.default), props);
        case 0, $8MHVw.FILTERED_CARD_CLEAR_FAILURE:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kzCvy.default), props);
        case 0, $hf5c2.CARD_CREATE_GLOBAL:
            return (props)=>{
                if ((0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) {
                    const globalIssues = action.payload.globalIssues;
                    const issueType = globalIssues.length > 0 ? action.payload.globalIssues[0].createdIssueDetails?.fields.issuetype.name : undefined;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6c57g.CardCreateGlobalFlag), {
                        ...props,
                        cardKeys: action.payload.globalIssues.map((issue)=>issue.issueKey),
                        issueType: issueType,
                        ...(0, $4R6GH.fg)('show-create-success-flag-once-in-backlog-page') ? {
                            isAutoDismissed: false
                        } : {}
                    });
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6c57g.CardCreateGlobalFlag), {
                    ...props,
                    cardKeys: action.payload.globalIssues.map((issue)=>issue.issueKey),
                    ...(0, $4R6GH.fg)('show-create-success-flag-once-in-backlog-page') ? {
                        isAutoDismissed: false
                    } : {}
                });
            };
        case 0, $hf5c2.CARD_CREATE_SPLIT_ISSUE:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cen46.SplitIssueSuccessFlag), {
                    ...props,
                    originalIssueKey: action.payload.originalIssueKey,
                    issueKeys: action.payload.newIssueKeys,
                    issueTypeName: action.payload.issueTypeName
                });
        case 0, $6GNN7.CARDS_MOVE_DISABLED:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i9g1N.default), {
                    ...props,
                    boardId: action.payload.boardId,
                    isAdmin: action.payload.isAdmin
                });
        case 0, $6GNN7.CARDS_TRANSITION_AND_RANK_FAILURE:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jRU2X.TransitionAndRankFailureFlag), {
                    ...props,
                    errorMessages: action.payload.errorMessages
                });
        case 0, $avYIL.BULK_OPS_SHOW_FAILED_FLAG:
            return (props)=>{
                const { payload: payload } = action;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $60s5X.default), {
                    ...props,
                    ...payload
                });
            };
        case 0, $c0C8a.SPRINT_BOARD_LINK_CLICK_PERMISSIONLESS:
            return (0, $6s1PB.expValEquals)('surface_origin_board_on_sprint_containers', 'cohort', 'test') ? (props)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ffuah.SprintBoardPermissionlessFlag), props);
            } : undefined;
        default:
            return undefined;
    }
};

});
parcelRegister("alNv9", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.optimistic = module.exports.ensureState = module.exports.REVERT = module.exports.COMMIT = module.exports.BEGIN = undefined;
var $78924382a593567a$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $bXQuv = parcelRequire("bXQuv");
var $78924382a593567a$var$BEGIN = module.exports.BEGIN = '@@optimist/BEGIN';
var $78924382a593567a$var$COMMIT = module.exports.COMMIT = '@@optimist/COMMIT';
var $78924382a593567a$var$REVERT = module.exports.REVERT = '@@optimist/REVERT';
var $78924382a593567a$var$isOptimistState = function isOptimistState(state) {
    return state && Object.keys(state).length === 3 && state.hasOwnProperty('beforeState') && state.hasOwnProperty('history') && state.hasOwnProperty('current');
};
var $78924382a593567a$var$ensureState = module.exports.ensureState = function ensureState(state) {
    return $78924382a593567a$var$isOptimistState(state) ? state.current : state;
};
var $78924382a593567a$var$createState = function createState(state) {
    return {
        beforeState: undefined,
        history: [],
        current: state
    };
};
var $78924382a593567a$var$applyCommit = function applyCommit(state, targetActionIndex, reducer) {
    var history = state.history;
    // If the action to commit is the first in the queue (most common scenario)
    if (targetActionIndex === 0) {
        var historyWithoutCommit = history.slice(1);
        var nextOptimisticIndex = (0, $bXQuv.findIndex)(historyWithoutCommit, function(action) {
            return action.meta && action.meta.optimistic && !action.meta.optimistic.isNotOptimistic && action.meta.optimistic.id;
        });
        // If this is the only optimistic item in the queue, we're done!
        if (nextOptimisticIndex === -1) return $78924382a593567a$var$_extends({}, state, {
            history: [],
            beforeState: undefined
        });
        // Create a new history starting with the next one
        var newHistory = historyWithoutCommit.slice(nextOptimisticIndex);
        // And run every action up until that next one to get the new beforeState
        var newBeforeState = history.reduce(function(mutState, action, index) {
            return index <= nextOptimisticIndex ? reducer(mutState, action) : mutState;
        }, state.beforeState);
        return $78924382a593567a$var$_extends({}, state, {
            history: newHistory,
            beforeState: newBeforeState
        });
    } else {
        // If the committed action isn't the first in the queue, find out where it is
        var actionToCommit = history[targetActionIndex];
        // Make it a regular non-optimistic action
        var newAction = Object.assign({}, actionToCommit, {
            meta: Object.assign({}, actionToCommit.meta, {
                optimistic: null
            })
        });
        var _newHistory = state.history.slice();
        _newHistory.splice(targetActionIndex, 1, newAction);
        return $78924382a593567a$var$_extends({}, state, {
            history: _newHistory
        });
    }
};
var $78924382a593567a$var$applyRevert = function applyRevert(state, targetActionIndex, reducer) {
    var beforeState = state.beforeState, history = state.history;
    var newHistory = void 0;
    // If the action to revert is the first in the queue (most common scenario)
    if (targetActionIndex === 0) {
        var historyWithoutRevert = history.slice(1);
        var nextOptimisticIndex = (0, $bXQuv.findIndex)(historyWithoutRevert, function(action) {
            return action.meta && action.meta.optimistic && !action.meta.optimistic.isNotOptimistic && action.meta.optimistic.id;
        });
        // If this is the only optimistic action in the queue, we're done!
        if (nextOptimisticIndex === -1) return $78924382a593567a$var$_extends({}, state, {
            history: [],
            current: historyWithoutRevert.reduce(function(s, action) {
                return reducer(s, action);
            }, beforeState),
            beforeState: undefined
        });
        newHistory = historyWithoutRevert.slice(nextOptimisticIndex);
    } else {
        newHistory = history.slice();
        newHistory.splice(targetActionIndex, 1);
    }
    var newCurrent = newHistory.reduce(function(s, action) {
        return reducer(s, action);
    }, beforeState);
    return $78924382a593567a$var$_extends({}, state, {
        history: newHistory,
        current: newCurrent,
        beforeState: beforeState
    });
};
var $78924382a593567a$var$optimistic = module.exports.optimistic = function optimistic(reducer) {
    var rawConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var config = Object.assign({
        maxHistory: 100
    }, rawConfig);
    return function(state, action) {
        if (state === undefined || !$78924382a593567a$var$isOptimistState(state)) state = $78924382a593567a$var$createState(reducer($78924382a593567a$var$ensureState(state), {}));
        var historySize = state.history.length;
        var _ref = action.meta && action.meta.optimistic || {}, type = _ref.type, id = _ref.id;
        // a historySize means there is at least 1 outstanding fetch
        if (historySize) {
            if (type !== $78924382a593567a$var$COMMIT && type !== $78924382a593567a$var$REVERT) {
                if (historySize > config.maxHistory) console.error('@@optimist: Possible memory leak detected.\n                  Verify all actions result in a commit or revert and\n                  don\'t use optimistic-UI for long-running server fetches');
                // if it's a BEGIN but we already have a historySize, treat it like a non-opt
                return $78924382a593567a$var$_extends({}, state, {
                    history: state.history.concat([
                        action
                    ]),
                    current: reducer(state.current, action)
                });
            }
            var targetActionIndex = (0, $bXQuv.findIndex)(state.history, function(action) {
                return action.meta && action.meta.optimistic && action.meta.optimistic.id === id;
            });
            if (targetActionIndex === -1) throw new Error('@@optimist: Failed to ' + (type === $78924382a593567a$var$COMMIT ? 'commit' : 'revert') + '. Transaction #' + id + ' does not exist!');
            // for resolutions, add a flag so that we know it is not an optimistic action
            action.meta.optimistic.isNotOptimistic = true;
            // include the resolution in the history & current state
            var nextState = $78924382a593567a$var$_extends({}, state, {
                history: state.history.concat([
                    action
                ]),
                current: reducer(state.current, action)
            });
            var applyFunc = type === $78924382a593567a$var$COMMIT ? $78924382a593567a$var$applyCommit : $78924382a593567a$var$applyRevert;
            return applyFunc(nextState, targetActionIndex, reducer);
        }
        // create a beforeState since one doesn't already exist
        if (type === $78924382a593567a$var$BEGIN) return $78924382a593567a$var$_extends({}, state, {
            history: state.history.concat([
                action
            ]),
            current: reducer(state.current, action),
            beforeState: state.current
        });
        // standard action escape
        return $78924382a593567a$var$_extends({}, state, {
            current: reducer(state.current, action)
        });
    };
};

});
parcelRegister("bXQuv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findIndex = $8b5dec00f6be39ba$var$findIndex;
function $8b5dec00f6be39ba$var$findIndex(arr, predicate) {
    var l = arr.length;
    for(var i = 0; i < l; i++){
        if (predicate(arr[i])) return i;
    }
    return -1;
}

});


parcelRegister("467lJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc639d9ac2372482$export$2e2bcd8739ae039);

var $8BkAH = parcelRequire("8BkAH");

var $8hiuq = parcelRequire("8hiuq");

var $l7mS2 = parcelRequire("l7mS2");

var $5jDRa = parcelRequire("5jDRa");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$dc639d9ac2372482$export$2e2bcd8739ae039 = {
    forbidden: $8BkAH.default,
    genericError: $8hiuq.default,
    serverError: $l7mS2.default,
    unauthorized: $5jDRa.default
};

});
parcelRegister("8BkAH", function(module, exports) {

$parcel$export(module.exports, "default", () => $47acdb71562a5159$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $47acdb71562a5159$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.forbidden.title",
        "defaultMessage": "You don't have permission to do that"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.forbidden.description",
        "defaultMessage": "Ask your Jira admin for help."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$47acdb71562a5159$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $47acdb71562a5159$var$messages.title,
        description: $47acdb71562a5159$var$messages.description,
        messageId: 'flags.ui.configurations.errors.forbidden.flag.error',
        messageType: 'transactional'
    });

});

parcelRegister("8hiuq", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffd4533bf12eb3f1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $ffd4533bf12eb3f1$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.generic-error.title",
        "defaultMessage": "Something's gone wrong"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.generic-error.description",
        "defaultMessage": "Refresh the page and try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ffd4533bf12eb3f1$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $ffd4533bf12eb3f1$var$messages.title,
        description: $ffd4533bf12eb3f1$var$messages.description,
        messageId: 'flags.ui.configurations.errors.generic-error.flag.error',
        messageType: 'transactional'
    });

});

parcelRegister("l7mS2", function(module, exports) {

$parcel$export(module.exports, "default", () => $31a915dd4c1d2142$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $31a915dd4c1d2142$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.server-error.title",
        "defaultMessage": "We're having some trouble"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.server-error.description",
        "defaultMessage": "Something went wrong on our end. Refresh the page and try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$31a915dd4c1d2142$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $31a915dd4c1d2142$var$messages.title,
        description: $31a915dd4c1d2142$var$messages.description,
        messageId: 'flags.ui.configurations.errors.server-error.flag.error',
        messageType: 'transactional'
    });

});

parcelRegister("5jDRa", function(module, exports) {

$parcel$export(module.exports, "default", () => $8754751d720d57d4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $8754751d720d57d4$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.unauthorized.title",
        "defaultMessage": "You're logged out"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.unauthorized.description",
        "defaultMessage": "Log back in and try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8754751d720d57d4$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $8754751d720d57d4$var$messages.title,
        description: $8754751d720d57d4$var$messages.description,
        messageId: 'flags.ui.configurations.errors.unauthorized.flag.error',
        messageType: 'transactional'
    });

});


parcelRegister("6c57g", function(module, exports) {

$parcel$export(module.exports, "CardCreateGlobalFlag", () => $44cad0f844ccec7d$export$b6918b93a6420e06);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $d4xRU = parcelRequire("d4xRU");
var $3KRpp = parcelRequire("3KRpp");

var $koVbs = parcelRequire("koVbs");

var $64qgp = parcelRequire("64qgp");

var $24y3R = parcelRequire("24y3R");

var $eCbBU = parcelRequire("eCbBU");
const $44cad0f844ccec7d$var$GLOBAL_CREATE_POLLINATOR_DATA_TEST_ID = 'jira-issue-create.modal.create-form.success-flag';
const $44cad0f844ccec7d$export$b6918b93a6420e06 = ({ onDismissed: onDismissed, id: id, cardKeys: cardKeys, isAutoDismissed: isAutoDismissed = true, issueType: issueType })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isCopied, setCopied] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        let timeoutId;
        if (isCopied) timeoutId = setTimeout(()=>{
            setCopied(false);
        }, 2000);
        return ()=>{
            timeoutId && clearTimeout(timeoutId);
        };
    }, [
        isCopied
    ]);
    const issueDiscoveryUrl = (0, $24y3R.getIssueDiscoveryUrl)(cardKeys);
    const copyToClipboard = (0, $5uXOq.useCallback)(()=>{
        if ((0, $4R6GH.fg)('jfp-magma-undefined-navigator')) globalThis.navigator.clipboard.writeText(`${globalThis.window.location.origin}${issueDiscoveryUrl}`);
        else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        navigator.clipboard.writeText(`${window.location.origin}${issueDiscoveryUrl}`);
        setCopied(true);
    }, [
        issueDiscoveryUrl
    ]);
    const getFlagTitle = ()=>{
        if (cardKeys.length <= 1 && issueType && (0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return formatMessage((0, $eCbBU.default).createSuccessFlagTitleIssueTerminologyRefreshM4, {
            issueKey: cardKeys[0],
            workType: issueType
        });
        return cardKeys.length > 1 ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eCbBU.default).multiplesIssuesCreatedSuccessFlagTitleIssueTermRefresh : (0, $eCbBU.default).multiplesIssuesCreatedSuccessFlagTitle, {
            issueCount: cardKeys.length
        }) : formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eCbBU.default).createSuccessFlagTitleIssueTermRefresh : (0, $eCbBU.default).createSuccessFlagTitle, {
            issueKey: cardKeys[0]
        });
    };
    const getViewMessage = ()=>{
        if (issueType && (0, $64qgp.isWorkTypeAvgLength)(issueType) && (0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return cardKeys.length > 1 ? (0, $eCbBU.default).viewIssueLinkMultipleTextIssueTerminologyRefreshM4 : (0, $eCbBU.default).viewIssueLinkTextIssueTerminologyRefreshM4;
        if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return (0, $eCbBU.default).viewIssueLinkTextIssueTermRefresh;
        return (0, $eCbBU.default).viewIssueLinkText;
    };
    const actions = [
        {
            content: formatMessage(getViewMessage(), {
                numIssues: cardKeys.length,
                workType: issueType
            }),
            href: issueDiscoveryUrl
        },
        {
            content: isCopied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($44cad0f844ccec7d$var$CopySuccess, null, formatMessage((0, $eCbBU.default).linkCopied)) : formatMessage((0, $eCbBU.default).copyLink),
            onClick: ()=>{
                copyToClipboard();
            }
        }
    ];
    if (!isAutoDismissed && (0, $4R6GH.fg)('show-create-success-flag-once-in-backlog-page')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": $44cad0f844ccec7d$var$GLOBAL_CREATE_POLLINATOR_DATA_TEST_ID,
        "data-issue-key": cardKeys[0]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4xRU.default), {
        id: id,
        onDismissed: onDismissed,
        title: getFlagTitle(),
        actions: actions
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": $44cad0f844ccec7d$var$GLOBAL_CREATE_POLLINATOR_DATA_TEST_ID,
        "data-issue-key": cardKeys[0]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.SuccessAutoDismissFlag), {
        id: id,
        onDismissed: onDismissed,
        title: getFlagTitle(),
        actions: actions
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $44cad0f844ccec7d$var$CopySuccess = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syazy4f1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("64qgp", function(module, exports) {

$parcel$export(module.exports, "isWorkTypeAvgLength", () => $75f802d4e52cf385$export$cc4247ae0afa23ac);
const $75f802d4e52cf385$var$WORK_TYPE_AVG_LENGTH = 30;
const $75f802d4e52cf385$export$cc4247ae0afa23ac = (workType)=>workType.length < $75f802d4e52cf385$var$WORK_TYPE_AVG_LENGTH;

});

parcelRegister("24y3R", function(module, exports) {

$parcel$export(module.exports, "getIssueDiscoveryUrl", () => $ebd8351448f87226$export$852450339fdb3b37);
const $ebd8351448f87226$export$852450339fdb3b37 = (cardKeys)=>{
    if (cardKeys.length > 1) {
        const issueKeys = cardKeys.join(',');
        const jqlSearch = encodeURIComponent(`issueKey in (${issueKeys})`);
        return `/issues/?jql=${jqlSearch}`;
    }
    return `/browse/${cardKeys[0]}`;
};

});

parcelRegister("eCbBU", function(module, exports) {

$parcel$export(module.exports, "default", () => $a405eb29c4610c88$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a405eb29c4610c88$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createSuccessFlagTitle: {
        "id": "software-flags.card-create-global.create-success-flag-title",
        "defaultMessage": "You've created \"{issueKey}\" issue."
    },
    viewIssueLinkText: {
        "id": "software-flags.card-create-global.view-issue-link-text",
        "defaultMessage": "View {numIssues, plural, one {issue} other {issues}}"
    },
    multiplesIssuesCreatedSuccessFlagTitle: {
        "id": "software-flags.card-create-global.multiples-issues-created-success-flag-title",
        "defaultMessage": "You've created {issueCount, plural, one {# issue} other {# issues}}."
    },
    copyLink: {
        "id": "software-flags.card-create-global.copy-link",
        "defaultMessage": "Copy link"
    },
    linkCopied: {
        "id": "software-flags.card-create-global.link-copied",
        "defaultMessage": "Copied"
    },
    createSuccessFlagTitleIssueTermRefresh: {
        "id": "software-flags.card-create-global.create-success-flag-title-issue-term-refresh",
        "defaultMessage": "You've created \"{issueKey}\" work item."
    },
    viewIssueLinkTextIssueTermRefresh: {
        "id": "software-flags.card-create-global.view-issue-link-text-issue-term-refresh",
        "defaultMessage": "View{numIssues, plural, one {} other { work items}}"
    },
    multiplesIssuesCreatedSuccessFlagTitleIssueTermRefresh: {
        "id": "software-flags.card-create-global.multiples-issues-created-success-flag-title-issue-term-refresh",
        "defaultMessage": "You've created {issueCount, plural, one {# work item} other {# work items}}."
    },
    createSuccessFlagTitleIssueTerminologyRefreshM4: {
        "id": "software-flags.card-create-global.create-success-flag-title-issue-terminology-refresh-m4",
        "defaultMessage": "Created {workType} \"{issueKey}\""
    },
    viewIssueLinkTextIssueTerminologyRefreshM4: {
        "id": "software-flags.card-create-global.view-issue-link-text-issue-terminology-refresh-m4",
        "defaultMessage": "View {workType}"
    },
    viewIssueLinkMultipleTextIssueTerminologyRefreshM4: {
        "id": "software-flags.card-create-global.view-issue-link-multiple-text-issue-terminology-refresh-m4",
        "defaultMessage": "View work items"
    }
});

});


parcelRegister("4cr9K", function(module, exports) {

$parcel$export(module.exports, "SHOW_ERROR_FLAG_FROM_SWAG", () => $dcafaf5dc15a1c9d$export$849b6aff5e6c9763);
$parcel$export(module.exports, "showErrorFlag", () => $dcafaf5dc15a1c9d$export$dfa2148cdb92917d);
$parcel$export(module.exports, "XSRF_CHECK_FAILED", () => $dcafaf5dc15a1c9d$export$653597ecd43ee3b5);
const $dcafaf5dc15a1c9d$export$849b6aff5e6c9763 = 'SHOW_ERROR_FLAG_FROM_SWAG';
const $dcafaf5dc15a1c9d$export$dfa2148cdb92917d = (error)=>({
        type: $dcafaf5dc15a1c9d$export$849b6aff5e6c9763,
        payload: error
    });
const $dcafaf5dc15a1c9d$export$653597ecd43ee3b5 = 'XSRF_CHECK_FAILED';

});

parcelRegister("4tEQ4", function(module, exports) {

$parcel$export(module.exports, "getErrorFlag", () => $854596c2afd2e9d8$export$7a23a73c35436772);
$parcel$export(module.exports, "extractFlagFromAction", () => $854596c2afd2e9d8$export$6783b18b1c9d1ab1);

var $9XE6b = parcelRequire("9XE6b");

var $467lJ = parcelRequire("467lJ");

var $4cr9K = parcelRequire("4cr9K");

var $i5xPZ = parcelRequire("i5xPZ");

var $cNrxd = parcelRequire("cNrxd");
const $854596c2afd2e9d8$export$2cf9ab1b4d75e34e = (error)=>{
    const { graphQLErrors: graphQLErrors } = error;
    if (!graphQLErrors || graphQLErrors.length === 0) return null;
    const applicationError = graphQLErrors.find((e)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(e, [
            'extensions',
            'errorType'
        ], false));
    if (!applicationError) return null;
    return {
        errorType: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(applicationError, [
            'extensions',
            'errorType'
        ], '')
    };
};
const $854596c2afd2e9d8$export$eeae51b1c2ad1cfa = (error)=>{
    if ((0, $cNrxd.isFetchError)(error)) return {
        statusCode: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
            'statusCode'
        ], null),
        userMessage: null
    };
    const { graphQLErrors: graphQLErrors, networkError: networkError } = error;
    if (networkError) return {
        statusCode: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(networkError, [
            'statusCode'
        ], null),
        userMessage: null
    };
    if (graphQLErrors.length > 0) return {
        statusCode: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(graphQLErrors, [
            0,
            'extensions',
            'statusCode'
        ], null),
        userMessage: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(graphQLErrors, [
            0,
            'extensions',
            'userMessage'
        ], null)
    };
    return {
        statusCode: null,
        userMessage: null
    };
};
const $854596c2afd2e9d8$var$isApplicationError = (error)=>{
    const applicationError = $854596c2afd2e9d8$export$2cf9ab1b4d75e34e(error);
    return applicationError?.errorType === (0, $4cr9K.XSRF_CHECK_FAILED);
};
const $854596c2afd2e9d8$export$7a23a73c35436772 = (error)=>{
    if (!(0, $cNrxd.isFetchError)(error)) {
        // check if any error contains "errorType", and process prior to http-status-code
        if ($854596c2afd2e9d8$var$isApplicationError(error)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return {
            type: 'error',
            title: (0, $i5xPZ.default).xsrfCheckFailedTitle,
            description: (0, $i5xPZ.default).xsrfCheckFailedDescription,
            messageId: 'software-swag.services.error-to-flag.flag.error.xsrf-check-failed',
            messageType: 'transactional',
            error: error
        };
    }
    const { statusCode: httpStatusCode, userMessage: userMessage } = $854596c2afd2e9d8$export$eeae51b1c2ad1cfa(error);
    if ((httpStatusCode === 400 || httpStatusCode === 403) && userMessage) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return {
        type: 'error',
        title: (0, $467lJ.default).genericError().title,
        description: [
            (0, $i5xPZ.default).genericErrorDescription,
            {
                userMessage: userMessage
            }
        ],
        messageId: 'software-swag.services.error-to-flag.flag.error.generic-error',
        messageType: 'transactional',
        error: error
    };
    if (httpStatusCode === 401) {
        const unauthorizedError = (0, $467lJ.default).unauthorized();
        unauthorizedError.error = error;
        return unauthorizedError;
    }
    if (httpStatusCode === 403) {
        const forbiddenError = (0, $467lJ.default).forbidden();
        forbiddenError.error = error;
        return forbiddenError;
    }
    const genericError = (0, $467lJ.default).genericError();
    genericError.error = error;
    return genericError;
};
const $854596c2afd2e9d8$export$6783b18b1c9d1ab1 = (action)=>{
    const { payload: error } = action;
    if ((0, $cNrxd.isSwagError)(error) || (0, $cNrxd.isFetchError)(error)) return $854596c2afd2e9d8$export$7a23a73c35436772(error);
    // eslint-disable-next-line no-console
    console.error('Action showErrorFlag(error) contains invalid error format. \n Make sure you are using query$() or mutation$() utils from @atlassian/jira-software-swag in /rest layer');
    return undefined;
};

});
parcelRegister("i5xPZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $61a9111c121ba41d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $61a9111c121ba41d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    genericErrorDescription: {
        "id": "software-swag.common.generic-error-description",
        "defaultMessage": "{userMessage}"
    },
    xsrfCheckFailedTitle: {
        "id": "software-swag.common.xsrf-check-failed-title",
        "defaultMessage": "Our session has expired"
    },
    xsrfCheckFailedDescription: {
        "id": "software-swag.common.xsrf-check-failed-description",
        "defaultMessage": "Refresh the page and try again"
    }
});

});


parcelRegister("avYIL", function(module, exports) {

$parcel$export(module.exports, "BULK_OPS_SHOW_FAILED_FLAG", () => $c0a333a3121809e1$export$d9ef62afaf787d0f);
$parcel$export(module.exports, "bulkOpsShowFailedFlag", () => $c0a333a3121809e1$export$4a9779e37388dc91);
const $c0a333a3121809e1$export$d9ef62afaf787d0f = 'state.actions.bulk-ops-flags.BULK_OPS_SHOW_FAILED_FLAG';
const $c0a333a3121809e1$export$4a9779e37388dc91 = (payload)=>({
        type: $c0a333a3121809e1$export$d9ef62afaf787d0f,
        payload: payload
    });

});

parcelRegister("hf5c2", function(module, exports) {

$parcel$export(module.exports, "CARD_CREATE_END_OF_BACKLOG_OPTIMISTIC", () => $ba18c1f1070affea$export$3b377ab2ad221faa);
$parcel$export(module.exports, "CARD_CREATE_MULTIPLE_REQUEST", () => $ba18c1f1070affea$export$ffc92aa1986bdcac);
$parcel$export(module.exports, "CARD_CREATE_SUCCESS", () => $ba18c1f1070affea$export$f1c65160dd038544);
$parcel$export(module.exports, "CARD_CREATE_FAILURE", () => $ba18c1f1070affea$export$10f0879d5640132c);
$parcel$export(module.exports, "CARD_CREATE_FILTERED", () => $ba18c1f1070affea$export$20457ba50549c0b6);
$parcel$export(module.exports, "CARD_CREATE_FILTERED_V2", () => $ba18c1f1070affea$export$a7dcdd006d3cee32);
$parcel$export(module.exports, "CARD_CREATE_UNMAPPED", () => $ba18c1f1070affea$export$ac5655119bbf2fd5);
$parcel$export(module.exports, "CARD_CREATE_UNMAPPED_WITH_ISSUE_LINK", () => $ba18c1f1070affea$export$db85d3288a006ee9);
$parcel$export(module.exports, "CARD_CREATE_GLOBAL", () => $ba18c1f1070affea$export$7e3530b9017404ec);
$parcel$export(module.exports, "CARD_CREATE_SPLIT_ISSUE", () => $ba18c1f1070affea$export$3a82665bcf11f9d6);
$parcel$export(module.exports, "cardCreateMultipleRequest", () => $ba18c1f1070affea$export$67a60206c7a89110);
$parcel$export(module.exports, "cardCreateEndOfBacklogOptimistic", () => $ba18c1f1070affea$export$ffd447be3d58e464);
$parcel$export(module.exports, "cardCreateSuccess", () => $ba18c1f1070affea$export$b70c18d8546382b2);
$parcel$export(module.exports, "cardCreateFailure", () => $ba18c1f1070affea$export$151deebc0c103b3c);
$parcel$export(module.exports, "cardCreateFilteredV2", () => $ba18c1f1070affea$export$f1c368b5cfb9b941);
$parcel$export(module.exports, "cardCreateUnmapped", () => $ba18c1f1070affea$export$2afdf25d9071462e);
$parcel$export(module.exports, "cardCreateUnmappedWithIssueLink", () => $ba18c1f1070affea$export$7e2a2d17eb3fb542);
$parcel$export(module.exports, "cardCreateGlobal", () => $ba18c1f1070affea$export$7fd1edcce679a11d);
$parcel$export(module.exports, "splitIssueCreate", () => $ba18c1f1070affea$export$f587280de61983a7);

var $c0irb = parcelRequire("c0irb");
const $ba18c1f1070affea$export$3b377ab2ad221faa = 'state.actions.cards.create.CARD_CREATE_END_OF_BACKLOG_OPTIMISTIC';
const $ba18c1f1070affea$export$ffc92aa1986bdcac = 'state.actions.cards.create.CARD_CREATE_MULTIPLE_REQUEST';
const $ba18c1f1070affea$export$f1c65160dd038544 = 'state.actions.cards.create.CARD_CREATE_SUCCESS';
const $ba18c1f1070affea$export$10f0879d5640132c = 'state.actions.cards.create.CARD_CREATE_FAILURE';
const $ba18c1f1070affea$export$20457ba50549c0b6 = 'state.actions.cards.create.CARD_CREATE_FILTERED';
const $ba18c1f1070affea$export$a7dcdd006d3cee32 = 'state.actions.cards.create.CARD_CREATE_FILTERED_V2';
const $ba18c1f1070affea$export$ac5655119bbf2fd5 = 'state.actions.cards.create.CARD_CREATE_UNMAPPED';
const $ba18c1f1070affea$export$db85d3288a006ee9 = 'state.actions.cards.create.CARD_CREATE_UNMAPPED_WITH_ISSUE_LINK';
const $ba18c1f1070affea$export$7e3530b9017404ec = 'state.actions.cards.create.CARD_CREATE_GLOBAL';
const $ba18c1f1070affea$export$3a82665bcf11f9d6 = 'state.actions.cards.create.CARD_CREATE_SPLIT_ISSUE';
const $ba18c1f1070affea$export$67a60206c7a89110 = ({ tempIds: tempIds, summaries: summaries, typeId: typeId, typeIcon: typeIcon, parentId: parentId, fixVersions: fixVersions, insertBefore: insertBefore = null, listId: listId, storeFieldsFromCardCreateData: storeFieldsFromCardCreateData, storeFieldsFromFetchIssuesData: storeFieldsFromFetchIssuesData, analyticsEvent: analyticsEvent, descriptions: descriptions = null })=>({
        type: $ba18c1f1070affea$export$ffc92aa1986bdcac,
        payload: {
            tempIds: tempIds,
            summaries: summaries,
            typeId: typeId,
            parentId: parentId,
            typeIcon: typeIcon,
            fixVersions: fixVersions,
            insertBefore: insertBefore,
            listId: listId,
            storeFieldsFromCardCreateData: storeFieldsFromCardCreateData,
            storeFieldsFromFetchIssuesData: storeFieldsFromFetchIssuesData,
            descriptions: descriptions
        },
        meta: {
            ...(0, $c0irb.beginOptimisticUiMeta)(),
            analyticsEvent: analyticsEvent
        }
    });
const $ba18c1f1070affea$export$ffd447be3d58e464 = (changeEvent)=>({
        type: $ba18c1f1070affea$export$3b377ab2ad221faa,
        payload: {
            changeEvent: changeEvent
        }
    });
const $ba18c1f1070affea$export$b70c18d8546382b2 = (card, listId, temporaryCardId, createdWithRank, createdWithBulk, optimisticId, analyticsEvent)=>({
        type: $ba18c1f1070affea$export$f1c65160dd038544,
        payload: {
            card: card,
            listId: listId,
            temporaryCardId: temporaryCardId,
            createdWithRank: createdWithRank,
            createdWithBulk: createdWithBulk
        },
        meta: {
            ...(0, $c0irb.commitOptimisticUiMeta)(optimisticId),
            analyticsEvent: analyticsEvent
        }
    });
const $ba18c1f1070affea$export$151deebc0c103b3c = (numCards, optimisticId, errorMessage, statusCode, isClientFetchError = false, analyticsEvent)=>({
        type: $ba18c1f1070affea$export$10f0879d5640132c,
        meta: {
            ...(0, $c0irb.revertOptimisticUiMeta)(optimisticId),
            analyticsEvent: analyticsEvent
        },
        payload: {
            numCards: numCards,
            errorMessage: errorMessage,
            statusCode: statusCode,
            isClientFetchError: isClientFetchError
        }
    });
const $ba18c1f1070affea$export$f069b59557af9611 = (card)=>({
        type: $ba18c1f1070affea$export$20457ba50549c0b6,
        payload: card
    });
const $ba18c1f1070affea$export$f1c368b5cfb9b941 = (cardIds)=>({
        type: $ba18c1f1070affea$export$a7dcdd006d3cee32,
        payload: cardIds
    });
const $ba18c1f1070affea$export$2afdf25d9071462e = (numIssues, cardKeys, optimisticId, issueTypeName, analyticsEvent)=>({
        type: $ba18c1f1070affea$export$ac5655119bbf2fd5,
        payload: {
            numIssues: numIssues,
            cardKeys: cardKeys,
            issueTypeName: issueTypeName
        },
        meta: {
            ...(0, $c0irb.revertOptimisticUiMeta)(optimisticId),
            analyticsEvent: analyticsEvent
        }
    });
const $ba18c1f1070affea$export$7e2a2d17eb3fb542 = (cardsIdentifiers)=>({
        type: $ba18c1f1070affea$export$db85d3288a006ee9,
        payload: {
            cardsIdentifiers: cardsIdentifiers
        }
    });
const $ba18c1f1070affea$export$7fd1edcce679a11d = (globalIssues)=>({
        type: $ba18c1f1070affea$export$7e3530b9017404ec,
        payload: {
            globalIssues: globalIssues
        }
    });
const $ba18c1f1070affea$export$f587280de61983a7 = (originalIssueKey, newIssueKeys, issueTypeName)=>({
        type: $ba18c1f1070affea$export$3a82665bcf11f9d6,
        payload: {
            originalIssueKey: originalIssueKey,
            newIssueKeys: newIssueKeys,
            issueTypeName: issueTypeName
        }
    });

});
parcelRegister("c0irb", function(module, exports) {

$parcel$export(module.exports, "beginOptimisticUiMeta", () => $dc00a23f33d26d32$export$ebf02a95198109b6);
$parcel$export(module.exports, "commitOptimisticUiMeta", () => $dc00a23f33d26d32$export$76fabd640a0893d7);
$parcel$export(module.exports, "revertOptimisticUiMeta", () => $dc00a23f33d26d32$export$732172a3c90c9446);
$parcel$export(module.exports, "revertOptimisticUiWithFlagMeta", () => $dc00a23f33d26d32$export$62b48e9d9fa388fd);
$parcel$export(module.exports, "revertOptimisticUiWithDisabledFlagMeta", () => $dc00a23f33d26d32$export$b28d028621480a59);

var $alNv9 = parcelRequire("alNv9");

var $7Jxgt = parcelRequire("7Jxgt");

const $dc00a23f33d26d32$export$afc40f9cba31cfb3 = 'OPTIMISTIC_REVERT_FLAG';
// This is a temporary key for SSR until we can verify when we server render the backlog content
const $dc00a23f33d26d32$var$getUniqueId = ()=>(0, $cdb023d06c7f62fa$export$19d68f5aa485d903) ? 'ssr-unique-id' : (0, $7Jxgt.v4)();
const $dc00a23f33d26d32$export$ebf02a95198109b6 = ()=>({
        optimistic: {
            type: (0, $alNv9.BEGIN),
            id: $dc00a23f33d26d32$var$getUniqueId()
        }
    });
const $dc00a23f33d26d32$export$76fabd640a0893d7 = (optimisticId)=>({
        optimistic: {
            type: (0, $alNv9.COMMIT),
            id: optimisticId
        }
    });
const $dc00a23f33d26d32$export$732172a3c90c9446 = (optimisticId)=>({
        optimistic: {
            type: (0, $alNv9.REVERT),
            id: optimisticId
        }
    });
const $dc00a23f33d26d32$export$62b48e9d9fa388fd = (optimisticId)=>({
        optimistic: {
            type: (0, $alNv9.REVERT),
            id: optimisticId
        },
        showGenericFlag: true
    });
const $dc00a23f33d26d32$export$b28d028621480a59 = (optimisticId)=>({
        optimistic: {
            type: (0, $alNv9.REVERT),
            id: optimisticId
        },
        showGenericFlag: false
    });

});
// This constant will be true on entry-fs (modern SSR) bundles and false on jira-fe-gateway (legacy SSR) and client bundles
const $cdb023d06c7f62fa$export$19d68f5aa485d903 = false;



parcelRegister("8MHVw", function(module, exports) {

$parcel$export(module.exports, "FILTERED_CARD_REQUEST", () => $1a641115eaf94368$export$4bd6c1b43abf609);
$parcel$export(module.exports, "filteredCardsRequest", () => $1a641115eaf94368$export$f3f4ad1fd3672b39);
$parcel$export(module.exports, "FILTERED_CARD_SUCCESS", () => $1a641115eaf94368$export$8f5834f2d50f84b5);
$parcel$export(module.exports, "filteredCardsSuccess", () => $1a641115eaf94368$export$aa1ef8dc8bb1be1b);
$parcel$export(module.exports, "FILTERED_CARD_FAILURE", () => $1a641115eaf94368$export$a17483c6b4ef650d);
$parcel$export(module.exports, "filteredCardsFailed", () => $1a641115eaf94368$export$8357ffeaf5f8e6b8);
$parcel$export(module.exports, "FILTERED_CARD_CLEAR_SUCCESS", () => $1a641115eaf94368$export$40b57191c66adf76);
$parcel$export(module.exports, "clearFilteredCardsSuccess", () => $1a641115eaf94368$export$f614b38cfc8bdee4);
$parcel$export(module.exports, "FILTERED_CARD_CLEAR_FAILURE", () => $1a641115eaf94368$export$deb9be1fa48a7771);
$parcel$export(module.exports, "clearFilteredCardsFailed", () => $1a641115eaf94368$export$aaedb9c3d66fff54);
$parcel$export(module.exports, "FILTERED_CARD_CLEAR_REQUEST", () => $1a641115eaf94368$export$55f9625eb5f081fe);
$parcel$export(module.exports, "clearFilteredCardsRequest", () => $1a641115eaf94368$export$1eb5e229a2675c22);
$parcel$export(module.exports, "FILTERED_CARD_CLEAR", () => $1a641115eaf94368$export$507d49f4a5857f49);
$parcel$export(module.exports, "clearFilteredCards", () => $1a641115eaf94368$export$81b4fe421a8e6fe4);
$parcel$export(module.exports, "REFILTER_SUCCESS", () => $1a641115eaf94368$export$4d3b992e541cd8ce);
$parcel$export(module.exports, "refilterSuccess", () => $1a641115eaf94368$export$a76ad4df662ec1fb);
$parcel$export(module.exports, "REFILTER_FAILURE", () => $1a641115eaf94368$export$f09f82741fa84c27);
$parcel$export(module.exports, "refilterFailure", () => $1a641115eaf94368$export$138c508cb95b66c3);
const $1a641115eaf94368$export$4bd6c1b43abf609 = 'state.actions.cards.filtered-cards.FILTERED_CARD_REQUEST';
const $1a641115eaf94368$export$f3f4ad1fd3672b39 = (issueIds, analyticsEvent, customFilterIds)=>({
        type: $1a641115eaf94368$export$4bd6c1b43abf609,
        payload: {
            issueIds: issueIds,
            customFilterIds: customFilterIds
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $1a641115eaf94368$export$8f5834f2d50f84b5 = 'state.actions.cards.filtered-cards.FILTERED_CARD_SUCCESS';
const $1a641115eaf94368$export$aa1ef8dc8bb1be1b = (cardIds, numCustomFiltersApplied, numIssueIds, analyticsEvent)=>({
        type: $1a641115eaf94368$export$8f5834f2d50f84b5,
        payload: cardIds,
        meta: {
            analyticsEvent: analyticsEvent,
            numCustomFiltersApplied: numCustomFiltersApplied,
            numIssueIds: numIssueIds
        }
    });
const $1a641115eaf94368$export$a17483c6b4ef650d = 'state.actions.cards.filtered-cards.FILTERED_CARD_FAILURE';
const $1a641115eaf94368$export$8357ffeaf5f8e6b8 = (error, analyticsEvent)=>({
        type: $1a641115eaf94368$export$a17483c6b4ef650d,
        payload: {
            error: error
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $1a641115eaf94368$export$40b57191c66adf76 = 'state.actions.cards.filtered-cards.FILTERED_CARD_CLEAR_SUCCESS';
const $1a641115eaf94368$export$f614b38cfc8bdee4 = (analyticsEvent)=>({
        type: $1a641115eaf94368$export$40b57191c66adf76,
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $1a641115eaf94368$export$deb9be1fa48a7771 = 'state.actions.cards.filtered-cards.FILTERED_CARD_CLEAR_FAILURE';
const $1a641115eaf94368$export$aaedb9c3d66fff54 = (error, analyticsEvent)=>({
        type: $1a641115eaf94368$export$deb9be1fa48a7771,
        payload: {
            error: error
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $1a641115eaf94368$export$55f9625eb5f081fe = 'state.actions.cards.filtered-cards.FILTERED_CARD_CLEAR_REQUEST';
const $1a641115eaf94368$export$1eb5e229a2675c22 = (analyticsEvent)=>({
        type: $1a641115eaf94368$export$55f9625eb5f081fe,
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $1a641115eaf94368$export$507d49f4a5857f49 = 'state.actions.cards.filtered-cards.FILTERED_CARD_CLEAR';
const $1a641115eaf94368$export$81b4fe421a8e6fe4 = ()=>({
        type: $1a641115eaf94368$export$507d49f4a5857f49
    });
const $1a641115eaf94368$export$4d3b992e541cd8ce = 'state.actions.cards.filtered-cards.REFILTER_SUCCESS';
const $1a641115eaf94368$export$a76ad4df662ec1fb = (excludedCardIds, filteredCardIds)=>({
        type: $1a641115eaf94368$export$4d3b992e541cd8ce,
        payload: {
            excludedCardIds: excludedCardIds,
            filteredCardIds: filteredCardIds
        }
    });
const $1a641115eaf94368$export$f09f82741fa84c27 = 'state.actions.cards.filtered-cards.REFILTER_FAILURE';
const $1a641115eaf94368$export$138c508cb95b66c3 = (error)=>({
        type: $1a641115eaf94368$export$f09f82741fa84c27,
        payload: {
            error: error
        }
    });

});

parcelRegister("6GNN7", function(module, exports) {

$parcel$export(module.exports, "CARDS_MOVE", () => $6badb4c03b3b2474$export$b33d2f47990782ba);
$parcel$export(module.exports, "cardsMove", () => $6badb4c03b3b2474$export$68ae240377a1a3d7);
$parcel$export(module.exports, "CARDS_MOVE_REQUEST", () => $6badb4c03b3b2474$export$e13d64a2ffca3097);
$parcel$export(module.exports, "cardsMoveRequest", () => $6badb4c03b3b2474$export$798efca6e002e359);
$parcel$export(module.exports, "CARDS_MOVE_NON_OPTIMISTIC_REQUEST", () => $6badb4c03b3b2474$export$6ae1b17e1807f013);
$parcel$export(module.exports, "cardsMoveNonOptimisticRequest", () => $6badb4c03b3b2474$export$c581f6c48c739c84);
$parcel$export(module.exports, "CARDS_MOVE_SUCCESS", () => $6badb4c03b3b2474$export$1b15bd4898d41956);
$parcel$export(module.exports, "cardsMoveSuccess", () => $6badb4c03b3b2474$export$d9bd27fc2155921d);
$parcel$export(module.exports, "CARDS_MOVE_FAILURE", () => $6badb4c03b3b2474$export$cfcb4c2d7a25be3d);
$parcel$export(module.exports, "cardsMoveFailure", () => $6badb4c03b3b2474$export$418f4abeb5fa5e63);
$parcel$export(module.exports, "CARDS_TRANSITION_AND_RANK_FAILURE", () => $6badb4c03b3b2474$export$f9b68831e6b4477c);
$parcel$export(module.exports, "cardsTransitionAndRankFailure", () => $6badb4c03b3b2474$export$46bbdf3a931c511);
$parcel$export(module.exports, "cardsMoveCancel", () => $6badb4c03b3b2474$export$1d737d00c97bf50e);
$parcel$export(module.exports, "CARDS_MOVE_SET", () => $6badb4c03b3b2474$export$b807c0f117e6382c);
$parcel$export(module.exports, "cardsMoveSet", () => $6badb4c03b3b2474$export$106b66132b61ee71);
$parcel$export(module.exports, "CARDS_MOVE_DISABLED", () => $6badb4c03b3b2474$export$93dd8120f4a8e5e9);
$parcel$export(module.exports, "cardsMoveDisabled", () => $6badb4c03b3b2474$export$426568831df3d9fb);
$parcel$export(module.exports, "CARD_DRAG_DISALLOWED", () => $6badb4c03b3b2474$export$98c6114056f9246b);
$parcel$export(module.exports, "cardDragDisallowed", () => $6badb4c03b3b2474$export$a6e3bd55037d34be);

var $c0irb = parcelRequire("c0irb");
const $6badb4c03b3b2474$export$b33d2f47990782ba = 'state.actions.cards.move.CARDS_MOVE';
const $6badb4c03b3b2474$export$68ae240377a1a3d7 = (payload, analyticsEvent)=>({
        type: $6badb4c03b3b2474$export$b33d2f47990782ba,
        payload: payload,
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $6badb4c03b3b2474$export$e13d64a2ffca3097 = 'state.actions.cards.move.CARDS_MOVE_REQUEST';
const $6badb4c03b3b2474$export$798efca6e002e359 = (payload, analyticsEvent)=>({
        type: $6badb4c03b3b2474$export$e13d64a2ffca3097,
        payload: payload,
        meta: {
            analyticsEvent: analyticsEvent,
            ...(0, $c0irb.beginOptimisticUiMeta)()
        }
    });
const $6badb4c03b3b2474$export$6ae1b17e1807f013 = 'state.actions.cards.move.CARDS_MOVE_NON_OPTIMISTIC_REQUEST';
const $6badb4c03b3b2474$export$c581f6c48c739c84 = (optimisticId, payload, analyticsEvent)=>({
        type: $6badb4c03b3b2474$export$6ae1b17e1807f013,
        payload: payload,
        meta: {
            optimisticId: optimisticId,
            analyticsEvent: analyticsEvent
        }
    });
const $6badb4c03b3b2474$export$1b15bd4898d41956 = 'state.actions.cards.move.CARDS_MOVE_SUCCESS';
const $6badb4c03b3b2474$export$d9bd27fc2155921d = (optimisticId, cardIds, cardListId, analyticsEvent, targetStatusId)=>({
        type: $6badb4c03b3b2474$export$1b15bd4898d41956,
        payload: {
            cardIds: cardIds,
            cardListId: cardListId,
            targetStatusId: targetStatusId
        },
        meta: {
            analyticsEvent: analyticsEvent,
            ...(0, $c0irb.commitOptimisticUiMeta)(optimisticId)
        }
    });
const $6badb4c03b3b2474$export$cfcb4c2d7a25be3d = 'state.actions.cards.move.CARDS_MOVE_FAILURE';
const $6badb4c03b3b2474$export$418f4abeb5fa5e63 = (optimisticId, cardIds, cardListId, analyticsEvent, error)=>({
        type: $6badb4c03b3b2474$export$cfcb4c2d7a25be3d,
        payload: {
            cardIds: cardIds,
            cardListId: cardListId,
            error: error
        },
        meta: {
            analyticsEvent: analyticsEvent,
            ...(0, $c0irb.revertOptimisticUiWithFlagMeta)(optimisticId)
        }
    });
const $6badb4c03b3b2474$export$f9b68831e6b4477c = 'CARDS_TRANSITION_AND_RANK_FAILURE';
const $6badb4c03b3b2474$export$46bbdf3a931c511 = (optimisticId, errorMessages, analyticsEvent)=>({
        type: $6badb4c03b3b2474$export$f9b68831e6b4477c,
        payload: {
            errorMessages: errorMessages
        },
        meta: {
            analyticsEvent: analyticsEvent,
            ...(0, $c0irb.revertOptimisticUiWithDisabledFlagMeta)(optimisticId)
        }
    });
const $6badb4c03b3b2474$export$705d22119d4bbfd3 = 'state.actions.cards.move.CARDS_MOVE_CANCEL';
const $6badb4c03b3b2474$export$1d737d00c97bf50e = (optimisticId, analyticsEvent)=>({
        type: $6badb4c03b3b2474$export$705d22119d4bbfd3,
        meta: {
            analyticsEvent: analyticsEvent,
            ...(0, $c0irb.revertOptimisticUiMeta)(optimisticId)
        }
    });
const $6badb4c03b3b2474$export$b807c0f117e6382c = 'state.actions.cards.move.CARDS_MOVE_SET';
const $6badb4c03b3b2474$export$106b66132b61ee71 = (payload)=>({
        type: $6badb4c03b3b2474$export$b807c0f117e6382c,
        payload: payload
    });
const $6badb4c03b3b2474$export$93dd8120f4a8e5e9 = 'state.actions.cards.move.CARDS_MOVE_DISABLED';
const $6badb4c03b3b2474$export$426568831df3d9fb = (optimisticId, analyticsEvent, boardId, isAdmin)=>({
        type: $6badb4c03b3b2474$export$93dd8120f4a8e5e9,
        payload: {
            boardId: boardId,
            isAdmin: isAdmin
        },
        meta: {
            analyticsEvent: analyticsEvent,
            ...(0, $c0irb.revertOptimisticUiWithDisabledFlagMeta)(optimisticId)
        }
    });
const $6badb4c03b3b2474$export$98c6114056f9246b = 'state.actions.cards.move.CARD_DRAG_DISALLOWED';
const $6badb4c03b3b2474$export$a6e3bd55037d34be = ()=>({
        type: $6badb4c03b3b2474$export$98c6114056f9246b
    });

});

parcelRegister("e978U", function(module, exports) {

$parcel$export(module.exports, "FLAG_SPRINT_STARTED", () => $b5a409985e3b6a97$export$694f8ba06b56ee81);
$parcel$export(module.exports, "showSprintStartedFlagAction", () => $b5a409985e3b6a97$export$10698da25970db59);
const $b5a409985e3b6a97$export$694f8ba06b56ee81 = 'state.actions.sprints.start.FLAG_SPRINT_STARTED';
const $b5a409985e3b6a97$export$10698da25970db59 = ()=>({
        type: $b5a409985e3b6a97$export$694f8ba06b56ee81
    });

});

parcelRegister("c0C8a", function(module, exports) {

$parcel$export(module.exports, "SPRINT_BOARD_LINK_CLICK", () => $3c07bbf35f9361b3$export$93f3e9c4546cc942);
$parcel$export(module.exports, "SPRINT_BOARD_LINK_CLICK_PERMISSIONLESS", () => $3c07bbf35f9361b3$export$ed77660614bd217f);
$parcel$export(module.exports, "SPRINT_BOARD_LINK_CLICK_SUCCESS", () => $3c07bbf35f9361b3$export$a2ec988d2bb787bc);
$parcel$export(module.exports, "SPRINT_BOARD_LINK_CLICK_FAILURE", () => $3c07bbf35f9361b3$export$a7149fdf07d055ab);
$parcel$export(module.exports, "sprintBoardLinkPermissionlessFlagRequest", () => $3c07bbf35f9361b3$export$635b13ce99113f9b);
$parcel$export(module.exports, "sprintBoardLinkClickRequest", () => $3c07bbf35f9361b3$export$dd4479d50763a10b);
$parcel$export(module.exports, "sprintBoardLinkClickSuccess", () => $3c07bbf35f9361b3$export$3c7e71942386aeac);
$parcel$export(module.exports, "sprintBoardLinkClickFailure", () => $3c07bbf35f9361b3$export$58c0684d82892a6d);

var $c0irb = parcelRequire("c0irb");
const $3c07bbf35f9361b3$export$93f3e9c4546cc942 = 'state.actions.sprints.board-link-click';
const $3c07bbf35f9361b3$export$ed77660614bd217f = 'state.actions.sprints.board-link-click.permissionless-flag';
const $3c07bbf35f9361b3$export$a2ec988d2bb787bc = 'state.actions.sprints.board-link-click.success';
const $3c07bbf35f9361b3$export$a7149fdf07d055ab = 'state.actions.sprints.board-link-click.failure';
const $3c07bbf35f9361b3$export$635b13ce99113f9b = (analyticsEvent)=>({
        type: $3c07bbf35f9361b3$export$ed77660614bd217f,
        payload: {},
        meta: {
            ...(0, $c0irb.beginOptimisticUiMeta)(),
            analyticsEvent: analyticsEvent
        }
    });
const $3c07bbf35f9361b3$export$dd4479d50763a10b = (rapidViewId, analyticsEvent)=>({
        type: $3c07bbf35f9361b3$export$93f3e9c4546cc942,
        payload: {
            rapidViewId: rapidViewId
        },
        meta: {
            ...(0, $c0irb.beginOptimisticUiMeta)(),
            analyticsEvent: analyticsEvent
        }
    });
const $3c07bbf35f9361b3$export$3c7e71942386aeac = (analyticsEvent)=>({
        type: $3c07bbf35f9361b3$export$a2ec988d2bb787bc,
        payload: {},
        meta: {
            ...(0, $c0irb.beginOptimisticUiMeta)(),
            analyticsEvent: analyticsEvent
        }
    });
const $3c07bbf35f9361b3$export$58c0684d82892a6d = (analyticsEvent)=>({
        type: $3c07bbf35f9361b3$export$a7149fdf07d055ab,
        payload: {},
        meta: {
            ...(0, $c0irb.beginOptimisticUiMeta)(),
            analyticsEvent: analyticsEvent
        }
    });

});

parcelRegister("60s5X", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3e92fd24fb3750c$export$2e2bcd8739ae039);

var $aB8eX = parcelRequire("aB8eX");

var $8QpSo = parcelRequire("8QpSo");

var $bC2fB = parcelRequire("bC2fB");

var $4mqko = parcelRequire("4mqko");

var $dGljH = parcelRequire("dGljH");

var $iXH87 = parcelRequire("iXH87");
const $f3e92fd24fb3750c$var$mapDispatchToProps = (dispatch, { failedActionBuilders: failedActionBuilders, onDismissed: onDismissed, id: flagId, failedIssueKeys: failedIssueKeys, failedBatchIds: failedBatchIds })=>({
        onRetry: ()=>{
            onDismissed?.(flagId);
            if (failedActionBuilders.length < 1) return;
            const action = (0, $aB8eX.batchActions)(failedActionBuilders.map((f)=>{
                const builtAction = f();
                return {
                    ...builtAction,
                    meta: {
                        ...builtAction.meta,
                        failedBatchIds: failedBatchIds
                    }
                };
            }));
            dispatch(action);
        },
        onSelectFailedItems: (getCardIdFromCardKey)=>{
            onDismissed?.(flagId);
            const failedCardIds = failedIssueKeys.map((key)=>getCardIdFromCardKey(key));
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            dispatch((0, $4mqko.cardMultiSelect)(failedCardIds));
        }
    });
const $f3e92fd24fb3750c$var$onSelectFailedItemsFactory = (0, $8QpSo.default)((getCardIdFromCardKey, onSelectFailedItems)=>()=>onSelectFailedItems(getCardIdFromCardKey));
const $f3e92fd24fb3750c$var$onViewSummaryFactory = (0, $8QpSo.default)((failedIssueKeys, onDismissed, flagId)=>()=>{
        const cardKeys = failedIssueKeys.join(',');
        const jqlSearch = encodeURIComponent(`issueKey in (${cardKeys})`);
        const url = `/issues/?jql=${jqlSearch}`;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.open(url, '_blank');
        onDismissed?.(flagId);
    });
const $f3e92fd24fb3750c$export$9d1611c77c2fe928 = ({ getCardIdFromCardKey: getCardIdFromCardKey }, { onRetry: onRetry, onSelectFailedItems: onSelectFailedItems }, { failedActionBuilders: failedActions, failedIssueKeys: failedIssueKeys, id: flagId, onDismissed: onDismissed, failedBatchIds: failedBatchIds, failureReason: failureReason, ...restOwnProps })=>{
    const hasReachedRetryLimit = failedBatchIds && failedBatchIds?.length > 2;
    const shouldShowRetryButton = failedActions.length > 0 && !hasReachedRetryLimit && failureReason !== 'validation';
    const shouldShowViewSummaryButton = failureReason !== 'network' || failureReason === 'network' && !hasReachedRetryLimit;
    const shouldShowSelectFailedItemsButton = failureReason === 'validation';
    const shouldShowHelpButton = hasReachedRetryLimit && failureReason !== 'network' && failureReason !== 'validation';
    return {
        failedCount: failedIssueKeys.length,
        onRetry: onRetry,
        onSelectFailedItems: $f3e92fd24fb3750c$var$onSelectFailedItemsFactory(getCardIdFromCardKey, onSelectFailedItems),
        onViewSummary: $f3e92fd24fb3750c$var$onViewSummaryFactory(failedIssueKeys, onDismissed, flagId),
        showRetryButton: shouldShowRetryButton,
        showViewSummaryButton: shouldShowViewSummaryButton,
        showSelectFailedItemsButton: shouldShowSelectFailedItemsButton,
        showLearnMoreButton: !!shouldShowHelpButton,
        id: flagId,
        failureReason: failureReason,
        onDismissed: onDismissed,
        ...restOwnProps
    };
};
const $f3e92fd24fb3750c$var$mapStateToProps = (state)=>({
        getCardIdFromCardKey: (0, $dGljH.makeCardIdFromCardKey)(state)
    });
var $f3e92fd24fb3750c$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($f3e92fd24fb3750c$var$mapStateToProps, $f3e92fd24fb3750c$var$mapDispatchToProps, $f3e92fd24fb3750c$export$9d1611c77c2fe928)((0, $iXH87.default));

});
parcelRegister("4mqko", function(module, exports) {

$parcel$export(module.exports, "CARD_CLICK", () => $9b08934ab8e0c5b7$export$1f7bc7dd5a83e5d6);
$parcel$export(module.exports, "cardClick", () => $9b08934ab8e0c5b7$export$e7d364bce6e7eb03);
$parcel$export(module.exports, "PARENT_CLICK", () => $9b08934ab8e0c5b7$export$3c3fc48f596a8caf);
$parcel$export(module.exports, "parentClick", () => $9b08934ab8e0c5b7$export$5b3ee90f81d7c287);
$parcel$export(module.exports, "CARD_TOGGLE_SELECTION", () => $9b08934ab8e0c5b7$export$5f8bf17701529b20);
$parcel$export(module.exports, "cardToggleSelection", () => $9b08934ab8e0c5b7$export$bf1970aeeba42166);
$parcel$export(module.exports, "CARD_EMPTY_SELECTION", () => $9b08934ab8e0c5b7$export$9aba3277bb9b4f3);
$parcel$export(module.exports, "cardEmptySelection", () => $9b08934ab8e0c5b7$export$9bbdebcbf6166d18);
$parcel$export(module.exports, "CARD_SINGLE_SELECT", () => $9b08934ab8e0c5b7$export$c68d63d54996a817);
$parcel$export(module.exports, "cardSingleSelect", () => $9b08934ab8e0c5b7$export$9df5a921382fd88e);
$parcel$export(module.exports, "CARD_MULTI_SELECT", () => $9b08934ab8e0c5b7$export$674d868bde506f3c);
$parcel$export(module.exports, "cardMultiSelect", () => $9b08934ab8e0c5b7$export$43cca0fb4ffd3a83);
$parcel$export(module.exports, "SET_LAST_SELECTED_CARD_KEY", () => $9b08934ab8e0c5b7$export$c355c5f11b814fa5);
$parcel$export(module.exports, "setLastSelectedCardKey", () => $9b08934ab8e0c5b7$export$7cfa242c22a8bfdd);
$parcel$export(module.exports, "CARD_CLEAR_RELATIVE_CARD", () => $9b08934ab8e0c5b7$export$2310cdad67e30ee6);
$parcel$export(module.exports, "cardClearRelativeCard", () => $9b08934ab8e0c5b7$export$74e6e8a2495983f2);
$parcel$export(module.exports, "CARD_MULTI_SELECT_EXTEND", () => $9b08934ab8e0c5b7$export$73624cc5484d682a);
$parcel$export(module.exports, "cardMultiSelectExtend", () => $9b08934ab8e0c5b7$export$651e3bf6aa397b17);
$parcel$export(module.exports, "CARD_MULTI_REMOVE", () => $9b08934ab8e0c5b7$export$3311b2d7e3ec44e9);
$parcel$export(module.exports, "cardMultiRemove", () => $9b08934ab8e0c5b7$export$f44e863d2e71da4a);
const $9b08934ab8e0c5b7$export$1f7bc7dd5a83e5d6 = 'state.actions.cards.selection.CARD_CLICK';
const $9b08934ab8e0c5b7$export$e7d364bce6e7eb03 = (cardId, withCmd, withShift, withCheckbox, fireSelectionAnalytics, externalAction)=>({
        type: $9b08934ab8e0c5b7$export$1f7bc7dd5a83e5d6,
        payload: {
            cardId: cardId,
            withCmd: withCmd,
            withShift: withShift,
            withCheckbox: withCheckbox,
            fireSelectionAnalytics: fireSelectionAnalytics,
            externalAction: externalAction
        }
    });
const $9b08934ab8e0c5b7$export$3c3fc48f596a8caf = 'state.actions.cards.selection.PARENT_CLICK';
const $9b08934ab8e0c5b7$export$5b3ee90f81d7c287 = (cardId)=>({
        type: $9b08934ab8e0c5b7$export$3c3fc48f596a8caf,
        payload: {
            cardId: cardId
        }
    });
const $9b08934ab8e0c5b7$export$5f8bf17701529b20 = 'state.actions.cards.selection.CARD_TOGGLE_SELECTION';
const $9b08934ab8e0c5b7$export$bf1970aeeba42166 = (cardId)=>({
        type: $9b08934ab8e0c5b7$export$5f8bf17701529b20,
        payload: {
            cardId: cardId
        }
    });
const $9b08934ab8e0c5b7$export$9aba3277bb9b4f3 = 'state.actions.cards.selection.CARD_EMPTY_SELECTION';
const $9b08934ab8e0c5b7$export$9bbdebcbf6166d18 = ()=>({
        type: $9b08934ab8e0c5b7$export$9aba3277bb9b4f3
    });
const $9b08934ab8e0c5b7$export$c68d63d54996a817 = 'state.actions.cards.selection.CARD_SINGLE_SELECT';
const $9b08934ab8e0c5b7$export$9df5a921382fd88e = (cardId)=>({
        type: $9b08934ab8e0c5b7$export$c68d63d54996a817,
        payload: {
            cardId: cardId
        }
    });
const $9b08934ab8e0c5b7$export$674d868bde506f3c = 'state.actions.cards.selection.CARD_MULTI_SELECT';
const $9b08934ab8e0c5b7$export$43cca0fb4ffd3a83 = (cardIds)=>({
        type: $9b08934ab8e0c5b7$export$674d868bde506f3c,
        payload: {
            cardIds: cardIds
        }
    });
const $9b08934ab8e0c5b7$export$c355c5f11b814fa5 = 'state.actions.cards.selection.SET_LAST_SELECTED_CARD_KEY';
const $9b08934ab8e0c5b7$export$7cfa242c22a8bfdd = (cardKey)=>({
        type: $9b08934ab8e0c5b7$export$c355c5f11b814fa5,
        payload: {
            cardKey: cardKey
        }
    });
const $9b08934ab8e0c5b7$export$2310cdad67e30ee6 = 'state.actions.cards.selection.CARD_CLEAR_RELATIVE_CARD';
const $9b08934ab8e0c5b7$export$74e6e8a2495983f2 = ()=>({
        type: $9b08934ab8e0c5b7$export$2310cdad67e30ee6
    });
const $9b08934ab8e0c5b7$export$73624cc5484d682a = 'state.actions.cards.selection.CARD_MULTI_SELECT_EXTEND';
const $9b08934ab8e0c5b7$export$651e3bf6aa397b17 = (cardIds)=>({
        type: $9b08934ab8e0c5b7$export$73624cc5484d682a,
        payload: {
            cardIds: cardIds
        }
    });
const $9b08934ab8e0c5b7$export$3311b2d7e3ec44e9 = 'state.actions.cards.selection.CARD_MULTI_REMOVE';
const $9b08934ab8e0c5b7$export$f44e863d2e71da4a = (cardIds)=>({
        type: $9b08934ab8e0c5b7$export$3311b2d7e3ec44e9,
        payload: {
            cardIds: cardIds
        }
    });

});

parcelRegister("dGljH", function(module, exports) {

$parcel$export(module.exports, "getCardLists", () => $5ed71ca496f4aade$export$75be3facf1d769f7);
$parcel$export(module.exports, "getCards", () => $5ed71ca496f4aade$export$bc61c71d8347e4d9);
$parcel$export(module.exports, "isBacklogEmptySelector", () => $5ed71ca496f4aade$export$77a8abb93bb2e730);
$parcel$export(module.exports, "getCardListsKeys", () => $5ed71ca496f4aade$export$b0ebc690fddac876);
$parcel$export(module.exports, "getCardsCount", () => $5ed71ca496f4aade$export$4bb6cca38ab53750);
$parcel$export(module.exports, "makeGetCardAssignee", () => $5ed71ca496f4aade$export$b6f335c8997a1343);
$parcel$export(module.exports, "getCardColor", () => $5ed71ca496f4aade$export$49e99cd9a6ce8b74);
$parcel$export(module.exports, "getCardEpicColor", () => $5ed71ca496f4aade$export$dc5c6effc654e62c);
$parcel$export(module.exports, "makeGetCardTypeHierarchyLevel", () => $5ed71ca496f4aade$export$66175bb0467d3f5b);
$parcel$export(module.exports, "hasCardExtraFields", () => $5ed71ca496f4aade$export$962651073dd96b20);
$parcel$export(module.exports, "getCardExtraFields", () => $5ed71ca496f4aade$export$f338837bff9d7477);
$parcel$export(module.exports, "getCardListCount", () => $5ed71ca496f4aade$export$d63ed38773ad2770);
$parcel$export(module.exports, "getOrderedCardIdsByCardListId", () => $5ed71ca496f4aade$export$3593c0292d4c2e0b);
$parcel$export(module.exports, "makeOrderedCardIdsByCardListIdExcludingSubtasks", () => $5ed71ca496f4aade$export$91f28e45d69d8c3c);
$parcel$export(module.exports, "getOrderedCardListIds", () => $5ed71ca496f4aade$export$5895481c46e9779a);
$parcel$export(module.exports, "getOrderedCardIdsByCardListIdWithLimit", () => $5ed71ca496f4aade$export$5e8030258431459d);
$parcel$export(module.exports, "makeOrderedCardIdsByCardListIdWithLimitExcludingSubtasks", () => $5ed71ca496f4aade$export$c9e173fcee586682);
$parcel$export(module.exports, "getSelectedCards", () => $5ed71ca496f4aade$export$ad9f3c6d3dd8c300);
$parcel$export(module.exports, "getLastSelectedCardKey", () => $5ed71ca496f4aade$export$c30df5b31e28112c);
$parcel$export(module.exports, "getDetailViewData", () => $5ed71ca496f4aade$export$401c35958b2ae848);
$parcel$export(module.exports, "getListSelectionRelativeCard", () => $5ed71ca496f4aade$export$aa636ff49e4c9964);
$parcel$export(module.exports, "getFocusedCard", () => $5ed71ca496f4aade$export$10aea3ed8ea28af7);
$parcel$export(module.exports, "isFilteredCardsLoading", () => $5ed71ca496f4aade$export$eadf838276efbfae);
$parcel$export(module.exports, "isCardSelected", () => $5ed71ca496f4aade$export$a67ae423fb9ea0f9);
$parcel$export(module.exports, "getCardAutoScroll", () => $5ed71ca496f4aade$export$4eeaff5dde2f423b);
$parcel$export(module.exports, "getActiveCard", () => $5ed71ca496f4aade$export$c090658018e2f5dc);
$parcel$export(module.exports, "getActiveCardKey", () => $5ed71ca496f4aade$export$1542f5de67e48825);
$parcel$export(module.exports, "getActiveCardAssignee", () => $5ed71ca496f4aade$export$1b32fabbb013793a);
$parcel$export(module.exports, "cardsSelector", () => $5ed71ca496f4aade$export$c6ca016832785256);
$parcel$export(module.exports, "getCardIds", () => $5ed71ca496f4aade$export$841def0f013aa3d3);
$parcel$export(module.exports, "isDetailViewOpenWithAnySelectedCardSelector", () => $5ed71ca496f4aade$export$9e2c1554ae605d31);
$parcel$export(module.exports, "getOrderedAssignees", () => $5ed71ca496f4aade$export$793179e0c0778f7d);
$parcel$export(module.exports, "getOrderedLabels", () => $5ed71ca496f4aade$export$2777f818bf992a42);
$parcel$export(module.exports, "getOrderedVersions", () => $5ed71ca496f4aade$export$d35c7777091af15b);
$parcel$export(module.exports, "getOrderedCardTypes", () => $5ed71ca496f4aade$export$7fd50a0e5f559f3a);
$parcel$export(module.exports, "getLastSelectedCard", () => $5ed71ca496f4aade$export$66743788dd4e9bd8);
$parcel$export(module.exports, "willDetailViewShow", () => $5ed71ca496f4aade$export$e6b4eade500df666);
$parcel$export(module.exports, "makeCardKeyFromCardId", () => $5ed71ca496f4aade$export$588fddef6c4ed7f9);
$parcel$export(module.exports, "makeCardIdFromCardKey", () => $5ed71ca496f4aade$export$10cabd141980d8a2);
$parcel$export(module.exports, "makeOrderedVisibleCardsForCardList", () => $5ed71ca496f4aade$export$869d157a8342f44f);
$parcel$export(module.exports, "makeOrderedVisibleCardsExcludingSubtasksForCardList", () => $5ed71ca496f4aade$export$488409900307c7a6);
$parcel$export(module.exports, "makeOrderedVisibleCardsExcludingSubtasksForCardListWithLimit", () => $5ed71ca496f4aade$export$b544e9d18cad6c7d);
$parcel$export(module.exports, "getFilteredOrderedCardIdsByCardListId", () => $5ed71ca496f4aade$export$338dee38ad2f42f6);
$parcel$export(module.exports, "makeOrderVisibleCardIdsForCardListWithLimit", () => $5ed71ca496f4aade$export$d5b2e72cab21ec54);
$parcel$export(module.exports, "shouldShowDetailView", () => $5ed71ca496f4aade$export$786319817f19c360);
$parcel$export(module.exports, "makeOrderedVisibleCardIdsForCardList", () => $5ed71ca496f4aade$export$c24a16d8eafb7cff);
$parcel$export(module.exports, "makeOrderedVisibleCardEntriesOld", () => $5ed71ca496f4aade$export$b3426d0830bb4960);
$parcel$export(module.exports, "getExpandedCardGroups", () => $5ed71ca496f4aade$export$d2f7dc3ebc256192);
$parcel$export(module.exports, "makeGetCardGroupExpanded", () => $5ed71ca496f4aade$export$e3846ee85e6596cc);
$parcel$export(module.exports, "getParentIdByChildIdSelector", () => $5ed71ca496f4aade$export$8f9f740048610b66);
$parcel$export(module.exports, "getChildIdsByParentIdSelector", () => $5ed71ca496f4aade$export$63ae7bac909d8340);
$parcel$export(module.exports, "makeGetCardHierarchyLevel", () => $5ed71ca496f4aade$export$c0ec2d5d5f08d6fd);
$parcel$export(module.exports, "makeGetOrderedCardEntries", () => $5ed71ca496f4aade$export$e8229a391aa249b1);
$parcel$export(module.exports, "makeGetAllAttachedToParentCardGroupEntries", () => $5ed71ca496f4aade$export$8187607852c1fedc);
$parcel$export(module.exports, "makeOrderedVisibleCardEntries", () => $5ed71ca496f4aade$export$f4b996b8eaed63ba);
$parcel$export(module.exports, "makeGetVisibleCardOrderFromCardEntries", () => $5ed71ca496f4aade$export$2a0bb0de1d232830);
$parcel$export(module.exports, "getVisibleCardIds", () => $5ed71ca496f4aade$export$ef62d40ffc479d23);
$parcel$export(module.exports, "makeIsCardVisible", () => $5ed71ca496f4aade$export$6b61f32266c676c3);
$parcel$export(module.exports, "makeIsCardOnBoard", () => $5ed71ca496f4aade$export$325317470b38c674);
$parcel$export(module.exports, "makeGetCardListIdByCardId", () => $5ed71ca496f4aade$export$44b7fd430cc830af);
$parcel$export(module.exports, "makeGetFastVirtualListMinimumOffSetByCardListId", () => $5ed71ca496f4aade$export$9436834ba11ae17a);
$parcel$export(module.exports, "makeGetCardListAnalyticsTypeById", () => $5ed71ca496f4aade$export$ab100b26d47e733e);
$parcel$export(module.exports, "makeGetTopCardIdFromCardList", () => $5ed71ca496f4aade$export$57205cd918d1a471);
$parcel$export(module.exports, "makeGetBottomCardIdFromCardList", () => $5ed71ca496f4aade$export$c30c77f267ed58fa);
$parcel$export(module.exports, "hasCardTypesSelector", () => $5ed71ca496f4aade$export$a1e0feed5c998c95);
$parcel$export(module.exports, "getCollapsedCardLists", () => $5ed71ca496f4aade$export$14682dc3868ac2f2);
$parcel$export(module.exports, "makeIsCardListCollapsed", () => $5ed71ca496f4aade$export$48519a9ef4b7246c);
$parcel$export(module.exports, "getVisibleCardListIds", () => $5ed71ca496f4aade$export$a23657169ef5c959);
$parcel$export(module.exports, "getVisibleSprintCardLists", () => $5ed71ca496f4aade$export$277d12d0ad2acbb1);
$parcel$export(module.exports, "isAnyOptimisticCardList", () => $5ed71ca496f4aade$export$44ac769c42548b1);
$parcel$export(module.exports, "makeGetNextCardListId", () => $5ed71ca496f4aade$export$91ea52aeac57cc52);
$parcel$export(module.exports, "getFlattenOrderedCardIds", () => $5ed71ca496f4aade$export$9fc808638e14d4f0);
$parcel$export(module.exports, "makeIsCardListDisabled", () => $5ed71ca496f4aade$export$b40f586b1b1b5b3d);
$parcel$export(module.exports, "makeGetMaxColumnLimit", () => $5ed71ca496f4aade$export$86fa3555538a1895);
$parcel$export(module.exports, "makeGetMinColumnLimit", () => $5ed71ca496f4aade$export$daddaca8cdd663b3);
$parcel$export(module.exports, "validFilterValuesSelector", () => $5ed71ca496f4aade$export$a3e606d31ce14076);
$parcel$export(module.exports, "hasInvalidFilterValuesSelector", () => $5ed71ca496f4aade$export$e5ce012c8ff94f67);
$parcel$export(module.exports, "selectedCardsForVersionsPanelSelector", () => $5ed71ca496f4aade$export$116ea4e15b17d748);
$parcel$export(module.exports, "selectedPartialCardsWithTypeHierarchyLevelSelector", () => $5ed71ca496f4aade$export$97279e04a1cfee44);
$parcel$export(module.exports, "partialCardsFromCardIdsSelector", () => $5ed71ca496f4aade$export$cb1654a9ed6d9099);
$parcel$export(module.exports, "cardsForFlagWithCommentModalFromCardIdsSelector", () => $5ed71ca496f4aade$export$9656edc7cd965e96);
$parcel$export(module.exports, "numTotalIssueChildren", () => $5ed71ca496f4aade$export$1b6edd941a4eaddd);
$parcel$export(module.exports, "numCompleteIssueChildren", () => $5ed71ca496f4aade$export$18ec94fe8e415ca5);
$parcel$export(module.exports, "getKeyByIdForAllIssueTypes", () => $5ed71ca496f4aade$export$ebb887ede9b3994e);
$parcel$export(module.exports, "getIdByKeyForAllIssueTypes", () => $5ed71ca496f4aade$export$8d7d30d4816f6177);
$parcel$export(module.exports, "getCardIdWithAboveICCOpen", () => $5ed71ca496f4aade$export$7170cae353180463);
$parcel$export(module.exports, "hasICCOpen", () => $5ed71ca496f4aade$export$8f8d79952e8c1b8f);
$parcel$export(module.exports, "getAllCardIdsIncludingIssueParents", () => $5ed71ca496f4aade$export$ee56c425125d2ef6);
$parcel$export(module.exports, "getCardListStats", () => $5ed71ca496f4aade$export$22d153c4cb386f10);
$parcel$export(module.exports, "shouldRenderRichElements", () => $5ed71ca496f4aade$export$6450c8aec6d3b414);
$parcel$export(module.exports, "makeGetDefaultRowSize", () => $5ed71ca496f4aade$export$454eae1b4bd66f70);
$parcel$export(module.exports, "getDefaultCardHeight", () => $5ed71ca496f4aade$export$697c63a5f8659c9);
$parcel$export(module.exports, "getIsCardListDragInProgress", () => $5ed71ca496f4aade$export$ac2362f84ffb1564);
$parcel$export(module.exports, "getIsDragging", () => $5ed71ca496f4aade$export$59261b5a26c04c00);
$parcel$export(module.exports, "makeGetSourceCardListId", () => $5ed71ca496f4aade$export$a62ade440fb97a7a);
$parcel$export(module.exports, "makeGetSourceCardGroupId", () => $5ed71ca496f4aade$export$f787c700d21c234a);
$parcel$export(module.exports, "cardVersionsSelector", () => $5ed71ca496f4aade$export$2b8ccf236ef3c2ad);
$parcel$export(module.exports, "getFirstNonEmptyCardListId", () => $5ed71ca496f4aade$export$10c1cb90425eb140);
$parcel$export(module.exports, "backlogHasFlaggedCards", () => $5ed71ca496f4aade$export$91d6529e043b6231);
$parcel$export(module.exports, "backlogHasPriority", () => $5ed71ca496f4aade$export$df669897ce3195c6);
$parcel$export(module.exports, "backlogHasDueDate", () => $5ed71ca496f4aade$export$41cf0539676d3407);
$parcel$export(module.exports, "backlogHasStoryPoints", () => $5ed71ca496f4aade$export$242c58db4e305622);
$parcel$export(module.exports, "backlogHasEstimates", () => $5ed71ca496f4aade$export$261deb4fe884b0a1);
$parcel$export(module.exports, "getNumberOfCardsWithDueDates", () => $5ed71ca496f4aade$export$8983c3cdc7e8c1a5);
$parcel$export(module.exports, "getLastNonEmptyCardListId", () => $5ed71ca496f4aade$export$5bab56d9e503125d);
$parcel$export(module.exports, "makeGetDraggingCardIds", () => $5ed71ca496f4aade$export$eb5d19e26822928b);
$parcel$export(module.exports, "getCheckboxSelectionMode", () => $5ed71ca496f4aade$export$f8a371c4dafe2836);

var $7uUwQ = parcelRequire("7uUwQ");

var $dGvGJ = parcelRequire("dGvGJ");

var $hm7zS = parcelRequire("hm7zS");

var $k8IPx = parcelRequire("k8IPx");

var $hIkqU = parcelRequire("hIkqU");

var $9XE6b = parcelRequire("9XE6b");

var $fn8B5 = parcelRequire("fn8B5");

var $4wVpT = parcelRequire("4wVpT");

var $gccSB = parcelRequire("gccSB");

var $hGgHi = parcelRequire("hGgHi");

var $dPSWJ = parcelRequire("dPSWJ");

var $fEeCa = parcelRequire("fEeCa");

var $gJBT6 = parcelRequire("gJBT6");

var $fr1K2 = parcelRequire("fr1K2");

var $icGZu = parcelRequire("icGZu");

var $iThRn = parcelRequire("iThRn");

var $2nvJN = parcelRequire("2nvJN");

var $kGsr8 = parcelRequire("kGsr8");

var $3JOCw = parcelRequire("3JOCw");

var $8O7FC = parcelRequire("8O7FC");

var $g4tDr = parcelRequire("g4tDr");

var $g5X3G = parcelRequire("g5X3G");


var $4R6GH = parcelRequire("4R6GH");

var $2lpqS = parcelRequire("2lpqS");

var $f6RVN = parcelRequire("f6RVN");

var $guzeq = parcelRequire("guzeq");


var $ee1tL = parcelRequire("ee1tL");

var $jG5HW = parcelRequire("jG5HW");

var $74oBv = parcelRequire("74oBv");

var $e5nhF = parcelRequire("e5nhF");

var $l9VFH = parcelRequire("l9VFH");

var $fmuR9 = parcelRequire("fmuR9");

var $9ZuIF = parcelRequire("9ZuIF");

var $fpDLy = parcelRequire("fpDLy");
const $5ed71ca496f4aade$export$75be3facf1d769f7 = (state)=>(0, $e5nhF.getEntities)(state).cardList;
const $5ed71ca496f4aade$export$bc61c71d8347e4d9 = (state)=>(0, $e5nhF.getEntities)(state).card;
const $5ed71ca496f4aade$export$77a8abb93bb2e730 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9
], (cards)=>Object.keys(cards).length === 0);
const $5ed71ca496f4aade$export$b0ebc690fddac876 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$75be3facf1d769f7
], (cardLists)=>Object.keys(cardLists));
const $5ed71ca496f4aade$export$4bb6cca38ab53750 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9
], (cards)=>Object.keys(cards).length);
const $5ed71ca496f4aade$var$getCardById = (cards, cardId)=>cards[String(cardId)];
const $5ed71ca496f4aade$export$b6f335c8997a1343 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9
], (cards)=>(cardId)=>{
        const card = cards[cardId];
        return card ? card.assignee : null;
    });
const $5ed71ca496f4aade$export$49e99cd9a6ce8b74 = (state, cardId)=>{
    const cards = $5ed71ca496f4aade$export$bc61c71d8347e4d9(state);
    const color = $5ed71ca496f4aade$var$getCardById(cards, cardId)?.color;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(color) || (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))((0, (/*@__PURE__*/$parcel$interopDefault($2nvJN)))(color))) return undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($2nvJN)))(color);
};
const $5ed71ca496f4aade$export$dc5c6effc654e62c = (state, cardId)=>{
    const cards = $5ed71ca496f4aade$export$bc61c71d8347e4d9(state);
    const color = $5ed71ca496f4aade$var$getCardById(cards, cardId)?.epicColor;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(color) || (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))((0, (/*@__PURE__*/$parcel$interopDefault($2nvJN)))(color))) return undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($2nvJN)))(color);
};
const $5ed71ca496f4aade$export$66175bb0467d3f5b = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9,
    (0, $fmuR9.getIssueParents),
    (0, $74oBv.getBaseLevelCardTypes)
], (cards, parents, allCardTypes)=>(cardId)=>{
        const card = cards[cardId];
        if (card) {
            const cardType = allCardTypes.find((it)=>it.id === card.typeId);
            return cardType?.typeHierarchyLevel ?? (0, $g4tDr.BASE_HIERARCHY_TYPE);
        }
        const parent = parents[cardId];
        return parent ? (0, $g4tDr.PARENT_HIERARCHY_TYPE) : (0, $g4tDr.BASE_HIERARCHY_TYPE);
    });
const $5ed71ca496f4aade$export$962651073dd96b20 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9
], (cards)=>(0, (/*@__PURE__*/$parcel$interopDefault($icGZu)))(cards, (card)=>card?.extraFields ? card.extraFields.length > 0 : false));
const $5ed71ca496f4aade$export$f338837bff9d7477 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9
], (cards)=>{
    const extraFieldsMap = new Map();
    Object.values(cards).forEach((card)=>{
        card.extraFields?.forEach((field)=>extraFieldsMap.set(field.id, field));
    });
    return Array.from(extraFieldsMap.values());
});
const $5ed71ca496f4aade$export$d63ed38773ad2770 = (state)=>{
    const { cardList: cardList } = (0, $e5nhF.getEntities)(state);
    return Object.keys(cardList).length;
};
const $5ed71ca496f4aade$export$3593c0292d4c2e0b = (state)=>(0, $e5nhF.getEntities)(state).cardOrder;
const $5ed71ca496f4aade$export$85056ee91e64823a = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$3593c0292d4c2e0b
], (orderedCardIdsByCardListId)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((cardListId)=>orderedCardIdsByCardListId?.[cardListId] || []));
const $5ed71ca496f4aade$export$91f28e45d69d8c3c = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9,
    $5ed71ca496f4aade$export$3593c0292d4c2e0b
], (allCards, orderedCardIdsByCardListId)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((cardListId)=>{
        const cardIds = orderedCardIdsByCardListId?.[cardListId];
        if (!cardIds) return [];
        return cardIds.filter((cardId)=>!(0, $g4tDr.isSubtaskHierarchyLevel)(allCards[String(cardId)]?.typeHierarchyLevel));
    }));
const $5ed71ca496f4aade$export$70f41e60f354f620 = (cardOrder, cardListOrder, limit = 50)=>{
    let currentCount = 0;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const truncatedCardIds = {};
    cardListOrder.forEach((listId)=>{
        const cardIds = cardOrder[listId];
        if (!cardIds) return;
        const remaining = limit - currentCount;
        const sliceAmount = Math.min(remaining, cardIds.length);
        const firstCards = cardIds.slice(0, sliceAmount);
        truncatedCardIds[listId] = firstCards;
        currentCount += sliceAmount;
    });
    return truncatedCardIds;
};
const $5ed71ca496f4aade$export$5895481c46e9779a = (state)=>(0, $e5nhF.getEntities)(state).cardListOrder;
const $5ed71ca496f4aade$export$5e8030258431459d = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$3593c0292d4c2e0b,
    $5ed71ca496f4aade$export$5895481c46e9779a
], (cardOrder, cardListOrder)=>$5ed71ca496f4aade$export$70f41e60f354f620(cardOrder, cardListOrder));
const $5ed71ca496f4aade$export$c9e173fcee586682 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9,
    $5ed71ca496f4aade$export$3593c0292d4c2e0b,
    $5ed71ca496f4aade$export$5895481c46e9779a
], (allCards, orderedCardIdsByCardListId, cardListOrder)=>{
    const initialResult = $5ed71ca496f4aade$export$70f41e60f354f620(orderedCardIdsByCardListId, cardListOrder);
    const result = {};
    cardListOrder.forEach((cardListId)=>{
        const cardIds = initialResult[cardListId] ?? [];
        result[cardListId] = cardIds.filter((cardId)=>!(0, $g4tDr.isSubtaskHierarchyLevel)(allCards[String(cardId)].typeHierarchyLevel));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((cardListId)=>result[cardListId] ?? []);
});
const $5ed71ca496f4aade$export$ad9f3c6d3dd8c300 = (state)=>state.ui.cards.selected;
const $5ed71ca496f4aade$export$c30df5b31e28112c = (state)=>state.ui.cards.lastSelectedCardKey;
const $5ed71ca496f4aade$export$401c35958b2ae848 = (state)=>state.ui.detailView;
const $5ed71ca496f4aade$export$aa636ff49e4c9964 = (state)=>state.ui.cards.listSelectionRelativeCard;
const $5ed71ca496f4aade$export$10aea3ed8ea28af7 = (state)=>state.ui.cards.focused;
const $5ed71ca496f4aade$export$5496a8bd76ac3cc7 = (state)=>state.ui.cards.filteredCards.filteredCardsIds;
const $5ed71ca496f4aade$export$eadf838276efbfae = (state)=>state.ui.cards.filteredCards.isLoading;
const $5ed71ca496f4aade$export$73a0d145c861a8f6 = (state)=>state.ui.cards.fields.isStatusFieldsHidden;
const $5ed71ca496f4aade$export$62270500eeccff2a = (state)=>state.ui.cards.fields.isVersionFieldsHidden;
const $5ed71ca496f4aade$export$f96a2f7628e75ad2 = (state)=>state.ui.cards.fields.isEpicFieldsHidden;
const $5ed71ca496f4aade$export$a67ae423fb9ea0f9 = (0, $dGvGJ.createSelector)($5ed71ca496f4aade$export$ad9f3c6d3dd8c300, (selectedCards)=>(cardId)=>selectedCards.includes(cardId));
const $5ed71ca496f4aade$export$4eeaff5dde2f423b = (state)=>state.ui.cards.autoScroll;
const $5ed71ca496f4aade$export$c090658018e2f5dc = (state)=>{
    const focusedCard = $5ed71ca496f4aade$export$10aea3ed8ea28af7(state);
    if (focusedCard !== null) return focusedCard;
    const selectedCards = $5ed71ca496f4aade$export$ad9f3c6d3dd8c300(state);
    return selectedCards[selectedCards.length - 1];
};
const $5ed71ca496f4aade$export$1542f5de67e48825 = (state)=>{
    const activeCardId = $5ed71ca496f4aade$export$c090658018e2f5dc(state);
    const allCards = $5ed71ca496f4aade$export$bc61c71d8347e4d9(state);
    return allCards[String(activeCardId)] && allCards[String(activeCardId)].key;
};
const $5ed71ca496f4aade$export$1b32fabbb013793a = (state)=>{
    const activeCardId = $5ed71ca496f4aade$export$c090658018e2f5dc(state);
    const allCards = $5ed71ca496f4aade$export$bc61c71d8347e4d9(state);
    return allCards[String(activeCardId)] && allCards[String(activeCardId)].assignee;
};
const $5ed71ca496f4aade$export$c6ca016832785256 = (0, $dGvGJ.createSelector)($5ed71ca496f4aade$export$bc61c71d8347e4d9, (cards)=>Object.values(cards));
const $5ed71ca496f4aade$export$841def0f013aa3d3 = (0, $dGvGJ.createSelector)($5ed71ca496f4aade$export$c6ca016832785256, (cards)=>cards.map((card)=>card.id));
const $5ed71ca496f4aade$export$9e2c1554ae605d31 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$401c35958b2ae848,
    $5ed71ca496f4aade$export$ad9f3c6d3dd8c300
], (detailView, selectedCards)=>detailView && selectedCards.indexOf(detailView.cardId) > -1);
const $5ed71ca496f4aade$export$793179e0c0778f7d = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9,
    (0, $9ZuIF.getCurrentUser),
    (0, $jG5HW.getIsCompanyManaged)
], (allCards, currentUser, isCompanyManaged)=>{
    const currentUserId = currentUser ? currentUser.id : null;
    if (isCompanyManaged && (0, $4R6GH.fg)('backlog-assignee-filter-sort-fix')) {
        const assignees = Array.from(// Makes assignees as basically a Set
        Object.values(allCards).reduce((people, card)=>{
            if (card.assignee) people.set(card.assignee.id, card.assignee);
            return people;
        }, new Map()).values());
        const assigneeList = assignees.filter((person)=>person.id !== currentUserId).sort((a, b)=>a.displayName.localeCompare(b.displayName));
        const cUser = currentUser?.avatarUrl ? currentUser : assignees.find((assignee)=>assignee.id === currentUser?.id);
        if (cUser) assigneeList.unshift(cUser);
        return (0, $7uUwQ.freeze)(assigneeList);
    }
    const assigneeList = Object.values(allCards).map((card)=>card.assignee) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((people, person)=>{
        if (person && person.id !== currentUserId) people.push(person);
        return people;
    }, []);
    const uniqueAssigneeList = (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))(assigneeList, (assignee)=>assignee.id);
    if (isCompanyManaged) uniqueAssigneeList.sort((a, b)=>a.displayName.localeCompare(b.displayName));
    else {
        const assigneeCounts = (0, (/*@__PURE__*/$parcel$interopDefault($hm7zS)))(assigneeList, (assignee)=>assignee.id);
        uniqueAssigneeList.sort((a, b)=>assigneeCounts[b.id] - assigneeCounts[a.id]);
    }
    if (currentUser) uniqueAssigneeList.unshift(currentUser);
    return (0, $7uUwQ.freeze)(uniqueAssigneeList);
});
const $5ed71ca496f4aade$export$2777f818bf992a42 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9
], (allCards)=>(0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))(Object.values(allCards).reduce((labels, card)=>{
        if (card.labels && card.labels.length > 0) labels.push(...card.labels);
        return labels;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    }, [])).sort((a, b)=>(0, $8O7FC.alphabeticalSort)(a, b)));
const $5ed71ca496f4aade$export$d35c7777091af15b = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9
], (allCards)=>(0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))(Object.values(allCards).reduce((fixVersions, card)=>card.fixVersions && card.fixVersions.length > 0 ? fixVersions.concat(card.fixVersions) : fixVersions, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    [])).sort((a, b)=>(0, $8O7FC.alphabeticalSort)(a, b)));
const $5ed71ca496f4aade$export$f9311774fcd7a245 = (0, $dGvGJ.createSelector)([
    (0, $fpDLy.getVersionsOrder)
], (versions)=>versions.concat().sort((a, b)=>(0, $8O7FC.alphabeticalSort)(a, b)));
const $5ed71ca496f4aade$export$d4dec7daa49a8c5 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9
], (allCards)=>(0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))(Object.values(allCards).map((card)=>String(card.typeId))));
const $5ed71ca496f4aade$export$7fd50a0e5f559f3a = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$d4dec7daa49a8c5,
    (0, $74oBv.getCardTypes)
], (uniqCardTypeIds, allCardTypes)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const uniqCardTypes = uniqCardTypeIds.reduce((cardTypes, typeId)=>{
        const foundCardType = allCardTypes.find((cardType)=>String(cardType.id) === typeId);
        if (foundCardType) cardTypes.push({
            id: String(foundCardType.id),
            name: foundCardType.name,
            iconUrl: foundCardType.iconUrl,
            typeHierarchyLevel: foundCardType.typeHierarchyLevel ?? null
        });
        return cardTypes;
    }, []);
    return uniqCardTypes.sort((a, b)=>(0, $8O7FC.alphabeticalSort)(a.name, b.name));
});
const $5ed71ca496f4aade$export$66743788dd4e9bd8 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$ad9f3c6d3dd8c300
], (cardSelection)=>cardSelection.slice(-1)[0] || null);
const $5ed71ca496f4aade$export$e6b4eade500df666 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$c30df5b31e28112c
], (lastSelectedCardKey)=>lastSelectedCardKey !== '');
const $5ed71ca496f4aade$export$588fddef6c4ed7f9 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9,
    (0, $fmuR9.getIssueParents)
], (cards, issueParents)=>{
    const unmappedParents = {};
    Object.values(cards).forEach(({ parentId: parentId, parentKey: parentKey })=>{
        if (parentId && parentKey && !cards[parentId] && !issueParents[parentId] && !unmappedParents[parentId]) unmappedParents[parentId] = {
            key: parentKey
        };
    });
    return (cardId)=>(cards[cardId] || issueParents[cardId] || unmappedParents[cardId])?.key ?? null;
});
const $5ed71ca496f4aade$export$10cabd141980d8a2 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9
], (allCards)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((cardKey)=>{
        const cardIdWithKey = Object.keys(allCards).find((cardId)=>allCards[cardId]?.key === cardKey);
        return Number(cardIdWithKey);
    }));
const $5ed71ca496f4aade$export$4d2a5b62ef91607b = (0, $dGvGJ.createSelector)([
    (0, $l9VFH.getFilters),
    $5ed71ca496f4aade$export$5496a8bd76ac3cc7,
    $5ed71ca496f4aade$export$bc61c71d8347e4d9
], (filterValues, filteredCardIds, allCards)=>(0, $l9VFH.filter)(filterValues, filteredCardIds || undefined, Object.values(allCards)));
const $5ed71ca496f4aade$export$869d157a8342f44f = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9,
    $5ed71ca496f4aade$export$3593c0292d4c2e0b,
    $5ed71ca496f4aade$export$4d2a5b62ef91607b
], (allCards, orderedCardIdsLists, filterFunction)=>{
    const getOrderedVisibleCards = (cardListId)=>{
        const cardIds = orderedCardIdsLists[cardListId];
        if (!cardIds) return [];
        const unfilteredList = cardIds.filter((cardId)=>allCards[String(cardId)]).map((cardId)=>allCards[String(cardId)]);
        return filterFunction(unfilteredList);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getOrderedVisibleCards);
});
const $5ed71ca496f4aade$export$488409900307c7a6 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9,
    $5ed71ca496f4aade$export$3593c0292d4c2e0b,
    $5ed71ca496f4aade$export$4d2a5b62ef91607b
], (allCards, orderedCardIdsLists, filterFunction)=>{
    const getOrderedVisibleCardsExcludingSubtasks = (cardListId)=>{
        const cardIds = orderedCardIdsLists[cardListId];
        if (!cardIds) return [];
        const unfilteredList = cardIds.filter((cardId)=>allCards[String(cardId)] && !(0, $g4tDr.isSubtaskHierarchyLevel)(allCards[String(cardId)].typeHierarchyLevel)).map((cardId)=>allCards[String(cardId)]);
        return filterFunction(unfilteredList);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getOrderedVisibleCardsExcludingSubtasks);
});
const $5ed71ca496f4aade$export$aed4af4b88bc3874 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9,
    $5ed71ca496f4aade$export$5e8030258431459d,
    $5ed71ca496f4aade$export$4d2a5b62ef91607b
], (allCards, orderedCardIdsLists, filterFunction)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((cardListId)=>{
        const cardIds = orderedCardIdsLists[cardListId];
        if (!cardIds) return [];
        const unfilteredList = cardIds.filter((cardId)=>allCards[String(cardId)]).map((cardId)=>allCards[String(cardId)]);
        return filterFunction(unfilteredList);
    }));
const $5ed71ca496f4aade$export$b544e9d18cad6c7d = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9,
    $5ed71ca496f4aade$export$5e8030258431459d,
    $5ed71ca496f4aade$export$4d2a5b62ef91607b
], (allCards, orderedCardIdsLists, filterFunction)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((cardListId)=>{
        const cardIds = orderedCardIdsLists[cardListId];
        if (!cardIds) return [];
        const unfilteredList = cardIds.filter((cardId)=>allCards[String(cardId)] && !(0, $g4tDr.isSubtaskHierarchyLevel)(allCards[String(cardId)].typeHierarchyLevel)).map((cardId)=>allCards[String(cardId)]);
        return filterFunction(unfilteredList);
    }));
const $5ed71ca496f4aade$export$338dee38ad2f42f6 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9,
    $5ed71ca496f4aade$export$3593c0292d4c2e0b,
    $5ed71ca496f4aade$export$4d2a5b62ef91607b
], (allCards, orderedCardIdsLists, filterFunction)=>Object.fromEntries(Object.entries(orderedCardIdsLists).map(([key, cardIds])=>{
        const unfilteredList = cardIds.filter((cardId)=>allCards[String(cardId)]).map((cardId)=>allCards[String(cardId)]);
        const filteredIds = filterFunction(unfilteredList).map((card)=>card.id);
        return [
            key,
            filteredIds
        ];
    })));
const $5ed71ca496f4aade$export$d5b2e72cab21ec54 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$aed4af4b88bc3874
], (getOrderedVisibleCardsForCardList)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((cardListId)=>getOrderedVisibleCardsForCardList(cardListId).map((card)=>card.id)));
const $5ed71ca496f4aade$export$786319817f19c360 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$401c35958b2ae848
], (detailView)=>detailView !== null);
const $5ed71ca496f4aade$export$c24a16d8eafb7cff = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$869d157a8342f44f
], (getOrderedVisibleCardsForCardList)=>{
    const getOrderedVisibileCardIds = (cardListId)=>getOrderedVisibleCardsForCardList(cardListId).map((card)=>card.id);
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getOrderedVisibileCardIds);
});
const $5ed71ca496f4aade$export$b3426d0830bb4960 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$869d157a8342f44f
], (getOrderedVisibleCardsForCardList)=>{
    const getOrderedVisibileCardIds = (cardListId)=>getOrderedVisibleCardsForCardList(cardListId).map((card)=>({
                type: 'card',
                cardId: card.id
            }));
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getOrderedVisibileCardIds);
});
const $5ed71ca496f4aade$export$d2f7dc3ebc256192 = (state)=>state.ui.cardList.cardGroupExpanded;
const $5ed71ca496f4aade$export$e3846ee85e6596cc = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9,
    $5ed71ca496f4aade$export$d2f7dc3ebc256192
], (cards, expandedCardGroups)=>{
    const getCardGroupExpanded = (cardId)=>{
        const card = $5ed71ca496f4aade$var$getCardById(cards, cardId);
        if (card && card.parentId && (0, $g4tDr.isSubtaskHierarchyLevel)(card?.typeHierarchyLevel)) // you passed in a subtask, checking if the parent is expanded
        return expandedCardGroups[card.parentId];
        return expandedCardGroups[cardId];
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getCardGroupExpanded);
});
const $5ed71ca496f4aade$export$8f9f740048610b66 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9
], (cards)=>{
    const getParentId = (cardId)=>$5ed71ca496f4aade$var$getCardById(cards, cardId)?.parentId ?? undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getParentId);
});
const $5ed71ca496f4aade$export$63ae7bac909d8340 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9
], (cards)=>{
    const cardsByParent = (0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(cards, (card)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(card, 'parentId', 'NO_PARENT'));
    const cardsWithParent = (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(cardsByParent, 'NO_PARENT');
    return (0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(cardsWithParent, (childCards)=>childCards.map((card)=>card.id));
});
const $5ed71ca496f4aade$export$c0ec2d5d5f08d6fd = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9
], (cards)=>{
    const getHierarchyLevel = (cardId)=>$5ed71ca496f4aade$var$getCardById(cards, cardId)?.typeHierarchyLevel ?? undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getHierarchyLevel);
});
const $5ed71ca496f4aade$export$e8229a391aa249b1 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$8f9f740048610b66,
    $5ed71ca496f4aade$export$869d157a8342f44f,
    $5ed71ca496f4aade$export$e3846ee85e6596cc
], (getParentId, getOrderedVisibleCardsForCardList, getIsGroupExpanded)=>{
    const getOrderedVisibileCardIds = (cardListId)=>{
        const cardEntries = [];
        const cards = getOrderedVisibleCardsForCardList(cardListId);
        const cardIds = cards.map((card)=>card.id);
        const nonParentCardIds = cards.filter((card)=>!(0, $g4tDr.isSubtaskHierarchyLevel)(card.typeHierarchyLevel)).map((card)=>card.id);
        const parentCardIds = cards.filter((card)=>(0, $g4tDr.isSubtaskHierarchyLevel)(card.typeHierarchyLevel) && !!getParentId(card.id)).map((card)=>card.id);
        const parentCardIdsByChild = (0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(parentCardIds, getParentId);
        const childCardEntries = [
            []
        ];
        cardIds?.forEach((cardId)=>{
            if (nonParentCardIds.includes(cardId)) {
                cardEntries.push({
                    type: 'card',
                    cardId: cardId
                });
                return;
            }
            const parentId = getParentId(cardId);
            if (!parentId || !(parentId in parentCardIdsByChild)) return;
            const isGroupCollapsed = !getIsGroupExpanded(parentId);
            const parent = cardEntries.find((entry)=>!(0, $ee1tL.isCardEntryGroup)(entry) && entry.cardId === parentId);
            // If parent and subtasks are in the same list find parent index and insert group next to it
            if (nonParentCardIds.includes(parentId)) {
                const isAttachedToParent = nonParentCardIds.includes(parentId);
                if (parent !== undefined) {
                    const parentIndex = cardEntries.indexOf(parent);
                    cardEntries.splice(parentIndex + 1, 0, {
                        type: 'group',
                        parentId: parentId,
                        cardIds: parentCardIdsByChild[parentId],
                        isAttachedToParent: isAttachedToParent,
                        // Only card groups with a parent are able to be visually collapsed
                        isCollapsed: isGroupCollapsed && isAttachedToParent
                    });
                } else childCardEntries.push(parentCardIdsByChild[parentId]);
            } else {
                const isAttachedToParent = nonParentCardIds.includes(parentId);
                cardEntries.push({
                    type: 'group',
                    parentId: parentId,
                    cardIds: parentCardIdsByChild[parentId],
                    isAttachedToParent: isAttachedToParent,
                    isCollapsed: isGroupCollapsed && isAttachedToParent
                });
            }
            delete parentCardIdsByChild[parentId];
        });
        if (childCardEntries.length > 0) {
            childCardEntries.forEach((subtask)=>{
                const parentId = getParentId(subtask[0]);
                const parent = cardEntries.find((entry)=>!(0, $ee1tL.isCardEntryGroup)(entry) && entry.cardId === parentId);
                if (parent !== undefined && parentId !== undefined) {
                    const parentIndex = cardEntries.indexOf(parent);
                    const isCollapsed = !getIsGroupExpanded(parentId);
                    cardEntries.splice(parentIndex + 1, 0, {
                        type: 'group',
                        parentId: parentId,
                        cardIds: subtask,
                        isAttachedToParent: true,
                        isCollapsed: isCollapsed
                    });
                }
            });
            return cardEntries;
        }
        return cardEntries;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getOrderedVisibileCardIds);
});
const $5ed71ca496f4aade$export$8187607852c1fedc = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$b0ebc690fddac876,
    $5ed71ca496f4aade$export$e8229a391aa249b1
], (cardListKeys, getOrderedCardEntries)=>{
    const getAllAttachedToParentCardGroupEntries = ()=>{
        let cardEntryGroups = [];
        cardListKeys.forEach((cardListId)=>{
            const cardEntries = getOrderedCardEntries(cardListId);
            const groupCardEntries = cardEntries.filter((0, $ee1tL.isCardEntryGroup));
            const attachedToParentGroupCardEntries = groupCardEntries.filter((cardEntry)=>cardEntry.isAttachedToParent);
            cardEntryGroups = cardEntryGroups.concat(attachedToParentGroupCardEntries);
        });
        return cardEntryGroups;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getAllAttachedToParentCardGroupEntries);
});
const $5ed71ca496f4aade$export$f4b996b8eaed63ba = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$e8229a391aa249b1
], (getOrderedCardEntries)=>{
    const getOrderedVisibileCardIds = (cardListId)=>{
        const cardEntries = getOrderedCardEntries(cardListId);
        return cardEntries.filter((cardEntry)=>{
            if ((0, $ee1tL.isCardEntryGroup)(cardEntry)) return !cardEntry.isCollapsed;
            return true;
        });
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getOrderedVisibileCardIds);
});
const $5ed71ca496f4aade$export$2a0bb0de1d232830 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$f4b996b8eaed63ba
], (cardEntries)=>{
    const getVisibleCardOrderFromCardEntries = (cardListId)=>{
        const currentCardEntries = cardEntries(cardListId);
        return currentCardEntries.flatMap((entry)=>(0, $ee1tL.isCardEntryGroup)(entry) ? entry.cardIds : entry.cardId);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getVisibleCardOrderFromCardEntries);
});
const $5ed71ca496f4aade$export$ef62d40ffc479d23 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$c24a16d8eafb7cff,
    $5ed71ca496f4aade$export$5895481c46e9779a
], (getOrderedVisibleCardIdsForCardList, cardListIds)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    cardListIds.reduce((allCards, id)=>allCards.concat(getOrderedVisibleCardIdsForCardList(id)), []));
const $5ed71ca496f4aade$export$6b61f32266c676c3 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9,
    $5ed71ca496f4aade$export$4d2a5b62ef91607b
], (allCards, filterFunction)=>(id)=>{
        const card = allCards[`${id}`];
        if (!card) return false;
        const list = filterFunction([
            card
        ]);
        return list.length !== 0;
    });
const $5ed71ca496f4aade$export$325317470b38c674 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$3593c0292d4c2e0b
], (cardIdsByCardList)=>{
    const getIsCardOnBoard = (id)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(cardIdsByCardList, [
            (0, $guzeq.BOARD)
        ], []).includes(id);
    return getIsCardOnBoard;
});
const $5ed71ca496f4aade$export$44b7fd430cc830af = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$3593c0292d4c2e0b
], (cardIdsByCardList)=>{
    const getCardListIdByCardId = (id)=>Object.keys(cardIdsByCardList).find((cardListId)=>cardIdsByCardList[cardListId].includes(id));
    return getCardListIdByCardId;
});
const $5ed71ca496f4aade$export$9436834ba11ae17a = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$5895481c46e9779a,
    $5ed71ca496f4aade$export$c24a16d8eafb7cff
], (cardListIds, orderedVisibleCardIdsForCardList)=>{
    const getFastVirtualListMinimumOffSetByCardListId = (cardListId)=>{
        const cardListIndex = cardListIds.findIndex((id)=>id === cardListId);
        let offset = 0;
        for(let i = 0; i < cardListIndex; i += 1)offset += orderedVisibleCardIdsForCardList(cardListIds[i]).length * 40;
        return offset;
    };
    return getFastVirtualListMinimumOffSetByCardListId;
});
const $5ed71ca496f4aade$export$ab100b26d47e733e = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$75be3facf1d769f7
], (cardLists)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((id)=>{
        if (id === (0, $guzeq.BACKLOG)) return 0, $guzeq.BACKLOG;
        // If its a sprint, figure out whether its an active one or not, else kanban board
        const card = cardLists[id];
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(card) && card.type === (0, $guzeq.SPRINT) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(card.sprintData)) return card.sprintData.state === 'ACTIVE' ? (0, $guzeq.ACTIVE_SPRINT) : (0, $guzeq.INACTIVE_SPRINT);
        // Default to null or we will get skewed analytics
        return id === (0, $guzeq.BOARD) ? (0, $guzeq.BOARD) : null;
    }));
const $5ed71ca496f4aade$export$57205cd918d1a471 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$3593c0292d4c2e0b,
    $5ed71ca496f4aade$export$bc61c71d8347e4d9
], (cardIdsByCardList, allCards)=>(cardListId, ignoredIds = [])=>{
        const list = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(cardIdsByCardList[cardListId], ignoredIds);
        const cardId = list.length > 0 ? list[0] : null;
        if (cardId && (0, $g4tDr.isSubtaskHierarchyLevel)(allCards[String(cardId)]?.typeHierarchyLevel)) return allCards[String(cardId)].parentId;
        return cardId;
    });
const $5ed71ca496f4aade$export$c30c77f267ed58fa = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$3593c0292d4c2e0b
], (cardIdsByCardList)=>(cardListId, ignoredIds = [])=>{
        const list = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(cardIdsByCardList[cardListId], ignoredIds);
        return list.length > 0 ? list[list.length - 1] : null;
    });
const $5ed71ca496f4aade$export$a1e0feed5c998c95 = (0, $dGvGJ.createSelector)([
    (0, $74oBv.getBaseLevelCardTypes)
], (cardTypes)=>cardTypes?.length > 0);
const $5ed71ca496f4aade$export$14682dc3868ac2f2 = (state)=>state.ui.cardList.collapsed;
const $5ed71ca496f4aade$export$48519a9ef4b7246c = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$14682dc3868ac2f2
], (collapsedCardLists)=>(cardListId)=>!!collapsedCardLists[cardListId]);
const $5ed71ca496f4aade$export$a23657169ef5c959 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$75be3facf1d769f7,
    $5ed71ca496f4aade$export$5895481c46e9779a
], (cardLists, ids)=>ids.filter((id)=>!cardLists[id]?.isOptimistic));
const $5ed71ca496f4aade$export$277d12d0ad2acbb1 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$75be3facf1d769f7,
    $5ed71ca496f4aade$export$5895481c46e9779a
], (cardLists, ids)=>ids.reduce((accVisibleSprintCardLists, id)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const card = cardLists[id];
        if (card && !card.isOptimistic && card.type === (0, $guzeq.SPRINT)) accVisibleSprintCardLists.push(card);
        return accVisibleSprintCardLists;
    }, []));
const $5ed71ca496f4aade$export$44ac769c42548b1 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$5895481c46e9779a,
    $5ed71ca496f4aade$export$a23657169ef5c959
], (all, visible)=>all.length !== visible.length);
const $5ed71ca496f4aade$export$91ea52aeac57cc52 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$a23657169ef5c959
], (ids)=>{
    const getNextCardListId = (cardListId)=>{
        const index = ids.indexOf(cardListId);
        if (index === -1 || index === ids.length - 1) return null;
        return ids[index + 1];
    };
    return getNextCardListId;
});
const $5ed71ca496f4aade$export$9fc808638e14d4f0 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$3593c0292d4c2e0b,
    $5ed71ca496f4aade$export$a23657169ef5c959
], (cardIdsByCardListId, cardListIds)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    cardListIds.reduce((cardIds, cardListId)=>{
        cardIds.push(...cardIdsByCardListId[cardListId]);
        return cardIds;
    }, []));
const $5ed71ca496f4aade$export$e84ce0fc304b2d5d = (state)=>state.ui.cardList.disabled;
const $5ed71ca496f4aade$export$b40f586b1b1b5b3d = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$e84ce0fc304b2d5d
], (disabled)=>{
    const getIsCardListDisabled = (cardListId)=>Boolean(disabled[cardListId]);
    return getIsCardListDisabled;
});
const $5ed71ca496f4aade$var$getMaxColumnLimitFromCardList = (cardList)=>cardList.maxColumnLimit;
const $5ed71ca496f4aade$var$getMinColumnLimitFromCardList = (cardList)=>cardList.minColumnLimit;
const $5ed71ca496f4aade$var$makeGetColumnLimit = (columnLimitSelector)=>(0, $dGvGJ.createSelector)([
        $5ed71ca496f4aade$export$75be3facf1d769f7,
        (0, $jG5HW.getIsCompanyManaged),
        (0, $jG5HW.isKanbanBacklogStrategy)
    ], (cardLists, isCompanyManaged, isKanban)=>{
        const getColumnLimit = (cardListId)=>isCompanyManaged && isKanban && cardLists[cardListId] && columnLimitSelector(cardLists[cardListId]) ? columnLimitSelector(cardLists[cardListId]) : undefined;
        return getColumnLimit;
    });
const $5ed71ca496f4aade$export$86fa3555538a1895 = $5ed71ca496f4aade$var$makeGetColumnLimit($5ed71ca496f4aade$var$getMaxColumnLimitFromCardList);
const $5ed71ca496f4aade$export$daddaca8cdd663b3 = $5ed71ca496f4aade$var$makeGetColumnLimit($5ed71ca496f4aade$var$getMinColumnLimitFromCardList);
const $5ed71ca496f4aade$export$a3e606d31ce14076 = (0, $dGvGJ.createSelector)([
    (0, $l9VFH.getFilters),
    $5ed71ca496f4aade$export$793179e0c0778f7d,
    $5ed71ca496f4aade$export$2777f818bf992a42,
    (0, $fmuR9.issueParentIdsSelector),
    $5ed71ca496f4aade$export$d4dec7daa49a8c5,
    $5ed71ca496f4aade$export$f9311774fcd7a245,
    (0, $l9VFH.getCMPFilters),
    (0, $jG5HW.getIsCompanyManaged)
], (filters, validAssignees, validLabels, validIssueParentIds, validIssueTypeIds, validVersions, validCustomFilters, isCompanyManaged)=>{
    const filterTypeWhitelist = [
        (0, $41ce9b5576b92b7a$export$37aee82a3cb1e8f7),
        (0, $41ce9b5576b92b7a$export$f8f7545d2bb78afb),
        (0, $41ce9b5576b92b7a$export$d597759d33be802e),
        (0, $41ce9b5576b92b7a$export$2a4f270075a033de),
        (0, $41ce9b5576b92b7a$export$ebb48b08205007c5),
        (0, $41ce9b5576b92b7a$export$a4ad2735b021c132),
        'CUSTOM_FILTER'
    ];
    const validIssueParentIdsWithUnassignedOption = [
        String((0, $2lpqS.UNASSIGNED_EPIC_ID)),
        ...validIssueParentIds
    ];
    const validAssigneesWithUnassignedOption = [
        (0, $2lpqS.UNASSIGNED_USER),
        ...validAssignees
    ];
    const validVersionsWithUnassignedOption = [
        (0, $15a528573ccd89ae$export$ac95b4b2317d4b33),
        ...validVersions
    ];
    const validFilters = {};
    if (filters[0, $41ce9b5576b92b7a$export$f8f7545d2bb78afb]) {
        const allValidAssignees = isCompanyManaged ? validAssigneesWithUnassignedOption : validAssignees;
        const inter = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(allValidAssignees.map((person)=>person.id), filters[0, $41ce9b5576b92b7a$export$f8f7545d2bb78afb] ?? []);
        if (inter.length > 0) validFilters[0, $41ce9b5576b92b7a$export$f8f7545d2bb78afb] = inter;
    }
    if (filters[0, $41ce9b5576b92b7a$export$37aee82a3cb1e8f7]) {
        const inter = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(validLabels, filters[0, $41ce9b5576b92b7a$export$37aee82a3cb1e8f7]);
        if (inter.length > 0) validFilters[0, $41ce9b5576b92b7a$export$37aee82a3cb1e8f7] = inter;
    }
    if (filters[0, $41ce9b5576b92b7a$export$2a4f270075a033de]) {
        // Ignore the epic/issue parent filter validation in CMP
        if (isCompanyManaged) validFilters[0, $41ce9b5576b92b7a$export$2a4f270075a033de] = filters[0, $41ce9b5576b92b7a$export$2a4f270075a033de];
        else {
            const inter = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(validIssueParentIdsWithUnassignedOption, filters[0, $41ce9b5576b92b7a$export$2a4f270075a033de] ?? []);
            if (inter.length > 0) validFilters[0, $41ce9b5576b92b7a$export$2a4f270075a033de] = inter;
        }
    }
    if (filters[0, $41ce9b5576b92b7a$export$ebb48b08205007c5]) {
        const inter = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(validIssueTypeIds, filters[0, $41ce9b5576b92b7a$export$ebb48b08205007c5] ?? []);
        if (inter.length > 0) validFilters[0, $41ce9b5576b92b7a$export$ebb48b08205007c5] = inter;
    }
    if (filters[0, $41ce9b5576b92b7a$export$a4ad2735b021c132]) {
        const allValidVersions = isCompanyManaged ? validVersionsWithUnassignedOption : validVersions;
        const inter = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(allValidVersions, filters[0, $41ce9b5576b92b7a$export$a4ad2735b021c132] ?? []);
        if (inter.length > 0) validFilters[0, $41ce9b5576b92b7a$export$a4ad2735b021c132] = inter;
    }
    if (isCompanyManaged && filters[0, $41ce9b5576b92b7a$export$68d693c35a8d8866]) {
        const inter = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(filters[0, $41ce9b5576b92b7a$export$68d693c35a8d8866], validCustomFilters.map(({ id: id })=>id));
        if (inter.length > 0) validFilters[0, $41ce9b5576b92b7a$export$68d693c35a8d8866] = inter;
    }
    Object.keys(filters).filter((filterType)=>!filterTypeWhitelist.includes(filterType)).forEach((notAllowedFilter)=>{
        throw new Error(`Please whitelist filter '${notAllowedFilter}' in filter selectors`);
    });
    return validFilters;
});
const $5ed71ca496f4aade$export$333b83a56fe77194 = (0, $dGvGJ.createSelector)([
    (0, $l9VFH.getFilters),
    $5ed71ca496f4aade$export$793179e0c0778f7d,
    $5ed71ca496f4aade$export$2777f818bf992a42,
    (0, $fmuR9.issueParentIdsSelector),
    $5ed71ca496f4aade$export$d4dec7daa49a8c5,
    $5ed71ca496f4aade$export$f9311774fcd7a245,
    (0, $l9VFH.getCMPFilters),
    (0, $jG5HW.getIsCompanyManaged)
], (filters, validAssignees, validLabels, validIssueParentIds, validIssueTypeIds, validVersions, validCustomFilters, isCompanyManaged)=>{
    const filterTypeWhitelist = [
        (0, $41ce9b5576b92b7a$export$37aee82a3cb1e8f7),
        (0, $41ce9b5576b92b7a$export$f8f7545d2bb78afb),
        (0, $41ce9b5576b92b7a$export$d597759d33be802e),
        (0, $41ce9b5576b92b7a$export$2a4f270075a033de),
        (0, $41ce9b5576b92b7a$export$ebb48b08205007c5),
        (0, $41ce9b5576b92b7a$export$a4ad2735b021c132),
        (0, $41ce9b5576b92b7a$export$68d693c35a8d8866)
    ];
    const validIssueParentIdsWithUnassignedOption = [
        String((0, $2lpqS.UNASSIGNED_EPIC_ID)),
        ...validIssueParentIds
    ];
    const validAssigneesWithUnassignedOption = [
        (0, $2lpqS.UNASSIGNED_USER),
        ...validAssignees
    ];
    const validVersionsWithUnassignedOption = [
        (0, $15a528573ccd89ae$export$ac95b4b2317d4b33),
        ...validVersions
    ];
    const invalidFilters = {};
    if (filters[0, $41ce9b5576b92b7a$export$f8f7545d2bb78afb]) {
        const allValidAssignees = validAssigneesWithUnassignedOption;
        const diff = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(filters[0, $41ce9b5576b92b7a$export$f8f7545d2bb78afb], allValidAssignees.map((person)=>person.id));
        if (diff.length > 0) invalidFilters[0, $41ce9b5576b92b7a$export$f8f7545d2bb78afb] = diff;
    }
    if (filters[0, $41ce9b5576b92b7a$export$37aee82a3cb1e8f7]) {
        const diff = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(filters[0, $41ce9b5576b92b7a$export$37aee82a3cb1e8f7], validLabels);
        if (diff.length > 0) invalidFilters[0, $41ce9b5576b92b7a$export$37aee82a3cb1e8f7] = diff;
    }
    // Ignore the epic/issue parent filter validation in CMP
    if (filters[0, $41ce9b5576b92b7a$export$2a4f270075a033de] && !isCompanyManaged) {
        const diff = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(filters[0, $41ce9b5576b92b7a$export$2a4f270075a033de], validIssueParentIdsWithUnassignedOption);
        if (diff.length > 0) invalidFilters[0, $41ce9b5576b92b7a$export$2a4f270075a033de] = diff;
    }
    if (filters[0, $41ce9b5576b92b7a$export$ebb48b08205007c5]) {
        const diff = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(filters[0, $41ce9b5576b92b7a$export$ebb48b08205007c5], validIssueTypeIds);
        if (diff.length > 0) invalidFilters[0, $41ce9b5576b92b7a$export$ebb48b08205007c5] = diff;
    }
    if (filters[0, $41ce9b5576b92b7a$export$a4ad2735b021c132]) {
        const allValidVersions = isCompanyManaged ? validVersionsWithUnassignedOption : validVersions;
        const diff = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(filters[0, $41ce9b5576b92b7a$export$a4ad2735b021c132], allValidVersions);
        if (diff.length > 0) invalidFilters[0, $41ce9b5576b92b7a$export$a4ad2735b021c132] = diff;
    }
    if (isCompanyManaged && filters[0, $41ce9b5576b92b7a$export$68d693c35a8d8866]) {
        const diff = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(filters[0, $41ce9b5576b92b7a$export$68d693c35a8d8866], validCustomFilters.map(({ id: id })=>id));
        if (diff.length > 0) invalidFilters[0, $41ce9b5576b92b7a$export$68d693c35a8d8866] = diff;
    }
    Object.keys(filters)// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .filter((filterType)=>!filterTypeWhitelist.includes(filterType)).forEach((notAllowedFilter)=>{
        throw new Error(`Please whitelist filter '${notAllowedFilter}' in filter selectors`);
    });
    return invalidFilters;
});
const $5ed71ca496f4aade$export$e5ce012c8ff94f67 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$333b83a56fe77194
], (invalidFilterValues)=>Object.keys(invalidFilterValues).length > 0);
const $5ed71ca496f4aade$export$116ea4e15b17d748 = (0, $dGvGJ.createSelector)($5ed71ca496f4aade$export$bc61c71d8347e4d9, $5ed71ca496f4aade$export$ad9f3c6d3dd8c300, (cards, cardIds)=>cardIds.filter((cardId)=>cards[String(cardId)]).map((cardId)=>{
        const { id: id, key: key, parentId: parentId, projectId: projectId, fixVersions: fixVersions, issueTypeName: issueTypeName } = cards[String(cardId)];
        return {
            id: id,
            key: key,
            parentId: parentId,
            projectId: projectId,
            fixVersions: fixVersions,
            issueTypeName: issueTypeName
        };
    }));
const $5ed71ca496f4aade$export$97279e04a1cfee44 = (0, $dGvGJ.createSelector)($5ed71ca496f4aade$export$bc61c71d8347e4d9, $5ed71ca496f4aade$export$ad9f3c6d3dd8c300, (cards, cardIds)=>cardIds.filter((cardId)=>cards[String(cardId)]).map((cardId)=>{
        const { id: id, key: key, parentId: parentId, projectId: projectId, typeHierarchyLevel: typeHierarchyLevel } = cards[String(cardId)];
        return {
            id: id,
            key: key,
            parentId: parentId,
            projectId: projectId,
            typeHierarchyLevel: typeHierarchyLevel
        };
    }));
const $5ed71ca496f4aade$export$cb1654a9ed6d9099 = (0, $dGvGJ.createSelector)($5ed71ca496f4aade$export$bc61c71d8347e4d9, (cards)=>{
    const getPartialCardsFromCardIds = (cardIds)=>cardIds.filter((cardId)=>cards[String(cardId)]).map((cardId)=>{
            const { id: id, key: key, parentId: parentId, projectId: projectId, issueTypeName: issueTypeName } = cards[String(cardId)];
            return {
                id: id,
                key: key,
                parentId: parentId,
                projectId: projectId,
                issueTypeName: issueTypeName
            };
        });
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getPartialCardsFromCardIds);
});
const $5ed71ca496f4aade$export$9656edc7cd965e96 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9,
    (0, $74oBv.getCardTypesForFilter)
], (cards, cardTypes)=>{
    const getCardsForFlagWithCommentModalFromCardIds = (cardIds)=>cardIds.filter((cardId)=>cards[String(cardId)]).map((cardId)=>{
            const { id: id, key: key, summary: summary, typeId: typeId } = cards[String(cardId)];
            const type = cardTypes.find((it)=>it.id === String(typeId)) ?? {
                id: String(typeId),
                name: '',
                iconUrl: ''
            };
            return {
                id: id,
                key: key,
                summary: summary,
                type: type
            };
        });
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getCardsForFlagWithCommentModalFromCardIds);
});
const $5ed71ca496f4aade$export$a9b1eabca1c583fe = (0, $dGvGJ.createSelector)($5ed71ca496f4aade$export$c6ca016832785256, (cards)=>{
    const getIsAssignedToIssueParent = (selectedIds)=>cards.some((card)=>selectedIds.includes(card.id) && card.parentId);
    return getIsAssignedToIssueParent;
});
const $5ed71ca496f4aade$export$1b6edd941a4eaddd = (0, $dGvGJ.createSelector)($5ed71ca496f4aade$export$c6ca016832785256, (cards)=>cards.reduce((num, card)=>num + card.numTotalChildren, 0));
const $5ed71ca496f4aade$export$18ec94fe8e415ca5 = (0, $dGvGJ.createSelector)($5ed71ca496f4aade$export$c6ca016832785256, (cards)=>cards.reduce((num, card)=>num + card.numCompleteChildren, 0));
const $5ed71ca496f4aade$export$ebb887ede9b3994e = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9,
    (0, $fmuR9.getIssueParents)
], (cards, parents)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((cardId)=>{
        if (cards[cardId]) return cards[cardId].key;
        if (parents[cardId]) return parents[cardId].key;
        return null;
    }));
const $5ed71ca496f4aade$export$8d7d30d4816f6177 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9,
    (0, $fmuR9.getIssueParents)
], (cards, parents)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((key)=>{
        const cardId = Object.keys(cards).find((id)=>cards[id].key === key);
        if (cardId) return Number(cardId);
        const parentId = Object.keys(parents).find((id)=>parents[id].key === key);
        if (parentId) return Number(parentId);
        return null;
    }));
const $5ed71ca496f4aade$export$7170cae353180463 = (state)=>state.ui.cards.richCard.cardIdWithAboveIccOpen ?? null;
const $5ed71ca496f4aade$export$8f8d79952e8c1b8f = (state, { cardId: cardId })=>cardId === $5ed71ca496f4aade$export$7170cae353180463(state);
const $5ed71ca496f4aade$export$a874620d473113d0 = (state)=>state.ui.cards.richCard.mainActiveCard;
const $5ed71ca496f4aade$export$ee56c425125d2ef6 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$841def0f013aa3d3,
    (0, $fmuR9.issueParentIdsSelector)
], (cardIds, parentIds)=>{
    const formattedParentIds = parentIds.map((id)=>Number(id));
    return [
        ...cardIds,
        ...formattedParentIds
    ];
});
const $5ed71ca496f4aade$export$22d153c4cb386f10 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$75be3facf1d769f7,
    $5ed71ca496f4aade$export$5895481c46e9779a,
    $5ed71ca496f4aade$export$3593c0292d4c2e0b,
    $5ed71ca496f4aade$export$ab100b26d47e733e
], (cardLists, cardListIds, cardIdsByCardListId, getCardListAnalyticsTypeById)=>{
    const getListCount = (listId)=>listId && cardIdsByCardListId[listId] && cardIdsByCardListId[listId].length || 0;
    const boardIssueNo = getListCount((0, $guzeq.BOARD));
    const backlogIssueNo = getListCount((0, $guzeq.BACKLOG));
    const sprintStats = cardListIds.map((cardListId)=>({
            count: getListCount(cardListId),
            type: getCardListAnalyticsTypeById(cardListId)
        })).filter(({ type: type })=>type === (0, $guzeq.ACTIVE_SPRINT) || type === (0, $guzeq.INACTIVE_SPRINT));
    const activeSprintIssueNo = sprintStats.find(({ type: type })=>type === (0, $guzeq.ACTIVE_SPRINT))?.count ?? 0;
    const sprintsCount = sprintStats.length;
    const sprintsCardCounts = sprintStats.map(({ count: count })=>count);
    const sprintsMaxIssueNo = (0, (/*@__PURE__*/$parcel$interopDefault($fEeCa)))(sprintsCardCounts);
    const sprintsIssueNo = (0, (/*@__PURE__*/$parcel$interopDefault($iThRn)))(sprintsCardCounts);
    const sprintsAverageIssueNo = sprintsIssueNo / sprintsCount;
    return {
        boardIssueNo: boardIssueNo,
        activeSprintIssueNo: activeSprintIssueNo,
        backlogIssueNo: backlogIssueNo,
        sprintsCount: sprintsCount,
        sprintsMaxIssueNo: // @ts-expect-error - TS2322 - Type 'number | undefined' is not assignable to type 'number'.
        sprintsMaxIssueNo,
        sprintsAverageIssueNo: sprintsAverageIssueNo,
        sprintsIssueNo: sprintsIssueNo
    };
});
const $5ed71ca496f4aade$export$6450c8aec6d3b414 = (0, $dGvGJ.createSelector)([
    (state, props)=>props.cardId,
    (state)=>$5ed71ca496f4aade$export$a874620d473113d0(state),
    (state)=>$5ed71ca496f4aade$export$3593c0292d4c2e0b(state),
    (state)=>$5ed71ca496f4aade$export$c24a16d8eafb7cff(state)
], (targetCardId, activeCardId, orderedCardIdsByCardListId, getVisibleCardsForCardList)=>{
    if (!activeCardId) return false;
    if (targetCardId === activeCardId) return true;
    const activeCardList = Object.entries(orderedCardIdsByCardListId).find(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ([, cardIds])=>Array.isArray(cardIds) && cardIds.includes(activeCardId));
    if (!activeCardList) return false;
    const [activeCardListId] = activeCardList;
    const activeCardListCardIds = getVisibleCardsForCardList(activeCardListId);
    if (!Array.isArray(activeCardListCardIds)) return false;
    const activeCardIndex = activeCardListCardIds.indexOf(activeCardId);
    const targetCardIndex = activeCardListCardIds.indexOf(targetCardId);
    return activeCardIndex !== -1 && targetCardIndex !== -1 && targetCardIndex === activeCardIndex + 1;
});
const $5ed71ca496f4aade$export$454eae1b4bd66f70 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$962651073dd96b20
], (hasExtraFields)=>({ isInlineCardCreateOpen: isInlineCardCreateOpen, numberOfCardsInCardEntry: numberOfCardsInCardEntry, isCompact: isCompact, hideExtraFields: hideExtraFields = false })=>{
        const cardRowHeight = isCompact ? (0, $2lpqS.COMPACT_CARD_ROW_HEIGHT) : (0, $2lpqS.CARD_ROW_HEIGHT);
        const shouldHideExtraFields = (0, $f6RVN.isViewSettingAsPanelExpEnabledWithNoExposure)() ? hideExtraFields : false;
        const rowHeight = hasExtraFields && !shouldHideExtraFields ? cardRowHeight + (0, $2lpqS.EXTRA_CARD_ROW_HEIGHT) : cardRowHeight;
        const groupHeight = rowHeight * numberOfCardsInCardEntry;
        const inlineCreateHeight = isInlineCardCreateOpen ? (0, $2lpqS.INLINE_CARD_CREATE_ROW_HEIGHT) : 0;
        return groupHeight + inlineCreateHeight;
    });
const $5ed71ca496f4aade$export$697c63a5f8659c9 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$962651073dd96b20
], (hasExtraFields)=>(isCompact)=>{
        const cardRowHeight = isCompact ? (0, $2lpqS.COMPACT_CARD_ROW_HEIGHT) : (0, $2lpqS.CARD_ROW_HEIGHT);
        return hasExtraFields ? cardRowHeight + (0, $2lpqS.EXTRA_CARD_ROW_HEIGHT) : cardRowHeight;
    });
const $5ed71ca496f4aade$export$88889176877886a9 = (state)=>state.ui.cardList.dragState;
const $5ed71ca496f4aade$export$ac2362f84ffb1564 = (state, cardListId)=>Boolean($5ed71ca496f4aade$export$88889176877886a9(state)[cardListId]);
const $5ed71ca496f4aade$export$59261b5a26c04c00 = (state)=>state.ui.cardList.isDragging;
const $5ed71ca496f4aade$export$a62ade440fb97a7a = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$3593c0292d4c2e0b
], (orderedCardListIds)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((cardId)=>Object.keys(orderedCardListIds).find((cardListId)=>orderedCardListIds[cardListId].includes(cardId))));
const $5ed71ca496f4aade$export$f787c700d21c234a = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$f4b996b8eaed63ba
], (orderedCardEntriesByCardListId)=>{
    const getCardGroupId = (cardListId, cardId)=>{
        if (cardListId === undefined) return undefined;
        const orderedCardEntries = orderedCardEntriesByCardListId(cardListId);
        const group = orderedCardEntries.find((entry)=>entry.type === (0, $guzeq.GROUP_TYPE) && entry.parentId !== cardId && entry.cardIds.includes(cardId));
        return group !== null && group?.type === (0, $guzeq.GROUP_TYPE) ? `${group.parentId}-${cardListId}` : undefined;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getCardGroupId);
});
const $5ed71ca496f4aade$export$2b8ccf236ef3c2ad = (state, cardId)=>{
    const versions = (0, $fpDLy.getEntitiesVersions)(state);
    const cards = $5ed71ca496f4aade$export$bc61c71d8347e4d9(state);
    const card = $5ed71ca496f4aade$var$getCardById(cards, cardId);
    return card?.fixVersions?.map((versionId)=>versions?.[versionId]).filter(Boolean) ?? [];
};
const $5ed71ca496f4aade$export$10c1cb90425eb140 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$a23657169ef5c959,
    $5ed71ca496f4aade$export$c24a16d8eafb7cff,
    $5ed71ca496f4aade$export$48519a9ef4b7246c
], (visibleCardListIds, getOrderedVisibleCardIdsForCardList, getIsCardListCollapsed)=>visibleCardListIds.find((listId)=>getOrderedVisibleCardIdsForCardList(listId).length > 0 && !getIsCardListCollapsed(listId)));
const $5ed71ca496f4aade$export$91d6529e043b6231 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9
], (cards)=>(0, (/*@__PURE__*/$parcel$interopDefault($icGZu)))(cards, (card)=>!!card?.isFlagged));
const $5ed71ca496f4aade$export$df669897ce3195c6 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9
], (cards)=>(0, (/*@__PURE__*/$parcel$interopDefault($icGZu)))(cards, (card)=>!!card?.priority));
const $5ed71ca496f4aade$export$41cf0539676d3407 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9
], (cards)=>(0, (/*@__PURE__*/$parcel$interopDefault($icGZu)))(cards, (card)=>!!card?.dueDate));
const $5ed71ca496f4aade$export$242c58db4e305622 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9
], (cards)=>(0, (/*@__PURE__*/$parcel$interopDefault($icGZu)))(cards, (card)=>!!card?.estimate?.storyPoints));
const $5ed71ca496f4aade$export$261deb4fe884b0a1 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9
], (cards)=>(0, (/*@__PURE__*/$parcel$interopDefault($icGZu)))(cards, (card)=>!!card?.estimate?.originalEstimate?.value));
const $5ed71ca496f4aade$export$8983c3cdc7e8c1a5 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9
], (cards)=>(0, $g5X3G.values)(cards).filter((card)=>!!card?.dueDate).length);
const $5ed71ca496f4aade$export$5bab56d9e503125d = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$5895481c46e9779a,
    $5ed71ca496f4aade$export$c24a16d8eafb7cff
], (orderedCardListIds, getOrderedVisibleCardIdsForCardList)=>(0, (/*@__PURE__*/$parcel$interopDefault($hIkqU)))(orderedCardListIds, (listId)=>getOrderedVisibleCardIdsForCardList(listId).length > 0));
const $5ed71ca496f4aade$export$eb5d19e26822928b = (0, $dGvGJ.createSelector)([
    (0, $jG5HW.isCmpKanbanProject),
    $5ed71ca496f4aade$export$ad9f3c6d3dd8c300,
    $5ed71ca496f4aade$export$9fc808638e14d4f0,
    $5ed71ca496f4aade$export$8f9f740048610b66
], (isCmpKanbanBacklog, selectedCardIds, orderedCardIds, getParentIdByChildId)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((draggingCardId)=>{
        const relevantCards = new Set(selectedCardIds.includes(draggingCardId) ? selectedCardIds : [
            draggingCardId
        ]);
        return orderedCardIds.filter((cardId)=>{
            if (isCmpKanbanBacklog) return relevantCards.has(cardId);
            const parentId = getParentIdByChildId(cardId);
            return relevantCards.has(cardId) && (!parentId || !relevantCards.has(parentId));
        });
    }));
const $5ed71ca496f4aade$export$f8a371c4dafe2836 = (state)=>state.ui.cards.isCheckboxSelectionMode;

});
parcelRegister("hm7zS", function(module, exports) {

var $1m3dq = parcelRequire("1m3dq");

var $4CZTG = parcelRequire("4CZTG");
/** Used for built-in method references. */ var $ca2a5e84e2b42ea9$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ca2a5e84e2b42ea9$var$hasOwnProperty = $ca2a5e84e2b42ea9$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the number of times the key was returned by `iteratee`. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.countBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': 1, '6': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.countBy(['one', 'two', 'three'], 'length');
 * // => { '3': 2, '5': 1 }
 */ var $ca2a5e84e2b42ea9$var$countBy = $4CZTG(function(result, value, key) {
    if ($ca2a5e84e2b42ea9$var$hasOwnProperty.call(result, key)) ++result[key];
    else $1m3dq(result, key, 1);
});
module.exports = $ca2a5e84e2b42ea9$var$countBy;

});

parcelRegister("hIkqU", function(module, exports) {

var $bptzf = parcelRequire("bptzf");

var $apUNl = parcelRequire("apUNl");
/**
 * This method is like `_.find` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=collection.length-1] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * _.findLast([1, 2, 3, 4], function(n) {
 *   return n % 2 == 1;
 * });
 * // => 3
 */ var $0353f9604956038c$var$findLast = $bptzf($apUNl);
module.exports = $0353f9604956038c$var$findLast;

});
parcelRegister("bptzf", function(module, exports) {

var $bxDef = parcelRequire("bxDef");

var $hTJwX = parcelRequire("hTJwX");

var $66FNL = parcelRequire("66FNL");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $84e8f705a13e859f$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$hTJwX(collection)) {
            var iteratee = $bxDef(predicate, 3);
            collection = $66FNL(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = $84e8f705a13e859f$var$createFind;

});

parcelRegister("apUNl", function(module, exports) {

var $b5dwA = parcelRequire("b5dwA");

var $bxDef = parcelRequire("bxDef");

var $kPZpS = parcelRequire("kPZpS");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $79584b713e0c6354$var$nativeMax = Math.max, $79584b713e0c6354$var$nativeMin = Math.min;
/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */ function $79584b713e0c6354$var$findLastIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = length - 1;
    if (fromIndex !== undefined) {
        index = $kPZpS(fromIndex);
        index = fromIndex < 0 ? $79584b713e0c6354$var$nativeMax(length + index, 0) : $79584b713e0c6354$var$nativeMin(index, length - 1);
    }
    return $b5dwA(array, $bxDef(predicate, 3), index, true);
}
module.exports = $79584b713e0c6354$var$findLastIndex;

});


parcelRegister("fn8B5", function(module, exports) {

var $1m3dq = parcelRequire("1m3dq");

var $4CZTG = parcelRequire("4CZTG");
/** Used for built-in method references. */ var $b30fac385487af61$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b30fac385487af61$var$hasOwnProperty = $b30fac385487af61$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */ var $b30fac385487af61$var$groupBy = $4CZTG(function(result, value, key) {
    if ($b30fac385487af61$var$hasOwnProperty.call(result, key)) result[key].push(value);
    else $1m3dq(result, key, [
        value
    ]);
});
module.exports = $b30fac385487af61$var$groupBy;

});

parcelRegister("4wVpT", function(module, exports) {

var $1nIHN = parcelRequire("1nIHN");

var $9dThv = parcelRequire("9dThv");

var $g7i7g = parcelRequire("g7i7g");

var $d9Hx6 = parcelRequire("d9Hx6");
/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */ var $34c6b050456654f8$var$intersection = $g7i7g(function(arrays) {
    var mapped = $1nIHN(arrays, $d9Hx6);
    return mapped.length && mapped[0] === arrays[0] ? $9dThv(mapped) : [];
});
module.exports = $34c6b050456654f8$var$intersection;

});
parcelRegister("9dThv", function(module, exports) {

var $ijRUK = parcelRequire("ijRUK");

var $fUP98 = parcelRequire("fUP98");

var $dA3tP = parcelRequire("dA3tP");

var $1nIHN = parcelRequire("1nIHN");

var $cW28x = parcelRequire("cW28x");

var $40I25 = parcelRequire("40I25");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6b7035a795ecd274$var$nativeMin = Math.min;
/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */ function $6b7035a795ecd274$var$baseIntersection(arrays, iteratee, comparator) {
    var includes = comparator ? $dA3tP : $fUP98, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result = [];
    while(othIndex--){
        var array = arrays[othIndex];
        if (othIndex && iteratee) array = $1nIHN(array, $cW28x(iteratee));
        maxLength = $6b7035a795ecd274$var$nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new $ijRUK(othIndex && array) : undefined;
    }
    array = arrays[0];
    var index = -1, seen = caches[0];
    outer: while(++index < length && result.length < maxLength){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (!(seen ? $40I25(seen, computed) : includes(result, computed, comparator))) {
            othIndex = othLength;
            while(--othIndex){
                var cache = caches[othIndex];
                if (!(cache ? $40I25(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
            }
            if (seen) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $6b7035a795ecd274$var$baseIntersection;

});

parcelRegister("d9Hx6", function(module, exports) {

var $f3SOL = parcelRequire("f3SOL");
/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */ function $993de25d5a02863a$var$castArrayLikeObject(value) {
    return $f3SOL(value) ? value : [];
}
module.exports = $993de25d5a02863a$var$castArrayLikeObject;

});


parcelRegister("iThRn", function(module, exports) {

var $gBzAF = parcelRequire("gBzAF");

var $etyzk = parcelRequire("etyzk");
/**
 * Computes the sum of the values in `array`.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {number} Returns the sum.
 * @example
 *
 * _.sum([4, 2, 8, 6]);
 * // => 20
 */ function $dc0b37ac120f9bb6$var$sum(array) {
    return array && array.length ? $gBzAF(array, $etyzk) : 0;
}
module.exports = $dc0b37ac120f9bb6$var$sum;

});
parcelRegister("gBzAF", function(module, exports) {
/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */ function $c16bb58eedefe4cd$var$baseSum(array, iteratee) {
    var result, index = -1, length = array.length;
    while(++index < length){
        var current = iteratee(array[index]);
        if (current !== undefined) result = result === undefined ? current : result + current;
    }
    return result;
}
module.exports = $c16bb58eedefe4cd$var$baseSum;

});


parcelRegister("2nvJN", function(module, exports) {

var $kHBB0 = parcelRequire("kHBB0");

var $6wH7T = parcelRequire("6wH7T");

var $gvFfr = parcelRequire("gvFfr");

var $4TR1Q = parcelRequire("4TR1Q");

var $c2mKc = parcelRequire("c2mKc");

var $jx6Tp = parcelRequire("jx6Tp");

var $jJVtR = parcelRequire("jJVtR");
/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */ function $1bb6592c97235e03$var$trim(string, chars, guard) {
    string = $jJVtR(string);
    if (string && (guard || chars === undefined)) return $6wH7T(string);
    if (!string || !(chars = $kHBB0(chars))) return string;
    var strSymbols = $jx6Tp(string), chrSymbols = $jx6Tp(chars), start = $c2mKc(strSymbols, chrSymbols), end = $4TR1Q(strSymbols, chrSymbols) + 1;
    return $gvFfr(strSymbols, start, end).join('');
}
module.exports = $1bb6592c97235e03$var$trim;

});
parcelRegister("4TR1Q", function(module, exports) {

var $2wwA6 = parcelRequire("2wwA6");
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */ function $39156edc40ecb497$var$charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;
    while(index-- && $2wwA6(chrSymbols, strSymbols[index], 0) > -1);
    return index;
}
module.exports = $39156edc40ecb497$var$charsEndIndex;

});

parcelRegister("c2mKc", function(module, exports) {

var $2wwA6 = parcelRequire("2wwA6");
/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */ function $8c37507367fba30b$var$charsStartIndex(strSymbols, chrSymbols) {
    var index = -1, length = strSymbols.length;
    while(++index < length && $2wwA6(chrSymbols, strSymbols[index], 0) > -1);
    return index;
}
module.exports = $8c37507367fba30b$var$charsStartIndex;

});


parcelRegister("f6RVN", function(module, exports) {

$parcel$export(module.exports, "isViewSettingAsPanelExpEnabledWithNoExposure", () => $e70219a0f392597e$export$6f295af995afef94);
/**
 * Feature flags convention: go/frontend-feature-flags. Please ensure integration tests are still working afterwards.
 */ 
var $4R6GH = parcelRequire("4R6GH");
// Add your feature flag name as a constant
const $e70219a0f392597e$var$ERROR_TRACKING_ENABLED = 'fe_platform_error_tracking_enabled_sentry';
const $e70219a0f392597e$var$UIF_STATSIG_EXPOSURES_UPDATES = 'jsw.perf.uif.statsig-exposures-update';
const $e70219a0f392597e$export$52a40ff46dc0c1ad = [
    $e70219a0f392597e$var$ERROR_TRACKING_ENABLED,
    $e70219a0f392597e$var$UIF_STATSIG_EXPOSURES_UPDATES,
    'jsw-backlog-main-component-refactor'
];
const $e70219a0f392597e$export$6f295af995afef94 = ()=>(0, $4R6GH.fg)('jira_view_settings_additional_fields');

});

const $41ce9b5576b92b7a$export$d597759d33be802e = 'TEXT';
const $41ce9b5576b92b7a$export$f8f7545d2bb78afb = 'ASSIGNEE';
const $41ce9b5576b92b7a$export$37aee82a3cb1e8f7 = 'LABEL';
const $41ce9b5576b92b7a$export$2a4f270075a033de = 'ISSUE_PARENT';
const $41ce9b5576b92b7a$export$a4ad2735b021c132 = 'VERSION';
const $41ce9b5576b92b7a$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $41ce9b5576b92b7a$export$68d693c35a8d8866 = 'CUSTOM_FILTER';
const $41ce9b5576b92b7a$export$360e7ca29749d455 = 6;

parcelRegister("ee1tL", function(module, exports) {

$parcel$export(module.exports, "isCardEntryGroup", () => $bfdc71dc0d0cc8bd$export$1f425e415814c059);
$parcel$export(module.exports, "getCardEntryGroupKey", () => $bfdc71dc0d0cc8bd$export$57a979d82c39e211);
const $bfdc71dc0d0cc8bd$export$1f425e415814c059 = (cardEntry)=>cardEntry?.type === 'group';
const $bfdc71dc0d0cc8bd$export$57a979d82c39e211 = ({ parentId: parentId }, cardListId)=>`cardGroup-${cardListId}-${parentId}`;

});

parcelRegister("jG5HW", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $4d4429919f577b04$export$f654b28f82155665);
$parcel$export(module.exports, "getLocale", () => $4d4429919f577b04$export$180605366c04f0cd);
$parcel$export(module.exports, "getCloudId", () => $4d4429919f577b04$export$fdd2c0ba94025c3c);
$parcel$export(module.exports, "getAtlassianAccountId", () => $4d4429919f577b04$export$f5baf4f0aaa47428);
$parcel$export(module.exports, "getIsCompanyManaged", () => $4d4429919f577b04$export$a5407237e82f55bc);
$parcel$export(module.exports, "getIsBoardCrossProject", () => $4d4429919f577b04$export$28687faffae2aeb1);
$parcel$export(module.exports, "getDetailView", () => $4d4429919f577b04$export$afc39f7bfa2dc85);
$parcel$export(module.exports, "getRapidViewId", () => $4d4429919f577b04$export$d5d5a91bd9ef0413);
$parcel$export(module.exports, "getProjectName", () => $4d4429919f577b04$export$2cd058184eb75757);
$parcel$export(module.exports, "getProjects", () => $4d4429919f577b04$export$b00a271f69f3d728);
$parcel$export(module.exports, "getProjectIds", () => $4d4429919f577b04$export$178da5d750a5a582);
$parcel$export(module.exports, "projectIdSelector", () => $4d4429919f577b04$export$4c9d6034f65d22f4);
$parcel$export(module.exports, "getProjectKey", () => $4d4429919f577b04$export$667f2a0f99c75faa);
$parcel$export(module.exports, "getSessionId", () => $4d4429919f577b04$export$b3739caaf2580dd);
$parcel$export(module.exports, "getProjectAris", () => $4d4429919f577b04$export$aa9d76803f3432de);
$parcel$export(module.exports, "getRankCustomFieldId", () => $4d4429919f577b04$export$e98a0db7f9514370);
$parcel$export(module.exports, "getStoryPointFieldId", () => $4d4429919f577b04$export$60b2b9fa88a67144);
$parcel$export(module.exports, "getSprintFieldId", () => $4d4429919f577b04$export$84ee6604e6063636);
$parcel$export(module.exports, "getEpicLinkFieldId", () => $4d4429919f577b04$export$366de0fbf3478a25);
$parcel$export(module.exports, "getEpicIssueType", () => $4d4429919f577b04$export$c58dde3f1e86a4e4);
$parcel$export(module.exports, "getRequestColumnMigration", () => $4d4429919f577b04$export$55ebbbc856ff6213);
$parcel$export(module.exports, "getName", () => $4d4429919f577b04$export$7d9f7e9c1c02b41e);
$parcel$export(module.exports, "getBacklogStrategy", () => $4d4429919f577b04$export$a5a7be8ea88122cc);
$parcel$export(module.exports, "getTimeTrackingOptions", () => $4d4429919f577b04$export$cb06173d4516a1bf);
$parcel$export(module.exports, "getJqlQuery", () => $4d4429919f577b04$export$2af3643b1d2591eb);
$parcel$export(module.exports, "getIsParallelSprintsEnabled", () => $4d4429919f577b04$export$3dc3b60a5f5423b3);
$parcel$export(module.exports, "isKanbanBacklogStrategy", () => $4d4429919f577b04$export$5aa5fa3e0697f97f);
$parcel$export(module.exports, "isScrumBacklogStrategy", () => $4d4429919f577b04$export$3c97bd51d3f010f7);
$parcel$export(module.exports, "getKanbanBoardColumnId", () => $4d4429919f577b04$export$a97644e2ddb37b5e);
$parcel$export(module.exports, "getKanbanBacklogColumnId", () => $4d4429919f577b04$export$b5c1d7f6a57c60b8);
$parcel$export(module.exports, "getKanbanTargetColumnId", () => $4d4429919f577b04$export$e4c5fb56a3200047);
$parcel$export(module.exports, "getHasActiveSprints", () => $4d4429919f577b04$export$b7c097c5d71343b7);
$parcel$export(module.exports, "isCardMoveDisabled", () => $4d4429919f577b04$export$6cea212e63a4af6c);
$parcel$export(module.exports, "isCmpKanbanProject", () => $4d4429919f577b04$export$8b4b78473e0920ac);
$parcel$export(module.exports, "isCheckboxSelectionMode", () => $4d4429919f577b04$export$af914ee70a3d8e9f);
$parcel$export(module.exports, "isCMPScrumBacklog", () => $4d4429919f577b04$export$481012a7a1572742);
$parcel$export(module.exports, "getBoardType", () => $4d4429919f577b04$export$985c8cf86abe2d42);
$parcel$export(module.exports, "getBacklogExtensionData", () => $4d4429919f577b04$export$a08aabe4b0cf08ae);

var $dGvGJ = parcelRequire("dGvGJ");

var $2vSU6 = parcelRequire("2vSU6");

var $dXq4S = parcelRequire("dXq4S");

var $g5X3G = parcelRequire("g5X3G");


var $guzeq = parcelRequire("guzeq");

var $e5nhF = parcelRequire("e5nhF");
const $4d4429919f577b04$export$f654b28f82155665 = (state)=>state.config.baseUrl;
const $4d4429919f577b04$export$180605366c04f0cd = (state)=>state.config.locale;
const $4d4429919f577b04$export$14407a25c57e1f92 = (state)=>state.config.xsrfToken;
const $4d4429919f577b04$export$fdd2c0ba94025c3c = (state)=>state.config.cloudId;
const $4d4429919f577b04$export$f5baf4f0aaa47428 = (state)=>state.config.atlassianAccountId;
const $4d4429919f577b04$export$a5407237e82f55bc = (state)=>state.config.isCompanyManaged;
const $4d4429919f577b04$export$28687faffae2aeb1 = (state)=>state.config.isBoardCrossProject;
const $4d4429919f577b04$export$afc39f7bfa2dc85 = (state)=>state.ui.detailView;
const $4d4429919f577b04$export$d5d5a91bd9ef0413 = (state)=>state.config.rapidViewId;
/*
 * @deprecated getProjectId getter should not be used for company-managed. Use projectIdSelector instead.
 * Eventually this will have to be deprecated for team-managed project as well.
 * */ const $4d4429919f577b04$var$getProjectId = (state)=>state.config.projectId;
const $4d4429919f577b04$export$2cd058184eb75757 = (state)=>state.config.projectName;
const $4d4429919f577b04$export$b00a271f69f3d728 = (0, $dGvGJ.createSelector)([
    (0, $e5nhF.getEntities)
], (entities)=>entities.project.projects);
const $4d4429919f577b04$export$178da5d750a5a582 = (0, $dGvGJ.createSelector)([
    $4d4429919f577b04$export$a5407237e82f55bc,
    $4d4429919f577b04$export$b00a271f69f3d728,
    $4d4429919f577b04$var$getProjectId
], (isCompanyManaged, projects, projectId)=>isCompanyManaged ? projects.map((x)=>x.id) : [
        projectId
    ]);
const $4d4429919f577b04$export$4c9d6034f65d22f4 = (0, $dGvGJ.createSelector)([
    $4d4429919f577b04$export$178da5d750a5a582
], (projectIds)=>projectIds[0]);
const $4d4429919f577b04$export$667f2a0f99c75faa = (state)=>state.config.projectKey;
const $4d4429919f577b04$export$b3739caaf2580dd = (state)=>state.config.sessionId;
const $4d4429919f577b04$export$aa9d76803f3432de = (0, $dGvGJ.createSelector)([
    $4d4429919f577b04$export$178da5d750a5a582,
    $4d4429919f577b04$export$fdd2c0ba94025c3c
], (projectIds, cloudId)=>projectIds.map((id)=>(0, $dXq4S.createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'project',
            resourceId: String(id)
        })));
const $4d4429919f577b04$export$e98a0db7f9514370 = (state)=>state.config.rankCustomFieldId;
const $4d4429919f577b04$export$60b2b9fa88a67144 = (state)=>state.config.storyPointFieldId;
const $4d4429919f577b04$export$84ee6604e6063636 = (state)=>state.config.sprintFieldId;
const $4d4429919f577b04$export$366de0fbf3478a25 = (state)=>state.config.epicLinkField?.id;
const $4d4429919f577b04$export$c58dde3f1e86a4e4 = (state)=>state.config.epicIssueType ?? null;
const $4d4429919f577b04$export$55ebbbc856ff6213 = (state)=>state.config.requestColumnMigration;
const $4d4429919f577b04$export$7d9f7e9c1c02b41e = (state)=>state.config.name;
const $4d4429919f577b04$export$a5a7be8ea88122cc = (state)=>state.config.backlogStrategy;
const $4d4429919f577b04$export$cb06173d4516a1bf = (state)=>state.config.timeTrackingOptions;
const $4d4429919f577b04$export$2af3643b1d2591eb = (state)=>state.config.jqlQuery;
const $4d4429919f577b04$export$3dc3b60a5f5423b3 = (state)=>state.config.parallelSprints;
const $4d4429919f577b04$export$5aa5fa3e0697f97f = (state)=>state.config.backlogStrategy === (0, $guzeq.KANBAN_BACKLOG_STRATEGY);
const $4d4429919f577b04$export$3c97bd51d3f010f7 = (state)=>$4d4429919f577b04$export$a5a7be8ea88122cc(state) === (0, $guzeq.SPRINT_BACKLOG_STRATEGY);
const $4d4429919f577b04$export$a97644e2ddb37b5e = (state)=>state?.config?.kanbanBoardColumnId ?? null;
const $4d4429919f577b04$export$b5c1d7f6a57c60b8 = (state)=>state?.config?.kanbanBacklogColumnId ?? null;
const $4d4429919f577b04$export$e4c5fb56a3200047 = (state)=>(cardListType)=>cardListType === (0, $guzeq.BACKLOG) ? $4d4429919f577b04$export$b5c1d7f6a57c60b8(state) : $4d4429919f577b04$export$a97644e2ddb37b5e(state);
const $4d4429919f577b04$export$b7c097c5d71343b7 = (state)=>{
    // TODO: Update this to use Object.values when TS comes in
    // Damn you Flow.
    const { cardList: cardList } = (0, $e5nhF.getEntities)(state);
    return Object.keys(cardList).some((key)=>cardList[key].sprintData?.state === (0, $guzeq.SPRINT_STATE_ACTIVE));
};
const $4d4429919f577b04$export$6cea212e63a4af6c = (state)=>state.config.isCompanyManaged === true && state.config.isOrderedByRank === false;
const $4d4429919f577b04$export$8b4b78473e0920ac = (state)=>$4d4429919f577b04$export$a5407237e82f55bc(state) && $4d4429919f577b04$export$5aa5fa3e0697f97f(state);
const $4d4429919f577b04$export$af914ee70a3d8e9f = (state)=>state.ui.cards.isCheckboxSelectionMode;
const $4d4429919f577b04$export$481012a7a1572742 = (state)=>$4d4429919f577b04$export$a5407237e82f55bc(state) && $4d4429919f577b04$export$3c97bd51d3f010f7(state);
const $4d4429919f577b04$export$985c8cf86abe2d42 = (state)=>{
    if ($4d4429919f577b04$export$a5407237e82f55bc(state)) {
        if ($4d4429919f577b04$export$3c97bd51d3f010f7(state)) return 0, $a9c483c0d986286a$export$8ee1fad10cc70eb5;
        if ($4d4429919f577b04$export$5aa5fa3e0697f97f(state)) return 0, $a9c483c0d986286a$export$9f54a1518145e351;
    }
    return 0, $a9c483c0d986286a$export$9a2b21d55c0f061c;
};
const $4d4429919f577b04$var$getBoardTypeForREST = (boardType)=>{
    switch(boardType){
        case 0, $a9c483c0d986286a$export$9f54a1518145e351:
            return 'kanban';
        case 0, $a9c483c0d986286a$export$8ee1fad10cc70eb5:
            return 'scrum';
        default:
            return 'simple';
    }
};
const $4d4429919f577b04$export$a08aabe4b0cf08ae = (state)=>{
    const { projectKey: projectKey, rapidViewId: rapidViewId } = state.config;
    return {
        project: {
            id: (0, $g5X3G.toProjectId)(String($4d4429919f577b04$export$4c9d6034f65d22f4(state))),
            key: projectKey,
            type: (0, $2vSU6.SOFTWARE_PROJECT)
        },
        board: {
            id: rapidViewId,
            type: $4d4429919f577b04$var$getBoardTypeForREST($4d4429919f577b04$export$985c8cf86abe2d42(state))
        }
    };
};

});
const $a9c483c0d986286a$export$dfd208682d29484c = 'software-backlog';
const $a9c483c0d986286a$export$b6e4306772e8a60d = 'ng-backlog';
const $a9c483c0d986286a$export$7858b0b4e02abd78 = 'cmp-backlog';
const $a9c483c0d986286a$export$840e3848643f7781 = 'backlog';
const $a9c483c0d986286a$export$9f54a1518145e351 = 'Kanban';
const $a9c483c0d986286a$export$8ee1fad10cc70eb5 = 'Scrum';
const $a9c483c0d986286a$export$9a2b21d55c0f061c = 'Agility';

parcelRegister("e5nhF", function(module, exports) {

$parcel$export(module.exports, "getEntities", () => $31f541e32b7bdffd$export$e2e3f9f64b249105);
$parcel$export(module.exports, "getIssueParentsOrderIds", () => $31f541e32b7bdffd$export$6074a6cc45eb2317);

var $alNv9 = parcelRequire("alNv9");
const $31f541e32b7bdffd$export$e2e3f9f64b249105 = (state)=>(0, $alNv9.ensureState)(state.entities);
const $31f541e32b7bdffd$export$6074a6cc45eb2317 = (state)=>$31f541e32b7bdffd$export$e2e3f9f64b249105(state).issueParentsOrder;

});


parcelRegister("74oBv", function(module, exports) {

$parcel$export(module.exports, "getCardTypes", () => $dc0656ae0ef75194$export$b20723ae469526fe);
$parcel$export(module.exports, "getBaseLevelCardTypes", () => $dc0656ae0ef75194$export$25d4089e81ce95ff);
$parcel$export(module.exports, "getCardTypesForFilter", () => $dc0656ae0ef75194$export$9b7f24e4cefec566);
$parcel$export(module.exports, "manageIssueTypesSelector", () => $dc0656ae0ef75194$export$3d59df9affe3fcf3);
$parcel$export(module.exports, "getHasAnyIssueTypeWithRequireFields", () => $dc0656ae0ef75194$export$67aba0fda804be4c);

var $alNv9 = parcelRequire("alNv9");

var $dGvGJ = parcelRequire("dGvGJ");

var $2vSU6 = parcelRequire("2vSU6");

var $g4tDr = parcelRequire("g4tDr");

var $02Psx = parcelRequire("02Psx");

var $jG5HW = parcelRequire("jG5HW");
const $dc0656ae0ef75194$export$b20723ae469526fe = (state)=>(0, $alNv9.ensureState)(state.entities).cardTypes;
const $dc0656ae0ef75194$export$25d4089e81ce95ff = (0, $dGvGJ.createSelector)($dc0656ae0ef75194$export$b20723ae469526fe, (cardTypes)=>cardTypes.length > 0 ? cardTypes?.filter((issueType)=>issueType.typeHierarchyLevel === (0, $g4tDr.BASE_HIERARCHY_TYPE)) : []);
const $dc0656ae0ef75194$export$9b7f24e4cefec566 = (0, $dGvGJ.createSelector)($dc0656ae0ef75194$export$25d4089e81ce95ff, (cardTypes)=>cardTypes.map((cardType)=>({
            id: String(cardType.id),
            name: cardType.name,
            iconUrl: cardType.iconUrl
        })));
const $dc0656ae0ef75194$export$d4dec7daa49a8c5 = (0, $dGvGJ.createSelector)($dc0656ae0ef75194$export$25d4089e81ce95ff, (cardTypes)=>cardTypes.map((cardType)=>String(cardType.id)));
const $dc0656ae0ef75194$export$3d59df9affe3fcf3 = (0, $dGvGJ.createSelector)([
    (0, $jG5HW.getBaseUrl),
    (0, $jG5HW.getProjectKey)
], (_, projectKey)=>(0, $02Psx.getNextgenSettingsIssueTypesUrl)((0, $2vSU6.SOFTWARE_PROJECT), projectKey));
const $dc0656ae0ef75194$export$67aba0fda804be4c = (0, $dGvGJ.createSelector)([
    $dc0656ae0ef75194$export$25d4089e81ce95ff
], (cardTypes)=>cardTypes.some((cardType)=>cardType.hasRequiredFields));

});

parcelRegister("l9VFH", function(module, exports) {

$parcel$export(module.exports, "getFilters", () => $424c5f2057b4a72b$export$1933a9fe712fc1fd);
$parcel$export(module.exports, "getCMPFilters", () => $424c5f2057b4a72b$export$b85cb74b5db260e6);
$parcel$export(module.exports, "getAppliedParentFilters", () => $424c5f2057b4a72b$export$889ee627c9da88af);
$parcel$export(module.exports, "getAppliedAssigneeFilters", () => $424c5f2057b4a72b$export$4724d05a9e1b68d8);
$parcel$export(module.exports, "getAppliedVersionFilters", () => $424c5f2057b4a72b$export$f08351012de61e58);
$parcel$export(module.exports, "getAppliedLabelFilters", () => $424c5f2057b4a72b$export$60ee89f2718fc651);
$parcel$export(module.exports, "getAppliedCustomFilters", () => $424c5f2057b4a72b$export$e4cc6991cb44d849);
$parcel$export(module.exports, "getAppliedCustomFilterQueries", () => $424c5f2057b4a72b$export$5d6b2188da2fc080);
$parcel$export(module.exports, "getLastFilteredIssueTypeId", () => $424c5f2057b4a72b$export$66fc4c808781b0dd);
$parcel$export(module.exports, "filter", () => $424c5f2057b4a72b$export$3dea766d36a8935f);

var $dGvGJ = parcelRequire("dGvGJ");

var $hYfgW = parcelRequire("hYfgW");

var $gJBT6 = parcelRequire("gJBT6");

var $g4tDr = parcelRequire("g4tDr");

var $dVREV = parcelRequire("dVREV");


var $e5nhF = parcelRequire("e5nhF");
const $424c5f2057b4a72b$export$1933a9fe712fc1fd = (state)=>state.ui.filters;
const $424c5f2057b4a72b$export$b85cb74b5db260e6 = (state)=>(0, $e5nhF.getEntities)(state).customFilters.filters;
const $424c5f2057b4a72b$export$889ee627c9da88af = (state)=>$424c5f2057b4a72b$export$1933a9fe712fc1fd(state)[0, $41ce9b5576b92b7a$export$2a4f270075a033de];
const $424c5f2057b4a72b$export$4724d05a9e1b68d8 = (state)=>$424c5f2057b4a72b$export$1933a9fe712fc1fd(state)[0, $41ce9b5576b92b7a$export$f8f7545d2bb78afb];
const $424c5f2057b4a72b$export$f08351012de61e58 = (state)=>$424c5f2057b4a72b$export$1933a9fe712fc1fd(state)[0, $41ce9b5576b92b7a$export$a4ad2735b021c132];
const $424c5f2057b4a72b$export$60ee89f2718fc651 = (state)=>$424c5f2057b4a72b$export$1933a9fe712fc1fd(state)[0, $41ce9b5576b92b7a$export$37aee82a3cb1e8f7];
const $424c5f2057b4a72b$export$e4cc6991cb44d849 = (state)=>$424c5f2057b4a72b$export$1933a9fe712fc1fd(state)[0, $41ce9b5576b92b7a$export$68d693c35a8d8866];
const $424c5f2057b4a72b$export$5d6b2188da2fc080 = (0, $dGvGJ.createSelector)([
    $424c5f2057b4a72b$export$b85cb74b5db260e6,
    $424c5f2057b4a72b$export$e4cc6991cb44d849
], (filters, currentAppliedFilters)=>filters.filter((f)=>currentAppliedFilters?.includes(f.id)).map((f)=>f.query).filter(Boolean));
const $424c5f2057b4a72b$export$7ea0d3589e75ea3e = (state)=>$424c5f2057b4a72b$export$1933a9fe712fc1fd(state)[0, $41ce9b5576b92b7a$export$ebb48b08205007c5];
const $424c5f2057b4a72b$export$66fc4c808781b0dd = (0, $dGvGJ.createSelector)([
    $424c5f2057b4a72b$export$7ea0d3589e75ea3e
], (issueTypes)=>{
    if (issueTypes && issueTypes.length) return Number((0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(issueTypes));
    return undefined;
});
const $424c5f2057b4a72b$export$79e3f18eafd008ab = (issue)=>Number(issue.id) < 0;
const $424c5f2057b4a72b$export$3dea766d36a8935f = (filterValues, filteredIssueIds, cards)=>{
    const toFilterableIssue = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(({ id: id, key: key, summary: summary, labels: labels, typeId: typeId, parentId: parentId, assignee: assignee, fixVersions: fixVersions })=>{
        const filterableAssignee = assignee ? {
            id: assignee.id,
            displayName: assignee.displayName
        } : undefined;
        return {
            id: String(id),
            key: key,
            summary: summary,
            labels: labels,
            type: {
                id: String(typeId)
            },
            versionIds: fixVersions,
            parentId: typeof parentId !== 'undefined' && parentId !== null ? String(parentId) : undefined,
            assignee: filterableAssignee
        };
    });
    const issuesContext = cards && cards.length ? {
        list: [],
        hash: {}
    } : undefined;
    if (issuesContext) cards?.filter((card)=>card.typeHierarchyLevel !== (0, $g4tDr.ISSUE_HIERARCHY_LEVEL_EPIC)).forEach((card)=>{
        const filterableIssue = toFilterableIssue(card);
        issuesContext.list.push(filterableIssue);
        issuesContext.hash[card.id] = filterableIssue;
    });
    const filterFunction = (0, $dVREV.createFilterFunction)(filterValues, {
        filteredIssueIds: filteredIssueIds,
        issues: issuesContext
    }, (0, $dVREV.createDefaultMatcherCreators)(), [
        $424c5f2057b4a72b$export$79e3f18eafd008ab
    ]);
    return (issues)=>issues.filter((issue)=>{
            const filterableIssue = toFilterableIssue(issue);
            return filterFunction(filterableIssue);
        });
};

});
parcelRegister("dVREV", function(module, exports) {

$parcel$export(module.exports, "createDefaultMatcherCreators", () => $da698aa4f276c01f$export$551eb27bf5bd708);
$parcel$export(module.exports, "createFilterFunction", () => $da698aa4f276c01f$export$5b4da3e2bd753e6);


var $83R7M = parcelRequire("83R7M");

var $9NUFF = parcelRequire("9NUFF");

var $bOpxF = parcelRequire("bOpxF");

var $2Ol4g = parcelRequire("2Ol4g");

var $kSow3 = parcelRequire("kSow3");

var $91AxA = parcelRequire("91AxA");

var $8wcaA = parcelRequire("8wcaA");

var $7vODb = parcelRequire("7vODb");

var $bliRS = parcelRequire("bliRS");

var $iZeAQ = parcelRequire("iZeAQ");

var $ly5rg = parcelRequire("ly5rg");

var $4nYh7 = parcelRequire("4nYh7");

var $gbBLn = parcelRequire("gbBLn");

var $gw6jA = parcelRequire("gw6jA");
const $da698aa4f276c01f$export$551eb27bf5bd708 = ()=>({
        [(0, $15a528573ccd89ae$export$d597759d33be802e)]: (0, $gbBLn.textMatcherCreator),
        [(0, $15a528573ccd89ae$export$f8f7545d2bb78afb)]: (0, $83R7M.assigneeMatcherCreator),
        [(0, $15a528573ccd89ae$export$37aee82a3cb1e8f7)]: (0, $7vODb.labelMatcherCreator),
        [(0, $15a528573ccd89ae$export$2a4f270075a033de)]: (0, $kSow3.issueParentMatcherCreator),
        [(0, $15a528573ccd89ae$export$401f4b6eda6a369c)]: (0, $91AxA.issueProjectMatcherCreator),
        [(0, $15a528573ccd89ae$export$ebb48b08205007c5)]: (0, $8wcaA.issueTypeMatcherCreator),
        [(0, $15a528573ccd89ae$export$a4ad2735b021c132)]: (0, $gw6jA.versionMatcherCreator),
        [(0, $15a528573ccd89ae$export$68d693c35a8d8866)]: (0, $2Ol4g.filteredIssueIdsMatcherCreator),
        [(0, $15a528573ccd89ae$export$af1e30ebbae9df3b)]: (0, $9NUFF.componentMatcherCreator),
        [(0, $15a528573ccd89ae$export$92ab80c1dc9baf44)]: (0, $bliRS.requestTypeMatcherCreator),
        [(0, $15a528573ccd89ae$export$f863b019d19144f4)]: (0, $ly5rg.statusCategoryMatcherCreator),
        [(0, $15a528573ccd89ae$export$e50006273435e7d4)]: (0, $4nYh7.statusMatcherCreator),
        [(0, $15a528573ccd89ae$export$1ea95b94fb0c51d9)]: (0, $2Ol4g.filteredIssueIdsMatcherCreator),
        [(0, $15a528573ccd89ae$export$a316570a0dbfd2b0)]: (0, $iZeAQ.sprintMatcherCreator),
        [(0, $15a528573ccd89ae$export$871e58afc769b358)]: (0, $2Ol4g.filteredIssueIdsMatcherCreator),
        [(0, $15a528573ccd89ae$export$db362e2d293fe52e)]: (0, $bOpxF.dependenciesMatcherCreator)
    });
const $da698aa4f276c01f$var$createMatchers = (filter, context, matcherCreators)=>Object.keys(filter).reduce((acc, key)=>{
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Filters'.
        const filterValue = filter[key];
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'MatcherCreators<Issue>'.
        const matcherCreator = matcherCreators[key];
        if (filterValue === undefined || filterValue.length <= 0 || matcherCreator === undefined) return acc;
        acc.push(matcherCreator(filterValue, context));
        return acc;
    }, []);
const $da698aa4f276c01f$export$5b4da3e2bd753e6 = (filter, context, matcherCreators, overrideMatchers)=>{
    const matchers = $da698aa4f276c01f$var$createMatchers(filter, context, matcherCreators ?? $da698aa4f276c01f$export$551eb27bf5bd708());
    return (issue)=>matchers.every((matcher)=>matcher(issue)) || overrideMatchers !== undefined && overrideMatchers.some((matcher)=>matcher(issue));
};

});
parcelRegister("83R7M", function(module, exports) {

$parcel$export(module.exports, "assigneeMatcherCreator", () => $516b0f9136210863$export$5c453ff7d8a6957f);

var $g5X3G = parcelRequire("g5X3G");

const $516b0f9136210863$export$5c453ff7d8a6957f = (assigneeFilter)=>{
    const assigneeSet = new Set(assigneeFilter);
    return ({ assignee: assignee })=>assignee !== undefined && assigneeSet.has(assignee.id) || assignee === undefined && assigneeSet.has((0, $g5X3G.toAccountId)((0, $15a528573ccd89ae$export$12e572fd459c10dc)));
};

});

parcelRegister("9NUFF", function(module, exports) {

$parcel$export(module.exports, "componentMatcherCreator", () => $f76f751e605f1ced$export$667cab6ac6c65512);

const $f76f751e605f1ced$export$667cab6ac6c65512 = (componentFilter)=>{
    const componentSet = new Set(componentFilter);
    return ({ componentIds: componentIds })=>componentIds !== undefined && (componentIds.some((componentId)=>componentSet.has(componentId)) || componentIds.length === 0 && componentSet.has((0, $15a528573ccd89ae$export$4b7c755e61199a36)));
};

});

parcelRegister("bOpxF", function(module, exports) {

$parcel$export(module.exports, "dependenciesMatcherCreator", () => $03061179e3dc93a9$export$18a8a0a9891403f1);

var $kIDH3 = parcelRequire("kIDH3");
const $03061179e3dc93a9$export$18a8a0a9891403f1 = (dependenciesFilter)=>{
    // General rule of dependencies filter is that it should include issues that has at least 1 dependency matches the selected filter.
    // So if off track is selected, it should include issues that has at least 1 off track dependency and vice versa,
    // if on track is selected, it should include issues that has at least 1 on track dependency.
    // If both off track and on track are selected, it should include issues that has at least 1 off track or on track dependency.
    if (dependenciesFilter) {
        const includeOffTrack = dependenciesFilter.includes((0, $kIDH3.DependencyFilterOption).OFF_TRACK);
        const includeOnTrack = dependenciesFilter.includes((0, $kIDH3.DependencyFilterOption).ON_TRACK);
        return (issue)=>includeOffTrack && !!issue.hasOfftrackDependency || includeOnTrack && !!issue.hasOntrackDependency;
    }
    return ()=>true;
};

});
parcelRegister("kIDH3", function(module, exports) {

$parcel$export(module.exports, "DependencyFilterOption", () => $ddac187df0965772$export$499848eca2db01cf);
const $ddac187df0965772$export$499848eca2db01cf = {
    OFF_TRACK: 'off-track',
    ON_TRACK: 'on-track'
};

});


parcelRegister("2Ol4g", function(module, exports) {

$parcel$export(module.exports, "filteredIssueIdsMatcherCreator", () => $497597637c50e49d$export$4493d922cd011b1a);
const $497597637c50e49d$export$4493d922cd011b1a = (value, { filteredIssueIds: filteredIssueIds })=>({ id: id })=>filteredIssueIds !== undefined ? id !== undefined && filteredIssueIds.has(id) : true;

});

parcelRegister("kSow3", function(module, exports) {

$parcel$export(module.exports, "issueParentMatcherCreator", () => $a81202b8afefb6ff$export$4729465fe91e6864);

const $a81202b8afefb6ff$export$4729465fe91e6864 = (issueParentFilter, { issues: issues })=>{
    const issueParentSet = new Set(issueParentFilter);
    const isAncestorInFilter = (id, checked = [])=>{
        if (id === undefined) return issueParentSet.has((0, $9ac224d9ad6eb576$export$794f07be04aca3fe));
        if (issueParentSet.has(id)) return true;
        if (checked.includes(id)) return false;
        if (issues === undefined) return false;
        const issue = issues.hash[id];
        if (issue === undefined) return false;
        const { parentId: parentId } = issue;
        return isAncestorInFilter(parentId, checked.concat(id));
    };
    return ({ id: id, parentId: parentId })=>{
        if (id === undefined) return false;
        if (issueParentSet.has(id)) return true;
        if (id === parentId) return false;
        return isAncestorInFilter(parentId, [
            id
        ]);
    };
};

});
const $9ac224d9ad6eb576$export$794f07be04aca3fe = '0';


parcelRegister("91AxA", function(module, exports) {

$parcel$export(module.exports, "issueProjectMatcherCreator", () => $4fdd97fe73369965$export$b10ee43342090204);
const $4fdd97fe73369965$export$b10ee43342090204 = (projectFilter)=>{
    const projectSet = new Set(projectFilter);
    return ({ projectId: projectId })=>!!projectId && projectSet.has(projectId);
};

});

parcelRegister("8wcaA", function(module, exports) {

$parcel$export(module.exports, "issueTypeMatcherCreator", () => $1427bf4cc0e6bee2$export$48b17418005f8b9b);
const $1427bf4cc0e6bee2$export$48b17418005f8b9b = (issueTypeFilter)=>{
    const issueTypeSet = new Set(issueTypeFilter);
    return ({ type: type })=>issueTypeSet.has(type.id);
};

});

parcelRegister("7vODb", function(module, exports) {

$parcel$export(module.exports, "labelMatcherCreator", () => $40f84c5420493f05$export$71d90ee236f2e796);

const $40f84c5420493f05$export$71d90ee236f2e796 = (labelFilter)=>{
    const labelSet = new Set(labelFilter);
    return ({ labels: labels })=>labels !== undefined && (labels.some((label)=>labelSet.has(label)) || labels.length === 0 && labelSet.has((0, $15a528573ccd89ae$export$81ef49afbbead0a1)));
};

});

parcelRegister("bliRS", function(module, exports) {

$parcel$export(module.exports, "requestTypeMatcherCreator", () => $0e9572c0a83b3cdc$export$d04e41d82fbfb8ba);
const $0e9572c0a83b3cdc$export$d04e41d82fbfb8ba = (requestTypeFilter)=>{
    const requestTypeSet = new Set(requestTypeFilter);
    return ({ requestTypeId: requestTypeId })=>!!requestTypeId && requestTypeSet.has(requestTypeId);
};

});

parcelRegister("iZeAQ", function(module, exports) {

$parcel$export(module.exports, "sprintMatcherCreator", () => $18f99efa97d4433e$export$4706275ba29d0c7);
const $18f99efa97d4433e$export$4706275ba29d0c7 = (sprintFilter)=>({ sprintId: sprintId })=>sprintFilter.includes(sprintId || '');

});

parcelRegister("ly5rg", function(module, exports) {

$parcel$export(module.exports, "statusCategoryMatcherCreator", () => $e669431e48d4db53$export$bb986e45707c6c33);
const $e669431e48d4db53$export$bb986e45707c6c33 = (statusCategoryFilter)=>{
    const statusCategorySet = new Set(statusCategoryFilter);
    return ({ statusCategoryId: statusCategoryId })=>statusCategoryId !== undefined && statusCategorySet.has(statusCategoryId);
};

});

parcelRegister("4nYh7", function(module, exports) {

$parcel$export(module.exports, "statusMatcherCreator", () => $931417eb46388f8b$export$c61724a440d8ea1d);
const $931417eb46388f8b$export$c61724a440d8ea1d = (statusFilter)=>{
    const statusSet = new Set(statusFilter);
    return ({ statusId: statusId })=>!!statusId && statusSet.has(statusId);
};

});

parcelRegister("gbBLn", function(module, exports) {

$parcel$export(module.exports, "textMatcherCreator", () => $b425285590e5a6aa$export$71a22d4a5d2891fc);

var $8QDwl = parcelRequire("8QDwl");

var $gJBT6 = parcelRequire("gJBT6");
const $b425285590e5a6aa$export$f3f2882e8b11d731 = (text)=>text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
const $b425285590e5a6aa$var$doesSummaryContainText = (summary, lowercaseText)=>summary.toLowerCase().includes(lowercaseText) || $b425285590e5a6aa$export$f3f2882e8b11d731(summary).toLowerCase().includes(lowercaseText);
const $b425285590e5a6aa$var$doesIssueKeyMatchLoosely = (key, lowercaseText)=>key !== undefined && key?.toLowerCase().includes(lowercaseText);
const $b425285590e5a6aa$var$createDisplayNameChecker = (text)=>{
    // It transforms a text to a regular expression.
    // eg: text='mi ze', the transformed regexp would be 'mi.*\s+ze'
    // which searches for 'mi' followed by anything then 'ze'.
    const pattern = text.split(/\s+/).map((0, (/*@__PURE__*/$parcel$interopDefault($8QDwl)))).join('.*\\s+');
    const regExp = new RegExp(pattern, 'i');
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((displayName)=>regExp.test(displayName));
};
const $b425285590e5a6aa$export$71a22d4a5d2891fc = (textFilter)=>{
    const lowercaseText = textFilter.toLowerCase();
    const doesDisplayNameMatchRegExp = $b425285590e5a6aa$var$createDisplayNameChecker(textFilter);
    return ({ summary: summary, key: key, assignee: assignee })=>summary && $b425285590e5a6aa$var$doesSummaryContainText(summary, lowercaseText) || $b425285590e5a6aa$var$doesIssueKeyMatchLoosely(key, lowercaseText) || assignee !== undefined && doesDisplayNameMatchRegExp(assignee.displayName);
};

});

parcelRegister("gw6jA", function(module, exports) {

$parcel$export(module.exports, "versionMatcherCreator", () => $f7a5a8a45b854dff$export$fb114a888e0e17b4);

const $f7a5a8a45b854dff$export$fb114a888e0e17b4 = (versionFilter)=>{
    const versionSet = new Set(versionFilter);
    return ({ versionIds: versionIds })=>versionIds !== undefined && (versionIds.some((versionId)=>versionSet.has(versionId)) || versionIds.length === 0 && versionSet.has((0, $15a528573ccd89ae$export$ac95b4b2317d4b33)));
};

});



parcelRegister("fmuR9", function(module, exports) {

$parcel$export(module.exports, "getIssueParents", () => $d93b8942be551a65$export$df9259146e40d32c);
$parcel$export(module.exports, "issueParentsSelector", () => $d93b8942be551a65$export$27ed9219e3872aed);
$parcel$export(module.exports, "issueParentsToListItemSelector", () => $d93b8942be551a65$export$ed2bad70f85ffb04);
$parcel$export(module.exports, "issueParentIdsSelector", () => $d93b8942be551a65$export$e69b35537968b7e1);
$parcel$export(module.exports, "partialIssueParentSelector", () => $d93b8942be551a65$export$3e87abb8e670325c);
$parcel$export(module.exports, "issueParentTypeIdsSelector", () => $d93b8942be551a65$export$80f40427dc008040);
$parcel$export(module.exports, "firstParentIssueTypeNameSelector", () => $d93b8942be551a65$export$461364b3b51e10c1);
$parcel$export(module.exports, "filteredParentsSelector", () => $d93b8942be551a65$export$a69ed0ba1bae99d6);
$parcel$export(module.exports, "issueHierarchyLevelSelector", () => $d93b8942be551a65$export$877c3c60e0259f4b);

var $dGvGJ = parcelRequire("dGvGJ");

var $2HfxU = parcelRequire("2HfxU");

var $9XE6b = parcelRequire("9XE6b");

var $gccSB = parcelRequire("gccSB");

var $gJBT6 = parcelRequire("gJBT6");

var $kGsr8 = parcelRequire("kGsr8");

var $g4tDr = parcelRequire("g4tDr");

var $guzeq = parcelRequire("guzeq");

var $e5nhF = parcelRequire("e5nhF");

var $l9VFH = parcelRequire("l9VFH");
const $d93b8942be551a65$export$df9259146e40d32c = (state)=>(0, $e5nhF.getEntities)(state).issueParents;
const $d93b8942be551a65$export$fc955fffc3b3200c = (0, $dGvGJ.createSelector)([
    $d93b8942be551a65$export$df9259146e40d32c
], (issueParents)=>{
    const issueParentById = (parentId)=>issueParents[String(parentId)] || null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(issueParentById);
});
const $d93b8942be551a65$export$27ed9219e3872aed = (0, $dGvGJ.createSelector)([
    $d93b8942be551a65$export$df9259146e40d32c,
    (0, $e5nhF.getIssueParentsOrderIds)
], (issueParents, issueParentsOrderIds)=>issueParentsOrderIds.reduce((issueParentsArray, issueParentId)=>{
        const issueParent = issueParents[issueParentId];
        issueParent && issueParentsArray.push(issueParent);
        return issueParentsArray;
    }, []));
const $d93b8942be551a65$export$ed2bad70f85ffb04 = (0, $dGvGJ.createSelector)($d93b8942be551a65$export$27ed9219e3872aed, (issueParents)=>issueParents.map(({ id: id, summary: summary })=>({
            id: String(id),
            name: summary
        })));
const $d93b8942be551a65$export$e69b35537968b7e1 = (0, $dGvGJ.createSelector)($d93b8942be551a65$export$df9259146e40d32c, (issueParents)=>Object.keys(issueParents));
const $d93b8942be551a65$export$3e87abb8e670325c = (0, $dGvGJ.createSelector)($d93b8942be551a65$export$27ed9219e3872aed, (issueParents)=>issueParents.map(({ id: id, summary: summary, issueType: issueType, key: key })=>({
            id: id,
            summary: summary,
            key: key,
            issueType: issueType
        })));
const $d93b8942be551a65$export$80f40427dc008040 = (0, $dGvGJ.createSelector)($d93b8942be551a65$export$27ed9219e3872aed, (issueParents)=>(0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))(issueParents.map(({ issueType: issueType })=>issueType?.id)));
const $d93b8942be551a65$export$461364b3b51e10c1 = (0, $dGvGJ.createSelector)($d93b8942be551a65$export$27ed9219e3872aed, (issueParents)=>issueParents ? (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))((0, (/*@__PURE__*/$parcel$interopDefault($2HfxU)))(issueParents), [
        'issueType',
        'name'
    ], (0, $guzeq.DEFAULT_PARENT_ISSUE_TYPE_NAME)) : (0, $guzeq.DEFAULT_PARENT_ISSUE_TYPE_NAME));
const $d93b8942be551a65$var$EMPTY_ISSUE_PARENTS = [];
const $d93b8942be551a65$export$a69ed0ba1bae99d6 = (0, $dGvGJ.createSelector)((0, $l9VFH.getAppliedParentFilters), $d93b8942be551a65$export$df9259146e40d32c, (filteredParentIds, issueParents)=>!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filteredParentIds) ? filteredParentIds?.map((filteredParentId)=>issueParents?.[filteredParentId]).filter(Boolean) || $d93b8942be551a65$var$EMPTY_ISSUE_PARENTS : $d93b8942be551a65$var$EMPTY_ISSUE_PARENTS);
const $d93b8942be551a65$export$877c3c60e0259f4b = (0, $dGvGJ.createSelector)([], ()=>{
    const getIssueHierarchyLevel = (isEpicPanel = false)=>isEpicPanel ? (0, $g4tDr.ISSUE_HIERARCHY_LEVEL_EPIC) : (0, $g4tDr.ISSUE_HIERARCHY_LEVEL_BASE);
    return getIssueHierarchyLevel;
});

});
parcelRegister("2HfxU", function(module, exports) {

module.exports = (parcelRequire("bH3EF"));

});
parcelRegister("bH3EF", function(module, exports) {
/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */ function $88368ba58341d518$var$head(array) {
    return array && array.length ? array[0] : undefined;
}
module.exports = $88368ba58341d518$var$head;

});



parcelRegister("9ZuIF", function(module, exports) {

$parcel$export(module.exports, "getCurrentUser", () => $944a15bb4c308ca0$export$e5432d4c8eb97ea7);
$parcel$export(module.exports, "isCurrentUserLoaded", () => $944a15bb4c308ca0$export$6b3694fe2dc20c31);

var $alNv9 = parcelRequire("alNv9");
const $944a15bb4c308ca0$export$e5432d4c8eb97ea7 = (state)=>(0, $alNv9.ensureState)(state.entities).currentUser;
const $944a15bb4c308ca0$export$6b3694fe2dc20c31 = (state)=>$944a15bb4c308ca0$export$e5432d4c8eb97ea7(state) !== null;

});

parcelRegister("fpDLy", function(module, exports) {

$parcel$export(module.exports, "getEntitiesVersions", () => $019de366069e2a30$export$6dd679056b6b958c);
$parcel$export(module.exports, "getVersionsOrder", () => $019de366069e2a30$export$5b7ad9152ad991bf);
$parcel$export(module.exports, "isVersionsFeatureEnabled", () => $019de366069e2a30$export$5f0729b6671904c3);

var $24ebX = parcelRequire("24ebX");

var $e5nhF = parcelRequire("e5nhF");
const $019de366069e2a30$var$getConfig = (state)=>state.config;
const $019de366069e2a30$export$6dd679056b6b958c = (state)=>(0, $e5nhF.getEntities)(state).versions;
const $019de366069e2a30$export$5b7ad9152ad991bf = (state)=>(0, $e5nhF.getEntities)(state).version.versions;
const $019de366069e2a30$export$5f0729b6671904c3 = (0, $24ebX.createSelector)([
    $019de366069e2a30$var$getConfig
], (config)=>config.version.isVersionsFeatureEnabled || false);

});
parcelRegister("24ebX", function(module, exports) {

$parcel$export(module.exports, "createWeakMapSelector", () => $f4af8f8b2496e057$export$3a90d1d234e724b5);
$parcel$export(module.exports, "createSelector", () => $f4af8f8b2496e057$export$595d22ed68ca2841);
// @ts-expect-error - TS2305 - Module '"reselect"' has no exported member 'SelectorCreator'.

var $dGvGJ = parcelRequire("dGvGJ");

var $eKGsF = parcelRequire("eKGsF");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $f4af8f8b2496e057$var$weakMapMemoize = (func)=>{
    const memorizer = (0, $eKGsF.createMemorizer)();
    // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    return (...args)=>{
        const cached = memorizer.read(args);
        if (cached !== undefined) return (0, $eKGsF.toReturnValue)(cached);
        const result = func.apply(func, args);
        memorizer.store(args, result);
        return result;
    };
};
const $f4af8f8b2496e057$export$3a90d1d234e724b5 = (0, $dGvGJ.createSelectorCreator)($f4af8f8b2496e057$var$weakMapMemoize);
const $f4af8f8b2496e057$export$595d22ed68ca2841 = (0, $dGvGJ.createSelectorCreator)((0, $dGvGJ.defaultMemoize));

});
parcelRegister("eKGsF", function(module, exports) {

$parcel$export(module.exports, "toReturnValue", () => $a725e29cfc60dcfc$export$9f3707bed4fc53c8);
$parcel$export(module.exports, "createMemorizer", () => $a725e29cfc60dcfc$export$9db09f4ba21f9d2a);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a725e29cfc60dcfc$var$UNDEFINED = {};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a725e29cfc60dcfc$var$NULL = {};
const $a725e29cfc60dcfc$export$7abc386bcfed62e1 = (key)=>{
    if (key === undefined) return $a725e29cfc60dcfc$var$UNDEFINED;
    if (key === null) return $a725e29cfc60dcfc$var$NULL;
    return key;
};
const $a725e29cfc60dcfc$export$9f3707bed4fc53c8 = (x)=>{
    if (x === $a725e29cfc60dcfc$var$UNDEFINED) return undefined;
    if (x === $a725e29cfc60dcfc$var$NULL) return null;
    return x;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a725e29cfc60dcfc$var$getFromWeakMapChain = (args, index, map)=>{
    const element = map.get($a725e29cfc60dcfc$export$7abc386bcfed62e1(args[index]));
    if (index < args.length - 1) {
        if (element) return $a725e29cfc60dcfc$var$getFromWeakMapChain(args, index + 1, element);
        return undefined;
    }
    return element;
};
const $a725e29cfc60dcfc$var$storeToEmptyWeakMapChain = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
args, index, // eslint-disable-next-line @typescript-eslint/no-explicit-any
map, // eslint-disable-next-line @typescript-eslint/no-explicit-any
result)=>{
    if (index < args.length - 1) {
        const subMap = new WeakMap();
        map.set($a725e29cfc60dcfc$export$7abc386bcfed62e1(args[index]), subMap);
        $a725e29cfc60dcfc$var$storeToEmptyWeakMapChain(args, index + 1, subMap, result);
    } else map.set($a725e29cfc60dcfc$export$7abc386bcfed62e1(args[index]), result);
};
const $a725e29cfc60dcfc$var$storeToWeakMapChain = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
args, index, // eslint-disable-next-line @typescript-eslint/no-explicit-any
map, // eslint-disable-next-line @typescript-eslint/no-explicit-any
result)=>{
    if (index < args.length - 1) {
        const element = map.get($a725e29cfc60dcfc$export$7abc386bcfed62e1(args[index]));
        if (element) $a725e29cfc60dcfc$var$storeToWeakMapChain(args, index + 1, element, result);
        else {
            const subMap = new WeakMap();
            map.set($a725e29cfc60dcfc$export$7abc386bcfed62e1(args[index]), subMap);
            // we know that from now on, all chain elements need to be new maps,
            // so we move to a slightly more performent recursion
            $a725e29cfc60dcfc$var$storeToEmptyWeakMapChain(args, index + 1, subMap, result);
        }
    } else map.set($a725e29cfc60dcfc$export$7abc386bcfed62e1(args[index]), result);
};
const $a725e29cfc60dcfc$export$9db09f4ba21f9d2a = ()=>{
    const weakMap = new WeakMap();
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        store: (args, result)=>result !== undefined ? $a725e29cfc60dcfc$var$storeToWeakMapChain(args, 0, weakMap, result) : $a725e29cfc60dcfc$var$storeToWeakMapChain(args, 0, weakMap, $a725e29cfc60dcfc$var$UNDEFINED),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        read: (args)=>$a725e29cfc60dcfc$var$getFromWeakMapChain(args, 0, weakMap)
    };
};

});




parcelRegister("iXH87", function(module, exports) {

$parcel$export(module.exports, "default", () => $7eb23df8fb7f3b4f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3KRpp = parcelRequire("3KRpp");

var $5Zxxp = parcelRequire("5Zxxp");

var $koVbs = parcelRequire("koVbs");


var $gOlJR = parcelRequire("gOlJR");
function $7eb23df8fb7f3b4f$export$2e2bcd8739ae039({ failedCount: failedCount, id: flagId, onRetry: onRetry, onViewSummary: onViewSummary, totalCount: totalCount, onDismissed: onDismissed, showRetryButton: showRetryButton, showViewSummaryButton: showViewSummaryButton, showSelectFailedItemsButton: showSelectFailedItemsButton, showLearnMoreButton: showLearnMoreButton, failureReason: failureReason, onSelectFailedItems: onSelectFailedItems }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const openInProductHelp = (0, $5Zxxp.useHelpPanelLink)();
    const didAllUpdatesFail = failedCount === totalCount;
    const actions = (0, $5uXOq.useMemo)(()=>{
        const flagActions = [];
        if (showSelectFailedItemsButton) flagActions.push({
            content: formatMessage((0, $gOlJR.default).selectFailedActionContent),
            onClick: onSelectFailedItems
        });
        if (showRetryButton) flagActions.push({
            content: formatMessage((0, $gOlJR.default).retryActionContent),
            onClick: onRetry
        });
        if (showViewSummaryButton) flagActions.push({
            content: formatMessage((0, $gOlJR.default).viewSummaryActionContent),
            onClick: onViewSummary
        });
        if (showLearnMoreButton) flagActions.push({
            content: formatMessage((0, $gOlJR.default).learnMoreActionContent),
            onClick: ()=>openInProductHelp((0, $0722405d3fdf7822$export$8f3a5e9fd2211cd2))
        });
        return flagActions;
    }, [
        showRetryButton,
        showViewSummaryButton,
        formatMessage,
        onRetry,
        onViewSummary,
        onSelectFailedItems,
        showSelectFailedItemsButton,
        openInProductHelp,
        showLearnMoreButton
    ]);
    const title = didAllUpdatesFail ? formatMessage((0, $gOlJR.default).flagTitleError) : formatMessage((0, $gOlJR.default).flagTitlePartialError, {
        failedCount: failedCount,
        totalCount: totalCount
    });
    const description = showRetryButton ? formatMessage((0, $gOlJR.default).flagDescriptionError) : formatMessage((0, $gOlJR.default).flagDescriptionErrorTryLater);
    const validationErrorDescription = formatMessage((0, $gOlJR.default).flagDescriptionValidationError);
    const networkErrorDescriptionTryLater = formatMessage((0, $gOlJR.default).flagDescriptionNetworkError);
    const descriptionMap = {
        network: showRetryButton ? description : networkErrorDescriptionTryLater,
        validation: validationErrorDescription,
        server: description,
        mixed: description
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.ErrorFlag), {
        id: flagId,
        onDismissed: onDismissed,
        title: title,
        description: descriptionMap[failureReason],
        actions: actions,
        testId: "software-backlog.flags.bulk-actions.error.bulk-actions-failed-flag"
    });
}

});
const $0722405d3fdf7822$export$8f3a5e9fd2211cd2 = '62h4g5fA9BUhungZSSNyEl';

parcelRegister("gOlJR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cd682ff44ff9fa0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1cd682ff44ff9fa0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    retryActionContent: {
        "id": "backlog.flags.bulk-actions.error.retry-action-content",
        "defaultMessage": "Try again"
    },
    viewSummaryActionContent: {
        "id": "backlog.flags.bulk-actions.error.view-summary-action-content",
        "defaultMessage": "View summary"
    },
    selectFailedActionContent: {
        "id": "backlog.flags.bulk-actions.error.select-failed-action-content",
        "defaultMessage": "Select failed items"
    },
    learnMoreActionContent: {
        "id": "backlog.flags.bulk-actions.error.learn-more-action-content",
        "defaultMessage": "Learn more"
    },
    flagTitleError: {
        "id": "backlog.flags.bulk-actions.error.flag-title-error",
        "defaultMessage": "Failed to update"
    },
    flagTitlePartialError: {
        "id": "backlog.flags.bulk-actions.error.flag-title-partial-error",
        "defaultMessage": "{failedCount}/{totalCount} {totalCount, plural, one {items} other {items}} not updated"
    },
    flagDescriptionError: {
        "id": "backlog.flags.bulk-actions.error.flag-description-error",
        "defaultMessage": "We were unable to update some of the items. Try again, or view the items that failed to update."
    },
    flagDescriptionErrorTryLater: {
        "id": "backlog.flags.bulk-actions.error.flag-description-error-try-later",
        "defaultMessage": "You can view the items that failed to update in a new tab, or wait a few minutes and try again."
    },
    flagDescriptionNetworkError: {
        "id": "backlog.flags.bulk-actions.error.flag-description-network-error",
        "defaultMessage": "There might be something wrong with the connection. Wait a few minutes, then try again."
    },
    flagDescriptionValidationError: {
        "id": "backlog.flags.bulk-actions.error.flag-description-validation-error",
        "defaultMessage": "The items might not be editable, or you may require permissions. Select the failed items to try again, or view a summary of the failed items."
    }
});

});



parcelRegister("dpfT9", function(module, exports) {

$parcel$export(module.exports, "default", () => $899cbbc8a3182d22$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $dfMzt = parcelRequire("dfMzt");

var $38qhf = parcelRequire("38qhf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $1z1J7 = parcelRequire("1z1J7");

var $aMEh9 = parcelRequire("aMEh9");
const $899cbbc8a3182d22$var$getActiveCustomFilterIds = (state)=>state.ui.filters.CUSTOM_FILTER || [];
const $899cbbc8a3182d22$var$isCustomFiltersActive = (state)=>$899cbbc8a3182d22$var$getActiveCustomFilterIds(state).length > 0;
const $899cbbc8a3182d22$var$mapStateToProps = (state, { cardIds: cardIds })=>({
        cards: (0, $dGljH.partialCardsFromCardIdsSelector)(state)(cardIds),
        showCustomFiltersSettingsLink: (0, $1z1J7.canEditBoardConfig)(state) && $899cbbc8a3182d22$var$isCustomFiltersActive(state),
        customFiltersSettingsUrl: (0, $dfMzt.getCustomFiltersSettingsUrl)((0, $jG5HW.getProjectKey)(state), (0, $jG5HW.getRapidViewId)(state))
    });
const $899cbbc8a3182d22$var$mapDispatchToProps = {
    onViewIssue: (0, $38qhf.openDetailView)
};
const $899cbbc8a3182d22$export$9d1611c77c2fe928 = (stateProps, dispatchProps, { id: id, onDismissed: onDismissed })=>({
        id: id,
        onDismissed: onDismissed,
        ...stateProps,
        ...dispatchProps
    });
var $899cbbc8a3182d22$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($899cbbc8a3182d22$var$mapStateToProps, $899cbbc8a3182d22$var$mapDispatchToProps, $899cbbc8a3182d22$export$9d1611c77c2fe928)((0, $aMEh9.default));

});
parcelRegister("dfMzt", function(module, exports) {

$parcel$export(module.exports, "getColumnStatusMappingUrl", () => $f6db5d87cddd7a75$export$5eee224adec4e661);
$parcel$export(module.exports, "getCustomFiltersSettingsUrl", () => $f6db5d87cddd7a75$export$15f763506e87c58e);
$parcel$export(module.exports, "getCustomFilterFromUrlQuery", () => $f6db5d87cddd7a75$export$7076eae01bf61f73);

var $ebyGx = parcelRequire("ebyGx");

var $f01qr = parcelRequire("f01qr");
const $f6db5d87cddd7a75$export$5eee224adec4e661 = (projectKey, boardId)=>`/jira/software/projects/${projectKey}/settings/boards/${boardId}/columns`;
const $f6db5d87cddd7a75$export$15f763506e87c58e = (projectKey, boardId)=>`/jira/software/projects/${projectKey}/settings/boards/${boardId}/custom-filters`;
const $f6db5d87cddd7a75$export$7076eae01bf61f73 = ({ search: search })=>{
    const queryParameters = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(search);
    if (queryParameters?.customFilter) return (0, $f01qr.toArray)(queryParameters.customFilter);
    if (queryParameters.quickFilter) return (0, $f01qr.toArray)(queryParameters.quickFilter);
    return undefined;
};

});

parcelRegister("38qhf", function(module, exports) {

$parcel$export(module.exports, "OPEN_DETAIL_VIEW", () => $5b286b4f283f0f82$export$674d39029d0816cc);
$parcel$export(module.exports, "openDetailView", () => $5b286b4f283f0f82$export$d412abc3bc336eb6);
$parcel$export(module.exports, "OPEN_DETAIL_VIEW_DEBOUNCED", () => $5b286b4f283f0f82$export$372223232eefdb08);
$parcel$export(module.exports, "openDetailViewDebounced", () => $5b286b4f283f0f82$export$9147c3f14f6ec3b9);
$parcel$export(module.exports, "UPDATE_DETAIL_VIEW", () => $5b286b4f283f0f82$export$e38020a85931f37e);
$parcel$export(module.exports, "updateDetailView", () => $5b286b4f283f0f82$export$d5df566661a69c2d);
$parcel$export(module.exports, "CLOSE_DETAIL_VIEW", () => $5b286b4f283f0f82$export$c22445a1fd3a65ce);
$parcel$export(module.exports, "closeDetailView", () => $5b286b4f283f0f82$export$b996efd4b4df6740);
const $5b286b4f283f0f82$export$674d39029d0816cc = 'state.actions.detail-view.OPEN_DETAIL_VIEW';
const $5b286b4f283f0f82$export$d412abc3bc336eb6 = (cardId, externalAction)=>({
        type: $5b286b4f283f0f82$export$674d39029d0816cc,
        payload: {
            cardId: cardId,
            externalAction: externalAction
        }
    });
const $5b286b4f283f0f82$export$372223232eefdb08 = 'state.actions.detail-view.OPEN_DETAIL_VIEW_DEBOUNCED';
const $5b286b4f283f0f82$export$9147c3f14f6ec3b9 = (cardId, externalAction)=>({
        type: $5b286b4f283f0f82$export$372223232eefdb08,
        payload: {
            cardId: cardId,
            externalAction: externalAction
        }
    });
const $5b286b4f283f0f82$export$e38020a85931f37e = 'state.actions.detail-view.UPDATE_DETAIL_VIEW';
const $5b286b4f283f0f82$export$d5df566661a69c2d = ()=>({
        type: $5b286b4f283f0f82$export$e38020a85931f37e
    });
const $5b286b4f283f0f82$export$c22445a1fd3a65ce = 'state.actions.detail-view.CLOSE_DETAIL_VIEW';
const $5b286b4f283f0f82$export$b996efd4b4df6740 = (issueId)=>({
        type: $5b286b4f283f0f82$export$c22445a1fd3a65ce,
        payload: {
            issueId: issueId
        }
    });

});

parcelRegister("1z1J7", function(module, exports) {

$parcel$export(module.exports, "getPermissions", () => $3cd8560dd862a6b3$export$e10fd44ca431fa8e);
$parcel$export(module.exports, "canViewBoard", () => $3cd8560dd862a6b3$export$86298d668b506539);
$parcel$export(module.exports, "canEditBoardConfig", () => $3cd8560dd862a6b3$export$6dd65380225d5199);
$parcel$export(module.exports, "canManageSprints", () => $3cd8560dd862a6b3$export$8830b0b3ee0a6ade);
$parcel$export(module.exports, "canCreateIssues", () => $3cd8560dd862a6b3$export$38d976fa7e28ee53);
$parcel$export(module.exports, "canEditIssue", () => $3cd8560dd862a6b3$export$3f2995080649d07c);
$parcel$export(module.exports, "canDeleteIssues", () => $3cd8560dd862a6b3$export$f9d3b77685359020);
$parcel$export(module.exports, "canAssignIssues", () => $3cd8560dd862a6b3$export$5df0ca7091398ef7);
$parcel$export(module.exports, "canTransitionIssues", () => $3cd8560dd862a6b3$export$e03f24612ae6fce6);
$parcel$export(module.exports, "canBulkEditIssues", () => $3cd8560dd862a6b3$export$793ca6e17cc6edb8);

const $3cd8560dd862a6b3$export$e10fd44ca431fa8e = (state)=>state.config.permissions;
const $3cd8560dd862a6b3$export$86298d668b506539 = (state)=>$3cd8560dd862a6b3$export$e10fd44ca431fa8e(state)[0, $a33d0dff7e784665$export$feb9a4de117c162] || false;
const $3cd8560dd862a6b3$export$6dd65380225d5199 = (state)=>$3cd8560dd862a6b3$export$e10fd44ca431fa8e(state)[0, $a33d0dff7e784665$export$b35e3ebf2c83a499] || false;
const $3cd8560dd862a6b3$export$8830b0b3ee0a6ade = (state)=>$3cd8560dd862a6b3$export$e10fd44ca431fa8e(state)[0, $a33d0dff7e784665$export$d765836bd761b2ee] || false;
const $3cd8560dd862a6b3$export$38d976fa7e28ee53 = (state)=>$3cd8560dd862a6b3$export$e10fd44ca431fa8e(state)[0, $a33d0dff7e784665$export$526c94c551c00291] || false;
const $3cd8560dd862a6b3$export$3f2995080649d07c = (state)=>$3cd8560dd862a6b3$export$e10fd44ca431fa8e(state)[0, $a33d0dff7e784665$export$8a1ecb9983951227] || false;
const $3cd8560dd862a6b3$export$f9d3b77685359020 = (state)=>$3cd8560dd862a6b3$export$e10fd44ca431fa8e(state)[0, $a33d0dff7e784665$export$a20ec683078f5f77] || false;
const $3cd8560dd862a6b3$export$5df0ca7091398ef7 = (state)=>$3cd8560dd862a6b3$export$e10fd44ca431fa8e(state)[0, $a33d0dff7e784665$export$9c0523cef5fab15e] || false;
const $3cd8560dd862a6b3$export$e03f24612ae6fce6 = (state)=>$3cd8560dd862a6b3$export$e10fd44ca431fa8e(state)[0, $a33d0dff7e784665$export$b5f3bd28b6a935be] || false;
const $3cd8560dd862a6b3$export$793ca6e17cc6edb8 = (state)=>$3cd8560dd862a6b3$export$e10fd44ca431fa8e(state)[0, $a33d0dff7e784665$export$a71edb30f3453bef] || false;

});
const $a33d0dff7e784665$export$feb9a4de117c162 = 'CAN_VIEW_BOARD';
const $a33d0dff7e784665$export$a71edb30f3453bef = 'CAN_BULK_CHANGE_ISSUES';
const $a33d0dff7e784665$export$b35e3ebf2c83a499 = 'CAN_EDIT_BOARD_CONFIG';
const $a33d0dff7e784665$export$d765836bd761b2ee = 'CAN_MANAGE_SPRINTS';
const $a33d0dff7e784665$export$526c94c551c00291 = 'CAN_CREATE_ISSUES';
const $a33d0dff7e784665$export$8a1ecb9983951227 = 'CAN_EDIT_ISSUES';
const $a33d0dff7e784665$export$a20ec683078f5f77 = 'CAN_DELETE_ISSUES';
const $a33d0dff7e784665$export$9c0523cef5fab15e = 'CAN_ASSIGN_ISSUES';
const $a33d0dff7e784665$export$b5f3bd28b6a935be = 'CAN_TRANSITION_ISSUES';
const $a33d0dff7e784665$export$e6bcada406923d66 = 'CAN_ARCHIVE_ISSUE';


parcelRegister("aMEh9", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b18d4a8086f34f0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $e4yMr = parcelRequire("e4yMr");

var $4R6GH = parcelRequire("4R6GH");

var $6s1PB = parcelRequire("6s1PB");

var $3KRpp = parcelRequire("3KRpp");

var $8Q4sF = parcelRequire("8Q4sF");

var $koVbs = parcelRequire("koVbs");

var $14uhY = parcelRequire("14uhY");

var $jQ7vZ = parcelRequire("jQ7vZ");


var $1RaZ1 = parcelRequire("1RaZ1");
const $8b18d4a8086f34f0$var$linkStart = '{linkStart}';
const $8b18d4a8086f34f0$var$linkEnd = '{linkEnd}';
const $8b18d4a8086f34f0$var$getIssueLink = (key)=>`/browse/${key}`;
const $8b18d4a8086f34f0$var$CardCreateFiltered = ({ cards: cards, id: id, onDismissed: onDismissed, onViewIssue: onViewIssue, customFiltersSettingsUrl: customFiltersSettingsUrl, showCustomFiltersSettingsLink: showCustomFiltersSettingsLink })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [, setIssueKey] = (0, $jQ7vZ.useQueryParam)((0, $4f4a02cead13bb5a$export$3a0c4bc79274bbaa));
    const onActionClick = (0, $5uXOq.useCallback)(()=>{
        (0, $14uhY.setReturnToProjectUrl)();
    }, []);
    const onClickSingleCard = (0, $5uXOq.useCallback)((e)=>{
        if (cards.length === 1) {
            e.preventDefault();
            onViewIssue(cards[0].id);
            setIssueKey(cards[0].key);
        }
    }, [
        cards,
        onViewIssue,
        setIssueKey
    ]);
    const actions = [
        ...showCustomFiltersSettingsLink ? [
            {
                content: formatMessage((0, $1RaZ1.default).settingsLink),
                href: customFiltersSettingsUrl,
                target: '_blank',
                onClick: onActionClick
            }
        ] : []
    ];
    const isSingle = cards.length === 1;
    if (isSingle) {
        const card = cards[0];
        const issueLinkComponent = ()=>(0, $4R6GH.fg)('replace-anchor-with-link__a4t-tanuki') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
                href: $8b18d4a8086f34f0$var$getIssueLink(card.key),
                onClick: onClickSingleCard
            }, card.key) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
                href: $8b18d4a8086f34f0$var$getIssueLink(card.key),
                onClick: onClickSingleCard
            }, card.key);
        const getDescription = ()=>{
            if ((0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return (0, $1RaZ1.default).issueHiddenDescriptionIssueTerminologyRefreshM4;
            if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return (0, $1RaZ1.default).issueHiddenDescriptionIssueTermRefresh;
            return (0, $1RaZ1.default).issueHiddenDescription;
        };
        const getTitle = ()=>{
            if ((0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return (0, $1RaZ1.default).issueHiddenTitleIssueTerminologyRefreshM4;
            if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return (0, $1RaZ1.default).issueHiddenTitleIssueTermRefresh;
            return (0, $1RaZ1.default).issueHiddenTitle;
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.SuccessAutoDismissFlag), {
            id: id,
            onDismissed: onDismissed,
            title: formatMessage(getTitle(), {
                workType: card.issueTypeName
            }),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Q4sF.FormattedI18nMessage), {
                message: formatMessage(getDescription(), {
                    linkStart: $8b18d4a8086f34f0$var$linkStart,
                    linkEnd: $8b18d4a8086f34f0$var$linkEnd,
                    workType: card.issueTypeName
                }),
                componentsMapping: {
                    link: issueLinkComponent
                }
            }),
            actions: [
                {
                    content: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1RaZ1.default).issueLinkIssueTermRefresh : (0, $1RaZ1.default).issueLink),
                    onClick: onClickSingleCard,
                    href: $8b18d4a8086f34f0$var$getIssueLink(card.key)
                },
                ...actions
            ]
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.SuccessAutoDismissFlag), {
        id: id,
        onDismissed: onDismissed,
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1RaZ1.default).multipleIssuesHiddenTitleIssueTermRefresh : (0, $1RaZ1.default).multipleIssuesHiddenTitle),
        description: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1RaZ1.default).multipleIssuesHiddenDescriptionIssueTermRefresh : (0, $1RaZ1.default).multipleIssuesHiddenDescription),
        actions: actions
    });
};
var $8b18d4a8086f34f0$export$2e2bcd8739ae039 = $8b18d4a8086f34f0$var$CardCreateFiltered;

});
parcelRegister("8Q4sF", function(module, exports) {

$parcel$export(module.exports, "FormattedI18nMessage", () => $7c8c20575fbc9bfc$export$200d7bd7633253ce);

var $5uXOq = parcelRequire("5uXOq");

var $gHDlh = parcelRequire("gHDlh");

var $9Byym = parcelRequire("9Byym");
const $7c8c20575fbc9bfc$export$200d7bd7633253ce = (props)=>{
    const { message: message, packageName: packageName, componentsMapping: componentsMapping } = props;
    const messageParts = (0, $5uXOq.useMemo)(()=>{
        const { tags: tags, openTags: openTags, closeTags: closeTags } = (0, $9Byym.getTags)(componentsMapping);
        try {
            const parts = [];
            let token = '';
            let TagComponent;
            let closeTagLookup;
            for(let i = 0; i < message.length; i += 1){
                const letter = message[i];
                token += letter;
                if ((0, $9Byym.isCloseTagDelimiter)(letter)) {
                    const firstTagFound = (0, $9Byym.findTag)(token, {
                        tags: openTags
                    });
                    if (firstTagFound !== null && firstTagFound !== undefined) {
                        // if we have a tag already means it is a malformed message since it is 2 subsequent open tags
                        if (TagComponent) throw new (0, $gHDlh.MalformedMessageError)();
                        const text = token.replace(firstTagFound, '');
                        parts.push(text);
                        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
                        const tagInfo = tags[firstTagFound];
                        TagComponent = tagInfo.component;
                        closeTagLookup = tagInfo.close;
                        token = '';
                    }
                }
                if (closeTagLookup !== null && closeTagLookup !== undefined && (0, $9Byym.isCloseTagDelimiter)(letter) && (0, $9Byym.isAnyTag)(token, {
                    tags: [
                        closeTagLookup
                    ]
                })) {
                    // this mean that we do not have an open tag for this closing tag
                    if (!TagComponent) throw new (0, $gHDlh.MalformedMessageError)();
                    const text = token.replace(closeTagLookup, '');
                    parts.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TagComponent, null, text));
                    TagComponent = undefined;
                    token = '';
                    closeTagLookup = undefined;
                }
                if ((0, $9Byym.isCloseTagDelimiter)(letter) && (0, $9Byym.isAnyTag)(token, {
                    tags: closeTags
                })) {
                    // if we do not have an open tag mean we are closing a tag that is not open
                    if (!TagComponent) throw new (0, $gHDlh.MalformedMessageError)();
                }
            }
            // if we reached the end and we have an open tag, mean this message is malformed
            if (TagComponent || closeTagLookup) throw new (0, $gHDlh.MalformedMessageError)();
            // flush anything we keep in the current token
            if (token.length > 0) parts.push(token);
            return parts;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e instanceof (0, $gHDlh.MalformedMessageError)) {
                (0, $gHDlh.logMalformedMessageError)({
                    message: message,
                    packageName: packageName
                });
                return [
                    (0, $gHDlh.getMalformedMessage)({
                        message: message,
                        closeTags: closeTags,
                        openTags: openTags
                    })
                ];
            }
            throw e;
        }
    }, [
        message,
        packageName,
        componentsMapping
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, messageParts.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
            key: index
        }, item)));
};

});
parcelRegister("gHDlh", function(module, exports) {

$parcel$export(module.exports, "getMalformedMessage", () => $ecff24857c176a60$export$f085cf20ec1f69ab);
$parcel$export(module.exports, "logMalformedMessageError", () => $ecff24857c176a60$export$954c3e6aad1c9429);
$parcel$export(module.exports, "MalformedMessageError", () => $ecff24857c176a60$export$40d900e818b9630e);

var $2YZCu = parcelRequire("2YZCu");

var $jcw0u = parcelRequire("jcw0u");

const $ecff24857c176a60$export$f085cf20ec1f69ab = ({ message: message, openTags: openTags, closeTags: closeTags })=>[
        ...openTags,
        ...closeTags
    ].reduce((acc, tag)=>acc.replace(new RegExp(tag, 'g'), ''), message);
const $ecff24857c176a60$export$954c3e6aad1c9429 = ({ message: message, packageName: packageName })=>{
    if (packageName !== null && packageName !== undefined) {
        const errorMessage = `Malformed message: ${message}`;
        // Send error log to analytics pipeline (i.e. SFX) and Sentry
        (0, $jcw0u.default)({
            meta: {
                packageName: packageName,
                id: (0, $5514815b06163219$export$f3390a0e172fee41)
            },
            attributes: {
                message: errorMessage
            }
        });
        // Send error log to Splunk
        const location = `${packageName}.${(0, $5514815b06163219$export$f3390a0e172fee41)}`;
        (0, $2YZCu.default).unsafeErrorWithCustomerData(location, errorMessage);
    }
};
class $ecff24857c176a60$export$40d900e818b9630e extends Error {
    constructor(){
        super('Malformed i18n message');
    }
}

});
const $5514815b06163219$export$f3390a0e172fee41 = 'formattedI18NMessage';


parcelRegister("9Byym", function(module, exports) {

$parcel$export(module.exports, "getTags", () => $84498158f946a67b$export$af63d7414243dad3);
$parcel$export(module.exports, "isAnyTag", () => $84498158f946a67b$export$38ffa64fc639355f);
$parcel$export(module.exports, "findTag", () => $84498158f946a67b$export$dfca0f74034f8657);
$parcel$export(module.exports, "isCloseTagDelimiter", () => $84498158f946a67b$export$d5170904651e91b1);

const $84498158f946a67b$export$af63d7414243dad3 = (componentsMapping)=>Object.entries(componentsMapping).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (acc, [key, value])=>{
        const open = `{${key}Start}`;
        const close = `{${key}End}`;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        acc.tags[open] = {
            close: close,
            component: value
        };
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.openTags.push(open);
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.closeTags.push(close);
        return acc;
    }, {
        tags: {},
        openTags: [],
        closeTags: []
    });
const $84498158f946a67b$export$38ffa64fc639355f = (text, { tags: tags })=>tags.some((tag)=>text.includes(tag));
const $84498158f946a67b$export$dfca0f74034f8657 = (text, { tags: tags })=>tags.find((tag)=>text.includes(tag));
const $84498158f946a67b$export$d5170904651e91b1 = (letter)=>letter === (0, $7ed9c0b663db8b35$export$a10c567c3288a6b4);

});
const $7ed9c0b663db8b35$export$a10c567c3288a6b4 = '}';



parcelRegister("14uhY", function(module, exports) {

$parcel$export(module.exports, "setReturnToProjectUrl", () => $5f614763a26e8877$export$127f7bd1c092fc8f);
$parcel$export(module.exports, "getReturnToProjectUrl", () => $5f614763a26e8877$export$575dc7c4a154874b);

var $eNf8a = parcelRequire("eNf8a");
const $5f614763a26e8877$var$RETURN_TO_PROJECT_URL = 'returnToProjectUrl';
const $5f614763a26e8877$var$sessionStorage = (0, $eNf8a.createSessionExpirableStorageProvider)('navigation');
const $5f614763a26e8877$export$127f7bd1c092fc8f = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    $5f614763a26e8877$var$sessionStorage.set($5f614763a26e8877$var$RETURN_TO_PROJECT_URL, window.location.pathname + window.location.search);
};
const $5f614763a26e8877$export$575dc7c4a154874b = ()=>String($5f614763a26e8877$var$sessionStorage.get($5f614763a26e8877$var$RETURN_TO_PROJECT_URL) || '');

});

parcelRegister("jQ7vZ", function(module, exports) {

$parcel$export(module.exports, "useQueryParam", () => $9fff0bf09ea99829$export$ae316f0eeb712a36);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $9xWGk = parcelRequire("9xWGk");

var $ebyGx = parcelRequire("ebyGx");

var $doZTA = parcelRequire("doZTA");
const $9fff0bf09ea99829$export$ae316f0eeb712a36 = (queryParam)=>{
    const [{ location: { pathname: pathname }, query: query }, { push: push }] = (0, $doZTA.useRouter)();
    const queryParamValue = query[queryParam];
    const setQueryParam = (0, $5uXOq.useCallback)((newValue)=>{
        const parsedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($9xWGk)))({
            ...query,
            [queryParam]: newValue
        }, (value)=>(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value));
        const strSearch = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(parsedSearch);
        push(pathname + (strSearch !== '' ? `?${strSearch}` : ''));
    }, [
        pathname,
        push,
        query,
        queryParam
    ]);
    return [
        queryParamValue,
        setQueryParam
    ];
};

});

const $4f4a02cead13bb5a$export$e39925d10cebc0b = 'text';
const $4f4a02cead13bb5a$export$f78d8c81fcad32a2 = 'assignee';
const $4f4a02cead13bb5a$export$e729d951ab128c3b = 'label';
const $4f4a02cead13bb5a$export$3a0c4bc79274bbaa = 'selectedIssue';
const $4f4a02cead13bb5a$export$8a2cab795731dc42 = 'issueParent';
const $4f4a02cead13bb5a$export$7f765927237d6fb0 = 'issueParentPanel';
const $4f4a02cead13bb5a$export$9c304e612707f622 = 'versionPanel';
const $4f4a02cead13bb5a$export$fa7b72626a2e0090 = 'issueType';
const $4f4a02cead13bb5a$export$392308739e657b75 = 'version';
const $4f4a02cead13bb5a$export$cb08ebea4a46cd29 = 'customFilter';
const $4f4a02cead13bb5a$export$61119f100c357d06 = 'isInsightsOpen';
const $4f4a02cead13bb5a$export$ec3c43b997309252 = 'epics';
const $4f4a02cead13bb5a$export$a86c1a6dde9da34f = 'versions';

parcelRegister("1RaZ1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4b7029a91dab57d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e4b7029a91dab57d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    issueHiddenTitle: {
        "id": "backlog.flags.card-create-filtered-v2.issue-hidden-title",
        "defaultMessage": "Changes are saved, but the issue isn\u2019t visible"
    },
    issueHiddenDescription: {
        "id": "backlog.flags.card-create-filtered-v2.issue-hidden-description",
        "defaultMessage": "Issue {linkStart}{linkEnd} is currently hidden by a filter."
    },
    issueLink: {
        "id": "backlog.flags.card-create-filtered-v2.issue-link",
        "defaultMessage": "View issue"
    },
    multipleIssuesHiddenTitle: {
        "id": "backlog.flags.card-create-filtered-v2.multiple-issues-hidden-title",
        "defaultMessage": "Changes are saved, but issues aren't visible"
    },
    multipleIssuesHiddenDescription: {
        "id": "backlog.flags.card-create-filtered-v2.multiple-issues-hidden-description",
        "defaultMessage": "Created issues are currently hidden by a filter."
    },
    settingsLink: {
        "id": "backlog.flags.card-create-filtered-v2.settings-link",
        "defaultMessage": "Manage custom filters"
    },
    issueHiddenTitleIssueTermRefresh: {
        "id": "backlog.flags.card-create-filtered-v2.issue-hidden-title-issue-term-refresh",
        "defaultMessage": "Changes are saved, but the work item isn\u2019t visible"
    },
    issueHiddenDescriptionIssueTermRefresh: {
        "id": "backlog.flags.card-create-filtered-v2.issue-hidden-description-issue-term-refresh",
        "defaultMessage": "Work item {linkStart}{linkEnd} is currently hidden by a filter."
    },
    issueLinkIssueTermRefresh: {
        "id": "backlog.flags.card-create-filtered-v2.issue-link-issue-term-refresh",
        "defaultMessage": "View"
    },
    multipleIssuesHiddenTitleIssueTermRefresh: {
        "id": "backlog.flags.card-create-filtered-v2.multiple-issues-hidden-title-issue-term-refresh",
        "defaultMessage": "Changes are saved, but nothing is visible"
    },
    multipleIssuesHiddenDescriptionIssueTermRefresh: {
        "id": "backlog.flags.card-create-filtered-v2.multiple-issues-hidden-description-issue-term-refresh",
        "defaultMessage": "New work items are currently hidden by a filter."
    },
    issueHiddenTitleIssueTerminologyRefreshM4: {
        "id": "backlog.flags.card-create-filtered-v2.issue-hidden-title-issue-terminology-refresh-m4",
        "defaultMessage": "Changes are saved, but the {workType} isn\u2019t visible"
    },
    issueHiddenDescriptionIssueTerminologyRefreshM4: {
        "id": "backlog.flags.card-create-filtered-v2.issue-hidden-description-issue-terminology-refresh-m4",
        "defaultMessage": "{workType} {linkStart}{linkEnd} is currently hidden by a filter."
    },
    issueLinkIssueTerminologyRefreshM4: {
        "id": "backlog.flags.card-create-filtered-v2.issue-link-issue-terminology-refresh-m4",
        "defaultMessage": "View {workType}"
    }
});

});



parcelRegister("7VNNI", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b79d788c37b87ec$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $38qhf = parcelRequire("38qhf");

var $fSbPL = parcelRequire("fSbPL");
var $7b79d788c37b87ec$export$2e2bcd8739ae039 = (0, $bC2fB.connect)(null, (dispatch)=>({
        onPrimaryActionClick: (cardId)=>{
            // @ts-expect-error - Argument of type 'string' is not assignable to parameter of type 'number'.
            dispatch((0, $38qhf.openDetailView)(cardId));
        }
    }))((0, $fSbPL.default));

});
parcelRegister("fSbPL", function(module, exports) {

$parcel$export(module.exports, "default", () => $30bc80a2dc56149a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $8igKv = parcelRequire("8igKv");

var $koVbs = parcelRequire("koVbs");

var $jQ7vZ = parcelRequire("jQ7vZ");

var $64qgp = parcelRequire("64qgp");


var $boh8Y = parcelRequire("boh8Y");
const $30bc80a2dc56149a$var$CardIsFiltered = ({ onPrimaryActionClick: onPrimaryActionClick, card: card, ...props })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [, setIssueKey] = (0, $jQ7vZ.useQueryParam)((0, $4f4a02cead13bb5a$export$3a0c4bc79274bbaa));
    const workType = card.issueTypeName;
    const getCreatedCardLink = ()=>{
        if (workType && (0, $64qgp.isWorkTypeAvgLength)(workType) && (0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return (0, $boh8Y.default).createdCardIsFilteredLinkIssueTerminologyRefreshM4;
        if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return (0, $boh8Y.default).createdCardIsFilteredLinkIssueTermRefresh;
        return (0, $boh8Y.default).createdCardIsFilteredLink;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8igKv.default), {
        messageId: "software-backlog.flags.card-create-filtered.warning-flag",
        messageType: "transactional",
        ...props,
        key: card.key,
        title: formatMessage((0, $boh8Y.default).createdCardIsFilteredTitle, {
            cardKey: card.key
        }),
        description: formatMessage((0, $boh8Y.default).createdCardIsFilteredDescription),
        actions: [
            {
                content: formatMessage(getCreatedCardLink(), {
                    workType: card.issueTypeName
                }),
                onClick: ()=>{
                    onPrimaryActionClick(String(card.id));
                    setIssueKey(card.key);
                }
            }
        ]
    });
};
var $30bc80a2dc56149a$export$2e2bcd8739ae039 = $30bc80a2dc56149a$var$CardIsFiltered;

});
parcelRegister("boh8Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b16a8d175a8dd8f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0b16a8d175a8dd8f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createdCardIsFilteredTitle: {
        "id": "backlog.flags.card-create-filtered.created-card-is-filtered-title",
        "defaultMessage": "{cardKey} has been created."
    },
    createdCardIsFilteredDescription: {
        "id": "backlog.flags.card-create-filtered.created-card-is-filtered-description",
        "defaultMessage": "It's hidden by your current filter."
    },
    createdCardIsFilteredLink: {
        "id": "backlog.flags.card-create-filtered.created-card-is-filtered-link",
        "defaultMessage": "View issue"
    },
    createdCardIsFilteredLinkIssueTermRefresh: {
        "id": "backlog.flags.card-create-filtered.created-card-is-filtered-link-issue-term-refresh",
        "defaultMessage": "View"
    },
    createdCardIsFilteredLinkIssueTerminologyRefreshM4: {
        "id": "backlog.flags.card-create-filtered.created-card-is-filtered-link-issue-terminology-refresh-m4",
        "defaultMessage": "View {workType}"
    }
});

});



parcelRegister("2A04N", function(module, exports) {

$parcel$export(module.exports, "default", () => $f28c6c7b53310f29$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $esJnl = parcelRequire("esJnl");

var $dfMzt = parcelRequire("dfMzt");

var $jG5HW = parcelRequire("jG5HW");

var $1z1J7 = parcelRequire("1z1J7");
const $f28c6c7b53310f29$var$mapStateToProps = (state)=>({
        boardConfigUrl: (0, $dfMzt.getColumnStatusMappingUrl)((0, $jG5HW.getProjectKey)(state), (0, $jG5HW.getRapidViewId)(state)),
        isConfigureBoardEnabled: (0, $1z1J7.canEditBoardConfig)(state)
    });
var $f28c6c7b53310f29$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($f28c6c7b53310f29$var$mapStateToProps, {})((0, $esJnl.CardCreateUnmappedFlag));

});
parcelRegister("esJnl", function(module, exports) {

$parcel$export(module.exports, "CardCreateUnmappedFlag", () => $39f5c9a19aa037a2$export$41f7bf5526b10063);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $d4xRU = parcelRequire("d4xRU");
var $3KRpp = parcelRequire("3KRpp");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $24y3R = parcelRequire("24y3R");

var $pvsdI = parcelRequire("pvsdI");
const $39f5c9a19aa037a2$export$41f7bf5526b10063 = ({ cardKeys: cardKeys, onDismissed: onDismissed, id: id, isAutoDismissed: isAutoDismissed = true })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const numIssues = cardKeys.length;
    const getFlagDescription = ()=>formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $pvsdI.default).updatedIssueHiddenDescriptionIssueTermRefresh : (0, $pvsdI.default).updatedIssueHiddenDescription);
    const getActions = ()=>{
        const actions = [
            {
                content: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $pvsdI.default).issueLinkIssueTermRefresh : (0, $pvsdI.default).issueLink, {
                    numIssues: numIssues
                }),
                href: (0, $24y3R.getIssueDiscoveryUrl)(cardKeys),
                target: '_blank'
            }
        ];
        return actions;
    };
    if (!isAutoDismissed && (0, $4R6GH.fg)('fix-gryf-a11y-issues-2')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4xRU.default), {
        id: id,
        onDismissed: onDismissed,
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $pvsdI.default).updatedIssueHiddenTitleIssueTermRefresh : (0, $pvsdI.default).updatedIssueHiddenTitle, {
            numIssues: numIssues
        }),
        description: getFlagDescription(),
        actions: getActions()
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.SuccessAutoDismissFlag), {
        id: id,
        onDismissed: onDismissed,
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $pvsdI.default).updatedIssueHiddenTitleIssueTermRefresh : (0, $pvsdI.default).updatedIssueHiddenTitle, {
            numIssues: numIssues
        }),
        description: getFlagDescription(),
        actions: getActions()
    });
};

});
parcelRegister("pvsdI", function(module, exports) {

$parcel$export(module.exports, "default", () => $3834fa35b5b67285$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3834fa35b5b67285$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    issueHiddenTitle: {
        "id": "software-flags.card-create-unmapped.issue-hidden-title",
        "defaultMessage": "Changes saved, but {numIssues, plural, one {issue} other {issues}} not visible"
    },
    issueHiddenDescription: {
        "id": "software-flags.card-create-unmapped.issue-hidden-description",
        "defaultMessage": "Issue {linkStart}{linkEnd} has a status that\u2019s not visible on the board and backlog."
    },
    multipleIssuesHiddenDescription: {
        "id": "software-flags.card-create-unmapped.multiple-issues-hidden-description",
        "defaultMessage": "{numIssues, plural, one {{numIssues} issue has} other {{numIssues} issues have}} been created, but one or more have a status that's not visible on the board and backlog"
    },
    issueLink: {
        "id": "software-flags.card-create-unmapped.issue-link",
        "defaultMessage": "View {numIssues, plural, one {issue} other {issues}}"
    },
    updatedIssueHiddenTitle: {
        "id": "software-flags.card-create-unmapped.updated-issue-hidden-title",
        "defaultMessage": "Changes saved, but {numIssues, plural, one {Issue} other {Issues}} not visible"
    },
    updatedIssueHiddenDescription: {
        "id": "software-flags.card-create-unmapped.updated-issue-hidden-description",
        "defaultMessage": "For an issue to be visible, it must match your project and filters, and have a status that\u2019s assigned to the board."
    },
    issueHiddenTitleIssueTermRefresh: {
        "id": "software-flags.card-create-unmapped.issue-hidden-title-issue-term-refresh",
        "defaultMessage": "Changes saved, but {numIssues, plural, one {work item} other {work items}} not visible"
    },
    issueHiddenDescriptionIssueTermRefresh: {
        "id": "software-flags.card-create-unmapped.issue-hidden-description-issue-term-refresh",
        "defaultMessage": "Work item {linkStart}{linkEnd} has a status that\u2019s not visible on the board and backlog."
    },
    multipleIssuesHiddenDescriptionIssueTermRefresh: {
        "id": "software-flags.card-create-unmapped.multiple-issues-hidden-description-issue-term-refresh",
        "defaultMessage": "{numIssues, plural, one {{numIssues} work item has} other {{numIssues} work items have}} been created, but one or more have a status that's not visible on the board and backlog"
    },
    issueLinkIssueTermRefresh: {
        "id": "software-flags.card-create-unmapped.issue-link-issue-term-refresh",
        "defaultMessage": "View {numIssues, plural, one {work item} other {work items}}"
    },
    updatedIssueHiddenTitleIssueTermRefresh: {
        "id": "software-flags.card-create-unmapped.updated-issue-hidden-title-issue-term-refresh",
        "defaultMessage": "Changes saved, but {numIssues, plural, one {work item} other {work items}} not visible"
    },
    updatedIssueHiddenDescriptionIssueTermRefresh: {
        "id": "software-flags.card-create-unmapped.updated-issue-hidden-description-issue-term-refresh",
        "defaultMessage": "For a work item to be visible, it must match your project and filters, and have a status that\u2019s assigned to the board."
    }
});

});



parcelRegister("9KRJk", function(module, exports) {

$parcel$export(module.exports, "default", () => $6019ad4abeab9d16$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $dfMzt = parcelRequire("dfMzt");

var $jG5HW = parcelRequire("jG5HW");

var $1z1J7 = parcelRequire("1z1J7");

var $6wkXY = parcelRequire("6wkXY");
const $6019ad4abeab9d16$var$mapStateToProps = (state)=>({
        boardConfigUrl: (0, $dfMzt.getColumnStatusMappingUrl)((0, $jG5HW.getProjectKey)(state), (0, $jG5HW.getRapidViewId)(state)),
        isConfigureBoardEnabled: (0, $1z1J7.canEditBoardConfig)(state)
    });
var $6019ad4abeab9d16$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($6019ad4abeab9d16$var$mapStateToProps, {})((0, $6wkXY.CardCreateUnmappedFlag));

});
parcelRegister("6wkXY", function(module, exports) {

$parcel$export(module.exports, "CardCreateUnmappedFlag", () => $69a5bf3ca297f4c6$export$41f7bf5526b10063);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $3KRpp = parcelRequire("3KRpp");

var $koVbs = parcelRequire("koVbs");

var $5qfKt = parcelRequire("5qfKt");
const $69a5bf3ca297f4c6$export$41f7bf5526b10063 = ({ onDismissed: onDismissed, id: id, numIssues: numIssues, issueTypeName: issueTypeName, boardConfigUrl: boardConfigUrl, isConfigureBoardEnabled: isConfigureBoardEnabled })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const getActions = isConfigureBoardEnabled ? [
        {
            content: formatMessage((0, $5qfKt.default).assignStatuses),
            href: boardConfigUrl
        }
    ] : [];
    const getDescription = (0, $5uXOq.useCallback)(()=>{
        if (numIssues <= 1 && (0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return formatMessage((0, $5qfKt.default).issueHiddenDescriptionIssueTerminologyRefreshM4, {
            workType: issueTypeName
        });
        if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return numIssues > 1 ? formatMessage((0, $5qfKt.default).multipleIssuesHiddenDescriptionIssueTermRefresh, {
            numIssues: numIssues
        }) : formatMessage((0, $5qfKt.default).issueHiddenDescriptionIssueTermRefresh);
        return numIssues > 1 ? formatMessage((0, $5qfKt.default).multipleIssuesHiddenDescription, {
            numIssues: numIssues
        }) : formatMessage((0, $5qfKt.default).issueHiddenDescription);
    }, [
        formatMessage,
        numIssues,
        issueTypeName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.SuccessAutoDismissFlag), {
        id: id,
        onDismissed: onDismissed,
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5qfKt.default).issueHiddenTitleIssueTermRefresh : (0, $5qfKt.default).issueHiddenTitle, {
            numIssues: numIssues
        }),
        description: getDescription(),
        actions: getActions
    });
};

});
parcelRegister("5qfKt", function(module, exports) {

$parcel$export(module.exports, "default", () => $d31345c7df07b908$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d31345c7df07b908$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    issueHiddenTitle: {
        "id": "backlog.flags.card-create-unmapped.issue-hidden-title",
        "defaultMessage": "Changes saved, but {numIssues, plural, one {issue} other {issues}} not visible"
    },
    issueHiddenDescription: {
        "id": "backlog.flags.card-create-unmapped.issue-hidden-description",
        "defaultMessage": "The issue is assigned to a status that\u2019s not visible on the board and backlog."
    },
    multipleIssuesHiddenDescription: {
        "id": "backlog.flags.card-create-unmapped.multiple-issues-hidden-description",
        "defaultMessage": "{numIssues} issues have been created, but one or more have a status that\u2019s not visible on the board and backlog."
    },
    assignStatuses: {
        "id": "backlog.flags.card-create-unmapped.assign-statuses",
        "defaultMessage": "Assign statuses"
    },
    issueHiddenTitleIssueTermRefresh: {
        "id": "backlog.flags.card-create-unmapped.issue-hidden-title-issue-term-refresh",
        "defaultMessage": "Changes saved, but {numIssues, plural, one {work item} other {work items}} not visible"
    },
    issueHiddenDescriptionIssueTermRefresh: {
        "id": "backlog.flags.card-create-unmapped.issue-hidden-description-issue-term-refresh",
        "defaultMessage": "The work item is assigned to a status that\u2019s not visible on the board and backlog."
    },
    multipleIssuesHiddenDescriptionIssueTermRefresh: {
        "id": "backlog.flags.card-create-unmapped.multiple-issues-hidden-description-issue-term-refresh",
        "defaultMessage": "{numIssues} work items have been created, but one or more have a status that\u2019s not visible on the board and backlog."
    },
    issueHiddenDescriptionIssueTerminologyRefreshM4: {
        "id": "backlog.flags.card-create-unmapped.issue-hidden-description-issue-terminology-refresh-m4",
        "defaultMessage": "The {workType} is assigned to a status that\u2019s not visible on the board and backlog."
    }
});

});



parcelRegister("aLVM6", function(module, exports) {

$parcel$export(module.exports, "CardDragDisallowedFlag", () => $db84e05fef80cb1a$export$7df6cad02c3a09f1);

var $5uXOq = parcelRequire("5uXOq");

var $3KRpp = parcelRequire("3KRpp");

var $koVbs = parcelRequire("koVbs");

var $kULld = parcelRequire("kULld");
function $db84e05fef80cb1a$export$7df6cad02c3a09f1({ id: id, onDismissed: onDismissed }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.ErrorFlag), {
        id: id,
        onDismissed: onDismissed,
        title: formatMessage((0, $kULld.default).removeSubtaskTitle),
        description: formatMessage((0, $kULld.default).removeSubtaskDescription)
    });
}

});
parcelRegister("kULld", function(module, exports) {

$parcel$export(module.exports, "default", () => $f92e7dc823f52d13$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f92e7dc823f52d13$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    removeSubtaskTitle: {
        "id": "backlog.flags.card-drag-disallowed.remove-subtask-title",
        "defaultMessage": "Subtasks can't be moved from their parent on the backlog"
    },
    removeSubtaskDescription: {
        "id": "backlog.flags.card-drag-disallowed.remove-subtask-description",
        "defaultMessage": "Select a subtask to view and edit its details"
    }
});

});


parcelRegister("i9g1N", function(module, exports) {

$parcel$export(module.exports, "default", () => $8422601ec4afa025$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $8igKv = parcelRequire("8igKv");

var $koVbs = parcelRequire("koVbs");

var $lTqEw = parcelRequire("lTqEw");
const $8422601ec4afa025$export$321f8e7a5f776e25 = ({ id: id, boardId: boardId, isAdmin: isAdmin, onDismissed: onDismissed })=>{
    const getEditFilterUrl = `/secure/RapidBoard.jspa?rapidView=${boardId}&config=filter`;
    const learnMoreUrl = 'https://support.atlassian.com/jira-software-cloud/docs/enable-ranking/';
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const getContent = ()=>{
        if (isAdmin) return {
            description: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lTqEw.default).descriptionIssueTermRefresh : (0, $lTqEw.default).description),
            actions: [
                {
                    content: formatMessage((0, $lTqEw.default).showJqlFilterForBoard),
                    href: getEditFilterUrl
                },
                {
                    content: formatMessage((0, $lTqEw.default).learnMore),
                    href: learnMoreUrl
                }
            ]
        };
        return {
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lTqEw.default).descriptionIssueTermRefresh : (0, $lTqEw.default).description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null), formatMessage((0, $lTqEw.default).contactAdmin)),
            actions: [
                {
                    content: formatMessage((0, $lTqEw.default).learnMore),
                    href: learnMoreUrl
                }
            ]
        };
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8igKv.default), {
        id: id,
        // @ts-expect-error isAutoDismiss prop looks to be unused but should be tested before removing
        isAutoDismiss: true,
        onDismissed: onDismissed,
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lTqEw.default).titleIssueTermRefresh : (0, $lTqEw.default).title),
        ...getContent()
    });
};
var $8422601ec4afa025$export$2e2bcd8739ae039 = $8422601ec4afa025$export$321f8e7a5f776e25;

});
parcelRegister("lTqEw", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dd0c94f07a9fb44$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9dd0c94f07a9fb44$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "backlog.flags.card-move-disabled.title",
        "defaultMessage": "Issues can\u2019t be manually ranked"
    },
    description: {
        "id": "backlog.flags.card-move-disabled.description",
        "defaultMessage": "The board\u2019s filter query isn\u2019t sorted by rank. To rank issues manually on your board and backlog, sort issues by ascending rank."
    },
    contactAdmin: {
        "id": "backlog.flags.card-move-disabled.contact-admin",
        "defaultMessage": "Contact your admin to adjust the board filter."
    },
    showJqlFilterForBoard: {
        "id": "backlog.flags.card-move-disabled.show-jql-filter-for-board",
        "defaultMessage": "Manage board filter"
    },
    learnMore: {
        "id": "backlog.flags.card-move-disabled.learn-more",
        "defaultMessage": "Learn more"
    },
    titleIssueTermRefresh: {
        "id": "backlog.flags.card-move-disabled.title-issue-term-refresh",
        "defaultMessage": "Work items can\u2019t be manually ranked"
    },
    descriptionIssueTermRefresh: {
        "id": "backlog.flags.card-move-disabled.description-issue-term-refresh",
        "defaultMessage": "The board\u2019s filter query isn\u2019t sorted by rank. To rank work items manually on your board and backlog, sort them by ascending rank."
    }
});

});


parcelRegister("kzCvy", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8edc96250ceb721$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8igKv = parcelRequire("8igKv");

var $koVbs = parcelRequire("koVbs");

var $qgGvU = parcelRequire("qgGvU");
const $c8edc96250ceb721$var$ClearCustomFilterFailed = ({ id: id, onDismissed: onDismissed, ...props })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onClick = (0, $5uXOq.useCallback)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.reload();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8igKv.default), {
        messageId: props.messageId ?? `software-backlog.flags.custom-filter-failed.warning-flag.${id}`,
        messageType: props.messageType ?? 'transactional',
        id: id,
        onDismissed: onDismissed,
        title: formatMessage((0, $qgGvU.default).endUserTitle),
        description: formatMessage((0, $qgGvU.default).endUserDescription),
        actions: [
            {
                content: formatMessage((0, $qgGvU.default).endUserActionLink),
                onClick: onClick
            }
        ]
    });
};
var $c8edc96250ceb721$export$2e2bcd8739ae039 = $c8edc96250ceb721$var$ClearCustomFilterFailed;

});
parcelRegister("qgGvU", function(module, exports) {

$parcel$export(module.exports, "default", () => $783edd5a65af9cf5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $783edd5a65af9cf5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    endUserTitle: {
        "id": "backlog.flags.clear-custom-filter-failed.end-user-title",
        "defaultMessage": "We couldn't clear your filters"
    },
    endUserDescription: {
        "id": "backlog.flags.clear-custom-filter-failed.end-user-description",
        "defaultMessage": "Refresh the page and try again."
    },
    endUserActionLink: {
        "id": "backlog.flags.clear-custom-filter-failed.end-user-action-link",
        "defaultMessage": "Reload page"
    }
});

});


parcelRegister("dS41P", function(module, exports) {

$parcel$export(module.exports, "default", () => $467edcaf2bf4621a$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $dfMzt = parcelRequire("dfMzt");

var $jG5HW = parcelRequire("jG5HW");

var $1z1J7 = parcelRequire("1z1J7");

var $4DYFQ = parcelRequire("4DYFQ");
const $467edcaf2bf4621a$var$mapStateToProps = (state)=>({
        canAccessCustomFilterSettings: (0, $1z1J7.canEditBoardConfig)(state),
        customFiltersSettingsUrl: (0, $dfMzt.getCustomFiltersSettingsUrl)((0, $jG5HW.getProjectKey)(state), (0, $jG5HW.getRapidViewId)(state))
    });
var $467edcaf2bf4621a$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($467edcaf2bf4621a$var$mapStateToProps, {})((0, $4DYFQ.default));

});
parcelRegister("4DYFQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a42591bef76b3fd7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8igKv = parcelRequire("8igKv");

var $koVbs = parcelRequire("koVbs");

var $14uhY = parcelRequire("14uhY");

var $8zOmE = parcelRequire("8zOmE");

var $gwk8F = parcelRequire("gwk8F");
const $a42591bef76b3fd7$var$CustomFilterFailed = ({ id: id, customFiltersSettingsUrl: customFiltersSettingsUrl, canAccessCustomFilterSettings: canAccessCustomFilterSettings, onDismissed: onDismissed = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), ...props })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const dismissFlag = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        (0, $14uhY.setReturnToProjectUrl)();
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'customFilterFailedFlagLink', {
            canAccessCustomFilterSettings: canAccessCustomFilterSettings
        });
        onDismissed(id);
    }, [
        canAccessCustomFilterSettings,
        id,
        onDismissed
    ]);
    return canAccessCustomFilterSettings ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8igKv.default), {
        messageId: props.messageId ?? `software-backlog.flags.custom-filter-failed.warning-flag.${id}`,
        messageType: props.messageType ?? 'transactional',
        id: id,
        onDismissed: onDismissed,
        title: formatMessage((0, $gwk8F.default).adminUserTitle),
        description: formatMessage((0, $gwk8F.default).adminUserDescription),
        actions: [
            {
                content: formatMessage((0, $gwk8F.default).adminUserActionLink),
                href: customFiltersSettingsUrl,
                target: '_blank',
                onClick: dismissFlag
            }
        ]
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8igKv.default), {
        messageId: props.messageId ?? `software-backlog.flags.custom-filter-failed.warning-flag.${id}`,
        messageType: props.messageType ?? 'transactional',
        id: id,
        onDismissed: onDismissed,
        title: formatMessage((0, $gwk8F.default).endUserTitle),
        description: formatMessage((0, $gwk8F.default).endUserDescription),
        actions: [
            {
                content: formatMessage((0, $gwk8F.default).endUserActionLink),
                onClick: dismissFlag
            }
        ]
    });
};
var $a42591bef76b3fd7$export$2e2bcd8739ae039 = $a42591bef76b3fd7$var$CustomFilterFailed;

});
parcelRegister("gwk8F", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cedcb9101baaa70$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5cedcb9101baaa70$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    adminUserTitle: {
        "id": "backlog.flags.custom-filter-failed.admin-user-title",
        "defaultMessage": "We couldn't load your filters"
    },
    adminUserDescription: {
        "id": "backlog.flags.custom-filter-failed.admin-user-description",
        "defaultMessage": "One or more of your filters can't be used right now. You can check your filter queries and try again."
    },
    adminUserActionLink: {
        "id": "backlog.flags.custom-filter-failed.admin-user-action-link",
        "defaultMessage": "Manage custom filters"
    },
    endUserTitle: {
        "id": "backlog.flags.custom-filter-failed.end-user-title",
        "defaultMessage": "We couldn't load your filters"
    },
    endUserDescription: {
        "id": "backlog.flags.custom-filter-failed.end-user-description",
        "defaultMessage": "One or more of your filters can't be used right now. Contact your Jira admin to check the filter queries, then try again."
    },
    endUserActionLink: {
        "id": "backlog.flags.custom-filter-failed.end-user-action-link",
        "defaultMessage": "OK"
    }
});

});



parcelRegister("cen46", function(module, exports) {

$parcel$export(module.exports, "SplitIssueSuccessFlag", () => $bd0e2adb84ca6fae$export$75ae40d8ea21392a);

var $47bDC = parcelRequire("47bDC");

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $3KRpp = parcelRequire("3KRpp");

var $koVbs = parcelRequire("koVbs");

var $64qgp = parcelRequire("64qgp");

var $cnvr3 = parcelRequire("cnvr3");
// eslint-disable-next-line @compiled/no-css-prop-without-css-function, @atlaskit/design-system/consistent-css-prop-usage
const $bd0e2adb84ca6fae$var$copiedSuccessStyles = {
    color: "var(--ds-background-success-pressed, #7EE2B8)"
};
const $bd0e2adb84ca6fae$var$getIssueDiscoveryUrl = (issueKeys)=>{
    if (issueKeys.length > 1) {
        const cardKeys = issueKeys.join(',');
        const jqlSearch = encodeURIComponent(`issueKey in (${cardKeys})`);
        return `/issues/?jql=${jqlSearch}`;
    }
    return `/browse/${issueKeys[0]}`;
};
var $bd0e2adb84ca6fae$var$_StyledSpan = /*#__PURE__*/ (0, $47bDC.default)("span").withConfig({
    componentId: "jhvvvj-0"
})`${$bd0e2adb84ca6fae$var$copiedSuccessStyles}`;
const $bd0e2adb84ca6fae$export$75ae40d8ea21392a = ({ originalIssueKey: originalIssueKey, issueKeys: issueKeys, issueTypeName: issueTypeName, onDismissed: onDismissed, id: id })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isCopied, setCopied] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        let timeoutId;
        if (isCopied) timeoutId = setTimeout(()=>{
            setCopied(false);
        }, 2000);
        return ()=>{
            timeoutId && clearTimeout(timeoutId);
        };
    }, [
        isCopied
    ]);
    const issueDiscoveryUrl = $bd0e2adb84ca6fae$var$getIssueDiscoveryUrl(issueKeys);
    const copyToClipboard = (0, $5uXOq.useCallback)(()=>{
        if ((0, $4R6GH.fg)('jfp-magma-undefined-navigator')) globalThis.navigator.clipboard.writeText(`${globalThis.window.location.origin}${issueDiscoveryUrl}`);
        else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        navigator.clipboard.writeText(`${window.location.origin}${issueDiscoveryUrl}`);
        setCopied(true);
    }, [
        issueDiscoveryUrl
    ]);
    const getFlagTitle = (0, $5uXOq.useCallback)(()=>{
        if (issueKeys.length <= 1 && (0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return formatMessage((0, $cnvr3.default).createSuccessFlagTitleIssueTerminologyRefreshM4, {
            issueKey: issueKeys[0],
            workType: issueTypeName
        });
        if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return issueKeys.length > 1 ? formatMessage((0, $cnvr3.default).multiplesIssuesCreatedSuccessFlagTitleIssueTermRefresh, {
            issueCount: issueKeys.length
        }) : formatMessage((0, $cnvr3.default).createSuccessFlagTitleIssueTermRefresh, {
            issueKey: issueKeys[0]
        });
        return issueKeys.length > 1 ? formatMessage((0, $cnvr3.default).multiplesIssuesCreatedSuccessFlagTitle, {
            issueCount: issueKeys.length
        }) : formatMessage((0, $cnvr3.default).createSuccessFlagTitle, {
            issueKey: issueKeys[0]
        });
    }, [
        formatMessage,
        issueKeys,
        issueTypeName
    ]);
    const getFlagDescription = (0, $5uXOq.useCallback)(()=>{
        if (issueKeys.length <= 1 && (0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return formatMessage((0, $cnvr3.default).createSuccessFlagDescriptionIssueTerminologyRefreshM4, {
            issueKey: originalIssueKey,
            workType: issueTypeName
        });
        if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return issueKeys.length > 1 ? formatMessage((0, $cnvr3.default).multipleIssuesCreatedSuccessFlagDescriptionIssueTermRefresh, {
            issueKey: originalIssueKey
        }) : formatMessage((0, $cnvr3.default).createSuccessFlagDescriptionIssueTermRefresh, {
            issueKey: originalIssueKey
        });
        return issueKeys.length > 1 ? formatMessage((0, $cnvr3.default).multipleIssuesCreatedSuccessFlagDescription, {
            issueKey: originalIssueKey
        }) : formatMessage((0, $cnvr3.default).createSuccessFlagDescription, {
            issueKey: originalIssueKey
        });
    }, [
        formatMessage,
        issueKeys,
        originalIssueKey,
        issueTypeName
    ]);
    const getLinkActionMessage = ()=>{
        if (issueTypeName && (0, $64qgp.isWorkTypeAvgLength)(issueTypeName) && (0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return issueKeys.length > 1 ? (0, $cnvr3.default).viewIssueLinkMultipleTextIssueTerminologyRefreshM4 : (0, $cnvr3.default).viewIssueLinkTextIssueTerminologyRefreshM4;
        if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return (0, $cnvr3.default).viewIssueLinkTextIssueTermRefresh;
        return (0, $cnvr3.default).viewIssueLinkText;
    };
    const flagActions = [
        {
            content: formatMessage(getLinkActionMessage(), {
                numIssues: issueKeys.length,
                workType: issueTypeName
            }),
            href: issueDiscoveryUrl
        },
        {
            content: isCopied ? // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bd0e2adb84ca6fae$var$_StyledSpan, null, formatMessage((0, $cnvr3.default).linkCopied)) : formatMessage((0, $cnvr3.default).copyLink),
            onClick: ()=>{
                copyToClipboard();
            }
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.SuccessAutoDismissFlag), {
        id: id,
        onDismissed: onDismissed,
        title: getFlagTitle(),
        description: getFlagDescription(),
        actions: flagActions
    });
};

});
parcelRegister("cnvr3", function(module, exports) {

$parcel$export(module.exports, "default", () => $5990d8181de93287$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5990d8181de93287$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createSuccessFlagTitle: {
        "id": "backlog.flags.split-issue-success.create-success-flag-title",
        "defaultMessage": "You've created issue \"{issueKey}\""
    },
    createSuccessFlagTitleIssueTermRefresh: {
        "id": "backlog.flags.split-issue-success.create-success-flag-title-issue-term-refresh",
        "defaultMessage": "You've created \"{issueKey}\""
    },
    multiplesIssuesCreatedSuccessFlagTitle: {
        "id": "backlog.flags.split-issue-success.multiples-issues-created-success-flag-title",
        "defaultMessage": "You've created {issueCount, plural, one {# issue} other {# new issues}}"
    },
    createSuccessFlagDescription: {
        "id": "backlog.flags.split-issue-success.create-success-flag-description",
        "defaultMessage": "It's linked to issue \"{issueKey}\"."
    },
    createSuccessFlagDescriptionIssueTermRefresh: {
        "id": "backlog.flags.split-issue-success.create-success-flag-description-issue-term-refresh",
        "defaultMessage": "It's linked to work item \"{issueKey}\"."
    },
    multipleIssuesCreatedSuccessFlagDescription: {
        "id": "backlog.flags.split-issue-success.multiple-issues-created-success-flag-description",
        "defaultMessage": "They're linked to issue \"{issueKey}\"."
    },
    multipleIssuesCreatedSuccessFlagDescriptionIssueTermRefresh: {
        "id": "backlog.flags.split-issue-success.multiple-issues-created-success-flag-description-issue-term-refresh",
        "defaultMessage": "They're linked to work item \"{issueKey}\"."
    },
    viewIssueLinkText: {
        "id": "backlog.flags.split-issue-success.view-issue-link-text",
        "defaultMessage": "View {numIssues, plural, one {issue} other {issues}}"
    },
    copyLink: {
        "id": "backlog.flags.split-issue-success.copy-link",
        "defaultMessage": "Copy link"
    },
    linkCopied: {
        "id": "backlog.flags.split-issue-success.link-copied",
        "defaultMessage": "Copied"
    },
    multiplesIssuesCreatedSuccessFlagTitleIssueTermRefresh: {
        "id": "backlog.flags.split-issue-success.multiples-issues-created-success-flag-title-issue-term-refresh",
        "defaultMessage": "You've created {issueCount, plural, one {# work item} other {# new work items}}"
    },
    viewIssueLinkTextIssueTermRefresh: {
        "id": "backlog.flags.split-issue-success.view-issue-link-text-issue-term-refresh",
        "defaultMessage": "View{numIssues, plural, one {} other { work items}}"
    },
    createSuccessFlagTitleIssueTerminologyRefreshM4: {
        "id": "backlog.flags.split-issue-success.create-success-flag-title-issue-terminology-refresh-m4",
        "defaultMessage": "Created {workType} \"{issueKey}\""
    },
    createSuccessFlagDescriptionIssueTerminologyRefreshM4: {
        "id": "backlog.flags.split-issue-success.create-success-flag-description-issue-terminology-refresh-m4",
        "defaultMessage": "It's linked to {workType} \"{issueKey}\"."
    },
    viewIssueLinkTextIssueTerminologyRefreshM4: {
        "id": "backlog.flags.split-issue-success.view-issue-link-text-issue-terminology-refresh-m4",
        "defaultMessage": "View {workType}"
    },
    viewIssueLinkMultipleTextIssueTerminologyRefreshM4: {
        "id": "backlog.flags.split-issue-success.view-issue-link-multiple-text-issue-terminology-refresh-m4",
        "defaultMessage": "View work items"
    }
});

});


parcelRegister("t6MXq", function(module, exports) {

$parcel$export(module.exports, "showSprintStartedFlag", () => $63e4a485d7c77bf2$export$16e805c83a7e91ec);

var $kQyxB = parcelRequire("kQyxB");
const $63e4a485d7c77bf2$export$16e805c83a7e91ec = ()=>({
        type: 'success',
        title: (0, $kQyxB.default).sprintStartedTitle,
        description: (0, $kQyxB.default).sprintStartedParallelSprintDescription,
        messageId: 'software-backlog.flags.sprint-started-flag.flag.success.flags.sprint-started',
        messageType: 'transactional'
    });

});
parcelRegister("kQyxB", function(module, exports) {

$parcel$export(module.exports, "default", () => $2783654e55be6c1d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2783654e55be6c1d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    sprintStartedTitle: {
        "id": "backlog.flags.sprint-started-flag.sprint-started-title",
        "defaultMessage": "Sprint started"
    },
    sprintStartedDescription: {
        "id": "backlog.flags.sprint-started-flag.sprint-started-description",
        "defaultMessage": "We\u2019ve taken you to your team\u2019s sprint board. Good luck team!"
    },
    sprintStartedParallelSprintDescription: {
        "id": "backlog.flags.sprint-started-flag.sprint-started-parallel-sprint-description",
        "defaultMessage": "We\u2019ve filtered the board to show your new sprint. Good luck, team!"
    }
});

});


parcelRegister("jRU2X", function(module, exports) {

$parcel$export(module.exports, "TransitionAndRankFailureFlag", () => $b99c3e12f982237a$export$ecea190680b7bcc);

var $5uXOq = parcelRequire("5uXOq");

var $3KRpp = parcelRequire("3KRpp");

var $koVbs = parcelRequire("koVbs");

var $8GzsK = parcelRequire("8GzsK");
function $b99c3e12f982237a$export$ecea190680b7bcc({ id: id, errorMessages: errorMessages, onDismissed: onDismissed }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.ErrorFlag), {
        id: id,
        title: formatMessage((0, $8GzsK.default).title),
        onDismissed: onDismissed,
        description: errorMessages.join('. ')
    });
}

});
parcelRegister("8GzsK", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9567e8de9a41b1b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a9567e8de9a41b1b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "backlog.flags.transition-and-rank-failure.title",
        "defaultMessage": "We couldn't move your card"
    }
});

});


parcelRegister("ffuah", function(module, exports) {

$parcel$export(module.exports, "SprintBoardPermissionlessFlag", () => $eecafc44dfa651ba$export$edfb3a8049d5dac2);

var $5uXOq = parcelRequire("5uXOq");

var $3KRpp = parcelRequire("3KRpp");

var $koVbs = parcelRequire("koVbs");

var $12YlG = parcelRequire("12YlG");
const $eecafc44dfa651ba$export$edfb3a8049d5dac2 = ({ id: id, onDismissed: onDismissed })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.WarningFlag), {
        id: id,
        onDismissed: onDismissed,
        title: formatMessage((0, $12YlG.default).noPermissionFlagHeader),
        description: formatMessage((0, $12YlG.default).noPermissionFlagBody)
    });
};

});
parcelRegister("12YlG", function(module, exports) {

$parcel$export(module.exports, "default", () => $50c992424aad9ba4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $50c992424aad9ba4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noPermissionFlagHeader: {
        "id": "backlog.flags.sprint-board-permissionless-flag.no-permission-flag-header",
        "defaultMessage": "You don't have permission to access this project"
    },
    noPermissionFlagBody: {
        "id": "backlog.flags.sprint-board-permissionless-flag.no-permission-flag-body",
        "defaultMessage": "Speak to your Jira admin or Project admin to get access"
    }
});

});



parcelRegister("cinXQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f4292cbc22f5db0$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $4R6GH = parcelRequire("4R6GH");

var $6s1PB = parcelRequire("6s1PB");

var $63Y57 = parcelRequire("63Y57");

var $e2PDn = parcelRequire("e2PDn");

var $eBTGr = parcelRequire("eBTGr");

var $hnaxO = parcelRequire("hnaxO");

var $gqn54 = parcelRequire("gqn54");

var $eKj5K = parcelRequire("eKj5K");

var $lTfMj = parcelRequire("lTfMj");

var $kOw1j = parcelRequire("kOw1j");

var $5o0zk = parcelRequire("5o0zk");

var $ntGXV = parcelRequire("ntGXV");

var $3EYDb = parcelRequire("3EYDb");

var $hHUaf = parcelRequire("hHUaf");

var $jQmfK = parcelRequire("jQmfK");

var $eVhWm = parcelRequire("eVhWm");

var $028Rt = parcelRequire("028Rt");

var $jv1aX = parcelRequire("jv1aX");

var $2YtLH = parcelRequire("2YtLH");

var $iKvYD = parcelRequire("iKvYD");

var $1pwBu = parcelRequire("1pwBu");

var $aXaCi = parcelRequire("aXaCi");

var $7w8zv = parcelRequire("7w8zv");

var $f4vxM = parcelRequire("f4vxM");

var $f5yE6 = parcelRequire("f5yE6");

var $hCa2B = parcelRequire("hCa2B");

var $h1Jne = parcelRequire("h1Jne");

var $7u8UG = parcelRequire("7u8UG");

var $3xTTB = parcelRequire("3xTTB");

var $dfRpl = parcelRequire("dfRpl");

var $cnhvw = parcelRequire("cnhvw");

var $BJrNt = parcelRequire("BJrNt");

var $jQJPl = parcelRequire("jQJPl");

var $5z625 = parcelRequire("5z625");

var $vO8Pq = parcelRequire("vO8Pq");

var $9Vyzy = parcelRequire("9Vyzy");

var $41ack = parcelRequire("41ack");

var $1fqjN = parcelRequire("1fqjN");

var $cZpfH = parcelRequire("cZpfH");

var $3l3iU = parcelRequire("3l3iU");

var $13hY5 = parcelRequire("13hY5");

var $jRnbG = parcelRequire("jRnbG");

var $1JXN4 = parcelRequire("1JXN4");

var $8Z17A = parcelRequire("8Z17A");

var $2sQbO = parcelRequire("2sQbO");

var $gnmD3 = parcelRequire("gnmD3");

var $h34Bb = parcelRequire("h34Bb");

var $83JtA = parcelRequire("83JtA");

var $dZEjB = parcelRequire("dZEjB");

var $6BlmG = parcelRequire("6BlmG");

var $7ixW2 = parcelRequire("7ixW2");

var $51zzD = parcelRequire("51zzD");

var $9kHz3 = parcelRequire("9kHz3");

var $daZWX = parcelRequire("daZWX");
const $9f4292cbc22f5db0$var$createRootEpic = (isServer, isCompanyManaged, getLocation, push, replace, // eslint-disable-next-line @typescript-eslint/no-explicit-any
swagClient)=>{
    const withUifCmpKillSwitch = (0, $63Y57.withKillSwitch)(isCompanyManaged);
    const clientEpics = isServer ? [] : [
        (0, $jQJPl.issueViewUpdateEpic),
        (0, $8Z17A.postLoadCleanDataEpic),
        (0, $83JtA.sprintCreateEpic),
        (0, $dZEjB.sprintDeleteEpic),
        (0, $6BlmG.sprintMoveEpic),
        ...(0, $63Y57.withKillSwitch)(()=>(0, $6s1PB.expValEquals)('surface_origin_board_on_sprint_containers', 'cohort', 'test'))([
            (0, $daZWX.sprintBoardLinkClickEpic)(push)
        ]),
        (0, $BJrNt.filteredCardsEpic),
        (0, $1pwBu.beforeMoveCardsEpic),
        (0, $aXaCi.cardsMoveRequestEpic),
        (0, $eKj5K.cardClickEpic)(getLocation, push),
        (0, $1JXN4.selectIssueParentEpic)(getLocation, push),
        (0, $iKvYD.cardsFlagWithCommentEpic),
        (0, $f4vxM.default),
        (0, $kOw1j.cardDeleteEpic)(getLocation, push),
        (0, $jQmfK.cardRefreshEpic),
        (0, $ntGXV.cardListToggleEpic),
        (0, $3EYDb.cardPostCreateEpic),
        (0, $7w8zv.cardsNavigateEpic),
        (0, $hCa2B.detailViewCloseEpic)(getLocation, push),
        (0, $7u8UG.detailViewUpdateEpic),
        (0, $h1Jne.detailViewOpenDebouncedEpic)(getLocation, push),
        (0, $cnhvw.filterValidValuesEpic)(getLocation, push),
        (0, $h34Bb.default)(getLocation, push, isCompanyManaged),
        // This still needs to be loaded because the critical query is not loaded in CMP
        // which holds the other user data.
        (0, $1fqjN.loadCurrentUserEpic),
        (0, $63Y57.withSwitch)(isCompanyManaged)((0, $9Vyzy.loadConfigDataEpicCmp), (0, $41ack.loadConfigDataEpic)),
        ...withUifCmpKillSwitch([
            (0, $cZpfH.loadPermissionsEpic),
            (0, $vO8Pq.loadCardCreateConfigEpic),
            (0, $3xTTB.refetchEpicPanelEpic),
            (0, $5o0zk.cardGroupToggleEpic),
            (0, $hHUaf.cardRankAfterGlobalIssueCreateEpic),
            (0, $9kHz3.workloadModalSubtaskToggleEpic)
        ]),
        (0, $e2PDn.default),
        (0, $gnmD3.refreshDataEpic),
        (0, $dfRpl.default),
        (0, $hnaxO.buildAssignToMeEpic)(swagClient),
        (0, $51zzD.refreshBacklog)(),
        (0, $hnaxO.cardAssignToMeThrottledEpic),
        (0, $028Rt.default),
        (0, $eVhWm.default),
        (0, $f5yE6.checkGlobalIssueCreateEpic),
        (0, $lTfMj.cardCreateMultipleGqlEpic),
        ...(0, $63Y57.withKillSwitch)(()=>(0, $4R6GH.fg)('jira-backlog-close-icc-on-drag'))([
            (0, $lTfMj.closeCardCreateOnDragStart)
        ]),
        (0, $jRnbG.onTogglePanelEpic)(getLocation, replace),
        (0, $jRnbG.onCloseInsightsEpic)(getLocation, replace),
        ...(0, $63Y57.withKillSwitch)(!isCompanyManaged)([
            (0, $cZpfH.loadPermissionsEpic)
        ]),
        (0, $13hY5.loadPrioritiesEpic),
        (0, $eBTGr.default),
        (0, $2sQbO.refetchVersionsEpic),
        (0, $jv1aX.cardsBulkOperationsFailureEpic),
        ...(0, $63Y57.withKillSwitch)(isCompanyManaged)([
            (0, $jv1aX.cardsBulkOperationsSuccessEpicCmp)
        ]),
        ...(0, $63Y57.withKillSwitch)(()=>(0, $6s1PB.expVal)('bulk_delete_experiment', 'isEnabled', false))([
            (0, $2YtLH.cardsBulkOperationsDeleteRequestEpic)(getLocation, push)
        ]),
        (0, $gqn54.cardAutoScrollOnFilterEpic),
        ...(0, $63Y57.withKillSwitch)(()=>(0, $4R6GH.fg)('sprint_planning_whiteboards_kill_switch'))([
            (0, $7ixW2.loadWhiteboardsEntrypointExperimentEpic)
        ])
    ];
    const loadEpic = (0, $63Y57.withSwitch)(isCompanyManaged)((0, $3l3iU.loadPlanDataEpic), (0, $5z625.loadAgilityGraphqlDataEpic));
    return (0, $e1AU2.combineEpics)(loadEpic, ...clientEpics);
};
var $9f4292cbc22f5db0$export$2e2bcd8739ae039 = $9f4292cbc22f5db0$var$createRootEpic;

});
parcelRegister("63Y57", function(module, exports) {

$parcel$export(module.exports, "withSwitch", () => $5e9a3144cc583fc1$export$645938e27cb11e4e);
$parcel$export(module.exports, "withKillSwitch", () => $5e9a3144cc583fc1$export$2a43929f73f32330);
$parcel$export(module.exports, "fromRelayObservable", () => $5e9a3144cc583fc1$export$b57c7b401625b0df);
parcelRequire("1oQta");

var $kVLXA = parcelRequire("kVLXA");
function $5e9a3144cc583fc1$var$executePredicate(predicate) {
    if (predicate !== null && typeof predicate === 'function') return predicate();
    if (predicate !== null && typeof predicate === 'boolean') return predicate;
    return false;
}
const $5e9a3144cc583fc1$export$645938e27cb11e4e = (...predicates)=>(matchedPredicateEpic, unmatchedPredicateEpic)=>(action$, store, dependencies)=>predicates.every($5e9a3144cc583fc1$var$executePredicate) ? matchedPredicateEpic(action$, store, dependencies) : unmatchedPredicateEpic(action$, store, dependencies);
const $5e9a3144cc583fc1$export$2a43929f73f32330 = (...predicates)=>(epics)=>epics.map((epic)=>(action$, store, dependencies)=>epic(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                action$.filter(()=>predicates.every($5e9a3144cc583fc1$var$executePredicate)), store, dependencies));
const $5e9a3144cc583fc1$export$b57c7b401625b0df = (create)=>(0, $kVLXA.Observable).create((sink)=>{
        const subscription = create().subscribe(sink);
        return ()=>subscription.unsubscribe();
    });

});

parcelRegister("e2PDn", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c3f412b9ece8b4c$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $l6pDE = parcelRequire("l6pDE");

var $3b59T = parcelRequire("3b59T");
var // @ts-expect-error - TS2769: Type 'void' is not assignable to type 'BoardIssueMoveShowAction'.
$6c3f412b9ece8b4c$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, $l6pDE.default), (0, $3b59T.default));

});
parcelRegister("l6pDE", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad09ca4581dbd798$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("7mHDu");
parcelRequire("6cbqE");

var $jIyVb = parcelRequire("jIyVb");

var $3lZ6i = parcelRequire("3lZ6i");

var $3qXBy = parcelRequire("3qXBy");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ad09ca4581dbd798$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $3lZ6i.SET_APP_DATA)).take(1).switchMap(()=>(0, $jIyVb.shouldDisplayDialog)(store.getState()).flatMap((shouldDisplay)=>shouldDisplay ? (0, $kVLXA.Observable).of((0, $3qXBy.boardIssueMoveShow)()) : (0, $kVLXA.Observable).empty()));

});
parcelRegister("jIyVb", function(module, exports) {

$parcel$export(module.exports, "shouldDisplayDialog", () => $c542be53d12c746b$export$fd02a046fd38bde);
$parcel$export(module.exports, "dismissDialog", () => $c542be53d12c746b$export$581c7e9b587e8156);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("hZWgu");

var $8AOG8 = parcelRequire("8AOG8");

var $jG5HW = parcelRequire("jG5HW");

var $7b0Pa = parcelRequire("7b0Pa");

var $1z1J7 = parcelRequire("1z1J7");

var $k35me = parcelRequire("k35me");
const $c542be53d12c746b$var$shouldCheckForDialog = (state)=>{
    const canEdit = (0, $1z1J7.canEditBoardConfig)(state);
    const isAlreadyOpen = (0, $7b0Pa.isDialogOpen)(state);
    const isSprintsEnabled = (0, $k35me.isBacklogWithSprints)(state);
    return canEdit && !isAlreadyOpen && !isSprintsEnabled;
};
const $c542be53d12c746b$export$fd02a046fd38bde = (state)=>{
    if ($c542be53d12c746b$var$shouldCheckForDialog(state)) return (0, $kVLXA.Observable).of((0, $jG5HW.getRequestColumnMigration)(state));
    return (0, $kVLXA.Observable).of(false);
};
const $c542be53d12c746b$export$581c7e9b587e8156 = (state)=>{
    const rapidViewId = (0, $jG5HW.getRapidViewId)(state);
    const baseUrl = (0, $jG5HW.getBaseUrl)(state);
    return (0, $8AOG8.dismissMigrationModal)(baseUrl, rapidViewId).ignoreElements();
};

});
parcelRegister("8AOG8", function(module, exports) {

$parcel$export(module.exports, "dismissMigrationModal", () => $cd8b23f08d3813c3$export$e05baac531611192);

var $ivqh1 = parcelRequire("ivqh1");

var $6iJbJ = parcelRequire("6iJbJ");
const $cd8b23f08d3813c3$export$716b4280dda478e9 = 'DismissFirstColumnMigrationModalBacklog';
const $cd8b23f08d3813c3$export$19a8cfc9fd174c1c = (0, $ivqh1.gqlTagSwag)`
    mutation DismissFirstColumnMigrationModalBacklog($boardId: ID!) {
        dismissFirstColumnMigrationModal(input: {boardId: $boardId}) {
            boardScope {
                id
            }
        }
    }
`;
const $cd8b23f08d3813c3$export$e05baac531611192 = (baseUrl, boardId)=>(0, $6iJbJ.mutation$)(baseUrl, $cd8b23f08d3813c3$export$716b4280dda478e9, $cd8b23f08d3813c3$export$19a8cfc9fd174c1c, {
        boardId: boardId
    });

});
parcelRegister("ivqh1", function(module, exports) {

$parcel$export(module.exports, "gqlTagSwag", () => $01c130fdc769ad97$export$c4eea1172a449e1a);

var $ftbQH = parcelRequire("ftbQH");
const $01c130fdc769ad97$export$c4eea1172a449e1a = (0, $ftbQH.gqlTagRest);

});
parcelRegister("ftbQH", function(module, exports) {

$parcel$export(module.exports, "gqlTagRest", () => $e1de9369168f5428$export$ecc155df19ba52ff);
/**
 * This file is to define tags for GraphQL queries to be identified
 * by https://github.com/apollographql/eslint-plugin-graphql
 * It returns the full query string for template literals
 */ const $e1de9369168f5428$export$ecc155df19ba52ff = (literals, ...substitutions)=>{
    let result = '';
    // run the loop only for the substitution count
    substitutions.forEach((key, i)=>{
        result += literals[i];
        result += key.toString();
    });
    // add the last literal
    result += literals[literals.length - 1];
    return result;
};

});


parcelRegister("6iJbJ", function(module, exports) {

$parcel$export(module.exports, "mutation$", () => $fd52b7b2722ec81e$export$3c168c5a8b47d553);

var $4nUsC = parcelRequire("4nUsC");
const $fd52b7b2722ec81e$export$3c168c5a8b47d553 = (baseUrl, operationName, query, variables, analyticOptions)=>(0, $4nUsC.operation$)('mutation', baseUrl, operationName, query, variables, analyticOptions);

});


parcelRegister("7b0Pa", function(module, exports) {

$parcel$export(module.exports, "isDialogOpen", () => $856a62ef091671f4$export$61d407d1c7ec6926);
const $856a62ef091671f4$export$61d407d1c7ec6926 = (state)=>state.ui.boardIssueMoveDialog.isOpen;

});

parcelRegister("k35me", function(module, exports) {

$parcel$export(module.exports, "makeGetSprintEstimations", () => $b6dd983165ce5ba4$export$36e03197e8c5fd07);
$parcel$export(module.exports, "makeIsCardListActiveSprint", () => $b6dd983165ce5ba4$export$5ce180897302be5f);
$parcel$export(module.exports, "makeIsSprintCardList", () => $b6dd983165ce5ba4$export$560f07fa8255aee3);
$parcel$export(module.exports, "getAllSprints", () => $b6dd983165ce5ba4$export$60a2c24a37c53cfb);
$parcel$export(module.exports, "makeGetOtherOrderedSprints", () => $b6dd983165ce5ba4$export$7ac571a2238dcc12);
$parcel$export(module.exports, "makeGetNextSprintId", () => $b6dd983165ce5ba4$export$b6b936656317fb38);
$parcel$export(module.exports, "makeGetPreviousNotStartedSprintId", () => $b6dd983165ce5ba4$export$a192949a255d1997);
$parcel$export(module.exports, "getFirstInactiveSprintId", () => $b6dd983165ce5ba4$export$e5a3f72422855e02);
$parcel$export(module.exports, "getLastInactiveSprintId", () => $b6dd983165ce5ba4$export$d38a80f79acac8b8);
$parcel$export(module.exports, "makeCanEditSprint", () => $b6dd983165ce5ba4$export$d0747858fa55f115);
$parcel$export(module.exports, "makeGetSprint", () => $b6dd983165ce5ba4$export$a0cc63864a6ae856);
$parcel$export(module.exports, "isBacklogWithSprints", () => $b6dd983165ce5ba4$export$5a6d0e1cb58a7ee5);
$parcel$export(module.exports, "makeIsSprintMenuVisible", () => $b6dd983165ce5ba4$export$c30c507815cb669f);
$parcel$export(module.exports, "makeIsStartSprintVisible", () => $b6dd983165ce5ba4$export$b617a44e0fda9735);
$parcel$export(module.exports, "makeIsCreateSprintVisible", () => $b6dd983165ce5ba4$export$fd48a9e7d9ffc297);
$parcel$export(module.exports, "makeIsStartSprintEnabled", () => $b6dd983165ce5ba4$export$35ab6d7577f201a3);
$parcel$export(module.exports, "makeIsCompleteSprintVisible", () => $b6dd983165ce5ba4$export$b447779f07c42b51);
$parcel$export(module.exports, "makeIsAddSprintDatesButtonVisible", () => $b6dd983165ce5ba4$export$47615c8fc3c602b6);
$parcel$export(module.exports, "makeIsShowBoardNameVisible", () => $b6dd983165ce5ba4$export$e867ff6149c29060);
$parcel$export(module.exports, "numCrossBoardSprints", () => $b6dd983165ce5ba4$export$53c26b74c0a1e3fe);

var $dGvGJ = parcelRequire("dGvGJ");

var $gJBT6 = parcelRequire("gJBT6");

var $g4tDr = parcelRequire("g4tDr");

var $guzeq = parcelRequire("guzeq");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $45Qwd = parcelRequire("45Qwd");

var $1z1J7 = parcelRequire("1z1J7");

var $bAfUr = parcelRequire("bAfUr");
const $b6dd983165ce5ba4$export$36e03197e8c5fd07 = (0, $dGvGJ.createSelector)([
    (0, $dGljH.makeOrderedVisibleCardsForCardList),
    (0, $bAfUr.getInitialStatusIds),
    (0, $bAfUr.getResolutionDoneStatusIds),
    (0, $45Qwd.getEstimationType),
    (0, $jG5HW.isCmpKanbanProject)
], (getOrderedVisibleCardsForCardList, initialStatusIds, resolutionDoneStatusIds, estimationType, isCmpKanban)=>{
    const getSprintEstimations = (cardListId)=>{
        let list = getOrderedVisibleCardsForCardList(cardListId);
        if (!isCmpKanban) list = list.filter((card)=>!(0, $g4tDr.isSubtaskHierarchyLevel)(card.typeHierarchyLevel));
        const estimations = {
            NOT_STARTED: 0,
            IN_PROGRESS: 0,
            DONE: 0
        };
        list.forEach((card)=>{
            const incrementTypes = Object.freeze({
                [(0, $guzeq.ORIGINAL_ESTIMATE)]: card.estimate?.originalEstimate?.value || 0,
                [(0, $guzeq.STORY_POINTS)]: card.estimate?.storyPoints || 0,
                [(0, $guzeq.ISSUE_COUNT)]: 1
            });
            const increment = incrementTypes[estimationType] || 0;
            if (initialStatusIds.includes(card.statusId)) estimations.NOT_STARTED += increment;
            else if (resolutionDoneStatusIds.includes(card.statusId)) estimations.DONE += increment;
            else estimations.IN_PROGRESS += increment;
        });
        return estimations;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getSprintEstimations);
});
const $b6dd983165ce5ba4$export$5ce180897302be5f = (0, $dGvGJ.createSelector)([
    (0, $dGljH.getCardLists)
], (cardLists)=>{
    const isCardListActiveSprint = (cardListId)=>Boolean(cardLists[cardListId]?.type === (0, $guzeq.SPRINT) && cardLists[cardListId]?.sprintData?.state === 'ACTIVE');
    return isCardListActiveSprint;
});
const $b6dd983165ce5ba4$export$548ce523ca2b9fc0 = (0, $dGvGJ.createSelector)([
    (0, $dGljH.getCardLists)
], (cardLists)=>{
    const isCardListFutureSprint = (cardListId)=>Boolean(cardLists[cardListId]?.type === (0, $guzeq.SPRINT) && cardLists[cardListId]?.sprintData?.state === 'FUTURE');
    return isCardListFutureSprint;
});
const $b6dd983165ce5ba4$export$560f07fa8255aee3 = (0, $dGvGJ.createSelector)([
    (0, $dGljH.getCardLists)
], (cardLists)=>(cardListId)=>Boolean(cardLists && cardLists[cardListId]?.type === (0, $guzeq.SPRINT)));
const $b6dd983165ce5ba4$export$3df6198cde5435f9 = (state, sprintId)=>(0, $dGljH.getCardLists)(state)[String(sprintId)].name;
const $b6dd983165ce5ba4$export$4402d4ed26f26131 = (state, sprintId)=>(0, $dGljH.getCardLists)(state)[String(sprintId)].sprintData || null;
const $b6dd983165ce5ba4$export$60a2c24a37c53cfb = (0, $dGvGJ.createSelector)([
    (0, $dGljH.getVisibleCardListIds),
    (0, $dGljH.getCardLists)
], (cardListIds, cardLists)=>cardListIds.map((cardListId)=>cardLists[cardListId]).filter((cardList)=>cardList.type === (0, $guzeq.SPRINT)));
const $b6dd983165ce5ba4$export$7ac571a2238dcc12 = (0, $dGvGJ.createSelector)([
    (0, $dGljH.getVisibleCardListIds),
    (0, $dGljH.getCardLists)
], (cardListIds, cardLists)=>{
    const getOtherOrderedSprints = (id)=>cardListIds.map((cardListId)=>cardLists[cardListId]).filter((cardList)=>cardList.type === (0, $guzeq.SPRINT) && cardList.id !== id);
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getOtherOrderedSprints);
});
const $b6dd983165ce5ba4$export$b6b936656317fb38 = (0, $dGvGJ.createSelector)([
    (0, $dGljH.getVisibleCardListIds)
], (cardListIds)=>{
    const getNextSprintId = (sprintId)=>{
        const index = cardListIds.indexOf(sprintId);
        const nextCardListIndex = index + 1;
        if (index === -1 || index === cardListIds.length - 1 || cardListIds[nextCardListIndex] === (0, $guzeq.BACKLOG)) return null;
        return cardListIds[nextCardListIndex];
    };
    return getNextSprintId;
});
const $b6dd983165ce5ba4$export$a192949a255d1997 = (0, $dGvGJ.createSelector)([
    (0, $dGljH.getVisibleCardListIds),
    (0, $dGljH.getCardLists)
], (cardListIds, cardLists)=>{
    const getPrevNotStartedSprintId = (sprintId)=>{
        const index = cardListIds.indexOf(sprintId);
        const previousCardListIndex = index - 1;
        const previousCardListId = cardListIds[previousCardListIndex];
        if (index === -1 || index === 0 || cardLists[previousCardListId].type !== (0, $guzeq.SPRINT) || !cardLists[previousCardListId].sprintData || // @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS2532 - Object is possibly 'undefined'.
        cardLists[previousCardListId].sprintData.state !== 'FUTURE') return null;
        return previousCardListId;
    };
    return getPrevNotStartedSprintId;
});
const $b6dd983165ce5ba4$export$e5a3f72422855e02 = (0, $dGvGJ.createSelector)([
    (0, $dGljH.getCardLists),
    (0, $dGljH.getVisibleCardListIds)
], (cardLists, ids)=>ids.filter((id)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const card = cardLists[id];
        return card.type === (0, $guzeq.SPRINT) && card.sprintData?.state === 'FUTURE';
    })[0]);
const $b6dd983165ce5ba4$export$d38a80f79acac8b8 = (0, $dGvGJ.createSelector)([
    (0, $dGljH.getCardLists),
    (0, $dGljH.getVisibleCardListIds)
], (cardLists, ids)=>{
    const unscheduledSprints = ids.filter((id)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const card = cardLists[id];
        return card.type === (0, $guzeq.SPRINT) && card.sprintData?.state === 'FUTURE';
    });
    return unscheduledSprints[unscheduledSprints.length - 1];
});
const $b6dd983165ce5ba4$export$d0747858fa55f115 = (0, $dGvGJ.createSelector)([
    (0, $dGljH.getCardLists)
], (cardLists)=>{
    const getCanEditSprint = (id)=>Boolean(cardLists[id] && cardLists[id].type === (0, $guzeq.SPRINT) && cardLists[id].sprintData && // @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS2532 - Object is possibly 'undefined'.
        cardLists[id].sprintData.canUpdateSprint);
    return getCanEditSprint;
});
const $b6dd983165ce5ba4$export$a0cc63864a6ae856 = (0, $dGvGJ.createSelector)([
    (0, $dGljH.getCardLists)
], (cardLists)=>{
    const getSprintById = (id)=>// @ts-expect-error - TS2322 - Type 'Sprint | null | undefined' is not assignable to type 'Sprint | null'. | TS2532 - Object is possibly 'undefined'. | TS2532 - Object is possibly 'undefined'.
        cardLists[id] && cardLists[id].sprintData ? cardLists[id].sprintData : null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getSprintById);
});
const $b6dd983165ce5ba4$export$5a6d0e1cb58a7ee5 = (0, $dGvGJ.createSelector)([
    (0, $jG5HW.getBacklogStrategy)
], (backlogStrategy)=>backlogStrategy === (0, $guzeq.SPRINT));
const $b6dd983165ce5ba4$export$c30c507815cb669f = (0, $dGvGJ.createSelector)([
    $b6dd983165ce5ba4$export$5a6d0e1cb58a7ee5,
    $b6dd983165ce5ba4$export$a0cc63864a6ae856,
    $b6dd983165ce5ba4$export$d0747858fa55f115
], (areSprintsEnabled, getSprintById, canEditSprint)=>{
    const isSprintMenuVisible = (id)=>{
        if (!areSprintsEnabled) return false;
        const sprint = getSprintById(id);
        if (!sprint) return false;
        return canEditSprint(id);
    };
    return isSprintMenuVisible;
});
const $b6dd983165ce5ba4$export$b617a44e0fda9735 = (0, $dGvGJ.createSelector)([
    $b6dd983165ce5ba4$export$5a6d0e1cb58a7ee5,
    $b6dd983165ce5ba4$export$d0747858fa55f115,
    $b6dd983165ce5ba4$export$548ce523ca2b9fc0,
    (0, $jG5HW.getIsParallelSprintsEnabled),
    (0, $jG5HW.getIsCompanyManaged)
], (areSprintsEnabled, canEditSprint, isFutureSprint, isParallelSprintsEnabled, isCompanyManaged)=>{
    const isStartSprintVisible = (id, isFirstList)=>{
        if (!areSprintsEnabled || isCompanyManaged && !isParallelSprintsEnabled && !isFirstList) return false;
        return isFutureSprint(id);
    };
    return isStartSprintVisible;
});
const $b6dd983165ce5ba4$export$fd48a9e7d9ffc297 = (0, $dGvGJ.createSelector)([
    $b6dd983165ce5ba4$export$5a6d0e1cb58a7ee5,
    (0, $1z1J7.canManageSprints)
], (areSprintsEnabled)=>{
    const isCreateSprintVisible = (id)=>{
        if (!areSprintsEnabled) return false;
        return id === (0, $guzeq.BACKLOG);
    };
    return isCreateSprintVisible;
});
const $b6dd983165ce5ba4$export$35ab6d7577f201a3 = (0, $dGvGJ.createSelector)([
    (0, $jG5HW.getIsCompanyManaged),
    (0, $jG5HW.getIsParallelSprintsEnabled),
    $b6dd983165ce5ba4$export$b617a44e0fda9735
], (isCompanyManaged, isParallelSprintsEnabled, isStartSprintVisible)=>(id, isFirstList)=>{
        if (!isStartSprintVisible(id, isFirstList)) return false;
        // First list in backlog always has start sprint button enabled regardless
        if (isFirstList) return true;
        // Agility Boards always have parallel sprints enabled
        return isCompanyManaged ? isParallelSprintsEnabled : true;
    });
const $b6dd983165ce5ba4$export$b447779f07c42b51 = (0, $dGvGJ.createSelector)([
    $b6dd983165ce5ba4$export$5a6d0e1cb58a7ee5,
    $b6dd983165ce5ba4$export$d0747858fa55f115,
    $b6dd983165ce5ba4$export$5ce180897302be5f
], (areSprintsEnabled, canEditSprint, isActiveSprint)=>{
    const isCompleteSprintVisible = (id)=>areSprintsEnabled && isActiveSprint(id);
    return isCompleteSprintVisible;
});
const $b6dd983165ce5ba4$export$47615c8fc3c602b6 = (0, $dGvGJ.createSelector)([
    (state)=>(0, $dGljH.getCardLists)(state),
    (state)=>$b6dd983165ce5ba4$export$d0747858fa55f115(state),
    (state)=>$b6dd983165ce5ba4$export$5a6d0e1cb58a7ee5(state),
    // @ts-expect-error - TS7031 - Binding element 'cardListId' implicitly has an 'any' type.
    (state, { cardListId: cardListId })=>cardListId
], (cardLists, canEditSprint, areSprintsEnabled, cardListId)=>Boolean(areSprintsEnabled && canEditSprint(cardListId) && cardLists[cardListId].sprintData && !cardLists[cardListId].sprintData?.startDate && !cardLists[cardListId].sprintData?.endDate));
const $b6dd983165ce5ba4$export$e867ff6149c29060 = (0, $dGvGJ.createSelector)([
    (0, $jG5HW.getRapidViewId),
    (0, $dGljH.getVisibleCardListIds),
    (0, $dGljH.getCardLists)
], (rapidViewId, cardListIds, cardLists)=>// checking that there are any sprints which originates from a different board which is the requirement to show
    // the show board name config
    Boolean(cardListIds.map((cardListId)=>cardLists[cardListId]).filter((cardList)=>cardList.type === (0, $guzeq.SPRINT)).filter((cardList)=>{
        const originBoardId = cardList.sprintData?.originBoard?.rapidViewId;
        return originBoardId !== undefined && originBoardId !== Number(rapidViewId);
    }).length));
const $b6dd983165ce5ba4$export$53c26b74c0a1e3fe = (0, $dGvGJ.createSelector)([
    (0, $jG5HW.getIsCompanyManaged),
    (0, $dGljH.getCardLists),
    (0, $jG5HW.getRapidViewId)
], (isCMP, cardLists, id)=>{
    if (!isCMP) return 0;
    return Object.values(cardLists).map((cardList)=>cardList.sprintData?.originBoard).filter((originBoard)=>!!originBoard).filter((originBoard)=>originBoard?.rapidViewId !== Number(id)).length;
});

});
parcelRegister("45Qwd", function(module, exports) {

$parcel$export(module.exports, "getEstimationType", () => $9eb91d07319b2140$export$29518a6a820fd3eb);
$parcel$export(module.exports, "isOriginalEstimateTypeSelector", () => $9eb91d07319b2140$export$6a137137bd478798);
$parcel$export(module.exports, "isNumericEstimateTypeSelector", () => $9eb91d07319b2140$export$97ec2e51e7a87787);
$parcel$export(module.exports, "getEstimationFieldId", () => $9eb91d07319b2140$export$d49fd37e39c6e680);
$parcel$export(module.exports, "getEstimationName", () => $9eb91d07319b2140$export$402e2f057625b12d);
$parcel$export(module.exports, "getIsRemainingTimeTrackingEnabled", () => $9eb91d07319b2140$export$7de59b2ad512814f);

var $dGvGJ = parcelRequire("dGvGJ");

var $guzeq = parcelRequire("guzeq");

var $dGljH = parcelRequire("dGljH");

var $e5nhF = parcelRequire("e5nhF");
const $9eb91d07319b2140$export$930445b4a7dea9c7 = (state)=>(0, $e5nhF.getEntities)(state).estimation;
const $9eb91d07319b2140$export$a8f00aa8643e90b5 = (0, $dGvGJ.createSelector)($9eb91d07319b2140$export$930445b4a7dea9c7, (estimation)=>estimation.isEstimationFeatureEnabled);
const $9eb91d07319b2140$export$29518a6a820fd3eb = (0, $dGvGJ.createSelector)($9eb91d07319b2140$export$930445b4a7dea9c7, (estimation)=>estimation.estimationType);
const $9eb91d07319b2140$export$6a137137bd478798 = (state)=>$9eb91d07319b2140$export$29518a6a820fd3eb(state) === (0, $guzeq.ORIGINAL_ESTIMATE);
const $9eb91d07319b2140$export$97ec2e51e7a87787 = (state)=>$9eb91d07319b2140$export$29518a6a820fd3eb(state) === (0, $guzeq.STORY_POINTS);
const $9eb91d07319b2140$export$d49fd37e39c6e680 = (0, $dGvGJ.createSelector)($9eb91d07319b2140$export$930445b4a7dea9c7, (estimation)=>estimation.estimationFieldId);
const $9eb91d07319b2140$export$402e2f057625b12d = (0, $dGvGJ.createSelector)($9eb91d07319b2140$export$930445b4a7dea9c7, (estimation)=>estimation.name);
const $9eb91d07319b2140$export$7de59b2ad512814f = (0, $dGvGJ.createSelector)((0, $dGljH.getCards), (allCards)=>{
    const listOfCards = Object.values(allCards);
    if (listOfCards.length <= 0) return false;
    return !!listOfCards[0]?.estimate?.timeRemainingEstimate;
});

});

parcelRegister("bAfUr", function(module, exports) {

$parcel$export(module.exports, "getInitialStatusIds", () => $0bb134b497279a79$export$3b740680bb74be21);
$parcel$export(module.exports, "getResolutionDoneStatusIds", () => $0bb134b497279a79$export$a1205d43535ec163);
$parcel$export(module.exports, "getColumnStatusByStatusId", () => $0bb134b497279a79$export$2ae22d7372adb0d1);
$parcel$export(module.exports, "getColumnStatusIds", () => $0bb134b497279a79$export$eb0fe596a80f835f);
$parcel$export(module.exports, "isStatusMappedToBoardOld", () => $0bb134b497279a79$export$b9df98cb1a9ce42b);
$parcel$export(module.exports, "isStatusMappedToBoard", () => $0bb134b497279a79$export$48bfbcc6c0173871);
$parcel$export(module.exports, "makeGetKanbanSingleColumnStatusId", () => $0bb134b497279a79$export$5826bba123eba4f6);
$parcel$export(module.exports, "isStatusVisibleOnCmpKanbanBacklog", () => $0bb134b497279a79$export$87b2d43ded99833b);
$parcel$export(module.exports, "areStatusesFromSameColumn", () => $0bb134b497279a79$export$7c7e516bfb4a3562);

var $dGvGJ = parcelRequire("dGvGJ");

var $hGgHi = parcelRequire("hGgHi");

var $gJBT6 = parcelRequire("gJBT6");

var $gULOk = parcelRequire("gULOk");

var $guzeq = parcelRequire("guzeq");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $kwBUh = parcelRequire("kwBUh");
const $0bb134b497279a79$export$3b740680bb74be21 = (0, $dGvGJ.createSelector)([
    (0, $jG5HW.getIsCompanyManaged),
    (0, $kwBUh.getColumns)
], (isCompanyManaged, columns)=>{
    if (!columns) return [];
    const columnsArray = Object.values(columns);
    if (isCompanyManaged) {
        if (columnsArray.length) {
            const initialStatusColumn = columnsArray.find((column)=>column.order === 0);
            return initialStatusColumn ? initialStatusColumn.statuses.map((status)=>status.id) : [];
        }
    }
    return columnsArray.reduce((initialStatuses, column)=>{
        column.statuses.forEach((status)=>{
            const isInitialStatus = /* eslint-disable @typescript-eslint/consistent-type-assertions */ [
                (0, $gULOk.StatusCategoryTypes).NEW,
                (0, $gULOk.StatusCategoryTypes).UNDEFINED
            ]/* eslint-enable @typescript-eslint/consistent-type-assertions */ .includes(status.category);
            isInitialStatus && initialStatuses.push(status.id);
        });
        return initialStatuses;
    }, []);
});
const $0bb134b497279a79$export$a1205d43535ec163 = (0, $dGvGJ.createSelector)([
    (0, $jG5HW.getIsCompanyManaged),
    (0, $kwBUh.getColumns)
], (isCompanyManaged, columns)=>{
    if (!columns) return [];
    const columnsArray = Object.values(columns);
    if (isCompanyManaged) {
        if (columnsArray.length) {
            const resolutionDoneStatusColumn = columnsArray.find((column)=>column.order === columnsArray.length - 1);
            return resolutionDoneStatusColumn ? resolutionDoneStatusColumn.statuses.map((status)=>status.id) : [];
        }
    }
    return columnsArray.reduce((resolutionDoneStatuses, column)=>{
        column.statuses.forEach((status)=>{
            if (status.category === (0, $gULOk.StatusCategoryTypes).DONE) resolutionDoneStatuses.push(status.id);
        });
        return resolutionDoneStatuses;
    }, []);
});
const $0bb134b497279a79$export$2ae22d7372adb0d1 = (statusId)=>(0, $dGvGJ.createSelector)([
        (0, $kwBUh.getColumns)
    ], (columns)=>{
        if (!columns) return null;
        // We do this kind of loop because its more efficient than the alternative loops
        for (const columnKey of Object.keys(columns)){
            const status = (columns[columnKey].statuses || []).find((s)=>!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(s) && s.id === statusId);
            // Terminate early if we find what we need (flow doesn't like isNil here)
            if (status !== undefined && status !== null) return status;
        }
        return null;
    });
const $0bb134b497279a79$export$eb0fe596a80f835f = (0, $dGvGJ.createSelector)([
    (0, $kwBUh.getColumns)
], (columns)=>{
    if (!columns) return [];
    const columnsArray = Object.values(columns);
    return columnsArray.reduce((statuseIds, column)=>{
        column.statuses.forEach((status)=>{
            statuseIds.push(status.id);
        });
        return statuseIds;
    }, []);
});
const $0bb134b497279a79$export$b9df98cb1a9ce42b = (statusId)=>(0, $dGvGJ.createSelector)([
        $0bb134b497279a79$export$eb0fe596a80f835f
    ], (columnStatusIds)=>{
        if (!columnStatusIds) return false;
        return columnStatusIds.includes(statusId);
    });
const $0bb134b497279a79$export$48bfbcc6c0173871 = (0, $dGvGJ.createSelector)([
    $0bb134b497279a79$export$eb0fe596a80f835f
], (columnStatusIds)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((statusId)=>{
        if (!columnStatusIds) return false;
        return columnStatusIds.includes(statusId);
    }));
const $0bb134b497279a79$export$5826bba123eba4f6 = (0, $dGvGJ.createSelector)([
    (0, $jG5HW.getIsCompanyManaged),
    (0, $jG5HW.isKanbanBacklogStrategy),
    (0, $dGljH.getCardLists),
    (0, $jG5HW.getKanbanTargetColumnId),
    (0, $kwBUh.makeGetColumn)
], (isCompanyManaged, isKanbanStrategy, cardLists, selectKanbanTargetColumnId, getColumn)=>(cardListId)=>{
        if (!isCompanyManaged || !isKanbanStrategy) return undefined;
        const cardList = cardLists[cardListId];
        if (!cardList) return undefined;
        if (cardList.type === (0, $guzeq.SPRINT)) return undefined;
        const targetColumnId = selectKanbanTargetColumnId(cardList.type);
        if (!targetColumnId) return undefined;
        const column = getColumn(targetColumnId);
        if (!column) return undefined;
        return column.statuses.length === 1 ? column.statuses[0].id : undefined;
    });
const $0bb134b497279a79$export$84797642e3c942d3 = (0, $dGvGJ.createSelector)([
    (0, $kwBUh.getColumns),
    (0, $jG5HW.getKanbanBoardColumnId),
    (0, $jG5HW.getKanbanBacklogColumnId)
], (columns, kanbanBoardColumnId, kanbanBacklogColumnId)=>{
    if (!columns || !kanbanBoardColumnId || !kanbanBacklogColumnId) return [];
    const boardStatuses = columns[kanbanBoardColumnId].statuses;
    const backlogStatuses = columns[kanbanBacklogColumnId].statuses;
    return [
        ...boardStatuses,
        ...backlogStatuses
    ].map((columnStatus)=>columnStatus.id);
});
const $0bb134b497279a79$export$87b2d43ded99833b = (0, $dGvGJ.createSelector)([
    $0bb134b497279a79$export$84797642e3c942d3
], (visibleStatusIds)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((statusId)=>visibleStatusIds.includes(statusId)));
const $0bb134b497279a79$export$7c7e516bfb4a3562 = (0, $dGvGJ.createSelector)([
    (0, $kwBUh.getColumns)
], (columns)=>// The first two statusIds have been named explicitly to ensure
    // at least two statuses are required for comparison
    (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((firstStatusId, secondStatusId, ...remainingStatusIds)=>{
        if (!columns) return false;
        // The column that houses the first status is the point of reference.
        // We'll check whether all other statuses exist in this column.
        const columnOfFirstStatus = (0, $kwBUh.findColumnByStatusId)(columns, firstStatusId);
        const statusesToCheck = [
            secondStatusId,
            ...remainingStatusIds
        ];
        if (!columnOfFirstStatus) return false;
        const columnStatusIds = columnOfFirstStatus.statuses.map(({ id: id })=>id);
        return statusesToCheck.every((statusId)=>columnStatusIds.includes(statusId));
    }, // Construct a custom cache key for memoize as it
    // only uses the first arg for the cache key by default
    (...statusIds)=>[
            ...statusIds.concat().sort()
        ].join('_')));

});
parcelRegister("kwBUh", function(module, exports) {

$parcel$export(module.exports, "getColumns", () => $d00b9b2cbbfb80a8$export$978e30a0fb8610d8);
$parcel$export(module.exports, "makeGetColumn", () => $d00b9b2cbbfb80a8$export$c8e2f531112a8425);
$parcel$export(module.exports, "findColumnByStatusId", () => $d00b9b2cbbfb80a8$export$b8cb2be3dbed32e1);
$parcel$export(module.exports, "getColumnCount", () => $d00b9b2cbbfb80a8$export$813bef8f01765aa1);

var $dGvGJ = parcelRequire("dGvGJ");

var $gJBT6 = parcelRequire("gJBT6");

var $e5nhF = parcelRequire("e5nhF");
const $d00b9b2cbbfb80a8$export$978e30a0fb8610d8 = (state)=>(0, $e5nhF.getEntities)(state).column;
const $d00b9b2cbbfb80a8$export$c8e2f531112a8425 = (state)=>(columnId)=>{
        const columns = $d00b9b2cbbfb80a8$export$978e30a0fb8610d8(state);
        if (!columns) return null;
        return columns[String(columnId)] ?? null;
    };
const $d00b9b2cbbfb80a8$export$b8cb2be3dbed32e1 = (columns, statusId)=>columns && Object.values(columns).find((column)=>column.statuses.some((columnStatus)=>columnStatus.id === statusId));
const $d00b9b2cbbfb80a8$export$c0868dfc0085fdc9 = (0, $dGvGJ.createSelector)([
    $d00b9b2cbbfb80a8$export$978e30a0fb8610d8
], (columns)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((statusId)=>$d00b9b2cbbfb80a8$export$b8cb2be3dbed32e1(columns, statusId)));
const $d00b9b2cbbfb80a8$export$813bef8f01765aa1 = (columns)=>{
    if (!columns || Object.keys(columns).length === 0) return {
        initialColumnCount: 0,
        inProgressColumnCount: 0,
        doneColumnCount: 0
    };
    // the order of columns in the state is not guaranteed so if you want to get the correct column object you will need to sort them by tje column's "order"
    const cols = Object.values(columns);
    const initialColumnCount = 1;
    const doneColumnCount = cols.length > 1 ? 1 : 0;
    const inProgressColumnCount = Math.max(0, cols.length - 2); // columns between initial and done
    return {
        initialColumnCount: initialColumnCount,
        inProgressColumnCount: inProgressColumnCount,
        doneColumnCount: doneColumnCount
    };
};

});




parcelRegister("3lZ6i", function(module, exports) {

$parcel$export(module.exports, "INITIALIZE_APP_PROPS", () => $a8888b8c4c9e815d$export$84856e4ae7cd7538);
$parcel$export(module.exports, "initializeAppProps", () => $a8888b8c4c9e815d$export$5f0e35553cecddfe);
$parcel$export(module.exports, "LOAD_APP_DATA_REQUEST", () => $a8888b8c4c9e815d$export$4f8b7d7927a22b01);
$parcel$export(module.exports, "loadAppData", () => $a8888b8c4c9e815d$export$c0b92fee0bc9f9f3);
$parcel$export(module.exports, "LOAD_APP_DATA_FAILURE", () => $a8888b8c4c9e815d$export$b707057781245e8f);
$parcel$export(module.exports, "loadAppDataFailure", () => $a8888b8c4c9e815d$export$442c6ce163728713);
$parcel$export(module.exports, "SET_APP_DATA", () => $a8888b8c4c9e815d$export$913417342844b14c);
$parcel$export(module.exports, "setAppData", () => $a8888b8c4c9e815d$export$9f61e044a5ec71f4);
$parcel$export(module.exports, "LOAD_CONFIG_DATA_REQUEST", () => $a8888b8c4c9e815d$export$a7098c3930b55b23);
$parcel$export(module.exports, "loadConfigData", () => $a8888b8c4c9e815d$export$6ca3a482217f96bb);
$parcel$export(module.exports, "LOAD_CONFIG_DATA_FAILURE", () => $a8888b8c4c9e815d$export$d9a7e4743c3f9bb6);
$parcel$export(module.exports, "loadConfigDataFailure", () => $a8888b8c4c9e815d$export$a6d32f0fe95fd7);
$parcel$export(module.exports, "LOAD_CONFIG_DATA_MODEL_SUCCESS", () => $a8888b8c4c9e815d$export$1231ea6d6fc1e894);
$parcel$export(module.exports, "loadConfigDataModelSuccess", () => $a8888b8c4c9e815d$export$11bca38ca7a076c9);
$parcel$export(module.exports, "LOAD_CONFIG_DATA_SUCCESS", () => $a8888b8c4c9e815d$export$e84bf3e6432acad9);
$parcel$export(module.exports, "loadConfigDataSuccess", () => $a8888b8c4c9e815d$export$2d8a793787dedc61);
$parcel$export(module.exports, "SET_CONFIG_DATA", () => $a8888b8c4c9e815d$export$b46a9391a0c75503);
$parcel$export(module.exports, "setConfigData", () => $a8888b8c4c9e815d$export$6da10c57829cd8e6);
$parcel$export(module.exports, "BACKLOG_VIEW", () => $a8888b8c4c9e815d$export$bcb8585a82b8f8c7);
$parcel$export(module.exports, "backlogView", () => $a8888b8c4c9e815d$export$4696f1f49cfb7d46);
$parcel$export(module.exports, "REFRESH_DATA_REQUEST", () => $a8888b8c4c9e815d$export$f015544c9ef3cb40);
$parcel$export(module.exports, "refreshDataRequest", () => $a8888b8c4c9e815d$export$7245a5bb55cf1c);
$parcel$export(module.exports, "refreshDataFailure", () => $a8888b8c4c9e815d$export$5bb841369f417b5b);
$parcel$export(module.exports, "CHECK_GLOBAL_ISSUE_CREATE", () => $a8888b8c4c9e815d$export$d3342655e6919343);
$parcel$export(module.exports, "checkGlobalIssueCreate", () => $a8888b8c4c9e815d$export$d2425890b90f3347);
$parcel$export(module.exports, "LOAD_CARD_CREATE_CONFIG_REQUEST", () => $a8888b8c4c9e815d$export$1dd1f39bb2e82807);
$parcel$export(module.exports, "LOAD_CARD_CREATE_CONFIG_SUCCESS", () => $a8888b8c4c9e815d$export$a62958b8add4d4a0);
$parcel$export(module.exports, "loadCardCreateConfigSuccess", () => $a8888b8c4c9e815d$export$42eba9692ae3b59c);
$parcel$export(module.exports, "LOAD_CARD_CREATE_CONFIG_FAILURE", () => $a8888b8c4c9e815d$export$4b08535554f72f68);
$parcel$export(module.exports, "loadCardCreateConfigFailure", () => $a8888b8c4c9e815d$export$eddf97b41d9e89cf);
const $a8888b8c4c9e815d$export$84856e4ae7cd7538 = 'state.actions.app.INITIALIZE_APP_PROPS';
const $a8888b8c4c9e815d$export$5f0e35553cecddfe = (payload)=>({
        type: $a8888b8c4c9e815d$export$84856e4ae7cd7538,
        payload: payload
    });
const $a8888b8c4c9e815d$export$4f8b7d7927a22b01 = 'state.actions.app.LOAD_APP_DATA_REQUEST';
const $a8888b8c4c9e815d$export$c0b92fee0bc9f9f3 = (payload = {})=>({
        type: $a8888b8c4c9e815d$export$4f8b7d7927a22b01,
        payload: payload
    });
const $a8888b8c4c9e815d$export$b707057781245e8f = 'state.actions.app.LOAD_APP_DATA_FAILURE';
const $a8888b8c4c9e815d$export$442c6ce163728713 = ()=>({
        type: $a8888b8c4c9e815d$export$b707057781245e8f
    });
const $a8888b8c4c9e815d$export$913417342844b14c = 'state.actions.app.SET_APP_DATA';
const $a8888b8c4c9e815d$export$9f61e044a5ec71f4 = (payload)=>({
        type: $a8888b8c4c9e815d$export$913417342844b14c,
        payload: payload
    });
const $a8888b8c4c9e815d$export$a7098c3930b55b23 = 'state.actions.app.LOAD_CONFIG_DATA_REQUEST';
const $a8888b8c4c9e815d$export$6ca3a482217f96bb = ()=>({
        type: $a8888b8c4c9e815d$export$a7098c3930b55b23
    });
const $a8888b8c4c9e815d$export$d9a7e4743c3f9bb6 = 'state.actions.app.LOAD_CONFIG_DATA_FAILURE';
const $a8888b8c4c9e815d$export$a6d32f0fe95fd7 = ()=>({
        type: $a8888b8c4c9e815d$export$d9a7e4743c3f9bb6
    });
const $a8888b8c4c9e815d$export$1231ea6d6fc1e894 = 'state.actions.app.LOAD_CONFIG_DATA_MODEL_SUCCESS';
const $a8888b8c4c9e815d$export$11bca38ca7a076c9 = (payload)=>({
        type: $a8888b8c4c9e815d$export$1231ea6d6fc1e894,
        payload: payload
    });
const $a8888b8c4c9e815d$export$e84bf3e6432acad9 = 'state.actions.app.LOAD_CONFIG_DATA_SUCCESS';
const $a8888b8c4c9e815d$export$2d8a793787dedc61 = ()=>({
        type: $a8888b8c4c9e815d$export$e84bf3e6432acad9
    });
const $a8888b8c4c9e815d$export$b46a9391a0c75503 = 'state.actions.app.SET_CONFIG_DATA';
const $a8888b8c4c9e815d$export$6da10c57829cd8e6 = (payload)=>({
        type: $a8888b8c4c9e815d$export$b46a9391a0c75503,
        payload: payload
    });
const $a8888b8c4c9e815d$export$bcb8585a82b8f8c7 = 'state.actions.app.BACKLOG_VIEW';
const $a8888b8c4c9e815d$export$4696f1f49cfb7d46 = (analyticsEvent)=>({
        type: $a8888b8c4c9e815d$export$bcb8585a82b8f8c7,
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $a8888b8c4c9e815d$export$f015544c9ef3cb40 = 'state.actions.app.REFRESH_DATA_REQUEST';
const $a8888b8c4c9e815d$export$7245a5bb55cf1c = (source, issues, storeFieldsActions)=>({
        type: $a8888b8c4c9e815d$export$f015544c9ef3cb40,
        payload: {
            source: source,
            issues: issues,
            storeFieldsActions: storeFieldsActions
        }
    });
const $a8888b8c4c9e815d$export$447a7d83169b5ed9 = 'state.actions.app.REFRESH_DATA_FAILURE';
const $a8888b8c4c9e815d$export$5bb841369f417b5b = ()=>({
        type: $a8888b8c4c9e815d$export$447a7d83169b5ed9
    });
const $a8888b8c4c9e815d$export$d3342655e6919343 = 'state.actions.app.CHECK_GLOBAL_ISSUE_CREATE';
const $a8888b8c4c9e815d$export$d2425890b90f3347 = (issues)=>({
        type: $a8888b8c4c9e815d$export$d3342655e6919343,
        payload: {
            issues: issues
        }
    });
const $a8888b8c4c9e815d$export$1dd1f39bb2e82807 = 'state.actions.app.LOAD_CARD_CREATE_CONFIG_REQUEST';
const $a8888b8c4c9e815d$export$149bf88f2a958c35 = ()=>({
        type: $a8888b8c4c9e815d$export$1dd1f39bb2e82807
    });
const $a8888b8c4c9e815d$export$a62958b8add4d4a0 = 'state.actions.app.LOAD_CARD_CREATE_CONFIG_SUCCESS';
const $a8888b8c4c9e815d$export$42eba9692ae3b59c = (response, analyticsEvent)=>({
        type: $a8888b8c4c9e815d$export$a62958b8add4d4a0,
        payload: response,
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $a8888b8c4c9e815d$export$4b08535554f72f68 = 'state.actions.app.LOAD_CARD_CREATE_CONFIG_FAILURE';
const $a8888b8c4c9e815d$export$eddf97b41d9e89cf = (error, analyticsEvent)=>({
        type: $a8888b8c4c9e815d$export$4b08535554f72f68,
        payload: {
            error: error
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });

});

parcelRegister("3qXBy", function(module, exports) {

$parcel$export(module.exports, "BOARD_ISSUE_MOVE_CANCEL", () => $478abff165c36fa8$export$22ae87f30df1ab2a);
$parcel$export(module.exports, "boardIssueMoveCancel", () => $478abff165c36fa8$export$21c319cd4bbf2b2f);
$parcel$export(module.exports, "BOARD_ISSUE_MOVE_SHOW", () => $478abff165c36fa8$export$e229682e10ad017a);
$parcel$export(module.exports, "boardIssueMoveShow", () => $478abff165c36fa8$export$afe8c48481994c25);
$parcel$export(module.exports, "BOARD_ISSUE_MOVE_EXECUTE", () => $478abff165c36fa8$export$a0efdae17a1cafbf);
$parcel$export(module.exports, "boardIssueMoveExecute", () => $478abff165c36fa8$export$47de1859c695eca7);
$parcel$export(module.exports, "BOARD_ISSUE_MOVE_EXECUTE_SUCCESS", () => $478abff165c36fa8$export$7bbe0c5ad5f82e3b);
$parcel$export(module.exports, "BOARD_ISSUE_MOVE_EXECUTE_FAILURE", () => $478abff165c36fa8$export$a246706d8be8143c);

var $c0irb = parcelRequire("c0irb");
const $478abff165c36fa8$export$22ae87f30df1ab2a = 'state.actions.board-issue-move.BOARD_ISSUE_MOVE_CANCEL';
const $478abff165c36fa8$export$21c319cd4bbf2b2f = ()=>({
        type: $478abff165c36fa8$export$22ae87f30df1ab2a
    });
const $478abff165c36fa8$export$e229682e10ad017a = 'state.actions.board-issue-move.BOARD_ISSUE_MOVE_SHOW';
const $478abff165c36fa8$export$afe8c48481994c25 = ()=>({
        type: $478abff165c36fa8$export$e229682e10ad017a
    });
const $478abff165c36fa8$export$a0efdae17a1cafbf = 'state.actions.board-issue-move.BOARD_ISSUE_MOVE_EXECUTE';
const $478abff165c36fa8$export$47de1859c695eca7 = ()=>({
        type: $478abff165c36fa8$export$a0efdae17a1cafbf,
        meta: (0, $c0irb.beginOptimisticUiMeta)()
    });
const $478abff165c36fa8$export$7bbe0c5ad5f82e3b = 'state.actions.board-issue-move.BOARD_ISSUE_MOVE_EXECUTE_SUCCESS';
const $478abff165c36fa8$export$403d172f0e549eb1 = (optimisticId)=>({
        type: $478abff165c36fa8$export$7bbe0c5ad5f82e3b,
        meta: (0, $c0irb.commitOptimisticUiMeta)(optimisticId)
    });
const $478abff165c36fa8$export$a246706d8be8143c = 'state.actions.board-issue-move.BOARD_ISSUE_MOVE_EXECUTE_FAILURE';
const $478abff165c36fa8$export$3c31c79b76c3db3b = (optimisticId)=>({
        type: $478abff165c36fa8$export$a246706d8be8143c,
        meta: (0, $c0irb.revertOptimisticUiWithFlagMeta)(optimisticId)
    });

});


parcelRegister("3b59T", function(module, exports) {

$parcel$export(module.exports, "default", () => $56d0c98c20f0247b$export$2e2bcd8739ae039);

var $jIyVb = parcelRequire("jIyVb");
parcelRequire("hZWgu");
parcelRequire("6cbqE");

var $3qXBy = parcelRequire("3qXBy");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$56d0c98c20f0247b$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $3qXBy.BOARD_ISSUE_MOVE_CANCEL), (0, $3qXBy.BOARD_ISSUE_MOVE_EXECUTE)).switchMap(()=>(0, $jIyVb.dismissDialog)(store.getState()).ignoreElements());

});


parcelRegister("eBTGr", function(module, exports) {

$parcel$export(module.exports, "default", () => $2123bb6f294a6113$export$2e2bcd8739ae039);

var $aB8eX = parcelRequire("aB8eX");

var $e1AU2 = parcelRequire("e1AU2");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");
parcelRequire("d0pqD");
parcelRequire("1oQta");
parcelRequire("6hSeW");
parcelRequire("d6iim");
parcelRequire("fjPtF");

var $7Jxgt = parcelRequire("7Jxgt");

var $2YZCu = parcelRequire("2YZCu");

var $jJZqs = parcelRequire("jJZqs");

var $fZneA = parcelRequire("fZneA");

var $g4slm = parcelRequire("g4slm");

var $avYIL = parcelRequire("avYIL");

var $js96S = parcelRequire("js96S");

var $6JzCg = parcelRequire("6JzCg");
const $2123bb6f294a6113$export$d03120aa6150e275 = (action$)=>action$.ofType((0, $js96S.CARD_SET_REQUEST)).mergeMap((action)=>{
        const { batchId: batchId, setMutations: setMutations } = action.payload;
        return (0, $kVLXA.Observable).from(setMutations).mergeMap((mutation)=>{
            const { optimistic: { id: optimisticId }, [(0, $6JzCg.CARD_SET_META_KEY)]: { fieldId: fieldId, issueKey: issueKey, newValue: newValue, retryAction: retryAction }, analyticsEvent: analyticsEvent } = mutation;
            return (0, $g4slm.default)({
                issueKey: issueKey,
                fieldId: fieldId,
                newValue: newValue
            }).map(()=>(0, $js96S.cardSetIndividualResponseSuccess)({
                    batchId: batchId,
                    issueKey: issueKey,
                    fieldId: fieldId
                }, optimisticId, analyticsEvent)).catch((error)=>{
                (0, $2YZCu.default).safeErrorWithoutCustomerData('bulk-ops-send-request-epic', `Failed to set card field '${fieldId}'`, error);
                const isNetworkError = (0, $fZneA.isClientFetchError)(error);
                const isUserValidationError = (0, $jJZqs.isValidationError)(error);
                // eslint-disable-next-line no-nested-ternary
                const failureReason = isNetworkError ? 'network' : isUserValidationError ? 'validation' : 'server';
                const statusCode = 'statusCode' in error ? error.statusCode : undefined;
                return (0, $kVLXA.Observable).of((0, $js96S.cardSetIndividualResponseFailure)({
                    batchId: batchId,
                    issueKey: issueKey,
                    fieldId: fieldId,
                    retryAction: retryAction,
                    failureReason: failureReason,
                    statusCode: statusCode
                }, optimisticId, analyticsEvent));
            });
        }).bufferCount(setMutations.length).mergeMap((cardSetRequestResponses)=>(0, $kVLXA.Observable).of((0, $aB8eX.batchActions)(cardSetRequestResponses)));
    });
const $2123bb6f294a6113$var$isActionWithCardSetMeta = (action)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    action.meta?.[0, $6JzCg.CARD_SET_META_KEY] !== undefined;
const $2123bb6f294a6113$var$isCardSetIndividualResponse = (action)=>action.type === (0, $js96S.CARD_SET_INDIVIDUAL_REQUEST_SUCCESS) || action.type === (0, $js96S.CARD_SET_INDIVIDUAL_REQUEST_FAILURE);
const $2123bb6f294a6113$var$isCardSetIndividualRequestFailure = (action)=>action.type === (0, $js96S.CARD_SET_INDIVIDUAL_REQUEST_FAILURE);
const $2123bb6f294a6113$var$getFailureReason = (failedActions)=>{
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const firstFailureReason = failedActions[0].payload.failureReason;
    const isAllSameFailureReason = failedActions.every((action)=>action.payload.failureReason === firstFailureReason);
    return isAllSameFailureReason ? firstFailureReason : 'mixed';
};
const $2123bb6f294a6113$export$1d45daa6c882af99 = (action$)=>action$.ofType((0, $aB8eX.BATCH)).mergeMap((action)=>{
        const cardSetMetaActions = action.payload.filter($2123bb6f294a6113$var$isActionWithCardSetMeta);
        if (cardSetMetaActions.length < 1) return (0, $kVLXA.Observable).empty();
        const cardSetActions$ = (0, $kVLXA.Observable).from(cardSetMetaActions).map((actionWithCardSetMeta)=>actionWithCardSetMeta.meta);
        const batchId = (0, $7Jxgt.v4)();
        const request$ = cardSetActions$.bufferCount(cardSetMetaActions.length).map((setMutations)=>(0, $js96S.cardSetRequest)(setMutations, batchId));
        const response$ = action$.ofType((0, $aB8eX.BATCH)).mergeMap((batchAction)=>batchAction.payload).filter($2123bb6f294a6113$var$isCardSetIndividualResponse).filter((cardSetIndividualResponse)=>cardSetIndividualResponse.payload.batchId === batchId).bufferCount(cardSetMetaActions.length).mergeMap((cardSetRequestResponses)=>{
            const failedActions = cardSetRequestResponses.filter($2123bb6f294a6113$var$isCardSetIndividualRequestFailure);
            if (!failedActions.length) return (0, $kVLXA.Observable).empty();
            const totalCount = cardSetRequestResponses.length;
            const previousFailedBatchIds = cardSetMetaActions[0].meta.failedBatchIds;
            const failedActionBuilders = failedActions.map((failedAction)=>failedAction.payload.retryAction);
            const failedIssueKeys = failedActions.map((failedAction)=>failedAction.payload.issueKey);
            const failedBatchIds = previousFailedBatchIds?.length ? previousFailedBatchIds.concat(batchId) : [
                batchId
            ];
            return (0, $kVLXA.Observable).of((0, $avYIL.bulkOpsShowFailedFlag)({
                failedActionBuilders: failedActionBuilders,
                failedIssueKeys: failedIssueKeys,
                totalCount: totalCount,
                failedBatchIds: failedBatchIds,
                failureReason: $2123bb6f294a6113$var$getFailureReason(failedActions)
            }));
        });
        return request$.merge(response$);
    });
var $2123bb6f294a6113$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)($2123bb6f294a6113$export$1d45daa6c882af99, $2123bb6f294a6113$export$d03120aa6150e275);

});
parcelRegister("g4slm", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c29720f4ae98da0$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");

var $fund4 = parcelRequire("fund4");
parcelRequire("9o0uh");
const $9c29720f4ae98da0$var$cardSetService = ({ fieldId: fieldId, issueKey: issueKey, newValue: newValue })=>(0, $kVLXA.Observable).fromPromise((0, $fund4.default)({
        issueKey: issueKey,
        fieldId: fieldId,
        newValue: newValue
    }));
var $9c29720f4ae98da0$export$2e2bcd8739ae039 = $9c29720f4ae98da0$var$cardSetService;

});
parcelRegister("fund4", function(module, exports) {

$parcel$export(module.exports, "default", () => $d42a6296829b6c86$export$2e2bcd8739ae039);

var $ebyGx = parcelRequire("ebyGx");

var $eusud = parcelRequire("eusud");

var $4tcSU = parcelRequire("4tcSU");
const $d42a6296829b6c86$var$getFieldUpdate = (fieldId, value)=>({
        fields: {
            [fieldId]: value
        }
    });
const $d42a6296829b6c86$var$cardUpdateRest = ({ fieldId: fieldId, issueKey: issueKey, newValue: newValue })=>(0, $eusud.performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify($d42a6296829b6c86$var$getFieldUpdate(fieldId, newValue))
    });
const $d42a6296829b6c86$export$31627ab97a843839 = ({ fieldId: fieldId, cardId: cardId, newValue: newValue, fieldsToForcePresent: fieldsToForcePresent })=>(0, $eusud.performPostRequest)('/secure/AjaxIssueAction.jspa?decorator=none', {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: (0, $ebyGx.stringify)({
            issueId: cardId,
            [fieldId]: newValue,
            atl_token: (0, $4tcSU.default)(),
            skipScreenCheck: true,
            singleFieldEdit: true,
            fieldsToForcePresent: fieldsToForcePresent
        })
    });
var $d42a6296829b6c86$export$2e2bcd8739ae039 = $d42a6296829b6c86$var$cardUpdateRest;

});


parcelRegister("js96S", function(module, exports) {

$parcel$export(module.exports, "CARD_SET_REQUEST", () => $c5e269039e50e9db$export$952416878bada00d);
$parcel$export(module.exports, "cardSetRequest", () => $c5e269039e50e9db$export$dc4cb42f76517e71);
$parcel$export(module.exports, "CARD_SET_INDIVIDUAL_REQUEST_SUCCESS", () => $c5e269039e50e9db$export$8cbba69660c382bc);
$parcel$export(module.exports, "cardSetIndividualResponseSuccess", () => $c5e269039e50e9db$export$a84ab8ecccfa05f1);
$parcel$export(module.exports, "CARD_SET_INDIVIDUAL_REQUEST_FAILURE", () => $c5e269039e50e9db$export$a0fc6789cc35a208);
$parcel$export(module.exports, "cardSetIndividualResponseFailure", () => $c5e269039e50e9db$export$fff072d58f0c031f);

var $c0irb = parcelRequire("c0irb");
const $c5e269039e50e9db$export$952416878bada00d = 'state.actions.card-set.CARD_SET_REQUEST';
const $c5e269039e50e9db$export$dc4cb42f76517e71 = (setMutations, batchId)=>({
        type: $c5e269039e50e9db$export$952416878bada00d,
        payload: {
            setMutations: setMutations,
            batchId: batchId
        }
    });
const $c5e269039e50e9db$export$8cbba69660c382bc = 'state.actions.card-set.CARD_SET_INDIVIDUAL_REQUEST_SUCCESS';
const $c5e269039e50e9db$export$a84ab8ecccfa05f1 = (payload, optimisticId, analyticsEvent)=>({
        type: $c5e269039e50e9db$export$8cbba69660c382bc,
        payload: payload,
        meta: {
            ...(0, $c0irb.commitOptimisticUiMeta)(optimisticId),
            analyticsEvent: analyticsEvent
        }
    });
const $c5e269039e50e9db$export$a0fc6789cc35a208 = 'state.actions.card-set.CARD_SET_INDIVIDUAL_REQUEST_FAILURE';
const $c5e269039e50e9db$export$fff072d58f0c031f = (payload, optimisticId, analyticsEvent)=>({
        type: $c5e269039e50e9db$export$a0fc6789cc35a208,
        payload: payload,
        meta: {
            ...(0, $c0irb.revertOptimisticUiMeta)(optimisticId),
            analyticsEvent: analyticsEvent
        }
    });

});

parcelRegister("6JzCg", function(module, exports) {

$parcel$export(module.exports, "CARD_SET_META_KEY", () => $5ecc710be775690b$export$d065026949290531);
$parcel$export(module.exports, "setCardSetMeta", () => $5ecc710be775690b$export$6bd5fd0b08cb2b1d);

var $c0irb = parcelRequire("c0irb");
const $5ecc710be775690b$export$d065026949290531 = Symbol('CARD_SET_META_KEY');
const $5ecc710be775690b$export$6bd5fd0b08cb2b1d = (payload, analyticsEvent)=>({
        [$5ecc710be775690b$export$d065026949290531]: payload,
        analyticsEvent: analyticsEvent,
        ...(0, $c0irb.beginOptimisticUiMeta)()
    });

});


parcelRegister("hnaxO", function(module, exports) {

$parcel$export(module.exports, "buildAssignToMeEpic", () => $7402c8a809d95853$export$f773e45c14115697);
$parcel$export(module.exports, "cardAssignToMeThrottledEpic", () => $7402c8a809d95853$export$5ed483b9a7992e55);
parcelRequire("fp4O3");
parcelRequire("9o0uh");
parcelRequire("3awJm");
parcelRequire("fPS7b");
parcelRequire("d0pqD");
parcelRequire("c66Ur");

var $hGgHi = parcelRequire("hGgHi");

var $kVLXA = parcelRequire("kVLXA");

var $7Jxgt = parcelRequire("7Jxgt");

var $aYkSv = parcelRequire("aYkSv");

var $4G04L = parcelRequire("4G04L");

var $8hVbJ = parcelRequire("8hVbJ");

var $g4P00 = parcelRequire("g4P00");
const $7402c8a809d95853$export$59640cb3aa92677 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
swagClient, action, { onStart: onStart, onSuccess: onSuccess } = {})=>{
    const { id: optimisticId } = action.meta.optimistic;
    const { cardId: cardId, assignee: assignee, concurrentId: concurrentId } = action.payload;
    if (onStart) onStart(action);
    return (0, $kVLXA.Observable).fromPromise((0, $aYkSv.assignToMe)(swagClient, {
        issueId: `${cardId}`,
        accountId: assignee?.id
    })).map(()=>{
        if (onSuccess) onSuccess(action);
        return (0, $g4P00.assignToMeSuccess)(optimisticId, concurrentId);
    }).catch(()=>(0, $kVLXA.Observable).of((0, $g4P00.assignToMeFailure)(optimisticId, concurrentId)));
};
const $7402c8a809d95853$var$hooks = {
    onStart: ({ payload: { concurrentId: concurrentId, assignee: assignee, fireShortcutAnalyticsFn: fireShortcutAnalyticsFn } })=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(concurrentId)) (0, $4G04L.scheduleAfterRender)(()=>{
            (0, $8hVbJ.assignToMeInteraction)(concurrentId).mark('feedback');
        });
        if (fireShortcutAnalyticsFn) fireShortcutAnalyticsFn({
            id: 'assignToMeKeyboardShortcut',
            key: 'i',
            attributes: {
                assignStatus: assignee !== null ? 'assign' : 'unassign'
            }
        });
    },
    onSuccess: ({ payload: { concurrentId: concurrentId } })=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(concurrentId)) (0, $4G04L.scheduleAfterRender)(()=>{
            (0, $8hVbJ.assignToMeInteraction)(concurrentId).stop();
        });
    }
};
const $7402c8a809d95853$export$f773e45c14115697 = (swagClient)=>(action$)=>action$.ofType((0, $g4P00.ASSIGN_TO_ME_REQUEST)).flatMap((action)=>$7402c8a809d95853$export$59640cb3aa92677(swagClient, action, $7402c8a809d95853$var$hooks));
const $7402c8a809d95853$export$5ed483b9a7992e55 = (action$)=>action$.ofType((0, $g4P00.ASSIGN_TO_ME_REQUEST_THROTTLED)).throttleTime(500).flatMap((action)=>{
        const { cardId: cardId, assignee: assignee, fireShortcutAnalyticsFn: fireShortcutAnalyticsFn } = action.payload;
        const concurrentId = (0, $7Jxgt.v4)();
        (0, $8hVbJ.assignToMeInteraction)(concurrentId).start();
        return (0, $kVLXA.Observable).of((0, $g4P00.assignToMeRequest)({
            cardId: cardId,
            assignee: assignee,
            concurrentId: concurrentId,
            fireShortcutAnalyticsFn: fireShortcutAnalyticsFn
        }));
    });

});
parcelRegister("aYkSv", function(module, exports) {

$parcel$export(module.exports, "assignToMe", () => $4addbd3196ad60f5$export$521df9d10558315a);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $cNrxd = parcelRequire("cNrxd");

var $1EJrV = parcelRequire("1EJrV");

var $j8ZVG = parcelRequire("j8ZVG");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4addbd3196ad60f5$var$onMutationError = (error)=>{
    if ((0, $1EJrV.isExpectedGraphQLError)(error)) return;
    (0, $jcw0u.default)({
        error: error,
        meta: {
            id: 'assignToMeMutationFailed',
            packageName: 'jiraSoftwareKeyboardShortcuts'
        }
    });
};
const $4addbd3196ad60f5$export$521df9d10558315a = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
swagClient, variables)=>swagClient.mutate({
        mutation: (0, $j8ZVG.MUTATION),
        variables: variables
    }).then((result)=>{
        if (result.errors && result.errors.length || !result.data) throw new (0, $cNrxd.SwagError)({
            // @ts-expect-error - TS2322 - Type 'readonly GraphQLError[] | undefined' is not assignable to type 'GraphqlError[] | undefined'.
            graphQLErrors: result.errors,
            errorMessage: 'Assign to me failed'
        });
        return result.data;
    }).catch((err)=>{
        $4addbd3196ad60f5$var$onMutationError(err);
        throw err;
    });
const $4addbd3196ad60f5$export$5d2cd46d1c41b734 = ()=>{
    const [assignToMeMutation] = (0, $j8ZVG.useAssignToMeMutation)();
    return (0, $5uXOq.useCallback)(({ issueId: issueId, accountId: accountId })=>{
        const assignMutationPromise = assignToMeMutation({
            variables: {
                issueId: issueId,
                accountId: accountId
            }
        });
        assignMutationPromise.catch($4addbd3196ad60f5$var$onMutationError);
        return assignMutationPromise;
    }, [
        assignToMeMutation
    ]);
};

});
parcelRegister("1EJrV", function(module, exports) {

$parcel$export(module.exports, "isExpectedGraphQLError", () => $ec71481172594c19$export$9bfdf944b8987eac);
const $ec71481172594c19$export$9bfdf944b8987eac = (error)=>Boolean(error.graphQLErrors?.length > 0 && error.graphQLErrors?.every((graphQLError)=>{
        const statusCode = graphQLError?.extensions?.statusCode;
        return Boolean(statusCode);
    }));

});

parcelRegister("j8ZVG", function(module, exports) {

$parcel$export(module.exports, "MUTATION", () => $37c313ac561550fe$export$7473a9a03a67999e);
$parcel$export(module.exports, "useAssignToMeMutation", () => $37c313ac561550fe$export$9c4806aca0078faa);

var $5tTFS = parcelRequire("5tTFS");

var $5cllN = parcelRequire("5cllN");
const $37c313ac561550fe$export$7473a9a03a67999e = (0, $5cllN.default)`
    mutation AssignIssue($issueId: ID!, $accountId: ID) {
        assignIssue(input: { issueId: $issueId, accountId: $accountId }) {
            statusCode
            message
        }
    }
`;
const $37c313ac561550fe$export$9c4806aca0078faa = ()=>(0, $5tTFS.useMutation)($37c313ac561550fe$export$7473a9a03a67999e);

});
parcelRegister("5tTFS", function(module, exports) {

$parcel$export(module.exports, "useQuery", () => $3fdad8fd02cd9507$export$dd0a697e1782aedd);
$parcel$export(module.exports, "useLazyQuery", () => $3fdad8fd02cd9507$export$fd83eea6ecd2d8fa);
$parcel$export(module.exports, "useMutation", () => $3fdad8fd02cd9507$export$609860bf8b0084c);
$parcel$export(module.exports, "useApolloClient", () => $3fdad8fd02cd9507$export$eb9a56e7a29e494);

var $bvsgq = parcelRequire("bvsgq");

var $3VFsf = parcelRequire("3VFsf");

var $5uXOq = parcelRequire("5uXOq");

var $e3a3O = parcelRequire("e3a3O");

var $bqMzA = parcelRequire("bqMzA");

var $1DiV8 = parcelRequire("1DiV8");
var $3fdad8fd02cd9507$var$OperationData = function() {
    function OperationData(options, context) {
        this.isMounted = false;
        this.previousOptions = {};
        this.context = {};
        this.options = {};
        this.options = options || {};
        this.context = context || {};
    }
    OperationData.prototype.getOptions = function() {
        return this.options;
    };
    OperationData.prototype.setOptions = function(newOptions, storePrevious) {
        if (storePrevious === void 0) storePrevious = false;
        if (storePrevious && !(0, $bqMzA.equal)(this.options, newOptions)) this.previousOptions = this.options;
        this.options = newOptions;
    };
    OperationData.prototype.unmount = function() {
        this.isMounted = false;
    };
    OperationData.prototype.refreshClient = function() {
        var client = this.options && this.options.client || this.context && this.context.client;
        (0, $1DiV8.invariant)(!!client, 2);
        var isNew = false;
        if (client !== this.client) {
            isNew = true;
            this.client = client;
            this.cleanup();
        }
        return {
            client: this.client,
            isNew: isNew
        };
    };
    OperationData.prototype.verifyDocumentType = function(document, type) {
        var operation = (0, $bvsgq.parser)(document);
        var requiredOperationName = (0, $bvsgq.operationName)(type);
        var usedOperationName = (0, $bvsgq.operationName)(operation.type);
        (0, $1DiV8.invariant)(operation.type === type, 3);
    };
    return OperationData;
}();
var $3fdad8fd02cd9507$var$QueryData = function(_super) {
    (0, $3VFsf.__extends)(QueryData, _super);
    function QueryData(_a) {
        var options = _a.options, context = _a.context, forceUpdate = _a.forceUpdate;
        var _this = _super.call(this, options, context) || this;
        _this.previousData = {};
        _this.currentObservable = {};
        _this.runLazy = false;
        _this.runLazyQuery = function(options) {
            _this.cleanup();
            _this.runLazy = true;
            _this.lazyOptions = options;
            _this.forceUpdate();
        };
        _this.getExecuteResult = function() {
            var result = _this.getQueryResult();
            _this.startQuerySubscription();
            return result;
        };
        _this.obsRefetch = function(variables) {
            return _this.currentObservable.query.refetch(variables);
        };
        _this.obsFetchMore = function(fetchMoreOptions) {
            return _this.currentObservable.query.fetchMore(fetchMoreOptions);
        };
        _this.obsUpdateQuery = function(mapFn) {
            return _this.currentObservable.query.updateQuery(mapFn);
        };
        _this.obsStartPolling = function(pollInterval) {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.startPolling(pollInterval);
        };
        _this.obsStopPolling = function() {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.stopPolling();
        };
        _this.obsSubscribeToMore = function(options) {
            return _this.currentObservable.query.subscribeToMore(options);
        };
        _this.forceUpdate = forceUpdate;
        return _this;
    }
    QueryData.prototype.execute = function() {
        this.refreshClient();
        var _a = this.getOptions(), skip = _a.skip, query = _a.query;
        if (skip || query !== this.previousData.query) {
            this.removeQuerySubscription();
            this.previousData.query = query;
        }
        this.updateObservableQuery();
        if (this.isMounted) this.startQuerySubscription();
        return this.getExecuteSsrResult() || this.getExecuteResult();
    };
    QueryData.prototype.executeLazy = function() {
        return !this.runLazy ? [
            this.runLazyQuery,
            {
                loading: false,
                networkStatus: (0, $e3a3O.NetworkStatus).ready,
                called: false,
                data: undefined
            }
        ] : [
            this.runLazyQuery,
            this.execute()
        ];
    };
    QueryData.prototype.fetchData = function() {
        var options = this.getOptions();
        if (options.skip || options.ssr === false) return false;
        var obs = this.currentObservable.query;
        var currentResult = obs.getCurrentResult();
        return currentResult.loading ? obs.result() : false;
    };
    QueryData.prototype.afterExecute = function(_a) {
        var _this = this;
        var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
        this.isMounted = true;
        if (!lazy || this.runLazy) {
            this.handleErrorOrCompleted();
            setTimeout(function() {
                _this.currentObservable.query && _this.currentObservable.query.resetQueryStoreErrors();
            });
        }
        this.previousOptions = this.getOptions();
        return this.unmount.bind(this);
    };
    QueryData.prototype.cleanup = function() {
        this.removeQuerySubscription();
        delete this.currentObservable.query;
        delete this.previousData.result;
    };
    QueryData.prototype.getOptions = function() {
        var options = _super.prototype.getOptions.call(this);
        if (this.lazyOptions) {
            options.variables = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options.variables), this.lazyOptions.variables);
            options.context = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options.context), this.lazyOptions.context);
        }
        if (this.runLazy) delete options.skip;
        return options;
    };
    QueryData.prototype.getExecuteSsrResult = function() {
        var treeRenderingInitiated = this.context && this.context.renderPromises;
        var ssrDisabled = this.getOptions().ssr === false;
        var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
        var ssrLoading = {
            loading: true,
            networkStatus: (0, $e3a3O.NetworkStatus).loading,
            called: true,
            data: undefined
        };
        if (ssrDisabled && (treeRenderingInitiated || fetchDisabled)) return ssrLoading;
        var result;
        if (treeRenderingInitiated) result = this.context.renderPromises.addQueryPromise(this, this.getExecuteResult) || ssrLoading;
        return result;
    };
    QueryData.prototype.prepareObservableQueryOptions = function() {
        var options = this.getOptions();
        this.verifyDocumentType(options.query, (0, $bvsgq.DocumentType).Query);
        var displayName = options.displayName || 'Query';
        if (this.context && this.context.renderPromises && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options.fetchPolicy = 'cache-first';
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
            displayName: displayName,
            context: options.context,
            metadata: {
                reactComponent: {
                    displayName: displayName
                }
            }
        });
    };
    QueryData.prototype.initializeObservableQuery = function() {
        if (this.context && this.context.renderPromises) this.currentObservable.query = this.context.renderPromises.getSSRObservable(this.getOptions());
        if (!this.currentObservable.query) {
            var observableQueryOptions = this.prepareObservableQueryOptions();
            this.previousData.observableQueryOptions = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, observableQueryOptions), {
                children: null
            });
            this.currentObservable.query = this.refreshClient().client.watchQuery((0, $3VFsf.__assign)({}, observableQueryOptions));
            if (this.context && this.context.renderPromises) this.context.renderPromises.registerSSRObservable(this.currentObservable.query, observableQueryOptions);
        }
    };
    QueryData.prototype.updateObservableQuery = function() {
        if (!this.currentObservable.query) {
            this.initializeObservableQuery();
            return;
        }
        var newObservableQueryOptions = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.prepareObservableQueryOptions()), {
            children: null
        });
        if (!(0, $bqMzA.equal)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
            this.previousData.observableQueryOptions = newObservableQueryOptions;
            this.currentObservable.query.setOptions(newObservableQueryOptions).catch(function() {});
        }
    };
    QueryData.prototype.startQuerySubscription = function() {
        var _this = this;
        if (this.currentObservable.subscription || this.getOptions().skip) return;
        var obsQuery = this.currentObservable.query;
        this.currentObservable.subscription = obsQuery.subscribe({
            next: function(_a) {
                var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, $bqMzA.equal)(previousResult.data, data)) return;
                _this.forceUpdate();
            },
            error: function(error) {
                _this.resubscribeToQuery();
                if (!error.hasOwnProperty('graphQLErrors')) throw error;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading || !(0, $bqMzA.equal)(error, _this.previousData.error)) {
                    _this.previousData.error = error;
                    _this.forceUpdate();
                }
            }
        });
    };
    QueryData.prototype.resubscribeToQuery = function() {
        this.removeQuerySubscription();
        var lastError = this.currentObservable.query.getLastError();
        var lastResult = this.currentObservable.query.getLastResult();
        this.currentObservable.query.resetLastResults();
        this.startQuerySubscription();
        Object.assign(this.currentObservable.query, {
            lastError: lastError,
            lastResult: lastResult
        });
    };
    QueryData.prototype.getQueryResult = function() {
        var result = this.observableQueryFields();
        var options = this.getOptions();
        if (options.skip) result = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, result), {
            data: undefined,
            error: undefined,
            loading: false,
            called: true
        });
        else {
            var currentResult = this.currentObservable.query.getCurrentResult();
            var loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
            var error = currentResult.error, data = currentResult.data;
            if (errors && errors.length > 0) error = new (0, $e3a3O.ApolloError)({
                graphQLErrors: errors
            });
            result = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, result), {
                loading: loading,
                networkStatus: networkStatus,
                error: error,
                called: true
            });
            if (loading) {
                var previousData = this.previousData.result && this.previousData.result.data;
                result.data = previousData && data ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, previousData), data) : previousData || data;
            } else if (error) Object.assign(result, {
                data: (this.currentObservable.query.getLastResult() || {}).data
            });
            else {
                var fetchPolicy = this.currentObservable.query.options.fetchPolicy;
                var partialRefetch = options.partialRefetch;
                if (partialRefetch && !data && partial && fetchPolicy !== 'cache-only') {
                    Object.assign(result, {
                        loading: true,
                        networkStatus: (0, $e3a3O.NetworkStatus).loading
                    });
                    result.refetch();
                    return result;
                }
                result.data = data;
            }
        }
        result.client = this.client;
        this.previousData.loading = this.previousData.result && this.previousData.result.loading || false;
        this.previousData.result = result;
        return result;
    };
    QueryData.prototype.handleErrorOrCompleted = function() {
        var obsQuery = this.currentObservable.query;
        if (!obsQuery) return;
        var _a = obsQuery.getCurrentResult(), data = _a.data, loading = _a.loading, error = _a.error;
        if (!loading) {
            var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError;
            if (this.previousOptions && !this.previousData.loading && (0, $bqMzA.equal)(this.previousOptions.query, query) && (0, $bqMzA.equal)(this.previousOptions.variables, variables)) return;
            if (onCompleted && !error) onCompleted(data);
            else if (onError && error) onError(error);
        }
    };
    QueryData.prototype.removeQuerySubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    QueryData.prototype.observableQueryFields = function() {
        var observable = this.currentObservable.query;
        return {
            variables: observable.variables,
            refetch: this.obsRefetch,
            fetchMore: this.obsFetchMore,
            updateQuery: this.obsUpdateQuery,
            startPolling: this.obsStartPolling,
            stopPolling: this.obsStopPolling,
            subscribeToMore: this.obsSubscribeToMore
        };
    };
    return QueryData;
}($3fdad8fd02cd9507$var$OperationData);
function $3fdad8fd02cd9507$var$useDeepMemo(memoFn, key) {
    var ref = (0, $5uXOq.useRef)();
    if (!ref.current || !(0, $bqMzA.equal)(key, ref.current.key)) ref.current = {
        key: key,
        value: memoFn()
    };
    return ref.current.value;
}
function $3fdad8fd02cd9507$var$useBaseQuery(query, options, lazy) {
    if (lazy === void 0) lazy = false;
    var context = (0, $5uXOq.useContext)((0, $bvsgq.getApolloContext)());
    var _a = (0, $5uXOq.useReducer)(function(x) {
        return x + 1;
    }, 0), tick = _a[0], forceUpdate = _a[1];
    var updatedOptions = options ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
        query: query
    }) : {
        query: query
    };
    var queryDataRef = (0, $5uXOq.useRef)();
    if (!queryDataRef.current) queryDataRef.current = new $3fdad8fd02cd9507$var$QueryData({
        options: updatedOptions,
        context: context,
        forceUpdate: forceUpdate
    });
    var queryData = queryDataRef.current;
    queryData.setOptions(updatedOptions);
    queryData.context = context;
    var memo = {
        options: (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, updatedOptions), {
            onError: undefined,
            onCompleted: undefined
        }),
        context: context,
        tick: tick
    };
    var result = $3fdad8fd02cd9507$var$useDeepMemo(function() {
        return lazy ? queryData.executeLazy() : queryData.execute();
    }, memo);
    var queryResult = lazy ? result[1] : result;
    (0, $5uXOq.useEffect)(function() {
        return queryData.afterExecute({
            lazy: lazy
        });
    }, [
        queryResult.loading,
        queryResult.networkStatus,
        queryResult.error,
        queryResult.data
    ]);
    (0, $5uXOq.useEffect)(function() {
        return function() {
            return queryData.cleanup();
        };
    }, []);
    return result;
}
function $3fdad8fd02cd9507$export$dd0a697e1782aedd(query, options) {
    return $3fdad8fd02cd9507$var$useBaseQuery(query, options, false);
}
function $3fdad8fd02cd9507$export$fd83eea6ecd2d8fa(query, options) {
    return $3fdad8fd02cd9507$var$useBaseQuery(query, options, true);
}
var $3fdad8fd02cd9507$var$MutationData = function(_super) {
    (0, $3VFsf.__extends)(MutationData, _super);
    function MutationData(_a) {
        var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.runMutation = function(mutationFunctionOptions) {
            if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
            _this.onMutationStart();
            var mutationId = _this.generateNewMutationId();
            return _this.mutate(mutationFunctionOptions).then(function(response) {
                _this.onMutationCompleted(response, mutationId);
                return response;
            }).catch(function(error) {
                _this.onMutationError(error, mutationId);
                if (!_this.getOptions().onError) throw error;
            });
        };
        _this.verifyDocumentType(options.mutation, (0, $bvsgq.DocumentType).Mutation);
        _this.result = result;
        _this.setResult = setResult;
        _this.mostRecentMutationId = 0;
        return _this;
    }
    MutationData.prototype.execute = function(result) {
        this.isMounted = true;
        this.verifyDocumentType(this.getOptions().mutation, (0, $bvsgq.DocumentType).Mutation);
        result.client = this.refreshClient().client;
        return [
            this.runMutation,
            result
        ];
    };
    MutationData.prototype.afterExecute = function() {
        this.isMounted = true;
        return this.unmount.bind(this);
    };
    MutationData.prototype.cleanup = function() {};
    MutationData.prototype.mutate = function(mutationFunctionOptions) {
        var _a = this.getOptions(), mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, mutationContext = _b === void 0 ? {} : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, fetchPolicy = _a.fetchPolicy;
        var mutateOptions = (0, $3VFsf.__assign)({}, mutationFunctionOptions);
        var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
        delete mutateOptions.variables;
        return this.refreshClient().client.mutate((0, $3VFsf.__assign)({
            mutation: mutation,
            optimisticResponse: optimisticResponse,
            refetchQueries: mutateOptions.refetchQueries || this.getOptions().refetchQueries,
            awaitRefetchQueries: awaitRefetchQueries,
            update: update,
            context: mutationContext,
            fetchPolicy: fetchPolicy,
            variables: mutateVariables
        }, mutateOptions));
    };
    MutationData.prototype.onMutationStart = function() {
        if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
            loading: true,
            error: undefined,
            data: undefined,
            called: true
        });
    };
    MutationData.prototype.onMutationCompleted = function(response, mutationId) {
        var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
        var data = response.data, errors = response.errors;
        var error = errors && errors.length > 0 ? new (0, $e3a3O.ApolloError)({
            graphQLErrors: errors
        }) : undefined;
        var callOncomplete = function() {
            return onCompleted ? onCompleted(data) : null;
        };
        if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
            called: true,
            loading: false,
            data: data,
            error: error
        });
        callOncomplete();
    };
    MutationData.prototype.onMutationError = function(error, mutationId) {
        var onError = this.getOptions().onError;
        if (this.isMostRecentMutation(mutationId)) this.updateResult({
            loading: false,
            error: error,
            data: undefined,
            called: true
        });
        if (onError) onError(error);
    };
    MutationData.prototype.generateNewMutationId = function() {
        return ++this.mostRecentMutationId;
    };
    MutationData.prototype.isMostRecentMutation = function(mutationId) {
        return this.mostRecentMutationId === mutationId;
    };
    MutationData.prototype.updateResult = function(result) {
        if (this.isMounted && (!this.previousResult || !(0, $bqMzA.equal)(this.previousResult, result))) {
            this.setResult(result);
            this.previousResult = result;
        }
    };
    return MutationData;
}($3fdad8fd02cd9507$var$OperationData);
function $3fdad8fd02cd9507$export$609860bf8b0084c(mutation, options) {
    var context = (0, $5uXOq.useContext)((0, $bvsgq.getApolloContext)());
    var _a = (0, $5uXOq.useState)({
        called: false,
        loading: false
    }), result = _a[0], setResult = _a[1];
    var updatedOptions = options ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
        mutation: mutation
    }) : {
        mutation: mutation
    };
    var mutationDataRef = (0, $5uXOq.useRef)();
    function getMutationDataRef() {
        if (!mutationDataRef.current) mutationDataRef.current = new $3fdad8fd02cd9507$var$MutationData({
            options: updatedOptions,
            context: context,
            result: result,
            setResult: setResult
        });
        return mutationDataRef.current;
    }
    var mutationData = getMutationDataRef();
    mutationData.setOptions(updatedOptions);
    mutationData.context = context;
    (0, $5uXOq.useEffect)(function() {
        return mutationData.afterExecute();
    });
    return mutationData.execute(result);
}
var $3fdad8fd02cd9507$var$SubscriptionData = function(_super) {
    (0, $3VFsf.__extends)(SubscriptionData, _super);
    function SubscriptionData(_a) {
        var options = _a.options, context = _a.context, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.currentObservable = {};
        _this.setResult = setResult;
        _this.initialize(options);
        return _this;
    }
    SubscriptionData.prototype.execute = function(result) {
        if (this.getOptions().skip === true) {
            this.cleanup();
            return {
                loading: false,
                error: undefined,
                data: undefined,
                variables: this.getOptions().variables
            };
        }
        var currentResult = result;
        if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
        var shouldResubscribe = this.getOptions().shouldResubscribe;
        if (typeof shouldResubscribe === 'function') shouldResubscribe = !!shouldResubscribe(this.getOptions());
        if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, $bqMzA.equal)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
            this.cleanup();
            currentResult = this.getLoadingResult();
        }
        this.initialize(this.getOptions());
        this.startSubscription();
        this.previousOptions = this.getOptions();
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, currentResult), {
            variables: this.getOptions().variables
        });
    };
    SubscriptionData.prototype.afterExecute = function() {
        this.isMounted = true;
    };
    SubscriptionData.prototype.cleanup = function() {
        this.endSubscription();
        delete this.currentObservable.query;
    };
    SubscriptionData.prototype.initialize = function(options) {
        if (this.currentObservable.query || this.getOptions().skip === true) return;
        this.currentObservable.query = this.refreshClient().client.subscribe({
            query: options.subscription,
            variables: options.variables,
            fetchPolicy: options.fetchPolicy
        });
    };
    SubscriptionData.prototype.startSubscription = function() {
        if (this.currentObservable.subscription) return;
        this.currentObservable.subscription = this.currentObservable.query.subscribe({
            next: this.updateCurrentData.bind(this),
            error: this.updateError.bind(this),
            complete: this.completeSubscription.bind(this)
        });
    };
    SubscriptionData.prototype.getLoadingResult = function() {
        return {
            loading: true,
            error: undefined,
            data: undefined
        };
    };
    SubscriptionData.prototype.updateResult = function(result) {
        if (this.isMounted) this.setResult(result);
    };
    SubscriptionData.prototype.updateCurrentData = function(result) {
        var onSubscriptionData = this.getOptions().onSubscriptionData;
        this.updateResult({
            data: result.data,
            loading: false,
            error: undefined
        });
        if (onSubscriptionData) onSubscriptionData({
            client: this.refreshClient().client,
            subscriptionData: result
        });
    };
    SubscriptionData.prototype.updateError = function(error) {
        this.updateResult({
            error: error,
            loading: false
        });
    };
    SubscriptionData.prototype.completeSubscription = function() {
        var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
        if (onSubscriptionComplete) onSubscriptionComplete();
        this.endSubscription();
    };
    SubscriptionData.prototype.endSubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    return SubscriptionData;
}($3fdad8fd02cd9507$var$OperationData);
function $3fdad8fd02cd9507$export$368b4214baeb914c(subscription, options) {
    var context = (0, $5uXOq.useContext)((0, $bvsgq.getApolloContext)());
    var updatedOptions = options ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
        subscription: subscription
    }) : {
        subscription: subscription
    };
    var _a = (0, $5uXOq.useState)({
        loading: !updatedOptions.skip,
        error: undefined,
        data: undefined
    }), result = _a[0], setResult = _a[1];
    var subscriptionDataRef = (0, $5uXOq.useRef)();
    function getSubscriptionDataRef() {
        if (!subscriptionDataRef.current) subscriptionDataRef.current = new $3fdad8fd02cd9507$var$SubscriptionData({
            options: updatedOptions,
            context: context,
            setResult: setResult
        });
        return subscriptionDataRef.current;
    }
    var subscriptionData = getSubscriptionDataRef();
    subscriptionData.setOptions(updatedOptions, true);
    subscriptionData.context = context;
    (0, $5uXOq.useEffect)(function() {
        return subscriptionData.afterExecute();
    });
    (0, $5uXOq.useEffect)(function() {
        return subscriptionData.cleanup.bind(subscriptionData);
    }, []);
    return subscriptionData.execute(result);
}
function $3fdad8fd02cd9507$export$eb9a56e7a29e494() {
    var client = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext((0, $bvsgq.getApolloContext)()).client;
    (0, $1DiV8.invariant)(client, 1);
    return client;
}
function $3fdad8fd02cd9507$var$makeDefaultQueryInfo() {
    return {
        seen: false,
        observable: null
    };
}
var $3fdad8fd02cd9507$export$260e90e395a79974 = function() {
    function RenderPromises() {
        this.queryPromises = new Map();
        this.queryInfoTrie = new Map();
    }
    RenderPromises.prototype.registerSSRObservable = function(observable, props) {
        this.lookupQueryInfo(props).observable = observable;
    };
    RenderPromises.prototype.getSSRObservable = function(props) {
        return this.lookupQueryInfo(props).observable;
    };
    RenderPromises.prototype.addQueryPromise = function(queryInstance, finish) {
        var info = this.lookupQueryInfo(queryInstance.getOptions());
        if (!info.seen) {
            this.queryPromises.set(queryInstance.getOptions(), new Promise(function(resolve) {
                resolve(queryInstance.fetchData());
            }));
            return null;
        }
        return finish();
    };
    RenderPromises.prototype.hasPromises = function() {
        return this.queryPromises.size > 0;
    };
    RenderPromises.prototype.consumeAndAwaitPromises = function() {
        var _this = this;
        var promises = [];
        this.queryPromises.forEach(function(promise, queryInstance) {
            _this.lookupQueryInfo(queryInstance).seen = true;
            promises.push(promise);
        });
        this.queryPromises.clear();
        return Promise.all(promises);
    };
    RenderPromises.prototype.lookupQueryInfo = function(props) {
        var queryInfoTrie = this.queryInfoTrie;
        var query = props.query, variables = props.variables;
        var varMap = queryInfoTrie.get(query) || new Map();
        if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
        var variablesString = JSON.stringify(variables);
        var info = varMap.get(variablesString) || $3fdad8fd02cd9507$var$makeDefaultQueryInfo();
        if (!varMap.has(variablesString)) varMap.set(variablesString, info);
        return info;
    };
    return RenderPromises;
}();

});



parcelRegister("4G04L", function(module, exports) {

$parcel$export(module.exports, "scheduleAfterRender", () => $2060ab97dc501826$export$a845aafd0a0e29e6);

var $gg6CF = parcelRequire("gg6CF");

var $6cAn5 = parcelRequire("6cAn5");
const $2060ab97dc501826$export$a845aafd0a0e29e6 = (callback)=>{
    if ($gg6CF && $gg6CF.unstable_scheduleCallback) // Wait a tick for renders that will still be scheduled on this event-loop tick.
    $6cAn5.nextTick(()=>{
        try {
            // Schedule an idle priority callback with react's scheduler.
            $gg6CF.unstable_scheduleCallback($gg6CF.unstable_IdlePriority, ()=>{
                callback();
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            // React.js' lower priority is at minimum 0ms or a postMessage tick.
            // Waiting 1ms seems to be a good enough approximation to run after that.
            setTimeout(()=>{
                callback();
            }, 1);
        }
    });
    else setTimeout(()=>{
        callback();
    }, 1);
};

});

parcelRegister("8hVbJ", function(module, exports) {

$parcel$export(module.exports, "PAGE_LOAD_MARK_CONSTRUCTOR_START", () => $1f56309c299aaf11$export$c4552a2c37c43ea9);
$parcel$export(module.exports, "PAGE_LOAD_MARK_CONSTRUCTOR_END", () => $1f56309c299aaf11$export$6aa9fcaba5907700);
$parcel$export(module.exports, "PAGE_LOAD_MARK_REDUX_START", () => $1f56309c299aaf11$export$57eb941eb8f235ee);
$parcel$export(module.exports, "PAGE_LOAD_MARK_REDUX_END", () => $1f56309c299aaf11$export$7f8583ae22e5705f);
$parcel$export(module.exports, "PAGE_LOAD_MARK_TRANSFORM_CRITICAL_START", () => $1f56309c299aaf11$export$765cd8e38999963b);
$parcel$export(module.exports, "PAGE_LOAD_MARK_TRANSFORM_CRITICAL_END", () => $1f56309c299aaf11$export$f7e5395ee7a2ecfb);
$parcel$export(module.exports, "PAGE_LOAD_MARK_RENDER_START", () => $1f56309c299aaf11$export$a4eb0ce95caacc19);
$parcel$export(module.exports, "PAGE_LOAD_MARK_RENDER_END", () => $1f56309c299aaf11$export$a4a935943fc371c5);
$parcel$export(module.exports, "CRITICAL_RELAY_RESOURCE_GET_DATA_START", () => $1f56309c299aaf11$export$f987279f084c1947);
$parcel$export(module.exports, "CRITICAL_RELAY_RESOURCE_GET_DATA_END", () => $1f56309c299aaf11$export$86d7d16316a4fd86);
$parcel$export(module.exports, "PAGE_LOAD_MARK_TRANSFORM_CRITICAL_REST_START", () => $1f56309c299aaf11$export$9437b7e8f9f46514);
$parcel$export(module.exports, "PAGE_LOAD_MARK_TRANSFORM_CRITICAL_REST_END", () => $1f56309c299aaf11$export$6377757b944905f8);
$parcel$export(module.exports, "USE_RESOURCE_START", () => $1f56309c299aaf11$export$226c1bb9e4c0f2ee);
$parcel$export(module.exports, "USE_RESOURCE_READY", () => $1f56309c299aaf11$export$1037ea278e95f493);
$parcel$export(module.exports, "RENDER_START", () => $1f56309c299aaf11$export$672257010af09af1);
$parcel$export(module.exports, "RENDER_END", () => $1f56309c299aaf11$export$b4f76538e9c39ff7);
$parcel$export(module.exports, "JSW_CRITICAL_RESOURCE_START", () => $1f56309c299aaf11$export$c637a04c5a8cc32c);
$parcel$export(module.exports, "JSW_CRITICAL_RESOURCE_END", () => $1f56309c299aaf11$export$cbf503ef2abe660d);
$parcel$export(module.exports, "nextGenBacklogPageLoad", () => $1f56309c299aaf11$export$412da6c620d3c22f);
$parcel$export(module.exports, "uifBacklogNewUiPageLoad", () => $1f56309c299aaf11$export$dafd90f37e91dd7d);
$parcel$export(module.exports, "issueViewOpenInteraction", () => $1f56309c299aaf11$export$412ac2e825a54154);
$parcel$export(module.exports, "issueRankInteraction", () => $1f56309c299aaf11$export$b49f1606cfd9ead4);
$parcel$export(module.exports, "filterInteraction", () => $1f56309c299aaf11$export$8decf314e9f3b4a0);
$parcel$export(module.exports, "issueCreateInteraction", () => $1f56309c299aaf11$export$be312698838f27be);
$parcel$export(module.exports, "issueDeleteInteraction", () => $1f56309c299aaf11$export$1b8cf3f3c2894329);
$parcel$export(module.exports, "flagToggleInteraction", () => $1f56309c299aaf11$export$6c532396e24c45e7);
$parcel$export(module.exports, "assignToMeInteraction", () => $1f56309c299aaf11$export$79f93553011c8d54);
$parcel$export(module.exports, "cardListToggleInteraction", () => $1f56309c299aaf11$export$570f89c911f782e4);
$parcel$export(module.exports, "createSprintInteraction", () => $1f56309c299aaf11$export$208bdc4a71e10bff);
$parcel$export(module.exports, "deleteSprintInteraction", () => $1f56309c299aaf11$export$b4f79447cf23e1d8);
$parcel$export(module.exports, "moveSprintInteraction", () => $1f56309c299aaf11$export$6dc2d6f22f8f27e1);
$parcel$export(module.exports, "startSprintModalLoad", () => $1f56309c299aaf11$export$b582949e90c55414);
$parcel$export(module.exports, "completeSprintModalLoad", () => $1f56309c299aaf11$export$281157708c6b132a);
$parcel$export(module.exports, "customFilterInteraction", () => $1f56309c299aaf11$export$ae56111e009a2b76);
$parcel$export(module.exports, "clearCustomFilterInteraction", () => $1f56309c299aaf11$export$776b3d2eaed43448);
$parcel$export(module.exports, "versionsPanelLoad", () => $1f56309c299aaf11$export$b2b67b41751ce72b);
$parcel$export(module.exports, "inlineEditStatusInteraction", () => $1f56309c299aaf11$export$7e4ecb299cc27d61);
$parcel$export(module.exports, "inlineEditAssigneeInteraction", () => $1f56309c299aaf11$export$2acaf09c8ee524bb);
$parcel$export(module.exports, "inlineEditStoryPointInteraction", () => $1f56309c299aaf11$export$98f90b59da066325);
$parcel$export(module.exports, "inlineEditOriginalEstimateInteraction", () => $1f56309c299aaf11$export$d01dddd30d43031c);

var $dGrdR = parcelRequire("dGrdR");

const $1f56309c299aaf11$export$c4552a2c37c43ea9 = 'CONSTRUCTOR_START';
const $1f56309c299aaf11$export$6aa9fcaba5907700 = 'CONSTRUCTOR_END';
const $1f56309c299aaf11$export$57eb941eb8f235ee = 'REDUX_START';
const $1f56309c299aaf11$export$7f8583ae22e5705f = 'REDUX_END';
const $1f56309c299aaf11$export$765cd8e38999963b = 'TRANSFORM_CRITICAL_START';
const $1f56309c299aaf11$export$f7e5395ee7a2ecfb = 'TRANSFORM_CRITICAL_END';
const $1f56309c299aaf11$export$a4eb0ce95caacc19 = 'RENDER_START';
const $1f56309c299aaf11$export$a4a935943fc371c5 = 'RENDER_END';
const $1f56309c299aaf11$export$f987279f084c1947 = 'relay_resource_get_data:NEXTGEN_BACKLOG_RELAY:start';
const $1f56309c299aaf11$export$86d7d16316a4fd86 = 'relay_resource_get_data:NEXTGEN_BACKLOG_RELAY:end';
const $1f56309c299aaf11$export$9437b7e8f9f46514 = 'TRANSFORM_CRITICAL_REST_START';
const $1f56309c299aaf11$export$6377757b944905f8 = 'TRANSFORM_CRITICAL_REST_END';
const $1f56309c299aaf11$export$226c1bb9e4c0f2ee = 'USE_RESOURCE_START';
const $1f56309c299aaf11$export$1037ea278e95f493 = 'USE_RESOURCE_READY';
const $1f56309c299aaf11$export$672257010af09af1 = 'RENDER_START_FRAME';
const $1f56309c299aaf11$export$b4f76538e9c39ff7 = 'RENDER_END_FRAME';
const $1f56309c299aaf11$export$c637a04c5a8cc32c = 'JSW_CRITICAL_RESOURCE_START';
const $1f56309c299aaf11$export$cbf503ef2abe660d = 'JSW_CRITICAL_RESOURCE_END';
const $1f56309c299aaf11$export$6516506c3fb10def = 'EARLY_FETCH_START';
const $1f56309c299aaf11$export$8d6886d639f5aab0 = 'EARLY_FETCH_END';
const $1f56309c299aaf11$var$NEXT_GEN_BACKLOG = 'next-gen-backlog';
const $1f56309c299aaf11$var$UIF_BACKLOG_NEW_UI = 'classic-backlog';
const $1f56309c299aaf11$var$backlogPageLoad = (key)=>(0, $dGrdR.metrics).pageLoad({
        key: key,
        featureFlags: [],
        ssr: {
            doneAsFmp: true
        },
        slo: {
            fmp: {
                initial: {
                    threshold: 1000
                },
                transition: {
                    threshold: 1000
                }
            },
            tti: {
                initial: {
                    threshold: 14000
                },
                transition: {
                    threshold: 14000
                }
            }
        },
        timings: [
            {
                key: 'product/page-constructor',
                startMark: $1f56309c299aaf11$export$c4552a2c37c43ea9,
                endMark: $1f56309c299aaf11$export$6aa9fcaba5907700
            },
            {
                key: 'product/page-constructor/redux-setup',
                startMark: $1f56309c299aaf11$export$57eb941eb8f235ee,
                endMark: $1f56309c299aaf11$export$7f8583ae22e5705f
            },
            {
                key: 'product/page-constructor/redux-setup/transform-critical-data',
                startMark: $1f56309c299aaf11$export$765cd8e38999963b,
                endMark: $1f56309c299aaf11$export$f7e5395ee7a2ecfb
            },
            {
                key: 'product/page-constructor/redux-setup/transform-critical-rest-data',
                startMark: $1f56309c299aaf11$export$9437b7e8f9f46514,
                endMark: $1f56309c299aaf11$export$6377757b944905f8
            },
            {
                key: 'product/render',
                startMark: $1f56309c299aaf11$export$a4eb0ce95caacc19,
                endMark: $1f56309c299aaf11$export$a4a935943fc371c5
            },
            {
                key: 'fixed-render',
                startMark: $1f56309c299aaf11$export$672257010af09af1,
                endMark: $1f56309c299aaf11$export$b4f76538e9c39ff7
            },
            {
                key: 'use-resource-call',
                startMark: $1f56309c299aaf11$export$226c1bb9e4c0f2ee,
                endMark: $1f56309c299aaf11$export$1037ea278e95f493
            },
            {
                key: 'critical-resource-get-data',
                startMark: $1f56309c299aaf11$export$f987279f084c1947,
                endMark: $1f56309c299aaf11$export$86d7d16316a4fd86
            },
            {
                key: 'critical-resource',
                startMark: $1f56309c299aaf11$export$c637a04c5a8cc32c,
                endMark: $1f56309c299aaf11$export$cbf503ef2abe660d
            },
            {
                key: 'early-fetch',
                startMark: $1f56309c299aaf11$export$6516506c3fb10def,
                endMark: $1f56309c299aaf11$export$8d6886d639f5aab0
            },
            {
                key: (0, $ce556f125dee8174$export$48552baa9db8ce1d),
                endMark: (0, $ce556f125dee8174$export$99c08ec92759c71c)
            }
        ]
    });
const $1f56309c299aaf11$export$412da6c620d3c22f = $1f56309c299aaf11$var$backlogPageLoad($1f56309c299aaf11$var$NEXT_GEN_BACKLOG);
const $1f56309c299aaf11$export$dafd90f37e91dd7d = $1f56309c299aaf11$var$backlogPageLoad($1f56309c299aaf11$var$UIF_BACKLOG_NEW_UI);
const $1f56309c299aaf11$export$412ac2e825a54154 = (0, $dGrdR.metrics).interaction({
    key: 'backlog.issue-view-open',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '1000_2000_3000_4000_5000_6000'
    },
    timings: [
        {
            key: 'feedbackPreMount',
            endMark: 'feedbackPreMountEnd'
        }
    ]
});
const $1f56309c299aaf11$export$b49f1606cfd9ead4 = (0, $dGrdR.metrics).interaction({
    key: 'backlog.issue-rank',
    histogram: {
        result: '1000_2000_3000_4000_5000_6000',
        response: '100_200_500_1000_1500'
    }
});
const $1f56309c299aaf11$export$8decf314e9f3b4a0 = (0, $dGrdR.metrics).interaction({
    key: 'backlog.filter',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '100_200_500_1000_1200_1500'
    }
});
const $1f56309c299aaf11$export$2562fe4b040b7db0 = (0, $dGrdR.metrics).interaction({
    key: 'backlogCardRenderHoverState',
    histogram: {
        result: '100_200_300_500_700_1000_1250_1500_1750_2000_2500_3000',
        response: ''
    },
    timings: [
        {
            key: 'backlogCardHover',
            endMark: 'backlogCardHoverRendered'
        }
    ]
});
const $1f56309c299aaf11$export$f735dcf907082d42 = (0, $dGrdR.metrics).interaction({
    key: 'backlogCardMouseLeaveTiming',
    histogram: {
        result: '100_200_300_500_700_1000_1250_1500_1750_2000_2500_3000',
        response: ''
    },
    timings: [
        {
            key: 'backlogCardMouseLeaveTiming',
            endMark: 'backlogCardMouseLeaveTimingEnd'
        }
    ]
});
const $1f56309c299aaf11$export$753f9e06af8cfa2e = (0, $dGrdR.metrics).interaction({
    key: 'backlogCardDragDropTargetTiming',
    histogram: {
        result: '100_200_300_500_700_1000_1250_1500_1750_2000_2500_3000',
        response: ''
    },
    timings: [
        {
            key: 'backlogCardDragDropTargetTiming',
            endMark: 'backlogCardDragDropTargetRendered'
        }
    ]
});
const $1f56309c299aaf11$export$be312698838f27be = (0, $dGrdR.metrics).concurrent.interaction({
    key: 'backlog.issue-create',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '1000_2000_3000_4000_5000'
    }
});
const $1f56309c299aaf11$export$1b8cf3f3c2894329 = (0, $dGrdR.metrics).concurrent.interaction({
    key: 'backlog.issue-delete'
});
const $1f56309c299aaf11$export$6c532396e24c45e7 = (0, $dGrdR.metrics).concurrent.interaction({
    key: 'backlog.flag-toggle',
    histogram: {
        result: '1000_2000_3000_4000_5000_6000',
        response: '50_100_150_200_300_500'
    }
});
const $1f56309c299aaf11$export$79f93553011c8d54 = (0, $dGrdR.metrics).concurrent.interaction({
    key: 'backlog.assign-to-me',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.result]' is missing in type '{ response: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        response: '50_100_150_200_300_400_500'
    }
});
const $1f56309c299aaf11$export$570f89c911f782e4 = (0, $dGrdR.metrics).interaction({
    key: 'backlog.card-list-toggle'
});
const $1f56309c299aaf11$export$208bdc4a71e10bff = (0, $dGrdR.metrics).concurrent.interaction({
    key: 'backlog.sprint-create'
});
const $1f56309c299aaf11$export$b4f79447cf23e1d8 = (0, $dGrdR.metrics).concurrent.interaction({
    key: 'backlog.sprint-delete',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '500_1000_1500_2000_2500_3000_3500_4000'
    }
});
const $1f56309c299aaf11$export$6dc2d6f22f8f27e1 = (0, $dGrdR.metrics).interaction({
    key: 'backlog.sprint-move',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '500_1000_1500_2000_2500_3000'
    }
});
const $1f56309c299aaf11$export$b582949e90c55414 = (0, $dGrdR.metrics).interaction({
    key: 'start-sprint-modal-load'
});
const $1f56309c299aaf11$export$281157708c6b132a = (0, $dGrdR.metrics).interaction({
    key: 'complete-sprint-modal-load'
});
const $1f56309c299aaf11$export$ae56111e009a2b76 = (0, $dGrdR.metrics).interaction({
    key: 'backlog.custom-filter',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '500_1000_1500_2000_2500_3000_3500_4000'
    }
});
const $1f56309c299aaf11$export$776b3d2eaed43448 = (0, $dGrdR.metrics).interaction({
    key: 'backlog.clear-custom-filter'
});
const $1f56309c299aaf11$export$b2b67b41751ce72b = (0, $dGrdR.metrics).interaction({
    key: 'backlog.versions-panel-load'
});
const $1f56309c299aaf11$export$7e4ecb299cc27d61 = (0, $dGrdR.metrics).interaction({
    key: 'backlog.inline-issue-field-status'
});
const $1f56309c299aaf11$export$2acaf09c8ee524bb = (0, $dGrdR.metrics).interaction({
    key: 'backlog.inline-issue-field-assignee'
});
const $1f56309c299aaf11$export$98f90b59da066325 = (0, $dGrdR.metrics).interaction({
    key: 'backlog.inline-issue-field-story-point'
});
const $1f56309c299aaf11$export$d01dddd30d43031c = (0, $dGrdR.metrics).interaction({
    key: 'backlog.inline-issue-field-original-estimate'
});

});
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("g4P00", function(module, exports) {

$parcel$export(module.exports, "ASSIGN_TO_ME_REQUEST", () => $2d9ad77c206dcf96$export$4a7b4d6811230566);
$parcel$export(module.exports, "assignToMeRequest", () => $2d9ad77c206dcf96$export$e2776354d9221c82);
$parcel$export(module.exports, "ASSIGN_TO_ME_REQUEST_THROTTLED", () => $2d9ad77c206dcf96$export$f241ab4d2fe8b61e);
$parcel$export(module.exports, "assignToMeRequestThrottled", () => $2d9ad77c206dcf96$export$13bfccdb4d681951);
$parcel$export(module.exports, "assignToMeSuccess", () => $2d9ad77c206dcf96$export$caabee9a075ba7f1);
$parcel$export(module.exports, "assignToMeFailure", () => $2d9ad77c206dcf96$export$50fd16f97611da56);

var $c0irb = parcelRequire("c0irb");
const $2d9ad77c206dcf96$export$4a7b4d6811230566 = 'state.actions.cards.assign-to-me.ASSIGN_TO_ME_REQUEST';
const $2d9ad77c206dcf96$export$e2776354d9221c82 = ({ cardId: cardId, assignee: assignee, concurrentId: concurrentId, fireShortcutAnalyticsFn: fireShortcutAnalyticsFn })=>({
        type: $2d9ad77c206dcf96$export$4a7b4d6811230566,
        payload: {
            cardId: cardId,
            assignee: assignee,
            concurrentId: concurrentId,
            fireShortcutAnalyticsFn: fireShortcutAnalyticsFn
        },
        meta: (0, $c0irb.beginOptimisticUiMeta)()
    });
const $2d9ad77c206dcf96$export$f241ab4d2fe8b61e = 'state.actions.cards.assign-to-me.ASSIGN_TO_ME_REQUEST_THROTTLED';
const $2d9ad77c206dcf96$export$13bfccdb4d681951 = (cardId, assignee, fireShortcutAnalyticsFn)=>({
        type: $2d9ad77c206dcf96$export$f241ab4d2fe8b61e,
        payload: {
            cardId: cardId,
            assignee: assignee,
            fireShortcutAnalyticsFn: fireShortcutAnalyticsFn
        }
    });
const $2d9ad77c206dcf96$export$1249a100986a9489 = 'state.actions.cards.assign-to-me.ASSIGN_TO_ME_SUCCESS';
const $2d9ad77c206dcf96$export$caabee9a075ba7f1 = (optimisticId, concurrentId)=>({
        type: $2d9ad77c206dcf96$export$1249a100986a9489,
        payload: {
            concurrentId: concurrentId
        },
        meta: (0, $c0irb.commitOptimisticUiMeta)(optimisticId)
    });
const $2d9ad77c206dcf96$export$1ce003be5a9445ee = 'state.actions.cards.assign-to-me.ASSIGN_TO_ME_FAILURE';
const $2d9ad77c206dcf96$export$50fd16f97611da56 = (optimisticId, concurrentId)=>({
        type: $2d9ad77c206dcf96$export$1ce003be5a9445ee,
        payload: {
            concurrentId: concurrentId
        },
        meta: (0, $c0irb.revertOptimisticUiMeta)(optimisticId)
    });

});


parcelRegister("gqn54", function(module, exports) {

$parcel$export(module.exports, "cardAutoScrollOnFilterEpic", () => $b70d4603454af212$export$1eee00ad491917f1);
parcelRequire("zjDln");
parcelRequire("6hSeW");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $9Z18E = parcelRequire("9Z18E");

var $dGljH = parcelRequire("dGljH");
const $b70d4603454af212$export$1eee00ad491917f1 = (action$, store)=>action$.ofType((0, $9Z18E.CARD_AUTO_SCROLL_REQUEST_ON_FILTER)).mergeMap(()=>{
        const state = store.getState();
        const selectedIssueId = (0, $dGljH.getLastSelectedCard)(state);
        return selectedIssueId ? (0, $kVLXA.Observable).of((0, $9Z18E.cardAutoScroll)(selectedIssueId)) : (0, $kVLXA.Observable).empty();
    });

});
parcelRegister("9Z18E", function(module, exports) {

$parcel$export(module.exports, "CARD_AUTO_SCROLL", () => $ce845b910b9935bd$export$21e828c0e9d1105a);
$parcel$export(module.exports, "cardAutoScroll", () => $ce845b910b9935bd$export$274e46dc8e4633e0);
$parcel$export(module.exports, "CARD_AUTO_SCROLL_REQUEST_ON_FILTER", () => $ce845b910b9935bd$export$3a965e6001d5e2e9);
$parcel$export(module.exports, "cardAutoScrollRequestOnFilter", () => $ce845b910b9935bd$export$58d9ced87e626159);
const $ce845b910b9935bd$export$21e828c0e9d1105a = 'state.actions.card.CARD_AUTO_SCROLL';
const $ce845b910b9935bd$export$274e46dc8e4633e0 = (cardId)=>({
        type: $ce845b910b9935bd$export$21e828c0e9d1105a,
        payload: {
            cardId: cardId
        }
    });
const $ce845b910b9935bd$export$3a965e6001d5e2e9 = 'state.actions.card.CARD_AUTO_SCROLL_REQUEST_ON_FILTER';
const $ce845b910b9935bd$export$58d9ced87e626159 = ()=>({
        type: $ce845b910b9935bd$export$3a965e6001d5e2e9
    });

});


parcelRegister("eKj5K", function(module, exports) {

$parcel$export(module.exports, "cardClickEpic", () => $e232d0c2125d72fa$export$d1fdf7f3fe665b5b);
parcelRequire("zjDln");
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $f6RVN = parcelRequire("f6RVN");


var $7SF9g = parcelRequire("7SF9g");

var $cik5h = parcelRequire("cik5h");

var $8SI0F = parcelRequire("8SI0F");

var $4mqko = parcelRequire("4mqko");

var $38qhf = parcelRequire("38qhf");

var $9g0YE = parcelRequire("9g0YE");

var $dGljH = parcelRequire("dGljH");
const $e232d0c2125d72fa$var$getCardIdsToListSelection = (state, relativeCardId, clickedCardId)=>{
    const relativeCardListId = (0, $dGljH.makeGetCardListIdByCardId)(state)(relativeCardId);
    const clickedCardListId = (0, $dGljH.makeGetCardListIdByCardId)(state)(clickedCardId);
    if (!relativeCardListId || !clickedCardListId) return [];
    // selecting from the same card list
    if (relativeCardListId === clickedCardListId) {
        const cards = (0, $dGljH.makeOrderedVisibleCardIdsForCardList)(state)(relativeCardListId);
        const relativeCardIndex = cards.indexOf(relativeCardId);
        const clickedCardIndex = cards.indexOf(clickedCardId);
        const cardInBetween = clickedCardIndex > relativeCardIndex ? cards.slice(relativeCardIndex, clickedCardIndex + 1) : cards.slice(clickedCardIndex, relativeCardIndex + 1).reverse();
        return cardInBetween;
    }
    // selecting from across card lists
    const orderedCardListIds = (0, $dGljH.getOrderedCardListIds)(state);
    const relativeCardListIndex = orderedCardListIds.indexOf(relativeCardListId);
    const clickedCardListIndex = orderedCardListIds.indexOf(clickedCardListId);
    const isSelectingCardListBelow = clickedCardListIndex > relativeCardListIndex;
    // getting all cards in card lists that are in between the relative and clicked cards
    const cardListsInBetween = orderedCardListIds.filter((_, index)=>{
        if (isSelectingCardListBelow) return index > relativeCardListIndex && index < clickedCardListIndex;
        return index > clickedCardListIndex && index < relativeCardListIndex;
    });
    const cardsInBetweenCardList = cardListsInBetween.reduce((result, key)=>result.concat((0, $dGljH.makeOrderedVisibleCardIdsForCardList)(state)(key)), []);
    const orderedCardsInBetweenCardLists = isSelectingCardListBelow ? cardsInBetweenCardList : cardsInBetweenCardList.reverse();
    // getting cards from where the relative card is based on the card order
    const relativeCardListCards = (0, $dGljH.makeOrderedVisibleCardIdsForCardList)(state)(relativeCardListId);
    const cardsToAddInRelativeCardList = isSelectingCardListBelow ? relativeCardListCards.slice(relativeCardListCards.indexOf(relativeCardId), relativeCardListCards.length) : relativeCardListCards.slice(0, relativeCardListCards.indexOf(relativeCardId) + 1).reverse();
    // getting cards from where the clicked card is based on the card order
    const clickedCardListCards = (0, $dGljH.makeOrderedVisibleCardIdsForCardList)(state)(clickedCardListId);
    const cardsToAddInClickedCardList = isSelectingCardListBelow ? clickedCardListCards.slice(0, clickedCardListCards.indexOf(clickedCardId) + 1) : clickedCardListCards.slice(clickedCardListCards.indexOf(clickedCardId), clickedCardListCards.length).reverse();
    return [
        ...cardsToAddInRelativeCardList,
        ...orderedCardsInBetweenCardLists,
        ...cardsToAddInClickedCardList
    ];
};
const $e232d0c2125d72fa$var$getLocationAfterCloseInsights = (location)=>(0, $7SF9g.setPanelsUrl)((0, $4f4a02cead13bb5a$export$61119f100c357d06), false, location);
const $e232d0c2125d72fa$export$d1fdf7f3fe665b5b = (getLocation, push)=>(action$, store)=>action$.ofType((0, $4mqko.CARD_CLICK)).mergeMap((action)=>{
            const state = store.getState();
            const { cardId: cardId, withCmd: withCmd, withShift: withShift } = action.payload;
            const selectedCardIds = (0, $dGljH.getSelectedCards)(state);
            const focusedCard = (0, $dGljH.getFocusedCard)(state);
            const getCardKeyFromCardId = (0, $dGljH.makeCardKeyFromCardId)(state);
            if (!withShift && !withCmd && action.payload.externalAction) {
                const actions = [
                    (0, $4mqko.cardSingleSelect)(cardId)
                ];
                actions.push((0, $9g0YE.closeInsightsPanel)(false));
                (0, $f6RVN.isViewSettingAsPanelExpEnabledWithNoExposure)() && actions.push((0, $9g0YE.closeViewSettingsPanel)());
                actions.push((0, $8SI0F.setCheckboxSelectionMode)(!!action.payload.withCheckbox));
                push((0, $cik5h.addSelectedIssueToUrl)(getCardKeyFromCardId(cardId), $e232d0c2125d72fa$var$getLocationAfterCloseInsights(getLocation())));
                actions.push((0, $38qhf.openDetailView)(cardId, action.payload.externalAction));
                action.payload.fireSelectionAnalytics?.({
                    numSelectedCards: 1,
                    issue_ids: [
                        cardId
                    ]
                });
                return (0, $kVLXA.Observable).from(actions);
            }
            if (!withShift && !withCmd) {
                const actions = [
                    (0, $4mqko.cardSingleSelect)(cardId),
                    (0, $38qhf.openDetailView)(cardId)
                ];
                actions.push((0, $9g0YE.closeInsightsPanel)(false));
                (0, $f6RVN.isViewSettingAsPanelExpEnabledWithNoExposure)() && actions.push((0, $9g0YE.closeViewSettingsPanel)());
                actions.push((0, $8SI0F.setCheckboxSelectionMode)(!!action.payload.withCheckbox));
                push((0, $cik5h.addSelectedIssueToUrl)(getCardKeyFromCardId(cardId), $e232d0c2125d72fa$var$getLocationAfterCloseInsights(getLocation())));
                action.payload.fireSelectionAnalytics?.({
                    numSelectedCards: 1,
                    issue_ids: [
                        cardId
                    ]
                });
                return (0, $kVLXA.Observable).from(actions);
            }
            if (withShift && withCmd) {
                const relativeCardId = (0, $dGljH.getListSelectionRelativeCard)(state);
                if (!relativeCardId) return (0, $kVLXA.Observable).empty();
                const cardsToBeSelected = $e232d0c2125d72fa$var$getCardIdsToListSelection(state, relativeCardId, cardId);
                const relativeCardIndex = selectedCardIds.indexOf(relativeCardId);
                const newSelectionList = selectedCardIds.slice(0, relativeCardIndex === -1 ? selectedCardIds.length : relativeCardIndex) // clean last shift+cmd list selection
                .filter((cardIdInSelectedList)=>!cardsToBeSelected.includes(cardIdInSelectedList)) // unique list
                .concat(cardsToBeSelected);
                const actions = [
                    (0, $4mqko.cardMultiSelect)(newSelectionList)
                ];
                action.payload.fireSelectionAnalytics?.({
                    numSelectedCards: newSelectionList.length,
                    issue_ids: newSelectionList
                });
                actions.push((0, $8SI0F.setCheckboxSelectionMode)(true));
                return (0, $kVLXA.Observable).from(actions);
            }
            if (withShift) {
                const relativeCardId = (0, $dGljH.getListSelectionRelativeCard)(state);
                if (!relativeCardId) return (0, $kVLXA.Observable).empty();
                const cardsToBeSelected = $e232d0c2125d72fa$var$getCardIdsToListSelection(state, relativeCardId, cardId).reverse();
                const actions = [
                    (0, $4mqko.cardMultiSelect)(cardsToBeSelected)
                ];
                action.payload.fireSelectionAnalytics?.({
                    numSelectedCards: cardsToBeSelected.length,
                    issue_ids: cardsToBeSelected
                });
                focusedCard !== relativeCardId && actions.push((0, $8SI0F.setCheckboxSelectionMode)(true));
                return (0, $kVLXA.Observable).from(actions);
            }
            if (withCmd) {
                const actions = [];
                if (selectedCardIds.length === 1 && cardId === selectedCardIds[0]) {
                    actions.push((0, $4mqko.cardEmptySelection)(), (0, $38qhf.closeDetailView)());
                    actions.push((0, $8SI0F.setCheckboxSelectionMode)(false));
                } else {
                    actions.push((0, $4mqko.cardToggleSelection)(cardId));
                    actions.push((0, $8SI0F.setCheckboxSelectionMode)(true));
                }
                action.payload.fireSelectionAnalytics?.({
                    numSelectedCards: selectedCardIds.includes(cardId) ? selectedCardIds.length - 1 : selectedCardIds.length + 1,
                    issue_ids: selectedCardIds.includes(cardId) ? selectedCardIds.filter((id)=>id !== cardId) : [
                        ...selectedCardIds,
                        cardId
                    ]
                });
                return (0, $kVLXA.Observable).from(actions);
            }
            return (0, $kVLXA.Observable).empty();
        });

});
parcelRegister("7SF9g", function(module, exports) {

$parcel$export(module.exports, "setPanelsUrl", () => $85434ff057809d96$export$b0d97eda249239c5);
parcelRequire("6hSeW");
parcelRequire("fp4O3");

var $7uUwQ = parcelRequire("7uUwQ");

var $ebyGx = parcelRequire("ebyGx");

const $85434ff057809d96$export$b0d97eda249239c5 = (panel, isOpen, location)=>{
    const search = (0, $7uUwQ.chain)({
        ...(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(location.search)
    });
    if (isOpen) // using 'visible' as this is what the old CMP uses
    search.set(panel, panel === (0, $4f4a02cead13bb5a$export$61119f100c357d06) ? true : 'visible');
    else search.unset(panel);
    return {
        ...location,
        search: (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(search.value())
    };
};

});

parcelRegister("cik5h", function(module, exports) {

$parcel$export(module.exports, "addSelectedIssueToUrl", () => $fe1f24bd5e953f6b$export$56eb5b2509c9e59c);
$parcel$export(module.exports, "removeSelectedIssueFromUrl", () => $fe1f24bd5e953f6b$export$e850ae281e93782);

var $7uUwQ = parcelRequire("7uUwQ");

var $ebyGx = parcelRequire("ebyGx");

const $fe1f24bd5e953f6b$export$56eb5b2509c9e59c = (cardKey, location)=>{
    const search = (0, $7uUwQ.chain)({
        ...(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(location.search)
    });
    search.set((0, $4f4a02cead13bb5a$export$3a0c4bc79274bbaa), cardKey);
    return {
        ...location,
        search: (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(search.value())
    };
};
const $fe1f24bd5e953f6b$export$e850ae281e93782 = (location)=>{
    const search = (0, $7uUwQ.chain)({
        ...(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(location.search)
    });
    search.unset((0, $4f4a02cead13bb5a$export$3a0c4bc79274bbaa));
    return {
        ...location,
        search: (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(search.value())
    };
};

});

parcelRegister("8SI0F", function(module, exports) {

$parcel$export(module.exports, "CHECKBOX_SELECTION_MODE", () => $eca1da487a90baaa$export$2993cc8e0a65cc79);
$parcel$export(module.exports, "setCheckboxSelectionMode", () => $eca1da487a90baaa$export$bb628ef7fc94ed9);
const $eca1da487a90baaa$export$2993cc8e0a65cc79 = 'state.actions.cards.checkbox-selection-mode.CHECKBOX_SELECTION_MODE';
const $eca1da487a90baaa$export$bb628ef7fc94ed9 = (isCheckboxSelectionMode)=>({
        type: $eca1da487a90baaa$export$2993cc8e0a65cc79,
        payload: {
            isCheckboxSelectionMode: isCheckboxSelectionMode
        }
    });

});

parcelRegister("9g0YE", function(module, exports) {

$parcel$export(module.exports, "TOGGLE_PANEL", () => $7804c0f987e094d3$export$81879e9427948bf);
$parcel$export(module.exports, "togglePanel", () => $7804c0f987e094d3$export$67879b1cfc177b88);
$parcel$export(module.exports, "CLOSE_INSIGHTS_PANEL", () => $7804c0f987e094d3$export$8e43d92e9c342d0);
$parcel$export(module.exports, "closeInsightsPanel", () => $7804c0f987e094d3$export$4fda8ba2e49f8d0c);
$parcel$export(module.exports, "CLOSE_VIEW_SETTINGS_PANEL", () => $7804c0f987e094d3$export$b1f480ba0abd2610);
$parcel$export(module.exports, "closeViewSettingsPanel", () => $7804c0f987e094d3$export$ef3e4b5eca4263a7);
$parcel$export(module.exports, "SET_ALL_PANELS", () => $7804c0f987e094d3$export$c2b45216f8258443);
$parcel$export(module.exports, "setAllPanels", () => $7804c0f987e094d3$export$550d1aa0feb70ab4);
$parcel$export(module.exports, "SET_ALL_PANELS_SUCCESS", () => $7804c0f987e094d3$export$8c036bde1eda2c94);
const $7804c0f987e094d3$export$81879e9427948bf = 'state.actions.panels.TOGGLE_PANEL';
const $7804c0f987e094d3$export$67879b1cfc177b88 = (panel)=>({
        type: $7804c0f987e094d3$export$81879e9427948bf,
        payload: {
            panel: panel
        }
    });
const $7804c0f987e094d3$export$8e43d92e9c342d0 = 'state.actions.panels.CLOSE_INSIGHTS_PANEL';
const $7804c0f987e094d3$export$4fda8ba2e49f8d0c = (shouldUpdateLocation = true)=>({
        type: $7804c0f987e094d3$export$8e43d92e9c342d0,
        payload: {
            shouldUpdateLocation: shouldUpdateLocation
        }
    });
const $7804c0f987e094d3$export$b1f480ba0abd2610 = 'state.actions.panels.CLOSE_VIEW_SETTINGS_PANEL';
const $7804c0f987e094d3$export$ef3e4b5eca4263a7 = ()=>({
        type: $7804c0f987e094d3$export$b1f480ba0abd2610
    });
const $7804c0f987e094d3$export$c2b45216f8258443 = 'state.actions.panels.SET_ALL_PANELS';
const $7804c0f987e094d3$export$550d1aa0feb70ab4 = ()=>({
        type: $7804c0f987e094d3$export$c2b45216f8258443
    });
const $7804c0f987e094d3$export$8c036bde1eda2c94 = 'state.actions.panels.SET_ALL_PANELS_SUCCESS';
const $7804c0f987e094d3$export$9491aa22a408c1a9 = (panels)=>({
        type: $7804c0f987e094d3$export$8c036bde1eda2c94,
        payload: {
            panels: panels
        }
    });

});


parcelRegister("lTfMj", function(module, exports) {

$parcel$export(module.exports, "cardCreateMultipleGqlEpic", () => $0ee7d1e105ae28ce$export$2d487b79844af2c);
$parcel$export(module.exports, "closeCardCreateOnDragStart", () => $0ee7d1e105ae28ce$export$57f17a282bb0a020);

var $2HfxU = parcelRequire("2HfxU");

var $9XE6b = parcelRequire("9XE6b");

var $80afZ = parcelRequire("80afZ");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");


var $fZneA = parcelRequire("fZneA");

var $01j5n = parcelRequire("01j5n");

var $3vXOY = parcelRequire("3vXOY");

var $4cr9K = parcelRequire("4cr9K");

var $cNrxd = parcelRequire("cNrxd");

var $guzeq = parcelRequire("guzeq");


var $hNeni = parcelRequire("hNeni");

var $i4Z8q = parcelRequire("i4Z8q");

var $3lZ6i = parcelRequire("3lZ6i");

var $hf5c2 = parcelRequire("hf5c2");

var $5Eoed = parcelRequire("5Eoed");

var $gwOHY = parcelRequire("gwOHY");

var $jG5HW = parcelRequire("jG5HW");

var $aU3CO = parcelRequire("aU3CO");

var $bAfUr = parcelRequire("bAfUr");

var $9tZuw = parcelRequire("9tZuw");

var $dGljH = parcelRequire("dGljH");

var $eMLHT = parcelRequire("eMLHT");
const $0ee7d1e105ae28ce$var$parseFirstFetchErrorMessage = (error)=>{
    if ((0, $cNrxd.isJson)(error.message)) {
        const response = JSON.parse(error.message);
        return(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, (/*@__PURE__*/$parcel$interopDefault($2HfxU)))((0, (/*@__PURE__*/$parcel$interopDefault($80afZ)))((0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(response, 'errors', null))) ?? (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(response, 'generalErrors[0]', null) ?? null);
    }
    return error.message;
};
const $0ee7d1e105ae28ce$var$getBadRequestErrorMessage = (error)=>{
    if ((0, $cNrxd.isSwagError)(error)) {
        const badRequestError = error.graphQLErrors.find(({ extensions: { statusCode: statusCode } })=>statusCode === (0, $3cd8a0ece36fbae5$export$9de493bcd9b1d977));
        return badRequestError ? badRequestError.message : null;
    }
    if ((0, $cNrxd.isFetchError)(error) && error.statusCode === (0, $3cd8a0ece36fbae5$export$9de493bcd9b1d977)) return $0ee7d1e105ae28ce$var$parseFirstFetchErrorMessage(error);
    return null;
};
const $0ee7d1e105ae28ce$export$2d487b79844af2c = (action$, store)=>action$.ofType((0, $hf5c2.CARD_CREATE_MULTIPLE_REQUEST)).mergeMap((action)=>{
        const { payload: { listId: listId, insertBefore: insertBefore, storeFieldsFromCardCreateData: storeFieldsFromCardCreateData, storeFieldsFromFetchIssuesData: storeFieldsFromFetchIssuesData, tempIds: tempIds, summaries: summaries, typeId: typeId, parentId: parentId, fixVersions: fixVersions, descriptions: descriptions }, meta: { optimistic: { id: optimisticId }, analyticsEvent: analyticsEvent } } = action;
        const state = store.getState();
        const serviceContext = (0, $i4Z8q.makeServiceContext)(state);
        const inlineCreateSessionId = (0, $aU3CO.getInlineCreateSessionId)(state);
        return (0, $hNeni.cardCreateService)(serviceContext, store, summaries, typeId, parentId, fixVersions, listId, insertBefore, descriptions, storeFieldsFromCardCreateData, storeFieldsFromFetchIssuesData).flatMap((cardsCreated)=>{
            if (cardsCreated === null) return (0, $kVLXA.Observable).of((0, $hf5c2.cardCreateUnmapped)(summaries.length, null, optimisticId, null, analyticsEvent));
            if (!(0, $bAfUr.isStatusMappedToBoardOld)(cardsCreated[0].statusId)(state)) return (0, $kVLXA.Observable).of((0, $hf5c2.cardCreateUnmapped)(summaries.length, cardsCreated.map((cardCreated)=>cardCreated.key), optimisticId, cardsCreated[0].issueTypeName, analyticsEvent));
            const actions = cardsCreated.map((cardCreated, index)=>(0, $hf5c2.cardCreateSuccess)(cardCreated, listId, tempIds[index], insertBefore !== null, summaries.length > 1, optimisticId, analyticsEvent));
            // We should refetch versions data when an issue is inline created to keep the version panel on sync
            // and to avoid this issue: https://hello.atlassian.net/browse/FEBA-1548a
            actions.push((0, $gwOHY.refetchVersions)());
            if ((0, $jG5HW.isCmpKanbanProject)(state)) {
                const cardListStatusId = (0, $bAfUr.makeGetKanbanSingleColumnStatusId)(state)(listId);
                if (cardListStatusId && !(0, $bAfUr.areStatusesFromSameColumn)(state)(cardListStatusId, cardsCreated[0].statusId)) actions.push((0, $3lZ6i.loadAppData)());
            }
            return (0, $kVLXA.Observable).from(actions);
        }).catch((error)=>{
            const validationErrorMessage = $0ee7d1e105ae28ce$var$getBadRequestErrorMessage(error);
            const statusCode = (0, $3vXOY.extractStatusCode)(error);
            const isClientFetchError = (0, $fZneA.isClientFetchError)(error) || (0, $01j5n.isUserNetworkError)(error);
            if (validationErrorMessage) return (0, $kVLXA.Observable).from([
                (0, $5Eoed.openModal)({
                    type: (0, $b107c54ec82f76f2$export$55cae6fd3c958bc5),
                    payload: {
                        cardListId: listId,
                        cardParentId: parentId,
                        cardSummary: summaries[0],
                        cardTypeId: typeId,
                        rankBeforeCardId: insertBefore,
                        fixVersions: fixVersions,
                        submitErrorMessage: validationErrorMessage,
                        sessionId: inlineCreateSessionId
                    }
                }),
                (0, $hf5c2.cardCreateFailure)(summaries.length, optimisticId, error.message, statusCode, isClientFetchError)
            ]);
            return (0, $kVLXA.Observable).from([
                (0, $hf5c2.cardCreateFailure)(summaries.length, optimisticId, error.message, statusCode, isClientFetchError, analyticsEvent),
                (0, $4cr9K.showErrorFlag)(error),
                (0, $3lZ6i.refreshDataRequest)((0, $guzeq.REFRESH_SOURCE_FAILURE))
            ]);
        });
    });
const $0ee7d1e105ae28ce$export$57f17a282bb0a020 = (action$, store)=>action$.ofType((0, $eMLHT.DRAG_START)).mergeMap(()=>{
        const state = store.getState();
        const cardIdWithAboveICCOpen = (0, $dGljH.getCardIdWithAboveICCOpen)(state);
        if (cardIdWithAboveICCOpen) return (0, $kVLXA.Observable).of((0, $9tZuw.setCardIdWithAboveICCOpen)(null));
        return (0, $kVLXA.Observable).empty();
    });

});
parcelRegister("80afZ", function(module, exports) {

var $1nIHN = parcelRequire("1nIHN");

var $bxDef = parcelRequire("bxDef");

var $jXnVG = parcelRequire("jXnVG");

var $8LQ84 = parcelRequire("8LQ84");
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $5d3647a04b83e8d6$var$map(collection, iteratee) {
    var func = $8LQ84(collection) ? $1nIHN : $jXnVG;
    return func(collection, $bxDef(iteratee, 3));
}
module.exports = $5d3647a04b83e8d6$var$map;

});

const $3cd8a0ece36fbae5$export$ff39ebd4bb12b718 = 201;
const $3cd8a0ece36fbae5$export$3288b14b6745c572 = 204;
const $3cd8a0ece36fbae5$export$9de493bcd9b1d977 = 400;
const $3cd8a0ece36fbae5$export$67d19e9a991baa07 = 401;
const $3cd8a0ece36fbae5$export$a3269a3914b007e3 = 403;
const $3cd8a0ece36fbae5$export$8bca792d963eb0ef = 404;
const $3cd8a0ece36fbae5$export$4a3cb39801694eee = 407;
const $3cd8a0ece36fbae5$export$fa405bbf47d510e2 = 408;
const $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f = 409;
const $3cd8a0ece36fbae5$export$5244030134e99 = 412;
const $3cd8a0ece36fbae5$export$f90ac1df0b60853d = 413;
const $3cd8a0ece36fbae5$export$a447d0a965e16776 = 422;
const $3cd8a0ece36fbae5$export$3b48aba8957000cd = 426;
const $3cd8a0ece36fbae5$export$6763168a631449a2 = 429;
const $3cd8a0ece36fbae5$export$e813cd7045fcc98d = 500;
const $3cd8a0ece36fbae5$export$2ce38d41a306034e = 502;
const $3cd8a0ece36fbae5$export$974c37534b0191b1 = 503;
const $3cd8a0ece36fbae5$export$5400e8dddac3fcf3 = 504;

const $b107c54ec82f76f2$export$86a0c18887a92eae = 'MOVE_CARDS_ACTIVE_SPRINT';
const $b107c54ec82f76f2$export$dcb8eb3e585ecde = 'MOVE_CARD_SELECT_TRANSITION';
const $b107c54ec82f76f2$export$87c7cb14aa706e2d = 'DELETE_CARD';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b107c54ec82f76f2$var$DeleteSprintType = 'DELETE_SPRINT';
const $b107c54ec82f76f2$export$9d5b8103d4fbbb34 = 'ASSIGN_ISSUE_PARENT';
const $b107c54ec82f76f2$export$55cae6fd3c958bc5 = 'GLOBAL_ISSUE_CREATE';
const $b107c54ec82f76f2$export$77e94846ed2f57d7 = 'SPLIT_ISSUE_BACKLOG';
const $b107c54ec82f76f2$export$34f52cb2089ddc40 = 'FLAG_WITH_COMMENT_BACKLOG';

parcelRegister("hNeni", function(module, exports) {

$parcel$export(module.exports, "cardCreateService", () => $8e7733a925b3c12d$export$73bba27938f44f97);

var $hYfgW = parcelRequire("hYfgW");

var $4R6GH = parcelRequire("4R6GH");

var $jG5HW = parcelRequire("jG5HW");

var $9Pc1U = parcelRequire("9Pc1U");

var $l9VFH = parcelRequire("l9VFH");

var $fmuR9 = parcelRequire("fmuR9");

var $8URt5 = parcelRequire("8URt5");

var $k35me = parcelRequire("k35me");

var $eWiJG = parcelRequire("eWiJG");

var $aqpnO = parcelRequire("aqpnO");
const $8e7733a925b3c12d$var$createOverrides = (state, cardListId)=>{
    const isSprintCardList = (0, $k35me.makeIsSprintCardList)(state);
    const epicLinkShortCustomFieldId = (0, $9Pc1U.epicLinkShortCustomFieldIdSelector)(state);
    const sprintShortCustomFieldId = (0, $9Pc1U.sprintShortCustomFieldIdSelector)(state);
    const sprintId = isSprintCardList(cardListId) ? Number(cardListId) : undefined;
    const issueParent = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))((0, $fmuR9.filteredParentsSelector)(state));
    const assignee = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))((0, $l9VFH.getAppliedAssigneeFilters)(state));
    const version = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))((0, $l9VFH.getAppliedVersionFilters)(state));
    const label = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))((0, $l9VFH.getAppliedLabelFilters)(state));
    return {
        ...assignee ? {
            assignee: assignee
        } : {},
        ...sprintId && sprintShortCustomFieldId ? {
            [sprintShortCustomFieldId]: sprintId
        } : {},
        ...issueParent && epicLinkShortCustomFieldId ? {
            [epicLinkShortCustomFieldId]: issueParent.key
        } : {},
        ...version ? {
            fixVersion: version
        } : {},
        ...label ? {
            labels: label
        } : {}
    };
};
function $8e7733a925b3c12d$export$73bba27938f44f97(serviceContext, store, summaries, issueTypeId, parentId, fixVersions, cardListId, rankBeforeCardId = null, descriptions, storeFieldsFromCardCreateData, storeFieldsFromFetchIssuesData) {
    if (serviceContext.isCompanyManaged) {
        const state = store.getState();
        const contexts = (0, $8URt5.jqlContextSelector)(state);
        const epicIssueType = (0, $jG5HW.getEpicIssueType)(state);
        const overrides = $8e7733a925b3c12d$var$createOverrides(state, cardListId);
        const sprintFieldId = (0, $jG5HW.getSprintFieldId)(state);
        const isSprintCardList = (0, $k35me.makeIsSprintCardList)(state);
        const sprintId = isSprintCardList(cardListId) ? cardListId : undefined;
        if (descriptions && (0, $4R6GH.fg)('ai_powered_backlog_inline_create_gate')) {
            const issueParent = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))((0, $fmuR9.filteredParentsSelector)(state));
            const cards = summaries.map((summary, index)=>({
                    summary: summary,
                    description: descriptions[index]
                }));
            const projectId = (0, $jG5HW.projectIdSelector)(state);
            const cloudId = (0, $jG5HW.getCloudId)(state);
            // skip sprint id for the time being
            return (0, $aqpnO.inlineCardBulkCreateService)({
                epicIssueType: epicIssueType,
                projectId: projectId,
                cloudId: cloudId,
                fixVersions: overrides.fixVersion ? [
                    overrides.fixVersion
                ] : [],
                assigneeId: overrides.assignee ?? null,
                parentId: issueParent ? issueParent.id : null,
                labels: overrides.labels ? [
                    overrides.labels
                ] : [],
                issueTypeId: String(issueTypeId),
                ...(0, $4R6GH.fg)('ai_powered_backlog_inline_create-create_in_sprint') ? {
                    sprintIds: sprintId ? [
                        sprintId
                    ] : [],
                    sprintFieldId: sprintFieldId ?? ''
                } : {},
                cards: cards,
                storeFieldsFromFetchIssuesData: storeFieldsFromFetchIssuesData
            });
        }
        return (0, $aqpnO.inlineCardCreateService)(serviceContext, {
            summary: summaries[0],
            issueTypeId: String(issueTypeId),
            contexts: contexts,
            overrides: overrides,
            epicIssueType: epicIssueType,
            storeFieldsFromFetchIssuesData: storeFieldsFromFetchIssuesData
        });
    }
    return (0, $eWiJG.createMultipleCardService)(store, summaries, issueTypeId, parentId, fixVersions, cardListId, rankBeforeCardId, descriptions, storeFieldsFromCardCreateData);
}

});
parcelRegister("9Pc1U", function(module, exports) {

$parcel$export(module.exports, "getConfig", () => $f4b895e6f32be889$export$44487a86467333c3);
$parcel$export(module.exports, "isConfigLoaded", () => $f4b895e6f32be889$export$d39ab0d27414dd81);
$parcel$export(module.exports, "isCriticalDataLoaded", () => $f4b895e6f32be889$export$d3455c208c1b3727);
$parcel$export(module.exports, "isUserAtLeastMemberOfProject", () => $f4b895e6f32be889$export$56dbce3d18728488);
$parcel$export(module.exports, "isInlineIssueCreateAvailableForCurrentUser", () => $f4b895e6f32be889$export$61b79888ee8d503a);
$parcel$export(module.exports, "getAllFeatures", () => $f4b895e6f32be889$export$a15e774d3d888bb9);
$parcel$export(module.exports, "getShowEpicAsPanel", () => $f4b895e6f32be889$export$60ba0c8082dd51bc);
$parcel$export(module.exports, "getEpicLinkField", () => $f4b895e6f32be889$export$3a84de4f399e5939);
$parcel$export(module.exports, "getEpicColorFieldId", () => $f4b895e6f32be889$export$b02b4f80d1c4ab0b);
$parcel$export(module.exports, "epicLinkShortCustomFieldIdSelector", () => $f4b895e6f32be889$export$71a1cd2c8522f4bf);
$parcel$export(module.exports, "sprintShortCustomFieldIdSelector", () => $f4b895e6f32be889$export$d1c61551fd7c800e);

var $dGvGJ = parcelRequire("dGvGJ");

var $f01qr = parcelRequire("f01qr");

var $jG5HW = parcelRequire("jG5HW");

var $1z1J7 = parcelRequire("1z1J7");
const $f4b895e6f32be889$export$44487a86467333c3 = (state)=>state.config;
const $f4b895e6f32be889$export$d39ab0d27414dd81 = (state)=>state.ui.isConfigLoaded;
const $f4b895e6f32be889$export$d3455c208c1b3727 = (state)=>state.ui.isCriticalDataLoaded;
const $f4b895e6f32be889$export$65853863ca35552 = (state)=>$f4b895e6f32be889$export$44487a86467333c3(state).isInlineCardCreateEnabled;
const $f4b895e6f32be889$var$canViewBoardAndCreateOrMutateIssues = (state)=>(0, $1z1J7.canViewBoard)(state) && ((0, $1z1J7.canCreateIssues)(state) || (0, $1z1J7.canEditIssue)(state) || (0, $1z1J7.canDeleteIssues)(state) || (0, $1z1J7.canAssignIssues)(state) || (0, $1z1J7.canTransitionIssues)(state) || (0, $1z1J7.canBulkEditIssues)(state));
const $f4b895e6f32be889$var$canCreateOrMutateIssues = (state)=>(0, $1z1J7.canCreateIssues)(state) || (0, $1z1J7.canEditIssue)(state) || (0, $1z1J7.canDeleteIssues)(state);
const $f4b895e6f32be889$export$56dbce3d18728488 = (state)=>// This is a proxy for the DW idea of Project 'Member' but it's still flawed and not compatible with company-managed permission model.
    // If a user can create, edit or delete issues in this project, they must be at least a Member,
    // and enjoy all the privileges of a Project Member (e.g. creating and ranking issues).
    (0, $jG5HW.getIsCompanyManaged)(state) ? $f4b895e6f32be889$var$canViewBoardAndCreateOrMutateIssues(state) : $f4b895e6f32be889$var$canCreateOrMutateIssues(state);
const $f4b895e6f32be889$export$61b79888ee8d503a = (0, $dGvGJ.createSelector)([
    $f4b895e6f32be889$export$56dbce3d18728488,
    (0, $jG5HW.getIsCompanyManaged),
    (0, $1z1J7.canCreateIssues)
], (isMember, isCompanyManaged, canUserCreateIssues)=>isCompanyManaged ? canUserCreateIssues : isMember);
const $f4b895e6f32be889$export$a15e774d3d888bb9 = (state)=>state.config.allFeatures;
const $f4b895e6f32be889$export$60ba0c8082dd51bc = (state)=>!(0, $jG5HW.getIsCompanyManaged)(state) || state.config.showEpicAsPanel;
const $f4b895e6f32be889$export$3a84de4f399e5939 = (state)=>state.config.epicLinkField;
const $f4b895e6f32be889$export$b02b4f80d1c4ab0b = (state)=>state.config.epicColorFieldId;
const $f4b895e6f32be889$export$71a1cd2c8522f4bf = (0, $dGvGJ.createSelector)([
    $f4b895e6f32be889$export$3a84de4f399e5939
], (epicLinkField)=>epicLinkField?.id ? (0, $f01qr.toShortCustomFieldId)(epicLinkField?.id) : undefined);
const $f4b895e6f32be889$export$d1c61551fd7c800e = (0, $dGvGJ.createSelector)([
    (0, $jG5HW.getSprintFieldId)
], (sprintCustomFieldId)=>sprintCustomFieldId ? (0, $f01qr.toShortCustomFieldId)(sprintCustomFieldId) : undefined);

});

parcelRegister("8URt5", function(module, exports) {

$parcel$export(module.exports, "jqlContextSelector", () => $85418be1dfd8983d$export$a0b5ed948695afc3);

var $dGvGJ = parcelRequire("dGvGJ");

var $l9VFH = parcelRequire("l9VFH");
const $85418be1dfd8983d$export$2af3643b1d2591eb = (state)=>state.config.jqlQuery;
const $85418be1dfd8983d$export$a0b5ed948695afc3 = (0, $dGvGJ.createSelector)([
    $85418be1dfd8983d$export$2af3643b1d2591eb,
    (0, $l9VFH.getAppliedCustomFilterQueries)
], // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
(jqlQuery, jqlCustomFilters)=>[
        jqlQuery,
        ...jqlCustomFilters
    ]);

});

parcelRegister("eWiJG", function(module, exports) {

$parcel$export(module.exports, "createMultipleCardService", () => $f9f16a630333a4e4$export$76edf6a735664e34);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $4R6GH = parcelRequire("4R6GH");

var $2lpqS = parcelRequire("2lpqS");

var $guzeq = parcelRequire("guzeq");

var $a0k9j = parcelRequire("a0k9j");

var $jG5HW = parcelRequire("jG5HW");

var $3QmBe = parcelRequire("3QmBe");

var $dGljH = parcelRequire("dGljH");

var $42pTt = parcelRequire("42pTt");

var $fmuR9 = parcelRequire("fmuR9");
const $f9f16a630333a4e4$var$transformParent = (parentId, parents)=>{
    if (!parentId) return null;
    return parents.find((parent)=>parent.id === parentId) ?? null;
};
const $f9f16a630333a4e4$var$transformer = ({ id: id, done: isDone, flagged: isFlagged, parentId: parentId, fixVersions: fixVersions, issue: { key: key, summary: summary, type: { id: cardTypeId, iconUrl: cardTypeUrl, name: cardTypeName }, labels: labels, status: { id: statusId }, assignee: assignee }, priority: priority, dueDate: dueDate }, projectId, parents)=>({
        id: Number(id),
        key: key,
        summary: summary,
        icon: cardTypeUrl,
        typeId: Number(cardTypeId),
        isDone: isDone,
        labels: labels,
        isFlagged: isFlagged,
        assignee: assignee ? {
            id: assignee.accountId,
            displayName: assignee.displayName,
            avatarUrl: assignee.avatarUrl
        } : null,
        issueUrl: `/browse/${key}`,
        statusId: statusId,
        parentId: parentId || '' ? Number(parentId) : null,
        parent: parentId ? $f9f16a630333a4e4$var$transformParent(parentId, parents) : null,
        fixVersions: fixVersions || [],
        priority: priority,
        dueDate: dueDate,
        estimate: null,
        numCompleteChildren: 0,
        numTotalChildren: 0,
        projectId: projectId,
        issueTypeName: cardTypeName
    });
function $f9f16a630333a4e4$export$9975557ae115718f(response, overrides) {
    const newCards = Object.values(response).map((creationRequest)=>{
        if (!creationRequest?.createIssue?.issue) return null;
        const { issue: issue } = creationRequest.createIssue;
        const issueGql = {
            id: issue.issueId,
            key: issue.key,
            summary: issue.summary,
            labels: issue.fieldSetsById.edges[0]?.node?.fields.edges[0]?.node?.labels?.edges.map((label)=>label.node.name) || [],
            type: {
                id: issue.issueTypeField.issueType.issueTypeId,
                name: issue.issueTypeField.issueType.name,
                iconUrl: issue.issueTypeField.issueType.avatar.medium
            },
            status: {
                id: issue.statusField.status.statusId,
                name: issue.statusField.status.name,
                category: issue.statusCategory.key
            },
            assignee: issue.assigneeField.user ? {
                accountId: issue.assigneeField.user.accountId,
                displayName: issue.assigneeField.user.name,
                avatarUrl: issue.assigneeField.user.picture
            } : null
        };
        const priorityGql = issue.priorityField?.priority ? {
            name: issue.priorityField.priority.name,
            iconUrl: issue.priorityField.priority.iconUrl
        } : null;
        const newCardGql = {
            id: issue.issueId,
            parentId: issue.parentIssueField.parentIssue?.issueId || null,
            issue: issueGql,
            priority: priorityGql,
            ...overrides
        };
        // newCardGql
        return newCardGql;
    }).filter(Boolean);
    // Construct the eventual object
    const cardCreateGql = {
        planModeCardCreate: {
            newCards: newCards
        }
    };
    return cardCreateGql;
}
const $f9f16a630333a4e4$export$76edf6a735664e34 = (// TODO: Passing the store is against the architecture, use service-context instead and request objects;
// additionally, don't pass in a callback parameter
store, summaries, issueTypeId, parentId, fixVersions, cardListId, rankBeforeCardId = null, descriptions, storeFieldsFromCardCreateData)=>{
    const state = store.getState();
    const baseUrl = (0, $jG5HW.getBaseUrl)(state);
    const boardId = (0, $jG5HW.getRapidViewId)(state);
    const storyPointFieldId = (0, $jG5HW.getStoryPointFieldId)(state);
    const assignee = (0, $3QmBe.getMostRecentAssigneeFilter)(state);
    const labels = (0, $3QmBe.getAppliedLabelFilters)(state);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const cardList = (0, $dGljH.getCardLists)(state)[cardListId];
    const projectId = (0, $jG5HW.projectIdSelector)(state);
    const cloudId = (0, $jG5HW.getCloudId)(state);
    const sprintFieldId = (0, $jG5HW.getSprintFieldId)(state);
    const isSprintCardList = cardList.type === (0, $guzeq.SPRINT);
    const sprintIds = isSprintCardList ? [
        cardListId
    ] : [];
    const parents = (0, $fmuR9.issueParentsSelector)(state);
    if (descriptions && (0, $4R6GH.fg)('ai_powered_backlog_inline_create_gate')) return (0, $42pTt.bulkCreateIssuesWithDescription)({
        projectId: String(projectId),
        cloudId: cloudId,
        issueTypeId: String(issueTypeId),
        parentId: parentId ? String(parentId) : null,
        fixVersions: fixVersions,
        assigneeId: assignee ? assignee.id : null,
        labels: labels,
        cards: summaries.map((summary, index)=>({
                summary: summary,
                description: descriptions[index]
            })),
        ...(0, $4R6GH.fg)('ai_powered_backlog_inline_create-create_in_sprint') ? {
            sprintFieldId: sprintFieldId,
            sprintIds: sprintIds
        } : {}
    }).map((response)=>$f9f16a630333a4e4$export$9975557ae115718f(response, {
            flagged: false,
            done: false,
            dueDate: null,
            fixVersions: fixVersions
        }))// @ts-expect-error - TS2345 - Argument of type '(result: CardCreateGql) => ObservableType<null> | ObservableType<Card[]>' is not assignable to parameter of type '(value: CardCreateGql, index: number) => ObservableInput<Card[] | null>'.
    .flatMap((result)=>{
        const fieldConfigs = {
            storyPointFieldId: storyPointFieldId
        };
        // Pre-populate extracted fields (Sweet State) using card create data
        storeFieldsFromCardCreateData(result, fieldConfigs);
        if (result.planModeCardCreate.newCards && result.planModeCardCreate.newCards.length > 0) {
            const transformedCards = result.planModeCardCreate.newCards.map((card)=>$f9f16a630333a4e4$var$transformer(card, projectId, parents));
            return (0, $kVLXA.Observable).of(transformedCards);
        }
        return (0, $kVLXA.Observable).of(null);
    });
    return (0, $a0k9j.default)(baseUrl, {
        boardId: boardId,
        destination: cardList.type,
        destinationId: cardList.type === (0, $guzeq.SPRINT) ? cardList.id : null,
        newCards: summaries.map((summary)=>({
                summary: summary,
                issueTypeId: issueTypeId,
                parentId: parentId === (0, $2lpqS.UNASSIGNED_EPIC_ID) ? null : parentId,
                fixVersions: fixVersions,
                assigneeId: assignee ? assignee.id : null,
                labels: labels || []
            })),
        rankBeforeCardId: rankBeforeCardId
    }).flatMap((result)=>{
        const fieldConfigs = {
            storyPointFieldId: storyPointFieldId
        };
        // Pre-populate extracted fields (Sweet State) using card create data
        storeFieldsFromCardCreateData(result, fieldConfigs);
        if (result.planModeCardCreate.newCards && result.planModeCardCreate.newCards.length > 0) {
            const transformedCards = result.planModeCardCreate.newCards.map((card)=>$f9f16a630333a4e4$var$transformer(card, projectId, parents));
            return (0, $kVLXA.Observable).of(transformedCards);
        }
        return (0, $kVLXA.Observable).of(null);
    });
};

});
parcelRegister("a0k9j", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b15a5d8d00a25d0$export$2e2bcd8739ae039);

var $6iJbJ = parcelRequire("6iJbJ");
const $1b15a5d8d00a25d0$var$MUTATION_NAME = 'BacklogCreateCard';
const $1b15a5d8d00a25d0$export$e904bac7f43ed94a = ()=>`
    mutation ${$1b15a5d8d00a25d0$var$MUTATION_NAME} (
        $boardId: ID!,
        $destination: PlanModeDestination!,
        $destinationId: ID,
        $newCards: [NewCard!]!,
        $rankBeforeCardId: Long
    ) {
        planModeCardCreate(input: {
            boardId: $boardId,
            destination: $destination,
            destinationId: $destinationId,
            newCards: $newCards,
            rankBeforeCardId: $rankBeforeCardId
        }) {
            newCards {
                id
                flagged
                done
                parentId
                fixVersions
                issue {
                    id
                    key
                    summary
                    labels
                    status {
                        id
                        name
                        category
                    }
                    assignee {
                        accountId
                        displayName
                        avatarUrl
                    }
                    type {
                        id
                        name
                        iconUrl
                    }
                }
                priority {
                    name
                    iconUrl
                }
                dueDate
            }
        }
    }`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1b15a5d8d00a25d0$export$2e2bcd8739ae039 = (baseUrl, input)=>{
    const { boardId: boardId, destination: destination, destinationId: destinationId, newCards: newCards, rankBeforeCardId: rankBeforeCardId } = input;
    const variables = {
        boardId: boardId,
        destination: destination,
        destinationId: destinationId,
        newCards: newCards,
        rankBeforeCardId: rankBeforeCardId
    };
    return (0, $6iJbJ.mutation$)(baseUrl, $1b15a5d8d00a25d0$var$MUTATION_NAME, $1b15a5d8d00a25d0$export$e904bac7f43ed94a(), variables);
};

});

parcelRegister("3QmBe", function(module, exports) {

$parcel$export(module.exports, "getMostRecentAssigneeFilter", () => $39764b8392382256$export$aeda5a2993a15e54);
$parcel$export(module.exports, "getAppliedLabelFilters", () => $39764b8392382256$export$60ee89f2718fc651);
$parcel$export(module.exports, "getLastAppliedParentFilters", () => $39764b8392382256$export$b88c37c6fa8adc17);

var $dGvGJ = parcelRequire("dGvGJ");

var $hYfgW = parcelRequire("hYfgW");

var $dGljH = parcelRequire("dGljH");

var $l9VFH = parcelRequire("l9VFH");
const $39764b8392382256$export$aeda5a2993a15e54 = (0, $dGvGJ.createSelector)((0, $l9VFH.getFilters), (0, $dGljH.getOrderedAssignees), (filters, allAssignees)=>{
    const assignees = filters.ASSIGNEE;
    if (assignees && assignees.length > 0) {
        const lastSelectedKey = assignees[assignees.length - 1];
        const lastSelected = allAssignees.find((assignee)=>assignee.id === lastSelectedKey);
        if (lastSelected) return lastSelected;
    }
    return null;
});
const $39764b8392382256$export$60ee89f2718fc651 = (state)=>{
    const labels = state.ui.filters.LABEL;
    if (labels && labels.length > 0) return labels;
    return null;
};
const $39764b8392382256$export$b88c37c6fa8adc17 = (0, $dGvGJ.createSelector)((0, $l9VFH.getAppliedParentFilters), (parentIds)=>{
    if (parentIds && parentIds.length > 0) return Number((0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(parentIds));
    return null;
});

});

parcelRegister("42pTt", function(module, exports) {

$parcel$export(module.exports, "bulkCreateIssuesWithDescription", () => $a6778ebf3ff3f50c$export$e97214bfd7f3ce63);

var $487fd = parcelRequire("487fd");

var $dXq4S = parcelRequire("dXq4S");

var $cNrxd = parcelRequire("cNrxd");

var $4R6GH = parcelRequire("4R6GH");

var $f01qr = parcelRequire("f01qr");
const $a6778ebf3ff3f50c$var$MUTATION_NAME = 'BacklogBulkCreateCardWithDescription';
const $a6778ebf3ff3f50c$var$getConcurrentJiraMutation = (issueNum)=>{
    const variables = Array.from({
        length: issueNum
    }).map((_, i)=>`$cardCreateInput${i}: JiraIssueCreateInput!`).join(', ');
    const mutationBodies = Array.from({
        length: issueNum
    }).map((_, i)=>`
		  request${i}: jira {
			createIssue(input: $cardCreateInput${i}) @optIn(to: "JiraIssueCreateMutation") {
			  success
			  errors {
				message
				extensions {
				  statusCode
				  errorType
				}
			  }
			  issue {
				id
				issueId
				key
				summary
				issueTypeField {
				  issueType {
					issueTypeId
					name
					avatar {
					  medium
					}
					hierarchy {
					  level
					}
				  }
				}
				assigneeField {
				  user {
					id
					accountId
					name
					picture
				  }
				}
				statusField {
				  status {
					statusId
					name
					description
				  }
				}
				statusCategory {
				  statusCategoryId
				  key
				  colorName
				}
				priorityField {
				  priority {
					id
					iconUrl
					name
				  }
				}
				parentIssueField {
				  parentIssue {
					issueId
					key
					summary
					issueTypeField {
					  id
					  name
					  issueType {
						issueTypeId
						name
						id
						avatar {
						  medium
						}
					  }
					}
				  }
				}
				fieldSetsById(fieldSetIds: ["labels"]) {
				  edges {
					node {
					  fields {
						edges {
						  node {
							... on JiraLabelsField {
							  labels {
								edges {
								  node {
									name
								  }
								}
							  }
							}
						  }
						}
					  }
					}
				  }
				}
			  }
			}
		  }
		`).join('');
    return `
	  mutation ${$a6778ebf3ff3f50c$var$MUTATION_NAME}(${variables}) {
		${mutationBodies}
	  }
	`;
};
const $a6778ebf3ff3f50c$export$e97214bfd7f3ce63 = ({ projectId: projectId, cloudId: cloudId, issueTypeId: issueTypeId, parentId: parentId, fixVersions: fixVersions, assigneeId: assigneeId, labels: labels, sprintIds: sprintIds, sprintFieldId: sprintFieldId, cards: cards })=>{
    const variables = {};
    const projectAri = (0, $dXq4S.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'project',
        resourceId: projectId
    });
    const issueTypeAri = (0, $dXq4S.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'issue-type',
        resourceId: issueTypeId
    });
    cards.forEach((card, i)=>{
        variables[`cardCreateInput${i}`] = {
            projectId: projectAri,
            issueTypeId: issueTypeAri,
            fields: {
                singleLineTextFields: [
                    {
                        fieldId: 'summary',
                        text: card.summary
                    }
                ],
                richTextFields: [
                    {
                        fieldId: 'description',
                        richText: {
                            adfValue: (0, $f01qr.getCardDescriptionAsADF)(card.description)
                        }
                    }
                ],
                ...parentId && {
                    parentField: {
                        issueId: (0, $dXq4S.createAri)({
                            resourceOwner: 'jira',
                            cloudId: cloudId,
                            resourceType: 'issue',
                            resourceId: parentId
                        })
                    }
                },
                ...fixVersions?.length && {
                    multipleVersionPickerFields: [
                        {
                            fieldId: 'fixVersions',
                            versions: fixVersions.map((versionId)=>({
                                    versionId: versionId
                                }))
                        }
                    ]
                },
                ...assigneeId && {
                    singleSelectUserPickerFields: [
                        {
                            fieldId: 'assignee',
                            user: {
                                accountId: assigneeId
                            }
                        }
                    ]
                },
                ...labels?.length && {
                    labelsFields: [
                        {
                            fieldId: 'labels',
                            labels: labels.map((name)=>({
                                    name: name
                                }))
                        }
                    ]
                },
                ...sprintIds?.length && sprintFieldId && (0, $4R6GH.fg)('ai_powered_backlog_inline_create-create_in_sprint') && {
                    sprintsField: {
                        fieldId: sprintFieldId,
                        sprints: sprintIds.map((sprintId)=>({
                                sprintId: sprintId
                            }))
                    }
                }
            }
        };
    });
    return (0, $487fd.default)('/gateway/api/graphql', {
        method: 'POST',
        body: JSON.stringify({
            operationName: $a6778ebf3ff3f50c$var$MUTATION_NAME,
            query: $a6778ebf3ff3f50c$var$getConcurrentJiraMutation(cards.length),
            variables: variables
        })
    }).map((response)=>response.data).map((response)=>{
        const errors = Object.values(response).find((request)=>request.createIssue?.errors)?.createIssue?.errors;
        if (errors?.length) // Just take the first error for the time being
        // Format the error as a swag error to reuse existing checks, down the line we should rename related to `gqlError`
        throw new (0, $cNrxd.SwagError)({
            graphQLErrors: errors.map(({ message: message, extensions: extensions })=>({
                    message: message,
                    path: [],
                    extensions: {
                        statusCode: extensions?.statusCode ?? null,
                        errorType: extensions?.errorType ?? '',
                        userMessage: message
                    }
                })),
            errorMessage: errors[0].message
        });
        return response;
    });
};

});


parcelRegister("aqpnO", function(module, exports) {

$parcel$export(module.exports, "inlineCardCreateService", () => $475f23634c6f5948$export$239dafa7fe96b795);
$parcel$export(module.exports, "inlineCardBulkCreateService", () => $475f23634c6f5948$export$57dbcd78792f2f12);
parcelRequire("fp4O3");
parcelRequire("d0pqD");
parcelRequire("fPS7b");

var $4R6GH = parcelRequire("4R6GH");

var $3vPnu = parcelRequire("3vPnu");

var $fhHy4 = parcelRequire("fhHy4");

var $fCYjW = parcelRequire("fCYjW");

var $42pTt = parcelRequire("42pTt");
const $475f23634c6f5948$var$fetchNewlyCreatedIssue = (boardId)=>(inlineCreateResponse)=>(0, $fhHy4.fetchIssue)(boardId, Number(inlineCreateResponse.issue.issueId));
const $475f23634c6f5948$var$updateIssueConfigStore = (epicIssueType, storeFieldsFromFetchIssuesData)=>(issue)=>{
        storeFieldsFromFetchIssuesData([
            issue
        ], epicIssueType);
        return issue;
    };
const $475f23634c6f5948$var$transformIssueToCard = (issue)=>[
        (0, $3vPnu.transformCard)(issue)
    ];
function $475f23634c6f5948$export$239dafa7fe96b795(serviceContext, { summary: summary, issueTypeId: issueTypeId, contexts: contexts, overrides: overrides, epicIssueType: epicIssueType, storeFieldsFromFetchIssuesData: storeFieldsFromFetchIssuesData }) {
    return (0, $fCYjW.inlineCreateIssue)({
        summary: summary,
        issueTypeId: issueTypeId,
        contexts: contexts,
        overrides: overrides
    }).flatMap($475f23634c6f5948$var$fetchNewlyCreatedIssue(serviceContext.boardId)).map($475f23634c6f5948$var$updateIssueConfigStore(epicIssueType, storeFieldsFromFetchIssuesData)).map($475f23634c6f5948$var$transformIssueToCard);
}
function $475f23634c6f5948$export$57dbcd78792f2f12({ epicIssueType: epicIssueType, fixVersions: fixVersions, assigneeId: assigneeId, parentId: parentId, labels: labels, issueTypeId: issueTypeId, cards: cards, storeFieldsFromFetchIssuesData: storeFieldsFromFetchIssuesData, projectId: projectId, cloudId: cloudId, sprintFieldId: sprintFieldId, sprintIds: sprintIds }) {
    return (0, $42pTt.bulkCreateIssuesWithDescription)({
        projectId: String(projectId),
        cloudId: cloudId,
        issueTypeId: issueTypeId,
        parentId: parentId ? String(parentId) : null,
        fixVersions: fixVersions,
        assigneeId: assigneeId,
        labels: labels,
        sprintIds: sprintIds,
        sprintFieldId: sprintFieldId,
        cards: cards
    }).map((response)=>$475f23634c6f5948$export$68bdc32ad8e22738(response, {
            projectId: projectId,
            flagged: false,
            done: false,
            hidden: false,
            dueDate: undefined,
            fixVersions: fixVersions,
            sprintIds: (0, $4R6GH.fg)('ai_powered_backlog_inline_create-create_in_sprint') ? sprintIds ?? [] : []
        })).map((issues)=>{
        storeFieldsFromFetchIssuesData(issues, epicIssueType);
        return issues;
    }).map((issues)=>issues.map((0, $3vPnu.transformCard)));
}
function $475f23634c6f5948$export$68bdc32ad8e22738(response, overrides) {
    return Object.values(response).map((creationRequest)=>{
        if (!creationRequest.createIssue?.issue) return null;
        const { issue: issue } = creationRequest.createIssue;
        // Construct the Issue object
        const formattedIssue = {
            id: Number(issue.issueId),
            key: issue.key,
            summary: issue.summary,
            labels: issue.fieldSetsById.edges.flatMap((edge)=>edge.node.fields.edges).flatMap((fieldEdge)=>fieldEdge.node.labels.edges).map((labelEdge)=>labelEdge.node.name),
            ...issue.parentIssueField.parentIssue ? {
                parentId: Number(issue.parentIssueField.parentIssue.issueId),
                parentKey: issue.parentIssueField.parentIssue.key,
                epicField: {
                    issueId: issue.parentIssueField.parentIssue.issueId,
                    epicKey: issue.parentIssueField.parentIssue.key,
                    summary: issue.parentIssueField.parentIssue.summary,
                    text: issue.parentIssueField.parentIssue.summary,
                    issueTypeId: issue.parentIssueField.parentIssue.issueTypeField.issueType.issueTypeId,
                    label: issue.parentIssueField.parentIssue.issueTypeField.issueType.name,
                    issueTypeIconUrl: issue.parentIssueField.parentIssue.issueTypeField.issueType.avatar.medium,
                    color: '',
                    epicColor: ''
                }
            } : {
                parentId: undefined,
                parentKey: undefined,
                epicField: undefined
            },
            ...issue.priorityField?.priority ? {
                priorityUrl: issue.priorityField.priority.iconUrl,
                priorityName: issue.priorityField.priority.name
            } : {
                priorityUrl: '',
                priorityName: ''
            },
            statusId: issue.statusField.status.statusId,
            statusName: issue.statusField.status.name,
            statusUrl: '',
            status: {
                id: issue.statusField.status.statusId,
                name: issue.statusField.status.name,
                description: issue.statusField.status.description,
                iconUrl: '',
                statusCategory: {
                    id: issue.statusCategory.statusCategoryId,
                    key: issue.statusCategory.key,
                    colorName: issue.statusCategory.colorName
                }
            },
            ...issue.assigneeField.user ? {
                assignee: issue.assigneeField.user.name,
                assigneeAccountId: issue.assigneeField.user.accountId,
                assigneeKey: issue.assigneeField.user.id,
                assigneeName: issue.assigneeField.user.name
            } : {
                assignee: undefined,
                assigneeAccountId: undefined,
                assigneeKey: undefined,
                assigneeName: undefined
            },
            avatarUrl: issue.assigneeField.user?.picture,
            typeName: issue.issueTypeField.issueType.name,
            typeId: issue.issueTypeField.issueType.issueTypeId,
            typeHierarchyLevel: issue.issueTypeField.issueType.hierarchy.level,
            typeUrl: issue.issueTypeField.issueType.avatar.medium,
            // Specified in service call
            dueDate: overrides.dueDate,
            hidden: overrides.hidden,
            done: overrides.done,
            flagged: overrides.flagged,
            fixVersions: overrides.fixVersions.map((v)=>Number(v)),
            sprintIds: overrides.sprintIds.map((v)=>Number(v)),
            projectId: overrides.projectId,
            // Use constant for the time being
            extraFields: undefined,
            linkedPagesCount: 0,
            estimateStatisticRequired: false,
            columnStatistic: {
                statFieldId: '',
                statFieldValue: {
                    text: '',
                    value: 0
                }
            }
        };
        return formattedIssue;
    }).filter(Boolean);
}

});
parcelRegister("3vPnu", function(module, exports) {

$parcel$export(module.exports, "transformCard", () => $e8ed48e7d53ec7da$export$dcbde76ab89d36a);

var $hGgHi = parcelRequire("hGgHi");

var $4R6GH = parcelRequire("4R6GH");

var $g4tDr = parcelRequire("g4tDr");

var $guzeq = parcelRequire("guzeq");

var $eaTAr = parcelRequire("eaTAr");

var $dpWCZ = parcelRequire("dpWCZ");
const $e8ed48e7d53ec7da$var$isNumericFieldEstimate = (statisticField)=>statisticField && statisticField?.statFieldId?.includes((0, $guzeq.NUMERIC_ESTIMATE_FIELD_ID_PREFIX));
const $e8ed48e7d53ec7da$var$isTimeOriginalEstimate = (statisticField)=>statisticField && statisticField?.statFieldId?.startsWith((0, $guzeq.ORIGINAL_ESTIMATE_ID));
const $e8ed48e7d53ec7da$var$transformEstimateStatistic = ({ estimateStatistic: estimateStatistic, trackingStatistic: trackingStatistic })=>{
    const timeRemainingEstimate = trackingStatistic?.statFieldValue ? {
        value: trackingStatistic?.statFieldValue?.value || 0,
        valueAsText: trackingStatistic?.statFieldValue?.text || ''
    } : null;
    const storyPoints = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(estimateStatistic) && $e8ed48e7d53ec7da$var$isNumericFieldEstimate(estimateStatistic) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(estimateStatistic?.statFieldValue?.value) ? Number(estimateStatistic?.statFieldValue?.value) : null;
    const originalEstimate = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(estimateStatistic) && $e8ed48e7d53ec7da$var$isTimeOriginalEstimate(estimateStatistic) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(estimateStatistic?.statFieldValue?.value) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(estimateStatistic?.statFieldValue?.text) ? {
        value: estimateStatistic?.statFieldValue?.value,
        valueAsText: estimateStatistic?.statFieldValue?.text
    } : null;
    return {
        storyPoints: storyPoints,
        originalEstimate: originalEstimate,
        timeRemainingEstimate: timeRemainingEstimate
    };
};
const $e8ed48e7d53ec7da$var$transformPriority = ({ priorityName: priorityName, priorityUrl: priorityUrl })=>priorityName && priorityUrl ? {
        name: priorityName,
        iconUrl: priorityUrl
    } : null;
const $e8ed48e7d53ec7da$var$transformAssignee = ({ assigneeAccountId: assigneeAccountId, assigneeName: assigneeName, avatarUrl: avatarUrl })=>assigneeAccountId && assigneeName && avatarUrl ? {
        id: assigneeAccountId,
        displayName: assigneeName,
        avatarUrl: avatarUrl
    } : null;
const $e8ed48e7d53ec7da$var$transformParentId = (issue)=>{
    if ((0, $g4tDr.isSubtaskHierarchyLevel)(issue.typeHierarchyLevel)) return issue.parentId ?? null;
    if (!(0, $dpWCZ.hasEpicField)(issue) || !(0, $dpWCZ.isEpicField)(issue.epicField)) return null;
    return issue.epicField.issueId ?? null;
};
const $e8ed48e7d53ec7da$var$transformParent = (issue)=>{
    if (!(0, $dpWCZ.hasEpicField)(issue) || !(0, $dpWCZ.isEpicField)(issue.epicField)) return null;
    return {
        id: issue.epicField.issueId.toString(),
        key: issue.epicField.epicKey,
        summary: issue.epicField.summary ?? '',
        issueType: {
            id: issue.epicField.issueTypeId,
            name: issue.epicField.label,
            iconUrl: issue.epicField.issueTypeIconUrl
        },
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        color: issue.epicField.color?.toUpperCase()
    };
};
const $e8ed48e7d53ec7da$var$toExtraField = (extraField)=>{
    const { id: id, label: label, renderer: renderer, text: text, html: html } = extraField;
    if ((0, $eaTAr.isExtraFieldHtml)(extraField)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return {
        id: id,
        label: label,
        renderer: renderer,
        html: html
    };
    if ((0, $eaTAr.isExtraFieldDate)(extraField)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return {
        id: id,
        label: label,
        renderer: renderer,
        text: text,
        html: html
    };
    if ((0, $eaTAr.isExtraFieldText)(extraField)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return {
        id: id,
        label: label,
        renderer: renderer,
        text: text
    };
    return undefined;
};
const $e8ed48e7d53ec7da$var$transformCardExtraFields = (issue)=>(issue?.extraFields ?? []).map($e8ed48e7d53ec7da$var$toExtraField).filter(Boolean);
const $e8ed48e7d53ec7da$var$getIssueEpicColor = (issue)=>(0, $dpWCZ.hasEpicField)(issue) ? issue.epicField.color || issue.epicField.epicColor : issue.color;
const $e8ed48e7d53ec7da$export$dcbde76ab89d36a = (issue)=>({
        id: issue.id,
        key: issue.key,
        summary: issue.summary,
        labels: issue.labels ?? [],
        assignee: $e8ed48e7d53ec7da$var$transformAssignee(issue),
        typeId: Number(issue.typeId),
        icon: issue.typeUrl,
        isDone: issue.done,
        isFlagged: issue.flagged,
        issueUrl: `/browse/${issue.key}`,
        statusId: issue.statusId,
        parentId: $e8ed48e7d53ec7da$var$transformParentId(issue),
        parentKey: issue.parentKey,
        parent: (0, $4R6GH.fg)('jsw-backlog-parent-field-render') ? $e8ed48e7d53ec7da$var$transformParent(issue) : null,
        priority: $e8ed48e7d53ec7da$var$transformPriority(issue),
        projectId: issue.projectId,
        dueDate: issue.dueDate ?? null,
        estimate: $e8ed48e7d53ec7da$var$transformEstimateStatistic(issue),
        numCompleteChildren: 0,
        numTotalChildren: 0,
        fixVersions: issue.fixVersions?.map(String),
        color: issue.color,
        epicColor: $e8ed48e7d53ec7da$var$getIssueEpicColor(issue),
        extraFields: $e8ed48e7d53ec7da$var$transformCardExtraFields(issue),
        typeHierarchyLevel: issue.typeHierarchyLevel,
        hidden: issue.hidden,
        issueTypeName: issue.typeName
    });

});
parcelRegister("eaTAr", function(module, exports) {

$parcel$export(module.exports, "isExtraFieldHtml", () => $d13e0dbf27e02f79$export$d1fe808976407c4c);
$parcel$export(module.exports, "isExtraFieldDate", () => $d13e0dbf27e02f79$export$da33088c7c3e5cb2);
$parcel$export(module.exports, "isExtraFieldLabel", () => $d13e0dbf27e02f79$export$748f5a82c0532889);
$parcel$export(module.exports, "isExtraFieldThumbnail", () => $d13e0dbf27e02f79$export$236190af5d6fde4c);
$parcel$export(module.exports, "isExtraFieldText", () => $d13e0dbf27e02f79$export$899a90d8d4afc87b);

var $5fc53 = parcelRequire("5fc53");

function $d13e0dbf27e02f79$var$isExtraField(field, rendererTypes = []) {
    if (field !== null && typeof field === 'object' && 'renderer' in field) return rendererTypes.some((rendererType)=>field?.renderer === rendererType);
    return false;
}
function $d13e0dbf27e02f79$export$d1fe808976407c4c(field) {
    return $d13e0dbf27e02f79$var$isExtraField(field, [
        (0, $1f23dc9825a8e3a5$export$bda4531b1a353ad5)
    ]) && 'html' in field;
}
function $d13e0dbf27e02f79$export$da33088c7c3e5cb2(field) {
    return $d13e0dbf27e02f79$var$isExtraField(field, [
        (0, $1f23dc9825a8e3a5$export$17bb0a20b1f25353)
    ]);
}
function $d13e0dbf27e02f79$export$748f5a82c0532889(field) {
    return $d13e0dbf27e02f79$var$isExtraField(field, [
        (0, $1f23dc9825a8e3a5$export$9b9dcd4746c10184)
    ]) && field.id === (0, $5fc53.LABELS_TYPE);
}
function $d13e0dbf27e02f79$export$236190af5d6fde4c(field) {
    return $d13e0dbf27e02f79$export$d1fe808976407c4c(field) && field.id === (0, $1f23dc9825a8e3a5$export$a44cd70654f485a4);
}
function $d13e0dbf27e02f79$export$899a90d8d4afc87b(field) {
    return $d13e0dbf27e02f79$var$isExtraField(field, [
        (0, $1f23dc9825a8e3a5$export$9b9dcd4746c10184),
        (0, $1f23dc9825a8e3a5$export$110883b3780f4ea),
        (0, $1f23dc9825a8e3a5$export$bde36270f821fce6),
        (0, $1f23dc9825a8e3a5$export$8edb5204f086f2f1),
        (0, $1f23dc9825a8e3a5$export$2bff164ceff5df7e)
    ]);
}

});
const $1f23dc9825a8e3a5$export$9b9dcd4746c10184 = 'text';
const $1f23dc9825a8e3a5$export$8edb5204f086f2f1 = 'status';
const $1f23dc9825a8e3a5$export$bde36270f821fce6 = 'duration';
const $1f23dc9825a8e3a5$export$110883b3780f4ea = 'number';
const $1f23dc9825a8e3a5$export$17bb0a20b1f25353 = 'date';
const $1f23dc9825a8e3a5$export$bda4531b1a353ad5 = 'html';
const $1f23dc9825a8e3a5$export$2bff164ceff5df7e = 'url';
const $1f23dc9825a8e3a5$export$a44cd70654f485a4 = 'thumbnail';



parcelRegister("fhHy4", function(module, exports) {

$parcel$export(module.exports, "fetchIssue", () => $162bf599e41e206c$export$dcd87b70796c5c27);

var $487fd = parcelRequire("487fd");
function $162bf599e41e206c$export$dcd87b70796c5c27(boardId, issueId) {
    return (0, $487fd.default)(`/rest/greenhopper/1.0/xboard/plan/backlog/issue.json?rapidViewId=${boardId}&issueId=${issueId}`);
}

});

parcelRegister("fCYjW", function(module, exports) {

$parcel$export(module.exports, "inlineCreateIssue", () => $10ad9f4102677363$export$6a4019ebc77bfcad);

var $487fd = parcelRequire("487fd");
function $10ad9f4102677363$export$6a4019ebc77bfcad({ summary: summary, issueTypeId: issueTypeId, contexts: contexts, overrides: overrides }) {
    return (0, $487fd.default)('/rest/inline-create/1.0/issue', {
        method: 'POST',
        body: JSON.stringify({
            summary: summary,
            issueTypeId: issueTypeId,
            contexts: contexts,
            overrides: overrides
        })
    });
}

});



parcelRegister("i4Z8q", function(module, exports) {

$parcel$export(module.exports, "makeServiceContext", () => $8bf18a91ef99273b$export$47bf8333d7adacd0);

var $jG5HW = parcelRequire("jG5HW");
function $8bf18a91ef99273b$export$47bf8333d7adacd0(state) {
    return {
        boardId: (0, $jG5HW.getRapidViewId)(state),
        isCompanyManaged: (0, $jG5HW.getIsCompanyManaged)(state)
    };
}

});

parcelRegister("5Eoed", function(module, exports) {

$parcel$export(module.exports, "OPEN_MODAL", () => $e3f3ab7c36d05c39$export$d1956215992c54b);
$parcel$export(module.exports, "openModal", () => $e3f3ab7c36d05c39$export$a7f6cffb6b8ba11c);
$parcel$export(module.exports, "CLOSE_MODAL", () => $e3f3ab7c36d05c39$export$d984830de9a39518);
$parcel$export(module.exports, "closeModal", () => $e3f3ab7c36d05c39$export$3f6fecd573f3fa48);
const $e3f3ab7c36d05c39$export$d1956215992c54b = 'state.actions.modals.OPEN_MODAL';
const $e3f3ab7c36d05c39$export$a7f6cffb6b8ba11c = (payload)=>({
        type: $e3f3ab7c36d05c39$export$d1956215992c54b,
        payload: payload
    });
const $e3f3ab7c36d05c39$export$d984830de9a39518 = 'state.actions.modals.CLOSE_MODAL';
const $e3f3ab7c36d05c39$export$3f6fecd573f3fa48 = ()=>({
        type: $e3f3ab7c36d05c39$export$d984830de9a39518
    });

});

parcelRegister("gwOHY", function(module, exports) {

$parcel$export(module.exports, "SET_VERSIONS", () => $6d6a4c65ff06d5cc$export$8d55849a0d8ef0c7);
$parcel$export(module.exports, "setVersions", () => $6d6a4c65ff06d5cc$export$44737a4035599644);
$parcel$export(module.exports, "UPDATE_VERSION", () => $6d6a4c65ff06d5cc$export$c4aaf486103b8376);
$parcel$export(module.exports, "updateVersion", () => $6d6a4c65ff06d5cc$export$5652a4ac6807e581);
$parcel$export(module.exports, "REFETCH_VERSIONS", () => $6d6a4c65ff06d5cc$export$a4ef9c1f4cfa323c);
$parcel$export(module.exports, "refetchVersions", () => $6d6a4c65ff06d5cc$export$70fb16a0ad235611);
const $6d6a4c65ff06d5cc$export$8d55849a0d8ef0c7 = 'state.actions.version.SET_VERSIONS';
const $6d6a4c65ff06d5cc$export$44737a4035599644 = (payload)=>({
        type: $6d6a4c65ff06d5cc$export$8d55849a0d8ef0c7,
        payload: payload
    });
const $6d6a4c65ff06d5cc$export$c4aaf486103b8376 = 'state.actions.version.UPDATE_VERSION';
const $6d6a4c65ff06d5cc$export$5652a4ac6807e581 = (version)=>({
        type: $6d6a4c65ff06d5cc$export$c4aaf486103b8376,
        payload: {
            version: version
        }
    });
const $6d6a4c65ff06d5cc$export$a4ef9c1f4cfa323c = 'state.actions.version.REFETCH_VERSIONS';
const $6d6a4c65ff06d5cc$export$70fb16a0ad235611 = ()=>({
        type: $6d6a4c65ff06d5cc$export$a4ef9c1f4cfa323c
    });

});

parcelRegister("aU3CO", function(module, exports) {

$parcel$export(module.exports, "getInlineCreateSessionId", () => $5246fcf6b22584f7$export$12a9e7e0a7f5b591);
$parcel$export(module.exports, "getCardTypesForICC", () => $5246fcf6b22584f7$export$544c7fd474a93225);

var $dGvGJ = parcelRequire("dGvGJ");

var $g4tDr = parcelRequire("g4tDr");

var $jG5HW = parcelRequire("jG5HW");

var $74oBv = parcelRequire("74oBv");

var $9Pc1U = parcelRequire("9Pc1U");

var $e5nhF = parcelRequire("e5nhF");
const $5246fcf6b22584f7$export$1ca4cd34e6f2914c = (state)=>(0, $e5nhF.getEntities)(state).inlineCreate;
const $5246fcf6b22584f7$export$12a9e7e0a7f5b591 = (0, $dGvGJ.createSelector)([
    $5246fcf6b22584f7$export$1ca4cd34e6f2914c
], (inlineCreateState)=>inlineCreateState?.sessionId);
const $5246fcf6b22584f7$var$getInlineCreateCardTypeIds = (0, $dGvGJ.createSelector)([
    $5246fcf6b22584f7$export$1ca4cd34e6f2914c
], (inlineCreate)=>inlineCreate.cardTypeIds);
const $5246fcf6b22584f7$export$544c7fd474a93225 = (0, $dGvGJ.createSelector)([
    (0, $74oBv.getCardTypes),
    $5246fcf6b22584f7$var$getInlineCreateCardTypeIds,
    (0, $jG5HW.isCmpKanbanProject),
    (0, $9Pc1U.getShowEpicAsPanel)
], (cardTypes, cardTypeIds, isCmpKanban, showEpicAsPanel)=>cardTypes.filter((cardType)=>isCmpKanban && !showEpicAsPanel ? cardType.typeHierarchyLevel === (0, $g4tDr.EPIC_PARENT_HIERARCHY_TYPE) || cardType.typeHierarchyLevel === (0, $g4tDr.BASE_HIERARCHY_TYPE) : cardType.typeHierarchyLevel === (0, $g4tDr.BASE_HIERARCHY_TYPE)).filter((cardType)=>cardTypeIds?.includes(cardType.id)));

});

parcelRegister("9tZuw", function(module, exports) {

$parcel$export(module.exports, "SET_RICH_ACTIVE_CARD", () => $a3e6803fcd7c890e$export$4c9169a58b37875e);
$parcel$export(module.exports, "setRichActiveCard", () => $a3e6803fcd7c890e$export$64729d240866f3ef);
$parcel$export(module.exports, "SET_CARD_ID_WITH_ABOVE_ICC_OPEN", () => $a3e6803fcd7c890e$export$ec2969f9f94bf260);
$parcel$export(module.exports, "setCardIdWithAboveICCOpen", () => $a3e6803fcd7c890e$export$77d156de930b02f2);
const $a3e6803fcd7c890e$export$4c9169a58b37875e = 'state.actions.cards.rich-card.SET_RICH_ACTIVE_CARD';
const $a3e6803fcd7c890e$export$64729d240866f3ef = (cardId)=>({
        type: $a3e6803fcd7c890e$export$4c9169a58b37875e,
        payload: {
            cardId: cardId
        }
    });
const $a3e6803fcd7c890e$export$ec2969f9f94bf260 = 'state.actions.cards.rich-card.SET_CARD_ID_WITH_ABOVE_ICC_OPEN';
const $a3e6803fcd7c890e$export$77d156de930b02f2 = (cardId)=>({
        type: $a3e6803fcd7c890e$export$ec2969f9f94bf260,
        payload: {
            cardId: cardId
        }
    });

});

parcelRegister("eMLHT", function(module, exports) {

$parcel$export(module.exports, "DRAG_START", () => $cd7b4e6c2d61a9be$export$56a2165aef3d890f);
$parcel$export(module.exports, "dragStart", () => $cd7b4e6c2d61a9be$export$c34730c351bf3a09);
$parcel$export(module.exports, "DRAG_END", () => $cd7b4e6c2d61a9be$export$fc1141357993c252);
$parcel$export(module.exports, "dragEnd", () => $cd7b4e6c2d61a9be$export$5d38b0bd4bef40ba);
$parcel$export(module.exports, "BEFORE_CAPTURE", () => $cd7b4e6c2d61a9be$export$243992ddf18a3626);
$parcel$export(module.exports, "beforeCapture", () => $cd7b4e6c2d61a9be$export$f9e12102ea5efb98);
$parcel$export(module.exports, "TRANSITION_ZONE_ENTER", () => $cd7b4e6c2d61a9be$export$204c8582fbaab1b9);
$parcel$export(module.exports, "transitionZoneEnter", () => $cd7b4e6c2d61a9be$export$105dc40c43a094f8);
$parcel$export(module.exports, "TRANSITION_ZONE_LEAVE", () => $cd7b4e6c2d61a9be$export$b6bb144f1db68c2d);
$parcel$export(module.exports, "transitionZoneLeave", () => $cd7b4e6c2d61a9be$export$a9aed1d92a4d13b4);
const $cd7b4e6c2d61a9be$export$56a2165aef3d890f = 'state.actions.drag.DRAG_START';
const $cd7b4e6c2d61a9be$export$c34730c351bf3a09 = ()=>({
        type: $cd7b4e6c2d61a9be$export$56a2165aef3d890f
    });
const $cd7b4e6c2d61a9be$export$fc1141357993c252 = 'state.actions.drag.DRAG_END';
const $cd7b4e6c2d61a9be$export$5d38b0bd4bef40ba = ()=>({
        type: $cd7b4e6c2d61a9be$export$fc1141357993c252
    });
const $cd7b4e6c2d61a9be$export$243992ddf18a3626 = 'state.actions.drag.BEFORE_CAPTURE';
const $cd7b4e6c2d61a9be$export$f9e12102ea5efb98 = (sourceCardGroupType, sourceCardListId, isSubtask, sourceParentId)=>({
        type: $cd7b4e6c2d61a9be$export$243992ddf18a3626,
        payload: {
            sourceCardGroupType: sourceCardGroupType,
            sourceCardListId: sourceCardListId,
            isSubtask: isSubtask,
            sourceParentId: sourceParentId
        }
    });
const $cd7b4e6c2d61a9be$export$204c8582fbaab1b9 = 'state.actions.drag.TRANSITION_ZONE_ENTER';
const $cd7b4e6c2d61a9be$export$105dc40c43a094f8 = ()=>({
        type: $cd7b4e6c2d61a9be$export$204c8582fbaab1b9
    });
const $cd7b4e6c2d61a9be$export$b6bb144f1db68c2d = 'state.actions.drag.TRANSITION_ZONE_LEAVE';
const $cd7b4e6c2d61a9be$export$a9aed1d92a4d13b4 = ()=>({
        type: $cd7b4e6c2d61a9be$export$b6bb144f1db68c2d
    });

});


parcelRegister("kOw1j", function(module, exports) {

$parcel$export(module.exports, "cardDeleteEpic", () => $014d2de2519d2da4$export$eb4bca8cd893632);
parcelRequire("zjDln");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $guzeq = parcelRequire("guzeq");

var $3UEQx = parcelRequire("3UEQx");

var $cik5h = parcelRequire("cik5h");

var $3lZ6i = parcelRequire("3lZ6i");

var $legw4 = parcelRequire("legw4");

var $jG5HW = parcelRequire("jG5HW");
const $014d2de2519d2da4$export$eb4bca8cd893632 = (getLocation, push)=>(action$, store)=>action$.ofType((0, $legw4.CARD_DELETE_REQUEST)).mergeMap((action)=>{
            const { payload: { cardId: cardId }, meta: { optimistic: { id: optimisticId } } } = action;
            const state = store.getState();
            const baseUrl = (0, $jG5HW.getBaseUrl)(state);
            push((0, $cik5h.removeSelectedIssueFromUrl)(getLocation()));
            return (0, $3UEQx.default)(baseUrl, String(cardId)).flatMap(()=>{
                const actions = [
                    (0, $legw4.cardDeleteSuccess)(cardId, optimisticId)
                ];
                return (0, $kVLXA.Observable).from(actions);
            }).catch(()=>(0, $kVLXA.Observable).from([
                    (0, $legw4.cardDeleteFailure)(cardId, optimisticId),
                    (0, $3lZ6i.refreshDataRequest)((0, $guzeq.REFRESH_SOURCE_FAILURE))
                ]));
        });

});
parcelRegister("3UEQx", function(module, exports) {

$parcel$export(module.exports, "default", () => $eac278b6b027a840$export$2e2bcd8739ae039);

var $6iJbJ = parcelRequire("6iJbJ");
const $eac278b6b027a840$var$MUTATION_NAME = 'BacklogDeleteCard';
const $eac278b6b027a840$export$e904bac7f43ed94a = ()=>`mutation ${$eac278b6b027a840$var$MUTATION_NAME} ($issueId: ID!) {
        deleteCard(issueId: $issueId) {
            success
        }
    }`;
const $eac278b6b027a840$var$cardDeleteGraphql = (baseUrl, issueId)=>// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
    (0, $6iJbJ.mutation$)(baseUrl, $eac278b6b027a840$var$MUTATION_NAME, $eac278b6b027a840$export$e904bac7f43ed94a(), {
        issueId: issueId
    });
var $eac278b6b027a840$export$2e2bcd8739ae039 = $eac278b6b027a840$var$cardDeleteGraphql;

});

parcelRegister("legw4", function(module, exports) {

$parcel$export(module.exports, "CARD_DELETE_REQUEST", () => $25b07de62d83e2e6$export$9bc1d1c298c8f5af);
$parcel$export(module.exports, "cardDeleteRequest", () => $25b07de62d83e2e6$export$d2ea563d7459b747);
$parcel$export(module.exports, "CARD_DELETE_SUCCESS", () => $25b07de62d83e2e6$export$c9235af922e153a1);
$parcel$export(module.exports, "cardDeleteSuccess", () => $25b07de62d83e2e6$export$abf29851b85a5dc);
$parcel$export(module.exports, "CARD_DELETE_FAILURE", () => $25b07de62d83e2e6$export$229ed28ef1c0b98);
$parcel$export(module.exports, "cardDeleteFailure", () => $25b07de62d83e2e6$export$14995a1d9fdd27aa);
$parcel$export(module.exports, "CARD_DELETE", () => $25b07de62d83e2e6$export$b82590935cfab60f);
$parcel$export(module.exports, "cardDelete", () => $25b07de62d83e2e6$export$ba9d764de574147c);

var $c0irb = parcelRequire("c0irb");
const $25b07de62d83e2e6$export$9bc1d1c298c8f5af = 'state.actions.cards.delete.CARD_DELETE_REQUEST';
const $25b07de62d83e2e6$export$d2ea563d7459b747 = (payload)=>({
        type: $25b07de62d83e2e6$export$9bc1d1c298c8f5af,
        payload: payload,
        meta: {
            ...(0, $c0irb.beginOptimisticUiMeta)()
        }
    });
const $25b07de62d83e2e6$export$c9235af922e153a1 = 'state.actions.cards.delete.CARD_DELETE_SUCCESS';
const $25b07de62d83e2e6$export$abf29851b85a5dc = (cardId, optimisticId)=>({
        type: $25b07de62d83e2e6$export$c9235af922e153a1,
        payload: {
            cardId: cardId
        },
        meta: (0, $c0irb.commitOptimisticUiMeta)(optimisticId)
    });
const $25b07de62d83e2e6$export$229ed28ef1c0b98 = 'state.actions.cards.delete.CARD_DELETE_FAILURE';
const $25b07de62d83e2e6$export$14995a1d9fdd27aa = (cardId, optimisticId)=>({
        type: $25b07de62d83e2e6$export$229ed28ef1c0b98,
        payload: {
            cardId: cardId
        },
        meta: (0, $c0irb.revertOptimisticUiWithFlagMeta)(optimisticId)
    });
const $25b07de62d83e2e6$export$b82590935cfab60f = 'state.actions.cards.delete.CARD_DELETE';
const $25b07de62d83e2e6$export$ba9d764de574147c = (cardId)=>({
        type: $25b07de62d83e2e6$export$b82590935cfab60f,
        payload: {
            cardId: cardId
        }
    });

});


parcelRegister("5o0zk", function(module, exports) {

$parcel$export(module.exports, "cardGroupToggleEpic", () => $e1610f16a32f448c$export$dcdf634c78f06f28);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $3FUwR = parcelRequire("3FUwR");

var $a7yHf = parcelRequire("a7yHf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");
const $e1610f16a32f448c$export$dcdf634c78f06f28 = (action$, store)=>action$.ofType((0, $a7yHf.CARD_GROUP_TOGGLE), (0, $a7yHf.COLLAPSE_ALL_CARD_GROUPS), (0, $a7yHf.SET_EXPANDED_CARD_GROUP)).flatMap(()=>{
        const state = store.getState();
        const expandedCardGroups = (0, $dGljH.getExpandedCardGroups)(state);
        (0, $3FUwR.setBacklogCardGroupSettings)(Number((0, $jG5HW.getRapidViewId)(state)), expandedCardGroups);
        return (0, $kVLXA.Observable).empty();
    });

});
parcelRegister("3FUwR", function(module, exports) {

$parcel$export(module.exports, "getDetailViewWidthRatio", () => $adc0c55af25e35a9$export$5a9c556da9744b1b);
$parcel$export(module.exports, "setDetailViewWidthRatio", () => $adc0c55af25e35a9$export$d194f7c4bdc33538);
$parcel$export(module.exports, "getBacklogSettings", () => $adc0c55af25e35a9$export$385952056bbb1deb);
$parcel$export(module.exports, "setBacklogSettings", () => $adc0c55af25e35a9$export$6ddb49680d7ce77d);
$parcel$export(module.exports, "getPanelStateOld", () => $adc0c55af25e35a9$export$87f4e6f908d51646);
$parcel$export(module.exports, "getPanelState", () => $adc0c55af25e35a9$export$6f4f3781f70858b9);
$parcel$export(module.exports, "setPanelStateOld", () => $adc0c55af25e35a9$export$58bb10ae80996d55);
$parcel$export(module.exports, "setPanelState", () => $adc0c55af25e35a9$export$5554b6f93f40abe5);
$parcel$export(module.exports, "unsetPanelState", () => $adc0c55af25e35a9$export$48192827b67d2f17);
$parcel$export(module.exports, "getBacklogCardGroupSettings", () => $adc0c55af25e35a9$export$74b19271af6b55e5);
$parcel$export(module.exports, "setBacklogCardGroupSettings", () => $adc0c55af25e35a9$export$d5b7ae0d62d4ef81);
$parcel$export(module.exports, "getWorkloadSubtaskSettings", () => $adc0c55af25e35a9$export$b1494519a5c8386e);
$parcel$export(module.exports, "setWorkloadSubtaskSettings", () => $adc0c55af25e35a9$export$fc1a0f95945c8afd);

var $hqTkp = parcelRequire("hqTkp");

var $bSSG7 = parcelRequire("bSSG7");
const $adc0c55af25e35a9$var$localStorage = (0, $bSSG7.createLocalStorageProvider)('backlog');
const $adc0c55af25e35a9$var$DETAIL_VIEW_WIDTH_RATIO = 'gh.detailViewWidth';
const $adc0c55af25e35a9$var$BACKLOG_SETTINGS_PREFIX = 'gh.backlogSettings.';
const $adc0c55af25e35a9$var$BACKLOG_CARDGROUP_SETTINGS_PREFIX = 'gh.backlogCardGroupSettings.';
const $adc0c55af25e35a9$var$PANEL_STATE = 'panel-state';
const $adc0c55af25e35a9$var$WORKLOAD_MODAL_SUBTASKS = 'gh.workloadModal.subtasks';
const $adc0c55af25e35a9$export$5a9c556da9744b1b = ()=>{
    const value = $adc0c55af25e35a9$var$localStorage.get($adc0c55af25e35a9$var$DETAIL_VIEW_WIDTH_RATIO);
    return value ? Number(value) : 0;
};
const $adc0c55af25e35a9$export$d194f7c4bdc33538 = (ratio)=>$adc0c55af25e35a9$var$localStorage.set($adc0c55af25e35a9$var$DETAIL_VIEW_WIDTH_RATIO, ratio);
const $adc0c55af25e35a9$export$385952056bbb1deb = (boardId)=>{
    const data = $adc0c55af25e35a9$var$localStorage.get(`${$adc0c55af25e35a9$var$BACKLOG_SETTINGS_PREFIX}${boardId}`);
    if (!data || !data.collapsedCardLists) return {};
    return data;
};
const $adc0c55af25e35a9$export$6ddb49680d7ce77d = (boardId, settings)=>{
    $adc0c55af25e35a9$var$localStorage.set(`${$adc0c55af25e35a9$var$BACKLOG_SETTINGS_PREFIX}${boardId}`, settings);
};
const $adc0c55af25e35a9$export$87f4e6f908d51646 = ()=>$adc0c55af25e35a9$var$localStorage.get($adc0c55af25e35a9$var$PANEL_STATE);
const $adc0c55af25e35a9$export$6f4f3781f70858b9 = (boardId)=>$adc0c55af25e35a9$var$localStorage.get(`${$adc0c55af25e35a9$var$PANEL_STATE}-${boardId}`);
const $adc0c55af25e35a9$export$58bb10ae80996d55 = (panelState)=>$adc0c55af25e35a9$var$localStorage.set($adc0c55af25e35a9$var$PANEL_STATE, panelState);
const $adc0c55af25e35a9$export$5554b6f93f40abe5 = (panelState, boardId)=>{
    const currentPanelState = $adc0c55af25e35a9$export$6f4f3781f70858b9(boardId) || [];
    if (!currentPanelState.includes(panelState)) $adc0c55af25e35a9$var$localStorage.set(`${$adc0c55af25e35a9$var$PANEL_STATE}-${boardId}`, [
        ...currentPanelState,
        panelState
    ]);
};
const $adc0c55af25e35a9$export$b31b38479befe75d = (panels, boardId)=>{
    const openPanels = Object.entries(panels).filter(([_, value])=>value === true).map(([key])=>key);
    $adc0c55af25e35a9$var$localStorage.set(`${$adc0c55af25e35a9$var$PANEL_STATE}-${boardId}`, openPanels);
};
const $adc0c55af25e35a9$export$48192827b67d2f17 = (panelState, boardId)=>{
    const currentPanelState = $adc0c55af25e35a9$export$6f4f3781f70858b9(boardId);
    if (currentPanelState?.includes(panelState)) $adc0c55af25e35a9$var$localStorage.set(`${$adc0c55af25e35a9$var$PANEL_STATE}-${boardId}`, (0, (/*@__PURE__*/$parcel$interopDefault($hqTkp)))(currentPanelState, panelState));
};
const $adc0c55af25e35a9$export$74b19271af6b55e5 = (boardId)=>{
    const data = $adc0c55af25e35a9$var$localStorage.get(`${$adc0c55af25e35a9$var$BACKLOG_CARDGROUP_SETTINGS_PREFIX}${boardId}`);
    return data ?? {};
};
const $adc0c55af25e35a9$export$d5b7ae0d62d4ef81 = (boardId, settings)=>{
    $adc0c55af25e35a9$var$localStorage.set(`${$adc0c55af25e35a9$var$BACKLOG_CARDGROUP_SETTINGS_PREFIX}${boardId}`, settings);
};
const $adc0c55af25e35a9$export$b1494519a5c8386e = ()=>{
    const data = $adc0c55af25e35a9$var$localStorage.get($adc0c55af25e35a9$var$WORKLOAD_MODAL_SUBTASKS);
    return !!data;
};
const $adc0c55af25e35a9$export$fc1a0f95945c8afd = (includeSubtasks)=>{
    $adc0c55af25e35a9$var$localStorage.set($adc0c55af25e35a9$var$WORKLOAD_MODAL_SUBTASKS, includeSubtasks);
};

});

parcelRegister("a7yHf", function(module, exports) {

$parcel$export(module.exports, "CARD_LIST_TOGGLE", () => $ef75a116916584d7$export$8ac407f033388640);
$parcel$export(module.exports, "cardListToggle", () => $ef75a116916584d7$export$90d6f3c77a83064c);
$parcel$export(module.exports, "SET_COLLAPSED_CARD_LIST", () => $ef75a116916584d7$export$8e3dbeb7df2e2eed);
$parcel$export(module.exports, "setCollapsedCardLists", () => $ef75a116916584d7$export$5f2a6b9a0552b438);
$parcel$export(module.exports, "CARD_LISTS_DISABLE", () => $ef75a116916584d7$export$cc7cd3c4009760cc);
$parcel$export(module.exports, "cardListsDisable", () => $ef75a116916584d7$export$3bb589b09264f63f);
$parcel$export(module.exports, "CARD_LISTS_ENABLE_ALL", () => $ef75a116916584d7$export$649d537a55101566);
$parcel$export(module.exports, "cardListsEnableAll", () => $ef75a116916584d7$export$f44d80a86eadf7f4);
$parcel$export(module.exports, "CARD_LIST_DRAG_START", () => $ef75a116916584d7$export$dc86559f09e710b9);
$parcel$export(module.exports, "cardListDragStart", () => $ef75a116916584d7$export$87075c8b80f899ee);
$parcel$export(module.exports, "CARD_LIST_DRAG_END", () => $ef75a116916584d7$export$39a50360ed362605);
$parcel$export(module.exports, "cardListDragEnd", () => $ef75a116916584d7$export$e6bf5fbe83cd7d74);
$parcel$export(module.exports, "CARD_GROUP_TOGGLE", () => $ef75a116916584d7$export$bde12efd87a4ac85);
$parcel$export(module.exports, "cardGroupToggle", () => $ef75a116916584d7$export$92a3d8e003e4f107);
$parcel$export(module.exports, "SET_COLLAPSED_CARD_GROUP", () => $ef75a116916584d7$export$9da147a1292f7381);
$parcel$export(module.exports, "SET_EXPANDED_CARD_GROUP", () => $ef75a116916584d7$export$3f7371c8d6ee730e);
$parcel$export(module.exports, "setCollapsedCardGroups", () => $ef75a116916584d7$export$b56fc1f894629222);
$parcel$export(module.exports, "setExpandedCardGroups", () => $ef75a116916584d7$export$7ff65c0e4fbb1fb);
$parcel$export(module.exports, "CLEAR_COLLAPSED_CARD_GROUP", () => $ef75a116916584d7$export$f79940d7e9a921f6);
$parcel$export(module.exports, "CLEAR_EXPANDED_CARD_GROUP", () => $ef75a116916584d7$export$a93c0bd80b95451c);
$parcel$export(module.exports, "clearExpandedCardGroup", () => $ef75a116916584d7$export$f3ccf76393691844);
$parcel$export(module.exports, "COLLAPSE_ALL_CARD_GROUPS", () => $ef75a116916584d7$export$a081f6cfebf37017);
$parcel$export(module.exports, "collapseAllCardGroups", () => $ef75a116916584d7$export$5f921ba0e1020c03);
const $ef75a116916584d7$export$8ac407f033388640 = 'state.actions.card-list.CARD_LIST_TOGGLE';
const $ef75a116916584d7$export$90d6f3c77a83064c = (cardListId)=>({
        type: $ef75a116916584d7$export$8ac407f033388640,
        payload: {
            cardListId: cardListId
        }
    });
const $ef75a116916584d7$export$8e3dbeb7df2e2eed = 'state.actions.card-list.SET_COLLAPSED_CARD_LIST';
const $ef75a116916584d7$export$5f2a6b9a0552b438 = (cardListIds)=>({
        type: $ef75a116916584d7$export$8e3dbeb7df2e2eed,
        payload: {
            cardListIds: cardListIds
        }
    });
const $ef75a116916584d7$export$cc7cd3c4009760cc = 'state.actions.card-list.CARD_LISTS_DISABLE';
const $ef75a116916584d7$export$3bb589b09264f63f = (cardListIds)=>({
        type: $ef75a116916584d7$export$cc7cd3c4009760cc,
        payload: {
            cardListIds: cardListIds
        }
    });
const $ef75a116916584d7$export$649d537a55101566 = 'state.actions.card-list.CARD_LISTS_ENABLE_ALL';
const $ef75a116916584d7$export$f44d80a86eadf7f4 = ()=>({
        type: $ef75a116916584d7$export$649d537a55101566
    });
const $ef75a116916584d7$export$dc86559f09e710b9 = 'state.actions.card-list.DRAG_START';
const $ef75a116916584d7$export$87075c8b80f899ee = (cardListIds, sourceCardListId, sourceCardGroupId)=>({
        type: $ef75a116916584d7$export$dc86559f09e710b9,
        payload: {
            cardListIds: cardListIds,
            sourceCardListId: sourceCardListId,
            sourceCardGroupId: sourceCardGroupId
        }
    });
const $ef75a116916584d7$export$39a50360ed362605 = 'state.actions.card-list.DRAG_END';
const $ef75a116916584d7$export$e6bf5fbe83cd7d74 = ()=>({
        type: $ef75a116916584d7$export$39a50360ed362605
    });
const $ef75a116916584d7$export$bde12efd87a4ac85 = 'state.actions.card-list.CARD_GROUP_TOGGLE';
const $ef75a116916584d7$export$92a3d8e003e4f107 = (parentId)=>({
        type: $ef75a116916584d7$export$bde12efd87a4ac85,
        payload: {
            parentId: parentId
        }
    });
const $ef75a116916584d7$export$9da147a1292f7381 = 'state.actions.card-list.SET_COLLAPSED_CARD_GROUP';
const $ef75a116916584d7$export$3f7371c8d6ee730e = 'state.actions.card-list.SET_EXPANDED_CARD_GROUP';
const $ef75a116916584d7$export$b56fc1f894629222 = (parentIds)=>({
        type: $ef75a116916584d7$export$9da147a1292f7381,
        payload: {
            parentIds: parentIds
        }
    });
const $ef75a116916584d7$export$7ff65c0e4fbb1fb = (parentIds)=>({
        type: $ef75a116916584d7$export$3f7371c8d6ee730e,
        payload: {
            parentIds: parentIds
        }
    });
const $ef75a116916584d7$export$f79940d7e9a921f6 = 'state.actions.card-list.CLEAR_COLLAPSED_CARD_GROUP';
const $ef75a116916584d7$export$a93c0bd80b95451c = 'state.actions.card-list.CLEAR_EXPANDED_CARD_GROUP';
const $ef75a116916584d7$export$2847fdebb2aad4f5 = (parentId)=>({
        type: $ef75a116916584d7$export$f79940d7e9a921f6,
        payload: {
            parentId: parentId
        }
    });
const $ef75a116916584d7$export$f3ccf76393691844 = (parentId)=>({
        type: $ef75a116916584d7$export$a93c0bd80b95451c,
        payload: {
            parentId: parentId
        }
    });
const $ef75a116916584d7$export$a081f6cfebf37017 = 'state.actions.card-list.COLLAPSE_ALL_CARD_GROUPS';
const $ef75a116916584d7$export$5f921ba0e1020c03 = ()=>({
        type: $ef75a116916584d7$export$a081f6cfebf37017
    });

});


parcelRegister("ntGXV", function(module, exports) {

$parcel$export(module.exports, "cardListToggleEpic", () => $0ca27dd893a538ce$export$35eb239dac6e0c31);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $3FUwR = parcelRequire("3FUwR");

var $a7yHf = parcelRequire("a7yHf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");
const $0ca27dd893a538ce$export$35eb239dac6e0c31 = (action$, store)=>action$.ofType((0, $a7yHf.CARD_LIST_TOGGLE)).flatMap(()=>{
        const state = store.getState();
        const collapsedCardLists = (0, $dGljH.getCollapsedCardLists)(state);
        (0, $3FUwR.setBacklogSettings)(Number((0, $jG5HW.getRapidViewId)(state)), {
            collapsedCardLists: collapsedCardLists
        });
        return (0, $kVLXA.Observable).empty();
    });

});

parcelRegister("3EYDb", function(module, exports) {

$parcel$export(module.exports, "cardPostCreateEpic", () => $608a6ccdf0dfdb54$export$bae9f8e0951e31da);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $hf5c2 = parcelRequire("hf5c2");

var $dGljH = parcelRequire("dGljH");
const $608a6ccdf0dfdb54$var$getActiveCustomFilterIds = (state)=>state.ui.filters.CUSTOM_FILTER || [];
const $608a6ccdf0dfdb54$var$isCustomFiltersActive = (state)=>$608a6ccdf0dfdb54$var$getActiveCustomFilterIds(state).length > 0;
const $608a6ccdf0dfdb54$export$bae9f8e0951e31da = (action$, store)=>action$.ofType((0, $hf5c2.CARD_CREATE_SUCCESS)).mergeMap((action)=>{
        const state = store.getState();
        const visibleCardIds = (0, $dGljH.makeOrderedVisibleCardIdsForCardList)(state)(action.payload.listId);
        if (!visibleCardIds.includes(action.payload.card.id)) {
            // don't show this flag here if custom filters are active,
            // we'll show it after the refiltering succeeds
            if (!$608a6ccdf0dfdb54$var$isCustomFiltersActive(state)) return (0, $kVLXA.Observable).of((0, $hf5c2.cardCreateFilteredV2)([
                action.payload.card.id
            ]));
        }
        return (0, $kVLXA.Observable).empty();
    });

});

parcelRegister("hHUaf", function(module, exports) {

$parcel$export(module.exports, "cardRankAfterGlobalIssueCreateEpic", () => $3e6c86d4e1aab4ec$export$40e733b396c30c9b);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("1oQta");
parcelRequire("6hSeW");
parcelRequire("6cbqE");
parcelRequire("7mHDu");
parcelRequire("fPS7b");

var $guzeq = parcelRequire("guzeq");

var $3lZ6i = parcelRequire("3lZ6i");

var $hf5c2 = parcelRequire("hf5c2");

var $6GNN7 = parcelRequire("6GNN7");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");
const $3e6c86d4e1aab4ec$export$40e733b396c30c9b = (action$, store, dependencies)=>action$.ofType((0, $hf5c2.CARD_CREATE_GLOBAL)).switchMap((cardCreateGlobalAction)=>{
        const state = store.getState();
        const lastSelectedCardId = (0, $dGljH.getLastSelectedCard)(state);
        const cardMoveDisabled = (0, $jG5HW.isCardMoveDisabled)(state);
        const listId = lastSelectedCardId && (0, $dGljH.makeGetCardListIdByCardId)(state)(lastSelectedCardId);
        // We should not rank created issues from GIC when:
        // - there is no selected card
        // - the board is not ordered by rank (this will also filter out TMP projects)
        // - the card is not part of any card list
        // - the card is not on `BACKLOG` card list
        if (!lastSelectedCardId || cardMoveDisabled || !listId || listId !== (0, $guzeq.BACKLOG)) return (0, $kVLXA.Observable).empty();
        const { payload: { globalIssues: globalIssues } } = cardCreateGlobalAction;
        const analyticsEvent = dependencies && dependencies.createAnalyticsEvent ? dependencies.createAnalyticsEvent({}) : {};
        return action$.ofType((0, $3lZ6i.SET_APP_DATA)).filter(()=>{
            const cards = (0, $dGljH.getCards)(store.getState());
            return globalIssues.every(({ issueId: issueId })=>cards[issueId]);
        }).take(1).flatMap(()=>{
            const cardIds = globalIssues.map((createdIssue)=>parseInt(createdIssue.issueId, 10));
            return (0, $kVLXA.Observable).of((0, $6GNN7.cardsMoveRequest)({
                cardIds: cardIds,
                cardListId: listId,
                isBetweenLists: false,
                beforeCardId: null,
                afterCardId: lastSelectedCardId
            }, analyticsEvent));
        });
    });

});

parcelRegister("jQmfK", function(module, exports) {

$parcel$export(module.exports, "cardRefreshEpic", () => $93cf125363aaffce$export$343b49279bcad83d);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $2YZCu = parcelRequire("2YZCu");

var $kBFd5 = parcelRequire("kBFd5");

var $i4Z8q = parcelRequire("i4Z8q");

var $fdAim = parcelRequire("fdAim");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $fmuR9 = parcelRequire("fmuR9");
const $93cf125363aaffce$var$getRefreshCardId = (action, state)=>{
    const { payload: { cardId: cardId } } = action;
    if (cardId) return cardId;
    const detailViewData = (0, $dGljH.getDetailViewData)(state);
    if (detailViewData) return detailViewData.cardId;
    return null;
};
const $93cf125363aaffce$export$343b49279bcad83d = (action$, store)=>action$.ofType((0, $fdAim.CARD_REFRESH_REQUEST)).flatMap((action)=>{
        const state = store.getState();
        const cardId = $93cf125363aaffce$var$getRefreshCardId(action, state);
        const issueParents = (0, $fmuR9.getIssueParents)(state);
        const projectId = (0, $jG5HW.projectIdSelector)(state);
        const parents = (0, $fmuR9.issueParentsSelector)(state);
        /** TODO: issueParents check part below to be removed WHEN
		 * Swag supports fetching epic level issues OR
		 * FE updates backlog optimistically (in redux store) instead of relying on refetching issues via GraphQL
		 */ if (!cardId || issueParents[String(cardId)]) return (0, $kVLXA.Observable).empty();
        const serviceContext = (0, $i4Z8q.makeServiceContext)(state);
        return (0, $kBFd5.cardLoadService)(serviceContext, cardId, projectId, parents).map((card)=>(0, $fdAim.cardRefreshSuccess)(card)).catch((error)=>{
            (0, $2YZCu.default).safeErrorWithoutCustomerData('backlog.card-refresh-graphql.failure', 'Failed to refresh issue', error);
            return (0, $kVLXA.Observable).empty();
        });
    });

});
parcelRegister("kBFd5", function(module, exports) {

$parcel$export(module.exports, "cardLoadService", () => $2348e1764f321cfa$export$77afcec7b8f1f966);
parcelRequire("d0pqD");

var $3vPnu = parcelRequire("3vPnu");

var $7nLcW = parcelRequire("7nLcW");

var $fhHy4 = parcelRequire("fhHy4");

var $4EjDu = parcelRequire("4EjDu");
function $2348e1764f321cfa$export$77afcec7b8f1f966(serviceContext, cardId, projectId, parents) {
    if (serviceContext.isCompanyManaged) return (0, $fhHy4.fetchIssue)(serviceContext.boardId, cardId).map((0, $3vPnu.transformCard));
    return (0, $7nLcW.default)('', serviceContext.boardId, cardId).map((cardData)=>(0, $4EjDu.cardTransformer)(cardData, projectId, parents));
}

});
parcelRegister("7nLcW", function(module, exports) {

$parcel$export(module.exports, "default", () => $fca25373e5ee2ca6$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $cBLvH = parcelRequire("cBLvH");
const $fca25373e5ee2ca6$var$cardDataOperationName = 'BacklogCardQuery';
const $fca25373e5ee2ca6$export$71eec30d9db46a56 = ()=>`
    query ${$fca25373e5ee2ca6$var$cardDataOperationName} ($boardId: ID!, $cardId: ID!) {
        boardScope(boardId: $boardId) {
            cards(cardIds: [$cardId]) {
                id
                issue {
                    id
                    key
                    summary
                    labels
                    type {
                        id
                        name
                        iconUrl
                    }
                    status {
                        id
                        name
                        category
                    }
                    assignee {
                        accountId
                        displayName
                        avatarUrl
                    }
                }
                flagged
                done
                parentId
                fixVersions
                estimate {
                    storyPoints
                    originalEstimate {
                        value
                        valueAsText
                    }
                }
                childIssuesMetadata {
                    complete
                    total
                }
                priority {
                    name
                    iconUrl
                }
                dueDate
            }
        }
    }
`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fca25373e5ee2ca6$export$2e2bcd8739ae039 = (baseUrl, boardId, cardId)=>(0, $cBLvH.query$)(baseUrl, $fca25373e5ee2ca6$var$cardDataOperationName, $fca25373e5ee2ca6$export$71eec30d9db46a56(), {
        boardId: boardId,
        cardId: cardId
    }).flatMap((data)=>// @ts-expect-error - TS2571 - Object is of type 'unknown'.
        (0, $kVLXA.Observable).of(data.boardScope.cards[0]));

});

parcelRegister("4EjDu", function(module, exports) {

$parcel$export(module.exports, "cardTransformer", () => $be43b450a4c183c9$export$c44fc4642496cd94);
$parcel$export(module.exports, "default", () => $be43b450a4c183c9$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $hGgHi = parcelRequire("hGgHi");

var $kGsr8 = parcelRequire("kGsr8");

var $dMEgP = parcelRequire("dMEgP");

var $sLb2Q = parcelRequire("sLb2Q");

var $4R6GH = parcelRequire("4R6GH");

var $g4tDr = parcelRequire("g4tDr");



var $f01qr = parcelRequire("f01qr");


var $guzeq = parcelRequire("guzeq");


var $8hVbJ = parcelRequire("8hVbJ");
const $be43b450a4c183c9$var$backlogList = (0, $7uUwQ.freeze)({
    id: (0, $guzeq.BACKLOG),
    type: (0, $guzeq.BACKLOG),
    name: 'Backlog',
    issueListKey: null
});
const $be43b450a4c183c9$var$isFeatureEnabled = (features, featureKey)=>(features || []).some(({ key: key, status: status })=>key === featureKey && status === (0, $0b986b66d9bedfde$export$e927a5d1b72f0b68));
const $be43b450a4c183c9$var$isEstimationFeatureEnabled = (features)=>$be43b450a4c183c9$var$isFeatureEnabled(features, (0, $0b986b66d9bedfde$export$4181c6622414bfdf));
const $be43b450a4c183c9$var$isVersionsFeatureEnabled = (features)=>$be43b450a4c183c9$var$isFeatureEnabled(features, (0, $0b986b66d9bedfde$export$173708eb8a9ba955));
const $be43b450a4c183c9$export$64e7b2d3af76d9e6 = (features)=>$be43b450a4c183c9$var$isFeatureEnabled(features, (0, $0b986b66d9bedfde$export$4279f6f79febea0a));
const $be43b450a4c183c9$var$isBacklogFeatureEnabled = (features)=>$be43b450a4c183c9$var$isFeatureEnabled(features, (0, $guzeq.BACKLOG));
const $be43b450a4c183c9$var$assigneeTransformer = ({ accountId: accountId, displayName: displayName, avatarUrl: avatarUrl })=>({
        id: accountId,
        displayName: displayName,
        avatarUrl: avatarUrl
    });
const $be43b450a4c183c9$var$parentTransform = (parentId, issueParents)=>{
    if (!parentId) return null;
    return issueParents.find((parent)=>parent.id === parentId) ?? null;
};
const $be43b450a4c183c9$export$c44fc4642496cd94 = ({ id: id, issue: { key: key, type: type, summary: summary, labels: labels, status: status, assignee: assignee }, done: done, flagged: flagged, parentId: parentId, priority: priority, dueDate: dueDate, estimate: estimate, childIssuesMetadata: childIssuesMetadata, fixVersions: fixVersions }, projectId, issueParents)=>({
        summary: summary,
        id: Number(id),
        key: key,
        labels: labels,
        assignee: assignee ? $be43b450a4c183c9$var$assigneeTransformer(assignee) : null,
        icon: type.iconUrl,
        isDone: done,
        isFlagged: flagged,
        typeId: Number(type.id),
        issueUrl: `/browse/${key}`,
        statusId: status.id,
        parentId: parentId || '' ? Number(parentId) : null,
        priority: priority || null,
        dueDate: dueDate || '' || null,
        estimate: (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(estimate) ? null : {
            ...estimate,
            timeRemainingEstimate: null
        },
        numCompleteChildren: childIssuesMetadata?.complete || 0,
        numTotalChildren: childIssuesMetadata?.total || 0,
        fixVersions: fixVersions,
        projectId: Number(projectId),
        issueTypeName: type.name,
        parent: (0, $4R6GH.fg)('jsw-backlog-parent-field-render') ? $be43b450a4c183c9$var$parentTransform(parentId, issueParents) : null
    });
const $be43b450a4c183c9$var$cardTypesTransformer = (issueTypes)=>issueTypes.reduce((baseLevelCardTypes, { hierarchyLevelType: hierarchyLevelType, id: id, ...issueType })=>{
        if (hierarchyLevelType === (0, $g4tDr.BASE_HIERARCHY_TYPE)) baseLevelCardTypes.push({
            id: Number(id),
            typeHierarchyLevel: hierarchyLevelType,
            ...issueType
        });
        return baseLevelCardTypes;
    }, []);
const $be43b450a4c183c9$var$storyPointFieldIdTransformer = (availableEstimation)=>{
    const storyPointId = availableEstimation.find(({ statisticFieldId: statisticFieldId })=>statisticFieldId !== (0, $guzeq.ORIGINAL_ESTIMATE_FIELD_ID) && statisticFieldId !== (0, $guzeq.ISSUE_COUNT_ID))?.statisticFieldId || '';
    return storyPointId.replace((0, $guzeq.ESTIMATION_TYPE_ID_PREFIX), '') || null;
};
const $be43b450a4c183c9$var$getBacklogStrategy = (features)=>{
    if (!$be43b450a4c183c9$var$isBacklogFeatureEnabled(features)) return 0, $guzeq.NONE;
    if ($be43b450a4c183c9$export$64e7b2d3af76d9e6(features)) return 0, $guzeq.SPRINT;
    return 0, $guzeq.ISSUE_LIST;
};
const $be43b450a4c183c9$export$69760b7e76c533f9 = ({ jira: { timeTrackingOptions: timeTrackingOptions }, boardScope: { board: { rankCustomFieldId: rankCustomFieldId }, projectLocation: { name: name, features: projectFeatures }, currentUser: { permissions: permissions }, features: features, estimation: estimation, backlog: { requestColumnMigration: requestColumnMigration } } })=>{
    const transformedConfig = {
        rankCustomFieldId: Number(rankCustomFieldId),
        requestColumnMigration: requestColumnMigration,
        name: name,
        permissions: {
            [(0, $a33d0dff7e784665$export$d765836bd761b2ee)]: permissions.includes((0, $guzeq.MANAGE_SPRINT)),
            [(0, $a33d0dff7e784665$export$526c94c551c00291)]: permissions.includes((0, $guzeq.CREATE_ISSUE)),
            [(0, $a33d0dff7e784665$export$8a1ecb9983951227)]: permissions.includes((0, $guzeq.EDIT_ISSUE)),
            [(0, $a33d0dff7e784665$export$b35e3ebf2c83a499)]: permissions.includes((0, $guzeq.EDIT_BOARD_CONFIG)),
            [(0, $e525e6c25695c9df$export$e6bcada406923d66)]: permissions.includes((0, $guzeq.ARCHIVE_ISSUE))
        },
        version: {
            isVersionsFeatureEnabled: $be43b450a4c183c9$var$isVersionsFeatureEnabled(projectFeatures)
        },
        allFeatures: features,
        backlogStrategy: $be43b450a4c183c9$var$getBacklogStrategy(features),
        storyPointFieldId: $be43b450a4c183c9$var$storyPointFieldIdTransformer(estimation.available),
        timeTrackingOptions: timeTrackingOptions
    };
    return transformedConfig;
};
const $be43b450a4c183c9$export$4055277b2f3e701f = ({ id: id, name: name, goal: goal, startDate: startDate, endDate: endDate, daysRemaining: daysRemaining, sprintState: sprintState }, canUpdateSprint)=>({
        id: String(id),
        name: name,
        type: (0, $guzeq.SPRINT),
        issueListKey: null,
        sprintData: {
            goal: goal || '',
            startDate: startDate,
            endDate: endDate,
            daysRemaining: daysRemaining,
            state: sprintState,
            canUpdateSprint: canUpdateSprint
        }
    });
const $be43b450a4c183c9$export$9a5176a1a22928d9 = (issueParents)=>issueParents.reduce((issueParentsEntityState, issueParent)=>Object.assign(issueParentsEntityState, {
            [issueParent.id]: issueParent
        }), {});
const $be43b450a4c183c9$export$f96dae738e4d5e19 = (isEstimationEnabled, estimation)=>{
    const estimateFieldKey = estimation.current.customFieldId || '';
    if (isEstimationEnabled && estimateFieldKey) return estimateFieldKey === (0, $e9be48d6d2c01760$export$5fbd3b15555b9ef2) ? (0, $guzeq.ORIGINAL_ESTIMATE) : (0, $guzeq.STORY_POINTS);
    return 0, $guzeq.ISSUE_COUNT;
};
const $be43b450a4c183c9$export$6b3f2edb57acc06e = (isEstimationEnabled, estimation)=>isEstimationEnabled ? estimation.current.customFieldId : null;
const $be43b450a4c183c9$export$3bf59b7c6d7e91d9 = (features, estimation)=>{
    const isEstimationEnabled = $be43b450a4c183c9$var$isEstimationFeatureEnabled(features);
    return {
        isEstimationFeatureEnabled: isEstimationEnabled,
        estimationType: $be43b450a4c183c9$export$f96dae738e4d5e19(isEstimationEnabled, estimation),
        estimationFieldId: $be43b450a4c183c9$export$6b3f2edb57acc06e(isEstimationEnabled, estimation),
        name: ''
    };
};
const $be43b450a4c183c9$export$cfeec69489a32e7d = (allCards)=>({
        versions: (0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))((0, (/*@__PURE__*/$parcel$interopDefault($dMEgP)))(allCards).reduce((fixVersions, card)=>card.fixVersions && card.fixVersions.length > 0 ? fixVersions.concat(card.fixVersions) : fixVersions, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        []))
    });
const $be43b450a4c183c9$var$projectTransformer = (projectLocation)=>({
        projects: [
            {
                id: Number((0, $f01qr.getIdFromAri)(projectLocation.id)),
                isSimplified: true,
                key: projectLocation.key,
                name: projectLocation.name
            }
        ]
    });
const $be43b450a4c183c9$export$2e67aaf0261afb3 = (data)=>{
    const { currentUser: { permissions: permissions }, sprints: sprints, backlog: backlog, board: { issueParents: issueParents }, features: features, estimation: estimation, projectLocation: { id: projectId, issueTypes: issueTypes } } = data.boardScope;
    const canUpdateSprint = permissions.includes((0, $guzeq.MANAGE_SPRINT));
    const cardList = {
        [(0, $guzeq.BACKLOG)]: $be43b450a4c183c9$var$backlogList
    };
    const cardListOrder = [];
    const cardOrder = {
        [(0, $guzeq.BACKLOG)]: backlog.cards.reduce((backlogCardOrder, { id: id, done: done })=>done ? backlogCardOrder : backlogCardOrder.concat(Number(id)), [])
    };
    let cards = [];
    sprints.forEach((sprint)=>{
        cardList[sprint.id] = $be43b450a4c183c9$export$4055277b2f3e701f(sprint, canUpdateSprint);
        cardListOrder.push(String(sprint.id));
        cardOrder[sprint.id] = sprint.cards.map(({ id: id })=>Number(id));
        cards = cards.concat(sprint.cards);
    });
    cardListOrder.push((0, $guzeq.BACKLOG));
    cards = cards.concat(backlog.cards);
    const card = (0, (/*@__PURE__*/$parcel$interopDefault($sLb2Q)))(cards.map(({ id: id })=>id), cards.map((cardData)=>$be43b450a4c183c9$export$c44fc4642496cd94(cardData, projectId, issueParents)));
    return {
        entities: {
            cardList: cardList,
            cardListOrder: cardListOrder,
            card: card,
            cardTypes: $be43b450a4c183c9$var$cardTypesTransformer(issueTypes),
            cardOrder: cardOrder,
            issueParents: $be43b450a4c183c9$export$9a5176a1a22928d9(issueParents),
            issueParentsOrder: issueParents.map(({ id: id })=>id),
            estimation: $be43b450a4c183c9$export$3bf59b7c6d7e91d9(features, estimation),
            version: $be43b450a4c183c9$export$cfeec69489a32e7d(card),
            inlineCreate: {
                cardTypeIds: issueTypes.map((it)=>Number(it.id))
            },
            project: $be43b450a4c183c9$var$projectTransformer(data.boardScope.projectLocation)
        },
        config: $be43b450a4c183c9$export$69760b7e76c533f9(data)
    };
};
const $be43b450a4c183c9$export$8714abbd873c8285 = (data)=>{
    const { backlog: backlog, board: board, board: { issueParents: issueParents }, features: features, estimation: estimation, projectLocation: { id: projectId, issueTypes: issueTypes } } = data.boardScope;
    const cards = backlog.cards.concat(board.cards);
    const card = (0, (/*@__PURE__*/$parcel$interopDefault($sLb2Q)))(cards.map(({ id: id })=>id), cards.map((cardData)=>$be43b450a4c183c9$export$c44fc4642496cd94(cardData, projectId, issueParents)));
    return {
        entities: {
            cardList: {
                [(0, $guzeq.BOARD)]: {
                    id: (0, $guzeq.BOARD),
                    type: (0, $guzeq.BOARD),
                    name: 'Board',
                    issueListKey: backlog.boardIssueListKey
                },
                [(0, $guzeq.BACKLOG)]: $be43b450a4c183c9$var$backlogList
            },
            cardListOrder: [
                (0, $guzeq.BOARD),
                (0, $guzeq.BACKLOG)
            ],
            cardTypes: $be43b450a4c183c9$var$cardTypesTransformer(issueTypes),
            card: card,
            cardOrder: {
                [(0, $guzeq.BOARD)]: board.cards.map(({ id: id })=>Number(id)),
                [(0, $guzeq.BACKLOG)]: backlog.cards.map(({ id: id })=>Number(id))
            },
            issueParents: $be43b450a4c183c9$export$9a5176a1a22928d9(issueParents),
            issueParentsOrder: issueParents.map(({ id: id })=>id),
            estimation: $be43b450a4c183c9$export$3bf59b7c6d7e91d9(features, estimation),
            version: $be43b450a4c183c9$export$cfeec69489a32e7d(card),
            inlineCreate: {
                cardTypeIds: issueTypes.map((it)=>Number(it.id))
            },
            project: $be43b450a4c183c9$var$projectTransformer(data.boardScope.projectLocation)
        },
        config: $be43b450a4c183c9$export$69760b7e76c533f9(data)
    };
};
const $be43b450a4c183c9$var$transformCriticalData = (data, isCompanyManaged)=>{
    const metric = isCompanyManaged ? (0, $8hVbJ.uifBacklogNewUiPageLoad) : (0, $8hVbJ.nextGenBacklogPageLoad);
    metric.mark((0, $8hVbJ.PAGE_LOAD_MARK_TRANSFORM_CRITICAL_START));
    const result = $be43b450a4c183c9$export$64e7b2d3af76d9e6(data.boardScope.features) ? $be43b450a4c183c9$export$2e67aaf0261afb3(data) : $be43b450a4c183c9$export$8714abbd873c8285(data);
    metric.mark((0, $8hVbJ.PAGE_LOAD_MARK_TRANSFORM_CRITICAL_END));
    return result;
};
var $be43b450a4c183c9$export$2e2bcd8739ae039 = $be43b450a4c183c9$var$transformCriticalData;

});
parcelRegister("sLb2Q", function(module, exports) {

var $hsOo6 = parcelRequire("hsOo6");

var $dVL8S = parcelRequire("dVL8S");
/**
 * This method is like `_.fromPairs` except that it accepts two arrays,
 * one of property identifiers and one of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 0.4.0
 * @category Array
 * @param {Array} [props=[]] The property identifiers.
 * @param {Array} [values=[]] The property values.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.zipObject(['a', 'b'], [1, 2]);
 * // => { 'a': 1, 'b': 2 }
 */ function $056736098c9e0b45$var$zipObject(props, values) {
    return $dVL8S(props || [], values || [], $hsOo6);
}
module.exports = $056736098c9e0b45$var$zipObject;

});
parcelRegister("dVL8S", function(module, exports) {
/**
 * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
 *
 * @private
 * @param {Array} props The property identifiers.
 * @param {Array} values The property values.
 * @param {Function} assignFunc The function to assign values.
 * @returns {Object} Returns the new object.
 */ function $a2452aab1e6d9d16$var$baseZipObject(props, values, assignFunc) {
    var index = -1, length = props.length, valsLength = values.length, result = {};
    while(++index < length){
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
    }
    return result;
}
module.exports = $a2452aab1e6d9d16$var$baseZipObject;

});


const $e525e6c25695c9df$export$9f1186f5f46d05d7 = 'CAN_MANAGE_LABS';
const $e525e6c25695c9df$export$1d4594bb2516d9ef = 'CAN_RANK_COLUMNS';
const $e525e6c25695c9df$export$aadc620ce91112df = 'CAN_EDIT_BOARD';
const $e525e6c25695c9df$export$5cd553a40d575c6c = 'CAN_EDIT_ISSUE';
const $e525e6c25695c9df$export$b5cf1ddd753a0a1c = 'CAN_RENAME_COLUMNS';
const $e525e6c25695c9df$export$c5d82f9af027c432 = 'CAN_CREATE_COLUMNS';
const $e525e6c25695c9df$export$9205190dd90cb392 = 'CAN_CREATE_CARDS';
const $e525e6c25695c9df$export$d4845393d78ba468 = 'CAN_DELETE_ISSUE';
const $e525e6c25695c9df$export$112115098b6cf79b = 'CAN_MANAGE_SPRINT';
const $e525e6c25695c9df$export$7c16e92435670968 = 'CAN_MANAGE_AUTOMATION';
const $e525e6c25695c9df$export$172db259b98bcef1 = 'CAN_RELEASE';
const $e525e6c25695c9df$export$e6bcada406923d66 = 'CAN_ARCHIVE_ISSUE';
const $e525e6c25695c9df$export$c713a1185b717514 = 'CAN_ASSIGN_ISSUE';
const $e525e6c25695c9df$export$5904c54eb0bdf886 = 'CAN_SCHEDULE_ISSUE';

const $0b986b66d9bedfde$export$4279f6f79febea0a = 'SPRINTS';
const $0b986b66d9bedfde$export$4181c6622414bfdf = 'ESTIMATION';
const $0b986b66d9bedfde$export$173708eb8a9ba955 = 'RELEASES';
const $0b986b66d9bedfde$export$e927a5d1b72f0b68 = 'ENABLED';
const $0b986b66d9bedfde$export$8cd212c10b4124d2 = 'DISABLED';
const $0b986b66d9bedfde$export$b0409bb9b247a093 = 'COMING_SOON';



parcelRegister("fdAim", function(module, exports) {

$parcel$export(module.exports, "CARD_REFRESH_REQUEST", () => $2abd2fdf8ad53fef$export$a5cacf6c12c6c43b);
$parcel$export(module.exports, "CARD_REFRESH_SUCCESS", () => $2abd2fdf8ad53fef$export$5d5ffe0a39497fb1);
$parcel$export(module.exports, "cardRefreshRequest", () => $2abd2fdf8ad53fef$export$54efae65153e525a);
$parcel$export(module.exports, "cardRefreshSuccess", () => $2abd2fdf8ad53fef$export$8c0b797631a3987f);
const $2abd2fdf8ad53fef$export$a5cacf6c12c6c43b = 'state.actions.cards.refresh.CARD_REFRESH_REQUEST';
const $2abd2fdf8ad53fef$export$5d5ffe0a39497fb1 = 'state.actions.cards.refresh.CARD_REFRESH_SUCCESS';
const $2abd2fdf8ad53fef$export$54efae65153e525a = (cardId, changeEvent)=>({
        type: $2abd2fdf8ad53fef$export$a5cacf6c12c6c43b,
        payload: {
            cardId: cardId,
            changeEvent: changeEvent || null
        }
    });
const $2abd2fdf8ad53fef$export$8c0b797631a3987f = (card)=>({
        type: $2abd2fdf8ad53fef$export$5d5ffe0a39497fb1,
        payload: card
    });

});


parcelRegister("eVhWm", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1820cf215861eb7$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("fPS7b");


var $guzeq = parcelRequire("guzeq");

var $3lZ6i = parcelRequire("3lZ6i");

var $czUNp = parcelRequire("czUNp");

var $dGljH = parcelRequire("dGljH");

var $bAfUr = parcelRequire("bAfUr");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d1820cf215861eb7$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $czUNp.CARD_STATUS_CHECK)).mergeMap((action)=>{
        const { payload: payload } = action;
        if ('fieldId' in payload && payload.fieldId !== (0, $e9be48d6d2c01760$export$4420b7468f889692)) return (0, $kVLXA.Observable).empty();
        const state = store.getState();
        const hasIssueOnBacklog = (0, $dGljH.getAllCardIdsIncludingIssueParents)(state).includes(Number(payload.issueId));
        // since ChangeEvent can be of different type and not all have fieldValue
        // @ts-expect-error - TS2339 - Property 'fieldValue' does not exist on type '{ fieldId: string; fieldValue: any; } | { fieldId: string; } | { fieldId: string; fieldValue: any; } | { typeName: string; } | { newParentIssueId: string | null; oldParentIssueId: string | null; } | ChangedIssueLink | { ...; } | { ...; } | { ...; }'.
        const isStatusIdMappedToBoard = payload.meta.fieldValue ? (0, $bAfUr.isStatusMappedToBoardOld)(payload.meta.fieldValue.id)(state) : false;
        // if an unmapped issue(including parent) does not exist on backlog & its remapped with status change,
        // need to refresh the data, so that issue will reappear on backlog
        return !hasIssueOnBacklog && isStatusIdMappedToBoard ? (0, $kVLXA.Observable).of((0, $3lZ6i.refreshDataRequest)((0, $guzeq.REFRESH_SOURCE_STATUS_REMAPPED))) : (0, $kVLXA.Observable).empty();
    });

});
parcelRegister("czUNp", function(module, exports) {

$parcel$export(module.exports, "CARD_STATUS_SET", () => $7cb4a4f27fcd037f$export$ecf291dab442850b);
$parcel$export(module.exports, "cardStatusSet", () => $7cb4a4f27fcd037f$export$8f909d4ac3011c05);
$parcel$export(module.exports, "CARD_STATUS_CHECK", () => $7cb4a4f27fcd037f$export$17514c9f1eddf04d);
$parcel$export(module.exports, "cardStatusCheck", () => $7cb4a4f27fcd037f$export$9fafd08cacc25a20);
const $7cb4a4f27fcd037f$export$ecf291dab442850b = 'state.actions.status.CARD_STATUS_SET';
const $7cb4a4f27fcd037f$export$8f909d4ac3011c05 = (cardId, prevStatusId, statusId, statusCategory, isCMP)=>({
        type: $7cb4a4f27fcd037f$export$ecf291dab442850b,
        payload: {
            cardId: cardId,
            prevStatusId: prevStatusId,
            statusId: statusId,
            statusCategory: statusCategory,
            isCMP: isCMP
        }
    });
const $7cb4a4f27fcd037f$export$17514c9f1eddf04d = 'state.actions.status.CARD_STATUS_CHECK';
const $7cb4a4f27fcd037f$export$9fafd08cacc25a20 = (payload)=>({
        type: $7cb4a4f27fcd037f$export$17514c9f1eddf04d,
        payload: payload
    });

});


parcelRegister("028Rt", function(module, exports) {

$parcel$export(module.exports, "default", () => $8072515d79f2e477$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("zjDln");
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $3lZ6i = parcelRequire("3lZ6i");

var $a7yHf = parcelRequire("a7yHf");

var $hf5c2 = parcelRequire("hf5c2");

var $czUNp = parcelRequire("czUNp");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $bAfUr = parcelRequire("bAfUr");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8072515d79f2e477$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $czUNp.CARD_STATUS_SET)).mergeMap((action)=>{
        const { payload: { cardId: cardId, prevStatusId: prevStatusId, statusId: statusId } } = action;
        const state = store.getState();
        const cardKey = (0, $dGljH.makeCardKeyFromCardId)(state)(cardId);
        if (!(0, $bAfUr.isStatusMappedToBoard)(state)(statusId)) return (0, $kVLXA.Observable).of((0, $hf5c2.cardCreateUnmappedWithIssueLink)([
            {
                id: cardId,
                key: cardKey
            }
        ]));
        if ((0, $jG5HW.isCmpKanbanProject)(state)) {
            const statusIdIsVisible = (0, $bAfUr.isStatusVisibleOnCmpKanbanBacklog)(state)(statusId);
            const cardHasMovedColumn = !(0, $bAfUr.areStatusesFromSameColumn)(state)(prevStatusId, statusId);
            if (!statusIdIsVisible || cardHasMovedColumn) return (0, $kVLXA.Observable).from([
                (0, $3lZ6i.loadAppData)(),
                (0, $a7yHf.clearExpandedCardGroup)(cardId)
            ]);
        }
        const isCMP = (0, $jG5HW.getIsCompanyManaged)(state);
        if (isCMP) // For CMP, always do a data refresh on status transition
        // to ensure the issue's resolution is correct.
        return (0, $kVLXA.Observable).from([
            (0, $3lZ6i.loadAppData)()
        ]);
        return (0, $kVLXA.Observable).empty();
    });

});

parcelRegister("jv1aX", function(module, exports) {

$parcel$export(module.exports, "cardsBulkOperationsFailureEpic", () => $3b557eae5da9a56a$export$7900f6327252d82);
$parcel$export(module.exports, "cardsBulkOperationsSuccessEpicCmp", () => $3b557eae5da9a56a$export$1398e97029b0b992);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $guzeq = parcelRequire("guzeq");

var $3lZ6i = parcelRequire("3lZ6i");

var $eSSqy = parcelRequire("eSSqy");
const $3b557eae5da9a56a$export$7900f6327252d82 = (action$)=>action$.ofType((0, $eSSqy.CARDS_BULK_OPERATIONS_FAILURE)).flatMap((action)=>{
        if (action.payload.length === 0) return (0, $kVLXA.Observable).empty();
        return (0, $kVLXA.Observable).of((0, $3lZ6i.refreshDataRequest)((0, $guzeq.REFRESH_SOURCE_FAILURE)));
    });
const $3b557eae5da9a56a$export$1398e97029b0b992 = (action$)=>action$.ofType((0, $eSSqy.CARDS_BULK_OPERATIONS_SUCCESS)).flatMap((action)=>{
        if (action.payload.length === 0) return (0, $kVLXA.Observable).empty();
        return (0, $kVLXA.Observable).of((0, $3lZ6i.loadAppData)());
    });

});
parcelRegister("eSSqy", function(module, exports) {

$parcel$export(module.exports, "CARDS_BULK_OPERATIONS_REQUESTS", () => $4b622b7cab87e15c$export$89d925e1f8ce24b2);
$parcel$export(module.exports, "cardsBulkOperationsRequests", () => $4b622b7cab87e15c$export$1edfb57ee17c64a7);
$parcel$export(module.exports, "CARDS_BULK_OPERATIONS_SUCCESS", () => $4b622b7cab87e15c$export$3f2add5deaccd21);
$parcel$export(module.exports, "cardsBulkOperationsSuccess", () => $4b622b7cab87e15c$export$a9c3b26200843a57);
$parcel$export(module.exports, "CARDS_BULK_OPERATIONS_FAILURE", () => $4b622b7cab87e15c$export$11514e15dcf93257);
$parcel$export(module.exports, "cardsBulkOperationsFailure", () => $4b622b7cab87e15c$export$ca0b712e0be4eecd);

var $c0irb = parcelRequire("c0irb");
const $4b622b7cab87e15c$export$89d925e1f8ce24b2 = 'state.actions.cards.bulk-operations.CARDS_BULK_OPERATIONS_REQUESTS';
const $4b622b7cab87e15c$export$1edfb57ee17c64a7 = (payload)=>({
        type: $4b622b7cab87e15c$export$89d925e1f8ce24b2,
        payload: payload,
        meta: (0, $c0irb.beginOptimisticUiMeta)()
    });
const $4b622b7cab87e15c$export$3f2add5deaccd21 = 'state.actions.cards.bulk-operations.CARDS_BULK_OPERATIONS_SUCCESS';
const $4b622b7cab87e15c$export$a9c3b26200843a57 = (optimisticId, payload)=>({
        type: $4b622b7cab87e15c$export$3f2add5deaccd21,
        meta: (0, $c0irb.commitOptimisticUiMeta)(optimisticId),
        payload: payload
    });
const $4b622b7cab87e15c$export$11514e15dcf93257 = 'state.actions.cards.bulk-operations.CARDS_BULK_OPERATIONS_FAILURE';
const $4b622b7cab87e15c$export$ca0b712e0be4eecd = (optimisticId, payload)=>({
        type: $4b622b7cab87e15c$export$11514e15dcf93257,
        meta: (0, $c0irb.revertOptimisticUiMeta)(optimisticId),
        payload: payload
    });

});


parcelRegister("2YtLH", function(module, exports) {

$parcel$export(module.exports, "cardsBulkOperationsDeleteRequestEpic", () => $8afb2aeb1eba5466$export$ccdd8b315421243e);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $7X18B = parcelRequire("7X18B");

var $cik5h = parcelRequire("cik5h");
const $8afb2aeb1eba5466$export$ccdd8b315421243e = (getLocation, push)=>(action$)=>action$.ofType((0, $7X18B.CARDS_BULK_OPERATIONS_DELETE_REQUESTS)).flatMap((action)=>{
            if (action.payload.length === 0) return (0, $kVLXA.Observable).empty();
            push((0, $cik5h.removeSelectedIssueFromUrl)(getLocation()));
            return (0, $kVLXA.Observable).empty();
        });

});
parcelRegister("7X18B", function(module, exports) {

$parcel$export(module.exports, "CARDS_BULK_OPERATIONS_DELETE_REQUESTS", () => $1038ae93b4b85a12$export$2434726845f850a5);
$parcel$export(module.exports, "cardsBulkOperationsDeleteRequests", () => $1038ae93b4b85a12$export$cc28e3ffcd8d64e);
$parcel$export(module.exports, "CARDS_BULK_OPERATIONS_DELETE_SUCCESS", () => $1038ae93b4b85a12$export$9fcd8f3d7adf65d8);
$parcel$export(module.exports, "cardsBulkOperationsDeleteSuccess", () => $1038ae93b4b85a12$export$7a7dede3f057798b);
$parcel$export(module.exports, "cardsBulkOperationsDeleteFailure", () => $1038ae93b4b85a12$export$1e0d04788aa14ace);

var $c0irb = parcelRequire("c0irb");
const $1038ae93b4b85a12$export$2434726845f850a5 = 'state.actions.cards.bulk-operations.CARDS_BULK_OPERATIONS_DELETE_REQUEST';
const $1038ae93b4b85a12$export$cc28e3ffcd8d64e = (payload)=>({
        type: $1038ae93b4b85a12$export$2434726845f850a5,
        payload: payload,
        meta: (0, $c0irb.beginOptimisticUiMeta)()
    });
const $1038ae93b4b85a12$export$9fcd8f3d7adf65d8 = 'state.actions.cards.bulk-operations.CARDS_BULK_OPERATIONS_DELETE_SUCCESS';
const $1038ae93b4b85a12$export$7a7dede3f057798b = (optimisticId, payload)=>({
        type: $1038ae93b4b85a12$export$9fcd8f3d7adf65d8,
        payload: payload,
        meta: (0, $c0irb.commitOptimisticUiMeta)(optimisticId)
    });
const $1038ae93b4b85a12$export$33e9bc12c53db220 = 'state.actions.cards.bulk-operations.CARDS_BULK_OPERATIONS_DELETE_FAILURE';
const $1038ae93b4b85a12$export$1e0d04788aa14ace = (optimisticId, payload)=>({
        type: $1038ae93b4b85a12$export$33e9bc12c53db220,
        payload: payload,
        meta: (0, $c0irb.revertOptimisticUiMeta)(optimisticId)
    });

});


parcelRegister("iKvYD", function(module, exports) {

$parcel$export(module.exports, "cardsFlagWithCommentEpic", () => $da9c82ece9086f7c$export$a1e5554df37d16f8);

var $ajpes = parcelRequire("ajpes");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $kz2lw = parcelRequire("kz2lw");

var $2YZCu = parcelRequire("2YZCu");

var $8zOmE = parcelRequire("8zOmE");

var $4R6GH = parcelRequire("4R6GH");

var $guzeq = parcelRequire("guzeq");

var $63NNS = parcelRequire("63NNS");

var $3lZ6i = parcelRequire("3lZ6i");

var $aKajY = parcelRequire("aKajY");
const $da9c82ece9086f7c$export$a1e5554df37d16f8 = (action$, store)=>action$.ofType((0, $aKajY.CARDS_FLAG_WITH_COMMENT_REQUEST)).mergeMap((action)=>{
        const { payload: { cards: cards, flag: flag, comment: comment }, meta: { optimistic: { id: optimisticId }, analyticsEvent: analyticsEvent } } = action;
        return (0, $63NNS.default)(store, action).flatMap((response)=>{
            if (response === null) {
                // if we get here, all of the issues were successfully updated
                const extendedAnalyticsArgs = {};
                if ((0, $4R6GH.fg)('add_has_comment_attribute_to_cards_flagged_client')) extendedAnalyticsArgs.hasComment = !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(comment, (0, $kz2lw.getEmptyADF)());
                (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'cards flagged', {
                    numCards: cards.length,
                    flagAction: flag ? 'added' : 'removed',
                    ...extendedAnalyticsArgs
                });
                return (0, $kVLXA.Observable).of((0, $aKajY.cardsFlagWithCommentSuccess)(optimisticId, {
                    cards: cards
                }));
            }
            // if we get here, at least one of the issues failed to be updated,
            // so we treat it as a failure
            const error = new Error(response.errorMessages.join(', '));
            (0, $2YZCu.default).safeErrorWithoutCustomerData('backlog.cards-flag-with-comment.partial-failure', 'Failed to flag and/or comment on some issues.', error);
            throw error;
        }).catch(()=>{
            // if we get here directly from the cardsFlagWithCommentService, none
            // of the issues were successfully updated
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'ui taskFail', {
                task: 'flagCards',
                numCards: cards.length,
                flagAction: flag ? 'added' : 'removed'
            });
            return (0, $kVLXA.Observable).from([
                (0, $aKajY.cardsFlagWithCommentFailure)(optimisticId, {
                    cards: cards
                }),
                (0, $3lZ6i.refreshDataRequest)((0, $guzeq.REFRESH_SOURCE_FAILURE))
            ]);
        });
    });

});
parcelRegister("63NNS", function(module, exports) {

$parcel$export(module.exports, "default", () => $54678a7970acef10$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");

var $fYPeZ = parcelRequire("fYPeZ");

var $dGljH = parcelRequire("dGljH");
const $54678a7970acef10$export$de42cacd38bf80bd = (store, action)=>{
    const { payload: { cards: cards, flag: flag, comment: comment } } = action;
    const state = store.getState();
    const allCards = (0, $dGljH.getCards)(state);
    const issueKeys = cards.map((id)=>allCards[String(id)].key);
    return (0, $kVLXA.Observable).fromPromise((0, $fYPeZ.default)(issueKeys, flag, comment));
};
var $54678a7970acef10$export$2e2bcd8739ae039 = $54678a7970acef10$export$de42cacd38bf80bd;

});
parcelRegister("fYPeZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a56f37a43de2568b$export$2e2bcd8739ae039);

var $jJZqs = parcelRequire("jJZqs");

var $iwPwz = parcelRequire("iwPwz");
const $a56f37a43de2568b$export$3ae968343ffb0d2b = '/rest/greenhopper/3/xboard/issue/flag/flag';
const $a56f37a43de2568b$var$noContentStatus = 204;
const $a56f37a43de2568b$export$5e94598347afb988 = (issueKeys, flag, comment)=>fetch($a56f37a43de2568b$export$3ae968343ffb0d2b, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            issueKeys: issueKeys,
            flag: flag,
            comment: comment,
            commentProperty: '',
            commentVisibility: ''
        })
    }).then((response)=>{
        if (!response.ok) {
            const { status: status } = response;
            const traceId = (0, $iwPwz.getTraceId)(response);
            if (traceId != null && traceId !== '') throw new (0, $jJZqs.default)(status, `Fetch call failed with status code: ${status}`, traceId);
            else throw new (0, $jJZqs.default)(status);
        }
        if (response.status === $a56f37a43de2568b$var$noContentStatus) return null;
        return response.text().then((body)=>body ? JSON.parse(body) : null);
    });
var $a56f37a43de2568b$export$2e2bcd8739ae039 = $a56f37a43de2568b$export$5e94598347afb988;

});


parcelRegister("aKajY", function(module, exports) {

$parcel$export(module.exports, "CARDS_FLAG_WITH_COMMENT_REQUEST", () => $3faa5ac58d7af7dd$export$54cb48f5bedda9b0);
$parcel$export(module.exports, "cardsFlagWithCommentRequest", () => $3faa5ac58d7af7dd$export$5e94598347afb988);
$parcel$export(module.exports, "CARDS_FLAG_WITH_COMMENT_SUCCESS", () => $3faa5ac58d7af7dd$export$7ae03d8a0b15c6bb);
$parcel$export(module.exports, "cardsFlagWithCommentSuccess", () => $3faa5ac58d7af7dd$export$de9dc95767a5ba8a);
$parcel$export(module.exports, "CARDS_FLAG_WITH_COMMENT_FAILURE", () => $3faa5ac58d7af7dd$export$b85cf7baff5e9cdb);
$parcel$export(module.exports, "cardsFlagWithCommentFailure", () => $3faa5ac58d7af7dd$export$83679228bcad76fd);

var $c0irb = parcelRequire("c0irb");
const $3faa5ac58d7af7dd$export$54cb48f5bedda9b0 = 'state.actions.cards.flag-with-comment.CARDS_FLAG_WITH_COMMENT_REQUEST';
const $3faa5ac58d7af7dd$export$5e94598347afb988 = (payload, analyticsEvent)=>({
        type: $3faa5ac58d7af7dd$export$54cb48f5bedda9b0,
        payload: payload,
        meta: {
            ...(0, $c0irb.beginOptimisticUiMeta)(),
            analyticsEvent: analyticsEvent
        }
    });
const $3faa5ac58d7af7dd$export$7ae03d8a0b15c6bb = 'state.actions.cards.flag-with-comment.CARDS_FLAG_WITH_COMMENT_SUCCESS';
const $3faa5ac58d7af7dd$export$de9dc95767a5ba8a = (optimisticId, payload)=>({
        type: $3faa5ac58d7af7dd$export$7ae03d8a0b15c6bb,
        meta: (0, $c0irb.commitOptimisticUiMeta)(optimisticId),
        payload: payload
    });
const $3faa5ac58d7af7dd$export$b85cf7baff5e9cdb = 'state.actions.cards.flag-with-comment.CARDS_FLAG_WITH_COMMENT_FAILURE';
const $3faa5ac58d7af7dd$export$83679228bcad76fd = (optimisticId, payload)=>({
        type: $3faa5ac58d7af7dd$export$b85cf7baff5e9cdb,
        meta: (0, $c0irb.revertOptimisticUiWithFlagMeta)(optimisticId),
        payload: payload
    });

});


parcelRegister("1pwBu", function(module, exports) {

$parcel$export(module.exports, "beforeMoveCardsEpic", () => $75c07ecefd9b343a$export$4cb77cd53144053d);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $g4tDr = parcelRequire("g4tDr");

var $f01qr = parcelRequire("f01qr");

var $guzeq = parcelRequire("guzeq");


var $6GNN7 = parcelRequire("6GNN7");

var $5Eoed = parcelRequire("5Eoed");

var $jG5HW = parcelRequire("jG5HW");

var $ld0jI = parcelRequire("ld0jI");

var $dGljH = parcelRequire("dGljH");

var $k35me = parcelRequire("k35me");

var $bAfUr = parcelRequire("bAfUr");

var $4RNa9 = parcelRequire("4RNa9");
const $75c07ecefd9b343a$var$getBeforeCardId = (action, topCardId)=>{
    const { placement: placement } = action.payload;
    if (placement === (0, $guzeq.TOP_OF_LIST)) return topCardId || null;
    if (action.payload.placement === (0, $guzeq.BEFORE_CARD)) return action.payload.beforeCardId;
    return null;
};
const $75c07ecefd9b343a$var$getAfterCardId = (action, bottomCardId)=>{
    const { placement: placement } = action.payload;
    if (placement === (0, $guzeq.BOTTOM_OF_LIST) || placement === (0, $guzeq.BOTTOM_OF_CARD_GROUP)) return bottomCardId || null;
    return null;
};
const $75c07ecefd9b343a$export$c53c1ed4374c27e3 = ({ state: state, cardListId: cardListId, cardIds: cardIds, isDroppedInTransitionZone: isDroppedInTransitionZone, beforeCardId: beforeCardId, afterCardId: afterCardId, targetStatusId: targetStatusId, analyticsEvent: analyticsEvent, newCardOrderGlobal: newCardOrderGlobal })=>{
    const newCardOrder = (0, $4RNa9.getNewCardOrder)(state, cardListId, cardIds, beforeCardId, afterCardId, isDroppedInTransitionZone);
    return (0, $kVLXA.Observable).of((0, $6GNN7.cardsMoveRequest)({
        cardIds: cardIds,
        cardListId: cardListId,
        newCardOrder: newCardOrder,
        newCardOrderGlobal: newCardOrderGlobal,
        targetStatusId: targetStatusId,
        beforeCardId: beforeCardId,
        afterCardId: afterCardId,
        isBetweenLists: true
    }, analyticsEvent));
};
const $75c07ecefd9b343a$export$4cb77cd53144053d = (action$, store)=>action$.ofType((0, $6GNN7.CARDS_MOVE)).mergeMap((action)=>{
        const state = store.getState();
        const rankCustomFieldId = (0, $jG5HW.getRankCustomFieldId)(state);
        if (!rankCustomFieldId) return (0, $kVLXA.Observable).empty();
        const { payload: { cardIds: cardIds, cardListId: destinationCardListId, isBetweenLists: isBetweenLists, isFromActiveSprint: isFromActiveSprint, placement: placement }, meta: { analyticsEvent: analyticsEvent } } = action;
        const cardListId = (0, $f01qr.getCardListId)(destinationCardListId);
        const cardOrder = (0, $dGljH.getFlattenOrderedCardIds)(state);
        const cardLists = (0, $dGljH.getCardLists)(state);
        const cards = (0, $dGljH.getCards)(state);
        const isCmpKanbanBacklog = (0, $jG5HW.isCmpKanbanProject)(state);
        const isCmpScrumBacklog = (0, $jG5HW.isCMPScrumBacklog)(state);
        const isCmpBacklog = (0, $jG5HW.getIsCompanyManaged)(state);
        let cardsToMove = cardIds || (0, $dGljH.getSelectedCards)(state);
        let newCardOrderGlobal;
        const isMovingSubtasks = (0, $4RNa9.getIsMovingSubtasks)(cards, cardsToMove);
        const cardParentId = cardsToMove.filter((card)=>(0, $g4tDr.isSubtaskHierarchyLevel)(cards[card]?.typeHierarchyLevel)).reduce((id, curr)=>cards[curr].parentId ?? id, null);
        const targetStatusId = isBetweenLists ? (0, $bAfUr.makeGetKanbanSingleColumnStatusId)(state)(cardListId) : undefined;
        if (isCmpBacklog) {
            const getCardListIdByCardId = (0, $dGljH.makeGetCardListIdByCardId)(state);
            const getCardGroupByParentId = (0, $ld0jI.makeGetCardGroupByParentId)(state);
            cardsToMove = (0, $4RNa9.getCMPCardsToMove)({
                cardIds: cardsToMove,
                getCardListIdByCardId: getCardListIdByCardId,
                getCardGroupByParentId: getCardGroupByParentId,
                isCmpScrumBacklog: isCmpScrumBacklog
            });
        }
        const orderedCardIds = cardOrder.filter((orderedCardId)=>cardsToMove.includes(orderedCardId));
        const topCardId = (0, $dGljH.makeGetTopCardIdFromCardList)(state)(cardListId, cardsToMove);
        const bottomCardId = isMovingSubtasks && cardParentId && placement !== (0, $guzeq.BOTTOM_OF_LIST) ? (0, $ld0jI.makeGetBottomCardIdFromCardGroup)(state)(cardListId, cardParentId, cardsToMove) : (0, $dGljH.makeGetBottomCardIdFromCardList)(state)(cardListId, cardsToMove);
        const beforeCardId = $75c07ecefd9b343a$var$getBeforeCardId(action, topCardId);
        // When dropping on subtask and moving card is not a subtask set bottom as the parentId of the subtasks
        const bottomId = bottomCardId && !isMovingSubtasks && (0, $g4tDr.isSubtaskHierarchyLevel)(cards[bottomCardId]?.typeHierarchyLevel) ? cards[bottomCardId]?.parentId : bottomCardId;
        const afterCardId = $75c07ecefd9b343a$var$getAfterCardId(action, bottomId);
        if (isCmpKanbanBacklog) {
            const isTransitionZoneDestination = action.payload.placement === (0, $guzeq.TRANSITION_ZONE);
            newCardOrderGlobal = (0, $4RNa9.getNewCardOrderGlobal)(state, orderedCardIds, beforeCardId, afterCardId, isMovingSubtasks);
            if (isBetweenLists && (isTransitionZoneDestination || isMovingSubtasks)) return $75c07ecefd9b343a$export$c53c1ed4374c27e3({
                state: state,
                cardListId: cardListId,
                cardIds: orderedCardIds,
                isDroppedInTransitionZone: isTransitionZoneDestination,
                beforeCardId: beforeCardId,
                afterCardId: afterCardId,
                targetStatusId: targetStatusId,
                analyticsEvent: analyticsEvent,
                newCardOrderGlobal: newCardOrderGlobal
            });
        }
        const payload = {
            cardIds: orderedCardIds,
            cardListId: cardListId,
            isBetweenLists: isBetweenLists,
            beforeCardId: beforeCardId,
            afterCardId: afterCardId,
            targetStatusId: targetStatusId,
            newCardOrderGlobal: newCardOrderGlobal
        };
        const toActiveSprint = (0, $k35me.makeIsCardListActiveSprint)(state)(cardListId);
        if (isBetweenLists && (isFromActiveSprint || toActiveSprint)) {
            const originCardListId = (0, $dGljH.makeGetCardListIdByCardId)(state)(orderedCardIds[0]);
            return (0, $kVLXA.Observable).of((0, $5Eoed.openModal)({
                type: (0, $b107c54ec82f76f2$export$86a0c18887a92eae),
                payload: {
                    cardIds: orderedCardIds,
                    originCardListName: originCardListId ? cardLists[originCardListId].name : '',
                    destinationCardListName: cardLists[cardListId].name,
                    confirmActionPayload: payload,
                    analyticsEvent: analyticsEvent
                }
            }));
        }
        return (0, $kVLXA.Observable).of((0, $6GNN7.cardsMoveRequest)(payload, analyticsEvent));
    });

});
parcelRegister("ld0jI", function(module, exports) {

$parcel$export(module.exports, "makeGetCardGroupByParentId", () => $0271650b1fb6a13c$export$d2788281fedf0254);
$parcel$export(module.exports, "makeGetCardGroupByChildId", () => $0271650b1fb6a13c$export$c259bd0429fd462d);
$parcel$export(module.exports, "makeGetBottomCardIdFromCardGroup", () => $0271650b1fb6a13c$export$310938eee52c1639);
$parcel$export(module.exports, "makeIsCardInCollapsedCardGroup", () => $0271650b1fb6a13c$export$7e51b32fda52165e);

var $dGvGJ = parcelRequire("dGvGJ");

var $k8IPx = parcelRequire("k8IPx");

var $gJBT6 = parcelRequire("gJBT6");

var $ee1tL = parcelRequire("ee1tL");

var $dGljH = parcelRequire("dGljH");
const $0271650b1fb6a13c$export$d2788281fedf0254 = (0, $dGvGJ.createSelector)([
    (0, $dGljH.makeGetOrderedCardEntries)
], (getOrderedCardEntries)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((cardListId, parentId)=>{
        const cardEntries = getOrderedCardEntries(cardListId);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return cardEntries.find((cardEntry)=>(0, $ee1tL.isCardEntryGroup)(cardEntry) && cardEntry.parentId === parentId);
    }, (cardListId, parentId)=>`${cardListId}::${parentId}`));
const $0271650b1fb6a13c$export$c259bd0429fd462d = (0, $dGvGJ.createSelector)([
    (0, $dGljH.makeGetCardListIdByCardId),
    (0, $dGljH.getParentIdByChildIdSelector),
    $0271650b1fb6a13c$export$d2788281fedf0254
], (getCardListIdByCardId, getParentIdByChildId, getCardGroupByParentId)=>{
    const getCardGroupByChildId = (cardId)=>{
        const cardListId = getCardListIdByCardId(cardId);
        if (!cardListId) return null;
        const parentId = getParentIdByChildId(cardId);
        return parentId ? getCardGroupByParentId(cardListId, parentId) : null;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getCardGroupByChildId);
});
const $0271650b1fb6a13c$export$310938eee52c1639 = (0, $dGvGJ.createSelector)([
    $0271650b1fb6a13c$export$d2788281fedf0254
], (getCardGroupByParentId)=>(cardListId, parentId, ignoredIds)=>{
        const cardGroup = getCardGroupByParentId(cardListId, parentId);
        if (!cardGroup) return null;
        const list = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(cardGroup.cardIds, ignoredIds);
        return list.length > 0 ? list[list.length - 1] : null;
    });
const $0271650b1fb6a13c$export$7e51b32fda52165e = (0, $dGvGJ.createSelector)([
    $0271650b1fb6a13c$export$c259bd0429fd462d
], (getCardGroupByChildId)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((cardId)=>{
        const cardGroup = getCardGroupByChildId(cardId);
        if (cardGroup) return cardGroup.isCollapsed;
        return false;
    }));

});

parcelRegister("4RNa9", function(module, exports) {

$parcel$export(module.exports, "getIsMovingSubtasks", () => $13554e2871800c00$export$a9e6d5ca31611623);
$parcel$export(module.exports, "getCMPCardsToMove", () => $13554e2871800c00$export$9b3afea889889644);
$parcel$export(module.exports, "getNewCardOrder", () => $13554e2871800c00$export$5455144e38b4d576);
$parcel$export(module.exports, "getNewCardOrderGlobal", () => $13554e2871800c00$export$7bc7f0caf073cc20);

var $g4tDr = parcelRequire("g4tDr");

var $lt7Oy = parcelRequire("lt7Oy");

var $dGljH = parcelRequire("dGljH");
const $13554e2871800c00$export$a9e6d5ca31611623 = (cards, cardsToMove)=>cardsToMove.some((cardId)=>cards[cardId] && (0, $g4tDr.isSubtaskHierarchyLevel)(cards[cardId].typeHierarchyLevel));
const $13554e2871800c00$var$removeSubtasks = (cards, cardIds)=>cardIds.filter((cardId)=>cards[cardId] && !(0, $g4tDr.isSubtaskHierarchyLevel)(cards[cardId].typeHierarchyLevel));
const $13554e2871800c00$export$9b3afea889889644 = ({ cardIds: cardIds, getCardListIdByCardId: getCardListIdByCardId, getCardGroupByParentId: getCardGroupByParentId, isCmpScrumBacklog: isCmpScrumBacklog })=>{
    // For each card, we check if it is the parent of
    // a collapsed card group in kanban, or any card
    // group in scurm. If yes, we take the subtasks in
    // this card group and add them to the subtasksToMove.
    const subtasksToMove = cardIds.flatMap((cardId)=>{
        const listId = getCardListIdByCardId(cardId);
        const cardGroup = listId && getCardGroupByParentId(listId, cardId);
        if (cardGroup && (isCmpScrumBacklog || cardGroup.isCollapsed)) return cardGroup.cardIds;
        return [];
    });
    return [
        ...cardIds,
        ...subtasksToMove
    ];
};
const $13554e2871800c00$export$546ed7c4f4fa68f9 = (cardIdOrder, cardIds)=>cardIdOrder.filter((cardId)=>cardIds.includes(cardId));
const $13554e2871800c00$export$5455144e38b4d576 = (state, cardListId, cardIds, beforeCardId, afterCardId, isDroppedInTransitionZone)=>{
    const globalCardOrder = (0, $lt7Oy.getCardOrderGlobal)(state);
    const cardListCardOrder = (0, $lt7Oy.getCardOrderByCardlistId)(state, cardListId);
    const allCards = (0, $dGljH.getCards)(state);
    // 1. Handle when cards are dropped and ranked within a cardlist.
    // This could include both subtasks and non-subtasks, where
    // the card that was dragged was a non-subtask.
    // This can only occur when the backlog is sorted by rank.
    if (!isDroppedInTransitionZone && (beforeCardId || afterCardId)) {
        const subtaskCardIds = [];
        const nonSubtaskCardIds = [];
        cardIds.forEach((cardId)=>{
            const card = allCards[cardId];
            const isSubtask = (0, $g4tDr.isSubtaskHierarchyLevel)(card.typeHierarchyLevel);
            if (isSubtask) subtaskCardIds.push(cardId);
            else nonSubtaskCardIds.push(cardId);
        });
        // a. Order subtasks within the cardlist according to their global rank
        const newCardOrder = $13554e2871800c00$export$546ed7c4f4fa68f9(globalCardOrder, [
            ...subtaskCardIds,
            ...cardListCardOrder
        ]);
        const insertIndex = beforeCardId ? newCardOrder.indexOf(beforeCardId) : newCardOrder.indexOf(afterCardId || 0) + 1;
        // b. Insert sorted non-subtasks into the position in the cardlist they were dropped
        newCardOrder.splice(insertIndex, 0, ...$13554e2871800c00$export$546ed7c4f4fa68f9(globalCardOrder, nonSubtaskCardIds));
        return newCardOrder;
    }
    // 2. Handle when cards are dropped in a cardlist where the backlog is not
    // sorted by rank, or when the dragged card is a subtask, and therefore
    // not itself rankable.
    return $13554e2871800c00$export$546ed7c4f4fa68f9(globalCardOrder, [
        ...cardIds,
        ...cardListCardOrder
    ]);
};
const $13554e2871800c00$export$7bc7f0caf073cc20 = (state, cardIds, beforeCardId, afterCardId, isMovingSubtasks)=>{
    const globalCardOrder = (0, $lt7Oy.getCardOrderGlobal)(state);
    const cards = (0, $dGljH.getCards)(state);
    if (!(beforeCardId || afterCardId)) return globalCardOrder;
    let cardsToMove = cardIds.concat();
    // When multiple cards including both subtasks and
    // non-subtasks have moved, and the dropped card is
    // a non-subtask, the subtasks will keep their global order,
    // while the non-subtasks will have their order changed
    // based on beforeCardId or afterCardId
    if (isMovingSubtasks) cardsToMove = $13554e2871800c00$var$removeSubtasks(cards, cardIds);
    // Remove all the cards that have moved, to be
    // placed back into their new position below
    const newCardOrderGlobal = globalCardOrder.filter((cardId)=>!cardsToMove.includes(cardId));
    const insertIndex = beforeCardId ? newCardOrderGlobal.indexOf(beforeCardId) : newCardOrderGlobal.indexOf(afterCardId) + 1;
    newCardOrderGlobal.splice(insertIndex, 0, ...$13554e2871800c00$export$546ed7c4f4fa68f9(globalCardOrder, cardsToMove));
    return newCardOrderGlobal;
};

});
parcelRegister("lt7Oy", function(module, exports) {

$parcel$export(module.exports, "getCardOrderGlobal", () => $3d50e9abbfaef6cd$export$befde80c539a6f40);
$parcel$export(module.exports, "getCardOrderByCardlistId", () => $3d50e9abbfaef6cd$export$e79e737a0d7a721b);

var $e5nhF = parcelRequire("e5nhF");
const $3d50e9abbfaef6cd$export$b7cd5af9264d7384 = (state)=>(0, $e5nhF.getEntities)(state).cardOrder;
const $3d50e9abbfaef6cd$export$befde80c539a6f40 = (state)=>(0, $e5nhF.getEntities)(state).cardOrderGlobal;
const $3d50e9abbfaef6cd$export$e79e737a0d7a721b = (state, cardListId)=>$3d50e9abbfaef6cd$export$b7cd5af9264d7384(state)[cardListId];

});



parcelRegister("aXaCi", function(module, exports) {

$parcel$export(module.exports, "cardsMoveRequestEpic", () => $8ccaab8bb1e5bac0$export$8d85b975065644ab);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("c66Ur");
parcelRequire("fPS7b");
parcelRequire("d0pqD");

var $2YZCu = parcelRequire("2YZCu");

var $8zOmE = parcelRequire("8zOmE");

var $2lpqS = parcelRequire("2lpqS");

var $86ezP = parcelRequire("86ezP");

var $f01qr = parcelRequire("f01qr");

var $guzeq = parcelRequire("guzeq");


var $bhjL2 = parcelRequire("bhjL2");

var $4aiwT = parcelRequire("4aiwT");

var $lDAfn = parcelRequire("lDAfn");

var $7PjMX = parcelRequire("7PjMX");

var $3oKOV = parcelRequire("3oKOV");

var $iruXQ = parcelRequire("iruXQ");

var $i4Z8q = parcelRequire("i4Z8q");


var $ifBw8 = parcelRequire("ifBw8");

var $lyvhj = parcelRequire("lyvhj");

var $3lZ6i = parcelRequire("3lZ6i");

var $a1ybZ = parcelRequire("a1ybZ");

var $6GNN7 = parcelRequire("6GNN7");

var $5Eoed = parcelRequire("5Eoed");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $1z1J7 = parcelRequire("1z1J7");
const $8ccaab8bb1e5bac0$var$isCardsMoveNonOptimisticRequestAction = (action)=>action && 'meta' in action && 'optimisticId' in action.meta;
const $8ccaab8bb1e5bac0$var$getOptimisticId = (action)=>$8ccaab8bb1e5bac0$var$isCardsMoveNonOptimisticRequestAction(action) ? action.meta.optimisticId : action.meta.optimistic.id;
const $8ccaab8bb1e5bac0$var$getTargetStatusId = (action)=>{
    if (action.payload.selectedTransition) return String(action.payload.selectedTransition.toStatusId);
    return action.payload.targetStatusId;
};
const $8ccaab8bb1e5bac0$var$moveToSprint = (params)=>(0, $7PjMX.default)(params.baseUrl, params.rankCustomFieldId, Number(params.rapidViewId), Number(params.cardList.id), params.cardKeys, params.beforeCardKey, params.afterCardKey, false);
const $8ccaab8bb1e5bac0$var$moveCardToList = (params, targetColumn, isCompanyManaged, isCmpKanban)=>isCompanyManaged ? (0, $iruXQ.transitionAndRankService)({
        rankCustomFieldId: params.rankCustomFieldId,
        issueKeys: params.cardKeys,
        targetColumn: targetColumn,
        rankBeforeIssueIdOrKey: params.beforeCardKey,
        rankAfterIssueIdOrKey: params.afterCardKey,
        rapidViewId: Number(params.rapidViewId),
        selectedTransitionId: params.selectedTransition?.id,
        calculateNewIssuesOrder: isCmpKanban
    }) : (0, $bhjL2.default)(params.baseUrl, params.rankCustomFieldId, params.cardKeys, params.beforeCardKey, params.afterCardKey, Number(params.rapidViewId), params.cardListId);
const $8ccaab8bb1e5bac0$var$moveCardToBacklog = (params)=>(0, $7PjMX.default)(params.baseUrl, params.rankCustomFieldId, Number(params.rapidViewId), null, params.cardKeys, params.beforeCardKey, params.afterCardKey, true);
const $8ccaab8bb1e5bac0$var$moveInsideList = (params, errorLogAttributes)=>{
    if (!params.beforeCardKey && !params.afterCardKey) {
        if (errorLogAttributes) (0, $2YZCu.default).safeErrorWithoutCustomerData('jsw.backlog.cards-move.request-epic', 'Failed to rank cards due to missing beforeCardKey and afterCardKey', errorLogAttributes);
        return (0, $kVLXA.Observable).empty();
    }
    if (params.afterCardKey) return (0, $4aiwT.default)(params.baseUrl, params.rankCustomFieldId, params.cardKeys, params.afterCardKey);
    return (0, $lDAfn.default)(params.baseUrl, params.rankCustomFieldId, params.cardKeys, params.beforeCardKey);
};
const $8ccaab8bb1e5bac0$export$e9800111bfe3c5b3 = (action, state, servicePayload)=>{
    const { payload: { isBetweenLists: isBetweenLists, beforeCardId: beforeCardId, afterCardId: afterCardId } } = action;
    const serviceContext = (0, $i4Z8q.makeServiceContext)(state);
    const { cardListType: cardListType } = servicePayload;
    const errorLogAttributes = {
        beforeCardId: beforeCardId,
        afterCardId: afterCardId,
        isCompanyManaged: serviceContext.isCompanyManaged
    };
    // move cards within a Sprint or to a different Sprint list when in Scrum board
    if (cardListType === (0, $guzeq.SPRINT)) {
        if (serviceContext.isCompanyManaged) return $8ccaab8bb1e5bac0$var$moveToSprint(servicePayload);
        return $8ccaab8bb1e5bac0$var$moveToSprint(servicePayload);
    }
    // move cards within the backlog or to the backlog when in Scrum board
    if ((0, $jG5HW.getBacklogStrategy)(state) === (0, $guzeq.SPRINT) && cardListType === (0, $guzeq.BACKLOG)) {
        if (serviceContext.isCompanyManaged) return $8ccaab8bb1e5bac0$var$moveCardToBacklog(servicePayload);
        return $8ccaab8bb1e5bac0$var$moveCardToBacklog(servicePayload);
    }
    const targetColumnId = (0, $jG5HW.getKanbanTargetColumnId)(state)(servicePayload.cardListType);
    if (serviceContext.isCompanyManaged && (0, $jG5HW.isKanbanBacklogStrategy)(state)) {
        // move cards from one list to another list for Kanban board
        if (isBetweenLists) {
            const isCompanyManagedKanban = true;
            return $8ccaab8bb1e5bac0$var$moveCardToList(servicePayload, targetColumnId, serviceContext.isCompanyManaged, isCompanyManagedKanban);
        }
        // move cards within a list for Kanban board
        return $8ccaab8bb1e5bac0$var$moveInsideList(servicePayload, errorLogAttributes);
    }
    // move cards from one list to another list for Kanban board
    if (isBetweenLists) return $8ccaab8bb1e5bac0$var$moveCardToList(servicePayload, targetColumnId, serviceContext.isCompanyManaged, (0, $jG5HW.isKanbanBacklogStrategy)(state));
    // move cards within a list for Kanban board
    return $8ccaab8bb1e5bac0$var$moveInsideList(servicePayload, errorLogAttributes);
};
const $8ccaab8bb1e5bac0$var$rankForTransitionScreen = (action, params)=>(transitionScreenEvent)=>{
        const { payload: { cardIds: cardIds, cardListId: cardListId, selectedTransition: selectedTransition }, meta: { analyticsEvent: analyticsEvent } } = action;
        const optimisticId = $8ccaab8bb1e5bac0$var$getOptimisticId(action);
        const analyticsEventProperties = {
            withSelectedTransition: !!selectedTransition
        };
        if ((0, $lyvhj.isShowEvent)(transitionScreenEvent)) {
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'transitionScreen show', analyticsEventProperties);
            return (0, $kVLXA.Observable).empty();
        }
        if ((0, $lyvhj.isSuccessfulEvent)(transitionScreenEvent)) {
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'transitionScreen success', analyticsEventProperties);
            return $8ccaab8bb1e5bac0$var$moveInsideList(params).map(()=>(0, $6GNN7.cardsMoveSuccess)(optimisticId, cardIds, cardListId, analyticsEvent, $8ccaab8bb1e5bac0$var$getTargetStatusId(action)));
        }
        (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'transitionScreen cancel', analyticsEventProperties);
        return (0, $kVLXA.Observable).of((0, $6GNN7.cardsMoveCancel)(optimisticId, analyticsEvent));
    };
const $8ccaab8bb1e5bac0$var$handleMoveCardSuccess = (action, state, dispatch, params)=>(response)=>{
        const serviceContext = (0, $i4Z8q.makeServiceContext)(state);
        const { payload: { cardIds: cardIds, cardListId: cardListId, isBetweenLists: isBetweenLists, beforeCardId: beforeCardId, afterCardId: afterCardId }, meta: { analyticsEvent: analyticsEvent } } = action;
        const optimisticId = $8ccaab8bb1e5bac0$var$getOptimisticId(action);
        const { cardKeys: cardKeys } = params;
        if (!serviceContext.isCompanyManaged) return (0, $kVLXA.Observable).of((0, $6GNN7.cardsMoveSuccess)(optimisticId, cardIds, cardListId, analyticsEvent));
        if ((0, $3oKOV.isFailedTransitionAndRankResponse)(response) && (0, $3oKOV.hasMultipleTransitions)(response)) {
            const transitions = (0, $3oKOV.getPossibleTransitions)(response).map((possibleTransition)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                ({
                    id: possibleTransition.id,
                    name: possibleTransition.name,
                    hasScreen: possibleTransition.hasTransitionView,
                    toStatusId: possibleTransition.targetStatus
                }));
            return (0, $kVLXA.Observable).of((0, $5Eoed.openModal)({
                type: (0, $b107c54ec82f76f2$export$dcb8eb3e585ecde),
                payload: {
                    cardKeys: cardKeys,
                    transitions: transitions,
                    moveCardsActionPayload: {
                        cardIds: cardIds,
                        cardListId: cardListId,
                        isBetweenLists: isBetweenLists,
                        beforeCardId: beforeCardId,
                        afterCardId: afterCardId
                    },
                    optimisticId: optimisticId,
                    analyticsEvent: analyticsEvent
                }
            }));
        }
        if ((0, $3oKOV.isFailedTransitionAndRankResponse)(response) && (0, $3oKOV.hasTransitionScreens)(response)) {
            const transition = (0, $3oKOV.getFirstTransitionScreen)(response);
            if (!transition) return (0, $kVLXA.Observable).of((0, $6GNN7.cardsMoveCancel)(optimisticId, analyticsEvent));
            return (0, $ifBw8.transitionScreenDialogService)({
                issueId: cardIds[0],
                issueKey: cardKeys[0],
                transitionId: transition.id,
                analyticsEvent: analyticsEvent,
                dispatch: dispatch
            }).flatMap($8ccaab8bb1e5bac0$var$rankForTransitionScreen(action, params));
        }
        if (serviceContext.isCompanyManaged && (0, $jG5HW.getBacklogStrategy)(state) === (0, $guzeq.KANBAN_BACKLOG_STRATEGY)) {
            const actions = [
                (0, $6GNN7.cardsMoveSuccess)(optimisticId, cardIds, cardListId, analyticsEvent, $8ccaab8bb1e5bac0$var$getTargetStatusId(action)),
                // TODO: Review why we need this and avoid it on most cases
                // This will refresh
                (0, $3lZ6i.refreshDataRequest)((0, $guzeq.REFRESH_SOURCE_KANBAN_CARD_MOVE_SUCCESS))
            ];
            const getCardIdFromCardKey = (0, $dGljH.makeCardIdFromCardKey)(state);
            const newCardOrder = (0, $3oKOV.getNewCardOrder)(response)?.map((cardKey)=>getCardIdFromCardKey(cardKey));
            if (newCardOrder) actions.push((0, $a1ybZ.setCardOrderGlobal)(newCardOrder));
            return (0, $kVLXA.Observable).from(actions);
        }
        return (0, $kVLXA.Observable).of((0, $6GNN7.cardsMoveSuccess)(optimisticId, cardIds, cardListId, analyticsEvent, $8ccaab8bb1e5bac0$var$getTargetStatusId(action)));
    };
const $8ccaab8bb1e5bac0$var$getCardMoveParams = (action, state)=>{
    const { payload: { cardIds: cardIds, cardListId: cardListId, beforeCardId: beforeCardId, afterCardId: afterCardId, selectedTransition: selectedTransition } } = action;
    const rankCustomFieldId = (0, $jG5HW.getRankCustomFieldId)(state);
    if (!rankCustomFieldId) return null;
    const baseUrl = (0, $jG5HW.getBaseUrl)(state);
    const cardEntities = (0, $dGljH.getCards)(state);
    const cardLists = (0, $dGljH.getCardLists)(state);
    const isCardMoveDisabled = (0, $jG5HW.isCardMoveDisabled)(state);
    if (cardListId === String((0, $2lpqS.UNASSIGNED_EPIC_ID))) return null;
    const cardKeys = cardIds.map((id)=>cardEntities[String(id)].key);
    const rapidViewId = (0, $jG5HW.getRapidViewId)(state);
    const derivedCardListId = (0, $f01qr.getCardListId)(cardListId);
    const cardList = cardLists[derivedCardListId];
    const cardListType = cardList.type;
    const getCardKeyByCardId = (0, $dGljH.makeCardKeyFromCardId)(state);
    const beforeCardKey = !isCardMoveDisabled && beforeCardId ? getCardKeyByCardId(beforeCardId) : null;
    const afterCardKey = !isCardMoveDisabled && afterCardId ? getCardKeyByCardId(afterCardId) : null;
    return {
        cardIds: cardIds,
        cardKeys: cardKeys,
        cardListId: derivedCardListId,
        cardList: cardList,
        cardListType: cardListType,
        beforeCardKey: beforeCardKey,
        afterCardKey: afterCardKey,
        baseUrl: baseUrl,
        rankCustomFieldId: rankCustomFieldId,
        rapidViewId: rapidViewId,
        selectedTransition: selectedTransition
    };
};
const $8ccaab8bb1e5bac0$export$8d85b975065644ab = (action$, store)=>action$.ofType((0, $6GNN7.CARDS_MOVE_REQUEST), (0, $6GNN7.CARDS_MOVE_NON_OPTIMISTIC_REQUEST)).mergeMap((action)=>{
        const state = store.getState();
        const dispatch = store.dispatch.bind(store);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const cardsMoveAction = action;
        const { payload: { cardIds: cardIds, cardListId: cardListId, isBetweenLists: isBetweenLists }, meta: { analyticsEvent: analyticsEvent } } = cardsMoveAction;
        const optimisticId = $8ccaab8bb1e5bac0$var$getOptimisticId(cardsMoveAction);
        // Card move is disabled only if in a CMP board jql filter is not order by RANK
        const cardMoveDisabled = (0, $jG5HW.isCardMoveDisabled)(state);
        if (!isBetweenLists && cardMoveDisabled) return (0, $kVLXA.Observable).from([
            (0, $6GNN7.cardsMoveDisabled)(optimisticId, analyticsEvent, (0, $jG5HW.getRapidViewId)(state), (0, $1z1J7.canEditBoardConfig)(state)),
            (0, $3lZ6i.refreshDataRequest)((0, $guzeq.REFRESH_SOURCE_FAILURE))
        ]);
        const cardMoveParams = $8ccaab8bb1e5bac0$var$getCardMoveParams(cardsMoveAction, state);
        if (!cardMoveParams) return (0, $kVLXA.Observable).empty();
        const { cardKeys: cardKeys } = cardMoveParams;
        const serviceContext = (0, $i4Z8q.makeServiceContext)(state);
        if (serviceContext.isCompanyManaged && (0, $jG5HW.getBacklogStrategy)(state) === (0, $guzeq.KANBAN_BACKLOG_STRATEGY) && cardMoveParams.selectedTransition && cardMoveParams.selectedTransition.hasScreen) return (0, $ifBw8.transitionScreenDialogService)({
            issueId: cardIds[0],
            issueKey: cardKeys[0],
            transitionId: cardMoveParams.selectedTransition.id,
            analyticsEvent: analyticsEvent,
            dispatch: dispatch
        }).flatMap($8ccaab8bb1e5bac0$var$rankForTransitionScreen(action, cardMoveParams));
        return $8ccaab8bb1e5bac0$export$e9800111bfe3c5b3(cardsMoveAction, state, cardMoveParams).flatMap($8ccaab8bb1e5bac0$var$handleMoveCardSuccess(cardsMoveAction, state, dispatch, cardMoveParams)).catch((error)=>{
            (0, $2YZCu.default).safeErrorWithoutCustomerData('backlog.cards-move.failure', 'Failed to move cards', error);
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'issueTransition failed', {
                triggerPointKey: (0, $708436aca879dc5c$export$7b6d848ab1be1ec3),
                isModalOpen: false
            });
            return (0, $kVLXA.Observable).from([
                (0, $86ezP.hasJiraErrorMessages)(error) ? (0, $6GNN7.cardsTransitionAndRankFailure)(optimisticId, (0, $86ezP.parseJiraErrorMessages)(error), analyticsEvent) : (0, $6GNN7.cardsMoveFailure)(optimisticId, cardIds, cardListId, analyticsEvent, error),
                (0, $3lZ6i.refreshDataRequest)((0, $guzeq.REFRESH_SOURCE_FAILURE))
            ]);
        });
    });

});
parcelRegister("86ezP", function(module, exports) {

$parcel$export(module.exports, "hasJiraErrorMessages", () => $04ea1bc08d605bdc$export$7ee986d35f407138);
$parcel$export(module.exports, "parseJiraErrorMessages", () => $04ea1bc08d605bdc$export$d11297bc34463f4);

var $9XE6b = parcelRequire("9XE6b");
const $04ea1bc08d605bdc$var$parseMessage = (error)=>{
    if (error === null || typeof error !== 'object') return null;
    try {
        const message = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
            'message'
        ], null);
        return JSON.parse(message);
    } catch  {
        return null;
    }
};
const $04ea1bc08d605bdc$var$hasErrorMessagesProperty = (response)=>response !== null && typeof response === 'object' && 'errorMessages' in response && Array.isArray(response.errorMessages);
function $04ea1bc08d605bdc$export$7ee986d35f407138(error) {
    const response = $04ea1bc08d605bdc$var$parseMessage(error);
    return $04ea1bc08d605bdc$var$hasErrorMessagesProperty(response) && response.errorMessages.length > 0;
}
function $04ea1bc08d605bdc$export$d11297bc34463f4(error) {
    const response = $04ea1bc08d605bdc$var$parseMessage(error);
    if ($04ea1bc08d605bdc$var$hasErrorMessagesProperty(response)) return response.errorMessages;
    return [];
}

});

parcelRegister("bhjL2", function(module, exports) {

$parcel$export(module.exports, "default", () => $59919940a3a06e64$export$2e2bcd8739ae039);

var $7zmUm = parcelRequire("7zmUm");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$59919940a3a06e64$export$2e2bcd8739ae039 = (baseUrl, rankCustomFieldId, issueKeys, rankBeforeIssueIdOrKey, rankAfterIssueIdOrKey, rapidViewId, target)=>(0, $7zmUm.default)(`${baseUrl}/rest/greenhopper/1.0/xboard/assignToListAndRank`, {
        method: 'PUT',
        body: JSON.stringify({
            calculateNewIssuesOrder: false,
            issueKeys: issueKeys,
            rankBeforeIssueIdOrKey: rankBeforeIssueIdOrKey,
            rankAfterIssueIdOrKey: rankAfterIssueIdOrKey,
            rankCustomFieldId: rankCustomFieldId,
            rapidViewId: rapidViewId,
            target: target
        })
    });

});
parcelRegister("7zmUm", function(module, exports) {

$parcel$export(module.exports, "default", () => $198ed207dec01cca$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $5HnTq = parcelRequire("5HnTq");

var $fnyT4 = parcelRequire("fnyT4");

var $jJZqs = parcelRequire("jJZqs");

var $8KpGl = parcelRequire("8KpGl");

var $51xpa = parcelRequire("51xpa");
const $198ed207dec01cca$var$noContentStatus = 204;
var // This function returns a stream which emits a single string value on success, and throws
// an error on failure
// eslint-disable-next-line jira/import/no-anonymous-default-export
$198ed207dec01cca$export$2e2bcd8739ae039 = (url, options = {})=>(0, $kVLXA.Observable).of(url).mergeMap(()=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $7uUwQ.merge)((0, $7uUwQ.merge)((0, $5HnTq.defaultOptions), options), (0, $51xpa.makeObservabilityHeaders)(url)))).mergeMap((response)=>{
        if (!response.ok) {
            const { status: status } = response;
            const traceId = response.headers.get((0, $fnyT4.TRACE_ID_HEADER));
            if (traceId != null && traceId !== '') throw new (0, $jJZqs.default)(status, `Fetch call failed with status code: ${response.status}`, traceId);
            else throw new (0, $jJZqs.default)(status);
        }
        if (response.status === $198ed207dec01cca$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty<never>()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $kVLXA.Observable).of(null);
        // @ts-expect-error - TS2339 - Property 'responseText' does not exist on type 'Response'.
        return (0, $kVLXA.Observable).of(response.responseText || 'OK');
    });

});


parcelRegister("4aiwT", function(module, exports) {

$parcel$export(module.exports, "default", () => $d597f77b0d3b31b1$export$2e2bcd8739ae039);

var $7zmUm = parcelRequire("7zmUm");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d597f77b0d3b31b1$export$2e2bcd8739ae039 = (baseUrl, customFieldId, issueKeys, rankAfterKey)=>(0, $7zmUm.default)(`${baseUrl}/rest/greenhopper/1.0/api/rank/after`, {
        method: 'PUT',
        body: JSON.stringify({
            customFieldId: customFieldId,
            issueKeys: issueKeys,
            rankAfterKey: rankAfterKey
        })
    });

});

parcelRegister("lDAfn", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c62d96eb390687c$export$2e2bcd8739ae039);

var $7zmUm = parcelRequire("7zmUm");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8c62d96eb390687c$export$2e2bcd8739ae039 = (baseUrl, customFieldId, issueKeys, rankBeforeKey)=>(0, $7zmUm.default)(`${baseUrl}/rest/greenhopper/1.0/api/rank/before`, {
        method: 'PUT',
        body: JSON.stringify({
            customFieldId: customFieldId,
            issueKeys: issueKeys,
            rankBeforeKey: rankBeforeKey
        })
    });

});

parcelRegister("7PjMX", function(module, exports) {

$parcel$export(module.exports, "default", () => $14a402c1819855ea$export$2e2bcd8739ae039);

var $7zmUm = parcelRequire("7zmUm");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$14a402c1819855ea$export$2e2bcd8739ae039 = (baseUrl, customFieldId, rapidViewId, sprintId, issueKeys, rankBeforeKey, rankAfterKey, addToBacklog)=>(0, $7zmUm.default)(`${baseUrl}/rest/greenhopper/1.0/sprint/rank`, {
        method: 'PUT',
        body: JSON.stringify({
            addToBacklog: addToBacklog,
            calculateNewIssuesOrder: false,
            customFieldId: customFieldId,
            idOrKeys: issueKeys,
            rapidViewId: rapidViewId,
            sprintId: sprintId,
            ...rankAfterKey ? {
                idOrKeyAfter: rankAfterKey
            } : {},
            ...!rankAfterKey && rankBeforeKey ? {
                idOrKeyBefore: rankBeforeKey
            } : {}
        })
    });

});

parcelRegister("3oKOV", function(module, exports) {

$parcel$export(module.exports, "isFailedTransitionAndRankResponse", () => $d27d53af272cdb68$export$baa57c6351668324);
$parcel$export(module.exports, "hasTransitionScreens", () => $d27d53af272cdb68$export$197df750c1dc3961);
$parcel$export(module.exports, "hasMultipleTransitions", () => $d27d53af272cdb68$export$e642abf2d8cab89c);
$parcel$export(module.exports, "getFirstTransitionScreen", () => $d27d53af272cdb68$export$b886c9119f3b41db);
$parcel$export(module.exports, "getPossibleTransitions", () => $d27d53af272cdb68$export$a422da2e79341934);
$parcel$export(module.exports, "getNewCardOrder", () => $d27d53af272cdb68$export$5455144e38b4d576);
function $d27d53af272cdb68$export$baa57c6351668324(response) {
    if (response !== null && typeof response === 'object') return 'issuesWereTransitioned' in response && !response.issuesWereTransitioned;
    return false;
}
function $d27d53af272cdb68$export$197df750c1dc3961(response) {
    return response.possibleTransitions.length > 0 && response.possibleTransitions.some((transition)=>transition.hasTransitionView);
}
function $d27d53af272cdb68$export$e642abf2d8cab89c(response) {
    return response.possibleTransitions.length > 1;
}
function $d27d53af272cdb68$export$b886c9119f3b41db(response) {
    return response.possibleTransitions.find((transition)=>transition.hasTransitionView);
}
function $d27d53af272cdb68$export$a422da2e79341934(response) {
    return response.possibleTransitions || [];
}
function $d27d53af272cdb68$export$5455144e38b4d576(response) {
    return response !== null && typeof response === 'object' && response.newIssuesOrder !== undefined ? response.newIssuesOrder : null;
}

});

parcelRegister("iruXQ", function(module, exports) {

$parcel$export(module.exports, "transitionAndRankService", () => $49ab892d169e619b$export$dfb4be6fa5ae4b7);

var $iAiqV = parcelRequire("iAiqV");
const $49ab892d169e619b$export$dfb4be6fa5ae4b7 = ({ rankCustomFieldId: rankCustomFieldId, issueKeys: issueKeys, targetColumn: targetColumn, rankBeforeIssueIdOrKey: rankBeforeIssueIdOrKey, rankAfterIssueIdOrKey: rankAfterIssueIdOrKey, rapidViewId: rapidViewId, selectedTransitionId: selectedTransitionId, calculateNewIssuesOrder: calculateNewIssuesOrder = false })=>(0, $iAiqV.transitionAndRankFetch)({
        rankCustomFieldId: rankCustomFieldId,
        issueKeys: issueKeys,
        targetColumn: targetColumn,
        rankBeforeIssueIdOrKey: rankBeforeIssueIdOrKey,
        rankAfterIssueIdOrKey: rankAfterIssueIdOrKey,
        rapidViewId: rapidViewId,
        selectedTransitionId: selectedTransitionId,
        calculateNewIssuesOrder: calculateNewIssuesOrder
    });

});
parcelRegister("iAiqV", function(module, exports) {

$parcel$export(module.exports, "transitionAndRankFetch", () => $75b32455d39c3970$export$11e7ff3f2320f2c4);

var $487fd = parcelRequire("487fd");
const $75b32455d39c3970$export$11e7ff3f2320f2c4 = ({ rankCustomFieldId: rankCustomFieldId, issueKeys: issueKeys, targetColumn: targetColumn, rankBeforeIssueIdOrKey: rankBeforeIssueIdOrKey, rankAfterIssueIdOrKey: rankAfterIssueIdOrKey, rapidViewId: rapidViewId, selectedTransitionId: selectedTransitionId, calculateNewIssuesOrder: calculateNewIssuesOrder = false })=>(0, $487fd.default)('/rest/greenhopper/1.0/xboard/transitionAndRank', {
        method: 'PUT',
        body: JSON.stringify({
            mode: 'plan',
            calculateNewIssuesOrder: calculateNewIssuesOrder,
            rapidViewId: rapidViewId,
            issueKeys: issueKeys,
            targetColumn: targetColumn,
            rankCustomFieldId: rankCustomFieldId,
            rankBeforeIssueIdOrKey: rankBeforeIssueIdOrKey,
            rankAfterIssueIdOrKey: rankAfterIssueIdOrKey,
            selectedTransitionId: selectedTransitionId
        })
    });

});


const $708436aca879dc5c$export$33dc74496d86bd4a = 'SHOW_EVENT';
const $708436aca879dc5c$export$d03e9fb76fb73c30 = 'SUCCESS_EVENT';
const $708436aca879dc5c$export$c2f5880ac823ea8e = 'CANCEL_EVENT';
const $708436aca879dc5c$export$7b6d848ab1be1ec3 = 'software-backlog-issue-transition';

parcelRegister("ifBw8", function(module, exports) {

$parcel$export(module.exports, "transitionScreenDialogService", () => $bade04f26adcd1b9$export$659d73295f3a3de8);

var $kVLXA = parcelRequire("kVLXA");

var $8zOmE = parcelRequire("8zOmE");

var $6zjUi = parcelRequire("6zjUi");


var $jOZwR = parcelRequire("jOZwR");
function $bade04f26adcd1b9$export$659d73295f3a3de8({ issueId: issueId, issueKey: issueKey, transitionId: transitionId, analyticsEvent: analyticsEvent, dispatch: dispatch }) {
    return new (0, $kVLXA.Observable)((subscriber)=>{
        const handleDialogSuccess = ()=>{
            subscriber.next((0, $jOZwR.transitionScreenDialogSuccess)());
            subscriber.complete();
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'issueTransition success', {
                triggerPointKey: (0, $708436aca879dc5c$export$7b6d848ab1be1ec3),
                isModalOpen: true
            });
        };
        const handleDialogCancel = ()=>{
            subscriber.next((0, $jOZwR.transitionScreenDialogCancel)());
            subscriber.complete();
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'issueTransition cancel', {
                triggerPointKey: (0, $708436aca879dc5c$export$7b6d848ab1be1ec3),
                isModalOpen: true
            });
        };
        const handleDialogError = (error)=>{
            subscriber.error(error || new Error('Transition screen failed'));
            subscriber.complete();
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'issueTransition failed', {
                triggerPointKey: (0, $708436aca879dc5c$export$7b6d848ab1be1ec3),
                isModalOpen: true
            });
        };
        const handleDialogShow = ()=>{
            subscriber.next((0, $jOZwR.transitionScreenDialogShow)());
        };
        dispatch((0, $6zjUi.openIssueTransitionModal)({
            issueId: String(issueId),
            issueKey: issueKey,
            transitionId: String(transitionId),
            onDialogCancel: handleDialogCancel,
            onDialogError: handleDialogError,
            onDialogSuccess: handleDialogSuccess
        }));
        handleDialogShow();
    });
}

});
parcelRegister("6zjUi", function(module, exports) {

$parcel$export(module.exports, "OPEN_ISSUE_TRANSITION_MODAL", () => $271e58db57b2749f$export$8832c8eada77a7);
$parcel$export(module.exports, "openIssueTransitionModal", () => $271e58db57b2749f$export$bb76131907dfafc);
$parcel$export(module.exports, "CLOSE_ISSUE_TRANSITION_MODAL", () => $271e58db57b2749f$export$e15861bd6dba960e);
$parcel$export(module.exports, "closeIssueTransitionModal", () => $271e58db57b2749f$export$221941c279d4f72);
const $271e58db57b2749f$export$8832c8eada77a7 = 'state.actions.issue.issue-transition-modal.OPEN_ISSUE_TRANSITION_MODAL';
const $271e58db57b2749f$export$bb76131907dfafc = (payload)=>({
        type: $271e58db57b2749f$export$8832c8eada77a7,
        payload: payload
    });
const $271e58db57b2749f$export$e15861bd6dba960e = 'state.actions.issue.issue-transition-modal.CLOSE_ISSUE_TRANSITION_MODAL';
const $271e58db57b2749f$export$221941c279d4f72 = ()=>({
        type: $271e58db57b2749f$export$e15861bd6dba960e
    });

});

parcelRegister("jOZwR", function(module, exports) {

$parcel$export(module.exports, "transitionScreenDialogShow", () => $3527f4d0d7c961d6$export$7cab574154dd97ed);
$parcel$export(module.exports, "transitionScreenDialogSuccess", () => $3527f4d0d7c961d6$export$818eb39bfb8e0008);
$parcel$export(module.exports, "transitionScreenDialogCancel", () => $3527f4d0d7c961d6$export$b353addc50c0b6fe);

const $3527f4d0d7c961d6$export$7cab574154dd97ed = ()=>({
        type: (0, $708436aca879dc5c$export$33dc74496d86bd4a)
    });
const $3527f4d0d7c961d6$export$818eb39bfb8e0008 = ()=>({
        type: (0, $708436aca879dc5c$export$d03e9fb76fb73c30)
    });
const $3527f4d0d7c961d6$export$b353addc50c0b6fe = ()=>({
        type: (0, $708436aca879dc5c$export$c2f5880ac823ea8e)
    });

});


parcelRegister("lyvhj", function(module, exports) {

$parcel$export(module.exports, "isShowEvent", () => $7fb7df51b6c9fae5$export$cd300abbf6342075);
$parcel$export(module.exports, "isSuccessfulEvent", () => $7fb7df51b6c9fae5$export$351a696eb45d767b);

function $7fb7df51b6c9fae5$export$cd300abbf6342075(event) {
    return event.type === (0, $708436aca879dc5c$export$33dc74496d86bd4a);
}
function $7fb7df51b6c9fae5$export$351a696eb45d767b(event) {
    return event.type === (0, $708436aca879dc5c$export$d03e9fb76fb73c30);
}

});

parcelRegister("a1ybZ", function(module, exports) {

$parcel$export(module.exports, "SET_CARD_ORDER_GLOBAL", () => $a5e0723950a9346d$export$596e51910ab2bf17);
$parcel$export(module.exports, "setCardOrderGlobal", () => $a5e0723950a9346d$export$4148d0f8b0a57f36);
const $a5e0723950a9346d$export$596e51910ab2bf17 = 'state.actions.card-order-global.SET_CARD_ORDER_GLOBAL';
const $a5e0723950a9346d$export$4148d0f8b0a57f36 = (cardIds)=>({
        type: $a5e0723950a9346d$export$596e51910ab2bf17,
        payload: cardIds
    });

});


parcelRegister("7w8zv", function(module, exports) {

$parcel$export(module.exports, "cardsNavigateEpic", () => $37d703f3a937c8ec$export$e2e898999df763ff);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("zjDln");
parcelRequire("3awJm");
parcelRequire("fPS7b");

var $lReb9 = parcelRequire("lReb9");

var $cscVG = parcelRequire("cscVG");

var $4mqko = parcelRequire("4mqko");

var $38qhf = parcelRequire("38qhf");

var $abzh7 = parcelRequire("abzh7");

var $dGljH = parcelRequire("dGljH");

var $2Z0Yd = parcelRequire("2Z0Yd");
const $37d703f3a937c8ec$export$e2e898999df763ff = (action$, store)=>action$.ofType((0, $cscVG.CARD_NEXT), (0, $cscVG.CARD_PREV)).throttleTime(250).mergeMap(({ type: type, payload: payload })=>{
        const state = store.getState();
        const activeCardId = (0, $dGljH.getActiveCard)(state);
        const isActiveCardVisible = activeCardId !== undefined ? (0, $abzh7.makeIsCardVisibleAndNotCollapsed)(state)(activeCardId) : false;
        const isNext = type === (0, $cscVG.CARD_NEXT);
        const getFirstSelectableIssueFn = isNext ? (0, $abzh7.getFirstSelectableIssueAscending) : (0, $abzh7.getFirstSelectableIssueDescending);
        const makeNextOrPrevIssueFn = isNext ? (0, $abzh7.makeGetNextSelectableIssue) : (0, $abzh7.makeGetPrevSelectableIssue);
        const nextIssueId = activeCardId !== undefined && isActiveCardVisible ? makeNextOrPrevIssueFn(state)(activeCardId) : getFirstSelectableIssueFn(state);
        const attributes = isNext ? {
            key: 'j',
            id: 'nextIssueKeyboardShortcut'
        } : {
            key: 'k',
            id: 'previousIssueKeyboardShortcut'
        };
        payload.fireShortcutAnalyticsFn(attributes);
        if (nextIssueId !== undefined) {
            const actions = [
                (0, $4mqko.cardSingleSelect)(nextIssueId),
                (0, $lReb9.cardFocus)(nextIssueId)
            ];
            if ((0, $2Z0Yd.isDetailViewOpen)(state)) actions.push((0, $38qhf.openDetailViewDebounced)(nextIssueId));
            return (0, $kVLXA.Observable).from(actions);
        }
        return (0, $kVLXA.Observable).empty();
    });

});
parcelRegister("lReb9", function(module, exports) {

$parcel$export(module.exports, "CARD_FOCUS", () => $34ee37e501257be7$export$7de76f693f0d3820);
$parcel$export(module.exports, "cardFocus", () => $34ee37e501257be7$export$e462552ef1675527);
$parcel$export(module.exports, "CARD_BLUR", () => $34ee37e501257be7$export$6ac448f92e1f338b);
$parcel$export(module.exports, "cardBlur", () => $34ee37e501257be7$export$9dea9abf478df7d7);
const $34ee37e501257be7$export$7de76f693f0d3820 = 'state.actions.cards.focus.CARD_FOCUS';
const $34ee37e501257be7$export$e462552ef1675527 = (cardId)=>({
        type: $34ee37e501257be7$export$7de76f693f0d3820,
        payload: {
            cardId: cardId
        }
    });
const $34ee37e501257be7$export$6ac448f92e1f338b = 'state.actions.cards.focus.CARD_BLUR';
const $34ee37e501257be7$export$9dea9abf478df7d7 = ()=>({
        type: $34ee37e501257be7$export$6ac448f92e1f338b
    });

});

parcelRegister("cscVG", function(module, exports) {

$parcel$export(module.exports, "CARD_NEXT", () => $dfa4dcfddc32a7f2$export$e780294f9cb0bbfd);
$parcel$export(module.exports, "cardNext", () => $dfa4dcfddc32a7f2$export$d848405832f5c1d5);
$parcel$export(module.exports, "CARD_PREV", () => $dfa4dcfddc32a7f2$export$22f722071ae1a37d);
$parcel$export(module.exports, "cardPrev", () => $dfa4dcfddc32a7f2$export$6dc88d98f7609a22);
const $dfa4dcfddc32a7f2$export$e780294f9cb0bbfd = 'state.actions.cards.navigate.CARD_NEXT';
const $dfa4dcfddc32a7f2$export$d848405832f5c1d5 = (fireShortcutAnalyticsFn)=>({
        type: $dfa4dcfddc32a7f2$export$e780294f9cb0bbfd,
        payload: {
            fireShortcutAnalyticsFn: fireShortcutAnalyticsFn
        }
    });
const $dfa4dcfddc32a7f2$export$22f722071ae1a37d = 'state.actions.cards.navigate.CARD_PREV';
const $dfa4dcfddc32a7f2$export$6dc88d98f7609a22 = (fireShortcutAnalyticsFn)=>({
        type: $dfa4dcfddc32a7f2$export$22f722071ae1a37d,
        payload: {
            fireShortcutAnalyticsFn: fireShortcutAnalyticsFn
        }
    });

});

parcelRegister("abzh7", function(module, exports) {

$parcel$export(module.exports, "getFirstSelectableIssueAscending", () => $48c95a9b729fa3da$export$10c0b19e7f67cd54);
$parcel$export(module.exports, "getFirstSelectableIssueDescending", () => $48c95a9b729fa3da$export$66eabf17ea5e1f07);
$parcel$export(module.exports, "makeIsCardVisibleAndNotCollapsed", () => $48c95a9b729fa3da$export$796b5629f15fb2a0);
$parcel$export(module.exports, "makeGetNextSelectableIssue", () => $48c95a9b729fa3da$export$a57bd23e25548782);
$parcel$export(module.exports, "makeGetPrevSelectableIssue", () => $48c95a9b729fa3da$export$6075bf86943a5068);

var $dGvGJ = parcelRequire("dGvGJ");

var $gJBT6 = parcelRequire("gJBT6");

var $jG5HW = parcelRequire("jG5HW");

var $ld0jI = parcelRequire("ld0jI");

var $dGljH = parcelRequire("dGljH");
const $48c95a9b729fa3da$export$c09bebfcb61f3779 = (0, $dGvGJ.createSelector)([
    (0, $dGljH.getVisibleCardListIds),
    (0, $dGljH.makeOrderedVisibleCardIdsForCardList),
    (0, $dGljH.makeGetVisibleCardOrderFromCardEntries),
    (0, $dGljH.makeIsCardListCollapsed)
], (cardListIds, getOrderedVisibleCardsByCardList, getVisibleCardOrderFromCardEntries, isCardListCollapsed)=>cardListIds.filter((id)=>!isCardListCollapsed(id)).map((id)=>getVisibleCardOrderFromCardEntries(id)).find((cardList)=>cardList.length));
const $48c95a9b729fa3da$export$10c0b19e7f67cd54 = (0, $dGvGJ.createSelector)($48c95a9b729fa3da$export$c09bebfcb61f3779, (cardList)=>cardList && cardList[0]);
const $48c95a9b729fa3da$export$66eabf17ea5e1f07 = (0, $dGvGJ.createSelector)($48c95a9b729fa3da$export$c09bebfcb61f3779, (cardList)=>cardList && cardList[cardList.length - 1]);
const $48c95a9b729fa3da$export$796b5629f15fb2a0 = (0, $dGvGJ.createSelector)([
    (0, $dGljH.makeGetCardListIdByCardId),
    (0, $dGljH.makeIsCardListCollapsed),
    (0, $dGljH.makeIsCardVisible),
    (0, $ld0jI.makeIsCardInCollapsedCardGroup),
    (0, $jG5HW.isCmpKanbanProject)
], (getCardListByCardId, isCardListCollapsed, isCardVisible, isCardInCollapsedCardGroup, isCmpKanbanBacklog)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((cardId)=>{
        const cardListId = getCardListByCardId(cardId);
        if (cardListId === undefined) return false;
        if (isCmpKanbanBacklog) return !isCardListCollapsed(cardListId) && !isCardInCollapsedCardGroup(cardId) && isCardVisible(cardId);
        return !isCardListCollapsed(cardListId) && isCardVisible(cardId);
    }));
const $48c95a9b729fa3da$export$1b5a343b24b5f39d = (0, $dGvGJ.createSelector)([
    (0, $dGljH.getVisibleCardListIds),
    (0, $dGljH.makeOrderedVisibleCardIdsForCardList),
    (0, $dGljH.makeGetVisibleCardOrderFromCardEntries),
    (0, $dGljH.makeIsCardListCollapsed)
], (cardListIds, getOrderedVisibleCardsByCardList, getVisibleCardOrderFromCardEntries, isCardListCollapsed)=>cardListIds.filter((id)=>!isCardListCollapsed(id)).map((id)=>getVisibleCardOrderFromCardEntries(id)).flat());
const $48c95a9b729fa3da$export$a57bd23e25548782 = (0, $dGvGJ.createSelector)($48c95a9b729fa3da$export$1b5a343b24b5f39d, (selectableIssues)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((cardId)=>{
        const cardIndex = selectableIssues.indexOf(cardId);
        if (cardIndex < 0) return undefined;
        return selectableIssues[cardIndex + 1];
    }));
const $48c95a9b729fa3da$export$6075bf86943a5068 = (0, $dGvGJ.createSelector)($48c95a9b729fa3da$export$1b5a343b24b5f39d, (selectableIssues)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((cardId)=>{
        const cardIndex = selectableIssues.indexOf(cardId);
        return selectableIssues[cardIndex - 1];
    }));

});

parcelRegister("2Z0Yd", function(module, exports) {

$parcel$export(module.exports, "isDetailViewOpen", () => $ca8ab0542b41ad2e$export$6c8a703f6e6f7f67);
const $ca8ab0542b41ad2e$export$6c8a703f6e6f7f67 = (state)=>Boolean(state.ui.detailView);

});


parcelRegister("f4vxM", function(module, exports) {

$parcel$export(module.exports, "default", () => $76de12c19b37c861$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("zjDln");
parcelRequire("9o0uh");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $2YZCu = parcelRequire("2YZCu");

var $et6P7 = parcelRequire("et6P7");

var $fdAim = parcelRequire("fdAim");

var $dGljH = parcelRequire("dGljH");
function $76de12c19b37c861$export$2e2bcd8739ae039(action$, store) {
    return action$.ofType((0, $et6P7.CARDS_PARENT_SET_OPTIMISTIC)).mergeMap((action)=>{
        const { payload: { cards: cards, parentId: parentId }, meta: { optimistic: optimistic } } = action;
        const cardEntities = (0, $dGljH.getCards)(store.getState());
        const changedCardIds = cards.filter(({ id: id })=>{
            const card = cardEntities[id];
            return card?.parentId !== parentId;
        }).map((card)=>card.id);
        if (changedCardIds.length === 0) return (0, $kVLXA.Observable).of((0, $et6P7.cardsParentSetSuccess)(optimistic.id, {
            cards: cards
        }));
        return (0, $kVLXA.Observable).fromPromise(action.payload.requestPromise).flatMap(()=>(0, $kVLXA.Observable).of((0, $et6P7.cardsParentSetSuccess)(optimistic.id, {
                cards: cards
            }))).catch((error)=>{
            (0, $2YZCu.default).safeErrorWithoutCustomerData('cards.parent-set.failure', 'Failed to set card parent', error);
            const actions = changedCardIds.map((cardId)=>(0, $fdAim.cardRefreshRequest)(cardId));
            return (0, $kVLXA.Observable).from([
                (0, $et6P7.cardsParentSetFailure)(optimistic.id),
                ...actions
            ]);
        });
    });
}

});
parcelRegister("et6P7", function(module, exports) {

$parcel$export(module.exports, "CARDS_PARENT_SET_OPTIMISTIC", () => $5e3c87ff0135645a$export$91e916b961a6d9b);
$parcel$export(module.exports, "cardsParentSetOptimistic", () => $5e3c87ff0135645a$export$3feb2fd47a9012aa);
$parcel$export(module.exports, "CARDS_PARENT_SET_SUCCESS", () => $5e3c87ff0135645a$export$249765deb6efe8ae);
$parcel$export(module.exports, "cardsParentSetSuccess", () => $5e3c87ff0135645a$export$30fe913aeacc7d4c);
$parcel$export(module.exports, "CARDS_PARENT_SET_FAILURE", () => $5e3c87ff0135645a$export$36c7e0e6fa088864);
$parcel$export(module.exports, "cardsParentSetFailure", () => $5e3c87ff0135645a$export$24c3df942a1f1dd5);

var $c0irb = parcelRequire("c0irb");
const $5e3c87ff0135645a$export$91e916b961a6d9b = 'state.actions.cards.parent.CARDS_PARENT_SET_OPTIMISTIC';
const $5e3c87ff0135645a$export$3feb2fd47a9012aa = (payload)=>({
        type: $5e3c87ff0135645a$export$91e916b961a6d9b,
        payload: payload,
        meta: {
            ...(0, $c0irb.beginOptimisticUiMeta)()
        }
    });
const $5e3c87ff0135645a$export$249765deb6efe8ae = 'state.actions.cards.parent.CARDS_PARENT_SET_SUCCESS';
const $5e3c87ff0135645a$export$30fe913aeacc7d4c = (optimisticId, payload)=>({
        type: $5e3c87ff0135645a$export$249765deb6efe8ae,
        payload: payload,
        meta: (0, $c0irb.commitOptimisticUiMeta)(optimisticId)
    });
const $5e3c87ff0135645a$export$36c7e0e6fa088864 = 'state.actions.cards.parent.CARDS_PARENT_SET_FAILURE';
const $5e3c87ff0135645a$export$24c3df942a1f1dd5 = (optimisticId)=>({
        type: $5e3c87ff0135645a$export$36c7e0e6fa088864,
        meta: (0, $c0irb.revertOptimisticUiWithFlagMeta)(optimisticId)
    });

});


parcelRegister("f5yE6", function(module, exports) {

$parcel$export(module.exports, "checkGlobalIssueCreateEpic", () => $e3caf3d5e48a492a$export$c92e72129db344be);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $3lZ6i = parcelRequire("3lZ6i");

var $hf5c2 = parcelRequire("hf5c2");

var $gwOHY = parcelRequire("gwOHY");

var $bAfUr = parcelRequire("bAfUr");
const $e3caf3d5e48a492a$export$c92e72129db344be = (action$, store)=>action$.ofType((0, $3lZ6i.CHECK_GLOBAL_ISSUE_CREATE)).mergeMap((action)=>{
        const { payload: { issues: globalIssues } } = action;
        if (globalIssues.length === 0) return (0, $kVLXA.Observable).empty();
        const state = store.getState();
        const actions = [];
        // We should refetch versions data when an issue is created to keep the version panel on sync
        // and to avoid this issue: https://hello.atlassian.net/browse/FEBA-1548a
        actions.push((0, $gwOHY.refetchVersions)());
        // Check if any globally created issues have unmapped statuses
        // (this doesn't however apply to epics since they will be visible on the backlog and board)
        const columnStatusIds = (0, $bAfUr.getColumnStatusIds)(state);
        const unmappedIssuesExist = globalIssues.filter((issue)=>issue.createdIssueDetails && issue.createdIssueDetails.fields.issuetype.hierarchyLevel < 1).some((issue)=>issue.createdIssueDetails && !columnStatusIds.includes(issue.createdIssueDetails.fields.status.id));
        if (unmappedIssuesExist) {
            const cardsIdentifiers = globalIssues.map((issue)=>({
                    id: Number(issue.issueId),
                    key: issue.issueKey
                }));
            actions.push((0, $hf5c2.cardCreateUnmappedWithIssueLink)(cardsIdentifiers));
        } else actions.push((0, $hf5c2.cardCreateGlobal)(globalIssues));
        return (0, $kVLXA.Observable).from(actions);
    });

});

parcelRegister("hCa2B", function(module, exports) {

$parcel$export(module.exports, "detailViewCloseEpic", () => $ef368a28185fe9b2$export$511093f766907f93);
parcelRequire("6hSeW");
parcelRequire("6cbqE");

var $kVLXA = parcelRequire("kVLXA");

var $luHLg = parcelRequire("luHLg");

var $cik5h = parcelRequire("cik5h");

var $38qhf = parcelRequire("38qhf");

var $l9VFH = parcelRequire("l9VFH");
const $ef368a28185fe9b2$export$511093f766907f93 = (getLocation, push)=>(action$, store)=>action$.ofType((0, $38qhf.CLOSE_DETAIL_VIEW)).switchMap((action)=>{
            const state = store.getState();
            const filters = (0, $l9VFH.getAppliedParentFilters)(state);
            const issueId = action.payload?.issueId;
            push((0, $cik5h.removeSelectedIssueFromUrl)((0, $luHLg.removeIssueParentFromUrlByFilters)(getLocation(), issueId, filters)));
            return (0, $kVLXA.Observable).empty();
        });

});
parcelRegister("luHLg", function(module, exports) {

$parcel$export(module.exports, "removeIssueParentFromUrlByFilters", () => $54b3470035e6f164$export$87a36404d6a49f8a);

var $7uUwQ = parcelRequire("7uUwQ");

var $hGgHi = parcelRequire("hGgHi");

var $ebyGx = parcelRequire("ebyGx");

const $54b3470035e6f164$export$87a36404d6a49f8a = (location, issueId, filters = [])=>{
    const searchParams = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(location.search);
    const updatedSearchParams = (0, $7uUwQ.chain)(searchParams);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(searchParams[0, $4f4a02cead13bb5a$export$8a2cab795731dc42]) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issueId)) {
        const urlIssueParents = searchParams[0, $4f4a02cead13bb5a$export$8a2cab795731dc42].split(',');
        // The closed issueId is in IssueParent QueryParams, but not in Filters , probably caused by deleting epics in detail view
        const issueIdStr = issueId.toString();
        if (urlIssueParents.includes(issueIdStr) && !filters.includes(issueIdStr)) urlIssueParents.splice(urlIssueParents.indexOf(issueIdStr), 1);
        urlIssueParents.length > 0 ? updatedSearchParams.set((0, $4f4a02cead13bb5a$export$8a2cab795731dc42), urlIssueParents.join(',')) : updatedSearchParams.unset((0, $4f4a02cead13bb5a$export$8a2cab795731dc42));
    }
    return {
        ...location,
        search: (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(updatedSearchParams.value())
    };
};

});


parcelRegister("h1Jne", function(module, exports) {

$parcel$export(module.exports, "detailViewOpenDebouncedEpic", () => $0c01dab87f8c9561$export$2e5970b542a40342);
parcelRequire("fp4O3");
parcelRequire("eSGL3");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $cik5h = parcelRequire("cik5h");

var $38qhf = parcelRequire("38qhf");

var $dGljH = parcelRequire("dGljH");
const $0c01dab87f8c9561$export$2e5970b542a40342 = (getLocation, push)=>(action$, store)=>action$.ofType((0, $38qhf.OPEN_DETAIL_VIEW_DEBOUNCED)).debounceTime(500).mergeMap((action)=>{
            push((0, $cik5h.addSelectedIssueToUrl)((0, $dGljH.makeCardKeyFromCardId)(store.getState())(action.payload.cardId), getLocation()));
            return (0, $kVLXA.Observable).of((0, $38qhf.openDetailView)(action.payload.cardId, action.payload.externalAction));
        });

});

parcelRegister("7u8UG", function(module, exports) {

$parcel$export(module.exports, "detailViewUpdateEpic", () => $abc7cf427dc3e86e$export$ddc67837ea92e238);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("6cbqE");

var $eSSqy = parcelRequire("eSSqy");

var $aKajY = parcelRequire("aKajY");

var $6GNN7 = parcelRequire("6GNN7");

var $et6P7 = parcelRequire("et6P7");

var $38qhf = parcelRequire("38qhf");

var $czUNp = parcelRequire("czUNp");

var $dGljH = parcelRequire("dGljH");
const $abc7cf427dc3e86e$export$ddc67837ea92e238 = (action$, store)=>action$.ofType((0, $aKajY.CARDS_FLAG_WITH_COMMENT_SUCCESS), (0, $et6P7.CARDS_PARENT_SET_SUCCESS), (0, $6GNN7.CARDS_MOVE_SUCCESS), (0, $czUNp.CARD_STATUS_SET), (0, $eSSqy.CARDS_BULK_OPERATIONS_SUCCESS)).switchMap((action)=>{
        const state = store.getState();
        const { cardId: cardId } = (0, $dGljH.getDetailViewData)(state) || {};
        if (!cardId) return (0, $kVLXA.Observable).empty();
        if (action.type === (0, $eSSqy.CARDS_BULK_OPERATIONS_SUCCESS)) {
            if (action.payload.includes(cardId)) return (0, $kVLXA.Observable).of((0, $38qhf.updateDetailView)());
        }
        if (action.type === (0, $aKajY.CARDS_FLAG_WITH_COMMENT_SUCCESS) && action.payload.cards.includes(cardId)) return (0, $kVLXA.Observable).of((0, $38qhf.updateDetailView)());
        if (action.type === (0, $et6P7.CARDS_PARENT_SET_SUCCESS) && action.payload.cards.map((card)=>card.id).includes(cardId)) return (0, $kVLXA.Observable).of((0, $38qhf.updateDetailView)());
        if (action.type === (0, $6GNN7.CARDS_MOVE_SUCCESS)) {
            const parentIds = (0, $dGljH.partialCardsFromCardIdsSelector)(state)(action.payload.cardIds).map((card)=>card.parentId);
            if (action.payload.cardIds.includes(cardId) || parentIds.includes(cardId)) return (0, $kVLXA.Observable).of((0, $38qhf.updateDetailView)());
        }
        return (0, $kVLXA.Observable).empty();
    });

});

parcelRegister("3xTTB", function(module, exports) {

$parcel$export(module.exports, "refetchEpicPanelEpic", () => $edb8106e01e05ab1$export$da2d2f9f49d2aaf1);

var $aB8eX = parcelRequire("aB8eX");

var $kVLXA = parcelRequire("kVLXA");

var $5fc53 = parcelRequire("5fc53");
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("eSGL3");
parcelRequire("6cbqE");

var $3bPZM = parcelRequire("3bPZM");

var $bKpgX = parcelRequire("bKpgX");

var $3lZ6i = parcelRequire("3lZ6i");

var $js96S = parcelRequire("js96S");

var $hf5c2 = parcelRequire("hf5c2");

var $legw4 = parcelRequire("legw4");
const $edb8106e01e05ab1$var$isCardSetIndividualResponse = (action)=>action.type === (0, $js96S.CARD_SET_INDIVIDUAL_REQUEST_SUCCESS);
const $edb8106e01e05ab1$var$isBatchCardParentSetSuccess = (batchAction)=>batchAction.payload.some((action)=>$edb8106e01e05ab1$var$isCardSetIndividualResponse(action) && action.payload.fieldId === (0, $5fc53.PARENT_TYPE));
const $edb8106e01e05ab1$var$REFETCH_EPIC_PANEL_DEBOUNCE_MS = 500;
const $edb8106e01e05ab1$export$da2d2f9f49d2aaf1 = (action$)=>action$.ofType((0, $3lZ6i.REFRESH_DATA_REQUEST), (0, $hf5c2.CARD_CREATE_SUCCESS), (0, $legw4.CARD_DELETE_SUCCESS), (0, $aB8eX.BATCH)).debounceTime($edb8106e01e05ab1$var$REFETCH_EPIC_PANEL_DEBOUNCE_MS).switchMap((action)=>{
        if (action.type === (0, $aB8eX.BATCH) && !$edb8106e01e05ab1$var$isBatchCardParentSetSuccess(action)) return (0, $kVLXA.Observable).empty();
        const epicPanelRefetchStoreInstance = (0, $bKpgX.defaultRegistry).getStore((0, $3bPZM.EpicPanelRefetchStore));
        const { triggerEpicPanelRefetch: triggerEpicPanelRefetch } = epicPanelRefetchStoreInstance.actions;
        triggerEpicPanelRefetch();
        return (0, $kVLXA.Observable).empty();
    });

});
parcelRegister("3bPZM", function(module, exports) {

$parcel$export(module.exports, "EpicPanelRefetchStore", () => $a89a33b3e24797dc$export$161cbc183f817581);
$parcel$export(module.exports, "useShouldRefetchEpicPanel", () => $a89a33b3e24797dc$export$3c3bb9bb30c98856);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $a89a33b3e24797dc$var$triggerEpicPanelRefetch = ()=>({ setState: setState })=>{
        setState({
            shouldRefetchEpicPanel: true
        });
    };
const $a89a33b3e24797dc$var$finishEpicPanelRefetch = ()=>({ setState: setState })=>{
        setState({
            shouldRefetchEpicPanel: false
        });
    };
const $a89a33b3e24797dc$var$actions = {
    triggerEpicPanelRefetch: $a89a33b3e24797dc$var$triggerEpicPanelRefetch,
    finishEpicPanelRefetch: $a89a33b3e24797dc$var$finishEpicPanelRefetch
};
const $a89a33b3e24797dc$export$161cbc183f817581 = (0, $iXqE5.createStore)({
    name: 'jira-software-backlog-panel-should-refetch-epic',
    initialState: {
        shouldRefetchEpicPanel: false
    },
    actions: $a89a33b3e24797dc$var$actions
});
const $a89a33b3e24797dc$export$3c3bb9bb30c98856 = (0, $3sQ5x.createHook)($a89a33b3e24797dc$export$161cbc183f817581);

});


parcelRegister("dfRpl", function(module, exports) {

$parcel$export(module.exports, "default", () => $4837d662057d5604$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("fp4O3");
parcelRequire("d0pqD");
parcelRequire("fPS7b");
parcelRequire("c66Ur");
parcelRequire("6cbqE");

var $2YZCu = parcelRequire("2YZCu");

var $469SI = parcelRequire("469SI");

var $fAcQ9 = parcelRequire("fAcQ9");

var $i4Z8q = parcelRequire("i4Z8q");

var $3lZ6i = parcelRequire("3lZ6i");

var $hseEV = parcelRequire("hseEV");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4837d662057d5604$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $3lZ6i.SET_APP_DATA)).switchMap(()=>{
        const state = store.getState();
        const ctx = (0, $i4Z8q.makeServiceContext)(state);
        return (0, $fAcQ9.loadExtensionDataService)(ctx).map((0, $469SI.transformExtensionLoad)).flatMap((extension)=>(0, $kVLXA.Observable).of((0, $hseEV.extensionFetchSuccess)(extension))).catch((error)=>{
            (0, $2YZCu.default).safeErrorWithoutCustomerData('backlog.extension.operations', error.message, error);
            // ABE-21: Handle this when the call is made as part of the non-critical path
            return (0, $kVLXA.Observable).empty();
        });
    });

});
parcelRegister("469SI", function(module, exports) {

$parcel$export(module.exports, "transformExtensionLoad", () => $085023d6346c2432$export$8fb5dd35b8f7d028);
const $085023d6346c2432$export$8fb5dd35b8f7d028 = (response)=>{
    const operations = response.extension ? response.extension.operations.map((op)=>({
            icon: {
                url: op.icon && op.icon.url
            },
            name: op.name,
            url: op.url,
            tooltip: op.tooltip,
            styleClass: op.styleClass
        })) : [];
    return {
        operations: operations
    };
};

});

parcelRegister("fAcQ9", function(module, exports) {

$parcel$export(module.exports, "loadExtensionDataService", () => $491d5dad7741f821$export$f33c43566824ade1);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");

var $24yxP = parcelRequire("24yxP");
function $491d5dad7741f821$export$f33c43566824ade1(ctx) {
    if (ctx.isCompanyManaged) return (0, $kVLXA.Observable).empty();
    return (0, $24yxP.fetchExtensionData)('', ctx.boardId);
}

});
parcelRegister("24yxP", function(module, exports) {

$parcel$export(module.exports, "fetchExtensionData", () => $d6ab7af6d082f738$export$5fe98ae96d282610);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $cBLvH = parcelRequire("cBLvH");
const $d6ab7af6d082f738$var$softwareBacklogExtensionOperationName = 'SoftwareBacklogExtension';
const $d6ab7af6d082f738$export$1d6e6c1cef4b8fcc = (boardId)=>`query ${$d6ab7af6d082f738$var$softwareBacklogExtensionOperationName} {
        boardScope(boardId:${boardId}) {
            backlog {
                extension {
                    operations {
                        icon {
                           url
                        }
                        name
                        url
                        tooltip
                        styleClass
                    }
                }
            }
        }
    }`;
const $d6ab7af6d082f738$export$5fe98ae96d282610 = (contextPath, boardId)=>(0, $cBLvH.query$)(contextPath, $d6ab7af6d082f738$var$softwareBacklogExtensionOperationName, $d6ab7af6d082f738$export$1d6e6c1cef4b8fcc(boardId)).flatMap((data)=>(0, $kVLXA.Observable).of(data.boardScope.backlog));

});


parcelRegister("hseEV", function(module, exports) {

$parcel$export(module.exports, "EXTENSION_FETCH_SUCCESS", () => $e2ea6d89308c0cc3$export$4b80f261a964f809);
$parcel$export(module.exports, "extensionFetchSuccess", () => $e2ea6d89308c0cc3$export$12037fbc95e2254d);
const $e2ea6d89308c0cc3$export$4b80f261a964f809 = 'state.actions.extension.EXTENSION_FETCH_SUCCESS';
const $e2ea6d89308c0cc3$export$12037fbc95e2254d = (extension)=>({
        type: $e2ea6d89308c0cc3$export$4b80f261a964f809,
        payload: {
            extension: extension
        }
    });

});


parcelRegister("cnhvw", function(module, exports) {

$parcel$export(module.exports, "filterValidValuesEpic", () => $1b72c186edda326d$export$92792813ec12d76);
parcelRequire("zjDln");
parcelRequire("1oQta");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $jgEcS = parcelRequire("jgEcS");

var $likqC = parcelRequire("likqC");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $9Pc1U = parcelRequire("9Pc1U");

var $9ZuIF = parcelRequire("9ZuIF");
const $1b72c186edda326d$var$makeFilter = (state)=>(0, $9Pc1U.isCriticalDataLoaded)(state) && (0, $9ZuIF.isCurrentUserLoaded)(state) && (0, $9Pc1U.isConfigLoaded)(state) && (0, $dGljH.hasInvalidFilterValuesSelector)(state);
const $1b72c186edda326d$export$92792813ec12d76 = (getLocation, push)=>(action$, store)=>action$.filter(()=>$1b72c186edda326d$var$makeFilter(store.getState())).mergeMap(()=>{
            const state = store.getState();
            const filters = (0, $dGljH.validFilterValuesSelector)(state);
            const actions = [
                (0, $likqC.setAllFilters)(filters)
            ];
            const isCompanyManaged = (0, $jG5HW.getIsCompanyManaged)(state);
            push((0, $jgEcS.getPushPayload)(filters, getLocation(), isCompanyManaged));
            return (0, $kVLXA.Observable).from(actions);
        });

});
parcelRegister("jgEcS", function(module, exports) {

$parcel$export(module.exports, "getPushPayload", () => $0e7a205a3891e68f$export$6ee0645423b27902);

var $7uUwQ = parcelRequire("7uUwQ");

var $ebyGx = parcelRequire("ebyGx");


const $0e7a205a3891e68f$export$6ee0645423b27902 = (filters, location, isCompanyManaged)=>{
    const search = (0, $7uUwQ.chain)({
        ...(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(location.search)
    });
    filters[0, $41ce9b5576b92b7a$export$d597759d33be802e] ? search.set((0, $4f4a02cead13bb5a$export$e39925d10cebc0b), filters[0, $41ce9b5576b92b7a$export$d597759d33be802e]) : search.unset((0, $4f4a02cead13bb5a$export$e39925d10cebc0b));
    filters[0, $41ce9b5576b92b7a$export$f8f7545d2bb78afb] ? search.set((0, $4f4a02cead13bb5a$export$f78d8c81fcad32a2), filters[0, $41ce9b5576b92b7a$export$f8f7545d2bb78afb].join(',')) : search.unset((0, $4f4a02cead13bb5a$export$f78d8c81fcad32a2));
    filters[0, $41ce9b5576b92b7a$export$37aee82a3cb1e8f7] ? search.set((0, $4f4a02cead13bb5a$export$e729d951ab128c3b), filters[0, $41ce9b5576b92b7a$export$37aee82a3cb1e8f7].join(',')) : search.unset((0, $4f4a02cead13bb5a$export$e729d951ab128c3b));
    filters[0, $41ce9b5576b92b7a$export$2a4f270075a033de] ? search.set((0, $4f4a02cead13bb5a$export$8a2cab795731dc42), filters[0, $41ce9b5576b92b7a$export$2a4f270075a033de].join(',')) : search.unset((0, $4f4a02cead13bb5a$export$8a2cab795731dc42));
    filters[0, $41ce9b5576b92b7a$export$ebb48b08205007c5] ? search.set((0, $4f4a02cead13bb5a$export$fa7b72626a2e0090), filters[0, $41ce9b5576b92b7a$export$ebb48b08205007c5].join(',')) : search.unset((0, $4f4a02cead13bb5a$export$fa7b72626a2e0090));
    filters[0, $41ce9b5576b92b7a$export$a4ad2735b021c132] ? search.set((0, $4f4a02cead13bb5a$export$392308739e657b75), filters[0, $41ce9b5576b92b7a$export$a4ad2735b021c132].join(',')) : search.unset((0, $4f4a02cead13bb5a$export$392308739e657b75));
    if (isCompanyManaged) filters[0, $41ce9b5576b92b7a$export$68d693c35a8d8866] ? search.set((0, $4f4a02cead13bb5a$export$cb08ebea4a46cd29), filters[0, $41ce9b5576b92b7a$export$68d693c35a8d8866].join(',')) : search.unset((0, $4f4a02cead13bb5a$export$cb08ebea4a46cd29));
    return {
        ...location,
        search: (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(search.value())
    };
};

});

parcelRegister("likqC", function(module, exports) {

$parcel$export(module.exports, "SET_ALL_FILTERS", () => $97e1cddba88799b1$export$2771e5a27cdc85fe);
$parcel$export(module.exports, "setAllFilters", () => $97e1cddba88799b1$export$1e6b2e9f0ff84131);
const $97e1cddba88799b1$export$2771e5a27cdc85fe = 'state.actions.filters.SET_ALL_FILTERS';
const $97e1cddba88799b1$export$1e6b2e9f0ff84131 = (filters, filterType)=>({
        type: $97e1cddba88799b1$export$2771e5a27cdc85fe,
        payload: {
            filters: filters
        },
        meta: {
            filterType: filterType
        }
    });

});


parcelRegister("BJrNt", function(module, exports) {

$parcel$export(module.exports, "filteredCardsEpic", () => $ef125b900a6a43e7$export$e2f185e35a8c9054);

var $e1AU2 = parcelRequire("e1AU2");

var $7DoPy = parcelRequire("7DoPy");

var $h6CKH = parcelRequire("h6CKH");

var $S4gg9 = parcelRequire("S4gg9");
const $ef125b900a6a43e7$export$e2f185e35a8c9054 = (0, $e1AU2.combineEpics)((0, $h6CKH.filteredCardsRequestEpic), (0, $S4gg9.refilterRequestEpic), (0, $7DoPy.clearFilterRequestEpic));

});
parcelRegister("7DoPy", function(module, exports) {

$parcel$export(module.exports, "clearFilterRequestEpic", () => $e3b2d5360bf951aa$export$f800c2415f438ec5);

var $kVLXA = parcelRequire("kVLXA");

var $hSQIY = parcelRequire("hSQIY");
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("eSGL3");
parcelRequire("3awJm");
parcelRequire("6cbqE");
parcelRequire("fPS7b");
parcelRequire("c66Ur");
parcelRequire("zjDln");

var $2YZCu = parcelRequire("2YZCu");

var $j0SXO = parcelRequire("j0SXO");

var $i4Z8q = parcelRequire("i4Z8q");

var $3lZ6i = parcelRequire("3lZ6i");

var $8MHVw = parcelRequire("8MHVw");

var $sRW5v = parcelRequire("sRW5v");
const $e3b2d5360bf951aa$export$4670d1476dee8194 = (action, store, dependencies)=>{
    const state = store.getState();
    const { analyticsEvent: analyticsEvent } = action.meta;
    const ctx = (0, $i4Z8q.makeServiceContext)(state);
    return (0, $j0SXO.loadPlanDataService)({
        boardId: ctx.boardId,
        isCompanyManaged: ctx.isCompanyManaged,
        epicIssueType: null,
        storeFieldsActions: dependencies?.storeFieldsActions
    }).mergeMap((data)=>(0, $kVLXA.Observable).from([
            (0, $8MHVw.clearFilteredCardsSuccess)(analyticsEvent),
            (0, $3lZ6i.setAppData)(data)
        ])).catch((error)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('backlog.clear-filtered-cards.failure', 'Failed to load plan data to clear cards filter', error);
        return (0, $kVLXA.Observable).of((0, $8MHVw.clearFilteredCardsFailed)(error, analyticsEvent));
    });
};
const $e3b2d5360bf951aa$export$f800c2415f438ec5 = (action$, store, dependencies)=>action$.ofType((0, $8MHVw.FILTERED_CARD_CLEAR_REQUEST)).throttleTime((0, $sRW5v.getCustomFiltersDebounceTime)(), (0, $hSQIY.async), {
        leading: true,
        trailing: true
    }).switchMap((action)=>$e3b2d5360bf951aa$export$4670d1476dee8194(action, store, dependencies));

});
parcelRegister("j0SXO", function(module, exports) {

$parcel$export(module.exports, "loadPlanDataService", () => $45918024f87d3a8f$export$102560d7738611a1);
parcelRequire("d0pqD");

var $bpHwy = parcelRequire("bpHwy");

var $ey78P = parcelRequire("ey78P");

var $3qYzN = parcelRequire("3qYzN");
function $45918024f87d3a8f$export$102560d7738611a1({ boardId: boardId, isCompanyManaged: isCompanyManaged, activeQuickFilters: activeQuickFilters, epicIssueType: epicIssueType, storeFieldsActions: storeFieldsActions }) {
    return (0, $ey78P.fetchPlanData)({
        rapidViewId: boardId,
        activeQuickFilters: activeQuickFilters,
        operation: 'fetchBacklogData'
    }).map((data)=>{
        if (storeFieldsActions?.storeFieldsFromPrefetchedPlanData) storeFieldsActions.storeFieldsFromPrefetchedPlanData(data, epicIssueType);
        (0, $bpHwy.refreshUIFBacklogData)(Number(boardId), data);
        return (0, $3qYzN.transformPlanData)(data, isCompanyManaged, activeQuickFilters);
    });
}

});
parcelRegister("bpHwy", function(module, exports) {

$parcel$export(module.exports, "fetchUIFBoardData", () => $620843ca516c403b$export$240c6c415d37cd75);
$parcel$export(module.exports, "refreshUIFBoardData", () => $620843ca516c403b$export$f34cbc63057c38be);
$parcel$export(module.exports, "fetchUIFBacklogData", () => $620843ca516c403b$export$60a4d33615c60f8);
$parcel$export(module.exports, "refreshUIFBacklogData", () => $620843ca516c403b$export$69efc1d2bf5ce2ae);
$parcel$export(module.exports, "fetchBacklogConfigData", () => $620843ca516c403b$export$e01389e26c6cdee);
$parcel$export(module.exports, "fetchBacklogGlobalConfigData", () => $620843ca516c403b$export$7e803310d32d4164);

var $jywXF = parcelRequire("jywXF");

var $cRqmM = parcelRequire("cRqmM");

var $c1BZi = parcelRequire("c1BZi");

var $l8SKN = parcelRequire("l8SKN");

var $8XYl5 = parcelRequire("8XYl5");
async function $620843ca516c403b$export$240c6c415d37cd75(params) {
    const { cachedPromise: cachedPromise, refreshPromise: refreshPromise } = (0, $c1BZi.fetchUIFBoardDataStream)(params);
    const refreshResult = refreshPromise.then((value)=>({
            value: value,
            type: 'refresh'
        }));
    const { value: result, type: type } = await Promise.race([
        cachedPromise.then((value)=>value != null ? {
                value: value,
                type: 'cache'
            } : refreshResult),
        refreshResult
    ]);
    const isCacheHit = type === 'cache';
    return {
        result: result,
        refresh: isCacheHit ? refreshPromise : null,
        isCacheHit: isCacheHit
    };
}
async function $620843ca516c403b$export$f34cbc63057c38be(boardId, response) {
    (0, $l8SKN.setBoardCachedEntry)({
        boardId: boardId
    }, {
        timestamp: Date.now(),
        etag: response.etag,
        data: response
    });
}
async function $620843ca516c403b$export$60a4d33615c60f8(boardId, queryParameters) {
    const { cachedPromise: cachedPromise, requestPromise: requestPromise } = (0, $jywXF.fetchUIFBacklogData)(boardId, queryParameters);
    const refreshResult = requestPromise.then((response)=>{
        $620843ca516c403b$export$69efc1d2bf5ce2ae(boardId, response);
        return {
            result: response,
            type: 'refresh'
        };
    });
    const { result: result, type: type } = await Promise.race([
        cachedPromise.then((cachedResult)=>cachedResult != null ? {
                result: cachedResult.data,
                type: 'cache'
            } : refreshResult),
        refreshResult
    ]);
    const isCacheHit = type === 'cache';
    return {
        result: result,
        refresh: type === 'cache' ? requestPromise : null,
        isCacheHit: isCacheHit
    };
}
function $620843ca516c403b$export$69efc1d2bf5ce2ae(boardId, response) {
    return (0, $cRqmM.setBacklogCachedEntry)(boardId, {
        timestamp: Date.now(),
        data: response
    });
}
async function $620843ca516c403b$export$e01389e26c6cdee(boardId) {
    const result = await (0, $8XYl5.fetchConfigData)(boardId);
    return {
        result: result,
        refresh: null,
        isCacheHit: false
    };
}
async function $620843ca516c403b$export$7e803310d32d4164() {
    const result = await (0, $8XYl5.fetchGlobalConfigData)();
    return {
        result: result,
        refresh: null,
        isCacheHit: false
    };
}

});
parcelRegister("jywXF", function(module, exports) {

$parcel$export(module.exports, "fetchUIFBacklogDataOld", () => $b625b9c23407900e$export$df49ad631c58a3f6);
$parcel$export(module.exports, "fetchUIFBacklogData", () => $b625b9c23407900e$export$60a4d33615c60f8);
$parcel$export(module.exports, "runUIFBacklogEarlyScript", () => $b625b9c23407900e$export$a0c2e05a12ae5621);

var $ebyGx = parcelRequire("ebyGx");

var $tcn7E = parcelRequire("tcn7E");


var $x9xyg = parcelRequire("x9xyg");

var $l83Uu = parcelRequire("l83Uu");

var $dO0aE = parcelRequire("dO0aE");

var $4R6GH = parcelRequire("4R6GH");

var $eKonk = parcelRequire("eKonk");

var $cRqmM = parcelRequire("cRqmM");

var $aBK23 = parcelRequire("aBK23");

var $hUQ5s = parcelRequire("hUQ5s");
// Removing isIndexedDBCachingEnabledForBacklog will make this obsolete.
let $b625b9c23407900e$var$backlogResponsePromise;
let $b625b9c23407900e$var$backlogResponse = null;
const $b625b9c23407900e$export$b08a6e96e3de5356 = (response)=>{
    $b625b9c23407900e$var$backlogResponsePromise = response;
};
const $b625b9c23407900e$export$592ab10c6cb9d596 = ()=>{
    const response = $b625b9c23407900e$var$backlogResponsePromise;
    $b625b9c23407900e$var$backlogResponsePromise = null;
    return response;
};
const $b625b9c23407900e$export$55e9294018933a18 = (response)=>{
    $b625b9c23407900e$var$backlogResponse = response;
};
const $b625b9c23407900e$export$b55ab086f6a0c481 = ()=>{
    const response = $b625b9c23407900e$var$backlogResponse;
    $b625b9c23407900e$var$backlogResponse = null;
    return response;
};
const $b625b9c23407900e$var$onEnd = ()=>{
    (0, $x9xyg.setMark)('uif-backlog-fetch-end');
    (0, $x9xyg.setMeasure)('uif-backlog-fetch/request', 'uif-backlog-fetch-start-request', 'uif-backlog-fetch-end');
    (0, $x9xyg.setMeasure)('uif-backlog-fetch', 'uif-backlog-fetch-start', 'uif-backlog-fetch-end');
};
const $b625b9c23407900e$export$df49ad631c58a3f6 = async (boardId, queryParameters)=>{
    const earlyScriptResponse = $b625b9c23407900e$export$592ab10c6cb9d596();
    if (earlyScriptResponse) return earlyScriptResponse;
    (0, $x9xyg.setMark)('uif-backlog-fetch-start');
    const fetchUIFBacklogDataParams = (0, $hUQ5s.buildPlanDataFetchOptions)(boardId, queryParameters);
    const queryStr = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(fetchUIFBacklogDataParams);
    (0, $x9xyg.setMark)('uif-backlog-fetch-start-request');
    const backlogDataUrl = `/rest/greenhopper/1.0/xboard/plan/v2/backlog/data?${queryStr}`;
    const enhancedCapabilityHeader = (0, $eKonk.getEnhancedCapabilityHeader)((0, $281cbd47ba46dd7d$export$571692eec8a399e1));
    const headers = {
        ...enhancedCapabilityHeader ? {
            'X-Atlassian-Capability': enhancedCapabilityHeader
        } : {}
    };
    Object.assign(headers, (0, $tcn7E.getActiveTraceHttpRequestHeaders)(backlogDataUrl));
    const res = await fetch(backlogDataUrl, {
        headers: headers
    });
    const json = await res.json().catch(()=>null);
    if (!res.ok) {
        $b625b9c23407900e$var$onEnd();
        const traceId = (0, $l83Uu.getTraceId)(res);
        const message = (0, $aBK23.extractErrorMessage)(json);
        if (traceId) throw new (0, $dO0aE.FetchError)(res.status, message, traceId);
        else throw new (0, $dO0aE.FetchError)(res.status, message);
    }
    $b625b9c23407900e$var$onEnd();
    return json;
};
const $b625b9c23407900e$export$60a4d33615c60f8 = (boardId, queryParameters)=>{
    const earlyScriptResponse = $b625b9c23407900e$export$b55ab086f6a0c481();
    if (earlyScriptResponse) return earlyScriptResponse;
    const requestPromise = (async ()=>{
        (0, $x9xyg.setMark)('uif-backlog-fetch-start');
        const fetchUIFBacklogDataParams = (0, $hUQ5s.buildPlanDataFetchOptions)(boardId, queryParameters);
        const queryStr = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(fetchUIFBacklogDataParams);
        (0, $x9xyg.setMark)('uif-backlog-fetch-start-request');
        const backlogDataUrl = `/rest/greenhopper/1.0/xboard/plan/v2/backlog/data?${queryStr}`;
        const enhancedCapabilityHeader = (0, $eKonk.getEnhancedCapabilityHeader)((0, $281cbd47ba46dd7d$export$571692eec8a399e1));
        const headers = {
            ...enhancedCapabilityHeader ? {
                'X-Atlassian-Capability': enhancedCapabilityHeader
            } : {}
        };
        Object.assign(headers, (0, $tcn7E.getActiveTraceHttpRequestHeaders)(backlogDataUrl));
        const res = await fetch(backlogDataUrl, {
            headers: headers
        });
        const json = await res.json().catch(()=>null);
        if (!res.ok) {
            $b625b9c23407900e$var$onEnd();
            const traceId = (0, $l83Uu.getTraceId)(res);
            const message = (0, $aBK23.extractErrorMessage)(json);
            if (traceId) throw new (0, $dO0aE.FetchError)(res.status, message, traceId);
            else throw new (0, $dO0aE.FetchError)(res.status, message);
        }
        $b625b9c23407900e$var$onEnd();
        return json;
    })();
    const cachedPromise = (0, $cRqmM.getBacklogCachedEntry)(boardId);
    return {
        requestPromise: requestPromise,
        cachedPromise: cachedPromise
    };
};
function $b625b9c23407900e$export$a0c2e05a12ae5621(location) {
    const parsedResult = (0, $aBK23.parseBacklogLocation)(location);
    if (!parsedResult) return false;
    const { boardId: boardId, queryParameters: queryParameters } = parsedResult;
    if ((0, $4R6GH.fg)('indexeddb_cache_for_backlog')) {
        const backlogData = $b625b9c23407900e$export$60a4d33615c60f8(boardId, queryParameters);
        $b625b9c23407900e$export$55e9294018933a18(backlogData);
    } else {
        const backlogData = $b625b9c23407900e$export$df49ad631c58a3f6(boardId, queryParameters);
        $b625b9c23407900e$export$b08a6e96e3de5356(backlogData);
    }
    return true;
}

});
const $281cbd47ba46dd7d$export$ef94a84e2990361c = 'ISSUE_VIEW';
const $281cbd47ba46dd7d$export$fc5f182fc9019b1c = 'CLASSIC_BOARD';
const $281cbd47ba46dd7d$export$664edf77d4c76110 = 'COMPANY_MANAGED_BOARD';
const $281cbd47ba46dd7d$export$f364828958cffad0 = 'TEAM_MANAGED_BOARD';
const $281cbd47ba46dd7d$export$93104dc4eba58ba4 = 'CLASSIC_BACKLOG';
const $281cbd47ba46dd7d$export$571692eec8a399e1 = 'COMPANY_MANAGED_BACKLOG';
const $281cbd47ba46dd7d$export$c17f34c425972af1 = 'TEAM_MANAGED_BACKLOG';
const $281cbd47ba46dd7d$export$d0ad1160bb95ce50 = 'NIN_NEW_ISSUE_NAVIGATOR';
const $281cbd47ba46dd7d$export$4695c1a423ffe431 = 'DASHBOARD';
const $281cbd47ba46dd7d$export$f999749ac7a2cd1 = 'PLAN_CALENDAR';
const $281cbd47ba46dd7d$export$9a80695e72849f84 = 'X-Atlassian-Capability';

parcelRegister("cRqmM", function(module, exports) {

$parcel$export(module.exports, "setBacklogCachedEntry", () => $31c19adcc162b6bc$export$a9fe76d96b47f80a);
$parcel$export(module.exports, "getBacklogCachedEntry", () => $31c19adcc162b6bc$export$d01cbd23f4b0c290);

var $sn9QA = parcelRequire("sn9QA");

var $2FZUH = parcelRequire("2FZUH");
const $31c19adcc162b6bc$export$1ba4f312a27970c1 = (0, $sn9QA.createIndexedDBStorageProvider)('cmp-backlog');
async function $31c19adcc162b6bc$export$a9fe76d96b47f80a(boardId, entry) {
    if (!entry.data.localDeviceCacheEnabled) {
        $31c19adcc162b6bc$export$1ba4f312a27970c1.clearAll();
        return Promise.resolve();
    }
    const key = (0, $2FZUH.buildCachedEntryKey)(boardId);
    return $31c19adcc162b6bc$export$1ba4f312a27970c1.set(key, entry);
}
async function $31c19adcc162b6bc$export$d01cbd23f4b0c290(boardId) {
    const key = (0, $2FZUH.buildCachedEntryKey)(boardId);
    try {
        const entry = await $31c19adcc162b6bc$export$1ba4f312a27970c1.get(key);
        if (!entry) return null;
        if (!(0, $2FZUH.isValid)(entry)) {
            await $31c19adcc162b6bc$export$1ba4f312a27970c1.remove(key);
            return null;
        }
        return entry;
    } catch (err) {
        return null;
    }
}

});
parcelRegister("sn9QA", function(module, exports) {

$parcel$export(module.exports, "createIndexedDBStorageProvider", () => $cf3437e9474a0e2b$export$6ba36c4f5fb8919d);

var $gJBT6 = parcelRequire("gJBT6");

var $8vEj7 = parcelRequire("8vEj7");
const $cf3437e9474a0e2b$export$6ba36c4f5fb8919d = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((appPrefix, options)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    const provider = (0, $8vEj7.createStorageProvider)(appPrefix);
    if (options?.shouldAutoReconnect) return (0, $8vEj7.withAutoReconnect)(provider);
    return provider;
});

});
parcelRegister("8vEj7", function(module, exports) {

$parcel$export(module.exports, "createStorageProvider", () => $33b8db71261fb346$export$8441605555fbd60c);
$parcel$export(module.exports, "withAutoReconnect", () => $33b8db71261fb346$export$8432fe49db7d8865);

var $jIIX7 = parcelRequire("jIIX7");
const $33b8db71261fb346$export$7382f85ef4ff4314 = (prefix, key)=>`${prefix.replace(/_*$/, '')}__${key || ''}`;
const $33b8db71261fb346$var$createCustomStore = ()=>(0, $jIIX7.createStore)('keyval-store', 'keyval');
let $33b8db71261fb346$var$customStore;
const $33b8db71261fb346$var$getStore = ()=>{
    let store = $33b8db71261fb346$var$customStore;
    if (!store) {
        $33b8db71261fb346$var$customStore = $33b8db71261fb346$var$createCustomStore();
        store = $33b8db71261fb346$var$customStore;
    }
    return store;
};
const $33b8db71261fb346$export$8441605555fbd60c = (appPrefix)=>{
    const KEYS_STORE_PREFIX = $33b8db71261fb346$export$7382f85ef4ff4314(appPrefix);
    const prefix = (key)=>$33b8db71261fb346$export$7382f85ef4ff4314(appPrefix, key);
    // Runtime check to ensure a key is provided as the prefix without a key
    // holds an array of all the keys that are prefixed by this store
    const assertKey = (key)=>{
        if (!key) throw Error('You must provide a key');
    };
    // Calling `clearAll` would require us to iterate over every key in the
    // indexed-db, filtering by this instance's prefix and subsequently deleting
    // all the filtered keys. As indexed-db gains traction within Jira, this
    // will quickly become an expensive operation. To counteract this, we
    // instead store all the keys that this instance has created so that when it
    // comes time to clear them all, we simply just have to clear every key in
    // this store. This removes the need for iterating and filtering all
    // together.
    const updateStoreKeys = async (key, remove = false)=>(0, $jIIX7.update)(KEYS_STORE_PREFIX, (currentKeys)=>{
            const storeKeys = new Set(currentKeys);
            if (remove) {
                storeKeys.delete(key);
                return Array.from(storeKeys.values());
            }
            storeKeys.add(key);
            return Array.from(storeKeys.values());
        }, $33b8db71261fb346$var$getStore());
    return {
        async get (key) {
            assertKey(key);
            return (0, $jIIX7.get)(prefix(key), $33b8db71261fb346$var$getStore());
        },
        async remove (key) {
            assertKey(key);
            const prefixedKey = prefix(key);
            await (0, $jIIX7.del)(prefixedKey, $33b8db71261fb346$var$getStore());
            return updateStoreKeys(prefixedKey, true);
        },
        async clearAll () {
            const prefixedKeys = await (0, $jIIX7.get)(KEYS_STORE_PREFIX, $33b8db71261fb346$var$getStore());
            if (!prefixedKeys || prefixedKeys.length === 0) return undefined;
            return (0, $jIIX7.delMany)(prefixedKeys.concat(KEYS_STORE_PREFIX));
        },
        async set (key, value) {
            assertKey(key);
            const prefixedKey = prefix(key);
            if (typeof value === 'function') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            (0, $jIIX7.update)(prefixedKey, value);
            else (0, $jIIX7.set)(prefixedKey, value, $33b8db71261fb346$var$getStore());
            return updateStoreKeys(prefixedKey);
        },
        async reconnect () {
            $33b8db71261fb346$var$customStore = $33b8db71261fb346$var$createCustomStore();
        }
    };
};
const $33b8db71261fb346$export$8432fe49db7d8865 = (storageProvider)=>({
        async get (...args) {
            try {
                return await storageProvider.get(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.get(...args);
                }
                throw e;
            }
        },
        async set (...args) {
            try {
                return await storageProvider.set(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.set(...args);
                }
                throw e;
            }
        },
        async remove (...args) {
            try {
                return await storageProvider.remove(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.remove(...args);
                }
                throw e;
            }
        },
        async clearAll (...args) {
            try {
                return await storageProvider.clearAll(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.clearAll(...args);
                }
                throw e;
            }
        },
        async reconnect () {
            await storageProvider.reconnect?.();
        }
    });

});
parcelRegister("jIIX7", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $e5b4ff07e835609c$export$f51a9068ac82ea43);
$parcel$export(module.exports, "get", () => $e5b4ff07e835609c$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $e5b4ff07e835609c$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "update", () => $e5b4ff07e835609c$export$722fbec263ad908a);
$parcel$export(module.exports, "del", () => $e5b4ff07e835609c$export$1d2f21e549771e67);
$parcel$export(module.exports, "delMany", () => $e5b4ff07e835609c$export$c8aa84257229cac8);
function $e5b4ff07e835609c$export$b327150396135fe7(request) {
    return new Promise((resolve, reject)=>{
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = ()=>resolve(request.result);
        // @ts-ignore - file size hacks
        request.onabort = request.onerror = ()=>reject(request.error);
    });
}
function $e5b4ff07e835609c$export$f51a9068ac82ea43(dbName, storeName) {
    const request = indexedDB.open(dbName);
    request.onupgradeneeded = ()=>request.result.createObjectStore(storeName);
    const dbp = $e5b4ff07e835609c$export$b327150396135fe7(request);
    return (txMode, callback)=>dbp.then((db)=>callback(db.transaction(storeName, txMode).objectStore(storeName)));
}
let $e5b4ff07e835609c$var$defaultGetStoreFunc;
function $e5b4ff07e835609c$var$defaultGetStore() {
    if (!$e5b4ff07e835609c$var$defaultGetStoreFunc) $e5b4ff07e835609c$var$defaultGetStoreFunc = $e5b4ff07e835609c$export$f51a9068ac82ea43('keyval-store', 'keyval');
    return $e5b4ff07e835609c$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$3988ae62b71be9a3(key, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>$e5b4ff07e835609c$export$b327150396135fe7(store.get(key)));
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$adaa4cf7ef1b65be(key, value, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.put(value, key);
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$daa0a5170277c7a8(entries, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        entries.forEach((entry)=>store.put(entry[1], entry[0]));
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$5df405cccea42673(keys, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>Promise.all(keys.map((key)=>$e5b4ff07e835609c$export$b327150396135fe7(store.get(key)))));
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$722fbec263ad908a(key, updater, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>// Need to create the promise manually.
        // If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise((resolve, reject)=>{
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($e5b4ff07e835609c$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$1d2f21e549771e67(key, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.delete(key);
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$c8aa84257229cac8(keys, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        keys.forEach((key)=>store.delete(key));
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$42ffd38884aecdac(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.clear();
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
function $e5b4ff07e835609c$var$eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$ed97f33186d4b816(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        if (store.getAllKeys) return $e5b4ff07e835609c$export$b327150396135fe7(store.getAllKeys());
        const items = [];
        return $e5b4ff07e835609c$var$eachCursor(store, (cursor)=>items.push(cursor.key)).then(()=>items);
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$68c286be0e7e55b7(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        if (store.getAll) return $e5b4ff07e835609c$export$b327150396135fe7(store.getAll());
        const items = [];
        return $e5b4ff07e835609c$var$eachCursor(store, (cursor)=>items.push(cursor.value)).then(()=>items);
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$3e9f948b41964866(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            $e5b4ff07e835609c$export$b327150396135fe7(store.getAllKeys()),
            $e5b4ff07e835609c$export$b327150396135fe7(store.getAll())
        ]).then(([keys, values])=>keys.map((key, i)=>[
                    key,
                    values[i]
                ]));
        const items = [];
        return customStore('readonly', (store)=>$e5b4ff07e835609c$var$eachCursor(store, (cursor)=>items.push([
                    cursor.key,
                    cursor.value
                ])).then(()=>items));
    });
}

});



parcelRegister("2FZUH", function(module, exports) {

$parcel$export(module.exports, "isValid", () => $ec6817f630f9a6c9$export$1ea939691cdc45b8);
$parcel$export(module.exports, "getAccountId", () => $ec6817f630f9a6c9$export$c1e0336bde96e2dc);
$parcel$export(module.exports, "buildCachedEntryKey", () => $ec6817f630f9a6c9$export$59c82678f286b00f);

var $8QpSo = parcelRequire("8QpSo");

var $sn9QA = parcelRequire("sn9QA");
const $ec6817f630f9a6c9$var$EXPIRATION_TIME = 259200000; // 3 days
function $ec6817f630f9a6c9$export$1ea939691cdc45b8(cachedDataEntry) {
    const timeDelta = Date.now() - cachedDataEntry.timestamp;
    const expirationTime = $ec6817f630f9a6c9$var$EXPIRATION_TIME;
    return timeDelta < expirationTime;
}
const $ec6817f630f9a6c9$export$c1e0336bde96e2dc = (0, $8QpSo.default)(()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const el = document.querySelector('meta[name="ajs-atlassian-account-id"]');
    return el?.getAttribute('content') ?? null;
});
function $ec6817f630f9a6c9$export$59c82678f286b00f(boardId) {
    const accountId = $ec6817f630f9a6c9$export$c1e0336bde96e2dc() ?? 'no-account-id';
    return `local-device-cache::${accountId}::${boardId}`;
}
const $ec6817f630f9a6c9$export$cc1314e9c2424f02 = (0, $sn9QA.createIndexedDBStorageProvider)('labs-preferences');

});


parcelRegister("aBK23", function(module, exports) {

$parcel$export(module.exports, "convertQuickFiltersToString", () => $2271887588c9e1ef$export$4f216f9114f89403);
$parcel$export(module.exports, "getCachedQuickFilters", () => $2271887588c9e1ef$export$e59cda69449c77c2);
$parcel$export(module.exports, "parseBoardLocation", () => $2271887588c9e1ef$export$97471107364bd76c);
$parcel$export(module.exports, "parseBacklogLocation", () => $2271887588c9e1ef$export$be59cb299ab0331c);
$parcel$export(module.exports, "extractErrorMessage", () => $2271887588c9e1ef$export$8cc545829c7461b0);
$parcel$export(module.exports, "View", () => $2271887588c9e1ef$export$27a5bd065ad55220);
$parcel$export(module.exports, "getViewSettings", () => $2271887588c9e1ef$export$3ae70db4a97563c);

var $ebyGx = parcelRequire("ebyGx");

var $4R6GH = parcelRequire("4R6GH");
const $2271887588c9e1ef$var$SOFTWARE_BOARD_REGEX = /\/jira\/software\/c\/?projects\/\w+\/boards\/(\d+)\/?(\?.*)?$/;
const $2271887588c9e1ef$var$USER_LOCATED_BOARD_REGEX = /\/jira\/people\/[^/]+\/boards\/(\d+)\/?(\?.*)?$/;
// people/project match needs to consider `...:...` ids
const $2271887588c9e1ef$var$SOFTWARE_BACKLOG_REGEX = /\/jira\/(?:software\/c\/)?(?:projects|people)\/[^/]+\/boards\/(\d+)\/backlog\/?(\?.*)?$/;
const $2271887588c9e1ef$var$parsePath = (pathname, pattern)=>{
    const match = pattern.exec(pathname);
    if (!match) return null;
    const boardId = match[1];
    return {
        boardId: Number(boardId)
    };
};
const $2271887588c9e1ef$export$4f216f9114f89403 = (queryParameters)=>{
    // Terminate early for the null/undefined cases
    if (!queryParameters?.quickFilter) return undefined; // This is safe to return as it means the query string will just be excluded
    if (!Array.isArray(queryParameters.quickFilter)) {
        // If for whatever reason an object gets in here
        if (typeof queryParameters.quickFilter === 'object') // Fail gracefully
        return undefined;
        // Ensure that the value is a number
        if (Number.isNaN(Number(queryParameters.quickFilter))) return undefined;
        // this isn't an array. It's probably a string or number which is fine to return as is.
        return `${queryParameters.quickFilter}`;
    }
    // Array passed in is the common case
    // If it is empty, don't include it at all.
    if (queryParameters.quickFilter.length === 0) return undefined;
    return queryParameters.quickFilter.filter((val)=>Number.isInteger(Number(val))).join(',');
};
const $2271887588c9e1ef$export$e59cda69449c77c2 = (feature, boardId)=>{
    const localStorageKey = `__storejs_software_${feature}-filters.${boardId}`;
    const updatedStorageKey = `software.${feature}-filters.${boardId}`;
    let cachedFilters;
    const storage = localStorage;
    if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) // if new keys does not exist, falls back to older keys
    cachedFilters = storage.getItem(updatedStorageKey) || localStorage.getItem(localStorageKey);
    else cachedFilters = storage.getItem(localStorageKey);
    if (!cachedFilters) return undefined;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { CUSTOM_FILTER: cachedQuickFilters } = JSON.parse(cachedFilters);
    return cachedQuickFilters && cachedQuickFilters.length > 0 ? cachedQuickFilters.join(',') : undefined;
};
const $2271887588c9e1ef$export$97471107364bd76c = ({ pathname: pathname, search: search })=>{
    const parsedPath = $2271887588c9e1ef$var$parsePath(pathname, $2271887588c9e1ef$var$SOFTWARE_BOARD_REGEX) ?? $2271887588c9e1ef$var$parsePath(pathname, $2271887588c9e1ef$var$USER_LOCATED_BOARD_REGEX);
    if (!parsedPath) return null;
    const queryStringParameters = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(search) ?? {};
    // Early termination if the quick filter isnt a part of the query string
    if (!queryStringParameters.quickFilter) return {
        ...parsedPath
    };
    // Guarantee that the quick filter will be returned as an array. This helps with typing further upstream
    const quickFilterArray = Array.isArray(queryStringParameters.quickFilter) ? queryStringParameters.quickFilter : [
        queryStringParameters.quickFilter
    ];
    return {
        ...parsedPath,
        queryParameters: {
            quickFilter: quickFilterArray
        }
    };
};
const $2271887588c9e1ef$export$be59cb299ab0331c = ({ pathname: pathname, search: search })=>{
    const parsedPath = $2271887588c9e1ef$var$parsePath(pathname, $2271887588c9e1ef$var$SOFTWARE_BACKLOG_REGEX);
    if (!parsedPath) return null;
    return {
        ...parsedPath,
        queryParameters: (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(search) ?? {}
    };
};
const $2271887588c9e1ef$var$isErrorMessagesResponse = (json)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    json?.errorMessages instanceof Array;
const $2271887588c9e1ef$export$8cc545829c7461b0 = (json)=>{
    if ($2271887588c9e1ef$var$isErrorMessagesResponse(json)) {
        const { errorMessages: errorMessages } = json;
        return errorMessages.length ? errorMessages.join(', ') : undefined;
    }
    return undefined;
};
/* Copied from jira/src/packages/software/view-settings/src/services/local-storage/index.tsx
 to reduce bundle size by using native localStorage */ const $2271887588c9e1ef$var$VIEW_SETTINGS = 'view-settings';
const $2271887588c9e1ef$export$752f3d44db2fbd2d = 'jira-software-view-settings';
const $2271887588c9e1ef$export$27a5bd065ad55220 = {
    BACKLOG: 'jsw-backlog',
    BOARD: 'jsw-board',
    INCREMENT_PLANNING_BOARD: 'increment-planning-board',
    JSM_BOARD: 'jsm-board'
};
const $2271887588c9e1ef$export$36e24695f02d4503 = (view)=>{
    if (view && view === $2271887588c9e1ef$export$27a5bd065ad55220.INCREMENT_PLANNING_BOARD) return `${$2271887588c9e1ef$var$VIEW_SETTINGS}-${$2271887588c9e1ef$export$27a5bd065ad55220.INCREMENT_PLANNING_BOARD}`;
    if ((0, $4R6GH.fg)('jira_view_settings_additional_fields')) switch(view){
        case $2271887588c9e1ef$export$27a5bd065ad55220.INCREMENT_PLANNING_BOARD:
            return `${$2271887588c9e1ef$var$VIEW_SETTINGS}-${$2271887588c9e1ef$export$27a5bd065ad55220.INCREMENT_PLANNING_BOARD}`;
        case $2271887588c9e1ef$export$27a5bd065ad55220.BACKLOG:
            return `${$2271887588c9e1ef$var$VIEW_SETTINGS}-${$2271887588c9e1ef$export$27a5bd065ad55220.BACKLOG}`;
        case $2271887588c9e1ef$export$27a5bd065ad55220.BOARD:
            return `${$2271887588c9e1ef$var$VIEW_SETTINGS}-${$2271887588c9e1ef$export$27a5bd065ad55220.BOARD}`;
        case $2271887588c9e1ef$export$27a5bd065ad55220.JSM_BOARD:
            return `${$2271887588c9e1ef$var$VIEW_SETTINGS}-${$2271887588c9e1ef$export$27a5bd065ad55220.JSM_BOARD}`;
        default:
            return $2271887588c9e1ef$var$VIEW_SETTINGS;
    }
    return $2271887588c9e1ef$var$VIEW_SETTINGS;
};
const $2271887588c9e1ef$export$3ae70db4a97563c = ({ boardId: boardId, view: view })=>{
    /**
	 * This usage is excluded via package exclusion in jira/ratcheting-rules.tsx
	 * Because it is only a READ Operation, and reads are not blocked in compliant APIs.
	 * This read will be tracked via a compliant API read in following code
	 * - Initializing view-settings panel on board: jira/src/packages/software/view-settings/src/ui/index.tsx
	 * - rendering cards on the board (Implementation In Progress https://hello.jira.atlassian.cloud/browse/PNDR-1926)
	 * More context in this discussion: https://atlassian.slack.com/archives/C02785CLSTW/p1722822320190909
	 */ const localStorageKey = `__storejs_${$2271887588c9e1ef$export$752f3d44db2fbd2d}_${$2271887588c9e1ef$export$36e24695f02d4503(view)}-${boardId}`;
    const updatedStorageKey = `${$2271887588c9e1ef$export$752f3d44db2fbd2d}.${$2271887588c9e1ef$export$36e24695f02d4503(view)}-${boardId}`;
    const legacyStorageKey = `__storejs_${$2271887588c9e1ef$export$752f3d44db2fbd2d}_${$2271887588c9e1ef$var$VIEW_SETTINGS}-${boardId}`;
    const updatedLegacyStorageKey = `${$2271887588c9e1ef$export$752f3d44db2fbd2d}.${$2271887588c9e1ef$var$VIEW_SETTINGS}-${boardId}`;
    const storage = localStorage;
    let viewSettingStorageValue;
    if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) viewSettingStorageValue = storage.getItem(updatedStorageKey) || storage.getItem(updatedLegacyStorageKey) || // if new keys does not exist, falls back to older keys
    storage.getItem(localStorageKey) || storage.getItem(legacyStorageKey);
    else viewSettingStorageValue = storage.getItem(localStorageKey) || // return legacy view settings if prefixed storage doesn't exist
    storage.getItem(legacyStorageKey);
    return JSON.parse(viewSettingStorageValue ?? 'null');
};

});

parcelRegister("hUQ5s", function(module, exports) {

$parcel$export(module.exports, "buildPlanDataFetchOptions", () => $f874c35ef69356eb$export$dab2d96649ebf00a);

var $aBK23 = parcelRequire("aBK23");
const $f874c35ef69356eb$export$68c4c1e22c91f23f = 'fetchBacklogData';
const $f874c35ef69356eb$var$parseActiveQuickFilters = (queryParameters, boardId)=>{
    if (queryParameters?.customFilter && typeof queryParameters?.customFilter === 'string') return queryParameters.customFilter.split(',');
    return (0, $aBK23.getCachedQuickFilters)('backlog', boardId)?.split(',');
};
const $f874c35ef69356eb$export$dab2d96649ebf00a = (boardId, queryParameters)=>({
        rapidViewId: boardId,
        forceConsistency: queryParameters?.forceConsistency ? /true/i.test(String(queryParameters.forceConsistency)) : true,
        activeQuickFilters: $f874c35ef69356eb$var$parseActiveQuickFilters(queryParameters, boardId),
        operation: $f874c35ef69356eb$export$68c4c1e22c91f23f
    });

});


parcelRegister("c1BZi", function(module, exports) {

$parcel$export(module.exports, "fetchUIFBoardDataStream", () => $8173307478a42629$export$92fdd848ddb362ed);

var $dO0aE = parcelRequire("dO0aE");

var $d4P1V = parcelRequire("d4P1V");

var $l8SKN = parcelRequire("l8SKN");
function $8173307478a42629$export$92fdd848ddb362ed({ boardId: boardId, queryParameters: queryParameters, fields: fields }) {
    const { cachedPromise: cachedBoardData, promise: promise } = (0, $d4P1V.fetchUIFBoardData)({
        boardId: boardId,
        queryParameters: queryParameters,
        fields: fields
    });
    const cachedPromise = cachedBoardData.then((cache)=>cache?.data ?? null);
    const refreshPromise = (async ()=>{
        const response = await promise;
        if (!response) throw new (0, $dO0aE.ResponseNullError)('CMP fetchUIFBoardData returned null');
        (0, $l8SKN.setBoardCachedEntry)({
            boardId: boardId
        }, {
            timestamp: Date.now(),
            etag: response.etag,
            data: response
        });
        return response;
    })();
    return {
        cachedPromise: cachedPromise,
        refreshPromise: refreshPromise
    };
}

});
parcelRegister("d4P1V", function(module, exports) {

$parcel$export(module.exports, "fetchUIFBoardData", () => $29c6e7c438197219$export$240c6c415d37cd75);
$parcel$export(module.exports, "runUIFBoardEarlyScript", () => $29c6e7c438197219$export$4c749dee5e4e8bc6);

var $ebyGx = parcelRequire("ebyGx");


var $x9xyg = parcelRequire("x9xyg");

var $l83Uu = parcelRequire("l83Uu");

var $dO0aE = parcelRequire("dO0aE");

var $5HnTq = parcelRequire("5HnTq");

var $eKonk = parcelRequire("eKonk");

var $l8SKN = parcelRequire("l8SKN");

var $aBK23 = parcelRequire("aBK23");
const $29c6e7c438197219$export$5aec1fe89a336a5d = 'fetchBoardData';
let $29c6e7c438197219$var$combinedBoardPromises = null;
function $29c6e7c438197219$var$putBoardEarlyScriptResponse(promises) {
    $29c6e7c438197219$var$combinedBoardPromises = promises;
}
function $29c6e7c438197219$export$1601e80f8f15c5cd() {
    const promises = $29c6e7c438197219$var$combinedBoardPromises;
    $29c6e7c438197219$var$combinedBoardPromises = null;
    return promises;
}
function $29c6e7c438197219$export$3b583d36792fd1ab(boardId) {
    const isCardCoversToggled = (0, $aBK23.getViewSettings)({
        boardId: Number(boardId),
        view: (0, $aBK23.View).BOARD
    })?.showCardCovers;
    // If viewSetting isn't set, return skipCardCovers as false by default
    if (isCardCoversToggled === null || isCardCoversToggled === undefined) return false;
    return !isCardCoversToggled;
}
function $29c6e7c438197219$export$240c6c415d37cd75({ boardId: boardId, queryParameters: queryParameters, fields: fields }) {
    // It is important that there is no async operation before this first
    // return block, otherwise we may create a cycle of this fetch with itself.
    const response = $29c6e7c438197219$export$1601e80f8f15c5cd();
    if (response) return response;
    (0, $x9xyg.setMark)('uif-board-fetch-start');
    const query = {
        moduleKey: 'agile-web-board-service',
        hideCardExtraFields: true,
        onlyUseEpicsFromIssues: true,
        skipEtag: true,
        skipExtraFields: true,
        includeHidden: true,
        activeQuickFilters: (0, $aBK23.convertQuickFiltersToString)(queryParameters) ?? (0, $aBK23.getCachedQuickFilters)('board', boardId),
        fields: fields,
        operation: $29c6e7c438197219$export$5aec1fe89a336a5d,
        skipCardCovers: $29c6e7c438197219$export$3b583d36792fd1ab(boardId)
    };
    const queryStr = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(query);
    (0, $x9xyg.setMark)('uif-board-fetch-start-request');
    const boardDataUrl = `/rest/boards/latest/board/${boardId}?${queryStr}`;
    const capabilityHeader = (0, $eKonk.getEnhancedCapabilityHeader)((0, $281cbd47ba46dd7d$export$664edf77d4c76110));
    const headers = {
        ...capabilityHeader ? {
            'X-Atlassian-Capability': capabilityHeader
        } : {}
    };
    const cachedPromise = (0, $l8SKN.getBoardCachedEntry)({
        boardId: boardId
    });
    const defaultOptions = (0, $5HnTq.getDefaultOptions)(boardDataUrl);
    const options = {
        ...defaultOptions,
        headers: {
            ...defaultOptions.headers,
            ...headers
        }
    };
    const promise = fetch(boardDataUrl, options).then(async (res)=>{
        const json = await res.json().catch(()=>null);
        (0, $x9xyg.setMark)('uif-board-fetch-end');
        (0, $x9xyg.setMeasure)('uif-board-fetch/request', 'uif-board-fetch-start-request', 'uif-board-fetch-end');
        (0, $x9xyg.setMeasure)('uif-board-fetch', 'uif-board-fetch-start', 'uif-board-fetch-end');
        if (!res.ok) {
            const traceId = (0, $l83Uu.getTraceId)(res);
            const message = (0, $aBK23.extractErrorMessage)(json);
            if (traceId) throw new (0, $dO0aE.FetchError)(res.status, message, traceId);
            else throw new (0, $dO0aE.FetchError)(res.status, message);
        }
        return json;
    });
    return {
        cachedPromise: cachedPromise,
        promise: promise
    };
}
function $29c6e7c438197219$export$4c749dee5e4e8bc6(location) {
    const parsedResult = (0, $aBK23.parseBoardLocation)(location);
    if (!parsedResult) return false;
    $29c6e7c438197219$var$putBoardEarlyScriptResponse($29c6e7c438197219$export$240c6c415d37cd75(parsedResult));
    return true;
}

});
parcelRegister("l8SKN", function(module, exports) {

$parcel$export(module.exports, "setBoardCachedEntry", () => $378b724625452625$export$ce85349d82f1217c);
$parcel$export(module.exports, "getBoardCachedEntry", () => $378b724625452625$export$992aa38aa2da87a4);

var $sn9QA = parcelRequire("sn9QA");

var $x9xyg = parcelRequire("x9xyg");

var $2FZUH = parcelRequire("2FZUH");
const $378b724625452625$export$13bc140835202cda = (0, $sn9QA.createIndexedDBStorageProvider)('cmp-board');
function $378b724625452625$export$4c715dd110bf64d2({ boardId: boardId, accountId: accountId, queryParameters: queryParameters }) {
    const params = [
        accountId,
        boardId
    ];
    if (queryParameters) params.push(JSON.stringify(queryParameters));
    const paramString = params.join('::');
    return `local-device-cache::${paramString}`;
}
async function $378b724625452625$export$ce85349d82f1217c({ boardId: boardId, queryParameters: queryParameters }, entry) {
    if (!entry.data.localDeviceCacheEnabled) {
        $378b724625452625$export$13bc140835202cda.clearAll();
        return Promise.resolve();
    }
    const accountId = (0, $2FZUH.getAccountId)() ?? 'no-account-id';
    const key = $378b724625452625$export$4c715dd110bf64d2({
        boardId: boardId,
        accountId: accountId,
        queryParameters: queryParameters
    });
    return $378b724625452625$export$13bc140835202cda.set(key, entry);
}
async function $378b724625452625$export$992aa38aa2da87a4({ boardId: boardId, queryParameters: queryParameters }) {
    const accountId = (0, $2FZUH.getAccountId)() ?? 'no-account-id';
    const cacheKey = $378b724625452625$export$4c715dd110bf64d2({
        boardId: boardId,
        accountId: accountId,
        queryParameters: queryParameters
    });
    try {
        (0, $x9xyg.setMark)('uif-board-fetch-read-cache-start');
        const entry = await $378b724625452625$export$13bc140835202cda.get(cacheKey);
        if (entry) (0, $x9xyg.setMark)('uif-board-fetch-read-cache-end');
        else return null;
        if (!(0, $2FZUH.isValid)(entry)) {
            await $378b724625452625$export$13bc140835202cda.remove(cacheKey);
            return null;
        }
        return entry;
    } catch (err) {
        return null;
    }
}

});



parcelRegister("8XYl5", function(module, exports) {

$parcel$export(module.exports, "fetchConfigData", () => $88832a6b5d28007e$export$89341835c2b99b9c);
$parcel$export(module.exports, "fetchGlobalConfigData", () => $88832a6b5d28007e$export$2835d43f6465400);

var $dO0aE = parcelRequire("dO0aE");
var $l83Uu = parcelRequire("l83Uu");

var $aBK23 = parcelRequire("aBK23");
let $88832a6b5d28007e$var$configData = null;
let $88832a6b5d28007e$var$globalConfigData = null;
const $88832a6b5d28007e$var$takeEarlyScriptConfigResponse = ()=>{
    const response = $88832a6b5d28007e$var$configData;
    $88832a6b5d28007e$var$configData = null;
    return response;
};
const $88832a6b5d28007e$var$takeEarlyScriptGlobalConfigResponse = ()=>{
    const response = $88832a6b5d28007e$var$globalConfigData;
    $88832a6b5d28007e$var$globalConfigData = null;
    return response;
};
function $88832a6b5d28007e$export$89341835c2b99b9c(boardId) {
    const earlyScriptResponse = $88832a6b5d28007e$var$takeEarlyScriptConfigResponse();
    if (earlyScriptResponse) return earlyScriptResponse;
    const promise = fetch(`/rest/greenhopper/3/xboard/config?boardId=${boardId}&operation=ConfigData`).then(async (res)=>{
        const json = await res.json().catch(()=>null);
        if (!res.ok) {
            const traceId = (0, $l83Uu.getTraceId)(res);
            const message = (0, $aBK23.extractErrorMessage)(json);
            throw new (0, $dO0aE.FetchError)(res.status, message, traceId);
        }
        return json;
    });
    const response = promise;
    $88832a6b5d28007e$var$configData = response;
    return response;
}
function $88832a6b5d28007e$export$2835d43f6465400() {
    const earlyScriptResponse = $88832a6b5d28007e$var$takeEarlyScriptGlobalConfigResponse();
    if (earlyScriptResponse) return earlyScriptResponse;
    const promise = fetch('/rest/greenhopper/3/globalconfig?operation=GlobalConfigData').then(async (res)=>{
        const json = await res.json().catch(()=>null);
        if (!res.ok) {
            const traceId = (0, $l83Uu.getTraceId)(res);
            const message = (0, $aBK23.extractErrorMessage)(json);
            throw new (0, $dO0aE.FetchError)(res.status, message, traceId);
        }
        return json;
    });
    const response = promise;
    $88832a6b5d28007e$var$globalConfigData = response;
    return response;
}

});


parcelRegister("ey78P", function(module, exports) {

$parcel$export(module.exports, "fetchPlanData", () => $1863e9cebf4aed19$export$be4775dacb1fbad6);

var $ebyGx = parcelRequire("ebyGx");

var $487fd = parcelRequire("487fd");
function $1863e9cebf4aed19$export$be4775dacb1fbad6(fetchPlanOptions) {
    return (0, $487fd.default)(`/rest/greenhopper/1.0/xboard/plan/v2/backlog/data?${(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(fetchPlanOptions)}`);
}

});

parcelRegister("3qYzN", function(module, exports) {

$parcel$export(module.exports, "transformPlanData", () => $5f4cd5ebb1f1e87b$export$5c1a457e91f81261);

var $7uUwQ = parcelRequire("7uUwQ");

var $chc6P = parcelRequire("chc6P");

var $183uB = parcelRequire("183uB");

var $4Xk2W = parcelRequire("4Xk2W");

var $2nvJN = parcelRequire("2nvJN");

var $g4tDr = parcelRequire("g4tDr");

var $6s1PB = parcelRequire("6s1PB");

var $guzeq = parcelRequire("guzeq");

var $3vPnu = parcelRequire("3vPnu");

var $3teSA = parcelRequire("3teSA");

var $8hVbJ = parcelRequire("8hVbJ");
const $5f4cd5ebb1f1e87b$var$NONE = 'None';
const $5f4cd5ebb1f1e87b$var$boardList = {
    id: (0, $guzeq.BOARD),
    type: (0, $guzeq.BOARD),
    name: 'Board',
    issueListKey: null
};
const $5f4cd5ebb1f1e87b$var$backlogList = (0, $7uUwQ.freeze)({
    id: (0, $guzeq.BACKLOG),
    type: (0, $guzeq.BACKLOG),
    name: 'Backlog',
    issueListKey: null
});
const $5f4cd5ebb1f1e87b$var$transformCards = (issues)=>(0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(issues.map((0, $3vPnu.transformCard)), 'id');
const $5f4cd5ebb1f1e87b$var$isInKanbanContainer = (issue, column)=>!!column && column.statusIds.includes(issue.statusId);
const $5f4cd5ebb1f1e87b$var$transformKanbanCardsOrder = ({ issues: issues, selectedForDevelopmentColumn: board, backlogColumn: backlog })=>{
    const cardIdByContainerType = {
        [(0, $guzeq.BOARD)]: [],
        [(0, $guzeq.BACKLOG)]: []
    };
    issues.forEach((issue)=>{
        if ($5f4cd5ebb1f1e87b$var$isInKanbanContainer(issue, board)) cardIdByContainerType[0, $guzeq.BOARD].push(issue.id);
        else if ($5f4cd5ebb1f1e87b$var$isInKanbanContainer(issue, backlog)) cardIdByContainerType[0, $guzeq.BACKLOG].push(issue.id);
    });
    return cardIdByContainerType;
};
const $5f4cd5ebb1f1e87b$var$transformConfig = (response)=>{
    const isKanban = (0, $3teSA.isKanbanPlanDataResponse)(response);
    return {
        requestColumnMigration: false,
        rankCustomFieldId: response.rankCustomFieldId || -1,
        version: {
            // We want the versions feature to be always true for CMP
            isVersionsFeatureEnabled: true
        },
        allFeatures: [],
        backlogStrategy: isKanban ? (0, $guzeq.KANBAN_BACKLOG_STRATEGY) : (0, $guzeq.SPRINT_BACKLOG_STRATEGY),
        kanbanBoardColumnId: isKanban ? response?.selectedForDevelopmentColumn?.id : null,
        kanbanBacklogColumnId: isKanban ? response?.backlogColumn?.id : null,
        hierarchyNomenclature: response?.flexibleNomenclatureData?.levelOneName ? {
            firstLevelName: response?.flexibleNomenclatureData?.levelOneName
        } : null,
        permissions: {
            CAN_CREATE_ISSUES: response.canCreateIssue,
            CAN_EDIT_ISSUES: response.canCreateIssue,
            CAN_MANAGE_SPRINTS: response.canManageSprints,
            // The BE will always return `true` otherwise it will return a 401 error
            CAN_VIEW_BOARD: true
        }
    };
};
const $5f4cd5ebb1f1e87b$var$isValidDateSprint = (value)=>(0, (/*@__PURE__*/$parcel$interopDefault($2nvJN)))(value) !== $5f4cd5ebb1f1e87b$var$NONE;
const $5f4cd5ebb1f1e87b$var$getSprintDate = (value)=>$5f4cd5ebb1f1e87b$var$isValidDateSprint(value) ? value : '';
const $5f4cd5ebb1f1e87b$var$transformSprintOld = ({ id: id, name: name, goal: goal, isoStartDate: isoStartDate, isoEndDate: isoEndDate, daysRemaining: daysRemaining, state: state, canUpdateSprint: canUpdateSprint })=>({
        id: String(id),
        name: name,
        type: (0, $guzeq.SPRINT),
        issueListKey: null,
        sprintData: {
            goal: goal || '',
            startDate: $5f4cd5ebb1f1e87b$var$getSprintDate(isoStartDate),
            endDate: $5f4cd5ebb1f1e87b$var$getSprintDate(isoEndDate),
            daysRemaining: daysRemaining,
            state: state,
            canUpdateSprint: canUpdateSprint
        }
    });
const $5f4cd5ebb1f1e87b$var$transformSprint = ({ id: id, name: name, goal: goal, isoStartDate: isoStartDate, isoEndDate: isoEndDate, daysRemaining: daysRemaining, state: state, canUpdateSprint: canUpdateSprint, originBoard: originBoard })=>({
        id: String(id),
        name: name,
        type: (0, $guzeq.SPRINT),
        issueListKey: null,
        sprintData: {
            goal: goal || '',
            startDate: $5f4cd5ebb1f1e87b$var$getSprintDate(isoStartDate),
            endDate: $5f4cd5ebb1f1e87b$var$getSprintDate(isoEndDate),
            daysRemaining: daysRemaining,
            state: state,
            canUpdateSprint: canUpdateSprint,
            originBoard: originBoard
        }
    });
const $5f4cd5ebb1f1e87b$var$transformVersions = (response)=>(0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))((0, (/*@__PURE__*/$parcel$interopDefault($chc6P)))(response.versionData?.versionsPerProject, (versions, projectId)=>versions.map((version)=>({
                id: version.id,
                name: version.name,
                projectId: Number(projectId)
            }))), (version)=>String(version.id));
const $5f4cd5ebb1f1e87b$var$toVersionIds = (versions)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    versions ? versions.map((version)=>String(version.id)) : [];
const $5f4cd5ebb1f1e87b$var$transformVersionsOrder = (response)=>response?.versionData?.versionsPerProject ? (0, (/*@__PURE__*/$parcel$interopDefault($183uB)))(Object.keys(response.versionData.versionsPerProject).map((projectId)=>$5f4cd5ebb1f1e87b$var$toVersionIds(response.versionData.versionsPerProject[projectId]))) : [];
const $5f4cd5ebb1f1e87b$var$transformFilteredCardIds = (issues, activeQuickFilters)=>{
    if (!activeQuickFilters.length) return null;
    return new Set(issues.map((issue)=>String(issue.id)));
};
const $5f4cd5ebb1f1e87b$var$transformIssueIdsBySprint = (issues, sprintId)=>issues.filter((issue)=>issue.sprintIds?.includes(sprintId) ?? false).map((issue)=>issue.id);
const $5f4cd5ebb1f1e87b$var$extractCardTypes = (issues)=>Array.from(issues.reduce((acc, val)=>{
        if (acc.has(val.typeId)) return acc;
        return acc.set(val.typeId, {
            id: Number(val.typeId),
            name: val.typeName,
            iconUrl: val.typeUrl,
            hasRequiredFields: null,
            typeHierarchyLevel: (0, $g4tDr.getHierarchyLevelType)(val.typeHierarchyLevel)
        });
    }, new Map()).values());
const $5f4cd5ebb1f1e87b$var$isSubtask = (issue)=>typeof issue.parentKey === 'string' && issue.parentKey.length > 0;
const $5f4cd5ebb1f1e87b$export$c53ff095db760b09 = (issues, issueIdInSprints)=>{
    if (issues.length === 0) return [];
    const backlogIssues = issues.filter((issue)=>!issueIdInSprints.includes(issue.id));
    const backlogIssueIds = new Set();
    if (backlogIssues.length > 0) {
        const subtasks = backlogIssues.filter($5f4cd5ebb1f1e87b$var$isSubtask);
        backlogIssues.forEach((issue)=>{
            // In case the issue has already been processed return to prevent the loop below which is expensive.
            if (backlogIssueIds.has(issue.id)) return;
            backlogIssueIds.add(issue.id);
            // subtasks can not have subtasks and thus the work below is unnecessary.
            if ($5f4cd5ebb1f1e87b$var$isSubtask(issue)) return;
            subtasks.forEach((subtask)=>{
                if (subtask.parentId !== issue.id) return;
                backlogIssueIds.add(subtask.id);
            });
        });
    }
    return Array.from(backlogIssueIds);
};
const $5f4cd5ebb1f1e87b$var$transformScrumBacklog = (response, activeQuickFilters)=>{
    const cardList = {
        [(0, $guzeq.BACKLOG)]: $5f4cd5ebb1f1e87b$var$backlogList
    };
    const cardOrder = {};
    const cardListOrder = [];
    let issueIdInSprints = [];
    const visibleIssues = response.issues.filter((issue)=>!issue.hidden);
    response.sprints.forEach((sprint)=>{
        const sprintIssueIds = $5f4cd5ebb1f1e87b$var$transformIssueIdsBySprint(response.issues, sprint.id);
        cardList[sprint.id] = (0, $6s1PB.expValEquals)('surface_origin_board_on_sprint_containers', 'cohort', 'test') ? $5f4cd5ebb1f1e87b$var$transformSprint(sprint) : $5f4cd5ebb1f1e87b$var$transformSprintOld(sprint);
        cardOrder[sprint.id] = sprintIssueIds;
        cardListOrder.push(String(sprint.id));
        issueIdInSprints = issueIdInSprints.concat(sprintIssueIds);
    });
    cardOrder[0, $guzeq.BACKLOG] = $5f4cd5ebb1f1e87b$export$c53ff095db760b09(response.issues, issueIdInSprints);
    cardListOrder.push((0, $guzeq.BACKLOG));
    return {
        entities: {
            card: $5f4cd5ebb1f1e87b$var$transformCards(response.issues),
            cardOrder: cardOrder,
            cardListOrder: cardListOrder,
            cardList: cardList,
            cardTypes: $5f4cd5ebb1f1e87b$var$extractCardTypes(response.issues),
            project: {
                projects: response.projects
            },
            versions: $5f4cd5ebb1f1e87b$var$transformVersions(response),
            version: {
                versions: $5f4cd5ebb1f1e87b$var$transformVersionsOrder(response)
            }
        },
        config: $5f4cd5ebb1f1e87b$var$transformConfig(response),
        ui: {
            cards: {
                filteredCards: {
                    isLoading: false,
                    filteredCardsIds: $5f4cd5ebb1f1e87b$var$transformFilteredCardIds(visibleIssues, activeQuickFilters)
                }
            }
        }
    };
};
const $5f4cd5ebb1f1e87b$var$transformBoardListWithLimits = (firstColumn)=>{
    if (firstColumn) return {
        ...$5f4cd5ebb1f1e87b$var$boardList,
        name: firstColumn.name,
        minColumnLimit: firstColumn.min,
        maxColumnLimit: firstColumn.max
    };
    return $5f4cd5ebb1f1e87b$var$boardList;
};
const $5f4cd5ebb1f1e87b$var$transformKanbanBacklog = (response, activeQuickFilters)=>{
    const visibleIssues = response.issues.filter((issue)=>!issue.hidden);
    return {
        entities: {
            card: $5f4cd5ebb1f1e87b$var$transformCards(response.issues),
            cardOrder: $5f4cd5ebb1f1e87b$var$transformKanbanCardsOrder(response),
            cardOrderGlobal: response.issues.map((issue)=>issue.id),
            cardListOrder: [
                (0, $guzeq.BOARD),
                (0, $guzeq.BACKLOG)
            ],
            cardList: {
                [(0, $guzeq.BOARD)]: $5f4cd5ebb1f1e87b$var$transformBoardListWithLimits(response.selectedForDevelopmentColumn),
                [(0, $guzeq.BACKLOG)]: $5f4cd5ebb1f1e87b$var$backlogList
            },
            project: {
                projects: response.projects
            },
            versions: $5f4cd5ebb1f1e87b$var$transformVersions(response),
            version: {
                versions: $5f4cd5ebb1f1e87b$var$transformVersionsOrder(response)
            }
        },
        config: $5f4cd5ebb1f1e87b$var$transformConfig(response),
        ui: {
            cards: {
                filteredCards: {
                    isLoading: false,
                    filteredCardsIds: $5f4cd5ebb1f1e87b$var$transformFilteredCardIds(visibleIssues, activeQuickFilters)
                }
            }
        }
    };
};
const $5f4cd5ebb1f1e87b$export$5c1a457e91f81261 = (response, isCompanyManaged, activeQuickFilters = [])=>{
    const metric = isCompanyManaged ? (0, $8hVbJ.uifBacklogNewUiPageLoad) : (0, $8hVbJ.nextGenBacklogPageLoad);
    metric.mark((0, $8hVbJ.PAGE_LOAD_MARK_TRANSFORM_CRITICAL_REST_START));
    const result = (0, $3teSA.isKanbanPlanDataResponse)(response) ? $5f4cd5ebb1f1e87b$var$transformKanbanBacklog(response, activeQuickFilters) : $5f4cd5ebb1f1e87b$var$transformScrumBacklog(response, activeQuickFilters);
    metric.mark((0, $8hVbJ.PAGE_LOAD_MARK_TRANSFORM_CRITICAL_REST_END));
    return result;
};

});
parcelRegister("chc6P", function(module, exports) {

var $ekcP3 = parcelRequire("ekcP3");

var $80afZ = parcelRequire("80afZ");
/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $8f007734a6a4d9ac$var$flatMap(collection, iteratee) {
    return $ekcP3($80afZ(collection, iteratee), 1);
}
module.exports = $8f007734a6a4d9ac$var$flatMap;

});

parcelRegister("3teSA", function(module, exports) {

$parcel$export(module.exports, "isKanbanPlanDataResponse", () => $f46b59a8a075e05b$export$489d7cf1df036453);
function $f46b59a8a075e05b$export$489d7cf1df036453(response) {
    if (response !== null && typeof response === 'object') return 'backlogColumn' in response && 'selectedForDevelopmentColumn' in response;
    return false;
}

});



parcelRegister("sRW5v", function(module, exports) {

$parcel$export(module.exports, "getCustomFiltersDebounceTime", () => $f8f506341feac682$export$2ecac126a7851701);
const $f8f506341feac682$export$2ecac126a7851701 = ()=>500;

});


parcelRegister("h6CKH", function(module, exports) {

$parcel$export(module.exports, "filteredCardsRequestEpic", () => $f8059299f5245a9d$export$ee8377ae46706014);

var $kVLXA = parcelRequire("kVLXA");

var $hSQIY = parcelRequire("hSQIY");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("eSGL3");
parcelRequire("3awJm");
parcelRequire("6cbqE");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $2YZCu = parcelRequire("2YZCu");

var $35NvU = parcelRequire("35NvU");

var $i4Z8q = parcelRequire("i4Z8q");

var $3lZ6i = parcelRequire("3lZ6i");

var $9Z18E = parcelRequire("9Z18E");

var $8MHVw = parcelRequire("8MHVw");

var $likqC = parcelRequire("likqC");

var $jG5HW = parcelRequire("jG5HW");

var $sRW5v = parcelRequire("sRW5v");
const $f8059299f5245a9d$var$filterCards = (action, store, dependencies)=>{
    const state = store.getState();
    const { issueIds: issueIds, customFilterIds: customFilterIds } = action.payload;
    const { analyticsEvent: analyticsEvent } = action.meta;
    const ctx = (0, $i4Z8q.makeServiceContext)(state);
    if (!customFilterIds || !customFilterIds.length) return (0, $kVLXA.Observable).from([
        ctx.isCompanyManaged ? (0, $8MHVw.clearFilteredCardsRequest)(analyticsEvent) : (0, $8MHVw.clearFilteredCards)(),
        (0, $9Z18E.cardAutoScrollRequestOnFilter)()
    ]);
    return (0, $35NvU.fetchFilteredCardsService)(ctx, {
        issueIds: issueIds,
        customFilterIds: customFilterIds,
        epicIssueType: (0, $jG5HW.getEpicIssueType)(state),
        storeFieldsActions: dependencies?.storeFieldsActions
    }).flatMap(({ filteredCardIds: filteredCardIds, data: data })=>[
            (0, $8MHVw.filteredCardsSuccess)(filteredCardIds, customFilterIds.length, issueIds.length, analyticsEvent),
            ...data ? [
                (0, $3lZ6i.setAppData)(data)
            ] : [],
            (0, $9Z18E.cardAutoScrollRequestOnFilter)()
        ]).catch((error)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('backlog.filtered-cards.failure', 'Fail to filter cards with custom filters', error);
        return (0, $kVLXA.Observable).of((0, $8MHVw.filteredCardsFailed)(error, analyticsEvent), (0, $likqC.setAllFilters)({}));
    });
};
const $f8059299f5245a9d$export$ee8377ae46706014 = (action$, store, dependencies)=>action$.ofType((0, $8MHVw.FILTERED_CARD_REQUEST)).throttleTime((0, $sRW5v.getCustomFiltersDebounceTime)(), (0, $hSQIY.async), {
        leading: true,
        trailing: true
    }).switchMap((action)=>$f8059299f5245a9d$var$filterCards(action, store, dependencies));

});
parcelRegister("35NvU", function(module, exports) {

$parcel$export(module.exports, "fetchFilteredCardsService", () => $e0df9b6195c9e771$export$6aa3118e5c68853c);
parcelRequire("d0pqD");

var $4CpQY = parcelRequire("4CpQY");

var $j0SXO = parcelRequire("j0SXO");
function $e0df9b6195c9e771$export$6aa3118e5c68853c(ctx, { issueIds: issueIds, customFilterIds: customFilterIds, epicIssueType: epicIssueType, storeFieldsActions: storeFieldsActions }) {
    if (ctx.isCompanyManaged) return (0, $j0SXO.loadPlanDataService)({
        boardId: ctx.boardId,
        isCompanyManaged: ctx.isCompanyManaged,
        activeQuickFilters: customFilterIds,
        epicIssueType: epicIssueType,
        storeFieldsActions: storeFieldsActions
    }).map((data)=>({
            data: data,
            filteredCardIds: Object.values(data.entities.card).filter((card)=>!card.hidden).map((card)=>String(card.id))
        }));
    return (0, $4CpQY.default)('', ctx.boardId, issueIds, customFilterIds).map((filteredCardIds)=>({
            filteredCardIds: filteredCardIds
        }));
}

});
parcelRegister("4CpQY", function(module, exports) {

$parcel$export(module.exports, "default", () => $69f0bbf21dbb8335$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $cBLvH = parcelRequire("cBLvH");
const $69f0bbf21dbb8335$var$filteredCardsQuery = 'FilteredCardIds';
const $69f0bbf21dbb8335$export$71eec30d9db46a56 = ()=>`
    query ${$69f0bbf21dbb8335$var$filteredCardsQuery} ($boardId: ID!, $issueIds: [ID]!, $customFilterIds: [ID]!) {
        boardScope(boardId: $boardId) {
            filteredCardIds(
                issueIds: $issueIds,
                customFilterIds: $customFilterIds
            )
        }
    }
`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$69f0bbf21dbb8335$export$2e2bcd8739ae039 = (baseUrl, boardId, issueIds, customFilterIds)=>(0, $cBLvH.query$)(baseUrl, $69f0bbf21dbb8335$var$filteredCardsQuery, $69f0bbf21dbb8335$export$71eec30d9db46a56(), {
        boardId: boardId,
        issueIds: issueIds,
        customFilterIds: customFilterIds
    }).flatMap(({ boardScope: boardScope })=>(0, $kVLXA.Observable).of(boardScope.filteredCardIds));

});



parcelRegister("S4gg9", function(module, exports) {

$parcel$export(module.exports, "refilterRequestEpic", () => $f06427293390e5a3$export$12fb76cfeb5c0ed2);
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("fPS7b");
parcelRequire("c66Ur");
parcelRequire("6cbqE");
parcelRequire("1oQta");

var $k8IPx = parcelRequire("k8IPx");

var $1sXeC = parcelRequire("1sXeC");

var $kVLXA = parcelRequire("kVLXA");

var $2YZCu = parcelRequire("2YZCu");

var $cnhn5 = parcelRequire("cnhn5");

var $35NvU = parcelRequire("35NvU");

var $i4Z8q = parcelRequire("i4Z8q");

var $3lZ6i = parcelRequire("3lZ6i");

var $hf5c2 = parcelRequire("hf5c2");

var $8MHVw = parcelRequire("8MHVw");

var $ubpiL = parcelRequire("ubpiL");

var $jG5HW = parcelRequire("jG5HW");
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $f06427293390e5a3$var$isActiveTab = ()=>!document.hidden;
const $f06427293390e5a3$var$getActiveCustomFilterIds = (state)=>state.ui.filters.CUSTOM_FILTER || [];
const $f06427293390e5a3$var$isCustomFiltersActive = (state)=>$f06427293390e5a3$var$getActiveCustomFilterIds(state).length > 0;
const $f06427293390e5a3$export$12fb76cfeb5c0ed2 = (action$, store, dependencies)=>action$.ofType((0, $ubpiL.REALTIME_DISPATCH_EVENT_BATCH)).filter($f06427293390e5a3$var$isActiveTab).filter(()=>$f06427293390e5a3$var$isCustomFiltersActive(store.getState())).switchMap((action)=>{
        const state = store.getState();
        const currentUser = (0, $jG5HW.getAtlassianAccountId)(state);
        const triggerEvents = action.payload.events.filter((event)=>event.payload.atlassianId === currentUser && (event.type === (0, $cnhn5.ISSUE_CREATED_EVENT) || event.type === (0, $cnhn5.ISSUE_UPDATED_EVENT)));
        if (triggerEvents.length > 0) {
            const customFilterIds = $f06427293390e5a3$var$getActiveCustomFilterIds(state);
            const issueIds = triggerEvents.map(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (event)=>event.payload.issueId);
            return (0, $35NvU.fetchFilteredCardsService)((0, $i4Z8q.makeServiceContext)(state), {
                customFilterIds: customFilterIds,
                issueIds: issueIds,
                epicIssueType: (0, $jG5HW.getEpicIssueType)(state),
                storeFieldsActions: dependencies?.storeFieldsActions
            }).mergeMap(({ filteredCardIds: filteredCardIds, data: data })=>{
                const excludedCardIds = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(issueIds.map((issueId)=>String(issueId)), filteredCardIds);
                if (excludedCardIds.length) {
                    // we only want to show the flag for created issues
                    const excludedCreatedCardIds = excludedCardIds.map((cardId)=>(0, (/*@__PURE__*/$parcel$interopDefault($1sXeC)))(cardId)).filter((cardId)=>triggerEvents.some((event)=>// @ts-expect-error - TS2339 - Property 'issueId' does not exist on type 'EventPayload'.
                            event.payload.issueId === cardId && event.type === (0, $cnhn5.ISSUE_CREATED_EVENT)));
                    if (excludedCreatedCardIds.length) return [
                        ...data ? [
                            (0, $3lZ6i.setAppData)(data)
                        ] : [],
                        (0, $hf5c2.cardCreateFilteredV2)(excludedCreatedCardIds),
                        (0, $8MHVw.refilterSuccess)(excludedCardIds, filteredCardIds)
                    ];
                }
                return [
                    ...data ? [
                        (0, $3lZ6i.setAppData)(data)
                    ] : [],
                    (0, $8MHVw.refilterSuccess)(excludedCardIds, filteredCardIds)
                ];
            }).catch((error)=>{
                (0, $2YZCu.default).safeErrorWithoutCustomerData('backlog.filtered-cards.refilter.batch.failure', 'Fail to batch re-filter cards with custom filters', error);
                return (0, $kVLXA.Observable).of((0, $8MHVw.refilterFailure)(error));
            });
        }
        return (0, $kVLXA.Observable).empty();
    });

});
parcelRegister("cnhn5", function(module, exports) {

$parcel$export(module.exports, "ISSUE_ASSIGNED_EVENT", () => $09d938f04e8899c4$export$86d416e8d15777d);
$parcel$export(module.exports, "ISSUE_CREATED_EVENT", () => $09d938f04e8899c4$export$b22a14d5dac59664);
$parcel$export(module.exports, "ISSUE_DELETED_EVENT", () => $09d938f04e8899c4$export$25fa37e5059c5a99);
$parcel$export(module.exports, "ISSUE_TRANSITIONED_EVENT", () => $09d938f04e8899c4$export$d9bc8850eeef9f60);
$parcel$export(module.exports, "ISSUE_UPDATED_EVENT", () => $09d938f04e8899c4$export$b22142e61b3fdbee);
$parcel$export(module.exports, "ISSUE_COMMENTED_EVENT", () => $09d938f04e8899c4$export$773466d9acc404c0);
$parcel$export(module.exports, "ISSUE_PARENT_ASSOCIATION_EVENT", () => $09d938f04e8899c4$export$6b7e46ea0442b66c);
$parcel$export(module.exports, "BOARD_SCOPE_ISSUES_UPDATED", () => $09d938f04e8899c4$export$6024bd0c20931af3);
$parcel$export(module.exports, "SUBSCRIPTION_SUPPORTED_EVENTS", () => $09d938f04e8899c4$export$5a28ff49c25ece6e);
$parcel$export(module.exports, "BOARD_SUPPORTED_EVENTS", () => $09d938f04e8899c4$export$47ea50c123247eb0);
const $09d938f04e8899c4$export$86d416e8d15777d = 'avi:jira:assigned:issue';
const $09d938f04e8899c4$export$b22a14d5dac59664 = 'avi:jira:created:issue';
const $09d938f04e8899c4$export$25fa37e5059c5a99 = 'avi:jira:deleted:issue';
const $09d938f04e8899c4$export$d9bc8850eeef9f60 = 'avi:jira:transitioned:issue';
const $09d938f04e8899c4$export$b22142e61b3fdbee = 'avi:jira:updated:issue';
const $09d938f04e8899c4$export$773466d9acc404c0 = 'avi:jira:commented:issue';
const $09d938f04e8899c4$export$72f85a03fb1edcaf = 'avi:jira:mentioned:issue';
const $09d938f04e8899c4$export$6b7e46ea0442b66c = 'avi:jira:updated:issue_parent_association';
const $09d938f04e8899c4$export$6024bd0c20931af3 = 'avi:jira-software:update:board-scope-issues';
const $09d938f04e8899c4$export$5a28ff49c25ece6e = new Set([
    $09d938f04e8899c4$export$b22a14d5dac59664,
    $09d938f04e8899c4$export$25fa37e5059c5a99,
    $09d938f04e8899c4$export$b22142e61b3fdbee,
    $09d938f04e8899c4$export$773466d9acc404c0,
    $09d938f04e8899c4$export$72f85a03fb1edcaf,
    $09d938f04e8899c4$export$6b7e46ea0442b66c
]);
const $09d938f04e8899c4$export$47ea50c123247eb0 = new Set([
    $09d938f04e8899c4$export$6024bd0c20931af3
]);

});

parcelRegister("ubpiL", function(module, exports) {

$parcel$export(module.exports, "REALTIME_DISPATCH_EVENT_BATCH", () => $7097cc282617eb64$export$146c7f09e2af258);
$parcel$export(module.exports, "dispatchRealtimeEventBatch", () => $7097cc282617eb64$export$884fd41fa17b25da);
// eslint-disable-next-line jira/import/no-restricted-import
const $7097cc282617eb64$export$146c7f09e2af258 = 'state.actions.realtime.dispatch.REALTIME_DISPATCH_EVENT_BATCH';
const $7097cc282617eb64$export$884fd41fa17b25da = (event)=>({
        type: $7097cc282617eb64$export$146c7f09e2af258,
        payload: {
            events: event
        }
    });

});



parcelRegister("jQJPl", function(module, exports) {

$parcel$export(module.exports, "issueViewUpdateEpic", () => $af823fc0306b2266$export$f43e66f9c7ce58d1);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("zjDln");
parcelRequire("fPS7b");

var $hi0S3 = parcelRequire("hi0S3");

var $9zy1T = parcelRequire("9zy1T");

var $17kP6 = parcelRequire("17kP6");

var $dGljH = parcelRequire("dGljH");

var $fmuR9 = parcelRequire("fmuR9");
const $af823fc0306b2266$export$f43e66f9c7ce58d1 = (action$, store)=>action$.ofType((0, $17kP6.ISSUE_VIEW_UPDATE)).mergeMap((action)=>{
        const state = store.getState();
        const { payload: payload } = action;
        const targetIssueParent = (0, $fmuR9.getIssueParents)(state)[payload.issueId];
        if (targetIssueParent) {
            const actionsFromMappedResponse = (0, $9zy1T.mapResponseToIssueParent)(targetIssueParent, state, payload);
            return actionsFromMappedResponse ? (0, $kVLXA.Observable).from([
                actionsFromMappedResponse
            ]) : (0, $kVLXA.Observable).empty();
        }
        // TODO: Add getIssueChildren(state)[payload.issueId] when issue children is supported in Backlog (CATBUS-2200)
        const targetIssue = (0, $dGljH.getCards)(state)[payload.issueId];
        const actionsFromMappedResponse = (0, $hi0S3.mapResponseToIssue)(targetIssue, state, payload);
        return actionsFromMappedResponse ? (0, $kVLXA.Observable).from([
            actionsFromMappedResponse
        ]) : (0, $kVLXA.Observable).empty();
    });

});
parcelRegister("hi0S3", function(module, exports) {

$parcel$export(module.exports, "mapResponseToIssue", () => $bdd1761ffea1dd72$export$270311cab2abcd0d);

var $FTaAj = parcelRequire("FTaAj");

var $3lZ6i = parcelRequire("3lZ6i");

var $jG5HW = parcelRequire("jG5HW");

var $6jl1B = parcelRequire("6jl1B");
const $bdd1761ffea1dd72$export$270311cab2abcd0d = (issue, state, payload)=>{
    if (!payload.type || !issue) return null;
    // TODO: To be added when Backlog supports issue children (CATBUS-2200)
    // if (payload.type === ChangeEventTypes.ISSUE_CHILDREN_ORDER_CHANGED) {
    //     return setIssueChildrenRank(payload.meta);
    // }
    if (payload.type === (0, $FTaAj.ChangeEventTypes).FIELD_CHANGED) {
        const isCMPScrum = (0, $jG5HW.isCMPScrumBacklog)(state);
        const sprintFieldId = (0, $jG5HW.getSprintFieldId)(state);
        if (isCMPScrum && payload.meta.fieldId === sprintFieldId) return (0, $3lZ6i.loadAppData)();
    }
    if (payload.type === (0, $FTaAj.ChangeEventTypes).SUBTASK_ADDED || payload.type === (0, $FTaAj.ChangeEventTypes).CHILD_ISSUE_ADDED) return (0, $3lZ6i.loadAppData)();
    if (payload.type === (0, $FTaAj.ChangeEventTypes).ISSUE_CHILDREN_ORDER_CHANGED) return (0, $6jl1B.updateRankOnChildrenOrderChange)(state, payload.meta);
    return null;
};

});
parcelRegister("FTaAj", function(module, exports) {

$parcel$export(module.exports, "ChangeEventTypes", () => $0a7f3a2a8450d0c8$export$8db21fc94823e1cc);
const $0a7f3a2a8450d0c8$var$FIELD_CHANGE_REQUESTED = 'FIELD_CHANGE_REQUESTED';
const $0a7f3a2a8450d0c8$var$FIELD_CHANGED = 'FIELD_CHANGED';
const $0a7f3a2a8450d0c8$var$FIELD_CHANGE_FAILED = 'FIELD_CHANGE_FAILED';
const $0a7f3a2a8450d0c8$var$ISSUE_TYPE_CHANGED = 'ISSUE_TYPE_CHANGED';
const $0a7f3a2a8450d0c8$var$ISSUE_RELATIONSHIP_UPDATED = 'ISSUE_RELATIONSHIP_UPDATED';
const $0a7f3a2a8450d0c8$var$ISSUE_LINKS_CREATED = 'ISSUE_LINKS_CREATED';
const $0a7f3a2a8450d0c8$var$ISSUE_LINK_DELETED = 'ISSUE_LINK_DELETED';
const $0a7f3a2a8450d0c8$var$CHILD_ISSUE_ADDED = 'CHILD_ISSUE_ADDED';
const $0a7f3a2a8450d0c8$var$SUBTASK_ADDED = 'SUBTASK_ADDED';
const $0a7f3a2a8450d0c8$var$ISSUE_CHILDREN_ORDER_CHANGED = 'ISSUE_CHILDREN_ORDER_CHANGED';
const $0a7f3a2a8450d0c8$var$CHILD_ISSUE_FIELD_UPDATED = 'CHILD_ISSUE_FIELD_UPDATED';
const $0a7f3a2a8450d0c8$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS = 'CREATE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $0a7f3a2a8450d0c8$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS = 'DELETE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $0a7f3a2a8450d0c8$export$8db21fc94823e1cc = {
    [$0a7f3a2a8450d0c8$var$FIELD_CHANGE_REQUESTED]: $0a7f3a2a8450d0c8$var$FIELD_CHANGE_REQUESTED,
    [$0a7f3a2a8450d0c8$var$FIELD_CHANGE_FAILED]: $0a7f3a2a8450d0c8$var$FIELD_CHANGE_FAILED,
    [$0a7f3a2a8450d0c8$var$FIELD_CHANGED]: $0a7f3a2a8450d0c8$var$FIELD_CHANGED,
    [$0a7f3a2a8450d0c8$var$ISSUE_TYPE_CHANGED]: $0a7f3a2a8450d0c8$var$ISSUE_TYPE_CHANGED,
    [$0a7f3a2a8450d0c8$var$ISSUE_RELATIONSHIP_UPDATED]: $0a7f3a2a8450d0c8$var$ISSUE_RELATIONSHIP_UPDATED,
    [$0a7f3a2a8450d0c8$var$ISSUE_LINKS_CREATED]: $0a7f3a2a8450d0c8$var$ISSUE_LINKS_CREATED,
    [$0a7f3a2a8450d0c8$var$ISSUE_LINK_DELETED]: $0a7f3a2a8450d0c8$var$ISSUE_LINK_DELETED,
    [$0a7f3a2a8450d0c8$var$CHILD_ISSUE_ADDED]: $0a7f3a2a8450d0c8$var$CHILD_ISSUE_ADDED,
    [$0a7f3a2a8450d0c8$var$SUBTASK_ADDED]: $0a7f3a2a8450d0c8$var$SUBTASK_ADDED,
    [$0a7f3a2a8450d0c8$var$ISSUE_CHILDREN_ORDER_CHANGED]: $0a7f3a2a8450d0c8$var$ISSUE_CHILDREN_ORDER_CHANGED,
    [$0a7f3a2a8450d0c8$var$CHILD_ISSUE_FIELD_UPDATED]: $0a7f3a2a8450d0c8$var$CHILD_ISSUE_FIELD_UPDATED,
    [$0a7f3a2a8450d0c8$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS]: $0a7f3a2a8450d0c8$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS,
    [$0a7f3a2a8450d0c8$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS]: $0a7f3a2a8450d0c8$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS
};

});

parcelRegister("6jl1B", function(module, exports) {

$parcel$export(module.exports, "updateRankOnChildrenOrderChange", () => $13717743638f3d7a$export$d180b3cae3a333fb);

var $6GNN7 = parcelRequire("6GNN7");

var $dGljH = parcelRequire("dGljH");
const $13717743638f3d7a$export$d180b3cae3a333fb = (state, { issueIds: issueIds, rankId: rankId, isRankAfter: isRankAfter })=>{
    const cardOrder = (0, $dGljH.getOrderedCardIdsByCardListId)(state);
    const cardListId = (0, $dGljH.makeGetCardListIdByCardId)(state)(rankId);
    if (cardListId == null) return null;
    const cardIds = issueIds.map((id)=>Number(id)).filter((id)=>(cardOrder[cardListId] || []).includes(id));
    const cardsMoveSetPayload = {
        cardIds: cardIds,
        cardListId: cardListId,
        isBetweenLists: false,
        beforeCardId: !isRankAfter ? rankId : null,
        afterCardId: isRankAfter ? rankId : null
    };
    /** cardIds can be an empty list here depending on cardListId.
	 * This check ensures no optimistic ranking updates is triggered in Backlog when the issue ranked (and surrounding issues) in BENTO children panel are from different sections
	 * e.g. one from backlog and another from a sprint etc.
	 */ return cardIds.length ? (0, $6GNN7.cardsMoveSet)(cardsMoveSetPayload) : null;
};

});


parcelRegister("9zy1T", function(module, exports) {

$parcel$export(module.exports, "mapResponseToIssueParent", () => $6d8d50ba60123d1c$export$b4cee4073a723eae);

var $iHPnC = parcelRequire("iHPnC");

var $FTaAj = parcelRequire("FTaAj");

var $hf5c2 = parcelRequire("hf5c2");

var $hqokg = parcelRequire("hqokg");

var $9Pc1U = parcelRequire("9Pc1U");

var $6jl1B = parcelRequire("6jl1B");
const $6d8d50ba60123d1c$export$b4cee4073a723eae = (issueParent, state, payload)=>{
    const epicColorFieldId = (0, $9Pc1U.getEpicColorFieldId)(state);
    if (!payload.type || !issueParent) return null;
    if (payload.type === (0, $FTaAj.ChangeEventTypes).FIELD_CHANGED) {
        if (payload.meta.fieldId !== 'summary' && payload.meta.fieldId !== epicColorFieldId) return null;
        const issueParentContent = payload.meta.fieldId === epicColorFieldId ? {
            color: (0, $iHPnC.asColor)(payload.meta.fieldValue)
        } : {
            [payload.meta.fieldId]: payload.meta.fieldValue
        };
        return (0, $hqokg.issueParentPatch)({
            id: issueParent.id,
            issueParent: issueParentContent
        });
    }
    if (payload.type === (0, $FTaAj.ChangeEventTypes).ISSUE_CHILDREN_ORDER_CHANGED) return (0, $6jl1B.updateRankOnChildrenOrderChange)(state, payload.meta);
    if (payload.type === (0, $FTaAj.ChangeEventTypes).CHILD_ISSUE_ADDED) return (0, $hf5c2.cardCreateEndOfBacklogOptimistic)(payload);
    return null;
};

});
parcelRegister("hqokg", function(module, exports) {

$parcel$export(module.exports, "ISSUE_PARENT_PATCH", () => $828778a217f635e3$export$e9af2723cb3ed91e);
$parcel$export(module.exports, "issueParentPatch", () => $828778a217f635e3$export$72e99a23ae3ed0b0);
const $828778a217f635e3$export$e9af2723cb3ed91e = 'state.actions.issue-parents.patch.ISSUE_PARENT_PATCH';
const $828778a217f635e3$export$72e99a23ae3ed0b0 = (payload)=>({
        type: $828778a217f635e3$export$e9af2723cb3ed91e,
        payload: payload
    });

});


parcelRegister("17kP6", function(module, exports) {

$parcel$export(module.exports, "ISSUE_VIEW_UPDATE", () => $0dba4489a533382f$export$be7899fc700a03e7);
$parcel$export(module.exports, "issueViewUpdate", () => $0dba4489a533382f$export$758415d5f0ecccd0);
const $0dba4489a533382f$export$be7899fc700a03e7 = 'state.actions.issue-view-update.ISSUE_VIEW_UPDATE';
const $0dba4489a533382f$export$758415d5f0ecccd0 = (payload)=>({
        type: $0dba4489a533382f$export$be7899fc700a03e7,
        payload: payload
    });

});


parcelRegister("5z625", function(module, exports) {

$parcel$export(module.exports, "fetchData", () => $f8d821d1f878bbaa$export$8134c072fddab6a5);
$parcel$export(module.exports, "loadAgilityGraphqlDataEpic", () => $f8d821d1f878bbaa$export$8976970ef97c8467);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("d0pqD");
parcelRequire("c66Ur");

var $2YZCu = parcelRequire("2YZCu");

var $72ViA = parcelRequire("72ViA");

var $3lZ6i = parcelRequire("3lZ6i");

var $jG5HW = parcelRequire("jG5HW");
const $f8d821d1f878bbaa$export$8134c072fddab6a5 = (params)=>{
    const { store: store, prefetchedData: prefetchedData = null, storeFieldsActions: storeFieldsActions } = params;
    const state = store.getState();
    const baseUrl = (0, $jG5HW.getBaseUrl)(state);
    const boardId = (0, $jG5HW.getRapidViewId)(state);
    const isCompanyManaged = (0, $jG5HW.getIsCompanyManaged)(state);
    const storyPointFieldId = (0, $jG5HW.getStoryPointFieldId)(state);
    const fieldConfigs = {
        storyPointFieldId: storyPointFieldId
    };
    return (0, $72ViA.default)({
        baseUrl: baseUrl,
        boardId: boardId,
        fieldConfigs: fieldConfigs,
        prefetchedData: prefetchedData,
        storeFieldsActions: storeFieldsActions,
        isCompanyManaged: isCompanyManaged
    }).map((0, $3lZ6i.setAppData)).catch((restError)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('backlog.load-agility-graphql-data.failure', 'Failed to load graphql data', restError);
        return (0, $kVLXA.Observable).of((0, $3lZ6i.loadAppDataFailure)());
    });
};
const $f8d821d1f878bbaa$export$8976970ef97c8467 = (action$, store)=>action$.ofType((0, $3lZ6i.LOAD_APP_DATA_REQUEST)).flatMap((action)=>$f8d821d1f878bbaa$export$8134c072fddab6a5({
            store: store,
            prefetchedData: action.payload.prefetchedData,
            storeFieldsActions: action.payload.storeFieldsActions
        }));

});
parcelRegister("72ViA", function(module, exports) {

$parcel$export(module.exports, "default", () => $84754d5dceb75031$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("d0pqD");

var $74daz = parcelRequire("74daz");

var $4EjDu = parcelRequire("4EjDu");
function $84754d5dceb75031$var$updateStoreFields(data, fieldConfigs, updateFieldsAction) {
    if (updateFieldsAction && fieldConfigs) updateFieldsAction(data, fieldConfigs);
}
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$84754d5dceb75031$export$2e2bcd8739ae039 = ({ baseUrl: baseUrl, boardId: boardId, isCompanyManaged: isCompanyManaged, fieldConfigs: fieldConfigs, prefetchedData: prefetchedData, storeFieldsActions: storeFieldsActions })=>{
    const getResponse = ()=>{
        if (prefetchedData) {
            $84754d5dceb75031$var$updateStoreFields(prefetchedData, fieldConfigs, storeFieldsActions?.storeFieldsFromPrefetchedData);
            return (0, $kVLXA.Observable).of(prefetchedData);
        }
        return (0, $74daz.default)(baseUrl, boardId);
    };
    return getResponse().map((data)=>{
        $84754d5dceb75031$var$updateStoreFields(data, fieldConfigs, storeFieldsActions?.storeFieldsFromPrefetchedData);
        return (0, $4EjDu.default)(data, isCompanyManaged);
    });
};

});


parcelRegister("vO8Pq", function(module, exports) {

$parcel$export(module.exports, "loadCardCreateConfigEpic", () => $a55a2bbb1993897a$export$8772c54f1f4570e1);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("d0pqD");
parcelRequire("c66Ur");

var $2YZCu = parcelRequire("2YZCu");

var $2AULr = parcelRequire("2AULr");

var $3lZ6i = parcelRequire("3lZ6i");

var $jG5HW = parcelRequire("jG5HW");
const $a55a2bbb1993897a$export$8772c54f1f4570e1 = (action$, store, dependencies)=>action$.ofType((0, $3lZ6i.LOAD_CARD_CREATE_CONFIG_REQUEST), (0, $3lZ6i.LOAD_CONFIG_DATA_MODEL_SUCCESS)).flatMap((action)=>{
        const state = store.getState();
        const jqlQuery = action.type === (0, $3lZ6i.LOAD_CONFIG_DATA_MODEL_SUCCESS) ? action.payload.config.jqlQuery : (0, $jG5HW.getJqlQuery)(state) || '';
        const analyticsEvent = dependencies && dependencies.createAnalyticsEvent ? dependencies.createAnalyticsEvent({
            action: 'load',
            actionSubject: 'cardCreateConfig'
        }) : undefined;
        return (0, $2AULr.default)(jqlQuery).map((cardConfigResponse)=>(0, $3lZ6i.loadCardCreateConfigSuccess)(cardConfigResponse, analyticsEvent)).catch((error)=>{
            (0, $2YZCu.default).safeErrorWithoutCustomerData('backlog.load-card-create-config.failure', 'Failed to load card create config from REST', error);
            return (0, $kVLXA.Observable).of((0, $3lZ6i.loadCardCreateConfigFailure)(error, analyticsEvent));
        });
    });

});
parcelRegister("2AULr", function(module, exports) {

$parcel$export(module.exports, "default", () => $636153f632b2190a$export$2e2bcd8739ae039);

var $g4tDr = parcelRequire("g4tDr");

var $bJTER = parcelRequire("bJTER");
parcelRequire("d0pqD");
const $636153f632b2190a$export$6b468dcfb64c653c = (response)=>{
    if (!response.issueTypes.successful) return {
        cardTypes: []
    };
    return {
        cardTypes: response.issueTypes.values.map((issueType)=>({
                id: Number(issueType.id),
                name: issueType.name,
                iconUrl: issueType.iconUrl,
                hasRequiredFields: null,
                typeHierarchyLevel: (0, $g4tDr.getHierarchyLevelTypeSplitEpicFromCustom)(issueType.hierarchyLevel)
            }))
    };
};
const $636153f632b2190a$var$loadCardCreateConfigService = (jqlQuery)=>(0, $bJTER.loadCardCreateConfig)(jqlQuery).map($636153f632b2190a$export$6b468dcfb64c653c);
var $636153f632b2190a$export$2e2bcd8739ae039 = $636153f632b2190a$var$loadCardCreateConfigService;

});
parcelRegister("bJTER", function(module, exports) {

$parcel$export(module.exports, "loadCardCreateConfig", () => $6e699de5e1bddbb9$export$149bf88f2a958c35);

var $ebyGx = parcelRequire("ebyGx");

var $487fd = parcelRequire("487fd");
function $6e699de5e1bddbb9$export$149bf88f2a958c35(jqlQuery) {
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
        query: jqlQuery
    });
    return (0, $487fd.default)(`/rest/inline-create/1.0/context/bootstrap?${query}`);
}

});



parcelRegister("9Vyzy", function(module, exports) {

$parcel$export(module.exports, "loadConfigDataEpicCmp", () => $0180c36fc9d74144$export$6c9a22a434be99a2);
parcelRequire("fp4O3");
parcelRequire("zjDln");
parcelRequire("9IWoG");
parcelRequire("d0pqD");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $kVLXA = parcelRequire("kVLXA");

var $2YZCu = parcelRequire("2YZCu");

var $8UYjN = parcelRequire("8UYjN");

var $i4Z8q = parcelRequire("i4Z8q");

var $3lZ6i = parcelRequire("3lZ6i");
const $0180c36fc9d74144$export$6c9a22a434be99a2 = (action$, store)=>action$.ofType((0, $3lZ6i.LOAD_CONFIG_DATA_REQUEST)).mergeMap(()=>(0, $8UYjN.default)((0, $i4Z8q.makeServiceContext)(store.getState()))).mergeMap((response)=>(0, $kVLXA.Observable).of((0, $3lZ6i.loadConfigDataModelSuccess)(response))).catch((error)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('backlog.load-config-data-cmp.failure', 'Failed to load config data for CMP', error);
        return (0, $kVLXA.Observable).of((0, $3lZ6i.loadConfigDataFailure)());
    });

});
parcelRegister("8UYjN", function(module, exports) {

$parcel$export(module.exports, "transformer", () => $c678f0380b48c4d6$export$6b468dcfb64c653c);
$parcel$export(module.exports, "default", () => $c678f0380b48c4d6$export$2e2bcd8739ae039);

var $sLb2Q = parcelRequire("sLb2Q");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("d0pqD");

var $gBj4V = parcelRequire("gBj4V");

var $guzeq = parcelRequire("guzeq");

var $710AE = parcelRequire("710AE");

var $bDQw3 = parcelRequire("bDQw3");
const $c678f0380b48c4d6$var$transformEstimationType = (resp)=>{
    const currentStatisticFieldPrefix = (0, $guzeq.statisticFieldPrefixes).find((statisticFieldPrefix)=>resp?.estimationStatisticConfig?.currentEstimationStatistic?.id?.startsWith(statisticFieldPrefix) ?? false) ?? (0, $guzeq.ISSUE_COUNT_ID);
    return (0, $guzeq.statisticFieldToEstimateType)[currentStatisticFieldPrefix] ?? (0, $guzeq.ISSUE_COUNT);
};
const $c678f0380b48c4d6$var$transformEstimation = (response)=>({
        isEstimationFeatureEnabled: response.estimationStatisticConfig?.currentEstimationStatistic?.isEnabled ?? false,
        estimationType: $c678f0380b48c4d6$var$transformEstimationType(response),
        estimationFieldId: response.estimationStatisticConfig?.currentEstimationStatistic?.fieldId ?? null,
        name: response.estimationStatisticConfig?.currentEstimationStatistic?.name ?? ''
    });
const $c678f0380b48c4d6$var$transformTracking = (response)=>({
        isEnabled: response.trackingStatisticConfig?.currentTrackingStatistic.isEnabled ?? false,
        typeId: response.trackingStatisticConfig?.currentTrackingStatistic.typeId ?? '',
        fieldId: response.trackingStatisticConfig?.currentTrackingStatistic.fieldId ?? '',
        isValid: response.trackingStatisticConfig?.currentTrackingStatistic.isValid ?? false,
        name: response.trackingStatisticConfig?.currentTrackingStatistic.name ?? ''
    });
const $c678f0380b48c4d6$export$6b468dcfb64c653c = (boardConfig, globalConfig, isCompanyManaged = false)=>({
        entities: {
            estimation: $c678f0380b48c4d6$var$transformEstimation(boardConfig),
            ...isCompanyManaged ? {
                tracking: $c678f0380b48c4d6$var$transformTracking(boardConfig)
            } : {},
            quickFilters: boardConfig.quickFilterConfig?.quickFilters?.map((f)=>({
                    ...f,
                    id: String(f.id)
                })) ?? []
        },
        config: {
            isInlineCardCreateEnabled: boardConfig.isInlineCardCreateEnabled,
            backlogStrategy: boardConfig.backlogStrategy,
            epicIssueType: globalConfig.epicConfig?.epicIssueTypeId ? {
                id: globalConfig.epicConfig?.epicIssueTypeId,
                name: globalConfig.epicConfig?.epicIssueTypeName,
                iconUrl: globalConfig.epicConfig?.epicIssueTypeIconUrl
            } : null,
            epicLinkField: globalConfig.epicConfig?.epicLinkFieldId ? {
                id: globalConfig.epicConfig?.epicLinkFieldId,
                name: globalConfig.epicConfig?.epicLinkFieldName
            } : null,
            ...isCompanyManaged ? {
                name: boardConfig.name,
                epicColorFieldId: globalConfig?.epicConfig?.colorFieldId,
                storyPointFieldId: boardConfig.estimationStatisticConfig?.currentEstimationStatistic?.fieldId || null,
                sprintFieldId: globalConfig.sprintConfig?.sprintFieldId,
                timeTrackingOptions: {
                    workingHoursPerDay: globalConfig.timeTrackingConfig?.hoursPerDay || (0, $gBj4V.defaultTimeTrackingOptions).workingHoursPerDay,
                    workingDaysPerWeek: globalConfig.timeTrackingConfig?.daysPerWeek || (0, $gBj4V.defaultTimeTrackingOptions).workingDaysPerWeek,
                    timeFormat: globalConfig.timeTrackingConfig?.timeFormat || (0, $gBj4V.TimeFormats).PRETTY,
                    defaultUnit: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    globalConfig.timeTrackingConfig?.defaultUnit?.toLowerCase() || (0, $gBj4V.TimeUnits).MINUTE
                }
            } : undefined,
            jqlQuery: boardConfig.filterConfig?.query,
            isOrderedByRank: boardConfig.filterConfig?.isOrderedByRank,
            isBoardCrossProject: boardConfig.isBoardCrossProject,
            parallelSprints: boardConfig.parallelSprints,
            showEpicAsPanel: boardConfig.showEpicAsPanel
        },
        columns: (0, (/*@__PURE__*/$parcel$interopDefault($sLb2Q)))(boardConfig.rapidListConfig.mappedColumns.map((column)=>column.id), boardConfig.rapidListConfig.mappedColumns.map((column, index)=>({
                id: column.id,
                name: column.name,
                order: index,
                statuses: column.mappedStatuses.map((status)=>({
                        id: status.id,
                        name: status.name,
                        isInitial: status.isInitial,
                        isResolutionDone: status.isResolutionDone,
                        category: status.statusCategory.key
                    }))
            })))
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c678f0380b48c4d6$export$2e2bcd8739ae039 = (serviceContext)=>(0, $kVLXA.Observable).forkJoin((0, $710AE.default)(serviceContext.boardId), (0, $bDQw3.default)()).map(([boardConfigResponse, globalConfigResponse])=>$c678f0380b48c4d6$export$6b468dcfb64c653c(boardConfigResponse, globalConfigResponse, serviceContext.isCompanyManaged));

});
parcelRegister("gBj4V", function(module, exports) {

$parcel$export(module.exports, "SECONDS_PER_MINUTE", () => $f8bb2765f8828f08$export$544c576050746347);
$parcel$export(module.exports, "SECONDS_PER_HOUR", () => $f8bb2765f8828f08$export$3cc7ae4b390f50a);
$parcel$export(module.exports, "TimeFormats", () => $f8bb2765f8828f08$export$5d7ed58d46354b1);
$parcel$export(module.exports, "TimeUnits", () => $f8bb2765f8828f08$export$5d7753c8ad881494);
$parcel$export(module.exports, "defaultTimeTrackingOptions", () => $f8bb2765f8828f08$export$f8d48c1fed813e90);
const $f8bb2765f8828f08$export$544c576050746347 = 60;
const $f8bb2765f8828f08$var$MINUTES_PER_HOUR = 60;
const $f8bb2765f8828f08$export$3cc7ae4b390f50a = $f8bb2765f8828f08$var$MINUTES_PER_HOUR * $f8bb2765f8828f08$export$544c576050746347;
const $f8bb2765f8828f08$var$TIME_FORMAT_PRETTY = 'pretty';
const $f8bb2765f8828f08$var$TIME_FORMAT_DAYS = 'days';
const $f8bb2765f8828f08$var$TIME_FORMAT_HOURS = 'hours';
const $f8bb2765f8828f08$export$5d7ed58d46354b1 = Object.freeze({
    PRETTY: $f8bb2765f8828f08$var$TIME_FORMAT_PRETTY,
    DAYS: $f8bb2765f8828f08$var$TIME_FORMAT_DAYS,
    HOURS: $f8bb2765f8828f08$var$TIME_FORMAT_HOURS
});
const $f8bb2765f8828f08$var$TIME_UNIT_WEEK = 'week';
const $f8bb2765f8828f08$var$TIME_UNIT_DAY = 'day';
const $f8bb2765f8828f08$var$TIME_UNIT_HOUR = 'hour';
const $f8bb2765f8828f08$var$TIME_UNIT_MINUTE = 'minute';
const $f8bb2765f8828f08$export$5d7753c8ad881494 = Object.freeze({
    WEEK: $f8bb2765f8828f08$var$TIME_UNIT_WEEK,
    DAY: $f8bb2765f8828f08$var$TIME_UNIT_DAY,
    HOUR: $f8bb2765f8828f08$var$TIME_UNIT_HOUR,
    MINUTE: $f8bb2765f8828f08$var$TIME_UNIT_MINUTE
});
const $f8bb2765f8828f08$export$f8d48c1fed813e90 = {
    workingHoursPerDay: 8,
    workingDaysPerWeek: 5,
    timeFormat: $f8bb2765f8828f08$export$5d7ed58d46354b1.PRETTY,
    defaultUnit: $f8bb2765f8828f08$export$5d7753c8ad881494.MINUTE
};

});

parcelRegister("710AE", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5ac5d6c5c6afa1a$export$2e2bcd8739ae039);

var $487fd = parcelRequire("487fd");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f5ac5d6c5c6afa1a$export$2e2bcd8739ae039 = (rapidViewId)=>(0, $487fd.default)(`/rest/greenhopper/3/xboard/config?boardId=${rapidViewId}&operation=ConfigData`);

});

parcelRegister("bDQw3", function(module, exports) {

$parcel$export(module.exports, "default", () => $c783422664db1d4c$export$2e2bcd8739ae039);

var $487fd = parcelRequire("487fd");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c783422664db1d4c$export$2e2bcd8739ae039 = ()=>(0, $487fd.default)('/rest/greenhopper/3/globalconfig?operation=GlobalConfigData');

});



parcelRegister("41ack", function(module, exports) {

$parcel$export(module.exports, "loadConfigDataEpic", () => $c18b672f1c28d11e$export$cc32ef09edf2b5cb);
parcelRequire("fp4O3");
parcelRequire("zjDln");
parcelRequire("9IWoG");
parcelRequire("d0pqD");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $7uUwQ = parcelRequire("7uUwQ");

var $kVLXA = parcelRequire("kVLXA");

var $2YZCu = parcelRequire("2YZCu");

var $j6Jic = parcelRequire("j6Jic");

var $GtqoM = parcelRequire("GtqoM");

var $i4Z8q = parcelRequire("i4Z8q");

var $3lZ6i = parcelRequire("3lZ6i");

var $cPahM = parcelRequire("cPahM");
const $c18b672f1c28d11e$export$cc32ef09edf2b5cb = (action$, store)=>action$.ofType((0, $3lZ6i.LOAD_CONFIG_DATA_REQUEST)).mergeMap(()=>(0, $kVLXA.Observable).forkJoin((0, $GtqoM.default)((0, $i4Z8q.makeServiceContext)(store.getState())), (0, $j6Jic.default)(store))).mergeMap(([{ entities: entities, config: config, columns: columns }, additionalBoardData])=>(0, $kVLXA.Observable).from([
            (0, $3lZ6i.setConfigData)((0, $7uUwQ.merge)({
                entities: entities,
                config: config
            }, additionalBoardData)),
            (0, $3lZ6i.loadConfigDataSuccess)(),
            (0, $cPahM.setColumns)(columns)
        ])).catch((error)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('backlog.load-config-data.failure', 'Failed to load config data', error);
        return (0, $kVLXA.Observable).of((0, $3lZ6i.loadConfigDataFailure)());
    });

});
parcelRegister("j6Jic", function(module, exports) {

$parcel$export(module.exports, "default", () => $1244acb31847e756$export$2e2bcd8739ae039);
parcelRequire("d0pqD");


var $7ZKYz = parcelRequire("7ZKYz");

var $jG5HW = parcelRequire("jG5HW");
const $1244acb31847e756$export$6b468dcfb64c653c = (response, isCompanyManaged)=>({
        config: {
            permissions: !isCompanyManaged ? {
                [(0, $a33d0dff7e784665$export$a20ec683078f5f77)]: response.canDeleteIssues
            } : {},
            isInlineCardCreateEnabled: response.isInlineCardCreateEnabled
        }
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1244acb31847e756$export$2e2bcd8739ae039 = (store)=>{
    const state = store.getState();
    const baseUrl = (0, $jG5HW.getBaseUrl)(state);
    const rapidViewId = (0, $jG5HW.getRapidViewId)(state);
    const isCompanyManaged = (0, $jG5HW.getIsCompanyManaged)(state);
    return (0, $7ZKYz.default)(baseUrl, rapidViewId).map((response)=>$1244acb31847e756$export$6b468dcfb64c653c(response, isCompanyManaged));
};

});
parcelRegister("7ZKYz", function(module, exports) {

$parcel$export(module.exports, "default", () => $87a0bf6efd4bc3c8$export$2e2bcd8739ae039);

var $487fd = parcelRequire("487fd");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$87a0bf6efd4bc3c8$export$2e2bcd8739ae039 = (baseUrl, rapidViewId)=>(0, $487fd.default)(`${baseUrl}/rest/greenhopper/1.0/xboard/work/additionalBoardData?rapidViewId=${rapidViewId}`);

});


parcelRegister("GtqoM", function(module, exports) {

$parcel$export(module.exports, "default", () => $d55220375b735463$export$2e2bcd8739ae039);

var $sLb2Q = parcelRequire("sLb2Q");
parcelRequire("d0pqD");

var $gBj4V = parcelRequire("gBj4V");

var $4R6GH = parcelRequire("4R6GH");


var $guzeq = parcelRequire("guzeq");

var $cNe1c = parcelRequire("cNe1c");
const $d55220375b735463$var$transformEstimationType = (resp)=>{
    const currentStatisticFieldPrefix = (0, $guzeq.statisticFieldPrefixes).find((statisticFieldPrefix)=>resp?.estimationStatisticConfig?.currentEstimationStatistic?.id?.startsWith(statisticFieldPrefix) ?? false) ?? (0, $guzeq.ISSUE_COUNT_ID);
    return (0, $guzeq.statisticFieldToEstimateType)[currentStatisticFieldPrefix] ?? (0, $guzeq.ISSUE_COUNT);
};
const $d55220375b735463$var$transformEstimation = (response)=>({
        isEstimationFeatureEnabled: response?.estimationStatisticConfig?.currentEstimationStatistic?.isEnabled ?? false,
        estimationType: $d55220375b735463$var$transformEstimationType(response),
        estimationFieldId: response?.estimationStatisticConfig?.currentEstimationStatistic?.fieldId ?? null,
        name: response?.estimationStatisticConfig?.currentEstimationStatistic?.name ?? ''
    });
const $d55220375b735463$export$6b468dcfb64c653c = (resp, isCompanyManaged = false)=>({
        entities: {
            estimation: $d55220375b735463$var$transformEstimation(resp),
            quickFilters: resp?.quickFilterConfig?.quickFilters?.map((f)=>({
                    ...f,
                    id: String(f.id)
                })) ?? []
        },
        config: {
            permissions: !isCompanyManaged ? {
                [(0, $a33d0dff7e784665$export$b35e3ebf2c83a499)]: resp.canEdit
            } : {},
            backlogStrategy: resp.backlogStrategy,
            epicIssueType: resp?.globalConfig?.epicConfig?.epicIssueTypeId ? {
                id: resp?.globalConfig?.epicConfig?.epicIssueTypeId,
                name: resp?.globalConfig?.epicConfig?.epicIssueTypeName,
                iconUrl: resp?.globalConfig?.epicConfig?.epicIssueTypeIconUrl
            } : null,
            epicLinkField: resp?.globalConfig?.epicConfig?.epicLinkFieldId ? {
                id: resp?.globalConfig?.epicConfig?.epicLinkFieldId,
                name: resp?.globalConfig?.epicConfig?.epicLinkFieldName
            } : null,
            ...(0, $4R6GH.fg)('ai_powered_backlog_inline_create-create_in_sprint') ? {
                sprintFieldId: resp?.globalConfig?.sprintConfig?.sprintFieldId
            } : {},
            ...isCompanyManaged ? {
                name: resp.name,
                storyPointFieldId: resp?.estimationStatisticConfig?.currentEstimationStatistic?.fieldId || null,
                ...!(0, $4R6GH.fg)('ai_powered_backlog_inline_create-create_in_sprint') ? {
                    sprintFieldId: resp?.globalConfig?.sprintConfig?.sprintFieldId
                } : {},
                timeTrackingOptions: {
                    workingHoursPerDay: resp?.globalConfig?.timeTrackingConfig?.hoursPerDay || (0, $gBj4V.defaultTimeTrackingOptions).workingHoursPerDay,
                    workingDaysPerWeek: resp?.globalConfig?.timeTrackingConfig?.daysPerWeek || (0, $gBj4V.defaultTimeTrackingOptions).workingDaysPerWeek,
                    timeFormat: resp?.globalConfig?.timeTrackingConfig?.timeFormat || (0, $gBj4V.TimeFormats).PRETTY,
                    defaultUnit: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    resp?.globalConfig?.timeTrackingConfig?.defaultUnit?.toLowerCase() || (0, $gBj4V.TimeUnits).MINUTE
                }
            } : undefined,
            jqlQuery: resp?.filterConfig?.query,
            isOrderedByRank: resp?.filterConfig?.isOrderedByRank,
            isBoardCrossProject: resp.isBoardCrossProject,
            parallelSprints: resp.globalConfig.parallelSprints,
            showEpicAsPanel: resp.showEpicAsPanel
        },
        columns: (0, (/*@__PURE__*/$parcel$interopDefault($sLb2Q)))(resp.rapidListConfig.mappedColumns.map((column)=>column.id), resp.rapidListConfig.mappedColumns.map((column, index)=>({
                id: column.id,
                name: column.name,
                order: index,
                statuses: column.mappedStatuses.map((status)=>({
                        id: status.id,
                        name: status.name,
                        isInitial: status.isInitial,
                        isResolutionDone: status.isResolutionDone,
                        category: status.statusCategory.key
                    }))
            })))
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d55220375b735463$export$2e2bcd8739ae039 = (serviceContext)=>(0, $cNe1c.default)(serviceContext.boardId).map((response)=>$d55220375b735463$export$6b468dcfb64c653c(response, serviceContext.isCompanyManaged));

});
parcelRegister("cNe1c", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a451a4424baaf29$export$2e2bcd8739ae039);

var $487fd = parcelRequire("487fd");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7a451a4424baaf29$export$2e2bcd8739ae039 = (rapidViewId)=>(0, $487fd.default)(`/rest/greenhopper/1.0/rapidviewconfig/editmodel?rapidViewId=${rapidViewId}`);

});


parcelRegister("cPahM", function(module, exports) {

$parcel$export(module.exports, "SET_COLUMNS", () => $48820c1d307941ee$export$f7b453d5c91bc422);
$parcel$export(module.exports, "setColumns", () => $48820c1d307941ee$export$cfc099c0be5cff67);
const $48820c1d307941ee$export$f7b453d5c91bc422 = 'state.actions.columns.SET_COLUMNS';
const $48820c1d307941ee$export$cfc099c0be5cff67 = (columns)=>({
        type: $48820c1d307941ee$export$f7b453d5c91bc422,
        payload: {
            columns: columns
        }
    });

});


parcelRegister("1fqjN", function(module, exports) {

$parcel$export(module.exports, "loadCurrentUserEpic", () => $aae03fc097f92e2d$export$9ce838b1f98e9002);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("1oQta");
parcelRequire("fPS7b");
parcelRequire("d0pqD");
parcelRequire("c66Ur");

var $2YZCu = parcelRequire("2YZCu");

var $f4Hvj = parcelRequire("f4Hvj");

var $bI3co = parcelRequire("bI3co");

var $jG5HW = parcelRequire("jG5HW");
const $aae03fc097f92e2d$export$9ce838b1f98e9002 = (action$, store)=>action$.ofType((0, $bI3co.REQUEST_CURRENT_USER)).map(()=>(0, $jG5HW.getAtlassianAccountId)(store.getState())).filter((accountId)=>accountId !== null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .mergeMap((accountId)=>(0, $f4Hvj.default)(store, accountId)).map((appData)=>(0, $bI3co.setCurrentUser)(appData)).catch((error)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('backlog.load-current-user.failure', 'Failed to load current user data', error);
        // no error flag, as this data is not critical for application
        return (0, $kVLXA.Observable).empty();
    });

});
parcelRegister("f4Hvj", function(module, exports) {

$parcel$export(module.exports, "default", () => $dec88a097577de3f$export$2e2bcd8739ae039);
parcelRequire("d0pqD");

var $g6xSt = parcelRequire("g6xSt");

var $jG5HW = parcelRequire("jG5HW");
const $dec88a097577de3f$export$6b468dcfb64c653c = (response)=>({
        id: response.accountId,
        displayName: response.displayName,
        avatarUrl: response.avatarUrls['48x48']
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$dec88a097577de3f$export$2e2bcd8739ae039 = (store, accountId)=>{
    const state = store.getState();
    const baseUrl = (0, $jG5HW.getBaseUrl)(state);
    return (0, $g6xSt.default)(baseUrl, accountId).map($dec88a097577de3f$export$6b468dcfb64c653c);
};

});
parcelRegister("g6xSt", function(module, exports) {

$parcel$export(module.exports, "default", () => $66e11ce5ad8ea8f2$export$2e2bcd8739ae039);

var $487fd = parcelRequire("487fd");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$66e11ce5ad8ea8f2$export$2e2bcd8739ae039 = (baseUrl, accountId)=>(0, $487fd.default)(`${baseUrl}/rest/api/2/user?accountId=${accountId}`);

});


parcelRegister("bI3co", function(module, exports) {

$parcel$export(module.exports, "REQUEST_CURRENT_USER", () => $985a85ff9b223813$export$23c24718e49aca5d);
$parcel$export(module.exports, "SET_CURRENT_USER", () => $985a85ff9b223813$export$c6dfa1844d1d3b74);
$parcel$export(module.exports, "requestCurrentUser", () => $985a85ff9b223813$export$96fd75d854a9dd1);
$parcel$export(module.exports, "setCurrentUser", () => $985a85ff9b223813$export$64e99e757b084e7c);
const $985a85ff9b223813$export$23c24718e49aca5d = 'state.actions.user.REQUEST_CURRENT_USER';
const $985a85ff9b223813$export$c6dfa1844d1d3b74 = 'state.actions.user.SET_CURRENT_USER';
const $985a85ff9b223813$export$96fd75d854a9dd1 = ()=>({
        type: $985a85ff9b223813$export$23c24718e49aca5d
    });
const $985a85ff9b223813$export$64e99e757b084e7c = (payload)=>({
        type: $985a85ff9b223813$export$c6dfa1844d1d3b74,
        payload: payload
    });

});


parcelRegister("cZpfH", function(module, exports) {

$parcel$export(module.exports, "loadPermissionsEpic", () => $3813d671af33e4d2$export$f7fed3a68920cb18);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("d0pqD");
parcelRequire("c66Ur");

var $2YZCu = parcelRequire("2YZCu");

var $ihDIX = parcelRequire("ihDIX");

var $3lZ6i = parcelRequire("3lZ6i");

var $fNaAq = parcelRequire("fNaAq");

var $jG5HW = parcelRequire("jG5HW");
const $3813d671af33e4d2$var$loadPermissions = ({ store: store })=>{
    const state = store.getState();
    const boardId = (0, $jG5HW.getRapidViewId)(state);
    return (0, $ihDIX.loadPermissionsService)(boardId).map((0, $fNaAq.fetchPermissionsSuccess)).catch((error)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('backlog.load-permission.failure', 'Failed to fetch permissions for Company-Managed backlog', error);
        return (0, $kVLXA.Observable).of((0, $fNaAq.fetchPermissionsFailure)());
    });
};
const $3813d671af33e4d2$export$f7fed3a68920cb18 = (action$, store)=>action$.ofType((0, $3lZ6i.LOAD_APP_DATA_REQUEST)).flatMap(()=>$3813d671af33e4d2$var$loadPermissions({
            store: store
        }));

});
parcelRegister("ihDIX", function(module, exports) {

$parcel$export(module.exports, "loadPermissionsService", () => $ad5d17ab0b633e4f$export$4c653019d1c2f19f);
parcelRequire("d0pqD");

var $jA1Dj = parcelRequire("jA1Dj");

var $dJc1e = parcelRequire("dJc1e");

var $3E9ii = parcelRequire("3E9ii");
const $ad5d17ab0b633e4f$var$toBacklogPermissions = (response)=>(0, $jA1Dj.fromServicePermission)(response.boardPermissions);
const $ad5d17ab0b633e4f$export$4c653019d1c2f19f = (boardId)=>(0, $3E9ii.fetchPermissions)(boardId, (0, $dJc1e.getDefaultCompanyManagedPermissions)()).map($ad5d17ab0b633e4f$var$toBacklogPermissions);

});
parcelRegister("jA1Dj", function(module, exports) {

$parcel$export(module.exports, "fromServicePermission", () => $48c50d3a40c621b4$export$b37c57dce4c43c62);

var $cuHs1 = parcelRequire("cuHs1");

var $guzeq = parcelRequire("guzeq");

const $48c50d3a40c621b4$var$serviceToBacklogPermissions = {
    [(0, $guzeq.VIEW_BOARD)]: (0, $a33d0dff7e784665$export$feb9a4de117c162),
    [(0, $guzeq.ADMINISTER_BOARD)]: (0, $a33d0dff7e784665$export$b35e3ebf2c83a499),
    [(0, $guzeq.BULK_CHANGE)]: (0, $a33d0dff7e784665$export$a71edb30f3453bef),
    [(0, $guzeq.MANAGE_SPRINT)]: (0, $a33d0dff7e784665$export$d765836bd761b2ee),
    [(0, $guzeq.CREATE_ISSUE)]: (0, $a33d0dff7e784665$export$526c94c551c00291),
    [(0, $guzeq.EDIT_ISSUE)]: (0, $a33d0dff7e784665$export$8a1ecb9983951227),
    [(0, $guzeq.DELETE_ISSUE)]: (0, $a33d0dff7e784665$export$a20ec683078f5f77),
    [(0, $guzeq.ASSIGN_ISSUE)]: (0, $a33d0dff7e784665$export$9c0523cef5fab15e),
    [(0, $guzeq.TRANSITION_ISSUE)]: (0, $a33d0dff7e784665$export$b5f3bd28b6a935be),
    [(0, $guzeq.ARCHIVE_ISSUE)]: (0, $a33d0dff7e784665$export$e6bcada406923d66)
};
const $48c50d3a40c621b4$export$b37c57dce4c43c62 = (permissions)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, (/*@__PURE__*/$parcel$interopDefault($cuHs1)))(permissions, (value, key)=>$48c50d3a40c621b4$var$serviceToBacklogPermissions[key]);
};

});
parcelRegister("cuHs1", function(module, exports) {

var $1m3dq = parcelRequire("1m3dq");

var $hDnyx = parcelRequire("hDnyx");

var $bxDef = parcelRequire("bxDef");
/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */ function $0258ef72e36fbfcb$var$mapKeys(object, iteratee) {
    var result = {};
    iteratee = $bxDef(iteratee, 3);
    $hDnyx(object, function(value, key, object) {
        $1m3dq(result, iteratee(value, key, object), value);
    });
    return result;
}
module.exports = $0258ef72e36fbfcb$var$mapKeys;

});


parcelRegister("dJc1e", function(module, exports) {

$parcel$export(module.exports, "getDefaultCompanyManagedPermissions", () => $f3e48a17e0e8f0b7$export$125a09606aa6423a);

var $guzeq = parcelRequire("guzeq");
const $f3e48a17e0e8f0b7$export$125a09606aa6423a = ()=>[
        (0, $guzeq.VIEW_BOARD),
        (0, $guzeq.ADMINISTER_BOARD),
        (0, $guzeq.BULK_CHANGE),
        (0, $guzeq.DELETE_ISSUE),
        (0, $guzeq.EDIT_ISSUE),
        (0, $guzeq.CREATE_ISSUE),
        (0, $guzeq.ASSIGN_ISSUE),
        (0, $guzeq.TRANSITION_ISSUE),
        (0, $guzeq.MANAGE_SPRINT)
    ];

});

parcelRegister("3E9ii", function(module, exports) {

$parcel$export(module.exports, "fetchPermissions", () => $6d5301b501e92c7f$export$4f24ecba11982e9d);

var $487fd = parcelRequire("487fd");
function $6d5301b501e92c7f$export$4f24ecba11982e9d(boardId, permissions = []) {
    return (0, $487fd.default)(`/rest/greenhopper/1.0/xboard/permissions?boardId=${boardId}&permissions=${permissions.join(',')}`);
}

});


parcelRegister("fNaAq", function(module, exports) {

$parcel$export(module.exports, "FETCH_PERMISSIONS_SUCCESS", () => $b2cf0d2beefc4c2b$export$ba150518109978de);
$parcel$export(module.exports, "fetchPermissionsSuccess", () => $b2cf0d2beefc4c2b$export$9ea81e209e5fa95a);
$parcel$export(module.exports, "fetchPermissionsFailure", () => $b2cf0d2beefc4c2b$export$81c33c1b0d6e16b1);
const $b2cf0d2beefc4c2b$export$ba150518109978de = 'state.actions.permissions.FETCH_PERMISSIONS_SUCCESS';
const $b2cf0d2beefc4c2b$export$9ea81e209e5fa95a = (permissions)=>({
        type: $b2cf0d2beefc4c2b$export$ba150518109978de,
        payload: {
            permissions: permissions
        }
    });
const $b2cf0d2beefc4c2b$export$87e65d60f042b0d0 = 'state.actions.permissions.FETCH_PERMISSIONS_FAILURE';
const $b2cf0d2beefc4c2b$export$81c33c1b0d6e16b1 = ()=>({
        type: $b2cf0d2beefc4c2b$export$87e65d60f042b0d0
    });

});


parcelRegister("3l3iU", function(module, exports) {

$parcel$export(module.exports, "loadPlanDataEpic", () => $3782687796b171ac$export$e0e3208a5652318a);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("9o0uh");
parcelRequire("93e44");
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("d0pqD");
parcelRequire("c66Ur");

var $99gkn = parcelRequire("99gkn");

var $2YZCu = parcelRequire("2YZCu");

var $4R6GH = parcelRequire("4R6GH");

var $lODMY = parcelRequire("lODMY");

var $dfMzt = parcelRequire("dfMzt");

var $j0SXO = parcelRequire("j0SXO");

var $3qYzN = parcelRequire("3qYzN");

var $3lZ6i = parcelRequire("3lZ6i");

var $jG5HW = parcelRequire("jG5HW");

var $l9VFH = parcelRequire("l9VFH");
const $3782687796b171ac$var$fetchData = ({ store: store, prefetchedData: prefetchedData, refreshData: refreshData, storeFieldsActions: storeFieldsActions })=>{
    const state = store.getState();
    const isCompanyManaged = (0, $jG5HW.getIsCompanyManaged)(state);
    const epicIssueType = (0, $jG5HW.getEpicIssueType)(state);
    const activeQuickFilters = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    (0, $l9VFH.getAppliedCustomFilters)(state) ?? (0, $dfMzt.getCustomFilterFromUrlQuery)(window.location);
    if (prefetchedData) {
        const refresh$ = refreshData && (0, $4R6GH.fg)('indexeddb_cache_for_backlog') ? (0, $kVLXA.Observable).fromPromise(refreshData) : (0, $kVLXA.Observable).empty();
        const refreshAction$ = refresh$.flatMap((data)=>(0, $kVLXA.Observable).of((0, $3lZ6i.setAppData)((0, $3qYzN.transformPlanData)(data, isCompanyManaged, activeQuickFilters))));
        if (isCompanyManaged) {
            const serverTime = Array.from(performance.getEntriesByType('resource')).find(({ name: name })=>name.includes('fetchBacklogData'))?.serverTiming.find(({ name: name })=>name === 'atl-edge')?.duration;
            (0, $99gkn.addUFOCustomData)({
                serverTime: serverTime
            });
        }
        return (0, $kVLXA.Observable).merge((0, $kVLXA.Observable).of((0, $3lZ6i.setAppData)((0, $3qYzN.transformPlanData)(prefetchedData, isCompanyManaged, activeQuickFilters))), refreshAction$);
    }
    const boardId = (0, $4R6GH.fg)('backlog-reset-data-when-data-updates') ? String((0, $lODMY.getRouterState)().match.params.boardId) : (0, $jG5HW.getRapidViewId)(state);
    return (0, $j0SXO.loadPlanDataService)({
        boardId: boardId,
        isCompanyManaged: isCompanyManaged,
        activeQuickFilters: activeQuickFilters,
        epicIssueType: epicIssueType,
        storeFieldsActions: storeFieldsActions
    }).map((0, $3lZ6i.setAppData)).catch((error)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('backlog.load-plan-data.failure', 'Failed to load plan data from REST', error);
        return (0, $kVLXA.Observable).of((0, $3lZ6i.loadAppDataFailure)());
    });
};
const $3782687796b171ac$export$e0e3208a5652318a = (action$, store, dependencies)=>action$.ofType((0, $3lZ6i.LOAD_APP_DATA_REQUEST)).flatMap(({ payload: payload })=>$3782687796b171ac$var$fetchData({
            store: store,
            prefetchedData: (0, $4R6GH.fg)('indexeddb_cache_for_backlog') ? payload.prefetchCmpBacklogData?.result : payload.prefetchedJiraPlanRestData,
            refreshData: (0, $4R6GH.fg)('indexeddb_cache_for_backlog') ? payload.prefetchCmpBacklogData?.refresh : null,
            storeFieldsActions: payload.storeFieldsActions || dependencies?.storeFieldsActions
        }));

});

parcelRegister("13hY5", function(module, exports) {

$parcel$export(module.exports, "loadPrioritiesEpic", () => $d30731ea5040493f$export$20ae9bff1fb86dc1);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("d0pqD");
parcelRequire("c66Ur");

var $2YZCu = parcelRequire("2YZCu");

var $5EGHE = parcelRequire("5EGHE");

var $3lZ6i = parcelRequire("3lZ6i");

var $c7Xu8 = parcelRequire("c7Xu8");

var $jG5HW = parcelRequire("jG5HW");
const $d30731ea5040493f$export$20ae9bff1fb86dc1 = (action$, store)=>action$.ofType((0, $3lZ6i.SET_APP_DATA), (0, $c7Xu8.LOAD_PRIORITIES_REQUEST)).flatMap(()=>{
        const state = store.getState();
        const projectIds = (0, $jG5HW.getProjectAris)(state);
        return (0, $5EGHE.fetchAllPriorities)(projectIds).map((0, $c7Xu8.loadPrioritiesSuccess)).catch((error)=>{
            (0, $2YZCu.default).safeErrorWithoutCustomerData('backlog.load-priorities.failure', 'Failed to load priorities from REST', error);
            return (0, $kVLXA.Observable).of((0, $c7Xu8.loadPrioritiesFailure)());
        });
    });

});
parcelRegister("5EGHE", function(module, exports) {

$parcel$export(module.exports, "fetchAllPriorities", () => $19029c30a6fee69a$export$910988adc9be7f87);
parcelRequire("9IWoG");
parcelRequire("d0pqD");

var $487fd = parcelRequire("487fd");

const $19029c30a6fee69a$export$6b468dcfb64c653c = (priorities)=>{
    const allPriorities = priorities.data.jira.jiraProjects.map((project)=>project.priorityScheme.priorities.edges.map((edge)=>({
                id: edge.node.priorityId,
                name: edge.node.name,
                iconUrl: edge.node.iconUrl
            })));
    const intersectingPriorities = allPriorities.reduce((prioritiesA, prioritiesB)=>prioritiesA.filter((priorityA)=>prioritiesB.some((priorityB)=>priorityA.id === priorityB.id)));
    return intersectingPriorities;
};
const $19029c30a6fee69a$export$910988adc9be7f87 = (projectIds)=>(0, $487fd.default)(`${(0, $d9b8a0aa13e64ddd$export$4159899b2a5c63f2)}?operation=${(0, $d9b8a0aa13e64ddd$export$21c589a2cbb3ede0)}`, {
        method: 'post',
        body: JSON.stringify({
            query: (0, $d9b8a0aa13e64ddd$export$4459165bea9549c9),
            variables: {
                projectIds: projectIds
            }
        })
    }).map($19029c30a6fee69a$export$6b468dcfb64c653c);

});
// To support the priorities per project feature we need to use the /rest/api/3/priority/search endpoint instead: https://developer.atlassian.com/cloud/jira/platform/rest/v3/api-group-issue-priorities/#api-rest-api-3-priority-search-get
const $d9b8a0aa13e64ddd$export$4159899b2a5c63f2 = '/rest/gira/1/';
const $d9b8a0aa13e64ddd$export$21c589a2cbb3ede0 = 'BacklogCardListPrioritiesQuery';
const $d9b8a0aa13e64ddd$export$4459165bea9549c9 = `
query ${$d9b8a0aa13e64ddd$export$21c589a2cbb3ede0} ($projectIds: [ID!]!) {
    jira {
        jiraProjects(ids: $projectIds) {
          priorityScheme {
            priorities {
              edges {
                node {
                  priorityId
                  name
                  iconUrl
                }
              }
            }
          }
        }
      }
}
`;


parcelRegister("c7Xu8", function(module, exports) {

$parcel$export(module.exports, "LOAD_PRIORITIES_REQUEST", () => $b6059f88a1f974a0$export$ec0e161fbc75b17);
$parcel$export(module.exports, "loadPriorities", () => $b6059f88a1f974a0$export$298a3cca1db04fc7);
$parcel$export(module.exports, "LOAD_PRIORITIES_SUCCESS", () => $b6059f88a1f974a0$export$8e601591d139ea1e);
$parcel$export(module.exports, "loadPrioritiesSuccess", () => $b6059f88a1f974a0$export$8c198db10c34eeae);
$parcel$export(module.exports, "loadPrioritiesFailure", () => $b6059f88a1f974a0$export$db7c0221961bec8a);
$parcel$export(module.exports, "CARD_PRIORITY_SET", () => $b6059f88a1f974a0$export$81f23650b1079e);
$parcel$export(module.exports, "cardPrioritySet", () => $b6059f88a1f974a0$export$2054774d4090891c);
$parcel$export(module.exports, "CARD_PRIORITY_SET_OPTIMISTIC", () => $b6059f88a1f974a0$export$2357c19e39838a71);
$parcel$export(module.exports, "cardPrioritySetOptimistic", () => $b6059f88a1f974a0$export$df682081f15f18be);

var $5fc53 = parcelRequire("5fc53");

var $6JzCg = parcelRequire("6JzCg");
const $b6059f88a1f974a0$export$ec0e161fbc75b17 = 'state.actions.priorities.LOAD_PRIORITIES_REQUEST';
const $b6059f88a1f974a0$export$298a3cca1db04fc7 = ()=>({
        type: $b6059f88a1f974a0$export$ec0e161fbc75b17
    });
const $b6059f88a1f974a0$export$8e601591d139ea1e = 'state.actions.priorities.LOAD_PRIORITY_SUCCESS';
const $b6059f88a1f974a0$export$8c198db10c34eeae = (response)=>({
        type: $b6059f88a1f974a0$export$8e601591d139ea1e,
        payload: response
    });
const $b6059f88a1f974a0$export$9f00fd43080ad118 = 'state.actions.priorities.LOAD_PRIORITY_FAILURE';
const $b6059f88a1f974a0$export$db7c0221961bec8a = ()=>({
        type: $b6059f88a1f974a0$export$9f00fd43080ad118
    });
const $b6059f88a1f974a0$export$81f23650b1079e = 'state.actions.priorities.CARD_PRIORITY_SET';
const $b6059f88a1f974a0$export$2054774d4090891c = (payload)=>({
        type: $b6059f88a1f974a0$export$81f23650b1079e,
        payload: payload
    });
const $b6059f88a1f974a0$export$2357c19e39838a71 = 'state.actions.priorities.CARD_PRIORITY_SET_OPTIMISTIC';
const $b6059f88a1f974a0$export$df682081f15f18be = (payload, issueKey, analyticsEvent)=>({
        type: $b6059f88a1f974a0$export$2357c19e39838a71,
        payload: payload,
        meta: {
            ...(0, $6JzCg.setCardSetMeta)({
                fieldId: (0, $5fc53.PRIORITY_TYPE),
                issueKey: issueKey,
                newValue: payload.priority,
                retryAction: ()=>$b6059f88a1f974a0$export$df682081f15f18be(payload, issueKey, analyticsEvent)
            }, analyticsEvent)
        }
    });

});


parcelRegister("jRnbG", function(module, exports) {

$parcel$export(module.exports, "onCloseInsightsEpic", () => $c585c90bf40533f4$export$89929865228bcbd8);
$parcel$export(module.exports, "onTogglePanelEpic", () => $c585c90bf40533f4$export$f59322268512fa6c);
parcelRequire("zjDln");
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $f6RVN = parcelRequire("f6RVN");



var $3FUwR = parcelRequire("3FUwR");

var $h9NU3 = parcelRequire("h9NU3");

var $7SF9g = parcelRequire("7SF9g");

var $9g0YE = parcelRequire("9g0YE");

var $jG5HW = parcelRequire("jG5HW");

var $l89dM = parcelRequire("l89dM");
const $c585c90bf40533f4$export$89929865228bcbd8 = (getLocation, replace)=>(action$, store)=>action$.ofType((0, $9g0YE.CLOSE_INSIGHTS_PANEL)).mergeMap((action)=>{
            const state = store.getState();
            if (action.payload && action.payload.shouldUpdateLocation) // We only set the URL if this action is called with `shouldUpdateLocation`
            // Mainly because there is a case user will click on an issue and it auto close the insights panel
            // In this action we will fire two actions.
            // 1. Update the URL selected issue,
            // 2. Update the URL for insights panel.
            // However, these two actions fire at one cycle, and we can't get the updated route location if we fire both actions
            // at the same time. Therefore, the second push action (here) which update the URL will override the first push action,
            // it cause the URL is not changed after we select an issue.
            // Therefore, we will fire all the update to the URL in one push on when the issue card is clicked.
            replace((0, $7SF9g.setPanelsUrl)((0, $4f4a02cead13bb5a$export$61119f100c357d06), false, getLocation()));
            // Make sure Insights is removed from the local storage
            (0, $3FUwR.unsetPanelState)((0, $c35fd6591a78fffe$export$29d7f2210b16d662), (0, $jG5HW.getRapidViewId)(state));
            return (0, $kVLXA.Observable).empty();
        });
const $c585c90bf40533f4$export$f59322268512fa6c = (getLocation, replace)=>(action$, store)=>action$.ofType((0, $9g0YE.TOGGLE_PANEL)).mergeMap((action)=>{
            const { panel: panel } = action.payload;
            const state = store.getState();
            if (panel === (0, $c35fd6591a78fffe$export$29d7f2210b16d662)) {
                const isInsightsOpen = (0, $h9NU3.isInsightsPanelOpen)();
                const isViewSettingsPanelOpen = (0, $l89dM.getViewSettingsPanel)(state);
                replace((0, $7SF9g.setPanelsUrl)((0, $4f4a02cead13bb5a$export$61119f100c357d06), !isInsightsOpen, getLocation()));
                if ((0, $f6RVN.isViewSettingAsPanelExpEnabledWithNoExposure)() && isViewSettingsPanelOpen) return (0, $kVLXA.Observable).of((0, $9g0YE.closeViewSettingsPanel)());
            }
            if ((0, $f6RVN.isViewSettingAsPanelExpEnabledWithNoExposure)() && panel === (0, $c35fd6591a78fffe$export$ba1da943283b9900)) return (0, $kVLXA.Observable).of((0, $9g0YE.closeInsightsPanel)(true));
            return (0, $kVLXA.Observable).empty();
        });

});
const $c35fd6591a78fffe$export$a10c132b86ae798b = 'ISSUE_PARENT_PANEL';
const $c35fd6591a78fffe$export$41073ac826c57195 = 'VERSION_PANEL';
const $c35fd6591a78fffe$export$29d7f2210b16d662 = 'INSIGHTS_PANEL';
const $c35fd6591a78fffe$export$ba1da943283b9900 = 'VIEW_SETTINGS_PANEL';

parcelRegister("h9NU3", function(module, exports) {

$parcel$export(module.exports, "isIssueParentPanelOpen", () => $0ef21687ba992671$export$aba8540b0819f844);
$parcel$export(module.exports, "isVersionPanelOpen", () => $0ef21687ba992671$export$6387d97dce325d43);
$parcel$export(module.exports, "isInsightsPanelOpen", () => $0ef21687ba992671$export$597778e52dd2f97b);

var $ebyGx = parcelRequire("ebyGx");


var $3FUwR = parcelRequire("3FUwR");
const $0ef21687ba992671$export$d4d8b30943776734 = (currentPanel, panelFromLocalStorage)=>currentPanel === panelFromLocalStorage ? null : currentPanel;
const $0ef21687ba992671$export$b057090d6eb17ec2 = (currentPanel, boardId)=>{
    if (boardId) {
        const panelStateFromLocalStorage = (0, $3FUwR.getPanelState)(boardId);
        panelStateFromLocalStorage?.includes(currentPanel) ? (0, $3FUwR.unsetPanelState)(currentPanel, boardId) : (0, $3FUwR.setPanelState)(currentPanel, boardId);
    } else {
        const panelStateFromLocalStorage = (0, $3FUwR.getPanelStateOld)();
        (0, $3FUwR.setPanelStateOld)($0ef21687ba992671$export$d4d8b30943776734(currentPanel, panelStateFromLocalStorage));
    }
};
const $0ef21687ba992671$export$aba8540b0819f844 = (location)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const queryParams = (0, $ebyGx.parse)(location ? location.search : window.location.search);
    return queryParams[0, $4f4a02cead13bb5a$export$ec3c43b997309252] === 'visible';
};
const $0ef21687ba992671$export$6387d97dce325d43 = (location)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const queryParams = (0, $ebyGx.parse)(location ? location.search : window.location.search);
    return queryParams[0, $4f4a02cead13bb5a$export$a86c1a6dde9da34f] === 'visible';
};
const $0ef21687ba992671$export$597778e52dd2f97b = ()=>{
    // This is used in the old version and new version
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const queryParams = (0, $ebyGx.parse)(window.location.search);
    return queryParams[0, $4f4a02cead13bb5a$export$61119f100c357d06] === 'true';
};

});

parcelRegister("l89dM", function(module, exports) {

$parcel$export(module.exports, "getPanels", () => $6d33d2146617bd6f$export$be078297eeb6e8a2);
$parcel$export(module.exports, "getEpicPanel", () => $6d33d2146617bd6f$export$9680a3ff98a72c33);
$parcel$export(module.exports, "getInsightsPanel", () => $6d33d2146617bd6f$export$806d34b644f1954d);
$parcel$export(module.exports, "getViewSettingsPanel", () => $6d33d2146617bd6f$export$a0b20e22a1f77091);

var $f6RVN = parcelRequire("f6RVN");

const $6d33d2146617bd6f$export$be078297eeb6e8a2 = (state)=>state.ui.panels;
const $6d33d2146617bd6f$export$9680a3ff98a72c33 = (state)=>state.ui.panels[0, $c35fd6591a78fffe$export$a10c132b86ae798b] || false;
const $6d33d2146617bd6f$export$893e9e519770bdb0 = (state)=>state.ui.panels[0, $c35fd6591a78fffe$export$41073ac826c57195] || false;
const $6d33d2146617bd6f$export$806d34b644f1954d = (state)=>state.ui.panels[0, $c35fd6591a78fffe$export$29d7f2210b16d662] || false;
const $6d33d2146617bd6f$export$a0b20e22a1f77091 = (state)=>(0, $f6RVN.isViewSettingAsPanelExpEnabledWithNoExposure)() && state.ui.panels[0, $c35fd6591a78fffe$export$ba1da943283b9900] || false;

});


parcelRegister("1JXN4", function(module, exports) {

$parcel$export(module.exports, "selectIssueParentEpic", () => $0de65fa931148179$export$f716b183f4055d82);
parcelRequire("zjDln");
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $cik5h = parcelRequire("cik5h");

var $4mqko = parcelRequire("4mqko");

var $38qhf = parcelRequire("38qhf");

var $fmuR9 = parcelRequire("fmuR9");
const $0de65fa931148179$export$f716b183f4055d82 = (getLocation, push)=>(action$, store)=>action$.ofType((0, $4mqko.PARENT_CLICK)).mergeMap((action)=>{
            const state = store.getState();
            const { cardId: cardId } = action.payload;
            const issueParents = (0, $fmuR9.getIssueParents)(state);
            const parentCardId = issueParents[String(cardId)] ? issueParents[String(cardId)].key : null;
            if (!parentCardId) return (0, $kVLXA.Observable).empty();
            const actions = [
                (0, $4mqko.cardSingleSelect)(cardId),
                (0, $38qhf.openDetailView)(cardId)
            ];
            push((0, $cik5h.addSelectedIssueToUrl)(parentCardId, getLocation()));
            return (0, $kVLXA.Observable).from(actions);
        });

});

parcelRegister("8Z17A", function(module, exports) {

$parcel$export(module.exports, "postLoadCleanDataEpic", () => $4e3a040cc13a03d7$export$6404a6651653bf5a);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $3lZ6i = parcelRequire("3lZ6i");

var $4mqko = parcelRequire("4mqko");

var $dGljH = parcelRequire("dGljH");
const $4e3a040cc13a03d7$export$6404a6651653bf5a = (action$, store)=>// @ts-expect-error - TS2345: Types of property 'type' are incompatible. Type 'state.actions.cards.selection.CARD_MULTI_SELECT' is not assignable to type 'state.actions.cards.selection.CARD_EMPTY_SELECTION'.
    action$.ofType((0, $3lZ6i.SET_APP_DATA)).flatMap(()=>{
        const state = store.getState();
        const actions = [];
        // remove deleted issues from the list
        const cardIds = Object.keys((0, $dGljH.getCards)(state)).map((id)=>Number(id));
        const selectedCards = (0, $dGljH.getSelectedCards)(state);
        if (selectedCards.length === 0) return (0, $kVLXA.Observable).empty();
        const existingSelectedCards = selectedCards.filter((cardId)=>cardIds.includes(cardId));
        const relativeCard = (0, $dGljH.getListSelectionRelativeCard)(state);
        if (existingSelectedCards.length !== selectedCards.length) {
            if (existingSelectedCards.length === 0) return (0, $kVLXA.Observable).of((0, $4mqko.cardEmptySelection)());
            actions.push((0, $4mqko.cardMultiSelect)(existingSelectedCards));
        }
        if (relativeCard && existingSelectedCards.length > 0 && !existingSelectedCards.includes(relativeCard)) actions.push((0, $4mqko.cardClearRelativeCard)());
        return (0, $kVLXA.Observable).from(actions);
    });

});

parcelRegister("2sQbO", function(module, exports) {

$parcel$export(module.exports, "refetchVersionsEpic", () => $c8d3330bab3cfd1c$export$4c96c86475a36738);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");
parcelRequire("6hSeW");

var $jcw0u = parcelRequire("jcw0u");

var $dXq4S = parcelRequire("dXq4S");

var $63Y57 = parcelRequire("63Y57");

var $gwOHY = parcelRequire("gwOHY");

var $jG5HW = parcelRequire("jG5HW");
const $c8d3330bab3cfd1c$export$4c96c86475a36738 = (action$, store, dependencies)=>action$.ofType((0, $gwOHY.REFETCH_VERSIONS)).mergeMap(()=>{
        const state = store.getState();
        const cloudId = (0, $jG5HW.getCloudId)(state);
        const projectIds = (0, $jG5HW.getProjectIds)(state);
        if (!projectIds.length || !dependencies || !dependencies.refetchVersionsForProjects) return (0, $kVLXA.Observable).empty();
        const refetchVersions = dependencies.refetchVersionsForProjects;
        const jiraProjectIds = projectIds.map((id)=>(0, $dXq4S.createAri)({
                resourceOwner: 'jira',
                cloudId: cloudId,
                resourceType: 'project',
                resourceId: String(id)
            }));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return (0, $63Y57.fromRelayObservable)(()=>refetchVersions(jiraProjectIds)).flatMap((data)=>{
            const versions = data?.jira?.versionsForProjects;
            return (0, $kVLXA.Observable).of((0, $gwOHY.setVersions)({
                versions: versions?.edges?.map((edge)=>edge?.node?.versionId)?.filter(Boolean) ?? []
            }));
        }).catch((error)=>(0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'refetchVersionsQuery',
                    packageName: 'jiraSoftwareBacklog',
                    teamName: 'a4t-tanuki'
                }
            }));
    });

});

parcelRegister("gnmD3", function(module, exports) {

$parcel$export(module.exports, "refreshDataEpic", () => $b4e8a371a56793e6$export$c5e96b1fc124b3e);
parcelRequire("fp4O3");
parcelRequire("zjDln");
parcelRequire("fPS7b");
parcelRequire("7qVV7");
parcelRequire("76ueo");
parcelRequire("bZiwb");
parcelRequire("c66Ur");
parcelRequire("1oQta");

var $gccSB = parcelRequire("gccSB");

var $kVLXA = parcelRequire("kVLXA");

var $2YZCu = parcelRequire("2YZCu");

var $guzeq = parcelRequire("guzeq");

var $i4Z8q = parcelRequire("i4Z8q");

var $3lZ6i = parcelRequire("3lZ6i");

var $5Eoed = parcelRequire("5Eoed");

var $c7Xu8 = parcelRequire("c7Xu8");

var $lDDqj = parcelRequire("lDDqj");

var $jhRgJ = parcelRequire("jhRgJ");

var $5z625 = parcelRequire("5z625");
const $b4e8a371a56793e6$var$hasSprintCompleteSource = (actions)=>actions.some((action)=>action.payload.source === (0, $guzeq.REFRESH_SOURCE_SPRINT_COMPLETE));
const $b4e8a371a56793e6$export$74060531d4970975 = (refreshActions, resultActions)=>$b4e8a371a56793e6$var$hasSprintCompleteSource(refreshActions) ? [
        ...resultActions,
        (0, $5Eoed.closeModal)()
    ] : resultActions;
const $b4e8a371a56793e6$var$getGlobalIssueCreateSource = (actions)=>actions.find((action)=>action.payload.source === (0, $guzeq.REFRESH_SOURCE_GLOBAL_ISSUE_CREATE));
const $b4e8a371a56793e6$export$7a1171f81211a01b = (refreshActions, resultActions)=>{
    const globalIssueCreateAction = $b4e8a371a56793e6$var$getGlobalIssueCreateSource(refreshActions);
    if (globalIssueCreateAction === undefined) return resultActions;
    const globalIssues = globalIssueCreateAction?.payload?.issues;
    return globalIssues === undefined ? [
        ...resultActions
    ] : [
        ...resultActions,
        (0, $3lZ6i.checkGlobalIssueCreate)(globalIssues)
    ];
};
const $b4e8a371a56793e6$var$isOptimitsticOrDragging = (store)=>{
    const state = store.getState();
    return (0, $jhRgJ.hasAnyActiveOptimistic)(state) || (0, $lDDqj.isDragging)(state);
};
const $b4e8a371a56793e6$var$shouldCloseBuffer = (action$, store)=>action$.filter(()=>!$b4e8a371a56793e6$var$isOptimitsticOrDragging(store));
const $b4e8a371a56793e6$var$shouldAbort = (action$, store)=>action$.filter(()=>$b4e8a371a56793e6$var$isOptimitsticOrDragging(store));
const $b4e8a371a56793e6$export$98174b963acaea1d = (actions)=>actions.some((action)=>action.payload.source === (0, $guzeq.REFRESH_SOURCE_ON_MOUNT));
const $b4e8a371a56793e6$export$c5e96b1fc124b3e = (action$, store)=>action$.ofType((0, $3lZ6i.REFRESH_DATA_REQUEST)).bufferWhen(()=>$b4e8a371a56793e6$var$shouldCloseBuffer(action$, store)).filter((buffer)=>!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(buffer)).exhaustMap((refreshActions)=>{
        const serviceContext = (0, $i4Z8q.makeServiceContext)(store.getState());
        const gicSourceRefreshAction = $b4e8a371a56793e6$var$getGlobalIssueCreateSource(refreshActions);
        if (serviceContext.isCompanyManaged) {
            const loadAppDataAction = gicSourceRefreshAction !== undefined ? (0, $3lZ6i.loadAppData)({
                storeFieldsActions: gicSourceRefreshAction.payload.storeFieldsActions
            }) : (0, $3lZ6i.loadAppData)();
            const actions = [
                loadAppDataAction,
                (0, $3lZ6i.loadConfigData)()
            ];
            return (0, $kVLXA.Observable).from([
                ...$b4e8a371a56793e6$export$74060531d4970975(refreshActions, []),
                ...$b4e8a371a56793e6$export$7a1171f81211a01b(refreshActions, []),
                ...actions,
                (0, $c7Xu8.loadPriorities)()
            ]).takeUntil($b4e8a371a56793e6$var$shouldAbort(action$, store));
        }
        return (0, $5z625.fetchData)({
            store: store,
            ...gicSourceRefreshAction && gicSourceRefreshAction.payload.storeFieldsActions && {
                storeFieldsActions: gicSourceRefreshAction.payload.storeFieldsActions
            }
        }).flatMap((resultAction)=>[
                ...$b4e8a371a56793e6$export$74060531d4970975(refreshActions, [
                    resultAction
                ]),
                ...$b4e8a371a56793e6$export$7a1171f81211a01b(refreshActions, [
                    resultAction
                ])
            ]).takeUntil($b4e8a371a56793e6$var$shouldAbort(action$, store));
    }).catch((error)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('backlog.refresh-data.failure', 'Fail to refresh data.', error);
        return (0, $kVLXA.Observable).of((0, $3lZ6i.refreshDataFailure)());
    });

});
parcelRegister("lDDqj", function(module, exports) {

$parcel$export(module.exports, "isDragging", () => $5c1e30b3ded0b001$export$9e9bc3c487fccc00);
$parcel$export(module.exports, "getSourceDroppableType", () => $5c1e30b3ded0b001$export$e2d19a990d0e9f1c);
$parcel$export(module.exports, "getSourceCardListId", () => $5c1e30b3ded0b001$export$3c7985ea201cdfef);
$parcel$export(module.exports, "getIsSubtaskDrag", () => $5c1e30b3ded0b001$export$fa75a25bcebce8f1);
const $5c1e30b3ded0b001$export$9e9bc3c487fccc00 = (state)=>state.ui.drag.isDragging;
const $5c1e30b3ded0b001$export$e2d19a990d0e9f1c = (state)=>state.ui.drag.sourceCardGroupType;
const $5c1e30b3ded0b001$export$3c7985ea201cdfef = (state)=>state.ui.drag.sourceCardListId;
const $5c1e30b3ded0b001$export$fa75a25bcebce8f1 = (state)=>state.ui.drag.isSubtask;
const $5c1e30b3ded0b001$export$376f09b67fc96920 = (state)=>state.ui.drag.sourceParentId;
const $5c1e30b3ded0b001$export$158fcd85e87a52bd = (state)=>state.ui.drag.isOverTransitionZone;

});

parcelRegister("jhRgJ", function(module, exports) {

$parcel$export(module.exports, "hasAnyActiveOptimistic", () => $5584ea5159bebe6f$export$5c9c2a640adc17da);
const $5584ea5159bebe6f$export$5c9c2a640adc17da = (state)=>{
    const beforeState = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    state.entities && state.entities.beforeState;
    return beforeState !== undefined;
};

});


parcelRegister("h34Bb", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad47d927a2ea593e$export$2e2bcd8739ae039);
parcelRequire("9IWoG");
parcelRequire("6hSeW");
parcelRequire("zjDln");
parcelRequire("8vsXW");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $kVLXA = parcelRequire("kVLXA");

var $cik5h = parcelRequire("cik5h");

var $3lZ6i = parcelRequire("3lZ6i");

var $9Z18E = parcelRequire("9Z18E");

var $4mqko = parcelRequire("4mqko");

var $38qhf = parcelRequire("38qhf");

var $aCC3Y = parcelRequire("aCC3Y");

var $dGljH = parcelRequire("dGljH");
const $ad47d927a2ea593e$var$performSelectedKeyCheck = (store, location, push)=>()=>{
        const state = store.getState();
        const lastSelectedCardKeyFromUrl = (0, $dGljH.getLastSelectedCardKey)(state);
        if (lastSelectedCardKeyFromUrl) {
            const cardId = (0, $dGljH.getIdByKeyForAllIssueTypes)(state)(lastSelectedCardKeyFromUrl);
            if (cardId) return (0, $kVLXA.Observable).from([
                (0, $4mqko.cardSingleSelect)(cardId),
                (0, $38qhf.openDetailView)(cardId),
                (0, $9Z18E.cardAutoScroll)(cardId)
            ]);
            push((0, $cik5h.removeSelectedIssueFromUrl)(location));
        }
        return (0, $kVLXA.Observable).empty();
    };
// there are two cases, when we need to read lastSelectedCardKey from URL and open Bento on Backlog init
// 1) When critical path data is loaded before App routing initialised (with SSR/SPA) -> postLocationSetEpic
// 2) When critical path data is loaded after App routing initialised (without SSR) -> setSelectedIssueFromUrlEpic
const $ad47d927a2ea593e$var$observables = (action$, isCompanyManaged)=>isCompanyManaged ? [
        action$.ofType((0, $4mqko.SET_LAST_SELECTED_CARD_KEY)).first(),
        action$.ofType((0, $3lZ6i.SET_APP_DATA)).first(),
        action$.ofType((0, $aCC3Y.LOAD_ISSUE_PARENTS_SUCCESS)).first()
    ] : [
        action$.ofType((0, $4mqko.SET_LAST_SELECTED_CARD_KEY)).first(),
        action$.ofType((0, $3lZ6i.SET_APP_DATA)).first()
    ];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ad47d927a2ea593e$export$2e2bcd8739ae039 = (getLocation, push, isCompanyManaged)=>(action$, store)=>(0, $kVLXA.Observable).forkJoin($ad47d927a2ea593e$var$observables(action$, isCompanyManaged)).mergeMap($ad47d927a2ea593e$var$performSelectedKeyCheck(store, getLocation(), push)).catch(()=>(0, $kVLXA.Observable).empty());

});
parcelRegister("aCC3Y", function(module, exports) {

$parcel$export(module.exports, "LOAD_ISSUE_PARENTS_SUCCESS", () => $078bf955f0868777$export$c4816ca6503594af);
$parcel$export(module.exports, "loadIssueParentsSuccess", () => $078bf955f0868777$export$690a91ea1d3856a7);
$parcel$export(module.exports, "loadIssueParentsFailure", () => $078bf955f0868777$export$a69a6037d2ab7dc4);
const $078bf955f0868777$export$c4816ca6503594af = 'state.actions.app.LOAD_ISSUE_PARENTS_SUCCESS';
const $078bf955f0868777$export$690a91ea1d3856a7 = (issueParents)=>({
        type: $078bf955f0868777$export$c4816ca6503594af,
        payload: {
            issueParents: issueParents
        }
    });
const $078bf955f0868777$export$10fa8c4c0ecf4112 = 'state.actions.app.LOAD_ISSUE_PARENTS_FAILURE';
const $078bf955f0868777$export$a69a6037d2ab7dc4 = ()=>({
        type: $078bf955f0868777$export$10fa8c4c0ecf4112
    });

});


parcelRegister("83JtA", function(module, exports) {

$parcel$export(module.exports, "sprintCreateEpic", () => $1535a80ded97b3da$export$fd754fd9ce87f92b);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("zjDln");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $2YZCu = parcelRequire("2YZCu");

var $guzeq = parcelRequire("guzeq");

var $gz7B4 = parcelRequire("gz7B4");

var $3lZ6i = parcelRequire("3lZ6i");

var $jkFPs = parcelRequire("jkFPs");

var $jG5HW = parcelRequire("jG5HW");
const $1535a80ded97b3da$export$fd754fd9ce87f92b = (action$, store)=>action$.ofType((0, $jkFPs.SPRINT_CREATE_REQUEST)).mergeMap((action)=>{
        const { meta: { optimistic: { id: optimisticId }, analyticsEvent: analyticsEvent }, payload: { temporaryCardListId: temporaryCardListId } } = action;
        const state = store.getState();
        const baseUrl = (0, $jG5HW.getBaseUrl)(state);
        const rapidViewId = (0, $jG5HW.getRapidViewId)(state);
        return (0, $gz7B4.default)(baseUrl, rapidViewId).map((sprint)=>(0, $jkFPs.sprintCreateSuccess)(sprint, temporaryCardListId, optimisticId, analyticsEvent)).catch((error)=>{
            (0, $2YZCu.default).safeErrorWithoutCustomerData('backlog.sprint-create.failure', 'Failed to create sprint', error);
            return (0, $kVLXA.Observable).from([
                (0, $jkFPs.sprintCreateFailure)(temporaryCardListId, optimisticId, analyticsEvent),
                (0, $3lZ6i.refreshDataRequest)((0, $guzeq.REFRESH_SOURCE_FAILURE))
            ]);
        });
    });

});
parcelRegister("gz7B4", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c848cd8159d0472$export$2e2bcd8739ae039);
parcelRequire("d0pqD");

var $guzeq = parcelRequire("guzeq");

var $9Fk0e = parcelRequire("9Fk0e");
const $3c848cd8159d0472$var$transformer = (response)=>({
        id: String(response.id),
        name: response.name,
        type: (0, $guzeq.SPRINT),
        issueListKey: null,
        sprintData: {
            goal: '',
            startDate: response.isoStartDate,
            endDate: response.isoEndDate,
            daysRemaining: response.daysRemaining,
            state: response.state,
            canUpdateSprint: response.canUpdateSprint
        }
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3c848cd8159d0472$export$2e2bcd8739ae039 = (baseUrl, rapidViewId)=>(0, $9Fk0e.default)(baseUrl, rapidViewId).map($3c848cd8159d0472$var$transformer);

});
parcelRegister("9Fk0e", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9bc8011977a9010$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $6iJbJ = parcelRequire("6iJbJ");
const $b9bc8011977a9010$var$MUTATION_NAME = 'BacklogCreateSprint';
const $b9bc8011977a9010$export$e904bac7f43ed94a = (boardId)=>`mutation ${$b9bc8011977a9010$var$MUTATION_NAME} {
        createSprint(input: { 
            boardId: ${boardId}
        }) {
            sprint {
                id,
                name,
                daysRemaining,
                startDate,
                endDate,
                sprintState,
                canUpdateSprint
            }
        }
    }`;
const $b9bc8011977a9010$export$9c68d69a4c5bbcf9 = (result)=>{
    const { sprintState: sprintState, endDate: endDate, startDate: startDate, ...rest } = result.createSprint.sprint;
    const createdSprint = {
        ...rest,
        state: sprintState,
        isoEndDate: endDate === 'None' ? '' : endDate,
        isoStartDate: startDate === 'None' ? '' : startDate
    };
    return (0, $kVLXA.Observable).of(createdSprint);
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b9bc8011977a9010$export$2e2bcd8739ae039 = (baseUrl, boardId)=>(0, $6iJbJ.mutation$)(baseUrl, $b9bc8011977a9010$var$MUTATION_NAME, $b9bc8011977a9010$export$e904bac7f43ed94a(boardId)).flatMap($b9bc8011977a9010$export$9c68d69a4c5bbcf9);

});


parcelRegister("jkFPs", function(module, exports) {

$parcel$export(module.exports, "SPRINT_CREATE_REQUEST", () => $be47e9ec4954e21f$export$d59013ccc191ced6);
$parcel$export(module.exports, "sprintCreateRequest", () => $be47e9ec4954e21f$export$6a8c5a7f76e28862);
$parcel$export(module.exports, "SPRINT_CREATE_SUCCESS", () => $be47e9ec4954e21f$export$4e82b88c987fbfcb);
$parcel$export(module.exports, "sprintCreateSuccess", () => $be47e9ec4954e21f$export$4bedc2fcbe2138bd);
$parcel$export(module.exports, "SPRINT_CREATE_FAILURE", () => $be47e9ec4954e21f$export$fe11ca1e4db494a);
$parcel$export(module.exports, "sprintCreateFailure", () => $be47e9ec4954e21f$export$cb20bc93da1235f7);

var $c0irb = parcelRequire("c0irb");
let $be47e9ec4954e21f$var$lastSprintId = 0;
const $be47e9ec4954e21f$var$generateId = ()=>{
    $be47e9ec4954e21f$var$lastSprintId -= 1;
    return $be47e9ec4954e21f$var$lastSprintId;
};
const $be47e9ec4954e21f$export$d59013ccc191ced6 = 'state.actions.sprints.create.SPRINT_CREATE_REQUEST';
const $be47e9ec4954e21f$export$6a8c5a7f76e28862 = (analyticsEvent)=>({
        type: $be47e9ec4954e21f$export$d59013ccc191ced6,
        payload: {
            temporaryCardListId: String($be47e9ec4954e21f$var$generateId())
        },
        meta: {
            ...(0, $c0irb.beginOptimisticUiMeta)(),
            analyticsEvent: analyticsEvent
        }
    });
const $be47e9ec4954e21f$export$4e82b88c987fbfcb = 'state.actions.sprints.create.SPRINT_CREATE_SUCCESS';
const $be47e9ec4954e21f$export$4bedc2fcbe2138bd = (sprint, temporaryCardListId, optimisticId, analyticsEvent)=>({
        type: $be47e9ec4954e21f$export$4e82b88c987fbfcb,
        payload: {
            sprint: sprint,
            temporaryCardListId: temporaryCardListId
        },
        meta: {
            ...(0, $c0irb.commitOptimisticUiMeta)(optimisticId),
            analyticsEvent: analyticsEvent
        }
    });
const $be47e9ec4954e21f$export$fe11ca1e4db494a = 'state.actions.sprints.create.SPRINT_CREATE_FAILURE';
const $be47e9ec4954e21f$export$cb20bc93da1235f7 = (temporaryCardListId, optimisticId, analyticsEvent)=>({
        type: $be47e9ec4954e21f$export$fe11ca1e4db494a,
        payload: {
            temporaryCardListId: temporaryCardListId
        },
        meta: {
            ...(0, $c0irb.revertOptimisticUiWithFlagMeta)(optimisticId),
            ...analyticsEvent ? {
                analyticsEvent: analyticsEvent
            } : {}
        }
    });

});


parcelRegister("dZEjB", function(module, exports) {

$parcel$export(module.exports, "sprintDeleteEpic", () => $497e2c3e192c01a2$export$5ffc2a46229f98c0);

var $kVLXA = parcelRequire("kVLXA");

var $fZneA = parcelRequire("fZneA");

var $8zOmE = parcelRequire("8zOmE");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $4cr9K = parcelRequire("4cr9K");

var $guzeq = parcelRequire("guzeq");

var $9aEBE = parcelRequire("9aEBE");

var $3lZ6i = parcelRequire("3lZ6i");

var $d09wv = parcelRequire("d09wv");

var $jG5HW = parcelRequire("jG5HW");
const $497e2c3e192c01a2$export$5ffc2a46229f98c0 = (action$, store)=>action$.ofType((0, $d09wv.SPRINT_DELETE_REQUEST)).mergeMap((action)=>{
        const { payload: { sprintId: sprintId }, meta: { optimistic: { id: optimisticId }, analyticsEvent: analyticsEvent } } = action;
        const state = store.getState();
        const baseUrl = (0, $jG5HW.getBaseUrl)(state);
        const rapidViewId = (0, $jG5HW.getRapidViewId)(state);
        return (0, $9aEBE.default)(baseUrl, sprintId, rapidViewId).flatMap(()=>{
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'sprint deleted');
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'ui taskSuccess', {
                task: 'deleteSprint'
            });
            return (0, $kVLXA.Observable).of((0, $d09wv.sprintDeleteSuccess)(sprintId, optimisticId));
        }).catch((error)=>{
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'ui taskFail', {
                task: 'deleteSprint',
                isClientFetchError: (0, $fZneA.isClientFetchError)(error),
                errorMessage: error.message
            });
            return (0, $kVLXA.Observable).from([
                (0, $d09wv.sprintDeleteFailure)(sprintId, optimisticId),
                (0, $3lZ6i.refreshDataRequest)((0, $guzeq.REFRESH_SOURCE_FAILURE)),
                (0, $4cr9K.showErrorFlag)(error)
            ]);
        });
    });

});
parcelRegister("9aEBE", function(module, exports) {

$parcel$export(module.exports, "default", () => $068a1ffb704f2871$export$2e2bcd8739ae039);

var $6iJbJ = parcelRequire("6iJbJ");
const $068a1ffb704f2871$var$MUTATION_NAME = 'BacklogDeleteSprint';
const $068a1ffb704f2871$export$e904bac7f43ed94a = (boardId, sprintId)=>`mutation ${$068a1ffb704f2871$var$MUTATION_NAME} {
        deleteSprint(input: { boardId: ${boardId}, sprintId: ${sprintId} }) {
            success
        }
    }`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$068a1ffb704f2871$export$2e2bcd8739ae039 = (baseUrl, sprintId, boardId)=>(0, $6iJbJ.mutation$)(baseUrl, $068a1ffb704f2871$var$MUTATION_NAME, $068a1ffb704f2871$export$e904bac7f43ed94a(boardId, sprintId));

});

parcelRegister("d09wv", function(module, exports) {

$parcel$export(module.exports, "SPRINT_DELETE_REQUEST", () => $4118be0dc04226a7$export$6b303f66a5e5797e);
$parcel$export(module.exports, "sprintDeleteRequest", () => $4118be0dc04226a7$export$35fe698532b74175);
$parcel$export(module.exports, "SPRINT_DELETE_SUCCESS", () => $4118be0dc04226a7$export$834703750976df63);
$parcel$export(module.exports, "sprintDeleteSuccess", () => $4118be0dc04226a7$export$83b0e54db46bc14c);
$parcel$export(module.exports, "sprintDeleteFailure", () => $4118be0dc04226a7$export$f3bca19c58d95d7a);

var $c0irb = parcelRequire("c0irb");
const $4118be0dc04226a7$export$6b303f66a5e5797e = 'state.actions.sprints.delete.SPRINT_DELETE_REQUEST';
const $4118be0dc04226a7$export$35fe698532b74175 = (sprintId, nextCardListId, analyticsEvent)=>({
        type: $4118be0dc04226a7$export$6b303f66a5e5797e,
        payload: {
            sprintId: sprintId,
            nextCardListId: nextCardListId
        },
        meta: {
            ...(0, $c0irb.beginOptimisticUiMeta)(),
            analyticsEvent: analyticsEvent
        }
    });
const $4118be0dc04226a7$export$834703750976df63 = 'state.actions.sprints.delete.SPRINT_DELETE_SUCCESS';
const $4118be0dc04226a7$export$83b0e54db46bc14c = (sprintId, optimisticId)=>({
        type: $4118be0dc04226a7$export$834703750976df63,
        payload: {
            sprintId: sprintId
        },
        meta: (0, $c0irb.commitOptimisticUiMeta)(optimisticId)
    });
const $4118be0dc04226a7$export$b96bc6bf6780477 = 'state.actions.sprints.delete.SPRINT_DELETE_FAILURE';
const $4118be0dc04226a7$export$f3bca19c58d95d7a = (sprintId, optimisticId)=>({
        type: $4118be0dc04226a7$export$b96bc6bf6780477,
        payload: {
            sprintId: sprintId
        },
        meta: (0, $c0irb.revertOptimisticUiWithDisabledFlagMeta)(optimisticId)
    });

});


parcelRegister("6BlmG", function(module, exports) {

$parcel$export(module.exports, "sprintMoveEpic", () => $09ac061b60d08e43$export$aee7bffc312e2d9d);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $fZneA = parcelRequire("fZneA");

var $8zOmE = parcelRequire("8zOmE");

var $94PWq = parcelRequire("94PWq");

var $jWMwu = parcelRequire("jWMwu");

var $3lZ6i = parcelRequire("3lZ6i");

var $dkxyn = parcelRequire("dkxyn");

var $jG5HW = parcelRequire("jG5HW");
const $09ac061b60d08e43$export$aee7bffc312e2d9d = (action$, store)=>action$.ofType((0, $dkxyn.SPRINT_MOVE_REQUEST)).mergeMap((action)=>{
        const { payload: { sprintId: sprintId, targetSprintId: targetSprintId, analyticsEvent: analyticsEvent }, meta: { optimistic: { id: optimisticId } } } = action;
        const state = store.getState();
        const baseUrl = (0, $jG5HW.getBaseUrl)(state);
        const boardId = (0, $jG5HW.getRapidViewId)(state);
        (0, $jWMwu.setMoveSprintInteractionStartMark)();
        return (0, $94PWq.default)(baseUrl, boardId, sprintId, targetSprintId).flatMap(()=>{
            (0, $jWMwu.stopMoveSprintInteraction)();
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'sprint moved', {
                sprintId: sprintId,
                targetSprintId: targetSprintId
            });
            return (0, $kVLXA.Observable).of((0, $dkxyn.sprintMoveSuccess)(optimisticId));
        }).catch((error)=>{
            (0, $jWMwu.cancelMoveSprintInteraction)();
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'sprint moveFailed', {
                isClientFetchError: (0, $fZneA.isClientFetchError)(error)
            });
            return (0, $kVLXA.Observable).from([
                (0, $dkxyn.sprintMoveFailure)(optimisticId),
                (0, $3lZ6i.loadAppData)()
            ]);
        });
    });

});
parcelRegister("94PWq", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b744e7748e5e5e9$export$2e2bcd8739ae039);

var $6iJbJ = parcelRequire("6iJbJ");
const $5b744e7748e5e5e9$var$MUTATION_NAME = 'BacklogMoveSprint';
const $5b744e7748e5e5e9$export$e904bac7f43ed94a = (boardId, sprintId, targetSprintId)=>`mutation ${$5b744e7748e5e5e9$var$MUTATION_NAME} {
        moveSprint (input: {
            boardId: ${boardId},
            sprintId: ${sprintId},
            targetSprintId: ${targetSprintId},
        }) {
            success
        }
    }`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5b744e7748e5e5e9$export$2e2bcd8739ae039 = (baseUrl, boardId, sprintId, targetSprintId)=>(0, $6iJbJ.mutation$)(baseUrl, $5b744e7748e5e5e9$var$MUTATION_NAME, $5b744e7748e5e5e9$export$e904bac7f43ed94a(boardId, sprintId, targetSprintId));

});

parcelRegister("jWMwu", function(module, exports) {

$parcel$export(module.exports, "setMoveSprintInteractionStartMark", () => $3fa3a3efc5209706$export$f22a6d0772829be2);
$parcel$export(module.exports, "cancelMoveSprintInteraction", () => $3fa3a3efc5209706$export$24d4fe151992bf19);
$parcel$export(module.exports, "stopMoveSprintInteraction", () => $3fa3a3efc5209706$export$a76821761124e4d4);

var $8hVbJ = parcelRequire("8hVbJ");
const $3fa3a3efc5209706$export$f22a6d0772829be2 = ()=>{
    (0, $8hVbJ.moveSprintInteraction).start();
};
const $3fa3a3efc5209706$export$24d4fe151992bf19 = ()=>{
    (0, $8hVbJ.moveSprintInteraction).cancel();
};
const $3fa3a3efc5209706$export$a76821761124e4d4 = ()=>{
    (0, $8hVbJ.moveSprintInteraction).stop();
};

});

parcelRegister("dkxyn", function(module, exports) {

$parcel$export(module.exports, "SPRINT_MOVE_REQUEST", () => $af4860f05ea864cc$export$af51e9f0383af197);
$parcel$export(module.exports, "sprintMoveRequest", () => $af4860f05ea864cc$export$3f8b743cac3b0a79);
$parcel$export(module.exports, "sprintMoveSuccess", () => $af4860f05ea864cc$export$604066b4fdce8da8);
$parcel$export(module.exports, "sprintMoveFailure", () => $af4860f05ea864cc$export$62075de456e485a);

var $c0irb = parcelRequire("c0irb");
const $af4860f05ea864cc$export$af51e9f0383af197 = 'state.actions.sprints.move.SPRINT_MOVE_REQUEST';
const $af4860f05ea864cc$export$3f8b743cac3b0a79 = (payload)=>({
        type: $af4860f05ea864cc$export$af51e9f0383af197,
        payload: payload,
        meta: (0, $c0irb.beginOptimisticUiMeta)()
    });
const $af4860f05ea864cc$export$404f9f04f93189f = 'state.actions.sprints.move.SPRINT_MOVE_SUCCESS';
const $af4860f05ea864cc$export$604066b4fdce8da8 = (optimisticId)=>({
        type: $af4860f05ea864cc$export$404f9f04f93189f,
        meta: (0, $c0irb.commitOptimisticUiMeta)(optimisticId)
    });
const $af4860f05ea864cc$export$512be0ad1cebb005 = 'state.actions.sprints.move.SPRINT_MOVE_FAILURE';
const $af4860f05ea864cc$export$62075de456e485a = (optimisticId)=>({
        type: $af4860f05ea864cc$export$512be0ad1cebb005,
        meta: (0, $c0irb.revertOptimisticUiWithFlagMeta)(optimisticId)
    });

});


parcelRegister("7ixW2", function(module, exports) {

$parcel$export(module.exports, "loadWhiteboardsEntrypointExperimentEpic", () => $e2f24da0a13c0e0c$export$217e0b1862428616);

var $e1AU2 = parcelRequire("e1AU2");

var $4R6GH = parcelRequire("4R6GH");

var $63Y57 = parcelRequire("63Y57");

var $5G4FL = parcelRequire("5G4FL");

var $qBa3H = parcelRequire("qBa3H");

var $aUidi = parcelRequire("aUidi");
const $e2f24da0a13c0e0c$export$217e0b1862428616 = (0, $e1AU2.combineEpics)((0, $qBa3H.loadWhiteboardsEntrypointConfluenceDataEpic), ...(0, $63Y57.withKillSwitch)(()=>(0, $4R6GH.fg)('grw_1037_expand_plan_in_whiteboards_gate'))([
    (0, $aUidi.loadHasXflowFromWhiteboardsTouchpointEpic)
]), ...(0, $63Y57.withKillSwitch)(()=>(0, $4R6GH.fg)('sprint_planning_whiteboards_gate'))([
    (0, $5G4FL.loadUserPropertyKeysEpic)
]));

});
parcelRegister("5G4FL", function(module, exports) {

$parcel$export(module.exports, "loadUserPropertyKeysEpic", () => $da77d04c18cbfdf1$export$6f9dd359476cc0c9);
parcelRequire("fp4O3");
parcelRequire("6cbqE");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("eSGL3");

var $aq199 = parcelRequire("aq199");

var $eN6O2 = parcelRequire("eN6O2");

var $3lZ6i = parcelRequire("3lZ6i");

var $5uBAa = parcelRequire("5uBAa");

var $jG5HW = parcelRequire("jG5HW");
const $da77d04c18cbfdf1$export$6f9dd359476cc0c9 = (action$, store)=>action$.ofType((0, $3lZ6i.LOAD_APP_DATA_REQUEST))// Prevents multiple requests from being fired off
    .debounceTime(1000).switchMap(()=>{
        const accountId = (0, $jG5HW.getAtlassianAccountId)(store.getState());
        if (accountId) return (0, $eN6O2.loadUserPropertyKeysService)(accountId).map((0, $5uBAa.setUserPropertyKeys));
        return (0, $aq199.of)();
    });

});
parcelRegister("eN6O2", function(module, exports) {

$parcel$export(module.exports, "hasXFlowFromWhiteboardsTouchpointService", () => $200fb04df21782d7$export$4e055a191dc96714);
$parcel$export(module.exports, "loadUserPropertyKeysService", () => $200fb04df21782d7$export$b4e26d104aaa549c);

var $aq199 = parcelRequire("aq199");

var $e6C7w = parcelRequire("e6C7w");

var $cVFxd = parcelRequire("cVFxd");

var $j7Dz8 = parcelRequire("j7Dz8");

var $eNf8a = parcelRequire("eNf8a");

var $jcw0u = parcelRequire("jcw0u");

var $7IKPD = parcelRequire("7IKPD");

var $kBXQ9 = parcelRequire("kBXQ9");
const $200fb04df21782d7$export$4e055a191dc96714 = (cloudId)=>{
    const expirableStorage = (0, $eNf8a.createSessionExpirableStorageProvider)((0, $7IKPD.STORAGE_PROVIDER_PREFIX));
    const cachedValue = expirableStorage.get((0, $7IKPD.CACHE_KEYS).HAS_XFLOW_FROM_WHITEBOARDS_TOUCHPOINT_TAP_TRAIT_KEY);
    if (cachedValue !== null && cachedValue !== undefined) return (0, $aq199.of)(cachedValue);
    return (0, $kBXQ9.fetchSiteTraits)(cloudId).pipe((0, $cVFxd.map)((response)=>response.attributes.some((attribute)=>attribute?.name === (0, $7IKPD.CACHE_KEYS).HAS_XFLOW_FROM_WHITEBOARDS_TOUCHPOINT_TAP_TRAIT_KEY)), (0, $j7Dz8.tap)((hasCrossFlowed)=>{
        expirableStorage.set((0, $7IKPD.CACHE_KEYS).HAS_XFLOW_FROM_WHITEBOARDS_TOUCHPOINT_TAP_TRAIT_KEY, hasCrossFlowed);
    }), (0, $e6C7w.catchError)((error)=>{
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'backlog.has-cross-flowed-from-whiteboards-service.failure',
                packageName: 'jiraSoftwareBacklog',
                teamName: 'starburst'
            }
        });
        return (0, $aq199.of)(false);
    }));
};
const $200fb04df21782d7$var$ONE_DAY = 86400000;
const $200fb04df21782d7$export$b4e26d104aaa549c = (accountId)=>{
    const expirableStorage = (0, $eNf8a.createSessionExpirableStorageProvider)((0, $7IKPD.STORAGE_PROVIDER_PREFIX));
    const cachedValue = expirableStorage.get((0, $7IKPD.CACHE_KEYS).USER_PROPERTIES);
    if (cachedValue !== null && cachedValue !== undefined) return (0, $aq199.of)(cachedValue);
    return (0, $kBXQ9.fetchUserPropertyKeys)(accountId).pipe((0, $cVFxd.map)((response)=>response.keys.map((value)=>value.key)), (0, $j7Dz8.tap)((keys)=>{
        expirableStorage.set((0, $7IKPD.CACHE_KEYS).USER_PROPERTIES, keys, Date.now() + $200fb04df21782d7$var$ONE_DAY);
    }), (0, $e6C7w.catchError)(()=>(0, $aq199.of)(null)));
};

});
parcelRegister("7IKPD", function(module, exports) {

$parcel$export(module.exports, "NOT_ENROLLED", () => $0398d758657f1eb1$export$5b7423264d48ab04);
$parcel$export(module.exports, "VARIATION", () => $0398d758657f1eb1$export$fa04ad826acc90da);
$parcel$export(module.exports, "CTA_SOURCE_CONTEXT", () => $0398d758657f1eb1$export$fb3e39c896b51be6);
$parcel$export(module.exports, "CTA_SOURCE_COMPONENT", () => $0398d758657f1eb1$export$946e6c5b067bf134);
$parcel$export(module.exports, "CTA_SPOTLIGHT_SOURCE_CONTEXT", () => $0398d758657f1eb1$export$b8e6edc9050e8b8d);
$parcel$export(module.exports, "DATA_PRIVACY_LINK", () => $0398d758657f1eb1$export$aefe1c8741b24a28);
$parcel$export(module.exports, "USER_PROPERTY_KEY_NAMES", () => $0398d758657f1eb1$export$11d82676e8d3e34d);
$parcel$export(module.exports, "ELEMENT_IDS", () => $0398d758657f1eb1$export$27ab2ff8fd5f43b3);
$parcel$export(module.exports, "CACHE_KEYS", () => $0398d758657f1eb1$export$34e19e61668698cb);
$parcel$export(module.exports, "STORAGE_PROVIDER_PREFIX", () => $0398d758657f1eb1$export$b4c2fd6328606b0e);
$parcel$export(module.exports, "setHasClickedOnPulse", () => $0398d758657f1eb1$export$bc708ee563e4f3a0);
$parcel$export(module.exports, "getHasClickedOnPulse", () => $0398d758657f1eb1$export$db8829fda2a591b5);
$parcel$export(module.exports, "getSpaceKey", () => $0398d758657f1eb1$export$c74e0ded7b123e80);
$parcel$export(module.exports, "setSpaceKey", () => $0398d758657f1eb1$export$4718112ffbeae5c5);
$parcel$export(module.exports, "getConfluenceData", () => $0398d758657f1eb1$export$7026bb8c5c571a7e);
$parcel$export(module.exports, "setConfluenceData", () => $0398d758657f1eb1$export$1a8782a287467f35);

var $bSSG7 = parcelRequire("bSSG7");
const $0398d758657f1eb1$export$5b7423264d48ab04 = 'not-enrolled';
const $0398d758657f1eb1$export$fa04ad826acc90da = 'variation';
const $0398d758657f1eb1$export$64c52b23355c8a22 = 'grw_1037_expand_plan_in_whiteboards';
const $0398d758657f1eb1$export$fb3e39c896b51be6 = 'planOnWhiteboardBacklogButton';
const $0398d758657f1eb1$export$946e6c5b067bf134 = 'planOnWhiteboardsButtonCTAScreen';
const $0398d758657f1eb1$export$b8e6edc9050e8b8d = 'planOnWhiteboardSpotlightButton';
const $0398d758657f1eb1$export$aefe1c8741b24a28 = 'https://www.atlassian.com/legal/privacy-policy';
const $0398d758657f1eb1$export$ed09d360c28bf9e1 = {
    CONTEXT_MENU: 'variant_contextual_menu',
    BACKLOG_BUTTON: 'variant_backlog_button',
    CONTROL: 'control'
};
const $0398d758657f1eb1$export$11d82676e8d3e34d = {
    BANNER_DISMISSED: 'whiteboards-backlog-entrypoint-banner-dismissed',
    WHITEBOARDS_BACKLOG_ENTRYPOINT_DISMISSED: 'whiteboards-backlog-entrypoint-dismissed'
};
const $0398d758657f1eb1$export$27ab2ff8fd5f43b3 = {
    CTA_BUTTON: 'software-backlog.whiteboards-entrypoint-experiment.backlog-button-refresh.cta-button',
    BANNER: 'software-backlog.whiteboards-entrypoint-experiment.backlog-button-refresh.banner-container',
    TOUCHPOINT: 'software-backlog.whiteboards-entrypoint-experiment.backlog-button-refresh.whiteboards-touchpoint'
};
const $0398d758657f1eb1$export$34e19e61668698cb = {
    HAS_XFLOW_FROM_WHITEBOARDS_TOUCHPOINT_TAP_TRAIT_KEY: 'whiteboard_backlog_jira_ui_button_clicked_confirmbutton_xflow',
    USER_PROPERTIES: 'whiteboard_backlog_jira_ui_user_properties',
    PROJECT_SPACE_KEY: 'whiteboards_backlog_jira_ui_project_space_key',
    PULSE_LOCAL_STORAGE_KEY: 'whiteboardsExperimentHasClickedOnPulse',
    WHITEBOARDS_ENTRYPOINT_CONFLUENCE_DATA_KEY: 'whiteboards_backlog_jira_confluence_data'
};
const $0398d758657f1eb1$export$b4c2fd6328606b0e = 'whiteboards-entrypoint';
const $0398d758657f1eb1$var$whiteboardsLocalStorage = (0, $bSSG7.createLocalExpirableStorageProvider)('whiteboardsTouchpoint');
const $0398d758657f1eb1$var$SEVEN_DAYS = 604800000;
const $0398d758657f1eb1$var$TEN_SECONDS = 10000;
const $0398d758657f1eb1$export$bc708ee563e4f3a0 = ()=>$0398d758657f1eb1$var$whiteboardsLocalStorage.set($0398d758657f1eb1$export$34e19e61668698cb.PULSE_LOCAL_STORAGE_KEY, 'true');
const $0398d758657f1eb1$export$db8829fda2a591b5 = ()=>$0398d758657f1eb1$var$whiteboardsLocalStorage.get($0398d758657f1eb1$export$34e19e61668698cb.PULSE_LOCAL_STORAGE_KEY) === 'true';
const $0398d758657f1eb1$export$c74e0ded7b123e80 = ()=>$0398d758657f1eb1$var$whiteboardsLocalStorage.get($0398d758657f1eb1$export$34e19e61668698cb.PROJECT_SPACE_KEY);
const $0398d758657f1eb1$export$4718112ffbeae5c5 = (value)=>$0398d758657f1eb1$var$whiteboardsLocalStorage.set($0398d758657f1eb1$export$34e19e61668698cb.PROJECT_SPACE_KEY, value, Date.now() + $0398d758657f1eb1$var$SEVEN_DAYS);
const $0398d758657f1eb1$export$7026bb8c5c571a7e = ()=>$0398d758657f1eb1$var$whiteboardsLocalStorage.get($0398d758657f1eb1$export$34e19e61668698cb.WHITEBOARDS_ENTRYPOINT_CONFLUENCE_DATA_KEY);
const $0398d758657f1eb1$export$1a8782a287467f35 = (data)=>$0398d758657f1eb1$var$whiteboardsLocalStorage.set($0398d758657f1eb1$export$34e19e61668698cb.WHITEBOARDS_ENTRYPOINT_CONFLUENCE_DATA_KEY, data, Date.now() + $0398d758657f1eb1$var$TEN_SECONDS);

});

parcelRegister("kBXQ9", function(module, exports) {

$parcel$export(module.exports, "fetchConfluencePermissions", () => $62b35d6aa06ad41f$export$332e821aef1400f5);
$parcel$export(module.exports, "fetchConfluenceAccessRequestCapability", () => $62b35d6aa06ad41f$export$172a99e3eee0bb2a);
$parcel$export(module.exports, "fetchConfluenceSpace", () => $62b35d6aa06ad41f$export$41d2a3af49f11b2d);
$parcel$export(module.exports, "fetchSiteTraits", () => $62b35d6aa06ad41f$export$954f05a5dfd487e4);
$parcel$export(module.exports, "fetchUserPropertyKeys", () => $62b35d6aa06ad41f$export$56d2a14b21426072);

var $487fd = parcelRequire("487fd");
function $62b35d6aa06ad41f$export$332e821aef1400f5() {
    return (0, $487fd.default)('/wiki/rest/api/user/current?expand=operations,personalSpace');
}
function $62b35d6aa06ad41f$export$172a99e3eee0bb2a(cloudId) {
    const resource = `ari:cloud:confluence::site/${cloudId}`;
    const params = new URLSearchParams({
        resource: resource
    });
    return (0, $487fd.default)(`/gateway/api/invitations/v1/access-requests/capabilities?${params.toString()}`, {
        credentials: 'include'
    });
}
function $62b35d6aa06ad41f$export$41d2a3af49f11b2d() {
    return (0, $487fd.default)('/wiki/api/v2/spaces?limit=1');
}
function $62b35d6aa06ad41f$export$954f05a5dfd487e4(cloudId) {
    return (0, $487fd.default)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`, {
        perf: {
            key: 'site-traits',
            prefix: 'whiteboards-entrypoint-experiment'
        }
    });
}
function $62b35d6aa06ad41f$export$56d2a14b21426072(accountId) {
    return (0, $487fd.default)(`/rest/api/3/user/properties?accountId=${encodeURIComponent(accountId)}&operation=UserPropertyKeys`);
}

});


parcelRegister("5uBAa", function(module, exports) {

$parcel$export(module.exports, "SET_CONFLUENCE_DATA", () => $2eb5d524e057b09d$export$a96a8fed4d61027a);
$parcel$export(module.exports, "setConfluenceData", () => $2eb5d524e057b09d$export$1a8782a287467f35);
$parcel$export(module.exports, "SET_WHITEBOARD_ELIGIBILITY", () => $2eb5d524e057b09d$export$4d0a6a14430368e6);
$parcel$export(module.exports, "HAS_XFLOW_FROM_WHITEBOARDS_TOUCHPOINT", () => $2eb5d524e057b09d$export$a0ec8c8be4bc8ceb);
$parcel$export(module.exports, "setHasXflowFromWhiteboardsTouchpoint", () => $2eb5d524e057b09d$export$2c8e03303ba71f7c);
$parcel$export(module.exports, "SET_USER_PROPERTY_KEYS", () => $2eb5d524e057b09d$export$5f2342e0b5b154f1);
$parcel$export(module.exports, "setUserPropertyKeys", () => $2eb5d524e057b09d$export$f1eb0bdee5af73db);
$parcel$export(module.exports, "SET_USER_PROPERTY_KEY", () => $2eb5d524e057b09d$export$ea0ab0d6bbb9745e);
$parcel$export(module.exports, "setUserPropertyKey", () => $2eb5d524e057b09d$export$e0ea59841fd3ab80);
const $2eb5d524e057b09d$export$a96a8fed4d61027a = 'state.actions.permissions.SET_CONFLUENCE_DATA';
const $2eb5d524e057b09d$export$1a8782a287467f35 = ({ hasConfluenceRequestOrDirectAccess: hasConfluenceRequestOrDirectAccess, hasConfluenceAccess: hasConfluenceAccess, hasConfluenceSpaces: hasConfluenceSpaces })=>({
        type: $2eb5d524e057b09d$export$a96a8fed4d61027a,
        payload: {
            hasConfluenceRequestOrDirectAccess: hasConfluenceRequestOrDirectAccess,
            hasConfluenceSpaces: hasConfluenceSpaces,
            hasConfluenceAccess: hasConfluenceAccess
        }
    });
const $2eb5d524e057b09d$export$4d0a6a14430368e6 = 'state.actions.permissions.SET_WHITEBOARD_ELIGIBILITY';
const $2eb5d524e057b09d$export$e965b613697e9fbe = ({ flow: flow, cohort: cohort })=>({
        type: $2eb5d524e057b09d$export$4d0a6a14430368e6,
        payload: {
            flow: flow,
            cohort: cohort
        }
    });
const $2eb5d524e057b09d$export$a0ec8c8be4bc8ceb = 'state.actions.permissions.HAS_CROSS_FLOWED_FROM_WHITEBOARDS';
const $2eb5d524e057b09d$export$2c8e03303ba71f7c = (hasXflowFromWhiteboardsTouchpoint)=>({
        type: $2eb5d524e057b09d$export$a0ec8c8be4bc8ceb,
        payload: {
            hasXflowFromWhiteboardsTouchpoint: hasXflowFromWhiteboardsTouchpoint
        }
    });
const $2eb5d524e057b09d$export$5f2342e0b5b154f1 = 'state.actions.permissions.SET_USER_PROPERTY_KEYS';
const $2eb5d524e057b09d$export$f1eb0bdee5af73db = (payload)=>({
        type: $2eb5d524e057b09d$export$5f2342e0b5b154f1,
        payload: payload
    });
const $2eb5d524e057b09d$export$ea0ab0d6bbb9745e = 'state.actions.permissions.SET_USER_PROPERTY_KEY';
const $2eb5d524e057b09d$export$e0ea59841fd3ab80 = (payload)=>({
        type: $2eb5d524e057b09d$export$ea0ab0d6bbb9745e,
        payload: payload
    });

});


parcelRegister("qBa3H", function(module, exports) {

$parcel$export(module.exports, "loadWhiteboardsEntrypointConfluenceDataEpic", () => $4605eba0ec311102$export$edb952156f0c8f43);
parcelRequire("6cbqE");
parcelRequire("3awJm");

var $aq199 = parcelRequire("aq199");

var $e6C7w = parcelRequire("e6C7w");

var $cVFxd = parcelRequire("cVFxd");

var $80gxR = parcelRequire("80gxR");

var $j7Dz8 = parcelRequire("j7Dz8");

var $4R6GH = parcelRequire("4R6GH");

var $fjcgS = parcelRequire("fjcgS");

var $kBXQ9 = parcelRequire("kBXQ9");

var $3lZ6i = parcelRequire("3lZ6i");

var $5uBAa = parcelRequire("5uBAa");

var $7IKPD = parcelRequire("7IKPD");

var $jG5HW = parcelRequire("jG5HW");
const $4605eba0ec311102$var$hasPermissionsAndPersonalSpaceService = ()=>(0, $kBXQ9.fetchConfluencePermissions)().pipe((0, $cVFxd.map)((response)=>({
            hasOperations: (response?.operations && response?.operations?.length > 0) ?? false,
            hasPersonalSpace: !!response?.personalSpace,
            statusCode: response?.status || 200
        })), (0, $e6C7w.catchError)((error)=>(0, $aq199.of)({
            hasOperations: false,
            hasPersonalSpace: false,
            statusCode: error?.statusCode || -1
        })));
const $4605eba0ec311102$var$hasConfluenceSpacesService = ()=>(0, $kBXQ9.fetchConfluenceSpace)().pipe((0, $cVFxd.map)((response)=>(response?.results && response?.results?.length > 0) ?? false), (0, $e6C7w.catchError)(()=>(0, $aq199.of)(false)));
const $4605eba0ec311102$var$hasConfluenceAccessRequestCapabilityService = (cloudId)=>{
    const resource = `ari:cloud:confluence::site/${cloudId}`;
    return (0, $kBXQ9.fetchConfluenceAccessRequestCapability)(cloudId).pipe((0, $cVFxd.map)((response)=>{
        if (response?.results) {
            (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
                const payload = {
                    action: 'success',
                    actionSubject: 'crossJoinFromWhiteboardTouchpointToConfluenceExpRequestCapabilities',
                    source: 'backlog',
                    attributes: {
                        accessType: response.results[resource]
                    }
                };
                client.getInstance().sendOperationalEvent(payload);
            });
            return response.results[resource] === 'DIRECT_ACCESS' || response.results[resource] === 'REQUEST_ACCESS';
        }
        return false;
    }), (0, $e6C7w.catchError)((error)=>{
        (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                action: 'failed',
                actionSubject: 'crossJoinFromWhiteboardTouchpointToConfluenceExpRequestCapabilities',
                source: 'backlog',
                attributes: {
                    errorAction: 'Failed to fetch user capabilities',
                    error: error
                }
            };
            client.getInstance().sendOperationalEvent(payload);
        });
        return (0, $aq199.of)(false);
    }));
};
const $4605eba0ec311102$export$edb952156f0c8f43 = (action$, store)=>{
    return action$.ofType((0, $3lZ6i.LOAD_APP_DATA_REQUEST)).throttleTime(1000).switchMap(()=>{
        const cloudId = (0, $jG5HW.getCloudId)(store.getState());
        const cachedValue = (0, $7IKPD.getConfluenceData)();
        // If the request api fg is on and cloudId does not exist yet,
        // don't return the cachedValue because that means we potentially haven't run the api check for Confluence request/direct access
        if (cachedValue && (!(0, $4R6GH.fg)('cc_virality_cross_join_whiteboard_conf_kill_switch') || cloudId && (0, $4R6GH.fg)('cc_virality_cross_join_whiteboard_conf_kill_switch'))) return (0, $aq199.of)((0, $5uBAa.setConfluenceData)(cachedValue));
        return $4605eba0ec311102$var$hasPermissionsAndPersonalSpaceService().pipe((0, $80gxR.mergeMap)(({ hasOperations: hasOperations, hasPersonalSpace: hasPersonalSpace, statusCode: statusCode })=>{
            // Only check request capability if hasOperations is false and statusCode is 403 because when hasOperations is true that means user already has access to Confluence
            // And when status code is 403 that means the user doesn't have Confluence permissions, which indicates that Confluence exists on this instance.
            if (!hasOperations && cloudId && statusCode === 403 && (0, $4R6GH.fg)('cc_virality_cross_join_whiteboard_conf_kill_switch')) return $4605eba0ec311102$var$hasConfluenceAccessRequestCapabilityService(cloudId).pipe((0, $j7Dz8.tap)((hasConfluenceRequestOrDirectAccess)=>{
                (0, $7IKPD.setConfluenceData)({
                    hasConfluenceRequestOrDirectAccess: hasConfluenceRequestOrDirectAccess,
                    hasConfluenceAccess: hasOperations,
                    hasConfluenceSpaces: false
                });
            }), (0, $cVFxd.map)((hasConfluenceRequestOrDirectAccess)=>(0, $5uBAa.setConfluenceData)({
                    hasConfluenceRequestOrDirectAccess: hasConfluenceRequestOrDirectAccess,
                    hasConfluenceAccess: hasOperations,
                    hasConfluenceSpaces: false
                })));
            // If user already has access to Confluence they won't have request or direct access
            if (hasPersonalSpace) {
                const data = {
                    hasConfluenceRequestOrDirectAccess: false,
                    hasConfluenceAccess: hasOperations,
                    hasConfluenceSpaces: true
                };
                (0, $7IKPD.setConfluenceData)(data);
                return (0, $aq199.of)((0, $5uBAa.setConfluenceData)(data));
            }
            return $4605eba0ec311102$var$hasConfluenceSpacesService().pipe((0, $j7Dz8.tap)((hasSpaces)=>{
                (0, $7IKPD.setConfluenceData)({
                    hasConfluenceRequestOrDirectAccess: false,
                    hasConfluenceAccess: hasOperations,
                    hasConfluenceSpaces: hasSpaces
                });
            }), (0, $cVFxd.map)((hasSpaces)=>(0, $5uBAa.setConfluenceData)({
                    hasConfluenceRequestOrDirectAccess: false,
                    hasConfluenceAccess: hasOperations,
                    hasConfluenceSpaces: hasSpaces
                })));
        }));
    }).catch(()=>(0, $aq199.of)((0, $5uBAa.setConfluenceData)({
            hasConfluenceRequestOrDirectAccess: false,
            hasConfluenceAccess: false,
            hasConfluenceSpaces: false
        })));
};

});

parcelRegister("aUidi", function(module, exports) {

$parcel$export(module.exports, "loadHasXflowFromWhiteboardsTouchpointEpic", () => $977a27a57fccf346$export$bdcd402968afe778);
parcelRequire("fp4O3");
parcelRequire("6cbqE");

var $aq199 = parcelRequire("aq199");

var $cVFxd = parcelRequire("cVFxd");

var $eN6O2 = parcelRequire("eN6O2");

var $5uBAa = parcelRequire("5uBAa");

var $jG5HW = parcelRequire("jG5HW");

var $eoB0b = parcelRequire("eoB0b");
const $977a27a57fccf346$export$bdcd402968afe778 = (action$, store)=>action$.ofType((0, $5uBAa.SET_WHITEBOARD_ELIGIBILITY)).switchMap(()=>{
        const cloudId = (0, $jG5HW.getCloudId)(store.getState());
        const eligibility = (0, $eoB0b.getWhiteboardEligibility)(store.getState());
        const isCoUse = eligibility?.flow === 'coUse';
        if (isCoUse && cloudId) return (0, $eN6O2.hasXFlowFromWhiteboardsTouchpointService)(cloudId).pipe((0, $cVFxd.map)((0, $5uBAa.setHasXflowFromWhiteboardsTouchpoint)));
        return (0, $aq199.of)((0, $5uBAa.setHasXflowFromWhiteboardsTouchpoint)(false));
    });

});
parcelRegister("eoB0b", function(module, exports) {

$parcel$export(module.exports, "getHasConfluenceAccess", () => $cd0e8d2bc95119e8$export$6b10e8289feb83ca);
$parcel$export(module.exports, "getHasConfluenceRequestOrDirectAccess", () => $cd0e8d2bc95119e8$export$2ca49b96fd702b2d);
$parcel$export(module.exports, "getHasConfluenceSpaces", () => $cd0e8d2bc95119e8$export$2c012cbcdccebb42);
$parcel$export(module.exports, "getWhiteboardEligibility", () => $cd0e8d2bc95119e8$export$db95b58c02bd0d3e);
$parcel$export(module.exports, "getHasXflowFromWhiteboardsTouchPoint", () => $cd0e8d2bc95119e8$export$4bbc1bfaf5ab7411);
$parcel$export(module.exports, "hasDismissedBanner", () => $cd0e8d2bc95119e8$export$41b53f6f834dfea8);
$parcel$export(module.exports, "hasDismissedWhiteboardsEntrypoint", () => $cd0e8d2bc95119e8$export$d55343f3f0f35ec9);

var $dGvGJ = parcelRequire("dGvGJ");

var $7IKPD = parcelRequire("7IKPD");
const $cd0e8d2bc95119e8$export$ccc046947a5517f1 = (state)=>state.config.whiteboardsEntrypointExperimentConfig;
const $cd0e8d2bc95119e8$export$6b10e8289feb83ca = (state)=>$cd0e8d2bc95119e8$export$ccc046947a5517f1(state).hasConfluenceAccess;
const $cd0e8d2bc95119e8$export$2ca49b96fd702b2d = (state)=>$cd0e8d2bc95119e8$export$ccc046947a5517f1(state).hasConfluenceRequestOrDirectAccess;
const $cd0e8d2bc95119e8$export$2c012cbcdccebb42 = (state)=>$cd0e8d2bc95119e8$export$ccc046947a5517f1(state).hasConfluenceSpaces;
const $cd0e8d2bc95119e8$export$db95b58c02bd0d3e = (state)=>$cd0e8d2bc95119e8$export$ccc046947a5517f1(state).eligibility;
const $cd0e8d2bc95119e8$export$4bbc1bfaf5ab7411 = (state)=>$cd0e8d2bc95119e8$export$ccc046947a5517f1(state).hasXFlowFromWhiteboardsTouchpoint;
const $cd0e8d2bc95119e8$var$getUserPropertyKeys = (0, $dGvGJ.createSelector)([
    $cd0e8d2bc95119e8$export$ccc046947a5517f1
], (config)=>config?.userPropertyKeys ? new Set(config?.userPropertyKeys) : null);
const $cd0e8d2bc95119e8$export$41b53f6f834dfea8 = (0, $dGvGJ.createSelector)([
    $cd0e8d2bc95119e8$var$getUserPropertyKeys
], (keys)=>{
    if (keys === null) return true;
    return keys.has((0, $7IKPD.USER_PROPERTY_KEY_NAMES).BANNER_DISMISSED);
});
const $cd0e8d2bc95119e8$export$d55343f3f0f35ec9 = (0, $dGvGJ.createSelector)([
    $cd0e8d2bc95119e8$var$getUserPropertyKeys
], (keys)=>{
    if (keys === null) return true;
    return keys.has((0, $7IKPD.USER_PROPERTY_KEY_NAMES).WHITEBOARDS_BACKLOG_ENTRYPOINT_DISMISSED);
});

});



parcelRegister("51zzD", function(module, exports) {

$parcel$export(module.exports, "refreshBacklog", () => $c0653de01764c7a5$export$d182fa418f4f1d16);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("2JdQp");
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("iQCJJ");
parcelRequire("ihPQR");
parcelRequire("1oQta");
parcelRequire("kxK5F");
parcelRequire("eSGL3");
parcelRequire("3awJm");
parcelRequire("6cbqE");

var $gSIcW = parcelRequire("gSIcW");

var $guzeq = parcelRequire("guzeq");

var $3lZ6i = parcelRequire("3lZ6i");

var $jG5HW = parcelRequire("jG5HW");

var $jhRgJ = parcelRequire("jhRgJ");
const $c0653de01764c7a5$export$4bac01e56d750d42 = Symbol('STREAM_START_MARKER');
const $c0653de01764c7a5$var$DEBOUNCE_TIME = 1000;
const $c0653de01764c7a5$var$POLLIG_INTERVAL = 600000;
const $c0653de01764c7a5$export$d182fa418f4f1d16 = (debounceScheduler, intervalScheduler, throttleScheduler)=>(action$, store)=>(0, $gSIcW.default)().distinctUntilChanged().debounceTime($c0653de01764c7a5$var$DEBOUNCE_TIME, debounceScheduler) // prevent multiple requests when switching tabs within 1s
        .switchMap((isTabVisible, idx)=>{
            if (!isTabVisible) return (0, $kVLXA.Observable).empty();
            const refreshStream$ = (0, $kVLXA.Observable).interval($c0653de01764c7a5$var$POLLIG_INTERVAL, intervalScheduler).mapTo((0, $3lZ6i.refreshDataRequest)((0, $guzeq.REFRESH_SOURCE_POLLING))).filter(()=>isTabVisible).filter(()=>!(0, $jhRgJ.hasAnyActiveOptimistic)(store.getState())).filter(()=>(0, $jG5HW.getIsCompanyManaged)(store.getState()));
            return idx === 0 ? refreshStream$.startWith($c0653de01764c7a5$export$4bac01e56d750d42) : refreshStream$.startWith((0, $3lZ6i.refreshDataRequest)((0, $guzeq.REFRESH_SOURCE_ACTIVE_TAB)));
        }).throttleTime($c0653de01764c7a5$var$POLLIG_INTERVAL, throttleScheduler).filter((action)=>action !== $c0653de01764c7a5$export$4bac01e56d750d42);

});
parcelRegister("gSIcW", function(module, exports) {

$parcel$export(module.exports, "default", () => $63d01e218c271471$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");

var $cab1K = parcelRequire("cab1K");
parcelRequire("jG6Un");
parcelRequire("iQCJJ");
parcelRequire("d0pqD");

var $laTox = parcelRequire("laTox");
/**
 * Returns a stream of the current page visibility state whenever it changes.
 * Emits 'true' when the page is visible and 'false' when the page is hidden.
 *
 * Will emit `null` if document is not defined.
 *
 * This Observable WILL EMIT a value at the start of the load. If you're using
 * it to trigger refreshes, you should skip 1 value.
 */ const $63d01e218c271471$var$getVisibility$ = ()=>// @ts-expect-error - TS2322 - Type 'Observable<unknown>' is not assignable to type 'Observable<boolean | null>'.
    typeof document !== 'undefined' ? (0, $kVLXA.Observable).fromEvent(document, (0, $laTox.supportedVisiblityEvent))// We want to send the current visibility on a new subscription.
    // If we use `.startWith(isPageVisible())` then new subscribers
    // will get the initial visibility at load and not the current
    // visibility as the initial value.
    .startWith(null).map((0, $laTox.isPageVisible)) : new (0, $cab1K.Subject)().startWith(null);
var $63d01e218c271471$export$2e2bcd8739ae039 = $63d01e218c271471$var$getVisibility$;

});


parcelRegister("9kHz3", function(module, exports) {

$parcel$export(module.exports, "workloadModalSubtaskToggleEpic", () => $df37297fbb62cf4c$export$79647fc8c74209a6);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $3FUwR = parcelRequire("3FUwR");

var $lHBhO = parcelRequire("lHBhO");

var $62nZT = parcelRequire("62nZT");
const $df37297fbb62cf4c$export$79647fc8c74209a6 = (action$, store)=>action$.ofType((0, $lHBhO.TOGGLE_INCLUDE_SUBTASKS)).flatMap(()=>{
        const state = store.getState();
        const includeSubtasks = (0, $62nZT.getIncludeSubtasks)(state);
        (0, $3FUwR.setWorkloadSubtaskSettings)(includeSubtasks);
        return (0, $kVLXA.Observable).empty();
    });

});
parcelRegister("lHBhO", function(module, exports) {

$parcel$export(module.exports, "TOGGLE_INCLUDE_SUBTASKS", () => $b05b254e887fdc1d$export$9e8abc0f766522c0);
$parcel$export(module.exports, "SET_INCLUDE_SUBTASKS", () => $b05b254e887fdc1d$export$2bb50ef8dfae1cac);
$parcel$export(module.exports, "toggleIncludeSubtasks", () => $b05b254e887fdc1d$export$4010b3772248a658);
$parcel$export(module.exports, "setIncludeSubtasksAction", () => $b05b254e887fdc1d$export$1c3dc37b8734dfc3);
const $b05b254e887fdc1d$export$9e8abc0f766522c0 = 'state.actions.workload-modal.TOGGLE_INCLUDE_SUBTASKS';
const $b05b254e887fdc1d$export$2bb50ef8dfae1cac = 'state.actions.workload-modal.SET_INCLUDE_SUBTASKS';
const $b05b254e887fdc1d$export$4010b3772248a658 = ()=>({
        type: $b05b254e887fdc1d$export$9e8abc0f766522c0
    });
const $b05b254e887fdc1d$export$1c3dc37b8734dfc3 = (includeSubtasks)=>({
        type: $b05b254e887fdc1d$export$2bb50ef8dfae1cac,
        payload: {
            includeSubtasks: includeSubtasks
        }
    });

});

parcelRegister("62nZT", function(module, exports) {

$parcel$export(module.exports, "getIncludeSubtasks", () => $8bdfa4f07af83349$export$2ada7f35c22b42ed);
$parcel$export(module.exports, "makeWorkLoadByAssignee", () => $8bdfa4f07af83349$export$cfa0f2c87d880353);

var $dGvGJ = parcelRequire("dGvGJ");

var $fn8B5 = parcelRequire("fn8B5");

var $gJBT6 = parcelRequire("gJBT6");

var $g4tDr = parcelRequire("g4tDr");

var $dGljH = parcelRequire("dGljH");
const $8bdfa4f07af83349$export$2ada7f35c22b42ed = (state)=>state.ui.workloadModal.includeSubtasks;
const $8bdfa4f07af83349$export$cfa0f2c87d880353 = (0, $dGvGJ.createSelector)([
    (0, $dGljH.makeOrderedVisibleCardsForCardList),
    $8bdfa4f07af83349$export$2ada7f35c22b42ed
], (getOrderedVisibleCardsForCardList, includeSubtasks)=>{
    const getWorkLoadByAssignee = (cardListId)=>{
        let listOfVisibleCards = getOrderedVisibleCardsForCardList(cardListId);
        if (!includeSubtasks) listOfVisibleCards = listOfVisibleCards.filter((card)=>!(0, $g4tDr.isSubtaskHierarchyLevel)(card.typeHierarchyLevel));
        const cardsGroupedByAssigned = (0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(listOfVisibleCards, (card)=>card.assignee?.id ?? 'unassigned');
        const assignees = Object.values(cardsGroupedByAssigned).map((cardList)=>{
            const initial = {
                name: undefined,
                profilePicture: undefined,
                storyPoints: 0,
                remainingTimeEstimateInSeconds: 0,
                originalTimeEstimateInSeconds: 0,
                issueCount: 0,
                subtaskCount: 0
            };
            return cardList.reduce((prev, card)=>{
                const storyPointIncrement = card.estimate?.storyPoints ?? 0;
                const timeEstimateIncrement = card.estimate?.originalEstimate?.value ?? 0;
                const timeRemainingIncrement = card.estimate?.timeRemainingEstimate?.value ?? 0;
                return {
                    name: card.assignee?.displayName ?? prev.name,
                    profilePicture: card.assignee?.avatarUrl ?? prev.name,
                    storyPoints: prev.storyPoints + storyPointIncrement,
                    originalTimeEstimateInSeconds: prev.originalTimeEstimateInSeconds + timeEstimateIncrement,
                    remainingTimeEstimateInSeconds: prev.remainingTimeEstimateInSeconds + timeRemainingIncrement,
                    issueCount: (0, $g4tDr.isSubtaskHierarchyLevel)(card.typeHierarchyLevel) ? prev.issueCount : prev.issueCount + 1,
                    subtaskCount: (0, $g4tDr.isSubtaskHierarchyLevel)(card.typeHierarchyLevel) ? (prev.subtaskCount ?? 0) + 1 : prev.subtaskCount
                };
            }, initial);
        });
        return assignees;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getWorkLoadByAssignee);
});

});


parcelRegister("daZWX", function(module, exports) {

$parcel$export(module.exports, "sprintBoardLinkClickEpic", () => $18997f8a2da36e0f$export$611bf50a1fee88ad);
parcelRequire("zjDln");
parcelRequire("6hSeW");
parcelRequire("fPS7b");
parcelRequire("fp4O3");
parcelRequire("3awJm");
parcelRequire("c66Ur");

var $kVLXA = parcelRequire("kVLXA");

var $2YZCu = parcelRequire("2YZCu");

var $c0C8a = parcelRequire("c0C8a");

var $64W1A = parcelRequire("64W1A");
const $18997f8a2da36e0f$var$getUserLocatedBoardUrl = (accountId, boardId)=>{
    return `/jira/people/${accountId}/boards/${boardId}`;
};
const $18997f8a2da36e0f$var$getProjectLocatedBoardUrl = (isCMPBoard, projectKey, boardId)=>{
    return `/jira/software${isCMPBoard ? '/c' : ''}/projects/${projectKey}/boards/${boardId}`;
};
const $18997f8a2da36e0f$export$611bf50a1fee88ad = (push)=>(action$)=>action$.ofType((0, $c0C8a.SPRINT_BOARD_LINK_CLICK)).throttleTime(1000).mergeMap((action)=>{
            const rapidViewId = action.payload.rapidViewId;
            const analyticsEvent = action.meta.analyticsEvent;
            return (0, $64W1A.fetchBoardDetails)(rapidViewId).mergeMap((response)=>{
                const type = response.type;
                const userAccountId = response.location?.userAccountId;
                const projectKey = response.location?.projectKey;
                if (userAccountId) {
                    push($18997f8a2da36e0f$var$getUserLocatedBoardUrl(userAccountId, rapidViewId));
                    return (0, $kVLXA.Observable).of((0, $c0C8a.sprintBoardLinkClickSuccess)(analyticsEvent));
                }
                if (projectKey && type) {
                    push($18997f8a2da36e0f$var$getProjectLocatedBoardUrl(type !== 'simple', projectKey, rapidViewId));
                    return (0, $kVLXA.Observable).of((0, $c0C8a.sprintBoardLinkClickSuccess)(analyticsEvent));
                }
                return (0, $kVLXA.Observable).of((0, $c0C8a.sprintBoardLinkPermissionlessFlagRequest)(analyticsEvent));
            }).catch((error)=>{
                (0, $2YZCu.default).safeErrorWithoutCustomerData('backlog.sprint-board-link-click.failure', 'Failed to redirect to board', error);
                return (0, $kVLXA.Observable).from([
                    (0, $c0C8a.sprintBoardLinkClickFailure)(analyticsEvent)
                ]);
            });
        });

});
parcelRegister("64W1A", function(module, exports) {

$parcel$export(module.exports, "fetchBoardDetails", () => $23fe70cac5b3ffab$export$5669d68280febc83);

var $487fd = parcelRequire("487fd");
const $23fe70cac5b3ffab$export$94df0e59ebebf4a7 = (boardId)=>`/rest/agile/1.0/board/${boardId}`;
const $23fe70cac5b3ffab$export$5669d68280febc83 = (rapidViewId)=>(0, $487fd.default)(`${$23fe70cac5b3ffab$export$94df0e59ebebf4a7(rapidViewId)}`);

});



parcelRegister("81CEh", function(module, exports) {

$parcel$export(module.exports, "getHideEpics", () => $20551ed6a1672a5b$export$344e252cb642fb56);
$parcel$export(module.exports, "getHideStatuses", () => $20551ed6a1672a5b$export$d3997e0a815ec9a9);
$parcel$export(module.exports, "getHideVersions", () => $20551ed6a1672a5b$export$bccf76194364adbb);

var $bSSG7 = parcelRequire("bSSG7");

var $4R6GH = parcelRequire("4R6GH");
const $20551ed6a1672a5b$var$localStorageProvider = (0, $bSSG7.createLocalStorageProvider)('', false);
const $20551ed6a1672a5b$var$HIDE_EPIC_FIELD_PREFIX = 'gh.epicShownOnRapidBoard.';
const $20551ed6a1672a5b$var$HIDE_STATUS_FIELD_PREFIX = 'gh.statusShownOnRapidBoard.';
const $20551ed6a1672a5b$var$HIDE_VERSION_FIELD_PREFIX = 'gh.versionShownOnRapidBoard.';
const $20551ed6a1672a5b$export$344e252cb642fb56 = (boardId)=>((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? $20551ed6a1672a5b$var$localStorageProvider.get(`${$20551ed6a1672a5b$var$HIDE_EPIC_FIELD_PREFIX}${boardId}`) : localStorage.getItem(`${$20551ed6a1672a5b$var$HIDE_EPIC_FIELD_PREFIX}${boardId}`)) === 'false';
const $20551ed6a1672a5b$export$c9ac14c6e06788a3 = (boardId, hideEpics)=>(0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? $20551ed6a1672a5b$var$localStorageProvider.set(`${$20551ed6a1672a5b$var$HIDE_EPIC_FIELD_PREFIX}${boardId}`, (!hideEpics).toString()) : localStorage.setItem(`${$20551ed6a1672a5b$var$HIDE_EPIC_FIELD_PREFIX}${boardId}`, (!hideEpics).toString());
const $20551ed6a1672a5b$export$d3997e0a815ec9a9 = (boardId)=>((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? $20551ed6a1672a5b$var$localStorageProvider.get(`${$20551ed6a1672a5b$var$HIDE_STATUS_FIELD_PREFIX}${boardId}`) : localStorage.getItem(`${$20551ed6a1672a5b$var$HIDE_STATUS_FIELD_PREFIX}${boardId}`)) === 'false';
const $20551ed6a1672a5b$export$66dad339f6bd60a0 = (boardId, hideStatuses)=>(0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? $20551ed6a1672a5b$var$localStorageProvider.set(`${$20551ed6a1672a5b$var$HIDE_STATUS_FIELD_PREFIX}${boardId}`, (!hideStatuses).toString()) : localStorage.setItem(`${$20551ed6a1672a5b$var$HIDE_STATUS_FIELD_PREFIX}${boardId}`, (!hideStatuses).toString());
const $20551ed6a1672a5b$export$bccf76194364adbb = (boardId)=>((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? $20551ed6a1672a5b$var$localStorageProvider.get(`${$20551ed6a1672a5b$var$HIDE_VERSION_FIELD_PREFIX}${boardId}`) : localStorage.getItem(`${$20551ed6a1672a5b$var$HIDE_VERSION_FIELD_PREFIX}${boardId}`)) === 'false';
const $20551ed6a1672a5b$export$828020f0cfbd3e66 = (boardId, hideVersions)=>(0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? $20551ed6a1672a5b$var$localStorageProvider.set(`${$20551ed6a1672a5b$var$HIDE_VERSION_FIELD_PREFIX}${boardId}`, (!hideVersions).toString()) : localStorage.setItem(`${$20551ed6a1672a5b$var$HIDE_VERSION_FIELD_PREFIX}${boardId}`, (!hideVersions).toString());

});

parcelRegister("5qbje", function(module, exports) {

$parcel$export(module.exports, "removeLocationLegacyPanelQueryParameters", () => $a12f49547554404b$export$1c4bddcdc8213ef1);

var $7uUwQ = parcelRequire("7uUwQ");

var $ebyGx = parcelRequire("ebyGx");

var $2YZCu = parcelRequire("2YZCu");

const $a12f49547554404b$export$1c4bddcdc8213ef1 = (location, push)=>{
    const search = (0, $7uUwQ.chain)({
        ...(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(location.search)
    });
    const searchValue = search.value();
    let legacyPanelQueryParamRemoved = false;
    const { versionPanel: versionPanel, issueParentPanel: issueParentPanel } = searchValue;
    if (versionPanel) {
        search.unset((0, $4f4a02cead13bb5a$export$9c304e612707f622));
        legacyPanelQueryParamRemoved = true;
    }
    if (issueParentPanel) {
        search.unset((0, $4f4a02cead13bb5a$export$7f765927237d6fb0));
        legacyPanelQueryParamRemoved = true;
    }
    if (legacyPanelQueryParamRemoved) {
        const routerPayload = {
            ...location,
            search: (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(search.value())
        };
        (0, $2YZCu.default).safeInfoWithoutCustomerData('backlog.services.routing.legacy-panel-query-parameters', 'Removed legacy panel query parameter(s)', {
            versionPanel: versionPanel,
            issueParentPanel: issueParentPanel
        });
        push(routerPayload);
    }
};

});

parcelRegister("gUpx5", function(module, exports) {

$parcel$export(module.exports, "getCustomDataForMemoryAnalyticsFromUrl", () => $7e5eaaee945296ad$export$f0fe5d1ef77b9f92);

const $7e5eaaee945296ad$export$f0fe5d1ef77b9f92 = ()=>{
    // use the URL parameters to determine whether any panels are open
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const queryParams = new URL(window.location.href).searchParams;
    return {
        isEpicPanelOpen: queryParams.has((0, $4f4a02cead13bb5a$export$ec3c43b997309252)),
        isVersionPanelOpen: queryParams.has((0, $4f4a02cead13bb5a$export$a86c1a6dde9da34f)),
        isIssueViewOpen: queryParams.has((0, $4f4a02cead13bb5a$export$3a0c4bc79274bbaa))
    };
};

});

parcelRegister("bNDq8", function(module, exports) {

$parcel$export(module.exports, "TOGGLE_STATUS_FIELDS", () => $316d359c1f4dfb27$export$4dd62b8143c11245);
$parcel$export(module.exports, "toggleCardStatusFields", () => $316d359c1f4dfb27$export$8c139077a3243812);
$parcel$export(module.exports, "TOGGLE_VERSION_FIELDS", () => $316d359c1f4dfb27$export$afb58370a9942348);
$parcel$export(module.exports, "toggleCardVersionFields", () => $316d359c1f4dfb27$export$2f4945efdaceca5a);
$parcel$export(module.exports, "TOGGLE_EPIC_FIELDS", () => $316d359c1f4dfb27$export$b480e0a6893627bb);
$parcel$export(module.exports, "toggleCardEpicFields", () => $316d359c1f4dfb27$export$f47236aa9e8486c);
const $316d359c1f4dfb27$export$4dd62b8143c11245 = 'state.actions.cards.fields.TOGGLE_STATUS_FIELDS';
const $316d359c1f4dfb27$export$8c139077a3243812 = (hideStatusFields)=>({
        type: $316d359c1f4dfb27$export$4dd62b8143c11245,
        payload: {
            hideStatusFields: hideStatusFields
        }
    });
const $316d359c1f4dfb27$export$afb58370a9942348 = 'state.actions.cards.fields.TOGGLE_VERSION_FIELDS';
const $316d359c1f4dfb27$export$2f4945efdaceca5a = (hideVersionFields)=>({
        type: $316d359c1f4dfb27$export$afb58370a9942348,
        payload: {
            hideVersionFields: hideVersionFields
        }
    });
const $316d359c1f4dfb27$export$b480e0a6893627bb = 'state.actions.cards.fields.TOGGLE_EPIC_FIELDS';
const $316d359c1f4dfb27$export$f47236aa9e8486c = (hideEpicFields)=>({
        type: $316d359c1f4dfb27$export$b480e0a6893627bb,
        payload: {
            hideEpicFields: hideEpicFields
        }
    });

});

parcelRegister("c1MAf", function(module, exports) {

$parcel$export(module.exports, "createStoreWithCache", () => $2c6815b54d8c8758$export$96feb51b037b866);
$parcel$export(module.exports, "unmountCachedStore", () => $2c6815b54d8c8758$export$a0196b1023d1dffd);
$parcel$export(module.exports, "BacklogReduxProvider", () => $2c6815b54d8c8758$export$ab832ec0f3793a0b);
$parcel$export(module.exports, "useBacklogStore", () => $2c6815b54d8c8758$export$bd6baa7168fb537b);
$parcel$export(module.exports, "useBacklogSelector", () => $2c6815b54d8c8758$export$3f6a924af1f755b6);
$parcel$export(module.exports, "useBacklogDispatch", () => $2c6815b54d8c8758$export$230b86ce3b02444b);
$parcel$export(module.exports, "useBacklogActionCreator", () => $2c6815b54d8c8758$export$d20547f842c968f1);
parcelRequire("korqb");

var $F2Mxm = parcelRequire("F2Mxm");

var $g3qyq = parcelRequire("g3qyq");

var $5Ue2S = parcelRequire("5Ue2S");

var $46ha9 = parcelRequire("46ha9");

var $guzeq = parcelRequire("guzeq");


var $8HBV0 = parcelRequire("8HBV0");

var $3olna = parcelRequire("3olna");

var $6j9F6 = parcelRequire("6j9F6");
function $2c6815b54d8c8758$export$2e2bcd8739ae039(preloadedState, { rootEpic: rootEpic, dependencies: dependencies }) {
    const middlewares = [
        (0, $8HBV0.default)(dependencies),
        (0, $g3qyq.default)((0, $guzeq.APP_ID)),
        (0, $3olna.default)
    ];
    var _getState, action;
    return (0, $F2Mxm.default)({
        appName: 'backlog',
        rootReducer: (0, $6j9F6.default)(),
        initialState: preloadedState ?? undefined,
        rootEpic: rootEpic,
        middlewares: middlewares,
        rootEpicDependencies: dependencies
    });
}
const $2c6815b54d8c8758$export$a6385bddcc8e6b77 = new (0, $5Ue2S.CachedStoreManager)({
    storeFactory: $2c6815b54d8c8758$export$2e2bcd8739ae039,
    mergeCachedState: (cachedState, _preloadedState)=>cachedState
});
function $2c6815b54d8c8758$export$96feb51b037b866(boardId, initialState, options) {
    return $2c6815b54d8c8758$export$a6385bddcc8e6b77.createStore(boardId, initialState, options);
}
const $2c6815b54d8c8758$export$a0196b1023d1dffd = ()=>{
    $2c6815b54d8c8758$export$a6385bddcc8e6b77.unmount();
};
const { Provider: $2c6815b54d8c8758$export$ab832ec0f3793a0b, useStore: $2c6815b54d8c8758$export$bd6baa7168fb537b, useSelector: $2c6815b54d8c8758$export$3f6a924af1f755b6, useDispatch: $2c6815b54d8c8758$export$230b86ce3b02444b, useActionCreator: $2c6815b54d8c8758$export$d20547f842c968f1 } = (0, $46ha9.createJiraSoftwareStoreContext)();

});
parcelRegister("g3qyq", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c091411acc86b19$export$2e2bcd8739ae039);

var $2YZCu = parcelRequire("2YZCu");

var $aMh57 = parcelRequire("aMh57");
/**
 * Catches errors within redux reducers and makes them available to monitoring.
 *
 * Takes an optional error action creator as a parameter to be reduced when an error is encountered.
 * This could be used to show an error flag, for example.
 *
 * Should be passed as part of the middleware array when creating the store.
 * E.g. [middlewareOne, errorHandling('your-app-name')]
 */ const $4c091411acc86b19$var$errorHandling = (appId, errorActionCreator, /**
		 * Callback for errors
		 */ onError)=>()=>(next)=>(action)=>{
                try {
                    next(action);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    const fullLocation = `common.redux-error.${appId}`;
                    (0, $2YZCu.default).safeErrorWithoutCustomerData(fullLocation, `Unhandled error for Redux action: '${action?.type}'`, error);
                    (0, $aMh57.captureException)(fullLocation, error);
                    errorActionCreator && next(errorActionCreator());
                    onError && onError(error);
                }
            };
var $4c091411acc86b19$export$2e2bcd8739ae039 = $4c091411acc86b19$var$errorHandling;

});

parcelRegister("5Ue2S", function(module, exports) {

$parcel$export(module.exports, "CachedStoreManager", () => $8f61412efdaebad3$export$519eb0cf9e49db0c);

var $91VA7 = parcelRequire("91VA7");
class $8f61412efdaebad3$export$519eb0cf9e49db0c {
    constructor({ storeFactory: storeFactory, mergeCachedState: mergeCachedState }){
        this.cache = null;
        this.storeFactory = storeFactory;
        this.mergeCachedState = mergeCachedState;
    }
    /**
	 * Return true if the redux state was in cache. In this case, we won't consider
	 * the resources' data.
	 */ hasCachedState(boardId) {
        return Boolean(this.cache && this.cache.boardId === boardId);
    }
    getCachedState(boardId) {
        if (this.cache && this.cache.boardId === boardId) return this.cache.state;
        return null;
    }
    /**
	 * Create a new store, merging a preloadedState with any cached state that was
	 * previously held in memory.
	 */ createStore(boardId, preloadedStateParam, options) {
        // Cast to get rid of Omit<...>. Both types are partial so this is valid
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        let preloadedState = (0, (/*@__PURE__*/$parcel$interopDefault($91VA7)))(preloadedStateParam);
        const cachedState = this.getCachedState(boardId);
        if (!options.disableStoreCaches && cachedState) preloadedState = this.mergeCachedState(cachedState, preloadedState);
        const store = this.storeFactory(preloadedState, options);
        if (options.disableStoreCaches) return store;
        // On every change copy a reference to the redux state to this
        // `cachedStoreState` object.
        this.unmount();
        this.cache = {
            boardId: boardId,
            state: store.getState(),
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            unsubscribe: ()=>{}
        };
        this.cache.unsubscribe = store.subscribe(()=>{
            if (this.cache) this.cache.state = store.getState();
        });
        return store;
    }
    /**
	 * Clean-up redux store subscriptions.
	 */ unmount() {
        this.cache?.unsubscribe();
    }
    /**
	 * FOR TESTING ONLY
	 */ getCacheForTesting() {
        return this.cache;
    }
    // For testing
    resetCache() {
        this.cache = null;
    }
}

});

parcelRegister("46ha9", function(module, exports) {

$parcel$export(module.exports, "createJiraSoftwareStoreContext", () => $b414fa8c478f8909$export$884b1d3e4c97abdd);

var $5uXOq = parcelRequire("5uXOq");

var $bDWQ3 = parcelRequire("bDWQ3");

var $7D59a = parcelRequire("7D59a");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b414fa8c478f8909$var$refEquality = (a, b)=>a === b;
function $b414fa8c478f8909$export$884b1d3e4c97abdd() {
    const ctx = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
    const useStore = ()=>{
        const store = (0, $5uXOq.useContext)(ctx);
        if (!store) throw new Error('useStore called outside of redux JiraSoftwareStoreContext tree');
        return store;
    };
    function useSelector(selector, equalityFn = $b414fa8c478f8909$var$refEquality) {
        const store = useStore();
        const result = (0, $bDWQ3.useSyncExternalStoreWithSelector)(store.subscribe, store.getState, // Server state probably wont exist but we can use store.getState in case it does work.
        store.getState, selector, equalityFn);
        return result;
    }
    function useDispatch() {
        const store = useStore();
        return store.dispatch;
    }
    function useActionCreator(actionCreator) {
        const dispatch = useDispatch();
        return (0, $7D59a.useEvent)((...args)=>{
            const action = actionCreator(...args);
            dispatch(action);
        });
    }
    function ReduxProvider(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ctx.Provider, {
            value: props.store
        }, props.children);
    }
    return {
        Provider: ReduxProvider,
        useSelector: useSelector,
        useStore: useStore,
        useDispatch: useDispatch,
        useActionCreator: useActionCreator
    };
}

});
parcelRegister("7D59a", function(module, exports) {

$parcel$export(module.exports, "useEvent", () => $cc6c832ad15d24e3$export$90fc3a17d93f704c);

var $5uXOq = parcelRequire("5uXOq");
const $cc6c832ad15d24e3$export$90fc3a17d93f704c = (callback)=>{
    const callbackRef = (0, $5uXOq.useRef)(callback);
    (0, $5uXOq.useLayoutEffect)(()=>{
        callbackRef.current = callback;
    }, [
        callback
    ]);
    return (0, $5uXOq.useCallback)((...args)=>callbackRef.current(...args), []);
};

});


parcelRegister("8HBV0", function(module, exports) {

$parcel$export(module.exports, "default", () => $633621fea0af4ff8$export$2e2bcd8739ae039);

var $4RHcR = parcelRequire("4RHcR");

var $gccSB = parcelRequire("gccSB");

var $hhweD = parcelRequire("hhweD");

var $f2NGE = parcelRequire("f2NGE");

var $8zOmE = parcelRequire("8zOmE");

var $jG5HW = parcelRequire("jG5HW");

var $3Uc50 = parcelRequire("3Uc50");

var $1wOVq = parcelRequire("1wOVq");
const $633621fea0af4ff8$var$APP_ANALYTICS_PREFIX = 'software-plan-view';
// @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value.
const $633621fea0af4ff8$var$shouldTriggerAnalytics = ({ type: type } = {})=>(0, $3Uc50.default)()[type] !== undefined;
const $633621fea0af4ff8$var$getAnalyticsForAction = (preActionState, postActionState, action, dependencies)=>(0, $3Uc50.default)()[action.type].map((createAnalytic)=>createAnalytic((0, $3Uc50.ANALYTIC_PREFIX))(preActionState, postActionState, action, dependencies)).filter((analyticEvent)=>analyticEvent != null);
const $633621fea0af4ff8$var$triggerAnalyticsForAction = (analyticEvents, state)=>{
    const triggerSoftwareAnalytics = (0, $1wOVq.triggerAnalytics)($633621fea0af4ff8$var$APP_ANALYTICS_PREFIX);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(analyticEvents)) return;
    analyticEvents.forEach(({ name: name, data: data = {}, trackEvents: trackEvents = [] })=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($4RHcR)))(data, {
            rapidViewId: (0, $jG5HW.getRapidViewId)(state),
            projectId: (0, $jG5HW.projectIdSelector)(state),
            isCompanyManaged: (0, $jG5HW.getIsCompanyManaged)(state)
        });
        // This is not doing anything, we can remove it as part of
        // https://hello.atlassian.net/browse/CATB-418
        triggerSoftwareAnalytics(name, data);
        trackEvents.forEach((trackEvent)=>{
            const { payload: payload } = trackEvent;
            const { action: action, actionSubject: actionSubject, card: card, ...otherProperties } = payload;
            /**
			 * Fields inputted by the user. When this was created, there was no ability to
			 * add in extra fields in the inline create, so we'll assume it's ONLY summary.
			 */ const issueCreateFieldsUsed = payload.issueCreateFieldsUsed ?? [
                {
                    gqlType: 'JiraSingleLineTextField',
                    issueFieldId: 'summary',
                    issueFieldType: 'summary',
                    isPopulated: true
                }
            ];
            let fieldsPopulated = {};
            if (payload.sessionId !== undefined && !!card) // Fields that can be populated automatically e.g. by filters, swimlanes, postfunctions
            fieldsPopulated = {
                ASSIGNEE: !!card.assignee,
                PARENT: !!card.parentId,
                PRIORITY: !!card.priority,
                FIX_VERSIONS: (0, $f2NGE.getFieldLengthForAnalytics)(card.fixVersions?.length),
                LABELS: (0, $f2NGE.getFieldLengthForAnalytics)(card.labels?.length)
            };
            /**
			 * Facilitate CMP instrumentation for inline creation analytics.
			 *
			 * https://hello.atlassian.net/wiki/spaces/SQE/pages/2613558743/Instrumentation+Spec+Inline+Create+CMP+Boards - ERAI-1376
			 *
			 * The following assumptions are made due to how inline creation is made;
			 * - the only issue create field that is present: summary
			 * - It has to be "backlog" for the source of inline creation, if this is altered in the future, this will not track other sources.
			 */ const additionalPayloads = {
                ...otherProperties,
                isCompanyManaged: (0, $jG5HW.getIsCompanyManaged)(state),
                issueCreateFieldsUsed: issueCreateFieldsUsed,
                fieldsPopulated: fieldsPopulated
            };
            /**
			 * NOTE
			 *
			 * This is a temporary fix for https://hello.atlassian.net/browse/CATB-415
			 *
			 * It should be cleaned up by https://hello.atlassian.net/browse/CATB-418
			 */ if (action && actionSubject) (0, $8zOmE.fireTrackAnalytics)(trackEvent, `${actionSubject} ${action}`, {
                ...additionalPayloads
            });
            else (0, $hhweD.fireTrackAnalytics)(trackEvent, {
                action: payload.action,
                attributes: {
                    ...additionalPayloads
                }
            });
        });
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$633621fea0af4ff8$export$2e2bcd8739ae039 = (dependencies)=>(store)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (next)=>(action)=>{
                if (!$633621fea0af4ff8$var$shouldTriggerAnalytics(action)) {
                    next(action);
                    return;
                }
                const preActionState = store.getState();
                next(action);
                const postActionState = store.getState();
                const analyticEvents = $633621fea0af4ff8$var$getAnalyticsForAction(preActionState, postActionState, action, dependencies);
                $633621fea0af4ff8$var$triggerAnalyticsForAction(analyticEvents, postActionState);
            };

});
parcelRegister("4RHcR", function(module, exports) {

var $4NkAS = parcelRequire("4NkAS");

var $9MM2g = parcelRequire("9MM2g");

var $lbyKY = parcelRequire("lbyKY");
/**
 * This method is like `_.assign` except that it iterates over own and
 * inherited source properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias extend
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assign
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assignIn({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
 */ var $38ada0910bc35ca9$var$assignIn = $9MM2g(function(object, source) {
    $4NkAS(source, $lbyKY(source), object);
});
module.exports = $38ada0910bc35ca9$var$assignIn;

});

parcelRegister("f2NGE", function(module, exports) {

$parcel$export(module.exports, "getFieldLengthForAnalytics", () => $b46d240c3082c919$export$e337040f61dd6dff);
const $b46d240c3082c919$export$e337040f61dd6dff = (length)=>{
    if (!length) return '0';
    if (length > 3) return '>3';
    return String(length);
};

});

parcelRegister("3Uc50", function(module, exports) {

$parcel$export(module.exports, "ANALYTIC_PREFIX", () => $922e25649c340829$export$c88107e5c6decd92);
$parcel$export(module.exports, "default", () => $922e25649c340829$export$2e2bcd8739ae039);

var $aB8eX = parcelRequire("aB8eX");

var $6s1PB = parcelRequire("6s1PB");

var $3lZ6i = parcelRequire("3lZ6i");

var $3qXBy = parcelRequire("3qXBy");

var $hf5c2 = parcelRequire("hf5c2");

var $legw4 = parcelRequire("legw4");

var $8MHVw = parcelRequire("8MHVw");

var $aKajY = parcelRequire("aKajY");

var $6GNN7 = parcelRequire("6GNN7");

var $et6P7 = parcelRequire("et6P7");

var $4mqko = parcelRequire("4mqko");

var $38qhf = parcelRequire("38qhf");

var $likqC = parcelRequire("likqC");

var $jkFPs = parcelRequire("jkFPs");

var $d09wv = parcelRequire("d09wv");

var $c0C8a = parcelRequire("c0C8a");

var $j0q3O = parcelRequire("j0q3O");

var $36SBa = parcelRequire("36SBa");

var $iEYCH = parcelRequire("iEYCH");

var $65Uph = parcelRequire("65Uph");

var $lASqM = parcelRequire("lASqM");

var $hchCX = parcelRequire("hchCX");

var $9kmfU = parcelRequire("9kmfU");

var $1kERf = parcelRequire("1kERf");

var $f9vTq = parcelRequire("f9vTq");
const $922e25649c340829$export$c88107e5c6decd92 = 'plan-view';
const $922e25649c340829$var$actionAnalyticsMap = ()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ({
        [(0, $3lZ6i.BACKLOG_VIEW)]: [
            (0, $j0q3O.backlogView)
        ],
        [(0, $3lZ6i.LOAD_APP_DATA_FAILURE)]: [
            (0, $j0q3O.backlogLoadAppDataFailure)
        ],
        [(0, $3lZ6i.LOAD_CONFIG_DATA_FAILURE)]: [
            (0, $j0q3O.backlogLoadConfigDataFailure)
        ],
        [(0, $3lZ6i.LOAD_CONFIG_DATA_SUCCESS)]: [
            (0, $j0q3O.backlogLoadConfigDataSuccess)
        ],
        [(0, $3lZ6i.LOAD_CONFIG_DATA_MODEL_SUCCESS)]: [
            (0, $j0q3O.backlogLoadConfigDataSuccess)
        ],
        [(0, $3lZ6i.REFRESH_DATA_REQUEST)]: [
            (0, $j0q3O.refreshDataRequest)
        ],
        [(0, $3qXBy.BOARD_ISSUE_MOVE_SHOW)]: [
            (0, $36SBa.boardIssueMoveShow)
        ],
        [(0, $3qXBy.BOARD_ISSUE_MOVE_CANCEL)]: [
            (0, $36SBa.boardIssueMoveCancel)
        ],
        [(0, $3qXBy.BOARD_ISSUE_MOVE_EXECUTE)]: [
            (0, $36SBa.boardIssueMoveExecute)
        ],
        [(0, $3qXBy.BOARD_ISSUE_MOVE_EXECUTE_FAILURE)]: [
            (0, $36SBa.boardIssueMoveExecuteFailure)
        ],
        [(0, $3qXBy.BOARD_ISSUE_MOVE_EXECUTE_SUCCESS)]: [
            (0, $36SBa.boardIssueMoveExecuteSuccess)
        ],
        [(0, $hf5c2.CARD_CREATE_MULTIPLE_REQUEST)]: [
            (0, $65Uph.cardCreateMultipleRequestPerformance)
        ],
        [(0, $hf5c2.CARD_CREATE_SUCCESS)]: [
            (0, $65Uph.cardCreateSuccess),
            (0, $65Uph.cardCreateSuccessPerformance)
        ],
        [(0, $hf5c2.CARD_CREATE_FAILURE)]: [
            (0, $65Uph.cardCreateFailure)
        ],
        [(0, $hf5c2.CARD_CREATE_FILTERED)]: [
            (0, $65Uph.cardCreateFiltered)
        ],
        [(0, $hf5c2.CARD_CREATE_FILTERED_V2)]: [
            (0, $65Uph.cardCreateFilteredV2)
        ],
        [(0, $legw4.CARD_DELETE_REQUEST)]: [
            (0, $65Uph.cardDeleteRequestPerformance)
        ],
        [(0, $legw4.CARD_DELETE_SUCCESS)]: [
            (0, $65Uph.cardDeleteSuccess)
        ],
        [(0, $legw4.CARD_DELETE_FAILURE)]: [
            (0, $65Uph.cardDeleteFailure)
        ],
        [(0, $aKajY.CARDS_FLAG_WITH_COMMENT_REQUEST)]: [
            (0, $65Uph.cardsFlagRequestPerformance)
        ],
        [(0, $aKajY.CARDS_FLAG_WITH_COMMENT_SUCCESS)]: [
            (0, $65Uph.cardsFlagSuccess)
        ],
        [(0, $aKajY.CARDS_FLAG_WITH_COMMENT_FAILURE)]: [
            (0, $65Uph.cardsFlagFailure)
        ],
        [(0, $et6P7.CARDS_PARENT_SET_SUCCESS)]: [
            (0, $65Uph.cardsParentSetSuccess)
        ],
        [(0, $et6P7.CARDS_PARENT_SET_FAILURE)]: [
            (0, $65Uph.cardsParentSetFailure)
        ],
        [(0, $likqC.SET_ALL_FILTERS)]: [
            (0, $hchCX.setAllFilters),
            (0, $hchCX.setAllFiltersPerformance)
        ],
        [(0, $38qhf.OPEN_DETAIL_VIEW)]: [
            (0, $65Uph.cardOpenDetailView)
        ],
        [(0, $6GNN7.CARDS_MOVE)]: [
            (0, $65Uph.cardRankRequestPerformance)
        ],
        [(0, $6GNN7.CARDS_MOVE_SUCCESS)]: [
            (0, $65Uph.cardsMoveSuccess)
        ],
        [(0, $6GNN7.CARDS_MOVE_FAILURE)]: [
            (0, $65Uph.cardsMoveFailure)
        ],
        [(0, $jkFPs.SPRINT_CREATE_REQUEST)]: [
            (0, $f9vTq.sprintCreateRequestPerformance)
        ],
        [(0, $jkFPs.SPRINT_CREATE_SUCCESS)]: [
            (0, $f9vTq.sprintCreateSuccess),
            (0, $f9vTq.sprintCreateSuccessPerformance)
        ],
        [(0, $jkFPs.SPRINT_CREATE_FAILURE)]: [
            (0, $f9vTq.sprintCreateFailure)
        ],
        [(0, $d09wv.SPRINT_DELETE_REQUEST)]: [
            (0, $f9vTq.sprintDeleteRequestPerformance)
        ],
        [(0, $d09wv.SPRINT_DELETE_SUCCESS)]: [
            (0, $f9vTq.sprintDeleteSuccessPerformance)
        ],
        [(0, $c0C8a.SPRINT_BOARD_LINK_CLICK_SUCCESS)]: (0, $6s1PB.expValEquals)('surface_origin_board_on_sprint_containers', 'cohort', 'test') ? [
            (0, $f9vTq.sprintOriginBoardClickSuccess)
        ] : [],
        [(0, $c0C8a.SPRINT_BOARD_LINK_CLICK_FAILURE)]: (0, $6s1PB.expValEquals)('surface_origin_board_on_sprint_containers', 'cohort', 'test') ? [
            (0, $f9vTq.sprintOriginBoardClickFailure)
        ] : [],
        [(0, $c0C8a.SPRINT_BOARD_LINK_CLICK_PERMISSIONLESS)]: (0, $6s1PB.expValEquals)('surface_origin_board_on_sprint_containers', 'cohort', 'test') ? [
            (0, $f9vTq.sprintOriginBoardClickPermissionless)
        ] : [],
        [(0, $4mqko.CARD_CLICK)]: [
            (0, $9kmfU.issueViewOpenPerformance)
        ],
        [(0, $8MHVw.FILTERED_CARD_SUCCESS)]: [
            (0, $lASqM.setCustomFiltersPerformance),
            (0, $lASqM.setCustomFiltersSuccess)
        ],
        [(0, $8MHVw.FILTERED_CARD_FAILURE)]: [
            (0, $lASqM.setCustomFiltersFailure)
        ],
        [(0, $8MHVw.REFILTER_SUCCESS)]: [
            (0, $lASqM.setCustomFiltersRefilterSuccess)
        ],
        [(0, $8MHVw.REFILTER_FAILURE)]: [
            (0, $lASqM.setCustomFiltersRefilterFailure)
        ],
        [(0, $8MHVw.FILTERED_CARD_CLEAR_SUCCESS)]: [
            (0, $lASqM.setClearCustomFiltersPerformance),
            (0, $lASqM.setClearCustomFiltersSuccess)
        ],
        [(0, $8MHVw.FILTERED_CARD_CLEAR_FAILURE)]: [
            (0, $lASqM.setClearCustomFiltersFailure)
        ],
        [(0, $aB8eX.BATCH)]: [
            (0, $iEYCH.setCardRequestIndividualResponse)
        ],
        [(0, $3lZ6i.LOAD_CARD_CREATE_CONFIG_SUCCESS)]: [
            (0, $1kERf.cardCreateConfigLoadSuccess)
        ],
        [(0, $3lZ6i.LOAD_CARD_CREATE_CONFIG_FAILURE)]: [
            (0, $1kERf.cardCreateConfigLoadFailure)
        ]
    });
var $922e25649c340829$export$2e2bcd8739ae039 = $922e25649c340829$var$actionAnalyticsMap;

});
parcelRegister("j0q3O", function(module, exports) {

$parcel$export(module.exports, "backlogView", () => $7ba94140e53271d3$export$4696f1f49cfb7d46);
$parcel$export(module.exports, "backlogLoadAppDataFailure", () => $7ba94140e53271d3$export$326068e951e3c300);
$parcel$export(module.exports, "backlogLoadConfigDataFailure", () => $7ba94140e53271d3$export$159273fe78e3d429);
$parcel$export(module.exports, "refreshDataRequest", () => $7ba94140e53271d3$export$7245a5bb55cf1c);
$parcel$export(module.exports, "backlogLoadConfigDataSuccess", () => $7ba94140e53271d3$export$3d70f256a15041c6);

var $hhweD = parcelRequire("hhweD");

var $8zOmE = parcelRequire("8zOmE");

var $6uzgj = parcelRequire("6uzgj");

var $a4XJc = parcelRequire("a4XJc");

var $8zmNw = parcelRequire("8zmNw");

var $h9NU3 = parcelRequire("h9NU3");

var $9MUCL = parcelRequire("9MUCL");

var $jG5HW = parcelRequire("jG5HW");

var $74oBv = parcelRequire("74oBv");

var $dGljH = parcelRequire("dGljH");

var $9Pc1U = parcelRequire("9Pc1U");

var $l89dM = parcelRequire("l89dM");
const $7ba94140e53271d3$export$4696f1f49cfb7d46 = (eventPrefix)=>(preState, state, action)=>{
        const numCards = Object.keys((0, $dGljH.getCards)(state)).length;
        const { analyticsEvent: analyticsEvent } = action.meta;
        const visibleCardIds = (0, $dGljH.getVisibleCardIds)(state);
        const orderedLabels = (0, $dGljH.getOrderedLabels)(state);
        const sprints = (0, $dGljH.getVisibleSprintCardLists)(state);
        const unscheduledSprints = sprints.filter((sprint)=>!sprint.sprintData?.startDate && !sprint.sprintData?.endDate);
        const isCompanyManaged = (0, $jG5HW.getIsCompanyManaged)(state);
        const boardId = Number((0, $jG5HW.getRapidViewId)(state));
        const isQuickFiltersBarToggled = (0, $8zmNw.getViewSettings)({
            boardId: boardId,
            view: (0, $a4XJc.View).BACKLOG
        })?.showQuickFilters;
        const cmpAttributes = isCompanyManaged && {
            isQuickFiltersBarToggled: isQuickFiltersBarToggled
        };
        const dueDateStats = {
            showDueDateViewSettings: (0, $dGljH.backlogHasDueDate)(state) && Boolean((0, $8zmNw.getViewSettings)({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG
            })?.showDueDate),
            numCardsWithDueDates: (0, $dGljH.getNumberOfCardsWithDueDates)(state)
        };
        const extra = {
            numCards: numCards,
            numSprints: sprints.length,
            numUnscheduledSprints: unscheduledSprints.length,
            hasFilteredIssues: visibleCardIds.length !== numCards,
            numLabels: orderedLabels.length,
            issueResultProjectIds: (0, $jG5HW.getProjectIds)(state),
            ...dueDateStats
        };
        const featureAttributes = (0, $6uzgj.getFeatureAnalyticsAttributes)((0, $9Pc1U.getAllFeatures)(state));
        (0, $hhweD.fireTrackAnalytics)(analyticsEvent, {
            action: 'viewed',
            attributes: {
                ...featureAttributes,
                isEpicPanelOpen: (0, $l89dM.getEpicPanel)(state),
                isVersionPanelOpen: (0, $h9NU3.isVersionPanelOpen)(),
                ...extra,
                ...cmpAttributes
            }
        });
        return {
            name: `${eventPrefix}.view`,
            data: {
                ...extra
            }
        };
    };
const $7ba94140e53271d3$export$326068e951e3c300 = (eventPrefix)=>()=>({
            name: `${eventPrefix}.load-app-data.failure`,
            data: {}
        });
const $7ba94140e53271d3$export$159273fe78e3d429 = (eventPrefix)=>()=>({
            name: `${eventPrefix}.load-config-data.failure`,
            data: {}
        });
const $7ba94140e53271d3$export$7245a5bb55cf1c = (eventPrefix)=>(preState, state, action, dependencies)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = dependencies || {};
        if (createAnalyticsEvent) (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'backlog refreshed', {
            ...(0, $9MUCL.getAttributes)(state),
            source: action.payload.source
        });
        return {
            name: `${eventPrefix}.refresh`,
            data: {
                source: action.payload.source
            }
        };
    };
const $7ba94140e53271d3$export$3d70f256a15041c6 = (eventPrefix)=>(preState, state)=>({
            name: `${eventPrefix}.load-config-data.success`,
            data: {
                numIssueTypes: (0, $74oBv.getBaseLevelCardTypes)(state).length
            }
        });

});
parcelRegister("6uzgj", function(module, exports) {

$parcel$export(module.exports, "getFeatureAnalyticsAttributes", () => $130d3cc5b8e064da$export$ac70e171fbeaebce);
const $130d3cc5b8e064da$export$4517b897375f940f = (key)=>`is_${key}_enabled`;
const $130d3cc5b8e064da$export$ac70e171fbeaebce = (allFeatures)=>{
    const result = {};
    allFeatures.forEach((feature)=>{
        result[$130d3cc5b8e064da$export$4517b897375f940f(feature.key)] = feature.status === 'ENABLED';
    });
    return result;
};

});

parcelRegister("a4XJc", function(module, exports) {

$parcel$export(module.exports, "View", () => $3338322e4425e825$export$27a5bd065ad55220);
$parcel$export(module.exports, "KeyboardShortcut", () => $3338322e4425e825$export$47a1bf8d9994c680);
$parcel$export(module.exports, "ExpandableState", () => $3338322e4425e825$export$d0f8c009a99b9c1b);
$parcel$export(module.exports, "ViewLocation", () => $3338322e4425e825$export$7ee1cf745baadfcd);
$parcel$export(module.exports, "ViewAs", () => $3338322e4425e825$export$70549c4aef7e1632);
$parcel$export(module.exports, "QUICK_FILTERS", () => $3338322e4425e825$export$59191afd909777e0);
$parcel$export(module.exports, "COMPACT_MODE", () => $3338322e4425e825$export$abd09d2531440e47);
$parcel$export(module.exports, "SHOW_EPICS", () => $3338322e4425e825$export$f3d7917d25ca2d13);
$parcel$export(module.exports, "SHOW_STATUSES", () => $3338322e4425e825$export$933792f2c41e7c51);
$parcel$export(module.exports, "SHOW_VERSIONS", () => $3338322e4425e825$export$fe0a5eeac8bdee53);
$parcel$export(module.exports, "SHOW_ISSUE_LINKS_STATS", () => $3338322e4425e825$export$889dbf130218e8b3);
$parcel$export(module.exports, "SHOW_ISSUE_KEY", () => $3338322e4425e825$export$f199de710b228934);
$parcel$export(module.exports, "SHOW_ISSUE_TYPE", () => $3338322e4425e825$export$e8f86e49139c6abb);
$parcel$export(module.exports, "SHOW_ESTIMATE", () => $3338322e4425e825$export$e1f60d3e74825af0);
$parcel$export(module.exports, "SHOW_PRIORITY", () => $3338322e4425e825$export$bcfd60da3302536e);
$parcel$export(module.exports, "SHOW_DEVELOPMENT", () => $3338322e4425e825$export$e7b5d3d062c615d5);
$parcel$export(module.exports, "SHOW_ASSIGNEE", () => $3338322e4425e825$export$3c14ba0cd46183b);
$parcel$export(module.exports, "SHOW_DAYS_IN_COLUMN", () => $3338322e4425e825$export$8224ffeed837235e);
$parcel$export(module.exports, "SHOW_DUE_DATE", () => $3338322e4425e825$export$770e28bfe2e0208d);
$parcel$export(module.exports, "SHOW_LABELS", () => $3338322e4425e825$export$63993996bfd99919);
$parcel$export(module.exports, "SHOW_CARD_COVERS", () => $3338322e4425e825$export$b811e8bce70dd7c2);
$parcel$export(module.exports, "SHOW_BOARD_NAME", () => $3338322e4425e825$export$658afd7e43f6b440);
$parcel$export(module.exports, "Panels", () => $3338322e4425e825$export$b94e9de8950563ef);
$parcel$export(module.exports, "IncrementPlanningSettings", () => $3338322e4425e825$export$ad46e765f851721f);
const $3338322e4425e825$export$27a5bd065ad55220 = {
    BACKLOG: 'jsw-backlog',
    BOARD: 'jsw-board',
    INCREMENT_PLANNING_BOARD: 'increment-planning-board',
    JSM_BOARD: 'jsm-board'
};
const $3338322e4425e825$export$47a1bf8d9994c680 = {
    ISSUE_PARENT_PANEL_SHORTCUT: 'E',
    VERSION_PANEL_SHORTCUT: 'V'
};
const $3338322e4425e825$export$d0f8c009a99b9c1b = {
    EXPANDED: 'expanded',
    COLLAPSED: 'collapsed'
};
const $3338322e4425e825$export$7ee1cf745baadfcd = {
    SIDEBAR: 'sidebar',
    MODAL: 'modal'
};
const $3338322e4425e825$export$70549c4aef7e1632 = {
    PANEL: 'Panel',
    POPUP: 'Popup'
};
const $3338322e4425e825$export$41073ac826c57195 = 'VERSION_PANEL';
const $3338322e4425e825$export$86bfe5c9d2cf6b7c = 'EPIC_PANEL';
const $3338322e4425e825$export$59191afd909777e0 = 'QUICK_FILTERS';
const $3338322e4425e825$export$abd09d2531440e47 = 'COMPACT_MODE';
const $3338322e4425e825$export$f3d7917d25ca2d13 = 'SHOW_EPICS';
const $3338322e4425e825$export$933792f2c41e7c51 = 'SHOW_STATUSES';
const $3338322e4425e825$export$fe0a5eeac8bdee53 = 'SHOW_VERSIONS';
const $3338322e4425e825$export$889dbf130218e8b3 = 'SHOW_ISSUE_LINKS_STATS';
const $3338322e4425e825$export$c3308fa11d994bc5 = 'SHOW_UNSCHEDULED_COLUMN';
const $3338322e4425e825$export$f199de710b228934 = 'SHOW_ISSUE_KEY';
const $3338322e4425e825$export$e8f86e49139c6abb = 'SHOW_ISSUE_TYPE';
const $3338322e4425e825$export$e1f60d3e74825af0 = 'SHOW_ESTIMATE';
const $3338322e4425e825$export$bcfd60da3302536e = 'SHOW_PRIORITY';
const $3338322e4425e825$export$e7b5d3d062c615d5 = 'SHOW_DEVELOPMENT';
const $3338322e4425e825$export$3c14ba0cd46183b = 'SHOW_ASSIGNEE';
const $3338322e4425e825$export$8224ffeed837235e = 'SHOW_DAYS_IN_COLUMN';
const $3338322e4425e825$export$770e28bfe2e0208d = 'SHOW_DUE_DATE';
const $3338322e4425e825$export$63993996bfd99919 = 'SHOW_LABELS';
const $3338322e4425e825$export$b811e8bce70dd7c2 = 'SHOW_CARD_COVERS';
const $3338322e4425e825$export$ecec86e489253c13 = 'SHOW_OFFTRACK_DEPENDENCY_LINES';
const $3338322e4425e825$export$79b3cada7e291288 = 'ISSUE_IDS_TO_SHOW_DEPENDENCIES';
const $3338322e4425e825$export$658afd7e43f6b440 = 'SHOW_BOARD_NAME';
const $3338322e4425e825$export$b94e9de8950563ef = {
    VERSION_PANEL: $3338322e4425e825$export$41073ac826c57195,
    EPIC_PANEL: $3338322e4425e825$export$86bfe5c9d2cf6b7c
};
const $3338322e4425e825$export$ad46e765f851721f = {
    SHOW_UNSCHEDULED_COLUMN: $3338322e4425e825$export$c3308fa11d994bc5,
    SHOW_OFFTRACK_DEPENDENCY_LINES: $3338322e4425e825$export$ecec86e489253c13,
    ISSUE_IDS_TO_SHOW_DEPENDENCIES: $3338322e4425e825$export$79b3cada7e291288
};

});

parcelRegister("8zmNw", function(module, exports) {

$parcel$export(module.exports, "getViewSettings", () => $a5d579bc47cfed7a$export$3ae70db4a97563c);
$parcel$export(module.exports, "setViewSettingsIsFullscreen", () => $a5d579bc47cfed7a$export$322210075289ef56);
$parcel$export(module.exports, "getViewSettingsIsFullscreen", () => $a5d579bc47cfed7a$export$d2c8042121049ae8);
$parcel$export(module.exports, "getViewSettingsPanels", () => $a5d579bc47cfed7a$export$d6a5a0d616fcec93);
$parcel$export(module.exports, "setViewSettings", () => $a5d579bc47cfed7a$export$99f2d9eb0b41b93);
$parcel$export(module.exports, "setViewSettingsPanels", () => $a5d579bc47cfed7a$export$427f126b21640252);
$parcel$export(module.exports, "getViewSettingsQuickFilters", () => $a5d579bc47cfed7a$export$18eb87e1feb49f18);
$parcel$export(module.exports, "setViewSettingsQuickFilters", () => $a5d579bc47cfed7a$export$60d0caf3b1c59159);
$parcel$export(module.exports, "getViewSettingsCompactMode", () => $a5d579bc47cfed7a$export$658ed39e1ffe75b);
$parcel$export(module.exports, "setViewSettingsCompactMode", () => $a5d579bc47cfed7a$export$9ca6e4490ca9b1fc);
$parcel$export(module.exports, "getViewSettingsCardDetails", () => $a5d579bc47cfed7a$export$a2a95ab43ea98277);
$parcel$export(module.exports, "setViewSettingsCardDetails", () => $a5d579bc47cfed7a$export$af2e5a35023755b5);
$parcel$export(module.exports, "getViewSettingsCardExtraFields", () => $a5d579bc47cfed7a$export$6a2173913af81755);
$parcel$export(module.exports, "setViewSettingsCardExtraFields", () => $a5d579bc47cfed7a$export$b54537ba70def946);
$parcel$export(module.exports, "setShowEpics", () => $a5d579bc47cfed7a$export$294c0e262bd1285a);
$parcel$export(module.exports, "setShowVersions", () => $a5d579bc47cfed7a$export$a3ab3e2c6a6189bd);
$parcel$export(module.exports, "setShowStatuses", () => $a5d579bc47cfed7a$export$e95c7c8d7cbf6350);
$parcel$export(module.exports, "setShowIssueLinksStats", () => $a5d579bc47cfed7a$export$163e0dded7eda9d9);
$parcel$export(module.exports, "setShowUnscheduledColumn", () => $a5d579bc47cfed7a$export$6edce735c6eb4cb0);
$parcel$export(module.exports, "getShowUnscheduledColumn", () => $a5d579bc47cfed7a$export$bf31a7b99f7bc62f);
$parcel$export(module.exports, "setShowDaysInColumn", () => $a5d579bc47cfed7a$export$68382c1a767b0133);
$parcel$export(module.exports, "setShowDueDate", () => $a5d579bc47cfed7a$export$13fed6c54275816a);
$parcel$export(module.exports, "setShowLabels", () => $a5d579bc47cfed7a$export$43aa76b69739d220);
$parcel$export(module.exports, "setExtraFields", () => $a5d579bc47cfed7a$export$b24e660e664a6bba);
$parcel$export(module.exports, "setShowOfftrackDependencyLines", () => $a5d579bc47cfed7a$export$2c48063cd4ef1ade);
$parcel$export(module.exports, "getShowOfftrackDependencyLines", () => $a5d579bc47cfed7a$export$32c01395d25dfdcc);
$parcel$export(module.exports, "setIssueIdsToShowDependencies", () => $a5d579bc47cfed7a$export$f7b68cb584e33d77);
$parcel$export(module.exports, "getIssueIdsToShowDependencies", () => $a5d579bc47cfed7a$export$67e6bba1326e537a);

var $bSSG7 = parcelRequire("bSSG7");

var $duOMW = parcelRequire("duOMW");

var $a4XJc = parcelRequire("a4XJc");

var $cYeCp = parcelRequire("cYeCp");
const $a5d579bc47cfed7a$var$browserLocalStorage = (0, $bSSG7.createLocalStorageProvider)((0, $duOMW.VIEW_SETTINGS_LOCAL_STORAGE));
const $a5d579bc47cfed7a$export$36e24695f02d4503 = (view)=>{
    if (view && view === (0, $a4XJc.View).INCREMENT_PLANNING_BOARD) return `${0, $duOMW.VIEW_SETTINGS}-${(0, $a4XJc.View).INCREMENT_PLANNING_BOARD}`;
    if ((0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)()) switch(view){
        case (0, $a4XJc.View).INCREMENT_PLANNING_BOARD:
            return `${0, $duOMW.VIEW_SETTINGS}-${(0, $a4XJc.View).INCREMENT_PLANNING_BOARD}`;
        case (0, $a4XJc.View).BACKLOG:
            return `${0, $duOMW.VIEW_SETTINGS}-${(0, $a4XJc.View).BACKLOG}`;
        case (0, $a4XJc.View).BOARD:
            return `${0, $duOMW.VIEW_SETTINGS}-${(0, $a4XJc.View).BOARD}`;
        case (0, $a4XJc.View).JSM_BOARD:
            return `${0, $duOMW.VIEW_SETTINGS}-${(0, $a4XJc.View).JSM_BOARD}`;
        default:
            return 0, $duOMW.VIEW_SETTINGS;
    }
    return 0, $duOMW.VIEW_SETTINGS;
};
const $a5d579bc47cfed7a$export$3ae70db4a97563c = ({ boardId: boardId, view: view })=>$a5d579bc47cfed7a$var$browserLocalStorage.get(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`) || $a5d579bc47cfed7a$var$browserLocalStorage.get(`${(0, $duOMW.VIEW_SETTINGS)}-${boardId}`); // return legacy view settings if prefixed storage doesn't exist
const $a5d579bc47cfed7a$export$322210075289ef56 = ({ boardId: boardId, isFullscreen: isFullscreen, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        isFullscreen: isFullscreen
    });
};
const $a5d579bc47cfed7a$export$d2c8042121049ae8 = ({ boardId: boardId, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    return state?.isFullscreen ?? (0, $duOMW.initialState).isFullscreen;
};
const $a5d579bc47cfed7a$export$d6a5a0d616fcec93 = ({ boardId: boardId, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    return {
        EPIC_PANEL: state?.showEpicPanel ?? (0, $duOMW.initialState).showEpicPanel,
        VERSION_PANEL: state?.showVersionPanel ?? (0, $duOMW.initialState).showVersionPanel
    };
};
const $a5d579bc47cfed7a$export$99f2d9eb0b41b93 = ({ boardId: boardId, state: state, view: view })=>$a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, state);
const $a5d579bc47cfed7a$export$427f126b21640252 = ({ boardId: boardId, panelState: panelState, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showEpicPanel: panelState.EPIC_PANEL,
        showVersionPanel: panelState.VERSION_PANEL
    });
};
const $a5d579bc47cfed7a$export$7a001fa75693814b = ({ boardId: boardId, panel: panel, show: show, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    if (panel === (0, $a4XJc.Panels).EPIC_PANEL) $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showEpicPanel: show
    });
    if (panel === (0, $a4XJc.Panels).VERSION_PANEL) $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showVersionPanel: show
    });
};
const $a5d579bc47cfed7a$export$18eb87e1feb49f18 = ({ boardId: boardId, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    return state?.showQuickFilters ?? (0, $duOMW.initialState).showQuickFilters;
};
const $a5d579bc47cfed7a$export$60d0caf3b1c59159 = ({ boardId: boardId, showQuickFilters: showQuickFilters, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showQuickFilters: showQuickFilters
    });
};
const $a5d579bc47cfed7a$export$658ed39e1ffe75b = ({ boardId: boardId, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    return state?.showCompactMode ?? (0, $duOMW.initialState).showCompactMode;
};
const $a5d579bc47cfed7a$export$9ca6e4490ca9b1fc = ({ boardId: boardId, showCompactMode: showCompactMode, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showCompactMode: showCompactMode
    });
};
const $a5d579bc47cfed7a$export$a2a95ab43ea98277 = ({ boardId: boardId, view: view, isDaysInColumnEnabled: isDaysInColumnEnabled, isDueDateEnabled: isDueDateEnabled, isLabelsEnabled: isLabelsEnabled, isEstimateEnabled: isEstimateEnabled, isPriorityEnabled: isPriorityEnabled })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    return {
        SHOW_EPICS: state?.showEpics ?? (0, $duOMW.initialState).showEpics,
        SHOW_STATUSES: state?.showStatuses ?? (0, $duOMW.initialState).showStatuses,
        SHOW_VERSIONS: state?.showVersions ?? (0, $duOMW.initialState).showVersions,
        SHOW_ISSUE_LINKS_STATS: state?.showIssueLinksStats ?? (0, $duOMW.initialState).showIssueLinksStats,
        SHOW_ISSUE_KEY: state?.showIssueKey ?? (0, $duOMW.initialState).showIssueKey,
        SHOW_ISSUE_TYPE: state?.showIssueType ?? (0, $duOMW.initialState).showIssueType,
        SHOW_ASSIGNEE: state?.showAssignee ?? (0, $duOMW.initialState).showAssignee,
        SHOW_PRIORITY: (isPriorityEnabled ? state?.showPriority : (0, $duOMW.initialState).showPriority) ?? (0, $duOMW.initialState).showPriority,
        SHOW_DEVELOPMENT: state?.showDevelopment ?? (0, $duOMW.initialState).showDevelopment,
        SHOW_ESTIMATE: (isEstimateEnabled ? state?.showEstimate : (0, $duOMW.initialState).showEstimate) ?? (0, $duOMW.initialState).showEstimate,
        SHOW_DAYS_IN_COLUMN: (isDaysInColumnEnabled ? state?.showDaysInColumn : (0, $duOMW.initialState).showDaysInColumn) ?? (0, $duOMW.initialState).showDaysInColumn,
        SHOW_DUE_DATE: (isDueDateEnabled ? state?.showDueDate : (0, $duOMW.initialState).showDueDate) ?? (0, $duOMW.initialState).showDueDate,
        SHOW_LABELS: (isLabelsEnabled ? state?.showLabels : (0, $duOMW.initialState).showLabels) ?? (0, $duOMW.initialState).showLabels,
        SHOW_CARD_COVERS: state?.showCardCovers ?? (0, $duOMW.initialState).showCardCovers,
        SHOW_BOARD_NAME: state?.showBoardName ?? (0, $duOMW.initialState).showBoardName
    };
};
const $a5d579bc47cfed7a$export$af2e5a35023755b5 = ({ boardId: boardId, cardDetailsState: cardDetailsState, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showEpics: cardDetailsState.SHOW_EPICS,
        showStatuses: cardDetailsState.SHOW_STATUSES,
        showVersions: cardDetailsState.SHOW_VERSIONS,
        showDaysInColumn: cardDetailsState.SHOW_DAYS_IN_COLUMN,
        showEstimate: cardDetailsState.SHOW_ESTIMATE,
        showIssueLinksStats: cardDetailsState.SHOW_ISSUE_LINKS_STATS,
        showIssueKey: cardDetailsState.SHOW_ISSUE_KEY,
        showIssueType: cardDetailsState.SHOW_ISSUE_TYPE,
        showAssignee: cardDetailsState.SHOW_ASSIGNEE,
        showPriority: cardDetailsState.SHOW_PRIORITY,
        showDevelopment: cardDetailsState.SHOW_DEVELOPMENT,
        showDueDate: cardDetailsState.SHOW_DUE_DATE,
        showLabels: cardDetailsState.SHOW_LABELS,
        showCardCovers: cardDetailsState.SHOW_CARD_COVERS,
        showBoardName: cardDetailsState.SHOW_BOARD_NAME
    });
};
const $a5d579bc47cfed7a$export$6a2173913af81755 = ({ boardId: boardId, view: view, cardExtraFields: cardExtraFields })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    return cardExtraFields.reduce((acc, field)=>{
        acc[field.id] = state?.cardExtraFields?.[field.id] ?? true;
        return acc;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    }, {});
};
const $a5d579bc47cfed7a$export$b54537ba70def946 = ({ boardId: boardId, cardExtraFieldsState: cardExtraFieldsState, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        cardExtraFields: cardExtraFieldsState
    });
};
const $a5d579bc47cfed7a$export$294c0e262bd1285a = ({ boardId: boardId, showEpics: showEpics, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showEpics: showEpics
    });
};
const $a5d579bc47cfed7a$export$a3ab3e2c6a6189bd = ({ boardId: boardId, showVersions: showVersions, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showVersions: showVersions
    });
};
const $a5d579bc47cfed7a$export$e95c7c8d7cbf6350 = ({ boardId: boardId, showStatuses: showStatuses, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showStatuses: showStatuses
    });
};
const $a5d579bc47cfed7a$export$163e0dded7eda9d9 = ({ boardId: boardId, showIssueLinksStats: showIssueLinksStats, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showIssueLinksStats: showIssueLinksStats
    });
};
const $a5d579bc47cfed7a$export$6edce735c6eb4cb0 = ({ boardId: boardId, showUnscheduledColumn: showUnscheduledColumn })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503((0, $a4XJc.View).INCREMENT_PLANNING_BOARD)}-${boardId}`, {
        ...state,
        showUnscheduledColumn: showUnscheduledColumn
    });
};
const $a5d579bc47cfed7a$export$bf31a7b99f7bc62f = (boardId)=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD
    });
    return state?.showUnscheduledColumn ?? (0, $duOMW.initialState).showUnscheduledColumn;
};
const $a5d579bc47cfed7a$export$68382c1a767b0133 = ({ boardId: boardId, showDaysInColumn: showDaysInColumn, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showDaysInColumn: showDaysInColumn
    });
};
const $a5d579bc47cfed7a$export$13fed6c54275816a = ({ boardId: boardId, showDueDate: showDueDate, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showDueDate: showDueDate
    });
};
const $a5d579bc47cfed7a$export$43aa76b69739d220 = ({ boardId: boardId, showLabels: showLabels, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showLabels: showLabels
    });
};
const $a5d579bc47cfed7a$export$b24e660e664a6bba = ({ boardId: boardId, cardExtraFields: cardExtraFields, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        cardExtraFields: cardExtraFields
    });
};
const $a5d579bc47cfed7a$export$90df0703e41f9b = ({ boardId: boardId, showCardCovers: showCardCovers, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showCardCovers: showCardCovers
    });
};
const $a5d579bc47cfed7a$export$2c48063cd4ef1ade = ({ boardId: boardId, showOfftrackDependencyLines: showOfftrackDependencyLines })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503((0, $a4XJc.View).INCREMENT_PLANNING_BOARD)}-${boardId}`, {
        ...state,
        showOfftrackDependencyLines: showOfftrackDependencyLines
    });
};
const $a5d579bc47cfed7a$export$32c01395d25dfdcc = (boardId)=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD
    });
    return state?.showOfftrackDependencyLines ?? (0, $duOMW.initialState).showOfftrackDependencyLines;
};
const $a5d579bc47cfed7a$export$f7b68cb584e33d77 = ({ boardId: boardId, issueIds: issueIds })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503((0, $a4XJc.View).INCREMENT_PLANNING_BOARD)}-${boardId}`, {
        ...state,
        issueIdsToShowDependencies: issueIds
    });
};
const $a5d579bc47cfed7a$export$67e6bba1326e537a = (boardId)=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD
    });
    return state?.issueIdsToShowDependencies ?? (0, $duOMW.initialState).issueIdsToShowDependencies;
};

});
parcelRegister("duOMW", function(module, exports) {

$parcel$export(module.exports, "VIEW_SETTINGS", () => $6350b42865dc529c$export$f900da9acbf1ac33);
$parcel$export(module.exports, "VIEW_SETTINGS_LOCAL_STORAGE", () => $6350b42865dc529c$export$752f3d44db2fbd2d);
$parcel$export(module.exports, "initialState", () => $6350b42865dc529c$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "boardViewTestIds", () => $6350b42865dc529c$export$9cf6a064d9c55597);
$parcel$export(module.exports, "backlogViewTestIds", () => $6350b42865dc529c$export$af828cca0407ed81);
$parcel$export(module.exports, "VIEW_SETTINGS_PANEL_CLOSE_BUTTON_TEST_ID", () => $6350b42865dc529c$export$b954e2c30216a1e9);
$parcel$export(module.exports, "VIEW_SETTINGS_BUTTON_LG", () => $6350b42865dc529c$export$20070c180403c06a);
$parcel$export(module.exports, "VIEW_SETTINGS_BUTTON_SM", () => $6350b42865dc529c$export$563c80e8ea5620c4);
$parcel$export(module.exports, "VIEW_SETTINGS_BUTTON_RESPONSIVE", () => $6350b42865dc529c$export$3895498dfef21366);
$parcel$export(module.exports, "QUERY_ENABLED_VALUE", () => $6350b42865dc529c$export$c0d46007b8549aca);
const $6350b42865dc529c$export$f900da9acbf1ac33 = 'view-settings';
const $6350b42865dc529c$export$752f3d44db2fbd2d = 'jira-software-view-settings';
const $6350b42865dc529c$export$d4c72bab9d6cc13a = {
    view: null,
    isFullscreen: false,
    showEpicPanel: false,
    showVersionPanel: false,
    showQuickFilters: false,
    showEpics: true,
    showStatuses: true,
    showVersions: true,
    showCompactMode: false,
    showUnscheduledColumn: true,
    showIssueLinksStats: false,
    showIssueKey: true,
    showIssueType: true,
    showEstimate: true,
    showAssignee: true,
    showPriority: true,
    showDevelopment: true,
    showDaysInColumn: true,
    showDueDate: true,
    showLabels: true,
    showCardCovers: true,
    showOfftrackDependencyLines: true,
    showBoardName: true,
    issueIdsToShowDependencies: [],
    cardExtraFields: {}
};
const $6350b42865dc529c$export$9cf6a064d9c55597 = {
    viewSettingsBoardMenu: 'software-view-settings.ui.view-settings-menu.menu-board',
    openIssuesInSidebarToggle: 'software-view-settings.ui.view-settings-menu.views.board.open-issues-in-sidebar',
    showQuickFiltersToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-quick-filters-toggle',
    showWorkSuggestionsToggle: 'software-view-settings.ui.view-settings-menu.views.board.work-suggestions-toggle',
    swimlaneExpandAll: 'software-view-settings.ui.view-settings-menu.views.board.expand-all',
    swimlaneCollapseAll: 'software-view-settings.ui.view-settings-menu.views.board.collapse-all',
    cardDetailsSection: 'software-view-settings.ui.view-settings-menu.views.board.card-details-board',
    showIssueTypeToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-issue-type-toggle-board',
    showIssueKeyToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-issue-key-toggle-board',
    showEpicsToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-epics-toggle-board',
    showDueDateToggle: 'software-view-settings.ui.view-settings-menu.views.board.due-date-toggle-board',
    showLabelsToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-labels-toggle-board',
    showEstimateToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-estimate-toggle-board',
    showDaysInColumnToggle: 'software-view-settings.ui.view-settings-menu.views.board.days-in-column-toggle-board',
    showLinkedIssueStatsToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-linked-issue-stats-toggle-board',
    showCardCoversToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-card-covers-toggle-board',
    showPriorityToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-priority-toggle-board',
    showDevelopmentToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-development-toggle-board',
    showAssigneeToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-assignee-toggle-board',
    customFieldsSection: 'software-view-settings.ui.view-settings-menu.views.board.custom-fields-board'
};
const $6350b42865dc529c$export$af828cca0407ed81 = {
    showVersionPanelToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-version-panel-toggle',
    showEpicPanelToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-epic-panel-toggle',
    showQuickFiltersToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-quick-filters-toggle',
    cardLayoutSection: 'software-view-settings.view-settings-menu.card-layout',
    cardLayoutRadioGroup: 'software-view-settings.ui.view-settings-menu.views.backlog.card-layout',
    showCompactModeToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-compact-mode-toggle',
    subtaskSection: 'software-view-settings.view-settings-menu.subtasks',
    subtaskExpandAll: 'software-view-settings.ui.view-settings-menu.views.backlog.expand-all-subtasks',
    subtaskCollapseAll: 'software-view-settings.ui.view-settings-menu.views.backlog.collapse-all-subtasks',
    cardDetailsSection: 'software-view-settings.ui.view-settings-menu.views.backlog.card-details-backlog',
    showIssueTypeToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-issue-type-toggle-backlog',
    showIssueKeyToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-issue-key-toggle-backlog',
    showVersionsToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-versions-toggle-backlog',
    showEpicsToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-epics-toggle-backlog',
    showDueDateToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.due-date-toggle-backlog',
    showStatusToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-statuses-toggle-backlog',
    showEstimateToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-estimate-toggle-backlog',
    showPriorityToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-priority-toggle-backlog',
    showAssigneeToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-assignee-toggle-backlog',
    customFieldsSection: 'software-view-settings.ui.view-settings-menu.views.backlog.custom-fields-backlog',
    showBoardNameToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-board-name-toggle-backlog'
};
const $6350b42865dc529c$export$b954e2c30216a1e9 = 'view-settings.ui.panel.header.close-button';
const $6350b42865dc529c$export$20070c180403c06a = 'view-settings-show-button.ui.view-settings-button-large';
const $6350b42865dc529c$export$563c80e8ea5620c4 = 'view-settings-show-button.ui.view-settings-button-small';
const $6350b42865dc529c$export$3895498dfef21366 = 'view-settings-show-button.ui.view-settings-button-responsive';
const $6350b42865dc529c$export$c0d46007b8549aca = 'on';
const $6350b42865dc529c$export$788a94e8107fb947 = 'off';

});

parcelRegister("cYeCp", function(module, exports) {

$parcel$export(module.exports, "parseSearchQuery", () => $e84c24ee8b7a736a$export$6298490de4ddc3eb);
$parcel$export(module.exports, "setPanels", () => $e84c24ee8b7a736a$export$d89c07c704083e54);
$parcel$export(module.exports, "parseSearchQueryForIPBoard", () => $e84c24ee8b7a736a$export$442a6f7c9ee1c18a);
$parcel$export(module.exports, "setIncrementPlanningSettingsQuery", () => $e84c24ee8b7a736a$export$8bc567645273ba46);
$parcel$export(module.exports, "isViewSettingsPanelAndTailoredViewExperimentEnabled", () => $e84c24ee8b7a736a$export$eed360eb853808ee);

var $7uUwQ = parcelRequire("7uUwQ");

var $ebyGx = parcelRequire("ebyGx");

var $4R6GH = parcelRequire("4R6GH");

const $e84c24ee8b7a736a$export$6298490de4ddc3eb = (search)=>{
    const searchParams = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(search);
    return {
        EPIC_PANEL: searchParams[0, $2634c0a33984ecbe$export$ec3c43b997309252] === 'visible',
        VERSION_PANEL: searchParams[0, $2634c0a33984ecbe$export$a86c1a6dde9da34f] === 'visible'
    };
};
const $e84c24ee8b7a736a$export$d89c07c704083e54 = (panels, location)=>{
    const search = (0, $7uUwQ.chain)({
        ...(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(location.search)
    });
    search.unset((0, $2634c0a33984ecbe$export$ec3c43b997309252));
    search.unset((0, $2634c0a33984ecbe$export$a86c1a6dde9da34f));
    if (panels.EPIC_PANEL) search.set((0, $2634c0a33984ecbe$export$ec3c43b997309252), 'visible');
    if (panels.VERSION_PANEL) search.set((0, $2634c0a33984ecbe$export$a86c1a6dde9da34f), 'visible');
    return {
        ...location,
        search: (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(search.value())
    };
};
const $e84c24ee8b7a736a$export$442a6f7c9ee1c18a = (search)=>{
    const searchParams = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(search);
    const issuesQuery = searchParams[0, $2634c0a33984ecbe$export$1692762d83d78f09] ? decodeURIComponent(searchParams[0, $2634c0a33984ecbe$export$1692762d83d78f09]) : undefined;
    const issuesSplit = issuesQuery ? issuesQuery.split(',') : [];
    const issueIdsToShowDependencies = [];
    issuesSplit.forEach((issueId)=>{
        const trimmedIssueId = issueId.trim();
        if (trimmedIssueId.length) issueIdsToShowDependencies.push(trimmedIssueId);
    });
    return {
        SHOW_UNSCHEDULED_COLUMN: searchParams[0, $2634c0a33984ecbe$export$bfa26a3d2f080ac5] === 'hidden' ? false : undefined,
        SHOW_OFFTRACK_DEPENDENCY_LINES: searchParams[0, $2634c0a33984ecbe$export$8b0819c4fa234ad] === 'hidden' ? false : undefined,
        ISSUE_IDS_TO_SHOW_DEPENDENCIES: issueIdsToShowDependencies
    };
};
const $e84c24ee8b7a736a$export$8bc567645273ba46 = (incrementPlanningSettings, location)=>{
    const search = (0, $7uUwQ.chain)({
        ...(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(location.search)
    });
    search.unset((0, $2634c0a33984ecbe$export$bfa26a3d2f080ac5));
    if (!incrementPlanningSettings.SHOW_UNSCHEDULED_COLUMN) search.set((0, $2634c0a33984ecbe$export$bfa26a3d2f080ac5), 'hidden');
    search.unset((0, $2634c0a33984ecbe$export$8b0819c4fa234ad));
    search.unset((0, $2634c0a33984ecbe$export$1692762d83d78f09));
    if (!incrementPlanningSettings.SHOW_OFFTRACK_DEPENDENCY_LINES) search.set((0, $2634c0a33984ecbe$export$8b0819c4fa234ad), 'hidden');
    if (incrementPlanningSettings.ISSUE_IDS_TO_SHOW_DEPENDENCIES && incrementPlanningSettings.ISSUE_IDS_TO_SHOW_DEPENDENCIES.length) search.set((0, $2634c0a33984ecbe$export$1692762d83d78f09), encodeURIComponent(incrementPlanningSettings.ISSUE_IDS_TO_SHOW_DEPENDENCIES.toString()));
    return {
        ...location,
        search: (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(search.value())
    };
};
const $e84c24ee8b7a736a$export$eed360eb853808ee = ()=>(0, $4R6GH.fg)('jira_view_settings_additional_fields');

});
const $2634c0a33984ecbe$export$ec3c43b997309252 = 'epics';
const $2634c0a33984ecbe$export$a86c1a6dde9da34f = 'versions';
const $2634c0a33984ecbe$export$bfa26a3d2f080ac5 = 'unscheduledWork';
const $2634c0a33984ecbe$export$8b0819c4fa234ad = 'showOfftrackDependencyLines';
const $2634c0a33984ecbe$export$1692762d83d78f09 = 'issueIdsToShowDependencies';



parcelRegister("9MUCL", function(module, exports) {

$parcel$export(module.exports, "getAttributes", () => $2e8c6c3e19cea0f9$export$fe94072fee8a6976);

var $2vSU6 = parcelRequire("2vSU6");

var $6s1PB = parcelRequire("6s1PB");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $45Qwd = parcelRequire("45Qwd");

var $1z1J7 = parcelRequire("1z1J7");

var $k35me = parcelRequire("k35me");
const $2e8c6c3e19cea0f9$export$fe94072fee8a6976 = (state)=>({
        /*
	 * isIssueDetailVisible prop is being equated with it showing in the future
	 *  because the backlog screen event is fired before the issue details
	 *  actually show, but it showing is conditional on there being a last
	 *  selected issue key
	 */ isIssueDetailVisible: (0, $dGljH.willDetailViewShow)(state),
        boardType: (0, $jG5HW.getBoardType)(state),
        projectType: (0, $2vSU6.SOFTWARE_PROJECT),
        boardId: (0, $jG5HW.getRapidViewId)(state),
        projectId: (0, $jG5HW.projectIdSelector)(state),
        isReactifiedBacklog: true,
        numSubtasks: (0, $dGljH.numTotalIssueChildren)(state),
        numCompleteSubtasks: (0, $dGljH.numCompleteIssueChildren)(state),
        numCrossBoardSprints: (0, $6s1PB.expValEquals)('surface_origin_board_on_sprint_containers', 'cohort', 'test') ? (0, $k35me.numCrossBoardSprints)(state) : 0,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        isInactiveTab: document.hidden,
        estimationStatistic: (0, $45Qwd.getEstimationType)(state),
        isProjectAdmin: (0, $1z1J7.canEditBoardConfig)(state),
        isUIF: true,
        isClassic: (0, $jG5HW.getIsCompanyManaged)(state)
    });

});


parcelRegister("36SBa", function(module, exports) {

$parcel$export(module.exports, "boardIssueMoveShow", () => $220ff2145410d5b4$export$afe8c48481994c25);
$parcel$export(module.exports, "boardIssueMoveCancel", () => $220ff2145410d5b4$export$21c319cd4bbf2b2f);
$parcel$export(module.exports, "boardIssueMoveExecute", () => $220ff2145410d5b4$export$47de1859c695eca7);
$parcel$export(module.exports, "boardIssueMoveExecuteSuccess", () => $220ff2145410d5b4$export$403d172f0e549eb1);
$parcel$export(module.exports, "boardIssueMoveExecuteFailure", () => $220ff2145410d5b4$export$3c31c79b76c3db3b);
const $220ff2145410d5b4$export$afe8c48481994c25 = (eventPrefix)=>()=>({
            name: `${eventPrefix}.board-issue-move.show`
        });
const $220ff2145410d5b4$export$21c319cd4bbf2b2f = (eventPrefix)=>()=>({
            name: `${eventPrefix}.board-issue-move.cancel`
        });
const $220ff2145410d5b4$export$47de1859c695eca7 = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.board-issue-move.execute`,
            data: {
                transactionId: action.meta.optimistic.id
            }
        });
const $220ff2145410d5b4$export$403d172f0e549eb1 = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.board-issue-move.execute.success`,
            data: {
                transactionId: action.meta.optimistic.id
            }
        });
const $220ff2145410d5b4$export$3c31c79b76c3db3b = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.board-issue-move.execute.failure`,
            data: {
                transactionId: action.meta.optimistic.id
            }
        });

});

parcelRegister("iEYCH", function(module, exports) {

$parcel$export(module.exports, "setCardRequestIndividualResponse", () => $da7cf263c2da6fe9$export$b8a62aa106707ded);

var $8zOmE = parcelRequire("8zOmE");

var $js96S = parcelRequire("js96S");
const $da7cf263c2da6fe9$export$b8a62aa106707ded = (eventPrefix)=>(preState, state, action)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const successActions = action.payload.filter((innerAction)=>innerAction.type === (0, $js96S.CARD_SET_INDIVIDUAL_REQUEST_SUCCESS));
        const commonAttributes = {
            isContextualEditing: true
        };
        if (successActions.length) (0, $8zOmE.fireTrackAnalytics)(successActions[0].meta.analyticsEvent, 'field updated', commonAttributes);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const failureActions = action.payload.filter((innerAction)=>innerAction.type === (0, $js96S.CARD_SET_INDIVIDUAL_REQUEST_FAILURE));
        if (failureActions.length) (0, $8zOmE.fireOperationalAnalytics)(failureActions[0].meta.analyticsEvent, 'field updateFailed', {
            ...commonAttributes,
            successCount: successActions.length,
            failureCount: failureActions.length,
            statusCode: failureActions[0].payload.statusCode
        });
        return {
            name: `${eventPrefix}.set-card-request.execute-individual.response`
        };
    };

});

parcelRegister("65Uph", function(module, exports) {

$parcel$export(module.exports, "cardCreateSuccess", () => $3895e17f29bd590b$export$b70c18d8546382b2);
$parcel$export(module.exports, "cardCreateFailure", () => $3895e17f29bd590b$export$151deebc0c103b3c);
$parcel$export(module.exports, "cardCreateFiltered", () => $3895e17f29bd590b$export$f069b59557af9611);
$parcel$export(module.exports, "cardCreateFilteredV2", () => $3895e17f29bd590b$export$f1c368b5cfb9b941);
$parcel$export(module.exports, "cardDeleteSuccess", () => $3895e17f29bd590b$export$abf29851b85a5dc);
$parcel$export(module.exports, "cardDeleteFailure", () => $3895e17f29bd590b$export$14995a1d9fdd27aa);
$parcel$export(module.exports, "cardsFlagSuccess", () => $3895e17f29bd590b$export$656497d228a51fa0);
$parcel$export(module.exports, "cardsFlagFailure", () => $3895e17f29bd590b$export$a54ef1c368494a58);
$parcel$export(module.exports, "cardOpenDetailView", () => $3895e17f29bd590b$export$acfe54087abfec17);
$parcel$export(module.exports, "cardCreateMultipleRequestPerformance", () => $3895e17f29bd590b$export$13e8b731273e5b62);
$parcel$export(module.exports, "cardCreateSuccessPerformance", () => $3895e17f29bd590b$export$496eebfe0f44eeed);
$parcel$export(module.exports, "cardRankRequestPerformance", () => $3895e17f29bd590b$export$195ac2f6e1a95c77);
$parcel$export(module.exports, "cardDeleteRequestPerformance", () => $3895e17f29bd590b$export$d3ff2e6ac38e63d6);
$parcel$export(module.exports, "cardsMoveSuccess", () => $3895e17f29bd590b$export$d9bd27fc2155921d);
$parcel$export(module.exports, "cardsMoveFailure", () => $3895e17f29bd590b$export$418f4abeb5fa5e63);
$parcel$export(module.exports, "cardsFlagRequestPerformance", () => $3895e17f29bd590b$export$dc3005aa374f7956);
$parcel$export(module.exports, "cardsParentSetSuccess", () => $3895e17f29bd590b$export$30fe913aeacc7d4c);
$parcel$export(module.exports, "cardsParentSetFailure", () => $3895e17f29bd590b$export$24c3df942a1f1dd5);

var $9XE6b = parcelRequire("9XE6b");

var $k12ix = parcelRequire("k12ix");

var $8zOmE = parcelRequire("8zOmE");

var $4G04L = parcelRequire("4G04L");

var $f01qr = parcelRequire("f01qr");


var $gZhS0 = parcelRequire("gZhS0");

var $8hVbJ = parcelRequire("8hVbJ");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $l9VFH = parcelRequire("l9VFH");

var $k35me = parcelRequire("k35me");
const $3895e17f29bd590b$export$d516175c274e4e4b = (cardId, issueTypeId, createdWithRank)=>({
        actionSubjectId: cardId,
        objectType: 'issue',
        objectId: cardId,
        issueTypeId: issueTypeId,
        createdWithRank: createdWithRank
    });
const $3895e17f29bd590b$export$b70c18d8546382b2 = (eventPrefix)=>(preState, state, action)=>{
        const filterValues = (0, $l9VFH.getFilters)(state);
        // There is only ever at most 1 text filter
        const textFilter = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filterValues, [
            (0, $41ce9b5576b92b7a$export$d597759d33be802e),
            'length'
        ], 0) > 0;
        const numAssigneeFilters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filterValues, [
            (0, $41ce9b5576b92b7a$export$f8f7545d2bb78afb),
            'length'
        ], 0);
        const numLabelFilters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filterValues, [
            (0, $41ce9b5576b92b7a$export$37aee82a3cb1e8f7),
            'length'
        ], 0);
        const cardId = action.payload.card.id;
        const issueTypeId = action.payload.card.typeId;
        const { createdWithRank: createdWithRank } = action.payload;
        const { meta: { analyticsEvent: analyticsEvent } } = action;
        const trackEvents = [];
        const event = analyticsEvent?.clone();
        if (event != null) trackEvents.push(event.update({
            ...$3895e17f29bd590b$export$d516175c274e4e4b(cardId, issueTypeId, createdWithRank),
            appliedFilters: Object.keys(filterValues),
            card: action.payload.card
        }));
        return {
            name: `${eventPrefix}.card.create.success`,
            data: {
                cardId: cardId,
                issueTypeId: issueTypeId,
                transactionId: action.meta.optimistic.id,
                textFilter: textFilter,
                numAssigneeFilters: numAssigneeFilters,
                numLabelFilters: numLabelFilters
            },
            trackEvents: trackEvents
        };
    };
const $3895e17f29bd590b$export$151deebc0c103b3c = (eventPrefix)=>(preState, state, action)=>{
        const { meta: { analyticsEvent: analyticsEvent }, payload: { errorMessage: errorMessage, statusCode: statusCode, numCards: numCards, isClientFetchError: isClientFetchError } } = action;
        const isCompanyManaged = (0, $jG5HW.getIsCompanyManaged)(state);
        if (analyticsEvent) for(let i = 0; i < numCards; i += 1){
            const clonedAnalyticsEvent = analyticsEvent.clone();
            // Will be null if it's already been fired
            if (clonedAnalyticsEvent) (0, $8zOmE.fireOperationalAnalytics)(clonedAnalyticsEvent, 'issue createdFailed', {
                errorMessage: errorMessage,
                isClientFetchError: isClientFetchError,
                statusCode: statusCode,
                isCompanyManaged: isCompanyManaged
            });
        }
        return {
            name: `${eventPrefix}.card.create.failure`,
            data: {
                transactionId: action.meta.optimistic.id,
                isCompanyManaged: isCompanyManaged
            }
        };
    };
const $3895e17f29bd590b$export$f069b59557af9611 = (eventPrefix)=>(preState, state, action)=>{
        const card = action.payload;
        const filterValues = (0, $l9VFH.getFilters)(state);
        // There is only ever at most 1 text filter
        const textFilter = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filterValues, [
            (0, $41ce9b5576b92b7a$export$d597759d33be802e),
            'length'
        ], 0) > 0;
        const numAssigneeFilters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filterValues, [
            (0, $41ce9b5576b92b7a$export$f8f7545d2bb78afb),
            'length'
        ], 0);
        const numLabelFilters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filterValues, [
            (0, $41ce9b5576b92b7a$export$37aee82a3cb1e8f7),
            'length'
        ], 0);
        return {
            name: `${eventPrefix}.filter.flag.new-card-filtered.shown`,
            data: {
                cardId: card.id,
                textFilter: textFilter,
                numAssigneeFilters: numAssigneeFilters,
                numLabelFilters: numLabelFilters
            }
        };
    };
const $3895e17f29bd590b$export$f1c368b5cfb9b941 = (eventPrefix)=>(preState, state, action)=>{
        const cardIds = action.payload;
        const filterValues = (0, $l9VFH.getFilters)(state);
        // There is only ever at most 1 text filter
        const textFilter = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filterValues, [
            (0, $41ce9b5576b92b7a$export$d597759d33be802e),
            'length'
        ], 0) > 0;
        const numAssigneeFilters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filterValues, [
            (0, $41ce9b5576b92b7a$export$f8f7545d2bb78afb),
            'length'
        ], 0);
        const numLabelFilters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filterValues, [
            (0, $41ce9b5576b92b7a$export$37aee82a3cb1e8f7),
            'length'
        ], 0);
        return {
            name: `${eventPrefix}.filter.flag.new-card-filtered.shown`,
            data: {
                cardIds: cardIds,
                textFilter: textFilter,
                numAssigneeFilters: numAssigneeFilters,
                numLabelFilters: numLabelFilters
            }
        };
    };
const $3895e17f29bd590b$export$abf29851b85a5dc = (eventPrefix)=>(preState, state, action)=>{
        const concurrentId = action.meta.optimistic.id;
        (0, $8hVbJ.issueDeleteInteraction)(concurrentId).stop({
            customData: {
                ...(0, $gZhS0.getBacklogCardCount)(state)
            }
        });
        return {
            name: `${eventPrefix}.card.delete.success`,
            data: {
                cardId: action.payload.cardId
            }
        };
    };
const $3895e17f29bd590b$export$14995a1d9fdd27aa = (eventPrefix)=>(preState, state, action)=>{
        const concurrentId = action.meta.optimistic.id;
        (0, $8hVbJ.issueDeleteInteraction)(concurrentId).cancel();
        return {
            name: `${eventPrefix}.card.delete.failure`,
            data: {
                cardId: action.payload.cardId
            }
        };
    };
const $3895e17f29bd590b$export$656497d228a51fa0 = (eventPrefix)=>(preState, state, action)=>{
        const concurrentId = action.meta.optimistic.id;
        const isCompanyManaged = (0, $jG5HW.getIsCompanyManaged)(state);
        (0, $8hVbJ.flagToggleInteraction)(concurrentId).stop({
            customData: {
                ...(0, $gZhS0.getBacklogCardCount)(state),
                isCompanyManaged: isCompanyManaged
            }
        });
        const { cards: cards } = action.payload;
        const flagDirection = (0, $dGljH.getCards)(state)[String(cards[0])].isFlagged ? 'added' : 'removed';
        return {
            name: `${eventPrefix}.cards.flag.${flagDirection}`,
            data: {
                numCards: cards.length
            }
        };
    };
const $3895e17f29bd590b$export$a54ef1c368494a58 = (eventPrefix)=>(preState, state, action)=>{
        const concurrentId = action.meta.optimistic.id;
        (0, $8hVbJ.flagToggleInteraction)(concurrentId).cancel();
        const { cards: cards } = action.payload;
        return {
            name: `${eventPrefix}.cards.flag.failure`,
            data: {
                numCards: cards.length
            }
        };
    };
const $3895e17f29bd590b$export$acfe54087abfec17 = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.card.open-detail-view`,
            data: {
                cardId: action.payload.cardId
            }
        });
const $3895e17f29bd590b$export$13e8b731273e5b62 = ()=>(preState, state, action)=>{
        const concurrentIds = action.payload.tempIds;
        concurrentIds.forEach((concurrentId)=>{
            (0, $8hVbJ.issueCreateInteraction)(String(concurrentId)).start();
        });
        (0, $4G04L.scheduleAfterRender)(()=>{
            concurrentIds.forEach((concurrentId)=>{
                (0, $8hVbJ.issueCreateInteraction)(String(concurrentId)).mark('feedback');
            });
        });
        return null;
    };
const $3895e17f29bd590b$export$496eebfe0f44eeed = ()=>(preState, state, action)=>{
        const { payload: { temporaryCardId: temporaryCardId, listId: listId, createdWithBulk: createdWithBulk } } = action;
        const concurrentId = String(temporaryCardId);
        const isCompanyManaged = (0, $jG5HW.getIsCompanyManaged)(state);
        // listId potential values: 'BOARD', 'BACKLOG' or sprintId e.g. '155'
        const cardListType = Number.isInteger(Number(listId)) ? 'SPRINT' : listId;
        (0, $8hVbJ.issueCreateInteraction)(concurrentId).stop({
            customData: {
                ...(0, $k12ix.getNormalisedPerformanceFFs)(),
                ...(0, $gZhS0.getBacklogCardCount)(state),
                cardListType: cardListType,
                createdWithBulk: createdWithBulk,
                isCompanyManaged: isCompanyManaged
            }
        });
        return null;
    };
const $3895e17f29bd590b$export$195ac2f6e1a95c77 = ()=>()=>{
        (0, $8hVbJ.issueRankInteraction).start();
        (0, $4G04L.scheduleAfterRender)(()=>{
            (0, $8hVbJ.issueRankInteraction).mark('feedback');
        });
        return null;
    };
const $3895e17f29bd590b$export$d3ff2e6ac38e63d6 = ()=>(preState, state, action)=>{
        const concurrentId = action.meta.optimistic.id;
        (0, $8hVbJ.issueDeleteInteraction)(concurrentId).start();
        (0, $4G04L.scheduleAfterRender)(()=>{
            (0, $8hVbJ.issueDeleteInteraction)(concurrentId).mark('feedback');
        });
        return null;
    };
const $3895e17f29bd590b$export$d9bd27fc2155921d = ()=>(preState, state, action)=>{
        const { meta: { analyticsEvent: analyticsEvent }, payload: { cardIds: cardIds, cardListId: cardListId } } = action;
        if (!analyticsEvent) return null;
        const isCompanyManaged = (0, $jG5HW.getIsCompanyManaged)(state);
        const isActiveSprint = (0, $k35me.makeIsCardListActiveSprint)(state);
        cardIds.forEach((id)=>(0, $f01qr.sendSuccessToMoveAnalytic)(id, // @ts-expect-error Argument of type 'UIAnalyticsEvent | null' is not assignable to parameter of type 'UIAnalyticsEvent'.
            analyticsEvent.clone(), cardListId, isActiveSprint));
        (0, $8hVbJ.issueRankInteraction).stop({
            customData: {
                ...(0, $k12ix.getNormalisedPerformanceFFs)(),
                ...(0, $gZhS0.getBacklogCardCount)(state),
                isCompanyManaged: isCompanyManaged
            }
        });
        return null;
    };
const $3895e17f29bd590b$export$418f4abeb5fa5e63 = ()=>(preState, state, action)=>{
        const { meta: { analyticsEvent: analyticsEvent }, payload: { error: error, cardIds: cardIds, cardListId: cardListId } } = action;
        if (!analyticsEvent) return null;
        const isActiveSprint = (0, $k35me.makeIsCardListActiveSprint)(state);
        (0, $f01qr.sendFailToMoveAnalytic)(analyticsEvent, cardIds, error, cardListId, isActiveSprint);
        (0, $8hVbJ.issueRankInteraction).cancel();
        return null;
    };
const $3895e17f29bd590b$export$dc3005aa374f7956 = ()=>(preState, state, action)=>{
        const concurrentId = action.meta.optimistic.id;
        (0, $8hVbJ.flagToggleInteraction)(concurrentId).start();
        (0, $4G04L.scheduleAfterRender)(()=>{
            (0, $8hVbJ.flagToggleInteraction)(concurrentId).mark('feedback');
        });
        return null;
    };
const $3895e17f29bd590b$export$30fe913aeacc7d4c = (eventPrefix)=>()=>({
            name: `${eventPrefix}.cards.parent-set.success`
        });
const $3895e17f29bd590b$export$24c3df942a1f1dd5 = (eventPrefix)=>()=>({
            name: `${eventPrefix}.cards.parent-set.failure`
        });

});
parcelRegister("k12ix", function(module, exports) {

$parcel$export(module.exports, "getPerformanceFFsString", () => $c2cbddd7f2605816$export$c983ad7dc5517558);
$parcel$export(module.exports, "getNormalisedPerformanceFFs", () => $c2cbddd7f2605816$export$de03840ff3eb49a4);

var $6eBRn = parcelRequire("6eBRn");

var $9XE6b = parcelRequire("9XE6b");

var $8QpSo = parcelRequire("8QpSo");

var $y7eb2 = parcelRequire("y7eb2");
const $c2cbddd7f2605816$var$PERF_FF_PREFIX = 'jsw.perf.';
const $c2cbddd7f2605816$var$EXTRA_FFS_WHITELIST = new Set([
    'fe_platform_error_tracking_enabled_sentry'
]);
const $c2cbddd7f2605816$var$getPerformanceFFs = (0, $8QpSo.default)(()=>{
    const featureFlags = Object.entries((0, $y7eb2.default)() || {})// @ts-expect-error - TS2769 - No overload matches this call.
    .filter(([key])=>key.startsWith($c2cbddd7f2605816$var$PERF_FF_PREFIX)) // eslint-disable-line @typescript-eslint/no-explicit-any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map(([key, value])=>[
            key.substring($c2cbddd7f2605816$var$PERF_FF_PREFIX.length),
            (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(value, [
                'value'
            ], null)
        ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6eBRn)))(featureFlags);
});
const $c2cbddd7f2605816$var$isConsistencyCheckValue = (value)=>value === 'NEW' || value === 'OLD' || value === 'CHECK' || value === 'CHECK_RETURN_NEW';
const $c2cbddd7f2605816$export$448575db1388a8e6 = (0, $8QpSo.default)((whitelist = $c2cbddd7f2605816$var$EXTRA_FFS_WHITELIST)=>{
    const featurePairs = Object.entries((0, $y7eb2.default)() || {})// @ts-expect-error - TS2769 - No overload matches this call.
    .filter(([key])=>whitelist.has(key)) // eslint-disable-line @typescript-eslint/no-explicit-any
    .map(([key, value])=>[
            key,
            (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(value, [
                'value'
            ], null)
        ]); // eslint-disable-line @typescript-eslint/no-explicit-any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    // @ts-expect-error - TS2345 - Argument of type '([key, value]: [any, any]) => void' is not assignable to parameter of type '(value: any[], index: number, array: any[][]) => void'.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    featurePairs.forEach(([key, value])=>{
        result[key] = value;
        if ($c2cbddd7f2605816$var$isConsistencyCheckValue(value)) {
            result[`${key}-new`] = value === 'NEW';
            result[`${key}-old`] = value === 'OLD';
            result[`${key}-check`] = value === 'CHECK';
            result[`${key}-check-return-new`] = value === 'CHECK_RETURN_NEW';
        }
    });
    return result;
});
const $c2cbddd7f2605816$export$c983ad7dc5517558 = (0, $8QpSo.default)(()=>JSON.stringify($c2cbddd7f2605816$var$getPerformanceFFs()));
const $c2cbddd7f2605816$export$de03840ff3eb49a4 = (0, $8QpSo.default)(()=>{
    const featureEntries = Object.entries({
        ...$c2cbddd7f2605816$var$getPerformanceFFs(),
        ...$c2cbddd7f2605816$export$448575db1388a8e6()
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const map = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    featureEntries.forEach(([key, value])=>{
        const normalisedKey = key.replace(/\./g, '-');
        map[normalisedKey] = value;
        return map;
    });
    return map;
});

});

parcelRegister("gZhS0", function(module, exports) {

$parcel$export(module.exports, "getBacklogCardCount", () => $3f1c907b3819a10a$export$b90897b496813c20);

var $dGljH = parcelRequire("dGljH");
const $3f1c907b3819a10a$export$b90897b496813c20 = (state)=>({
        cardsCount: Object.keys((0, $dGljH.getCards)(state)).length,
        visibleCardsCount: (0, $dGljH.getVisibleCardIds)(state).length
    });

});


parcelRegister("lASqM", function(module, exports) {

$parcel$export(module.exports, "setCustomFiltersPerformance", () => $b33ffd7246c68f9a$export$a4497c4897069a2b);
$parcel$export(module.exports, "setCustomFiltersFailure", () => $b33ffd7246c68f9a$export$b6336fdfea9c7130);
$parcel$export(module.exports, "setCustomFiltersSuccess", () => $b33ffd7246c68f9a$export$807bc3d6fd05a3f8);
$parcel$export(module.exports, "setClearCustomFiltersFailure", () => $b33ffd7246c68f9a$export$8390cb5d2e786615);
$parcel$export(module.exports, "setClearCustomFiltersSuccess", () => $b33ffd7246c68f9a$export$7705547b216dde);
$parcel$export(module.exports, "setClearCustomFiltersPerformance", () => $b33ffd7246c68f9a$export$c95dc6c32e218669);
$parcel$export(module.exports, "setCustomFiltersRefilterSuccess", () => $b33ffd7246c68f9a$export$be433321d98a3ffa);
$parcel$export(module.exports, "setCustomFiltersRefilterFailure", () => $b33ffd7246c68f9a$export$d76e8115781031ba);

var $fZneA = parcelRequire("fZneA");

var $8zOmE = parcelRequire("8zOmE");

var $fjcgS = parcelRequire("fjcgS");

var $4G04L = parcelRequire("4G04L");

var $hJnrC = parcelRequire("hJnrC");

var $jG5HW = parcelRequire("jG5HW");
const $b33ffd7246c68f9a$export$a4497c4897069a2b = ()=>(preState, state, action)=>{
        const { meta: { numCustomFiltersApplied: numCustomFiltersApplied, numIssueIds: numIssueIds } } = action;
        const isCompanyManaged = (0, $jG5HW.getIsCompanyManaged)(state);
        (0, $4G04L.scheduleAfterRender)(()=>{
            (0, $hJnrC.stopCustomFilterInteraction)(numCustomFiltersApplied, numIssueIds, isCompanyManaged);
        });
        return null;
    };
const $b33ffd7246c68f9a$export$b6336fdfea9c7130 = ()=>(preState, state, action)=>{
        const { payload: { error: error }, meta: { analyticsEvent: analyticsEvent } } = action;
        if (analyticsEvent) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'customFilters failed', {
            isClientFetchError: (0, $fZneA.isClientFetchError)(error),
            errorMessage: error?.message
        });
        (0, $hJnrC.cancelCustomFilterInteraction)();
        return null;
    };
const $b33ffd7246c68f9a$export$807bc3d6fd05a3f8 = ()=>(preState, state, action)=>{
        const { meta: { analyticsEvent: analyticsEvent, numCustomFiltersApplied: numCustomFiltersApplied, numIssueIds: numIssueIds } } = action;
        (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'customFilters applied', {
            numCustomFiltersApplied: numCustomFiltersApplied,
            numIssueIds: numIssueIds
        });
        return null;
    };
const $b33ffd7246c68f9a$export$8390cb5d2e786615 = ()=>(preState, state, action)=>{
        const { payload: { error: error }, meta: { analyticsEvent: analyticsEvent } } = action;
        if (analyticsEvent) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'clearCustomFilters failed', {
            isClientFetchError: (0, $fZneA.isClientFetchError)(error),
            errorMessage: error?.message
        });
        (0, $hJnrC.cancelClearCustomFilterInteraction)();
        return null;
    };
const $b33ffd7246c68f9a$export$7705547b216dde = ()=>(preState, state, action)=>{
        const { meta: { analyticsEvent: analyticsEvent } } = action;
        // @ts-expect-error - Argument of type 'UIAnalyticsEvent | undefined' is not assignable to parameter of type 'UIAnalyticsEvent'.
        (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'clearCustomFilters applied');
        return null;
    };
const $b33ffd7246c68f9a$export$c95dc6c32e218669 = ()=>(preState, state)=>{
        const isCompanyManaged = (0, $jG5HW.getIsCompanyManaged)(state);
        (0, $4G04L.scheduleAfterRender)(()=>{
            (0, $hJnrC.stopClearCustomFilterInteraction)(isCompanyManaged);
        });
        return null;
    };
const $b33ffd7246c68f9a$export$be433321d98a3ffa = ()=>(preState, state, action)=>{
        const { excludedCardIds: excludedCardIds, filteredCardIds: filteredCardIds } = action.payload;
        (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                source: 'backlog',
                actionSubject: 'customFiltersRefilter',
                action: 'applied',
                attributes: {
                    excludedCards: excludedCardIds.length,
                    filteredCards: filteredCardIds.length
                }
            };
            client.getInstance().sendTrackEvent(payload);
        });
        return null;
    };
const $b33ffd7246c68f9a$export$d76e8115781031ba = ()=>(preState, state, action)=>{
        const { error: error } = action.payload;
        (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                source: 'backlog',
                actionSubject: 'customFiltersRefilter',
                action: 'failed',
                attributes: {
                    isClientFetchError: (0, $fZneA.isClientFetchError)(error),
                    errorMessage: error?.message
                }
            };
            client.getInstance().sendOperationalEvent(payload);
        });
        return null;
    };

});
parcelRegister("hJnrC", function(module, exports) {

$parcel$export(module.exports, "setCustomFilterInteractionFeedbackMark", () => $df84e2ee7edada30$export$5dd87a22b8e2c81c);
$parcel$export(module.exports, "setCustomFilterInteractionStartMark", () => $df84e2ee7edada30$export$600569a4fb9e5675);
$parcel$export(module.exports, "cancelCustomFilterInteraction", () => $df84e2ee7edada30$export$178f6b8399be6909);
$parcel$export(module.exports, "stopCustomFilterInteraction", () => $df84e2ee7edada30$export$90db63ac5c02197a);
$parcel$export(module.exports, "setClearCustomFilterInteractionStartMark", () => $df84e2ee7edada30$export$962ac6dbaf359610);
$parcel$export(module.exports, "stopClearCustomFilterInteraction", () => $df84e2ee7edada30$export$6960edeeed3db8b2);
$parcel$export(module.exports, "cancelClearCustomFilterInteraction", () => $df84e2ee7edada30$export$9ff508c2f230f886);

var $k12ix = parcelRequire("k12ix");

var $8hVbJ = parcelRequire("8hVbJ");
const $df84e2ee7edada30$export$5dd87a22b8e2c81c = ()=>{
    (0, $8hVbJ.customFilterInteraction).mark('feedback');
};
const $df84e2ee7edada30$export$600569a4fb9e5675 = ()=>{
    (0, $8hVbJ.customFilterInteraction).start();
};
const $df84e2ee7edada30$export$178f6b8399be6909 = ()=>{
    (0, $8hVbJ.customFilterInteraction).cancel();
};
const $df84e2ee7edada30$export$90db63ac5c02197a = (numCustomFiltersApplied, numIssueIds, isCompanyManaged)=>{
    (0, $8hVbJ.customFilterInteraction).stop({
        customData: {
            ...(0, $k12ix.getNormalisedPerformanceFFs)(),
            numCustomFiltersApplied: numCustomFiltersApplied,
            numIssueIds: numIssueIds,
            isCompanyManaged: isCompanyManaged
        }
    });
};
const $df84e2ee7edada30$export$962ac6dbaf359610 = ()=>{
    (0, $8hVbJ.clearCustomFilterInteraction).start();
};
const $df84e2ee7edada30$export$6960edeeed3db8b2 = (isCompanyManaged)=>{
    (0, $8hVbJ.clearCustomFilterInteraction).stop({
        customData: {
            isCompanyManaged: isCompanyManaged
        }
    });
};
const $df84e2ee7edada30$export$9ff508c2f230f886 = ()=>{
    (0, $8hVbJ.clearCustomFilterInteraction).cancel();
};

});


parcelRegister("hchCX", function(module, exports) {

$parcel$export(module.exports, "setAllFilters", () => $eca15b66a6aed40e$export$1e6b2e9f0ff84131);
$parcel$export(module.exports, "setAllFiltersPerformance", () => $eca15b66a6aed40e$export$338d2cd01a36c93d);

var $9XE6b = parcelRequire("9XE6b");

var $k12ix = parcelRequire("k12ix");

var $4G04L = parcelRequire("4G04L");


var $8hVbJ = parcelRequire("8hVbJ");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $l9VFH = parcelRequire("l9VFH");

var $9ZuIF = parcelRequire("9ZuIF");
const $eca15b66a6aed40e$export$c48d1dabfffb8ec0 = (eventPrefix)=>(preState, state)=>{
        const totalAssigneeCount = (0, $dGljH.getOrderedAssignees)(state).length;
        return {
            name: `${eventPrefix}.filters.show`,
            data: {
                numAvatarsDisplayed: totalAssigneeCount > (0, $41ce9b5576b92b7a$export$360e7ca29749d455) ? (0, $41ce9b5576b92b7a$export$360e7ca29749d455) : totalAssigneeCount
            }
        };
    };
const $eca15b66a6aed40e$export$556a5ff7bd7ac86 = (eventPrefix)=>()=>({
            name: `${eventPrefix}.filters.search-field.focus`,
            data: {}
        });
const $eca15b66a6aed40e$export$5845d1911d8d06dd = (eventPrefix)=>(preState)=>{
        const selectedFilters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))((0, $l9VFH.getFilters)(preState), [
            'values'
        ]);
        return {
            name: `${eventPrefix}.filters.clear-button.click`,
            data: {
                numSelectedAvatars: (selectedFilters[0, $41ce9b5576b92b7a$export$f8f7545d2bb78afb] || []).length
            }
        };
    };
const $eca15b66a6aed40e$var$getFilterAnalyticsData = (state)=>{
    const filters = (0, $l9VFH.getFilters)(state);
    const assigneeFilters = filters[0, $41ce9b5576b92b7a$export$f8f7545d2bb78afb] || [];
    const labelFilters = filters[0, $41ce9b5576b92b7a$export$37aee82a3cb1e8f7] || [];
    const issueParentFilters = filters[0, $41ce9b5576b92b7a$export$2a4f270075a033de] || [];
    const versionFilters = filters[0, $41ce9b5576b92b7a$export$a4ad2735b021c132] || [];
    const issueTypeFilters = filters[0, $41ce9b5576b92b7a$export$ebb48b08205007c5] || [];
    const currentUser = (0, $9ZuIF.getCurrentUser)(state);
    return {
        numSelectedAvatars: assigneeFilters.length,
        isAssignedToMeSelected: currentUser ? assigneeFilters.indexOf(currentUser.id) > -1 : false,
        numSelectedLabels: labelFilters.length,
        numVisibleIssues: (0, $dGljH.getVisibleCardIds)(state).length,
        numSelectedIssueParents: issueParentFilters.length,
        numSelectedVersions: versionFilters.length,
        numSelectedIssueTypes: issueTypeFilters.length
    };
};
const $eca15b66a6aed40e$export$1e6b2e9f0ff84131 = (eventPrefix)=>(preState, state, action)=>{
        const { filterType: filterType } = action.meta;
        if (filterType) {
            let actionName = 'select';
            const filters = (0, $l9VFH.getFilters)(state);
            if (filterType === (0, $41ce9b5576b92b7a$export$d597759d33be802e) && !filters[0, $41ce9b5576b92b7a$export$d597759d33be802e]) actionName = 'deselect';
            else {
                const preFilters = (0, $l9VFH.getFilters)(preState);
                actionName = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filters, [
                    filterType
                ], []).length < (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(preFilters, [
                    filterType
                ], []).length ? 'deselect' : actionName;
            }
            return {
                name: `${eventPrefix}.filters.${filterType}.${actionName}`,
                data: $eca15b66a6aed40e$var$getFilterAnalyticsData(state)
            };
        }
        return null;
    };
const $eca15b66a6aed40e$export$338d2cd01a36c93d = ()=>(preState, state, action)=>{
        const { filters: filters } = action.payload;
        const filterType = Object.keys(filters || {});
        const isCompanyManaged = (0, $jG5HW.getIsCompanyManaged)(state);
        filterType.sort();
        (0, $4G04L.scheduleAfterRender)(()=>{
            (0, $8hVbJ.filterInteraction).stop({
                customData: {
                    ...(0, $k12ix.getNormalisedPerformanceFFs)(),
                    filterType: filterType.join(',') || 'CLEAR',
                    isCompanyManaged: isCompanyManaged
                }
            });
        });
        return null;
    };

});

parcelRegister("9kmfU", function(module, exports) {

$parcel$export(module.exports, "issueViewOpenPerformance", () => $5527b94c194d23b8$export$2da4dabf4eeee402);

var $eTXmK = parcelRequire("eTXmK");

var $8hVbJ = parcelRequire("8hVbJ");
const $5527b94c194d23b8$export$2da4dabf4eeee402 = ()=>(prevState, state, action)=>{
        if (!action.payload.withCmd && !action.payload.withShift) {
            (0, $eTXmK.default)('backlog.issue-view-opened');
            (0, $8hVbJ.issueViewOpenInteraction).start();
        }
        return null;
    };

});

parcelRegister("1kERf", function(module, exports) {

$parcel$export(module.exports, "cardCreateConfigLoadFailure", () => $2118f0cebbe48a34$export$55f7f50ae5d386e);
$parcel$export(module.exports, "cardCreateConfigLoadSuccess", () => $2118f0cebbe48a34$export$30b096da81e0022e);

var $fZneA = parcelRequire("fZneA");

var $8zOmE = parcelRequire("8zOmE");
const $2118f0cebbe48a34$export$55f7f50ae5d386e = ()=>(preState, state, action)=>{
        const { payload: { error: error }, meta: { analyticsEvent: analyticsEvent } } = action;
        if (analyticsEvent) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'cardCreateConfigLoad failed', {
            isClientFetchError: (0, $fZneA.isClientFetchError)(error),
            errorMessage: error?.message,
            statusCode: error?.statusCode
        });
        return null;
    };
const $2118f0cebbe48a34$export$30b096da81e0022e = ()=>(preState, state, action)=>{
        const { meta: { analyticsEvent: analyticsEvent } } = action;
        if (analyticsEvent) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'cardCreateConfigLoad success');
        return null;
    };

});

parcelRegister("f9vTq", function(module, exports) {

$parcel$export(module.exports, "sprintCreateRequestPerformance", () => $1bb8e5aebc1865f7$export$a2c86d07fe1585ea);
$parcel$export(module.exports, "sprintCreateSuccessPerformance", () => $1bb8e5aebc1865f7$export$ffb3b8195785fb3e);
$parcel$export(module.exports, "sprintDeleteRequestPerformance", () => $1bb8e5aebc1865f7$export$ffd831d4c6f0494);
$parcel$export(module.exports, "sprintDeleteSuccessPerformance", () => $1bb8e5aebc1865f7$export$795344b111af47fb);
$parcel$export(module.exports, "sprintCreateSuccess", () => $1bb8e5aebc1865f7$export$4bedc2fcbe2138bd);
$parcel$export(module.exports, "sprintCreateFailure", () => $1bb8e5aebc1865f7$export$cb20bc93da1235f7);
$parcel$export(module.exports, "sprintOriginBoardClickFailure", () => $1bb8e5aebc1865f7$export$823f11c0d0553628);
$parcel$export(module.exports, "sprintOriginBoardClickSuccess", () => $1bb8e5aebc1865f7$export$1327cb353e0e397f);
$parcel$export(module.exports, "sprintOriginBoardClickPermissionless", () => $1bb8e5aebc1865f7$export$ddc0780213c6223d);

var $k12ix = parcelRequire("k12ix");

var $8zOmE = parcelRequire("8zOmE");

var $4G04L = parcelRequire("4G04L");

var $gZhS0 = parcelRequire("gZhS0");

var $8hVbJ = parcelRequire("8hVbJ");
const $1bb8e5aebc1865f7$export$a2c86d07fe1585ea = ()=>(preState, state, action)=>{
        const concurrentId = action.payload.temporaryCardListId;
        (0, $8hVbJ.createSprintInteraction)(concurrentId).start();
        (0, $4G04L.scheduleAfterRender)(()=>{
            (0, $8hVbJ.createSprintInteraction)(concurrentId).mark('feedback');
        });
        return null;
    };
const $1bb8e5aebc1865f7$export$ffb3b8195785fb3e = ()=>(preState, state, action)=>{
        const concurrentId = String(action.payload.temporaryCardListId);
        (0, $8hVbJ.createSprintInteraction)(concurrentId).stop({
            customData: {
                ...(0, $k12ix.getNormalisedPerformanceFFs)(),
                ...(0, $gZhS0.getBacklogCardCount)(state)
            }
        });
        return null;
    };
const $1bb8e5aebc1865f7$export$ffd831d4c6f0494 = ()=>(preState, state, action)=>{
        const concurrentId = action.payload.sprintId;
        (0, $8hVbJ.deleteSprintInteraction)(concurrentId).start();
        (0, $4G04L.scheduleAfterRender)(()=>{
            (0, $8hVbJ.deleteSprintInteraction)(concurrentId).mark('feedback');
        });
        return null;
    };
const $1bb8e5aebc1865f7$export$795344b111af47fb = ()=>(preState, state, action)=>{
        const concurrentId = action.payload.sprintId;
        (0, $8hVbJ.deleteSprintInteraction)(concurrentId).stop({
            customData: {
                ...(0, $k12ix.getNormalisedPerformanceFFs)(),
                ...(0, $gZhS0.getBacklogCardCount)(state)
            }
        });
    };
const $1bb8e5aebc1865f7$export$4bedc2fcbe2138bd = ()=>(preState, state, action)=>{
        const { payload: payload, meta: { analyticsEvent: analyticsEvent } } = action;
        if (!analyticsEvent) return null;
        const trackEvent = analyticsEvent.clone();
        if (trackEvent) {
            const didSprintCreateWithDefaultDates = Boolean(payload.sprint.sprintData?.startDate);
            (0, $8zOmE.fireTrackAnalytics)(trackEvent, 'sprint created', {
                didSprintCreateWithDefaultDates: didSprintCreateWithDefaultDates,
                sprintId: payload.sprint.id
            });
        }
        const opEvent = analyticsEvent.clone();
        if (opEvent) (0, $8zOmE.fireOperationalAnalytics)(opEvent, 'ui taskSuccess', {
            task: 'createSprint'
        });
        return null;
    };
const $1bb8e5aebc1865f7$export$cb20bc93da1235f7 = ()=>(preState, state, action)=>{
        const { meta: { analyticsEvent: analyticsEvent } } = action;
        if (!analyticsEvent) return null;
        const opEvent = analyticsEvent.clone();
        if (opEvent) (0, $8zOmE.fireOperationalAnalytics)(opEvent, 'ui taskFail', {
            task: 'createSprint'
        });
        return null;
    };
const $1bb8e5aebc1865f7$export$823f11c0d0553628 = ()=>(preState, state, action)=>{
        const { meta: { analyticsEvent: analyticsEvent } } = action;
        if (analyticsEvent) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'ui taskFail', {
            task: 'sprintClickOriginBoardLink'
        });
        return null;
    };
const $1bb8e5aebc1865f7$export$1327cb353e0e397f = ()=>(preState, state, action)=>{
        const { meta: { analyticsEvent: analyticsEvent } } = action;
        if (analyticsEvent) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'ui taskSuccess', {
            task: 'sprintClickOriginBoardLink'
        });
        return null;
    };
const $1bb8e5aebc1865f7$export$ddc0780213c6223d = ()=>(preState, state, action)=>{
        const { meta: { analyticsEvent: analyticsEvent } } = action;
        if (analyticsEvent) (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'permissionlessSprintOriginBoardFlag shown');
        return null;
    };

});


parcelRegister("1wOVq", function(module, exports) {

$parcel$export(module.exports, "triggerAnalytics", () => $d61bdc31368fd475$export$2c57de8a70f64057);
/**
 * @deprecated GasV2 has been cleaned up, and it has not been logging any events since July. Please replace implementation with sending GasV3 analytics: go/gasv3
 */ const $d61bdc31368fd475$export$2c57de8a70f64057 = (_appName)=>(_eventNameSuffix, _eventData)=>Promise.resolve(undefined);

});


parcelRegister("3olna", function(module, exports) {

$parcel$export(module.exports, "default", () => $2049d23ef66afe52$export$2e2bcd8739ae039);


var $hi6AJ = parcelRequire("hi6AJ");

var $4R6GH = parcelRequire("4R6GH");

var $3lZ6i = parcelRequire("3lZ6i");

var $a7yHf = parcelRequire("a7yHf");

var $8MHVw = parcelRequire("8MHVw");

var $lReb9 = parcelRequire("lReb9");

var $cscVG = parcelRequire("cscVG");

var $fdAim = parcelRequire("fdAim");

var $9tZuw = parcelRequire("9tZuw");

var $4mqko = parcelRequire("4mqko");

var $cPahM = parcelRequire("cPahM");

var $38qhf = parcelRequire("38qhf");

var $eMLHT = parcelRequire("eMLHT");

var $likqC = parcelRequire("likqC");

var $5Eoed = parcelRequire("5Eoed");

var $9g0YE = parcelRequire("9g0YE");

var $c7Xu8 = parcelRequire("c7Xu8");

var $ubpiL = parcelRequire("ubpiL");

var $bI3co = parcelRequire("bI3co");

var $gwOHY = parcelRequire("gwOHY");

var $5uBAa = parcelRequire("5uBAa");

var $7zF3i = parcelRequire("7zF3i");
// We ignore the success and failure mutations, we just invalidate them as soon as the request
// is fired. That way if someone navigates away before the SUCCESS/FAILURE mutation returns they
// won't get an incorrect cached version
const $2049d23ef66afe52$var$BACKLOG_IGNORE_REGEX = /^(state\.actions\.).+(_SUCCESS|_FAILURE)$/;
// This one helps us ignore junk like COMMON/REDUX_DISPOSABLE/DISPOSE_ACTION
const $2049d23ef66afe52$var$ELIGIBLE_FOR_INVALIDATION = /^(state\.actions\.).+$/;
const $2049d23ef66afe52$export$d4b7dead01a52ae = ({ type: type })=>{
    switch(type){
        case 0, $3lZ6i.REFRESH_DATA_REQUEST:
        case 0, $3lZ6i.LOAD_APP_DATA_REQUEST:
        case 0, $3lZ6i.LOAD_CONFIG_DATA_REQUEST:
        case 0, $c7Xu8.LOAD_PRIORITIES_REQUEST:
        case 0, $3lZ6i.SET_CONFIG_DATA:
        case 0, $3lZ6i.LOAD_CONFIG_DATA_MODEL_SUCCESS:
        case 0, $3lZ6i.SET_APP_DATA:
        case 0, $bI3co.REQUEST_CURRENT_USER:
        case 0, $bI3co.SET_CURRENT_USER:
        case 0, $3lZ6i.INITIALIZE_APP_PROPS:
        case 0, $3lZ6i.BACKLOG_VIEW:
        case 0, $likqC.SET_ALL_FILTERS:
        case 0, $cPahM.SET_COLUMNS:
        case 0, $cscVG.CARD_PREV:
        case 0, $cscVG.CARD_NEXT:
        case 0, $lReb9.CARD_FOCUS:
        case 0, $lReb9.CARD_BLUR:
        case 0, $9tZuw.SET_RICH_ACTIVE_CARD:
        case 0, $4mqko.CARD_CLICK:
        case 0, $4mqko.CARD_SINGLE_SELECT:
        case 0, $4mqko.SET_LAST_SELECTED_CARD_KEY:
        case 0, $a7yHf.CARD_LIST_TOGGLE:
        case 0, $a7yHf.SET_COLLAPSED_CARD_LIST:
        case 0, $38qhf.OPEN_DETAIL_VIEW:
        case 0, $38qhf.CLOSE_DETAIL_VIEW:
        case 0, $5Eoed.OPEN_MODAL:
        case 0, $5Eoed.CLOSE_MODAL:
        case 0, $ubpiL.REALTIME_DISPATCH_EVENT_BATCH:
        case 0, $9tZuw.SET_CARD_ID_WITH_ABOVE_ICC_OPEN:
        case 0, $fdAim.CARD_REFRESH_REQUEST:
        case 0, $eMLHT.DRAG_START:
        case 0, $eMLHT.DRAG_END:
        case 0, $38qhf.UPDATE_DETAIL_VIEW:
        case 0, $4mqko.CARD_EMPTY_SELECTION:
        case 0, $4mqko.PARENT_CLICK:
        case 0, $a7yHf.CARD_LISTS_ENABLE_ALL:
        case 0, $4mqko.CARD_TOGGLE_SELECTION:
        case 0, $8MHVw.FILTERED_CARD_CLEAR:
        case 0, $a7yHf.CARD_LISTS_DISABLE:
        case 0, $38qhf.OPEN_DETAIL_VIEW_DEBOUNCED:
        case 0, $4mqko.CARD_MULTI_SELECT:
        case 0, $9g0YE.CLOSE_INSIGHTS_PANEL:
        case 0, $gwOHY.SET_VERSIONS:
        case 0, $9g0YE.SET_ALL_PANELS:
        case 0, $9g0YE.SET_ALL_PANELS_SUCCESS:
            return false;
        default:
            break;
    }
    if ((0, $4R6GH.fg)('fix_backlog_board_transition_cache')) switch(type){
        case 0, $5uBAa.SET_CONFLUENCE_DATA:
        case 0, $7zF3i.SET_INLINE_CREATE_SESSION_ID:
        case 0, $5uBAa.SET_USER_PROPERTY_KEYS:
            return false;
        default:
            break;
    }
    // Ignore stuff that isn't applicable to the board (e.g. COMMON/REDUX_DISPOSABLE/DISPOSE_ACTION)
    // Test against board specific actions
    if (!$2049d23ef66afe52$var$ELIGIBLE_FOR_INVALIDATION.exec(type) || $2049d23ef66afe52$var$BACKLOG_IGNORE_REGEX.exec(type)) return false;
    // DEFAULT TO TRUE. It's better to forcibly refresh the cache if someone forgets to add
    // their mutation here
    return true;
};
var $2049d23ef66afe52$export$2e2bcd8739ae039 = (0, $hi6AJ.default)((0, $8631d6ce464ccf2e$export$dedbdcc35e955187), $2049d23ef66afe52$export$d4b7dead01a52ae);

});
parcelRegister("hi6AJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1904eee7acf3b502$export$2e2bcd8739ae039);

var $b0yad = parcelRequire("b0yad");
const $1904eee7acf3b502$export$41c940a04807c68c = (subject)=>(origin, invalidationFunction)=>()=>(next)=>(action)=>{
                    // There is a potential that the action gets passed as undefined
                    if (action && invalidationFunction(action)) {
                        // Trigger cache invalidation. Let the listeners handle everything else
                        subject.next(origin);
                        (0, $b0yad.addInvalidationReason)(origin, action.type ?? 'UNKNOWN');
                    }
                    return next(action);
                };
var $1904eee7acf3b502$export$2e2bcd8739ae039 = $1904eee7acf3b502$export$41c940a04807c68c((0, $b0yad.default));

});

parcelRegister("7zF3i", function(module, exports) {

$parcel$export(module.exports, "SET_INLINE_CREATE_SESSION_ID", () => $59a43373b6293d31$export$b7afd69edc8efc16);
$parcel$export(module.exports, "setInlineCreateSessionId", () => $59a43373b6293d31$export$69abc158578163fc);
$parcel$export(module.exports, "CLEAR_INLINE_CREATE_SESSION_ID", () => $59a43373b6293d31$export$932498ee6899f22a);
const $59a43373b6293d31$export$b7afd69edc8efc16 = 'state.actions.inline-create.SET_INLINE_CREATE_SESSION_ID';
const $59a43373b6293d31$export$69abc158578163fc = ({ sessionId: sessionId })=>({
        type: $59a43373b6293d31$export$b7afd69edc8efc16,
        payload: {
            sessionId: sessionId
        }
    });
const $59a43373b6293d31$export$932498ee6899f22a = 'state.actions.inline-create.CLEAR_INLINE_CREATE_SESSION_ID';
const $59a43373b6293d31$export$138f7b7b7eb9ceaa = ()=>({
        type: $59a43373b6293d31$export$932498ee6899f22a
    });

});


parcelRegister("6j9F6", function(module, exports) {

$parcel$export(module.exports, "default", () => $736b3bfcb1b5ed36$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $heEMQ = parcelRequire("heEMQ");

var $li1vk = parcelRequire("li1vk");

var $dN8hL = parcelRequire("dN8hL");
function $736b3bfcb1b5ed36$export$2e2bcd8739ae039() {
    return (0, $3f2cs.combineReducers)({
        ui: (0, $dN8hL.default)(),
        // Need cast to open-up store to | type that isn't only handling optimistic
        // state. This is due to `optimistic(...)` from redux-optimistic-ui not
        // being fully type-safe.
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        entities: (0, $li1vk.default)(),
        config: $heEMQ.default
    });
}

});
parcelRegister("heEMQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb17f8a619b8d234$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $7Jxgt = parcelRequire("7Jxgt");

var $lzeFL = parcelRequire("lzeFL");

var $l2T6l = parcelRequire("l2T6l");

var $gBj4V = parcelRequire("gBj4V");

var $3lZ6i = parcelRequire("3lZ6i");

var $hseEV = parcelRequire("hseEV");

var $fNaAq = parcelRequire("fNaAq");

var $5uBAa = parcelRequire("5uBAa");

var $1Xr8M = parcelRequire("1Xr8M");
const $cb17f8a619b8d234$var$defaultState = ()=>({
        locale: (0, $lzeFL.defaultLocale),
        baseUrl: '',
        rapidViewId: '',
        isCompanyManaged: false,
        projectKey: '',
        projectId: 1,
        projectName: '',
        rankCustomFieldId: 0,
        // @ts-expect-error(PARTIAL_RECORD) TS2739 - Type '{}' is missing the following properties from type 'Permissions': CAN_CREATE_ISSUES, CAN_DELETE_ISSUES, CAN_MANAGE_SPRINTS, CAN_EDIT_ISSUES, CAN_EDIT_BOARD_CONFIG
        permissions: {},
        timeTrackingOptions: (0, $gBj4V.defaultTimeTrackingOptions),
        cloudId: '',
        atlassianAccountId: null,
        xsrfToken: '',
        backlogStrategy: 'NONE',
        name: '',
        sprintFieldId: null,
        storyPointFieldId: null,
        epicIssueType: null,
        epicLinkField: null,
        jqlQuery: null,
        isInlineCardCreateEnabled: false,
        requestColumnMigration: false,
        extension: {
            operations: []
        },
        allFeatures: [],
        version: {
            isVersionsFeatureEnabled: false
        },
        sessionId: (0, $7Jxgt.v4)(),
        kanbanBoardColumnId: null,
        kanbanBacklogColumnId: null,
        isOrderedByRank: true,
        showEpicAsPanel: false,
        whiteboardsEntrypointExperimentConfig: {
            hasConfluenceAccess: false,
            hasConfluenceRequestOrDirectAccess: false,
            hasConfluenceSpaces: false,
            hasXFlowFromWhiteboardsTouchpoint: false,
            eligibility: {
                flow: null,
                cohort: 'not-enrolled'
            },
            userPropertyKeys: null
        }
    });
function $cb17f8a619b8d234$export$2e2bcd8739ae039(state = $cb17f8a619b8d234$var$defaultState(), action) {
    switch(action.type){
        case 0, $3lZ6i.INITIALIZE_APP_PROPS:
            return {
                ...state,
                ...action.payload,
                sessionId: (0, $7Jxgt.v4)()
            };
        case 0, $3lZ6i.LOAD_CONFIG_DATA_MODEL_SUCCESS:
            return (0, $7uUwQ.merge)((0, $7uUwQ.merge)(state, action.payload.config), {
                permissions: state.permissions
            });
        case 0, $3lZ6i.SET_APP_DATA:
        case 0, $3lZ6i.SET_CONFIG_DATA:
            return (0, $7uUwQ.merge)((0, $7uUwQ.merge)(state, action.payload.config), {
                permissions: (0, $7uUwQ.merge)(state.permissions, action.payload.config.permissions)
            });
        case 0, $fNaAq.FETCH_PERMISSIONS_SUCCESS:
            return (0, $7uUwQ.merge)(state, {
                permissions: (0, $7uUwQ.merge)(state.permissions, action.payload.permissions)
            });
        case 0, $hseEV.EXTENSION_FETCH_SUCCESS:
            return (0, $l2T6l.chainUnsafe)(state).set('extension', (0, $1Xr8M.default)(state.extension, action)).value();
        case 0, $5uBAa.SET_CONFLUENCE_DATA:
            return (0, $7uUwQ.merge)(state, {
                whiteboardsEntrypointExperimentConfig: {
                    ...state.whiteboardsEntrypointExperimentConfig,
                    hasConfluenceSpaces: action.payload.hasConfluenceSpaces,
                    hasConfluenceAccess: action.payload.hasConfluenceAccess,
                    hasConfluenceRequestOrDirectAccess: action.payload.hasConfluenceRequestOrDirectAccess
                }
            });
        case 0, $5uBAa.SET_WHITEBOARD_ELIGIBILITY:
            return (0, $7uUwQ.merge)(state, {
                whiteboardsEntrypointExperimentConfig: {
                    ...state.whiteboardsEntrypointExperimentConfig,
                    eligibility: {
                        flow: action.payload.flow,
                        cohort: action.payload.cohort
                    }
                }
            });
        case 0, $5uBAa.HAS_XFLOW_FROM_WHITEBOARDS_TOUCHPOINT:
            return (0, $7uUwQ.merge)(state, {
                whiteboardsEntrypointExperimentConfig: {
                    ...state.whiteboardsEntrypointExperimentConfig,
                    hasXFlowFromWhiteboardsTouchpoint: action.payload.hasXflowFromWhiteboardsTouchpoint
                }
            });
        case 0, $5uBAa.SET_USER_PROPERTY_KEYS:
            return (0, $7uUwQ.merge)(state, {
                whiteboardsEntrypointExperimentConfig: {
                    ...state.whiteboardsEntrypointExperimentConfig,
                    userPropertyKeys: action.payload
                }
            });
        case 0, $5uBAa.SET_USER_PROPERTY_KEY:
            {
                const userPropertyKeys = state.whiteboardsEntrypointExperimentConfig.userPropertyKeys;
                const userPropertyKeysSet = new Set(userPropertyKeys);
                userPropertyKeysSet.add(action.payload);
                return (0, $7uUwQ.merge)(state, {
                    whiteboardsEntrypointExperimentConfig: {
                        ...state.whiteboardsEntrypointExperimentConfig,
                        userPropertyKeys: Array.from(userPropertyKeysSet)
                    }
                });
            }
        default:
            return state;
    }
}

});
parcelRegister("l2T6l", function(module, exports) {

$parcel$export(module.exports, "assocUnsafe", () => $10cc07b888293773$export$a759ec8fde46de77);
$parcel$export(module.exports, "dissocUnsafe", () => $10cc07b888293773$export$e0867c1b5da854fe);
$parcel$export(module.exports, "assocInUnsafe", () => $10cc07b888293773$export$1bfac1118aad2c2f);
$parcel$export(module.exports, "updateInUnsafe", () => $10cc07b888293773$export$f920b8c255ec1192);
$parcel$export(module.exports, "chainUnsafe", () => $10cc07b888293773$export$181c753256d1c9a0);

var $7uUwQ = parcelRequire("7uUwQ");
const $10cc07b888293773$export$a759ec8fde46de77 = (collection, key, value)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $7uUwQ.assoc(collection, key, value);
const $10cc07b888293773$export$9b65d21cdbb50a87 = (collection, key, value)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $7uUwQ.set(collection, key, value);
const $10cc07b888293773$export$e0867c1b5da854fe = (collection, key)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $7uUwQ.dissoc(collection, key);
const $10cc07b888293773$export$958195bad0a3dbcf = (collection, key)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $7uUwQ.unset(collection, key);
const $10cc07b888293773$export$1bfac1118aad2c2f = (collection, path, value)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $7uUwQ.assocIn(collection, path, value);
const $10cc07b888293773$export$565e6fa2e54b66b3 = (collection, path, value)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $7uUwQ.setIn(collection, path, value);
const $10cc07b888293773$export$75197f11bfe5de5f = (collection, path)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $7uUwQ.getIn(collection, path);
const $10cc07b888293773$export$f920b8c255ec1192 = (collection, path, callback)=>$7uUwQ.updateIn(collection, path, callback);
class $10cc07b888293773$var$IcepickUnsafeWrapper {
    constructor(collection){
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        this.wrapper = $7uUwQ.chain(collection);
    }
    value() {
        return this.wrapper.value();
    }
    freeze() {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.freeze().value());
    }
    assoc(key, value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.assoc(key, value).value());
    }
    set(key, value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.set(key, value).value());
    }
    dissoc(key) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.dissoc(key).value());
    }
    unset(key) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.unset(key).value());
    }
    assocIn(path, value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.assocIn(path, value).value());
    }
    setIn(path, value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.setIn(path, value).value());
    }
    getIn(path, value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.getIn(path, value).value());
    }
    updateIn(path, callback) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.updateIn(path, callback).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    assign(source) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.assign(source).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    assign(s1, s2) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.assign(s1, s2).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    assign(s1, s2, s3) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.assign(s1, s2, s3).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    assign(s1, s2, s3, s4) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.assign(s1, s2, s3, s4).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    extend(source) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.extend(source).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    extend(s1, s2) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.extend(s1, s2).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    extend(s1, s2, s3) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.extend(s1, s2, s3).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    extend(s1, s2, s3, s4) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.extend(s1, s2, s3, s4).value());
    }
    merge(source) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.merge(source).value());
    }
    thru(val) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.thru(val).value());
    }
}
const $10cc07b888293773$export$181c753256d1c9a0 = (collection)=>new $10cc07b888293773$var$IcepickUnsafeWrapper(collection);

});

parcelRegister("1Xr8M", function(module, exports) {

$parcel$export(module.exports, "default", () => $98ded37837b2ccf8$export$2e2bcd8739ae039);

var $hseEV = parcelRequire("hseEV");
const $98ded37837b2ccf8$var$initialState = {
    operations: []
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$98ded37837b2ccf8$export$2e2bcd8739ae039 = (state = $98ded37837b2ccf8$var$initialState, action)=>{
    if (action.type === (0, $hseEV.EXTENSION_FETCH_SUCCESS)) return action.payload.extension;
    return state;
};

});


parcelRegister("li1vk", function(module, exports) {

$parcel$export(module.exports, "default", () => $44e7c4b16e186663$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $alNv9 = parcelRequire("alNv9");

var $3mKMp = parcelRequire("3mKMp");

var $bgMYY = parcelRequire("bgMYY");

var $vE7h8 = parcelRequire("vE7h8");

var $9yRWt = parcelRequire("9yRWt");

var $aLuWu = parcelRequire("aLuWu");

var $5nW8W = parcelRequire("5nW8W");

var $cj2CS = parcelRequire("cj2CS");

var $3Ek8N = parcelRequire("3Ek8N");

var $hDT0g = parcelRequire("hDT0g");

var $d74Q9 = parcelRequire("d74Q9");

var $lRpaB = parcelRequire("lRpaB");

var $aQATd = parcelRequire("aQATd");

var $bA8dH = parcelRequire("bA8dH");

var $bgxMB = parcelRequire("bgxMB");

var $3zbT1 = parcelRequire("3zbT1");

var $9tayK = parcelRequire("9tayK");

var $7k9YH = parcelRequire("7k9YH");

var $4Q0MU = parcelRequire("4Q0MU");

var $4lJeG = parcelRequire("4lJeG");
function $44e7c4b16e186663$export$2e2bcd8739ae039() {
    return (0, $alNv9.optimistic)((0, $3f2cs.combineReducers)({
        card: (0, $5nW8W.default),
        cardList: (0, $bgMYY.default),
        cardListOrder: (0, $3mKMp.default),
        cardOrder: (0, $9yRWt.default),
        cardOrderGlobal: (0, $vE7h8.default),
        column: (0, $cj2CS.default),
        currentUser: (0, $3Ek8N.default),
        customFilters: (0, $hDT0g.customFiltersReducer),
        cardTypes: (0, $aLuWu.default),
        estimation: (0, $d74Q9.default),
        tracking: (0, $7k9YH.trackingReducer),
        inlineCreate: (0, $lRpaB.default),
        issueParents: (0, $bA8dH.default),
        issueParentsOrder: (0, $aQATd.default),
        priorities: (0, $3zbT1.default),
        project: (0, $9tayK.default),
        versions: (0, $4lJeG.versionsReducer),
        version: (0, $4Q0MU.default),
        lastCreatedCardId: (0, $bgxMB.default)
    }));
}

});
parcelRegister("3mKMp", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4048878690a248f$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $guzeq = parcelRequire("guzeq");

var $3lZ6i = parcelRequire("3lZ6i");

var $jkFPs = parcelRequire("jkFPs");

var $d09wv = parcelRequire("d09wv");

var $dkxyn = parcelRequire("dkxyn");
const $c4048878690a248f$var$defaultState = [];
const $c4048878690a248f$var$cardListOrderReducer = (state = $c4048878690a248f$var$defaultState, action)=>{
    switch(action.type){
        case 0, $3lZ6i.SET_APP_DATA:
            return action.payload.entities.cardListOrder;
        case 0, $jkFPs.SPRINT_CREATE_REQUEST:
            {
                const backlogIndex = state.indexOf((0, $guzeq.BACKLOG));
                return (0, $7uUwQ.splice)(state, backlogIndex, 0, action.payload.temporaryCardListId);
            }
        case 0, $jkFPs.SPRINT_CREATE_SUCCESS:
            {
                const tempIndex = state.indexOf(action.payload.temporaryCardListId);
                return (0, $7uUwQ.splice)(state, tempIndex, 1, action.payload.sprint.id);
            }
        case 0, $d09wv.SPRINT_DELETE_REQUEST:
            return (0, $7uUwQ.splice)(state, state.indexOf(action.payload.sprintId), 1);
        case 0, $dkxyn.SPRINT_MOVE_REQUEST:
            {
                const { payload: { sprintId: sprintId, targetSprintId: targetSprintId, direction: direction } } = action;
                const sprintIndex = state.indexOf(sprintId);
                const otherSprintIndex = state.indexOf(targetSprintId);
                if (direction === (0, $guzeq.SPRINT_MOVE_TO_TOP)) {
                    const activeSprints = state.slice(0, otherSprintIndex);
                    const inactiveSprints = state.slice(otherSprintIndex);
                    inactiveSprints.pop(); // pop the "BACKLOG" sprint
                    const sprintIndexWithinInactives = inactiveSprints.indexOf(sprintId);
                    // move sprint to the top of targetSprintId, but below active sprints
                    return [
                        ...activeSprints,
                        sprintId,
                        ...(0, $7uUwQ.splice)(inactiveSprints, sprintIndexWithinInactives, 1),
                        (0, $guzeq.BACKLOG)
                    ];
                }
                if (direction === (0, $guzeq.SPRINT_MOVE_TO_BOTTOM)) {
                    const sprints = state;
                    sprints.pop(); // pop the "BACKLOG" sprint
                    const sprintIndexWithinSprints = sprints.indexOf(sprintId);
                    return [
                        ...(0, $7uUwQ.splice)(sprints, sprintIndexWithinSprints, 1),
                        sprintId,
                        (0, $guzeq.BACKLOG)
                    ];
                }
                return (0, $7uUwQ.chain)(state).set(sprintIndex, targetSprintId).set(otherSprintIndex, sprintId).value();
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $c4048878690a248f$export$2e2bcd8739ae039 = $c4048878690a248f$var$cardListOrderReducer;

});

parcelRegister("bgMYY", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d4a2668b04c6af0$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $l2T6l = parcelRequire("l2T6l");

var $guzeq = parcelRequire("guzeq");

var $3lZ6i = parcelRequire("3lZ6i");

var $jkFPs = parcelRequire("jkFPs");

var $d09wv = parcelRequire("d09wv");

var $ksKI7 = parcelRequire("ksKI7");
const $9d4a2668b04c6af0$var$defaultState = {};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9d4a2668b04c6af0$export$2e2bcd8739ae039 = (state = $9d4a2668b04c6af0$var$defaultState, action)=>{
    switch(action.type){
        case 0, $3lZ6i.SET_APP_DATA:
            return action.payload.entities.cardList;
        case 0, $jkFPs.SPRINT_CREATE_REQUEST:
            return (0, $7uUwQ.assign)(state, {
                [action.payload.temporaryCardListId]: {
                    id: String(action.payload.temporaryCardListId),
                    name: 'Sprint',
                    type: (0, $guzeq.SPRINT),
                    issueListKey: null,
                    isOptimistic: true,
                    sprintData: {
                        goal: '',
                        startDate: '',
                        endDate: '',
                        daysRemaining: 0,
                        state: 'FUTURE',
                        canUpdateSprint: true
                    }
                }
            });
        case 0, $jkFPs.SPRINT_CREATE_SUCCESS:
            return (0, $l2T6l.chainUnsafe)(state).set(action.payload.sprint.id, action.payload.sprint).unset(action.payload.temporaryCardListId).value();
        case 0, $d09wv.SPRINT_DELETE_REQUEST:
            return (0, $7uUwQ.unset)(state, action.payload.sprintId);
        case 0, $ksKI7.EDIT_SPRINT_REQUEST:
            return (0, $l2T6l.chainUnsafe)(state).setIn([
                String(action.payload.id),
                'name'
            ], action.payload.name).setIn([
                String(action.payload.id),
                'sprintData',
                'goal'
            ], action.payload.goal).setIn([
                String(action.payload.id),
                'sprintData',
                'startDate'
            ], action.payload.startDate).setIn([
                String(action.payload.id),
                'sprintData',
                'endDate'
            ], action.payload.endDate).value();
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});
parcelRegister("ksKI7", function(module, exports) {

$parcel$export(module.exports, "EDIT_SPRINT_REQUEST", () => $af6e991d87d504d7$export$123abdbc4d2e52b2);
$parcel$export(module.exports, "editSprintRequest", () => $af6e991d87d504d7$export$f1ede94f3f629cd9);
$parcel$export(module.exports, "editSprintSuccess", () => $af6e991d87d504d7$export$3b274a040443f185);
$parcel$export(module.exports, "editSprintFailure", () => $af6e991d87d504d7$export$193b8520faf6f6b0);

var $c0irb = parcelRequire("c0irb");
const $af6e991d87d504d7$export$123abdbc4d2e52b2 = 'state.actions.sprints.edit.EDIT_SPRINT_REQUEST';
const $af6e991d87d504d7$export$f1ede94f3f629cd9 = (id, name, goal, startDate, endDate)=>({
        type: $af6e991d87d504d7$export$123abdbc4d2e52b2,
        payload: {
            id: id,
            name: name,
            goal: goal,
            startDate: startDate,
            endDate: endDate
        },
        meta: (0, $c0irb.beginOptimisticUiMeta)()
    });
const $af6e991d87d504d7$export$e043c26cf23a5c18 = 'state.actions.sprints.edit.EDIT_SPRINT_SUCCESS';
const $af6e991d87d504d7$export$3b274a040443f185 = (txId)=>({
        type: $af6e991d87d504d7$export$e043c26cf23a5c18,
        meta: (0, $c0irb.commitOptimisticUiMeta)(txId)
    });
const $af6e991d87d504d7$export$c58baca64c75a779 = 'state.actions.sprints.edit.EDIT_SPRINT_FAILURE';
const $af6e991d87d504d7$export$193b8520faf6f6b0 = (txId)=>({
        type: $af6e991d87d504d7$export$c58baca64c75a779,
        meta: (0, $c0irb.revertOptimisticUiWithFlagMeta)(txId)
    });

});


parcelRegister("vE7h8", function(module, exports) {

$parcel$export(module.exports, "default", () => $c47088fbae861226$export$2e2bcd8739ae039);

var $3lZ6i = parcelRequire("3lZ6i");

var $a1ybZ = parcelRequire("a1ybZ");

var $6GNN7 = parcelRequire("6GNN7");
const $c47088fbae861226$var$cardOrderGlobalReducer = (state = [], action)=>{
    if (action.type === (0, $3lZ6i.SET_APP_DATA)) return action.payload.entities.cardOrderGlobal || state;
    if (action.type === (0, $a1ybZ.SET_CARD_ORDER_GLOBAL)) return action.payload;
    if (action.type === (0, $6GNN7.CARDS_MOVE_REQUEST)) return action.payload.newCardOrderGlobal || state;
    return state;
};
var $c47088fbae861226$export$2e2bcd8739ae039 = $c47088fbae861226$var$cardOrderGlobalReducer;

});

parcelRegister("9yRWt", function(module, exports) {

$parcel$export(module.exports, "default", () => $78835702a3680988$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $sLb2Q = parcelRequire("sLb2Q");

var $FTaAj = parcelRequire("FTaAj");

var $2lpqS = parcelRequire("2lpqS");

var $f01qr = parcelRequire("f01qr");

var $guzeq = parcelRequire("guzeq");

var $3lZ6i = parcelRequire("3lZ6i");

var $hf5c2 = parcelRequire("hf5c2");

var $legw4 = parcelRequire("legw4");

var $6GNN7 = parcelRequire("6GNN7");

var $jkFPs = parcelRequire("jkFPs");

var $d09wv = parcelRequire("d09wv");

var $7X18B = parcelRequire("7X18B");
const $78835702a3680988$var$defaultState = {};
const $78835702a3680988$var$getNewCardOrder = (action)=>{
    if (action.type === (0, $6GNN7.CARDS_MOVE_REQUEST)) return action.payload.newCardOrder;
    return undefined;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$78835702a3680988$export$2e2bcd8739ae039 = (state = $78835702a3680988$var$defaultState, action)=>{
    switch(action.type){
        case 0, $3lZ6i.SET_APP_DATA:
            return action.payload.entities.cardOrder;
        case 0, $6GNN7.CARDS_MOVE_SET:
        case 0, $6GNN7.CARDS_MOVE_REQUEST:
            {
                const newState = (0, $7uUwQ.chain)(state);
                const { payload: { cardIds: cardIds, beforeCardId: beforeCardId, afterCardId: afterCardId, cardListId: cardListId } } = action;
                const derivedCardListId = (0, $f01qr.getCardListId)(cardListId);
                if (cardListId === String((0, $2lpqS.UNASSIGNED_EPIC_ID))) return state;
                // Remove the moved cardIds from all cardlists, to be
                // returned to their new location below
                Object.keys(state).forEach((key)=>newState.setIn([
                        key
                    ], state[key].filter((cardId)=>!cardIds.includes(cardId))));
                if ($78835702a3680988$var$getNewCardOrder(action)) return newState.setIn([
                    derivedCardListId
                ], $78835702a3680988$var$getNewCardOrder(action)).value();
                const cardIdList = newState.value()[derivedCardListId];
                const insertIndex = beforeCardId ? cardIdList.indexOf(beforeCardId) : cardIdList.indexOf(afterCardId || 0) + 1;
                newState.setIn([
                    derivedCardListId
                ], (0, $7uUwQ.splice)(cardIdList, insertIndex, 0, ...cardIds));
                return newState.value();
            }
        case 0, $hf5c2.CARD_CREATE_MULTIPLE_REQUEST:
            {
                const { tempIds: tempIds, listId: listId, insertBefore: insertBefore } = action.payload;
                if (!insertBefore) {
                    let updatedState = state[listId];
                    tempIds.forEach((tempId)=>{
                        updatedState = (0, $7uUwQ.push)(updatedState, tempId);
                    });
                    return (0, $7uUwQ.set)(state, listId, updatedState);
                }
                const insertIndex = state[listId].indexOf(insertBefore);
                return (0, $7uUwQ.set)(state, listId, (0, $7uUwQ.splice)(state[listId], insertIndex, 0, ...tempIds));
            }
        case 0, $hf5c2.CARD_CREATE_SUCCESS:
            {
                const { card: card, listId: listId, temporaryCardId: temporaryCardId } = action.payload;
                const index = state[listId].indexOf(temporaryCardId);
                return (0, $7uUwQ.setIn)(state, [
                    listId,
                    index
                ], card.id);
            }
        // todo handle here
        case 0, $legw4.CARD_DELETE:
        case 0, $legw4.CARD_DELETE_REQUEST:
            {
                const cardListIds = Object.keys(state);
                const { cardId: deletedCardId } = action.payload;
                const filteredLists = cardListIds.map((cardListId)=>state[cardListId].filter((cardId)=>cardId !== deletedCardId));
                return (0, (/*@__PURE__*/$parcel$interopDefault($sLb2Q)))(cardListIds, filteredLists);
            }
        case 0, $hf5c2.CARD_CREATE_UNMAPPED_WITH_ISSUE_LINK:
            {
                const cardListIds = Object.keys(state);
                const deletedCardIds = action.payload.cardsIdentifiers.map((cardIds)=>cardIds.id);
                const filteredLists = cardListIds.map((cardListId)=>state[cardListId].filter((cardId)=>!deletedCardIds.includes(cardId)));
                return (0, (/*@__PURE__*/$parcel$interopDefault($sLb2Q)))(cardListIds, filteredLists);
            }
        case 0, $jkFPs.SPRINT_CREATE_REQUEST:
            return (0, $7uUwQ.set)(state, action.payload.temporaryCardListId, []);
        case 0, $jkFPs.SPRINT_CREATE_SUCCESS:
            return (0, $7uUwQ.chain)(state).unset(action.payload.temporaryCardListId).set(action.payload.sprint.id, []).value();
        case 0, $d09wv.SPRINT_DELETE_REQUEST:
            {
                const { payload: { nextCardListId: nextCardListId, sprintId: sprintId } } = action;
                if (!nextCardListId) return (0, $7uUwQ.unset)(state, sprintId);
                return (0, $7uUwQ.chain)(state).set(nextCardListId, state[sprintId].concat(state[nextCardListId])).unset(sprintId).value();
            }
        case 0, $hf5c2.CARD_CREATE_END_OF_BACKLOG_OPTIMISTIC:
            {
                const { changeEvent: changeEvent } = action.payload;
                if (changeEvent.type === (0, $FTaAj.ChangeEventTypes).CHILD_ISSUE_ADDED) {
                    const { meta: { childIssue: { id: id } } } = changeEvent;
                    return {
                        ...state,
                        [(0, $guzeq.BACKLOG)]: [
                            ...state[0, $guzeq.BACKLOG],
                            Number(id)
                        ]
                    };
                }
                return state;
            }
        case 0, $7X18B.CARDS_BULK_OPERATIONS_DELETE_REQUESTS:
            {
                const cardListIds = Object.keys(state);
                const deletedCardIds = action.payload.flatMap(({ cardIds: cardIds })=>cardIds);
                const filteredLists = cardListIds.map((cardListId)=>state[cardListId].filter((cardId)=>!deletedCardIds.includes(cardId)));
                return (0, (/*@__PURE__*/$parcel$interopDefault($sLb2Q)))(cardListIds, filteredLists);
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("aLuWu", function(module, exports) {

$parcel$export(module.exports, "default", () => $e47007ce3481c726$export$2e2bcd8739ae039);

var $3JOCw = parcelRequire("3JOCw");

var $3lZ6i = parcelRequire("3lZ6i");
const $e47007ce3481c726$var$defaultState = [];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e47007ce3481c726$export$2e2bcd8739ae039 = (state = $e47007ce3481c726$var$defaultState, action)=>{
    switch(action.type){
        case 0, $3lZ6i.SET_APP_DATA:
            // cardTypes will not be provided in the payload for CMP
            return action.payload.entities.cardTypes || state;
        case 0, $3lZ6i.LOAD_CARD_CREATE_CONFIG_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))([
                ...action.payload.cardTypes,
                ...state
            ], 'id');
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("5nW8W", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5adb40fb42e31da$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $gccSB = parcelRequire("gccSB");

var $gULOk = parcelRequire("gULOk");

var $FTaAj = parcelRequire("FTaAj");

var $4R6GH = parcelRequire("4R6GH");

var $3lZ6i = parcelRequire("3lZ6i");

var $2HxVZ = parcelRequire("2HxVZ");

var $g4P00 = parcelRequire("g4P00");

var $eSSqy = parcelRequire("eSSqy");

var $7X18B = parcelRequire("7X18B");

var $hf5c2 = parcelRequire("hf5c2");

var $legw4 = parcelRequire("legw4");

var $aKajY = parcelRequire("aKajY");

var $6GNN7 = parcelRequire("6GNN7");

var $et6P7 = parcelRequire("et6P7");

var $fdAim = parcelRequire("fdAim");

var $3EtSK = parcelRequire("3EtSK");

var $gkSeR = parcelRequire("gkSeR");

var $c7Xu8 = parcelRequire("c7Xu8");

var $czUNp = parcelRequire("czUNp");

var $kB9og = parcelRequire("kB9og");

var $hqokg = parcelRequire("hqokg");

var $ksTa3 = parcelRequire("ksTa3");
const $c5adb40fb42e31da$var$defaultState = {};
const $c5adb40fb42e31da$var$updateCardFlags = (state, { payload: { cards: cards, flag: flag } })=>{
    const chainedState = (0, $7uUwQ.chain)(state);
    cards.forEach((id)=>chainedState.assocIn([
            String(id),
            'isFlagged'
        ], flag));
    return chainedState.value();
};
const $c5adb40fb42e31da$var$updateCardsParent = (state, { payload: { cards: cards, parentId: parentId } })=>{
    const chainedState = (0, $7uUwQ.chain)(state);
    cards.forEach((card)=>chainedState.assocIn([
            String(card.id),
            'parentId'
        ], parentId));
    return chainedState.value();
};
const $c5adb40fb42e31da$var$updateCardsDetails = (state, payload)=>{
    const chainedState = (0, $7uUwQ.chain)(state);
    payload.forEach(({ cardIds: cardIds, data: data })=>{
        const dataTransformer = (0, $ksTa3.transformBulkOperationsData)(data);
        cardIds.forEach((cardId)=>{
            const id = String(cardId);
            const newData = dataTransformer(state[id]);
            const newCardData = (0, $7uUwQ.chain)(state[id]).assign(newData);
            chainedState.assoc(id, newCardData.value());
        });
    });
    return chainedState.value();
};
const $c5adb40fb42e31da$var$setCardStatus = (state, { payload: { cardId: cardId, statusId: statusId, statusCategory: statusCategory, isCMP: isCMP } })=>{
    const chainedState = (0, $7uUwQ.chain)(state);
    chainedState.assocIn([
        String(cardId),
        'statusId'
    ], statusId);
    // We use `isDone` to show issue key strikethrough as an indicator of issue resolution.
    // Only for TMP, status' category equaling `Done` means the issue is resolved.
    // For CMP, we cannot determine an issue's resolution completely client-side due to the complexities of non-simplified workflows.
    // As we're fire a data refresh request on each issue transition for CMP, the correct `isDone` value will be pulled from the server anyway with a slight delay.
    if (!isCMP) {
        const isDone = (0, $gULOk.StatusCategoryIds)[statusCategory] === (0, $gULOk.StatusCategoryIds)[(0, $gULOk.StatusCategoryTypes).DONE];
        chainedState.assocIn([
            String(cardId),
            'isDone'
        ], isDone);
    }
    return chainedState.value();
};
const $c5adb40fb42e31da$var$setCardEstimate = (state, { payload: { cardId: cardId, estimate: estimate } })=>{
    const chainedState = (0, $7uUwQ.chain)(state);
    chainedState.merge({
        [String(cardId)]: {
            estimate: estimate
        }
    });
    return chainedState.value();
};
const $c5adb40fb42e31da$var$setCardAssignee = (state, { payload: { cardId: cardId, assignee: assignee } })=>{
    const chainedState = (0, $7uUwQ.chain)(state);
    chainedState.assocIn([
        String(cardId),
        'assignee'
    ], assignee);
    return chainedState.value();
};
const $c5adb40fb42e31da$var$setCardSummary = (state, { payload: { cardId: cardId, summary: summary } })=>{
    const chainedState = (0, $7uUwQ.chain)(state);
    chainedState.assocIn([
        String(cardId),
        'summary'
    ], summary);
    return chainedState.value();
};
const $c5adb40fb42e31da$var$setCardParentId = (state, { payload: { cardId: cardId, parentId: parentId } })=>{
    const chainedState = (0, $7uUwQ.chain)(state);
    chainedState.assocIn([
        String(cardId),
        'parentId'
    ], parentId);
    return chainedState.value();
};
const $c5adb40fb42e31da$var$setCardParent = (state, { payload: { cardId: cardId, parent: parent } })=>{
    const chainedState = (0, $7uUwQ.chain)(state);
    chainedState.assocIn([
        String(cardId),
        'parentId'
    ], (parent?.id && Number(parent.id)) ?? null).assocIn([
        String(cardId),
        'parentKey'
    ], parent?.key ?? null);
    return chainedState.value();
};
const $c5adb40fb42e31da$var$setCardTargetStatusId = (state, { payload: { cardIds: cardIds, targetStatusId: targetStatusId } })=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(cardIds) || targetStatusId === undefined) return state;
    const chainedState = (0, $7uUwQ.chain)(state);
    cardIds.forEach((cardId)=>{
        chainedState.assocIn([
            String(cardId),
            'statusId'
        ], targetStatusId);
    });
    return chainedState.value();
};
const $c5adb40fb42e31da$var$setCardPriority = (state, { payload: { cardId: cardId, priority: priority } })=>{
    const { id: id, ...cardPriority } = priority;
    const chainedState = (0, $7uUwQ.chain)(state);
    chainedState.assocIn([
        String(cardId),
        'priority'
    ], cardPriority);
    return chainedState.value();
};
const $c5adb40fb42e31da$var$cardReducer = (state = $c5adb40fb42e31da$var$defaultState, action)=>{
    switch(action.type){
        case 0, $3lZ6i.SET_APP_DATA:
            return action.payload.entities.card;
        case 0, $hf5c2.CARD_CREATE_MULTIPLE_REQUEST:
            {
                const { tempIds: tempIds, summaries: summaries, typeId: typeId, typeIcon: typeIcon } = action.payload;
                const chainState = (0, $7uUwQ.chain)(state);
                const defaultCardProps = {
                    key: '',
                    labels: [],
                    assignee: null,
                    isDone: false,
                    isFlagged: false,
                    issueUrl: '',
                    statusId: '',
                    parentId: null,
                    priority: null,
                    dueDate: null,
                    estimate: null,
                    numCompleteChildren: 0,
                    numTotalChildren: 0,
                    fixVersions: []
                };
                for(let i = 0; i < tempIds.length; i += 1){
                    const tempId = tempIds[i];
                    const summary = summaries[i];
                    chainState.set(String(tempId), {
                        ...defaultCardProps,
                        summary: summary,
                        id: tempId,
                        icon: typeIcon,
                        typeId: typeId
                    });
                }
                return chainState.value();
            }
        case 0, $hf5c2.CARD_CREATE_SUCCESS:
            {
                const { card: card, temporaryCardId: temporaryCardId } = action.payload;
                return (0, $7uUwQ.chain)(state).unset(String(temporaryCardId)).set(String(card.id), card).value();
            }
        case 0, $6GNN7.CARDS_MOVE_REQUEST:
        case 0, $6GNN7.CARDS_MOVE_SUCCESS:
            return $c5adb40fb42e31da$var$setCardTargetStatusId(state, action);
        case 0, $aKajY.CARDS_FLAG_WITH_COMMENT_REQUEST:
            return $c5adb40fb42e31da$var$updateCardFlags(state, action);
        case 0, $legw4.CARD_DELETE_REQUEST:
        case 0, $legw4.CARD_DELETE:
            return (0, $7uUwQ.unset)(state, String(action.payload.cardId));
        case 0, $hf5c2.CARD_CREATE_UNMAPPED_WITH_ISSUE_LINK:
            {
                const stateChain = (0, $7uUwQ.chain)(state);
                action.payload.cardsIdentifiers.forEach(({ id: id })=>{
                    stateChain.unset(String(id));
                });
                return stateChain.value();
            }
        case 0, $fdAim.CARD_REFRESH_REQUEST:
            {
                const { cardId: cardId, changeEvent: changeEvent } = action.payload;
                if (cardId == null || !changeEvent) return state;
                const cardIdStr = String(cardId);
                const oldCard = state[cardIdStr];
                if (!oldCard) // This should only happen when the updated card is a subtask which doesn't exist in the state
                return state;
                const optimisticCard = (0, $ksTa3.updateCardWithChangeEvent)(oldCard, changeEvent);
                return (0, $7uUwQ.set)(state, cardIdStr, optimisticCard);
            }
        case 0, $fdAim.CARD_REFRESH_SUCCESS:
            return (0, $7uUwQ.set)(state, String(action.payload.id), action.payload);
        case 0, $et6P7.CARDS_PARENT_SET_OPTIMISTIC:
            return $c5adb40fb42e31da$var$updateCardsParent(state, action);
        case 0, $hf5c2.CARD_CREATE_END_OF_BACKLOG_OPTIMISTIC:
            {
                const { changeEvent: changeEvent } = action.payload;
                if (changeEvent.type === (0, $FTaAj.ChangeEventTypes).CHILD_ISSUE_ADDED) {
                    const [cardId, newCard] = (0, $ksTa3.buildCardFromEvent)(changeEvent);
                    return (0, $7uUwQ.set)(state, cardId, newCard);
                }
                return state;
            }
        case 0, $czUNp.CARD_STATUS_SET:
            return $c5adb40fb42e31da$var$setCardStatus(state, action);
        case 0, $3EtSK.CARD_ESTIMATE_SET_OPTIMISTIC:
        case 0, $3EtSK.CARD_ESTIMATE_SET:
            return $c5adb40fb42e31da$var$setCardEstimate(state, action);
        case 0, $2HxVZ.CARD_ASSIGNEE_SET_OPTIMISTIC:
        case 0, $g4P00.ASSIGN_TO_ME_REQUEST:
        case 0, $2HxVZ.CARD_ASSIGNEE_SET:
            return $c5adb40fb42e31da$var$setCardAssignee(state, action);
        case 0, $kB9og.CARD_SUMMARY_SET:
            return $c5adb40fb42e31da$var$setCardSummary(state, action);
        case 0, $gkSeR.CARD_PARENT_ID_SET:
            return $c5adb40fb42e31da$var$setCardParentId(state, action);
        case 0, $gkSeR.CARD_PARENT_SET_OPTIMISTIC:
            return $c5adb40fb42e31da$var$setCardParent(state, action);
        case 0, $c7Xu8.CARD_PRIORITY_SET_OPTIMISTIC:
        case 0, $c7Xu8.CARD_PRIORITY_SET:
            return $c5adb40fb42e31da$var$setCardPriority(state, action);
        case 0, $eSSqy.CARDS_BULK_OPERATIONS_REQUESTS:
            return $c5adb40fb42e31da$var$updateCardsDetails(state, action.payload);
        case 0, $7X18B.CARDS_BULK_OPERATIONS_DELETE_REQUESTS:
            {
                const stateChain = (0, $7uUwQ.chain)(state);
                action.payload.forEach(({ cardIds: cardIds })=>{
                    Object.entries(state).forEach(([cardId, value])=>{
                        if (cardIds.includes(Number(cardId)) || value.parentId !== null && cardIds.includes(value.parentId)) stateChain.unset(String(cardId));
                    });
                });
                return stateChain.value();
            }
        case 0, $hqokg.ISSUE_PARENT_PATCH:
            {
                if (!(0, $4R6GH.fg)('jsw-backlog-parent-field-render')) return state;
                const newState = (0, $7uUwQ.chain)(state);
                for (const [key, value] of Object.entries(state))if (value.parent?.id === action.payload.id) newState.merge({
                    [key]: {
                        parent: action.payload.issueParent
                    }
                });
                return newState.value();
            }
        default:
            return state;
    }
};
var $c5adb40fb42e31da$export$2e2bcd8739ae039 = $c5adb40fb42e31da$var$cardReducer;

});
parcelRegister("2HxVZ", function(module, exports) {

$parcel$export(module.exports, "CARD_ASSIGNEE_SET", () => $3fac26e3bede51bd$export$8592163118330a98);
$parcel$export(module.exports, "cardAssigneeSet", () => $3fac26e3bede51bd$export$6b6e5f1997c8a08c);
$parcel$export(module.exports, "CARD_ASSIGNEE_SET_OPTIMISTIC", () => $3fac26e3bede51bd$export$b43ad5b0028f1504);
$parcel$export(module.exports, "cardAssigneeSetOptimistic", () => $3fac26e3bede51bd$export$dfd208865fa6a432);

var $5fc53 = parcelRequire("5fc53");

var $6JzCg = parcelRequire("6JzCg");
const $3fac26e3bede51bd$export$8592163118330a98 = 'state.actions.assignee.CARD_ASSIGNEE_SET';
const $3fac26e3bede51bd$export$6b6e5f1997c8a08c = (cardId, assignee)=>({
        type: $3fac26e3bede51bd$export$8592163118330a98,
        payload: {
            cardId: cardId,
            assignee: assignee
        }
    });
const $3fac26e3bede51bd$export$b43ad5b0028f1504 = 'state.actions.assignee.CARD_ASSIGNEE_SET_OPTIMISTIC';
const $3fac26e3bede51bd$export$dfd208865fa6a432 = (payload, issueKey, analyticsEvent)=>({
        type: $3fac26e3bede51bd$export$b43ad5b0028f1504,
        payload: payload,
        meta: {
            ...(0, $6JzCg.setCardSetMeta)({
                issueKey: issueKey,
                fieldId: (0, $5fc53.ASSIGNEE_TYPE),
                newValue: payload.assignee,
                retryAction: ()=>$3fac26e3bede51bd$export$dfd208865fa6a432(payload, issueKey, analyticsEvent)
            }, analyticsEvent)
        }
    });

});

parcelRegister("3EtSK", function(module, exports) {

$parcel$export(module.exports, "CARD_ESTIMATE_SET", () => $00f2538e16fb2889$export$3b7d1bc5ea31bea3);
$parcel$export(module.exports, "cardEstimateSet", () => $00f2538e16fb2889$export$a8708880a95d91af);
$parcel$export(module.exports, "CARD_ESTIMATE_SET_OPTIMISTIC", () => $00f2538e16fb2889$export$c1b2b9b852128ca2);
$parcel$export(module.exports, "cardEstimateSetOptimistic", () => $00f2538e16fb2889$export$7f4e1182c4ce5ed4);

var $6JzCg = parcelRequire("6JzCg");
const $00f2538e16fb2889$export$3b7d1bc5ea31bea3 = 'state.actions.estimate.CARD_ESTIMATE_SET';
const $00f2538e16fb2889$export$a8708880a95d91af = (cardId, estimate)=>({
        type: $00f2538e16fb2889$export$3b7d1bc5ea31bea3,
        payload: {
            cardId: cardId,
            estimate: estimate
        }
    });
const $00f2538e16fb2889$export$c1b2b9b852128ca2 = 'state.actions.estimate.CARD_ESTIMATE_SET_OPTIMISTIC';
const $00f2538e16fb2889$export$7f4e1182c4ce5ed4 = (payload, cardSet, analyticsEvent)=>({
        type: $00f2538e16fb2889$export$c1b2b9b852128ca2,
        payload: payload,
        meta: (0, $6JzCg.setCardSetMeta)({
            issueKey: cardSet.issueKey,
            fieldId: cardSet.estimationFieldId,
            newValue: payload.estimate.originalEstimate ? {
                originalEstimate: payload.estimate.originalEstimate.valueAsText
            } : payload.estimate.storyPoints,
            retryAction: ()=>$00f2538e16fb2889$export$7f4e1182c4ce5ed4(payload, cardSet, analyticsEvent)
        }, analyticsEvent)
    });

});

parcelRegister("gkSeR", function(module, exports) {

$parcel$export(module.exports, "CARD_PARENT_ID_SET", () => $e2205286ea0004b9$export$765aff4d74f630ef);
$parcel$export(module.exports, "cardParentIdSet", () => $e2205286ea0004b9$export$8e5862c35c9d4ec6);
$parcel$export(module.exports, "CARD_PARENT_SET_OPTIMISTIC", () => $e2205286ea0004b9$export$e771cf2ac685cb14);
$parcel$export(module.exports, "cardParentSetOptimistic", () => $e2205286ea0004b9$export$f5008334a98f6790);

var $5fc53 = parcelRequire("5fc53");

var $6JzCg = parcelRequire("6JzCg");
const $e2205286ea0004b9$export$765aff4d74f630ef = 'state.actions.parent.CARD_PARENT_ID_SET';
const $e2205286ea0004b9$export$8e5862c35c9d4ec6 = (cardId, parentId)=>({
        type: $e2205286ea0004b9$export$765aff4d74f630ef,
        payload: {
            cardId: cardId,
            parentId: parentId
        }
    });
const $e2205286ea0004b9$export$e771cf2ac685cb14 = 'state.actions.priorities.CARD_PARENT_SET_OPTIMISTIC';
const $e2205286ea0004b9$export$f5008334a98f6790 = (payload, issueKey, analyticsEvent)=>({
        type: $e2205286ea0004b9$export$e771cf2ac685cb14,
        payload: payload,
        meta: {
            ...(0, $6JzCg.setCardSetMeta)({
                fieldId: (0, $5fc53.PARENT_TYPE),
                issueKey: issueKey,
                newValue: payload.parent,
                retryAction: ()=>$e2205286ea0004b9$export$f5008334a98f6790(payload, issueKey, analyticsEvent)
            }, analyticsEvent)
        }
    });

});

parcelRegister("kB9og", function(module, exports) {

$parcel$export(module.exports, "CARD_SUMMARY_SET", () => $1550bb03b278d689$export$447c8cffca6dd3a0);
$parcel$export(module.exports, "cardSummarySet", () => $1550bb03b278d689$export$4584175580349cb0);
const $1550bb03b278d689$export$447c8cffca6dd3a0 = 'state.actions.summary.CARD_SUMMARY_SET';
const $1550bb03b278d689$export$4584175580349cb0 = (cardId, summary)=>({
        type: $1550bb03b278d689$export$447c8cffca6dd3a0,
        payload: {
            cardId: cardId,
            summary: summary
        }
    });

});

parcelRegister("ksTa3", function(module, exports) {

$parcel$export(module.exports, "updateCardWithChangeEvent", () => $d2513729104fe39d$export$55ea42a298d73e4f);
$parcel$export(module.exports, "buildCardFromEvent", () => $d2513729104fe39d$export$818d870b4da795a8);
$parcel$export(module.exports, "transformBulkOperationsData", () => $d2513729104fe39d$export$bbf3856ca410a627);
/* NOTE:
 * This module is mapping bento change events onto card updates for backlog optimistic state updates.
 * Handling is separated onto different functions to improve documentation.
 */ 
var $dPSWJ = parcelRequire("dPSWJ");

var $FTaAj = parcelRequire("FTaAj");

const $d2513729104fe39d$export$6232590629abe6b = (oldCard, changeEvent)=>({
        ...oldCard,
        summary: changeEvent.meta.fieldValue || ''
    });
/**
 * Apply a bento labels change event onto a card.
 * We assume that fieldValue will be an array of strings.
 */ const $d2513729104fe39d$var$updateCardWithLabelsChangeEvent = (oldCard, changeEvent)=>({
        ...oldCard,
        labels: changeEvent.meta.fieldValue
    });
const $d2513729104fe39d$var$updateCardWithParentChangeEvent = (oldCard, changeEvent)=>({
        ...oldCard,
        parentId: Number(changeEvent.meta.newParentIssueId)
    });
const $d2513729104fe39d$export$55ea42a298d73e4f = (oldCard, changeEvent)=>{
    if (changeEvent.type === (0, $FTaAj.ChangeEventTypes).ISSUE_RELATIONSHIP_UPDATED) return $d2513729104fe39d$var$updateCardWithParentChangeEvent(oldCard, changeEvent);
    if (changeEvent.type === (0, $FTaAj.ChangeEventTypes).FIELD_CHANGE_REQUESTED || changeEvent.type === (0, $FTaAj.ChangeEventTypes).FIELD_CHANGED) switch(changeEvent.meta.fieldId){
        case 0, $e9be48d6d2c01760$export$e7cf1830fe735d1f:
            return $d2513729104fe39d$export$6232590629abe6b(oldCard, changeEvent);
        case 0, $e9be48d6d2c01760$export$93605f2a09aa8d26:
            return $d2513729104fe39d$var$updateCardWithLabelsChangeEvent(oldCard, changeEvent);
        default:
            return oldCard;
    }
    return oldCard;
};
const $d2513729104fe39d$export$818d870b4da795a8 = (changeEvent)=>{
    const { issueId: issueId, meta: { childIssue: { id: id, issueKey: issueKey, issueLink: issueLink, issueSummary: issueSummary, issueTypeIconUrl: issueTypeIconUrl, issueTypeName: issueTypeName } } } = changeEvent;
    const card = {
        id: Number(id),
        key: issueKey || '',
        statusId: '',
        issueUrl: issueLink || '',
        summary: issueSummary || '',
        icon: issueTypeIconUrl || '',
        typeId: 0,
        labels: [],
        assignee: null,
        parentId: Number(issueId),
        parent: null,
        priority: null,
        dueDate: null,
        estimate: null,
        fixVersions: [],
        numCompleteChildren: 0,
        numTotalChildren: 0,
        isDone: false,
        isFlagged: false,
        projectId: 0,
        issueTypeName: issueTypeName || ''
    };
    return [
        String(id),
        card
    ];
};
const $d2513729104fe39d$export$5a286d741e9c601b = (input, action, data)=>{
    if (action === 'add') {
        const filtered = data.filter((value)=>!input.includes(value));
        return [
            ...input,
            ...filtered
        ];
    }
    if (action === 'remove') return input.filter((value)=>!data.includes(value));
    if (action === 'set') return data;
    return input;
};
const $d2513729104fe39d$var$transformData = (cardData)=>(data, key)=>{
        if (key === 'labels') {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-non-null-assertion
            const { action: action, value: value } = data;
            return $d2513729104fe39d$export$5a286d741e9c601b(cardData.labels, action, value);
        }
        if (key === 'fixVersions' && cardData.fixVersions) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-non-null-assertion
            const { action: action, value: value } = data;
            return $d2513729104fe39d$export$5a286d741e9c601b(cardData.fixVersions, action, value);
        }
        return data;
    };
const $d2513729104fe39d$export$bbf3856ca410a627 = (data)=>(cardData)=>(0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(data, $d2513729104fe39d$var$transformData(cardData));

});


parcelRegister("cj2CS", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d5af50e815cc815$export$2e2bcd8739ae039);

var $3lZ6i = parcelRequire("3lZ6i");

var $cPahM = parcelRequire("cPahM");
const $6d5af50e815cc815$var$defaultState = null;
function $6d5af50e815cc815$export$2e2bcd8739ae039(state = $6d5af50e815cc815$var$defaultState, action) {
    switch(action.type){
        case 0, $3lZ6i.LOAD_CONFIG_DATA_MODEL_SUCCESS:
            return action.payload.columns;
        case 0, $cPahM.SET_COLUMNS:
            return action.payload.columns;
        default:
            return state;
    }
}

});

parcelRegister("3Ek8N", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6da2bf71e72d802$export$2e2bcd8739ae039);

var $j8DrX = parcelRequire("j8DrX");

var $4R6GH = parcelRequire("4R6GH");

var $bI3co = parcelRequire("bI3co");
const $c6da2bf71e72d802$var$defaultState = ()=>{
    if (!(0, $4R6GH.fg)('backlog-assignee-filter-sort-fix')) return null;
    const id = (0, $j8DrX.default)('ajs-atlassian-account-id');
    if (!id) return null;
    return {
        id: id,
        avatarUrl: '',
        displayName: ''
    };
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c6da2bf71e72d802$export$2e2bcd8739ae039 = (state = $c6da2bf71e72d802$var$defaultState(), action)=>{
    switch(action.type){
        case 0, $bI3co.SET_CURRENT_USER:
            return action.payload;
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});

parcelRegister("hDT0g", function(module, exports) {

$parcel$export(module.exports, "customFiltersReducer", () => $2ef1369b2c794365$export$dbd98ee5f91df1a);

var $3lZ6i = parcelRequire("3lZ6i");

var $DBM4S = parcelRequire("DBM4S");
const $2ef1369b2c794365$var$initialState = {
    filters: []
};
function $2ef1369b2c794365$export$dbd98ee5f91df1a(state = $2ef1369b2c794365$var$initialState, action) {
    switch(action.type){
        case 0, $3lZ6i.LOAD_CONFIG_DATA_MODEL_SUCCESS:
            {
                const filters = action.payload.entities.quickFilters;
                return {
                    filters: filters
                };
            }
        case 0, $DBM4S.SET_CUSTOM_FILTERS:
            return {
                filters: action.payload
            };
        default:
            return state;
    }
}

});
parcelRegister("DBM4S", function(module, exports) {

$parcel$export(module.exports, "SET_CUSTOM_FILTERS", () => $657cbfa22776c80f$export$6388e83e9b720843);
const $657cbfa22776c80f$export$6388e83e9b720843 = 'state.actions.custom-filters.SET_CUSTOM_FILTERS';
function $657cbfa22776c80f$export$5500f63fa8214463(customFilters) {
    return {
        type: $657cbfa22776c80f$export$6388e83e9b720843,
        payload: customFilters
    };
}

});


parcelRegister("d74Q9", function(module, exports) {

$parcel$export(module.exports, "default", () => $a27226ad5e664250$export$2e2bcd8739ae039);

var $guzeq = parcelRequire("guzeq");

var $3lZ6i = parcelRequire("3lZ6i");
const $a27226ad5e664250$var$defaultState = {
    isEstimationFeatureEnabled: false,
    estimationType: (0, $guzeq.ISSUE_COUNT),
    estimationFieldId: null,
    name: ''
};
function $a27226ad5e664250$export$2e2bcd8739ae039(state = $a27226ad5e664250$var$defaultState, action) {
    if (action.type === (0, $3lZ6i.SET_APP_DATA) || action.type === (0, $3lZ6i.SET_CONFIG_DATA) || action.type === (0, $3lZ6i.LOAD_CONFIG_DATA_MODEL_SUCCESS)) {
        if (!action.payload.entities.estimation) return state;
        const { isEstimationFeatureEnabled: isEstimationFeatureEnabled, estimationType: estimationType, estimationFieldId: estimationFieldId, name: name } = action.payload.entities.estimation || {};
        return {
            isEstimationFeatureEnabled: isEstimationFeatureEnabled || false,
            estimationType: estimationType || (0, $guzeq.ISSUE_COUNT),
            estimationFieldId: estimationFieldId || null,
            name: name || ''
        };
    }
    return state;
}

});

parcelRegister("lRpaB", function(module, exports) {

$parcel$export(module.exports, "default", () => $057994c0da7e174b$export$2e2bcd8739ae039);

var $3lZ6i = parcelRequire("3lZ6i");

var $7zF3i = parcelRequire("7zF3i");
const $057994c0da7e174b$var$defaultState = {
    sessionId: undefined,
    cardTypeIds: []
};
const $057994c0da7e174b$var$projectReducer = (state = $057994c0da7e174b$var$defaultState, action)=>{
    switch(action.type){
        case 0, $3lZ6i.SET_APP_DATA:
            if (!action.payload.entities.inlineCreate?.cardTypeIds) return state;
            return {
                ...state,
                cardTypeIds: action.payload.entities.inlineCreate.cardTypeIds
            };
        case 0, $7zF3i.SET_INLINE_CREATE_SESSION_ID:
            return {
                ...state,
                sessionId: action.payload.sessionId
            };
        case 0, $7zF3i.CLEAR_INLINE_CREATE_SESSION_ID:
            return {
                ...state,
                sessionId: undefined
            };
        case 0, $3lZ6i.LOAD_CARD_CREATE_CONFIG_SUCCESS:
            return {
                ...state,
                cardTypeIds: action.payload.cardTypes.map((t)=>t.id)
            };
        default:
            return state;
    }
};
var $057994c0da7e174b$export$2e2bcd8739ae039 = $057994c0da7e174b$var$projectReducer;

});

parcelRegister("aQATd", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd31245ddc321836$export$2e2bcd8739ae039);

var $3lZ6i = parcelRequire("3lZ6i");

var $c2Ik2 = parcelRequire("c2Ik2");

var $aCC3Y = parcelRequire("aCC3Y");
const $bd31245ddc321836$var$defaultState = [];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bd31245ddc321836$export$2e2bcd8739ae039 = (state = $bd31245ddc321836$var$defaultState, action)=>{
    switch(action.type){
        case 0, $3lZ6i.SET_APP_DATA:
            {
                const { payload: { entities: { issueParentsOrder: issueParentsOrder } } } = action;
                return issueParentsOrder || state;
            }
        case 0, $c2Ik2.ISSUE_PARENTS_CREATE_SET:
            {
                const issueParentIds = action.payload.issueParents.map((issueParent)=>issueParent.id);
                return [
                    ...state,
                    ...issueParentIds
                ];
            }
        case 0, $aCC3Y.LOAD_ISSUE_PARENTS_SUCCESS:
            return action.payload.issueParents.map((issueParent)=>issueParent.id);
        default:
            return state;
    }
};

});
parcelRegister("c2Ik2", function(module, exports) {

$parcel$export(module.exports, "ISSUE_PARENTS_CREATE_SET", () => $26e306c666ef0951$export$3491dc76ca1d517c);
$parcel$export(module.exports, "issueParentsCreateSet", () => $26e306c666ef0951$export$55d568aa4e952be5);
const $26e306c666ef0951$export$3491dc76ca1d517c = 'state.actions.issue-parents.create.ISSUE_PARENTS_CREATE_SET';
const $26e306c666ef0951$export$55d568aa4e952be5 = (payload)=>({
        type: $26e306c666ef0951$export$3491dc76ca1d517c,
        payload: payload
    });

});


parcelRegister("bA8dH", function(module, exports) {

$parcel$export(module.exports, "default", () => $411ecc0d42c08102$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $3lZ6i = parcelRequire("3lZ6i");

var $c2Ik2 = parcelRequire("c2Ik2");

var $aCC3Y = parcelRequire("aCC3Y");

var $hqokg = parcelRequire("hqokg");
const $411ecc0d42c08102$var$defaultState = {};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$411ecc0d42c08102$export$2e2bcd8739ae039 = (state = $411ecc0d42c08102$var$defaultState, action)=>{
    switch(action.type){
        case 0, $3lZ6i.SET_APP_DATA:
            {
                const { payload: { entities: { issueParents: issueParents } } } = action;
                return issueParents ? (0, $7uUwQ.freeze)(issueParents) : state;
            }
        case 0, $c2Ik2.ISSUE_PARENTS_CREATE_SET:
        case 0, $aCC3Y.LOAD_ISSUE_PARENTS_SUCCESS:
            {
                const { issueParents: issueParents } = action.payload;
                const chainedState = (0, $7uUwQ.chain)(state);
                issueParents.forEach((issueParent)=>{
                    chainedState.set(String(issueParent.id), issueParent);
                });
                return chainedState.value();
            }
        case 0, $hqokg.ISSUE_PARENT_PATCH:
            {
                const { issueParent: issueParent, id: id } = action.payload;
                const oldParent = state[id];
                if (!oldParent) return state;
                return (0, $7uUwQ.set)(state, id, (0, $7uUwQ.merge)(oldParent, issueParent));
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("bgxMB", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbbf3f4ba538b658$export$2e2bcd8739ae039);

var $hf5c2 = parcelRequire("hf5c2");
function $bbbf3f4ba538b658$export$2e2bcd8739ae039(state = null, action) {
    switch(action.type){
        case 0, $hf5c2.CARD_CREATE_SUCCESS:
            return action.payload.card.id;
        default:
            return state;
    }
}

});

parcelRegister("3zbT1", function(module, exports) {

$parcel$export(module.exports, "default", () => $f18bed784cbf1cd6$export$2e2bcd8739ae039);

var $c7Xu8 = parcelRequire("c7Xu8");
const $f18bed784cbf1cd6$var$defaultState = [];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f18bed784cbf1cd6$export$2e2bcd8739ae039 = (state = $f18bed784cbf1cd6$var$defaultState, action)=>{
    switch(action.type){
        case 0, $c7Xu8.LOAD_PRIORITIES_SUCCESS:
            return action.payload;
        default:
            return state;
    }
};

});

parcelRegister("9tayK", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f7ee976f15e1210$export$2e2bcd8739ae039);

var $3lZ6i = parcelRequire("3lZ6i");
const $2f7ee976f15e1210$var$defaultState = {
    projects: []
};
const $2f7ee976f15e1210$var$projectReducer = (state = $2f7ee976f15e1210$var$defaultState, action)=>{
    switch(action.type){
        case 0, $3lZ6i.SET_APP_DATA:
            return action.payload.entities.project ?? $2f7ee976f15e1210$var$defaultState;
        default:
            return state;
    }
};
var $2f7ee976f15e1210$export$2e2bcd8739ae039 = $2f7ee976f15e1210$var$projectReducer;

});

parcelRegister("7k9YH", function(module, exports) {

$parcel$export(module.exports, "trackingReducer", () => $b208c9e23d8eb089$export$9dc75892c8308f9d);

var $gccSB = parcelRequire("gccSB");

var $3lZ6i = parcelRequire("3lZ6i");
const $b208c9e23d8eb089$var$defaultState = {
    name: '',
    typeId: '',
    fieldId: '',
    isValid: false,
    isEnabled: false
};
const $b208c9e23d8eb089$export$9dc75892c8308f9d = (state = $b208c9e23d8eb089$var$defaultState, action)=>{
    if (action.type === (0, $3lZ6i.LOAD_CONFIG_DATA_MODEL_SUCCESS)) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(action?.payload?.entities?.tracking)) return state;
        return action.payload.entities.tracking;
    }
    return state;
};

});

parcelRegister("4Q0MU", function(module, exports) {

$parcel$export(module.exports, "default", () => $80c4a7c489606dff$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $3lZ6i = parcelRequire("3lZ6i");

var $gwOHY = parcelRequire("gwOHY");
const $80c4a7c489606dff$var$defaultState = {
    versions: []
};
const $80c4a7c489606dff$var$versionReducer = (state = $80c4a7c489606dff$var$defaultState, action)=>{
    switch(action.type){
        case 0, $3lZ6i.SET_APP_DATA:
            return action.payload.entities.version;
        case 0, $gwOHY.SET_VERSIONS:
            return action.payload;
        case 0, $gwOHY.UPDATE_VERSION:
            if (state.versions.includes(String(action.payload.version.id))) return state;
            return (0, $7uUwQ.chain)(state).setIn([
                'versions'
            ], (0, $7uUwQ.push)(state.versions, String(action.payload.version.id))).value();
        default:
            {
                // @ts-expect-error - TS2322: Type 'BatchAction | ShowErrorFlagAction | InitializeAppPropsAction | LoadAppDataAction | LoadAppDataFailureAction | ... 173 more ... | SetIncludeSubtasksAction' is not assignable to type 'never'.
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $80c4a7c489606dff$export$2e2bcd8739ae039 = $80c4a7c489606dff$var$versionReducer;

});

parcelRegister("4lJeG", function(module, exports) {

$parcel$export(module.exports, "versionsReducer", () => $5dce534f3702af64$export$3616d11dc800f8ee);

var $7uUwQ = parcelRequire("7uUwQ");

var $3lZ6i = parcelRequire("3lZ6i");

var $gwOHY = parcelRequire("gwOHY");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $5dce534f3702af64$var$defaultState = (0, $7uUwQ.freeze)({});
const $5dce534f3702af64$export$3616d11dc800f8ee = (state = $5dce534f3702af64$var$defaultState, action)=>{
    switch(action.type){
        case 0, $3lZ6i.SET_APP_DATA:
            return action.payload.entities.versions ? (0, $7uUwQ.freeze)(action.payload.entities.versions) : state;
        case 0, $gwOHY.UPDATE_VERSION:
            return (0, $7uUwQ.chain)(state).setIn([
                String(action.payload.version.id)
            ], action.payload.version).value();
        default:
            return state;
    }
};

});


parcelRegister("dN8hL", function(module, exports) {

$parcel$export(module.exports, "default", () => $6916925f142bc836$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $BsLUY = parcelRequire("BsLUY");

var $5c4HU = parcelRequire("5c4HU");

var $gWsfQ = parcelRequire("gWsfQ");

var $eNpIX = parcelRequire("eNpIX");

var $9wNs2 = parcelRequire("9wNs2");

var $70ywa = parcelRequire("70ywa");

var $bwP9g = parcelRequire("bwP9g");

var $cjd7v = parcelRequire("cjd7v");

var $jcM6E = parcelRequire("jcM6E");

var $e03Tz = parcelRequire("e03Tz");

var $6oZez = parcelRequire("6oZez");

var $fxbtA = parcelRequire("fxbtA");
function $6916925f142bc836$export$2e2bcd8739ae039() {
    return (0, $3f2cs.combineReducers)({
        boardIssueMoveDialog: (0, $BsLUY.default),
        cardList: (0, $5c4HU.default),
        cards: (0, $gWsfQ.default)(),
        detailView: (0, $eNpIX.detailViewReducer),
        issueTransitionModal: (0, $jcM6E.default),
        filters: (0, $70ywa.default),
        panels: (0, $6oZez.default),
        isConfigLoaded: (0, $bwP9g.default),
        isCriticalDataLoaded: (0, $cjd7v.default),
        modals: (0, $e03Tz.modalsReducer),
        drag: (0, $9wNs2.default),
        workloadModal: (0, $fxbtA.default)
    });
}

});
parcelRegister("BsLUY", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b74dcf9b47c6bd2$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $3qXBy = parcelRequire("3qXBy");
const $4b74dcf9b47c6bd2$var$closedState = (0, $7uUwQ.freeze)({
    isOpen: false
});
const $4b74dcf9b47c6bd2$var$openState = (0, $7uUwQ.freeze)({
    isOpen: true
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4b74dcf9b47c6bd2$export$2e2bcd8739ae039 = (state = $4b74dcf9b47c6bd2$var$closedState, action)=>{
    switch(action.type){
        case 0, $3qXBy.BOARD_ISSUE_MOVE_SHOW:
            return $4b74dcf9b47c6bd2$var$openState;
        case 0, $3qXBy.BOARD_ISSUE_MOVE_CANCEL:
            return $4b74dcf9b47c6bd2$var$closedState;
        case 0, $3qXBy.BOARD_ISSUE_MOVE_EXECUTE:
            return $4b74dcf9b47c6bd2$var$closedState;
        default:
            return state;
    }
};

});

parcelRegister("5c4HU", function(module, exports) {

$parcel$export(module.exports, "default", () => $40f0d1bc673341fc$export$2e2bcd8739ae039);

var $fr1K2 = parcelRequire("fr1K2");

var $sLb2Q = parcelRequire("sLb2Q");

var $a7yHf = parcelRequire("a7yHf");

var $jkFPs = parcelRequire("jkFPs");
const $40f0d1bc673341fc$var$defaultState = {
    collapsed: {},
    disabled: {},
    recentCreatedId: undefined,
    dragState: {},
    isDragging: false,
    isDraggingSubtask: false,
    cardGroupCollapsed: {},
    cardGroupExpanded: {}
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$40f0d1bc673341fc$export$2e2bcd8739ae039 = (state = $40f0d1bc673341fc$var$defaultState, action)=>{
    switch(action.type){
        case 0, $a7yHf.CARD_LIST_TOGGLE:
            {
                const { cardListId: cardListId } = action.payload;
                if (state.collapsed[cardListId]) return {
                    ...state,
                    collapsed: (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(state.collapsed, cardListId)
                };
                return {
                    ...state,
                    collapsed: {
                        ...state.collapsed,
                        [cardListId]: true
                    }
                };
            }
        case 0, $a7yHf.SET_COLLAPSED_CARD_LIST:
            return {
                ...state,
                collapsed: (0, (/*@__PURE__*/$parcel$interopDefault($sLb2Q)))(action.payload.cardListIds, Array(action.payload.cardListIds.length).fill(true))
            };
        case 0, $a7yHf.CARD_LISTS_DISABLE:
            {
                const newDisabled = action.payload.cardListIds.reduce(// eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                (disabled, cardListId)=>({
                        ...disabled,
                        [cardListId]: true
                    }), {
                    ...state.disabled
                });
                return {
                    ...state,
                    disabled: newDisabled
                };
            }
        case 0, $a7yHf.CARD_LISTS_ENABLE_ALL:
            return {
                ...state,
                disabled: {}
            };
        case 0, $jkFPs.SPRINT_CREATE_SUCCESS:
            {
                const { payload: { sprint: { id: id } } } = action;
                return {
                    ...state,
                    recentCreatedId: id
                };
            }
        case 0, $a7yHf.CARD_LIST_DRAG_START:
            {
                const newDragInProgress = action.payload.cardListIds.reduce((dragInProgress, cardListId)=>Object.assign(dragInProgress, {
                        [cardListId]: cardListId === action.payload.sourceCardListId
                    }), {
                    ...state.dragState
                });
                return {
                    ...state,
                    dragState: newDragInProgress,
                    isDragging: true,
                    isDraggingSubtask: action.payload.sourceCardGroupId !== undefined
                };
            }
        case 0, $a7yHf.CARD_LIST_DRAG_END:
            return {
                ...state,
                dragState: {},
                isDragging: false,
                isDraggingSubtask: false
            };
        case 0, $a7yHf.CARD_GROUP_TOGGLE:
            {
                const { parentId: parentId } = action.payload;
                if (state.cardGroupExpanded[parentId]) return {
                    ...state,
                    cardGroupExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(state.cardGroupExpanded, parentId)
                };
                return {
                    ...state,
                    cardGroupExpanded: {
                        ...state.cardGroupExpanded,
                        [parentId]: true
                    }
                };
            }
        case 0, $a7yHf.SET_COLLAPSED_CARD_GROUP:
            return {
                ...state,
                cardGroupCollapsed: (0, (/*@__PURE__*/$parcel$interopDefault($sLb2Q)))(action.payload.parentIds, Array(action.payload.parentIds.length).fill(true))
            };
        case 0, $a7yHf.CLEAR_COLLAPSED_CARD_GROUP:
            {
                const { parentId: parentId } = action.payload;
                return {
                    ...state,
                    cardGroupCollapsed: (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(state.cardGroupCollapsed, parentId)
                };
            }
        case 0, $a7yHf.SET_EXPANDED_CARD_GROUP:
            {
                const expandedCardGroup = [
                    ...Object.keys(state.cardGroupExpanded),
                    ...action.payload.parentIds
                ];
                return {
                    ...state,
                    cardGroupExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($sLb2Q)))(expandedCardGroup, Array(expandedCardGroup.length).fill(true))
                };
            }
        case 0, $a7yHf.CLEAR_EXPANDED_CARD_GROUP:
            {
                const { parentId: parentId } = action.payload;
                return {
                    ...state,
                    cardGroupExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(state.cardGroupExpanded, parentId)
                };
            }
        case 0, $a7yHf.COLLAPSE_ALL_CARD_GROUPS:
            return {
                ...state,
                cardGroupExpanded: {}
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("gWsfQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b9d90186d2b3ab1$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $2h5Y8 = parcelRequire("2h5Y8");

var $l7QHW = parcelRequire("l7QHW");

var $k2nID = parcelRequire("k2nID");

var $a1yUO = parcelRequire("a1yUO");

var $2XYpA = parcelRequire("2XYpA");

var $bFper = parcelRequire("bFper");

var $5i1vv = parcelRequire("5i1vv");

var $8PUI4 = parcelRequire("8PUI4");

var $6MSgp = parcelRequire("6MSgp");
function $4b9d90186d2b3ab1$export$2e2bcd8739ae039() {
    return (0, $3f2cs.combineReducers)({
        richCard: (0, $8PUI4.richCardReducer),
        selected: (0, $6MSgp.selectedReducer),
        lastSelectedCardKey: (0, $bFper.lastSelectedCardKeyReducer),
        listSelectionRelativeCard: (0, $5i1vv.listSelectionRelativeCardReducer),
        focused: (0, $2XYpA.focusedReducer),
        filteredCards: (0, $a1yUO.filteredCardsReducer),
        fields: (0, $k2nID.fieldsReducer),
        isCheckboxSelectionMode: (0, $l7QHW.checkboxSelectionModeReducer),
        autoScroll: (0, $2h5Y8.cardAutoScrollReducer)
    });
}

});
parcelRegister("2h5Y8", function(module, exports) {

$parcel$export(module.exports, "cardAutoScrollReducer", () => $3b7bea4a66c1582d$export$d9b2c10f6d8f7f96);

var $9Z18E = parcelRequire("9Z18E");
const $3b7bea4a66c1582d$var$initialAutoScrollState = {
    cardId: null
};
const $3b7bea4a66c1582d$export$d9b2c10f6d8f7f96 = (state = $3b7bea4a66c1582d$var$initialAutoScrollState, action)=>{
    if (action.type === (0, $9Z18E.CARD_AUTO_SCROLL)) return {
        cardId: action.payload.cardId
    };
    return state;
};

});

parcelRegister("l7QHW", function(module, exports) {

$parcel$export(module.exports, "checkboxSelectionModeReducer", () => $6dd7a18bc29aa366$export$23fed535413aadfa);

var $8SI0F = parcelRequire("8SI0F");
const $6dd7a18bc29aa366$var$initialState = false;
const $6dd7a18bc29aa366$export$23fed535413aadfa = (state = $6dd7a18bc29aa366$var$initialState, action)=>{
    if (action.type === (0, $8SI0F.CHECKBOX_SELECTION_MODE)) return action.payload.isCheckboxSelectionMode;
    return state;
};

});

parcelRegister("k2nID", function(module, exports) {

$parcel$export(module.exports, "fieldsReducer", () => $81a3114735971ae9$export$570db622a488cbe7);

var $bNDq8 = parcelRequire("bNDq8");
const $81a3114735971ae9$var$initialState = {
    isStatusFieldsHidden: false,
    isVersionFieldsHidden: false,
    isEpicFieldsHidden: false
};
const $81a3114735971ae9$export$570db622a488cbe7 = (state = $81a3114735971ae9$var$initialState, action)=>{
    if (action.type === (0, $bNDq8.TOGGLE_STATUS_FIELDS)) return {
        ...state,
        isStatusFieldsHidden: action.payload.hideStatusFields
    };
    if (action.type === (0, $bNDq8.TOGGLE_VERSION_FIELDS)) return {
        ...state,
        isVersionFieldsHidden: action.payload.hideVersionFields
    };
    if (action.type === (0, $bNDq8.TOGGLE_EPIC_FIELDS)) return {
        ...state,
        isEpicFieldsHidden: action.payload.hideEpicFields
    };
    return state;
};

});

parcelRegister("a1yUO", function(module, exports) {

$parcel$export(module.exports, "filteredCardsReducer", () => $9a637eafccb10984$export$a42af41a01ab9b7a);

var $3lZ6i = parcelRequire("3lZ6i");

var $hf5c2 = parcelRequire("hf5c2");

var $8MHVw = parcelRequire("8MHVw");
const $9a637eafccb10984$export$d4c72bab9d6cc13a = {
    isLoading: false,
    filteredCardsIds: null
};
const $9a637eafccb10984$export$a42af41a01ab9b7a = (state = $9a637eafccb10984$export$d4c72bab9d6cc13a, action)=>{
    if (action.type === (0, $3lZ6i.SET_APP_DATA)) return action.payload.ui?.cards?.filteredCards ? action.payload.ui.cards.filteredCards : state;
    if (action.type === (0, $8MHVw.FILTERED_CARD_REQUEST) || action.type === (0, $8MHVw.FILTERED_CARD_CLEAR_REQUEST)) return {
        ...state,
        isLoading: true
    };
    if (action.type === (0, $8MHVw.FILTERED_CARD_SUCCESS)) return {
        isLoading: false,
        filteredCardsIds: new Set(action.payload)
    };
    if (action.type === (0, $8MHVw.FILTERED_CARD_CLEAR_FAILURE)) return {
        ...state,
        isLoading: false
    };
    if (action.type === (0, $8MHVw.FILTERED_CARD_CLEAR) || action.type === (0, $8MHVw.FILTERED_CARD_CLEAR_SUCCESS) || action.type === (0, $8MHVw.FILTERED_CARD_FAILURE)) return $9a637eafccb10984$export$d4c72bab9d6cc13a;
    if (action.type === (0, $8MHVw.REFILTER_SUCCESS)) {
        const { excludedCardIds: excludedCardIds, filteredCardIds: filteredCardIds } = action.payload;
        const updatedFilteredCardIds = new Set([
            ...state.filteredCardsIds || [],
            ...filteredCardIds
        ]);
        excludedCardIds.forEach((cardId)=>updatedFilteredCardIds.delete(cardId)); // delete is faster than filtering on state
        return {
            isLoading: false,
            filteredCardsIds: updatedFilteredCardIds
        };
    }
    if (action.type === (0, $hf5c2.CARD_CREATE_SUCCESS)) {
        const { card: card } = action.payload;
        if (card?.hidden) return state;
        const updatedFilteredCardIds = new Set([
            ...state.filteredCardsIds || [],
            String(card.id)
        ]);
        return {
            isLoading: false,
            filteredCardsIds: updatedFilteredCardIds
        };
    }
    return state;
};

});

parcelRegister("2XYpA", function(module, exports) {

$parcel$export(module.exports, "focusedReducer", () => $c5f082a10a26cabc$export$d95915a76998fdf);

var $lReb9 = parcelRequire("lReb9");
const $c5f082a10a26cabc$var$initialState = null;
const $c5f082a10a26cabc$export$d95915a76998fdf = (state = $c5f082a10a26cabc$var$initialState, action)=>{
    if (action.type === (0, $lReb9.CARD_FOCUS)) return action.payload.cardId;
    if (action.type === (0, $lReb9.CARD_BLUR)) return null;
    return state;
};

});

parcelRegister("bFper", function(module, exports) {

$parcel$export(module.exports, "lastSelectedCardKeyReducer", () => $62c70271f65aeb86$export$9db40db2e7ad7222);

var $4mqko = parcelRequire("4mqko");
const $62c70271f65aeb86$var$initialState = '';
const $62c70271f65aeb86$export$9db40db2e7ad7222 = (state = $62c70271f65aeb86$var$initialState, action)=>{
    if (action.type === (0, $4mqko.SET_LAST_SELECTED_CARD_KEY)) {
        const { cardKey: cardKey } = action.payload;
        return cardKey;
    }
    return state;
};

});

parcelRegister("5i1vv", function(module, exports) {

$parcel$export(module.exports, "listSelectionRelativeCardReducer", () => $7febb523d89aeee1$export$4c9c80b017b58fa6);

var $4mqko = parcelRequire("4mqko");
const $7febb523d89aeee1$var$initialState = null;
const $7febb523d89aeee1$export$4c9c80b017b58fa6 = (state = $7febb523d89aeee1$var$initialState, action)=>{
    if (action.type === (0, $4mqko.CARD_SINGLE_SELECT)) {
        const { cardId: cardId } = action.payload;
        return cardId;
    }
    if (action.type === (0, $4mqko.CARD_TOGGLE_SELECTION)) {
        const { cardId: cardId } = action.payload;
        return cardId;
    }
    if (action.type === (0, $4mqko.CARD_EMPTY_SELECTION) || action.type === (0, $4mqko.CARD_CLEAR_RELATIVE_CARD)) return null;
    return state;
};

});

parcelRegister("8PUI4", function(module, exports) {

$parcel$export(module.exports, "richCardReducer", () => $66c15fc17e9d7cef$export$a3aea80312727ab4);

var $9tZuw = parcelRequire("9tZuw");
const $66c15fc17e9d7cef$export$d4c72bab9d6cc13a = {
    mainActiveCard: null,
    cardIdWithAboveIccOpen: null
};
const $66c15fc17e9d7cef$export$a3aea80312727ab4 = (state, action)=>{
    switch(action.type){
        case 0, $9tZuw.SET_RICH_ACTIVE_CARD:
            return {
                ...state || $66c15fc17e9d7cef$export$d4c72bab9d6cc13a,
                mainActiveCard: action.payload.cardId
            };
        case 0, $9tZuw.SET_CARD_ID_WITH_ABOVE_ICC_OPEN:
            return {
                ...state || $66c15fc17e9d7cef$export$d4c72bab9d6cc13a,
                cardIdWithAboveIccOpen: action.payload.cardId
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state || $66c15fc17e9d7cef$export$d4c72bab9d6cc13a;
            }
    }
};

});

parcelRegister("6MSgp", function(module, exports) {

$parcel$export(module.exports, "selectedReducer", () => $22e2fb32610eb274$export$7c705be79fc8c698);

var $7uUwQ = parcelRequire("7uUwQ");

var $legw4 = parcelRequire("legw4");

var $4mqko = parcelRequire("4mqko");

var $7X18B = parcelRequire("7X18B");
const $22e2fb32610eb274$var$initialState = (0, $7uUwQ.freeze)([]);
const $22e2fb32610eb274$export$7c705be79fc8c698 = (state = $22e2fb32610eb274$var$initialState, action)=>{
    if (action.type === (0, $4mqko.CARD_TOGGLE_SELECTION)) {
        const { cardId: cardId } = action.payload;
        const selectedCardIndex = state.indexOf(cardId);
        return selectedCardIndex === -1 ? (0, $7uUwQ.push)(state, cardId) : (0, $7uUwQ.splice)(state, selectedCardIndex, 1);
    }
    if (action.type === (0, $4mqko.CARD_SINGLE_SELECT)) {
        const { cardId: cardId } = action.payload;
        return [
            cardId
        ];
    }
    if (action.type === (0, $4mqko.CARD_MULTI_SELECT)) return action.payload.cardIds;
    if (action.type === (0, $4mqko.CARD_EMPTY_SELECTION)) return $22e2fb32610eb274$var$initialState;
    if (action.type === (0, $legw4.CARD_DELETE_REQUEST) || action.type === (0, $legw4.CARD_DELETE)) {
        const { cardId: deletedCardId } = action.payload;
        return state.filter((cardId)=>cardId !== deletedCardId);
    }
    if (action.type === (0, $4mqko.CARD_MULTI_SELECT_EXTEND)) {
        const { cardIds: cardIds } = action.payload;
        return [
            ...new Set([
                ...state,
                ...cardIds
            ])
        ];
    }
    if (action.type === (0, $4mqko.CARD_MULTI_REMOVE)) {
        const { cardIds: cardIds } = action.payload;
        return state.filter((cardId)=>!cardIds.includes(cardId));
    }
    if (action.type === (0, $7X18B.CARDS_BULK_OPERATIONS_DELETE_SUCCESS)) {
        const cardIds = action.payload;
        return state.filter((cardId)=>!cardIds.includes(cardId));
    }
    return state;
};

});


parcelRegister("eNpIX", function(module, exports) {

$parcel$export(module.exports, "detailViewReducer", () => $4cff5e06bd7b728d$export$574c967e85ca2750);

var $legw4 = parcelRequire("legw4");

var $7X18B = parcelRequire("7X18B");

var $38qhf = parcelRequire("38qhf");
const $4cff5e06bd7b728d$export$574c967e85ca2750 = (state = null, action)=>{
    switch(action.type){
        case 0, $38qhf.OPEN_DETAIL_VIEW:
            if (!state || action.payload.cardId !== state.cardId) return {
                timestamp: state ? state.timestamp : Date.now(),
                cardId: action.payload.cardId,
                externalAction: action.payload.externalAction
            };
            return state;
        case 0, $38qhf.UPDATE_DETAIL_VIEW:
            return state ? {
                cardId: state.cardId,
                timestamp: Date.now()
            } : null;
        case 0, $38qhf.CLOSE_DETAIL_VIEW:
            return null;
        case 0, $legw4.CARD_DELETE_REQUEST:
            if (state && state.cardId === action.payload.cardId) return null;
            return state;
        case 0, $7X18B.CARDS_BULK_OPERATIONS_DELETE_REQUESTS:
            if (state && action.payload.flatMap(({ cardIds: cardIds })=>cardIds).some((cardId)=>cardId === state.cardId)) return null;
            return state;
        default:
            return state;
    }
};

});

parcelRegister("9wNs2", function(module, exports) {

$parcel$export(module.exports, "default", () => $761cdeded7b26b68$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $eMLHT = parcelRequire("eMLHT");
const $761cdeded7b26b68$var$initialState = {
    isDragging: false,
    isSubtask: false,
    isOverTransitionZone: false,
    sourceCardGroupType: '',
    sourceCardListId: '',
    sourceParentId: undefined
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$761cdeded7b26b68$export$2e2bcd8739ae039 = (state = $761cdeded7b26b68$var$initialState, action)=>{
    switch(action.type){
        case 0, $eMLHT.DRAG_START:
            return (0, $7uUwQ.setIn)(state, [
                'isDragging'
            ], true);
        case 0, $eMLHT.DRAG_END:
            return (0, $7uUwQ.setIn)(state, [
                'isDragging'
            ], false);
        case 0, $eMLHT.TRANSITION_ZONE_ENTER:
            return (0, $7uUwQ.setIn)(state, [
                'isOverTransitionZone'
            ], true);
        case 0, $eMLHT.TRANSITION_ZONE_LEAVE:
            return (0, $7uUwQ.setIn)(state, [
                'isOverTransitionZone'
            ], false);
        case 0, $eMLHT.BEFORE_CAPTURE:
            return {
                ...state,
                sourceCardGroupType: action.payload.sourceCardGroupType,
                sourceCardListId: action.payload.sourceCardListId,
                isSubtask: action.payload.isSubtask,
                sourceParentId: action.payload.sourceParentId
            };
        default:
            return state;
    }
};

});

parcelRegister("70ywa", function(module, exports) {

$parcel$export(module.exports, "default", () => $733bf018efec9975$export$2e2bcd8739ae039);

var $likqC = parcelRequire("likqC");
const $733bf018efec9975$var$initialState = {};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$733bf018efec9975$export$2e2bcd8739ae039 = (state = $733bf018efec9975$var$initialState, action)=>{
    if (action.type === (0, $likqC.SET_ALL_FILTERS)) return action.payload.filters;
    return state;
};

});

parcelRegister("bwP9g", function(module, exports) {

$parcel$export(module.exports, "default", () => $b23b324b1a2c851a$export$2e2bcd8739ae039);

var $3lZ6i = parcelRequire("3lZ6i");
function $b23b324b1a2c851a$export$2e2bcd8739ae039(state = false, action) {
    switch(action.type){
        case 0, $3lZ6i.LOAD_CONFIG_DATA_MODEL_SUCCESS:
            return true;
        case 0, $3lZ6i.SET_CONFIG_DATA:
            return true;
        default:
            return state;
    }
}

});

parcelRegister("cjd7v", function(module, exports) {

$parcel$export(module.exports, "default", () => $52bea3269328f7eb$export$2e2bcd8739ae039);

var $3lZ6i = parcelRequire("3lZ6i");
function $52bea3269328f7eb$export$2e2bcd8739ae039(state = false, action) {
    switch(action.type){
        case 0, $3lZ6i.SET_APP_DATA:
            return true;
        default:
            return state;
    }
}

});

parcelRegister("jcM6E", function(module, exports) {

$parcel$export(module.exports, "default", () => $f786369fe958bf99$export$2e2bcd8739ae039);

var $6zjUi = parcelRequire("6zjUi");
const $f786369fe958bf99$var$defaultState = {
    isOpen: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f786369fe958bf99$export$2e2bcd8739ae039 = (state = $f786369fe958bf99$var$defaultState, action)=>{
    if (action.type === (0, $6zjUi.OPEN_ISSUE_TRANSITION_MODAL)) return {
        isOpen: true,
        ...action.payload
    };
    if (action.type === (0, $6zjUi.CLOSE_ISSUE_TRANSITION_MODAL)) return {
        isOpen: false
    };
    return state;
};

});

parcelRegister("e03Tz", function(module, exports) {

$parcel$export(module.exports, "modalsReducer", () => $5135aac88c82c9e3$export$c732e1f962e199dd);

var $5Eoed = parcelRequire("5Eoed");
const $5135aac88c82c9e3$export$c732e1f962e199dd = (state = null, action)=>{
    switch(action.type){
        case 0, $5Eoed.OPEN_MODAL:
            return action.payload;
        case 0, $5Eoed.CLOSE_MODAL:
            return null;
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("6oZez", function(module, exports) {

$parcel$export(module.exports, "default", () => $484d2bd8c5200dac$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");


var $h9NU3 = parcelRequire("h9NU3");

var $9g0YE = parcelRequire("9g0YE");
const $484d2bd8c5200dac$var$initialState = ()=>({
        [(0, $c35fd6591a78fffe$export$a10c132b86ae798b)]: (0, $h9NU3.isIssueParentPanelOpen)(),
        [(0, $c35fd6591a78fffe$export$41073ac826c57195)]: (0, $h9NU3.isVersionPanelOpen)(),
        [(0, $c35fd6591a78fffe$export$29d7f2210b16d662)]: (0, $h9NU3.isInsightsPanelOpen)(),
        [(0, $c35fd6591a78fffe$export$ba1da943283b9900)]: false
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$484d2bd8c5200dac$export$2e2bcd8739ae039 = (state = $484d2bd8c5200dac$var$initialState(), action)=>{
    switch(action.type){
        case 0, $9g0YE.TOGGLE_PANEL:
            {
                const { payload: { panel: panel } } = action;
                return state[panel] === true ? (0, $7uUwQ.unset)(state, panel) : (0, $7uUwQ.chain)(state).set(panel, true).value();
            }
        case 0, $9g0YE.CLOSE_INSIGHTS_PANEL:
            return (0, $7uUwQ.unset)(state, (0, $c35fd6591a78fffe$export$29d7f2210b16d662));
        case 0, $9g0YE.CLOSE_VIEW_SETTINGS_PANEL:
            return (0, $7uUwQ.unset)(state, (0, $c35fd6591a78fffe$export$ba1da943283b9900));
        case 0, $9g0YE.SET_ALL_PANELS_SUCCESS:
            return action.payload.panels;
        default:
            return state;
    }
};

});

parcelRegister("fxbtA", function(module, exports) {

$parcel$export(module.exports, "default", () => $260ae5bea4fbca2a$export$2e2bcd8739ae039);

var $lHBhO = parcelRequire("lHBhO");
const $260ae5bea4fbca2a$var$initialState = {
    includeSubtasks: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$260ae5bea4fbca2a$export$2e2bcd8739ae039 = (state = $260ae5bea4fbca2a$var$initialState, action)=>{
    switch(action.type){
        case 0, $lHBhO.TOGGLE_INCLUDE_SUBTASKS:
            return {
                includeSubtasks: !state.includeSubtasks
            };
        case 0, $lHBhO.SET_INCLUDE_SUBTASKS:
            return {
                includeSubtasks: action.payload.includeSubtasks
            };
        default:
            return state;
    }
};

});




parcelRegister("gshHs", function(module, exports) {

$parcel$export(module.exports, "default", () => $a47ef8d075adac28$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3anEO = parcelRequire("3anEO");

var $likqC = parcelRequire("likqC");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $fpDLy = parcelRequire("fpDLy");

var $lCFtU = parcelRequire("lCFtU");
// register root level data-providers here
const $a47ef8d075adac28$var$View = (props)=>{
    const { children: children, boardId: boardId } = props;
    const isCompanyManaged = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
    const isVersionsFeatureEnabled = (0, $c1MAf.useBacklogSelector)((0, $fpDLy.isVersionsFeatureEnabled));
    const onFiltersChange = (0, $c1MAf.useBacklogActionCreator)((filters)=>(0, $likqC.setAllFilters)(filters));
    // onSetAllFilters is a redux action fired to sync filters
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3anEO.FiltersContainer), {
        boardId: boardId,
        onFiltersChange: onFiltersChange,
        isVersionsFeatureEnabled: isCompanyManaged || isVersionsFeatureEnabled,
        isCompanyManaged: isCompanyManaged
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lCFtU.VersionPanelEntrypointContextProvider), null, children));
};
var $a47ef8d075adac28$export$2e2bcd8739ae039 = $a47ef8d075adac28$var$View;

});
parcelRegister("3anEO", function(module, exports) {

$parcel$export(module.exports, "FiltersContainer", () => $3fad31ed9ec6979b$export$4e5fef3bf0d55c67);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $wKznQ = parcelRequire("wKznQ");

var $gg7kZ = parcelRequire("gg7kZ");


var $h3f3a = parcelRequire("h3f3a");

var $86mek = parcelRequire("86mek");

var $88tXZ = parcelRequire("88tXZ");

var $8QLN8 = parcelRequire("8QLN8");
const $3fad31ed9ec6979b$var$Container = (0, $gg7kZ.createContainer)((0, $88tXZ.FiltersStore), {
    onInit: ()=>({ dispatch: dispatch }, { isVersionsFeatureEnabled: isVersionsFeatureEnabled, isCompanyManaged: isCompanyManaged, boardId: boardId })=>{
            // set initial filters from URL
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const { search: search } = window.location;
            const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(search);
            let initialFilters = (0, $h3f3a.getFiltersFromQuery)(queryParams, isVersionsFeatureEnabled);
            if (isCompanyManaged && Object.entries(initialFilters).length === 0) initialFilters = (0, $wKznQ.getCachedFilters)('backlog', boardId) ?? {};
            dispatch((0, $86mek.setFilters)(initialFilters));
        }
});
const $3fad31ed9ec6979b$export$4e5fef3bf0d55c67 = ({ boardId: boardId, onFiltersChange: onFiltersChange, children: children, isVersionsFeatureEnabled: isVersionsFeatureEnabled, isCompanyManaged: isCompanyManaged })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3fad31ed9ec6979b$var$Container, {
        scope: `${(0, $0904d0fa958edff5$export$37f04a6502d23030)}-${String(boardId)}`,
        onFiltersChange: onFiltersChange,
        isVersionsFeatureEnabled: isVersionsFeatureEnabled,
        isCompanyManaged: isCompanyManaged,
        boardId: boardId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8QLN8.SyncWithRouting), {
        isVersionsFeatureEnabled: isVersionsFeatureEnabled
    })));

});
parcelRegister("wKznQ", function(module, exports) {

$parcel$export(module.exports, "getCachedFilters", () => $a26a3456dc06172d$export$cc165fee46da38d4);
$parcel$export(module.exports, "setCachedFilters", () => $a26a3456dc06172d$export$fb56bc6b9e534664);

var $bSSG7 = parcelRequire("bSSG7");
const $a26a3456dc06172d$var$localStorage = (0, $bSSG7.createLocalStorageProvider)('software');
const $a26a3456dc06172d$var$CACHED_FILTERS_KEY = 'filters';
const $a26a3456dc06172d$var$getKey = (feature, projectId)=>`${feature}-${$a26a3456dc06172d$var$CACHED_FILTERS_KEY}.${projectId}`;
function $a26a3456dc06172d$export$cc165fee46da38d4(feature, projectId) {
    return $a26a3456dc06172d$var$localStorage.get($a26a3456dc06172d$var$getKey(feature, projectId)) || undefined;
}
function $a26a3456dc06172d$export$fb56bc6b9e534664(feature, projectId, filters) {
    if (filters && Object.entries(filters).length > 0) $a26a3456dc06172d$var$localStorage.set($a26a3456dc06172d$var$getKey(feature, projectId), filters);
    else $a26a3456dc06172d$var$localStorage.remove($a26a3456dc06172d$var$getKey(feature, projectId));
}

});

const $0904d0fa958edff5$export$37f04a6502d23030 = 'next-gen/backlog-filters-state';
const $0904d0fa958edff5$export$d597759d33be802e = 'TEXT';
const $0904d0fa958edff5$export$f8f7545d2bb78afb = 'ASSIGNEE';
const $0904d0fa958edff5$export$37aee82a3cb1e8f7 = 'LABEL';
const $0904d0fa958edff5$export$2a4f270075a033de = 'ISSUE_PARENT';
const $0904d0fa958edff5$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $0904d0fa958edff5$export$a4ad2735b021c132 = 'VERSION';
const $0904d0fa958edff5$export$68d693c35a8d8866 = 'CUSTOM_FILTER';
const $0904d0fa958edff5$export$e39925d10cebc0b = 'text';
const $0904d0fa958edff5$export$a181206198b7f50c = 'search';
const $0904d0fa958edff5$export$f78d8c81fcad32a2 = 'assignee';
const $0904d0fa958edff5$export$e729d951ab128c3b = 'label';
const $0904d0fa958edff5$export$8a2cab795731dc42 = 'issueParent';
const $0904d0fa958edff5$export$fa7b72626a2e0090 = 'issueType';
const $0904d0fa958edff5$export$392308739e657b75 = 'version';
const $0904d0fa958edff5$export$cb08ebea4a46cd29 = 'customFilter';
const $0904d0fa958edff5$export$163cc317352fc53e = 'quickFilter';

parcelRegister("h3f3a", function(module, exports) {

$parcel$export(module.exports, "getFiltersFromQuery", () => $45e427c2f325b4a6$export$7b8e59218dd68efc);
$parcel$export(module.exports, "getQueryFromFilters", () => $45e427c2f325b4a6$export$aad56ffdcf894f3b);

const $45e427c2f325b4a6$var$toArray = (x)=>Array.isArray(x) ? x : x.split(',');
const $45e427c2f325b4a6$export$7b8e59218dd68efc = (searchParams, isVersionsFeatureEnabled)=>{
    const filtersFromQuery = {};
    // search comes from old CMP
    if (searchParams[0, $0904d0fa958edff5$export$a181206198b7f50c]) filtersFromQuery[0, $0904d0fa958edff5$export$d597759d33be802e] = searchParams[0, $0904d0fa958edff5$export$a181206198b7f50c];
    if (searchParams[0, $0904d0fa958edff5$export$e39925d10cebc0b]) filtersFromQuery[0, $0904d0fa958edff5$export$d597759d33be802e] = searchParams[0, $0904d0fa958edff5$export$e39925d10cebc0b];
    if (searchParams[0, $0904d0fa958edff5$export$f78d8c81fcad32a2]) filtersFromQuery[0, $0904d0fa958edff5$export$f8f7545d2bb78afb] = $45e427c2f325b4a6$var$toArray(searchParams[0, $0904d0fa958edff5$export$f78d8c81fcad32a2]);
    if (searchParams[0, $0904d0fa958edff5$export$e729d951ab128c3b]) filtersFromQuery[0, $0904d0fa958edff5$export$37aee82a3cb1e8f7] = $45e427c2f325b4a6$var$toArray(searchParams[0, $0904d0fa958edff5$export$e729d951ab128c3b]);
    if (searchParams[0, $0904d0fa958edff5$export$8a2cab795731dc42]) filtersFromQuery[0, $0904d0fa958edff5$export$2a4f270075a033de] = $45e427c2f325b4a6$var$toArray(searchParams[0, $0904d0fa958edff5$export$8a2cab795731dc42]);
    if (searchParams[0, $0904d0fa958edff5$export$392308739e657b75] && isVersionsFeatureEnabled) filtersFromQuery[0, $0904d0fa958edff5$export$a4ad2735b021c132] = $45e427c2f325b4a6$var$toArray(searchParams[0, $0904d0fa958edff5$export$392308739e657b75]);
    if (searchParams[0, $0904d0fa958edff5$export$fa7b72626a2e0090]) filtersFromQuery[0, $0904d0fa958edff5$export$ebb48b08205007c5] = $45e427c2f325b4a6$var$toArray(searchParams[0, $0904d0fa958edff5$export$fa7b72626a2e0090]);
    // quickFilters from the old CMP
    if (searchParams[0, $0904d0fa958edff5$export$163cc317352fc53e]) filtersFromQuery[0, $0904d0fa958edff5$export$68d693c35a8d8866] = $45e427c2f325b4a6$var$toArray(searchParams[0, $0904d0fa958edff5$export$163cc317352fc53e]);
    if (searchParams[0, $0904d0fa958edff5$export$cb08ebea4a46cd29]) filtersFromQuery[0, $0904d0fa958edff5$export$68d693c35a8d8866] = $45e427c2f325b4a6$var$toArray(searchParams[0, $0904d0fa958edff5$export$cb08ebea4a46cd29]);
    return filtersFromQuery;
};
const $45e427c2f325b4a6$export$aad56ffdcf894f3b = (filters)=>({
        [(0, $0904d0fa958edff5$export$e39925d10cebc0b)]: filters[0, $0904d0fa958edff5$export$d597759d33be802e] || undefined,
        // Replace CMP search with text above
        [(0, $0904d0fa958edff5$export$a181206198b7f50c)]: undefined,
        [(0, $0904d0fa958edff5$export$f78d8c81fcad32a2)]: filters[0, $0904d0fa958edff5$export$f8f7545d2bb78afb] ? filters[0, $0904d0fa958edff5$export$f8f7545d2bb78afb].join(',') : undefined,
        [(0, $0904d0fa958edff5$export$e729d951ab128c3b)]: filters[0, $0904d0fa958edff5$export$37aee82a3cb1e8f7] ? filters[0, $0904d0fa958edff5$export$37aee82a3cb1e8f7].join(',') : undefined,
        [(0, $0904d0fa958edff5$export$8a2cab795731dc42)]: filters[0, $0904d0fa958edff5$export$2a4f270075a033de] ? filters[0, $0904d0fa958edff5$export$2a4f270075a033de].join(',') : undefined,
        [(0, $0904d0fa958edff5$export$fa7b72626a2e0090)]: filters[0, $0904d0fa958edff5$export$ebb48b08205007c5] ? filters[0, $0904d0fa958edff5$export$ebb48b08205007c5].join(',') : undefined,
        [(0, $0904d0fa958edff5$export$392308739e657b75)]: filters[0, $0904d0fa958edff5$export$a4ad2735b021c132] ? filters[0, $0904d0fa958edff5$export$a4ad2735b021c132].join(',') : undefined,
        [(0, $0904d0fa958edff5$export$cb08ebea4a46cd29)]: filters[0, $0904d0fa958edff5$export$68d693c35a8d8866] ? filters[0, $0904d0fa958edff5$export$68d693c35a8d8866].join(',') : undefined,
        // Replace CMP quickFilter with customFilter
        [(0, $0904d0fa958edff5$export$163cc317352fc53e)]: undefined
    });

});

parcelRegister("86mek", function(module, exports) {

$parcel$export(module.exports, "setFilters", () => $00f9303a0e206c58$export$90e9b0558f0311af);

var $ajpes = parcelRequire("ajpes");
const $00f9303a0e206c58$export$90e9b0558f0311af = (filters)=>({ getState: getState, setState: setState }, { onFiltersChange: onFiltersChange })=>{
        const state = getState();
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(state, filters)) {
            setState({
                filters: filters
            });
            onFiltersChange && onFiltersChange(filters);
        }
    };

});

parcelRegister("88tXZ", function(module, exports) {

$parcel$export(module.exports, "FiltersStore", () => $a707d54d22dd5787$export$83881a29077d5ffe);
$parcel$export(module.exports, "useFilters", () => $a707d54d22dd5787$export$973ca22476b0e05f);
$parcel$export(module.exports, "useEpicFilters", () => $a707d54d22dd5787$export$d840a10da638967b);
$parcel$export(module.exports, "useFixVersionFilters", () => $a707d54d22dd5787$export$55f8e6f74a492d36);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");


var $6hsVv = parcelRequire("6hsVv");

var $kNguL = parcelRequire("kNguL");

var $btxt2 = parcelRequire("btxt2");

var $cxBEo = parcelRequire("cxBEo");
const $a707d54d22dd5787$var$initialState = {
    filters: {}
};
const $a707d54d22dd5787$export$83881a29077d5ffe = (0, $iXqE5.createStore)({
    name: (0, $0904d0fa958edff5$export$37f04a6502d23030),
    initialState: $a707d54d22dd5787$var$initialState,
    actions: $6hsVv.actions
});
const $a707d54d22dd5787$export$973ca22476b0e05f = (0, $3sQ5x.createHook)($a707d54d22dd5787$export$83881a29077d5ffe, {
    selector: (0, $btxt2.getFilters)
});
const $a707d54d22dd5787$export$d840a10da638967b = (0, $3sQ5x.createHook)($a707d54d22dd5787$export$83881a29077d5ffe, {
    selector: (0, $kNguL.getEpic)
});
const $a707d54d22dd5787$export$55f8e6f74a492d36 = (0, $3sQ5x.createHook)($a707d54d22dd5787$export$83881a29077d5ffe, {
    selector: (0, $cxBEo.getFixVersion)
});

});
parcelRegister("6hsVv", function(module, exports) {

$parcel$export(module.exports, "actions", () => $6a94a68519fb849e$export$e324594224ef24da);

var $cQhWs = parcelRequire("cQhWs");

var $86mek = parcelRequire("86mek");

var $e7Dvb = parcelRequire("e7Dvb");
const $6a94a68519fb849e$export$e324594224ef24da = {
    setFilters: $86mek.setFilters,
    setEpicFilters: $cQhWs.setEpicFilters,
    setVersionFilters: $e7Dvb.setVersionFilters
};

});
parcelRegister("cQhWs", function(module, exports) {

$parcel$export(module.exports, "setEpicFilters", () => $b859b1e97bc1ccf8$export$e24537ba01fbbff1);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state


var $bbNss = parcelRequire("bbNss");
const $b859b1e97bc1ccf8$export$e24537ba01fbbff1 = (0, $bbNss.setFilter)((0, $0904d0fa958edff5$export$2a4f270075a033de));

});
parcelRegister("bbNss", function(module, exports) {

$parcel$export(module.exports, "setFilter", () => $8fa8f4b7b2e1add9$export$939370273cf4a757);

var $gccSB = parcelRequire("gccSB");

var $86mek = parcelRequire("86mek");
const $8fa8f4b7b2e1add9$export$939370273cf4a757 = (filterKey)=>(newFilterValue)=>({ getState: getState, dispatch: dispatch })=>{
            const state = getState();
            const filters = {
                ...state.filters
            };
            if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(newFilterValue)) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ TEXT?: string | undefined; ASSIGNEE?: string[] | undefined; LABEL?: string[] | undefined; ISSUE_PARENT?: string[] | undefined; ISSUE_TYPE?: string[] | undefined; VERSION?: string[] | undefined; CUSTOM_FILTER?: string[] | undefined; }'.
            delete filters[filterKey];
            else // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ TEXT?: string | undefined; ASSIGNEE?: string[] | undefined; LABEL?: string[] | undefined; ISSUE_PARENT?: string[] | undefined; ISSUE_TYPE?: string[] | undefined; VERSION?: string[] | undefined; CUSTOM_FILTER?: string[] | undefined; }'.
            filters[filterKey] = newFilterValue;
            dispatch((0, $86mek.setFilters)(filters));
        };

});


parcelRegister("e7Dvb", function(module, exports) {

$parcel$export(module.exports, "setVersionFilters", () => $7d05b54ba202350e$export$2dd46fe22cb52ed5);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state


var $bbNss = parcelRequire("bbNss");
const $7d05b54ba202350e$export$2dd46fe22cb52ed5 = (0, $bbNss.setFilter)((0, $0904d0fa958edff5$export$a4ad2735b021c132));

});


parcelRegister("kNguL", function(module, exports) {

$parcel$export(module.exports, "getEpic", () => $4f0dfad7edbcb0d4$export$73171e65af38eb92);
const $4f0dfad7edbcb0d4$export$73171e65af38eb92 = (state)=>state.filters ? state.filters.ISSUE_PARENT : null;

});

parcelRegister("btxt2", function(module, exports) {

$parcel$export(module.exports, "getFilters", () => $dbd96765a8e1bc68$export$1933a9fe712fc1fd);
const $dbd96765a8e1bc68$export$1933a9fe712fc1fd = (state)=>state.filters;

});

parcelRegister("cxBEo", function(module, exports) {

$parcel$export(module.exports, "getFixVersion", () => $c7a4982693da9d44$export$f234b291359ecd8b);
const $c7a4982693da9d44$export$f234b291359ecd8b = (state)=>state.filters ? state.filters.VERSION : null;

});


parcelRegister("8QLN8", function(module, exports) {

$parcel$export(module.exports, "SyncWithRouting", () => $6801f19dd5932cce$export$6cfa8b91c03902d6);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $3hGWp = parcelRequire("3hGWp");


var $h3f3a = parcelRequire("h3f3a");

var $88tXZ = parcelRequire("88tXZ");
const $6801f19dd5932cce$export$6cfa8b91c03902d6 = /*#__PURE__*/ (0, $5uXOq.memo)(({ isVersionsFeatureEnabled: isVersionsFeatureEnabled })=>{
    const [filters, { setFilters: setFilters }] = (0, $88tXZ.useFilters)();
    const [queryParams, setQueryParams] = (0, $3hGWp.useQueryParams)((0, $0904d0fa958edff5$export$e39925d10cebc0b), (0, $0904d0fa958edff5$export$a181206198b7f50c), (0, $0904d0fa958edff5$export$f78d8c81fcad32a2), (0, $0904d0fa958edff5$export$e729d951ab128c3b), (0, $0904d0fa958edff5$export$8a2cab795731dc42), (0, $0904d0fa958edff5$export$fa7b72626a2e0090), (0, $0904d0fa958edff5$export$392308739e657b75), (0, $0904d0fa958edff5$export$cb08ebea4a46cd29), (0, $0904d0fa958edff5$export$163cc317352fc53e));
    const filtersFromQuery = (0, $5uXOq.useMemo)(()=>(0, $h3f3a.getFiltersFromQuery)(queryParams, isVersionsFeatureEnabled), [
        isVersionsFeatureEnabled,
        queryParams
    ]);
    const filtersRef = (0, $5uXOq.useRef)(filtersFromQuery);
    const queryFromFilters = (0, $5uXOq.useMemo)(()=>(0, $h3f3a.getQueryFromFilters)(filters), [
        filters
    ]);
    // set as initially empty so we can sync the query parameters from the filters store
    const routeRef = (0, $5uXOq.useRef)({
        [(0, $0904d0fa958edff5$export$e39925d10cebc0b)]: undefined,
        [(0, $0904d0fa958edff5$export$a181206198b7f50c)]: undefined,
        [(0, $0904d0fa958edff5$export$f78d8c81fcad32a2)]: undefined,
        [(0, $0904d0fa958edff5$export$e729d951ab128c3b)]: undefined,
        [(0, $0904d0fa958edff5$export$8a2cab795731dc42)]: undefined,
        [(0, $0904d0fa958edff5$export$fa7b72626a2e0090)]: undefined,
        [(0, $0904d0fa958edff5$export$392308739e657b75)]: undefined,
        [(0, $0904d0fa958edff5$export$cb08ebea4a46cd29)]: undefined,
        [(0, $0904d0fa958edff5$export$163cc317352fc53e)]: undefined
    });
    // set initial filters from URL (prev componentDidMount)
    (0, $5uXOq.useEffect)(()=>{
        // Sync state -> url
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(queryFromFilters, routeRef.current)) {
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(queryParams, queryFromFilters)) setQueryParams(queryFromFilters);
            routeRef.current = queryFromFilters;
        }
    }, [
        setQueryParams,
        queryFromFilters,
        queryParams
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Sync url -> state
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(filtersFromQuery, filtersRef.current)) {
            // check if filters state is already updated to prevent useless update
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(filtersFromQuery, filters)) setFilters(filtersFromQuery);
            filtersRef.current = filtersFromQuery;
        }
    }, [
        filters,
        filtersFromQuery,
        setFilters
    ]);
    return null;
});

});
parcelRegister("3hGWp", function(module, exports) {

$parcel$export(module.exports, "useQueryParams", () => $afd0e0a12e1f2496$export$b37ee0d76c6d2fbc);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $hGgHi = parcelRequire("hGgHi");

var $9xWGk = parcelRequire("9xWGk");

var $ebyGx = parcelRequire("ebyGx");

var $doZTA = parcelRequire("doZTA");
const $afd0e0a12e1f2496$export$b37ee0d76c6d2fbc = (...queryParamsToWatch)=>{
    const [{ location: { pathname: pathname }, query: query }, { push: push, replace: replace }] = (0, $doZTA.useRouter)();
    const queryParamsRef = (0, $5uXOq.useRef)({});
    const parsedQueryParams = (0, $5uXOq.useMemo)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newQueryParams = queryParamsToWatch.reduce((accumulator, currentValue)=>{
            accumulator[currentValue] = query[currentValue] || undefined;
            return accumulator;
        }, {});
        // update cache only when one of requested params actually changed
        // otherwise return cached value to avoid changing return object reference
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(queryParamsRef.current, newQueryParams)) queryParamsRef.current = newQueryParams;
        return queryParamsRef.current;
    }, [
        query,
        queryParamsToWatch
    ]);
    const setQueryParams = (0, $5uXOq.useCallback)((newQueryParams, options)=>{
        const parsedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($9xWGk)))({
            ...query,
            ...newQueryParams
        }, (value)=>(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value));
        const { updateType: updateType, ...stringifyOptions } = options ?? {};
        // @ts-expect-error - TS2559 - Type '{ sort?: false | ((a: string, b: string) => number) | undefined; }' has no properties in common with type 'StringifyOptions'.
        const strSearch = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(parsedSearch, stringifyOptions);
        const url = pathname + (strSearch !== '' ? `?${strSearch}` : '');
        updateType === 'replace' ? replace(url) : push(url);
    }, [
        pathname,
        push,
        replace,
        query
    ]);
    return [
        parsedQueryParams,
        setQueryParams
    ];
};

});



parcelRegister("lCFtU", function(module, exports) {

$parcel$export(module.exports, "VersionPanelEntrypointContextProvider", () => $a5227fd571b1570c$export$e87f6587ec389c16);

var $5uXOq = parcelRequire("5uXOq");

var $4mO32 = parcelRequire("4mO32");

var $dXq4S = parcelRequire("dXq4S");

var $3HX6K = parcelRequire("3HX6K");

var $koeKL = parcelRequire("koeKL");

var $93BDy = parcelRequire("93BDy");

var $8hVbJ = parcelRequire("8hVbJ");

var $4GPQ6 = parcelRequire("4GPQ6");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $kuePT = parcelRequire("kuePT");
const $a5227fd571b1570c$export$e87f6587ec389c16 = ({ children: children })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const isFirstRender = (0, $5uXOq.useRef)(true);
    const isLoaded = (0, $5uXOq.useRef)(false);
    const isVersionPanelOpen = (0, $kuePT.useIsVersionsPanelOpen)();
    const projectIds = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getProjectIds));
    const jiraProjectIds = projectIds.map((id)=>(0, $dXq4S.createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'project',
            resourceId: String(id)
        }));
    const boardARI = (0, $93BDy.useBoardAri)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            after: null,
            first: 500,
            jiraProjectIds: jiraProjectIds,
            boardId: boardARI,
            shouldShowVersionPanel: !!jiraProjectIds.length
        }), [
        boardARI,
        cloudId,
        jiraProjectIds
    ]);
    const entryPointHookResult = (0, $4mO32.useEntryPoint)((0, $3HX6K.versionsPanelEntryPoint), entryPointParams, (0, $8hVbJ.versionsPanelLoad));
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (!isLoaded.current && isVersionPanelOpen) {
            entryPointHookResult.entryPointActions.load();
            isLoaded.current = true;
        } else if (isFirstRender.current) {
            // if panel is open on first render - load versions panel
            if (isVersionPanelOpen) entryPointHookResult.entryPointActions.load();
            isFirstRender.current = false;
        }
    }, [
        entryPointHookResult,
        isVersionPanelOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4GPQ6.VersionPanelEntrypointContext).Provider, {
        value: entryPointHookResult
    }, children);
};

});
parcelRegister("3HX6K", function(module, exports) {

$parcel$export(module.exports, "versionsPanelEntryPoint", () => $c64b6f10df23ec8c$export$b707e1ce7d4339f2);

var $emydz = parcelRequire("emydz");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $c64b6f10df23ec8c$export$b707e1ce7d4339f2 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("76qad")), {
        moduleId: "a6db963d"
    }),
    getPreloadProps: (variables)=>({
            queries: {
                versionsPanel: {
                    options: {
                        // have to add "as const" https://stackoverflow.com/questions/37978528/typescript-type-string-is-not-assignable-to-type
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $emydz.default,
                    variables: variables
                }
            }
        })
});

});
parcelRegister("emydz", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9b068d712ed45ea$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b712db637dc5526f65d5e2776bbc46d1>>
 * @relayHash 3e5f50334a833356bade8dcc1802689c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 99f2e17660825bfdf24015d2f280ce7f4250d15c6cc0fb49f7770602d4a1a510

var $i7FzY = parcelRequire("i7FzY");

var $iWXRl = parcelRequire("iWXRl");
const $a9b068d712ed45ea$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "99f2e17660825bfdf24015d2f280ce7f4250d15c6cc0fb49f7770602d4a1a510",
        "metadata": {
            "connection": [
                {
                    "count": "first",
                    "cursor": "after",
                    "direction": "forward",
                    "path": [
                        "jira",
                        "versionsForProjects"
                    ]
                }
            ]
        },
        "name": "uiVersionBacklogPanelRelayQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcvisualrefresheap2relayprovider": (0, $iWXRl.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcismanageversionspermissionenabledrelayprovider": (0, $i7FzY.default)
        }
    }
};
var $a9b068d712ed45ea$export$2e2bcd8739ae039 = $a9b068d712ed45ea$var$node;

});

parcelRegister("76qad", function(module, exports) {

let $52bd63807ea9cc54$var$load = (parcelRequire("28QjX"))(4);
module.exports = $52bd63807ea9cc54$var$load("aJXUj").then(()=>parcelRequire('4yyWF'));

});


parcelRegister("4GPQ6", function(module, exports) {

$parcel$export(module.exports, "VersionPanelEntrypointContext", () => $9e33278fdef07516$export$bdb33cd5a96d0170);

var $l37qh = parcelRequire("l37qh");
const $9e33278fdef07516$export$bdb33cd5a96d0170 = (0, $l37qh.createUseEntryPointContext)();

});
parcelRegister("l37qh", function(module, exports) {

$parcel$export(module.exports, "createUseEntryPointContext", () => $6e7e19c2d291c94c$export$41bce2223126846b);

var $5uXOq = parcelRequire("5uXOq");
const $6e7e19c2d291c94c$export$41bce2223126846b = ()=>/*#__PURE__*/ (0, $5uXOq.createContext)({
        entryPointActions: {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            cancelPreload () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            load () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            preload () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            unload () {}
        },
        entryPointReferenceSubject: {
            getValue: ()=>null,
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            subscribe: ()=>()=>{}
        },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        stopMetric () {}
    });

});


parcelRegister("kuePT", function(module, exports) {

$parcel$export(module.exports, "useIsVersionsPanelOpen", () => $952d461d63e3cbc5$export$2b96edcb84157d9);

var $iDGXn = parcelRequire("iDGXn");

var $c1MAf = parcelRequire("c1MAf");

var $fpDLy = parcelRequire("fpDLy");
const $952d461d63e3cbc5$export$2b96edcb84157d9 = ()=>{
    const isVersionPanelOpen = (0, $iDGXn.useShowVersionPanel)();
    const isVersionsEnabled = (0, $c1MAf.useBacklogSelector)((0, $fpDLy.isVersionsFeatureEnabled));
    return isVersionsEnabled && isVersionPanelOpen;
};

});
parcelRegister("iDGXn", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsContainer", () => $ca78323127435ce7$export$920204d7413f6fe1);
$parcel$export(module.exports, "useViewSettings", () => $ca78323127435ce7$export$704cffd05c51e2b6);
$parcel$export(module.exports, "useViewSettingsActions", () => $ca78323127435ce7$export$d6a70239aff099b8);
$parcel$export(module.exports, "useIsFullscreen", () => $ca78323127435ce7$export$d397eccea5f37b0a);
$parcel$export(module.exports, "useShowVersionPanel", () => $ca78323127435ce7$export$459b400687bc0f20);
$parcel$export(module.exports, "useShowEpicPanel", () => $ca78323127435ce7$export$203c9a05aebea04a);
$parcel$export(module.exports, "useShowQuickFilters", () => $ca78323127435ce7$export$714ba21e90859f45);
$parcel$export(module.exports, "useShowCompactMode", () => $ca78323127435ce7$export$8a591bb42a805814);
$parcel$export(module.exports, "useShowPanels", () => $ca78323127435ce7$export$736bfa164a60e240);
$parcel$export(module.exports, "useShowEpics", () => $ca78323127435ce7$export$ecaca052f9755b4e);
$parcel$export(module.exports, "useShowVersions", () => $ca78323127435ce7$export$10178a1fc177e27a);
$parcel$export(module.exports, "useShowStatuses", () => $ca78323127435ce7$export$7a14d92e68e42de1);
$parcel$export(module.exports, "useShowUnscheduledColumn", () => $ca78323127435ce7$export$afb23457b0007ce7);
$parcel$export(module.exports, "useShowIssueLinksStats", () => $ca78323127435ce7$export$1d584d816be8e0fd);
$parcel$export(module.exports, "useShowAssignee", () => $ca78323127435ce7$export$be6bf1e24771efde);
$parcel$export(module.exports, "useShowCardCovers", () => $ca78323127435ce7$export$77ff271d002b6f7e);
$parcel$export(module.exports, "useShowBoardName", () => $ca78323127435ce7$export$59b3ccd51053cf7e);
$parcel$export(module.exports, "useHasCardExtraFields", () => $ca78323127435ce7$export$9e1ece2ef34a030);
$parcel$export(module.exports, "useCardFieldsSettings", () => $ca78323127435ce7$export$e41d531469117029);
$parcel$export(module.exports, "useShowOfftrackDependencyLines", () => $ca78323127435ce7$export$e709b26074f3a4a5);
$parcel$export(module.exports, "useIssueIdsToShowDependencies", () => $ca78323127435ce7$export$b6fb171038a9e77e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $duOMW = parcelRequire("duOMW");

var $6zihU = parcelRequire("6zihU");

var $ffHmx = parcelRequire("ffHmx");
const $ca78323127435ce7$var$Store = (0, $iXqE5.createStore)({
    name: 'ViewSettings',
    initialState: $duOMW.initialState,
    actions: $6zihU.actions
});
const $ca78323127435ce7$export$920204d7413f6fe1 = (0, $gg7kZ.createContainer)($ca78323127435ce7$var$Store, {
    onInit: (0, $6zihU.actions).initState
});
const $ca78323127435ce7$export$704cffd05c51e2b6 = (0, $3sQ5x.createHook)($ca78323127435ce7$var$Store);
const $ca78323127435ce7$export$d6a70239aff099b8 = (0, $3sQ5x.createActionsHook)($ca78323127435ce7$var$Store);
const $ca78323127435ce7$export$d397eccea5f37b0a = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getIsFullscreen)
});
const $ca78323127435ce7$export$459b400687bc0f20 = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowVersionPanel)
});
const $ca78323127435ce7$export$203c9a05aebea04a = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowEpicPanel)
});
const $ca78323127435ce7$export$714ba21e90859f45 = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowQuickFilters)
});
const $ca78323127435ce7$export$8a591bb42a805814 = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowCompactMode)
});
const $ca78323127435ce7$export$736bfa164a60e240 = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowPanels)
});
const $ca78323127435ce7$export$ecaca052f9755b4e = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowEpics)
});
const $ca78323127435ce7$export$10178a1fc177e27a = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowVersions)
});
const $ca78323127435ce7$export$7a14d92e68e42de1 = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowStatuses)
});
const $ca78323127435ce7$export$afb23457b0007ce7 = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowUnscheduledColumn)
});
const $ca78323127435ce7$export$1d584d816be8e0fd = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowIssueLinksStats)
});
const $ca78323127435ce7$export$c94c02788702c7e4 = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowIssueType)
});
const $ca78323127435ce7$export$8007ae8b25a75629 = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowIssueKey)
});
const $ca78323127435ce7$export$75223d65852dc3c0 = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowPriority)
});
const $ca78323127435ce7$export$eac20fb60c7f35ac = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowDevelopment)
});
const $ca78323127435ce7$export$be6bf1e24771efde = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowAssignee)
});
const $ca78323127435ce7$export$b5a76590347456cc = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowEstimate)
});
const $ca78323127435ce7$export$5e8e69c97a3cd45b = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowCardExtraField)
});
const $ca78323127435ce7$export$a53839ab3a916ce3 = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowDaysInColumn)
});
const $ca78323127435ce7$export$77ff271d002b6f7e = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowCardCovers)
});
const $ca78323127435ce7$export$59b3ccd51053cf7e = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowBoardName)
});
const $ca78323127435ce7$export$9e1ece2ef34a030 = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getHasCardExtraFields)
});
const $ca78323127435ce7$export$e41d531469117029 = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getCardFieldsSettings)
});
const $ca78323127435ce7$export$e709b26074f3a4a5 = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowOfftrackDependencyLines)
});
const $ca78323127435ce7$export$b6fb171038a9e77e = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getIssueIdsToShowDependencies)
});

});
parcelRegister("6zihU", function(module, exports) {

$parcel$export(module.exports, "actions", () => $718ecccac1489fb2$export$e324594224ef24da);

var $3whhk = parcelRequire("3whhk");
const $718ecccac1489fb2$export$e324594224ef24da = {
    setViewSettings: $3whhk.setViewSettings,
    setIsFullscreen: $3whhk.setIsFullscreen,
    setViewSettingsPanels: $3whhk.setViewSettingsPanels,
    setViewSettingsQuickFilters: $3whhk.setViewSettingsQuickFilters,
    setViewSettingsCardDetails: $3whhk.setViewSettingsCardDetails,
    setViewSettingsCardExtraFields: $3whhk.setViewSettingsCardExtraFields,
    setViewSettingsCompactMode: $3whhk.setViewSettingsCompactMode,
    setShowUnscheduledColumn: $3whhk.setShowUnscheduledColumn,
    setShowOfftrackDependencyLines: $3whhk.setShowOfftrackDependencyLines,
    setIssueIdsToShowDependencies: $3whhk.setIssueIdsToShowDependencies,
    setViewSettingsShowCardCovers: $3whhk.setViewSettingsShowCardCovers,
    toggleViewSetting: $3whhk.toggleViewSetting,
    toggleShowEpics: $3whhk.toggleShowEpics,
    toggleShowVersions: $3whhk.toggleShowVersions,
    toggleShowStatuses: $3whhk.toggleShowStatuses,
    toggleShowLinkedIssuesStats: $3whhk.toggleShowLinkedIssuesStats,
    toggleExtraField: $3whhk.toggleExtraField,
    toggleShowDaysInColumn: $3whhk.toggleShowDaysInColumn,
    toggleShowDueDate: $3whhk.toggleShowDueDate,
    toggleShowLabels: $3whhk.toggleShowLabels,
    initState: $3whhk.initState
};

});
parcelRegister("3whhk", function(module, exports) {

$parcel$export(module.exports, "initState", () => $b6bf5ef387c9e297$export$f6196a6c6bb539b4);
$parcel$export(module.exports, "setViewSettings", () => $b6bf5ef387c9e297$export$99f2d9eb0b41b93);
$parcel$export(module.exports, "setIsFullscreen", () => $b6bf5ef387c9e297$export$9c73b2f282069160);
$parcel$export(module.exports, "setViewSettingsPanels", () => $b6bf5ef387c9e297$export$427f126b21640252);
$parcel$export(module.exports, "setViewSettingsQuickFilters", () => $b6bf5ef387c9e297$export$60d0caf3b1c59159);
$parcel$export(module.exports, "setViewSettingsCompactMode", () => $b6bf5ef387c9e297$export$9ca6e4490ca9b1fc);
$parcel$export(module.exports, "setViewSettingsCardDetails", () => $b6bf5ef387c9e297$export$af2e5a35023755b5);
$parcel$export(module.exports, "setViewSettingsCardExtraFields", () => $b6bf5ef387c9e297$export$b54537ba70def946);
$parcel$export(module.exports, "setViewSettingsShowCardCovers", () => $b6bf5ef387c9e297$export$d166622a8f3a93f0);
$parcel$export(module.exports, "toggleViewSetting", () => $b6bf5ef387c9e297$export$779d9a10b8826796);
$parcel$export(module.exports, "toggleShowEpics", () => $b6bf5ef387c9e297$export$c1bb93dcfa07c797);
$parcel$export(module.exports, "toggleShowVersions", () => $b6bf5ef387c9e297$export$582a65f6c8cb93ab);
$parcel$export(module.exports, "toggleShowStatuses", () => $b6bf5ef387c9e297$export$ac311ca7d5df1d03);
$parcel$export(module.exports, "toggleShowLinkedIssuesStats", () => $b6bf5ef387c9e297$export$580abda923c30dc5);
$parcel$export(module.exports, "setShowUnscheduledColumn", () => $b6bf5ef387c9e297$export$6edce735c6eb4cb0);
$parcel$export(module.exports, "toggleShowDaysInColumn", () => $b6bf5ef387c9e297$export$2849cc68d8e521b7);
$parcel$export(module.exports, "toggleShowDueDate", () => $b6bf5ef387c9e297$export$ef2b1a307fba6e8a);
$parcel$export(module.exports, "toggleShowLabels", () => $b6bf5ef387c9e297$export$229260fb852e61e0);
$parcel$export(module.exports, "toggleExtraField", () => $b6bf5ef387c9e297$export$6acb0c83c20a20);
$parcel$export(module.exports, "setShowOfftrackDependencyLines", () => $b6bf5ef387c9e297$export$2c48063cd4ef1ade);
$parcel$export(module.exports, "setIssueIdsToShowDependencies", () => $b6bf5ef387c9e297$export$f7b68cb584e33d77);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $9pP0g = parcelRequire("9pP0g");

var $8zmNw = parcelRequire("8zmNw");
const $b6bf5ef387c9e297$export$f6196a6c6bb539b4 = ()=>({ setState: setState }, { view: view })=>{
        setState({
            view: view
        });
    };
const $b6bf5ef387c9e297$export$99f2d9eb0b41b93 = (newState)=>({ setState: setState })=>{
        setState(newState);
    };
const $b6bf5ef387c9e297$export$9c73b2f282069160 = ({ boardId: boardId, view: view, isFullscreen: isFullscreen })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setViewSettingsIsFullscreen({
            boardId: boardId,
            isFullscreen: isFullscreen,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            isFullscreen: isFullscreen
        });
    };
const $b6bf5ef387c9e297$export$427f126b21640252 = ({ boardId: boardId, view: view, panelState: panelState })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setViewSettingsPanels({
            boardId: boardId,
            panelState: panelState,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showEpicPanel: panelState.EPIC_PANEL,
            showVersionPanel: panelState.VERSION_PANEL
        });
    };
const $b6bf5ef387c9e297$export$60d0caf3b1c59159 = ({ boardId: boardId, view: view, showQuickFilters: showQuickFilters })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setViewSettingsQuickFilters({
            boardId: boardId,
            showQuickFilters: showQuickFilters,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showQuickFilters: showQuickFilters
        });
    };
const $b6bf5ef387c9e297$export$9ca6e4490ca9b1fc = ({ boardId: boardId, view: view, showCompactMode: showCompactMode })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setViewSettingsCompactMode({
            boardId: boardId,
            showCompactMode: showCompactMode,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showCompactMode: showCompactMode
        });
    };
const $b6bf5ef387c9e297$export$af2e5a35023755b5 = ({ boardId: boardId, view: view, cardDetailsState: cardDetailsState })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setViewSettingsCardDetails({
            boardId: boardId,
            cardDetailsState: cardDetailsState,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showEpics: cardDetailsState.SHOW_EPICS,
            showVersions: cardDetailsState.SHOW_VERSIONS,
            showStatuses: cardDetailsState.SHOW_STATUSES,
            showIssueLinksStats: cardDetailsState.SHOW_ISSUE_LINKS_STATS,
            showDaysInColumn: cardDetailsState.SHOW_DAYS_IN_COLUMN,
            showIssueType: cardDetailsState.SHOW_ISSUE_TYPE,
            showIssueKey: cardDetailsState.SHOW_ISSUE_KEY,
            showEstimate: cardDetailsState.SHOW_ESTIMATE,
            showPriority: cardDetailsState.SHOW_PRIORITY,
            showDevelopment: cardDetailsState.SHOW_DEVELOPMENT,
            showAssignee: cardDetailsState.SHOW_ASSIGNEE,
            showDueDate: cardDetailsState.SHOW_DUE_DATE,
            showLabels: cardDetailsState.SHOW_LABELS,
            showCardCovers: cardDetailsState.SHOW_CARD_COVERS,
            showBoardName: cardDetailsState.SHOW_BOARD_NAME
        });
    };
const $b6bf5ef387c9e297$export$b54537ba70def946 = ({ boardId: boardId, view: view, cardExtraFieldsState: cardExtraFieldsState })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setViewSettingsCardExtraFields({
            boardId: boardId,
            cardExtraFieldsState: cardExtraFieldsState,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            cardExtraFields: cardExtraFieldsState
        });
    };
const $b6bf5ef387c9e297$export$d166622a8f3a93f0 = ({ boardId: boardId, view: view, showCardCovers: showCardCovers })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        const newState = {
            ...currentSettings,
            showCardCovers: showCardCovers
        };
        $8zmNw.setViewSettings({
            boardId: boardId,
            state: newState,
            view: view || currentSettings.view || undefined
        });
        setState(newState);
    };
const $b6bf5ef387c9e297$export$779d9a10b8826796 = ({ boardId: boardId, view: view, setting: setting })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        const set = (newState)=>{
            setState(newState);
            $8zmNw.setViewSettings({
                boardId: boardId,
                state: newState,
                view: view || currentSettings.view || undefined
            });
        };
        switch(setting){
            case (0, $9pP0g.ViewSetting).VERSION_PANEL:
                set({
                    ...currentSettings,
                    showVersionPanel: !currentSettings.showVersionPanel
                });
                break;
            case (0, $9pP0g.ViewSetting).EPIC_PANEL:
                set({
                    ...currentSettings,
                    showEpicPanel: !currentSettings.showEpicPanel
                });
                break;
            case (0, $9pP0g.ViewSetting).QUICK_FILTERS:
                set({
                    ...currentSettings,
                    showQuickFilters: !currentSettings.showQuickFilters
                });
                break;
            case (0, $9pP0g.ViewSetting).COMPACT_MODE:
                set({
                    ...currentSettings,
                    showCompactMode: !currentSettings.showCompactMode
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_EPICS:
                set({
                    ...currentSettings,
                    showEpics: !currentSettings.showEpics
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_STATUSES:
                set({
                    ...currentSettings,
                    showStatuses: !currentSettings.showStatuses
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_VERSIONS:
                set({
                    ...currentSettings,
                    showVersions: !currentSettings.showVersions
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_UNSCHEDULED_COLUMN:
                set({
                    ...currentSettings,
                    showUnscheduledColumn: !currentSettings.showUnscheduledColumn
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_ISSUE_KEY:
                set({
                    ...currentSettings,
                    showIssueKey: !currentSettings.showIssueKey
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_ISSUE_TYPE:
                set({
                    ...currentSettings,
                    showIssueType: !currentSettings.showIssueType
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_PRIORITY:
                set({
                    ...currentSettings,
                    showPriority: !currentSettings.showPriority
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_DEVELOPMENT:
                set({
                    ...currentSettings,
                    showDevelopment: !currentSettings.showDevelopment
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_ASSIGNEE:
                set({
                    ...currentSettings,
                    showAssignee: !currentSettings.showAssignee
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_ESTIMATE:
                set({
                    ...currentSettings,
                    showEstimate: !currentSettings.showEstimate
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_DAYS_IN_COLUMN:
                set({
                    ...currentSettings,
                    showDaysInColumn: !currentSettings.showDaysInColumn
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_DUE_DATE:
                set({
                    ...currentSettings,
                    showDueDate: !currentSettings.showDueDate
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_LABELS:
                set({
                    ...currentSettings,
                    showLabels: !currentSettings.showLabels
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_CARD_COVERS:
                set({
                    ...currentSettings,
                    showCardCovers: !currentSettings.showCardCovers
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_OFFTRACK_DEPENDENCY_LINES:
                set({
                    ...currentSettings,
                    showOfftrackDependencyLines: !currentSettings.showOfftrackDependencyLines
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_BOARD_NAME:
                set({
                    ...currentSettings,
                    showBoardName: !currentSettings.showBoardName
                });
                break;
            default:
                break;
        }
    };
const $b6bf5ef387c9e297$export$c1bb93dcfa07c797 = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setShowEpics({
            boardId: boardId,
            showEpics: !currentSettings.showEpics,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showEpics: !currentSettings.showEpics
        });
    };
const $b6bf5ef387c9e297$export$582a65f6c8cb93ab = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setShowVersions({
            boardId: boardId,
            showVersions: !currentSettings.showVersions,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showVersions: !currentSettings.showVersions
        });
    };
const $b6bf5ef387c9e297$export$ac311ca7d5df1d03 = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setShowStatuses({
            boardId: boardId,
            showStatuses: !currentSettings.showStatuses,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showStatuses: !currentSettings.showStatuses
        });
    };
const $b6bf5ef387c9e297$export$580abda923c30dc5 = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setShowIssueLinksStats({
            boardId: boardId,
            showIssueLinksStats: !currentSettings.showIssueLinksStats,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showIssueLinksStats: !currentSettings.showIssueLinksStats
        });
    };
const $b6bf5ef387c9e297$export$6edce735c6eb4cb0 = (boardId, isVisible)=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setShowUnscheduledColumn({
            boardId: boardId,
            showUnscheduledColumn: isVisible
        });
        setState({
            ...currentSettings,
            showUnscheduledColumn: isVisible
        });
    };
const $b6bf5ef387c9e297$export$2849cc68d8e521b7 = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setShowDaysInColumn({
            boardId: boardId,
            showDaysInColumn: !currentSettings.showDaysInColumn,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showDaysInColumn: !currentSettings.showDaysInColumn
        });
    };
const $b6bf5ef387c9e297$export$ef2b1a307fba6e8a = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setShowDueDate({
            boardId: boardId,
            showDueDate: !currentSettings.showDueDate,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showDueDate: !currentSettings.showDueDate
        });
    };
const $b6bf5ef387c9e297$export$229260fb852e61e0 = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setShowLabels({
            boardId: boardId,
            showLabels: !currentSettings.showLabels,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showLabels: !currentSettings.showLabels
        });
    };
const $b6bf5ef387c9e297$export$6acb0c83c20a20 = ({ boardId: boardId, view: view, fieldId: fieldId })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        const currentExtraFields = currentSettings.cardExtraFields;
        $8zmNw.setExtraFields({
            boardId: boardId,
            cardExtraFields: {
                ...currentExtraFields,
                [fieldId]: !currentExtraFields[fieldId]
            },
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            cardExtraFields: {
                ...currentExtraFields,
                [fieldId]: !currentExtraFields[fieldId]
            }
        });
    };
const $b6bf5ef387c9e297$export$2c48063cd4ef1ade = (boardId, isVisible)=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setShowOfftrackDependencyLines({
            boardId: boardId,
            showOfftrackDependencyLines: isVisible
        });
        setState({
            ...currentSettings,
            showOfftrackDependencyLines: isVisible
        });
    };
const $b6bf5ef387c9e297$export$f7b68cb584e33d77 = (boardId, issueIds)=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setIssueIdsToShowDependencies({
            boardId: boardId,
            issueIds: issueIds
        });
        setState({
            ...currentSettings,
            issueIdsToShowDependencies: issueIds
        });
    };

});
parcelRegister("9pP0g", function(module, exports) {

$parcel$export(module.exports, "ViewSetting", () => $23bab0da4eba41c6$export$b6da678b61e4982c);

var $a4XJc = parcelRequire("a4XJc");

var $iJgHp = parcelRequire("iJgHp");
const $23bab0da4eba41c6$export$b6da678b61e4982c = {
    ...(0, $a4XJc.Panels),
    ...(0, $iJgHp.CardDetails),
    ...(0, $a4XJc.IncrementPlanningSettings),
    QUICK_FILTERS: $a4XJc.QUICK_FILTERS,
    COMPACT_MODE: $a4XJc.COMPACT_MODE
};

});
parcelRegister("iJgHp", function(module, exports) {

$parcel$export(module.exports, "CardDetails", () => $a1cb757db25241b3$export$741386389156bf07);

var $a4XJc = parcelRequire("a4XJc");
const $a1cb757db25241b3$export$741386389156bf07 = {
    SHOW_ISSUE_KEY: $a4XJc.SHOW_ISSUE_KEY,
    SHOW_ISSUE_TYPE: $a4XJc.SHOW_ISSUE_TYPE,
    SHOW_EPICS: $a4XJc.SHOW_EPICS,
    SHOW_STATUSES: $a4XJc.SHOW_STATUSES,
    SHOW_VERSIONS: $a4XJc.SHOW_VERSIONS,
    SHOW_ISSUE_LINKS_STATS: $a4XJc.SHOW_ISSUE_LINKS_STATS,
    SHOW_PRIORITY: $a4XJc.SHOW_PRIORITY,
    SHOW_DEVELOPMENT: $a4XJc.SHOW_DEVELOPMENT,
    SHOW_ASSIGNEE: $a4XJc.SHOW_ASSIGNEE,
    SHOW_ESTIMATE: $a4XJc.SHOW_ESTIMATE,
    SHOW_DAYS_IN_COLUMN: $a4XJc.SHOW_DAYS_IN_COLUMN,
    SHOW_DUE_DATE: $a4XJc.SHOW_DUE_DATE,
    SHOW_LABELS: $a4XJc.SHOW_LABELS,
    SHOW_CARD_COVERS: $a4XJc.SHOW_CARD_COVERS,
    SHOW_BOARD_NAME: $a4XJc.SHOW_BOARD_NAME
};

});




parcelRegister("ffHmx", function(module, exports) {

$parcel$export(module.exports, "getIsFullscreen", () => $fc378329dceca517$export$b061161f83abaf15);
$parcel$export(module.exports, "getShowVersionPanel", () => $fc378329dceca517$export$cdf1158c8123d31c);
$parcel$export(module.exports, "getShowEpicPanel", () => $fc378329dceca517$export$fc9a39e5c1906367);
$parcel$export(module.exports, "getShowQuickFilters", () => $fc378329dceca517$export$732caa9fcae1c5ff);
$parcel$export(module.exports, "getShowCompactMode", () => $fc378329dceca517$export$72bae49530cc02bb);
$parcel$export(module.exports, "getShowPanels", () => $fc378329dceca517$export$e2483fb3e0d0ff4b);
$parcel$export(module.exports, "getShowEpics", () => $fc378329dceca517$export$b631ebb4887e6060);
$parcel$export(module.exports, "getShowVersions", () => $fc378329dceca517$export$2cb6de520195dbf5);
$parcel$export(module.exports, "getShowStatuses", () => $fc378329dceca517$export$b5f1c34af9498ea);
$parcel$export(module.exports, "getShowUnscheduledColumn", () => $fc378329dceca517$export$bf31a7b99f7bc62f);
$parcel$export(module.exports, "getShowIssueLinksStats", () => $fc378329dceca517$export$266785c43d094472);
$parcel$export(module.exports, "getShowIssueType", () => $fc378329dceca517$export$a079b5f709c4d237);
$parcel$export(module.exports, "getShowIssueKey", () => $fc378329dceca517$export$cb710ef8b1ccd94b);
$parcel$export(module.exports, "getShowPriority", () => $fc378329dceca517$export$5abfbf16fb2cec7b);
$parcel$export(module.exports, "getShowDevelopment", () => $fc378329dceca517$export$d89a1b3e54af627e);
$parcel$export(module.exports, "getShowAssignee", () => $fc378329dceca517$export$ad1a6d247a05049d);
$parcel$export(module.exports, "getShowEstimate", () => $fc378329dceca517$export$d21c0b83591460c9);
$parcel$export(module.exports, "getShowCardExtraField", () => $fc378329dceca517$export$7549550e839e6e0c);
$parcel$export(module.exports, "getShowDaysInColumn", () => $fc378329dceca517$export$9a608cd91e68c95c);
$parcel$export(module.exports, "getShowCardCovers", () => $fc378329dceca517$export$983376245b8547dc);
$parcel$export(module.exports, "getShowOfftrackDependencyLines", () => $fc378329dceca517$export$32c01395d25dfdcc);
$parcel$export(module.exports, "getShowBoardName", () => $fc378329dceca517$export$e3335f300fcfef70);
$parcel$export(module.exports, "getIssueIdsToShowDependencies", () => $fc378329dceca517$export$67e6bba1326e537a);
$parcel$export(module.exports, "getCardFieldsSettings", () => $fc378329dceca517$export$e9dfc10bd434fabb);
$parcel$export(module.exports, "getHasCardExtraFields", () => $fc378329dceca517$export$1e24fae4497ff7e0);
const $fc378329dceca517$export$b061161f83abaf15 = (state)=>state.isFullscreen;
const $fc378329dceca517$export$cdf1158c8123d31c = (state)=>state.showVersionPanel;
const $fc378329dceca517$export$fc9a39e5c1906367 = (state)=>state.showEpicPanel;
const $fc378329dceca517$export$732caa9fcae1c5ff = (state)=>state.showQuickFilters;
const $fc378329dceca517$export$72bae49530cc02bb = (state)=>state.showCompactMode;
const $fc378329dceca517$export$e2483fb3e0d0ff4b = (state)=>({
        EPIC_PANEL: state.showEpicPanel,
        VERSION_PANEL: state.showVersionPanel
    });
const $fc378329dceca517$export$b631ebb4887e6060 = (state)=>state.showEpics;
const $fc378329dceca517$export$2cb6de520195dbf5 = (state)=>state.showVersions;
const $fc378329dceca517$export$b5f1c34af9498ea = (state)=>state.showStatuses;
const $fc378329dceca517$export$bf31a7b99f7bc62f = (state)=>state.showUnscheduledColumn;
const $fc378329dceca517$export$266785c43d094472 = (state)=>state.showIssueLinksStats;
const $fc378329dceca517$export$a079b5f709c4d237 = (state)=>state.showIssueType;
const $fc378329dceca517$export$cb710ef8b1ccd94b = (state)=>state.showIssueKey;
const $fc378329dceca517$export$5abfbf16fb2cec7b = (state)=>state.showPriority;
const $fc378329dceca517$export$d89a1b3e54af627e = (state)=>state.showDevelopment;
const $fc378329dceca517$export$ad1a6d247a05049d = (state)=>state.showAssignee;
const $fc378329dceca517$export$d21c0b83591460c9 = (state)=>state.showEstimate;
const $fc378329dceca517$export$7549550e839e6e0c = (state)=>state.cardExtraFields;
const $fc378329dceca517$export$9a608cd91e68c95c = (state)=>state.showDaysInColumn;
const $fc378329dceca517$export$983376245b8547dc = (state)=>state.showCardCovers;
const $fc378329dceca517$export$32c01395d25dfdcc = (state)=>state.showOfftrackDependencyLines;
const $fc378329dceca517$export$e3335f300fcfef70 = (state)=>state.showBoardName;
const $fc378329dceca517$export$67e6bba1326e537a = (state)=>state.issueIdsToShowDependencies;
const $fc378329dceca517$export$e9dfc10bd434fabb = (state)=>({
        showIssueType: state.showIssueType,
        showIssueKey: state.showIssueKey,
        showPriority: state.showPriority,
        showDevelopment: state.showDevelopment,
        showAssignee: state.showAssignee,
        showEstimate: state.showEstimate,
        cardExtraFields: state.cardExtraFields,
        showDaysInColumn: state.showDaysInColumn,
        showDueDate: state.showDueDate,
        showLabels: state.showLabels,
        showCardCovers: state.showCardCovers,
        showStatuses: state.showStatuses
    });
const $fc378329dceca517$export$1e24fae4497ff7e0 = (state)=>Object.values(state.cardExtraFields).length > 0 && Object.values(state.cardExtraFields).some((value)=>value === true);

});





parcelRegister("hzdKw", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4b88614fc499447$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $10Ngv = parcelRequire("10Ngv");

var $guzeq = parcelRequire("guzeq");

var $3lZ6i = parcelRequire("3lZ6i");

var $c1MAf = parcelRequire("c1MAf");

var $fmuR9 = parcelRequire("fmuR9");
const $d4b88614fc499447$var$GICOnCloseHandler = ({ bindToOnJiraGlobalIssueCreateClose: bindToOnJiraGlobalIssueCreateClose })=>{
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const issueParents = (0, $c1MAf.useBacklogSelector)((state)=>(0, $fmuR9.issueParentsSelector)(state));
    const storeFieldsActions = (0, $10Ngv.useStoreFields)({
        issueParents: issueParents
    });
    (0, $5uXOq.useEffect)(()=>{
        bindToOnJiraGlobalIssueCreateClose((_, issues)=>{
            dispatch((0, $3lZ6i.refreshDataRequest)((0, $guzeq.REFRESH_SOURCE_GLOBAL_ISSUE_CREATE), issues, storeFieldsActions));
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
var $d4b88614fc499447$export$2e2bcd8739ae039 = $d4b88614fc499447$var$GICOnCloseHandler;

});

parcelRegister("9OvEV", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4dbe1b645c1b407$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $8QpSo = parcelRequire("8QpSo");

var $cb25w = parcelRequire("cb25w");

var $jzjy1 = parcelRequire("jzjy1");

var $8lxl7 = parcelRequire("8lxl7");

var $x9xyg = parcelRequire("x9xyg");

var $bC2fB = parcelRequire("bC2fB");



var $3lZ6i = parcelRequire("3lZ6i");

var $a7yHf = parcelRequire("a7yHf");

var $4mqko = parcelRequire("4mqko");

var $9g0YE = parcelRequire("9g0YE");

var $9MUCL = parcelRequire("9MUCL");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $fmuR9 = parcelRequire("fmuR9");

var $8YYZB = parcelRequire("8YYZB");
const $b4dbe1b645c1b407$export$c31df4bd766f9c35 = (state)=>({
        storyPointFieldId: (0, $jG5HW.getStoryPointFieldId)(state),
        epicIssueType: (0, $jG5HW.getEpicIssueType)(state),
        cardListIds: (0, $dGljH.getVisibleCardListIds)(state),
        cardLists: (0, $dGljH.getCardLists)(state),
        selectedCards: (0, $dGljH.getSelectedCards)(state),
        isDetailViewVisible: (0, $dGljH.shouldShowDetailView)(state),
        getCardKeyFromCardId: (0, $dGljH.makeCardKeyFromCardId)(state),
        collapsedCardLists: (0, $dGljH.getCollapsedCardLists)(state),
        boardId: Number((0, $jG5HW.getRapidViewId)(state)),
        baseUrl: (0, $jG5HW.getBaseUrl)(state),
        projectKey: (0, $jG5HW.getProjectKey)(state),
        backlogSessionId: (0, $jG5HW.getSessionId)(state),
        issueHierarchyLevel: (0, $fmuR9.issueHierarchyLevelSelector)(state)(),
        getSourceCardListId: (0, $dGljH.makeGetSourceCardListId)(state),
        getSourceCardGroupId: (0, $dGljH.makeGetSourceCardGroupId)(state),
        getCardHierarchyLevel: (0, $dGljH.makeGetCardHierarchyLevel)(state)
    });
const $b4dbe1b645c1b407$export$9e6a17cf56877796 = (dispatch)=>({
        onBacklogView: (analyticsEvent)=>{
            dispatch((0, $3lZ6i.backlogView)(analyticsEvent));
        },
        onCardListsDisable: (cardListIds)=>{
            dispatch((0, $a7yHf.cardListsDisable)(cardListIds));
        },
        onCardListsEnableAll: ()=>{
            dispatch((0, $a7yHf.cardListsEnableAll)());
        },
        onCardSingleSelect: (cardId)=>{
            dispatch((0, $4mqko.cardSingleSelect)(cardId));
        },
        onTogglePanel: (panel)=>{
            dispatch((0, $9g0YE.togglePanel)(panel));
        }
    });
const $b4dbe1b645c1b407$var$onPanelClose = ({ onTogglePanel: onTogglePanel }, panelType)=>()=>{
        onTogglePanel(panelType);
    };
const $b4dbe1b645c1b407$var$onBacklogViewFactory = (0, $8QpSo.default)((onBacklogView)=>(analyticsEvent)=>{
        (0, $x9xyg.setMark)((0, $4cb373726ed9c2f0$export$82147bdd117dc85a));
        (0, $x9xyg.setMark)((0, $4cb373726ed9c2f0$export$e9a67bcd28a7fa89));
        onBacklogView(analyticsEvent);
    });
const $b4dbe1b645c1b407$var$onEpicPanelCloseFactory = (0, $8QpSo.default)((onTogglePanel, panelType)=>$b4dbe1b645c1b407$var$onPanelClose({
        onTogglePanel: onTogglePanel
    }, panelType));
const $b4dbe1b645c1b407$var$onVersionPanelCloseFactory = (0, $8QpSo.default)((onTogglePanel, panelType)=>$b4dbe1b645c1b407$var$onPanelClose({
        onTogglePanel: onTogglePanel
    }, panelType));
const $b4dbe1b645c1b407$export$9d1611c77c2fe928 = ({ storyPointFieldId: storyPointFieldId, epicIssueType: epicIssueType, cardListIds: cardListIds, isDetailViewVisible: isDetailViewVisible, boardId: boardId, baseUrl: baseUrl, projectKey: projectKey, issueHierarchyLevel: issueHierarchyLevel }, { onBacklogView: onBacklogView, onTogglePanel: onTogglePanel }, { isCacheHit: isCacheHit, prefetchedData: prefetchedData, prefetchedPlanData: prefetchedPlanData, customFiltersQueryRef: customFiltersQueryRef, versionFilterRelayQueryRef: versionFilterRelayQueryRef })=>({
        isCacheHit: isCacheHit,
        prefetchedData: prefetchedData,
        prefetchedPlanData: prefetchedPlanData,
        storyPointFieldId: storyPointFieldId,
        epicIssueType: epicIssueType,
        cardListIds: cardListIds,
        isDetailViewVisible: isDetailViewVisible,
        boardId: boardId,
        baseUrl: baseUrl,
        projectKey: projectKey,
        issueHierarchyLevel: issueHierarchyLevel,
        onBacklogView: $b4dbe1b645c1b407$var$onBacklogViewFactory(onBacklogView),
        onEpicPanelClose: $b4dbe1b645c1b407$var$onEpicPanelCloseFactory(onTogglePanel, (0, $c35fd6591a78fffe$export$a10c132b86ae798b)),
        onVersionPanelClose: $b4dbe1b645c1b407$var$onVersionPanelCloseFactory(onTogglePanel, (0, $c35fd6591a78fffe$export$41073ac826c57195)),
        customFiltersQueryRef: customFiltersQueryRef,
        versionFilterRelayQueryRef: versionFilterRelayQueryRef
    });
var $b4dbe1b645c1b407$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $cb25w.default)(), (0, $8lxl7.default)((state)=>({
        attributes: (0, $9MUCL.getAttributes)(state)
    })), (0, $jzjy1.AnalyticsSubject)('backlog'), (0, $bC2fB.connect)($b4dbe1b645c1b407$export$c31df4bd766f9c35, $b4dbe1b645c1b407$export$9e6a17cf56877796, $b4dbe1b645c1b407$export$9d1611c77c2fe928))((0, $8YYZB.default));

});
parcelRegister("8lxl7", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3768e8b105140d5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $daJ0i = parcelRequire("daJ0i");

var $bC2fB = parcelRequire("bC2fB");

var $cAj1I = parcelRequire("cAj1I");

var $i4iBk = parcelRequire("i4iBk");
const $d3768e8b105140d5$var$ReduxAnalyticsData = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
mapStateToAnalytics, connectOptions = {})=>(WrappedComponent)=>{
        // eslint-disable-next-line jira/react/no-class-components
        class ComponentWrappedInAnalytics extends (0, $5uXOq.Component) {
            static{
                this.displayName = `ReduxAnalyticsData(${WrappedComponent.displayName || WrappedComponent.name})`;
            }
            static{
                this.defaultProps = {
                    analyticsContext: {}
                };
            }
            render() {
                const { analyticsContext: analyticsContext, ...componentProps } = this.props;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $daJ0i.default), {
                    data: analyticsContext
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, componentProps));
            }
        }
        const mapStateToPropsFactory = ()=>{
            const analyticsContextSelectorInstance = (0, $8QpSo.default)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
            (state, ownProps)=>(0, $i4iBk.default)(mapStateToAnalytics(state, ownProps)));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (state, ownProps)=>({
                    analyticsContext: analyticsContextSelectorInstance(state, ownProps)
                });
        };
        return (0, $bC2fB.connect)(mapStateToPropsFactory, ()=>({}), null, {
            // to prevent connected component from unnecessary re-render
            areStatePropsEqual: (nextProps, prevProps)=>{
                const { attributes: prevAttributes, ...prevFields } = prevProps.analyticsContext;
                const { attributes: nextAttributes, ...nextFields } = nextProps.analyticsContext;
                return (0, $cAj1I.default)(prevAttributes, nextAttributes) && (0, $cAj1I.default)(prevFields, nextFields);
            },
            ...connectOptions
        })(ComponentWrappedInAnalytics);
    };
var $d3768e8b105140d5$export$2e2bcd8739ae039 = $d3768e8b105140d5$var$ReduxAnalyticsData;

});
parcelRegister("cAj1I", function(module, exports) {

$parcel$export(module.exports, "default", () => $95d580e76a13b783$export$2e2bcd8739ae039);
const $95d580e76a13b783$var$isArrayEqual = (array1 = [], array2 = [])=>{
    if (array1 === array2) return true;
    // check one level deep
    return array1.length === array2.length && array1.every((item, index)=>item === array2[index]);
};
var // one level check to see if object references are equal
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$95d580e76a13b783$export$2e2bcd8739ae039 = (obj1, obj2)=>{
    if (obj1 === obj2) return true;
    if (!obj1 || !obj2) return false;
    const item1Keys = Object.keys(obj1).sort();
    const item2Keys = Object.keys(obj2).sort();
    // are keys equal?
    // @ts-expect-error - TS2345 - Argument of type 'string[]' is not assignable to parameter of type 'never[]'.
    if (!$95d580e76a13b783$var$isArrayEqual(item1Keys, item2Keys)) return false;
    // are the values equal?
    const areValuesEqual = item2Keys.every((key)=>{
        const value = obj1[key];
        const nextValue = obj2[key];
        if (value === nextValue) return true;
        // @ts-expect-error - TS2345 - Argument of type 'any[]' is not assignable to parameter of type 'never[]'.
        return Array.isArray(nextValue) && Array.isArray(value) && $95d580e76a13b783$var$isArrayEqual(value, nextValue);
    });
    return areValuesEqual;
};

});


const $4cb373726ed9c2f0$export$82147bdd117dc85a = 'BACKLOG_READY_FOR_USER_MARK';
const $4cb373726ed9c2f0$export$e9a67bcd28a7fa89 = 'BACKLOG_INTERACTIVE_MARK';

parcelRegister("8YYZB", function(module, exports) {

$parcel$export(module.exports, "default", () => $083bc8c563c121c0$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $34ck9 = parcelRequire("34ck9");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $gJlZe = parcelRequire("gJlZe");

var $5ZW09 = parcelRequire("5ZW09");

var $hP2lu = parcelRequire("hP2lu");

var $hZHze = parcelRequire("hZHze");

var $acDhY = parcelRequire("acDhY");

var $5vJHu = parcelRequire("5vJHu");

var $7wqBZ = parcelRequire("7wqBZ");

var $dhsbO = parcelRequire("dhsbO");

var $4R6GH = parcelRequire("4R6GH");

var $g4tDr = parcelRequire("g4tDr");

var $8CVvd = parcelRequire("8CVvd");

var $3HwlS = parcelRequire("3HwlS");

var $2Z6La = parcelRequire("2Z6La");

var $l8ruj = parcelRequire("l8ruj");

var $5NBkv = parcelRequire("5NBkv");

var $iXVV6 = parcelRequire("iXVV6");
var $2NMNM = parcelRequire("2NMNM");

var $5Nutl = parcelRequire("5Nutl");

var $i8JTM = parcelRequire("i8JTM");

var $5fQw9 = parcelRequire("5fQw9");

var $kJ1Ne = parcelRequire("kJ1Ne");

var $9hLEH = parcelRequire("9hLEH");

var $7D59a = parcelRequire("7D59a");

var $3U6yu = parcelRequire("3U6yu");

var $dFfIn = parcelRequire("dFfIn");

var $dCm1o = parcelRequire("dCm1o");

var $6cG4N = parcelRequire("6cG4N");

var $lmBAt = parcelRequire("lmBAt");

var $ijYb7 = parcelRequire("ijYb7");

var $9OXo1 = parcelRequire("9OXo1");

var $ldyPw = parcelRequire("ldyPw");

var $g3TqM = parcelRequire("g3TqM");

var $bVDE5 = parcelRequire("bVDE5");


var $10Ngv = parcelRequire("10Ngv");


var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $1z1J7 = parcelRequire("1z1J7");

var $9Pc1U = parcelRequire("9Pc1U");

var $fSgHa = parcelRequire("fSgHa");

var $3VzmQ = parcelRequire("3VzmQ");

var $zM1Qq = parcelRequire("zM1Qq");

var $1wpyB = parcelRequire("1wpyB");

var $4APWT = parcelRequire("4APWT");

var $gFU0Q = parcelRequire("gFU0Q");

var $2jVnP = parcelRequire("2jVnP");

var $gz0if = parcelRequire("gz0if");

var $ab9TP = parcelRequire("ab9TP");

var $5A42o = parcelRequire("5A42o");

var $X8Rcv = parcelRequire("X8Rcv");

var $aPfpu = parcelRequire("aPfpu");

var $bzlhL = parcelRequire("bzlhL");

var $aammX = parcelRequire("aammX");

var $emFUM = parcelRequire("emFUM");

var $h7RbI = parcelRequire("h7RbI");

var $b75A0 = parcelRequire("b75A0");

var $9HRx0 = parcelRequire("9HRx0");

var $1UKUc = parcelRequire("1UKUc");

var $4MJfo = parcelRequire("4MJfo");
const $083bc8c563c121c0$var$BacklogComponent = ({ isCacheHit: isCacheHit, boardId: boardId, baseUrl: baseUrl, projectKey: projectKey, isDetailViewVisible: isDetailViewVisible, issueHierarchyLevel: issueHierarchyLevel = (0, $g4tDr.ISSUE_HIERARCHY_LEVEL_BASE), cardListIds: cardListIds, onBacklogView: onBacklogViewProp, onEpicPanelClose: onEpicPanelCloseProp, onVersionPanelClose: onVersionPanelCloseProp, customFiltersQueryRef: customFiltersQueryRef, versionFilterRelayQueryRef: versionFilterRelayQueryRef })=>{
    const isViewEventSent = (0, $5uXOq.useRef)(false);
    const [width, setWidth] = (0, $5uXOq.useState)(0);
    const [openSidebar, setOpenSidebar] = (0, $5uXOq.useState)(false);
    const throttledSetWidth = (0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))(setWidth, 50);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const shouldShowAdminInaccessibleBoard = (0, $hP2lu.useShouldShowAdminInaccessibleBoard)((0, $5Nutl.uifBacklogResource));
    const onBacklogView = (0, $7D59a.useEvent)(onBacklogViewProp);
    const onEpicPanelClose = (0, $7D59a.useEvent)(onEpicPanelCloseProp);
    const onVersionPanelClose = (0, $7D59a.useEvent)(onVersionPanelCloseProp);
    const isCMPBacklog = (0, $fSgHa.useIsCMPBacklog)();
    const [{ isInitialRender: isInitialRender }] = (0, $4R6GH.fg)('backlog_skeleton_sync_with_store') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $bVDE5.useSpaStateTransition)() : [
        {
            isInitialRender: undefined
        }
    ];
    const isStoreInitialised = (0, $4R6GH.fg)('backlog_skeleton_sync_with_store') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $c1MAf.useBacklogSelector)((0, $9Pc1U.isCriticalDataLoaded)) : undefined;
    const onOpenSidebar = (0, $5uXOq.useCallback)(()=>{
        setOpenSidebar(true);
    }, []);
    const onCloseSidebar = (0, $5uXOq.useCallback)(()=>{
        setOpenSidebar(false);
    }, []);
    const isEpicPanelOpen = (0, $zM1Qq.useIsEpicPanelOpen)();
    (0, $5NBkv.usePreloadEpicPanel)(isEpicPanelOpen && (0, $4R6GH.fg)('preload_epic_panel_component'), boardId, isCMPBacklog);
    (0, $5uXOq.useEffect)(()=>{
        const timer = setTimeout(()=>{
            (0, $7wqBZ.getLongTasksMetrics)('filter').stop((0, $dhsbO.filterReporter));
        }, 1);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.body?.classList.add('spb');
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.body?.classList.remove('spb');
            clearTimeout(timer);
        };
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (!isViewEventSent.current && cardListIds.length > 0) {
            isViewEventSent.current = true;
            const analyticsEvent = createAnalyticsEvent({});
            onBacklogView(analyticsEvent);
        }
    }, [
        onBacklogView,
        cardListIds.length,
        createAnalyticsEvent
    ]);
    const bulkOperationsForm = (0, $5vJHu.useReferenceLoader)();
    const issueCount = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCardsCount));
    const userCanEditBoardConfig = (0, $c1MAf.useBacklogSelector)((0, $1z1J7.getPermissions))[0, $a33d0dff7e784665$export$b35e3ebf2c83a499];
    const backlogContainerIssueCount = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getOrderedCardIdsByCardListId)).BACKLOG?.length;
    const isScrumBacklog = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.isScrumBacklogStrategy));
    const issueLimitFlagViews = (0, $5uXOq.useMemo)(()=>{
        if (isCMPBacklog) return [
            {
                view: 'BACKLOG',
                issueCount: issueCount
            }
        ];
        return [
            {
                view: 'BACKLOG',
                issueCount: backlogContainerIssueCount
            },
            {
                view: isScrumBacklog ? 'SPRINTS' : 'BOARD',
                issueCount: issueCount - backlogContainerIssueCount
            }
        ];
    }, [
        issueCount,
        backlogContainerIssueCount,
        isScrumBacklog,
        isCMPBacklog
    ]);
    const shouldShowIssueLimitFlags = issueLimitFlagViews.some((view)=>view.issueCount >= (0, $ijYb7.ISSUE_APPROACHING_LIMIT));
    const projectId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getProjects))?.find((project)=>project.key === projectKey)?.id;
    const shouldShowPublicFormsChangeboardingModal = projectId && userCanEditBoardConfig && (0, $4R6GH.fg)('jira_forms_public_access_changeboarding_gate');
    const isBulkOpsAvailable = (0, $3VzmQ.useShowCheckbox)();
    const { appEditions: appEditions } = (0, $9OXo1.useTenantContext)();
    const shouldMountStorageLimitsBanner = appEditions.software === (0, $ldyPw.FREE_EDITION);
    if (isStoreInitialised === false && isInitialRender === true && (0, $4R6GH.fg)('backlog_skeleton_sync_with_store')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8JTM.NextGenBacklogSkeleton), null);
    const ContainerComponent = (0, $3HwlS.getWillShowNav4)() ? $083bc8c563c121c0$var$HeightlessContainer : $083bc8c563c121c0$var$Container;
    const HeaderWrapperComponent = (0, $lmBAt.getIsSoftwareThemingM2Enabled)() ? (0, $g3TqM.ContrastThemeWrapper) : (0, $5uXOq.Fragment);
    // created to avoid duplication and will be moved back when cleaning up the FF.
    const backlogContainerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ContainerComponent, {
        "data-test-id": "software-backlog.backlog",
        "data-testid": "software-backlog.backlog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $X8Rcv.default), null), (shouldMountStorageLimitsBanner || !(0, $4R6GH.fg)('conditionally_load_storagelimitsbanner_in_backlog')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3U6yu.StorageLimitsBanner), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "backlog-header"
    }, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(HeaderWrapperComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $083bc8c563c121c0$var$pageHeaderStyles,
            (0, $lmBAt.getIsSoftwareThemingM2Enabled)('blurry-background') && $083bc8c563c121c0$var$pageHeaderBackgroundStyles
        ],
        testId: "software-backlog.page-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aammX.default), {
        customFiltersQueryRef: customFiltersQueryRef,
        versionFilterRelayQueryRef: versionFilterRelayQueryRef
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($083bc8c563c121c0$var$PageHeaderWrapper, {
        "data-testid": "software-backlog.page-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aammX.default), {
        customFiltersQueryRef: customFiltersQueryRef,
        versionFilterRelayQueryRef: versionFilterRelayQueryRef
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            analyticsSource: (0, $a9c483c0d986286a$export$840e3848643f7781)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($083bc8c563c121c0$var$SizeDetectorWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Z6La.IccProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gJlZe.WidthObserver), {
        setWidth: throttledSetWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4APWT.default), {
        isDetailViewVisible: isDetailViewVisible,
        parentWidth: width || 0,
        boardId: boardId,
        cardListIds: cardListIds,
        DetailView: (0, $5A42o.default),
        SubmitApdex: (0, $1UKUc.default),
        isCacheHit: isCacheHit,
        CardList: (0, $ab9TP.default),
        BoardIssueMoveDialog: (0, $h7RbI.default),
        onEpicPanelClose: onEpicPanelClose,
        onVersionPanelClose: onVersionPanelClose,
        issueHierarchyLevel: issueHierarchyLevel
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9HRx0.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b75A0.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZHze.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dFfIn.default), {
        baseUrl: baseUrl,
        boardId: String(boardId)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4MJfo.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $emFUM.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wpyB.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aPfpu.FiltersStorage), null), (shouldShowIssueLimitFlags || !(0, $4R6GH.fg)('conditionally_load_issuelimitflags_in_backlog')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "backlog-issue-limit-flags"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5fQw9.default), {
        boardId: boardId,
        isCMP: isCMPBacklog,
        isProjectAdmin: userCanEditBoardConfig,
        projectKey: projectKey,
        views: issueLimitFlagViews
    })), shouldShowPublicFormsChangeboardingModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJ1Ne.default), {
        projectId: projectId.toString()
    }));
    // Show a message to admin users if the board is inaccessible due to filter permissions and how to update it
    if (shouldShowAdminInaccessibleBoard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ZW09.AsyncAdminInaccessibleBoard), {
        rapidViewId: boardId.toString(),
        skeleton: (0, $i8JTM.NextGenBacklogSkeleton)
    });
    const WrapperComponent = (0, $3HwlS.getWillShowNav4)() ? $083bc8c563c121c0$var$ConstrainedWrapper : $083bc8c563c121c0$var$Wrapper;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "backlog"
    }, isCMPBacklog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gFU0Q.CmpBacklogSlaTracker), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bzlhL.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $acDhY.BulkOpsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrapperComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($083bc8c563c121c0$var$MainContent, null, backlogContainerContent), isBulkOpsAvailable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gz0if.BulkOperationsSidebar), {
        parentWidth: width || 0,
        isOpen: openSidebar,
        bulkOperationsForm: bulkOperationsForm
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2jVnP.BulkOperationsLoader), {
        bulkOperationsForm: bulkOperationsForm,
        onCloseSidebar: onCloseSidebar,
        onOpenSidebar: onOpenSidebar
    })), (0, $8CVvd.getWillShowNav3)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9hLEH.default), {
        boardId: boardId,
        projectKey: projectKey,
        isCMPBoard: isCMPBacklog
    })));
};
const $083bc8c563c121c0$export$2532845c810cfaa1 = /*#__PURE__*/ (0, $5uXOq.memo)($083bc8c563c121c0$var$BacklogComponent);
var // TODO: This is a flaky design. We shouldn't depend on prefetched data being available at certain points.
// As of current if prefetched data is null (which is a valid state), then the issue fields won't be initialized correctly.
// While there is sync. for lots of values, there is not sync for certain required values, such as `HIERARCHY...` fields. On
// that case, switching into the issue fields epic renderers will hide epics.
// In particular, src/packages/issue/fields/parent-switcher/src/controllers/with-sweet-state-parent-switcher/index.tsx
// won't render the field.
// eslint-disable-next-line jira/import/no-anonymous-default-export
$083bc8c563c121c0$export$2e2bcd8739ae039 = ({ prefetchedData: prefetchedData, prefetchedPlanData: prefetchedPlanData, storyPointFieldId: storyPointFieldId, epicIssueType: epicIssueType, ...rest })=>{
    const { storeFieldsFromPrefetchedData: storeFieldsFromPrefetchedData, storeFieldsFromPrefetchedPlanData: storeFieldsFromPrefetchedPlanData } = (0, $10Ngv.useStoreFields)();
    // Initialise extracted fields (Sweet State) using prefetched data (SSR)
    (0, $5uXOq.useEffect)(()=>{
        const fieldConfigs = {
            storyPointFieldId: storyPointFieldId
        };
        if (prefetchedPlanData) storeFieldsFromPrefetchedPlanData(prefetchedPlanData, epicIssueType);
        else if (prefetchedData) storeFieldsFromPrefetchedData(prefetchedData, fieldConfigs);
    }, [
        prefetchedData,
        prefetchedPlanData,
        storeFieldsFromPrefetchedData,
        storeFieldsFromPrefetchedPlanData,
        storyPointFieldId,
        epicIssueType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($083bc8c563c121c0$export$2532845c810cfaa1, rest);
};
const $083bc8c563c121c0$var$ConstrainedWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $083bc8c563c121c0$var$constrainedWrapperStyles
    }, children);
const $083bc8c563c121c0$var$HeightlessContainer = ({ children: children, 'data-testid': testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: (0, $4R6GH.fg)('jira-concurrent-backlog-perf') ? $083bc8c563c121c0$var$heightlessContainerStylesNew : $083bc8c563c121c0$var$heightlessContainerStylesOld,
        testId: testId
    }, children);
const $083bc8c563c121c0$var$PageHeaderWrapper = ({ children: children, 'data-testid': testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: testId,
        xcss: $083bc8c563c121c0$var$pageHeaderWrapperStyle
    }, children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $083bc8c563c121c0$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _12ji1r31 _1qu2glyw _12y31o36 _c71l1i8v _4t3i1i8v _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $083bc8c563c121c0$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $083bc8c563c121c0$var$MainContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zidpf _i0dlf1ug _1reo15vq _18m915vq _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $083bc8c563c121c0$var$SizeDetectorWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _i0dlf1ug _c71l1osq _1e0c1txw _10pb1h90 _6ndb1osq",
            __cmplp.className
        ])
    });
});
const $083bc8c563c121c0$var$pageHeaderWrapperStyle = (0, $8CUq3.xcss)({
    paddingInline: 'space.500'
});
const $083bc8c563c121c0$var$pageHeaderStyles = (0, $8CUq3.xcss)({
    paddingInline: 'space.300'
});
const $083bc8c563c121c0$var$pageHeaderBackgroundStyles = (0, $8CUq3.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    background: (0, $6cG4N.Tokens).ELEVATION_SURFACE_CONTRAST,
    marginBottom: 'space.200',
    position: 'relative',
    '::before': {
        content: '""',
        position: 'absolute',
        height: '100%',
        width: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backdropFilter: (0, $6cG4N.Tokens).BACKDROP_FILTER,
        top: 'space.0',
        left: 'space.0'
    }
});
const $083bc8c563c121c0$var$constrainedWrapperStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    height: '100%',
    overflow: 'hidden'
});
const $083bc8c563c121c0$var$heightlessContainerStylesOld = (0, $8CUq3.xcss)({
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    outline: 'none'
});
const $083bc8c563c121c0$var$heightlessContainerStylesNew = (0, $8CUq3.xcss)({
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    outline: 'none',
    minHeight: '100%'
});

});
parcelRegister("gJlZe", function(module, exports) {

$parcel$export(module.exports, "WidthObserver", () => $f3c667de71b5760d$export$b2ad68b9bc407b80);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jWz2c = parcelRequire("jWz2c");
const $f3c667de71b5760d$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jWz2c.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $f3c667de71b5760d$export$2e2bcd8739ae039 = $f3c667de71b5760d$export$b2ad68b9bc407b80;

});
parcelRegister("jWz2c", function(module, exports) {

$parcel$export(module.exports, "WidthDetectorObserver", () => $76470ef26276f9f4$export$ff983d2a2b6112ea);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1LwQL = parcelRequire("1LwQL");
const $76470ef26276f9f4$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $1LwQL.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});

});
parcelRegister("1LwQL", function(module, exports) {

$parcel$export(module.exports, "useInView", () => $1dfb7d23cdbb03d0$export$2f62ee6831462844);

var $5uXOq = parcelRequire("5uXOq");
function $1dfb7d23cdbb03d0$export$2f62ee6831462844(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
	 * Unsubscribe IntersectionObserver before unmounting a component.
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}

});



parcelRegister("5ZW09", function(module, exports) {

$parcel$export(module.exports, "AsyncAdminInaccessibleBoard", () => $bcf1c6c59cc68dbc$export$516550003e785216);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $bcf1c6c59cc68dbc$var$AdminInaccessibleBoard = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("gDwkl")), {
    ssr: false,
    moduleId: "./src/packages/software/admin-inaccessible-board/src/ui/main.tsx"
});
const $bcf1c6c59cc68dbc$export$516550003e785216 = (props)=>{
    const Skeleton = props.skeleton;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        packageName: "jiraAdminInaccessibleBoard",
        id: "async-admin-inaccessible-board",
        sendToPrivacyUnsafeSplunk: true,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "admin-inaccessible-board",
        fallback: Skeleton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Skeleton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bcf1c6c59cc68dbc$var$AdminInaccessibleBoard, props)));
};

});
parcelRegister("gDwkl", function(module, exports) {

let $c1c95d6168a4dd52$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c1c95d6168a4dd52$var$load("3fI2Z").then(()=>parcelRequire('2Bz5k'));

});


parcelRegister("hP2lu", function(module, exports) {

$parcel$export(module.exports, "useShouldShowAdminInaccessibleBoard", () => $7a289048e0431de9$export$1a15223f3cf409b4);

var $3vXOY = parcelRequire("3vXOY");

var $itmJb = parcelRequire("itmJb");

var $2YP9W = parcelRequire("2YP9W");
const $7a289048e0431de9$export$1a15223f3cf409b4 = (resource)=>{
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const data = (0, $2YP9W.useResource)(resource);
    const statusCode = data.error ? (0, $3vXOY.extractStatusCode)(data.error) : null;
    return isAdmin && statusCode === 404;
};

});

parcelRegister("acDhY", function(module, exports) {

$parcel$export(module.exports, "useBulkOpsEntryPoint", () => $9114dbe32a67b4e4$export$f263bc273a3aa10f);
$parcel$export(module.exports, "BulkOpsWrapper", () => $9114dbe32a67b4e4$export$e2a60475ecfbe3cf);

var $5uXOq = parcelRequire("5uXOq");

var $iAbh9 = parcelRequire("iAbh9");

var $4mO32 = parcelRequire("4mO32");

var $l37qh = parcelRequire("l37qh");

var $fvbIR = parcelRequire("fvbIR");
const $9114dbe32a67b4e4$var$BulkOpsCoreEntryPointContext = (0, $l37qh.createUseEntryPointContext)();
const $9114dbe32a67b4e4$var$emptyObject = {};
const $9114dbe32a67b4e4$var$BulkOpsCoreEntryPointProvider = ({ children: children })=>{
    const entryPointResult = (0, $4mO32.useEntryPoint)((0, $fvbIR.asyncBulkOpsCoreEntryPoint), $9114dbe32a67b4e4$var$emptyObject);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9114dbe32a67b4e4$var$BulkOpsCoreEntryPointContext.Provider, {
        value: entryPointResult
    }, children);
};
const $9114dbe32a67b4e4$export$f263bc273a3aa10f = ()=>(0, $5uXOq.useContext)($9114dbe32a67b4e4$var$BulkOpsCoreEntryPointContext);
const $9114dbe32a67b4e4$export$e2a60475ecfbe3cf = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iAbh9.BulkOpsAnalyticsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9114dbe32a67b4e4$var$BulkOpsCoreEntryPointProvider, null, children));

});
parcelRegister("iAbh9", function(module, exports) {

$parcel$export(module.exports, "BulkOpsAnalyticsProvider", () => $477c8df705ed825f$export$8ab440f197429d1e);
$parcel$export(module.exports, "useBulkOpsSessionContext", () => $477c8df705ed825f$export$95271787b6ae4d3c);

var $5uXOq = parcelRequire("5uXOq");

var $iXVV6 = parcelRequire("iXVV6");

var $8p26c = parcelRequire("8p26c");
const $477c8df705ed825f$var$BulkOpsAnalyticsContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $477c8df705ed825f$export$8ab440f197429d1e = (props)=>{
    const [bulkOpsFlow] = (0, $5uXOq.useState)(new (0, $8p26c.DefaultBulkOpsFlow)());
    const [bulkOpsSessionID, setBulkOpsSessionID] = (0, $5uXOq.useState)(bulkOpsFlow?.getFlowAttributes().bulkOpsSessionID || undefined);
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = bulkOpsFlow?.registerAnalyticsEventPublisher((sessionId)=>{
            setBulkOpsSessionID(sessionId);
        });
        return ()=>{
            unsubscribe?.();
        };
    }, [
        bulkOpsFlow
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($477c8df705ed825f$var$BulkOpsAnalyticsContext.Provider, {
        value: bulkOpsFlow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            bulkOpsSessionID: bulkOpsSessionID
        }
    }, props.children));
};
const $477c8df705ed825f$export$95271787b6ae4d3c = ()=>(0, $5uXOq.useContext)($477c8df705ed825f$var$BulkOpsAnalyticsContext);

});
parcelRegister("8p26c", function(module, exports) {

$parcel$export(module.exports, "DefaultBulkOpsFlow", () => $66219c4f12f760b8$export$74bf75c57acfbb74);

var $7Jxgt = parcelRequire("7Jxgt");
class $66219c4f12f760b8$export$74bf75c57acfbb74 {
    isInFlow() {
        return this.bulkOpsSessionID !== undefined;
    }
    get sessionID() {
        return this.bulkOpsSessionID;
    }
    get bulkActionsCompleted() {
        return this.numBulkActionsCompleted;
    }
    get bulkOperationType() {
        return this.bulkOperationTypeValue;
    }
    notifyAnalyticsEventPublishers(sessionID) {
        let index = 0;
        this.analyticsEventPublishers.forEach((listener)=>{
            listener(sessionID, index);
            index += 1;
        });
        this.analyticsEventPublishers.clear();
    }
    start(_attributes) {
        if (this.isInFlow()) return;
        this.bulkOpsSessionID = (0, $7Jxgt.v4)();
        this.notifyAnalyticsEventPublishers(this.bulkOpsSessionID);
    }
    end(_attributes) {
        this.bulkOpsSessionID = undefined;
        this.numBulkActionsCompleted = 0;
    }
    executeAction() {
        if (!this.isInFlow()) this.start();
        this.numBulkActionsCompleted += 1;
    }
    setBulkOperationType(bulkOperationType) {
        this.bulkOperationTypeValue = bulkOperationType;
    }
    getFlowAttributes() {
        if (this.bulkOpsSessionID && this.numBulkActionsCompleted !== 0) return {
            bulkOpsSessionID: this.bulkOpsSessionID,
            numBulkActionsCompleted: this.numBulkActionsCompleted
        };
        return this.bulkOpsSessionID ? {
            bulkOpsSessionID: this.bulkOpsSessionID
        } : {};
    }
    registerAnalyticsEventPublisher(analyticsEventPublisher) {
        this.analyticsEventPublishers.add(analyticsEventPublisher);
        return ()=>{
            this.analyticsEventPublishers.delete(analyticsEventPublisher);
        };
    }
    constructor(){
        this.numBulkActionsCompleted = 0;
        this.analyticsEventPublishers = new Set();
    }
}

});


parcelRegister("fvbIR", function(module, exports) {

$parcel$export(module.exports, "asyncBulkOpsCoreEntryPoint", () => $187b82d9aad4ec6a$export$d90d57132636bb1);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $187b82d9aad4ec6a$export$d90d57132636bb1 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("cliXS")), {
        moduleId: "f81933b6"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("cliXS", function(module, exports) {

let $8fc628381702f5c0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8fc628381702f5c0$var$load("3bwa5").then(()=>parcelRequire('k9wdm'));

});



parcelRegister("5vJHu", function(module, exports) {

$parcel$export(module.exports, "useReferenceLoader", () => $6eeb97186bbafb10$export$727d936bc4a88f4e);

var $5uXOq = parcelRequire("5uXOq");
const $6eeb97186bbafb10$export$727d936bc4a88f4e = ()=>{
    const [ref, setRef] = (0, $5uXOq.useState)(null);
    return (0, $5uXOq.useMemo)(()=>({
            setRef: setRef,
            ref: ref
        }), [
        setRef,
        ref
    ]);
};

});

parcelRegister("7wqBZ", function(module, exports) {

$parcel$export(module.exports, "getLongTasksMetrics", () => $f85af650a825558e$export$b092a8653a66aa5e);

var $gJBT6 = parcelRequire("gJBT6");

var $x9xyg = parcelRequire("x9xyg");

var $6RCeq = parcelRequire("6RCeq");

var $cJpFl = parcelRequire("cJpFl");
let $f85af650a825558e$var$observer = null;
const $f85af650a825558e$var$stopObserver = ()=>{
    if ($f85af650a825558e$var$observer) {
        $f85af650a825558e$var$observer.disconnect();
        $f85af650a825558e$var$observer = null;
    }
};
const $f85af650a825558e$export$b092a8653a66aa5e = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((type)=>{
    const clearData = {
        type: type
    };
    let isStarted = false;
    let observationData = {
        ...clearData
    };
    const isDnd = /dnd$/.test(type.toLowerCase());
    return {
        start: (appName, startPerformanceMark, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        extra = {})=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            if (window.PerformanceObserver && !isStarted) try {
                const startTimestamp = (0, $6RCeq.default).now();
                observationData = {
                    type: observationData.type,
                    startTimestamp: startTimestamp,
                    dragStartEndTimestamp: startTimestamp,
                    eventStartPerformanceMark: startPerformanceMark,
                    events: [],
                    appName: appName,
                    extra: extra
                };
                isStarted = true;
                $f85af650a825558e$var$stopObserver();
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                $f85af650a825558e$var$observer = new window.PerformanceObserver((list)=>{
                    list.getEntries().forEach((entry)=>{
                        if (entry.entryType === 'longtask') {
                            if (!(0, $cJpFl.isExpandedObservationData)(observationData) || observationData.events.find((item)=>item.timestamp === entry.startTime && item.duration === entry.duration)) return;
                            observationData.events.push({
                                timestamp: entry.startTime,
                                duration: entry.duration
                            });
                        } else if (entry.entryType === 'event' && entry.name === 'dragstart') /**
								 * Use the observed event to compute the "end" timestamp of the dragstart event,
								 * which will be used for splitting the long tasks for dragstart and dragmove.
								 */ observationData.dragStartEndTimestamp = entry.startTime + entry.duration;
                    });
                });
                $f85af650a825558e$var$observer.observe({
                    type: 'longtask'
                });
                if (isDnd) /**
						 * Observe events with >48ms duration.
						 * https://developer.mozilla.org/en-US/docs/Web/API/PerformanceObserver/observe
						 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                $f85af650a825558e$var$observer.observe({
                    type: 'event',
                    durationThreshold: 48
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-empty
            } catch (e) {}
        },
        stop: (callback, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        extra = {})=>{
            if ((0, $6RCeq.default).now && isStarted) {
                const stopTimestamp = (0, $6RCeq.default).now();
                setTimeout(()=>{
                    $f85af650a825558e$var$stopObserver();
                    callback({
                        ...observationData
                    }, extra, stopTimestamp);
                    observationData = {
                        ...clearData
                    };
                    isStarted = false;
                });
            }
        },
        stopIfNoMark: (performanceMark)=>{
            if ($f85af650a825558e$var$observer && performanceMark) {
                const perfMark = (0, $x9xyg.getMark)(performanceMark);
                if (!perfMark) {
                    $f85af650a825558e$var$stopObserver();
                    observationData = {
                        ...clearData
                    };
                    isStarted = false;
                }
            }
        }
    };
});

});
parcelRegister("cJpFl", function(module, exports) {

$parcel$export(module.exports, "isExpandedObservationData", () => $3e1de7ace69512d1$export$3d38a87309e205a4);
const $3e1de7ace69512d1$export$3d38a87309e205a4 = (observationData)=>observationData !== undefined && 'events' in observationData && observationData.events !== undefined;

});


parcelRegister("dhsbO", function(module, exports) {

$parcel$export(module.exports, "filterReporter", () => $f7989144fec0a9cf$export$facf842185aa645c);

var $k12ix = parcelRequire("k12ix");

var $cJpFl = parcelRequire("cJpFl");

var $if7bx = parcelRequire("if7bx");
const $f7989144fec0a9cf$export$facf842185aa645c = (observationData, // eslint-disable-next-line @typescript-eslint/no-explicit-any
featureFlags = {})=>{
    if ((0, $cJpFl.isExpandedObservationData)(observationData)) {
        const triggerSoftwareAnalytics = (0, $if7bx.triggerAnalytics)(`software.${observationData.appName}`);
        const startTime = observationData.events.map((event)=>event.timestamp);
        const analyticsData = {
            ...(0, $if7bx.generateLongTaskAnalyticsSummary)('filter', observationData.events),
            measureTimespan: performance.now() - Math.min(observationData.startTimestamp, ...startTime),
            ...featureFlags,
            performanceFFs: (0, $k12ix.getPerformanceFFsString)()
        };
        triggerSoftwareAnalytics('long-tasks-filter', analyticsData);
        try {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            performance.measure('filterBarResponsiveness', 'filterBarStart', 'filterBarStop');
            triggerSoftwareAnalytics('performance-filter-bar', // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            performance.getEntriesByName('filterBarResponsiveness')[0]);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
        // do nothing
        }
        try {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            performance.measure('oldFilterBarResponsiveness', 'oldFilterBarStart', 'oldFilterBarStop');
            triggerSoftwareAnalytics('performance-old-filter-bar', // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            performance.getEntriesByName('oldFilterBarResponsiveness')[0]);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
        // do nothing
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        performance.clearMeasures();
    }
};

});
parcelRegister("if7bx", function(module, exports) {

$parcel$export(module.exports, "triggerAnalytics", () => $3a39af364070fc96$export$2c57de8a70f64057);
$parcel$export(module.exports, "generateLongTaskAnalyticsSummary", () => $3a39af364070fc96$export$2be2635781d23aab);
$parcel$export(module.exports, "generateLongTaskAnalyticsSummaryWithSlo", () => $3a39af364070fc96$export$c674a20081e82c6a);
$parcel$export(module.exports, "getAverageResultsFromContinuousActions", () => $3a39af364070fc96$export$c36fdc326d0c207c);
$parcel$export(module.exports, "generateLongTaskAnalyticsContinuousActionSummary", () => $3a39af364070fc96$export$7e5f2df95eca342a);

var $gZFbt = parcelRequire("gZFbt");

var $iThRn = parcelRequire("iThRn");

var $6oxJH = parcelRequire("6oxJH");
const $3a39af364070fc96$export$2c57de8a70f64057 = (_appName)=>(_eventNameSuffix, _eventData)=>Promise.resolve(undefined);
const $3a39af364070fc96$export$2be2635781d23aab = (prefix, longTasks)=>{
    const durations = longTasks.map((task)=>task.duration);
    return {
        [`${prefix}LongTaskCount`]: longTasks.length,
        [`${prefix}LongTaskAvg`]: longTasks.length > 0 ? durations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / longTasks.length : 0,
        [`${prefix}LongTaskMax`]: longTasks.length > 0 ? Math.max(...durations) : 0
    };
};
const $3a39af364070fc96$export$c674a20081e82c6a = (prefix, longTasks, sloSettings)=>{
    const summary = $3a39af364070fc96$export$2be2635781d23aab(prefix, longTasks);
    if (!sloSettings) return summary;
    const framerate = summary[`${prefix}LongTaskCount`] === 0 ? 20 : 1000 / summary[`${prefix}LongTaskAvg`];
    const blocktime = summary[`${prefix}LongTaskCount`] === 0 ? 0 : summary[`${prefix}LongTaskCount`] * summary[`${prefix}LongTaskAvg`];
    const isSuccess = framerate >= sloSettings.framerateThreshold && blocktime < sloSettings.blocktimeThreshold;
    return {
        [`${prefix}LongTaskSloIsSuccess`]: isSuccess,
        ...summary
    };
};
const $3a39af364070fc96$export$c36fdc326d0c207c = (prefix, data)=>{
    // Do NOT inline this variable into its usage site below - it is here to mitigate an Atlaspack bug: https://product-fabric.atlassian.net/browse/AFB-1057 & https://atlassian.slack.com/archives/C0288U06PGC/p1736811949973719
    const avgLongTaskCountSum = (0, (/*@__PURE__*/$parcel$interopDefault($6oxJH)))(data, `${prefix}ClusterAvgLongTaskCount`);
    return {
        [`${prefix}ClusterCount`]: (0, (/*@__PURE__*/$parcel$interopDefault($6oxJH)))(data, `${prefix}ClusterCount`) || 0,
        [`${prefix}ClusterCountAvg`]: (0, (/*@__PURE__*/$parcel$interopDefault($gZFbt)))(data, `${prefix}ClusterCount`) || 0,
        [`${prefix}ClusterAvg`]: (0, (/*@__PURE__*/$parcel$interopDefault($gZFbt)))(data, `${prefix}ClusterAvg`) || 0,
        [`${prefix}ClusterDistanceAvg`]: (0, (/*@__PURE__*/$parcel$interopDefault($gZFbt)))(data, `${prefix}ClusterDistanceAvg`) || 0,
        [`${prefix}ClusterAvgLongTaskCount`]: (0, (/*@__PURE__*/$parcel$interopDefault($gZFbt)))(data, `${prefix}ClusterAvgLongTaskCount`) || 0,
        [`${prefix}ClusterAvgLongTaskAvg`]: data.length > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($iThRn)))(data.map((entry)=>entry[`${prefix}ClusterAvgLongTaskCount`] * entry[`${prefix}ClusterAvgLongTaskAvg`])) / avgLongTaskCountSum : 0,
        [`${prefix}Count`]: data.length
    };
};
const $3a39af364070fc96$export$7e5f2df95eca342a = (prefix, longTasks)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const clusters = longTasks.reduce((foundClusters, task)=>{
        if (foundClusters.length === 0) foundClusters.push({
            tasks: [],
            start: 0,
            stop: 0
        });
        const prevCluster = foundClusters[foundClusters.length - 1];
        const taskEnd = task.timestamp + task.duration;
        if (prevCluster.tasks.length === 0) {
            prevCluster.tasks.push(task);
            prevCluster.start = task.timestamp;
            prevCluster.stop = taskEnd;
        } else if (task.timestamp - prevCluster.stop < 100) {
            prevCluster.tasks.push(task);
            prevCluster.stop = taskEnd;
        } else foundClusters.push({
            tasks: [
                task
            ],
            start: task.timestamp,
            stop: taskEnd
        });
        return foundClusters;
    }, []);
    const clusterDurations = clusters.map((cluster)=>cluster.stop - cluster.start);
    const tasksDurations = longTasks.map((task)=>task.duration);
    const gapsBetweenClusters = clusters.length > 1 ? clusters // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((gaps, cluster, i)=>{
        if (gaps.length === 0) {
            gaps.push({
                start: cluster.stop,
                stop: null
            });
            return gaps;
        }
        // eslint-disable-next-line no-param-reassign
        gaps[gaps.length - 1].stop = cluster.start;
        if (i !== clusters.length - 1) gaps.push({
            start: cluster.stop,
            stop: null
        });
        return gaps;
    }, []).map((gap)=>gap.stop - gap.start) : [];
    return {
        [`${prefix}ClusterCount`]: clusters.length,
        [`${prefix}ClusterAvg`]: clusters.length > 0 ? clusterDurations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / clusters.length : 0,
        [`${prefix}ClusterDistanceAvg`]: gapsBetweenClusters.length > 0 ? gapsBetweenClusters.reduce((sumAcc, duration)=>sumAcc + duration, 0) / gapsBetweenClusters.length : 0,
        [`${prefix}ClusterAvgLongTaskCount`]: clusters.length > 0 ? clusters.map((cluster)=>cluster.tasks.length).reduce((sumAcc, count)=>sumAcc + count, 0) / clusters.length : 0,
        [`${prefix}ClusterAvgLongTaskAvg`]: longTasks.length > 0 ? tasksDurations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / longTasks.length : 0
    };
};

});
parcelRegister("gZFbt", function(module, exports) {

var $bxDef = parcelRequire("bxDef");

var $520Yb = parcelRequire("520Yb");
/**
 * This method is like `_.mean` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be averaged.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the mean.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.meanBy(objects, function(o) { return o.n; });
 * // => 5
 *
 * // The `_.property` iteratee shorthand.
 * _.meanBy(objects, 'n');
 * // => 5
 */ function $c5f24a2590a3cbef$var$meanBy(array, iteratee) {
    return $520Yb(array, $bxDef(iteratee, 2));
}
module.exports = $c5f24a2590a3cbef$var$meanBy;

});
parcelRegister("520Yb", function(module, exports) {

var $gBzAF = parcelRequire("gBzAF");
/** Used as references for various `Number` constants. */ var $3a9de433504d679a$var$NAN = 0 / 0;
/**
 * The base implementation of `_.mean` and `_.meanBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the mean.
 */ function $3a9de433504d679a$var$baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? $gBzAF(array, iteratee) / length : $3a9de433504d679a$var$NAN;
}
module.exports = $3a9de433504d679a$var$baseMean;

});


parcelRegister("6oxJH", function(module, exports) {

var $bxDef = parcelRequire("bxDef");

var $gBzAF = parcelRequire("gBzAF");
/**
 * This method is like `_.sum` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be summed.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the sum.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.sumBy(objects, function(o) { return o.n; });
 * // => 20
 *
 * // The `_.property` iteratee shorthand.
 * _.sumBy(objects, 'n');
 * // => 20
 */ function $4a7f273a61dd10a7$var$sumBy(array, iteratee) {
    return array && array.length ? $gBzAF(array, $bxDef(iteratee, 2)) : 0;
}
module.exports = $4a7f273a61dd10a7$var$sumBy;

});



parcelRegister("2Z6La", function(module, exports) {

$parcel$export(module.exports, "IccContext", () => $093fa356b2a966b6$export$2f62d2dfd027123d);
$parcel$export(module.exports, "useIccContext", () => $093fa356b2a966b6$export$f7b8d088c9ea045e);
$parcel$export(module.exports, "IccProvider", () => $093fa356b2a966b6$export$4a7497397d7465fc);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");
const $093fa356b2a966b6$var$defaultValue = {
    initialSummary: '',
    initialCardTypeId: null,
    initialFieldValues: new Map(),
    initialProjectId: null,
    onChangeSummary: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onChangeCardType: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onChangeFieldValue: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onChangeProject: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onCreate: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
const $093fa356b2a966b6$export$2f62d2dfd027123d = /*#__PURE__*/ (0, $5uXOq.createContext)($093fa356b2a966b6$var$defaultValue);
const $093fa356b2a966b6$export$f7b8d088c9ea045e = ()=>(0, $5uXOq.useContext)($093fa356b2a966b6$export$2f62d2dfd027123d);
const $093fa356b2a966b6$export$4a7497397d7465fc = ({ children: children })=>{
    const [initialSummary, setInitialSummary] = (0, $5uXOq.useState)($093fa356b2a966b6$var$defaultValue.initialSummary);
    const [initialCardTypeId, setInitialCardTypeId] = (0, $5uXOq.useState)($093fa356b2a966b6$var$defaultValue.initialCardTypeId);
    const [initialFieldValues, setInitialFieldValues] = (0, $5uXOq.useState)($093fa356b2a966b6$var$defaultValue.initialFieldValues);
    const [initialProjectId, setInitialProjectId] = (0, $5uXOq.useState)($093fa356b2a966b6$var$defaultValue.initialProjectId);
    const onChangeSummary = (0, $5uXOq.useCallback)((summary)=>{
        setInitialSummary(summary);
    }, []);
    const onChangeProject = (0, $5uXOq.useCallback)((projectId)=>{
        setInitialProjectId(projectId);
    }, []);
    const onChangeCardType = (0, $5uXOq.useCallback)((cardTypeId)=>{
        setInitialCardTypeId(cardTypeId);
    }, []);
    const onChangeFieldValue = (0, $5uXOq.useCallback)((fieldKey, fieldValue)=>{
        setInitialFieldValues((prevFieldValues)=>{
            const updatedFieldValues = new Map(prevFieldValues);
            updatedFieldValues.set(fieldKey, fieldValue);
            return updatedFieldValues;
        });
    }, []);
    const onCancel = (0, $5uXOq.useCallback)(()=>{
        setInitialSummary('');
        setInitialCardTypeId(null);
    }, []);
    const onCreate = (0, $5uXOq.useCallback)(()=>{
        setInitialSummary('');
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($093fa356b2a966b6$export$2f62d2dfd027123d.Provider, {
        value: {
            initialSummary: initialSummary,
            initialCardTypeId: initialCardTypeId,
            initialFieldValues: initialFieldValues,
            initialProjectId: initialProjectId,
            onChangeCardType: onChangeCardType,
            onChangeSummary: onChangeSummary,
            onChangeFieldValue: onChangeFieldValue,
            onChangeProject: onChangeProject,
            onCancel: onCancel,
            onCreate: onCreate
        }
    }, children);
};

});

parcelRegister("5NBkv", function(module, exports) {

$parcel$export(module.exports, "default", () => $339fc654e2f8db18$export$2e2bcd8739ae039);
$parcel$export(module.exports, "usePreloadEpicPanel", () => $339fc654e2f8db18$export$20a94fa49c784cd5);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $4R6GH = parcelRequire("4R6GH");

var $3aqXA = parcelRequire("3aqXA");

var $5ZVKE = parcelRequire("5ZVKE");

var $5dA0t = parcelRequire("5dA0t");

const $339fc654e2f8db18$export$f69665587e333870 = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("5HVbu")), {
    ssr: false,
    moduleId: "./src/packages/software/backlog-panel/src/ui/epic/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$339fc654e2f8db18$export$2e2bcd8739ae039 = (props)=>{
    const { fireErrorBoundaryExperienceFail: fireErrorBoundaryExperienceFail } = (0, $3aqXA.useViewEpicPanelExperienceTracker)({
        isClassic: props.isCompanyManaged || false
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "async.jira.backlog.panel",
        packageName: "jiraSoftwareBacklogPanel",
        fallback: "flag",
        teamName: "a4t-pandora",
        onError: fireErrorBoundaryExperienceFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "backlog-panel-boundary",
        fallback: (0, $4R6GH.fg)('prefetch-epics-data-backlog') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5dA0t.LoadingSkeleton), {
            canCreate: props.canCreate,
            hierarchyName: props.hierarchyName
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($339fc654e2f8db18$export$f69665587e333870, props)));
};
const $339fc654e2f8db18$export$20a94fa49c784cd5 = (isEpicPanelOpen, boardId, isCompanyManaged)=>{
    const isPreloaded = (0, $5uXOq.useRef)(false);
    const [getEpicDetails] = (0, $5ZVKE.useEpicDetailsQueryLazy)({
        boardId: boardId,
        isCompanyManaged: isCompanyManaged
    });
    (0, $5uXOq.useEffect)(()=>{
        if (isEpicPanelOpen && isPreloaded && !isPreloaded.current) {
            $339fc654e2f8db18$export$f69665587e333870.preload();
            isPreloaded.current = true;
            if (!(0, $4R6GH.fg)('prefetch-epics-data-backlog')) getEpicDetails();
        }
    }, [
        getEpicDetails,
        isEpicPanelOpen
    ]);
    return null;
};

});
parcelRegister("3aqXA", function(module, exports) {

$parcel$export(module.exports, "useViewEpicPanelExperienceTracker", () => $76790e6e87ec47c2$export$c1017fffc722d968);
$parcel$export(module.exports, "useInlineIssueCreateEpicPanelExperienceTracker", () => $76790e6e87ec47c2$export$7ab965f5d69be412);
$parcel$export(module.exports, "useGlobalIssueCreateEpicPanelExperienceTracker", () => $76790e6e87ec47c2$export$dff71c2c64b5caea);
$parcel$export(module.exports, "useAssignEpicPanelExperienceTracker", () => $76790e6e87ec47c2$export$98afccaa5b17be1);
$parcel$export(module.exports, "useUnassignEpicPanelExperienceTracker", () => $76790e6e87ec47c2$export$51f7a79bb0e6c44e);
$parcel$export(module.exports, "useRankExperienceTracker", () => $76790e6e87ec47c2$export$8942fc10da43a00a);

var $a6ebl = parcelRequire("a6ebl");

var $dZggJ = parcelRequire("dZggJ");
const $76790e6e87ec47c2$export$c1017fffc722d968 = (attributes = {})=>(0, $a6ebl.useExperienceTracker)((0, $dZggJ.APP_ID), (0, $dZggJ.EPIC_PANEL_VIEW_EXPERIENCE), (0, $dZggJ.EXPERIENCE_TRACKER_PROVIDER_SOURCE), attributes);
const $76790e6e87ec47c2$export$7ab965f5d69be412 = (attributes = {})=>(0, $a6ebl.useExperienceTracker)((0, $dZggJ.APP_ID), (0, $dZggJ.EPIC_PANEL_INLINE_ISSUE_CREATE_EXPERIENCE), (0, $dZggJ.EXPERIENCE_TRACKER_PROVIDER_SOURCE), attributes);
const $76790e6e87ec47c2$export$dff71c2c64b5caea = (attributes = {})=>(0, $a6ebl.useExperienceTracker)((0, $dZggJ.APP_ID), (0, $dZggJ.EPIC_PANEL_GLOBAL_ISSUE_CREATE_EXPERIENCE), (0, $dZggJ.EXPERIENCE_TRACKER_PROVIDER_SOURCE), attributes);
const $76790e6e87ec47c2$export$98afccaa5b17be1 = (attributes = {})=>(0, $a6ebl.useExperienceTracker)((0, $dZggJ.APP_ID), (0, $dZggJ.EPIC_PANEL_ASSIGN_EXPERIENCE), (0, $dZggJ.EXPERIENCE_TRACKER_PROVIDER_SOURCE), attributes);
const $76790e6e87ec47c2$export$51f7a79bb0e6c44e = (attributes = {})=>(0, $a6ebl.useExperienceTracker)((0, $dZggJ.APP_ID), (0, $dZggJ.EPIC_PANEL_UNASSIGN_EXPERIENCE), (0, $dZggJ.EXPERIENCE_TRACKER_PROVIDER_SOURCE), attributes);
const $76790e6e87ec47c2$export$8942fc10da43a00a = (attributes = {})=>(0, $a6ebl.useExperienceTracker)((0, $dZggJ.APP_ID), (0, $dZggJ.EPIC_PANEL_RANK_EXPERIENCE), (0, $dZggJ.EXPERIENCE_TRACKER_PROVIDER_SOURCE), attributes);

});
parcelRegister("a6ebl", function(module, exports) {

$parcel$export(module.exports, "useExperienceTracker", () => $ff81be28c31601ee$export$cdefb2a8b53f879f);

var $5uXOq = parcelRequire("5uXOq");

var $8dXDG = parcelRequire("8dXDG");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $efvDm = parcelRequire("efvDm");

var $9OXo1 = parcelRequire("9OXo1");


var $gk7Z3 = parcelRequire("gk7Z3");
const $ff81be28c31601ee$export$cdefb2a8b53f879f = (experienceId, experience, analyticsSource, attributes = {})=>{
    const { appEditions: appEditions } = (0, $9OXo1.useTenantContext)();
    const fireExperienceStart = (0, $kaHBi.useExperienceStart)({
        experienceId: experienceId,
        experience: experience,
        analyticsSource: analyticsSource,
        edition: appEditions.software,
        application: (0, $efvDm.JIRA_SOFTWARE)
    });
    const commonAttributes = (0, $5uXOq.useMemo)(()=>(0, $gk7Z3.createCommonAttributes)(attributes), [
        attributes
    ]);
    const fireExperienceSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: experience,
        attributes: commonAttributes
    });
    const fireExperienceFail = (0, $93jKl.useExperienceFail)({
        experience: experience,
        attributes: commonAttributes
    });
    const fireExperienceAbort = (0, $8dXDG.useExperienceAbort)({
        experience: experience,
        attributes: commonAttributes
    });
    const fireExperienceError = (0, $5uXOq.useCallback)((error, errorAttributes = {})=>{
        if ((0, $gk7Z3.isSloFailure)(error)) fireExperienceFail(experienceId, error, {
            ...(0, $gk7Z3.getErrorAttributes)(error),
            ...errorAttributes
        });
        else fireExperienceAbort((0, $463a875e77767855$export$e6589edd1f8a04af), {
            ...(0, $gk7Z3.getErrorAttributes)(error),
            ...errorAttributes
        });
    }, [
        experienceId,
        fireExperienceAbort,
        fireExperienceFail
    ]);
    const fireErrorBoundaryExperienceFail = (0, $5uXOq.useCallback)((location, error, errorAttributes = {})=>{
        fireExperienceFail(location || experienceId, error, {
            ...(0, $gk7Z3.getErrorAttributes)(error),
            ...errorAttributes
        });
    }, [
        experienceId,
        fireExperienceFail
    ]);
    return {
        fireExperienceStart: fireExperienceStart,
        fireExperienceSuccess: fireExperienceSuccess,
        fireExperienceError: fireExperienceError,
        fireExperienceFail: fireExperienceFail,
        fireExperienceAbort: fireExperienceAbort,
        fireErrorBoundaryExperienceFail: fireErrorBoundaryExperienceFail
    };
};

});
const $463a875e77767855$export$ba068cc3610b559d = 'NOT_PRESENT';
const $463a875e77767855$export$78244dbb77cfa6b6 = 'unknown';
const $463a875e77767855$export$d441f436c87942f5 = '1xx';
const $463a875e77767855$export$b29a3bb66f63d888 = '3xx';
const $463a875e77767855$export$16e7f409a0d3529f = '4xx';
const $463a875e77767855$export$549a32621a554e7c = '5xx';
const $463a875e77767855$export$e6589edd1f8a04af = 'Aborting due to non SLO failures';

parcelRegister("gk7Z3", function(module, exports) {

$parcel$export(module.exports, "extractStatusCode", () => $b10dba156c9c5dc5$export$1fdf7c1c0741a7e7);
$parcel$export(module.exports, "getErrorAttributes", () => $b10dba156c9c5dc5$export$6ad9e7706a4ee0f8);
$parcel$export(module.exports, "isHttpClientErrorResponse", () => $b10dba156c9c5dc5$export$2b62e563f0fadcee);
$parcel$export(module.exports, "isSloFailure", () => $b10dba156c9c5dc5$export$2ab75c18c9535885);
$parcel$export(module.exports, "isHttpConflictRequestResponse", () => $b10dba156c9c5dc5$export$35ef4ce2961027c7);
$parcel$export(module.exports, "createCommonAttributes", () => $b10dba156c9c5dc5$export$7916ec13418094a3);

var $9XE6b = parcelRequire("9XE6b");

var $fZneA = parcelRequire("fZneA");

var $68LWC = parcelRequire("68LWC");

const $b10dba156c9c5dc5$var$extractGraphQLExtensionErrorName = (error)=>{
    const graphqlErrorExtensions = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'extensions'
    ], null);
    const errorType = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(graphqlErrorExtensions, [
        'errorType'
    ]);
    if (errorType) return errorType;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(graphqlErrorExtensions, [
        'operationName'
    ]);
};
const $b10dba156c9c5dc5$var$extractErrorName = (error)=>{
    const networkError = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'networkError'
    ]);
    if (networkError) return (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(networkError, [
        'name'
    ], (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'name'
    ], (0, $463a875e77767855$export$ba068cc3610b559d)));
    const graphQLErrors = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'graphQLErrors'
    ], []);
    if (graphQLErrors && graphQLErrors.length > 0) {
        const graphqlErrorExtensionsName = $b10dba156c9c5dc5$var$extractGraphQLExtensionErrorName((0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(graphQLErrors, [
            0
        ]));
        if (graphqlErrorExtensionsName) return graphqlErrorExtensionsName;
    }
    const graphqlErrorExtensionsName = $b10dba156c9c5dc5$var$extractGraphQLExtensionErrorName(error);
    if (graphqlErrorExtensionsName) return graphqlErrorExtensionsName;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'name'
    ], (0, $463a875e77767855$export$ba068cc3610b559d));
};
const $b10dba156c9c5dc5$export$1fdf7c1c0741a7e7 = (error)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'networkError',
        'statusCode'
    ]) || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'graphQLErrors',
        0,
        'extensions',
        'statusCode'
    ]) || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'extensions',
        'statusCode'
    ]) || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'extensions',
        'status'
    ]) || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'statusCode'
    ]) || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'status'
    ]) || (0, $463a875e77767855$export$ba068cc3610b559d);
const $b10dba156c9c5dc5$export$f3626cbbcad37421 = (error)=>{
    const statusCode = Number($b10dba156c9c5dc5$export$1fdf7c1c0741a7e7(error));
    if (!statusCode) return 0, $463a875e77767855$export$ba068cc3610b559d;
    if (statusCode >= 100 && statusCode < 200) return 0, $463a875e77767855$export$d441f436c87942f5;
    if (statusCode >= 300 && statusCode < 400) return 0, $463a875e77767855$export$b29a3bb66f63d888;
    if (statusCode >= 400 && statusCode < 500) return 0, $463a875e77767855$export$16e7f409a0d3529f;
    if (statusCode >= 500 && statusCode < 600) return 0, $463a875e77767855$export$549a32621a554e7c;
    return 0, $463a875e77767855$export$78244dbb77cfa6b6;
};
const $b10dba156c9c5dc5$var$extractTraceId = (error)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'traceId'
    ]) || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'extensions',
        'traceId'
    ]) || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'extensions',
        'request_id'
    ], (0, $463a875e77767855$export$ba068cc3610b559d)) || (0, $463a875e77767855$export$ba068cc3610b559d);
const $b10dba156c9c5dc5$var$extractErrorMessage = (error)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'message'
    ]) || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'extensions',
        'message'
    ]) || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'extensions',
        'userMessage'
    ], (0, $463a875e77767855$export$ba068cc3610b559d));
const $b10dba156c9c5dc5$var$extractErrorStack = (error)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'stack'
    ], (0, $463a875e77767855$export$ba068cc3610b559d));
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $b10dba156c9c5dc5$var$getBuildKey = ()=>window.BUILD_KEY || (0, $463a875e77767855$export$ba068cc3610b559d);
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $b10dba156c9c5dc5$var$getSsrBuildKey = ()=>window.SSR_BUILD_KEY || (0, $463a875e77767855$export$ba068cc3610b559d);
const $b10dba156c9c5dc5$export$6ad9e7706a4ee0f8 = (error)=>({
        errorName: $b10dba156c9c5dc5$var$extractErrorName(error),
        errorMessage: $b10dba156c9c5dc5$var$extractErrorMessage(error),
        errorStack: $b10dba156c9c5dc5$var$extractErrorStack(error),
        statusCode: $b10dba156c9c5dc5$export$1fdf7c1c0741a7e7(error),
        statusCodeGroup: $b10dba156c9c5dc5$export$f3626cbbcad37421(error),
        traceId: $b10dba156c9c5dc5$var$extractTraceId(error),
        buildKey: $b10dba156c9c5dc5$var$getBuildKey(),
        ssrBuildKey: $b10dba156c9c5dc5$var$getSsrBuildKey()
    });
const $b10dba156c9c5dc5$export$2b62e563f0fadcee = (error)=>{
    const statusCode = Number($b10dba156c9c5dc5$export$1fdf7c1c0741a7e7(error));
    return Number.isNaN(statusCode) ? false : statusCode >= 400 && statusCode < 500;
};
const $b10dba156c9c5dc5$export$dc0d2c5fff67f524 = (error)=>(0, $fZneA.isClientFetchError)(error);
const $b10dba156c9c5dc5$export$2ab75c18c9535885 = (error)=>!$b10dba156c9c5dc5$export$dc0d2c5fff67f524(error) && !$b10dba156c9c5dc5$export$2b62e563f0fadcee(error);
const $b10dba156c9c5dc5$export$9d73d6caff63cf52 = (error)=>{
    const statusCode = Number($b10dba156c9c5dc5$export$1fdf7c1c0741a7e7(error));
    return Number.isNaN(statusCode) ? false : statusCode === 429;
};
const $b10dba156c9c5dc5$export$35ef4ce2961027c7 = (error)=>{
    const statusCode = Number($b10dba156c9c5dc5$export$1fdf7c1c0741a7e7(error));
    return Number.isNaN(statusCode) ? false : statusCode === 409;
};
const $b10dba156c9c5dc5$export$7916ec13418094a3 = (attributes = {})=>({
        synthetic: (0, $68LWC.isSynthetic)(),
        isUIF: true,
        isClassic: false,
        ...attributes
    });

});
parcelRegister("68LWC", function(module, exports) {

$parcel$export(module.exports, "isSynthetic", () => $de689dbe95a6a017$export$947749d756ccb0a);

var $4R6GH = parcelRequire("4R6GH");

var $j8DrX = parcelRequire("j8DrX");
const $de689dbe95a6a017$export$947749d756ccb0a = ()=>(0, $j8DrX.default)('ajs-is-synthetic') === 'true' || (0, $4R6GH.fg)('is_synthetic_tenant');

});



parcelRegister("dZggJ", function(module, exports) {

$parcel$export(module.exports, "APP_ID", () => $24ba128e04401c75$export$d76071d5de2774fc);
$parcel$export(module.exports, "DIVIDER_DRAGGABLE_ID_PREFIX", () => $24ba128e04401c75$export$ed2b0386b406afb8);
$parcel$export(module.exports, "ANALYTICS_SOURCE_EPIC_PANEL", () => $24ba128e04401c75$export$f1fdbf1399e060a9);
$parcel$export(module.exports, "EXPERIENCE_TRACKER_PROVIDER_SOURCE", () => $24ba128e04401c75$export$d91023b42bd42fec);
$parcel$export(module.exports, "EPIC_PANEL_VIEW_EXPERIENCE", () => $24ba128e04401c75$export$226ec0e287da7094);
$parcel$export(module.exports, "EPIC_PANEL_INLINE_ISSUE_CREATE_EXPERIENCE", () => $24ba128e04401c75$export$c7ce0888e908ec32);
$parcel$export(module.exports, "EPIC_PANEL_GLOBAL_ISSUE_CREATE_EXPERIENCE", () => $24ba128e04401c75$export$64c0a8fb162be663);
$parcel$export(module.exports, "EPIC_PANEL_ASSIGN_EXPERIENCE", () => $24ba128e04401c75$export$562f3a50ddeda12d);
$parcel$export(module.exports, "EPIC_PANEL_UNASSIGN_EXPERIENCE", () => $24ba128e04401c75$export$95ac924aa931f0a6);
$parcel$export(module.exports, "EPIC_PANEL_RANK_EXPERIENCE", () => $24ba128e04401c75$export$28fe94147fbd3844);
$parcel$export(module.exports, "ABORT_EXPERIENCE_MISSING_REQUIRED_FIELD_REASON", () => $24ba128e04401c75$export$681650f90e45ec69);
$parcel$export(module.exports, "ABORT_EXPERIENCE_CANCELED_BY_USE_REASON", () => $24ba128e04401c75$export$7087cf857048f677);
$parcel$export(module.exports, "DEFAULT_PARENT_ISSUE_TYPE_NAME", () => $24ba128e04401c75$export$cb17e3c17bc50301);
$parcel$export(module.exports, "UNASSIGNED_EPIC_ID", () => $24ba128e04401c75$export$794f07be04aca3fe);
$parcel$export(module.exports, "UNASSIGNED_EPIC_ISSUE_KEY", () => $24ba128e04401c75$export$7766a7962c866d1a);
$parcel$export(module.exports, "DND_OPERATION_CARD_PARENT_SET", () => $24ba128e04401c75$export$41f0d8a4d1ec169b);
$parcel$export(module.exports, "DND_OPERATION_CARD_PARENT_UNSET", () => $24ba128e04401c75$export$5fd94e0ea08b5e7);
$parcel$export(module.exports, "DND_OPERATION_EPIC_RANK_UPDATE", () => $24ba128e04401c75$export$bc493dacb9d33787);
$parcel$export(module.exports, "EPIC_CARD_DESCRIPTION_ID", () => $24ba128e04401c75$export$5511b715832e28a2);
$parcel$export(module.exports, "PAGE_SIZE", () => $24ba128e04401c75$export$8ec3d08588d2eeda);

var $cnhn5 = parcelRequire("cnhn5");
const $24ba128e04401c75$export$d76071d5de2774fc = 'software.backlog-panel';
const $24ba128e04401c75$export$ed2b0386b406afb8 = 'DIVIDER_DRAGGABLE_ID';
const $24ba128e04401c75$export$f1fdbf1399e060a9 = 'epic panel';
const $24ba128e04401c75$export$d91023b42bd42fec = 'epicPanel';
const $24ba128e04401c75$export$226ec0e287da7094 = 'viewEpicPanel';
const $24ba128e04401c75$export$c7ce0888e908ec32 = 'createInlineIssueEpicPanel';
const $24ba128e04401c75$export$64c0a8fb162be663 = 'createGlobalIssueEpicPanel';
const $24ba128e04401c75$export$562f3a50ddeda12d = 'assignEpicPanel';
const $24ba128e04401c75$export$95ac924aa931f0a6 = 'unassignEpicPanel';
const $24ba128e04401c75$export$28fe94147fbd3844 = 'rankCardEpicPanel';
const $24ba128e04401c75$export$681650f90e45ec69 = 'require-field-missing';
const $24ba128e04401c75$export$7087cf857048f677 = 'global-issue-create-canceled-by-user';
const $24ba128e04401c75$export$de67c9c28353ce6e = 'EPIC-';
const $24ba128e04401c75$export$28ad8b364940d9aa = 'VERSION-';
const $24ba128e04401c75$export$cb17e3c17bc50301 = 'Epic';
const $24ba128e04401c75$export$794f07be04aca3fe = 0;
const $24ba128e04401c75$export$7766a7962c866d1a = 'ISK-0';
const $24ba128e04401c75$export$a45e758f2a5806e6 = [
    (0, $cnhn5.ISSUE_ASSIGNED_EVENT),
    (0, $cnhn5.ISSUE_CREATED_EVENT),
    (0, $cnhn5.ISSUE_DELETED_EVENT),
    (0, $cnhn5.ISSUE_TRANSITIONED_EVENT),
    (0, $cnhn5.ISSUE_UPDATED_EVENT),
    (0, $cnhn5.ISSUE_PARENT_ASSOCIATION_EVENT)
];
const $24ba128e04401c75$export$41f0d8a4d1ec169b = 'cardParentSet';
const $24ba128e04401c75$export$5fd94e0ea08b5e7 = 'cardParentUnset';
const $24ba128e04401c75$export$bc493dacb9d33787 = 'epicRankUpdate';
const $24ba128e04401c75$export$5511b715832e28a2 = 'epicCardDescriptionId';
const $24ba128e04401c75$export$9efe2bc97f2b0faa = 1510;
const $24ba128e04401c75$export$8ec3d08588d2eeda = 100;

});


parcelRegister("5ZVKE", function(module, exports) {

$parcel$export(module.exports, "useEpicDetailsQuery", () => $d4b9c93a4c9ddd9f$export$97e1c9675ac0bfb2);
$parcel$export(module.exports, "useEpicDetailsQueryLazy", () => $d4b9c93a4c9ddd9f$export$8ef40d993e73da57);

var $5tTFS = parcelRequire("5tTFS");

var $5cllN = parcelRequire("5cllN");

var $4R6GH = parcelRequire("4R6GH");

var $dZggJ = parcelRequire("dZggJ");

var $kGkjZ = parcelRequire("kGkjZ");
/**
 * Query to fetch full epic details for the epic panel.
 */ const $d4b9c93a4c9ddd9f$var$EPIC_DETAILS_QUERY = (0, $5cllN.default)`
    ${(0, $kGkjZ.epicFragment)}
    ${(0, $kGkjZ.estimationInfoFragment)}
    query FullEpicDetails($boardId: ID!, $isCompanyManaged: Boolean!, $pageSize: Int!, $startCursor: String) {
        boardScope(boardId: $boardId, isCMP: $isCompanyManaged) {
            parents(first: $pageSize, after: $startCursor) {
                pageInfo {
                    hasNextPage
                    endCursor
                }
                edges {
                    node {
                        ...EpicPanelIssueParentFragment
                        estimationInfo @include(if: $isCompanyManaged) {
                            ...EstimationInfoFragment
                        }
                    }
                }
            }
        }
    }
`;
const $d4b9c93a4c9ddd9f$export$97e1c9675ac0bfb2 = ({ boardId: boardId, isCompanyManaged: isCompanyManaged })=>(0, $5tTFS.useQuery)($d4b9c93a4c9ddd9f$var$EPIC_DETAILS_QUERY, {
        notifyOnNetworkStatusChange: true,
        context: {
            headers: {
                'is-company-managed-board': isCompanyManaged
            }
        },
        variables: {
            boardId: String(boardId),
            isCompanyManaged: isCompanyManaged,
            pageSize: (0, $dZggJ.PAGE_SIZE)
        },
        fetchPolicy: (0, $4R6GH.fg)('prefetch-epics-data-backlog') ? 'cache-first' : 'network-only',
        skip: true
    });
const $d4b9c93a4c9ddd9f$export$8ef40d993e73da57 = ({ boardId: boardId, isCompanyManaged: isCompanyManaged })=>(0, $5tTFS.useLazyQuery)($d4b9c93a4c9ddd9f$var$EPIC_DETAILS_QUERY, {
        notifyOnNetworkStatusChange: true,
        context: {
            headers: {
                'is-company-managed-board': isCompanyManaged
            }
        },
        variables: {
            boardId: String(boardId),
            isCompanyManaged: isCompanyManaged,
            pageSize: (0, $dZggJ.PAGE_SIZE)
        },
        fetchPolicy: 'cache-first'
    });

});
parcelRegister("kGkjZ", function(module, exports) {

$parcel$export(module.exports, "epicFragment", () => $3d3e864e78b9ac81$export$cb2dabc00ff80765);
$parcel$export(module.exports, "estimationInfoFragment", () => $3d3e864e78b9ac81$export$6ac7dc3c00d264bc);
$parcel$export(module.exports, "createEpicFragment", () => $3d3e864e78b9ac81$export$c627d203a3aa0338);

var $5cllN = parcelRequire("5cllN");
const $3d3e864e78b9ac81$export$cb2dabc00ff80765 = (0, $5cllN.default)`
    fragment EpicPanelIssueParentFragment on IssueParent {
        id
        key
        summary
        color
        childrenInfo {
            todoStats {
                issueCount
            }
            inProgressStats {
                issueCount
            }
            doneStats {
                issueCount
            }
        }
        startDate
        dueDate
    }
`;
const $3d3e864e78b9ac81$export$6ac7dc3c00d264bc = (0, $5cllN.default)`
    fragment EstimationInfoFragment on EstimationInfo {
        details {
            estimationType
            name
        }
        childrenEstimationStats {
            doneEstimate
            totalEstimate
            percentageCompleted
            notEstimated
        }
    }
`;
const $3d3e864e78b9ac81$export$c627d203a3aa0338 = (0, $5cllN.default)`
    fragment CreateIssueParentFragment on IssueParent {
        id
        key
        summary
        color
        issueType {
            id
            name
            iconUrl
        }
        childrenInfo {
            todoStats {
                issueCount
            }
            inProgressStats {
                issueCount
            }
            doneStats {
                issueCount
            }
        }
        startDate
        dueDate
    }
`;

});


parcelRegister("5dA0t", function(module, exports) {

$parcel$export(module.exports, "LoadingSkeleton", () => $4032def8b776a022$export$44c18d210d5de37b);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");

var $ksXL1 = parcelRequire("ksXL1");

var $3WsOp = parcelRequire("3WsOp");

var $fQ8Wt = parcelRequire("fQ8Wt");
const $4032def8b776a022$export$44c18d210d5de37b = ({ canCreate: canCreate, hierarchyName: hierarchyName })=>{
    const [epicIssueTypeName] = (0, $ksXL1.useEpicIssueTypeName)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3WsOp.default), {
        title: epicIssueTypeName,
        onClose: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        justifyContent: "center",
        xcss: $4032def8b776a022$var$loadingWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "medium"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fQ8Wt.CreateEpicButton), {
        isCreateEnabled: Boolean(canCreate),
        hierarchyName: hierarchyName,
        onCreateEpic: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onCreateCMPEpic: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    }));
};
const $4032def8b776a022$var$loadingWrapper = (0, $8CUq3.xcss)({
    paddingBlock: 'space.600'
});

});
parcelRegister("ksXL1", function(module, exports) {

$parcel$export(module.exports, "useEpicsStoreActions", () => $f3cf61f3dba099db$export$cc607320af4fa537);
$parcel$export(module.exports, "useEpicsStoreIsInitialised", () => $f3cf61f3dba099db$export$9ddd8d2fb828030f);
$parcel$export(module.exports, "useHasFullFetchStarted", () => $f3cf61f3dba099db$export$c73f0d69190183c7);
$parcel$export(module.exports, "useEpicIssueType", () => $f3cf61f3dba099db$export$acd1723f083afb7c);
$parcel$export(module.exports, "useEpicIssueTypeName", () => $f3cf61f3dba099db$export$1392ad62b696a2fd);
$parcel$export(module.exports, "useTimeTrackingOptions", () => $f3cf61f3dba099db$export$cfd3a8034358ba8f);
$parcel$export(module.exports, "useIsRankingEnabled", () => $f3cf61f3dba099db$export$f2905104781f6877);
$parcel$export(module.exports, "useEpicCardsState", () => $f3cf61f3dba099db$export$a1a694f17da9b27c);
$parcel$export(module.exports, "useEpicsFilterData", () => $f3cf61f3dba099db$export$9162a71a3e0d59c1);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");

var $16n1o = parcelRequire("16n1o");
const $f3cf61f3dba099db$export$cc607320af4fa537 = (0, $3sQ5x.createHook)((0, $16n1o.EpicsStore), {
    selector: null
});
const $f3cf61f3dba099db$var$getEpicsStoreIsInitialised = (state)=>state.isInitialised;
const $f3cf61f3dba099db$export$9ddd8d2fb828030f = (0, $3sQ5x.createHook)((0, $16n1o.EpicsStore), {
    selector: $f3cf61f3dba099db$var$getEpicsStoreIsInitialised
});
const $f3cf61f3dba099db$var$getHasFullFetchStarted = (state)=>state.hasFullFetchStarted;
const $f3cf61f3dba099db$export$c73f0d69190183c7 = (0, $3sQ5x.createHook)((0, $16n1o.EpicsStore), {
    selector: $f3cf61f3dba099db$var$getHasFullFetchStarted
});
const $f3cf61f3dba099db$export$c58dde3f1e86a4e4 = (state)=>state.epicIssueType;
const $f3cf61f3dba099db$export$acd1723f083afb7c = (0, $3sQ5x.createHook)((0, $16n1o.EpicsStore), {
    selector: $f3cf61f3dba099db$export$c58dde3f1e86a4e4
});
const $f3cf61f3dba099db$export$d30c1ce996fed20b = (state)=>state.epicIssueTypeName;
const $f3cf61f3dba099db$export$1392ad62b696a2fd = (0, $3sQ5x.createHook)((0, $16n1o.EpicsStore), {
    selector: $f3cf61f3dba099db$export$d30c1ce996fed20b
});
const $f3cf61f3dba099db$export$cb06173d4516a1bf = (state)=>state.timeTrackingOptions;
const $f3cf61f3dba099db$export$cfd3a8034358ba8f = (0, $3sQ5x.createHook)((0, $16n1o.EpicsStore), {
    selector: $f3cf61f3dba099db$export$cb06173d4516a1bf
});
const $f3cf61f3dba099db$export$c8d7f1b90bd94368 = (state)=>state.isRankingEnabled;
const $f3cf61f3dba099db$export$f2905104781f6877 = (0, $3sQ5x.createHook)((0, $16n1o.EpicsStore), {
    selector: $f3cf61f3dba099db$export$c8d7f1b90bd94368
});
const $f3cf61f3dba099db$export$f138f9cd4309615d = (state)=>({
        cards: state.cards,
        cardsWithFullDetailsLoaded: state.cardsWithFullDetailsLoaded,
        loading: state.loading,
        error: state.error,
        refetchError: state.refetchError
    });
const $f3cf61f3dba099db$export$a1a694f17da9b27c = (0, $3sQ5x.createHook)((0, $16n1o.EpicsStore), {
    selector: $f3cf61f3dba099db$export$f138f9cd4309615d
});
const $f3cf61f3dba099db$var$getEpicsFilterData = (state)=>({
        cards: state.cards,
        isLoading: state.loading,
        epicIssueTypeName: state.epicIssueTypeName,
        isEpicIssueTypeAvailable: state.isEpicIssueTypeAvailable
    });
const $f3cf61f3dba099db$export$9162a71a3e0d59c1 = (0, $3sQ5x.createHook)((0, $16n1o.EpicsStore), {
    selector: $f3cf61f3dba099db$var$getEpicsFilterData
});
const $f3cf61f3dba099db$export$b2da883a667e9881 = (state)=>state.isEpicIssueTypeAvailable;
const $f3cf61f3dba099db$export$9f53fc27477100a8 = (0, $3sQ5x.createHook)((0, $16n1o.EpicsStore), {
    selector: $f3cf61f3dba099db$export$b2da883a667e9881
});

});
parcelRegister("16n1o", function(module, exports) {

$parcel$export(module.exports, "EpicsStore", () => $45e2ae73c35abc39$export$718386d323810d5b);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $1mWpL = parcelRequire("1mWpL");

var $7pLfz = parcelRequire("7pLfz");
const $45e2ae73c35abc39$export$718386d323810d5b = (0, $iXqE5.createStore)({
    name: 'EpicsStore',
    initialState: (0, $7pLfz.INITIAL_STATE),
    actions: $1mWpL.actions
});
const $45e2ae73c35abc39$export$2eb948e5227270ad = (0, $3sQ5x.createHook)($45e2ae73c35abc39$export$718386d323810d5b);
const $45e2ae73c35abc39$export$e7d232b78090ef52 = (0, $gg7kZ.createContainer)($45e2ae73c35abc39$export$718386d323810d5b, {
    onInit: (0, $1mWpL.actions).initContainer
});

});
parcelRegister("1mWpL", function(module, exports) {

$parcel$export(module.exports, "actions", () => $0b74ab6d58eeb130$export$e324594224ef24da);

var $3JOCw = parcelRequire("3JOCw");

var $4R6GH = parcelRequire("4R6GH");

var $7pLfz = parcelRequire("7pLfz");
const $0b74ab6d58eeb130$export$57d319145ef8fcba = ()=>({ setState: setState }, initProps)=>{
        setState({
            ...initProps,
            isInitialised: true
        });
    };
const $0b74ab6d58eeb130$export$f6196a6c6bb539b4 = ({ cards: cards, ...initProps })=>({ setState: setState, getState: getState })=>{
        const { cards: existingCards, cardsWithFullDetailsLoaded: cardsWithFullDetailsLoaded } = getState();
        const mergedCards = (0, $4R6GH.fg)('prefetch-epics-data-backlog') ? cards.map((card)=>{
            if (cardsWithFullDetailsLoaded.has(card.epic.id)) return existingCards.find(({ epic: { id: id } })=>id === card.epic.id) ?? card;
            return card;
        }) : cards;
        setState({
            ...initProps,
            cards: mergedCards,
            isInitialised: true
        });
    };
const $0b74ab6d58eeb130$export$8e84bad0b35de9e8 = ()=>({ setState: setState })=>{
        setState((0, $7pLfz.INITIAL_STATE));
    };
const $0b74ab6d58eeb130$export$de1bc8024bd89034 = (newQueryState = {})=>({ setState: setState })=>{
        setState({
            ...newQueryState
        });
    };
const $0b74ab6d58eeb130$export$c27415602243c7a5 = (epics, optimisticIds = [])=>({ setState: setState, getState: getState })=>{
        // There is an implicit assumption that the optimisticIds match up 1-1 with the epics provided
        const { cards: cards } = getState();
        if (!optimisticIds.length) {
            if ((0, $4R6GH.fg)('prefetch-epics-data-backlog')) setState({
                cards: [
                    ...cards,
                    ...epics
                ],
                cardsWithFullDetailsLoaded: new Set([
                    ...getState().cardsWithFullDetailsLoaded,
                    ...epics.map(({ epic: { id: id } })=>id)
                ])
            });
            else setState({
                cards: [
                    ...cards,
                    ...epics
                ]
            });
            return;
        }
        const firstIndex = cards.findIndex(({ epic: { id: id } })=>optimisticIds[0] === id);
        const lastIndex = cards.findIndex(({ epic: { id: id } })=>optimisticIds[optimisticIds.length - 1] === id);
        setState({
            cards: [
                ...cards.slice(0, firstIndex),
                ...epics,
                ...cards.slice(lastIndex + 1)
            ]
        });
    };
const $0b74ab6d58eeb130$export$843544102309bcdc = (epicIds, newPosition)=>({ setState: setState, getState: getState })=>{
        const { cards: existingCards } = getState();
        const cardsNotMoved = existingCards.filter(({ epic: { id: id } })=>!epicIds.includes(Number(id)));
        const cardsMoved = existingCards.filter(({ epic: { id: id } })=>epicIds.includes(Number(id)));
        setState({
            cards: [
                ...cardsNotMoved.slice(0, newPosition),
                ...cardsMoved,
                ...cardsNotMoved.slice(newPosition)
            ]
        });
    };
const $0b74ab6d58eeb130$export$d122bcc694b92bff = ({ updatedCards: updatedCards, startIndex: startIndex = 0, hasNextPage: hasNextPage })=>({ setState: setState, getState: getState })=>{
        const { cards: cards } = getState();
        cards.splice(startIndex, hasNextPage ? updatedCards.length : cards.length - startIndex, ...updatedCards);
        if ((0, $4R6GH.fg)('prefetch-epics-data-backlog')) setState({
            cards: (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))(cards, (card)=>card.epic.id),
            cardsWithFullDetailsLoaded: new Set([
                ...getState().cardsWithFullDetailsLoaded,
                ...updatedCards.map(({ epic: { id: id } })=>id)
            ])
        });
        else setState({
            cards: (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))(cards, (card)=>card.epic.id)
        });
    };
const $0b74ab6d58eeb130$export$71b128798a3cdc4b = (epicId, attributes)=>({ setState: setState, getState: getState })=>{
        const { cards: cards } = getState();
        const updatedCards = cards.map((card)=>{
            if (card.epic.id === Number(epicId)) return {
                ...card,
                epic: {
                    ...card.epic,
                    ...attributes
                }
            };
            return card;
        });
        if (!(0, $4R6GH.fg)('prefetch-epics-data-backlog')) return setState({
            cards: updatedCards
        });
        const { cardsWithFullDetailsLoaded: cardsWithFullDetailsLoaded } = getState();
        const newCardsWithFullDetailsLoaded = attributes.isLoading !== undefined ? new Set(cardsWithFullDetailsLoaded) : null;
        if (newCardsWithFullDetailsLoaded) {
            if (attributes.isLoading) newCardsWithFullDetailsLoaded.delete(Number(epicId));
            else newCardsWithFullDetailsLoaded.add(Number(epicId));
        }
        setState({
            cards: updatedCards,
            cardsWithFullDetailsLoaded: newCardsWithFullDetailsLoaded ?? cardsWithFullDetailsLoaded
        });
    };
const $0b74ab6d58eeb130$export$3293922453e4d4c = (attributes, startIndex = 0)=>({ setState: setState, getState: getState })=>{
        const { cards: existingCards } = getState();
        const cards = existingCards.map((card, index)=>({
                ...card,
                epic: {
                    ...card.epic,
                    ...index >= startIndex && attributes
                }
            }));
        if (!(0, $4R6GH.fg)('prefetch-epics-data-backlog')) return setState({
            cards: cards
        });
        const { cardsWithFullDetailsLoaded: cardsWithFullDetailsLoaded } = getState();
        const newCardsWithFullDetailsLoaded = attributes.isLoading !== undefined ? new Set(cardsWithFullDetailsLoaded) : null;
        if (newCardsWithFullDetailsLoaded) {
            for(let i = startIndex; i < existingCards.length; i++)if (attributes.isLoading) newCardsWithFullDetailsLoaded.delete(existingCards[i].epic.id);
            else newCardsWithFullDetailsLoaded.add(existingCards[i].epic.id);
        }
        setState({
            cards: cards,
            cardsWithFullDetailsLoaded: newCardsWithFullDetailsLoaded ?? cardsWithFullDetailsLoaded
        });
    };
const $0b74ab6d58eeb130$export$24cf08eca89ef91 = (started)=>({ setState: setState, getState: getState })=>{
        setState({
            hasFullFetchStarted: started || getState().hasFullFetchStarted
        });
    };
const $0b74ab6d58eeb130$export$e324594224ef24da = {
    initContainer: $0b74ab6d58eeb130$export$57d319145ef8fcba,
    initState: $0b74ab6d58eeb130$export$f6196a6c6bb539b4,
    resetState: $0b74ab6d58eeb130$export$8e84bad0b35de9e8,
    updateQueryState: $0b74ab6d58eeb130$export$de1bc8024bd89034,
    addEpics: $0b74ab6d58eeb130$export$c27415602243c7a5,
    rankEpics: $0b74ab6d58eeb130$export$843544102309bcdc,
    updateEpics: $0b74ab6d58eeb130$export$d122bcc694b92bff,
    updateEpicAttributes: $0b74ab6d58eeb130$export$71b128798a3cdc4b,
    updateEpicsAttributes: $0b74ab6d58eeb130$export$3293922453e4d4c,
    updateHasFullFetchStarted: $0b74ab6d58eeb130$export$24cf08eca89ef91
};

});
parcelRegister("7pLfz", function(module, exports) {

$parcel$export(module.exports, "INITIAL_STATE", () => $a7be206ef5b19981$export$36d128238e6b60f5);
$parcel$export(module.exports, "STORY_POINTS", () => $a7be206ef5b19981$export$405b6d72f2d243a9);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE", () => $a7be206ef5b19981$export$bfb354504bb547a0);

var $gBj4V = parcelRequire("gBj4V");
const $a7be206ef5b19981$export$36d128238e6b60f5 = {
    cards: [],
    cardsWithFullDetailsLoaded: new Set(),
    columnCounts: {
        toDo: 0,
        inProgress: 0,
        done: 0
    },
    isEpicIssueTypeAvailable: false,
    epicIssueType: {
        id: 0,
        name: 'Epic',
        hasRequiredFields: false
    },
    epicIssueTypeName: 'Epic',
    timeTrackingOptions: (0, $gBj4V.defaultTimeTrackingOptions),
    isRankingEnabled: false,
    isInitialised: false,
    loading: false,
    hasFullFetchStarted: false
};
const $a7be206ef5b19981$export$405b6d72f2d243a9 = 'STORY_POINTS';
const $a7be206ef5b19981$export$bfb354504bb547a0 = 'ORIGINAL_ESTIMATE';
const $a7be206ef5b19981$export$43cafe5ec3ffdbf5 = 'CUSTOM_NUMBER_FIELD';
const $a7be206ef5b19981$export$8775696968c9b13c = 'ISSUE_COUNT';

});




parcelRegister("3WsOp", function(module, exports) {

$parcel$export(module.exports, "default", () => $87db1608ea208649$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $dCm1o = parcelRequire("dCm1o");

var $a2e2Q = parcelRequire("a2e2Q");

var $lmBAt = parcelRequire("lmBAt");

var $lUMFO = parcelRequire("lUMFO");
const $87db1608ea208649$export$2ddb90ad54e5f587 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ title: title = '', onClose: onClose = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), children: children }, ref)=>{
    const { isSoftwareFullTheming: isSoftwareFullTheming } = (0, $lmBAt.getIsSoftwareThemingM2Enabled)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $a2e2Q.useSoftwareProjectTheming)() : {
        isSoftwareFullTheming: false
    };
    if ((0, $dCm1o.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "software-backlog-panel.common.ui.panel.container",
        className: (0, $bwpsq.default)([
            "_2rkoftgi _1e0c1txw _2lx21bp4 _16jlkb7n _n3tdv77o _vchhusvi _bfhkqbzx _1wpzv2br _c71l1q0t",
            "_1i7q1ogy _6ru51ogy _1y8o1wdt _zzrm1wdt",
            isSoftwareFullTheming && "_bfhk1jc5"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lUMFO.default), {
        title: title,
        onClose: onClose
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($87db1608ea208649$var$Content, {
        ref: ref
    }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($87db1608ea208649$var$Container, {
        "data-test-id": "software-backlog-panel.common.ui.panel.container",
        "data-testid": "software-backlog-panel.common.ui.panel.container",
        className: (0, $bwpsq.default)([
            "_1i7q1ogy _6ru51ogy _1y8o1wdt _zzrm1wdt"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lUMFO.default), {
        title: title,
        onClose: onClose
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($87db1608ea208649$var$Content, {
        ref: ref
    }, children));
});
var $87db1608ea208649$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($87db1608ea208649$export$2ddb90ad54e5f587);
const $87db1608ea208649$var$width = 220;
const $87db1608ea208649$var$widthLarge = 270;
const $87db1608ea208649$var$containerWidthStyles = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $87db1608ea208649$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoftgi _1e0c1txw _2lx21bp4 _16jlkb7n _n3tdv77o _vchhusvi _bfhkqbzx _1wpzv2br _c71l1vmz",
            __cmplp.className
        ])
    });
});
const $87db1608ea208649$var$containerStyles = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $87db1608ea208649$var$Content = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _1reo15vq _18m91wug",
            __cmplp.className
        ])
    });
});
const $87db1608ea208649$var$themed = null;

});
parcelRegister("lUMFO", function(module, exports) {

$parcel$export(module.exports, "default", () => $e20f5c482c9df4d8$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $2jwCH = parcelRequire("2jwCH");

var $dqoiX = parcelRequire("dqoiX");

var $gwIPs = parcelRequire("gwIPs");

var $az4zD = parcelRequire("az4zD");

var $dZggJ = parcelRequire("dZggJ");

var $gJwmE = parcelRequire("gJwmE");

var $iGDv7 = parcelRequire("iGDv7");
const $e20f5c482c9df4d8$export$8b251419efc915eb = ({ title: title, onClose: onClose, intl: { formatMessage: formatMessage } })=>{
    const label = formatMessage((0, $iGDv7.default).closeButtonLabel, {
        title: title
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e20f5c482c9df4d8$var$Container, {
        "data-testid": "software-backlog-panel.common.ui.panel.header.container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e20f5c482c9df4d8$var$TitleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e20f5c482c9df4d8$var$Title, {
        "data-testid": "software-backlog-panel.common.ui.panel.header.title"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "xsmall"
    }, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), {
        id: (0, $dZggJ.EPIC_CARD_DESCRIPTION_ID)
    }, formatMessage((0, $iGDv7.default).epicCardDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e20f5c482c9df4d8$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        spacing: "none",
        onClick: onClose,
        testId: "software-backlog-panel.common.ui.panel.header.close-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e20f5c482c9df4d8$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2jwCH))), {
        spacing: "spacious",
        label: label,
        color: "var(--ds-icon, #44546F)"
    })))));
};
var $e20f5c482c9df4d8$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)(/*#__PURE__*/ (0, $5uXOq.memo)($e20f5c482c9df4d8$export$8b251419efc915eb));
const $e20f5c482c9df4d8$var$ICON_SIZE = (0, $gwIPs.gridSize) * 3; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e20f5c482c9df4d8$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o _1o9zidpf _ca0qutpp _u5f3u2gc _n3tdu2gc _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $e20f5c482c9df4d8$var$TitleWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _16jlkb7n _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $e20f5c482c9df4d8$var$ButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _1bsb1tcg _4t3i1tcg _1ul91tcg _1tke1tcg",
            __cmplp.className
        ])
    });
});
const $e20f5c482c9df4d8$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1tcg _4t3i1tcg",
            __cmplp.className
        ])
    });
});
const $e20f5c482c9df4d8$var$Title = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_ol3jx8": (0, $lD23V.default)((0, $gJwmE.cardColor).default.textColorSubtle)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1ule _1bto1l2s _o5721q9c _k48p1wq8 _syazqpuq _19bvu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2jwCH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e514a79fafb6c57d068e94d2350d1008>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1af6a969f6ce5e7d$var$_react = $1af6a969f6ce5e7d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $1af6a969f6ce5e7d$var$_close = $1af6a969f6ce5e7d$var$_interopRequireDefault((parcelRequire("i28qQ")));

var $1af6a969f6ce5e7d$var$_close2 = $1af6a969f6ce5e7d$var$_interopRequireDefault((parcelRequire("2C7j9")));
function $1af6a969f6ce5e7d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CloseIcon.
 * This component is CloseIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1af6a969f6ce5e7d$var$CloseIcon = (props)=>/*#__PURE__*/ $1af6a969f6ce5e7d$var$_react.default.createElement($1af6a969f6ce5e7d$var$_close.default, Object.assign({
        LEGACY_fallbackIcon: $1af6a969f6ce5e7d$var$_close2.default
    }, props));
$1af6a969f6ce5e7d$var$CloseIcon.Name = 'CloseIconMigration';
var $1af6a969f6ce5e7d$var$_default = module.exports.default = $1af6a969f6ce5e7d$var$CloseIcon;

});

parcelRegister("gJwmE", function(module, exports) {

$parcel$export(module.exports, "cardColor", () => $a7528499484db0c3$export$7371e516c83e77f1);
const $a7528499484db0c3$var$COLOR_TEXT = "var(--ds-text, #172B4D)";
const $a7528499484db0c3$var$COLOR_TEXT_INVERSE = "var(--ds-text-inverse, #FFFFFF)";
const $a7528499484db0c3$export$7371e516c83e77f1 = {
    default: {
        textColor: $a7528499484db0c3$var$COLOR_TEXT,
        textColorSubtle: "var(--ds-text-subtle, #44546F)",
        progressBar: {
            textColor: "var(--ds-text-subtlest, #626F86)"
        },
        mouseLeave: {
            backgroundColor: "var(--ds-surface-raised, #FFFFFF)",
            textColor: $a7528499484db0c3$var$COLOR_TEXT
        },
        mouseOver: {
            backgroundColor: "var(--ds-surface-raised-hovered, #F1F2F4)",
            textColor: $a7528499484db0c3$var$COLOR_TEXT
        },
        mouseDown: {
            backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
        }
    },
    active: {
        progressBar: {
            textColor: $a7528499484db0c3$var$COLOR_TEXT_INVERSE
        },
        mouseLeave: {
            backgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
            textColor: $a7528499484db0c3$var$COLOR_TEXT
        },
        mouseOver: {
            backgroundColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
            textColor: $a7528499484db0c3$var$COLOR_TEXT
        },
        mouseDown: {
            backgroundColor: "var(--ds-background-selected-pressed, #85B8FF)"
        }
    }
};

});

parcelRegister("iGDv7", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bc7c4bdb8f2ea1a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9bc7c4bdb8f2ea1a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    closeButtonLabel: {
        "id": "software-backlog-panel.common.panel.header.close-button-label-new",
        "defaultMessage": "Close {title} panel"
    },
    epicCardDescription: {
        "id": "software-backlog-panel.common.panel.header.epic-card-description",
        "defaultMessage": "Whatever you select will be shown in the main content"
    }
});

});



parcelRegister("fQ8Wt", function(module, exports) {

$parcel$export(module.exports, "CreateEpicButton", () => $2072429d11c4e00e$export$e2fee146605f4d14);
$parcel$export(module.exports, "default", () => $2072429d11c4e00e$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $MHKc7 = parcelRequire("MHKc7");

var $ksXL1 = parcelRequire("ksXL1");


var $9Ik53 = parcelRequire("9Ik53");

var $3WsOp = parcelRequire("3WsOp");

var $a65fr = parcelRequire("a65fr");

var $eSUJA = parcelRequire("eSUJA");

var $hADnR = parcelRequire("hADnR");

var $g0bCK = parcelRequire("g0bCK");

var $lkS4n = parcelRequire("lkS4n");
const $2072429d11c4e00e$export$e2fee146605f4d14 = ({ isCreateEnabled: isCreateEnabled, hierarchyName: hierarchyName, onCreateEpic: onCreateEpic, onCreateCMPEpic: onCreateCMPEpic })=>{
    const { isCompanyManaged: isCompanyManaged } = (0, $eSUJA.usePanelData)();
    const [epicIssueType] = (0, $ksXL1.useEpicIssueType)();
    if (!isCreateEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        paddingInline: "space.050"
    }, isCompanyManaged ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hADnR.default), {
        onCreate: onCreateCMPEpic,
        issueType: epicIssueType,
        hierarchyName: hierarchyName
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lkS4n.default), {
        epicIssueType: epicIssueType,
        triggerAppearance: (0, $7462c685f739ed5a$export$dda6912361cddac9),
        onCreate: onCreateEpic
    }));
};
/**
 * This is the main entrypoint for the epic panel, responsible for rendering the actual list of epic cards
 */ const $2072429d11c4e00e$var$EpicPanel = ({ isCreateEnabled: isCreateEnabled, isEditEnabled: isEditEnabled, selectedIssues: selectedIssues, hierarchyName: hierarchyName, onClose: onClose = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onCardDetailClick: onCardDetailClick = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onCreateIssueClick: onCreateIssueClick, onCreateEpic: onCreateEpic = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onCreateCMPEpic: onCreateCMPEpic, onAssignEpic: onAssignEpic, onRefetch: onRefetch })=>{
    const scrollElementRef = (0, $5uXOq.useRef)(null);
    const [epicIssueTypeName] = (0, $ksXL1.useEpicIssueTypeName)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3WsOp.default), {
        ref: scrollElementRef,
        title: epicIssueTypeName,
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2072429d11c4e00e$var$DroppableArea, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Ik53.ScrollStateContextProvider), {
        scrollRef: scrollElementRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a65fr.CardOpenProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0bCK.EpicCardList), {
        isEditEnabled: isEditEnabled,
        selectedIssues: selectedIssues,
        onAssignEpic: onAssignEpic,
        onCardDetailClick: onCardDetailClick,
        onCreateIssueClick: onCreateIssueClick,
        onRefetch: onRefetch
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2072429d11c4e00e$export$e2fee146605f4d14, {
        isCreateEnabled: isCreateEnabled,
        hierarchyName: hierarchyName,
        onCreateEpic: onCreateEpic,
        onCreateCMPEpic: onCreateCMPEpic
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2072429d11c4e00e$var$DroppableArea = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _1o9zidpf",
            __cmplp.className
        ])
    });
});
var $2072429d11c4e00e$export$2e2bcd8739ae039 = $2072429d11c4e00e$var$EpicPanel;

});
const $7462c685f739ed5a$export$3789e4b2a10baa2b = 'full';
const $7462c685f739ed5a$export$db1cdb8627b81f84 = 'compact';
const $7462c685f739ed5a$export$aca095bc476d426f = 'simple';
const $7462c685f739ed5a$export$1aad44a7533f8ad8 = 'table_row';
const $7462c685f739ed5a$export$d2f7b3f0efb6e208 = 'hidden';
const $7462c685f739ed5a$export$dda6912361cddac9 = 'visible';
const $7462c685f739ed5a$export$565566e3df4dad53 = 'blur';
const $7462c685f739ed5a$export$806b905ec7df742f = 'enter';
const $7462c685f739ed5a$export$2bb790b9008907b4 = 'escape';
const $7462c685f739ed5a$export$ba9f60edfdf2e66 = 'create_button';
const $7462c685f739ed5a$export$193356664cd84c83 = 255;
const $7462c685f739ed5a$export$f9e3e7ede9ba929d = 500;
const $7462c685f739ed5a$export$e0bc602b327f818b = 'add-issue-type-option';

parcelRegister("9Ik53", function(module, exports) {

$parcel$export(module.exports, "useScrollState", () => $c77424cc0be42400$export$98084ad349e2edae);
$parcel$export(module.exports, "ScrollStateContextProvider", () => $c77424cc0be42400$export$7cc0055278d35041);
/*!
 * Adding too many scroll listeners adds overhead to both the initial
 * "bootstrap" phase, when the listeners are added, and all scroll events.
 *
 * Some virtualisation use-cases such as boards may have a large number of
 * virtual lists instances. Sharing a scroll element through context avoids
 * attaching one listener per list.
 */ 
var $5uXOq = parcelRequire("5uXOq");
const $c77424cc0be42400$export$50b6b7783d156e1b = 200;
const $c77424cc0be42400$var$DEFAULT_SCROLL_STATE = {
    height: 0,
    width: 0,
    scrollHeight: 0,
    scrollWidth: 0,
    scrollTop: 0,
    scrollLeft: 0,
    isScrolling: false,
    scrollElement: null
};
const $c77424cc0be42400$var$ScrollStateContext = /*#__PURE__*/ (0, $5uXOq.createContext)($c77424cc0be42400$var$DEFAULT_SCROLL_STATE);
const $c77424cc0be42400$export$98084ad349e2edae = ()=>(0, $5uXOq.useContext)($c77424cc0be42400$var$ScrollStateContext);
const $c77424cc0be42400$var$attachResizeObserver = (callback, targetEl)=>{
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    if (!targetEl) return ()=>{};
    let resizeObserver = null;
    // SSR fix. Do not instantiate for SSR
    if (typeof ResizeObserver !== 'undefined') resizeObserver = new ResizeObserver(()=>callback());
    // When mounting our listener, if its the Window object, treat it as such.
    // This can happen in Storybook but not in any other scenario
    if (targetEl instanceof Window) targetEl.addEventListener('resize', callback);
    else resizeObserver?.observe(targetEl);
    return ()=>{
        // Cleanup the resize callback we have attached
        if (targetEl instanceof Window) targetEl.removeEventListener('resize', callback);
        else resizeObserver?.disconnect();
    };
};
/**
 * Listens for scroll events on the `HTMLElement` `scrollRef.current` and updates a state
 * variable with the scroll state, which is returned.
 */ const $c77424cc0be42400$var$useElementScrollState = (scrollRef, shouldSkipFirstResize, initialScrollState)=>{
    const [scrollState, setScrollState] = (0, $5uXOq.useState)(initialScrollState ?? $c77424cc0be42400$var$DEFAULT_SCROLL_STATE);
    const isFirstResize = (0, $5uXOq.useRef)(true);
    (0, $5uXOq.useEffect)(()=>{
        const targetEl = scrollRef.current;
        if (!targetEl) return undefined;
        let clearScrollingTimeoutId;
        const onScroll = ()=>{
            setScrollState((state)=>({
                    ...state,
                    scrollTop: targetEl.scrollTop,
                    scrollLeft: targetEl.scrollLeft,
                    isScrolling: true
                }));
            clearTimeout(clearScrollingTimeoutId);
            clearScrollingTimeoutId = setTimeout(()=>{
                setScrollState((state)=>({
                        ...state,
                        scrollTop: targetEl.scrollTop,
                        scrollLeft: targetEl.scrollLeft,
                        isScrolling: false
                    }));
            }, $c77424cc0be42400$export$50b6b7783d156e1b);
        };
        const onResize = ()=>{
            if (shouldSkipFirstResize && isFirstResize.current) {
                isFirstResize.current = false;
                return;
            }
            setScrollState((state)=>({
                    ...state,
                    scrollTop: targetEl.scrollTop,
                    scrollLeft: targetEl.scrollLeft,
                    height: targetEl.clientHeight,
                    width: targetEl.clientWidth,
                    scrollHeight: targetEl.scrollHeight,
                    scrollWidth: targetEl.scrollWidth,
                    isScrolling: true
                }));
            clearTimeout(clearScrollingTimeoutId);
            clearScrollingTimeoutId = setTimeout(()=>{
                setScrollState((state)=>({
                        ...state,
                        scrollTop: targetEl.scrollTop,
                        scrollLeft: targetEl.scrollLeft,
                        isScrolling: false
                    }));
            }, $c77424cc0be42400$export$50b6b7783d156e1b);
        };
        // We want to know when the scroll element/container itself resizes as this impacts
        // the number of rows we show
        const cleanupResizeObserver = $c77424cc0be42400$var$attachResizeObserver(onResize, targetEl);
        targetEl.addEventListener('scroll', onScroll);
        setScrollState({
            height: targetEl.clientHeight,
            width: targetEl.clientWidth,
            scrollHeight: targetEl.scrollHeight,
            scrollWidth: targetEl.scrollWidth,
            scrollTop: targetEl.scrollTop,
            scrollLeft: targetEl.scrollLeft,
            isScrolling: false,
            scrollElement: targetEl
        });
        return ()=>{
            targetEl.removeEventListener('scroll', onScroll);
            cleanupResizeObserver();
            clearTimeout(clearScrollingTimeoutId);
        };
    }, [
        scrollRef,
        shouldSkipFirstResize
    ]);
    return scrollState;
};
const $c77424cc0be42400$export$7cc0055278d35041 = ({ scrollRef: scrollRef, shouldSkipFirstResize: shouldSkipFirstResize, children: children, initialScrollState: initialScrollState })=>{
    const scrollState = $c77424cc0be42400$var$useElementScrollState(scrollRef, shouldSkipFirstResize, initialScrollState);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c77424cc0be42400$var$ScrollStateContext.Provider, {
        value: scrollState
    }, children);
};

});

parcelRegister("a65fr", function(module, exports) {

$parcel$export(module.exports, "CardOpenProvider", () => $3c3e1d15a77e7efb$export$7dbab6cc701950d3);
$parcel$export(module.exports, "useCardOpen", () => $3c3e1d15a77e7efb$export$4ccd3b742a9adc36);

var $5uXOq = parcelRequire("5uXOq");
const $3c3e1d15a77e7efb$var$CardOpenContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    openCards: new Set(),
    setOpenCards: ()=>null
});
const $3c3e1d15a77e7efb$export$7dbab6cc701950d3 = ({ children: children })=>{
    const [openCards, setOpenCards] = (0, $5uXOq.useState)(new Set([]));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3c3e1d15a77e7efb$var$CardOpenContext.Provider, {
        value: {
            openCards: openCards,
            setOpenCards: setOpenCards
        }
    }, children);
};
const $3c3e1d15a77e7efb$export$fc9f1fd0b88ef846 = ()=>(0, $5uXOq.useContext)($3c3e1d15a77e7efb$var$CardOpenContext);
const $3c3e1d15a77e7efb$export$4ccd3b742a9adc36 = (id)=>{
    const { openCards: openCards, setOpenCards: setOpenCards } = (0, $5uXOq.useContext)($3c3e1d15a77e7efb$var$CardOpenContext);
    return {
        isContentExpanded: openCards.has(id),
        toggleOpen: ()=>{
            openCards.has(id) ? openCards.delete(id) : openCards.add(id);
            setOpenCards(new Set(openCards));
        }
    };
};

});

parcelRegister("eSUJA", function(module, exports) {

$parcel$export(module.exports, "PanelDataProvider", () => $7bfe6da32abe9d26$export$3391167f05694d55);
$parcel$export(module.exports, "usePanelData", () => $7bfe6da32abe9d26$export$50f78812a0e4a6ee);

var $5uXOq = parcelRequire("5uXOq");
const $7bfe6da32abe9d26$var$PanelDataContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isCompanyManaged: false,
    boardId: -1,
    sourceDroppableType: ''
});
const $7bfe6da32abe9d26$export$3391167f05694d55 = ({ children: children, isCompanyManaged: isCompanyManaged, boardId: boardId, sourceDroppableType: sourceDroppableType })=>{
    const panelData = (0, $5uXOq.useMemo)(()=>({
            isCompanyManaged: isCompanyManaged,
            boardId: boardId,
            sourceDroppableType: sourceDroppableType
        }), [
        boardId,
        isCompanyManaged,
        sourceDroppableType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7bfe6da32abe9d26$var$PanelDataContext.Provider, {
        value: panelData
    }, children);
};
const $7bfe6da32abe9d26$export$50f78812a0e4a6ee = ()=>(0, $5uXOq.useContext)($7bfe6da32abe9d26$var$PanelDataContext);

});

parcelRegister("hADnR", function(module, exports) {

$parcel$export(module.exports, "default", () => $c90261bc8f4cd52e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dCm1o = parcelRequire("dCm1o");

var $koVbs = parcelRequire("koVbs");

var $l94uE = parcelRequire("l94uE");

var $lmBAt = parcelRequire("lmBAt");

var $a2e2Q = parcelRequire("a2e2Q");

var $aehOU = parcelRequire("aehOU");
const $c90261bc8f4cd52e$var$styles = {
    stickyButtonContainer: "_2rkohyhq _1e0c1txw _1bah1e5h _kqsw1if8 _94n5idpf _ca0qv77o _u5f3idpf _n3tdv77o _19bvidpf _bfhkqbzx _18u012x7",
    themed: "_bfhk18uv"
};
const $c90261bc8f4cd52e$var$CreateIssueButton = ({ onCreate: onCreate, issueType: issueType, hierarchyName: hierarchyName })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { isSoftwareFullTheming: isSoftwareFullTheming } = (0, $lmBAt.getIsSoftwareThemingM2Enabled)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $a2e2Q.useSoftwareProjectTheming)() : {
        isSoftwareFullTheming: false
    };
    const label = hierarchyName?.toLocaleLowerCase() || issueType.name.toLocaleLowerCase();
    return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "software-backlog-panel.ui.epic.epic-panel.create-issue-button.sticky-button-container",
        className: (0, $bwpsq.default)([
            $c90261bc8f4cd52e$var$styles.stickyButtonContainer,
            isSoftwareFullTheming && $c90261bc8f4cd52e$var$styles.themed
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l94uE.default), {
        label: formatMessage((0, $aehOU.default).label, {
            issueTypeNameLowerCase: label
        }),
        onClick: onCreate
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c90261bc8f4cd52e$var$StickyButtonContainer, {
        "data-testid": "software-backlog-panel.ui.epic.epic-panel.create-issue-button.sticky-button-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l94uE.default), {
        label: formatMessage((0, $aehOU.default).label, {
            issueTypeNameLowerCase: label
        }),
        onClick: onCreate
    }));
};
var $c90261bc8f4cd52e$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $c90261bc8f4cd52e$var$CreateIssueButton;
const $c90261bc8f4cd52e$var$StickyButtonContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkohyhq _1e0c1txw _1bah1e5h _kqsw1if8 _94n5idpf _ca0qv77o _u5f3idpf _n3tdv77o _19bvidpf _bfhkqbzx",
            __cmplp.className
        ])
    });
});

});
parcelRegister("l94uE", function(module, exports) {

$parcel$export(module.exports, "default", () => $9719a5afff7fc59d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $6s1PB = parcelRequire("6s1PB");

var $az4zD = parcelRequire("az4zD");

var $2OMDV = parcelRequire("2OMDV");


var $gBq9h = parcelRequire("gBq9h");

var $egFHr = parcelRequire("egFHr");

var $5Qqfj = parcelRequire("5Qqfj");
function $9719a5afff7fc59d$export$41fb9f06171c75f4({ isDisabled: isDisabled, triggerAppearance: triggerAppearance, isSticky: isSticky, label: label, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, onClick: onClick, intl: { formatMessage: formatMessage }, isModalTrigger: isModalTrigger, shouldFocusTrigger: shouldFocusTrigger = false }) {
    const defaultLabel = label || formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $egFHr.default).labelIssueTermRefresh : (0, $egFHr.default).label);
    if (triggerAppearance === (0, $7462c685f739ed5a$export$dda6912361cddac9)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Qqfj.default), {
        isModalTrigger: isModalTrigger,
        isSticky: isSticky,
        label: defaultLabel,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        isDisabled: isDisabled,
        shouldFocusTrigger: shouldFocusTrigger
    });
    if (isDisabled !== true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gBq9h.default), {
        label: defaultLabel,
        onClick: onClick,
        shouldFocusTrigger: shouldFocusTrigger
    });
    return null;
}
$9719a5afff7fc59d$export$41fb9f06171c75f4.defaultProps = {
    isDisabled: false,
    isSticky: false,
    triggerAppearance: (0, $7462c685f739ed5a$export$dda6912361cddac9),
    label: '',
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    shouldFocusTrigger: false
};
var $9719a5afff7fc59d$export$2e2bcd8739ae039 = (0, $2OMDV.AnalyticsEventToProps)('button', {
    onClick: 'clicked'
})((0, $az4zD.injectIntlV2)($9719a5afff7fc59d$export$41fb9f06171c75f4));

});
parcelRegister("gBq9h", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0a1afa644007482$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $faod6 = parcelRequire("faod6");

var $dCm1o = parcelRequire("dCm1o");

const $e0a1afa644007482$var$fadeInAnimation = null;
const $e0a1afa644007482$var$triggerStyles = null;
const $e0a1afa644007482$var$TriggerFallback = (props)=>/*#__PURE__*/ $5uXOq.createElement("div", {
        ...props,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1e0c1ule _kqswh2mm _1pbykb7n _19pkr5cr _2hwxidpf _otyrr5cr _18u0idpf _4t3iu2gc _1bsb1osq _bfhk18uv _tzy4idpf _qj9aglyw _1pjhtlke _1mygkb7n _d0altlke _11om1wwu _7psyfnf5 _1uy0fnf5 _bir2q7pw"
        ])
    });
const $e0a1afa644007482$export$9496cf78b8451731 = ({ label: label, onClick: onClick, TriggerWrapper: TriggerWrapper = $e0a1afa644007482$var$TriggerFallback, shouldFocusTrigger: shouldFocusTrigger = false })=>/*#__PURE__*/ $5uXOq.createElement(TriggerWrapper, {
        onClick: onClick
    }, /*#__PURE__*/ $5uXOq.createElement((0, $3bDjY.default), {
        content: label,
        position: "left",
        delay: (0, $7462c685f739ed5a$export$f9e3e7ede9ba929d),
        hideTooltipOnClick: true
    }, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ $5uXOq.createElement("button", {
        "data-testid": "platform-inline-card-create.ui.trigger.hidden.button",
        autoFocus: shouldFocusTrigger,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _12ji1r31 _1qu2glyw _12y31o36 _19itglyw _2rkoglpi _1e0c1ule _kqswstnw _t9ec1w5p _1pbykb7n _4t3i1ejb _1bsb1ejb _bfhkb29m _80om1kw7",
            "_19itzgxb _bfhk1bhr _irr316qz"
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($faod6))), {
        label: label,
        color: "var(--ds-icon, #44546F)"
    })) : /*#__PURE__*/ $5uXOq.createElement("button", {
        "data-testid": "platform-inline-card-create.ui.trigger.hidden.button",
        autoFocus: shouldFocusTrigger,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _12ji1r31 _1qu2glyw _12y31o36 _19itglyw _2rkoglpi _1e0c1ule _kqswstnw _t9ec1w5p _1pbykb7n _4t3i1ejb _1bsb1ejb _bfhkb29m _80om1kw7"
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        xcss: $e0a1afa644007482$var$centeredIconStyles
    }, /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($faod6))), {
        spacing: "spacious",
        label: label,
        color: "var(--ds-icon-inverse, #FFFFFF)"
    })))), /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        xcss: $e0a1afa644007482$var$dividerStyles,
        backgroundColor: "color.background.brand.bold"
    }));
var $e0a1afa644007482$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($e0a1afa644007482$export$9496cf78b8451731);
const $e0a1afa644007482$var$dividerStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    transform: 'translateY(3px)',
    height: "var(--ds-space-025, 2px)",
    width: '100%'
});
const $e0a1afa644007482$var$centeredIconStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    height: "var(--ds-space-300, 24px)",
    width: "var(--ds-space-300, 24px)"
});
const $e0a1afa644007482$var$buttonStyles = null;
const $e0a1afa644007482$var$visualRefreshStyles = null;

});

parcelRegister("egFHr", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f56794831a7b04b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0f56794831a7b04b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "inline-card-create.trigger.label",
        "defaultMessage": "Create issue"
    },
    labelIssueTermRefresh: {
        "id": "inline-card-create.trigger.label-issue-term-refresh",
        "defaultMessage": "Create"
    }
});

});

parcelRegister("5Qqfj", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd137c52878495bb$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $9yOBd = parcelRequire("9yOBd");

var $99M5v = parcelRequire("99M5v");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $gwIPs = parcelRequire("gwIPs");

var $iKdRC = parcelRequire("iKdRC");
const $cd137c52878495bb$var$labelWrapperStyles = null;
const $cd137c52878495bb$var$contentWrapperStyles = null;
const $cd137c52878495bb$export$305831e851c35a16 = ({ isDisabled: isDisabled = false, isSticky: isSticky = false, label: label, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, onClick: onClick, isModalTrigger: isModalTrigger, shouldFocusTrigger: shouldFocusTrigger = false })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const iccButtonTheme = (currentTheme, props)=>{
        const themeProps = {
            ...props
        };
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
        return {
            buttonStyles: {
                ...buttonStyles,
                marginTop: "var(--ds-space-025, 2px)",
                marginBottom: "var(--ds-space-025, 2px)",
                height: `${(0, $gwIPs.gridSize) * 4.5}px`,
                alignItems: 'center'
            },
            spinnerStyles: spinnerStyles
        };
    };
    const iconColor = isDisabled ? "var(--ds-icon-disabled, #091E424F)" : "var(--ds-icon, #44546F)";
    const shouldShowTooltip = label.length > 16;
    const renderStickyContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
            className: (0, $bwpsq.default)([
                "_1e0c1txw _2lx2vrvc _4cvr1h6o _1bah1e5h"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($99M5v))), {
            testId: "platform-inline-card-create.ui.trigger.visible.add-icon",
            label: "",
            color: iconColor,
            LEGACY_size: "small"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, $bwpsq.default)([
                "_1e0c1ule _18u01b66 _1reo15vq _1wnr15vq"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $cd137c52878495bb$var$labelContextStyles,
            as: "span"
        }, label)));
    const ButtonComponent = isModalTrigger ? (0, $iKdRC.ModalTriggerButton) : (0, $9yOBd.default);
    const renderButtonComponent = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ButtonComponent, {
            ...triggerProps,
            iconBefore: isSticky ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($99M5v))), {
                testId: "platform-inline-card-create.ui.trigger.visible.add-icon",
                label: "",
                color: iconColor,
                LEGACY_size: "small"
            }),
            appearance: "subtle",
            theme: iccButtonTheme,
            shouldFitContainer: true,
            onClick: onClick,
            isDisabled: isDisabled,
            testId: "platform-inline-card-create.ui.trigger.visible.button",
            "aria-labelledby": ariaLabelledBy,
            "aria-label": ariaLabel || label,
            autoFocus: shouldFocusTrigger
        }, isSticky ? renderStickyContent() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $cd137c52878495bb$var$labelContextStyles,
            as: "span"
        }, label));
    return shouldShowTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: label,
        tag: "span"
    }, renderButtonComponent) : renderButtonComponent();
};
const $cd137c52878495bb$var$labelContextStyles = (0, $8CUq3.xcss)({
    display: 'block',
    textAlign: 'left',
    textOverflow: 'ellipsis',
    overflowX: 'hidden'
});
var $cd137c52878495bb$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($cd137c52878495bb$export$305831e851c35a16);

});
parcelRegister("iKdRC", function(module, exports) {

$parcel$export(module.exports, "ModalTriggerButton", () => $dd7ef71db2053b80$export$f69d15d2f52857d);

var $5uXOq = parcelRequire("5uXOq");

var $9yOBd = parcelRequire("9yOBd");
var $fVnbM = parcelRequire("fVnbM");

var $42CjB = parcelRequire("42CjB");

var $hCCtP = parcelRequire("hCCtP");

var $lu5k0 = parcelRequire("lu5k0");
const $dd7ef71db2053b80$export$f69d15d2f52857d = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const internalRef = (0, $5uXOq.useRef)(null);
    const { setReturnFocusTo: setReturnFocusTo } = (0, $lu5k0.useModalDialogActions)();
    const handleRef = (0, $5uXOq.useCallback)((element)=>{
        if (ref) {
            if (typeof ref === 'function') ref(element);
            else {
                // We need to proxy ref to avoid an eslint error (no-param-reassign)
                const mutableRef = ref;
                mutableRef.current = element;
            }
        }
        internalRef.current = element;
    }, [
        ref
    ]);
    const isIconProp = 'icon' in props;
    const onClickHandler = !isIconProp ? props.onClick : undefined;
    const iconButtonOnClickHandler = isIconProp ? props.onClick : undefined;
    const onClick = (0, $5uXOq.useCallback)((...args)=>{
        if (!isIconProp) {
            // @ts-expect-error - Type 'HTMLElement' is missing the following properties from type 'HTMLButtonElement': disabled, form, formAction, formEnctype, and 15 more.ts(2345)
            onClickHandler?.(...args);
            setReturnFocusTo(internalRef);
        }
    }, [
        isIconProp,
        setReturnFocusTo,
        internalRef,
        onClickHandler
    ]);
    const onIconButtonClick = (0, $5uXOq.useCallback)((...args)=>{
        if (isIconProp) {
            iconButtonOnClickHandler?.(...args);
            setReturnFocusTo(internalRef);
        }
    }, [
        isIconProp,
        setReturnFocusTo,
        internalRef,
        iconButtonOnClickHandler
    ]);
    if ('icon' in props) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        ...props,
        ref: handleRef,
        onClick: onIconButtonClick
    });
    if ('theme' in props) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yOBd.default), {
        ...props,
        ref: handleRef,
        onClick: onClick
    });
    if ('isThemed' in props) {
        // TODO: this is a temporary solution to make sure themed button only exist for board
        // we should clean up this component so the types don't need to be suppressed
        // https://hello.jira.atlassian.cloud/browse/DEE-6985
        const { isThemed: isThemed, ...others } = props;
        if (isThemed) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCCtP.ThemedButtonNew), {
            ...others,
            ref: handleRef,
            onClick: onClick
        });
    }
    // @ts-expect-error - TS2322 - Type 'Props' is not assignable to type 'ButtonProps'.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        ...props,
        ref: handleRef,
        onClick: onClick
    });
});

});
parcelRegister("hCCtP", function(module, exports) {

$parcel$export(module.exports, "ThemedButtonWrapper", () => $34060b1367424582$export$269674ad0c604d30);
$parcel$export(module.exports, "ThemedButtonNew", () => $34060b1367424582$export$15536ee0f9ee7c0b);
$parcel$export(module.exports, "ThemedIconButton", () => $34060b1367424582$export$d9c2d067feb61447);
$parcel$export(module.exports, "ThemedLinkButton", () => $34060b1367424582$export$b0b5aeed52623827);
$parcel$export(module.exports, "ThemedLinkIconButton", () => $34060b1367424582$export$a1ab08e79d264ec8);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $eCeGD = parcelRequire("eCeGD");
var $42CjB = parcelRequire("42CjB");
var $1GGwS = parcelRequire("1GGwS");
var $krXdA = parcelRequire("krXdA");

var $6cG4N = parcelRequire("6cG4N");

var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");

var $lmBAt = parcelRequire("lmBAt");

const $34060b1367424582$export$269674ad0c604d30 = ({ children: children })=>(0, $lmBAt.getIsSoftwareThemingEnabled)() || (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-headers-buttons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span",
        xcss: [
            $34060b1367424582$var$overrideStyles,
            (0, $lmBAt.getIsSoftwareThemingM2Enabled)() && $34060b1367424582$var$themingM2Styles,
            (0, $4R6GH.fg)('jira_themed_button_styling_fix') && $34060b1367424582$var$wrapperStyles
        ]
    }, children) : children;
const $34060b1367424582$export$15536ee0f9ee7c0b = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($34060b1367424582$export$269674ad0c604d30, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        ...props,
        ref: ref
    }))));
const $34060b1367424582$export$d9c2d067feb61447 = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($34060b1367424582$export$269674ad0c604d30, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        ...props,
        ref: ref
    }))));
const $34060b1367424582$export$b0b5aeed52623827 = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($34060b1367424582$export$269674ad0c604d30, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1GGwS.default), {
        ...props,
        ref: ref
    }))));
const $34060b1367424582$export$a1ab08e79d264ec8 = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($34060b1367424582$export$269674ad0c604d30, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $krXdA.default), {
        ...props,
        ref: ref
    }))));
const $34060b1367424582$var$overrideStyles = (0, $8CUq3.xcss)({
    // @ts-expect-error Object literal may only specify known properties, and ''--ds-background-brand-bold'' does not exist in type 'SafeCSSObject'.ts(2353)
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-brand-bold': (0, $6cG4N.Tokens).COLOR_BACKGROUND_BRAND_BOLD,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-brand-bold-hovered': (0, $6cG4N.Tokens).COLOR_BACKGROUND_BRAND_BOLD_HOVERED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-brand-bold-pressed': (0, $6cG4N.Tokens).COLOR_BACKGROUND_BRAND_BOLD_PRESSED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-disabled': (0, $6cG4N.Tokens).COLOR_BACKGROUND_DISABLED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-selected': (0, $6cG4N.Tokens).COLOR_BACKGROUND_SELECTED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-selected-hovered': (0, $6cG4N.Tokens).COLOR_BACKGROUND_SELECTED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-selected-pressed': (0, $6cG4N.Tokens).COLOR_BACKGROUND_SELECTED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-neutral': (0, $6cG4N.Tokens).COLOR_BACKGROUND_NEUTRAL,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-neutral-hovered': (0, $6cG4N.Tokens).COLOR_BACKGROUND_NEUTRAL_HOVERED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-neutral-pressed': (0, $6cG4N.Tokens).COLOR_BACKGROUND_NEUTRAL_PRESSED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-neutral-subtle-hovered': (0, $6cG4N.Tokens).COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-neutral-subtle-pressed': (0, $6cG4N.Tokens).COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-icon-subtle': (0, $6cG4N.Tokens).COLOR_TEXT_SUBTLE,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-icon': (0, $6cG4N.Tokens).COLOR_TEXT,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-link': (0, $6cG4N.Tokens).COLOR_LINK,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-link-pressed': (0, $6cG4N.Tokens).COLOR_LINK_PRESSED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-text': (0, $6cG4N.Tokens).COLOR_TEXT_SUBTLE,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-text-disabled': (0, $6cG4N.Tokens).COLOR_TEXT_DISABLED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-text-inverse': (0, $6cG4N.Tokens).COLOR_TEXT_INVERSE,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-text-selected': (0, $6cG4N.Tokens).COLOR_TEXT_SELECTED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-text-subtle': (0, $6cG4N.Tokens).COLOR_TEXT_SUBTLE,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-border': (0, $6cG4N.Tokens).COLOR_BORDER,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-border-selected': (0, $6cG4N.Tokens).COLOR_BORDER_SELECTED
});
const $34060b1367424582$var$themingM2Styles = (0, $8CUq3.xcss)({
    // @ts-expect-error Object literal may only specify known properties, and ''--ds-background-brand-bold'' does not exist in type 'SafeCSSObject'.ts(2353)
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--project-color-link': `var(${(0, $5b25b2eb4e8be764$export$fac615ceaa871e35)}, ${"var(--ds-text, #172B4D)"})`
});
const $34060b1367424582$var$wrapperStyles = (0, $8CUq3.xcss)({
    display: 'inline-flex'
});

});
const $5b25b2eb4e8be764$export$d1b9ea3245b6a5de = 3;
const $5b25b2eb4e8be764$export$d07bba395c9390f1 = 32;
const $5b25b2eb4e8be764$export$29911ec08ab2ca2d = 5;
const $5b25b2eb4e8be764$export$b61e6f89a9db76de = 4;
const $5b25b2eb4e8be764$export$7fd2e391116c6ef5 = 9;
const $5b25b2eb4e8be764$export$e1633e494d305bfb = 'MORE';
const $5b25b2eb4e8be764$export$1cfe9795423425c = '--horizontal-navigation-color-background-neutral-hovered';
const $5b25b2eb4e8be764$export$539c074adec2188a = '--horizontal-navigation-color-link';
const $5b25b2eb4e8be764$export$6f76912df5477959 = '--horizontal-navigation-color-link-pressed';
const $5b25b2eb4e8be764$export$fac615ceaa871e35 = '--horizontal-navigation-color-text-subtle';
const $5b25b2eb4e8be764$export$7748fdcd335afdc0 = '--horizontal-navigation-color-text';
const $5b25b2eb4e8be764$export$88e550ed188132a7 = '--horizontal-navigation-color-elevation-surface';
const $5b25b2eb4e8be764$export$e2e8fadb946a45d2 = '--horizontal-navigation-color-border-selected';
const $5b25b2eb4e8be764$export$4cd72d361867c565 = '--horizontal-navigation-color-border';
const $5b25b2eb4e8be764$export$be4d7e23cb48401e = '--horizontal-navigation-color-background-neutral';
const $5b25b2eb4e8be764$export$8dd437f6d09d567 = '--horizontal-navigation-color-background-neutral-selected';
const $5b25b2eb4e8be764$export$cf26c31143daa350 = '--hn-yjlbv';
const $5b25b2eb4e8be764$export$6377a47d5e33fe0c = '--horizontal-navigation-background-selected';
const $5b25b2eb4e8be764$export$7d1315b9160d905c = '--horizontal-navigation-color-text-selected';
const $5b25b2eb4e8be764$export$b7b95e9772d9313 = '--horizontal-navigation-text-accent-selected';
const $5b25b2eb4e8be764$export$6c9f7212e806df4b = '--horizontal-navigation-color-background-input';
const $5b25b2eb4e8be764$export$7156de003aaa81f0 = '--horizontal-navigation-color-background-brand-bold';
const $5b25b2eb4e8be764$export$8993323021b69878 = '--horizontal-navigation-color-text-inverse';





parcelRegister("aehOU", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb4fb1a2ce92f0c8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $eb4fb1a2ce92f0c8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-backlog-panel.epic.epic-panel.create-issue-button.label",
        "defaultMessage": "Create {issueTypeNameLowerCase}"
    }
});

});


parcelRegister("g0bCK", function(module, exports) {

$parcel$export(module.exports, "EpicCardList", () => $7e66d89aa384a195$export$22fb79a79eb3c9b6);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $7nsd3 = parcelRequire("7nsd3");

var $8Rkzz = parcelRequire("8Rkzz");

var $hqTkp = parcelRequire("hqTkp");

var $5uJ9N = parcelRequire("5uJ9N");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");

var $ksXL1 = parcelRequire("ksXL1");

var $g4tDr = parcelRequire("g4tDr");

var $2m0b6 = parcelRequire("2m0b6");

var $88tXZ = parcelRequire("88tXZ");

var $687vG = parcelRequire("687vG");

var $guFRy = parcelRequire("guFRy");

var $1fZVH = parcelRequire("1fZVH");

var $7D59a = parcelRequire("7D59a");

var $4R6GH = parcelRequire("4R6GH");

var $dZggJ = parcelRequire("dZggJ");

var $eSUJA = parcelRequire("eSUJA");

var $9VsCL = parcelRequire("9VsCL");

var $kiGNe = parcelRequire("kiGNe");

var $6sKhR = parcelRequire("6sKhR");
const $7e66d89aa384a195$var$EpicCardRenderer = ({ epic: epic, epicIsLoading: epicIsLoading, progress: progress, estimation: estimation, index: index, epicFilters: epicFilters, isEditEnabled: isEditEnabled, selectedIssues: selectedIssues, isDropAllowed: isDropAllowed, onClick: onClick, onCardDetailClick: onCardDetailClick, onCreateIssueClick: onCreateIssueClick, onAssignEpic: onAssignEpic, setMeasure: setMeasure, setForceRemeasure: setForceRemeasure, rankEpic: rankEpic, onRefetch: onRefetch })=>{
    const autobatch = (0, $1fZVH.useAutobatch)();
    const containerRef = (0, $5uXOq.useRef)(null);
    const [isRankingEnabled] = (0, $ksXL1.useIsRankingEnabled)();
    const epicId = String(epic.id);
    const epicFilterIsActive = epicFilters.includes(epicId);
    const isLoading = (0, $4R6GH.fg)('prefetch-epics-data-backlog') ? epicIsLoading : epic.isLoading;
    const isEpicRankable = !isLoading && isEditEnabled;
    const { dragState: dragState, closestEdge: closestEdge } = (0, $6sKhR.useDragToRankEpic)({
        ref: !isRankingEnabled ? null : containerRef,
        epicId: epicId,
        index: index,
        isDropAllowed: isDropAllowed,
        rankEpic: rankEpic
    });
    const onResize = (0, $7D59a.useEvent)(()=>{
        if (containerRef.current) setForceRemeasure(containerRef.current);
    });
    /*
   * *Important note:* This must be called in this layout hook
   * because we must call it *after* DOM height has been changed.
   */ (0, $5uXOq.useLayoutEffect)(()=>{
        autobatch(()=>{
            if (containerRef.current) setMeasure(containerRef.current);
        });
    }, [
        containerRef,
        setMeasure,
        autobatch
    ]);
    (0, $2m0b6.useResizeObserver)({
        ref: containerRef,
        onResize: onResize
    });
    const content = (isDragging = false, isDragHandle = false)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kiGNe.default), {
            isLoading: isLoading,
            isDragging: isDragging,
            isDragHandle: isDragHandle,
            isActive: epicFilterIsActive,
            selectedIssues: selectedIssues,
            epic: epic,
            progress: progress,
            estimation: estimation,
            isDropAllowed: isDropAllowed,
            onClick: onClick,
            onDetailClick: onCardDetailClick,
            onCreateIssueClick: onCreateIssueClick,
            onAssignEpic: onAssignEpic,
            onRefetch: onRefetch
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7e66d89aa384a195$var$Gap, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7e66d89aa384a195$var$DraggableCard, {
        ref: containerRef,
        "data-testid": "software-backlog-panel.ui.epic.epic-panel.epic-card-list.draggable-epic-card",
        "data-cardid": epicId,
        tabIndex: isEpicRankable ? -1 : undefined
    }, content(dragState.type === 'dragging'), closestEdge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uJ9N.default), {
        edge: closestEdge
    })), dragState.type === 'dragging' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).createPortal(content(true, true), dragState.container));
};
const $7e66d89aa384a195$var$COLLAPSED_HEIGHT = 100;
const $7e66d89aa384a195$var$CARD_HEIGHTS_CACHE = new Map();
const $7e66d89aa384a195$export$22fb79a79eb3c9b6 = ({ isEditEnabled: isEditEnabled, selectedIssues: selectedIssues, onAssignEpic: onAssignEpic, onCardDetailClick: onCardDetailClick, onCreateIssueClick: onCreateIssueClick, onRefetch: onRefetch })=>{
    const [epicFilterState, { setEpicFilters: setEpicFilters }] = (0, $88tXZ.useEpicFilters)();
    const epicFilters = (0, $5uXOq.useMemo)(()=>epicFilterState || [], [
        epicFilterState
    ]);
    const [{ cards: cards, cardsWithFullDetailsLoaded: cardsWithFullDetailsLoaded, loading: loading }] = (0, $ksXL1.useEpicCardsState)();
    const { boardId: boardId, isCompanyManaged: isCompanyManaged } = (0, $eSUJA.usePanelData)();
    // At list level so objects are not created many times for each card.
    const rankEpic = (0, $6sKhR.useRankEpic)(boardId, isCompanyManaged);
    const memoizedOnCardClick = (0, $5uXOq.useCallback)((id)=>{
        const epicIdAsString = String(id);
        const epicIsActiveCurrently = epicFilters.includes(epicIdAsString);
        if (epicIsActiveCurrently) setEpicFilters((0, (/*@__PURE__*/$parcel$interopDefault($hqTkp)))(epicFilters, epicIdAsString));
        else setEpicFilters([
            ...epicFilters,
            epicIdAsString
        ]);
    }, [
        epicFilters,
        setEpicFilters
    ]);
    const isDropAllowed = (0, $5uXOq.useCallback)(()=>!selectedIssues.some((issue)=>issue?.typeHierarchyLevel === (0, $g4tDr.ISSUE_HIERARCHY_LEVEL_SUBTASK)), [
        selectedIssues
    ]);
    const cacheOptions = (0, $5uXOq.useMemo)(()=>({
            cache: $7e66d89aa384a195$var$CARD_HEIGHTS_CACHE,
            getCacheKey: (index)=>cards[index]?.epic.id ?? 'none'
        }), [
        cards
    ]);
    const { rows: rows, totalSize: totalSize, reinitialize: reinitialize } = (0, $guFRy.useVirtual)({
        rowCount: cards.length,
        overscanHeight: 300,
        offsetTop: 0,
        cacheOptions: cacheOptions,
        getDefaultRowSize: ()=>$7e66d89aa384a195$var$COLLAPSED_HEIGHT
    });
    (0, $5uXOq.useEffect)(()=>{
        reinitialize();
    // We need cards in here to make sure the card list is recalculated when things change
    }, [
        reinitialize,
        cards
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $687vG.runRecalculateSubscribers)();
    }, [
        cards
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, cards.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kiGNe.default), {
        isActive: epicFilters.includes(String((0, $dZggJ.UNASSIGNED_EPIC_ID))),
        selectedIssues: selectedIssues,
        isDropAllowed: isDropAllowed,
        epic: {
            id: (0, $dZggJ.UNASSIGNED_EPIC_ID),
            key: (0, $dZggJ.UNASSIGNED_EPIC_ISSUE_KEY),
            name: '',
            isLoading: false,
            hasError: false
        },
        progress: {
            status: {
                toDo: {
                    issueCount: 0
                },
                inProgress: {
                    issueCount: 0
                },
                done: {
                    issueCount: 0
                }
            },
            totalIssues: 0
        },
        estimation: null,
        onClick: memoizedOnCardClick,
        onCreateIssueClick: onCreateIssueClick,
        onAssignEpic: onAssignEpic,
        onRefetch: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7e66d89aa384a195$var$CardList, {
        $height: totalSize
    }, rows.length > 0 && rows.map(({ index: index, top: top, measure: measure, forceRemeasure: forceRemeasure })=>{
        const card = cards[index];
        // Check that the card actually exists
        if (!card) return null;
        const { epic: epic, progress: progress, estimation: estimation } = card;
        const epicIsLoading = !cardsWithFullDetailsLoaded.has(epic.id);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7e66d89aa384a195$var$Card, {
            top: top,
            key: `epic-card-${epic.id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7e66d89aa384a195$var$EpicCardRenderer, {
            key: epic.id,
            index: index,
            isEditEnabled: isEditEnabled,
            selectedIssues: selectedIssues,
            epicFilters: epicFilters,
            epic: epic,
            epicIsLoading: epicIsLoading,
            progress: progress,
            estimation: estimation,
            isDropAllowed: isDropAllowed,
            onClick: memoizedOnCardClick,
            onCardDetailClick: onCardDetailClick,
            onCreateIssueClick: onCreateIssueClick,
            onAssignEpic: onAssignEpic,
            onRefetch: onRefetch,
            setMeasure: measure,
            setForceRemeasure: forceRemeasure,
            rankEpic: rankEpic
        }));
    }), !loading && cards.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9VsCL.EpicEmptyState), null), loading && cards.length === 0 && (0, $4R6GH.fg)('prefetch-epics-data-backlog') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        justifyContent: "center",
        xcss: $7e66d89aa384a195$var$loadingWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "medium"
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7e66d89aa384a195$var$CardList = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { $height: $height, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_nq8i22": (0, $lD23V.default)(__cmplp.$height, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm",
            __cmplp.$height > 0 ? "_4t3i1s3s" : "_4t3i1wug",
            __cmplp.className
        ])
    });
});
const $7e66d89aa384a195$var$Card = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { top: top, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1bsv5hl": (0, $lD23V.default)(`${__cmplp.top}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1ltvze3t _154ikz78 _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $7e66d89aa384a195$var$DraggableCard = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _n3tdv77o _1o2873ad",
            __cmplp.className
        ])
    });
});
const $7e66d89aa384a195$var$Gap = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0q1chj",
            __cmplp.className
        ])
    });
});
const $7e66d89aa384a195$var$loadingWrapper = (0, $8CUq3.xcss)({
    paddingBlock: 'space.600'
});

});
parcelRegister("5uJ9N", function(module, exports) {

$parcel$export(module.exports, "DropIndicator", () => $057503bea847bf4c$export$62ed72bc21f6b8a6);
$parcel$export(module.exports, "default", () => $057503bea847bf4c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $40bhS = parcelRequire("40bhS");

var $choBO = parcelRequire("choBO");
function $057503bea847bf4c$export$62ed72bc21f6b8a6({ appearance: appearance = 'default', edge: edge, gap: gap, indent: indent, type: type }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $40bhS.Line), {
        edge: edge,
        gap: gap,
        strokeColor: (0, $choBO.presetStrokeColors)[appearance],
        type: type,
        indent: indent
    });
}
var // This default export is intended for usage with React.lazy
$057503bea847bf4c$export$2e2bcd8739ae039 = $057503bea847bf4c$export$62ed72bc21f6b8a6;

});
parcelRegister("40bhS", function(module, exports) {

$parcel$export(module.exports, "Line", () => $5554523a258e458d$export$17d680238e50603e);
/* line.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $choBO = parcelRequire("choBO");
const $5554523a258e458d$var$edgeToOrientationMap = {
    top: 'horizontal',
    bottom: 'horizontal',
    left: 'vertical',
    right: 'vertical'
};
const $5554523a258e458d$var$baseStyles = {
    root: "_1e0c1ule _kqswstnw _1pbykb7n _lcxvglyw _bfhkys7w _rfx31ssb _3l8810ly _kzdanqa1 _15m6ys7w _cfu11ld9 _1kt9b3bt _1cs8stnw _13y0usvi _1mp4vjfa _kfgtvjfa"
};
const $5554523a258e458d$var$orientationStyles = {
    horizontal: "_4t3i10ly _1e02fghn _rjxpidpf _z5wtuj5p",
    vertical: "_1bsb10ly _154ifghn _94n5idpf _1aukuj5p"
};
const $5554523a258e458d$var$edgeStyles = {
    top: "_154ihv0e _1auk70hn",
    right: "_1xi2hv0e _ooun70hn",
    bottom: "_94n5hv0e _19wo70hn",
    left: "_1ltvhv0e _qnec70hn"
};
const $5554523a258e458d$var$lineStartFrom = {
    // - half the terminal bleeding out the containing element
    // - half the terminal inside the containing element (we need to position the line next to this)
    terminal: ({ indent: indent })=>`calc(var(--terminal-radius) + ${indent})`,
    // The full terminal is inside the containing element (we need to position the line next to this)
    'terminal-no-bleed': ({ indent: indent })=>`calc(var(--terminal-diameter) + ${indent})`,
    // No terminal to worry about, line should take up all the space
    'no-terminal': ({ indent: indent })=>indent
};
function $5554523a258e458d$export$17d680238e50603e({ edge: edge, gap: gap = '0px', indent: indent = '0px', strokeColor: strokeColor = (0, $choBO.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $choBO.presetStrokeWidth), type: type = 'terminal' }) {
    const orientation = $5554523a258e458d$var$edgeToOrientationMap[edge];
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            // ## All
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            // Shift line and terminal on the main access to account for gaps between items
            '--main-axis-offset': `calc(-0.5 * (${gap} + var(--stroke-width)))`,
            // ## Line
            // If there is a terminal, we want the line to start from next to it
            '--line-main-axis-start': $5554523a258e458d$var$lineStartFrom[type]({
                indent: indent
            }),
            // ## Terminal
            '--terminal-display': type === 'no-terminal' ? 'none' : 'block',
            '--terminal-diameter': 'calc(var(--stroke-width) * 4)',
            '--terminal-radius': 'calc(var(--terminal-diameter) / 2)',
            // The line is positioned to account for the the terminal (--line-main-axis-start).
            // The terminal is rendered relative to the line (it's a `::before`)
            // We need to pull the terminal backwards so it sits before the start of the line
            '--terminal-main-axis-start': 'calc(-1 * var(--terminal-diameter))',
            // Pull the terminal backwards on the cross axis (eg "up" on "vertical")
            // so the center of the terminal lines up with the center of the line
            '--terminal-cross-axis-offset': 'calc(calc(var(--stroke-width) - var(--terminal-diameter)) / 2)'
        },
        className: (0, $bwpsq.default)([
            $5554523a258e458d$var$baseStyles.root,
            $5554523a258e458d$var$orientationStyles[orientation],
            $5554523a258e458d$var$edgeStyles[edge]
        ])
    });
}
var // For React.lazy
$5554523a258e458d$export$2e2bcd8739ae039 = $5554523a258e458d$export$17d680238e50603e;

});
parcelRegister("choBO", function(module, exports) {

$parcel$export(module.exports, "presetStrokeColors", () => $9f99301ec58274c5$export$477fafec326bfca0);
$parcel$export(module.exports, "presetStrokeWidth", () => $9f99301ec58274c5$export$45db03aa04b685e3);
const $9f99301ec58274c5$export$477fafec326bfca0 = {
    default: "var(--ds-border-selected, #0C66E4)",
    warning: "var(--ds-border-warning, #E56910)"
};
const $9f99301ec58274c5$export$45db03aa04b685e3 = "var(--ds-border-width-outline, 2px)";

});



parcelRegister("2m0b6", function(module, exports) {

$parcel$export(module.exports, "createResizeObserverHook", () => $072291c9ed048772$export$87a9d3e287304ae4);
$parcel$export(module.exports, "useResizeObserver", () => $072291c9ed048772$export$683480f191c0e3ea);
$parcel$export(module.exports, "flushResizeObservers", () => $072291c9ed048772$export$a181ef2a6d0a1bb6);
$parcel$export(module.exports, "useRectObserver", () => $072291c9ed048772$export$e58143dc89297272);

var $5uXOq = parcelRequire("5uXOq");

var $eUdQc = parcelRequire("eUdQc");
function $072291c9ed048772$export$87a9d3e287304ae4(params) {
    const group = new (0, $eUdQc.ResizeObserverGroup)(params?.debouncePeriod);
    /**
	 * This hook uses a shared ResizeObserver instance.
	 *
	 * When a resize notification comes in, a single batched React update will be
	 * dispatched after a debounce period only for the elements that have been
	 * resized.
	 *
	 * This does NOT react to updates to REF
	 */ function useResizeObserver({ ref: ref, onResize: onResize }) {
        const onResizeRef = (0, $5uXOq.useRef)(onResize);
        (0, $5uXOq.useEffect)(()=>{
            onResizeRef.current = onResize;
        });
        const stableOnResize = (0, $5uXOq.useCallback)(()=>onResizeRef.current(), []);
        (0, $5uXOq.useLayoutEffect)(()=>group.observe(ref, stableOnResize), [
            ref,
            stableOnResize
        ]);
    }
    return {
        useResizeObserver: useResizeObserver,
        flushResizeObservers: ()=>group.flush()
    };
}
const { useResizeObserver: $072291c9ed048772$export$683480f191c0e3ea, flushResizeObservers: $072291c9ed048772$export$a181ef2a6d0a1bb6 } = $072291c9ed048772$export$87a9d3e287304ae4();
function $072291c9ed048772$export$e58143dc89297272({ ref: ref, useResizeObserverDI: useResizeObserverDI = $072291c9ed048772$export$683480f191c0e3ea }) {
    const [rect, setRect] = (0, $5uXOq.useState)(null);
    const onResize = ()=>{
        if (ref.current) setRect(ref.current.getBoundingClientRect());
    };
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!ref.current) throw new Error([
            'useRectObserver: ref is not available on mount.',
            'This means you are attaching refs conditionally onto your elements, for example in with an early return.',
            'This will not work properly. Please update your code so that refs are always attached to components on mount.'
        ].join('\n'));
        setRect(ref.current.getBoundingClientRect());
    }, [
        ref
    ]);
    useResizeObserverDI({
        ref: ref,
        onResize: onResize
    });
    return rect;
}

});
parcelRegister("eUdQc", function(module, exports) {

$parcel$export(module.exports, "ResizeObserverGroup", () => $52e6ab4254804b44$export$607798bbe2869c0);

var $7nsd3 = parcelRequire("7nsd3");

var $lFKmC = parcelRequire("lFKmC");
class $52e6ab4254804b44$export$607798bbe2869c0 {
    constructor(debouncePeriod = 16){
        this.subscribers = new Map();
        this.pendingUpdates = new Map();
        this.onResize = (entries)=>{
            entries.forEach((entry)=>{
                const subscriber = this.subscribers.get(entry.target);
                if (subscriber) this.pendingUpdates.set(subscriber.element, subscriber);
            });
            this.scheduleFlush();
        };
        this.observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(this.onResize) : null;
        this.scheduleFlush = debouncePeriod > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(()=>{
            this.flush();
        }, debouncePeriod, {
            trailing: true,
            maxWait: 32
        }) : ()=>{
            this.flush();
        };
    }
    observe(ref, callback) {
        if (!ref.current) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        this.subscribers.set(ref.current, {
            element: ref.current,
            callback: callback
        });
        this.observer?.observe(ref.current);
        return ()=>{
            if (!ref.current) return;
            this.subscribers.delete(ref.current);
            this.pendingUpdates.delete(ref.current);
            this.observer?.unobserve(ref.current);
        };
    }
    flush() {
        const entries = Array.from(this.pendingUpdates.values()).filter((entry)=>this.subscribers.has(entry.element));
        this.pendingUpdates.clear();
        (0, $7nsd3.unstable_batchedUpdates)(()=>{
            entries.forEach(({ callback: callback })=>{
                callback();
            });
        });
    }
}

});


parcelRegister("687vG", function(module, exports) {

$parcel$export(module.exports, "runRecalculateSubscribers", () => $c63364c275b5d8f7$export$c385874db128c328);
$parcel$export(module.exports, "useElementOffset", () => $c63364c275b5d8f7$export$35f58fcda6094144);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $lFKmC = parcelRequire("lFKmC");

var $iASWI = parcelRequire("iASWI");

var $9Ik53 = parcelRequire("9Ik53");
const $c63364c275b5d8f7$var$MINIMUM_OFFSET_DIFF = 0.05;
const $c63364c275b5d8f7$export$658605f405ffebd5 = new Set();
const $c63364c275b5d8f7$export$c385874db128c328 = ()=>{
    const recalculateSubscribersArr = Array.from($c63364c275b5d8f7$export$658605f405ffebd5);
    const changes = recalculateSubscribersArr.map((subscriber)=>({
            newOffsetTop: subscriber.measureOffsetTop(),
            subscriber: subscriber
        })).filter(({ subscriber: subscriber, newOffsetTop: newOffsetTop })=>Math.abs((subscriber.offsetTopRef.current ?? 0) - newOffsetTop) > $c63364c275b5d8f7$var$MINIMUM_OFFSET_DIFF);
    if (!changes.length) return 0;
    (0, $7nsd3.unstable_batchedUpdates)(()=>{
        changes.forEach(({ subscriber: subscriber, newOffsetTop: newOffsetTop })=>{
            subscriber.onChange(newOffsetTop);
        });
    });
    return changes.length;
};
// Debounced version of the call used because during DND, the ResizeObserver can
// crash due to being triggered too much
const $c63364c275b5d8f7$var$debouncedRunRecalculateSubscribers = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))($c63364c275b5d8f7$export$c385874db128c328, 50);
let $c63364c275b5d8f7$var$resizeObserver = null;
if (typeof ResizeObserver !== 'undefined') $c63364c275b5d8f7$var$resizeObserver = new ResizeObserver($c63364c275b5d8f7$var$debouncedRunRecalculateSubscribers);
let $c63364c275b5d8f7$var$intersectionObserver = null;
if (typeof IntersectionObserver !== 'undefined') $c63364c275b5d8f7$var$intersectionObserver = new IntersectionObserver($c63364c275b5d8f7$export$c385874db128c328, {
    // Will fire every 1/5000 size visibility change.
    // A list with more than 5000 rows will fail to detect single row
    // changes.
    // A list with 5000 rows will only detect 1 row shifts at a time.
    threshold: (0, (/*@__PURE__*/$parcel$interopDefault($iASWI)))(5000).map((i, _, arr)=>i / arr.length)
});
function $c63364c275b5d8f7$export$99c4e73123d23bda({ initialOffset: initialOffset, ref: ref }) {
    const [offsetTop, setOffsetTop] = (0, $5uXOq.useState)(initialOffset);
    const previousOffsetTopRef = (0, $5uXOq.useRef)(initialOffset);
    const { scrollElement: scrollElement } = (0, $9Ik53.useScrollState)();
    (0, $5uXOq.useEffect)(()=>{
        const el = ref.current;
        if (!el) throw new Error('Invariant failed, observed element is null on mount');
        const onChange = (size)=>{
            setOffsetTop(size);
            previousOffsetTopRef.current = size;
        };
        const measureOffsetTop = ()=>{
            if (!el || !scrollElement) return previousOffsetTopRef.current;
            // scrollElement defaults to Window.
            // This default value is normally only seen in Storybook.
            if (scrollElement instanceof Window || // FIXME JIV-14148 - unclear behavior in Storybook mount strict - Window is not Window
            !scrollElement.getBoundingClientRect) return 0;
            return el.getBoundingClientRect().top - scrollElement.getBoundingClientRect().top + scrollElement.scrollTop;
        };
        onChange(measureOffsetTop());
        const recalculateGroup = {
            measureOffsetTop: measureOffsetTop,
            onChange: onChange,
            offsetTop: previousOffsetTopRef.current,
            offsetTopRef: previousOffsetTopRef
        };
        $c63364c275b5d8f7$export$658605f405ffebd5.add(recalculateGroup);
        $c63364c275b5d8f7$var$resizeObserver?.observe(el);
        $c63364c275b5d8f7$var$intersectionObserver?.observe(el);
        const onResize = ()=>{
            $c63364c275b5d8f7$var$debouncedRunRecalculateSubscribers();
        };
        if ($c63364c275b5d8f7$export$658605f405ffebd5.size === 1) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('resize', onResize);
        return ()=>{
            $c63364c275b5d8f7$export$658605f405ffebd5.delete(recalculateGroup);
            $c63364c275b5d8f7$var$resizeObserver?.unobserve(el);
            $c63364c275b5d8f7$var$intersectionObserver?.unobserve(el);
            if ($c63364c275b5d8f7$export$658605f405ffebd5.size === 0) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('resize', onResize);
            // Fire once when we clean this up since when we unmount an element we also
            // want to trigger the callback (e.g. removing a column or cardlist)
            $c63364c275b5d8f7$var$debouncedRunRecalculateSubscribers();
        };
    }, [
        ref,
        scrollElement
    ]);
    return offsetTop;
}
function $c63364c275b5d8f7$export$35f58fcda6094144({ initialOffset: initialOffset }) {
    const ref = (0, $5uXOq.useRef)(null);
    const offsetTop = $c63364c275b5d8f7$export$99c4e73123d23bda({
        initialOffset: initialOffset,
        ref: ref
    });
    return {
        ref: ref,
        offsetTop: offsetTop
    };
}

});

parcelRegister("guFRy", function(module, exports) {

$parcel$export(module.exports, "useVirtual", () => $8a37cce55cc85701$export$ebc1863da693699a);

var $5uXOq = parcelRequire("5uXOq");

var $gccSB = parcelRequire("gccSB");

var $hGgHi = parcelRequire("hGgHi");

var $itWjr = parcelRequire("itWjr");

var $9Ik53 = parcelRequire("9Ik53");

var $2PIRw = parcelRequire("2PIRw");
const $8a37cce55cc85701$export$c61d420d8ad72523 = (rowCount, offsetTop, getDefaultRowSize, cacheOptions)=>{
    const states = new Array(rowCount);
    let currentTop = offsetTop;
    for(let i = 0; i < rowCount; i += 1){
        const height = cacheOptions?.cache.get(cacheOptions.getCacheKey(i))?.height ?? getDefaultRowSize(i);
        const result = {
            height: height,
            top: currentTop,
            bottom: currentTop + height
        };
        currentTop = result.bottom;
        states[i] = result;
    }
    return states;
};
const $8a37cce55cc85701$var$MINIMUM_CARD_HEIGHT = 0.05;
function $8a37cce55cc85701$export$fd7df3dcf242e12a({ cacheOptions: cacheOptions, index: index, rowStates: rowStates, setRowHeight: setRowHeight, isVisible: isVisible }) {
    const forceRemeasure = (el, withCache = false)=>{
        if (!el) return;
        if (withCache && cacheOptions?.cache?.has(cacheOptions.getCacheKey(index))) return;
        const { height: height } = el.getBoundingClientRect();
        const roundedHeight = Math.round(height * 100) / 100;
        // TODO: React DnD will set row height to 0 on pick-up, that update must be ignored.
        // This is not a clean solution.
        if (roundedHeight > $8a37cce55cc85701$var$MINIMUM_CARD_HEIGHT && cacheOptions) {
            const cacheKey = cacheOptions.getCacheKey(index);
            if (cacheKey !== undefined) cacheOptions.cache.set(cacheKey, {
                height: height
            });
        }
        if (height != null && height > $8a37cce55cc85701$var$MINIMUM_CARD_HEIGHT && rowStates[index].height !== height) setRowHeight(index, height);
    };
    return {
        key: index,
        index: index,
        top: rowStates[index].top,
        isVisible: isVisible,
        measure (el) {
            forceRemeasure(el, true);
        },
        forceRemeasure: forceRemeasure
    };
}
const $8a37cce55cc85701$var$EMPTY_ROW_DESCRIPTOR = [];
function $8a37cce55cc85701$export$824e0ab10a990d7b({ start: start, end: end, rowStates: rowStates, cacheOptions: cacheOptions, setRowHeight: setRowHeight, startVisible: startVisible, endVisible: endVisible }) {
    if (start === end) return $8a37cce55cc85701$var$EMPTY_ROW_DESCRIPTOR;
    const numRows = end - start;
    // This code is structured in a way that allows it to be changed into stable indexes and support element recycling.
    const result = new Array(Math.max(numRows, 0));
    for(let offset = 0; offset < numRows; offset += 1){
        const index = start + offset;
        const isVisible = index >= startVisible && index <= endVisible;
        result[offset] = $8a37cce55cc85701$export$fd7df3dcf242e12a({
            cacheOptions: cacheOptions,
            index: index,
            rowStates: rowStates,
            setRowHeight: setRowHeight,
            isVisible: isVisible
        });
    }
    return result;
}
function $8a37cce55cc85701$var$useRows(scrollState, rowStates, // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
cacheOptions, setRowHeight, overscanHeight) {
    const { start: start, end: end } = (0, $5uXOq.useMemo)(()=>(0, $itWjr.getRenderedRange)(scrollState, rowStates, overscanHeight), [
        scrollState,
        rowStates,
        overscanHeight
    ]);
    const { start: startVisible, end: endVisible } = (0, $5uXOq.useMemo)(()=>(0, $itWjr.getRenderedRange)(scrollState, rowStates, 0), [
        scrollState,
        rowStates
    ]);
    return (0, $5uXOq.useMemo)(()=>$8a37cce55cc85701$export$824e0ab10a990d7b({
            start: start,
            end: end,
            rowStates: rowStates,
            cacheOptions: cacheOptions,
            setRowHeight: setRowHeight,
            startVisible: startVisible,
            endVisible: endVisible
        }), [
        start,
        end,
        rowStates,
        cacheOptions,
        setRowHeight,
        startVisible,
        endVisible
    ]);
}
function $8a37cce55cc85701$export$ebc1863da693699a({ rowCount: rowCount, getDefaultRowSize: getDefaultRowSize, offsetTop: offsetTop = 0, overscanHeight: overscanHeight = 0, cacheOptions: cacheOptions, version: version }) {
    const scrollState = (0, $9Ik53.useScrollState)();
    const [rowStates, setRowStates] = (0, $5uXOq.useState)(()=>$8a37cce55cc85701$export$c61d420d8ad72523(rowCount, offsetTop, getDefaultRowSize, cacheOptions));
    const reinitialize = ()=>setRowStates($8a37cce55cc85701$export$c61d420d8ad72523(rowCount, offsetTop, getDefaultRowSize, cacheOptions));
    const reinitializeRef = (0, $5uXOq.useRef)(reinitialize);
    reinitializeRef.current = reinitialize;
    const reinitializeCb = (0, $5uXOq.useCallback)(()=>reinitializeRef.current(), []);
    const lastOffsetTop = (0, $5uXOq.useRef)(null);
    const lastVersion = (0, $5uXOq.useRef)(null);
    /**
	 * checking rowCount, offsetTop and version to rebuild the rowStates
	 * if the version is undefined, null or empty string, it will not be used
	 */ const shouldRebuildRowStates = rowCount !== rowStates.length || offsetTop !== lastOffsetTop.current || !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(version) && !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(version) && version !== lastVersion.current;
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (shouldRebuildRowStates) {
            lastVersion.current = version;
            lastOffsetTop.current = offsetTop;
            const states = $8a37cce55cc85701$export$c61d420d8ad72523(rowCount, offsetTop, getDefaultRowSize, cacheOptions);
            setRowStates(states);
        }
    }, [
        rowStates,
        rowCount,
        offsetTop,
        cacheOptions,
        getDefaultRowSize,
        shouldRebuildRowStates,
        version
    ]);
    const scrollTo = (0, $2PIRw.useScrollTo)(rowStates);
    const setRowHeight = (0, $5uXOq.useCallback)((row, height)=>{
        setRowStates((currentRowStates)=>{
            let currentTop = offsetTop;
            return currentRowStates.map((state, index)=>{
                const newState = {
                    ...state
                };
                if (index === row) newState.height = height;
                newState.top = currentTop;
                newState.bottom = currentTop + newState.height;
                currentTop = newState.bottom;
                return newState;
            });
        });
    }, [
        offsetTop
    ]);
    const totalSize = (0, $5uXOq.useMemo)(()=>{
        let sum = 0;
        rowStates.forEach(({ height: height })=>{
            sum += height; // This is a float
        });
        // We don't want to end up with a totalSize that is floating point. It results in the
        // ResizeObserver in useElementOffset triggering for pixel changes below 1px
        return Math.ceil(sum);
    }, [
        rowStates
    ]);
    const rows = $8a37cce55cc85701$var$useRows(scrollState, rowStates, cacheOptions, setRowHeight, overscanHeight);
    return (0, $5uXOq.useMemo)(()=>({
            rows: rows,
            rowStates: rowStates,
            scrollTo: scrollTo,
            totalSize: totalSize,
            isScrolling: scrollState.isScrolling,
            reinitialize: reinitializeCb
        }), [
        rows,
        rowStates,
        scrollTo,
        totalSize,
        scrollState.isScrolling,
        reinitializeCb
    ]);
}

});
parcelRegister("itWjr", function(module, exports) {

$parcel$export(module.exports, "getRenderedRange", () => $cbe28e6cb7ea4dcb$export$303e1fc2567e8469);
/**
 * Binary search for the nearest value to a `needle`, given high and low indexes
 * and a `getValue` function to get the value at a certain index.
 */ const $cbe28e6cb7ea4dcb$export$b961f15adda64c7b = (lowIndexDontRead, highIndexDontRead, getValue, needle)=>{
    // JFE linting doesn't allow changing the arg as a local.
    let low = lowIndexDontRead;
    let high = highIndexDontRead;
    while(low < high){
        const middleIndex = Math.floor((high + low) / 2);
        const candidate = getValue(middleIndex);
        if (candidate > needle) high = middleIndex - 1;
        else if (candidate < needle) low = middleIndex + 1;
        else return middleIndex;
    }
    return low;
};
const $cbe28e6cb7ea4dcb$export$303e1fc2567e8469 = (viewportRectangle, rowPositions, overscanHeight)=>{
    if (rowPositions.length === 0) return {
        start: 0,
        end: 0
    };
    // Render elements starting at the top edge of the scroll container, minus
    // some overscan height.
    const startPositionTop = viewportRectangle.scrollTop - overscanHeight;
    // And up to elements at the bottom edge of the scroll container, plus some
    // overscan height.
    // NOTE: This needs to default to 0 otherwise it is NaN which means that isAbove is true.
    const endPositionTop = (viewportRectangle?.scrollTop ?? 0) + (viewportRectangle?.height ?? 0) + overscanHeight;
    // If the viewport fully above or under the rows, render nothing
    const isAbove = endPositionTop < rowPositions[0].top;
    const isUnder = startPositionTop > rowPositions[rowPositions.length - 1].bottom;
    if (isAbove || isUnder) return {
        start: 0,
        end: 0
    };
    const startIndex = $cbe28e6cb7ea4dcb$export$b961f15adda64c7b(0, rowPositions.length, (i)=>rowPositions[i].bottom, startPositionTop);
    let endIndex = startIndex;
    while(endIndex < rowPositions.length && rowPositions[endIndex].top <= endPositionTop)endIndex += 1;
    return {
        start: startIndex,
        end: endIndex
    };
};

});

parcelRegister("2PIRw", function(module, exports) {

$parcel$export(module.exports, "useScrollTo", () => $6575a25f747838db$export$d774db9fe736aa73);

var $5uXOq = parcelRequire("5uXOq");

var $9Ik53 = parcelRequire("9Ik53");

var $kTgNN = parcelRequire("kTgNN");
const $6575a25f747838db$export$e1700fccdc2280c5 = 80;
const $6575a25f747838db$var$SCROLLING_INTERVAL = 50;
const $6575a25f747838db$var$SCROLLING_ATTEMPT = 5;
const $6575a25f747838db$export$d774db9fe736aa73 = (rowStates)=>{
    // scrollState CONSTANTLY changes
    // Just grabbing out the scrollElement will hardly change
    const { scrollElement: scrollElement } = (0, $9Ik53.useScrollState)();
    // We do NOT want to regenerate the return function everytime so we should use REFs
    // here instead
    const scrollElementRef = (0, $5uXOq.useRef)(null);
    const rowStatesRef = (0, $5uXOq.useRef)([]);
    (0, $5uXOq.useEffect)(()=>{
        // Only bind to the scrollElementRef once. We don't need it anymore once we have it
        if (scrollElementRef.current === null && scrollElement) scrollElementRef.current = scrollElement;
        // Always ensure our rowStates ref is up to date
        rowStatesRef.current = rowStates ?? rowStatesRef.current;
    }, [
        rowStates,
        scrollElement
    ]);
    const scrollTo = (0, $5uXOq.useCallback)((index, options, attempt = 1)=>{
        let timeoutId = null;
        // Early termination for invalid data
        if (index === -1 || attempt > $6575a25f747838db$var$SCROLLING_ATTEMPT) {
            options?.onComplete?.();
            return;
        }
        if (rowStatesRef?.current == null || // Can be null on first pass
        scrollElementRef?.current == null || // Can be null on first pass
        index >= rowStatesRef.current.length) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            timeoutId = window.setTimeout(()=>{
                scrollTo(index, options, attempt + 1);
            }, $6575a25f747838db$var$SCROLLING_INTERVAL);
            return ()=>{
                timeoutId && clearTimeout(timeoutId);
            };
        }
        const scrollElementEl = scrollElementRef.current;
        const rowState = rowStatesRef.current;
        // Complete scrolling when the target is on screen.
        if ((0, $kTgNN.hasScrolledIntoView)(scrollElementRef.current, rowStatesRef.current[index])) {
            options?.onComplete?.();
            return;
        }
        const scrollToPosition = (0, $kTgNN.getScrollToPosition)(scrollElementEl, rowState[index], options);
        if (options?.immediate) scrollElementEl.scrollTop = scrollToPosition;
        else scrollElementEl.scrollTo({
            top: scrollToPosition,
            behavior: 'smooth'
        });
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        timeoutId = window.setTimeout(()=>scrollTo(index, options, attempt + 1), $6575a25f747838db$var$SCROLLING_INTERVAL);
        return ()=>{
            timeoutId && clearTimeout(timeoutId);
        };
    }, [
        scrollElementRef,
        rowStatesRef
    ]);
    return scrollTo;
};

});
parcelRegister("kTgNN", function(module, exports) {

$parcel$export(module.exports, "hasScrolledIntoView", () => $abb1a9602db1b1f8$export$6ced3bc78dcece56);
$parcel$export(module.exports, "getScrollToPosition", () => $abb1a9602db1b1f8$export$dfe56cb366876f29);
const $abb1a9602db1b1f8$var$VIEWPORT_BUFFER = 50;
const $abb1a9602db1b1f8$export$6ced3bc78dcece56 = (scrollElementEl, rowState)=>{
    if (!scrollElementEl || !rowState) return false;
    const topOfRow = rowState.top;
    const bottomOfRow = rowState.top + rowState.height;
    // Make the viewport a bit smaller so the card won't stick to the edge of the screen
    const topOfView = scrollElementEl.scrollTop + $abb1a9602db1b1f8$var$VIEWPORT_BUFFER;
    const bottomOfView = scrollElementEl.scrollTop + scrollElementEl.clientHeight - $abb1a9602db1b1f8$var$VIEWPORT_BUFFER;
    return topOfRow > topOfView && topOfRow < bottomOfView || bottomOfRow > topOfView && bottomOfRow < bottomOfView || topOfRow < topOfView && bottomOfRow > bottomOfView;
};
const $abb1a9602db1b1f8$export$dfe56cb366876f29 = (scrollElementEl, rowState, options)=>{
    if (!scrollElementEl || !rowState) return 0;
    if (options?.hasVirtualisedChildren) return rowState.top - scrollElementEl.clientHeight;
    return rowState.top + rowState.height / 2 - scrollElementEl.clientHeight / 3;
};

});



parcelRegister("1fZVH", function(module, exports) {

$parcel$export(module.exports, "autobatch", () => $befa27b0681ab6bc$export$46f5568dd7916109);
$parcel$export(module.exports, "useAutobatch", () => $befa27b0681ab6bc$export$5b8ae94abd7adcf);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $4R6GH = parcelRequire("4R6GH");
const $befa27b0681ab6bc$var$queue = new Set();
let $befa27b0681ab6bc$var$hasQueuedFlush = false;
function $befa27b0681ab6bc$var$flush() {
    const tasks = Array.from($befa27b0681ab6bc$var$queue);
    $befa27b0681ab6bc$var$queue.clear();
    (0, $7nsd3.unstable_batchedUpdates)(()=>{
        tasks.forEach((task)=>{
            task();
        });
    });
}
function $befa27b0681ab6bc$export$46f5568dd7916109(task) {
    $befa27b0681ab6bc$var$queue.add(task);
    if (!$befa27b0681ab6bc$var$hasQueuedFlush) {
        $befa27b0681ab6bc$var$hasQueuedFlush = true;
        queueMicrotask(()=>{
            $befa27b0681ab6bc$var$hasQueuedFlush = false;
            $befa27b0681ab6bc$var$flush();
        });
    }
    return ()=>{
        $befa27b0681ab6bc$var$queue.delete(task);
    };
}
function $befa27b0681ab6bc$export$5b8ae94abd7adcf() {
    if (!(0, $4R6GH.fg)('jsw_backlog_pragmatic_dnd_automatic_batching')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $5uXOq.useCallback)((task)=>task(), []);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const cancelFunctions = (0, $5uXOq.useRef)([]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const batchingFunction = (0, $5uXOq.useCallback)((task)=>{
        const cancel = $befa27b0681ab6bc$export$46f5568dd7916109(task);
        cancelFunctions.current.push(cancel);
    }, []);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>()=>{
            cancelFunctions.current.forEach((cancel)=>{
                cancel();
            });
        }, []);
    return batchingFunction;
}

});

parcelRegister("9VsCL", function(module, exports) {

$parcel$export(module.exports, "EpicEmptyState", () => $73fd00415221a0f7$export$27ae7178aa376138);

var $5uXOq = parcelRequire("5uXOq");

var $ksXL1 = parcelRequire("ksXL1");

var $6s1PB = parcelRequire("6s1PB");

var $dNCp9 = parcelRequire("dNCp9");

var $8lD2Q = parcelRequire("8lD2Q");

var $koVbs = parcelRequire("koVbs");

var $dZggJ = parcelRequire("dZggJ");

var $d6MNE = parcelRequire("d6MNE");

var $i3jYV = parcelRequire("i3jYV");
const $73fd00415221a0f7$export$27ae7178aa376138 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [epicIssueTypeName] = (0, $ksXL1.useEpicIssueTypeName)();
    const issueTypeName = epicIssueTypeName && epicIssueTypeName !== (0, $dZggJ.DEFAULT_PARENT_ISSUE_TYPE_NAME) ? epicIssueTypeName : (0, $dZggJ.DEFAULT_PARENT_ISSUE_TYPE_NAME).toLowerCase();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d6MNE.default), {
        image: {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($dNCp9)))
        },
        Illustration: (0, $8lD2Q.default),
        messages: [
            formatMessage((0, $i3jYV.default).information),
            formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $i3jYV.default).suggestionIssueTermRefresh : (0, $i3jYV.default).suggestion, {
                epicIssueTypeName: issueTypeName
            })
        ]
    });
};

});
parcelRegister("dNCp9", function(module, exports) {
module.exports = new URL("empty-state-growth-sprout.36bafc1e.svg", import.meta.url).toString();

});

parcelRegister("8lD2Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3a0a62c87310572$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $tLAyE = parcelRequire("tLAyE");

var $2fngB = parcelRequire("2fngB");
const $e3a0a62c87310572$var$Illustration = (0, $dCLgq.createIllustration)({
    srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($tLAyE))),
    srcLight: (0, (/*@__PURE__*/$parcel$interopDefault($2fngB)))
});
var $e3a0a62c87310572$export$2e2bcd8739ae039 = $e3a0a62c87310572$var$Illustration;
const $e3a0a62c87310572$export$87ec2877821a8f12 = (0, (/*@__PURE__*/$parcel$interopDefault($tLAyE)));
const $e3a0a62c87310572$export$abdf1e325e38b834 = (0, (/*@__PURE__*/$parcel$interopDefault($2fngB)));

});
parcelRegister("tLAyE", function(module, exports) {
module.exports = new URL("toolbox-darkmode.b2678524.svg", import.meta.url).toString();

});

parcelRegister("2fngB", function(module, exports) {
module.exports = new URL("toolbox.d2bfa8dc.svg", import.meta.url).toString();

});


parcelRegister("d6MNE", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bcb7ac55669ed57$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $gwIPs = parcelRequire("gwIPs");

var $8zOmE = parcelRequire("8zOmE");

var $dCm1o = parcelRequire("dCm1o");
const $8bcb7ac55669ed57$export$fddf379e22a74b00 = ({ image: { src: src }, messages: messages, learnMore: learnMore, Illustration: Illustration })=>{
    const onClick = (event, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'learnMoreLink');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8bcb7ac55669ed57$var$Container, null, Illustration && (0, $dCm1o.isVisualRefreshEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Illustration, {
        height: (0, $gwIPs.gridSize) * 10,
        width: (0, $gwIPs.gridSize) * 10,
        alt: "",
        testId: "software-backlog-panel.common.ui.panel.empty-state.illustration"
    }), (!Illustration || !(0, $dCm1o.isVisualRefreshEnabled)()) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        "data-testid": "software-backlog-panel.common.ui.panel.empty-state.illustration",
        src: src,
        height: (0, $gwIPs.gridSize) * 10,
        width: (0, $gwIPs.gridSize) * 10,
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8bcb7ac55669ed57$var$Messages, null, messages.map((message, index)=>// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", {
            key: index
        }, message))), learnMore && // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        testId: "software-backlog-panel.common.ui.panel.empty-state.button",
        appearance: "link",
        href: learnMore.url,
        target: "_blank",
        onClick: onClick
    }, learnMore.message)));
};
var $8bcb7ac55669ed57$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($8bcb7ac55669ed57$export$fddf379e22a74b00);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8bcb7ac55669ed57$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _19pkoahv _2hwxpxbi _otyrxncg _18u0pxbi",
            __cmplp.className
        ])
    });
});
const $8bcb7ac55669ed57$var$Messages = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _19pkxy5q _y3gn1h6o _syaz131l",
            __cmplp.className
        ])
    });
});

});

parcelRegister("i3jYV", function(module, exports) {

$parcel$export(module.exports, "default", () => $686c8e8becdc876c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $686c8e8becdc876c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    information: {
        "id": "software-backlog-panel.epic.epic-panel.epic-card-list.empty-state.information",
        "defaultMessage": "Plan and prioritize large chunks of work."
    },
    suggestion: {
        "id": "software-backlog-panel.epic.epic-panel.epic-card-list.empty-state.suggestion",
        "defaultMessage": "Create your first {epicIssueTypeName} to start capturing and breaking down work for your team."
    },
    suggestionIssueTermRefresh: {
        "id": "software-backlog-panel.epic.epic-panel.epic-card-list.empty-state.suggestion-issue-term-refresh",
        "defaultMessage": "Create your first {epicIssueTypeName} to start capturing and breaking down work for your team."
    }
});

});


parcelRegister("kiGNe", function(module, exports) {

$parcel$export(module.exports, "default", () => $b45b1d82e2e12a16$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $8Rkzz = parcelRequire("8Rkzz");

var $jAy2o = parcelRequire("jAy2o");

var $MHKc7 = parcelRequire("MHKc7");

var $ksXL1 = parcelRequire("ksXL1");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $iHPnC = parcelRequire("iHPnC");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dCm1o = parcelRequire("dCm1o");

var $dZggJ = parcelRequire("dZggJ");

var $jBWM0 = parcelRequire("jBWM0");

var $80Lrr = parcelRequire("80Lrr");

var $eSUJA = parcelRequire("eSUJA");

var $715mj = parcelRequire("715mj");

var $crMwx = parcelRequire("crMwx");

var $5dyzd = parcelRequire("5dyzd");
const $b45b1d82e2e12a16$export$e5ad405d6acc1da0 = ({ isUnassigned: isUnassigned, color: color, name: name, isActive: isActive, epicIssueTypeName: epicIssueTypeName })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { selectedColor: selectedColor, title: title } = (0, $5uXOq.useMemo)(()=>{
        const paletteColorValues = (0, $iHPnC.transformColorToTheme)((colorSchema)=>colorSchema.primary);
        const target = epicIssueTypeName && epicIssueTypeName !== (0, $dZggJ.DEFAULT_PARENT_ISSUE_TYPE_NAME) ? epicIssueTypeName : (0, $dZggJ.DEFAULT_PARENT_ISSUE_TYPE_NAME).toLowerCase();
        return {
            selectedColor: color && paletteColorValues[color] || '',
            title: isUnassigned ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $crMwx.default).unassignedIssueTermRefresh : (0, $crMwx.default).unassigned, {
                target: target
            }) : name
        };
    }, [
        color,
        epicIssueTypeName,
        formatMessage,
        isUnassigned,
        name
    ]);
    const visualRefreshEnabled = (0, $dCm1o.isVisualRefreshEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b45b1d82e2e12a16$var$Title, {
        visualRefresh: visualRefreshEnabled
    }, isUnassigned && visualRefreshEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        paddingInline: "space.050",
        paddingBlock: "space.025",
        testId: "software-backlog-panel.ui.epic.epic-panel.epic-card-list.epic-card.box"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jAy2o))), {
        color: "currentColor",
        label: ""
    })), selectedColor && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b45b1d82e2e12a16$var$ColorIndicator, {
        color: selectedColor,
        "data-testid": "software-backlog-panel.ui.epic.epic-panel.epic-card-list.epic-card.color-indicator",
        visualRefresh: visualRefreshEnabled
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b45b1d82e2e12a16$var$TitleButton, {
        "aria-pressed": isActive,
        "aria-describedby": (0, $dZggJ.EPIC_CARD_DESCRIPTION_ID),
        visualRefresh: visualRefreshEnabled
    }, title));
};
const $b45b1d82e2e12a16$export$19e02114ee9734c8 = ({ hasMessage: hasMessage, isLoading: isLoading, isUnassigned: isUnassigned, epicIssueTypeName: epicIssueTypeName, selectedIssues: selectedIssues, status: status })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return isUnassigned ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $80Lrr.default), {
        hasMessage: hasMessage,
        progress: status,
        isLoading: isLoading,
        confirmMessage: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $crMwx.default).confirmMessageIssueTermRefresh : (0, $crMwx.default).confirmMessage, {
            numberOfIssues: selectedIssues.length,
            issueKey: selectedIssues.length > 0 ? selectedIssues[0].key : '',
            epicIssueTypeName: epicIssueTypeName
        })
    });
};
const $b45b1d82e2e12a16$export$cc925e48e4e1e63b = ({ isLoading: isLoading = false, isDragging: isDragging = false, isActive: isActive = false, isDragHandle: isDragHandle = false, selectedIssues: selectedIssues = [], epic: epic, progress: progress, estimation: estimation, isDropAllowed: isDropAllowed, onClick: onClick = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onDetailClick: onDetailClick = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onCreateIssueClick: onCreateIssueClick = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onAssignEpic: onAssignEpic = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onRefetch: onRefetch })=>{
    const { boardId: boardId, isCompanyManaged: isCompanyManaged } = (0, $eSUJA.usePanelData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [epicIssueTypeName] = (0, $ksXL1.useEpicIssueTypeName)();
    const [hasMessage, setHasMessage] = (0, $5uXOq.useState)(false);
    const { id: id, color: color, name: name, startDate: startDate, dueDate: dueDate, hasError: hasError } = epic;
    const isUnassigned = id === (0, $dZggJ.UNASSIGNED_EPIC_ID);
    const { status: status, totalIssues: totalIssues } = progress;
    const toggleMessage = (messageStatus, isMessageUsed = true)=>{
        isMessageUsed && setHasMessage(messageStatus);
    };
    (0, $5uXOq.useEffect)(()=>{
        toggleMessage(false);
    }, [
        status.toDo,
        status.inProgress,
        status.done
    ]);
    const onViewDetailsClick = (0, $5uXOq.useCallback)(()=>onDetailClick(id), [
        id,
        onDetailClick
    ]);
    const onClickEvent = (0, $5uXOq.useCallback)((_e)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'droppableCard'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, {
            epicCardId: id,
            isSelected: !isActive
        });
        onClick(id);
    }, [
        isActive,
        onClick,
        id,
        createAnalyticsEvent
    ]);
    const epicCardRef = (0, $5uXOq.useRef)(null);
    const { isDraggingOver: isDraggingOver } = (0, $5dyzd.useDropToAssignEpic)({
        epicId: id,
        boardId: boardId,
        ref: epicCardRef,
        isCompanyManaged: isCompanyManaged,
        selectedIssues: selectedIssues,
        isDropAllowed: isDropAllowed,
        toggleMessage: toggleMessage,
        onAssignEpic: onAssignEpic
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jBWM0.default), {
        id: epic.id,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b45b1d82e2e12a16$export$e5ad405d6acc1da0, {
            isUnassigned: isUnassigned,
            color: color,
            name: name,
            epicIssueTypeName: epicIssueTypeName,
            isActive: isActive
        }),
        subtitle: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b45b1d82e2e12a16$export$19e02114ee9734c8, {
            hasMessage: hasMessage,
            isLoading: isLoading,
            isUnassigned: isUnassigned,
            epicIssueTypeName: epicIssueTypeName,
            selectedIssues: selectedIssues,
            status: status
        }),
        isActive: isActive,
        isDragging: isDragging,
        isDraggingOver: isDraggingOver,
        onClick: onClickEvent,
        innerRef: epicCardRef,
        itemName: name,
        itemType: "epic"
    }, id !== (0, $dZggJ.UNASSIGNED_EPIC_ID) && !isDragHandle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $715mj.EpicCardContents), {
        isActive: isActive,
        isLoading: isLoading,
        epic: epic,
        progress: progress,
        estimation: estimation,
        hasError: hasError,
        startDate: startDate,
        dueDate: dueDate,
        totalIssues: totalIssues,
        onDetailClick: onDetailClick,
        onCreateIssueClick: onCreateIssueClick,
        onViewDetailsClick: onViewDetailsClick,
        onRefetch: onRefetch
    }) : null);
};
var $b45b1d82e2e12a16$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $b45b1d82e2e12a16$export$cc925e48e4e1e63b;
const $b45b1d82e2e12a16$var$Title = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1y6m",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b45b1d82e2e12a16$var$ColorIndicator = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { visualRefresh: visualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $lD23V.default)(__cmplp.color),
            "--_cbr7ax": (0, $lD23V.default)(`${__cmplp.visualRefresh ? "var(--ds-space-025, 2px)" : "var(--ds-space-050, 4px)"} ${__cmplp.visualRefresh ? "var(--ds-space-050, 4px)" : "var(--ds-space-100, 8px)"} 0 0`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoglpi _11q71cj8 _18s8tzpx _1o9zidpf _1bsbpxbi _4t3ipxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b45b1d82e2e12a16$var$TitleButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { visualRefresh: visualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _19itglyw _11q71kw7 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _slp31hna _syaz1kw7 _y3gn1kw7",
            !__cmplp.visualRefresh && "_18s8v77o",
            __cmplp.visualRefresh ? "_11c82smr" : "_11c8140y",
            __cmplp.visualRefresh && "_k48pi7a9",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jBWM0", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc9eb837e425a0eb$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $8Rkzz = parcelRequire("8Rkzz");

var $l1N8i = parcelRequire("l1N8i");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");

var $7XYc4 = parcelRequire("7XYc4");

var $8zOmE = parcelRequire("8zOmE");

var $dCm1o = parcelRequire("dCm1o");

var $a2e2Q = parcelRequire("a2e2Q");

var $6cG4N = parcelRequire("6cG4N");

var $lmBAt = parcelRequire("lmBAt");

var $4R6GH = parcelRequire("4R6GH");

var $lu5k0 = parcelRequire("lu5k0");

var $fraBZ = parcelRequire("fraBZ");

var $a65fr = parcelRequire("a65fr");

var $gJwmE = parcelRequire("gJwmE");

var $gHYqG = parcelRequire("gHYqG");

var $dVYHr = parcelRequire("dVYHr");
const $dc9eb837e425a0eb$var$Container = ({ innerRef: innerRef, isActive: isActive = false, isDraggingOver: isDraggingOver = false, children: children, onClick: onClick = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isLoading: isLoading, isDragging: isDragging = false, expanded: expanded = false, onHoverOrFocus: onHoverOrFocus, onUnhoverOrBlur: onUnhoverOrBlur })=>{
    const containerProps = {
        'data-test-id': 'software-backlog-panel.common.ui.card.container',
        'data-testid': 'software-backlog-panel.common.ui.card.container'
    };
    const { isSoftwareFullTheming: isSoftwareFullTheming } = (0, $lmBAt.getIsSoftwareThemingM2Enabled)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $a2e2Q.useSoftwareProjectTheming)() : {
        isSoftwareFullTheming: false
    };
    const cardRef = /*#__PURE__*/ (0, $5uXOq.createRef)();
    (0, $5uXOq.useEffect)(()=>{
        if (cardRef && cardRef.current && cardRef.current.scrollIntoView && isLoading === true) cardRef.current.scrollIntoView({
            behavior: 'smooth'
        });
    }, [
        cardRef,
        isLoading
    ]);
    // This is to prevent onUnhoverOrBlur from being triggered when focused on children
    const onBlur = (0, $5uXOq.useCallback)((event)=>{
        if (innerRef?.current && !innerRef.current.contains(event.relatedTarget) && onUnhoverOrBlur) onUnhoverOrBlur();
    }, [
        innerRef,
        onUnhoverOrBlur
    ]);
    return isLoading === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dc9eb837e425a0eb$var$StaticContainer, {
        ref: cardRef,
        ...containerProps,
        className: (0, $bwpsq.default)([
            "_2tdeu2gc _1a87utpp _uwpcu2gc _3r7outpp _1eog1b66 _qjx3u2gc _1cel1b66 _5n7au2gc"
        ])
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dc9eb837e425a0eb$var$InteractiveContainer, {
        ...containerProps,
        ref: innerRef,
        isActive: isActive,
        isDraggingOver: isDraggingOver,
        onClick: onClick,
        isDragging: isDragging,
        expanded: expanded,
        onMouseEnter: onHoverOrFocus,
        onFocus: onHoverOrFocus,
        onBlur: onBlur,
        onMouseLeave: onUnhoverOrBlur,
        isSoftwareFullTheming: isSoftwareFullTheming,
        className: (0, $bwpsq.default)([
            "_2tdeu2gc _1a87utpp _uwpcu2gc _3r7outpp _1eog1b66 _qjx3u2gc _1cel1b66 _5n7au2gc"
        ])
    }, children);
};
const $dc9eb837e425a0eb$var$Card = (props)=>{
    const { isContentExpanded: isContentExpanded, toggleOpen: toggleOpen } = (0, $a65fr.useCardOpen)(props.id);
    const { isSoftwareFullTheming: isSoftwareFullTheming } = (0, $lmBAt.getIsSoftwareThemingM2Enabled)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $a2e2Q.useSoftwareProjectTheming)() : {
        isSoftwareFullTheming: false
    };
    const { title: title = '', subtitle: subtitle = null, children: children, isLoading: isLoading, isActive: isActive = false, itemName: itemName = '', itemType: itemType, editButton: editButton, id: id } = props;
    const content = typeof children === 'function' ? children(isContentExpanded) : children;
    const shouldShowContents = Boolean(content) && !isLoading;
    const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
    const menuTriggerRef = (0, $5uXOq.useRef)(null);
    const { setReturnFocusTo: setReturnFocusTo } = (0, $lu5k0.useModalDialogActions)();
    const onToggleExpanded = (event, analyticsEvent)=>{
        // stop event propagation so that the card's isActive state does not get toggled
        event.stopPropagation();
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'expandToggleButton', {
            expandState: !isContentExpanded
        });
        toggleOpen();
    };
    const [announcement, setAnnouncement] = (0, $5uXOq.useState)('');
    const showEditButton = (0, $5uXOq.useCallback)(()=>setIsHovered(true), []);
    const hideEditButton = (0, $5uXOq.useCallback)(()=>setIsHovered(false), []);
    const handleMenuOpenChange = (0, $5uXOq.useCallback)((isOpen)=>{
        if (isOpen && menuTriggerRef?.current) setReturnFocusTo(menuTriggerRef);
    }, [
        setReturnFocusTo
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dc9eb837e425a0eb$var$Container, {
        ...props,
        expanded: isContentExpanded,
        onHoverOrFocus: showEditButton,
        onUnhoverOrBlur: hideEditButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dc9eb837e425a0eb$var$Header, {
        showChevron: shouldShowContents,
        visualRefresh: (0, $dCm1o.isVisualRefreshEnabled)()
    }, shouldShowContents && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gHYqG.default), {
        "data-testid": "software-backlog-panel.common.ui.card.expand",
        isExpanded: isContentExpanded,
        onToggle: onToggleExpanded,
        itemName: itemName,
        itemType: itemType,
        isActive: isActive
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dc9eb837e425a0eb$var$Title, {
        "data-testid": "software-backlog-panel.common.ui.card.title",
        visualRefresh: (0, $dCm1o.isVisualRefreshEnabled)()
    }, (0, $dCm1o.isVisualRefreshEnabled)() && ((0, $4R6GH.fg)('jfp-a11y-team_fix_heading_on_backlog_card_ui') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "h3",
        paddingBlockStart: "space.0",
        xcss: [
            $dc9eb837e425a0eb$var$titleContainerStylesNew,
            isActive && $dc9eb837e425a0eb$var$titleSelectedStyles,
            isSoftwareFullTheming && isActive && $dc9eb837e425a0eb$var$titleSelectedThemedStyles
        ]
    }, title), isHovered && editButton) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        as: "ul",
        justifyContent: "space-between",
        alignItems: "center",
        xcss: [
            $dc9eb837e425a0eb$var$titleContainerStyles,
            isActive && $dc9eb837e425a0eb$var$titleSelectedStyles,
            isSoftwareFullTheming && isActive && $dc9eb837e425a0eb$var$titleSelectedThemedStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "li",
        paddingBlockStart: "space.0"
    }, title), isHovered && editButton)), !(0, $dCm1o.isVisualRefreshEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h3",
        size: "xsmall"
    }, title)), isLoading === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $dc9eb837e425a0eb$var$cardSpinnerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        testId: "software-backlog-panel.common.ui.card.spinner",
        size: "small",
        appearance: isActive ? 'invert' : 'inherit'
    })), itemType === 'epic' && shouldShowContents && (0, $4R6GH.fg)('epic_panel_context_menu') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fraBZ.AnnouncerV2), {
        message: announcement,
        shouldAnnounce: announcement !== '',
        liveMode: "polite"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dVYHr.ContextMenu), {
        cardId: id,
        onOpenChange: handleMenuOpenChange,
        triggerRef: menuTriggerRef,
        setAnnouncement: setAnnouncement
    }))), subtitle, shouldShowContents && isContentExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dc9eb837e425a0eb$var$AnimatedHeight, {
        "data-testid": "software-backlog-panel.common.ui.card.content-container",
        "aria-hidden": !isContentExpanded,
        isExpanded: isContentExpanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $dc9eb837e425a0eb$var$contentStyles
    }, content)));
};
var $dc9eb837e425a0eb$export$2e2bcd8739ae039 = $dc9eb837e425a0eb$var$Card;
const $dc9eb837e425a0eb$var$cardMaxWidth = 270;
const $dc9eb837e425a0eb$var$responsiveStyles = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dc9eb837e425a0eb$var$AnimatedHeight = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isExpanded: isExpanded, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _v5644er6",
            __cmplp.isExpanded ? "_c71lw7q6" : "_c71lidpf",
            __cmplp.className
        ])
    });
});
const $dc9eb837e425a0eb$var$cardSpinnerStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.150'
});
const $dc9eb837e425a0eb$var$defaultBoxShadow = "var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)";
const $dc9eb837e425a0eb$var$focusBoxShadow = `inset 0 0 0 2px ${"var(--ds-border-focused, #388BFF)"};`;
const $dc9eb837e425a0eb$var$outlineStyles = `
    outline: none;
    &:focus {
        box-shadow: ${$dc9eb837e425a0eb$var$focusBoxShadow};
    }
`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dc9eb837e425a0eb$var$StaticContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLoading: isLoading, isDraggingOver: isDraggingOver, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1h09nl0": (0, $lD23V.default)((0, $gJwmE.cardColor).default.mouseLeave.backgroundColor),
            "--_1dnfcf4": (0, $lD23V.default)((0, $gJwmE.cardColor).default.mouseLeave.textColor)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1sit _v56419bn _1e0c1txw _2lx21bp4 _vchhusvi _p12f1ogy _bfhk1365 _syazhclr _19pkv77o _2hwx1b66 _otyrv77o _18u01b66",
            __cmplp.isLoading ? "_80om15jw" : "_80om73ad",
            __cmplp.isDraggingOver ? "_16qs64oc" : "_16qszucj",
            __cmplp.className
        ])
    });
});
const $dc9eb837e425a0eb$var$StaticContainerNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLoading: isLoading, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1dnfcf4": (0, $lD23V.default)((0, $gJwmE.cardColor).default.mouseLeave.textColor)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoglpi _v56419bn _1e0c1txw _2lx21bp4 _vchhusvi _p12f1ogy _bfhk18uv _syazhclr _19pkv77o _2hwxu2gc _otyrv77o _18u0u2gc",
            __cmplp.isLoading ? "_80om15jw" : "_80om73ad",
            __cmplp.className
        ])
    });
});
const $dc9eb837e425a0eb$var$InteractiveContainerOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $dc9eb837e425a0eb$var$StaticContainer, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_xo8bol": (0, $lD23V.default)((0, $gJwmE.cardColor).default.mouseOver.backgroundColor),
            "--_au4plk": (0, $lD23V.default)((0, $gJwmE.cardColor).default.mouseOver.textColor),
            "--_181jl6c": (0, $lD23V.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $gJwmE.cardColor).active.mouseDown.backgroundColor),
            "--_1yuuf1b": (0, $lD23V.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $gJwmE.cardColor).default.mouseDown.backgroundColor),
            "--_rgmfhj": (0, $lD23V.default)((0, $gJwmE.cardColor).active.mouseLeave.backgroundColor),
            "--_fdouhv": (0, $lD23V.default)((0, $gJwmE.cardColor).active.mouseLeave.textColor),
            "--_lyilio": (0, $lD23V.default)((0, $gJwmE.cardColor).active.mouseOver.backgroundColor),
            "--_1g6q8x": (0, $lD23V.default)((0, $gJwmE.cardColor).active.mouseOver.textColor)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_12ji1r31 _1qu2glyw _12y31o36 _7ehi64oc _10j71jng _irr31jng _vp7g1lpq _30l31lpq",
            __cmplp.isActive ? "_1di61uj6" : "_1di6hjni",
            __cmplp.isDragging && "_bfhkfg4m _irr3fg4m",
            __cmplp.isActive && "_bfhk1ayf _syaz1o5v _10j78okp _irr38okp _vp7g1r2d _30l31r2d",
            __cmplp.isDraggingOver && "_bfhkfg4m _irr3fg4m _syaz1fxt _30l31fxt",
            __cmplp.className
        ])
    });
});
const $dc9eb837e425a0eb$var$InteractiveContainerNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $dc9eb837e425a0eb$var$StaticContainerNew, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1smle1g": (0, $lD23V.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $gJwmE.cardColor).default.mouseOver.backgroundColor),
            "--_au4plk": (0, $lD23V.default)((0, $gJwmE.cardColor).default.mouseOver.textColor),
            "--_1yuuf1b": (0, $lD23V.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $gJwmE.cardColor).default.mouseDown.backgroundColor),
            "--_1koxd6y": (0, $lD23V.default)(__cmplp.isSoftwareFullTheming ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- needed for theming
            (0, $6cG4N.Tokens).COLOR_BACKGROUND_NEUTRAL : "var(--ds-background-selected, #E9F2FF)"),
            "--_fdouhv": (0, $lD23V.default)((0, $gJwmE.cardColor).active.mouseLeave.textColor),
            "--_17sxilo": (0, $lD23V.default)(__cmplp.isSoftwareFullTheming ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- needed for theming
            (0, $6cG4N.Tokens).COLOR_BORDER_SELECTED : "var(--ds-border-selected, #0C66E4)"),
            "--_g5kx1x": (0, $lD23V.default)(__cmplp.isSoftwareFullTheming ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- needed for theming
            (0, $6cG4N.Tokens).COLOR_BACKGROUND_NEUTRAL_HOVERED : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $gJwmE.cardColor).active.mouseOver.backgroundColor),
            "--_1g6q8x": (0, $lD23V.default)((0, $gJwmE.cardColor).active.mouseOver.textColor),
            "--_5lhzjr": (0, $lD23V.default)(__cmplp.isSoftwareFullTheming ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- needed for theming
            (0, $6cG4N.Tokens).WRAPPER_BACKGROUND : "var(--ds-surface, #FFFFFF)")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoglpi _12ji1r31 _1qu2glyw _12y31o36 _1h6d3acm _1dqonqa1 _189ee4h9 _7ehi64oc _vp7g1lpq _30l31lpq",
            __cmplp.isSoftwareFullTheming ? "_10j7llho _irr3llho" : "_10j71rtj _irr31rtj",
            __cmplp.isActive ? "_1di6fg4m" : "_1di6hjni",
            __cmplp.isDragging && "_bfhkfg4m _irr3fg4m",
            __cmplp.isActive && "_2rkoglpi _1h6d1031 _1dqonqa1 _189ee4h9 _bfhk1ru1 _syaz1o5v _10j7sgqa _irr3sgqa _vp7g1r2d _30l31r2d",
            __cmplp.isDraggingOver && "_bfhkfg4m _irr3fg4m _syaz1fxt _30l31fxt",
            __cmplp.expanded && !__cmplp.isActive && "_1h6dmuej _bfhk1v2w",
            __cmplp.className
        ])
    });
});
const $dc9eb837e425a0eb$var$InteractiveContainer = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $dc9eb837e425a0eb$var$InteractiveContainerNew, $dc9eb837e425a0eb$var$InteractiveContainerOld);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dc9eb837e425a0eb$var$Header = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { showChevron: showChevron, visualRefresh: visualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1sit _12ji1r31 _1qu2glyw _12y31o36 _1e0c1txw _4cvr1h6o _19pkv77o _1tke1ejb _7ehi64oc",
            __cmplp.showChevron && !__cmplp.visualRefresh ? "_18u0x0bf" : "_18u0ze3t",
            __cmplp.visualRefresh && "_1tke1f4h",
            __cmplp.className
        ])
    });
});
const $dc9eb837e425a0eb$var$Title = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { visualRefresh: visualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_14jabjs": (0, $lD23V.default)((0, $gJwmE.cardColor).default.textColor)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81psy _16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1o8l _ca0qv77o _slp31hna _1reo15vq _k48p1wq8 _1wpz1h6o _syaz15fh",
            __cmplp.visualRefresh && "_1yt4v77o",
            __cmplp.className
        ])
    });
});
const $dc9eb837e425a0eb$var$titleContainerStylesNew = (0, $8CUq3.xcss)({
    font: 'font.body',
    fontWeight: "var(--ds-font-weight-medium, 500)",
    color: 'color.text.subtle',
    paddingLeft: 'space.0',
    margin: 'space.0',
    minHeight: 'space.300'
});
const $dc9eb837e425a0eb$var$titleContainerStyles = (0, $8CUq3.xcss)({
    listStyle: 'none',
    color: 'color.text.subtle',
    paddingLeft: 'space.0',
    margin: 'space.0',
    minHeight: 'space.300'
});
const $dc9eb837e425a0eb$var$contentStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.100'
});
const $dc9eb837e425a0eb$var$titleSelectedStyles = (0, $8CUq3.xcss)({
    color: 'color.text.selected'
});
const $dc9eb837e425a0eb$var$titleSelectedThemedStyles = (0, $8CUq3.xcss)({
    // @ts-expect-error value does not match expected type
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- needed for theming
    color: (0, $6cG4N.Tokens).COLOR_TEXT_SUBTLE
});

});
parcelRegister("gHYqG", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc1befbb69b38e5a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $6Ingq = parcelRequire("6Ingq");

var $ebd3R = parcelRequire("ebd3R");

var $hORKG = parcelRequire("hORKG");

var $3dGN0 = parcelRequire("3dGN0");

var $gwIPs = parcelRequire("gwIPs");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $6cG4N = parcelRequire("6cG4N");

var $a2e2Q = parcelRequire("a2e2Q");

var $lmBAt = parcelRequire("lmBAt");

var $7r8Gn = parcelRequire("7r8Gn");
const $fc1befbb69b38e5a$export$49bd1dfb0ad29c40 = ({ isExpanded: isExpanded = false, onToggle: onToggle = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), itemName: itemName, itemType: itemType, isActive: isActive = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { isSoftwareFullTheming: isSoftwareFullTheming } = (0, $lmBAt.getIsSoftwareThemingM2Enabled)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $a2e2Q.useSoftwareProjectTheming)() : {
        isSoftwareFullTheming: false
    };
    const primaryColor = "var(--ds-icon, #44546F)";
    const collapseLabel = itemType === 'epic' ? formatMessage((0, $7r8Gn.default).collapseEpicLabel, {
        epicName: itemName
    }) : formatMessage((0, $7r8Gn.default).collapseVersionLabel, {
        versionName: itemName
    });
    const expandLabel = itemType === 'epic' ? formatMessage((0, $7r8Gn.default).expandEpicLabel, {
        epicName: itemName
    }) : formatMessage((0, $7r8Gn.default).expandVersionLabel, {
        versionName: itemName
    });
    const iconColor = (0, $dCm1o.isVisualRefreshEnabled)() && isActive ? "var(--ds-text-selected, #0C66E4)" : primaryColor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fc1befbb69b38e5a$var$ButtonWrapper, {
        visualRefresh: (0, $dCm1o.isVisualRefreshEnabled)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        testId: "software-backlog-panel.common.ui.card.expand",
        "aria-label": isExpanded ? collapseLabel : expandLabel,
        iconBefore: isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hORKG))), {
            label: "" // @ts-expect-error value does not match type - needed for theming
            ,
            color: isSoftwareFullTheming && isActive ? (0, $6cG4N.Tokens).COLOR_TEXT : iconColor,
            spacing: (0, $dCm1o.isVisualRefreshEnabled)() ? 'spacious' : 'compact',
            LEGACY_size: "medium",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($6Ingq)))
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3dGN0))), {
            label: "" // @ts-expect-error value does not match type - needed for theming
            ,
            color: isSoftwareFullTheming && isActive ? (0, $6cG4N.Tokens).COLOR_TEXT : iconColor,
            spacing: (0, $dCm1o.isVisualRefreshEnabled)() ? 'spacious' : 'compact',
            LEGACY_size: "medium",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($ebd3R)))
        }),
        appearance: "subtle-link",
        spacing: "none",
        onClick: onToggle
    }));
};
var $fc1befbb69b38e5a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($fc1befbb69b38e5a$export$49bd1dfb0ad29c40);
const $fc1befbb69b38e5a$var$ICON_SIZE = (0, $gwIPs.gridSize) * 3; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fc1befbb69b38e5a$var$ButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { visualRefresh: visualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1tcg _1bsb1tcg",
            __cmplp.visualRefresh && "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7r8Gn", function(module, exports) {

$parcel$export(module.exports, "default", () => $f679287902deb817$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f679287902deb817$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    expandEpicLabel: {
        "id": "software-backlog-panel.common.card.expand.expand-epic-label",
        "defaultMessage": "Expand {epicName} epic summary"
    },
    collapseEpicLabel: {
        "id": "software-backlog-panel.common.card.expand.collapse-epic-label",
        "defaultMessage": "Collapse {epicName} epic summary"
    },
    expandVersionLabel: {
        "id": "software-backlog-panel.common.card.expand.expand-version-label",
        "defaultMessage": "Expand {versionName} version summary"
    },
    collapseVersionLabel: {
        "id": "software-backlog-panel.common.card.expand.collapse-version-label",
        "defaultMessage": "Collapse {versionName} version summary"
    }
});

});


parcelRegister("dVYHr", function(module, exports) {

$parcel$export(module.exports, "ContextMenu", () => $81a20f6dd5523434$export$8dc6765e8be191c7);

var $5uXOq = parcelRequire("5uXOq");

var $fhtW3 = parcelRequire("fhtW3");

var $4tD4f = parcelRequire("4tD4f");

var $koVbs = parcelRequire("koVbs");

var $hGKqf = parcelRequire("hGKqf");

var $gMVzN = parcelRequire("gMVzN");
const $81a20f6dd5523434$export$8dc6765e8be191c7 = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>{
    const { cardId: cardId, onOpenChange: onOpenChange, triggerRef: triggerRef, setAnnouncement: setAnnouncement } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const moveToMenuItems = (0, $hGKqf.useMoveTo)({
        cardId: cardId,
        setAnnouncement: setAnnouncement
    });
    const renderMenu = (0, $5uXOq.useCallback)((scope, menuTriggerRef)=>{
        if (!moveToMenuItems) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4tD4f.AsyncMenuRenderer), {
            scope: scope,
            menuItems: moveToMenuItems,
            triggerRef: menuTriggerRef || triggerRef
        });
    }, [
        moveToMenuItems,
        triggerRef
    ]);
    if (!moveToMenuItems) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fhtW3.MeatballMenu), {
        scope: `${cardId}`,
        renderMenu: renderMenu,
        cardId: cardId,
        selectedCardIds: [
            cardId
        ],
        ariaLabel: formatMessage((0, $gMVzN.default).moreActions),
        onOpenChange: onOpenChange,
        jsErrorBoundaryProps: {
            id: 'epic-card-menu',
            packageName: 'backlog',
            teamName: 'a4t-pandora'
        }
    });
});

});
parcelRegister("fhtW3", function(module, exports) {

$parcel$export(module.exports, "MeatballMenu", () => $8f2eab45fd3069e5$export$ef4a0fdddd7eccb7);

var $5uXOq = parcelRequire("5uXOq");

var $iAbh9 = parcelRequire("iAbh9");

var $6U9Sv = parcelRequire("6U9Sv");

var $ewaBk = parcelRequire("ewaBk");

var $2g5oC = parcelRequire("2g5oC");

var $g74eh = parcelRequire("g74eh");
const $8f2eab45fd3069e5$export$ef4a0fdddd7eccb7 = ({ cardId: cardId, selectedCardIds: selectedCardIds, analyticsMapping: analyticsMapping, scope: scope, ...props })=>{
    const fullScope = (0, $g74eh.makeScope)(scope, 'meatball');
    const bulkOpsFlow = (0, $iAbh9.useBulkOpsSessionContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ewaBk.ContextMenuContainer), {
        isGlobal: true,
        selectedCardIds: selectedCardIds,
        analyticsMapping: analyticsMapping,
        cardId: cardId,
        bulkOpsFlow: bulkOpsFlow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6U9Sv.ContextMenuAnalytics), {
        scope: fullScope,
        cardId: cardId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2g5oC.MeatballMenu), {
        scope: fullScope,
        ...props
    })));
};

});
parcelRegister("6U9Sv", function(module, exports) {

$parcel$export(module.exports, "useContextMenuAnalytics", () => $bd5d557ceb1e8011$export$e3e152955394305b);
$parcel$export(module.exports, "ContextMenuAnalytics", () => $bd5d557ceb1e8011$export$eceb0d68a993ec5c);
$parcel$export(module.exports, "ContextualAnalyticsDataFromNode", () => $bd5d557ceb1e8011$export$f9d8ab9f9d913310);
$parcel$export(module.exports, "useFireCheckboxAnalytics", () => $bd5d557ceb1e8011$export$41c45cbb6f557de5);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $iAbh9 = parcelRequire("iAbh9");

var $jcw0u = parcelRequire("jcw0u");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");

var $ewaBk = parcelRequire("ewaBk");

var $gj8F1 = parcelRequire("gj8F1");
const $bd5d557ceb1e8011$export$e3e152955394305b = ()=>{
    const analyticsMapping = (0, $ewaBk.useAnalyticsMapping)();
    const getAnalyticsMapping = (0, $5uXOq.useMemo)(()=>(0, $gj8F1.createGetAnalyticsMapping)(analyticsMapping), [
        analyticsMapping
    ]);
    const addMappedAnalyticsToEvent = (0, $5uXOq.useCallback)((event, id, updater)=>{
        const mappedAnalytics = getAnalyticsMapping(id);
        if (mappedAnalytics && typeof mappedAnalytics === 'object') {
            const { actionSubjectId: actionSubjectId, attributes: attributes, ...analytics } = mappedAnalytics;
            event.update(analytics);
        }
        if (updater) {
            if (typeof updater === 'function') event.update(updater);
            else {
                const { actionSubjectId: actionSubjectId, attributes: attributes, ...analytics } = updater;
                event.update(analytics);
            }
        }
        return event;
    }, [
        getAnalyticsMapping
    ]);
    const getAttributesForId = (0, $5uXOq.useCallback)((id, updater)=>{
        const mappedAnalytics = getAnalyticsMapping(id);
        const mappedAttributes = typeof mappedAnalytics === 'object' ? mappedAnalytics.attributes : undefined;
        return typeof updater === 'object' ? {
            ...mappedAttributes,
            ...updater?.attributes
        } : mappedAttributes;
    }, [
        getAnalyticsMapping
    ]);
    const fireUIAnalyticsForNode = (0, $5uXOq.useCallback)((event, id, updater, attributes)=>{
        const mappedAnalytics = getAnalyticsMapping(id);
        let subjectId = typeof updater === 'function' ? updater(event.payload).actionSubjectId : updater?.actionSubjectId;
        if (!subjectId && mappedAnalytics) subjectId = typeof mappedAnalytics === 'string' ? mappedAnalytics : mappedAnalytics.actionSubjectId;
        if (attributes) subjectId ? (0, $8zOmE.fireUIAnalytics)(event, subjectId, attributes) : (0, $8zOmE.fireUIAnalytics)(event, attributes);
        else subjectId ? (0, $8zOmE.fireUIAnalytics)(event, subjectId) : (0, $8zOmE.fireUIAnalytics)(event);
    }, [
        getAnalyticsMapping
    ]);
    const values = (0, $5uXOq.useMemo)(()=>({
            fireUIAnalyticsForNode: fireUIAnalyticsForNode,
            getAttributesForId: getAttributesForId,
            addMappedAnalyticsToEvent: addMappedAnalyticsToEvent
        }), [
        fireUIAnalyticsForNode,
        getAttributesForId,
        addMappedAnalyticsToEvent
    ]);
    return values;
};
const $bd5d557ceb1e8011$export$eceb0d68a993ec5c = ({ scope: scope, children: children, cardId: cardId })=>{
    const attributes = (0, $ewaBk.useAnalyticsAttributes)({
        scope: scope,
        cardId: cardId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: attributes
    }, children);
};
const $bd5d557ceb1e8011$export$f9d8ab9f9d913310 = ({ id: id, updater: updater, children: children })=>{
    const { getAttributesForId: getAttributesForId } = $bd5d557ceb1e8011$export$e3e152955394305b();
    const attributes = (0, $5uXOq.useMemo)(()=>getAttributesForId(id, updater), [
        getAttributesForId,
        id,
        updater
    ]);
    if (!attributes) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: attributes
    }, children);
};
const $bd5d557ceb1e8011$export$41c45cbb6f557de5 = ()=>{
    const bulkOpsFlow = (0, $iAbh9.useBulkOpsSessionContext)();
    const subscriptionHandle = (0, $5uXOq.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))));
    const fireCheckboxAnalytics = (0, $5uXOq.useCallback)((event, actionSubjectId, attributes)=>{
        if (!bulkOpsFlow) {
            (0, $jcw0u.default)({
                error: new Error('Trying to fire checkbox analytics when bulkOpsFlow is undefined'),
                meta: {
                    id: 'jira-software-context-menu-controller-analytics-use-fire-checkbox-analytics',
                    packageName: 'jiraSoftwareContextMenu',
                    teamName: 'deliveroo'
                },
                attributes: {
                    actionSubjectId: actionSubjectId,
                    attributes: attributes
                }
            });
            (0, $8zOmE.fireUIAnalytics)(event, actionSubjectId, {
                ...attributes,
                bulkOpsSessionID: 'unknown'
            });
            return;
        }
        if (bulkOpsFlow.isInFlow()) (0, $8zOmE.fireUIAnalytics)(event, actionSubjectId, attributes);
        else subscriptionHandle.current = bulkOpsFlow.registerAnalyticsEventPublisher((sessionID)=>{
            const attributesWithSessionId = {
                ...attributes,
                bulkOpsSessionID: sessionID
            };
            (0, $8zOmE.fireUIAnalytics)(event, actionSubjectId, attributesWithSessionId);
        });
    }, [
        bulkOpsFlow,
        subscriptionHandle
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            return subscriptionHandle.current();
        }, []);
    return fireCheckboxAnalytics;
};

});
parcelRegister("ewaBk", function(module, exports) {

$parcel$export(module.exports, "useContextMenuStore", () => $1b2687c2318490cf$export$d1b2e16030b3efbf);
$parcel$export(module.exports, "useContextMenuActions", () => $1b2687c2318490cf$export$fb508b9bcc816326);
$parcel$export(module.exports, "ContextMenuContainer", () => $1b2687c2318490cf$export$4f48a5067cf73390);
$parcel$export(module.exports, "useMenuItemCheckOpen", () => $1b2687c2318490cf$export$60c643cac8887fbe);
$parcel$export(module.exports, "useShouldForceFocus", () => $1b2687c2318490cf$export$ac348ec4828a6056);
$parcel$export(module.exports, "useIsMenuOpen", () => $1b2687c2318490cf$export$3eef7351bd308de1);
$parcel$export(module.exports, "useAnalyticsAttributes", () => $1b2687c2318490cf$export$1fd8522aeddaccda);
$parcel$export(module.exports, "useAnalyticsMapping", () => $1b2687c2318490cf$export$aeb28cc7c774c3ed);
$parcel$export(module.exports, "useIsAnyMenuOpen", () => $1b2687c2318490cf$export$91d90cb66ff7a71e);
$parcel$export(module.exports, "useIsPersistentFocus", () => $1b2687c2318490cf$export$1e85791d95627e79);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $jwhNt = parcelRequire("jwhNt");

var $f19dW = parcelRequire("f19dW");

var $5tijM = parcelRequire("5tijM");
const $1b2687c2318490cf$var$ContextMenuStore = (0, $iXqE5.createStore)({
    name: 'software-context-menu',
    initialState: (0, $f19dW.getInitialState)(),
    actions: $f19dW.actions
});
const $1b2687c2318490cf$export$d1b2e16030b3efbf = (0, $3sQ5x.createHook)($1b2687c2318490cf$var$ContextMenuStore);
const $1b2687c2318490cf$export$fb508b9bcc816326 = (0, $3sQ5x.createActionsHook)($1b2687c2318490cf$var$ContextMenuStore);
const $1b2687c2318490cf$export$4f48a5067cf73390 = (0, $gg7kZ.createContainer)($1b2687c2318490cf$var$ContextMenuStore, {
    onInit: (0, $5tijM.onContainerInit),
    onUpdate: (0, $5tijM.onContainerUpdate)
});
const $1b2687c2318490cf$var$getMenuItemOpen = (state, { menuItem: menuItem, scope: scope })=>state.menus[scope]?.openPath?.startsWith(menuItem.id);
const $1b2687c2318490cf$export$60c643cac8887fbe = (0, $3sQ5x.createStateHook)($1b2687c2318490cf$var$ContextMenuStore, {
    selector: $1b2687c2318490cf$var$getMenuItemOpen
});
const $1b2687c2318490cf$var$getIsFocusForced = (state, { menuItem: menuItem, scope: scope })=>state.menus[scope]?.forcedFocusPath === menuItem.id;
const $1b2687c2318490cf$export$ac348ec4828a6056 = (0, $3sQ5x.createStateHook)($1b2687c2318490cf$var$ContextMenuStore, {
    selector: $1b2687c2318490cf$var$getIsFocusForced
});
const $1b2687c2318490cf$var$getIsMenuOpen = (state, { scope: scope })=>state.openMenu === scope;
const $1b2687c2318490cf$export$3eef7351bd308de1 = (0, $3sQ5x.createStateHook)($1b2687c2318490cf$var$ContextMenuStore, {
    selector: $1b2687c2318490cf$var$getIsMenuOpen
});
const $1b2687c2318490cf$var$getAnalyticsAttributes = (state, { scope: scope, cardId: cardId })=>{
    const isMenuOpen = $1b2687c2318490cf$var$getIsMenuOpen(state, {
        scope: scope
    });
    const { analytics: { selectedCardIds: selectedCardIds } } = state;
    return (0, $jwhNt.getCardSelectionAnalytics)(selectedCardIds, cardId, isMenuOpen);
};
const $1b2687c2318490cf$export$1fd8522aeddaccda = (0, $3sQ5x.createStateHook)($1b2687c2318490cf$var$ContextMenuStore, {
    selector: $1b2687c2318490cf$var$getAnalyticsAttributes
});
const $1b2687c2318490cf$var$getAnalyticsMapping = (state)=>state.analytics.analyticsMapping;
const $1b2687c2318490cf$export$aeb28cc7c774c3ed = (0, $3sQ5x.createStateHook)($1b2687c2318490cf$var$ContextMenuStore, {
    selector: $1b2687c2318490cf$var$getAnalyticsMapping
});
const $1b2687c2318490cf$export$d8b7614abf2894d6 = (state)=>!!state.openMenu;
const $1b2687c2318490cf$export$91d90cb66ff7a71e = (0, $3sQ5x.createStateHook)($1b2687c2318490cf$var$ContextMenuStore, {
    selector: $1b2687c2318490cf$export$d8b7614abf2894d6
});
const $1b2687c2318490cf$var$getIsPersistentFocus = (state)=>!!state?.persistentFocus;
const $1b2687c2318490cf$export$1e85791d95627e79 = (0, $3sQ5x.createStateHook)($1b2687c2318490cf$var$ContextMenuStore, {
    selector: $1b2687c2318490cf$var$getIsPersistentFocus
});

});
parcelRegister("jwhNt", function(module, exports) {

$parcel$export(module.exports, "hasUserStartedSelecting", () => $17a2da3770fdd915$export$5195d9082487fa42);
$parcel$export(module.exports, "hasUserUnselectedAll", () => $17a2da3770fdd915$export$3b8cd3ffacc95e4f);
$parcel$export(module.exports, "getCardSelectionAnalytics", () => $17a2da3770fdd915$export$f96eca8ded123f8b);
$parcel$export(module.exports, "shouldFlowBeEnded", () => $17a2da3770fdd915$export$539307982a715ea8);
const $17a2da3770fdd915$export$5195d9082487fa42 = (analytics, contextMenuContainerAnalytics)=>analytics.selectedCardIds.length === 0 && contextMenuContainerAnalytics.selectedCardIds.length > 0;
const $17a2da3770fdd915$export$3b8cd3ffacc95e4f = (analytics, contextMenuContainerAnalytics)=>analytics.selectedCardIds.length > 0 && contextMenuContainerAnalytics.selectedCardIds.length === 0;
const $17a2da3770fdd915$export$f96eca8ded123f8b = (selectedCardIds, cardId, isMenuOpen)=>{
    let cardIds;
    if (isMenuOpen) cardIds = selectedCardIds.includes(cardId) ? selectedCardIds : [
        cardId
    ];
    else cardIds = selectedCardIds;
    const numSelectedCards = cardIds.length;
    return {
        numSelectedCards: numSelectedCards,
        issue_ids: cardIds,
        issue_id: cardId
    };
};
const $17a2da3770fdd915$export$539307982a715ea8 = (analytics, contextMenuContainerAnalytics, bulkOpsFlow)=>{
    const sessionID = !!bulkOpsFlow?.getFlowAttributes().bulkOpsSessionID;
    return sessionID && contextMenuContainerAnalytics.selectedCardIds.length === 0;
};

});

parcelRegister("f19dW", function(module, exports) {

$parcel$export(module.exports, "getInitialState", () => $c2d99694a10aebe1$export$53ac33307b5acee9);
$parcel$export(module.exports, "actions", () => $c2d99694a10aebe1$export$e324594224ef24da);

var $jcw0u = parcelRequire("jcw0u");

var $5tijM = parcelRequire("5tijM");
const $c2d99694a10aebe1$export$53ac33307b5acee9 = ()=>({
        menus: {},
        openMenu: null,
        analytics: {
            selectedCardIds: []
        },
        lastAction: {
            action: 'init',
            scope: undefined
        }
    });
const $c2d99694a10aebe1$export$aad8462122ac592b = (lastAction)=>({ setState: setState })=>{
        const { analytics: analytics, ...initialState } = $c2d99694a10aebe1$export$53ac33307b5acee9();
        initialState.lastAction = lastAction || {
            action: 'reset'
        };
        setState(initialState);
    };
const $c2d99694a10aebe1$var$setPersistentFocus = (persistentFocus)=>({ setState: setState })=>{
        setState({
            persistentFocus: persistentFocus
        });
    };
const $c2d99694a10aebe1$var$openMenu = ({ position: position, scope: scope, analyticsEvent: analyticsEvent, persistentFocus: persistentFocus, openedFrom: openedFrom })=>({ setState: setState }, { selectedCardIds: selectedCardIds, cardId: cardId })=>{
        (0, $5tijM.fireOpenMenuAnalyticsEvent)({
            event: analyticsEvent,
            selectedCardIds: selectedCardIds,
            cardId: cardId,
            openedFrom: openedFrom
        });
        setState({
            openMenu: scope,
            persistentFocus: persistentFocus,
            menus: {
                [scope]: {
                    openPath: undefined,
                    scope: scope,
                    position: position,
                    forcedFocusPath: undefined
                }
            },
            lastAction: {
                action: 'openMenu',
                scope: scope
            }
        });
    };
const $c2d99694a10aebe1$export$11ed9b7b8045d408 = (scope, menuItem)=>({ setState: setState, getState: getState })=>{
        const { menus: menus, lastAction: lastAction } = getState();
        const menuState = menus[scope];
        if (!menuState) {
            if (lastAction?.action === 'closeMenu') return;
            const errorMessage = `Menu state is not defined - last action(${lastAction?.action}) scopes(${lastAction?.scope}-${scope})`;
            const error = new Error(errorMessage);
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'jira-software-context-menu-controller-open-sub-menu-error',
                    packageName: 'jiraSoftwareContextMenu',
                    teamName: 'deliveroo'
                }
            });
            return;
        }
        setState({
            menus: {
                [scope]: {
                    ...menuState,
                    openPath: menuItem.id
                }
            },
            lastAction: {
                action: 'openSubMenu',
                scope: scope
            }
        });
    };
const $c2d99694a10aebe1$export$69ff42680518db68 = (scope)=>({ getState: getState, dispatch: dispatch })=>{
        const { menus: menus, lastAction: lastAction } = getState();
        const menuState = menus[scope];
        if (!menuState) {
            if (lastAction?.action === 'closeMenu') return;
            const errorMessage = `Menu state is not defined - last action(${lastAction?.action}) scopes(${lastAction?.scope}-${scope})`;
            const error = new Error(errorMessage);
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'jira-software-context-menu-controller-close-menu-error',
                    packageName: 'jiraSoftwareContextMenu',
                    teamName: 'deliveroo'
                }
            });
            return;
        }
        dispatch($c2d99694a10aebe1$export$aad8462122ac592b({
            action: 'closeMenu',
            scope: scope
        }));
    };
const $c2d99694a10aebe1$var$closeSubMenu = (scope)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const menuState = state.menus[scope];
        if (!menuState) {
            if (state.lastAction?.action === 'closeMenu') return;
            const errorMessage = `Menu state is not defined - last action(${state.lastAction?.action}) scopes(${state.lastAction?.scope}-${scope})`;
            const error = new Error(errorMessage);
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'jira-software-context-menu-controller-close-sub-menu-error',
                    packageName: 'jiraSoftwareContextMenu',
                    teamName: 'deliveroo'
                }
            });
            return;
        }
        setState({
            menus: {
                [scope]: {
                    ...menuState,
                    openPath: undefined
                }
            },
            lastAction: {
                action: 'closeSubMenu',
                scope: scope
            }
        });
    };
const $c2d99694a10aebe1$var$setForcedFocusPath = (scope, id)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const menuState = state.menus[scope];
        if (!menuState) {
            if (state.lastAction?.action === 'closeMenu') return;
            const errorMessage = `Menu state is not defined - last action(${state.lastAction?.action}) scopes(${state.lastAction?.scope}-${scope}`;
            const error = new Error(errorMessage);
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'jira-software-context-menu-controller-set-focused-path-error',
                    packageName: 'jiraSoftwareContextMenu',
                    teamName: 'deliveroo'
                }
            });
            return;
        }
        setState({
            menus: {
                [scope]: {
                    ...menuState,
                    forcedFocusPath: id
                }
            },
            lastAction: {
                action: 'setForcedFocusPath',
                scope: scope
            }
        });
    };
const $c2d99694a10aebe1$export$e324594224ef24da = {
    openMenu: $c2d99694a10aebe1$var$openMenu,
    closeMenu: $c2d99694a10aebe1$export$69ff42680518db68,
    openSubMenu: $c2d99694a10aebe1$export$11ed9b7b8045d408,
    closeSubMenu: $c2d99694a10aebe1$var$closeSubMenu,
    setForcedFocusPath: $c2d99694a10aebe1$var$setForcedFocusPath,
    reset: $c2d99694a10aebe1$export$aad8462122ac592b,
    setPersistentFocus: $c2d99694a10aebe1$var$setPersistentFocus
};

});
parcelRegister("5tijM", function(module, exports) {

$parcel$export(module.exports, "onContainerInit", () => $61c942cebc868b99$export$34f4621b58d3fbc8);
$parcel$export(module.exports, "onContainerUpdate", () => $61c942cebc868b99$export$ab8f0de40a3a2d2d);
$parcel$export(module.exports, "fireOpenMenuAnalyticsEvent", () => $61c942cebc868b99$export$d4ad71c555abd3c8);

var $ajpes = parcelRequire("ajpes");

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");

var $4R6GH = parcelRequire("4R6GH");

var $jwhNt = parcelRequire("jwhNt");
const $61c942cebc868b99$export$34f4621b58d3fbc8 = ()=>({ setState: setState, getState: getState }, { cardId: cardId, bulkOpsFlow: bulkOpsFlow, ...analyticsContainerProps })=>{
        const { analytics: analytics } = getState();
        if ((0, $4R6GH.fg)('jira-concurrent-contextual-menu-fix')) {
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(getState().analytics, analyticsContainerProps)) setState({
                analytics: {
                    ...analyticsContainerProps
                }
            });
        } else setState({
            analytics: {
                ...analyticsContainerProps
            }
        });
        if (bulkOpsFlow && (0, $jwhNt.shouldFlowBeEnded)(analytics, analyticsContainerProps, bulkOpsFlow)) bulkOpsFlow?.end();
        else if (bulkOpsFlow && (0, $jwhNt.hasUserStartedSelecting)(analytics, analyticsContainerProps)) bulkOpsFlow?.start();
    };
const $61c942cebc868b99$export$ab8f0de40a3a2d2d = ()=>({ setState: setState, getState: getState }, { cardId: cardId, bulkOpsFlow: bulkOpsFlow, ...analyticsContainerProps })=>{
        const { analytics: analytics } = getState();
        if ((0, $jwhNt.hasUserStartedSelecting)(analytics, analyticsContainerProps)) {
            if (!bulkOpsFlow) (0, $jcw0u.default)({
                error: new Error('Trying to start a flow while bulkOpsSession is undefined'),
                meta: {
                    id: 'jira-software-context-menu-controller-on-container-update-flow-start-error',
                    packageName: 'jiraSoftwareContextMenu',
                    teamName: 'deliveroo'
                }
            });
            else bulkOpsFlow?.start();
        } else if ((0, $jwhNt.hasUserUnselectedAll)(analytics, analyticsContainerProps)) {
            if (!bulkOpsFlow) (0, $jcw0u.default)({
                error: new Error('Trying to end a flow while bulkOpsSession is undefined'),
                meta: {
                    id: 'jira-software-context-menu-controller-on-container-update-flow-end-error',
                    packageName: 'jiraSoftwareContextMenu',
                    teamName: 'deliveroo'
                }
            });
            else bulkOpsFlow?.end();
        }
        setState({
            analytics: {
                ...analytics,
                ...analyticsContainerProps
            }
        });
    };
const $61c942cebc868b99$export$d4ad71c555abd3c8 = ({ event: event, cardId: cardId, selectedCardIds: selectedCardIds, openedFrom: openedFrom })=>{
    const attributes = {
        ...(0, $jwhNt.getCardSelectionAnalytics)(selectedCardIds, cardId, true),
        isLinkIssueFromBoardCardEnabled: true,
        openedFrom: openedFrom
    };
    // Attributes normally get merged together. We want to override the issue_ids attribute instead
    event.context.push({
        attributes: {
            issue_ids: null
        }
    });
    (0, $8zOmE.fireUIAnalytics)(event, 'cardActions', attributes);
};

});



parcelRegister("gj8F1", function(module, exports) {

$parcel$export(module.exports, "createGetAnalyticsMapping", () => $84e9c18cb7a7bed7$export$836ec4673aac623f);

var $gJBT6 = parcelRequire("gJBT6");
const $84e9c18cb7a7bed7$export$7b036678329a3ea2 = (id, analyticsMapping)=>{
    let result = analyticsMapping[id];
    if (!result) {
        const matchedId = Object.keys(analyticsMapping).find((key)=>key.startsWith(id) || id.startsWith(key));
        if (matchedId) result = analyticsMapping[matchedId];
    }
    return result;
};
const $84e9c18cb7a7bed7$export$836ec4673aac623f = (analyticsMapping)=>{
    if (!analyticsMapping) return (_id)=>undefined;
    // Sorting the analytics mapping by key length ensures that the shortest key is matched first - shortest key means best match
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const sortedAnalyticsMapping = Object.fromEntries(Object.entries(analyticsMapping).sort(([keyA], [keyB])=>keyA.length - keyB.length));
    const memoizedGetterFunction = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))($84e9c18cb7a7bed7$export$7b036678329a3ea2);
    return (id)=>memoizedGetterFunction(id, sortedAnalyticsMapping);
};

});


parcelRegister("2g5oC", function(module, exports) {

$parcel$export(module.exports, "MeatballMenu", () => $13a9ebb12169281b$export$ef4a0fdddd7eccb7);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $42CjB = parcelRequire("42CjB");

var $8U6zd = parcelRequire("8U6zd");

var $bJeNF = parcelRequire("bJeNF");

var $7CMCs = parcelRequire("7CMCs");

var $jgJNO = parcelRequire("jgJNO");

var $iXVV6 = parcelRequire("iXVV6");

var $dCm1o = parcelRequire("dCm1o");

var $koVbs = parcelRequire("koVbs");

var $ewaBk = parcelRequire("ewaBk");


var $2bK3l = parcelRequire("2bK3l");
const $13a9ebb12169281b$export$ef4a0fdddd7eccb7 = ({ onOpenChange: onOpenChange, scope: scope, renderMenu: renderMenu, ariaLabel: ariaLabel, isCompact: isCompact, jsErrorBoundaryProps: jsErrorBoundaryProps })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { openMenu: openMenu, closeMenu: closeMenu } = (0, $ewaBk.useContextMenuActions)();
    const isOpen = (0, $ewaBk.useIsMenuOpen)({
        scope: scope
    });
    const triggerRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        onOpenChange?.(isOpen);
    }, [
        isOpen,
        onOpenChange
    ]);
    const renderContent = (0, $5uXOq.useCallback)(({ isOpen: isContentOpen })=>isContentOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
            fallback: "unmount",
            ...jsErrorBoundaryProps
        }, ' ', renderMenu(scope, triggerRef)) : null, [
        renderMenu,
        scope,
        jsErrorBoundaryProps
    ]);
    const onClick = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        e.stopPropagation();
        analyticsEvent.update({
            action: 'opened',
            actionSubject: 'contextMenu'
        });
        if (!isOpen) openMenu({
            scope: scope,
            position: {
                x: 0,
                y: 0
            },
            analyticsEvent: analyticsEvent,
            persistentFocus: e.detail === 0 || undefined,
            openedFrom: 'meatball'
        });
        else closeMenu(scope);
    }, [
        closeMenu,
        isOpen,
        openMenu,
        scope
    ]);
    const handleKeyDown = (0, $5uXOq.useCallback)((e)=>{
        if (e.key === 'Enter') e.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        placement: "bottom-end",
        content: renderContent,
        shouldRenderToParent: true,
        messageId: "software-context-menu.ui.meatball-menu.popup",
        messageType: "transactional",
        trigger: ({ ref: popupRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
                attributes: {
                    inputSource: 'threeDot'
                }
            }, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
                ...triggerProps,
                appearance: "subtle",
                spacing: // eslint-disable-next-line no-nested-ternary
                (0, $dCm1o.isVisualRefreshEnabled)() ? 'compact' : isCompact ? 'compact' : 'default',
                testId: (0, $00df11e79838cf5e$export$7449a807b3ce7b1c),
                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8U6zd))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)"
                    }),
                onClick: onClick,
                onKeyDown: handleKeyDown,
                label: ariaLabel,
                ref: (r)=>{
                    if (popupRef) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    popupRef(r);
                    triggerRef.current = r;
                },
                isTooltipDisabled: false,
                tooltip: {
                    content: formatMessage((0, $2bK3l.default).moreActionsTooltip),
                    hideTooltipOnClick: true
                }
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                ...triggerProps,
                spacing: isCompact ? 'compact' : 'default',
                testId: (0, $00df11e79838cf5e$export$7449a807b3ce7b1c),
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))), {
                    spacing: "spacious",
                    label: "",
                    color: "var(--ds-icon, #44546F)"
                }),
                onClick: onClick,
                onKeyDown: handleKeyDown,
                "aria-label": ariaLabel,
                ref: (r)=>{
                    if (popupRef) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    popupRef(r);
                    triggerRef.current = r;
                }
            }))
    });
};

});
const $00df11e79838cf5e$export$7449a807b3ce7b1c = 'software-context-menu.meatball-menu';

parcelRegister("2bK3l", function(module, exports) {

$parcel$export(module.exports, "default", () => $784647cebaff00a0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $784647cebaff00a0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    moreActionsTooltip: {
        "id": "jira.platform.software.context-menu.more-actions-tooltip",
        "defaultMessage": "More actions"
    }
});

});


parcelRegister("g74eh", function(module, exports) {

$parcel$export(module.exports, "makeScope", () => $ce0e9067ffc1f4fc$export$79c43e8605ed7f8f);
const $ce0e9067ffc1f4fc$export$79c43e8605ed7f8f = (scope, menuType)=>`${scope}-${menuType}`;

});


parcelRegister("4tD4f", function(module, exports) {

$parcel$export(module.exports, "AsyncMeatballMenu", () => $65fdd06020fea880$export$dad57d856f7c40e9);
$parcel$export(module.exports, "AsyncMenuRenderer", () => $65fdd06020fea880$export$481d980aecfdabe6);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $h9HNs = parcelRequire("h9HNs");

var $6GBq8 = parcelRequire("6GBq8");

const $65fdd06020fea880$export$e5a84b368c677a12 = (0, $kxZPA.lazy)(()=>Promise.resolve((parcelRequire("fhtW3"))).then((module)=>module.MeatballMenu), {
    moduleId: "./src/packages/software/context-menu/src/ui/MeatballMenu.tsx"
});

/* istanbul ignore next */ // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $65fdd06020fea880$var$AsyncMenuRendererLazy = (0, $kxZPA.lazy)(()=>(parcelRequire("dUtxn")).then((module)=>module.MenuRenderer), {
    moduleId: "./src/packages/software/context-menu/src/ui/menu-renderer/index.tsx"
});
const $65fdd06020fea880$var$InternalAsyncMeatballMenu = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-software-context-menu-meatball-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($65fdd06020fea880$export$e5a84b368c677a12, props));
const $65fdd06020fea880$export$dad57d856f7c40e9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h9HNs.ContextMenuErrorBoundary), {
        id: "jira-software-context-menu-meatball-menu",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($65fdd06020fea880$var$InternalAsyncMeatballMenu, props));
const $65fdd06020fea880$export$481d980aecfdabe6 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-software-context-menu-menu-renderer",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6GBq8.MenuRendererPlaceholder), {
            menuItems: props.menuItems
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($65fdd06020fea880$var$AsyncMenuRendererLazy, props));

});
parcelRegister("h9HNs", function(module, exports) {

$parcel$export(module.exports, "ContextMenuErrorBoundary", () => $0bf642946ee45d6d$export$9253ba2022568501);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");
const $0bf642946ee45d6d$export$9253ba2022568501 = ({ id: id, children: children, fallback: fallback })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: id,
        packageName: "jiraSoftwareContextMenu",
        fallback: fallback || 'unmount',
        teamName: "deliveroo"
    }, children);

});

parcelRegister("6GBq8", function(module, exports) {

$parcel$export(module.exports, "MenuRendererPlaceholder", () => $03bf8ee5a763f135$export$9c3503516e6b2b03);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $eZJjh = parcelRequire("eZJjh");

var $4R6GH = parcelRequire("4R6GH");

var $1HF4Y = parcelRequire("1HF4Y");

var $6ssLS = parcelRequire("6ssLS");

var $clxlA = parcelRequire("clxlA");
const $03bf8ee5a763f135$var$getChildren = (children)=>{
    return Array.isArray(children) ? children : [
        children
    ];
};
const $03bf8ee5a763f135$export$b12353dcfd2c40d3 = (menuItems)=>menuItems.reduce((acc, menuItem)=>{
        if (menuItem.type === (0, $1HF4Y.MenuNodeType).Separator) return acc + $clxlA.SEPARATOR_PLACEHOLDER_HEIGHT;
        if (menuItem.type === (0, $1HF4Y.MenuNodeType).Section) return acc + $clxlA.SECTION_HEADER_PLACEHOLDER_HEIGHT + ((0, $4R6GH.fg)('jfp_a11y_team_boards_list_markup_used_incorrectly') ? $03bf8ee5a763f135$export$b12353dcfd2c40d3($03bf8ee5a763f135$var$getChildren(menuItem.children)) : $03bf8ee5a763f135$export$b12353dcfd2c40d3(menuItem.children || []));
        return acc + $clxlA.MENU_ITEM_PLACEHOLDER_HEIGHT;
    }, 0);
const $03bf8ee5a763f135$export$9c3503516e6b2b03 = /*#__PURE__*/ (0, $5uXOq.memo)(({ menuItems: menuItems })=>{
    const height = $03bf8ee5a763f135$export$b12353dcfd2c40d3(menuItems);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($03bf8ee5a763f135$var$Container, {
        "data-testid": $clxlA.CONTEXT_MENU_PLACEHOLDER_TESTID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($03bf8ee5a763f135$var$InnerItems, {
        height: height
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "medium"
    })));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $03bf8ee5a763f135$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $6ssLS.MenuContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bsbuuw1",
            __cmplp.className
        ])
    });
});
const $03bf8ee5a763f135$var$InnerItems = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $lD23V.default)(`${__cmplp.height}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i2nrh _1bsb1osq _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1HF4Y", function(module, exports) {

$parcel$export(module.exports, "MenuNodeType", () => $8e9d98803c1f1230$export$d6a3c2c57b227e3b);
const $8e9d98803c1f1230$export$d6a3c2c57b227e3b = {
    Item: 'item',
    Node: 'node',
    Separator: 'separator',
    Section: 'section',
    Search: 'search',
    BulkIndicator: 'bulkIndicator'
};

});

parcelRegister("6ssLS", function(module, exports) {

$parcel$export(module.exports, "MenuContainer", () => $c700ae4c66d12196$export$b286f91cddfedb5a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $c700ae4c66d12196$export$b286f91cddfedb5a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _1ul9uuw1 _c71ldgin _ca0q1b66 _u5f3idpf _n3td1b66 _19bvidpf _vchhusvi _bfhk1bhr",
            __cmplp.className
        ])
    });
});

});

parcelRegister("clxlA", function(module, exports) {

$parcel$export(module.exports, "CONTEXT_MENU_PLACEHOLDER_TESTID", () => $be0729fb178ee569$export$d0775d7ba1f28e6);
$parcel$export(module.exports, "SEPARATOR_PLACEHOLDER_HEIGHT", () => $be0729fb178ee569$export$49b3e4b8a0edc9b7);
$parcel$export(module.exports, "SECTION_HEADER_PLACEHOLDER_HEIGHT", () => $be0729fb178ee569$export$71999dec35730ebd);
$parcel$export(module.exports, "MENU_ITEM_PLACEHOLDER_HEIGHT", () => $be0729fb178ee569$export$f9717b5566f9ac9f);

var $gwIPs = parcelRequire("gwIPs");

const $be0729fb178ee569$export$d0775d7ba1f28e6 = 'software-context-menu.ui.menu-renderer-placeholder';
const $be0729fb178ee569$export$49b3e4b8a0edc9b7 = (0, $gwIPs.gridSize) + 1;
const $be0729fb178ee569$export$71999dec35730ebd = (0, $gwIPs.gridSize) * 2;
const $be0729fb178ee569$export$f9717b5566f9ac9f = (0, $d9cdb1c71f9dbf8c$export$b9e05b29ae05bdd9);

});
const $d9cdb1c71f9dbf8c$export$b9e05b29ae05bdd9 = 32;
const $d9cdb1c71f9dbf8c$export$dce8cd449abd1f77 = 5;
const $d9cdb1c71f9dbf8c$export$1ec3328eed0aedd9 = 300;
const $d9cdb1c71f9dbf8c$export$6b4c950ad6cadf50 = 200;
const $d9cdb1c71f9dbf8c$export$bb89c9064245f005 = 500;
const $d9cdb1c71f9dbf8c$export$f4f3847a7eaec9e9 = 'software-context-menu.ui.context-menu-inner.context-menu-inner-container';
const $d9cdb1c71f9dbf8c$export$b3f11e5d123cdbe9 = 'software-context-menu.ui.context-menu-inner.context-menu-node.context-menu-item.context-menu-submenu';
const $d9cdb1c71f9dbf8c$export$ef86d72244e00c00 = 'software-context-menu.ui.menu-renderer.context-menu-inner.context-menu-node.context-menu-item.chevron-icon';
const $d9cdb1c71f9dbf8c$export$8e765acf3440e0b = 'software-context-menu.ui.context-menu-inner.context-menu-node.context-menu-item.context-menu-item';
const $d9cdb1c71f9dbf8c$export$75f77b2251314894 = 'software-context-menu.ui.menu-renderer.context-menu-inner.context-menu-node.context-menu-item.overflow-visible-popup-container';
const $d9cdb1c71f9dbf8c$export$602eb83148423ac6 = 'software-context-menu.ui.menu-renderer.context-menu-inner.context-menu-node.context-menu-item.tooltip';
const $d9cdb1c71f9dbf8c$export$ae734f89618d3c5f = 'software-context-menu.ui.menu-renderer.context-menu-inner.context-menu-node.context-menu-item.context-menu-label';
const $d9cdb1c71f9dbf8c$export$90350df905144507 = 'software-context-menu.ui.context-menu-inner.context-menu-node.context-menu-search';
const $d9cdb1c71f9dbf8c$export$328d05d650390cfd = 'software-context-menu.ui.context-menu-inner.context-menu-node.context-menu-search.content';
const $d9cdb1c71f9dbf8c$export$1245780b529c0d82 = 'software-context-menu.ui.context-menu-inner.context-menu-node.context-menu-search.loading';
const $d9cdb1c71f9dbf8c$export$803f51dcf576f554 = 'software-context-menu.ui.context-menu-inner.context-menu-node.context-menu-search.no-results';
const $d9cdb1c71f9dbf8c$export$bb79bd28759ee895 = 'context';
const $d9cdb1c71f9dbf8c$export$ee5015c6ad52cf0b = 'meatball';



parcelRegister("dUtxn", function(module, exports) {

let $a2076ad63adba6fe$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a2076ad63adba6fe$var$load("9NWgM").then(()=>parcelRequire('6hc7I'));

});


parcelRegister("hGKqf", function(module, exports) {

$parcel$export(module.exports, "useMoveTo", () => $14200d9b3790ebfd$export$f91d8f33a4d36cb0);

var $5uXOq = parcelRequire("5uXOq");

var $ksXL1 = parcelRequire("ksXL1");

var $eSUJA = parcelRequire("eSUJA");

var $jLeW1 = parcelRequire("jLeW1");

var $c3V1Q = parcelRequire("c3V1Q");
const $14200d9b3790ebfd$export$f91d8f33a4d36cb0 = ({ cardId: cardId, setAnnouncement: setAnnouncement })=>{
    const { boardId: boardId } = (0, $eSUJA.usePanelData)();
    const [{ cards: epicCards }] = (0, $ksXL1.useEpicCardsState)();
    const [rankEpics] = (0, $jLeW1.useRankEpicsMutation)(boardId);
    const getOrderedIds = (0, $5uXOq.useCallback)(()=>{
        return epicCards.map((card)=>card.epic.id.toString());
    }, [
        epicCards
    ]);
    const moveTo = (0, $5uXOq.useCallback)((direction)=>{
        const orderedIds = getOrderedIds();
        const currentIndex = orderedIds.indexOf(cardId.toString());
        if (currentIndex === -1) return;
        let targetIndex;
        switch(direction){
            case 'up':
                targetIndex = Math.max(0, currentIndex - 1);
                break;
            case 'down':
                targetIndex = Math.min(orderedIds.length - 1, currentIndex + 1);
                break;
            case 'top':
                targetIndex = 0;
                break;
            case 'bottom':
                targetIndex = orderedIds.length - 1;
                break;
            default:
                return;
        }
        if (targetIndex === currentIndex) return;
        rankEpics([
            cardId
        ], targetIndex);
    }, [
        cardId,
        getOrderedIds,
        rankEpics
    ]);
    const orderedIds = getOrderedIds();
    const currentIndex = orderedIds.indexOf(cardId.toString());
    const isFirst = currentIndex === 0;
    const isLast = currentIndex === orderedIds.length - 1;
    return (0, $c3V1Q.useMoveToContent)({
        isMoveToTopActionVisible: !isFirst,
        isMoveToBottomActionVisible: !isLast,
        isMoveUpActionVisible: !isFirst,
        isMoveDownActionVisible: !isLast,
        onMoveToTop: ()=>moveTo('top'),
        onMoveToBottom: ()=>moveTo('bottom'),
        onMoveUp: ()=>moveTo('up'),
        onMoveDown: ()=>moveTo('down'),
        setAnnouncement: setAnnouncement
    });
};

});
parcelRegister("jLeW1", function(module, exports) {

$parcel$export(module.exports, "useRankEpicsMutation", () => $2be297e93ef79d8f$export$7de49bca8e4aeb66);

var $5tTFS = parcelRequire("5tTFS");

var $5cllN = parcelRequire("5cllN");

var $ksXL1 = parcelRequire("ksXL1");
const $2be297e93ef79d8f$export$a6269456da5f21bd = (0, $5cllN.default)`
    mutation SoftwareEpicPanelRank(
        $boardId: ID!
        $issueParentIds: [ID!]!
        $rankBeforeIssueParentId: Long
        $rankAfterIssueParentId: Long
    ) {
        rankIssueParent(
            input: {
                boardId: $boardId
                issueParentIds: $issueParentIds
                rankBeforeIssueParentId: $rankBeforeIssueParentId
                rankAfterIssueParentId: $rankAfterIssueParentId
            }
        ) {
            statusCode
            success
            message
        }
    }
`;
const $2be297e93ef79d8f$var$getRankBeforeAfterIssueParentId = (cards, index)=>{
    if (cards.length === 0) // Unable to return just an empty plain object {}
    // https://github.com/facebook/flow/issues/2977
    return Object.freeze({});
    // last one ?
    if (index === cards.length) return {
        rankAfterIssueParentId: cards[index - 1].epic.id
    };
    return {
        rankBeforeIssueParentId: cards[index].epic.id
    };
};
const $2be297e93ef79d8f$export$7de49bca8e4aeb66 = (boardId)=>{
    const [mutate, epicRankingMutationData] = (0, $5tTFS.useMutation)($2be297e93ef79d8f$export$a6269456da5f21bd);
    const [{ cards: cards }] = (0, $ksXL1.useEpicCardsState)();
    const [, { rankEpics: rankEpicsAction }] = (0, $ksXL1.useEpicsStoreActions)();
    const rankEpics = (issueParentIds, newPosition)=>mutate({
            variables: {
                boardId: boardId,
                issueParentIds: issueParentIds,
                ...$2be297e93ef79d8f$var$getRankBeforeAfterIssueParentId(cards.filter(({ epic: { id: id } })=>!issueParentIds.includes(id)), newPosition)
            },
            update: ()=>{
                rankEpicsAction(issueParentIds, newPosition);
            },
            optimisticResponse: {
                rankIssueParent: {
                    __typename: 'GenericMutationResponse',
                    statusCode: 200,
                    success: true,
                    message: ''
                }
            }
        });
    return [
        rankEpics,
        epicRankingMutationData
    ];
};

});

parcelRegister("c3V1Q", function(module, exports) {

$parcel$export(module.exports, "useMoveToContent", () => $7a0351a88bda270d$export$ba5a2e46cd05ad01);

var $1HF4Y = parcelRequire("1HF4Y");

var $koVbs = parcelRequire("koVbs");


var $dOr0N = parcelRequire("dOr0N");
const $7a0351a88bda270d$export$ba5a2e46cd05ad01 = ({ isMoveToTopActionVisible: isMoveToTopActionVisible, isMoveUpActionVisible: isMoveUpActionVisible, isMoveDownActionVisible: isMoveDownActionVisible, isMoveToBottomActionVisible: isMoveToBottomActionVisible, onMoveToTop: onMoveToTop, onMoveUp: onMoveUp, onMoveDown: onMoveDown, onMoveToBottom: onMoveToBottom, setAnnouncement: setAnnouncement })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const moveToActions = [];
    if (isMoveToTopActionVisible) moveToActions.push({
        type: (0, $1HF4Y.MenuNodeType).Item,
        id: (0, $749e2412280e6661$export$bdb9565438582b9d),
        label: formatMessage((0, $dOr0N.default).topOfPanel),
        onClick: ()=>{
            setAnnouncement(formatMessage((0, $dOr0N.default).movedToTop));
            onMoveToTop();
        }
    });
    if (isMoveUpActionVisible) moveToActions.push({
        type: (0, $1HF4Y.MenuNodeType).Item,
        id: (0, $749e2412280e6661$export$f26d7d68143616eb),
        label: formatMessage((0, $dOr0N.default).up),
        onClick: ()=>{
            setAnnouncement(formatMessage((0, $dOr0N.default).movedUp));
            onMoveUp();
        }
    });
    if (isMoveDownActionVisible) moveToActions.push({
        type: (0, $1HF4Y.MenuNodeType).Item,
        id: (0, $749e2412280e6661$export$9352ca79ca7f44be),
        label: formatMessage((0, $dOr0N.default).down),
        onClick: ()=>{
            setAnnouncement(formatMessage((0, $dOr0N.default).movedDown));
            onMoveDown();
        }
    });
    if (isMoveToBottomActionVisible) moveToActions.push({
        type: (0, $1HF4Y.MenuNodeType).Item,
        id: (0, $749e2412280e6661$export$52c041beb3a2516f),
        label: formatMessage((0, $dOr0N.default).bottomOfPanel),
        onClick: ()=>{
            setAnnouncement(formatMessage((0, $dOr0N.default).movedToBottom));
            onMoveToBottom();
        }
    });
    return moveToActions.length > 0 ? moveToActions : null;
};

});
const $749e2412280e6661$export$bdb9565438582b9d = 'actions/move-to/top';
const $749e2412280e6661$export$f26d7d68143616eb = 'actions/move-to/up';
const $749e2412280e6661$export$9352ca79ca7f44be = 'actions/move-to/down';
const $749e2412280e6661$export$52c041beb3a2516f = 'actions/move-to/bottom';

parcelRegister("dOr0N", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c456de713dc638b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1c456de713dc638b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    topOfPanel: {
        "id": "backlog-panel.card.context-menu.top-of-panel",
        "defaultMessage": "Move to top"
    },
    bottomOfPanel: {
        "id": "backlog-panel.card.context-menu.bottom-of-panel",
        "defaultMessage": "Move to bottom"
    },
    up: {
        "id": "backlog-panel.card.context-menu.up",
        "defaultMessage": "Move up"
    },
    down: {
        "id": "backlog-panel.card.context-menu.down",
        "defaultMessage": "Move down"
    },
    movedToTop: {
        "id": "backlog-panel.card.context-menu.moved-to-top",
        "defaultMessage": "Moved epic to top of panel"
    },
    movedToBottom: {
        "id": "backlog-panel.card.context-menu.moved-to-bottom",
        "defaultMessage": "Moved epic to bottom of panel"
    },
    movedUp: {
        "id": "backlog-panel.card.context-menu.moved-up",
        "defaultMessage": "Moved epic up"
    },
    movedDown: {
        "id": "backlog-panel.card.context-menu.moved-down",
        "defaultMessage": "Moved epic down"
    }
});

});



parcelRegister("gMVzN", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a57545cb93d00f3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5a57545cb93d00f3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    moreActions: {
        "id": "software-backlog-panel.card.context-menu.more-actions",
        "defaultMessage": "More actions"
    }
});

});



parcelRegister("80Lrr", function(module, exports) {

$parcel$export(module.exports, "default", () => $087e7d837f7bec6c$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $l1N8i = parcelRequire("l1N8i");

var $c2i4s = parcelRequire("c2i4s");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $4R6GH = parcelRequire("4R6GH");

var $6xUNT = parcelRequire("6xUNT");

var $7IWsp = parcelRequire("7IWsp");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $gJwmE = parcelRequire("gJwmE");


var $2q1IZ = parcelRequire("2q1IZ");
const $087e7d837f7bec6c$export$c17561cb55d4db30 = ({ hasMessage: hasMessage = false, progress: progress, confirmMessage: confirmMessage = '', isLoading: isLoading })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { toDo: toDo, inProgress: inProgress, done: done } = progress;
    const total = toDo.issueCount + inProgress.issueCount + done.issueCount;
    const toDoTooltipMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $2q1IZ.messages).toDoToolTipsTextIssueTermRefresh : (0, $2q1IZ.messages).toDoToolTipsText;
    const inProgressTooltipMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $2q1IZ.messages).inProgressToolTipsTextIssueTermRefresh : (0, $2q1IZ.messages).inProgressToolTipsText;
    const doneTooltipMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $2q1IZ.messages).doneToolTipsTextIssueTermRefresh : (0, $2q1IZ.messages).doneToolTipsText;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($087e7d837f7bec6c$var$ProgressBarContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xxsmall",
        as: "div"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($087e7d837f7bec6c$var$MessageWrapper, {
        hasMessage: hasMessage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $087e7d837f7bec6c$var$iconWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))), {
        color: "var(--ds-icon-success, #22A06B)",
        LEGACY_size: "small",
        testId: "software-backlog-panel.common.ui.progress-bar.check-circle-icon",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($087e7d837f7bec6c$var$Message, null, confirmMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($087e7d837f7bec6c$var$ProgressBarWrapper, {
        hasMessage: hasMessage,
        "data-testid": (0, $ccd5a4612b7fa03f$export$e26566c7bbad3269)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6xUNT.default), {
        height: (0, $ccd5a4612b7fa03f$export$7d8ca445d9a39d60),
        sum: Math.max(total, 1),
        backgroundColor: isLoading ? (0, $ccd5a4612b7fa03f$export$62e21f5321ae3e61) : (0, $ccd5a4612b7fa03f$export$9a2ce699a8e88c00),
        remainingTooltipContent: formatMessage(toDoTooltipMessage, {
            count: toDo.issueCount,
            total: total
        }),
        "aria-label": (0, $4R6GH.fg)('tanuki_a11y_fixes_drop_2') ? formatMessage(toDoTooltipMessage, {
            count: toDo.issueCount,
            total: total
        }) : undefined,
        tooltipHoverPadding: (0, $ccd5a4612b7fa03f$export$8235cb2ac10a8179)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7IWsp.default), {
        value: done.issueCount,
        color: (0, $ccd5a4612b7fa03f$export$f2a648c26a91297f),
        tooltipContent: formatMessage(doneTooltipMessage, {
            count: done.issueCount,
            total: total
        }),
        tooltipHoverPadding: (0, $ccd5a4612b7fa03f$export$8235cb2ac10a8179)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7IWsp.default), {
        value: inProgress.issueCount,
        color: (0, $ccd5a4612b7fa03f$export$dc4e31a90347554e),
        tooltipContent: formatMessage(inProgressTooltipMessage, {
            count: inProgress.issueCount,
            total: total
        }),
        tooltipHoverPadding: (0, $ccd5a4612b7fa03f$export$8235cb2ac10a8179)
    }))));
};
var $087e7d837f7bec6c$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $5uXOq.memo)($087e7d837f7bec6c$export$c17561cb55d4db30);
const $087e7d837f7bec6c$var$ProgressBarContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $087e7d837f7bec6c$var$MessageWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasMessage: hasMessage, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_14jabjs": (0, $lD23V.default)((0, $gJwmE.cardColor).default.textColor)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _v5641bs3 _1e0c1txw _4cvr1h6o _p12f1osq _syaz15fh _19pkidpf _2hwxv77o _otyridpf _18u0v77o _kqswstnw _k8m0brmi _lcxvglyw",
            __cmplp.hasMessage ? "_tzy4kb7n" : "_tzy4idpf",
            __cmplp.className
        ])
    });
});
const $087e7d837f7bec6c$var$iconWrapperStyles = (0, $8CUq3.xcss)({
    paddingRight: 'space.050'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $087e7d837f7bec6c$var$Message = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $087e7d837f7bec6c$var$ProgressBarWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasMessage: hasMessage, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_v5641bs3 _19pk1b66 _2hwxv77o _otyr1b66 _18u0v77o _k8m0brmi",
            __cmplp.hasMessage ? "_tzy4idpf" : "_tzy4kb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6xUNT", function(module, exports) {

$parcel$export(module.exports, "default", () => $d12efc7cca969bbb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");


var $az4zD = parcelRequire("az4zD");

var $7IWsp = parcelRequire("7IWsp");

var $jR3Es = parcelRequire("jR3Es");
// eslint-disable-next-line jira/react/no-class-components
class $d12efc7cca969bbb$var$ProgressBar extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            children: null,
            sum: 0,
            remainingTooltipContent: '',
            // TODO: Use tokens for colors
            backgroundColor: (0, $829f609a65d26a98$exports).N30,
            height: 10
        };
    }
    validateElementsAndCalculateElementsWidth() {
        const { children: children } = this.props;
        let sumOfElementsValues = 0;
        const validatedElements = [];
        (0, $5uXOq.Children).map(children, (child)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const childEl = child;
            if (childEl.props.value && childEl.props.value > 0) {
                sumOfElementsValues += childEl.props.value;
                validatedElements.push(childEl);
            }
        });
        return {
            validatedElements: validatedElements,
            elementsSum: sumOfElementsValues
        };
    }
    render() {
        const { children: children, remainingTooltipContent: remainingTooltipContent, sum: sum = 0, backgroundColor: backgroundColor, height: height, borderRadius: borderRadius, tooltipHoverPadding: tooltipHoverPadding, intl: { formatMessage: formatMessage } } = this.props;
        if (!children) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d12efc7cca969bbb$var$ProgressWrapper, {
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            "data-testid": "common.components.progress-bar.progress-wrapper",
            backgroundColor: backgroundColor,
            elementsGrow: 0,
            elementsHeight: height,
            // @ts-expect-error - TS2322 - Type 'number | undefined' is not assignable to type 'string | number'.
            borderRadius: borderRadius
        });
        const { validatedElements: validatedElements, elementsSum: elementsSum } = this.validateElementsAndCalculateElementsWidth();
        const correctedSum = Number.isNaN(sum) ? 0 : sum;
        const remaining = correctedSum - elementsSum;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d12efc7cca969bbb$var$ProgressWrapper, {
            ...this.props,
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            "data-testid": "common.components.progress-bar.progress-wrapper",
            backgroundColor: remaining > 0 ? backgroundColor : 'transparent',
            elementsHeight: height,
            // @ts-expect-error - TS2322 - Type 'number | undefined' is not assignable to type 'string | number'.
            borderRadius: borderRadius,
            tooltipHoverPadding: tooltipHoverPadding,
            ariaLive: "polite",
            role: "progressbar",
            "aria-valuemax": correctedSum,
            "aria-valuenow": elementsSum,
            "aria-label": this.props['aria-label'] || formatMessage((0, $jR3Es.default).progressBarAriaLabel)
        }, validatedElements, remaining > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7IWsp.default), {
            value: remaining,
            tooltipContent: remainingTooltipContent,
            color: backgroundColor,
            tooltipHoverPadding: tooltipHoverPadding
        }));
    }
}
var $d12efc7cca969bbb$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($d12efc7cca969bbb$var$ProgressBar);
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d12efc7cca969bbb$var$ProgressWrapper = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1750df9-0"
})`width:100%;height:${// eslint-disable-next-line @typescript-eslint/no-explicit-any
(props)=>props.elementsHeight}px;display:flex;${({ borderRadius: borderRadius, elementsHeight: elementsHeight, tooltipHoverPadding: tooltipHoverPadding })=>!tooltipHoverPadding && `border-radius: ${borderRadius || elementsHeight / 2}px;
        overflow: hidden;
    `} & > div{${({ borderRadius: borderRadius, elementsHeight: elementsHeight })=>{
    const radius = `${borderRadius || elementsHeight / 2}px`;
    return `
                &:first-child {
                    border-top-left-radius: ${radius};
                    border-bottom-left-radius: ${radius};
                }
                &:last-child {
                    border-top-right-radius: ${radius};
                    border-bottom-right-radius: ${radius};
                }
                &:not(:last-child) {
                    margin-right: 2px;
                }
                &:last-child {
                    margin-right: 0;
                }
            `;
}}}`;
$d12efc7cca969bbb$var$ProgressWrapper.displayName = 'ProgressWrapper';

});
parcelRegister("7IWsp", function(module, exports) {

$parcel$export(module.exports, "default", () => $719ee7d438676972$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $3bDjY = parcelRequire("3bDjY");
const $719ee7d438676972$var$SingleElementWithTooltip = (props)=>{
    const { value: value, tooltipContent: tooltipContent, color: color, position: position, tooltipHoverPadding: tooltipHoverPadding } = props;
    const TooltipTag = (0, $5uXOq.useMemo)(()=>{
        const singleElementProps = {
            alt: tooltipContent
        };
        // FIXME: Fix that by extracting the forwarded component
        return /*#__PURE__*/ (0, $5uXOq.forwardRef)((tagProps, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($719ee7d438676972$var$SingleElement, {
                elementGrow: value,
                color: color,
                // @ts-expect-error - TS2322 - Type '((instance: unknown) => void) | MutableRefObject<unknown> | null' is not assignable to type '((instance: any) => void) | RefObject<HTMLElement | SVGElement | Component<{}, {}, any>> | undefined'.
                innerRef: ref,
                tooltipHoverPadding: tooltipHoverPadding,
                ...tagProps,
                ...typeof tooltipContent === 'string' ? singleElementProps : {}
            }));
    }, [
        value,
        color,
        tooltipHoverPadding,
        tooltipContent
    ]);
    return(// @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<RefAttributes<unknown>>' is not assignable to type 'keyof IntrinsicElements | ComponentType<AllHTMLAttributes<HTMLElement> & { ref: Ref<HTMLElement>; }> | undefined'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: tooltipContent,
        position: position,
        tag: TooltipTag
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null)));
};
class $719ee7d438676972$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            value: 0,
            tooltipContent: ''
        };
    }
    render() {
        const { value: value, tooltipContent: tooltipContent, color: color } = this.props;
        const hasTooltipContent = Boolean(tooltipContent);
        if (hasTooltipContent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($719ee7d438676972$var$SingleElementWithTooltip, {
            ...this.props,
            tooltipContent: tooltipContent
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($719ee7d438676972$var$SingleElement, {
            elementGrow: value,
            color: color,
            alt: tooltipContent
        });
    }
}
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $719ee7d438676972$var$SingleElement = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-234u1k-0"
})`flex-grow:${// eslint-disable-next-line @typescript-eslint/no-explicit-any
(props)=>props.elementGrow};height:100%;min-width:5px;background-color:${// eslint-disable-next-line @typescript-eslint/no-explicit-any
(props)=>props.color};div{height:100%;width:100%;${({ tooltipHoverPadding: tooltipHoverPadding })=>tooltipHoverPadding && `padding-block: ${tooltipHoverPadding}px;
            margin-top: -${tooltipHoverPadding}px;`}}`;
$719ee7d438676972$var$SingleElement.displayName = 'SingleElement';

});

parcelRegister("jR3Es", function(module, exports) {

$parcel$export(module.exports, "default", () => $0110d4743e8f1dbb$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0110d4743e8f1dbb$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    progressBarAriaLabel: {
        "id": "common.components.progress-bar.aria-label",
        "defaultMessage": "Progress Bar"
    }
});

});


const $ccd5a4612b7fa03f$export$7d8ca445d9a39d60 = 5;
const $ccd5a4612b7fa03f$export$8235cb2ac10a8179 = 3;
const $ccd5a4612b7fa03f$export$62e21f5321ae3e61 = "var(--ds-skeleton, #091E420F)";
const $ccd5a4612b7fa03f$export$9a2ce699a8e88c00 = "var(--ds-border, #091E4224)";
const $ccd5a4612b7fa03f$export$dc4e31a90347554e = "var(--ds-border-information, #1D7AFC)";
const $ccd5a4612b7fa03f$export$f2a648c26a91297f = "var(--ds-border-success, #22A06B)";
const $ccd5a4612b7fa03f$export$e26566c7bbad3269 = 'software-backlog-panel.common.ui.progress-bar.progress-bar-wrapper';

parcelRegister("2q1IZ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8049c624d6074b15$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $8049c624d6074b15$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    toDoToolTipsText: {
        "id": "software-backlog-panel.common.progress-bar.to-do-tool-tips-text",
        "defaultMessage": "To Do: {count} of {total} ({total, plural, =0 {issue} one {issue} other {issues}})"
    },
    inProgressToolTipsText: {
        "id": "software-backlog-panel.common.progress-bar.in-progress-tool-tips-text",
        "defaultMessage": "In Progress: {count} of {total} ({total, plural, =0 {issue} one {issue} other {issues}})"
    },
    doneToolTipsText: {
        "id": "software-backlog-panel.common.progress-bar.done-tool-tips-text",
        "defaultMessage": "Done: {count} of {total} ({total, plural, =0 {issue} one {issue} other {issues}})"
    },
    doneToolTipsTextIssueTermRefresh: {
        "id": "software-backlog-panel.common.progress-bar.done-tool-tips-text-issue-term-refresh",
        "defaultMessage": "Done: {count} of {total} ({total, plural, =0 {work items} one {work item} other {work items}})"
    },
    inProgressToolTipsTextIssueTermRefresh: {
        "id": "software-backlog-panel.common.progress-bar.in-progress-tool-tips-text-issue-term-refresh",
        "defaultMessage": "In Progress: {count} of {total} ({total, plural, =0 {work item} one {work item} other {work items}})"
    },
    toDoToolTipsTextIssueTermRefresh: {
        "id": "software-backlog-panel.common.progress-bar.to-do-tool-tips-text-issue-term-refresh",
        "defaultMessage": "To Do: {count} of {total} ({total, plural, =0 {work item} one {work item} other {work items}})"
    }
});

});


parcelRegister("715mj", function(module, exports) {

$parcel$export(module.exports, "EpicCardContents", () => $fd2f4582ea0a83f2$export$bad04f13da51cd05);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $ksXL1 = parcelRequire("ksXL1");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $3yvnz = parcelRequire("3yvnz");

var $gBj4V = parcelRequire("gBj4V");

var $c5VWe = parcelRequire("c5VWe");

var $bcQ8v = parcelRequire("bcQ8v");

var $53cZc = parcelRequire("53cZc");

var $fbWyS = parcelRequire("fbWyS");

var $eSUJA = parcelRequire("eSUJA");

var $14Waf = parcelRequire("14Waf");

var $kyWip = parcelRequire("kyWip");

var $l47Zr = parcelRequire("l47Zr");

var $fx51X = parcelRequire("fx51X");

var $hg2Om = parcelRequire("hg2Om");
const $fd2f4582ea0a83f2$var$EpicCardButtons = ({ isActive: isActive, epicId: epicId, onViewDetailsClick: onViewDetailsClick, onCreateIssueClick: onCreateIssueClick })=>{
    const { isCompanyManaged: isCompanyManaged } = (0, $eSUJA.usePanelData)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onCreateIssueInEpic = (0, $5uXOq.useCallback)(()=>{
        onCreateIssueClick(epicId);
    }, [
        epicId,
        onCreateIssueClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isCompanyManaged ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $fd2f4582ea0a83f2$var$cardButtonContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c5VWe.default), {
        analyticName: "viewDetails",
        text: formatMessage((0, $hg2Om.default).viewDetails),
        isActive: isActive,
        onClick: onViewDetailsClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c5VWe.default), {
        analyticName: "createIssueInEpic",
        text: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $hg2Om.default).createIssueIssueTermRefresh : (0, $hg2Om.default).createIssue),
        isActive: isActive,
        onClick: onCreateIssueInEpic
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c5VWe.default), {
        isActive: isActive,
        text: formatMessage((0, $hg2Om.default).viewAllDetails),
        onClick: onViewDetailsClick
    }));
};
const $fd2f4582ea0a83f2$export$b9a07cbf9f8f949c = ({ startDate: startDate, dueDate: dueDate, isLoading: isLoading, hasError: hasError, totalIssues: totalIssues, onRefetch: onRefetch })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3yvnz.TMPEpicPanelDetailsSkeleton), {
        testId: "software-backlog-panel.ui.epic.epic-panel.epic-card-list.epic-card.card-contents.skeleton"
    });
    if (hasError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l47Zr.CardContentsErrorState), {
        onRefetch: onRefetch
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "software-backlog-panel.ui.epic.epic-panel.epic-card-list.epic-card.card-contents.total-issues"
    }, totalIssues ? null : formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $hg2Om.default).emptyIssueTermRefresh : (0, $hg2Om.default).empty)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $14Waf.default), {
        label: formatMessage((0, $kyWip.default).startDate),
        date: startDate
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $14Waf.default), {
        label: formatMessage((0, $kyWip.default).dueDate),
        date: dueDate
    }));
};
const $fd2f4582ea0a83f2$export$281db6f8756bfac5 = ({ isLoading: isLoading, hasError: hasError, progress: progress, estimation: estimation, epic: epic, onDetailClick: onDetailClick, onRefetch: onRefetch })=>{
    const { key: epicKey, id: id } = epic;
    const [timeTrackingOptions = (0, $gBj4V.defaultTimeTrackingOptions)] = (0, $ksXL1.useTimeTrackingOptions)();
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3yvnz.CMPEpicPanelDetailsSkeleton), null);
    if (hasError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l47Zr.CardContentsErrorState), {
        onRefetch: onRefetch
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fx51X.default), {
        issueId: id,
        issueKey: epicKey,
        onDetailClick: onDetailClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fbWyS.Divider), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $53cZc.default), {
        totalIssues: progress.totalIssues,
        done: progress.status.done.issueCount
    }), estimation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fbWyS.Divider), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bcQ8v.default), {
        estimationInfo: estimation,
        timeTrackingOptions: timeTrackingOptions
    })));
};
const $fd2f4582ea0a83f2$export$bad04f13da51cd05 = ({ isActive: isActive, isLoading: isLoading, hasError: hasError, progress: progress, estimation: estimation, epic: epic, startDate: startDate, dueDate: dueDate, totalIssues: totalIssues, onDetailClick: onDetailClick, onViewDetailsClick: onViewDetailsClick, onCreateIssueClick: onCreateIssueClick, onRefetch: onRefetch })=>{
    const { isCompanyManaged: isCompanyManaged } = (0, $eSUJA.usePanelData)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isCompanyManaged ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fd2f4582ea0a83f2$export$281db6f8756bfac5, {
        isLoading: isLoading,
        hasError: hasError,
        progress: progress,
        estimation: estimation,
        epic: epic,
        onDetailClick: onDetailClick,
        onRefetch: onRefetch
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fd2f4582ea0a83f2$export$b9a07cbf9f8f949c, {
        startDate: startDate,
        dueDate: dueDate,
        isLoading: isLoading,
        hasError: hasError,
        totalIssues: totalIssues,
        onRefetch: onRefetch
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fd2f4582ea0a83f2$var$EpicCardButtons, {
        isActive: isActive,
        epicId: epic.id,
        onViewDetailsClick: onViewDetailsClick,
        onCreateIssueClick: onCreateIssueClick
    }));
};
const $fd2f4582ea0a83f2$var$cardButtonContainerStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.100'
});

});
parcelRegister("3yvnz", function(module, exports) {

$parcel$export(module.exports, "TMPEpicPanelDetailsSkeleton", () => $ab64dfc9b8916903$export$35b8a2bf3072a83b);
$parcel$export(module.exports, "CMPEpicPanelDetailsSkeleton", () => $ab64dfc9b8916903$export$b05e55dda8e1d1a5);
/* TMPEpicPanelDetailsSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $jljil = parcelRequire("jljil");

var $1WxUx = parcelRequire("1WxUx");
const $ab64dfc9b8916903$var$customCssStyles = null;
const $ab64dfc9b8916903$export$35b8a2bf3072a83b = ({ testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1WxUx))),
        containerStyles: {
            maxHeight: '100px',
            overflow: 'hidden'
        },
        testId: testId,
        className: (0, $bwpsq.default)([
            "_1wgmglyw"
        ])
    });
const $ab64dfc9b8916903$export$b05e55dda8e1d1a5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jljil))),
        containerStyles: {
            maxHeight: '170px',
            overflow: 'hidden'
        },
        className: (0, $bwpsq.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("jljil", function(module, exports) {
module.exports = new URL("cmp-epic-panel-details.tpl.3aa68d36.svg", import.meta.url).toString();

});

parcelRegister("1WxUx", function(module, exports) {
module.exports = new URL("tmp-epic-panel-details.tpl.a8264571.svg", import.meta.url).toString();

});


parcelRegister("c5VWe", function(module, exports) {

$parcel$export(module.exports, "default", () => $03d31ceeb0d8d4b2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9yOBd = parcelRequire("9yOBd");

var $8zOmE = parcelRequire("8zOmE");

var $iKdRC = parcelRequire("iKdRC");

var $dCm1o = parcelRequire("dCm1o");
const $03d31ceeb0d8d4b2$var$CardButton = ({ isActive: isActive, text: text, isVisible: isVisible = true, analyticName: analyticName = 'cardButton', onClick: onClick, onFocus: onFocus, onMouseOver: onMouseOver, isModalTrigger: isModalTrigger })=>{
    const onButtonClick = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        event.stopPropagation();
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, analyticName);
        onClick();
    }, [
        analyticName,
        onClick
    ]);
    const ButtonComponent = isModalTrigger ? (0, $iKdRC.ModalTriggerButton) : (0, $9yOBd.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ButtonComponent, {
        testId: "software-backlog-panel.common.ui.card-button",
        tabIndex: isVisible ? 0 : -1,
        onClick: onButtonClick,
        shouldFitContainer: true,
        isSelected: isActive,
        onFocus: onFocus,
        onMouseOver: onMouseOver,
        theme: (currentTheme, themeProps)=>{
            const { buttonStyles: buttonStyles, ...rest } = currentTheme(themeProps);
            return {
                buttonStyles: {
                    ...buttonStyles,
                    ...(0, $dCm1o.isVisualRefreshEnabled)() ? {
                        color: "var(--ds-text-subtle, #44546F)",
                        borderRadius: "var(--ds-border-radius-100, 4px)",
                        borderWidth: "var(--ds-border-width, 1px)",
                        borderStyle: 'solid',
                        borderColor: "var(--ds-border, #091E4224)",
                        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
                    } : {
                        backgroundColor: "var(--ds-background-neutral, #091E420F)",
                        color: "var(--ds-text, #172B4D)"
                    },
                    margin: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-0, 0px)"}`,
                    '&:hover': {
                        backgroundColor: "var(--ds-background-neutral-hovered, #091E4224)"
                    },
                    '&:focus': {
                        backgroundColor: "var(--ds-background-neutral-pressed, #091E424F)"
                    },
                    '&:active': {
                        backgroundColor: "var(--ds-background-neutral-pressed, #091E424F)"
                    }
                },
                ...rest
            };
        }
    }, text);
};
var $03d31ceeb0d8d4b2$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($03d31ceeb0d8d4b2$var$CardButton);

});

parcelRegister("bcQ8v", function(module, exports) {

$parcel$export(module.exports, "EstimateContainer", () => $a3ba44993908e9fe$export$541d39676097f853);
$parcel$export(module.exports, "EstimateDT", () => $a3ba44993908e9fe$export$7ba3b4abeaca5f47);
$parcel$export(module.exports, "EstimateDD", () => $a3ba44993908e9fe$export$5d603d368e732a5b);
$parcel$export(module.exports, "Subtext", () => $a3ba44993908e9fe$export$43d56d6f8adb025c);
$parcel$export(module.exports, "default", () => $a3ba44993908e9fe$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $7pLfz = parcelRequire("7pLfz");

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $koVbs = parcelRequire("koVbs");

var $etKNj = parcelRequire("etKNj");

var $dCm1o = parcelRequire("dCm1o");

var $in6eD = parcelRequire("in6eD");

var $gJwmE = parcelRequire("gJwmE");

var $8m1Ge = parcelRequire("8m1Ge");
// TODO: move to ui/card-contents level since this is not used in the version panel
const $a3ba44993908e9fe$var$EstimateField = ({ estimationInfo: estimationInfo, timeTrackingOptions: timeTrackingOptions })=>{
    const intl = (0, $koVbs.default)();
    const { formatMessage: formatMessage } = intl;
    const formattedEstimationInfo = (0, $5uXOq.useMemo)(()=>{
        const { estimationType: estimationType, doneEstimate: unformattedDoneEstimate, totalEstimate: unformattedTotalEstimate } = estimationInfo;
        const isTimeEstimate = estimationType === (0, $7pLfz.ORIGINAL_ESTIMATE);
        const doneEstimate = isTimeEstimate ? (0, $etKNj.timeTrackingFormatter)(unformattedDoneEstimate, timeTrackingOptions, intl) : (0, $in6eD.roundToTwoDecimalPlaces)(unformattedDoneEstimate);
        const totalEstimate = isTimeEstimate ? (0, $etKNj.timeTrackingFormatter)(unformattedTotalEstimate, timeTrackingOptions, intl) : (0, $in6eD.roundToTwoDecimalPlaces)(unformattedTotalEstimate);
        return {
            ...estimationInfo,
            doneEstimate: doneEstimate,
            totalEstimate: totalEstimate
        };
    }, [
        estimationInfo,
        intl,
        timeTrackingOptions
    ]);
    const { estimationType: estimationType, name: name, doneEstimate: doneEstimate, totalEstimate: totalEstimate, percentageCompleted: percentageCompleted, notEstimated: notEstimated } = formattedEstimationInfo;
    const [totalEstimateMessage, tooltipMessage] = (0, $5uXOq.useMemo)(()=>{
        if (estimationType === (0, $7pLfz.STORY_POINTS)) return [
            formatMessage((0, $8m1Ge.default).points, {
                totalEstimate: totalEstimate
            }),
            formatMessage((0, $8m1Ge.default).pointsTooltip, {
                doneEstimate: doneEstimate,
                totalEstimate: totalEstimate
            })
        ];
        return [
            totalEstimate,
            estimationType === (0, $7pLfz.ORIGINAL_ESTIMATE) ? formatMessage((0, $8m1Ge.default).timeEstimateTooltip, {
                doneEstimate: doneEstimate,
                totalEstimate: totalEstimate
            }) : formatMessage((0, $8m1Ge.default).customEstimateTooltip, {
                doneEstimate: doneEstimate,
                totalEstimate: totalEstimate,
                name: name
            })
        ];
    }, [
        estimationType,
        name,
        formatMessage,
        doneEstimate,
        totalEstimate
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3ba44993908e9fe$export$541d39676097f853, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        as: "dl",
        justifyContent: "space-between",
        xcss: $a3ba44993908e9fe$var$sectionWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3ba44993908e9fe$export$7ba3b4abeaca5f47, null, formatMessage((0, $8m1Ge.default).label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3ba44993908e9fe$export$5d603d368e732a5b, null, totalEstimateMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: tooltipMessage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3ba44993908e9fe$export$43d56d6f8adb025c, null, formatMessage((0, $8m1Ge.default).percentageCompleted, {
        percentageCompleted: percentageCompleted
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3ba44993908e9fe$export$43d56d6f8adb025c, null, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $8m1Ge.default).unestimatedIssuesIssueTermRefresh : (0, $8m1Ge.default).unestimatedIssues, {
        notEstimated: notEstimated
    })));
};
const $a3ba44993908e9fe$var$sectionWrapperStyles = (0, $8CUq3.xcss)({
    margin: '0',
    padding: '0'
}); /**
     * These are used in the version panel as well so they are exported from here.
     * Ideally the version panel should define its own colocated compiled components to use instead of importing from the epic panel.
     */ 
const $a3ba44993908e9fe$export$cfbd4f6ecd2ccfc8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $a3ba44993908e9fe$export$541d39676097f853 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1b66 _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $a3ba44993908e9fe$export$9c31e3b2b51be3d6 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_14jabjs": (0, $lD23V.default)((0, $gJwmE.cardColor).default.textColor)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81o8v _syaz15fh",
            __cmplp.className
        ])
    });
});
const $a3ba44993908e9fe$export$59634af339c2a1fe = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "dt", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_k48pi7a9",
            __cmplp.className
        ])
    });
});
const $a3ba44993908e9fe$export$6c261ad8077c7332 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "dd", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
});
const $a3ba44993908e9fe$export$7ba3b4abeaca5f47 = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "dt",
        xcss: $a3ba44993908e9fe$var$estimateLabelStyles
    }, children), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3ba44993908e9fe$export$59634af339c2a1fe, null, children));
const $a3ba44993908e9fe$export$5d603d368e732a5b = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "dd",
        xcss: $a3ba44993908e9fe$var$estimateMessageStyles
    }, children), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3ba44993908e9fe$export$6c261ad8077c7332, null, children));
const $a3ba44993908e9fe$export$43d56d6f8adb025c = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $a3ba44993908e9fe$var$subtextStyles
    }, children), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3ba44993908e9fe$export$9c31e3b2b51be3d6, null, children));
const $a3ba44993908e9fe$var$estimateLabelStyles = (0, $8CUq3.xcss)({
    font: 'font.body',
    color: 'color.text.subtle'
});
const $a3ba44993908e9fe$var$estimateMessageStyles = (0, $8CUq3.xcss)({
    font: 'font.body',
    color: 'color.text',
    marginTop: 'space.0'
});
const $a3ba44993908e9fe$var$subtextStyles = (0, $8CUq3.xcss)({
    font: 'font.body.UNSAFE_small',
    color: 'color.text.subtle'
});
var $a3ba44993908e9fe$export$2e2bcd8739ae039 = $a3ba44993908e9fe$var$EstimateField;

});
parcelRegister("etKNj", function(module, exports) {

$parcel$export(module.exports, "timeTrackingFormatter", () => $5d7d4350edc91a82$export$5169d8c8f9327e33);
$parcel$export(module.exports, "timeTrackingFormatterWithDefaults", () => $5d7d4350edc91a82$export$71be3aa954f6065b);
$parcel$export(module.exports, "timeTrackingFormatterLongForm", () => $5d7d4350edc91a82$export$bb4e82d8c2aeeff1);
$parcel$export(module.exports, "transformAGGToJiraTimeFormat", () => $5d7d4350edc91a82$export$9dccd3a07969375d);
$parcel$export(module.exports, "transformAGGToJiraTimeUnit", () => $5d7d4350edc91a82$export$8516173ab945b52f);

var $gBj4V = parcelRequire("gBj4V");

var $lgkxY = parcelRequire("lgkxY");

var $4TB2x = parcelRequire("4TB2x");
const $5d7d4350edc91a82$var$validate = (condition)=>(distance)=>condition ? distance : 0;
// Format time to be 2 decimal places without trailing zeros
const $5d7d4350edc91a82$var$timeFormatter = (time, unit)=>time > 0 ? `${time.toFixed(2).replace(/\.?0+$/, '')}${unit}` : `0${unit}`;
const $5d7d4350edc91a82$var$timePrettyFormatter = (timeInSeconds, units, formatMessage)=>{
    const timeForZero = `0${formatMessage(units[3].suffix)}`;
    if (timeInSeconds <= 0) return timeForZero;
    const initialTimeObj = {
        secondsRemaining: timeInSeconds,
        time: ''
    };
    const result = units.reduce((timeObj, unit)=>{
        if (unit.seconds <= 0) return timeObj;
        const currentTimeValue = Math.floor(timeObj.secondsRemaining / unit.seconds);
        const secondsRemaining = currentTimeValue > 0 ? timeObj.secondsRemaining % unit.seconds : timeObj.secondsRemaining;
        const time = currentTimeValue > 0 ? `${timeObj.time} ${currentTimeValue}${formatMessage(unit.suffix)}` : timeObj.time;
        return {
            secondsRemaining: secondsRemaining,
            time: time
        };
    }, initialTimeObj);
    return result.time.trim() || timeForZero;
};
const $5d7d4350edc91a82$var$timePrettyFormatterLongForm = (timeInSeconds, units, formatMessage)=>{
    const timeForZero = `0 ${formatMessage(units[3].suffix, {
        [units[3].type]: 0
    })}`;
    if (timeInSeconds <= 0) return timeForZero;
    const initialTimeObj = {
        secondsRemaining: timeInSeconds,
        time: ''
    };
    const result = units.reduce((timeObj, unit)=>{
        if (unit.seconds <= 0) return timeObj;
        const { suffix: suffix, type: type } = unit;
        const currentTimeValue = Math.floor(timeObj.secondsRemaining / unit.seconds);
        if (currentTimeValue === 1) return {
            secondsRemaining: timeObj.secondsRemaining % unit.seconds,
            time: `${timeObj.time} ${currentTimeValue} ${formatMessage(suffix, {
                [type]: currentTimeValue
            })}`
        };
        const secondsRemaining = currentTimeValue > 1 ? timeObj.secondsRemaining % unit.seconds : timeObj.secondsRemaining;
        const time = currentTimeValue > 1 ? `${timeObj.time} ${currentTimeValue} ${formatMessage(suffix, {
            [type]: currentTimeValue
        })}` : timeObj.time;
        return {
            secondsRemaining: secondsRemaining,
            time: time
        };
    }, initialTimeObj);
    return result.time.trim() || timeForZero;
};
const $5d7d4350edc91a82$export$5169d8c8f9327e33 = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat } = (0, $gBj4V.defaultTimeTrackingOptions), { formatMessage: formatMessage })=>{
    const isTimeValid = timeInSeconds > 0;
    const isTimeInDaysValid = isTimeValid && workingHoursPerDay > 0;
    const unit = (0, $4TB2x.createUnit)(timeInSeconds);
    const units = [
        unit({
            type: 'week',
            suffix: (0, $lgkxY.default).timeUnitWeek,
            seconds: Math.max(workingDaysPerWeek, 0) * Math.max(workingHoursPerDay, 0) * (0, $gBj4V.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'day',
            suffix: (0, $lgkxY.default).timeUnitDay,
            transform: $5d7d4350edc91a82$var$validate(isTimeInDaysValid),
            seconds: Math.max(workingHoursPerDay, 0) * (0, $gBj4V.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'hour',
            suffix: (0, $lgkxY.default).timeUnitHour,
            transform: $5d7d4350edc91a82$var$validate(isTimeValid),
            seconds: (0, $gBj4V.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'minute',
            suffix: (0, $lgkxY.default).timeUnitMinute,
            seconds: (0, $gBj4V.SECONDS_PER_MINUTE)
        })
    ];
    switch(timeFormat){
        case (0, $gBj4V.TimeFormats).DAYS:
            return $5d7d4350edc91a82$var$timeFormatter(units[1].time, formatMessage(units[1].suffix));
        case (0, $gBj4V.TimeFormats).HOURS:
            return $5d7d4350edc91a82$var$timeFormatter(units[2].time, formatMessage(units[2].suffix));
        case (0, $gBj4V.TimeFormats).PRETTY:
        default:
            return $5d7d4350edc91a82$var$timePrettyFormatter(timeInSeconds, units, formatMessage);
    }
};
const $5d7d4350edc91a82$export$71be3aa954f6065b = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat }, intl)=>{
    const timeTrackingSettings = {
        workingHoursPerDay: workingHoursPerDay || (0, $gBj4V.defaultTimeTrackingOptions).workingHoursPerDay,
        workingDaysPerWeek: workingDaysPerWeek || (0, $gBj4V.defaultTimeTrackingOptions).workingDaysPerWeek,
        timeFormat: timeFormat || (0, $gBj4V.defaultTimeTrackingOptions).timeFormat,
        defaultUnit: (0, $gBj4V.defaultTimeTrackingOptions).defaultUnit
    };
    return $5d7d4350edc91a82$export$5169d8c8f9327e33(timeInSeconds || 0, timeTrackingSettings, intl);
};
const $5d7d4350edc91a82$export$bb4e82d8c2aeeff1 = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat } = (0, $gBj4V.defaultTimeTrackingOptions), { formatMessage: formatMessage })=>{
    const isTimeValid = timeInSeconds > 0;
    const isTimeInDaysValid = isTimeValid && workingHoursPerDay > 0;
    const unit = (0, $4TB2x.createUnit)(timeInSeconds);
    const units = [
        unit({
            type: 'week',
            suffix: (0, $lgkxY.default).timeUnitLongWeek,
            seconds: Math.max(workingDaysPerWeek, 0) * Math.max(workingHoursPerDay, 0) * (0, $gBj4V.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'day',
            suffix: (0, $lgkxY.default).timeUnitLongDay,
            transform: $5d7d4350edc91a82$var$validate(isTimeInDaysValid),
            seconds: Math.max(workingHoursPerDay, 0) * (0, $gBj4V.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'hour',
            suffix: (0, $lgkxY.default).timeUnitLongHour,
            transform: $5d7d4350edc91a82$var$validate(isTimeValid),
            seconds: (0, $gBj4V.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'minute',
            suffix: (0, $lgkxY.default).timeUnitLongMinute,
            seconds: (0, $gBj4V.SECONDS_PER_MINUTE)
        })
    ];
    switch(timeFormat){
        case (0, $gBj4V.TimeFormats).DAYS:
            return $5d7d4350edc91a82$var$timeFormatter(units[1].time, ` ${formatMessage(units[1].suffix, {
                day: units[1].time
            })}`);
        case (0, $gBj4V.TimeFormats).HOURS:
            return $5d7d4350edc91a82$var$timeFormatter(units[2].time, ` ${formatMessage(units[2].suffix, {
                hour: units[2].time
            })}`);
        case (0, $gBj4V.TimeFormats).PRETTY:
        default:
            return $5d7d4350edc91a82$var$timePrettyFormatterLongForm(timeInSeconds, units, formatMessage);
    }
};
const $5d7d4350edc91a82$export$9dccd3a07969375d = (format)=>{
    switch(String(format).toLowerCase()){
        case (0, $gBj4V.TimeFormats).DAYS:
            return (0, $gBj4V.TimeFormats).DAYS;
        case (0, $gBj4V.TimeFormats).HOURS:
            return (0, $gBj4V.TimeFormats).HOURS;
        case (0, $gBj4V.TimeFormats).PRETTY:
            return (0, $gBj4V.TimeFormats).PRETTY;
        default:
            return (0, $gBj4V.TimeFormats).DAYS;
    }
};
const $5d7d4350edc91a82$export$8516173ab945b52f = (defaultUnit)=>{
    switch(String(defaultUnit).toLowerCase()){
        case (0, $gBj4V.TimeUnits).DAY:
            return (0, $gBj4V.TimeUnits).DAY;
        case (0, $gBj4V.TimeUnits).HOUR:
            return (0, $gBj4V.TimeUnits).HOUR;
        case (0, $gBj4V.TimeUnits).MINUTE:
            return (0, $gBj4V.TimeUnits).MINUTE;
        case (0, $gBj4V.TimeUnits).WEEK:
            return (0, $gBj4V.TimeUnits).WEEK;
        default:
            return (0, $gBj4V.TimeUnits).DAY;
    }
};

});
parcelRegister("lgkxY", function(module, exports) {

$parcel$export(module.exports, "default", () => $00e424f4a1d744f3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $00e424f4a1d744f3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    timeUnitWeek: {
        "id": "time-tracking-formatter.time-unit-week",
        "defaultMessage": "w"
    },
    timeUnitDay: {
        "id": "time-tracking-formatter.time-unit-day",
        "defaultMessage": "d"
    },
    timeUnitHour: {
        "id": "time-tracking-formatter.time-unit-hour",
        "defaultMessage": "h"
    },
    timeUnitMinute: {
        "id": "time-tracking-formatter.time-unit-minute",
        "defaultMessage": "m"
    },
    timeUnitLongWeek: {
        "id": "time-tracking-formatter.time-unit-long-week",
        "defaultMessage": "{week, plural, zero {weeks} one {week} other {weeks} }"
    },
    timeUnitLongDay: {
        "id": "time-tracking-formatter.time-unit-long-day",
        "defaultMessage": "{day, plural, zero {days} one {day} other {days} }"
    },
    timeUnitLongHour: {
        "id": "time-tracking-formatter.time-unit-long-hour",
        "defaultMessage": "{hour, plural, zero {hours} one {hour} other {hours} }"
    },
    timeUnitLongMinute: {
        "id": "time-tracking-formatter.time-unit-long-minute",
        "defaultMessage": "{minute, plural, zero {minutes} one {minute} other {minutes} }"
    }
});

});

parcelRegister("4TB2x", function(module, exports) {

$parcel$export(module.exports, "createUnit", () => $d8f5ee4c356dec74$export$aab44654646f3ccc);
const $d8f5ee4c356dec74$export$aab44654646f3ccc = (timeInSeconds)=>({ suffix: suffix, seconds: seconds, type: type, transform: transform })=>{
        const distance = timeInSeconds / seconds;
        const time = transform ? transform(distance) : distance;
        return {
            seconds: seconds,
            suffix: suffix,
            time: time,
            type: type
        };
    };

});


parcelRegister("in6eD", function(module, exports) {

$parcel$export(module.exports, "roundToTwoDecimalPlaces", () => $f9e9d0a51ba7525c$export$edaf2b90b4b014f2);
const $f9e9d0a51ba7525c$export$edaf2b90b4b014f2 = (value)=>Math.round((value + Number.EPSILON) * 100) / 100;

});

parcelRegister("8m1Ge", function(module, exports) {

$parcel$export(module.exports, "default", () => $707ea215ac8f33b2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $707ea215ac8f33b2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-backlog-panel.common.estimate-field.label",
        "defaultMessage": "Estimate"
    },
    points: {
        "id": "software-backlog-panel.common.estimate-field.points",
        "defaultMessage": "{totalEstimate, plural, one {# point} other {# points}}"
    },
    percentageCompleted: {
        "id": "software-backlog-panel.common.estimate-field.percentage-completed",
        "defaultMessage": "{percentageCompleted, number, percent} of estimated work complete"
    },
    unestimatedIssues: {
        "id": "software-backlog-panel.common.estimate-field.unestimated-issues",
        "defaultMessage": "{notEstimated, plural, one {# issue} other {# issues}} unestimated"
    },
    pointsTooltip: {
        "id": "software-backlog-panel.common.estimate-field.points-tooltip",
        "defaultMessage": "{doneEstimate} of {totalEstimate, plural, one {# point} other {# points}} completed"
    },
    timeEstimateTooltip: {
        "id": "software-backlog-panel.common.estimate-field.time-estimate-tooltip",
        "defaultMessage": "{doneEstimate} of {totalEstimate} completed"
    },
    customEstimateTooltip: {
        "id": "software-backlog-panel.common.estimate-field.custom-estimate-tooltip",
        "defaultMessage": "{doneEstimate} of {totalEstimate, plural, one {#} other {#}} {name} completed"
    },
    unestimatedIssuesIssueTermRefresh: {
        "id": "software-backlog-panel.common.estimate-field.unestimated-issues-issue-term-refresh",
        "defaultMessage": "{notEstimated, plural, one {# work item} other {# work items}} unestimated"
    }
});

});


parcelRegister("53cZc", function(module, exports) {

$parcel$export(module.exports, "default", () => $34002171da7ffde2$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $9cto1 = parcelRequire("9cto1");
const $34002171da7ffde2$var$IssuesCount = ({ totalIssues: totalIssues, done: done })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        as: "dl",
        justifyContent: "space-between",
        xcss: $34002171da7ffde2$var$sectionWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($34002171da7ffde2$export$68aee4382043ef46, null, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $9cto1.default).issuesIssueTermRefresh : (0, $9cto1.default).issues)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($34002171da7ffde2$var$IssueCountDD, null, totalIssues)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        as: "dl",
        justifyContent: "space-between",
        xcss: $34002171da7ffde2$var$sectionWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($34002171da7ffde2$export$68aee4382043ef46, null, formatMessage((0, $9cto1.default).completed)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($34002171da7ffde2$var$IssueCountDD, null, done)));
};
var $34002171da7ffde2$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($34002171da7ffde2$var$IssuesCount);
const $34002171da7ffde2$var$sectionWrapperStyles = (0, $8CUq3.xcss)({
    margin: '0',
    padding: '0',
    marginTop: 'space.050'
});
const $34002171da7ffde2$var$issueCountLabelStyles = (0, $8CUq3.xcss)({
    font: 'font.body',
    color: 'color.text.subtle'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $34002171da7ffde2$var$IssueCountDTOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "dt", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_k48pi7a9",
            __cmplp.className
        ])
    });
});
const $34002171da7ffde2$var$IssueCountDD = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "dd", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
});
const $34002171da7ffde2$export$68aee4382043ef46 = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "dt",
        xcss: $34002171da7ffde2$var$issueCountLabelStyles
    }, children), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($34002171da7ffde2$var$IssueCountDTOld, null, children));

});
parcelRegister("9cto1", function(module, exports) {

$parcel$export(module.exports, "default", () => $48ee866ad05caa4e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $48ee866ad05caa4e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    issues: {
        "id": "software-backlog-panel.common.issues-count.issues",
        "defaultMessage": "Issues"
    },
    completed: {
        "id": "software-backlog-panel.common.issues-count.completed",
        "defaultMessage": "Completed"
    },
    issuesIssueTermRefresh: {
        "id": "software-backlog-panel.common.issues-count.issues-issue-term-refresh",
        "defaultMessage": "Work items"
    }
});

});


parcelRegister("fbWyS", function(module, exports) {

$parcel$export(module.exports, "Divider", () => $f6989252e8ae2082$export$2e0a83ec2e27ecbb);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $f6989252e8ae2082$var$dividerStyles = null;
const $f6989252e8ae2082$export$2e0a83ec2e27ecbb = ()=>/*#__PURE__*/ $5uXOq.createElement("hr", {
        role: "presentation",
        className: (0, $bwpsq.default)([
            "_19itidpf _n7zlzgxb _tnqlu2gc _1x7012x7"
        ])
    });

});

parcelRegister("14Waf", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1d45d80449468e4$export$2e2bcd8739ae039);

var $az4zD = parcelRequire("az4zD");

var $2CTqw = parcelRequire("2CTqw");
var $e1d45d80449468e4$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)((0, $2CTqw.default));

});
parcelRegister("2CTqw", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c1e82ce953d03e8$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hGgHi = parcelRequire("hGgHi");

var $hjSnd = parcelRequire("hjSnd");

var $dCm1o = parcelRequire("dCm1o");

var $kyWip = parcelRequire("kyWip");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $4c1e82ce953d03e8$var$EmptyValue = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1fxt",
            __cmplp.className
        ])
    });
});
const $4c1e82ce953d03e8$var$DateLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $hjSnd.FieldHeadingTitle), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.isVisualRefreshEnabled ? "_12r2i7a9" : "_12r2bfng",
            !__cmplp.isVisualRefreshEnabled && "_1w901fxt",
            __cmplp.className
        ])
    });
});
const $4c1e82ce953d03e8$var$ReadContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _otyru2gc _syaz1fxt",
            __cmplp.className
        ])
    });
});
var $4c1e82ce953d03e8$export$2e2bcd8739ae039 = ({ label: label, date: date, intl: { formatDate: formatDate, formatMessage: formatMessage } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4c1e82ce953d03e8$var$DateLabel, {
        isVisualRefreshEnabled: (0, $dCm1o.isVisualRefreshEnabled)()
    }, label), !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(date) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4c1e82ce953d03e8$var$ReadContainer, null, formatDate(date, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        timeZone: 'UTC'
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4c1e82ce953d03e8$var$EmptyValue, null, formatMessage((0, $kyWip.default).none)));

});
parcelRegister("hjSnd", function(module, exports) {

$parcel$export(module.exports, "animationFadeIn", () => $46fb5b8c02da4832$export$5b770964b96200c1);
$parcel$export(module.exports, "FIELD_WRAPPER_COMPONENT_SELECTOR", () => $46fb5b8c02da4832$export$760fd24410df5fa0);
$parcel$export(module.exports, "FieldHeadingIconsVisibility", () => $46fb5b8c02da4832$export$f59c6cdc64591e40);
$parcel$export(module.exports, "FieldWrapper", () => $46fb5b8c02da4832$export$6a00f65eec6002a6);
$parcel$export(module.exports, "fieldHeadingIconsCss", () => $46fb5b8c02da4832$export$ddb92a8141f8005e);
$parcel$export(module.exports, "SideBySideField", () => $46fb5b8c02da4832$export$e5dd22bc212e7c08);
$parcel$export(module.exports, "FieldHeadingSideBySide", () => $46fb5b8c02da4832$export$5af56773efb90dc2);
$parcel$export(module.exports, "FIELD_HEADING_TITLE_COMPONENT_SELECTOR", () => $46fb5b8c02da4832$export$27dd6acbb09d64a0);
$parcel$export(module.exports, "FieldHeadingTitle", () => $46fb5b8c02da4832$export$947d5e0776c984dd);
$parcel$export(module.exports, "MULTILINE_FIELD_HEADING_TITLE_COMPONENT_SELECTOR", () => $46fb5b8c02da4832$export$3631a5c0b71e5fa6);
$parcel$export(module.exports, "MultilineFieldHeadingTitle", () => $46fb5b8c02da4832$export$7f55a99d7dec33cb);
$parcel$export(module.exports, "FieldHeadingIconsContainer", () => $46fb5b8c02da4832$export$2abed9becd14e08);
$parcel$export(module.exports, "MultilineFieldHeading", () => $46fb5b8c02da4832$export$1a4b3736f8ddb19a);
$parcel$export(module.exports, "MultilineFieldHeadingView", () => $46fb5b8c02da4832$export$af99f65e154b41d1);
$parcel$export(module.exports, "StyledFieldHeading", () => $46fb5b8c02da4832$export$12de48230c9f63a1);
$parcel$export(module.exports, "CustomFieldHeadingWithBottomMargin", () => $46fb5b8c02da4832$export$1e09f33a591b411d);
$parcel$export(module.exports, "DevPanelIconContainer", () => $46fb5b8c02da4832$export$1f3e3b60331a6712);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $47bDC = parcelRequire("47bDC");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $2vSU6 = parcelRequire("2vSU6");

var $gwIPs = parcelRequire("gwIPs");

var $6s1PB = parcelRequire("6s1PB");

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $2gCtH = parcelRequire("2gCtH");

var $iv6X1 = parcelRequire("iv6X1");

var $crmHM = parcelRequire("crmHM");

var $gr93b = parcelRequire("gr93b");

var $93Yeu = parcelRequire("93Yeu");

var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");
const $46fb5b8c02da4832$export$f0117e48a06cb805 = '[data-component-selector="jira-issue-field-edit-field-edit-button"]';
const $46fb5b8c02da4832$export$582300267c3b9252 = 40.0; // eslint-disable-next-line @compiled/no-exported-keyframes, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $46fb5b8c02da4832$export$5b770964b96200c1 = null; // eslint-disable-next-line @compiled/no-exported-keyframes, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $46fb5b8c02da4832$export$a106f18d99f19ea0 = null;
const $46fb5b8c02da4832$var$fieldWrapperSelectorName = 'jira-issue-field-heading-field-wrapper';
const $46fb5b8c02da4832$export$760fd24410df5fa0 = `[data-component-selector="${$46fb5b8c02da4832$var$fieldWrapperSelectorName}"]`; // APP-649 Workaround the static evaluation error with a type assertion
const $46fb5b8c02da4832$var$FIELD_ICON_POPUP_WRAPPER_COMPONENT_SELECTOR_WORKAROUND = '[data-component-selector="jira-issue-field-icon-popup-wrapper"]'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $46fb5b8c02da4832$var$FieldHeadingIconsVisibilityOldWithoutFlickerFix = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_o0a01u4f _s1t41u4f _29a51440 _nopz1440 _le7a1440 _uqy11440",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $46fb5b8c02da4832$var$FieldHeadingIconsVisibilityOldWithFlickerFix = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1f775xq6 _do8z5xq6 _gzzzidpf _z7alidpf _1rv1kb7n _hb7ckb7n _174ukb7n _exurkb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $46fb5b8c02da4832$var$FieldHeadingIconsVisibilityNewWithoutFlickerFix = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_on331u4f _o0a01u4f _s1t41u4f _1c061440 _29a51440 _nopz1440 _g6d31440 _le7a1440 _uqy11440",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $46fb5b8c02da4832$var$FieldHeadingIconsVisibilityNewWithFlickerFix = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1rre5xq6 _1f775xq6 _do8z5xq6 _11mkidpf _gzzzidpf _z7alidpf _17ulkb7n _1rv1kb7n _hb7ckb7n _18nqkb7n _174ukb7n _exurkb7n",
            __cmplp.className
        ])
    });
});
const $46fb5b8c02da4832$var$FieldHeadingIconsVisibilityNew = (0, $cSD7y.componentWithFG)('pinned_fields_iv_llc_fields', $46fb5b8c02da4832$var$FieldHeadingIconsVisibilityNewWithFlickerFix, $46fb5b8c02da4832$var$FieldHeadingIconsVisibilityNewWithoutFlickerFix);
const $46fb5b8c02da4832$var$FieldHeadingIconsVisibilityOld = (0, $cSD7y.componentWithFG)('pinned_fields_iv_llc_fields', $46fb5b8c02da4832$var$FieldHeadingIconsVisibilityOldWithFlickerFix, $46fb5b8c02da4832$var$FieldHeadingIconsVisibilityOldWithoutFlickerFix);
const $46fb5b8c02da4832$export$f59c6cdc64591e40 = (0, $cSD7y.componentWithFG)('issue_view_field_config_edit', $46fb5b8c02da4832$var$FieldHeadingIconsVisibilityNew, $46fb5b8c02da4832$var$FieldHeadingIconsVisibilityOld); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $46fb5b8c02da4832$var$FieldWrapperComponentOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1n261g80 _otyrpxbi _1nmz1hna",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $46fb5b8c02da4832$var$FieldWrapperComponentNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $46fb5b8c02da4832$var$FieldHeadingIconsVisibilityNew, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1n261g80 _otyrpxbi _1nmz1hna _gy1pv47k",
            __cmplp.className
        ])
    });
});
const $46fb5b8c02da4832$var$FieldWrapperComponent = (0, $cSD7y.componentWithFG)('issue_view_field_config_edit', $46fb5b8c02da4832$var$FieldWrapperComponentNew, $46fb5b8c02da4832$var$FieldWrapperComponentOld);
const $46fb5b8c02da4832$export$6a00f65eec6002a6 = (props)=>{
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey) || null;
    const isJSMProject = projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);
    const appEditions = (0, $k9JTq.useAppEditions)();
    let editionFromTenantContext;
    if (projectType) editionFromTenantContext = (0, $ldyPw.getEdition)((0, $efvDm.getApplicationForProject)(projectType), appEditions);
    return !isJSMProject && editionFromTenantContext !== (0, $ldyPw.PREMIUM_EDITION) && ((0, $6s1PB.expVal)('pin_fields_observation_exp', 'isPinFieldObservabilityExpEnabled', false) || (0, $6s1PB.expVal)('jira_pin_field_configurability_experiment', 'isPinFieldConfigurabilityEnabled', false)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($46fb5b8c02da4832$var$JiraPinFieldConfigurabilityFieldWrapper, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($46fb5b8c02da4832$var$FieldWrapperComponent, {
        "data-component-selector": $46fb5b8c02da4832$var$fieldWrapperSelectorName,
        ...props
    });
};
const $46fb5b8c02da4832$var$issueViewFieldConfigEditStyles = null;
const $46fb5b8c02da4832$var$JiraPinFieldConfigurabilityFieldWrapperOld = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-component-selector": $46fb5b8c02da4832$var$fieldWrapperSelectorName,
        ...props,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1n261g80 _otyrpxbi _1nmz1hna _o0a01u4f _s1t41u4f _1r3m1440 _29a51440 _le7a1440 _uqy11440",
            (0, $4R6GH.fg)('issue_view_field_config_edit') && "_gy1pv47k"
        ])
    });
const $46fb5b8c02da4832$var$JiraPinFieldConfigurabilityFieldWrapperNew = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-component-selector": $46fb5b8c02da4832$var$fieldWrapperSelectorName,
        ...props,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1n261g80 _otyrpxbi _1nmz1hna _on331u4f _o0a01u4f _s1t41u4f _16pe1440 _1r3m1440 _29a51440 _g6d31440 _le7a1440 _uqy11440",
            (0, $4R6GH.fg)('issue_view_field_config_edit') && "_gy1pv47k"
        ])
    });
const $46fb5b8c02da4832$var$JiraPinFieldConfigurabilityFieldWrapper = (0, $cSD7y.componentWithFG)('issue_view_field_config_edit', $46fb5b8c02da4832$var$JiraPinFieldConfigurabilityFieldWrapperNew, $46fb5b8c02da4832$var$JiraPinFieldConfigurabilityFieldWrapperOld); /**
                                                                                                                                                                                          * @deprecated `fieldHeadingIconsCss` is consumed by other styled-components (e.g. src/packages/servicedesk/post-incident-review/src/ui/primary-incident/styled.tsx )
                                                                                                                                                                                          * TODO: Remove `fieldHeadingIconsCss` once its consumers are migrated to CompiledCSS
                                                                                                                                                                                          */ 
const $46fb5b8c02da4832$export$ddb92a8141f8005e = /*#__PURE__*/ (0, $47bDC.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    [`${0, $gr93b.FieldPinButtonControl}, ${0, $crmHM.FieldIconPopupWrapperControl}`]: {
        animation: `${$46fb5b8c02da4832$export$a106f18d99f19ea0} 0.15s linear forwards`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`:hover ${0, $gr93b.FieldPinButtonControl}, :hover ${0, $crmHM.FieldIconPopupWrapperControl}, :focus-within ${0, $gr93b.FieldPinButtonControl}, :focus-within ${0, $crmHM.FieldIconPopupWrapperControl}`]: {
        animation: `${$46fb5b8c02da4832$export$5b770964b96200c1} 0.15s linear forwards`
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $46fb5b8c02da4832$var$SideBySideFieldOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasTooltip: hasTooltip, isEditing: isEditing, fixedHeight: fixedHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_o1a0pj": (0, $lD23V.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            !__cmplp.isEditing && __cmplp.fixedHeight === true ? `${(0, $gwIPs.gridSize) * 4}px` : undefined)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1bsb1nrf _vchhusvi",
            __cmplp.hasTooltip ? "_1owx1p55" : "_196m1p55",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $46fb5b8c02da4832$var$SideBySideFieldNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasTooltip: hasTooltip, isEditing: isEditing, fixedHeight: fixedHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_o1a0pj": (0, $lD23V.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            !__cmplp.isEditing && __cmplp.fixedHeight === true ? `${(0, $gwIPs.gridSize) * 4}px` : undefined)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zidpf _i0dlf1ug _1bsb1nrf _vchhusvi _1ul91nrf",
            __cmplp.hasTooltip ? "_1owx1p55" : "_196m1p55",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
const $46fb5b8c02da4832$export$e5dd22bc212e7c08 = (0, $cSD7y.componentWithFG)('issue_view_field_config_edit', $46fb5b8c02da4832$var$SideBySideFieldNew, $46fb5b8c02da4832$var$SideBySideFieldOld);
const $46fb5b8c02da4832$var$fieldHeadingMaxWidthCss = /*#__PURE__*/ (0, $47bDC.css)({
    maxWidth: '170px'
}); // FIXME: type error in object syntax
// eslint-disable-next-line @typescript-eslint/no-explicit-any,  @atlaskit/design-system/no-css-tagged-template-expression
const $46fb5b8c02da4832$var$fieldHeadingCompactMaxWidthCss = /*#__PURE__*/ (0, $47bDC.css)`${({ isCompact: isCompact })=>isCompact ? undefined : $46fb5b8c02da4832$var$fieldHeadingMaxWidthCss}`; /**
                                                          * @deprecated `fieldHeadingSideBySideCss` is consumed by other styled-components (e.g. src/packages/development/releases-glance/src/view/styled.tsx)
                                                          * TODO: Remove `fieldHeadingSideBySideCss` once its consumers are migrated to CompiledCSS
                                                          */ 
const $46fb5b8c02da4832$export$39e618e716cf7ac7 = /*#__PURE__*/ (0, $47bDC.css)`${$46fb5b8c02da4832$export$ddb92a8141f8005e} position:relative;flex-grow:1;box-sizing:border-box;padding-right:${"var(--ds-space-300, 24px)"};min-width:120px;width:${$46fb5b8c02da4832$export$582300267c3b9252}%;padding-top:${"var(--ds-space-100, 8px)"};line-height:1;${$46fb5b8c02da4832$var$fieldHeadingCompactMaxWidthCss}`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $46fb5b8c02da4832$export$5af56773efb90dc2 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $46fb5b8c02da4832$export$f59c6cdc64591e40, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _16jlkb7n _vchhusvi _u5f31ejb _1ul968cl _1bsbhwvj _ca0qu2gc _vwz4kb7n",
            !__cmplp.isCompact && "_p12f7l9q",
            __cmplp.isMobile && __cmplp.isCompact && "_1tkezwfg _n3td1b66",
            __cmplp.isVisualRefreshEnabled && "_1e0c1txw _4cvr1h6o _ca0qidpf _u5f3idpf",
            __cmplp.className
        ])
    });
}); /*
        Unfoiling typography.h200 as @atlaskit/heading doesn't support
        extending of className prop making it complicated to apply ellipsis
        without wrapper components
    
        https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/design-system/theme/src/typography.tsx
    */ 
const $46fb5b8c02da4832$var$h200Styles = null;
const $46fb5b8c02da4832$var$FieldWrapperComponentForPinFieldConfigurabilityOld = null;
const $46fb5b8c02da4832$var$FieldWrapperComponentForPinFieldConfigurabilityNew = null;
const $46fb5b8c02da4832$var$fieldHeadingTitleSelectorName = 'jira-issue-field-heading-field-heading-title';
const $46fb5b8c02da4832$export$27dd6acbb09d64a0 = `[data-component-selector="${$46fb5b8c02da4832$var$fieldHeadingTitleSelectorName}"]`;
const $46fb5b8c02da4832$var$fieldHeadingTitleStyles = null;
const $46fb5b8c02da4832$var$fieldHeadingTitleStylesWithExperiment = null;
const $46fb5b8c02da4832$var$FieldHeadingTitleComponent = (props)=>{
    const { isExperimentEnabled: isExperimentEnabled } = (0, $iv6X1.useBespokeEmptyFieldTextExperiment)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("h3", {
        ...props,
        className: (0, $bwpsq.default)([
            "_11c82smr _k48p1wq8 _vwz41clk _syaz131l _19pkpxbi",
            isExperimentEnabled ? "_vchhusvi _syaz16l4" : "_vchhusvi _syaz1gjq"
        ])
    }, props.children);
};
const $46fb5b8c02da4832$export$947d5e0776c984dd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($46fb5b8c02da4832$var$FieldHeadingTitleComponent, {
        "data-component-selector": $46fb5b8c02da4832$var$fieldHeadingTitleSelectorName,
        ...props
    });
const $46fb5b8c02da4832$var$multilineFieldHeadingTitleSelectorName = 'jira-issue-field-heading-multiline-field-heading-title';
const $46fb5b8c02da4832$export$3631a5c0b71e5fa6 = `[data-component-selector="${$46fb5b8c02da4832$var$multilineFieldHeadingTitleSelectorName}"]`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $46fb5b8c02da4832$var$MultilineFieldHeadingTitleComponentOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _1reo15vq _18m915vq _k48p1wq8 _vwz41clk _19pkpxbi _o5721q9c _1bto1l2s _syaz1fxt",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $46fb5b8c02da4832$var$MultilineFieldHeadingTitleComponentNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _1reo15vq _18m915vq _k48p1wq8 _vwz41clk _19pkpxbi _o5721q9c _1bto1l2s _syaz1gjq",
            __cmplp.className
        ])
    });
});
const $46fb5b8c02da4832$var$MultilineFieldHeadingTitleComponent = (0, $cSD7y.componentWithFG)('thor_fix_for_jracloud-84411', $46fb5b8c02da4832$var$MultilineFieldHeadingTitleComponentNew, $46fb5b8c02da4832$var$MultilineFieldHeadingTitleComponentOld);
const $46fb5b8c02da4832$export$7f55a99d7dec33cb = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($46fb5b8c02da4832$var$MultilineFieldHeadingTitleComponent, {
        "data-component-selector": $46fb5b8c02da4832$var$multilineFieldHeadingTitleSelectorName,
        ...props
    });
const $46fb5b8c02da4832$var$fieldHeadingIconContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.100'
});
const $46fb5b8c02da4832$export$2abed9becd14e08 = ({ children: children, isCustomFieldConfigurationEnabled: isCustomFieldConfigurationEnabled })=>isCustomFieldConfigurationEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $46fb5b8c02da4832$var$fieldHeadingIconContainerStyles
    }, children) : children; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $46fb5b8c02da4832$var$MultilineFieldHeadingOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $46fb5b8c02da4832$export$f59c6cdc64591e40, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyr126e _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $46fb5b8c02da4832$var$MultilineFieldHeadingNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $46fb5b8c02da4832$export$f59c6cdc64591e40, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1y44 _otyr126e _1e0c1txw _4cvr1h6o _18u0r5cr _ca0qu2gc _u5f31b66 _n3tdu2gc _19bv1b66 _1bsb1ns9 _irr315ej",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $46fb5b8c02da4832$export$1a4b3736f8ddb19a = (0, $cSD7y.componentWithFG)('issue_view_field_config_edit', $46fb5b8c02da4832$var$MultilineFieldHeadingNew, $46fb5b8c02da4832$var$MultilineFieldHeadingOld); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $46fb5b8c02da4832$export$af99f65e154b41d1 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $46fb5b8c02da4832$export$1a4b3736f8ddb19a, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1y44 _1bsb1ns9 _ca0qu2gc _u5f31b66 _n3tdu2gc _19bv1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $46fb5b8c02da4832$export$12de48230c9f63a1 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $46fb5b8c02da4832$export$5af56773efb90dc2, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_bud1116y _1wyw116y _1x8f116y _ievayfq0 _169syfq0 _c1r1yfq0 _omua116y _ax5w116y _1e29116y",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $46fb5b8c02da4832$export$a3d12639af1fe986 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $46fb5b8c02da4832$export$12de48230c9f63a1, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $46fb5b8c02da4832$export$1e09f33a591b411d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $46fb5b8c02da4832$export$12de48230c9f63a1, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyr1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $46fb5b8c02da4832$export$1f3e3b60331a6712 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1tcg _18u0v77o _2hwx1i6y _19pkr5cr _kqswh2mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $46fb5b8c02da4832$export$ba0ba2df6c06b1aa = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _2hwx19bv _4t3i1crf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iv6X1", function(module, exports) {

$parcel$export(module.exports, "useBespokeEmptyFieldTextExperiment", () => $79e1a209ff1442cd$export$5a7b1bb3c8ba459f);

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $2gCtH = parcelRequire("2gCtH");

var $93Yeu = parcelRequire("93Yeu");

var $2vSU6 = parcelRequire("2vSU6");
const $79e1a209ff1442cd$var$useIsExperimentEligible = ()=>{
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    /* Some URL patterns where Issue view is rendered either in a modal or full page or in a sidebar
	The common pattern is presence of issue key in the URL pathname or search params
	1. /browse/TEST-1
	2. /issues/TEST-1
	3. /jira/software/c/projects/TEST/issues/TEST-1
	4. /jira/software/c/projects/TEST/boards/1?selectedIssue=TEST-1
	5. /jira/software/c/projects/TEST/boards/1/backlog?selectedIssue=TEST-1
	6. /jira/software/c/projects/TEST/list?selectedIssue=TEST-1
	*/ const ISSUE_KEY_REGEX = /[A-Z][A-Z0-9]+-\d+/;
    let isFieldRenderedInIssueView = false;
    try {
        isFieldRenderedInIssueView = // eslint-disable-next-line no-restricted-globals
        ISSUE_KEY_REGEX.test(location.search) || ISSUE_KEY_REGEX.test(location.pathname);
    } catch (error) {
        // If regex test fails for some reason, default to false
        isFieldRenderedInIssueView = false;
    }
    return projectType === (0, $2vSU6.SOFTWARE_PROJECT) && isFieldRenderedInIssueView && (0, $4R6GH.fg)('bespoke_empty_field_text_gate');
};
const $79e1a209ff1442cd$export$5a7b1bb3c8ba459f = ()=>{
    const isExperimentEligible = $79e1a209ff1442cd$var$useIsExperimentEligible();
    const isVisibleAlways = isExperimentEligible && (0, $6s1PB.expValEquals)('bespoke_empty_field_text_experiment', 'showBespokeFieldText', 'always', 'never');
    const isVisibleOnHover = isExperimentEligible && (0, $6s1PB.expValEquals)('bespoke_empty_field_text_experiment', 'showBespokeFieldText', 'hover', 'never');
    return {
        isExperimentEnabled: isVisibleAlways || isVisibleOnHover,
        isVisibleAlways: isVisibleAlways,
        isVisibleOnHover: isVisibleOnHover
    };
};

});

parcelRegister("crmHM", function(module, exports) {

$parcel$export(module.exports, "FieldIconPopup", () => $99653cf5ebd6e570$export$2cf5dc58704c9c6);
$parcel$export(module.exports, "FieldIconPopupWrapper", () => $99653cf5ebd6e570$export$521c4a081d93a985);
$parcel$export(module.exports, "FieldIconPopupWrapperControl", () => $99653cf5ebd6e570$export$a9af3f5afe66cb3f);
/* FieldIconPopup.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $fVnbM = parcelRequire("fVnbM");

var $1I7E8 = parcelRequire("1I7E8");

var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $gwIPs = parcelRequire("gwIPs");

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $fChT1 = parcelRequire("fChT1");

var $7Jmnq = parcelRequire("7Jmnq");

var $grJuq = parcelRequire("grJuq");
const $99653cf5ebd6e570$var$containerHeight = window.innerHeight < 600 ? 150 : 400; // This is visible for testing
const $99653cf5ebd6e570$export$f48224de87d33a65 = ()=>(0, $5uXOq.useState)(false);
const $99653cf5ebd6e570$export$2cf5dc58704c9c6 = /*#__PURE__*/ (0, $5uXOq.memo)(({ children: children, label: label, ...props })=>{
    let adfDescription;
    let customContent;
    if ('adfDescription' in props) adfDescription = props.adfDescription;
    else if ('customContent' in props) customContent = props.customContent;
    const [isOpen, setIsOpen] = $99653cf5ebd6e570$export$f48224de87d33a65();
    const [autoFocus, setAutoFocus] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onHide = ()=>setIsOpen(false);
    const onShow = ()=>setIsOpen(true);
    const { setCardHoverStatus: setCardHoverStatus, setTriggerHoverStatus: setTriggerHoverStatus } = (0, $fChT1.useCard)({
        onHide: onHide,
        onShow: onShow
    });
    const handleMouseEnter = (0, $5uXOq.useCallback)(()=>{
        setAutoFocus(false);
        setTriggerHoverStatus(true);
    }, [
        setTriggerHoverStatus
    ]);
    const handleMouseLeave = (0, $5uXOq.useCallback)(()=>{
        setTriggerHoverStatus(false);
    }, [
        setTriggerHoverStatus
    ]);
    const onMouseEnterContent = (0, $5uXOq.useCallback)(()=>{
        setAutoFocus(false);
        setCardHoverStatus(true);
    }, [
        setCardHoverStatus
    ]);
    const onMouseLeaveContent = (0, $5uXOq.useCallback)(()=>{
        setCardHoverStatus(false);
    }, [
        setCardHoverStatus
    ]);
    const handleTriggerClick = (0, $5uXOq.useCallback)(()=>{
        setTriggerHoverStatus(true);
        setAutoFocus(true);
    }, [
        setTriggerHoverStatus
    ]);
    const onPopupClose = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(false);
        setAutoFocus(false);
    }, [
        setIsOpen
    ]); // FIXME: Bento should fix that by extracting the forwarded component
    const CustomPopupContainer = (0, $5uXOq.useMemo)(()=>// eslint-disable-next-line react/no-unstable-nested-components
        /*#__PURE__*/ (0, $5uXOq.forwardRef)((containerProps, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($99653cf5ebd6e570$var$PopupCustomContainer, {
                ...containerProps,
                ref: ref,
                containerHeight: $99653cf5ebd6e570$var$containerHeight,
                onMouseEnter: onMouseEnterContent,
                onMouseLeave: onMouseLeaveContent,
                onClick: (e)=>e.stopPropagation()
            })), [
        onMouseEnterContent,
        onMouseLeaveContent
    ]);
    const fieldIconPopupTriggerWrapperOld = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            "aria-label": customContent ? label : formatMessage((0, $grJuq.default).moreInformation, {
                label: label
            }),
            ...triggerProps,
            onClick: handleTriggerClick,
            spacing: "none",
            appearance: "subtle",
            isSelected: isOpen,
            "data-component-selector": $99653cf5ebd6e570$export$ed75fb31bbc5ce0c,
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            interactionName: "auto-generated.jira-issue-field-icon-popup-button"
        }, children);
    const fieldIconPopupTriggerWrapperNew = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
            "aria-label": formatMessage((0, $grJuq.default).moreInformation, {
                label: label
            }),
            ...triggerProps,
            onClick: handleTriggerClick,
            "data-component-selector": $99653cf5ebd6e570$export$ed75fb31bbc5ce0c,
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            xcss: $99653cf5ebd6e570$var$fieldIconPopupTriggerWrapperNewStyles,
            interactionName: "auto-generated.jira-issue-field-icon-popup.button"
        }, children);
    const fieldIconPopupTriggerWrapper = (0, $4R6GH.fg)('issue_view_field_config_edit') ? fieldIconPopupTriggerWrapperNew : fieldIconPopupTriggerWrapperOld;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
        zIndex: (0, $gwIPs.layers).modal,
        autoFocus: autoFocus,
        isOpen: isOpen,
        onClose: onPopupClose,
        content: ()=>customContent || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Jmnq.default), {
                description: adfDescription
            }),
        trigger: fieldIconPopupTriggerWrapper,
        placement: "top" // @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<RefAttributes<unknown>>' is not assignable to type 'ComponentType<PopupComponentProps> | undefined'.
        ,
        popupComponent: CustomPopupContainer,
        boundary: "clippingParents",
        shouldFlip: true,
        testId: "issue-field-icon-popup.ak-popup"
    });
});
const $99653cf5ebd6e570$var$fieldIconPopupWrapperSelectorName = 'jira-issue-field-icon-popup-wrapper';
const $99653cf5ebd6e570$export$e97aec18d9615958 = `[data-component-selector="${$99653cf5ebd6e570$var$fieldIconPopupWrapperSelectorName}"]`;
const $99653cf5ebd6e570$export$ed75fb31bbc5ce0c = 'jira-issue-field-icon-popup-with-button-wrapper';
const $99653cf5ebd6e570$var$FIELD_ICON_POPUP_WITH_BUTTON_WRAPPER_COMPONENT_SELECTOR = `[data-component-selector="${$99653cf5ebd6e570$export$ed75fb31bbc5ce0c}"]`;
const $99653cf5ebd6e570$export$521c4a081d93a985 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($99653cf5ebd6e570$var$FieldIconPopupWrapperComponent, {
        "data-component-selector": $99653cf5ebd6e570$var$fieldIconPopupWrapperSelectorName,
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $99653cf5ebd6e570$var$PopupCustomContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { containerHeight: containerHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1gzoyxy": (0, $lD23V.default)(`${__cmplp.containerHeight}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo1wug _18m91wug _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bv1ejb _c71l1p8o _bfhkhp5a _16qszucj",
            __cmplp.className
        ])
    });
}); /**
     * @deprecated `FieldIconPopupWrapperControl` is used as component selector in `fieldHeadingIconsCss`
     * which is consumed by other styled-components (e.g. src/packages/servicedesk/post-incident-review/src/ui/primary-incident/styled.tsx )
     * TODO: Remove `FieldIconPopupWrapperControl` once its consumers are migrated to CompiledCSS
     */ 
const $99653cf5ebd6e570$export$a9af3f5afe66cb3f = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1o3r4gr-0"
})({
    color: "var(--ds-background-neutral-bold, #44546F)",
    cursor: 'pointer',
    marginLeft: "var(--ds-space-050, 4px)",
    flexShrink: 0,
    '&:hover': {
        color: "var(--ds-background-neutral-bold-hovered, #2C3E5D)"
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $99653cf5ebd6e570$var$FieldIconPopupWrapperComponentOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syazcdhy _80omtlke _18u01b66 _1o9zidpf _1vqwglyw _mp36glyw _1lddglyw _p85m1bsc _n30c1bsc _rq3hcdhy _bw8dyh40 _30l31bsc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $99653cf5ebd6e570$var$FieldIconPopupWrapperComponentNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syazcdhy _80omtlke _18u01b66 _1o9zidpf _ca0qv77o _p85m1bsc _n30c1bsc _rq3hcdhy _bw8dyh40 _30l31bsc",
            __cmplp.className
        ])
    });
});
const $99653cf5ebd6e570$var$FieldIconPopupWrapperComponent = (0, $cSD7y.componentWithFG)('issue_view_field_config_edit', $99653cf5ebd6e570$var$FieldIconPopupWrapperComponentNew, $99653cf5ebd6e570$var$FieldIconPopupWrapperComponentOld);
const $99653cf5ebd6e570$var$fieldIconPopupTriggerWrapperNewStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    width: '16px',
    height: '16px',
    padding: 'space.025',
    borderRadius: '4px',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'color.background.neutral.subtle',
    color: 'color.text.subtle',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    }
});

});
parcelRegister("fChT1", function(module, exports) {

$parcel$export(module.exports, "useCard", () => $5dd7036cf2013f67$export$5a0763f6a9ca51f0);

var $5uXOq = parcelRequire("5uXOq");
const $5dd7036cf2013f67$export$5a0763f6a9ca51f0 = ({ onHide: onHide, onShow: onShow, hoverDuration: hoverDuration = 800 })=>{
    const hideTimeoutId = (0, $5uXOq.useRef)(null);
    const showTimeoutId = (0, $5uXOq.useRef)(null);
    const triggerHoverStatus = (0, $5uXOq.useRef)(false);
    const cardHoverStatus = (0, $5uXOq.useRef)(false);
    const executeOnHide = ()=>{
        if (hideTimeoutId.current) // @ts-expect-error - TS2769 - No overload matches this call.
        clearTimeout(hideTimeoutId.current);
        hideTimeoutId.current = setTimeout(()=>{
            if (!triggerHoverStatus.current && !cardHoverStatus.current) onHide();
        }, 400);
    };
    const executeOnShow = ()=>{
        if (showTimeoutId.current) // @ts-expect-error - TS2769 - No overload matches this call.
        clearTimeout(showTimeoutId.current);
        showTimeoutId.current = setTimeout(()=>{
            // only able to show card when trigger is hovering after 800 milliseconds
            if (triggerHoverStatus.current) onShow();
        }, hoverDuration);
    };
    const setTriggerHoverStatus = (status)=>{
        triggerHoverStatus.current = status;
        executeOnHide();
        executeOnShow();
    };
    const setCardHoverStatus = (status)=>{
        cardHoverStatus.current = status;
        executeOnHide();
        executeOnShow();
    };
    return {
        setCardHoverStatus: setCardHoverStatus,
        setTriggerHoverStatus: setTriggerHoverStatus
    };
};

});

parcelRegister("7Jmnq", function(module, exports) {

$parcel$export(module.exports, "default", () => $527888ed1dca7d57$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $kOFhM = parcelRequire("kOFhM");

var $f5oqj = parcelRequire("f5oqj");

var $4R6GH = parcelRequire("4R6GH");

var $6a30R = parcelRequire("6a30R");

var $8zOmE = parcelRequire("8zOmE");
var $isuse = parcelRequire("isuse");
const $527888ed1dca7d57$var$Card = /*#__PURE__*/ (0, $5uXOq.memo)(({ description: description })=>{
    const onMount = (analyticsEvent)=>(0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'CustomFieldDescription mounted');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($527888ed1dca7d57$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isuse.MountEvent), {
        onMount: onMount
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5oqj.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        document: description,
        schema: (0, $kOFhM.defaultSchema),
        disableHeadingIDs: true,
        eventHandlers: {
            smartCard: {
                onClick: (0, $6a30R.onLinkClick)
            },
            link: {
                onClick: (0, $6a30R.onLinkClick)
            }
        },
        featureFlags: {
            codeBidiWarnings: true,
            'code-bidi-warnings': true,
            'renderer-tti-tracking': (0, $4R6GH.fg)('renderer_tti_tracking_jira')
        },
        smartLinks: (0, $6a30R.smartLinksDefault)
    }));
});
var $527888ed1dca7d57$export$2e2bcd8739ae039 = $527888ed1dca7d57$var$Card;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $527888ed1dca7d57$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12f1k99 _1bsb1wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kOFhM", function(module, exports) {

$parcel$export(module.exports, "defaultSchemaConfig", () => $f27880a8173018db$export$e4e3ac1fa64862db);
$parcel$export(module.exports, "getSchemaBasedOnStage", () => $f27880a8173018db$export$fd147e7d448dea03);
$parcel$export(module.exports, "defaultSchema", () => $f27880a8173018db$export$1db618b7b2275ea1);

var $8QpSo = parcelRequire("8QpSo");

var $7kC9H = parcelRequire("7kC9H");
var $47jug = parcelRequire("47jug");
var $gZoER = parcelRequire("gZoER");
var $2FIVU = parcelRequire("2FIVU");
var $9UDEr = parcelRequire("9UDEr");

var $kBho7 = parcelRequire("kBho7");
const $f27880a8173018db$var$getDefaultSchemaConfig = ()=>{
    const defaultSchemaConfig = {
        nodes: [
            'doc',
            'paragraph',
            'text',
            'bulletList',
            'orderedList',
            'listItem',
            'heading',
            'blockquote',
            'codeBlock',
            'panel',
            'rule',
            'image',
            'caption',
            'mention',
            'media',
            'mediaGroup',
            'mediaSingle',
            'mediaInline',
            'confluenceUnsupportedBlock',
            'confluenceUnsupportedInline',
            'confluenceJiraIssue',
            'expand',
            'nestedExpand',
            'extension',
            'inlineExtension',
            'bodiedExtension',
            'hardBreak',
            'emoji',
            'table',
            'tableCell',
            'tableHeader',
            'tableRow',
            'decisionList',
            'decisionItem',
            'taskList',
            'taskItem',
            'unknownBlock',
            'date',
            'status',
            'placeholder',
            'layoutSection',
            'layoutColumn',
            'inlineCard',
            'blockCard',
            'embedCard',
            'unsupportedBlock',
            'unsupportedInline'
        ],
        marks: [
            'link',
            'em',
            'strong',
            'strike',
            'subsup',
            'underline',
            'code',
            'textColor',
            'backgroundColor',
            'confluenceInlineComment',
            'breakout',
            'alignment',
            'indentation',
            'annotation',
            'dataConsumer',
            'border',
            'unsupportedMark',
            'unsupportedNodeAttribute',
            'typeAheadQuery',
            // https://product-fabric.atlassian.net/browse/ED-10214,
            'fragment'
        ]
    };
    return defaultSchemaConfig;
};
const $f27880a8173018db$export$e4e3ac1fa64862db = $f27880a8173018db$var$getDefaultSchemaConfig();
const $f27880a8173018db$export$fd147e7d448dea03 = (0, $8QpSo.default)((stage = 'final')=>{
    const defaultSchemaConfig = $f27880a8173018db$var$getDefaultSchemaConfig();
    if (stage === 'stage0') defaultSchemaConfig.customNodeSpecs = {
        layoutSection: (0, $gZoER.layoutSectionWithSingleColumn),
        multiBodiedExtension: (0, $47jug.multiBodiedExtension),
        extensionFrame: (0, $47jug.extensionFrame),
        expand: (0, $7kC9H.expandWithNestedExpand),
        listItem: (0, $2FIVU.listItemWithDecisionStage0),
        table: (0, $9UDEr.tableWithNestedTable),
        tableRow: (0, $9UDEr.tableRowWithNestedTable),
        tableCell: (0, $9UDEr.tableCellWithNestedTable),
        tableHeader: (0, $9UDEr.tableHeaderWithNestedTable)
    };
    return (0, $kBho7.createSchema)(defaultSchemaConfig);
});
const $f27880a8173018db$export$1db618b7b2275ea1 = $f27880a8173018db$export$fd147e7d448dea03();

});
parcelRegister("7kC9H", function(module, exports) {

$parcel$export(module.exports, "expand", () => $5567ff8f3f52f7a8$export$9f77e0932fb78f72);
$parcel$export(module.exports, "expandWithNestedExpand", () => $5567ff8f3f52f7a8$export$7b80cba28d10b2c1);
$parcel$export(module.exports, "toJSON", () => $5567ff8f3f52f7a8$export$54fd2c36b5cc6731);

var $gthjq = parcelRequire("gthjq");
/**
 * @name expand_node
 */ /**
 * @name expand_with_no_mark_node
 */ /**
 * @name expand_root_only_node
 */ function $5567ff8f3f52f7a8$var$getExpandAttrs(domNode) {
    const dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
const $5567ff8f3f52f7a8$var$nodeSpecOptions = {
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: $5567ff8f3f52f7a8$var$getExpandAttrs
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $5567ff8f3f52f7a8$var$getExpandAttrs
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $5567ff8f3f52f7a8$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: $5567ff8f3f52f7a8$var$getExpandAttrs
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $5567ff8f3f52f7a8$export$9f77e0932fb78f72 = (0, $gthjq.expandWithoutNestedExpand)($5567ff8f3f52f7a8$var$nodeSpecOptions);
const $5567ff8f3f52f7a8$export$7b80cba28d10b2c1 = (0, $gthjq.expand)($5567ff8f3f52f7a8$var$nodeSpecOptions);
const $5567ff8f3f52f7a8$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>!key.startsWith('__')).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });

});
parcelRegister("gthjq", function(module, exports) {

$parcel$export(module.exports, "blockCard", () => $bfdcc8a4590754dc$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockquote", () => $bfdcc8a4590754dc$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockquoteLegacy", () => $bfdcc8a4590754dc$export$199922e5af8e9a6);
$parcel$export(module.exports, "blockquoteWithoutNestedCodeblockOrMedia", () => $bfdcc8a4590754dc$export$a91509d1c739c16f);
$parcel$export(module.exports, "blockquoteWithoutNonBodiedMacros", () => $bfdcc8a4590754dc$export$32b1dde15f5fe85b);
$parcel$export(module.exports, "bodiedExtension", () => $bfdcc8a4590754dc$export$27903d543b563e39);
$parcel$export(module.exports, "bulletList", () => $bfdcc8a4590754dc$export$a140c94e5ea26bee);
$parcel$export(module.exports, "caption", () => $bfdcc8a4590754dc$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "codeBlock", () => $bfdcc8a4590754dc$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "confluenceJiraIssue", () => $bfdcc8a4590754dc$export$daf889beb5092f95);
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $bfdcc8a4590754dc$export$e6e4878f43c27cab);
$parcel$export(module.exports, "confluenceUnsupportedInline", () => $bfdcc8a4590754dc$export$3e6d667072febc87);
$parcel$export(module.exports, "date", () => $bfdcc8a4590754dc$export$324d90190a8b822a);
$parcel$export(module.exports, "decisionItem", () => $bfdcc8a4590754dc$export$6959e16eeff859b4);
$parcel$export(module.exports, "decisionList", () => $bfdcc8a4590754dc$export$62d45a65fb43d95e);
$parcel$export(module.exports, "doc", () => $bfdcc8a4590754dc$export$2a111da947c407d2);
$parcel$export(module.exports, "embedCard", () => $bfdcc8a4590754dc$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "emoji", () => $bfdcc8a4590754dc$export$a19185d1233fc4b2);
$parcel$export(module.exports, "expand", () => $bfdcc8a4590754dc$export$9f77e0932fb78f72);
$parcel$export(module.exports, "expandWithoutNestedExpand", () => $bfdcc8a4590754dc$export$63c0f3992661097b);
$parcel$export(module.exports, "extension", () => $bfdcc8a4590754dc$export$1b45514b112dd749);
$parcel$export(module.exports, "extensionFrameStage0", () => $bfdcc8a4590754dc$export$b555be60c7703afb);
$parcel$export(module.exports, "hardBreak", () => $bfdcc8a4590754dc$export$371da9dd35aba193);
$parcel$export(module.exports, "heading", () => $bfdcc8a4590754dc$export$46e4a324ac90507f);
$parcel$export(module.exports, "image", () => $bfdcc8a4590754dc$export$5c452ff88e35e47d);
$parcel$export(module.exports, "inlineCard", () => $bfdcc8a4590754dc$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineExtensionWithMarks", () => $bfdcc8a4590754dc$export$b3b1e36c2105006d);
$parcel$export(module.exports, "layoutColumn", () => $bfdcc8a4590754dc$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutSection", () => $bfdcc8a4590754dc$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionFull", () => $bfdcc8a4590754dc$export$cdae19acb0a520fd);
$parcel$export(module.exports, "layoutSectionWithSingleColumnStage0", () => $bfdcc8a4590754dc$export$206007566ca0aca5);
$parcel$export(module.exports, "listItem", () => $bfdcc8a4590754dc$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "listItemWithNestedDecisionStage0", () => $bfdcc8a4590754dc$export$df876f0305235056);
$parcel$export(module.exports, "listItemWithoutNonBodiedMacros", () => $bfdcc8a4590754dc$export$171e9ff2be159af7);
$parcel$export(module.exports, "media", () => $bfdcc8a4590754dc$export$987d49ffe1b0900f);
$parcel$export(module.exports, "mediaGroup", () => $bfdcc8a4590754dc$export$2855e964765eac9);
$parcel$export(module.exports, "mediaInline", () => $bfdcc8a4590754dc$export$38bab695e3f720f1);
$parcel$export(module.exports, "mediaSingle", () => $bfdcc8a4590754dc$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingleCaption", () => $bfdcc8a4590754dc$export$8d067f22dc2d1254);
$parcel$export(module.exports, "mediaSingleFull", () => $bfdcc8a4590754dc$export$7e767666f2ce108a);
$parcel$export(module.exports, "mediaSingleWidthType", () => $bfdcc8a4590754dc$export$4bd9a38995f6bf50);
$parcel$export(module.exports, "mention", () => $bfdcc8a4590754dc$export$db83999c14438df4);
$parcel$export(module.exports, "multiBodiedExtensionStage0", () => $bfdcc8a4590754dc$export$750e45819f66d9d0);
$parcel$export(module.exports, "nestedExpand", () => $bfdcc8a4590754dc$export$63cadbf5f4296627);
$parcel$export(module.exports, "nestedExpandWithoutNonBodiedMacros", () => $bfdcc8a4590754dc$export$15ebf236772fa336);
$parcel$export(module.exports, "orderedList", () => $bfdcc8a4590754dc$export$a5dc81035676e7a);
$parcel$export(module.exports, "panel", () => $bfdcc8a4590754dc$export$21f42ab9b6679f44);
$parcel$export(module.exports, "panelWithoutNestedNonBodiedMacros", () => $bfdcc8a4590754dc$export$220c665c23b9541b);
$parcel$export(module.exports, "paragraph", () => $bfdcc8a4590754dc$export$9c206ddddb32a9b);
$parcel$export(module.exports, "placeholder", () => $bfdcc8a4590754dc$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "rule", () => $bfdcc8a4590754dc$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "status", () => $bfdcc8a4590754dc$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "table", () => $bfdcc8a4590754dc$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableWithNestedTable", () => $bfdcc8a4590754dc$export$ce086a560a1d05f5);
$parcel$export(module.exports, "tableCell", () => $bfdcc8a4590754dc$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "tableCellWithNestedTable", () => $bfdcc8a4590754dc$export$abf39ca178940ff3);
$parcel$export(module.exports, "tableHeader", () => $bfdcc8a4590754dc$export$48884d2a5190dc73);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => $bfdcc8a4590754dc$export$2a5a518232fa1a97);
$parcel$export(module.exports, "tableRow", () => $bfdcc8a4590754dc$export$ce666bf02318c957);
$parcel$export(module.exports, "tableRowWithNestedTable", () => $bfdcc8a4590754dc$export$7d657479499397);
$parcel$export(module.exports, "taskItem", () => $bfdcc8a4590754dc$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "taskList", () => $bfdcc8a4590754dc$export$375b6afcc5f4d291);
$parcel$export(module.exports, "text", () => $bfdcc8a4590754dc$export$6f093cfa640b7166);
$parcel$export(module.exports, "unsupportedBlock", () => $bfdcc8a4590754dc$export$44b79b0979d0f0f7);
$parcel$export(module.exports, "unsupportedInline", () => $bfdcc8a4590754dc$export$310ebe0d80122e9b);
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $f0ccE = parcelRequire("f0ccE");
const $bfdcc8a4590754dc$export$c4c2f833baaebdb8 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: null
        },
        datasource: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $bfdcc8a4590754dc$export$67dc04e652a298ca = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock | codeBlock | mediaSingle | mediaGroup | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    group: 'block',
    selectable: true,
    defining: true
});
const $bfdcc8a4590754dc$export$199922e5af8e9a6 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: true,
    defining: true
});
const $bfdcc8a4590754dc$export$a91509d1c739c16f = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: true,
    defining: true
});
const $bfdcc8a4590754dc$export$32b1dde15f5fe85b = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock | codeBlock | mediaSingle | mediaGroup)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: true,
    defining: true
});
const $bfdcc8a4590754dc$export$27903d543b563e39 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$e7320d153c538837 = (0, $f0ccE.createPMNodeSpecFactory)({
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$a140c94e5ea26bee = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: false
});
const $bfdcc8a4590754dc$export$8e3c2dfdc4f0453d = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(hardBreak | mention | emoji | date | placeholder | inlineCard | status | text | unsupportedInline)*',
    marks: '_',
    selectable: false,
    isolating: true
});
const $bfdcc8a4590754dc$export$7bb0d5c671655cc4 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        }
    },
    code: true,
    defining: true
});
const $bfdcc8a4590754dc$export$e4f1c66d84049f8b = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        }
    },
    code: true,
    defining: true
});
const $bfdcc8a4590754dc$export$daf889beb5092f95 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        issueKey: {
            default: ''
        },
        macroId: {
            default: null
        },
        schemaVersion: {
            default: null
        },
        server: {
            default: null
        },
        serverId: {
            default: null
        }
    }
});
const $bfdcc8a4590754dc$export$e6e4878f43c27cab = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
const $bfdcc8a4590754dc$export$3e6d667072febc87 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
const $bfdcc8a4590754dc$export$324d90190a8b822a = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$47988d68fe575725 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$6959e16eeff859b4 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'DECIDED'
        }
    },
    defining: true
});
const $bfdcc8a4590754dc$export$62d45a65fb43d95e = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(decisionItem | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$2a111da947c407d2 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(block | codeBlock | layoutSection | blockRootOnly | expand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment breakout'
});
const $bfdcc8a4590754dc$export$be4283d9a1cb1ff6 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: ''
        },
        layout: {
            default: 'center'
        },
        width: {
            default: 100
        },
        originalHeight: {
            default: null
        },
        originalWidth: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$a19185d1233fc4b2 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$f5574b5d45fc2112 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$9f77e0932fb78f72 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$7e3788972005cc72 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$63c0f3992661097b = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$1b45514b112dd749 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$a8baf338431a691 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$b555be60c7703afb = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | extension | bodiedExtension | unsupportedBlock | blockCard | embedCard)+',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {},
    selectable: false,
    definingAsContext: false,
    definingForContent: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$371da9dd35aba193 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: '\n'
        }
    },
    selectable: false,
    linebreakReplacement: true
});
const $bfdcc8a4590754dc$export$46e4a324ac90507f = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$1b0c1557b234fa00 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$85461f751c457cc2 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$2b380a0f7e250af1 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$5c452ff88e35e47d = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        src: {
            default: ''
        },
        alt: {
            default: ''
        },
        title: {
            default: null
        }
    },
    draggable: true
});
const $bfdcc8a4590754dc$export$cbf8224b64e0d942 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $bfdcc8a4590754dc$export$2f4e72b9459914ad = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $bfdcc8a4590754dc$export$16b353b2649bd8d9 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$b3b1e36c2105006d = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$ab76e7c03cd6f650 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(block | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment',
    attrs: {
        width: {
            default: undefined
        }
    },
    selectable: false,
    isolating: true
});
const $bfdcc8a4590754dc$export$b3b6a70a7fa4a5be = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,3} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    isolating: true
});
const $bfdcc8a4590754dc$export$cdae19acb0a520fd = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){2,3}',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    isolating: true
});
const $bfdcc8a4590754dc$export$206007566ca0aca5 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,5} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        columnRuleStyle: {
            default: null
        }
    },
    isolating: true
});
const $bfdcc8a4590754dc$export$76c7e83ecc9cdf05 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock | extension) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | extension)*',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$df876f0305235056 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock | decisionList | extension) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | decisionList | extension)*',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$171e9ff2be159af7 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$987d49ffe1b0900f = (0, $f0ccE.createPMNodeSpecFactory)({
    attrs: {
        type: {
            default: 'file'
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        height: {
            default: null
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        __contextId: {
            default: null
        },
        __displayType: {
            default: null
        },
        __external: {
            default: false
        },
        __fileMimeType: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        url: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$2855e964765eac9 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(media | unsupportedBlock)+',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {},
    selectable: false
});
const $bfdcc8a4590754dc$export$38bab695e3f720f1 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        type: {
            default: 'file'
        },
        url: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        height: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __fileMimeType: {
            default: null
        },
        __displayType: {
            default: null
        },
        __contextId: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        __external: {
            default: false
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$969fe3781ca15058 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true,
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'annotation border link unsupportedMark unsupportedNodeAttribute'
});
const $bfdcc8a4590754dc$export$8d067f22dc2d1254 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$7e767666f2ce108a = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$4bd9a38995f6bf50 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: true,
    attrs: {
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$db83999c14438df4 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$46f790bd65f760d0 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$750e45819f66d9d0 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'extensionFrame+',
    marks: 'unsupportedNodeAttribute unsupportedMark',
    group: 'blockRootOnly',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    definingAsContext: true
});
const $bfdcc8a4590754dc$export$63cadbf5f4296627 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | panel | blockquote | unsupportedBlock | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$f03786aa6312d1e4 = (0, $f0ccE.createPMNodeSpecFactory)({
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$15ebf236772fa336 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | panel | blockquote | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$a5dc81035676e7a = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        order: {
            default: 1
        }
    },
    selectable: false
});
const $bfdcc8a4590754dc$export$21f42ab9b6679f44 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$220c665c23b9541b = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$9c206ddddb32a9b = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $bfdcc8a4590754dc$export$4f98472e6dc14293 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $bfdcc8a4590754dc$export$ea332b61641b0588 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $bfdcc8a4590754dc$export$a1f41dc4901771f8 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $bfdcc8a4590754dc$export$c7187bbd1a7a9244 = (0, $f0ccE.createPMNodeSpecFactory)({
    marks: '',
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        }
    },
    selectable: false
});
const $bfdcc8a4590754dc$export$fbeb3a3956e8a3c7 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block'
});
const $bfdcc8a4590754dc$export$471f7ae5c4103ae1 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$b6ce52be8d7a261 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$9852986a3ec5f6a0 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
const $bfdcc8a4590754dc$export$ce086a560a1d05f5 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
const $bfdcc8a4590754dc$export$e1e720e5f4603e6a = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
const $bfdcc8a4590754dc$export$abf39ca178940ff3 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock | table)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
const $bfdcc8a4590754dc$export$48884d2a5190dc73 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
const $bfdcc8a4590754dc$export$2a5a518232fa1a97 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | table)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
const $bfdcc8a4590754dc$export$ce666bf02318c957 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    tableRole: 'row'
});
const $bfdcc8a4590754dc$export$7d657479499397 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    tableRole: 'row'
});
const $bfdcc8a4590754dc$export$6d8b0ef52e2e6390 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$375b6afcc5f4d291 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(taskItem | unsupportedBlock)+ (taskItem | taskList | unsupportedBlock)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$6f093cfa640b7166 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline'
});
const $bfdcc8a4590754dc$export$5ea06bc686c59dc2 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline'
});
const $bfdcc8a4590754dc$export$93256a4c17b33a82 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline'
});
const $bfdcc8a4590754dc$export$a12828d0f14a2762 = (0, $f0ccE.createPMNodeSpecFactory)({});
const $bfdcc8a4590754dc$export$44b79b0979d0f0f7 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$310ebe0d80122e9b = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});

});
parcelRegister("f0ccE", function(module, exports) {

$parcel$export(module.exports, "createPMNodeSpecFactory", () => $aec0525c0df12bb9$export$bf0a80f00e2b8ff6);
$parcel$export(module.exports, "createPMMarkSpecFactory", () => $aec0525c0df12bb9$export$cf5823ed4e9f4c6f);
/**
 * Factory method to attach custom parseDOM and/or toDOM for nodeSpec
 *
 * @example
 * createPMNodeSpecFactory<SomeNode>(node)({parseDOM: {}, toDOM: (node) => {} });
 *
 * @param nodeSpec - NodeSpec without toDom and parseDom
 * @returns A function for a node which allows the consumer to define toDom and parseDom
 */ const $aec0525c0df12bb9$export$bf0a80f00e2b8ff6 = (nodeSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
        return {
            ...nodeSpec,
            ...parseDOM && {
                parseDOM: parseDOM
            },
            ...toDOM && {
                toDOM: toDOM
            },
            ...toDebugString && {
                toDebugString: toDebugString
            }
        };
    };
const $aec0525c0df12bb9$export$cf5823ed4e9f4c6f = (markSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
        return {
            ...markSpec,
            ...parseDOM && {
                parseDOM: parseDOM
            },
            ...toDOM && {
                toDOM: toDOM
            },
            ...toDebugString && {
                toDebugString: toDebugString
            }
        };
    };

});



parcelRegister("47jug", function(module, exports) {

$parcel$export(module.exports, "extensionFrame", () => $2ff6ee9baaedd4b6$export$4fdcae991fd743e7);
$parcel$export(module.exports, "multiBodiedExtension", () => $2ff6ee9baaedd4b6$export$c3c04d555a8b9013);

var $CWpyq = parcelRequire("CWpyq");

var $gthjq = parcelRequire("gthjq");
const $2ff6ee9baaedd4b6$export$4fdcae991fd743e7 = (0, $gthjq.extensionFrameStage0)({
    parseDOM: [
        {
            context: 'extensionFrame//',
            tag: 'div[data-extension-frame]',
            skip: true
        },
        {
            tag: 'div[data-extension-frame]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-extension-frame': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $2ff6ee9baaedd4b6$export$c3c04d555a8b9013 = (0, $gthjq.multiBodiedExtensionStage0)({
    parseDOM: [
        {
            context: 'multiBodiedExtension//',
            tag: '[data-node-type="multi-bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="multi-bodied-extension"]',
            getAttrs: (domNode)=>(0, $CWpyq.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'multi-bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});
parcelRegister("CWpyq", function(module, exports) {

$parcel$export(module.exports, "getExtensionAttrs", () => $0750dbf71b86cced$export$1765e2758fc47004);
const $0750dbf71b86cced$export$d5f21755dc782a4a = (name)=>{
    return !!name && [
        'default',
        'wide',
        'full-width'
    ].includes(name);
};
const $0750dbf71b86cced$export$1765e2758fc47004 = (dom, isInline = false)=>{
    const extensionType = dom.getAttribute('data-extension-type');
    const extensionKey = dom.getAttribute('data-extension-key');
    if (!extensionType || !extensionKey) return false;
    const attrs = {
        extensionType: extensionType,
        extensionKey: extensionKey,
        text: dom.getAttribute('data-text') || undefined,
        parameters: JSON.parse(dom.getAttribute('data-parameters') || '{}'),
        localId: dom.getAttribute('data-local-id') || undefined
    };
    if (!isInline) {
        const rawLayout = dom.getAttribute('data-layout');
        attrs.layout = $0750dbf71b86cced$export$d5f21755dc782a4a(rawLayout) ? rawLayout : 'default';
    }
    return attrs;
};

});


parcelRegister("gZoER", function(module, exports) {

$parcel$export(module.exports, "layoutSection", () => $c5e57867b1f8b9c7$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionWithSingleColumn", () => $c5e57867b1f8b9c7$export$4f9d8f623ff17117);

var $gthjq = parcelRequire("gthjq");
const $c5e57867b1f8b9c7$export$b3b6a70a7fa4a5be = (0, $gthjq.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $c5e57867b1f8b9c7$export$cdae19acb0a520fd = (0, $gthjq.layoutSectionFull)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $c5e57867b1f8b9c7$export$4f9d8f623ff17117 = (0, $gthjq.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: (dom)=>{
                const columnRuleStyle = dom.getAttribute('data-column-rule-style');
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle
                } : {};
            }
        }
    ],
    toDOM (node) {
        const { columnRuleStyle: columnRuleStyle } = node.attrs;
        const attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("2FIVU", function(module, exports) {

$parcel$export(module.exports, "listItem", () => $1f2243de0d109562$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "listItemWithTask", () => $1f2243de0d109562$export$58dca2f0678302a4);
$parcel$export(module.exports, "listItemWithDecisionStage0", () => $1f2243de0d109562$export$b2cd54d5ce935ddb);
$parcel$export(module.exports, "listItemWithoutNonBodiedMacros", () => $1f2243de0d109562$export$171e9ff2be159af7);

var $gthjq = parcelRequire("gthjq");
const $1f2243de0d109562$export$76c7e83ecc9cdf05 = (0, $gthjq.listItem)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
});
const $1f2243de0d109562$export$58dca2f0678302a4 = $1f2243de0d109562$export$76c7e83ecc9cdf05;
const $1f2243de0d109562$export$b2cd54d5ce935ddb = (0, $gthjq.listItemWithNestedDecisionStage0)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
});
const $1f2243de0d109562$export$171e9ff2be159af7 = (0, $gthjq.listItemWithoutNonBodiedMacros)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
});

});

parcelRegister("9UDEr", function(module, exports) {

$parcel$export(module.exports, "tablePrefixSelector", () => $737819f27951a815$export$9cfceb893b24742a);
$parcel$export(module.exports, "tableCellSelector", () => $737819f27951a815$export$69cb4c3f80383763);
$parcel$export(module.exports, "tableHeaderSelector", () => $737819f27951a815$export$7b07d37d879c957f);
$parcel$export(module.exports, "tableCellContentWrapperSelector", () => $737819f27951a815$export$8dd42a84cd52da07);
$parcel$export(module.exports, "tableCellContentDomSelector", () => $737819f27951a815$export$5e26a5c19f0865d8);
$parcel$export(module.exports, "getCellAttrs", () => $737819f27951a815$export$43977bde391e007);
$parcel$export(module.exports, "getCellDomAttrs", () => $737819f27951a815$export$363c8dda799bfe9c);
$parcel$export(module.exports, "tableBackgroundColorNames", () => $737819f27951a815$export$8cc2833b5b349a1e);
$parcel$export(module.exports, "tableBackgroundColorPalette", () => $737819f27951a815$export$219b7f492ad209f8);
$parcel$export(module.exports, "tableBackgroundBorderColor", () => $737819f27951a815$export$95e9c925fbf01d1c);
$parcel$export(module.exports, "table", () => $737819f27951a815$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableWithCustomWidth", () => $737819f27951a815$export$90e634fbace1f0c4);
$parcel$export(module.exports, "tableStage0", () => $737819f27951a815$export$3862de5c8c9098cf);
$parcel$export(module.exports, "tableToJSON", () => $737819f27951a815$export$1f92a2f429e06fa8);
$parcel$export(module.exports, "tableRow", () => $737819f27951a815$export$ce666bf02318c957);
$parcel$export(module.exports, "tableCell", () => $737819f27951a815$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "toJSONTableCell", () => $737819f27951a815$export$2ac34c099660f1a8);
$parcel$export(module.exports, "tableHeader", () => $737819f27951a815$export$48884d2a5190dc73);
$parcel$export(module.exports, "toJSONTableHeader", () => $737819f27951a815$export$2af48797a1010bb1);
$parcel$export(module.exports, "tableWithNestedTable", () => $737819f27951a815$export$ce086a560a1d05f5);
$parcel$export(module.exports, "tableRowWithNestedTable", () => $737819f27951a815$export$7d657479499397);
$parcel$export(module.exports, "tableCellWithNestedTable", () => $737819f27951a815$export$abf39ca178940ff3);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => $737819f27951a815$export$2a5a518232fa1a97);

var $daes7 = parcelRequire("daes7");

var $51H8P = parcelRequire("51H8P");

var $9IGaJ = parcelRequire("9IGaJ");

var $87j2U = parcelRequire("87j2U");

var $gthjq = parcelRequire("gthjq");
const $737819f27951a815$export$9cfceb893b24742a = 'pm-table';
const $737819f27951a815$export$69cb4c3f80383763 = `${$737819f27951a815$export$9cfceb893b24742a}-cell-content-wrap`;
const $737819f27951a815$export$7b07d37d879c957f = `${$737819f27951a815$export$9cfceb893b24742a}-header-content-wrap`;
const $737819f27951a815$export$8dd42a84cd52da07 = `${$737819f27951a815$export$9cfceb893b24742a}-cell-nodeview-wrapper`;
const $737819f27951a815$export$5e26a5c19f0865d8 = `${$737819f27951a815$export$9cfceb893b24742a}-cell-nodeview-content-dom`;
const $737819f27951a815$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND = (0, $51H8P.N20).toLocaleLowerCase();
const $737819f27951a815$export$43977bde391e007 = (dom, defaultValues = {})=>{
    const widthAttr = dom.getAttribute('data-colwidth');
    const width = widthAttr && /^\d+(,\d+)*$/.test(widthAttr) ? widthAttr.split(',').map((str)=>Number(str)) : null;
    const colspan = Number(dom.getAttribute('colspan') || 1);
    let { backgroundColor: backgroundColor } = dom.style;
    /**
   * We have pivoted to store background color information in
   *  data-cell-background.
   * We will have original hex code (which we map to DST token)
   *  stored in data-cell-background, use that.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ const dataCellBackground = dom.getAttribute('data-cell-background');
    const dataCellBackgroundHexCode = dataCellBackground && (0, $51H8P.isHex)(dataCellBackground) ? dataCellBackground : undefined;
    // ignore setting background attr if ds neutral token is detected
    if (backgroundColor.includes('--ds-background-neutral')) backgroundColor = '';
    else if (backgroundColor && (0, $51H8P.isRgb)(backgroundColor)) {
        const result = (0, $51H8P.rgbToHex)(backgroundColor);
        if (result !== null) backgroundColor = result;
    }
    const backgroundHexCode = dataCellBackgroundHexCode || (backgroundColor && backgroundColor !== defaultValues['background'] ? backgroundColor : null);
    return {
        colspan: colspan,
        rowspan: Number(dom.getAttribute('rowspan') || 1),
        colwidth: width && width.length === colspan ? width : null,
        background: backgroundHexCode
    };
};
// these are for test only
let $737819f27951a815$var$testGlobalTheme;
const $737819f27951a815$export$fd7e0dd2b74807f7 = (theme)=>{
    $737819f27951a815$var$testGlobalTheme = theme;
};
// This is a minimal duplication of the method from @atlaskit/tokens
// to minimise the number of dependencies required as these changes are expected
// to be patched onto CR8.
const $737819f27951a815$var$getGlobalTheme = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($737819f27951a815$var$testGlobalTheme) return {
        colorMode: $737819f27951a815$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
const $737819f27951a815$var$cssVariablePattern = /^var\(--.*\)$/;
const $737819f27951a815$export$363c8dda799bfe9c = (node)=>{
    const attrs = {};
    const nodeType = node.type.name;
    if (node.attrs.colspan !== 1) attrs.colspan = node.attrs.colspan;
    if (node.attrs.rowspan !== 1) attrs.rowspan = node.attrs.rowspan;
    if (node.attrs.colwidth) attrs['data-colwidth'] = node.attrs.colwidth.join(',');
    if (node.attrs.background) {
        const { background: background } = node.attrs;
        // to ensure that we don't overwrite product's style:
        // - it clears background color for <th> if its set to gray
        // - it clears background color for <td> if its set to white
        // - it clears background color for <th> if ds neutral token is detected
        const ignored = nodeType === 'tableHeader' && background === $737819f27951a815$export$8cc2833b5b349a1e.get('light gray') || nodeType === 'tableCell' && background === $737819f27951a815$export$8cc2833b5b349a1e.get('white') || nodeType === 'tableHeader' && background.includes('--ds-background-neutral');
        if (ignored) attrs.style = '';
        else {
            const color = (0, $51H8P.isRgb)(background) && (0, $51H8P.rgbToHex)(background) ? (0, $51H8P.rgbToHex)(background) : background;
            /**
       * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
       * backgrounds persisted.
       *
       * This feature predates the introduction of dark mode.
       *
       * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
       *
       * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
       *
       * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
       * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
       * seperate attribute (data-cell-background), instead of the inline style.
       *
       * See the following document for more details on this behaviour
       * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
       */ const tokenColor = (0, $daes7.hexToEditorBackgroundPaletteRawValue)(color);
            if (tokenColor) attrs.style = `background-color: ${tokenColor};`;
            else if (/**
       * There was previously a bug in dark mode where we would attempt to invert
       * a design token in `getDarkModeLCHColor` causing issues.
       * If it's a design token we should return it as is.
       */ $737819f27951a815$var$cssVariablePattern.test(color)) attrs.style = `background-color: ${color};`;
            else // if we have a custom color, we need to check if we are in dark mode
            if ($737819f27951a815$var$getGlobalTheme().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
            attrs.style = `background-color: ${(0, $87j2U.getDarkModeLCHColor)(color)};`;
            else // if we are in light mode, we can just set the color
            attrs.style = `background-color: ${background};`;
            /**
       * Storing hex code in data-cell-background because
       *  we want to have DST token (css variable) or
       *  DST token value (value (hex code) of css variable) in
       *  inline style to correct render table cell background
       *  based on selected theme.
       * Currently we rely on background color hex code stored in
       *  inline style.
       * Because of that when we copy and paste table, we end up
       *  having DST token or DST token value in ADF instead of
       *  original hex code which we map to DST token.
       * So, introducing data-cell-background.
       * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
       */ if (color) attrs['data-cell-background'] = color;
            attrs.colorname = $737819f27951a815$export$219b7f492ad209f8.get(color);
        }
    }
    if (nodeType === 'tableHeader') attrs.class = $737819f27951a815$export$7b07d37d879c957f;
    else attrs.class = $737819f27951a815$export$69cb4c3f80383763;
    return attrs;
};
const $737819f27951a815$export$219b7f492ad209f8 = new Map();
const $737819f27951a815$export$95e9c925fbf01d1c = (0, $51H8P.hexToRgba)((0, $51H8P.N800), 0.12) || (0, $51H8P.N0);
const $737819f27951a815$export$8cc2833b5b349a1e = new Map();
[
    [
        (0, $51H8P.N0),
        'White'
    ],
    [
        (0, $51H8P.B50),
        'Light blue'
    ],
    [
        (0, $51H8P.T50),
        'Light teal'
    ],
    [
        (0, $51H8P.G50),
        'Light green'
    ],
    [
        (0, $51H8P.Y50),
        'Light yellow'
    ],
    [
        (0, $51H8P.R50),
        'Light red'
    ],
    [
        (0, $51H8P.P50),
        'Light purple'
    ],
    [
        (0, $51H8P.N20),
        'Light gray'
    ],
    [
        (0, $51H8P.B75),
        'Blue'
    ],
    [
        (0, $51H8P.T75),
        'Teal'
    ],
    [
        (0, $51H8P.G75),
        'Green'
    ],
    [
        (0, $51H8P.Y75),
        'Yellow'
    ],
    [
        (0, $51H8P.R75),
        'Red'
    ],
    [
        (0, $51H8P.P75),
        'Purple'
    ],
    [
        (0, $51H8P.N60),
        'Gray'
    ],
    [
        (0, $51H8P.B100),
        'Dark blue'
    ],
    [
        (0, $51H8P.T100),
        'Dark teal'
    ],
    [
        (0, $51H8P.G200),
        'Dark green'
    ],
    [
        (0, $51H8P.Y200),
        'Dark yellow'
    ],
    [
        (0, $51H8P.R100),
        'Dark red'
    ],
    [
        (0, $51H8P.P100),
        'Dark purple'
    ]
].forEach(([colorValue, colorName])=>{
    $737819f27951a815$export$219b7f492ad209f8.set(colorValue.toLowerCase(), colorName);
    $737819f27951a815$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
});
/**
 * @name table_node
 */ /**
 * @name table_row_node
 */ /**
 * @name table_cell_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name table_cell_node
 */ /**
 * @name table_header_node
 */ // table nodes with nested tables support
const $737819f27951a815$var$tableNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'table',
            getAttrs: (node)=>{
                var _dom$parentElement;
                const dom = node;
                const breakoutWrapper = (_dom$parentElement = dom.parentElement) === null || _dom$parentElement === void 0 ? void 0 : _dom$parentElement.parentElement;
                return {
                    isNumberColumnEnabled: dom.getAttribute('data-number-column') === 'true',
                    layout: // copying from editor
                    dom.getAttribute('data-layout') || (breakoutWrapper === null || breakoutWrapper === void 0 ? void 0 : breakoutWrapper.getAttribute('data-layout')) || 'default',
                    __autoSize: dom.getAttribute('data-autosize') === 'true',
                    localId: dom.getAttribute('data-table-local-id') || (0, $9IGaJ.uuid).generate(),
                    width: Number(dom.getAttribute('data-table-width')) || null,
                    displayMode: dom.getAttribute('data-table-display-mode') || null
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-number-column': node.attrs.isNumberColumnEnabled,
            'data-layout': node.attrs.layout,
            'data-autosize': node.attrs.__autoSize,
            'data-table-local-id': node.attrs.localId,
            'data-table-width': node.attrs.width,
            'data-table-display-mode': node.attrs.displayMode
        };
        return [
            'table',
            attrs,
            [
                'tbody',
                0
            ]
        ];
    }
};
// TODO: Fix any, potential issue. ED-5048
const $737819f27951a815$var$createTableSpec = ()=>(0, $gthjq.table)($737819f27951a815$var$tableNodeSpecOptions);
const $737819f27951a815$export$9852986a3ec5f6a0 = $737819f27951a815$var$createTableSpec();
const $737819f27951a815$export$90e634fbace1f0c4 = $737819f27951a815$var$createTableSpec();
const $737819f27951a815$export$3862de5c8c9098cf = $737819f27951a815$var$createTableSpec();
const $737819f27951a815$var$shouldIncludeAttribute = (key, value)=>!key.startsWith('__') && (key !== 'localId' || !!value);
const $737819f27951a815$export$1f92a2f429e06fa8 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>$737819f27951a815$var$shouldIncludeAttribute(key, node.attrs[key])).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });
const $737819f27951a815$var$tableRowNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'tr'
        }
    ],
    toDOM () {
        return [
            'tr',
            0
        ];
    }
};
const $737819f27951a815$export$ce666bf02318c957 = (0, $gthjq.tableRow)($737819f27951a815$var$tableRowNodeSpecOptions);
const $737819f27951a815$var$cellAttrs = {
    colspan: {
        default: 1
    },
    rowspan: {
        default: 1
    },
    colwidth: {
        default: null
    },
    background: {
        default: null
    }
};
const $737819f27951a815$var$tableCellNodeSpecOptions = {
    parseDOM: [
        // Ignore number cell copied from renderer
        {
            tag: '.ak-renderer-table-number-column',
            ignore: true
        },
        {
            tag: 'td',
            getAttrs: (dom)=>$737819f27951a815$export$43977bde391e007(dom)
        }
    ],
    toDOM: (node)=>[
            'td',
            $737819f27951a815$export$363c8dda799bfe9c(node),
            0
        ]
};
const $737819f27951a815$export$e1e720e5f4603e6a = (0, $gthjq.tableCell)($737819f27951a815$var$tableCellNodeSpecOptions);
const $737819f27951a815$export$2ac34c099660f1a8 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if ($737819f27951a815$var$cellAttrs[key].default !== node.attrs[key]) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });
const $737819f27951a815$var$tableHeaderNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: (dom)=>$737819f27951a815$export$43977bde391e007(dom, {
                    background: $737819f27951a815$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND
                })
        }
    ],
    toDOM: (node)=>[
            'th',
            $737819f27951a815$export$363c8dda799bfe9c(node),
            0
        ]
};
const $737819f27951a815$export$48884d2a5190dc73 = (0, $gthjq.tableHeader)($737819f27951a815$var$tableHeaderNodeSpecOptions);
const $737819f27951a815$export$2af48797a1010bb1 = $737819f27951a815$export$2ac34c099660f1a8;
const $737819f27951a815$export$ce086a560a1d05f5 = (0, $gthjq.tableWithNestedTable)($737819f27951a815$var$tableNodeSpecOptions);
const $737819f27951a815$export$7d657479499397 = (0, $gthjq.tableRowWithNestedTable)($737819f27951a815$var$tableRowNodeSpecOptions);
const $737819f27951a815$export$abf39ca178940ff3 = (0, $gthjq.tableCellWithNestedTable)($737819f27951a815$var$tableCellNodeSpecOptions);
const $737819f27951a815$export$2a5a518232fa1a97 = (0, $gthjq.tableHeaderWithNestedTable)($737819f27951a815$var$tableHeaderNodeSpecOptions);

});
parcelRegister("daes7", function(module, exports) {

$parcel$export(module.exports, "hexToEditorBorderPaletteColor", () => $99576b847e5fbb17$export$bad3c41dd33cb4bc);
$parcel$export(module.exports, "hexToEditorTextPaletteColor", () => $99576b847e5fbb17$export$9c2f408d391feb93);
$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", () => $99576b847e5fbb17$export$8b58ff1b36bb75e0);
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", () => $99576b847e5fbb17$export$a270511a0e7fd61a);
/**
 * This takes an adf hex color and returns a matching border palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToEditorBorderPaletteColor('#091E4224');
 * //     ^? const cssValue: string
 * <div style={{borderColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $99576b847e5fbb17$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return hexColor ? $99576b847e5fbb17$export$aa000893c5e2b9c2[hexColor.toUpperCase()] : undefined;
}
const $99576b847e5fbb17$export$aa000893c5e2b9c2 = {
    /** gray - subtle */ '#091E4224': 'var(--ds-border, #091E4224)',
    /** gray */ '#758195': 'var(--ds-border-bold, #758195)',
    /** gray - bold */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $99576b847e5fbb17$export$9c2f408d391feb93(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return hexColor ? $99576b847e5fbb17$export$57fa5089caad992[hexColor.toUpperCase()] : undefined;
}
const $99576b847e5fbb17$export$57fa5089caad992 = {
    /** blue - light */ '#B3D4FF': 'var(--ds-background-accent-blue-subtler, #B3D4FF)',
    /** blue - medium */ '#4C9AFF': 'var(--ds-icon-accent-blue, #4C9AFF)',
    /** blue - strong */ '#0747A6': 'var(--ds-text-accent-blue, #0747A6)',
    /** teal - light */ '#B3F5FF': 'var(--ds-background-accent-teal-subtler, #B3F5FF)',
    /** teal - medium */ '#00B8D9': 'var(--ds-icon-accent-teal, #00B8D9)',
    /** teal - strong */ '#008DA6': 'var(--ds-text-accent-teal, #008DA6)',
    /** green - light */ '#ABF5D1': 'var(--ds-background-accent-green-subtler, #ABF5D1)',
    /** green - medium */ '#36B37E': 'var(--ds-icon-accent-green, #36B37E)',
    /** green - strong */ '#006644': 'var(--ds-text-accent-green, #006644)',
    /** yellowOrange - light */ '#FFF0B3': 'var(--ds-background-accent-yellow-subtler, #FFF0B3)',
    /** yellowOrange - medium */ '#FFC400': 'var(--ds-background-accent-orange-subtle, #FFC400)',
    /** yellowOrange - strong */ '#FF991F': 'var(--ds-icon-accent-orange, #FF991F)',
    /** red - light */ '#FFBDAD': 'var(--ds-background-accent-red-subtler, #FFBDAD)',
    /** red - medium */ '#FF5630': 'var(--ds-icon-accent-red, #FF5630)',
    /** red - strong */ '#BF2600': 'var(--ds-text-accent-red, #BF2600)',
    /** purple - light */ '#EAE6FF': 'var(--ds-background-accent-purple-subtler, #EAE6FF)',
    /** purple - medium */ '#6554C0': 'var(--ds-icon-accent-purple, #6554C0)',
    /** purple - strong */ '#403294': 'var(--ds-text-accent-purple, #403294)',
    /** whiteGray - light */ '#FFFFFF': 'var(--ds-text-inverse, #FFFFFF)',
    /** whiteGray - medium */ '#97A0AF': 'var(--ds-icon-accent-gray, #97A0AF)',
    /** whiteGray - strong */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $99576b847e5fbb17$export$8b58ff1b36bb75e0(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    return hexColor ? $99576b847e5fbb17$export$12a518ff137dd389[hexColor.toUpperCase()] : undefined;
}
const $99576b847e5fbb17$export$12a518ff137dd389 = {
    /** Gray - light */ '#DCDFE4': 'var(--ds-background-accent-gray-subtler, #DCDFE4)',
    /** Teal - light */ '#C6EDFB': 'var(--ds-background-accent-teal-subtler, #C6EDFB)',
    /** Lime - light */ '#D3F1A7': 'var(--ds-background-accent-lime-subtler, #D3F1A7)',
    /** Orange - light */ '#FEDEC8': 'var(--ds-background-accent-orange-subtler, #FEDEC8)',
    /** Magenta - light */ '#FDD0EC': 'var(--ds-background-accent-magenta-subtler, #FDD0EC)',
    /** Purple - light */ '#DFD8FD': 'var(--ds-background-accent-purple-subtler, #DFD8FD)'
};
function $99576b847e5fbb17$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    const tokenData = hexColor ? $99576b847e5fbb17$export$2462741d70e6a62f[hexColor.toUpperCase()] : undefined;
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
const $99576b847e5fbb17$export$2462741d70e6a62f = {
    /** blue - light */ '#DEEBFF': {
        getValue: ()=>'#DEEBFF',
        token: 'var(--ds-background-accent-blue-subtlest, #DEEBFF)'
    },
    /** blue - medium */ '#B3D4FF': {
        getValue: ()=>'#B3D4FF',
        token: 'var(--ds-background-accent-blue-subtler, #B3D4FF)'
    },
    /** blue - strong */ '#4C9AFF': {
        getValue: ()=>'#4C9AFF',
        token: 'var(--ds-background-accent-blue-subtle, #4C9AFF)'
    },
    /** teal - light */ '#E6FCFF': {
        getValue: ()=>'#E6FCFF',
        token: 'var(--ds-background-accent-teal-subtlest, #E6FCFF)'
    },
    /** teal - medium */ '#B3F5FF': {
        getValue: ()=>'#B3F5FF',
        token: 'var(--ds-background-accent-teal-subtler, #B3F5FF)'
    },
    /** teal - strong */ '#79E2F2': {
        getValue: ()=>'#79E2F2',
        token: 'var(--ds-background-accent-teal-subtle, #79E2F2)'
    },
    /** green - light */ '#E3FCEF': {
        getValue: ()=>'#E3FCEF',
        token: 'var(--ds-background-accent-green-subtlest, #E3FCEF)'
    },
    /** green - medium */ '#ABF5D1': {
        getValue: ()=>'#ABF5D1',
        token: 'var(--ds-background-accent-green-subtler, #ABF5D1)'
    },
    /** green - strong */ '#57D9A3': {
        getValue: ()=>'#57D9A3',
        token: 'var(--ds-background-accent-green-subtle, #57D9A3)'
    },
    /** yellowOrange - light */ '#FFFAE6': {
        getValue: ()=>'#FFFAE6',
        token: 'var(--ds-background-accent-yellow-subtlest, #FFFAE6)'
    },
    /** yellowOrange - medium */ '#FFF0B3': {
        getValue: ()=>'#FFF0B3',
        token: 'var(--ds-background-accent-yellow-subtler, #FFF0B3)'
    },
    /** yellowOrange - strong */ '#FFC400': {
        getValue: ()=>'#FFC400',
        token: 'var(--ds-background-accent-orange-subtle, #FFC400)'
    },
    /** red - light */ '#FFEBE6': {
        getValue: ()=>'#FFEBE6',
        token: 'var(--ds-background-accent-red-subtlest, #FFEBE6)'
    },
    /** red - medium */ '#FFBDAD': {
        getValue: ()=>'#FFBDAD',
        token: 'var(--ds-background-accent-red-subtler, #FFBDAD)'
    },
    /** red - strong */ '#FF8F73': {
        getValue: ()=>'#FF8F73',
        token: 'var(--ds-background-accent-red-subtle, #FF8F73)'
    },
    /** purple - light */ '#EAE6FF': {
        getValue: ()=>'#EAE6FF',
        token: 'var(--ds-background-accent-purple-subtlest, #EAE6FF)'
    },
    /** purple - medium */ '#C0B6F2': {
        getValue: ()=>'#C0B6F2',
        token: 'var(--ds-background-accent-purple-subtler, #C0B6F2)'
    },
    /** purple - strong */ '#998DD9': {
        getValue: ()=>'#998DD9',
        token: 'var(--ds-background-accent-purple-subtle, #998DD9)'
    },
    /** whiteGray - light */ '#FFFFFF': {
        getValue: ()=>'#FFFFFF',
        token: 'var(--ds-surface, #FFFFFF)'
    },
    /** whiteGray - medium */ '#F4F5F7': {
        getValue: ()=>'#F4F5F7',
        token: 'var(--ds-background-accent-gray-subtlest, #F4F5F7)'
    },
    /** whiteGray - strong */ '#B3BAC5': {
        getValue: ()=>'#B3BAC5',
        token: 'var(--ds-background-accent-gray-subtle, #B3BAC5)'
    }
};

});

parcelRegister("51H8P", function(module, exports) {

$parcel$export(module.exports, "R50", () => $3a8e82bcbd673dd1$export$4b84fd0e2c617bd);
$parcel$export(module.exports, "R75", () => $3a8e82bcbd673dd1$export$b34b069eff244586);
$parcel$export(module.exports, "R100", () => $3a8e82bcbd673dd1$export$be802dd0d8b57f35);
$parcel$export(module.exports, "R300", () => $3a8e82bcbd673dd1$export$4a7404f376229999);
$parcel$export(module.exports, "R500", () => $3a8e82bcbd673dd1$export$2837b5a1a71d5c02);
$parcel$export(module.exports, "Y50", () => $3a8e82bcbd673dd1$export$8d9596b529bbb9cf);
$parcel$export(module.exports, "Y75", () => $3a8e82bcbd673dd1$export$41060a744ab0b7ae);
$parcel$export(module.exports, "Y200", () => $3a8e82bcbd673dd1$export$5aae31392d72caaa);
$parcel$export(module.exports, "Y400", () => $3a8e82bcbd673dd1$export$59619663aa6500fb);
$parcel$export(module.exports, "G50", () => $3a8e82bcbd673dd1$export$8a6341c32b6a3ee6);
$parcel$export(module.exports, "G75", () => $3a8e82bcbd673dd1$export$69a3bf21b9686c2b);
$parcel$export(module.exports, "G200", () => $3a8e82bcbd673dd1$export$747d86715d4175de);
$parcel$export(module.exports, "G300", () => $3a8e82bcbd673dd1$export$940e1f69e873f202);
$parcel$export(module.exports, "G500", () => $3a8e82bcbd673dd1$export$6fa04827ac68a4fb);
$parcel$export(module.exports, "B50", () => $3a8e82bcbd673dd1$export$226de0355ed012f8);
$parcel$export(module.exports, "B75", () => $3a8e82bcbd673dd1$export$8c13c2ee36917869);
$parcel$export(module.exports, "B100", () => $3a8e82bcbd673dd1$export$ecfc1dff386a3e7a);
$parcel$export(module.exports, "B400", () => $3a8e82bcbd673dd1$export$b3de0ae08da2ce64);
$parcel$export(module.exports, "B500", () => $3a8e82bcbd673dd1$export$a6ee3d71bc067634);
$parcel$export(module.exports, "L200", () => $3a8e82bcbd673dd1$export$f72948ef771f6f15);
$parcel$export(module.exports, "N0", () => $3a8e82bcbd673dd1$export$29a4f05edc054374);
$parcel$export(module.exports, "N20", () => $3a8e82bcbd673dd1$export$9fdfb749e33cdf97);
$parcel$export(module.exports, "N30", () => $3a8e82bcbd673dd1$export$3e51e8f1440314ba);
$parcel$export(module.exports, "N40", () => $3a8e82bcbd673dd1$export$1ce2d1575d444ceb);
$parcel$export(module.exports, "N50", () => $3a8e82bcbd673dd1$export$8754fc7e6d8b3000);
$parcel$export(module.exports, "N60", () => $3a8e82bcbd673dd1$export$c2e91cbeada39b8b);
$parcel$export(module.exports, "N80", () => $3a8e82bcbd673dd1$export$eaa8c8a70ac22806);
$parcel$export(module.exports, "N200", () => $3a8e82bcbd673dd1$export$f563ee71e9ee74cd);
$parcel$export(module.exports, "N300", () => $3a8e82bcbd673dd1$export$e2ef2124cf4024b1);
$parcel$export(module.exports, "Neutral300", () => $3a8e82bcbd673dd1$export$1ae1cebe22dcedb4);
$parcel$export(module.exports, "N300A", () => $3a8e82bcbd673dd1$export$13609db0e6812ab8);
$parcel$export(module.exports, "N500", () => $3a8e82bcbd673dd1$export$c39c0fe0f26207ae);
$parcel$export(module.exports, "N600", () => $3a8e82bcbd673dd1$export$7090862dc3038a9f);
$parcel$export(module.exports, "N800", () => $3a8e82bcbd673dd1$export$7d61b15e0da132af);
$parcel$export(module.exports, "N1000", () => $3a8e82bcbd673dd1$export$f78789c8b01753cd);
$parcel$export(module.exports, "M200", () => $3a8e82bcbd673dd1$export$a19f0c33186f7767);
$parcel$export(module.exports, "O200", () => $3a8e82bcbd673dd1$export$51716a84e62e022c);
$parcel$export(module.exports, "P50", () => $3a8e82bcbd673dd1$export$363e4475840015bb);
$parcel$export(module.exports, "P75", () => $3a8e82bcbd673dd1$export$4b0a4417ed59760f);
$parcel$export(module.exports, "P100", () => $3a8e82bcbd673dd1$export$6011520a64d9a187);
$parcel$export(module.exports, "P200", () => $3a8e82bcbd673dd1$export$a7175d4e9206bc80);
$parcel$export(module.exports, "P300", () => $3a8e82bcbd673dd1$export$b48405b95304b5a1);
$parcel$export(module.exports, "P500", () => $3a8e82bcbd673dd1$export$147899de772240ec);
$parcel$export(module.exports, "T50", () => $3a8e82bcbd673dd1$export$2cf711fe14c66f06);
$parcel$export(module.exports, "T75", () => $3a8e82bcbd673dd1$export$7a8f4d33f6f9772c);
$parcel$export(module.exports, "T100", () => $3a8e82bcbd673dd1$export$776c9c497ef08533);
$parcel$export(module.exports, "T200", () => $3a8e82bcbd673dd1$export$69cb3ca10c1e330e);
$parcel$export(module.exports, "T300", () => $3a8e82bcbd673dd1$export$9dc1ef0f3f48059b);
$parcel$export(module.exports, "T500", () => $3a8e82bcbd673dd1$export$6036577f95c3877e);
$parcel$export(module.exports, "normalizeHexColor", () => $3a8e82bcbd673dd1$export$b61655071712e690);
$parcel$export(module.exports, "isHex", () => $3a8e82bcbd673dd1$export$8a9b6341a7c96bc);
$parcel$export(module.exports, "isRgb", () => $3a8e82bcbd673dd1$export$e698776ec826343);
$parcel$export(module.exports, "rgbToHex", () => $3a8e82bcbd673dd1$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgb", () => $3a8e82bcbd673dd1$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToRgba", () => $3a8e82bcbd673dd1$export$9665a07d9187b414);

var $3nnJa = parcelRequire("3nnJa");
const $3a8e82bcbd673dd1$export$4b84fd0e2c617bd = '#FFEBE6';
const $3a8e82bcbd673dd1$export$b34b069eff244586 = '#FFBDAD';
const $3a8e82bcbd673dd1$export$be802dd0d8b57f35 = '#FF8F73';
const $3a8e82bcbd673dd1$export$4a7404f376229999 = '#FF5630';
const $3a8e82bcbd673dd1$export$2010d0fb4295b346 = '#DE350B';
const $3a8e82bcbd673dd1$export$2837b5a1a71d5c02 = '#BF2600';
const $3a8e82bcbd673dd1$export$8d9596b529bbb9cf = '#FFFAE6';
const $3a8e82bcbd673dd1$export$41060a744ab0b7ae = '#FFF0B3';
const $3a8e82bcbd673dd1$export$5aae31392d72caaa = '#FFC400';
const $3a8e82bcbd673dd1$export$59619663aa6500fb = '#FF991F';
const $3a8e82bcbd673dd1$export$874739ea9e379ab6 = '#FF8B00';
const $3a8e82bcbd673dd1$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $3a8e82bcbd673dd1$export$69a3bf21b9686c2b = '#ABF5D1';
const $3a8e82bcbd673dd1$export$747d86715d4175de = '#57D9A3';
const $3a8e82bcbd673dd1$export$940e1f69e873f202 = '#36B37E';
const $3a8e82bcbd673dd1$export$a49394138f7b8e85 = '#00875A';
const $3a8e82bcbd673dd1$export$6fa04827ac68a4fb = '#006644';
const $3a8e82bcbd673dd1$export$226de0355ed012f8 = '#DEEBFF';
const $3a8e82bcbd673dd1$export$8c13c2ee36917869 = '#B3D4FF';
const $3a8e82bcbd673dd1$export$ecfc1dff386a3e7a = '#4C9AFF';
const $3a8e82bcbd673dd1$export$b3de0ae08da2ce64 = '#0052CC';
const $3a8e82bcbd673dd1$export$a6ee3d71bc067634 = '#0747A6';
const $3a8e82bcbd673dd1$export$f72948ef771f6f15 = '#D3F1A7';
const $3a8e82bcbd673dd1$export$29a4f05edc054374 = '#FFFFFF';
const $3a8e82bcbd673dd1$export$9fdfb749e33cdf97 = '#F4F5F7';
const $3a8e82bcbd673dd1$export$3e51e8f1440314ba = '#EBECF0';
const $3a8e82bcbd673dd1$export$1ce2d1575d444ceb = '#DFE1E6';
const $3a8e82bcbd673dd1$export$8754fc7e6d8b3000 = '#C1C7D0';
const $3a8e82bcbd673dd1$export$c2e91cbeada39b8b = '#B3BAC5';
const $3a8e82bcbd673dd1$export$eaa8c8a70ac22806 = '#97A0AF';
const $3a8e82bcbd673dd1$export$7c87d337fb91a97d = '#8993A4';
const $3a8e82bcbd673dd1$export$f563ee71e9ee74cd = '#6B778C';
const $3a8e82bcbd673dd1$export$e2ef2124cf4024b1 = '#5E6C84';
const $3a8e82bcbd673dd1$export$1ae1cebe22dcedb4 = '#DCDFE4';
const $3a8e82bcbd673dd1$export$13609db0e6812ab8 = '#091E4224';
const $3a8e82bcbd673dd1$export$c39c0fe0f26207ae = '#42526E';
const $3a8e82bcbd673dd1$export$7090862dc3038a9f = '#758195';
const $3a8e82bcbd673dd1$export$7d61b15e0da132af = '#172B4D';
const $3a8e82bcbd673dd1$export$f78789c8b01753cd = '#172B4D';
const $3a8e82bcbd673dd1$export$a19f0c33186f7767 = '#FDD0EC';
const $3a8e82bcbd673dd1$export$51716a84e62e022c = '#FEDEC8';
const $3a8e82bcbd673dd1$export$363e4475840015bb = '#EAE6FF';
const $3a8e82bcbd673dd1$export$4b0a4417ed59760f = '#C0B6F2';
const $3a8e82bcbd673dd1$export$6011520a64d9a187 = '#998DD9';
const $3a8e82bcbd673dd1$export$a7175d4e9206bc80 = '#DFD8FD';
const $3a8e82bcbd673dd1$export$b48405b95304b5a1 = '#6554C0';
const $3a8e82bcbd673dd1$export$c71e4279dd54a18d = '#5243AA';
const $3a8e82bcbd673dd1$export$147899de772240ec = '#403294';
const $3a8e82bcbd673dd1$export$2cf711fe14c66f06 = '#E6FCFF';
const $3a8e82bcbd673dd1$export$7a8f4d33f6f9772c = '#B3F5FF';
const $3a8e82bcbd673dd1$export$776c9c497ef08533 = '#79E2F2';
const $3a8e82bcbd673dd1$export$69cb3ca10c1e330e = '#C6EDFB';
const $3a8e82bcbd673dd1$export$9dc1ef0f3f48059b = '#00B8D9';
const $3a8e82bcbd673dd1$export$6036577f95c3877e = '#008DA6';
function $3a8e82bcbd673dd1$export$b61655071712e690(color, defaultColor) {
    if (!color) return null;
    // Normalize to hex
    color = color.trim().toLowerCase();
    if ($3a8e82bcbd673dd1$export$8a9b6341a7c96bc(color)) // Normalize 3-hex to 6-hex colours
    {
        if (color.length === 4) color = color.split('').map((c)=>c === '#' ? '#' : `${c}${c}`).join('');
    } else if ($3a8e82bcbd673dd1$export$e698776ec826343(color)) return $3a8e82bcbd673dd1$export$34d09c4a771c46ef(color);
    else {
        // http://dev.w3.org/csswg/css-color/#named-colors
        if (color === 'default') return null;
        else if ($3nnJa.default && $3nnJa.default[color]) color = $3nnJa.default[color];
        else if ($3nnJa && $3nnJa[color]) color = $3nnJa[color];
        else return null;
    }
    if (color === defaultColor) return null;
    return color;
}
function $3a8e82bcbd673dd1$export$5a544e13ad4e1fa5(color) {
    if (!$3a8e82bcbd673dd1$export$8a9b6341a7c96bc(color)) return null;
    let colorBits = color.substring(1).split('');
    if (colorBits.length === 3) colorBits = [
        colorBits[0],
        colorBits[0],
        colorBits[1],
        colorBits[1],
        colorBits[2],
        colorBits[2]
    ];
    const rgb = Number(`0x${colorBits.join('')}`);
    // eslint-disable-next-line no-bitwise
    return `rgb(${rgb >> 16 & 255},${rgb >> 8 & 255},${rgb & 255})`;
}
function $3a8e82bcbd673dd1$export$9665a07d9187b414(rawColor, alpha) {
    const color = $3a8e82bcbd673dd1$export$b61655071712e690(rawColor);
    if (!color) return null;
    const hex2rgb = (color)=>color.match(/[a-z0-9]{2}/gi).map((hex)=>parseInt(hex, 16));
    return `rgba(${hex2rgb(color).concat(alpha).join(',')})`;
}
function $3a8e82bcbd673dd1$export$34d09c4a771c46ef(value) {
    const matches = value.match(/(0?\.?\d{1,3})%?\b/g);
    if (matches && matches.length >= 3) {
        const [red, green, blue] = matches.map(Number);
        return '#' + (blue | green << 8 | red << 16 | 16777216).toString(16).slice(1) // eslint-disable-line no-bitwise
        ;
    }
    return null;
}
function $3a8e82bcbd673dd1$export$e698776ec826343(color) {
    return /rgba?\(/.test(color);
}
function $3a8e82bcbd673dd1$export$8a9b6341a7c96bc(color) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(color);
}

});
parcelRegister("3nnJa", function(module, exports) {
module.exports = JSON.parse("{\"aliceblue\":\"#f0f8ff\",\"antiquewhite\":\"#faebd7\",\"aqua\":\"#00ffff\",\"aquamarine\":\"#7fffd4\",\"azure\":\"#f0ffff\",\"beige\":\"#f5f5dc\",\"bisque\":\"#ffe4c4\",\"black\":\"#000000\",\"blanchedalmond\":\"#ffebcd\",\"blue\":\"#0000ff\",\"blueviolet\":\"#8a2be2\",\"brown\":\"#a52a2a\",\"burlywood\":\"#deb887\",\"cadetblue\":\"#5f9ea0\",\"chartreuse\":\"#7fff00\",\"chocolate\":\"#d2691e\",\"coral\":\"#ff7f50\",\"cornflowerblue\":\"#6495ed\",\"cornsilk\":\"#fff8dc\",\"crimson\":\"#dc143c\",\"cyan\":\"#00ffff\",\"darkblue\":\"#00008b\",\"darkcyan\":\"#008b8b\",\"darkgoldenrod\":\"#b8860b\",\"darkgray\":\"#a9a9a9\",\"darkgreen\":\"#006400\",\"darkgrey\":\"#a9a9a9\",\"darkkhaki\":\"#bdb76b\",\"darkmagenta\":\"#8b008b\",\"darkolivegreen\":\"#556b2f\",\"darkorange\":\"#ff8c00\",\"darkorchid\":\"#9932cc\",\"darkred\":\"#8b0000\",\"darksalmon\":\"#e9967a\",\"darkseagreen\":\"#8fbc8f\",\"darkslateblue\":\"#483d8b\",\"darkslategray\":\"#2f4f4f\",\"darkslategrey\":\"#2f4f4f\",\"darkturquoise\":\"#00ced1\",\"darkviolet\":\"#9400d3\",\"deeppink\":\"#ff1493\",\"deepskyblue\":\"#00bfff\",\"dimgray\":\"#696969\",\"dimgrey\":\"#696969\",\"dodgerblue\":\"#1e90ff\",\"firebrick\":\"#b22222\",\"floralwhite\":\"#fffaf0\",\"forestgreen\":\"#228b22\",\"fuchsia\":\"#ff00ff\",\"gainsboro\":\"#dcdcdc\",\"ghostwhite\":\"#f8f8ff\",\"gold\":\"#ffd700\",\"goldenrod\":\"#daa520\",\"gray\":\"#808080\",\"green\":\"#008000\",\"greenyellow\":\"#adff2f\",\"grey\":\"#808080\",\"honeydew\":\"#f0fff0\",\"hotpink\":\"#ff69b4\",\"indianred\":\"#cd5c5c\",\"indigo\":\"#4b0082\",\"ivory\":\"#fffff0\",\"khaki\":\"#f0e68c\",\"lavender\":\"#e6e6fa\",\"lavenderblush\":\"#fff0f5\",\"lawngreen\":\"#7cfc00\",\"lemonchiffon\":\"#fffacd\",\"lightblue\":\"#add8e6\",\"lightcoral\":\"#f08080\",\"lightcyan\":\"#e0ffff\",\"lightgoldenrodyellow\":\"#fafad2\",\"lightgray\":\"#d3d3d3\",\"lightgreen\":\"#90ee90\",\"lightgrey\":\"#d3d3d3\",\"lightpink\":\"#ffb6c1\",\"lightsalmon\":\"#ffa07a\",\"lightseagreen\":\"#20b2aa\",\"lightskyblue\":\"#87cefa\",\"lightslategray\":\"#778899\",\"lightslategrey\":\"#778899\",\"lightsteelblue\":\"#b0c4de\",\"lightyellow\":\"#ffffe0\",\"lime\":\"#00ff00\",\"limegreen\":\"#32cd32\",\"linen\":\"#faf0e6\",\"magenta\":\"#ff00ff\",\"maroon\":\"#800000\",\"mediumaquamarine\":\"#66cdaa\",\"mediumblue\":\"#0000cd\",\"mediumorchid\":\"#ba55d3\",\"mediumpurple\":\"#9370db\",\"mediumseagreen\":\"#3cb371\",\"mediumslateblue\":\"#7b68ee\",\"mediumspringgreen\":\"#00fa9a\",\"mediumturquoise\":\"#48d1cc\",\"mediumvioletred\":\"#c71585\",\"midnightblue\":\"#191970\",\"mintcream\":\"#f5fffa\",\"mistyrose\":\"#ffe4e1\",\"moccasin\":\"#ffe4b5\",\"navajowhite\":\"#ffdead\",\"navy\":\"#000080\",\"oldlace\":\"#fdf5e6\",\"olive\":\"#808000\",\"olivedrab\":\"#6b8e23\",\"orange\":\"#ffa500\",\"orangered\":\"#ff4500\",\"orchid\":\"#da70d6\",\"palegoldenrod\":\"#eee8aa\",\"palegreen\":\"#98fb98\",\"paleturquoise\":\"#afeeee\",\"palevioletred\":\"#db7093\",\"papayawhip\":\"#ffefd5\",\"peachpuff\":\"#ffdab9\",\"peru\":\"#cd853f\",\"pink\":\"#ffc0cb\",\"plum\":\"#dda0dd\",\"powderblue\":\"#b0e0e6\",\"purple\":\"#800080\",\"rebeccapurple\":\"#663399\",\"red\":\"#ff0000\",\"rosybrown\":\"#bc8f8f\",\"royalblue\":\"#4169e1\",\"saddlebrown\":\"#8b4513\",\"salmon\":\"#fa8072\",\"sandybrown\":\"#f4a460\",\"seagreen\":\"#2e8b57\",\"seashell\":\"#fff5ee\",\"sienna\":\"#a0522d\",\"silver\":\"#c0c0c0\",\"skyblue\":\"#87ceeb\",\"slateblue\":\"#6a5acd\",\"slategray\":\"#708090\",\"slategrey\":\"#708090\",\"snow\":\"#fffafa\",\"springgreen\":\"#00ff7f\",\"steelblue\":\"#4682b4\",\"tan\":\"#d2b48c\",\"teal\":\"#008080\",\"thistle\":\"#d8bfd8\",\"tomato\":\"#ff6347\",\"turquoise\":\"#40e0d0\",\"violet\":\"#ee82ee\",\"wheat\":\"#f5deb3\",\"white\":\"#ffffff\",\"whitesmoke\":\"#f5f5f5\",\"yellow\":\"#ffff00\",\"yellowgreen\":\"#9acd32\"}");

});


parcelRegister("9IGaJ", function(module, exports) {

$parcel$export(module.exports, "generateUuid", () => $7138efa2a0163ee8$export$1c3aefb711c3a4cc);
$parcel$export(module.exports, "uuid", () => $7138efa2a0163ee8$export$31b40729666a4ae0);
/* eslint-disable no-bitwise */ const $7138efa2a0163ee8$export$1c3aefb711c3a4cc = ()=>'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0;
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
/* eslint-enable no-bitwise */ let $7138efa2a0163ee8$var$staticValue = false;
const $7138efa2a0163ee8$export$31b40729666a4ae0 = {
    setStatic (value) {
        $7138efa2a0163ee8$var$staticValue = value;
    },
    generate () {
        return $7138efa2a0163ee8$var$staticValue || $7138efa2a0163ee8$export$1c3aefb711c3a4cc();
    }
};

});

parcelRegister("87j2U", function(module, exports) {

$parcel$export(module.exports, "getDarkModeLCHColor", () => $5e8dc04ff4ab4f7d$export$a5065c3b8aacaf99);
// https://en.wikipedia.org/wiki/HCL_color_space
// https://en.wikipedia.org/wiki/CIE_1931_color_space#CIE_xy_chromaticity_diagram_and_the_CIE_xyY_color_space
// https://en.wikipedia.org/wiki/CIELAB_color_space
const $5e8dc04ff4ab4f7d$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
const $5e8dc04ff4ab4f7d$var$expandShorthandHex = (input)=>input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b)=>r + r + g + g + b + b);
const $5e8dc04ff4ab4f7d$var$rgbFromHex = (input)=>{
    const fullHex = $5e8dc04ff4ab4f7d$var$expandShorthandHex(input);
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
const $5e8dc04ff4ab4f7d$var$rgbToHex = ({ r: r, g: g, b: b })=>{
    const convertComponent = (c)=>{
        const cBase16 = c.toString(16);
        return cBase16.length === 1 ? `0${cBase16}` : cBase16;
    };
    return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
};
const $5e8dc04ff4ab4f7d$var$rgbToXyz = (rgb)=>{
    const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    const r = convertRgbComponent(rgb.r / 255);
    const g = convertRgbComponent(rgb.g / 255);
    const b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
const $5e8dc04ff4ab4f7d$var$xyzToLab = ({ x: x, y: y, z: z })=>({
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    });
const $5e8dc04ff4ab4f7d$var$labToLch = ({ l: l, a: a, b: b })=>{
    let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
const $5e8dc04ff4ab4f7d$var$lchToLab = ({ l: l, c: c, h: h })=>{
    const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
const $5e8dc04ff4ab4f7d$var$labToXyz = ({ l: l, a: a, b: b })=>{
    const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    const y = (l + 16) / 116;
    const x = a / 500 + y;
    const z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
const $5e8dc04ff4ab4f7d$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
    const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    return {
        r: $5e8dc04ff4ab4f7d$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $5e8dc04ff4ab4f7d$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $5e8dc04ff4ab4f7d$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
const $5e8dc04ff4ab4f7d$var$rgbToLch = (rgb)=>$5e8dc04ff4ab4f7d$var$labToLch($5e8dc04ff4ab4f7d$var$xyzToLab($5e8dc04ff4ab4f7d$var$rgbToXyz(rgb)));
const $5e8dc04ff4ab4f7d$var$lchToRgb = (lch)=>$5e8dc04ff4ab4f7d$var$xyzToRgb($5e8dc04ff4ab4f7d$var$labToXyz($5e8dc04ff4ab4f7d$var$lchToLab(lch)));
const $5e8dc04ff4ab4f7d$export$313b8a8fcb34c3b8 = (color, newPercent)=>{
    const rgb = $5e8dc04ff4ab4f7d$var$rgbFromHex(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    const lch = $5e8dc04ff4ab4f7d$var$rgbToLch(rgb);
    lch.l = $5e8dc04ff4ab4f7d$var$clamp(newPercent, 0, 100);
    return $5e8dc04ff4ab4f7d$var$rgbToHex($5e8dc04ff4ab4f7d$var$lchToRgb(lch));
};
const $5e8dc04ff4ab4f7d$var$getLightness = (color)=>{
    const rgb = $5e8dc04ff4ab4f7d$var$rgbFromHex(color);
    if (rgb === null) return 0;
    const lch = $5e8dc04ff4ab4f7d$var$rgbToLch(rgb);
    return lch.l;
};
const $5e8dc04ff4ab4f7d$export$a5065c3b8aacaf99 = (currentBackgroundColor)=>{
    const lightness = $5e8dc04ff4ab4f7d$var$getLightness(currentBackgroundColor);
    const newLightness = Math.abs(100 - lightness);
    return $5e8dc04ff4ab4f7d$export$313b8a8fcb34c3b8(currentBackgroundColor, newLightness).toUpperCase();
};

});


parcelRegister("kBho7", function(module, exports) {

$parcel$export(module.exports, "createSchema", () => $eff4c0443be4d23b$export$5f4ce795563f4211);

var $kCV8T = parcelRequire("kCV8T");


var $7P7H6 = parcelRequire("7P7H6");

var $aeGrH = parcelRequire("aeGrH");
var $88i6h = parcelRequire("88i6h");
var $8jJss = parcelRequire("8jJss");
var $14Vqw = parcelRequire("14Vqw");
var $zceQE = parcelRequire("zceQE");
var $lcXoV = parcelRequire("lcXoV");
var $71k4W = parcelRequire("71k4W");
var $cUwVZ = parcelRequire("cUwVZ");
var $l3Tmi = parcelRequire("l3Tmi");
var $29Vii = parcelRequire("29Vii");
var $fK6mK = parcelRequire("fK6mK");
var $8XeG6 = parcelRequire("8XeG6");
var $aUhe2 = parcelRequire("aUhe2");
var $hhtT8 = parcelRequire("hhtT8");
var $4NwJJ = parcelRequire("4NwJJ");
var $c9aa1 = parcelRequire("c9aa1");
var $dtyqo = parcelRequire("dtyqo");
var $8EAPB = parcelRequire("8EAPB");
var $jxVez = parcelRequire("jxVez");
var $lVmBd = parcelRequire("lVmBd");

var $21PS7 = parcelRequire("21PS7");
var $5AxYU = parcelRequire("5AxYU");
var $kjhhp = parcelRequire("kjhhp");
var $5JeV5 = parcelRequire("5JeV5");
var $8vlrc = parcelRequire("8vlrc");
var $6bbHe = parcelRequire("6bbHe");
var $5y0tR = parcelRequire("5y0tR");
var $bd7A9 = parcelRequire("bd7A9");
var $b2VmY = parcelRequire("b2VmY");
var $Khvpb = parcelRequire("Khvpb");
var $8gSD8 = parcelRequire("8gSD8");
var $xjCuM = parcelRequire("xjCuM");
var $kshOv = parcelRequire("kshOv");
var $7DoMR = parcelRequire("7DoMR");
var $7kC9H = parcelRequire("7kC9H");
var $aXBFx = parcelRequire("aXBFx");
var $bFtEE = parcelRequire("bFtEE");
var $hhN5g = parcelRequire("hhN5g");
var $47jug = parcelRequire("47jug");
var $jnMM2 = parcelRequire("jnMM2");
var $lRTZM = parcelRequire("lRTZM");
var $7lRBh = parcelRequire("7lRBh");
var $cCBEe = parcelRequire("cCBEe");
var $5BOuQ = parcelRequire("5BOuQ");
var $4EbxI = parcelRequire("4EbxI");
var $gZoER = parcelRequire("gZoER");
var $2FIVU = parcelRequire("2FIVU");
var $7agO8 = parcelRequire("7agO8");
var $92lix = parcelRequire("92lix");
var $7Xgp3 = parcelRequire("7Xgp3");
var $bIGZ7 = parcelRequire("bIGZ7");
var $g7Cky = parcelRequire("g7Cky");
var $dx5eC = parcelRequire("dx5eC");
var $dwptW = parcelRequire("dwptW");
var $abme3 = parcelRequire("abme3");
var $dgJoa = parcelRequire("dgJoa");
var $M4hHz = parcelRequire("M4hHz");
var $18bvk = parcelRequire("18bvk");
var $9UDEr = parcelRequire("9UDEr");
var $iThOL = parcelRequire("iThOL");
var $43mJF = parcelRequire("43mJF");
var $3DR6L = parcelRequire("3DR6L");
var $9X587 = parcelRequire("9X587");
var $d1d6m = parcelRequire("d1d6m");
var $6kr5W = parcelRequire("6kr5W");
function $eff4c0443be4d23b$var$addItems(builtInItems, config, customSpecs = {}) {
    if (!config) return {};
    /**
   * Add built-in Node / Mark specs
   */ const items = builtInItems.reduce((items, { name: name, spec: spec })=>{
        if (config.indexOf(name) !== -1) items[name] = customSpecs[name] || spec;
        return items;
    }, {});
    /**
   * Add Custom Node / Mark specs
   */ return Object.keys(customSpecs).reduce((items, name)=>{
        if (items[name]) return items;
        items[name] = customSpecs[name];
        return items;
    }, items);
}
// We use groups to allow schemas to be constructed in different shapes without changing node/mark
// specs, but this means nodes/marks are defined with groups that might never be used in the schema.
// In this scenario ProseMirror will complain and prevent the schema from being constructed.
//
// To avoid the problem, we include items that serve to "declare" the groups in the schema. This
// approach unfortunately leaves unused items in the schema, but has the benefit of avoiding the
// need to manipulate `exclude` or content expression values for potentially every schema item.
function $eff4c0443be4d23b$var$groupDeclaration(name) {
    return {
        name: `__${name}GroupDeclaration`,
        spec: {
            group: name
        }
    };
}
const $eff4c0443be4d23b$var$markGroupDeclarations = [
    $eff4c0443be4d23b$var$groupDeclaration((0, $72fd39d34ca5bb7c$export$9b982809044276a6)),
    $eff4c0443be4d23b$var$groupDeclaration((0, $72fd39d34ca5bb7c$export$4498a6080fed604c)),
    $eff4c0443be4d23b$var$groupDeclaration((0, $72fd39d34ca5bb7c$export$f8e8a5f34f6ea725)),
    $eff4c0443be4d23b$var$groupDeclaration((0, $72fd39d34ca5bb7c$export$b395009ca7f092c7))
];
const $eff4c0443be4d23b$var$markGroupDeclarationsNames = $eff4c0443be4d23b$var$markGroupDeclarations.map((groupMark)=>groupMark.name);
const $eff4c0443be4d23b$var$nodesInOrder = [
    {
        name: 'doc',
        spec: (0, $xjCuM.doc)
    },
    {
        name: 'paragraph',
        spec: (0, $abme3.paragraph)
    },
    {
        name: 'text',
        spec: (0, $3DR6L.text)
    },
    {
        name: 'bulletList',
        spec: (0, $kjhhp.bulletList)
    },
    {
        name: 'orderedList',
        spec: (0, $dwptW.orderedListWithOrder)
    },
    {
        name: 'listItem',
        spec: (0, $2FIVU.listItemWithTask)
    },
    {
        name: 'heading',
        spec: (0, $lRTZM.heading)
    },
    {
        name: 'blockquote',
        spec: (0, $aXBFx.extendedBlockquote)
    },
    {
        name: 'codeBlock',
        spec: (0, $8vlrc.codeBlock)
    },
    {
        name: 'panel',
        spec: (0, $bFtEE.extendedPanel)(true)
    },
    {
        name: 'rule',
        spec: (0, $M4hHz.rule)
    },
    {
        name: 'image',
        spec: (0, $7lRBh.image)
    },
    {
        name: 'mention',
        spec: (0, $g7Cky.mention)
    },
    {
        name: 'caption',
        spec: (0, $5JeV5.caption)
    },
    {
        name: 'media',
        spec: (0, $7agO8.media)
    },
    {
        name: 'mediaGroup',
        spec: (0, $92lix.mediaGroup)
    },
    {
        name: 'mediaSingle',
        spec: (0, $bIGZ7.mediaSingleFull)
    },
    {
        name: 'mediaInline',
        spec: (0, $7Xgp3.mediaInline)
    },
    {
        name: 'placeholder',
        spec: (0, $dgJoa.placeholder)
    },
    {
        name: 'layoutSection',
        spec: (0, $gZoER.layoutSection)
    },
    {
        name: 'layoutColumn',
        spec: (0, $4EbxI.layoutColumn)
    },
    {
        name: 'hardBreak',
        spec: (0, $jnMM2.hardBreak)
    },
    {
        name: 'emoji',
        spec: (0, $7DoMR.emoji)
    },
    {
        name: 'table',
        spec: (0, $9UDEr.table)
    },
    {
        name: 'tableCell',
        spec: (0, $9UDEr.tableCell)
    },
    {
        name: 'tableRow',
        spec: (0, $9UDEr.tableRow)
    },
    {
        name: 'tableHeader',
        spec: (0, $9UDEr.tableHeader)
    },
    {
        name: 'confluenceJiraIssue',
        spec: (0, $6bbHe.confluenceJiraIssue)
    },
    {
        name: 'confluenceUnsupportedInline',
        spec: (0, $bd7A9.confluenceUnsupportedInline)
    },
    {
        name: 'confluenceUnsupportedBlock',
        spec: (0, $5y0tR.confluenceUnsupportedBlock)
    },
    {
        name: 'decisionList',
        spec: (0, $8gSD8.decisionList)
    },
    {
        name: 'decisionItem',
        spec: (0, $Khvpb.decisionItem)
    },
    {
        name: 'taskList',
        spec: (0, $43mJF.taskList)
    },
    {
        name: 'taskItem',
        spec: (0, $iThOL.taskItem)
    },
    {
        name: 'date',
        spec: (0, $b2VmY.date)
    },
    {
        name: 'status',
        spec: (0, $18bvk.status)
    },
    {
        name: 'expand',
        spec: (0, $7kC9H.expandWithNestedExpand)
    },
    {
        name: 'nestedExpand',
        spec: (0, $dx5eC.nestedExpand)
    },
    {
        name: 'extension',
        spec: (0, $hhN5g.extension)
    },
    {
        name: 'inlineExtension',
        spec: (0, $5BOuQ.inlineExtension)
    },
    {
        name: 'bodiedExtension',
        spec: (0, $5AxYU.bodiedExtension)
    },
    {
        name: 'multiBodiedExtension',
        spec: (0, $47jug.multiBodiedExtension)
    },
    {
        name: 'extensionFrame',
        spec: (0, $47jug.extensionFrame)
    },
    {
        name: 'inlineCard',
        spec: (0, $cCBEe.inlineCard)
    },
    {
        name: 'blockCard',
        spec: (0, $21PS7.blockCard)
    },
    {
        name: 'embedCard',
        spec: (0, $kshOv.embedCard)
    },
    {
        name: 'unknownBlock',
        spec: (0, $9X587.default)
    },
    {
        name: 'unsupportedBlock',
        spec: (0, $d1d6m.unsupportedBlock)
    },
    {
        name: 'unsupportedInline',
        spec: (0, $6kr5W.unsupportedInline)
    }
];
const $eff4c0443be4d23b$var$marksInOrder = [
    {
        name: 'link',
        spec: (0, $8XeG6.link)
    },
    {
        name: 'em',
        spec: (0, $l3Tmi.em)
    },
    {
        name: 'strong',
        spec: (0, $hhtT8.strong)
    },
    {
        name: 'textColor',
        spec: (0, $c9aa1.textColor)
    },
    {
        name: 'backgroundColor',
        spec: (0, $8jJss.backgroundColor)
    },
    {
        name: 'strike',
        spec: (0, $aUhe2.strike)
    },
    {
        name: 'subsup',
        spec: (0, $4NwJJ.subsup)
    },
    {
        name: 'underline',
        spec: (0, $8EAPB.underline)
    },
    {
        name: 'code',
        spec: (0, $lcXoV.code)
    },
    {
        name: 'typeAheadQuery',
        spec: (0, $dtyqo.typeAheadQuery)
    },
    {
        name: 'alignment',
        spec: (0, $aeGrH.alignment)
    },
    {
        name: 'annotation',
        spec: (0, $88i6h.annotation)
    },
    {
        name: 'confluenceInlineComment',
        spec: (0, $71k4W.confluenceInlineComment)
    },
    ...$eff4c0443be4d23b$var$markGroupDeclarations,
    {
        name: 'breakout',
        spec: (0, $zceQE.breakout)
    },
    {
        name: 'dataConsumer',
        spec: (0, $cUwVZ.dataConsumer)
    },
    {
        name: 'fragment',
        spec: (0, $29Vii.fragment)
    },
    {
        name: 'indentation',
        spec: (0, $fK6mK.indentation)
    },
    {
        name: 'border',
        spec: (0, $14Vqw.border)
    },
    {
        name: 'unsupportedMark',
        spec: (0, $jxVez.unsupportedMark)
    },
    {
        name: 'unsupportedNodeAttribute',
        spec: (0, $lVmBd.unsupportedNodeAttribute)
    }
];
function $eff4c0443be4d23b$export$2d0c32a809131488() {
    const nodes = $eff4c0443be4d23b$var$nodesInOrder.reduce((acc, { name: name, spec: spec })=>{
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    const marks = $eff4c0443be4d23b$var$marksInOrder.reduce((acc, { name: name, spec: spec })=>{
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    return {
        nodes: nodes,
        marks: marks
    };
}
function $eff4c0443be4d23b$export$5f4ce795563f4211(config) {
    const { customNodeSpecs: customNodeSpecs, customMarkSpecs: customMarkSpecs } = config;
    const nodesConfig = Object.keys(customNodeSpecs || {}).concat(config.nodes);
    const marksConfig = Object.keys(customMarkSpecs || {}).concat(config.marks || []).concat($eff4c0443be4d23b$var$markGroupDeclarationsNames);
    let nodes = $eff4c0443be4d23b$var$addItems($eff4c0443be4d23b$var$nodesInOrder, nodesConfig, customNodeSpecs);
    const marks = $eff4c0443be4d23b$var$addItems($eff4c0443be4d23b$var$marksInOrder, marksConfig, customMarkSpecs);
    nodes = (0, $7P7H6.sanitizeNodes)(nodes, marks);
    return new (0, $kCV8T.Schema)({
        nodes: nodes,
        marks: marks
    });
}
const $eff4c0443be4d23b$export$c77b6d30da5276a1 = true;

});
parcelRegister("kCV8T", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $f043ae92c0a873f0$export$ffb0004e005737fa);
$parcel$export(module.exports, "Mark", () => $f043ae92c0a873f0$export$c9d15bcfc6d42044);
$parcel$export(module.exports, "ReplaceError", () => $f043ae92c0a873f0$export$6de0e778727af3f2);
$parcel$export(module.exports, "Slice", () => $f043ae92c0a873f0$export$b3f2e2de3a8baa1e);
$parcel$export(module.exports, "ResolvedPos", () => $f043ae92c0a873f0$export$b2a42f82e59e4b19);
$parcel$export(module.exports, "NodeRange", () => $f043ae92c0a873f0$export$7bc461ceb770fb16);
$parcel$export(module.exports, "Node", () => $f043ae92c0a873f0$export$85c928794f8d04d4);
$parcel$export(module.exports, "MarkType", () => $f043ae92c0a873f0$export$b6a78689043c6521);
$parcel$export(module.exports, "Schema", () => $f043ae92c0a873f0$export$19342e026b58ebb7);
$parcel$export(module.exports, "DOMParser", () => $f043ae92c0a873f0$export$1059c6e7d2ce5669);
$parcel$export(module.exports, "DOMSerializer", () => $f043ae92c0a873f0$export$3476b78f8f5a8b72);

var $dHeNB = parcelRequire("dHeNB");
function $f043ae92c0a873f0$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $f043ae92c0a873f0$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $f043ae92c0a873f0$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $f043ae92c0a873f0$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $f043ae92c0a873f0$export$ffb0004e005737fa {
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $f043ae92c0a873f0$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $f043ae92c0a873f0$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $f043ae92c0a873f0$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $f043ae92c0a873f0$var$retIndex(0, pos);
        if (pos == this.size) return $f043ae92c0a873f0$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $f043ae92c0a873f0$var$retIndex(i + 1, end);
                return $f043ae92c0a873f0$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
        if (nodes instanceof $f043ae92c0a873f0$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $f043ae92c0a873f0$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $f043ae92c0a873f0$export$ffb0004e005737fa.empty = new $f043ae92c0a873f0$export$ffb0004e005737fa([], 0);
const $f043ae92c0a873f0$var$found = {
    index: 0,
    offset: 0
};
function $f043ae92c0a873f0$var$retIndex(index, offset) {
    $f043ae92c0a873f0$var$found.index = index;
    $f043ae92c0a873f0$var$found.offset = offset;
    return $f043ae92c0a873f0$var$found;
}
function $f043ae92c0a873f0$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$f043ae92c0a873f0$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$f043ae92c0a873f0$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $f043ae92c0a873f0$export$c9d15bcfc6d42044 {
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $f043ae92c0a873f0$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        if (marks instanceof $f043ae92c0a873f0$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
}
/**
The empty set of marks.
*/ $f043ae92c0a873f0$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $f043ae92c0a873f0$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $f043ae92c0a873f0$export$b3f2e2de3a8baa1e {
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $f043ae92c0a873f0$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e($f043ae92c0a873f0$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e($f043ae92c0a873f0$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
}
/**
The empty slice.
*/ $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.empty = new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e($f043ae92c0a873f0$export$ffb0004e005737fa.empty, 0, 0);
function $f043ae92c0a873f0$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($f043ae92c0a873f0$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $f043ae92c0a873f0$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $f043ae92c0a873f0$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $f043ae92c0a873f0$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $f043ae92c0a873f0$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $f043ae92c0a873f0$export$6de0e778727af3f2("Inconsistent open depths");
    return $f043ae92c0a873f0$var$replaceOuter($from, $to, slice, 0);
}
function $f043ae92c0a873f0$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $f043ae92c0a873f0$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $f043ae92c0a873f0$var$close(node, $f043ae92c0a873f0$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $f043ae92c0a873f0$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $f043ae92c0a873f0$var$prepareSliceForReplace(slice, $from);
        return $f043ae92c0a873f0$var$close(node, $f043ae92c0a873f0$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $f043ae92c0a873f0$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $f043ae92c0a873f0$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $f043ae92c0a873f0$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $f043ae92c0a873f0$var$checkJoin(node, $after.node(depth));
    return node;
}
function $f043ae92c0a873f0$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $f043ae92c0a873f0$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $f043ae92c0a873f0$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$f043ae92c0a873f0$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $f043ae92c0a873f0$var$addNode($end.nodeBefore, target);
}
function $f043ae92c0a873f0$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $f043ae92c0a873f0$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $f043ae92c0a873f0$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $f043ae92c0a873f0$var$joinable($end, $to, depth + 1);
    let content = [];
    $f043ae92c0a873f0$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $f043ae92c0a873f0$var$checkJoin(openStart, openEnd);
        $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(openStart, $f043ae92c0a873f0$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(openStart, $f043ae92c0a873f0$var$replaceTwoWay($from, $start, depth + 1)), content);
        $f043ae92c0a873f0$var$addRange($start, $end, depth, content);
        if (openEnd) $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(openEnd, $f043ae92c0a873f0$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $f043ae92c0a873f0$var$addRange($to, null, depth, content);
    return new $f043ae92c0a873f0$export$ffb0004e005737fa(content);
}
function $f043ae92c0a873f0$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $f043ae92c0a873f0$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $f043ae92c0a873f0$var$joinable($from, $to, depth + 1);
        $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(type, $f043ae92c0a873f0$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $f043ae92c0a873f0$var$addRange($to, null, depth, content);
    return new $f043ae92c0a873f0$export$ffb0004e005737fa(content);
}
function $f043ae92c0a873f0$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($f043ae92c0a873f0$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $f043ae92c0a873f0$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $f043ae92c0a873f0$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $f043ae92c0a873f0$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $f043ae92c0a873f0$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $f043ae92c0a873f0$var$resolveCache.set(doc, cache = new $f043ae92c0a873f0$var$ResolveCache);
        let result = cache.elts[cache.i] = $f043ae92c0a873f0$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $f043ae92c0a873f0$var$resolveCacheSize;
        return result;
    }
}
class $f043ae92c0a873f0$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $f043ae92c0a873f0$var$resolveCacheSize = 12, $f043ae92c0a873f0$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $f043ae92c0a873f0$export$7bc461ceb770fb16 {
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
}
const $f043ae92c0a873f0$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](/docs/guide/#doc) for more information.
*/ class $f043ae92c0a873f0$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
    }
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $f043ae92c0a873f0$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $f043ae92c0a873f0$var$emptyAttrs) && $f043ae92c0a873f0$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $f043ae92c0a873f0$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $f043ae92c0a873f0$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $f043ae92c0a873f0$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $f043ae92c0a873f0$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $f043ae92c0a873f0$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $f043ae92c0a873f0$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $f043ae92c0a873f0$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $f043ae92c0a873f0$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$f043ae92c0a873f0$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $f043ae92c0a873f0$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
}
$f043ae92c0a873f0$export$85c928794f8d04d4.prototype.text = undefined;
class $f043ae92c0a873f0$var$TextNode extends $f043ae92c0a873f0$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $f043ae92c0a873f0$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $f043ae92c0a873f0$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $f043ae92c0a873f0$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
}
function $f043ae92c0a873f0$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $f043ae92c0a873f0$export$364ed450558d7ec4 {
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $f043ae92c0a873f0$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $f043ae92c0a873f0$export$364ed450558d7ec4.empty;
        let expr = $f043ae92c0a873f0$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $f043ae92c0a873f0$var$dfa($f043ae92c0a873f0$var$nfa(expr));
        $f043ae92c0a873f0$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $f043ae92c0a873f0$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
}
/**
@internal
*/ $f043ae92c0a873f0$export$364ed450558d7ec4.empty = new $f043ae92c0a873f0$export$364ed450558d7ec4(true);
class $f043ae92c0a873f0$var$TokenStream {
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
}
function $f043ae92c0a873f0$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($f043ae92c0a873f0$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $f043ae92c0a873f0$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($f043ae92c0a873f0$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $f043ae92c0a873f0$var$parseExprSubscript(stream) {
    let expr = $f043ae92c0a873f0$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $f043ae92c0a873f0$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $f043ae92c0a873f0$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $f043ae92c0a873f0$var$parseExprRange(stream, expr) {
    let min = $f043ae92c0a873f0$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $f043ae92c0a873f0$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $f043ae92c0a873f0$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $f043ae92c0a873f0$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $f043ae92c0a873f0$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $f043ae92c0a873f0$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $f043ae92c0a873f0$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $f043ae92c0a873f0$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $f043ae92c0a873f0$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($f043ae92c0a873f0$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $f043ae92c0a873f0$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($f043ae92c0a873f0$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $f043ae92c0a873f0$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $f043ae92c0a873f0$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($f043ae92c0a873f0$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $f043ae92c0a873f0$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $f043ae92c0a873f0$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $f043ae92c0a873f0$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $f043ae92c0a873f0$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $f043ae92c0a873f0$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $f043ae92c0a873f0$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $f043ae92c0a873f0$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $f043ae92c0a873f0$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $f043ae92c0a873f0$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $f043ae92c0a873f0$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $f043ae92c0a873f0$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $f043ae92c0a873f0$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $f043ae92c0a873f0$export$ffb0004e005737fa.from(content), $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $f043ae92c0a873f0$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $f043ae92c0a873f0$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $f043ae92c0a873f0$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($f043ae92c0a873f0$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $f043ae92c0a873f0$export$85c928794f8d04d4(this, attrs, content.append(after), $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $f043ae92c0a873f0$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $f043ae92c0a873f0$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
}
function $f043ae92c0a873f0$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $f043ae92c0a873f0$var$Attribute {
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $f043ae92c0a873f0$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
    get isRequired() {
        return !this.hasDefault;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $f043ae92c0a873f0$export$b6a78689043c6521 {
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $f043ae92c0a873f0$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $f043ae92c0a873f0$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $f043ae92c0a873f0$export$c9d15bcfc6d42044(this, defaults) : null;
    }
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $f043ae92c0a873f0$export$c9d15bcfc6d42044(this, $f043ae92c0a873f0$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $f043ae92c0a873f0$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $f043ae92c0a873f0$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $f043ae92c0a873f0$export$19342e026b58ebb7 {
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $dHeNB.default).from(spec.nodes), instanceSpec.marks = (0, $dHeNB.default).from(spec.marks || {}), this.nodes = $f043ae92c0a873f0$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $f043ae92c0a873f0$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $f043ae92c0a873f0$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $f043ae92c0a873f0$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $f043ae92c0a873f0$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $f043ae92c0a873f0$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $f043ae92c0a873f0$var$TextNode(type, type.defaultAttrs, text, $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $f043ae92c0a873f0$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $f043ae92c0a873f0$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
}
function $f043ae92c0a873f0$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $f043ae92c0a873f0$var$isTagRule(rule) {
    return rule.tag != null;
}
function $f043ae92c0a873f0$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $f043ae92c0a873f0$export$1059c6e7d2ce5669 {
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($f043ae92c0a873f0$var$isTagRule(rule)) this.tags.push(rule);
            else if ($f043ae92c0a873f0$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $f043ae92c0a873f0$var$ParseContext(this, options, false);
        context.addAll(dom, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $f043ae92c0a873f0$var$ParseContext(this, options, true);
        context.addAll(dom, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($f043ae92c0a873f0$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $f043ae92c0a873f0$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $f043ae92c0a873f0$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $f043ae92c0a873f0$export$1059c6e7d2ce5669(schema, $f043ae92c0a873f0$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
}
const $f043ae92c0a873f0$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $f043ae92c0a873f0$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $f043ae92c0a873f0$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $f043ae92c0a873f0$var$OPT_PRESERVE_WS = 1, $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL = 2, $f043ae92c0a873f0$var$OPT_OPEN_LEFT = 4;
function $f043ae92c0a873f0$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $f043ae92c0a873f0$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $f043ae92c0a873f0$var$OPT_PRESERVE_WS | $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL : base & ~$f043ae92c0a873f0$var$OPT_OPEN_LEFT;
}
class $f043ae92c0a873f0$var$NodeContext {
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $f043ae92c0a873f0$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($f043ae92c0a873f0$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $f043ae92c0a873f0$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $f043ae92c0a873f0$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($f043ae92c0a873f0$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$f043ae92c0a873f0$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
}
class $f043ae92c0a873f0$var$ParseContext {
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $f043ae92c0a873f0$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $f043ae92c0a873f0$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $f043ae92c0a873f0$var$NodeContext(topNode.type, topNode.attrs, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $f043ae92c0a873f0$var$NodeContext(null, null, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $f043ae92c0a873f0$var$NodeContext(parser.schema.topNodeType, null, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $f043ae92c0a873f0$var$OPT_PRESERVE_WS) > 0;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS !== "full") value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value), marks);
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($f043ae92c0a873f0$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $f043ae92c0a873f0$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $f043ae92c0a873f0$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($f043ae92c0a873f0$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks)) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks) {
        let route, sync;
        for(let depth = this.open; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) break;
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $f043ae92c0a873f0$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $f043ae92c0a873f0$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $f043ae92c0a873f0$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $f043ae92c0a873f0$var$OPT_OPEN_LEFT;
        let applyMarks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $f043ae92c0a873f0$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $f043ae92c0a873f0$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $f043ae92c0a873f0$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $f043ae92c0a873f0$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $f043ae92c0a873f0$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $f043ae92c0a873f0$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $f043ae92c0a873f0$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $f043ae92c0a873f0$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $f043ae92c0a873f0$export$3476b78f8f5a8b72 {
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $f043ae92c0a873f0$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $f043ae92c0a873f0$var$renderSpec($f043ae92c0a873f0$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $f043ae92c0a873f0$var$renderSpec($f043ae92c0a873f0$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $f043ae92c0a873f0$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $f043ae92c0a873f0$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $f043ae92c0a873f0$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $f043ae92c0a873f0$var$gatherToDOM(schema.marks);
    }
}
function $f043ae92c0a873f0$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $f043ae92c0a873f0$var$doc(options) {
    return options.document || window.document;
}
const $f043ae92c0a873f0$var$suspiciousAttributeCache = new WeakMap();
function $f043ae92c0a873f0$var$suspiciousAttributes(attrs) {
    let value = $f043ae92c0a873f0$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $f043ae92c0a873f0$var$suspiciousAttributeCache.set(attrs, value = $f043ae92c0a873f0$var$suspiciousAttributesInner(attrs));
    return value;
}
function $f043ae92c0a873f0$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $f043ae92c0a873f0$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $f043ae92c0a873f0$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $f043ae92c0a873f0$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});
parcelRegister("dHeNB", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f8ac547b0b2e1f8$export$2e2bcd8739ae039);
// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function $9f8ac547b0b2e1f8$var$OrderedMap(content) {
    this.content = content;
}
$9f8ac547b0b2e1f8$var$OrderedMap.prototype = {
    constructor: $9f8ac547b0b2e1f8$var$OrderedMap,
    find: function(key) {
        for(var i = 0; i < this.content.length; i += 2)if (this.content[i] === key) return i;
        return -1;
    },
    // :: (string) → ?any
    // Retrieve the value stored under `key`, or return undefined when
    // no such key exists.
    get: function(key) {
        var found = this.find(key);
        return found == -1 ? undefined : this.content[found + 1];
    },
    // :: (string, any, ?string) → OrderedMap
    // Create a new map by replacing the value of `key` with a new
    // value, or adding a binding to the end of the map. If `newKey` is
    // given, the key of the binding will be replaced with that key.
    update: function(key, value, newKey) {
        var self = newKey && newKey != key ? this.remove(newKey) : this;
        var found = self.find(key), content = self.content.slice();
        if (found == -1) content.push(newKey || key, value);
        else {
            content[found + 1] = value;
            if (newKey) content[found] = newKey;
        }
        return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
    },
    // :: (string) → OrderedMap
    // Return a map with the given key removed, if it existed.
    remove: function(key) {
        var found = this.find(key);
        if (found == -1) return this;
        var content = this.content.slice();
        content.splice(found, 2);
        return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the start of the map.
    addToStart: function(key, value) {
        return new $9f8ac547b0b2e1f8$var$OrderedMap([
            key,
            value
        ].concat(this.remove(key).content));
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the end of the map.
    addToEnd: function(key, value) {
        var content = this.remove(key).content.slice();
        content.push(key, value);
        return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
    },
    // :: (string, string, any) → OrderedMap
    // Add a key after the given key. If `place` is not found, the new
    // key is added to the end.
    addBefore: function(place, key, value) {
        var without = this.remove(key), content = without.content.slice();
        var found = without.find(place);
        content.splice(found == -1 ? content.length : found, 0, key, value);
        return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
    },
    // :: ((key: string, value: any))
    // Call the given function for each key/value pair in the map, in
    // order.
    forEach: function(f) {
        for(var i = 0; i < this.content.length; i += 2)f(this.content[i], this.content[i + 1]);
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by prepending the keys in this map that don't
    // appear in `map` before the keys in `map`.
    prepend: function(map) {
        map = $9f8ac547b0b2e1f8$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $9f8ac547b0b2e1f8$var$OrderedMap(map.content.concat(this.subtract(map).content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by appending the keys in this map that don't
    // appear in `map` after the keys in `map`.
    append: function(map) {
        map = $9f8ac547b0b2e1f8$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $9f8ac547b0b2e1f8$var$OrderedMap(this.subtract(map).content.concat(map.content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a map containing all the keys in this map that don't
    // appear in `map`.
    subtract: function(map) {
        var result = this;
        map = $9f8ac547b0b2e1f8$var$OrderedMap.from(map);
        for(var i = 0; i < map.content.length; i += 2)result = result.remove(map.content[i]);
        return result;
    },
    // :: () → Object
    // Turn ordered map into a plain object.
    toObject: function() {
        var result = {};
        this.forEach(function(key, value) {
            result[key] = value;
        });
        return result;
    },
    // :: number
    // The amount of keys in this map.
    get size () {
        return this.content.length >> 1;
    }
};
// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
$9f8ac547b0b2e1f8$var$OrderedMap.from = function(value) {
    if (value instanceof $9f8ac547b0b2e1f8$var$OrderedMap) return value;
    var content = [];
    if (value) for(var prop in value)content.push(prop, value[prop]);
    return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
};
var $9f8ac547b0b2e1f8$export$2e2bcd8739ae039 = $9f8ac547b0b2e1f8$var$OrderedMap;

});


// # What do marks exist?
//
// Marks are categorised into different groups. One motivation for this was to allow the `code` mark
// to exclude other marks, without needing to explicitly name them. Explicit naming requires the
// named mark to exist in the schema. This is undesirable because we want to construct different
// schemas that have different sets of nodes/marks.
//
// Groups provide a level of indirection, and solve this problem. For the immediate use-case, one
// group called "not_code" would have sufficed, but this an ultra-specialised to code.
// Mark group for font styling (e.g. bold, italic, underline, superscript).
const $72fd39d34ca5bb7c$export$4498a6080fed604c = 'fontStyle';
const $72fd39d34ca5bb7c$export$f8e8a5f34f6ea725 = 'searchQuery';
const $72fd39d34ca5bb7c$export$b395009ca7f092c7 = 'link';
const $72fd39d34ca5bb7c$export$9b982809044276a6 = 'color';
const $72fd39d34ca5bb7c$export$470d0905851e47a1 = 'alignment';
const $72fd39d34ca5bb7c$export$bacb7f4b06a06b22 = 'indentation';

parcelRegister("7P7H6", function(module, exports) {

$parcel$export(module.exports, "sanitizeNodes", () => $5b2343b4eb27461c$export$daf54fed04c8fb77);
function $5b2343b4eb27461c$export$daf54fed04c8fb77(nodes, supportedMarks) {
    const nodeNames = Object.keys(nodes);
    nodeNames.forEach((nodeKey)=>{
        const nodeSpec = {
            ...nodes[nodeKey]
        };
        if (nodeSpec.marks && nodeSpec.marks !== '_') nodeSpec.marks = nodeSpec.marks.split(' ').filter((mark)=>!!supportedMarks[mark]).join(' ');
        if (nodeSpec.content) nodeSpec.content = $5b2343b4eb27461c$var$sanitizeNodeSpecContent(nodes, nodeSpec.content);
        nodes[nodeKey] = nodeSpec;
    });
    return nodes;
}
function $5b2343b4eb27461c$var$sanitizeNodeSpecContent(nodes, rawContent) {
    const content = rawContent.replace(/\W/g, ' ');
    const contentKeys = content.split(' ');
    const unsupportedContentKeys = contentKeys.filter((contentKey)=>!$5b2343b4eb27461c$var$isContentSupported(nodes, contentKey));
    return unsupportedContentKeys.reduce((newContent, nodeName)=>$5b2343b4eb27461c$var$sanitizedContent(newContent, nodeName), rawContent);
}
function $5b2343b4eb27461c$var$sanitizedContent(content, invalidContent) {
    if (!invalidContent.length) return content || '';
    if (!content || !content.match(/\w/)) return '';
    const pattern = `(${invalidContent}((\\s)*\\|)+)|((\\|(\\s)*)+${invalidContent}(\\+|\\*)?)|(${invalidContent}$)|(${invalidContent}(\\+|\\*))`;
    return content.replace(new RegExp(pattern, 'g'), '').replace('  ', ' ').trim();
}
function $5b2343b4eb27461c$var$isContentSupported(nodes, contentKey) {
    const nodeKeys = Object.keys(nodes);
    // content is with valid node
    if (nodeKeys.indexOf(contentKey) > -1) return true;
    // content is with valid group
    for(const supportedKey in nodes){
        const nodeSpec = nodes[supportedKey];
        if (nodeSpec && nodeSpec.group === contentKey) return true;
    }
    return false;
}

});

parcelRegister("aeGrH", function(module, exports) {

$parcel$export(module.exports, "alignmentPositionMap", () => $773c2309706a915e$export$be9cf49015769bbd);
$parcel$export(module.exports, "alignment", () => $773c2309706a915e$export$8e53000a4ec837);

var $2fTAU = parcelRequire("2fTAU");
const $773c2309706a915e$export$be9cf49015769bbd = {
    end: 'right',
    right: 'end',
    center: 'center'
};
const $773c2309706a915e$export$8e53000a4ec837 = (0, $2fTAU.alignment)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-block-mark',
            getAttrs: (dom)=>{
                const align = dom.getAttribute('data-align');
                return align ? {
                    align: align
                } : false;
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: `fabric-editor-block-mark fabric-editor-alignment fabric-editor-align-${mark.attrs.align}`,
                'data-align': mark.attrs.align
            },
            0
        ];
    }
});

});
parcelRegister("2fTAU", function(module, exports) {

$parcel$export(module.exports, "alignment", () => $1a481b607696d815$export$8e53000a4ec837);
$parcel$export(module.exports, "annotation", () => $1a481b607696d815$export$8512c9afa7b24c3b);
$parcel$export(module.exports, "backgroundColor", () => $1a481b607696d815$export$8c5a050822fd698c);
$parcel$export(module.exports, "border", () => $1a481b607696d815$export$1edee58a52776cd9);
$parcel$export(module.exports, "breakout", () => $1a481b607696d815$export$89015c65f1c75e3f);
$parcel$export(module.exports, "code", () => $1a481b607696d815$export$6565f9f03506010b);
$parcel$export(module.exports, "confluenceInlineComment", () => $1a481b607696d815$export$f3b72f8fc4684ecd);
$parcel$export(module.exports, "dataConsumer", () => $1a481b607696d815$export$3024f02c495408d6);
$parcel$export(module.exports, "em", () => $1a481b607696d815$export$c63c6f932822f543);
$parcel$export(module.exports, "fragment", () => $1a481b607696d815$export$f00aeb236b6f05af);
$parcel$export(module.exports, "indentation", () => $1a481b607696d815$export$480c699bd4ec0d86);
$parcel$export(module.exports, "link", () => $1a481b607696d815$export$9c30223ca0a664fb);
$parcel$export(module.exports, "strike", () => $1a481b607696d815$export$4899a95d70ec5056);
$parcel$export(module.exports, "strong", () => $1a481b607696d815$export$59ae2c325a998f89);
$parcel$export(module.exports, "subsup", () => $1a481b607696d815$export$b3401ee80eb31041);
$parcel$export(module.exports, "textColor", () => $1a481b607696d815$export$32f78bffcd82ff28);
$parcel$export(module.exports, "typeAheadQuery", () => $1a481b607696d815$export$20af3dabbb5538df);
$parcel$export(module.exports, "underline", () => $1a481b607696d815$export$425327af25286e5e);
$parcel$export(module.exports, "unsupportedMark", () => $1a481b607696d815$export$30d78d5eb6719bb8);
$parcel$export(module.exports, "unsupportedNodeAttribute", () => $1a481b607696d815$export$a316dc07ff5182a2);
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $f0ccE = parcelRequire("f0ccE");
const $1a481b607696d815$export$8e53000a4ec837 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        align: {}
    },
    excludes: 'alignment indentation',
    group: 'alignment'
});
const $1a481b607696d815$export$8512c9afa7b24c3b = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        id: {
            default: ''
        },
        annotationType: {
            default: 'inlineComment'
        }
    },
    inclusive: true,
    excludes: '',
    group: 'annotation'
});
const $1a481b607696d815$export$8c5a050822fd698c = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    excludes: 'color',
    group: 'color'
});
const $1a481b607696d815$export$1edee58a52776cd9 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        size: {},
        color: {}
    },
    inclusive: false
});
const $1a481b607696d815$export$89015c65f1c75e3f = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        mode: {
            default: 'wide'
        },
        width: {
            default: null
        }
    },
    inclusive: false,
    spanning: false
});
const $1a481b607696d815$export$6565f9f03506010b = (0, $f0ccE.createPMMarkSpecFactory)({
    inclusive: true,
    excludes: 'fontStyle link searchQuery color'
});
const $1a481b607696d815$export$f3b72f8fc4684ecd = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        reference: {
            default: ''
        }
    },
    inclusive: false,
    excludes: ''
});
const $1a481b607696d815$export$3024f02c495408d6 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        sources: {
            default: []
        }
    }
});
const $1a481b607696d815$export$c63c6f932822f543 = (0, $f0ccE.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $1a481b607696d815$export$f00aeb236b6f05af = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        localId: {
            default: ''
        },
        name: {
            default: null
        }
    },
    inclusive: false,
    excludes: ''
});
const $1a481b607696d815$export$480c699bd4ec0d86 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        level: {}
    },
    excludes: 'indentation alignment',
    group: 'indentation'
});
const $1a481b607696d815$export$9c30223ca0a664fb = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        href: {},
        __confluenceMetadata: {
            default: null
        }
    },
    inclusive: false,
    excludes: 'link',
    group: 'link'
});
const $1a481b607696d815$export$4899a95d70ec5056 = (0, $f0ccE.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $1a481b607696d815$export$59ae2c325a998f89 = (0, $f0ccE.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $1a481b607696d815$export$b3401ee80eb31041 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        type: {
            default: 'sub'
        }
    },
    inclusive: true,
    group: 'fontStyle'
});
const $1a481b607696d815$export$32f78bffcd82ff28 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    group: 'color'
});
const $1a481b607696d815$export$20af3dabbb5538df = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        trigger: {
            default: ''
        }
    },
    inclusive: true,
    group: 'searchQuery'
});
const $1a481b607696d815$export$425327af25286e5e = (0, $f0ccE.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $1a481b607696d815$export$30d78d5eb6719bb8 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        originalValue: {}
    },
    excludes: ''
});
const $1a481b607696d815$export$a316dc07ff5182a2 = (0, $f0ccE.createPMMarkSpecFactory)({
    attrs: {
        unsupported: {},
        type: {}
    }
});

});


parcelRegister("88i6h", function(module, exports) {

$parcel$export(module.exports, "AnnotationTypes", () => $5ebd1c6c912098fc$export$94aa2fc69ad33d19);
$parcel$export(module.exports, "AnnotationMarkStates", () => $5ebd1c6c912098fc$export$4bab14797673da9f);
$parcel$export(module.exports, "buildDataAttributes", () => $5ebd1c6c912098fc$export$93a98caa8bc6cb07);
$parcel$export(module.exports, "annotation", () => $5ebd1c6c912098fc$export$8512c9afa7b24c3b);

var $2fTAU = parcelRequire("2fTAU");
let $5ebd1c6c912098fc$export$94aa2fc69ad33d19 = /*#__PURE__*/ function(AnnotationTypes) {
    AnnotationTypes["INLINE_COMMENT"] = "inlineComment";
    return AnnotationTypes;
}({});
let $5ebd1c6c912098fc$export$4bab14797673da9f = /*#__PURE__*/ function(AnnotationMarkStates) {
    AnnotationMarkStates["RESOLVED"] = "resolved";
    AnnotationMarkStates["ACTIVE"] = "active";
    return AnnotationMarkStates;
}({});
function $5ebd1c6c912098fc$export$93a98caa8bc6cb07({ id: id, annotationType: annotationType, state: state }) {
    const data = {
        'data-mark-type': 'annotation',
        'data-mark-annotation-type': annotationType,
        'data-id': id
    };
    if (state) return {
        ...data,
        'data-mark-annotation-state': state
    };
    return data;
}
const $5ebd1c6c912098fc$export$8512c9afa7b24c3b = (0, $2fTAU.annotation)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="annotation"]',
            mark: 'annotation',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const attrs = {
                    id: dom.getAttribute('data-id'),
                    annotationType: dom.getAttribute('data-mark-annotation-type')
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        /*
      Data attributes on the DOM node are a temporary means of
      incrementally switching over to the Annotation mark. Once renderer
      provides native support for inline comments the data attributes on the
      DOM nodes will be removed.
    */ return [
            'span',
            {
                // Prettier will remove the quotes around class. This would cause some browsers
                // to not add this attribute properly, as its a reserved word.
                // prettier-ignore
                'class': 'fabric-editor-annotation',
                ...$5ebd1c6c912098fc$export$93a98caa8bc6cb07({
                    id: node.attrs.id,
                    annotationType: node.attrs.annotationType
                })
            },
            0
        ];
    }
});

});

parcelRegister("8jJss", function(module, exports) {

$parcel$export(module.exports, "backgroundColor", () => $60e35c16db44f137$export$8c5a050822fd698c);

var $2fTAU = parcelRequire("2fTAU");

var $daes7 = parcelRequire("daes7");

var $51H8P = parcelRequire("51H8P");

var $c9aa1 = parcelRequire("c9aa1");

var $87j2U = parcelRequire("87j2U");
/**
 * @name backgroundColor_mark
 */ const $60e35c16db44f137$var$colorArrayPalette = [
    [
        (0, $51H8P.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $51H8P.T200),
        'Teal'
    ],
    // token: color.background.accent.teal.subtler
    [
        (0, $51H8P.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $51H8P.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $51H8P.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $51H8P.P200),
        'Purple'
    ] // token: color.background.accent.purple.subtler
];
const $60e35c16db44f137$export$14ec3f21a268e497 = new Map();
$60e35c16db44f137$var$colorArrayPalette.forEach(([color, label])=>$60e35c16db44f137$export$14ec3f21a268e497.set(color.toLowerCase(), label));
const $60e35c16db44f137$export$8c5a050822fd698c = (0, $2fTAU.backgroundColor)({
    parseDOM: [
        {
            style: 'background-color',
            getAttrs: (maybeValue)=>{
                const value = maybeValue;
                let hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $51H8P.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $60e35c16db44f137$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This is used to support the work-around that converts the hex color to
        // a design system token to enable light / dark mode (through a CSS variable --custom-palette-color)
        {
            tag: '.fabric-background-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.backgroundCustomColor;
                return hexColor && $60e35c16db44f137$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        /**
     * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * separate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $daes7.hexToEditorTextBackgroundPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ((0, $c9aa1.getGlobalTheme)().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $87j2U.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-background-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-background-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-background-custom-color']: mark.attrs.color
            }
        ];
    }
});

});
parcelRegister("c9aa1", function(module, exports) {

$parcel$export(module.exports, "colorPalette", () => $8d7e34fd69d04bb8$export$569885e57444f84a);
$parcel$export(module.exports, "getGlobalTheme", () => $8d7e34fd69d04bb8$export$813ecdf77207a053);
$parcel$export(module.exports, "textColor", () => $8d7e34fd69d04bb8$export$32f78bffcd82ff28);

var $2fTAU = parcelRequire("2fTAU");

var $daes7 = parcelRequire("daes7");

var $51H8P = parcelRequire("51H8P");

var $87j2U = parcelRequire("87j2U");
/**
 * @name textColor_mark
 */ // used for extended palette in text color picker
const $8d7e34fd69d04bb8$var$colorArrayPalette = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [
        (0, $51H8P.B500),
        'Dark blue'
    ],
    // Chore coat
    [
        (0, $51H8P.T500),
        'Dark teal'
    ],
    // Shabby chic
    [
        (0, $51H8P.G500),
        'Dark green'
    ],
    // Keen green
    [
        (0, $51H8P.Y400),
        'Orange'
    ],
    // Cheezy blasters
    [
        (0, $51H8P.R500),
        'Dark red'
    ],
    // Dragon's blood
    [
        (0, $51H8P.P500),
        'Dark purple'
    ],
    // Prince
    // row 2
    [
        (0, $51H8P.N80),
        'Light gray'
    ],
    // Spooky ghost
    [
        (0, $51H8P.B100),
        'Blue'
    ],
    // Arvo breeze
    [
        (0, $51H8P.T300),
        'Teal'
    ],
    // Tamarama
    [
        (0, $51H8P.G300),
        'Green'
    ],
    // Fine pine
    [
        (0, $51H8P.Y200),
        'Yellow'
    ],
    // Pub mix
    [
        (0, $51H8P.R300),
        'Red'
    ],
    // Poppy surprise
    [
        (0, $51H8P.P300),
        'Purple'
    ],
    // Da' juice
    // row 3
    [
        (0, $51H8P.N0),
        'White'
    ],
    [
        (0, $51H8P.B75),
        'Light blue'
    ],
    // Schwag
    [
        (0, $51H8P.T75),
        'Light teal'
    ],
    // Arctic chill
    [
        (0, $51H8P.G75),
        'Light green'
    ],
    // Mintie
    [
        (0, $51H8P.Y75),
        'Light yellow'
    ],
    // Dandelion whisper
    [
        (0, $51H8P.R75),
        'Light red'
    ],
    // Bondi sunburn
    [
        (0, $51H8P.P50),
        'Light purple'
    ] // Lavender secret
];
const $8d7e34fd69d04bb8$export$569885e57444f84a = new Map();
const $8d7e34fd69d04bb8$export$81e5ed9e84fe2e28 = $8d7e34fd69d04bb8$export$569885e57444f84a;
$8d7e34fd69d04bb8$var$colorArrayPalette.forEach(([color, label])=>$8d7e34fd69d04bb8$export$569885e57444f84a.set(color.toLowerCase(), label));
// these are for test only
let $8d7e34fd69d04bb8$var$testGlobalTheme;
const $8d7e34fd69d04bb8$export$fd7e0dd2b74807f7 = (theme)=>{
    $8d7e34fd69d04bb8$var$testGlobalTheme = theme;
};
const $8d7e34fd69d04bb8$export$813ecdf77207a053 = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($8d7e34fd69d04bb8$var$testGlobalTheme) return {
        colorMode: $8d7e34fd69d04bb8$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
const $8d7e34fd69d04bb8$export$32f78bffcd82ff28 = (0, $2fTAU.textColor)({
    parseDOM: [
        {
            style: 'color',
            getAttrs: (maybeValue)=>{
                const value = maybeValue;
                let hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $51H8P.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $8d7e34fd69d04bb8$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This was initially introduced to ensure text-color marks were not lost
        // when text-color was used inside a link, and is now also used to support
        // where the hex color stored in ADF is used as an ID for a design system
        // token (and based on theme mode -- the presented color will change).
        {
            tag: '.fabric-text-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.textCustomColor;
                return hexColor && $8d7e34fd69d04bb8$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        /**
     * The Editor persists custom text colors when content has been migrated from the old editor, or created via
     * apis.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $daes7.hexToEditorTextPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ($8d7e34fd69d04bb8$export$813ecdf77207a053().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $87j2U.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-text-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-text-custom-color']: mark.attrs.color
            }
        ];
    }
});

});


parcelRegister("14Vqw", function(module, exports) {

$parcel$export(module.exports, "borderColorPalette", () => $0c92b5eb9dbe9377$export$e4e044c989c86ca7);
$parcel$export(module.exports, "border", () => $0c92b5eb9dbe9377$export$1edee58a52776cd9);

var $2fTAU = parcelRequire("2fTAU");

var $daes7 = parcelRequire("daes7");

var $51H8P = parcelRequire("51H8P");
/**
 * @name border_mark
 * @description This mark adds decoration to an element, and any element decorated with it will also have a border style.
 */ const $0c92b5eb9dbe9377$var$borderColorArrayPalette = [
    [
        (0, $51H8P.N300A),
        'Subtle gray'
    ],
    [
        (0, $51H8P.N600),
        'Gray'
    ],
    [
        (0, $51H8P.N1000),
        'Bold gray'
    ]
];
const $0c92b5eb9dbe9377$export$e4e044c989c86ca7 = new Map();
$0c92b5eb9dbe9377$var$borderColorArrayPalette.forEach(([color, label])=>$0c92b5eb9dbe9377$export$e4e044c989c86ca7.set(color.toLowerCase(), label));
const $0c92b5eb9dbe9377$export$1edee58a52776cd9 = (0, $2fTAU.border)({
    parseDOM: [
        {
            tag: '[data-mark-type="border"]',
            getAttrs: (domNode)=>{
                var _dom$getAttribute, _dom$getAttribute2;
                const dom = domNode;
                const color = ((_dom$getAttribute = dom.getAttribute('data-color')) !== null && _dom$getAttribute !== void 0 ? _dom$getAttribute : '').toLowerCase();
                const size = +((_dom$getAttribute2 = dom.getAttribute('data-size')) !== null && _dom$getAttribute2 !== void 0 ? _dom$getAttribute2 : '0');
                return {
                    size: size > 3 ? 3 : size < 1 ? false : size,
                    color: $0c92b5eb9dbe9377$export$e4e044c989c86ca7.has(color) ? color : false
                };
            }
        }
    ],
    toDOM (mark, isInline) {
        const wrapperStyle = isInline ? 'span' : 'div';
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        const paletteColorValue = (0, $daes7.hexToEditorBorderPaletteColor)(mark.attrs.color) || mark.attrs.color;
        return [
            wrapperStyle,
            {
                'data-mark-type': 'border',
                'data-color': mark.attrs.color,
                'data-size': mark.attrs.size,
                style: `--custom-palette-color: ${paletteColorValue}`
            }
        ];
    }
});

});

parcelRegister("zceQE", function(module, exports) {

$parcel$export(module.exports, "breakout", () => $069cc34ec2ef025e$export$89015c65f1c75e3f);

var $2fTAU = parcelRequire("2fTAU");
const $069cc34ec2ef025e$var$allowedTypes = [
    'wide',
    'full-width'
];
const $069cc34ec2ef025e$export$89015c65f1c75e3f = (0, $2fTAU.breakout)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-breakout-mark',
            getAttrs (dom) {
                const mode = dom.getAttribute('data-mode');
                const width = dom.getAttribute('data-width');
                return {
                    mode: $069cc34ec2ef025e$var$allowedTypes.indexOf(mode || '') === -1 ? 'wide' : mode,
                    width: width ? parseInt(width) : null
                };
            }
        }
    ],
    toDOM (mark) {
        var _mark$attrs;
        return [
            'div',
            {
                class: 'fabric-editor-breakout-mark',
                'data-mode': mark.attrs.mode,
                'data-width': (_mark$attrs = mark.attrs) === null || _mark$attrs === void 0 ? void 0 : _mark$attrs.width
            },
            0
        ];
    }
});

});

parcelRegister("lcXoV", function(module, exports) {

$parcel$export(module.exports, "code", () => $f708cbc93f02b120$export$6565f9f03506010b);

var $2fTAU = parcelRequire("2fTAU");
const $f708cbc93f02b120$export$6565f9f03506010b = (0, $2fTAU.code)({
    parseDOM: [
        {
            tag: 'span.code',
            preserveWhitespace: true
        },
        {
            tag: 'code',
            preserveWhitespace: true
        },
        {
            tag: 'tt',
            preserveWhitespace: true
        },
        {
            tag: 'span',
            preserveWhitespace: true,
            getAttrs: (domNode)=>{
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre') return {};
                if (dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') >= 0) return {};
                return false;
            }
        }
    ],
    toDOM () {
        return [
            'span',
            {
                class: 'code',
                spellcheck: 'false'
            }
        ];
    }
});

});

parcelRegister("71k4W", function(module, exports) {

$parcel$export(module.exports, "confluenceInlineComment", () => $51c833981031ae17$export$f3b72f8fc4684ecd);

var $2fTAU = parcelRequire("2fTAU");
const $51c833981031ae17$export$f3b72f8fc4684ecd = (0, $2fTAU.confluenceInlineComment)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="confluenceInlineComment"]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-mark-type': 'confluenceInlineComment',
                'data-reference': node.attrs.reference
            }
        ];
    }
});

});

parcelRegister("cUwVZ", function(module, exports) {

$parcel$export(module.exports, "dataConsumer", () => $966443126bdc8969$export$3024f02c495408d6);
$parcel$export(module.exports, "toJSON", () => $966443126bdc8969$export$54fd2c36b5cc6731);

var $2fTAU = parcelRequire("2fTAU");

var $6VXbJ = parcelRequire("6VXbJ");
/**
 * This annotation is purely for reference, & does _nothing_ given annotating
 * `minLength` on an array of strings is not supported with our schema+spec
 * generator.
 *
 * We're keeping it to signal that data consumer `sources` shouldn't be empty
 * strings
 *
 * // @minLength 1
 */ /**
 * @name dataConsumer_mark
 * @description This mark is used for metadata surrounding a node consuming data
 * from a given source node
 */ const $966443126bdc8969$var$parseDataConsumer = (maybeValue)=>{
    const sources = (0, $6VXbJ.isDOMElement)(maybeValue) && maybeValue.getAttribute('data-sources');
    try {
        return sources ? {
            sources: JSON.parse(sources)
        } : false;
    } catch  {
        return false;
    }
};
const $966443126bdc8969$export$3024f02c495408d6 = (0, $2fTAU.dataConsumer)({
    parseDOM: [
        {
            tag: '[data-mark-type="dataConsumer"]',
            getAttrs: (maybeValue)=>$966443126bdc8969$var$parseDataConsumer(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'dataConsumer',
                'data-sources': JSON.stringify(mark.attrs.sources)
            }
        ];
    }
});
const $966443126bdc8969$export$54fd2c36b5cc6731 = (mark)=>{
    // // Remove intemediary state if we don't have any sources on data consumer
    // if (mark.attrs?.sources?.length < 1) {
    //   return null;
    // }
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).filter((key)=>key === 'sources' && mark.attrs[key].length > 0 && mark.attrs[key] !== null).reduce((acc, key)=>{
            return {
                ...acc,
                [key]: mark.attrs[key]
            };
        }, {})
    };
};

});
parcelRegister("6VXbJ", function(module, exports) {

$parcel$export(module.exports, "isDOMElement", () => $50c5fa8010b73128$export$c296e2d4365c37a5);
const $50c5fa8010b73128$export$c296e2d4365c37a5 = (maybeNode)=>maybeNode instanceof Node && maybeNode.nodeType === Node.ELEMENT_NODE;

});


parcelRegister("l3Tmi", function(module, exports) {

$parcel$export(module.exports, "em", () => $f554d1dac524ac83$export$c63c6f932822f543);

var $2fTAU = parcelRequire("2fTAU");
/**
 * @name em_mark
 */ const $f554d1dac524ac83$var$emDOM = [
    'em'
];
const $f554d1dac524ac83$export$c63c6f932822f543 = (0, $2fTAU.em)({
    parseDOM: [
        {
            tag: 'i'
        },
        {
            tag: 'em'
        },
        {
            style: 'font-style=italic'
        }
    ],
    toDOM () {
        return $f554d1dac524ac83$var$emDOM;
    }
});

});

parcelRegister("29Vii", function(module, exports) {

$parcel$export(module.exports, "fragment", () => $1928dd6d160b68a9$export$f00aeb236b6f05af);
$parcel$export(module.exports, "toJSON", () => $1928dd6d160b68a9$export$54fd2c36b5cc6731);

var $2fTAU = parcelRequire("2fTAU");

var $6VXbJ = parcelRequire("6VXbJ");
/**
 * @name fragment_mark
 * @description Indicates that the elements decorated with this mark belong to a "fragment" entity, which represents a collection of ADF nodes.
 * This entity can be referred to later by its `localId` attribute.
 */ const $1928dd6d160b68a9$var$parseFragment = (maybeValue)=>{
    var _maybeValue$getAttrib;
    if (!(0, $6VXbJ.isDOMElement)(maybeValue)) return false;
    const name = (_maybeValue$getAttrib = maybeValue.getAttribute('data-name')) !== null && _maybeValue$getAttrib !== void 0 ? _maybeValue$getAttrib : undefined;
    const localId = maybeValue.getAttribute('data-localId');
    if (!localId) return false;
    return {
        localId: localId,
        name: name
    };
};
const $1928dd6d160b68a9$export$f00aeb236b6f05af = (0, $2fTAU.fragment)({
    parseDOM: [
        {
            tag: '[data-mark-type="fragment"]',
            getAttrs: (maybeValue)=>$1928dd6d160b68a9$var$parseFragment(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'fragment',
                'data-name': mark.attrs.name,
                'data-localId': mark.attrs.localId
            }
        ];
    }
});
const $1928dd6d160b68a9$export$54fd2c36b5cc6731 = (mark)=>{
    return {
        type: mark.type.name,
        attrs: {
            localId: mark.attrs.localId,
            ...mark.attrs.name ? {
                name: mark.attrs.name
            } : {}
        }
    };
};

});

parcelRegister("fK6mK", function(module, exports) {

$parcel$export(module.exports, "indentation", () => $b760170dcfe13435$export$480c699bd4ec0d86);

var $2fTAU = parcelRequire("2fTAU");
const $b760170dcfe13435$export$480c699bd4ec0d86 = (0, $2fTAU.indentation)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-indentation-mark',
            getAttrs (dom) {
                const level = +(dom.getAttribute('data-level') || '0');
                return {
                    level: level > 6 ? 6 : level < 1 ? false : level
                };
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: 'fabric-editor-block-mark fabric-editor-indentation-mark',
                'data-level': mark.attrs.level
            },
            0
        ];
    }
});

});

parcelRegister("8XeG6", function(module, exports) {

$parcel$export(module.exports, "link", () => $684f383282dda449$export$9c30223ca0a664fb);
$parcel$export(module.exports, "toJSON", () => $684f383282dda449$export$54fd2c36b5cc6731);

var $2fTAU = parcelRequire("2fTAU");

var $iZOJ9 = parcelRequire("iZOJ9");
const $684f383282dda449$export$b5f67017585d1431 = (attribute)=>(domNode)=>{
        const dom = domNode;
        const href = dom.getAttribute(attribute) || '';
        const attrs = {
            __confluenceMetadata: dom.hasAttribute('__confluenceMetadata') ? JSON.parse(dom.getAttribute('__confluenceMetadata') || '') : undefined
        };
        if (!(0, $iZOJ9.isSafeUrl)(href)) return false;
        if ((0, $iZOJ9.isRootRelative)(href)) {
            attrs.href = href;
            return attrs;
        }
        attrs.href = (0, $iZOJ9.normalizeUrl)(href);
        return attrs;
    };
const $684f383282dda449$export$9c30223ca0a664fb = (0, $2fTAU.link)({
    parseDOM: [
        {
            tag: '[data-block-link]',
            getAttrs: $684f383282dda449$export$b5f67017585d1431('data-block-link'),
            contentElement: (node)=>{
                const clone = node.cloneNode(true);
                clone.removeAttribute('data-block-link');
                clone.setAttribute('data-skip-paste', 'true');
                const wrapper = document.createElement('div');
                wrapper.appendChild(clone);
                return wrapper;
            }
        },
        {
            tag: 'a[href]',
            getAttrs: $684f383282dda449$export$b5f67017585d1431('href')
        }
    ],
    toDOM (node, isInline) {
        const attrs = Object.keys(node.attrs).reduce((attrs, key)=>{
            if (key === '__confluenceMetadata') {
                if (node.attrs[key] !== null) attrs[key] = JSON.stringify(node.attrs[key]);
            } else if (key === 'href') attrs[key] = (0, $iZOJ9.isSafeUrl)(node.attrs[key]) ? node.attrs[key] : undefined;
            else attrs[key] = node.attrs[key];
            return attrs;
        }, {});
        if (isInline) return [
            'a',
            attrs
        ];
        return [
            'a',
            {
                ...attrs,
                ['data-block-link']: 'true',
                class: 'blockLink'
            },
            0
        ];
    }
});
const $684f383282dda449$var$OPTIONAL_ATTRS = [
    'title',
    'id',
    'collection',
    'occurrenceKey',
    '__confluenceMetadata'
];
const $684f383282dda449$export$54fd2c36b5cc6731 = (mark)=>({
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).reduce((attrs, key)=>{
            if ($684f383282dda449$var$OPTIONAL_ATTRS.indexOf(key) === -1 || mark.attrs[key] !== null) attrs[key] = mark.attrs[key];
            return attrs;
        }, {})
    });

});
parcelRegister("iZOJ9", function(module, exports) {

$parcel$export(module.exports, "isSafeUrl", () => $dd4545da25e52dce$export$c9f92f5469372e0f);
$parcel$export(module.exports, "linkify", () => $dd4545da25e52dce$export$8ccbde94d5c7f8e7);
$parcel$export(module.exports, "linkifyMatch", () => $dd4545da25e52dce$export$6f7d7761b97f967);
$parcel$export(module.exports, "getLinkMatch", () => $dd4545da25e52dce$export$ce9ae45aed3e4ec);
$parcel$export(module.exports, "normalizeUrl", () => $dd4545da25e52dce$export$6535eb414fa2c8b6);
$parcel$export(module.exports, "isRootRelative", () => $dd4545da25e52dce$export$23579274a7a24f7b);
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $i6xkD = parcelRequire("i6xkD");
const $dd4545da25e52dce$var$whitelistedURLPatterns = [
    /^https?:\/\//im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\//im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:/im,
    /^facetime:/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    // This is not a valid sourcetree link, but we support this pattern for backwards compatibility
    /^sourcetree:/im,
    /^sourcetree:\/\//im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^#/im
];
const $dd4545da25e52dce$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url.trim();
    if (urlTrimmed.length === 0) return true;
    return $dd4545da25e52dce$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
const $dd4545da25e52dce$export$8ccbde94d5c7f8e7 = (0, (/*@__PURE__*/$parcel$interopDefault($i6xkD)))();
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('sourcetree:', 'http:');
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('jamfselfservice:', 'http:');
const $dd4545da25e52dce$var$urlWithoutSpacesValidator = {
    validate: /[^\s]+/
};
// `tel:` URI spec is https://datatracker.ietf.org/doc/html/rfc3966
// We're not validating the phone number or separators - but if there's a space it definitely isn't a valid `tel:` URI
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('tel:', $dd4545da25e52dce$var$urlWithoutSpacesValidator);
// https://datatracker.ietf.org/doc/html/rfc8089
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('file:', $dd4545da25e52dce$var$urlWithoutSpacesValidator);
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('notes:', 'http:');
const $dd4545da25e52dce$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $dd4545da25e52dce$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$dd4545da25e52dce$var$tlds.push($dd4545da25e52dce$var$tlds2Char);
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.tlds($dd4545da25e52dce$var$tlds, false);
const $dd4545da25e52dce$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
const $dd4545da25e52dce$export$6f7d7761b97f967 = (text)=>{
    if (!$dd4545da25e52dce$export$746d02eae03c72e1.test(text)) return [];
    const matches = [];
    let startpos = 0;
    let substr;
    while(substr = text.substr(startpos)){
        const link = (substr.match($dd4545da25e52dce$export$746d02eae03c72e1) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($dd4545da25e52dce$export$746d02eae03c72e1);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
function $dd4545da25e52dce$export$ce9ae45aed3e4ec(str) {
    if (!str) return null;
    // linkify-it mishandles closing braces on long urls, so we preference using our own regex first:
    // https://product-fabric.atlassian.net/browse/ED-13669
    let match = $dd4545da25e52dce$export$6f7d7761b97f967(str);
    if (!match.length) match = $dd4545da25e52dce$export$8ccbde94d5c7f8e7.match(str);
    return match && match[0];
}
function $dd4545da25e52dce$export$6535eb414fa2c8b6(url) {
    const match = $dd4545da25e52dce$export$ce9ae45aed3e4ec(url);
    return match && match.url || '';
}
function $dd4545da25e52dce$export$23579274a7a24f7b(url) {
    // Support `#top` and `#` special references as per:
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#linking_to_an_element_on_the_same_page
    return url.startsWith('/') || url === '#top' || url === '#';
}

});
parcelRegister("i6xkD", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $d2e2a485107d561a$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $d2e2a485107d561a$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $d2e2a485107d561a$var$isString(obj) {
    return $d2e2a485107d561a$var$_class(obj) === '[object String]';
}
function $d2e2a485107d561a$var$isObject(obj) {
    return $d2e2a485107d561a$var$_class(obj) === '[object Object]';
}
function $d2e2a485107d561a$var$isRegExp(obj) {
    return $d2e2a485107d561a$var$_class(obj) === '[object RegExp]';
}
function $d2e2a485107d561a$var$isFunction(obj) {
    return $d2e2a485107d561a$var$_class(obj) === '[object Function]';
}
function $d2e2a485107d561a$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $d2e2a485107d561a$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $d2e2a485107d561a$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $d2e2a485107d561a$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $d2e2a485107d561a$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $d2e2a485107d561a$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $d2e2a485107d561a$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $d2e2a485107d561a$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $d2e2a485107d561a$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $d2e2a485107d561a$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $d2e2a485107d561a$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("9mKTr"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($d2e2a485107d561a$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($d2e2a485107d561a$var$isObject(val)) {
            if ($d2e2a485107d561a$var$isRegExp(val.validate)) compiled.validate = $d2e2a485107d561a$var$createValidator(val.validate);
            else if ($d2e2a485107d561a$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($d2e2a485107d561a$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $d2e2a485107d561a$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($d2e2a485107d561a$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $d2e2a485107d561a$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($d2e2a485107d561a$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|' + '(' + self.re.host_fuzzy_test.source + ')|' + '@', 'i');
    //
    // Cleanup
    //
    $d2e2a485107d561a$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $d2e2a485107d561a$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $d2e2a485107d561a$var$createMatch(self, shift) {
    var match = new $d2e2a485107d561a$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $d2e2a485107d561a$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $d2e2a485107d561a$var$LinkifyIt)) return new $d2e2a485107d561a$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($d2e2a485107d561a$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $d2e2a485107d561a$var$assign({}, $d2e2a485107d561a$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $d2e2a485107d561a$var$assign({}, $d2e2a485107d561a$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $d2e2a485107d561a$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $d2e2a485107d561a$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $d2e2a485107d561a$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $d2e2a485107d561a$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($d2e2a485107d561a$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($d2e2a485107d561a$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $d2e2a485107d561a$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $d2e2a485107d561a$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $d2e2a485107d561a$var$LinkifyIt;

});
parcelRegister("9mKTr", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("b9ep3")).source;
    re.src_Cc = (parcelRequire("23ErL")).source;
    re.src_Z = (parcelRequire("oRY4m")).source;
    re.src_P = (parcelRequire("9bBmm")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,3}[a-zA-Z0-9%/]|' + // github has ... in commit range links. Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + '\\,(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    '\\!(?!' + re.src_ZCc + '|[!]).|' + '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    re.src_email_name = '[\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]+';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + // don't allow `--` in domain names, because:
    // - that can conflict with markdown &mdash; / &ndash;
    // - nobody use those anyway
    '(?:' + re.src_pseudo_letter + '(?:-(?!-)|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|\\(|' + re.src_ZCc + ')(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});
parcelRegister("b9ep3", function(module, exports) {
module.exports = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRegister("23ErL", function(module, exports) {
module.exports = /[\0-\x1F\x7F-\x9F]/;

});

parcelRegister("oRY4m", function(module, exports) {
module.exports = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;

});

parcelRegister("9bBmm", function(module, exports) {
module.exports = /[!-#%-\*,-/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E49\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});





parcelRegister("aUhe2", function(module, exports) {

$parcel$export(module.exports, "strike", () => $7f0c7ef7d4ef76e7$export$4899a95d70ec5056);

var $2fTAU = parcelRequire("2fTAU");
const $7f0c7ef7d4ef76e7$export$4899a95d70ec5056 = (0, $2fTAU.strike)({
    parseDOM: [
        {
            tag: 'strike'
        },
        {
            tag: 's'
        },
        {
            tag: 'del'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'line-through' && null
        }
    ],
    toDOM () {
        return [
            's'
        ];
    }
});

});

parcelRegister("hhtT8", function(module, exports) {

$parcel$export(module.exports, "strong", () => $c94b3560d4129743$export$59ae2c325a998f89);

var $2fTAU = parcelRequire("2fTAU");
/**
 * @name strong_mark
 */ const $c94b3560d4129743$var$strongDOM = [
    'strong'
];
const $c94b3560d4129743$export$59ae2c325a998f89 = (0, $2fTAU.strong)({
    parseDOM: [
        {
            tag: 'strong'
        },
        // This works around a Google Docs misbehavior where
        // pasted content will be inexplicably wrapped in `<b>`
        // tags with a font-weight normal.
        {
            tag: 'b',
            getAttrs (node) {
                const element = node;
                return element.style.fontWeight !== 'normal' && null;
            }
        },
        {
            tag: 'span',
            getAttrs (node) {
                const element = node;
                const { fontWeight: fontWeight } = element.style;
                return typeof fontWeight === 'string' && (fontWeight === 'bold' || fontWeight === 'bolder' || /^(bold(er)?|[5-9]\d{2,})$/.test(fontWeight)) && null;
            }
        }
    ],
    toDOM () {
        return $c94b3560d4129743$var$strongDOM;
    }
});

});

parcelRegister("4NwJJ", function(module, exports) {

$parcel$export(module.exports, "subsup", () => $37e521d9accf6615$export$b3401ee80eb31041);

var $2fTAU = parcelRequire("2fTAU");
/**
 * @name subsup_mark
 */ function $37e521d9accf6615$var$getAttrFromVerticalAlign(node) {
    if (node === 'sub') return {
        type: 'sub'
    };
    if (node === 'super') return {
        type: 'sup'
    };
    return false;
}
const $37e521d9accf6615$export$b3401ee80eb31041 = (0, $2fTAU.subsup)({
    parseDOM: [
        {
            tag: 'sub',
            attrs: {
                type: 'sub'
            }
        },
        {
            tag: 'sup',
            attrs: {
                type: 'sup'
            }
        },
        {
            // Special case for pasting from Google Docs
            // Google Docs uses vertical align to denote subscript and super script
            style: 'vertical-align=super',
            getAttrs: (node)=>$37e521d9accf6615$var$getAttrFromVerticalAlign(node)
        },
        {
            style: 'vertical-align=sub',
            getAttrs: (node)=>$37e521d9accf6615$var$getAttrFromVerticalAlign(node)
        }
    ],
    toDOM (mark) {
        return [
            mark.attrs.type
        ];
    }
});

});

parcelRegister("dtyqo", function(module, exports) {

$parcel$export(module.exports, "typeAheadQuery", () => $9cf8afcff83743a0$export$20af3dabbb5538df);

var $2fTAU = parcelRequire("2fTAU");

var $51H8P = parcelRequire("51H8P");
const $9cf8afcff83743a0$export$20af3dabbb5538df = (0, $2fTAU.typeAheadQuery)({
    parseDOM: [
        {
            tag: 'span[data-type-ahead-query]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-type-ahead-query': 'true',
                'data-trigger': node.attrs.trigger,
                style: `color: ${(0, $51H8P.B400)}`
            }
        ];
    }
});

});

parcelRegister("8EAPB", function(module, exports) {

$parcel$export(module.exports, "underline", () => $64cea1116bb0e8f8$export$425327af25286e5e);

var $2fTAU = parcelRequire("2fTAU");
const $64cea1116bb0e8f8$export$425327af25286e5e = (0, $2fTAU.underline)({
    parseDOM: [
        {
            tag: 'u'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'underline' && null
        }
    ],
    toDOM () {
        return [
            'u'
        ];
    }
});

});

parcelRegister("jxVez", function(module, exports) {

$parcel$export(module.exports, "unsupportedMark", () => $e3ad7edb6364f3b2$export$30d78d5eb6719bb8);

var $2fTAU = parcelRequire("2fTAU");
const $e3ad7edb6364f3b2$export$30d78d5eb6719bb8 = (0, $2fTAU.unsupportedMark)({
    toDOM () {
        return [
            'span'
        ];
    }
});

});

parcelRegister("lVmBd", function(module, exports) {

$parcel$export(module.exports, "unsupportedNodeAttribute", () => $ff60739479aa7be3$export$a316dc07ff5182a2);

var $2fTAU = parcelRequire("2fTAU");
const $ff60739479aa7be3$export$a316dc07ff5182a2 = (0, $2fTAU.unsupportedNodeAttribute)({
    toDOM () {
        return [
            'span'
        ];
    }
});

});

parcelRegister("21PS7", function(module, exports) {

$parcel$export(module.exports, "blockCard", () => $17a3e9738ed289c7$export$c4c2f833baaebdb8);

var $gthjq = parcelRequire("gthjq");
/**
 * @name blockCard_node
 */ const $17a3e9738ed289c7$var$getCommonAttributesFromDom = (dom)=>{
    const anchor = dom;
    const data = anchor.getAttribute('data-card-data');
    const datasource = anchor.getAttribute('data-datasource');
    return {
        data: data ? JSON.parse(data) : undefined,
        layout: datasource ? dom.getAttribute('data-layout') || undefined : undefined,
        width: Number(dom.getAttribute('data-width')) || undefined,
        datasource: datasource ? JSON.parse(datasource) : undefined
    };
};
const $17a3e9738ed289c7$export$c4c2f833baaebdb8 = (0, $gthjq.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('href') || undefined,
                    ...$17a3e9738ed289c7$var$getCommonAttributesFromDom(dom)
                };
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('data-card-url') || undefined,
                    ...$17a3e9738ed289c7$var$getCommonAttributesFromDom(dom)
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const { url: url } = node.attrs;
        const { data: data } = node.attrs;
        const { layout: layout, width: width, datasource: datasource } = node.attrs;
        const attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': `${width}`
        };
        return [
            'a',
            attrs,
            (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.url) || ' '
        ];
    }
});

});

parcelRegister("5AxYU", function(module, exports) {

$parcel$export(module.exports, "bodiedExtension", () => $411aac89e34c8741$export$27903d543b563e39);

var $CWpyq = parcelRequire("CWpyq");

var $gthjq = parcelRequire("gthjq");
const $411aac89e34c8741$export$27903d543b563e39 = (0, $gthjq.bodiedExtension)({
    parseDOM: [
        {
            context: 'bodiedExtension//',
            tag: '[data-node-type="bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="bodied-extension"]',
            getAttrs: (domNode)=>(0, $CWpyq.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("kjhhp", function(module, exports) {

$parcel$export(module.exports, "bulletListSelector", () => $ec92fc66e86ee824$export$5f25a39efab3b58b);
$parcel$export(module.exports, "bulletList", () => $ec92fc66e86ee824$export$a140c94e5ea26bee);

var $gthjq = parcelRequire("gthjq");
const $ec92fc66e86ee824$export$5f25a39efab3b58b = '.ak-ul';
const $ec92fc66e86ee824$export$a140c94e5ea26bee = (0, $gthjq.bulletList)({
    parseDOM: [
        {
            tag: 'ul'
        }
    ],
    toDOM () {
        const attrs = {
            class: $ec92fc66e86ee824$export$5f25a39efab3b58b.substr(1)
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});

});

parcelRegister("5JeV5", function(module, exports) {

$parcel$export(module.exports, "caption", () => $42bcba7b958fdfd3$export$8e3c2dfdc4f0453d);

var $gthjq = parcelRequire("gthjq");
const $42bcba7b958fdfd3$export$8e3c2dfdc4f0453d = (0, $gthjq.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-caption': 'true'
        };
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});

});

parcelRegister("8vlrc", function(module, exports) {

$parcel$export(module.exports, "codeBlock", () => $6311d90c8f0b12c7$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "toJSON", () => $6311d90c8f0b12c7$export$54fd2c36b5cc6731);

var $kCV8T = parcelRequire("kCV8T");

var $gthjq = parcelRequire("gthjq");
/**
 * @name codeBlock_with_no_marks_node
 */ /**
 * @name codeBlock_node
 */ const $6311d90c8f0b12c7$var$getLanguageFromEditorStyle = (dom)=>{
    return dom.getAttribute('data-language') || undefined;
};
// example of BB style:
// <div class="codehilite language-javascript"><pre><span>hello world</span><span>\n</span></pre></div>
const $6311d90c8f0b12c7$var$getLanguageFromBitbucketStyle = (dom)=>{
    if (dom && dom.classList.contains('codehilite')) // code block html from Bitbucket always contains an extra new line
    return $6311d90c8f0b12c7$var$extractLanguageFromClass(dom.className);
    return;
};
// If there is a child code element, check that for data-language
const $6311d90c8f0b12c7$var$getLanguageFromCode = (dom)=>{
    const firstChild = dom.firstElementChild;
    if (firstChild && firstChild.nodeName === 'CODE') return firstChild.getAttribute('data-language') || undefined;
};
const $6311d90c8f0b12c7$var$extractLanguageFromClass = (className)=>{
    const languageRegex = /(?:^|\s)language-([^\s]+)/;
    const result = languageRegex.exec(className);
    if (result && result[1]) return result[1];
    return;
};
const $6311d90c8f0b12c7$var$removeLastNewLine = (dom)=>{
    const parent = dom && dom.parentElement;
    if (parent && parent.classList.contains('codehilite')) dom.textContent = dom.textContent.replace(/\n$/, '');
    return dom;
};
function $6311d90c8f0b12c7$var$parseCodeFromHtml(node) {
    let code = '';
    node.childNodes.forEach((child)=>{
        if (child.nodeType === Node.TEXT_NODE) // append text
        code += child.nodeValue;
        else if (child.nodeType === Node.ELEMENT_NODE && child instanceof Element) {
            const tagName = child.tagName.toLowerCase();
            if (tagName === 'div' || tagName === 'p') // add a newline before its content, unless it's the first child to avoid leading newlines
            {
                if (child.previousElementSibling !== null) code += '\n';
            }
            if (tagName === 'br') code += '\n';
            else code += $6311d90c8f0b12c7$var$parseCodeFromHtml(child);
        }
    });
    return code;
}
const $6311d90c8f0b12c7$export$7bb0d5c671655cc4 = (0, $gthjq.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                let dom = domNode;
                const language = $6311d90c8f0b12c7$var$getLanguageFromBitbucketStyle(dom.parentElement) || $6311d90c8f0b12c7$var$getLanguageFromEditorStyle(dom.parentElement) || $6311d90c8f0b12c7$var$getLanguageFromCode(dom) || dom.getAttribute('data-language');
                dom = $6311d90c8f0b12c7$var$removeLastNewLine(dom);
                return {
                    language: language
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                return false;
            },
            getContent: (domNode, schema)=>{
                const code = $6311d90c8f0b12c7$var$parseCodeFromHtml(domNode);
                return code ? (0, $kCV8T.Fragment).from(schema.text(code)) : (0, $kCV8T.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: (dom)=>{
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                const dom = domNode;
                // TODO: ED-5604 Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                const lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach((line)=>line.remove());
                return {};
            }
        }
    ],
    toDOM (node) {
        return [
            'pre',
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});
const $6311d90c8f0b12c7$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((memo, key)=>{
            if (key === 'uniqueId') return memo;
            if (key === 'language' && node.attrs.language === null) return memo;
            memo[key] = node.attrs[key];
            return memo;
        }, {})
    });

});

parcelRegister("6bbHe", function(module, exports) {

$parcel$export(module.exports, "confluenceJiraIssue", () => $47fcd7cf328a46ad$export$daf889beb5092f95);

var $gthjq = parcelRequire("gthjq");
const $47fcd7cf328a46ad$var$name = 'confluenceJiraIssue';
const $47fcd7cf328a46ad$export$daf889beb5092f95 = (0, $gthjq.confluenceJiraIssue)({
    parseDOM: [
        {
            tag: `span[data-node-type="${$47fcd7cf328a46ad$var$name}"]`,
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    issueKey: dom.textContent,
                    macroId: dom.dataset && dom.dataset.macroId,
                    schemaVersion: dom.dataset && dom.dataset.schemaVersion,
                    server: dom.dataset && dom.dataset.server,
                    serverId: dom.dataset && dom.dataset.serverId
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': $47fcd7cf328a46ad$var$name,
            'data-macro-id': node.attrs.macroId,
            'data-schema-version': node.attrs.schemaVersion,
            'data-server': node.attrs.server,
            'data-server-id': node.attrs.serverId,
            'data-jira-issue': node.attrs.issueKey
        };
        return [
            'span',
            attrs,
            node.attrs.issueKey
        ];
    }
});

});

parcelRegister("5y0tR", function(module, exports) {

$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $40a0802970c8dfd0$export$e6e4878f43c27cab);

var $gthjq = parcelRequire("gthjq");
const $40a0802970c8dfd0$var$name = 'confluenceUnsupportedBlock';
const $40a0802970c8dfd0$export$e6e4878f43c27cab = (0, $gthjq.confluenceUnsupportedBlock)({
    toDOM (node) {
        // NOTE: This node cannot be "contenteditable: false". If it's the only node in a document, PM throws an error because there's nowhere to put the cursor.
        const attrs = {
            'data-node-type': $40a0802970c8dfd0$var$name,
            'data-confluence-unsupported': 'block',
            'data-confluence-unsupported-block-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$40a0802970c8dfd0$var$name}"]`,
            getAttrs (dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-block-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("bd7A9", function(module, exports) {

$parcel$export(module.exports, "confluenceUnsupportedInline", () => $8296ca40a4ed2ee7$export$3e6d667072febc87);

var $gthjq = parcelRequire("gthjq");
const $8296ca40a4ed2ee7$var$name = 'confluenceUnsupportedInline';
const $8296ca40a4ed2ee7$export$3e6d667072febc87 = (0, $gthjq.confluenceUnsupportedInline)({
    toDOM (node) {
        const attrs = {
            'data-node-type': $8296ca40a4ed2ee7$var$name,
            'data-confluence-unsupported': 'inline',
            'data-confluence-unsupported-inline-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$8296ca40a4ed2ee7$var$name}"]`,
            getAttrs (dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-inline-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("b2VmY", function(module, exports) {

$parcel$export(module.exports, "date", () => $80ac620012a63cc1$export$324d90190a8b822a);

var $gthjq = parcelRequire("gthjq");
const $80ac620012a63cc1$export$324d90190a8b822a = (0, $gthjq.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: (dom)=>({
                    timestamp: dom.getAttribute('data-timestamp')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("Khvpb", function(module, exports) {

$parcel$export(module.exports, "decisionItem", () => $08b1e03a19cbdc24$export$6959e16eeff859b4);

var $9IGaJ = parcelRequire("9IGaJ");

var $gthjq = parcelRequire("gthjq");
const $08b1e03a19cbdc24$export$6959e16eeff859b4 = (0, $gthjq.decisionItem)({
    parseDOM: [
        {
            tag: 'li[data-decision-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $9IGaJ.uuid).generate(),
                    state: dom.getAttribute('data-decision-state')
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-decision-local-id': localId || 'local-decision',
            'data-decision-state': state
        };
        return [
            'li',
            attrs,
            0
        ];
    }
});

});

parcelRegister("8gSD8", function(module, exports) {

$parcel$export(module.exports, "decisionListSelector", () => $605a31c9af2a8977$export$a5393ce68c2ff601);
$parcel$export(module.exports, "decisionList", () => $605a31c9af2a8977$export$62d45a65fb43d95e);

var $9IGaJ = parcelRequire("9IGaJ");

var $gthjq = parcelRequire("gthjq");
/**
 * @name decisionList_node
 */ const $605a31c9af2a8977$var$name = 'decisionList';
const $605a31c9af2a8977$export$a5393ce68c2ff601 = `[data-node-type="${$605a31c9af2a8977$var$name}"]`;
const $605a31c9af2a8977$export$62d45a65fb43d95e = (0, $gthjq.decisionList)({
    parseDOM: [
        {
            tag: `ol${$605a31c9af2a8977$export$a5393ce68c2ff601}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $9IGaJ.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $605a31c9af2a8977$var$name,
            'data-decision-list-local-id': localId || 'local-decision-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("xjCuM", function(module, exports) {

$parcel$export(module.exports, "doc", () => $06424d48e92613a9$export$2a111da947c407d2);

var $gthjq = parcelRequire("gthjq");
const $06424d48e92613a9$export$2a111da947c407d2 = (0, $gthjq.doc)({});

});

parcelRegister("kshOv", function(module, exports) {

$parcel$export(module.exports, "embedCard", () => $ee443d93678dbe0b$export$be4283d9a1cb1ff6);

var $gthjq = parcelRequire("gthjq");
const $ee443d93678dbe0b$export$be4283d9a1cb1ff6 = (0, $gthjq.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: (dom)=>({
                    url: dom.getAttribute('data-card-url'),
                    layout: dom.getAttribute('data-layout') || 'center',
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(dom.getAttribute('data-card-original-height')) || null
                })
        }
    ],
    toDOM (node) {
        const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
        const attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("7DoMR", function(module, exports) {

$parcel$export(module.exports, "emoji", () => $58ef6723e99e5604$export$a19185d1233fc4b2);

var $4pzsz = parcelRequire("4pzsz");

var $gthjq = parcelRequire("gthjq");
const $58ef6723e99e5604$export$a19185d1233fc4b2 = (0, $gthjq.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            getAttrs: (dom)=>(0, $4pzsz.acNameToEmoji)(dom.getAttribute('data-emoticon-name'))
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            getAttrs: (dom)=>(0, $4pzsz.acShortcutToEmoji)(dom.getAttribute('data-hipchat-emoticon'))
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        }
    ],
    toDOM (node) {
        const { shortName: shortName, id: id, text: text } = node.attrs;
        const attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});
parcelRegister("4pzsz", function(module, exports) {

$parcel$export(module.exports, "acNameToEmoji", () => $336500cbd1ca0f10$export$f61e93bda2a8b420);
$parcel$export(module.exports, "acShortcutToEmoji", () => $336500cbd1ca0f10$export$441f8b58f5790a68);
$parcel$export(module.exports, "getEmojiAcName", () => $336500cbd1ca0f10$export$880a2465992fbbe);
// Default emoji id for Confluence glyphs that has no match to Fabric Emoji
const $336500cbd1ca0f10$var$DEFAULT_EMOJI_ID = '2b50';
// Default ac:name for emoticons as a fallback is `blue-star`
const $336500cbd1ca0f10$var$DEFAULT_EMOJI_ACNAME = 'blue-star';
// ac:hipchat-emoticon prefix when converting to Emoji ID
const $336500cbd1ca0f10$var$HC_EMOTICON_PREFIX = 'atlassian-';
/**
 * Confluence glyphs ac:name of <ac:emoticon /> map to new emojis
 * {
 *   [ac:name] : ['emoji-id', 'emoji-shortName', 'emoji-fallback']
 *   ...
 * }
 * Glyphs that do not map to Fabric Emoji
 * will be mapped to Emoji Id '2b50' (:star:) with preserving ac:name as shortName attribute;
 */ const $336500cbd1ca0f10$var$acNameToEmojiMap = {
    smile: [
        '1f642',
        ':slight_smile:',
        '\uD83D\uDE42'
    ],
    sad: [
        '1f641',
        ':slight_frown:',
        '\uD83D\uDE41'
    ],
    cheeky: [
        '1f61b',
        ':stuck_out_tongue:',
        '\uD83D\uDE1B'
    ],
    laugh: [
        '1f600',
        ':grinning:',
        '\uD83D\uDE00'
    ],
    wink: [
        '1f609',
        ':wink:',
        '\uD83D\uDE09'
    ],
    information: [
        '2139',
        ':information_source:',
        '\u2139'
    ],
    tick: [
        '2705',
        ':white_check_mark:',
        '\u2705'
    ],
    cross: [
        '274c',
        ':x:',
        '\u274C'
    ],
    warning: [
        '26a0',
        ':warning:',
        '\u26A0'
    ],
    plus: [
        '2795',
        ':heavy_plus_sign:',
        '\u2795'
    ],
    minus: [
        '2796',
        ':heavy_minus_sign:',
        '\u2796'
    ],
    question: [
        '2753',
        ':question:',
        '\u003F'
    ],
    'thumbs-up': [
        '1f44d',
        ':thumbsup:',
        '\uD83D\uDC4D'
    ],
    'thumbs-down': [
        '1f44e',
        ':thumbsdown:',
        '\uD83D\uDC4E'
    ],
    'light-on': [
        '1f4a1',
        ':bulb:',
        '\uD83D\uDCA1'
    ],
    'yellow-star': [
        '2b50',
        ':star:',
        '\uD83D\uDC9B'
    ],
    'light-off': [
        '1f6ab',
        ':no_entry_sign:',
        '\uD83D\uDEAB'
    ],
    'red-star': [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'green-star': [
        '1f49a',
        ':green_heart:',
        '\uD83D\uDC9A'
    ],
    'blue-star': [
        '1f499',
        ':blue_heart:',
        '\uD83D\uDC99'
    ],
    heart: [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'broken-heart': [
        '1f494',
        ':broken_heart:',
        '\uD83D\uDC94'
    ]
};
function $336500cbd1ca0f10$export$f61e93bda2a8b420(acName) {
    const emojiData = $336500cbd1ca0f10$var$acNameToEmojiMap[acName];
    return emojiData ? {
        id: emojiData[0],
        shortName: emojiData[1],
        text: emojiData[2]
    } : {
        id: $336500cbd1ca0f10$var$DEFAULT_EMOJI_ID,
        shortName: `:${acName}:`,
        text: ''
    };
}
function $336500cbd1ca0f10$export$bc94e44ec0e7bd82(emojiId) {
    const filterEmojis = (acName)=>$336500cbd1ca0f10$var$acNameToEmojiMap[acName] ? $336500cbd1ca0f10$var$acNameToEmojiMap[acName][0] === emojiId : false;
    return Object.keys($336500cbd1ca0f10$var$acNameToEmojiMap).filter(filterEmojis)[0];
}
function $336500cbd1ca0f10$export$441f8b58f5790a68(hipchatEmoticonShortName) {
    return {
        id: `${$336500cbd1ca0f10$var$HC_EMOTICON_PREFIX}${hipchatEmoticonShortName}`,
        shortName: `:${hipchatEmoticonShortName}:`,
        text: ''
    };
}
function $336500cbd1ca0f10$var$getAcNameFromShortName(shortName) {
    return shortName.slice(shortName[0] === ':' ? 1 : 0, shortName[shortName.length - 1] === ':' ? -1 : shortName.length);
}
function $336500cbd1ca0f10$export$880a2465992fbbe({ id: id, shortName: shortName }) {
    if ($336500cbd1ca0f10$var$DEFAULT_EMOJI_ID === id) {
        const possibleName = $336500cbd1ca0f10$var$getAcNameFromShortName(shortName);
        if (possibleName in $336500cbd1ca0f10$var$acNameToEmojiMap) return possibleName;
    }
    return $336500cbd1ca0f10$export$bc94e44ec0e7bd82(id) || $336500cbd1ca0f10$var$DEFAULT_EMOJI_ACNAME;
}

});


parcelRegister("aXBFx", function(module, exports) {

$parcel$export(module.exports, "blockquote", () => $7faca2534e4894a0$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockquoteWithNestedCodeblockOrMedia", () => $7faca2534e4894a0$export$c4d50234112df933);
$parcel$export(module.exports, "extendedBlockquote", () => $7faca2534e4894a0$export$70a64939da3e8455);
$parcel$export(module.exports, "blockquoteWithList", () => $7faca2534e4894a0$export$9b4686c4b9672643);
$parcel$export(module.exports, "blockquoteWithoutNonBodiedMacros", () => $7faca2534e4894a0$export$32b1dde15f5fe85b);

var $gthjq = parcelRequire("gthjq");
/**
 * @name blockquote_node
 */ const $7faca2534e4894a0$var$nodeSpecOptions = {
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM () {
        return [
            'blockquote',
            0
        ];
    }
};
const $7faca2534e4894a0$export$67dc04e652a298ca = (0, $gthjq.blockquoteLegacy)($7faca2534e4894a0$var$nodeSpecOptions);
const $7faca2534e4894a0$export$c4d50234112df933 = (0, $gthjq.blockquoteWithoutNonBodiedMacros)($7faca2534e4894a0$var$nodeSpecOptions);
const $7faca2534e4894a0$export$70a64939da3e8455 = (0, $gthjq.blockquote)($7faca2534e4894a0$var$nodeSpecOptions);
const $7faca2534e4894a0$export$9b4686c4b9672643 = (0, $gthjq.blockquoteWithoutNestedCodeblockOrMedia)({
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM () {
        return [
            'blockquote',
            0
        ];
    }
});
const $7faca2534e4894a0$export$32b1dde15f5fe85b = (0, $gthjq.blockquoteWithoutNonBodiedMacros)({
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM () {
        return [
            'blockquote',
            0
        ];
    }
});

});

parcelRegister("bFtEE", function(module, exports) {

$parcel$export(module.exports, "PanelType", () => $87ea86de426496d8$export$969277cf61e5a7aa);
$parcel$export(module.exports, "extendedPanel", () => $87ea86de426496d8$export$ce20b13564211141);
$parcel$export(module.exports, "panelWithoutNestedNonBodiedMacros", () => $87ea86de426496d8$export$220c665c23b9541b);

var $gthjq = parcelRequire("gthjq");
let $87ea86de426496d8$export$969277cf61e5a7aa = /*#__PURE__*/ function(PanelType) {
    PanelType["INFO"] = "info";
    PanelType["NOTE"] = "note";
    PanelType["TIP"] = "tip";
    PanelType["WARNING"] = "warning";
    PanelType["ERROR"] = "error";
    PanelType["SUCCESS"] = "success";
    PanelType["CUSTOM"] = "custom";
    return PanelType;
}({});
/**
 * @name panel_node
 */ const $87ea86de426496d8$var$getDomAttrs = (nodeAttrs)=>{
    const attrs = {
        'data-panel-type': nodeAttrs.panelType,
        'data-panel-icon': nodeAttrs.panelIcon,
        'data-panel-icon-id': nodeAttrs.panelIconId,
        'data-panel-icon-text': nodeAttrs.panelIconText,
        'data-panel-color': nodeAttrs.panelColor
    };
    return attrs;
};
const $87ea86de426496d8$var$getParseDOMAttrs = (allowCustomPanel, dom)=>{
    let parseDOMAttrs = {
        panelType: dom.getAttribute('data-panel-type')
    };
    if (allowCustomPanel) parseDOMAttrs = {
        ...parseDOMAttrs,
        panelIcon: dom.getAttribute('data-panel-icon'),
        panelIconId: dom.getAttribute('data-panel-icon-id'),
        panelIconText: dom.getAttribute('data-panel-icon-text'),
        panelColor: dom.getAttribute('data-panel-color')
    };
    else parseDOMAttrs.panelType = parseDOMAttrs.panelType === $87ea86de426496d8$export$969277cf61e5a7aa.CUSTOM ? $87ea86de426496d8$export$969277cf61e5a7aa.INFO : parseDOMAttrs.panelType;
    return parseDOMAttrs;
};
const $87ea86de426496d8$var$createPanelNodeSpecOptions = (allowCustomPanel)=>({
        parseDOM: [
            {
                tag: 'div[data-panel-type]',
                getAttrs: (dom)=>$87ea86de426496d8$var$getParseDOMAttrs(allowCustomPanel, dom)
            }
        ],
        toDOM (node) {
            const attrs = $87ea86de426496d8$var$getDomAttrs(node.attrs);
            const contentAttrs = {
                'data-panel-content': 'true'
            };
            return [
                'div',
                attrs,
                [
                    'div',
                    contentAttrs,
                    0
                ]
            ];
        }
    });
const $87ea86de426496d8$export$ce20b13564211141 = (allowCustomPanel)=>(0, $gthjq.panel)($87ea86de426496d8$var$createPanelNodeSpecOptions(allowCustomPanel));
const $87ea86de426496d8$export$220c665c23b9541b = (allowCustomPanel)=>(0, $gthjq.panelWithoutNestedNonBodiedMacros)($87ea86de426496d8$var$createPanelNodeSpecOptions(allowCustomPanel));

});

parcelRegister("hhN5g", function(module, exports) {

$parcel$export(module.exports, "extension", () => $c95a1940f4fa6aee$export$1b45514b112dd749);

var $CWpyq = parcelRequire("CWpyq");

var $gthjq = parcelRequire("gthjq");
const $c95a1940f4fa6aee$export$1b45514b112dd749 = (0, $gthjq.extension)({
    parseDOM: [
        {
            tag: '[data-node-type="extension"]',
            getAttrs: (domNode)=>(0, $CWpyq.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("jnMM2", function(module, exports) {

$parcel$export(module.exports, "hardBreak", () => $e1c5ffc4cc369fdc$export$371da9dd35aba193);

var $gthjq = parcelRequire("gthjq");
const $e1c5ffc4cc369fdc$export$371da9dd35aba193 = (0, $gthjq.hardBreak)({
    parseDOM: [
        {
            tag: 'br'
        }
    ],
    toDOM () {
        return [
            'br'
        ];
    }
});

});

parcelRegister("lRTZM", function(module, exports) {

$parcel$export(module.exports, "heading", () => $feb9fbb7aabe0cc7$export$46e4a324ac90507f);

var $gthjq = parcelRequire("gthjq");
/**
 * @name heading_node
 */ /**
 * @name heading_with_no_marks_node
 */ // Check `paragraph` node for why we are doing things like this
/**
 * @name heading_with_alignment_node
 */ /**
 * @name heading_with_indentation_node
 */ const $feb9fbb7aabe0cc7$var$getAttrs = (level)=>(domNode)=>{
        var _heading$attrs, _heading$attrs$localI;
        return {
            level: level,
            localId: domNode.getAttribute('data-local-id') || ((_heading$attrs = $feb9fbb7aabe0cc7$export$46e4a324ac90507f.attrs) === null || _heading$attrs === void 0 ? void 0 : (_heading$attrs$localI = _heading$attrs.localId) === null || _heading$attrs$localI === void 0 ? void 0 : _heading$attrs$localI.default)
        };
    };
const $feb9fbb7aabe0cc7$export$46e4a324ac90507f = (0, $gthjq.heading)({
    parseDOM: [
        {
            tag: 'h1',
            getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(1)
        },
        {
            tag: 'h2',
            getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(2)
        },
        {
            tag: 'h3',
            getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(3)
        },
        {
            tag: 'h4',
            getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(4)
        },
        {
            tag: 'h5',
            getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(5)
        },
        {
            tag: 'h6',
            getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(6)
        }
    ],
    toDOM (node) {
        const { level: level, localId: localId } = node.attrs;
        const name = 'h' + level;
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
});

});

parcelRegister("7lRBh", function(module, exports) {

$parcel$export(module.exports, "image", () => $55a4127c569d3934$export$5c452ff88e35e47d);

var $gthjq = parcelRequire("gthjq");
const $55a4127c569d3934$export$5c452ff88e35e47d = (0, $gthjq.image)({
    parseDOM: [
        {
            tag: 'img[src^="data:image/"]',
            ignore: true
        },
        {
            tag: 'img[src]',
            getAttrs (domNode) {
                const dom = domNode;
                return {
                    src: dom.getAttribute('src'),
                    alt: dom.getAttribute('alt'),
                    title: dom.getAttribute('title')
                };
            }
        }
    ],
    toDOM (node) {
        return [
            'img',
            node.attrs
        ];
    }
});

});

parcelRegister("cCBEe", function(module, exports) {

$parcel$export(module.exports, "inlineCard", () => $93063cb7956d3766$export$cbf8224b64e0d942);

var $gthjq = parcelRequire("gthjq");
const $93063cb7956d3766$export$cbf8224b64e0d942 = (0, $gthjq.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : ''
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});

});

parcelRegister("5BOuQ", function(module, exports) {

$parcel$export(module.exports, "inlineExtension", () => $4157940155363fee$export$16b353b2649bd8d9);

var $CWpyq = parcelRequire("CWpyq");

var $gthjq = parcelRequire("gthjq");
const $4157940155363fee$export$16b353b2649bd8d9 = (0, $gthjq.inlineExtensionWithMarks)({
    parseDOM: [
        {
            tag: 'span[data-extension-type]',
            getAttrs: (domNode)=>(0, $CWpyq.getExtensionAttrs)(domNode, true)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-local-id:': node.attrs.localId,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("4EbxI", function(module, exports) {

$parcel$export(module.exports, "layoutColumn", () => $3623d9fd8951cfd2$export$ab76e7c03cd6f650);

var $gthjq = parcelRequire("gthjq");
const $3623d9fd8951cfd2$export$ab76e7c03cd6f650 = (0, $gthjq.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    width: Number(dom.getAttribute('data-column-width')) || undefined
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-layout-column': 'true'
        };
        const { width: width } = node.attrs;
        if (width) {
            attrs['style'] = `flex-basis: ${width}%`;
            attrs['data-column-width'] = `${width}`;
        }
        // We need to apply a attribute to the inner most child to help
        // ProseMirror identify its boundaries better.
        const contentAttrs = {
            'data-layout-content': 'true'
        };
        return [
            'div',
            attrs,
            [
                'div',
                contentAttrs,
                0
            ]
        ];
    }
});

});

parcelRegister("7agO8", function(module, exports) {

$parcel$export(module.exports, "createMediaSpec", () => $5376813d9b4ea07d$export$35bdbf5bc8caa677);
$parcel$export(module.exports, "copyPrivateAttributes", () => $5376813d9b4ea07d$export$111130fa8968d741);
$parcel$export(module.exports, "media", () => $5376813d9b4ea07d$export$987d49ffe1b0900f);
$parcel$export(module.exports, "toJSON", () => $5376813d9b4ea07d$export$54fd2c36b5cc6731);

var $51H8P = parcelRequire("51H8P");

var $gthjq = parcelRequire("gthjq");
const $5376813d9b4ea07d$export$bb3fe706be61f640 = (0, $gthjq.media)({}).attrs;
const $5376813d9b4ea07d$export$35bdbf5bc8caa677 = (attributes, inline = false)=>{
    const domNodeType = inline ? 'span' : 'div';
    const nodeName = inline ? 'mediaInline' : 'media';
    const parseDOM = [
        {
            tag: `${domNodeType}[data-node-type="${nodeName}"]`,
            getAttrs: (dom)=>{
                const attrs = {};
                if (attributes) Object.keys(attributes).forEach((k)=>{
                    const key = $5376813d9b4ea07d$export$f84fdfb973c05bd8(k).replace(/^__/, '');
                    const value = dom.getAttribute(`data-${key}`) || '';
                    if (value) attrs[k] = value;
                });
                // Need to do validation & type conversion manually
                if (attrs.__fileSize) attrs.__fileSize = +attrs.__fileSize;
                const width = Number(attrs.width);
                if (typeof width !== 'undefined' && !isNaN(width)) attrs.width = width;
                const height = Number(attrs.height);
                if (typeof height !== 'undefined' && !isNaN(height)) attrs.height = height;
                return attrs;
            }
        },
        // Don't match data URI
        {
            tag: 'img[src^="data:image"]',
            ignore: true
        }
    ];
    const toDOM = (node)=>{
        const attrs = {
            'data-id': node.attrs.id,
            'data-node-type': `${nodeName}`,
            'data-type': node.attrs.type,
            'data-collection': node.attrs.collection,
            'data-occurrence-key': node.attrs.occurrenceKey,
            'data-width': node.attrs.width,
            'data-height': node.attrs.height,
            'data-url': node.attrs.url,
            'data-alt': node.attrs.alt,
            // toDOM is used for static rendering as well as editor rendering. This comes into play for
            // emails, copy/paste, etc, so the title and styling here *is* useful (despite a React-based
            // node view being used for editing).
            title: 'Attachment',
            // Manually kept in sync with the style of media cards. The goal is to render a plain gray
            // rectangle that provides an affordance for media.
            style: `display: inline-block; border-radius: 3px; background: ${(0, $51H8P.N30)}; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);`
        };
        $5376813d9b4ea07d$export$111130fa8968d741(node.attrs, attrs, (key)=>`data-${$5376813d9b4ea07d$export$f84fdfb973c05bd8(key.slice(2))}`);
        return [
            `${domNodeType}`,
            attrs
        ];
    };
    if (inline) return (0, $gthjq.mediaInline)({
        parseDOM: parseDOM,
        toDOM: toDOM
    });
    return (0, $gthjq.media)({
        parseDOM: [
            ...parseDOM,
            {
                // media-inline.ts uses this same function to generate the nodespec
                // this ensures that we don't make a media inline out of a copied image
                // https://product-fabric.atlassian.net/browse/EDM-2996
                tag: 'img:not(.smart-link-icon)',
                getAttrs: (dom)=>{
                    return {
                        type: 'external',
                        url: dom.getAttribute('src') || '',
                        alt: dom.getAttribute('alt') || ''
                    };
                }
            }
        ],
        toDOM: toDOM
    });
};
const $5376813d9b4ea07d$export$987d49ffe1b0900f = $5376813d9b4ea07d$export$35bdbf5bc8caa677($5376813d9b4ea07d$export$bb3fe706be61f640, false);
const $5376813d9b4ea07d$export$f84fdfb973c05bd8 = (str)=>str.replace(/([^A-Z]+)([A-Z])/g, (_, x, y)=>`${x}-${y.toLowerCase()}`);
const $5376813d9b4ea07d$export$111130fa8968d741 = (from, to, map)=>{
    if ($5376813d9b4ea07d$export$987d49ffe1b0900f.attrs) Object.keys($5376813d9b4ea07d$export$987d49ffe1b0900f.attrs).forEach((key)=>{
        if (key[0] === '_' && key[1] === '_' && from[key]) to[map ? map(key) : key] = from[key];
    });
};
/**
 * There's no concept of optional property in ProseMirror. It sets value as `null`
 * when there's no use of any property. We are filtering out all private & optional attrs here.
 */ const $5376813d9b4ea07d$var$optionalAttributes = [
    'occurrenceKey',
    'width',
    'height',
    'url',
    'alt'
];
const $5376813d9b4ea07d$var$externalOnlyAttributes = [
    'type',
    'url',
    'width',
    'height',
    'alt'
];
const $5376813d9b4ea07d$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs)// Strip private attributes e.g. __fileName, __fileSize, __fileMimeType, etc.
        .filter((key)=>!(key[0] === '_' && key[1] === '_')).reduce((obj, key)=>{
            if (node.attrs.type === 'external' && $5376813d9b4ea07d$var$externalOnlyAttributes.indexOf(key) === -1) return obj;
            if ($5376813d9b4ea07d$var$optionalAttributes.indexOf(key) > -1 && (node.attrs[key] === null || node.attrs[key] === '')) return obj;
            if ([
                'width',
                'height'
            ].indexOf(key) !== -1) {
                obj[key] = Number(node.attrs[key]);
                return obj;
            }
            obj[key] = node.attrs[key];
            return obj;
        }, {})
    });

});

parcelRegister("92lix", function(module, exports) {

$parcel$export(module.exports, "mediaGroup", () => $6944d24b2c8b0dd9$export$2855e964765eac9);

var $gthjq = parcelRequire("gthjq");
const $6944d24b2c8b0dd9$export$2855e964765eac9 = (0, $gthjq.mediaGroup)({
    parseDOM: [
        {
            tag: 'div[data-node-type="mediaGroup"]'
        },
        {
            tag: 'div[class="MediaGroup"]'
        }
    ],
    toDOM () {
        return [
            'div',
            {
                'data-node-type': 'mediaGroup'
            },
            0
        ];
    }
});

});

parcelRegister("7Xgp3", function(module, exports) {

$parcel$export(module.exports, "mediaInline", () => $5caac46433adf3f0$export$38bab695e3f720f1);

var $7agO8 = parcelRequire("7agO8");

var $gthjq = parcelRequire("gthjq");
const $5caac46433adf3f0$export$38bab695e3f720f1 = (0, $7agO8.createMediaSpec)((0, $gthjq.mediaInline)({}).attrs, true);

});

parcelRegister("bIGZ7", function(module, exports) {

$parcel$export(module.exports, "mediaSingleSpec", () => $888525ada96954d1$export$5a1e124099b60c6b);
$parcel$export(module.exports, "mediaSingle", () => $888525ada96954d1$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingleWithCaption", () => $888525ada96954d1$export$d35e6c006d4abdfb);
$parcel$export(module.exports, "mediaSingleWithWidthType", () => $888525ada96954d1$export$9c58e19811ce4cf5);
$parcel$export(module.exports, "mediaSingleFull", () => $888525ada96954d1$export$7e767666f2ce108a);
$parcel$export(module.exports, "toJSON", () => $888525ada96954d1$export$54fd2c36b5cc6731);

var $ITAJ1 = parcelRequire("ITAJ1");

var $6VXbJ = parcelRequire("6VXbJ");

var $gthjq = parcelRequire("gthjq");
const $888525ada96954d1$export$bb3fe706be61f640 = {
    width: {
        default: null
    },
    // null makes small images to have original size by default
    layout: {
        default: 'center'
    }
};
const $888525ada96954d1$export$5a1e124099b60c6b = ({ withCaption: withCaption = false, withExtendedWidthTypes: withExtendedWidthTypes = false })=>{
    const getAttrs = (dom)=>{
        if (!(0, $6VXbJ.isDOMElement)(dom)) // this should never happen
        return {
            layout: 'center'
        };
        const layout = dom.getAttribute('data-layout') || 'center';
        const width = Number(dom.getAttribute('data-width')) || null;
        const widthType = dom.getAttribute('data-width-type');
        if (withExtendedWidthTypes) return {
            layout: layout,
            width: width,
            widthType: widthType
        };
        else if (widthType === (0, $ITAJ1.WidthType).PIXEL) // if editor does not support widthType attribute.
        // We ignore width and widthType together.
        return {
            layout: layout
        };
        else return {
            layout: layout,
            width: width
        };
    };
    const getAttrsFromNode = (node)=>{
        const { layout: layout, width: width } = node.attrs;
        const attrs = {
            'data-node-type': 'mediaSingle',
            'data-layout': layout,
            'data-width': ''
        };
        if (width) attrs['data-width'] = isFinite(width) && Math.floor(width) === width ? width : width.toFixed(2);
        if (withExtendedWidthTypes && node.attrs.widthType) {
            const { widthType: widthType } = node.attrs;
            return {
                ...attrs,
                'data-width-type': widthType || (0, $ITAJ1.WidthType).PERCENTAGE
            };
        }
        return attrs;
    };
    if (withExtendedWidthTypes && withCaption) return (0, $gthjq.mediaSingleFull)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (withExtendedWidthTypes && !withCaption) return (0, $gthjq.mediaSingleWidthType)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (!withExtendedWidthTypes && withCaption) return (0, $gthjq.mediaSingleCaption)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    return (0, $gthjq.mediaSingle)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
};
const $888525ada96954d1$export$969fe3781ca15058 = $888525ada96954d1$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: false
});
const $888525ada96954d1$export$d35e6c006d4abdfb = $888525ada96954d1$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: false
});
const $888525ada96954d1$export$9c58e19811ce4cf5 = $888525ada96954d1$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: true
});
const $888525ada96954d1$export$7e767666f2ce108a = $888525ada96954d1$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true
});
const $888525ada96954d1$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if (node.attrs[key] !== null) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });

});
parcelRegister("ITAJ1", function(module, exports) {

$parcel$export(module.exports, "WidthType", () => $086f3b754fef02e1$export$4d41558722ac7eed);
/**
 * @description The widthType attribute is used to support fixed with media single
 */ let $086f3b754fef02e1$export$4d41558722ac7eed = /*#__PURE__*/ function(WidthType) {
    WidthType["PIXEL"] = "pixel";
    WidthType["PERCENTAGE"] = "percentage";
    return WidthType;
}({});

});


parcelRegister("g7Cky", function(module, exports) {

$parcel$export(module.exports, "mention", () => $bbcb0873d657d42d$export$db83999c14438df4);
$parcel$export(module.exports, "toJSON", () => $bbcb0873d657d42d$export$54fd2c36b5cc6731);

var $9IGaJ = parcelRequire("9IGaJ");

var $gthjq = parcelRequire("gthjq");
let $bbcb0873d657d42d$export$abebb208988c258 = /*#__PURE__*/ function(USER_TYPES) {
    USER_TYPES["DEFAULT"] = "DEFAULT";
    USER_TYPES["SPECIAL"] = "SPECIAL";
    USER_TYPES["APP"] = "APP";
    return USER_TYPES;
}({});
const $bbcb0873d657d42d$export$db83999c14438df4 = (0, $gthjq.mention)({
    parseDOM: [
        {
            tag: 'span[data-mention-id]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const attrs = {
                    id: dom.getAttribute('data-mention-id') || $bbcb0873d657d42d$export$db83999c14438df4.attrs.id.default,
                    text: dom.textContent || $bbcb0873d657d42d$export$db83999c14438df4.attrs.text.default,
                    accessLevel: dom.getAttribute('data-access-level') || $bbcb0873d657d42d$export$db83999c14438df4.attrs.accessLevel.default,
                    localId: (0, $9IGaJ.uuid).generate()
                };
                const userType = dom.getAttribute('data-user-type');
                if ($bbcb0873d657d42d$export$abebb208988c258[userType]) attrs.userType = userType;
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { id: id, accessLevel: accessLevel, text: text, userType: userType, localId: localId } = node.attrs;
        const attrs = {
            'data-mention-id': id,
            'data-access-level': accessLevel,
            contenteditable: 'false'
        };
        if (localId) attrs['data-local-id'] = localId;
        if (userType) attrs['data-user-type'] = userType;
        return [
            'span',
            attrs,
            text
        ];
    }
});
const $bbcb0873d657d42d$var$isOptional = (key)=>{
    return [
        'userType',
        'localId'
    ].indexOf(key) > -1;
};
const $bbcb0873d657d42d$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if ($bbcb0873d657d42d$var$isOptional(key) && !node.attrs[key]) return obj;
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });

});

parcelRegister("dx5eC", function(module, exports) {

$parcel$export(module.exports, "nestedExpand", () => $9da26af350402964$export$63cadbf5f4296627);
$parcel$export(module.exports, "nestedExpandWithoutNonBodiedMacros", () => $9da26af350402964$export$15ebf236772fa336);

var $gthjq = parcelRequire("gthjq");
/**
 * @name nestedExpand_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name nestedExpand_node
 */ /**
 * @name nestedExpand_with_no_marks_node
 */ function $9da26af350402964$var$getExpandAttrs(domNode) {
    const dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
const $9da26af350402964$var$nestedExpandFactoryOptions = {
    parseDOM: [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: $9da26af350402964$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="nestedExpand"]',
            getAttrs: $9da26af350402964$var$getExpandAttrs
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'nestedExpand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $9da26af350402964$var$nestedExpandWithoutNonBodiedMacrosFactoryOptions = {
    parseDOM: [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: $9da26af350402964$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="nestedExpand"]',
            getAttrs: $9da26af350402964$var$getExpandAttrs
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'nestedExpand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $9da26af350402964$export$63cadbf5f4296627 = (0, $gthjq.nestedExpand)($9da26af350402964$var$nestedExpandFactoryOptions);
const $9da26af350402964$export$15ebf236772fa336 = (0, $gthjq.nestedExpandWithoutNonBodiedMacros)($9da26af350402964$var$nestedExpandWithoutNonBodiedMacrosFactoryOptions);

});

parcelRegister("dwptW", function(module, exports) {

$parcel$export(module.exports, "orderedListSelector", () => $9d8207b1e6c47527$export$4e7125c7ff595be5);
$parcel$export(module.exports, "orderedList", () => $9d8207b1e6c47527$export$a5dc81035676e7a);
$parcel$export(module.exports, "orderedListWithOrder", () => $9d8207b1e6c47527$export$b9ab759e8298198f);

var $gthjq = parcelRequire("gthjq");
const $9d8207b1e6c47527$export$4e7125c7ff595be5 = '.ak-ol';
const $9d8207b1e6c47527$export$a5dc81035676e7a = (0, $gthjq.orderedList)({
    parseDOM: [
        {
            tag: 'ol'
        }
    ],
    toDOM () {
        const attrs = {
            class: $9d8207b1e6c47527$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
// resolve "start" to a safe, 0+ integer, otherwise return undefined
// Note: Any changes to this function should also be made to "resolveOrder"
// in packages/editor/editor-common/src/utils/list.ts
const $9d8207b1e6c47527$var$resolveStart = (start)=>{
    const num = Number(start);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $9d8207b1e6c47527$export$b9ab759e8298198f = (0, $gthjq.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const startDOMAttr = dom.getAttribute('start');
                if (startDOMAttr) {
                    const start = $9d8207b1e6c47527$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start
                    };
                }
                return null;
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const start = $9d8207b1e6c47527$var$resolveStart(node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.order);
        const attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $9d8207b1e6c47527$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("abme3", function(module, exports) {

$parcel$export(module.exports, "paragraph", () => $769c2c0b195d79f6$export$9c206ddddb32a9b);

var $gthjq = parcelRequire("gthjq");
const $769c2c0b195d79f6$export$9c206ddddb32a9b = (0, $gthjq.paragraph)({
    parseDOM: [
        {
            tag: 'p',
            getAttrs: (domNode)=>{
                var _paragraph$attrs, _paragraph$attrs$loca;
                const dom = domNode;
                const attrs = {
                    localId: dom.getAttribute('data-local-id') || ((_paragraph$attrs = $769c2c0b195d79f6$export$9c206ddddb32a9b.attrs) === null || _paragraph$attrs === void 0 ? void 0 : (_paragraph$attrs$loca = _paragraph$attrs.localId) === null || _paragraph$attrs$loca === void 0 ? void 0 : _paragraph$attrs$loca.default)
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const name = 'p';
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
});

});

parcelRegister("dgJoa", function(module, exports) {

$parcel$export(module.exports, "placeholder", () => $9a8ffa3be19d5bd0$export$c7187bbd1a7a9244);

var $gthjq = parcelRequire("gthjq");
const $9a8ffa3be19d5bd0$export$c7187bbd1a7a9244 = (0, $gthjq.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: (dom)=>({
                    text: dom.getAttribute('data-placeholder') || $9a8ffa3be19d5bd0$export$c7187bbd1a7a9244.attrs.text.default
                })
        }
    ],
    toDOM (node) {
        const { text: text } = node.attrs;
        const attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("M4hHz", function(module, exports) {

$parcel$export(module.exports, "rule", () => $0907ce9fea0294ca$export$fbeb3a3956e8a3c7);

var $gthjq = parcelRequire("gthjq");
/**
 * @name rule_node
 */ const $0907ce9fea0294ca$var$hrDOM = [
    'hr'
];
const $0907ce9fea0294ca$export$fbeb3a3956e8a3c7 = (0, $gthjq.rule)({
    parseDOM: [
        {
            tag: 'hr'
        }
    ],
    toDOM () {
        return $0907ce9fea0294ca$var$hrDOM;
    }
});

});

parcelRegister("18bvk", function(module, exports) {

$parcel$export(module.exports, "status", () => $0d2f764e7fea7c00$export$471f7ae5c4103ae1);

var $9IGaJ = parcelRequire("9IGaJ");

var $gthjq = parcelRequire("gthjq");
const $0d2f764e7fea7c00$export$471f7ae5c4103ae1 = (0, $gthjq.status)({
    parseDOM: [
        {
            tag: 'span[data-node-type="status"]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    text: dom.textContent.replace(/\n/, '').trim(),
                    color: dom.getAttribute('data-color'),
                    localId: (0, $9IGaJ.uuid).generate(),
                    style: dom.getAttribute('data-style')
                };
            }
        }
    ],
    toDOM (node) {
        const { text: text, color: color, localId: localId, style: style } = node.attrs;
        const attrs = {
            'data-node-type': 'status',
            'data-color': color,
            'data-local-id': localId,
            'data-style': style,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("iThOL", function(module, exports) {

$parcel$export(module.exports, "taskItem", () => $dc0b2f4f47f16dc0$export$6d8b0ef52e2e6390);

var $9IGaJ = parcelRequire("9IGaJ");

var $gthjq = parcelRequire("gthjq");
const $dc0b2f4f47f16dc0$export$6d8b0ef52e2e6390 = (0, $gthjq.taskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $9IGaJ.uuid).generate(),
                    state: dom.getAttribute('data-task-state') || 'TODO'
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("43mJF", function(module, exports) {

$parcel$export(module.exports, "taskListSelector", () => $2f3914100d01687b$export$c0ec71adb7a18fb2);
$parcel$export(module.exports, "taskList", () => $2f3914100d01687b$export$375b6afcc5f4d291);

var $9IGaJ = parcelRequire("9IGaJ");

var $gthjq = parcelRequire("gthjq");
/**
 * @name taskList_node
 */ const $2f3914100d01687b$var$name = 'actionList';
const $2f3914100d01687b$export$c0ec71adb7a18fb2 = `[data-node-type="${$2f3914100d01687b$var$name}"]`;
const $2f3914100d01687b$export$375b6afcc5f4d291 = (0, $gthjq.taskList)({
    parseDOM: [
        {
            tag: `div${$2f3914100d01687b$export$c0ec71adb7a18fb2}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $9IGaJ.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $2f3914100d01687b$var$name,
            'data-task-list-local-id': localId || 'local-task-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("3DR6L", function(module, exports) {

$parcel$export(module.exports, "text", () => $2a6e35cab1a01b8e$export$6f093cfa640b7166);

var $gthjq = parcelRequire("gthjq");
const $2a6e35cab1a01b8e$export$6f093cfa640b7166 = (0, $gthjq.text)({
    toDebugString: ()=>'text_node'
});

});

parcelRegister("9X587", function(module, exports) {

$parcel$export(module.exports, "default", () => $01deabc8204e5493$export$2e2bcd8739ae039);
const $01deabc8204e5493$var$name = 'unknownBlock';
var $01deabc8204e5493$export$2e2bcd8739ae039 = {
    group: 'block',
    content: 'inline+',
    marks: '_',
    toDOM () {
        return [
            'div',
            {
                'data-node-type': $01deabc8204e5493$var$name
            },
            0
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$01deabc8204e5493$var$name}"]`
        }
    ]
};

});

parcelRegister("d1d6m", function(module, exports) {

$parcel$export(module.exports, "unsupportedBlock", () => $97a5880db351ce36$export$44b79b0979d0f0f7);

var $gthjq = parcelRequire("gthjq");
const $97a5880db351ce36$export$44b79b0979d0f0f7 = (0, $gthjq.unsupportedBlock)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedBlock"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedBlock',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    }
});

});

parcelRegister("6kr5W", function(module, exports) {

$parcel$export(module.exports, "unsupportedInline", () => $49b9a0cbcfdcc3a0$export$310ebe0d80122e9b);

var $gthjq = parcelRequire("gthjq");
const $49b9a0cbcfdcc3a0$export$310ebe0d80122e9b = (0, $gthjq.unsupportedInline)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedInline"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedInline',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'span',
            attrs,
            'Unsupported content'
        ];
    }
});

});



parcelRegister("f5oqj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3de1eca32602d427$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $kOFhM = parcelRequire("kOFhM");

var $dGzaM = parcelRequire("dGzaM");
var $9S8fM = parcelRequire("9S8fM");

var $9Iju4 = parcelRequire("9Iju4");
var $fIJEx = parcelRequire("fIJEx");
var $iiXGq = parcelRequire("iiXGq");
var $4ceoy = parcelRequire("4ceoy");
var $2DpUZ = parcelRequire("2DpUZ");

var $gmhCD = parcelRequire("gmhCD");

var $f8Sb3 = parcelRequire("f8Sb3");

var $gE8f9 = parcelRequire("gE8f9");

var $iN9lO = parcelRequire("iN9lO");

var $ap7h6 = parcelRequire("ap7h6");

var $kFiBa = parcelRequire("kFiBa");

var $4NUlu = parcelRequire("4NUlu");
var $fc6h8 = parcelRequire("fc6h8");

var $VSDnB = parcelRequire("VSDnB");

var $dWAZk = parcelRequire("dWAZk");

var $1PVpv = parcelRequire("1PVpv");

var $gkwXh = parcelRequire("gkwXh");

var $4zXba = parcelRequire("4zXba");

var $bXrHm = parcelRequire("bXrHm");

var $9gOVJ = parcelRequire("9gOVJ");
var $12yAL = parcelRequire("12yAL");

var $TM1uy = parcelRequire("TM1uy");

var $knXBU = parcelRequire("knXBU");

var $1urn6 = parcelRequire("1urn6");

var $3kKuL = parcelRequire("3kKuL");

var $dyURG = parcelRequire("dyURG");

var $K5Jsy = parcelRequire("K5Jsy");

var $fCNtA = parcelRequire("fCNtA");

var $4BsEy = parcelRequire("4BsEy");

var $1pTqN = parcelRequire("1pTqN");

var $4YrGg = parcelRequire("4YrGg");

var $8Eu7T = parcelRequire("8Eu7T");

var $jUVor = parcelRequire("jUVor");

var $TPpI8 = parcelRequire("TPpI8");

var $kgV4b = parcelRequire("kgV4b");


var $3lRy2 = parcelRequire("3lRy2");

var $1SqDw = parcelRequire("1SqDw");

var $glOdv = parcelRequire("glOdv");

var $aagOn = parcelRequire("aagOn");

var $dJPoO = parcelRequire("dJPoO");

var $kjHuf = parcelRequire("kjHuf");

var $8QrLL = parcelRequire("8QrLL");
function $3de1eca32602d427$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3de1eca32602d427$export$47b2879ca9bbf67a = 2000;
const $3de1eca32602d427$export$1b622068be977101 = 3000;
const $3de1eca32602d427$var$packageName = "platform-pkg";
const $3de1eca32602d427$var$packageVersion = "0.0.0-use.local";
const $3de1eca32602d427$var$setAsQueryContainerStyles = {
    name: "3qfej8",
    styles: "container-name:ak-renderer-wrapper;container-type:inline-size"
};
const $3de1eca32602d427$var$handleMouseTripleClickInTables = (event)=>{
    if ((0, $gE8f9.browser).ios || (0, $gE8f9.browser).android) return;
    const badBrowser = (0, $gE8f9.browser).chrome || (0, $gE8f9.browser).safari;
    const tripleClick = event.detail >= 3;
    if (!(badBrowser && tripleClick)) return;
    const selection = window.getSelection();
    if (!selection) return;
    const { type: type, anchorNode: anchorNode, focusNode: focusNode } = selection;
    const rangeSelection = Boolean(type === 'Range' && anchorNode && focusNode);
    if (!rangeSelection) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const target = event.target;
    const tableCell = target.closest('td,th');
    const clickedInCell = Boolean(tableCell);
    if (!clickedInCell) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const anchorInCell = tableCell.contains(anchorNode);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const focusInCell = tableCell.contains(focusNode);
    const selectionStartsOrEndsOutsideClickedCell = !(anchorInCell && focusInCell);
    if (!selectionStartsOrEndsOutsideClickedCell) return;
    // Ensure that selecting text in the renderer doesn't trigger onUnhandledClick
    // This logic originated in jira-frontend:
    // src/packages/issue/issue-view/src/views/field/rich-text/rich-text-inline-edit-view.js
    // The selection is required to be checked in `onMouseDown` and here. If not here, a new
    // selection isn't reported; if not in `onMouseDown`, a click outside the selection will
    // return an empty selection, which will erroneously fire onUnhandledClick.
    const elementToSelect = anchorInCell ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    anchorNode.parentElement?.closest('div,p') : focusInCell ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    focusNode.parentElement?.closest('div,p') : tableCell;
    if (elementToSelect) selection.selectAllChildren(elementToSelect);
};
/**
 * Handle clicks inside renderer. If the click isn't on media, in the media picker, or on a
 * link, call the onUnhandledClick eventHandler (which in Jira for example, may switch the
 * renderer out for the editor).
 * @param event Click event anywhere inside renderer
 * @param props
 * @param mouseDownSelection
 * @example
 */ const $3de1eca32602d427$var$handleWrapperOnClick = (event, props, mouseDownSelection)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const targetElement = event.target;
    $3de1eca32602d427$var$handleMouseTripleClickInTables(event);
    // ED-14862: When a user triple clicks to select a line of content inside a
    // a table cell, but the browser incorrectly moves the selection start or end into
    // a different table cell, we manually set the selection back to within the original
    // table cell the user intended to target
    if (!props.eventHandlers?.onUnhandledClick) return;
    if (!(targetElement instanceof window.Element)) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const rendererWrapper = event.currentTarget;
    const isInteractiveElementInTree = (0, $K5Jsy.findInTree)(targetElement, rendererWrapper, (0, $TPpI8.isInteractiveElement));
    if (isInteractiveElementInTree) return;
    // Ensure that selecting text in the renderer doesn't trigger onUnhandledClick
    // This logic originated in jira-frontend:
    // src/packages/issue/issue-view/src/views/field/rich-text/rich-text-inline-edit-view.js
    // The selection is required to be checked in `onMouseDown` and here. If not here, a new
    // selection isn't reported; if not in `onMouseDown`, a click outside the selection will
    // return an empty selection, which will erroneously fire onUnhandledClick.
    const windowSelection = window.getSelection();
    const selection = windowSelection !== null ? windowSelection.toString() : undefined;
    const hasSelection = selection && selection.length !== 0;
    const hasSelectionMouseDown = mouseDownSelection.current && mouseDownSelection.current.length !== 0;
    const allowEditBasedOnSelection = !hasSelection && !hasSelectionMouseDown;
    if (allowEditBasedOnSelection) props.eventHandlers.onUnhandledClick(event);
};
const $3de1eca32602d427$export$c49fe2316038f3c2 = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = props;
    const mouseDownSelection = (0, $5uXOq.useRef)(undefined);
    const providerFactory = (0, $5uXOq.useMemo)(()=>props.dataProviders || new (0, $dGzaM.default)(), [
        props.dataProviders
    ]);
    const createRendererContext = (0, $5uXOq.useMemo)(()=>(featureFlags, isTopLevelRenderer)=>{
            const normalizedFeatureFlags = (0, $4zXba.normalizeFeatureFlags)(featureFlags);
            return {
                featureFlags: normalizedFeatureFlags,
                isTopLevelRenderer: isTopLevelRenderer === undefined
            };
        }, []);
    const fireAnalyticsEventOld = (0, $5uXOq.useCallback)((event)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = props;
        if (createAnalyticsEvent) {
            const channel = (0, $dWAZk.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }, [
        props
    ]);
    const fireAnalyticsEventNew = (0, $5uXOq.useCallback)((event)=>{
        if (createAnalyticsEvent) {
            const channel = (0, $dWAZk.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }, [
        createAnalyticsEvent
    ]);
    const fireAnalyticsEvent = (0, $gmhCD.editorExperiment)('platform_renderer_fix_analytics_memo_callback', true, {
        exposure: true
    }) ? fireAnalyticsEventNew : fireAnalyticsEventOld;
    const deriveSerializerProps = (0, $5uXOq.useCallback)((props)=>{
        const stickyHeaders = props.stickyHeaders ? props.stickyHeaders === true ? {} : props.stickyHeaders : undefined;
        const { annotationProvider: annotationProvider } = props;
        const allowAnnotationsDraftMode = Boolean(annotationProvider && annotationProvider.inlineComment && annotationProvider.inlineComment.allowDraftMode);
        const { featureFlags: featureFlags } = createRendererContext(props.featureFlags, props.isTopLevelRenderer);
        return {
            startPos: props.startPos ?? 0,
            providers: providerFactory,
            eventHandlers: props.eventHandlers,
            extensionHandlers: props.extensionHandlers,
            portal: props.portal,
            objectContext: {
                adDoc: props.shouldRemoveEmptySpaceAroundContent ? (0, $dJPoO.removeEmptySpaceAroundContent)(props.document) : props.document,
                schema: props.schema,
                ...props.rendererContext
            },
            appearance: props.appearance,
            disableHeadingIDs: props.disableHeadingIDs,
            disableActions: props.disableActions,
            allowHeadingAnchorLinks: props.allowHeadingAnchorLinks,
            allowColumnSorting: props.allowColumnSorting,
            fireAnalyticsEvent: fireAnalyticsEvent,
            shouldOpenMediaViewer: props.shouldOpenMediaViewer,
            allowAltTextOnImages: props.allowAltTextOnImages,
            stickyHeaders: stickyHeaders,
            allowMediaLinking: props.media && props.media.allowLinking,
            surroundTextNodesWithTextWrapper: allowAnnotationsDraftMode,
            media: props.media,
            emojiResourceConfig: props.emojiResourceConfig,
            smartLinks: props.smartLinks,
            extensionViewportSizes: props.extensionViewportSizes,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowCustomPanels: props.allowCustomPanels,
            allowAnnotations: props.allowAnnotations,
            allowSelectAllTrap: props.allowSelectAllTrap,
            allowPlaceholderText: props.allowPlaceholderText,
            nodeComponents: props.nodeComponents,
            allowWindowedCodeBlock: featureFlags?.allowWindowedCodeBlock,
            isInsideOfInlineExtension: props.isInsideOfInlineExtension,
            isPresentational: props.UNSTABLE_isPresentational,
            textHighlighter: props.textHighlighter || props.UNSTABLE_textHighlighter,
            allowTableAlignment: props.UNSTABLE_allowTableAlignment,
            allowTableResizing: props.UNSTABLE_allowTableResizing
        };
    }, [
        createRendererContext,
        providerFactory,
        fireAnalyticsEvent
    ]);
    // Abstract out the logic into its own function
    const serializer = (0, $kjHuf.useMemoFromPropsDerivative)((serializerProps)=>{
        // If progressive rendering is enabled, create a new serializer
        if ((0, $VSDnB.fg)('cc_complexit_fe_progressive_adf_rendering')) {
            const newSerializer = props.createSerializer?.(serializerProps);
            if (newSerializer) return newSerializer;
        }
        return new (0, $9gOVJ.default)(serializerProps);
    }, deriveSerializerProps, props);
    const localRef = (0, $5uXOq.useRef)(null);
    const editorRef = props.innerRef || localRef;
    const id = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))(), []);
    const renderedMeasurementDistortedDurationMonitor = (0, $5uXOq.useMemo)(()=>(0, $ap7h6.getDistortedDurationMonitor)(), []);
    // we are doing this to ensure it runs as
    // early as possible in the React lifecycle
    // to avoid any other side effects
    const measureStarted = (0, $5uXOq.useRef)(false);
    const startAnalyticsMeasure = ()=>{
        (0, $iN9lO.startMeasure)(`Renderer Render Time: ${id}`);
    };
    if (!measureStarted.current) {
        startAnalyticsMeasure();
        measureStarted.current = true;
    }
    const anchorLinkAnalytics = (0, $5uXOq.useCallback)(()=>{
        const hash = window.location.hash && decodeURIComponent(window.location.hash.slice(1));
        const disableHeadingIDs = props.disableHeadingIDs;
        if (!disableHeadingIDs && hash && editorRef && editorRef.current instanceof HTMLElement) {
            const anchorLinkElement = document.getElementById(hash);
            if (anchorLinkElement && editorRef.current.contains(anchorLinkElement)) fireAnalyticsEvent({
                action: (0, $gkwXh.ACTION).VIEWED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANCHOR_LINK,
                attributes: {
                    platform: (0, $knXBU.PLATFORM).WEB,
                    mode: (0, $knXBU.MODE).RENDERER
                },
                eventType: (0, $gkwXh.EVENT_TYPE).UI
            });
        }
    }, [
        props.disableHeadingIDs,
        editorRef,
        fireAnalyticsEvent
    ]);
    const getSchema = (0, $5uXOq.useMemo)(()=>{
        return (schema, adfStage)=>{
            if (schema) return schema;
            return (0, $kOFhM.getSchemaBasedOnStage)(adfStage);
        };
    }, []);
    const onMouseDownEditView = ()=>{
        const windowSelection = window.getSelection();
        mouseDownSelection.current = windowSelection !== null ? windowSelection.toString() : undefined;
    };
    const { dataProviders: dataProviders, analyticsEventSeverityTracking: analyticsEventSeverityTracking } = props;
    (0, $5uXOq.useEffect)(()=>{
        let rafID;
        const handleAnalytics = ()=>{
            fireAnalyticsEvent({
                action: (0, $gkwXh.ACTION).STARTED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
                attributes: {
                    platform: (0, $knXBU.PLATFORM).WEB
                },
                eventType: (0, $gkwXh.EVENT_TYPE).UI
            });
            rafID = requestAnimationFrame(()=>{
                (0, $iN9lO.stopMeasure)(`Renderer Render Time: ${id}`, (duration)=>{
                    const forceSeverityTracking = typeof analyticsEventSeverityTracking === 'undefined' && (0, $fc6h8.shouldForceTracking)();
                    const severity = !!forceSeverityTracking || analyticsEventSeverityTracking?.enabled ? (0, $4NUlu.getAnalyticsEventSeverity)(duration, analyticsEventSeverityTracking?.severityNormalThreshold ?? $3de1eca32602d427$export$47b2879ca9bbf67a, analyticsEventSeverityTracking?.severityDegradedThreshold ?? $3de1eca32602d427$export$1b622068be977101) : undefined;
                    const isTTRTrackingExplicitlyDisabled = analyticsEventSeverityTracking?.enabled === false;
                    if (!isTTRTrackingExplicitlyDisabled) fireAnalyticsEvent({
                        action: (0, $gkwXh.ACTION).RENDERED,
                        actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
                        attributes: {
                            platform: (0, $knXBU.PLATFORM).WEB,
                            duration: duration,
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            distortedDuration: renderedMeasurementDistortedDurationMonitor.distortedDuration,
                            ttfb: (0, $kFiBa.getResponseEndTime)(),
                            nodes: (0, $kgV4b.countNodes)(props.document),
                            severity: severity
                        },
                        eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
                    });
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    renderedMeasurementDistortedDurationMonitor.cleanup();
                });
                anchorLinkAnalytics();
            });
        };
        handleAnalytics();
        return ()=>{
            if (rafID) window.cancelAnimationFrame(rafID);
            // if this is the ProviderFactory which was created in constructor
            // it's safe to destroy it on Renderer unmount
            // updated to match existing class component
            if (!dataProviders) providerFactory.destroy();
        };
    // we are going to ignore this because I'm doing this on purpose
    // having a dependency array means we run stopMeasure twice per render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const rendererContext = (0, $5uXOq.useMemo)(()=>createRendererContext(props.featureFlags, props.isTopLevelRenderer), [
        props.featureFlags,
        props.isTopLevelRenderer,
        createRendererContext
    ]);
    try {
        const schema = getSchema(props.schema, props.adfStage);
        const { result: result, stat: stat, pmDoc: pmDoc } = (0, $12yAL.renderDocument)(props.shouldRemoveEmptySpaceAroundContent ? (0, $dJPoO.removeEmptySpaceAroundContent)(props.document) : props.document, serializer, schema, props.adfStage, props.useSpecBasedValidator, id, fireAnalyticsEvent, props.unsupportedContentLevelsTracking, props.appearance, props.includeNodesCountInStats, props.skipValidation, props.validationOverrides);
        if (props.onComplete) props.onComplete(stat);
        const rendererOutput = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dyURG.RendererContextProvider), {
            value: rendererContext
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1pTqN.ActiveHeaderIdProvider), {
            value: (0, $3kKuL.getActiveHeadingId)(props.allowHeadingAnchorLinks)
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $TM1uy.default).Provider, {
            value: {
                fireAnalyticsEvent: (event)=>fireAnalyticsEvent(event)
            }
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4BsEy.Provider), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9S8fM.ProviderFactoryProvider), {
            value: providerFactory
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$var$RendererWrapper, {
            allowAnnotations: props.allowAnnotations,
            appearance: props.appearance,
            allowNestedHeaderLinks: (0, $3kKuL.isNestedHeaderLinksEnabled)(props.allowHeadingAnchorLinks),
            allowColumnSorting: props.allowColumnSorting,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowCustomPanels: props.allowCustomPanels,
            allowPlaceholderText: props.allowPlaceholderText,
            useBlockRenderForCodeBlock: rendererContext.featureFlags.useBlockRenderForCodeBlock ?? true,
            addTelepointer: props.addTelepointer,
            innerRef: editorRef,
            onClick: (event)=>$3de1eca32602d427$var$handleWrapperOnClick(event, props, mouseDownSelection),
            onMouseDown: onMouseDownEditView,
            ssr: props.media?.ssr,
            isInsideOfInlineExtension: props.isInsideOfInlineExtension,
            isTopLevelRenderer: rendererContext.isTopLevelRenderer,
            shouldRemoveEmptySpaceAroundContent: props.shouldRemoveEmptySpaceAroundContent
        }, props.enableSsrInlineScripts || props.noOpSSRInlineScript ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jUVor.BreakoutSSRInlineScript), {
            noOpSSRInlineScript: Boolean(props.noOpSSRInlineScript)
        }) : null, /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$var$RendererActionsInternalUpdater, {
            doc: pmDoc,
            schema: schema,
            onAnalyticsEvent: fireAnalyticsEvent
        }, result)))))));
        const rendererResult = props.truncated ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3lRy2.TruncatedWrapper), {
            height: props.maxHeight,
            fadeHeight: props.fadeOutHeight
        }, rendererOutput) : rendererOutput;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, rendererResult);
    } catch (e) {
        if (props.onError) props.onError(e);
        return /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$var$RendererWrapper, {
            allowAnnotations: props.allowAnnotations,
            appearance: props.appearance,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowPlaceholderText: props.allowPlaceholderText,
            allowColumnSorting: props.allowColumnSorting,
            allowNestedHeaderLinks: (0, $3kKuL.isNestedHeaderLinksEnabled)(props.allowHeadingAnchorLinks),
            useBlockRenderForCodeBlock: rendererContext.featureFlags.useBlockRenderForCodeBlock ?? true,
            addTelepointer: props.addTelepointer,
            onClick: (event)=>$3de1eca32602d427$var$handleWrapperOnClick(event, props, mouseDownSelection),
            isTopLevelRenderer: rendererContext.isTopLevelRenderer
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $iiXGq.default), null));
    }
};
const $3de1eca32602d427$var$RendererFunctionalComponentMemoized = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo($3de1eca32602d427$export$c49fe2316038f3c2);
const $3de1eca32602d427$var$RendererFunctionalComponentWithPortalContext = (props)=>{
    const { portal: portal, ...propsWithoutPortal } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8QrLL.PortalContext).Provider, {
        value: portal
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$export$c49fe2316038f3c2, propsWithoutPortal));
};
const $3de1eca32602d427$var$RendererFunctionalComponentWithPortalContextMemoized = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo($3de1eca32602d427$var$RendererFunctionalComponentWithPortalContext);
const $3de1eca32602d427$var$getRendererComponent = (nodeComponents)=>{
    // If nodeComponents are provided, for now we don't want to remove portal from props
    // and use context instead because at this time we cannot guarantee that existing
    // consumers of Atlaskit Renderer will update to use the new portal context.
    if (!Boolean(nodeComponents) && (0, $VSDnB.fg)('cc_complexit_reduce_portal_rerenders')) return $3de1eca32602d427$var$RendererFunctionalComponentWithPortalContextMemoized;
    return $3de1eca32602d427$var$RendererFunctionalComponentMemoized;
};
function $3de1eca32602d427$export$88530751e3977073(props) {
    const { startPos: startPos } = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext((0, $4YrGg.AnnotationsPositionContext));
    const { isTopLevelRenderer: isTopLevelRenderer } = (0, $dyURG.useRendererContext)();
    const { skipValidation: skipValidation, allowNestedTables: allowNestedTables } = (0, $5uXOq.useContext)((0, $1SqDw.ValidationContext)) || {};
    const RendererComponent = $3de1eca32602d427$var$getRendererComponent(props.nodeComponents);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(RendererComponent, {
        ...props,
        startPos: startPos,
        isTopLevelRenderer: isTopLevelRenderer,
        skipValidation: skipValidation,
        validationOverrides: {
            allowNestedTables: allowNestedTables
        }
    });
}
const $3de1eca32602d427$export$af81ffb59b6ef0dd = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1PVpv.FabricEditorAnalyticsContext), {
        data: {
            appearance: (0, $4NUlu.getAnalyticsAppearance)(props.appearance),
            packageName: $3de1eca32602d427$var$packageName,
            packageVersion: $3de1eca32602d427$var$packageVersion,
            componentName: 'renderer',
            editorSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))()
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2DpUZ.WithCreateAnalyticsEvent), {
        render: (createAnalyticsEvent)=>{
            // `IntlErrorBoundary` only captures Internationalisation errors, leaving others for `ErrorBoundary`.
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8Eu7T.ErrorBoundary), {
                component: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
                rethrowError: true,
                fallbackComponent: null,
                createAnalyticsEvent: createAnalyticsEvent
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fIJEx.IntlErrorBoundary), null, /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$export$88530751e3977073, {
                ...props,
                createAnalyticsEvent: createAnalyticsEvent
            })));
        }
    })));
const $3de1eca32602d427$var$RendererWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>{
    const { allowColumnSorting: allowColumnSorting, allowNestedHeaderLinks: allowNestedHeaderLinks, innerRef: innerRef, appearance: appearance, children: children, onClick: onClick, onMouseDown: onMouseDown, useBlockRenderForCodeBlock: useBlockRenderForCodeBlock, addTelepointer: addTelepointer, ssr: ssr, isInsideOfInlineExtension: isInsideOfInlineExtension, allowTableResizing: allowTableResizing, isTopLevelRenderer: isTopLevelRenderer } = props;
    const createTelepointer = ()=>{
        const telepointer = document.createElement('span');
        telepointer.textContent = '\u200b';
        telepointer.id = (0, $19a4579e32968c00$export$74b525449cc7cbd1);
        return telepointer;
    };
    const initialUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(true);
    (0, $5uXOq.useEffect)(()=>{
        // We must check if window is defined, if it isn't we are in a SSR environment
        // and we don't want to add the telepointer
        if (typeof window !== 'undefined' && addTelepointer && innerRef?.current) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const renderer = innerRef.current.querySelector('.ak-renderer-document');
            if (initialUpdate.current) {
                const lastChild = renderer.lastChild;
                lastChild && lastChild.appendChild(createTelepointer());
            }
            const mutateTelepointer = (mutations)=>{
                mutations.forEach((mutation)=>{
                    if (initialUpdate.current) {
                        const oldTelepointer = renderer.querySelector(`#${(0, $19a4579e32968c00$export$74b525449cc7cbd1)}`);
                        if (oldTelepointer) oldTelepointer.remove();
                        const lastChild = renderer.lastChild;
                        lastChild && lastChild.appendChild(createTelepointer());
                        initialUpdate.current = false;
                    }
                    if (mutation.type === 'characterData') {
                        const parentNode = mutation.target.parentElement;
                        if (parentNode) {
                            const oldTelepointer = renderer.querySelector(`#${(0, $19a4579e32968c00$export$74b525449cc7cbd1)}`);
                            if (oldTelepointer) oldTelepointer.remove();
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            parentNode.appendChild(createTelepointer());
                        }
                    }
                });
            };
            const observer = new MutationObserver(mutateTelepointer);
            observer.observe(innerRef.current, {
                characterData: true,
                attributes: false,
                childList: true,
                subtree: true
            });
            return ()=>observer.disconnect();
        }
    }, [
        innerRef,
        addTelepointer
    ]);
    const renderer = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4ceoy.WidthProvider), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `ak-renderer-wrapper is-${appearance}`,
        "data-appearance": appearance,
        shouldCheckExistingValue: isInsideOfInlineExtension
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9Iju4.BaseTheme), {
        baseFontSize: (0, $aagOn.getBaseFontSize)(appearance)
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1urn6.EditorMediaClientProvider), {
        ssr: ssr
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $glOdv.RendererStyleContainer), {
        innerRef: innerRef,
        onClick: onClick,
        onMouseDown: onMouseDown,
        appearance: appearance,
        allowNestedHeaderLinks: allowNestedHeaderLinks,
        allowColumnSorting: !!allowColumnSorting,
        useBlockRenderForCodeBlock: useBlockRenderForCodeBlock,
        allowAnnotations: props.allowAnnotations,
        allowTableResizing: allowTableResizing
    }, children))));
    // We can only make the wrapper div query container when we have a known width.
    // This is also required for SSR to work correctly. As WidthProvider/WithConsumer will not have the correct width during SSR.
    //
    // We are setting this wrapper div as query container conditionally.
    // Only apply container-type = inline-size when having a known width in full-page/full-width/comment mode.
    // Otherwise when appearance is unspecified the renderer size is decided by the content.
    // In this case we can't set the container-type = inline-size as it will collapse width to 0.
    return (appearance === 'full-page' || appearance === 'full-width' || appearance === 'comment') && // In case of having excerpt-include on page there are multiple renderers nested.
    // Make sure only the root renderer is set to be query container.
    isTopLevelRenderer && (0, $VSDnB.fg)('platform-ssr-table-resize') ? /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $3de1eca32602d427$var$setAsQueryContainerStyles
    }, renderer) : renderer;
});
const $3de1eca32602d427$var$RootRendererContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(null);
function $3de1eca32602d427$var$RendererActionsInternalUpdater({ children: children, doc: doc, schema: schema, onAnalyticsEvent: onAnalyticsEvent }) {
    const rootRendererContextValue = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($3de1eca32602d427$var$RootRendererContext);
    const actions = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    const rendererRef = (0, $5uXOq.useRef)(null);
    // This doc is used by the renderer actions when applying comments to the document.
    // (via hand crafted steps based on non prosemirror based position calculations)
    // It is set to the root renderer's doc as otherwise the resulting document will
    // be incorrect (nested renderers use a fake document which represents a subset
    // of the actual document).
    let _doc;
    if ((0, $gmhCD.editorExperiment)('comment_on_bodied_extensions', true) && rootRendererContextValue) // If rootRendererContextValue is set -- we are inside a nested renderer
    // and should always use the doc from the root renderer
    _doc = rootRendererContextValue.doc;
    else // If rootRendererContextValue is not set -- we are in the root renderer
    // and set the doc to the current doc.
    _doc = doc;
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (_doc) actions._privateRegisterRenderer(rendererRef, _doc, schema, onAnalyticsEvent);
        else actions._privateUnregisterRenderer();
        return ()=>actions._privateUnregisterRenderer();
    }, [
        actions,
        schema,
        _doc,
        onAnalyticsEvent
    ]);
    if ((0, $gmhCD.editorExperiment)('comment_on_bodied_extensions', true)) return /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$var$RootRendererContext.Provider, {
        value: {
            doc: _doc
        }
    }, children);
    return children;
}
// Usage notes:
// Used by Confluence for nested renderers
// For the View page renderer - see RendererWithAnalytics
const $3de1eca32602d427$var$RendererWithAnnotationSelection = (props)=>{
    const { allowAnnotations: allowAnnotations, document: adfDocument } = props;
    const localRef = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(null);
    const innerRef = props.innerRef || localRef;
    if (!allowAnnotations) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$export$af81ffb59b6ef0dd, {
        innerRef: innerRef,
        ...props
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fCNtA.RendererActionsContext), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4YrGg.AnnotationsWrapper), {
        rendererRef: innerRef,
        adfDocument: adfDocument,
        annotationProvider: props.annotationProvider,
        isNestedRender: true
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$export$af81ffb59b6ef0dd, {
        innerRef: innerRef,
        ...props,
        featureFlags: props.featureFlags
    })));
};
var // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/* @deprecated using this version of the renderer causes the RendererActions to inaccessible from any consumers */ $3de1eca32602d427$export$2e2bcd8739ae039 = $3de1eca32602d427$var$RendererWithAnnotationSelection;

});
parcelRegister("dGzaM", function(module, exports) {

$parcel$export(module.exports, "default", () => $586c606cb83743fd$export$2e2bcd8739ae039);
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $586c606cb83743fd$var$isUndefined(x) {
    return x === undefined;
}
class $586c606cb83743fd$export$2e2bcd8739ae039 {
    static create(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    providers) {
        const providerFactory = new $586c606cb83743fd$export$2e2bcd8739ae039();
        const keys = Object.keys(providers);
        keys.forEach((name)=>{
            providerFactory.setProvider(name, providers[name]);
        });
        return providerFactory;
    }
    destroy() {
        this.providers.clear();
        this.subscribers.clear();
    }
    isEmpty() {
        return !this.providers.size && !this.subscribers.size;
    }
    setProvider(name, provider) {
        // Do not trigger notifyUpdate if provider is the same.
        if (this.providers.get(name) === provider) return;
        if (!$586c606cb83743fd$var$isUndefined(provider)) this.providers.set(name, provider);
        else this.providers.delete(name);
        this.notifyUpdated(name, provider);
    }
    removeProvider(name) {
        this.providers.delete(name);
        this.notifyUpdated(name);
    }
    subscribe(name, handler) {
        const handlers = this.subscribers.get(name) || [];
        handlers.push(handler);
        this.subscribers.set(name, handlers);
        const provider = this.providers.get(name);
        if (provider) handler(name, provider);
        return provider;
    }
    unsubscribe(name, handler) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        const index = handlers.indexOf(handler);
        if (index !== -1) handlers.splice(index, 1);
        if (handlers.length === 0) this.subscribers.delete(name);
        else this.subscribers.set(name, handlers);
    }
    unsubscribeAll(name) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        this.subscribers.delete(name);
    }
    hasProvider(name) {
        return this.providers.has(name);
    }
    notifyUpdated(name, provider) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        handlers.forEach((handler)=>{
            handler(name, provider);
        });
    }
    constructor(){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.providers = new Map();
        this.subscribers = new Map();
    }
}

});

parcelRegister("9S8fM", function(module, exports) {

$parcel$export(module.exports, "ProviderFactoryProvider", () => $d1ee541d73df1fcd$export$617c134b25cc4265);
$parcel$export(module.exports, "useProvider", () => $d1ee541d73df1fcd$export$693cdb10cec23617);
$parcel$export(module.exports, "useProviderLayout", () => $d1ee541d73df1fcd$export$6fde1d0d81db98e1);

var $5uXOq = parcelRequire("5uXOq");

var $dGzaM = parcelRequire("dGzaM");
const $d1ee541d73df1fcd$var$ProviderFactoryContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(new (0, $dGzaM.default)());
const $d1ee541d73df1fcd$export$617c134b25cc4265 = $d1ee541d73df1fcd$var$ProviderFactoryContext.Provider;
const $d1ee541d73df1fcd$export$a3af4b6980aa23b5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($d1ee541d73df1fcd$var$ProviderFactoryContext);
const $d1ee541d73df1fcd$export$693cdb10cec23617 = (name)=>{
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState();
    const providerFactory = $d1ee541d73df1fcd$export$a3af4b6980aa23b5();
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        const providerHandler = (_, provider)=>{
            setProvider(provider);
        };
        providerFactory.subscribe(name, providerHandler);
        return ()=>{
            providerFactory.unsubscribe(name, providerHandler);
        };
    }, [
        name,
        providerFactory
    ]);
    return provider;
};
const $d1ee541d73df1fcd$export$6fde1d0d81db98e1 = (name)=>{
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState();
    const providerFactory = $d1ee541d73df1fcd$export$a3af4b6980aa23b5();
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useLayoutEffect(()=>{
        const providerHandler = (_, provider)=>{
            setProvider(provider);
        };
        providerFactory.subscribe(name, providerHandler);
        return ()=>{
            providerFactory.unsubscribe(name, providerHandler);
        };
    }, [
        name,
        providerFactory
    ]);
    return provider;
};

});

parcelRegister("9Iju4", function(module, exports) {

$parcel$export(module.exports, "mapBreakpointToLayoutMaxWidth", () => $b0fd15d81ba0fb5a$export$b5ccf4d25d2c5af1);
$parcel$export(module.exports, "BaseTheme", () => $b0fd15d81ba0fb5a$export$a1a213d350ca51ca);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $g0wej = parcelRequire("g0wej");

var $iHYdz = parcelRequire("iHYdz");

var $4ceoy = parcelRequire("4ceoy");
function $b0fd15d81ba0fb5a$export$b5ccf4d25d2c5af1(breakpoint) {
    switch(breakpoint){
        case 'M':
        case 'L':
            return 760;
        default:
            return 680;
    }
}
function $b0fd15d81ba0fb5a$export$3de34996b814f0f0({ baseFontSize: baseFontSize, children: children }) {
    const memoizedTheme = (0, $5uXOq.useMemo)(()=>({
            baseFontSize: baseFontSize || 14,
            layoutMaxWidth: (0, $iHYdz.akEditorDefaultLayoutWidth)
        }), [
        baseFontSize
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $g0wej.a), {
        theme: memoizedTheme,
        children: children
    });
}
function $b0fd15d81ba0fb5a$export$a1a213d350ca51ca({ children: children, baseFontSize: baseFontSize }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4ceoy.WidthConsumer), {
        children: ({ breakpoint: breakpoint })=>/*#__PURE__*/ (0, $2OMIu.jsx)($b0fd15d81ba0fb5a$export$3de34996b814f0f0, {
                breakpoint: breakpoint,
                baseFontSize: baseFontSize,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                    children: children
                })
            })
    });
}

});
parcelRegister("iHYdz", function(module, exports) {

$parcel$export(module.exports, "akEditorFullPageDefaultFontSize", () => $01f0a5ace820da37$export$fe6b0b821a0e9067);
$parcel$export(module.exports, "akEditorCodeFontFamily", () => $01f0a5ace820da37$export$9a7c520c39e1f0aa);
$parcel$export(module.exports, "akEditorSubtleAccent", () => $01f0a5ace820da37$export$1d762aef048d30f9);
$parcel$export(module.exports, "akEditorBlockquoteBorderColor", () => $01f0a5ace820da37$export$a7a75e50ae62d0a8);
$parcel$export(module.exports, "akEditorDeleteBackground", () => $01f0a5ace820da37$export$ef95eb6ef0fd0a4a);
$parcel$export(module.exports, "akEditorDeleteBackgroundWithOpacity", () => $01f0a5ace820da37$export$8f7d2d784079e274);
$parcel$export(module.exports, "akEditorDeleteBorder", () => $01f0a5ace820da37$export$3c108a6bc41bb5f2);
$parcel$export(module.exports, "akEditorDeleteIconColor", () => $01f0a5ace820da37$export$bf3aaa2106c119fd);
$parcel$export(module.exports, "akEditorCustomIconSize", () => $01f0a5ace820da37$export$d2715266dd4a1fd1);
$parcel$export(module.exports, "akEditorSelectedBorderColor", () => $01f0a5ace820da37$export$cf524c1b49838a49);
$parcel$export(module.exports, "akEditorSelectedBorderSize", () => $01f0a5ace820da37$export$8dac549e32469ac4);
$parcel$export(module.exports, "akEditorSelectedBorderBoldSize", () => $01f0a5ace820da37$export$befaaae517e3d864);
$parcel$export(module.exports, "akEditorSelectedBorder", () => $01f0a5ace820da37$export$6e1e1996c4e8cc51);
$parcel$export(module.exports, "akEditorSelectedBoxShadow", () => $01f0a5ace820da37$export$b6a59ac3a19b6343);
$parcel$export(module.exports, "akEditorSelectedBoldBoxShadow", () => $01f0a5ace820da37$export$37e178ca41c198ca);
$parcel$export(module.exports, "akEditorUnitZIndex", () => $01f0a5ace820da37$export$f35cc48f3398ab79);
$parcel$export(module.exports, "akEditorShadowZIndex", () => $01f0a5ace820da37$export$b46cda584c619451);
$parcel$export(module.exports, "akEditorStickyHeaderZIndex", () => $01f0a5ace820da37$export$6bed85de54b5de42);
$parcel$export(module.exports, "akEditorSmallZIndex", () => $01f0a5ace820da37$export$321ddd2f049dd12);
$parcel$export(module.exports, "akEditorGridLineZIndex", () => $01f0a5ace820da37$export$daeac9b8422ac3c2);
$parcel$export(module.exports, "akEditorMenuZIndex", () => $01f0a5ace820da37$export$501d46e11ed5bf73);
$parcel$export(module.exports, "akEditorFloatingPanelZIndex", () => $01f0a5ace820da37$export$6817b4b6a5ef78f1);
$parcel$export(module.exports, "akEditorFloatingDialogZIndex", () => $01f0a5ace820da37$export$93768eb72dec48ce);
$parcel$export(module.exports, "akEditorTableCellOnStickyHeaderZIndex", () => $01f0a5ace820da37$export$c0aec4e0896849a0);
$parcel$export(module.exports, "akEditorFloatingOverlapPanelZIndex", () => $01f0a5ace820da37$export$5886f057e4f21fe4);
$parcel$export(module.exports, "akEditorTableToolbarSize", () => $01f0a5ace820da37$export$6e85faa46d537a3f);
$parcel$export(module.exports, "akEditorTableBorder", () => $01f0a5ace820da37$export$36ba77fba4a62d5f);
$parcel$export(module.exports, "akEditorTableToolbar", () => $01f0a5ace820da37$export$640eef769748f78f);
$parcel$export(module.exports, "akEditorTableHeaderCellBackground", () => $01f0a5ace820da37$export$4c6f61fb4b9ae93);
$parcel$export(module.exports, "akEditorTableBorderSelected", () => $01f0a5ace820da37$export$f7bbcec54ff5bc47);
$parcel$export(module.exports, "akEditorFullPageMaxWidth", () => $01f0a5ace820da37$export$fad19f16d3f953a3);
$parcel$export(module.exports, "akEditorDefaultLayoutWidth", () => $01f0a5ace820da37$export$9db045950eedb49f);
$parcel$export(module.exports, "akEditorWideLayoutWidth", () => $01f0a5ace820da37$export$74c442132af16a);
$parcel$export(module.exports, "akEditorFullWidthLayoutWidth", () => $01f0a5ace820da37$export$f580e3d28d0986de);
$parcel$export(module.exports, "akEditorTableNumberColumnWidth", () => $01f0a5ace820da37$export$37df10057d36a0e5);
$parcel$export(module.exports, "akEditorBreakoutPadding", () => $01f0a5ace820da37$export$437293c5e9fc2703);
$parcel$export(module.exports, "akEditorGutterPadding", () => $01f0a5ace820da37$export$6e0f4d52efd3d2d);
$parcel$export(module.exports, "akEditorGutterPaddingDynamic", () => $01f0a5ace820da37$export$f222e0c7a2dc5324);
$parcel$export(module.exports, "akEditorMobileBreakoutPoint", () => $01f0a5ace820da37$export$efe8561bbd3f74d2);
$parcel$export(module.exports, "akEditorTableCellMinWidth", () => $01f0a5ace820da37$export$e4d39a9e8607c1d3);
$parcel$export(module.exports, "akEditorTableLegacyCellMinWidth", () => $01f0a5ace820da37$export$43946f2400ab6f1f);
$parcel$export(module.exports, "akEditorMediaResizeHandlerPaddingWide", () => $01f0a5ace820da37$export$558438ae7fd4b8ce);
$parcel$export(module.exports, "akEditorMediaResizeHandlerPadding", () => $01f0a5ace820da37$export$6beb98d32d4ca149);
$parcel$export(module.exports, "akEditorSwoopCubicBezier", () => $01f0a5ace820da37$export$3b24948cd5dbb087);
$parcel$export(module.exports, "gridMediumMaxWidth", () => $01f0a5ace820da37$export$5edb4f38c3eacb1a);
$parcel$export(module.exports, "breakoutWideScaleRatio", () => $01f0a5ace820da37$export$e60820063058ed59);
$parcel$export(module.exports, "akEditorCalculatedWideLayoutWidthSmallViewport", () => $01f0a5ace820da37$export$60da500206e2ceec);
$parcel$export(module.exports, "akEditorCalculatedWideLayoutWidth", () => $01f0a5ace820da37$export$c0e6648ae1bb2fac);
$parcel$export(module.exports, "akRichMediaResizeZIndex", () => $01f0a5ace820da37$export$fb15fade89f67217);
$parcel$export(module.exports, "akLayoutGutterOffset", () => $01f0a5ace820da37$export$847030921e9d5a40);
$parcel$export(module.exports, "akEditorLineHeight", () => $01f0a5ace820da37$export$40eb41ab799f0329);
$parcel$export(module.exports, "akEditorToolbarKeylineHeight", () => $01f0a5ace820da37$export$d29cb2c31fcbb7c5);
$parcel$export(module.exports, "akEditorContextPanelWidth", () => $01f0a5ace820da37$export$688a6dc01e760755);
$parcel$export(module.exports, "akEditorTableCellBlanketSelected", () => $01f0a5ace820da37$export$e736f2caf3b39eb3);
$parcel$export(module.exports, "akEditorTableCellBlanketDeleted", () => $01f0a5ace820da37$export$de3cef07cda55645);
$parcel$export(module.exports, "akEditorWrappedNodeZIndex", () => $01f0a5ace820da37$export$e88f6c898960b391);
$parcel$export(module.exports, "blockNodesVerticalMargin", () => $01f0a5ace820da37$export$1d0d506416d457f1);
$parcel$export(module.exports, "DEFAULT_EMBED_CARD_WIDTH", () => $01f0a5ace820da37$export$e683ef42725d1713);
$parcel$export(module.exports, "DEFAULT_EMBED_CARD_HEIGHT", () => $01f0a5ace820da37$export$226c784ba04bd04b);
$parcel$export(module.exports, "MAX_BROWSER_SCROLLBAR_HEIGHT", () => $01f0a5ace820da37$export$214ff00e5618d86c);
$parcel$export(module.exports, "FULL_PAGE_EDITOR_TOOLBAR_HEIGHT", () => $01f0a5ace820da37$export$d7726a000ae2d7c);
$parcel$export(module.exports, "akEditorSelectedNodeClassName", () => $01f0a5ace820da37$export$a02a3f1515c2e21a);
$parcel$export(module.exports, "editorFontSize", () => $01f0a5ace820da37$export$58a725ff69bda73a);
$parcel$export(module.exports, "relativeFontSizeToBase16", () => $01f0a5ace820da37$export$59733a9f61449b25);
$parcel$export(module.exports, "VIEWPORT_SIZES", () => $01f0a5ace820da37$export$96b72b7f243fa693);
$parcel$export(module.exports, "akEditorMobileMaxWidth", () => $01f0a5ace820da37$export$9369fd010fa0ddd6);
$parcel$export(module.exports, "participantColors", () => $01f0a5ace820da37$export$42608c013398a830);

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");
const $01f0a5ace820da37$export$fe6b0b821a0e9067 = 16;
const $01f0a5ace820da37$export$9a7c520c39e1f0aa = "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)";
const $01f0a5ace820da37$export$1d762aef048d30f9 = "var(--ds-background-accent-gray-subtler, #DCDFE4)";
const $01f0a5ace820da37$export$a7a75e50ae62d0a8 = "var(--ds-border, #091E4224)";
const $01f0a5ace820da37$export$b9864494c2608629 = "var(--ds-background-accent-gray-subtlest, #F1F2F4)";
const $01f0a5ace820da37$export$f0e953d95429ca1 = '12px';
const $01f0a5ace820da37$export$a309dbdeca0adb1a = '2px 4px';
const $01f0a5ace820da37$export$ef95eb6ef0fd0a4a = "var(--ds-background-danger, #FFECEB)";
const $01f0a5ace820da37$export$8f7d2d784079e274 = 'rgba(255, 189, 173, 0.5)'; // R75 with 50% opacity
const $01f0a5ace820da37$export$3c108a6bc41bb5f2 = "var(--ds-border-danger, #E2483D)";
const $01f0a5ace820da37$export$bf3aaa2106c119fd = "var(--ds-icon-danger, #C9372C)";
const $01f0a5ace820da37$export$d2715266dd4a1fd1 = 20;
const $01f0a5ace820da37$export$cf524c1b49838a49 = "var(--ds-border-selected, #0C66E4)";
const $01f0a5ace820da37$export$8dac549e32469ac4 = 1;
const $01f0a5ace820da37$export$befaaae517e3d864 = 2;
const $01f0a5ace820da37$export$6e1e1996c4e8cc51 = `${$01f0a5ace820da37$export$8dac549e32469ac4}px solid ${"var(--ds-border-selected, #0C66E4)"}`;
const $01f0a5ace820da37$export$b6a59ac3a19b6343 = `0 0 0 ${$01f0a5ace820da37$export$8dac549e32469ac4}px ${"var(--ds-border-selected, #0C66E4)"}`;
const $01f0a5ace820da37$export$37e178ca41c198ca = `0 0 0 ${$01f0a5ace820da37$export$befaaae517e3d864}px ${"var(--ds-border-selected, #0C66E4)"}`;
const $01f0a5ace820da37$export$4a007c22e25e31f6 = 0.3;
const $01f0a5ace820da37$export$f35cc48f3398ab79 = 1;
const $01f0a5ace820da37$export$b46cda584c619451 = 2;
const $01f0a5ace820da37$export$6bed85de54b5de42 = 11; // filmstrip uses 10 for its shadow
const $01f0a5ace820da37$export$321ddd2f049dd12 = $01f0a5ace820da37$export$6bed85de54b5de42 + 1;
const $01f0a5ace820da37$export$daeac9b8422ac3c2 = 2;
const $01f0a5ace820da37$export$501d46e11ed5bf73 = 500;
const $01f0a5ace820da37$export$6817b4b6a5ef78f1 = 400;
const $01f0a5ace820da37$export$93768eb72dec48ce = $01f0a5ace820da37$export$501d46e11ed5bf73 + 10;
const $01f0a5ace820da37$export$c0aec4e0896849a0 = $01f0a5ace820da37$export$93768eb72dec48ce - 5;
const $01f0a5ace820da37$export$5886f057e4f21fe4 = $01f0a5ace820da37$export$6817b4b6a5ef78f1 + 5;
const $01f0a5ace820da37$export$6e85faa46d537a3f = 11;
const $01f0a5ace820da37$export$36ba77fba4a62d5f = "var(--ds-background-accent-gray-subtler, #DCDFE4)";
const $01f0a5ace820da37$export$640eef769748f78f = "var(--ds-background-accent-gray-subtlest, #F1F2F4)";
const $01f0a5ace820da37$export$4c6f61fb4b9ae93 = '#F1F2F4';
const $01f0a5ace820da37$export$95e9a0285b97474d = '#2C333A';
const $01f0a5ace820da37$export$f7bbcec54ff5bc47 = "var(--ds-border-focused, #388BFF)";
const $01f0a5ace820da37$export$76b5e653883e5290 = '3px';
const $01f0a5ace820da37$export$6d85fe8177a50c0c = 0.5;
const $01f0a5ace820da37$export$fad19f16d3f953a3 = 680;
const $01f0a5ace820da37$export$9db045950eedb49f = 760;
const $01f0a5ace820da37$export$74c442132af16a = 960; // This value is used for tables with breakouts and is used to calculate `breakoutWidthPx`
const $01f0a5ace820da37$export$f580e3d28d0986de = 1800;
const $01f0a5ace820da37$export$9d5488b5afad62bf = 1792;
const $01f0a5ace820da37$export$37df10057d36a0e5 = 42;
const $01f0a5ace820da37$export$437293c5e9fc2703 = 96;
const $01f0a5ace820da37$export$6e0f4d52efd3d2d = 32;
const $01f0a5ace820da37$export$f222e0c7a2dc5324 = ()=>// eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $VSDnB.fg)('platform_editor_controls_increase_full_page_gutter') && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') ? 72 : 52;
const $01f0a5ace820da37$export$efe8561bbd3f74d2 = 720;
const $01f0a5ace820da37$export$e4d39a9e8607c1d3 = 48;
const $01f0a5ace820da37$export$43946f2400ab6f1f = 128;
const $01f0a5ace820da37$export$558438ae7fd4b8ce = 12;
const $01f0a5ace820da37$export$6beb98d32d4ca149 = 4;
const $01f0a5ace820da37$export$3b24948cd5dbb087 = `cubic-bezier(0.15, 1, 0.3, 1)`;
const $01f0a5ace820da37$export$5edb4f38c3eacb1a = 1024;
const $01f0a5ace820da37$export$e60820063058ed59 = 1.33;
const $01f0a5ace820da37$export$60da500206e2ceec = 905; // from breakoutConsts.calcWideWidth, layoutMaxWidth * breakoutConsts.wideScaleRatio = 904.8 ~ 905 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is <= 1266px.
const $01f0a5ace820da37$export$c0e6648ae1bb2fac = 1011; // = akEditorDefaultLayoutWidth * breakoutWideScaleRatio = 1010.8 ~ 1011 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is > 1329px.
const $01f0a5ace820da37$export$fb15fade89f67217 = $01f0a5ace820da37$export$f35cc48f3398ab79 * 99;
const $01f0a5ace820da37$export$847030921e9d5a40 = 12;
const $01f0a5ace820da37$export$40eb41ab799f0329 = 1.714;
const $01f0a5ace820da37$export$e271312fc7124aec = '1px';
const $01f0a5ace820da37$export$d29cb2c31fcbb7c5 = 2;
const $01f0a5ace820da37$export$688a6dc01e760755 = 320;
const $01f0a5ace820da37$export$e736f2caf3b39eb3 = 'rgba(179, 212, 255, 0.3)';
const $01f0a5ace820da37$export$de3cef07cda55645 = 'rgba(255, 235, 230, 0.3)';
const $01f0a5ace820da37$export$e88f6c898960b391 = $01f0a5ace820da37$export$f35cc48f3398ab79 * 2; //prevent paragraph nodes from rendering above wrapped nodes
const $01f0a5ace820da37$export$e5c605f2b2a12b00 = {
    SMALL: 550,
    MEDIUM: 760
};
const $01f0a5ace820da37$export$1d0d506416d457f1 = '0.75rem';
const $01f0a5ace820da37$export$e683ef42725d1713 = 680;
const $01f0a5ace820da37$export$226c784ba04bd04b = 480;
const $01f0a5ace820da37$export$214ff00e5618d86c = 20;
const $01f0a5ace820da37$export$c82675fa56f2eefd = '56px';
const $01f0a5ace820da37$var$DEFAULT_FONT_SIZE = 14;
const $01f0a5ace820da37$export$d7726a000ae2d7c = ()=>{
    if ((0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1', {
        exposure: true
    })) return "var(--ds-space-500, 40px)";
    if ((0, $VSDnB.fg)('live_pages_content_jump_mitigation')) return '2.188rem';
    return "var(--ds-space-500, 40px)";
};
const $01f0a5ace820da37$export$a02a3f1515c2e21a = 'ak-editor-selected-node';
const $01f0a5ace820da37$export$58a725ff69bda73a = ({ theme: theme })=>theme && theme.baseFontSize ? theme.baseFontSize : $01f0a5ace820da37$var$DEFAULT_FONT_SIZE;
const $01f0a5ace820da37$export$945a9e125632354d = (multiplier)=>({ theme: theme })=>$01f0a5ace820da37$export$58a725ff69bda73a({
            theme: theme
        }) * multiplier;
const $01f0a5ace820da37$export$59733a9f61449b25 = (px)=>{
    if (typeof px === 'string') px = parseInt(px);
    if (isNaN(px)) throw new Error(`Invalid font size: '${px}'`);
    return `${px / 16}rem`;
};
const $01f0a5ace820da37$export$96b72b7f243fa693 = {
    laptopHiDPI: {
        width: 1440,
        height: 900
    },
    laptopMDPI: {
        width: 1280,
        height: 800
    },
    tabletL: {
        width: 1024,
        height: 1366
    },
    tabletS: {
        width: 768,
        height: 1024
    },
    mobileM: {
        width: 414,
        height: 736
    },
    mobileS: {
        width: 375,
        height: 667
    },
    mobileXS: {
        width: 320,
        height: 568
    }
};
const $01f0a5ace820da37$export$9369fd010fa0ddd6 = 0;
const $01f0a5ace820da37$export$846a716e9e69a8df = [
    [
        'White',
        '#000000'
    ],
    [
        'Light blue',
        '#0C294F'
    ],
    [
        'Light teal',
        '#0C343B'
    ],
    [
        'Light green',
        '#052E21'
    ],
    [
        'Light yellow',
        '#484123'
    ],
    [
        'Light red',
        '#441C13'
    ],
    [
        'Light purple',
        '#282249'
    ],
    [
        'Light gray',
        '#202328'
    ],
    [
        'Blue',
        '#0B3165'
    ],
    [
        'Teal',
        '#044853'
    ],
    [
        'Green',
        '#053927'
    ],
    [
        'Yellow',
        '#6F5C25'
    ],
    [
        'Red',
        '#582013'
    ],
    [
        'Purple',
        '#3E327B'
    ],
    [
        'Gray',
        '#475262'
    ],
    [
        'Dark blue',
        '#003884'
    ],
    [
        'Dark teal',
        '#055866'
    ],
    [
        'Dark green',
        '#044932'
    ],
    [
        'Dark yellow',
        '#82641C'
    ],
    [
        'Dark red',
        '#6B2A19'
    ],
    [
        'Dark purple',
        '#4D38B2'
    ]
].map(([colorName, colorValue])=>$01f0a5ace820da37$export$5f2dade43b841301(colorName, colorValue)).join('\n');
function $01f0a5ace820da37$export$5f2dade43b841301(colorName, colorValue) {
    return `
  &[colorname="${colorName}"] {
    background-color: ${colorValue} !important; // !important to override default style color
  }
  `;
}
const $01f0a5ace820da37$export$312e1e71424c4aa1 = [
    "var(--ds-icon-accent-red, #C9372C)",
    "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    "var(--ds-icon-accent-magenta, #CD519D)",
    "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "var(--ds-icon-accent-orange, #E56910)",
    "var(--ds-background-accent-orange-bolder-hovered, #A54800)",
    "var(--ds-icon-accent-green, #22A06B)",
    "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    "var(--ds-icon-accent-blue, #1D7AFC)",
    "var(--ds-background-accent-blue-bolder-hovered, #0055CC)",
    "var(--ds-icon-accent-teal, #2898BD)",
    "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    "var(--ds-icon-accent-lime, #6A9A23)",
    "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    "var(--ds-icon-accent-purple, #8270DB)",
    "var(--ds-background-accent-purple-bolder-hovered, #5E4DB2)",
    "var(--ds-icon-accent-gray, #758195)",
    "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
    "var(--ds-icon-accent-yellow, #B38600)",
    "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    "var(--ds-background-accent-yellow-bolder-pressed, #533F04)"
];
const $01f0a5ace820da37$export$42608c013398a830 = [
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-blue-bolder, #0C66E4)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-yellow-bolder, #946F00)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-purple-bolder, #6E5DC6)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-magenta-bolder, #AE4787)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-teal-bolder, #227D9B)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-orange-bolder, #C25100)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-lime-bolder, #5B7F24)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-gray-bolder, #626F86)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-blue-subtle, #579DFF)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-orange-subtle, #FEA362)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-yellow-subtle, #F5CD47)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-purple-subtle, #9F8FEF)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-magenta-subtle, #E774BB)"
    }
];

});
parcelRegister("gmhCD", function(module, exports) {

$parcel$export(module.exports, "editorExperiment", () => $a90e6fd79e0e0cb2$export$9b7cf3b74f250027);
$parcel$export(module.exports, "unstable_editorExperimentParam", () => $a90e6fd79e0e0cb2$export$92316ae898e357eb);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $iEN9D = parcelRequire("iEN9D");

var $hdkTE = parcelRequire("hdkTE");

var $a0Psj = parcelRequire("a0Psj");
function $a90e6fd79e0e0cb2$export$9b7cf3b74f250027(experimentName, expectedExperimentValue, options = {
    exposure: false
}) {
    const experimentConfig = (0, $hdkTE.editorExperimentsConfig)[experimentName];
    if ((0, $a0Psj._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $a0Psj._overrides)[experimentName] === expectedExperimentValue;
    if (experimentConfig === undefined) // Warning! If a product is improperly configured (ie. their editor packages are misaligned)
    // it can cause the editor to crash here or if the experiment does not exist.
    // We will definitely crash via any code path later in this function - this just makes the error explicit and clear.
    throw new Error(`Editor experiment configuration is not defined ${experimentName}. Likely the experiment does not exist or editor package versions are misaligned`);
    if (!(0, $a0Psj._product)) // This will be hit in the case of a product not having setup the editor experiment tooling
    return experimentConfig.defaultValue === expectedExperimentValue;
    // Typescript is complaining here about accessing the productKeys property
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const experimentKey = experimentConfig?.productKeys?.[0, $a0Psj._product];
    if (!experimentKey) // This will be hit in the case of an experiment not being set up for the product
    return (0, $hdkTE.editorExperimentsConfig)[experimentName]?.defaultValue === expectedExperimentValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $iEN9D.default).getExperimentValue(// @ts-ignore
    experimentKey, experimentConfig.param, experimentConfig.defaultValue, {
        typeGuard: experimentConfig.typeGuard,
        fireExperimentExposure: options.exposure
    });
    return expectedExperimentValue === experimentValue;
}
function $a90e6fd79e0e0cb2$export$92316ae898e357eb(experimentName, paramName, options) {
    if ((0, $a0Psj._paramOverrides)[experimentName]?.[paramName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $a0Psj._paramOverrides)[experimentName][paramName];
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $iEN9D.default).getExperimentValue(experimentName, paramName, options.defaultValue, {
        typeGuard: options.typeGuard,
        fireExperimentExposure: options.exposure ?? false
    });
    return experimentValue;
}

});
parcelRegister("hdkTE", function(module, exports) {

$parcel$export(module.exports, "editorExperimentsConfig", () => $7a273b3c03491c92$export$6cbb856f286b07ef);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $7rlXf = parcelRequire("7rlXf");
const $7a273b3c03491c92$export$6cbb856f286b07ef = {
    // Added 2025-05-27
    platform_editor_reduce_noisy_steps_ncs: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_reduce_noisy_steps_ncs'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-boolean': (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_boolean'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-multivariate': (0, $7rlXf.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_multivariate'
        },
        param: 'variant',
        values: [
            'one',
            'two',
            'three'
        ],
        defaultValue: 'one'
    }),
    // Added 2024-08-08
    'test-new-experiments-package': (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package',
            jira: 'jira_editor_experiment_test_new_package'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-05
    support_table_in_comment: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_support_table_in_comment_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-07
    platform_editor_exp_lazy_node_views: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_exp_lazy_node_views'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-18
    platform_renderer_table_sticky_scrollbar: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_table_sticky_scrollbar'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-28
    platform_editor_controls_performance_fixes: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls_performance_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-26
    platform_editor_prevent_toolbar_layout_shifts: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_prevent_toolbar_layout_shifts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-01
    comment_on_bodied_extensions: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_comment_on_bodied_extensions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-14
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_advanced_layouts/setup
    advanced_layouts: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_advanced_layouts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-3-15
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_single_column_layout/setup
    single_column_layouts: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_single_column_layout'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-08
    support_table_in_comment_jira: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_support_table_in_comment_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    'platform_editor_ai-prompts-placeholder': (0, $7rlXf.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai-prompts-placeholder'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // added 2024-11-06
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_nested_tables/setup
    'nested-tables-in-tables': (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nested_tables'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-11-26
    platform_editor_ai_unsplash_page_header: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_unsplash_page_header'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-12-05
    platform_editor_blockquote_in_text_formatting_menu: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blockquote_in_text_formatting_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-09
    platform_editor_advanced_code_blocks: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_advanced_code_blocks'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-13
    platform_editor_element_drag_and_drop_multiselect: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_element_drag_and_drop_multiselect'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-19
    platform_editor_ai_edit_response_in_preview: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_edit_response_in_preview'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-02-10
    platform_editor_controls: (0, $7rlXf.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 28-02-2025
    platform_editor_insertion: (0, $7rlXf.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_insertion'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-04-01
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_vanilla_dom/setup
    platform_editor_vanilla_dom: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_vanilla_dom'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-03-13
    editor_text_highlight_orange_to_yellow: (0, $7rlXf.createMultivariateExperiment)({
        productKeys: {
            confluence: 'editor_text_highlight_orange_to_yellow'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-03-28
    platform_editor_ai_proactive_ai_nudge_parameters: (0, $7rlXf.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_proactive_ai_nudge_parameters'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-04-14
    // https://switcheroo.atlassian.com/ui/gates/b159b45a-86d9-4f4b-b482-f9aca5b615d6/key/platform_editor_offline_editing_web
    platform_editor_offline_editing_web: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_offline_editing_web'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-14
    editor_ai_inline_suggestion_date_v2: (0, $7rlXf.createMultivariateExperiment)({
        productKeys: {
            confluence: 'editor_ai_inline_suggestion_date_v2'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-04-17
    platform_editor_tables_drag_and_drop: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_tables_drag_and_drop'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-17
    platform_editor_tables_table_selector: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_tables_table_selector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_editor_usesharedpluginstateselector: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_usesharedpluginstateselector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_renderer_fix_analytics_memo_callback: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_fix_analytics_memo_callback'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-05
    editor_ai_contextual_selection_toolbar_button: (0, $7rlXf.createMultivariateExperiment)({
        productKeys: {
            confluence: 'editor_ai_contextual_selection_toolbar_button'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-05-08
    editor_ai_converge_free_gen_on_rovo: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_ai_converge_free_gen_on_rovo'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-07
    editor_ai_cmd_palette_remove_retry: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_ai_cmd_palette_remove_retry'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-26
    platform_editor_stop_width_reflows: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_stop_width_reflows'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-08
    platform_editor_core_static_emotion: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_core_static_emotion'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-13
    editor_ai_comment_freegen_rovo: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_ai_comment_freegen_rovo'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-15
    confluence_p2m_style_recalc_and_expand_joint_exp: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_p2m_style_recalc_and_expand_joint_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-21
    platform_editor_nodevisibility: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nodevisibility'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-15
    platform_editor_breakout_resizing: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_resizing'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-30
    platform_editor_exp_disable_lnv: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_exp_disable_lnv'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-07
    platform_editor_ai_quickstart_command: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_quickstart_command'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-22
    editor_ai_in_editor_streaming: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_ai_in_editor_streaming'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_hide_floating_toolbar_in_ssr: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_hide_floating_toolbar_in_ssr'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_smart_card_open_overlay_perf: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_smart_card_open_overlay_perf'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-28
    platform_editor_toolbar_rerender_optimization_exp: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_rerender_optimization_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-30
    platform_editor_controls_toolbar_pinning_exp: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls_toolbar_pinning_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    })
};

});
parcelRegister("7rlXf", function(module, exports) {

$parcel$export(module.exports, "createBooleanExperiment", () => $641ded07329846f0$export$456f1587c9c92021);
$parcel$export(module.exports, "createMultivariateExperiment", () => $641ded07329846f0$export$fb89e8a786694d1);

var $9qwvi = parcelRequire("9qwvi");
function $641ded07329846f0$export$456f1587c9c92021(config) {
    return {
        ...config,
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: config.defaultValue
    };
}
function $641ded07329846f0$export$fb89e8a786694d1(config) {
    const { values: values } = config;
    return {
        ...config,
        values: [
            ...values
        ],
        typeGuard: (0, $9qwvi.oneOf)(config.values),
        defaultValue: config.defaultValue
    };
}

});
parcelRegister("9qwvi", function(module, exports) {

$parcel$export(module.exports, "isBoolean", () => $41035ee8947774ef$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "oneOf", () => $41035ee8947774ef$export$a9a18ae5ba42aeab);
function $41035ee8947774ef$export$f9ce7b637dfbe238(value) {
    return typeof value === 'boolean';
}
function $41035ee8947774ef$export$a9a18ae5ba42aeab(values) {
    function typeGuard(value) {
        return values.includes(value);
    }
    /**
	 * This is used by test utils to get the variants when running describe.each
	 */ if ($41035ee8947774ef$var$IS_TESTING_ENV) typeGuard.values = values;
    return typeGuard;
}
const $41035ee8947774ef$var$IS_TESTING_ENV = false;

});



parcelRegister("a0Psj", function(module, exports) {

$parcel$export(module.exports, "_overrides", () => $ae2371e90434836c$export$e5d73bf4f8e2ae96);
$parcel$export(module.exports, "_paramOverrides", () => $ae2371e90434836c$export$4e849416bb5c5b52);
$parcel$export(module.exports, "_product", () => $ae2371e90434836c$export$cf7305fc65acbf0d);
$parcel$export(module.exports, "setupEditorExperiments", () => $ae2371e90434836c$export$1c2b6dbf79eb3560);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $hdkTE = parcelRequire("hdkTE");
let $ae2371e90434836c$export$e5d73bf4f8e2ae96 = {};
let $ae2371e90434836c$export$4e849416bb5c5b52 = {};
let $ae2371e90434836c$export$cf7305fc65acbf0d;
function $ae2371e90434836c$export$1c2b6dbf79eb3560(product, /**
	 * Overrides are used to set the group of an experiment for testing purposes.
	 * This is useful when you want to test a specific experiment group.
	 */ groupOverrides, /**
	 * Param overrides are used to set the experiment parameters for testing purposes.
	 * This is useful when you want to tweak the experiment parameters for testing.
	 */ paramOverrides) {
    if (groupOverrides) {
        // When setting up overrides, we want to ensure that experiments don't end up with invalid
        // values.
        // For production usage -- this is done via the feature flag client which takes the type
        // and performs equivalent logic.
        // @ts-ignore
        groupOverrides = Object.entries(groupOverrides).reduce((acc, [key, value])=>{
            const config = (0, $hdkTE.editorExperimentsConfig)[key];
            if (config) acc = {
                ...acc,
                [key]: config.typeGuard(value) ? value : config.defaultValue
            };
            return acc;
        }, {});
        $ae2371e90434836c$export$e5d73bf4f8e2ae96 = groupOverrides;
    }
    $ae2371e90434836c$export$cf7305fc65acbf0d = product;
    if (paramOverrides) $ae2371e90434836c$export$4e849416bb5c5b52 = paramOverrides;
}

});



parcelRegister("4ceoy", function(module, exports) {

$parcel$export(module.exports, "getBreakpoint", () => $a2904bcfe480568e$export$1eb095b00b926404);
$parcel$export(module.exports, "createWidthContext", () => $a2904bcfe480568e$export$31a4966bffb9ac98);
$parcel$export(module.exports, "WidthContext", () => $a2904bcfe480568e$export$27e39f636459b9f);
$parcel$export(module.exports, "WidthConsumer", () => $a2904bcfe480568e$export$5d8538aa831b6ebb);
$parcel$export(module.exports, "WidthProvider", () => $a2904bcfe480568e$export$7921e18173e8c666);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8QpSo = parcelRequire("8QpSo");

var $7nRxN = parcelRequire("7nRxN");

var $gJlZe = parcelRequire("gJlZe");

var $1v3g5 = parcelRequire("1v3g5");
function $a2904bcfe480568e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a2904bcfe480568e$var$styles = {
    name: "pw7jst",
    styles: "position:relative;width:100%"
};
const $a2904bcfe480568e$var$SCROLLBAR_WIDTH = 30;
function $a2904bcfe480568e$export$1eb095b00b926404(width = 0) {
    const MAX_S = 1266;
    const MAX_M = 2146;
    if (width >= MAX_S && width < MAX_M) return 'M';
    else if (width >= MAX_M) return 'L';
    return 'S';
}
function $a2904bcfe480568e$export$31a4966bffb9ac98(width = 0) {
    return {
        width: width,
        breakpoint: $a2904bcfe480568e$export$1eb095b00b926404(width)
    };
}
const $a2904bcfe480568e$export$27e39f636459b9f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext($a2904bcfe480568e$export$31a4966bffb9ac98());
const { Provider: $a2904bcfe480568e$var$Provider, Consumer: $a2904bcfe480568e$export$5d8538aa831b6ebb } = $a2904bcfe480568e$export$27e39f636459b9f;
const $a2904bcfe480568e$export$df154c49e93b2ac2 = (0, $8QpSo.default)(()=>{
    return (0, $1v3g5.isSSR)() ? 0 : document.body?.offsetWidth ?? 0;
});
const $a2904bcfe480568e$export$7921e18173e8c666 = ({ className: className, shouldCheckExistingValue: shouldCheckExistingValue, children: children })=>{
    const existingContextValue = (0, $5uXOq.useContext)($a2904bcfe480568e$export$27e39f636459b9f);
    const [width, setWidth] = (0, $5uXOq.useState)($a2904bcfe480568e$export$df154c49e93b2ac2);
    const widthRef = (0, $5uXOq.useRef)(width);
    const isMountedRef = (0, $5uXOq.useRef)(true);
    const providerValue = (0, $5uXOq.useMemo)(()=>$a2904bcfe480568e$export$31a4966bffb9ac98(width), [
        width
    ]);
    const updateWidth = (0, $5uXOq.useMemo)(()=>{
        return (0, $7nRxN.default)((nextWidth)=>{
            const currentWidth = widthRef.current || 0;
            // Ignore changes that are less than SCROLLBAR_WIDTH, otherwise it can cause infinite re-scaling
            if (Math.abs(currentWidth - nextWidth) < $a2904bcfe480568e$var$SCROLLBAR_WIDTH) return;
            // Avoid React memory leak by checking if the component is still mounted
            if (!isMountedRef.current) return;
            widthRef.current = nextWidth;
            setWidth(nextWidth);
        });
    }, []);
    const skipWidthDetection = shouldCheckExistingValue && existingContextValue.width > 0;
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useLayoutEffect(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $a2904bcfe480568e$var$styles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, !skipWidthDetection && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gJlZe.WidthObserver), {
        setWidth: updateWidth,
        offscreen: true
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)($a2904bcfe480568e$var$Provider, {
        value: providerValue
    }, children)), skipWidthDetection && children);
};

});
parcelRegister("1v3g5", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $161da1f5bf80dbfb$export$48d7c418edadb60c);

var $6cAn5 = parcelRequire("6cAn5");
function $161da1f5bf80dbfb$export$48d7c418edadb60c() {
    try {
        return Boolean(// In most places there is no document when running on server-side
        typeof document === 'undefined' || // When SSRing editor with full cycle mode we define the document
        // Check Confluence specific environment variable
        typeof $6cAn5 !== 'undefined' && undefined);
    } catch (e) {
        // Catch possible error that might occur and just return false
        return false;
    }
}

});



parcelRegister("fIJEx", function(module, exports) {

$parcel$export(module.exports, "IntlErrorBoundary", () => $f1eccfecc1c43fb5$export$7df0749115d18d19);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");
const $f1eccfecc1c43fb5$export$c7ef921528e1d279 = '<IntlProvider> needs to exist in the component ancestry';
const $f1eccfecc1c43fb5$var$isMissingIntlProviderInAncestryError = (err)=>err?.toString()?.includes('<IntlProvider> needs to exist in the component ancestry');
class $f1eccfecc1c43fb5$export$7df0749115d18d19 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidCatch(error, errorInfo) {
        // if missing IntlProvider in ancestry, we setup a fallback IntlProvider ourselves
        if ($f1eccfecc1c43fb5$var$isMissingIntlProviderInAncestryError(error)) this.setState({
            missingIntlProviderInAncestry: true
        });
        else // else we re-propagate the non-react-intl-next error
        throw error;
    }
    render() {
        if (this.state.missingIntlProviderInAncestry) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
            locale: "en",
            children: this.props.children
        });
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            missingIntlProviderInAncestry: false
        };
    }
}

});

parcelRegister("iiXGq", function(module, exports) {

$parcel$export(module.exports, "default", () => $94120525d10931b9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $iHYdz = parcelRequire("iHYdz");

var $dg0Fl = parcelRequire("dg0Fl");

var $3bDjY = parcelRequire("3bDjY");

var $gkwXh = parcelRequire("gkwXh");

var $7R1zM = parcelRequire("7R1zM");

var $d54NZ = parcelRequire("d54NZ");

var $9tFGn = parcelRequire("9tFGn");
const $94120525d10931b9$var$blockNodeStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    background: "var(--ds-background-disabled, #091E4208)",
    border: `1px dashed ${"var(--ds-border-disabled, #091E420F)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-border-radius, 3px)",
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $iHYdz.relativeFontSizeToBase16)(14),
    margin: `${"var(--ds-space-100, 8px)"} 0`,
    minHeight: '24px',
    padding: "var(--ds-space-150, 12px)",
    textAlign: 'center',
    verticalAlign: 'text-bottom',
    minWidth: '120px',
    alignItems: 'center',
    justifyContent: 'center'
});
const $94120525d10931b9$var$UnsupportedBlockNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const message = (0, $9tFGn.getUnsupportedContent)((0, $7R1zM.unsupportedContentMessages).unsupportedBlockContent, (0, $7R1zM.unsupportedContentMessages).unsupportedBlockContent.defaultMessage + ':', node, intl);
    const tooltipContent = intl.formatMessage((0, $7R1zM.unsupportedContentMessages).unsupportedContentTooltip);
    const { current: style } = (0, $5uXOq.useRef)({
        padding: '4px'
    });
    const originalNodeType = node?.attrs.originalValue.type;
    const tooltipOnShowHandler = (0, $5uXOq.useCallback)(()=>dispatchAnalyticsEvent && (0, $d54NZ.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $gkwXh.ACTION_SUBJECT_ID).ON_UNSUPPORTED_BLOCK, originalNodeType), [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $94120525d10931b9$var$blockNodeStyle,
        className: "unsupported"
    }, message, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        style: style
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dg0Fl))), {
        label: "?",
        LEGACY_size: "small"
    })))));
};
var $94120525d10931b9$export$2e2bcd8739ae039 = (0, $8RXs9.default)($94120525d10931b9$var$UnsupportedBlockNode);

});
parcelRegister("gkwXh", function(module, exports) {

$parcel$export(module.exports, "EVENT_TYPE", () => $97c56ca7515fdb59$export$76a2e4c433c23bb9);
$parcel$export(module.exports, "ACTION", () => $97c56ca7515fdb59$export$9523889e0a5da4ba);
$parcel$export(module.exports, "INPUT_METHOD", () => $97c56ca7515fdb59$export$85f107b1fcc9d96f);
$parcel$export(module.exports, "INSERT_MEDIA_VIA", () => $97c56ca7515fdb59$export$9b31fa32ae3f8051);
$parcel$export(module.exports, "TRIGGER_METHOD", () => $97c56ca7515fdb59$export$81a8b7dba1aa8f75);
$parcel$export(module.exports, "ACTION_SUBJECT", () => $97c56ca7515fdb59$export$7525482b5931e326);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $97c56ca7515fdb59$export$9957974f8b4d8f74);
$parcel$export(module.exports, "CONTENT_COMPONENT", () => $97c56ca7515fdb59$export$9f0b2adf3cfd71b7);
var $97c56ca7515fdb59$export$76a2e4c433c23bb9 = /*#__PURE__*/ function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
    return EVENT_TYPE;
}({});
var $97c56ca7515fdb59$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["ACTIONED"] = "actioned";
    ACTION["ACTIVATED"] = "activated";
    ACTION["ADDED"] = "added";
    ACTION["API_ERROR"] = "apiError";
    ACTION["API_RECEIVED"] = "apiReceived";
    ACTION["API_PURGED"] = "apiPurged";
    ACTION["BROWSER_FREEZE"] = "browserFreeze";
    ACTION["CANCELLED"] = "cancelled";
    ACTION["CAUGHT_DOM_ERROR"] = "caughtDomError";
    ACTION["CHANGED_BACKGROUND_COLOR"] = "changedBackgroundColor";
    ACTION["CHANGED_ICON"] = "changedIcon";
    ACTION["CHANGED_FULL_WIDTH_MODE"] = "changedFullWidthMode";
    ACTION["CHANGED_LAYOUT"] = "changedLayout";
    ACTION["CHANGED_REPLACEMENT_TEXT"] = "changedReplacementText";
    ACTION["CHANGED_TYPE"] = "changedType";
    ACTION["CHANGED_URL"] = "changedUrl";
    ACTION["CLEARED"] = "cleared";
    ACTION["CLICK"] = "click";
    ACTION["CLICKED"] = "clicked";
    ACTION["CLOSED"] = "closed";
    ACTION["COMMITTED"] = "committed";
    /** used in @atlassian/editor-referentiality */ ACTION["CONNECTED_NODES"] = "connectedNodes";
    ACTION["CONVERTED"] = "converted";
    ACTION["COPIED"] = "copied";
    ACTION["CUT"] = "cut";
    ACTION["DEACTIVATED"] = "deactivated";
    ACTION["DECREMENTED"] = "decremented";
    ACTION["DELETED"] = "deleted";
    ACTION["DISCARDED_INVALID_STEPS_FROM_TRANSACTION"] = "discardedInvalidStepsFromTransaction";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_SOURCE"] = "disconnectedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_TARGET"] = "disconnectedTarget";
    ACTION["DISMISSED"] = "dismissed";
    ACTION["DISPATCHED_INVALID_TRANSACTION"] = "dispatchedInvalidTransaction";
    ACTION["DISPATCHED_VALID_TRANSACTION"] = "dispatchedValidTransaction";
    ACTION["DOUBLE_CLICKED"] = "doubleClicked";
    ACTION["DRAGGED"] = "dragged";
    ACTION["EDITED"] = "edited";
    ACTION["EDITOR_CRASHED"] = "unhandledErrorCaught";
    ACTION["EDITOR_CRASHED_ADDITIONAL_INFORMATION"] = "unhandledErrorCaughtAdditionalInfov2";
    ACTION["EDITOR_MOUNTED"] = "mounted";
    ACTION["EDITOR_CONTENT_RETRIEVAL_PERFORMED"] = "contentRetrievalPerformed";
    ACTION["RE_RENDERED"] = "reRendered";
    ACTION["ENDED"] = "ended";
    ACTION["ENTERED"] = "entered";
    ACTION["ERROR"] = "error";
    ACTION["ERRORED"] = "errored";
    ACTION["EXPOSED"] = "exposed";
    ACTION["FAILED_TO_UNMOUNT"] = "failedToUnmount";
    ACTION["FAILED_TO_INSERT"] = "failedToInsert";
    ACTION["FIND_NEXT_PERFORMED"] = "findNextPerformed";
    ACTION["FIND_PERFORMED"] = "findPerformed";
    ACTION["FIND_PREV_PERFORMED"] = "findPrevPerformed";
    ACTION["UNDO_PERFORMED"] = "undo";
    ACTION["REDO_PERFORMED"] = "redo";
    ACTION["FORMATTED"] = "formatted";
    ACTION["HELP_OPENED"] = "helpOpened";
    ACTION["HIGHLIGHTED"] = "highlighted";
    ACTION["INCREMENTED"] = "incremented";
    ACTION["INDENTED"] = "indented";
    ACTION["INITIALISED"] = "initialised";
    ACTION["INITIATED"] = "initiated";
    /** used in @atlassian/editor-referentiality */ ACTION["INITIALISED_FRAGMENT_MARK"] = "initialisedFragmentMark";
    ACTION["INPUT_PERF_SAMPLING"] = "inputPerfSampling";
    ACTION["INPUT_PERF_SAMPLING_AVG"] = "inputPerfSamplingAvg";
    ACTION["INSERTED"] = "inserted";
    ACTION["INVALID_DOCUMENT_ENCOUNTERED"] = "invalidDocumentEncountered";
    ACTION["INVOKED"] = "invoked";
    /** used in @atlassian/editor-referentiality */ ACTION["GOT_CONNECTIONS"] = "gotConnections";
    ACTION["LANGUAGE_SELECTED"] = "languageSelected";
    ACTION["LIST_ITEM_JOINED"] = "listItemJoined";
    ACTION["MATCHED"] = "matched";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    ACTION["NODE_CONTENT_SANITIZED"] = "nodeContentSanitized";
    ACTION["OFFLINE_STORAGE_TOO_MANY_RETRIES_ERROR"] = "offlineStorageTooManyRetriesError";
    ACTION["OFFLINE_STORAGE_STEPS_DATABASE_ERROR"] = "offlineStorageStepsDatabaseError";
    ACTION["OFFLINE_STORAGE_RESYNC_ONLINE"] = "offlineStorageResyncOnline";
    ACTION["OFFLINE_STORAGE_BROADCAST_CHANNEL_FIRST_UPDATE"] = "offlineStorageBroadcastChannelFirstUpdate";
    ACTION["OPENED"] = "opened";
    ACTION["OUTDENTED"] = "outdented";
    ACTION["PASTED"] = "pasted";
    ACTION["PASTED_AS_PLAIN"] = "pastedAsPlain";
    ACTION["PASTED_TIMED"] = "pastedTimed";
    ACTION["PRESSED"] = "pressed";
    ACTION["PROSEMIRROR_RENDERED"] = "proseMirrorRendered";
    ACTION["REACT_NODEVIEW_RENDERED"] = "reactNodeViewRendered";
    ACTION["REPLACED_ALL"] = "replacedAll";
    ACTION["REPLACED_ONE"] = "replacedOne";
    ACTION["RESOLVED"] = "resolved";
    ACTION["REQUEST_TO_EDIT"] = "requestToEdit";
    ACTION["SELECTED"] = "selected";
    ACTION["SHOWN"] = "shown";
    ACTION["SLOW_INPUT"] = "slowInput";
    ACTION["STARTED"] = "started";
    ACTION["STOPPED"] = "stopped";
    ACTION["SUBMITTED"] = "submitted";
    ACTION["SUBSTITUTED"] = "autoSubstituted";
    ACTION["SYNCHRONY_DISCONNECTED"] = "synchronyDisconnected";
    ACTION["SYNCHRONY_ENTITY_ERROR"] = "synchronyEntityError";
    ACTION["SYNCHRONY_ERROR"] = "synchronyError";
    ACTION["TEXT_LINK_MARK_TRANSFORMED"] = "textLinkMarkTransformed";
    ACTION["TOGGLED"] = "toggled";
    ACTION["DEDUPE_MARKS_TRANSFORMED_V2"] = "dedupeMarksTransformedV2";
    ACTION["NODES_MISSING_CONTENT_TRANSFORMED"] = "nodesMissingContentTransformed";
    ACTION["INDENTATION_MARKS_TRANSFORMED"] = "indentationMarksTransformed";
    ACTION["INVALID_MEDIA_CONTENT_TRANSFORMED"] = "invalidMediaContentTransformed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["TRANSACTION_MUTATED_AFTER_DISPATCH"] = "transactionMutatedAfterDispatched";
    ACTION["TYPING_FINISHED"] = "typingFinished";
    ACTION["TYPING_STARTED"] = "typingStarted";
    ACTION["UNHANDLED_ERROR_CAUGHT"] = "unhandledErrorCaught";
    ACTION["UNLINK"] = "unlinked";
    ACTION["UNSUPPORTED_CONTENT_ENCOUNTERED"] = "unsupportedContentEncounteredV2";
    ACTION["UPDATED"] = "updated";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_FRAGMENT_MARK_NAME"] = "updatedFragmentMarkName";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_SOURCE"] = "updatedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_TARGET"] = "updatedTarget";
    ACTION["UPLOAD_EXTERNAL_FAIL"] = "uploadExternalFailed";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["WITH_PLUGIN_STATE_CALLED"] = "withPluginStateCalled";
    ACTION["RENDERED"] = "rendered";
    ACTION["ON_EDITOR_READY_CALLBACK"] = "onEditorReadyCallback";
    /**
	 * @private
	 * @deprecated
	 *
	 * This is no longer used and can be removed at a later date
	 */ ACTION["ON_CHANGE_CALLBACK"] = "onChangeCalled";
    ACTION["NESTED_TABLE_TRANSFORMED"] = "nestedTableTransformed";
    ACTION["NEW_COLLAB_SYNC_UP_ERROR_NO_STEPS"] = "newCollabSyncUpErrorNoSteps";
    ACTION["REMOVE_ICON"] = "removedIcon";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["DOCUMENT_PROCESSING_ERROR"] = "documentProcessingErrorV2";
    ACTION["CRASHED"] = "unhandledErrorCaughtV2";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    ACTION["STEPS_TRACKED"] = "stepsTracked";
    ACTION["STEPS_FILTERED"] = "stepsFiltered";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["UNSUPPORTED_TOOLTIP_VIEWED"] = "viewed";
    ACTION["RECORD_VIDEO"] = "recordVideo";
    ACTION["INSERT_VIDEO"] = "insertVideo";
    ACTION["RECORD_VIDEO_FAILED"] = "recordVideoFailed";
    ACTION["ADD_CHILD"] = "addChild";
    ACTION["CHANGE_ACTIVE"] = "changeActive";
    ACTION["REMOVE_CHILD"] = "removeChild";
    ACTION["UPDATE_PARAMETERS"] = "updateParameters";
    ACTION["GET_CHILDREN"] = "getChildren";
    ACTION["GET_CHILDREN_CONTAINER"] = "getChildrenContainer";
    ACTION["MOVED"] = "moved";
    ACTION["UPLOAD_COMMENCED"] = "uploadCommenced";
    ACTION["UPLOAD_SUCCEEDED"] = "uploadSucceeded";
    ACTION["UPLOAD_FAILED"] = "uploadFailed";
    ACTION["TOGGLE_CODE_BLOCK_WRAP"] = "toggleCodeBlockWrap";
    ACTION["RESIZED"] = "resized";
    ACTION["BLOCKS_DRAG_INIT"] = "blocksDragInit";
    ACTION["SINGLE_COL_LAYOUT_DETECTED"] = "singleColumLayoutDetected";
    ACTION["VIEW_MORE"] = "viewMore";
    /**
	 * used in Editor AI inline suggestion for a track event when a suggestion is inserted
	 * previously tracked events being used by Editor AI proactive suggestion
	 *
	 */ ACTION["SUGGESTION_INSERTED"] = "suggestionInserted";
    ACTION["SUGGESTION_DISMISSED"] = "suggestionDismissed";
    ACTION["SUGGESTION_VIEWED"] = "suggestionViewed";
    return ACTION;
}({});
var $97c56ca7515fdb59$export$85f107b1fcc9d96f = /*#__PURE__*/ function(INPUT_METHOD) {
    INPUT_METHOD["ASCII"] = "ascii";
    INPUT_METHOD["AUTO"] = "auto";
    INPUT_METHOD["AUTO_DETECT"] = "autoDetect";
    INPUT_METHOD["BUTTON"] = "button";
    INPUT_METHOD["BLUR"] = "blur";
    INPUT_METHOD["CARD"] = "card";
    INPUT_METHOD["CLIPBOARD"] = "clipboard";
    INPUT_METHOD["CONFIG_PANEL"] = "configPanel";
    INPUT_METHOD["CONTEXT_MENU"] = "contextMenu";
    INPUT_METHOD["DRAG_AND_DROP"] = "dragAndDrop";
    INPUT_METHOD["DRAG"] = "drag";
    INPUT_METHOD["EXTERNAL"] = "external";
    INPUT_METHOD["EXTENSION_API"] = "extensionApi";
    INPUT_METHOD["FLOATING_TB"] = "floatingToolbar";
    INPUT_METHOD["FORMATTING"] = "autoformatting";
    INPUT_METHOD["INSERT_MENU"] = "insertMenu";
    INPUT_METHOD["INSERT_MENU_RIGHT_RAIL"] = "insertMenuRightRail";
    INPUT_METHOD["KEYBOARD"] = "keyboard";
    INPUT_METHOD["MEDIA_PICKER"] = "mediaPicker";
    INPUT_METHOD["MACRO_BROWSER"] = "macroBrowser";
    INPUT_METHOD["MANUAL"] = "manual";
    INPUT_METHOD["PICKER"] = "picker";
    INPUT_METHOD["PICKER_CLOUD"] = "cloudPicker";
    INPUT_METHOD["PREFILL"] = "prefill";
    INPUT_METHOD["QUICK_INSERT"] = "quickInsert";
    INPUT_METHOD["SHORTCUT"] = "shortcut";
    INPUT_METHOD["TOOLBAR"] = "toolbar";
    INPUT_METHOD["TYPEAHEAD"] = "typeAhead";
    INPUT_METHOD["DATASOURCE"] = "datasource_config";
    INPUT_METHOD["TABLE_CONTEXT_MENU"] = "tableContextMenu";
    INPUT_METHOD["MOUSE"] = "mouse";
    INPUT_METHOD["BROWSER"] = "browser";
    INPUT_METHOD["DOUBLE_CLICK"] = "doubleClick";
    INPUT_METHOD["INLINE_SUGGESTION_FLOATING_TB"] = "inlineSuggestionFloatingToolbar";
    return INPUT_METHOD;
}({});
var $97c56ca7515fdb59$export$9b31fa32ae3f8051 = /*#__PURE__*/ function(INSERT_MEDIA_VIA) {
    INSERT_MEDIA_VIA["LOCAL_UPLOAD"] = "localUpload";
    INSERT_MEDIA_VIA["EXTERNAL_URL"] = "externalUrl";
    INSERT_MEDIA_VIA["EXTERNAL_UPLOAD"] = "externalUpload";
    return INSERT_MEDIA_VIA;
}({});
var $97c56ca7515fdb59$export$81a8b7dba1aa8f75 = /*#__PURE__*/ function(TRIGGER_METHOD) {
    TRIGGER_METHOD["BUTTON"] = "button";
    TRIGGER_METHOD["KEYBOARD"] = "keyboard";
    TRIGGER_METHOD["SHORTCUT"] = "shortcut";
    TRIGGER_METHOD["TOOLBAR"] = "toolbar";
    TRIGGER_METHOD["EXTERNAL"] = "external";
    return TRIGGER_METHOD;
}({});
var $97c56ca7515fdb59$export$7525482b5931e326 = /*#__PURE__*/ function(ACTION_SUBJECT) {
    ACTION_SUBJECT["AI_INTERACTION"] = "aiInteraction";
    ACTION_SUBJECT["AI_RESULT"] = "aiResult";
    ACTION_SUBJECT["AI_FEEDBACK"] = "aiFeedback";
    ACTION_SUBJECT["COLLAB"] = "collab";
    ACTION_SUBJECT["TOOLBAR_BUTTON"] = "toolbarButton";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["CONFIG_PANEL"] = "configPanel";
    ACTION_SUBJECT["CONTENT_COMPONENT"] = "contentComponent";
    ACTION_SUBJECT["DATE"] = "date";
    ACTION_SUBJECT["DATE_SEGMENT"] = "dateSegment";
    ACTION_SUBJECT["DOCUMENT"] = "document";
    ACTION_SUBJECT["EDITOR"] = "editor";
    ACTION_SUBJECT["ACTIVITY_SESSION"] = "activitySession";
    ACTION_SUBJECT["ELEMENT_BROWSER"] = "elementBrowser";
    ACTION_SUBJECT["EMBEDS"] = "embeds";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["EXTENSION"] = "extension";
    ACTION_SUBJECT["FEATURE"] = "feature";
    ACTION_SUBJECT["FEEDBACK_DIALOG"] = "feedbackDialog";
    ACTION_SUBJECT["FIND_REPLACE_DIALOG"] = "findReplaceDialog";
    ACTION_SUBJECT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    ACTION_SUBJECT["FLOATING_TOOLBAR_PLUGIN"] = "floatingToolbarPlugin";
    ACTION_SUBJECT["HELP"] = "help";
    ACTION_SUBJECT["INVITE_ITEM"] = "inviteItem";
    ACTION_SUBJECT["LAYOUT"] = "layout";
    ACTION_SUBJECT["LIST"] = "list";
    ACTION_SUBJECT["MEDIA"] = "media";
    ACTION_SUBJECT["MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT["MEDIA_INLINE"] = "mediaInline";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["MENTION"] = "mention";
    ACTION_SUBJECT["MENTION_TYPEAHEAD"] = "mentionTypeahead";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["PANEL"] = "panel";
    ACTION_SUBJECT["PICKER"] = "picker";
    ACTION_SUBJECT["PLUS_MENU"] = "plusMenu";
    ACTION_SUBJECT["PLUGIN_SLOT"] = "pluginSlot";
    ACTION_SUBJECT["REQUEST_TO_EDIT_POP_UP"] = "requestToEditPopUp";
    ACTION_SUBJECT["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT["SELECTION"] = "selection";
    ACTION_SUBJECT["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["TABLES_PLUGIN"] = "tablesPlugin";
    ACTION_SUBJECT["TEAM_MENTION_TYPEAHEAD"] = "teamMentionTypeahead";
    ACTION_SUBJECT["TELEPOINTER"] = "telepointer";
    ACTION_SUBJECT["TEXT"] = "text";
    ACTION_SUBJECT["TOOLBAR"] = "toolbar";
    ACTION_SUBJECT["TYPEAHEAD"] = "typeAhead";
    ACTION_SUBJECT["TYPEAHEAD_ITEM"] = "typeAheadItem";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["SEARCH_RESULT"] = "searchResult";
    ACTION_SUBJECT["CREATE_LINK_INLINE_DIALOG"] = "createLinkInlineDialog";
    ACTION_SUBJECT["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT["REACT_EDITOR_VIEW"] = "reactEditorView";
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["TOOLTIP"] = "tooltip";
    ACTION_SUBJECT["LOOM"] = "loom";
    ACTION_SUBJECT["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT["BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT["DROP_TARGET"] = "dropTarget";
    ACTION_SUBJECT["DRAG"] = "drag";
    ACTION_SUBJECT["ELEMENT"] = "element";
    ACTION_SUBJECT["INLINE_DIALOG"] = "inlineDialog";
    ACTION_SUBJECT["ENGAGEMENT_PLATFORM"] = "engagementPlatform";
    ACTION_SUBJECT["MEDIA_VIEWER"] = "mediaViewer";
    ACTION_SUBJECT["DECORATION"] = "decoration";
    ACTION_SUBJECT["EDITOR_PLUGIN_AI"] = "editorPluginAI";
    ACTION_SUBJECT["EDITOR_PLUGIN_SELECTION_EXTENSION"] = "editorPluginSelectionExtension";
    ACTION_SUBJECT["AI_DEFINITIONS"] = "aiDefinitions";
    ACTION_SUBJECT["USER_PREFERENCES"] = "userPreferences";
    ACTION_SUBJECT["ALIGNMENT"] = "alignment";
    ACTION_SUBJECT["OFFLINE_EDITING"] = "offlineEditing";
    return ACTION_SUBJECT;
}({});
var $97c56ca7515fdb59$export$9957974f8b4d8f74 = /*#__PURE__*/ function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["ACTION"] = "action";
    ACTION_SUBJECT_ID["ACTIVITY"] = "activity";
    ACTION_SUBJECT_ID["AI_DEFINITIONS_DEFINE_BUTTON"] = "aiDefinitionsDefineButton";
    ACTION_SUBJECT_ID["AI_DEFINITIONS_AUTO_HIGHLIGHT"] = "aiDefinitionsAutoHighlight";
    ACTION_SUBJECT_ID["AI_INLINE_SUGGESTION"] = "aiInlineSuggestion";
    ACTION_SUBJECT_ID["AI_PANELS_BODIED_EXTENSION"] = "aiPanelsBodiedExtension";
    ACTION_SUBJECT_ID["AI_PROMPT_LINK_PICKER_BUTTON"] = "aiPromptLinkPickerButton";
    ACTION_SUBJECT_ID["AI_PROMPT_MENTION_BUTTON"] = "aiPromptMentionButton";
    ACTION_SUBJECT_ID["AI_PROACTIVE_FEEDBACK_DIALOG"] = "aiProactiveFeedbackDialog";
    ACTION_SUBJECT_ID["ALL"] = "all";
    ACTION_SUBJECT_ID["ALT_TEXT"] = "altText";
    ACTION_SUBJECT_ID["ANNOTATE_BUTTON"] = "annotateButton";
    ACTION_SUBJECT_ID["AVATAR_GROUP_PLUGIN"] = "AvatarGroupInPlugin";
    ACTION_SUBJECT_ID["BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["BORDER"] = "border";
    ACTION_SUBJECT_ID["BUTTON_CATEGORY"] = "categoryButton";
    ACTION_SUBJECT_ID["BUTTON_FEEDBACK"] = "feedbackButton";
    ACTION_SUBJECT_ID["BUTTON_HELP"] = "helpButton";
    ACTION_SUBJECT_ID["CANCEL"] = "cancel";
    ACTION_SUBJECT_ID["CAPTION"] = "caption";
    ACTION_SUBJECT_ID["CARD_BLOCK"] = "blockCard";
    ACTION_SUBJECT_ID["CARD_INLINE"] = "inlineCard";
    ACTION_SUBJECT_ID["CELL"] = "cell";
    ACTION_SUBJECT_ID["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    ACTION_SUBJECT_ID["COPY_BUTTON"] = "copyButton";
    ACTION_SUBJECT_ID["COPY_LINK_TO_ANCHOR"] = "copyLinkToAnchor";
    ACTION_SUBJECT_ID["CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU"] = "createInlineCommentFromHighlightActionsMenu";
    ACTION_SUBJECT_ID["DATE"] = "date";
    ACTION_SUBJECT_ID["DATE_DAY"] = "day";
    ACTION_SUBJECT_ID["DATE_MONTH"] = "month";
    ACTION_SUBJECT_ID["DATE_YEAR"] = "year";
    ACTION_SUBJECT_ID["DECISION"] = "decision";
    ACTION_SUBJECT_ID["DIVIDER"] = "divider";
    ACTION_SUBJECT_ID["EDIT_LINK"] = "editLink";
    ACTION_SUBJECT_ID["EDIT_DATASOURCE"] = "editDatasource";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_AI"] = "editorPluginAI";
    ACTION_SUBJECT_ID["ELEMENT_DRAG_HANDLE"] = "elementDragHandle";
    ACTION_SUBJECT_ID["ELEMENT_DROP_TARGET"] = "elementDropTarget";
    ACTION_SUBJECT_ID["EMBEDS"] = "embeds";
    ACTION_SUBJECT_ID["EMOJI"] = "emoji";
    ACTION_SUBJECT_ID["EXPAND"] = "expand";
    ACTION_SUBJECT_ID["EXPERIENCE_APPLICATION"] = "experienceApplication";
    ACTION_SUBJECT_ID["EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_API"] = "extensionApi";
    ACTION_SUBJECT_ID["EXTENSION_BLOCK"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_BODIED"] = "bodiedExtension";
    ACTION_SUBJECT_ID["EXTENSION_INLINE"] = "inlineExtension";
    ACTION_SUBJECT_ID["FORMAT_BACKGROUND_COLOR"] = "backgroundColor";
    ACTION_SUBJECT_ID["FORMAT_BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["FORMAT_CLEAR"] = "clearFormatting";
    ACTION_SUBJECT_ID["FORMAT_CODE"] = "code";
    ACTION_SUBJECT_ID["FORMAT_COLOR"] = "color";
    ACTION_SUBJECT_ID["FORMAT_HEADING"] = "heading";
    ACTION_SUBJECT_ID["FORMAT_INDENT"] = "indentation";
    ACTION_SUBJECT_ID["FORMAT_ITALIC"] = "italic";
    ACTION_SUBJECT_ID["FORMAT_LIST_BULLET"] = "bulletedList";
    ACTION_SUBJECT_ID["FORMAT_LIST_NUMBER"] = "numberedList";
    ACTION_SUBJECT_ID["FORMAT_STRIKE"] = "strike";
    ACTION_SUBJECT_ID["FORMAT_STRONG"] = "strong";
    ACTION_SUBJECT_ID["FORMAT_SUB"] = "subscript";
    ACTION_SUBJECT_ID["FORMAT_SUPER"] = "superscript";
    ACTION_SUBJECT_ID["FORMAT_UNDERLINE"] = "underline";
    ACTION_SUBJECT_ID["FRAGMENT_MARK"] = "fragmentMark";
    ACTION_SUBJECT_ID["GOTO_SMART_LINK_SETTINGS"] = "goToSmartLinkSettings";
    ACTION_SUBJECT_ID["HELP_QUICK_INSERT"] = "helpQuickInsert";
    ACTION_SUBJECT_ID["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["LAYOUT"] = "layout";
    ACTION_SUBJECT_ID["LINE_BREAK"] = "lineBreak";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["LINK_PREVIEW"] = "linkPreview";
    ACTION_SUBJECT_ID["LINK_SEARCH_INPUT"] = "linkSearchInput";
    ACTION_SUBJECT_ID["MEDIA"] = "media";
    ACTION_SUBJECT_ID["MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["MEDIA_INLINE"] = "mediaInline";
    ACTION_SUBJECT_ID["MEDIA_INLINE_IMAGE"] = "mediaInlineImage";
    ACTION_SUBJECT_ID["MEDIA_LINK"] = "mediaLink";
    ACTION_SUBJECT_ID["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["MENTION"] = "mention";
    ACTION_SUBJECT_ID["MENTION_PROVIDER"] = "mentionProvider";
    ACTION_SUBJECT_ID["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["NODE"] = "node";
    ACTION_SUBJECT_ID["OPEN_LINK"] = "openLink";
    ACTION_SUBJECT_ID["OFFLINE_EDITING"] = "offlineEditing";
    ACTION_SUBJECT_ID["PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_BLOCK_CARD"] = "blockCard";
    ACTION_SUBJECT_ID["PASTE_BLOCKQUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["PASTE_BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT_ID["PASTE_BULLET_LIST"] = "bulletList";
    ACTION_SUBJECT_ID["PASTE_CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["PASTE_DECISION_LIST"] = "decisionList";
    ACTION_SUBJECT_ID["PASTE_EXPAND"] = "expand";
    ACTION_SUBJECT_ID["PASTE_EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["PASTE_HEADING"] = "heading";
    ACTION_SUBJECT_ID["PASTE_MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["PASTE_MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["PASTE_NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["PASTE_ORDERED_LIST"] = "orderedList";
    ACTION_SUBJECT_ID["PASTE_PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_PARAGRAPH"] = "paragraph";
    ACTION_SUBJECT_ID["PASTE_RULE"] = "rule";
    ACTION_SUBJECT_ID["PASTE_TABLE"] = "table";
    ACTION_SUBJECT_ID["PASTE_TABLE_CELL"] = "tableCell";
    ACTION_SUBJECT_ID["PASTE_TABLE_HEADER"] = "tableHeader";
    ACTION_SUBJECT_ID["PASTE_TABLE_ROW"] = "tableRow";
    ACTION_SUBJECT_ID["PASTE_TASK_LIST"] = "taskList";
    ACTION_SUBJECT_ID["PICKER_CLOUD"] = "cloudPicker";
    ACTION_SUBJECT_ID["PICKER_MEDIA"] = "mediaPicker";
    ACTION_SUBJECT_ID["PICKER_COLOR"] = "colorPicker";
    ACTION_SUBJECT_ID["PICKER_EMOJI"] = "emojiPicker";
    ACTION_SUBJECT_ID["PICKER_TABLE_SIZE"] = "tableSizePicker";
    ACTION_SUBJECT_ID["DOCKED_PRIMARY_TOOLBAR"] = "dockedPrimaryToolbar";
    ACTION_SUBJECT_ID["PLACEHOLDER_TEXT"] = "placeholderText";
    ACTION_SUBJECT_ID["POST_QUERY_SEARCH_RESULTS"] = "postQuerySearchResults";
    ACTION_SUBJECT_ID["PRE_QUERY_SEARCH_RESULTS"] = "preQuerySearchResults";
    ACTION_SUBJECT_ID["PROACTIVE_SUGGESTION"] = "proactiveSuggestion";
    ACTION_SUBJECT_ID["PRODUCT_NAME"] = "productName";
    ACTION_SUBJECT_ID["PUNC"] = "punctuation";
    ACTION_SUBJECT_ID["QUICK_SEARCH"] = "quickSearch";
    ACTION_SUBJECT_ID["RANGE"] = "range";
    ACTION_SUBJECT_ID["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT_ID["RECENT_ACTIVITIES"] = "recentActivities";
    ACTION_SUBJECT_ID["RESIZED"] = "resized";
    ACTION_SUBJECT_ID["RESPONSE_FEEDBACK_BUTTON"] = "responseFeedbackButton";
    ACTION_SUBJECT_ID["RICH_MEDIA_LAYOUT"] = "richMediaLayout";
    ACTION_SUBJECT_ID["SAVE"] = "save";
    ACTION_SUBJECT_ID["SECTION"] = "section";
    ACTION_SUBJECT_ID["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT_ID["SMART_LINK_TOOLBAR"] = "smartLinkToolbar";
    ACTION_SUBJECT_ID["STATUS"] = "status";
    ACTION_SUBJECT_ID["SYMBOL"] = "symbol";
    ACTION_SUBJECT_ID["TABLE"] = "table";
    ACTION_SUBJECT_ID["TELEPOINTER"] = "telepointer";
    ACTION_SUBJECT_ID["TEXT"] = "text";
    ACTION_SUBJECT_ID["TYPEAHEAD_EMOJI"] = "emojiTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_LINK"] = "linkTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_MENTION"] = "mentionTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_QUICK_INSERT"] = "quickInsertTypeAhead";
    ACTION_SUBJECT_ID["UNKNOWN_NODE"] = "unknownNode";
    ACTION_SUBJECT_ID["UNLINK"] = "unlink";
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["UNSUPPORTED_ERROR"] = "unsupportedUnhandled";
    ACTION_SUBJECT_ID["UNSUPPORTED_NODE_ATTRIBUTE"] = "unsupportedNodeAttribute";
    ACTION_SUBJECT_ID["UNSUPPORTED_BLOCK"] = "unsupportedBlock";
    ACTION_SUBJECT_ID["UNSUPPORTED_INLINE"] = "unsupportedInline";
    ACTION_SUBJECT_ID["UNSUPPORTED_MARK"] = "unsupportedMark";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_INLINE"] = "onUnsupportedInline";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_BLOCK"] = "onUnsupportedBlock";
    ACTION_SUBJECT_ID["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT_ID["UPLOAD_MEDIA"] = "uploadMedia";
    ACTION_SUBJECT_ID["SELECTION_TOOLBAR_PREFERENCES"] = "selectionToolbarPreferences";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_DROPDOWN"] = "editorPluginSelectionExtensionDropdown";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_ITEM"] = "editorPluginSelectionExtensionItem";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_COMPONENT"] = "editorPluginSelectionExtensionComponent";
    return ACTION_SUBJECT_ID;
}({});
var $97c56ca7515fdb59$export$75ef928acd21e35b = /*#__PURE__*/ function(FLOATING_CONTROLS_TITLE) {
    FLOATING_CONTROLS_TITLE["CODE_BLOCK"] = "codeBlockFloatingControls";
    FLOATING_CONTROLS_TITLE["EXTENSION"] = "extensionFloatingControls";
    FLOATING_CONTROLS_TITLE["HYPERLINK"] = "hyperlinkFloatingControls";
    FLOATING_CONTROLS_TITLE["MEDIA"] = "mediaFloatingControls";
    FLOATING_CONTROLS_TITLE["PANEL"] = "panelFloatingControls";
    FLOATING_CONTROLS_TITLE["TABLE"] = "tableFloatingControls";
    FLOATING_CONTROLS_TITLE["EXPAND"] = "expandToolbar";
    return FLOATING_CONTROLS_TITLE;
}({});
var $97c56ca7515fdb59$export$9f0b2adf3cfd71b7 = /*#__PURE__*/ function(CONTENT_COMPONENT) {
    CONTENT_COMPONENT["INLINE_COMMENT"] = "inlineComment";
    CONTENT_COMPONENT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    CONTENT_COMPONENT["FLOATING_INSERT_BUTTON"] = "floatingInsertButton";
    CONTENT_COMPONENT["FLOATING_TOOLBAR"] = "floatingToolbar";
    return CONTENT_COMPONENT;
}({});

});

parcelRegister("7R1zM", function(module, exports) {

$parcel$export(module.exports, "unsupportedContentMessages", () => $757d518931aaa671$export$32ec96484dd3ba39);

var $7VHMR = parcelRequire("7VHMR");
const $757d518931aaa671$export$32ec96484dd3ba39 = (0, $7VHMR.defineMessages)({
    unsupportedInlineContent: {
        id: 'fabric.editor.unsupportedInlineContent',
        defaultMessage: 'Unsupported content',
        description: 'Unsupported content'
    },
    unsupportedBlockContent: {
        id: 'fabric.editor.unsupportedBlockContent',
        defaultMessage: 'This editor does not support displaying this content',
        description: 'This editor does not support displaying this content'
    },
    unsupportedContentTooltip: {
        id: 'fabric.editor.unsupportedContentTooltip',
        defaultMessage: 'Content is not available in this editor, this will be preserved when you edit and save',
        description: 'Content is not available in this editor, this will be preserved when you edit and save'
    }
});

});

parcelRegister("d54NZ", function(module, exports) {

$parcel$export(module.exports, "findAndTrackUnsupportedContentNodes", () => $850930d0b79c2a61$export$d343369b8f25914);
$parcel$export(module.exports, "fireUnsupportedEvent", () => $850930d0b79c2a61$export$e1051b410945e4d4);
$parcel$export(module.exports, "trackUnsupportedContentTooltipDisplayedFor", () => $850930d0b79c2a61$export$3a34598135e7219b);

var $gkwXh = parcelRequire("gkwXh");
const $850930d0b79c2a61$var$whitelistedAttributes = [
    'align',
    'annotationType',
    'extensionKey',
    'extensionType',
    'layout',
    'type',
    'localId',
    'mode',
    'language',
    'timestamp',
    'state',
    'originalWidth',
    'originalHeight',
    'height',
    'width',
    'shortName',
    'level',
    'userType',
    'order',
    'panelType',
    'color',
    'style',
    'isNumberColumnEnabled',
    'colspan',
    'rowspan',
    'colwidth',
    'background'
];
function $850930d0b79c2a61$var$concatAncestorHierarchy(node, ancestoryHierarchy) {
    const { name: name } = node.type;
    // Space concatenator used to reduce analytics payload size
    return ancestoryHierarchy ? `${ancestoryHierarchy} ${name}` : name;
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $850930d0b79c2a61$var$sanitizeMarks = (marks = [])=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedMarks = [];
    marks.forEach((mark)=>{
        if (mark.attrs) {
            const attrs = $850930d0b79c2a61$var$sanitizeAttributes(mark.attrs);
            sanitizedMarks.push({
                ...mark,
                attrs: attrs
            });
        } else sanitizedMarks.push({
            ...mark
        });
    });
    return sanitizedMarks;
};
const $850930d0b79c2a61$var$sanitizeAttributes = (attrs = {})=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedAttrs = Object.assign({}, attrs);
    Object.keys(attrs).filter((key)=>!$850930d0b79c2a61$var$whitelistedAttributes.includes(key)).forEach((key)=>{
        sanitizedAttrs[key] !== null ? sanitizedAttrs[key] = '' : sanitizedAttrs[key] = 'null';
    });
    return sanitizedAttrs;
};
const $850930d0b79c2a61$var$trackUnsupportedContentTooltipActionFor = (action, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    dispatchAnalyticsEvent({
        action: action,
        actionSubjectId: unsupportedContentType,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).TOOLTIP,
        eventType: (0, $gkwXh.EVENT_TYPE).UI,
        attributes: {
            unsupportedNodeType: originalNodeType
        }
    });
};
const $850930d0b79c2a61$export$d343369b8f25914 = (node, schema, dispatchAnalyticsEvent, ancestorHierarchy = '')=>{
    const { type: nodeType, marks: nodeMarks } = node;
    const { unsupportedMark: unsupportedMark, unsupportedNodeAttribute: unsupportedNodeAttribute } = schema.marks;
    const { unsupportedInline: unsupportedInline, unsupportedBlock: unsupportedBlock } = schema.nodes;
    const parentType = ancestorHierarchy.split(' ').pop() || '';
    if (nodeMarks.length) nodeMarks.forEach((mark)=>{
        if (mark.type === unsupportedMark) {
            const { originalValue: originalValue } = mark.attrs || {};
            const { type: type } = originalValue || {};
            const unsupportedNode = {
                type: type || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: originalValue.attrs || {}
            };
            $850930d0b79c2a61$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $gkwXh.ACTION_SUBJECT_ID).UNSUPPORTED_MARK, unsupportedNode);
        } else if (mark.type === unsupportedNodeAttribute) {
            const { unsupported: unsupported } = mark.attrs || {};
            const unsupportedNodeAttribute = {
                type: nodeType.name || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: unsupported || {}
            };
            $850930d0b79c2a61$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $gkwXh.ACTION_SUBJECT_ID).UNSUPPORTED_NODE_ATTRIBUTE, unsupportedNodeAttribute);
        }
    });
    if (nodeType === unsupportedInline || nodeType === unsupportedBlock) {
        const { originalValue: originalValue } = node.attrs || {};
        const { marks: marks } = originalValue || [];
        const { attrs: attrs } = originalValue || {};
        const { type: type } = originalValue || {};
        const unsupportedNode = {
            type: type || '',
            ancestry: ancestorHierarchy,
            parentType: parentType,
            marks: marks || [],
            attrs: attrs || {}
        };
        const actionSubjectId = nodeType === unsupportedInline ? (0, $gkwXh.ACTION_SUBJECT_ID).UNSUPPORTED_INLINE : (0, $gkwXh.ACTION_SUBJECT_ID).UNSUPPORTED_BLOCK;
        $850930d0b79c2a61$export$e1051b410945e4d4(dispatchAnalyticsEvent, actionSubjectId, unsupportedNode);
    } else // Recursive check for nested content
    node.content.forEach((childNode)=>$850930d0b79c2a61$export$d343369b8f25914(childNode, schema, dispatchAnalyticsEvent, $850930d0b79c2a61$var$concatAncestorHierarchy(node, ancestorHierarchy)));
};
const $850930d0b79c2a61$export$e1051b410945e4d4 = (dispatchAnalyticsEvent, actionSubjectId, unsupportedNode, errorCode)=>{
    const sanitizedAttrs = $850930d0b79c2a61$var$sanitizeAttributes(unsupportedNode.attrs);
    const sanitizedMarks = $850930d0b79c2a61$var$sanitizeMarks(unsupportedNode.marks);
    const sanitizedUnsupportedNode = {
        type: unsupportedNode.type,
        ancestry: unsupportedNode.ancestry,
        parentType: unsupportedNode.parentType,
        attrs: sanitizedAttrs,
        marks: sanitizedMarks
    };
    const payload = {
        action: (0, $gkwXh.ACTION).UNSUPPORTED_CONTENT_ENCOUNTERED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: actionSubjectId,
        attributes: {
            unsupportedNode: sanitizedUnsupportedNode,
            ...!!errorCode && {
                errorCode: errorCode
            }
        },
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK
    };
    dispatchAnalyticsEvent(payload);
};
const $850930d0b79c2a61$export$3a34598135e7219b = (dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    $850930d0b79c2a61$var$trackUnsupportedContentTooltipActionFor((0, $gkwXh.ACTION).UNSUPPORTED_TOOLTIP_VIEWED, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType);
};

});

parcelRegister("9tFGn", function(module, exports) {

$parcel$export(module.exports, "getUnsupportedContent", () => $3ba5e7dd155390b9$export$d4ded51d0f0bd2df);
function $3ba5e7dd155390b9$export$d4ded51d0f0bd2df(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
message, prefix, node, intl) {
    const defaultLocale = 'en';
    let canTranslateToLocale = true;
    const locale = intl ? intl.locale : defaultLocale;
    let finalMessage = message.defaultMessage;
    if (node && locale.startsWith(defaultLocale)) {
        const { originalValue: originalValue } = node.attrs;
        if (originalValue.text || originalValue.attrs && originalValue.attrs.text) {
            finalMessage = originalValue.text ? originalValue.text : originalValue.attrs.text;
            canTranslateToLocale = false;
        } else if (originalValue.type) {
            finalMessage = `${prefix} ${originalValue.type}`;
            canTranslateToLocale = false;
        }
    }
    if (intl && canTranslateToLocale) return intl.formatMessage(message);
    return finalMessage;
}

});


parcelRegister("2DpUZ", function(module, exports) {

$parcel$export(module.exports, "WithCreateAnalyticsEvent", () => $10143a74d71d9da7$export$9ac3d19711324187);

var $5uXOq = parcelRequire("5uXOq");

var $cb25w = parcelRequire("cb25w");
const $10143a74d71d9da7$export$9ac3d19711324187 = (0, $cb25w.default)()(class WithCreateAnalyticsEvent extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { render: render, createAnalyticsEvent: createAnalyticsEvent } = this.props;
        return render(createAnalyticsEvent);
    }
});

});

parcelRegister("gE8f9", function(module, exports) {

$parcel$export(module.exports, "browser", () => $6911d91f679e4e6c$export$3f2684e5d7cb1006);
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6911d91f679e4e6c$export$3f2684e5d7cb1006 = {
    mac: false,
    windows: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    gecko_version: 0,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    safari_version: 0,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const ieEdge = /(?:Edge|Edg)\/(\d+)/.exec(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.mac = /Mac/.test(navigator.platform);
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.windows = // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    navigator.userAgentData?.platform === 'Windows' || // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /Windows|Win\d+/i.test(navigator.userAgent);
    const ie = $6911d91f679e4e6c$export$3f2684e5d7cb1006.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.ie_version = ieUpTo10 ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.gecko_version = parseInt((navigator.userAgent.match(/Firefox\/(\d+)/) || [])[1], 10);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.android = /Android \d/.test(navigator.userAgent);
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.ios = // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.safari_version = parseInt(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    (navigator.userAgent.match(/Version\/([0-9\._]+).*Safari/) || [])[1], 10);
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}

});

parcelRegister("iN9lO", function(module, exports) {

$parcel$export(module.exports, "startMeasure", () => $420059dd531814dc$export$b62aa2130c86b59b);
$parcel$export(module.exports, "stopMeasure", () => $420059dd531814dc$export$37c25be427bec097);
$parcel$export(module.exports, "clearMeasure", () => $420059dd531814dc$export$6f766653554dac02);

var $b7gJe = parcelRequire("b7gJe");
const $420059dd531814dc$var$measureMap = new Map();
function $420059dd531814dc$export$b62aa2130c86b59b(measureName) {
    if (!(0, $b7gJe.isPerformanceAPIAvailable)()) return;
    performance.mark(`${measureName}::start`);
    $420059dd531814dc$var$measureMap.set(measureName, performance.now());
}
function $420059dd531814dc$export$37c25be427bec097(measureName, onMeasureComplete) {
    if (!(0, $b7gJe.isPerformanceAPIAvailable)()) return;
    performance.mark(`${measureName}::end`);
    const start = onMeasureComplete ? $420059dd531814dc$var$measureMap.get(measureName) : undefined;
    try {
        performance.measure(measureName, `${measureName}::start`, `${measureName}::end`);
    } catch (error) {} finally{
        if (onMeasureComplete) {
            const entry = performance.getEntriesByName(measureName).pop();
            if (entry) onMeasureComplete(entry.duration, entry.startTime);
            else if (start) onMeasureComplete(performance.now() - start, start);
        }
        $420059dd531814dc$export$6f766653554dac02(measureName);
    }
}
function $420059dd531814dc$export$6f766653554dac02(measureName) {
    if (!(0, $b7gJe.isPerformanceAPIAvailable)()) return;
    $420059dd531814dc$var$measureMap.delete(measureName);
    performance.clearMarks(`${measureName}::start`);
    performance.clearMarks(`${measureName}::end`);
    performance.clearMeasures(measureName);
}
function $420059dd531814dc$export$b0a51f9f0047ea32(measureName) {
    if (!(0, $b7gJe.isPerformanceAPIAvailable)()) return false;
    return $420059dd531814dc$var$measureMap.get(measureName) !== undefined;
}

});
parcelRegister("b7gJe", function(module, exports) {

$parcel$export(module.exports, "isPerformanceAPIAvailable", () => $da51e67df7144cd5$export$b5717a625dd4a3eb);
$parcel$export(module.exports, "isPerformanceObserverAvailable", () => $da51e67df7144cd5$export$48995af1e77d8643);
let $da51e67df7144cd5$var$hasRequiredPerformanceAPIs;
function $da51e67df7144cd5$export$b5717a625dd4a3eb() {
    if ($da51e67df7144cd5$var$hasRequiredPerformanceAPIs === undefined) $da51e67df7144cd5$var$hasRequiredPerformanceAPIs = typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType',
        'now'
    ].every((api)=>!!performance[api]);
    return $da51e67df7144cd5$var$hasRequiredPerformanceAPIs;
}
function $da51e67df7144cd5$export$48995af1e77d8643() {
    return !!(typeof window !== 'undefined' && 'PerformanceObserver' in window);
}
function $da51e67df7144cd5$export$4370ec0f52022f66() {
    return $da51e67df7144cd5$export$48995af1e77d8643() && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes('longtask');
}

});


parcelRegister("ap7h6", function(module, exports) {

$parcel$export(module.exports, "getDistortedDurationMonitor", () => $3e05ce213e57560b$export$70f7d127254a90c);
$parcel$export(module.exports, "measureRender", () => $3e05ce213e57560b$export$267ed650a5d21ae6);

var $b7gJe = parcelRequire("b7gJe");
const $3e05ce213e57560b$export$70f7d127254a90c = ()=>{
    if (typeof document === 'undefined') return {
        distortedDuration: false,
        cleanup () {}
    };
    // If an editor is rendered when the document is not visible -- the callback passed to
    // requestAnimationFrame will not fire until the document becomes visible again.
    //
    // For the purposes of using performance measurement -- this behaviour means the events
    // which have been fired in the background are not useful -- and lead to other events
    // being hard to draw conclusions from.
    //
    // To mitigate this -- we detect this state -- and fire a separate callback when the
    // measurement has occurred when the render was in the background
    let distortedDuration = document.visibilityState !== 'visible';
    function handleVisibilityChange() {
        if (document.visibilityState !== 'visible') distortedDuration = true;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return {
        distortedDuration: distortedDuration,
        /**
		 * Cleans up the document visibility event listener
		 */ cleanup () {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        }
    };
};
function $3e05ce213e57560b$export$267ed650a5d21ae6(/**
	 * Unique name for the measurement
	 *
	 * Important: if multiple measureRender events are fired at the same time
	 * with the same measure name -- the result will not be correct.
	 */ measureName, /**
	 * Call back fired when the measurement completes.
	 *
	 * Note: when this function is called when the Document.visibilityState is not
	 * visible -- the duration is likely to be misleading/inaccurate. This is due
	 * to the measurements use of the `requestAnimationFrame` api which only fires
	 * when the Document.visibilityState is visible.
	 */ onMeasureComplete) {
    if (!(0, $b7gJe.isPerformanceAPIAvailable)()) return;
    const startMark = `[START]: ${measureName}`;
    const endMark = `[END]: ${measureName}`;
    const startTime = performance.now();
    performance.mark(startMark);
    const distortedDurationMonitor = $3e05ce213e57560b$export$70f7d127254a90c();
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            performance.mark(endMark);
            distortedDurationMonitor.cleanup();
            const duration = performance.now() - startTime;
            try {
                performance.measure(measureName, startMark, endMark);
                const entry = performance.getEntriesByName(measureName).pop();
                if (!entry) onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
                else onMeasureComplete({
                    duration: entry.duration,
                    startTime: entry.startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            } catch (e) {
                onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            }
            performance.clearMeasures(measureName);
            performance.clearMarks(startMark);
            performance.clearMarks(endMark);
        });
    });
}

});

parcelRegister("kFiBa", function(module, exports) {

$parcel$export(module.exports, "getResponseEndTime", () => $9d05c46136d117ff$export$92d097a1155bbe27);

var $b7gJe = parcelRequire("b7gJe");
function $9d05c46136d117ff$export$92d097a1155bbe27() {
    if (!(0, $b7gJe.isPerformanceAPIAvailable)()) return;
    const nav = performance.getEntriesByType('navigation')[0];
    if (nav) return nav.responseEnd;
    return;
}

});

parcelRegister("4NUlu", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsAppearance", () => $d9ce436f8d702318$export$be87849653b93e6b);
$parcel$export(module.exports, "getAnalyticsEditorAppearance", () => $d9ce436f8d702318$export$31ae53e002edded0);
$parcel$export(module.exports, "getAnalyticsEventSeverity", () => $d9ce436f8d702318$export$f8edd689e8b20f3a);
$parcel$export(module.exports, "findInsertLocation", () => $d9ce436f8d702318$export$d770b562ead089d8);
$parcel$export(module.exports, "analyticsEventKey", () => $d9ce436f8d702318$export$288273ee3e3b6132);

var $d93fQ = parcelRequire("d93fQ");

var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");

var $hFEwm = parcelRequire("hFEwm");
const $d9ce436f8d702318$export$be87849653b93e6b = (appearance)=>{
    switch(appearance){
        case 'full-page':
            return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).FIXED_WIDTH;
        case 'full-width':
            return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).FULL_WIDTH;
        case 'comment':
            return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).COMMENT;
        case 'chromeless':
            return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).CHROMELESS;
        case 'mobile':
            return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).MOBILE;
    }
};
const $d9ce436f8d702318$export$31ae53e002edded0 = (editorAppearance)=>editorAppearance ? `editor_${$d9ce436f8d702318$export$be87849653b93e6b(editorAppearance)}` : '_unknown';
const $d9ce436f8d702318$export$f8edd689e8b20f3a = (duration, normalThreshold, degradedThreshold)=>{
    if (duration > normalThreshold && duration <= degradedThreshold) return "degraded";
    if (duration > degradedThreshold) return "blocking";
    return "normal";
};
function $d9ce436f8d702318$export$d770b562ead089d8(selection) {
    const { schema: schema, name: name } = selection.$from.doc.type;
    if (selection instanceof (0, $gZGBX.NodeSelection)) return selection.node.type.name;
    if (selection instanceof (0, $hFEwm.CellSelection)) return schema.nodes.table.name;
    // Text selection
    const parentNodeInfo = (0, $5r0mK.findParentNode)((node)=>node.type !== schema.nodes.paragraph)(selection);
    return parentNodeInfo ? parentNodeInfo.node.type.name : name;
}
var $d9ce436f8d702318$export$6a6bef12562cd865 = /*#__PURE__*/ function(SEVERITY) {
    SEVERITY["NORMAL"] = "normal";
    SEVERITY["DEGRADED"] = "degraded";
    SEVERITY["BLOCKING"] = "blocking";
    return SEVERITY;
}({});
const $d9ce436f8d702318$export$288273ee3e3b6132 = 'EDITOR_ANALYTICS_EVENT';

});
parcelRegister("5r0mK", function(module, exports) {

$parcel$export(module.exports, "removeParentNodeOfType", () => $3f4fc20879d21ebe$export$5dd18664fe8bcbde);
$parcel$export(module.exports, "findParentNodeOfType", () => $3f4fc20879d21ebe$export$1a3a74094b9968e);
$parcel$export(module.exports, "replaceParentNodeOfType", () => $3f4fc20879d21ebe$export$b72cc612b642c071);
$parcel$export(module.exports, "removeSelectedNode", () => $3f4fc20879d21ebe$export$7d6e4e6663186878);
$parcel$export(module.exports, "isNodeSelection", () => $3f4fc20879d21ebe$export$a8c1d2c13abf8822);
$parcel$export(module.exports, "replaceSelectedNode", () => $3f4fc20879d21ebe$export$39874bca494f9ba3);
$parcel$export(module.exports, "setTextSelection", () => $3f4fc20879d21ebe$export$1df6d14df6b0b758);
$parcel$export(module.exports, "safeInsert", () => $3f4fc20879d21ebe$export$5fe92db78385e37c);
$parcel$export(module.exports, "canInsert", () => $3f4fc20879d21ebe$export$b4d1262a40ad21d4);
$parcel$export(module.exports, "removeNodeBefore", () => $3f4fc20879d21ebe$export$ffb1550ab6c3d03c);
$parcel$export(module.exports, "findPositionOfNodeBefore", () => $3f4fc20879d21ebe$export$f8088819b1e2c2dc);
$parcel$export(module.exports, "findParentNode", () => $3f4fc20879d21ebe$export$dc159056ffdb4c76);
$parcel$export(module.exports, "findParentNodeClosestToPos", () => $3f4fc20879d21ebe$export$fe09644e3bc6166b);
$parcel$export(module.exports, "findDomRefAtPos", () => $3f4fc20879d21ebe$export$666ce65defe9ad6e);
$parcel$export(module.exports, "hasParentNode", () => $3f4fc20879d21ebe$export$178ecaf80f45fdb6);
$parcel$export(module.exports, "findParentNodeOfTypeClosestToPos", () => $3f4fc20879d21ebe$export$8bf0d019bde85d18);
$parcel$export(module.exports, "hasParentNodeOfType", () => $3f4fc20879d21ebe$export$14f438bb7227ce63);
$parcel$export(module.exports, "findParentDomRefOfType", () => $3f4fc20879d21ebe$export$faeafc1151740116);
$parcel$export(module.exports, "findSelectedNodeOfType", () => $3f4fc20879d21ebe$export$924aa2dd4d9a67fa);
$parcel$export(module.exports, "flatten", () => $3f4fc20879d21ebe$export$bffa455ba8c619a6);
$parcel$export(module.exports, "findChildren", () => $3f4fc20879d21ebe$export$f94ca194e830789c);
$parcel$export(module.exports, "findChildrenByType", () => $3f4fc20879d21ebe$export$96bb9476c7c69f39);
$parcel$export(module.exports, "contains", () => $3f4fc20879d21ebe$export$2344b14b097df817);
// src/selection.ts

var $gZGBX = parcelRequire("gZGBX");

var $kCV8T = parcelRequire("kCV8T");
var $3f4fc20879d21ebe$export$5dd18664fe8bcbde = (nodeType)=>(tr)=>{
        const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $3f4fc20879d21ebe$var$removeNodeAtPos(parent.pos)(tr);
        return tr;
    };
var $3f4fc20879d21ebe$export$b72cc612b642c071 = (nodeType, content)=>(tr)=>{
        if (!Array.isArray(nodeType)) nodeType = [
            nodeType
        ];
        for(let i = 0, count = nodeType.length; i < count; i++){
            const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeType[i])(tr.selection);
            if (parent) {
                const newTr = $3f4fc20879d21ebe$var$replaceNodeAtPos(parent.pos, content)(tr);
                if (newTr !== tr) return newTr;
            }
        }
        return tr;
    };
var $3f4fc20879d21ebe$export$7d6e4e6663186878 = (tr)=>{
    if ($3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection)) {
        const from = tr.selection.$from.pos;
        const to = tr.selection.$to.pos;
        return $3f4fc20879d21ebe$var$cloneTr(tr.delete(from, to));
    }
    return tr;
};
var $3f4fc20879d21ebe$export$39874bca494f9ba3 = (content)=>(tr)=>{
        if ($3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection)) {
            const { $from: $from, $to: $to } = tr.selection;
            if (content instanceof (0, $kCV8T.Fragment) && $from.parent.canReplace($from.index(), $from.indexAfter(), content) || content instanceof (0, $kCV8T.Node) && $from.parent.canReplaceWith($from.index(), $from.indexAfter(), content.type)) return $3f4fc20879d21ebe$var$cloneTr(tr.replaceWith($from.pos, $to.pos, content).setSelection(new (0, $gZGBX.NodeSelection)(tr.doc.resolve($from.pos))));
        }
        return tr;
    };
var $3f4fc20879d21ebe$export$1df6d14df6b0b758 = (position, dir = 1)=>(tr)=>{
        const nextSelection = (0, $gZGBX.Selection).findFrom(tr.doc.resolve(position), dir, true);
        if (nextSelection) return tr.setSelection(nextSelection);
        return tr;
    };
var $3f4fc20879d21ebe$var$isSelectableNode = (node)=>Boolean(node instanceof (0, $kCV8T.Node) && node.type && node.type.spec.selectable);
var $3f4fc20879d21ebe$var$shouldSelectNode = (node)=>$3f4fc20879d21ebe$var$isSelectableNode(node) && node.type.isLeaf;
var $3f4fc20879d21ebe$var$setSelection = (node, pos, tr)=>{
    if ($3f4fc20879d21ebe$var$shouldSelectNode(node)) return tr.setSelection(new (0, $gZGBX.NodeSelection)(tr.doc.resolve(pos)));
    return $3f4fc20879d21ebe$export$1df6d14df6b0b758(pos)(tr);
};
var $3f4fc20879d21ebe$export$5fe92db78385e37c = (content, position, tryToReplace)=>(tr)=>{
        const hasPosition = typeof position === "number";
        const { $from: $from } = tr.selection;
        const $insertPos = hasPosition ? tr.doc.resolve(position) : $3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection) ? tr.doc.resolve($from.pos + 1) : $from;
        const { parent: parent } = $insertPos;
        if ($3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection) && tryToReplace) {
            const oldTr = tr;
            tr = $3f4fc20879d21ebe$export$39874bca494f9ba3(content)(tr);
            if (oldTr !== tr) return tr;
        }
        if ($3f4fc20879d21ebe$var$isEmptyParagraph(parent)) {
            const oldTr = tr;
            tr = $3f4fc20879d21ebe$export$b72cc612b642c071(parent.type, content)(tr);
            if (oldTr !== tr) {
                const pos = $3f4fc20879d21ebe$var$isSelectableNode(content) ? // for selectable node, selection position would be the position of the replaced parent
                $insertPos.before($insertPos.depth) : $insertPos.pos;
                return $3f4fc20879d21ebe$var$setSelection(content, pos, tr);
            }
        }
        if ($3f4fc20879d21ebe$export$b4d1262a40ad21d4($insertPos, content)) {
            tr.insert($insertPos.pos, content);
            const pos = hasPosition ? $insertPos.pos : $3f4fc20879d21ebe$var$isSelectableNode(content) ? // for atom nodes selection position after insertion is the previous pos
            tr.selection.$anchor.pos - 1 : tr.selection.$anchor.pos;
            return $3f4fc20879d21ebe$var$cloneTr($3f4fc20879d21ebe$var$setSelection(content, pos, tr));
        }
        for(let i = $insertPos.depth; i > 0; i--){
            const pos = $insertPos.after(i);
            const $pos = tr.doc.resolve(pos);
            if ($3f4fc20879d21ebe$export$b4d1262a40ad21d4($pos, content)) {
                tr.insert(pos, content);
                return $3f4fc20879d21ebe$var$cloneTr($3f4fc20879d21ebe$var$setSelection(content, pos, tr));
            }
        }
        return tr;
    };
var $3f4fc20879d21ebe$export$36491a9ea218d882 = (nodeType, type, attrs, marks)=>(tr)=>{
        const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $3f4fc20879d21ebe$var$cloneTr(tr.setNodeMarkup(parent.pos, type, Object.assign({}, parent.node.attrs, attrs), marks));
        return tr;
    };
var $3f4fc20879d21ebe$export$7f11cc48adfe3aed = (nodeType)=>(tr)=>{
        if (!$3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection)) {
            const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeType)(tr.selection);
            if (parent) return $3f4fc20879d21ebe$var$cloneTr(tr.setSelection((0, $gZGBX.NodeSelection).create(tr.doc, parent.pos)));
        }
        return tr;
    };
var $3f4fc20879d21ebe$export$ffb1550ab6c3d03c = (tr)=>{
    const position = $3f4fc20879d21ebe$export$f8088819b1e2c2dc(tr.selection);
    if (typeof position === "number") return $3f4fc20879d21ebe$var$removeNodeAtPos(position)(tr);
    return tr;
};
// src/helpers.ts
var $3f4fc20879d21ebe$export$a8c1d2c13abf8822 = (selection)=>{
    return selection instanceof (0, $gZGBX.NodeSelection);
};
var $3f4fc20879d21ebe$var$equalNodeType = (nodeType, node)=>{
    return Array.isArray(nodeType) && nodeType.indexOf(node.type) > -1 || node.type === nodeType;
};
var $3f4fc20879d21ebe$var$cloneTr = (tr)=>{
    return Object.assign(Object.create(tr), tr).setTime(Date.now());
};
var $3f4fc20879d21ebe$var$replaceNodeAtPos = (position, content)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        const $pos = tr.doc.resolve(position);
        if (!node) return tr;
        if ($3f4fc20879d21ebe$var$canReplace($pos, content)) {
            tr = tr.replaceWith(position, position + node.nodeSize, content);
            const start = tr.selection.$from.pos - 1;
            tr = $3f4fc20879d21ebe$export$1df6d14df6b0b758(Math.max(start, 0), -1)(tr);
            tr = $3f4fc20879d21ebe$export$1df6d14df6b0b758(tr.selection.$from.start())(tr);
            return $3f4fc20879d21ebe$var$cloneTr(tr);
        }
        return tr;
    };
var $3f4fc20879d21ebe$var$canReplace = ($pos, content)=>{
    const node = $pos.node($pos.depth);
    return node && node.type.validContent(content instanceof (0, $kCV8T.Fragment) ? content : (0, $kCV8T.Fragment).from(content));
};
var $3f4fc20879d21ebe$var$removeNodeAtPos = (position)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        if (!node) return tr;
        return $3f4fc20879d21ebe$var$cloneTr(tr.delete(position, position + node.nodeSize));
    };
var $3f4fc20879d21ebe$export$b4d1262a40ad21d4 = ($pos, content)=>{
    const index = $pos.index();
    if (content instanceof (0, $kCV8T.Fragment)) return $pos.parent.canReplace(index, index, content);
    else if (content instanceof (0, $kCV8T.Node)) return $pos.parent.canReplaceWith(index, index, content.type);
    return false;
};
var $3f4fc20879d21ebe$var$isEmptyParagraph = (node)=>{
    return !node || node.type.name === "paragraph" && node.nodeSize === 2;
};
// src/selection.ts
var $3f4fc20879d21ebe$export$dc159056ffdb4c76 = (predicate)=>({ $from: $from, $to: $to }, validateSameParent = false)=>{
        if (validateSameParent && !$from.sameParent($to)) {
            let depth = Math.min($from.depth, $to.depth);
            while(depth >= 0){
                const fromNode = $from.node(depth);
                const toNode = $to.node(depth);
                if (toNode === fromNode) {
                    if (predicate(fromNode)) return {
                        // Return the resolved pos
                        pos: depth > 0 ? $from.before(depth) : 0,
                        start: $from.start(depth),
                        depth: depth,
                        node: fromNode
                    };
                }
                depth = depth - 1;
            }
            return;
        }
        return $3f4fc20879d21ebe$export$fe09644e3bc6166b($from, predicate);
    };
var $3f4fc20879d21ebe$export$fe09644e3bc6166b = ($pos, predicate)=>{
    for(let i = $pos.depth; i > 0; i--){
        const node = $pos.node(i);
        if (predicate(node)) return {
            pos: i > 0 ? $pos.before(i) : 0,
            start: $pos.start(i),
            depth: i,
            node: node
        };
    }
};
var $3f4fc20879d21ebe$export$8556d79fa8189214 = (predicate, domAtPos)=>(selection)=>{
        const parent = $3f4fc20879d21ebe$export$dc159056ffdb4c76(predicate)(selection);
        if (parent) return $3f4fc20879d21ebe$export$666ce65defe9ad6e(parent.pos, domAtPos);
    };
var $3f4fc20879d21ebe$export$178ecaf80f45fdb6 = (predicate)=>(selection)=>{
        return !!$3f4fc20879d21ebe$export$dc159056ffdb4c76(predicate)(selection);
    };
var $3f4fc20879d21ebe$export$1a3a74094b9968e = (nodeType)=>(selection)=>{
        return $3f4fc20879d21ebe$export$dc159056ffdb4c76((node)=>$3f4fc20879d21ebe$var$equalNodeType(nodeType, node))(selection);
    };
var $3f4fc20879d21ebe$export$8bf0d019bde85d18 = ($pos, nodeType)=>{
    return $3f4fc20879d21ebe$export$fe09644e3bc6166b($pos, (node)=>$3f4fc20879d21ebe$var$equalNodeType(nodeType, node));
};
var $3f4fc20879d21ebe$export$14f438bb7227ce63 = (nodeType)=>(selection)=>{
        return $3f4fc20879d21ebe$export$178ecaf80f45fdb6((node)=>$3f4fc20879d21ebe$var$equalNodeType(nodeType, node))(selection);
    };
var $3f4fc20879d21ebe$export$faeafc1151740116 = (nodeType, domAtPos)=>(selection)=>{
        return $3f4fc20879d21ebe$export$8556d79fa8189214((node)=>$3f4fc20879d21ebe$var$equalNodeType(nodeType, node), domAtPos)(selection);
    };
var $3f4fc20879d21ebe$export$924aa2dd4d9a67fa = (nodeType)=>(selection)=>{
        if ($3f4fc20879d21ebe$export$a8c1d2c13abf8822(selection)) {
            const { node: node, $from: $from } = selection;
            if ($3f4fc20879d21ebe$var$equalNodeType(nodeType, node)) return {
                node: node,
                start: $from.start(),
                pos: $from.pos,
                depth: $from.depth
            };
        }
    };
var $3f4fc20879d21ebe$export$f8088819b1e2c2dc = (selection)=>{
    const { nodeBefore: nodeBefore } = selection.$from;
    const maybeSelection = (0, $gZGBX.Selection).findFrom(selection.$from, -1);
    if (maybeSelection && nodeBefore) {
        const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeBefore.type)(maybeSelection);
        if (parent) return parent.pos;
        return maybeSelection.$from.pos;
    }
};
var $3f4fc20879d21ebe$export$666ce65defe9ad6e = (position, domAtPos)=>{
    const dom = domAtPos(position);
    const node = dom.node.childNodes[dom.offset];
    if (dom.node.nodeType === Node.TEXT_NODE && dom.node.parentNode) return dom.node.parentNode;
    if (!node || node.nodeType === Node.TEXT_NODE) return dom.node;
    return node;
};
// src/node.ts
var $3f4fc20879d21ebe$export$bffa455ba8c619a6 = (node, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    const result = [];
    node.descendants((child, pos)=>{
        result.push({
            node: child,
            pos: pos
        });
        if (!descend) return false;
    });
    return result;
};
var $3f4fc20879d21ebe$export$f94ca194e830789c = (node, predicate, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    else if (!predicate) throw new Error('Invalid "predicate" parameter');
    return $3f4fc20879d21ebe$export$bffa455ba8c619a6(node, descend).filter((child)=>predicate(child.node));
};
var $3f4fc20879d21ebe$export$53418710fbc2d8cc = (node, descend = true)=>{
    return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>child.isText, descend);
};
var $3f4fc20879d21ebe$export$ddc1620722e25671 = (node, descend = true)=>{
    return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>child.isInline, descend);
};
var $3f4fc20879d21ebe$export$cae8d7f259e5bbe9 = (node, descend = true)=>{
    return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>child.isBlock, descend);
};
var $3f4fc20879d21ebe$export$a836476a7f9de5b4 = (node, predicate, descend = true)=>{
    return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>!!predicate(child.attrs), descend);
};
var $3f4fc20879d21ebe$export$96bb9476c7c69f39 = (node, nodeType, descend = true)=>{
    return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>child.type === nodeType, descend);
};
var $3f4fc20879d21ebe$export$c01a9e7ec615e821 = (node, markType, descend = true)=>{
    return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>Boolean(markType.isInSet(child.marks)), descend);
};
var $3f4fc20879d21ebe$export$2344b14b097df817 = (node, nodeType)=>{
    return !!$3f4fc20879d21ebe$export$96bb9476c7c69f39(node, nodeType).length;
};

});

parcelRegister("hFEwm", function(module, exports) {

$parcel$export(module.exports, "CellSelection", () => $451fe475e5e2c47a$export$831cc7e2a83afa94);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
// Was copied from https://github.com/ProseMirror/prosemirror-tables/blob/master/src/cellselection.js
// This file defines a ProseMirror selection subclass that models
// table cell selections. The table plugin needs to be active to wire
// in the user interaction part of table selections (so that you
// actually get such selections when you select across cells).

var $kCV8T = parcelRequire("kCV8T");

var $gZGBX = parcelRequire("gZGBX");

var $6MNnJ = parcelRequire("6MNnJ");

var $uOUlv = parcelRequire("uOUlv");

var $6hQQ3 = parcelRequire("6hQQ3");

var $6e6o8 = parcelRequire("6e6o8");

var $aKDxB = parcelRequire("aKDxB");

var $bQFBc = parcelRequire("bQFBc");
class $451fe475e5e2c47a$export$831cc7e2a83afa94 extends (0, $gZGBX.Selection) {
    constructor($anchorCell, $headCell = $anchorCell){
        const ranges = (0, $aKDxB.getCellSelectionRanges)($anchorCell, $headCell);
        super(ranges[0].$from, ranges[0].$to, ranges);
        // :: ResolvedPos
        // A resolved position pointing _in front of_ the anchor cell (the one
        // that doesn't move when extending the selection).
        this.$anchorCell = $anchorCell;
        // :: ResolvedPos
        // A resolved position pointing in front of the head cell (the one
        // moves when extending the selection).
        this.$headCell = $headCell;
        this.visible = false;
    }
    map(doc, mapping) {
        const $anchorCell = doc.resolve(mapping.map(this.$anchorCell.pos));
        const $headCell = doc.resolve(mapping.map(this.$headCell.pos));
        if ((0, $6hQQ3.pointsAtCell)($anchorCell) && (0, $6hQQ3.pointsAtCell)($headCell) && (0, $bQFBc.inSameTable)($anchorCell, $headCell)) {
            const tableChanged = this.$anchorCell.node(-1) !== $anchorCell.node(-1);
            if (tableChanged && this.isRowSelection()) return $451fe475e5e2c47a$export$831cc7e2a83afa94.rowSelection($anchorCell, $headCell);
            if (tableChanged && this.isColSelection()) return $451fe475e5e2c47a$export$831cc7e2a83afa94.colSelection($anchorCell, $headCell);
            return new $451fe475e5e2c47a$export$831cc7e2a83afa94($anchorCell, $headCell);
        }
        return (0, $gZGBX.TextSelection).between($anchorCell, $headCell);
    }
    // :: () → Slice
    // Returns a rectangular slice of table rows containing the selected
    // cells.
    content() {
        const table = this.$anchorCell.node(-1);
        const map = (0, $uOUlv.TableMap).get(table);
        const start = this.$anchorCell.start(-1);
        const rect = map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start);
        const seen = {};
        const rows = [];
        for(let row = rect.top; row < rect.bottom; row++){
            const rowContent = [];
            for(let index = row * map.width + rect.left, col = rect.left; col < rect.right; col++, index++){
                const pos = map.map[index];
                if (!seen[pos]) {
                    seen[pos] = true;
                    const cellRect = map.findCell(pos);
                    let cell = table.nodeAt(pos);
                    if (cell === null || cell === undefined) throw new Error(`No cell at position ${pos}`);
                    const extraLeft = rect.left - cellRect.left;
                    const extraRight = cellRect.right - rect.right;
                    if (extraLeft > 0 || extraRight > 0) {
                        let { attrs: attrs } = cell;
                        if (!attrs) throw new Error(`No cell at position ${pos}`);
                        if (extraLeft > 0) attrs = (0, $6e6o8.removeColSpan)(attrs, 0, extraLeft);
                        if (extraRight > 0) // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        attrs = (0, $6e6o8.removeColSpan)(attrs, attrs.colspan - extraRight, extraRight);
                        if (cellRect.left < rect.left) cell = cell.type.createAndFill(attrs);
                        else cell = cell.type.create(attrs, cell.content);
                    }
                    if (cell === null || cell === undefined) throw new Error(`No cell at position after create/createAndFill`);
                    if (cellRect.top < rect.top || cellRect.bottom > rect.bottom) {
                        const attrs = {
                            ...cell.attrs,
                            rowspan: Math.min(cellRect.bottom, rect.bottom) - Math.max(cellRect.top, rect.top)
                        };
                        if (cellRect.top < rect.top) cell = cell.type.createAndFill(attrs);
                        else cell = cell.type.create(attrs, cell.content);
                    }
                    if (cell === null || cell === undefined) throw new Error(`No cell at position before rowContent.push`);
                    rowContent.push(cell);
                }
            }
            rows.push(table.child(row).copy((0, $kCV8T.Fragment).from(rowContent)));
        }
        const fragment = this.isColSelection() && this.isRowSelection() ? table : rows;
        return new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(fragment), 1, 1);
    }
    replace(tr, content = (0, $kCV8T.Slice).empty) {
        const mapFrom = tr.steps.length;
        const { ranges: ranges } = this;
        for(let i = 0; i < ranges.length; i++){
            const { $from: $from, $to: $to } = ranges[i];
            const mapping = tr.mapping.slice(mapFrom);
            tr.replace(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $kCV8T.Slice).empty : content);
        }
        const sel = (0, $gZGBX.Selection).findFrom(tr.doc.resolve(tr.mapping.slice(mapFrom).map(this.to)), -1);
        if (sel) tr.setSelection(sel);
    }
    replaceWith(tr, node) {
        this.replace(tr, new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(node), 0, 0));
    }
    forEachCell(f) {
        const table = this.$anchorCell.node(-1);
        const map = (0, $uOUlv.TableMap).get(table);
        const start = this.$anchorCell.start(-1);
        const cells = map.cellsInRect(map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start));
        for(let i = 0; i < cells.length; i++){
            const cell = table.nodeAt(cells[i]);
            if (cell === null || cell === undefined) throw new Error(`undefined cell at pos ${cells[i]}`);
            f(cell, start + cells[i]);
        }
    }
    // :: () → bool
    // True if this selection goes all the way from the top to the
    // bottom of the table.
    isColSelection() {
        if (!this.$anchorCell || !this.$headCell) throw new Error('invalid $anchorCell or $headCell');
        const anchorTop = this.$anchorCell.index(-1);
        const headTop = this.$headCell.index(-1);
        if (Math.min(anchorTop, headTop) > 0) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const anchorBot = anchorTop + this.$anchorCell.nodeAfter.attrs.rowspan;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const headBot = headTop + this.$headCell.nodeAfter.attrs.rowspan;
        return Math.max(anchorBot, headBot) === this.$headCell.node(-1).childCount;
    }
    // :: (ResolvedPos, ?ResolvedPos) → CellSelection
    // Returns the smallest column selection that covers the given anchor
    // and head cell.
    static colSelection($anchorCell, $headCell = $anchorCell) {
        let $calculatedAnchorCell = $anchorCell;
        let $calculatedHeadCell = $headCell;
        const map = (0, $uOUlv.TableMap).get($calculatedAnchorCell.node(-1));
        const start = $calculatedAnchorCell.start(-1);
        const anchorRect = map.findCell($calculatedAnchorCell.pos - start);
        const headRect = map.findCell($calculatedHeadCell.pos - start);
        const doc = $calculatedAnchorCell.node(0);
        if (anchorRect.top <= headRect.top) {
            if (anchorRect.top > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.left]);
            if (headRect.bottom < map.height) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (map.height - 1) + headRect.right - 1]);
        } else {
            if (headRect.top > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.left]);
            if (anchorRect.bottom < map.height) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (map.height - 1) + anchorRect.right - 1]);
        }
        return new $451fe475e5e2c47a$export$831cc7e2a83afa94($calculatedAnchorCell, $calculatedHeadCell);
    }
    // :: () → bool
    // True if this selection goes all the way from the left to the
    // right of the table.
    isRowSelection() {
        if (!this.$anchorCell || !this.$headCell) return false;
        const start = this.$anchorCell.start(-1);
        const map = (0, $uOUlv.TableMap).get(this.$anchorCell.node(-1));
        const rowAtAnchorCell = map.rowCount(this.$anchorCell.pos - start);
        const rowAtHeadCell = map.rowCount(this.$headCell.pos - start);
        const isSelectionSameRow = rowAtAnchorCell === rowAtHeadCell;
        // if anchor and head in the same line, counting how many cells
        // should be in the row except merged cell
        const maxColumnInSelectedRow = map.getMaxColInRow(this.$anchorCell);
        // if selected cells less than table max column amount, and
        // the anchor/head not in a merged cell
        // it should be select maxColumnInSelectedRow to be TRUE
        if (isSelectionSameRow && this.ranges.length <= map.width && !map.isPosMerged(this.$anchorCell.pos - start) && !map.isPosMerged(this.$headCell.pos - start)) return this.ranges.length === maxColumnInSelectedRow;
        // If anchor and head in different row, it should be always in first and
        // last column to select the whole row.
        const anchorLeft = map.colCount(this.$anchorCell.pos - start);
        const headLeft = map.colCount(this.$headCell.pos - start);
        if (Math.min(anchorLeft, headLeft) > 0) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const anchorRight = anchorLeft + this.$anchorCell.nodeAfter.attrs.colspan;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const headRight = headLeft + this.$headCell.nodeAfter.attrs.colspan;
        return Math.max(anchorRight, headRight) === map.width;
    }
    eq(other) {
        return other instanceof $451fe475e5e2c47a$export$831cc7e2a83afa94 && other.$anchorCell.pos === this.$anchorCell.pos && other.$headCell.pos === this.$headCell.pos;
    }
    // :: (ResolvedPos, ?ResolvedPos) → CellSelection
    // Returns the smallest row selection that covers the given anchor
    // and head cell.
    static rowSelection($anchorCell, $headCell = $anchorCell) {
        let $calculatedAnchorCell = $anchorCell;
        let $calculatedHeadCell = $headCell;
        const map = (0, $uOUlv.TableMap).get($calculatedAnchorCell.node(-1));
        const start = $calculatedAnchorCell.start(-1);
        const anchorRect = map.findCell($calculatedAnchorCell.pos - start);
        const headRect = map.findCell($calculatedHeadCell.pos - start);
        const doc = $calculatedAnchorCell.node(0);
        if (anchorRect.left <= headRect.left) {
            if (anchorRect.left > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.top * map.width]);
            if (headRect.right < map.width) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (headRect.top + 1) - 1]);
        } else {
            if (headRect.left > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.top * map.width]);
            if (anchorRect.right < map.width) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (anchorRect.top + 1) - 1]);
        }
        return new $451fe475e5e2c47a$export$831cc7e2a83afa94($calculatedAnchorCell, $calculatedHeadCell);
    }
    toJSON() {
        return {
            type: 'cell',
            anchor: this.$anchorCell.pos,
            head: this.$headCell.pos
        };
    }
    static fromJSON(doc, json) {
        return new $451fe475e5e2c47a$export$831cc7e2a83afa94(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    // :: (Node, number, ?number) → CellSelection
    static create(doc, anchorCell, headCell = anchorCell) {
        return new $451fe475e5e2c47a$export$831cc7e2a83afa94(doc.resolve(anchorCell), doc.resolve(headCell));
    }
    getBookmark() {
        return new (0, $6MNnJ.CellBookmark)(this.$anchorCell.pos, this.$headCell.pos);
    }
}
(0, $gZGBX.Selection).jsonID('cell', $451fe475e5e2c47a$export$831cc7e2a83afa94);

});
parcelRegister("6MNnJ", function(module, exports) {

$parcel$export(module.exports, "CellBookmark", () => $7bc56074adb266b5$export$ca751a6394ad160e);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $gZGBX = parcelRequire("gZGBX");

var $bQFBc = parcelRequire("bQFBc");
class $7bc56074adb266b5$export$ca751a6394ad160e {
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new $7bc56074adb266b5$export$ca751a6394ad160e(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        const $anchorCell = doc.resolve(this.anchor);
        const $headCell = doc.resolve(this.head);
        if ($anchorCell.parent.type.spec.tableRole === 'row' && $headCell.parent.type.spec.tableRole === 'row' && $anchorCell.index() < $anchorCell.parent.childCount && $headCell.index() < $headCell.parent.childCount && (0, $bQFBc.inSameTable)($anchorCell, $headCell)) {
            const data = {
                type: 'cell',
                anchor: $anchorCell.pos,
                head: $headCell.pos
            };
            return (0, $gZGBX.Selection).fromJSON(doc, data);
        }
        return (0, $gZGBX.Selection).near($headCell, 1);
    }
}

});
parcelRegister("bQFBc", function(module, exports) {

$parcel$export(module.exports, "isInTable", () => $e501ca8feab95168$export$217a88ad224d1b11);
$parcel$export(module.exports, "inSameTable", () => $e501ca8feab95168$export$debd62b44eb7e281);
function $e501ca8feab95168$export$217a88ad224d1b11(state) {
    const { $head: $head } = state.selection;
    for(let d = $head.depth; d > 0; d--){
        if ($head.node(d).type.spec.tableRole === 'row') return true;
    }
    return false;
}
function $e501ca8feab95168$export$debd62b44eb7e281($a, $b) {
    return $a.depth === $b.depth && $a.pos >= $b.start(-1) && $a.pos <= $b.end(-1);
}

});


parcelRegister("uOUlv", function(module, exports) {

$parcel$export(module.exports, "Rect", () => $ca500cf7ecedd822$export$c79fc6492f3af13d);
$parcel$export(module.exports, "TableProblemTypes", () => $ca500cf7ecedd822$export$d8cd393a71edca79);
$parcel$export(module.exports, "TableMap", () => $ca500cf7ecedd822$export$493da463fed0a57a);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
// Because working with row and column-spanning cells is not quite
// trivial, this code builds up a descriptive structure for a given
// table node. The structures are cached with the (persistent) table
// nodes as key, so that they only have to be recomputed when the
// content of the table changes.
//
// This does mean that they have to store table-relative, not
// document-relative positions. So code that uses them will typically
// compute the start position of the table and offset positions passed
// to or gotten from this structure by that amount.
let $ca500cf7ecedd822$var$readFromCache, $ca500cf7ecedd822$var$addToCache;
// Prefer using a weak map to cache table maps. Fall back on a
// fixed-size cache if that's not supported.
if (typeof WeakMap !== 'undefined') {
    const cache = new WeakMap();
    $ca500cf7ecedd822$var$readFromCache = (key)=>cache.get(key);
    $ca500cf7ecedd822$var$addToCache = (key, value)=>{
        cache.set(key, value);
        return value;
    };
} else {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cache = [];
    const cacheSize = 10;
    let cachePos = 0;
    $ca500cf7ecedd822$var$readFromCache = (key)=>{
        for(let i = 0; i < cache.length; i += 2){
            if (cache[i] === key) return cache[i + 1];
        }
    };
    $ca500cf7ecedd822$var$addToCache = (key, value)=>{
        if (cachePos === cacheSize) cachePos = 0;
        cache[cachePos++] = key;
        return cache[cachePos++] = value;
    };
}
class $ca500cf7ecedd822$export$c79fc6492f3af13d {
    constructor(left, top, right, bottom){
        this.left = left;
        this.top = top;
        this.right = right;
        this.bottom = bottom;
    }
}
var $ca500cf7ecedd822$export$d8cd393a71edca79 = /*#__PURE__*/ function(TableProblemTypes) {
    TableProblemTypes["COLLISION"] = "collision";
    TableProblemTypes["OVERLONG_ROWSPAN"] = "overlong_rowspan";
    TableProblemTypes["MISSING"] = "missing";
    TableProblemTypes["COLWIDTH_MISMATCH"] = "colwidth mismatch";
    return TableProblemTypes;
}({});
const $ca500cf7ecedd822$export$c60fae4049791eae = 140;
class $ca500cf7ecedd822$export$493da463fed0a57a {
    constructor(width, height, map, problems, mapByColumn, mapByRow){
        this.mapByColumn = [];
        this.mapByRow = [];
        this.width = width;
        this.height = height;
        this.mapByColumn = mapByColumn || [];
        this.mapByRow = mapByRow || [];
        // :: [number] A width * height array with the start position of
        // the cell covering that part of the table in each slot
        this.map = map;
        // An optional array of problems (cell overlap or non-rectangular
        // shape) for the table, used by the table normalizer.
        this.problems = problems;
    }
    // :: (number) → Rect
    // Find the dimensions of the cell at the given position.
    findCell(pos) {
        for(let i = 0; i < this.map.length; i++){
            const curPos = this.map[i];
            if (curPos !== pos) continue;
            const left = i % this.width;
            const top = i / this.width | 0;
            let right = left + 1;
            let bottom = top + 1;
            for(let j = 1; right < this.width && this.map[i + j] === curPos; j++)right++;
            for(let j = 1; bottom < this.height && this.map[i + this.width * j] === curPos; j++)bottom++;
            return new $ca500cf7ecedd822$export$c79fc6492f3af13d(left, top, right, bottom);
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    // Find the left side of the cell at the given position.
    colCount(pos) {
        for(let i = 0; i < this.map.length; i++){
            if (this.map[i] === pos) return i % this.width;
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    // Find the top side of the cell at the given position.
    rowCount(pos) {
        if (this.width <= 0) throw new RangeError('Wrong table width found');
        for(let i = 0; i < this.map.length; i++){
            if (this.map[i] === pos) return Math.floor(i / this.width);
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    isPosMerged(pos) {
        return this.map.includes(pos, this.map.indexOf(pos) + 1);
    }
    isCellMerged(row, col) {
        return this.isCellMergedTopLeft(row, col) || this.isCellMergedBottomRight(row, col);
    }
    isCellMergedTopLeft(row, col) {
        const pos = this.map[row * this.width + col];
        return(// top
        row > 0 && pos === this.map[(row - 1) * this.width + col] || // left
        col > 0 && pos === this.map[row * this.width + (col - 1)]);
    }
    isCellMergedBottomRight(row, col) {
        const pos = this.map[row * this.width + col];
        return(// bottom
        row < this.height - 1 && pos === this.map[(row + 1) * this.width + col] || // right
        col < this.width - 1 && pos === this.map[row * this.width + (col + 1)]);
    }
    // :: (number, string, number) → ?number
    // Find the next cell in the given direction, starting from the cell
    // at `pos`, if any.
    nextCell(pos, axis, dir) {
        const { left: left, right: right, top: top, bottom: bottom } = this.findCell(pos);
        if (axis === 'horiz') {
            if (dir < 0 ? left === 0 : right === this.width) return null;
            return this.map[top * this.width + (dir < 0 ? left - 1 : right)];
        } else {
            if (dir < 0 ? top === 0 : bottom === this.height) return null;
            return this.map[left + this.width * (dir < 0 ? top - 1 : bottom)];
        }
    }
    // :: (number, number) → Rect
    // Get the rectangle spanning the two given cells.
    rectBetween(a, b) {
        const { left: leftA, right: rightA, top: topA, bottom: bottomA } = this.findCell(a);
        const { left: leftB, right: rightB, top: topB, bottom: bottomB } = this.findCell(b);
        return new $ca500cf7ecedd822$export$c79fc6492f3af13d(Math.min(leftA, leftB), Math.min(topA, topB), Math.max(rightA, rightB), Math.max(bottomA, bottomB));
    }
    // :: (Rect) → [number]
    // Return the position of all cells that have the top left corner in
    // the given rectangle.
    cellsInRect(rect) {
        const result = [];
        const seen = {};
        for(let row = rect.top; row < rect.bottom; row++)for(let col = rect.left; col < rect.right; col++){
            const index = row * this.width + col;
            const pos = this.map[index];
            if (seen[pos]) continue;
            seen[pos] = true;
            if ((col !== rect.left || !col || this.map[index - 1] !== pos) && (row !== rect.top || !row || this.map[index - this.width] !== pos)) result.push(pos);
        }
        return result;
    }
    // :: (number, number, Node) → number
    // Return the position at which the cell at the given row and column
    // starts, or would start, if a cell started there.
    positionAt(row, col, table) {
        for(let i = 0, rowStart = 0;; i++){
            const rowEnd = rowStart + table.child(i).nodeSize;
            if (i === row) {
                let index = col + row * this.width;
                const rowEndIndex = (row + 1) * this.width;
                // Skip past cells from previous rows (via rowspan)
                while(index < rowEndIndex && this.map[index] < rowStart)index++;
                return index === rowEndIndex ? rowEnd - 1 : this.map[index];
            }
            rowStart = rowEnd;
        }
    }
    getMaxColInRow(pos) {
        const parentRowNode = pos.parent;
        if (parentRowNode.type.name === 'tableRow') return parentRowNode.childCount;
    }
    hasMergedCells() {
        const uniquePositions = new Set(this.map);
        return uniquePositions.size !== this.map.length;
    }
    // :: (Node) → TableMap
    // Find the table map for the given table node.
    static get(table) {
        return $ca500cf7ecedd822$var$readFromCache(table) || $ca500cf7ecedd822$var$addToCache(table, $ca500cf7ecedd822$var$computeMap(table));
    }
}
// Compute a table map.
function $ca500cf7ecedd822$var$computeMap(table) {
    if (table.type.spec.tableRole !== 'table') throw new RangeError('Not a table node: ' + table.type.name);
    const width = $ca500cf7ecedd822$var$findWidth(table);
    const height = table.childCount;
    const map = [];
    const colWidths = [];
    let mapPos = 0, problems = null;
    for(let i = 0, e = width * height; i < e; i++)map[i] = 0;
    for(let row = 0, pos = 0; row < height; row++){
        const rowNode = table.child(row);
        pos++;
        for(let i = 0;; i++){
            while(mapPos < map.length && map[mapPos] !== 0)mapPos++;
            if (i === rowNode.childCount) break;
            const cellNode = rowNode.child(i), { colspan: colspan, rowspan: rowspan, colwidth: colwidth } = cellNode.attrs;
            for(let h = 0; h < rowspan; h++){
                if (h + row >= height) {
                    (problems || (problems = [])).push({
                        type: "overlong_rowspan",
                        pos: pos,
                        n: rowspan - h
                    });
                    break;
                }
                const start = mapPos + h * width;
                for(let w = 0; w < colspan; w++){
                    if (map[start + w] === 0) map[start + w] = pos;
                    else (problems || (problems = [])).push({
                        type: "collision",
                        row: row,
                        pos: pos,
                        n: colspan - w
                    });
                    const colW = colwidth && colwidth[w];
                    if (colW) {
                        const widthIndex = (start + w) % width * 2, prev = colWidths[widthIndex];
                        if (prev == null || prev !== colW && colWidths[widthIndex + 1] === 1) {
                            colWidths[widthIndex] = colW;
                            colWidths[widthIndex + 1] = 1;
                        } else if (prev === colW) colWidths[widthIndex + 1]++;
                    }
                }
            }
            mapPos += colspan;
            pos += cellNode.nodeSize;
        }
        const expectedPos = (row + 1) * width;
        let missing = 0;
        while(mapPos < expectedPos)if (map[mapPos++] === 0) missing++;
        if (missing) (problems || (problems = [])).push({
            type: "missing",
            row: row,
            n: missing
        });
        pos++;
    }
    const mapByRow = Array(height);
    const mapByColumn = Array(width);
    for(let i = 0; i < map.length; i++){
        const columnIndex = i % width;
        mapByColumn[columnIndex] = mapByColumn[columnIndex] ?? [];
        mapByColumn[columnIndex].push(map[i]);
        const rowIndex = Math.trunc(i / width);
        mapByRow[rowIndex] = mapByRow[rowIndex] ?? [];
        mapByRow[rowIndex].push(map[i]);
    }
    const tableMap = new $ca500cf7ecedd822$export$493da463fed0a57a(width, height, map, problems, mapByColumn, mapByRow);
    let badWidths = false;
    // For columns that have defined widths, but whose widths disagree
    // between rows, fix up the cells whose width doesn't match the
    // computed one.
    for(let i = 0; !badWidths && i < colWidths.length; i += 2)if (colWidths[i] != null && colWidths[i + 1] < height) badWidths = true;
    // colWidths is an array of numbers, it can look like this
    // const colWidths = [255, 3, 125, 3, 150, 2, 130, 1];
    // 255 is a colWidth and 3 is a number of cells with this colwidth.
    // This check exists to make sure that the table has been resized,
    // which means there will be elements in the colWidths array.
    if (colWidths.length > 0 && colWidths.length !== width * 2) {
        for(let i = 0; i < width * 2 - colWidths.length; i++)colWidths.push($ca500cf7ecedd822$export$c60fae4049791eae, 0);
        badWidths = true;
    }
    if (badWidths) $ca500cf7ecedd822$var$findBadColWidths(tableMap, colWidths, table);
    return tableMap;
}
function $ca500cf7ecedd822$var$findWidth(table) {
    let width = -1;
    let hasRowSpan = false;
    for(let row = 0; row < table.childCount; row++){
        const rowNode = table.child(row);
        let rowWidth = 0;
        if (hasRowSpan) for(let j = 0; j < row; j++){
            const prevRow = table.child(j);
            for(let i = 0; i < prevRow.childCount; i++){
                const cell = prevRow.child(i);
                if (j + cell.attrs.rowspan > row) rowWidth += cell.attrs.colspan;
            }
        }
        for(let i = 0; i < rowNode.childCount; i++){
            const cell = rowNode.child(i);
            rowWidth += cell.attrs.colspan;
            if (cell.attrs.rowspan > 1) hasRowSpan = true;
        }
        if (width === -1) width = rowWidth;
        else if (width !== rowWidth) width = Math.max(width, rowWidth);
    }
    return width;
}
function $ca500cf7ecedd822$var$findBadColWidths(map, colWidths, table) {
    if (!map.problems) map.problems = [];
    const seen = {};
    for(let i = 0; i < map.map.length; i++){
        const pos = map.map[i];
        if (seen[pos]) continue;
        seen[pos] = true;
        const node = table.nodeAt(pos);
        let updated = null;
        for(let j = 0; j < node.attrs.colspan; j++){
            const col = (i + j) % map.width, colWidth = colWidths[col * 2];
            if (colWidth != null && (!node.attrs.colwidth || node.attrs.colwidth[j] !== colWidth)) (updated || (updated = $ca500cf7ecedd822$var$freshColWidth(node.attrs)))[j] = colWidth;
        }
        if (updated) map.problems.unshift({
            type: "colwidth mismatch",
            pos: pos,
            colwidth: updated
        });
    }
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ca500cf7ecedd822$var$freshColWidth(attrs) {
    if (attrs.colwidth) return attrs.colwidth.slice();
    const result = [];
    for(let i = 0; i < attrs.colspan; i++)result.push(0);
    return result;
}

});

parcelRegister("6hQQ3", function(module, exports) {

$parcel$export(module.exports, "pointsAtCell", () => $6704a47d099ba366$export$3c89e45c7dff9619);
$parcel$export(module.exports, "cellNear", () => $6704a47d099ba366$export$7a283ef453dbae9e);
$parcel$export(module.exports, "cellAround", () => $6704a47d099ba366$export$1f482d92c57578ce);
$parcel$export(module.exports, "nextCell", () => $6704a47d099ba366$export$172699367bb25225);

var $uOUlv = parcelRequire("uOUlv");
function $6704a47d099ba366$export$3c89e45c7dff9619($pos) {
    return $pos.parent.type.spec.tableRole === 'row' && $pos.nodeAfter;
}
function $6704a47d099ba366$export$7a283ef453dbae9e($pos) {
    for(let after = $pos.nodeAfter, { pos: pos } = $pos; after; after = after.firstChild, pos++){
        const role = after.type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') return $pos.doc.resolve(pos);
    }
    for(let before = $pos.nodeBefore, { pos: pos } = $pos; before; before = before.lastChild, pos--){
        const role = before.type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') return $pos.doc.resolve(pos - before.nodeSize);
    }
    return null;
}
function $6704a47d099ba366$export$1f482d92c57578ce($pos) {
    for(let d = $pos.depth - 1; d > 0; d--){
        if ($pos.node(d).type.spec.tableRole === 'row') return $pos.node(0).resolve($pos.before(d + 1));
    }
    return null;
}
function $6704a47d099ba366$export$172699367bb25225($pos, axis, dir) {
    const start = $pos.start(-1);
    const map = (0, $uOUlv.TableMap).get($pos.node(-1));
    const moved = map.nextCell($pos.pos - start, axis, dir);
    return moved == null ? null : $pos.node(0).resolve(start + moved);
}

});

parcelRegister("6e6o8", function(module, exports) {

$parcel$export(module.exports, "removeColSpan", () => $44eb8577da1c519b$export$b24d9c3cc95412e0);
$parcel$export(module.exports, "assertColspan", () => $44eb8577da1c519b$export$6fccdf7cee1b5201);
$parcel$export(module.exports, "addColSpan", () => $44eb8577da1c519b$export$147ee78a1321ac36);
function $44eb8577da1c519b$export$b24d9c3cc95412e0(attrs, pos, n = 1) {
    if (!attrs.colspan) throw new Error('removeColSpan(): attrs.colspan not defined');
    const result = {
        ...attrs,
        colspan: attrs.colspan - n
    };
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        result.colwidth.splice(pos, n);
        if (!result.colwidth.some((w)=>w > 0)) result.colwidth = undefined;
    }
    return result;
}
function $44eb8577da1c519b$export$6fccdf7cee1b5201(attrs) {
    if (typeof attrs.colspan === 'undefined') throw new Error('addColSpan: attrs.colspan is not defined');
    if (typeof attrs.colspan !== 'number' || Number.isNaN(attrs.colspan) || attrs.colspan < 1) throw new Error(`addColSpan: attrs.colspan must be number >= 1, received: ${attrs.colspan}`);
}
function $44eb8577da1c519b$export$147ee78a1321ac36(attrs, pos, n = 1) {
    $44eb8577da1c519b$export$6fccdf7cee1b5201(attrs);
    const result = {
        ...attrs,
        colspan: attrs.colspan + n
    };
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        for(let i = 0; i < n; i++)result.colwidth.splice(pos, 0, 0);
    }
    return result;
}

});

parcelRegister("aKDxB", function(module, exports) {

$parcel$export(module.exports, "getCellSelectionRanges", () => $d20b421410b3cfed$export$a60a444208fd5099);

var $gZGBX = parcelRequire("gZGBX");

var $uOUlv = parcelRequire("uOUlv");
function $d20b421410b3cfed$export$a60a444208fd5099($anchorCell, $headCell) {
    const table = $anchorCell.node(-1);
    const map = (0, $uOUlv.TableMap).get(table);
    const start = $anchorCell.start(-1);
    const rect = map.rectBetween($anchorCell.pos - start, $headCell.pos - start);
    const doc = $anchorCell.node(0);
    const cells = map.cellsInRect(rect).filter((p)=>p !== $headCell.pos - start);
    // Make the head cell the first range, so that it counts as the
    // primary part of the selection
    cells.unshift($headCell.pos - start);
    return cells.map((pos)=>{
        const cell = table.nodeAt(pos);
        if (cell === null) throw new Error(`No cell at position ${pos}`);
        const from = pos + start + 1;
        return new (0, $gZGBX.SelectionRange)(doc.resolve(from), doc.resolve(from + cell.content.size));
    });
}

});



parcelRegister("fc6h8", function(module, exports) {

$parcel$export(module.exports, "shouldForceTracking", () => $d5e5ded83470406e$export$5b59d3e9e22dbdc6);
// START: temporary code https://product-fabric.atlassian.net/browse/ED-10260
const $d5e5ded83470406e$export$5b59d3e9e22dbdc6 = ()=>{
    try {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const { FRONTEND_VERSION: FRONTEND_VERSION = '' } = window.__buildInfo || {};
        return window.location.hostname === 'product-fabric.atlassian.net' && FRONTEND_VERSION.includes('branch-deploy');
    } catch (err) {
        // eslint-disable-next-line no-console
        console.warn(err);
        return false;
    }
}; // END:  temporary code  https://product-fabric.atlassian.net/browse/ED-10260

});

parcelRegister("4zXba", function(module, exports) {

$parcel$export(module.exports, "normalizeFeatureFlags", () => $e819a2725d93345d$export$f1485fc4974593c0);
$parcel$export(module.exports, "getEnabledFeatureFlagKeys", () => $e819a2725d93345d$export$6d018dd0f6cbebcb);

var $e4eHl = parcelRequire("e4eHl");

var $3T6Xo = parcelRequire("3T6Xo");
const $e819a2725d93345d$var$EMPTY = {};
function $e819a2725d93345d$var$isObjectFlagKey(key, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
value, objectFlagKeys) {
    return Boolean(typeof value === 'string' && objectFlagKeys?.includes(key));
}
function $e819a2725d93345d$var$isValidJSONObject(value) {
    try {
        const result = JSON.parse(value);
        if (typeof result === 'object' && result !== null) return true;
        return false;
    } catch (err) {
        return false;
    }
}
function $e819a2725d93345d$export$f1485fc4974593c0(rawFeatureFlags, options) {
    if (!rawFeatureFlags) return $e819a2725d93345d$var$EMPTY;
    return Object.entries(rawFeatureFlags).filter((e)=>{
        if (typeof e[1] === 'boolean') return true;
        if ($e819a2725d93345d$var$isObjectFlagKey((0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(e[0]), e[1], options?.objectFlagKeys) && $e819a2725d93345d$var$isValidJSONObject(e[1])) return true;
        return false;
    }).filter(([key])=>(0, (/*@__PURE__*/$parcel$interopDefault($3T6Xo)))(key) === key).map(([key, value])=>[
            (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(key),
            value
        ]).reduce((flags, [key, value])=>{
        if ($e819a2725d93345d$var$isObjectFlagKey(key, value, options?.objectFlagKeys)) flags[key] = JSON.parse(value);
        if (typeof value === 'boolean') flags[key] = value;
        return flags;
    }, {});
}
function $e819a2725d93345d$export$6d018dd0f6cbebcb(featureFlags) {
    return Object.keys(featureFlags).filter((key)=>featureFlags[key] === true);
}

});

parcelRegister("9gOVJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a549b54270369c2c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $kCV8T = parcelRequire("kCV8T");

var $gmhCD = parcelRequire("gmhCD");

var $3kKuL = parcelRequire("3kKuL");
parcelRequire("gJX6d");
var $5KNWO = parcelRequire("5KNWO");
var $gJX6d = parcelRequire("gJX6d");

var $5BLIh = parcelRequire("5BLIh");

var $cKKwC = parcelRequire("cKKwC");
var $GDkvY = parcelRequire("GDkvY");

var $eQNWQ = parcelRequire("eQNWQ");

var $5or39 = parcelRequire("5or39");

var $K5Jsy = parcelRequire("K5Jsy");

var $5r0mK = parcelRequire("5r0mK");

var $VSDnB = parcelRequire("VSDnB");

var $bzwTW = parcelRequire("bzwTW");

var $bVGKe = parcelRequire("bVGKe");

var $h5tvG = parcelRequire("h5tvG");

var $3VpWO = parcelRequire("3VpWO");
function $a549b54270369c2c$var$mergeMarks(marksAndNodes) {
    return marksAndNodes.reduce((acc, markOrNode)=>{
        const prev = acc.length && acc[acc.length - 1] || null;
        if (markOrNode.type instanceof (0, $kCV8T.MarkType) && prev && prev.type instanceof (0, $kCV8T.MarkType) && Array.isArray(prev.content) && (0, $eQNWQ.isSameMark)(prev, markOrNode)) prev.content = $a549b54270369c2c$var$mergeMarks(prev.content.concat(markOrNode.content));
        else acc.push(markOrNode);
        return acc;
    }, []);
}
class $a549b54270369c2c$export$2e2bcd8739ae039 {
    constructor(init){
        this.headingIds = [];
        /**
	 * The reason we have this extra array here is because we need to generate the same unique
	 * heading id for 2 different nodes: headers and expands (check the implementation of
	 * `getUniqueHeadingId` for more info).
	 *
	 * We will eventually need to refactor the current approach to generate unique ids
	 * for headers under this ticket -> https://product-fabric.atlassian.net/browse/ED-9668
	 */ this.expandHeadingIds = [];
        this.allowCopyToClipboard = false;
        this.allowWrapCodeBlock = false;
        this.allowPlaceholderText = true;
        this.allowCustomPanels = false;
        this.surroundTextNodesWithTextWrapper = false;
        this.allowAnnotations = false;
        this.serializeFragmentChild = (node, { index: index, parentInfo: parentInfo })=>{
            const pos = this.startPos;
            const currentPath = parentInfo && parentInfo.path || [];
            const parentIsIncompleteTask = node.type.name === 'taskItem' && node.attrs.state !== 'DONE';
            const nodeKey = `${node.type.name}__${this.startPos}`;
            const serializedContent = this.serializeFragment(node.content, this.getNodeProps(node, parentInfo), (0, $gJX6d.toReact)(node, {
                allowSelectAllTrap: this.allowSelectAllTrap,
                allowWindowedCodeBlock: this.allowWindowedCodeBlock
            }, this.nodeComponents), nodeKey, {
                parentIsIncompleteTask: parentIsIncompleteTask,
                path: [
                    ...currentPath,
                    node
                ],
                pos: this.startPos
            });
            this.startPos = pos + node.nodeSize;
            const marks = node.marks ? [
                ...node.marks
            ] : [];
            const isMedia = node.type.name === 'media';
            const shouldSkipBorderMark = (mark)=>currentPath.some((n)=>n.type?.name !== 'mediaSingle') && isMedia && mark.type.name === 'border';
            const shouldSkipLinkMark = (mark)=>this.allowMediaLinking !== true && isMedia && mark.type.name === 'link';
            return marks.reduceRight((content, mark)=>{
                if (shouldSkipLinkMark(mark) || shouldSkipBorderMark(mark)) return content;
                return this.renderMark((0, $GDkvY.toReact)(mark), this.withMediaMarkProps(node, mark, this.getMarkProps(mark, [], node)), `${mark.type.name}-${index}`, content);
            }, serializedContent);
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.withMediaMarkProps = (node, mark, defaultProps)=>{
            if (mark.type.name === 'link' && node.type.name === 'media') return {
                ...defaultProps,
                isMediaLink: true
            };
            if (node.type.name === 'mediaInline' && mark.type.name === 'annotation') return {
                ...defaultProps,
                isMediaInline: true
            };
            return defaultProps;
        };
        this.getUnsupportedContentProps = (node)=>{
            return {
                node: node,
                dispatchAnalyticsEvent: this.fireAnalyticsEvent
            };
        };
        this.getAnnotationMarkProps = (mark, marksParentPath)=>{
            const annotationParentIds = (marksParentPath || []).reduce((acc, parent)=>{
                if ((0, $cKKwC.isAnnotationMark)(parent)) return [
                    ...acc,
                    parent.attrs.id
                ];
                return acc;
            }, []);
            return {
                id: mark.attrs.id,
                annotationType: mark.attrs.annotationType,
                annotationParentIds: annotationParentIds,
                allowAnnotations: this.allowAnnotations,
                dataAttributes: {
                    'data-renderer-mark': true
                }
            };
        };
        this.getMarkProps = (mark, marksParentPath, node)=>{
            if ((0, $cKKwC.isAnnotationMark)(mark)) return this.getAnnotationMarkProps(mark, marksParentPath);
            const { key: key, ...otherAttrs } = mark.attrs;
            const extraProps = {
                isInline: node?.isInline
            };
            // currently the only mark which has custom props is the code mark
            const markSpecificProps = (0, $bVGKe.isCodeMark)(mark) ? {
                // The appearance being mobile indicates we are in an renderer being
                // rendered by mobile bridge in a web view.
                // The tooltip is likely to have unexpected behaviour there, with being cut
                // off, so we disable it. This is also to keep the behaviour consistent with
                // the rendering in the mobile Native Renderer.
                codeBidiWarningTooltipEnabled: false
            } : {};
            const props = {
                eventHandlers: this.eventHandlers,
                fireAnalyticsEvent: this.fireAnalyticsEvent,
                markKey: key,
                ...otherAttrs,
                ...extraProps,
                ...markSpecificProps,
                dataAttributes: {
                    'data-renderer-mark': true
                }
            };
            return props;
        };
        if ((0, $gmhCD.editorExperiment)('comment_on_bodied_extensions', true)) {
            this.initStartPos = init.startPos || 1;
            this.startPos = init.startPos || 1;
        } else {
            this.initStartPos = 1;
            this.startPos = 1;
        }
        this.providers = init.providers;
        this.eventHandlers = init.eventHandlers;
        this.extensionHandlers = init.extensionHandlers;
        this.portal = init.portal;
        this.rendererContext = init.objectContext;
        this.appearance = init.appearance;
        this.disableHeadingIDs = init.disableHeadingIDs;
        this.disableActions = init.disableActions;
        this.allowHeadingAnchorLinks = init.allowHeadingAnchorLinks;
        this.allowCopyToClipboard = init.allowCopyToClipboard;
        this.allowWrapCodeBlock = init.allowWrapCodeBlock;
        this.allowPlaceholderText = init.allowPlaceholderText;
        this.allowCustomPanels = init.allowCustomPanels;
        this.allowColumnSorting = init.allowColumnSorting;
        this.fireAnalyticsEvent = init.fireAnalyticsEvent;
        this.shouldOpenMediaViewer = init.shouldOpenMediaViewer;
        this.allowAltTextOnImages = init.allowAltTextOnImages;
        this.stickyHeaders = init.stickyHeaders;
        this.allowMediaLinking = init.allowMediaLinking;
        this.allowAnnotations = Boolean(init.allowAnnotations);
        this.surroundTextNodesWithTextWrapper = Boolean(init.surroundTextNodesWithTextWrapper);
        this.media = init.media;
        this.emojiResourceConfig = init.emojiResourceConfig;
        this.smartLinks = init.smartLinks;
        this.extensionViewportSizes = init.extensionViewportSizes;
        this.allowSelectAllTrap = init.allowSelectAllTrap;
        this.nodeComponents = init.nodeComponents;
        this.allowWindowedCodeBlock = init.allowWindowedCodeBlock;
        this.isInsideOfInlineExtension = init.isInsideOfInlineExtension;
        this.textHighlighter = init.textHighlighter;
        this.allowTableAlignment = init.allowTableAlignment;
        this.allowTableResizing = init.allowTableResizing;
        this.isPresentational = init.isPresentational;
    }
    resetState() {
        this.headingIds = [];
        this.expandHeadingIds = [];
        this.startPos = this.initStartPos;
    }
    getNodeProps(node, parentInfo) {
        const path = parentInfo ? parentInfo.path : undefined;
        switch(node.type.name){
            case 'date':
                return this.getDateProps(node, parentInfo, path);
            case 'hardBreak':
                return this.getHardBreakProps(node, path);
            case 'heading':
                return this.getHeadingProps(node, path);
            case 'media':
                return this.getMediaProps(node, path);
            case 'emoji':
                return this.getEmojiProps(node);
            case 'extension':
            case 'bodiedExtension':
                return this.getExtensionProps(node, path);
            case 'mediaGroup':
                return this.getMediaGroupProps(node);
            case 'mediaInline':
                return this.getMediaInlineProps(node);
            case 'mediaSingle':
                return this.getMediaSingleProps(node, path);
            case 'table':
                return this.getTableProps(node, path);
            case 'tableHeader':
            case 'tableRow':
                return this.getTableChildrenProps(node);
            case 'taskItem':
                return this.getTaskItemProps(node, path);
            case 'embedCard':
                return this.getEmbedCardProps(node, path);
            case 'blockCard':
                return this.getBlockCardProps(node, path);
            case 'expand':
                return this.getExpandProps(node, path);
            case 'unsupportedBlock':
            case 'unsupportedInline':
                return this.getUnsupportedContentProps(node);
            case 'codeBlock':
                return this.getCodeBlockProps(node);
            case 'panel':
                return this.getPanelProps(node);
            default:
                return this.getProps(node, path);
        }
    }
    serializeFragment(fragment, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props = {}, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    target = this.allowSelectAllTrap ? (0, $5KNWO.DocWithSelectAllTrap) : (0, $5KNWO.default), key = 'root-0', parentInfo) {
        // This makes sure that we reset internal state on re-render.
        if (key === 'root-0') this.resetState();
        return this.renderNode(target, props, key, $a549b54270369c2c$export$2e2bcd8739ae039.getChildNodes(fragment).map((node, index)=>{
            if ((0, $gJX6d.isTextWrapper)(node)) return this.serializeTextWrapper(node.content, {
                index: index,
                parentInfo: parentInfo
            });
            return this.serializeFragmentChild(node, {
                index: index,
                parentInfo: parentInfo
            });
        }));
    }
    serializeTextWrapper(content, { index: index, parentInfo: parentInfo }) {
        const currentPath = parentInfo && parentInfo.path || [];
        const nodePosition = parentInfo && parentInfo.pos || 1;
        return $a549b54270369c2c$export$2e2bcd8739ae039.buildMarkStructure(content).map((mark, index)=>{
            return this.serializeMark({
                mark: mark,
                parentNode: {
                    path: currentPath,
                    pos: nodePosition
                },
                parentMark: {
                    path: [
                        mark
                    ]
                }
            });
        });
    }
    serializeMark({ mark: mark, parentNode: parentNode, parentMark: parentMark }) {
        if (!(0, $gJX6d.isTextNode)(mark)) {
            const serializeContent = (childMark, index)=>this.serializeMark({
                    mark: childMark,
                    parentNode: parentNode,
                    parentMark: {
                        path: [
                            ...parentMark.path,
                            childMark
                        ]
                    }
                });
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const content = (mark.content || []).map(serializeContent);
            const markKey = `${mark.type.name}-component__${this.startPos}__${parentMark.path.length}`;
            return this.renderMark((0, $GDkvY.toReact)(mark), this.getMarkProps(mark, parentMark.path), markKey, content);
        }
        const startPos = this.startPos;
        const endPos = startPos + mark.nodeSize;
        this.startPos = endPos;
        const textKey = `text-wrapper_${this.startPos}`;
        if (this.surroundTextNodesWithTextWrapper) {
            const parentDepth = Math.max(parentNode.path.length - 1, 0);
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5BLIh.default), {
                startPos: startPos + parentDepth,
                endPos: endPos + parentDepth,
                textHighlighter: this.textHighlighter,
                marks: mark.marks,
                children: mark.text
            }, textKey);
        }
        const segments = (0, $h5tvG.segmentText)(mark.text, this.textHighlighter);
        return (0, $3VpWO.renderTextSegments)(segments, this.textHighlighter, mark.marks, startPos);
    }
    renderNode(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    NodeComponent, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props, key, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    content) {
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $2OMIu.jsx)(NodeComponent, {
            ...props,
            children: content
        }, key));
    }
    renderMark(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    MarkComponent, props, key, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    content) {
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $2OMIu.jsx)(MarkComponent, {
            ...props,
            children: content
        }, key));
    }
    getTableChildrenProps(node) {
        return {
            ...this.getProps(node),
            allowColumnSorting: this.allowColumnSorting
        };
    }
    getTableProps(node, path = []) {
        const isInsideOfBlockNode = (0, $bzwTW.insideBlockNode)(path, node.type.schema);
        const isInsideMultiBodiedExtension = (0, $bzwTW.insideMultiBodiedExtension)(path, node.type.schema);
        const isInsideOfTable = (0, $bzwTW.insideTable)(path, node.type.schema);
        // TODO: CEMS-1048 - Support sticky headers inside breakout + layout
        const stickyHeaders = !isInsideOfTable && !(0, $bzwTW.insideBreakoutLayout)(path) ? this.stickyHeaders : undefined;
        return {
            ...this.getProps(node),
            allowColumnSorting: this.allowColumnSorting,
            columnWidths: (0, $5or39.getColumnWidths)(node),
            tableNode: node,
            stickyHeaders: stickyHeaders,
            isInsideOfBlockNode: isInsideOfBlockNode,
            isInsideOfTable: isInsideOfTable,
            isInsideMultiBodiedExtension: isInsideMultiBodiedExtension,
            allowTableAlignment: this.allowTableAlignment,
            allowTableResizing: this.allowTableResizing,
            isPresentational: (0, $VSDnB.fg)('platform_renderer_isPresentational') ? this.isPresentational : false
        };
    }
    getDateProps(node, parentInfo, path = []) {
        return {
            timestamp: node.attrs && node.attrs.timestamp,
            parentIsIncompleteTask: parentInfo && parentInfo.parentIsIncompleteTask,
            dataAttributes: {
                // We need to account for depth (path.length gives up depth) here
                // but depth doesnt increment the pos, only accounted for.
                'data-renderer-start-pos': this.startPos + path.length
            }
        };
    }
    getMediaSingleProps(node, path = []) {
        const { marks: { link: link } } = node.type.schema;
        const isInsideOfBlockNode = (0, $bzwTW.insideBlockNode)(path, node.type.schema);
        const isLinkMark = (mark)=>mark.type === link;
        const childHasLink = node.firstChild && node.firstChild.marks.filter((m)=>isLinkMark(m) || this.allowMediaLinking === true).length;
        return {
            ...this.getProps(node, path),
            isInsideOfBlockNode: isInsideOfBlockNode,
            childHasLink: childHasLink,
            allowCaptions: this.media && this.media.allowCaptions,
            featureFlags: this.media && this.media.featureFlags
        };
    }
    getMediaProps(node, path = []) {
        const { marks: { annotation: annotation, link: link, border: border } } = node.type.schema;
        const isChildOfMediaSingle = path.some((n)=>n.type?.name === 'mediaSingle');
        const isAnnotationMark = (mark)=>mark.type === annotation;
        const isLinkMark = (mark)=>mark.type === link;
        const isBorderMark = (mark)=>isChildOfMediaSingle && mark.type === border;
        return {
            ...this.getProps(node, path),
            marks: node.marks.filter((m)=>!isLinkMark(m) || this.allowMediaLinking === true),
            isLinkMark: isLinkMark,
            isBorderMark: isBorderMark,
            isAnnotationMark: isAnnotationMark,
            allowAltTextOnImages: this.allowAltTextOnImages,
            featureFlags: this.media && this.media.featureFlags,
            shouldOpenMediaViewer: this.shouldOpenMediaViewer,
            ssr: this.media?.ssr,
            // surroundTextNodesWithTextWrapper checks inlineComment.allowDraftMode
            allowAnnotationsDraftMode: this.surroundTextNodesWithTextWrapper
        };
    }
    getExtensionProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            extensionViewportSizes: this.extensionViewportSizes
        };
    }
    getEmojiProps(node) {
        return {
            ...this.getProps(node),
            resourceConfig: this.emojiResourceConfig
        };
    }
    getEmbedCardProps(node, path = []) {
        const isInsideOfBlockNode = (0, $bzwTW.insideBlockNode)(path, node.type.schema);
        return {
            ...this.getProps(node),
            isInsideOfBlockNode: isInsideOfBlockNode
        };
    }
    getBlockCardProps(node, path = []) {
        return {
            ...this.getProps(node),
            isNodeNested: path.length > 0
        };
    }
    getMediaGroupProps(node) {
        return {
            ...this.getProps(node),
            shouldOpenMediaViewer: this.shouldOpenMediaViewer,
            allowAltTextOnImages: this.allowAltTextOnImages,
            featureFlags: this.media && this.media.featureFlags,
            enableDownloadButton: this.media?.enableDownloadButton,
            ssr: this.media?.ssr
        };
    }
    getMediaInlineProps(node) {
        return {
            ...this.getProps(node),
            ssr: this.media?.ssr
        };
    }
    getTaskItemProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            disabled: this.disableActions
        };
    }
    getHardBreakProps(node, path = []) {
        let forceNewLine = false;
        const parentNode = path.length > 0 ? path[path.length - 1] : null;
        if (parentNode && parentNode.lastChild === node) forceNewLine = true;
        return {
            ...this.getProps(node),
            forceNewLine: forceNewLine
        };
    }
    getCodeBlockProps(node) {
        // The appearance being mobile indicates we are in an renderer being
        // rendered by mobile bridge in a web view.
        // The tooltip is likely to have unexpected behaviour there, with being cut
        // off, so we disable it. This is also to keep the behaviour consistent with
        // the rendering in the mobile Native Renderer.
        const codeBidiWarningTooltipEnabled = false;
        return {
            ...this.getProps(node),
            text: node.textContent,
            codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
        };
    }
    getPanelProps(node) {
        return {
            ...this.getProps(node),
            allowCustomPanels: this.allowCustomPanels
        };
    }
    getProps(node, path = []) {
        const startPos = this.startPos + path.length;
        return {
            text: node.text,
            providers: this.providers,
            eventHandlers: this.eventHandlers,
            extensionHandlers: this.extensionHandlers,
            portal: this.portal,
            rendererContext: this.rendererContext,
            serializer: this,
            content: node.content ? node.content.toJSON() : undefined,
            allowHeadingAnchorLinks: this.allowHeadingAnchorLinks,
            allowCopyToClipboard: this.allowCopyToClipboard,
            allowWrapCodeBlock: this.allowWrapCodeBlock,
            allowPlaceholderText: this.allowPlaceholderText,
            rendererAppearance: this.appearance,
            fireAnalyticsEvent: this.fireAnalyticsEvent,
            nodeType: node.type.name,
            marks: node.marks,
            smartLinks: this.smartLinks,
            isInsideOfInlineExtension: this.isInsideOfInlineExtension,
            dataAttributes: {
                // We need to account for depth (path.length gives up depth) here
                // but depth doesnt increment the pos, only accounted for.
                'data-renderer-start-pos': startPos
            },
            startPos: startPos,
            path: path,
            ...node.attrs
        };
    }
    headingAnchorSupported(path = []) {
        const isImmediateParent = (path, nodeName)=>{
            return path.length > 0 && path[path.length - 1].type.name === nodeName;
        };
        return (0, $3kKuL.isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks) || path.length === 0 || isImmediateParent(path, 'layoutColumn');
    }
    getHeadingProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            content: node.content ? node.content.toJSON() : undefined,
            headingId: this.getHeadingId(node, this.headingIds),
            showAnchorLink: this.appearance !== 'comment' && this.allowHeadingAnchorLinks && !this.disableHeadingIDs && this.headingAnchorSupported(path)
        };
    }
    getExpandProps(node, path = []) {
        if (!(0, $3kKuL.isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks)) return this.getProps(node);
        const nestedHeaderIds = (0, $5r0mK.findChildrenByType)(node, node.type.schema.nodes.heading).map(({ node: node })=>this.getHeadingId(node, this.expandHeadingIds));
        return {
            ...this.getProps(node),
            nestedHeaderIds: nestedHeaderIds
        };
    }
    // The return value of this function is NOT url encoded,
    // In HTML5 standard, id can contain any characters, encoding is no necessary.
    // Plus we trying to avoid double encoding, therefore we leave the value as is.
    // Remember to use encodeURIComponent when generating url from the id value.
    getHeadingId(node, headingIds) {
        if (this.disableHeadingIDs || !node.content.size) return;
        // We are not use node.textContent here, because we would like to handle cases where
        // headings only contain inline blocks like emoji, status and date.
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const nodeContent = node.content.toJSON()// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((acc, node)=>acc.concat((0, $K5Jsy.getText)(node) || ''), '').trim()// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        .replace(/\s/g, '-');
        if (!nodeContent) return;
        return this.getUniqueHeadingId(nodeContent, headingIds);
    }
    getUniqueHeadingId(baseId, headingIds, counter = 0) {
        if (counter === 0 && headingIds.indexOf(baseId) === -1) {
            headingIds.push(baseId);
            return baseId;
        } else if (counter !== 0) {
            const headingId = `${baseId}.${counter}`;
            if (headingIds.indexOf(headingId) === -1) {
                headingIds.push(headingId);
                return headingId;
            }
        }
        return this.getUniqueHeadingId(baseId, headingIds, ++counter);
    }
    static getChildNodes(fragment) {
        const children = [];
        fragment.forEach((node)=>{
            children.push(node);
        });
        return (0, $gJX6d.mergeTextNodes)(children);
    }
    static getMarks(node) {
        if (!node.marks || node.marks.length === 0) return [];
        return (0, $eQNWQ.getMarksByOrder)(node.marks);
    }
    static buildMarkStructure(content) {
        return $a549b54270369c2c$var$mergeMarks(content.map((node)=>{
            const nodeMarks = this.getMarks(node);
            if (nodeMarks.length === 0) return node;
            return nodeMarks.reverse().reduce((acc, mark)=>{
                const { eq: eq } = mark;
                return {
                    ...mark,
                    eq: eq,
                    content: [
                        acc
                    ]
                };
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            }, node);
        }));
    }
    // TODO: ED-9004 - Remove unused ReactSerializer.fromSchema in renderer
    // https://sourcegraph-frontend.internal.shared-prod.us-west-2.kitt-inf.net/search?q=ReactSerializer.fromSchema&patternType=literal
    static fromSchema(_, init) {
        return new $a549b54270369c2c$export$2e2bcd8739ae039(init);
    }
}

});
parcelRegister("3kKuL", function(module, exports) {

$parcel$export(module.exports, "isNestedHeaderLinksEnabled", () => $e845fca6b21fd822$export$7aa7587d1ce9583c);
$parcel$export(module.exports, "getActiveHeadingId", () => $e845fca6b21fd822$export$acb253d79d72af92);
function $e845fca6b21fd822$export$7aa7587d1ce9583c(allowHeadingAnchorLinks) {
    // If it's a boolean or undefined, then we don't support nesting.
    if (!allowHeadingAnchorLinks || typeof allowHeadingAnchorLinks === 'boolean') return false;
    const { allowNestedHeaderLinks: allowNestedHeaderLinks } = allowHeadingAnchorLinks;
    // Explicit cast to a boolean to cover scenario where it's undefined.
    return !!allowNestedHeaderLinks;
}
function $e845fca6b21fd822$export$acb253d79d72af92(allowHeadingAnchorLinks) {
    if (!$e845fca6b21fd822$export$7aa7587d1ce9583c(allowHeadingAnchorLinks)) return undefined;
    return allowHeadingAnchorLinks.activeHeadingId;
}

});

parcelRegister("gJX6d", function(module, exports) {

$parcel$export(module.exports, "InlineCard", () => $2b5167c1d6aa176d$export$aff6291803939b05);
$parcel$export(module.exports, "nodeToReact", () => $2b5167c1d6aa176d$export$3931063f6a5f290e);
$parcel$export(module.exports, "toReact", () => $2b5167c1d6aa176d$export$d4334b129116aad7);
$parcel$export(module.exports, "mergeTextNodes", () => $2b5167c1d6aa176d$export$8045509d14b5046f);
$parcel$export(module.exports, "isTextWrapper", () => $2b5167c1d6aa176d$export$d4ebd3557ee7fac1);
$parcel$export(module.exports, "isTextNode", () => $2b5167c1d6aa176d$export$ccbedd67ef6e9417);
$parcel$export(module.exports, "Doc", () => (parcelRequire("5KNWO")).default);
$parcel$export(module.exports, "DocWithSelectAllTrap", () => (parcelRequire("5KNWO")).DocWithSelectAllTrap);
/* eslint-disable @atlaskit/editor/no-re-export */ // Mapping file

var $4qBtX = parcelRequire("4qBtX");

var $iiXGq = parcelRequire("iiXGq");
var $9kpKZ = parcelRequire("9kpKZ");

var $VSDnB = parcelRequire("VSDnB");

var $atrOQ = parcelRequire("atrOQ");

var $4dtZR = parcelRequire("4dtZR");

var $2SZph = parcelRequire("2SZph");

var $bQeYo = parcelRequire("bQeYo");

var $cOnYv = parcelRequire("cOnYv");

var $cWRvh = parcelRequire("cWRvh");

var $5KNWO = parcelRequire("5KNWO");

var $i8Zwf = parcelRequire("i8Zwf");

var $lKIDi = parcelRequire("lKIDi");

var $7AttJ = parcelRequire("7AttJ");

var $112O7 = parcelRequire("112O7");

var $ieJGA = parcelRequire("ieJGA");

var $3RqVz = parcelRequire("3RqVz");

var $qjsNK = parcelRequire("qjsNK");

var $jHa9U = parcelRequire("jHa9U");

var $6svWT = parcelRequire("6svWT");

var $9FXQX = parcelRequire("9FXQX");

var $hqBb9 = parcelRequire("hqBb9");

var $ixoQV = parcelRequire("ixoQV");

var $dkc63 = parcelRequire("dkc63");

var $cWojJ = parcelRequire("cWojJ");

var $i4Lgj = parcelRequire("i4Lgj");

var $gfMkN = parcelRequire("gfMkN");

const $2b5167c1d6aa176d$export$a22ee8f907eecb5f = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("8WMBu")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$6c415d1fdae3dfdb = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("kHVHQ")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$771a55a10b0a40ae = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("1KGZa")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$27c4189b8be1bf93 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("4OnIJ")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$b458dfa720128865 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("clvfA")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$b6f73a2b0b0de599 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("2Fwz0")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$6341f9a885713487 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("hQAvz")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$96e9906d6d93a972 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("2c01v")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$56cc48506ff790a = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("hSHcF")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$2ddb90ad54e5f587 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("8ugtC")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$6789d7ecdc77631b = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("5WPrU")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$aff6291803939b05 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("6tHHQ")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$d18ccd25c0d2c6b0 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("8m1sA")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$7fc53215244aec38 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("jHdEo")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$d7858be3df00d59 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("bokwI")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$462ea7c2a1c4cb1f = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("dmxb9")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$888d74bc001c3a5d = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("32Gvn")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$e891316fea657d90 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("XeDOe")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$49bd1dfb0ad29c40 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("aVEPl")).then((mod)=>mod.default),
    loading: ()=>null
});
const $2b5167c1d6aa176d$export$3931063f6a5f290e = {
    blockquote: (0, $atrOQ.default),
    bulletList: (0, $cWRvh.default),
    blockCard: $2b5167c1d6aa176d$export$d18ccd25c0d2c6b0,
    caption: (0, $jHa9U.default),
    date: $2b5167c1d6aa176d$export$6341f9a885713487,
    decisionItem: $2b5167c1d6aa176d$export$b6f73a2b0b0de599,
    decisionList: $2b5167c1d6aa176d$export$b458dfa720128865,
    doc: (0, $5KNWO.default),
    emoji: $2b5167c1d6aa176d$export$56cc48506ff790a,
    extension: (0, $i8Zwf.default),
    bodiedExtension: (0, $4dtZR.default),
    multiBodiedExtension: (0, $bQeYo.default),
    extensionFrame: (0, $cOnYv.default),
    hardBreak: (0, $lKIDi.default),
    heading: (0, $7AttJ.default),
    inlineCard: $2b5167c1d6aa176d$export$aff6291803939b05,
    inlineExtension: (0, $112O7.default),
    layoutSection: (0, $ieJGA.default),
    layoutColumn: (0, $3RqVz.default),
    listItem: (0, $qjsNK.default),
    media: $2b5167c1d6aa176d$export$7fc53215244aec38,
    mediaGroup: $2b5167c1d6aa176d$export$d7858be3df00d59,
    mediaInline: $2b5167c1d6aa176d$export$462ea7c2a1c4cb1f,
    mediaSingle: $2b5167c1d6aa176d$export$888d74bc001c3a5d,
    mention: $2b5167c1d6aa176d$export$e891316fea657d90,
    orderedList: (0, $6svWT.default),
    panel: $2b5167c1d6aa176d$export$2ddb90ad54e5f587,
    paragraph: (0, $9FXQX.default),
    placeholder: (0, $hqBb9.default),
    rule: (0, $ixoQV.default),
    status: $2b5167c1d6aa176d$export$96e9906d6d93a972,
    taskItem: $2b5167c1d6aa176d$export$27c4189b8be1bf93,
    taskList: $2b5167c1d6aa176d$export$771a55a10b0a40ae,
    table: (0, $dkc63.default),
    tableCell: (0, $cWojJ.TableCell),
    tableHeader: (0, $cWojJ.TableHeader),
    tableRow: (0, $i4Lgj.default),
    unknownBlock: (0, $gfMkN.default),
    unsupportedBlock: (0, $iiXGq.default),
    unsupportedInline: (0, $9kpKZ.default),
    expand: $2b5167c1d6aa176d$export$49bd1dfb0ad29c40,
    nestedExpand: $2b5167c1d6aa176d$export$49bd1dfb0ad29c40,
    embedCard: $2b5167c1d6aa176d$export$6789d7ecdc77631b
};
const $2b5167c1d6aa176d$export$d4334b129116aad7 = (node, flags, nodeComponents)=>{
    if (node.type.name === 'doc' && flags?.allowSelectAllTrap === true) return 0, $5KNWO.DocWithSelectAllTrap;
    if (node.type.name === 'codeBlock') {
        if (flags?.allowWindowedCodeBlock === true) return $2b5167c1d6aa176d$export$a22ee8f907eecb5f;
        return $2b5167c1d6aa176d$export$6c415d1fdae3dfdb;
    }
    // Allowing custom components to override those provided in nodeToReact
    const nodes = {
        ...$2b5167c1d6aa176d$export$3931063f6a5f290e,
        ...nodeComponents
    };
    nodes['multiBodiedExtension'] = (0, $VSDnB.fg)('platform_editor_multi_body_extension_extensibility') ? (0, $bQeYo.default) : (0, $2SZph.default);
    return nodes[node.type.name];
};
const $2b5167c1d6aa176d$export$8045509d14b5046f = (nodes)=>{
    return nodes.reduce((acc, current)=>{
        if (!$2b5167c1d6aa176d$export$1879817ac5c922b7(current.type.name)) {
            acc.push(current);
            return acc;
        }
        // Append node to previous node, if it was a text wrapper
        if (acc.length > 0 && $2b5167c1d6aa176d$export$d4ebd3557ee7fac1(acc[acc.length - 1])) {
            const textWrapper = acc[acc.length - 1];
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            textWrapper.content.push(current);
            textWrapper.nodeSize += current.nodeSize;
        } else acc.push({
            type: {
                name: 'textWrapper'
            },
            content: [
                current
            ],
            nodeSize: current.nodeSize
        });
        return acc;
    }, []);
};
const $2b5167c1d6aa176d$export$1879817ac5c922b7 = (type)=>{
    return type === 'text';
};
const $2b5167c1d6aa176d$export$d4ebd3557ee7fac1 = (node)=>{
    return node.type.name === 'textWrapper';
};
function $2b5167c1d6aa176d$export$ccbedd67ef6e9417(node) {
    return node.type.name === 'text';
}
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $2b5167c1d6aa176d$var$whitespaceRegex = /^\s*$/;
const $2b5167c1d6aa176d$export$dd0c7365db1f79a5 = (doc)=>{
    if (doc.childCount !== 1) return false;
    const parentNodes = [];
    doc.forEach((child)=>parentNodes.push(child));
    const node = parentNodes[0];
    return node.type.name === 'paragraph' && $2b5167c1d6aa176d$var$isEmojiBlock(node.content);
};
const $2b5167c1d6aa176d$var$isEmojiBlock = (pnode)=>{
    const content = [];
    // Optimisation for long documents - worst case block will be space-emoji-space
    if (pnode.childCount > 7) return false;
    pnode.forEach((child)=>content.push(child));
    let emojiCount = 0;
    for(let i = 0; i < content.length; ++i){
        const node = content[i];
        switch(node.type.name){
            case 'text':
                if (node.text && !node.text.match($2b5167c1d6aa176d$var$whitespaceRegex)) return false;
                continue;
            case 'emoji':
                if (++emojiCount > 3) return false;
                continue;
            default:
                // Only text and emoji nodes are allowed
                return false;
        }
    }
    return emojiCount > 0;
};

});
parcelRegister("9kpKZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b743bc5ccb58a13$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $iHYdz = parcelRequire("iHYdz");

var $dg0Fl = parcelRequire("dg0Fl");

var $3bDjY = parcelRequire("3bDjY");

var $gkwXh = parcelRequire("gkwXh");

var $7R1zM = parcelRequire("7R1zM");

var $d54NZ = parcelRequire("d54NZ");

var $9tFGn = parcelRequire("9tFGn");
const $5b743bc5ccb58a13$var$inlineNodeStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    alignItems: 'center',
    background: "var(--ds-background-disabled, #091E4208)",
    border: `1px dashed ${"var(--ds-border-disabled, #091E420F)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-border-radius, 3px)",
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'inline-flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $iHYdz.relativeFontSizeToBase16)(14),
    margin: `0 ${"var(--ds-space-025, 2px)"}`,
    minHeight: '24px',
    padding: `0 ${"var(--ds-space-100, 8px)"}`,
    verticalAlign: 'middle',
    whiteSpace: 'nowrap'
});
const $5b743bc5ccb58a13$var$UnsupportedInlineNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const message = (0, $9tFGn.getUnsupportedContent)((0, $7R1zM.unsupportedContentMessages).unsupportedInlineContent, 'Unsupported', node, intl);
    const tooltipContent = intl.formatMessage((0, $7R1zM.unsupportedContentMessages).unsupportedContentTooltip);
    const { current: style } = (0, $5uXOq.useRef)({
        padding: '4px'
    });
    const originalNodeType = node?.attrs.originalValue.type;
    const tooltipOnShowHandler = (0, $5uXOq.useCallback)(()=>dispatchAnalyticsEvent && (0, $d54NZ.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $gkwXh.ACTION_SUBJECT_ID).ON_UNSUPPORTED_INLINE, originalNodeType), [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $5b743bc5ccb58a13$var$inlineNodeStyle
    }, message, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        style: style
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dg0Fl))), {
        label: "?",
        LEGACY_size: "small"
    }))));
};
var $5b743bc5ccb58a13$export$2e2bcd8739ae039 = (0, $8RXs9.default)($5b743bc5ccb58a13$var$UnsupportedInlineNode);

});

parcelRegister("atrOQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d51d57a125840f5$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $8d51d57a125840f5$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("blockquote", {
        children: props.children
    });
}

});

parcelRegister("4dtZR", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9e9d2beaec6b895$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $i8Zwf = parcelRequire("i8Zwf");

var $8Eu7T = parcelRequire("8Eu7T");

var $fAZXL = parcelRequire("fAZXL");

var $cWCI0 = parcelRequire("cWCI0");

var $gkwXh = parcelRequire("gkwXh");

var $4YrGg = parcelRequire("4YrGg");

var $1SqDw = parcelRequire("1SqDw");

var $VSDnB = parcelRequire("VSDnB");
const $b9e9d2beaec6b895$var$ValidationContextWrapper = ({ children: children })=>{
    // We override validation of nested tables in nested renderers as invalid ADF (but valid Prosemirror)
    // may have been introduced in the parent renderer's render and subsequent transformations.
    // For example - nested tables which are transformed from an extension node in ADF
    // to native Prosemirror nested table nodes in and this is invalid ADF.
    const validationContextValue = (0, $5uXOq.useMemo)(()=>({
            allowNestedTables: true
        }), []);
    if (!(0, $VSDnB.fg)('platform_editor_nested_table_extension_comment_fix')) return children;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1SqDw.ValidationContextProvider), {
        value: validationContextValue,
        children: children
    });
};
const $b9e9d2beaec6b895$var$BodiedExtension = (props)=>{
    const { children: children, layout: layout = 'default', path: path = [], extensionKey: extensionKey, extensionType: extensionType, parameters: parameters, extensionViewportSizes: extensionViewportSizes } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const removeOverflow = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children)// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child) ? child.props.nodeType === 'table' : false).every(Boolean);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Eu7T.ErrorBoundary), {
        component: (0, $cWCI0.ACTION_SUBJECT).RENDERER,
        componentId: (0, $gkwXh.ACTION_SUBJECT_ID).EXTENSION_BODIED,
        createAnalyticsEvent: createAnalyticsEvent,
        additionalInfo: `${extensionType}: ${extensionKey} `,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4YrGg.AnnotationsPositionContext).Provider, {
            value: {
                startPos: props.startPos + 1
            },
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($b9e9d2beaec6b895$var$ValidationContextWrapper, {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fAZXL.default), {
                    ...props,
                    type: "bodiedExtension",
                    children: ({ result: result })=>{
                        try {
                            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(result)) // Return the content directly if it's a valid JSX.Element
                            return (0, $i8Zwf.renderExtension)(result, layout, {
                                isTopLevel: path.length < 1
                            }, removeOverflow, parameters?.extensionId, extensionViewportSizes);
                        } catch (e) {
                        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
                        // Always return default content if anything goes wrong
                        return (0, $i8Zwf.renderExtension)(children, layout, {
                            isTopLevel: path.length < 1
                        }, removeOverflow, parameters?.extensionId, extensionViewportSizes);
                    }
                })
            })
        })
    });
};
var $b9e9d2beaec6b895$export$2e2bcd8739ae039 = $b9e9d2beaec6b895$var$BodiedExtension;

});
parcelRegister("i8Zwf", function(module, exports) {

$parcel$export(module.exports, "renderExtension", () => $1a97cbb70a611ae8$export$b7482bdc8aff85e4);
$parcel$export(module.exports, "default", () => $1a97cbb70a611ae8$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fAZXL = parcelRequire("fAZXL");

var $ajc8Z = parcelRequire("ajc8Z");
var $4ceoy = parcelRequire("4ceoy");

var $eOOFp = parcelRequire("eOOFp");

var $l8Gxi = parcelRequire("l8Gxi");
const $1a97cbb70a611ae8$var$viewportSizes = [
    'small',
    'medium',
    'default',
    'large',
    'xlarge'
];
// Mirrors sizes from https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/platform/packages/forge/xen-editor-provider/src/render/renderers/ForgeUIExtension.tsx
const $1a97cbb70a611ae8$var$macroHeights = {
    small: '112px',
    medium: '262px',
    default: '262px',
    large: '524px',
    xlarge: '1048px'
};
const $1a97cbb70a611ae8$var$getViewportSize = (extensionId, extensionViewportSizes)=>{
    if (!Array.isArray(extensionViewportSizes) || !extensionId) return;
    const extension = extensionViewportSizes.find((extension)=>extension.extensionId === extensionId);
    if (extension) {
        const viewportSize = extension.viewportSize && $1a97cbb70a611ae8$var$viewportSizes.includes(extension.viewportSize) ? extension.viewportSize : 'default';
        return $1a97cbb70a611ae8$var$macroHeights[viewportSize];
    }
};
const $1a97cbb70a611ae8$export$b7482bdc8aff85e4 = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
content, layout, options = {}, removeOverflow, extensionId, extensionViewportSizes)=>{
    const overflowContainerClass = !removeOverflow ? (0, $l8Gxi.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER : '';
    // by default, we assume the extension is at top level, (direct child of doc node)
    const { isTopLevel: isTopLevel = true } = options || {};
    const centerAlignClass = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) ? (0, $l8Gxi.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    const viewportSize = $1a97cbb70a611ae8$var$getViewportSize(extensionId, extensionViewportSizes);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4ceoy.WidthConsumer), {
        children: ({ width: width })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                ref: options.handleRef,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: `${(0, $l8Gxi.RendererCssClassName).EXTENSION} ${options.shadowClassNames} ${centerAlignClass}`,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    width: isTopLevel ? (0, $eOOFp.calcBreakoutWidth)(layout, width) : '100%',
                    minHeight: viewportSize
                },
                "data-layout": layout,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: overflowContainerClass,
                    children: content
                })
            })
    });
};
const $1a97cbb70a611ae8$var$Extension = (props)=>{
    const { text: text, layout: layout = 'default', handleRef: handleRef, shadowClassNames: shadowClassNames, path: path = [], extensionViewportSizes: extensionViewportSizes, parameters: parameters } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fAZXL.default), {
        ...props,
        type: "extension",
        children: ({ result: result })=>{
            try {
                // Return the result directly if it's a valid JSX.Element
                if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(result)) return $1a97cbb70a611ae8$export$b7482bdc8aff85e4(result, layout, {
                    isTopLevel: path.length < 1,
                    handleRef: handleRef,
                    shadowClassNames: shadowClassNames
                }, undefined, parameters?.extensionId, extensionViewportSizes);
            } catch (e) {
            /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
            // Always return default content if anything goes wrong
            return $1a97cbb70a611ae8$export$b7482bdc8aff85e4(text || 'extension', layout, {
                isTopLevel: path.length < 1,
                handleRef: handleRef,
                shadowClassNames: shadowClassNames
            }, undefined, parameters?.extensionId, extensionViewportSizes);
        }
    });
};
var $1a97cbb70a611ae8$export$2e2bcd8739ae039 = (0, $ajc8Z.default)($1a97cbb70a611ae8$var$Extension, {
    overflowSelector: `.${(0, $l8Gxi.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`
});

});
parcelRegister("fAZXL", function(module, exports) {

$parcel$export(module.exports, "default", () => $45cce7a6859f4709$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $gnH2s = parcelRequire("gnH2s");

var $9Egzu = parcelRequire("9Egzu");

var $2vGdQ = parcelRequire("2vGdQ");
const $45cce7a6859f4709$var$inlineExtensionStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'inline-block',
    maxWidth: '100%',
    verticalAlign: 'middle',
    // es-lint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    margin: `1px 1px ${"var(--ds-space-050, 4px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& .rich-media-item': {
        maxWidth: '100%'
    }
});
function $45cce7a6859f4709$export$2e2bcd8739ae039(props) {
    const { extensionHandlers: extensionHandlers, rendererContext: rendererContext, extensionType: extensionType, extensionKey: extensionKey, parameters: parameters, content: content, text: text, type: type, localId: localId, marks: marks, actions: actions, children: children } = props;
    const isMounted = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(true);
    const localGetNodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>(0, $8QpSo.default)((0, $gnH2s.getNodeRenderer)), []);
    const [extensionProvider, setExtensionProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState(null);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleProvider = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((name, providerPromise)=>{
        providerPromise && providerPromise.then((provider)=>{
            if (isMounted.current) setExtensionProvider(provider);
        });
    }, []);
    const renderExtensionNode = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((extensionProvider)=>{
        const fragmentLocalId = marks?.find((m)=>m.type.name === 'fragment')?.attrs?.localId;
        const node = {
            type: type,
            extensionKey: extensionKey,
            extensionType: extensionType,
            parameters: parameters,
            content: content || text,
            localId: localId,
            fragmentLocalId: fragmentLocalId
        };
        let result = null;
        try {
            if (extensionHandlers && extensionHandlers[extensionType]) {
                const render = (0, $2vGdQ.getExtensionRenderer)(extensionHandlers[extensionType]);
                result = render(node, rendererContext.adDoc);
            }
            if (!result && extensionProvider) {
                const NodeRenderer = localGetNodeRenderer(extensionProvider, extensionType, extensionKey);
                if (node.type === 'multiBodiedExtension') result = /*#__PURE__*/ (0, $f8Sb3.jsx)(NodeRenderer, {
                    node: node,
                    actions: actions
                });
                else if (node.type === 'inlineExtension') result = /*#__PURE__*/ (0, $f8Sb3.jsx)($45cce7a6859f4709$export$f41ccc3bd3324832, null, /*#__PURE__*/ (0, $f8Sb3.jsx)(NodeRenderer, {
                    node: node
                }));
                else result = /*#__PURE__*/ (0, $f8Sb3.jsx)(NodeRenderer, {
                    node: node
                });
            }
        } catch (e) {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        return children({
            result: result
        });
    }, [
        actions,
        children,
        content,
        extensionHandlers,
        extensionKey,
        extensionType,
        localGetNodeRenderer,
        localId,
        marks,
        parameters,
        rendererContext?.adDoc,
        text,
        type
    ]);
    const setupAndRenderExtensionNode = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((providers)=>{
        if (!extensionProvider && providers.extensionProvider) handleProvider('extensionProvider', providers.extensionProvider);
        return renderExtensionNode(extensionProvider);
    }, [
        extensionProvider,
        handleProvider,
        renderExtensionNode
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    if (!props.providers) return setupAndRenderExtensionNode({});
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9Egzu.WithProviders), {
        providers: [
            'extensionProvider'
        ],
        providerFactory: props.providers,
        renderNode: setupAndRenderExtensionNode
    });
}
const $45cce7a6859f4709$export$f41ccc3bd3324832 = ({ children: children })=>{
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        className: "inline-extension-renderer",
        css: $45cce7a6859f4709$var$inlineExtensionStyle
    }, children));
};

});
parcelRegister("gnH2s", function(module, exports) {

$parcel$export(module.exports, "getExtensionModuleNode", () => $36d4284a17bc60a0$export$82dd45c2db936caf);
$parcel$export(module.exports, "getExtensionModuleNodePrivateProps", () => $36d4284a17bc60a0$export$426f8efd8690d8aa);
$parcel$export(module.exports, "getNodeRenderer", () => $36d4284a17bc60a0$export$67a7d49db68d30a0);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $4qBtX = parcelRequire("4qBtX");

var $VSDnB = parcelRequire("VSDnB");

var $izxHQ = parcelRequire("izxHQ");
function $36d4284a17bc60a0$var$getNodeFromManifest(// eslint-disable-next-line @typescript-eslint/no-explicit-any
manifest, extKey, nodeKey, extensionType, extensionKey) {
    if (!manifest) throw new Error(`Extension with key "${extKey}" and type "${extensionType}" not found!`);
    if (!manifest.modules.nodes) throw new Error(`Couldn't find any node for extension type "${extensionType}" and key "${extensionKey}"!`);
    const node = manifest.modules.nodes[nodeKey];
    if (!node) throw new Error(`Node with key "${extensionKey}" not found on manifest for extension type "${extensionType}" and key "${extensionKey}"!`);
    return node;
}
async function $36d4284a17bc60a0$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey) {
    const [extKey, nodeKey] = (0, $izxHQ.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
    const manifest = await extensionProvider.getExtension(extensionType, extKey);
    return $36d4284a17bc60a0$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey);
}
function $36d4284a17bc60a0$export$903681ffb5af37a7(extensionProvider, extensionType, extensionKey) {
    const [extKey, nodeKey] = (0, $izxHQ.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
    const manifest = extensionProvider?.getPreloadedExtension?.(extensionType, extKey);
    if (manifest) return $36d4284a17bc60a0$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey);
    else return extensionProvider.getExtension(extensionType, extKey).then((manifest)=>$36d4284a17bc60a0$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey));
}
async function $36d4284a17bc60a0$export$426f8efd8690d8aa(extensionProvider, extensionType, extensionKey) {
    const moduleNode = await $36d4284a17bc60a0$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey);
    return Object.keys(moduleNode).filter((key)=>key.startsWith('__')).reduce((acc, key)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        acc[key] = moduleNode[key];
        return acc;
    }, {});
}
function $36d4284a17bc60a0$var$ExtensionLoading(props) {
    if (props.error || props.timedOut) {
        // eslint-disable-next-line no-console
        console.error('Error rendering extension', props.error);
        return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            children: "Error loading the extension!"
        });
    } else return null;
}
function $36d4284a17bc60a0$export$67a7d49db68d30a0(extensionProvider, extensionType, extensionKey) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
        loader: ()=>{
            if ((0, $VSDnB.fg)('confluence_preload_extension_providers')) {
                const maybePromise = $36d4284a17bc60a0$export$903681ffb5af37a7(extensionProvider, extensionType, extensionKey);
                if (maybePromise instanceof Promise) return maybePromise.then((node)=>(0, $izxHQ.resolveImport)(node.render()));
                else {
                    const preloaded = maybePromise?.renderSync?.();
                    // Only product implemented preloading will return sync result
                    // However the out-of-box won't handle this. Confluence uses a custom implementation
                    return preloaded ? (0, $izxHQ.resolveImportSync)(preloaded) : (0, $izxHQ.resolveImport)(maybePromise.render());
                }
            } else return $36d4284a17bc60a0$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey).then((node)=>(0, $izxHQ.resolveImport)(node.render()));
        },
        loading: $36d4284a17bc60a0$var$ExtensionLoading
    });
}

});
parcelRegister("izxHQ", function(module, exports) {

$parcel$export(module.exports, "getExtensionKeyAndNodeKey", () => $23c4e3f9598df846$export$8a49818572e1d105);
$parcel$export(module.exports, "buildAction", () => $23c4e3f9598df846$export$bb33bcdd9a10a608);
$parcel$export(module.exports, "resolveImportSync", () => $23c4e3f9598df846$export$dca2026e63034304);
$parcel$export(module.exports, "resolveImport", () => $23c4e3f9598df846$export$d69c9b451c47653b);
const $23c4e3f9598df846$export$a7d04c836550045a = 'com.atlassian.ecosystem';
const $23c4e3f9598df846$export$8a49818572e1d105 = (extensionKey, extensionType)=>{
    // Forge macro extensionKey has a user generated string, so splitting on
    // a colon is unstable for their particular use case. They only have one
    // node in the relevant manifest so we can hardcode nodeKey to 'default'.
    if (extensionType === $23c4e3f9598df846$export$a7d04c836550045a) return [
        extensionKey,
        'default'
    ];
    const [extKey, nodeKey = 'default'] = extensionKey.split(':');
    return [
        extKey,
        nodeKey
    ];
};
const $23c4e3f9598df846$export$5f3eb042babacbbd = (extensionKey, nodeKey)=>{
    if (!nodeKey || nodeKey === 'default') return extensionKey;
    return `${extensionKey}:${nodeKey}`;
};
function $23c4e3f9598df846$export$bb33bcdd9a10a608(action, manifest) {
    if (typeof action === 'function') return action;
    if (action.type === 'node' && manifest.modules.nodes) return $23c4e3f9598df846$export$33863d887d6f4bfd(action, manifest);
}
const $23c4e3f9598df846$export$dca2026e63034304 = (importedModule)=>{
    return importedModule && importedModule.__esModule ? importedModule.default : importedModule;
};
const $23c4e3f9598df846$export$d69c9b451c47653b = async (importPromise)=>{
    return $23c4e3f9598df846$export$dca2026e63034304(await importPromise);
};
function $23c4e3f9598df846$export$33863d887d6f4bfd(action, manifest) {
    if (!manifest.modules.nodes) return;
    const node = manifest.modules.nodes[action.key];
    const extensionKey = $23c4e3f9598df846$export$5f3eb042babacbbd(manifest.key, action.key);
    const extension = {
        type: node.type,
        attrs: {
            extensionType: manifest.type,
            extensionKey: extensionKey,
            parameters: action.parameters
        }
    };
    if (node.type === 'bodiedExtension') return {
        ...extension,
        content: [
            {
                type: 'paragraph',
                content: []
            }
        ]
    };
    else if (node.type === 'multiBodiedExtension') return {
        ...extension,
        content: [
            {
                type: 'extensionFrame',
                content: [
                    {
                        type: 'paragraph',
                        content: []
                    }
                ]
            }
        ]
    };
    return extension;
}

});


parcelRegister("9Egzu", function(module, exports) {

$parcel$export(module.exports, "WithProviders", () => $76144329c6f313cf$export$d498ee8be33e096f);
/* eslint-disable @repo/internal/react/no-class-components */ 
var $5uXOq = parcelRequire("5uXOq");
class $76144329c6f313cf$export$d498ee8be33e096f extends (0, $5uXOq.PureComponent) {
    static{
        this.displayName = 'WithProviders';
    }
    constructor(props){
        super(props), this.mounted = false, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleProviderIfMounted = (name, provider)=>{
            if (!this.mounted) return;
            this.handleProvider(name, provider);
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleProvider = (name, provider)=>{
            this.setState(({ providers: providers })=>{
                return {
                    providers: {
                        ...providers,
                        [name]: provider
                    }
                };
            });
        };
        this.mounted = false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const providers = {};
        this.props.providers.forEach((name)=>{
            const providerPromise = props.providerFactory.subscribe(name, this.handleProviderIfMounted);
            providers[name] = providerPromise;
        });
        this.state = {
            providers: providers
        };
    }
    componentDidMount() {
        this.mounted = true;
    }
    componentWillUnmount() {
        const { providers: providers, providerFactory: providerFactory } = this.props;
        providers.forEach((name)=>{
            providerFactory.unsubscribe(name, this.handleProvider);
        });
    }
    render() {
        const { state: state, props: props } = this;
        const { renderNode: renderNode } = props;
        return renderNode(state.providers);
    }
}

});

parcelRegister("2vGdQ", function(module, exports) {

$parcel$export(module.exports, "getExtensionRenderer", () => $f7ce50c6d2d400b7$export$9214452ef07eda7);
function $f7ce50c6d2d400b7$export$9214452ef07eda7(extensionHandler) {
    if (typeof extensionHandler === 'object') return extensionHandler.render;
    else return extensionHandler;
}

});


parcelRegister("ajc8Z", function(module, exports) {

$parcel$export(module.exports, "shadowClassNames", () => $0d6cb6e0383d0ba0$export$4735dd2b0fa88aa5);
$parcel$export(module.exports, "default", () => $0d6cb6e0383d0ba0$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bbl9Y = parcelRequire("bbl9Y");
const $0d6cb6e0383d0ba0$export$4735dd2b0fa88aa5 = {
    RIGHT_SHADOW: 'right-shadow',
    LEFT_SHADOW: 'left-shadow'
};
function $0d6cb6e0383d0ba0$export$2e2bcd8739ae039(Component, options) {
    return class OverflowShadow extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
        componentWillUnmount() {
            if (options.useShadowObserver) return this.shadowObserver && this.shadowObserver.dispose();
            if (this.overflowContainer) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowContainer.removeEventListener('scroll', this.handleScroll);
            this.updateShadows();
        }
        componentDidUpdate() {
            if (!options.useShadowObserver) this.updateShadows();
        }
        initShadowObserver() {
            if (this.shadowObserver || !this.overflowContainer) return;
            this.shadowObserver = new (0, $bbl9Y.ShadowObserver)({
                scrollContainer: this.overflowContainer,
                onUpdateShadows: (shadowStates)=>{
                    this.setState((prevState)=>{
                        const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = shadowStates;
                        if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== prevState.showRightShadow) return {
                            showLeftShadow: showLeftShadow,
                            showRightShadow: showRightShadow
                        };
                        return null;
                    });
                }
            });
        }
        render() {
            const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = this.state;
            const classNames = [
                showRightShadow && $0d6cb6e0383d0ba0$export$4735dd2b0fa88aa5.RIGHT_SHADOW,
                showLeftShadow && $0d6cb6e0383d0ba0$export$4735dd2b0fa88aa5.LEFT_SHADOW,
                options.useShadowObserver && (0, $bbl9Y.shadowObserverClassNames).SHADOW_CONTAINER
            ].filter(Boolean).join(' ');
            return(// Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                handleRef: this.handleContainer,
                shadowClassNames: classNames,
                ...this.props
            }));
        }
        constructor(...args){
            super(...args), this.overflowContainerWidth = 0, this.state = {
                showLeftShadow: false,
                showRightShadow: false
            }, this.handleScroll = (event)=>{
                if (!this.overflowContainer || event.target !== this.overflowContainer || options.useShadowObserver) return;
                this.updateShadows();
            }, this.updateShadows = ()=>{
                if (options.useShadowObserver) return;
                this.setState((prevState)=>{
                    if (!this.overflowContainer) return;
                    const diff = this.calcOverflowDiff();
                    const showRightShadow = diff > 0 && diff > this.overflowContainer.scrollLeft;
                    const showLeftShadow = this.showLeftShadow(this.overflowContainer);
                    if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== this.state.showRightShadow) return {
                        showLeftShadow: showLeftShadow,
                        showRightShadow: showRightShadow
                    };
                    return null;
                });
            }, this.showLeftShadow = (overflowContainer)=>{
                return !!overflowContainer && overflowContainer.scrollLeft > 0;
            }, this.calcOverflowDiff = ()=>{
                if (!this.overflowContainer) return 0;
                this.diff = this.calcScrollableWidth();
                return this.diff - this.overflowContainer.offsetWidth;
            }, this.calcScrollableWidth = ()=>{
                if (!this.scrollable && this.overflowContainer) return this.overflowContainer.scrollWidth;
                if (!this.scrollable) return 0;
                let width = 0;
                for(let i = 0; i < this.scrollable.length; i++){
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    const scrollableElement = this.scrollable[i];
                    width += scrollableElement.scrollWidth;
                }
                return width;
            }, this.handleContainer = (container)=>{
                if (!container || this.container) return;
                this.container = container;
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                this.overflowContainer = container.querySelector(options.overflowSelector);
                if (!this.overflowContainer) this.overflowContainer = container;
                if (options.useShadowObserver) {
                    this.initShadowObserver();
                    return;
                }
                this.updateShadows();
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.overflowContainer.addEventListener('scroll', this.handleScroll);
            };
        }
    };
}

});
parcelRegister("bbl9Y", function(module, exports) {

$parcel$export(module.exports, "shadowObserverClassNames", () => $cd027df5593f4e8b$export$1cbe0bb16052178d);
$parcel$export(module.exports, "ShadowObserver", () => $cd027df5593f4e8b$export$51a5b28e4fb2dba2);
var $cd027df5593f4e8b$export$ebeea2fe2e93862e = /*#__PURE__*/ function(ShadowKeys) {
    ShadowKeys["SHOW_LEFT_SHADOW"] = "showLeftShadow";
    ShadowKeys["SHOW_RIGHT_SHADOW"] = "showRightShadow";
    return ShadowKeys;
}({});
const $cd027df5593f4e8b$export$1cbe0bb16052178d = {
    SENTINEL_LEFT: 'sentinel-left',
    SENTINEL_RIGHT: 'sentinel-right',
    SHADOW_CONTAINER: 'with-shadow-observer'
};
const $cd027df5593f4e8b$var$requestIdleCallback = (fn)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return window.requestIdleCallback ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.requestIdleCallback(fn) : window.requestAnimationFrame(fn);
};
const $cd027df5593f4e8b$var$cancelIdleCallback = (id)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return window.cancelIdleCallback ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.cancelIdleCallback(id) : window.cancelAnimationFrame(id);
};
class $cd027df5593f4e8b$export$51a5b28e4fb2dba2 {
    constructor({ scrollContainer: scrollContainer, onUpdateShadows: onUpdateShadows }){
        this.sentinels = {};
        this.shadowStates = {
            ["showLeftShadow"]: false,
            ["showRightShadow"]: false
        };
        this.init = ()=>{
            if (!this.scrollContainer || this.intersectionObserver) return;
            this.sentinels.right = document.createElement('div');
            this.sentinels.right.classList.add($cd027df5593f4e8b$export$1cbe0bb16052178d.SENTINEL_RIGHT);
            this.scrollContainer.appendChild(this.sentinels.right);
            this.sentinels.left = document.createElement('div');
            this.sentinels.left.classList.add($cd027df5593f4e8b$export$1cbe0bb16052178d.SENTINEL_LEFT);
            this.scrollContainer.prepend(this.sentinels.left);
            this.intersectionObserver = new IntersectionObserver((entries, _)=>{
                entries.forEach(this.onIntersect);
            }, {
                root: this.scrollContainer,
                rootMargin: '1px'
            });
            this.intersectionObserver.observe(this.sentinels.left);
            this.intersectionObserver.observe(this.sentinels.right);
        };
        this.onIntersect = (entry)=>{
            this.requestCallbackId = $cd027df5593f4e8b$var$requestIdleCallback(()=>{
                if (entry.target.classList.contains($cd027df5593f4e8b$export$1cbe0bb16052178d.SENTINEL_LEFT)) this.shadowStates["showLeftShadow"] = !entry.isIntersecting;
                if (entry.target.classList.contains($cd027df5593f4e8b$export$1cbe0bb16052178d.SENTINEL_RIGHT)) this.shadowStates["showRightShadow"] = !entry.isIntersecting;
                this.onUpdateShadows(this.shadowStates);
            });
        };
        this.scrollContainer = scrollContainer;
        this.onUpdateShadows = onUpdateShadows;
        this.init();
    }
    dispose() {
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            this.intersectionObserver = undefined;
            this.requestCallbackId && $cd027df5593f4e8b$var$cancelIdleCallback(this.requestCallbackId);
        }
    }
}

});


parcelRegister("eOOFp", function(module, exports) {

$parcel$export(module.exports, "breakoutConsts", () => $081c5ce54850cd88$export$ead1fecec2ecf57c);
$parcel$export(module.exports, "absoluteBreakoutWidth", () => $081c5ce54850cd88$export$b34ea040d1533a3);
$parcel$export(module.exports, "calcWideWidth", () => $081c5ce54850cd88$export$86325001fe8f3adc);
$parcel$export(module.exports, "calcBreakoutWidth", () => $081c5ce54850cd88$export$5f4502874a28dfce);
$parcel$export(module.exports, "calcBreakoutWithCustomWidth", () => $081c5ce54850cd88$export$ccc0a02edddeed39);
$parcel$export(module.exports, "calculateBreakoutStyles", () => $081c5ce54850cd88$export$c377853ecdd53e5b);
$parcel$export(module.exports, "getNextBreakoutMode", () => $081c5ce54850cd88$export$7eb758567e6644fd);
$parcel$export(module.exports, "getTitle", () => $081c5ce54850cd88$export$70d1bf7729efff40);

var $iHYdz = parcelRequire("iHYdz");

var $8DYpW = parcelRequire("8DYpW");

var $9Iju4 = parcelRequire("9Iju4");

var $4ceoy = parcelRequire("4ceoy");

var $eQcNy = parcelRequire("eQcNy");
const $081c5ce54850cd88$export$ead1fecec2ecf57c = {
    padding: (0, $iHYdz.akEditorBreakoutPadding),
    defaultLayoutWidth: (0, $iHYdz.akEditorDefaultLayoutWidth),
    wideScaleRatio: (0, $iHYdz.breakoutWideScaleRatio),
    fullWidthLayoutWidth: (0, $iHYdz.akEditorFullWidthLayoutWidth),
    wideLayoutWidth: (0, $iHYdz.akEditorWideLayoutWidth),
    mapBreakpointToLayoutMaxWidth: $9Iju4.mapBreakpointToLayoutMaxWidth,
    getBreakpoint: $4ceoy.getBreakpoint,
    /**
	 * This function can return percentage value or px value depending upon the inputs
	 */ calcBreakoutWidth: (layout, containerWidth, padding)=>{
        const effectiveFullWidth = containerWidth - (padding ?? $081c5ce54850cd88$export$ead1fecec2ecf57c.padding);
        switch(layout){
            case 'full-width':
                return `${Math.min(effectiveFullWidth, $081c5ce54850cd88$export$ead1fecec2ecf57c.fullWidthLayoutWidth)}px`;
            case 'wide':
                if (effectiveFullWidth <= 0) return '100%';
                const wideWidth = $081c5ce54850cd88$export$ead1fecec2ecf57c.calcWideWidth(containerWidth, undefined, undefined, padding);
                if (wideWidth.endsWith('%')) return `${Math.min(effectiveFullWidth, $081c5ce54850cd88$export$ead1fecec2ecf57c.fullWidthLayoutWidth)}px`;
                return wideWidth;
            default:
                return '100%';
        }
    },
    calcBreakoutWithCustomWidth: (mode, width, editorContainerWidth)=>{
        if (width !== null && width > 0) {
            const effectiveFullWidth = editorContainerWidth - $081c5ce54850cd88$export$ead1fecec2ecf57c.padding;
            // if below 0 then expect we're rendering in SSR
            return `${Math.min(width, effectiveFullWidth)}px`;
        }
        return $081c5ce54850cd88$export$ead1fecec2ecf57c.calcBreakoutWidth(mode, editorContainerWidth);
    },
    calcLineLength: ()=>$081c5ce54850cd88$export$ead1fecec2ecf57c.defaultLayoutWidth,
    calcWideWidth: (containerWidth = $081c5ce54850cd88$export$ead1fecec2ecf57c.defaultLayoutWidth, maxWidth = Infinity, fallback = '100%', padding)=>{
        const effectiveFullWidth = containerWidth - (padding ?? $081c5ce54850cd88$export$ead1fecec2ecf57c.padding);
        const layoutMaxWidth = $081c5ce54850cd88$export$ead1fecec2ecf57c.mapBreakpointToLayoutMaxWidth($081c5ce54850cd88$export$ead1fecec2ecf57c.getBreakpoint(containerWidth));
        const wideWidth = Math.min(Math.ceil(layoutMaxWidth * $081c5ce54850cd88$export$ead1fecec2ecf57c.wideScaleRatio), effectiveFullWidth);
        return layoutMaxWidth > wideWidth ? fallback : `${Math.min(maxWidth, wideWidth)}px`;
    }
};
const $081c5ce54850cd88$export$b34ea040d1533a3 = (layout, containerWidth)=>{
    const breakoutWidth = $081c5ce54850cd88$export$ead1fecec2ecf57c.calcBreakoutWidth(layout, containerWidth);
    // If it's percent, map to max layout size
    if (breakoutWidth.endsWith('%')) switch(layout){
        case 'full-width':
            return 0, $iHYdz.akEditorFullWidthLayoutWidth;
        case 'wide':
            return 0, $iHYdz.akEditorWideLayoutWidth;
        default:
            return $081c5ce54850cd88$export$ead1fecec2ecf57c.mapBreakpointToLayoutMaxWidth($081c5ce54850cd88$export$ead1fecec2ecf57c.getBreakpoint(containerWidth));
    }
    return parseInt(breakoutWidth, 10);
};
const $081c5ce54850cd88$export$86325001fe8f3adc = $081c5ce54850cd88$export$ead1fecec2ecf57c.calcWideWidth;
const $081c5ce54850cd88$export$5f4502874a28dfce = $081c5ce54850cd88$export$ead1fecec2ecf57c.calcBreakoutWidth;
const $081c5ce54850cd88$export$ccc0a02edddeed39 = $081c5ce54850cd88$export$ead1fecec2ecf57c.calcBreakoutWithCustomWidth;
function $081c5ce54850cd88$export$c377853ecdd53e5b({ mode: mode, widthStateLineLength: widthStateLineLength, widthStateWidth: widthStateWidth }) {
    const breakoutWidth = $081c5ce54850cd88$export$5f4502874a28dfce(mode, widthStateWidth);
    const breakoutWidthPx = (0, $eQcNy.parsePx)(breakoutWidth);
    if (!widthStateLineLength) // lineLength is not normally undefined when this is run for,
    // consumers but can be in SSR, initial render or test (jsdom)
    // environments.
    //
    // this approach doesn't work well with position: fixed, so
    // it breaks things like sticky headers.
    //
    // It can also cause bluriness for some child content (such as iframes)
    return {
        type: 'line-length-unknown',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        display: 'flex',
        justifyContent: 'center',
        transform: 'none',
        transition: `min-width 0.5s ${0, $iHYdz.akEditorSwoopCubicBezier}`
    };
    // NOTE
    // At time of writing -- when toggling between full-width and
    // full-page appearance modes. There is a slight delay before
    // the widthState is updated.
    // During this period -- the marginLeftPx will be incorrect.
    // const marginLeftPx = -(breakoutWidthPx - widthStateLineLength) / 2;
    return {
        type: 'line-length-known',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        transition: `min-width 0.5s ${0, $iHYdz.akEditorSwoopCubicBezier}`,
        transform: `translateX(-50%)`,
        marginLeft: `50%`
    };
}
function $081c5ce54850cd88$export$586300c53bd298dd(mode, widthStateWidth, padding) {
    return (0, $eQcNy.parsePx)($081c5ce54850cd88$export$5f4502874a28dfce(mode, widthStateWidth, padding));
}
const $081c5ce54850cd88$export$7eb758567e6644fd = (currentMode)=>{
    if (currentMode === 'full-width') return 'center';
    else if (currentMode === 'wide') return 'full-width';
    return 'wide';
};
const $081c5ce54850cd88$export$70d1bf7729efff40 = (layout)=>{
    switch(layout){
        case 'full-width':
            return (0, $8DYpW.default).layoutFixedWidth;
        case 'wide':
            return (0, $8DYpW.default).layoutFullWidth;
        default:
            return (0, $8DYpW.default).layoutWide;
    }
};

});
parcelRegister("8DYpW", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb832a3bfaa1d66d$export$2e2bcd8739ae039);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $7VHMR = parcelRequire("7VHMR");

var $l9HLU = parcelRequire("l9HLU");

var $8cp3a = parcelRequire("8cp3a");

var $1C4XH = parcelRequire("1C4XH");

var $9NKqk = parcelRequire("9NKqk");

var $fJyLQ = parcelRequire("fJyLQ");


var $gSYO9 = parcelRequire("gSYO9");

var $jDuvE = parcelRequire("jDuvE");


var $lQKNV = parcelRequire("lQKNV");

var $2i4K4 = parcelRequire("2i4K4");

var $eX53M = parcelRequire("eX53M");

var $80CM7 = parcelRequire("80CM7");

var $kXnoC = parcelRequire("kXnoC");

var $eDTMN = parcelRequire("eDTMN");

var $2V0EL = parcelRequire("2V0EL");

var $kFJBG = parcelRequire("kFJBG");

var $7S9ZN = parcelRequire("7S9ZN");

var $6OcHr = parcelRequire("6OcHr");

var $dbepQ = parcelRequire("dbepQ");

var $kANLZ = parcelRequire("kANLZ");

var $kmmxF = parcelRequire("kmmxF");

var $80TXs = parcelRequire("80TXs");

var $9QBHe = parcelRequire("9QBHe");

var $1IiUD = parcelRequire("1IiUD");

var $kAM3u = parcelRequire("kAM3u");

var $6lWmZ = parcelRequire("6lWmZ");

var $ixwvf = parcelRequire("ixwvf");

var $fJm1A = parcelRequire("fJm1A");

var $ecAvy = parcelRequire("ecAvy");

var $7ywdr = parcelRequire("7ywdr");

var $1ElKj = parcelRequire("1ElKj");



var $3AEXe = parcelRequire("3AEXe");


var $2y1kv = parcelRequire("2y1kv");
var $eb832a3bfaa1d66d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    layoutFixedWidth: {
        id: 'fabric.editor.layoutFixedWidth',
        defaultMessage: 'Back to center',
        description: 'Display your element (image, table, extension, etc) as standard width'
    },
    layoutStateFixedWidth: {
        id: 'fabric.editor.layoutStateFixedWidth',
        defaultMessage: 'Centered',
        description: 'Displaying your element (image, table, extension, etc) as standard width'
    },
    layoutWide: {
        id: 'fabric.editor.layoutWide',
        defaultMessage: 'Go wide',
        description: 'Display your element (image, table, extension, etc) wider than normal'
    },
    layoutStateWide: {
        id: 'fabric.editor.layoutStateWide',
        defaultMessage: 'Wide',
        description: 'Displaying your element (image, table, extension, etc) wider than normal'
    },
    layoutFullWidth: {
        id: 'fabric.editor.layoutFullWidth',
        defaultMessage: 'Go full width',
        description: 'Display your element (image, table, extension, etc) as full width'
    },
    layoutStateFullWidth: {
        id: 'fabric.editor.layoutStateFullWidth',
        defaultMessage: 'Full width',
        description: 'Displaying your element (image, table, extension, etc) as full width'
    },
    alignImageRight: {
        id: 'fabric.editor.alignImageRight',
        defaultMessage: 'Align right',
        description: 'Aligns image to the right'
    },
    alignImageCenter: {
        id: 'fabric.editor.alignImageCenter',
        defaultMessage: 'Align center',
        description: 'Aligns image to the center'
    },
    alignImageLeft: {
        id: 'fabric.editor.alignImageLeft',
        defaultMessage: 'Align left',
        description: 'Aligns image to the left'
    },
    delete: {
        id: 'fabric.editor.delete',
        defaultMessage: 'Delete',
        description: 'Delete the element (image, panel, table, etc.) from your document'
    },
    remove: {
        id: 'fabric.editor.remove',
        defaultMessage: 'Remove',
        description: 'Delete the element (image, panel, table, etc.) from your document'
    },
    removeEmoji: {
        id: 'fabric.editor.removeEmoji',
        defaultMessage: 'Remove emoji',
        description: 'Remove the emoji panel icon from custom panel'
    },
    visit: {
        id: 'fabric.editor.visit',
        defaultMessage: 'Open link in a new window',
        description: 'Open the link in a new window'
    },
    inviteToEditButtonTitle: {
        id: 'fabric.editor.editMode.inviteToEditButton.title',
        defaultMessage: 'Invite to edit',
        description: 'Invite another user to edit the current document'
    },
    saveButton: {
        id: 'fabric.editor.saveButton',
        defaultMessage: 'Save',
        description: 'Submit and save a comment or document'
    },
    cancelButton: {
        id: 'fabric.editor.cancelButton',
        defaultMessage: 'Cancel',
        description: 'Discard the current comment or document'
    },
    taskList: {
        id: 'fabric.editor.tooltip.taskList',
        defaultMessage: 'an action item',
        description: 'an action item in the Editor'
    },
    bulletList: {
        id: 'fabric.editor.tooltip.bulletList',
        defaultMessage: 'a list',
        description: 'a list item in the Editor'
    },
    nestedExpand: {
        id: 'fabric.editor.tooltip.nestedExpand',
        defaultMessage: 'a nested expand',
        description: 'expand node which is nested'
    },
    decisionList: {
        id: 'fabric.editor.tooltip.decisionList',
        defaultMessage: 'a decision list',
        description: 'a list of decisions'
    },
    defaultBlockNode: {
        id: 'fabric.editor.tooltip.defaultBlockNode',
        defaultMessage: 'a block node',
        description: 'a block node element'
    },
    panel: {
        id: 'fabric.editor.tooltip.blockPanel',
        defaultMessage: 'a panel',
        description: 'Panel node in the Editor'
    },
    blockquote: {
        id: 'fabric.editor.blockquote',
        defaultMessage: 'a quote',
        description: 'a quote node'
    },
    timeUpdated: {
        id: 'fabric.editor.time.updated',
        defaultMessage: 'Updated',
        description: 'Time last updated'
    },
    timeViewed: {
        id: 'fabric.editor.time.viewed',
        defaultMessage: 'Viewed',
        description: 'Time last viewed'
    },
    timeAgo: {
        id: 'fabric.editor.time.ago',
        defaultMessage: 'ago',
        description: 'Some time ago'
    },
    copyToClipboard: {
        id: 'fabric.editor.copyToClipboard',
        defaultMessage: 'Copy',
        description: 'Copy the whole content of the element to your clipboard'
    },
    copiedToClipboard: {
        id: 'fabric.editor.copiedToClipboard',
        defaultMessage: 'Copied!',
        description: 'Copied the whole content of the element to clipboard'
    },
    viewMore: {
        id: 'fabric.editor.overflowMenuViewMore',
        defaultMessage: 'View more',
        description: 'View more options in toolbar'
    }
});

});
parcelRegister("l9HLU", function(module, exports) {

$parcel$export(module.exports, "alignmentMessages", () => $c0194801a7a2c28d$export$5229ffea355cfdf6);

var $7VHMR = parcelRequire("7VHMR");
const $c0194801a7a2c28d$export$5229ffea355cfdf6 = (0, $7VHMR.defineMessages)({
    alignment: {
        id: 'fabric.editor.alignment',
        defaultMessage: 'Text alignment',
        description: 'Opens drop down menu of options to configure text alignment'
    },
    alignLeft: {
        id: 'fabric.editor.alignLeft',
        defaultMessage: 'Align left',
        description: 'label stating that text is aligned left'
    },
    alignCenter: {
        id: 'fabric.editor.alignCenter',
        defaultMessage: 'Align center',
        description: 'label stating that text is aligned center'
    },
    alignRight: {
        id: 'fabric.editor.alignRight',
        defaultMessage: 'Align right',
        description: 'label stating that text is aligned right'
    }
});

});

parcelRegister("8cp3a", function(module, exports) {

$parcel$export(module.exports, "annotationMessages", () => $0f161f19f888f3d2$export$ff612ca71703201d);

var $7VHMR = parcelRequire("7VHMR");
const $0f161f19f888f3d2$export$ff612ca71703201d = (0, $7VHMR.defineMessages)({
    createComment: {
        id: 'fabric.editor.createComment',
        defaultMessage: 'Comment',
        description: 'Create/add an inline comment based on the users selection'
    },
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Remove this message when the editor_inline_comments_on_inline_nodes FF is removed
    createCommentInvalid: {
        id: 'fabric.editor.createCommentInvalid',
        defaultMessage: 'You can only comment on text and headings',
        description: 'Error message to communicate to the user they can only do the current action in certain contexts'
    },
    createCommentDisabled: {
        id: 'fabric.editor.createCommentDisabled',
        defaultMessage: 'You can only comment on text, headings, emojis, dates, mentions, links, and statuses.',
        description: 'Error message to communicate to the user they can only do the current action in certain contexts'
    },
    toolbar: {
        id: 'fabric.editor.annotationToolbar',
        defaultMessage: 'Annotation toolbar',
        description: 'A label for a toolbar (UI element) that creates annotations/comments in the document'
    },
    createCommentOnInlineNodeSpotlightBody: {
        id: 'fabric.editor.createCommentOnInlineNodeSpotlight.body',
        defaultMessage: 'You can now leave comments on inline elements like links, dates, statuses and mentions.',
        description: 'The body content of the spotlight message that appears when the user can leave comments on inline nodes'
    },
    createCommentOnInlineNodeSpotlightAction: {
        id: 'fabric.editor.createCommentOnInlineNodeSpotlight.action',
        defaultMessage: 'Got it',
        description: 'The content of the action button that closes the spotlight'
    }
});

});

parcelRegister("1C4XH", function(module, exports) {

$parcel$export(module.exports, "messages", () => $11841756f48da98b$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $11841756f48da98b$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    fullWidthLabel: {
        id: 'fabric.editor.breakoutFullWidthLabel',
        defaultMessage: 'Full-width',
        description: 'Resize current element to full-width mode'
    },
    wideWidthLabel: {
        id: 'fabric.editor.breakoutWideWidthLabel',
        defaultMessage: 'Wide',
        description: 'Resize current element to wide mode'
    },
    resizeHandle: {
        id: 'fabric.editor.resizeHandle',
        defaultMessage: 'Resize handle',
        description: 'Resize handle'
    }
});

});

parcelRegister("9NKqk", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f845f8650b83fa4e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $f845f8650b83fa4e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    normal: {
        id: 'fabric.editor.normal',
        defaultMessage: 'Normal text',
        description: 'This is the default text style'
    },
    heading1: {
        id: 'fabric.editor.heading1',
        defaultMessage: 'Heading 1',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading1Description: {
        id: 'fabric.editor.heading1Description',
        defaultMessage: 'Use this for a top level heading',
        description: 'Description of the main heading, heading 1'
    },
    heading2: {
        id: 'fabric.editor.heading2',
        defaultMessage: 'Heading 2',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading2Description: {
        id: 'fabric.editor.heading2Description',
        defaultMessage: 'Use this for key sections',
        description: 'Description of a subtitle heading or secondary heading'
    },
    heading3: {
        id: 'fabric.editor.heading3',
        defaultMessage: 'Heading 3',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading3Description: {
        id: 'fabric.editor.heading3Description',
        defaultMessage: 'Use this for sub sections and group headings',
        description: ''
    },
    heading4: {
        id: 'fabric.editor.heading4',
        defaultMessage: 'Heading 4',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading4Description: {
        id: 'fabric.editor.heading4Description',
        defaultMessage: 'Use this for deep headings',
        description: ''
    },
    heading5: {
        id: 'fabric.editor.heading5',
        defaultMessage: 'Heading 5',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading5Description: {
        id: 'fabric.editor.heading5Description',
        defaultMessage: 'Use this for grouping list items',
        description: ''
    },
    heading6: {
        id: 'fabric.editor.heading6',
        defaultMessage: 'Heading 6',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading6Description: {
        id: 'fabric.editor.heading6Description',
        defaultMessage: 'Use this for low level headings',
        description: ''
    },
    blockquote: {
        id: 'fabric.editor.blockquote2',
        defaultMessage: 'Quote',
        description: 'Quote some text'
    },
    blockquoteDescription: {
        id: 'fabric.editor.blockquote.description',
        defaultMessage: 'Insert a quote or citation',
        description: 'Quote some text'
    },
    codeblock: {
        id: 'fabric.editor.codeblock',
        defaultMessage: 'Code snippet',
        description: 'Insert a snippet/segment of code (code block)'
    },
    codeblockDescription: {
        id: 'fabric.editor.codeblock.description',
        defaultMessage: 'Display code with syntax highlighting',
        description: 'Insert a snippet/segment of code (code block)'
    },
    infoPanel: {
        id: 'fabric.editor.infoPanel',
        defaultMessage: 'Info panel',
        description: 'Visually distinguishes your text by adding a background colour (blue, purple, yellow, green, red)'
    },
    infoPanelDescription: {
        id: 'fabric.editor.infoPanel.description',
        defaultMessage: 'Highlight information in a colored panel',
        description: 'Visually distinguishes your text by adding a background colour (blue, purple, yellow, green, red)'
    },
    notePanel: {
        id: 'fabric.editor.notePanel',
        defaultMessage: 'Note panel',
        description: 'Visually distinguishes your text by adding a note panel'
    },
    notePanelDescription: {
        id: 'fabric.editor.notePanel.description',
        defaultMessage: 'Add a note in a colored panel',
        description: 'Visually distinguishes your text by adding a note panel'
    },
    successPanel: {
        id: 'fabric.editor.successPanel',
        defaultMessage: 'Success panel',
        description: 'Visually distinguishes your text by adding a success panel'
    },
    successPanelDescription: {
        id: 'fabric.editor.successPanel.description',
        defaultMessage: 'Add tips in a colored panel',
        description: 'Visually distinguishes your text by adding a success panel'
    },
    warningPanel: {
        id: 'fabric.editor.warningPanel',
        defaultMessage: 'Warning panel',
        description: 'Visually distinguishes your text by adding a warning panel'
    },
    warningPanelDescription: {
        id: 'fabric.editor.warningPanel.description',
        defaultMessage: 'Add a note of caution in a colored panel',
        description: 'Visually distinguishes your text by adding a warning panel'
    },
    errorPanel: {
        id: 'fabric.editor.errorPanel',
        defaultMessage: 'Error panel',
        description: 'Visually distinguishes your text by adding a error panel'
    },
    errorPanelDescription: {
        id: 'fabric.editor.errorPanel.description',
        defaultMessage: 'Call out errors in a colored panel',
        description: 'Visually distinguishes your text by adding a error panel'
    },
    customPanel: {
        id: 'fabric.editor.customPanel',
        defaultMessage: 'Custom panel',
        description: 'Visually distinguishes your panel by adding a emoji icon and background color'
    },
    customPanelDescription: {
        id: 'fabric.editor.customPanel.description',
        defaultMessage: 'Add a note with an emoji and colored background',
        description: 'Visually distinguishes your panel by adding a emoji icon and background color '
    },
    panel: {
        id: 'fabric.editor.panel',
        defaultMessage: 'Panel',
        description: 'Visually distinguishes your text by adding a panel'
    },
    other: {
        id: 'fabric.editor.other',
        defaultMessage: 'Others...',
        description: 'Other text formatting'
    }
});

});

parcelRegister("fJyLQ", function(module, exports) {

$parcel$export(module.exports, "codeBidiWarningMessages", () => $bc1b61e25b99393f$export$42bb270d1224182);

var $7VHMR = parcelRequire("7VHMR");
const $bc1b61e25b99393f$export$42bb270d1224182 = (0, $7VHMR.defineMessages)({
    /**
	 * Message taken from
	 * https://hello.atlassian.net/wiki/spaces/~tswan/pages/1366555782/PSHELP-2943+Investigate+Trojan+Source+Attack+Vulnerability+design
	 */ label: {
        id: 'fabric.editor.codeBidiWarningLabel',
        defaultMessage: 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.',
        description: 'Tooltip message to present to users when a bidirectional character is encountered in code.'
    }
});

});

parcelRegister("gSYO9", function(module, exports) {

$parcel$export(module.exports, "linkMessages", () => $6ccabeb0d4490fe2$export$4ce3884394d6d9);

var $7VHMR = parcelRequire("7VHMR");
const $6ccabeb0d4490fe2$export$4ce3884394d6d9 = (0, $7VHMR.defineMessages)({
    openLink: {
        id: 'fabric.editor.openLink',
        defaultMessage: 'Open link in a new tab',
        description: 'Opens the link in a new tab'
    }
});

});

parcelRegister("jDuvE", function(module, exports) {

$parcel$export(module.exports, "linkToolbarMessages", () => $8ffd20c106600435$export$2d7676d841c8ae9);

var $7VHMR = parcelRequire("7VHMR");
const $8ffd20c106600435$export$2d7676d841c8ae9 = (0, $7VHMR.defineMessages)({
    addLink: {
        id: 'fabric.editor.mediaAddLink',
        defaultMessage: 'Add link',
        description: 'Add link'
    },
    unableToOpenLink: {
        id: 'fabric.editor.unableToOpenLink',
        defaultMessage: 'Unable to open this link',
        description: 'Unable to open this link'
    },
    unlink: {
        id: 'fabric.editor.unlink',
        defaultMessage: 'Unlink',
        description: 'Removes the hyperlink but keeps your text.'
    },
    editDatasourceStandalone: {
        id: 'fabric.editor.editDatasourceStandalone',
        defaultMessage: 'Edit',
        description: 'A standalone edit button to edit the datasource via a config modal'
    },
    editDatasourceStandaloneTooltip: {
        id: 'fabric.editor.editDatasourceStandaloneTooltip',
        defaultMessage: 'Edit search query',
        description: 'A standalone edit button tooltip to hint at editing the datasource via a config modal'
    },
    editLink: {
        id: 'fabric.editor.editLink',
        defaultMessage: 'Edit link',
        description: 'Edit the link, update display text'
    },
    placeholder: {
        id: 'fabric.editor.hyperlinkToolbarPlaceholder',
        defaultMessage: 'Paste or search for link',
        description: 'Paste or search for link'
    },
    linkPlaceholder: {
        id: 'fabric.editor.linkPlaceholder',
        defaultMessage: 'Paste link',
        description: 'Create a new link by pasting a URL.'
    },
    linkAddress: {
        id: 'fabric.editor.linkAddress',
        defaultMessage: 'Link address',
        description: 'Insert the address of the link'
    },
    invalidLink: {
        id: 'fabric.editor.invalidLink',
        defaultMessage: 'Please enter a valid link.',
        description: 'Please enter a valid link.'
    },
    emptyLink: {
        id: 'fabric.editor.emptyLink',
        defaultMessage: 'Please enter a link.',
        description: 'Please enter a link.'
    },
    settingsLink: {
        id: 'fabric.editor.settingsLinks',
        defaultMessage: 'Go to Link Preferences',
        description: 'Go to Link Preferences'
    },
    preferencesLink: {
        id: 'fabric.editor.preferencesLink',
        defaultMessage: 'Link preferences',
        description: 'Go to link preferences'
    },
    editDatasource: {
        id: 'fabric.editor.edit.datasource',
        defaultMessage: 'Edit search query',
        description: 'Datasource toolbar edit button'
    },
    searchInput: {
        id: 'fabric.editor.edit.searchInput',
        defaultMessage: 'Add a link',
        description: 'Label for the search media input'
    }
});

});

parcelRegister("lQKNV", function(module, exports) {

$parcel$export(module.exports, "codeBlockButtonMessages", () => $20d0fb06aaa96548$export$74e304339778e94d);

var $7VHMR = parcelRequire("7VHMR");
const $20d0fb06aaa96548$export$74e304339778e94d = (0, $7VHMR.defineMessages)({
    copyCodeToClipboard: {
        id: 'fabric.editor.codeBlockCopyButton.copyToClipboard',
        defaultMessage: 'Copy as text',
        description: 'Copy the content of the code block as text to your clipboard'
    },
    copiedCodeToClipboard: {
        id: 'fabric.editor.codeBlockCopyButton.copiedToClipboard',
        defaultMessage: 'Copied!',
        description: 'Copied the content of the code block as text to clipboard'
    },
    wrapCode: {
        id: 'fabric.editor.codeBlockWrapButton.wrapCodeBlock',
        defaultMessage: 'Turn on wrap',
        description: 'Wrap the content of the code block'
    },
    unwrapCode: {
        id: 'fabric.editor.codeBlockWrapButton.unwrapCodeBlock',
        defaultMessage: 'Turn off wrap',
        description: 'Wrap the content of the code block'
    },
    selectLanguage: {
        id: 'fabric.editor.selectLanguage',
        defaultMessage: 'Select language',
        description: 'Code blocks display software code. A prompt to select the software language the code is written in.'
    }
});

});

parcelRegister("2i4K4", function(module, exports) {

$parcel$export(module.exports, "toolbarInsertBlockMessages", () => $4423ee10317a70cf$export$70c8a7203d95247);

var $7VHMR = parcelRequire("7VHMR");
const $4423ee10317a70cf$export$70c8a7203d95247 = (0, $7VHMR.defineMessages)({
    action: {
        id: 'fabric.editor.action',
        defaultMessage: 'Action item',
        description: "Also known as a \u201Ctask\u201D, \u201Cto do item\u201D, or a checklist"
    },
    actionDescription: {
        id: 'fabric.editor.action.description',
        defaultMessage: 'Create and assign action items',
        description: ''
    },
    closeInsertRightRail: {
        id: 'fabric.editor.insertRightRail.close',
        defaultMessage: 'Close',
        description: 'Close button label'
    },
    link: {
        id: 'fabric.editor.link',
        defaultMessage: 'Link',
        description: 'Insert a hyperlink'
    },
    linkDescription: {
        id: 'fabric.editor.link.description',
        defaultMessage: 'Insert a link',
        description: 'Insert a hyperlink'
    },
    mediaFiles: {
        id: 'fabric.editor.mediaFiles',
        defaultMessage: 'Image, video, or file',
        description: 'Insert one or more files, videos or images'
    },
    addMediaFiles: {
        id: 'fabric.editor.addMediaFiles',
        defaultMessage: 'Add image, video, or file',
        description: 'Insert one or more files, videos or images'
    },
    insertRightRailTitle: {
        id: 'fabric.editor.insertRightRail.title',
        defaultMessage: 'Insert',
        description: 'Insert a node into the document'
    },
    mediaFilesDescription: {
        id: 'fabric.editor.mediaFiles.description',
        defaultMessage: 'Add images and other files to your page',
        description: 'Insert one or more files or images'
    },
    image: {
        id: 'fabric.editor.image',
        defaultMessage: 'Image',
        description: 'Insert an image.'
    },
    mention: {
        id: 'fabric.editor.mention',
        defaultMessage: 'Mention',
        description: 'Reference another person in your document'
    },
    mentionDescription: {
        id: 'fabric.editor.mention.description',
        defaultMessage: 'Mention someone to send them a notification',
        description: 'Reference another person in your document'
    },
    emoji: {
        id: 'fabric.editor.emoji',
        defaultMessage: 'Emoji',
        description: 'Insert an emoticon or smiley :-)'
    },
    emojiDescription: {
        id: 'fabric.editor.emoji.description',
        defaultMessage: "Use emojis to express ideas \uD83C\uDF89 and emotions \uD83D\uDE04",
        description: 'Insert an emoticon or smiley :-)'
    },
    table: {
        id: 'fabric.editor.table',
        defaultMessage: 'Table',
        description: 'Inserts a table in the document'
    },
    tableDescription: {
        id: 'fabric.editor.table.description',
        defaultMessage: 'Insert a table',
        description: 'Inserts a table in the document'
    },
    tableSelector: {
        id: 'fabric.editor.tableSelector',
        defaultMessage: 'Table size',
        description: 'Opens a table selector that lets you insert a table of custom size'
    },
    tableSelectorDescription: {
        id: 'fabric.editor.tableSelector.description',
        defaultMessage: 'Add a table using popup to select a custom size',
        description: 'Opens a table selector that lets you insert a table of a custom size'
    },
    tableSizeSelectorButton: {
        id: 'fabric.editor.tableSizeSelectorButton',
        defaultMessage: '{numberOfColumns} by {numberOfRows}',
        description: 'Creates a table of custom size'
    },
    tableSizeSelectorPopup: {
        id: 'fabric.editor.tableSizeSelectorPopup',
        defaultMessage: 'Table size selector',
        description: 'Table selector popup to create table of custom size'
    },
    expand: {
        id: 'fabric.editor.expand',
        defaultMessage: 'Expand',
        description: 'Inserts an expand in the document'
    },
    expandDescription: {
        id: 'fabric.editor.expand.description',
        defaultMessage: 'Insert an expand',
        description: 'Inserts an expand in the document'
    },
    decision: {
        id: 'fabric.editor.decision',
        defaultMessage: 'Decision',
        description: "Capture a decision you\u2019ve made"
    },
    decisionDescription: {
        id: 'fabric.editor.decision.description',
        defaultMessage: "Capture decisions so they\u2019re easy to track",
        description: "Capture a decision you\u2019ve made"
    },
    feedbackDialog: {
        id: 'fabric.editor.feedbackDialog',
        defaultMessage: 'Give feedback',
        description: 'Open the feedback dialog from editor'
    },
    feedbackDialogDescription: {
        id: 'fabric.editor.feedbackDialog.description',
        defaultMessage: 'Tell us about your experience using the new editor',
        description: 'Description for feedback option under quick insert dropdown'
    },
    horizontalRule: {
        id: 'fabric.editor.horizontalRule',
        defaultMessage: 'Divider',
        description: 'A horizontal rule or divider'
    },
    horizontalRuleDescription: {
        id: 'fabric.editor.horizontalRule.description',
        defaultMessage: 'Separate content with a horizontal line',
        description: 'A horizontal rule or divider'
    },
    date: {
        id: 'fabric.editor.date',
        defaultMessage: 'Date',
        description: 'Opens a date picker that lets you select a date'
    },
    dateDescription: {
        id: 'fabric.editor.date.description',
        defaultMessage: 'Add a date using a calendar',
        description: 'Opens a date picker that lets you select a date'
    },
    placeholderText: {
        id: 'fabric.editor.placeholderText',
        defaultMessage: 'Placeholder text',
        description: 'Inserts a text placeholder into the page'
    },
    placeholderTextDescription: {
        id: 'fabric.editor.placeholderText.description',
        defaultMessage: 'Insert a text placeholder into the page',
        description: 'Inserts a text placeholder into the page'
    },
    columns: {
        id: 'fabric.editor.columns',
        defaultMessage: 'Layouts',
        description: 'Create a multi column section or layout'
    },
    columnsDescription: {
        id: 'fabric.editor.columns.description',
        defaultMessage: 'Structure your page using sections',
        description: 'Create a multi column section or layout'
    },
    columnsDescriptionAdvancedLayout: {
        id: 'fabric.editor.columns.advanced.layout.description',
        defaultMessage: 'Insert {numberOfColumns} equal {numberOfColumns, plural, one {column} other {columns}}',
        description: 'Create a multi column section or layout'
    },
    singleColumnsDescriptionAdvancedLayout: {
        id: 'fabric.editor.columns.advanced.layout.single.description',
        defaultMessage: 'Insert a single column layout',
        description: 'Create a multi column section or layout'
    },
    status: {
        id: 'fabric.editor.status',
        defaultMessage: 'Status',
        description: 'Inserts an item representing the status of an activity to task.'
    },
    statusDescription: {
        id: 'fabric.editor.status.description',
        defaultMessage: 'Add a custom status label',
        description: 'Inserts an item representing the status of an activity to task.'
    },
    viewMore: {
        id: 'fabric.editor.viewMore',
        defaultMessage: 'View more',
        description: 'View more elements that can be inserted'
    },
    viewMoreAriaLabel: {
        id: 'fabric.editor.viewMoreAriaLabel',
        defaultMessage: 'View all elements',
        description: 'A more descriptive aria label describing that users can view all the elements to be inserted.'
    },
    insertMenu: {
        id: 'fabric.editor.insertMenu',
        defaultMessage: 'Insert elements',
        description: 'Opens a menu of additional items that can be inserted into your document.'
    },
    help: {
        id: 'fabric.editor.help',
        defaultMessage: 'Help',
        description: 'Opens up the help dialog'
    },
    helpDescription: {
        id: 'fabric.editor.help.description',
        defaultMessage: 'Browse all the keyboard shortcuts and markdown options',
        description: 'Browse all the keyboard shortcuts and markdown options'
    },
    recordVideo: {
        id: 'fabric.editor.recordVideo',
        defaultMessage: 'Record a Loom video',
        description: 'Record a Loom video'
    },
    addLoomVideo: {
        id: 'fabric.editor.addLoomVideo',
        defaultMessage: 'Record a Loom video',
        description: 'Record a Loom video'
    },
    addLoomVideoComment: {
        id: 'fabric.editor.addLoomVideoComment',
        defaultMessage: 'Record a Loom video comment',
        description: 'Record a Loom video comment'
    },
    recordVideoDescription: {
        id: 'fabric.editor.recordVideo.description',
        defaultMessage: 'Record and share your screen and thoughts',
        description: 'Record and share your screen and thoughts'
    },
    recordLoomShortTitle: {
        id: 'fabric.editor.recordLoomShortTitle',
        defaultMessage: 'Record',
        description: 'Record'
    },
    turnInto: {
        id: 'fabric.editor.turnInto',
        defaultMessage: 'Turn into',
        description: 'Turn selected texts into another element containing those texts'
    }
});

});

parcelRegister("eX53M", function(module, exports) {

$parcel$export(module.exports, "toolbarMessages", () => $0e5cb7a66b16e8d0$export$81b075fd34c2f0bb);

var $7VHMR = parcelRequire("7VHMR");
const $0e5cb7a66b16e8d0$export$81b075fd34c2f0bb = (0, $7VHMR.defineMessages)({
    wrapLeft: {
        id: 'fabric.editor.wrapLeft',
        defaultMessage: 'Wrap left',
        description: 'Aligns your image to the left and wraps text around it.'
    },
    wrapRight: {
        id: 'fabric.editor.wrapRight',
        defaultMessage: 'Wrap right',
        description: 'Aligns your image to the right and wraps text around it.'
    },
    changeToMediaSingle: {
        id: 'fabric.editor.media_change_mediasingle',
        defaultMessage: 'Original size',
        description: 'In the context of a media inline image, it allows the user to convert it to media single'
    },
    changeToMediaInlineImage: {
        id: 'fabric.editor.media_change_mediainline_default',
        defaultMessage: 'Inline',
        description: 'In the context of media single contains media node, it allows the user to convert media single to media inline image'
    },
    changeToMediaInlineImageCaptionWarning: {
        id: 'fabric.editor.media_change_mediainline_caption_warn',
        defaultMessage: 'Inline (caption will be removed)',
        description: 'In the context of media single contains media node, it allows the user to convert media single to media inline image and warn user about caption being removed'
    }
});

});

parcelRegister("80CM7", function(module, exports) {

$parcel$export(module.exports, "messages", () => $402c787ddf19f01c$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $402c787ddf19f01c$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    url: {
        id: 'fabric.editor.url',
        defaultMessage: 'Display URL',
        description: 'Convert the card to become a regular text-based hyperlink.'
    },
    block: {
        id: 'fabric.editor.displayBlock',
        defaultMessage: 'Display card',
        description: 'Display link as a card with a rich preview similar to in a Facebook feed with page title, description, and potentially an image.'
    },
    inline: {
        id: 'fabric.editor.displayInline',
        defaultMessage: 'Display inline',
        description: 'Display link with the title only.'
    },
    embed: {
        id: 'fabric.editor.displayEmbed',
        defaultMessage: 'Display embed',
        description: 'Display link as an embedded object'
    },
    link: {
        id: 'fabric.editor.displayLink',
        defaultMessage: 'Display as text',
        description: 'Convert the card to become a regular text-based hyperlink.'
    },
    card: {
        id: 'fabric.editor.cardFloatingControls',
        defaultMessage: 'Card options',
        description: 'Options to change card type'
    },
    blockCardUnavailable: {
        id: 'fabric.editor.blockCardUnavailable',
        defaultMessage: 'The inline link is inside {node} and cannot have its view changed',
        description: 'Warning message to show the user that this node cannot change its view'
    },
    displayOptionUnavailableInParentNode: {
        id: 'fabric.editor.displayOptionUnavailableInParentNode',
        defaultMessage: "This display option isn't available inside {node}",
        description: 'Warning message to show the user that this node option is not available inside a parent node type'
    },
    urlTitle: {
        id: 'fabric.editor.urlTitle',
        defaultMessage: 'URL',
        description: 'Title for option to convert the card to become a regular text-based hyperlink.'
    },
    blockTitle: {
        id: 'fabric.editor.blockTitle',
        defaultMessage: 'Card',
        description: 'Title for option to display link in the card view.'
    },
    inlineTitle: {
        id: 'fabric.editor.inlineTitle',
        defaultMessage: 'Inline',
        description: 'Title for option to display link in the inline view.'
    },
    openButtonTitle: {
        id: 'fabric.editor.openButtonTitle',
        defaultMessage: 'Open',
        description: 'Title for a button that opens a link when clicked.'
    },
    embedTitle: {
        id: 'fabric.editor.embedTitle',
        defaultMessage: 'Embed',
        description: 'Title for option to display link as an embedded object.'
    },
    urlDescription: {
        id: 'fabric.editor.urlDescription',
        defaultMessage: 'Display link as URL',
        description: 'Description for option to convert the card to become a regular text-based hyperlink.'
    },
    blockDescription: {
        id: 'fabric.editor.blockDescription',
        defaultMessage: 'Display more information about a link, including a summary and actions',
        description: 'Description for option to display link in the card view.'
    },
    inlineDescription: {
        id: 'fabric.editor.inlineDescription',
        defaultMessage: 'Display link as inline text',
        description: 'Description for option to display link in the inline view.'
    },
    embedDescription: {
        id: 'fabric.editor.ecombedDescription',
        defaultMessage: 'Display an interactive preview of a link',
        description: 'Description for option to display link as an embedded object.'
    },
    editDropdownExpandIconLabel: {
        id: 'fabric.editor.editDropdownExpandIconLabel',
        defaultMessage: 'Expand dropdown menu',
        description: 'Text of an icon to expand the dropdown'
    },
    editDropdownTriggerTitle: {
        id: 'fabric.editor.editDropdownTriggerTitle',
        defaultMessage: 'Edit',
        description: 'Text of a button to trigger opening an edit dropdown'
    },
    editDropdownEditLinkTitle: {
        id: 'fabric.editor.editDropdownEditLinkTitle',
        defaultMessage: 'Edit link',
        description: 'Edit dropdown edit link button text'
    },
    editDropdownEditDatasourceTitle: {
        id: 'fabric.editor.editDropdownEditDatasourceTitle',
        defaultMessage: 'Edit search query',
        description: 'Edit dropdown edit datasource button text'
    },
    datasourceTitle: {
        id: 'fabric.editor.datasourceTitle',
        defaultMessage: 'Edit search query',
        description: 'Tooltip of button to edit a card into a datasource'
    },
    datasourceAppearanceTitle: {
        id: 'fabric.editor.datasourceAppearanceTitle',
        defaultMessage: 'List',
        description: 'Tooltip of button to change to datasource appearance'
    },
    datasourceJiraIssue: {
        id: 'fabric.editor.datasource.jiraIssue',
        defaultMessage: 'Jira Issues',
        description: 'Insert a jira datasource table'
    },
    datasourceJiraIssueDescription: {
        id: 'fabric.editor.datasource.jiraIssue.description',
        defaultMessage: 'Insert Jira issues from Jira Cloud with enhanced search, filtering, and configuration.',
        description: 'Insert a jira datasource table'
    },
    datasourceAssetsObjectsGeneralAvailability: {
        id: 'fabric.editor.datasource.assetsObjectsGeneralAvailability',
        defaultMessage: 'Assets',
        description: 'Text displayed when selecting the type of data to include onto the page, in this case: JSM Assets objects.'
    },
    datasourceAssetsObjectsDescription: {
        id: 'fabric.editor.datasource.assetsObjects.description',
        defaultMessage: 'Insert objects from Assets in Jira Service Management with search and filtering',
        description: 'Description text displayed when selecting the type of data to include onto the page, in this case: JSM Assets objects'
    },
    inlineOverlay: {
        id: 'fabric.editor.inlineOverlay',
        defaultMessage: 'Configure',
        description: 'An overlay shown when hover over inline smart link to inform user that they can click the link to edit the links appearance.'
    },
    inlineConfigureLink: {
        id: 'fabric.editor.inlineConfigureLink',
        defaultMessage: 'Configure link',
        description: 'An icon shown when hovering over inline smart link to inform user they can click the icon to configure the links appearance.'
    },
    inlineGoToLink: {
        id: 'fabric.editor.inlineGoToLink',
        defaultMessage: 'Go to link',
        description: 'An option in the configure link dropdown that informs the user they can click the option to open the link'
    },
    datasourceConfluenceSearch: {
        id: 'fabric.editor.datasource.confluenceSearch',
        defaultMessage: 'Insert Confluence list',
        description: 'Title shown for Confluence Search datasource on QuickInsert options'
    },
    datasourceConfluenceSearchDescription: {
        id: 'fabric.editor.datasource.confluenceSearch.description',
        defaultMessage: 'Insert list of search results from Confluence with enhanced search, filtering, and configuration.',
        description: 'Description text displayed when selecting the type of data to include onto the page, in this case: Confluence Search objects'
    },
    datasourceJiraIssueIssueTermRefresh: {
        id: 'fabric.editor.datasource.jiraIssue.issue-term-refresh',
        defaultMessage: 'Jira Work Items',
        description: 'Insert a jira datasource table (Issue Terminology Refresh)'
    },
    datasourceJiraIssueDescriptionIssueTermRefresh: {
        id: 'fabric.editor.datasource.jiraIssue.description.issue-term-refresh',
        defaultMessage: 'Insert Jira work items from Jira Cloud with enhanced search, filtering, and configuration.',
        description: 'Insert a jira datasource table (Issue Terminology Refresh)'
    }
});

});

parcelRegister("kXnoC", function(module, exports) {

$parcel$export(module.exports, "messages", () => $19e3f2f865259995$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $19e3f2f865259995$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    toolbarLabel: {
        id: 'fabric.editor.toolbarLabel',
        defaultMessage: 'Editor',
        description: 'Label for the ARIA region landmark'
    },
    pageActionsLabel: {
        id: 'fabric.editor.pageActionsLabel',
        defaultMessage: 'Page actions',
        description: 'Label for the ARIA region landmark'
    },
    editableContentLabel: {
        id: 'fabric.editor.editableContentLabel',
        defaultMessage: 'Editable content',
        description: 'Label for the ARIA region landmark'
    }
});

});

parcelRegister("eDTMN", function(module, exports) {

$parcel$export(module.exports, "toolbarMessages", () => $ec9866e02d0168cb$export$81b075fd34c2f0bb);

var $7VHMR = parcelRequire("7VHMR");
const $ec9866e02d0168cb$export$81b075fd34c2f0bb = (0, $7VHMR.defineMessages)({
    underline: {
        id: 'fabric.editor.underline',
        defaultMessage: 'Underline',
        description: 'Whether the text selection has underlined text'
    },
    strike: {
        id: 'fabric.editor.strike',
        defaultMessage: 'Strikethrough',
        description: 'Whether the text selection has crossed out text'
    },
    code: {
        id: 'fabric.editor.code',
        defaultMessage: 'Code',
        description: 'Whether the text selection has monospaced/code font'
    },
    codeOn: {
        id: 'fabric.editor.code.on',
        defaultMessage: '{textFormattingOff}, Code On',
        description: 'Reports that code formatting has been turned on'
    },
    subscript: {
        id: 'fabric.editor.subscript',
        defaultMessage: 'Subscript',
        description: 'Whether the text selection is written below the line in a slightly smaller size'
    },
    subscriptOffSuperscriptOn: {
        id: 'fabric.editor.subscript.off.superscript.on',
        defaultMessage: 'Subscript Off, Superscript On',
        description: 'Reports text formatting in case when subscript off and superscript on'
    },
    superscript: {
        id: 'fabric.editor.superscript',
        defaultMessage: 'Superscript',
        description: 'Whether the text selection is written above the line in a slightly smaller size'
    },
    superscriptOffSubscriptOn: {
        id: 'fabric.editor.superscript.off.subscript.on',
        defaultMessage: 'Superscript Off, Subscript On',
        description: 'Describe text formatting in case when Superscript Off and Subscript on'
    },
    clearFormatting: {
        id: 'fabric.editor.clearFormatting',
        defaultMessage: 'Clear formatting',
        description: 'Remove all rich text formatting from the selected text'
    },
    moreFormatting: {
        id: 'fabric.editor.moreFormatting',
        defaultMessage: 'More formatting',
        description: 'Clicking this will show a menu with additional formatting options'
    },
    textFormatting: {
        id: 'fabric.editor.textFormatting',
        defaultMessage: 'Text formatting',
        description: 'Aria label for the wrapper of text format buttons'
    },
    textFormat: {
        id: 'fabric.editor.textFormat',
        defaultMessage: 'Format text',
        description: 'Aria label for the wrapper of text format buttons'
    },
    bold: {
        id: 'fabric.editor.bold',
        defaultMessage: 'Bold',
        description: "This refers to bold or \u201Cstrong\u201D formatting, indicates that its contents have strong importance, seriousness, or urgency."
    },
    italic: {
        id: 'fabric.editor.italic',
        defaultMessage: 'Italic',
        description: 'This refers to italics or emphasized formatting.'
    },
    on: {
        id: 'fabric.editor.on',
        defaultMessage: '{formattingType} On',
        description: 'Reports that text formatting has been turned on'
    },
    off: {
        id: 'fabric.editor.off',
        defaultMessage: '{formattingType} Off',
        description: 'Reports that text formatting has been turned off'
    },
    textStyles: {
        id: 'fabric.editor.textStyles',
        defaultMessage: '{blockTypeName} Text styles',
        description: 'Menu label that provides access to various heading styles or normal text. For example: normal text styles, heading 1 text styles.'
    },
    textStylesTooltip: {
        id: 'fabric.editor.textStylesTooltip',
        defaultMessage: 'Text styles',
        description: 'Tooltip text for menu that provides access to various heading styles or normal text.'
    },
    textFormattingOff: {
        id: 'fabric.editor.text.formatting.off',
        defaultMessage: 'Text formatting Off',
        description: 'Reports that text formatting has been turned off'
    },
    navigateToEditorToolbar: {
        id: 'fabric.editor.navigate.toolbar.editor',
        defaultMessage: 'Navigate to editor toolbar',
        description: 'Navigate to the main editor toolbar.'
    },
    navigateToFloatingToolbar: {
        id: 'fabric.editor.navigate.toolbar.floating',
        defaultMessage: 'Navigate to floating toolbar',
        description: 'Navigate to a floating toolbar for relevant nodes (e.g. tables or panels).'
    },
    askAI: {
        id: 'fabric.editor.navigate.toolbar.askAI',
        defaultMessage: 'Ask AI',
        description: 'Open the AI panel to ask a question or generate content.'
    }
});

});

parcelRegister("2V0EL", function(module, exports) {

$parcel$export(module.exports, "messages", () => $bcecf16097bd0035$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $bcecf16097bd0035$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    tableOptions: {
        id: 'fabric.editor.tableOptions',
        defaultMessage: 'Table options',
        description: 'Opens a menu with additional table options'
    },
    tableSizeIncreaseScreenReaderInformation: {
        id: 'fabric.editor.tableResizeIncreaseScreenReaderInformation',
        defaultMessage: 'Table width increased to {newWidth, plural, one {# pixel} other {# pixels}}.',
        description: 'Information for screen reader users about increasing the table size by a certain number of pixels.'
    },
    tableSizeDecreaseScreenReaderInformation: {
        id: 'fabric.editor.tableResizeDecreaseScreenReaderInformation',
        defaultMessage: 'Table width decreased to {newWidth, plural, one {# pixel} other {# pixels}}.',
        description: 'Information for screen reader users about decreasing the table size by a certain number of pixels.'
    },
    headerRow: {
        id: 'fabric.editor.headerRow',
        defaultMessage: 'Header row',
        description: 'Marks the first table row as a header row'
    },
    headerColumn: {
        id: 'fabric.editor.headerColumn',
        defaultMessage: 'Header column',
        description: 'Marks the first table column as a header row'
    },
    numberedColumn: {
        id: 'fabric.editor.numberedColumn',
        defaultMessage: 'Numbered column',
        description: 'Adds an auto-numbering column to your table'
    },
    collapseTable: {
        id: 'fabric.editor.collapseTable',
        defaultMessage: 'Collapse table',
        description: 'Wraps table in an expand'
    },
    resizeTable: {
        id: 'fabric.editor.tables.resizeTable',
        defaultMessage: 'Resize table',
        description: 'Tooltip displayed on custom table width resize hande'
    },
    insertColumn: {
        id: 'fabric.editor.insertColumn',
        defaultMessage: 'Insert column right',
        description: 'Inserts a new column to the right of selected column.'
    },
    addColumnLeft: {
        id: 'fabric.editor.addColumnLeft',
        defaultMessage: 'Add column left',
        description: 'Adds a new column to the left of selected column.'
    },
    addColumnRight: {
        id: 'fabric.editor.addColumnRight',
        defaultMessage: 'Add column right',
        description: 'Adds a new column to the right of selected column.'
    },
    insertColumnDrag: {
        id: 'fabric.editor.insertColumnDrag',
        defaultMessage: 'Insert column',
        description: 'Inserts a new column to the right of selected column.'
    },
    removeColumns: {
        id: 'fabric.editor.removeColumns',
        defaultMessage: 'Delete {0, plural, one {column} other {columns}}',
        description: 'Deletes a table column.'
    },
    insertRow: {
        id: 'fabric.editor.insertRow',
        defaultMessage: 'Insert row below',
        description: 'Inserts a new row below the selected row.'
    },
    addRowAbove: {
        id: 'fabric.editor.addRowAbove',
        defaultMessage: 'Add row above',
        description: 'Adds a new row above the selected row.'
    },
    addRowBelow: {
        id: 'fabric.editor.addRowBelow',
        defaultMessage: 'Add row below',
        description: 'Adds a new row below the selected row.'
    },
    moveColumnLeft: {
        id: 'fabric.editor.moveColumnLeft',
        defaultMessage: 'Move {0, plural, one {column} other {columns}} left',
        description: 'Moves a column or columns to the left.'
    },
    moveColumnRight: {
        id: 'fabric.editor.moveColumnRight',
        defaultMessage: 'Move {0, plural, one {column} other {columns}} right',
        description: 'Moves a column or columns to the right.'
    },
    moveRowUp: {
        id: 'fabric.editor.moveRowUp',
        defaultMessage: 'Move {0, plural, one {row} other {rows}} up',
        description: 'Moves a row or selected rows up.'
    },
    moveRowDown: {
        id: 'fabric.editor.moveDownDown',
        defaultMessage: 'Move {0, plural, one {row} other {rows}} down',
        description: 'Moves a row or selected rows down.'
    },
    insertRowDrag: {
        id: 'fabric.editor.insertRowDrag',
        defaultMessage: 'Insert row',
        description: 'Inserts a new row below the selected row.'
    },
    removeRows: {
        id: 'fabric.editor.removeRows',
        defaultMessage: 'Delete {0, plural, one {row} other {rows}}',
        description: 'Deletes a table row.'
    },
    rowNumbers: {
        id: 'fabrid.editor.rowNumbers',
        defaultMessage: 'Row numbers',
        desciption: 'Adds a number to each row except header row'
    },
    rowsAreInserted: {
        id: 'fabric.editor.rowsAreInserted',
        defaultMessage: '{count, plural, one {A row has been} other {{count} rows have been}} inserted',
        description: 'Assistive message following the insertion of row(s)'
    },
    rowsAreRemoved: {
        id: 'fabric.editor.rowsAreRemoved',
        defaultMessage: '{count, plural, one {The row has been} other {{count} rows have been}} removed',
        description: 'Assistive message following the removal of row(s)'
    },
    rowSelected: {
        id: 'fabric.editor.rowSelected',
        defaultMessage: 'Row {index} of {total} selected',
        description: 'Assistive message following the selection of a row'
    },
    rowMovedUp: {
        id: 'fabric.editor.rowMovedUp',
        defaultMessage: 'Row moved up to {index} of {total}',
        description: 'Assistive message following the upward movement of a row'
    },
    rowMovedDown: {
        id: 'fabric.editor.rowMovedDown',
        defaultMessage: 'Row moved down to {index} of {total}',
        description: 'Assistive message following the downward movement of a row'
    },
    columnsAreInserted: {
        id: 'fabric.editor.columnsAreInserted',
        defaultMessage: '{count, plural, one {A column has been} other {{count} columns have been}} inserted',
        description: 'Assistive message following the insertion of column(s)'
    },
    columnsAreRemoved: {
        id: 'fabric.editor.columnsAreRemoved',
        defaultMessage: '{count, plural, one {The column has been} other {{count} columns have been}} removed',
        description: 'Assistive message following the removal of column(s)'
    },
    columnSelected: {
        id: 'fabric.editor.columnSelected',
        defaultMessage: 'Column {index} of {total} selected',
        description: 'Assistive message following the selection of a column'
    },
    columnMovedLeft: {
        id: 'fabric.editor.columnMovedLeft',
        defaultMessage: 'Column moved left to {index} of {total}',
        description: 'Assistive message following the left movement of a column'
    },
    columnMovedRight: {
        id: 'fabric.editor.columnMovedRight',
        defaultMessage: 'Column moved right to {index} of {total}',
        description: 'Assistive message following the right movement of a column'
    },
    cellOptions: {
        id: 'fabric.editor.cellOptions',
        defaultMessage: 'Cell options',
        description: 'Opens a menu with options for the current table cell.'
    },
    confirmDeleteLinkedModalOKButton: {
        id: 'fabric.editor.tables.confirmDeleteLinkedModalOKButton',
        defaultMessage: 'Delete',
        description: 'Action button label for confirm modal when deleting a table linked to an extension.'
    },
    confirmDeleteLinkedModalMessage: {
        id: 'fabric.editor.tables.confirmDeleteLinkedModalMessage',
        defaultMessage: 'Deleting {nodeName} will break anything connected to it.',
        description: 'Message for confirm modal when deleting a table linked to an extension.'
    },
    confirmDeleteLinkedModalMessagePrefix: {
        id: 'fabric.editor.extension.confirmDeleteLinkedModalMessagePrefix',
        defaultMessage: 'Deleting',
        description: 'prefix for confirmation dialog text'
    },
    confirmModalCheckboxLabel: {
        id: 'fabric.editor.floatingToolbar.confirmModalCheckboxLabel',
        defaultMessage: 'Also delete connected elements',
        description: 'checkbox label text'
    },
    deleteElementTitle: {
        id: 'fabric.editor.extension.deleteElementTitle',
        defaultMessage: 'Delete element',
        description: 'Title text for confirm modal when deleting an extension linked to a data consumer.'
    },
    unnamedSource: {
        id: 'fabric.editor.extension.sourceNoTitledName',
        defaultMessage: 'this element',
        description: 'The current element without preset name been selected'
    },
    adjustColumns: {
        id: 'fabric.editor.tables.adjustColumn',
        defaultMessage: 'Adjust column',
        description: 'Tooltip displayed on table column resize handle'
    },
    cornerControl: {
        id: 'fabric.editor.cornerControl',
        defaultMessage: 'Highlight table',
        description: 'A button on the upper left corner of the table that shows up when the table is in focus. Clicking on it will select the entire table.'
    },
    cellBackground: {
        id: 'fabric.editor.cellBackground',
        defaultMessage: 'Cell background',
        description: 'Change the background color of a table cell.'
    },
    backgroundColor: {
        id: 'fabric.editor.backgroundColor',
        defaultMessage: 'Background color',
        description: 'Change the background color of a table cell.'
    },
    mergeCells: {
        id: 'fabric.editor.mergeCells',
        defaultMessage: 'Merge cells',
        description: 'Merge tables cells together.'
    },
    splitCell: {
        id: 'fabric.editor.splitCell',
        defaultMessage: 'Split cell',
        description: 'Split a merged table cell.'
    },
    clearCells: {
        id: 'fabric.editor.clearCells',
        defaultMessage: 'Clear {0, plural, one {cell} other {cells}}',
        description: 'Clears the contents of the selected cells (this does not delete the cells themselves).'
    },
    sortColumnASC: {
        id: 'fabric.editor.sortColumnASC',
        defaultMessage: "Sort column A \u2192 Z",
        description: 'Sort column in ascending order'
    },
    sortColumnDESC: {
        id: 'fabric.editor.sortColumnDESC',
        defaultMessage: "Sort column Z \u2192 A",
        description: 'Sort column in descending order'
    },
    sortColumnIncreasing: {
        id: 'fabric.editor.sortColumnIncreasing',
        defaultMessage: 'Sort increasing',
        description: 'Sort column in ascending order'
    },
    sortColumnDecreasing: {
        id: 'fabric.editor.sortColumnDecreasing',
        defaultMessage: 'Sort decreasing',
        description: 'Sort column in descending order'
    },
    canNotSortTable: {
        id: 'fabric.editor.canNotSortTable',
        defaultMessage: `\u{26A0}\u{FE0F} You can't sort a table with merged cells`,
        description: `Split your cells to enable this feature`
    },
    distributeColumns: {
        id: 'fabric.editor.distributeColumns',
        defaultMessage: `Distribute columns`,
        description: `Distribute widths between selected columns`
    },
    lockColumnWidths: {
        id: 'fabric.editor.lockColumns',
        defaultMessage: 'Fixed column widths',
        description: 'Toggle button to enable fixed column widths'
    },
    rowControl: {
        id: 'fabric.editor.rowControl',
        defaultMessage: 'Highlight row',
        description: 'A button on the left of each row that shows up when the table is in focus. Clicking on it will select the entire row.'
    },
    rowDragHandle: {
        id: 'fabric.editor.rowDragHandle',
        defaultMessage: 'Row options',
        description: 'The row drag handle to move the row within the table. Click to open a menu for more row options.'
    },
    columnDragHandle: {
        id: 'fabric.editor.columnDragHandle',
        defaultMessage: 'Column options',
        description: 'The column drag handle to move the column within the table. Click to open a menu for more column options.'
    },
    fullWidthLabel: {
        id: 'fabric.editor.tableFullWidthLabel',
        defaultMessage: 'Full-width',
        description: 'Trigger table width to full-width mode'
    },
    startedColumnResize: {
        id: 'fabric.editor.tables.startedColumnResize',
        defaultMessage: 'Started column resize',
        description: 'Screen Reader announces when the user engages the column resizer'
    },
    focusedOtherResize: {
        id: 'fabric.editor.tables.otherResize',
        defaultMessage: '{direction, select, left {Switched to the left column resize} right {Switched to the right column resize} other {}}',
        description: 'Screen Reader announces when the user switches to the left or right column resizer'
    },
    changedColumnWidth: {
        id: 'fabric.editor.tables.columnWidth',
        defaultMessage: '{width, plural, one {Column width was changed to {width} pixel} other {Column width was changed to {width} pixels}}',
        description: 'Screen Reader announces when the user modifies the column width'
    },
    columnResizeStop: {
        id: 'fabric.editor.tables.resizeStop',
        defaultMessage: 'Stopped resize',
        description: 'Screen Reader announces when the user discontinues the resizing operation'
    },
    columnResizeOverflow: {
        id: 'fabric.editor.tables.columnResizeOverflow',
        defaultMessage: 'You can only resize this column while the table has a scroll bar.',
        description: 'Screen Reader announces when the user attempts to resize the last column without the table being in overflow state'
    },
    columnResizeLast: {
        id: 'fabric.editor.tables.columnResizeLast',
        defaultMessage: 'You can only resize this column to the left.',
        description: 'Screen Reader announces when the user attempts to resize the last column when only the previous one is available for resizing'
    },
    tableAlignmentOptions: {
        id: 'fabric.editor.tableAlignmentOptions',
        defaultMessage: 'Alignment options',
        description: 'Opens a menu with additional table alignment options'
    },
    alignTableCenter: {
        id: 'fabric.editor.alignTableCenter',
        defaultMessage: 'Align center',
        description: 'Aligns table to the center'
    },
    alignTableLeft: {
        id: 'fabric.editor.alignTableLeft',
        defaultMessage: 'Align left',
        description: 'Aligns table to the left'
    }
});

});

parcelRegister("kFJBG", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a872fd5a03f73724$export$defe85febe8b728c);
// Common Translations will live here

var $7VHMR = parcelRequire("7VHMR");
const $a872fd5a03f73724$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    unorderedList: {
        id: 'fabric.editor.unorderedList',
        defaultMessage: 'Bullet list',
        description: "A list with bullets. Also known as an \u201Cunordered\u201D list"
    },
    unorderedListDescription: {
        id: 'fabric.editor.unorderedList.description',
        defaultMessage: 'Create an unordered list',
        description: ''
    },
    orderedList: {
        id: 'fabric.editor.orderedList',
        defaultMessage: 'Numbered list',
        description: "A list with ordered items 1\u2026 2\u2026 3\u2026"
    },
    orderedListDescription: {
        id: 'fabric.editor.orderedList.description',
        defaultMessage: 'Create an ordered list',
        description: ''
    },
    lists: {
        id: 'fabric.editor.lists',
        defaultMessage: 'Lists',
        description: 'Menu shows ordered/bullet list and unordered/numbered lists'
    },
    listsFormat: {
        id: 'fabric.editor.listsFormat',
        defaultMessage: 'List formatting',
        description: 'Aria label for the wrapper of list buttons'
    }
});

});

parcelRegister("7S9ZN", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9078664297972b18$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $9078664297972b18$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    undo: {
        id: 'fabric.editor.undo',
        defaultMessage: 'Undo',
        description: 'Undo the previously performed action.'
    },
    redo: {
        id: 'fabric.editor.redo',
        defaultMessage: 'Redo',
        description: 'Redo the previously undone action.'
    }
});

});

parcelRegister("6OcHr", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b883afcc2fb8665e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $b883afcc2fb8665e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    statusEditorLabel: {
        id: 'fabric.editor.statusEditorLabel',
        defaultMessage: 'Status editor',
        description: 'Label for the status element editor'
    },
    placeholder: {
        id: 'fabric.editor.statusPlaceholder',
        defaultMessage: 'Set a status',
        description: 'Placeholder description for an empty (new) status item in the editor'
    },
    editText: {
        id: 'fabric.editor.editStatusText',
        defaultMessage: 'Edit Status',
        description: 'Title for the input that changes the status text'
    },
    editColor: {
        id: 'fabric.editor.editStatusColor',
        defaultMessage: 'Edit Status Color',
        description: 'Title for the color picker that changes the status color'
    },
    statusPickerOpenedAlert: {
        id: 'fabric.editor.statusPickerOpenedAlert',
        defaultMessage: 'Status editor popup opened, press Tab to access popup',
        description: 'Screen reader alert when the status picker is opened, letting the user know they can press the Tab button to access the status picker'
    }
});

});

parcelRegister("dbepQ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $19b9098ff265842b$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $19b9098ff265842b$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    editText: {
        id: 'fabric.editor.editDateText',
        defaultMessage: 'Edit Date',
        description: 'Title for the input that changes the date'
    },
    invalidDateError: {
        id: 'fabric.editor.invalidDateError',
        defaultMessage: 'Enter a valid date',
        description: 'Error message when the date typed in is invalid, requesting they inputs a new date'
    },
    onKeyUpDownText: {
        id: 'fabric.editor.upDown',
        defaultMessage: 'On the use of up and down arrow keys into the following input field, the date will update below',
        description: 'The text for the date input informs the user that using the arrow keys (up and down) will update the date picker below'
    },
    datePickerOpenedAlert: {
        id: 'fabric.editor.datePickerOpenedAlert',
        defaultMessage: 'Date editor popup opened, press Tab to access popup',
        description: 'Screen reader alert when the date picker is opened, letting the user know they can press the Tab button to access the date picker'
    }
});

});

parcelRegister("kANLZ", function(module, exports) {

$parcel$export(module.exports, "toolbarMessages", () => $2ae4030e88533f57$export$81b075fd34c2f0bb);

var $7VHMR = parcelRequire("7VHMR");
const $2ae4030e88533f57$export$81b075fd34c2f0bb = (0, $7VHMR.defineMessages)({
    singleColumn: {
        id: 'fabric.editor.single',
        defaultMessage: 'Single column layout',
        description: 'Layout with one single column'
    },
    twoColumns: {
        id: 'fabric.editor.twoColumns',
        defaultMessage: 'Two columns layout',
        description: 'Layout with two columns of equal width'
    },
    singleColumnAdvancedLayout: {
        id: 'fabric.editor.singleColumns',
        defaultMessage: '1 Column layout',
        description: 'Layout with one column of equal width'
    },
    twoColumnsAdvancedLayout: {
        id: 'fabric.editor.twoColumns',
        defaultMessage: '2 Column layout',
        description: 'Layout with two columns of equal width'
    },
    threeColumns: {
        id: 'fabric.editor.threeColumns',
        defaultMessage: 'Three columns layout',
        description: 'Layout with three columns of equal width'
    },
    threeColumnsAdvancedLayout: {
        id: 'fabric.editor.threeColumns',
        defaultMessage: '3 Column layout',
        description: 'Layout with three columns of equal width'
    },
    fourColumns: {
        id: 'fabric.editor.fourColumns',
        defaultMessage: '4 Column layout',
        description: 'Layout with four columns of equal width'
    },
    fiveColumns: {
        id: 'fabric.editor.fiveColumns',
        defaultMessage: '5 Column layout',
        description: 'Layout with five columns of equal width'
    },
    rightSidebar: {
        id: 'fabric.editor.rightSidebar',
        defaultMessage: 'Right sidebar layout',
        description: 'Layout with two columns, left column is 2/3 and right is 1/3 of page'
    },
    leftSidebar: {
        id: 'fabric.editor.leftSidebar',
        defaultMessage: 'Left sidebar layout',
        description: 'Layout with two columns, left column is 1/3 and right is 2/3 of page'
    },
    threeColumnsWithSidebars: {
        id: 'fabric.editor.threeColumnsWithSidebars',
        defaultMessage: 'Three columns with sidebars layout',
        description: 'Layout with 3 columns laid out as 25% - 50% - 25%'
    },
    threeColumnsWithLeftSidebars: {
        id: 'fabric.editor.threeColumnsWithLeftSidebars',
        defaultMessage: 'Three columns with left sidebar layout',
        description: 'Layout with 3 columns laid out as 25% - 25% - 50%'
    },
    threeColumnsWithRightSidebars: {
        id: 'fabric.editor.threeColumnsWithRightSidebars',
        defaultMessage: 'Three columns with right sidebar layout',
        description: 'Layout with 3 columns laid out as 50% - 25% - 25%'
    },
    floatingToolbarRadioGroupAriaLabel: {
        id: 'fabric.editor.floatingToolbar.floatingToolbarRadioGroupAriaLabel',
        defaultMessage: 'Layout options',
        description: "a floating toolbar radiogroup's aria label"
    },
    layoutPlaceholder: {
        id: 'fabric.editor.layout.placeholder',
        defaultMessage: 'Add content',
        description: 'Add placeholder text for empty layout'
    },
    controlslayoutPlaceholder: {
        id: 'fabric.editor.layout.controls.placeholder',
        defaultMessage: '/ to insert',
        description: 'Add placeholder text for empty layout'
    },
    columnOption: {
        id: 'fabric.editor.layout.columnOption',
        defaultMessage: '{count, plural, one {{count} Column} other {{count} Columns}}',
        description: 'column option text for layout'
    },
    resizeLayout: {
        id: 'fabric.editor.layout.resizeLayout',
        defaultMessage: 'Resize layout',
        description: 'resize layout'
    }
});

});

parcelRegister("kmmxF", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e4735e0a5cdca6f9$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $e4735e0a5cdca6f9$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    indent: {
        id: 'fabric.editor.indent',
        defaultMessage: 'Indent',
        description: 'Indent a list item, paragraph or heading'
    },
    outdent: {
        id: 'fabric.editor.outdent',
        defaultMessage: 'Outdent',
        description: 'Outdent a list item, paragraph or heading'
    }
});

});

parcelRegister("80TXs", function(module, exports) {

$parcel$export(module.exports, "avatarGroupMessages", () => $cedd04a0024a64f8$export$8a0e7c3f8f5b8868);

var $7VHMR = parcelRequire("7VHMR");
const $cedd04a0024a64f8$export$8a0e7c3f8f5b8868 = (0, $7VHMR.defineMessages)({
    editors: {
        id: 'fabric.editor.editors',
        defaultMessage: 'Editors',
        description: 'classifying the people that are currently editing the document'
    }
});

});

parcelRegister("9QBHe", function(module, exports) {

$parcel$export(module.exports, "findReplaceMessages", () => $b943fdad34912591$export$b46a930e1a386b2e);

var $7VHMR = parcelRequire("7VHMR");
const $b943fdad34912591$export$b46a930e1a386b2e = (0, $7VHMR.defineMessages)({
    find: {
        id: 'fabric.editor.find',
        defaultMessage: 'Find',
        description: 'The word or phrase to search for on the document'
    },
    matchCase: {
        id: 'fabric.editor.matchCase',
        defaultMessage: 'Match case',
        description: 'Toggle whether should also match case when searching for text'
    },
    findNext: {
        id: 'fabric.editor.findNext',
        defaultMessage: 'Find next',
        description: 'Locate the next occurrence of the word or phrase that was searched for'
    },
    findPrevious: {
        id: 'fabric.editor.findPrevious',
        defaultMessage: 'Find previous',
        description: 'Locate the previous occurrence of the word or phrase that was searched for'
    },
    closeFindReplaceDialog: {
        id: 'fabric.editor.closeFindReplaceDialog',
        defaultMessage: 'Close',
        description: 'Cancel search and close the "Find and Replace" dialog'
    },
    noResultsFound: {
        id: 'fabric.editor.noResultsFound',
        defaultMessage: 'No results',
        description: 'No matches were found for the word or phrase that was searched for'
    },
    resultsCount: {
        id: 'fabric.editor.resultsCount',
        description: 'Text for selected search match position and total results count',
        defaultMessage: '{selectedMatchPosition} of {totalResultsCount}'
    },
    findReplaceToolbarButton: {
        id: 'fabric.editor.findReplaceToolbarButton',
        defaultMessage: 'Find and replace',
        description: '"Find" highlights all instances of a word or phrase on the document, and "Replace" changes one or all of those instances to something else'
    },
    replaceWith: {
        id: 'fabric.editor.replaceWith',
        defaultMessage: 'Replace with',
        description: 'The value that will replace the word or phrase that was searched for'
    },
    replace: {
        id: 'fabric.editor.replace',
        defaultMessage: 'Replace',
        description: 'Replace only the currently selected instance of the word or phrase'
    },
    replaceAll: {
        id: 'fabric.editor.replaceAll',
        defaultMessage: 'Replace all',
        description: 'Replace all instances of the word or phrase throughout the entire document'
    },
    replaceSuccess: {
        id: 'fabric.editor.replaceSuccess',
        defaultMessage: '{numberOfMatches, plural, one {# match replaced} other {# matches replaced}}',
        description: 'Text when replacement succesfully done'
    }
});

});

parcelRegister("1IiUD", function(module, exports) {

$parcel$export(module.exports, "elementInsertSidePanel", () => $97dbccb0b0b981b3$export$276a218f93338b76);

var $7VHMR = parcelRequire("7VHMR");
const $97dbccb0b0b981b3$export$276a218f93338b76 = (0, $7VHMR.defineMessages)({
    title: {
        id: 'fabric.editor.elementInsertSidePanel.title',
        defaultMessage: 'Insert',
        description: 'Title of a panel that opens on the side'
    }
});

});

parcelRegister("kAM3u", function(module, exports) {

$parcel$export(module.exports, "textColorMessages", () => $147c4cd461faf1fe$export$effb4ee8b6f74abe);

var $7VHMR = parcelRequire("7VHMR");
const $147c4cd461faf1fe$export$effb4ee8b6f74abe = (0, $7VHMR.defineMessages)({
    textColor: {
        id: 'fabric.editor.textColor',
        defaultMessage: '{selectedColorName} Text color',
        description: 'Label of menu that provides access to various colors of text. For example: green Text color, dark blue Text color'
    },
    textColorTooltip: {
        id: 'fabric.editor.textColorTooltip',
        defaultMessage: 'Text color',
        description: 'Toolip of menu that provides access to various colors of text.'
    }
});

});

parcelRegister("6lWmZ", function(module, exports) {

$parcel$export(module.exports, "tasksAndDecisionsMessages", () => $65d46911a2519e83$export$273d864e9e6d0b1f);

var $7VHMR = parcelRequire("7VHMR");
const $65d46911a2519e83$export$273d864e9e6d0b1f = (0, $7VHMR.defineMessages)({
    taskPlaceholder: {
        id: 'fabric.editor.taskPlaceholder',
        defaultMessage: "Type your action, use '@' to assign to someone.",
        description: 'Placeholder description for an empty action/task in the editor'
    },
    decisionPlaceholder: {
        id: 'fabric.editor.decisionPlaceholder',
        defaultMessage: "Add a decision\u2026",
        description: 'Placeholder description for an empty decision in the editor'
    },
    editAccessTitle: {
        id: 'fabric.editor.editAccessTitle',
        defaultMessage: 'You need edit access',
        description: 'Title in the popup when we click on action item checkbox without edit permission'
    },
    requestToEditDescription: {
        id: 'fabric.editor.requestToEditDescription',
        defaultMessage: 'When you request access, the page owner will receive a notification.',
        description: 'Description in the popup when we click on action item checkbox without edit permission'
    },
    requestToEdit: {
        id: 'fabric.editor.requestToEdit',
        defaultMessage: 'Request to edit',
        description: 'Button in the popup when we click on action item checkbox without edit permission'
    },
    dismiss: {
        id: 'fabric.editor.requestToEditDismiss',
        defaultMessage: 'Dismiss',
        description: 'Button in the popup when we click on dismiss without edit permission'
    }
});

});

parcelRegister("ixwvf", function(module, exports) {

$parcel$export(module.exports, "placeholderTextMessages", () => $358e275c47040b0e$export$ee8ab8a034b5a8bd);

var $7VHMR = parcelRequire("7VHMR");
const $358e275c47040b0e$export$ee8ab8a034b5a8bd = (0, $7VHMR.defineMessages)({
    placeholderTextPlaceholder: {
        id: 'fabric.editor.placeholderTextPlaceholder',
        defaultMessage: 'Add placeholder text',
        description: ''
    },
    shortEmptyNodePlaceholderText: {
        id: 'fabric.editor.shortEmptyNodePlaceholderText',
        defaultMessage: '/ to insert',
        description: 'Short placeholder text for empty nodes'
    },
    longEmptyNodePlaceholderText: {
        id: 'fabric.editor.longEmptyNodePlaceholderText',
        defaultMessage: 'Type / to insert elements',
        description: 'Long placeholder text for empty nodes'
    }
});

});

parcelRegister("fJm1A", function(module, exports) {

$parcel$export(module.exports, "pasteOptionsToolbarMessages", () => $b0fedd2e9a93e39a$export$703e803e9cb0cea4);

var $7VHMR = parcelRequire("7VHMR");
const $b0fedd2e9a93e39a$export$703e803e9cb0cea4 = (0, $7VHMR.defineMessages)({
    pasteOptions: {
        id: 'fabric.editor.pasteOptions',
        defaultMessage: 'Paste options',
        description: 'Opens a menu with additional paste options'
    },
    plainText: {
        id: 'fabric.editor.plainText',
        defaultMessage: 'Use plain text',
        description: 'Converts pasted text into plain text'
    },
    markdown: {
        id: 'fabric.editor.useMarkdown',
        defaultMessage: 'Use Markdown',
        description: 'Converts pasted text into Markdown'
    },
    richText: {
        id: 'fabric.editor.richText',
        defaultMessage: 'Use rich text',
        description: 'Converts pasted text into Rich text'
    }
});

});

parcelRegister("ecAvy", function(module, exports) {

$parcel$export(module.exports, "panelMessages", () => $e955dc2d97d725ff$export$7bb18eb6f9170174);

var $7VHMR = parcelRequire("7VHMR");
const $e955dc2d97d725ff$export$7bb18eb6f9170174 = (0, $7VHMR.defineMessages)({
    info: {
        id: 'fabric.editor.info',
        defaultMessage: 'Info',
        description: 'Panels provide a way to highlight text. The info panel has a blue background.'
    },
    note: {
        id: 'fabric.editor.note',
        defaultMessage: 'Note',
        description: 'Panels provide a way to highlight text. The note panel has a purple background.'
    },
    success: {
        id: 'fabric.editor.success',
        defaultMessage: 'Success',
        description: 'Panels provide a way to highlight text. The success panel has a green background.'
    },
    warning: {
        id: 'fabric.editor.warning',
        defaultMessage: 'Warning',
        description: 'Panels provide a way to highlight text. The warning panel has a yellow background.'
    },
    error: {
        id: 'fabric.editor.error',
        defaultMessage: 'Error',
        description: 'Panels provide a way to highlight text. The error panel has a red background.'
    },
    emoji: {
        id: 'fabric.editor.panel.emoji',
        defaultMessage: 'Add emoji',
        description: 'Select the panel icon'
    },
    custom: {
        id: 'fabric.editor.panel.custom',
        defaultMessage: 'Custom',
        description: 'Custom panels where user has selected custom emoji and background color'
    },
    backgroundColor: {
        id: 'fabric.editor.panel.backgroundColor',
        defaultMessage: 'Background color',
        description: 'Select the panel background color.'
    },
    panelsGroup: {
        id: 'fabric.editor.panel.panelsGroup',
        defaultMessage: 'Panel Types',
        description: 'aria-label for group of panels the floating toolbar'
    }
});

});

parcelRegister("7ywdr", function(module, exports) {

$parcel$export(module.exports, "mentionMessages", () => $a3d6d16f96d339d5$export$33aafd5ccbbbd00a);

var $7VHMR = parcelRequire("7VHMR");
const $a3d6d16f96d339d5$export$33aafd5ccbbbd00a = (0, $7VHMR.defineMessages)({
    inviteItemTitle: {
        id: 'fabric.editor.inviteItem.title',
        defaultMessage: '{userRole, select, admin {Invite} trusted {Invite} other {Add}} teammate to {productName}',
        description: 'Title of the invite teammate item in typeahead plugin'
    },
    mentionsAddLabel: {
        id: 'fabric.editor.mentionsAddLabel',
        defaultMessage: 'add-icon',
        description: 'icon label to describe adding a new mention'
    },
    mentionsIconLabel: {
        id: 'fabric.editor.mentionsIconLabel',
        defaultMessage: 'Mention',
        description: 'icon label to describe the mention icon'
    },
    mentionsNodeLabel: {
        id: 'fabric.editor.mentionNode.label',
        defaultMessage: 'Tagged user',
        description: 'Label to indicate mention node to Screen reader users, that preceeds with user name ex: "Tagged user @XXX'
    },
    unknownLabel: {
        id: 'fabric.editor.unknown.label',
        defaultMessage: 'Unknown',
        description: 'Label to indicate unknown mention node'
    }
});

});

parcelRegister("1ElKj", function(module, exports) {

$parcel$export(module.exports, "helpDialogMessages", () => $691908dbd48d7aae$export$83c85447c71428ba);

var $7VHMR = parcelRequire("7VHMR");
const $691908dbd48d7aae$export$83c85447c71428ba = (0, $7VHMR.defineMessages)({
    editorHelp: {
        id: 'fabric.editor.editorHelp',
        defaultMessage: 'Editor help',
        description: 'Title of editor help dialog.'
    },
    helpDialogTips: {
        id: 'fabric.editor.helpDialogTips',
        defaultMessage: 'Press {keyMap} to quickly open this dialog at any time',
        description: 'Hint about how to open a dialog quickly using a shortcut.'
    },
    keyboardShortcuts: {
        id: 'fabric.editor.keyboardShortcuts',
        defaultMessage: 'Keyboard shortcuts',
        description: ''
    },
    markdown: {
        id: 'fabric.editor.markdown',
        defaultMessage: 'Markdown',
        description: 'It is a name of popular markup language.'
    },
    pastePlainText: {
        id: 'fabric.editor.pastePlainText',
        defaultMessage: 'Paste plain text',
        description: ''
    },
    CheckUncheckActionItem: {
        id: 'fabric.editor.checkUncheckActionItem',
        defaultMessage: 'Toggle action item',
        description: 'For Check/Uncheck Action item use shortcut'
    },
    InsertTableColumn: {
        id: 'fabric.editor.insertTableColumn',
        defaultMessage: 'Insert table column',
        description: 'For insert table column'
    },
    InsertTableRow: {
        id: 'fabric.editor.insertTableRow',
        defaultMessage: 'Insert table row',
        description: 'For insert table row'
    },
    altText: {
        id: 'fabric.editor.altText',
        defaultMessage: 'Alt text',
        description: 'Alternative text for image.'
    },
    selectTableRow: {
        id: 'fabric.editor.selectTableRow',
        defaultMessage: 'Select table row',
        description: 'Hint for selecting a table row using a shortcut'
    },
    selectTableColumn: {
        id: 'fabric.editor.selectTableColumn',
        defaultMessage: 'Select table column',
        description: 'Hint for selecting a table column using a shortcut'
    },
    selectColumnResize: {
        id: 'fabric.editor.selectColumnResize',
        defaultMessage: 'Select column resize',
        description: 'Hint for selecting a column resize a shortcut'
    },
    increaseSize: {
        id: 'fabric.editor.increaseSize',
        defaultMessage: 'Increase table or media size',
        description: 'The text is shown as an shortcut description in help dialog modal, when the user uses the described shortcut, he is able to increase the width of the selected element. Optimal characters less than 21.'
    },
    decreaseSize: {
        id: 'fabric.editor.decreaseSize',
        defaultMessage: 'Decrease table or media size',
        description: 'The text is shown as an shortcut description in help dialog modal, when the user uses the described shortcut, he is able to decrease the width of the selected element. Optimal characters less than 21.'
    },
    openCellOptions: {
        id: 'fabric.editor.openCellOptions',
        defaultMessage: 'Open cell options',
        description: 'Keyboard shortcut to open cell options.'
    },
    focusTableResizeHandle: {
        id: 'fabric.editor.focusTableResizeHandle',
        defaultMessage: 'Focus table resize handle',
        description: 'Focus table resize handle'
    },
    closeHelpDialog: {
        id: 'fabric.editor.closeHelpDialog',
        defaultMessage: 'Close help dialog',
        description: ''
    },
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Move it inside quick insert plugin
    quickInsert: {
        id: 'fabric.editor.quickInsert',
        defaultMessage: 'Quick insert',
        description: 'Name of a feature, which let you insert items quickly.'
    },
    highlightColor: {
        id: 'fabric.editor.highlightColor',
        defaultMessage: 'Toggle highlight color palette',
        description: 'Keyboard shortcut to toggle highlight color palette.'
    }
});

});

parcelRegister("3AEXe", function(module, exports) {

$parcel$export(module.exports, "mediaInsertMessages", () => $a755ba82139b4a7d$export$7eb9dc59242bbc45);

var $7VHMR = parcelRequire("7VHMR");
const $a755ba82139b4a7d$export$7eb9dc59242bbc45 = (0, $7VHMR.defineMessages)({
    loadPreview: {
        id: 'fabric.editor.media.insert.loadPreview',
        defaultMessage: 'Load preview',
        description: 'Text on a button that loads a preview of a media file that has been linked to from a URL'
    },
    insert: {
        id: 'fabric.editor.media.insert.insert',
        defaultMessage: 'Insert',
        description: 'Text on the modal action button that inserts the linked media file into the editor document'
    },
    pasteLinkToUpload: {
        id: 'fabric.editor.media.insert.pasteLinkToUpload',
        defaultMessage: 'Paste link to upload',
        description: 'Placeholder text for the input field where a user can paste (as in copy-paste) a URL to upload a media file'
    },
    cancel: {
        id: 'fabric.editor.media.insert.cancel',
        defaultMessage: 'Cancel',
        description: 'Text on the modal action button that cancels the media file insertion and closes the modal'
    },
    fromUrlErrorMessage: {
        id: 'fabric.editor.media.insert.fromUrlErrorMessage',
        defaultMessage: "Unfortunately, we can\u2019t add this image link. Download the image, then drag and drop onto the page.",
        description: 'Error message displayed when a user tries to insert an image from a URL that cannot be loaded. This may be because the URL is invalid, there is a network error or any other reason the preview upload does not succeed. When this occurs the suggestion is to attempt downloading the linked file manually and using a local upload instead.'
    },
    fromUrlWarning: {
        id: 'fabric.editor.media.insert.fromUrlWarning',
        defaultMessage: 'This image might not be visible to others due to source restrictions. Consider uploading the file instead.',
        description: 'Warning message displayed when a user tries to insert an image from a URL that may not be visible to others due to source restrictions such as not having permissions/authentication to load the image. The suggestion is to upload the file instead.'
    },
    localFileNetworkErrorMessage: {
        id: 'fabric.editor.media.insert.localFileNetworkErrorMessage',
        defaultMessage: 'File upload error. Check file path or network.',
        description: 'Error message displayed when a network error occurs during file upload'
    },
    localFileErrorMessage: {
        id: 'fabric.editor.media.insert.localFileErrorMessage',
        defaultMessage: "This file couldn\u2019t be uploaded.",
        description: 'Generic catch-all error message displayed when file upload fails'
    },
    mediaAlt: {
        id: 'fabric.editor.media.insert.mediaAlt',
        defaultMessage: 'Preview for uploaded image or video file',
        description: 'Alt text describing a preview of an image uploaded.'
    },
    upload: {
        id: 'fabric.editor.media.insert.upload',
        defaultMessage: 'Upload',
        description: 'Text on a button that opens a file picker dialog to upload a media file'
    },
    linkTabTitle: {
        id: 'fabric.editor.media.insert.linkTabTitle',
        defaultMessage: 'Link',
        description: 'Title of the navigation tab that allows users to insert media from a URL or link'
    },
    fileTabTitle: {
        id: 'fabric.editor.media.insert.fileTabTitle',
        defaultMessage: 'File',
        description: 'Title of the navigation tab that allows users to upload local media files'
    },
    mediaPickerPopupAriaLabel: {
        id: 'fabric.editor.media.insert.mediaPickerPopupAriaLabel',
        defaultMessage: 'Media picker',
        description: 'Accessibility label for the media picker popup'
    },
    invalidUrlErrorMessage: {
        id: 'fabric.editor.media.insert.invalidUrlErrorMessage',
        defaultMessage: 'Invalid link',
        description: 'Error message displayed when a user tries to insert media from an invalid URL'
    }
});

});

parcelRegister("2y1kv", function(module, exports) {

$parcel$export(module.exports, "selectionToolbarMessages", () => $14d5a3715e7fc293$export$b0226831bf5c0d3e);

var $7VHMR = parcelRequire("7VHMR");
const $14d5a3715e7fc293$export$b0226831bf5c0d3e = (0, $7VHMR.defineMessages)({
    toolbarAppears: {
        id: 'fabric.editor.toolbarAppears',
        defaultMessage: 'Toolbar appears',
        description: 'Label for toolbar position options'
    },
    toolbarPositionInline: {
        id: 'fabric.editor.toolbarPositionInline',
        defaultMessage: 'In-line with text',
        description: 'Label for in-line toolbar position option'
    },
    toolbarPositionFixedAtTop: {
        id: 'fabric.editor.toolbarPositionFixedAtTop',
        defaultMessage: 'Fixed at top',
        description: 'Label for fixed at top toolbar position option'
    },
    toolbarPositionUnpined: {
        id: 'fabric.editor.toolbarPositionUnpined',
        defaultMessage: 'Pin the toolbar at the top',
        description: 'Label for in-line toolbar position option'
    },
    toolbarPositionPinedAtTop: {
        id: 'fabric.editor.toolbarPositionPinedAtTop',
        defaultMessage: 'Unpin the toolbar',
        description: 'Label for fixed at top toolbar position option'
    }
});

});


parcelRegister("eQcNy", function(module, exports) {

$parcel$export(module.exports, "walkUpTreeUntil", () => $ab609be3c0cbf6e9$export$df14aaf7a527ab0c);
$parcel$export(module.exports, "unwrap", () => $ab609be3c0cbf6e9$export$debb760848ca95a);
$parcel$export(module.exports, "removeNestedEmptyEls", () => $ab609be3c0cbf6e9$export$5b66dc78851adb5e);
$parcel$export(module.exports, "containsClassName", () => $ab609be3c0cbf6e9$export$c8913a477cc44663);
$parcel$export(module.exports, "closest", () => $ab609be3c0cbf6e9$export$ff7f7c97cdce86e);
$parcel$export(module.exports, "closestElement", () => $ab609be3c0cbf6e9$export$d508bcfb7f019487);
$parcel$export(module.exports, "parsePx", () => $ab609be3c0cbf6e9$export$b0eef8cd00b29d5c);
$parcel$export(module.exports, "maphElem", () => $ab609be3c0cbf6e9$export$5b6ab01a6efa50e2);
/**
 * Walks a DOM tree up to the provided `stopElement`, or if falsy before.
 * @param element
 * @param stopElement
 */ function $ab609be3c0cbf6e9$export$df14aaf7a527ab0c(element, shouldStop) {
    let rootElement = element;
    while(rootElement && rootElement.parentElement && !shouldStop(rootElement))rootElement = rootElement.parentElement;
    return rootElement;
}
function $ab609be3c0cbf6e9$export$debb760848ca95a(parent, wrapped) {
    const docsFragment = document.createDocumentFragment();
    Array.from(wrapped.children).forEach((child)=>{
        docsFragment.appendChild(child);
    });
    parent.replaceChild(docsFragment, wrapped);
}
function $ab609be3c0cbf6e9$export$5b66dc78851adb5e(el) {
    while(el.parentElement && el.childElementCount === 0 && el.textContent === ''){
        const parentEl = el.parentElement;
        parentEl.removeChild(el);
        el = parentEl;
    }
}
const $ab609be3c0cbf6e9$export$c8913a477cc44663 = (node, className)=>{
    if (!node) return false;
    if (node.classList && node.classList.contains) return node.classList.contains(className);
    if (!node.className) return false;
    const classNames = typeof node.className.baseVal === 'string' ? node.className.baseVal : node.className;
    return classNames.split(' ').indexOf(className) !== -1;
};
function $ab609be3c0cbf6e9$export$ff7f7c97cdce86e(node, s) {
    if (!node) return null;
    let el = node;
    if (!document.documentElement || !document.documentElement.contains(el)) return null;
    if (el.closest) return el.closest(s);
    do {
        const matchfn = el.matches ? el.matches : el.msMatchesSelector;
        if (matchfn && matchfn.call(el, s)) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        return el;
        el = el.parentElement || el.parentNode;
    }while (el !== null && el.nodeType === 1);
    return null;
}
function $ab609be3c0cbf6e9$export$d508bcfb7f019487(node, s) {
    return $ab609be3c0cbf6e9$export$ff7f7c97cdce86e(node, s);
}
function $ab609be3c0cbf6e9$export$b0eef8cd00b29d5c(pxStr) {
    if (!pxStr.endsWith('px')) return undefined;
    const maybeNumber = parseInt(pxStr, 10);
    return !Number.isNaN(maybeNumber) ? maybeNumber : undefined;
}
function $ab609be3c0cbf6e9$export$b2d5d4f1aeebddf1(elem, callback) {
    const array = [];
    for(let i = 0; i < elem.childElementCount; i++)array.push(callback(elem.children[i], i, elem));
    return array;
}
function $ab609be3c0cbf6e9$export$5b6ab01a6efa50e2(elem, callback) {
    return $ab609be3c0cbf6e9$export$b2d5d4f1aeebddf1(elem, callback);
}

});


parcelRegister("l8Gxi", function(module, exports) {

$parcel$export(module.exports, "RendererCssClassName", () => $ca55565f908e8e5d$export$91f3bbbf974496e2);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
const $ca55565f908e8e5d$var$clPrefix = 'ak-renderer-';
const $ca55565f908e8e5d$export$91f3bbbf974496e2 = {
    DOCUMENT: `${$ca55565f908e8e5d$var$clPrefix}document`,
    EXTENSION: `${$ca55565f908e8e5d$var$clPrefix}extension`,
    EXTENSION_CENTER_ALIGN: `${$ca55565f908e8e5d$var$clPrefix}extension-center-align`,
    EXTENSION_OVERFLOW_CONTAINER: `${$ca55565f908e8e5d$var$clPrefix}extension-overflow-container`,
    NUMBER_COLUMN: `${$ca55565f908e8e5d$var$clPrefix}table-number-column`,
    SORTABLE_COLUMN_WRAPPER: `${$ca55565f908e8e5d$var$clPrefix}tableHeader-sortable-column__wrapper`,
    SORTABLE_COLUMN: `${$ca55565f908e8e5d$var$clPrefix}tableHeader-sortable-column`,
    SORTABLE_COLUMN_ICON_WRAPPER: `${$ca55565f908e8e5d$var$clPrefix}tableHeader-sorting-icon__wrapper`,
    SORTABLE_COLUMN_NO_ORDER: `${$ca55565f908e8e5d$var$clPrefix}tableHeader-sorting-icon__no-order`
};

});


parcelRegister("8Eu7T", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $19f8e43ef61748ed$export$e926676385687eaf);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gkwXh = parcelRequire("gkwXh");

var $dWAZk = parcelRequire("dWAZk");

var $1KzE6 = parcelRequire("1KzE6");

var $knXBU = parcelRequire("knXBU");

var $7Jxgt = parcelRequire("7Jxgt");
class $19f8e43ef61748ed$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    fireAnalyticsEvent(event) {
        const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
        if (createAnalyticsEvent) {
            const channel = (0, $dWAZk.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }
    hasFallback() {
        return typeof this.props.fallbackComponent !== 'undefined';
    }
    shouldRecover() {
        return this.hasFallback() && this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        const additionalInfo = this.props.additionalInfo ?? '';
        this.fireAnalyticsEvent({
            action: (0, $gkwXh.ACTION).CRASHED,
            actionSubject: this.props.component,
            actionSubjectId: this.props.componentId,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $knXBU.PLATFORM).WEB,
                errorMessage: `${additionalInfo}${error?.message}`,
                componentStack: errorInfo?.componentStack || undefined,
                errorRethrown: Boolean(this.props.rethrowError)
            }
        });
        (0, $1KzE6.logException)(error, {
            location: 'renderer'
        });
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const pattern = /Failed to execute.*on 'Node'.*/;
        const matchesPattern = pattern.test(error.message);
        if (matchesPattern) {
            this.fireAnalyticsEvent({
                action: (0, $gkwXh.ACTION).CAUGHT_DOM_ERROR,
                actionSubject: this.props.component,
                actionSubjectId: this.props.componentId,
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    platform: (0, $knXBU.PLATFORM).WEB,
                    errorMessage: `${additionalInfo}${error?.message}`
                }
            });
            this.setState(()=>({
                    domError: true
                }));
        }
        if (this.hasFallback()) this.setState({
            errorCaptured: true
        }, ()=>{
            if (this.props.rethrowError) throw error;
        });
    }
    render() {
        if (this.state.domError) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
            children: this.props.children
        }, (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))());
        if (this.shouldRecover()) return this.props.fallbackComponent;
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            errorCaptured: false,
            domError: false
        };
    }
}

});
parcelRegister("1KzE6", function(module, exports) {

$parcel$export(module.exports, "logException", () => $8cb678cf4830ec10$export$f86b2a1a2ce291b3);

var $8eFcy = parcelRequire("8eFcy");
const $8cb678cf4830ec10$var$SENTRY_DSN = 'https://0b10c8e02fb44d8796c047b102c9bee8@o55978.ingest.sentry.io/4505129224110080';
const $8cb678cf4830ec10$var$packageName = 'editor-common'; // Sentry doesn't accept '/' in its releases https://docs.sentry.io/platforms/javascript/configuration/releases/
const $8cb678cf4830ec10$var$packageVersion = "0.0.0-use.local";
const $8cb678cf4830ec10$var$sanitiseSentryEvents = (data, _hint)=>{
    // Remove URL as it has UGC
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Sanitise the URL instead of just removing it
    if (data.request) delete data.request.url;
    return data;
};


const $8cb678cf4830ec10$export$f86b2a1a2ce291b3 = async (error, tags)=>{
    try {
        const { BrowserClient: BrowserClient, defaultIntegrations: defaultIntegrations, getCurrentHub: getCurrentHub } = await (parcelRequire("4IfOW"));
        const { ExtraErrorData: ExtraErrorData } = await (parcelRequire("5bwDx"));
        const sentryOptions = {
            dsn: (0, $8eFcy.isFedRamp)() ? undefined : $8cb678cf4830ec10$var$SENTRY_DSN,
            release: `${$8cb678cf4830ec10$var$packageName}@${$8cb678cf4830ec10$var$packageVersion}`,
            environment: undefined ?? 'unknown',
            ignoreErrors: [
                // Network issues
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                /^network error/i,
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                /^network failure/i,
                'TypeError: Failed to fetch',
                // A benign error, see https://stackoverflow.com/a/50387233/2645305
                'ResizeObserver loop limit exceeded',
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                /ResizeObserver loop completed with undelivered notifications/
            ],
            autoSessionTracking: false,
            integrations: (_integrations)=>[
                    // Remove the Breadcrumbs integration from the default as it's too likely to log UGC/PII
                    // https://docs.sentry.io/platforms/javascript/configuration/integrations/default/
                    ...defaultIntegrations.filter(({ name: name })=>name !== 'Breadcrumbs'),
                    // Extracts all non-native attributes from the error object and attaches them to the event as the extra data
                    // https://docs.sentry.io/platforms/javascript/configuration/integrations/plugin/?original_referrer=https%3A%2F%2Fduckduckgo.com%2F#extraerrordata
                    new ExtraErrorData()
                ],
            beforeSend: $8cb678cf4830ec10$var$sanitiseSentryEvents
        };
        // Use a client to avoid picking up the errors from parent applications
        const client = new BrowserClient(sentryOptions);
        const hub = getCurrentHub();
        hub.bindClient(client);
        hub.withScope((scope)=>{
            scope.setTags({
                // Jira environment variables
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-bundler': window.BUNDLER_VERSION,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-variant': window.BUILD_VARIANT,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-release': window.BUILD_KEY,
                // Confluence environment variables
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'confluence-frontend-version': window.__buildInfo?.FRONTEND_VERSION,
                ...tags
            });
            // Explicitly remove the breadcrumbs as it's too likely to log UGC/PII to side-step the hub integrations not being respected
            scope.clearBreadcrumbs();
            hub.captureException(error);
        });
        return client.close();
    } catch (_error) {
    // Error reporting failed, we don't want this to generate more errors
    }
};

});
parcelRegister("8eFcy", function(module, exports) {

$parcel$export(module.exports, "isFedRamp", () => $1a8a754a294d51a4$export$64d6499adf9b2e51);
const $1a8a754a294d51a4$var$FEDRAMP_MODERATE = 'fedramp-moderate';
function $1a8a754a294d51a4$export$64d6499adf9b2e51() {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === $1a8a754a294d51a4$var$FEDRAMP_MODERATE;
    const matches = global.location?.hostname?.match(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});

parcelRegister("4IfOW", function(module, exports) {

let $36e78b2683548d65$var$load = (parcelRequire("28QjX"))(4);
module.exports = $36e78b2683548d65$var$load("5j2yR").then(()=>parcelRequire('hFoxV'));

});

parcelRegister("5bwDx", function(module, exports) {

let $3c674bc9dbc46d1b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3c674bc9dbc46d1b$var$load("5ywns").then(()=>parcelRequire('1dEW4'));

});


parcelRegister("knXBU", function(module, exports) {

$parcel$export(module.exports, "PLATFORM", () => $11894d4d5d86b4b1$export$88c4881e092abcaf);
$parcel$export(module.exports, "MODE", () => $11894d4d5d86b4b1$export$e48589d9e4824227);
var $11894d4d5d86b4b1$export$88c4881e092abcaf = /*#__PURE__*/ function(PLATFORM) {
    PLATFORM["NATIVE"] = "mobileNative";
    PLATFORM["HYBRID"] = "mobileHybrid";
    PLATFORM["WEB"] = "web";
    return PLATFORM;
}({});
var $11894d4d5d86b4b1$export$e48589d9e4824227 = /*#__PURE__*/ function(MODE) {
    MODE["RENDERER"] = "renderer";
    MODE["EDITOR"] = "editor";
    return MODE;
}({});
var $11894d4d5d86b4b1$var$RESOLVE_METHOD = /*#__PURE__*/ function(RESOLVE_METHOD) {
    RESOLVE_METHOD["COMPONENT"] = "component";
    RESOLVE_METHOD["CONSUMER"] = "consumer";
    RESOLVE_METHOD["ORPHANED"] = "orphaned";
    return RESOLVE_METHOD;
}($11894d4d5d86b4b1$var$RESOLVE_METHOD || {});

});


parcelRegister("cWCI0", function(module, exports) {

$parcel$export(module.exports, "EVENT_TYPE", () => $78ed418dcea0e38c$export$76a2e4c433c23bb9);
$parcel$export(module.exports, "ACTION", () => $78ed418dcea0e38c$export$9523889e0a5da4ba);
$parcel$export(module.exports, "ACTION_SUBJECT", () => $78ed418dcea0e38c$export$7525482b5931e326);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $78ed418dcea0e38c$export$9957974f8b4d8f74);
var $78ed418dcea0e38c$export$76a2e4c433c23bb9 = /*#__PURE__*/ function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
    return EVENT_TYPE;
}({});
var $78ed418dcea0e38c$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["STARTED"] = "started";
    ACTION["RENDERED"] = "rendered";
    ACTION["CRASHED"] = "unhandledErrorCaught";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["CLICKED"] = "clicked";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["INSERTED"] = "inserted";
    ACTION["OPENED"] = "opened";
    ACTION["CLOSED"] = "closed";
    ACTION["DELETED"] = "deleted";
    ACTION["EDITED"] = "edited";
    ACTION["RESOLVED"] = "resolved";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    return ACTION;
}({});
var $78ed418dcea0e38c$export$7525482b5931e326 = /*#__PURE__*/ function(ACTION_SUBJECT) {
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["MEDIA"] = "media";
    return ACTION_SUBJECT;
}({});
var $78ed418dcea0e38c$export$9957974f8b4d8f74 = /*#__PURE__*/ function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    return ACTION_SUBJECT_ID;
}({});

});

parcelRegister("4YrGg", function(module, exports) {

$parcel$export(module.exports, "AnnotationsPositionContext", () => $5dd0541565473935$export$8c8c3e12db6c0591);
$parcel$export(module.exports, "AnnotationsWrapper", () => $5dd0541565473935$export$cef0157dd42cbb3f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $88i6h = parcelRequire("88i6h");

var $VSDnB = parcelRequire("VSDnB");

var $eka68 = parcelRequire("eka68");

var $8Mz83 = parcelRequire("8Mz83");

var $iYAgE = parcelRequire("iYAgE");

var $joddd = parcelRequire("joddd");

var $1oOiu = parcelRequire("1oOiu");

var $2NMNM = parcelRequire("2NMNM");

var $2EsbE = parcelRequire("2EsbE");

var $kuusl = parcelRequire("kuusl");

var $jw62c = parcelRequire("jw62c");
const $5dd0541565473935$var$LoadAnnotations = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete })=>{
    (0, $joddd.useLoadAnnotations)({
        adfDocument: adfDocument,
        isNestedRender: isNestedRender,
        onLoadComplete: onLoadComplete
    });
    return null;
});
const $5dd0541565473935$export$8c8c3e12db6c0591 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    startPos: 1
});
const $5dd0541565473935$export$7121915072388536 = (props)=>{
    const { children: children, rendererRef: rendererRef, adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete } = props;
    const providers = (0, $5uXOq.useContext)((0, $iYAgE.ProvidersContext));
    const updateSubscriber = providers && providers.inlineComment && providers.inlineComment.updateSubscriber;
    const inlineCommentAnnotationsState = (0, $1oOiu.useAnnotationStateByTypeEvent)({
        type: (0, $88i6h.AnnotationTypes).INLINE_COMMENT,
        updateSubscriber: updateSubscriber || null
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iYAgE.InlineCommentsStateContext).Provider, {
        value: inlineCommentAnnotationsState,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2EsbE.AnnotationRangeProvider), {
            allowCommentsOnMedia: providers?.inlineComment?.allowCommentsOnMedia ?? false,
            isNestedRender: isNestedRender,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kuusl.AnnotationHoverContext), {
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $8Mz83.AnnotationsContextWrapper), {
                    createAnalyticsEvent: createAnalyticsEvent,
                    rendererRef: rendererRef,
                    isNestedRender: isNestedRender,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)($5dd0541565473935$var$LoadAnnotations, {
                            adfDocument: adfDocument,
                            isNestedRender: isNestedRender,
                            onLoadComplete: onLoadComplete
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eka68.AnnotationView), {
                            isNestedRender: isNestedRender,
                            createAnalyticsEvent: createAnalyticsEvent
                        }),
                        children
                    ]
                })
            })
        })
    });
};
const $5dd0541565473935$export$cef0157dd42cbb3f = (props)=>{
    const { children: children, annotationProvider: annotationProvider, rendererRef: rendererRef, adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete } = props;
    if (!isNestedRender && (0, $VSDnB.fg)('platform_editor_comments_api_manager')) // We need to ensure there is a single instance of the annotation manager for the whole document
    // and that it is the same instance for all annotations.
    // This is because the annotation manager is responsible for managing the state of ALL annotations.
    // This includes annotations inside extensions.
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iYAgE.ProvidersContext).Provider, {
        value: annotationProvider,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jw62c.AnnotationManagerProvider), {
            annotationManager: annotationProvider?.annotationManager,
            updateSubscriber: annotationProvider?.inlineComment?.updateSubscriber ?? undefined,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($5dd0541565473935$export$7121915072388536, {
                rendererRef: rendererRef,
                adfDocument: adfDocument,
                isNestedRender: isNestedRender,
                onLoadComplete: onLoadComplete,
                children: children
            })
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iYAgE.ProvidersContext).Provider, {
        value: annotationProvider,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($5dd0541565473935$export$7121915072388536, {
            rendererRef: rendererRef,
            adfDocument: adfDocument,
            isNestedRender: isNestedRender,
            onLoadComplete: onLoadComplete,
            children: children
        })
    });
};

});
parcelRegister("eka68", function(module, exports) {

$parcel$export(module.exports, "AnnotationView", () => $38b360e678e45e5a$export$41cd4a02859c2806);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $iYAgE = parcelRequire("iYAgE");

var $1oOiu = parcelRequire("1oOiu");

var $fCNtA = parcelRequire("fCNtA");
const $38b360e678e45e5a$export$41cd4a02859c2806 = (props)=>{
    const providers = (0, $5uXOq.useContext)((0, $iYAgE.ProvidersContext));
    const actionContext = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    const inlineCommentProvider = providers && providers.inlineComment;
    const updateSubscriber = inlineCommentProvider && inlineCommentProvider.updateSubscriber || null;
    const viewComponentProps = (0, $1oOiu.useAnnotationClickEvent)({
        updateSubscriber: updateSubscriber,
        createAnalyticsEvent: props.createAnalyticsEvent,
        isNestedRender: props.isNestedRender
    });
    const ViewComponent = inlineCommentProvider && inlineCommentProvider.viewComponent;
    const deleteAnnotation = (0, $5uXOq.useMemo)(()=>(annotationInfo)=>actionContext.deleteAnnotation(annotationInfo.id, annotationInfo.type), [
        actionContext
    ]);
    // For view mode, the finding of inline node types is a bit more complex,
    // that's why we will not provide it as a `inlineNodeTypes` props to the view component,
    // to speed up the rendering process.
    const getInlineNodeTypes = (0, $5uXOq.useCallback)((annotationId)=>actionContext.getInlineNodeTypes(annotationId), [
        actionContext
    ]);
    if (ViewComponent && viewComponentProps) {
        const { annotations: annotations, clickElementTarget: clickElementTarget } = viewComponentProps;
        return /*#__PURE__*/ (0, $2OMIu.jsx)(ViewComponent, {
            annotations: annotations,
            clickElementTarget: clickElementTarget,
            deleteAnnotation: deleteAnnotation,
            getInlineNodeTypes: getInlineNodeTypes
        });
    }
    return null;
};

});
parcelRegister("iYAgE", function(module, exports) {

$parcel$export(module.exports, "ProvidersContext", () => $1cf3b601714e6f28$export$6a26b015ac619737);
$parcel$export(module.exports, "InlineCommentsStateContext", () => $1cf3b601714e6f28$export$aafe46a36ef535ba);

var $5uXOq = parcelRequire("5uXOq");
const $1cf3b601714e6f28$export$6a26b015ac619737 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $1cf3b601714e6f28$export$aafe46a36ef535ba = /*#__PURE__*/ (0, $5uXOq.createContext)({});

});

parcelRegister("1oOiu", function(module, exports) {

$parcel$export(module.exports, "useAnnotationStateByTypeEvent", () => $477334c02b9da473$export$95f9f9045e92d283);
$parcel$export(module.exports, "useHasFocusEvent", () => $477334c02b9da473$export$48f5d7f6702be07c);
$parcel$export(module.exports, "useAnnotationClickEvent", () => $477334c02b9da473$export$26cf539704e444c1);

var $5uXOq = parcelRequire("5uXOq");

var $dEtqo = parcelRequire("dEtqo");

var $88i6h = parcelRequire("88i6h");

var $gkwXh = parcelRequire("gkwXh");

var $dWAZk = parcelRequire("dWAZk");

var $VSDnB = parcelRequire("VSDnB");

var $jw62c = parcelRequire("jw62c");
const $477334c02b9da473$export$95f9f9045e92d283 = ({ type: type, updateSubscriber: updateSubscriber })=>{
    const [states, setStates] = (0, $5uXOq.useState)({});
    const { dispatch: dispatch } = (0, $jw62c.useAnnotationManagerDispatch)();
    const { annotations: annotations } = (0, $jw62c.useAnnotationManagerState)();
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!updateSubscriber) return;
        const cb = (payload)=>{
            if (!payload) return;
            const nextStates = Object.values(payload).reduce((acc, curr)=>{
                if (curr.id && curr.annotationType === type) {
                    // Check for empty state to prevent additional renders
                    const isEmpty = curr.state === null || curr.state === undefined;
                    return {
                        ...acc,
                        [curr.id]: !isEmpty ? curr.state : states[curr.id]
                    };
                }
                return acc;
            }, {});
            setStates({
                ...states,
                ...nextStates
            });
        };
        if (!(0, $VSDnB.fg)('platform_editor_comments_api_manager')) {
            updateSubscriber.on((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
            return ()=>{
                updateSubscriber.off((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
            };
        }
    }, [
        states,
        type,
        updateSubscriber,
        dispatch
    ]);
    const annotationMarkStates = (0, $5uXOq.useMemo)(()=>{
        return Object.values(annotations).reduce((acc, curr)=>{
            return {
                ...acc,
                [curr.id]: curr.markState
            };
        }, {});
    }, [
        annotations
    ]);
    if ((0, $VSDnB.fg)('platform_editor_comments_api_manager')) return annotationMarkStates;
    else return states;
};
const $477334c02b9da473$export$48f5d7f6702be07c = ({ id: id, updateSubscriber: updateSubscriber })=>{
    const [hasFocus, setHasFocus] = (0, $5uXOq.useState)(false);
    const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
    const { currentSelectedAnnotationId: currentSelectedAnnotationId, currentHoveredAnnotationId: currentHoveredAnnotationId } = (0, $jw62c.useAnnotationManagerState)();
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!updateSubscriber) return;
        const cb = (payload)=>{
            setHasFocus(payload && payload.annotationId === id);
        };
        const callbackForHoveredAnnotation = (payload)=>{
            setIsHovered(payload && payload.annotationId === id);
        };
        const removeFocus = ()=>{
            setHasFocus(false);
            if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
        };
        const removeHoverEffect = ()=>{
            setIsHovered(false);
            if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
        };
        if (!(0, $VSDnB.fg)('platform_editor_comments_api_manager')) {
            updateSubscriber.on((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
            updateSubscriber.on((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, callbackForHoveredAnnotation);
            updateSubscriber.on((0, $dEtqo.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
            updateSubscriber.on((0, $dEtqo.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, removeHoverEffect);
            return ()=>{
                updateSubscriber.off((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
                updateSubscriber.off((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, callbackForHoveredAnnotation);
                updateSubscriber.off((0, $dEtqo.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
                updateSubscriber.off((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, removeHoverEffect);
            };
        }
    }, [
        id,
        updateSubscriber
    ]);
    if ((0, $VSDnB.fg)('platform_editor_comments_api_manager')) return {
        hasFocus: currentSelectedAnnotationId === id,
        isHovered: currentHoveredAnnotationId === id
    };
    else return {
        hasFocus: hasFocus,
        isHovered: isHovered
    };
};
const $477334c02b9da473$var$NO_ANNOTATION_SELECTED = {
    annotations: [],
    clickElementTarget: undefined
};
const $477334c02b9da473$export$26cf539704e444c1 = (props)=>{
    const [annotationClickEvent, setAnnotationClickEvent] = (0, $5uXOq.useState)(null);
    const { updateSubscriber: updateSubscriber, createAnalyticsEvent: createAnalyticsEvent, isNestedRender: isNestedRender } = props;
    const { currentSelectedAnnotationId: currentSelectedAnnotationId, currentSelectedMarkRef: currentSelectedMarkRef } = (0, $jw62c.useAnnotationManagerState)();
    const selectedAnnotation = (0, $5uXOq.useMemo)(()=>{
        return currentSelectedAnnotationId && currentSelectedMarkRef && currentSelectedMarkRef.id === currentSelectedAnnotationId ? {
            annotations: [
                {
                    id: currentSelectedAnnotationId,
                    type: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
                }
            ],
            clickElementTarget: currentSelectedMarkRef
        } : // When creating a new annotation, currentSelectedAnnotationId and currentSelectedMarkRef will be set one after another,
        // if this isn't a const, it will cause useMemo to return two different "empty" objects and causes infinite re-renders.
        $477334c02b9da473$var$NO_ANNOTATION_SELECTED;
    }, [
        currentSelectedAnnotationId,
        currentSelectedMarkRef
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!updateSubscriber || isNestedRender) return;
        const clickCb = ({ annotationIds: annotationIds, eventTarget: eventTarget, eventTargetType: eventTargetType, viewMethod: viewMethod })=>{
            const annotationsByType = annotationIds.filter((id)=>!!id).map((id)=>({
                    id: id,
                    type: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
                }));
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $gkwXh.ACTION).VIEWED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: annotationsByType.length || 0,
                    targetNodeType: eventTargetType,
                    method: viewMethod
                }
            }).fire((0, $dWAZk.FabricChannel).editor);
            setAnnotationClickEvent({
                annotations: annotationsByType,
                clickElementTarget: eventTarget
            });
        };
        const deselectCb = ()=>{
            setAnnotationClickEvent({
                annotations: [],
                clickElementTarget: undefined
            });
            if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
        };
        if (!(0, $VSDnB.fg)('platform_editor_comments_api_manager')) {
            updateSubscriber.on((0, $dEtqo.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
            updateSubscriber.on((0, $dEtqo.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
            return ()=>{
                updateSubscriber.off((0, $dEtqo.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
                updateSubscriber.off((0, $dEtqo.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
            };
        }
    }, [
        updateSubscriber,
        createAnalyticsEvent,
        isNestedRender
    ]);
    if ((0, $VSDnB.fg)('platform_editor_comments_api_manager')) return isNestedRender ? null : selectedAnnotation;
    else return annotationClickEvent;
};

});
parcelRegister("dEtqo", function(module, exports) {

$parcel$export(module.exports, "AnnotationUpdateEvent", () => $916fd31c0363f129$export$c1c4b33b4e7b1c70);

var $6Oghe = parcelRequire("6Oghe");
var $916fd31c0363f129$export$c1c4b33b4e7b1c70 = /*#__PURE__*/ function(AnnotationUpdateEvent) {
    AnnotationUpdateEvent["SET_ANNOTATION_FOCUS"] = "SET_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["SET_ANNOTATION_HOVERED"] = "SET_ANNOTATION_HOVERED";
    AnnotationUpdateEvent["SET_ANNOTATION_STATE"] = "SET_ANNOTATION_STATE";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_FOCUS"] = "REMOVE_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_HOVERED"] = "REMOVE_ANNOTATION_HOVERED";
    AnnotationUpdateEvent["ON_ANNOTATION_CLICK"] = "ON_ANNOTATION_CLICK";
    AnnotationUpdateEvent["DESELECT_ANNOTATIONS"] = "DESELECT_ANNOTATIONS";
    return AnnotationUpdateEvent;
}({});
class $916fd31c0363f129$export$7cc60aa9ef845515 {
    emit(event, params) {
        if (typeof params === 'undefined') return this.emitter.emit(event);
        return this.emitter.emit(event, params);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    on(event, listener) {
        return this.emitter.on(event, listener);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    off(event, listener) {
        return this.emitter.removeListener(event, listener);
    }
    listeners(event) {
        return this.emitter.listeners(event);
    }
    constructor(){
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($6Oghe)))();
    }
}

});
parcelRegister("6Oghe", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $4f5409da028b4771$var$R = typeof Reflect === 'object' ? Reflect : null;
var $4f5409da028b4771$var$ReflectApply = $4f5409da028b4771$var$R && typeof $4f5409da028b4771$var$R.apply === 'function' ? $4f5409da028b4771$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $4f5409da028b4771$var$ReflectOwnKeys;
if ($4f5409da028b4771$var$R && typeof $4f5409da028b4771$var$R.ownKeys === 'function') $4f5409da028b4771$var$ReflectOwnKeys = $4f5409da028b4771$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $4f5409da028b4771$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $4f5409da028b4771$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $4f5409da028b4771$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $4f5409da028b4771$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $4f5409da028b4771$var$EventEmitter() {
    $4f5409da028b4771$var$EventEmitter.init.call(this);
}
module.exports = $4f5409da028b4771$var$EventEmitter;
module.exports.once = $4f5409da028b4771$var$once;
// Backwards-compat with node 0.10.x
$4f5409da028b4771$var$EventEmitter.EventEmitter = $4f5409da028b4771$var$EventEmitter;
$4f5409da028b4771$var$EventEmitter.prototype._events = undefined;
$4f5409da028b4771$var$EventEmitter.prototype._eventsCount = 0;
$4f5409da028b4771$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $4f5409da028b4771$var$defaultMaxListeners = 10;
function $4f5409da028b4771$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($4f5409da028b4771$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $4f5409da028b4771$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $4f5409da028b4771$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $4f5409da028b4771$var$defaultMaxListeners = arg;
    }
});
$4f5409da028b4771$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$4f5409da028b4771$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $4f5409da028b4771$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $4f5409da028b4771$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $4f5409da028b4771$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$4f5409da028b4771$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $4f5409da028b4771$var$_getMaxListeners(this);
};
$4f5409da028b4771$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $4f5409da028b4771$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $4f5409da028b4771$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$4f5409da028b4771$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $4f5409da028b4771$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $4f5409da028b4771$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $4f5409da028b4771$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $4f5409da028b4771$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$4f5409da028b4771$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $4f5409da028b4771$var$_addListener(this, type, listener, false);
};
$4f5409da028b4771$var$EventEmitter.prototype.on = $4f5409da028b4771$var$EventEmitter.prototype.addListener;
$4f5409da028b4771$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $4f5409da028b4771$var$_addListener(this, type, listener, true);
};
function $4f5409da028b4771$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $4f5409da028b4771$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $4f5409da028b4771$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$4f5409da028b4771$var$EventEmitter.prototype.once = function once(type, listener) {
    $4f5409da028b4771$var$checkListener(listener);
    this.on(type, $4f5409da028b4771$var$_onceWrap(this, type, listener));
    return this;
};
$4f5409da028b4771$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $4f5409da028b4771$var$checkListener(listener);
    this.prependListener(type, $4f5409da028b4771$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$4f5409da028b4771$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $4f5409da028b4771$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $4f5409da028b4771$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$4f5409da028b4771$var$EventEmitter.prototype.off = $4f5409da028b4771$var$EventEmitter.prototype.removeListener;
$4f5409da028b4771$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $4f5409da028b4771$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $4f5409da028b4771$var$unwrapListeners(evlistener) : $4f5409da028b4771$var$arrayClone(evlistener, evlistener.length);
}
$4f5409da028b4771$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $4f5409da028b4771$var$_listeners(this, type, true);
};
$4f5409da028b4771$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $4f5409da028b4771$var$_listeners(this, type, false);
};
$4f5409da028b4771$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $4f5409da028b4771$var$listenerCount.call(emitter, type);
};
$4f5409da028b4771$var$EventEmitter.prototype.listenerCount = $4f5409da028b4771$var$listenerCount;
function $4f5409da028b4771$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$4f5409da028b4771$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $4f5409da028b4771$var$ReflectOwnKeys(this._events) : [];
};
function $4f5409da028b4771$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $4f5409da028b4771$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $4f5409da028b4771$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $4f5409da028b4771$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $4f5409da028b4771$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $4f5409da028b4771$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $4f5409da028b4771$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $4f5409da028b4771$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $4f5409da028b4771$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});


parcelRegister("jw62c", function(module, exports) {

$parcel$export(module.exports, "AnnotationManagerProvider", () => $dbab420736de348f$export$f21fb05766361bb3);
$parcel$export(module.exports, "useAnnotationManagerState", () => $dbab420736de348f$export$654a1fb45487f838);
$parcel$export(module.exports, "useAnnotationManagerDispatch", () => $dbab420736de348f$export$12cbbb89fb7702d0);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $88i6h = parcelRequire("88i6h");

var $dEtqo = parcelRequire("dEtqo");

var $fCNtA = parcelRequire("fCNtA");
const $dbab420736de348f$var$initState = {
    isDrafting: false,
    draftId: undefined,
    draftMarkRef: undefined,
    draftActionResult: undefined,
    annotations: {},
    currentSelectedAnnotationId: undefined,
    currentSelectedMarkRef: undefined,
    currentHoveredAnnotationId: undefined
};
const $dbab420736de348f$var$AnnotationManagerStateContext = /*#__PURE__*/ (0, $5uXOq.createContext)($dbab420736de348f$var$initState);
const $dbab420736de348f$var$AnnotationManagerDispatchContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    annotationManager: undefined,
    dispatch: ()=>{}
});
function $dbab420736de348f$var$reducer(state, action) {
    switch(action.type){
        case 'reset':
            return {
                ...state,
                ...$dbab420736de348f$var$initState
            };
        case 'loadAnnotation':
            {
                const currentIds = Object.keys(state.annotations);
                const uids = Array.from(new Set(currentIds.concat(action.data.map((a)=>a.id))));
                const updates = [];
                for (const id of uids){
                    const loadedAnnotation = action.data.find((a)=>a.id === id);
                    if (!loadedAnnotation && state.annotations[id]?.markState === (0, $88i6h.AnnotationMarkStates).ACTIVE) {
                        // If the annotation is not in the loaded data, we need to remove it from the state. However,
                        // rather then removing it, we will set the mark state to resolved. This is to align it better with
                        // how the editor works.
                        updates.push({
                            id: id,
                            markState: (0, $88i6h.AnnotationMarkStates).RESOLVED
                        });
                        continue;
                    }
                    if (!!loadedAnnotation?.markState && state.annotations[id]?.markState !== loadedAnnotation.markState) {
                        updates.push({
                            id: id,
                            markState: loadedAnnotation.markState
                        });
                        continue;
                    }
                }
                if (updates.length > 0) return {
                    ...state,
                    annotations: updates.reduce((nextAnnotations, update)=>{
                        return {
                            ...nextAnnotations,
                            [update.id]: {
                                ...nextAnnotations[update.id],
                                ...update
                            }
                        };
                    }, state.annotations)
                };
                return state;
            }
        case 'updateAnnotation':
            {
                const current = state.annotations[action.data.id];
                const { id: id, selected: selected, hovered: hovered, markState: markState = current?.markState } = action.data;
                const updates = [];
                // If the annotation is not currently in the state, we need to add it to the state.
                if (!current) updates.push({
                    id: id,
                    markState: markState ?? (0, $88i6h.AnnotationMarkStates).ACTIVE
                });
                // The goal of the following is to enforce a single selection and a single hover state across all annotations.
                let nextSelectedId = state.currentSelectedAnnotationId;
                if (selected && nextSelectedId !== id) nextSelectedId = id;
                // If the annotation is currently selected and it's being unselected, we need to remove it from the
                // current selected annotation id.
                if (selected === false && nextSelectedId === id) nextSelectedId = undefined;
                let nextHoveredId = state.currentHoveredAnnotationId;
                if (hovered && nextHoveredId !== id) nextHoveredId = id;
                // If the annotation is currently hovered and it's being unhovered, we need to remove it from the
                // current hovered annotation id.
                if (hovered === false && nextHoveredId === id) nextHoveredId = undefined;
                // If the annotations mark state is not the same as the current mark state, we need to update it.
                if (current?.markState !== markState) {
                    updates.push({
                        id: id,
                        markState: markState ?? (0, $88i6h.AnnotationMarkStates).ACTIVE
                    });
                    // If the annotation is currently selected and it's being resolved, then we need to remove it from the
                    // current selected annotation id also.
                    if (markState === (0, $88i6h.AnnotationMarkStates).RESOLVED && nextSelectedId === id) nextSelectedId = undefined;
                }
                if (updates.length > 0 || nextSelectedId !== state.currentSelectedAnnotationId || nextHoveredId !== state.currentHoveredAnnotationId) return {
                    ...state,
                    currentSelectedAnnotationId: nextSelectedId,
                    currentHoveredAnnotationId: nextHoveredId,
                    annotations: updates.reduce((nextAnnotations, update)=>{
                        return {
                            ...nextAnnotations,
                            [update.id]: {
                                ...nextAnnotations[update.id],
                                ...update
                            }
                        };
                    }, state.annotations)
                };
                return state;
            }
        case 'resetSelectedAnnotation':
            if (state.currentSelectedAnnotationId !== undefined) return {
                ...state,
                currentSelectedAnnotationId: undefined,
                currentSelectedMarkRef: undefined
            };
            return state;
        case 'resetHoveredAnnotation':
            if (state.currentHoveredAnnotationId !== undefined) return {
                ...state,
                currentHoveredAnnotationId: undefined
            };
            return state;
        case 'setDrafting':
            if (state.isDrafting !== action.data.isDrafting || state.draftId !== action.data.draftId || state.draftActionResult !== action.data.draftActionResult) // XXX: When a draft is open the current selected annotation should no longer be selected. We need
            // to decide what is better UX,
            // 1 - do we want to deselct the selected annotation on draft open, if so then when draft is closed the s
            // selected annotation will not come back
            // 2 - do we want to still allow the selected annotation to be selected when draft is open, however the underlying
            // mark style just shows the annotation as not selected when a draft is active. Then when a draft closes
            // we can reopen the previous selected annotation.
            return {
                ...state,
                isDrafting: action.data.isDrafting,
                draftId: action.data.draftId,
                draftActionResult: action.data.draftActionResult
            };
            return state;
        case 'setDraftMarkRef':
            if (state.draftMarkRef !== action.data.draftMarkRef) return {
                ...state,
                draftMarkRef: action.data.draftMarkRef
            };
            return state;
        case 'setSelectedMarkRef':
            if (state.currentSelectedMarkRef !== action.data.markRef) return {
                ...state,
                currentSelectedMarkRef: action.data.markRef
            };
            return state;
    }
}
const $dbab420736de348f$export$f21fb05766361bb3 = ({ children: children, annotationManager: annotationManager, updateSubscriber: updateSubscriber })=>{
    const [state, dispatch] = (0, $5uXOq.useReducer)($dbab420736de348f$var$reducer, $dbab420736de348f$var$initState);
    const actionContext = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    (0, $5uXOq.useEffect)(()=>{
        const getDraft = ()=>{
            if (!state.isDrafting || !state.draftActionResult || !state.draftMarkRef || !state.draftId) return {
                success: false,
                reason: 'draft-not-started'
            };
            return {
                success: true,
                inlineNodeTypes: state.draftActionResult.inlineNodeTypes ?? [],
                targetElement: state.draftMarkRef,
                actionResult: {
                    step: state.draftActionResult.step,
                    doc: state.draftActionResult.doc,
                    inlineNodeTypes: state.draftActionResult.inlineNodeTypes,
                    targetNodeType: state.draftActionResult.targetNodeType,
                    originalSelection: state.draftActionResult.originalSelection,
                    numMatches: state.draftActionResult.numMatches,
                    matchIndex: state.draftActionResult.matchIndex,
                    pos: state.draftActionResult.pos
                }
            };
        };
        annotationManager?.hook('getDraft', getDraft);
        return ()=>{
            annotationManager?.unhook('getDraft', getDraft);
        };
    }, [
        annotationManager,
        state.draftId,
        state.isDrafting,
        state.draftMarkRef,
        state.draftActionResult
    ]);
    // We need to watch for the draft mark element to exist, so we can inform any listeners that the draft has been started
    // and give them a reference to the element
    (0, $5uXOq.useEffect)(()=>{
        if (state.isDrafting && state.draftId && state.draftMarkRef && state.draftActionResult) annotationManager?.emit({
            name: 'draftAnnotationStarted',
            data: {
                inlineNodeTypes: state.draftActionResult.inlineNodeTypes ?? [],
                targetElement: state.draftMarkRef,
                actionResult: {
                    step: state.draftActionResult.step,
                    doc: state.draftActionResult.doc,
                    inlineNodeTypes: state.draftActionResult.inlineNodeTypes,
                    targetNodeType: state.draftActionResult.targetNodeType,
                    originalSelection: state.draftActionResult.originalSelection,
                    numMatches: state.draftActionResult.numMatches,
                    matchIndex: state.draftActionResult.matchIndex,
                    pos: state.draftActionResult.pos
                }
            }
        });
    }, [
        annotationManager,
        state.draftId,
        state.isDrafting,
        state.draftMarkRef,
        state.draftActionResult
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const setIsAnnotationSelected = (id, isSelected)=>{
            if (state.isDrafting) return {
                success: false,
                reason: 'draft-in-progress'
            };
            if (!state.annotations?.[id]) return {
                success: false,
                reason: 'id-not-valid'
            };
            // the annotation is currently not selected and is being selected
            if (id !== state.currentSelectedAnnotationId && isSelected) {
                dispatch({
                    type: 'updateAnnotation',
                    data: {
                        id: id,
                        selected: true
                    }
                });
                dispatch({
                    type: 'setSelectedMarkRef',
                    data: {
                        markRef: document.getElementById(id) || undefined
                    }
                });
            } else if (id === state.currentSelectedAnnotationId && !isSelected) dispatch({
                type: 'resetSelectedAnnotation'
            });
            return {
                success: true,
                isSelected: isSelected
            };
        };
        annotationManager?.hook('setIsAnnotationSelected', setIsAnnotationSelected);
        return ()=>{
            annotationManager?.unhook('setIsAnnotationSelected', setIsAnnotationSelected);
        };
    }, [
        annotationManager,
        state.isDrafting,
        state.annotations,
        state.currentSelectedAnnotationId,
        state.currentSelectedMarkRef
    ]);
    const prevSelectedAnnotationId = (0, $5uXOq.useRef)(undefined);
    (0, $5uXOq.useEffect)(()=>{
        if (prevSelectedAnnotationId.current) annotationManager?.emit({
            name: 'annotationSelectionChanged',
            data: {
                annotationId: prevSelectedAnnotationId.current,
                isSelected: false,
                inlineNodeTypes: []
            }
        });
        prevSelectedAnnotationId.current = state.currentSelectedAnnotationId;
    }, [
        state.currentSelectedAnnotationId,
        annotationManager
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (state.currentSelectedAnnotationId && state.currentSelectedMarkRef && state.currentSelectedMarkRef.id === state.currentSelectedAnnotationId) annotationManager?.emit({
            name: 'annotationSelectionChanged',
            data: {
                annotationId: state.currentSelectedAnnotationId,
                isSelected: true,
                inlineNodeTypes: []
            }
        });
    }, [
        annotationManager,
        state.currentSelectedAnnotationId,
        state.currentSelectedMarkRef
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const setIsAnnotationHovered = (id, isHovered)=>{
            if (!state.annotations?.[id]) return {
                success: false,
                reason: 'id-not-valid'
            };
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: id,
                    hovered: isHovered
                }
            });
            return {
                success: true,
                isHovered: isHovered
            };
        };
        annotationManager?.hook('setIsAnnotationHovered', setIsAnnotationHovered);
        return ()=>{
            annotationManager?.unhook('setIsAnnotationHovered', setIsAnnotationHovered);
        };
    }, [
        annotationManager,
        state.annotations
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const clearAnnotation = (id)=>{
            if (!state.annotations?.[id]) return {
                success: false,
                reason: 'id-not-valid'
            };
            const result = actionContext.deleteAnnotation(id, (0, $88i6h.AnnotationTypes).INLINE_COMMENT);
            if (!result) return {
                success: false,
                reason: 'clear-failed'
            };
            const { step: step, doc: doc } = result;
            return {
                success: true,
                actionResult: {
                    step: step,
                    doc: doc
                }
            };
        };
        annotationManager?.hook('clearAnnotation', clearAnnotation);
        return ()=>{
            annotationManager?.unhook('clearAnnotation', clearAnnotation);
        };
    }, [
        annotationManager,
        state.annotations,
        actionContext
    ]);
    /**
	 * This is a temporary solution to ensure that the annotation manager state is in sync with the
	 * old updateSubscriber. The updateSubscriber will eventually be deprecated and the state will be managed
	 * by the annotation manager itself.
	 */ (0, $5uXOq.useEffect)(()=>{
        const onSetAnnotationState = (payload)=>{
            if (!payload) return;
            Object.values(payload).forEach((annotation)=>{
                if (annotation.id && annotation.annotationType === (0, $88i6h.AnnotationTypes).INLINE_COMMENT) dispatch({
                    type: 'updateAnnotation',
                    data: {
                        id: annotation.id,
                        markState: annotation.state ?? undefined
                    }
                });
            });
        };
        const onAnnotationSelected = (payload)=>{
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: payload.annotationId,
                    selected: true
                }
            });
        };
        const onAnnotationHovered = (payload)=>{
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: payload.annotationId,
                    hovered: true
                }
            });
        };
        const onAnnotationSelectedRemoved = ()=>{
            dispatch({
                type: 'resetSelectedAnnotation'
            });
        };
        const onAnnotationHoveredRemoved = ()=>{
            dispatch({
                type: 'resetHoveredAnnotation'
            });
        };
        const onAnnotationClick = ({ annotationIds: annotationIds, eventTarget: eventTarget, eventTargetType: eventTargetType, viewMethod: viewMethod })=>{
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: annotationIds[0],
                    selected: true
                }
            });
            dispatch({
                type: 'setSelectedMarkRef',
                data: {
                    markRef: eventTarget
                }
            });
        };
        const onAnnotationDeselect = ()=>{
            dispatch({
                type: 'resetSelectedAnnotation'
            });
        };
        updateSubscriber?.on((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_STATE, onSetAnnotationState);
        updateSubscriber?.on((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, onAnnotationSelected);
        updateSubscriber?.on((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, onAnnotationHovered);
        updateSubscriber?.on((0, $dEtqo.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, onAnnotationSelectedRemoved);
        updateSubscriber?.on((0, $dEtqo.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, onAnnotationHoveredRemoved);
        updateSubscriber?.on((0, $dEtqo.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, onAnnotationClick);
        updateSubscriber?.on((0, $dEtqo.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, onAnnotationDeselect);
        return ()=>{
            updateSubscriber?.off((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_STATE, onSetAnnotationState);
            updateSubscriber?.off((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, onAnnotationSelected);
            updateSubscriber?.off((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, onAnnotationHovered);
            updateSubscriber?.off((0, $dEtqo.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, onAnnotationSelectedRemoved);
            updateSubscriber?.off((0, $dEtqo.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, onAnnotationHoveredRemoved);
            updateSubscriber?.off((0, $dEtqo.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, onAnnotationClick);
            updateSubscriber?.off((0, $dEtqo.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, onAnnotationDeselect);
        };
    }, [
        updateSubscriber
    ]);
    const dispatchData = (0, $5uXOq.useMemo)(()=>({
            annotationManager: annotationManager,
            dispatch: dispatch
        }), [
        annotationManager,
        dispatch
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($dbab420736de348f$var$AnnotationManagerStateContext.Provider, {
        value: state,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($dbab420736de348f$var$AnnotationManagerDispatchContext.Provider, {
            value: dispatchData,
            children: children
        })
    });
};
const $dbab420736de348f$export$654a1fb45487f838 = ()=>{
    return (0, $5uXOq.useContext)($dbab420736de348f$var$AnnotationManagerStateContext);
};
const $dbab420736de348f$export$12cbbb89fb7702d0 = ()=>{
    return (0, $5uXOq.useContext)($dbab420736de348f$var$AnnotationManagerDispatchContext);
};

});
parcelRegister("fCNtA", function(module, exports) {

$parcel$export(module.exports, "RendererContext", () => $7e61ed70df2336e9$export$1e9ea4edb6d1bfe6);
$parcel$export(module.exports, "RendererActionsContext", () => $7e61ed70df2336e9$export$66feffbad722f9d4);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6pY1y = parcelRequire("6pY1y");
const $7e61ed70df2336e9$export$1e9ea4edb6d1bfe6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(new (0, $6pY1y.default)());
function $7e61ed70df2336e9$export$66feffbad722f9d4({ children: children, context: context }) {
    const actions = (0, $5uXOq.useMemo)(()=>new (0, $6pY1y.default)(true), []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($7e61ed70df2336e9$export$1e9ea4edb6d1bfe6.Provider, {
        value: context || actions,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.only(children)
    });
}
const $7e61ed70df2336e9$export$d5fcf151601331bc = $7e61ed70df2336e9$export$1e9ea4edb6d1bfe6.Consumer;

});
parcelRegister("6pY1y", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e7850a7dc1aaf7e$export$2e2bcd8739ae039);

var $88i6h = parcelRequire("88i6h");

var $h03xs = parcelRequire("h03xs");

var $hYNZx = parcelRequire("hYNZx");

var $gZGBX = parcelRequire("gZGBX");

var $gkwXh = parcelRequire("gkwXh");

var $eS2Dn = parcelRequire("eS2Dn");

var $VSDnB = parcelRequire("VSDnB");

var $cMPbW = parcelRequire("cMPbW");

var $4apTl = parcelRequire("4apTl");

var $hAPWV = parcelRequire("hAPWV");
class $5e7850a7dc1aaf7e$export$2e2bcd8739ae039 {
    constructor(initFromContext = false){
        // This is our psuedo feature flag for now
        // This module can only be used when wrapped with
        // the <RendererContext> component for now.
        this.initFromContext = false;
        this.debugAnalyticLoggingEnabled = false;
        // TODO: EDITOR-595 - This method is temporary and should be removed once the following issue
        // has been identified and fixed: https://atlassian.slack.com/archives/C08JK0WSCH5/p1745902609966999
        // This is a copy of the original canApplyAnnotationOnRange. If that returns false this is run to figure out exactly why
        // the annotation cannot be applied to the range.
        this._privateWhyCannotApplyAnnotationOnRange = (pos, doc, schema)=>{
            const { from: from, to: to } = pos;
            if (isNaN(from + to) || to - from <= 0 || to < 0 || from < 0) return 'position invalid';
            const reasons = [];
            doc.nodesBetween(from, to, (node, _pos, parent)=>{
                // Special exception for hardBreak nodes
                if (schema.nodes.hardBreak === node.type) return false;
                // For block elements or text nodes, we want to check
                // if annotations are allowed inside this tree
                // or if we're leaf and not text
                if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) {
                    const isAllowedInlineNode = [
                        'emoji',
                        'status',
                        'date',
                        'mention',
                        'inlineCard'
                    ].includes(node.type.name);
                    if (node.isInline && !node.isText && !isAllowedInlineNode) {
                        reasons.push(`Err 1 - type: ${node.type.name}, isInline: ${node.isInline}, isText: ${node.isText}, isLeaf: ${node.isLeaf}`);
                        return false;
                    } else if (node.isLeaf && !node.isText && !isAllowedInlineNode) {
                        reasons.push(`Err 2 - type: ${node.type.name}, isInline: ${node.isInline}, isText: ${node.isText}, isLeaf: ${node.isLeaf}`);
                        return false;
                    } else if (node.isText && !parent?.type.allowsMarkType(schema.marks.annotation)) {
                        reasons.push(`Err 3 - type: ${node.type.name}, isInline: ${node.isInline}, isText: ${node.isText}, isLeaf: ${node.isLeaf}, parent: ${parent?.type.name}`);
                        return false;
                    }
                } else {
                    if (node.isInline && !node.isText) {
                        reasons.push(`Err 4 - type: ${node.type.name}, isInline: ${node.isInline}, isText: ${node.isText}, isLeaf: ${node.isLeaf}`);
                        return false;
                    } else if (node.isLeaf && !node.isText) {
                        reasons.push(`Err 5 - type: ${node.type.name}, isInline: ${node.isInline}, isText: ${node.isText}, isLeaf: ${node.isLeaf}`);
                        return false;
                    } else if (node.isText && !parent?.type.allowsMarkType(schema.marks.annotation)) {
                        reasons.push(`Err 6 - type: ${node.type.name}, isInline: ${node.isInline}, isText: ${node.isText}, isLeaf: ${node.isLeaf}, parent: ${parent?.type.name}`);
                        return false;
                    }
                }
                return true;
            });
            return reasons.join(', ');
        };
        this.initFromContext = initFromContext;
        this.transformer = new (0, $hYNZx.JSONTransformer)();
    }
    //#region private
    _privateRegisterRenderer(ref, doc, schema, onAnalyticsEvent) {
        if (!this.initFromContext) return;
        else if (!this.ref) this.ref = ref;
        else if (this.ref !== ref) throw new Error("Renderer has already been registered! It's not allowed to re-register with another new Renderer instance.");
        this.doc = doc;
        this.schema = schema;
        this.onAnalyticsEvent = onAnalyticsEvent;
    }
    _privateUnregisterRenderer() {
        this.doc = undefined;
        this.ref = undefined;
        this.schema = undefined;
    }
    /**
	 * Validate whether we can create an annotation between two positions
	 */ _privateValidatePositionsForAnnotation(from, to) {
        if (!this.doc || !this.schema) {
            if (this.debugAnalyticLoggingEnabled && this.onAnalyticsEvent && (0, $VSDnB.fg)('platform_renderer_annotations_create_debug_logging')) this.onAnalyticsEvent({
                // @ts-ignore
                action: 'failed',
                // @ts-ignore
                actionSubject: 'applyAnnotation',
                // @ts-ignore
                actionSubjectId: 'inlineCommentFailureReason',
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    // @ts-ignore
                    reason: `Annotation Position validation failed - Missing doc or schema`,
                    commentsOnInlineNodesAllowed: (0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes'),
                    isDocValid: !!this.doc,
                    isSchemaValid: !!this.schema
                }
            });
            return false;
        }
        const currentSelection = (0, $gZGBX.TextSelection).create(this.doc, from, to);
        if ((0, $h03xs.isEmptyTextSelection)(currentSelection, this.schema)) {
            if (this.debugAnalyticLoggingEnabled && this.onAnalyticsEvent && (0, $VSDnB.fg)('platform_renderer_annotations_create_debug_logging')) this.onAnalyticsEvent({
                // @ts-ignore
                action: 'failed',
                // @ts-ignore
                actionSubject: 'applyAnnotation',
                // @ts-ignore
                actionSubjectId: 'inlineCommentFailureReason',
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    // @ts-ignore
                    reason: `Annotation Position validation - Empty Text Selection`,
                    commentsOnInlineNodesAllowed: (0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes'),
                    from: from,
                    to: to
                }
            });
            return false;
        }
        const result = (0, $h03xs.canApplyAnnotationOnRange)({
            from: from,
            to: to
        }, this.doc, this.schema);
        if (this.debugAnalyticLoggingEnabled && !result && this.onAnalyticsEvent && (0, $VSDnB.fg)('platform_renderer_annotations_create_debug_logging')) this.onAnalyticsEvent({
            // @ts-ignore
            action: 'failed',
            // @ts-ignore
            actionSubject: 'applyAnnotation',
            // @ts-ignore
            actionSubjectId: 'inlineCommentFailureReason',
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
            attributes: {
                // @ts-ignore
                reason: `Annotation canApplyAnnotationOnRange failed`,
                details: this._privateWhyCannotApplyAnnotationOnRange({
                    from: from,
                    to: to
                }, this.doc, this.schema),
                commentsOnInlineNodesAllowed: (0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes'),
                from: from,
                to: to
            }
        });
        return result;
    }
    //#endregion
    deleteAnnotation(annotationId, annotationType) {
        if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
        const mark = this.schema.marks.annotation.create({
            id: annotationId,
            annotationType: annotationType
        });
        let from;
        let to;
        let nodePos;
        let step;
        this.doc.descendants((node, pos)=>{
            const found = mark.isInSet(node.marks);
            if (found && node.type.name === 'media') nodePos = pos;
            if (found && !from) {
                // Set both here incase it only spans one node.
                from = pos;
                to = pos + node.nodeSize;
            } else if (found && from) // If the mark spans multiple nodes,
            // we'll keep setting the end until no longer found.
            to = pos + node.nodeSize;
            return true;
        });
        if (nodePos !== undefined) step = new (0, $eS2Dn.RemoveNodeMarkStep)(nodePos, mark);
        else {
            if (from === undefined || to === undefined) return false;
            step = new (0, $eS2Dn.RemoveMarkStep)(from, to, mark);
        }
        const { doc: doc, failed: failed } = step.apply(this.doc);
        if (this.onAnalyticsEvent) {
            const payload = {
                action: (0, $gkwXh.ACTION).DELETED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                attributes: {
                    inlineNodeNames: step instanceof (0, $eS2Dn.RemoveMarkStep) ? (0, $4apTl.getRendererRangeInlineNodeNames)({
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        pos: {
                            from: from,
                            to: to
                        },
                        actions: this
                    }) : undefined
                }
            };
            this.onAnalyticsEvent(payload);
        }
        if (!failed && doc) return {
            step: step,
            doc: this.transformer.encode(doc)
        };
        return false;
    }
    annotate(range, annotationId, annotationType) {
        if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
        const pos = (0, $cMPbW.getPosFromRange)(range);
        if (!pos) return false;
        const { from: from, to: to } = pos;
        const validPositions = this._privateValidatePositionsForAnnotation(from, to);
        if (!validPositions) return false;
        return this.applyAnnotation(pos, {
            annotationId: annotationId,
            annotationType: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
        });
    }
    isValidAnnotationRange(range) {
        if (!range) return false;
        if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) {
            if (this.isRendererWithinRange(range)) return false;
        }
        const pos = (0, $cMPbW.getPosFromRange)(range);
        if (!pos || !this.doc) return false;
        return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
    }
    isRangeAnnotatable(range) {
        try {
            if (!range) return false;
            const { startContainer: startContainer, endContainer: endContainer } = range;
            if (startContainer.parentElement?.closest('.ak-renderer-extension') || endContainer.parentElement?.closest('.ak-renderer-extension')) return false;
            return this.isValidAnnotationRange(range);
        } catch  {
            // isValidAnnotationRange can fail when called inside nested renderers.
            // while isRendererWithinRange guards against this to some degree -- the classnames
            // are controlled by product -- and we don't have platform guarantees on them.
            //
            // Currently there is a mix of logic across the platform and confluence on determining
            // positions that are annotatable. This is a defensive check to ensure we don't throw an error
            // in cases where the range is not valid.
            return false;
        }
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
	 * This is replaced by `isRangeAnnotatable`.
	 *
	 * @deprecated
	 **/ isRendererWithinRange(range) {
        const { startContainer: startContainer, endContainer: endContainer } = range;
        if (startContainer.parentElement && startContainer.parentElement.closest('.ak-renderer-extension') || endContainer.parentElement && endContainer.parentElement.closest('.ak-renderer-extension')) return true;
        return false;
    }
    isValidAnnotationPosition(pos) {
        if (!pos || !this.doc) {
            if (this.debugAnalyticLoggingEnabled && this.onAnalyticsEvent && (0, $VSDnB.fg)('platform_renderer_annotations_create_debug_logging')) this.onAnalyticsEvent({
                // @ts-ignore
                action: 'failed',
                // @ts-ignore
                actionSubject: 'applyAnnotation',
                // @ts-ignore
                actionSubjectId: 'inlineCommentFailureReason',
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    // @ts-ignore
                    reason: `Annotation Position validation failed - Missing doc or position`,
                    commentsOnInlineNodesAllowed: (0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes'),
                    isPosValid: !!pos,
                    isDocValid: !!this.doc
                }
            });
            return false;
        }
        return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
    }
    /**
	 * Note: False indicates that the selection not able to be calculated.
	 */ getPositionFromRange(range) {
        if (!this.doc || !this.schema || !range) return false;
        return (0, $cMPbW.getPosFromRange)(range);
    }
    getAnnotationMarks() {
        const { schema: schema, doc: doc } = this;
        if (!schema || !doc) return [];
        const { marks: { annotation: annotationMarkType } } = schema;
        if (!annotationMarkType) return [];
        const marks = [];
        doc.descendants((node)=>{
            const annotationsMark = node.marks.filter((m)=>m.type === annotationMarkType);
            if (!annotationsMark || !annotationsMark.length) return true;
            marks.push(...annotationsMark);
            return false;
        });
        const uniqueMarks = new Map();
        marks.forEach((m)=>{
            uniqueMarks.set(m.attrs.id, m);
        });
        return Array.from(uniqueMarks.values());
    }
    getAnnotationsByPosition(range) {
        if (!this.doc || !this.schema) return [];
        const pos = (0, $cMPbW.getPosFromRange)(range);
        if (!pos || !this.doc) return [];
        return (0, $h03xs.getAnnotationIdsFromRange)(pos, this.doc, this.schema);
    }
    applyAnnotation(pos, annotation) {
        if (!this.doc || !pos || !this.schema) {
            if (this.onAnalyticsEvent && (0, $VSDnB.fg)('platform_renderer_annotations_create_debug_logging')) this.onAnalyticsEvent({
                // @ts-ignore
                action: 'failed',
                // @ts-ignore
                actionSubject: 'applyAnnotation',
                // @ts-ignore
                actionSubjectId: 'inlineCommentFailureReason',
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    // @ts-ignore
                    reason: `Annotation applyAnnotation failed - Missing doc, position or schema`,
                    commentsOnInlineNodesAllowed: (0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes'),
                    isPosValid: !!pos,
                    isDocValid: !!this.doc,
                    isSchemaValid: !!this.schema
                }
            });
            return false;
        }
        const { from: from, to: to } = pos;
        const { annotationId: annotationId, annotationType: annotationType } = annotation;
        let step;
        let targetNodeType;
        // As part of fix for RAP, `from` points to the position right before media node
        // hence, -1 is not needed
        const beforeNodePos = from;
        const possibleNode = this.doc.nodeAt(beforeNodePos);
        if (possibleNode?.type.name === 'media') {
            targetNodeType = 'media';
            step = new (0, $eS2Dn.AddNodeMarkStep)(beforeNodePos, this.schema.marks.annotation.create({
                id: annotationId,
                type: annotationType
            }));
        } else {
            const resolvedNode = this.doc.resolve(from).node();
            // annotation is technically on text, but the context is caption
            targetNodeType = resolvedNode.type.name === 'caption' ? 'caption' : 'text';
            step = (0, $cMPbW.createAnnotationStep)(from, to, {
                annotationId: annotationId,
                annotationType: annotationType,
                schema: this.schema
            });
        }
        const { doc: doc, failed: failed } = step.apply(this.doc);
        if (failed || !doc) {
            if (this.onAnalyticsEvent && (0, $VSDnB.fg)('platform_renderer_annotations_create_debug_logging')) this.onAnalyticsEvent({
                // @ts-ignore
                action: 'failed',
                // @ts-ignore
                actionSubject: 'applyAnnotation',
                // @ts-ignore
                actionSubjectId: 'inlineCommentFailureReason',
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    // @ts-ignore
                    reason: `Annotation applyAnnotation failed - ${failed}`,
                    commentsOnInlineNodesAllowed: (0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')
                }
            });
            return false;
        }
        const originalSelection = doc.textBetween(from, to);
        const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, $hAPWV.getIndexMatch)(this.doc, this.schema, originalSelection, from);
        return {
            step: step,
            doc: this.transformer.encode(doc),
            inlineNodeTypes: (0, $4apTl.getRendererRangeInlineNodeNames)({
                actions: this,
                pos: {
                    from: from,
                    to: to
                }
            }),
            originalSelection: originalSelection,
            numMatches: numMatches,
            matchIndex: matchIndex,
            pos: blockNodePos,
            targetNodeType: targetNodeType
        };
    }
    generateAnnotationIndexMatch(pos) {
        if (!this.doc || !pos || !this.schema) return false;
        const { from: from, to: to } = pos;
        const originalSelection = this.doc.textBetween(from, to);
        const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, $hAPWV.getIndexMatch)(this.doc, this.schema, originalSelection, from);
        return {
            originalSelection: originalSelection,
            numMatches: numMatches,
            matchIndex: matchIndex,
            pos: blockNodePos
        };
    }
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Do not forget to remove `undefined` when the `editor_inline_comments_on_inline_nodes` is removed.
    getInlineNodeTypes(annotationId) {
        if (!this.doc || !this.schema) return [];
        return (0, $h03xs.getAnnotationInlineNodeTypes)({
            doc: this.doc,
            schema: this.schema
        }, annotationId);
    }
    /**
	 * This is a temporary method used for controlling when extra analytics shoulw be logged.
	 */ _setDebugLogging(enabled) {
        this.debugAnalyticLoggingEnabled = enabled;
    }
}

});
parcelRegister("h03xs", function(module, exports) {

$parcel$export(module.exports, "canApplyAnnotationOnRange", () => $ccb20202dc8fa865$export$77ddf8216f9eb904);
$parcel$export(module.exports, "getAnnotationIdsFromRange", () => $ccb20202dc8fa865$export$badbcc229c848aec);
$parcel$export(module.exports, "hasAnnotationMark", () => $ccb20202dc8fa865$export$5fe1412b20386053);
$parcel$export(module.exports, "containsAnyAnnotations", () => $ccb20202dc8fa865$export$1976770b876b2728);
$parcel$export(module.exports, "getRangeInlineNodeNames", () => $ccb20202dc8fa865$export$35054451202ed5d9);
$parcel$export(module.exports, "getAnnotationInlineNodeTypes", () => $ccb20202dc8fa865$export$8261bc1f662f3f6e);
$parcel$export(module.exports, "getAnnotationMarksForPos", () => $ccb20202dc8fa865$export$bb1945a828f2864b);
$parcel$export(module.exports, "isEmptyTextSelection", () => $ccb20202dc8fa865$export$2efbc6d84ea0fbec);

var $88i6h = parcelRequire("88i6h");

var $VSDnB = parcelRequire("VSDnB");
const $ccb20202dc8fa865$export$77ddf8216f9eb904 = (rangeSelection, doc, schema)=>{
    const { from: from, to: to } = rangeSelection;
    if (isNaN(from + to) || to - from <= 0 || to < 0 || from < 0) return false;
    let foundInvalid = false;
    doc.nodesBetween(rangeSelection.from, rangeSelection.to, (node, _pos, parent)=>{
        // Special exception for hardBreak nodes
        if (schema.nodes.hardBreak === node.type) return false;
        // For block elements or text nodes, we want to check
        // if annotations are allowed inside this tree
        // or if we're leaf and not text
        if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) {
            const isAllowedInlineNode = [
                'emoji',
                'status',
                'date',
                'mention',
                'inlineCard'
            ].includes(node.type.name);
            if (node.isInline && !node.isText && !isAllowedInlineNode || node.isLeaf && !node.isText && !isAllowedInlineNode || node.isText && !parent?.type.allowsMarkType(schema.marks.annotation)) {
                foundInvalid = true;
                return false;
            }
        } else if (node.isInline && !node.isText || node.isLeaf && !node.isText || node.isText && !parent?.type.allowsMarkType(schema.marks.annotation)) {
            foundInvalid = true;
            return false;
        }
        return true;
    });
    return !foundInvalid;
};
const $ccb20202dc8fa865$export$badbcc229c848aec = (rangeSelection, doc, schema)=>{
    const { from: from, to: to } = rangeSelection;
    const annotations = new Set();
    doc.nodesBetween(from, to, (node)=>{
        if (!node.marks) return true;
        node.marks.forEach((mark)=>{
            if (mark.type === schema.marks.annotation && mark.attrs) annotations.add(mark.attrs.id);
        });
        return true;
    });
    return Array.from(annotations);
};
function $ccb20202dc8fa865$export$5fe1412b20386053(node, state) {
    const { schema: { marks: { annotation: annotationMark } } } = state;
    return !!(annotationMark && node && node.marks.length && annotationMark.isInSet(node.marks));
}
function $ccb20202dc8fa865$export$1976770b876b2728(slice, state) {
    if (!slice.content.size) return false;
    let hasAnnotation = false;
    slice.content.forEach((node)=>{
        hasAnnotation = hasAnnotation || $ccb20202dc8fa865$export$5fe1412b20386053(node, state);
        // return early if annotation found already
        if (hasAnnotation) return true;
        // check annotations in descendants
        node.descendants((node)=>{
            if ($ccb20202dc8fa865$export$5fe1412b20386053(node, state)) {
                hasAnnotation = true;
                return false;
            }
            return true;
        });
    });
    return hasAnnotation;
}
function $ccb20202dc8fa865$export$35054451202ed5d9({ doc: doc, pos: pos }) {
    if (!(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const nodeNames = new Set();
    try {
        doc.nodesBetween(pos.from, pos.to, (node)=>{
            if (node.isInline) nodeNames.add(node.type.name);
        });
        // We sort the list alphabetically to make human consumption of the list easier (in tools like the analytics extension)
        const sortedNames = [
            ...nodeNames
        ].sort();
        return sortedNames;
    } catch  {
        // Some callers have existing gaps where the positions are not valid,
        // and so when called in the current document can throw an error if out of range.
        //
        // This is a defensive check to ensure we don't throw an error in those cases.
        return undefined;
    }
}
function $ccb20202dc8fa865$export$8261bc1f662f3f6e(state, annotationId) {
    if (!(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const mark = state.schema.marks.annotation.create({
        id: annotationId,
        annotationType: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
    });
    const inlineNodeNames = new Set();
    state.doc.descendants((node, pos)=>{
        if (mark.isInSet(node.marks)) inlineNodeNames.add(node.type.name);
        return true;
    });
    // This sorting is done to make human consumption easier (ie. in dev tools, test snapshots, analytics events, ...)
    return [
        ...inlineNodeNames
    ].sort();
}
function $ccb20202dc8fa865$export$bb1945a828f2864b(pos) {
    if (!(0, $VSDnB.fg)('editor_inline_comments_paste_insert_nodes')) return undefined;
    const annotationMarks = pos.marks().filter((mark)=>mark.type === pos.doc.type.schema.marks.annotation);
    return annotationMarks;
}
function $ccb20202dc8fa865$export$2efbc6d84ea0fbec(selection, schema) {
    const { text: text, paragraph: paragraph } = schema.nodes;
    let hasContent = false;
    selection.content().content.descendants((node)=>{
        // for empty paragraph - consider empty (nothing to comment on)
        if (node.type === paragraph && !node.content.size) return false;
        // for not a text or nonempty text - consider nonempty (can comment if the node is supported for annotations)
        if (node.type !== text || !node.textContent) hasContent = true;
        return !hasContent;
    });
    return !hasContent;
}

});

parcelRegister("hYNZx", function(module, exports) {

$parcel$export(module.exports, "SchemaStage", () => $c960adc5c7547145$export$933e6445c497ffd5);
$parcel$export(module.exports, "JSONTransformer", () => $c960adc5c7547145$export$98cb1d9308d0944d);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $ajpes = parcelRequire("ajpes");

var $8vlrc = parcelRequire("8vlrc");
var $cUwVZ = parcelRequire("cUwVZ");
var $7kC9H = parcelRequire("7kC9H");
var $29Vii = parcelRequire("29Vii");
var $8XeG6 = parcelRequire("8XeG6");
var $bIGZ7 = parcelRequire("bIGZ7");
var $7agO8 = parcelRequire("7agO8");
var $g7Cky = parcelRequire("g7Cky");
var $9UDEr = parcelRequire("9UDEr");

var $kOFhM = parcelRequire("kOFhM");

var $fVI2q = parcelRequire("fVI2q");

var $0Cgjx = parcelRequire("0Cgjx");
var $c960adc5c7547145$export$933e6445c497ffd5 = /*#__PURE__*/ function(SchemaStage) {
    SchemaStage["FINAL"] = "final";
    SchemaStage["STAGE_0"] = "stage0";
    return SchemaStage;
}({});
const $c960adc5c7547145$var$isType = (type)=>(node)=>node.type.name === type;
const $c960adc5c7547145$var$isCodeBlock = $c960adc5c7547145$var$isType('codeBlock');
const $c960adc5c7547145$var$isMediaNode = $c960adc5c7547145$var$isType('media');
const $c960adc5c7547145$var$isMediaInline = $c960adc5c7547145$var$isType('mediaInline');
const $c960adc5c7547145$var$isMediaSingleNode = $c960adc5c7547145$var$isType('mediaSingle');
const $c960adc5c7547145$var$isMentionNode = $c960adc5c7547145$var$isType('mention');
const $c960adc5c7547145$var$isParagraph = $c960adc5c7547145$var$isType('paragraph');
const $c960adc5c7547145$var$isHeading = $c960adc5c7547145$var$isType('heading');
const $c960adc5c7547145$var$isTable = $c960adc5c7547145$var$isType('table');
const $c960adc5c7547145$var$isTableCell = $c960adc5c7547145$var$isType('tableCell');
const $c960adc5c7547145$var$isTableHeader = $c960adc5c7547145$var$isType('tableHeader');
const $c960adc5c7547145$var$isLinkMark = $c960adc5c7547145$var$isType('link');
const $c960adc5c7547145$var$isUnsupportedMark = $c960adc5c7547145$var$isType('unsupportedMark');
const $c960adc5c7547145$var$isUnsupportedNodeAttributeMark = $c960adc5c7547145$var$isType('unsupportedNodeAttribute');
const $c960adc5c7547145$var$isExpand = $c960adc5c7547145$var$isType('expand');
const $c960adc5c7547145$var$isNestedExpand = $c960adc5c7547145$var$isType('nestedExpand');
const $c960adc5c7547145$var$isUnsupportedNode = (node)=>$c960adc5c7547145$var$isType('unsupportedBlock')(node) || $c960adc5c7547145$var$isType('unsupportedInline')(node);
const $c960adc5c7547145$var$isDataConsumer = $c960adc5c7547145$var$isType('dataConsumer');
const $c960adc5c7547145$var$isFragmentMark = $c960adc5c7547145$var$isType('fragment');
const $c960adc5c7547145$var$isHardBreak = $c960adc5c7547145$var$isType('hardBreak');
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c960adc5c7547145$var$filterNull = (subject)=>{
    let output = {
        ...subject
    };
    // eslint-disable-next-line guard-for-in
    for(const key in output){
        const current = output[key];
        if (current === null) {
            const { [key]: unusedKey, ...filteredObj } = output;
            output = filteredObj;
        } else if (typeof current === 'object' && !Array.isArray(current)) output[key] = $c960adc5c7547145$var$filterNull(current);
    }
    return output;
};
const $c960adc5c7547145$var$createDocFromContent = (content)=>{
    return {
        version: 1,
        type: 'doc',
        content: content || []
    };
};
const $c960adc5c7547145$var$emptyDoc = $c960adc5c7547145$var$createDocFromContent([
    {
        type: 'paragraph',
        content: []
    }
]);
const $c960adc5c7547145$var$toJSON = (node, mentionMap)=>{
    const obj = {
        type: node.type.name
    };
    if ($c960adc5c7547145$var$isUnsupportedNode(node)) return node.attrs.originalValue;
    else if ($c960adc5c7547145$var$isMediaNode(node)) obj.attrs = (0, $7agO8.toJSON)(node).attrs;
    else if ($c960adc5c7547145$var$isMediaSingleNode(node)) obj.attrs = (0, $bIGZ7.toJSON)(node).attrs;
    else if ($c960adc5c7547145$var$isMediaInline(node)) obj.attrs = (0, $7agO8.toJSON)(node).attrs;
    else if ($c960adc5c7547145$var$isMentionNode(node)) obj.attrs = (0, $g7Cky.toJSON)(node).attrs;
    else if ($c960adc5c7547145$var$isCodeBlock(node)) obj.attrs = (0, $8vlrc.toJSON)(node).attrs;
    else if ($c960adc5c7547145$var$isTable(node)) obj.attrs = (0, $9UDEr.tableToJSON)(node).attrs;
    else if ($c960adc5c7547145$var$isTableCell(node)) obj.attrs = (0, $9UDEr.toJSONTableCell)(node).attrs;
    else if ($c960adc5c7547145$var$isTableHeader(node)) obj.attrs = (0, $9UDEr.toJSONTableHeader)(node).attrs;
    else if ($c960adc5c7547145$var$isExpand(node) || $c960adc5c7547145$var$isNestedExpand(node)) obj.attrs = (0, $7kC9H.toJSON)(node).attrs;
    else if (node.attrs && Object.keys(node.attrs).length) obj.attrs = node.attrs;
    if (obj.attrs) obj.attrs = $c960adc5c7547145$var$filterNull(obj.attrs);
    if ($c960adc5c7547145$var$isMentionNode(node) && mentionMap) {
        // If the mentionMap exists and has a name defined then we should use it and prepend @ to the begining of it.
        const name = !!mentionMap?.[node.attrs.id] ? `@${mentionMap[node.attrs.id]}` : '';
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const text = obj.attrs?.text ?? '';
        obj.attrs = {
            ...obj.attrs,
            // If an explicit text value is set on the mention then that should take priority over the mentionMap value.
            text: !!text ? text : name
        };
    }
    // Remove the attrs property if it's empty, this is currently limited to paragraph nodes.
    if ($c960adc5c7547145$var$isParagraph(node) && obj.attrs && !Object.keys(obj.attrs).length) delete obj.attrs;
    // Hard break has optional attr.text which was added for PM <-> ADF compatibility.
    // No need to preserve it.
    if ($c960adc5c7547145$var$isHardBreak(node)) delete obj.attrs;
    if (node.isText) obj.text = node.textContent;
    else node.content.forEach((child)=>{
        obj.content = obj.content || [];
        obj.content.push($c960adc5c7547145$var$toJSON(child, mentionMap));
    });
    if ($c960adc5c7547145$var$isParagraph(node) || $c960adc5c7547145$var$isHeading(node)) obj.content = obj.content || [];
    if (node.marks.length) {
        // Run any custom mark serialisers
        const parsedMarks = node.marks.map((mark)=>{
            if ($c960adc5c7547145$var$isUnsupportedMark(mark)) return $c960adc5c7547145$var$canOverrideMark(mark, node.marks) ? null : mark.attrs.originalValue;
            else if ($c960adc5c7547145$var$isUnsupportedNodeAttributeMark(mark)) return null;
            else if ($c960adc5c7547145$var$isLinkMark(mark)) return (0, $8XeG6.toJSON)(mark);
            else if ($c960adc5c7547145$var$isDataConsumer(mark)) {
                const serialised = (0, $cUwVZ.toJSON)(mark);
                return !serialised.attrs.sources || serialised.attrs.sources?.length === 0 ? null : serialised;
            } else if ($c960adc5c7547145$var$isFragmentMark(mark)) {
                const fragmentMark = (0, $29Vii.toJSON)(mark);
                if (!fragmentMark.attrs.localId) return null;
                return fragmentMark;
            } else return mark.toJSON();
        }).filter((maybeMark)=>maybeMark !== null);
        // Only set if we have a non-empty array, otherwise explicitly undefine it (as we only run this path if `node.marks.length`)
        obj.marks = parsedMarks?.length > 0 ? parsedMarks : undefined;
        const nodeAttributeMark = node.marks.find($c960adc5c7547145$var$isUnsupportedNodeAttributeMark);
        if (nodeAttributeMark && nodeAttributeMark.attrs.type.nodeType === obj.type) obj.attrs = {
            ...$c960adc5c7547145$var$getUnwrappedNodeAttributes(node, nodeAttributeMark, obj)
        };
    }
    return obj;
};
const $c960adc5c7547145$var$canOverrideMark = (mark, existingMarks)=>{
    if (existingMarks.some((e)=>mark.attrs.originalValue.type === e.type.name)) return (0, $fVI2q.markOverrideRuleFor)(mark.attrs.originalValue.type).canOverrideUnsupportedMark();
    return false;
};
const $c960adc5c7547145$var$getUnwrappedNodeAttributes = (node, mark, obj)=>{
    const nodeAttributes = node.type.spec.attrs;
    const attributes = {
        ...mark.attrs.unsupported,
        ...obj.attrs
    };
    // Ignored via go/ees005
    // eslint-disable-next-line no-var
    for(var key in obj.attrs)if (obj.attrs.hasOwnProperty(key)) {
        const attribute = nodeAttributes ? nodeAttributes[key] : null;
        if (attribute) {
            if (attribute.default === node.attrs[key] && mark.attrs.unsupported[key]) return {
                ...attributes,
                [key]: mark.attrs.unsupported[key]
            };
        }
    }
    return attributes;
};
class $c960adc5c7547145$export$98cb1d9308d0944d {
    /**
	 * @param schema The current editor schema
	 * @param mentionMap An optional mapping of user IDs to mention names. This is used by the encoder to substitute empty
	 * mention node.attr.text values with mapped names.
	 */ constructor(schema = (0, $kOFhM.defaultSchema), mentionMap){
        this.schema = schema;
        this.mentionMap = mentionMap;
    }
    encode(node) {
        const content = [];
        node.content.forEach((child)=>{
            content.push((0, $0Cgjx.sanitizeNode)($c960adc5c7547145$var$toJSON(child, this.mentionMap)));
        });
        if (!content || (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(content, $c960adc5c7547145$var$emptyDoc.content)) return $c960adc5c7547145$var$createDocFromContent([]);
        return $c960adc5c7547145$var$createDocFromContent(content);
    }
    internalParse(content, schema) {
        const doc = schema.nodeFromJSON(content);
        doc.check();
        return doc;
    }
    parse(content, stage) {
        if (content.type !== 'doc') throw new Error('Expected content format to be ADF');
        const schema = !!stage ? (0, $kOFhM.getSchemaBasedOnStage)(stage) : this.schema;
        if (!content.content || content.content.length === 0) return this.internalParse($c960adc5c7547145$var$emptyDoc, schema);
        return this.internalParse(content, schema);
    }
    /**
	 * This method is used to encode a single node
	 */ encodeNode(node) {
        return (0, $0Cgjx.sanitizeNode)($c960adc5c7547145$var$toJSON(node, this.mentionMap));
    }
}

});
parcelRegister("fVI2q", function(module, exports) {

$parcel$export(module.exports, "markOverrideRuleFor", () => $7f7cf8cf5d94f891$export$28e4e3c024cce988);
const $7f7cf8cf5d94f891$var$defaultAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return true;
    }
};
const $7f7cf8cf5d94f891$var$defaultDoNotAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return false;
    }
};
const $7f7cf8cf5d94f891$export$28e4e3c024cce988 = (type)=>{
    switch(type){
        case 'link':
        case 'em':
        case 'strong':
        case 'strike':
        case 'subsup':
        case 'underline':
        case 'code':
        case 'textColor':
        case 'backgroundColor':
        case 'confluenceInlineComment':
        case 'breakout':
        case 'alignment':
        case 'indentation':
        case 'border':
            return $7f7cf8cf5d94f891$var$defaultAllowOverrideBehaviour;
        default:
            return $7f7cf8cf5d94f891$var$defaultDoNotAllowOverrideBehaviour;
    }
};

});

parcelRegister("0Cgjx", function(module, exports) {

$parcel$export(module.exports, "sanitizeNode", () => $45db1c8142107da9$export$48b382180baf8e88);

var $aSk3Q = parcelRequire("aSk3Q");

var $l1C1k = parcelRequire("l1C1k");

var $VSDnB = parcelRequire("VSDnB");

var $hRZSy = parcelRequire("hRZSy");
const $45db1c8142107da9$var$hasNestedTable = (tableCellNode)=>tableCellNode.content?.some((node)=>node?.type === 'table');
function $45db1c8142107da9$export$48b382180baf8e88(json) {
    const sanitizedJSON = (0, $l1C1k.traverse)(json, {
        text: (node)=>{
            if (!node || !Array.isArray(node.marks)) return node;
            return {
                ...node,
                marks: node.marks.filter((mark)=>mark.type !== 'typeAheadQuery')
            };
        },
        status: (node)=>{
            if (node.attrs && !!node.attrs.text) return (0, $hRZSy.removeNonAnnotationMarks)(node);
            return false; // empty status
        },
        caption: (node)=>{
            if (node.content) return node;
            return false; // empty caption
        },
        tableCell: (node)=>{
            if ($45db1c8142107da9$var$hasNestedTable(node) && (0, $VSDnB.fg)('platform_editor_use_nested_table_pm_nodes')) return (0, $aSk3Q.transformNestedTableNodeOutgoingDocument)(node);
        },
        tableHeader: (node)=>{
            if ($45db1c8142107da9$var$hasNestedTable(node) && (0, $VSDnB.fg)('platform_editor_use_nested_table_pm_nodes')) return (0, $aSk3Q.transformNestedTableNodeOutgoingDocument)(node);
        },
        emoji: (0, $hRZSy.removeNonAnnotationMarks),
        mention: (0, $hRZSy.removeNonAnnotationMarks),
        date: (0, $hRZSy.removeNonAnnotationMarks),
        hardBreak: (0, $hRZSy.removeMarks),
        inlineCard: (0, $hRZSy.removeNonAnnotationMarks)
    });
    return sanitizedJSON;
}

});
parcelRegister("aSk3Q", function(module, exports) {

$parcel$export(module.exports, "transformNestedTablesIncomingDocument", () => $2dd8f1bba9a54435$export$18544d0b5f43e4a1);
$parcel$export(module.exports, "transformNestedTableNodeOutgoingDocument", () => $2dd8f1bba9a54435$export$8a334a7d9fe120ec);

var $l1C1k = parcelRequire("l1C1k");

var $gxbjN = parcelRequire("gxbjN");

var $8YCkv = parcelRequire("8YCkv");
const $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_TYPE = 'com.atlassian.confluence.migration', $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_KEY = 'nested-table';
const $2dd8f1bba9a54435$export$f45e7335ec874bfe = (extensionNode)=>extensionNode.attrs?.extensionType === $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_TYPE && extensionNode.attrs?.extensionKey === $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_KEY;
const $2dd8f1bba9a54435$var$transformNestedTableExtension = (nestedTableExtension)=>{
    // No content - drop the extension node
    if (!nestedTableExtension.attrs?.parameters?.adf) return false;
    try {
        const adf = JSON.parse(nestedTableExtension.attrs?.parameters?.adf);
        if (!adf.content || adf.content.length === 0) return false;
        return adf.content[0];
    } catch (e) {
        throw new (0, $8YCkv.NodeNestingTransformError)('Failed to parse nested table content');
    }
};
// TODO: EDITOR-806 - Remove when cleaning feature gate platform_editor_nested_table_extension_comment_fix
function $2dd8f1bba9a54435$var$isInsideBodiedExtension(parent) {
    if (parent.node === undefined) return false;
    if (parent.node.type === 'bodiedExtension') return true;
    if (parent?.parent?.node) return $2dd8f1bba9a54435$var$isInsideBodiedExtension(parent.parent);
    return false;
}
const $2dd8f1bba9a54435$export$18544d0b5f43e4a1 = (adf, // TODO: EDITOR-806 - Remove options when cleaning feature gate platform_editor_nested_table_extension_comment_fix as no longer needed
options = {})=>{
    let isTransformed = false;
    const transformedAdf = (0, $l1C1k.traverse)(adf, {
        extension: (node, parent)=>{
            if ($2dd8f1bba9a54435$export$f45e7335ec874bfe(node)) {
                // TODO: EDITOR-806 - Remove this block when cleaning feature gate platform_editor_nested_table_extension_comment_fix
                // Bodied extensions in renderer use their own nested renderer to render the content.
                // This results in the document being validated/transformed twice, once with untransformed content and again with transformed content.
                // Since the untransformed content is valid ADF (table as extension in table) but the transformed content is not valid ADF, (table in table)
                // we need to skip transforming nested tables inside bodied extensions in renderer on the first pass or else it will fail validation and render an unsupported block.
                if (options.environment === 'renderer' && $2dd8f1bba9a54435$var$isInsideBodiedExtension(parent) && !options.disableNestedRendererTreatment) return undefined;
                isTransformed = true;
                return $2dd8f1bba9a54435$var$transformNestedTableExtension(node);
            }
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};
const $2dd8f1bba9a54435$export$8a334a7d9fe120ec = (tableCellNode)=>{
    try {
        return {
            ...tableCellNode,
            content: tableCellNode.content?.map((childNode)=>{
                // wrap nested table in an extension node
                if (childNode?.type === 'table') return (0, $gxbjN.extension)({
                    extensionType: $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_TYPE,
                    extensionKey: $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_KEY,
                    parameters: {
                        adf: JSON.stringify({
                            type: 'doc',
                            version: 1,
                            content: [
                                childNode
                            ]
                        })
                    }
                });
                return childNode;
            })
        };
    } catch (e) {
        throw new (0, $8YCkv.NodeNestingTransformError)('Failed to encode nested table node');
    }
};

});
parcelRegister("l1C1k", function(module, exports) {

$parcel$export(module.exports, "traverse", () => $b903aab814d8ed47$export$df3f009e3d155b20);
function $b903aab814d8ed47$export$735cfea22ce30f58(_visitors) {
    return true;
}
function $b903aab814d8ed47$export$df3f009e3d155b20(adf, visitors) {
    if (!$b903aab814d8ed47$export$735cfea22ce30f58(visitors)) throw new Error(`Visitors are not valid: "${Object.keys(visitors).join(', ')}"`);
    return $b903aab814d8ed47$var$traverseNode(adf, {
        node: undefined
    }, visitors, 0, 0);
}
function $b903aab814d8ed47$var$traverseNode(adfNode, parent, visitors, index, depth) {
    const visitor = visitors[adfNode.type] || visitors['any'];
    let newNode = {
        ...adfNode
    };
    if (visitor) {
        const processedNode = visitor({
            ...newNode
        }, parent, index, depth);
        if (processedNode === false) return false;
        newNode = processedNode || adfNode;
    }
    if (newNode.content) newNode.content = newNode.content.reduce((acc, node, idx)=>{
        if (!node) return acc;
        const processedNode = $b903aab814d8ed47$var$traverseNode(node, {
            node: newNode,
            parent: parent
        }, visitors, idx, depth + 1);
        if (processedNode !== false) acc.push(processedNode);
        return acc;
    }, []);
    return newNode;
}

});

parcelRegister("gxbjN", function(module, exports) {

$parcel$export(module.exports, "extension", () => $ec4576859225619a$export$1b45514b112dd749);
const $ec4576859225619a$export$1b45514b112dd749 = (attrs)=>({
        type: 'extension',
        attrs: attrs
    });

});

parcelRegister("8YCkv", function(module, exports) {

$parcel$export(module.exports, "NodeNestingTransformError", () => $b0271efedae2a0b7$export$3d8e8d2182f13924);
/** NodeNestingTransformError  */ class $b0271efedae2a0b7$export$3d8e8d2182f13924 extends Error {
    /**
	 * @param message - Error message - Do not use any UGC in this message
	 */ constructor(message){
        super(message);
        this.name = 'NodeNestingTransformError';
    }
}

});


parcelRegister("hRZSy", function(module, exports) {

$parcel$export(module.exports, "removeMarks", () => $7e7bed7752b3d3e8$export$9bf001d8ef76e497);
$parcel$export(module.exports, "removeNonAnnotationMarks", () => $7e7bed7752b3d3e8$export$8cae9126fc577085);
function $7e7bed7752b3d3e8$export$9bf001d8ef76e497(node) {
    const newNode = {
        ...node
    };
    delete newNode.marks;
    return newNode;
}
function $7e7bed7752b3d3e8$export$8cae9126fc577085(node) {
    const newNode = {
        ...node
    };
    if (node.marks) newNode.marks = node.marks.filter((mark)=>mark.type === 'annotation');
    return newNode;
}

});



parcelRegister("cMPbW", function(module, exports) {

$parcel$export(module.exports, "isRoot", () => $c9441534493a403f$export$e3140dc7d0c35e48);
$parcel$export(module.exports, "getPosFromRange", () => $c9441534493a403f$export$243cdddc5b21d8c1);
$parcel$export(module.exports, "createAnnotationStep", () => $c9441534493a403f$export$74899f7e5acb5cd3);

var $VSDnB = parcelRequire("VSDnB");

var $eS2Dn = parcelRequire("eS2Dn");
function $c9441534493a403f$var$getStartPos(element) {
    return parseInt(element.dataset.rendererStartPos || '-1', 10);
}
const $c9441534493a403f$var$getNodeType = (element)=>element.dataset.nodeType;
function $c9441534493a403f$var$isPositionPointer(element) {
    return $c9441534493a403f$var$getStartPos(element) > -1;
}
function $c9441534493a403f$var$findParent(element) {
    const { parentElement: parentElement } = element;
    if (!parentElement || $c9441534493a403f$export$e3140dc7d0c35e48(parentElement)) return null;
    if ($c9441534493a403f$var$isPositionPointer(parentElement)) return parentElement;
    return $c9441534493a403f$var$findParent(parentElement);
}
function $c9441534493a403f$var$findMediaParent(element) {
    const { parentElement: parentElement } = element;
    if (!parentElement || $c9441534493a403f$export$e3140dc7d0c35e48(parentElement)) return null;
    if (parentElement.dataset.nodeType === 'mediaSingle') return parentElement;
    return $c9441534493a403f$var$findMediaParent(parentElement);
}
function $c9441534493a403f$var$findParentBeforePointer(element) {
    const { parentElement: parentElement } = element;
    if ($c9441534493a403f$export$e3140dc7d0c35e48(parentElement) || !parentElement) return null;
    if ($c9441534493a403f$var$isPositionPointer(parentElement)) return element;
    return $c9441534493a403f$var$findParentBeforePointer(parentElement);
}
function $c9441534493a403f$var$isElementNode(node) {
    return node.nodeType === Node.ELEMENT_NODE;
}
function $c9441534493a403f$var$isTextNode(node) {
    return node.nodeType === Node.TEXT_NODE;
}
function $c9441534493a403f$var$isHighlightTextNode(node) {
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    return !!node?.dataset?.highlighted;
}
function $c9441534493a403f$var$isNodeInlineMark(node) {
    return $c9441534493a403f$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
}
function $c9441534493a403f$var$isElementInlineMark(element) {
    return !!element && Boolean(element.dataset.rendererMark);
}
function $c9441534493a403f$var$isNodeInlineTextMark(node) {
    if (node === null) return false;
    const isInlineMark = $c9441534493a403f$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
    if (!isInlineMark) return false;
    /**
	 * This checks if the element has any descendents with the data-inline-card
	 * attribute set to 'true'. If it does, we should not consider it as an
	 * inline text mark.
	 **/ if ($c9441534493a403f$var$hasInlineNodeDescendant(node)) return false;
    return true;
}
/**
 * This checks all the descendents of a node and returns true if it reaches
 * a descendant with the data-inline-card attribute set to 'true'.
 */ function $c9441534493a403f$var$hasInlineNodeDescendant(node) {
    if ($c9441534493a403f$var$isElementNode(node)) {
        if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) {
            if (node.dataset.annotationInlineNode === 'true') return true;
        } else {
            if (node.dataset.inlineCard === 'true') return true;
        }
        return Array.from(node.childNodes).some($c9441534493a403f$var$hasInlineNodeDescendant);
    }
    return false;
}
function $c9441534493a403f$var$resolveNodePos(node) {
    let resolvedPos = 0;
    let prev = node.previousSibling;
    while(prev){
        if ((0, $VSDnB.fg)('platform_editor_annotation_position_comment_nodes')) {
            if (prev.nodeType === Node.COMMENT_NODE) {
                // Comment nodes should not result in the position being
                // incremented, so we skip them.
                prev = prev.previousSibling;
                continue;
            }
        }
        if (prev && ($c9441534493a403f$var$isTextNode(prev) || $c9441534493a403f$var$isHighlightTextNode(prev))) resolvedPos += (prev.textContent || '').length;
        else if (prev) {
            if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) {
                if ($c9441534493a403f$var$isNodeInlineTextMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
                else resolvedPos += 1;
            } else if ($c9441534493a403f$var$isNodeInlineMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
            else resolvedPos += 1;
        }
        prev = prev.previousSibling;
    }
    return resolvedPos;
}
function $c9441534493a403f$export$e3140dc7d0c35e48(element) {
    return !!element && element.classList.contains('ak-renderer-document');
}
function $c9441534493a403f$export$5db587db55468da7(node, offset, findEnd = false) {
    // If the passed node doesn't exist, we should abort
    if (!node) return false;
    if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) {
        const startPosAncestor = node.parentElement?.closest('[data-renderer-start-pos');
        const potentialParent = (0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? 'data-annotation-mark' : 'data-inline-card';
        if (startPosAncestor?.hasAttribute(potentialParent)) {
            if (findEnd) return parseInt(startPosAncestor?.getAttribute('data-renderer-start-pos') || '-1', 10) + 1;
            else return parseInt(startPosAncestor?.getAttribute('data-renderer-start-pos') || '-1', 10);
        }
    }
    /**
	 * If anchor node is an element (e.g. after a triple click) the anchorOffset
	 * is the number of child nodes preceding the anchor.
	 * https://developer.mozilla.org/en-US/docs/Web/API/Selection/anchorOffset
	 *
	 * For end pos we calculate the number of characters by stepping through
	 * each of the node's children.
	 */ if (node instanceof HTMLElement && $c9441534493a403f$var$isPositionPointer(node)) {
        if (findEnd) {
            let count = $c9441534493a403f$var$getStartPos(node);
            const children = node.childNodes;
            for(let i = 0; i < offset; i++)count += children[i]?.textContent?.length || 1;
            return count;
        }
        return $c9441534493a403f$var$getStartPos(node) + offset;
    }
    const parent = $c9441534493a403f$var$findParent(node);
    // Similar to above, if we cant find a parent position pointer
    // we should not proceed.
    if (!parent) return false;
    let resolvedPos = $c9441534493a403f$var$getStartPos(parent);
    let current = node;
    if (current.parentElement && current.parentElement !== parent) {
        // Find the parent element that is a direct child of the position pointer
        // the outer most element from our text position.
        const preParentPointer = $c9441534493a403f$var$findParentBeforePointer(current.parentElement);
        // If our range is inside an inline node
        // We need to move our pointers to parent element
        // since we don't want to count text inside inline nodes at all
        if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) {
            if (!($c9441534493a403f$var$isNodeInlineTextMark(preParentPointer) || $c9441534493a403f$var$isHighlightTextNode(preParentPointer))) {
                current = current.parentElement;
                offset = 0;
            }
        } else if (!($c9441534493a403f$var$isElementInlineMark(preParentPointer) || $c9441534493a403f$var$isHighlightTextNode(preParentPointer))) {
            current = current.parentElement;
            offset = 0;
        }
        resolvedPos += $c9441534493a403f$var$resolveNodePos(current);
        while(current && current.parentElement !== parent){
            current = current.parentNode;
            if (current) {
                const nodePos = $c9441534493a403f$var$resolveNodePos(current);
                resolvedPos += nodePos;
            }
        }
    } else resolvedPos += $c9441534493a403f$var$resolveNodePos(current);
    return resolvedPos + offset;
}
function $c9441534493a403f$export$243cdddc5b21d8c1(range) {
    const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
    const possibleMediaOrMediaSingleElement = $c9441534493a403f$var$findParent(startContainer);
    // Video hover targets return media single, not media, thus, the extra check in condition.
    const isMediaOrMediaSingle = possibleMediaOrMediaSingleElement && // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /media|mediaSingle/.test($c9441534493a403f$var$getNodeType(possibleMediaOrMediaSingleElement) || '');
    if (isMediaOrMediaSingle) {
        let pos;
        const mediaSingleElement = $c9441534493a403f$var$getNodeType(possibleMediaOrMediaSingleElement) === 'mediaSingle' ? possibleMediaOrMediaSingleElement : $c9441534493a403f$var$findMediaParent(possibleMediaOrMediaSingleElement);
        if (mediaSingleElement) pos = $c9441534493a403f$var$getStartPos(mediaSingleElement);
        if (pos !== undefined) return {
            from: pos,
            to: pos
        };
    }
    const from = $c9441534493a403f$export$5db587db55468da7(startContainer, startOffset);
    const findEnd = true;
    const to = $c9441534493a403f$export$5db587db55468da7(endContainer, endOffset, findEnd);
    if (from === false || to === false) return false;
    return {
        from: from,
        to: to
    };
}
function $c9441534493a403f$export$74899f7e5acb5cd3(from, to, opts) {
    return new (0, $eS2Dn.AddMarkStep)(Math.min(from, to), Math.max(from, to), opts.schema.marks.annotation.create({
        id: opts.annotationId,
        annotationType: opts.annotationType
    }));
}

});

parcelRegister("4apTl", function(module, exports) {

$parcel$export(module.exports, "getRendererRangeInlineNodeNames", () => $3b0115c3167e4664$export$b0ea72d31617ccea);

var $h03xs = parcelRequire("h03xs");

var $VSDnB = parcelRequire("VSDnB");
function $3b0115c3167e4664$export$b0ea72d31617ccea({ actions: actions, pos: pos }) {
    if (!(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const { doc: doc } = actions;
    if (!pos || !doc) return undefined;
    const inlineNodeNames = (0, $h03xs.getRangeInlineNodeNames)({
        doc: doc,
        pos: pos
    });
    return inlineNodeNames;
}

});

parcelRegister("hAPWV", function(module, exports) {

$parcel$export(module.exports, "getIndexMatch", () => $8b6d6fb20e026dde$export$fb7dab895a0d310e);
function $8b6d6fb20e026dde$export$fb7dab895a0d310e(doc, schema, selectedText, startIndex) {
    let textContent = '';
    let matchIndex = 0;
    let numMatches = 0;
    let blockNodePos;
    doc.descendants((node, pos)=>{
        const nodeType = node.type;
        const { media: media } = schema.nodes;
        // Mirrors Confluence backend and doesn't construct textContent if it doesn't allow annotations
        // Don't skip media node so that block node can be defined its startIndex in within [nodeStart, nodeEnd]
        if ((node.isText || !nodeType.allowsMarkType(schema.marks.annotation)) && nodeType !== media) // Note: `return true` as a parent disallowing annotations does not mean a child disallows annotations.
        // Eg: panel (invalid) > p (valid)
        return true;
        const nodeStart = pos;
        const nodeEnd = nodeStart + node.nodeSize;
        if (startIndex >= nodeStart && startIndex <= nodeEnd) {
            // if it's a node block, set position to pos to indicate to the backend
            // that it's an annotation on a block node
            if (nodeType === media) blockNodePos = pos;
            // If the start of the annotation selection is within the current node, we scan the document for previous occurrences
            // Find the index by counting all previous instances of the selectedText in the partial textContent
            // Need to scan from start, up to `startIndex` (which includes partial of the current node)
            textContent += doc.textBetween(nodeStart, startIndex - 1);
            matchIndex = $8b6d6fb20e026dde$export$3c2359e76fc742da(textContent, selectedText);
            // Complete appending of the node
            textContent += doc.textBetween(startIndex, nodeEnd);
        } else textContent += node.textContent;
        return true;
    });
    // Count total number of matches in final text
    numMatches = $8b6d6fb20e026dde$export$3c2359e76fc742da(textContent, selectedText);
    return {
        numMatches: numMatches,
        matchIndex: matchIndex,
        textContent: textContent,
        blockNodePos: blockNodePos
    };
}
function $8b6d6fb20e026dde$export$3c2359e76fc742da(searchString, query) {
    if (searchString === '' || query === '') return 0;
    // Escape characters that would trigger as syntax in a regex query before converting to the query
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const reg = new RegExp(query.replace(/(?=[.\\+*?[^\]$(){}\|])/g, '\\'), 'g');
    return (searchString.match(reg) || []).length;
}

});






parcelRegister("8Mz83", function(module, exports) {

$parcel$export(module.exports, "AnnotationsContextWrapper", () => $68c25c02b6872087$export$787af8a111ff3c03);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $iYAgE = parcelRequire("iYAgE");

var $6MIvG = parcelRequire("6MIvG");

var $iatcV = parcelRequire("iatcV");
const $68c25c02b6872087$export$787af8a111ff3c03 = (props)=>{
    const providers = (0, $5uXOq.useContext)((0, $iYAgE.ProvidersContext));
    const { rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent, children: children } = props;
    const inlineCommentProvider = providers && providers.inlineComment;
    const selectionComponent = inlineCommentProvider && inlineCommentProvider.selectionComponent;
    const hoverComponent = inlineCommentProvider && inlineCommentProvider.hoverComponent;
    if (!selectionComponent && !hoverComponent) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            children,
            !!hoverComponent && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6MIvG.RangeValidator), {
                createAnalyticsEvent: createAnalyticsEvent,
                rendererRef: rendererRef,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                component: hoverComponent
            }),
            !!selectionComponent && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iatcV.SelectionRangeValidator), {
                createAnalyticsEvent: createAnalyticsEvent,
                rendererRef: rendererRef,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                selectionComponent: selectionComponent
            })
        ]
    });
};

});
parcelRegister("6MIvG", function(module, exports) {

$parcel$export(module.exports, "RangeValidator", () => $38d3fe2fadcf735b$export$6d8376a902cb8aa7);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7g31n = parcelRequire("7g31n");

var $fCNtA = parcelRequire("fCNtA");

var $2EsbE = parcelRequire("2EsbE");

var $kuusl = parcelRequire("kuusl");
const $38d3fe2fadcf735b$export$6d8376a902cb8aa7 = (props)=>{
    const { component: component, rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent } = props;
    const actions = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    const { clearHoverRange: clearHoverRange } = (0, $2EsbE.useAnnotationRangeDispatch)();
    const { range: range, type: type } = (0, $2EsbE.useAnnotationRangeState)();
    const { isWithinRange: isWithinRange } = (0, $kuusl.useAnnotationHoverContext)();
    if (!range || type !== 'hover') return null;
    const documentPosition = actions.getPositionFromRange(range);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7g31n.Mounter), {
        isWithinRange: isWithinRange,
        range: range,
        wrapperDOM: rendererRef,
        component: component,
        onClose: clearHoverRange,
        documentPosition: documentPosition,
        isAnnotationAllowed: true,
        applyAnnotation: actions.applyAnnotation.bind(actions),
        generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
        createAnalyticsEvent: createAnalyticsEvent
    });
};
$38d3fe2fadcf735b$export$6d8376a902cb8aa7.displayName = 'HoverRangeValidator';

});
parcelRegister("7g31n", function(module, exports) {

$parcel$export(module.exports, "Mounter", () => $3da53cae08f8e9e6$export$2109cd350bcf6eda);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $88i6h = parcelRequire("88i6h");

var $fVTp8 = parcelRequire("fVTp8");

var $dWAZk = parcelRequire("dWAZk");

var $gkwXh = parcelRequire("gkwXh");

var $fCNtA = parcelRequire("fCNtA");

var $2EsbE = parcelRequire("2EsbE");
const $3da53cae08f8e9e6$export$2109cd350bcf6eda = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>{
    const { component: Component, range: range, isWithinRange: isWithinRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
    const { promoteHoverToDraft: promoteHoverToDraft, clearHoverDraft: clearHoverDraft } = (0, $2EsbE.useAnnotationRangeDispatch)();
    const { hoverDraftDocumentPosition: hoverDraftDocumentPosition } = (0, $2EsbE.useAnnotationRangeState)();
    const actions = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    const onCreateCallback = (0, $5uXOq.useCallback)((annotationId)=>{
        const positionToAnnotate = hoverDraftDocumentPosition || documentPosition;
        if (!isAnnotationAllowed || !positionToAnnotate || !applyAnnotation) return false;
        const annotation = {
            annotationId: annotationId,
            annotationType: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
        };
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $gkwXh.ACTION).INSERTED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {},
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK
        }).fire((0, $dWAZk.FabricChannel).editor);
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        isAnnotationAllowed,
        documentPosition,
        applyAnnotation,
        createAnalyticsEvent,
        hoverDraftDocumentPosition
    ]);
    const createIndexCallback = (0, $5uXOq.useCallback)(()=>{
        if (!documentPosition || !generateIndexMatch) return false;
        const result = generateIndexMatch(documentPosition);
        if (!result) return false;
        return result;
    }, [
        documentPosition,
        generateIndexMatch
    ]);
    const applyDraftModeCallback = (0, $5uXOq.useCallback)((options)=>{
        if (!documentPosition || !isAnnotationAllowed) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $gkwXh.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {},
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK
            }).fire((0, $dWAZk.FabricChannel).editor);
            return false;
        }
        promoteHoverToDraft(documentPosition);
        if (createAnalyticsEvent) {
            const uniqueAnnotationsInRange = actions.getAnnotationsByPosition(range);
            createAnalyticsEvent({
                action: (0, $gkwXh.ACTION).OPENED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: uniqueAnnotationsInRange.length
                }
            }).fire((0, $dWAZk.FabricChannel).editor);
        }
        window.requestAnimationFrame(()=>{
            if (options.keepNativeSelection) (0, $fVTp8.updateWindowSelectionAroundDraft)(documentPosition);
            else {
                const sel = window.getSelection();
                if (sel) sel.removeAllRanges();
            }
        });
        const positionToAnnotate = hoverDraftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation || !options.annotationId) return false;
        const annotation = {
            annotationId: options.annotationId,
            annotationType: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
        };
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        documentPosition,
        isAnnotationAllowed,
        createAnalyticsEvent,
        applyAnnotation,
        actions,
        range,
        promoteHoverToDraft,
        hoverDraftDocumentPosition
    ]);
    const removeDraftModeCallback = (0, $5uXOq.useCallback)(()=>{
        clearHoverDraft();
        const sel = window.getSelection();
        if (sel) sel.removeAllRanges();
    }, [
        clearHoverDraft
    ]);
    const onCloseCallback = (0, $5uXOq.useCallback)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $gkwXh.ACTION).CLOSED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
            attributes: {}
        }).fire((0, $dWAZk.FabricChannel).editor);
        removeDraftModeCallback();
        onCloseProps();
    }, [
        onCloseProps,
        removeDraftModeCallback,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        range: range,
        isWithinRange: isWithinRange,
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        wrapperDOM: wrapperDOM.current,
        isAnnotationAllowed: isAnnotationAllowed,
        onClose: onCloseCallback,
        onCreate: onCreateCallback,
        getAnnotationIndexMatch: createIndexCallback,
        applyDraftMode: applyDraftModeCallback,
        removeDraftMode: removeDraftModeCallback
    });
});

});
parcelRegister("fVTp8", function(module, exports) {

$parcel$export(module.exports, "dataAttributes", () => $c2a45e53becb69f1$export$15d6ddc168d35719);
$parcel$export(module.exports, "updateWindowSelectionAroundDraft", () => $c2a45e53becb69f1$export$e14699d956e87e73);
const $c2a45e53becb69f1$export$15d6ddc168d35719 = ({ from: from, to: to })=>{
    return {
        ['data-annotation-draft-mark']: true,
        ['data-draft-start-at']: from,
        ['data-draft-end-at']: to
    };
};
const $c2a45e53becb69f1$var$buildDataAttributesQuery = (pos)=>{
    const a = $c2a45e53becb69f1$export$15d6ddc168d35719(pos);
    return Object.entries(a).map(([k, v])=>`[${k}="${v}"]`).join('');
};
const $c2a45e53becb69f1$export$e14699d956e87e73 = (pos)=>{
    const sel = window.getSelection();
    if (!sel) return false;
    const draftNodes = document.querySelectorAll($c2a45e53becb69f1$var$buildDataAttributesQuery(pos));
    if (!draftNodes || draftNodes.length === 0) return false;
    sel.removeAllRanges();
    const range = document.createRange();
    range.setStart(draftNodes[0], 0);
    range.setEndAfter(draftNodes[draftNodes.length - 1]);
    sel.addRange(range);
    return true;
};

});

parcelRegister("2EsbE", function(module, exports) {

$parcel$export(module.exports, "AnnotationRangeProvider", () => $7c7af48337b91c7a$export$30384a6aedd19fee);
$parcel$export(module.exports, "useAnnotationRangeState", () => $7c7af48337b91c7a$export$e07ee6d6cc95d9a0);
$parcel$export(module.exports, "useAnnotationRangeDispatch", () => $7c7af48337b91c7a$export$708fc397e2b6f08d);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $7c7af48337b91c7a$var$initialState = {
    type: null,
    selectionRange: null,
    hoverRange: null,
    selectionDraftRange: null,
    hoverDraftRange: null,
    selectionDraftDocumentPosition: null,
    hoverDraftDocumentPosition: null
};
function $7c7af48337b91c7a$var$reducer(state, action) {
    switch(action.type){
        case 'clearSelection':
            if (state.selectionRange !== null) return {
                ...state,
                selectionRange: null,
                type: state.type === 'selection' ? null : state.type
            };
            return state;
        case 'clearHover':
            if (state.hoverRange !== null) return {
                ...state,
                hoverRange: null,
                type: state.type === 'hover' ? null : state.type
            };
            return state;
        case 'setSelection':
            if (state.selectionRange !== action.range) return {
                ...state,
                selectionRange: action.range,
                type: 'selection'
            };
            return state;
        case 'setHover':
            if (state.hoverRange !== action.range) return {
                ...state,
                hoverRange: action.range,
                type: 'hover'
            };
            return state;
        case 'promoteSelectionToDraft':
            // we should only promote the range to a draft if the current range type is a selection
            // we should also store the promotion type, so that a clear will not accidently clear the draft of a
            // different type
            if (state.selectionDraftRange !== state.selectionRange) return {
                ...state,
                selectionRange: null,
                type: state.type === 'selection' ? null : state.type,
                selectionDraftRange: state.selectionRange,
                selectionDraftDocumentPosition: action.position
            };
            return state;
        case 'promoteHoverToDraft':
            if (state.hoverDraftRange !== state.hoverRange) return {
                ...state,
                hoverRange: null,
                type: state.type === 'hover' ? null : state.type,
                hoverDraftRange: state.hoverRange,
                hoverDraftDocumentPosition: action.position
            };
            return state;
        case 'clearSelectionDraft':
            if (state.selectionDraftRange !== null) return {
                ...state,
                selectionDraftRange: null,
                selectionDraftDocumentPosition: null
            };
            return state;
        case 'clearHoverDraft':
            if (state.hoverDraftRange !== null) return {
                ...state,
                hoverDraftRange: null,
                hoverDraftDocumentPosition: null
            };
            return state;
    }
}
const $7c7af48337b91c7a$export$145b9bb655c3d220 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    range: null,
    type: null,
    selectionDraftRange: null,
    hoverDraftRange: null,
    selectionDraftDocumentPosition: null,
    hoverDraftDocumentPosition: null
});
const $7c7af48337b91c7a$export$efb0d1c8cbaac647 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    clearSelectionRange: ()=>{},
    clearHoverRange: ()=>{},
    setSelectionRange: ()=>{},
    promoteSelectionToDraft: ()=>{},
    promoteHoverToDraft: ()=>{},
    clearSelectionDraft: ()=>{},
    clearHoverDraft: ()=>{}
});
const $7c7af48337b91c7a$export$7cf774ce920e4bbd = ({ children: children, allowCommentsOnMedia: allowCommentsOnMedia })=>{
    const [{ selectionRange: selectionRange, hoverRange: hoverRange, type: type, selectionDraftRange: selectionDraftRange, selectionDraftDocumentPosition: selectionDraftDocumentPosition, hoverDraftRange: hoverDraftRange, hoverDraftDocumentPosition: hoverDraftDocumentPosition }, dispatch] = (0, $5uXOq.useReducer)($7c7af48337b91c7a$var$reducer, $7c7af48337b91c7a$var$initialState);
    const clearSelectionRange = (0, $5uXOq.useCallback)(()=>dispatch({
            type: 'clearSelection'
        }), []);
    const clearHoverRange = (0, $5uXOq.useCallback)(()=>dispatch({
            type: 'clearHover'
        }), []);
    const setSelectionRange = (0, $5uXOq.useCallback)((range)=>dispatch({
            type: 'setSelection',
            range: range
        }), []);
    const setHoverTarget = (0, $5uXOq.useCallback)((target)=>{
        // the HoverComponent expects an element deeply nested inside media, these classes work with the current implementation
        const mediaNode = target.querySelector('.media-card-inline-player, .media-file-card-view');
        if (!mediaNode) return;
        const range = document.createRange();
        range.setStartBefore(mediaNode);
        range.setEndAfter(mediaNode);
        dispatch({
            type: 'setHover',
            range: range
        });
    }, []);
    const promoteSelectionToDraft = (0, $5uXOq.useCallback)((position)=>{
        dispatch({
            type: 'promoteSelectionToDraft',
            position: position
        });
    }, []);
    const clearSelectionDraft = (0, $5uXOq.useCallback)(()=>{
        dispatch({
            type: 'clearSelectionDraft'
        });
    }, []);
    const promoteHoverToDraft = (0, $5uXOq.useCallback)((position)=>{
        dispatch({
            type: 'promoteHoverToDraft',
            position: position
        });
    }, []);
    const clearHoverDraft = (0, $5uXOq.useCallback)(()=>{
        dispatch({
            type: 'clearHoverDraft'
        });
    }, []);
    const stateData = (0, $5uXOq.useMemo)(()=>{
        return {
            // We techinically have two ranges, however we only want to expose one of them at a time, because only one draft
            // can be active at a time. The type of range is used to determine which range is active.
            range: type === 'selection' ? selectionRange : hoverRange,
            type: type,
            selectionDraftRange: selectionDraftRange,
            hoverDraftRange: hoverDraftRange,
            selectionDraftDocumentPosition: selectionDraftDocumentPosition,
            hoverDraftDocumentPosition: hoverDraftDocumentPosition
        };
    }, [
        selectionRange,
        hoverRange,
        type,
        selectionDraftRange,
        selectionDraftDocumentPosition,
        hoverDraftRange,
        hoverDraftDocumentPosition
    ]);
    const dispatchData = (0, $5uXOq.useMemo)(()=>({
            clearSelectionRange: clearSelectionRange,
            clearHoverRange: clearHoverRange,
            setSelectionRange: setSelectionRange,
            setHoverTarget: !!allowCommentsOnMedia ? setHoverTarget : undefined,
            promoteSelectionToDraft: promoteSelectionToDraft,
            promoteHoverToDraft: promoteHoverToDraft,
            clearSelectionDraft: clearSelectionDraft,
            clearHoverDraft: clearHoverDraft
        }), [
        allowCommentsOnMedia,
        clearSelectionRange,
        clearHoverRange,
        setSelectionRange,
        setHoverTarget,
        promoteSelectionToDraft,
        promoteHoverToDraft,
        clearSelectionDraft,
        clearHoverDraft
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($7c7af48337b91c7a$export$145b9bb655c3d220.Provider, {
        value: stateData,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($7c7af48337b91c7a$export$efb0d1c8cbaac647.Provider, {
            value: dispatchData,
            children: children
        })
    });
};
const $7c7af48337b91c7a$export$30384a6aedd19fee = ({ children: children, allowCommentsOnMedia: allowCommentsOnMedia, isNestedRender: isNestedRender })=>{
    /*
	 * If this is a nested render, we do not provide the context
	 * because it has already been provided higher up the component tree
	 * and we need the original context to create annotations on extensions.
	 */ return isNestedRender ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($7c7af48337b91c7a$export$7cf774ce920e4bbd, {
        allowCommentsOnMedia: allowCommentsOnMedia,
        children: children
    });
};
const $7c7af48337b91c7a$export$e07ee6d6cc95d9a0 = ()=>{
    return (0, $5uXOq.useContext)($7c7af48337b91c7a$export$145b9bb655c3d220);
};
const $7c7af48337b91c7a$export$708fc397e2b6f08d = ()=>{
    return (0, $5uXOq.useContext)($7c7af48337b91c7a$export$efb0d1c8cbaac647);
};

});


parcelRegister("kuusl", function(module, exports) {

$parcel$export(module.exports, "AnnotationHoverContext", () => $b758d405b6d3becf$export$b3db0feb20552fc3);
$parcel$export(module.exports, "useAnnotationHoverContext", () => $b758d405b6d3becf$export$a02bfcbbbf920306);
$parcel$export(module.exports, "useAnnotationHoverDispatch", () => $b758d405b6d3becf$export$c288883964405c82);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $b758d405b6d3becf$var$AnnotationHoverStateContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isWithinRange: false
});
const $b758d405b6d3becf$var$AnnotationHoverDispatchContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    cancelTimeout: ()=>{},
    initiateTimeout: ()=>{},
    setIsWithinRange: ()=>{}
});
const $b758d405b6d3becf$export$b3db0feb20552fc3 = ({ children: children })=>{
    const [isWithinRange, setIsWithinRange] = (0, $5uXOq.useState)(false);
    const timeoutHandler = (0, $5uXOq.useRef)();
    const cancelTimeout = (0, $5uXOq.useCallback)(()=>{
        if (timeoutHandler) clearTimeout(timeoutHandler.current);
    }, [
        timeoutHandler
    ]);
    const initiateTimeout = (0, $5uXOq.useCallback)(()=>{
        if (isWithinRange) timeoutHandler.current = setTimeout(()=>{
            setIsWithinRange(false);
        }, 500);
    }, [
        isWithinRange
    ]);
    const stateData = (0, $5uXOq.useMemo)(()=>({
            isWithinRange: isWithinRange
        }), [
        isWithinRange
    ]);
    const dispatchData = (0, $5uXOq.useMemo)(()=>({
            cancelTimeout: cancelTimeout,
            initiateTimeout: initiateTimeout,
            setIsWithinRange: setIsWithinRange
        }), [
        cancelTimeout,
        initiateTimeout,
        setIsWithinRange
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($b758d405b6d3becf$var$AnnotationHoverStateContext.Provider, {
        value: stateData,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($b758d405b6d3becf$var$AnnotationHoverDispatchContext.Provider, {
            value: dispatchData,
            children: children
        })
    });
};
const $b758d405b6d3becf$export$a02bfcbbbf920306 = ()=>{
    return (0, $5uXOq.useContext)($b758d405b6d3becf$var$AnnotationHoverStateContext);
};
const $b758d405b6d3becf$export$c288883964405c82 = ()=>{
    return (0, $5uXOq.useContext)($b758d405b6d3becf$var$AnnotationHoverDispatchContext);
};

});


parcelRegister("iatcV", function(module, exports) {

$parcel$export(module.exports, "SelectionRangeValidator", () => $d73a3647df6a8131$export$74435b85e23b84d9);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jWe7H = parcelRequire("jWe7H");

var $bZQ2Q = parcelRequire("bZQ2Q");

var $fCNtA = parcelRequire("fCNtA");
const $d73a3647df6a8131$export$74435b85e23b84d9 = (props)=>{
    const { selectionComponent: selectionComponent, rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent } = props;
    const actions = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    const [type, range, draftRange, clearRange] = (0, $jWe7H.useUserSelectionRange)({
        rendererRef: rendererRef
    });
    const selectionRange = type === 'selection' ? range : null;
    if (!selectionRange && !draftRange) return null;
    const documentPosition = actions.getPositionFromRange(range);
    // This property is drilled down to consumers when a new range is selected to test it's validity
    let isAnnotationAllowedOnRange = false;
    try {
        isAnnotationAllowedOnRange = documentPosition && actions.isValidAnnotationPosition(documentPosition);
    } catch  {
        isAnnotationAllowedOnRange = false;
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bZQ2Q.SelectionInlineCommentMounter), {
        range: selectionRange,
        draftRange: draftRange,
        wrapperDOM: rendererRef,
        component: selectionComponent,
        onClose: clearRange,
        documentPosition: documentPosition,
        isAnnotationAllowed: isAnnotationAllowedOnRange,
        applyAnnotation: actions.applyAnnotation.bind(actions),
        generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
        createAnalyticsEvent: createAnalyticsEvent
    });
};
$d73a3647df6a8131$export$74435b85e23b84d9.displayName = 'SelectionRangeValidator';

});
parcelRegister("jWe7H", function(module, exports) {

$parcel$export(module.exports, "useUserSelectionRange", () => $cd0f4805a1ba9aff$export$47201332e612f5a4);

var $5uXOq = parcelRequire("5uXOq");

var $2EsbE = parcelRequire("2EsbE");

var $jqO24 = parcelRequire("jqO24");

var $cMPbW = parcelRequire("cMPbW");

var $VSDnB = parcelRequire("VSDnB");
const $cd0f4805a1ba9aff$export$47201332e612f5a4 = (props)=>{
    const { rendererRef: { current: rendererDOM } } = props;
    const selectionTimeoutRef = (0, $5uXOq.useRef)();
    const { clearSelectionRange: clearSelectionRange, setSelectionRange: setSelectionRange } = (0, $2EsbE.useAnnotationRangeDispatch)();
    const { range: range, type: type, selectionDraftRange: selectionDraftRange } = (0, $2EsbE.useAnnotationRangeState)();
    const lastRangeRef = (0, $5uXOq.useRef)(null);
    const onSelectionChange = (0, $5uXOq.useCallback)((event)=>{
        if ((0, $VSDnB.fg)('platform_renderer_triple_click_selects_paragraph')) {
            if (selectionTimeoutRef.current) clearTimeout(selectionTimeoutRef.current);
            selectionTimeoutRef.current = setTimeout(()=>{
                const sel = document.getSelection();
                if (!sel || sel.type !== 'Range' || sel.rangeCount !== 1) {
                    lastRangeRef.current = null; // Clear last range if selection is invalid
                    return;
                }
                let _range = sel.getRangeAt(0);
                // Skip if the selection hasn’t changed
                if (lastRangeRef.current && _range.compareBoundaryPoints(Range.START_TO_START, lastRangeRef.current) === 0 && _range.compareBoundaryPoints(Range.END_TO_END, lastRangeRef.current) === 0) return;
                if (rendererDOM && (0, $jqO24.isRangeInsideOfRendererContainer)(rendererDOM, _range)) {
                    const { startContainer: startContainer, endContainer: endContainer } = _range;
                    const isTripleClick = endContainer.nodeType !== Node.TEXT_NODE;
                    if (isTripleClick) {
                        let p = startContainer;
                        while(p && p.nodeName !== 'P' && p !== rendererDOM)p = p.parentNode;
                        if (p && p.nodeName === 'P' && p instanceof Element) {
                            const range = document.createRange();
                            range.selectNodeContents(p);
                            sel.removeAllRanges();
                            sel.addRange(range);
                            _range = sel.getRangeAt(0);
                        }
                    }
                    setSelectionRange(_range.cloneRange());
                    lastRangeRef.current = _range;
                }
            }, 100);
        } else {
            if (selectionTimeoutRef.current) clearTimeout(selectionTimeoutRef.current);
            selectionTimeoutRef.current = setTimeout(()=>{
                const sel = document.getSelection();
                if (!sel || sel.type !== 'Range' || sel.rangeCount !== 1) return;
                const _range = sel.getRangeAt(0);
                if (rendererDOM && (0, $jqO24.isRangeInsideOfRendererContainer)(rendererDOM, _range)) {
                    const { startContainer: startContainer, endContainer: endContainer, commonAncestorContainer: commonAncestorContainer } = _range;
                    const parentNode = startContainer.parentNode;
                    // ED-23493
                    // On triple-click in Chrome and Safari, the native Selection API's range has endContainer as a non-text node
                    // and commonAncestorContainer as root level div.ak-renderer-document when the node is followed by div or hr.
                    // Triple clicks are the only case that can cause the endContainer to be a non-text node
                    // Same check for highlight range logic in confluence/next/packages/comments-util/src/domUtils.ts Line 180
                    const isTripleClick = endContainer.nodeType !== Node.TEXT_NODE;
                    // isAnnotationAllowedOnRange range validation is checking if the parent container is root element and disable the comment if it is.
                    // platform/packages/editor/renderer/src/steps/index.ts Line 180
                    // This workaround ensures the endContainer is set to a text node when endContainer is non-text and the parent container is the root element
                    if (isTripleClick && commonAncestorContainer && commonAncestorContainer.nodeType === Node.ELEMENT_NODE && // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    (0, $cMPbW.isRoot)(commonAncestorContainer) && parentNode?.nodeName === 'P' // ignore if the parent node is strong, em, etc.
                    ) {
                        const lastChild = parentNode?.lastChild && parentNode?.lastChild?.nodeType === Node.TEXT_NODE ? parentNode?.lastChild : parentNode?.lastChild?.childNodes[0];
                        _range.setEnd(lastChild, lastChild.length || 0);
                    }
                    setSelectionRange(_range.cloneRange());
                }
            }, 250);
        }
    }, [
        rendererDOM,
        setSelectionRange
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!document || !rendererDOM) return;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('selectionchange', onSelectionChange);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('selectionchange', onSelectionChange);
            clearSelectionRange();
        };
    }, [
        rendererDOM,
        onSelectionChange,
        clearSelectionRange
    ]);
    return [
        type,
        range,
        selectionDraftRange,
        clearSelectionRange
    ];
};

});
parcelRegister("jqO24", function(module, exports) {

$parcel$export(module.exports, "isRangeInsideOfRendererContainer", () => $8373eb69e5c4287b$export$90ee8f2d9317f430);
/** Exists in its own module to allow mocking in unit tests */ const $8373eb69e5c4287b$export$90ee8f2d9317f430 = (rendererDOM, range)=>{
    const sourceRange = document.createRange();
    sourceRange.selectNode(rendererDOM);
    const isSelectionStartsAfterRenderer = range.compareBoundaryPoints(Range.START_TO_START, sourceRange) === 1;
    const isSelectionStartsBeforeRenderer = range.compareBoundaryPoints(Range.START_TO_END, sourceRange) === 1;
    const isSelectionEndsAfterRenderer = range.compareBoundaryPoints(Range.END_TO_END, sourceRange) === 1;
    return isSelectionStartsAfterRenderer && isSelectionStartsBeforeRenderer && !isSelectionEndsAfterRenderer;
};

});


parcelRegister("bZQ2Q", function(module, exports) {

$parcel$export(module.exports, "SelectionInlineCommentMounter", () => $7e4c7bbc0d380e24$export$ca7741472ed8ba00);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bXrHm = parcelRequire("bXrHm");

var $88i6h = parcelRequire("88i6h");

var $VSDnB = parcelRequire("VSDnB");

var $fVTp8 = parcelRequire("fVTp8");

var $dWAZk = parcelRequire("dWAZk");

var $gkwXh = parcelRequire("gkwXh");

var $4apTl = parcelRequire("4apTl");

var $fCNtA = parcelRequire("fCNtA");

var $jw62c = parcelRequire("jw62c");

var $2EsbE = parcelRequire("2EsbE");
const $7e4c7bbc0d380e24$export$ca7741472ed8ba00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>{
    const { component: Component, range: range, draftRange: draftRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
    const { promoteSelectionToDraft: promoteSelectionToDraft, clearSelectionDraft: clearSelectionDraft } = (0, $2EsbE.useAnnotationRangeDispatch)();
    const { selectionDraftDocumentPosition: selectionDraftDocumentPosition } = (0, $2EsbE.useAnnotationRangeState)();
    const actions = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    const { isDrafting: isDrafting, draftId: draftId } = (0, $jw62c.useAnnotationManagerState)();
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $jw62c.useAnnotationManagerDispatch)();
    const inlineNodeTypes = (0, $5uXOq.useMemo)(()=>{
        if ((0, $VSDnB.fg)('annotations_defensive_node_name_calculations')) {
            if (!actions.isRangeAnnotatable(range)) return undefined;
            return (0, $4apTl.getRendererRangeInlineNodeNames)({
                pos: documentPosition,
                actions: actions
            });
        } else {
            if (!(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
            if (actions.isValidAnnotationRange(range)) return (0, $4apTl.getRendererRangeInlineNodeNames)({
                pos: documentPosition,
                actions: actions
            });
            else return undefined;
        }
    }, [
        documentPosition,
        actions,
        range
    ]);
    const onCreateCallback = (0, $5uXOq.useCallback)((annotationId)=>{
        // We want to support creation on a documentPosition if the user is only using ranges
        // but we want to prioritize draft positions if they are being used by consumers
        const positionToAnnotate = selectionDraftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation) {
            // TODO: EDITOR-595 - This analytic event is temporary and should be removed once the following issue
            // has been identified and fixed: https://atlassian.slack.com/archives/C08JK0WSCH5/p1745902609966999
            if (createAnalyticsEvent && (0, $VSDnB.fg)('platform_renderer_annotations_create_debug_logging')) createAnalyticsEvent({
                action: 'failed',
                actionSubject: 'applyAnnotation',
                actionSubjectId: 'inlineCommentFailureReason',
                attributes: {
                    reason: 'Annotation Position invalid',
                    draftDocumentPosition: selectionDraftDocumentPosition,
                    documentPosition: documentPosition,
                    applyAnnotation: !!applyAnnotation,
                    isDraftPositionFixEnabled: true
                },
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
            }).fire((0, $dWAZk.FabricChannel).editor);
            return false;
        }
        if ((0, $VSDnB.fg)('platform_renderer_annotations_create_debug_logging')) actions._setDebugLogging(true);
        // Evaluate position validity when the user commits the position to be annotated
        const isCreateAllowedOnPosition = actions.isValidAnnotationPosition(positionToAnnotate);
        if (!isCreateAllowedOnPosition) return false;
        const annotation = {
            annotationId: annotationId,
            annotationType: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
        };
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $gkwXh.ACTION).INSERTED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {
                inlineNodeNames: inlineNodeTypes
            },
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK
        }).fire((0, $dWAZk.FabricChannel).editor);
        if ((0, $VSDnB.fg)('platform_renderer_annotations_create_debug_logging')) {
            const result = applyAnnotation(positionToAnnotate, annotation);
            actions._setDebugLogging(false);
            return result;
        } else return applyAnnotation(positionToAnnotate, annotation);
    }, [
        actions,
        documentPosition,
        applyAnnotation,
        createAnalyticsEvent,
        inlineNodeTypes,
        selectionDraftDocumentPosition
    ]);
    const createIndexCallback = (0, $5uXOq.useCallback)(()=>{
        if (!documentPosition || !generateIndexMatch) return false;
        const result = generateIndexMatch(documentPosition);
        if (!result) return false;
        return result;
    }, [
        documentPosition,
        generateIndexMatch
    ]);
    const applyDraftModeCallback = (0, $5uXOq.useCallback)((options)=>{
        if (!documentPosition || !isAnnotationAllowed) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $gkwXh.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    inlineNodeNames: inlineNodeTypes
                },
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK
            }).fire((0, $dWAZk.FabricChannel).editor);
            return false;
        }
        promoteSelectionToDraft(documentPosition);
        if (createAnalyticsEvent) {
            const uniqueAnnotationsInRange = range ? actions.getAnnotationsByPosition(range) : [];
            createAnalyticsEvent({
                action: (0, $gkwXh.ACTION).OPENED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: uniqueAnnotationsInRange.length,
                    inlineNodeNames: inlineNodeTypes
                }
            }).fire((0, $dWAZk.FabricChannel).editor);
        }
        window.requestAnimationFrame(()=>{
            if (options.keepNativeSelection) (0, $fVTp8.updateWindowSelectionAroundDraft)(documentPosition);
            else {
                const sel = window.getSelection();
                if (sel) sel.removeAllRanges();
            }
        });
        const positionToAnnotate = selectionDraftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation || !options.annotationId) return false;
        const annotation = {
            annotationId: options.annotationId,
            annotationType: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
        };
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        documentPosition,
        isAnnotationAllowed,
        createAnalyticsEvent,
        applyAnnotation,
        actions,
        range,
        inlineNodeTypes,
        promoteSelectionToDraft,
        selectionDraftDocumentPosition
    ]);
    const removeDraftModeCallback = (0, $5uXOq.useCallback)(()=>{
        clearSelectionDraft();
        const sel = window.getSelection();
        if (sel) sel.removeAllRanges();
    }, [
        clearSelectionDraft
    ]);
    const onCloseCallback = (0, $5uXOq.useCallback)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $gkwXh.ACTION).CLOSED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
            attributes: {
                inlineNodeNames: inlineNodeTypes
            }
        }).fire((0, $dWAZk.FabricChannel).editor);
        removeDraftModeCallback();
        onCloseProps();
    }, [
        onCloseProps,
        removeDraftModeCallback,
        createAnalyticsEvent,
        inlineNodeTypes
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $VSDnB.fg)('platform_editor_comments_api_manager')) {
            const allowAnnotation = ()=>{
                if (isDrafting) return false;
                return isAnnotationAllowed;
            };
            annotationManager?.hook('allowAnnotation', allowAnnotation);
            return ()=>{
                annotationManager?.unhook('allowAnnotation', allowAnnotation);
            };
        }
    }, [
        annotationManager,
        isAnnotationAllowed,
        isDrafting
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $VSDnB.fg)('platform_editor_comments_api_manager')) {
            const startDraft = ()=>{
                if (isDrafting) return {
                    success: false,
                    reason: 'draft-in-progress'
                };
                const id = (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))();
                const result = applyDraftModeCallback({
                    annotationId: id,
                    keepNativeSelection: false
                });
                if (!result) return {
                    success: false,
                    reason: 'invalid-range'
                };
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: true,
                        draftId: id,
                        draftActionResult: result
                    }
                });
                dispatch({
                    type: 'resetSelectedAnnotation'
                });
                return {
                    success: true,
                    // We cannot get a ref to the target element here
                    // because the draft is not yet applied to the DOM
                    targetElement: undefined,
                    inlineNodeTypes: result.inlineNodeTypes ?? [],
                    actionResult: {
                        step: result.step,
                        doc: result.doc,
                        inlineNodeTypes: result.inlineNodeTypes,
                        targetNodeType: result.targetNodeType,
                        originalSelection: result.originalSelection,
                        numMatches: result.numMatches,
                        matchIndex: result.matchIndex,
                        pos: result.pos
                    }
                };
            };
            annotationManager?.hook('startDraft', startDraft);
            return ()=>{
                annotationManager?.unhook('startDraft', startDraft);
            };
        }
    }, [
        annotationManager,
        isDrafting,
        applyDraftModeCallback,
        actions,
        range,
        dispatch
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $VSDnB.fg)('platform_editor_comments_api_manager')) {
            const clearDraft = ()=>{
                if (!isDrafting) return {
                    success: false,
                    reason: 'draft-not-started'
                };
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: false,
                        draftId: undefined,
                        draftActionResult: undefined
                    }
                });
                onCloseCallback();
                return {
                    success: true
                };
            };
            annotationManager?.hook('clearDraft', clearDraft);
            return ()=>{
                annotationManager?.unhook('clearDraft', clearDraft);
            };
        }
    }, [
        annotationManager,
        onCloseCallback,
        isDrafting,
        dispatch
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $VSDnB.fg)('platform_editor_comments_api_manager')) {
            const applyDraft = (id)=>{
                if (!isDrafting || !draftId) return {
                    success: false,
                    reason: 'draft-not-started'
                };
                const result = onCreateCallback(id);
                if (!result) return {
                    success: false,
                    reason: 'range-no-longer-exists'
                };
                onCloseCallback();
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: false,
                        draftId: undefined,
                        draftActionResult: undefined
                    }
                });
                dispatch({
                    type: 'updateAnnotation',
                    data: {
                        id: id,
                        selected: true,
                        markState: (0, $88i6h.AnnotationMarkStates).ACTIVE
                    }
                });
                return {
                    success: true,
                    targetElement: undefined,
                    actionResult: id !== draftId ? {
                        step: result.step,
                        doc: result.doc,
                        inlineNodeTypes: result.inlineNodeTypes,
                        targetNodeType: result.targetNodeType,
                        originalSelection: result.originalSelection,
                        numMatches: result.numMatches,
                        matchIndex: result.matchIndex,
                        pos: result.pos
                    } : undefined
                };
            };
            annotationManager?.hook('applyDraft', applyDraft);
            return ()=>{
                annotationManager?.unhook('applyDraft', applyDraft);
            };
        }
    }, [
        annotationManager,
        onCreateCallback,
        onCloseCallback,
        isDrafting,
        draftId,
        dispatch
    ]);
    // Please remove this NOP function when the flag platform_editor_comments_api_manager is removed.
    const nop = (0, $5uXOq.useMemo)(()=>()=>false, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        range: range,
        draftRange: draftRange,
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        wrapperDOM: wrapperDOM.current,
        isAnnotationAllowed: isAnnotationAllowed,
        onClose: (0, $VSDnB.fg)('platform_editor_comments_api_manager') ? nop : onCloseCallback,
        onCreate: (0, $VSDnB.fg)('platform_editor_comments_api_manager') ? nop : onCreateCallback,
        getAnnotationIndexMatch: createIndexCallback,
        applyDraftMode: (0, $VSDnB.fg)('platform_editor_comments_api_manager') ? nop : applyDraftModeCallback,
        removeDraftMode: (0, $VSDnB.fg)('platform_editor_comments_api_manager') ? nop : removeDraftModeCallback,
        inlineNodeTypes: inlineNodeTypes
    });
});

});



parcelRegister("joddd", function(module, exports) {

$parcel$export(module.exports, "useLoadAnnotations", () => $9aa08f3110a2b008$export$39f7c1a861a0d41c);

var $5uXOq = parcelRequire("5uXOq");

var $dEtqo = parcelRequire("dEtqo");

var $VSDnB = parcelRequire("VSDnB");

var $iYAgE = parcelRequire("iYAgE");

var $fCNtA = parcelRequire("fCNtA");

var $jw62c = parcelRequire("jw62c");
const $9aa08f3110a2b008$export$39f7c1a861a0d41c = ({ adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete })=>{
    const actions = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    const providers = (0, $5uXOq.useContext)((0, $iYAgE.ProvidersContext));
    const { dispatch: dispatch } = (0, $jw62c.useAnnotationManagerDispatch)();
    (0, $5uXOq.useEffect)(()=>{
        if (!providers) return;
        const { inlineComment: { getState: inlineCommentGetState, updateSubscriber: updateSubscriberInlineComment } } = providers;
        const annotations = actions.getAnnotationMarks();
        // we don't want to request integrators for state with an empty list of ids.
        if (!annotations.length) {
            if (!isNestedRender && (0, $VSDnB.fg)('use_comments_data_annotation_updater')) // inlineCommentGetState handles empty lists gracefully. It has a side-effect of clearing state, which is why this call is needed
            inlineCommentGetState([], isNestedRender);
            onLoadComplete && onLoadComplete({
                numberOfUnresolvedInlineComments: 0
            });
            return;
        }
        const ids = annotations.map((mark)=>mark.attrs.id);
        const cb = (data)=>{
            if (!updateSubscriberInlineComment) return;
            const payload = data.reduce((acc, value)=>({
                    ...acc,
                    [value.id]: value
                }), {});
            if ((0, $VSDnB.fg)('platform_editor_comments_api_manager')) dispatch({
                type: 'loadAnnotation',
                data: Object.keys(payload).map((id)=>({
                        id: id,
                        markState: payload[id].state ?? undefined
                    }))
            });
            else updateSubscriberInlineComment.emit((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_STATE, payload);
            onLoadComplete && onLoadComplete({
                numberOfUnresolvedInlineComments: data.filter((data)=>data.state === 'active').length
            });
        };
        inlineCommentGetState(ids, isNestedRender).then(cb);
    }, [
        actions,
        providers,
        adfDocument,
        isNestedRender,
        onLoadComplete,
        dispatch
    ]);
};

});


parcelRegister("1SqDw", function(module, exports) {

$parcel$export(module.exports, "ValidationContext", () => $a1d6c169ab0ab071$export$d452675449e81987);
$parcel$export(module.exports, "ValidationContextProvider", () => $a1d6c169ab0ab071$export$5b655fe45447a548);

var $5uXOq = parcelRequire("5uXOq");
const $a1d6c169ab0ab071$export$d452675449e81987 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $a1d6c169ab0ab071$export$5b655fe45447a548 = $a1d6c169ab0ab071$export$d452675449e81987.Provider;

});


parcelRegister("2SZph", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb082cddb2d59aba$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/prefer-primitives, @atlaskit/design-system/consistent-css-prop-usage */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");


var $5uXOq = parcelRequire("5uXOq");

var $i8Zwf = parcelRequire("i8Zwf");

var $fAZXL = parcelRequire("fAZXL");

var $edXiX = parcelRequire("edXiX");
var $4ceoy = parcelRequire("4ceoy");

var $l8Gxi = parcelRequire("l8Gxi");

var $eOOFp = parcelRequire("eOOFp");
const $fb082cddb2d59aba$var$useMultiBodiedExtensionActions = ({ updateActiveChild: updateActiveChild, children: children })=>{
    const actions = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        return {
            changeActive (index) {
                return updateActiveChild(index);
            },
            addChild () {
                return false;
            },
            getChildrenCount () {
                return children ? children?.length : 0;
            },
            removeChild (index) {
                return false;
            },
            updateParameters (parameters) {
                return false;
            },
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            getChildren () {
                return [];
            },
            getChildrenContainer () {
                return null;
            }
        };
    }, [
        updateActiveChild,
        children
    ]);
    return actions;
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $fb082cddb2d59aba$var$navigationCssExtended = /*#__PURE__*/ (0, $f8Sb3.css)((0, $edXiX.sharedMultiBodiedExtensionStyles).mbeNavigation, ";margin-left:0!important;margin-right:0!important;.mbe-add-tab-button,.mbe-remove-tab{display:none;}");
const $fb082cddb2d59aba$var$MultiBodiedExtension = (props)=>{
    const { children: children, layout: layout = 'default', path: path = [] } = props;
    const [activeChildIndex, setActiveChildIndex] = (0, $5uXOq.useState)(0);
    const removeOverflow = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children)// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child) ? child.props.nodeType === 'table' : false).every(Boolean);
    const overflowContainerClass = !removeOverflow ? (0, $l8Gxi.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER : '';
    const updateActiveChild = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((index)=>{
        if (typeof index !== 'number') {
            // Ignored via go/ees007
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO: Make sure we log this somewhere if this happens
            setActiveChildIndex(0);
            return false;
        }
        setActiveChildIndex(index);
        return true;
    }, [
        setActiveChildIndex
    ]);
    const actions = $fb082cddb2d59aba$var$useMultiBodiedExtensionActions({
        updateActiveChild: updateActiveChild,
        children: children
    });
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    const containerCssExtended = /*#__PURE__*/ (0, $f8Sb3.css)((0, $edXiX.sharedMultiBodiedExtensionStyles).mbeExtensionContainer, ";.ak-renderer-extension{margin-top:0!important;}[data-layout='full-width'],[data-layout='wide']{.multiBodiedExtension-navigation{border-right:3px solid ", `var(--ds-border, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`, "!important;}}.multiBodiedExtension--frames>[data-extension-frame='true']:nth-of-type(", activeChildIndex + 1, "){", (0, $edXiX.sharedMultiBodiedExtensionStyles).extensionFrameContent, " margin-left:0;margin-right:0;}");
    const isTopLevel = path.length < 1;
    const centerAlignClass = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) ? (0, $l8Gxi.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    function renderMbeContent(width) {
        return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $l8Gxi.RendererCssClassName).EXTENSION} ${centerAlignClass} ${overflowContainerClass}`,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                width: isTopLevel ? (0, $eOOFp.calcBreakoutWidth)(layout, width) : '100%'
            },
            "data-layout": layout
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("nav", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "multiBodiedExtension-navigation",
            css: $fb082cddb2d59aba$var$navigationCssExtended,
            "data-testid": "multiBodiedExtension-navigation"
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fAZXL.default), {
            ...props,
            actions: actions,
            type: "multiBodiedExtension"
        }, ({ result: result })=>{
            try {
                if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(result)) // Return the content directly if it's a valid JSX.Element
                return (0, $i8Zwf.renderExtension)(result, layout, {
                    isTopLevel: path.length < 1
                });
            } catch (e) {
            /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
            // Always return default content if anything goes wrong
            return (0, $i8Zwf.renderExtension)(children, layout, {
                isTopLevel: path.length < 1
            });
        })), /*#__PURE__*/ (0, $f8Sb3.jsx)("article", {
            "data-testid": "multiBodiedExtension--frames",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `multiBodiedExtension--frames`
        }, children));
    }
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("section", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "multiBodiedExtension--container",
        css: containerCssExtended,
        "data-testid": "multiBodiedExtension--container",
        "data-active-child-index": activeChildIndex,
        "data-layout": layout
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4ceoy.WidthConsumer), null, ({ width: width })=>renderMbeContent(width)));
};
var $fb082cddb2d59aba$export$2e2bcd8739ae039 = $fb082cddb2d59aba$var$MultiBodiedExtension;

});
parcelRegister("edXiX", function(module, exports) {

$parcel$export(module.exports, "removeMarginsAndBorder", () => $a5dc814f02ba73ab$export$8df0393dc2d5d656);
$parcel$export(module.exports, "sharedMultiBodiedExtensionStyles", () => $a5dc814f02ba73ab$export$9c7196ca47f67390);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
function $a5dc814f02ba73ab$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Wraps the navigation bar and extensionFrames
const $a5dc814f02ba73ab$var$mbeExtensionContainer = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    background: 'transparent !important',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'padding:': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        left: `${"var(--ds-space-100, 8px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        right: `${"var(--ds-space-100, 8px)"} !important`
    },
    paddingBottom: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-padding': {
        paddingBottom: 0
    },
    position: 'relative',
    verticalAlign: 'middle',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.multiBodiedExtension-handler-result': {
        marginLeft: "var(--ds-space-100, 8px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".multiBodiedExtension-content-dom-wrapper > [data-extension-frame='true'], .multiBodiedExtension--frames > [data-extension-frame='true']": {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.multiBodiedExtension-content-dom-wrapper, .multiBodiedExtension--frames': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[data-extension-frame='true'] > :not(style):first-child, [data-extension-frame='true'] > style:first-child + *": {
            marginTop: 0
        }
    }
});
const $a5dc814f02ba73ab$var$mbeNavigation = {
    name: "2ubief",
    styles: "border-top-left-radius:var(--ds-border-radius, 3px);border-top-right-radius:var(--ds-border-radius, 3px);user-select:none;-webkit-user-modify:read-only;border-bottom:none !important;background:var(--ds-surface, white);margin-left:var(--ds-space-100, 8px);margin-right:var(--ds-space-100, 8px);&.remove-margins{margin:var(--ds-space-negative-100, -8px);}&.remove-border{border:none;}"
};
const $a5dc814f02ba73ab$var$extensionFrameContent = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    padding: `${"var(--ds-space-100, 8px)"} !important`,
    display: 'block',
    minHeight: '100px',
    background: 'transparent',
    borderBottomLeftRadius: "var(--ds-border-radius, 3px)",
    borderBottomRightRadius: "var(--ds-border-radius, 3px)",
    marginLeft: "var(--ds-space-100, 8px)",
    marginRight: "var(--ds-space-100, 8px)",
    cursor: 'initial',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.pm-table-with-controls': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginLeft: `${"var(--ds-space-150, 12px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        paddingRight: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.bodiedExtensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.extensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-100, 8px)"} !important`
    }
});
const $a5dc814f02ba73ab$export$8df0393dc2d5d656 = {
    name: "c620zi",
    styles: "margin-left:0;margin-right:0;border:none"
};
const $a5dc814f02ba73ab$export$9c7196ca47f67390 = {
    mbeExtensionContainer: $a5dc814f02ba73ab$var$mbeExtensionContainer,
    mbeNavigation: $a5dc814f02ba73ab$var$mbeNavigation,
    extensionFrameContent: $a5dc814f02ba73ab$var$extensionFrameContent
};

});


parcelRegister("bQeYo", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5dc6f3b113435da$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/prefer-primitives, @atlaskit/design-system/consistent-css-prop-usage */ /**
                                                                                                                   * @jsxRuntime classic
                                                                                                                   * @jsx jsx
                                                                                                                   * @jsxFrag
                                                                                                                   */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $5uXOq = parcelRequire("5uXOq");

var $4ceoy = parcelRequire("4ceoy");

var $l8Gxi = parcelRequire("l8Gxi");

var $eOOFp = parcelRequire("eOOFp");

var $dkSnq = parcelRequire("dkSnq");

var $e4NNv = parcelRequire("e4NNv");
function $c5dc6f3b113435da$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c5dc6f3b113435da$var$containerStyles = {
    name: "utcqjk",
    styles: "&:first-child > .ak-renderer-extension{margin-top:0;}"
};
const $c5dc6f3b113435da$var$MultiBodiedExtensionChildrenContainer = ({ children: children })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("article", {
        "data-testid": "multiBodiedExtension--frames"
    }, children);
};
const $c5dc6f3b113435da$var$MultiBodiedExtensionNavigation = ({ children: children })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("nav", {
        "data-testid": "multiBodiedExtension-navigation"
    }, children);
};
const $c5dc6f3b113435da$var$MultiBodiedExtensionWrapper = ({ width: width, path: path, layout: layout, children: children })=>{
    const isTopLevel = path.length < 1;
    const centerAlignClass = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) ? (0, $l8Gxi.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    // This hierarchy is copied from regular extension (see extension.tsx)
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $l8Gxi.RendererCssClassName).EXTENSION} ${centerAlignClass}`,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            width: isTopLevel ? (0, $eOOFp.calcBreakoutWidth)(layout, width) : '100%'
        },
        "data-layout": layout,
        "data-testid": "multiBodiedExtension--wrapper"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: `${(0, $l8Gxi.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`
    }, children));
};
const $c5dc6f3b113435da$var$MultiBodiedExtension = (props)=>{
    const { children: children, layout: layout = 'default', path: path = [], parameters: parameters, extensionType: extensionType, extensionKey: extensionKey, content: content, marks: marks, localId: localId } = props;
    const [activeChildIndex, setActiveChildIndex] = (0, $5uXOq.useState)(0);
    const { loading: loading, extensionContext: extensionContext } = (0, $e4NNv.useMultiBodiedExtensionContext)({
        extensionType: extensionType,
        extensionKey: extensionKey
    });
    const actions = (0, $dkSnq.useMultiBodiedExtensionActions)({
        updateActiveChild: setActiveChildIndex,
        children: children,
        childrenContainer: /*#__PURE__*/ (0, $f8Sb3.jsx)($c5dc6f3b113435da$var$MultiBodiedExtensionChildrenContainer, null, children),
        allowBodiedOverride: extensionContext?.privateProps?.__allowBodiedOverride
    });
    const renderContent = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(()=>{
        if (loading || !extensionContext) return null;
        const { NodeRenderer: NodeRenderer, privateProps: privateProps } = extensionContext;
        const fragmentLocalId = marks?.find((m)=>m.type.name === 'fragment')?.attrs?.localId;
        const node = {
            type: 'multiBodiedExtension',
            extensionKey: extensionKey,
            extensionType: extensionType,
            parameters: parameters,
            content: content,
            localId: localId,
            fragmentLocalId: fragmentLocalId
        };
        if (privateProps.__allowBodiedOverride) return /*#__PURE__*/ (0, $f8Sb3.jsx)(NodeRenderer, {
            node: node,
            actions: actions
        });
        else return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, $f8Sb3.jsx)($c5dc6f3b113435da$var$MultiBodiedExtensionNavigation, null, /*#__PURE__*/ (0, $f8Sb3.jsx)(NodeRenderer, {
            node: node,
            actions: actions
        })), /*#__PURE__*/ (0, $f8Sb3.jsx)($c5dc6f3b113435da$var$MultiBodiedExtensionChildrenContainer, null, children));
    }, [
        loading,
        extensionContext,
        marks,
        extensionKey,
        extensionType,
        parameters,
        content,
        localId,
        actions,
        children
    ]);
    // make the frame visible
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    const containerActiveFrameStyles = /*#__PURE__*/ (0, $f8Sb3.css)("& [data-extension-frame='true']:nth-of-type(", activeChildIndex + 1, "){display:block;}");
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("section", {
        css: [
            $c5dc6f3b113435da$var$containerStyles,
            containerActiveFrameStyles
        ],
        "data-testid": "multiBodiedExtension--container",
        "data-multiBodiedExtension-container": true,
        "data-active-child-index": activeChildIndex,
        "data-layout": layout
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4ceoy.WidthConsumer), null, ({ width: width })=>/*#__PURE__*/ (0, $f8Sb3.jsx)($c5dc6f3b113435da$var$MultiBodiedExtensionWrapper, {
            layout: layout,
            width: width,
            path: path
        }, renderContent())));
};
var $c5dc6f3b113435da$export$2e2bcd8739ae039 = $c5dc6f3b113435da$var$MultiBodiedExtension;

});
parcelRegister("dkSnq", function(module, exports) {

$parcel$export(module.exports, "useMultiBodiedExtensionActions", () => $ef5b9c26278248e6$export$3c7139d93ecb4f1f);

var $5uXOq = parcelRequire("5uXOq");
const $ef5b9c26278248e6$export$3c7139d93ecb4f1f = ({ updateActiveChild: updateActiveChild, children: children, allowBodiedOverride: allowBodiedOverride, childrenContainer: childrenContainer })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        return {
            changeActive (index) {
                if (!Number.isInteger(index)) return false;
                updateActiveChild(index);
                return true;
            },
            addChild () {
                return false;
            },
            getChildrenCount () {
                return children && Array.isArray(children) ? children.length : 0;
            },
            removeChild (_index) {
                return false;
            },
            updateParameters (_parameters) {
                return false;
            },
            getChildren () {
                return [];
            },
            getChildrenContainer () {
                return allowBodiedOverride ? childrenContainer : null;
            }
        };
    }, [
        updateActiveChild,
        children,
        allowBodiedOverride,
        childrenContainer
    ]);
};

});

parcelRegister("e4NNv", function(module, exports) {

$parcel$export(module.exports, "useMultiBodiedExtensionContext", () => $9b12fab9f9c859c0$export$e55394818db35473);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $gnH2s = parcelRequire("gnH2s");

var $9S8fM = parcelRequire("9S8fM");
const $9b12fab9f9c859c0$export$e55394818db35473 = ({ extensionType: extensionType, extensionKey: extensionKey })=>{
    const isMounted = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(true);
    const localGetNodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>(0, $8QpSo.default)((0, $gnH2s.getNodeRenderer)), []);
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [privateProps, setPrivateProps] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState();
    const providerPromise = (0, $9S8fM.useProvider)('extensionProvider');
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        if (providerPromise) providerPromise.then((p)=>{
            if (isMounted.current) setProvider(p);
            return (0, $gnH2s.getExtensionModuleNodePrivateProps)(p, extensionType, extensionKey);
        }).then((pr)=>{
            if (isMounted.current) setPrivateProps(pr);
        });
    }, [
        providerPromise,
        extensionType,
        extensionKey
    ]);
    const NodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        if (!provider) return null;
        return localGetNodeRenderer(provider, extensionType, extensionKey);
    }, [
        provider,
        extensionType,
        extensionKey,
        localGetNodeRenderer
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        if (!provider || !NodeRenderer || !privateProps) return {
            extensionContext: null,
            loading: true
        };
        return {
            extensionContext: {
                NodeRenderer: NodeRenderer,
                privateProps: privateProps
            },
            loading: false
        };
    }, [
        provider,
        NodeRenderer,
        privateProps
    ]);
};

});


parcelRegister("cOnYv", function(module, exports) {

$parcel$export(module.exports, "default", () => $adf8f8318644b4cb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");
function $adf8f8318644b4cb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $adf8f8318644b4cb$var$containerCSSOld = {
    name: "1e1nv5z",
    styles: "min-height:100px;flex-basis:100%"
};
const $adf8f8318644b4cb$var$containerCSSNew = /*#__PURE__*/ (0, $f8Sb3.css)({
    padding: `${"var(--ds-space-100, 8px)"}`,
    minHeight: '100px',
    // by default all frames are hidden, this style is overridden in multiBodiedExtensions for active frame
    display: 'none'
});
const $adf8f8318644b4cb$var$ExtensionFrame = (props)=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            (0, $VSDnB.fg)('platform_editor_multi_body_extension_extensibility') ? $adf8f8318644b4cb$var$containerCSSNew : $adf8f8318644b4cb$var$containerCSSOld
        ],
        "data-extension-frame": "true"
    }, props.children);
};
var $adf8f8318644b4cb$export$2e2bcd8739ae039 = $adf8f8318644b4cb$var$ExtensionFrame;

});

parcelRegister("cWRvh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b4346c39a86c4f3$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $kjhhp = parcelRequire("kjhhp");

var $503mU = parcelRequire("503mU");
function $4b4346c39a86c4f3$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("ul", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $kjhhp.bulletListSelector).substr(1),
        "data-indent-level": props.path ? (0, $503mU.getListIndentLevel)(props.path) : 1,
        children: props.children
    });
}

});
parcelRegister("503mU", function(module, exports) {

$parcel$export(module.exports, "getListIndentLevel", () => $95f5719763d590de$export$75aa84e85754623e);
function $95f5719763d590de$export$75aa84e85754623e(path) {
    let count = 1;
    path.forEach((node)=>{
        if (node.type.name === 'bulletList' || node.type.name === 'orderedList') count++;
    });
    return count;
}

});


parcelRegister("5KNWO", function(module, exports) {

$parcel$export(module.exports, "default", () => $e507ebac88967e63$export$2e2bcd8739ae039);
$parcel$export(module.exports, "DocWithSelectAllTrap", () => $e507ebac88967e63$export$41121a410ca2f650);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $l8Gxi = parcelRequire("l8Gxi");

var $bGnBY = parcelRequire("bGnBY");
function $e507ebac88967e63$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $l8Gxi.RendererCssClassName).DOCUMENT,
        children: props.children
    });
}
function $e507ebac88967e63$export$41121a410ca2f650(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: (0, $bGnBY.useSelectAllTrap)(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $l8Gxi.RendererCssClassName).DOCUMENT,
        children: props.children
    });
}

});
parcelRegister("bGnBY", function(module, exports) {

$parcel$export(module.exports, "useSelectAllTrap", () => $08249876083d1eac$export$98871b245ee25215);

var $gkwXh = parcelRequire("gkwXh");

var $5uXOq = parcelRequire("5uXOq");

var $TM1uy = parcelRequire("TM1uy");

var $lb6Ua = parcelRequire("lb6Ua");
const $08249876083d1eac$export$98871b245ee25215 = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext((0, $TM1uy.default));
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(null);
    const clicked = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(false);
    const caught = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef();
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const mac = typeof navigator !== 'undefined' ? /Mac/.test(navigator.platform) : false;
    const onKeyDown = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((e)=>{
        const el = ref.current;
        if (!el) return;
        const modKey = mac ? e.metaKey : e.ctrlKey;
        if (!modKey || e.code !== 'KeyA' || e.shiftKey) return;
        const elementSelection = (0, $lb6Ua.ElementSelection).fromWindow();
        const isInput = e.target?.matches?.('input');
        if (elementSelection.eq(caught.current) || isInput) {
            fireAnalyticsEvent({
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                action: (0, $gkwXh.ACTION).SELECT_ALL_ESCAPED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER
            });
            return;
        }
        if (elementSelection.inside(el) || elementSelection.type === 'None' && clicked.current) {
            fireAnalyticsEvent({
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                action: (0, $gkwXh.ACTION).SELECT_ALL_CAUGHT,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER
            });
            e.preventDefault();
            caught.current = elementSelection.select(el);
        }
    }, [
        mac,
        ref,
        fireAnalyticsEvent,
        clicked,
        caught
    ]);
    const onClick = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((e)=>{
        clicked.current = ref.current?.contains(e.target) ?? false;
    }, [
        ref,
        clicked
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('keydown', onKeyDown);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('click', onClick);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('keydown', onKeyDown);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('click', onClick);
        };
    }, [
        onKeyDown,
        onClick
    ]);
    return ref;
};

});
parcelRegister("TM1uy", function(module, exports) {

$parcel$export(module.exports, "default", () => $64e1e4f8cfab5159$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $64e1e4f8cfab5159$var$AnalyticsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    fireAnalyticsEvent: (_event)=>null
});
var $64e1e4f8cfab5159$export$2e2bcd8739ae039 = $64e1e4f8cfab5159$var$AnalyticsContext;

});

parcelRegister("lb6Ua", function(module, exports) {

$parcel$export(module.exports, "ElementSelection", () => $854590065f4073c9$export$6e6724d89f27411);
class $854590065f4073c9$export$6e6724d89f27411 {
    constructor(selection){
        this.type = selection ? selection.type : 'None';
        if (selection && this.type !== 'None') this.range = selection.getRangeAt(0);
    }
    eq(selection) {
        if (!selection) return false;
        if (this.range && selection.range) {
            const startMatches = this.range?.compareBoundaryPoints(Range.START_TO_START, selection.range) === 0;
            const endMatches = this.range?.compareBoundaryPoints(Range.END_TO_END, selection.range) === 0;
            return startMatches && endMatches;
        }
        return this.type === 'None' && selection.type === 'None';
    }
    inside(el) {
        return el.contains(this.range?.commonAncestorContainer ?? null);
    }
    select(el) {
        const range = document.createRange();
        range.selectNodeContents(el);
        const selection = window.getSelection();
        if (selection) {
            selection.removeAllRanges();
            selection.addRange(range);
        }
        return $854590065f4073c9$export$6e6724d89f27411.fromWindow();
    }
    static fromWindow(win = window) {
        return new $854590065f4073c9$export$6e6724d89f27411(win.getSelection());
    }
}

});



parcelRegister("lKIDi", function(module, exports) {

$parcel$export(module.exports, "default", () => $98a311e98fd838fb$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $98a311e98fd838fb$var$HardBreak = ({ forceNewLine: forceNewLine = false })=>{
    // To display an empty line using Shift+Enter, ProseMirror inserts a
    // double <br>. The second <br> is not part of the document, it's just
    // there to make browsers behave properly. The forceNewLine prop in this
    // component replicates this behaviour. If the last child node is a
    // hardBreak, it will also insert a double <br>.
    if (forceNewLine) return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("br", {}),
            /*#__PURE__*/ (0, $2OMIu.jsx)("br", {})
        ]
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("br", {});
};
var $98a311e98fd838fb$export$2e2bcd8739ae039 = $98a311e98fd838fb$var$HardBreak;

});

parcelRegister("7AttJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e20de8dc9c3ed0b1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jldZL = parcelRequire("jldZL");

var $bFU4G = parcelRequire("bFU4G");

var $gkwXh = parcelRequire("gkwXh");

var $TM1uy = parcelRequire("TM1uy");

var $jSk6P = parcelRequire("jSk6P");

var $3rouw = parcelRequire("3rouw");
const $e20de8dc9c3ed0b1$var$getCurrentUrlWithHash = (hash = '')=>{
    const url = new URL(window.location.href);
    url.search = ''; // clear any query params so that the page will correctly scroll to the anchor
    url.hash = encodeURIComponent(hash);
    return url.href;
};
function $e20de8dc9c3ed0b1$var$hasRightAlignmentMark(marks) {
    if (!marks || !marks.length) return false;
    return marks.some((mark)=>mark.type.name === 'alignment' && mark.attrs.align === 'end');
}
function $e20de8dc9c3ed0b1$var$WrappedHeadingAnchor({ enableNestedHeaderLinks: enableNestedHeaderLinks, level: level, headingId: headingId, hideFromScreenReader: hideFromScreenReader }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $TM1uy.default).Consumer, {
        children: ({ fireAnalyticsEvent: fireAnalyticsEvent })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3rouw.default), {
                enableNestedHeaderLinks: enableNestedHeaderLinks,
                level: level,
                onCopyText: ()=>{
                    fireAnalyticsEvent({
                        action: (0, $gkwXh.ACTION).CLICKED,
                        actionSubject: (0, $gkwXh.ACTION_SUBJECT).BUTTON,
                        actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).HEADING_ANCHOR_LINK,
                        eventType: (0, $gkwXh.EVENT_TYPE).UI
                    });
                    return (0, $jSk6P.copyTextToClipboard)($e20de8dc9c3ed0b1$var$getCurrentUrlWithHash(headingId));
                },
                hideFromScreenReader: hideFromScreenReader,
                headingId: headingId
            })
    });
}
function $e20de8dc9c3ed0b1$var$Heading(props) {
    const { headingId: headingId, dataAttributes: dataAttributes, allowHeadingAnchorLinks: allowHeadingAnchorLinks, marks: marks, invisible: invisible } = props;
    const HX = `h${props.level}`;
    const mouseEntered = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(false);
    const showAnchorLink = !!props.showAnchorLink;
    const isRightAligned = $e20de8dc9c3ed0b1$var$hasRightAlignmentMark(marks);
    const enableNestedHeaderLinks = allowHeadingAnchorLinks && allowHeadingAnchorLinks.allowNestedHeaderLinks;
    const headingIdToUse = invisible ? undefined : headingId;
    const mouseEnterHandler = ()=>{
        if (showAnchorLink && !mouseEntered.current) {
            // Abort TTVC calculation when the mouse hovers over heading. Hovering over
            // heading render heading anchor and inline comment buttons. These user-induced
            // DOM changes are valid reasons to abort the TTVC calculation.
            (0, $bFU4G.abortAll)('new_interaction');
            mouseEntered.current = true;
        }
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)(HX, {
                id: headingIdToUse,
                "data-renderer-start-pos": dataAttributes['data-renderer-start-pos'],
                onMouseEnter: mouseEnterHandler,
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                    children: [
                        showAnchorLink && headingId && isRightAligned && /*#__PURE__*/ (0, $2OMIu.jsx)($e20de8dc9c3ed0b1$var$WrappedHeadingAnchor, {
                            level: props.level,
                            enableNestedHeaderLinks: enableNestedHeaderLinks,
                            headingId: headingId,
                            hideFromScreenReader: true
                        }),
                        props.children,
                        showAnchorLink && headingId && !isRightAligned && /*#__PURE__*/ (0, $2OMIu.jsx)($e20de8dc9c3ed0b1$var$WrappedHeadingAnchor, {
                            level: props.level,
                            enableNestedHeaderLinks: enableNestedHeaderLinks,
                            headingId: headingId,
                            hideFromScreenReader: true
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jldZL.default), {
                testId: "visually-hidden-heading-anchor",
                children: showAnchorLink && headingId && /*#__PURE__*/ (0, $2OMIu.jsx)($e20de8dc9c3ed0b1$var$WrappedHeadingAnchor, {
                    level: props.level,
                    enableNestedHeaderLinks: enableNestedHeaderLinks,
                    headingId: headingId
                })
            })
        ]
    });
}
var $e20de8dc9c3ed0b1$export$2e2bcd8739ae039 = $e20de8dc9c3ed0b1$var$Heading;

});
parcelRegister("jSk6P", function(module, exports) {

$parcel$export(module.exports, "copyTextToClipboard", () => $2ff51d830678d63e$export$f980440e1ab4537d);
const $2ff51d830678d63e$export$f980440e1ab4537d = (text)=>new Promise((resolve, reject)=>{
        const isApiSupported = !!navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
        if (isApiSupported) navigator.clipboard.writeText(text).then(()=>resolve(), (e)=>reject(e));
        else reject('Clipboard API is not supported');
    });

});

parcelRegister("3rouw", function(module, exports) {

$parcel$export(module.exports, "HeadingAnchorWrapperClassName", () => $b36f5408031b5508$export$3c9cedc52604835d);
$parcel$export(module.exports, "default", () => $b36f5408031b5508$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $jOyH3 = parcelRequire("jOyH3");

var $3bDjY = parcelRequire("3bDjY");

var $1Bd5P = parcelRequire("1Bd5P");
function $b36f5408031b5508$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b36f5408031b5508$export$3c9cedc52604835d = 'heading-anchor-wrapper';
const $b36f5408031b5508$var$CopyAnchorWrapperWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $b36f5408031b5508$export$3c9cedc52604835d,
        ref: ref
    }, children);
});
const $b36f5408031b5508$var$copyAnchorButtonStyles = {
    name: "vhh4ux",
    styles: "display:inline;outline:none;background-color:transparent;border:none;color:var(--ds-icon, #44546F);cursor:pointer;right:0"
};
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $b36f5408031b5508$var$HeadingAnchor extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    componentDidMount() {
        this.resetMessage();
    }
    render() {
        const { tooltipMessage: tooltipMessage } = this.state;
        if (tooltipMessage) // We set the key to the message to ensure it remounts when the message
        // changes, so that it correctly repositions.
        // @see https://ecosystem.atlassian.net/projects/AK/queues/issue/AK-6548
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            tag: $b36f5408031b5508$var$CopyAnchorWrapperWithRef,
            content: tooltipMessage,
            position: "top",
            delay: 0,
            key: tooltipMessage
        }, this.renderAnchorButton());
        return this.renderAnchorButton();
    }
    constructor(...args){
        super(...args), this.state = {
            tooltipMessage: '',
            isClicked: false
        }, this.setTooltipState = (message, isClicked = false)=>{
            this.setState({
                // TODO: ED-14403 - investigate why this does not translate
                tooltipMessage: this.props.intl.formatMessage(message),
                isClicked: isClicked
            });
        }, this.getCopyAriaLabel = ()=>{
            const { copyAriaLabel: copyAriaLabel } = (0, $1Bd5P.headingAnchorLinkMessages);
            return this.props.intl.formatMessage(copyAriaLabel);
        }, this.copyToClipboard = async (event)=>{
            const { copiedHeadingLinkToClipboard: copiedHeadingLinkToClipboard, failedToCopyHeadingLink: failedToCopyHeadingLink } = (0, $1Bd5P.headingAnchorLinkMessages);
            event.stopPropagation();
            try {
                await this.props.onCopyText();
                this.setTooltipState(copiedHeadingLinkToClipboard, true);
            } catch (e) {
                this.setTooltipState(failedToCopyHeadingLink);
            }
        }, this.resetMessage = ()=>{
            this.setTooltipState((0, $1Bd5P.headingAnchorLinkMessages).copyHeadingLinkToClipboard);
        }, this.renderAnchorButton = ()=>{
            const { hideFromScreenReader: hideFromScreenReader = false, headingId: headingId } = this.props;
            return /*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
                "data-testid": "anchor-button",
                css: $b36f5408031b5508$var$copyAnchorButtonStyles,
                onMouseLeave: this.resetMessage,
                onClick: this.copyToClipboard,
                "aria-hidden": hideFromScreenReader,
                tabIndex: hideFromScreenReader ? undefined : -1,
                "aria-label": hideFromScreenReader ? undefined : this.state.tooltipMessage,
                "aria-labelledby": hideFromScreenReader ? undefined : headingId,
                type: "button"
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jOyH3))), {
                label: this.getCopyAriaLabel(),
                LEGACY_size: this.props.level > 3 ? 'small' : 'medium',
                color: this.state.isClicked ? "var(--ds-icon-selected, #0C66E4)" : "var(--ds-icon-subtle, #626F86)"
            }));
        };
    }
}
var $b36f5408031b5508$export$2e2bcd8739ae039 = (0, $8RXs9.default)($b36f5408031b5508$var$HeadingAnchor);

});
parcelRegister("jOyH3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0c2e6e563a714afa66b2c445d0695bd6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e6cd993777d46e1b$var$_react = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e6cd993777d46e1b$var$_link = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("1f9bV")));

var $e6cd993777d46e1b$var$_link2 = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("458iJ")));
function $e6cd993777d46e1b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkIcon.
 * This component is LinkIcon, with `UNSAFE_fallbackIcon` set to "LinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e6cd993777d46e1b$var$LinkIcon = (props)=>/*#__PURE__*/ $e6cd993777d46e1b$var$_react.default.createElement($e6cd993777d46e1b$var$_link.default, Object.assign({
        LEGACY_fallbackIcon: $e6cd993777d46e1b$var$_link2.default
    }, props));
$e6cd993777d46e1b$var$LinkIcon.Name = 'LinkIconMigration';
var $e6cd993777d46e1b$var$_default = module.exports.default = $e6cd993777d46e1b$var$LinkIcon;

});
parcelRegister("1f9bV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7acdc4638dae9667d9917d02594abf75>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0e7e525cdad15340$var$_react = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0e7e525cdad15340$var$_baseNew = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $0e7e525cdad15340$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0e7e525cdad15340$var$LinkIcon = (props)=>/*#__PURE__*/ $0e7e525cdad15340$var$_react.default.createElement($0e7e525cdad15340$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.22 2.22a3.932 3.932 0 1 1 5.56 5.56l-2.25 2.25-1.06-1.06 2.25-2.25a2.432 2.432 0 0 0-3.44-3.44L7.03 5.53 5.97 4.47zm3.06 3.56-5.5 5.5-1.06-1.06 5.5-5.5zM2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 3.44 3.44l2.25-2.25 1.06 1.06-2.25 2.25a3.932 3.932 0 1 1-5.56-5.56" clip-rule="evenodd"/>`
    }, props));
$0e7e525cdad15340$var$LinkIcon.displayName = 'LinkIcon';
var $0e7e525cdad15340$var$_default = module.exports.default = $0e7e525cdad15340$var$LinkIcon;

});

parcelRegister("458iJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2f8e117d74b4de46$var$_react = $2f8e117d74b4de46$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $2f8e117d74b4de46$var$_link = $2f8e117d74b4de46$var$_interopRequireDefault((parcelRequire("1f9bV")));
function $2f8e117d74b4de46$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2f8e117d74b4de46$var$LinkIcon = (props)=>/*#__PURE__*/ $2f8e117d74b4de46$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props, {
        newIcon: $2f8e117d74b4de46$var$_link.default
    }));
$2f8e117d74b4de46$var$LinkIcon.displayName = 'LinkIcon';
var $2f8e117d74b4de46$var$_default = module.exports.default = $2f8e117d74b4de46$var$LinkIcon;

});


parcelRegister("1Bd5P", function(module, exports) {

$parcel$export(module.exports, "headingAnchorLinkMessages", () => $bb2bb569629ca076$export$74bada844422036d);
$parcel$export(module.exports, "tableCellMessages", () => $bb2bb569629ca076$export$c79ebc36348824d1);
$parcel$export(module.exports, "inlineCommentMessages", () => $bb2bb569629ca076$export$9f52c375a6ef34fc);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $7VHMR = parcelRequire("7VHMR");
const $bb2bb569629ca076$export$74bada844422036d = (0, $7VHMR.defineMessages)({
    copyHeadingLinkToClipboard: {
        id: 'fabric.editor.headingLink.copyAnchorLink',
        defaultMessage: 'Copy link to heading',
        description: 'Copy heading link to clipboard'
    },
    copiedHeadingLinkToClipboard: {
        id: 'fabric.editor.headingLink.copied',
        defaultMessage: 'Copied!',
        description: 'Copied heading link to clipboard'
    },
    failedToCopyHeadingLink: {
        id: 'fabric.editor.headingLink.failedToCopy',
        defaultMessage: 'Copy failed',
        description: 'failed to copy heading link to clipboard'
    },
    copyAriaLabel: {
        id: 'fabric.editor.headingLink.copyAriaLabel',
        defaultMessage: 'Copy',
        description: 'copy aria label for link icon'
    }
});
const $bb2bb569629ca076$export$c79ebc36348824d1 = (0, $7VHMR.defineMessages)({
    noneSortingLabel: {
        id: 'fabric.editor.headingLink.noneSortingLabel',
        defaultMessage: 'none',
        description: 'this table column is not sorted'
    },
    ascSortingLabel: {
        id: 'fabric.editor.headingLink.ascSortingLabel',
        defaultMessage: 'ascending',
        description: 'this table column is sorted in ascending order'
    },
    descSortingLabel: {
        id: 'fabric.editor.headingLink.descSortingLabel',
        defaultMessage: 'descending',
        description: 'this table column is sorted in descending order'
    }
});
const $bb2bb569629ca076$export$9f52c375a6ef34fc = (0, $7VHMR.defineMessages)({
    contentRendererInlineCommentMarkerStart: {
        id: 'fabric.editor.inlineComment.marker.start',
        defaultMessage: 'inline comment start',
        description: 'Starting marker to indicate that text is highlighted with an inline comment by a screen reader.'
    },
    contentRendererInlineCommentMarkerEnd: {
        id: 'fabric.editor.inlineComment.marker.end',
        defaultMessage: 'inline comment end',
        description: 'Ending marker to indicate that text was highlighted with an inline comment by a screen reader.'
    }
});

});



parcelRegister("112O7", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4bc2ade6d275922$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fAZXL = parcelRequire("fAZXL");
const $a4bc2ade6d275922$var$InlineExtension = (props)=>{
    const { text: text } = props;
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fAZXL.default), {
        ...props,
        type: "inlineExtension",
        children: ({ result: result })=>{
            try {
                // Return the result directly if it's a valid JSX.Element
                if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(result)) return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    children: result
                });
            } catch (e) {
            /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
            // Always return default content if anything goes wrong
            return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                children: text || 'inlineExtension'
            });
        }
    }));
};
var $a4bc2ade6d275922$export$2e2bcd8739ae039 = $a4bc2ade6d275922$var$InlineExtension;

});

parcelRegister("ieJGA", function(module, exports) {

$parcel$export(module.exports, "default", () => $57fd1bc0570bfa35$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $gmhCD = parcelRequire("gmhCD");
function $57fd1bc0570bfa35$export$2e2bcd8739ae039(props) {
    return (0, $gmhCD.editorExperiment)('advanced_layouts', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: "layout-section-container",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "data-layout-section": true,
            "data-layout-columns": props?.content?.length,
            children: props.children
        })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-layout-section": true,
        children: props.children
    });
}

});

parcelRegister("3RqVz", function(module, exports) {

$parcel$export(module.exports, "default", () => $93f45378df34617d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $4ceoy = parcelRequire("4ceoy");
function $93f45378df34617d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// localized styles, was from clearNextSiblingMarginTopStyle in @atlaskit/editor-common/ui
const $93f45378df34617d$var$clearNextSiblingMarginTopStyle = {
    name: "1f3w791",
    styles: "& + *{margin-top:0 !important;}"
};
// localized styles, was from clearNextSiblingBlockMarkMarginTopStyle in @atlaskit/editor-common/ui
const $93f45378df34617d$var$clearNextSiblingBlockMarkMarginTopStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`+ .fabric-editor-block-mark > p,
	  + .fabric-editor-block-mark > h1,
	  + .fabric-editor-block-mark > h2,
	  + .fabric-editor-block-mark > h3,
	  + .fabric-editor-block-mark > h4,
	  + .fabric-editor-block-mark > h5,
	  + .fabric-editor-block-mark > h6
	`]: {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: '0 !important'
    }
});
function $93f45378df34617d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "data-layout-column": true,
        "data-column-width": props.width,
        style: {
            flexBasis: `${props.width}%`
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4ceoy.WidthProvider), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $93f45378df34617d$var$clearNextSiblingMarginTopStyle,
            $93f45378df34617d$var$clearNextSiblingBlockMarkMarginTopStyle
        ]
    }), props.children));
}

});

parcelRegister("qjsNK", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccd334ef870d278c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $ccd334ef870d278c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("li", {
        children: props.children
    });
}

});

parcelRegister("jHa9U", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fce9f67e250185e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8hSwr = parcelRequire("8hSwr");
const $4fce9f67e250185e$var$RenderCaption = ({ children: children, dataAttributes: dataAttributes })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8hSwr.default), {
        hasContent: true,
        dataAttributes: dataAttributes,
        children: children
    });
};
var $4fce9f67e250185e$export$2e2bcd8739ae039 = $4fce9f67e250185e$var$RenderCaption;

});
parcelRegister("8hSwr", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bb2c70aa755b661$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $2AEnW = parcelRequire("2AEnW");
function $5bb2c70aa755b661$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5bb2c70aa755b661$var$captionWrapperStyle = {
    name: "1f0iwez",
    styles: "margin-top:var(--ds-space-100, 8px);text-align:center;position:relative;color:var(--ds-text-subtle, #44546F)"
};
const $5bb2c70aa755b661$var$placeholderStyle = (0, $8CUq3.xcss)({
    color: 'color.text.subtlest',
    position: 'absolute',
    top: 'space.0',
    width: '100%'
});
class $5bb2c70aa755b661$export$f7feb87190a94c76 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { selected: selected, hasContent: hasContent, children: children, dataAttributes: dataAttributes, intl: { formatMessage: formatMessage } } = this.props;
        const showPlaceholder = !selected && !hasContent;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            "data-media-caption": true,
            "data-testid": "media-caption",
            ...dataAttributes,
            css: $5bb2c70aa755b661$var$captionWrapperStyle
        }, showPlaceholder ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
            xcss: $5bb2c70aa755b661$var$placeholderStyle
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cgL5K.default), null, formatMessage((0, $2AEnW.messages).placeholder))) : null, children);
    }
}
var $5bb2c70aa755b661$export$2e2bcd8739ae039 = (0, $8RXs9.default)($5bb2c70aa755b661$export$f7feb87190a94c76);

});
parcelRegister("2AEnW", function(module, exports) {

$parcel$export(module.exports, "messages", () => $aa314c48a072d691$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $aa314c48a072d691$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    placeholder: {
        id: 'fabric.editor.captionPlaceholder',
        defaultMessage: 'Add a caption',
        description: 'Placeholder description for an empty (new) caption in the editor'
    }
});

});



parcelRegister("6svWT", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6654d29b704d772$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dwptW = parcelRequire("dwptW");

var $jlYLw = parcelRequire("jlYLw");

var $uTDrM = parcelRequire("uTDrM");

var $503mU = parcelRequire("503mU");
function $e6654d29b704d772$export$2e2bcd8739ae039(props) {
    const extraProps = {};
    const itemCounterDigitsSize = (0, $uTDrM.getItemCounterDigitsSize)({
        order: props.order,
        itemsCount: props?.content?.length
    });
    if (itemCounterDigitsSize && itemCounterDigitsSize > 2) extraProps.style = (0, $jlYLw.getOrderedListInlineStyles)(itemCounterDigitsSize, 'object');
    if (props.order !== undefined) extraProps.start = (0, $uTDrM.resolveOrder)(props.order);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("ol", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $dwptW.orderedListSelector).substr(1),
        "data-indent-level": props.path ? (0, $503mU.getListIndentLevel)(props.path) : 1,
        start: props.start,
        ...extraProps,
        children: props.children
    });
}

});
parcelRegister("jlYLw", function(module, exports) {

$parcel$export(module.exports, "listItemCounterPadding", () => $6a64108c33d9274c$export$bafd6beec0797f87);
$parcel$export(module.exports, "getOrderedListInlineStyles", () => $6a64108c33d9274c$export$6d31fdb1d74cee3e);
$parcel$export(module.exports, "listsSharedStyles", () => $6a64108c33d9274c$export$ea95db02cc29c78f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $kjhhp = parcelRequire("kjhhp");
var $dwptW = parcelRequire("dwptW");

var $gE8f9 = parcelRequire("gE8f9");
const $6a64108c33d9274c$export$bafd6beec0797f87 = 24;
var $6a64108c33d9274c$var$CSS_VAR_NAMES = /*#__PURE__*/ function(CSS_VAR_NAMES) {
    CSS_VAR_NAMES["ITEM_COUNTER_PADDING"] = "--ed--list--item-counter--padding";
    return CSS_VAR_NAMES;
}($6a64108c33d9274c$var$CSS_VAR_NAMES || {});
const $6a64108c33d9274c$var$getItemCounterLeftPadding = (itemCounterDigitsSize)=>{
    // Previous padding-left was approximately 24px. We approximate that
    // same value using "ch" units (which represent the width of a "0" digit
    // character). We use "ch" so that this computed padding can now grow if
    //  the font-size ever enlarges.
    let paddingLeft = `2.385ch`;
    if (itemCounterDigitsSize >= 3) {
        // When there are 3 or more digits, we use a combination of "ch" units and
        // pixel values so that while the computed padding grows if font-size ever
        // enlarges, it doesn't over-scale with each digit (because of the fixed pixel
        // portion of the computed value). This way, very large item counters will not
        // become overly left-padded.
        const fixedBasePx = 2;
        paddingLeft = `calc(${itemCounterDigitsSize + 1}ch - ${fixedBasePx}px)`;
    }
    return paddingLeft;
};
const $6a64108c33d9274c$var$stringifyStyle = (style)=>Object.entries(style).reduce((str, [key, value])=>`${str}${key}:${value};`, ``);
function $6a64108c33d9274c$export$6d31fdb1d74cee3e(itemCounterDigitsSize, styleFormat) {
    const style = {
        ["--ed--list--item-counter--padding"]: $6a64108c33d9274c$var$getItemCounterLeftPadding(itemCounterDigitsSize)
    };
    if (styleFormat === 'string') return $6a64108c33d9274c$var$stringifyStyle(style);
    return style;
}
const $6a64108c33d9274c$export$ea95db02cc29c78f = /*#__PURE__*/ (0, $f8Sb3.css)("ul,ol{box-sizing:border-box;padding-left:var(", "--ed--list--item-counter--padding", ", ", $6a64108c33d9274c$export$bafd6beec0797f87, "px);li p:empty,li p>span:empty{", (0, $gE8f9.browser).gecko ? 'display: inline-block;' : '', ";}}", (0, $dwptW.orderedListSelector), ",", (0, $kjhhp.bulletListSelector), "{/*\n      Ensures list item content adheres to the list's margin instead\n      of filling the entire block row. This is important to allow\n      clicking interactive elements which are floated next to a list.\n\n      For some history and context on this block, see PRs related to tickets.:\n      @see ED-6551 - original issue.\n      @see ED-7015 - follow up issue.\n      @see ED-7447 - flow-root change.\n\n      We use 'display: table' (old clear fix / new block formatting context hack)\n      for older browsers and 'flow-root' for modern browsers.\n\n      @see https://css-tricks.com/display-flow-root/\n    */display:table;display:flow-root;}ul,ul ul ul ul{list-style-type:disc;}ul ul,ul ul ul ul ul{list-style-type:circle;}ul ul ul,ul ul ul ul ul ul{list-style-type:square;}ol,ol ol ol ol{list-style-type:decimal;}ol ol,ol ol ol ol ol{list-style-type:lower-alpha;}ol ol ol,ol ol ol ol ol ol{list-style-type:lower-roman;}ol[data-indent-level='1'],ol[data-indent-level='4']{list-style-type:decimal;}ol[data-indent-level='2'],ol[data-indent-level='5']{list-style-type:lower-alpha;}ol[data-indent-level='3'],ol[data-indent-level='6']{list-style-type:lower-roman;}ul[data-indent-level='1'],ul[data-indent-level='4']{list-style-type:disc;}ul[data-indent-level='2'],ul[data-indent-level='5']{list-style-type:circle;}ul[data-indent-level='3'],ul[data-indent-level='6']{list-style-type:square;}");

});

parcelRegister("uTDrM", function(module, exports) {

$parcel$export(module.exports, "resolveOrder", () => $ebe278356715a8a4$export$d445360e2a3c026b);
$parcel$export(module.exports, "getOrderFromOrderedListNode", () => $ebe278356715a8a4$export$cbefb5b89ef0719f);
$parcel$export(module.exports, "getItemCounterDigitsSize", () => $ebe278356715a8a4$export$320582fc14ba1e0f);
$parcel$export(module.exports, "isListNode", () => $ebe278356715a8a4$export$a7d7d2b9ba4d4dbb);
$parcel$export(module.exports, "isParagraphNode", () => $ebe278356715a8a4$export$35f600abfe6f0127);
$parcel$export(module.exports, "isListItemNode", () => $ebe278356715a8a4$export$2ddb0a75547407f6);
$parcel$export(module.exports, "isBulletList", () => $ebe278356715a8a4$export$35b2f400604e700);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/prosemirror-transformer/utils/list.ts
// If changes are made to this file, please make the same update in the linked file.
const $ebe278356715a8a4$export$8ef94ae42a3729bd = 1;
const $ebe278356715a8a4$export$d445360e2a3c026b = (order)=>{
    const num = Number(order);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $ebe278356715a8a4$export$cbefb5b89ef0719f = (orderedListNode)=>{
    const order = orderedListNode?.attrs?.order;
    return $ebe278356715a8a4$export$d445360e2a3c026b(order) ?? $ebe278356715a8a4$export$8ef94ae42a3729bd;
};
const $ebe278356715a8a4$export$320582fc14ba1e0f = (options)=>{
    const order = $ebe278356715a8a4$export$d445360e2a3c026b(options.order) ?? $ebe278356715a8a4$export$8ef94ae42a3729bd;
    const itemsCount = typeof options.itemsCount === 'number' ? options.itemsCount : 0;
    const largestCounter = order + (itemsCount - 1);
    return String(largestCounter)?.split('.')?.[0]?.length;
};
function $ebe278356715a8a4$export$a7d7d2b9ba4d4dbb(node) {
    return Boolean(node && node.type && [
        'orderedList',
        'bulletList'
    ].includes(node.type.name));
}
function $ebe278356715a8a4$export$35f600abfe6f0127(node) {
    return Boolean(node && node.type && 'paragraph' === node.type.name);
}
function $ebe278356715a8a4$export$2ddb0a75547407f6(node) {
    return Boolean(node && node.type && 'listItem' === node.type.name);
}
function $ebe278356715a8a4$export$35b2f400604e700(node) {
    return Boolean(node && node.type && 'bulletList' === node.type.name);
}

});


parcelRegister("9FXQX", function(module, exports) {

$parcel$export(module.exports, "default", () => $26d2961aa3d14cef$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $EGPjg = parcelRequire("EGPjg");
function $26d2961aa3d14cef$export$2e2bcd8739ae039({ children: children, dataAttributes: dataAttributes }) {
    return(// ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, $2OMIu.jsx)("p", {
        ...dataAttributes,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $EGPjg.default), {
            children: children
        })
    }));
}

});
parcelRegister("EGPjg", function(module, exports) {

$parcel$export(module.exports, "default", () => $372a7010ecff9ba7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $372a7010ecff9ba7$export$2e2bcd8739ae039(props) {
    const { children: children } = props;
    const childCount = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children).length;
    if (!childCount) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: "\xa0"
    });
    return children;
}

});


parcelRegister("hqBb9", function(module, exports) {

$parcel$export(module.exports, "default", () => $add04eab04996fda$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $add04eab04996fda$export$2e2bcd8739ae039(props) {
    if (props.allowPlaceholderText) return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-placeholder": `${props.text}`,
        children: props.text
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {});
}

});

parcelRegister("ixoQV", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1bb5022786e53a6$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $e1bb5022786e53a6$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("hr", {
        role: "presentation"
    });
}

});

parcelRegister("dkc63", function(module, exports) {

$parcel$export(module.exports, "isTableResizingEnabled", () => $7478efdfea2a60bf$export$eec82c0a93aa66d9);
$parcel$export(module.exports, "isStickyScrollbarEnabled", () => $7478efdfea2a60bf$export$bdb2dadcb04aad50);
$parcel$export(module.exports, "default", () => $7478efdfea2a60bf$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6gEe5 = parcelRequire("6gEe5");

var $ajc8Z = parcelRequire("ajc8Z");
var $4ceoy = parcelRequire("4ceoy");

var $VSDnB = parcelRequire("VSDnB");

var $5vnE9 = parcelRequire("5vnE9");
var $5or39 = parcelRequire("5or39");
var $5J0oM = parcelRequire("5J0oM");

var $9BYlQ = parcelRequire("9BYlQ");

var $iHYdz = parcelRequire("iHYdz");

var $fKLIs = parcelRequire("fKLIs");

var $gmhCD = parcelRequire("gmhCD");


var $cWojJ = parcelRequire("cWojJ");

var $4BsEy = parcelRequire("4BsEy");

var $2aXGN = parcelRequire("2aXGN");

var $a4mor = parcelRequire("a4mor");

var $kjIja = parcelRequire("kjIja");

var $eIscD = parcelRequire("eIscD");

var $cInAA = parcelRequire("cInAA");
const $7478efdfea2a60bf$export$eec82c0a93aa66d9 = (appearance)=>(0, $kjIja.isFullWidthOrFullPageAppearance)(appearance) || (0, $kjIja.isCommentAppearance)(appearance) && (0, $gmhCD.editorExperiment)('support_table_in_comment', true, {
        exposure: true
    });
const $7478efdfea2a60bf$export$bdb2dadcb04aad50 = (appearance)=>(0, $kjIja.isFullWidthOrFullPageAppearance)(appearance) && (0, $gmhCD.editorExperiment)('platform_renderer_table_sticky_scrollbar', true, {
        exposure: true
    });
const $7478efdfea2a60bf$export$334894231c46c1a5 = (children, tableNode, smartCardStorage, tableOrderStatus)=>{
    if (!tableOrderStatus || tableOrderStatus.order === (0, $9BYlQ.SortOrder).NO_ORDER) return children;
    const { order: order, columnIndex: columnIndex } = tableOrderStatus;
    const compareNodesInOrder = (0, $5J0oM.createCompareNodes)({
        getInlineCardTextFromStore (attrs) {
            const { url: url } = attrs;
            if (!url) return null;
            return smartCardStorage.get(url) || null;
        }
    }, order);
    const tableArray = (0, $5or39.convertProsemirrorTableNodeToArrayOfRows)(tableNode);
    const tableArrayWithChildren = tableArray.map((rowNodes, index)=>({
            rowNodes: rowNodes,
            rowReact: children[index]
        }));
    const headerRow = tableArrayWithChildren.shift();
    const sortedTable = tableArrayWithChildren.sort((rowA, rowB)=>compareNodesInOrder(rowA.rowNodes[columnIndex], rowB.rowNodes[columnIndex]));
    if (headerRow) sortedTable.unshift(headerRow);
    return sortedTable.map((elem)=>elem.rowReact);
};
const $7478efdfea2a60bf$export$42f5658c8e0092da = (row)=>{
    let hasRowspan = false;
    row.forEach((cell)=>hasRowspan = hasRowspan || cell.attrs.rowspan > 1);
    return hasRowspan;
};
const $7478efdfea2a60bf$export$f422245984b0eda7 = (refElement)=>{
    return Math.round(refElement.getBoundingClientRect().top);
};
const $7478efdfea2a60bf$export$7c141112f3c89f11 = (scrollTop, tableTop, tableBottom, rowHeight)=>tableTop <= scrollTop && !(tableBottom - rowHeight <= scrollTop);
const $7478efdfea2a60bf$export$89f3188e1adc30d5 = (scrollTop, tableBottom, rowHeight)=>tableBottom - rowHeight <= scrollTop && !(tableBottom < scrollTop);
const $7478efdfea2a60bf$export$100baa0f10804e6e = (rows, tableOrderStatus, onSorting)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(rows, (row, index)=>{
        if (index === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.only(row), {
            tableOrderStatus: tableOrderStatus,
            onSorting: onSorting
        });
        return row;
    });
};
const $7478efdfea2a60bf$export$28daf78feed5098c = (rows)=>{
    if (!rows.length) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { children: children } = rows[0].props;
    if (!children.length) return false;
    if (children.length === 1) return children[0].type === (0, $cWojJ.TableHeader);
    return children.every((node)=>node.type === (0, $cWojJ.TableHeader));
};
const $7478efdfea2a60bf$export$940095e914312886 = (node, children)=>{
    return $7478efdfea2a60bf$export$28daf78feed5098c(children) && node && node.firstChild && !$7478efdfea2a60bf$export$42f5658c8e0092da(node.firstChild);
};
class $7478efdfea2a60bf$export$f2c3aea42b2a048f extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    /**
   *
   * @example
   */ componentDidMount() {
        this.resizeObserver = new ResizeObserver(this.applyResizerChange);
        if (this.wrapperRef.current) this.resizeObserver.observe(this.wrapperRef.current);
        if (this.stickyHeaderRef.current) this.resizeObserver.observe(this.stickyHeaderRef.current);
        if (this.props.stickyHeaders) {
            this.overflowParent = (0, $2aXGN.OverflowParent).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.addEventListener('scroll', this.onScroll);
        }
        if (this.wrapperRef.current && $7478efdfea2a60bf$export$bdb2dadcb04aad50(this.props.rendererAppearance)) this.stickyScrollbar = new (0, $eIscD.TableStickyScrollbar)(this.wrapperRef.current);
    }
    /**
   *
   * @param prevProps
   * @param prevState
   * @example
   */ componentDidUpdate(prevProps, prevState) {
        // toggling sticky headers visiblity
        if (this.props.stickyHeaders && !this.overflowParent) this.overflowParent = (0, $2aXGN.OverflowParent).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
        else if (!this.props.stickyHeaders && this.overflowParent) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            this.overflowParent = null;
        }
        // offsetTop might have changed, re-position sticky header
        if (this.props.stickyHeaders !== prevProps.stickyHeaders) this.updateSticky();
        // sync horizontal scroll in floating div when toggling modes
        if (prevState.stickyMode !== this.state.stickyMode) this.onWrapperScrolled();
    }
    /**
   *
   */ get pinTop() {
        if (!this.tableRef.current || !this.stickyHeaderRef.current) return;
        return this.tableRef.current.offsetHeight - this.stickyHeaderRef.current.offsetHeight + (0, $6gEe5.tableMarginTop) - (0, $2aXGN.tableStickyPadding);
    }
    /**
   *
   */ get shouldAddOverflowParentOffsetTop_DO_NOT_USE() {
        // IF the StickyHeaderConfig specifies that the default scroll root offsetTop should be added
        // AND the StickyHeaderConfig specifies a default scroll root id
        // AND the OverflowParent is the corresponding element
        // THEN we should add the OverflowParent offset top (RETURN TRUE)
        return this.props.stickyHeaders && !!this.props.stickyHeaders.shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE && !!this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE && this.overflowParent && this.overflowParent.id === this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE;
    }
    /**
   *
   */ get stickyTop() {
        switch(this.state.stickyMode){
            case 'pin-bottom':
                return this.pinTop;
            case 'stick':
                const offsetTop = this.props.stickyHeaders && this.props.stickyHeaders.offsetTop;
                if (typeof offsetTop === 'number' && this.shouldAddOverflowParentOffsetTop_DO_NOT_USE) {
                    const overflowParentOffsetTop = this.overflowParent ? this.overflowParent.top : 0;
                    return offsetTop + overflowParentOffsetTop;
                } else return offsetTop;
            default:
                return undefined;
        }
    }
    /**
   *
   * @example
   */ render() {
        const { isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, renderWidth: renderWidth, columnWidths: columnWidths, stickyHeaders: stickyHeaders, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableAlignment: allowTableAlignment, allowTableResizing: allowTableResizing, isPresentational: isPresentational } = this.props;
        const { stickyMode: stickyMode } = this.state;
        const lineLengthFixedWidth = (0, $iHYdz.akEditorDefaultLayoutWidth);
        let left;
        let updatedLayout;
        // The tableWidth and left offset logic below must stay aligned with the `breakout-ssr.tsx` logic
        // Please consider changes below carefully to not negatively impact SSR
        // `renderWidth` cannot be depended on during SSR
        const isRenderWidthValid = !!renderWidth && renderWidth > 0;
        const renderWidthCSS = rendererAppearance === 'full-page' ? `100cqw - ${0, $19a4579e32968c00$export$12fd658e5eef0d79}px * 2` : `100cqw`;
        const calcDefaultLayoutWidthByAppearance = (rendererAppearance, tableNode)=>{
            if (rendererAppearance === 'full-width' && !tableNode?.attrs.width) return [
                isRenderWidthValid ? Math.min((0, $iHYdz.akEditorFullWidthLayoutWidth), renderWidth) : (0, $iHYdz.akEditorFullWidthLayoutWidth),
                `min(${(0, $iHYdz.akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`
            ];
            else if (rendererAppearance === 'comment' && allowTableResizing && !tableNode?.attrs.width) {
                const tableContainerWidth = (0, $fKLIs.getTableContainerWidth)(tableNode);
                return [
                    isRenderWidthValid ? renderWidth : tableContainerWidth,
                    renderWidthCSS
                ];
            } else {
                // custom width, or width mapped to breakpoint
                const tableContainerWidth = (0, $fKLIs.getTableContainerWidth)(tableNode);
                return [
                    isRenderWidthValid ? Math.min(tableContainerWidth, renderWidth) : tableContainerWidth,
                    `min(${tableContainerWidth}px, ${renderWidthCSS})`
                ];
            }
        };
        const [tableWidth, tableWidthCSS] = calcDefaultLayoutWidthByAppearance(rendererAppearance, tableNode);
        // Logic for table alignment in renderer
        const isTableAlignStart = tableNode && tableNode.attrs && tableNode.attrs.layout === 'align-start' && allowTableAlignment;
        const fullWidthLineLength = isRenderWidthValid ? Math.min((0, $iHYdz.akEditorFullWidthLayoutWidth), renderWidth) : (0, $iHYdz.akEditorFullWidthLayoutWidth);
        const fullWidthLineLengthCSS = `min(${(0, $iHYdz.akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`;
        const commentLineLength = isRenderWidthValid ? renderWidth : lineLengthFixedWidth;
        const isCommentAppearanceAndTableAlignmentEnabled = (0, $kjIja.isCommentAppearance)(rendererAppearance) && allowTableAlignment;
        const lineLength = (0, $kjIja.isFullWidthAppearance)(rendererAppearance) ? fullWidthLineLength : isCommentAppearanceAndTableAlignmentEnabled ? commentLineLength : lineLengthFixedWidth;
        const lineLengthCSS = (0, $kjIja.isFullWidthAppearance)(rendererAppearance) ? fullWidthLineLengthCSS : isCommentAppearanceAndTableAlignmentEnabled ? renderWidthCSS : `${lineLengthFixedWidth}px`;
        // Setting fixTableSSRResizing to false while FG logic is true in tableNew
        const fixTableSSRResizing = false;
        const tableWidthNew = fixTableSSRResizing ? (0, $fKLIs.getTableContainerWidth)(tableNode) : tableWidth;
        const shouldCalculateLeftForAlignment = !isInsideOfBlockNode && !isInsideOfTable && isTableAlignStart && ((0, $kjIja.isFullPageAppearance)(rendererAppearance) && tableWidthNew <= lineLengthFixedWidth || (0, $kjIja.isFullWidthAppearance)(rendererAppearance) || isCommentAppearanceAndTableAlignmentEnabled);
        let leftCSS;
        if (shouldCalculateLeftForAlignment) {
            left = (tableWidth - lineLength) / 2;
            leftCSS = `(${tableWidthCSS} - ${lineLengthCSS}) / 2`;
        }
        if (fixTableSSRResizing) {
            if (!shouldCalculateLeftForAlignment && (0, $kjIja.isFullPageAppearance)(rendererAppearance)) // Note tableWidthCSS here is the renderer width
            // When the screen is super wide we want table to break out.
            // However if screen is smaller than 760px. We want table align to left.
            leftCSS = `min(0px, ${lineLengthCSS} - ${tableWidthCSS}) / 2`;
        } else if (!shouldCalculateLeftForAlignment && (0, $kjIja.isFullPageAppearance)(rendererAppearance) && tableWidthNew > lineLengthFixedWidth) left = lineLengthFixedWidth / 2 - tableWidth / 2;
        const children = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(this.props.children);
        // Historically, tables in the full-width renderer had their layout set to 'default' which is deceiving.
        // This check caters for those tables and helps with SSR logic
        const isFullWidth = !tableNode?.attrs.width && rendererAppearance === 'full-width' && layout !== 'full-width';
        if (isFullWidth) updatedLayout = 'full-width';
        else if (tableNode?.attrs.width) updatedLayout = 'custom';
        else updatedLayout = layout;
        let finalTableContainerWidth = allowTableResizing ? tableWidthNew : 'inherit';
        // We can only use CSS to determine the width when we have a known width in container.
        // When appearance is full-page, full-width or comment we use CSS based width calculation.
        // Otherwise it's fixed table width (customized width) or inherit.
        if ((rendererAppearance === 'full-page' || rendererAppearance === 'full-width') && fixTableSSRResizing) finalTableContainerWidth = allowTableResizing ? `calc(${tableWidthCSS})` : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && !allowTableAlignment) // If table alignment is disabled and table width is akEditorDefaultLayoutWidth = 760,
        // it is most likely a table created before "Support Table in Comments" FF was enabled
        // and we would see a bug ED-24795. A table created before "Support Table in Comments",
        // should inhirit the width of the renderer container.
        // !NOTE: it a table resized to 760 is copied from 'full-page' editor and pasted in comment editor
        // where (allowTableResizing && !allowTableAlignment), the table will loose 760px width.
        finalTableContainerWidth = tableNode?.attrs.width && tableNode?.attrs.width !== (0, $iHYdz.akEditorDefaultLayoutWidth) ? fixTableSSRResizing ? `calc(${tableWidthCSS})` : tableWidth : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && allowTableAlignment) // If table alignment is enabled and layout is not 'align-start' or 'center', we are loading a table that was
        // created before "Support Table in Comments" FF was enabled. So the table should have the same width as renderer container
        // instead of 760 that was set on tableNode when the table had been published.
        finalTableContainerWidth = (tableNode?.attrs.layout === 'align-start' || tableNode?.attrs.layout === 'center') && tableNode?.attrs.width ? fixTableSSRResizing ? `calc(${tableWidthCSS})` : tableWidth : 'inherit';
        let style;
        if (fixTableSSRResizing) style = {
            width: finalTableContainerWidth,
            left: leftCSS ? `calc(${leftCSS})` : undefined,
            marginLeft: shouldCalculateLeftForAlignment && leftCSS !== undefined ? `calc(-1 * (${leftCSS}))` : undefined
        };
        else style = {
            width: finalTableContainerWidth,
            left: left,
            marginLeft: shouldCalculateLeftForAlignment && left !== undefined ? -left : undefined
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: `${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER} ${this.props.shadowClassNames || ''}`,
                "data-layout": updatedLayout,
                ref: this.props.handleRef,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: style,
                children: [
                    $7478efdfea2a60bf$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP,
                        "data-testid": "sticky-scrollbar-sentinel-top"
                    }),
                    stickyHeaders && $7478efdfea2a60bf$export$940095e914312886(tableNode, children) && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2aXGN.StickyTable), {
                        isNumberColumnEnabled: isNumberColumnEnabled,
                        tableWidth: tableWidth,
                        layout: layout,
                        renderWidth: renderWidth,
                        handleRef: this.props.handleRef,
                        shadowClassNames: this.props.shadowClassNames,
                        top: this.stickyTop,
                        mode: stickyMode,
                        innerRef: this.stickyWrapperRef,
                        wrapperWidth: this.state.wrapperWidth,
                        columnWidths: columnWidths,
                        rowHeight: this.state.headerRowHeight,
                        tableNode: tableNode,
                        rendererAppearance: rendererAppearance,
                        allowTableResizing: allowTableResizing,
                        children: [
                            children && children[0]
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER,
                        ref: this.wrapperRef,
                        onScroll: this.props.stickyHeaders && this.onWrapperScrolled,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a4mor.Table), {
                            innerRef: this.tableRef,
                            columnWidths: columnWidths,
                            layout: layout,
                            isNumberColumnEnabled: isNumberColumnEnabled,
                            renderWidth: renderWidth,
                            tableNode: tableNode,
                            rendererAppearance: rendererAppearance,
                            isInsideOfBlockNode: isInsideOfBlockNode,
                            isInsideOfTable: isInsideOfTable,
                            isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
                            allowTableResizing: allowTableResizing,
                            isPresentational: isPresentational,
                            children: this.grabFirstRowRef(children)
                        })
                    }),
                    $7478efdfea2a60bf$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER,
                        ref: this.stickyScrollbarRef,
                        style: {
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            height: "var(--ds-space-250, 20px)",
                            // MAX_BROWSER_SCROLLBAR_HEIGHT
                            // Follow editor to hide by default so it does not show empty gap in SSR
                            // https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/platform/packages/editor/editor-plugin-table/src/nodeviews/TableComponent.tsx#957
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            display: fixTableSSRResizing ? 'none' : 'block',
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                            width: '100%'
                        },
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            style: {
                                width: this.tableRef.current?.clientWidth,
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                height: '100%'
                            }
                        })
                    }),
                    $7478efdfea2a60bf$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM,
                        "data-testid": "sticky-scrollbar-sentinel-bottom"
                    })
                ]
            })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            stickyMode: 'none',
            wrapperWidth: 0,
            headerRowHeight: 0
        }, this.tableRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.stickyHeaderRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.stickyScrollbarRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), // used for sync scroll + copying wrapper width to sticky header
        this.stickyWrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.wrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.overflowParent = null, this.resizeObserver = null, this.applyResizerChange = (entries)=>{
            let wrapperWidth = this.state.wrapperWidth;
            let headerRowHeight = this.state.headerRowHeight;
            for (const entry of entries){
                if (entry.target === this.wrapperRef.current) wrapperWidth = entry.contentRect.width;
                else if (entry.target === this.stickyHeaderRef.current) headerRowHeight = Math.round(entry.contentRect.height);
            }
            if (headerRowHeight !== this.state.headerRowHeight || wrapperWidth !== this.state.wrapperWidth) this.setState({
                wrapperWidth: wrapperWidth,
                headerRowHeight: headerRowHeight
            });
        }, this.componentWillUnmount = ()=>{
            if (this.overflowParent) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            if (this.nextFrame) cancelAnimationFrame(this.nextFrame);
            if (this.resizeObserver) this.resizeObserver.disconnect();
            if (this.stickyScrollbar) this.stickyScrollbar.dispose();
        }, this.getScrollTop = ()=>{
            const { stickyHeaders: stickyHeaders } = this.props;
            const offsetTop = stickyHeaders && stickyHeaders.offsetTop || 0;
            return (this.overflowParent ? this.overflowParent.top : 0) + offsetTop;
        }, this.updateSticky = ()=>{
            const tableElem = this.tableRef.current;
            const refElem = this.stickyHeaderRef.current;
            if (!tableElem || !refElem) return;
            const scrollTop = this.getScrollTop() + (0, $2aXGN.tableStickyPadding);
            const tableTop = $7478efdfea2a60bf$export$f422245984b0eda7(tableElem);
            const tableBottom = tableTop + tableElem.clientHeight;
            const shouldSticky = $7478efdfea2a60bf$export$7c141112f3c89f11(scrollTop, tableTop, tableBottom, refElem.clientHeight);
            const shouldPin = $7478efdfea2a60bf$export$89f3188e1adc30d5(scrollTop, tableBottom, refElem.clientHeight);
            let stickyMode = 'none';
            if (shouldPin) stickyMode = 'pin-bottom';
            else if (shouldSticky) stickyMode = 'stick';
            if (this.state.stickyMode !== stickyMode) this.setState({
                stickyMode: stickyMode
            });
            this.nextFrame = undefined;
        }, this.onScroll = ()=>{
            if (!this.nextFrame) this.nextFrame = requestAnimationFrame(this.updateSticky);
        }, this.onWrapperScrolled = ()=>{
            if (!this.wrapperRef.current || !this.stickyWrapperRef.current) return;
            this.stickyWrapperRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
            if (this.stickyScrollbarRef.current) this.stickyScrollbarRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
        }, this.grabFirstRowRef = (children)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children || false, (child, idx)=>{
                if (idx === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
                    innerRef: this.stickyHeaderRef
                });
                return child;
            });
        };
    }
}
class $7478efdfea2a60bf$export$91e0997fd3f75d56 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    /**
   *
   * @example
   */ render() {
        const { children: children } = this.props;
        if (!children) return null;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children);
        const orderedChildren = (0, $5vnE9.compose)(this.addNumberColumnIndexes, this.addSortableColumn)(childrenArray);
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $2OMIu.jsx)($7478efdfea2a60bf$export$f2c3aea42b2a048f, {
            ...this.props,
            children: orderedChildren
        });
    }
    constructor(...args){
        super(...args), this.state = {
            tableOrderStatus: undefined
        }, // adds sortable + re-orders children
        this.addSortableColumn = (childrenArray)=>{
            const { tableNode: tableNode, allowColumnSorting: allowColumnSorting, smartCardStorage: smartCardStorage } = this.props;
            const { tableOrderStatus: tableOrderStatus } = this.state;
            if (allowColumnSorting && $7478efdfea2a60bf$export$28daf78feed5098c(childrenArray) && tableNode && !(0, $5or39.hasMergedCell)(tableNode)) return $7478efdfea2a60bf$export$100baa0f10804e6e($7478efdfea2a60bf$export$334894231c46c1a5(childrenArray, tableNode, smartCardStorage, tableOrderStatus), tableOrderStatus, this.changeSortOrder);
            return childrenArray;
        }, this.changeSortOrder = (columnIndex, sortOrder)=>{
            this.setState({
                tableOrderStatus: {
                    columnIndex: columnIndex,
                    order: sortOrder
                }
            });
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.addNumberColumnIndexes = (rows)=>{
            const { isNumberColumnEnabled: isNumberColumnEnabled } = this.props;
            const headerRowEnabled = $7478efdfea2a60bf$export$28daf78feed5098c(rows);
            return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(rows, (row, index)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.only(row), {
                    isNumberColumnEnabled: isNumberColumnEnabled,
                    index: headerRowEnabled ? index === 0 ? '' : index : index + 1
                });
            });
        };
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7478efdfea2a60bf$var$TableWithShadowsAndContainerStyles = (0, $ajc8Z.default)((0, $cInAA.TableProcessorWithContainerStyles), {
    /**
   * The :scope is in reference to table container and we are selecting only
   * direct children that match the table node wrapper selector, not their
   * descendants.
   */ overflowSelector: `:scope > .${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER}`,
    useShadowObserver: true
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7478efdfea2a60bf$var$TableWithShadows = (0, $ajc8Z.default)($7478efdfea2a60bf$export$91e0997fd3f75d56, {
    /**
   * The :scope is in reference to table container and we are selecting only
   * direct children that match the table node wrapper selector, not their
   * descendants.
   */ overflowSelector: `:scope > .${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER}`,
    useShadowObserver: true
});
const $7478efdfea2a60bf$var$TableWithWidth = (props)=>{
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $VSDnB.fg)('platform-ssr-table-resize')) {
        const colWidthsSum = props.columnWidths?.reduce((total, val)=>total + val, 0) || 0;
        if (colWidthsSum || props.allowTableResizing) // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $2OMIu.jsx)($7478efdfea2a60bf$var$TableWithShadowsAndContainerStyles, {
            ...props
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cInAA.TableProcessorWithContainerStyles), {
            ...props
        });
    } else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4ceoy.WidthConsumer), {
        children: ({ width: width })=>{
            const renderWidth = props.rendererAppearance === 'full-page' ? width - (0, $19a4579e32968c00$export$12fd658e5eef0d79) * 2 : width;
            const colWidthsSum = props.columnWidths?.reduce((total, val)=>total + val, 0) || 0;
            if (colWidthsSum || props.allowTableResizing) // Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            return /*#__PURE__*/ (0, $2OMIu.jsx)($7478efdfea2a60bf$var$TableWithShadows, {
                renderWidth: renderWidth,
                ...props
            });
            // there should not be a case when colWidthsSum is 0 and table is in overflow state - so no need to render shadows in this case
            return /*#__PURE__*/ (0, $2OMIu.jsx)($7478efdfea2a60bf$export$91e0997fd3f75d56, {
                renderWidth: renderWidth,
                ...props
            });
        }
    });
};
var $7478efdfea2a60bf$export$2e2bcd8739ae039 = (0, $4BsEy.withSmartCardStorage)($7478efdfea2a60bf$var$TableWithWidth);

});
parcelRegister("6gEe5", function(module, exports) {

$parcel$export(module.exports, "tableMarginTop", () => $356bd8bd1d42bb7c$export$808015ab1dd6897a);
$parcel$export(module.exports, "tableMarginTopWithControl", () => $356bd8bd1d42bb7c$export$910bf0d22c3d10f2);
$parcel$export(module.exports, "tableMarginSides", () => $356bd8bd1d42bb7c$export$a43e30915fab3ccf);
$parcel$export(module.exports, "tableCellMinWidth", () => $356bd8bd1d42bb7c$export$531f77930bf508de);
$parcel$export(module.exports, "tableNewColumnMinWidth", () => $356bd8bd1d42bb7c$export$c60fae4049791eae);
$parcel$export(module.exports, "tableCellBorderWidth", () => $356bd8bd1d42bb7c$export$72aad729077aa0fb);
$parcel$export(module.exports, "tableCellPadding", () => $356bd8bd1d42bb7c$export$e56b8ca552b280f6);
$parcel$export(module.exports, "TableSharedCssClassName", () => $356bd8bd1d42bb7c$export$c096bca5477eb7ad);
$parcel$export(module.exports, "tableSharedStyle", () => $356bd8bd1d42bb7c$export$c2bf8eea75aa9302);
$parcel$export(module.exports, "calcTableWidth", () => $356bd8bd1d42bb7c$export$d7ece4d8beb06815);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $9UDEr = parcelRequire("9UDEr");

var $iHYdz = parcelRequire("iHYdz");
var $eluMF = parcelRequire("eluMF");

var $VSDnB = parcelRequire("VSDnB");

var $gE8f9 = parcelRequire("gE8f9");

var $cYeQP = parcelRequire("cYeQP");

var $hgR8Y = parcelRequire("hgR8Y");
function $356bd8bd1d42bb7c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $356bd8bd1d42bb7c$export$808015ab1dd6897a = 24;
const $356bd8bd1d42bb7c$export$afe1899c3eea9823 = 16;
const $356bd8bd1d42bb7c$export$910bf0d22c3d10f2 = 14;
const $356bd8bd1d42bb7c$export$a43e30915fab3ccf = 8;
const $356bd8bd1d42bb7c$export$531f77930bf508de = 48;
const $356bd8bd1d42bb7c$export$c60fae4049791eae = 140;
const $356bd8bd1d42bb7c$export$72aad729077aa0fb = 1;
const $356bd8bd1d42bb7c$export$e56b8ca552b280f6 = 8;
const $356bd8bd1d42bb7c$export$bba39e724bc39451 = 6;
const $356bd8bd1d42bb7c$export$e5ff276883773ffd = 8;
const $356bd8bd1d42bb7c$export$880976487022eb5 = $356bd8bd1d42bb7c$export$808015ab1dd6897a + $356bd8bd1d42bb7c$export$e5ff276883773ffd - $356bd8bd1d42bb7c$export$72aad729077aa0fb;
const $356bd8bd1d42bb7c$export$c096bca5477eb7ad = {
    TABLE_CONTAINER: `${(0, $9UDEr.tablePrefixSelector)}-container`,
    TABLE_NODE_WRAPPER: `${(0, $9UDEr.tablePrefixSelector)}-wrapper`,
    TABLE_LEFT_SHADOW: `${(0, $9UDEr.tablePrefixSelector)}-with-left-shadow`,
    TABLE_RIGHT_SHADOW: `${(0, $9UDEr.tablePrefixSelector)}-with-right-shadow`,
    TABLE_STICKY_SHADOW: `${(0, $9UDEr.tablePrefixSelector)}-sticky-shadow`,
    TABLE_STICKY_WRAPPER: `${(0, $9UDEr.tablePrefixSelector)}-sticky-wrapper`,
    TABLE_STICKY_SCROLLBAR_CONTAINER: `${(0, $9UDEr.tablePrefixSelector)}-sticky-scrollbar-container`,
    TABLE_STICKY_SENTINEL_TOP: `${(0, $9UDEr.tablePrefixSelector)}-sticky-sentinel-top`,
    TABLE_STICKY_SENTINEL_BOTTOM: `${(0, $9UDEr.tablePrefixSelector)}-sticky-sentinel-bottom`,
    TABLE_STICKY_SCROLLBAR_SENTINEL_TOP: `${(0, $9UDEr.tablePrefixSelector)}-sticky-scrollbar-sentinel-top`,
    TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM: `${(0, $9UDEr.tablePrefixSelector)}-sticky-scrollbar-sentinel-bottom`,
    TABLE_SHADOW_SENTINEL_LEFT: `${(0, $9UDEr.tablePrefixSelector)}-shadow-sentinel-left`,
    TABLE_SHADOW_SENTINEL_RIGHT: `${(0, $9UDEr.tablePrefixSelector)}-shadow-sentinel-right`,
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_CELL_NODEVIEW_CONTENT_DOM: (0, $9UDEr.tableCellContentDomSelector),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_CELL_WRAPPER: (0, $9UDEr.tableCellSelector),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_HEADER_CELL_WRAPPER: (0, $9UDEr.tableHeaderSelector),
    TABLE_ROW_CONTROLS_WRAPPER: `${(0, $9UDEr.tablePrefixSelector)}-row-controls-wrapper`,
    TABLE_COLUMN_CONTROLS_DECORATIONS: `${(0, $9UDEr.tablePrefixSelector)}-column-controls-decoration`,
    TABLE_RESIZER_CONTAINER: `${(0, $9UDEr.tablePrefixSelector)}-resizer-container`
};
/* first block node has 0 top margin */ var $356bd8bd1d42bb7c$var$_ref = {
    name: "qubt66",
    styles: ">:first-child:not(style),>style:first-child+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+*,>style:first-child+.ProseMirror-gapcursor+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+span+*,>style:first-child+.ProseMirror-gapcursor+span+*{margin-top:0;}"
};
var $356bd8bd1d42bb7c$var$_ref2 = {
    name: "1fct7qz",
    styles: ">:nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)){margin-top:0;}"
};
const $356bd8bd1d42bb7c$var$firstNodeWithNotMarginTop = ()=>(0, $VSDnB.fg)('platform_editor_nested_dnd_styles_changes') ? $356bd8bd1d42bb7c$var$_ref2 : $356bd8bd1d42bb7c$var$_ref;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Appears safe to auto-fix, but leaving it up to the team to remediate as the readability only gets worse with autofixing
const $356bd8bd1d42bb7c$export$c2bf8eea75aa9302 = ()=>/*#__PURE__*/ (0, $f8Sb3.css)((0, $hgR8Y.tableCellBackgroundStyleOverride)(), " .", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_CONTAINER, "{position:relative;margin:0 auto var(--ds-space-200, 16px);box-sizing:border-box;.decisionItemView-content-wrap:first-of-type>div{margin-top:0;}}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_CONTAINER, "[data-number-column='true']{padding-left:", (0, $iHYdz.akEditorTableNumberColumnWidth) - 1, "px;clear:both;}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_RESIZER_CONTAINER, "{will-change:width,margin-left;}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_RESIZER_CONTAINER, " table{will-change:width;}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER, ">table{margin:var(--ds-space-300, 24px) 0 0 0;}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_CONTAINER, ">table,.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_STICKY_WRAPPER, ">table{margin:var(--ds-space-300, 24px) var(--ds-space-100, 8px) 0 0;}", (0, $VSDnB.fg)('platform_editor_bordered_panel_nested_in_table') ? `.${$356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER} .ak-editor-panel {
			border: ${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #d9dbea)"};
		}` : '', ".", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_CONTAINER, ">table,.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER, ">table,.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_STICKY_WRAPPER, ">table{border-collapse:collapse;border:", $356bd8bd1d42bb7c$export$72aad729077aa0fb, "px solid ", `var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`, ";table-layout:fixed;font-size:1em;width:100%;&[data-autosize='true']{table-layout:auto;}&{*{box-sizing:border-box;}hr{box-sizing:content-box;}tbody{border-bottom:none;}th td{background-color:var(--ds-background-neutral-subtle, white);}", (0, $VSDnB.fg)('platform_editor_renderer_table_header_styles') ? `> tbody > tr > th, > tbody > tr > td` : 'th, td', "{min-width:", $356bd8bd1d42bb7c$export$531f77930bf508de, "px;font-weight:var(--ds-font-weight-regular, 400);vertical-align:top;border:1px solid ", `var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`, ";border-right-width:0;border-bottom-width:0;padding:var(--ds-space-100, 8px);", (0, $gE8f9.browser).gecko || (0, $gE8f9.browser).ie || (0, $gE8f9.browser).mac && (0, $gE8f9.browser).chrome ? 'background-clip: padding-box;' : '', " ", $356bd8bd1d42bb7c$var$firstNodeWithNotMarginTop(), " th p:not(:first-of-type),td p:not(:first-of-type){margin-top:var(--ds-space-150, 12px);}}>tbody>tr>td{background-color:var(--ds-surface, #FFFFFF);}th{background-color:", `var(--ds-background-accent-gray-subtlest, ${(0, $iHYdz.akEditorTableToolbar)})`, ";text-align:left;&:not([style]):not(.danger){.", (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, ":not(.danger){background-color:var(--ds-surface-raised, rgb(235, 237, 240));:not(.", (0, $iHYdz.akEditorSelectedNodeClassName), "){box-shadow:0px 0px 0px 1px var(--ds-border, transparent);}.", (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER, "{background-image:", (0, $eluMF.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), ";background-color:var(--ds-background-neutral, rgb(235, 237, 240));}.", (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER, "{background-color:var(--ds-background-neutral, rgb(226, 229, 233));}>[data-ds--code--code-block]{background-image:", (0, $eluMF.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), "!important;background-color:var(--ds-background-neutral, rgb(235, 237, 240))!important;/* selector lives inside @atlaskit/code */--ds--code--line-number-bg-color:var(--ds-background-neutral, rgb(226, 229, 233));}}}}}}");
const $356bd8bd1d42bb7c$export$d7ece4d8beb06815 = (layout, containerWidth, addControllerPadding = true)=>{
    switch(layout){
        case 'full-width':
            return containerWidth ? Math.min(containerWidth - (addControllerPadding ? (0, $iHYdz.akEditorBreakoutPadding) : 0), (0, $iHYdz.akEditorFullWidthLayoutWidth)) : (0, $iHYdz.akEditorFullWidthLayoutWidth);
        case 'wide':
            if (containerWidth) return Math.min(containerWidth - (addControllerPadding ? (0, $iHYdz.akEditorBreakoutPadding) : 0), (0, $iHYdz.akEditorWideLayoutWidth));
            return 0, $iHYdz.akEditorWideLayoutWidth;
        default:
            return 'inherit';
    }
};

});
parcelRegister("eluMF", function(module, exports) {

$parcel$export(module.exports, "overflowShadow", () => $b41fea6975363b1e$export$c5c1e4f4640336fb);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
const $b41fea6975363b1e$export$c5c1e4f4640336fb = ({ leftCoverWidth: leftCoverWidth, rightCoverWidth: rightCoverWidth })=>{
    const width = "var(--ds-space-100, 8px)";
    const leftCoverWidthResolved = leftCoverWidth || width;
    const rightCoverWidthResolved = rightCoverWidth || width;
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $f8Sb3.css)();
};

});

parcelRegister("cYeQP", function(module, exports) {

$parcel$export(module.exports, "CodeBlockSharedCssClassName", () => $dca73d3fed5e4b1b$export$42659c26f026f6ea);
$parcel$export(module.exports, "codeBlockSharedStyles", () => $dca73d3fed5e4b1b$export$a4fbe21dc6fae881);
$parcel$export(module.exports, "codeBlockInListSafariFix", () => $dca73d3fed5e4b1b$export$3aa5ee2f4c156533);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- Should be safe to autofix, but ignoring for now */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
var $eluMF = parcelRequire("eluMF");

var $VSDnB = parcelRequire("VSDnB");
function $dca73d3fed5e4b1b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $dca73d3fed5e4b1b$export$42659c26f026f6ea = {
    CODEBLOCK_CONTAINER: 'code-block',
    CODEBLOCK_START: 'code-block--start',
    CODEBLOCK_END: 'code-block--end',
    CODEBLOCK_CONTENT_WRAPPER: 'code-block-content-wrapper',
    CODEBLOCK_LINE_NUMBER_GUTTER: 'line-number-gutter',
    CODEBLOCK_CONTENT: 'code-content',
    DS_CODEBLOCK: '[data-ds--code--code-block]',
    CODEBLOCK_CONTENT_WRAPPED: 'code-content--wrapped',
    CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET: 'code-content__line-number--wrapped'
};
var $dca73d3fed5e4b1b$var$_ref = {
    name: "tagqr6",
    styles: "--ds--code--bg-color:transparent"
};
const $dca73d3fed5e4b1b$export$a4fbe21dc6fae881 = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(".", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPED, ">.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER, ">.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT, "{margin-right:var(--ds-space-100, 8px);code{display:block;word-break:break-word;white-space:pre-wrap;}}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER, ">.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT, "{display:flex;flex:1;code{flex-grow:1;white-space:pre;}}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTAINER, "{position:relative;background-color:var(--ds-surface-raised, #FFFFFF);border-radius:var(--ds-border-radius, 3px);margin:", (0, $iHYdz.blockNodesVerticalMargin), " 0 0 0;font-family:", (0, $iHYdz.akEditorCodeFontFamily), ";min-width:", (0, $iHYdz.akEditorTableCellMinWidth), "px;cursor:pointer;clear:both;white-space:normal;", (0, $VSDnB.fg)('platform_editor_fix_code_block_bg_color_in_macro') ? /*#__PURE__*/ (0, $f8Sb3.css)() : $dca73d3fed5e4b1b$var$_ref, " .code-block-gutter-pseudo-element::before{content:attr(data-label);}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_START, "{position:absolute;visibility:hidden;height:1.5rem;top:0px;left:0px;}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_END, "{position:absolute;visibility:hidden;height:1.5rem;bottom:0px;right:0px;}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER, "{position:relative;background-color:var(--ds-background-neutral, #091E420F);display:flex;border-radius:var(--ds-border-radius, 3px);width:100%;counter-reset:line;overflow-x:auto;background-image:", (0, $eluMF.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), ";background-repeat:no-repeat;background-attachment:local,local,local,local,scroll,scroll,scroll,scroll;background-size:var(--ds-space-300, 24px) 100%,var(--ds-space-300, 24px) 100%,var(--ds-space-100, 8px) 100%,var(--ds-space-100, 8px) 100%,var(--ds-space-100, 8px) 100%,1px 100%,var(--ds-space-100, 8px) 100%,1px 100%;background-position:0 0,0 0,100% 0,100% 0,100% 0,100% 0,0 0,0 0;overflow-y:hidden;}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER, "{background-color:var(--ds-background-neutral, #091E420F);position:relative;width:var(--lineNumberGutterWidth, 2rem);padding:var(--ds-space-100, 8px);flex-shrink:0;font-size:", (0, $iHYdz.relativeFontSizeToBase16)(14), ";box-sizing:content-box;}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER, "::before{content:'1';visibility:hidden;font-size:", (0, $iHYdz.relativeFontSizeToBase16)(14), ";line-height:1.5rem;}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT, "{code{tab-size:4;cursor:text;color:var(--ds-text, #172B4D);border-radius:var(--ds-border-radius, 3px);margin:var(--ds-space-100, 8px);font-size:", (0, $iHYdz.relativeFontSizeToBase16)(14), ";line-height:1.5rem;}}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET, "{pointer-events:none;user-select:none;width:var(--lineNumberGutterWidth, 2rem);left:0;position:absolute;font-size:", (0, $iHYdz.relativeFontSizeToBase16)(14), ";padding:0px var(--ds-space-100, 8px);line-height:1.5rem;text-align:right;color:var(--ds-text-subtlest, #505F79);box-sizing:content-box;}}");
const $dca73d3fed5e4b1b$export$3aa5ee2f4c156533 = /*#__PURE__*/ (0, $f8Sb3.css)("::before{content:' ';line-height:", (0, $iHYdz.akEditorLineHeight), ";}>p:first-child,>.code-block:first-child,>.ProseMirror-gapcursor:first-child+.code-block{margin-top:-", (0, $iHYdz.akEditorLineHeight), "em!important;}");

});

parcelRegister("hgR8Y", function(module, exports) {

$parcel$export(module.exports, "tableCellBackgroundStyleOverride", () => $eaa2b3bf40c7fca9$export$677e93f0f5f9623a);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $9UDEr = parcelRequire("9UDEr");

var $hAs1r = parcelRequire("hAs1r");
// This is used in order to support usage of DS tokens. Table cell background-color
// is set inline in '@atlaskit/adf-schema' and the color value is stored in ADF so
// it is not possible to use tokens there without polluting ADF.
// As table cell backgrounds are set inline, this should not break mobile as
// hexToEditorBackgroundPaletteColor() outputs a css variable with fallback hex.
const $eaa2b3bf40c7fca9$var$mapBackgroundColors = ()=>{
    let cssString = '';
    (0, $9UDEr.tableBackgroundColorNames).forEach((value, key)=>{
        const paletteColorValue = (0, $hAs1r.hexToEditorBackgroundPaletteColor)(value);
        if (paletteColorValue) cssString += `
        td[colorname='${key}' i],
        th[colorname='${key}' i] {
          background-color: ${paletteColorValue} !important;
        }
      `;
    });
    return cssString;
};
const $eaa2b3bf40c7fca9$export$677e93f0f5f9623a = ()=>/*#__PURE__*/ (0, $f8Sb3.css)($eaa2b3bf40c7fca9$var$mapBackgroundColors());

});
parcelRegister("hAs1r", function(module, exports) {

$parcel$export(module.exports, "hexToEditorBackgroundPaletteColor", () => $3966f91ec47ca318$export$5f6a44a42a4b38c2);
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", () => $3966f91ec47ca318$export$a270511a0e7fd61a);
// This import will be stripped on build

var $kTHGn = parcelRequire("kTHGn");
function $3966f91ec47ca318$export$5f6a44a42a4b38c2(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = $3966f91ec47ca318$export$2462741d70e6a62f[hexColor.toUpperCase()];
    return tokenData ? tokenData.token : undefined;
}
function $3966f91ec47ca318$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = $3966f91ec47ca318$export$2462741d70e6a62f[hexColor.toUpperCase()];
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
const $3966f91ec47ca318$export$2462741d70e6a62f = {
    // blue
    /** blue - light */ ['#DEEBFF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.blue.subtlest', fallback),
        token: "var(--ds-background-accent-blue-subtlest, #DEEBFF)"
    },
    // source for hex code was legacy token B50
    /** blue - medium */ ['#B3D4FF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.blue.subtler', fallback),
        token: "var(--ds-background-accent-blue-subtler, #B3D4FF)"
    },
    // source for hex code was legacy token B75
    /** blue - strong */ ['#4C9AFF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.blue.subtle', fallback),
        token: "var(--ds-background-accent-blue-subtle, #4C9AFF)"
    },
    // source for hex code was legacy token B100
    // teal
    /** teal - light */ ['#E6FCFF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.teal.subtlest', fallback),
        token: "var(--ds-background-accent-teal-subtlest, #E6FCFF)" // source for hex code was legacy token T50,
    },
    /** teal - medium */ ['#B3F5FF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.teal.subtler', fallback),
        token: "var(--ds-background-accent-teal-subtler, #B3F5FF)" // source for hex code was legacy token T75,
    },
    /** teal - strong */ ['#79E2F2']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.teal.subtle', fallback),
        token: "var(--ds-background-accent-teal-subtle, #79E2F2)" // source for hex code was legacy token T100,
    },
    // green
    /** green - light */ ['#E3FCEF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.green.subtlest', fallback),
        token: "var(--ds-background-accent-green-subtlest, #E3FCEF)" // source for hex code was legacy token G50,
    },
    /** green - medium */ ['#ABF5D1']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.green.subtler', fallback),
        token: "var(--ds-background-accent-green-subtler, #ABF5D1)" // source for hex code was legacy token G75,
    },
    /** green - strong */ ['#57D9A3']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.green.subtle', fallback),
        token: "var(--ds-background-accent-green-subtle, #57D9A3)" // source for hex code was legacy token G200,
    },
    // yellowOrange
    /** yellowOrange - light */ ['#FFFAE6']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.yellow.subtlest', fallback),
        token: "var(--ds-background-accent-yellow-subtlest, #FFFAE6)" // source for hex code was legacy token Y50,
    },
    /** yellowOrange - medium */ ['#FFF0B3']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.yellow.subtler', fallback),
        token: "var(--ds-background-accent-yellow-subtler, #FFF0B3)" // source for hex code was legacy token Y75,
    },
    /** yellowOrange - strong */ ['#FFC400']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.orange.subtle', fallback),
        token: "var(--ds-background-accent-orange-subtle, #FFC400)" // source for hex code was legacy token Y200,
    },
    // red
    /** red - light */ ['#FFEBE6']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.red.subtlest', fallback),
        token: "var(--ds-background-accent-red-subtlest, #FFEBE6)" // source for hex code was legacy token R50,
    },
    /** red - medium */ ['#FFBDAD']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.red.subtler', fallback),
        token: "var(--ds-background-accent-red-subtler, #FFBDAD)" // source for hex code was legacy token R75,
    },
    /** red - strong */ ['#FF8F73']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.red.subtle', fallback),
        token: "var(--ds-background-accent-red-subtle, #FF8F73)" // source for hex code was legacy token R100,
    },
    // purple
    /** purple - light */ ['#EAE6FF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.purple.subtlest', fallback),
        token: "var(--ds-background-accent-purple-subtlest, #EAE6FF)" // source for hex code was legacy token P50,
    },
    /** purple - medium */ ['#C0B6F2']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.purple.subtler', fallback),
        token: "var(--ds-background-accent-purple-subtler, #C0B6F2)" // source for hex code was legacy token P75,
    },
    /** purple - strong */ ['#998DD9']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.purple.subtle', fallback),
        token: "var(--ds-background-accent-purple-subtle, #998DD9)" // source for hex code was legacy token P100,
    },
    // whiteGray
    /** whiteGray - light */ ['#FFFFFF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('elevation.surface', fallback),
        token: "var(--ds-surface, #FFFFFF)" // source for hex code was legacy token N0,
    },
    /** whiteGray - medium */ ['#F4F5F7']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.gray.subtlest', fallback),
        token: "var(--ds-background-accent-gray-subtlest, #F4F5F7)" // source for hex code was legacy token N20,
    },
    /** whiteGray - strong */ ['#B3BAC5']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.gray.subtle', fallback),
        token: "var(--ds-background-accent-gray-subtle, #B3BAC5)" // source for hex code was legacy token N60,
    }
};

});



parcelRegister("5vnE9", function(module, exports) {

$parcel$export(module.exports, "compose", () => $8cb395a24b5942e2$export$f672e0b6f7222cd7);
/** Helper type for single arg function */ function $8cb395a24b5942e2$export$f672e0b6f7222cd7(func, ...funcs) {
    const allFuncs = [
        func,
        ...funcs
    ];
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function composed(raw) {
        return allFuncs.reduceRight((memo, func)=>func(memo), raw);
    };
}

});

parcelRegister("5or39", function(module, exports) {

$parcel$export(module.exports, "getColumnWidths", () => $a59f56ae192d20af$export$e54c9225ca52acc);
$parcel$export(module.exports, "calcTableColumnWidths", () => $a59f56ae192d20af$export$98951d3cdcfd364b);
$parcel$export(module.exports, "hasMergedCell", () => $a59f56ae192d20af$export$f9d610bfbb78949b);
$parcel$export(module.exports, "convertProsemirrorTableNodeToArrayOfRows", () => $a59f56ae192d20af$export$69fbfaf01f2fd534);
$parcel$export(module.exports, "isPositionNearTableRow", () => $a59f56ae192d20af$export$889a8e446452be16);
function $a59f56ae192d20af$export$e54c9225ca52acc(node) {
    let tableColumnWidths = [];
    node.forEach((row)=>{
        const currentTableWidth = [];
        row.forEach((cell)=>{
            const { colspan: colspan, colwidth: colwidth } = cell.attrs;
            // column has been resized, colWidth will be an array, can safely take values even if cell is merged
            if (Array.isArray(colwidth)) currentTableWidth.push(...colwidth);
            else if (colspan !== undefined && colspan > 1) currentTableWidth.push(...Array(colspan).fill(0));
            else currentTableWidth.push(0);
        });
        if (currentTableWidth.length > tableColumnWidths.length) tableColumnWidths = currentTableWidth;
    });
    return tableColumnWidths;
}
function $a59f56ae192d20af$export$98951d3cdcfd364b(node) {
    const firstRow = node.firstChild;
    const tableColumnWidths = [];
    if (firstRow) firstRow.forEach((cell)=>{
        const { colspan: colspan, colwidth: colwidth } = cell.attrs;
        // column has been resized, colWidth will be an array, can safely take values even if cell is merged
        if (Array.isArray(colwidth)) tableColumnWidths.push(...colwidth);
        else if (colspan > 1) tableColumnWidths.push(...Array(colspan).fill(0));
        else tableColumnWidths.push(0);
    });
    return tableColumnWidths;
}
function $a59f56ae192d20af$export$f9d610bfbb78949b(tableNode) {
    let hasSpan = false;
    tableNode.descendants((node)=>{
        if (node.type.name === 'tableRow') return true;
        const { colspan: colspan, rowspan: rowspan } = node.attrs;
        if (colspan > 1 || rowspan > 1) hasSpan = true;
        return false;
    });
    return hasSpan;
}
function $a59f56ae192d20af$export$69fbfaf01f2fd534(tableNode) {
    const result = [];
    tableNode.forEach((rowNode)=>{
        if (rowNode.type.name === 'tableRow') {
            const row = [];
            rowNode.forEach((n)=>row.push(n));
            result.push(row);
        }
    });
    return result;
}
function $a59f56ae192d20af$export$889a8e446452be16(pos, schema, direction) {
    if (!schema.nodes.tableRow) return false;
    const doc = pos.doc;
    let resolved = pos;
    const sibling = direction === 'before' ? 'nodeBefore' : 'nodeAfter';
    while(resolved.depth > 0){
        const siblingType = resolved[sibling]?.type;
        if (siblingType === schema.nodes.tableRow) return true;
        resolved = doc.resolve(resolved[direction]());
    }
    return false;
}

});

parcelRegister("5J0oM", function(module, exports) {

$parcel$export(module.exports, "createCompareNodes", () => $c09b1d49576acabb$export$49215374a8bec29c);

var $9BYlQ = parcelRequire("9BYlQ");
var $c09b1d49576acabb$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType[ContentType["NUMBER"] = 0] = "NUMBER";
    ContentType[ContentType["TEXT"] = 5] = "TEXT";
    ContentType[ContentType["MENTION"] = 10] = "MENTION";
    ContentType[ContentType["DATE"] = 15] = "DATE";
    ContentType[ContentType["STATUS"] = 20] = "STATUS";
    ContentType[ContentType["LINK"] = 25] = "LINK";
    return ContentType;
}({});
function $c09b1d49576acabb$var$getLinkMark(node) {
    const [linkMark] = node.marks.filter((mark)=>mark.type.name === 'link');
    return linkMark || null;
}
function $c09b1d49576acabb$var$parseLocaleNumber(stringNumber, groupPattern, fractionPattern) {
    if (!stringNumber.trim().length) return null;
    const maybeANumber = Number.parseFloat(stringNumber.replace(groupPattern, '').replace(fractionPattern, '.'));
    if (Number.isNaN(maybeANumber)) return null;
    return maybeANumber;
}
function $c09b1d49576acabb$export$8ebf986086b1866f() {
    // Source: https://stackoverflow.com/questions/12004808/does-javascript-take-local-decimal-separators-into-account
    const locale = window.navigator.language;
    const thousandSeparator = Intl.NumberFormat(locale).format(11111).replace(/\p{Number}/gu, '');
    const decimalSeparator = Intl.NumberFormat(locale).format(1.1).replace(/\p{Number}/gu, '');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const numericPattern = new RegExp(`(\\d+(?:[${thousandSeparator}${decimalSeparator}]?\\d+)*)`, 'g');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const thousandSeparatorPattern = new RegExp('\\' + thousandSeparator, 'g');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const decimalSeparatorPattern = new RegExp('\\' + decimalSeparator);
    return (text)=>{
        if (!text.trim().length) return null;
        // This will break the text apart at the locations of the formatted numbers
        const result = text.split(numericPattern);
        // We then put the text back together but with all the formatted numbers converted back to plain numerals,
        // for example a sentence like "What is 1,000.01% of 10,000.01" would be normalized and sorted as
        // if it's saying "What is 1000.01% of 10000.01". This way the Intl.Collator can use the numeric setting to sort
        // numeral values within string correctly.
        const tokens = result.reduce((acc, stringNumber)=>{
            if (!stringNumber?.length) return acc;
            const maybeANumber = $c09b1d49576acabb$var$parseLocaleNumber(stringNumber, thousandSeparatorPattern, decimalSeparatorPattern);
            // NOTE: We know there can only be a single decimal separator. So we can assume that if the first found separator
            // is not at the same position as the last found one, then we can assume the locale used to format the number
            // is different to our locale. This will result in the value being treated as a string.
            if (maybeANumber !== null && stringNumber.indexOf(decimalSeparator) === stringNumber.lastIndexOf(decimalSeparator)) acc.push(maybeANumber);
            else acc.push(stringNumber);
            return acc;
        }, []);
        if (tokens.length === 1) return tokens[0];
        return tokens.join('');
    };
}
function $c09b1d49576acabb$export$7cc053f549ed70b8(textNode, normalizeTextParser) {
    // treat as a link if contain a link
    const linkMark = $c09b1d49576acabb$var$getLinkMark(textNode);
    if (linkMark) {
        const value = textNode.text || '';
        return {
            type: 25,
            value: value
        };
    }
    const text = textNode.text || '';
    const normalizedText = normalizeTextParser(text);
    if (typeof normalizedText === 'number') return {
        type: 0,
        value: normalizedText
    };
    return {
        type: 5,
        value: normalizedText ?? text
    };
}
function $c09b1d49576acabb$var$getMetaFromNode(node, options, normalizeTextParser) {
    if (!node) return null;
    const firstChild = node.firstChild;
    if (!firstChild) return null;
    switch(firstChild.type.name){
        // Text case
        /*
      Get Meta value from the first child if the cell is of type
        * Heading (Any cell where the text is set to a heading type)
        * Paragraph (Normal text)
     */ case 'heading':
        case 'paragraph':
            return $c09b1d49576acabb$var$getMetaFromNode(firstChild, options, normalizeTextParser);
        case 'inlineCard':
            {
                const attrs = firstChild.attrs;
                const maybeTitle = options.getInlineCardTextFromStore(attrs);
                if (maybeTitle) return {
                    type: 25,
                    value: maybeTitle
                };
                const url = attrs.url;
                return {
                    type: 25,
                    value: url ? url : ''
                };
            }
        case 'text':
            return $c09b1d49576acabb$export$7cc053f549ed70b8(firstChild, normalizeTextParser);
        case 'status':
            {
                const text = firstChild.attrs.text;
                return {
                    type: 20,
                    value: text
                };
            }
        case 'date':
            {
                const timestamp = Number.parseInt(firstChild.attrs.timestamp, 20);
                return {
                    type: 15,
                    value: timestamp
                };
            }
        case 'mention':
            {
                const text = firstChild.attrs.text || '';
                return {
                    type: 10,
                    value: text.toLowerCase()
                };
            }
        default:
            return null;
    }
}
function $c09b1d49576acabb$var$compareValue(valueA, valueB) {
    if (valueA === valueB) return 0;
    if (typeof valueA === 'string' && typeof valueB === 'string') return valueA.localeCompare(valueB, window.navigator.language, {
        caseFirst: 'upper',
        numeric: true
    });
    return valueA > valueB ? 1 : -1;
}
const $c09b1d49576acabb$export$49215374a8bec29c = (options, order = (0, $9BYlQ.SortOrder).ASC)=>{
    const normalizeTextParser = $c09b1d49576acabb$export$8ebf986086b1866f();
    return (nodeA, nodeB)=>{
        const metaNodeA = $c09b1d49576acabb$var$getMetaFromNode(nodeA, options, normalizeTextParser);
        const metaNodeB = $c09b1d49576acabb$var$getMetaFromNode(nodeB, options, normalizeTextParser);
        /*
      Donot switch the order (Asec or Desc) if either node is null.
      This will ensure that empty cells are always at the bottom during sorting.
    */ if (metaNodeA === null || metaNodeB === null) return $c09b1d49576acabb$var$compareMetaFromNode(metaNodeA, metaNodeB);
        return (order === (0, $9BYlQ.SortOrder).DESC ? -1 : 1) * $c09b1d49576acabb$var$compareMetaFromNode(metaNodeA, metaNodeB);
    };
};
function $c09b1d49576acabb$var$compareMetaFromNode(metaNodeA, metaNodeB) {
    if (metaNodeA === metaNodeB) return 0;
    if (metaNodeA === null || metaNodeB === null) return metaNodeB === null ? -1 : 1;
    if (metaNodeA.type !== metaNodeB.type) return metaNodeA.type > metaNodeB.type ? 1 : -1;
    return $c09b1d49576acabb$var$compareValue(metaNodeA.value, metaNodeB.value);
}

});
parcelRegister("9BYlQ", function(module, exports) {

$parcel$export(module.exports, "SortOrder", () => $42ab1316856d1585$export$7ae723045d45777a);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $dEtqo = parcelRequire("dEtqo");

var $kXC89 = parcelRequire("kXC89");
var $42ab1316856d1585$export$7ae723045d45777a = /*#__PURE__*/ function(SortOrder) {
    SortOrder["ASC"] = "asc";
    SortOrder["DESC"] = "desc";
    SortOrder["NO_ORDER"] = "no_order";
    return SortOrder;
}({});

});
parcelRegister("kXC89", function(module, exports) {

$parcel$export(module.exports, "ToolbarSize", () => $fa36a5395f686390$export$ed55211407a9423);
$parcel$export(module.exports, "ToolbarWidths", () => $fa36a5395f686390$export$423b5e8c92d477b9);
$parcel$export(module.exports, "ToolbarWidthsNext", () => $fa36a5395f686390$export$3f050002d3df641b);
$parcel$export(module.exports, "ToolbarWidthsFullPage", () => $fa36a5395f686390$export$63ca43752be70b90);
$parcel$export(module.exports, "ToolbarWidthsFullPageNext", () => $fa36a5395f686390$export$501a79d885598191);
var $fa36a5395f686390$export$ed55211407a9423 = /*#__PURE__*/ function(ToolbarSize) {
    ToolbarSize[ToolbarSize["XXL"] = 6] = "XXL";
    ToolbarSize[ToolbarSize["XL"] = 5] = "XL";
    ToolbarSize[ToolbarSize["L"] = 4] = "L";
    ToolbarSize[ToolbarSize["M"] = 3] = "M";
    ToolbarSize[ToolbarSize["S"] = 2] = "S";
    ToolbarSize[ToolbarSize["XXXS"] = 1] = "XXXS";
    return ToolbarSize;
}({});
var $fa36a5395f686390$export$423b5e8c92d477b9 = /*#__PURE__*/ function(ToolbarWidths) {
    ToolbarWidths[ToolbarWidths["XXL"] = 610] = "XXL";
    ToolbarWidths[ToolbarWidths["XL"] = 540] = "XL";
    ToolbarWidths[ToolbarWidths["L"] = 460] = "L";
    ToolbarWidths[ToolbarWidths["M"] = 450] = "M";
    ToolbarWidths[ToolbarWidths["S"] = 410] = "S";
    return ToolbarWidths;
}({});
var $fa36a5395f686390$export$3f050002d3df641b = /*#__PURE__*/ function(ToolbarWidthsNext) {
    ToolbarWidthsNext[ToolbarWidthsNext["XXL"] = 768] = "XXL";
    ToolbarWidthsNext[ToolbarWidthsNext["XL"] = 576] = "XL";
    ToolbarWidthsNext[ToolbarWidthsNext["L"] = 460] = "L";
    ToolbarWidthsNext[ToolbarWidthsNext["M"] = 450] = "M";
    ToolbarWidthsNext[ToolbarWidthsNext["S"] = 410] = "S";
    return ToolbarWidthsNext;
}({});
var $fa36a5395f686390$export$63ca43752be70b90 = /*#__PURE__*/ function(ToolbarWidthsFullPage) {
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["XXL"] = 650] = "XXL";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["XL"] = 580] = "XL";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["L"] = 540] = "L";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["M"] = 490] = "M";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["S"] = 410] = "S";
    return ToolbarWidthsFullPage;
}({});
var $fa36a5395f686390$export$501a79d885598191 = /*#__PURE__*/ function(ToolbarWidthsFullPageNext) {
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["XXL"] = 1200] = "XXL";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["XL"] = 992] = "XL";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["L"] = 768] = "L";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["M"] = 576] = "M";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["S"] = 410] = "S";
    return ToolbarWidthsFullPageNext;
}({});

});



parcelRegister("fKLIs", function(module, exports) {

$parcel$export(module.exports, "layoutToWidth", () => $78b5f00ff26d55fc$export$9b77d38feba5446);
$parcel$export(module.exports, "getParentNodeWidth", () => $78b5f00ff26d55fc$export$d76cc081ce1449a8);
$parcel$export(module.exports, "getTableContainerWidth", () => $78b5f00ff26d55fc$export$3930799be057b305);

var $5r0mK = parcelRequire("5r0mK");

var $iHYdz = parcelRequire("iHYdz");

var $bQr2R = parcelRequire("bQr2R");

var $ejmVg = parcelRequire("ejmVg");

var $6gEe5 = parcelRequire("6gEe5");

var $eOOFp = parcelRequire("eOOFp");
const $78b5f00ff26d55fc$var$GRID_SIZE = 8;
const $78b5f00ff26d55fc$export$9b77d38feba5446 = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    default: (0, $iHYdz.akEditorDefaultLayoutWidth),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    wide: (0, $iHYdz.akEditorWideLayoutWidth),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    'full-width': (0, $iHYdz.akEditorFullWidthLayoutWidth)
};
const $78b5f00ff26d55fc$export$d76cc081ce1449a8 = (pos, state, containerWidth, isFullWidthModeEnabled)=>{
    if (!pos) return;
    const node = $78b5f00ff26d55fc$var$getNestedParentNode(pos, state);
    if (!node) return;
    let layout = node.attrs.layout || 'default';
    const { schema: schema } = state;
    const breakoutMark = schema.marks.breakout && schema.marks.breakout.isInSet(node.marks);
    if (breakoutMark && breakoutMark.attrs.mode) layout = breakoutMark.attrs.mode;
    let parentWidth = $78b5f00ff26d55fc$var$calcBreakoutNodeWidth(layout, containerWidth, isFullWidthModeEnabled);
    // Please, do not copy or use this kind of code below
    // @ts-ignore
    const contextPanelPluginKey = {
        key: 'contextPanelPluginKey$',
        getState: (state)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return state['contextPanelPluginKey$'];
        }
    };
    switch(node.type){
        case schema.nodes.layoutSection:
            parentWidth += (0, $iHYdz.akLayoutGutterOffset) * 2; // extra width that gets added to layout
            // Calculate width of parent layout column when
            // Parallel layout with viewport greater than 1024px
            // OR side panel of an extension is open and change the node width to smaller than containerWidth
            if (containerWidth.width > (0, $iHYdz.gridMediumMaxWidth) || contextPanelPluginKey.getState(state)?.contents.length > 0 && contextPanelPluginKey.getState(state)?.contents[0] !== undefined) {
                parentWidth -= ((0, $ejmVg.LAYOUT_SECTION_MARGIN) + 2) * (node.childCount - 1); // margin between sections
                const $pos = state.doc.resolve(pos);
                const column = (0, $5r0mK.findParentNodeOfTypeClosestToPos)($pos, [
                    state.schema.nodes.layoutColumn
                ]);
                if (column && column.node && !isNaN(column.node.attrs.width)) // get exact width of parent layout column using node attrs
                parentWidth = Math.round(parentWidth * column.node.attrs.width * 0.01);
            }
            // account for the padding of the parent node
            parentWidth -= (0, $ejmVg.LAYOUT_COLUMN_PADDING) * 2;
            break;
        case schema.nodes.bodiedExtension:
            parentWidth -= (0, $bQr2R.BODIED_EXT_PADDING) * 2;
            break;
        case schema.nodes.extensionFrame:
            parentWidth -= (0, $bQr2R.BODIED_EXT_PADDING) * 2;
            break;
        case schema.nodes.expand:
            // padding
            parentWidth -= $78b5f00ff26d55fc$var$GRID_SIZE * 2;
            // gutter offset
            parentWidth += $78b5f00ff26d55fc$var$GRID_SIZE * 3;
            // padding right
            parentWidth -= $78b5f00ff26d55fc$var$GRID_SIZE;
            // padding left
            parentWidth -= $78b5f00ff26d55fc$var$GRID_SIZE * 4 - $78b5f00ff26d55fc$var$GRID_SIZE / 2;
            break;
        case schema.nodes.tableCell:
        case schema.nodes.tableHeader:
            // Calculate the available column width
            if (Array.isArray(node.attrs.colwidth)) parentWidth = node.attrs.colwidth.slice(0, node.attrs.colspan).reduce((sum, width)=>sum + width, 0);
            // Compensate for padding
            parentWidth -= (0, $6gEe5.tableCellPadding) * 2;
            break;
    }
    parentWidth -= 2; // border
    return parentWidth;
};
const $78b5f00ff26d55fc$var$getNestedParentNode = (tablePos, state)=>{
    if (tablePos === undefined) return null;
    const $pos = state.doc.resolve(tablePos);
    const parent = (0, $5r0mK.findParentNodeOfTypeClosestToPos)($pos, [
        state.schema.nodes.bodiedExtension,
        state.schema.nodes.extensionFrame,
        state.schema.nodes.layoutSection,
        state.schema.nodes.expand,
        state.schema.nodes.tableCell,
        state.schema.nodes.tableHeader
    ]);
    return parent ? parent.node : null;
};
const $78b5f00ff26d55fc$var$calcBreakoutNodeWidth = (layout, containerWidth, isFullWidthModeEnabled)=>{
    return isFullWidthModeEnabled ? Math.min(containerWidth.lineLength, (0, $iHYdz.akEditorFullWidthLayoutWidth)) : (0, $eOOFp.absoluteBreakoutWidth)(layout, containerWidth.width);
};
const $78b5f00ff26d55fc$export$3930799be057b305 = (node)=>{
    if (node?.attrs.width) return node.attrs.width;
    return $78b5f00ff26d55fc$export$9b77d38feba5446[node?.attrs.layout] || (0, $iHYdz.akEditorDefaultLayoutWidth);
};
const $78b5f00ff26d55fc$export$9724081a0d43786a = (node, offset)=>{
    const isNumberColumnEnabled = node.attrs.isNumberColumnEnabled;
    if (isNumberColumnEnabled && offset > 0) return $78b5f00ff26d55fc$export$3930799be057b305(node) - offset;
    return $78b5f00ff26d55fc$export$3930799be057b305(node);
};

});
parcelRegister("bQr2R", function(module, exports) {

$parcel$export(module.exports, "BODIED_EXT_PADDING", () => $6a203c68476205e6$export$5ac5087fe1217160);
$parcel$export(module.exports, "BODIED_EXT_MBE_MARGIN_TOP", () => $6a203c68476205e6$export$91624ec52c59c24c);
const $6a203c68476205e6$export$f5ecdce4c60ff98b = 8;
const $6a203c68476205e6$export$5ac5087fe1217160 = $6a203c68476205e6$export$f5ecdce4c60ff98b * 2;
const $6a203c68476205e6$export$91624ec52c59c24c = 12;

});

parcelRegister("ejmVg", function(module, exports) {

$parcel$export(module.exports, "LAYOUT_SECTION_MARGIN", () => $16b49a7404f3316f$export$cd04f19842abff0);
$parcel$export(module.exports, "LAYOUT_COLUMN_PADDING", () => $16b49a7404f3316f$export$a1bb91aa2d5fcce8);
const $16b49a7404f3316f$export$cd04f19842abff0 = 8;
const $16b49a7404f3316f$export$a1bb91aa2d5fcce8 = $16b49a7404f3316f$export$cd04f19842abff0 * 1.5;

});


const $19a4579e32968c00$export$12fd658e5eef0d79 = 32;
const $19a4579e32968c00$export$74b525449cc7cbd1 = 'ai-streaming-telepointer';

parcelRegister("cWojJ", function(module, exports) {

$parcel$export(module.exports, "TableHeader", () => $decaf4f5703baa00$export$f850895b287ef28e);
$parcel$export(module.exports, "TableCell", () => $decaf4f5703baa00$export$1e4baea7053fc0e3);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $87j2U = parcelRequire("87j2U");
var $9UDEr = parcelRequire("9UDEr");

var $hxoiH = parcelRequire("hxoiH");

var $9BYlQ = parcelRequire("9BYlQ");

var $hAs1r = parcelRequire("hAs1r");

var $hrpWq = parcelRequire("hrpWq");

var $knXBU = parcelRequire("knXBU");

var $gkwXh = parcelRequire("gkwXh");

var $l8Gxi = parcelRequire("l8Gxi");

var $koVbs = parcelRequire("koVbs");

var $1Bd5P = parcelRequire("1Bd5P");
const $decaf4f5703baa00$var$IgnoreSorting = [
    'LABEL',
    'INPUT'
];
const $decaf4f5703baa00$var$nextStatusOrder = (currentSortOrder)=>{
    switch(currentSortOrder){
        case (0, $9BYlQ.SortOrder).NO_ORDER:
            return (0, $9BYlQ.SortOrder).ASC;
        case (0, $9BYlQ.SortOrder).ASC:
            return (0, $9BYlQ.SortOrder).DESC;
        case (0, $9BYlQ.SortOrder).DESC:
            return (0, $9BYlQ.SortOrder).NO_ORDER;
    }
    return (0, $9BYlQ.SortOrder).NO_ORDER;
};
const $decaf4f5703baa00$var$getSortOrderLabel = (intl, currentSortOrder)=>{
    const { noneSortingLabel: noneSortingLabel, ascSortingLabel: ascSortingLabel, descSortingLabel: descSortingLabel } = (0, $1Bd5P.tableCellMessages);
    switch(currentSortOrder){
        case (0, $9BYlQ.SortOrder).NO_ORDER:
            return intl.formatMessage(noneSortingLabel);
        case (0, $9BYlQ.SortOrder).ASC:
            return intl.formatMessage(ascSortingLabel);
        case (0, $9BYlQ.SortOrder).DESC:
            return intl.formatMessage(descSortingLabel);
        default:
            return intl.formatMessage(noneSortingLabel);
    }
};
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $decaf4f5703baa00$var$getDataAttributes = (colwidth, background)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const attrs = {};
    if (colwidth) attrs['data-colwidth'] = colwidth.join(',');
    /**
   * Storing hex code in data-cell-background because
   *  we want to have DST token (css variable) or
   *  DST token value (value (hex code) of css variable) in
   *  inline style to correct render table cell background
   *  based on selected theme.
   * Currently we rely on background color hex code stored in
   *  inline style.
   * Because of that when we copy and paste table, we end up
   *  having DST token or DST token value in ADF instead of
   *  original hex code which we map to DST token.
   * So, introducing data-cell-background.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ if (background) attrs['data-cell-background'] = background;
    return attrs;
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $decaf4f5703baa00$var$cssVariablePattern = /^var\(--.*\)$/;
const $decaf4f5703baa00$var$getStyle = ({ background: background, colGroupWidth: colGroupWidth, offsetTop: offsetTop, colorMode: colorMode })=>{
    const style = {};
    if (background && // ignore setting inline styles if ds neutral token is detected
    !background.includes('--ds-background-neutral')) {
        /**
     * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
     * backgrounds persisted.
     *
     * This feature predates the introduction of dark mode.
     *
     * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-cell-background), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $hAs1r.hexToEditorBackgroundPaletteRawValue)(background);
        if (tokenColor) style.backgroundColor = tokenColor;
        else if (/**
     * There was previously a bug in dark mode where we would attempt to invert
     * a design token in `getDarkModeLCHColor` causing issues.
     * If it's a design token we should return it as is.
     */ $decaf4f5703baa00$var$cssVariablePattern.test(background)) style.backgroundColor = background;
        else // if we have a custom color, we need to check if we are in dark mode
        if (colorMode === 'dark') // if we are in dark mode, we need to invert the color
        style.backgroundColor = (0, $87j2U.getDarkModeLCHColor)(background);
        else // if we are in light mode, we can just set the color
        style.backgroundColor = background;
    }
    if (colGroupWidth) {
        style.width = colGroupWidth;
        style.minWidth = colGroupWidth;
    }
    if (offsetTop !== undefined) style.top = offsetTop;
    return style;
};
const $decaf4f5703baa00$var$getWithCellProps = (WrapperComponent)=>{
    return function WithCellProps(props) {
        const { colorMode: colorMode } = (0, $hxoiH.default)();
        const { children: children, className: className, onClick: onClick, colwidth: colwidth, colGroupWidth: colGroupWidth, rowspan: rowspan, colspan: colspan, background: background, offsetTop: offsetTop, ariaSort: ariaSort } = props;
        // This is used to set the background color of the cell
        // to a dark mode color in mobile dark mode
        const colorName = background ? (0, $9UDEr.tableBackgroundColorPalette).get(background) : '';
        return /*#__PURE__*/ (0, $2OMIu.jsx)(WrapperComponent, {
            rowSpan: rowspan,
            colSpan: colspan,
            // Note: When content from a renderer is pasted into an editor
            // the background color is not taken from the inline style.
            // Instead it is taken from the data-cell-background attribute
            // (added via getDataAttributes below).
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $decaf4f5703baa00$var$getStyle({
                background: background,
                colGroupWidth: colGroupWidth,
                offsetTop: offsetTop,
                colorMode: colorMode
            }),
            colorname: colorName,
            onClick: onClick,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ...$decaf4f5703baa00$var$getDataAttributes(colwidth, background),
            "aria-sort": ariaSort,
            children: children
        });
    };
};
const $decaf4f5703baa00$var$TH = $decaf4f5703baa00$var$getWithCellProps('th');
const $decaf4f5703baa00$export$cfca40ca5c56a38e = (WrapperComponent)=>{
    return function THWithSortableColumn(props) {
        const intl = (0, $koVbs.default)();
        const { allowColumnSorting: allowColumnSorting, onSorting: onSorting, children: children, sortOrdered: sortOrdered, isHeaderRow: isHeaderRow } = props;
        const sortOrderedClassName = sortOrdered === (0, $9BYlQ.SortOrder).NO_ORDER ? (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER : '';
        if (!allowColumnSorting || !isHeaderRow) // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $2OMIu.jsx)(WrapperComponent, {
            ...props
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)(WrapperComponent, {
            ...props,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_WRAPPER,
            ariaSort: $decaf4f5703baa00$var$getSortOrderLabel(intl, sortOrdered),
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                className: (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN,
                children: [
                    children,
                    /*#__PURE__*/ (0, $2OMIu.jsx)("figure", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: `${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER} ${sortOrderedClassName}`,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hrpWq.default), {
                            isSortingAllowed: !!onSorting,
                            sortOrdered: sortOrdered,
                            onClick: sort,
                            onKeyDown: onKeyPress
                        })
                    })
                ]
            })
        });
        function onKeyPress(event) {
            const keys = [
                ' ',
                'Enter',
                'Spacebar'
            ];
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const { tagName: tagName } = event.target;
            // trigger sorting if space or enter are clicked but not when in an input field (template variables)
            if (keys.includes(event.key) && !$decaf4f5703baa00$var$IgnoreSorting.includes(tagName)) {
                event.preventDefault();
                sort();
            }
        }
        function sort() {
            const { fireAnalyticsEvent: fireAnalyticsEvent, onSorting: onSorting, columnIndex: columnIndex, sortOrdered: sortOrdered } = props;
            if (onSorting && columnIndex != null) {
                const sortOrder = $decaf4f5703baa00$var$nextStatusOrder(sortOrdered);
                onSorting(columnIndex, sortOrder);
                fireAnalyticsEvent && fireAnalyticsEvent({
                    action: (0, $gkwXh.ACTION).SORT_COLUMN,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
                    attributes: {
                        platform: (0, $knXBU.PLATFORM).WEB,
                        mode: (0, $knXBU.MODE).RENDERER,
                        columnIndex: columnIndex,
                        sortOrder: sortOrder
                    },
                    eventType: (0, $gkwXh.EVENT_TYPE).TRACK
                });
            } else fireAnalyticsEvent && fireAnalyticsEvent({
                action: (0, $gkwXh.ACTION).SORT_COLUMN_NOT_ALLOWED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
                attributes: {
                    platform: (0, $knXBU.PLATFORM).WEB,
                    mode: (0, $knXBU.MODE).RENDERER
                },
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK
            });
        }
    };
};
const $decaf4f5703baa00$export$f850895b287ef28e = $decaf4f5703baa00$export$cfca40ca5c56a38e($decaf4f5703baa00$var$TH);
const $decaf4f5703baa00$var$TD = $decaf4f5703baa00$var$getWithCellProps('td');
const $decaf4f5703baa00$export$1e4baea7053fc0e3 = $decaf4f5703baa00$var$TD;

});
parcelRegister("hrpWq", function(module, exports) {

$parcel$export(module.exports, "default", () => $d33846969f29997f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $3bDjY = parcelRequire("3bDjY");

var $9BYlQ = parcelRequire("9BYlQ");


var $3hakN = parcelRequire("3hakN");
function $d33846969f29997f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $d33846969f29997f$export$c3618f310f725028 = /*#__PURE__*/ function(StatusClassNames) {
    StatusClassNames["ASC"] = "sorting-icon-svg__asc";
    StatusClassNames["DESC"] = "sorting-icon-svg__desc";
    StatusClassNames["NO_ORDER"] = "sorting-icon-svg__no_order";
    StatusClassNames["SORTING_NOT_ALLOWED"] = "sorting-icon-svg__not-allowed";
    return StatusClassNames;
}({});
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $d33846969f29997f$var$buttonStyles = /*#__PURE__*/ (0, $f8Sb3.css)("position:absolute;display:flex;height:28px;width:28px;margin:var(--ds-space-075, 6px);right:0;top:0;border:2px solid var(--ds-border, #fff);border-radius:var(--ds-border-radius-100, 4px);background-color:var(--ds-surface-overlay, #FFFFFF);justify-content:center;align-items:center;cursor:pointer;&:hover{background-color:var(--ds-surface-overlay-hovered, #F1F2F4);}&:active{background-color:var(--ds-surface-overlay-pressed, rgba(179, 212, 255, 0.6));}&.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "__not-allowed{cursor:not-allowed;}");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $d33846969f29997f$var$iconWrapperStyles = /*#__PURE__*/ (0, $f8Sb3.css)("width:8px;height:12px;transition:transform 0.3s cubic-bezier(0.15, 1, 0.3, 1);transform-origin:50% 50%;display:flex;justify-content:center;&.", "sorting-icon-svg__desc", "{transform:rotate(-180deg);}&.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "-inactive{opacity:0.7;}");
// The icon is created with CSS due to the following Firefox issue: https://product-fabric.atlassian.net/browse/ED-8001
// The TL;DR is that svg's in tables mess up how HTML is copied in Firefox. Using a styled div instead solves the problem.
// For this reason, svg's should be avoided in tables until this issue is fixed: https://bugzilla.mozilla.org/show_bug.cgi?id=1664350
const $d33846969f29997f$var$iconStyles = {
    name: "14n17e4",
    styles: "height:100%;width:2px;border-radius:50px;background:var(--ds-icon, #42526E);user-select:none;&::before, &::after{background:var(--ds-icon, #42526E);content:'';height:2px;width:6px;position:absolute;border-radius:50px;}&::before{transform:rotate(45deg) translate(3.4px, 8.5px);}&::after{transform:rotate(-45deg) translate(-6.3px, 5.7px);}"
};
const $d33846969f29997f$var$getIconClassName = (isSortingAllowed, sortOrdered)=>{
    const activated = sortOrdered !== (0, $9BYlQ.SortOrder).NO_ORDER;
    const activeStatusClass = `${(0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23)}-${activated ? 'active' : 'inactive'}`;
    if (!isSortingAllowed) return `${"sorting-icon-svg__not-allowed"} ${activeStatusClass}`;
    switch(sortOrdered){
        case (0, $9BYlQ.SortOrder).ASC:
            return `${"sorting-icon-svg__asc"} ${activeStatusClass}`;
        case (0, $9BYlQ.SortOrder).DESC:
            return `${"sorting-icon-svg__desc"} ${activeStatusClass}`;
        default:
            return `${"sorting-icon-svg__no_order"} ${activeStatusClass}`;
    }
};
const $d33846969f29997f$var$getTooltipTitle = (intl, isSortingAllowed, sortOrdered)=>{
    const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel } = (0, $3hakN.sortingIconMessages);
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $9BYlQ.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $9BYlQ.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $9BYlQ.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return '';
};
const $d33846969f29997f$var$getAriaLabel = (intl, isSortingAllowed, sortOrdered)=>{
    const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel, defaultLabel: defaultLabel } = (0, $3hakN.sortingAriaLabelMessages);
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $9BYlQ.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $9BYlQ.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $9BYlQ.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return intl.formatMessage(defaultLabel);
};
const $d33846969f29997f$var$SortingIcon = ({ isSortingAllowed: isSortingAllowed, sortOrdered: sortOrdered, intl: intl, onClick: onClick, onKeyDown: onKeyDown })=>{
    const buttonClassName = `${(0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23)} ${sortOrdered !== (0, $9BYlQ.SortOrder).NO_ORDER ? 'is-active' : ''}${isSortingAllowed ? '' : ` ${0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23}__not-allowed `}`;
    const content = $d33846969f29997f$var$getTooltipTitle(intl, isSortingAllowed, sortOrdered);
    const ariaLabel = $d33846969f29997f$var$getAriaLabel(intl, isSortingAllowed, sortOrdered);
    const handleClick = ()=>{
        if (isSortingAllowed) onClick();
    };
    const handleKeyDown = (event)=>{
        if (isSortingAllowed) onKeyDown(event);
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
        delay: 0,
        content: content,
        position: "top"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $d33846969f29997f$var$buttonStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: buttonClassName,
        role: "button",
        tabIndex: isSortingAllowed ? 0 : -1,
        "aria-label": ariaLabel,
        "aria-disabled": !isSortingAllowed,
        "aria-hidden": !isSortingAllowed,
        onClick: handleClick,
        onKeyDown: handleKeyDown
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $d33846969f29997f$var$iconWrapperStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $d33846969f29997f$var$getIconClassName(isSortingAllowed, sortOrdered)
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $d33846969f29997f$var$iconStyles
        ]
    }))));
};
var $d33846969f29997f$export$2e2bcd8739ae039 = (0, $8RXs9.default)($d33846969f29997f$var$SortingIcon);

});
const $75c933b3daaf1f19$export$bd4f24d8b1e86b23 = `ak-renderer-tableHeader-sorting-icon`;

parcelRegister("3hakN", function(module, exports) {

$parcel$export(module.exports, "sortingIconMessages", () => $c1f584a2cfc01515$export$458c50917513cd1a);
$parcel$export(module.exports, "sortingAriaLabelMessages", () => $c1f584a2cfc01515$export$f142573f51a67577);

var $7VHMR = parcelRequire("7VHMR");
const $c1f584a2cfc01515$export$458c50917513cd1a = (0, $7VHMR.defineMessages)({
    noOrderLabel: {
        id: 'fabric.editor.headingLink.noOrderLabel',
        defaultMessage: 'Sort column A to Z',
        description: 'Sort the column in ascending order'
    },
    ascOrderLabel: {
        id: 'fabric.editor.headingLink.ascOrderLabel',
        defaultMessage: 'Sort column Z to A',
        description: 'Sort the column in descending order'
    },
    descOrderLabel: {
        id: 'fabric.editor.headingLink.descOrderLabel',
        defaultMessage: 'Clear sorting',
        description: 'clear the sorting from this column'
    },
    invalidLabel: {
        id: 'fabric.editor.headingLink.invalidLabel',
        defaultMessage: `\u{26A0}\u{FE0F}  You can't sort a table with merged cells`,
        description: 'this sort is invalid for merged cells'
    }
});
const $c1f584a2cfc01515$export$f142573f51a67577 = (0, $7VHMR.defineMessages)({
    noOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.no',
        defaultMessage: 'No sort applied to the column',
        description: 'Aria-label for Sort column button when sorting was not applied or the sorting has been cleared'
    },
    ascOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.asc',
        defaultMessage: 'Ascending sort applied',
        description: 'Aria-label for Sort column button when ascending sorting was applied'
    },
    descOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.desc',
        defaultMessage: 'Descending sort applied',
        description: 'Aria-label for Sort column button when descending sorting was applied'
    },
    invalidLabel: {
        id: 'fabric.editor.tableHeader.sorting.invalid',
        defaultMessage: `You can't sort a table with merged cells`,
        description: 'Aria-label for Sort column button when sorting is not possible'
    },
    defaultLabel: {
        id: 'fabric.editor.tableHeader.sorting.default',
        defaultMessage: 'Sort the column',
        description: 'Default aria-label for Sort column button'
    }
});

});



parcelRegister("4BsEy", function(module, exports) {

$parcel$export(module.exports, "Provider", () => $3b927b61a8274f19$export$2881499e37b75b9a);
$parcel$export(module.exports, "withSmartCardStorage", () => $3b927b61a8274f19$export$65e2d5a272a382b0);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $3b927b61a8274f19$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(new Map());
const $3b927b61a8274f19$export$2881499e37b75b9a = function({ children: children }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)($3b927b61a8274f19$export$841858b892ce1f4c.Provider, {
        value: new Map(),
        children: children
    });
};
const $3b927b61a8274f19$export$65e2d5a272a382b0 = (WrappedComponent)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/prefer-stateless-function
    return class extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
        render() {
            return /*#__PURE__*/ (0, $2OMIu.jsx)($3b927b61a8274f19$export$841858b892ce1f4c.Consumer, {
                children: (storage)=>/*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
                        ...this.props,
                        smartCardStorage: storage
                    })
            });
        }
    };
};

});

parcelRegister("2aXGN", function(module, exports) {

$parcel$export(module.exports, "tableStickyPadding", () => $9b3e020198447653$export$3de6413b528017ca);
$parcel$export(module.exports, "StickyTable", () => $9b3e020198447653$export$fd9654fc359d55a3);
$parcel$export(module.exports, "OverflowParent", () => $9b3e020198447653$export$e97bc6692974bd0b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $6gEe5 = parcelRequire("6gEe5");

var $iHYdz = parcelRequire("iHYdz");


var $VSDnB = parcelRequire("VSDnB");

var $a4mor = parcelRequire("a4mor");

var $6cOrl = parcelRequire("6cOrl");
function $9b3e020198447653$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9b3e020198447653$export$3de6413b528017ca = 8;
const $9b3e020198447653$var$modeSpecficStyles = {
    none: {
        name: "eivff4",
        styles: "display:none"
    },
    stick: {
        name: "duudsh",
        styles: "position:fixed"
    },
    'pin-bottom': {
        name: "a4hmbt",
        styles: "position:absolute"
    }
};
// refactored based on fixedTableDivStaticStyles
// TODO: DSP-4123 - Quality ticket
const $9b3e020198447653$var$fixedTableDivStaticStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    zIndex: 'var(--ak-renderer-sticky-header-zindex)',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}, & .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        marginTop: 0,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        tr: {
            background: "var(--ds-surface, white)"
        }
    },
    borderTop: `${$9b3e020198447653$export$3de6413b528017ca}px solid ${"var(--ds-surface, white)"}`,
    background: "var(--ds-surface-overlay, white)",
    boxShadow: `0 6px 4px -4px ${`var(--ds-shadow-overflow-perimeter, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "div[data-expanded='false'] &": {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.right-shadow::after, & .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.left-shadow::before`]: {
        top: '0px',
        height: '100%'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "&.fixed-table-div-custom-table-resizing[mode='stick']": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: 'var(--ak-renderer-sticky-header-zindex)'
    }
});
const $9b3e020198447653$var$FixedTableDiv = (props)=>{
    const { top: top, wrapperWidth: wrapperWidth, mode: mode, allowTableResizing: allowTableResizing } = props;
    let stickyHeaderZIndex;
    if (allowTableResizing) stickyHeaderZIndex = 13;
    else stickyHeaderZIndex = (0, $iHYdz.akEditorStickyHeaderZIndex);
    const attrs = {
        mode: mode
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...attrs,
        "data-testid": "sticky-table-fixed",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: allowTableResizing ? 'fixed-table-div-custom-table-resizing' : '',
        css: [
            $9b3e020198447653$var$fixedTableDivStaticStyles,
            $9b3e020198447653$var$modeSpecficStyles?.[mode]
        ],
        style: {
            '--ak-renderer-sticky-header-zindex': stickyHeaderZIndex,
            width: `${wrapperWidth}px`,
            top: (0, $VSDnB.fg)('sticky_header_in_embedded_confluence_fix') ? typeof top === 'number' ? `${top}px` : undefined : top ? `${top}px` : undefined
        }
    }, props.children);
};
const $9b3e020198447653$export$fd9654fc359d55a3 = ({ top: top, left: left, mode: mode, shadowClassNames: shadowClassNames, innerRef: innerRef, wrapperWidth: wrapperWidth, tableWidth: tableWidth, isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, children: children, columnWidths: columnWidths, renderWidth: renderWidth, rowHeight: rowHeight, tableNode: tableNode, rendererAppearance: rendererAppearance, allowTableResizing: allowTableResizing, fixTableSSRResizing: fixTableSSRResizing = false })=>{
    let styles;
    /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ if (allowTableResizing) styles = /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: mode === 'pin-bottom' ? top : undefined,
        position: 'absolute'
    });
    else styles = /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        left: left && left < 0 ? left : undefined,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: mode === 'pin-bottom' ? top : undefined,
        position: 'relative'
    });
    /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: styles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)($9b3e020198447653$var$FixedTableDiv, {
        top: mode === 'stick' ? top : undefined,
        mode: rowHeight > 300 ? 'none' : mode,
        wrapperWidth: wrapperWidth,
        allowTableResizing: allowTableResizing
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER} is-sticky ${shadowClassNames || ''}`,
        "data-layout": layout,
        style: {
            width: tableWidth,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginBottom: fixTableSSRResizing ? 0 : ''
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER}`,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $a4mor.Table), {
        columnWidths: columnWidths,
        layout: layout,
        isNumberColumnEnabled: isNumberColumnEnabled,
        renderWidth: renderWidth,
        tableNode: tableNode,
        rendererAppearance: rendererAppearance,
        fixTableSSRResizing: fixTableSSRResizing
    }, /**
               * @see https://product-fabric.atlassian.net/browse/ED-10235
               * We pass prop 'invisible' to our table's children nodes meaning
               * they exist inside of the 'invisible' duplicated table component that
               * enables sticky headers.
               */ (0, $6cOrl.recursivelyInjectProps)(children, {
        invisible: true
    })))))));
};
/**
 * Traverse DOM Tree upwards looking for table parents with "overflow: scroll".
 * @param table
 * @param defaultScrollRootId
 * @example
 */ function $9b3e020198447653$var$findHorizontalOverflowScrollParent(table, defaultScrollRootId) {
    let parent = table;
    if (!parent) return null;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while(parent = parent.parentElement){
        // IE11 on Window 8 doesn't show styles from CSS when accessing through element.style property.
        const style = window.getComputedStyle(parent);
        if (style.overflow === 'scroll' || style.overflowY === 'scroll') return parent;
        if (!!defaultScrollRootId && parent.id === defaultScrollRootId) // If a defaultScrollRootId was specified and we reached the element with this id without finding a closer
        // scroll parent, use this element as the scroll parent
        return parent;
    }
    return null;
}
class $9b3e020198447653$export$e97bc6692974bd0b {
    constructor(ref){
        this.ref = ref;
        this.ref = ref;
    }
    /**
   *
   * @param el
   * @param defaultScrollRootId
   * @example
   */ static fromElement(el, defaultScrollRootId) {
        return new $9b3e020198447653$export$e97bc6692974bd0b($9b3e020198447653$var$findHorizontalOverflowScrollParent(el, defaultScrollRootId) || window);
    }
    /**
   *
   */ get isElement() {
        return this.ref instanceof HTMLElement;
    }
    /**
   *
   */ get id() {
        if (this.ref instanceof HTMLElement) return this.ref.id;
        return '';
    }
    /**
   *
   */ get top() {
        if (this.ref instanceof HTMLElement) return this.ref.getBoundingClientRect().top;
        return 0;
    }
    /**
   *
   * @param type
   * @param cb
   * @param {...any} args
   * @example
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    addEventListener(type, cb, ...args) {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.ref.addEventListener(type, cb, ...args);
    }
    /**
   *
   * @param type
   * @param cb
   * @param {...any} args
   * @example
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    removeEventListener(type, cb, ...args) {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.ref.removeEventListener(type, cb, ...args);
    }
}

});
parcelRegister("a4mor", function(module, exports) {

$parcel$export(module.exports, "Table", () => $40c6d2c88bc98a0d$export$54ec01a60f47d33d);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3nHPA = parcelRequire("3nHPA");

var $fKLIs = parcelRequire("fKLIs");

var $iHYdz = parcelRequire("iHYdz");

var $VSDnB = parcelRequire("VSDnB");
const $40c6d2c88bc98a0d$export$54ec01a60f47d33d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ innerRef: innerRef, isNumberColumnEnabled: isNumberColumnEnabled, columnWidths: columnWidths, layout: layout, renderWidth: renderWidth, children: children, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableResizing: allowTableResizing, isPresentational: isPresentational, fixTableSSRResizing: fixTableSSRResizing = false })=>{
    let tableWidth = tableNode ? (0, $fKLIs.getTableContainerWidth)(tableNode) : (0, $iHYdz.akEditorDefaultLayoutWidth);
    if (rendererAppearance === 'comment' && allowTableResizing && tableNode && !tableNode.attrs?.width) tableWidth = 'inherit';
    if (rendererAppearance === 'comment' && !allowTableResizing) // in the case we have css container stylings,
    // we don't need to calculate width here as this
    // is done via css
    {
        if (!(0, $VSDnB.fg)('platform-ssr-table-resize')) tableWidth = renderWidth;
    }
    const tableLayout = tableNode?.attrs.layout;
    const tableDisplayMode = tableNode?.attrs.displayMode;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("table", {
        ...(0, $VSDnB.fg)('platform_renderer_isPresentational') && {
            role: isPresentational ? 'presentation' : undefined
        },
        "data-testid": "renderer-table",
        "data-number-column": isNumberColumnEnabled,
        "data-table-width": tableWidth,
        "data-layout": tableLayout,
        "data-table-display-mode": tableDisplayMode,
        ref: innerRef,
        style: {
            marginTop: fixTableSSRResizing ? '0px' : ''
        },
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3nHPA.Colgroup), {
                columnWidths: columnWidths,
                layout: layout,
                isNumberColumnEnabled: isNumberColumnEnabled,
                renderWidth: renderWidth,
                tableNode: tableNode,
                rendererAppearance: rendererAppearance,
                isInsideOfBlockNode: isInsideOfBlockNode,
                isInsideOfTable: isInsideOfTable,
                isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
                allowTableResizing: allowTableResizing
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("tbody", {
                children: children
            })
        ]
    });
});

});
parcelRegister("3nHPA", function(module, exports) {

$parcel$export(module.exports, "Colgroup", () => $ae0cfecd7422435f$export$89efc2d0ceeaa030);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6gEe5 = parcelRequire("6gEe5");

var $iHYdz = parcelRequire("iHYdz");

var $gmhCD = parcelRequire("gmhCD");

var $fKLIs = parcelRequire("fKLIs");

var $9JDnL = parcelRequire("9JDnL");

var $dyURG = parcelRequire("dyURG");
// we allow scaling down column widths by no more than 30%
// this intends to reduce unwanted scrolling in the Renderer in these scenarios:
// User A creates a table with column widths → User B views it on a smaller screen
// User A creates a table with column widths → User A views it with reduced viewport space (eg. Confluence sidebar is open)
const $ae0cfecd7422435f$var$MAX_SCALING_PERCENT = 0.3;
const $ae0cfecd7422435f$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION = 0.4;
const $ae0cfecd7422435f$var$isTableColumnResized = (columnWidths)=>{
    const filteredWidths = columnWidths.filter((width)=>width !== 0);
    return !!filteredWidths.length;
};
const $ae0cfecd7422435f$var$fixColumnWidth = (columnWidth, _tableWidth, _layoutWidth, zeroWidthColumnsCount, scaleDownPercent)=>{
    if (columnWidth === 0) return columnWidth;
    // If the tables total width (including no zero widths col or cols without width) is less than the current layout
    // We scale up the columns to meet the minimum of the table layout.
    if (zeroWidthColumnsCount === 0 && scaleDownPercent) return Math.max(Math.floor((1 - scaleDownPercent) * columnWidth), (0, $6gEe5.tableCellMinWidth));
    return Math.max(// We need to take tableCellBorderWidth, to avoid unnecessary overflow.
    columnWidth - (0, $6gEe5.tableCellBorderWidth), zeroWidthColumnsCount ? (0, $iHYdz.akEditorTableLegacyCellMinWidth) : (0, $6gEe5.tableCellMinWidth));
};
const $ae0cfecd7422435f$var$calcScalePercent = ({ renderWidth: renderWidth, tableWidth: tableWidth, maxScale: maxScale, isNumberColumnEnabled: isNumberColumnEnabled })=>{
    const noNumColumnScalePercent = renderWidth / tableWidth;
    // when numbered column is enabled, we need to calculate the scale percent without the akEditorTableNumberColumnWidth
    // As numbered column width is not scaled down
    const numColumnScalePercent = (renderWidth - (0, $iHYdz.akEditorTableNumberColumnWidth)) / (tableWidth - (0, $iHYdz.akEditorTableNumberColumnWidth));
    const diffPercent = 1 - noNumColumnScalePercent;
    return diffPercent < maxScale ? isNumberColumnEnabled ? 1 - numColumnScalePercent : diffPercent : maxScale;
};
const $ae0cfecd7422435f$var$colWidthSum = (columnWidths)=>columnWidths.reduce((prev, curr)=>curr + prev, 0);
const $ae0cfecd7422435f$var$renderScaleDownColgroup = (props)=>{
    const { columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled, renderWidth: renderWidth, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, isTableScalingEnabled: isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled, allowTableResizing: allowTableResizing, isTopLevelRenderer: isTopLevelRenderer } = props;
    if (!columnWidths) return [];
    const tableColumnResized = $ae0cfecd7422435f$var$isTableColumnResized(columnWidths);
    const noOfColumns = columnWidths.length;
    let targetWidths;
    // This is a fix for ED-23259
    // Some extensions (for ex: Page Properties or Excerpt) do not renderer tables directly inside themselves. They use ReactRenderer.
    // So if we add a check like isInsideExtension (similar to exising isInsideBlockNode), it will fail, and to the only way to learn
    // if the table is rendered inside another node, is to check if the Renderer itself is nested.
    const isRendererNested = isTopLevelRenderer === false;
    // appearance == comment && allowTableResizing && !tableNode?.attrs.width, means it is a comment
    // appearance == comment && !allowTableResizing && !tableNode?.attrs.width, means it is a inline comment
    // When comment and inline comment table width inherits from the parent container, we want tableContainerWidth === renderWidth
    const tableContainerWidth = rendererAppearance === 'comment' && !tableNode?.attrs.width || isRendererNested ? renderWidth : (0, $fKLIs.getTableContainerWidth)(tableNode);
    if (allowTableResizing && !isInsideOfBlockNode && !isInsideOfTable && !isinsideMultiBodiedExtension && !tableColumnResized) {
        // when no columns are resized, each column should have equal width, equals to tableWidth / noOfColumns
        const tableWidth = (isNumberColumnEnabled ? tableContainerWidth - (0, $iHYdz.akEditorTableNumberColumnWidth) : tableContainerWidth) - 1;
        const defaultColumnWidth = tableWidth / noOfColumns;
        targetWidths = new Array(noOfColumns).fill(defaultColumnWidth);
    } else if (!tableColumnResized) return null;
    const sumOfColumns = $ae0cfecd7422435f$var$colWidthSum(columnWidths);
    // tables in the wild may be smaller than table container width (col resizing bugs, created before custom widths etc.)
    // this causes issues with num column scaling as we add a new table column in renderer
    const isTableSmallerThanContainer = sumOfColumns < tableContainerWidth - 1;
    const forceScaleForNumColumn = isTableScalingEnabled && isNumberColumnEnabled && tableColumnResized;
    // when table resized and number column is enabled, we need to scale down the table in render
    if (forceScaleForNumColumn) {
        const scalePercentage = +((tableContainerWidth - (0, $iHYdz.akEditorTableNumberColumnWidth)) / tableContainerWidth);
        const targetMaxWidth = tableContainerWidth - (0, $iHYdz.akEditorTableNumberColumnWidth);
        let totalWidthAfterScale = 0;
        const newScaledTargetWidths = columnWidths.map((width)=>{
            // we need to scale each column UP, to ensure total width of table matches table container
            const patchedWidth = isTableSmallerThanContainer ? width / sumOfColumns * (tableContainerWidth - 1) : width;
            const newWidth = Math.floor(patchedWidth * scalePercentage);
            totalWidthAfterScale += newWidth;
            return newWidth;
        });
        const diff = targetMaxWidth - totalWidthAfterScale;
        targetWidths = newScaledTargetWidths;
        if (diff > 0 || diff < 0 && Math.abs(diff) < (0, $6gEe5.tableCellMinWidth)) {
            let updated = false;
            targetWidths = targetWidths.map((width)=>{
                if (!updated && width + diff > (0, $6gEe5.tableCellMinWidth)) {
                    updated = true;
                    width += diff;
                }
                return width;
            });
        }
    }
    targetWidths = targetWidths || columnWidths;
    // @see ED-6056
    const maxTableWidth = renderWidth < tableContainerWidth ? renderWidth : tableContainerWidth;
    let tableWidth = isNumberColumnEnabled ? (0, $iHYdz.akEditorTableNumberColumnWidth) : 0;
    let minTableWidth = tableWidth;
    let zeroWidthColumnsCount = 0;
    targetWidths.forEach((width)=>{
        if (width) tableWidth += Math.ceil(width);
        else zeroWidthColumnsCount += 1;
        minTableWidth += Math.ceil(width) || (0, $iHYdz.akEditorTableLegacyCellMinWidth);
    });
    let cellMinWidth = 0;
    let scaleDownPercent = 0;
    const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled;
    const isTableWidthFixed = isTableScalingWithFixedColumnWidthsOptionEnabled && props.tableNode?.attrs.displayMode === 'fixed';
    const maxScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && rendererAppearance === 'comment' ? $ae0cfecd7422435f$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION : $ae0cfecd7422435f$var$MAX_SCALING_PERCENT;
    // fixes migration tables with zero-width columns
    if (zeroWidthColumnsCount > 0) {
        if (minTableWidth > maxTableWidth) {
            const minWidth = Math.ceil((maxTableWidth - tableWidth) / zeroWidthColumnsCount);
            cellMinWidth = minWidth < (0, $iHYdz.akEditorTableLegacyCellMinWidth) ? (0, $iHYdz.akEditorTableLegacyCellMinWidth) : minWidth;
        }
    } else if (renderWidth < tableWidth && !isTableWidthFixed) {
        const shouldTable100ScaleDown = rendererAppearance === 'comment' && allowTableResizing && !tableNode?.attrs.width;
        scaleDownPercent = $ae0cfecd7422435f$var$calcScalePercent({
            renderWidth: renderWidth,
            tableWidth: tableWidth,
            maxScale: shouldTable100ScaleDown ? 1 : maxScalingPercent,
            isNumberColumnEnabled: isNumberColumnEnabled
        });
    }
    return targetWidths.map((colWidth)=>{
        const width = $ae0cfecd7422435f$var$fixColumnWidth(colWidth, minTableWidth, maxTableWidth, zeroWidthColumnsCount, scaleDownPercent) || cellMinWidth;
        const style = width ? {
            width: `${width}px`
        } : {};
        return style;
    });
};
const $ae0cfecd7422435f$export$89efc2d0ceeaa030 = (props)=>{
    const { isTopLevelRenderer: isTopLevelRenderer } = (0, $dyURG.useRendererContext)();
    const { columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled } = props;
    const flags = (0, $9JDnL.useFeatureFlags)();
    if (!columnWidths) return null;
    const colStyles = $ae0cfecd7422435f$var$renderScaleDownColgroup({
        ...props,
        isTopLevelRenderer: isTopLevelRenderer,
        isTableScalingEnabled: props.rendererAppearance === 'full-page' || props.rendererAppearance === 'full-width' || props.rendererAppearance === 'comment' && (0, $gmhCD.editorExperiment)('support_table_in_comment', true, {
            exposure: true
        }) || props.rendererAppearance === 'comment' && (0, $gmhCD.editorExperiment)('support_table_in_comment_jira', true, {
            exposure: true
        }),
        isTableFixedColumnWidthsOptionEnabled: !!(flags && 'tableWithFixedColumnWidthsOption' in flags && flags.tableWithFixedColumnWidthsOption) && (props.rendererAppearance === 'full-page' || props.rendererAppearance === 'full-width')
    });
    if (!colStyles) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("colgroup", {
        children: [
            isNumberColumnEnabled && /*#__PURE__*/ (0, $2OMIu.jsx)("col", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                style: {
                    width: (0, $iHYdz.akEditorTableNumberColumnWidth)
                },
                "data-test-id": 'num'
            }),
            colStyles.map((style, idx)=>// Ignored via go/ees005
                // eslint-disable-next-line react/no-array-index-key, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $2OMIu.jsx)("col", {
                    style: style
                }, idx))
        ]
    });
};

});
parcelRegister("9JDnL", function(module, exports) {

$parcel$export(module.exports, "useFeatureFlags", () => $7cc75954bd6ebac0$export$90335b3ff08f335);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $dyURG = parcelRequire("dyURG");
const $7cc75954bd6ebac0$export$90335b3ff08f335 = ()=>(0, $dyURG.useRendererContext)()?.featureFlags;

});
parcelRegister("dyURG", function(module, exports) {

$parcel$export(module.exports, "useRendererContext", () => $6d8aa882825f4203$export$a906432540ed7ed8);
$parcel$export(module.exports, "RendererContextProvider", () => $6d8aa882825f4203$export$ca5df47902194781);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $5uXOq = parcelRequire("5uXOq");
const $6d8aa882825f4203$var$RendererContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({});
const $6d8aa882825f4203$export$a906432540ed7ed8 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($6d8aa882825f4203$var$RendererContext);
const $6d8aa882825f4203$export$ca5df47902194781 = $6d8aa882825f4203$var$RendererContext.Provider;

});




parcelRegister("6cOrl", function(module, exports) {

$parcel$export(module.exports, "recursivelyInjectProps", () => $7a2ba32d880ccda8$export$40e12ce8e0a76b0c);

var $5uXOq = parcelRequire("5uXOq");
function $7a2ba32d880ccda8$export$40e12ce8e0a76b0c(children, propsToInject) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children).map((child)=>{
        // Cannot add a prop to an invalid element, so just return the child
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) return child;
        // Recursive call if child has nested children
        if (child.props.children) child = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
            children: $7a2ba32d880ccda8$export$40e12ce8e0a76b0c(child.props.children, propsToInject)
        });
        // Add props to react child node
        return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, propsToInject);
    });
}

});


parcelRegister("kjIja", function(module, exports) {

$parcel$export(module.exports, "isFullWidthAppearance", () => $b5d34963b73650ed$export$c0112b8340d4924b);
$parcel$export(module.exports, "isFullPageAppearance", () => $b5d34963b73650ed$export$a64737a81cde10b4);
$parcel$export(module.exports, "isCommentAppearance", () => $b5d34963b73650ed$export$f77d2ff45b2c53ed);
$parcel$export(module.exports, "isFullWidthOrFullPageAppearance", () => $b5d34963b73650ed$export$33331a99fac775a1);
const $b5d34963b73650ed$export$c0112b8340d4924b = (appearance)=>appearance === 'full-width';
const $b5d34963b73650ed$export$a64737a81cde10b4 = (appearance)=>appearance === 'full-page';
const $b5d34963b73650ed$export$f77d2ff45b2c53ed = (appearance)=>appearance === 'comment';
const $b5d34963b73650ed$export$33331a99fac775a1 = (appearance)=>$b5d34963b73650ed$export$a64737a81cde10b4(appearance) || $b5d34963b73650ed$export$c0112b8340d4924b(appearance);

});

parcelRegister("eIscD", function(module, exports) {

$parcel$export(module.exports, "TableStickyScrollbar", () => $ea0307076d72d83e$export$8c072780619cfc83);

var $6gEe5 = parcelRequire("6gEe5");

var $VSDnB = parcelRequire("VSDnB");
class $ea0307076d72d83e$export$8c072780619cfc83 {
    constructor(wrapper){
        this.sentinels = {};
        this.handleScroll = (event)=>{
            if (!this.stickyScrollbarContainerElement || !this.wrapper || event.target !== this.stickyScrollbarContainerElement) return;
            this.wrapper.scrollLeft = this.stickyScrollbarContainerElement.scrollLeft;
        };
        this.wrapper = wrapper;
        this.init();
    }
    dispose() {
        if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.removeEventListener('scroll', this.handleScroll);
        this.deleteIntersectionObserver();
    }
    scrollLeft(left) {
        if (this.stickyScrollbarContainerElement) this.stickyScrollbarContainerElement.scrollLeft = left;
    }
    init() {
        if (!this.wrapper) return;
        const scrollbarContainers = this.wrapper.parentElement?.querySelectorAll(`.${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`);
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.stickyScrollbarContainerElement = (0, $VSDnB.fg)('platform_editor_querySelector_fix_table_renderer') ? scrollbarContainers?.item(scrollbarContainers.length - 1) : this.wrapper.parentElement?.querySelector(`.${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`);
        if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.addEventListener('scroll', this.handleScroll, {
            passive: true
        });
        this.createIntersectionObserver();
    }
    createIntersectionObserver() {
        this.rendererScrollableElement = window.document;
        if (!this.rendererScrollableElement || !this.wrapper) return;
        this.intersectionObserver = new IntersectionObserver((entries, _)=>{
            if (!this.stickyScrollbarContainerElement) return;
            entries.forEach((entry)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const target = entry.target;
                if (target.classList.contains((0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)) this.sentinelBottomCallback(entry);
                if (target.classList.contains((0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)) this.sentinelTopCallback(entry);
            });
        }, {
            root: this.rendererScrollableElement
        });
        const bottomSentinels = this.wrapper?.parentElement?.getElementsByClassName((0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM);
        this.sentinels.bottom = (0, $VSDnB.fg)('platform_editor_querySelector_fix_table_renderer') ? bottomSentinels?.item(bottomSentinels.length - 1) : this.wrapper?.parentElement?.getElementsByClassName((0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)?.item(0);
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.sentinels.top = this.wrapper?.parentElement?.getElementsByClassName((0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)?.item(0);
        [
            this.sentinels.bottom,
            this.sentinels.top
        ].forEach((el)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.intersectionObserver.observe(el));
    }
    deleteIntersectionObserver() {
        if (this.intersectionObserver) {
            if (this.sentinels.bottom) this.intersectionObserver.unobserve(this.sentinels.bottom);
            this.intersectionObserver.disconnect();
        }
    }
    sentinelBottomCallback(entry) {
        const sentinelIsAboveScrollArea = entry.boundingClientRect.top < (entry.rootBounds?.top || 0);
        this.bottomSentinelState = sentinelIsAboveScrollArea ? 'above' : entry.isIntersecting ? 'visible' : 'below';
        this.toggle();
    }
    sentinelTopCallback(entry) {
        const sentinelIsBelowScrollArea = (entry.rootBounds?.bottom || 0) < entry.boundingClientRect.top;
        this.topSentinelState = sentinelIsBelowScrollArea ? 'below' : entry.isIntersecting ? 'visible' : 'above';
        this.toggle();
    }
    toggle() {
        if ((this.topSentinelState === 'visible' || this.topSentinelState === 'above') && this.bottomSentinelState === 'below') this.show();
        else this.hide();
    }
    hide() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'hidden') this.stickyScrollbarContainerElement.style.visibility = 'hidden';
    }
    show() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'visible') this.stickyScrollbarContainerElement.style.visibility = 'visible';
    }
}

});

parcelRegister("cInAA", function(module, exports) {

$parcel$export(module.exports, "TableProcessorWithContainerStyles", () => $ef3de7a711c9e97e$export$827f89182557f335);
/* eslint-disable @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/enforce-style-prop, @repo/internal/react/no-class-components */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6gEe5 = parcelRequire("6gEe5");

var $fKLIs = parcelRequire("fKLIs");


var $VSDnB = parcelRequire("VSDnB");

var $5vnE9 = parcelRequire("5vnE9");
var $5or39 = parcelRequire("5or39");
var $5J0oM = parcelRequire("5J0oM");

var $9BYlQ = parcelRequire("9BYlQ");

var $iHYdz = parcelRequire("iHYdz");

var $gmhCD = parcelRequire("gmhCD");

var $cWojJ = parcelRequire("cWojJ");

var $2aXGN = parcelRequire("2aXGN");

var $a4mor = parcelRequire("a4mor");

var $kjIja = parcelRequire("kjIja");

var $eIscD = parcelRequire("eIscD");
const $ef3de7a711c9e97e$var$stickyContainerBaseStyles = {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    height: "var(--ds-space-250, 20px)",
    // MAX_BROWSER_SCROLLBAR_HEIGHT
    // Follow editor to hide by default so it does not show empty gap in SSR
    // https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/platform/packages/editor/editor-plugin-table/src/nodeviews/TableComponent.tsx#957
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    display: 'block',
    width: '100%'
};
const $ef3de7a711c9e97e$var$stickyContainerAdditionalStyles = {
    visibility: 'hidden',
    overflowX: 'auto',
    position: 'sticky',
    bottom: "var(--ds-space-0, 0px)",
    zIndex: 1
};
const $ef3de7a711c9e97e$export$eec82c0a93aa66d9 = (appearance)=>(0, $kjIja.isFullWidthOrFullPageAppearance)(appearance) || (0, $kjIja.isCommentAppearance)(appearance) && (0, $gmhCD.editorExperiment)('support_table_in_comment', true, {
        exposure: true
    });
const $ef3de7a711c9e97e$export$bdb2dadcb04aad50 = (appearance)=>(0, $kjIja.isFullWidthOrFullPageAppearance)(appearance) && (0, $gmhCD.editorExperiment)('platform_renderer_table_sticky_scrollbar', true, {
        exposure: true
    });
const $ef3de7a711c9e97e$export$334894231c46c1a5 = (children, tableNode, smartCardStorage, tableOrderStatus)=>{
    if (!tableOrderStatus || tableOrderStatus.order === (0, $9BYlQ.SortOrder).NO_ORDER) return children;
    const { order: order, columnIndex: columnIndex } = tableOrderStatus;
    const compareNodesInOrder = (0, $5J0oM.createCompareNodes)({
        getInlineCardTextFromStore (attrs) {
            const { url: url } = attrs;
            if (!url) return null;
            return smartCardStorage.get(url) || null;
        }
    }, order);
    const tableArray = (0, $5or39.convertProsemirrorTableNodeToArrayOfRows)(tableNode);
    const tableArrayWithChildren = tableArray.map((rowNodes, index)=>({
            rowNodes: rowNodes,
            rowReact: children[index]
        }));
    const headerRow = tableArrayWithChildren.shift();
    const sortedTable = tableArrayWithChildren.sort((rowA, rowB)=>compareNodesInOrder(rowA.rowNodes[columnIndex], rowB.rowNodes[columnIndex]));
    if (headerRow) sortedTable.unshift(headerRow);
    return sortedTable.map((elem)=>elem.rowReact);
};
const $ef3de7a711c9e97e$export$42f5658c8e0092da = (row)=>{
    let hasRowspan = false;
    row.forEach((cell)=>hasRowspan = hasRowspan || cell.attrs.rowspan > 1);
    return hasRowspan;
};
const $ef3de7a711c9e97e$export$f422245984b0eda7 = (refElement)=>{
    return Math.round(refElement.getBoundingClientRect().top);
};
const $ef3de7a711c9e97e$export$7c141112f3c89f11 = (scrollTop, tableTop, tableBottom, rowHeight)=>tableTop <= scrollTop && !(tableBottom - rowHeight <= scrollTop);
const $ef3de7a711c9e97e$export$89f3188e1adc30d5 = (scrollTop, tableBottom, rowHeight)=>tableBottom - rowHeight <= scrollTop && !(tableBottom < scrollTop);
const $ef3de7a711c9e97e$export$100baa0f10804e6e = (rows, tableOrderStatus, onSorting)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(rows, (row, index)=>{
        if (index === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.only(row), {
            tableOrderStatus: tableOrderStatus,
            onSorting: onSorting
        });
        return row;
    });
};
const $ef3de7a711c9e97e$export$28daf78feed5098c = (rows)=>{
    if (!rows.length) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { children: children } = rows[0].props;
    if (!children.length) return false;
    if (children.length === 1) return children[0].type === (0, $cWojJ.TableHeader);
    return children.every((node)=>node.type === (0, $cWojJ.TableHeader));
};
const $ef3de7a711c9e97e$export$940095e914312886 = (node, children)=>{
    return $ef3de7a711c9e97e$export$28daf78feed5098c(children) && node && node.firstChild && !$ef3de7a711c9e97e$export$42f5658c8e0092da(node.firstChild);
};
class $ef3de7a711c9e97e$export$f2c3aea42b2a048f extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    /**
   *
   * @example
   */ componentDidMount() {
        this.resizeObserver = new ResizeObserver(this.applyResizerChange);
        if (this.wrapperRef.current) this.resizeObserver.observe(this.wrapperRef.current);
        if (this.stickyHeaderRef.current) this.resizeObserver.observe(this.stickyHeaderRef.current);
        if (this.props.stickyHeaders) {
            this.overflowParent = (0, $2aXGN.OverflowParent).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.addEventListener('scroll', this.onScroll);
        }
        if (this.wrapperRef.current && $ef3de7a711c9e97e$export$bdb2dadcb04aad50(this.props.rendererAppearance)) this.stickyScrollbar = new (0, $eIscD.TableStickyScrollbar)(this.wrapperRef.current);
    }
    /**
   *
   * @param prevProps
   * @param prevState
   * @example
   */ componentDidUpdate(prevProps, prevState) {
        // toggling sticky headers visiblity
        if (this.props.stickyHeaders && !this.overflowParent) this.overflowParent = (0, $2aXGN.OverflowParent).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
        else if (!this.props.stickyHeaders && this.overflowParent) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            this.overflowParent = null;
        }
        // offsetTop might have changed, re-position sticky header
        if (this.props.stickyHeaders !== prevProps.stickyHeaders) this.updateSticky();
        // sync horizontal scroll in floating div when toggling modes
        if (prevState.stickyMode !== this.state.stickyMode) this.onWrapperScrolled();
    }
    /**
   *
   */ get pinTop() {
        if (!this.tableRef.current || !this.stickyHeaderRef.current) return;
        return this.tableRef.current.offsetHeight - this.stickyHeaderRef.current.offsetHeight + (0, $6gEe5.tableMarginTop) - (0, $2aXGN.tableStickyPadding);
    }
    /**
   *
   */ get shouldAddOverflowParentOffsetTop_DO_NOT_USE() {
        // IF the StickyHeaderConfig specifies that the default scroll root offsetTop should be added
        // AND the StickyHeaderConfig specifies a default scroll root id
        // AND the OverflowParent is the corresponding element
        // THEN we should add the OverflowParent offset top (RETURN TRUE)
        return this.props.stickyHeaders && !!this.props.stickyHeaders.shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE && !!this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE && this.overflowParent && this.overflowParent.id === this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE;
    }
    /**
   *
   */ get stickyTop() {
        switch(this.state.stickyMode){
            case 'pin-bottom':
                return this.pinTop;
            case 'stick':
                const offsetTop = this.props.stickyHeaders && this.props.stickyHeaders.offsetTop;
                if (typeof offsetTop === 'number' && this.shouldAddOverflowParentOffsetTop_DO_NOT_USE) {
                    const overflowParentOffsetTop = this.overflowParent ? this.overflowParent.top : 0;
                    return offsetTop + overflowParentOffsetTop;
                } else return offsetTop;
            default:
                return undefined;
        }
    }
    /**
   *
   * @example
   */ render() {
        const { isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, columnWidths: columnWidths, stickyHeaders: stickyHeaders, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableAlignment: allowTableAlignment, allowTableResizing: allowTableResizing, isPresentational: isPresentational } = this.props;
        const { stickyMode: stickyMode } = this.state;
        const lineLengthFixedWidth = (0, $iHYdz.akEditorDefaultLayoutWidth);
        let updatedLayout;
        const renderWidthCSS = rendererAppearance === 'full-page' ? `100cqw - ${0, $19a4579e32968c00$export$12fd658e5eef0d79}px * 2` : `100cqw`;
        const calcDefaultLayoutWidthByAppearance = (rendererAppearance, tableNode)=>{
            if (rendererAppearance === 'full-width' && !tableNode?.attrs.width) return `min(${0, $iHYdz.akEditorFullWidthLayoutWidth}px, ${renderWidthCSS})`;
            else if (rendererAppearance === 'comment' && allowTableResizing && !tableNode?.attrs.width) return renderWidthCSS;
            else {
                // custom width, or width mapped to breakpoint
                const tableContainerWidth = (0, $fKLIs.getTableContainerWidth)(tableNode);
                return `min(${tableContainerWidth}px, ${renderWidthCSS})`;
            }
        };
        const tableWidthCSS = calcDefaultLayoutWidthByAppearance(rendererAppearance, tableNode);
        // Logic for table alignment in renderer
        const isTableAlignStart = tableNode && tableNode.attrs && tableNode.attrs.layout === 'align-start' && allowTableAlignment;
        const fullWidthLineLengthCSS = `min(${(0, $iHYdz.akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`;
        const isCommentAppearanceAndTableAlignmentEnabled = (0, $kjIja.isCommentAppearance)(rendererAppearance) && allowTableAlignment;
        const lineLengthCSS = (0, $kjIja.isFullWidthAppearance)(rendererAppearance) ? fullWidthLineLengthCSS : isCommentAppearanceAndTableAlignmentEnabled ? renderWidthCSS : `${lineLengthFixedWidth}px`;
        const tableWidthNew = (0, $fKLIs.getTableContainerWidth)(tableNode);
        const shouldCalculateLeftForAlignment = !isInsideOfBlockNode && !isInsideOfTable && isTableAlignStart && ((0, $kjIja.isFullPageAppearance)(rendererAppearance) && tableWidthNew <= lineLengthFixedWidth || (0, $kjIja.isFullWidthAppearance)(rendererAppearance) || isCommentAppearanceAndTableAlignmentEnabled);
        let leftCSS;
        if (shouldCalculateLeftForAlignment) leftCSS = `(${tableWidthCSS} - ${lineLengthCSS}) / 2`;
        if (!shouldCalculateLeftForAlignment && (0, $kjIja.isFullPageAppearance)(rendererAppearance)) // Note tableWidthCSS here is the renderer width
        // When the screen is super wide we want table to break out.
        // However if screen is smaller than 760px. We want table align to left.
        leftCSS = `min(0px, ${lineLengthCSS} - ${tableWidthCSS}) / 2`;
        const children = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(this.props.children);
        // Historically, tables in the full-width renderer had their layout set to 'default' which is deceiving.
        // This check caters for those tables and helps with SSR logic
        const isFullWidth = !tableNode?.attrs.width && rendererAppearance === 'full-width' && layout !== 'full-width';
        if (isFullWidth) updatedLayout = 'full-width';
        else if (tableNode?.attrs.width) updatedLayout = 'custom';
        else updatedLayout = layout;
        let finalTableContainerWidth = allowTableResizing ? tableWidthNew : 'inherit';
        // We can only use CSS to determine the width when we have a known width in container.
        // When appearance is full-page, full-width or comment we use CSS based width calculation.
        // Otherwise it's fixed table width (customized width) or inherit.
        if (rendererAppearance === 'full-page' || rendererAppearance === 'full-width') finalTableContainerWidth = allowTableResizing ? `calc(${tableWidthCSS})` : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && !allowTableAlignment) // If table alignment is disabled and table width is akEditorDefaultLayoutWidth = 760,
        // it is most likely a table created before "Support Table in Comments" FF was enabled
        // and we would see a bug ED-24795. A table created before "Support Table in Comments",
        // should inhirit the width of the renderer container.
        // !NOTE: it a table resized to 760 is copied from 'full-page' editor and pasted in comment editor
        // where (allowTableResizing && !allowTableAlignment), the table will loose 760px width.
        finalTableContainerWidth = tableNode?.attrs.width && tableNode?.attrs.width !== (0, $iHYdz.akEditorDefaultLayoutWidth) ? `calc(${tableWidthCSS})` : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && allowTableAlignment) // If table alignment is enabled and layout is not 'align-start' or 'center', we are loading a table that was
        // created before "Support Table in Comments" FF was enabled. So the table should have the same width as renderer container
        // instead of 760 that was set on tableNode when the table had been published.
        finalTableContainerWidth = (tableNode?.attrs.layout === 'align-start' || tableNode?.attrs.layout === 'center') && tableNode?.attrs.width ? `calc(${tableWidthCSS})` : 'inherit';
        const style = {
            width: finalTableContainerWidth,
            left: leftCSS ? `calc(${leftCSS})` : undefined,
            marginLeft: shouldCalculateLeftForAlignment && leftCSS !== undefined ? `calc(-1 * (${leftCSS}))` : undefined
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: `${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER} ${this.props.shadowClassNames || ''}`,
                "data-layout": updatedLayout,
                "data-testid": "table-container",
                ref: this.props.handleRef,
                style: style,
                children: [
                    $ef3de7a711c9e97e$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP,
                        "data-testid": "sticky-scrollbar-sentinel-top"
                    }),
                    stickyHeaders && tableNode && $ef3de7a711c9e97e$export$940095e914312886(tableNode, children) && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2aXGN.StickyTable), {
                        isNumberColumnEnabled: isNumberColumnEnabled,
                        tableWidth: "inherit",
                        renderWidth: 0,
                        layout: layout,
                        handleRef: this.props.handleRef,
                        shadowClassNames: this.props.shadowClassNames,
                        top: this.stickyTop,
                        mode: stickyMode,
                        innerRef: this.stickyWrapperRef,
                        wrapperWidth: this.state.wrapperWidth,
                        columnWidths: columnWidths,
                        rowHeight: this.state.headerRowHeight,
                        tableNode: tableNode,
                        rendererAppearance: rendererAppearance,
                        allowTableResizing: allowTableResizing,
                        fixTableSSRResizing: true,
                        children: [
                            children && children[0]
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER,
                        ref: this.wrapperRef,
                        "data-number-column": tableNode?.attrs.isNumberColumnEnabled,
                        "data-layout": tableNode?.attrs.layout,
                        "data-autosize": tableNode?.attrs.__autoSize,
                        "data-table-local-id": tableNode?.attrs.localId,
                        "data-table-width": tableNode?.attrs.width,
                        "data-vc": "table-node-wrapper",
                        onScroll: this.props.stickyHeaders && this.onWrapperScrolled,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a4mor.Table), {
                            innerRef: this.tableRef,
                            columnWidths: columnWidths,
                            layout: layout,
                            renderWidth: 0,
                            isNumberColumnEnabled: isNumberColumnEnabled,
                            tableNode: tableNode,
                            rendererAppearance: rendererAppearance,
                            isInsideOfBlockNode: isInsideOfBlockNode,
                            isInsideOfTable: isInsideOfTable,
                            isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
                            allowTableResizing: allowTableResizing,
                            isPresentational: isPresentational,
                            children: this.grabFirstRowRef(children)
                        })
                    }),
                    $ef3de7a711c9e97e$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: `${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}${(0, $VSDnB.fg)('confluence_frontend_table_scrollbar_ttvc_fix') ? '-view-page' : ''}`,
                        ref: this.stickyScrollbarRef,
                        "data-vc": "table-sticky-scrollbar-container",
                        style: (0, $VSDnB.fg)('confluence_frontend_table_scrollbar_ttvc_fix') ? {
                            ...$ef3de7a711c9e97e$var$stickyContainerBaseStyles,
                            ...$ef3de7a711c9e97e$var$stickyContainerAdditionalStyles
                        } : $ef3de7a711c9e97e$var$stickyContainerBaseStyles,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            style: {
                                width: (0, $VSDnB.fg)('confluence_frontend_table_scrollbar_ttvc_fix') ? '100%' : this.tableRef.current?.clientWidth,
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                height: '100%'
                            }
                        })
                    }),
                    $ef3de7a711c9e97e$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM,
                        "data-testid": "sticky-scrollbar-sentinel-bottom"
                    })
                ]
            })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            stickyMode: 'none',
            wrapperWidth: 0,
            headerRowHeight: 0
        }, this.tableRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.stickyHeaderRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.stickyScrollbarRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), // used for sync scroll + copying wrapper width to sticky header
        this.stickyWrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.wrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.overflowParent = null, this.updatedLayout = 'custom', this.resizeObserver = null, this.applyResizerChange = (entries)=>{
            let wrapperWidth = this.state.wrapperWidth;
            let headerRowHeight = this.state.headerRowHeight;
            for (const entry of entries){
                if (entry.target === this.wrapperRef.current) wrapperWidth = entry.contentRect.width;
                else if (entry.target === this.stickyHeaderRef.current) headerRowHeight = Math.round(entry.contentRect.height);
            }
            if (headerRowHeight !== this.state.headerRowHeight || wrapperWidth !== this.state.wrapperWidth) this.setState({
                wrapperWidth: wrapperWidth,
                headerRowHeight: headerRowHeight
            });
        }, this.componentWillUnmount = ()=>{
            if (this.overflowParent) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            if (this.nextFrame) cancelAnimationFrame(this.nextFrame);
            if (this.resizeObserver) this.resizeObserver.disconnect();
            if (this.stickyScrollbar) this.stickyScrollbar.dispose();
        }, this.getScrollTop = ()=>{
            const { stickyHeaders: stickyHeaders } = this.props;
            const offsetTop = stickyHeaders && stickyHeaders.offsetTop || 0;
            return (this.overflowParent ? this.overflowParent.top : 0) + offsetTop;
        }, this.updateSticky = ()=>{
            const tableElem = this.tableRef.current;
            const refElem = this.stickyHeaderRef.current;
            if (!tableElem || !refElem) return;
            const scrollTop = this.getScrollTop() + (0, $2aXGN.tableStickyPadding);
            const tableTop = $ef3de7a711c9e97e$export$f422245984b0eda7(tableElem);
            const tableBottom = tableTop + tableElem.clientHeight;
            const shouldSticky = $ef3de7a711c9e97e$export$7c141112f3c89f11(scrollTop, tableTop, tableBottom, refElem.clientHeight);
            const shouldPin = $ef3de7a711c9e97e$export$89f3188e1adc30d5(scrollTop, tableBottom, refElem.clientHeight);
            let stickyMode = 'none';
            if (shouldPin) stickyMode = 'pin-bottom';
            else if (shouldSticky) stickyMode = 'stick';
            if (this.state.stickyMode !== stickyMode) this.setState({
                stickyMode: stickyMode
            });
            this.nextFrame = undefined;
        }, this.onScroll = ()=>{
            if (!this.nextFrame) this.nextFrame = requestAnimationFrame(this.updateSticky);
        }, this.onWrapperScrolled = ()=>{
            if (!this.wrapperRef.current || !this.stickyWrapperRef.current) return;
            this.stickyWrapperRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
            if (this.stickyScrollbarRef.current) this.stickyScrollbarRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
        }, this.grabFirstRowRef = (children)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children || false, (child, idx)=>{
                if (idx === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
                    innerRef: this.stickyHeaderRef
                });
                return child;
            });
        };
    }
}
class $ef3de7a711c9e97e$export$827f89182557f335 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    /**
   *
   * @example
   */ render() {
        const { children: children } = this.props;
        if (!children) return null;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children);
        const orderedChildren = (0, $5vnE9.compose)(this.addNumberColumnIndexes, this.addSortableColumn)(childrenArray);
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $2OMIu.jsx)($ef3de7a711c9e97e$export$f2c3aea42b2a048f, {
            ...this.props,
            children: orderedChildren
        });
    }
    constructor(...args){
        super(...args), this.state = {
            tableOrderStatus: undefined
        }, // adds sortable + re-orders children
        this.addSortableColumn = (childrenArray)=>{
            const { tableNode: tableNode, allowColumnSorting: allowColumnSorting, smartCardStorage: smartCardStorage } = this.props;
            const { tableOrderStatus: tableOrderStatus } = this.state;
            if (allowColumnSorting && $ef3de7a711c9e97e$export$28daf78feed5098c(childrenArray) && tableNode && !(0, $5or39.hasMergedCell)(tableNode)) return $ef3de7a711c9e97e$export$100baa0f10804e6e($ef3de7a711c9e97e$export$334894231c46c1a5(childrenArray, tableNode, smartCardStorage, tableOrderStatus), tableOrderStatus, this.changeSortOrder);
            return childrenArray;
        }, this.changeSortOrder = (columnIndex, sortOrder)=>{
            this.setState({
                tableOrderStatus: {
                    columnIndex: columnIndex,
                    order: sortOrder
                }
            });
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.addNumberColumnIndexes = (rows)=>{
            const { isNumberColumnEnabled: isNumberColumnEnabled } = this.props;
            const headerRowEnabled = $ef3de7a711c9e97e$export$28daf78feed5098c(rows);
            return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(rows, (row, index)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.only(row), {
                    isNumberColumnEnabled: isNumberColumnEnabled,
                    index: headerRowEnabled ? index === 0 ? '' : index : index + 1
                });
            });
        };
    }
}

});


parcelRegister("i4Lgj", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d6cf54c99dd1cb3$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5vnE9 = parcelRequire("5vnE9");

var $9BYlQ = parcelRequire("9BYlQ");

var $VSDnB = parcelRequire("VSDnB");

var $l8Gxi = parcelRequire("l8Gxi");
class $6d6cf54c99dd1cb3$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { children: children, innerRef: innerRef } = this.props;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children);
        return /*#__PURE__*/ (0, $2OMIu.jsxs)("tr", {
            ref: innerRef,
            children: [
                this.props.isNumberColumnEnabled && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $2OMIu.jsx)("td", {
                    className: (0, $l8Gxi.RendererCssClassName).NUMBER_COLUMN,
                    children: this.props.index
                }),
                (0, $5vnE9.compose)(this.addSortableColumn, this.addColGroupWidth)(childrenArray)
            ]
        });
    }
    constructor(...args){
        super(...args), this.state = {
            colGroupWidths: []
        }, this.addSortableColumn = (childrenArray)=>{
            const { allowColumnSorting: allowColumnSorting, index: rowIndex } = this.props;
            const isHeaderRow = !rowIndex;
            if (allowColumnSorting && (!(0, $VSDnB.fg)('cc_complexit_fe_improve_table_sorting') || isHeaderRow)) childrenArray = childrenArray.map((child, index)=>{
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) {
                    const { tableOrderStatus: tableOrderStatus } = this.props;
                    let sortOrdered = (0, $9BYlQ.SortOrder).NO_ORDER;
                    if (tableOrderStatus) sortOrdered = index === tableOrderStatus.columnIndex ? tableOrderStatus.order : (0, $9BYlQ.SortOrder).NO_ORDER;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
                        columnIndex: index,
                        onSorting: this.props.onSorting,
                        sortOrdered: sortOrdered,
                        isHeaderRow: isHeaderRow
                    });
                }
            });
            return childrenArray;
        }, this.addColGroupWidth = (childrenArray)=>{
            if ((0, $VSDnB.fg)('platform_editor_table_column_group_width_check_3') ? this.state.colGroupWidths?.length : this.state.colGroupWidths) childrenArray = childrenArray.map((child, index)=>{
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
                    colGroupWidth: this.state.colGroupWidths[index]
                });
            });
            return childrenArray;
        };
    }
}

});

parcelRegister("gfMkN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5be854e6b8cbd84$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $d5be854e6b8cbd84$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: "UnknownBlock",
        children: props.children
    });
}

});

parcelRegister("8WMBu", function(module, exports) {

let $01ae58891255b6e8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $01ae58891255b6e8$var$load("7uAi5").then(()=>parcelRequire('fyj1u'));

});

parcelRegister("kHVHQ", function(module, exports) {

let $f134960741cca6cd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f134960741cca6cd$var$load("9JEXq").then(()=>parcelRequire('bO8HO'));

});

parcelRegister("1KGZa", function(module, exports) {

let $146b6e5faaa248eb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $146b6e5faaa248eb$var$load("af9eo").then(()=>parcelRequire('iLXzZ'));

});

parcelRegister("4OnIJ", function(module, exports) {

let $380e3b5a085ebc97$var$load = (parcelRequire("28QjX"))(4);
module.exports = $380e3b5a085ebc97$var$load("eiJrL").then(()=>parcelRequire('5Y7e4'));

});

parcelRegister("clvfA", function(module, exports) {

let $8fcfafdd49347737$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8fcfafdd49347737$var$load("bF2Yj").then(()=>parcelRequire('h2Mqp'));

});

parcelRegister("2Fwz0", function(module, exports) {

let $1f18ab91da841361$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1f18ab91da841361$var$load("7vMvR").then(()=>parcelRequire('sFJC1'));

});

parcelRegister("hQAvz", function(module, exports) {

let $cfe39cbeca7c95a6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cfe39cbeca7c95a6$var$load("7qbwG").then(()=>parcelRequire('4hMem'));

});

parcelRegister("2c01v", function(module, exports) {

let $198cb86922264390$var$load = (parcelRequire("28QjX"))(4);
module.exports = $198cb86922264390$var$load("hNOP2").then(()=>parcelRequire('c3ssB'));

});

parcelRegister("hSHcF", function(module, exports) {

let $d048fe1c0cc67525$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d048fe1c0cc67525$var$load("76n7a"),
    $d048fe1c0cc67525$var$load("l253H"),
    $d048fe1c0cc67525$var$load("ffQaD"),
    $d048fe1c0cc67525$var$load("kvRbA"),
    $d048fe1c0cc67525$var$load("aPoGi")
]).then(()=>parcelRequire('hibqv'));

});

parcelRegister("8ugtC", function(module, exports) {

let $62dde7fb2c16a4f8$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $62dde7fb2c16a4f8$var$load("76n7a"),
    $62dde7fb2c16a4f8$var$load("l253H"),
    $62dde7fb2c16a4f8$var$load("ffQaD"),
    $62dde7fb2c16a4f8$var$load("kvRbA"),
    $62dde7fb2c16a4f8$var$load("93KAt")
]).then(()=>parcelRequire('1lkep'));

});

parcelRegister("5WPrU", function(module, exports) {

let $454a4740a2b767cb$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $454a4740a2b767cb$var$load("fliVL"),
    $454a4740a2b767cb$var$load("76n7a"),
    $454a4740a2b767cb$var$load("l253H"),
    $454a4740a2b767cb$var$load("ffQaD"),
    $454a4740a2b767cb$var$load("kvRbA"),
    $454a4740a2b767cb$var$load("kNFvF"),
    $454a4740a2b767cb$var$load("dhTaM")
]).then(()=>parcelRequire('fz1ZD'));

});

parcelRegister("6tHHQ", function(module, exports) {

let $4b775aa4acac24a1$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $4b775aa4acac24a1$var$load("fliVL"),
    $4b775aa4acac24a1$var$load("76n7a"),
    $4b775aa4acac24a1$var$load("l253H"),
    $4b775aa4acac24a1$var$load("ffQaD"),
    $4b775aa4acac24a1$var$load("kvRbA"),
    $4b775aa4acac24a1$var$load("kNFvF"),
    $4b775aa4acac24a1$var$load("gNqLi")
]).then(()=>parcelRequire('lD0Zb'));

});

parcelRegister("8m1sA", function(module, exports) {

let $615182c0cb4d0375$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $615182c0cb4d0375$var$load("fliVL"),
    $615182c0cb4d0375$var$load("76n7a"),
    $615182c0cb4d0375$var$load("l253H"),
    $615182c0cb4d0375$var$load("ffQaD"),
    $615182c0cb4d0375$var$load("kvRbA"),
    $615182c0cb4d0375$var$load("kNFvF"),
    $615182c0cb4d0375$var$load("fig2F")
]).then(()=>parcelRequire('gQwn3'));

});

parcelRegister("jHdEo", function(module, exports) {

let $e56c9f2f2e5028d1$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e56c9f2f2e5028d1$var$load("76n7a"),
    $e56c9f2f2e5028d1$var$load("l253H"),
    $e56c9f2f2e5028d1$var$load("gguur")
]).then(()=>parcelRequire('aPwmB'));

});

parcelRegister("bokwI", function(module, exports) {

let $84b1dbc8c386e490$var$load = (parcelRequire("28QjX"))(4);
module.exports = $84b1dbc8c386e490$var$load("d0X7J").then(()=>parcelRequire('ebIkR'));

});

parcelRegister("dmxb9", function(module, exports) {

let $9ba7110bdfeaeeb3$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $9ba7110bdfeaeeb3$var$load("76n7a"),
    $9ba7110bdfeaeeb3$var$load("l253H"),
    $9ba7110bdfeaeeb3$var$load("lNsfv")
]).then(()=>parcelRequire('74PfD'));

});

parcelRegister("32Gvn", function(module, exports) {

let $237287a63ccdc68d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $237287a63ccdc68d$var$load("1VmC7").then(()=>parcelRequire('9jt2S'));

});

parcelRegister("XeDOe", function(module, exports) {

let $0b20de37847b85c1$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $0b20de37847b85c1$var$load("ffQaD"),
    $0b20de37847b85c1$var$load("kvRbA"),
    $0b20de37847b85c1$var$load("76n7a"),
    $0b20de37847b85c1$var$load("l253H"),
    $0b20de37847b85c1$var$load("kRYcQ")
]).then(()=>parcelRequire('V5Yjo'));

});

parcelRegister("aVEPl", function(module, exports) {

let $7f4ee5b0867c0347$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $7f4ee5b0867c0347$var$load("ffQaD"),
    $7f4ee5b0867c0347$var$load("kvRbA"),
    $7f4ee5b0867c0347$var$load("eIR2q")
]).then(()=>parcelRequire('hA9EZ'));

});


parcelRegister("5BLIh", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1269296b575a9fc$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $4dDLS = parcelRequire("4dDLS");
const $e1269296b575a9fc$var$TextWrapper = (props)=>{
    const { startPos: startPos, endPos: endPos } = props;
    const { children: children } = props;
    if (!children) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4dDLS.TextWithAnnotationDraft), {
        startPos: startPos,
        endPos: endPos,
        textHighlighter: props.textHighlighter,
        marks: props.marks,
        children: children
    });
};
var $e1269296b575a9fc$export$2e2bcd8739ae039 = $e1269296b575a9fc$var$TextWrapper;

});
parcelRegister("4dDLS", function(module, exports) {

$parcel$export(module.exports, "TextWithAnnotationDraft", () => $3c5c154ced085d7f$export$69a4e0ac39aaf9b7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $dLpur = parcelRequire("dLpur");

var $i9Z2i = parcelRequire("i9Z2i");

var $b60W1 = parcelRequire("b60W1");

var $fVTp8 = parcelRequire("fVTp8");

var $h5tvG = parcelRequire("h5tvG");

var $3VpWO = parcelRequire("3VpWO");

var $jw62c = parcelRequire("jw62c");

var $2EsbE = parcelRequire("2EsbE");
function $3c5c154ced085d7f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Localized AnnotationSharedCSSByState().common and AnnotationSharedCSSByState().focus
const $3c5c154ced085d7f$var$markStyles = {
    name: "ko40kj",
    styles: "color:inherit;background-color:unset;-webkit-tap-highlight-color:transparent;border-bottom:2px solid transparent;cursor:pointer;padding:1px 0 2px;&:has(.card), &:has([data-inline-card]){padding:5px 0 3px 0;}&:has(.date-lozenger-container){padding-top:var(--ds-space-025, 2px);}background:var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47);border-bottom-color:var(--ds-border-accent-yellow, #B38600);box-shadow:var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)"
};
const $3c5c154ced085d7f$export$8062d68eccdfa39c = ({ draftPosition: draftPosition, children: children })=>{
    const { dispatch: dispatch } = (0, $jw62c.useAnnotationManagerDispatch)();
    const markRef = (0, $5uXOq.useCallback)((node)=>{
        dispatch({
            type: 'setDraftMarkRef',
            data: {
                draftMarkRef: node ?? undefined
            }
        });
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("mark", {
        "data-renderer-mark": true,
        ...(0, $fVTp8.dataAttributes)(draftPosition),
        css: $3c5c154ced085d7f$var$markStyles,
        ref: markRef
    }, children);
};
const $3c5c154ced085d7f$export$846ef6158669db08 = (annotationPosition, fragmentCount)=>{
    if (annotationPosition === (0, $dLpur.InsertDraftPosition).START) return 0;
    if (annotationPosition === (0, $dLpur.InsertDraftPosition).END) return fragmentCount - 1;
    if (annotationPosition === (0, $dLpur.InsertDraftPosition).INSIDE && fragmentCount === 3) return 1;
    return -1;
};
const $3c5c154ced085d7f$export$b756d37afc321d72 = ({ texts: texts, shouldApplyAnnotationAt: shouldApplyAnnotationAt, draftPosition: draftPosition, textHighlighter: textHighlighter, marks: marks })=>{
    const annotateIndex = $3c5c154ced085d7f$export$846ef6158669db08(shouldApplyAnnotationAt, texts.length);
    return texts.map((value, index)=>{
        const segments = (0, $h5tvG.segmentText)(value, textHighlighter);
        if (annotateIndex === index) return(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $f8Sb3.jsx)($3c5c154ced085d7f$export$8062d68eccdfa39c, {
            key: index,
            draftPosition: draftPosition
        }, (0, $3VpWO.renderTextSegments)(segments, textHighlighter, marks || [], draftPosition.from)));
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
            key: index
        }, (0, $3VpWO.renderTextSegments)(segments, textHighlighter, marks || [], draftPosition.from)));
    });
};
const $3c5c154ced085d7f$export$69a4e0ac39aaf9b7 = ({ startPos: startPos, endPos: endPos, children: children, textHighlighter: textHighlighter, marks: marks })=>{
    const textPosition = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>({
            start: startPos,
            end: endPos
        }), [
        endPos,
        startPos
    ]);
    const { selectionDraftDocumentPosition: nextDraftPosition } = (0, $2EsbE.useAnnotationRangeState)();
    const shouldApplyAnnotationAt = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        if (!nextDraftPosition) return false;
        return (0, $b60W1.calcInsertDraftPositionOnText)(textPosition, nextDraftPosition);
    }, [
        nextDraftPosition,
        textPosition
    ]);
    const textString = (0, $i9Z2i.findTextString)(children);
    if (!textString) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, children);
    if (shouldApplyAnnotationAt === false || !nextDraftPosition) {
        const segments = (0, $h5tvG.segmentText)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, (0, $3VpWO.renderTextSegments)(segments, textHighlighter, marks || [], startPos));
    }
    if (shouldApplyAnnotationAt === (0, $dLpur.InsertDraftPosition).AROUND_TEXT) {
        const segments = (0, $h5tvG.segmentText)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $f8Sb3.jsx)($3c5c154ced085d7f$export$8062d68eccdfa39c, {
            key: 0,
            draftPosition: nextDraftPosition
        }, (0, $3VpWO.renderTextSegments)(segments, textHighlighter, marks || [], startPos));
    }
    const offsets = (0, $i9Z2i.calcTextSplitOffset)(nextDraftPosition, textPosition, textString);
    const texts = (0, $i9Z2i.splitText)(textString, offsets);
    if (!texts) {
        const segments = (0, $h5tvG.segmentText)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, (0, $3VpWO.renderTextSegments)(segments, textHighlighter, marks || [], startPos));
    }
    const components = $3c5c154ced085d7f$export$b756d37afc321d72({
        texts: texts,
        shouldApplyAnnotationAt: shouldApplyAnnotationAt,
        draftPosition: nextDraftPosition,
        textHighlighter: textHighlighter,
        marks: marks
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, components);
};

});
parcelRegister("dLpur", function(module, exports) {

$parcel$export(module.exports, "InsertDraftPosition", () => $0808a380eaa6574c$export$c1bd4813440b4505);
var $0808a380eaa6574c$export$c1bd4813440b4505 = /*#__PURE__*/ function(InsertDraftPosition) {
    InsertDraftPosition["AROUND_TEXT"] = "AROUND_TEXT";
    InsertDraftPosition["START"] = "START";
    InsertDraftPosition["END"] = "END";
    InsertDraftPosition["INSIDE"] = "INSIDE";
    return InsertDraftPosition;
}({});

});

parcelRegister("i9Z2i", function(module, exports) {

$parcel$export(module.exports, "findTextString", () => $b2e5f988c70f5313$export$a9795c84b22a1f06);
$parcel$export(module.exports, "splitText", () => $b2e5f988c70f5313$export$2878cc467c8be8fe);
$parcel$export(module.exports, "calcTextSplitOffset", () => $b2e5f988c70f5313$export$1059bfc467f4f55d);

var $5uXOq = parcelRequire("5uXOq");
const $b2e5f988c70f5313$export$a9795c84b22a1f06 = (reactNode)=>{
    let result = null;
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(reactNode);
    for (const childNode of children){
        if (result) break;
        else if (typeof childNode === 'string') result = childNode;
        else if ($b2e5f988c70f5313$var$isReactElement(childNode) && childNode.props.children) result = $b2e5f988c70f5313$export$a9795c84b22a1f06(childNode.props.children);
    }
    return result;
};
function $b2e5f988c70f5313$var$isReactElement(child) {
    return !!child.type;
}
const $b2e5f988c70f5313$export$2878cc467c8be8fe = (text, { startOffset: startOffset, endOffset: endOffset })=>{
    if (endOffset > text.length || endOffset - startOffset <= 0) return null;
    return [
        text.slice(0, startOffset),
        text.slice(startOffset, endOffset),
        text.slice(endOffset)
    ].filter(Boolean);
};
const $b2e5f988c70f5313$export$1059bfc467f4f55d = (position, textPosition, text)=>{
    const { start: start, end: end } = textPosition;
    const startOffset = Math.max(position.from - start, 0);
    const endOffset = Math.min(Math.abs(end - position.to - text.length), text.length);
    return {
        startOffset: startOffset,
        endOffset: endOffset
    };
};

});

parcelRegister("b60W1", function(module, exports) {

$parcel$export(module.exports, "calcInsertDraftPositionOnText", () => $cc6d6765c9b34830$export$b1baddbd5f289877);

var $dLpur = parcelRequire("dLpur");
const $cc6d6765c9b34830$export$b1baddbd5f289877 = ({ start: startTextPosition, end: endTextPosition }, position)=>{
    const isRangePositionAroundText = position.from <= startTextPosition && position.to >= endTextPosition;
    if (isRangePositionAroundText) return (0, $dLpur.InsertDraftPosition).AROUND_TEXT;
    const isRangePositionInsideText = position.from > startTextPosition && position.from < endTextPosition && position.to < endTextPosition && position.to > startTextPosition;
    if (isRangePositionInsideText) return (0, $dLpur.InsertDraftPosition).INSIDE;
    const isRangePositionStartingAtText = position.from >= startTextPosition && position.from <= endTextPosition && position.to >= endTextPosition;
    if (isRangePositionStartingAtText) return (0, $dLpur.InsertDraftPosition).END;
    const isRangePositionEndingAtText = position.from <= startTextPosition && position.to >= startTextPosition && position.to <= endTextPosition;
    if (isRangePositionEndingAtText) return (0, $dLpur.InsertDraftPosition).START;
    return false;
};

});

parcelRegister("h5tvG", function(module, exports) {

$parcel$export(module.exports, "segmentText", () => $63dc04a72edc8a4d$export$93301b6f1ff0b0c3);
function $63dc04a72edc8a4d$export$93301b6f1ff0b0c3(text, highlighter) {
    if (!highlighter || !text) return [
        {
            type: 'plain',
            text: text ?? ''
        }
    ];
    const segments = [];
    let pos = 0;
    try {
        const markTextSegmentMatches = text.matchAll(highlighter.pattern);
        for (const markTextMatch of markTextSegmentMatches){
            if (markTextMatch.index !== 0) segments.push({
                type: 'plain',
                text: text.substring(pos, markTextMatch.index)
            });
            segments.push({
                type: 'match',
                text: markTextMatch[0],
                groups: markTextMatch.groups && // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                Object.keys(markTextMatch.groups).filter((key)=>markTextMatch.groups[key])
            });
            pos = markTextMatch.index + markTextMatch[0].length;
        }
        if (pos < text.length) segments.push({
            type: 'plain',
            text: text.substring(pos)
        });
        return segments;
    } catch (_e) {}
    return [
        {
            type: 'plain',
            text: text
        }
    ];
}

});

parcelRegister("3VpWO", function(module, exports) {

$parcel$export(module.exports, "renderTextSegments", () => $eefbbe172cfc7a10$export$8a20fd0614851c5f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $eefbbe172cfc7a10$export$8a20fd0614851c5f(segments, textHighlighter, marksList, startPos) {
    const Component = textHighlighter?.component;
    const marks = new Set(marksList.map((m)=>m.type.name));
    function renderSegment(segment, idx = 0) {
        if (segment.type === 'plain' || !Component) return segment.text;
        return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            "data-highlighted": true,
            "data-vc": "highlighted-text",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                match: segment.text,
                groups: segment.groups,
                marks: marks,
                startPos: startPos + idx,
                children: segment.text
            }, `${segment.text}_${startPos}_${idx}`)
        });
    }
    if (segments.length === 1) return renderSegment(segments[0]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
        children: segments.map(renderSegment)
    }, `text-wrapper_${startPos}`);
}

});



parcelRegister("cKKwC", function(module, exports) {

$parcel$export(module.exports, "isAnnotationMark", () => $d006a5118aec07b0$export$855795c145f03402);
$parcel$export(module.exports, "default", () => $d006a5118aec07b0$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $88i6h = parcelRequire("88i6h");

var $5uoEK = parcelRequire("5uoEK");
const $d006a5118aec07b0$export$855795c145f03402 = (mark)=>{
    return mark && mark.type && mark.type.name === 'annotation';
};
const $d006a5118aec07b0$var$AnnotationComponent = ({ id: id, annotationType: annotationType, children: children, dataAttributes: dataAttributes, annotationParentIds: annotationParentIds = [], allowAnnotations: allowAnnotations, useBlockLevel: useBlockLevel, isMediaInline: isMediaInline })=>{
    const data = {
        ...dataAttributes,
        ...(0, $88i6h.buildDataAttributes)({
            id: id,
            annotationType: annotationType
        })
    };
    if (allowAnnotations) return isMediaInline ? // Inline comment on mediaInline is not supported as part of comments on media project,
    // hence skip any styling/event handling for annotations on mediaInline.
    // `id` is still needed so that comment view component can be correct positioned
    // when using comment navigation to access comments on mediaInline
    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        id: id,
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uoEK.MarkElement), {
        id: id,
        dataAttributes: data,
        annotationParentIds: annotationParentIds,
        annotationType: annotationType,
        useBlockLevel: useBlockLevel,
        children: children
    });
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        id: id,
        ...data,
        children: children
    }));
};
var $d006a5118aec07b0$export$2e2bcd8739ae039 = $d006a5118aec07b0$var$AnnotationComponent;

});
parcelRegister("5uoEK", function(module, exports) {

$parcel$export(module.exports, "MarkElement", () => $97291021c9f24158$export$f3069f755c1eba0b);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $88i6h = parcelRequire("88i6h");

var $dEtqo = parcelRequire("dEtqo");

var $VSDnB = parcelRequire("VSDnB");

var $8u8ms = parcelRequire("8u8ms");

var $6Oe8V = parcelRequire("6Oe8V");

var $3N1TD = parcelRequire("3N1TD");

var $1oOiu = parcelRequire("1oOiu");

var $iYAgE = parcelRequire("iYAgE");

var $jw62c = parcelRequire("jw62c");
const $97291021c9f24158$export$f3069f755c1eba0b = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, useBlockLevel: useBlockLevel })=>{
    const updateSubscriber = (0, $3N1TD.useInlineCommentSubscriberContext)();
    const states = (0, $5uXOq.useContext)((0, $iYAgE.InlineCommentsStateContext));
    const { hasFocus: hasFocus, isHovered: isHovered } = (0, $1oOiu.useHasFocusEvent)({
        id: id,
        updateSubscriber: updateSubscriber
    });
    const dataAttributesMemorized = (0, $5uXOq.useMemo)(()=>dataAttributes, [
        dataAttributes
    ]);
    const { dispatch: dispatch, annotationManager: annotationManager } = (0, $jw62c.useAnnotationManagerDispatch)();
    const onClick = (0, $5uXOq.useCallback)((props)=>{
        if (!updateSubscriber) return;
        if (useBlockLevel) return;
        const { eventTarget: eventTarget, annotationIds: annotationIds } = props;
        if ((0, $VSDnB.fg)('platform_editor_comments_api_manager_select')) {
            if (hasFocus) return;
            annotationManager?.checkPreemptiveGate().then((canSelect)=>{
                if (canSelect) {
                    // if there is a draft, clear it first
                    annotationManager?.clearDraft();
                    // use setIsAnnotationSelected won't work here if there is a draft in progress
                    // so we need to use dispatch to update the state directly
                    dispatch({
                        type: 'updateAnnotation',
                        data: {
                            id: annotationIds[0],
                            selected: true
                        }
                    });
                    dispatch({
                        type: 'setSelectedMarkRef',
                        data: {
                            markRef: eventTarget
                        }
                    });
                }
            }).catch((error)=>{
            // TODO: EDITOR-595 - An error occurred while checking the preemptive gate. We should report this error.
            });
        } else updateSubscriber.emit((0, $dEtqo.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: annotationIds,
            eventTarget: eventTarget
        });
    }, [
        updateSubscriber,
        useBlockLevel,
        dispatch,
        annotationManager,
        hasFocus
    ]);
    const activeParentIds = (0, $6Oe8V.useInlineCommentsFilter)({
        annotationIds: annotationParentIds,
        filter: {
            state: (0, $88i6h.AnnotationMarkStates).ACTIVE
        }
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8u8ms.MarkComponent), {
        id: id,
        dataAttributes: dataAttributesMemorized,
        annotationParentIds: activeParentIds,
        onClick: onClick,
        hasFocus: hasFocus,
        isHovered: isHovered,
        state: states[id],
        useBlockLevel: useBlockLevel,
        children: children
    });
};

});
parcelRegister("8u8ms", function(module, exports) {

$parcel$export(module.exports, "MarkComponent", () => $c95b45af50ffb058$export$4f5a51511304fdd0);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $88i6h = parcelRequire("88i6h");

var $VSDnB = parcelRequire("VSDnB");

var $koVbs = parcelRequire("koVbs");

var $1Bd5P = parcelRequire("1Bd5P");

var $jw62c = parcelRequire("jw62c");
const $c95b45af50ffb058$var$markStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: 'inherit',
    backgroundColor: 'unset',
    WebkitTapHighlightColor: 'transparent',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $88i6h.AnnotationMarkStates).ACTIVE}']`]: {
        // was from blur in AnnotationSharedCSSByState().blur
        background: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
        borderBottom: `2px solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&:focus, &[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
            borderBottom: `2px solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
            // TODO: DSP-4147 - Annotation shadow
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)",
            cursor: 'pointer'
        }
    }
});
const $c95b45af50ffb058$var$markStylesLayeringFix = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $88i6h.AnnotationMarkStates).ACTIVE}']`]: {
        // Only apply transparency to nested marks when parent is focused
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"] mark': {
            backgroundColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.fabric-background-color-mark &[data-has-focus="true"], &:focus, &[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)"
        }
    }
});
const $c95b45af50ffb058$var$markStylesWithUpdatedShadow = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $88i6h.AnnotationMarkStates).ACTIVE}']`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&:focus, &[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)"
        }
    }
});
const $c95b45af50ffb058$var$markStylesWithInlineComments = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $88i6h.AnnotationMarkStates).ACTIVE}']`]: {
        // was from common in AnnotationSharedCSSByState().common
        borderBottom: '2px solid transparent',
        cursor: 'pointer',
        padding: '1px 0 2px',
        // it was under fg(annotations_align_editor_and_renderer_styles) from AnnotationSharedCSSByState().common, assume it's on as already rolled out
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has(.card), &:has([data-inline-card])': {
            padding: '5px 0 3px 0'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has(.date-lozenger-container)': {
            paddingTop: "var(--ds-space-025, 2px)"
        },
        // was from blur in AnnotationSharedCSSByState().blur
        background: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
        borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&:focus, &[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)"
        }
    }
});
const $c95b45af50ffb058$var$markStylesWithCommentsPanel = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $88i6h.AnnotationMarkStates).ACTIVE}']`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&[data-is-hovered="true"]:not([data-has-focus="true"])': {
            background: "var(--ds-background-accent-yellow-subtlest-hovered, #F8E6A0)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)"
        }
    }
});
const $c95b45af50ffb058$var$isMobile = ()=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};
const $c95b45af50ffb058$var$accessibilityStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&::before, &::after': {
        clipPath: 'inset(100%)',
        clip: 'rect(1px, 1px, 1px, 1px)',
        height: '1px',
        overflow: 'hidden',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px'
    },
    '&::before': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        content: `' [var(--ak-renderer-annotation-startmarker)] '`
    },
    '&::after': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        content: `' [var(--ak-renderer-annotation-endmarker)] '`
    }
});
const $c95b45af50ffb058$export$4f5a51511304fdd0 = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, state: state, hasFocus: hasFocus, isHovered: isHovered, onClick: onClick, useBlockLevel: useBlockLevel })=>{
    const intl = (0, $koVbs.default)();
    const annotationIds = (0, $5uXOq.useMemo)(()=>[
            ...new Set([
                ...annotationParentIds,
                id
            ])
        ], [
        id,
        annotationParentIds
    ]);
    const { dispatch: dispatch } = (0, $jw62c.useAnnotationManagerDispatch)();
    const { currentSelectedAnnotationId: currentSelectedAnnotationId } = (0, $jw62c.useAnnotationManagerState)();
    // after creating a new annotation, we need to set the markRef to the new mark
    const markRef = (0, $5uXOq.useCallback)((node)=>{
        if (id === currentSelectedAnnotationId && node) dispatch({
            type: 'setSelectedMarkRef',
            data: {
                markRef: node
            }
        });
    }, [
        dispatch,
        id,
        currentSelectedAnnotationId
    ]);
    const onMarkClick = (0, $5uXOq.useCallback)((event)=>{
        // prevent inline mark logic for media block marks
        if (event.currentTarget instanceof HTMLElement && event.currentTarget.getAttribute('data-block-mark')) return;
        // prevents multiple callback on overlapping annotations
        if (event.defaultPrevented || state !== (0, $88i6h.AnnotationMarkStates).ACTIVE) return;
        if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) // We only want to interfere with click events if the click is on some ui inside the renderer document
        // This is to prevent the click events from portaled content (such as link previews and mention profiles)
        {
            if (event.target instanceof HTMLElement && event.target.closest('.ak-renderer-document')) {
                if (event.target.closest('[data-mention-id]')) ;
                else {
                    // prevents from opening link URL inside webView in Safari
                    event.preventDefault();
                    event.stopPropagation();
                }
            }
        } else // prevents from opening link URL inside webView in Safari
        event.preventDefault();
        if ((0, $VSDnB.fg)('platform_editor_comments_api_manager')) // currentTarget is the right element if there are multiple overlapping annotations
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        onClick({
            eventTarget: event.currentTarget,
            annotationIds: annotationIds
        });
        else // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        onClick({
            eventTarget: event.target,
            annotationIds: annotationIds
        });
    }, [
        annotationIds,
        onClick,
        state
    ]);
    const onMarkEnter = (evt)=>{
        const focusedElementTag = document.activeElement?.tagName;
        if (focusedElementTag === 'MARK' && evt.key === 'Enter') onMarkClick(evt);
    };
    const overriddenData = !state ? dataAttributes : {
        ...dataAttributes,
        'data-mark-annotation-state': state,
        'data-has-focus': hasFocus,
        'data-is-hovered': isHovered
    };
    const desktopAccessibilityAttributes = $c95b45af50ffb058$var$isMobile() ? {} : {
        role: 'button',
        tabIndex: 0,
        onKeyDown: onMarkEnter,
        'aria-expanded': hasFocus
    };
    const accessibility = state !== (0, $88i6h.AnnotationMarkStates).ACTIVE ? {
        'aria-disabled': true
    } : {
        'aria-details': annotationIds.join(', '),
        ...desktopAccessibilityAttributes
    };
    return (0, $f8Sb3.jsx)(useBlockLevel ? 'div' : 'mark', {
        ref: id === currentSelectedAnnotationId ? markRef : undefined,
        id: id,
        [(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? 'onClickCapture' : 'onClick']: onMarkClick,
        ...accessibility,
        ...overriddenData,
        ...!useBlockLevel && {
            css: [
                $c95b45af50ffb058$var$markStyles,
                (0, $VSDnB.fg)('platform_renderer_nested_annotation_styling') && $c95b45af50ffb058$var$markStylesLayeringFix,
                (0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') && $c95b45af50ffb058$var$markStylesWithInlineComments,
                (0, $VSDnB.fg)('confluence-frontend-comments-panel') && $c95b45af50ffb058$var$markStylesWithCommentsPanel,
                !$c95b45af50ffb058$var$isMobile() && $c95b45af50ffb058$var$accessibilityStyles,
                $c95b45af50ffb058$var$markStylesWithUpdatedShadow
            ],
            style: {
                '--ak-renderer-annotation-startmarker': intl.formatMessage((0, $1Bd5P.inlineCommentMessages).contentRendererInlineCommentMarkerStart),
                '--ak-renderer-annotation-endmarker': intl.formatMessage((0, $1Bd5P.inlineCommentMessages).contentRendererInlineCommentMarkerEnd)
            }
        }
    }, children);
};

});

parcelRegister("6Oe8V", function(module, exports) {

$parcel$export(module.exports, "useInlineCommentsFilter", () => $588f60613625d184$export$8e7d47f9e38ad4f1);

var $5uXOq = parcelRequire("5uXOq");

var $iYAgE = parcelRequire("iYAgE");
const $588f60613625d184$export$8e7d47f9e38ad4f1 = ({ annotationIds: annotationIds, filter: { state: stateFilter } })=>{
    const states = (0, $5uXOq.useContext)((0, $iYAgE.InlineCommentsStateContext));
    return (0, $5uXOq.useMemo)(()=>{
        return annotationIds.reduce((acc, id)=>{
            if (states && states[id] === stateFilter) return [
                ...acc,
                id
            ];
            return acc;
        }, []);
    }, [
        annotationIds,
        states,
        stateFilter
    ]);
};

});

parcelRegister("3N1TD", function(module, exports) {

$parcel$export(module.exports, "useInlineCommentSubscriberContext", () => $861d152b5ce122b2$export$b46737175cffd396);

var $5uXOq = parcelRequire("5uXOq");

var $iYAgE = parcelRequire("iYAgE");
const $861d152b5ce122b2$export$b46737175cffd396 = ()=>{
    const providers = (0, $5uXOq.useContext)((0, $iYAgE.ProvidersContext));
    if (!providers) return null;
    const { inlineComment: { updateSubscriber: updateSubscriber } } = providers;
    return updateSubscriber || null;
};

});



parcelRegister("GDkvY", function(module, exports) {

$parcel$export(module.exports, "toReact", () => $d1627eb50b8d1823$export$d4334b129116aad7);
/* eslint-disable @atlaskit/editor/no-re-export */ // Mapping file

var $bVGKe = parcelRequire("bVGKe");

var $lqKi3 = parcelRequire("lqKi3");

var $kgK5w = parcelRequire("kgK5w");

var $f14yv = parcelRequire("f14yv");

var $eVxaj = parcelRequire("eVxaj");

var $gUlHA = parcelRequire("gUlHA");

var $c15YI = parcelRequire("c15YI");

var $koUAb = parcelRequire("koUAb");

var $eESZY = parcelRequire("eESZY");

var $95Yll = parcelRequire("95Yll");

var $lbdLJ = parcelRequire("lbdLJ");

var $9xZ5X = parcelRequire("9xZ5X");

var $g5EjF = parcelRequire("g5EjF");

var $acz8Q = parcelRequire("acz8Q");

var $8DQfy = parcelRequire("8DQfy");

var $g9yqu = parcelRequire("g9yqu");

var $cKKwC = parcelRequire("cKKwC");

var $itF0z = parcelRequire("itF0z");

var $6EeUE = parcelRequire("6EeUE");
const $d1627eb50b8d1823$export$c00d967a0f56fdb7 = {
    code: (0, $bVGKe.default),
    em: (0, $lqKi3.default),
    link: (0, $kgK5w.default),
    strike: (0, $f14yv.default),
    strong: (0, $eVxaj.default),
    subsup: (0, $gUlHA.default),
    textColor: (0, $c15YI.default),
    backgroundColor: (0, $koUAb.default),
    underline: (0, $eESZY.default),
    annotation: (0, $cKKwC.default),
    border: (0, $itF0z.default),
    // Stage0
    confluenceInlineComment: (0, $6EeUE.default),
    breakout: (0, $95Yll.default),
    alignment: (0, $lbdLJ.default),
    indentation: (0, $9xZ5X.default),
    unsupportedMark: (0, $g5EjF.default),
    unsupportedNodeAttribute: (0, $acz8Q.default),
    dataConsumer: (0, $8DQfy.default),
    fragment: (0, $g9yqu.default)
};
const $d1627eb50b8d1823$export$d4334b129116aad7 = (mark)=>{
    return $d1627eb50b8d1823$export$c00d967a0f56fdb7[mark.type.name];
};

});
parcelRegister("bVGKe", function(module, exports) {

$parcel$export(module.exports, "isCodeMark", () => $caa083dc61fd842d$export$86390c02c110ec2f);
$parcel$export(module.exports, "default", () => $caa083dc61fd842d$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $O2UjQ = parcelRequire("O2UjQ");

var $fJyLQ = parcelRequire("fJyLQ");
const $caa083dc61fd842d$export$86390c02c110ec2f = (mark)=>{
    return mark && mark.type && mark.type.name === 'code';
};
function $caa083dc61fd842d$export$7cea6ffa7022e85f(props) {
    const codeBidiWarningLabel = props.intl.formatMessage((0, $fJyLQ.codeBidiWarningMessages).label);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $O2UjQ.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "code",
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: props.codeBidiWarningTooltipEnabled,
        ...props.dataAttributes,
        children: props.children
    });
}
var $caa083dc61fd842d$export$2e2bcd8739ae039 = (0, $8RXs9.default)($caa083dc61fd842d$export$7cea6ffa7022e85f);

});
parcelRegister("O2UjQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c9c981a54265bdd$export$2e2bcd8739ae039);
/* code.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $lrHA4 = parcelRequire("lrHA4");

var $31cgS = parcelRequire("31cgS");
const $4c9c981a54265bdd$var$styles = {
    base: "_ca0qyh40 _u5f3m5ip _n3tdyh40 _19bvm5ip _2rko1sit _11c81u0j _1reo1wug _18m91wug _1dqoglyw _1e0c1nu9 _bfhktkvp _16d9qvcn _syaz1fxt _vwz41kw7 _1i4q1hna _o5721jtm"
};
/**
 * __Code__
 *
 * Code highlights short strings of code snippets inline with body text.
 *
 * - [Examples](https://atlassian.design/components/code/examples)
 * - [Code](https://atlassian.design/components/code/code)
 * - [Usage](https://atlassian.design/components/code/usage)
 */ const $4c9c981a54265bdd$var$Code = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Code({ testId: testId, ...props }, ref) {
    const { children: children, codeBidiWarnings: codeBidiWarnings = true, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, ...otherProps } = props;
    const decoratedChildren = codeBidiWarnings ? /*#__PURE__*/ (0, $2OMIu.jsx)($4c9c981a54265bdd$var$RenderCodeChildrenWithBidiWarnings, {
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
        children: children
    }) : children;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("code", {
        ref: ref,
        "data-testid": testId,
        ...otherProps,
        className: (0, $bwpsq.default)([
            $4c9c981a54265bdd$var$styles.base
        ]),
        children: decoratedChildren
    });
}));
function $4c9c981a54265bdd$var$RenderCodeChildrenWithBidiWarnings({ children: children, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled }) {
    const replacedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children, (childNode)=>{
        if (typeof childNode === 'string') {
            const decorated = (0, $31cgS.default)(childNode, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $lrHA4.default), {
                    bidiCharacter: bidiCharacter,
                    label: codeBidiWarningLabel,
                    tooltipEnabled: codeBidiWarningTooltipEnabled
                }, index));
            return decorated;
        }
        if ($4c9c981a54265bdd$var$isReactElement(childNode) && childNode.props.children) {
            // eslint-disable-next-line @repo/internal/react/no-clone-element
            const newChildNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(childNode, {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($4c9c981a54265bdd$var$RenderCodeChildrenWithBidiWarnings, {
                    codeBidiWarningLabel: codeBidiWarningLabel,
                    codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
                    children: childNode.props.children
                })
            });
            return newChildNode;
        }
        return childNode;
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
        children: replacedChildren
    });
}
function $4c9c981a54265bdd$var$isReactElement(child) {
    return !!child.type;
}
$4c9c981a54265bdd$var$Code.displayName = 'Code';
var $4c9c981a54265bdd$export$2e2bcd8739ae039 = $4c9c981a54265bdd$var$Code;

});
parcelRegister("lrHA4", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e6443bd1dfeaac7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $abxiq = parcelRequire("abxiq");
function $2e6443bd1dfeaac7$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, tooltipEnabled: tooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
    if (tooltipEnabled) return(// Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: label,
        tag: $2e6443bd1dfeaac7$var$CustomizedTagWithRef,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $abxiq.Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter,
            children: skipChildren ? null : bidiCharacter
        })
    }));
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $abxiq.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter,
        children: skipChildren ? null : bidiCharacter
    });
}
const $2e6443bd1dfeaac7$var$CustomizedTagWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...rest,
        ref: ref,
        children: children
    });
});

});
parcelRegister("abxiq", function(module, exports) {

$parcel$export(module.exports, "Decorator", () => $59fdc1b7b0ae96c9$export$a592b67c93d52467);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jldZL = parcelRequire("jldZL");
const $59fdc1b7b0ae96c9$var$decoration = {
    root: "_kqswh2mm _szpl2smr _dsq41wug _1xyt1b66 _123w1b66 _15nnze3t _rxygze3t _1a354jg8 _1j6r1odn _1uakf6fq _1kt9y7el _is06wx40 _1rus1tzq _1cfcvrvc _24gj1h6o _19o61h6o _cfu1116y _1rbawx40 _1xqc1rd4"
};
function $59fdc1b7b0ae96c9$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
    const bidiCharacterCode = $59fdc1b7b0ae96c9$var$getBidiCharacterCode(bidiCharacter);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                "data-testid": testId,
                "data-bidi-character-code": bidiCharacterCode,
                // This is set to true so that the content is not read out by
                // screen readers as the content includes angle brackets for
                // visual decoration purposes.
                // We use a visually hidden `mark` element below for screen readers
                "aria-hidden": "true",
                className: (0, $bwpsq.default)([
                    $59fdc1b7b0ae96c9$var$decoration.root
                ]),
                children: children
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jldZL.default), {
                testId: testId && `${testId}--visually-hidden`,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("mark", {
                    children: bidiCharacterCode
                })
            })
        ]
    });
}
function $59fdc1b7b0ae96c9$var$getBidiCharacterCode(bidiCharacter) {
    const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
    return `U+${bidiCharacterCode}`;
}

});


parcelRegister("31cgS", function(module, exports) {

$parcel$export(module.exports, "default", () => $e16562bd8c2aca9b$export$2e2bcd8739ae039);
const $e16562bd8c2aca9b$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
function $e16562bd8c2aca9b$export$2e2bcd8739ae039(originalText, decorate) {
    const matches = [
        ...originalText.matchAll($e16562bd8c2aca9b$export$ecb256e6a1f5ee7e)
    ];
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    let children = [];
    let mappedTo = 0;
    for (const match of matches){
        if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
        // mapped to the children.
        // Add them as plain text.
        children.push(originalText.substring(mappedTo, match.index));
        children.push(decorate({
            bidiCharacter: match[0],
            index: match.index
        }));
        // While index is guaranteed to be present, it needs to be asserted due
        // to a limitation of typescripts regex handling
        //
        // https://github.com/microsoft/TypeScript/issues/36788
        // Decorate bidi character
        mappedTo = match.index + match[0].length;
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}

});



parcelRegister("lqKi3", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd21faba719ebab1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $fd21faba719ebab1$export$2e2bcd8739ae039(props) {
    // ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, $2OMIu.jsx)("em", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("kgK5w", function(module, exports) {

$parcel$export(module.exports, "default", () => $9900830cb94354be$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $K5Jsy = parcelRequire("K5Jsy");

var $knXBU = parcelRequire("knXBU");

var $gkwXh = parcelRequire("gkwXh");

var $VSDnB = parcelRequire("VSDnB");

var $iHvAB = parcelRequire("iHvAB");

var $daJ0i = parcelRequire("daJ0i");
const $9900830cb94354be$var$anchorStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: `var(--ds-link, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
    '&:hover': {
        color: `var(--ds-link, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
        textDecoration: 'underline'
    },
    '&:active': {
        color: `var(--ds-link-pressed, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`
    }
});
function $9900830cb94354be$export$2e2bcd8739ae039(props) {
    const { href: href, target: target, eventHandlers: eventHandlers, fireAnalyticsEvent: fireAnalyticsEvent, isMediaLink: isMediaLink, dataAttributes: dataAttributes } = props;
    const anchorProps = {
        href: href,
        target: target,
        title: href
    };
    if (target === '_blank') anchorProps.rel = 'noreferrer noopener';
    const handler = (0, $K5Jsy.getEventHandler)(eventHandlers, 'link');
    if (isMediaLink) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, props.children);
    const analyticsData = {
        attributes: {
            location: 'renderer'
        },
        // Below is added for the future implementation of Linking Platform namespaced analytic context
        location: 'renderer'
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $daJ0i.default), {
        data: analyticsData
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $iHvAB.default), {
        css: $9900830cb94354be$var$anchorStyles,
        onClick: (e)=>{
            if (fireAnalyticsEvent) fireAnalyticsEvent({
                action: (0, $gkwXh.ACTION).VISITED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).LINK,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                attributes: {
                    platform: (0, $knXBU.PLATFORM).WEB,
                    mode: (0, $knXBU.MODE).RENDERER
                }
            });
            if (handler) handler(e, href);
        },
        ...anchorProps,
        ...dataAttributes,
        ...(0, $VSDnB.fg)('platform_editor_hyperlink_underline') && {
            isLinkComponent: true
        }
    }, props.children));
}

});
parcelRegister("K5Jsy", function(module, exports) {

$parcel$export(module.exports, "ADFEncoder", () => $75b48ee07210971a$export$bcf771b83128eae7);
$parcel$export(module.exports, "getText", () => $75b48ee07210971a$export$c72d34660a162238);
$parcel$export(module.exports, "getEventHandler", () => $75b48ee07210971a$export$eee20638634729b3);
$parcel$export(module.exports, "findInTree", () => $75b48ee07210971a$export$38b61ebf4950cd39);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $kOFhM = parcelRequire("kOFhM");

var $hYNZx = parcelRequire("hYNZx");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $75b48ee07210971a$var$createEncoder(parser, encoder) {
    return (value)=>encoder.encode(parser.parse(value));
}
class $75b48ee07210971a$export$bcf771b83128eae7 {
    constructor(createTransformerWithSchema){
        const transformer = createTransformerWithSchema((0, $kOFhM.defaultSchema));
        this.encode = $75b48ee07210971a$var$createEncoder(transformer, new (0, $hYNZx.JSONTransformer)());
    }
}
const $75b48ee07210971a$export$c72d34660a162238 = (node)=>{
    return node.text || node.attrs && (node.attrs.text || node.attrs.shortName) || `[${typeof node.type === 'string' ? node.type : node.type.name}]`;
};
const $75b48ee07210971a$export$eee20638634729b3 = (eventHandlers, type, eventName = 'onClick')=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return eventHandlers && type && eventHandlers[type] && eventHandlers[type][eventName];
};
function $75b48ee07210971a$export$38b61ebf4950cd39(element, topElement, evaluate) {
    if (element === topElement) return false;
    if (evaluate(element)) return true;
    if (!element.parentElement) return false;
    return $75b48ee07210971a$export$38b61ebf4950cd39(element.parentElement, topElement, evaluate);
}

});

parcelRegister("iHvAB", function(module, exports) {

$parcel$export(module.exports, "default", () => $65e7a399613e0863$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $994MI = parcelRequire("994MI");

var $e4yMr = parcelRequire("e4yMr");

var $VSDnB = parcelRequire("VSDnB");

var $g2eZ6 = parcelRequire("g2eZ6");

var $66xOO = parcelRequire("66xOO");

var $hTTxJ = parcelRequire("hTTxJ");

var $cI2hq = parcelRequire("cI2hq");
const $65e7a399613e0863$var$PACKAGE_DATA = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local",
    componentName: 'linkUrl'
};
const $65e7a399613e0863$var$Anchor = (0, $g2eZ6.withLinkClickedEvent)('a');
const $65e7a399613e0863$export$8c0773eab230d49e = (0, $g2eZ6.withLinkClickedEvent)((0, $e4yMr.default));
const $65e7a399613e0863$var$LinkUrl = ({ href: href, children: children, checkSafety: checkSafety = true, onClick: onClick, testId: testId = 'link-with-safety', isLinkComponent: isLinkComponent = false, ...props })=>{
    (0, $gKZoD.di)($65e7a399613e0863$export$8c0773eab230d49e, (0, $cI2hq.useLinkWarningModal));
    const { isLinkSafe: isLinkSafe, showSafetyWarningModal: showSafetyWarningModal, ...linkWarningModalProps } = (0, $cI2hq.useLinkWarningModal)();
    const Link = isLinkComponent && (0, $VSDnB.fg)('platform_editor_hyperlink_underline') ? $65e7a399613e0863$export$8c0773eab230d49e : $65e7a399613e0863$var$Anchor;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $66xOO.LinkAnalyticsContext), {
                url: href,
                display: "url",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(Link, {
                    "data-testid": testId,
                    href: href || '',
                    onClick: (e)=>{
                        if (!checkSafety) {
                            onClick && onClick(e);
                            return;
                        }
                        // Only call the onClick if the link is safe
                        if (isLinkSafe(e, href)) onClick && onClick(e);
                        else showSafetyWarningModal(e, href);
                    },
                    ...props,
                    children: children
                })
            }),
            checkSafety && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hTTxJ.default), {
                ...linkWarningModalProps
            })
        ]
    });
};
var $65e7a399613e0863$export$2e2bcd8739ae039 = (0, $994MI.default)($65e7a399613e0863$var$PACKAGE_DATA)($65e7a399613e0863$var$LinkUrl);

});
parcelRegister("g2eZ6", function(module, exports) {

$parcel$export(module.exports, "fireLinkClickedEvent", () => $473b45d487f9fd1b$export$7987de3055fbdcb0);
$parcel$export(module.exports, "withLinkClickedEvent", () => $473b45d487f9fd1b$export$263352d59c0c5966);

var $5uXOq = parcelRequire("5uXOq");

var $b6uPu = parcelRequire("b6uPu");

var $4URMI = parcelRequire("4URMI");

var $fzJZi = parcelRequire("fzJZi");
const $473b45d487f9fd1b$export$cfb45d54e1604f6c = new Map([
    [
        undefined,
        'none'
    ],
    [
        0,
        'left'
    ],
    [
        1,
        'middle'
    ],
    [
        2,
        'right'
    ]
]);
const $473b45d487f9fd1b$export$74743eda5dda3ccf = (e)=>{
    return [
        'alt',
        'ctrl',
        'meta',
        'shift'
    ].filter((key)=>e[`${key}Key`] === true);
};
const $473b45d487f9fd1b$var$isContentEditable = (el)=>{
    return el instanceof HTMLElement && el.isContentEditable;
};
function $473b45d487f9fd1b$export$d2a83e3b34be812b(e, clickType) {
    const { mac: mac, safari: safari } = (0, $b6uPu.browser)();
    /**
	 * If the link/parent is content editable then left click won't have typical effect
	 */ if ($473b45d487f9fd1b$var$isContentEditable(e.currentTarget) && [
        'left',
        'middle'
    ].includes(clickType)) return 'contentEditable';
    switch(clickType){
        case 'left':
        case 'keyboard':
            {
                // Meta key = Cmd for macOS, Windows key sometimes for Windows (otherwise false)
                // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/metaKey
                if (e.metaKey) return mac ? 'clickThroughNewTabOrWindow' : 'clickThrough';
                if (e.shiftKey) {
                    // Alt/option click in safari typically adds the link to bookmarks
                    if (safari) return 'alt';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.ctrlKey) {
                    // Ctrl+Left on macOS defaults to triggering a right click instead (so won't trigger onClick)
                    // but if this behaviour is disabled, likely outcome is clickThrough
                    if (mac) return 'clickThrough';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.altKey) return 'alt';
                const target = e.currentTarget.getAttribute('target');
                if (target === '_blank') return 'clickThroughNewTabOrWindow';
                return 'clickThrough';
            }
        case 'middle':
            return 'clickThroughNewTabOrWindow';
        case 'right':
            return 'contextMenu';
    }
    return 'unknown';
}
const $473b45d487f9fd1b$var$linkClickedEvent = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented })=>({
        action: 'clicked',
        actionSubject: 'link',
        eventType: 'ui',
        attributes: {
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented
        }
    });
const $473b45d487f9fd1b$export$7fedc699766c16de = (event)=>{
    // Through the `detail` property, we're able to determine if the event is (most likely) triggered via keyboard
    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
    const isKeyboard = event.nativeEvent.detail === 0;
    const clickType = isKeyboard ? 'keyboard' : $473b45d487f9fd1b$export$cfb45d54e1604f6c.get(event.button);
    if (!clickType) return;
    const clickOutcome = $473b45d487f9fd1b$export$d2a83e3b34be812b(event, clickType);
    const keysHeld = $473b45d487f9fd1b$export$74743eda5dda3ccf(event);
    const defaultPrevented = event.defaultPrevented;
    const linkClickedEventResult = $473b45d487f9fd1b$var$linkClickedEvent({
        clickType: clickType,
        clickOutcome: clickOutcome,
        keysHeld: keysHeld,
        defaultPrevented: defaultPrevented
    });
    // if the current target is an anchor tag, we can get the href from it and use that as the url being navigated too.
    if (event.currentTarget instanceof HTMLAnchorElement) {
        const url = event.currentTarget.href;
        return {
            ...linkClickedEventResult,
            nonPrivacySafeAttributes: {
                url: url
            }
        };
    } else // We can't get the href from the event target, so dont include the url or any non privacy safe attributes
    return linkClickedEventResult;
};
const $473b45d487f9fd1b$export$7987de3055fbdcb0 = (createAnalyticsEvent)=>(event, overrides = {})=>{
        const payload = $473b45d487f9fd1b$export$7fedc699766c16de(event);
        if (payload) createAnalyticsEvent({
            ...payload,
            ...overrides,
            attributes: {
                ...payload.attributes,
                ...overrides?.attributes
            },
            nonPrivacySafeAttributes: {
                ...payload.nonPrivacySafeAttributes,
                ...overrides?.nonPrivacySafeAttributes
            }
        }).fire((0, $fzJZi.ANALYTICS_CHANNEL));
    };
const $473b45d487f9fd1b$var$getDisplayName = (WrappedComponent)=>{
    if (typeof WrappedComponent === 'string') return WrappedComponent;
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
function $473b45d487f9fd1b$export$263352d59c0c5966(WrappedComponent) {
    const Component = (props)=>{
        const onClick = (0, $4URMI.useLinkClicked)(props.onClick);
        const onMouseDown = (0, $4URMI.useMouseDownEvent)(props.onMouseDown);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...props,
            onClick: onClick,
            onMouseDown: onMouseDown
        });
    };
    Component.displayName = `withLinkClickedEvent(${$473b45d487f9fd1b$var$getDisplayName(WrappedComponent)})`;
    return Component;
}

});
parcelRegister("b6uPu", function(module, exports) {

$parcel$export(module.exports, "browser", () => $7f7209ce5c1e8d08$export$3f2684e5d7cb1006);
const $7f7209ce5c1e8d08$var$result = {
    mac: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.mac = /Mac/.test(navigator.platform);
    let ie = $7f7209ce5c1e8d08$var$result.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $7f7209ce5c1e8d08$var$result.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    $7f7209ce5c1e8d08$var$result.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    $7f7209ce5c1e8d08$var$result.android = /Android \d/.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $7f7209ce5c1e8d08$var$result.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $7f7209ce5c1e8d08$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $7f7209ce5c1e8d08$var$result.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}
function $7f7209ce5c1e8d08$export$3f2684e5d7cb1006() {
    return $7f7209ce5c1e8d08$var$result;
}

});

parcelRegister("4URMI", function(module, exports) {

$parcel$export(module.exports, "useLinkClicked", () => $0d5ea96be37e2b5d$export$5993d3ca6c85f774);
$parcel$export(module.exports, "useMouseDownEvent", () => $0d5ea96be37e2b5d$export$df67f318ded0283c);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $g2eZ6 = parcelRequire("g2eZ6");
var $0d5ea96be37e2b5d$export$81a5b494baf0f17c = /*#__PURE__*/ function(ClickButton) {
    ClickButton[ClickButton["Left"] = 0] = "Left";
    ClickButton[ClickButton["Middle"] = 1] = "Middle";
    ClickButton[ClickButton["Right"] = 2] = "Right";
    return ClickButton;
}({});
const $0d5ea96be37e2b5d$export$5993d3ca6c85f774 = (/**
	 * Handler to
	 */ handler, /**
	 * Filter which mouse events should trigger the link clicked event
	 */ predicate)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)((...args)=>{
        const [event] = args;
        handler?.apply(null, args);
        if (!predicate || predicate?.(event)) (0, $g2eZ6.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        handler,
        predicate,
        createAnalyticsEvent
    ]);
};
const $0d5ea96be37e2b5d$var$isNotLeftClick = (event)=>event.button !== 0;
const $0d5ea96be37e2b5d$export$df67f318ded0283c = (onMouseDown)=>{
    return $0d5ea96be37e2b5d$export$5993d3ca6c85f774(onMouseDown, $0d5ea96be37e2b5d$var$isNotLeftClick);
};

});

parcelRegister("fzJZi", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $3b4d25437cc28513$export$85183a312807388d);
$parcel$export(module.exports, "context", () => $3b4d25437cc28513$export$a078c61943f9dbbe);
$parcel$export(module.exports, "TrackQuickActionType", () => $3b4d25437cc28513$export$72af824fa910c33e);
$parcel$export(module.exports, "TrackQuickActionFailureReason", () => $3b4d25437cc28513$export$c89e475f7f7174c2);
$parcel$export(module.exports, "SmartLinkEvents", () => $3b4d25437cc28513$export$b91e0203b928470c);
const $3b4d25437cc28513$export$85183a312807388d = 'media';
const $3b4d25437cc28513$export$a078c61943f9dbbe = {
    componentName: 'smart-cards',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
var $3b4d25437cc28513$export$72af824fa910c33e = /*#__PURE__*/ function(TrackQuickActionType) {
    TrackQuickActionType["StatusUpdate"] = "StatusUpdate";
    return TrackQuickActionType;
}({});
var $3b4d25437cc28513$export$c89e475f7f7174c2 = /*#__PURE__*/ function(TrackQuickActionFailureReason) {
    TrackQuickActionFailureReason["PermissionError"] = "PermissionError";
    TrackQuickActionFailureReason["ValidationError"] = "ValidationError";
    TrackQuickActionFailureReason["UnknownError"] = "UnknownError";
    return TrackQuickActionFailureReason;
}({});
class $3b4d25437cc28513$export$b91e0203b928470c {
    insertSmartLink(url, type, createAnalyticsEvent) {
        $3b4d25437cc28513$export$2a123f7ee48a122c({
            action: 'inserted',
            actionSubject: 'smartLink',
            eventType: 'track',
            attributes: {
                type: type
            },
            nonPrivacySafeAttributes: {
                domainName: url
            }
        }, createAnalyticsEvent);
    }
}
const $3b4d25437cc28513$export$2a123f7ee48a122c = (payload, createAnalyticsEvent)=>{
    if (createAnalyticsEvent) createAnalyticsEvent(payload).fire($3b4d25437cc28513$export$85183a312807388d);
};

});


parcelRegister("66xOO", function(module, exports) {

$parcel$export(module.exports, "LinkAnalyticsContext", () => $a51765c35bf0b052$export$9458cdec663b9ff1);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $daJ0i = parcelRequire("daJ0i");
const $a51765c35bf0b052$export$9458cdec663b9ff1 = ({ display: display, id: id, children: children, source: source })=>{
    const displayCategory = display === 'url' ? 'link' : undefined;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $daJ0i.default), {
        data: {
            source: source,
            attributes: {
                displayCategory: displayCategory,
                display: display,
                id: id
            }
        },
        children: children
    });
};

});

parcelRegister("hTTxJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ef61591d3052acd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ousew = parcelRequire("ousew");
var $8RXs9 = parcelRequire("8RXs9");
var $i5FdW = parcelRequire("i5FdW");

var $fVnbM = parcelRequire("fVnbM");

var $e4yMr = parcelRequire("e4yMr");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");
var $i8Qvm = parcelRequire("i8Qvm");

var $VSDnB = parcelRequire("VSDnB");

var $7zaVw = parcelRequire("7zaVw");
const $6ef61591d3052acd$var$breakWordsCss = null;
const $6ef61591d3052acd$var$WarningModal = (props)=>{
    const { isOpen: isOpen, unsafeLinkText: unsafeLinkText, url: url, onClose: onClose, onContinue: onContinue, intl: intl } = props;
    const content = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i8Qvm.default), {
        children: isOpen && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $1R1Ge.default), {
            onClose: onClose,
            testId: "link-with-safety-warning",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jgVsb.default), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gofOI.default), {
                        appearance: "warning",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $7zaVw.messages).check_this_link
                        })
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7QSqG.default), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $bwpsq.default)([
                            "_o5726vc6 _1nmz9jpi"
                        ]),
                        children: url && unsafeLinkText && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $7zaVw.messages).link_safety_warning_message,
                            values: {
                                unsafeLinkText: unsafeLinkText,
                                a: ()=>(0, $VSDnB.fg)('platform-linking-fix-a11y-in-smart-card') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e4yMr.default), {
                                        href: url,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: url
                                    }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                                    /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
                                        href: url,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: url
                                    })
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $juxqI.default), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                            appearance: "subtle",
                            onClick: onClose,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                ...(0, $7zaVw.messages).go_back
                            })
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                            appearance: "warning",
                            onClick: onContinue,
                            autoFocus: true,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                ...(0, $7zaVw.messages).continue
                            })
                        })
                    ]
                })
            ]
        })
    });
    return intl ? content : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        locale: "en",
        children: content
    });
};
var $6ef61591d3052acd$export$2e2bcd8739ae039 = (0, $8RXs9.default)($6ef61591d3052acd$var$WarningModal, {
    enforceContext: false
});

});
parcelRegister("7zaVw", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a298b78183f16654$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $a298b78183f16654$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    actions: {
        id: 'fabric.linking.actions',
        defaultMessage: 'Actions',
        description: ''
    },
    add_account: {
        id: 'fabric.linking.add_account',
        defaultMessage: 'Add account',
        description: 'Allows to add a new account'
    },
    ai_summarize: {
        id: 'fabric.linking.ai_summarize',
        defaultMessage: 'Summarize',
        description: 'Action to summarize link resource content with AI'
    },
    ai_summarized: {
        id: 'fabric.linking.ai_summarized',
        defaultMessage: 'Summarized by Atlassian Intelligence',
        description: 'Shown with the content summarised by AI.'
    },
    ai_summarized_abbreviation: {
        id: 'fabric.linking.ai_summarized_abbreviation',
        defaultMessage: 'Summarized by AI',
        description: 'Shown with the content summarised by AI. AI is in abbreviation form to reduce space.'
    },
    ai_summarized_info: {
        id: 'fabric.linking.ai_summarized_info',
        defaultMessage: 'Information quality may vary. <a>Learn more</a>',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarized_info_short: {
        id: 'fabric.linking.ai_summarized_info_short',
        defaultMessage: 'Content quality may vary',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarizing: {
        id: 'fabric.linking.ai_summarizing',
        defaultMessage: 'Atlassian Intelligence is working...',
        description: 'Shown when AI summary is summarising the link resource content.'
    },
    ai_summary_error_generic: {
        id: 'fabric.linking.ai_summary_error_generic',
        defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <a>check the status of AI</a>.",
        description: 'Shown when AI Summary encountered an unexpected error while summarizing the linked resource content.'
    },
    ai_summary_error_acceptable_use_violation: {
        id: 'fabric.linking.ai_summary_error_acceptable_use_violation',
        defaultMessage: "We cannot show the results of this summary as it goes against <a>Atlassian's Acceptable Use Policy</a>.",
        description: 'Shown when AI summary is summarising the link resource content and the content violates atlassians acceptable use policy.'
    },
    ai_summary_error_hipaa_content_detected: {
        id: 'fabric.linking.ai_summary_error_hipaa_content_detected',
        defaultMessage: 'Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content.',
        description: 'Shown when the AI summary is summarising the link resource content and the content contains HIPAA restricted content.'
    },
    ai_summary_error_exceeding_context_length_error: {
        id: 'fabric.linking.ai_summary_error_exceeding_context_length_error',
        defaultMessage: "Atlassian Intelligence can't generate a summary for you right now as there is too much content to summarize.",
        description: 'Shown when the AI summary is summarising the link resource content and the content is too large to summarize.'
    },
    assigned_to: {
        id: 'fabric.linking.assigned_to',
        defaultMessage: 'Assigned to {context}',
        description: 'Indicates the person or entity that the resource is assigned to.'
    },
    automation_action_title: {
        id: 'fabric.linking.automation-action.title',
        defaultMessage: 'View automation rules',
        description: 'The title of the button in a hover card to open an automation menu for a given SmartLink.'
    },
    automation_action_icon_label: {
        id: 'fabric.linking.automation-action.icon.label',
        defaultMessage: 'Automation icon',
        description: 'The label for the automation icon inside of the button opening the automation menu.'
    },
    automation_action_tooltip: {
        id: 'fabric.linking.automation-action.tooltip',
        defaultMessage: 'Select an automation rule to run',
        description: 'The tooltip for the automation action indicating that a button will open an automation modal.'
    },
    automation_action_confluence_page_modal_title: {
        id: 'fabric.linking.automation-action.confluence.page.modal.title',
        defaultMessage: 'Page automations',
        description: 'The title of the automation modal when the SmartLink is a Confluence page'
    },
    automation_action_confluence_page_modal_description: {
        id: 'fabric.linking.automation-action.confluence.page.modal.description',
        defaultMessage: 'Apply an automation to <b>{name}</b>.{br}The available selections are controlled by Confluence and space administrators.',
        description: 'The description in the automation modal when the SmartLink is a Confluence page. Indicating which page the automation will apply to, and who controls the available automations.'
    },
    cancel: {
        id: 'fabric.linking.cancel',
        defaultMessage: 'Cancel',
        description: 'cancel'
    },
    beta: {
        id: 'fabric.linking.beta',
        defaultMessage: 'Beta',
        description: 'Indicates a beta phase of the feature.'
    },
    cannot_connect: {
        id: 'fabric.linking.cannot_connect',
        defaultMessage: "Can't connect, try again",
        description: 'Error for when a provided link is not found.'
    },
    cannot_find_link: {
        id: 'fabric.linking.cannot_find_link',
        defaultMessage: "Can't find link",
        description: 'Error for when a provided link is not found.'
    },
    click_to_join: {
        id: 'fabric.linking.click_to_join',
        defaultMessage: 'Join {context}',
        description: 'Allows the user join the product or service immediately'
    },
    click_to_join_description: {
        id: 'fabric.linking.click_to_join_description',
        defaultMessage: "You've been approved, so you can join {context} right away.",
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    close: {
        id: 'fabric.linking.close',
        defaultMessage: 'Close',
        description: ''
    },
    check_this_link: {
        id: 'fabric.linking.check_this_link',
        defaultMessage: 'Check this link',
        description: 'Link safety warning modal header'
    },
    compass_applied_components_count: {
        id: 'compass.applied_components_count.non-final',
        defaultMessage: 'Applied to {numberOfComponents, plural, one {{numberOfComponents, number} component}  other {{numberOfComponents, number} components}}'
    },
    connect_to: {
        id: 'fabric.linking.connect_to',
        defaultMessage: 'Connect to {name}',
        description: 'Allows the user to connect with different types of external services'
    },
    connect_account_description: {
        id: 'fabric.linking.connect_account_description',
        defaultMessage: "We'll open a new page to help you connect your {name} account",
        description: 'Explains what will happen when the users connects to a new account'
    },
    connect_link_account: {
        id: 'fabric.linking.connect_link_account',
        defaultMessage: 'Connect to preview',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link.'
    },
    connect_link_account_card: {
        id: 'fabric.linking.connect_link_account_card_view',
        defaultMessage: 'Connect',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_link_account_card_name: {
        id: 'fabric.linking.connect_link_account_card_view_name',
        defaultMessage: 'Connect your {context} account',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in title.'
    },
    connect_link_account_card_description: {
        id: 'fabric.linking.connect_link_account_card_view_description',
        defaultMessage: 'To show a preview of this link, connect your {context} account.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in byline.'
    },
    connect_unauthorised_account_action: {
        id: 'fabric.linking.connect_unauthorised_account_action',
        defaultMessage: 'Connect to {context}',
        description: 'Shown on a button to connect user external account to their Atlassian account.'
    },
    connect_unauthorised_account_description: {
        id: 'fabric.linking.connect_unauthorised_account_description',
        defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_unauthorised_account_description_no_provider: {
        id: 'fabric.linking.connect_unauthorised_account_description_no_provider',
        defaultMessage: 'Connect your account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
    },
    continue: {
        id: 'fabric.linking.continue',
        defaultMessage: 'Continue',
        description: 'continue'
    },
    copy_url_to_clipboard: {
        id: 'fabric.linking.copy_url_to_clipboard',
        defaultMessage: 'Copy link',
        description: ''
    },
    copied_url_to_clipboard: {
        id: 'fabric.linking.copied_url_to_clipboard',
        defaultMessage: 'Copied!',
        description: 'Url has been copied to the clipboard'
    },
    could_not_load_link: {
        id: 'fabric.linking.couldnt_load_link',
        defaultMessage: "We couldn't load this link for an unknown reason.",
        description: 'Error case for card view - link could not be loaded.'
    },
    created_by: {
        id: 'fabric.linking.created_by',
        defaultMessage: 'Created by {context}',
        description: 'Indicates the person or entity that created the resource.'
    },
    created_on_relative: {
        id: 'fabric.linking.create_on_relative',
        defaultMessage: 'Created {context}',
        description: 'Indicated when entity was created (relative form)'
    },
    created_on_absolute: {
        id: 'fabric.linking.create_on_absolute',
        defaultMessage: 'Created on {context}',
        description: 'Indicated when entity was created (absolute form)'
    },
    delete: {
        id: 'fabric.linking.delete',
        defaultMessage: 'Delete',
        description: 'Allow a user to delete a link'
    },
    download: {
        id: 'fabric.linking.download',
        defaultMessage: 'Download',
        description: ''
    },
    download_description: {
        id: 'fabric.linking.download_description',
        defaultMessage: 'Download this file into your local storage',
        description: 'Description on what Download does'
    },
    download_file: {
        id: 'fabric.linking.download_file',
        defaultMessage: 'Download file',
        description: 'Allow a user to download a file'
    },
    ai_summary_action: {
        id: 'fabric.linking.ai_summary_action',
        defaultMessage: 'Summarize with AI',
        description: 'Allow a user to summarize a link'
    },
    ai_summary_action_description: {
        id: 'fabric.linking.ai_summary_action_description',
        defaultMessage: 'Summarize the content of this link using Atlassian Intelligence.',
        description: 'Description of what the summarize link with AI action does'
    },
    copy_summary_action: {
        id: 'fabric.linking.copy_summary_action',
        defaultMessage: 'Copy summary',
        description: 'Allow a user to copy a generated summary'
    },
    copy_summary_action_description: {
        id: 'fabric.linking.copy_summary_action_description',
        defaultMessage: 'Copy summary',
        description: 'Description of what the copy summary AI action does'
    },
    copied_summary_action_description: {
        id: 'fabric.linking.copied_summary_action_description',
        defaultMessage: 'Copied summary to clipboard',
        description: 'Confirmation to the user that the summry has been copied'
    },
    edit: {
        id: 'fabric.linking.edit',
        defaultMessage: 'Edit',
        description: 'Allow a user to edit a link'
    },
    follow: {
        id: 'fabric.linking.follow',
        defaultMessage: 'Follow',
        description: 'Click to follow a project.'
    },
    follow_project_description: {
        id: 'fabric.linking.follow_project_description',
        defaultMessage: 'Follow to get notifications on this project',
        description: 'Description on what Follow does'
    },
    follow_project: {
        id: 'fabric.linking.follow_project',
        defaultMessage: 'Follow project',
        description: 'Click to follow a project.'
    },
    follow_project_error: {
        id: 'fabric.linking.follow_project_error',
        defaultMessage: 'We encountered an error while trying to follow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas project'
    },
    follow_goal_description: {
        id: 'fabric.linking.follow_goal_description',
        defaultMessage: 'Follow this goal to get notifications on updates',
        description: 'Description on what Follow does'
    },
    follow_goal: {
        id: 'fabric.linking.follow_goal',
        defaultMessage: 'Follow goal',
        description: 'Click to follow a project.'
    },
    follow_goal_error: {
        id: 'fabric.linking.follow_goal_error',
        defaultMessage: 'We encountered an error while trying to follow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas goal'
    },
    go_back: {
        id: 'fabric.linking.go_back',
        defaultMessage: 'Go back',
        description: 'go back'
    },
    invalid_permissions: {
        id: 'fabric.linking.invalid_permissions',
        defaultMessage: 'Restricted content',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    invalid_permissions_description: {
        id: 'fabric.linking.invalid_permissions_description',
        defaultMessage: "You'll need to request access or try a different account to view this preview.",
        description: 'Message shown when a user does not have permissions to view an item. Displayed as description.'
    },
    join_to_view: {
        id: 'fabric.linking.join_to_view',
        defaultMessage: 'Join {context} to view this issue',
        description: 'Allows the user join the product or service immediately'
    },
    learn_more_about_smart_links: {
        id: 'fabric.linking.learn_more_about_smart_links',
        defaultMessage: 'Learn more about Smart Links.',
        description: 'An anchor link to redirect user to a page about Smart Links.'
    },
    learn_more_about_connecting_account: {
        id: 'fabric.linking.learn_more_about_connecting_account',
        defaultMessage: 'Learn more about connecting your account to Atlassian products.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    },
    loading: {
        id: 'fabric.linking.loading',
        defaultMessage: 'Loading...',
        description: 'Indicates an element on a page is loading.'
    },
    modified_by: {
        id: 'fabric.linking.updated_by',
        defaultMessage: 'Modified by {context}',
        description: 'Indicates the person or entity that modified the resource.'
    },
    modified_on_relative: {
        id: 'fabric.linking.modified_on_relative',
        defaultMessage: 'Updated {context}',
        description: 'Indicated when entity was modified (relative form)'
    },
    modified_on_absolute: {
        id: 'fabric.linking.modified_on_absolute',
        defaultMessage: 'Updated on {context}',
        description: 'Indicated when entity was modified (absolute form)'
    },
    more_actions: {
        id: 'fabric.linking.more_actions',
        defaultMessage: 'More actions',
        description: 'Allows the users to see more link actions'
    },
    /**
	 * @deprecated remove when cleaning up FG platform_bandicoots-smart-card-disable-aria
	 */ more_information_about_this_work_item: {
        id: 'fabric.linking.more_information_about_this_work_item',
        defaultMessage: 'More information about this work item',
        description: 'Allows the users to see more about the work item'
    },
    open_issue_in_jira: {
        id: 'fabric.linking.open_issue_in_jira',
        defaultMessage: 'Open issue in Jira',
        description: 'Click to open link in Jira'
    },
    open_link_in_a_new_tab: {
        id: 'fabric.linking.open_link_in_a_new_tab',
        defaultMessage: 'Open link in a new tab',
        description: 'Click to open link in a new tab'
    },
    owned_by: {
        id: 'fabric.linking.owned_by',
        defaultMessage: 'Owned by {context}',
        description: 'Indicates the person or entity that owns or maintains the resource.'
    },
    preview_description: {
        id: 'fabric.linking.preview_description',
        defaultMessage: 'Open a full screen preview of this link',
        description: 'Description on what Preview does'
    },
    preview_improved: {
        id: 'fabric.linking.preview_improved',
        defaultMessage: 'Open preview',
        description: 'Click to view a richer view of your content, without needing to navigate to it.'
    },
    preview_close: {
        id: 'fabric.linking.preview_close',
        defaultMessage: 'Close preview',
        description: 'Click to close embed preview modal.'
    },
    preview_max_size: {
        id: 'fabric.linking.preview_max_size',
        defaultMessage: 'View full screen',
        description: 'Click to increase embed preview modal size to a maximum viewing size.'
    },
    preview_min_size: {
        id: 'fabric.linking.preview_min_size',
        defaultMessage: 'Close full screen',
        description: 'Click to decrease embed preview modal size to a minimum viewing size.'
    },
    priority_blocker: {
        id: 'fabric.linking.priority_blocker',
        defaultMessage: 'Blocker',
        description: 'Indicated priority as blocker'
    },
    priority_critical: {
        id: 'fabric.linking.priority_critical',
        defaultMessage: 'Critical',
        description: 'Indicated priority as critical'
    },
    priority_high: {
        id: 'fabric.linking.priority_high',
        defaultMessage: 'High',
        description: 'Indicated priority as high'
    },
    priority_highest: {
        id: 'fabric.linking.priority_highest',
        defaultMessage: 'Highest',
        description: 'Indicated priority as highest'
    },
    priority_low: {
        id: 'fabric.linking.priority_low',
        defaultMessage: 'Low',
        description: 'Indicated priority as low'
    },
    priority_lowest: {
        id: 'fabric.linking.priority_lowest',
        defaultMessage: 'Lowest',
        description: 'Indicated priority as lowest'
    },
    priority_major: {
        id: 'fabric.linking.priority_major',
        defaultMessage: 'Major',
        description: 'Indicated priority as major'
    },
    priority_medium: {
        id: 'fabric.linking.priority_medium',
        defaultMessage: 'Medium',
        description: 'Indicated priority as medium'
    },
    priority_minor: {
        id: 'fabric.linking.priority_minor',
        defaultMessage: 'Minor',
        description: 'Indicated priority as minor'
    },
    priority_trivial: {
        id: 'fabric.linking.priority_trivial',
        defaultMessage: 'Trivial',
        description: 'Indicated priority as trivial'
    },
    priority_undefined: {
        id: 'fabric.linking.priority_undefined',
        defaultMessage: 'Undefined',
        description: 'Indicated priority as unknown'
    },
    forbidden_access: {
        id: 'fabric.linking.forbidden_access',
        defaultMessage: 'Your access is forbidden',
        description: 'Shown when a user does not have access to a resource behind the link.'
    },
    pending_request: {
        id: 'fabric.linking.pending_request',
        defaultMessage: 'Your access request is pending',
        description: 'Shown when a user has requested an access but status is pending.'
    },
    read_time: {
        id: 'fabric.linking.read_time',
        defaultMessage: '{context} min read',
        description: 'Estimated time to read this resource'
    },
    restricted_link: {
        id: 'fabric.linking.restricted_link',
        defaultMessage: 'Restricted link, try another account',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    request_access_to_view: {
        id: 'fabric.linking.request_access_to_view',
        defaultMessage: 'Request access to {context} to view this issue',
        description: 'Allows the user to request access to a product or service'
    },
    request_denied: {
        id: 'fabric.linking.request_denied',
        defaultMessage: 'Your access request was denied',
        description: 'The user had request access but the request was denied by a product or service'
    },
    retry: {
        id: 'fabric.linking.retry',
        defaultMessage: 'Retry',
        description: 'Allows user to perform an action again'
    },
    save: {
        id: 'fabric.linking.save',
        defaultMessage: 'Save',
        description: 'Just the "save" word'
    },
    sent_on_relative: {
        id: 'fabric.linking.sent_on_relative',
        defaultMessage: 'Sent {context}',
        description: 'Indicated when entity was sent (relative form)'
    },
    sent_on_absolute: {
        id: 'fabric.linking.sent_on_absolute',
        defaultMessage: 'Sent on {context}',
        description: 'Indicated when entity was sent (absolute form)'
    },
    status_change_load_error: {
        id: 'fabric.linking.status_change_load_error',
        defaultMessage: "We couldn\u2019t load the statuses and transitions",
        description: 'Informs the user that the loading of status transitions failed'
    },
    status_change_permission_error: {
        id: 'fabric.linking.status_change_permission_error',
        defaultMessage: "You don\u2019t have permission to transition this issue. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    },
    status_change_update_error: {
        id: 'fabric.linking.status_change_update_error',
        defaultMessage: "We couldn\u2019t update the status",
        description: "Occurs when a user tries to update an issue's status but fails to do so"
    },
    try_again: {
        id: 'fabric.linking.try_again',
        defaultMessage: 'Try again',
        description: 'Allow the user to try an action again'
    },
    try_another_account: {
        id: 'fabric.linking.try_another_account',
        defaultMessage: 'Try another account',
        description: 'Allows the user to try an action again with a different account'
    },
    link_safety_warning_message: {
        id: 'fabric.linking.link_safety_warning_message',
        defaultMessage: 'The link {unsafeLinkText} is taking you to a different site, <a>actual link here</a>',
        description: 'Link safety check warning message'
    },
    unauthorised_account_description: {
        id: 'fabric.linking.unauthorised_account_description',
        defaultMessage: "You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_description_no_provider: {
        id: 'fabric.linking.unauthorised_account_description_no_provider',
        defaultMessage: "You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_name: {
        id: 'fabric.linking.unauthorised_account_name',
        defaultMessage: "We can't display private pages from {context}",
        description: 'Shown when a user does not have access to a link.'
    },
    unauthorised_account_name_no_provider: {
        id: 'fabric.linking.unauthorised_account_name_no_provider',
        defaultMessage: "We can't display private pages",
        description: 'Shown when a user does not have access to a link.'
    },
    unassigned: {
        id: 'fabric.linking.unassigned',
        defaultMessage: 'Unassigned',
        description: 'Shown as a tooltip text for a default unassigned fallback avatar'
    },
    unfollow: {
        id: 'fabric.linking.unfollow',
        defaultMessage: 'Unfollow',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_description: {
        id: 'fabric.linking.unfollow_project_description',
        defaultMessage: 'Unfollow to stop receiving project notifications',
        description: 'Description on what Unfollow does'
    },
    unfollow_project: {
        id: 'fabric.linking.unfollow_project',
        defaultMessage: 'Unfollow project',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_error: {
        id: 'fabric.linking.unfollow_project_error',
        defaultMessage: 'We encountered an error while trying to unfollow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
    },
    unfollow_goal_description: {
        id: 'fabric.linking.unfollow_goal_description',
        defaultMessage: 'Unfollow to stop receiving notifications for this goal',
        description: 'Description on what Unfollow does'
    },
    unfollow_goal: {
        id: 'fabric.linking.unfollow_goal',
        defaultMessage: 'Unfollow goal',
        description: 'Click to unfollow a project.'
    },
    unfollow_goal_error: {
        id: 'fabric.linking.unfollow_goal_error',
        defaultMessage: 'We encountered an error while trying to unfollow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas goal'
    },
    unlink_account: {
        id: 'fabric.linking.unlink_account',
        defaultMessage: 'Unlink Account',
        description: 'Allows to remove a connected account from the user'
    },
    view: {
        id: 'fabric.linking.view',
        defaultMessage: 'View',
        description: 'Go through to a piece of content to view it in its original context.'
    },
    viewIn: {
        id: 'fabric.linking.srclink',
        defaultMessage: 'View in',
        description: 'We have a link in our preview modals to the original document. This text goes before the provider name'
    },
    viewOriginal: {
        id: 'fabric.linking.srclinkunknown',
        defaultMessage: 'View Original',
        description: "We have a link in our preview modals to the original document. This is for when we don't know the provider name"
    },
    default_no_access_title: {
        id: 'fabric.linking.no_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they dont have access to certain content'
    },
    direct_access_title: {
        id: 'fabric.linking.direct_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access_description: {
        id: 'fabric.linking.direct_access_description',
        defaultMessage: 'Your team uses {product} to collaborate and you can start using it right away!',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access: {
        id: 'fabric.linking.direct_access',
        defaultMessage: 'Join now',
        description: 'Allows the user join the product or service immediately'
    },
    request_access_description: {
        id: 'fabric.linking.request_access_description',
        defaultMessage: 'Your team uses {product} to collaborate. Send your admin a request for access.',
        description: 'Informs the user to request access to a product by talking to the website administrator'
    },
    request_access: {
        id: 'fabric.linking.request_access',
        defaultMessage: 'Request access',
        description: 'Allows the user to request access to a product or service'
    },
    request_access_pending_title: {
        id: 'fabric.linking.request_access_pending_title',
        defaultMessage: 'Access to {product} is pending',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_access_pending_description: {
        id: 'fabric.linking.request_access_pending_description',
        defaultMessage: 'Your request to access {hostname} is awaiting admin approval.',
        description: 'Informs the user that their request to view this content is pending website administrator approval'
    },
    request_access_pending: {
        id: 'fabric.linking.request_access_pending',
        defaultMessage: 'Pending approval',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_denied_description: {
        id: 'fabric.linking.request_denied_description',
        defaultMessage: "Your admin didn't approve your request to view {product} pages from {hostname}.",
        description: 'Informs the user that their request to view this content was denied'
    },
    access_exists_description: {
        id: 'fabric.linking.access_exists_description',
        defaultMessage: 'Request access to view this content from {hostname}.',
        description: 'Informs the user to contact the website administrator to request access to a product'
    },
    not_found_description: {
        id: 'fabric.linking.not_found_description',
        defaultMessage: "The page doesn't exist or it may have changed after this link was added.",
        description: 'Error case for when a provided item is not found within the list of items'
    },
    not_found_title: {
        id: 'fabric.linking.not_found_title',
        defaultMessage: "We can't show you this {product} page",
        description: 'Error case for when a provided link is not found'
    },
    forbidden_title: {
        id: 'fabric.linking.forbidden_title',
        defaultMessage: "You don't have access to this content",
        description: 'Informs the user that they do not have access to the linked content.'
    },
    forbidden_description: {
        id: 'fabric.linking.forbidden_description',
        defaultMessage: 'Contact your admin to request access to {hostname}.',
        description: 'Informs the user that they must contact the site administrator for access.'
    },
    related: {
        id: 'fabric.linking.related',
        defaultMessage: 'Related',
        description: 'Informs the user about related resources'
    },
    generic_error_message: {
        id: 'fabric.linking.generic_error_message',
        defaultMessage: 'An error occurred',
        description: 'A generic error message to the user'
    },
    related_links_modal_title: {
        id: 'fabric.linking.related_links_modal_title',
        defaultMessage: 'Recent links',
        description: 'Shown as the title for the related links modal'
    },
    related_links_modal_title_v2: {
        id: 'fabric.linking.related_links_modal_title_v2',
        defaultMessage: 'Related links',
        description: 'Shown as the title for the related links modal'
    },
    related_links_view_related_urls: {
        id: 'fabric.linking.related_links_view_related_urls',
        defaultMessage: 'View recent links',
        description: 'Action to view related links to the given resource'
    },
    related_links_view_related_links: {
        id: 'fabric.linking.related_links_view_related_links',
        defaultMessage: 'View related links',
        description: 'Action to view related links to the given resource'
    },
    related_links_found_in: {
        id: 'fabric.linking.related_links_found_in',
        defaultMessage: 'Found In',
        description: 'Informs the user of the resources are found in the given url'
    },
    related_links_found_in_v2: {
        id: 'fabric.linking.related_links_found_in_v2',
        defaultMessage: 'Found in',
        description: 'Informs the user of the resources are found in the given url'
    },
    related_links_not_found: {
        id: 'fabric.linking.related_links_not_found',
        defaultMessage: "We didn't find any links to show here.",
        description: 'Informs the user that there are no related resources for the given url'
    },
    related_links_includes_links_to: {
        id: 'fabric.linking.related_links_includes_links_to',
        defaultMessage: 'Includes Links To',
        description: 'Informs the user of the resources the url links to'
    },
    related_links_includes_links_to_v2: {
        id: 'fabric.linking.related_links_includes_links_to_v2',
        defaultMessage: 'Includes links to',
        description: 'Informs the user of the resources the url links to'
    },
    related_links_modal_error_header: {
        id: 'fabric.linking.related_links_modal_error_header',
        defaultMessage: 'Something went wrong',
        description: 'Title for related links error'
    },
    related_links_modal_error_title: {
        id: 'fabric.linking.related_links_modal_error_title',
        defaultMessage: `We're having trouble loading related links`,
        description: 'Title for related links error'
    },
    related_links_modal_unavailable_title: {
        id: 'fabric.linking.related_links_modal_unavailable_title',
        defaultMessage: `We couldn't find any related links`,
        description: 'Title for related links error'
    },
    related_links_modal_error_message: {
        id: 'fabric.linking.related_links_modal_error_message',
        defaultMessage: 'We ran into an issue trying to load recent links. Check your connection or refresh to try again.',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_error_description: {
        id: 'fabric.linking.related_links_modal_error_description',
        defaultMessage: 'Check your connection or refresh the page to try again',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_unavailable_description: {
        id: 'fabric.linking.related_links_modal_unavailable_description',
        defaultMessage: 'We continuously review and add related links for updated pages or other content types',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_unavailable_header: {
        id: 'fabric.linking.related_links_modal_unavailable_header',
        defaultMessage: 'No recent links',
        description: 'Title for related links being unavailable'
    },
    related_links_modal_unavailable_message: {
        id: 'fabric.linking.related_links_modal_unavailable_message',
        defaultMessage: "We didn't find any links to show here. We continuously review and add recent links for updated pages or other content types.",
        description: 'Informs the user that related links were not found but may be available in the future'
    },
    join_to_viewIssueTermRefresh: {
        id: 'fabric.linking.join_to_view-issue-term-refresh',
        defaultMessage: 'Join {context} to view this work item',
        description: 'Allows the user join the product or service immediately'
    },
    open_issue_in_jiraIssueTermRefresh: {
        id: 'fabric.linking.open_issue_in_jira-issue-term-refresh',
        defaultMessage: 'Open work item in Jira',
        description: 'Click to open link in Jira'
    },
    request_access_to_viewIssueTermRefresh: {
        id: 'fabric.linking.request_access_to_view-issue-term-refresh',
        defaultMessage: 'Request access to {context} to view this work item',
        description: 'Allows the user to request access to a product or service'
    },
    status_change_permission_errorIssueTermRefresh: {
        id: 'fabric.linking.status_change_permission_error-issue-term-refresh',
        defaultMessage: "You don\u2019t have permission to transition this work item. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    }
});

});


parcelRegister("cI2hq", function(module, exports) {

$parcel$export(module.exports, "useLinkWarningModal", () => $afd5dc953340b04b$export$32b76c003683c2ec);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $57Lhk = parcelRequire("57Lhk");

var $VSDnB = parcelRequire("VSDnB");

var $fzJZi = parcelRequire("fzJZi");
const $afd5dc953340b04b$var$toUrl = (url, base)=>{
    try {
        return new URL(url, base);
    } catch  {
        return undefined;
    }
};
const $afd5dc953340b04b$export$32b76c003683c2ec = ()=>{
    const [unsafeLinkText, setUnsafeLinkText] = (0, $5uXOq.useState)(null);
    const [url, setUrl] = (0, $5uXOq.useState)(null);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const sendWarningModalViewedEvent = ()=>{
        createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'linkSafetyWarningModal',
            eventType: 'screen',
            name: 'linkSafetyWarningModal'
        }).fire((0, $fzJZi.ANALYTICS_CHANNEL));
    };
    const sendContinueClickedEvent = ()=>{
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'linkSafetyWarningModalContinue',
            eventType: 'ui',
            screen: 'linkSafetyWarningModal'
        }).fire((0, $fzJZi.ANALYTICS_CHANNEL));
    };
    /**
	 * It checks and warns if a link text is a URL and different from an actual link destination
	 */ const isLinkSafe = (event, href)=>{
        if (!href) return true;
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        const normalisedUrlFromLinkText = (0, $57Lhk.normalizeUrl)(linkText);
        if (!normalisedUrlFromLinkText) return true;
        const anchorLinkRegex = new RegExp(/^#/im);
        const isLinkTextAnchorLink = anchorLinkRegex.test(linkText);
        const isAnchorLink = anchorLinkRegex.test(href);
        if (isAnchorLink || isLinkTextAnchorLink) return true;
        const relativeLinkRegex = new RegExp(/^\//im);
        const isRelativeHrefLink = relativeLinkRegex.test(href);
        if (isRelativeHrefLink) return true;
        const hrefUrl = $afd5dc953340b04b$var$toUrl(href, window.location.origin);
        const linkTextUrl = $afd5dc953340b04b$var$toUrl(normalisedUrlFromLinkText, hrefUrl?.origin);
        if (!hrefUrl || !linkTextUrl) return true;
        if ((0, $VSDnB.fg)('do-not-show-link-mismatch-warning-for-same-origin')) {
            const currentAtlassianProductOrigin = window.location.origin;
            const isSafeToIgnoreNonOriginDifferences = hrefUrl?.origin === currentAtlassianProductOrigin && linkTextUrl?.origin === currentAtlassianProductOrigin;
            if (isSafeToIgnoreNonOriginDifferences) return true;
        }
        const httpProtocols = [
            'http:',
            'https:'
        ];
        let areProtocolsEquivalent;
        if (httpProtocols.includes(linkTextUrl.protocol) && httpProtocols.includes(hrefUrl.protocol)) {
            const noUserNameAndPassword = !linkTextUrl.username && !linkTextUrl.password && !hrefUrl.username && !hrefUrl.password;
            areProtocolsEquivalent = noUserNameAndPassword;
        } else areProtocolsEquivalent = linkTextUrl.protocol === hrefUrl.protocol;
        const areEquivalentLinks = linkTextUrl.hostname === hrefUrl.hostname && linkTextUrl.pathname === hrefUrl.pathname && linkTextUrl.search === hrefUrl.search && linkTextUrl.username === hrefUrl.username && linkTextUrl.password === hrefUrl.password && areProtocolsEquivalent;
        if (!areEquivalentLinks) return false;
        return true;
    };
    const showSafetyWarningModal = (event, href)=>{
        event.preventDefault();
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        setUnsafeLinkText(linkText);
        href && setUrl(href);
        setIsOpen(true);
        sendWarningModalViewedEvent();
    };
    const onClose = ()=>{
        setIsOpen(false);
        setUnsafeLinkText(null);
        setUrl(null);
    };
    const onContinue = ()=>{
        onClose();
        sendContinueClickedEvent();
        url && window.open(url, '_blank', 'noopener noreferrer');
    };
    return {
        isLinkSafe: isLinkSafe,
        isOpen: isOpen,
        onClose: onClose,
        onContinue: onContinue,
        showSafetyWarningModal: showSafetyWarningModal,
        unsafeLinkText: unsafeLinkText,
        url: url
    };
};

});
parcelRegister("57Lhk", function(module, exports) {

$parcel$export(module.exports, "isSafeUrl", () => $8f5c48f3a9939b0b$export$c9f92f5469372e0f);
$parcel$export(module.exports, "normalizeUrl", () => $8f5c48f3a9939b0b$export$6535eb414fa2c8b6);
/**
 * This file has been partially duplicated in packages/editor/adf-schema/src/utils/url.ts
 * Any changes made here should be mirrored there until the duplicate behaviour is resolved
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $e2gHg = parcelRequire("e2gHg");
const $8f5c48f3a9939b0b$var$linkify = (0, (/*@__PURE__*/$parcel$interopDefault($e2gHg)))();
$8f5c48f3a9939b0b$var$linkify.add('sourcetree:', 'http:');
$8f5c48f3a9939b0b$var$linkify.add('jamfselfservice:', 'http:');
$8f5c48f3a9939b0b$var$linkify.add('notes:', 'http:');
const $8f5c48f3a9939b0b$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $8f5c48f3a9939b0b$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$8f5c48f3a9939b0b$var$tlds.push($8f5c48f3a9939b0b$var$tlds2Char);
$8f5c48f3a9939b0b$var$linkify.tlds($8f5c48f3a9939b0b$var$tlds, false);
const $8f5c48f3a9939b0b$var$whitelistedURLPatterns = [
    /^https?:\/\/[^\s]*$/im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\/[^\s]*$/im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:[^\s]*$/im,
    /^facetime:[^\s]*$/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    /^sourcetree:/im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^foo:/im,
    /^#/im
];
const $8f5c48f3a9939b0b$var$normaliseLinkHref = (url)=>{
    const match = $8f5c48f3a9939b0b$var$getLinkMatch(url);
    return match && match.url || null;
};
const $8f5c48f3a9939b0b$var$getLinkMatch = (str)=>{
    if (!str) return null;
    let match = $8f5c48f3a9939b0b$var$linkifyMatch(str);
    if (!match.length) match = $8f5c48f3a9939b0b$var$linkify.match(str);
    return match && match.length > 0 && match[0].index === 0 && match[0].lastIndex === str.trim().length ? match[0] : null;
};
const $8f5c48f3a9939b0b$var$LINK_REGEXP = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
const $8f5c48f3a9939b0b$var$linkifyMatch = (text)=>{
    const matches = [];
    if (!$8f5c48f3a9939b0b$var$LINK_REGEXP.test(text)) return matches;
    let startpos = 0;
    let substr;
    while(substr = text.substr(startpos)){
        const link = (substr.match($8f5c48f3a9939b0b$var$LINK_REGEXP) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($8f5c48f3a9939b0b$var$LINK_REGEXP);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
const $8f5c48f3a9939b0b$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url.trim();
    return $8f5c48f3a9939b0b$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
function $8f5c48f3a9939b0b$export$6535eb414fa2c8b6(url) {
    if (!url) return '';
    const urlWithoutNewlines = url.replace(/[\r\n]+/g, '');
    if ($8f5c48f3a9939b0b$export$c9f92f5469372e0f(urlWithoutNewlines)) return urlWithoutNewlines.trim();
    return $8f5c48f3a9939b0b$var$normaliseLinkHref(urlWithoutNewlines);
}

});
parcelRegister("e2gHg", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $a37e3434b26d3f31$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $a37e3434b26d3f31$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $a37e3434b26d3f31$var$isString(obj) {
    return $a37e3434b26d3f31$var$_class(obj) === '[object String]';
}
function $a37e3434b26d3f31$var$isObject(obj) {
    return $a37e3434b26d3f31$var$_class(obj) === '[object Object]';
}
function $a37e3434b26d3f31$var$isRegExp(obj) {
    return $a37e3434b26d3f31$var$_class(obj) === '[object RegExp]';
}
function $a37e3434b26d3f31$var$isFunction(obj) {
    return $a37e3434b26d3f31$var$_class(obj) === '[object Function]';
}
function $a37e3434b26d3f31$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $a37e3434b26d3f31$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $a37e3434b26d3f31$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $a37e3434b26d3f31$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $a37e3434b26d3f31$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $a37e3434b26d3f31$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $a37e3434b26d3f31$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $a37e3434b26d3f31$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $a37e3434b26d3f31$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $a37e3434b26d3f31$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $a37e3434b26d3f31$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("d5qnw"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($a37e3434b26d3f31$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($a37e3434b26d3f31$var$isObject(val)) {
            if ($a37e3434b26d3f31$var$isRegExp(val.validate)) compiled.validate = $a37e3434b26d3f31$var$createValidator(val.validate);
            else if ($a37e3434b26d3f31$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($a37e3434b26d3f31$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $a37e3434b26d3f31$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($a37e3434b26d3f31$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $a37e3434b26d3f31$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($a37e3434b26d3f31$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $a37e3434b26d3f31$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $a37e3434b26d3f31$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $a37e3434b26d3f31$var$createMatch(self, shift) {
    var match = new $a37e3434b26d3f31$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $a37e3434b26d3f31$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $a37e3434b26d3f31$var$LinkifyIt)) return new $a37e3434b26d3f31$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($a37e3434b26d3f31$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $a37e3434b26d3f31$var$assign({}, $a37e3434b26d3f31$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $a37e3434b26d3f31$var$assign({}, $a37e3434b26d3f31$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $a37e3434b26d3f31$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $a37e3434b26d3f31$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $a37e3434b26d3f31$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $a37e3434b26d3f31$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($a37e3434b26d3f31$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($a37e3434b26d3f31$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $a37e3434b26d3f31$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $a37e3434b26d3f31$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $a37e3434b26d3f31$var$LinkifyIt;

});
parcelRegister("d5qnw", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("b9ep3")).source;
    re.src_Cc = (parcelRequire("23ErL")).source;
    re.src_Z = (parcelRequire("oRY4m")).source;
    re.src_P = (parcelRequire("9bBmm")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,}[a-zA-Z0-9%/&]|' + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + ',(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    ';(?!' + re.src_ZCc + ').|' + // allow `;` if not followed by space-like char
    '\\!+(?!' + re.src_ZCc + '|[!]).|' + // allow `!!!` in paths, but not at the end
    '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});






parcelRegister("f14yv", function(module, exports) {

$parcel$export(module.exports, "default", () => $e31acef3336a9ea7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $e31acef3336a9ea7$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props.dataAttributes,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            textDecoration: 'line-through'
        },
        children: props.children
    });
}

});

parcelRegister("eVxaj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3356ea5acdd73a43$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $3356ea5acdd73a43$export$2e2bcd8739ae039(props) {
    // ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, $2OMIu.jsx)("strong", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("gUlHA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c264e87eca3a3d05$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $c264e87eca3a3d05$var$isSub = (type)=>{
    return type === 'sub';
};
function $c264e87eca3a3d05$export$2e2bcd8739ae039(props) {
    if ($c264e87eca3a3d05$var$isSub(props.type)) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)("sub", {
        ...props.dataAttributes,
        children: props.children
    });
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)("sup", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("c15YI", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8904856eee164f6$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $87j2U = parcelRequire("87j2U");

var $lKA8N = parcelRequire("lKA8N");

var $hxoiH = parcelRequire("hxoiH");
function $c8904856eee164f6$export$2e2bcd8739ae039(props) {
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    // Note -- while there is no way to create custom colors using default tooling
    // the editor does supported ad hoc color values -- and there may be content
    // which has been migrated or created via apis which use such values.
    let paletteColorValue;
    /**
   * The Editor persists custom text colors when content has been migrated from the old editor, or created via
   * apis.
   *
   * This behaviour predates the introduction of dark mode.
   *
   * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
   *
   * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
   *
   * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
   * how we detect text colors copied from external editor sources. Where we load the background color from a
   * seperate attribute (data-text-custom-color), instead of the inline style.
   *
   * See the following document for more details on this behaviour
   * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
   */ const tokenColor = (0, $lKA8N.hexToEditorTextPaletteColor)(props.color);
    if (tokenColor) paletteColorValue = (0, $lKA8N.hexToEditorTextPaletteColor)(props.color) || props.color;
    else if (colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
    paletteColorValue = (0, $87j2U.getDarkModeLCHColor)(props.color);
    else // if we are in light mode, we can just set the color
    paletteColorValue = props.color;
    const style = (0, $5uXOq.useMemo)(()=>({
            ['--custom-palette-color']: paletteColorValue
        }), [
        paletteColorValue
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props.dataAttributes,
        "data-text-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-text-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: props.children
    });
}

});
parcelRegister("lKA8N", function(module, exports) {

$parcel$export(module.exports, "hexToEditorTextPaletteColor", () => $965e3166a7c18c5e$export$9c2f408d391feb93);
// This import will be stripped on build
/**
 * This takes an adf hex color and returns a matching text palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToTextPaletteColor('#0747A6');
 * //     ^? const cssValue: string
 * <span style={{textColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $965e3166a7c18c5e$export$9c2f408d391feb93(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    return $965e3166a7c18c5e$export$57fa5089caad992[hexColor.toUpperCase()];
}
const $965e3166a7c18c5e$export$57fa5089caad992 = {
    // blue
    /** blue - light */ ['#B3D4FF']: "var(--ds-background-accent-blue-subtler, #B3D4FF)",
    // source for hex code was legacy token B75
    /** blue - medium */ ['#4C9AFF']: "var(--ds-icon-accent-blue, #4C9AFF)",
    // source for hex code was legacy token B100
    /** blue - strong */ ['#0747A6']: "var(--ds-text-accent-blue, #0747A6)",
    // source for hex code was legacy token B500
    // teal
    /** teal - light */ ['#B3F5FF']: "var(--ds-background-accent-teal-subtler, #B3F5FF)",
    // source for hex code was legacy token T75
    /** teal - medium */ ['#00B8D9']: "var(--ds-icon-accent-teal, #00B8D9)",
    // source for hex code was legacy token T300
    /** teal - strong */ ['#008DA6']: "var(--ds-text-accent-teal, #008DA6)",
    // source for hex code was legacy token T500
    // green
    /** green - light */ ['#ABF5D1']: "var(--ds-background-accent-green-subtler, #ABF5D1)",
    // source for hex code was legacy token G75
    /** green - medium */ ['#36B37E']: "var(--ds-icon-accent-green, #36B37E)",
    // source for hex code was legacy token G300
    /** green - strong */ ['#006644']: "var(--ds-text-accent-green, #006644)",
    // source for hex code was legacy token G500
    // yellowOrange
    /** yellowOrange - light */ ['#FFF0B3']: "var(--ds-background-accent-yellow-subtler, #FFF0B3)",
    // source for hex code was legacy token Y75
    /** yellowOrange - medium */ ['#FFC400']: "var(--ds-background-accent-orange-subtle, #FFC400)",
    // source for hex code was legacy token Y200
    /** yellowOrange - strong */ ['#FF991F']: "var(--ds-icon-accent-orange, #FF991F)",
    // source for hex code was legacy token Y400
    // red
    /** red - light */ ['#FFBDAD']: "var(--ds-background-accent-red-subtler, #FFBDAD)",
    // source for hex code was legacy token R75
    /** red - medium */ ['#FF5630']: "var(--ds-icon-accent-red, #FF5630)",
    // source for hex code was legacy token R300
    /** red - strong */ ['#BF2600']: "var(--ds-text-accent-red, #BF2600)",
    // source for hex code was legacy token R500
    // purple
    /** purple - light */ ['#EAE6FF']: "var(--ds-background-accent-purple-subtler, #EAE6FF)",
    // source for hex code was legacy token P50
    /** purple - medium */ ['#6554C0']: "var(--ds-icon-accent-purple, #6554C0)",
    // source for hex code was legacy token P300
    /** purple - strong */ ['#403294']: "var(--ds-text-accent-purple, #403294)",
    // source for hex code was legacy token P500
    // whiteGray
    /** whiteGray - light */ ['#FFFFFF']: "var(--ds-text-inverse, #FFFFFF)",
    // source for hex code was legacy token N0
    /** whiteGray - medium */ ['#97A0AF']: "var(--ds-icon-accent-gray, #97A0AF)",
    // source for hex code was legacy token N80
    /** whiteGray - strong */ ['#172B4D']: "var(--ds-text, #172B4D)" // source for hex code was legacy token N800
};

});


parcelRegister("koUAb", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d139f843714a421$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $87j2U = parcelRequire("87j2U");

var $7dikW = parcelRequire("7dikW");

var $hxoiH = parcelRequire("hxoiH");
function $7d139f843714a421$export$2e2bcd8739ae039(props) {
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    let paletteColorValue;
    /**
   * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
   *
   * This behaviour predates the introduction of dark mode.
   *
   * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
   *
   * This introduces inversion of the presentation of the custom text background colors when the user is in dark mode.
   *
   * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
   * how we detect text background colors copied from external editor sources. Where we load the background color from a
   * separate attribute (data-background-custom-color), instead of the inline style.
   *
   * See the following document for more details on this behaviour
   * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
   */ const tokenColor = (0, $7dikW.hexToEditorTextBackgroundPaletteColor)(props.color);
    if (tokenColor) paletteColorValue = tokenColor;
    else if (colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
    paletteColorValue = (0, $87j2U.getDarkModeLCHColor)(props.color);
    else // if we are in light mode, we can just set the color
    paletteColorValue = props.color;
    const style = (0, $5uXOq.useMemo)(()=>({
            ['--custom-palette-color']: paletteColorValue
        }), [
        paletteColorValue
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props.dataAttributes,
        "data-background-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-background-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: props.children
    });
}

});
parcelRegister("7dikW", function(module, exports) {

$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", () => $b5a4f7ad3e4ae03c$export$8b58ff1b36bb75e0);

var $gmhCD = parcelRequire("gmhCD");
const $b5a4f7ad3e4ae03c$export$12a518ff137dd389 = {
    /** Gray - light */ ['#DCDFE4']: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
    /** Teal - light */ ['#C6EDFB']: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    /** Lime - light */ ['#D3F1A7']: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    /** Orange - light */ ['#FEDEC8']: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
    /** Magenta - light */ ['#FDD0EC']: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    /** Purple - light */ ['#DFD8FD']: "var(--ds-background-accent-purple-subtler, #DFD8FD)"
};
function $b5a4f7ad3e4ae03c$export$8b58ff1b36bb75e0(hexColor) {
    if ((0, $gmhCD.editorExperiment)('editor_text_highlight_orange_to_yellow', 'test', {
        exposure: true
    })) // @ts-expect-error Expect type error. Will modify production type
    // if experiment proceeds post-results.
    $b5a4f7ad3e4ae03c$export$12a518ff137dd389['#FEDEC8'] = "var(--ds-background-accent-yellow-subtler, #F8E6A0)";
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    // @ts-ignore
    return $b5a4f7ad3e4ae03c$export$12a518ff137dd389[hexColor.toUpperCase()];
}

});


parcelRegister("eESZY", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f8016b636a69d58$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $6f8016b636a69d58$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)("u", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("95Yll", function(module, exports) {

$parcel$export(module.exports, "default", () => $56f1f5242a99941b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $4ceoy = parcelRequire("4ceoy");

var $eOOFp = parcelRequire("eOOFp");

var $iHYdz = parcelRequire("iHYdz");

var $gmhCD = parcelRequire("gmhCD");
const $56f1f5242a99941b$var$wrapperStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `${(0, $iHYdz.blockNodesVerticalMargin)} 0`,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    marginLeft: '50%',
    transform: 'translateX(-50%)'
});
function $56f1f5242a99941b$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4ceoy.WidthConsumer), null, ({ width: width })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $56f1f5242a99941b$var$wrapperStyles,
            "data-mode": props.mode,
            ...(0, $gmhCD.editorExperiment)('advanced_layouts', true) && {
                'data-has-width': !!props.width,
                'data-width': props.width
            },
            style: {
                width: (0, $gmhCD.editorExperiment)('advanced_layouts', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $eOOFp.calcBreakoutWithCustomWidth)(props.mode, 'width' in props ? props.width : null, width) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $eOOFp.calcBreakoutWidth)(props.mode, width)
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "fabric-editor-breakout-mark fabric-editor-block-mark"
        }, props.children));
}

});

parcelRegister("lbdLJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1b7090399d1e727$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $aeGrH = parcelRequire("aeGrH");
const $d1b7090399d1e727$var$MarkWrapper = (props)=>{
    const dataAlign = props['data-align'] ? (0, $aeGrH.alignmentPositionMap)[props['data-align']] : undefined;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        style: {
            textAlign: dataAlign
        },
        ...props
    }, props.children);
};
function $d1b7090399d1e727$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($d1b7090399d1e727$var$MarkWrapper, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-alignment",
        "data-align": props.align
    }, props.children);
}

});

parcelRegister("9xZ5X", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ef073b46e3c6008$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $3ef073b46e3c6008$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-indentation-mark",
        "data-level": props.level,
        children: props.children
    });
}

});

parcelRegister("g5EjF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1398622ac205fad$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $b1398622ac205fad$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("acz8Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $04eeed03d14d0e78$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $04eeed03d14d0e78$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("8DQfy", function(module, exports) {

$parcel$export(module.exports, "default", () => $009dff5e97619965$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $009dff5e97619965$export$2e2bcd8739ae039(props) {
    const WrapperElement = props.isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, $2OMIu.jsx)(WrapperElement, {
        "data-source": props.sources ? JSON.stringify(props.sources) : undefined,
        "data-mark-type": "dataConsumer",
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("g9yqu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ac6eff929f5b91e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $8ac6eff929f5b91e$export$2e2bcd8739ae039(props) {
    const WrapperElement = props.isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, $2OMIu.jsx)(WrapperElement, {
        "data-localId": props.localId,
        "data-name": props.name,
        "data-mark-type": "fragment",
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("itF0z", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f200b42408cc462$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
function $7f200b42408cc462$export$2e2bcd8739ae039(props) {
    const borderColor = props.color ?? '';
    const borderSize = props.size ?? 0;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        "data-color": borderColor,
        "data-size": borderSize,
        "data-mark-type": "border"
    }, props.children);
}

});

parcelRegister("6EeUE", function(module, exports) {

$parcel$export(module.exports, "default", () => $efbb661461ca3406$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
class $efbb661461ca3406$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    render() {
        const { reference: reference, children: children } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            "data-mark-type": "confluenceInlineComment",
            "data-reference": reference,
            children: children
        });
    }
}

});


parcelRegister("eQNWQ", function(module, exports) {

$parcel$export(module.exports, "getMarksByOrder", () => $7bbfc2d34b0938dd$export$99a33ed044c278ae);
$parcel$export(module.exports, "isSameMark", () => $7bbfc2d34b0938dd$export$b1304404bdc42b7a);
$parcel$export(module.exports, "getValidDocument", () => $7bbfc2d34b0938dd$export$fb80336a7e408cb3);
$parcel$export(module.exports, "getValidNode", () => $7bbfc2d34b0938dd$export$81b20b6c83a56bd);

var $9IGaJ = parcelRequire("9IGaJ");
var $kc0v7 = parcelRequire("kc0v7");
var $iZOJ9 = parcelRequire("iZOJ9");
var $bFtEE = parcelRequire("bFtEE");

var $kOFhM = parcelRequire("kOFhM");

var $VSDnB = parcelRequire("VSDnB");
const $7bbfc2d34b0938dd$export$3b94ef2190b2d585 = {
    FINAL: 'final',
    STAGE_0: 'stage0'
};
const $7bbfc2d34b0938dd$export$62d5811a2955c1d8 = [
    'fragment',
    'link',
    'em',
    'strong',
    'textColor',
    'backgroundColor',
    'strike',
    'subsup',
    'underline',
    'code',
    'confluenceInlineComment',
    'annotation',
    'dataConsumer'
];
const $7bbfc2d34b0938dd$export$30f8aa4cc1f8c1cb = (type)=>{
    return type === 'sub' || type === 'sup';
};
const $7bbfc2d34b0938dd$export$99a33ed044c278ae = (marks)=>{
    return [
        ...marks
    ].sort((a, b)=>$7bbfc2d34b0938dd$export$62d5811a2955c1d8.indexOf(a.type.name) - $7bbfc2d34b0938dd$export$62d5811a2955c1d8.indexOf(b.type.name));
};
const $7bbfc2d34b0938dd$export$b1304404bdc42b7a = (mark, otherMark)=>{
    if (!mark || !otherMark) return false;
    return mark.eq(otherMark);
};
const $7bbfc2d34b0938dd$export$fb80336a7e408cb3 = (doc, schema = (0, $kOFhM.defaultSchema), adfStage = 'final')=>{
    const node = $7bbfc2d34b0938dd$export$81b20b6c83a56bd(doc, schema, adfStage);
    if (node.type === 'doc') {
        node.content = $7bbfc2d34b0938dd$var$wrapInlineNodes(node.content);
        return node;
    }
    return null;
};
const $7bbfc2d34b0938dd$var$wrapInlineNodes = (nodes = [])=>{
    return nodes.map((node)=>(0, $kc0v7.inlineNodes).has(node.type) ? {
            type: 'paragraph',
            content: [
                node
            ]
        } : node);
};
const $7bbfc2d34b0938dd$export$fafd4f799ee68da0 = (content, schema = (0, $kOFhM.defaultSchema), adfStage = 'final')=>{
    return content.map((node)=>$7bbfc2d34b0938dd$export$81b20b6c83a56bd(node, schema, adfStage));
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7bbfc2d34b0938dd$var$TEXT_COLOR_PATTERN = /^#[0-9a-fA-F]{6}$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7bbfc2d34b0938dd$var$RELATIVE_LINK = /^\//;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7bbfc2d34b0938dd$var$ANCHOR_LINK = /^#/;
const $7bbfc2d34b0938dd$var$flattenUnknownBlockTree = (node, schema = (0, $kOFhM.defaultSchema), adfStage = 'final')=>{
    const output = [];
    let isPrevLeafNode = false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    for(let i = 0; i < node.content.length; i++){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const childNode = node.content[i];
        const isLeafNode = !(childNode.content && childNode.content.length);
        if (i > 0) {
            if (isPrevLeafNode) output.push({
                type: 'text',
                text: ' '
            });
            else output.push({
                type: 'hardBreak'
            });
        }
        if (isLeafNode) output.push($7bbfc2d34b0938dd$export$81b20b6c83a56bd(childNode, schema, adfStage));
        else output.push(...$7bbfc2d34b0938dd$var$flattenUnknownBlockTree(childNode, schema, adfStage));
        isPrevLeafNode = isLeafNode;
    }
    return output;
};
const $7bbfc2d34b0938dd$export$b9908ef75cad1e0e = (node)=>{
    const { attrs: attrs = {}, content: content, text: text, type: type } = node;
    if (!content || !content.length) {
        const unknownInlineNode = {
            type: 'text',
            text: text || attrs.text || `[${type}]`
        };
        const { textUrl: textUrl } = attrs;
        if (textUrl && (0, $iZOJ9.isSafeUrl)(textUrl)) unknownInlineNode.marks = [
            {
                type: 'link',
                attrs: {
                    href: textUrl
                }
            }
        ];
        return unknownInlineNode;
    }
    /*
	 * Find leaf nodes and join them. If leaf nodes' parent node is the same node
	 * join with a blank space, otherwise they are children of different branches, i.e.
	 * we need to join them with a hardBreak node
	 */ return {
        type: 'unknownBlock',
        content: $7bbfc2d34b0938dd$var$flattenUnknownBlockTree(node)
    };
};
const $7bbfc2d34b0938dd$var$getValidMarks = (marks, adfStage = 'final')=>{
    if (marks && marks.length > 0) return marks.reduce((acc, mark)=>{
        const validMark = $7bbfc2d34b0938dd$export$87c6d4a6ebb7d9e9(mark, adfStage);
        if (validMark) acc.push(validMark);
        return acc;
    }, []);
    return marks;
};
const $7bbfc2d34b0938dd$export$81b20b6c83a56bd = (originalNode, schema = (0, $kOFhM.defaultSchema), adfStage = 'final')=>{
    const { attrs: attrs, marks: marks, text: text, type: type } = originalNode;
    let { content: content } = originalNode;
    const node = {
        attrs: attrs,
        marks: marks,
        text: text,
        type: type
    };
    if (content) node.content = content = $7bbfc2d34b0938dd$export$fafd4f799ee68da0(content, schema, adfStage);
    // If node type doesn't exist in schema, make it an unknown node
    if (!schema.nodes[type]) return $7bbfc2d34b0938dd$export$b9908ef75cad1e0e(node);
    if (type) switch(type){
        case 'doc':
            {
                const { version: version } = originalNode;
                if (version && content && content.length) return {
                    type: type,
                    content: content
                };
                break;
            }
        case 'codeBlock':
            if (content) content = content.reduce((acc, val)=>{
                if (val.type === 'text') acc.push({
                    type: val.type,
                    text: val.text
                });
                return acc;
            }, []);
            if (attrs && attrs.language) return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
            return {
                type: type,
                content: content,
                marks: marks
            };
        case 'date':
            if (attrs && attrs.timestamp) return {
                type: type,
                attrs: attrs,
                ...(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'status':
            if (attrs && attrs.text && attrs.color) return {
                type: type,
                attrs: attrs,
                ...(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'emoji':
            if (attrs && attrs.shortName) return {
                type: type,
                attrs: attrs,
                ...(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'inlineExtension':
        case 'extension':
            if (attrs && attrs.extensionType && attrs.extensionKey) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'inlineCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $iZOJ9.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $iZOJ9.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs,
                ...(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'blockCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $iZOJ9.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $iZOJ9.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'embedCard':
            if (attrs && (attrs.url && (0, $iZOJ9.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $iZOJ9.isSafeUrl)(attrs.data.url)) && attrs.layout) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'bodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'multiBodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'extensionFrame':
            if (content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'hardBreak':
            return {
                type: type
            };
        case 'caption':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'mediaInline':
            {
                let mediaId = '';
                let mediaCollection = [];
                if (attrs) {
                    const { id: id, collection: collection } = attrs;
                    mediaId = id;
                    mediaCollection = collection;
                }
                if (mediaId && mediaCollection) return {
                    type: type,
                    attrs: attrs,
                    marks: marks
                };
                break;
            }
        case 'media':
            {
                let mediaId = '';
                let mediaType = '';
                let mediaCollection = [];
                let mediaUrl = '';
                if (attrs) {
                    const { id: id, collection: collection, type: type, url: url } = attrs;
                    mediaId = id;
                    mediaType = type;
                    mediaCollection = collection;
                    mediaUrl = url;
                }
                if (mediaType === 'external' && !!mediaUrl) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const mediaAttrs = {
                        type: mediaType,
                        url: mediaUrl,
                        width: attrs.width,
                        height: attrs.height
                    };
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $7bbfc2d34b0938dd$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                } else if (mediaId && mediaType) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const mediaAttrs = {
                        type: mediaType,
                        id: mediaId,
                        collection: mediaCollection
                    };
                    if (attrs.width) mediaAttrs.width = attrs.width;
                    if (attrs.height) mediaAttrs.height = attrs.height;
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $7bbfc2d34b0938dd$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                }
                break;
            }
        case 'mediaGroup':
            if (Array.isArray(content) && !content.some((e)=>e.type !== 'media')) return {
                type: type,
                content: content
            };
            break;
        case 'mediaSingle':
            {
                const containsJustMedia = Array.isArray(content) && content.length === 1 && content[0].type === 'media';
                const containsMediaAndCaption = Array.isArray(content) && content.length === 2 && content[0].type === 'media' && content[1].type === 'caption';
                if (containsJustMedia || containsMediaAndCaption) return {
                    type: type,
                    attrs: attrs,
                    content: content,
                    marks: $7bbfc2d34b0938dd$var$getValidMarks(marks, adfStage)
                };
                break;
            }
        case 'mention':
            {
                let mentionText = '';
                let mentionId;
                let mentionAccess;
                if (attrs) {
                    const { text: text, displayName: displayName, id: id, accessLevel: accessLevel } = attrs;
                    mentionText = text || displayName;
                    mentionId = id;
                    mentionAccess = accessLevel;
                }
                if (!mentionText) mentionText = text || '@unknown';
                if (mentionText && mentionId) {
                    const mentionNode = {
                        type: type,
                        attrs: {
                            id: mentionId,
                            text: mentionText,
                            accessLevel: ''
                        },
                        ...(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? {
                            marks: marks
                        } : {}
                    };
                    if (mentionAccess) mentionNode.attrs.accessLevel = mentionAccess;
                    return mentionNode;
                }
                break;
            }
        case 'paragraph':
            if (adfStage === 'stage0') {
                const paragraphNode = {
                    type: type,
                    content: content || []
                };
                if (attrs && attrs.localId) paragraphNode.attrs = {
                    localId: attrs.localId
                };
                if (marks) paragraphNode.marks = [
                    ...marks
                ];
                return paragraphNode;
            }
            return marks ? {
                type: type,
                content: content || [],
                marks: marks
            } : {
                type: type,
                content: content || []
            };
        case 'rule':
            return {
                type: type
            };
        case 'text':
            {
                const { marks: marks } = node;
                if (text) return marks ? {
                    type: type,
                    text: text,
                    marks: $7bbfc2d34b0938dd$var$getValidMarks(marks, adfStage)
                } : {
                    type: type,
                    text: text
                };
                break;
            }
        case 'heading':
            if (attrs) {
                const { level: level } = attrs;
                const between = (x, a, b)=>x >= a && x <= b;
                if (level && between(level, 1, 6)) {
                    if (adfStage === 'stage0') {
                        const headingNode = {
                            type: type,
                            content: content,
                            attrs: {
                                level: level
                            }
                        };
                        if (attrs.localId) headingNode.attrs.localId = attrs.localId;
                        if (marks) headingNode.marks = [
                            ...marks
                        ];
                        return headingNode;
                    }
                    return marks ? {
                        type: type,
                        content: content,
                        marks: marks,
                        attrs: {
                            level: level
                        }
                    } : {
                        type: type,
                        content: content,
                        attrs: {
                            level: level
                        }
                    };
                }
            }
            break;
        case 'bulletList':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'orderedList':
            if (content) return {
                type: type,
                content: content,
                attrs: {
                    order: attrs && attrs.order
                }
            };
            break;
        case 'listItem':
            if (content) return {
                type: type,
                content: $7bbfc2d34b0938dd$var$wrapInlineNodes(content)
            };
            break;
        case 'blockquote':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'panel':
            if (attrs && content) {
                const { panelType: panelType } = attrs;
                if (Object.values((0, $bFtEE.PanelType)).includes(panelType)) return {
                    type: type,
                    attrs: attrs,
                    content: content
                };
            }
            break;
        case 'layoutSection':
            if (content) return {
                type: type,
                marks: marks,
                content: content
            };
            break;
        case 'layoutColumn':
            if (attrs && content) {
                if (attrs.width > 0 && attrs.width <= 100) return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'decisionList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $9IGaJ.generateUuid)()
                }
            };
        case 'decisionItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $9IGaJ.generateUuid)(),
                    state: attrs && attrs.state || 'DECIDED'
                }
            };
        case 'taskList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $9IGaJ.generateUuid)()
                }
            };
        case 'taskItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $9IGaJ.generateUuid)(),
                    state: attrs && attrs.state || 'TODO'
                }
            };
        case 'table':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableRow')) {
                if (adfStage === 'stage0') return {
                    type: type,
                    content: content,
                    attrs: {
                        ...attrs,
                        localId: attrs?.localId || (0, $9IGaJ.generateUuid)(),
                        width: attrs?.width || null
                    }
                };
                return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'tableRow':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableCell' && e.type !== 'tableHeader')) return {
                type: type,
                content: content
            };
            break;
        case 'tableCell':
        case 'tableHeader':
            if (content) {
                const cellAttrs = {};
                if (attrs) {
                    if (attrs.colspan && attrs.colspan > 1) cellAttrs.colspan = attrs.colspan;
                    if (attrs.rowspan && attrs.rowspan > 1) cellAttrs.rowspan = attrs.rowspan;
                    if (attrs.background) cellAttrs.background = attrs.background;
                    if (attrs.colwidth && Array.isArray(attrs.colwidth)) cellAttrs.colwidth = attrs.colwidth;
                }
                return {
                    type: type,
                    content: $7bbfc2d34b0938dd$var$wrapInlineNodes(content),
                    attrs: attrs ? cellAttrs : undefined
                };
            }
            break;
        case 'image':
            if (attrs && attrs.src) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'placeholder':
            if (attrs && typeof attrs.text !== 'undefined') return {
                type: type,
                attrs: attrs
            };
            break;
        case 'expand':
        case 'nestedExpand':
            return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
    }
    return $7bbfc2d34b0938dd$export$b9908ef75cad1e0e(node);
};
const $7bbfc2d34b0938dd$export$87c6d4a6ebb7d9e9 = (mark, adfStage = 'final')=>{
    const { attrs: attrs, type: type } = mark;
    if (type) switch(type){
        case 'code':
            return {
                type: type
            };
        case 'em':
            return {
                type: type
            };
        case 'link':
            if (attrs) {
                const { href: href, url: url, __confluenceMetadata: __confluenceMetadata } = attrs;
                let linkHref = href || url;
                if (linkHref && linkHref.indexOf(':') === -1 && !$7bbfc2d34b0938dd$var$RELATIVE_LINK.test(linkHref) && !$7bbfc2d34b0938dd$var$ANCHOR_LINK.test(linkHref)) linkHref = `http://${linkHref}`;
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const linkAttrs = {
                    href: linkHref
                };
                if (__confluenceMetadata) linkAttrs.__confluenceMetadata = __confluenceMetadata;
                if (linkHref && (0, $iZOJ9.isSafeUrl)(linkHref)) return {
                    type: type,
                    attrs: linkAttrs
                };
            }
            break;
        case 'strike':
            return {
                type: type
            };
        case 'strong':
            return {
                type: type
            };
        case 'subsup':
            if (attrs && attrs['type']) {
                const subSupType = attrs['type'];
                if ($7bbfc2d34b0938dd$export$30f8aa4cc1f8c1cb(subSupType)) return {
                    type: type,
                    attrs: {
                        type: subSupType
                    }
                };
            }
            break;
        case 'textColor':
            if (attrs && $7bbfc2d34b0938dd$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'underline':
            return {
                type: type
            };
        case 'annotation':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
        case 'backgroundColor':
            if (attrs && $7bbfc2d34b0938dd$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
    }
    if (adfStage === 'stage0') switch(type){
        case 'confluenceInlineComment':
            return {
                type: type,
                attrs: attrs
            };
        case 'dataConsumer':
            return {
                type: type,
                attrs: attrs
            };
        case 'fragment':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
    }
    return null;
};

});
parcelRegister("kc0v7", function(module, exports) {

$parcel$export(module.exports, "inlineNodes", () => $eb355120b38723aa$export$b1f729c6af6f2a6e);

var $ctVrM = parcelRequire("ctVrM");
const $eb355120b38723aa$var$typedNodes = $ctVrM;
const $eb355120b38723aa$export$b1f729c6af6f2a6e = new Set(Object.keys($eb355120b38723aa$var$typedNodes).filter((key)=>$eb355120b38723aa$var$typedNodes[key] && $eb355120b38723aa$var$typedNodes[key].group === 'inline'));

});
parcelRegister("ctVrM", function(module, exports) {

$parcel$export(module.exports, "expand", () => (parcelRequire("7kC9H")).expand);
$parcel$export(module.exports, "expandWithNestedExpand", () => (parcelRequire("7kC9H")).expandWithNestedExpand);
$parcel$export(module.exports, "expandToJSON", () => (parcelRequire("7kC9H")).toJSON);
$parcel$export(module.exports, "confluenceJiraIssue", () => (parcelRequire("6bbHe")).confluenceJiraIssue);
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => (parcelRequire("5y0tR")).confluenceUnsupportedBlock);
$parcel$export(module.exports, "confluenceUnsupportedInline", () => (parcelRequire("bd7A9")).confluenceUnsupportedInline);
$parcel$export(module.exports, "doc", () => (parcelRequire("xjCuM")).doc);
$parcel$export(module.exports, "blockquote", () => (parcelRequire("aXBFx")).blockquote);
$parcel$export(module.exports, "blockquoteWithNestedCodeblockOrMedia", () => (parcelRequire("aXBFx")).blockquoteWithNestedCodeblockOrMedia);
$parcel$export(module.exports, "extendedBlockquote", () => (parcelRequire("aXBFx")).extendedBlockquote);
$parcel$export(module.exports, "blockquoteWithList", () => (parcelRequire("aXBFx")).blockquoteWithList);
$parcel$export(module.exports, "blockquoteWithoutNonBodiedMacros", () => (parcelRequire("aXBFx")).blockquoteWithoutNonBodiedMacros);
$parcel$export(module.exports, "bulletList", () => (parcelRequire("kjhhp")).bulletList);
$parcel$export(module.exports, "bulletListSelector", () => (parcelRequire("kjhhp")).bulletListSelector);
$parcel$export(module.exports, "codeBlock", () => (parcelRequire("8vlrc")).codeBlock);
$parcel$export(module.exports, "codeBlockToJSON", () => (parcelRequire("8vlrc")).toJSON);
$parcel$export(module.exports, "hardBreak", () => (parcelRequire("jnMM2")).hardBreak);
$parcel$export(module.exports, "heading", () => (parcelRequire("lRTZM")).heading);
$parcel$export(module.exports, "rule", () => (parcelRequire("M4hHz")).rule);
$parcel$export(module.exports, "orderedList", () => (parcelRequire("dwptW")).orderedList);
$parcel$export(module.exports, "orderedListSelector", () => (parcelRequire("dwptW")).orderedListSelector);
$parcel$export(module.exports, "orderedListWithOrder", () => (parcelRequire("dwptW")).orderedListWithOrder);
$parcel$export(module.exports, "paragraph", () => (parcelRequire("abme3")).paragraph);
$parcel$export(module.exports, "emoji", () => (parcelRequire("7DoMR")).emoji);
$parcel$export(module.exports, "image", () => (parcelRequire("7lRBh")).image);
$parcel$export(module.exports, "mention", () => (parcelRequire("g7Cky")).mention);
$parcel$export(module.exports, "mentionToJSON", () => (parcelRequire("g7Cky")).toJSON);
$parcel$export(module.exports, "listItem", () => (parcelRequire("2FIVU")).listItem);
$parcel$export(module.exports, "listItemWithTask", () => (parcelRequire("2FIVU")).listItemWithTask);
$parcel$export(module.exports, "listItemWithDecisionStage0", () => (parcelRequire("2FIVU")).listItemWithDecisionStage0);
$parcel$export(module.exports, "listItemWithoutNonBodiedMacros", () => (parcelRequire("2FIVU")).listItemWithoutNonBodiedMacros);
$parcel$export(module.exports, "extendedPanel", () => (parcelRequire("bFtEE")).extendedPanel);
$parcel$export(module.exports, "panelWithoutNestedNonBodiedMacros", () => (parcelRequire("bFtEE")).panelWithoutNestedNonBodiedMacros);
$parcel$export(module.exports, "PanelType", () => (parcelRequire("bFtEE")).PanelType);
$parcel$export(module.exports, "text", () => (parcelRequire("3DR6L")).text);
$parcel$export(module.exports, "unknownBlock", () => (parcelRequire("9X587")).default);
$parcel$export(module.exports, "caption", () => (parcelRequire("5JeV5")).caption);
$parcel$export(module.exports, "media", () => (parcelRequire("7agO8")).media);
$parcel$export(module.exports, "copyPrivateMediaAttributes", () => (parcelRequire("7agO8")).copyPrivateAttributes);
$parcel$export(module.exports, "mediaToJSON", () => (parcelRequire("7agO8")).toJSON);
$parcel$export(module.exports, "mediaGroup", () => (parcelRequire("92lix")).mediaGroup);
$parcel$export(module.exports, "mediaInline", () => (parcelRequire("7Xgp3")).mediaInline);
$parcel$export(module.exports, "mediaSingle", () => (parcelRequire("bIGZ7")).mediaSingle);
$parcel$export(module.exports, "mediaSingleSpec", () => (parcelRequire("bIGZ7")).mediaSingleSpec);
$parcel$export(module.exports, "mediaSingleWithCaption", () => (parcelRequire("bIGZ7")).mediaSingleWithCaption);
$parcel$export(module.exports, "mediaSingleWithWidthType", () => (parcelRequire("bIGZ7")).mediaSingleWithWidthType);
$parcel$export(module.exports, "mediaSingleFull", () => (parcelRequire("bIGZ7")).mediaSingleFull);
$parcel$export(module.exports, "mediaSingleToJSON", () => (parcelRequire("bIGZ7")).toJSON);
$parcel$export(module.exports, "table", () => (parcelRequire("9UDEr")).table);
$parcel$export(module.exports, "tableWithNestedTable", () => (parcelRequire("9UDEr")).tableWithNestedTable);
$parcel$export(module.exports, "tableRowWithNestedTable", () => (parcelRequire("9UDEr")).tableRowWithNestedTable);
$parcel$export(module.exports, "tableCellWithNestedTable", () => (parcelRequire("9UDEr")).tableCellWithNestedTable);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => (parcelRequire("9UDEr")).tableHeaderWithNestedTable);
$parcel$export(module.exports, "tableStage0", () => (parcelRequire("9UDEr")).tableStage0);
$parcel$export(module.exports, "tableWithCustomWidth", () => (parcelRequire("9UDEr")).tableWithCustomWidth);
$parcel$export(module.exports, "tableToJSON", () => (parcelRequire("9UDEr")).tableToJSON);
$parcel$export(module.exports, "tableCell", () => (parcelRequire("9UDEr")).tableCell);
$parcel$export(module.exports, "toJSONTableCell", () => (parcelRequire("9UDEr")).toJSONTableCell);
$parcel$export(module.exports, "tableHeader", () => (parcelRequire("9UDEr")).tableHeader);
$parcel$export(module.exports, "toJSONTableHeader", () => (parcelRequire("9UDEr")).toJSONTableHeader);
$parcel$export(module.exports, "tableRow", () => (parcelRequire("9UDEr")).tableRow);
$parcel$export(module.exports, "tableBackgroundColorPalette", () => (parcelRequire("9UDEr")).tableBackgroundColorPalette);
$parcel$export(module.exports, "tableBackgroundBorderColor", () => (parcelRequire("9UDEr")).tableBackgroundBorderColor);
$parcel$export(module.exports, "tableBackgroundColorNames", () => (parcelRequire("9UDEr")).tableBackgroundColorNames);
$parcel$export(module.exports, "getCellAttrs", () => (parcelRequire("9UDEr")).getCellAttrs);
$parcel$export(module.exports, "getCellDomAttrs", () => (parcelRequire("9UDEr")).getCellDomAttrs);
$parcel$export(module.exports, "tablePrefixSelector", () => (parcelRequire("9UDEr")).tablePrefixSelector);
$parcel$export(module.exports, "tableCellSelector", () => (parcelRequire("9UDEr")).tableCellSelector);
$parcel$export(module.exports, "tableHeaderSelector", () => (parcelRequire("9UDEr")).tableHeaderSelector);
$parcel$export(module.exports, "tableCellContentWrapperSelector", () => (parcelRequire("9UDEr")).tableCellContentWrapperSelector);
$parcel$export(module.exports, "tableCellContentDomSelector", () => (parcelRequire("9UDEr")).tableCellContentDomSelector);
$parcel$export(module.exports, "decisionList", () => (parcelRequire("8gSD8")).decisionList);
$parcel$export(module.exports, "decisionListSelector", () => (parcelRequire("8gSD8")).decisionListSelector);
$parcel$export(module.exports, "decisionItem", () => (parcelRequire("Khvpb")).decisionItem);
$parcel$export(module.exports, "taskList", () => (parcelRequire("43mJF")).taskList);
$parcel$export(module.exports, "taskListSelector", () => (parcelRequire("43mJF")).taskListSelector);
$parcel$export(module.exports, "taskItem", () => (parcelRequire("iThOL")).taskItem);
$parcel$export(module.exports, "date", () => (parcelRequire("b2VmY")).date);
$parcel$export(module.exports, "placeholder", () => (parcelRequire("dgJoa")).placeholder);
$parcel$export(module.exports, "layoutSection", () => (parcelRequire("gZoER")).layoutSection);
$parcel$export(module.exports, "layoutSectionWithSingleColumn", () => (parcelRequire("gZoER")).layoutSectionWithSingleColumn);
$parcel$export(module.exports, "layoutColumn", () => (parcelRequire("4EbxI")).layoutColumn);
$parcel$export(module.exports, "inlineCard", () => (parcelRequire("cCBEe")).inlineCard);
$parcel$export(module.exports, "blockCard", () => (parcelRequire("21PS7")).blockCard);
$parcel$export(module.exports, "unsupportedBlock", () => (parcelRequire("d1d6m")).unsupportedBlock);
$parcel$export(module.exports, "unsupportedInline", () => (parcelRequire("6kr5W")).unsupportedInline);
$parcel$export(module.exports, "status", () => (parcelRequire("18bvk")).status);
$parcel$export(module.exports, "nestedExpand", () => (parcelRequire("dx5eC")).nestedExpand);
$parcel$export(module.exports, "nestedExpandWithoutNonBodiedMacros", () => (parcelRequire("dx5eC")).nestedExpandWithoutNonBodiedMacros);
$parcel$export(module.exports, "embedCard", () => (parcelRequire("kshOv")).embedCard);
$parcel$export(module.exports, "extension", () => (parcelRequire("hhN5g")).extension);
$parcel$export(module.exports, "inlineExtension", () => (parcelRequire("5BOuQ")).inlineExtension);
$parcel$export(module.exports, "bodiedExtension", () => (parcelRequire("5AxYU")).bodiedExtension);
$parcel$export(module.exports, "extensionFrame", () => (parcelRequire("47jug")).extensionFrame);
$parcel$export(module.exports, "multiBodiedExtension", () => (parcelRequire("47jug")).multiBodiedExtension);

var $7kC9H = parcelRequire("7kC9H");

var $6bbHe = parcelRequire("6bbHe");

var $5y0tR = parcelRequire("5y0tR");

var $bd7A9 = parcelRequire("bd7A9");

var $xjCuM = parcelRequire("xjCuM");

var $aXBFx = parcelRequire("aXBFx");

var $kjhhp = parcelRequire("kjhhp");

var $8vlrc = parcelRequire("8vlrc");

var $jnMM2 = parcelRequire("jnMM2");

var $lRTZM = parcelRequire("lRTZM");

var $M4hHz = parcelRequire("M4hHz");

var $dwptW = parcelRequire("dwptW");

var $abme3 = parcelRequire("abme3");

var $7DoMR = parcelRequire("7DoMR");

var $7lRBh = parcelRequire("7lRBh");

var $g7Cky = parcelRequire("g7Cky");

var $2FIVU = parcelRequire("2FIVU");

var $bFtEE = parcelRequire("bFtEE");

var $3DR6L = parcelRequire("3DR6L");

var $9X587 = parcelRequire("9X587");

var $5JeV5 = parcelRequire("5JeV5");

var $7agO8 = parcelRequire("7agO8");

var $92lix = parcelRequire("92lix");

var $7Xgp3 = parcelRequire("7Xgp3");

var $bIGZ7 = parcelRequire("bIGZ7");

var $9UDEr = parcelRequire("9UDEr");

var $8gSD8 = parcelRequire("8gSD8");

var $Khvpb = parcelRequire("Khvpb");

var $43mJF = parcelRequire("43mJF");

var $iThOL = parcelRequire("iThOL");

var $b2VmY = parcelRequire("b2VmY");

var $dgJoa = parcelRequire("dgJoa");

var $gZoER = parcelRequire("gZoER");

var $4EbxI = parcelRequire("4EbxI");

var $cCBEe = parcelRequire("cCBEe");

var $21PS7 = parcelRequire("21PS7");

var $d1d6m = parcelRequire("d1d6m");

var $6kr5W = parcelRequire("6kr5W");

var $18bvk = parcelRequire("18bvk");

var $dx5eC = parcelRequire("dx5eC");

var $kshOv = parcelRequire("kshOv");

var $hhN5g = parcelRequire("hhN5g");

var $5BOuQ = parcelRequire("5BOuQ");

var $5AxYU = parcelRequire("5AxYU");

var $47jug = parcelRequire("47jug");

});



parcelRegister("bzwTW", function(module, exports) {

$parcel$export(module.exports, "insideBreakoutLayout", () => $99a90b85f857f7e6$export$d7bc71cca336a3b);
$parcel$export(module.exports, "insideBlockNode", () => $99a90b85f857f7e6$export$42ddc573eb5a7b43);
$parcel$export(module.exports, "insideMultiBodiedExtension", () => $99a90b85f857f7e6$export$9f1e9347b0411934);
$parcel$export(module.exports, "insideTable", () => $99a90b85f857f7e6$export$244bf4b32387ef62);
const $99a90b85f857f7e6$var$isLayoutNode = (node)=>node.type.name === 'layoutSection';
const $99a90b85f857f7e6$var$hasBreakOutMark = (node)=>node.marks.some((m)=>m.type.name === 'breakout');
const $99a90b85f857f7e6$export$d7bc71cca336a3b = (path)=>path.some((item)=>$99a90b85f857f7e6$var$isLayoutNode(item) && $99a90b85f857f7e6$var$hasBreakOutMark(item));
const $99a90b85f857f7e6$export$42ddc573eb5a7b43 = (path, schema)=>{
    const { nodes: { expand: expand, nestedExpand: nestedExpand, layoutColumn: layoutColumn } } = schema;
    const blockNodeNames = [
        expand,
        nestedExpand,
        layoutColumn
    ].filter((node)=>Boolean(node)).map((node)=>node.name);
    return path && path.some((n)=>n.type && blockNodeNames.indexOf(n.type.name) > -1);
};
const $99a90b85f857f7e6$export$9f1e9347b0411934 = (path, schema)=>{
    const { nodes: { multiBodiedExtension: multiBodiedExtension } } = schema;
    return path.some((n)=>n.type === multiBodiedExtension);
};
const $99a90b85f857f7e6$export$244bf4b32387ef62 = (path, schema)=>{
    const { nodes: { table: table } } = schema;
    return path.some((n)=>n.type === table);
};

});


parcelRegister("12yAL", function(module, exports) {

$parcel$export(module.exports, "renderDocument", () => $af6d4930d9141440$export$59a54f98b9753d5c);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $kOFhM = parcelRequire("kOFhM");

var $4FBRr = parcelRequire("4FBRr");
var $aSk3Q = parcelRequire("aSk3Q");

var $gkwXh = parcelRequire("gkwXh");

var $d54NZ = parcelRequire("d54NZ");
var $4IuOY = parcelRequire("4IuOY");

var $eQNWQ = parcelRequire("eQNWQ");

var $VSDnB = parcelRequire("VSDnB");

var $8QpSo = parcelRequire("8QpSo");

var $knXBU = parcelRequire("knXBU");

var $1cjf7 = parcelRequire("1cjf7");

var $kgV4b = parcelRequire("kgV4b");
const $af6d4930d9141440$var$SUPPORTS_HIRES_TIMER_API = !!(typeof window !== 'undefined' && window.performance && performance.now);
const $af6d4930d9141440$var$withStopwatch = (cb)=>{
    const startTime = $af6d4930d9141440$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    const output = cb();
    const endTime = $af6d4930d9141440$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    const time = endTime - startTime;
    return {
        output: output,
        time: time
    };
};
const $af6d4930d9141440$var$_validation = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent, skipValidation, validationOverrides)=>{
    let result;
    if (useSpecBasedValidator) {
        // link mark on mediaSingle is deprecated, need to move link mark to child media node
        // https://product-fabric.atlassian.net/browse/ED-14043
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $4FBRr.transformMediaLinkMarks)(doc);
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).MEDIA_LINK_TRANSFORMED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        });
        result = skipValidation ? transformedAdf || doc : (0, $4IuOY.validateADFEntity)(schema, transformedAdf || doc, dispatchAnalyticsEvent, validationOverrides);
    } else result = (0, $eQNWQ.getValidDocument)(doc, schema, adfStage);
    if (!result) return result;
    // ProseMirror always require a child under doc
    if (result.type === 'doc' && useSpecBasedValidator) {
        if (Array.isArray(result.content) && result.content.length === 0) result.content.push({
            type: 'paragraph',
            content: []
        });
        // Just making sure doc is always valid
        if (!result.version) result.version = 1;
    }
    if ((0, $VSDnB.fg)('platform_editor_use_nested_table_pm_nodes')) // Convert nested-table extensions into nested tables
    try {
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $aSk3Q.transformNestedTablesIncomingDocument)(result, {
            environment: 'renderer',
            disableNestedRendererTreatment: (0, $VSDnB.fg)('platform_editor_nested_table_extension_comment_fix')
        });
        if (isTransformed) {
            dispatchAnalyticsEvent?.({
                action: (0, $gkwXh.ACTION).NESTED_TABLE_TRANSFORMED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
            });
            result = transformedAdf;
        }
    } catch (e) {
        dispatchAnalyticsEvent?.({
            action: (0, $gkwXh.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $knXBU.PLATFORM).WEB,
                errorStack: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to encode one or more nested tables' : undefined}`
            }
        });
    }
    return result;
};
const $af6d4930d9141440$var$memoValidation = (0, $8QpSo.default)($af6d4930d9141440$var$_validation, (newArgs, lastArgs)=>{
    let result = false;
    if ((0, $VSDnB.fg)('cc_complexit_fe_memoValidation_redundant_calls')) {
        const [newDoc, newSchema, newADFStage, newUseSpecValidator, , // ignoring dispatchAnalyticsEvent
        newSkipValidation, newValidationOverrides] = newArgs;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const [oldDoc, oldSchema, oldADFStage, oldUseSpecValidator, , // ignoring dispatchAnalyticsEvent
        oldSkipValidation, oldValidationOverrides] = lastArgs;
        result = $af6d4930d9141440$var$areDocsEqual(newDoc, oldDoc) && newSchema === oldSchema && newADFStage === oldADFStage && newUseSpecValidator === oldUseSpecValidator && newSkipValidation === oldSkipValidation && newValidationOverrides === oldValidationOverrides;
    } else {
        // This path has a bug and it will wrongfully assign dispatchAnalyticsEvent to skipValidation/oldSkipValidation
        // instead of ignoring it as it does not skip it when unpacking the array.
        // This results the function returning false when it should return true
        // and causing extra re-renders. see https://hello.jira.atlassian.cloud/browse/COMPLEXIT-161.
        const [newDoc, newSchema, newADFStage, newUseSpecValidator, , skipValidation, newValidationOverrides] = newArgs;
        const [oldDoc, oldSchema, oldADFStage, oldUseSpecValidator, , oldSkipValidation, oldValidationOverrides] = lastArgs;
        result = $af6d4930d9141440$var$areDocsEqual(newDoc, oldDoc) && newSchema === oldSchema && newADFStage === oldADFStage && newUseSpecValidator === oldUseSpecValidator && skipValidation === oldSkipValidation && newValidationOverrides === oldValidationOverrides;
    }
    return result;
});
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $af6d4930d9141440$var$areDocsEqual = (docA, docB)=>{
    if (docA === docB) return true;
    if (typeof docA === 'string' && typeof docB === 'string') return docA === docB;
    // PMNode
    if (docA.type && docA.toJSON && docB.type && docB.toJSON) return JSON.stringify(docA.toJSON()) === JSON.stringify(docB.toJSON());
    // Object
    return JSON.stringify(docA) === JSON.stringify(docB);
};
const $af6d4930d9141440$var$_serializeFragment = (serializer, doc)=>{
    return serializer.serializeFragment(doc.content);
};
const $af6d4930d9141440$var$memoSerializeFragment = (0, $8QpSo.default)($af6d4930d9141440$var$_serializeFragment, (newArgs, lastArgs)=>{
    const [newSerializer, newDoc] = newArgs;
    const [oldSerializer, oldDoc] = lastArgs;
    return newSerializer === oldSerializer && $af6d4930d9141440$var$areDocsEqual(newDoc, oldDoc);
});
const $af6d4930d9141440$var$_createNodeAndCheck = (schema, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
doc, dispatchAnalyticsEvent)=>{
    const pmNode = schema.nodeFromJSON(doc);
    try {
        pmNode.check();
    } catch (err) {
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $knXBU.PLATFORM).WEB,
                errorStack: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        });
    }
    return pmNode;
};
const $af6d4930d9141440$var$memoCreateNodeAndCheck = (0, $8QpSo.default)($af6d4930d9141440$var$_createNodeAndCheck, (newArgs, lastArgs)=>{
    // ignore dispatchAnalyticsEvent
    const [newSchema, newDoc] = newArgs;
    const [oldSchema, oldDoc] = lastArgs;
    return newSchema === oldSchema && $af6d4930d9141440$var$areDocsEqual(newDoc, oldDoc);
});
const $af6d4930d9141440$export$59a54f98b9753d5c = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
doc, serializer, schema = (0, $kOFhM.defaultSchema), adfStage = 'final', useSpecBasedValidator = false, rendererId = 'noid', dispatchAnalyticsEvent, unsupportedContentLevelsTracking, appearance, includeNodesCountInStats, skipValidation, validationOverrides)=>{
    const stat = {
        sanitizeTime: 0
    };
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $VSDnB.fg)('platform_editor_renderer_rm_usespecbasedvalidator')) useSpecBasedValidator = true;
    const { output: validDoc, time: sanitizeTime } = $af6d4930d9141440$var$withStopwatch(()=>{
        return $af6d4930d9141440$var$memoValidation(doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent, skipValidation, validationOverrides);
    });
    // save sanitize time to stats
    stat.sanitizeTime = sanitizeTime;
    if (!validDoc) return {
        stat: stat,
        result: null
    };
    const { output: node, time: buildTreeTime } = $af6d4930d9141440$var$withStopwatch(()=>{
        return $af6d4930d9141440$var$memoCreateNodeAndCheck(schema, validDoc, dispatchAnalyticsEvent);
    });
    // save build tree time to stats
    stat.buildTreeTime = buildTreeTime;
    const { output: result, time: serializeTime } = $af6d4930d9141440$var$withStopwatch(()=>{
        return $af6d4930d9141440$var$memoSerializeFragment(serializer, node);
    });
    // save serialize tree time to stats
    stat.serializeTime = serializeTime;
    if (dispatchAnalyticsEvent && useSpecBasedValidator) {
        (0, $d54NZ.findAndTrackUnsupportedContentNodes)(node, schema, dispatchAnalyticsEvent);
        if (unsupportedContentLevelsTracking?.enabled) {
            const documentData = {
                doc: validDoc,
                appearance: appearance,
                rendererId: rendererId
            };
            (0, $1cjf7.trackUnsupportedContentLevels)(documentData, unsupportedContentLevelsTracking, dispatchAnalyticsEvent);
        }
    }
    if (includeNodesCountInStats) stat.nodesCount = (0, $kgV4b.countNodes)(doc);
    return {
        result: result,
        stat: stat,
        pmDoc: node
    };
};

});
parcelRegister("4FBRr", function(module, exports) {

$parcel$export(module.exports, "transformMediaLinkMarks", () => $75bd921bb3a8c47e$export$6528700f3fa2fe2a);

var $l1C1k = parcelRequire("l1C1k");
const $75bd921bb3a8c47e$export$6528700f3fa2fe2a = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $l1C1k.traverse)(adf, {
        mediaSingle: (node)=>{
            if (!node.marks || !node.content || node.content[0]?.type !== 'media') return node;
            let linkMark = null;
            node.marks.forEach((mark, i)=>{
                if (mark.type === 'link') {
                    linkMark = mark;
                    node.marks?.splice(i, 1);
                    isTransformed = true;
                }
            });
            if (node.marks.length === 0) delete node.marks;
            if (linkMark) {
                const mediaNode = node.content[0];
                // only add link mark if media node doesnt already have one
                if (mediaNode.marks?.every((mark)=>mark.type !== 'link')) mediaNode.marks.push(linkMark);
                else if (!mediaNode.marks) mediaNode.marks = [
                    linkMark
                ];
            }
            return node;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});

parcelRegister("4IuOY", function(module, exports) {

$parcel$export(module.exports, "validateADFEntity", () => $2c0bbb60cfee2804$export$884cfad20dece33e);

var $905ey = parcelRequire("905ey");

var $gkwXh = parcelRequire("gkwXh");

var $d54NZ = parcelRequire("d54NZ");
const $2c0bbb60cfee2804$export$8e7fd962b4d3895d = 'unsupportedNodeAttribute';
const $2c0bbb60cfee2804$var$errorCallbackFor = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
marks, validate, dispatchAnalyticsEvent, validationOverrides)=>{
    return (entity, error, options)=>{
        return $2c0bbb60cfee2804$export$468b008419c9a974(entity, error, {
            ...options,
            allowNestedTables: validationOverrides?.allowNestedTables
        }, marks, validate, dispatchAnalyticsEvent);
    };
};
const $2c0bbb60cfee2804$export$468b008419c9a974 = (entity, error, options, marks, validate, dispatchAnalyticsEvent)=>{
    if (entity && entity.type === $2c0bbb60cfee2804$export$8e7fd962b4d3895d) return entity;
    if (options.isMark) return $2c0bbb60cfee2804$export$87b732fa69cdf16e(error.meta, 'mark');
    if (options.isNodeAttribute) {
        const entityType = entity && entity.type ? entity.type : undefined;
        return {
            type: $2c0bbb60cfee2804$export$8e7fd962b4d3895d,
            attrs: {
                type: {
                    nodeType: entityType
                },
                unsupported: error.meta
            }
        };
    }
    if (entity && marks.indexOf(entity.type) > -1) return;
    /**
	 * There's a inconsistency between ProseMirror and ADF.
	 * `content` is actually optional in ProseMirror.
	 * And, also empty `text` node is not valid.
	 */ if (error.code === 'MISSING_PROPERTIES' && entity.type === 'paragraph') return {
        type: 'paragraph',
        content: []
    };
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: We can repair missing content like `panel` without a `paragraph`.
    if (error.code === 'INVALID_CONTENT_LENGTH') {
        if (error.meta && options.allowUnsupportedBlock && entity.content) return $2c0bbb60cfee2804$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent);
        else // Can't fix it by wrapping
        if (dispatchAnalyticsEvent) $2c0bbb60cfee2804$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    }
    // Nested tables don't actually exist in ADF. In ADF they are stored as an `extension` node with the nested table content serialized in a property of that extension.
    // Usually when we validate ADF we are validating this `extension` and then later transforming it into nested tables for usage by ProseMirror.
    // Under certain circumstances however, ADF validation is performed on this already transformed extension and since nested tables aren't allowed by ADF this
    // produces an error. For example, nested renderers in Confluence `bodiedExtension`'s. The nested renderer receives the already transformed nested tables that originated from the
    // `extension` node and validates it. This is invalid ADF so an error is thrown.
    // This override allows an exception to be made for nested tables in the validator in this circumstance.
    if (options.allowNestedTables) {
        const meta = error.meta;
        if (options.allowNestedTables && meta?.parentType && [
            'tableCell',
            'tableHeader'
        ].includes(meta?.parentType) && error.code === 'INVALID_CONTENT' && entity.type === 'table') return entity;
    }
    if (options.allowUnsupportedBlock) return $2c0bbb60cfee2804$export$87b732fa69cdf16e(entity);
    if (options.allowUnsupportedInline) return $2c0bbb60cfee2804$export$87b732fa69cdf16e(entity, 'inline');
    if (dispatchAnalyticsEvent) $2c0bbb60cfee2804$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    return entity;
};
function $2c0bbb60cfee2804$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent) {
    const meta = error.meta;
    if (meta.type === 'maximum') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    entity.content = entity.content.filter((x)=>!!x).map((child, index)=>{
        return index >= meta.requiredLength && child.type !== 'unsupportedBlock' ? $2c0bbb60cfee2804$export$87b732fa69cdf16e(child) : validate(child, $2c0bbb60cfee2804$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent)).entity;
    });
    if (meta.type === 'minimum') {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (entity.content.length === 0) return $2c0bbb60cfee2804$export$87b732fa69cdf16e(entity);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        entity.content = entity.content.filter((x)=>!!x).map((child)=>{
            return child.type !== 'unsupportedBlock' ? $2c0bbb60cfee2804$export$87b732fa69cdf16e(child) : child;
        });
    }
    return entity;
}
function $2c0bbb60cfee2804$var$trackValidationError(dispatchAnalyticsEvent, error, entity) {
    if (!dispatchAnalyticsEvent) return;
    (0, $d54NZ.fireUnsupportedEvent)(dispatchAnalyticsEvent, (0, $gkwXh.ACTION_SUBJECT_ID).UNSUPPORTED_ERROR, {
        type: entity.type || '',
        ancestry: entity.ancestorHierarchy || '',
        parentType: entity.parentType || '',
        marks: entity.marks || [],
        attrs: entity.attrs || {}
    }, error.code);
}
const $2c0bbb60cfee2804$export$884cfad20dece33e = (schema, node, dispatchAnalyticsEvent, validationOverrides)=>{
    const nodes = Object.keys(schema.nodes);
    const marks = Object.keys(schema.marks);
    const validate = (0, $905ey.validator)(nodes, marks, {
        allowPrivateAttributes: true
    });
    const emptyDoc = {
        type: 'doc',
        content: []
    };
    const { entity: entity = emptyDoc } = validate(node, $2c0bbb60cfee2804$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent, validationOverrides));
    return entity;
};
function $2c0bbb60cfee2804$export$87b732fa69cdf16e(originalValue, type = 'block') {
    let unsupportedNodeType;
    switch(type){
        case 'inline':
            unsupportedNodeType = 'unsupportedInline';
            break;
        case 'mark':
            unsupportedNodeType = 'unsupportedMark';
            break;
        default:
            unsupportedNodeType = 'unsupportedBlock';
    }
    return {
        type: unsupportedNodeType,
        attrs: {
            originalValue: originalValue
        }
    };
}

});
parcelRegister("905ey", function(module, exports) {

$parcel$export(module.exports, "validator", () => $e861220f24467804$export$956325f45c5d174a);
// Ignored via go/ees005
// eslint-disable-next-line import/no-namespace

var $gsiq1 = parcelRequire("gsiq1");

var $iiazc = parcelRequire("iiazc");

var $1H4Aw = parcelRequire("1H4Aw");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e861220f24467804$var$mapMarksItems(spec, fn = (x)=>x) {
    if (spec.props && spec.props.marks) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { items: items, ...rest } = spec.props.marks;
        return {
            ...spec,
            props: {
                ...spec.props,
                marks: {
                    ...rest,
                    /**
					 * `Text & MarksObject<Mark-1>` produces `items: ['mark-1']`
					 * `Text & MarksObject<Mark-1 | Mark-2>` produces `items: [['mark-1', 'mark-2']]`
					 */ items: items.length ? Array.isArray(items[0]) ? items.map(fn) : [
                        fn(items)
                    ] : [
                        []
                    ]
                }
            }
        };
    } else return spec;
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e861220f24467804$var$partitionObject = (obj, predicate)=>Object.keys(obj).reduce((acc, key)=>{
        const result = predicate(key, obj[key], obj);
        acc[result ? 0 : 1].push(key);
        return acc;
    }, [
        [],
        []
    ]);
/**
 * Normalizes the structure of files imported from './specs'.
 * We denormalised the spec to save bundle size.
 */ function $e861220f24467804$var$createSpec(nodes, marks) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys($gsiq1).reduce((newSpecs, k)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const spec = {
            ...$gsiq1[k]
        };
        if (spec.props) {
            spec.props = {
                ...spec.props
            };
            if (spec.props.content) {
                // 'tableCell_content' => { type: 'array', items: [ ... ] }
                if ((0, $iiazc.isString)(spec.props.content)) // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                spec.props.content = $gsiq1[spec.props.content];
                // ['inline', 'emoji']
                if (Array.isArray(spec.props.content)) /**
					 * Flatten
					 *
					 * Input:
					 * [ { type: 'array', items: [ 'tableHeader' ] }, { type: 'array', items: [ 'tableCell' ] } ]
					 *
					 * Output:
					 * { type: 'array', items: [ [ 'tableHeader' ], [ 'tableCell' ] ] }
					 */ spec.props.content = {
                    type: 'array',
                    items: (spec.props.content || []).map((arr)=>arr.items)
                };
                else spec.props.content = {
                    ...spec.props.content
                };
                spec.props.content.items = spec.props.content.items// ['inline'] => [['emoji', 'hr', ...]]
                // ['media'] => [['media']]
                .map((item)=>(0, $iiazc.isString)(item) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    Array.isArray($gsiq1[item]) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    $gsiq1[item] : [
                        item
                    ] : item)// [['emoji', 'hr', 'inline_code']] => [['emoji', 'hr', ['text', { marks: {} }]]]
                .map((item)=>item.map((subItem)=>// Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        Array.isArray($gsiq1[subItem]) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        $gsiq1[subItem] : (0, $iiazc.isString)(subItem) ? subItem : [
                            'text',
                            subItem
                        ])// Remove unsupported nodes & marks
                    // Filter nodes
                    .filter((subItem)=>{
                        if (nodes) {
                            // Node with overrides
                            // ['mediaSingle', { props: { content: { items: [ 'media', 'caption' ] } }}]
                            if (Array.isArray(subItem)) {
                                const isMainNodeSupported = nodes.indexOf(subItem[0]) > -1;
                                if (isMainNodeSupported && subItem[1]?.props?.content?.items) return subItem[1].props.content.items.every((item)=>nodes.indexOf(item) > -1);
                                return isMainNodeSupported;
                            }
                            return nodes.indexOf(subItem) > -1;
                        }
                        return true;
                    })// Filter marks
                    .map((subItem)=>Array.isArray(subItem) && marks ? /**
										 * TODO: Probably try something like immer, but it's 3.3kb gzipped.
										 * Not worth it just for this.
										 */ [
                            subItem[0],
                            $e861220f24467804$var$mapMarksItems(subItem[1])
                        ] : subItem));
            }
        }
        newSpecs[k] = spec;
        return newSpecs;
    }, {});
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e861220f24467804$var$getOptionsForType(type, list) {
    if (!list) return {};
    for(let i = 0, len = list.length; i < len; i++){
        const spec = list[i];
        let name = spec;
        let options = {};
        if (Array.isArray(spec)) [name, options] = spec;
        if (name === type) return options;
    }
    return false;
}
const $e861220f24467804$var$isValidatorSpecAttrs = (spec)=>{
    return !!spec.props;
};
function $e861220f24467804$export$66c739158ef99a42(spec, value) {
    if (!(0, $iiazc.isDefined)(value)) return !!spec.optional;
    if ($e861220f24467804$var$isValidatorSpecAttrs(spec)) {
        // If spec has ".props" it is ValidatorSpecAttrs and need to pipe back in recursively
        const [_, invalidKeys] = $e861220f24467804$var$partitionObject(spec.props, (key, subSpec)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            $e861220f24467804$export$66c739158ef99a42(subSpec, value[key]));
        return invalidKeys.length === 0;
    }
    // extension_node parameters has no type
    if (!(0, $iiazc.isDefined)(spec.type)) return !!spec.optional;
    switch(spec.type){
        case 'boolean':
            return (0, $iiazc.isBoolean)(value);
        case 'number':
            return (0, $iiazc.isNumber)(value) && ((0, $iiazc.isDefined)(spec.minimum) ? spec.minimum <= value : true) && ((0, $iiazc.isDefined)(spec.maximum) ? spec.maximum >= value : true);
        case 'integer':
            return (0, $iiazc.isInteger)(value) && ((0, $iiazc.isDefined)(spec.minimum) ? spec.minimum <= value : true) && ((0, $iiazc.isDefined)(spec.maximum) ? spec.maximum >= value : true);
        case 'string':
            const validatorFnPassed = (rule)=>typeof value === 'string' && (0, $iiazc.isDefined)((0, $1H4Aw.validatorFnMap)[rule]) && (0, $1H4Aw.validatorFnMap)[rule](value);
            return (0, $iiazc.isString)(value) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            ((0, $iiazc.isDefined)(spec.minLength) ? spec.minLength <= value.length : true) && ((0, $iiazc.isDefined)(spec.validatorFn) ? validatorFnPassed(spec.validatorFn) : true) && // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            (spec.pattern ? new RegExp(spec.pattern).test(value) : true);
        case 'object':
            return (0, $iiazc.isPlainObject)(value);
        case 'array':
            if (Array.isArray(value)) {
                const isTuple = !!spec.isTupleLike;
                const { minItems: minItems, maxItems: maxItems } = spec;
                if (minItems !== undefined && value.length < minItems || maxItems !== undefined && value.length > maxItems) return false;
                if (isTuple) {
                    // If value has fewer items than tuple has specs - we are fine with that.
                    const numberOfItemsToCheck = Math.min(spec.items.length, value.length);
                    return Array(numberOfItemsToCheck).fill(null).every((_, i)=>$e861220f24467804$export$66c739158ef99a42(spec.items[i], value[i]));
                } else return value.every((valueItem)=>// We check that at least one of the specs in the list (spec.items) matches each value from
                    spec.items.some((itemSpec)=>$e861220f24467804$export$66c739158ef99a42(itemSpec, valueItem)));
            }
            return false;
        case 'enum':
            return (0, $iiazc.isString)(value) && spec.values.indexOf(value) > -1;
    }
}
const $e861220f24467804$var$errorMessageFor = (type, message)=>`${type}: ${message}.`;
const $e861220f24467804$var$getUnsupportedOptions = (spec)=>{
    if (spec && spec.props && spec.props.content) {
        const { allowUnsupportedBlock: allowUnsupportedBlock, allowUnsupportedInline: allowUnsupportedInline } = spec.props.content;
        return {
            allowUnsupportedBlock: allowUnsupportedBlock,
            allowUnsupportedInline: allowUnsupportedInline
        };
    }
    return {};
};
const $e861220f24467804$var$invalidChildContent = (child, errorCallback, parentSpec)=>{
    const message = $e861220f24467804$var$errorMessageFor(child.type, 'invalid content');
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        ...child
    }, {
        code: 'INVALID_CONTENT',
        message: message,
        meta: {
            parentType: parentSpec?.props?.type?.values[0]
        }
    }, $e861220f24467804$var$getUnsupportedOptions(parentSpec));
};
const $e861220f24467804$var$unsupportedMarkContent = (errorCode, mark, errorCallback, errorMessage)=>{
    const message = errorMessage || $e861220f24467804$var$errorMessageFor(mark.type, 'unsupported mark');
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        ...mark
    }, {
        code: errorCode,
        message: message,
        meta: mark
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: true
    });
};
const $e861220f24467804$var$unsupportedNodeAttributesContent = (entity, errorCode, invalidAttributes, message, errorCallback)=>{
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        type: entity.type
    }, {
        code: errorCode,
        message: message,
        meta: invalidAttributes
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: false,
        isNodeAttribute: true
    });
};
function $e861220f24467804$export$956325f45c5d174a(nodes, marks, options) {
    const validatorSpecs = $e861220f24467804$var$createSpec(nodes, marks);
    const { mode: mode = 'strict', allowPrivateAttributes: allowPrivateAttributes = false } = options || {};
    const validate = (entity, errorCallback, allowed, parentSpec)=>{
        const validationResult = validateNode(entity, errorCallback, allowed, parentSpec);
        return {
            entity: validationResult.entity,
            valid: validationResult.valid
        };
    };
    const validateNode = (entity, errorCallback, allowed, parentSpec, isMark = false)=>{
        const { type: type } = entity;
        const newEntity = {
            ...entity
        };
        const err = (code, msg, meta)=>{
            const message = $e861220f24467804$var$errorMessageFor(type, msg);
            if (errorCallback) return {
                valid: false,
                entity: errorCallback(newEntity, {
                    code: code,
                    message: message,
                    meta: meta
                }, $e861220f24467804$var$getUnsupportedOptions(parentSpec))
            };
            else throw new Error(message);
        };
        if (type) {
            const typeOptions = $e861220f24467804$var$getOptionsForType(type, allowed);
            if (typeOptions === false) return isMark ? {
                valid: false
            } : err('INVALID_TYPE', 'type not allowed here');
            const spec = validatorSpecs[type];
            if (!spec) return err('INVALID_TYPE', `${type}: No validation spec found for type!`);
            const specBasedValidationResult = specBasedValidationFor(spec, typeOptions, entity, err, newEntity, type, errorCallback, isMark);
            if (specBasedValidationResult.hasValidated && specBasedValidationResult.result) return specBasedValidationResult.result;
        } else return err('INVALID_TYPE', 'ProseMirror Node/Mark should contain a `type`');
        return {
            valid: true,
            entity: newEntity
        };
    };
    return validate;
    function marksValidationFor(validator, entity, errorCallback, newEntity, err) {
        let validationResult;
        if (validator.props && validator.props.marks) {
            const marksSet = allowedMarksFor(validator);
            const marksValidationResult = marksAfterValidation(entity, errorCallback, marksSet, validator);
            validationResult = {
                valid: true,
                entity: newEntity,
                marksValidationOutput: marksValidationResult
            };
        } else validationResult = marksForEntitySpecNotSupportingMarks(entity, newEntity, errorCallback, err);
        return validationResult;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function validatorFor(spec, typeOptions) {
        return {
            ...spec,
            ...typeOptions,
            // options with props can override props of spec
            ...spec.props ? {
                props: {
                    ...spec.props,
                    ...typeOptions['props'] || {}
                }
            } : {}
        };
    }
    function marksAfterValidation(entity, errorCallback, marksSet, validator) {
        return entity.marks ? entity.marks.map((mark)=>{
            const isAKnownMark = marks ? marks.indexOf(mark.type) > -1 : true;
            if (mode === 'strict' && isAKnownMark) {
                const finalResult = validateNode(mark, errorCallback, marksSet, validator, true);
                const finalMark = finalResult.entity;
                if (finalMark) return {
                    valid: true,
                    originalMark: mark,
                    newMark: finalMark
                };
                else if (finalResult.marksValidationOutput && finalResult.marksValidationOutput.length) return {
                    valid: false,
                    originalMark: mark,
                    errorCode: finalResult.marksValidationOutput[0].errorCode,
                    message: finalResult.marksValidationOutput[0].message
                };
                else return {
                    valid: false,
                    originalMark: mark,
                    errorCode: 'INVALID_TYPE'
                };
            } else return {
                valid: false,
                originalMark: mark,
                errorCode: 'INVALID_CONTENT'
            };
        }) : [];
    }
    function allowedMarksFor(validator) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { items: items } = validator.props.marks;
        const marksSet = items.length ? Array.isArray(items[0]) ? items[0] : items : [];
        return marksSet;
    }
    function marksForEntitySpecNotSupportingMarks(prevEntity, newEntity, errorCallback, err) {
        const errorCode = 'REDUNDANT_MARKS';
        const currentMarks = prevEntity.marks || [];
        const newMarks = currentMarks.map((mark)=>{
            const isUnsupportedNodeAttributeMark = mark.type === 'unsupportedNodeAttribute';
            if (isUnsupportedNodeAttributeMark) return mark;
            return $e861220f24467804$var$unsupportedMarkContent(errorCode, mark, errorCallback);
        });
        if (newMarks.length) {
            newEntity.marks = newMarks;
            return {
                valid: true,
                entity: newEntity
            };
        } else return err('REDUNDANT_MARKS', 'redundant marks', {
            marks: Object.keys(currentMarks)
        });
    }
    function requiredPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        if (validatorSpec.required) {
            if (!validatorSpec.required.every((prop)=>(0, $iiazc.isDefined)(prevEntity[prop]))) result = err('MISSING_PROPERTIES', 'required prop missing');
        }
        return result;
    }
    function textPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (validatorSpec.props.text) {
            if ((0, $iiazc.isDefined)(prevEntity.text) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            !$e861220f24467804$export$66c739158ef99a42(validatorSpec.props.text, prevEntity.text)) result = err('INVALID_TEXT', `'text' validation failed`);
        }
        return result;
    }
    function contentLengthValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (validatorSpec.props.content && prevEntity.content) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const { minItems: minItems, maxItems: maxItems } = validatorSpec.props.content;
            const length = prevEntity.content.length;
            if ((0, $iiazc.isDefined)(minItems) && minItems > length) result = err('INVALID_CONTENT_LENGTH', `'content' should have more than ${minItems} child`, {
                length: length,
                requiredLength: minItems,
                type: 'minimum'
            });
            else if ((0, $iiazc.isDefined)(maxItems) && maxItems < length) result = err('INVALID_CONTENT_LENGTH', `'content' should have less than ${maxItems} child`, {
                length: length,
                requiredLength: maxItems,
                type: 'maximum'
            });
        }
        return result;
    }
    function invalidAttributesFor(validatorSpec, prevEntity) {
        let invalidAttrs = [];
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let validatorAttrs = {};
        if (validatorSpec.props && validatorSpec.props.attrs) {
            const attrOptions = (0, $iiazc.makeArray)(validatorSpec.props.attrs);
            /**
			 * Attrs can be union type so try each path
			 * attrs: [{ props: { url: { type: 'string' } } }, { props: { data: {} } }],
			 * Gotcha: It will always report the last failure.
			 */ for(let i = 0, length = attrOptions.length; i < length; ++i){
                const attrOption = attrOptions[i];
                if (attrOption && attrOption.props) [, invalidAttrs] = $e861220f24467804$var$partitionObject(attrOption.props, (key, spec)=>{
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const valueToValidate = prevEntity.attrs[key];
                    return $e861220f24467804$export$66c739158ef99a42(spec, valueToValidate);
                });
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                validatorAttrs = attrOption;
                if (!invalidAttrs.length) break;
            }
        }
        return {
            invalidAttrs: invalidAttrs,
            validatorAttrs: validatorAttrs
        };
    }
    function attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback) {
        const validatorSpecAllowsAttributes = validatorSpec.props && validatorSpec.props.attrs;
        if (prevEntity.attrs) {
            if (!validatorSpecAllowsAttributes) {
                if (isMark) return handleNoAttibutesAllowedInSpecForMark(prevEntity, prevEntity.attrs);
                const attrs = Object.keys(prevEntity.attrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, [], attrs, errorCallback);
            }
            const { hasUnsupportedAttrs: hasUnsupportedAttrs, redundantAttrs: redundantAttrs, invalidAttrs: invalidAttrs } = validateAttributes(validatorSpec, prevEntity, prevEntity.attrs);
            if (hasUnsupportedAttrs) {
                if (isMark) return handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback);
            }
        }
        return {
            valid: true,
            entity: prevEntity
        };
    }
    function validateAttributes(validatorSpec, prevEntity, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attributes) {
        const invalidAttributesResult = invalidAttributesFor(validatorSpec, prevEntity);
        const { invalidAttrs: invalidAttrs } = invalidAttributesResult;
        const validatorAttrs = invalidAttributesResult.validatorAttrs;
        const attrs = Object.keys(attributes).filter((k)=>!(allowPrivateAttributes && k.startsWith('__')));
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const redundantAttrs = attrs.filter((a)=>!validatorAttrs.props[a]);
        const hasRedundantAttrs = redundantAttrs.length > 0;
        const hasUnsupportedAttrs = invalidAttrs.length || hasRedundantAttrs;
        return {
            hasUnsupportedAttrs: hasUnsupportedAttrs,
            invalidAttrs: invalidAttrs,
            redundantAttrs: redundantAttrs
        };
    }
    function handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback) {
        const attr = invalidAttrs.concat(redundantAttrs);
        let result = {
            valid: true,
            entity: prevEntity
        };
        const message = $e861220f24467804$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const errorCode = 'UNSUPPORTED_ATTRIBUTES';
        newEntity.marks = wrapUnSupportedNodeAttributes(prevEntity, newEntity, attr, errorCode, message, errorCallback);
        result = {
            valid: true,
            entity: newEntity
        };
        return result;
    }
    function handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs) {
        let errorCode = 'INVALID_ATTRIBUTES';
        let message = $e861220f24467804$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const hasRedundantAttrs = redundantAttrs.length;
        const hasBothInvalidAndRedundantAttrs = hasRedundantAttrs && invalidAttrs.length;
        if (!hasBothInvalidAndRedundantAttrs && hasRedundantAttrs) {
            errorCode = 'REDUNDANT_ATTRIBUTES';
            message = $e861220f24467804$var$errorMessageFor('redundant attributes found', redundantAttrs.join(', '));
        }
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function handleNoAttibutesAllowedInSpecForMark(prevEntity, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attributes) {
        const message = $e861220f24467804$var$errorMessageFor('redundant attributes found', Object.keys(attributes).join(', '));
        const errorCode = 'REDUNDANT_ATTRIBUTES';
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function wrapUnSupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, errorCode, message, errorCallback) {
        const invalidValues = {};
        // eslint-disable-next-line guard-for-in
        for(const invalidAttr in invalidAttrs){
            invalidValues[invalidAttrs[invalidAttr]] = prevEntity.attrs && prevEntity.attrs[invalidAttrs[invalidAttr]];
            if (newEntity.attrs) delete newEntity.attrs[invalidAttrs[invalidAttr]];
        }
        const unsupportedNodeAttributeValues = $e861220f24467804$var$unsupportedNodeAttributesContent(prevEntity, errorCode, invalidValues, message, errorCallback);
        const finalEntity = {
            ...newEntity
        };
        if (finalEntity.marks) {
            if (!unsupportedNodeAttributeValues) return finalEntity.marks;
            // If there is an existing unsupported node attribute mark, overwrite it to avoid duplicate marks
            const existingMark = finalEntity.marks.find((mark)=>mark.type === unsupportedNodeAttributeValues.type);
            if (existingMark) existingMark.attrs = unsupportedNodeAttributeValues.attrs;
            else finalEntity.marks.push(unsupportedNodeAttributeValues);
            return finalEntity.marks;
        } else return [
            unsupportedNodeAttributeValues
        ];
    }
    function extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type) {
        const result = {
            valid: true,
            entity: prevEntity
        };
        const [requiredProps, redundantProps] = $e861220f24467804$var$partitionObject(prevEntity, (k)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $iiazc.isDefined)(validatorSpec.props[k]));
        if (redundantProps.length) {
            if (mode === 'loose') {
                newEntity = {
                    type: type
                };
                requiredProps.reduce((acc, p)=>(0, $iiazc.copy)(prevEntity, acc, p), newEntity);
            } else {
                if (!((redundantProps.indexOf('marks') > -1 || redundantProps.indexOf('attrs') > -1) && redundantProps.length === 1)) return err('REDUNDANT_PROPERTIES', `redundant props found: ${redundantProps.join(', ')}`, {
                    props: redundantProps
                });
            }
        }
        return result;
    }
    function specBasedValidationFor(spec, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    typeOptions, prevEntity, err, newEntity, type, errorCallback, isMark) {
        const specBasedValidationResult = {
            hasValidated: false
        };
        const validatorSpec = validatorFor(spec, typeOptions);
        if (!validatorSpec) return specBasedValidationResult;
        // Required Props
        // For array format where `required` is an array
        const requiredPropertyValidatonResult = requiredPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!requiredPropertyValidatonResult.valid) return {
            hasValidated: true,
            result: requiredPropertyValidatonResult
        };
        if (!validatorSpec.props) {
            const props = Object.keys(prevEntity);
            // If there's no validator.props then there shouldn't be any key except `type`
            if (props.length > 1) return {
                hasValidated: true,
                result: err('REDUNDANT_PROPERTIES', `redundant props found: ${Object.keys(prevEntity).join(', ')}`, {
                    props: props
                })
            };
            return specBasedValidationResult;
        }
        // Check text
        const textPropertyValidationResult = textPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!textPropertyValidationResult.valid) return {
            hasValidated: true,
            result: textPropertyValidationResult
        };
        // Content Length
        const contentLengthValidationResult = contentLengthValidationFor(validatorSpec, prevEntity, err);
        if (!contentLengthValidationResult.valid) return {
            hasValidated: true,
            result: contentLengthValidationResult
        };
        // Required Props
        // For object format based on `optional` property
        const [, missingProps] = $e861220f24467804$var$partitionObject(validatorSpec.props, (k, v)=>{
            // if the validator is an array, then check
            // if the `required` field contains the key.
            const isOptional = Array.isArray(v) ? !validatorSpec.required?.includes(k) : typeof v === 'object' && v !== null && 'optional' in v ? v.optional : false;
            return isOptional || (0, $iiazc.isDefined)(prevEntity[k]);
        });
        if (missingProps.length) return {
            hasValidated: true,
            result: err('MISSING_PROPERTIES', 'required prop missing', {
                props: missingProps
            })
        };
        const attributesValidationResult = attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback);
        if (!attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        if (isMark && attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        const extraPropsValidationResult = extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type);
        if (!extraPropsValidationResult.valid) return {
            hasValidated: true,
            result: extraPropsValidationResult
        };
        // Children
        if (validatorSpec.props.content) {
            const contentValidatorSpec = validatorSpec.props.content;
            if (prevEntity.content) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const validateChildNode = (child, index)=>{
                    if (child === undefined) return child;
                    const validateChildMarks = (childEntity, marksValidationOutput, errorCallback, isLastValidationSpec, isParentTupleLike = false)=>{
                        let marksAreValid = true;
                        if (childEntity && childEntity.marks && marksValidationOutput) {
                            const validMarks = marksValidationOutput.filter((mark)=>mark.valid);
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            const finalMarks = marksValidationOutput.map((mr)=>{
                                if (mr.valid) return mr.newMark;
                                else {
                                    if (validMarks.length || isLastValidationSpec || isParentTupleLike || mr.errorCode === 'INVALID_TYPE' || mr.errorCode === 'INVALID_CONTENT' || mr.errorCode === 'REDUNDANT_ATTRIBUTES' || mr.errorCode === 'INVALID_ATTRIBUTES') return $e861220f24467804$var$unsupportedMarkContent(// Ignored via go/ees005
                                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                    mr.errorCode, mr.originalMark, errorCallback, mr.message);
                                    return;
                                }
                            }).filter(Boolean);
                            if (finalMarks.length) childEntity.marks = finalMarks;
                            else {
                                delete childEntity.marks;
                                marksAreValid = false;
                            }
                        }
                        return {
                            valid: marksAreValid,
                            entity: childEntity
                        };
                    };
                    const hasMultipleCombinationOfContentAllowed = !!contentValidatorSpec.isTupleLike;
                    if (hasMultipleCombinationOfContentAllowed) {
                        const { entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, (0, $iiazc.makeArray)(contentValidatorSpec.items[index] || contentValidatorSpec.items[contentValidatorSpec.items.length - 1]), validatorSpec);
                        const { entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, false, true);
                        return entity;
                    }
                    // Only go inside valid branch
                    const allowedSpecsForEntity = contentValidatorSpec.items.filter((item)=>Array.isArray(item) ? item.some(// [p, hr, ...] or [p, [text, {}], ...]
                        (spec)=>(Array.isArray(spec) ? spec[0] : spec) === child.type) : true);
                    if (allowedSpecsForEntity.length) {
                        if (allowedSpecsForEntity.length > 1) throw new Error('Consider using Tuple instead!');
                        const maybeArray = (0, $iiazc.makeArray)(allowedSpecsForEntity[0]);
                        const allowedSpecsForChild = maybeArray.filter((item)=>(Array.isArray(item) ? item[0] : item) === child.type);
                        if (allowedSpecsForChild.length === 0) return $e861220f24467804$var$invalidChildContent(child, errorCallback, validatorSpec);
                        /**
						 * When there's multiple possible branches try all of them.
						 * If all of them fails, throw the first one.
						 * e.g.- [['text', { marks: ['a'] }], ['text', { marks: ['b'] }]]
						 */ let firstError;
                        let firstChild;
                        for(let i = 0, len = allowedSpecsForChild.length; i < len; i++)try {
                            const allowedValueForCurrentSpec = [
                                allowedSpecsForChild[i]
                            ];
                            const { valid: valid, entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, allowedValueForCurrentSpec, validatorSpec);
                            if (valid) {
                                const isLastValidationSpec = i === allowedSpecsForChild.length - 1;
                                const { valid: marksAreValid, entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, isLastValidationSpec);
                                const unsupportedMarks = entity && entity.marks && entity.marks.filter((mark)=>mark.type === 'unsupportedMark') || [];
                                if (marksAreValid && !unsupportedMarks.length) return entity;
                                else firstChild = firstChild || newChildEntity;
                            } else firstChild = firstChild || newChildEntity;
                        } catch (error) {
                            firstError = firstError || error;
                        }
                        if (!errorCallback) throw firstError;
                        else return firstChild;
                    } else return $e861220f24467804$var$invalidChildContent(child, errorCallback, validatorSpec);
                };
                newEntity.content = prevEntity.content.map(validateChildNode).filter(Boolean);
            } else if (!contentValidatorSpec.optional) return {
                hasValidated: true,
                result: err('MISSING_PROPERTIES', 'missing `content` prop')
            };
        }
        // Marks
        if (prevEntity.marks) return {
            hasValidated: true,
            result: marksValidationFor(validatorSpec, prevEntity, errorCallback, newEntity, err)
        };
        return specBasedValidationResult;
    }
}

});
parcelRegister("gsiq1", function(module, exports) {

$parcel$export(module.exports, "alignment", () => (parcelRequire("5fjVx")).alignment);
$parcel$export(module.exports, "annotation", () => (parcelRequire("5fjVx")).annotation);
$parcel$export(module.exports, "backgroundColor", () => (parcelRequire("5fjVx")).backgroundColor);
$parcel$export(module.exports, "blockCard", () => (parcelRequire("5fjVx")).blockCard);
$parcel$export(module.exports, "block_content", () => (parcelRequire("5fjVx")).block_content);
$parcel$export(module.exports, "blockRootOnly", () => (parcelRequire("5fjVx")).blockRootOnly);
$parcel$export(module.exports, "blockquote", () => (parcelRequire("5fjVx")).blockquote);
$parcel$export(module.exports, "bodiedExtension", () => (parcelRequire("5fjVx")).bodiedExtension);
$parcel$export(module.exports, "bodiedExtension_with_marks", () => (parcelRequire("5fjVx")).bodiedExtension_with_marks);
$parcel$export(module.exports, "border", () => (parcelRequire("5fjVx")).border);
$parcel$export(module.exports, "breakout", () => (parcelRequire("5fjVx")).breakout);
$parcel$export(module.exports, "bulletList", () => (parcelRequire("5fjVx")).bulletList);
$parcel$export(module.exports, "caption", () => (parcelRequire("5fjVx")).caption);
$parcel$export(module.exports, "code", () => (parcelRequire("5fjVx")).code);
$parcel$export(module.exports, "codeBlock", () => (parcelRequire("5fjVx")).codeBlock);
$parcel$export(module.exports, "codeBlock_root_only", () => (parcelRequire("5fjVx")).codeBlock_root_only);
$parcel$export(module.exports, "text_with_no_marks", () => (parcelRequire("5fjVx")).text_with_no_marks);
$parcel$export(module.exports, "confluenceInlineComment", () => (parcelRequire("5fjVx")).confluenceInlineComment);
$parcel$export(module.exports, "dataConsumer", () => (parcelRequire("5fjVx")).dataConsumer);
$parcel$export(module.exports, "date", () => (parcelRequire("5fjVx")).date);
$parcel$export(module.exports, "decisionItem", () => (parcelRequire("5fjVx")).decisionItem);
$parcel$export(module.exports, "decisionList", () => (parcelRequire("5fjVx")).decisionList);
$parcel$export(module.exports, "doc", () => (parcelRequire("5fjVx")).doc);
$parcel$export(module.exports, "em", () => (parcelRequire("5fjVx")).em);
$parcel$export(module.exports, "embedCard", () => (parcelRequire("5fjVx")).embedCard);
$parcel$export(module.exports, "emoji", () => (parcelRequire("5fjVx")).emoji);
$parcel$export(module.exports, "expand", () => (parcelRequire("5fjVx")).expand);
$parcel$export(module.exports, "expand_root_only", () => (parcelRequire("5fjVx")).expand_root_only);
$parcel$export(module.exports, "extension", () => (parcelRequire("5fjVx")).extension);
$parcel$export(module.exports, "extensionFrame", () => (parcelRequire("5fjVx")).extensionFrame);
$parcel$export(module.exports, "extension_with_marks", () => (parcelRequire("5fjVx")).extension_with_marks);
$parcel$export(module.exports, "fragment", () => (parcelRequire("5fjVx")).fragment);
$parcel$export(module.exports, "hardBreak", () => (parcelRequire("5fjVx")).hardBreak);
$parcel$export(module.exports, "heading", () => (parcelRequire("5fjVx")).heading);
$parcel$export(module.exports, "heading_with_alignment", () => (parcelRequire("5fjVx")).heading_with_alignment);
$parcel$export(module.exports, "heading_with_indentation", () => (parcelRequire("5fjVx")).heading_with_indentation);
$parcel$export(module.exports, "heading_with_no_marks", () => (parcelRequire("5fjVx")).heading_with_no_marks);
$parcel$export(module.exports, "indentation", () => (parcelRequire("5fjVx")).indentation);
$parcel$export(module.exports, "inlineCard", () => (parcelRequire("5fjVx")).inlineCard);
$parcel$export(module.exports, "inlineExtension", () => (parcelRequire("5fjVx")).inlineExtension);
$parcel$export(module.exports, "inlineExtension_with_marks", () => (parcelRequire("5fjVx")).inlineExtension_with_marks);
$parcel$export(module.exports, "inline_content", () => (parcelRequire("5fjVx")).inline_content);
$parcel$export(module.exports, "layoutColumn", () => (parcelRequire("5fjVx")).layoutColumn);
$parcel$export(module.exports, "layoutSection", () => (parcelRequire("5fjVx")).layoutSection);
$parcel$export(module.exports, "layoutSection_full", () => (parcelRequire("5fjVx")).layoutSection_full);
$parcel$export(module.exports, "layoutSection_with_single_column", () => (parcelRequire("5fjVx")).layoutSection_with_single_column);
$parcel$export(module.exports, "link", () => (parcelRequire("5fjVx")).link);
$parcel$export(module.exports, "listItem", () => (parcelRequire("5fjVx")).listItem);
$parcel$export(module.exports, "media", () => (parcelRequire("5fjVx")).media);
$parcel$export(module.exports, "mediaGroup", () => (parcelRequire("5fjVx")).mediaGroup);
$parcel$export(module.exports, "mediaInline", () => (parcelRequire("5fjVx")).mediaInline);
$parcel$export(module.exports, "mediaSingle", () => (parcelRequire("5fjVx")).mediaSingle);
$parcel$export(module.exports, "mediaSingle_caption", () => (parcelRequire("5fjVx")).mediaSingle_caption);
$parcel$export(module.exports, "mediaSingle_full", () => (parcelRequire("5fjVx")).mediaSingle_full);
$parcel$export(module.exports, "mention", () => (parcelRequire("5fjVx")).mention);
$parcel$export(module.exports, "multiBodiedExtension", () => (parcelRequire("5fjVx")).multiBodiedExtension);
$parcel$export(module.exports, "nestedExpand", () => (parcelRequire("5fjVx")).nestedExpand);
$parcel$export(module.exports, "nestedExpand_content", () => (parcelRequire("5fjVx")).nestedExpand_content);
$parcel$export(module.exports, "nestedExpand_with_no_marks", () => (parcelRequire("5fjVx")).nestedExpand_with_no_marks);
$parcel$export(module.exports, "non_nestable_block_content", () => (parcelRequire("5fjVx")).non_nestable_block_content);
$parcel$export(module.exports, "orderedList", () => (parcelRequire("5fjVx")).orderedList);
$parcel$export(module.exports, "panel", () => (parcelRequire("5fjVx")).panel);
$parcel$export(module.exports, "paragraph", () => (parcelRequire("5fjVx")).paragraph);
$parcel$export(module.exports, "paragraph_with_alignment", () => (parcelRequire("5fjVx")).paragraph_with_alignment);
$parcel$export(module.exports, "paragraph_with_indentation", () => (parcelRequire("5fjVx")).paragraph_with_indentation);
$parcel$export(module.exports, "paragraph_with_no_marks", () => (parcelRequire("5fjVx")).paragraph_with_no_marks);
$parcel$export(module.exports, "placeholder", () => (parcelRequire("5fjVx")).placeholder);
$parcel$export(module.exports, "rule", () => (parcelRequire("5fjVx")).rule);
$parcel$export(module.exports, "status", () => (parcelRequire("5fjVx")).status);
$parcel$export(module.exports, "strike", () => (parcelRequire("5fjVx")).strike);
$parcel$export(module.exports, "strong", () => (parcelRequire("5fjVx")).strong);
$parcel$export(module.exports, "subsup", () => (parcelRequire("5fjVx")).subsup);
$parcel$export(module.exports, "table", () => (parcelRequire("5fjVx")).table);
$parcel$export(module.exports, "tableCell", () => (parcelRequire("5fjVx")).tableCell);
$parcel$export(module.exports, "tableHeader", () => (parcelRequire("5fjVx")).tableHeader);
$parcel$export(module.exports, "tableRow", () => (parcelRequire("5fjVx")).tableRow);
$parcel$export(module.exports, "taskItem", () => (parcelRequire("5fjVx")).taskItem);
$parcel$export(module.exports, "taskList", () => (parcelRequire("5fjVx")).taskList);
$parcel$export(module.exports, "text", () => (parcelRequire("5fjVx")).text);
$parcel$export(module.exports, "textColor", () => (parcelRequire("5fjVx")).textColor);
$parcel$export(module.exports, "text_code_inline", () => (parcelRequire("5fjVx")).text_code_inline);
$parcel$export(module.exports, "text_formatted", () => (parcelRequire("5fjVx")).text_formatted);
$parcel$export(module.exports, "text_link_inline", () => (parcelRequire("5fjVx")).text_link_inline);
$parcel$export(module.exports, "underline", () => (parcelRequire("5fjVx")).underline);
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $5fjVx = parcelRequire("5fjVx");

});
parcelRegister("5fjVx", function(module, exports) {

$parcel$export(module.exports, "alignment", () => $3d1dcf8b9eccd1a7$export$8e53000a4ec837);
$parcel$export(module.exports, "annotation", () => $3d1dcf8b9eccd1a7$export$8512c9afa7b24c3b);
$parcel$export(module.exports, "backgroundColor", () => $3d1dcf8b9eccd1a7$export$8c5a050822fd698c);
$parcel$export(module.exports, "block_content", () => $3d1dcf8b9eccd1a7$export$a31afb40076fa18b);
$parcel$export(module.exports, "blockCard", () => $3d1dcf8b9eccd1a7$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockquote", () => $3d1dcf8b9eccd1a7$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockRootOnly", () => $3d1dcf8b9eccd1a7$export$ebb5393736e9ba23);
$parcel$export(module.exports, "bodiedExtension", () => $3d1dcf8b9eccd1a7$export$27903d543b563e39);
$parcel$export(module.exports, "bodiedExtension_with_marks", () => $3d1dcf8b9eccd1a7$export$ee052cc5b2356e83);
$parcel$export(module.exports, "border", () => $3d1dcf8b9eccd1a7$export$1edee58a52776cd9);
$parcel$export(module.exports, "breakout", () => $3d1dcf8b9eccd1a7$export$89015c65f1c75e3f);
$parcel$export(module.exports, "bulletList", () => $3d1dcf8b9eccd1a7$export$a140c94e5ea26bee);
$parcel$export(module.exports, "caption", () => $3d1dcf8b9eccd1a7$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "code", () => $3d1dcf8b9eccd1a7$export$6565f9f03506010b);
$parcel$export(module.exports, "codeBlock", () => $3d1dcf8b9eccd1a7$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "codeBlock_root_only", () => $3d1dcf8b9eccd1a7$export$38d90d1aac6883a3);
$parcel$export(module.exports, "confluenceInlineComment", () => $3d1dcf8b9eccd1a7$export$f3b72f8fc4684ecd);
$parcel$export(module.exports, "dataConsumer", () => $3d1dcf8b9eccd1a7$export$3024f02c495408d6);
$parcel$export(module.exports, "date", () => $3d1dcf8b9eccd1a7$export$324d90190a8b822a);
$parcel$export(module.exports, "decisionItem", () => $3d1dcf8b9eccd1a7$export$6959e16eeff859b4);
$parcel$export(module.exports, "decisionList", () => $3d1dcf8b9eccd1a7$export$62d45a65fb43d95e);
$parcel$export(module.exports, "doc", () => $3d1dcf8b9eccd1a7$export$2a111da947c407d2);
$parcel$export(module.exports, "em", () => $3d1dcf8b9eccd1a7$export$c63c6f932822f543);
$parcel$export(module.exports, "embedCard", () => $3d1dcf8b9eccd1a7$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "emoji", () => $3d1dcf8b9eccd1a7$export$a19185d1233fc4b2);
$parcel$export(module.exports, "expand", () => $3d1dcf8b9eccd1a7$export$9f77e0932fb78f72);
$parcel$export(module.exports, "expand_root_only", () => $3d1dcf8b9eccd1a7$export$b2817c6954dd6d2c);
$parcel$export(module.exports, "extension", () => $3d1dcf8b9eccd1a7$export$1b45514b112dd749);
$parcel$export(module.exports, "extension_with_marks", () => $3d1dcf8b9eccd1a7$export$15be7c145cec614a);
$parcel$export(module.exports, "extensionFrame", () => $3d1dcf8b9eccd1a7$export$4fdcae991fd743e7);
$parcel$export(module.exports, "fragment", () => $3d1dcf8b9eccd1a7$export$f00aeb236b6f05af);
$parcel$export(module.exports, "hardBreak", () => $3d1dcf8b9eccd1a7$export$371da9dd35aba193);
$parcel$export(module.exports, "heading", () => $3d1dcf8b9eccd1a7$export$46e4a324ac90507f);
$parcel$export(module.exports, "heading_with_alignment", () => $3d1dcf8b9eccd1a7$export$c17edf9af655deaf);
$parcel$export(module.exports, "heading_with_indentation", () => $3d1dcf8b9eccd1a7$export$1902f9737466a0dc);
$parcel$export(module.exports, "heading_with_no_marks", () => $3d1dcf8b9eccd1a7$export$7b491e75f1be9278);
$parcel$export(module.exports, "indentation", () => $3d1dcf8b9eccd1a7$export$480c699bd4ec0d86);
$parcel$export(module.exports, "inline_content", () => $3d1dcf8b9eccd1a7$export$e23e6162adaa368d);
$parcel$export(module.exports, "inlineCard", () => $3d1dcf8b9eccd1a7$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineExtension", () => $3d1dcf8b9eccd1a7$export$16b353b2649bd8d9);
$parcel$export(module.exports, "inlineExtension_with_marks", () => $3d1dcf8b9eccd1a7$export$e37f10815f36843d);
$parcel$export(module.exports, "layoutColumn", () => $3d1dcf8b9eccd1a7$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutSection", () => $3d1dcf8b9eccd1a7$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSection_full", () => $3d1dcf8b9eccd1a7$export$941b63fbd931e449);
$parcel$export(module.exports, "layoutSection_with_single_column", () => $3d1dcf8b9eccd1a7$export$e0e9834198e8601d);
$parcel$export(module.exports, "link", () => $3d1dcf8b9eccd1a7$export$9c30223ca0a664fb);
$parcel$export(module.exports, "listItem", () => $3d1dcf8b9eccd1a7$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "media", () => $3d1dcf8b9eccd1a7$export$987d49ffe1b0900f);
$parcel$export(module.exports, "mediaGroup", () => $3d1dcf8b9eccd1a7$export$2855e964765eac9);
$parcel$export(module.exports, "mediaInline", () => $3d1dcf8b9eccd1a7$export$38bab695e3f720f1);
$parcel$export(module.exports, "mediaSingle", () => $3d1dcf8b9eccd1a7$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingle_caption", () => $3d1dcf8b9eccd1a7$export$68b0ead306f9670f);
$parcel$export(module.exports, "mediaSingle_full", () => $3d1dcf8b9eccd1a7$export$f7fd577406abd5f8);
$parcel$export(module.exports, "mention", () => $3d1dcf8b9eccd1a7$export$db83999c14438df4);
$parcel$export(module.exports, "multiBodiedExtension", () => $3d1dcf8b9eccd1a7$export$c3c04d555a8b9013);
$parcel$export(module.exports, "nestedExpand", () => $3d1dcf8b9eccd1a7$export$63cadbf5f4296627);
$parcel$export(module.exports, "nestedExpand_content", () => $3d1dcf8b9eccd1a7$export$9584f52f3ebd5d7e);
$parcel$export(module.exports, "nestedExpand_with_no_marks", () => $3d1dcf8b9eccd1a7$export$b756fc994eb0bc4f);
$parcel$export(module.exports, "non_nestable_block_content", () => $3d1dcf8b9eccd1a7$export$ed866000601e7fa5);
$parcel$export(module.exports, "orderedList", () => $3d1dcf8b9eccd1a7$export$a5dc81035676e7a);
$parcel$export(module.exports, "panel", () => $3d1dcf8b9eccd1a7$export$21f42ab9b6679f44);
$parcel$export(module.exports, "paragraph", () => $3d1dcf8b9eccd1a7$export$9c206ddddb32a9b);
$parcel$export(module.exports, "paragraph_with_alignment", () => $3d1dcf8b9eccd1a7$export$9ca11c06877e5c64);
$parcel$export(module.exports, "paragraph_with_indentation", () => $3d1dcf8b9eccd1a7$export$a3bd66932996fb7d);
$parcel$export(module.exports, "paragraph_with_no_marks", () => $3d1dcf8b9eccd1a7$export$f06f75eb1e56b0c5);
$parcel$export(module.exports, "placeholder", () => $3d1dcf8b9eccd1a7$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "rule", () => $3d1dcf8b9eccd1a7$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "status", () => $3d1dcf8b9eccd1a7$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "strike", () => $3d1dcf8b9eccd1a7$export$4899a95d70ec5056);
$parcel$export(module.exports, "strong", () => $3d1dcf8b9eccd1a7$export$59ae2c325a998f89);
$parcel$export(module.exports, "subsup", () => $3d1dcf8b9eccd1a7$export$b3401ee80eb31041);
$parcel$export(module.exports, "table", () => $3d1dcf8b9eccd1a7$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableCell", () => $3d1dcf8b9eccd1a7$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "tableHeader", () => $3d1dcf8b9eccd1a7$export$48884d2a5190dc73);
$parcel$export(module.exports, "tableRow", () => $3d1dcf8b9eccd1a7$export$ce666bf02318c957);
$parcel$export(module.exports, "taskItem", () => $3d1dcf8b9eccd1a7$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "taskList", () => $3d1dcf8b9eccd1a7$export$375b6afcc5f4d291);
$parcel$export(module.exports, "text", () => $3d1dcf8b9eccd1a7$export$6f093cfa640b7166);
$parcel$export(module.exports, "text_code_inline", () => $3d1dcf8b9eccd1a7$export$5008c13f04d544f6);
$parcel$export(module.exports, "text_formatted", () => $3d1dcf8b9eccd1a7$export$d24a7becb4e0da7c);
$parcel$export(module.exports, "text_link_inline", () => $3d1dcf8b9eccd1a7$export$2a9d18d5b3064e6c);
$parcel$export(module.exports, "text_with_no_marks", () => $3d1dcf8b9eccd1a7$export$437a3d96346717e0);
$parcel$export(module.exports, "textColor", () => $3d1dcf8b9eccd1a7$export$32f78bffcd82ff28);
$parcel$export(module.exports, "underline", () => $3d1dcf8b9eccd1a7$export$425327af25286e5e);
const $3d1dcf8b9eccd1a7$export$8e53000a4ec837 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'alignment'
            ]
        },
        attrs: {
            props: {
                align: {
                    type: 'enum',
                    values: [
                        'center',
                        'end'
                    ]
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$8512c9afa7b24c3b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'annotation'
            ]
        },
        attrs: {
            props: {
                id: {
                    type: 'string'
                },
                annotationType: {
                    type: 'enum',
                    values: [
                        'inlineComment'
                    ]
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$8c5a050822fd698c = {
    props: {
        type: {
            type: 'enum',
            values: [
                'backgroundColor'
            ]
        },
        attrs: {
            props: {
                color: {
                    pattern: '^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$a31afb40076fa18b = [
    'blockCard',
    'paragraph_with_no_marks',
    'paragraph_with_alignment',
    'paragraph_with_indentation',
    'mediaSingle_caption',
    'mediaSingle_full',
    'codeBlock',
    'taskList',
    'bulletList',
    'orderedList',
    'heading_with_no_marks',
    'heading_with_alignment',
    'heading_with_indentation',
    'mediaGroup',
    'decisionList',
    'rule',
    'panel',
    'blockquote',
    'extension_with_marks',
    'embedCard',
    'table',
    'expand',
    'bodiedExtension_with_marks'
];
const $3d1dcf8b9eccd1a7$export$c4c2f833baaebdb8 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'blockCard'
            ]
        },
        attrs: [
            {
                props: {
                    url: {
                        type: 'string',
                        optional: true,
                        validatorFn: 'safeUrl'
                    },
                    datasource: {
                        props: {
                            id: {
                                type: 'string'
                            },
                            parameters: {
                                type: 'object'
                            },
                            views: {
                                items: [
                                    {
                                        props: {
                                            properties: {
                                                optional: true,
                                                type: 'object'
                                            },
                                            type: {
                                                type: 'string'
                                            }
                                        }
                                    }
                                ],
                                minItems: 1,
                                type: 'array'
                            }
                        }
                    },
                    width: {
                        type: 'number',
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ],
                        optional: true
                    }
                }
            },
            {
                props: {
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    }
                }
            }
        ]
    },
    required: [
        'attrs'
    ]
};
const $3d1dcf8b9eccd1a7$export$67dc04e652a298ca = {
    props: {
        type: {
            type: 'enum',
            values: [
                'blockquote'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'orderedList',
                    'bulletList',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$ebb5393736e9ba23 = [
    'multiBodiedExtension'
];
const $3d1dcf8b9eccd1a7$export$27903d543b563e39 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'bodiedExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'non_nestable_block_content'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$ee052cc5b2356e83 = [
    'bodiedExtension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$1edee58a52776cd9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'border'
            ]
        },
        attrs: {
            props: {
                size: {
                    type: 'number',
                    minimum: 1,
                    maximum: 3
                },
                color: {
                    pattern: '^#[0-9a-fA-F]{8}$|^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$89015c65f1c75e3f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'breakout'
            ]
        },
        attrs: {
            props: {
                mode: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width'
                    ]
                },
                width: {
                    type: 'number',
                    optional: true
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$a140c94e5ea26bee = {
    props: {
        type: {
            type: 'enum',
            values: [
                'bulletList'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'listItem',
                    'listItem_with_nested_decision'
                ]
            ],
            minItems: 1
        }
    }
};
const $3d1dcf8b9eccd1a7$export$8e3c2dfdc4f0453d = {
    props: {
        type: {
            type: 'enum',
            values: [
                'caption'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'hardBreak',
                    'mention',
                    'emoji',
                    'date',
                    'placeholder',
                    'inlineCard',
                    'status',
                    'text_formatted',
                    'text_code_inline'
                ]
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$6565f9f03506010b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'code'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$7bb0d5c671655cc4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'codeBlock'
            ]
        },
        attrs: {
            props: {
                language: {
                    type: 'string',
                    optional: true
                },
                uniqueId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'text_with_no_marks'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$38d90d1aac6883a3 = [
    'codeBlock',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$f3b72f8fc4684ecd = {
    props: {
        type: {
            type: 'enum',
            values: [
                'confluenceInlineComment'
            ]
        },
        attrs: {
            props: {
                reference: {
                    type: 'string'
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$3024f02c495408d6 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'dataConsumer'
            ]
        },
        attrs: {
            props: {
                sources: {
                    type: 'array',
                    items: [
                        {
                            type: 'string'
                        }
                    ],
                    minItems: 1
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$324d90190a8b822a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'date'
            ]
        },
        attrs: {
            props: {
                timestamp: {
                    minLength: 1,
                    type: 'string'
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$6959e16eeff859b4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'decisionItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$62d45a65fb43d95e = {
    props: {
        type: {
            type: 'enum',
            values: [
                'decisionList'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'decisionItem'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$2a111da947c407d2 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'doc'
            ]
        },
        version: {
            type: 'enum',
            values: [
                1
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'blockCard',
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'paragraph_with_indentation',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'bulletList',
                    'orderedList',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'mediaGroup',
                    'decisionList',
                    'rule',
                    'panel',
                    'blockquote',
                    'extension_with_marks',
                    'embedCard',
                    'table',
                    'expand',
                    'bodiedExtension_with_marks',
                    'codeBlock_root_only',
                    'layoutSection_with_single_column',
                    'layoutSection_full',
                    'multiBodiedExtension',
                    'expand_root_only'
                ]
            ],
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$c63c6f932822f543 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'em'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$be4283d9a1cb1ff6 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'embedCard'
            ]
        },
        attrs: {
            props: {
                url: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'wrap-right',
                        'wrap-left',
                        'align-end',
                        'align-start'
                    ]
                },
                width: {
                    type: 'number',
                    maximum: 100,
                    minimum: 0,
                    optional: true
                },
                originalHeight: {
                    type: 'number',
                    optional: true
                },
                originalWidth: {
                    type: 'number',
                    optional: true
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$a19185d1233fc4b2 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'emoji'
            ]
        },
        attrs: {
            props: {
                shortName: {
                    type: 'string'
                },
                id: {
                    type: 'string',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$9f77e0932fb78f72 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'expand'
            ]
        },
        attrs: {
            props: {
                title: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'codeBlock',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'decisionList',
                    'taskList',
                    'table',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$b2817c6954dd6d2c = [
    'expand',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$1b45514b112dd749 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'extension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$15be7c145cec614a = [
    'extension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$4fdcae991fd743e7 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'extensionFrame'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'codeBlock',
                    'mediaGroup',
                    'mediaSingle_full',
                    'mediaSingle_caption',
                    'decisionList',
                    'taskList',
                    'table',
                    'extension_with_marks',
                    'bodiedExtension_with_marks',
                    'blockCard',
                    'embedCard'
                ]
            ],
            minItems: 1
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'dataConsumer',
                    'fragment'
                ]
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$f00aeb236b6f05af = {
    props: {
        type: {
            type: 'enum',
            values: [
                'fragment'
            ]
        },
        attrs: {
            props: {
                localId: {
                    minLength: 1,
                    type: 'string'
                },
                name: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$371da9dd35aba193 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'hardBreak'
            ]
        },
        attrs: {
            props: {
                text: {
                    type: 'enum',
                    values: [
                        '\n'
                    ],
                    optional: true
                }
            },
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$46e4a324ac90507f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'heading'
            ]
        },
        attrs: {
            props: {
                level: {
                    type: 'number',
                    minimum: 1,
                    maximum: 6
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$c17edf9af655deaf = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'alignment'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$1902f9737466a0dc = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'indentation'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$7b491e75f1be9278 = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$480c699bd4ec0d86 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'indentation'
            ]
        },
        attrs: {
            props: {
                level: {
                    type: 'number',
                    minimum: 1,
                    maximum: 6
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$e23e6162adaa368d = [
    'text_formatted',
    'text_code_inline',
    'date',
    'emoji',
    'hardBreak',
    'inlineCard',
    'mention',
    'placeholder',
    'status',
    'inlineExtension_with_marks',
    'mediaInline'
];
const $3d1dcf8b9eccd1a7$export$cbf8224b64e0d942 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'inlineCard'
            ]
        },
        attrs: [
            {
                props: {
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $3d1dcf8b9eccd1a7$export$16b353b2649bd8d9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'inlineExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$e37f10815f36843d = [
    'inlineExtension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$ab76e7c03cd6f650 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'layoutColumn'
            ]
        },
        attrs: {
            props: {
                width: {
                    type: 'number',
                    minimum: 0,
                    maximum: 100
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'block_content'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$b3b6a70a7fa4a5be = {
    props: {
        type: {
            type: 'enum',
            values: [
                'layoutSection'
            ]
        },
        content: {
            type: 'array',
            items: [
                'layoutColumn'
            ],
            minItems: 1,
            maxItems: 3,
            allowUnsupportedBlock: true
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'breakout'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$941b63fbd931e449 = [
    'layoutSection',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'layoutColumn'
                ],
                minItems: 2,
                maxItems: 3,
                allowUnsupportedBlock: true
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$e0e9834198e8601d = [
    'layoutSection',
    {
        props: {
            attrs: {
                props: {
                    columnRuleStyle: {
                        type: 'enum',
                        values: [
                            'solid'
                        ],
                        optional: true
                    }
                },
                optional: true
            },
            content: {
                type: 'array',
                items: [
                    'layoutColumn'
                ],
                minItems: 1,
                maxItems: 5,
                allowUnsupportedBlock: true
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$9c30223ca0a664fb = {
    props: {
        type: {
            type: 'enum',
            values: [
                'link'
            ]
        },
        attrs: {
            props: {
                href: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                title: {
                    type: 'string',
                    optional: true
                },
                id: {
                    type: 'string',
                    optional: true
                },
                collection: {
                    type: 'string',
                    optional: true
                },
                occurrenceKey: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$76c7e83ecc9cdf05 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'listItem'
            ]
        },
        content: {
            type: 'array',
            isTupleLike: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'extension_with_marks'
                ],
                [
                    'paragraph_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'taskList',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$2b82905b9aebbab0 = [
    'listItem',
    {
        props: {
            content: {
                type: 'array',
                isTupleLike: true,
                items: [
                    [
                        'paragraph_with_no_marks',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock',
                        'decisionList',
                        'extension_with_marks'
                    ],
                    [
                        'paragraph_with_no_marks',
                        'bulletList',
                        'orderedList',
                        'taskList',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock',
                        'decisionList',
                        'extension_with_marks'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$987d49ffe1b0900f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'media'
            ]
        },
        attrs: [
            {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'link',
                            'file'
                        ]
                    },
                    id: {
                        minLength: 1,
                        type: 'string'
                    },
                    alt: {
                        type: 'string',
                        optional: true
                    },
                    collection: {
                        type: 'string'
                    },
                    height: {
                        type: 'number',
                        optional: true
                    },
                    occurrenceKey: {
                        minLength: 1,
                        type: 'string',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    }
                }
            },
            {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'external'
                        ]
                    },
                    alt: {
                        type: 'string',
                        optional: true
                    },
                    height: {
                        type: 'number',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    },
                    url: {
                        type: 'string'
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'link',
                    'annotation',
                    'border'
                ]
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $3d1dcf8b9eccd1a7$export$2855e964765eac9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaGroup'
            ]
        },
        content: {
            type: 'array',
            items: [
                'media'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$38bab695e3f720f1 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaInline'
            ]
        },
        attrs: {
            props: {
                type: {
                    type: 'enum',
                    values: [
                        'link',
                        'file',
                        'image'
                    ],
                    optional: true
                },
                url: {
                    type: 'string',
                    optional: true
                },
                id: {
                    minLength: 1,
                    type: 'string'
                },
                alt: {
                    type: 'string',
                    optional: true
                },
                collection: {
                    type: 'string'
                },
                occurrenceKey: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                },
                width: {
                    type: 'number',
                    optional: true
                },
                height: {
                    type: 'number',
                    optional: true
                },
                data: {
                    type: 'object',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'link',
                    'annotation',
                    'border'
                ]
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$969fe3781ca15058 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaSingle'
            ]
        },
        attrs: [
            {
                props: {
                    width: {
                        type: 'number',
                        minimum: 0,
                        maximum: 100,
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    },
                    widthType: {
                        type: 'enum',
                        values: [
                            'percentage'
                        ],
                        optional: true
                    }
                }
            },
            {
                props: {
                    width: {
                        type: 'number',
                        minimum: 0
                    },
                    widthType: {
                        type: 'enum',
                        values: [
                            'pixel'
                        ]
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                'link'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$68b0ead306f9670f = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                isTupleLike: true,
                items: [
                    'media',
                    'caption'
                ],
                minItems: 1,
                maxItems: 2,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$f7fd577406abd5f8 = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'media'
                ],
                minItems: 1,
                maxItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$af10954ff7b86f88 = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'media'
                ],
                minItems: 1,
                maxItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$db83999c14438df4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mention'
            ]
        },
        attrs: {
            props: {
                id: {
                    type: 'string'
                },
                localId: {
                    type: 'string',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                accessLevel: {
                    type: 'string',
                    optional: true
                },
                userType: {
                    type: 'enum',
                    values: [
                        'DEFAULT',
                        'SPECIAL',
                        'APP'
                    ],
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$c3c04d555a8b9013 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'multiBodiedExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    type: 'string',
                    minLength: 1
                },
                extensionType: {
                    type: 'string',
                    minLength: 1
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'default',
                        'wide',
                        'full-width'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true,
                    minLength: 1
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'extensionFrame'
            ]
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$63cadbf5f4296627 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'nestedExpand'
            ]
        },
        attrs: {
            props: {
                title: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: 'nestedExpand_content'
    },
    required: [
        'content'
    ]
};
const $3d1dcf8b9eccd1a7$export$9584f52f3ebd5d7e = {
    type: 'array',
    items: [
        [
            'paragraph_with_no_marks',
            'heading_with_no_marks',
            'mediaSingle_caption',
            'mediaSingle_full',
            'mediaGroup',
            'codeBlock',
            'bulletList',
            'orderedList',
            'taskList',
            'decisionList',
            'rule',
            'panel',
            'blockquote',
            'extension_with_marks'
        ]
    ],
    minItems: 1,
    allowUnsupportedBlock: true
};
const $3d1dcf8b9eccd1a7$export$b756fc994eb0bc4f = [
    'nestedExpand',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$ed866000601e7fa5 = [
    'paragraph_with_no_marks',
    'panel',
    'blockquote',
    'orderedList',
    'bulletList',
    'rule',
    'heading_with_no_marks',
    'codeBlock',
    'mediaGroup',
    'mediaSingle_caption',
    'mediaSingle_full',
    'decisionList',
    'taskList',
    'table',
    'blockCard',
    'embedCard',
    'extension_with_marks'
];
const $3d1dcf8b9eccd1a7$export$a5dc81035676e7a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'orderedList'
            ]
        },
        attrs: {
            props: {
                order: {
                    type: 'number',
                    minimum: 0,
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'listItem',
                    'listItem_with_nested_decision'
                ]
            ],
            minItems: 1
        }
    }
};
const $3d1dcf8b9eccd1a7$export$21f42ab9b6679f44 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'panel'
            ]
        },
        attrs: {
            props: {
                panelType: {
                    type: 'enum',
                    values: [
                        'info',
                        'note',
                        'tip',
                        'warning',
                        'error',
                        'success',
                        'custom'
                    ]
                },
                panelIcon: {
                    type: 'string',
                    optional: true
                },
                panelIconId: {
                    type: 'string',
                    optional: true
                },
                panelIconText: {
                    type: 'string',
                    optional: true
                },
                panelColor: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'heading_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'blockCard',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'rule',
                    'decisionList',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$9c206ddddb32a9b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'paragraph'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$9ca11c06877e5c64 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'alignment'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$a3bd66932996fb7d = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'indentation'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$f06f75eb1e56b0c5 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$c7187bbd1a7a9244 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'placeholder'
            ]
        },
        attrs: {
            props: {
                text: {
                    type: 'string'
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$fbeb3a3956e8a3c7 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'rule'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$471f7ae5c4103ae1 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'status'
            ]
        },
        attrs: {
            props: {
                text: {
                    minLength: 1,
                    type: 'string'
                },
                color: {
                    type: 'enum',
                    values: [
                        'neutral',
                        'purple',
                        'blue',
                        'red',
                        'yellow',
                        'green'
                    ]
                },
                localId: {
                    type: 'string',
                    optional: true
                },
                style: {
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$4899a95d70ec5056 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strike'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$59ae2c325a998f89 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strong'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$b3401ee80eb31041 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'subsup'
            ]
        },
        attrs: {
            props: {
                type: {
                    type: 'enum',
                    values: [
                        'sub',
                        'sup'
                    ]
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$9852986a3ec5f6a0 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'table'
            ]
        },
        attrs: {
            props: {
                displayMode: {
                    type: 'enum',
                    values: [
                        'default',
                        'fixed'
                    ],
                    optional: true
                },
                isNumberColumnEnabled: {
                    type: 'boolean',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'align-end',
                        'align-start',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    minLength: 1,
                    optional: true
                },
                width: {
                    type: 'number',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'tableRow'
            ],
            minItems: 1
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'fragment'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$e1e720e5f4603e6a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableCell'
            ]
        },
        attrs: {
            props: {
                colspan: {
                    type: 'number',
                    optional: true
                },
                rowspan: {
                    type: 'number',
                    optional: true
                },
                colwidth: {
                    type: 'array',
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true
                },
                background: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'decisionList',
                    'taskList',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    },
    required: [
        'content'
    ]
};
const $3d1dcf8b9eccd1a7$export$48884d2a5190dc73 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableHeader'
            ]
        },
        attrs: {
            props: {
                colspan: {
                    type: 'number',
                    optional: true
                },
                rowspan: {
                    type: 'number',
                    optional: true
                },
                colwidth: {
                    type: 'array',
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true
                },
                background: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'decisionList',
                    'taskList',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks',
                    'nestedExpand'
                ]
            ],
            minItems: 1
        }
    },
    required: [
        'content'
    ]
};
const $3d1dcf8b9eccd1a7$export$ce666bf02318c957 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableRow'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'tableCell',
                    'tableHeader'
                ]
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$6d8b0ef52e2e6390 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'taskItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'enum',
                    values: [
                        'TODO',
                        'DONE'
                    ]
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$375b6afcc5f4d291 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'taskList'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            isTupleLike: true,
            items: [
                'taskItem',
                [
                    'taskItem',
                    'taskList'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$6f093cfa640b7166 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'text'
            ]
        },
        text: {
            type: 'string',
            minLength: 1
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$5008c13f04d544f6 = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'code',
                        'link',
                        'annotation'
                    ]
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$d24a7becb4e0da7c = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'link',
                        'em',
                        'strong',
                        'strike',
                        'subsup',
                        'underline',
                        'textColor',
                        'annotation',
                        'backgroundColor',
                        null
                    ]
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$2a9d18d5b3064e6c = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'link'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$437a3d96346717e0 = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$32f78bffcd82ff28 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'textColor'
            ]
        },
        attrs: {
            props: {
                color: {
                    type: 'string',
                    pattern: '^#[0-9a-fA-F]{6}$'
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$425327af25286e5e = {
    props: {
        type: {
            type: 'enum',
            values: [
                'underline'
            ]
        }
    }
};

});


parcelRegister("iiazc", function(module, exports) {

$parcel$export(module.exports, "isDefined", () => $2c8456da404b8e3f$export$4e62c701997796c1);
$parcel$export(module.exports, "isNumber", () => $2c8456da404b8e3f$export$7e4aa119212bc614);
$parcel$export(module.exports, "isInteger", () => $2c8456da404b8e3f$export$a287f47fed4544b8);
$parcel$export(module.exports, "isBoolean", () => $2c8456da404b8e3f$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "isString", () => $2c8456da404b8e3f$export$844ec244b1367d54);
$parcel$export(module.exports, "isPlainObject", () => $2c8456da404b8e3f$export$53b83ca8eaab0383);
$parcel$export(module.exports, "copy", () => $2c8456da404b8e3f$export$784d13d8ee351f07);
$parcel$export(module.exports, "makeArray", () => $2c8456da404b8e3f$export$7b85fd78dd236198);
const $2c8456da404b8e3f$export$4e62c701997796c1 = (x)=>x != null;
const $2c8456da404b8e3f$export$7e4aa119212bc614 = (x)=>typeof x === 'number' && !isNaN(x) && isFinite(x);
const $2c8456da404b8e3f$export$a287f47fed4544b8 = (x)=>typeof x === 'number' && isFinite(x) && Math.floor(x) === x;
const $2c8456da404b8e3f$export$f9ce7b637dfbe238 = (x)=>x === true || x === false || toString.call(x) === '[object Boolean]';
const $2c8456da404b8e3f$export$844ec244b1367d54 = (s)=>typeof s === 'string' || s instanceof String;
const $2c8456da404b8e3f$export$53b83ca8eaab0383 = (x)=>typeof x === 'object' && x !== null && !Array.isArray(x);
const $2c8456da404b8e3f$export$784d13d8ee351f07 = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
source, dest, key)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dest[key] = source[key];
    return dest;
};
const $2c8456da404b8e3f$export$7b85fd78dd236198 = (maybeArray)=>Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];

});

parcelRegister("1H4Aw", function(module, exports) {

$parcel$export(module.exports, "validatorFnMap", () => $608e35270d0ca1e8$export$d1b377ca77ac267d);

var $iZOJ9 = parcelRequire("iZOJ9");
const $608e35270d0ca1e8$export$d1b377ca77ac267d = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    safeUrl: (0, $iZOJ9.isSafeUrl)
};

});



parcelRegister("1cjf7", function(module, exports) {

$parcel$export(module.exports, "trackUnsupportedContentLevels", () => $dad344c5873159ce$export$a43de96edd8d0a0);

var $4NUlu = parcelRequire("4NUlu");
var $2KwKW = parcelRequire("2KwKW");

var $gkwXh = parcelRequire("gkwXh");

var $knXBU = parcelRequire("knXBU");
const $dad344c5873159ce$var$rendersMap = {};
const $dad344c5873159ce$var$processLevelsAndTrack = (item, thresholds, dispatchAnalyticsEvent)=>{
    try {
        const { severity: severity, percentage: percentage, counts: { supportedNodes: supportedNodes, unsupportedNodes: unsupportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } } = (0, $2KwKW.getUnsupportedContentLevelData)(item.doc, thresholds);
        dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
            attributes: {
                appearance: (0, $4NUlu.getAnalyticsAppearance)(item.appearance),
                platform: (0, $knXBU.PLATFORM).WEB,
                unsupportedContentLevelSeverity: severity,
                unsupportedContentLevelPercentage: percentage,
                unsupportedNodesCount: unsupportedNodes,
                supportedNodesCount: supportedNodes,
                unsupportedNodeTypeCount: unsupportedNodeTypeCount
            },
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        });
    } catch (err) {
        dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $knXBU.PLATFORM).WEB,
                error: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        });
    }
};
const $dad344c5873159ce$var$schedule = (fn)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (typeof window.requestIdleCallback === 'function') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.requestIdleCallback(fn);
    else setTimeout(fn, 0);
};
const $dad344c5873159ce$var$DEFAULT_SAMPLING_RATE = 100;
const $dad344c5873159ce$export$a43de96edd8d0a0 = (item, trackingOptions, dispatchAnalyticsEvent)=>{
    const { thresholds: thresholds, samplingRates: samplingRates } = trackingOptions;
    const appearance = item.appearance ?? 'unknown';
    if (!$dad344c5873159ce$var$rendersMap[appearance]) $dad344c5873159ce$var$rendersMap[appearance] = new Set();
    // bail out if already processed a render from a given renderer instance
    const didProcessRenderer = $dad344c5873159ce$var$rendersMap[appearance].has(item.rendererId);
    if (didProcessRenderer) return;
    // otherwise track the render
    $dad344c5873159ce$var$rendersMap[appearance].add(item.rendererId);
    const sampleRate = samplingRates && samplingRates[appearance] || $dad344c5873159ce$var$DEFAULT_SAMPLING_RATE;
    // sample from the first available tracked render
    if ($dad344c5873159ce$var$rendersMap[appearance].size === 1) $dad344c5873159ce$var$schedule(()=>$dad344c5873159ce$var$processLevelsAndTrack(item, thresholds, dispatchAnalyticsEvent));
    // cleanup/refresh tracked renders at the sampling rate
    if ($dad344c5873159ce$var$rendersMap[appearance].size % sampleRate === 0) $dad344c5873159ce$var$rendersMap[appearance] = new Set();
};

});
parcelRegister("2KwKW", function(module, exports) {

$parcel$export(module.exports, "getUnsupportedContentLevelData", () => $4210b4deee40727f$export$484b83e0462998d);

var $l1C1k = parcelRequire("l1C1k");
var $4210b4deee40727f$export$6632e71a22d31bf1 = /*#__PURE__*/ function(UNSUPPORTED_CONTENT_LEVEL_SEVERITY) {
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["NORMAL"] = "normal";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["DEGRADED"] = "degraded";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["BLOCKING"] = "blocking";
    return UNSUPPORTED_CONTENT_LEVEL_SEVERITY;
}({});
const $4210b4deee40727f$export$f9f8a29778652c3e = {
    DEGRADED: 10,
    BLOCKING: 25
};
const $4210b4deee40727f$var$buildUnsupportedContentLevelThresholds = (customThresholds)=>{
    return {
        degraded: customThresholds?.degraded || $4210b4deee40727f$export$f9f8a29778652c3e.DEGRADED,
        blocking: customThresholds?.blocking || $4210b4deee40727f$export$f9f8a29778652c3e.BLOCKING
    };
};
const $4210b4deee40727f$var$countSupportedUnsupportedNodes = (validDocument)=>{
    let unsupportedNodes = 0;
    let supportedNodes = 0;
    const unsupportedNodeTypeCount = {};
    const unsupportedNodeTypes = [
        'unsupportedInline',
        'unsupportedBlock',
        'confluenceUnsupportedInline',
        'confluenceUnsupportedBlock'
    ];
    (0, $l1C1k.traverse)(validDocument, {
        any: (node)=>{
            if (unsupportedNodeTypes.includes(node.type)) {
                const originalNode = node.attrs?.originalValue;
                if (originalNode) // start an independent traversal for the purpose of counting
                // unsupported content nodes (with nested children contributing towards
                // that count)
                (0, $l1C1k.traverse)(originalNode, {
                    any: (unsupportedNode, parent)=>{
                        unsupportedNodes++;
                        // Count the types of unsupported nodes
                        const parentType = parent.parent?.node?.type ?? 'unknown';
                        const type = `${parentType}/${unsupportedNode?.type ?? 'unknown'}`;
                        unsupportedNodeTypeCount[type] = (unsupportedNodeTypeCount?.[type] ?? 0) + 1;
                    }
                });
                // force the parent traversal (which is counting supported content nodes)
                // to skip traversal/counting of nested children of the unsupported nodes
                return false;
            } else supportedNodes++;
        }
    });
    return {
        unsupportedNodes: unsupportedNodes,
        supportedNodes: supportedNodes,
        unsupportedNodeTypeCount: unsupportedNodeTypeCount
    };
};
const $4210b4deee40727f$var$mapUnsupportedContentLevelToSeverity = (unsupportedContentLevelPercent, thresholds)=>{
    if (thresholds.degraded <= unsupportedContentLevelPercent && unsupportedContentLevelPercent < thresholds.blocking) return "degraded";
    if (thresholds.blocking <= unsupportedContentLevelPercent) return "blocking";
    return "normal";
};
const $4210b4deee40727f$export$484b83e0462998d = (validDocument, customThresholds)=>{
    const { unsupportedNodes: unsupportedNodes, supportedNodes: supportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } = $4210b4deee40727f$var$countSupportedUnsupportedNodes(validDocument);
    const thresholds = $4210b4deee40727f$var$buildUnsupportedContentLevelThresholds(customThresholds);
    const percentage = Math.round(unsupportedNodes / (unsupportedNodes + supportedNodes) * 100);
    const severity = $4210b4deee40727f$var$mapUnsupportedContentLevelToSeverity(percentage, thresholds);
    return {
        severity: severity,
        percentage: percentage,
        counts: {
            supportedNodes: supportedNodes,
            unsupportedNodes: unsupportedNodes,
            unsupportedNodeTypeCount: unsupportedNodeTypeCount
        }
    };
};

});


parcelRegister("kgV4b", function(module, exports) {

$parcel$export(module.exports, "countNodes", () => $7ac8dee2b321f8fd$export$1daf15cbaf649dad);

var $3Y1bF = parcelRequire("3Y1bF");
function $7ac8dee2b321f8fd$export$1daf15cbaf649dad(adfDocument) {
    return (0, $3Y1bF.reduce)(adfDocument, (acc, node)=>{
        acc[node.type] = (acc[node.type] || 0) + 1;
        return acc;
    }, {});
}

});
parcelRegister("3Y1bF", function(module, exports) {

$parcel$export(module.exports, "reduce", () => $de5bae64a9d3f36e$export$533b26079ad0b4b);

var $l1C1k = parcelRequire("l1C1k");
function $de5bae64a9d3f36e$export$533b26079ad0b4b(adf, callback, initial) {
    let result = initial;
    (0, $l1C1k.traverse)(adf, {
        any: (node)=>{
            result = callback(result, node);
        }
    });
    return result;
}

});



parcelRegister("1urn6", function(module, exports) {

$parcel$export(module.exports, "EditorMediaClientProvider", () => $d9518b7b87f036fd$export$77218b6ff680865f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $85xkt = parcelRequire("85xkt");
var $cEHh7 = parcelRequire("cEHh7");

var $9S8fM = parcelRequire("9S8fM");
const $d9518b7b87f036fd$export$77218b6ff680865f = ({ children: children, ssr: ssr })=>{
    const [mediaClientConfig, setMediaClientConfig] = (0, $5uXOq.useState)();
    const mediaProvider = (0, $9S8fM.useProviderLayout)('mediaProvider');
    /**
	 * If a mediaClientConfig is provided then we will force
	 * skip the mediaClient from context
	 */ const shouldSkipContext = Boolean(ssr?.config || mediaProvider);
    const contextMediaClient = (0, $5uXOq.useContext)((0, $cEHh7.MediaClientContext));
    // MediaClientProvider currently requires a mediaClientConfig
    // And inserting the MediaClientProvider will cause a re-render
    // We should use MediaClientProvider once it no longer requires a config
    const mediaClient = (0, $5uXOq.useMemo)(()=>mediaClientConfig ? (0, $85xkt.getMediaClient)(mediaClientConfig) : undefined, [
        mediaClientConfig
    ]);
    // Consumers can override the mediaClient for renderer,
    // by not providing both SSR config and mediaProvider,
    // and provide a top level mediaClient context
    // This is useful for testing and creating examples.
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (ssr?.config) setMediaClientConfig(ssr.config);
        else if (mediaProvider) mediaProvider.then((provider)=>{
            setMediaClientConfig(provider.viewMediaClientConfig);
        });
    }, [
        mediaProvider,
        ssr
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cEHh7.MediaClientContext).Provider, {
        value: shouldSkipContext ? mediaClient : contextMediaClient,
        children: children
    });
};

});
parcelRegister("cEHh7", function(module, exports) {

$parcel$export(module.exports, "MediaClientContext", () => $2a03c62fd3cc05ea$export$ba5d7212f2b4619f);
$parcel$export(module.exports, "MediaClientProvider", () => $2a03c62fd3cc05ea$export$5bff351c86f56d97);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $85xkt = parcelRequire("85xkt");
const $2a03c62fd3cc05ea$export$ba5d7212f2b4619f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(undefined);
const $2a03c62fd3cc05ea$export$5bff351c86f56d97 = ({ children: children, clientConfig: clientConfig })=>{
    const mediaClient = (0, $5uXOq.useMemo)(()=>(0, $85xkt.getMediaClient)(clientConfig), [
        clientConfig
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($2a03c62fd3cc05ea$export$ba5d7212f2b4619f.Provider, {
        value: mediaClient,
        children: children
    });
};

});


parcelRegister("1pTqN", function(module, exports) {

$parcel$export(module.exports, "ActiveHeaderIdProvider", () => $ae2d04c26b960a03$export$20439b49fdd0d26c);
$parcel$export(module.exports, "ActiveHeaderIdConsumer", () => $ae2d04c26b960a03$export$cddc3c6ebe2d2cec);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const { Provider: $ae2d04c26b960a03$export$20439b49fdd0d26c, Consumer: $ae2d04c26b960a03$var$Consumer } = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(undefined);
/**
 * We need to expose this abstraction on top of the native Consumer in order to control when
 * The consumer will get notified when a match has happened. If we use the Consumer directly in
 * Expand components without this inner state, everytime a new prop comes in, and the `newActiveHeaderId`
 * is the same as before, we will set the expand to true forever, until the active header id changes.
 * Thus, the user won't be able to collapse the expand.
 *
 * By exposing `onNestedHeaderIdMatch` here we can control when will consumers be notified:
 * only when a `newActiveHeaderId` comes in from the Provider and the list of header ids includes it.
 */ const $ae2d04c26b960a03$export$cddc3c6ebe2d2cec = ({ nestedHeaderIds: nestedHeaderIds, onNestedHeaderIdMatch: onNestedHeaderIdMatch })=>{
    const [activeHeaderId, setActiveHeaderId] = (0, $5uXOq.useState)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)($ae2d04c26b960a03$var$Consumer, {
        children: (newActiveHeaderId)=>{
            if (!newActiveHeaderId || !nestedHeaderIds.includes(newActiveHeaderId)) setActiveHeaderId(undefined);
            else if (newActiveHeaderId !== activeHeaderId && nestedHeaderIds.includes(newActiveHeaderId)) {
                setActiveHeaderId(newActiveHeaderId);
                onNestedHeaderIdMatch();
            }
            return null;
        }
    });
};

});

parcelRegister("jUVor", function(module, exports) {

$parcel$export(module.exports, "BreakoutSSRInlineScript", () => $5224f7c9e411dec4$export$cfc1361be0de4203);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eOOFp = parcelRequire("eOOFp");

var $VSDnB = parcelRequire("VSDnB");

function $5224f7c9e411dec4$export$cfc1361be0de4203({ noOpSSRInlineScript: noOpSSRInlineScript }) {
    /**
	 * Should only inline this script while SSR,
	 * not needed on the client side.
	 */ // For hydrateRoot there is a mismatch on client for this script.
    // So we want to add the script on client side but guard it with check to
    // not execute logic
    if (typeof window !== 'undefined' && !window.navigator.userAgent.includes('jsdom')) {
        if (!noOpSSRInlineScript) return null;
        else window.__RENDERER_BYPASS_BREAKOUT_SSR__ = true;
    }
    const id = Math.floor(Math.random() * 9999990001) + 9999;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("script", {
        "data-breakout-script-id": id,
        // To investigate if we can replace this.
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: (0, $VSDnB.fg)('platform-ssr-table-resize') ? $5224f7c9e411dec4$export$92859d13f30c883e(id, true) : $5224f7c9e411dec4$export$92859d13f30c883e(id)
        },
        "data-testid": "breakout-ssr-inline-script"
    });
}
function $5224f7c9e411dec4$export$92859d13f30c883e(id, optionalFlagArg) {
    return `
	 (function(window){
		if(typeof window !== 'undefined' && window.__RENDERER_BYPASS_BREAKOUT_SSR__) {
			return;
		}
    ${$5224f7c9e411dec4$export$47813c4121c8b4b3};
    (${$5224f7c9e411dec4$var$applyBreakoutAfterSSR.toString()})("${id}", breakoutConsts, ${optionalFlagArg ?? false});
  })(window);
`;
}
const $5224f7c9e411dec4$export$47813c4121c8b4b3 = `
  var breakoutConsts = ${JSON.stringify((0, $eOOFp.breakoutConsts))};
  breakoutConsts.mapBreakpointToLayoutMaxWidth = ${(0, $eOOFp.breakoutConsts).mapBreakpointToLayoutMaxWidth.toString()};
  breakoutConsts.getBreakpoint = ${(0, $eOOFp.breakoutConsts).getBreakpoint.toString()};
  breakoutConsts.calcBreakoutWidth = ${(0, $eOOFp.breakoutConsts).calcBreakoutWidth.toString()};
  breakoutConsts.calcBreakoutWithCustomWidth = ${(0, $eOOFp.breakoutConsts).calcBreakoutWithCustomWidth.toString()};
  breakoutConsts.calcLineLength = ${(0, $eOOFp.breakoutConsts).calcLineLength.toString()};
  breakoutConsts.calcWideWidth = ${(0, $eOOFp.breakoutConsts).calcWideWidth.toString()};
  breakoutConsts.FullPagePadding = ${(0, $19a4579e32968c00$export$12fd658e5eef0d79).toString()};
`;
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5224f7c9e411dec4$var$applyBreakoutAfterSSR(id, breakoutConsts, shouldSkipBreakoutScript) {
    const MEDIA_NODE_TYPE = 'mediaSingle';
    const WIDE_LAYOUT_MODES = [
        'full-width',
        'wide',
        'custom'
    ];
    function findUp(element, condition) {
        if (!element) return;
        while(element.parentElement){
            if (condition(element)) return element.parentElement;
            element = element.parentElement;
        }
    }
    const renderer = findUp(document.querySelector(`[data-breakout-script-id="${id}"]`), (elem)=>!!elem.parentElement?.classList.contains('ak-renderer-wrapper'));
    if (!renderer) return;
    const observer = new MutationObserver((mutationsList)=>{
        mutationsList.forEach((item)=>{
            if (item.target.nodeType !== Node.ELEMENT_NODE) return;
            // Remove with feature gate 'platform-ssr-table-resize'
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            if (item.target.classList.contains('ak-renderer-document')) item.addedNodes.forEach((maybeNode)=>{
                // maybeNode may contain comments which doesn't have a dataset property
                if (maybeNode.nodeType !== Node.ELEMENT_NODE) return;
                let width;
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const node = maybeNode;
                const mode = node.dataset.mode || node.dataset.layout || '';
                const resizedBreakout = node.dataset.hasWidth === 'true';
                if (!mode || !WIDE_LAYOUT_MODES.includes(mode)) return;
                // When flag is on we are using CSS to calculate the table width thus don't need logic below to set the width and left.
                if (shouldSkipBreakoutScript && node.classList.contains('pm-table-container')) return;
                // use breakout script for all other types of nodes
                if (node.classList.contains('pm-table-container') && mode === 'custom') {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const rendererWidth = renderer.offsetWidth;
                    const effectiveWidth = rendererWidth - breakoutConsts.padding;
                    width = `${Math.min(parseInt(node.style.width), effectiveWidth)}px`;
                } else if (resizedBreakout) width = breakoutConsts.calcBreakoutWithCustomWidth(mode, node.dataset.width || null, // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                renderer.offsetWidth);
                else // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                width = breakoutConsts.calcBreakoutWidth(mode, renderer.offsetWidth);
                if (node.style.width === width) return;
                node.style.width = width;
                // Tables require some special logic, as they are not using common css transform approach,
                // because it breaks with sticky headers. This logic is copied from a table node:
                // https://bitbucket.org/atlassian/atlassian-frontend/src/77938aee0c140d02ff99b98a03849be1236865b4/packages/editor/renderer/src/react/nodes/table.tsx#table.tsx-235:245
                if (node.classList.contains('pm-table-container') && // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                !renderer.classList.contains('is-full-width')) {
                    const lineLength = breakoutConsts.calcLineLength();
                    const left = lineLength / 2 - parseInt(width) / 2;
                    if (left < 0 && parseInt(width) > lineLength) node.style.left = left + 'px';
                    else node.style.left = '';
                }
            });
            else if (/**
				 * The mutation observer is only called once per added node.
				 * The above condition only deals with direct children of <div class="ak-renderer-document" />
				 * When it is initially called on the direct children, not all the sub children have loaded.
				 * So nested media elements which are not immediately loaded as sub children are not available in the above conditional.
				 * Thus adding this conditional to deal with all media elements directly.
				 */ // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            item.target.dataset.nodeType === MEDIA_NODE_TYPE) // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            applyMediaBreakout(item.target);
        });
    });
    const applyMediaBreakout = (card)=>{
        // width was already set by another breakout script
        if (card.style.width) return;
        const tableParent = findUp(card, (elem)=>elem instanceof HTMLTableCellElement);
        // only apply the breakout to media elements not nested inside table
        // table sizing is not based on percentage width
        if (tableParent) return;
        const mode = card.dataset.mode || card.dataset.layout || '';
        const width = card.dataset.width;
        const isPixelBasedResizing = card.dataset.widthType === 'pixel';
        if (WIDE_LAYOUT_MODES.includes(mode)) card.style.width = '100%';
        else if (width && !isPixelBasedResizing) // Pixel based resizing has width set in pixels based on its width attribute
        // Thus, no need to override for non-wide layouts
        card.style.width = `${width}%`;
    };
    observer.observe(renderer, {
        childList: true,
        subtree: true
    });
    /**
	 * Using window load event to unsubscribe from mutation observer, as at this stage document is fully rendered.
	 * Experiment with DOMContentLoaded showed that some of the blocks were not processed at all.
	 * That's why window load is necessary.
	 *
	 * More info:
	 * – https://html.spec.whatwg.org/multipage/parsing.html#the-end
	 * – https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
	 * – https://developer.mozilla.org/en-US/docs/Web/API/Document/DOMContentLoaded_event
	 */ const disconnect = ()=>{
        observer.disconnect();
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('load', disconnect);
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    window.addEventListener('load', disconnect);
}
const $5224f7c9e411dec4$export$2a0b3eeee3f2ea40 = (0, $eOOFp.breakoutConsts).calcLineLength;

});

parcelRegister("TPpI8", function(module, exports) {

$parcel$export(module.exports, "isInteractiveElement", () => $2d523c4d7c031fc5$export$3dee5e4542c672d9);


function $2d523c4d7c031fc5$export$3dee5e4542c672d9(element) {
    if ('href' in element && element.href != null) return true;
    if (element.classList.contains((0, $9e7f9e5fe795995b$export$42c8d07e41ed1e74))) return true;
    if (element.classList.contains((0, $025bde419ff72534$export$7a6526d4be3b7eb3))) return true;
    return false;
}

});
const $025bde419ff72534$export$7a6526d4be3b7eb3 = 'media-file-card-view';
const $025bde419ff72534$export$1b2a6cb6a124ba37 = 'media-file-card-view-selected';

/**
 * Classname for the media viewer popup that appears adjacent to the editor div. Use this to check
 * if the media viewer has appeared.
 */ const $9e7f9e5fe795995b$export$42c8d07e41ed1e74 = 'media-viewer-popup';


parcelRegister("3lRy2", function(module, exports) {

$parcel$export(module.exports, "TruncatedWrapper", () => $de95a93fc343bd51$export$79ad592494094f07);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $5uXOq = parcelRequire("5uXOq");
const $de95a93fc343bd51$var$fadeOutStyles = (maxHeight, top, backgroundColor)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        position: 'relative',
        overflowY: 'hidden',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxHeight: `${maxHeight}px`,
        '&::after': {
            content: "''",
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            top: `${top}px`,
            bottom: 0,
            left: 0,
            right: 0,
            backgroundImage: `linear-gradient( ${"var(--ds-background-neutral-subtle, rgba(255, 255, 255, 0))"}, ${backgroundColor} )`
        }
    });
const $de95a93fc343bd51$var$FadeOut = (props)=>{
    const { children: children, backgroundColor: backgroundColor, fadeHeight: fadeHeight, height: height } = props;
    const top = height - fadeHeight;
    const styles = $de95a93fc343bd51$var$fadeOutStyles(height, top, backgroundColor);
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: styles
    }, children);
};
class $de95a93fc343bd51$export$79ad592494094f07 extends (0, $5uXOq.Component) {
    constructor(props){
        super(props);
    }
    // TODO: DSP-4123 - Quality ticket as elevation.surface will be issue when sits top of modal.
    render() {
        const { height: height = 95, fadeHeight: fadeHeight = 24, backgroundColor: backgroundColor = "var(--ds-surface, white)", children: children } = this.props;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)($de95a93fc343bd51$var$FadeOut, {
            height: height,
            fadeHeight: fadeHeight,
            backgroundColor: backgroundColor
        }, children);
    }
}

});

parcelRegister("glOdv", function(module, exports) {

$parcel$export(module.exports, "RendererStyleContainer", () => $db1d99891a2fef87$export$8f0929e72efe521f);
/* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values */ /**
                                                                                                                                                                                                                                                                           * @jsxRuntime classic
                                                                                                                                                                                                                                                                           * @jsx jsx
                                                                                                                                                                                                                                                                           */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $f8Sb3 = parcelRequire("f8Sb3");



var $VSDnB = parcelRequire("VSDnB");

var $l8Gxi = parcelRequire("l8Gxi");

var $iHYdz = parcelRequire("iHYdz");

var $9R9Rb = parcelRequire("9R9Rb");

var $3rouw = parcelRequire("3rouw");

var $cYeQP = parcelRequire("cYeQP");
var $4E5wI = parcelRequire("4E5wI");
var $jlYLw = parcelRequire("jlYLw");
var $ceYEW = parcelRequire("ceYEW");
var $iJOES = parcelRequire("iJOES");
var $6gEe5 = parcelRequire("6gEe5");
var $1bQ0V = parcelRequire("1bQ0V");

var $kjhhp = parcelRequire("kjhhp");
var $dwptW = parcelRequire("dwptW");

var $ajc8Z = parcelRequire("ajc8Z");
var $bbl9Y = parcelRequire("bbl9Y");

var $gE8f9 = parcelRequire("gE8f9");

var $gmhCD = parcelRequire("gmhCD");

var $dkc63 = parcelRequire("dkc63");


var $2o2hu = parcelRequire("2o2hu");

var $04VvC = parcelRequire("04VvC");

var $aagOn = parcelRequire("aagOn");
function $db1d99891a2fef87$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $db1d99891a2fef87$var$wrappedMediaBreakoutPoint = 410;
const $db1d99891a2fef87$var$TELEPOINTER_ID = 'ai-streaming-telepointer';
const $db1d99891a2fef87$var$tableShadowWidth = 32;
const $db1d99891a2fef87$var$LAYOUT_BREAKPOINT_RENDERER = 629;
// originally defined from packages/editor/editor-plugin-table/src/ui/common-styles.ts
// Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// TODO: tableRowHeight can be moved into `@atlaskit/editor-common/table`
const $db1d99891a2fef87$var$tableRowHeight = 44;
const $db1d99891a2fef87$var$isBackgroundClipBrowserFixNeeded = ()=>(0, $gE8f9.browser).isGecko || (0, $gE8f9.browser).isIE || (0, $gE8f9.browser).isMac && (0, $gE8f9.browser).isChrome;
// styles are copied from ./style.tsx
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage
const $db1d99891a2fef87$var$baseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 'var(--ak-renderer-base-font-size)',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '1.5rem',
    color: `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`,
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT}::after`]: {
        // we add a clearfix after ak-renderer-document in order to
        // contain internal floats (such as media images that are "wrap-left")
        // to just the renderer (and not spill outside of it)
        content: '""',
        visibility: 'hidden',
        display: 'block',
        height: 0,
        clear: 'both'
    },
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT}`]: {
        // p, h3, and action items
        [`.${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
            height: '22px',
            transform: `translateY(-2px)`
        },
        h1: {
            [`> .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '36px',
                transform: `translateY(-3px)`
            }
        },
        h2: {
            [`> .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '31px',
                transform: `translateY(-3px)`
            }
        },
        h3: {
            [`> .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '25px',
                transform: `translateY(-2px)`
            }
        },
        h4: {
            [`> .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '23px',
                transform: `translateY(-2px)`
            }
        },
        h5: {
            [`> .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '20px',
                transform: `translateY(-2px)`
            }
        },
        h6: {
            [`> .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '18px',
                transform: `translateY(-2px)`
            }
        }
    },
    '& h1, & h2, & h3, & h4, & h5, & h6': {
        [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
            position: 'absolute',
            marginLeft: "var(--ds-space-075, 6px)",
            button: {
                paddingLeft: 0,
                paddingRight: 0
            },
            /**
       * Adds the visibility of the button when in focus through keyboard navigation.
       */ 'button:focus': {
                opacity: 1,
                transform: 'none !important'
            }
        },
        [`@media (hover: hover) and (pointer: fine)`]: {
            [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
                '> button': {
                    opacity: 0,
                    transform: `translate(-8px, 0px)`,
                    transition: `opacity 0.2s ease 0s, transform 0.2s ease 0s`
                }
            },
            '&:hover': {
                [`.${0, $3rouw.HeadingAnchorWrapperClassName} > button`]: {
                    opacity: 1,
                    transform: 'none !important'
                }
            }
        }
    },
    '& h1': {
        [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${28 / 24}em`
        }
    },
    '& h2': {
        [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${1.2}em`
        }
    },
    '& h3': {
        [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${1.25}em`
        }
    },
    '& h4': {
        [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 14}em`
        }
    },
    '& h5': {
        [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 12}em`
        }
    },
    '& h6': {
        [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 11}em`
        }
    },
    [`& span.akActionMark`]: {
        color: `var(--ds-link, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        textDecoration: 'none',
        cursor: 'pointer',
        '&:hover': {
            color: `var(--ds-link, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
            textDecoration: 'underline'
        },
        '&:active': {
            color: `var(--ds-link-pressed, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`
        }
    },
    '& span[data-placeholder]': {
        color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`
    }
});
const $db1d99891a2fef87$var$hideHeadingCopyLinkWrapperStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '& h1, & h2, & h3, & h4, & h5, & h6': {
        [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
            '&:focus-within': {
                opacity: 1
            }
        },
        [`@media (hover: hover) and (pointer: fine)`]: {
            [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
                opacity: 0,
                transition: `opacity 0.2s ease 0s`
            },
            '&:hover': {
                [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
                    opacity: 1
                }
            }
        }
    }
});
const $db1d99891a2fef87$var$rendererFullPageStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $iHYdz.akEditorDefaultLayoutWidth)}px`,
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    padding: `0 ${(0, $19a4579e32968c00$export$12fd658e5eef0d79)}px`
});
const $db1d99891a2fef87$var$rendererFullWidthStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $iHYdz.akEditorFullWidthLayoutWidth)}px`,
    margin: `0 auto`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-breakout-mark:not([data-has-width="true"]), .ak-renderer-extension': {
        width: '100% !important'
    }
});
const $db1d99891a2fef87$var$rendererFullWidthStylesForTableResizing = {
    name: "b6n1sl",
    styles: ".pm-table-container{width:100% !important;}"
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $db1d99891a2fef87$var$telepointerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`#${$db1d99891a2fef87$var$TELEPOINTER_ID}`]: {
        display: 'inline-block',
        position: 'relative',
        width: '1.5px',
        height: '25px',
        backgroundColor: "var(--ds-background-brand-bold, #0C66E4)",
        marginLeft: "var(--ds-space-025, 2px)",
        '&::after': {
            content: '"AI"',
            position: 'absolute',
            display: 'block',
            top: 0,
            left: 0,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: '10px',
            fontWeight: "var(--ds-font-weight-bold, 700)",
            width: '12.5px',
            height: '13px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            paddingTop: '1px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            paddingLeft: '1.5px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'initial',
            borderRadius: '0px 2px 2px 0px',
            color: "var(--ds-text-inverse, white)",
            backgroundColor: "var(--ds-background-brand-bold, #0C66E4)"
        }
    }
});
const $db1d99891a2fef87$var$whitespaceSharedStyles = {
    name: "1s8ykn2",
    styles: "word-wrap:break-word;white-space:pre-wrap"
};
const $db1d99891a2fef87$var$blockquoteSharedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& blockquote': {
        boxSizing: 'border-box',
        color: 'inherit',
        width: '100%',
        display: 'inline-block',
        paddingLeft: "var(--ds-space-200, 16px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        borderLeft: `2px solid ${`var(--ds-border, ${(0, $iHYdz.akEditorBlockquoteBorderColor)})`}`,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `${(0, $iHYdz.blockNodesVerticalMargin)} 0 0 0`,
        marginRight: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[dir='rtl'] &": {
            paddingLeft: 0,
            paddingRight: "var(--ds-space-200, 16px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-child': {
            marginTop: 0
        },
        '&::before': {
            content: "''"
        },
        '&::after': {
            content: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& p': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '& table, & table:last-child': {
            display: 'inline-table'
        },
        // Workaround for overriding the inline-block display on last child of a blockquote set in CSS reset.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .code-block:last-child, >.mediaSingleView-content-wrap:last-child, >.mediaGroupView-content-wrap:last-child': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> .extensionView-content-wrap:last-child': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: 'block'
        }
    }
});
const $db1d99891a2fef87$var$headingsSharedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '& h1': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${24 / 14}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 28 / 24,
        color: "var(--ds-text, #172B4D)",
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: `-0.01em`,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.667em'
    },
    '& h2': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${20 / 14}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1.2,
        color: "var(--ds-text, #172B4D)",
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: `-0.008em`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.8em',
        marginBottom: 0
    },
    '& h3': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${16 / 14}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1.25,
        color: "var(--ds-text, #172B4D)",
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: `-0.006em`,
        marginTop: "var(--ds-space-400, 2em)",
        marginBottom: 0
    },
    '& h4': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${1}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 16 / 14,
        color: "var(--ds-text, #172B4D)",
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: `-0.003em`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.357em'
    },
    '& h5': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${12 / 14}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 16 / 12,
        color: "var(--ds-text, #172B4D)",
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.667em',
        textTransform: 'none'
    },
    '& h6': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${11 / 14}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 16 / 11,
        color: "var(--ds-text-subtlest, #626F86)",
        fontWeight: "var(--ds-font-weight-bold, 700)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.455em',
        textTransform: 'none'
    }
});
const $db1d99891a2fef87$var$headingsSharedStylesWithEditorUGC = /*#__PURE__*/ (0, $f8Sb3.css)({
    '& h1': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h1)`,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        },
        '&::before': {}
    },
    '& h2': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h2)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.4em',
        marginBottom: 0,
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        }
    },
    '& h3': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h3)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.31249em',
        marginBottom: 0,
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        }
    },
    '& h4': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h4)`,
        marginTop: "var(--ds-space-250, 1.25em)",
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        }
    },
    '& h5': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h5)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em',
        textTransform: 'none',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        }
    },
    '& h6': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h6)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.59091em',
        textTransform: 'none',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        }
    }
});
const $db1d99891a2fef87$var$headingWithAlignmentStyles = {
    name: "sd2n24",
    styles: ".fabric-editor-block-mark.fabric-editor-alignment:not(:first-child){> h1:first-child{margin-top:1.667em;} > h2:first-child{margin-top:1.8em;}> h3:first-child{margin-top:2em;}> h4:first-child{margin-top:1.357em;}> h5:first-child{margin-top:1.667em;}> h6:first-child{margin-top:1.455em;}}.ProseMirror-gapcursor:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + .fabric-editor-block-mark.fabric-editor-alignment{> :is(h1, h2, h3, h4, h5, h6):first-child{margin-top:0;}}"
};
const $db1d99891a2fef87$var$ruleSharedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '& hr': {
        border: 'none',
        backgroundColor: "var(--ds-border, #091E4224)",
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `${(0, $iHYdz.akEditorLineHeight)}em 0`,
        height: '2px',
        borderRadius: '1px'
    }
});
const $db1d99891a2fef87$var$paragraphSharedStylesWithEditorUGC = /*#__PURE__*/ (0, $f8Sb3.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-normal-text)`,
        marginTop: (0, $iHYdz.blockNodesVerticalMargin),
        marginBottom: 0
    }
});
const $db1d99891a2fef87$var$paragraphSharedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: (0, $iHYdz.akEditorLineHeight),
        fontWeight: "var(--ds-font-weight-regular, 400)",
        marginTop: (0, $iHYdz.blockNodesVerticalMargin),
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: '-0.005em'
    }
});
const $db1d99891a2fef87$var$listsSharedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    /* =============== INDENTATION SPACING ========= */ 'ul, ol': {
        boxSizing: 'border-box',
        paddingLeft: `var(--ed--list--item-counter--padding, ${(0, $jlYLw.listItemCounterPadding)}px)`
    },
    [`${0, $dwptW.orderedListSelector}, ${0, $kjhhp.bulletListSelector}`]: {
        /*
     Ensures list item content adheres to the list's margin instead
     of filling the entire block row. This is important to allow
     clicking interactive elements which are floated next to a list.
      For some history and context on this block, see PRs related to tickets.:
     @see ED-6551 - original issue.
     @see ED-7015 - follow up issue.
     @see ED-7447 - flow-root change.
      used to have display: 'table' in tag template style but not supported in object styles
     removed display: 'table' as 'flow-root' is supported in latest browsers
      @see https://css-tricks.com/display-flow-root/
    */ display: 'flow-root'
    },
    /* =============== INDENTATION AESTHETICS ========= */ /**
  	We support nested lists up to six levels deep.
  **/ /* LEGACY LISTS */ 'ul, ul ul ul ul': {
        listStyleType: 'disc'
    },
    'ul ul, ul ul ul ul ul': {
        listStyleType: 'circle'
    },
    'ul ul ul, ul ul ul ul ul ul': {
        listStyleType: 'square'
    },
    'ol, ol ol ol ol': {
        listStyleType: 'decimal'
    },
    'ol ol, ol ol ol ol ol': {
        listStyleType: 'lower-alpha'
    },
    'ol ol ol, ol ol ol ol ol ol': {
        listStyleType: 'lower-roman'
    },
    /* PREDICTABLE LISTS */ 'ol[data-indent-level="1"], ol[data-indent-level="4"]': {
        listStyleType: 'decimal'
    },
    'ol[data-indent-level="2"], ol[data-indent-level="5"]': {
        listStyleType: 'lower-alpha'
    },
    'ol[data-indent-level="3"], ol[data-indent-level="6"]': {
        listStyleType: 'lower-roman'
    },
    'ul[data-indent-level="1"], ul[data-indent-level="4"]': {
        listStyleType: 'disc'
    },
    'ul[data-indent-level="2"], ul[data-indent-level="5"]': {
        listStyleType: 'circle'
    },
    'ul[data-indent-level="3"], ul[data-indent-level="6"]': {
        listStyleType: 'square'
    }
});
/*
	Firefox does not handle empty block element inside li tag.
	If there is not block element inside li tag,
	then firefox sets inherited height to li
	However, if there is any block element and if it's empty
	(or has empty inline element) then
	firefox sets li tag height to zero.
	More details at
	https://product-fabric.atlassian.net/wiki/spaces/~455502413/pages/3149365890/ED-14110+Investigation
*/ const $db1d99891a2fef87$var$listsSharedStylesForGekko = {
    name: "jlg15n",
    styles: "ul, ol{li p:empty, li p > span:empty{display:inline-block;}}"
};
const $db1d99891a2fef87$var$indentationSharedStyles = {
    name: "1bgz9nd",
    styles: ".fabric-editor-indentation-mark{&[data-level='1']{margin-left:30px;}&[data-level='2']{margin-left:60px;}&[data-level='3']{margin-left:90px;}&[data-level='4']{margin-left:120px;}&[data-level='5']{margin-left:150px;}&[data-level='6']{margin-left:180px;}}"
};
const $db1d99891a2fef87$var$indentationSharedStylesWithMarginFix = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.fabric-editor-indentation-mark': {
        // Prevent marginTop of p:first-child overrode by batch.css
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        'p:first-child': {
            marginTop: (0, $iHYdz.blockNodesVerticalMargin)
        }
    }
});
const $db1d99891a2fef87$var$blockMarksSharedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    /**
   * We need to remove margin-top from first item
   * inside doc, tableCell, tableHeader, blockquote, etc.
   */ [`*:not(.fabric-editor-block-mark) >,
  	*:not(.fabric-editor-block-mark) >
    div.fabric-editor-block-mark:first-of-type
	:not(.fabric-editor-indentation-mark)
	:not(.fabric-editor-alignment),
  	.fabric-editor-alignment:first-of-type:first-child,
  	.ProseMirror .fabric-editor-indentation-mark:first-of-type:first-child`]: {
        'p, h1, h2, h3, h4, h5, h6, .heading-wrapper': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            ':first-child:not(style), style:first-child + *': {
                marginTop: 0
            }
        }
    }
});
const $db1d99891a2fef87$var$codeMarkSharedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.code': {
        '--ds--code--bg-color': "var(--ds-background-neutral, #091E420F)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '0.875em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        fontWeight: "var(--ds-font-weight-regular, 400)",
        backgroundColor: `var(--ds--code--bg-color,${`var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`})`,
        color: `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`,
        borderStyle: 'none',
        borderRadius: "var(--ds-border-radius, 3px)",
        display: 'inline',
        padding: '2px 0.5ch',
        boxDecorationBreak: 'clone',
        overflow: 'auto',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap'
    }
});
const $db1d99891a2fef87$var$shadowSharedStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $ajc8Z.shadowClassNames).RIGHT_SHADOW}::before, .${(0, $ajc8Z.shadowClassNames).RIGHT_SHADOW}::after, .${(0, $ajc8Z.shadowClassNames).LEFT_SHADOW}::before, .${(0, $ajc8Z.shadowClassNames).LEFT_SHADOW}::after`]: {
        display: 'none',
        position: 'absolute',
        pointerEvents: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $iHYdz.akEditorShadowZIndex),
        width: '8px',
        content: "''",
        height: 'calc(100%)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $ajc8Z.shadowClassNames).RIGHT_SHADOW}, .${(0, $ajc8Z.shadowClassNames).LEFT_SHADOW}`]: {
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $ajc8Z.shadowClassNames).LEFT_SHADOW}::before`]: {
        background: `linear-gradient( to left, transparent 0, ${"var(--ds-shadow-overflow-spread, #091e4229)"} 140% ), linear-gradient( to right, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px )`,
        top: '0px',
        left: 0,
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $ajc8Z.shadowClassNames).RIGHT_SHADOW}::after`]: {
        background: `linear-gradient( to right, transparent 0, ${"var(--ds-shadow-overflow-spread, #091e4229)"} 140% ), linear-gradient( to left, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px )`,
        right: '0px',
        top: '0px',
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $bbl9Y.shadowObserverClassNames).SENTINEL_LEFT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $bbl9Y.shadowObserverClassNames).SENTINEL_RIGHT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    }
});
const $db1d99891a2fef87$var$dateSharedStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${(0, $4E5wI.DateSharedCssClassName).DATE_WRAPPER} span`]: {
        whiteSpace: 'unset'
    }
});
const $db1d99891a2fef87$var$textColorStyles = {
    name: "1nlqh0j",
    styles: ".fabric-text-color-mark{color:var(--custom-palette-color, inherit);}a .fabric-text-color-mark{color:unset;}"
};
const $db1d99891a2fef87$var$backgroundColorStyles = {
    name: "7ixjog",
    styles: ".fabric-background-color-mark{background-color:var(--custom-palette-color, inherit);border-radius:2px;padding-top:1px;padding-bottom:2px;box-decoration-break:clone;}a .fabric-background-color-mark{background-color:unset;}.fabric-background-color-mark .ak-editor-annotation{background-color:unset;}"
};
const $db1d99891a2fef87$var$tasksAndDecisionsStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '.ProseMirror': {
        [`.taskItemView-content-wrap,
		.${(0, $1bQ0V.TaskDecisionSharedCssClassName).DECISION_CONTAINER}`]: {
            position: 'relative',
            minWidth: `${(0, $iHYdz.akEditorTableCellMinWidth)}px`
        },
        [`.${(0, $1bQ0V.TaskDecisionSharedCssClassName).DECISION_CONTAINER}`]: {
            marginTop: 0
        },
        [`.${(0, $1bQ0V.TaskDecisionSharedCssClassName).TASK_CONTAINER}`]: {
            'span[contenteditable="false"]': {
                height: `${(0, $iHYdz.akEditorLineHeight)}em`
            }
        },
        [`.${(0, $1bQ0V.TaskDecisionSharedCssClassName).TASK_ITEM}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: (0, $iHYdz.akEditorLineHeight)
        }
    },
    'div[data-task-local-id]': {
        'span[contenteditable="false"]': {
            height: `${(0, $iHYdz.akEditorLineHeight)}em`
        },
        'span[contenteditable="false"] + div': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${(0, $iHYdz.akEditorLineHeight)}em`
        }
    },
    'div[data-task-list-local-id]': {
        margin: `${"var(--ds-space-150, 12px)"} 0 0 0`,
        // If task item is not first in the list then set margin top to 4px.
        'div + div': {
            marginTop: "var(--ds-space-050, 4px)"
        }
    },
    // If task list is not first in the document then set margin top to 4px.
    'div[data-task-list-local-id] div[data-task-list-local-id]': {
        marginTop: "var(--ds-space-050, 4px)",
        marginLeft: "var(--ds-space-300, 24px)"
    },
    /* When action list is inside panel */ '.ak-editor-panel__content': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div[data-task-list-local-id]:first-child': {
            margin: '0 0 0 0 !important'
        }
    }
});
const $db1d99891a2fef87$var$smartCardStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $iJOES.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}`]: {
        display: 'block',
        margin: `${(0, $iHYdz.blockNodesVerticalMargin)} 0 0`,
        maxWidth: `${760}px`
    }
});
const $db1d99891a2fef87$var$smartCardStylesAvatarFix = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $iJOES.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}`]: {
        /* EDM-11991: Fix list plugin adding padding to ADS AvatarGroup start */ 'ul, ol': {
            paddingLeft: 'inherit'
        }
    }
});
const $db1d99891a2fef87$var$smartCardStylesAvatarMarginFix = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $iJOES.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}`]: {
        'ul, ol': {
            marginRight: 'inherit'
        }
    }
});
const $db1d99891a2fef87$var$baseOtherStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '& .UnknownBlock': {
        fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${0.875}rem`,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word'
    },
    '& span.date-node': {
        background: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`,
        borderRadius: "var(--ds-border-radius-100, 3px)",
        color: `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`,
        padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`,
        margin: `0 1px`,
        transition: `background 0.3s`
    },
    '& span.date-node-highlighted': {
        background: `var(--ds-background-danger, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)})`,
        color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`
    },
    '& .renderer-image': {
        maxWidth: '100%',
        display: 'block',
        margin: `${"var(--ds-space-300, 24px)"} 0`
    },
    [`.${0, $ceYEW.richMediaClassName}.rich-media-wrapped + .${0, $ceYEW.richMediaClassName}:not(.rich-media-wrapped)`]: {
        clear: 'both'
    },
    [`& .code-block,
	& blockquote,
	& hr,
	& > div > div:not(.rich-media-wrapped),
	.${0, $ceYEW.richMediaClassName}.rich-media-wrapped + .rich-media-wrapped + *:not(.rich-media-wrapped),
	.${0, $ceYEW.richMediaClassName}.rich-media-wrapped + div:not(.rich-media-wrapped),
	.${0, $ceYEW.richMediaClassName}.image-align-start,
		.${0, $ceYEW.richMediaClassName}.image-center,
		.${0, $ceYEW.richMediaClassName}.image-align-end`]: {
        clear: 'both'
    },
    '& .rich-media-wrapped': {
        '& + h1, & + h2, & + h3, & + h4, & + h5, & + h6': {
            marginTop: "var(--ds-space-100, 8px)"
        }
    },
    // originally copied the block after mediaSharedStyle
    'div[class^="image-wrap-"] + div[class^="image-wrap-"]': {
        marginLeft: 0,
        marginRight: 0
    },
    /* Breakout for tables and extensions */ [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT} >`]: {
        [`*:not([data-mark-type='fragment']) .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}`]: {
            // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO - improve inline style logic on table container so important styles aren't required here
            width: '100% !important',
            left: '0 !important'
        },
        [`[data-mark-type='fragment'] * .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}`]: {
            // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO - improve inline style logic on table container so important styles aren't required here
            width: '100% !important',
            left: '0 !important'
        },
        [`* .${(0, $l8Gxi.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`]: {
            overflowX: 'auto'
        },
        [`& .${(0, $l8Gxi.RendererCssClassName).EXTENSION}:first-child`]: {
            marginTop: 0
        }
    },
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT}`]: {
        [`.${(0, $l8Gxi.RendererCssClassName).EXTENSION}`]: {
            marginTop: `${(0, $iHYdz.blockNodesVerticalMargin)}`
        },
        [`.${(0, $l8Gxi.RendererCssClassName).EXTENSION_CENTER_ALIGN}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginLeft: '50%',
            transform: 'translateX(-50%)'
        },
        [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER}`]: {
            overflowX: 'auto'
        },
        [`.${(0, $bbl9Y.shadowObserverClassNames).SHADOW_CONTAINER} .${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER}`]: {
            display: 'flex'
        }
    }
});
const $db1d99891a2fef87$var$alignedHeadingAnchorStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO Delete this comment after verifying space token -> previous value `margin: 6px`
    '.fabric-editor-block-mark[data-align] >': {
        'h1, h2, h3, h4, h5, h6': {
            position: 'relative'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-block-mark:not([data-align="center"])[data-align]': {
        [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
            margin: `0 ${"var(--ds-space-075, 6px)"} 0 0`,
            // If the anchor is right aligned then the left side of the heading
            // is aligned with the left side of the anchor.
            // In order to align as expected we transform it the width of the element (plus our expected 6px)
            // to the left
            transform: `translateX(calc(-100% - ${"var(--ds-space-075, 6px)"}))`
        },
        '@media (hover: hover) and (pointer: fine)': {
            [`.${0, $3rouw.HeadingAnchorWrapperClassName} > button`]: {
                transform: `translate(8px, 0px)`
            }
        }
    }
});
// Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// TODO: emotion refactor - there's a mediaSingleSharedNewStyle, but not originally used in the renderer.
const $db1d99891a2fef87$var$mediaSingleSharedStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${0, $ceYEW.richMediaClassName}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${0, $ceYEW.richMediaClassName}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${0, $ceYEW.richMediaClassName}.image-wrap-right + .${0, $ceYEW.richMediaClassName}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${0, $ceYEW.richMediaClassName}.image-wrap-left + .${0, $ceYEW.richMediaClassName}.image-wrap-right, .${0, $ceYEW.richMediaClassName}.image-wrap-right + .${0, $ceYEW.richMediaClassName}.image-wrap-left, .${0, $ceYEW.richMediaClassName}.image-wrap-left + .${0, $ceYEW.richMediaClassName}.image-wrap-left, .${0, $ceYEW.richMediaClassName}.image-wrap-right + .${0, $ceYEW.richMediaClassName}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$db1d99891a2fef87$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            margin: `${"var(--ds-space-150, 12px)"} 0`
        }
    }
});
// was shared between editor-core and renderer
const $db1d99891a2fef87$var$tableSharedStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    // originally from packages/editor/editor-common/src/styles/shared/tableCell.ts
    // Hardcoding the background color for the table cells to avoid the use of inline styles
    'td[colorname="white" i], th[colorname="white" i]': {
        backgroundColor: `${"var(--ds-surface, #FFFFFF)"} !important`
    },
    'td[colorname="light blue" i], th[colorname="light blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtlest, #DEEBFF)"} !important`
    },
    'td[colorname="light teal" i], th[colorname="light teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtlest, #E6FCFF)"} !important`
    },
    'td[colorname="light green" i], th[colorname="light green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtlest, #E3FCEF)"} !important`
    },
    'td[colorname="light yellow" i], th[colorname="light yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-yellow-subtlest, #FFFAE6)"} !important`
    },
    'td[colorname="light red" i], th[colorname="light red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtlest, #FFEBE6)"} !important`
    },
    'td[colorname="light purple" i], th[colorname="light purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtlest, #EAE6FF)"} !important`
    },
    'td[colorname="light gray" i], th[colorname="light gray" i]': {
        backgroundColor: `${"var(--ds-background-accent-gray-subtlest, #F4F5F7)"} !important`
    },
    'td[colorname="blue" i], th[colorname="blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtler, #B3D4FF)"} !important`
    },
    'td[colorname="teal" i], th[colorname="teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtler, #B3F5FF)"} !important`
    },
    'td[colorname="green" i], th[colorname="green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtler, #ABF5D1)"} !important`
    },
    'td[colorname="yellow" i], th[colorname="yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-yellow-subtler, #FFF0B3)"} !important`
    },
    'td[colorname="red" i], th[colorname="red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtler, #FFBDAD)"} !important`
    },
    'td[colorname="purple" i], th[colorname="purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtler, #C0B6F2)"} !important`
    },
    'td[colorname="gray" i], th[colorname="gray" i]': {
        backgroundColor: `${"var(--ds-background-accent-gray-subtle, #B3BAC5)"} !important`
    },
    'td[colorname="dark blue" i], th[colorname="dark blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtle, #4C9AFF)"} !important`
    },
    'td[colorname="dark teal" i], th[colorname="dark teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtle, #79E2F2)"} !important`
    },
    'td[colorname="dark green" i], th[colorname="dark green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtle, #57D9A3)"} !important`
    },
    'td[colorname="dark yellow" i], th[colorname="dark yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-orange-subtle, #FFC400)"} !important`
    },
    'td[colorname="dark red" i], th[colorname="dark red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtle, #FF8F73)"} !important`
    },
    'td[colorname="dark purple" i], th[colorname="dark purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtle, #998DD9)"} !important`
    },
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        position: 'relative',
        margin: `0 auto ${"var(--ds-space-200, 16px)"}`,
        boxSizing: 'border-box',
        /**
     * Fix block top alignment inside table cells.
     */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '.decisionItemView-content-wrap:first-of-type > div': {
            marginTop: 0
        }
    },
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}[data-number-column='true']`]: {
        paddingLeft: `${(0, $iHYdz.akEditorTableNumberColumnWidth) - 1}px`,
        clear: 'both'
    },
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_RESIZER_CONTAINER}`]: {
        willChange: 'width, margin-left'
    },
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_RESIZER_CONTAINER} table`]: {
        willChange: 'width'
    },
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table`]: {
        margin: `${"var(--ds-space-300, 24px)"} 0 0 0`
    },
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER} > table,
	.${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        margin: `${"var(--ds-space-300, 24px)"} ${"var(--ds-space-100, 8px)"} 0 0`
    },
    /* avoid applying styles to nested tables (possible via extensions) */ [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER} > table,
	.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
	.${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        borderCollapse: 'collapse',
        border: `${(0, $6gEe5.tableCellBorderWidth)}px solid ${`var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`}`,
        tableLayout: 'fixed',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        width: '100%',
        '&[data-autosize="true"]': {
            tableLayout: 'auto'
        },
        '*': {
            boxSizing: 'border-box'
        },
        hr: {
            boxSizing: 'content-box'
        },
        tbody: {
            borderBottom: 'none'
        },
        'th td': {
            backgroundColor: "var(--ds-background-neutral-subtle, white)"
        },
        '> tbody > tr > td': {
            backgroundColor: "var(--ds-surface, #FFFFFF)"
        },
        th: {
            backgroundColor: `var(--ds-background-accent-gray-subtlest, ${(0, $iHYdz.akEditorTableToolbar)})`,
            textAlign: 'left',
            /* only apply this styling to codeblocks in default background headercells */ /* TODO this needs to be overhauled as it relies on unsafe selectors */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not([style]):not(.danger)': {
                [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}:not(.danger)`]: {
                    backgroundColor: "var(--ds-surface-raised, rgb(235, 237, 240))",
                    [`&:not(.${0, $iHYdz.akEditorSelectedNodeClassName})`]: {
                        boxShadow: `0px 0px 0px 1px ${"var(--ds-border, transparent)"}`
                    },
                    [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}`]: {
                        // originally copied from packages/editor/editor-shared-styles/src/overflow-shadow/overflow-shadow.ts
                        backgroundImage: `linear-gradient(
							to right,
							${"var(--ds-background-neutral, #091E420F)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-background-neutral, #091E420F)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-spread, #091e4229)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-perimeter, #091e421f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-spread, #091e4229)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-perimeter, #091e421f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  )`,
                        backgroundColor: "var(--ds-background-neutral, rgb(235, 237, 240))"
                    },
                    [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER}`]: {
                        backgroundColor: "var(--ds-background-neutral, rgb(226, 229, 233))"
                    },
                    /* this is only relevant to the element taken care of by renderer */ '> [data-ds--code--code-block]': {
                        // originally copied from packages/editor/editor-shared-styles/src/overflow-shadow/overflow-shadow.ts
                        backgroundImage: `linear-gradient(
							to right,
							${"var(--ds-background-neutral, #091E420F)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-background-neutral, #091E420F)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-spread, #091e4229)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-perimeter, #091e421f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-spread, #091e4229)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-perimeter, #091e421f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  )`,
                        backgroundColor: `${"var(--ds-background-neutral, rgb(235, 237, 240))"}!important`,
                        // selector lives inside @atlaskit/code
                        '--ds--code--line-number-bg-color': "var(--ds-background-neutral, rgb(226, 229, 233))"
                    }
                }
            }
        }
    }
});
const $db1d99891a2fef87$var$tableRendererHeaderStylesForTableCellOnly = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        // platform_editor_renderer_table_header_styles has already been launched, so assume it's on
        '> tbody > tr > th, > tbody > tr > td': {
            minWidth: `${(0, $6gEe5.tableCellMinWidth)}px`,
            fontWeight: "var(--ds-font-weight-regular, 400)",
            verticalAlign: 'top',
            border: `1px solid ${`var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`}`,
            borderRightWidth: 0,
            borderBottomWidth: 0,
            padding: "var(--ds-space-100, 8px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            'th p:not(:first-of-type), td p:not(:first-of-type)': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    }
});
const $db1d99891a2fef87$var$tableRendererNestedPanelStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER} .ak-editor-panel`]: {
        border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #d9dbea)"}`
    }
});
const $db1d99891a2fef87$var$tableStylesBackGroundClipForGeckoForTableCellOnly = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> tbody > tr > th, > tbody > tr > td': {
            backgroundClip: 'padding-box'
        }
    }
});
const $db1d99891a2fef87$var$firstNodeWithNotMarginTopWithNestedDnD = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '> tbody > tr > th, > tbody > tr > td': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> :nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span))': {
                marginTop: 0
            }
        }
    }
});
const $db1d99891a2fef87$var$firstNodeWithNotMarginTop = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '> tbody > tr > th, > tbody > tr > td': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> :first-child:not(style), > style:first-child + *': {
                marginTop: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> .ProseMirror-gapcursor:first-child + *, > style:first-child + .ProseMirror-gapcursor + *': {
                marginTop: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> .ProseMirror-gapcursor:first-child + span + *, > style:first-child + .ProseMirror-gapcursor + span + *': {
                marginTop: 0
            }
        }
    }
});
const $db1d99891a2fef87$var$rendererTableStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT} .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        zIndex: 0,
        transition: `all 0.1s linear`,
        display: 'flex' /* needed to avoid position: fixed jumpiness in Chrome */ ,
        /** Shadow overrides */ [`&.${(0, $ajc8Z.shadowClassNames).RIGHT_SHADOW}::after, &.${(0, $ajc8Z.shadowClassNames).LEFT_SHADOW}::before`]: {
            top: `${(0, $6gEe5.tableMarginTop) - 1}px`,
            height: `calc(100% - ${(0, $6gEe5.tableMarginTop)}px)`,
            zIndex: `${(0, $iHYdz.akEditorStickyHeaderZIndex)}`,
            width: `${$db1d99891a2fef87$var$tableShadowWidth}px`,
            background: `linear-gradient(
					to left,
					transparent 0,
					${`var(--ds-shadow-overflow-spread, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`} 140%
				),
				linear-gradient(
					to right,
					${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px,
					transparent 1px
				)`
        },
        [`&.${(0, $ajc8Z.shadowClassNames).RIGHT_SHADOW}::after`]: {
            background: `linear-gradient(
					to right,
					transparent 0,
					${`var(--ds-shadow-overflow-spread, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`} 140%
				),
				linear-gradient(
					to left,
					${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px,
					transparent 1px
				)`,
            right: `0px`
        },
        [`&
          .${(0, $bbl9Y.shadowObserverClassNames).SENTINEL_LEFT},
          &
          .${(0, $bbl9Y.shadowObserverClassNames).SENTINEL_RIGHT}`]: {
            height: `calc(100% - ${(0, $6gEe5.tableMarginTop)}px)`
        }
    }
});
const $db1d99891a2fef87$var$stickyScrollbarStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT} .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        position: 'relative',
        flexDirection: 'column',
        [`> .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`]: {
            width: '100%',
            display: 'block',
            visibility: 'hidden',
            overflowX: 'auto',
            position: 'sticky',
            bottom: `${"var(--ds-space-0, 0px)"}`,
            zIndex: 1
        },
        [`> .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM},
		> .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP}`]: {
            position: 'absolute',
            width: '100%',
            height: '1px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '-1px',
            // need this to avoid sentinel being focused via keyboard
            // this still allows it to be detected by intersection observer
            visibility: 'hidden'
        },
        [`> .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP}`]: {
            top: `${$db1d99891a2fef87$var$tableRowHeight * 3}px`
        },
        [`> .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM}`]: {
            bottom: `${"var(--ds-space-250, 20px)"}` // MAX_BROWSER_SCROLLBAR_HEIGHT = 20;
        }
    }
});
const $db1d99891a2fef87$var$rendererTableHeaderEqualHeightStylesForTableCellOnly = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT} .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            height: '1px' /* will be ignored */ ,
            marginLeft: 0,
            marginRight: 0
        }
    },
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table > tbody > tr:first-of-type, .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table > tbody > tr:first-of-type`]: {
        height: '100%',
        'td, th': {
            position: 'relative'
        }
    }
});
const $db1d99891a2fef87$var$rendererTableSortableColumnStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT} .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            // allow nested heading links
            [`.${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}`]: {
                padding: 0,
                [`.${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN}`]: {
                    width: '100%',
                    height: '100%',
                    padding: `${(0, $6gEe5.tableCellPadding)}px`,
                    borderWidth: '1.5px',
                    borderStyle: 'solid',
                    borderColor: `transparent`,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> *:first-child': {
                        marginTop: 0
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .ProseMirror-gapcursor:first-child + *, > style:first-child + .ProseMirror-gapcursor + *': {
                        marginTop: 0
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .ProseMirror-gapcursor:first-child + span + *, > style:first-child + .ProseMirror-gapcursor + span + *': {
                        marginTop: 0
                    },
                    '@supports selector(:focus-visible)': {
                        '&:focus': {
                            outline: 'unset'
                        },
                        '&:focus-visible': {
                            borderColor: `${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`}`
                        }
                    }
                },
                [`> .${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN} > .${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER}`]: {
                    margin: 0,
                    [`.${0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23}`]: {
                        opacity: 1,
                        transition: `opacity 0.2s ease-in-out`
                    }
                },
                [`> .${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN}
						> .${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER}`]: {
                    [`.${0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23}`]: {
                        opacity: 0,
                        '&:focus': {
                            opacity: 1
                        }
                    }
                },
                [`&:hover:not(
							:has(
									.${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}
										.${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN}:hover
								)
						)
						> .${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN}
						> .${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER}`]: {
                    [`.${0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23}`]: {
                        opacity: 1
                    }
                }
            }
        }
    }
});
// TODO: ED-27229 - Cleanup with `platform_editor_tables_numbered_column_correction`
const $db1d99891a2fef87$var$rendererTableColumnStylesOld = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT} .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        'table[data-number-column="true"]': {
            [`.${(0, $l8Gxi.RendererCssClassName).NUMBER_COLUMN}`]: {
                backgroundColor: `${`var(--ds-background-neutral, ${(0, $iHYdz.akEditorTableToolbar)})`}`,
                borderRight: `1px solid
								${`var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`}`,
                width: `${(0, $iHYdz.akEditorTableNumberColumnWidth)}px`,
                textAlign: 'center',
                color: `${`var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`}`,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: `${0.875} rem`
            },
            [`.fixed .${(0, $l8Gxi.RendererCssClassName).NUMBER_COLUMN}`]: {
                borderRight: `0px none`
            }
        }
    }
});
const $db1d99891a2fef87$var$rendererTableColumnStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT} .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        'table[data-number-column="true"]': {
            [`.${(0, $l8Gxi.RendererCssClassName).NUMBER_COLUMN}`]: {
                backgroundColor: `${"var(--ds-background-accent-gray-subtlest, #F1F2F4)"}`,
                borderRight: `1px solid
								${`var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`}`,
                width: `${(0, $iHYdz.akEditorTableNumberColumnWidth)}px`,
                textAlign: 'center',
                color: `${`var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`}`,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: `${0.875} rem`
            },
            [`.fixed .${(0, $l8Gxi.RendererCssClassName).NUMBER_COLUMN}`]: {
                borderRight: `0px none`
            }
        }
    }
});
const $db1d99891a2fef87$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinks = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT} .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            [`.${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}`]: {
                [`.${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN}`]: {
                    [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
                        position: 'unset'
                    },
                    '>': {
                        'h1, h2, h3, h4, h5, h6': {
                            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                            marginRight: '30px'
                        }
                    }
                }
            }
        }
    }
});
// @ts-expect-error - throw TS error when use !import in position.
const $db1d99891a2fef87$var$stickyHeaderStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    'tr[data-header-row].fixed': {
        position: 'fixed !important',
        display: 'flex',
        overflow: 'hidden',
        zIndex: `${(0, $iHYdz.akEditorStickyHeaderZIndex)}`,
        borderRight: `1px solid ${`var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`}`,
        borderBottom: `1px solid ${`var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`}`,
        /* this is to compensate for the table border */ transform: 'translateX(-1px)'
    },
    '.sticky > th': {
        zIndex: `${(0, $iHYdz.akEditorStickyHeaderZIndex)}`,
        position: 'fixed !important',
        top: 0
    },
    /* Make the number column header sticky */ '.sticky > td': {
        position: 'fixed !important',
        top: 0
    },
    /* add border for position: sticky
  and work around background-clip: padding-box
  bug for FF causing box-shadow bug in Chrome */ '.sticky th, .sticky td': {
        boxShadow: `0px 1px ${`var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`},
			0px -0.5px ${`var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`},
			inset -1px 0px ${`var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableToolbar)})`},
			0px -1px ${`var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableToolbar)})`}`
    },
    /* this will remove jumpiness caused in Chrome for sticky headers */ '.fixed + tr': {
        minHeight: '0px'
    }
});
const $db1d99891a2fef87$var$codeBlockAndLayoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    /*
   * We wrap CodeBlock in a grid to prevent it from overflowing the container of the renderer.
   * See ED-4159.
   */ '& .code-block': {
        maxWidth: '100%',
        display: 'block',
        position: 'relative',
        borderRadius: "var(--ds-border-radius-100, 3px)",
        /*
     * The overall renderer has word-wrap: break; which causes issues with
     * code block line numbers in Safari / iOS.
     */ wordWrap: 'normal'
    },
    '& .MediaGroup, & .code-block': {
        marginTop: `${(0, $iHYdz.blockNodesVerticalMargin)}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:first-child': {
            marginTop: 0
        }
    },
    // We overwrite the rule that clears margin-top for first nested codeblocks, as
    // our lightweight codeblock dom structure will always nest the codeblock inside
    // an extra container div which would constantly be targeted. Now, top-level
    // lightweight codeblock containers will not be targeted.
    // NOTE: This must be added after other .code-block styles in the root
    // Renderer stylesheet.
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT}
		> .${(0, $2o2hu.LightWeightCodeBlockCssClassName).CONTAINER}
		.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`]: {
        marginTop: (0, $iHYdz.blockNodesVerticalMargin)
    },
    '& [data-layout-section]': {
        marginTop: "var(--ds-space-250, 20px)",
        '& > div + div': {
            marginLeft: "var(--ds-space-400, 32px)"
        },
        [`@media screen and (max-width: ${0, $iHYdz.gridMediumMaxWidth}px)`]: {
            '& > div + div': {
                marginLeft: 0
            }
        },
        '& .MediaGroup, & .code-block': {
            marginTop: (0, $iHYdz.blockNodesVerticalMargin),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:first-child': {
                marginTop: 0
            }
        }
    },
    '& li': {
        '> .code-block': {
            margin: `${(0, $iHYdz.blockNodesVerticalMargin)} 0 0 0`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .code-block:first-child': {
            marginTop: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div:last-of-type.code-block': {
            marginBottom: (0, $iHYdz.blockNodesVerticalMargin)
        }
    }
});
const $db1d99891a2fef87$var$layoutSectionForAdvancedLayoutsStyles = {
    name: "4wptv0",
    styles: "& [data-layout-section]{& > div + div{margin-left:0;}}"
};
const $db1d99891a2fef87$var$gridRenderForCodeBlockStyles = {
    name: "18d2t58",
    styles: "& .code-block{display:grid;grid-template-columns:minmax(0, 1fr);& > span{grid-column:1;}}"
};
// This prevents https://product-fabric.atlassian.net/browse/ED-20924
const $db1d99891a2fef87$var$codeBlockInListSafariFixStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`&:not([data-node-type='decisionList']) > li,
		&:not(.${(0, $iJOES.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}) > li`]: {
        '&::before': {
            content: '" "',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: (0, $iHYdz.akEditorLineHeight)
        },
        [`> p:first-child,
			> .code-block:first-child,
			> .ProseMirror-gapcursor:first-child + .code-block`]: {
            marginTop: `-${(0, $iHYdz.akEditorLineHeight)}em !important`
        }
    }
});
const $db1d99891a2fef87$var$columnLayoutSharedStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '[data-layout-section]': {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > *': {
            flex: 1,
            minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > .unsupportedBlockView-content-wrap': {
            minWidth: 'initial'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media screen and (max-width: ${0, $iHYdz.gridMediumMaxWidth}px)`]: {
            flexDirection: 'column'
        }
    }
});
const $db1d99891a2fef87$var$columnLayoutResponsiveSharedStyle = {
    name: "ee7qh9",
    styles: "[data-layout-section]{display:flex;flex-direction:row;gap:var(--ds-space-100, 8px);& > *{flex:1;min-width:0;}& > .unsupportedBlockView-content-wrap{min-width:initial;}}.layout-section-container{container-type:inline-size;container-name:layout-area;}"
};
const $db1d99891a2fef87$var$columnLayoutResponsiveRendererStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.layout-section-container [data-layout-section]': {
        gap: "var(--ds-space-600, 48px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries
        [`@container layout-area (max-width: ${$db1d99891a2fef87$var$LAYOUT_BREAKPOINT_RENDERER}px)`]: {
            flexDirection: 'column',
            gap: "var(--ds-space-400, 32px)"
        }
    }
});
const $db1d99891a2fef87$var$rendererAnnotationStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    "& [data-mark-type='annotation'][data-mark-annotation-state='active'] [data-annotation-mark], & [data-annotation-draft-mark][data-annotation-inline-node]": {
        background: `var(--ds-background-accent-yellow-subtler, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)})`,
        borderBottom: `2px solid ${`var(--ds-border-accent-yellow, ${(0, $829f609a65d26a98$export$c6930421db9fa514)})`}`,
        boxShadow: `var(--ds-shadow-overlay, ${`1px 2px 3px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}, -1px 2px 3px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`,
        cursor: 'pointer',
        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-025, 2px)"}`
    }
});
const $db1d99891a2fef87$var$rendererAnnotationStylesCommentHeightFix = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node]': {
        borderBottom: '2px solid transparent',
        cursor: 'pointer',
        padding: '1px 0 2px',
        background: `var(--ds-background-accent-yellow-subtler, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)})`,
        borderBottomColor: `var(--ds-border-accent-yellow, ${(0, $829f609a65d26a98$export$c6930421db9fa514)})`,
        boxShadow: `var(--ds-shadow-overlay, ${`1px 2px 3px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}, -1px 2px 3px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node][data-inline-card]': {
        padding: '5px 0 3px 0'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node].date-lozenger-container': {
        paddingTop: "var(--ds-space-025, 2px)"
    }
});
const $db1d99891a2fef87$export$8f0929e72efe521f = (props)=>{
    const { onClick: onClick, onMouseDown: onMouseDown, appearance: appearance, allowNestedHeaderLinks: allowNestedHeaderLinks, allowColumnSorting: allowColumnSorting, useBlockRenderForCodeBlock: useBlockRenderForCodeBlock, children: children, innerRef: innerRef, testId: testId } = props;
    const isAdvancedLayoutsOn = (0, $gmhCD.editorExperiment)('advanced_layouts', true);
    return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: innerRef,
        onClick: onClick,
        onMouseDown: onMouseDown,
        style: {
            '--ak-renderer-base-font-size': `${(0, $aagOn.getBaseFontSize)(appearance)}px`,
            '--ak-renderer-editor-font-heading-h1': `${(0, $04VvC.default)('editor.font.heading.h1')}`,
            '--ak-renderer-editor-font-heading-h2': `${(0, $04VvC.default)('editor.font.heading.h2')}`,
            '--ak-renderer-editor-font-heading-h3': `${(0, $04VvC.default)('editor.font.heading.h3')}`,
            '--ak-renderer-editor-font-heading-h4': `${(0, $04VvC.default)('editor.font.heading.h4')}`,
            '--ak-renderer-editor-font-heading-h5': `${(0, $04VvC.default)('editor.font.heading.h5')}`,
            '--ak-renderer-editor-font-heading-h6': `${(0, $04VvC.default)('editor.font.heading.h6')}`,
            '--ak-renderer-editor-font-normal-text': `${(0, $04VvC.default)('editor.font.body')}`
        },
        css: [
            $db1d99891a2fef87$var$baseStyles,
            $db1d99891a2fef87$var$hideHeadingCopyLinkWrapperStyles,
            appearance === 'full-page' && $db1d99891a2fef87$var$rendererFullPageStyles,
            appearance === 'full-width' && $db1d99891a2fef87$var$rendererFullWidthStyles,
            appearance === 'full-width' && !(0, $dkc63.isTableResizingEnabled)(appearance) && $db1d99891a2fef87$var$rendererFullWidthStylesForTableResizing,
            $db1d99891a2fef87$var$telepointerStyles,
            $db1d99891a2fef87$var$whitespaceSharedStyles,
            $db1d99891a2fef87$var$blockquoteSharedStyles,
            (0, $VSDnB.fg)('platform_editor_typography_ugc') ? $db1d99891a2fef87$var$headingsSharedStylesWithEditorUGC : $db1d99891a2fef87$var$headingsSharedStyles,
            $db1d99891a2fef87$var$headingWithAlignmentStyles,
            $db1d99891a2fef87$var$ruleSharedStyles,
            (0, $VSDnB.fg)('platform_editor_typography_ugc') ? $db1d99891a2fef87$var$paragraphSharedStylesWithEditorUGC : $db1d99891a2fef87$var$paragraphSharedStyles,
            $db1d99891a2fef87$var$listsSharedStyles,
            (0, $gE8f9.browser).gecko && $db1d99891a2fef87$var$listsSharedStylesForGekko,
            $db1d99891a2fef87$var$indentationSharedStyles,
            (0, $VSDnB.fg)('platform_editor__renderer_indentation_text_margin') && $db1d99891a2fef87$var$indentationSharedStylesWithMarginFix,
            $db1d99891a2fef87$var$blockMarksSharedStyles,
            $db1d99891a2fef87$var$codeMarkSharedStyles,
            $db1d99891a2fef87$var$shadowSharedStyle,
            $db1d99891a2fef87$var$dateSharedStyle,
            $db1d99891a2fef87$var$textColorStyles,
            $db1d99891a2fef87$var$backgroundColorStyles,
            $db1d99891a2fef87$var$tasksAndDecisionsStyles,
            $db1d99891a2fef87$var$smartCardStyles,
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $db1d99891a2fef87$var$smartCardStylesAvatarFix,
            (0, $VSDnB.fg)('smartcard_avatar_margin_fix') && $db1d99891a2fef87$var$smartCardStylesAvatarMarginFix,
            // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
            (0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') && $db1d99891a2fef87$var$rendererAnnotationStyles,
            // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
            (0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
            (0, $VSDnB.fg)('annotations_align_editor_and_renderer_styles') && $db1d99891a2fef87$var$rendererAnnotationStylesCommentHeightFix,
            $db1d99891a2fef87$var$baseOtherStyles,
            allowNestedHeaderLinks && $db1d99891a2fef87$var$alignedHeadingAnchorStyle,
            $db1d99891a2fef87$var$mediaSingleSharedStyle,
            $db1d99891a2fef87$var$tableSharedStyle,
            $db1d99891a2fef87$var$tableRendererHeaderStylesForTableCellOnly,
            (0, $VSDnB.fg)('platform_editor_bordered_panel_nested_in_table') && $db1d99891a2fef87$var$tableRendererNestedPanelStyles,
            $db1d99891a2fef87$var$isBackgroundClipBrowserFixNeeded() && $db1d99891a2fef87$var$tableStylesBackGroundClipForGeckoForTableCellOnly,
            (0, $VSDnB.fg)('platform_editor_nested_dnd_styles_changes') ? $db1d99891a2fef87$var$firstNodeWithNotMarginTopWithNestedDnD : $db1d99891a2fef87$var$firstNodeWithNotMarginTop,
            $db1d99891a2fef87$var$rendererTableStyles,
            (0, $dkc63.isStickyScrollbarEnabled)(appearance) && $db1d99891a2fef87$var$stickyScrollbarStyles,
            $db1d99891a2fef87$var$rendererTableHeaderEqualHeightStylesForTableCellOnly,
            allowColumnSorting && $db1d99891a2fef87$var$rendererTableSortableColumnStyles,
            allowColumnSorting && allowNestedHeaderLinks && $db1d99891a2fef87$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinks,
            (0, $VSDnB.fg)('platform_editor_tables_numbered_column_correction') ? $db1d99891a2fef87$var$rendererTableColumnStyles : $db1d99891a2fef87$var$rendererTableColumnStylesOld,
            $db1d99891a2fef87$var$stickyHeaderStyles,
            $db1d99891a2fef87$var$codeBlockAndLayoutStyles,
            $db1d99891a2fef87$var$columnLayoutSharedStyle,
            isAdvancedLayoutsOn && $db1d99891a2fef87$var$columnLayoutResponsiveSharedStyle,
            isAdvancedLayoutsOn && $db1d99891a2fef87$var$columnLayoutResponsiveRendererStyles,
            isAdvancedLayoutsOn && $db1d99891a2fef87$var$layoutSectionForAdvancedLayoutsStyles,
            !useBlockRenderForCodeBlock && $db1d99891a2fef87$var$gridRenderForCodeBlockStyles,
            (0, $gE8f9.browser).safari && $db1d99891a2fef87$var$codeBlockInListSafariFixStyles
        ],
        "data-testid": testId
    }, children));
};

});
parcelRegister("9R9Rb", function(module, exports) {

$parcel$export(module.exports, "INLINE_IMAGE_WRAPPER_CLASS_NAME", () => $c55873fb36219b19$export$dd2e16f83ae6aa78);
$parcel$export(module.exports, "INLINE_IMAGE_ASPECT_RATIO_CSS_VAR_KEY", () => $c55873fb36219b19$export$7ab34e219ce6eef);
$parcel$export(module.exports, "INLINE_IMAGE_BORDER_SIZE_CSS_VAR_KEY", () => $c55873fb36219b19$export$263a8a844c370a89);
$parcel$export(module.exports, "INLINE_IMAGE_BORDER_COLOR_CSS_VAR_KEY", () => $c55873fb36219b19$export$b0d1f1e1fb3c4b46);
$parcel$export(module.exports, "mediaInlineImageStyles", () => $c55873fb36219b19$export$dee15762144889b7);
$parcel$export(module.exports, "wrapperStyle", () => $c55873fb36219b19$export$c4d4f06a25de97f);
$parcel$export(module.exports, "selectedStyle", () => $c55873fb36219b19$export$a7abb1b3dc25813f);
$parcel$export(module.exports, "borderStyle", () => $c55873fb36219b19$export$4d0a7f76ad443516);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $dR3f5 = parcelRequire("dR3f5");
const $c55873fb36219b19$export$dd2e16f83ae6aa78 = 'media-inline-image-wrapper';
const $c55873fb36219b19$export$7ab34e219ce6eef = '--editor-media-inline-image-aspect-ratio';
const $c55873fb36219b19$export$263a8a844c370a89 = '--editor-media-inline-image-border-size';
const $c55873fb36219b19$export$b0d1f1e1fb3c4b46 = '--editor-media-inline-image-border-color';
// We implemented such selectors to ensure specificity:
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Nested and dynamic css calls are violations, needs manual remediation
const $c55873fb36219b19$var$inlineImageHeight = (height, margin = 0)=>/*#__PURE__*/ (0, $f8Sb3.css)(">.mediaInlineView-content-wrap>.", $c55873fb36219b19$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap>.", $c55873fb36219b19$export$dd2e16f83ae6aa78, ",>.", $c55873fb36219b19$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .", $c55873fb36219b19$export$dd2e16f83ae6aa78, "{height:", height, "px;transform:translateY(", margin, "px);}");
const $c55873fb36219b19$export$dee15762144889b7 = /*#__PURE__*/ (0, $f8Sb3.css)(".", $c55873fb36219b19$export$dd2e16f83ae6aa78, "{height:", (0, $dR3f5.referenceHeights)['p'], "px;transform:translateY(-2px);}h1{", $c55873fb36219b19$var$inlineImageHeight((0, $dR3f5.referenceHeights)['h1'], -3), ";}h2{", $c55873fb36219b19$var$inlineImageHeight((0, $dR3f5.referenceHeights)['h2'], -3), ";}h3{", $c55873fb36219b19$var$inlineImageHeight((0, $dR3f5.referenceHeights)['h3'], -2), ";}h4{", $c55873fb36219b19$var$inlineImageHeight((0, $dR3f5.referenceHeights)['h4'], -2), ";}h5{", $c55873fb36219b19$var$inlineImageHeight((0, $dR3f5.referenceHeights)['h5'], -2), ";}h6{", $c55873fb36219b19$var$inlineImageHeight((0, $dR3f5.referenceHeights)['h6'], -2), ";}");
const $c55873fb36219b19$export$c4d4f06a25de97f = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'inline-flex',
    cursor: 'pointer',
    justifyContent: 'center',
    alignItems: 'center',
    verticalAlign: 'middle',
    overflow: 'hidden',
    borderRadius: `${"var(--ds-border-radius, 3px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    aspectRatio: `var(${$c55873fb36219b19$export$7ab34e219ce6eef}, ${(0, $dR3f5.DEFAULT_INLINE_IMAGE_ASPECT_RATIO)})`,
    maxWidth: '100%'
});
const $c55873fb36219b19$export$a7abb1b3dc25813f = /*#__PURE__*/ (0, $f8Sb3.css)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}`,
    outline: 'none'
});
const $c55873fb36219b19$export$4d0a7f76ad443516 = /*#__PURE__*/ (0, $f8Sb3.css)({
    borderColor: `var(${$c55873fb36219b19$export$b0d1f1e1fb3c4b46})`,
    borderStyle: 'solid',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `calc(var(${$c55873fb36219b19$export$263a8a844c370a89}, ${(0, $dR3f5.DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 2px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderWidth: `calc(var(${$c55873fb36219b19$export$263a8a844c370a89}, ${(0, $dR3f5.DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 1px)`,
    boxSizing: `border-box`
});

});
parcelRegister("dR3f5", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_IMAGE_WIDTH", () => $c9848698b53f0c39$export$d722b7527b1834a8);
$parcel$export(module.exports, "DEFAULT_IMAGE_HEIGHT", () => $c9848698b53f0c39$export$da894f7669b4e67c);
$parcel$export(module.exports, "DEFAULT_INLINE_IMAGE_ASPECT_RATIO", () => $c9848698b53f0c39$export$286cf28b87ad4b4f);
$parcel$export(module.exports, "DEFAULT_INLINE_IMAGE_BORDER_SIZE", () => $c9848698b53f0c39$export$64fe09732fb8680);
$parcel$export(module.exports, "referenceHeights", () => $c9848698b53f0c39$export$c1317a9224e4d798);
const $c9848698b53f0c39$export$d722b7527b1834a8 = 250;
const $c9848698b53f0c39$export$da894f7669b4e67c = 200;
const $c9848698b53f0c39$export$286cf28b87ad4b4f = $c9848698b53f0c39$export$d722b7527b1834a8 / $c9848698b53f0c39$export$da894f7669b4e67c;
const $c9848698b53f0c39$export$64fe09732fb8680 = 0;
const $c9848698b53f0c39$export$c1317a9224e4d798 = {
    p: 22,
    h1: 36,
    h2: 31,
    h3: 25,
    h4: 23,
    h5: 20,
    h6: 18
};

});


parcelRegister("4E5wI", function(module, exports) {

$parcel$export(module.exports, "DateSharedCssClassName", () => $174371b9df7208d5$export$99cdf122d0bb9f95);
$parcel$export(module.exports, "dateSharedStyle", () => $174371b9df7208d5$export$86f86bd772084bf4);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
const $174371b9df7208d5$export$99cdf122d0bb9f95 = {
    DATE_WRAPPER: `date-lozenger-container`,
    DATE_CONTAINER: 'dateView-content-wrap'
};
const $174371b9df7208d5$export$86f86bd772084bf4 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$174371b9df7208d5$export$99cdf122d0bb9f95.DATE_WRAPPER} span`]: {
        whiteSpace: 'unset'
    }
});

});

parcelRegister("ceYEW", function(module, exports) {

$parcel$export(module.exports, "richMediaClassName", () => $5c06afce66d8efef$export$cfe6da7d522d87bb);
$parcel$export(module.exports, "mediaSingleSharedStyleNew", () => $5c06afce66d8efef$export$b51dea84d928a378);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
const $5c06afce66d8efef$export$cfe6da7d522d87bb = 'rich-media-item';
const $5c06afce66d8efef$var$wrappedMediaBreakoutPoint = 410;
const $5c06afce66d8efef$export$d031611b96ba4cf0 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${$5c06afce66d8efef$export$cfe6da7d522d87bb}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${$5c06afce66d8efef$export$cfe6da7d522d87bb}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$5c06afce66d8efef$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            margin: `${"var(--ds-space-150, 12px)"} 0`
        }
    }
});
const $5c06afce66d8efef$export$b51dea84d928a378 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${$5c06afce66d8efef$export$cfe6da7d522d87bb}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".mediaSingleView-content-wrap[layout^='wrap-']": {
        position: 'relative',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        zIndex: (0, $iHYdz.akEditorWrappedNodeZIndex)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${$5c06afce66d8efef$export$cfe6da7d522d87bb}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$5c06afce66d8efef$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            margin: `${"var(--ds-space-150, 12px)"} 0`
        }
    }
});

});

parcelRegister("iJOES", function(module, exports) {

$parcel$export(module.exports, "SmartCardSharedCssClassName", () => $bc13534612fcd0a2$export$4ccd31bf665a88f6);
$parcel$export(module.exports, "smartCardSharedStyles", () => $bc13534612fcd0a2$export$83e107f0a431e184);
$parcel$export(module.exports, "getSmartCardSharedStyles", () => $bc13534612fcd0a2$export$fbd9b588230965e4);

var $iHYdz = parcelRequire("iHYdz");
const $bc13534612fcd0a2$export$4ccd31bf665a88f6 = {
    INLINE_CARD_CONTAINER: 'inlineCardView-content-wrap',
    BLOCK_CARD_CONTAINER: 'blockCardView-content-wrap',
    EMBED_CARD_CONTAINER: 'embedCardView-content-wrap',
    DATASOURCE_CONTAINER: 'datasourceView-content-wrap',
    LOADER_WRAPPER: 'loader-wrapper'
};
const $bc13534612fcd0a2$export$83e107f0a431e184 = `
  .${$bc13534612fcd0a2$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER} {
    display: block;
    margin: ${(0, $iHYdz.blockNodesVerticalMargin)} 0 0;
    max-width: ${760}px;
  }
`;
const $bc13534612fcd0a2$export$fbd9b588230965e4 = ()=>`
  .${$bc13534612fcd0a2$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER} {
    display: block;
    margin: ${0, $iHYdz.blockNodesVerticalMargin} 0 0;
    max-width: ${760}px;
  }

  .${$bc13534612fcd0a2$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER} {
    /* EDM-11991: Fix list plugin adding padding to ADS AvatarGroup start */
    ul, ol {
      padding-left: inherit;
    }
    /* EDM-11991: Fix list plugin add padding to ADS AvatarGroup end */
  }
`;

});

parcelRegister("1bQ0V", function(module, exports) {

$parcel$export(module.exports, "TaskDecisionSharedCssClassName", () => $2398d5ed497032ce$export$a7172b75d403a0e4);
$parcel$export(module.exports, "tasksAndDecisionsStyles", () => $2398d5ed497032ce$export$df437277fbc8b4f5);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
const $2398d5ed497032ce$export$a7172b75d403a0e4 = {
    DECISION_CONTAINER: 'decisionItemView-content-wrap',
    TASK_CONTAINER: 'taskItemView-content-wrap',
    TASK_ITEM: 'task-item',
    TASK_CHECKBOX_CONTAINER: 'task-item-checkbox-wrap'
};
const $2398d5ed497032ce$export$df437277fbc8b4f5 = /*#__PURE__*/ (0, $f8Sb3.css)(".ProseMirror{.taskItemView-content-wrap,.", $2398d5ed497032ce$export$a7172b75d403a0e4.DECISION_CONTAINER, "{position:relative;min-width:", (0, $iHYdz.akEditorTableCellMinWidth), "px;}.", $2398d5ed497032ce$export$a7172b75d403a0e4.DECISION_CONTAINER, "{margin-top:0;}.", $2398d5ed497032ce$export$a7172b75d403a0e4.TASK_CONTAINER, "{span[contenteditable='false']{height:", (0, $iHYdz.akEditorLineHeight), "em;}}.", $2398d5ed497032ce$export$a7172b75d403a0e4.TASK_ITEM, "{line-height:", (0, $iHYdz.akEditorLineHeight), ";}}div[data-task-local-id]{span[contenteditable='false']{height:", (0, $iHYdz.akEditorLineHeight), "em;}span[contenteditable='false']+div{line-height:", (0, $iHYdz.akEditorLineHeight), "em;}}div[data-task-list-local-id]{margin:var(--ds-space-150, 12px) 0 0 0;}div[data-task-list-local-id]{div+div{margin-top:var(--ds-space-050, 4px);}}div[data-task-list-local-id] div[data-task-list-local-id]{margin-top:var(--ds-space-050, 4px);margin-left:var(--ds-space-300, 24px);}.ak-editor-panel__content{>div[data-task-list-local-id]:first-child{margin:0 0 0 0!important;}}");

});

parcelRegister("2o2hu", function(module, exports) {

$parcel$export(module.exports, "LightWeightCodeBlockCssClassName", () => $67d1fb0f1c6fc210$export$afbde0e7339bed51);
$parcel$export(module.exports, "default", () => $67d1fb0f1c6fc210$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
var $eluMF = parcelRequire("eluMF");

var $cYeQP = parcelRequire("cYeQP");

var $23OJc = parcelRequire("23OJc");

var $l8Gxi = parcelRequire("l8Gxi");
const $67d1fb0f1c6fc210$var$codeBlockSharedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPED}
		> .${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}
		> .${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT}`]: {
        marginRight: "var(--ds-space-100, 8px)",
        code: {
            display: 'block',
            wordBreak: 'break-word',
            whiteSpace: 'pre-wrap'
        }
    },
    [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}
		> .${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT}`]: {
        display: 'flex',
        flex: 1,
        code: {
            flexGrow: 1,
            whiteSpace: 'pre'
        }
    },
    [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`]: {
        position: 'relative',
        backgroundColor: "var(--ds-surface-raised, #FFFFFF)",
        borderRadius: "var(--ds-border-radius, 3px)",
        margin: `${(0, $iHYdz.blockNodesVerticalMargin)} 0 0 0`,
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        minWidth: `${(0, $iHYdz.akEditorTableCellMinWidth)}px`,
        cursor: 'pointer',
        clear: 'both',
        '--ds--code--bg-color': 'transparent',
        '.code-block-gutter-pseudo-element::before': {
            content: '"attr(data-label)"'
        },
        /* This is necessary to allow for arrow key navigation in/out of code blocks in Firefox. */ whiteSpace: 'normal',
        [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_START}`]: {
            position: 'absolute',
            visibility: 'hidden',
            height: '1.5rem',
            top: '0px',
            left: '0px'
        },
        [`${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_END}`]: {
            position: 'absolute',
            visibility: 'hidden',
            height: '1.5rem',
            bottom: '0px',
            right: '0px'
        },
        [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}`]: {
            position: 'relative',
            backgroundColor: "var(--ds-background-neutral, #091E420F)",
            display: 'flex',
            borderRadius: "var(--ds-border-radius, 3px)",
            width: '100%',
            counterReset: 'line',
            overflowX: 'auto',
            backgroundImage: 'var(--ak-renderer-codeblock-content-wrapper-bg-img)',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'local, local, local, local, scroll, scroll, scroll, scroll',
            backgroundSize: `${"var(--ds-space-300, 24px)"} 100%,
				${"var(--ds-space-300, 24px)"} 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				1px 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				1px 100%`,
            backgroundPosition: `0 0,
				0 0,
				100% 0,
				100% 0,
				100% 0,
				100% 0,
				0 0,
				0 0`,
            /* Be careful if refactoring this; it is needed to keep arrow key navigation in Firefox consistent with other browsers. */ overflowY: 'hidden'
        },
        [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER}`]: {
            backgroundColor: "var(--ds-background-neutral, #091E420F)",
            position: 'relative',
            width: 'var(--lineNumberGutterWidth, 2rem)',
            padding: "var(--ds-space-100, 8px)",
            flexShrink: 0,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: `${0.875}rem`,
            boxSizing: 'content-box'
        },
        // This is a fix of marker of list item with code block.
        // The list item marker in Chrome is aligned by the baseline of the text,
        // that's why we need to add a text (content: "1") to the line number gutter to align
        // the list item marker with the text.
        // Without it, the list item marker will be aligned by the bottom of the code block.
        [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER}::before`]: {
            content: '"1"',
            visibility: 'hidden',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: `${0.875}rem`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: '1.5rem'
        },
        [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT}`]: {
            code: {
                tabSize: 4,
                cursor: 'text',
                color: "var(--ds-text, #172B4D)",
                borderRadius: "var(--ds-border-radius, 3px)",
                margin: "var(--ds-space-100, 8px)",
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: `${0.875}rem`,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                lineHeight: '1.5rem'
            }
        },
        [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET}`]: {
            pointerEvents: 'none',
            userSelect: 'none',
            width: 'var(--lineNumberGutterWidth, 2rem)',
            left: 0,
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: `${0.875}rem`,
            padding: `0px ${"var(--ds-space-100, 8px)"}`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: '1.5rem',
            textAlign: 'right',
            color: "var(--ds-text-subtlest, #505F79)",
            boxSizing: 'content-box'
        }
    }
});
const $67d1fb0f1c6fc210$var$lightWeightCodeBlockStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`]: {
        cursor: 'text'
    }
});
const $67d1fb0f1c6fc210$export$afbde0e7339bed51 = {
    CONTAINER: 'light-weight-code-block'
};
const $67d1fb0f1c6fc210$export$3f1ff491ca7c4c4a = ()=>{
    // We overwrite the rule that clears margin-top for first nested codeblocks, as
    // our lightweight codeblock dom structure will always nest the codeblock inside
    // an extra container div which would constantly be targeted. Now, top-level
    // lightweight codeblock containers will not be targeted.
    // NOTE: This must be added after other .code-block styles in the root
    // Renderer stylesheet.
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $l8Gxi.RendererCssClassName).DOCUMENT, ">.", $67d1fb0f1c6fc210$export$afbde0e7339bed51.CONTAINER, " .", (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, "{margin-top:", (0, $iHYdz.blockNodesVerticalMargin), ";}");
};
const $67d1fb0f1c6fc210$var$LightWeightCodeBlock = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ text: text, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, className: className }, ref)=>{
    const textRows = (0, $5uXOq.useMemo)(()=>(text ?? '').split('\n'), [
        text
    ]);
    const { renderBidiWarnings: renderBidiWarnings } = (0, $23OJc.useBidiWarnings)({
        enableWarningTooltip: codeBidiWarningTooltipEnabled
    });
    const classNames = [
        $67d1fb0f1c6fc210$export$afbde0e7339bed51.CONTAINER,
        className
    ].join(' ');
    const codeBlockBackgroundImage = (0, $eluMF.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: classNames,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $67d1fb0f1c6fc210$var$codeBlockSharedStyles,
            $67d1fb0f1c6fc210$var$lightWeightCodeBlockStyles
        ],
        style: {
            '--ak-renderer-codeblock-content-wrapper-bg-img': codeBlockBackgroundImage
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        className: (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER
    }, textRows.map((_, index)=>// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            key: index
        }))), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        className: (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("code", null, renderBidiWarnings(text))))));
});
var $67d1fb0f1c6fc210$export$2e2bcd8739ae039 = $67d1fb0f1c6fc210$var$LightWeightCodeBlock;

});
parcelRegister("23OJc", function(module, exports) {

$parcel$export(module.exports, "useBidiWarnings", () => $807954ab13bca9b8$export$9fb9fe546a188c7b);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $lrHA4 = parcelRequire("lrHA4");

var $fJyLQ = parcelRequire("fJyLQ");

var $31cgS = parcelRequire("31cgS");
const $807954ab13bca9b8$export$9fb9fe546a188c7b = ({ enableWarningTooltip: enableWarningTooltip = true })=>{
    const intl = (0, $koVbs.default)();
    const warningLabel = intl.formatMessage((0, $fJyLQ.codeBidiWarningMessages).label);
    const renderBidiWarnings = (text)=>{
        return (0, $31cgS.default)(text, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $lrHA4.default), {
                bidiCharacter: bidiCharacter,
                label: warningLabel,
                tooltipEnabled: enableWarningTooltip
            }, index));
    };
    return {
        renderBidiWarnings: renderBidiWarnings,
        warningLabel: warningLabel
    };
};

});


parcelRegister("04VvC", function(module, exports) {

$parcel$export(module.exports, "default", () => $53f731000984869b$export$2e2bcd8739ae039);

var $VSDnB = parcelRequire("VSDnB");

var $kqZva = parcelRequire("kqZva");
function $53f731000984869b$var$editorUGCToken(path) {
    let tokens;
    if ((0, $VSDnB.fg)('platform_editor_typography_ugc')) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-dst-jira-web-fonts') || (0, $VSDnB.fg)('confluence_typography_refreshed') || (0, $VSDnB.fg)('atlas_editor_typography_refreshed')) tokens = (0, $kqZva.editorUGCTokensRefreshed);
        else tokens = (0, $kqZva.editorUGCTokensModernized);
    } else tokens = (0, $kqZva.editorUGCTokens);
    return tokens[path];
}
var $53f731000984869b$export$2e2bcd8739ae039 = $53f731000984869b$var$editorUGCToken;

});
parcelRegister("kqZva", function(module, exports) {

$parcel$export(module.exports, "editorUGCTokens", () => $5558cddd9c1ce385$export$4a3637dc6e2ae29e);
$parcel$export(module.exports, "editorUGCTokensModernized", () => $5558cddd9c1ce385$export$95588e746468319e);
$parcel$export(module.exports, "editorUGCTokensRefreshed", () => $5558cddd9c1ce385$export$63adc0ebe3278d31);
const $5558cddd9c1ce385$export$4a3637dc6e2ae29e = {
    'editor.font.heading.h1': 'normal 500 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 500 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600 1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600 0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 700 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};
const $5558cddd9c1ce385$export$95588e746468319e = {
    'editor.font.heading.h1': 'normal 600 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 600 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600  1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600  0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 600 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};
const $5558cddd9c1ce385$export$63adc0ebe3278d31 = {
    'editor.font.heading.h1': 'normal 600 1.71429em/1.16667 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 600 1.42857em/1.2 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600 1em/1.14286 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600 0.857143em/1.33333 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 600 0.785714em/1.45455 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};

});


parcelRegister("aagOn", function(module, exports) {

$parcel$export(module.exports, "getBaseFontSize", () => $1723ca6d969fec09$export$8e2864079bc476bd);

var $iHYdz = parcelRequire("iHYdz");
const $1723ca6d969fec09$export$8e2864079bc476bd = (appearance)=>{
    return appearance && appearance !== 'comment' ? (0, $iHYdz.akEditorFullPageDefaultFontSize) : 14;
};

});


parcelRegister("dJPoO", function(module, exports) {

$parcel$export(module.exports, "removeEmptySpaceAroundContent", () => $364a1dd5fa66cb46$export$c94cfc0c675062a1);
const $364a1dd5fa66cb46$export$c94cfc0c675062a1 = (document)=>{
    // Check if the document is valid
    if (!document || !document.content || !Array.isArray(document.content)) return document;
    // Check if the node is a meaningful content node meaning it is not an empty paragraph or a paragraph with only whitespace
    const isMeaningfulContentNode = (node)=>{
        // Check if the node is a non-empty paragraph or a non-paragraph node
        if (node.type !== 'paragraph') return true;
        // If the paragraph is empty, return false
        if (!node.content || node.content.length === 0) return false;
        // Check if paragraph has any content other than `hardBreak` or whitespace text nodes
        return node.content.some((child)=>{
            return !(child?.type === 'hardBreak' || child?.type === 'text' && typeof child.text === 'string' && child.text.trim() === '');
        });
    };
    const content = document.content;
    let firstContentIndex = -1;
    let lastContentIndex = -1;
    // Find the first and last paragraphs with content and check if they are meaningful
    for(let i = 0; i < content.length; i++)if (isMeaningfulContentNode(content[i])) {
        if (firstContentIndex === -1) firstContentIndex = i;
        lastContentIndex = i;
    }
    // If no content was found, return an empty document
    if (firstContentIndex === -1) return {
        ...document,
        content: []
    };
    // Slice the content array to include only paragraphs between the first and last content
    const trimmedContent = content.slice(firstContentIndex, lastContentIndex + 1);
    // Return a new document with the trimmed content
    return {
        ...document,
        content: trimmedContent
    };
};

});

parcelRegister("kjHuf", function(module, exports) {

$parcel$export(module.exports, "useMemoFromPropsDerivative", () => $d3a3005b3046eec9$export$80ffe7e3c6bf25c3);

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
function $d3a3005b3046eec9$export$80ffe7e3c6bf25c3(factory, propsDerivator, props) {
    // cache the last set of props
    const prev = (0, $5uXOq.useRef)(props);
    const prevFactory = (0, $5uXOq.useRef)(null);
    return (0, $5uXOq.useMemo)(()=>{
        if ((0, $VSDnB.fg)('cc_complexit_fe_reduce_fragment_serialization')) {
            // check if the serializer is already created
            let shouldCreate = !prevFactory.current;
            // check each prop to see if value has changed and also check if the number of props has changed
            if (prev.current !== props) {
                const propsEntries = Object.entries(props);
                shouldCreate = propsEntries.length !== Object.keys(prev.current).length || propsEntries.some(([key, prop])=>prev.current[key] !== prop);
            }
            prev.current = props;
            // If first time or any prop value has changed, create a new serializer
            if (shouldCreate) prevFactory.current = factory(propsDerivator(props));
            return prevFactory.current;
        }
        return factory(propsDerivator(props));
    }, // To keep deps consistent, here disable the exhaustive-deps rule to drop factory from the deps array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        propsDerivator,
        props
    ]);
}

});

parcelRegister("8QrLL", function(module, exports) {

$parcel$export(module.exports, "PortalContext", () => $d2ca68ebf215abf7$export$60d741e20e0aa309);
$parcel$export(module.exports, "usePortal", () => $d2ca68ebf215abf7$export$b1072f43c67b540c);

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $d2ca68ebf215abf7$export$60d741e20e0aa309 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(undefined);
const $d2ca68ebf215abf7$export$b1072f43c67b540c = ({ portal: portalFromProps } = {})=>{
    const portalFromContext = (0, $5uXOq.useContext)($d2ca68ebf215abf7$export$60d741e20e0aa309);
    if (portalFromProps) return portalFromProps;
    if ((0, $VSDnB.fg)('cc_complexit_reduce_portal_rerenders')) return portalFromContext;
    return undefined;
};

});


parcelRegister("6a30R", function(module, exports) {

$parcel$export(module.exports, "isExternalLink", () => $97cd92cd81dfd9ff$export$b98882f166bb7ce2);
$parcel$export(module.exports, "onLinkClick", () => $97cd92cd81dfd9ff$export$dccc97e4cadc9724);
$parcel$export(module.exports, "smartLinksDefault", () => $97cd92cd81dfd9ff$export$4f1b881d7a962ce6);
$parcel$export(module.exports, "useSmartCardProductType", () => $97cd92cd81dfd9ff$export$3f864e37674c79e7);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $dn5wJ = parcelRequire("dn5wJ");

var $2vSU6 = parcelRequire("2vSU6");

var $2gCtH = parcelRequire("2gCtH");

var $93Yeu = parcelRequire("93Yeu");
const $97cd92cd81dfd9ff$var$isLeftClick = (event)=>event.button === 0;
const $97cd92cd81dfd9ff$var$isMiddleClick = (event)=>event.button === 1;
const $97cd92cd81dfd9ff$var$isCmdOrCtrlClick = (event)=>$97cd92cd81dfd9ff$var$isLeftClick(event) && (event.metaKey || event.ctrlKey);
const $97cd92cd81dfd9ff$export$b98882f166bb7ce2 = (url)=>{
    (0, $gKZoD.di)(window);
    try {
        const { hostname: hostname, pathname: pathname } = new URL(url);
        return(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        hostname !== window.location.hostname || ![
            '/jira',
            '/browse'
        ].some((includedPath)=>pathname.startsWith(includedPath)));
    } catch (err) {
        // Defaults to external link for invalid URLs to avoid further processing
        return true;
    }
};
const $97cd92cd81dfd9ff$export$dccc97e4cadc9724 = (event, url)=>{
    (0, $gKZoD.di)(window);
    if (!url) return;
    if ($97cd92cd81dfd9ff$export$b98882f166bb7ce2(url)) {
        event.preventDefault();
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.open(url, '_blank', 'noopener,noreferrer');
        return;
    }
    if (event.defaultPrevented) {
        // The default has already been prevented meaning that we need to open links in one
        // way or another to ensure we do eventually open the link
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        const mouseEvent = event;
        $97cd92cd81dfd9ff$var$isCmdOrCtrlClick(mouseEvent) || $97cd92cd81dfd9ff$var$isMiddleClick(mouseEvent) ? window.open(url, '_blank', 'noopener,noreferrer') : window.location.assign(url);
    }
};
const $97cd92cd81dfd9ff$export$4f1b881d7a962ce6 = {
    actionOptions: {
        hide: false,
        exclude: [
            (0, $dn5wJ.CardAction).ChangeStatusAction
        ]
    }
};
const $97cd92cd81dfd9ff$var$getProductForSmartLinksProvider = (projectType)=>{
    switch(projectType){
        case 0, $2vSU6.CORE_PROJECT:
            return 'JWM';
        case 0, $2vSU6.SOFTWARE_PROJECT:
            return 'JSW';
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return 'JSM';
        case 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT:
            return 'JPD';
        default:
            return undefined;
    }
};
const $97cd92cd81dfd9ff$export$3f864e37674c79e7 = ()=>{
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    const product = (0, $5uXOq.useMemo)(()=>// Arbitrarily default to Jira Software if not specified
        $97cd92cd81dfd9ff$var$getProductForSmartLinksProvider(projectType) ?? 'JSW', [
        projectType
    ]);
    return product;
};

});
parcelRegister("dn5wJ", function(module, exports) {

$parcel$export(module.exports, "CardAction", () => $b402a0f22139e437$export$f40b7e0b762b928b);
var $b402a0f22139e437$export$f40b7e0b762b928b = /*#__PURE__*/ function(CardAction) {
    CardAction["DownloadAction"] = "DownloadAction";
    CardAction["PreviewAction"] = "PreviewAction";
    CardAction["ViewAction"] = "ViewAction";
    CardAction["ChangeStatusAction"] = "ChangeStatusAction";
    CardAction["FollowAction"] = "FollowAction";
    CardAction["CopyLinkAction"] = "CopyLinkAction";
    CardAction["AISummaryAction"] = "AISummaryAction";
    CardAction["AutomationAction"] = "AutomationAction";
    return CardAction;
}({});

});



parcelRegister("grJuq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9a54b464d210551$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f9a54b464d210551$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    moreInformation: {
        "id": "issue-field-description.more-information",
        "defaultMessage": "More information about {label}"
    }
});

});


parcelRegister("gr93b", function(module, exports) {

$parcel$export(module.exports, "default", () => $47d4e9d1bd2b0166$export$2e2bcd8739ae039);
$parcel$export(module.exports, "FieldPinButtonControl", () => $47d4e9d1bd2b0166$export$e953606ff2a0ef71);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $5LWLA = parcelRequire("5LWLA");

var $ay27n = parcelRequire("ay27n");

var $aXLRk = parcelRequire("aXLRk");

var $3bDjY = parcelRequire("3bDjY");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $2gCtH = parcelRequire("2gCtH");

var $93Yeu = parcelRequire("93Yeu");

var $2vSU6 = parcelRequire("2vSU6");

var $k9JTq = parcelRequire("k9JTq");

var $ldyPw = parcelRequire("ldyPw");

var $efvDm = parcelRequire("efvDm");

var $8BKyI = parcelRequire("8BKyI");

var $fW1Uj = parcelRequire("fW1Uj");

var $dRPIE = parcelRequire("dRPIE");

var $45Bvg = parcelRequire("45Bvg");
const $47d4e9d1bd2b0166$var$PIN_FIELD_ID = 'issue-field-pin.field-pin';
const $47d4e9d1bd2b0166$export$45e5ae05ceb3db0b = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>{
    const { isPinned: isPinned = false, onClick: onClick, hasPinnedFields: hasPinnedFields, label: label } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const tooltipMessage = (0, $5uXOq.useMemo)(()=>{
        if (isPinned) return formatMessage((0, $dRPIE.default).unpinField);
        if (hasPinnedFields === undefined || hasPinnedFields) // This renders typical (messages.pinField) 'Pin to top' message
        return formatMessage((0, $dRPIE.default).pinField);
        return formatMessage((0, $dRPIE.default).firstPinnedField);
    }, [
        formatMessage,
        hasPinnedFields,
        isPinned
    ]);
    const iconOld = isPinned ? (0, $8BKyI.default) : (0, $fW1Uj.default);
    const IconWrapper = isPinned ? $47d4e9d1bd2b0166$export$413ba3c829ad4fb0 : $47d4e9d1bd2b0166$var$UnpinnedIconWrapper;
    const icon = isPinned ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aXLRk))), {
        testId: "issue-field-pin.pin-filled-icon",
        color: "var(--ds-icon-accent-yellow, #B38600)",
        label: "",
        LEGACY_size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ay27n))), {
        testId: "issue-field-pin.pin-icon",
        label: "",
        LEGACY_size: "small",
        color: "var(--ds-icon, #44546F)"
    });
    const ariaLabel = label ? `${label} ${tooltipMessage}` : tooltipMessage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($47d4e9d1bd2b0166$var$FieldPinButton, {
        "data-testid": $47d4e9d1bd2b0166$var$PIN_FIELD_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: tooltipMessage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($47d4e9d1bd2b0166$var$FieldPinWithButtonWrapper, {
        onClick: onClick,
        "aria-pressed": isPinned,
        "aria-label": ariaLabel,
        iconBefore: (0, $dCm1o.isVisualRefreshEnabled)() ? icon : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IconWrapper, {
            className: "issue-details-pin-icon-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
            glyph: iconOld
        }))
    })));
});
$47d4e9d1bd2b0166$export$45e5ae05ceb3db0b.displayName = 'FieldPin';
var $47d4e9d1bd2b0166$export$2e2bcd8739ae039 = $47d4e9d1bd2b0166$export$45e5ae05ceb3db0b;
const $47d4e9d1bd2b0166$var$FieldPinWithButton = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        "data-component-selector": (0, $45Bvg.fieldPinWithButtonSelectorName),
        spacing: "none",
        testId: "issue-field-pin.button",
        appearance: "subtle",
        ...props,
        interactionName: "auto-generated.issue-field-pin.button.button"
    });
const $47d4e9d1bd2b0166$var$FieldPinButton = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($47d4e9d1bd2b0166$var$FieldPinButtonComponent, {
        "data-component-selector": (0, $45Bvg.fieldPinButtonSelectorName),
        ...props
    });
const $47d4e9d1bd2b0166$export$413ba3c829ad4fb0 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($47d4e9d1bd2b0166$var$PinnedIconWrapperComponent, {
        "data-component-selector": (0, $45Bvg.fieldPinButtonSelectorName),
        ...props
    });
const $47d4e9d1bd2b0166$var$UnpinnedIconWrapper = (props)=>{
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey) || null;
    const isJSMProject = projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);
    const appEditions = (0, $k9JTq.useAppEditions)();
    let editionFromTenantContext;
    if (projectType) editionFromTenantContext = (0, $ldyPw.getEdition)((0, $efvDm.getApplicationForProject)(projectType), appEditions);
    return !isJSMProject && editionFromTenantContext !== (0, $ldyPw.PREMIUM_EDITION) && ((0, $6s1PB.expVal)('pin_fields_observation_exp', 'isPinFieldObservabilityExpEnabled', false) || (0, $6s1PB.expVal)('jira_pin_field_configurability_experiment', 'isPinFieldConfigurabilityEnabled', false)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-component-selector": (0, $45Bvg.unpinnedIconWrapperSelectorName),
        ...props,
        className: (0, $bwpsq.default)([
            "_30l3wdcn"
        ])
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($47d4e9d1bd2b0166$var$UnpinnedIconWrapperComponent, {
        "data-component-selector": (0, $45Bvg.unpinnedIconWrapperSelectorName),
        ...props
    });
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $47d4e9d1bd2b0166$var$FieldPinWithButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $47d4e9d1bd2b0166$var$FieldPinWithButton, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11q7glyw _27a81oqg _f032wdcn _1du2glyw _19lcglyw",
            __cmplp.className
        ])
    });
}); /**
     * @deprecated `FieldPinButtonControl` is used as component selector in `fieldHeadingIconsCss`
     * which is consumed by other styled-components (e.g. src/packages/servicedesk/post-incident-review/src/ui/primary-incident/styled.tsx )
     * TODO: Remove `FieldPinButtonControl` once its consumers are migrated to CompiledCSS
     */ 
const $47d4e9d1bd2b0166$export$e953606ff2a0ef71 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_80omtlke _18u01b66 _1o9zidpf _y20wglyw _1xvhglyw _1nsgglyw _1j3j1oqg _1evowdcn",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $47d4e9d1bd2b0166$var$FieldPinButtonComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_80omtlke _18u01b66 _1o9zidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $47d4e9d1bd2b0166$var$PinnedIconWrapperComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1oqg _30l31oqg",
            __cmplp.className
        ])
    });
});
const $47d4e9d1bd2b0166$var$UnpinnedIconWrapperComponentForPinFieldConfigurability = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $47d4e9d1bd2b0166$var$UnpinnedIconWrapperComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz15cr _30l3wdcn",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

});
parcelRegister("ay27n", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3cbb4cee02b4cc3e5b584fbc7fe3feb6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7adeb8f7c2e17840$var$_react = $7adeb8f7c2e17840$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7adeb8f7c2e17840$var$_baseNew = $7adeb8f7c2e17840$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $7adeb8f7c2e17840$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pin".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: unpinned fields.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7adeb8f7c2e17840$var$PinIcon = (props)=>/*#__PURE__*/ $7adeb8f7c2e17840$var$_react.default.createElement($7adeb8f7c2e17840$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.354 0a1.376 1.376 0 0 0-1.268 1.908l.089.174L5 3.458v3.475a5 5 0 0 0-1.184.61C2.898 8.195 2 9.348 2 11.25c0 .414.336.75.75.75h4.5v4h1.5v-4h4.5a.75.75 0 0 0 .75-.75c0-1.903-.898-3.056-1.816-3.706A5 5 0 0 0 11 6.933V3.458l.825-1.376A1.375 1.375 0 0 0 10.647 0zm4.252 2.864a.75.75 0 0 0-.106.386V7.5c0 .367.265.68.627.74l.008.001.066.016a3.4 3.4 0 0 1 1.115.512c.463.327.938.852 1.113 1.731H3.57c.175-.88.65-1.404 1.113-1.731a3.4 3.4 0 0 1 1.181-.528l.008-.002A.75.75 0 0 0 6.5 7.5V3.25a.75.75 0 0 0-.106-.386L5.574 1.5h4.852z"/>`
    }, props));
$7adeb8f7c2e17840$var$PinIcon.displayName = 'PinIcon';
var $7adeb8f7c2e17840$var$_default = module.exports.default = $7adeb8f7c2e17840$var$PinIcon;

});

parcelRegister("aXLRk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::125e7296304e7c0f29e53606e034d45f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7fb489ec7557acda$var$_react = $7fb489ec7557acda$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7fb489ec7557acda$var$_baseNew = $7fb489ec7557acda$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $7fb489ec7557acda$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PinFilled".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: pinned fields.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7fb489ec7557acda$var$PinFilledIcon = (props)=>/*#__PURE__*/ $7fb489ec7557acda$var$_react.default.createElement($7fb489ec7557acda$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.354 0a1.376 1.376 0 0 0-1.268 1.908l.089.174L5 3.458v3.475a5 5 0 0 0-1.184.61C2.898 8.195 2 9.348 2 11.25c0 .414.336.75.75.75h4.5v4h1.5v-4h4.5a.75.75 0 0 0 .75-.75c0-1.903-.898-3.056-1.816-3.706A5 5 0 0 0 11 6.933V3.458l.825-1.376A1.375 1.375 0 0 0 10.647 0zm4.252 2.864-.045.09a.8.8 0 0 0-.061.296V7.5c0 .367.265.68.627.74l.008.001.066.016a3.4 3.4 0 0 1 1.115.512c.463.327.938.852 1.113 1.731H3.57c.175-.88.65-1.404 1.113-1.731a3.4 3.4 0 0 1 1.181-.528l.008-.002A.75.75 0 0 0 6.5 7.5V3.25a.75.75 0 0 0-.106-.386L5.574 1.5h4.852z"/><path fill="currentcolor" d="m9.606 2.864-.045.09a.8.8 0 0 0-.061.296V7.5c0 .367.265.68.627.74l.008.001.066.016a3.4 3.4 0 0 1 1.115.512c.463.327.938.852 1.113 1.731H3.57c.175-.88.65-1.404 1.113-1.731a3.4 3.4 0 0 1 1.181-.528l.008-.002A.75.75 0 0 0 6.5 7.5V3.25a.75.75 0 0 0-.106-.386L5.574 1.5h4.852z"/>`
    }, props));
$7fb489ec7557acda$var$PinFilledIcon.displayName = 'PinFilledIcon';
var $7fb489ec7557acda$var$_default = module.exports.default = $7fb489ec7557acda$var$PinFilledIcon;

});

parcelRegister("8BKyI", function(module, exports) {

$parcel$export(module.exports, "default", () => $44bea718e9612a85$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $44bea718e9612a85$var$PinFilled = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        "data-testid": "issue-field-pin-assets.pin-filled",
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "currentColor",
        d: "M5.48121736,7.00404408 L7.59617451,4.89248498 C7.83826329,4.65078605 7.83826329,4.2589269 7.59617451,4.01722797 L7.45004745,3.8713518 C7.28862892,3.71022438 7.28862892,3.44898234 7.45004745,3.28784713 L8.61890792,2.12084557 C8.78032645,1.95971814 9.04199766,1.95971814 9.20333816,2.12084557 L13.8789361,6.78886738 C14.0403546,6.94999481 14.0403546,7.21123684 13.8789361,7.37239542 L12.7100756,8.53937361 C12.5486571,8.70053219 12.2869859,8.70053219 12.1255674,8.53937361 L11.9795183,8.39348187 C11.7374295,8.15178294 11.3449227,8.15178294 11.102834,8.39348187 L8.9878534,10.5050565 C8.74576463,10.7467555 8.74576463,11.1385523 8.9878534,11.3802512 L9.57236166,11.9638182 C9.73370217,12.1248989 9.73370217,12.3861487 9.57236166,12.5473073 L8.40342317,13.7142855 C8.24208266,13.8754441 7.98041145,13.8754441 7.81899293,13.7142855 L5.48655377,11.3856258 L2.99050379,13.8776251 C2.91356278,13.9544266 2.8093702,13.9978903 2.70055118,13.9985135 L2.42647516,14 C2.20319644,14.0012397 2.01932444,13.8251258 2.0112106,13.6023547 L2.00027253,13.3019252 C1.99610639,13.187346 2.03985869,13.076272 2.12104386,12.9951864 L4.60989281,10.5103532 L2.26677303,8.17102227 C2.10538571,8.00986368 2.10538571,7.74861386 2.26677303,7.58753317 L3.43565691,6.42050825 C3.59705203,6.25938082 3.85871544,6.25938082 4.02010275,6.42050825 L4.6045486,7.00404408 C4.84663737,7.245743 5.23912858,7.245743 5.48121736,7.00404408 Z"
    }));
var $44bea718e9612a85$export$2e2bcd8739ae039 = $44bea718e9612a85$var$PinFilled;

});

parcelRegister("fW1Uj", function(module, exports) {

$parcel$export(module.exports, "default", () => $28cb13c9f8045855$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $28cb13c9f8045855$export$98e16bcd4c84a74d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        "data-testid": "issue-field-pin-assets.pin-unfilled",
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "currentColor",
        d: "M3.58176938,7.87928392 L8.11122851,12.4014141 L8.25734637,12.2555315 L8.18428744,12.1825901 C7.49835823,11.4978426 7.49835823,10.387565 8.18428744,9.70273982 L10.299184,7.5911928 C10.8579797,7.03331193 11.6995968,6.9299201 12.363196,7.28100178 L12.563933,7.08062671 L8.9111421,3.43373045 L8.71048291,3.63410553 C9.06208387,4.29665994 8.95852537,5.13692246 8.39972959,5.6948111 L6.28483307,7.80634258 C5.59890386,8.4911678 4.48684425,8.4911678 3.80093838,7.80634258 L3.72787945,7.73340123 L3.58176938,7.87928392 Z M5.48118484,7.00402665 L7.59615917,4.8924874 C7.83821064,4.65079444 7.83821064,4.25893086 7.59615917,4.01723789 L7.45004131,3.87135521 C7.28867366,3.71023174 7.28867366,3.44898677 7.45004131,3.28785554 L8.61890638,2.12084842 C8.78035183,1.95971719 9.04201017,1.95971719 9.20337782,2.12084842 L13.8789159,6.78887687 C14.0403614,6.9500081 14.0403614,7.21125308 13.8789159,7.37238431 L12.7100508,8.53940696 C12.5486832,8.70051489 12.2870249,8.70051489 12.1255794,8.53940696 L11.9794615,8.39352427 C11.7374101,8.1517847 11.3448837,8.1517847 11.1028322,8.39352427 L8.98785786,10.5050169 C8.74580639,10.7467565 8.74580639,11.1385735 8.98785786,11.380313 L9.5723293,11.9638438 C9.73369695,12.1249517 9.73369695,12.3861889 9.5723293,12.5472968 L8.40346423,13.7143583 C8.24201878,13.8754662 7.98036044,13.8754662 7.81899279,13.7143583 L5.48655339,11.3856729 L2.99050556,13.8776413 C2.91355638,13.9544666 2.80936765,13.9978896 2.70054953,13.9985111 L2.4264735,14 C2.20319639,14.0012299 2.01931974,13.8252074 2.01121246,13.6024217 L2.00027307,13.3019562 C1.99610272,13.1873785 2.03985249,13.0762963 2.12104205,12.9951986 L4.60988514,10.5103768 L2.26677088,8.17104929 C2.10537989,8.00994136 2.10537989,7.74862648 2.26677088,7.58752632 L3.4356593,6.42051921 C3.59705028,6.25938797 3.85870862,6.25938797 4.02009961,6.42051921 L4.60454771,7.00402665 C4.8466303,7.24571961 5.23912559,7.24571961 5.48118484,7.00402665 Z"
    }));
var $28cb13c9f8045855$export$2e2bcd8739ae039 = $28cb13c9f8045855$export$98e16bcd4c84a74d;

});

parcelRegister("dRPIE", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf98802a9cd68d05$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cf98802a9cd68d05$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    pinField: {
        "id": "issue-field-pin.pin-field",
        "defaultMessage": "Pin to top"
    },
    firstPinnedField: {
        "id": "issue-field-pin.first-pinned-field",
        "defaultMessage": "Pin to top. Only you can see pinned fields."
    },
    unpinField: {
        "id": "issue-field-pin.unpin-field",
        "defaultMessage": "Unpin"
    },
    fieldPinned: {
        "id": "issue-field-pin.field-pinned",
        "defaultMessage": "{fieldLabel} pinned to top."
    },
    errorTooManyPinnedTitle: {
        "id": "issue-field-pin.error-too-many-pinned-title",
        "defaultMessage": "Too many pinned fields"
    },
    errorTooManyPinnedDescription: {
        "id": "issue-field-pin.error-too-many-pinned-description",
        "defaultMessage": "You've reached the maximum number of fields for this project. If you'd like to pin a new field, you'll need to unpin another."
    }
});

});

parcelRegister("45Bvg", function(module, exports) {

$parcel$export(module.exports, "fieldPinButtonSelectorName", () => $08a3b5694d746d08$export$81b416e5079a19d);
$parcel$export(module.exports, "unpinnedIconWrapperSelectorName", () => $08a3b5694d746d08$export$5ac005c8855961e4);
$parcel$export(module.exports, "fieldPinWithButtonSelectorName", () => $08a3b5694d746d08$export$66eb55d72c2996fe);
$parcel$export(module.exports, "isFieldPinned", () => $08a3b5694d746d08$export$15d2e586d5f57232);
$parcel$export(module.exports, "encodePinnedFields", () => $08a3b5694d746d08$export$a26485c67d3d39ab);
$parcel$export(module.exports, "usePinnedFields", () => $08a3b5694d746d08$export$ef3db8d9ff40b53a);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $eNNkf = parcelRequire("eNNkf");

var $93Yeu = parcelRequire("93Yeu");

var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");
const $08a3b5694d746d08$export$177569d991526294 = {
    PINNED_FIELDS: 'jira.user.issue.details.pinned-fields',
    ATTACHMENT_VIEW: 'jira.user.issue.attachment.view'
};
const $08a3b5694d746d08$export$81b416e5079a19d = 'jira-issue-field-pin-field-pin-button';
const $08a3b5694d746d08$export$6283d7e3dfea3fc0 = `[data-component-selector="${$08a3b5694d746d08$export$81b416e5079a19d}"]`;
const $08a3b5694d746d08$export$5ac005c8855961e4 = 'jira-issue-field-pin-unpinned-icon-wrapper';
const $08a3b5694d746d08$export$ce49ab4122be954d = `[data-component-selector="${$08a3b5694d746d08$export$5ac005c8855961e4}"]`;
const $08a3b5694d746d08$export$66eb55d72c2996fe = 'jira-issue-field-pin-with-button-wrapper';
const $08a3b5694d746d08$export$f76e9f356c65c948 = `[data-component-selector="${$08a3b5694d746d08$export$66eb55d72c2996fe}"]`;
const $08a3b5694d746d08$export$14202689ff202a64 = 255;
const $08a3b5694d746d08$export$21fad9415db37df = (projectKey)=>{
    if (!projectKey) return $08a3b5694d746d08$export$177569d991526294.PINNED_FIELDS;
    return `${$08a3b5694d746d08$export$177569d991526294.PINNED_FIELDS}.${projectKey}`;
};
const $08a3b5694d746d08$export$15d2e586d5f57232 = (pinnedFields, fieldId)=>{
    if (!pinnedFields || !Array.isArray(pinnedFields || !fieldId)) return false;
    return pinnedFields.includes(fieldId);
};
const $08a3b5694d746d08$export$dc516a57c030b84a = (pinnedFields)=>{
    if (pinnedFields === undefined || pinnedFields === null || pinnedFields === '' || pinnedFields === 'null') return [];
    // TODO: Temporary until preferences API is extended (the .trim())
    return pinnedFields.trim().split(',');
};
const $08a3b5694d746d08$export$a26485c67d3d39ab = (pinnedFields)=>{
    // Null value will delete the preference key
    if (pinnedFields.filter((e)=>typeof e === 'string' && e !== '').length === 0) return 'null';
    return pinnedFields.join(',');
};
const $08a3b5694d746d08$export$ef3db8d9ff40b53a = (issueKey)=>{
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const preferenceName = $08a3b5694d746d08$export$21fad9415db37df(projectKey);
    const [rawPinnedFields, setPinnedFieldsUserPreferences] = (0, $eNNkf.useUserPreferencesValue)(preferenceName);
    const pinnedFields = $08a3b5694d746d08$export$dc516a57c030b84a(rawPinnedFields);
    let bannerPreferenceProjectKey;
    let setBannerPreferenceProjectKey = null;
    let isPinFieldConfigurabilityExperimentEnabled = false;
    /* eslint-disable react-hooks/rules-of-hooks */ if ((0, $4R6GH.fg)('pin_fields_ga') || (0, $4R6GH.fg)('jira_pin_field_configurability')) {
        [bannerPreferenceProjectKey, setBannerPreferenceProjectKey] = (0, $eNNkf.useUserPreferencesValue)('jira.user.issue.pinned-fields.banner.project');
        const projectType = (0, $93Yeu.useProjectType)(projectKey) || null;
        const isJSMProject = projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);
        const appEditions = (0, $k9JTq.useAppEditions)();
        let editionFromTenantContext;
        if (projectType) editionFromTenantContext = (0, $ldyPw.getEdition)((0, $efvDm.getApplicationForProject)(projectType), appEditions);
        if (!isJSMProject && editionFromTenantContext !== (0, $ldyPw.PREMIUM_EDITION) && (0, $4R6GH.fg)('pin_fields_ga')) isPinFieldConfigurabilityExperimentEnabled = (0, $6s1PB.expVal)('pin_fields_observation_exp', 'isPinFieldObservabilityExpEnabled', false);
        else if (!isJSMProject && editionFromTenantContext !== (0, $ldyPw.PREMIUM_EDITION)) isPinFieldConfigurabilityExperimentEnabled = (0, $6s1PB.expVal)('jira_pin_field_configurability_experiment', 'isPinFieldConfigurabilityEnabled', false);
    }
    const setPinnedFields = (0, $5uXOq.useCallback)((newPinnedFields)=>{
        const encoded = $08a3b5694d746d08$export$a26485c67d3d39ab(newPinnedFields);
        if (newPinnedFields.length > 0) {
            if (encoded.length > $08a3b5694d746d08$export$14202689ff202a64) return false;
            setPinnedFieldsUserPreferences.setValue(encoded);
            if (projectKey === bannerPreferenceProjectKey && isPinFieldConfigurabilityExperimentEnabled) setBannerPreferenceProjectKey && setBannerPreferenceProjectKey.setValue('{}');
            return true;
        }
        setPinnedFieldsUserPreferences.deleteValue();
        return true;
    }, [
        setPinnedFieldsUserPreferences,
        bannerPreferenceProjectKey,
        projectKey,
        setBannerPreferenceProjectKey,
        isPinFieldConfigurabilityExperimentEnabled
    ]);
    const sortPinnedField = (0, $5uXOq.useCallback)((idSource, idDestination, hasMovedUp)=>{
        const decodedFields = $08a3b5694d746d08$export$dc516a57c030b84a(rawPinnedFields);
        const indexSource = decodedFields.indexOf(idSource);
        if (indexSource === -1) return;
        decodedFields.splice(indexSource, 1);
        let indexDestination = decodedFields.indexOf(idDestination);
        if (indexDestination === -1) return;
        if (!hasMovedUp) indexDestination += 1;
        decodedFields.splice(indexDestination, 0, idSource);
        setPinnedFields(decodedFields);
    }, [
        rawPinnedFields,
        setPinnedFields
    ]);
    return [
        pinnedFields,
        setPinnedFields,
        sortPinnedField
    ];
};

});
parcelRegister("eNNkf", function(module, exports) {

$parcel$export(module.exports, "useUserPreferencesValue", () => $5092328ed6a09c60$export$8bd3660b16415efd);
$parcel$export(module.exports, "useUserPreferencesActions", () => $5092328ed6a09c60$export$eefe4b2985e8203e);

var $5uXOq = parcelRequire("5uXOq");

var $hLEug = parcelRequire("hLEug");

var $12pgs = parcelRequire("12pgs");
const $5092328ed6a09c60$export$8bd3660b16415efd = (userPreferenceKey)=>{
    const baseUrl = '';
    const [value, { setUserPreferenceValue: setUserPreferenceValue, deleteUserPreferenceValue: deleteUserPreferenceValue }] = (0, $hLEug.useUserPreferencesStoreValue)(userPreferenceKey);
    /**
	 * persist: boolean - if true, save the value to the server ,else just update the local state and return a promise with the new value
	 */ const setValue = (0, $5uXOq.useCallback)((newValue, persist = true)=>{
        setUserPreferenceValue(userPreferenceKey, newValue);
        if (!persist) return Promise.resolve(newValue);
        return (0, $12pgs.saveUserPreferenceValue)(baseUrl, userPreferenceKey, newValue);
    }, [
        baseUrl,
        setUserPreferenceValue,
        userPreferenceKey
    ]);
    const deleteValue = (0, $5uXOq.useCallback)(()=>{
        deleteUserPreferenceValue(userPreferenceKey);
        return (0, $12pgs.removeUserPreferenceValue)(baseUrl, userPreferenceKey);
    }, [
        baseUrl,
        deleteUserPreferenceValue,
        userPreferenceKey
    ]);
    const setUserPreferences = (0, $5uXOq.useMemo)(()=>({
            setValue: setValue,
            deleteValue: deleteValue
        }), [
        setValue,
        deleteValue
    ]);
    return [
        value,
        setUserPreferences
    ];
};
const $5092328ed6a09c60$export$eefe4b2985e8203e = ()=>{
    const baseUrl = '';
    const [, actions] = (0, $hLEug.useUserPreferencesStoreActions)();
    const userPreferenceActions = (0, $5uXOq.useMemo)(()=>{
        const setUserPreferenceValue = (userPreferenceKey, value)=>{
            actions.setUserPreferenceValue(userPreferenceKey, value);
            (0, $12pgs.saveUserPreferenceValue)(baseUrl, userPreferenceKey, value);
        };
        const deleteUserPreferenceValue = (userPreferenceKey)=>{
            actions.deleteUserPreferenceValue(userPreferenceKey);
            (0, $12pgs.removeUserPreferenceValue)(baseUrl, userPreferenceKey);
        };
        const setUserPreferences = (userPreferences)=>{
            userPreferences && Object.keys(userPreferences).length !== 0 && actions.setUserPreferences(userPreferences);
        };
        return {
            setUserPreferenceValue: setUserPreferenceValue,
            setUserPreferences: setUserPreferences,
            deleteUserPreferenceValue: deleteUserPreferenceValue,
            getUserPreferenceValue: actions.getUserPreferenceValue
        };
    }, [
        actions,
        baseUrl
    ]);
    return [
        null,
        userPreferenceActions
    ];
};

});
parcelRegister("hLEug", function(module, exports) {

$parcel$export(module.exports, "useUserPreferencesStoreValue", () => $f08ba98a3f2bdde2$export$46e7eeb2fc34fab8);
$parcel$export(module.exports, "useUserPreferencesStoreActions", () => $f08ba98a3f2bdde2$export$4d156074562bac9a);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $djdK3 = parcelRequire("djdK3");
const $f08ba98a3f2bdde2$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'user-preferences',
    initialState: {
        preferences: {}
    },
    actions: $djdK3.actions
});
const $f08ba98a3f2bdde2$var$getUserPreference = (state, userPreferenceKey)=>state.preferences[userPreferenceKey];
const $f08ba98a3f2bdde2$export$46e7eeb2fc34fab8 = (0, $3sQ5x.createHook)($f08ba98a3f2bdde2$export$6f57813fe9f31bf9, {
    selector: $f08ba98a3f2bdde2$var$getUserPreference
});
const $f08ba98a3f2bdde2$export$4d156074562bac9a = (0, $3sQ5x.createHook)($f08ba98a3f2bdde2$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("djdK3", function(module, exports) {

$parcel$export(module.exports, "actions", () => $5c68f1b920b8984c$export$e324594224ef24da);
const $5c68f1b920b8984c$var$setUserPreferenceValue = (key, value)=>({ setState: setState, getState: getState })=>{
        setState({
            preferences: {
                ...getState().preferences,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [key]: value
            }
        });
    };
const $5c68f1b920b8984c$var$deleteUserPreferenceValue = (key)=>({ setState: setState, getState: getState })=>{
        const { [key]: _, ...preferences } = getState().preferences;
        setState({
            preferences: preferences
        });
    };
const $5c68f1b920b8984c$var$setUserPreferences = (state)=>({ setState: setState })=>{
        setState({
            preferences: state
        });
    };
const $5c68f1b920b8984c$export$df0a4f67b9888111 = (key)=>({ getState: getState })=>{
        const { preferences: preferences } = getState();
        return preferences[key];
    };
const $5c68f1b920b8984c$export$e324594224ef24da = {
    setUserPreferenceValue: $5c68f1b920b8984c$var$setUserPreferenceValue,
    deleteUserPreferenceValue: $5c68f1b920b8984c$var$deleteUserPreferenceValue,
    setUserPreferences: $5c68f1b920b8984c$var$setUserPreferences,
    getUserPreferenceValue: $5c68f1b920b8984c$export$df0a4f67b9888111
};

});


parcelRegister("12pgs", function(module, exports) {

$parcel$export(module.exports, "saveUserPreferenceValue", () => $0dfd1081a7a72732$export$bebe1b9e9f4cbf16);
$parcel$export(module.exports, "removeUserPreferenceValue", () => $0dfd1081a7a72732$export$a60a810760d07867);

var $eusud = parcelRequire("eusud");
const $0dfd1081a7a72732$export$bebe1b9e9f4cbf16 = async (baseUrl, userPreferenceKey, value)=>(0, $eusud.performPutRequest)(`${baseUrl}/rest/api/2/mypreferences?key=${userPreferenceKey}`, {
        body: value
    });
const $0dfd1081a7a72732$export$a60a810760d07867 = async (baseUrl, userPreferenceKey)=>(0, $eusud.performDeleteRequest)(`${baseUrl}/rest/api/2/mypreferences?key=${userPreferenceKey}`);

});





parcelRegister("kyWip", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2477292346cf3b2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a2477292346cf3b2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    none: {
        "id": "software-backlog-panel.epic.epic-panel.epic-card-list.epic-card.card-contents.date-field.none",
        "defaultMessage": "None"
    },
    startDate: {
        "id": "software-backlog-panel.epic.epic-panel.epic-card-list.epic-card.card-contents.date-field.start-date",
        "defaultMessage": "Start date"
    },
    dueDate: {
        "id": "software-backlog-panel.epic.epic-panel.epic-card-list.epic-card.card-contents.date-field.due-date",
        "defaultMessage": "Due date"
    }
});

});



parcelRegister("l47Zr", function(module, exports) {

$parcel$export(module.exports, "CardContentsErrorState", () => $58c552d824628b0a$export$e2681b64266270a0);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $bU3PY = parcelRequire("bU3PY");

var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $9AN8t = parcelRequire("9AN8t");
const $58c552d824628b0a$export$e2681b64266270a0 = ({ onRefetch: onRefetch })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onClick = (e)=>{
        e.stopPropagation();
        onRefetch({
            triggerLoadingState: true
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        alignInline: "center",
        xcss: $58c552d824628b0a$var$errorStateContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
        spacing: "spacious",
        label: "",
        color: "var(--ds-icon-warning, #E56910)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $9AN8t.default).errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "link",
        onClick: onClick
    }, formatMessage((0, $9AN8t.default).tryAgain)));
};
const $58c552d824628b0a$var$errorStateContainerStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});

});
parcelRegister("9AN8t", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ed9d11114d90434$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5ed9d11114d90434$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorMessage: {
        "id": "software-backlog-panel.epic.epic-panel.epic-card-list.epic-card.card-contents.error-state.error-message.non-final",
        "defaultMessage": "Unable to load data"
    },
    tryAgain: {
        "id": "software-backlog-panel.epic.epic-panel.epic-card-list.epic-card.card-contents.error-state.try-again.non-final",
        "defaultMessage": "Try again"
    }
});

});


parcelRegister("fx51X", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1cdf7b3ba166a0a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $dS3PR = parcelRequire("dS3PR");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $2NY4b = parcelRequire("2NY4b");
const $c1cdf7b3ba166a0a$var$IssueKeyField = ({ issueId: issueId, issueKey: issueKey, onDetailClick: onDetailClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onClick = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        e.stopPropagation();
        const withCmd = e.ctrlKey || e.metaKey;
        // ensure this doesn't interfere with opening the link in a new window
        if (!withCmd) {
            e.preventDefault();
            onDetailClick(issueId);
        }
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'onEpicPanelIssueKeyClick', {
            withCmd: withCmd
        });
    }, [
        issueId,
        onDetailClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c1cdf7b3ba166a0a$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), null, formatMessage((0, $2NY4b.default).label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c1cdf7b3ba166a0a$var$StyledButton, {
        href: `/browse/${issueKey}`,
        target: "_blank",
        onClick: onClick,
        appearance: "subtle-link",
        spacing: "none"
    }, issueKey));
};
var $c1cdf7b3ba166a0a$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $c1cdf7b3ba166a0a$var$IssueKeyField;
const $c1cdf7b3ba166a0a$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c1cdf7b3ba166a0a$var$StyledButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _k48pi7a9 _syaz131l",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2NY4b", function(module, exports) {

$parcel$export(module.exports, "default", () => $58c302a327a01867$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $58c302a327a01867$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-backlog-panel.epic.epic-panel.epic-card-list.epic-card.card-contents.issue-key-field.label",
        "defaultMessage": "Key"
    }
});

});


parcelRegister("hg2Om", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd324d5ff304e9de$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bd324d5ff304e9de$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    empty: {
        "id": "software-backlog-panel.epic.epic-panel.epic-card-list.epic-card.card-contents.empty",
        "defaultMessage": "No issues"
    },
    viewAllDetails: {
        "id": "software-backlog-panel.epic.epic-panel.epic-card-list.epic-card.card-contents.view-all-details",
        "defaultMessage": "View all details"
    },
    viewDetails: {
        "id": "software-backlog-panel.epic.epic-panel.epic-card-list.epic-card.card-contents.view-details",
        "defaultMessage": "View details"
    },
    createIssue: {
        "id": "software-backlog-panel.epic.epic-panel.epic-card-list.epic-card.card-contents.create-issue",
        "defaultMessage": "Create issue"
    },
    startDate: {
        "id": "software-backlog-panel.epic.epic-panel.epic-card-list.epic-card.card-contents.start-date",
        "defaultMessage": "Start date"
    },
    dueDate: {
        "id": "software-backlog-panel.epic.epic-panel.epic-card-list.epic-card.card-contents.due-date",
        "defaultMessage": "Due date"
    },
    createIssueIssueTermRefresh: {
        "id": "software-backlog-panel.epic.epic-panel.epic-card-list.epic-card.card-contents.create-issue-issue-term-refresh",
        "defaultMessage": "Create work item"
    },
    emptyIssueTermRefresh: {
        "id": "software-backlog-panel.epic.epic-panel.epic-card-list.epic-card.card-contents.empty-issue-term-refresh",
        "defaultMessage": "No work items"
    }
});

});


parcelRegister("crMwx", function(module, exports) {

$parcel$export(module.exports, "default", () => $b081a9cddb3e06b3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b081a9cddb3e06b3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    unassigned: {
        "id": "software-backlog-panel.epic.epic-panel.epic-card-list.epic-card.unassigned",
        "defaultMessage": "Issues without {target}"
    },
    confirmMessage: {
        "id": "software-backlog-panel.epic.epic-panel.epic-card-list.epic-card.confirm-message",
        "defaultMessage": "{numberOfIssues, plural, one {{issueKey} added to {epicIssueTypeName}} other {# issues added to {epicIssueTypeName}}}"
    },
    unassignedIssueTermRefresh: {
        "id": "software-backlog-panel.epic.epic-panel.epic-card-list.epic-card.unassigned-issue-term-refresh",
        "defaultMessage": "No {target}"
    },
    confirmMessageIssueTermRefresh: {
        "id": "software-backlog-panel.epic.epic-panel.epic-card-list.epic-card.confirm-message-issue-term-refresh",
        "defaultMessage": "{numberOfIssues, plural, one {{issueKey} added to {epicIssueTypeName}} other {# work items added to {epicIssueTypeName}}}"
    }
});

});

parcelRegister("5dyzd", function(module, exports) {

$parcel$export(module.exports, "useDropToAssignEpic", () => $d9ba7763746d45e8$export$7d507c16fe13b7b7);
/*!
 * This module handles assigning cards to epics.
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $3JOCw = parcelRequire("3JOCw");

var $7gWdR = parcelRequire("7gWdR");

var $2YZCu = parcelRequire("2YZCu");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $fZneA = parcelRequire("fZneA");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $g4tDr = parcelRequire("g4tDr");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $1fZVH = parcelRequire("1fZVH");

var $7D59a = parcelRequire("7D59a");

var $ctrpc = parcelRequire("ctrpc");

var $5fc53 = parcelRequire("5fc53");

var $8ikZj = parcelRequire("8ikZj");

var $dZggJ = parcelRequire("dZggJ");

var $9AGgt = parcelRequire("9AGgt");

var $f9XJh = parcelRequire("f9XJh");

var $kjI4q = parcelRequire("kjI4q");

var $eTmfE = parcelRequire("eTmfE");

var $2tzyg = parcelRequire("2tzyg");
const $d9ba7763746d45e8$export$9bf4c574a476052 = (draggableId)=>draggableId.startsWith((0, $dZggJ.DIVIDER_DRAGGABLE_ID_PREFIX));
const $d9ba7763746d45e8$export$9839a30325a25e4f = (selectedIssues, parentId)=>selectedIssues.filter((issue)=>issue.parentId !== parentId);
const $d9ba7763746d45e8$export$20208a9cf96e51fd = (analyticsEvent, dndOperation, numIssues)=>{
    (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'issueParent updated', {
        analyticsSource: (0, $dZggJ.ANALYTICS_SOURCE_EPIC_PANEL),
        issueHierarchyLevel: (0, $g4tDr.ISSUE_HIERARCHY_LEVEL_BASE),
        operation: dndOperation,
        numIssues: numIssues
    });
};
function $d9ba7763746d45e8$export$2bb79709b1ac493e({ epicId: epicId, boardId: boardId, selectedIssues: selectedIssues, isDropAllowed: isDropAllowed, isCompanyManaged: isCompanyManaged, toggleMessage: toggleMessage, onAssignEpic: onAssignEpic, setIsDraggingOver: setIsDraggingOver }) {
    const isAssign = epicId !== (0, $dZggJ.UNASSIGNED_EPIC_ID);
    const [assignEpic] = (0, $9AGgt.useAssignEpicMutation)(boardId);
    const [unassignEpic] = (0, $f9XJh.useUnassignEpicMutation)(boardId);
    const [updateEpicParent] = (0, $kjI4q.useUpdateEpicParentMutation)(boardId);
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { fireExperienceStart: fireExperienceStart, fireExperienceError: fireExperienceError, fireExperienceSuccess: fireExperienceSuccess } = (0, $2tzyg.useDropToAssignExperienceTracker)({
        isCompanyManaged: isCompanyManaged,
        epicId: epicId
    });
    const { setStartInteraction: setStartInteraction, setStopInteraction: setStopInteraction, setCancelInteraction: setCancelInteraction, dndOperation: dndOperation, errorLogId: errorLogId, errorLogMessage: errorLogMessage } = (0, $2tzyg.getDropToAssignMarks)({
        epicId: epicId
    });
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onDrop = (0, $7D59a.useEvent)((data)=>{
        setIsDraggingOver(false);
        if (!isDropAllowed()) {
            showFlag({
                messageId: 'software-backlog-panel.ui.epic.epic-panel.epic-card-list.epic-card.use-drop-to-assign-epic.show-flag.warning.ssign-subtask-to-epic-error',
                messageType: 'transactional',
                type: 'warning',
                title: formatMessage((0, $eTmfE.default).assignSubtaskToEpicErrorFlagTitle),
                description: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eTmfE.default).assignSubtaskToEpicErrorDescriptionIssueTermRefresh : (0, $eTmfE.default).assignSubtaskToEpicErrorDescription),
                isAutoDismiss: true
            });
            return;
        }
        const changedIssues = (0, $4R6GH.fg)('jsw_backlog_pragmatic_dnd_automatic_batching') ? (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))([
            ...$d9ba7763746d45e8$export$9839a30325a25e4f(selectedIssues, epicId),
            {
                id: Number(data.cardId)
            }
        ], 'id') : $d9ba7763746d45e8$export$9839a30325a25e4f(selectedIssues, epicId);
        if ($d9ba7763746d45e8$export$9bf4c574a476052(String(data.type)) || !changedIssues.length) return;
        const isMessageUsed = data.cardParentId !== null;
        toggleMessage(true, isMessageUsed);
        let mutateEpicPromise;
        if ((0, $4R6GH.fg)('jira-epic-panel-unify-epic-mutations')) mutateEpicPromise = updateEpicParent(changedIssues, epicId);
        else mutateEpicPromise = isAssign ? assignEpic(changedIssues, epicId) : unassignEpic(changedIssues);
        if (changedIssues.length === 1 && (0, $4R6GH.fg)('one_event_rules_them_all_fg')) {
            const firstSelectedIssue = selectedIssues[0];
            (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd((0, $8ikZj.DRAG_DROP_UNKNOWN_FIELD_ID), {
                analytics: createAnalyticsEvent({}),
                attributes: {
                    fieldType: (0, $8ikZj.FIELD_TYPE_MAP)[0, $5fc53.PARENT_TYPE],
                    fieldKey: (0, $5fc53.PARENT_TYPE),
                    isDragEditing: true,
                    oldValId: firstSelectedIssue.parentId || undefined,
                    newValId: epicId === (0, $dZggJ.UNASSIGNED_EPIC_ID) ? null : epicId,
                    ...(0, $4R6GH.fg)('one_event_improvements_1') && {
                        issueId: firstSelectedIssue.id || undefined
                    }
                }
            });
        }
        setStartInteraction();
        fireExperienceStart();
        const analyticsEvent = createAnalyticsEvent({
            action: 'droppedIn',
            actionSubject: 'card'
        });
        mutateEpicPromise.then(()=>{
            setStopInteraction(isCompanyManaged);
            fireExperienceSuccess();
            $d9ba7763746d45e8$export$20208a9cf96e51fd(analyticsEvent, dndOperation, changedIssues.length);
            onAssignEpic(changedIssues, epicId, mutateEpicPromise.then(()=>undefined));
        }).catch((error)=>{
            setCancelInteraction();
            fireExperienceError(error);
            if (error.graphQLErrors?.length) showFlag({
                messageId: 'software-backlog-panel.ui.epic.epic-panel.epic-card-list.epic-card.use-drop-to-assign-epic.show-flag.error.generic-assign-to-epic-error',
                messageType: 'transactional',
                type: 'error',
                title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eTmfE.default).genericAssignToEpicErrorFlagTitleIssueTermRefresh : (0, $eTmfE.default).genericAssignToEpicErrorFlagTitle),
                description: error.graphQLErrors[0].message
            });
            toggleMessage(false, isMessageUsed);
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'cards moveFailed', {
                numCards: selectedIssues.length,
                errorMessage: error.message,
                operation: dndOperation,
                isClientFetchError: (0, $fZneA.isClientFetchError)(error),
                analyticsSource: (0, $dZggJ.ANALYTICS_SOURCE_EPIC_PANEL),
                issueHierarchyLevel: (0, $g4tDr.ISSUE_HIERARCHY_LEVEL_BASE)
            });
            (0, $2YZCu.default).safeErrorWithoutCustomerData(errorLogId, errorLogMessage, error);
        });
    });
    return onDrop;
}
function $d9ba7763746d45e8$export$7d507c16fe13b7b7({ ref: ref, epicId: epicId, isDropAllowed: isDropAllowed, boardId: boardId, selectedIssues: selectedIssues, isCompanyManaged: isCompanyManaged, toggleMessage: toggleMessage, onAssignEpic: onAssignEpic }) {
    const [isDraggingOver, setIsDraggingOver] = (0, $5uXOq.useState)(false);
    const onDrop = $d9ba7763746d45e8$export$2bb79709b1ac493e({
        isDropAllowed: isDropAllowed,
        epicId: epicId,
        setIsDraggingOver: setIsDraggingOver,
        boardId: boardId,
        selectedIssues: selectedIssues,
        isCompanyManaged: isCompanyManaged,
        toggleMessage: toggleMessage,
        onAssignEpic: onAssignEpic
    });
    const autobatch = (0, $1fZVH.useAutobatch)();
    (0, $5uXOq.useEffect)(()=>{
        if (!ref.current) return undefined;
        return (0, $7gWdR.dropTargetForElements)({
            element: ref.current,
            canDrop: (args)=>isDropAllowed() && args.source.data.type === 'CARD_DRAGGABLE_ID',
            onDragEnter () {
                autobatch(()=>{
                    setIsDraggingOver(true);
                });
            },
            onDragLeave () {
                autobatch(()=>{
                    setIsDraggingOver(false);
                });
            },
            onDrop ({ source: { data: data } }) {
                autobatch(()=>{
                    onDrop(data);
                });
            }
        });
    }, [
        autobatch,
        isDropAllowed,
        onDrop,
        ref
    ]);
    return {
        isDraggingOver: isDraggingOver
    };
}

});
parcelRegister("9AGgt", function(module, exports) {

$parcel$export(module.exports, "useAssignEpicMutation", () => $c0b1817e49a98f89$export$298b1411cf04f999);

var $5tTFS = parcelRequire("5tTFS");

var $5cllN = parcelRequire("5cllN");
const $c0b1817e49a98f89$export$d83b85686a2b469b = (0, $5cllN.default)`mutation BacklogIssueParentAssign(
        $boardId: ID!,
        $issueParentId: ID!,
        $issueIds: [ID!]!
    ) {
        assignIssueParent(input: {boardId: $boardId, issueParentId: $issueParentId, issueIds: $issueIds }) {
            success
        }
    }`;
const $c0b1817e49a98f89$export$298b1411cf04f999 = (boardId)=>{
    const [mutate, epicAssigningMutationData] = (0, $5tTFS.useMutation)($c0b1817e49a98f89$export$d83b85686a2b469b);
    const assignEpic = (issues, issueParentId)=>mutate({
            variables: {
                boardId: boardId,
                issueParentId: issueParentId,
                issueIds: issues.map(({ id: id })=>id)
            }
        });
    return [
        assignEpic,
        epicAssigningMutationData
    ];
};

});

parcelRegister("f9XJh", function(module, exports) {

$parcel$export(module.exports, "useUnassignEpicMutation", () => $92097e250bf75093$export$fcbac19f293b4ded);

var $5tTFS = parcelRequire("5tTFS");

var $5cllN = parcelRequire("5cllN");
const $92097e250bf75093$export$625a6e494debab48 = (0, $5cllN.default)`mutation BacklogissueParentUnassign(
        $boardId: ID!,
        $issueIds: [ID!]!
    ) {
        unassignIssueParent(input: { boardId: $boardId, issueIds: $issueIds }) {
            success
        }
    }`;
const $92097e250bf75093$export$fcbac19f293b4ded = (boardId)=>{
    const [mutate, epicAssigningMutationData] = (0, $5tTFS.useMutation)($92097e250bf75093$export$625a6e494debab48);
    const unassignEpic = (issues)=>mutate({
            variables: {
                boardId: boardId,
                issueIds: issues.map(({ id: id })=>id)
            }
        });
    return [
        unassignEpic,
        epicAssigningMutationData
    ];
};

});

parcelRegister("kjI4q", function(module, exports) {

$parcel$export(module.exports, "useUpdateEpicParentMutation", () => $0fb00ef53900f89e$export$26d25f10f71cac80);

var $5tTFS = parcelRequire("5tTFS");

var $5cllN = parcelRequire("5cllN");

var $dZggJ = parcelRequire("dZggJ");
const $0fb00ef53900f89e$export$5910797136f46b0 = (0, $5cllN.default)`mutation BacklogIssueParentUpdate(
        $boardId: ID!,
        $issueParentId: ID,
        $issueIds: [ID!]!
    ) {
        updateIssueParent(input: {boardId: $boardId, issueParentId: $issueParentId, issueIds: $issueIds }) {
            success
        }
    }`;
const $0fb00ef53900f89e$export$26d25f10f71cac80 = (boardId)=>{
    const [mutate, epicParentUpdateMutationData] = (0, $5tTFS.useMutation)($0fb00ef53900f89e$export$5910797136f46b0);
    const updateParent = (issues, issueParentId)=>mutate({
            variables: {
                boardId: boardId,
                issueParentId: issueParentId === (0, $dZggJ.UNASSIGNED_EPIC_ID) ? null : issueParentId,
                issueIds: issues.map(({ id: id })=>id)
            }
        });
    return [
        updateParent,
        epicParentUpdateMutationData
    ];
};

});

parcelRegister("eTmfE", function(module, exports) {

$parcel$export(module.exports, "default", () => $194cbd59367efe29$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $194cbd59367efe29$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    assignSubtaskToEpicErrorFlagTitle: {
        "id": "software-backlog-panel.epic.epic-panel.epic-card.assign-subtask-to-epic-error-flag-title",
        "defaultMessage": "You can\u2019t add subtasks to epics"
    },
    assignSubtaskToEpicErrorDescription: {
        "id": "software-backlog-panel.epic.epic-panel.epic-card.assign-subtask-to-epic-error-description",
        "defaultMessage": "Subtasks are automatically associated with the same epic as their parent issues. To associate a subtask with an epic, drag its parent issue to an epic in the panel."
    },
    genericAssignToEpicErrorFlagTitle: {
        "id": "software-backlog-panel.epic.epic-panel.epic-card.generic-assign-to-epic-error-flag-title",
        "defaultMessage": "Issue can\u2019t be added to epic"
    },
    assignSubtaskToEpicErrorDescriptionIssueTermRefresh: {
        "id": "software-backlog-panel.epic.epic-panel.epic-card.assign-subtask-to-epic-error-description-issue-term-refresh",
        "defaultMessage": "Subtasks are automatically associated with the same epic as their parent work item. To associate a subtask with an epic, drag its parent work item to an epic in the panel."
    },
    genericAssignToEpicErrorFlagTitleIssueTermRefresh: {
        "id": "software-backlog-panel.epic.epic-panel.epic-card.generic-assign-to-epic-error-flag-title-issue-term-refresh",
        "defaultMessage": "Work item can\u2019t be added to epic"
    }
});

});

parcelRegister("2tzyg", function(module, exports) {

$parcel$export(module.exports, "useDropToAssignExperienceTracker", () => $a63b6ffaac8a734b$export$8c195544da4a5084);
$parcel$export(module.exports, "getDropToAssignMarks", () => $a63b6ffaac8a734b$export$39d48c71eb264bf3);
/*!
 * Currently there are separate experiences and metrics for assign/unassign and hundreds of lines of
 * boilerplate code to handle that split. This is part of the same thing.
 *
 * We should remove this duplication.
 */ 
var $dZggJ = parcelRequire("dZggJ");

var $3aqXA = parcelRequire("3aqXA");

var $hqma7 = parcelRequire("hqma7");
function $a63b6ffaac8a734b$export$8c195544da4a5084({ epicId: epicId, isCompanyManaged: isClassic }) {
    const isAssign = epicId !== (0, $dZggJ.UNASSIGNED_EPIC_ID);
    const options = {
        isClassic: isClassic
    };
    const assignTracker = (0, $3aqXA.useAssignEpicPanelExperienceTracker)(options);
    const unassignTracker = (0, $3aqXA.useUnassignEpicPanelExperienceTracker)(options);
    return isAssign ? assignTracker : unassignTracker;
}
function $a63b6ffaac8a734b$export$39d48c71eb264bf3({ epicId: epicId }) {
    const isAssign = epicId !== (0, $dZggJ.UNASSIGNED_EPIC_ID);
    return isAssign ? (0, $hqma7.assignEpicUtils) : (0, $hqma7.unassignEpicUtils);
}

});
parcelRegister("hqma7", function(module, exports) {

$parcel$export(module.exports, "assignEpicUtils", () => $c47e69c0bbcc3bbf$export$eddfdc1410ae7842);
$parcel$export(module.exports, "unassignEpicUtils", () => $c47e69c0bbcc3bbf$export$676852cea2b5b8d9);
/**
 * TODO: Please deprecate this.
 */ 
var $dZggJ = parcelRequire("dZggJ");

var $6liM3 = parcelRequire("6liM3");

var $kxUAX = parcelRequire("kxUAX");
const $c47e69c0bbcc3bbf$export$eddfdc1410ae7842 = {
    setStartInteraction: (0, $6liM3.setBacklogPanelEpicAssignInteractionStartMark),
    setStopInteraction: (0, $6liM3.stopBacklogPanelEpicAssignInteraction),
    setCancelInteraction: (0, $6liM3.cancelBacklogPanelEpicAssignInteraction),
    dndOperation: (0, $dZggJ.DND_OPERATION_CARD_PARENT_SET),
    errorLogId: 'epic-assign.failure',
    errorLogMessage: 'Failed to assign an epic'
};
const $c47e69c0bbcc3bbf$export$676852cea2b5b8d9 = {
    setStartInteraction: (0, $kxUAX.setBacklogPanelEpicUnassignInteractionStartMark),
    setStopInteraction: (0, $kxUAX.stopBacklogPanelEpicUnassignInteraction),
    setCancelInteraction: (0, $kxUAX.cancelBacklogPanelEpicUnassignInteraction),
    dndOperation: (0, $dZggJ.DND_OPERATION_CARD_PARENT_UNSET),
    errorLogId: 'epic-unassign.failure',
    errorLogMessage: 'Failed to unassign an epic'
};

});
parcelRegister("6liM3", function(module, exports) {

$parcel$export(module.exports, "setBacklogPanelEpicAssignInteractionStartMark", () => $cf23d8c4f9c28dc5$export$5b8d779af53c98ae);
$parcel$export(module.exports, "cancelBacklogPanelEpicAssignInteraction", () => $cf23d8c4f9c28dc5$export$d2ff6f83e36c7bf6);
$parcel$export(module.exports, "stopBacklogPanelEpicAssignInteraction", () => $cf23d8c4f9c28dc5$export$33d5032d95ee9f38);

var $dGrdR = parcelRequire("dGrdR");
const $cf23d8c4f9c28dc5$var$backlogPanelEpicAssignInteraction = (0, $dGrdR.metrics).interaction({
    key: 'backlog-panel.epic-assign',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '1000_1500_2000_2500_3000_4000'
    }
});
const $cf23d8c4f9c28dc5$export$5b8d779af53c98ae = ()=>{
    $cf23d8c4f9c28dc5$var$backlogPanelEpicAssignInteraction.start();
};
const $cf23d8c4f9c28dc5$export$d2ff6f83e36c7bf6 = ()=>{
    $cf23d8c4f9c28dc5$var$backlogPanelEpicAssignInteraction.cancel();
};
const $cf23d8c4f9c28dc5$export$33d5032d95ee9f38 = (isCompanyManaged)=>{
    $cf23d8c4f9c28dc5$var$backlogPanelEpicAssignInteraction.stop({
        customData: {
            isCompanyManaged: isCompanyManaged
        }
    });
};

});

parcelRegister("kxUAX", function(module, exports) {

$parcel$export(module.exports, "setBacklogPanelEpicUnassignInteractionStartMark", () => $c0ec2b97632bf349$export$dd61028582faa886);
$parcel$export(module.exports, "cancelBacklogPanelEpicUnassignInteraction", () => $c0ec2b97632bf349$export$dc9b3b83663f0208);
$parcel$export(module.exports, "stopBacklogPanelEpicUnassignInteraction", () => $c0ec2b97632bf349$export$5a7628a0610b2a9c);

var $dGrdR = parcelRequire("dGrdR");
const $c0ec2b97632bf349$var$backlogPanelEpicUnassignInteraction = (0, $dGrdR.metrics).interaction({
    key: 'backlog-panel.epic-unassign',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '1000_1500_2000_2500_3000_4000'
    }
});
const $c0ec2b97632bf349$export$dd61028582faa886 = ()=>{
    $c0ec2b97632bf349$var$backlogPanelEpicUnassignInteraction.start();
};
const $c0ec2b97632bf349$export$dc9b3b83663f0208 = ()=>{
    $c0ec2b97632bf349$var$backlogPanelEpicUnassignInteraction.cancel();
};
const $c0ec2b97632bf349$export$5a7628a0610b2a9c = (isCompanyManaged)=>{
    $c0ec2b97632bf349$var$backlogPanelEpicUnassignInteraction.stop({
        customData: {
            isCompanyManaged: isCompanyManaged
        }
    });
};

});





parcelRegister("6sKhR", function(module, exports) {

$parcel$export(module.exports, "useRankEpic", () => $da5a7f8261143a69$export$96c39ff011215387);
$parcel$export(module.exports, "useDragToRankEpic", () => $da5a7f8261143a69$export$177c73b8ff0487a8);
/*!
 * This module handles *ranking* drag-and-drop of epic cards to re-order them.
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $biEfA = parcelRequire("biEfA");

var $4hDdm = parcelRequire("4hDdm");

var $7gWdR = parcelRequire("7gWdR");
parcelRequire("2Uxmu");
var $hJNa8 = parcelRequire("hJNa8");
parcelRequire("erBEN");
var $kpXwZ = parcelRequire("kpXwZ");

var $fZneA = parcelRequire("fZneA");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $1fZVH = parcelRequire("1fZVH");

var $dZggJ = parcelRequire("dZggJ");

var $jLeW1 = parcelRequire("jLeW1");

var $3aqXA = parcelRequire("3aqXA");

var $bWSeB = parcelRequire("bWSeB");
function $da5a7f8261143a69$export$96c39ff011215387(boardId, isCompanyManaged) {
    const [rankEpics] = (0, $jLeW1.useRankEpicsMutation)(boardId);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { fireExperienceStart: fireRankExperienceStart, fireExperienceSuccess: fireRankExperienceSuccess, fireExperienceError: fireRankExperienceError } = (0, $3aqXA.useRankExperienceTracker)({
        isClassic: isCompanyManaged
    });
    const analyticsEvent = createAnalyticsEvent({
        action: 'droppedWithin',
        actionSubject: 'card'
    });
    return (0, $5uXOq.useCallback)(({ epicId: epicId, index: index })=>{
        if (!epicId) return;
        (0, $bWSeB.setBacklogPanelEpicRankInteractionStartMark)();
        fireRankExperienceStart();
        rankEpics([
            epicId
        ], index).then(()=>{
            (0, $bWSeB.stopBacklogPanelEpicRankInteraction)(isCompanyManaged);
            fireRankExperienceSuccess();
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'issueRank updated');
        }).catch((error)=>{
            (0, $bWSeB.cancelBacklogPanelEpicRankInteraction)();
            fireRankExperienceError(error);
            // only support signal card ranking in epic panel
            const numOfSelectedCards = 1;
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'cards moveFailed', {
                numCards: numOfSelectedCards,
                errorMessage: error.message,
                operation: (0, $dZggJ.DND_OPERATION_EPIC_RANK_UPDATE),
                isClientFetchError: (0, $fZneA.isClientFetchError)(error)
            });
        });
    }, [
        isCompanyManaged,
        rankEpics,
        analyticsEvent,
        fireRankExperienceError,
        fireRankExperienceStart,
        fireRankExperienceSuccess
    ]);
}
function $da5a7f8261143a69$export$177c73b8ff0487a8({ ref: ref, epicId: epicId, index: index, isDropAllowed: isDropAllowed, rankEpic: rankEpic }) {
    const [dragState, setDragState] = (0, $5uXOq.useState)({
        type: 'idle'
    });
    const [closestEdge, setClosestEdge] = (0, $5uXOq.useState)(null);
    const autobatch = (0, $1fZVH.useAutobatch)();
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!ref?.current) return undefined;
        return (0, $4hDdm.combine)((0, $7gWdR.draggable)({
            element: ref.current,
            getInitialData: ()=>({
                    type: 'EPIC_CARD',
                    epicId: epicId
                }),
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onDragStart: ()=>{},
            onDrop: (_args)=>{
                autobatch(()=>{
                    setDragState({
                        type: 'idle'
                    });
                });
            },
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                (0, $kpXwZ.setCustomNativeDragPreview)({
                    getOffset: (0, $hJNa8.pointerOutsideOfPreview)({
                        x: '-16px',
                        y: '-16px'
                    }),
                    render ({ container: container }) {
                        setDragState({
                            type: 'dragging',
                            container: container
                        });
                        return ()=>setDragState({
                                type: 'idle'
                            });
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            }
        }), (0, $7gWdR.dropTargetForElements)({
            element: ref.current,
            getIsSticky: ()=>true,
            getData: ({ input: input, element: element })=>{
                const data = {
                    type: 'EPIC_CARD',
                    epicId: epicId
                };
                return (0, $biEfA.attachClosestEdge)(data, {
                    input: input,
                    element: element,
                    allowedEdges: [
                        'top',
                        'bottom'
                    ]
                });
            },
            onDrag: (args)=>{
                if (args.source.data.type === 'EPIC_CARD' && args.source.data.epicId !== epicId) autobatch(()=>{
                    setClosestEdge((0, $biEfA.extractClosestEdge)(args.self.data));
                });
            },
            onDragEnter: (args)=>{
                if (args.source.data.type === 'EPIC_CARD' && args.source.data.epicId !== epicId) autobatch(()=>{
                    setClosestEdge((0, $biEfA.extractClosestEdge)(args.self.data));
                });
            },
            onDragLeave: (args)=>{
                if (args.source.data.type === 'EPIC_CARD') autobatch(()=>{
                    setClosestEdge(null);
                });
            },
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onDropTargetChange: (_args)=>{},
            canDrop: (args)=>args.source.data.type === 'EPIC_CARD' && args.source.data.epicId !== epicId && isDropAllowed(),
            onDrop: (args)=>{
                const sourceEpicId = Number(args.source.data.epicId);
                const targetEpicId = Number(args.self.data.epicId);
                autobatch(()=>{
                    setClosestEdge(null);
                    if (sourceEpicId !== targetEpicId) rankEpic({
                        epicId: sourceEpicId,
                        index: index
                    });
                });
            }
        }));
    }, [
        ref,
        epicId,
        rankEpic,
        index,
        isDropAllowed,
        autobatch
    ]);
    return {
        dragState: dragState,
        closestEdge: closestEdge
    };
}

});
parcelRegister("biEfA", function(module, exports) {

$parcel$export(module.exports, "attachClosestEdge", () => $934cfe81468fb31a$export$f0cafff222395e89);
$parcel$export(module.exports, "extractClosestEdge", () => $934cfe81468fb31a$export$945a571f3b658bf);
const $934cfe81468fb31a$var$getDistanceToEdge = {
    top: (rect, client)=>Math.abs(client.y - rect.top),
    right: (rect, client)=>Math.abs(rect.right - client.x),
    bottom: (rect, client)=>Math.abs(rect.bottom - client.y),
    left: (rect, client)=>Math.abs(client.x - rect.left)
};
// using a symbol so we can guarantee a key with a unique value
const $934cfe81468fb31a$var$uniqueKey = Symbol('closestEdge');
function $934cfe81468fb31a$export$f0cafff222395e89(userData, { element: element, input: input, allowedEdges: allowedEdges }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    // I tried caching the result of `getBoundingClientRect()` for a single
    // frame in order to improve performance.
    // However, on measurement I saw no improvement. So no longer caching
    const rect = element.getBoundingClientRect();
    const entries = allowedEdges.map((edge)=>{
        return {
            edge: edge,
            value: $934cfe81468fb31a$var$getDistanceToEdge[edge](rect, client)
        };
    });
    // edge can be `null` when `allowedEdges` is []
    const addClosestEdge = entries.sort((a, b)=>a.value - b.value)[0]?.edge ?? null;
    return {
        ...userData,
        [$934cfe81468fb31a$var$uniqueKey]: addClosestEdge
    };
}
function $934cfe81468fb31a$export$945a571f3b658bf(userData) {
    return userData[$934cfe81468fb31a$var$uniqueKey] ?? null;
}

});

parcelRegister("2Uxmu", function(module, exports) {

$parcel$export(module.exports, "pointerOutsideOfPreview", () => (parcelRequire("hJNa8")).pointerOutsideOfPreview);

var $hJNa8 = parcelRequire("hJNa8");

});
parcelRegister("hJNa8", function(module, exports) {

$parcel$export(module.exports, "pointerOutsideOfPreview", () => $4030604dbfde028c$export$427e20518819fabc);

var $6NnQH = parcelRequire("6NnQH");
function $4030604dbfde028c$export$427e20518819fabc(point) {
    return ({ container: container })=>{
        /**
		 * **Approach: transparent borders.**
		 *
		 * The only reliable cross browser technique found to push a
		 * drag preview away from the cursor is to use transparent borders on the container.
		 *
		 * **🙅📱 Not pushing the preview away on iOS**
		 *
		 * On iOS, the browser will set the transparent border color to be black. We can provide a
		 * more polished experience not using the transparent border on iOS.
		 *
		 * While dragging, iOS will shift the drag preview under the center of the users pointer,
		 * so the "pushing away" of the preview is short lived on iOS anyway.
		 *
		 * Notes:
		 *
		 * - Tested on `iOS@18.4.1` on May 7th 2025
		 * - If you set the background color on the `container` the border color will be that
		 * - Setting a transparent background color on the `container` still results in a black border
		 * - The `<body>` text or background color does not change the black border color
		 */ if (!(0, $6NnQH.isSafariOnIOS)()) Object.assign(container.style, {
            borderInlineStart: `${point.x} solid transparent`,
            borderTop: `${point.y} solid transparent`
        });
        // Unfortunate that we need to use `getComputedStyle`,
        // but it's only a single call when the drag is starting.
        const computed = window.getComputedStyle(container);
        if (computed.direction === 'rtl') {
            // The DOMRect will include the new border we added
            const box = container.getBoundingClientRect();
            // Use the top right corner (including the new border) as the offset.
            // The border will push the preview away from the pointer.
            return {
                x: box.width,
                y: 0
            };
        }
        // Use the top left corner as the offset. The border will
        // push the preview away from the pointer.
        return {
            x: 0,
            y: 0
        };
    };
}

});
parcelRegister("6NnQH", function(module, exports) {

$parcel$export(module.exports, "isSafariOnIOS", () => $023dae56098ed162$export$52fc40c68fea4952);

var $jjNE9 = parcelRequire("jjNE9");

var $6aABs = parcelRequire("6aABs");
const $023dae56098ed162$export$52fc40c68fea4952 = (0, $jjNE9.once)(function isSafariOnIOS() {
    return (0, $6aABs.isSafari)() && 'ontouchend' in document;
});

});



parcelRegister("erBEN", function(module, exports) {

$parcel$export(module.exports, "setCustomNativeDragPreview", () => (parcelRequire("kpXwZ")).setCustomNativeDragPreview);

var $kpXwZ = parcelRequire("kpXwZ");

});
parcelRegister("kpXwZ", function(module, exports) {

$parcel$export(module.exports, "setCustomNativeDragPreview", () => $39163240d699f88a$export$52d889c66db0f96e);

var $40DDD = parcelRequire("40DDD");

var $6aABs = parcelRequire("6aABs");

/** By default we use the build in values for the native drag preview: {x: 0, y: 0} */ function $39163240d699f88a$var$defaultOffset() {
    return {
        x: 0,
        y: 0
    };
}
function $39163240d699f88a$export$52d889c66db0f96e({ render: render, nativeSetDragImage: nativeSetDragImage, getOffset: getOffset = $39163240d699f88a$var$defaultOffset }) {
    const container = document.createElement('div');
    Object.assign(container.style, {
        // Ensuring we don't cause reflow when adding the element to the page
        // Using `position:fixed` rather than `position:absolute` so we are
        // positioned on the current viewport.
        // `position:fixed` also creates a new stacking context, so we don't need to do that here
        position: 'fixed',
        // According to `mdn`, the element can be offscreen:
        // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setDragImage#imgelement
        //
        // However, that  information does not appear in the specs:
        // https://html.spec.whatwg.org/multipage/dnd.html#dom-datatransfer-setdragimage-dev
        //
        // If the element is _completely_ offscreen, Safari@17.1 will cancel the drag
        top: 0,
        left: 0,
        // Using maximum possible z-index so that this element will always be on top
        // https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
        // Did not use `layers` in `@atlaskit/theme` because:
        // 1. This element is not a 'layer' in the conventional sense, as this element
        //    is only created for a single frame for the browser to take a photo of it,
        //    and then it is destroyed
        // 2. Did not want to add a dependency onto `@atlaskit/theme`
        // 3. Want to always be on top of product UI which might have higher z-index's
        zIndex: (0, $ff68169bc3de57ec$export$7d0a15ee70427305),
        // Avoiding any additional events caused by the new element (being super safe)
        pointerEvents: 'none'
    });
    document.body.append(container);
    const unmount = render({
        container: container
    });
    /**
	 * Some frameworks (eg `react`) don't render into the container until the next microtask.
	 * - This will run before the browser takes it's picture of the element
	 * - This will run before the animation frame that removes `container`.
	 * */ queueMicrotask(()=>{
        const previewOffset = getOffset({
            container: container
        });
        /**
		 * **Problem**
		 * On `Safari@17.1` if a drag preview element has some opacity,
		 * Safari will include elements behind the drag preview element
		 * in the drag preview.
		 * Bug: https://bugs.webkit.org/show_bug.cgi?id=266025
		 *
		 * **Fix**
		 * We push the drag preview so it is _almost_ completely offscreen so that
		 * there won't be any elements behind the drag preview element.
		 * If the element is _completely_ offscreen, then the drag is cancelled by Safari.
		 *
		 * Using `-0.0001` so that any potential "see through" on the drag preview element
		 * is effectively invisible 👻
		 *
		 * **Unsuccessful alternatives**
		 * Setting a background color (eg "white") on the `container`
		 * → Wrecks the opacity of the drag preview element
		 *
		 * Adding a parent element of the `container` with a background color (eg "white")
		 * → Wrecks the opacity of the drag preview element
		 */ if ((0, $6aABs.isSafari)()) {
            const rect = container.getBoundingClientRect();
            // We cannot apply this fix if nothing has been rendered into the `container`
            if (rect.width === 0) return;
            container.style.left = `-${rect.width - 0.0001}px`;
        }
        nativeSetDragImage?.(container, previewOffset.x, previewOffset.y);
    });
    function cleanup() {
        unbindMonitor();
        unmount?.();
        document.body.removeChild(container);
    }
    const unbindMonitor = (0, $40DDD.monitorForElements)({
        // Remove portal in the dragstart event so that the user will never see it
        onDragStart: cleanup,
        // Backup: remove portal when the drop finishes (this would be an error case)
        onDrop: cleanup
    });
}

});
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
const $ff68169bc3de57ec$export$7d0a15ee70427305 = 2147483647;



parcelRegister("bWSeB", function(module, exports) {

$parcel$export(module.exports, "setBacklogPanelEpicRankInteractionStartMark", () => $e95c61291015ed83$export$636347642f8d5001);
$parcel$export(module.exports, "cancelBacklogPanelEpicRankInteraction", () => $e95c61291015ed83$export$9c4083e544116d5a);
$parcel$export(module.exports, "stopBacklogPanelEpicRankInteraction", () => $e95c61291015ed83$export$b0f81e21fadb0edc);

var $dGrdR = parcelRequire("dGrdR");
const $e95c61291015ed83$var$backlogPanelEpicRankInteraction = (0, $dGrdR.metrics).interaction({
    key: 'backlog-panel.epic-rank',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '1000_1500_2000_2500_3000'
    }
});
const $e95c61291015ed83$export$636347642f8d5001 = ()=>{
    $e95c61291015ed83$var$backlogPanelEpicRankInteraction.start();
};
const $e95c61291015ed83$export$9c4083e544116d5a = ()=>{
    $e95c61291015ed83$var$backlogPanelEpicRankInteraction.cancel();
};
const $e95c61291015ed83$export$b0f81e21fadb0edc = (isCompanyManaged)=>{
    $e95c61291015ed83$var$backlogPanelEpicRankInteraction.stop({
        customData: {
            isCompanyManaged: isCompanyManaged
        }
    });
};

});



parcelRegister("lkS4n", function(module, exports) {

$parcel$export(module.exports, "default", () => $a66dce967a45c2ed$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $az4zD = parcelRequire("az4zD");

var $g4tDr = parcelRequire("g4tDr");


var $iXVV6 = parcelRequire("iXVV6");

var $2ykml = parcelRequire("2ykml");

var $bgTck = parcelRequire("bgTck");
const $a66dce967a45c2ed$export$93d9680adf11bedd = ({ epicIssueType: epicIssueType, triggerAppearance: triggerAppearance = (0, $7462c685f739ed5a$export$dda6912361cddac9), onCreate: onCreate = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), intl: { formatMessage: formatMessage } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            issueHierarchyLevel: (0, $g4tDr.ISSUE_HIERARCHY_LEVEL_EPIC)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2ykml.default), {
        id: epicIssueType.id,
        triggerAppearance: triggerAppearance,
        triggerLabel: formatMessage((0, $bgTck.default).triggerLabel, {
            epicIssueTypeNameLowerCase: epicIssueType?.name?.toLocaleLowerCase()
        }),
        placeholder: formatMessage((0, $bgTck.default).createPlaceholder, {
            epicIssueTypeName: epicIssueType.name
        }),
        onCreate: onCreate
    }));
var $a66dce967a45c2ed$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)(/*#__PURE__*/ (0, $5uXOq.memo)($a66dce967a45c2ed$export$93d9680adf11bedd));

});
parcelRegister("2ykml", function(module, exports) {

$parcel$export(module.exports, "default", () => $8246a1a636f02c94$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");


var $hIWd8 = parcelRequire("hIWd8");

var $dCm1o = parcelRequire("dCm1o");

var $lmBAt = parcelRequire("lmBAt");

var $a2e2Q = parcelRequire("a2e2Q");
const $8246a1a636f02c94$var$styles = {
    iccWrapper: "_2rkohyhq _kqsw1if8 _94n5idpf _ca0qv77o _u5f3idpf _n3tdv77o _19bvidpf _bfhkqbzx _19pkidpf _2hwx12x7 _otyridpf _18u012x7",
    themed: "_bfhk18uv"
};
const $8246a1a636f02c94$var$ConditionalIccWrapper = ({ isVisuallyRefreshed: isVisuallyRefreshed, children: children })=>{
    const { isSoftwareFullTheming: isSoftwareFullTheming } = (0, $lmBAt.getIsSoftwareThemingM2Enabled)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $a2e2Q.useSoftwareProjectTheming)() : {
        isSoftwareFullTheming: false
    };
    if (isVisuallyRefreshed) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "software-backlog-panel.common.ui.inline-card-create.jira-inline-card-create",
        className: (0, $bwpsq.default)([
            $8246a1a636f02c94$var$styles.iccWrapper,
            isSoftwareFullTheming && $8246a1a636f02c94$var$styles.themed
        ])
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8246a1a636f02c94$var$IccWrapper, {
        "data-testid": "software-backlog-panel.common.ui.inline-card-create.jira-inline-card-create"
    }, children);
};
const $8246a1a636f02c94$var$InlineCardCreate = ({ id: id, triggerAppearance: triggerAppearance, triggerLabel: triggerLabel, placeholder: placeholder, onCreate: onCreate })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8246a1a636f02c94$var$ConditionalIccWrapper, {
        isVisuallyRefreshed: (0, $dCm1o.isVisualRefreshEnabled)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hIWd8.default), {
        cardTypes: [
            {
                id: id,
                name: '',
                iconUrl: ''
            }
        ],
        appearance: (0, $7462c685f739ed5a$export$aca095bc476d426f),
        triggerAppearance: triggerAppearance,
        triggerLabel: triggerLabel,
        placeholderText: placeholder,
        onCreate: onCreate
    }));
var $8246a1a636f02c94$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($8246a1a636f02c94$var$InlineCardCreate);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $8246a1a636f02c94$var$IccWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkohyhq _kqsw1if8 _94n5idpf _ca0qv77o _u5f3idpf _n3tdv77o _19bvidpf _bfhkqbzx",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hIWd8", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d06f081c1e675aa$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $7Jxgt = parcelRequire("7Jxgt");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $1XJ20 = parcelRequire("1XJ20");

var $4R6GH = parcelRequire("4R6GH");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $5knXz = parcelRequire("5knXz");

var $4pxa7 = parcelRequire("4pxa7");

var $c4UiF = parcelRequire("c4UiF");


var $2Z6La = parcelRequire("2Z6La");

var $dhszq = parcelRequire("dhszq");

var $hNJJt = parcelRequire("hNJJt");

var $l94uE = parcelRequire("l94uE");
// exact trigger height
const $0d06f081c1e675aa$var$TRIGGER_HEIGHT = 40;
const $0d06f081c1e675aa$var$withMarginTopStyles = null;
const $0d06f081c1e675aa$var$withTransparentStyles = null;
const $0d06f081c1e675aa$export$c283de3a59c46bc6 = (cardTypes, cardTypeId, defaultCardTypeId)=>{
    const selectedCardType = cardTypes.find(({ id: id })=>id === cardTypeId);
    const fallbackCardTypeId = defaultCardTypeId && cardTypes.some(({ id: id, isDisabled: isDisabled })=>id === defaultCardTypeId && isDisabled !== true) ? defaultCardTypeId : null;
    if (selectedCardType?.isDisabled === true) return fallbackCardTypeId;
    // To prevent setting invalid value when user switches to another ICC component that have different cardTypes
    return selectedCardType !== undefined ? cardTypeId : fallbackCardTypeId;
};
const $0d06f081c1e675aa$var$InlineCardCreate = (props)=>{
    const { isFormVisible: isFormVisibleProp, isFormVisibleDefault: isFormVisibleDefault = false, isDisabled: isDisabled = false, shouldScrollIntoView: shouldScrollIntoView, onChangeFormVisible: onChangeFormVisible = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), triggerAppearance: triggerAppearance, onTriggerClick: onTriggerClick = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onCancel: onCancel = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onCreate: onCreate = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onChangeCardType: onChangeCardType = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onChangeSummary: onChangeSummary = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onChangeStatusTransition: onChangeStatusTransition = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onChangeProject: onChangeProject = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), cardTypes: cardTypes = [], defaultCardTypeId: defaultCardTypeId, autoFocus: autoFocus, extraItems: extraItems, shouldKeepFormOpenOnClickOutside: shouldKeepFormOpenOnClickOutside, triggerLabel: triggerLabel, triggerAriaLabel: triggerAriaLabel, ariaLabelledBy: ariaLabelledBy, appearance: appearance, placeholderText: placeholderText, numFilters: numFilters, messages: messages, saveOnBlur: saveOnBlur, renderAdditionalTypeSelectOptionContent: renderAdditionalTypeSelectOptionContent, renderAdditionalInlineCreateFooter: renderAdditionalInlineCreateFooter, renderCompactViewEditorExperimental: renderCompactViewEditorExperimental, renderCompactViewPlaceholderExperimental: renderCompactViewPlaceholderExperimental, renderCompactViewActionButtonExperimental: renderCompactViewActionButtonExperimental, onBlur: onBlur = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), TypeSelect: TypeSelect, StatusSelect: StatusSelect, statusTransitions: statusTransitions, projects: projects, isModalTrigger: isModalTrigger, shouldShowCreateButton: shouldShowCreateButton, onAutoOpen: onAutoOpen = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), containerRef: containerRef, showIssueTypeConfigOptions: showIssueTypeConfigOptions, configSource: configSource, projectKey: projectKey, getShouldShowAdditionalFields: getShouldShowAdditionalFields, defaultAssignee: defaultAssignee, shouldShowDueDatePicker: shouldShowDueDatePicker, shouldShowAssigneePicker: shouldShowAssigneePicker, isCompactDueDatePicker: isCompactDueDatePicker = false } = props;
    const [isFormVisible, setIsFormVisible] = (0, $5uXOq.useState)(isFormVisibleProp ?? isFormVisibleDefault);
    const [triggerUnmountTimeoutId, setTriggerUnmountTimeoutId] = (0, $5uXOq.useState)(null);
    const previousIsFormVisibleProp = (0, $1XJ20.usePreviousWithInitial)(isFormVisibleProp);
    const previousIsFormVisible = (0, $1XJ20.usePreviousWithInitial)(isFormVisible);
    const [shouldFocusTrigger, setShouldFocusTrigger] = (0, $5uXOq.useState)(false);
    const setFocusOnTrigger = (0, $5uXOq.useCallback)(()=>{
        setShouldFocusTrigger(true);
    }, []);
    const { showEnforcementIfStorageIsFull: showEnforcementIfStorageIsFull } = (0, $5knXz.useStorageEnforcement)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { hasCreatedIssueICC: hasCreatedIssueICC, triggerReason: triggerReason } = (0, $4pxa7.useTriggerEventState)();
    const { setHasCreatedIssueICC: setHasCreatedIssueICC, setTriggerReason: setTriggerReason } = (0, $4pxa7.useKeepIccOpenActions)();
    const [isConfiguringIssueType, setIsConfiguringIssueType] = (0, $5uXOq.useState)(false);
    const { fetchFields: fetchFields, iccProps: additionalIccProps } = (0, $4R6GH.fg)('jira_pic_software_board_prerequisite') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $c4UiF.useLazyIssueTypesAndFieldsForICC)({
        projectKey: projectKey
    }) : {
        fetchFields: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        iccProps: null
    };
    (0, $5uXOq.useEffect)(()=>{
        if (!false && (previousIsFormVisibleProp !== isFormVisibleProp || previousIsFormVisible !== isFormVisible)) // invoke callback everytime isFormVisibleProp or internal isFormVisible state changes
        onChangeFormVisible(isFormVisibleProp ?? isFormVisible);
    }, [
        isFormVisible,
        isFormVisibleProp,
        onChangeFormVisible,
        previousIsFormVisible,
        previousIsFormVisibleProp
    ]);
    const onTriggerClickCallback = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        const sessionId = (0, $7Jxgt.v4)();
        setHasCreatedIssueICC(false);
        // @ts-expect-error Second argument should be of format "actionSubject action"
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'triggerClicked', 'triggerButton', {
            formWasOpen: isFormVisible,
            triggerAppearance: triggerAppearance,
            sessionId: sessionId,
            isAutoOpen: false
        });
        if (isFormVisibleProp === undefined) {
            setTriggerUnmountTimeoutId(null);
            setIsFormVisible(true);
        }
        setShouldFocusTrigger(false);
        onTriggerClick(sessionId);
    }, [
        setHasCreatedIssueICC,
        isFormVisible,
        triggerAppearance,
        isFormVisibleProp,
        onTriggerClick
    ]);
    const onCancelCallback = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'blurred',
            actionSubject: 'inlineCardCreate'
        }), {
            cancelledBy: (0, $7462c685f739ed5a$export$2bb790b9008907b4)
        });
        if (isFormVisibleProp === undefined) {
            if (triggerUnmountTimeoutId) {
                clearTimeout(triggerUnmountTimeoutId);
                setTriggerUnmountTimeoutId(null);
            }
            setIsFormVisible(false);
        }
        onCancel();
    }, [
        createAnalyticsEvent,
        triggerUnmountTimeoutId,
        isFormVisibleProp,
        onCancel
    ]);
    const makeOnBlur = (0, $5uXOq.useCallback)((context)=>(summary)=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'blurred',
                actionSubject: 'inlineCardCreate'
            }), {
                cancelledBy: (0, $7462c685f739ed5a$export$565566e3df4dad53),
                withContent: !!summary
            });
            context.onChangeSummary(summary);
            if (isFormVisibleProp === undefined) {
                if (triggerUnmountTimeoutId) {
                    clearTimeout(triggerUnmountTimeoutId);
                    setTriggerUnmountTimeoutId(null);
                }
                setIsFormVisible(false);
            }
            onBlur();
            setHasCreatedIssueICC(true);
        }, [
        createAnalyticsEvent,
        isFormVisibleProp,
        onBlur,
        setHasCreatedIssueICC,
        triggerUnmountTimeoutId
    ]);
    const makeOnCreate = (0, $5uXOq.useCallback)((context)=>(issues, metadata)=>{
            // analytic event name will be changed in the future to match other events
            const analyticsEvent = createAnalyticsEvent({
                action: 'confirmed',
                actionSubject: 'input'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, {
                createdBy: metadata.createdBy
            });
            context.onCreate();
            onCreate(issues, metadata, analyticsEvent);
            showEnforcementIfStorageIsFull({
                touchpoint: 'inline-card-create'
            });
            setHasCreatedIssueICC(true);
            setTriggerReason('lastIssueCreated');
        }, [
        createAnalyticsEvent,
        onCreate,
        showEnforcementIfStorageIsFull,
        setHasCreatedIssueICC,
        setTriggerReason
    ]);
    const makeOnCancel = (0, $5uXOq.useCallback)((context)=>{
        if (context && context.onCancel) return ()=>{
            context.onCancel();
            onCancelCallback();
        };
        return onCancelCallback;
    }, [
        onCancelCallback
    ]);
    const makeOnChangeCardType = (0, $5uXOq.useCallback)((context)=>{
        if (context && context.onChangeCardType) return (issueTypeId)=>{
            context.onChangeCardType(issueTypeId);
            additionalIccProps?.onChangeCardType(issueTypeId);
            onChangeCardType(issueTypeId);
        };
        return onChangeCardType;
    }, [
        onChangeCardType,
        additionalIccProps
    ]);
    const makeOnChangeStatusTransition = (0, $5uXOq.useCallback)((context)=>{
        if (context && context.onChangeFieldValue) return (transitionId)=>{
            context.onChangeFieldValue((0, $hNJJt.FIELD_KEY_STATUS_TRANSITIONS), transitionId);
            onChangeStatusTransition(transitionId);
        };
        return onChangeStatusTransition;
    }, [
        onChangeStatusTransition
    ]);
    const makeOnChangeSummary = (0, $5uXOq.useCallback)((context)=>{
        if (context && context.onChangeSummary) return (summary)=>{
            context.onChangeSummary(summary);
            onChangeSummary(summary);
        };
        return onChangeSummary;
    }, [
        onChangeSummary
    ]);
    const makeOnChangeProject = (0, $5uXOq.useCallback)((context)=>{
        if (context && context.onChangeProject) return (projectId)=>{
            context.onChangeProject(projectId);
            onChangeProject(projectId);
        };
        return onChangeProject;
    }, [
        onChangeProject
    ]);
    const isCardTypesEmptyOrAllDisabled = cardTypes.every(({ isDisabled: isCardTypeDisabled })=>Boolean(isCardTypeDisabled));
    const isTriggerDisabled = cardTypes?.length ? isDisabled || isCardTypesEmptyOrAllDisabled : isDisabled;
    const shouldRenderForm = (isFormVisibleProp ?? isFormVisible) && !isTriggerDisabled;
    (0, $5uXOq.useEffect)(()=>{
        /* 	below block is intended for case where icc is automatically opened after icc issue
    	created when user opens originally opens icc in-between two existing issues */ if (shouldRenderForm === true && hasCreatedIssueICC) {
            // unique sessionId for each icc
            const sessionId = (0, $7Jxgt.v4)();
            // fires start event and sets sessionId for end event
            onAutoOpen(sessionId);
            const autoFocusAnalyticsEvent = createAnalyticsEvent({
                action: 'focused',
                actionSubject: 'input',
                actionSubjectId: 'inlineCreateCard'
            });
            (0, $8zOmE.fireUIAnalytics)(autoFocusAnalyticsEvent, {
                triggeredBy: 'autoFocus',
                reason: triggerReason
            });
            setHasCreatedIssueICC(false);
            if ((0, $4R6GH.fg)('jira_pic_software_board_prerequisite')) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'form focused', 'inlineCreate');
        }
    }, [
        createAnalyticsEvent,
        hasCreatedIssueICC,
        setHasCreatedIssueICC,
        shouldRenderForm,
        triggerReason,
        isFormVisible,
        triggerAppearance,
        onTriggerClick,
        onAutoOpen
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (shouldRenderForm && (0, $4R6GH.fg)('jira_pic_software_board_prerequisite')) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'form focused', 'inlineCreate');
    }, [
        createAnalyticsEvent,
        shouldRenderForm
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "inline-card-create",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        attributes: {
            appearance: appearance,
            numFilters: numFilters
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        /** fetchFields is only used for ICC experiment and will be undefined if experiment is not enabled */ onMouseOver: fetchFields,
        xcss: [
            $0d06f081c1e675aa$var$containerStyles,
            triggerUnmountTimeoutId !== null && $0d06f081c1e675aa$var$withTriggerUnmountStyles
        ],
        testId: "platform-inline-card-create.ui.container",
        ref: containerRef
    }, shouldRenderForm && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Z6La.IccContext).Consumer, null, (value)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dhszq.AsyncInlineCardCreateForm), {
            isCompactDueDatePicker: isCompactDueDatePicker,
            autoFocus: autoFocus ?? true,
            shouldScrollIntoView: shouldScrollIntoView ?? false,
            onSubmit: makeOnCreate(value),
            onCancel: makeOnCancel(value),
            onBlur: makeOnBlur(value),
            onChangeSummary: makeOnChangeSummary(value),
            numFilters: numFilters ?? 0,
            messages: messages ?? [],
            cardTypes: cardTypes,
            extraItems: extraItems,
            shouldKeepFormOpenOnClickOutside: shouldKeepFormOpenOnClickOutside || isConfiguringIssueType,
            selectedCardTypeId: $0d06f081c1e675aa$export$c283de3a59c46bc6(cardTypes, value.initialCardTypeId, defaultCardTypeId),
            selectedFieldValues: value.initialFieldValues,
            appearance: appearance ?? 'full',
            placeholderText: placeholderText ?? '',
            saveOnBlur: saveOnBlur ?? false,
            onChangeCardType: makeOnChangeCardType(value),
            onChangeStatusTransition: makeOnChangeStatusTransition(value),
            onChangeProject: makeOnChangeProject(value),
            initialSummary: value.initialSummary,
            renderAdditionalTypeSelectOptionContent: renderAdditionalTypeSelectOptionContent,
            renderAdditionalInlineCreateFooter: renderAdditionalInlineCreateFooter,
            renderCompactViewEditorExperimental: renderCompactViewEditorExperimental,
            renderCompactViewPlaceholderExperimental: renderCompactViewPlaceholderExperimental,
            renderCompactViewActionButtonExperimental: renderCompactViewActionButtonExperimental,
            TypeSelect: TypeSelect,
            StatusSelect: StatusSelect,
            statusTransitions: statusTransitions,
            selectedProjectId: value.initialProjectId,
            projects: projects,
            shouldShowCreateButton: shouldShowCreateButton,
            setFocusOnTrigger: setFocusOnTrigger,
            showIssueTypeConfigOptions: showIssueTypeConfigOptions,
            configSource: configSource,
            setIsConfiguringIssueType: setIsConfiguringIssueType,
            isConfiguringIssueType: isConfiguringIssueType,
            projectKey: projectKey,
            getShouldShowAdditionalFields: getShouldShowAdditionalFields,
            defaultAssignee: defaultAssignee,
            shouldShowDueDatePicker: shouldShowDueDatePicker && additionalIccProps?.shouldShowDueDatePicker,
            shouldShowAssigneePicker: shouldShowAssigneePicker && additionalIccProps?.shouldShowAssigneePicker,
            onInitialCardTypeSet: additionalIccProps?.onChangeCardType
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            triggerUnmountTimeoutId !== null && "_19pk10j7",
            !(!shouldRenderForm && triggerUnmountTimeoutId === null) && "_tzy4idpf"
        ])
    }, (!shouldRenderForm || triggerUnmountTimeoutId !== null) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l94uE.default), {
        isModalTrigger: isModalTrigger,
        isSticky: appearance === (0, $7462c685f739ed5a$export$aca095bc476d426f),
        triggerAppearance: triggerAppearance,
        label: triggerLabel,
        ariaLabel: triggerAriaLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onTriggerClickCallback,
        isDisabled: isTriggerDisabled,
        shouldFocusTrigger: shouldFocusTrigger
    }))));
};
$0d06f081c1e675aa$var$InlineCardCreate.defaultProps = {
    isFormVisibleDefault: false,
    isDisabled: false,
    autoFocus: true,
    saveOnBlur: false,
    appearance: (0, $7462c685f739ed5a$export$3789e4b2a10baa2b),
    triggerAppearance: (0, $7462c685f739ed5a$export$dda6912361cddac9),
    triggerLabel: '',
    placeholderText: '',
    numFilters: 0,
    messages: [],
    cardTypes: [],
    extraItems: undefined,
    onCreate: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onTriggerClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onChangeSummary: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onChangeCardType: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onChangeStatusTransition: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onChangeFormVisible: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onChangeProject: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onAutoOpen: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    renderAdditionalInlineCreateFooter: undefined,
    renderCompactViewEditorExperimental: undefined,
    renderCompactViewPlaceholderExperimental: undefined,
    renderCompactViewActionButtonExperimental: undefined,
    shouldShowCreateButton: false,
    showIssueTypeConfigOptions: false,
    configSource: undefined
};
var $0d06f081c1e675aa$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($0d06f081c1e675aa$var$InlineCardCreate);
const $0d06f081c1e675aa$var$containerStyles = (0, $8CUq3.xcss)({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%'
});
const $0d06f081c1e675aa$var$withTriggerUnmountStyles = (0, $8CUq3.xcss)({
    minHeight: `${$0d06f081c1e675aa$var$TRIGGER_HEIGHT}px`
});

});
// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("5knXz", function(module, exports) {

$parcel$export(module.exports, "useStorageEnforcement", () => $a61178001d7e3bbc$export$fa2c25e1ed13a1a8);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $2gCtH = parcelRequire("2gCtH");

var $dAfqg = parcelRequire("dAfqg");


var $RnWyv = parcelRequire("RnWyv");

var $l2AwX = parcelRequire("l2AwX");
const $a61178001d7e3bbc$var$MODAL_COOLDOWN_MS = 86400000; // 1 day in ms
const $a61178001d7e3bbc$export$fa2c25e1ed13a1a8 = ()=>{
    const [currentState, { setIsOpen: setEnforceStorageModalIsOpen }] = (0, $l2AwX.useEnforceStorageModal)();
    const issueViewMode = (0, $2gCtH.useViewMode)();
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const isInJSWProject = projectContextData?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    const openModalIfNotOnCooldown = (0, $5uXOq.useCallback)((touchpoint)=>{
        const isOnCooldown = Date.now() - ((0, $RnWyv.localStorage).get((0, $3f79643dcab1adf8$export$ed785d2382d0101d)) || 0) < $a61178001d7e3bbc$var$MODAL_COOLDOWN_MS;
        if (isOnCooldown) {
            if (currentState.isOpen === 'pending') // Reset pending state if modal is on cooldown when it should be shown
            setEnforceStorageModalIsOpen({
                isOpen: 'closed',
                touchpoint: undefined
            });
        } else setEnforceStorageModalIsOpen({
            isOpen: 'open',
            touchpoint: touchpoint
        });
    }, [
        setEnforceStorageModalIsOpen,
        currentState.isOpen
    ]);
    const showEnforcementIfStorageIsFull = (0, $5uXOq.useCallback)(({ delayShow: delayShow = false, shouldOnlyShowInJSWContext: shouldOnlyShowInJSWContext = true, touchpoint: touchpoint })=>{
        if (shouldOnlyShowInJSWContext && !isInJSWProject) return;
        // Issue view use case is checked internally here rather than passed in, to avoid polluting consumer code
        if (delayShow || issueViewMode === 'MODAL') setEnforceStorageModalIsOpen({
            isOpen: 'pending',
            touchpoint: touchpoint
        });
        else openModalIfNotOnCooldown(touchpoint);
    }, [
        isInJSWProject,
        issueViewMode,
        setEnforceStorageModalIsOpen,
        openModalIfNotOnCooldown
    ]);
    // Used to show enforcement modal after modals are dismissed, to avoid modal on modal UX
    const showEnforcementIfPendingToShow = (0, $5uXOq.useCallback)(()=>{
        if (currentState.isOpen === 'pending') // Use the trigger from created the JSW issue
        openModalIfNotOnCooldown(currentState.touchpoint);
    }, [
        currentState.isOpen,
        openModalIfNotOnCooldown,
        currentState.touchpoint
    ]);
    return {
        showEnforcementIfStorageIsFull: showEnforcementIfStorageIsFull,
        showEnforcementIfPendingToShow: showEnforcementIfPendingToShow
    };
};

});
const $3f79643dcab1adf8$export$b8b9d90f9e5bd72b = 'jira-enforce-storage-limits';
const $3f79643dcab1adf8$export$ed785d2382d0101d = 'lastStorageEnforcement';

parcelRegister("RnWyv", function(module, exports) {

$parcel$export(module.exports, "localStorage", () => $5fd7f3930a81124f$export$c2ed3351cac403d1);

var $bSSG7 = parcelRequire("bSSG7");
const $5fd7f3930a81124f$export$c2ed3351cac403d1 = (0, $bSSG7.createLocalStorageProvider)('enforce-storage-limits');

});

parcelRegister("l2AwX", function(module, exports) {

$parcel$export(module.exports, "useEnforceStorageModal", () => $377250c350eb1ea3$export$56beb4c2629d6615);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $7FEwN = parcelRequire("7FEwN");
const $377250c350eb1ea3$var$initialState = {
    isOpen: 'closed',
    touchpoint: undefined
};
const $377250c350eb1ea3$var$store = (0, $iXqE5.createStore)({
    name: 'jsw-enforce-storage-limit-modal',
    initialState: $377250c350eb1ea3$var$initialState,
    actions: $7FEwN.actions
});
const $377250c350eb1ea3$export$56beb4c2629d6615 = (0, $3sQ5x.createHook)($377250c350eb1ea3$var$store);

});
parcelRegister("7FEwN", function(module, exports) {

$parcel$export(module.exports, "actions", () => $a1630f6ff8f7879d$export$e324594224ef24da);

var $aBMM9 = parcelRequire("aBMM9");
const $a1630f6ff8f7879d$export$e324594224ef24da = {
    setIsOpen: $aBMM9.setIsOpen
};

});
parcelRegister("aBMM9", function(module, exports) {

$parcel$export(module.exports, "setIsOpen", () => $bd4df525f1eeff62$export$dcf23146e0a40195);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $bd4df525f1eeff62$export$dcf23146e0a40195 = (newState)=>({ setState: setState })=>{
        setState(newState);
    };

});




parcelRegister("4pxa7", function(module, exports) {

$parcel$export(module.exports, "useKeepIccOpenState", () => $e01b50e33333395d$export$991bb5f828c64eee);
$parcel$export(module.exports, "useKeepIccOpenStateOnListView", () => $e01b50e33333395d$export$aff5da39850e1282);
$parcel$export(module.exports, "useKeepIccOpenActions", () => $e01b50e33333395d$export$bbdeb5b20a0dc1c1);
$parcel$export(module.exports, "useTriggerEventState", () => $e01b50e33333395d$export$438ab5dbdf55872);


var $9yQlD = parcelRequire("9yQlD");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $g7fKq = parcelRequire("g7fKq");
const $e01b50e33333395d$var$isModalVisible = (key)=>(0, $9yQlD.sessionStorage).get(key) !== undefined;
// If either modal is visible, then don't open the ICC
const $e01b50e33333395d$var$setInitialState = ()=>!($e01b50e33333395d$var$isModalVisible((0, $6784cbc7d62e5d7c$export$4e1360a3e7785935)) || $e01b50e33333395d$var$isModalVisible((0, $6784cbc7d62e5d7c$export$e3884212029f7bef)));
const $e01b50e33333395d$export$d4c72bab9d6cc13a = {
    get keepIccOpen () {
        return $e01b50e33333395d$var$setInitialState();
    },
    hasCreatedIssueICC: true,
    triggerReason: 'emptyBoard',
    keepIccOpenOnListView: false
};
const $e01b50e33333395d$var$store = (0, $iXqE5.createStore)({
    name: 'jsw-onboarding-keep-icc-open',
    initialState: $e01b50e33333395d$export$d4c72bab9d6cc13a,
    actions: $g7fKq.actions
});
const $e01b50e33333395d$export$991bb5f828c64eee = (0, $3sQ5x.createStateHook)($e01b50e33333395d$var$store, {
    selector: (state)=>state.keepIccOpen
});
const $e01b50e33333395d$export$aff5da39850e1282 = (0, $3sQ5x.createStateHook)($e01b50e33333395d$var$store, {
    selector: (state)=>state.keepIccOpenOnListView
});
const $e01b50e33333395d$export$bbdeb5b20a0dc1c1 = (0, $3sQ5x.createActionsHook)($e01b50e33333395d$var$store);
const $e01b50e33333395d$export$438ab5dbdf55872 = (0, $3sQ5x.createStateHook)($e01b50e33333395d$var$store, {
    selector: (state)=>({
            hasCreatedIssueICC: state.hasCreatedIssueICC,
            triggerReason: state.triggerReason
        })
});

});
// Session storage constants used between going through initial onboarding screens
// and landing in JIRA
// Note this key used to be 'should-show-scrum-modal' but was changed to prevent a bug where experienced users
// Could see the modal if they were previously enrolled into ISO
const $6784cbc7d62e5d7c$export$67abe0a3b8dfe03f = 'should-show-scrum-modal-v2';
const $6784cbc7d62e5d7c$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $6784cbc7d62e5d7c$export$e3884212029f7bef = 'should-show-welcome-modal';
const $6784cbc7d62e5d7c$export$c45d2ea50af63a85 = 'showed-welcome-modal-during-signup';
const $6784cbc7d62e5d7c$export$c9dc4cb209930823 = 'can-enroll-in-config-wizard-view';
const $6784cbc7d62e5d7c$export$891ca65264b256bb = 'should-show-personlized-sample-data-for-kanban';
const $6784cbc7d62e5d7c$export$f47dca9dda77d157 = 'should-hide-quickstart-for-personalized-sample-data';
const $6784cbc7d62e5d7c$export$16588d2012f3f89b = 'should-show-business-sample-data-nudge';
const $6784cbc7d62e5d7c$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $6784cbc7d62e5d7c$export$6e69f8dc03075ef8 = 'team-type';
const $6784cbc7d62e5d7c$export$c06666264cd35603 = 'team-type-shorthand';
const $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $6784cbc7d62e5d7c$export$6973064a898f5989 = 'should-show-list-view-type-cell-spotlight';
const $6784cbc7d62e5d7c$export$115fac1f1144bda1 = 'should-show-list-view-fields-dropdown-spotlight';
const $6784cbc7d62e5d7c$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $6784cbc7d62e5d7c$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $6784cbc7d62e5d7c$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $6784cbc7d62e5d7c$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $6784cbc7d62e5d7c$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $6784cbc7d62e5d7c$export$46d9a3d441dfd22b = 'navigationPlansNavItemNudge';
const $6784cbc7d62e5d7c$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $6784cbc7d62e5d7c$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $6784cbc7d62e5d7c$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $6784cbc7d62e5d7c$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $6784cbc7d62e5d7c$export$eb64d5f1a091478b = 'backlogCreateSprintIssueNudge';
const $6784cbc7d62e5d7c$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $6784cbc7d62e5d7c$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $6784cbc7d62e5d7c$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $6784cbc7d62e5d7c$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $6784cbc7d62e5d7c$export$468488291ccd988 = 'timelineAddItemNudge';
const $6784cbc7d62e5d7c$export$7a33548109ac931d = 'createFormNudge';
const $6784cbc7d62e5d7c$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $6784cbc7d62e5d7c$export$3b5d230b66f60471 = 'jsw-onboarding-checklist.visibility';
const $6784cbc7d62e5d7c$export$594d3436316492be = 'summaryViewNudge';
const $6784cbc7d62e5d7c$export$f93b83d735f01fa3 = 'pagesCreatePageNudge';
const $6784cbc7d62e5d7c$export$77bc79debbf5c069 = 'inviteTeamNudge';
const $6784cbc7d62e5d7c$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $6784cbc7d62e5d7c$export$699265ec8ad9a740 = 'Software Development';
const $6784cbc7d62e5d7c$export$e07d1fa2da8ed874 = 'Customer Service';
const $6784cbc7d62e5d7c$export$76dcec3f438d9e56 = 'IT Support';
const $6784cbc7d62e5d7c$export$9a574c301f67ba30 = 'Human Resources';
const $6784cbc7d62e5d7c$export$363ec144a94029c8 = 'Finance';
const $6784cbc7d62e5d7c$export$df0fb32d68ae1e78 = 'Legal';
const $6784cbc7d62e5d7c$export$d9c0e3e59442fb4 = 'Marketing';
const $6784cbc7d62e5d7c$export$27dbc7d7ce66e6e3 = 'Operations';
const $6784cbc7d62e5d7c$export$a5dce388adf922bd = 'Sales';
const $6784cbc7d62e5d7c$export$e1473b31a257caff = 'Data Science';
const $6784cbc7d62e5d7c$export$85657457db93c2c2 = 'Product Management';
const $6784cbc7d62e5d7c$export$c0c2d1dfaeba89dd = 'Project Management';
const $6784cbc7d62e5d7c$export$2e6a7ad3ab9c82a3 = 'Design';
const $6784cbc7d62e5d7c$export$7b60378c3b4372e9 = 'Other or Personal';
const $6784cbc7d62e5d7c$export$572242e58bd07594 = 'CS';
const $6784cbc7d62e5d7c$export$d7de553940261eba = 'ITS';
const $6784cbc7d62e5d7c$export$4c29d0d04c15e55d = 'HR';
const $6784cbc7d62e5d7c$export$3950f7f841bf94b6 = 'FNC';
const $6784cbc7d62e5d7c$export$881249b988b6030f = 'LGL';
const $6784cbc7d62e5d7c$export$e4824f74b9879164 = 'MKT';
const $6784cbc7d62e5d7c$export$4f3cb0844009af52 = 'OPS';
const $6784cbc7d62e5d7c$export$1a65d50c4a641bb4 = 'SAL';
const $6784cbc7d62e5d7c$export$9ee64e8fbd8b03a2 = 'DS';
const $6784cbc7d62e5d7c$export$b8b1ac856ba1434b = 'DEV';
const $6784cbc7d62e5d7c$export$4f54a09a24fd1d74 = 'PDM';
const $6784cbc7d62e5d7c$export$79685802e8ff1098 = 'PJM';
const $6784cbc7d62e5d7c$export$e5c438b7501b5a24 = 'DES';
const $6784cbc7d62e5d7c$export$cbc0e551d91a692d = 'OTR';

parcelRegister("g7fKq", function(module, exports) {

$parcel$export(module.exports, "actions", () => $22684fd1187cb60b$export$e324594224ef24da);

var $5hyrq = parcelRequire("5hyrq");

var $ePMUR = parcelRequire("ePMUR");

var $cr2Jb = parcelRequire("cr2Jb");

var $lWd86 = parcelRequire("lWd86");

var $47sVO = parcelRequire("47sVO");
const $22684fd1187cb60b$export$e324594224ef24da = {
    toggleKeepIccOpen: $lWd86.toggleKeepIccOpen,
    setKeepIccOpenOnListView: $47sVO.setKeepIccOpenOnListView,
    setHasCreatedIssueICC: $ePMUR.setHasCreatedIssueICC,
    setTriggerReason: $cr2Jb.setTriggerReason,
    closeICC: $5hyrq.closeICC
};

});
parcelRegister("5hyrq", function(module, exports) {

$parcel$export(module.exports, "closeICC", () => $a1f8bda87b6ffc9a$export$e6c10955f11a7b51);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $a1f8bda87b6ffc9a$export$e6c10955f11a7b51 = ()=>({ setState: setState })=>{
        setState({
            keepIccOpen: false
        });
    };

});

parcelRegister("ePMUR", function(module, exports) {

$parcel$export(module.exports, "setHasCreatedIssueICC", () => $a1b9adc891c00dd5$export$4bb464fc9800c324);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $a1b9adc891c00dd5$export$4bb464fc9800c324 = (hasCreatedIssueICC)=>({ getState: getState, setState: setState })=>{
        const { hasCreatedIssueICC: currentHasCreatedIssueICC } = getState();
        if (hasCreatedIssueICC === currentHasCreatedIssueICC) return;
        setState({
            hasCreatedIssueICC: hasCreatedIssueICC
        });
    };

});

parcelRegister("cr2Jb", function(module, exports) {

$parcel$export(module.exports, "setTriggerReason", () => $b662b9cea36b43af$export$8b8ceaca9e30bc48);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $b662b9cea36b43af$export$8b8ceaca9e30bc48 = (triggerReason)=>({ getState: getState, setState: setState })=>{
        const { triggerReason: currentTriggerReason } = getState();
        if (triggerReason === currentTriggerReason) return;
        setState({
            triggerReason: triggerReason
        });
    };

});

parcelRegister("lWd86", function(module, exports) {

$parcel$export(module.exports, "toggleKeepIccOpen", () => $071bcdbf7bb018d8$export$d09b33ff198a059);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $071bcdbf7bb018d8$export$d09b33ff198a059 = ()=>({ getState: getState, setState: setState })=>{
        const { keepIccOpen: iccOpenState } = getState();
        setState({
            keepIccOpen: !iccOpenState
        });
    };

});

parcelRegister("47sVO", function(module, exports) {

$parcel$export(module.exports, "setKeepIccOpenOnListView", () => $4e5de3e3ef2ed84f$export$72785f36e8a63554);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $4e5de3e3ef2ed84f$export$72785f36e8a63554 = (value)=>({ setState: setState })=>{
        setState({
            keepIccOpenOnListView: value
        });
    };

});



parcelRegister("c4UiF", function(module, exports) {

$parcel$export(module.exports, "useLazyIssueTypesAndFieldsForICC", () => $d48cbb3e2c023f1d$export$dc13f1a4fac3d00c);

var $5uXOq = parcelRequire("5uXOq");

var $bQ0kt = parcelRequire("bQ0kt");
const $d48cbb3e2c023f1d$export$dc13f1a4fac3d00c = ({ projectKey: projectKey })=>{
    const [selectedCardTypeId, setSelectedCardTypeId] = (0, $5uXOq.useState)(null);
    const fieldsUtil = (0, $bQ0kt.useLazyIssueTypesFieldsMap)({
        projectKey: projectKey
    });
    return {
        fetchFields: fieldsUtil.load,
        iccProps: (0, $5uXOq.useMemo)(()=>({
                shouldShowDueDatePicker: fieldsUtil.checkIssueTypeHasField(selectedCardTypeId, 'duedate'),
                shouldShowAssigneePicker: fieldsUtil.checkIssueTypeHasField(selectedCardTypeId, 'assignee'),
                onChangeCardType: setSelectedCardTypeId
            }), [
            fieldsUtil,
            selectedCardTypeId
        ])
    };
};

});
parcelRegister("bQ0kt", function(module, exports) {

$parcel$export(module.exports, "useLazyIssueTypesFieldsMap", () => $172181ad15050282$export$6e72d76da900f375);

var $5uXOq = parcelRequire("5uXOq");

var $34uA1 = parcelRequire("34uA1");
const $172181ad15050282$export$6e72d76da900f375 = ({ projectKey: projectKey })=>{
    // This state is kept per individual ICC trigger (each footer "+ Create" and sibling "+" (hidden) button)
    // Use shared state instead of local state for "dirty" to avoid re-fetching between cards
    const [dirty, setDirty] = (0, $5uXOq.useState)(false);
    const [issueTypeMap, setIssueTypeMap] = (0, $5uXOq.useState)(null);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const loading = dirty && !issueTypeMap && !error;
    const done = dirty && !loading;
    const load = (0, $5uXOq.useCallback)(()=>{
        // define caching strategy here. For now there's none and it won't be called twice for each button
        if (dirty || !projectKey) return;
        setDirty(true);
        (0, $34uA1.getIssueTypesAndFields)({
            projectKey: projectKey
        }).then(setIssueTypeMap).catch(setError);
    }, [
        dirty,
        projectKey
    ]);
    const checkIssueTypeHasField = (0, $5uXOq.useCallback)((issueTypeId, fieldId)=>{
        if (!issueTypeId || !issueTypeMap || !issueTypeMap[issueTypeId]) return false;
        return issueTypeMap[issueTypeId].fields.some((f)=>f.fieldId === fieldId);
    }, [
        issueTypeMap
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            load: load,
            error: error,
            done: done,
            loading: loading,
            issueTypeMap: issueTypeMap,
            checkIssueTypeHasField: checkIssueTypeHasField
        }), [
        load,
        error,
        done,
        loading,
        issueTypeMap,
        checkIssueTypeHasField
    ]);
};

});
parcelRegister("34uA1", function(module, exports) {

$parcel$export(module.exports, "getIssueTypesAndFields", () => $fb687dab2c5ae1cd$export$9205dae0ca81a60c);

var $eusud = parcelRequire("eusud");

const $fb687dab2c5ae1cd$export$9205dae0ca81a60c = ({ projectKey: projectKey })=>{
    return (0, $eusud.performPostRequest)('/rest/gira/1/?operation=JiraBusinessProjectDetails', {
        body: JSON.stringify({
            query: (0, $f62684c4bc22b630$export$e94926d83673c36b),
            variables: {
                projectKey: projectKey,
                issueOperation: 'CREATE',
                first: 100
            }
        })
    }).then($fb687dab2c5ae1cd$export$eca82dd5c4bcf11e);
};
const $fb687dab2c5ae1cd$export$eca82dd5c4bcf11e = (response)=>{
    const resultingMap = {};
    response.data.jiraBusinessAvailableFields.edges.forEach(({ node: typeNode })=>{
        const { issueTypeId: issueTypeId } = typeNode.issueType;
        resultingMap[issueTypeId] = {
            issueTypeId: issueTypeId,
            fields: typeNode.fields.edges.map(({ node: fieldNode })=>({
                    fieldId: fieldNode.fieldId
                }))
        };
    });
    return resultingMap;
};

});
const $f62684c4bc22b630$export$e94926d83673c36b = `query JiraWorkTypeFieldAssociation($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
  jiraBusinessAvailableFields(
    projectKey: $projectKey
    issueOperation: $issueOperation
    first: $first
    last: $last
    before: $before
    after: $after
  ) {
    edges {
      node {
        issueType {
          issueTypeId
        }
        fields {
          edges {
            node {
              fieldId
            }
          }
        }
      }
    }
  }
}`;




parcelRegister("dhszq", function(module, exports) {

$parcel$export(module.exports, "AsyncInlineCardCreateForm", () => $a64c6427d6c752bd$export$4f2abfdfd1993102);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $a64c6427d6c752bd$var$AsyncInlineCardCreateFormComp = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("e5Ne6")), {
    moduleId: "./src/packages/platform/ui/inline-card-create/src/ui/form/main.tsx"
});
const $a64c6427d6c752bd$export$4f2abfdfd1993102 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "async-inline-card-create-form",
        packageName: "JiraPlatformBoardKit"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-inline-card-create-form",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a64c6427d6c752bd$var$AsyncInlineCardCreateFormComp, props)));

});
parcelRegister("e5Ne6", function(module, exports) {

let $a427b7ac67822718$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $a427b7ac67822718$var$load("76n7a"),
    $a427b7ac67822718$var$load("l253H"),
    $a427b7ac67822718$var$load("ffQaD"),
    $a427b7ac67822718$var$load("kvRbA"),
    $a427b7ac67822718$var$load("7YwPO")
]).then(()=>parcelRequire('kNtWa'));

});


parcelRegister("hNJJt", function(module, exports) {

$parcel$export(module.exports, "FIELD_KEY_STATUS_TRANSITIONS", () => $e682d994c4b3be50$export$9f9b866ee3adcf04);
$parcel$export(module.exports, "default", () => $e682d994c4b3be50$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gZL7V = parcelRequire("gZL7V");

var $c8Oei = parcelRequire("c8Oei");

var $dC5iT = parcelRequire("dC5iT");
var $5ILhZ = parcelRequire("5ILhZ");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $bChGW = parcelRequire("bChGW");
var $b9dFI = parcelRequire("b9dFI");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");


var $85BdV = parcelRequire("85BdV");
const $e682d994c4b3be50$var$ANALYTICS_SUBJECT = 'iccStatusSelect';
const $e682d994c4b3be50$export$9f9b866ee3adcf04 = 'statusTransitions';
const $e682d994c4b3be50$var$getStatusTheme = (id)=>$e682d994c4b3be50$var$statusCategoryToThemeMap[id] || 'default';
const $e682d994c4b3be50$var$statusCategoryToThemeMap = {
    '1': 'default',
    '2': 'default',
    '3': 'success',
    '4': 'inprogress'
};
const $e682d994c4b3be50$var$Option = ({ children: children, ...props })=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { statusInfo: statusInfo } = props.data;
    const buttonTheme = $e682d994c4b3be50$var$getStatusTheme(String(statusInfo?.statusCategoryId));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: "platform-inline-card-create.ui.form.status-select.option",
        xcss: [
            $e682d994c4b3be50$var$optionContentStyles,
            $e682d994c4b3be50$var$buttonThemeStyle[buttonTheme]
        ]
    }, children));
};
const $e682d994c4b3be50$var$transformOptions = (statusTransitions, selectedTransitionId)=>{
    let value;
    const options = [];
    statusTransitions.forEach((transition)=>{
        const option = {
            label: transition.name,
            value: transition.transitionId,
            statusInfo: transition
        };
        if (transition.transitionId === selectedTransitionId) value = option;
        else options.push(option);
    });
    if (!value) value = options?.[0];
    return {
        options: options,
        value: value
    };
};
const $e682d994c4b3be50$var$buttonThemeStyle = {
    default: (0, $8CUq3.xcss)({
        backgroundColor: 'color.background.neutral',
        color: 'color.text',
        ':hover': {
            color: 'color.text',
            backgroundColor: 'color.background.neutral.hovered'
        }
    }),
    success: (0, $8CUq3.xcss)({
        backgroundColor: 'color.background.success',
        color: 'color.text.success',
        ':hover': {
            color: 'color.text.success',
            backgroundColor: 'color.background.success.hovered'
        }
    }),
    inprogress: (0, $8CUq3.xcss)({
        backgroundColor: 'color.background.information',
        color: 'color.text.information',
        ':hover': {
            color: 'color.text.information',
            backgroundColor: 'color.background.information.hovered'
        }
    })
};
const $e682d994c4b3be50$var$StatusTrigger = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ value: value, isOpen: isOpen, ...triggerProps }, ref)=>{
    const buttonTheme = $e682d994c4b3be50$var$getStatusTheme(String(value?.statusInfo?.statusCategoryId));
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e682d994c4b3be50$var$statusContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e682d994c4b3be50$var$statusButtonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: value.label ?? null,
        delay: (0, $7462c685f739ed5a$export$f9e3e7ede9ba929d),
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
        key: "pressable",
        ...triggerProps,
        ref: ref,
        xcss: [
            $e682d994c4b3be50$var$buttonContentStyles,
            $e682d994c4b3be50$var$buttonThemeStyle[buttonTheme]
        ],
        "aria-label": formatMessage((0, $85BdV.default).ariaLabel, {
            value: value.label ?? formatMessage((0, $85BdV.default).invalid)
        }),
        testId: "platform-inline-card-create.ui.form.status-select.trigger"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        maxLines: 1,
        weight: "bold",
        size: "small",
        color: "inherit"
    }, value.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e682d994c4b3be50$var$iconContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
        LEGACY_size: "medium",
        label: "",
        "aria-hidden": "true",
        color: "currentColor"
    }))))));
});
const $e682d994c4b3be50$var$StatusSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ statusTransitions: statusTransitions, selectedTransitionId: selectedTransitionId, onSelectTransition: onSelectTransition }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { value: value, options: options } = (0, $5uXOq.useMemo)(()=>$e682d994c4b3be50$var$transformOptions(statusTransitions, selectedTransitionId), [
        statusTransitions,
        selectedTransitionId
    ]);
    const onChange = (0, $5uXOq.useCallback)((option)=>{
        option && onSelectTransition(option.statusInfo.transitionId);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'dropdown changed',
            actionSubject: $e682d994c4b3be50$var$ANALYTICS_SUBJECT
        }), {});
    }, [
        createAnalyticsEvent,
        onSelectTransition
    ]);
    const onMenuOpen = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'dropdown opened',
            actionSubject: $e682d994c4b3be50$var$ANALYTICS_SUBJECT
        }), {});
    }, [
        createAnalyticsEvent
    ]);
    const setRefNode = (0, $5uXOq.useCallback)((popupSelectRef)=>{
        ref && popupSelectRef && (0, (/*@__PURE__*/$parcel$interopDefault($gZL7V)))(ref, 'current.node', popupSelectRef);
    }, [
        ref
    ]);
    const renderTrigger = (0, $5uXOq.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e682d994c4b3be50$var$StatusTrigger, {
            ...props,
            value: value
        }), [
        value
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b9dFI.default), {
        ref: setRefNode,
        components: {
            Option: $e682d994c4b3be50$var$Option
        },
        target: renderTrigger,
        options: options,
        value: value,
        onChange: onChange,
        onMenuOpen: onMenuOpen,
        isSearchable: false,
        // DSP-2990 - PopupSelect doesn't respect isSearchable, searchThreshold is required
        searchThreshold: Number.MAX_SAFE_INTEGER,
        minMenuWidth: "auto",
        classNamePrefix: "inline-card-create-status-select",
        testId: "platform-inline-card-create.ui.form.status-select.status-select"
    });
});
var $e682d994c4b3be50$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($e682d994c4b3be50$var$StatusSelect);
const $e682d994c4b3be50$var$statusContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    minWidth: '0px',
    position: 'relative'
});
const $e682d994c4b3be50$var$statusButtonWrapperStyles = (0, $8CUq3.xcss)({
    width: '100%',
    paddingLeft: 'space.100'
});
const $e682d994c4b3be50$export$548912fb31084970 = /*#__PURE__*/ (0, $5uXOq.memo)($e682d994c4b3be50$var$StatusSelect);
const $e682d994c4b3be50$var$buttonContentStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBlock: 'space.0',
    paddingLeft: 'space.100',
    paddingRight: 'space.0',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: 'uppercase',
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage -- The token value "4px" and fallback "3px" do not match and can't be replaced automatically.
    borderRadius: "var(--ds-border-radius, 3px)",
    textAlign: 'left',
    width: '100%'
});
const $e682d994c4b3be50$var$iconContainerStyles = (0, $8CUq3.xcss)({
    minWidth: '24px',
    height: '24px',
    display: 'flex',
    flex: '1',
    alignItems: 'center',
    justifyContent: 'center'
});
const $e682d994c4b3be50$var$optionContentStyles = (0, $8CUq3.xcss)({
    display: 'inline-block',
    width: 'auto',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: 'uppercase',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    paddingBlock: 'space.0',
    paddingInline: 'space.050',
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage -- The token value "4px" and fallback "3px" do not match and can't be replaced automatically.
    borderRadius: "var(--ds-border-radius, 3px)"
});

});
parcelRegister("gZL7V", function(module, exports) {

var $ajB7H = parcelRequire("ajB7H");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $c5f6e64373be0bfc$var$set(object, path, value) {
    return object == null ? object : $ajB7H(object, path, value);
}
module.exports = $c5f6e64373be0bfc$var$set;

});

parcelRegister("85BdV", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dac99c767b21e7c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9dac99c767b21e7c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    ariaLabel: {
        "id": "inline-card-create.form.status-select.aria-label",
        "defaultMessage": "The current status is {value}. Press the 'Space' key to change the status."
    },
    invalid: {
        "id": "inline-card-create.form.status-select.invalid",
        "defaultMessage": "invalid"
    }
});

});




parcelRegister("bgTck", function(module, exports) {

$parcel$export(module.exports, "default", () => $55d0a7604b773d2b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $55d0a7604b773d2b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    triggerLabel: {
        "id": "software-backlog-panel.epic.epic-panel.epic-inline-card-create.trigger-label",
        "defaultMessage": "Create {epicIssueTypeNameLowerCase}"
    },
    createPlaceholder: {
        "id": "software-backlog-panel.epic.epic-panel.epic-inline-card-create.create-placeholder",
        "defaultMessage": "What will the {epicIssueTypeName} be called?"
    }
});

});




parcelRegister("5HVbu", function(module, exports) {

let $427d53862806b5fd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $427d53862806b5fd$var$load("8Kobh").then(()=>parcelRequire('8pv3s'));

});


parcelRegister("5fQw9", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cbb5d72cb5df9c7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $ijYb7 = parcelRequire("ijYb7");
const $9cbb5d72cb5df9c7$var$App = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "app",
        packageName: "jiraSoftwareIssueLimitFlags",
        teamName: "a4t-tanuki",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ijYb7.IssueLimitFlags), props));
var $9cbb5d72cb5df9c7$export$2e2bcd8739ae039 = $9cbb5d72cb5df9c7$var$App;

});
parcelRegister("ijYb7", function(module, exports) {

$parcel$export(module.exports, "ISSUE_APPROACHING_LIMIT", () => $07c13de1d345d403$export$998713d4130be32d);
$parcel$export(module.exports, "IssueLimitFlags", () => $07c13de1d345d403$export$739da16e22409e4d);

var $5uXOq = parcelRequire("5uXOq");

var $e2T54 = parcelRequire("e2T54");

var $ir9Ry = parcelRequire("ir9Ry");
const $07c13de1d345d403$export$998713d4130be32d = 4500;
const $07c13de1d345d403$var$ISSUE_REACHED_LIMIT = 5000;
const $07c13de1d345d403$export$739da16e22409e4d = ({ isProjectAdmin: isProjectAdmin, ...flagProps })=>{
    const [limitReachedFlagShown, setLimitReachedFlagShown] = (0, $5uXOq.useState)(false);
    const limitReachedViews = flagProps.views.filter((view)=>view.issueCount >= $07c13de1d345d403$var$ISSUE_REACHED_LIMIT);
    const limitApproachingViews = flagProps.views.filter((view)=>view.issueCount >= $07c13de1d345d403$export$998713d4130be32d && view.issueCount < $07c13de1d345d403$var$ISSUE_REACHED_LIMIT);
    const shouldShowLimitReachedFlag = limitReachedViews.length > 0;
    const shouldShowLimitApproachingFlag = limitApproachingViews.length > 0 && !limitReachedFlagShown;
    (0, $5uXOq.useEffect)(()=>{
        if (shouldShowLimitReachedFlag && !limitReachedFlagShown) setLimitReachedFlagShown(true);
    }, [
        limitReachedFlagShown,
        shouldShowLimitReachedFlag
    ]);
    // Check to ensure permission is defined. If value is not boolean, then it likely
    // means it has not yet been loaded
    if (typeof isProjectAdmin !== 'boolean') return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, shouldShowLimitApproachingFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e2T54.LimitApproachingFlag), {
        ...flagProps,
        isProjectAdmin: isProjectAdmin,
        views: limitApproachingViews
    }), shouldShowLimitReachedFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ir9Ry.LimitReachedFlag), {
        ...flagProps,
        isProjectAdmin: isProjectAdmin,
        views: limitReachedViews
    }));
};

});
parcelRegister("e2T54", function(module, exports) {

$parcel$export(module.exports, "LimitApproachingFlag", () => $da6681a9a2d62d46$export$c8f47c0b0c12451c);

var $5uXOq = parcelRequire("5uXOq");

var $1jWct = parcelRequire("1jWct");

var $6s1PB = parcelRequire("6s1PB");

var $pa9q9 = parcelRequire("pa9q9");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $8g67F = parcelRequire("8g67F");

var $bvUMO = parcelRequire("bvUMO");
const $da6681a9a2d62d46$var$LIMIT_APPROACHING_FLAG_ID = 'jsw-issue-approaching-reached-flag';
const $da6681a9a2d62d46$export$c8f47c0b0c12451c = ({ isCMP: isCMP, isProjectAdmin: isProjectAdmin, projectKey: projectKey, views: flagViews })=>{
    const [flagShown, setFlagShown] = (0, $5uXOq.useState)(false);
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const flagActions = (0, $8g67F.useFlagActions)({
        isProjectAdmin: isProjectAdmin,
        isCMP: isCMP,
        projectKey: projectKey,
        flagType: 'approaching'
    });
    const views = flagViews.map((v)=>v.view);
    (0, $5uXOq.useEffect)(()=>{
        const getFlagTitle = ()=>{
            if (isCMP) return views[0] === 'BOARD' ? (0, $bvUMO.default).boardLimitApproachingFlagTitle : (0, $bvUMO.default).backlogLimitApproachingFlagTitle;
            if (views.includes('BACKLOG') && views.includes('SPRINTS')) return (0, $bvUMO.default).tmpBacklogSprintsLimitApproachingFlagTitle;
            if (views.includes('BACKLOG') && views.includes('BOARD')) return (0, $bvUMO.default).tmpBacklogBoardLimitApproachingFlagTitle;
            if (views.includes('BACKLOG')) return (0, $bvUMO.default).tmpBacklogLimitApproachingFlagTitle;
            if (views.includes('SPRINTS')) return (0, $bvUMO.default).tmpSprintsLimitApproachingFlagTitle;
            if (views.includes('BOARD')) return (0, $bvUMO.default).boardLimitApproachingFlagTitle;
            return (0, $bvUMO.default).boardLimitApproachingFlagTitle;
        };
        const getFlagMessage = ()=>{
            if (isCMP) {
                if (views[0] === 'BOARD') {
                    const boardLimitApproachingAdminFlagBodyMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bvUMO.default).boardLimitApproachingAdminFlagBodyIssueTermRefresh : (0, $bvUMO.default).boardLimitApproachingAdminFlagBody;
                    const boardLimitApproachingEndUserFlagBodyMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bvUMO.default).boardLimitApproachingEndUserFlagBodyIssueTermRefresh : (0, $bvUMO.default).boardLimitApproachingEndUserFlagBody;
                    return isProjectAdmin ? boardLimitApproachingAdminFlagBodyMessage : boardLimitApproachingEndUserFlagBodyMessage;
                }
                const backlogLimitApproachingAdminFlagBodyMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bvUMO.default).backlogLimitApproachingAdminFlagBodyIssueTermRefresh : (0, $bvUMO.default).backlogLimitApproachingAdminFlagBody;
                const backlogLimitApproachingEndUserFlagBodyMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bvUMO.default).backlogLimitApproachingEndUserFlagBodyIssueTermRefresh : (0, $bvUMO.default).backlogLimitApproachingEndUserFlagBody;
                return isProjectAdmin ? backlogLimitApproachingAdminFlagBodyMessage : backlogLimitApproachingEndUserFlagBodyMessage;
            }
            if (views.includes('BACKLOG') && views.includes('SPRINTS')) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bvUMO.default).tmpBacklogSprintsLimitApproachingFlagBodyIssueTermRefresh : (0, $bvUMO.default).tmpBacklogSprintsLimitApproachingFlagBody;
            if (views.includes('BACKLOG') && views.includes('BOARD')) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bvUMO.default).tmpBacklogBoardLimitApproachingFlagBodyIssueTermRefresh : (0, $bvUMO.default).tmpBacklogBoardLimitApproachingFlagBody;
            if (views.includes('BACKLOG')) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bvUMO.default).tmpBacklogLimitApproachingFlagBodyIssueTermRefresh : (0, $bvUMO.default).tmpBacklogLimitApproachingFlagBody;
            if (views.includes('SPRINTS')) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bvUMO.default).tmpSprintsLimitApproachingFlagBodyIssueTermRefresh : (0, $bvUMO.default).tmpSprintsLimitApproachingFlagBody;
            if (views.includes('BOARD')) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bvUMO.default).tmpBoardLimitApproachingFlagBodyIssueTermRefresh : (0, $bvUMO.default).tmpBoardLimitApproachingFlagBody;
            return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bvUMO.default).tmpBoardLimitApproachingFlagBodyIssueTermRefresh : (0, $bvUMO.default).tmpBoardLimitApproachingFlagBody;
        };
        const flagTitle = getFlagTitle();
        const flagDescription = getFlagMessage();
        if (!flagShown) {
            showFlag({
                messageId: 'software-issue-limit-flags.ui.limit-approaching-flag.show-flag.info',
                messageType: 'transactional',
                id: $da6681a9a2d62d46$var$LIMIT_APPROACHING_FLAG_ID,
                type: 'info',
                title: flagTitle,
                description: flagDescription,
                isAutoDismiss: false,
                actions: flagActions,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1jWct))), {
                    spacing: "spacious",
                    color: "var(--ds-icon-information, #1D7AFC)",
                    label: ""
                }),
                onDismissed: (_, analyticsEvent)=>{
                    if (analyticsEvent) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'jswIssueLimitApproachingFlag');
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'flag shown', 'jswIssueLimitApproachingFlag');
        }
        setFlagShown(true);
    }, [
        showFlag,
        isProjectAdmin,
        flagActions,
        flagShown,
        createAnalyticsEvent,
        isCMP,
        views
    ]);
    return null;
};

});
parcelRegister("8g67F", function(module, exports) {

$parcel$export(module.exports, "useFlagActions", () => $fc75b95d4a7d68f1$export$38e4a892c359139d);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $e5wyW = parcelRequire("e5wyW");

var $5Zxxp = parcelRequire("5Zxxp");

var $8zOmE = parcelRequire("8zOmE");

var $fR4iU = parcelRequire("fR4iU");
const $fc75b95d4a7d68f1$var$CMP_ISSUE_LIMIT_SUPPORT_ARTICLE_URL = 'https://support.atlassian.com/jira-software-cloud/docs/issue-limits-in-company-managed-projects/';
const $fc75b95d4a7d68f1$var$CMP_ISSUE_LIMIT_IPH_ARTICLE_ID = '1KMwTxMBNiDPhaHMDlfT4u';
function $fc75b95d4a7d68f1$export$d53148a666867fe1(flagSource) {
    return {
        content: (0, $fR4iU.default).editFilterCta,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        href: `${window.location.pathname}?config=filter`,
        onClick: (_, analyticsEvent)=>{
            if (analyticsEvent) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'editBoardFilter', {
                flagSource: flagSource
            });
        }
    };
}
function $fc75b95d4a7d68f1$export$72a228c0f924aef1(flagSource) {
    return {
        content: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $fR4iU.default).viewMoreInfoCtaIssueTermRefresh : (0, $fR4iU.default).viewMoreInfoCta,
        href: $fc75b95d4a7d68f1$var$CMP_ISSUE_LIMIT_SUPPORT_ARTICLE_URL,
        target: '_blank',
        onClick: (_, analyticsEvent)=>{
            if (analyticsEvent) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'cmpIssueLimitSupportArticle', {
                flagSource: flagSource
            });
        }
    };
}
function $fc75b95d4a7d68f1$export$d49a14b48e551259(flagSource, setIPHArticleId) {
    return {
        content: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $fR4iU.default).viewMoreInfoCtaIssueTermRefresh : (0, $fR4iU.default).viewMoreInfoCta,
        onClick: (_, analyticsEvent)=>{
            setIPHArticleId($fc75b95d4a7d68f1$var$CMP_ISSUE_LIMIT_IPH_ARTICLE_ID);
            if (analyticsEvent) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'cmpIssueLimitIph', {
                flagSource: flagSource
            });
        }
    };
}
const $fc75b95d4a7d68f1$export$226a1330ff7e389b = (projectKey)=>({
        content: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $fR4iU.default).seeIssuesInSearchCtaIssueTermRefresh : (0, $fR4iU.default).seeIssuesInSearchCta,
        href: `/issues/?jql=${encodeURIComponent(`project = ${projectKey} ORDER BY rank ASC`)}`
    });
const $fc75b95d4a7d68f1$var$selector = (0, $e5wyW.functionWithCondition)(()=>(0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false), ()=>({
        content: (0, $fR4iU.default).viewMoreInfoCtaIssueTermRefresh,
        href: 'TBD'
    }), ()=>({
        content: (0, $fR4iU.default).viewMoreInfoCta,
        href: 'TBD'
    }));
const $fc75b95d4a7d68f1$export$2ca20f1de5f009d2 = $fc75b95d4a7d68f1$var$selector();
const $fc75b95d4a7d68f1$export$38e4a892c359139d = ({ isProjectAdmin: isProjectAdmin, isCMP: isCMP, projectKey: projectKey, flagType: flagType })=>{
    const setIPHArticleId = (0, $5Zxxp.useHelpPanelLink)();
    const flagSource = flagType === 'approaching' ? 'jswIssueLimitApproachingFlag' : 'jswIssueLimitReachedFlag';
    return (0, $5uXOq.useMemo)(()=>{
        if (isCMP) {
            if (isProjectAdmin) return [
                $fc75b95d4a7d68f1$export$d53148a666867fe1(flagSource),
                $fc75b95d4a7d68f1$export$d49a14b48e551259(flagSource, setIPHArticleId)
            ];
            return [
                $fc75b95d4a7d68f1$export$72a228c0f924aef1(flagSource)
            ];
        }
        return [
            $fc75b95d4a7d68f1$export$226a1330ff7e389b(projectKey),
            $fc75b95d4a7d68f1$export$2ca20f1de5f009d2
        ];
    }, [
        isCMP,
        projectKey,
        isProjectAdmin,
        flagSource,
        setIPHArticleId
    ]);
};

});
parcelRegister("fR4iU", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a85e2fb64f1664f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8a85e2fb64f1664f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    editFilterCta: {
        "id": "software-issue-limit-flags.common.edit-filter-cta",
        "defaultMessage": "Edit filter"
    },
    viewMoreInfoCta: {
        "id": "software-issue-limit-flags.common.view-more-info-cta",
        "defaultMessage": "More about issue limits"
    },
    seeIssuesInSearchCta: {
        "id": "software-issue-limit-flags.common.see-issues-in-search-cta",
        "defaultMessage": "See issues in search"
    },
    viewMoreInfoCtaIssueTermRefresh: {
        "id": "software-issue-limit-flags.common.view-more-info-cta-issue-term-refresh",
        "defaultMessage": "More about work item limits "
    },
    seeIssuesInSearchCtaIssueTermRefresh: {
        "id": "software-issue-limit-flags.common.see-issues-in-search-cta-issue-term-refresh",
        "defaultMessage": "See everything in search"
    }
});

});


parcelRegister("bvUMO", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae0496ade39ae6cf$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ae0496ade39ae6cf$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    backlogLimitApproachingFlagTitle: {
        "id": "software-issue-limit-flags.limit-approaching-flag.backlog-limit-approaching-flag-title",
        "defaultMessage": "Your backlog is almost full"
    },
    backlogLimitApproachingAdminFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.backlog-limit-approaching-admin-flag-body",
        "defaultMessage": "The backlog can display up to 5000 issues. Edit your board filter to refine what's included and excluded."
    },
    backlogLimitApproachingEndUserFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.backlog-limit-approaching-end-user-flag-body",
        "defaultMessage": "The backlog can display up to 5000 issues. The admin who created the board filter can refine what's included and excluded."
    },
    boardLimitApproachingFlagTitle: {
        "id": "software-issue-limit-flags.limit-approaching-flag.board-limit-approaching-flag-title",
        "defaultMessage": "Your board is almost full"
    },
    boardLimitApproachingAdminFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.board-limit-approaching-admin-flag-body",
        "defaultMessage": "The board can display up to 5000 issues. Edit your board filter to refine what's included and excluded."
    },
    boardLimitApproachingEndUserFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.board-limit-approaching-end-user-flag-body",
        "defaultMessage": "The board can display up to 5000 issues. The admin who created the board filter can refine what's included and excluded."
    },
    tmpBacklogLimitApproachingFlagTitle: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-backlog-limit-approaching-flag-title",
        "defaultMessage": "Your backlog is almost full"
    },
    tmpSprintsLimitApproachingFlagTitle: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-sprints-limit-approaching-flag-title",
        "defaultMessage": "Your sprint section is almost full"
    },
    tmpBacklogSprintsLimitApproachingFlagTitle: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-backlog-sprints-limit-approaching-flag-title",
        "defaultMessage": "Your backlog and sprint sections are almost full"
    },
    tmpBacklogBoardLimitApproachingFlagTitle: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-backlog-board-limit-approaching-flag-title",
        "defaultMessage": "Your backlog and board sections are almost full"
    },
    tmpBoardLimitApproachingFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-board-limit-approaching-flag-body",
        "defaultMessage": "The board can only display up to 5000 issues. It might be time to move some issues."
    },
    tmpBacklogLimitApproachingFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-backlog-limit-approaching-flag-body",
        "defaultMessage": "The backlog can display up to 5000 issues. It might be time to move some issues."
    },
    tmpSprintsLimitApproachingFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-sprints-limit-approaching-flag-body",
        "defaultMessage": "We can only display up to 5000 issues across all your sprints. It might be time to move some issues."
    },
    tmpBacklogSprintsLimitApproachingFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-backlog-sprints-limit-approaching-flag-body",
        "defaultMessage": "Your backlog and sprint sections can each only display up to 5000 issues. It might be time to move some issues."
    },
    tmpBacklogBoardLimitApproachingFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-backlog-board-limit-approaching-flag-body",
        "defaultMessage": "Your backlog and board sections can each only display up to 5000 issues. It might be time to move some issues."
    },
    backlogLimitApproachingAdminFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-approaching-flag.backlog-limit-approaching-admin-flag-body-issue-term-refresh",
        "defaultMessage": "The backlog can display up to 5000 work items. Edit your board filter to refine what's included and excluded."
    },
    backlogLimitApproachingEndUserFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-approaching-flag.backlog-limit-approaching-end-user-flag-body-issue-term-refresh",
        "defaultMessage": "The backlog can display up to 5000 work items. The admin who created the board filter can refine what's included and excluded."
    },
    boardLimitApproachingAdminFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-approaching-flag.board-limit-approaching-admin-flag-body-issue-term-refresh",
        "defaultMessage": "The board can display up to 5000 work items. Edit your board filter to refine what's included and excluded."
    },
    boardLimitApproachingEndUserFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-approaching-flag.board-limit-approaching-end-user-flag-body-issue-term-refresh",
        "defaultMessage": "The board can display up to 5000 work items. The admin who created the board filter can refine what's included and excluded."
    },
    tmpBoardLimitApproachingFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-board-limit-approaching-flag-body-issue-term-refresh",
        "defaultMessage": "The board can only display up to 5000 work items. It might be time to move some work."
    },
    tmpBacklogLimitApproachingFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-backlog-limit-approaching-flag-body-issue-term-refresh",
        "defaultMessage": "The backlog can display up to 5000 work items. It might be time to move some work."
    },
    tmpSprintsLimitApproachingFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-sprints-limit-approaching-flag-body-issue-term-refresh",
        "defaultMessage": "We can only display up to 5000 work items across all your sprints. It might be time to move some work."
    },
    tmpBacklogSprintsLimitApproachingFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-backlog-sprints-limit-approaching-flag-body-issue-term-refresh",
        "defaultMessage": "Your backlog and sprint sections can each only display up to 5000 work items. It might be time to move some work."
    },
    tmpBacklogBoardLimitApproachingFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-backlog-board-limit-approaching-flag-body-issue-term-refresh",
        "defaultMessage": "Your backlog and board sections can each only display up to 5000 work items. It might be time to move some work."
    }
});

});


parcelRegister("ir9Ry", function(module, exports) {

$parcel$export(module.exports, "LimitReachedFlag", () => $48372b37d055d7b1$export$b4f3bdfaaded5337);

var $a6ceQ = parcelRequire("a6ceQ");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $6BtlL = parcelRequire("6BtlL");

var $6s1PB = parcelRequire("6s1PB");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $9OXo1 = parcelRequire("9OXo1");

var $8g67F = parcelRequire("8g67F");

var $lSfuc = parcelRequire("lSfuc");
const $48372b37d055d7b1$var$LIMIT_REACHED_FLAG_ID = 'jsw-issue-limit-reached-flag';
const $48372b37d055d7b1$export$b4f3bdfaaded5337 = ({ boardId: boardId, isProjectAdmin: isProjectAdmin, isCMP: isCMP, projectKey: projectKey, views: flagViews })=>{
    const [flagShown, setFlagShown] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const views = flagViews.map((flagView)=>flagView.view);
    const shouldFetchTotalCount = views.length === 1 && [
        'BACKLOG',
        'BOARD'
    ].includes(views[0]);
    const data = (0, $8Uumt.useLazyLoadQuery)((0, $a6ceQ.default), {
        cloudId: cloudId,
        issueSearchInput: {
            customInput: {
                jiraSoftwareInput: {
                    context: views[0] === 'BOARD' ? 'BOARD' : 'BACKLOG',
                    jiraEntityId: (0, $6BtlL.JiraSoftwareBoardAri).create({
                        boardId: boardId.toString(),
                        siteId: cloudId
                    }).toString()
                }
            }
        },
        skip: !shouldFetchTotalCount
    }, {
        fetchPolicy: 'network-only'
    });
    const totalCount = data.jira?.issueSearchTotalCount;
    const flagActions = (0, $8g67F.useFlagActions)({
        isProjectAdmin: isProjectAdmin,
        isCMP: isCMP,
        projectKey: projectKey,
        flagType: 'reached'
    });
    (0, $5uXOq.useEffect)(()=>{
        if (shouldFetchTotalCount && typeof totalCount !== 'number') return;
        const getFlagTitle = ()=>{
            if (isCMP) return views[0] === 'BOARD' ? (0, $lSfuc.default).boardLimitReachedFlagTitle : (0, $lSfuc.default).backlogLimitReachedFlagTitle;
            if (views.includes('BACKLOG') && views.includes('SPRINTS')) return (0, $lSfuc.default).tmpBacklogSprintsLimitReachedFlagTitle;
            if (views.includes('BACKLOG') && views.includes('BOARD')) return (0, $lSfuc.default).tmpBacklogBoardLimitReachedFlagTitle;
            if (views.includes('BACKLOG')) return (0, $lSfuc.default).tmpBacklogLimitReachedFlagTitle;
            if (views.includes('SPRINTS')) return (0, $lSfuc.default).tmpSprintsLimitReachedFlagTitle;
            if (views.includes('BOARD')) return (0, $lSfuc.default).boardLimitReachedFlagTitle;
            return (0, $lSfuc.default).boardLimitReachedFlagTitle;
        };
        const getFlagMessage = ()=>{
            if (isCMP) {
                if (views[0] === 'BOARD') {
                    const boardLimitReachedAdminFlagBodyMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lSfuc.default).boardLimitReachedAdminFlagBodyIssueTermRefresh : (0, $lSfuc.default).boardLimitReachedAdminFlagBody;
                    const boardLimitReachedEndUserFlagBodyMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lSfuc.default).boardLimitReachedEndUserFlagBodyIssueTermRefresh : (0, $lSfuc.default).boardLimitReachedEndUserFlagBody;
                    return isProjectAdmin ? boardLimitReachedAdminFlagBodyMessage : boardLimitReachedEndUserFlagBodyMessage;
                }
                const backlogLimitReachedAdminFlagBodyMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lSfuc.default).backlogLimitReachedAdminFlagBodyIssueTermRefresh : (0, $lSfuc.default).backlogLimitReachedAdminFlagBody;
                const backlogLimitReachedEndUserFlagBodyMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lSfuc.default).backlogLimitReachedEndUserFlagBodyIssueTermRefresh : (0, $lSfuc.default).backlogLimitReachedEndUserFlagBody;
                return isProjectAdmin ? backlogLimitReachedAdminFlagBodyMessage : backlogLimitReachedEndUserFlagBodyMessage;
            }
            if (views.includes('BACKLOG') && views.includes('SPRINTS')) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lSfuc.default).tmpBacklogSprintsLimitReachedFlagBodyIssueTermRefresh : (0, $lSfuc.default).tmpBacklogSprintsLimitReachedFlagBody;
            if (views.includes('BACKLOG') && views.includes('BOARD')) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lSfuc.default).tmpBacklogBoardLimitReachedFlagBodyIssueTermRefresh : (0, $lSfuc.default).tmpBacklogBoardLimitReachedFlagBody;
            if (views.includes('BACKLOG')) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lSfuc.default).tmpBacklogLimitReachedFlagBodyIssueTermRefresh : (0, $lSfuc.default).tmpBacklogLimitReachedFlagBody;
            if (views.includes('SPRINTS')) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lSfuc.default).tmpSprintsLimitReachedFlagBodyIssueTermRefresh : (0, $lSfuc.default).tmpSprintsLimitReachedFlagBody;
            if (views.includes('BOARD')) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lSfuc.default).tmpBoardLimitReachedFlagBodyIssueTermRefresh : (0, $lSfuc.default).tmpBoardLimitReachedFlagBody;
            return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lSfuc.default).tmpBoardLimitReachedFlagBodyIssueTermRefresh : (0, $lSfuc.default).tmpBoardLimitReachedFlagBody;
        };
        const flagTitle = getFlagTitle();
        const flagDescription = getFlagMessage();
        if (!flagShown) {
            showFlag({
                messageId: 'software-issue-limit-flags.ui.limit-reached-flag.show-flag.warning',
                messageType: 'transactional',
                id: $48372b37d055d7b1$var$LIMIT_REACHED_FLAG_ID,
                type: 'warning',
                title: flagTitle,
                description: formatMessage(flagDescription, {
                    issueCount: totalCount
                }),
                isAutoDismiss: false,
                actions: flagActions,
                onDismissed: (_, analyticsEvent)=>{
                    if (analyticsEvent) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'jswIssueLimitReachedFlag', {
                        totalIssueCount: totalCount
                    });
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'flag shown', 'jswIssueLimitReachedFlag', {
                totalIssueCount: totalCount
            });
            setFlagShown(true);
        }
    }, [
        formatMessage,
        showFlag,
        isProjectAdmin,
        flagActions,
        totalCount,
        flagShown,
        createAnalyticsEvent,
        isCMP,
        shouldFetchTotalCount,
        views
    ]);
    return null;
};

});
parcelRegister("a6ceQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6258a09992b1b59$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f0e08b1c167d3c20088a2c2a02e0608d>>
 * @relayHash 16968863187b798a94c81fb2f3c02587
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1d92172fafa12a38c14a21764204ae490c41baf36eb55b3ec10622230a6ef256
const $e6258a09992b1b59$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueSearchInput"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "skip"
        }
    ], v1 = [
        {
            "condition": "skip",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "issueSearchInput",
                                    "variableName": "issueSearchInput"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "issueSearchTotalCount"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "limitReachedFlagTotalIssueCountQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "limitReachedFlagTotalIssueCountQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "1d92172fafa12a38c14a21764204ae490c41baf36eb55b3ec10622230a6ef256",
            "metadata": {},
            "name": "limitReachedFlagTotalIssueCountQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e6258a09992b1b59$var$node.hash = "1b2bcb6691b0c1b0f0f93eb3b32f4323";
var $e6258a09992b1b59$export$2e2bcd8739ae039 = $e6258a09992b1b59$var$node;

});

parcelRegister("lSfuc", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cabc45eb3d95785$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3cabc45eb3d95785$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    backlogLimitReachedFlagTitle: {
        "id": "software-issue-limit-flags.limit-reached-flag.backlog-limit-reached-flag-title",
        "defaultMessage": "Your backlog is full"
    },
    backlogLimitReachedAdminFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.backlog-limit-reached-admin-flag-body",
        "defaultMessage": "The backlog can only display 5000 issues, and your current filter contains {issueCount}. Edit your filter to refine what's included and excluded."
    },
    backlogLimitReachedEndUserFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.backlog-limit-reached-end-user-flag-body",
        "defaultMessage": "The backlog can only display 5000 issues, and the current filter contains {issueCount}. An admin will need to edit the board filter to refine what's included and excluded."
    },
    boardLimitReachedFlagTitle: {
        "id": "software-issue-limit-flags.limit-reached-flag.board-limit-reached-flag-title",
        "defaultMessage": "Your board is full"
    },
    boardLimitReachedAdminFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.board-limit-reached-admin-flag-body",
        "defaultMessage": "The board can only display 5000 issues, and your current filter contains {issueCount}. Edit your filter to refine what's included and excluded."
    },
    boardLimitReachedEndUserFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.board-limit-reached-end-user-flag-body",
        "defaultMessage": "The board can only display 5000 issues, and the current filter contains {issueCount}. An admin will need to edit the board filter to refine what's included and excluded."
    },
    tmpBacklogSprintsLimitReachedFlagTitle: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-backlog-sprints-limit-reached-flag-title",
        "defaultMessage": "Your backlog and sprint sections are full"
    },
    tmpSprintsLimitReachedFlagTitle: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-sprints-limit-reached-flag-title",
        "defaultMessage": "Your sprint section is full"
    },
    tmpBacklogLimitReachedFlagTitle: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-backlog-limit-reached-flag-title",
        "defaultMessage": "Your backlog is full"
    },
    tmpBacklogBoardLimitReachedFlagTitle: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-backlog-board-limit-reached-flag-title",
        "defaultMessage": "Your backlog and board sections are full"
    },
    tmpBoardLimitReachedFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-board-limit-reached-flag-body",
        "defaultMessage": "The board can only display 5000 issues, and your current board contains {issueCount}. It's time to move some issues."
    },
    tmpBacklogSprintsLimitReachedFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-backlog-sprints-limit-reached-flag-body",
        "defaultMessage": "Your backlog and sprint sections can each only display 5000 issues. It's time to move some issues."
    },
    tmpSprintsLimitReachedFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-sprints-limit-reached-flag-body",
        "defaultMessage": "We can only display 5000 issues across all your sprints. It's time to move some issues."
    },
    tmpBacklogLimitReachedFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-backlog-limit-reached-flag-body",
        "defaultMessage": "The backlog can only display 5000 issues, and your current backlog contains {issueCount}. It's time to move some issues."
    },
    tmpBacklogBoardLimitReachedFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-backlog-board-limit-reached-flag-body",
        "defaultMessage": "Your backlog and board sections can each only display 5000 issues. It's time to move some issues."
    },
    backlogLimitReachedAdminFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-reached-flag.backlog-limit-reached-admin-flag-body-issue-term-refresh",
        "defaultMessage": "The backlog can only display 5000 work items, and your current filter contains {issueCount}. Edit your filter to refine what's included and excluded."
    },
    backlogLimitReachedEndUserFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-reached-flag.backlog-limit-reached-end-user-flag-body-issue-term-refresh",
        "defaultMessage": "The backlog can only display 5000 work items, and the current filter contains {issueCount}. An admin will need to edit the board filter to refine what's included and excluded."
    },
    boardLimitReachedAdminFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-reached-flag.board-limit-reached-admin-flag-body-issue-term-refresh",
        "defaultMessage": "The board can only display 5000 work items, and your current filter contains {issueCount}. Edit your filter to refine what's included and excluded."
    },
    boardLimitReachedEndUserFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-reached-flag.board-limit-reached-end-user-flag-body-issue-term-refresh",
        "defaultMessage": "The board can only display 5000 work items, and the current filter contains {issueCount}. An admin will need to edit the board filter to refine what's included and excluded."
    },
    tmpBoardLimitReachedFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-board-limit-reached-flag-body-issue-term-refresh",
        "defaultMessage": "The board can only display 5000 work items, and your current board contains {issueCount}. It's time to move some work."
    },
    tmpBacklogSprintsLimitReachedFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-backlog-sprints-limit-reached-flag-body-issue-term-refresh",
        "defaultMessage": "Your backlog and sprint sections can each only display 5000 work items. It's time to move some work."
    },
    tmpSprintsLimitReachedFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-sprints-limit-reached-flag-body-issue-term-refresh",
        "defaultMessage": "We can only display 5000 work items across all your sprints. It's time to move some work."
    },
    tmpBacklogLimitReachedFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-backlog-limit-reached-flag-body-issue-term-refresh",
        "defaultMessage": "The backlog can only display 5000 work items, and your current backlog contains {issueCount}. It's time to move some work."
    },
    tmpBacklogBoardLimitReachedFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-backlog-board-limit-reached-flag-body-issue-term-refresh",
        "defaultMessage": "Your backlog and board sections can each only display 5000 work items. It's time to move some work."
    }
});

});




parcelRegister("kJ1Ne", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce599d26c9577203$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $i8Qvm = parcelRequire("i8Qvm");

var $8uFbT = parcelRequire("8uFbT");

var $4mO32 = parcelRequire("4mO32");

var $7XluA = parcelRequire("7XluA");

var $7CMCs = parcelRequire("7CMCs");

var $AeWM3 = parcelRequire("AeWM3");

var $aXhsp = parcelRequire("aXhsp");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $e43Es = parcelRequire("e43Es");

var $hN7SF = parcelRequire("hN7SF");

var $getng = parcelRequire("getng");

var $6P8fi = parcelRequire("6P8fi");

const $ce599d26c9577203$var$entryPointParams = {};
const $ce599d26c9577203$var$PublicFormChangeboardingModalRoot = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "public-forms-changeboarding-modal",
        packageName: "@atlassian/jira-public-forms-changeboarding-modal",
        teamName: "a4t-tanuki",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $AeWM3.ApolloClientProvider), {
        client: (0, $aXhsp.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce599d26c9577203$var$PublicFormChangeboardingModalContainer, props))));
};
const $ce599d26c9577203$var$PublicFormChangeboardingModalContainer = ({ projectId: projectId })=>{
    const { isActive: isModalTriggerActive } = (0, $8uFbT.useTrigger)((0, $1a3ee76b747d2e0b$export$245c2608a15570d3));
    const { isActive: isFlagTriggerActive } = (0, $8uFbT.useTrigger)((0, $1a3ee76b747d2e0b$export$6c605e0a476d3e4b));
    const data = (0, $e43Es.useGetData)({
        projectId: projectId,
        isEnabled: (isModalTriggerActive || isFlagTriggerActive) && (0, $4R6GH.fg)('jira_forms_public_access_changeboarding_gate')
    });
    const hasLoadedEntrypoint = (0, $5uXOq.useRef)(false);
    const { entryPointActions: modalEntryPointActions, entryPointReferenceSubject: modalEntryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $getng.asyncChangeboardingModalEntryPoint), $ce599d26c9577203$var$entryPointParams);
    const { entryPointActions: flagEntryPointActions, entryPointReferenceSubject: flagEntryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $hN7SF.asyncChangeboardingFlagEntryPoint), $ce599d26c9577203$var$entryPointParams);
    const isEligibleToViewChangeboarding = data && !data.projectHasPublicForm && data.isPublicFormEnabledForSite && data.canAdministerProject && data.projectHasFormNavItem;
    const shouldLoadModal = isModalTriggerActive && isEligibleToViewChangeboarding;
    const shouldRenderFlag = isFlagTriggerActive && isEligibleToViewChangeboarding;
    (0, $5uXOq.useEffect)(()=>{
        // if project already has public forms or has been disabled for the site, then
        // they already are aware of the feature and do not need to be notified
        if (data?.projectHasPublicForm || data?.isPublicFormEnabledForSite === false) {
            (0, $6P8fi.emitModalMessageEvent)({
                action: 'filter'
            });
            (0, $6P8fi.emitFlagMessageEvent)({
                action: 'filter'
            });
        }
    }, [
        data?.projectHasPublicForm,
        data?.isPublicFormEnabledForSite
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!hasLoadedEntrypoint.current) {
            if (shouldRenderFlag) {
                if (!(0, $6s1PB.expVal)('jira_forms_public_access_changeboarding', 'isEnabled', false)) {
                    // if in control cohort, snooze the post office message and check again later
                    // as experiment gradually rolls out
                    (0, $6P8fi.emitFlagMessageEvent)({
                        action: 'snooze'
                    });
                    return;
                }
                flagEntryPointActions.load();
                hasLoadedEntrypoint.current = true;
            }
            if (shouldLoadModal) {
                if (!(0, $6s1PB.expVal)('jira_forms_public_access_changeboarding', 'isEnabled', false)) {
                    (0, $6P8fi.emitModalMessageEvent)({
                        action: 'snooze'
                    });
                    return;
                }
                modalEntryPointActions.load();
                hasLoadedEntrypoint.current = true;
            }
        }
    }, [
        flagEntryPointActions,
        modalEntryPointActions,
        shouldLoadModal,
        shouldRenderFlag
    ]);
    if (!data || !data.project || !shouldLoadModal && !shouldRenderFlag) return null;
    const firstFormIdInProject = data.forms?.[0]?.formId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: modalEntryPointReferenceSubject,
        id: "public-forms-changeboarding-modal",
        packageName: "@atlassian/jira-public-forms-changeboarding-modal",
        teamName: "a4t-tanuki",
        fallback: null,
        errorFallback: "unmount",
        runtimeProps: {
            firstFormIdInProject: firstFormIdInProject,
            project: data.project
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: flagEntryPointReferenceSubject,
        id: "public-forms-changeboarding-flag",
        packageName: "@atlassian/jira-public-forms-changeboarding-modal",
        teamName: "a4t-tanuki",
        fallback: null,
        errorFallback: "unmount",
        runtimeProps: {
            firstFormIdInProject: firstFormIdInProject,
            project: data.project
        }
    }));
};
var $ce599d26c9577203$export$2e2bcd8739ae039 = $ce599d26c9577203$var$PublicFormChangeboardingModalRoot;

});
parcelRegister("aXhsp", function(module, exports) {

$parcel$export(module.exports, "default", () => $d88f4e626c9babc0$export$2e2bcd8739ae039);

var $9XE6b = parcelRequire("9XE6b");

var $ivfDv = parcelRequire("ivfDv");

var $e3a3O = parcelRequire("e3a3O");

var $clSzL = parcelRequire("clSzL");

var $h4ppL = parcelRequire("h4ppL");

var $JPsIz = parcelRequire("JPsIz");

var $lC4FX = parcelRequire("lC4FX");

var $cuKXc = parcelRequire("cuKXc");

var $2YZCu = parcelRequire("2YZCu");

var $dxpxC = parcelRequire("dxpxC");

var $l0T7c = parcelRequire("l0T7c");

var $9g713 = parcelRequire("9g713");


const $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID = 'gira';
const $d88f4e626c9babc0$var$CACHE_NAME = `apollo-cache/${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}`;
const $d88f4e626c9babc0$var$LOG_NAMESPACE = `apollo.${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}.error.graphql`;
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $d88f4e626c9babc0$var$isSsrSuccessful = ()=>false ? true : !window || !window.SPA_STATE;
const $d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY = 'networkErrorsCounter';
const $d88f4e626c9babc0$export$851a7159daf49c89 = new (0, $ivfDv.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: (/*@__PURE__*/$parcel$interopDefault($l0T7c))
});
const $d88f4e626c9babc0$var$errorLink = (0, $h4ppL.onError)(({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
    // Ignore network errors as they will be logged in the retry link
    (0, $9g713.reportErrors)({
        graphQLErrors: graphQLErrors,
        operation: operation
    });
    // Skip default error logging if analytics context data is defined for the query.
    const errorAnalytics = (0, $9g713.getErrorAnalyticsContext)(operation.getContext());
    if (errorAnalytics !== undefined) return;
    if (graphQLErrors) {
        if (Array.isArray(graphQLErrors)) graphQLErrors.map(({ message: message, locations: locations, path: path })=>(0, $2YZCu.default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`, {
                message: JSON.stringify(message),
                path: JSON.stringify(path),
                locations: JSON.stringify(locations)
            }));
        else (0, $2YZCu.default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, '[GraphQL error]: Unexpected error message format', {
            message: JSON.stringify(graphQLErrors)
        });
    }
    if (networkError) {
        const occuredNetworkErrorsBefore = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(operation.getContext(), [
            $d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY
        ], 0);
        (0, $2YZCu.default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, `[Network error]: ${networkError}, attempt ${occuredNetworkErrorsBefore + 1}`);
        operation.setContext({
            [$d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY]: occuredNetworkErrorsBefore + 1
        });
    }
});
const $d88f4e626c9babc0$var$retryLinkWithFama = new (0, $lC4FX.RetryLink)({
    delay: {
        initial: 300,
        max: 120000,
        jitter: true
    },
    attempts: (count, operation, networkError)=>{
        const retry = count < 5 && networkError && !networkError.statusCode;
        // Don't report any error if we're going to attempt a retry
        if (!retry) (0, $9g713.reportErrors)({
            networkError: networkError,
            operation: operation
        });
        return retry;
    }
});
class $d88f4e626c9babc0$var$CancelableRequestLink extends (0, $clSzL.ApolloLink) {
    constructor(){
        super();
        this.inFlightRequestControllers = {};
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    request(operation, forward) {
        const context = operation.getContext();
        if (!context.cancelable) return forward(operation);
        const key = JSON.stringify([
            operation.operationName,
            operation.query
        ]); // Equivalent to `operation.toKey` less the _actual_ variables
        this.inFlightRequestControllers[key]?.abort(); // Always abort the previous request
        const abortController = new AbortController();
        operation.setContext({
            ...context,
            fetchOptions: {
                signal: abortController.signal
            } // HttpLink passes this directly to fetch implementation
        });
        this.inFlightRequestControllers[key] = abortController;
        const cleanup = ()=>{
            // This callback may be called long after the request is replaced
            if (this.inFlightRequestControllers[key] === abortController) delete this.inFlightRequestControllers[key];
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new (0, $clSzL.Observable)((observer)=>{
            const subscription = forward(operation).subscribe({
                next: observer.next.bind(observer),
                // @ts-expect-error - TS7006 - Parameter 'error' implicitly has an 'any' type.
                error: (error)=>{
                    observer.error(error);
                    cleanup();
                },
                complete: observer.complete.bind(observer)
            });
            return ()=>{
                subscription?.unsubscribe();
                cleanup();
            };
        });
    }
}
const $d88f4e626c9babc0$var$cache = new (0, $ivfDv.InMemoryCache)({
    cacheRedirects: {
        Query: {
            ...(0, $cuKXc.fragmentCacheRedirect)()
        }
    },
    fragmentMatcher: $d88f4e626c9babc0$export$851a7159daf49c89,
    dataIdFromObject: (object)=>object.id && `${object.id}${object.__typename}`
})// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
.restore(!$d88f4e626c9babc0$var$isSsrSuccessful() && window.SPA_STATE[$d88f4e626c9babc0$var$CACHE_NAME] || {});
const $d88f4e626c9babc0$export$de66868aab9e79ea = (baseUrl)=>new (0, $e3a3O.ApolloClient)({
        name: $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID,
        ssrMode: $d88f4e626c9babc0$var$isSsrSuccessful(),
        // @ts-expect-error - TS2345 - Argument of type '{ name: string; ssrMode: boolean; addTypename: boolean; link: ApolloLink; cache: InMemoryCache; connectToDevTools: boolean; }' is not assignable to parameter of type 'ApolloClientOptions<NormalizedCacheObject>'.
        addTypename: true,
        link: (0, $clSzL.ApolloLink).from([
            $d88f4e626c9babc0$var$retryLinkWithFama,
            $d88f4e626c9babc0$var$errorLink,
            (0, $dxpxC.UFOLoggerLink),
            (0, $cuKXc.fragmentLinkState)($d88f4e626c9babc0$var$cache),
            ...!$d88f4e626c9babc0$var$isSsrSuccessful() ? [
                new $d88f4e626c9babc0$var$CancelableRequestLink()
            ] : [],
            new (0, $JPsIz.HttpLink)({
                uri: ({ operationName: operationName })=>`${baseUrl}/rest/${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}/1/?operation=${encodeURIComponent(operationName)}`,
                credentials: 'same-origin',
                // @ts-expect-error - TS2345 - Argument of type '{ uri: ({ operationName }: Operation) => string; credentials: string; abortErrorDoesNotCauseError: boolean; }' is not assignable to parameter of type 'Options'.
                abortErrorDoesNotCauseError: !$d88f4e626c9babc0$var$isSsrSuccessful()
            })
        ].filter(Boolean)),
        cache: $d88f4e626c9babc0$var$cache,
        connectToDevTools: false
    });
var $d88f4e626c9babc0$export$2e2bcd8739ae039 = {
    clientId: $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID,
    clientCreator: $d88f4e626c9babc0$export$de66868aab9e79ea
};

});
parcelRegister("l0T7c", function(module, exports) {
module.exports = JSON.parse("{\"__schema\":{\"types\":[{\"kind\":\"UNION\",\"name\":\"AllActivityFeedItemUnion\",\"possibleTypes\":[{\"name\":\"HistoryItem\"},{\"name\":\"CommentItem\"},{\"name\":\"WorklogItem\"},{\"name\":\"IncidentItem\"},{\"name\":\"ApprovalItem\"},{\"name\":\"HiddenCommentItem\"}]},{\"kind\":\"UNION\",\"name\":\"ApprovalActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ApprovalCreated\"},{\"name\":\"ApproverDecision\"},{\"name\":\"ApprovalCompleted\"}]},{\"kind\":\"UNION\",\"name\":\"ConfluencePageUnion\",\"possibleTypes\":[{\"name\":\"ConfluencePage\"},{\"name\":\"FailedRemoteLink\"}]},{\"kind\":\"UNION\",\"name\":\"GQLCategorizedField\",\"possibleTypes\":[{\"name\":\"GQLSortableField\"},{\"name\":\"GQLSearchableField\"}]},{\"kind\":\"UNION\",\"name\":\"GadgetParameters\",\"possibleTypes\":[{\"name\":\"VotedGadgetParameters\"},{\"name\":\"AssignedToMeGadgetParameters\"},{\"name\":\"WatchedGadgetParameters\"},{\"name\":\"InProgressGadgetParameters\"},{\"name\":\"FilterResultsGadgetParameters\"},{\"name\":\"TwoDimensionalStatisticsParameters\"},{\"name\":\"PieChartParameters\"},{\"name\":\"IssueStatisticsParameters\"},{\"name\":\"WorkloadPieChartParameters\"},{\"name\":\"ActivityStreamGadgetParameters\"},{\"name\":\"CreatedVsResolvedGadgetParameters\"},{\"name\":\"SprintGadgetParameters\"},{\"name\":\"ProjectsGadgetParameters\"},{\"name\":\"ConnectGadgetParameters\"},{\"name\":\"NotConfiguredGadgetParameters\"},{\"name\":\"UnsupportedGadgetParameters\"}]},{\"kind\":\"UNION\",\"name\":\"GroupByFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"UserField\"},{\"name\":\"LabelsField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"FloatCustomField\"}]},{\"kind\":\"UNION\",\"name\":\"GroupSectionItem\",\"possibleTypes\":[{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"HistoryValue\",\"possibleTypes\":[{\"name\":\"AssigneeFieldValue\"},{\"name\":\"PriorityFieldValue\"},{\"name\":\"StatusFieldValue\"},{\"name\":\"WorkLogFieldValue\"},{\"name\":\"RespondersFieldValue\"},{\"name\":\"GenericFieldValue\"}]},{\"kind\":\"UNION\",\"name\":\"IncidentActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ResponderAlertAssignedValue\"},{\"name\":\"AlertValue\"},{\"name\":\"ResponderAlertPriorityChangedValue\"},{\"name\":\"IccSessionValue\"},{\"name\":\"IccSessionInvitationValue\"},{\"name\":\"StakeholderUpdatedValue\"},{\"name\":\"IncidentStakeholderActionValue\"}]},{\"kind\":\"UNION\",\"name\":\"IssueFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"ProjectComponentsField\"},{\"name\":\"LabelsField\"},{\"name\":\"WatchersField\"},{\"name\":\"UserField\"},{\"name\":\"TextField\"},{\"name\":\"VersionsField\"},{\"name\":\"DateField\"},{\"name\":\"DateTimeField\"},{\"name\":\"IssueKeyField\"},{\"name\":\"ProjectField\"},{\"name\":\"ResolutionField\"},{\"name\":\"TimeTrackingField\"},{\"name\":\"TimeOriginalEstimateField\"},{\"name\":\"TimeEstimateField\"},{\"name\":\"TimeSpentField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"EpicLinkField\"},{\"name\":\"EpicNameField\"},{\"name\":\"ColorField\"},{\"name\":\"EpicColorField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"FlaggedCustomField\"},{\"name\":\"UserPickerCustomField\"},{\"name\":\"TextAreaCustomField\"},{\"name\":\"FloatCustomField\"},{\"name\":\"DatePickerCustomField\"},{\"name\":\"TextFieldCustomField\"},{\"name\":\"MultiSelectCustomField\"},{\"name\":\"LabelsCustomField\"},{\"name\":\"MultiUserPickerCustomField\"},{\"name\":\"PeopleCustomField\"},{\"name\":\"UrlCustomField\"},{\"name\":\"VersionCustomField\"},{\"name\":\"GroupPickerCustomField\"},{\"name\":\"MultiVersionCustomField\"},{\"name\":\"MultiGroupPickerCustomField\"},{\"name\":\"CheckBoxesCustomField\"},{\"name\":\"RadioButtonsCustomField\"},{\"name\":\"DateTimeCustomField\"},{\"name\":\"SeverityField\"},{\"name\":\"AffectedServicesField\"},{\"name\":\"TechLeadField\"},{\"name\":\"AttachmentsField\"},{\"name\":\"GlancesField\"},{\"name\":\"SecurityLevelField\"},{\"name\":\"IssueLinksField\"},{\"name\":\"IssuesInEpicField\"},{\"name\":\"SubtasksField\"},{\"name\":\"ChildIssuesField\"},{\"name\":\"CascadingSelectCustomField\"},{\"name\":\"CmdbField\"},{\"name\":\"SLACustomField\"},{\"name\":\"ProjectCustomField\"},{\"name\":\"EpicStatusField\"},{\"name\":\"ParentField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"CommentSummaryField\"}]},{\"kind\":\"UNION\",\"name\":\"IssueSections\",\"possibleTypes\":[{\"name\":\"PrimarySecondaryContextSections\"},{\"name\":\"JsdSections\"}]},{\"kind\":\"UNION\",\"name\":\"JiraActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraColorBackground\"},{\"name\":\"JiraGradientBackground\"},{\"name\":\"JiraMediaBackground\"},{\"name\":\"JiraAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraAtlassianIntelligenceAction\",\"possibleTypes\":[{\"name\":\"JiraAccessAtlassianIntelligenceFeature\"},{\"name\":\"JiraEnableAtlassianIntelligenceDeepLink\"},{\"name\":\"JiraContactOrgAdminToEnableAtlassianIntelligence\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBoardResult\",\"possibleTypes\":[{\"name\":\"JiraBoard\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraChildIssues\",\"possibleTypes\":[{\"name\":\"JiraChildIssuesWithinLimit\"},{\"name\":\"JiraChildIssuesExceedingLimit\"}]},{\"kind\":\"UNION\",\"name\":\"JiraCommentVisibility\",\"possibleTypes\":[{\"name\":\"JiraRoleVisibility\"},{\"name\":\"JiraGroupVisibility\"}]},{\"kind\":\"UNION\",\"name\":\"JiraConfluencePageContent\",\"possibleTypes\":[{\"name\":\"JiraConfluencePageContentDetails\"},{\"name\":\"JiraConfluencePageContentError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraContainerNavigationResult\",\"possibleTypes\":[{\"name\":\"JiraContainerNavigation\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraDefaultUnsplashImagesPageResult\",\"possibleTypes\":[{\"name\":\"JiraDefaultUnsplashImagesPage\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFavourite\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraPlan\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraServiceManagementQueue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFieldFormatConfig\",\"possibleTypes\":[{\"name\":\"JiraNumberFieldFormatConfig\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFieldSetViewResult\",\"possibleTypes\":[{\"name\":\"JiraFieldSetView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFormattingExpression\",\"possibleTypes\":[{\"name\":\"JiraFormattingSingleValueOperand\"},{\"name\":\"JiraFormattingTwoValueOperand\"},{\"name\":\"JiraFormattingMultipleValueOperand\"},{\"name\":\"JiraFormattingNoValueOperand\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGlobalPermissionGrantsResult\",\"possibleTypes\":[{\"name\":\"JiraGlobalPermissionGrantsList\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGrantTypeValue\",\"possibleTypes\":[{\"name\":\"JiraDefaultGrantTypeValue\"},{\"name\":\"JiraUserGrantTypeValue\"},{\"name\":\"JiraProjectRoleGrantTypeValue\"},{\"name\":\"JiraGroupGrantTypeValue\"},{\"name\":\"JiraIssueFieldGrantTypeValue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGroupLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateAdditionalServicesResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateAdditionalServices\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateFieldsResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateFields\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateLayoutResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueExportEvent\",\"possibleTypes\":[{\"name\":\"JiraIssueExportTaskSubmitted\"},{\"name\":\"JiraIssueExportTaskProgress\"},{\"name\":\"JiraIssueExportTaskCompleted\"},{\"name\":\"JiraIssueExportTaskTerminated\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"},{\"name\":\"JiraIssueItemGroupContainer\"},{\"name\":\"JiraIssueItemTabContainer\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainersResult\",\"possibleTypes\":[{\"name\":\"JiraIssueItemContainers\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemGroupContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemTabContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayout\",\"possibleTypes\":[{\"name\":\"JiraDefaultIssueLayout\"},{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"JiraLegacyIssueLayout\"},{\"name\":\"JsdDefaultIssueLayout\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldConfigurationHiddenIn\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInGlobal\"},{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInLayoutOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldPanelItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutContainerConfiguration\"},{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutGroupContainerConfiguration\"},{\"name\":\"JiraIssueLayoutTabContainerConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwner\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutIssueTypeOwner\"},{\"name\":\"JiraIssueLayoutRequestTypeOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwners\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutOwnersResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueResult\",\"possibleTypes\":[{\"name\":\"JiraIssue\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByFilterResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByFilter\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByJqlResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByJql\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraCustomIssueSearchError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchViewResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJQLGenerationError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraUIExposedError\"},{\"name\":\"JiraUsageLimitExceededError\"},{\"name\":\"JiraUnsupportedLanguageError\"},{\"name\":\"JiraGeneratedJqlInvalidError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyItem\",\"possibleTypes\":[{\"name\":\"JiraJourneyWorkItem\"},{\"name\":\"JiraJourneyStatusDependency\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyParentIssueValueType\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyTriggerConfiguration\",\"possibleTypes\":[{\"name\":\"JiraJourneyWorkdayIntegrationTriggerConfiguration\"},{\"name\":\"JiraJourneyParentIssueTriggerConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraJqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JiraJqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedField\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedValue\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraMediaUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraMediaUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraNavigationItemResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"JiraSoftwareBuiltInNavigationItem\"},{\"name\":\"JiraAppNavigationItem\"},{\"name\":\"JiraShortcutNavigationItem\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOnSuggestedChildIssueResult\",\"possibleTypes\":[{\"name\":\"JiraSuggestedIssue\"},{\"name\":\"JiraSuggestedChildIssueStatus\"},{\"name\":\"JiraSuggestedChildIssueError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOverviewPlanMigrationStateResult\",\"possibleTypes\":[{\"name\":\"JiraOverviewPlanMigrationState\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraPermissionSchemeViewResult\",\"possibleTypes\":[{\"name\":\"JiraPermissionSchemeView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectConfiguration\",\"possibleTypes\":[{\"name\":\"JiraProjectConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectNavigationMetadata\",\"possibleTypes\":[{\"name\":\"JiraSoftwareProjectNavigationMetadata\"},{\"name\":\"JiraServiceManagementProjectNavigationMetadata\"},{\"name\":\"JiraWorkManagementProjectNavigationMetadata\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectsUsingField\",\"possibleTypes\":[{\"name\":\"JiraProjectsUsingFieldResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraRemoteIssueLink\",\"possibleTypes\":[{\"name\":\"JiraIssueRemoteIssueLink\"},{\"name\":\"JiraConfluenceRemoteIssueLink\"},{\"name\":\"JiraWebRemoteIssueLink\"},{\"name\":\"JiraCustomRemoteIssueLink\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSearchableEntity\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraIssue\"},{\"name\":\"JiraServiceManagementQueue\"},{\"name\":\"JiraPlan\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSectionLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraGroupLayout\"},{\"name\":\"JiraTabLayout\"},{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementApproverPrincipal\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserApproverPrincipal\"},{\"name\":\"JiraServiceManagementGroupApproverPrincipal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementEntitledEntity\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementEntitlementCustomer\"},{\"name\":\"JiraServiceManagementEntitlementOrganization\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementRequestTypePreviewField\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementTextPreviewField\"},{\"name\":\"JiraServiceManagementTextAreaPreviewField\"},{\"name\":\"JiraServiceManagementDueDatePreviewField\"},{\"name\":\"JiraServiceManagementDatePreviewField\"},{\"name\":\"JiraServiceManagementDateTimePreviewField\"},{\"name\":\"JiraServiceManagementAttachmentPreviewField\"},{\"name\":\"JiraServiceManagementSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiUserPickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiServicePickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiCheckboxesPreviewField\"},{\"name\":\"JiraServiceManagementPeoplePreviewField\"},{\"name\":\"JiraServiceManagementUnknownPreviewField\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementResponder\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserResponder\"},{\"name\":\"JiraServiceManagementTeamResponder\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityEditGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityShareGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityAnonymousAccessGrant\"},{\"name\":\"JiraShareableEntityAnyLoggedInUserGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSpreadsheetGroupFieldValue\",\"possibleTypes\":[{\"name\":\"AtlassianAccountUser\"},{\"name\":\"JiraOption\"},{\"name\":\"JiraStatus\"},{\"name\":\"JiraPriority\"},{\"name\":\"JiraStoryPoint\"},{\"name\":\"JiraGoal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraUnsplashImageSearchPageResult\",\"possibleTypes\":[{\"name\":\"JiraUnsplashImageSearchPage\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraVersionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionResult\",\"possibleTypes\":[{\"name\":\"JiraVersion\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementColorBackground\"},{\"name\":\"JiraWorkManagementGradientBackground\"},{\"name\":\"JiraWorkManagementMediaBackground\"},{\"name\":\"JiraWorkManagementAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementCategoryOptionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementCategoryOptionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFieldConfigurationConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFieldConfigurationConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFilterConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFilterConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementGiraOverviewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementGiraOverview\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementSavedViewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementViewItemConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementViewItemConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedField\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedValue\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"LayoutDefiner\",\"possibleTypes\":[{\"name\":\"FieldLayoutScreen\"},{\"name\":\"JiraRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"MediaUploadTokenUnion\",\"possibleTypes\":[{\"name\":\"MediaUploadToken\"},{\"name\":\"FailedMediaUploadToken\"}]},{\"kind\":\"UNION\",\"name\":\"MergedFieldUnion\",\"possibleTypes\":[{\"name\":\"IssueTypeField\"},{\"name\":\"StatusField\"}]},{\"kind\":\"UNION\",\"name\":\"ProjectCategoryGadgetUnion\",\"possibleTypes\":[{\"name\":\"ProjectsGadgetItem\"},{\"name\":\"CategoriesGadgetItem\"}]},{\"kind\":\"UNION\",\"name\":\"RemoteIssueDetailsUnion\",\"possibleTypes\":[{\"name\":\"AssociatedIssueWrapper\"},{\"name\":\"FailedRemoteIssue\"}]},{\"kind\":\"UNION\",\"name\":\"SectionItem\",\"possibleTypes\":[{\"name\":\"GroupLayout\"},{\"name\":\"TabLayout\"},{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"TimeSeriesChartAdditionalPropertiesUnion\",\"possibleTypes\":[{\"name\":\"CreatedVsResolvedProperties\"}]}]}}");

});

parcelRegister("9g713", function(module, exports) {

$parcel$export(module.exports, "getErrorAnalyticsContext", () => $a87e716199660ede$export$bd030713895ed5e2);
$parcel$export(module.exports, "reportErrors", () => $a87e716199660ede$export$a78ebe1911f50d41);

var $9XE6b = parcelRequire("9XE6b");

var $e3a3O = parcelRequire("e3a3O");

var $jcw0u = parcelRequire("jcw0u");
const $a87e716199660ede$export$15d632fe38832073 = 'giraErrorAnalytics';
const $a87e716199660ede$export$fc6a71db0f9a33f9 = (errorAnalytics, context = {})=>({
        ...context,
        [$a87e716199660ede$export$15d632fe38832073]: errorAnalytics
    });
const $a87e716199660ede$export$bd030713895ed5e2 = (context)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const errorAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(context, [
        $a87e716199660ede$export$15d632fe38832073
    ], undefined);
    if (typeof errorAnalytics === 'object' && typeof errorAnalytics.id === 'string' && (errorAnalytics.packageName === undefined || typeof errorAnalytics.packageName === 'string') && (errorAnalytics.teamName === undefined || typeof errorAnalytics.teamName === 'string') && (errorAnalytics.attributes === undefined || typeof errorAnalytics.attributes === 'object') && (errorAnalytics.sendToPrivacyUnsafeSplunk === undefined || typeof errorAnalytics.sendToPrivacyUnsafeSplunk === 'boolean')) return {
        id: errorAnalytics.id,
        packageName: errorAnalytics.packageName,
        teamName: errorAnalytics.teamName,
        attributes: errorAnalytics.attributes,
        sendToPrivacyUnsafeSplunk: errorAnalytics.sendToPrivacyUnsafeSplunk
    };
    return undefined;
};
const $a87e716199660ede$export$a78ebe1911f50d41 = ({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
    const errorAnalytics = $a87e716199660ede$export$bd030713895ed5e2(operation.getContext());
    // Refine mixed type to Array | void
    if (graphQLErrors !== undefined && !Array.isArray(graphQLErrors)) return;
    const hasGraphQLError = graphQLErrors !== undefined && graphQLErrors.length > 0;
    const hasNetworkError = networkError !== undefined;
    // Only report errors using the JFE analytics pipeline if analytics context data is defined for the query.
    if (errorAnalytics === undefined || !hasGraphQLError && !hasNetworkError) return;
    const { id: id, packageName: packageName, teamName: teamName, attributes: attributes, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk } = errorAnalytics;
    const error = new (0, $e3a3O.ApolloError)({
        // Above Array.isArray check will refine the type to a read-only array. We need this spread to keep flow happy.
        graphQLErrors: graphQLErrors ? [
            ...graphQLErrors
        ] : undefined,
        networkError: networkError
    });
    const attributesWithOperationName = {
        ...attributes,
        operationName: operation.operationName,
        hasGraphQLError: hasGraphQLError,
        hasNetworkError: hasNetworkError
    };
    (0, $jcw0u.default)({
        error: error,
        meta: {
            id: id,
            packageName: packageName,
            teamName: teamName
        },
        attributes: attributesWithOperationName,
        sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk
    });
};

});


parcelRegister("e43Es", function(module, exports) {

$parcel$export(module.exports, "useGetData", () => $41a4c09c49cfff36$export$1f47bbb09bba389a);

var $5tTFS = parcelRequire("5tTFS");

var $kV9ss = parcelRequire("kV9ss");

var $koeKL = parcelRequire("koeKL");

var $lHhTR = parcelRequire("lHhTR");
const $41a4c09c49cfff36$var$getProjectHasFormNavItem = (data)=>{
    if (!data.jira?.containerNavigation) return false;
    if (!('navigationItems' in data.jira.containerNavigation)) return false;
    return data.jira.containerNavigation.navigationItems?.edges?.some((node)=>node?.node?.typeKey === 'FORMS') ?? false;
};
const $41a4c09c49cfff36$var$getProjectHasPublicForm = (data)=>{
    return data.jiraBusinessFormsByProjectId?.nodes?.some((node)=>node?.accessLevel === 'public') ?? false;
};
const $41a4c09c49cfff36$export$1f47bbb09bba389a = ({ projectId: projectId, isEnabled: isEnabled })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const projectAri = (0, $kV9ss.JiraProjectAri).create({
        siteId: cloudId,
        projectId: projectId
    });
    const { data: data } = (0, $5tTFS.useQuery)((0, $lHhTR.GET_DATA_QUERY), {
        variables: {
            projectId: projectId,
            projectAri: projectAri.toString()
        },
        fetchPolicy: 'network-only',
        skip: !isEnabled
    });
    if (!data) return undefined;
    const projectHasFormNavItem = $41a4c09c49cfff36$var$getProjectHasFormNavItem(data);
    const isPublicFormEnabledForSite = data.jiraBusinessFormsByProjectId?.publicFormsEnabled ?? null;
    const canAdministerProject = data.jira?.jiraProject?.administerProject?.canPerform ?? false;
    const projectHasPublicForm = $41a4c09c49cfff36$var$getProjectHasPublicForm(data);
    const firstStoryLevelIssueTypeId = data.jira?.jiraProject?.issueTypes?.edges?.[0]?.node?.issueTypeId ?? null;
    return {
        forms: data.jiraBusinessFormsByProjectId?.nodes,
        project: data.jira?.jiraProject,
        projectHasFormNavItem: projectHasFormNavItem,
        isPublicFormEnabledForSite: isPublicFormEnabledForSite,
        canAdministerProject: canAdministerProject,
        projectHasPublicForm: projectHasPublicForm,
        firstStoryLevelIssueTypeId: firstStoryLevelIssueTypeId
    };
};

});
parcelRegister("lHhTR", function(module, exports) {

$parcel$export(module.exports, "GET_DATA_QUERY", () => $91b4b63945405a40$export$d51f8ada234b77b5);

var $5cllN = parcelRequire("5cllN");
const $91b4b63945405a40$export$d51f8ada234b77b5 = (0, $5cllN.default)`
query getPublicFormChangeboardingData ($projectId: Long!, $projectAri: ID!) {
    jira {
        containerNavigation(
            input: {scopeId: $projectAri}
        ) {
            ... on JiraContainerNavigation {
                id
                navigationItems(first: 100) {
                    edges {
                        node {
                            typeKey
                            id
                        }
                    }
                }
            }
        }

        jiraProject(id: $projectAri) {
            id
            projectId
            key
            name
            projectType
			tmpBoardId
            administerProject: action(type: EDIT_PROJECT_CONFIG) {
              canPerform
            }
            issueTypes(
                first: 1,
                filter: { minHierarchyLevel: 0, maxHierarchyLevel: 0 }
            ) {
                edges {
                    node {
                        id
                        name
                        issueTypeId
                    }
                }
            }
        }
    }

    jiraBusinessFormsByProjectId(projectId: $projectId, first: 50) {
        publicFormsEnabled
        nodes {
            formId
            accessLevel
        }
    }
}
`;

});


parcelRegister("hN7SF", function(module, exports) {

$parcel$export(module.exports, "asyncChangeboardingFlagEntryPoint", () => $b78bb725d4342816$export$b6311e50754a3c1b);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $b78bb725d4342816$export$b6311e50754a3c1b = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("eoxUT")), {
        moduleId: "8f6b3883",
        moduleName: "PublicFormChangeboardingFlag"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("eoxUT", function(module, exports) {

let $a7ad9db866bbc73d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a7ad9db866bbc73d$var$load("3G2OT").then(()=>parcelRequire('f17IT'));

});


parcelRegister("getng", function(module, exports) {

$parcel$export(module.exports, "asyncChangeboardingModalEntryPoint", () => $fe964ab657d9125c$export$6f32a80685928724);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $fe964ab657d9125c$export$6f32a80685928724 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("djZZ9")), {
        moduleId: "2cab4041",
        moduleName: "PublicFormChangeboardingModal"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("djZZ9", function(module, exports) {

let $9b2d21b108df2c1e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9b2d21b108df2c1e$var$load("aeZUn").then(()=>parcelRequire('aHFvH'));

});


parcelRegister("6P8fi", function(module, exports) {

$parcel$export(module.exports, "getFormBuilderUrl", () => $d9991abb643263eb$export$1a0bdbdcca54ab65);
$parcel$export(module.exports, "emitModalMessageEvent", () => $d9991abb643263eb$export$bd83076b2e7fa91a);
$parcel$export(module.exports, "emitFlagMessageEvent", () => $d9991abb643263eb$export$e40f3f03094e29dc);

const $d9991abb643263eb$var$SOFTWARE_TMP_PREFIX = '/jira/software';
const $d9991abb643263eb$var$SOFTWARE_CMP_PREFIX = '/jira/software/c';
const $d9991abb643263eb$var$BUSINESS_PREFIX = '/jira/core';
const $d9991abb643263eb$export$36e24695f02d4503 = (project)=>{
    if (project.projectType === 'SOFTWARE') {
        if (project.tmpBoardId !== null) return $d9991abb643263eb$var$SOFTWARE_TMP_PREFIX;
        return $d9991abb643263eb$var$SOFTWARE_CMP_PREFIX;
    }
    return $d9991abb643263eb$var$BUSINESS_PREFIX;
};
const $d9991abb643263eb$export$1a0bdbdcca54ab65 = ({ project: project, formId: formId })=>{
    return `${$d9991abb643263eb$export$36e24695f02d4503(project)}/projects/${project.key}/form/${formId}/builder`;
};
const $d9991abb643263eb$export$bd83076b2e7fa91a = (eventDetails)=>{
    const event = new CustomEvent((0, $1a3ee76b747d2e0b$export$ca851eafcdc960ee), {
        detail: eventDetails
    });
    if (typeof document !== 'undefined') document.dispatchEvent(event);
};
const $d9991abb643263eb$export$e40f3f03094e29dc = (eventDetails)=>{
    const event = new CustomEvent((0, $1a3ee76b747d2e0b$export$a963aea3558fe23a), {
        detail: eventDetails
    });
    if (typeof document !== 'undefined') document.dispatchEvent(event);
};

});
const $1a3ee76b747d2e0b$export$ca3d56c0d6d21363 = 'jira_business_public-forms-changeboarding';
const $1a3ee76b747d2e0b$export$3b45ec1a607f2838 = 'SHOULD_SHOW_FORM_BUILDER_SPOTLIGHTING';
const $1a3ee76b747d2e0b$export$64e47a95ce32c8b2 = 'PUBLIC_FORM_CHANGEBOARDING_SPOTLIGHTS_FORM_ACCESS_STEP';
const $1a3ee76b747d2e0b$export$51318ec2f5085d87 = 'PUBLIC_FORM_CHANGEBOARDING_SPOTLIGHTS_FORM_FIELD_STEP';
const $1a3ee76b747d2e0b$export$ca851eafcdc960ee = 'jira-forms-public-forms-changeboarding-event';
const $1a3ee76b747d2e0b$export$245c2608a15570d3 = 'jira-forms-public-forms-changeboarding-trigger-id';
const $1a3ee76b747d2e0b$export$a963aea3558fe23a = 'jira-forms-public-forms-changeboarding-flag-event';
const $1a3ee76b747d2e0b$export$6c605e0a476d3e4b = 'jira-forms-public-forms-changeboarding-flag-trigger-id';



parcelRegister("9hLEH", function(module, exports) {

$parcel$export(module.exports, "default", () => $25af9d0222a23099$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $25af9d0222a23099$var$LazyProjectKeyboardShortcuts = (0, $kxZPA.lazy)(()=>(parcelRequire("kGfv3")), {
    moduleId: "./src/packages/software/keyboard-shortcuts/src/ui/project-shortcuts/main.tsx"
});
/**
 * Binds keyboard shortcuts to navigate to the respective experience when enabled:
 * 1 - Backlog
 * 2 - Board
 * 3 - Reports
 * 4 - Timeline
 */ const $25af9d0222a23099$var$ProjectKeyboardShortcuts = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "jira-software-keyboard-shortcuts-project-shortcuts",
        packageName: "jira-software-keyboard-shortcuts",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jira-software-keyboard-shortcuts",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($25af9d0222a23099$var$LazyProjectKeyboardShortcuts, props)));
var $25af9d0222a23099$export$2e2bcd8739ae039 = $25af9d0222a23099$var$ProjectKeyboardShortcuts;

});
parcelRegister("kGfv3", function(module, exports) {

let $f0e3c0d8d61be037$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f0e3c0d8d61be037$var$load("76n7a"),
    $f0e3c0d8d61be037$var$load("l253H"),
    $f0e3c0d8d61be037$var$load("2vWSI")
]).then(()=>parcelRequire('9pQJj'));

});


parcelRegister("3U6yu", function(module, exports) {

$parcel$export(module.exports, "StorageLimitsBanner", () => $281484b8f4d3a170$export$3250e2c90ae56dd9);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $281484b8f4d3a170$var$LazyStorageLimitBanner = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("kVI8q")), {
    ssr: false,
    moduleId: "./src/packages/growth/storage-limits/src/ui/index.tsx"
});
const $281484b8f4d3a170$export$3250e2c90ae56dd9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: (0, $59503b90ac06f221$export$5dec3c05c01dac30),
        packageName: (0, $59503b90ac06f221$export$b8b9d90f9e5bd72b),
        teamName: "growth-tako",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "storage-limits-banner",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($281484b8f4d3a170$var$LazyStorageLimitBanner, props)));

});
const $59503b90ac06f221$export$bab748d4654ac4a5 = 0.9;
const $59503b90ac06f221$export$b8b9d90f9e5bd72b = 'jiraGrowthStorageLimits';
const $59503b90ac06f221$export$df9953733f41292a = 'storageLimitsBanner';
const $59503b90ac06f221$export$5dec3c05c01dac30 = 'asyncStorageLimitsBanner';
const $59503b90ac06f221$export$3aad3de2cc377789 = 'jira_software_free_is_ccp_billing_admins';

parcelRegister("kVI8q", function(module, exports) {

let $f3cb5dc84edc109f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f3cb5dc84edc109f$var$load("a5EaQ").then(()=>parcelRequire('iMYa9'));

});


parcelRegister("dFfIn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c54faa42ed76e90b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $01Rn4 = parcelRequire("01Rn4");

var $cACkL = parcelRequire("cACkL");
const $c54faa42ed76e90b$var$AddBoardToHistory = ({ baseUrl: baseUrl, boardId: boardId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01Rn4.default), {
        op: ()=>(0, $cACkL.addBoardToHistory)(baseUrl, boardId)
    });
var $c54faa42ed76e90b$export$2e2bcd8739ae039 = $c54faa42ed76e90b$var$AddBoardToHistory;

});
parcelRegister("cACkL", function(module, exports) {

$parcel$export(module.exports, "addBoardToHistory", () => $350fcc2e90657d19$export$eef897770c591084);

var $2YZCu = parcelRequire("2YZCu");

var $eusud = parcelRequire("eusud");
const $350fcc2e90657d19$export$eef897770c591084 = (baseUrl, boardId)=>(0, $eusud.performPostRequest)(`${baseUrl}/rest/greenhopper/1.0/rapidview/addtohistory`, {
        body: JSON.stringify({
            rapidViewId: boardId
        })
    }).catch((e)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('software.view-history.src.services', 'Cannot add board to recent history', e);
    });

});


parcelRegister("g3TqM", function(module, exports) {

$parcel$export(module.exports, "ContrastThemeWrapper", () => $7d5fccb6e2bd27bd$export$83167134ef4aca8c);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");


var $a2e2Q = parcelRequire("a2e2Q");
const $7d5fccb6e2bd27bd$export$83167134ef4aca8c = ({ children: children })=>{
    const { isSoftwareProject: isSoftwareProject } = (0, $a2e2Q.useSoftwareProjectTheming)();
    if (isSoftwareProject) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $7d5fccb6e2bd27bd$var$overrideStyles
    }, children);
    return children;
};
const $7d5fccb6e2bd27bd$var$overrideStyles = (0, $8CUq3.xcss)({
    // @ts-expect-error Object literal may only specify known properties, and ''--ds-background-brand-bold'' does not exist in type 'SafeCSSObject'.ts(2353)
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--project-color-text': `var(${(0, $5b25b2eb4e8be764$export$7748fdcd335afdc0)}, ${"var(--ds-text, #172B4D)"})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--project-color-text-subtle': `var(${(0, $5b25b2eb4e8be764$export$fac615ceaa871e35)}, ${"var(--ds-text-subtle, #44546F)"})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    '--project-color-border': `var(${(0, $5b25b2eb4e8be764$export$4cd72d361867c565)}, ${"var(--ds-border, #091E4224)"})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    '--project-background-selected': `var(${(0, $5b25b2eb4e8be764$export$6377a47d5e33fe0c)}, ${"var(--ds-background-selected, #E9F2FF)"})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    '--project-color-border-selected': `var(${(0, $5b25b2eb4e8be764$export$e2e8fadb946a45d2)}, ${"var(--ds-border-selected, #0C66E4)"})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    '--project-color-text-selected': `var(${(0, $5b25b2eb4e8be764$export$7d1315b9160d905c)}, ${"var(--ds-text-selected, #0C66E4)"})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    '--project-text-accent-selected': `var(${(0, $5b25b2eb4e8be764$export$b7b95e9772d9313)}, ${"var(--ds-text-selected, #0C66E4)"})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    '--project-color-background-input': `var(${(0, $5b25b2eb4e8be764$export$6c9f7212e806df4b)}, ${"var(--ds-background-input, #FFFFFF)"})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    '--project-color-background-brand-bold': `var(${(0, $5b25b2eb4e8be764$export$7156de003aaa81f0)}, ${"var(--ds-background-brand-bold, #0C66E4)"})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    '--project-color-text-inverse': `var(${(0, $5b25b2eb4e8be764$export$8993323021b69878)}, ${"var(--ds-text-inverse, #FFFFFF)"})`
});

});

parcelRegister("fSgHa", function(module, exports) {

$parcel$export(module.exports, "useIsCMPBacklog", () => $917a155ff75b7326$export$7154dac79ee0a0dc);
$parcel$export(module.exports, "useIsCMPKanbanBacklog", () => $917a155ff75b7326$export$fedd46f53876dc1c);

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");
const $917a155ff75b7326$export$7154dac79ee0a0dc = ()=>(0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
const $917a155ff75b7326$export$fedd46f53876dc1c = ()=>(0, $c1MAf.useBacklogSelector)((0, $jG5HW.isCmpKanbanProject));

});

parcelRegister("3VzmQ", function(module, exports) {

$parcel$export(module.exports, "useShowCheckbox", () => $d1a4e58dde96d894$export$78efc2489ae380a9);

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");
const $d1a4e58dde96d894$export$78efc2489ae380a9 = ()=>{
    const isCheckboxSelection = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.isCheckboxSelectionMode));
    const hasMoreThanOneSelectedCard = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getSelectedCards)).length > 1;
    return isCheckboxSelection || hasMoreThanOneSelectedCard;
};

});

parcelRegister("zM1Qq", function(module, exports) {

$parcel$export(module.exports, "useIsEpicPanelOpen", () => $36715c326826e8ee$export$b8bc95e738a09ae0);

var $iDGXn = parcelRequire("iDGXn");

var $lODMY = parcelRequire("lODMY");

var $cYeCp = parcelRequire("cYeCp");

var $4R6GH = parcelRequire("4R6GH");

var $c1MAf = parcelRequire("c1MAf");

var $9Pc1U = parcelRequire("9Pc1U");
const $36715c326826e8ee$var$useLocationSelector = (0, $lODMY.createRouterSelector)((state)=>state.location);
const $36715c326826e8ee$export$b8bc95e738a09ae0 = ()=>{
    const showEpicAsPanel = (0, $c1MAf.useBacklogSelector)((0, $9Pc1U.getShowEpicAsPanel));
    const isEpicsOpen = (0, $iDGXn.useShowEpicPanel)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const location = (0, $4R6GH.fg)('optimise_display_epics_panel') ? $36715c326826e8ee$var$useLocationSelector() : undefined;
    // drop location check once `optimise_display`_epics_panel` is cleaned up
    const isEpicsOpenFromUrl = (0, $4R6GH.fg)('optimise_display_epics_panel') ? location && (0, $cYeCp.parseSearchQuery)(location.search).EPIC_PANEL : undefined;
    // epic panel is set to be open from URL - use that information directly to optimise VC
    if (isEpicsOpenFromUrl === true) return true;
    if (!showEpicAsPanel) return false;
    return isEpicsOpen;
};

});

parcelRegister("1wpyB", function(module, exports) {

$parcel$export(module.exports, "default", () => $58b0304ef56de034$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");

var $3f70T = parcelRequire("3f70T");
const $58b0304ef56de034$var$AllFieldsSync = ()=>{
    const cardIds = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCardIds));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, cardIds.map((id)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3f70T.default), {
            key: id,
            cardId: id
        })));
};
var $58b0304ef56de034$export$2e2bcd8739ae039 = $58b0304ef56de034$var$AllFieldsSync;

});
parcelRegister("3f70T", function(module, exports) {

$parcel$export(module.exports, "default", () => $371a2c6df5a70765$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");

var $6NpRl = parcelRequire("6NpRl");

var $6ObdQ = parcelRequire("6ObdQ");

var $iw4r6 = parcelRequire("iw4r6");

var $hAlb7 = parcelRequire("hAlb7");

var $jsuz0 = parcelRequire("jsuz0");

var $74GNh = parcelRequire("74GNh");

var $diays = parcelRequire("diays");
const $371a2c6df5a70765$var$FieldSync = ({ cardId: cardId })=>{
    const shouldSync = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.isCardSelected)(state)(cardId) || (0, $dGljH.shouldRenderRichElements)(state, {
            cardId: cardId
        }));
    const card = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.getCards)(state)[String(cardId)]);
    const intl = (0, $koVbs.default)();
    // don't unmount syncing if once enabled
    const [sync, setSync] = (0, $5uXOq.useState)(shouldSync);
    (0, $5uXOq.useEffect)(()=>{
        if (!sync && shouldSync) setSync(true);
    }, [
        sync,
        shouldSync
    ]);
    // don't sync if card is not fetched from state correctly
    if (!card) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (sync || shouldSync) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6ObdQ.default), {
        card: card,
        intl: intl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $74GNh.default), {
        card: card
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jsuz0.default), {
        card: card
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6NpRl.default), {
        card: card
    }), !(0, $4R6GH.fg)('relay-migration-issue-fields-summary') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $diays.default), {
        card: card
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iw4r6.default), {
        card: card
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hAlb7.default), {
        card: card
    })));
};
var $371a2c6df5a70765$export$2e2bcd8739ae039 = $371a2c6df5a70765$var$FieldSync;

});
parcelRegister("6NpRl", function(module, exports) {

$parcel$export(module.exports, "default", () => $55247a924c44482a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fhSLy = parcelRequire("fhSLy");

var $3fAi8 = parcelRequire("3fAi8");


var $iefb6 = parcelRequire("iefb6");

var $2HxVZ = parcelRequire("2HxVZ");

var $c1MAf = parcelRequire("c1MAf");
const $55247a924c44482a$var$FieldSyncAssignee = ({ card: { key: key, id: id, assignee: assigneeFromBacklog } })=>{
    const { id: assigneeIdFromBacklog, displayName: assigneeNameFromBacklog, avatarUrl: assigneeAvatarUrlFromBacklog } = assigneeFromBacklog || {};
    const [assigneeFromExtractedFields, { setFieldValue: setAssigneeInExtractedFields }] = (0, $3fAi8.useFieldValue)({
        issueKey: key,
        fieldKey: (0, $e9be48d6d2c01760$export$e18419056f3d184a)
    });
    const { accountId: assigneeIdFromExtractedFields, displayName: assigneeNameFromExtractedFields } = assigneeFromExtractedFields || {};
    const assigneeAvatarUrlFromExtractedFields = assigneeFromExtractedFields?.avatarUrls?.['48x48'];
    const assigneeFromBacklogChanged = (0, $iefb6.useDiffCheck)([
        assigneeIdFromBacklog
    ]);
    const assigneeFromExtractedFieldsChanged = (0, $iefb6.useDiffCheck)([
        assigneeIdFromExtractedFields
    ]);
    const setAssigneeInBacklog = (0, $c1MAf.useBacklogActionCreator)((0, $2HxVZ.cardAssigneeSet));
    const storesNeedToSync = assigneeIdFromBacklog !== assigneeIdFromExtractedFields;
    (0, $5uXOq.useEffect)(()=>{
        const assigneeFromBacklogIsDefined = assigneeFromBacklog !== undefined;
        // ASSIGNEE SYNC: BACKLOG -> EXTRACTED FIELDS
        // initial value, realtime...
        if (assigneeFromBacklogIsDefined && assigneeFromBacklogChanged && storesNeedToSync) setAssigneeInExtractedFields(key, (0, $e9be48d6d2c01760$export$e18419056f3d184a), // if assignee id is '', null or undefined => set assignee to null
        assigneeIdFromBacklog ? (0, $fhSLy.getUserShape)(assigneeIdFromBacklog, // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        assigneeNameFromBacklog, assigneeAvatarUrlFromBacklog) : null);
    }, [
        key,
        assigneeFromBacklog,
        assigneeIdFromBacklog,
        assigneeNameFromBacklog,
        assigneeAvatarUrlFromBacklog,
        assigneeFromBacklogChanged,
        storesNeedToSync,
        setAssigneeInExtractedFields
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const assigneeFromExtractedFieldsIsDefined = assigneeFromExtractedFields !== undefined;
        // ASSIGNEE SYNC: EXTRACTED FIELDS -> BACKLOG REDUX
        // issue view updates, inline assignee edit...
        if (// Ensure no sync will be called by Backlog as Backlog is the driver
        !assigneeFromBacklogChanged && assigneeFromExtractedFieldsIsDefined && assigneeFromExtractedFieldsChanged && storesNeedToSync) setAssigneeInBacklog(id, // if assignee id is '', null or undefined => set assignee to null
        assigneeIdFromExtractedFields ? {
            id: assigneeIdFromExtractedFields,
            displayName: assigneeNameFromExtractedFields,
            avatarUrl: assigneeAvatarUrlFromExtractedFields
        } : null);
    }, [
        id,
        assigneeFromBacklogChanged,
        assigneeFromExtractedFields,
        assigneeIdFromExtractedFields,
        assigneeNameFromExtractedFields,
        assigneeAvatarUrlFromExtractedFields,
        assigneeFromExtractedFieldsChanged,
        storesNeedToSync,
        setAssigneeInBacklog
    ]);
    return null;
};
var $55247a924c44482a$export$2e2bcd8739ae039 = $55247a924c44482a$var$FieldSyncAssignee;

});
parcelRegister("iefb6", function(module, exports) {

$parcel$export(module.exports, "useDiffCheck", () => $244ab56ac6cb1c50$export$5ade32966816005f);

var $5uXOq = parcelRequire("5uXOq");
const $244ab56ac6cb1c50$export$5ade32966816005f = (nextValues = [])=>{
    const ref = (0, $5uXOq.useRef)([]);
    const prevValues = ref.current;
    ref.current = nextValues;
    return prevValues.length ? prevValues.some((value, i)=>nextValues[i] !== value) : false;
};

});


parcelRegister("6ObdQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe8a76a3e9026e6a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3fAi8 = parcelRequire("3fAi8");


var $etKNj = parcelRequire("etKNj");

var $iefb6 = parcelRequire("iefb6");

var $3EtSK = parcelRequire("3EtSK");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $45Qwd = parcelRequire("45Qwd");
const $fe8a76a3e9026e6a$var$FieldSyncOriginalEstimate = ({ card: { id: id, key: key, estimate: estimate }, intl: intl })=>{
    const timeTrackingOptions = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getTimeTrackingOptions));
    const isOriginalEstimateType = (0, $c1MAf.useBacklogSelector)((0, $45Qwd.isOriginalEstimateTypeSelector));
    const setOriginalEstimateInBacklog = (0, $c1MAf.useBacklogActionCreator)((cardId, value)=>{
        const originalEstimate = value === null ? null : {
            value: value,
            valueAsText: (0, $etKNj.timeTrackingFormatter)(value, timeTrackingOptions, intl)
        };
        return (0, $3EtSK.cardEstimateSet)(cardId, {
            originalEstimate: originalEstimate
        });
    });
    const estimateFromBacklog = estimate?.originalEstimate;
    const originalEstimateFromBacklog = estimateFromBacklog?.value ?? null;
    // This hook updates the state used by bento in the field value service. It's necessary to provide the initial value
    // and to update the bento store when the original estimate changes from elsewhere in the backlog
    const [originalEstimateFromExtractedFields, { setFieldValue: setOriginalEstimateInExtractedFields }] = (0, $3fAi8.useFieldValue)({
        issueKey: key,
        fieldKey: (0, $e9be48d6d2c01760$export$5fbd3b15555b9ef2)
    });
    const originalEstimateFromBacklogChanged = (0, $iefb6.useDiffCheck)([
        originalEstimateFromBacklog
    ]);
    const originalEstimateFromExtractedFieldsChanged = (0, $iefb6.useDiffCheck)([
        originalEstimateFromExtractedFields
    ]);
    const storesNeedToSync = originalEstimateFromBacklog !== originalEstimateFromExtractedFields;
    (0, $5uXOq.useEffect)(()=>{
        const originalEstimateFromBacklogIsDefined = estimateFromBacklog !== undefined;
        const shouldSync = originalEstimateFromBacklogIsDefined && originalEstimateFromBacklogChanged && storesNeedToSync && isOriginalEstimateType;
        // ORIGINAL ESTIMATE SYNC: BACKLOG -> EXTRACTED FIELDS
        // Update sweet state (extracted field) when the original estimate value changes elsewhere or the card is initially rendered
        if (shouldSync) setOriginalEstimateInExtractedFields(key, (0, $e9be48d6d2c01760$export$5fbd3b15555b9ef2), originalEstimateFromBacklog);
    }, [
        key,
        estimateFromBacklog,
        originalEstimateFromBacklog,
        originalEstimateFromBacklogChanged,
        storesNeedToSync,
        setOriginalEstimateInExtractedFields,
        isOriginalEstimateType
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const originalEstimateFromExtractedFieldsIsDefined = originalEstimateFromExtractedFields !== undefined;
        const shouldSync = !originalEstimateFromBacklogChanged && originalEstimateFromExtractedFieldsIsDefined && originalEstimateFromExtractedFieldsChanged && storesNeedToSync && isOriginalEstimateType;
        // ORIGINAL ESTIMATE SYNC: EXTRACTED FIELDS -> BACKLOG
        // Update the backlog store if the value of the original estimate is changed within extracted fields
        if (shouldSync) setOriginalEstimateInBacklog(id, originalEstimateFromExtractedFields);
    }, [
        id,
        originalEstimateFromBacklogChanged,
        originalEstimateFromExtractedFields,
        originalEstimateFromExtractedFieldsChanged,
        storesNeedToSync,
        setOriginalEstimateInBacklog,
        isOriginalEstimateType
    ]);
    return null;
};
var $fe8a76a3e9026e6a$export$2e2bcd8739ae039 = $fe8a76a3e9026e6a$var$FieldSyncOriginalEstimate;

});

parcelRegister("iw4r6", function(module, exports) {

$parcel$export(module.exports, "default", () => $24811e058ab38ecc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3fAi8 = parcelRequire("3fAi8");

var $7Fute = parcelRequire("7Fute");

var $5fc53 = parcelRequire("5fc53");

var $iefb6 = parcelRequire("iefb6");

var $gkSeR = parcelRequire("gkSeR");

var $c1MAf = parcelRequire("c1MAf");

var $fmuR9 = parcelRequire("fmuR9");
const $24811e058ab38ecc$var$FieldSyncParent = ({ card: { key: key, id: id, parentId: parentIdFromBacklog } })=>{
    const [parentFromExtractedFields, { setFieldValue: setParentInExtractedFields }] = (0, $3fAi8.useFieldValue)({
        issueKey: key,
        fieldKey: (0, $5fc53.PARENT_TYPE)
    });
    // parentId in cards is number | null
    const parentIdFromExtractedFields = parentFromExtractedFields?.id ? Number(parentFromExtractedFields.id) : null;
    const parentNameFromExtractedFields = parentFromExtractedFields?.fields?.summary ?? null;
    const parentColorFromExtractedFields = parentFromExtractedFields?.color ?? null;
    const parentIdFromBacklogChanged = (0, $iefb6.useDiffCheck)([
        parentIdFromBacklog
    ]);
    const parentIdFromExtractedFieldsChanged = (0, $iefb6.useDiffCheck)([
        parentIdFromExtractedFields
    ]);
    const storesNeedToSync = parentIdFromBacklog !== parentIdFromExtractedFields;
    const issueParents = (0, $c1MAf.useBacklogSelector)((0, $fmuR9.issueParentsSelector));
    const setParentInBacklog = (0, $c1MAf.useBacklogActionCreator)((0, $gkSeR.cardParentIdSet));
    (0, $5uXOq.useEffect)(()=>{
        const parentIdFromBacklogIsDefined = parentIdFromBacklog !== undefined;
        // PARENT SYNC: BACKLOG -> EXTRACTED FIELDS
        // initial value, realtime...
        if (parentIdFromBacklogIsDefined && parentIdFromBacklogChanged && storesNeedToSync) {
            const parent = issueParents.length && parentIdFromBacklog && issueParents.find((p)=>Number(p.id) === Number(parentIdFromBacklog));
            setParentInExtractedFields(key, (0, $5fc53.PARENT_TYPE), parentIdFromBacklogIsDefined && parent ? (0, $7Fute.getParentShape)(parent.id, parent.key, parent.summary, {
                id: parent.issueType?.id,
                name: parent.issueType?.name,
                iconUrl: parent.issueType?.iconUrl ?? ''
            }) : null);
        }
    }, [
        key,
        storesNeedToSync,
        setParentInExtractedFields,
        parentIdFromBacklog,
        parentIdFromBacklogChanged,
        issueParents
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const parentIdFromExtractedFieldsIsDefined = parentIdFromExtractedFields !== undefined;
        // PARENT SYNC: EXTRACTED FIELDS -> BACKLOG REDUX
        // issue view updates, inline parent edit...
        if (// Ensure no sync will be called by Backlog as Backlog is the driver
        !parentIdFromBacklogChanged && parentIdFromExtractedFieldsIsDefined && parentIdFromExtractedFieldsChanged && storesNeedToSync) setParentInBacklog(id, parentIdFromExtractedFields);
    }, [
        id,
        storesNeedToSync,
        setParentInBacklog,
        parentIdFromExtractedFields,
        parentIdFromBacklogChanged,
        parentIdFromExtractedFieldsChanged
    ]);
    // update epic summary/color if it has been changed in the issue view
    (0, $5uXOq.useEffect)(()=>{
        const parent = issueParents.length && parentIdFromExtractedFields && issueParents.find((p)=>Number(p.id) === Number(parentIdFromExtractedFields));
        if (parent && (parentNameFromExtractedFields !== parent.summary || parentColorFromExtractedFields !== parent.color)) setParentInExtractedFields(key, (0, $5fc53.PARENT_TYPE), (0, $7Fute.getParentShape)(parent.id, parent.key, parent.summary, {
            id: parent.issueType?.id,
            name: parent.issueType?.name,
            iconUrl: parent.issueType?.iconUrl ?? ''
        }, parent.color));
    }, [
        issueParents,
        key,
        parentColorFromExtractedFields,
        parentIdFromExtractedFields,
        parentNameFromExtractedFields,
        setParentInExtractedFields
    ]);
    return null;
};
var $24811e058ab38ecc$export$2e2bcd8739ae039 = $24811e058ab38ecc$var$FieldSyncParent;

});

parcelRegister("hAlb7", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d056ec667262cb2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3fAi8 = parcelRequire("3fAi8");

var $5fc53 = parcelRequire("5fc53");

var $iefb6 = parcelRequire("iefb6");

var $c7Xu8 = parcelRequire("c7Xu8");

var $c1MAf = parcelRequire("c1MAf");
const $8d056ec667262cb2$export$32a891753e1d9d91 = ({ card: { id: id, key: key, priority: priorityFromBacklog } })=>{
    const setPriorityInBacklog = (0, $c1MAf.useBacklogActionCreator)((0, $c7Xu8.cardPrioritySet));
    const [priorityFromExtractedField, { setFieldValue: setPriorityInExtractedField }] = (0, $3fAi8.useFieldValue)({
        issueKey: key,
        fieldKey: (0, $5fc53.PRIORITY_TYPE)
    });
    const priorityFromBacklogChanged = (0, $iefb6.useDiffCheck)([
        priorityFromBacklog?.name
    ]);
    const priorityFromExtractedFieldChanged = (0, $iefb6.useDiffCheck)([
        priorityFromExtractedField?.name
    ]);
    const storesNeedToSync = priorityFromBacklog !== priorityFromExtractedField;
    (0, $5uXOq.useEffect)(()=>{
        const priorityFromBacklogIsDefined = priorityFromBacklog !== undefined;
        if (priorityFromBacklogIsDefined && priorityFromBacklogChanged && storesNeedToSync) setPriorityInExtractedField(key, (0, $5fc53.PRIORITY_TYPE), priorityFromBacklog);
    }, [
        key,
        priorityFromBacklogChanged,
        storesNeedToSync,
        setPriorityInExtractedField,
        priorityFromBacklog
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const priorityFromExtractedFieldIsDefined = priorityFromExtractedField !== undefined;
        if (!priorityFromBacklogChanged && priorityFromExtractedFieldIsDefined && priorityFromExtractedFieldChanged && storesNeedToSync) setPriorityInBacklog({
            cardId: id,
            priority: priorityFromExtractedField
        });
    }, [
        id,
        priorityFromBacklogChanged,
        priorityFromExtractedField,
        priorityFromExtractedFieldChanged,
        storesNeedToSync,
        setPriorityInBacklog
    ]);
    return null;
};
var $8d056ec667262cb2$export$2e2bcd8739ae039 = $8d056ec667262cb2$export$32a891753e1d9d91;

});

parcelRegister("jsuz0", function(module, exports) {

$parcel$export(module.exports, "default", () => $850a9cb0391bfc75$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ggSx2 = parcelRequire("ggSx2");

var $hGgHi = parcelRequire("hGgHi");

var $gULOk = parcelRequire("gULOk");

var $3fAi8 = parcelRequire("3fAi8");

var $44VbI = parcelRequire("44VbI");


var $iefb6 = parcelRequire("iefb6");

var $czUNp = parcelRequire("czUNp");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $kwBUh = parcelRequire("kwBUh");

var $bAfUr = parcelRequire("bAfUr");
const $850a9cb0391bfc75$var$FieldSyncStatus = ({ card: card })=>{
    const columns = (0, $c1MAf.useBacklogSelector)((0, $kwBUh.getColumns));
    const statusFromBacklog = (0, $c1MAf.useBacklogSelector)((state)=>card ? (0, $bAfUr.getColumnStatusByStatusId)(card.statusId)(state) : null);
    const isCMP = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
    const { key: cardKey, id: cardId, statusId: cardStatusId } = card;
    const setStatusInBacklog = (0, $c1MAf.useBacklogActionCreator)((0, $czUNp.cardStatusSet));
    const { id: statusIdFromBacklog, name: statusNameFromBacklog, category: statusCategoryFromBacklog } = statusFromBacklog || {};
    const [statusFromExtractedFields, { setFieldValue: setStatusInExtractedFields }] = (0, $3fAi8.useFieldValue)({
        issueKey: cardKey,
        fieldKey: (0, $e9be48d6d2c01760$export$4420b7468f889692)
    });
    const { id: statusIdFromExtractedFields, statusCategory: statusCategoryFromExtractedFields } = statusFromExtractedFields || {};
    const statusFromBacklogChanged = (0, $iefb6.useDiffCheck)([
        statusIdFromBacklog
    ]);
    const statusFromExtractedFieldsChanged = (0, $iefb6.useDiffCheck)([
        statusIdFromExtractedFields
    ]);
    const storesNeedToSync = statusIdFromBacklog !== statusIdFromExtractedFields;
    (0, $5uXOq.useEffect)(()=>{
        const statusFromBacklogIsDefined = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(statusFromBacklog) && Boolean(statusIdFromBacklog);
        // STATUS SYNC: BACKLOG -> EXTRACTED FIELDS
        // initial value, realtime...
        if (statusFromBacklogIsDefined && statusFromBacklogChanged && storesNeedToSync) setStatusInExtractedFields(cardKey, (0, $e9be48d6d2c01760$export$4420b7468f889692), (0, $44VbI.getStatusShape)(// @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        statusIdFromBacklog, statusNameFromBacklog, statusCategoryFromBacklog));
    }, [
        cardKey,
        statusFromBacklog,
        statusIdFromBacklog,
        statusNameFromBacklog,
        statusCategoryFromBacklog,
        statusFromBacklogChanged,
        storesNeedToSync,
        setStatusInExtractedFields
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const statusFromExtractedFieldsIsDefined = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(statusFromExtractedFields) && Boolean(statusIdFromExtractedFields);
        // STATUS SYNC: EXTRACTED FIELDS -> BACKLOG REDUX
        // issue view updates, inline status edit...
        if (// Ensure no sync will be called by Backlog as Backlog is the driver
        columns !== null && !statusFromBacklogChanged && statusFromExtractedFieldsIsDefined && statusFromExtractedFieldsChanged && storesNeedToSync) setStatusInBacklog(cardId, cardStatusId, statusIdFromExtractedFields, // @ts-expect-error TS2345: Argument of type 'string' is not assignable to parameter of type 'StatusCategoryKeys'.
        (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))((0, $gULOk.StatusCategoryIds))[statusCategoryFromExtractedFields.id] || (0, $gULOk.StatusCategoryTypes).UNDEFINED, isCMP);
    }, [
        columns,
        cardId,
        cardStatusId,
        statusFromBacklogChanged,
        statusFromExtractedFields,
        statusIdFromExtractedFields,
        statusCategoryFromExtractedFields,
        statusFromExtractedFieldsChanged,
        storesNeedToSync,
        setStatusInBacklog,
        isCMP
    ]);
    return null;
};
var $850a9cb0391bfc75$export$2e2bcd8739ae039 = $850a9cb0391bfc75$var$FieldSyncStatus;

});

parcelRegister("74GNh", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4321c2b9a622196$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3fAi8 = parcelRequire("3fAi8");

var $iefb6 = parcelRequire("iefb6");

var $3EtSK = parcelRequire("3EtSK");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $45Qwd = parcelRequire("45Qwd");
const $e4321c2b9a622196$var$FieldSyncStoryPoint = ({ card: { id: id, key: key, estimate: estimate } })=>{
    const storyPointFieldId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getStoryPointFieldId));
    const isNumericEstimateType = (0, $c1MAf.useBacklogSelector)((0, $45Qwd.isNumericEstimateTypeSelector));
    const setStoryPointInBacklog = (0, $c1MAf.useBacklogActionCreator)((cardId, storyPoints)=>(0, $3EtSK.cardEstimateSet)(cardId, {
            storyPoints: storyPoints
        }));
    const StoryPointKey = storyPointFieldId || '';
    const storyPointFromBacklog = estimate?.storyPoints;
    // This hook updates the state used by bento in the field value service. It's necessary to provide the initial value
    // and to update the bento store when the story point changes from elsewhere in the backlog
    const [storyPointFromExtractedFields, { setFieldValue: setStoryPointInExtractedFields }] = (0, $3fAi8.useFieldValue)({
        issueKey: key,
        fieldKey: StoryPointKey
    });
    const storyPointFromBacklogChanged = (0, $iefb6.useDiffCheck)([
        storyPointFromBacklog
    ]);
    const storyPointFromExtractedFieldsChanged = (0, $iefb6.useDiffCheck)([
        storyPointFromExtractedFields
    ]);
    const storesNeedToSync = storyPointFromBacklog !== storyPointFromExtractedFields;
    (0, $5uXOq.useEffect)(()=>{
        const storyPointFromBacklogIsDefined = storyPointFromBacklog !== undefined;
        const shouldSync = StoryPointKey && storyPointFromBacklogIsDefined && storyPointFromBacklogChanged && storesNeedToSync && isNumericEstimateType;
        // STORY POINT SYNC: BACKLOG -> EXTRACTED FIELDS
        // Update sweet state (extracted field) when the story point value changes elsewhere or the card is initially rendered
        if (shouldSync) setStoryPointInExtractedFields(key, StoryPointKey, storyPointFromBacklog);
    }, [
        StoryPointKey,
        key,
        storyPointFromBacklog,
        storyPointFromBacklogChanged,
        storesNeedToSync,
        setStoryPointInExtractedFields,
        isNumericEstimateType
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const storyPointFromExtractedFieldsIsDefined = storyPointFromExtractedFields !== undefined;
        const shouldSync = !storyPointFromBacklogChanged && storyPointFromExtractedFieldsIsDefined && storyPointFromExtractedFieldsChanged && storesNeedToSync && isNumericEstimateType;
        // STORY POINT SYNC: EXTRACTED FIELDS -> BACKLOG
        // Update the backlog store if the value of the story point is changed within extracted fields
        if (shouldSync) setStoryPointInBacklog(id, storyPointFromExtractedFields);
    }, [
        id,
        storyPointFromBacklogChanged,
        storyPointFromExtractedFields,
        storyPointFromExtractedFieldsChanged,
        storesNeedToSync,
        setStoryPointInBacklog,
        isNumericEstimateType
    ]);
    return null;
};
var $e4321c2b9a622196$export$2e2bcd8739ae039 = $e4321c2b9a622196$var$FieldSyncStoryPoint;

});

parcelRegister("diays", function(module, exports) {

$parcel$export(module.exports, "default", () => $99ced2c1f60aaba6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3fAi8 = parcelRequire("3fAi8");


var $iefb6 = parcelRequire("iefb6");

var $kB9og = parcelRequire("kB9og");

var $c1MAf = parcelRequire("c1MAf");
const $99ced2c1f60aaba6$export$e5eb14bcd03ae390 = ({ card: { id: id, key: key, summary: summaryFromBacklog } })=>{
    const setSummaryInBacklog = (0, $c1MAf.useBacklogActionCreator)((0, $kB9og.cardSummarySet));
    const [summaryFromExtractedField, { setFieldValue: setSummaryInExtractedField }] = (0, $3fAi8.useFieldValue)({
        issueKey: key,
        fieldKey: (0, $e9be48d6d2c01760$export$e7cf1830fe735d1f)
    });
    const summaryFromBacklogChanged = (0, $iefb6.useDiffCheck)([
        summaryFromBacklog
    ]);
    const summaryFromExtractedFieldChanged = (0, $iefb6.useDiffCheck)([
        summaryFromExtractedField
    ]);
    const storesNeedToSync = summaryFromBacklog !== summaryFromExtractedField;
    // Fixes creating issues from GIC where redux isn't synced with React Sweet
    // State. This is a workaround to unblock me. There is a more permanent
    // solution being investigated here
    // https://hello.atlassian.net/browse/DEE-923
    (0, $5uXOq.useEffect)(()=>{
        const summaryFromBacklogIsDefined = summaryFromBacklog !== undefined;
        const summaryFromExtractedFieldIsUndefined = summaryFromExtractedField === undefined;
        if (summaryFromBacklogIsDefined && summaryFromExtractedFieldIsUndefined) setSummaryInExtractedField(key, (0, $e9be48d6d2c01760$export$e7cf1830fe735d1f), summaryFromBacklog);
    }, [
        key,
        setSummaryInExtractedField,
        summaryFromBacklog,
        summaryFromExtractedField
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const summaryFromBacklogIsDefined = summaryFromBacklog !== undefined;
        if (summaryFromBacklogIsDefined && summaryFromBacklogChanged && storesNeedToSync) setSummaryInExtractedField(key, (0, $e9be48d6d2c01760$export$e7cf1830fe735d1f), summaryFromBacklog);
    }, [
        key,
        summaryFromBacklog,
        summaryFromBacklogChanged,
        storesNeedToSync,
        setSummaryInExtractedField
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const summaryFromExtractedFieldIsDefined = summaryFromExtractedField !== undefined;
        if (!summaryFromBacklogChanged && summaryFromExtractedFieldIsDefined && summaryFromExtractedFieldChanged && storesNeedToSync) setSummaryInBacklog(id, summaryFromExtractedField);
    }, [
        id,
        summaryFromBacklogChanged,
        summaryFromExtractedField,
        summaryFromExtractedFieldChanged,
        storesNeedToSync,
        setSummaryInBacklog
    ]);
    return null;
};
var $99ced2c1f60aaba6$export$2e2bcd8739ae039 = $99ced2c1f60aaba6$export$e5eb14bcd03ae390;

});



parcelRegister("4APWT", function(module, exports) {

$parcel$export(module.exports, "default", () => $46c3b0ca80e674de$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $et6P7 = parcelRequire("et6P7");

var $4mqko = parcelRequire("4mqko");

var $38qhf = parcelRequire("38qhf");

var $c2Ik2 = parcelRequire("c2Ik2");

var $gwOHY = parcelRequire("gwOHY");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $l9VFH = parcelRequire("l9VFH");

var $fSgHa = parcelRequire("fSgHa");

var $87wCD = parcelRequire("87wCD");

var $jV4Wh = parcelRequire("jV4Wh");

var $f8qNM = parcelRequire("f8qNM");
const $46c3b0ca80e674de$var$BacklogContentContainerInner = (props)=>{
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const selectedCards = (0, $c1MAf.useBacklogSelector)((0, $dGljH.selectedCardsForVersionsPanelSelector));
    const lastFilteredIssueTypeId = (0, $c1MAf.useBacklogSelector)((0, $l9VFH.getLastFilteredIssueTypeId));
    const isCompanyManaged = (0, $fSgHa.useIsCMPBacklog)();
    const epicLinkFieldId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getEpicLinkFieldId));
    const firstNonEmptyCardListId = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getFirstNonEmptyCardListId));
    const lastNonEmptyCardListId = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getLastNonEmptyCardListId));
    const pushEvent = (0, $jV4Wh.useBatchOnReceive)();
    const onCardDetailClick = (0, $c1MAf.useBacklogActionCreator)((0, $4mqko.parentClick));
    const onEpicCreate = (0, $c1MAf.useBacklogActionCreator)((issueParents)=>(0, $c2Ik2.issueParentsCreateSet)({
            issueParents: issueParents
        }));
    const onVersionAltered = (0, $5uXOq.useCallback)((version)=>{
        if (isCompanyManaged) dispatch((0, $gwOHY.updateVersion)({
            id: version.versionId,
            name: version.name,
            projectId: Number(version.projectId)
        }));
        dispatch((0, $38qhf.updateDetailView)());
    }, [
        dispatch,
        isCompanyManaged
    ]);
    const onIssueVersionsUpdated = (0, $87wCD.useOnIssueVersionsUpdated)();
    const onEpicAssign = (0, $c1MAf.useBacklogActionCreator)((cards, parentId, requestPromise)=>(0, $et6P7.cardsParentSetOptimistic)({
            cards: cards,
            parentId: parentId,
            requestPromise: requestPromise
        }));
    // TODO: remove on 'jira_replace_provider_and_client_with_realtime' feature gate clean up
    const onReceive = (0, $5uXOq.useCallback)((eventType, payload)=>{
        const event = {
            type: eventType,
            payload: payload
        };
        pushEvent(event);
    }, [
        pushEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f8qNM.default), {
        ...props,
        selectedCards: selectedCards,
        selectedCardTypeId: lastFilteredIssueTypeId,
        onCardDetailClick: onCardDetailClick,
        onEpicCreate: onEpicCreate,
        onEpicAssign: onEpicAssign,
        onIssueVersionsUpdated: onIssueVersionsUpdated,
        onVersionAltered: onVersionAltered,
        onReceive: onReceive,
        onReceiveEvent: pushEvent,
        isCompanyManaged: isCompanyManaged,
        epicLinkFieldId: epicLinkFieldId,
        firstNonEmptyCardListId: firstNonEmptyCardListId,
        lastNonEmptyCardListId: lastNonEmptyCardListId,
        issueHierarchyLevel: props.issueHierarchyLevel
    });
};
const $46c3b0ca80e674de$var$BacklogContentContainer = /*#__PURE__*/ (0, $5uXOq.memo)($46c3b0ca80e674de$var$BacklogContentContainerInner);
var $46c3b0ca80e674de$export$2e2bcd8739ae039 = $46c3b0ca80e674de$var$BacklogContentContainer;

});
parcelRegister("87wCD", function(module, exports) {

$parcel$export(module.exports, "useOnIssueVersionsUpdated", () => $7c82466ffb9b2c1f$export$4b98876a65f85873);

var $5uXOq = parcelRequire("5uXOq");

var $fdAim = parcelRequire("fdAim");

var $38qhf = parcelRequire("38qhf");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");
const $7c82466ffb9b2c1f$export$4b98876a65f85873 = ()=>{
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const isDetailViewOpenWithAnySelectedCard = (0, $c1MAf.useBacklogSelector)((0, $dGljH.isDetailViewOpenWithAnySelectedCardSelector));
    return (0, $5uXOq.useCallback)((cardIds)=>{
        cardIds.forEach((id)=>dispatch((0, $fdAim.cardRefreshRequest)(id)));
        if (isDetailViewOpenWithAnySelectedCard) dispatch((0, $38qhf.updateDetailView)());
    }, [
        dispatch,
        isDetailViewOpenWithAnySelectedCard
    ]);
};

});

parcelRegister("jV4Wh", function(module, exports) {

$parcel$export(module.exports, "useBatchOnReceive", () => $cc5b5b5389b73340$export$b02b538e3e12eaf4);

var $5uXOq = parcelRequire("5uXOq");

var $cab1K = parcelRequire("cab1K");
parcelRequire("a2e6K");
parcelRequire("eSGL3");
parcelRequire("1oQta");

var $guzeq = parcelRequire("guzeq");

var $3lZ6i = parcelRequire("3lZ6i");

var $ubpiL = parcelRequire("ubpiL");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");
const $cc5b5b5389b73340$export$23831c9717212b2 = 500;
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $cc5b5b5389b73340$var$isActiveTab = ()=>!document.hidden;
const $cc5b5b5389b73340$export$b02b538e3e12eaf4 = ()=>{
    const subjectRef = (0, $5uXOq.useRef)(new (0, $cab1K.Subject)());
    const currentUser = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getAtlassianAccountId));
    const refreshData = (0, $c1MAf.useBacklogActionCreator)((0, $3lZ6i.refreshDataRequest));
    const dispatch = (0, $c1MAf.useBacklogActionCreator)((0, $ubpiL.dispatchRealtimeEventBatch));
    const pushEvent = (0, $5uXOq.useCallback)((event)=>{
        if (!subjectRef.current.closed) subjectRef.current.next(event);
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        const subject = subjectRef.current;
        subject.buffer(subject.debounceTime($cc5b5b5389b73340$export$23831c9717212b2)).filter($cc5b5b5389b73340$var$isActiveTab).subscribe((events)=>{
            if (!subjectRef.current.closed) {
                dispatch(events);
                const hasEventsFromOthers = events.filter((s)=>s.payload.atlassianId !== currentUser).length > 0;
                if (hasEventsFromOthers) refreshData((0, $guzeq.REFRESH_SOURCE_REALTIME));
            }
        });
        return ()=>{
            subject.unsubscribe();
        };
    }, [
        currentUser,
        dispatch,
        refreshData
    ]);
    return pushEvent;
};

});
parcelRegister("a2e6K", function(module, exports) {
"use strict";

var $kVLXA = parcelRequire("kVLXA");

var $1tgji = parcelRequire("1tgji");
$kVLXA.Observable.prototype.buffer = $1tgji.buffer;

});
parcelRegister("1tgji", function(module, exports) {

$parcel$export(module.exports, "buffer", () => $112526bf5dc8d152$export$ab1029bcae9ddb4a, (v) => $112526bf5dc8d152$export$ab1029bcae9ddb4a = v);
var $112526bf5dc8d152$export$ab1029bcae9ddb4a;
"use strict";

var $icZql = parcelRequire("icZql");
/**
 * Buffers the source Observable values until `closingNotifier` emits.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * that array only when another Observable emits.</span>
 *
 * <img src="./img/buffer.png" width="100%">
 *
 * Buffers the incoming Observable values until the given `closingNotifier`
 * Observable emits a value, at which point it emits the buffer on the output
 * Observable and starts a new buffer internally, awaiting the next time
 * `closingNotifier` emits.
 *
 * @example <caption>On every click, emit array of most recent interval events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var interval = Rx.Observable.interval(1000);
 * var buffered = interval.buffer(clicks);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link window}
 *
 * @param {Observable<any>} closingNotifier An Observable that signals the
 * buffer to be emitted on the output Observable.
 * @return {Observable<T[]>} An Observable of buffers, which are arrays of
 * values.
 * @method buffer
 * @owner Observable
 */ function $112526bf5dc8d152$var$buffer(closingNotifier) {
    return $icZql.buffer(closingNotifier)(this);
}
$112526bf5dc8d152$export$ab1029bcae9ddb4a = $112526bf5dc8d152$var$buffer;

});



parcelRegister("f8qNM", function(module, exports) {

$parcel$export(module.exports, "default", () => $8428b7783d52b361$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $k12ix = parcelRequire("k12ix");

var $4R6GH = parcelRequire("4R6GH");

var $g4tDr = parcelRequire("g4tDr");

var $3HwlS = parcelRequire("3HwlS");

var $2Z6La = parcelRequire("2Z6La");

var $1XJ20 = parcelRequire("1XJ20");

var $b32lf = parcelRequire("b32lf");

var $ewaBk = parcelRequire("ewaBk");

var $a5Tut = parcelRequire("a5Tut");

var $9Ik53 = parcelRequire("9Ik53");

var $g3RsK = parcelRequire("g3RsK");

var $a4XJc = parcelRequire("a4XJc");

var $9pP0g = parcelRequire("9pP0g");

var $iDGXn = parcelRequire("iDGXn");

var $l8ruj = parcelRequire("l8ruj");

var $dCm1o = parcelRequire("dCm1o");


var $3eS6S = parcelRequire("3eS6S");

var $8hVbJ = parcelRequire("8hVbJ");

var $6MzeB = parcelRequire("6MzeB");

var $gz8lb = parcelRequire("gz8lb");

var $6e1e1 = parcelRequire("6e1e1");

var $lmlf0 = parcelRequire("lmlf0");

var $e2Elo = parcelRequire("e2Elo");

var $jg0aS = parcelRequire("jg0aS");

var $eX9XD = parcelRequire("eX9XD");

var $fDXV9 = parcelRequire("fDXV9");

var $5eblm = parcelRequire("5eblm");

var $cc2av = parcelRequire("cc2av");
const $8428b7783d52b361$var$RenderEndMark = ()=>{
    const metric = (0, $6MzeB.usePerformanceMetric)();
    (0, $5uXOq.useEffect)(()=>{
        metric.mark((0, $8hVbJ.PAGE_LOAD_MARK_RENDER_END));
    }, [
        metric
    ]);
    return null;
};
const $8428b7783d52b361$var$BacklogContentInner = ({ isCacheHit: isCacheHit, boardId: boardId, issueHierarchyLevel: issueHierarchyLevel, isDetailViewVisible: isDetailViewVisible, isCompanyManaged: isCompanyManaged = false, parentWidth: parentWidth, CardList: CardList, cardListIds: cardListIds, selectedCards: selectedCards, SubmitApdex: SubmitApdex, BoardIssueMoveDialog: BoardIssueMoveDialog, selectedCardTypeId: selectedCardTypeId, epicLinkFieldId: epicLinkFieldId, firstNonEmptyCardListId: firstNonEmptyCardListId, lastNonEmptyCardListId: lastNonEmptyCardListId, onEpicAssign: onEpicAssign, onCardDetailClick: onCardDetailClick, onEpicCreate: onEpicCreate, onIssueVersionsUpdated: onIssueVersionsUpdated, onVersionAltered: onVersionAltered, onReceive: onReceive, onReceiveEvent: onReceiveEvent })=>{
    const scrollElementRef = (0, $5uXOq.useRef)(null);
    const { onChangeCardType: onChangeCardType } = (0, $2Z6La.useIccContext)();
    // NOTE: Update the selected issue type in ICC when the issue type filter is changed. Doing it here to avoid unnecessary update
    (0, $5uXOq.useEffect)(()=>{
        if (selectedCardTypeId !== undefined) onChangeCardType(selectedCardTypeId);
    }, [
        onChangeCardType,
        selectedCardTypeId
    ]);
    const previousCardListIds = (0, $1XJ20.usePrevious)(cardListIds);
    const isNewCardListAdded = (id)=>{
        if (!previousCardListIds || previousCardListIds.length === 0) return false;
        return !previousCardListIds.includes(id);
    };
    (0, $eX9XD.useAutoScroller)();
    (0, $fDXV9.useDragAnalytics)(issueHierarchyLevel);
    (0, $a5Tut.useCloseMenuOnScroll)(scrollElementRef);
    (0, $5eblm.useInitEpicData)(boardId);
    const { toggleViewSetting: toggleViewSetting } = (0, $iDGXn.useViewSettingsActions)();
    const isContextMenuOpened = (0, $ewaBk.useIsAnyMenuOpen)();
    const handleVersionPanelClose = (0, $5uXOq.useCallback)(()=>{
        toggleViewSetting({
            boardId: boardId,
            setting: (0, $9pP0g.ViewSetting).VERSION_PANEL,
            view: (0, $a4XJc.View).BACKLOG
        });
    }, [
        boardId,
        toggleViewSetting
    ]);
    const handleEpicPanelClose = (0, $5uXOq.useCallback)(()=>{
        toggleViewSetting({
            boardId: boardId,
            setting: (0, $9pP0g.ViewSetting).EPIC_PANEL,
            view: (0, $a4XJc.View).BACKLOG
        });
    }, [
        boardId,
        toggleViewSetting
    ]);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "backlog-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cc2av.VersionsPanelWithErrorBoundary), {
        boardId: boardId,
        selectedIssues: selectedCards,
        onClose: handleVersionPanelClose,
        onVersionAltered: onVersionAltered,
        onVersionAssigned: onIssueVersionsUpdated,
        onVersionsUnassigned: onIssueVersionsUpdated,
        isCompanyManaged: isCompanyManaged
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e2Elo.EpicPanelWithErrorBoundary), {
        boardId: boardId,
        selectedIssues: selectedCards,
        issueHierarchyLevel: (0, $g4tDr.ISSUE_HIERARCHY_LEVEL_EPIC),
        epicLinkFieldId: epicLinkFieldId,
        onEpicPanelClose: handleEpicPanelClose,
        onCardDetailClick: onCardDetailClick,
        onEpicCreate: onEpicCreate,
        onEpicAssign: onEpicAssign,
        isCompanyManaged: isCompanyManaged
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8428b7783d52b361$var$Scrollable, {
        // eslint-disable-next-line jira/integration/enforce-data-testid-usage
        "data-test-id": "software-backlog.backlog-content.scrollable",
        "data-testid": "software-backlog.backlog-content.scrollable",
        ref: scrollElementRef,
        isContextMenuOpened: isContextMenuOpened
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BoardIssueMoveDialog, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "backlog-card-list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Ik53.ScrollStateContextProvider), {
        scrollRef: scrollElementRef,
        shouldSkipFirstResize: (0, $4R6GH.fg)('jira-concurrent-backlog-perf'),
        initialScrollState: (0, $4R6GH.fg)('jira-concurrent-backlog-perf') ? {
            height: globalThis.innerHeight,
            width: 0,
            scrollHeight: globalThis.innerHeight,
            scrollWidth: 0,
            scrollTop: 0,
            scrollLeft: 0,
            isScrolling: false,
            scrollElement: null
        } : undefined
    }, cardListIds.map((id, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CardList, {
            key: id,
            id: id,
            isFirstList: index === 0,
            isFirstNonEmptyList: firstNonEmptyCardListId === id,
            isLastNonEmptyList: lastNonEmptyCardListId === id,
            justCreated: isNewCardListAdded(id)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jg0aS.MoreResults), {
        scrollableParentRef: scrollElementRef
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6e1e1.default), null), (0, $4R6GH.fg)('jsw_refactor_long-tasks_monitoring') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g3RsK.LongTasksScrollObserver), {
        appName: (0, $a9c483c0d986286a$export$840e3848643f7781),
        scrollElRef: scrollElementRef,
        attributes: (0, $k12ix.getNormalisedPerformanceFFs)()
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g3RsK.LongTasksScrollObserver), {
        appName: (0, $a9c483c0d986286a$export$840e3848643f7781),
        scrollEl: scrollElementRef.current
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lmlf0.DetailViewPanelWithErrorBoundary), {
        boardId: boardId,
        parentWidth: parentWidth,
        isDetailViewVisible: isDetailViewVisible
    }), cardListIds.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8428b7783d52b361$var$RenderEndMark, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SubmitApdex, {
        isCacheHit: isCacheHit
    })), (0, $4R6GH.fg)('jira_replace_provider_and_client_with_realtime') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gz8lb.default), {
        onReceive: onReceiveEvent
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gz8lb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b32lf.RealtimeClient), {
        events: (0, $3eS6S.REALTIME_EVENTS),
        onReceive: onReceive
    })));
    return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        "data-onboarding-observer-id": "backlog-wrapper",
        xcss: $8428b7783d52b361$var$wrapperStyles
    }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8428b7783d52b361$var$PageWrapper, {
        "data-onboarding-observer-id": "backlog-wrapper"
    }, content);
};
const $8428b7783d52b361$var$BacklogContent = /*#__PURE__*/ (0, $5uXOq.memo)($8428b7783d52b361$var$BacklogContentInner);
var $8428b7783d52b361$export$2e2bcd8739ae039 = $8428b7783d52b361$var$BacklogContent;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8428b7783d52b361$var$PageWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _i0dlf1ug _19bv1jfw _1e0c1txw _2lx2vrvc _4t3i1osq _c71l1osq",
            __cmplp.className
        ])
    });
});
const $8428b7783d52b361$var$wrapperStyles = (0, $8CUq3.xcss)({
    paddingLeft: 'space.300',
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
    maxHeight: '100%',
    overflow: 'hidden',
    flex: 1
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8428b7783d52b361$var$Scrollable = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isContextMenuOpened: isContextMenuOpened, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_q3kg9j": (0, $lD23V.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            `0 ${(0, $dCm1o.isVisualRefreshEnabled)() ? "var(--ds-space-300, 24px)" : "var(--ds-space-400, 32px)"} ${"var(--ds-space-600, 48px)"} 0`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt41a7k _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx21bp4 _c71l1osq _1reo1wug _uiztglyw _kqswh2mm _m6k4brmi",
            (0, $3HwlS.getWillShowNav4)() ? "_18m91wug" : "_18m915zi",
            __cmplp.isContextMenuOpened ? "_1pbyowjs" : "_1pbyb4wl",
            __cmplp.className
        ])
    });
});

});
parcelRegister("b32lf", function(module, exports) {

$parcel$export(module.exports, "RealtimeClient", () => $89de761bbc8dc49a$export$e680ceb7b9fcc184);

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $2OMDV = parcelRequire("2OMDV");

var $2YZCu = parcelRequire("2YZCu");

var $4R6GH = parcelRequire("4R6GH");

var $43Yto = parcelRequire("43Yto");


var $50Ssb = parcelRequire("50Ssb");

var $iwG6l = parcelRequire("iwG6l");
const $89de761bbc8dc49a$var$LOG_LOCATION = 'jira-realtime-client-fps';
// eslint-disable-next-line jira/react/no-class-components
class $89de761bbc8dc49a$var$RealtimeClientView extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            children: null
        };
    }
    componentDidMount() {
        this.subscribeToPropEvents();
    }
    componentDidUpdate(prevProps) {
        if (this.props.client !== prevProps.client || this.props.events !== prevProps.events) {
            const removedEvents = prevProps.events.filter((prevEvent)=>!this.props.events.includes(prevEvent));
            removedEvents.forEach(this.unSubscribeToEvent);
            this.subscribeToPropEvents();
        }
    }
    componentWillUnmount() {
        this.unsubscribeToPropEvents();
    }
    render() {
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.onReceiveEvent = (event, payload)=>{
            if ((0, $4R6GH.fg)('jirt-convert-class-to-functional-component')) (0, $2YZCu.default).safeInfoWithoutCustomerData($89de761bbc8dc49a$var$LOG_LOCATION, 'Event received', {
                source: (0, $cd8288ab589b4c19$export$4854d3ddf830ca94),
                appId: this.props?.appId,
                eventType: String(event)
            });
            // @ts-expect-error - TS2554 - Expected 3 arguments, but got 2.
            this.props.onReceive(event, payload);
        }, this.subscribeToEvent = (eventName)=>{
            this.props.client?.on(eventName, this.onReceiveEvent);
        }, this.unSubscribeToEvent = (eventName)=>{
            this.props.client?.off(eventName, this.onReceiveEvent);
        }, this.subscribeToPropEvents = ()=>{
            if (this.props.client) this.props.events.forEach(this.subscribeToEvent);
        }, this.unsubscribeToPropEvents = ()=>{
            if (this.props.client) this.props.events.forEach(this.unSubscribeToEvent);
        };
    }
}
const $89de761bbc8dc49a$var$withAnalytics = (0, $2OMDV.AnalyticsEventToProps)((0, $43Yto.analyticsComponent), {
    onReceive: (0, $43Yto.analyticEvents).EVENT_RECEIVED
});
const $89de761bbc8dc49a$export$e680ceb7b9fcc184 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))($89de761bbc8dc49a$var$withAnalytics, (0, $iwG6l.withPubSubClient), (0, $50Ssb.asClientOnly))($89de761bbc8dc49a$var$RealtimeClientView);
var $89de761bbc8dc49a$export$2e2bcd8739ae039 = $89de761bbc8dc49a$export$e680ceb7b9fcc184;

});
parcelRegister("43Yto", function(module, exports) {

$parcel$export(module.exports, "analyticsComponent", () => $e9d4cd49d7351075$export$b6860299007c6993);
$parcel$export(module.exports, "analyticEvents", () => $e9d4cd49d7351075$export$959fab53eba8917d);
const $e9d4cd49d7351075$export$b6860299007c6993 = 'jiraRealtime';
const $e9d4cd49d7351075$export$959fab53eba8917d = {
    SUBSCRIPTION_STARTED: 'subscriptionStarted',
    EVENT_RECEIVED: 'eventReceived',
    FAILURE: 'errorReceived',
    JOINED_CHANNEL: 'joinedChannel',
    LEFT_CHANNEL: 'leftChannel'
};

});

const $cd8288ab589b4c19$export$4854d3ddf830ca94 = 'fps';
const $cd8288ab589b4c19$export$f7ec9b25c28de3df = 'subscriptions';

parcelRegister("50Ssb", function(module, exports) {

$parcel$export(module.exports, "asClientOnly", () => $ccf1df230f4f0e4b$export$95cd02374de3431);

var $5uXOq = parcelRequire("5uXOq");
function $ccf1df230f4f0e4b$export$95cd02374de3431(WrappedComponent) {
    return (props)=>{
        if (false) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, props);
    };
}
var $ccf1df230f4f0e4b$export$2e2bcd8739ae039 = $ccf1df230f4f0e4b$export$95cd02374de3431;

});

parcelRegister("iwG6l", function(module, exports) {

$parcel$export(module.exports, "withPubSubClient", () => $9fb4f4e8a5d3670b$export$32d968d4900ae3cd);

var $5uXOq = parcelRequire("5uXOq");

var $bYYrF = parcelRequire("bYYrF");
function $9fb4f4e8a5d3670b$export$32d968d4900ae3cd(WrappedComponent) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bYYrF.Consumer), null, ({ client: client })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...props,
                client: client
            }));
}
var $9fb4f4e8a5d3670b$export$2e2bcd8739ae039 = $9fb4f4e8a5d3670b$export$32d968d4900ae3cd;

});
parcelRegister("bYYrF", function(module, exports) {

$parcel$export(module.exports, "Provider", () => $9398e66c20b16e31$export$2881499e37b75b9a);
$parcel$export(module.exports, "Consumer", () => $9398e66c20b16e31$export$b3bffd4bb7da6b8f);

var $5uXOq = parcelRequire("5uXOq");
const $9398e66c20b16e31$var$defaultContext = {
    client: null
};
const { Provider: $9398e66c20b16e31$export$2881499e37b75b9a, Consumer: $9398e66c20b16e31$export$b3bffd4bb7da6b8f } = /*#__PURE__*/ (0, $5uXOq.createContext)($9398e66c20b16e31$var$defaultContext);

});



parcelRegister("a5Tut", function(module, exports) {

$parcel$export(module.exports, "useCloseMenuOnScroll", () => $c7ad992979caef8c$export$2cf190faca0f2491);

var $5uXOq = parcelRequire("5uXOq");

var $ewaBk = parcelRequire("ewaBk");
const $c7ad992979caef8c$export$2cf190faca0f2491 = (ref)=>{
    const { reset: reset } = (0, $ewaBk.useContextMenuActions)();
    const isAnyMenuOpen = (0, $ewaBk.useIsAnyMenuOpen)();
    const added = (0, $5uXOq.useRef)(false);
    const handleScroll = (0, $5uXOq.useCallback)(()=>{
        reset({
            action: 'closeMenu'
        });
    }, [
        reset
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (ref.current) {
            if (isAnyMenuOpen) {
                if (!added.current) {
                    ref.current.addEventListener('scroll', handleScroll);
                    added.current = true;
                }
                return;
            }
            if (added.current) {
                ref.current.removeEventListener('scroll', handleScroll);
                added.current = false;
            }
        }
    }, [
        handleScroll,
        ref,
        isAnyMenuOpen
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            if (ref.current && added.current) {
                ref.current.removeEventListener('scroll', handleScroll);
                added.current = false;
            }
        }, [
        ref,
        handleScroll
    ]);
};

});

parcelRegister("g3RsK", function(module, exports) {

$parcel$export(module.exports, "LongTasksScrollObserver", () => $fe64e9d70a250807$export$55bf40af27443842);

var $5uXOq = parcelRequire("5uXOq");

var $7wqBZ = parcelRequire("7wqBZ");

var $4R6GH = parcelRequire("4R6GH");

var $bv8GQ = parcelRequire("bv8GQ");

var $gi25H = parcelRequire("gi25H");
/**
 * Tracks long-tasks that happen while scrolling on a certain 'scrollEl'.
 */ const $fe64e9d70a250807$var$LongTasksScrollObserverBase = ({ observationType: observationType, attributes: attributes, appName: appName, logAttributes: logAttributes = {}, ...rest })=>{
    const onScrollStart = (0, $5uXOq.useCallback)(()=>{
        (0, $7wqBZ.getLongTasksMetrics)(observationType).start(appName, undefined, attributes);
        if ((0, $4R6GH.fg)('jsw_refactor_long-tasks_monitoring')) performance.mark(`${appName}:scrolling-task:start`);
    }, [
        attributes,
        appName,
        observationType
    ]);
    const onScrollEnd = (0, $5uXOq.useCallback)((lastScrollTime)=>{
        (0, $7wqBZ.getLongTasksMetrics)(observationType).stop((0, $bv8GQ.softwareGenericLongTasksReporter)('scroll', lastScrollTime, logAttributes));
        if ((0, $4R6GH.fg)('jsw_refactor_long-tasks_monitoring')) {
            performance.mark(`${appName}:scrolling-task:end`);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            performance.measure(`${appName}:scrolling-task`, `${appName}:scrolling-task:start`, `${appName}:scrolling-task:end`);
        }
    }, [
        observationType,
        appName,
        logAttributes
    ]);
    (0, $gi25H.useScrollStateObserver)({
        ...rest,
        onScrollStart: onScrollStart,
        onScrollEnd: onScrollEnd
    });
    return null;
};
$fe64e9d70a250807$var$LongTasksScrollObserverBase.defaultProps = {
    observationType: 'scroll',
    attributes: {}
};
const $fe64e9d70a250807$export$55bf40af27443842 = /*#__PURE__*/ (0, $5uXOq.memo)($fe64e9d70a250807$var$LongTasksScrollObserverBase);

});
parcelRegister("bv8GQ", function(module, exports) {

$parcel$export(module.exports, "softwareGenericLongTasksReporter", () => $2795c9afa9443b8c$export$b78c92c0ba709033);

var $gZFbt = parcelRequire("gZFbt");

var $if7bx = parcelRequire("if7bx");

var $cJpFl = parcelRequire("cJpFl");

var $4R6GH = parcelRequire("4R6GH");


var $fjcgS = parcelRequire("fjcgS");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2795c9afa9443b8c$var$aggregatedDataTimeout = {};
const $2795c9afa9443b8c$export$b78c92c0ba709033 = (observationType, observationEndTime, logAttributes = {})=>(observationData)=>{
        if ((0, $4R6GH.fg)('jsw_refactor_long-tasks_monitoring')) {
            if (!(0, $cJpFl.isExpandedObservationData)(observationData) || !('appName' in observationData)) return;
            const { appName: appName, startTimestamp: startTimestamp, events: events } = observationData;
            const startTime = startTimestamp;
            const endTime = observationEndTime ?? performance.now();
            const duration = endTime - startTime;
            if (duration < 100) return;
            const rawLongTasks = events ?? [];
            const longTasks = rawLongTasks.filter((event)=>event.timestamp >= startTime && event.timestamp + event.duration <= endTime).map((event)=>({
                    timestamp: event.timestamp - startTime,
                    duration: event.duration
                }));
            const minimumBlockedDuration = longTasks.reduce((sum, longTask)=>sum + longTask.duration, 0);
            const frameRateTarget = 60;
            const budgetPerFrame = 1000 / frameRateTarget;
            const timeOverBudget = longTasks.map((event)=>event.duration - budgetPerFrame).reduce((sum, time)=>sum + time, 0);
            const summary = {
                qualityIndex: 1 - timeOverBudget / duration,
                hasLongTasks: longTasks.length > 0,
                hasExtraLongTasks: longTasks.filter((l)=>l.duration >= 100).length > 0,
                longTasks: longTasks,
                rawLongTaskCount: rawLongTasks.length,
                longTaskCount: longTasks.length,
                minimumBlockedDuration: minimumBlockedDuration,
                timeOverBudget: timeOverBudget,
                duration: duration,
                startTime: startTime,
                endTime: endTime
            };
            (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
                client.sendEvent({
                    type: (0, $4d5e0871c06cee03$export$12346a674644c156),
                    payload: {
                        source: appName,
                        action: 'longTask',
                        actionSubject: 'ui',
                        actionSubjectId: `${appName}-${observationType}`,
                        attributes: {
                            key: appName,
                            ...summary,
                            ...logAttributes
                        }
                    }
                });
            });
        } else {
            if (!(0, $cJpFl.isExpandedObservationData)(observationData)) return;
            const startTime = observationData.events.map((event)=>event.timestamp);
            const analyticsData = {
                ...(0, $if7bx.generateLongTaskAnalyticsContinuousActionSummary)(observationType, observationData.events),
                measureTimespan: performance.now() - Math.min(observationData.startTimestamp, ...startTime)
            };
            const { appName: appName } = observationData;
            if ($2795c9afa9443b8c$var$aggregatedDataTimeout[`software.${appName}.${observationType}`]) $2795c9afa9443b8c$var$aggregatedDataTimeout[`software.${appName}.${observationType}`].data.push(analyticsData);
            else $2795c9afa9443b8c$var$aggregatedDataTimeout[`software.${appName}.${observationType}`] = {
                data: [
                    analyticsData
                ],
                extra: observationData.extra,
                timeout: setTimeout(()=>{
                    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
                        const { data: data, extra: extraData } = $2795c9afa9443b8c$var$aggregatedDataTimeout[`software.${appName}.${observationType}`];
                        client.sendEvent({
                            type: (0, $4d5e0871c06cee03$export$12346a674644c156),
                            payload: {
                                source: appName,
                                action: 'longTask',
                                actionSubject: 'ui',
                                actionSubjectId: `${appName}-${observationType}`,
                                attributes: {
                                    key: appName,
                                    ...(0, $if7bx.getAverageResultsFromContinuousActions)(observationType, data),
                                    ...extraData,
                                    avgScrollTimespan: (0, (/*@__PURE__*/$parcel$interopDefault($gZFbt)))(data, 'measureTimespan'),
                                    ...logAttributes
                                }
                            }
                        });
                        delete $2795c9afa9443b8c$var$aggregatedDataTimeout[`software.${appName}.${observationType}`];
                    });
                }, 7000)
            };
        }
    };

});

parcelRegister("gi25H", function(module, exports) {

$parcel$export(module.exports, "useScrollStateObserver", () => $5c14c3e1741ffda3$export$51374614020e4579);

var $5uXOq = parcelRequire("5uXOq");
const $5c14c3e1741ffda3$var$DEFAULT_SCROLL_STOP_INTERVAL_MS = 500;
const $5c14c3e1741ffda3$export$53d63bb2b7d56f77 = ({ onScrollStart: onScrollStart, onScrollEnd: onScrollEnd, scrollStopIntervalMs: scrollStopIntervalMs })=>{
    const isScrollingRef = (0, $5uXOq.useRef)(false);
    const scrollStopTimerRef = (0, $5uXOq.useRef)(null);
    const onScroll = (0, $5uXOq.useCallback)(()=>{
        if (!isScrollingRef.current) {
            isScrollingRef.current = true;
            onScrollStart();
        }
        const lastScrollTime = performance.now();
        // @ts-expect-error - TS2769 - No overload matches this call.
        clearTimeout(scrollStopTimerRef.current);
        scrollStopTimerRef.current = setTimeout(()=>{
            isScrollingRef.current = false;
            onScrollEnd(lastScrollTime);
        }, scrollStopIntervalMs);
        return ()=>{
            if (isScrollingRef.current) onScrollEnd(lastScrollTime);
            // @ts-expect-error - TS2769 - No overload matches this call.
            clearTimeout(scrollStopTimerRef.current);
        };
    }, [
        isScrollingRef,
        scrollStopTimerRef,
        scrollStopIntervalMs,
        onScrollStart,
        onScrollEnd
    ]);
    return {
        onScroll: onScroll,
        isScrollingRef: isScrollingRef
    };
};
const $5c14c3e1741ffda3$export$51374614020e4579 = ({ scrollStopIntervalMs: scrollStopIntervalMs, scrollElRef: scrollElRef, scrollEl: scrollEl, onScrollStart: onScrollStart, onScrollEnd: onScrollEnd })=>{
    const { onScroll: onScroll, isScrollingRef: isScrollingRef } = $5c14c3e1741ffda3$export$53d63bb2b7d56f77({
        onScrollStart: onScrollStart,
        onScrollEnd: onScrollEnd,
        scrollStopIntervalMs: scrollStopIntervalMs ?? $5c14c3e1741ffda3$var$DEFAULT_SCROLL_STOP_INTERVAL_MS
    });
    (0, $5uXOq.useEffect)(()=>{
        const el = scrollEl ?? scrollElRef?.current;
        if (!el) return undefined;
        el.addEventListener('scroll', onScroll);
        return ()=>{
            el.removeEventListener('scroll', onScroll);
        };
    }, [
        scrollEl,
        scrollElRef,
        isScrollingRef,
        onScroll,
        onScrollEnd
    ]);
};

});


parcelRegister("3eS6S", function(module, exports) {

$parcel$export(module.exports, "REALTIME_EVENTS", () => $b9727070b384e890$export$a45e758f2a5806e6);

var $cnhn5 = parcelRequire("cnhn5");
const $b9727070b384e890$export$a45e758f2a5806e6 = [
    (0, $cnhn5.ISSUE_ASSIGNED_EVENT),
    (0, $cnhn5.ISSUE_CREATED_EVENT),
    (0, $cnhn5.ISSUE_DELETED_EVENT),
    (0, $cnhn5.ISSUE_TRANSITIONED_EVENT),
    (0, $cnhn5.ISSUE_UPDATED_EVENT),
    (0, $cnhn5.ISSUE_PARENT_ASSOCIATION_EVENT)
];

});

parcelRegister("6MzeB", function(module, exports) {

$parcel$export(module.exports, "usePerformanceMetric", () => $f3f14da65b3c231d$export$8c654db610e68aa9);

var $8hVbJ = parcelRequire("8hVbJ");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");
const $f3f14da65b3c231d$export$8c654db610e68aa9 = ()=>(0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged)) ? (0, $8hVbJ.uifBacklogNewUiPageLoad) : (0, $8hVbJ.nextGenBacklogPageLoad);

});

parcelRegister("gz8lb", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffb506c130e0fe88$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $jiRmc = parcelRequire("jiRmc");

var $dd8Xx = parcelRequire("dd8Xx");

var $4R6GH = parcelRequire("4R6GH");

var $guzeq = parcelRequire("guzeq");

var $c1MAf = parcelRequire("c1MAf");

var $3eS6S = parcelRequire("3eS6S");

var $azrUb = parcelRequire("azrUb");
const $ffb506c130e0fe88$var$RealtimeWrapper = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>{
    const realtimeChannels = (0, $c1MAf.useBacklogSelector)((0, $azrUb.realtimeChannelsSelector));
    if (!(0, $4R6GH.fg)('jira_replace_provider_and_client_with_realtime')) {
        if (realtimeChannels?.length === 0) return props.children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jiRmc.RealtimeProvider), {
            appId: (0, $guzeq.APP_ID),
            onJoin: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onReceive: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onLeave: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            channels: realtimeChannels
        }, props.children);
    }
    if (realtimeChannels?.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dd8Xx.default), {
        appId: (0, $guzeq.APP_ID),
        channels: realtimeChannels,
        events: (0, $3eS6S.REALTIME_EVENTS),
        onJoin: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onLeave: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onReceive: props.onReceive ?? (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    });
});
var $ffb506c130e0fe88$export$2e2bcd8739ae039 = $ffb506c130e0fe88$var$RealtimeWrapper;

});
parcelRegister("jiRmc", function(module, exports) {

$parcel$export(module.exports, "RealtimeProvider", () => $db014a952af56f77$export$64d242981d970821);

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $8Rkzz = parcelRequire("8Rkzz");

var $2YZCu = parcelRequire("2YZCu");

var $2OMDV = parcelRequire("2OMDV");

var $fjcgS = parcelRequire("fjcgS");

var $4R6GH = parcelRequire("4R6GH");


var $bYYrF = parcelRequire("bYYrF");

var $43Yto = parcelRequire("43Yto");


var $1eGpy = parcelRequire("1eGpy");

var $FPIEb = parcelRequire("FPIEb");
const $db014a952af56f77$var$LOG_LOCATION = 'jira-realtime-provider-fps';

const $db014a952af56f77$var$createPubSubClient = (host, analyticsClient)=>(parcelRequire("PCZCF")).then((module)=>{
        const Client = module.default;
        return new Client({
            product: (0, $dd367d66c147872b$export$13ac40d1a5475532),
            url: `${host}`,
            apsProtocol: {
                enabled: true
            },
            analyticsClient: analyticsClient
        });
    });
const $db014a952af56f77$export$c127c26e30518ed5 = (appId, client, channels, onHandler, onError)=>client.join(channels).then(onHandler) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .catch((error)=>{
        // Ideally anonymous users shouldn't get there.
        // Ignoring 401 status codes until it is fixed on the app level.
        if (error && error.code === 401) return;
        (0, $2YZCu.default).safeErrorWithoutCustomerData($db014a952af56f77$var$LOG_LOCATION, `[${appId}]: Failed to join channel`, error);
        if ((0, $4R6GH.fg)('jirt-convert-class-to-functional-component')) onError?.(error);
    });
const $db014a952af56f77$export$e6c41c8aa28ddeb9 = (appId, client, channels, onHandler, onError)=>client.leave(channels).then(onHandler) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .catch((error)=>{
        // Ideally anonymous users shouldn't get there.
        // Ignoring 401 status codes until it is fixed on the app level.
        if (error && error.code === 401) return;
        (0, $2YZCu.default).safeErrorWithoutCustomerData($db014a952af56f77$var$LOG_LOCATION, `[${appId}]: Failed to left channel`, error);
        if ((0, $4R6GH.fg)('jirt-convert-class-to-functional-component')) onError?.(error);
    });
// eslint-disable-next-line jira/react/no-class-components
class $db014a952af56f77$var$RealtimeProviderView extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            host: (0, $dd367d66c147872b$export$92ffb25149c24a33),
            onJoin: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onLeave: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    componentDidMount() {
        const { appId: appId, host: host, channels: channels, onError: onError } = this.props;
        this.isComponentMounted = true;
        (0, $fjcgS.getAnalyticsWebClientPromise)().then((analyticsClient)=>$db014a952af56f77$var$createPubSubClient(host, analyticsClient.getInstance())).then((pubSubClient)=>$db014a952af56f77$export$c127c26e30518ed5(appId, pubSubClient, channels, this.onJoinChannel, onError).then(()=>{
                if (this.isComponentMounted) this.setState({
                    client: pubSubClient
                });
            }));
    }
    componentDidUpdate({ channels: prevChannels }) {
        const { appId: appId, channels: newChannels, onError: onError } = this.props;
        const { client: client } = this.state;
        if (client && newChannels !== prevChannels) {
            const removedChannels = prevChannels.filter((channel)=>!newChannels.includes(channel));
            if ((0, $4R6GH.fg)('jirt-convert-class-to-functional-component')) {
                if (removedChannels.length > 0) {
                    $db014a952af56f77$export$e6c41c8aa28ddeb9(appId, client, removedChannels, this.onLeaveChannel, onError);
                    $db014a952af56f77$export$c127c26e30518ed5(appId, client, newChannels, this.onJoinChannel, onError);
                }
            } else {
                $db014a952af56f77$export$e6c41c8aa28ddeb9(appId, client, removedChannels, this.onLeaveChannel, onError);
                $db014a952af56f77$export$c127c26e30518ed5(appId, client, newChannels, this.onJoinChannel, onError);
            }
        }
    }
    componentWillUnmount() {
        const { appId: appId, channels: channels, onError: onError } = this.props;
        const { client: client } = this.state;
        this.isComponentMounted = false;
        if (client) $db014a952af56f77$export$e6c41c8aa28ddeb9(appId, client, channels, this.onLeaveChannel, onError);
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bYYrF.Provider), {
            value: {
                client: this.state.client
            }
        }, this.props.children);
    }
    constructor(...args){
        super(...args), this.state = {
            client: null
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onJoinChannel = (result)=>{
            const { onJoin: onJoin } = this.props;
            const joinChannels = result?.channels?.length > 0 ? result?.channels : this.props.channels;
            if ((0, $4R6GH.fg)('jirt-convert-class-to-functional-component')) (0, $2YZCu.default).safeInfoWithoutCustomerData($db014a952af56f77$var$LOG_LOCATION, 'Joined channel', {
                source: (0, $cd8288ab589b4c19$export$4854d3ddf830ca94),
                appId: this.props?.appId,
                channels: joinChannels?.join(', ') ?? ''
            });
            // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onJoin(Array.from(joinChannels ?? []));
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onLeaveChannel = (result)=>{
            const { onLeave: onLeave } = this.props;
            const leaveChannels = result?.channels?.length > 0 ? result?.channels : this.props.channels;
            if ((0, $4R6GH.fg)('jirt-convert-class-to-functional-component')) (0, $2YZCu.default).safeInfoWithoutCustomerData($db014a952af56f77$var$LOG_LOCATION, 'Left channel', {
                source: (0, $cd8288ab589b4c19$export$4854d3ddf830ca94),
                appId: this.props?.appId,
                channels: leaveChannels?.join(', ') ?? ''
            });
            // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onLeave(Array.from(leaveChannels ?? []));
        }, this.isComponentMounted = false;
    }
}
const $db014a952af56f77$var$withAnalytics = (0, $2OMDV.AnalyticsEventToProps)((0, $43Yto.analyticsComponent), {
    onJoin: (0, $43Yto.analyticEvents).JOINED_CHANNEL,
    onLeave: (0, $43Yto.analyticEvents).LEFT_CHANNEL
});
const $db014a952af56f77$export$64d242981d970821 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))($db014a952af56f77$var$withAnalytics, (0, $1eGpy.withHost), (0, $FPIEb.withRuntimeProvider))($db014a952af56f77$var$RealtimeProviderView);
var $db014a952af56f77$export$2e2bcd8739ae039 = $db014a952af56f77$export$64d242981d970821;

});
const $dd367d66c147872b$export$92ffb25149c24a33 = '/gateway/api/pubsub';
const $dd367d66c147872b$export$13ac40d1a5475532 = 'JIRA';

parcelRegister("1eGpy", function(module, exports) {

$parcel$export(module.exports, "withHost", () => $af5e53f160713d44$export$b2d89aaea1461cd9);

var $5uXOq = parcelRequire("5uXOq");

var $4h0Jz = parcelRequire("4h0Jz");
function $af5e53f160713d44$export$b2d89aaea1461cd9(WrappedComponent) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...props,
            host: (0, $4h0Jz.getDefaultPubSubHost)()
        });
}
var $af5e53f160713d44$export$2e2bcd8739ae039 = $af5e53f160713d44$export$b2d89aaea1461cd9;

});
parcelRegister("4h0Jz", function(module, exports) {

$parcel$export(module.exports, "getDefaultPubSubHost", () => $15272668181566a5$export$f795b2d9ba365882);
$parcel$export(module.exports, "buildChannelString", () => $15272668181566a5$export$354e43de513ff5);

var $j8DrX = parcelRequire("j8DrX");

const $15272668181566a5$export$f795b2d9ba365882 = ()=>(0, $j8DrX.default)('ajs-fabric-realtime-url') || (0, $dd367d66c147872b$export$92ffb25149c24a33);
const $15272668181566a5$export$354e43de513ff5 = (cloudId, projectId)=>`ari:cloud:jira:${cloudId}:project/${projectId}`;

});


parcelRegister("FPIEb", function(module, exports) {

$parcel$export(module.exports, "withRuntimeProvider", () => $5962bf1fe62742cb$export$4b38d0b01368c3f4);

var $5uXOq = parcelRequire("5uXOq");
function $5962bf1fe62742cb$export$4b38d0b01368c3f4(WrappedComponent) {
    return (props)=>{
        if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, props);
    };
}
var $5962bf1fe62742cb$export$2e2bcd8739ae039 = $5962bf1fe62742cb$export$4b38d0b01368c3f4;

});

parcelRegister("PCZCF", function(module, exports) {

let $09b302b7286410da$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $09b302b7286410da$var$load("76n7a"),
    $09b302b7286410da$var$load("l253H"),
    $09b302b7286410da$var$load("kpnGY")
]).then(()=>parcelRequire('9uh43'));

});


parcelRegister("dd8Xx", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a980bab3107478f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $4R6GH = parcelRequire("4R6GH");

var $2YZCu = parcelRequire("2YZCu");

var $kV9ss = parcelRequire("kV9ss");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $cSD7y = parcelRequire("cSD7y");

var $90yGq = parcelRequire("90yGq");

var $b32lf = parcelRequire("b32lf");

var $jiRmc = parcelRequire("jiRmc");

var $jFysZ = parcelRequire("jFysZ");


var $43Yto = parcelRequire("43Yto");
const $9a980bab3107478f$var$LOG_LOCATION = 'jira-realtime';
// eslint-disable-next-line jira/react/no-class-components
class $9a980bab3107478f$var$RealtimeOld extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            onJoin: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onReceive: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onLeave: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    render() {
        const { appId: appId, events: events, onJoin: onJoin, onLeave: onLeave, channels: channels, onReceive: onReceive } = this.props;
        if ((0, $4R6GH.fg)('jirt-log-unsupported-channels')) this.logUnsupportedChannels(channels, appId);
        if ((0, $4R6GH.fg)('jirt-use-graphql-subscriptions')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jFysZ.RealtimeSubscriptions), {
            appId: appId,
            onJoin: onJoin,
            onLeave: onLeave,
            channels: channels,
            events: events,
            onReceive: onReceive
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jiRmc.RealtimeProvider), {
            appId: appId,
            onJoin: onJoin,
            onLeave: onLeave,
            channels: channels
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b32lf.RealtimeClient), {
            appId: appId,
            events: events,
            onReceive: this.onEventReceive
        }));
    }
    constructor(...args){
        super(...args), this.onEventReceive = (eventType, payload)=>{
            const event = {
                type: eventType,
                payload: payload
            };
            this.props.onReceive(event);
        }, this.logUnsupportedChannels = (channels, appId)=>{
            const unsupportedChannels = channels.filter((channel)=>!(0, $kV9ss.JiraProjectAri).check(channel));
            if (unsupportedChannels.length > 0) (0, $2YZCu.default).safeWarnWithoutCustomerData($9a980bab3107478f$var$LOG_LOCATION, 'Unsupported channels', {
                source: (0, $4R6GH.fg)('jirt-use-graphql-subscriptions') ? (0, $cd8288ab589b4c19$export$f7ec9b25c28de3df) : (0, $cd8288ab589b4c19$export$4854d3ddf830ca94),
                appId: appId,
                unsupportedChannels: unsupportedChannels?.join(', ')
            });
        };
    }
}
function $9a980bab3107478f$var$RealtimeNew({ appId: appId, channels: channels, events: events, onJoin: onJoin = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onReceive: onReceive = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onLeave: onLeave = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) }) {
    const atlassianAccountId = (0, $90yGq.useAccountId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const logUnsupportedChannels = (0, $5uXOq.useCallback)(()=>{
        const unsupportedChannels = channels.filter((channel)=>!(0, $kV9ss.JiraProjectAri).check(channel));
        if (unsupportedChannels.length > 0) (0, $2YZCu.default).safeWarnWithoutCustomerData($9a980bab3107478f$var$LOG_LOCATION, 'Unsupported channels', {
            source: (0, $4R6GH.fg)('jirt-use-graphql-subscriptions') ? (0, $cd8288ab589b4c19$export$f7ec9b25c28de3df) : (0, $cd8288ab589b4c19$export$4854d3ddf830ca94),
            appId: appId,
            unsupportedChannels: unsupportedChannels?.join(', ')
        });
    }, [
        appId,
        channels
    ]);
    const onJoinChannel = (0, $5uXOq.useCallback)((joinChannels)=>{
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), `${(0, $43Yto.analyticsComponent)} ${(0, $43Yto.analyticEvents).SUBSCRIPTION_STARTED}`, {
            source: (0, $cd8288ab589b4c19$export$4854d3ddf830ca94),
            appId: appId,
            channels: joinChannels
        });
        onJoin(joinChannels);
    }, [
        appId,
        createAnalyticsEvent,
        onJoin
    ]);
    const onEventReceive = (0, $5uXOq.useCallback)((eventType, payload, analyticsEvent)=>{
        const event = {
            type: eventType,
            payload: payload
        };
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, `${(0, $43Yto.analyticsComponent)} ${(0, $43Yto.analyticEvents).EVENT_RECEIVED}`, {
            source: (0, $cd8288ab589b4c19$export$4854d3ddf830ca94),
            eventType: eventType,
            appId: appId,
            isTriggeredBySameUser: payload?.atlassianId === atlassianAccountId
        });
        onReceive(event);
    }, [
        appId,
        atlassianAccountId,
        onReceive
    ]);
    const onError = (0, $5uXOq.useCallback)((error)=>{
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), `${(0, $43Yto.analyticsComponent)} ${(0, $43Yto.analyticEvents).FAILURE}`, {
            source: (0, $cd8288ab589b4c19$export$4854d3ddf830ca94),
            appId: appId,
            channels: channels,
            events: events,
            error: error.message
        });
    }, [
        appId,
        channels,
        createAnalyticsEvent,
        events
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $4R6GH.fg)('jirt-log-unsupported-channels')) logUnsupportedChannels();
    }, [
        channels,
        appId,
        logUnsupportedChannels
    ]);
    if ((0, $4R6GH.fg)('jirt-use-graphql-subscriptions')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jFysZ.RealtimeSubscriptions), {
        appId: appId,
        onJoin: onJoin,
        onLeave: onLeave,
        channels: channels,
        events: events,
        onReceive: onReceive
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jiRmc.RealtimeProvider), {
        appId: appId,
        onJoin: onJoinChannel,
        onLeave: onLeave,
        channels: channels,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b32lf.RealtimeClient), {
        appId: appId,
        events: events,
        onReceive: onEventReceive
    }));
}
const $9a980bab3107478f$var$Realtime = (0, $cSD7y.componentWithFG)('jirt-convert-class-to-functional-component', $9a980bab3107478f$var$RealtimeNew, $9a980bab3107478f$var$RealtimeOld);
var $9a980bab3107478f$export$2e2bcd8739ae039 = $9a980bab3107478f$var$Realtime;

});
parcelRegister("jFysZ", function(module, exports) {

$parcel$export(module.exports, "RealtimeSubscriptions", () => $03883409ac785040$export$ecba46e7f0609959);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $kV9ss = parcelRequire("kV9ss");

var $hMvRp = parcelRequire("hMvRp");

var $90yGq = parcelRequire("90yGq");

var $4R6GH = parcelRequire("4R6GH");


var $cnhn5 = parcelRequire("cnhn5");

var $43Yto = parcelRequire("43Yto");

var $4w2WY = parcelRequire("4w2WY");

var $1H73m = parcelRequire("1H73m");
const $03883409ac785040$var$getProjectIdsToSubscribe = (channels)=>channels?.filter((projectAri)=>(0, $kV9ss.JiraProjectAri).check(projectAri))?.map((projectAri)=>(0, $kV9ss.JiraProjectAri).parse(projectAri))?.map((data)=>data.projectId)?.filter(Boolean) ?? [];
const $03883409ac785040$var$getIssueEventToSubscribe = (events)=>events?.filter(Boolean)?.filter((event)=>(0, $cnhn5.SUBSCRIPTION_SUPPORTED_EVENTS).has(event)) ?? [];
const $03883409ac785040$var$getBoardEventToSubscribe = (events)=>events?.filter(Boolean)?.filter((event)=>(0, $cnhn5.BOARD_SUPPORTED_EVENTS).has(event)) ?? [];
const $03883409ac785040$export$ecba46e7f0609959 = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>{
    const { appId: appId, channels: channels, events: events, onJoin: onJoin, onReceive: onReceive, onLeave: onLeave } = props;
    const atlassianAccountId = (0, $90yGq.useAccountId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isVisible = (0, $hMvRp.usePageVisibility)();
    const projectIds = (0, $5uXOq.useMemo)(()=>$03883409ac785040$var$getProjectIdsToSubscribe(channels), [
        channels
    ]);
    const issueEvents = (0, $5uXOq.useMemo)(()=>$03883409ac785040$var$getIssueEventToSubscribe(events), [
        events
    ]);
    const boardEvents = (0, $5uXOq.useMemo)(()=>$03883409ac785040$var$getBoardEventToSubscribe(events), [
        events
    ]);
    const handleOnJoin = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), `${(0, $43Yto.analyticsComponent)} ${(0, $43Yto.analyticEvents).SUBSCRIPTION_STARTED}`, {
            source: (0, $cd8288ab589b4c19$export$f7ec9b25c28de3df),
            appId: appId,
            channels: channels
        });
        onJoin(channels);
    }, [
        createAnalyticsEvent,
        appId,
        channels,
        onJoin
    ]);
    const handleOnReceive = (0, $5uXOq.useCallback)((event)=>{
        const { type: type, payload: { atlassianId: atlassianId } } = event;
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), `${(0, $43Yto.analyticsComponent)} ${(0, $43Yto.analyticEvents).EVENT_RECEIVED}`, {
            source: (0, $cd8288ab589b4c19$export$f7ec9b25c28de3df),
            eventType: type,
            appId: appId,
            channels: channels,
            isTriggeredBySameUser: atlassianId === atlassianAccountId
        });
        onReceive(event);
    }, [
        appId,
        atlassianAccountId,
        channels,
        createAnalyticsEvent,
        onReceive
    ]);
    const handleOnLeave = (0, $5uXOq.useCallback)(()=>{
        onLeave(channels);
    }, [
        channels,
        onLeave
    ]);
    const handleOnError = (0, $5uXOq.useCallback)((error)=>{
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), `${(0, $43Yto.analyticsComponent)} ${(0, $43Yto.analyticEvents).FAILURE}`, {
            source: (0, $cd8288ab589b4c19$export$f7ec9b25c28de3df),
            appId: appId,
            channels: channels,
            events: issueEvents,
            error: error.message
        });
    }, [
        channels,
        appId,
        issueEvents,
        createAnalyticsEvent
    ]);
    const shouldRenderIssueSubscription = projectIds?.length > 0 && issueEvents?.length > 0;
    const shouldRenderBoardIssueSubscription = projectIds?.length > 0 && boardEvents?.length > 0;
    // Do not render the component on server-side
    // rendering to avoid hydration issues
    if (false && (0, $4R6GH.fg)('jirt-convert-class-to-functional-component')) return null;
    // Do not render the component when the page or tab is not visible
    // this will force the subscription components to unsubscribe
    // and avoid unnecessary data transfer when the user is not visualizing
    // the page. The subscription will be re-established when the page
    // or tab is visible again.
    if (!isVisible && !(0, $4R6GH.fg)('jirt-disable-resubscription-for-page-visibility')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, shouldRenderIssueSubscription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4w2WY.IssueSubscription), {
        appId: appId,
        projectIds: projectIds,
        events: issueEvents,
        onJoin: handleOnJoin,
        onReceive: handleOnReceive,
        onLeave: handleOnLeave,
        onError: handleOnError
    }), shouldRenderBoardIssueSubscription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1H73m.BoardIssueSubscription), {
        appId: appId,
        projectIds: projectIds,
        events: boardEvents,
        onJoin: handleOnJoin,
        onReceive: handleOnReceive,
        onLeave: handleOnLeave,
        onError: handleOnError
    }));
});

});
parcelRegister("4w2WY", function(module, exports) {

$parcel$export(module.exports, "IssueSubscription", () => $77e279b1082e054b$export$97b721965fbe4764);

var $hBgv0 = parcelRequire("hBgv0");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jUlV7 = parcelRequire("jUlV7");

var $2YZCu = parcelRequire("2YZCu");

var $90yGq = parcelRequire("90yGq");

var $koeKL = parcelRequire("koeKL");

var $bkbBi = parcelRequire("bkbBi");

const $77e279b1082e054b$var$LOG_LOCATION = 'jira-realtime-issue-subscription';
const $77e279b1082e054b$export$97b721965fbe4764 = /*#__PURE__*/ (0, $5uXOq.memo)(({ appId: appId, projectIds: projectIds, events: events, onJoin: onJoin, onReceive: onReceive, onError: onError, onLeave: onLeave })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const atlassianAccountId = (0, $90yGq.useAccountId)();
    const defaultAttributes = {
        source: (0, $cd8288ab589b4c19$export$f7ec9b25c28de3df),
        cloudId: cloudId,
        appId: appId,
        atlassianAccountId: atlassianAccountId
    };
    (0, $8Uumt.useSubscription)((0, $5uXOq.useMemo)(()=>({
            subscription: (0, $hBgv0.default),
            variables: {
                cloudId: cloudId,
                atlassianAccountId: String(atlassianAccountId),
                events: events,
                projectIds: projectIds
            },
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onNext: (response)=>{
                const payload = response?.jira?.onJirtIssueSubscription;
                if (!payload) {
                    (0, $2YZCu.default).safeInfoWithoutCustomerData($77e279b1082e054b$var$LOG_LOCATION, 'Subscription started', defaultAttributes);
                    onJoin();
                    return;
                }
                if (!(0, $bkbBi.isSubscriptionEventType)(payload.type)) {
                    (0, $2YZCu.default).safeErrorWithoutCustomerData($77e279b1082e054b$var$LOG_LOCATION, 'Invalid event type', {
                        ...defaultAttributes,
                        eventType: payload.type
                    });
                    return;
                }
                const issueId = Number((0, $jUlV7.JiraIssueAri).parse(payload.resource).issueId);
                const realtimeEvent = {
                    type: payload.type,
                    payload: {
                        atlassianId: String(payload.actionerAccountId),
                        projectId: payload.project?.id,
                        issueId: issueId
                    }
                };
                (0, $2YZCu.default).safeInfoWithoutCustomerData($77e279b1082e054b$var$LOG_LOCATION, 'Event received', {
                    ...defaultAttributes,
                    eventType: payload.type,
                    projectId: payload.project?.id,
                    issueId: issueId,
                    resource: payload.resource,
                    triggeredBy: String(payload.actionerAccountId),
                    receivedBy: atlassianAccountId,
                    isTriggeredBySameUser: String(payload.actionerAccountId) === atlassianAccountId
                });
                onReceive(realtimeEvent);
            },
            onCompleted: ()=>{
                (0, $2YZCu.default).safeInfoWithoutCustomerData($77e279b1082e054b$var$LOG_LOCATION, 'Subscription completed', {
                    ...defaultAttributes,
                    receivedBy: atlassianAccountId
                });
                onLeave();
            },
            onError: (error)=>{
                (0, $2YZCu.default).safeErrorWithoutCustomerData($77e279b1082e054b$var$LOG_LOCATION, `[${appId}] Subscription failure`, error);
                onError(error);
            }
        }), // Given React hooks require dependencies to be stable, but this cannot be guaranteed by consumers.
    // To ensure the subscription is created only once and not recreated on every re-render,
    // an empty dependency array is used intentionally. This approach ensures stability and avoids unnecessary resubscriptions.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []));
    return null;
});

});
parcelRegister("hBgv0", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd668aee84be2330$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<328c09410a7466f00f74849cd5dfcec8>>
 * @relayHash 92106690bb7e678270694af845fb5480
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID be83f504300a405b42e65dceb83cbdf64f2aa7ee3b9778d98ae12ae09488c068
const $dd668aee84be2330$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "atlassianAccountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "events"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectIds"
    }, v4 = [
        {
            "concreteType": "JiraSubscription",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "atlassianAccountId",
                            "variableName": "atlassianAccountId"
                        },
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "events",
                            "variableName": "events"
                        },
                        {
                            "kind": "Variable",
                            "name": "projectIds",
                            "variableName": "projectIds"
                        }
                    ],
                    "concreteType": "JiraJirtEventPayload",
                    "kind": "LinkedField",
                    "name": "onJirtIssueSubscription",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "actionerAccountId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "resource"
                        },
                        {
                            "concreteType": "JiraIssueStreamHubEventPayloadProject",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "IssueSubscription",
            "selections": v4 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "IssueSubscription",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "id": "be83f504300a405b42e65dceb83cbdf64f2aa7ee3b9778d98ae12ae09488c068",
            "metadata": {},
            "name": "IssueSubscription",
            "operationKind": "subscription",
            "text": null
        }
    };
}();
$dd668aee84be2330$var$node.hash = "1288b7ac81835d68c9265e8c3bdfa3d5";
var $dd668aee84be2330$export$2e2bcd8739ae039 = $dd668aee84be2330$var$node;

});

parcelRegister("jUlV7", function(module, exports) {

$parcel$export(module.exports, "JiraIssueAri", () => $e7e440357f375b75$export$1da6808e89ee03e);

var $bQ5aj = parcelRequire("bQ5aj");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira/issue/manifest.ts
var $e7e440357f375b75$var$jiraIssueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $bQ5aj.JiraIssueAriResourceOwner),
    resourceType: (0, $bQ5aj.JiraIssueAriResourceType),
    resourceIdSlug: "{issueId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/
    }
};
// src/jira/issue/index.ts
var $e7e440357f375b75$export$1da6808e89ee03e = class _JiraIssueAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId;
    }
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $e7e440357f375b75$var$jiraIssueAriStaticOpts.qualifier,
            platformQualifier: $e7e440357f375b75$var$jiraIssueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $e7e440357f375b75$var$jiraIssueAriStaticOpts.resourceOwner,
            resourceType: $e7e440357f375b75$var$jiraIssueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $e7e440357f375b75$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $e7e440357f375b75$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId
        };
    }
};

});
parcelRegister("bQ5aj", function(module, exports) {

$parcel$export(module.exports, "JiraIssueAriResourceOwner", () => $89e88ec215209f61$export$665a39f1b4e29e0a);
$parcel$export(module.exports, "JiraIssueAriResourceType", () => $89e88ec215209f61$export$76beb4d0da177ad4);
// src/jira/issue/types.ts
var $89e88ec215209f61$export$665a39f1b4e29e0a = "jira", $89e88ec215209f61$export$76beb4d0da177ad4 = "issue";

});


parcelRegister("bkbBi", function(module, exports) {

$parcel$export(module.exports, "isSubscriptionEventType", () => $461958717eae170a$export$cec76ac77e3d331);
$parcel$export(module.exports, "isBoardIssueEventType", () => $461958717eae170a$export$4bc59bf28171f69e);

var $cnhn5 = parcelRequire("cnhn5");
function $461958717eae170a$export$cec76ac77e3d331(type) {
    return typeof type === 'string' && (0, $cnhn5.SUBSCRIPTION_SUPPORTED_EVENTS).has(type);
}
function $461958717eae170a$export$4bc59bf28171f69e(type) {
    return typeof type === 'string' && (0, $cnhn5.BOARD_SUPPORTED_EVENTS).has(type);
}

});


parcelRegister("1H73m", function(module, exports) {

$parcel$export(module.exports, "BoardIssueSubscription", () => $70818e6682d73c66$export$20d42873ce3eb6aa);

var $jonoc = parcelRequire("jonoc");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $2YZCu = parcelRequire("2YZCu");

var $90yGq = parcelRequire("90yGq");

var $koeKL = parcelRequire("koeKL");

var $bkbBi = parcelRequire("bkbBi");

const $70818e6682d73c66$var$LOG_LOCATION = 'jira-realtime-board-issue-subscription';
const $70818e6682d73c66$export$20d42873ce3eb6aa = /*#__PURE__*/ (0, $5uXOq.memo)(({ appId: appId, projectIds: projectIds, events: events, onJoin: onJoin, onReceive: onReceive, onError: onError, onLeave: onLeave })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const atlassianAccountId = (0, $90yGq.useAccountId)();
    const defaultAttributes = {
        source: (0, $cd8288ab589b4c19$export$f7ec9b25c28de3df),
        cloudId: cloudId,
        appId: appId,
        atlassianAccountId: atlassianAccountId
    };
    (0, $8Uumt.useSubscription)((0, $5uXOq.useMemo)(()=>({
            subscription: (0, $jonoc.default),
            variables: {
                cloudId: cloudId,
                atlassianAccountId: String(atlassianAccountId),
                events: events,
                projectIds: projectIds
            },
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onNext: (response)=>{
                const payload = response?.jira?.onJirtBoardIssueSubscription;
                if (!payload) {
                    (0, $2YZCu.default).safeInfoWithoutCustomerData($70818e6682d73c66$var$LOG_LOCATION, 'Subscription started', defaultAttributes);
                    onJoin();
                    return;
                }
                if (!(0, $bkbBi.isBoardIssueEventType)(payload.type)) {
                    (0, $2YZCu.default).safeErrorWithoutCustomerData($70818e6682d73c66$var$LOG_LOCATION, 'Invalid event type', {
                        ...defaultAttributes,
                        eventType: payload.type
                    });
                    return;
                }
                const boardId = Number(payload.boardId);
                const projectId = payload.projectId;
                const realtimeEvent = {
                    type: payload.type,
                    payload: {
                        boardId: boardId,
                        projectId: projectId,
                        atlassianId: String(payload.actionerAccountId)
                    }
                };
                (0, $2YZCu.default).safeInfoWithoutCustomerData($70818e6682d73c66$var$LOG_LOCATION, 'Event received', {
                    ...defaultAttributes,
                    eventType: payload.type,
                    projectId: projectId,
                    boardId: boardId,
                    resource: payload.resource,
                    triggeredBy: String(payload.actionerAccountId),
                    receivedBy: atlassianAccountId,
                    isTriggeredBySameUser: String(payload.actionerAccountId) === atlassianAccountId
                });
                onReceive(realtimeEvent);
            },
            onCompleted: ()=>{
                (0, $2YZCu.default).safeInfoWithoutCustomerData($70818e6682d73c66$var$LOG_LOCATION, 'Subscription completed', {
                    ...defaultAttributes,
                    receivedBy: atlassianAccountId
                });
                onLeave();
            },
            onError: (error)=>{
                (0, $2YZCu.default).safeErrorWithoutCustomerData($70818e6682d73c66$var$LOG_LOCATION, `[${appId}] Subscription failure`, error);
                onError(error);
            }
        }), // Given React hooks require dependencies to be stable, but this cannot be guaranteed by consumers.
    // To ensure the subscription is created only once and not recreated on every re-render,
    // an empty dependency array is used intentionally. This approach ensures stability and avoids unnecessary resubscriptions.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []));
    return null;
});

});
parcelRegister("jonoc", function(module, exports) {

$parcel$export(module.exports, "default", () => $d72e7cd29e30a9cc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<730097d6ae65b73af54d4da2e8d8c906>>
 * @relayHash 7ea059724811cea589537e314b11add7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 81051b9ef9e2b791f6b496bd28a23ed422f62b88a3e8eec5abb4c22716c6b69a
const $d72e7cd29e30a9cc$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "atlassianAccountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "events"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectIds"
    }, v4 = [
        {
            "concreteType": "JiraSubscription",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "atlassianAccountId",
                            "variableName": "atlassianAccountId"
                        },
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "events",
                            "variableName": "events"
                        },
                        {
                            "kind": "Variable",
                            "name": "projectIds",
                            "variableName": "projectIds"
                        }
                    ],
                    "concreteType": "JiraJirtBoardScoreIssueEventPayload",
                    "kind": "LinkedField",
                    "name": "onJirtBoardIssueSubscription",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "resource"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "boardId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "cloudId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "issueId"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "BoardIssueSubscription",
            "selections": v4 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "BoardIssueSubscription",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "id": "81051b9ef9e2b791f6b496bd28a23ed422f62b88a3e8eec5abb4c22716c6b69a",
            "metadata": {},
            "name": "BoardIssueSubscription",
            "operationKind": "subscription",
            "text": null
        }
    };
}();
$d72e7cd29e30a9cc$var$node.hash = "fe89207b97768c1d05529ecc19effa77";
var $d72e7cd29e30a9cc$export$2e2bcd8739ae039 = $d72e7cd29e30a9cc$var$node;

});




parcelRegister("azrUb", function(module, exports) {

$parcel$export(module.exports, "realtimeChannelsSelector", () => $f7ddc6bb65b350d8$export$3d8a5aabe9d41ff7);

var $dGvGJ = parcelRequire("dGvGJ");

var $4h0Jz = parcelRequire("4h0Jz");

var $jG5HW = parcelRequire("jG5HW");
const $f7ddc6bb65b350d8$export$3d8a5aabe9d41ff7 = (0, $dGvGJ.createSelector)((0, $jG5HW.getCloudId), (0, $jG5HW.getProjectIds), (cloudId, projectIds)=>projectIds.map((projectId)=>(0, $4h0Jz.buildChannelString)(cloudId, projectId)));

});


parcelRegister("6e1e1", function(module, exports) {

$parcel$export(module.exports, "default", () => $38f15258199c4b76$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $687vG = parcelRequire("687vG");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");
const $38f15258199c4b76$export$48dddccb48daa6d7 = ()=>{
    // track card lists being expanded and collapsed
    const collapsedCardLists = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCollapsedCardLists));
    // track sprint containers being created and deleted
    const cardListCount = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCardListCount));
    // track sprint containers moving up and down from ... menu
    const cardListOrder = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getOrderedCardListIds));
    // track cards moving up and down by draggable divider
    const cardOrder = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getOrderedCardIdsByCardListId));
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $687vG.runRecalculateSubscribers)();
    }, [
        collapsedCardLists,
        cardListCount,
        cardListOrder,
        cardOrder
    ]);
    return null;
};
var $38f15258199c4b76$export$2e2bcd8739ae039 = $38f15258199c4b76$export$48dddccb48daa6d7;

});

parcelRegister("lmlf0", function(module, exports) {

$parcel$export(module.exports, "DetailViewPanelWithErrorBoundary", () => $3c6dd45075bfccb0$export$8dcd12fa4f8f9bff);

var $5uXOq = parcelRequire("5uXOq");

var $hqTkp = parcelRequire("hqTkp");

var $7CMCs = parcelRequire("7CMCs");

var $88tXZ = parcelRequire("88tXZ");

var $f6RVN = parcelRequire("f6RVN");

var $czw5V = parcelRequire("czw5V");

var $c060Z = parcelRequire("c060Z");

var $5A42o = parcelRequire("5A42o");
const $3c6dd45075bfccb0$export$eec5a61ba1791f2b = ({ boardId: boardId, parentWidth: parentWidth, isDetailViewVisible: isDetailViewVisible })=>{
    const isInsightsPanelOpen = (0, $czw5V.useIsInsightsPanelOpen)();
    const isViewSettingsPanelOpen = (0, $c060Z.useIsViewSettingsPanelOpen)();
    const [epicFilters, { setEpicFilters: setEpicFilters }] = (0, $88tXZ.useEpicFilters)();
    const onBentoDelete = (0, $5uXOq.useCallback)((issueId)=>{
        if (epicFilters && epicFilters.includes(issueId)) setEpicFilters((0, (/*@__PURE__*/$parcel$interopDefault($hqTkp)))(epicFilters, issueId));
    }, [
        epicFilters,
        setEpicFilters
    ]);
    return isDetailViewVisible || isInsightsPanelOpen || (0, $f6RVN.isViewSettingAsPanelExpEnabledWithNoExposure)() && isViewSettingsPanelOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5A42o.default), {
        parentWidth: parentWidth,
        onDelete: onBentoDelete,
        boardId: boardId
    }) : null;
};
const $3c6dd45075bfccb0$export$8dcd12fa4f8f9bff = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "backlogContentDetailView",
        packageName: "software-backlog",
        teamName: "a4t-tanuki",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3c6dd45075bfccb0$export$eec5a61ba1791f2b, props));

});
parcelRegister("czw5V", function(module, exports) {

$parcel$export(module.exports, "useIsInsightsPanelOpen", () => $daf962c06fa7300b$export$b1fef7718462a5cf);

var $c1MAf = parcelRequire("c1MAf");

var $l89dM = parcelRequire("l89dM");

var $k35me = parcelRequire("k35me");
const $daf962c06fa7300b$export$b1fef7718462a5cf = ()=>{
    const isInsightsPanelVisible = (0, $c1MAf.useBacklogSelector)((0, $l89dM.getInsightsPanel));
    const hasSprints = (0, $c1MAf.useBacklogSelector)((0, $k35me.isBacklogWithSprints));
    return hasSprints && isInsightsPanelVisible;
};

});

parcelRegister("c060Z", function(module, exports) {

$parcel$export(module.exports, "useIsViewSettingsPanelOpen", () => $88c5cab41202b5fa$export$b9d31f582c2f1d3f);

var $c1MAf = parcelRequire("c1MAf");

var $l89dM = parcelRequire("l89dM");
const $88c5cab41202b5fa$export$b9d31f582c2f1d3f = ()=>{
    const isViewSettingsPanelVisible = (0, $c1MAf.useBacklogSelector)((0, $l89dM.getViewSettingsPanel));
    return isViewSettingsPanelVisible;
};

});

parcelRegister("5A42o", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3f381a0939c145c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $g4tDr = parcelRequire("g4tDr");

var $FTaAj = parcelRequire("FTaAj");


var $bC2fB = parcelRequire("bC2fB");

var $ksXL1 = parcelRequire("ksXL1");

var $10Ngv = parcelRequire("10Ngv");

var $legw4 = parcelRequire("legw4");

var $fdAim = parcelRequire("fdAim");

var $38qhf = parcelRequire("38qhf");

var $17kP6 = parcelRequire("17kP6");

var $9g0YE = parcelRequire("9g0YE");

var $czUNp = parcelRequire("czUNp");

var $gwOHY = parcelRequire("gwOHY");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $k35me = parcelRequire("k35me");

var $ixZA4 = parcelRequire("ixZA4");

var $kGoMd = parcelRequire("kGoMd");
const $e3f381a0939c145c$var$mapStateToProps = (state)=>{
    const { cardId: cardId, timestamp: timestamp, externalAction: externalAction } = (0, $dGljH.getDetailViewData)(state) || {};
    const getIssueKey = (0, $dGljH.getKeyByIdForAllIssueTypes)(state);
    const cardKey = getIssueKey(cardId);
    const storyPointFieldId = (0, $jG5HW.getStoryPointFieldId)(state);
    const isEpic = cardId ? (0, $dGljH.makeGetCardTypeHierarchyLevel)(state)(cardId) === (0, $g4tDr.PARENT_HIERARCHY_TYPE) : false;
    return {
        cardKey: cardKey,
        cardId: // @ts-expect-error - TS2322 - Type 'number | undefined' is not assignable to type 'number'.
        cardId,
        isEpic: isEpic,
        externalAction: externalAction,
        timestamp: // @ts-expect-error - TS2322 - Type 'number | undefined' is not assignable to type 'number'.
        timestamp,
        rapidViewId: (0, $jG5HW.getRapidViewId)(state),
        isBacklogWithSprints: (0, $k35me.isBacklogWithSprints)(state),
        backlogSessionId: (0, $jG5HW.getSessionId)(state),
        storyPointFieldId: storyPointFieldId
    };
};
const $e3f381a0939c145c$var$mapDispatchToProps = {
    onTogglePanel: (0, $9g0YE.togglePanel),
    onCloseInsightsPanel: ()=>(0, $9g0YE.closeInsightsPanel)(),
    onCloseViewSettingsPanel: ()=>(0, $9g0YE.closeViewSettingsPanel)(),
    onDelete: (0, $legw4.cardDelete),
    onIssueViewUpdate: (0, $17kP6.issueViewUpdate),
    onCardRefreshRequest: (0, $fdAim.cardRefreshRequest),
    onCardStatusCheck: (0, $czUNp.cardStatusCheck)
};
const $e3f381a0939c145c$var$onCloseFactory = (0, $8QpSo.default)((cardId, onCloseWithIssueId)=>()=>onCloseWithIssueId(cardId));
const $e3f381a0939c145c$var$onChangeFactory = (0, $8QpSo.default)((storyPointFieldId, onRefetchVersions, isEpic, onUpdateEpicSummary, rapidViewId, onCardStatusCheck, onIssueViewUpdate, onCardRefreshRequest)=>(event)=>{
        // NOTE: Updates for version panel are handled separately (owned by Fusion team: src/packages/software/version-backlog-panel/package.json)
        if (event.type === (0, $FTaAj.ChangeEventTypes).FIELD_CHANGED) {
            // Cannot remove StatusKey here as the fixed versions panel uses it
            // see https://stash.atlassian.com/projects/JIRACLOUD/repos/jira-frontend/pull-requests/32152/overview?commentId=2346562
            const versionsRefetchEventTypes = [
                (0, $e9be48d6d2c01760$export$4420b7468f889692),
                (0, $e9be48d6d2c01760$export$a68dbc90211df1a8),
                (0, $e9be48d6d2c01760$export$5fbd3b15555b9ef2),
                storyPointFieldId || ''
            ];
            if (versionsRefetchEventTypes.includes(event.fieldId)) onRefetchVersions();
            if (event.meta.fieldId === 'summary') {
                const { issueId: issueId } = event;
                if (isEpic) onUpdateEpicSummary(issueId, event.meta.fieldValue);
            }
            // with Unmapped status feature, an issue can be moved back to backlog, if status is updated to mapped status
            // In that case backlog need to refresh the data so that issue can reappear on backlog.
            if (event.meta.fieldId === (0, $e9be48d6d2c01760$export$4420b7468f889692)) onCardStatusCheck(event);
        }
        // NOTE: Updates for extracted fields are managed by Sweet State and handled by field sync (src/packages/software/backlog/src/view/all-fields-sync/field-sync)
        const extractedFields = (0, $10Ngv.getExtractedFields)({
            storyPointFieldId: storyPointFieldId
        });
        if ((event.type === (0, $FTaAj.ChangeEventTypes).FIELD_CHANGE_REQUESTED || event.type === (0, $FTaAj.ChangeEventTypes).FIELD_CHANGED || event.type === (0, $FTaAj.ChangeEventTypes).FIELD_CHANGE_FAILED) && extractedFields.includes(event.meta.fieldId) || event.type === (0, $FTaAj.ChangeEventTypes).ISSUE_RELATIONSHIP_UPDATED) return;
        // Handles updates for epics or subtasks by updating only relevant parts of the Redux store (non-trivial for Backlog card UI but impact the issue hierarchy relationship)
        onIssueViewUpdate(event);
        const refreshIssueId = event.type === (0, $FTaAj.ChangeEventTypes).CHILD_ISSUE_ADDED ? Number(event.meta.childIssue.id) : Number(event.issueId);
        // Handles updates for base-level issues by refetching the card (impact Backlog card UI directly)
        onCardRefreshRequest(refreshIssueId, event);
    });
const $e3f381a0939c145c$var$onDeleteFactory = (0, $8QpSo.default)((ownPropsOnDelete, onDelete, cardId, onCardRefreshRequest)=>({ issueId: issueId })=>{
        if (ownPropsOnDelete) ownPropsOnDelete(issueId);
        onDelete(Number(issueId));
        if (issueId && Number(issueId) !== cardId) onCardRefreshRequest();
    });
const $e3f381a0939c145c$export$9d1611c77c2fe928 = ({ rapidViewId: rapidViewId, backlogSessionId: backlogSessionId, storyPointFieldId: storyPointFieldId, cardId: cardId, cardKey: cardKey, isEpic: isEpic, timestamp: timestamp, isBacklogWithSprints: isBacklogWithSprints, externalAction: externalAction }, { onCloseInsightsPanel: onCloseInsightsPanel, onCloseViewSettingsPanel: onCloseViewSettingsPanel, onDelete: onDelete, onIssueViewUpdate: onIssueViewUpdate, onCardRefreshRequest: onCardRefreshRequest, onCardStatusCheck: onCardStatusCheck }, { parentWidth: parentWidth, onDelete: ownPropsOnDelete, onRefetchVersions: onRefetchVersions, onUpdateEpicSummary: onUpdateEpicSummary, onCloseWithIssueId: onCloseWithIssueId })=>({
        parentWidth: parentWidth,
        cardKey: cardKey,
        timestamp: timestamp,
        rapidViewId: rapidViewId,
        isBacklogWithSprints: isBacklogWithSprints,
        externalAction: externalAction,
        backlogSessionId: backlogSessionId,
        // extra method to avoid arguments in action creator
        onClose: $e3f381a0939c145c$var$onCloseFactory(cardId, onCloseWithIssueId),
        onCloseInsightsClick: onCloseInsightsPanel,
        onCloseViewSettingsPanelClick: onCloseViewSettingsPanel,
        onChange: $e3f381a0939c145c$var$onChangeFactory(storyPointFieldId, onRefetchVersions, isEpic, onUpdateEpicSummary, rapidViewId, onCardStatusCheck, onIssueViewUpdate, onCardRefreshRequest),
        onDelete: $e3f381a0939c145c$var$onDeleteFactory(ownPropsOnDelete, onDelete, cardId, onCardRefreshRequest),
        IssueWrapper: (0, $ixZA4.default)
    });
const $e3f381a0939c145c$export$812e801c43ce71e3 = (0, $bC2fB.connect)($e3f381a0939c145c$var$mapStateToProps, $e3f381a0939c145c$var$mapDispatchToProps, $e3f381a0939c145c$export$9d1611c77c2fe928)((0, $kGoMd.default));
const $e3f381a0939c145c$export$335ea2193bcd128b = ({ boardId: boardId, ...props })=>{
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const [, { updateEpicAttributes: updateEpicAttributes }] = (0, $ksXL1.useEpicsStoreActions)();
    const refetch = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $gwOHY.refetchVersions)());
    }, [
        dispatch
    ]);
    const onCloseWithIssueId = (0, $5uXOq.useCallback)((cardId)=>{
        dispatch((0, $38qhf.closeDetailView)(cardId));
        return (0, $38qhf.closeDetailView)(cardId);
    }, [
        dispatch
    ]);
    const onUpdateEpicSummary = (0, $5uXOq.useCallback)((issueId, summary)=>updateEpicAttributes(issueId, {
            name: summary
        }), [
        updateEpicAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e3f381a0939c145c$export$812e801c43ce71e3, {
        ...props,
        onRefetchVersions: refetch,
        onUpdateEpicSummary: onUpdateEpicSummary,
        onCloseWithIssueId: onCloseWithIssueId
    });
};
var $e3f381a0939c145c$export$2e2bcd8739ae039 = $e3f381a0939c145c$export$335ea2193bcd128b;

});
parcelRegister("ixZA4", function(module, exports) {

$parcel$export(module.exports, "default", () => $95e0f46b92431375$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $basmW = parcelRequire("basmW");

var $jzjy1 = parcelRequire("jzjy1");


var $dG9Wy = parcelRequire("dG9Wy");

var $7wqBZ = parcelRequire("7wqBZ");

var $hUXfN = parcelRequire("hUXfN");

var $fOGZN = parcelRequire("fOGZN");

var $a2e2Q = parcelRequire("a2e2Q");

var $lmBAt = parcelRequire("lmBAt");

var $7eqRV = parcelRequire("7eqRV");


var $kxZPA = parcelRequire("kxZPA");


var $gZhS0 = parcelRequire("gZhS0");

var $gKgRy = parcelRequire("gKgRy");

var $c1MAf = parcelRequire("c1MAf");

var $fSgHa = parcelRequire("fSgHa");

var $56RoY = parcelRequire("56RoY");

const $95e0f46b92431375$export$35dd9ab573b87c3f = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("iPF14")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});
const $95e0f46b92431375$var$IssueWrapper = (props)=>{
    const backlogCardCount = (0, $c1MAf.useBacklogSelector)((0, $gZhS0.getBacklogCardCount));
    const isCompanyManaged = (0, $fSgHa.useIsCMPBacklog)(); // If there's an external action to be fired, dispatch it as soon as possible
    const onSetDispatchExternalActionRef = (0, $5uXOq.useCallback)((dispatchExternalActionRef)=>{
        if (dispatchExternalActionRef && props.externalAction) dispatchExternalActionRef(props.externalAction);
    }, [
        props.externalAction
    ]);
    const { isSoftwareFullTheming: isSoftwareFullTheming } = (0, $lmBAt.getIsSoftwareThemingM2Enabled)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $a2e2Q.useSoftwareProjectTheming)() : {
        isSoftwareFullTheming: false
    };
    (0, $5uXOq.useEffect)(()=>{
        (0, $gKgRy.setIssueViewOpenFeedbackMark)();
    }, [
        props.issueKey
    ]);
    const isAgilityBoardForIssue = props.isAgilityBoard !== undefined ? props.isAgilityBoard : (0, $dG9Wy.isAgilityBoard);
    const configWithAppKey = isAgilityBoardForIssue ? (0, $fOGZN.simpleSoftwareBoardConfiguration)() : (0, $fOGZN.softwareConfiguration)();
    const { applicationKey: applicationKey, ...configWithoutAppKey } = configWithAppKey;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($95e0f46b92431375$var$BacklogIssueContainer, {
        "data-testid": "software-backlog.detail-view.issue-wrapper.backlog-issue",
        className: (0, $bwpsq.default)([
            isSoftwareFullTheming && $95e0f46b92431375$var$themedStyles.container
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $56RoY.PreIssueViewMountFeedbackMark), {
        issueKey: props.issueKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7eqRV.IssueBoundary), {
        packageName: (0, $a9c483c0d986286a$export$dfd208682d29484c)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($95e0f46b92431375$export$35dd9ab573b87c3f, {
        ...configWithoutAppKey,
        analyticsSource: (0, $fcf97b7a09088940$export$53d41ff2666118e1),
        isLoadedWithPage: true,
        issueKey: props.issueKey,
        onChange: props.onChange,
        onClose: props.onClose,
        rapidViewId: props.rapidViewId,
        viewModeOptions: {
            viewModeSwitchEnabled: false,
            viewMode: 'SIDEBAR'
        },
        onIssueDeleteSuccess: props.onIssueDeleteSuccess,
        shouldSetInitialFocus: true,
        shouldShowCloseButton: true,
        metrics: {
            onReadyForUser: ()=>{
                (0, $7wqBZ.getLongTasksMetrics)('bento').stop((0, $hUXfN.bentoReporter), {
                    type: 'sidebar',
                    backlogSessionId: props.backlogSessionId
                });
            },
            onInteractive: ()=>{
                (0, $gKgRy.setIssueViewOpenFinishMark)(true, backlogCardCount, isCompanyManaged);
            }
        },
        onIssueKeyChange: props.onIssueKeyChange,
        history: null,
        dispatchExternalActionRef: onSetDispatchExternalActionRef
    })));
};
var $95e0f46b92431375$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $jzjy1.AnalyticsSource)((0, $fcf97b7a09088940$export$53d41ff2666118e1), (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)))($95e0f46b92431375$var$IssueWrapper);
const $95e0f46b92431375$var$BacklogIssueContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq",
            __cmplp.className
        ])
    });
});
const $95e0f46b92431375$var$themedStyles = {
    container: "_bfhkvuon _qrwqpd34 _13lipd34 _16qs1cd0 _2hwx1ejb _ca0qu2gc _vchhusvi"
};

});
const $fcf97b7a09088940$export$53d41ff2666118e1 = 'agility-backlog';
const $fcf97b7a09088940$export$7552fe2669628499 = 'bitbucket-issue';
const $fcf97b7a09088940$export$41a718da0a8636f4 = 'connect-issue';
const $fcf97b7a09088940$export$cebf0bc8b2ccaf57 = 'core-issue';
const $fcf97b7a09088940$export$5e91e17726e54450 = 'jiraCalendar';
const $fcf97b7a09088940$export$2dac1950892123f5 = 'jiraTimeline';
const $fcf97b7a09088940$export$82540942fb014b0a = 'business-calendar';
const $fcf97b7a09088940$export$7ca28938a07e0c33 = 'business-list';
const $fcf97b7a09088940$export$f6cf06aaaeb58a54 = 'business-timeline';
const $fcf97b7a09088940$export$b2c0462ff17aa26e = 'business-board';
const $fcf97b7a09088940$export$a607850ebccd28ac = 'business-approvals';
const $fcf97b7a09088940$export$1da6cede3561048f = 'business-files';
const $fcf97b7a09088940$export$b19f949fb9713614 = 'full-issue';
const $fcf97b7a09088940$export$a5132300c5214280 = 'embed-issue';
const $fcf97b7a09088940$export$710114090a811b37 = 'global-issue-navigator-issue';
const $fcf97b7a09088940$export$ce88447986394f2d = 'mobile-issue';
const $fcf97b7a09088940$export$6a90d9196d330040 = 'project-issue-navigator';
const $fcf97b7a09088940$export$2247c9059c171db1 = 'roadmap-issue';
const $fcf97b7a09088940$export$cd16d39c55c569d0 = 'simple-software-board';
const $fcf97b7a09088940$export$f72626bf0d75dfad = 'software-backlog-issue';
const $fcf97b7a09088940$export$778b4609e784cb27 = 'software-deployments-issue';
const $fcf97b7a09088940$export$5b73d694a6048002 = 'version-detail-issue';
const $fcf97b7a09088940$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $fcf97b7a09088940$export$21b5b7189add7861 = 'software-incidents-issue';
const $fcf97b7a09088940$export$9c5d81b901471b27 = 'software-issue';
const $fcf97b7a09088940$export$1735f6ad917dc411 = 'change-calendar';
const $fcf97b7a09088940$export$7063ee6d0035a982 = 'queues-issue-view';
const $fcf97b7a09088940$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $fcf97b7a09088940$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $fcf97b7a09088940$export$14a8072f422804fd = 'issue-navigator-next';
const $fcf97b7a09088940$export$5f3c20fe2ff6c0a2 = 'staffing-issue';

parcelRegister("dG9Wy", function(module, exports) {

$parcel$export(module.exports, "isAgilityBoard", () => $a8e7e70c49421eb3$export$f5c021765283e8bd);

var $j8DrX = parcelRequire("j8DrX");
const $a8e7e70c49421eb3$export$f5c021765283e8bd = // this meta actually checks if backlog is using issueLists
(0, $j8DrX.default)('ghx-simply-filters-enabled') === 'true';

});

parcelRegister("hUXfN", function(module, exports) {

$parcel$export(module.exports, "bentoReporter", () => $6bde48e393b34dc9$export$b4ea9d181d8adab2);

var $k12ix = parcelRequire("k12ix");

var $cJpFl = parcelRequire("cJpFl");

var $if7bx = parcelRequire("if7bx");
const $6bde48e393b34dc9$export$b4ea9d181d8adab2 = (observationData, extra)=>{
    if ((0, $cJpFl.isExpandedObservationData)(observationData)) {
        const triggerSoftwareAnalytics = (0, $if7bx.triggerAnalytics)(`software.${observationData.appName}`);
        const startTime = observationData.events.map((event)=>event.timestamp);
        const analyticsData = {
            ...extra,
            ...(0, $if7bx.generateLongTaskAnalyticsSummary)('bento', observationData.events),
            measureTimespan: performance.now() - Math.min(observationData.startTimestamp, ...startTime),
            type: extra.type || 'unknown',
            performanceFFs: (0, $k12ix.getPerformanceFFsString)()
        };
        triggerSoftwareAnalytics('long-tasks-bento', analyticsData);
    }
};

});

parcelRegister("fOGZN", function(module, exports) {

$parcel$export(module.exports, "ISSUE_TYPE", () => $1df76d38eb6e3f90$export$ebb48b08205007c5);
$parcel$export(module.exports, "ISSUE_SUMMARY", () => $1df76d38eb6e3f90$export$a464614f8f5fe986);
$parcel$export(module.exports, "SUBTASK_PARENT", () => $1df76d38eb6e3f90$export$a311a3c9b207604e);
$parcel$export(module.exports, "WATCHES", () => $1df76d38eb6e3f90$export$289917d9a7031e1d);
$parcel$export(module.exports, "VOTES", () => $1df76d38eb6e3f90$export$81614f6dc3be5b00);
$parcel$export(module.exports, "SECURITY", () => $1df76d38eb6e3f90$export$72a5630aa398d6b4);
$parcel$export(module.exports, "ISSUE_RESTRICTION", () => $1df76d38eb6e3f90$export$caf1ff54fbdf44bf);
$parcel$export(module.exports, "ASSIGNEE", () => $1df76d38eb6e3f90$export$f8f7545d2bb78afb);
$parcel$export(module.exports, "REPORTER", () => $1df76d38eb6e3f90$export$6d7021166edc895c);
$parcel$export(module.exports, "DUE_DATE", () => $1df76d38eb6e3f90$export$cf7e173386d30cdd);
$parcel$export(module.exports, "PRIORITY", () => $1df76d38eb6e3f90$export$bb34f3538ba26c7e);
$parcel$export(module.exports, "LABELS", () => $1df76d38eb6e3f90$export$79b91d4669dcadcb);
$parcel$export(module.exports, "EPIC", () => $1df76d38eb6e3f90$export$3cb4a99a332e4186);
$parcel$export(module.exports, "FIX_VERSIONS", () => $1df76d38eb6e3f90$export$d7e18f5730074533);
$parcel$export(module.exports, "AFFECTS_VERSIONS", () => $1df76d38eb6e3f90$export$c435f0000304e508);
$parcel$export(module.exports, "TIME_TRACKING", () => $1df76d38eb6e3f90$export$ee99ef6ee562a446);
$parcel$export(module.exports, "TIME_ESTIMATE", () => $1df76d38eb6e3f90$export$a6a74b4bc927d39f);
$parcel$export(module.exports, "STATUS", () => $1df76d38eb6e3f90$export$e50006273435e7d4);
$parcel$export(module.exports, "CREATED", () => $1df76d38eb6e3f90$export$ff39ebd4bb12b718);
$parcel$export(module.exports, "UPDATED", () => $1df76d38eb6e3f90$export$cd8e68094cb5c3cb);
$parcel$export(module.exports, "SUMMARY", () => $1df76d38eb6e3f90$export$913055729e1380b2);
$parcel$export(module.exports, "DESCRIPTION", () => $1df76d38eb6e3f90$export$d44826c816b5619b);
$parcel$export(module.exports, "COMMENT", () => $1df76d38eb6e3f90$export$a29989082612d0d9);
$parcel$export(module.exports, "EPIC_ISSUES", () => $1df76d38eb6e3f90$export$8fe3d5be8cb17459);
$parcel$export(module.exports, "CHILDREN_ISSUES", () => $1df76d38eb6e3f90$export$3b3d0889022c85b3);
$parcel$export(module.exports, "ENVIRONMENT", () => $1df76d38eb6e3f90$export$be46596bc6608f3b);
$parcel$export(module.exports, "SUBTASKS", () => $1df76d38eb6e3f90$export$f528fadbfdb3c25e);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", () => $1df76d38eb6e3f90$export$f10e53e8928b61bd);
$parcel$export(module.exports, "PARENT", () => $1df76d38eb6e3f90$export$e0dfb65d1047c53c);
$parcel$export(module.exports, "PORTFOLIO_CHILD_ISSUES", () => $1df76d38eb6e3f90$export$aba22e09a66f6826);
$parcel$export(module.exports, "SELECT_CUSTOM_FIELD_TYPE", () => $1df76d38eb6e3f90$export$826d657005bbe54c);
$parcel$export(module.exports, "FLAG_ACTIONS", () => $1df76d38eb6e3f90$export$cdbd1eb3b05729e0);
$parcel$export(module.exports, "CARD_COVER_ACTIONS", () => $1df76d38eb6e3f90$export$c161a774ec2e7e56);
$parcel$export(module.exports, "specialFields", () => $1df76d38eb6e3f90$export$89e5c40c0f5c7561);
$parcel$export(module.exports, "ecosystemCustomFields", () => $1df76d38eb6e3f90$export$87934b3672715c91);
$parcel$export(module.exports, "customFieldsToDisplay", () => $1df76d38eb6e3f90$export$efd443bccc4c01ed);
$parcel$export(module.exports, "itemDocumentationUrls", () => $1df76d38eb6e3f90$export$a18b3a656ee9c709);
$parcel$export(module.exports, "emptyConfiguration", () => $1df76d38eb6e3f90$export$a52507e68e7aeeb);
$parcel$export(module.exports, "softwareConfiguration", () => $1df76d38eb6e3f90$export$27e0678365e5dcff);
$parcel$export(module.exports, "simpleSoftwareBoardConfiguration", () => $1df76d38eb6e3f90$export$aebf676dfa727a1c);
$parcel$export(module.exports, "standardRoadmapConfiguration", () => $1df76d38eb6e3f90$export$1afca4d3eb6b218b);
$parcel$export(module.exports, "bitbucketConfiguration", () => $1df76d38eb6e3f90$export$8a060ed6f66c43b0);
$parcel$export(module.exports, "mobileConfiguration", () => $1df76d38eb6e3f90$export$78a2cb921e46f5eb);
$parcel$export(module.exports, "serviceDeskConfiguration", () => $1df76d38eb6e3f90$export$db1115186532f6d5);
$parcel$export(module.exports, "connectConfiguration", () => $1df76d38eb6e3f90$export$557d5094ec5cf234);
$parcel$export(module.exports, "getIssueConfiguration", () => $1df76d38eb6e3f90$export$902f6c5cc939598a);

var $65mz3 = parcelRequire("65mz3");

var $2vSU6 = parcelRequire("2vSU6");

var $5fc53 = parcelRequire("5fc53");
const $1df76d38eb6e3f90$export$ebb48b08205007c5 = 'issuetype';
const $1df76d38eb6e3f90$export$a464614f8f5fe986 = 'summary';
const $1df76d38eb6e3f90$export$a311a3c9b207604e = 'parent';
const $1df76d38eb6e3f90$export$2a4f270075a033de = 'parent-issue';
const $1df76d38eb6e3f90$export$4561a4960baf1b2b = 'parent'; // new Hierarchy unification parent field
const $1df76d38eb6e3f90$export$289917d9a7031e1d = 'watches';
const $1df76d38eb6e3f90$export$81614f6dc3be5b00 = 'votes';
const $1df76d38eb6e3f90$export$72a5630aa398d6b4 = 'security';
const $1df76d38eb6e3f90$export$caf1ff54fbdf44bf = 'issuerestriction';
const $1df76d38eb6e3f90$export$f8f7545d2bb78afb = 'assignee';
const $1df76d38eb6e3f90$export$6d7021166edc895c = 'reporter';
const $1df76d38eb6e3f90$export$cf7e173386d30cdd = 'duedate';
const $1df76d38eb6e3f90$export$bb34f3538ba26c7e = 'priority';
const $1df76d38eb6e3f90$export$79b91d4669dcadcb = 'labels';
const $1df76d38eb6e3f90$export$cbedbfe2cd0caec7 = 'components';
const $1df76d38eb6e3f90$export$950d47e775e208ee = 'devSummary';
const $1df76d38eb6e3f90$export$f91d2bb4cc99fa5e = 'releases';
const $1df76d38eb6e3f90$export$a316570a0dbfd2b0 = 'sprint';
const $1df76d38eb6e3f90$export$405b6d72f2d243a9 = 'storyPointsField';
const $1df76d38eb6e3f90$export$3cb4a99a332e4186 = 'epic';
const $1df76d38eb6e3f90$export$d7e18f5730074533 = 'fixVersions';
const $1df76d38eb6e3f90$export$c435f0000304e508 = 'versions';
const $1df76d38eb6e3f90$export$ee99ef6ee562a446 = 'timetracking';
const $1df76d38eb6e3f90$export$a6a74b4bc927d39f = 'timeoriginalestimate';
const $1df76d38eb6e3f90$export$e50006273435e7d4 = 'status';
const $1df76d38eb6e3f90$export$f1a6ce22cbb7eb32 = 'resolution';
const $1df76d38eb6e3f90$export$ff39ebd4bb12b718 = 'created';
const $1df76d38eb6e3f90$export$cd8e68094cb5c3cb = 'updated';
const $1df76d38eb6e3f90$export$1d0e0bb6a21b800b = 'SLA_PANEL';
const $1df76d38eb6e3f90$export$340fac260c3e3637 = 'LINKED_ALERTS';
const $1df76d38eb6e3f90$export$24ec4dcc8e5b08ef = 'CHAT_CHANNEL';
const $1df76d38eb6e3f90$export$8631065e0909313 = 'MSTEAMS_CHANNEL';
const $1df76d38eb6e3f90$export$3c4dccba7d7e0acb = 'ZOOM_MEETING';
const $1df76d38eb6e3f90$export$cd5e9246357daec3 = 'CONFERENCE_CALL';
const $1df76d38eb6e3f90$export$9c83bd19c3ffd90d = 'SENTIMENT';
const $1df76d38eb6e3f90$export$c5c04443c6097d6e = 'ASSET_ONBOARDING';
const $1df76d38eb6e3f90$export$26d855f4cd7e5fe9 = 'MANAGE_STAKEHOLDERS';
const $1df76d38eb6e3f90$export$913055729e1380b2 = 'summary';
const $1df76d38eb6e3f90$export$d44826c816b5619b = 'description';
const $1df76d38eb6e3f90$export$a29989082612d0d9 = 'comment';
const $1df76d38eb6e3f90$export$8fe3d5be8cb17459 = 'epic-issues'; // this field is only served in classic projects
const $1df76d38eb6e3f90$export$3b3d0889022c85b3 = 'children-issues';
const $1df76d38eb6e3f90$export$be46596bc6608f3b = 'environment';
const $1df76d38eb6e3f90$export$f528fadbfdb3c25e = 'subtasks';
const $1df76d38eb6e3f90$export$f10e53e8928b61bd = 'dataclassification';
const $1df76d38eb6e3f90$export$e0dfb65d1047c53c = (0, $5fc53.PARENT_CF_TYPE);
const $1df76d38eb6e3f90$export$aba22e09a66f6826 = 'portfolio-child-issues';
const $1df76d38eb6e3f90$export$826d657005bbe54c = (0, $5fc53.SELECT_CF_TYPE);
const $1df76d38eb6e3f90$export$cdbd1eb3b05729e0 = 'flagActions';
const $1df76d38eb6e3f90$export$c161a774ec2e7e56 = 'cardCoverActions';
const $1df76d38eb6e3f90$export$89e5c40c0f5c7561 = ()=>{
    const fields = {
        [$1df76d38eb6e3f90$export$3cb4a99a332e4186]: 'com.pyxis.greenhopper.jira:gh-epic-link',
        [$1df76d38eb6e3f90$export$a316570a0dbfd2b0]: 'com.pyxis.greenhopper.jira:gh-sprint',
        [$1df76d38eb6e3f90$export$405b6d72f2d243a9]: 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint',
        [(0, $5fc53.TEAM_CF_TYPE)]: (0, $5fc53.TEAM_CF_TYPE),
        [(0, $5fc53.PARENT_CF_TYPE)]: (0, $5fc53.PARENT_CF_TYPE),
        [(0, $5fc53.BASELINE_START_CF_TYPE)]: (0, $5fc53.BASELINE_START_CF_TYPE),
        [(0, $5fc53.BASELINE_END_CF_TYPE)]: (0, $5fc53.BASELINE_END_CF_TYPE),
        [(0, $5fc53.COLOR_CF_TYPE)]: (0, $5fc53.COLOR_CF_TYPE),
        [(0, $5fc53.EPIC_COLOR_TYPE)]: (0, $5fc53.EPIC_COLOR_TYPE),
        [(0, $5fc53.EPIC_NAME_TYPE)]: (0, $5fc53.EPIC_NAME_TYPE)
    };
    return fields;
};
const $1df76d38eb6e3f90$export$87934b3672715c91 = [
    (0, $5fc53.ISSUE_FIELD_NUMBER_CF_TYPE),
    (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
    (0, $5fc53.ISSUE_FIELD_DATETIME_CF_TYPE),
    (0, $5fc53.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE),
    (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
];
const $1df76d38eb6e3f90$var$serviceDeskCustomFields = [
    (0, $5fc53.REQUEST_PARTICIPANTS_CF_TYPE),
    (0, $5fc53.ORGANIZATIONS_CF_TYPE),
    (0, $5fc53.REQUEST_LANGUAGE_CF_TYPE),
    (0, $5fc53.REQUEST_FEEDBACK_CF_TYPE),
    (0, $5fc53.APPROVALS_CF_TYPE),
    (0, $5fc53.APPROVERS_LIST_CF_TYPE),
    (0, $5fc53.REQUEST_TYPE_CF_TYPE),
    (0, $5fc53.CMDB_OBJECT_CF_TYPE),
    (0, $5fc53.RESPONDERS_CF_TYPE),
    (0, $5fc53.MAJOR_INCIDENT_CF_TYPE),
    (0, $5fc53.ENTITLEMENT_CF_TYPE),
    (0, $5fc53.SENTIMENT_CF_TYPE),
    (0, $5fc53.ORGANIZATION_CF_TYPE)
];
const $1df76d38eb6e3f90$export$efd443bccc4c01ed = ()=>[
        (0, $5fc53.LABELS_CF_TYPE),
        (0, $5fc53.TEXT_CF_TYPE),
        (0, $5fc53.MULTI_USER_CF_TYPE),
        (0, $5fc53.PARTICIPANTS_CF_TYPE),
        (0, $5fc53.URL_CF_TYPE),
        (0, $5fc53.NUMBER_CF_TYPE),
        (0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE),
        (0, $5fc53.SELECT_CF_TYPE),
        (0, $5fc53.MULTI_SELECT_CF_TYPE),
        (0, $5fc53.VERSION_CF_TYPE),
        (0, $5fc53.TEXT_AREA_CF_TYPE),
        (0, $5fc53.MULTI_VERSION_CF_TYPE),
        (0, $5fc53.DATE_CF_TYPE),
        (0, $5fc53.GROUP_CF_TYPE),
        (0, $5fc53.MULTI_GROUP_CF_TYPE),
        (0, $5fc53.USER_CF_TYPE),
        (0, $5fc53.MULTI_CHECKBOXES_CF_TYPE),
        (0, $5fc53.RADIO_BUTTONS_CF_TYPE),
        (0, $5fc53.DATETIME_CF_TYPE),
        (0, $5fc53.ASSETS_CF_TYPE),
        (0, $5fc53.SERVICE_ENTITY_CF_TYPE),
        (0, $5fc53.PEOPLE_CF_TYPE),
        (0, $5fc53.CASCADING_SELECT_CF_TYPE),
        (0, $5fc53.PROJECT_PICKER_CF_TYPE),
        (0, $5fc53.TEAMS_PLATFORM_CF_TYPE),
        (0, $5fc53.READ_ONLY_CF_TYPE),
        (0, $5fc53.EPIC_STATUS_TYPE),
        (0, $5fc53.MESSAGE_VIEW_CF_TYPE),
        (0, $5fc53.MESSAGE_EDIT_CF_TYPE),
        (0, $5fc53.CATEGORY_TYPE),
        (0, $5fc53.GOALS_CF_TYPE),
        ...$1df76d38eb6e3f90$export$87934b3672715c91,
        ...$1df76d38eb6e3f90$var$serviceDeskCustomFields
    ];
const $1df76d38eb6e3f90$export$a18b3a656ee9c709 = {
    [(0, $2vSU6.SOFTWARE_PROJECT)]: 'https://confluence.atlassian.com/jirasoftwarecloud/configure-field-layout-in-the-issue-view-961798059.html',
    [(0, $2vSU6.CORE_PROJECT)]: 'https://confluence.atlassian.com/jiracorecloud/configure-field-layout-in-the-issue-view-961798123.html',
    [(0, $2vSU6.SERVICE_DESK_PROJECT)]: 'https://support.atlassian.com/jira-service-desk-cloud/docs/what-are-the-different-sections-in-the-issue-view/'
};
const $1df76d38eb6e3f90$export$a52507e68e7aeeb = ()=>({
        issueActions: []
    });
const $1df76d38eb6e3f90$export$381ce08838c53afa = ()=>({
        applicationKey: (0, $65mz3.default).CORE_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$27e0678365e5dcff = ()=>({
        applicationKey: (0, $65mz3.default).SOFTWARE_ISSUE,
        issueActions: [
            $1df76d38eb6e3f90$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$aebf676dfa727a1c = ()=>({
        applicationKey: (0, $65mz3.default).SIMPLE_SOFTWARE_BOARD,
        issueActions: [
            $1df76d38eb6e3f90$export$cdbd1eb3b05729e0,
            $1df76d38eb6e3f90$export$c161a774ec2e7e56
        ],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$1afca4d3eb6b218b = ()=>({
        applicationKey: (0, $65mz3.default).STANDARD_ROADMAP_ISSUE,
        issueActions: [
            $1df76d38eb6e3f90$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$8a060ed6f66c43b0 = ()=>({
        applicationKey: (0, $65mz3.default).BITBUCKET_ISSUE,
        issueActions: []
    });
const $1df76d38eb6e3f90$export$78a2cb921e46f5eb = ()=>({
        applicationKey: (0, $65mz3.default).MOBILE_ISSUE,
        issueActions: []
    });
const $1df76d38eb6e3f90$export$db1115186532f6d5 = ()=>({
        applicationKey: (0, $65mz3.default).SERVICE_DESK,
        issueActions: [],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$557d5094ec5cf234 = ()=>({
        applicationKey: (0, $65mz3.default).CONNECT_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$902f6c5cc939598a = (config)=>{
    if (config) switch(config.projectType){
        case 0, $2vSU6.SOFTWARE_PROJECT:
            if (config.isSimplified) return $1df76d38eb6e3f90$export$aebf676dfa727a1c();
            return $1df76d38eb6e3f90$export$27e0678365e5dcff();
        case 0, $2vSU6.CORE_PROJECT:
            return $1df76d38eb6e3f90$export$381ce08838c53afa();
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return $1df76d38eb6e3f90$export$db1115186532f6d5();
        default:
            // fallback to sofware config
            return $1df76d38eb6e3f90$export$27e0678365e5dcff();
    }
    return $1df76d38eb6e3f90$export$27e0678365e5dcff();
};

});

parcelRegister("7eqRV", function(module, exports) {

$parcel$export(module.exports, "IssueBoundary", () => $e3c8771effba3477$export$fbf48ede0cf52b5a);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $gjEtj = parcelRequire("gjEtj");

var $lfTZh = parcelRequire("lfTZh");

var $lb0Dk = parcelRequire("lb0Dk");
const $e3c8771effba3477$export$fbf48ede0cf52b5a = ({ children: children, isEmbedView: isEmbedView = true, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "issue",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lb0Dk.IssueViewSkeleton), {
            isEmbedView: isEmbedView
        })
    }, children));
const $e3c8771effba3477$export$74d408982642a541 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjEtj.ModalBoundary), {
        id: "issue-modal",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-modal-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lb0Dk.IssueViewSkeleton), {
            isModalView: true
        })
    }, children));

});
parcelRegister("lb0Dk", function(module, exports) {

$parcel$export(module.exports, "IssueViewSkeleton", () => $bf9ca492e3d15685$export$49addbcdecb6e6ff);
/* IssueViewSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $iMqhh = parcelRequire("iMqhh");

var $4R6GH = parcelRequire("4R6GH");

var $hCy6k = parcelRequire("hCy6k");

var $3441h = parcelRequire("3441h");
const $bf9ca492e3d15685$var$fullpageStyles = null;
const $bf9ca492e3d15685$var$modalStyles = null;
const $bf9ca492e3d15685$var$customSpacingStylesWithIncreasedWidth = null;
const $bf9ca492e3d15685$var$customSpacingStylesWithDefaultWidth = null;
const $bf9ca492e3d15685$export$49addbcdecb6e6ff = ({ isEmbedView: isEmbedView, isModalView: isModalView })=>{
    // same as getIssueContainerMaxWidth
    const customCss = [
        (0, $4R6GH.fg)('jracloud-75406-remove-excessive-padding-from-side') ? $bf9ca492e3d15685$var$customSpacingStylesWithIncreasedWidth : $bf9ca492e3d15685$var$customSpacingStylesWithDefaultWidth,
        isEmbedView !== true && isModalView !== true ? $bf9ca492e3d15685$var$fullpageStyles : null,
        isModalView === true ? $bf9ca492e3d15685$var$modalStyles : null
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iMqhh.CompactModeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3441h))),
        className: (0, $bwpsq.default)([
            (0, $4R6GH.fg)('jracloud-75406-remove-excessive-padding-from-side') ? "_p12f107j _19pkze3t _2hwx1wug _otyrze3t _18u01wug _t6vdxy5q _hr4jxy5q _11y7uu9g _l82tpxbi _j7o0pxbi" : "_p12f1ypn _19pkze3t _2hwx1wug _otyrze3t _18u01wug _t6vdxy5q _hr4jxy5q _11y7uu9g _l82tpxbi _j7o0pxbi",
            isEmbedView !== true && isModalView !== true && "_uwhk1ejb",
            isModalView === true && "_19pk10j7"
        ])
    }));
};

});
parcelRegister("iMqhh", function(module, exports) {

$parcel$export(module.exports, "CompactModeContext", () => $db79d17d45755de5$export$37eeac5cc5245b18);
$parcel$export(module.exports, "CompactModeProvider", () => $db79d17d45755de5$export$10cf42790e523b8e);
$parcel$export(module.exports, "CompactModeConsumer", () => $db79d17d45755de5$export$20feb77b5b617e44);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");


var $8kj45 = parcelRequire("8kj45");

var $doZTA = parcelRequire("doZTA");

var $k1L82 = parcelRequire("k1L82");

var $hhMVP = parcelRequire("hhMVP");
const $db79d17d45755de5$export$37eeac5cc5245b18 = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
const { Provider: $db79d17d45755de5$var$Provider, Consumer: $db79d17d45755de5$var$Consumer } = $db79d17d45755de5$export$37eeac5cc5245b18;
const $db79d17d45755de5$export$55a90a8e865a39b5 = 700;
const $db79d17d45755de5$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY = `(max-width: ${$db79d17d45755de5$export$55a90a8e865a39b5}px)`;
const $db79d17d45755de5$export$ddd398a95f85cd75 = 850;
const $db79d17d45755de5$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY_SIDE_PANEL = `(max-width: ${$db79d17d45755de5$export$ddd398a95f85cd75}px)`;
/**
 * A utility hook which returns a key based on the route
 */ function $db79d17d45755de5$var$useRouteKey() {
    const [routeState] = (0, $doZTA.useRouter)();
    const { match: { path: path, params: params } } = routeState;
    // handle case where JSM doesn't have an issueKey on their route
    const hasIssueKey = params?.issueKey !== undefined;
    return `${path}${hasIssueKey ? '/hasIssueKey' : ''}`;
}
const $db79d17d45755de5$export$10cf42790e523b8e = ({ children: children })=>{
    const key = $db79d17d45755de5$var$useRouteKey();
    (0, $hhMVP.invalidateCacheIfRouteChanged)(key);
    let defaultState = (0, $hhMVP.getCachedIsCompactValue)(key);
    // in case there is no state change triggered
    if (defaultState === undefined) {
        defaultState = (0, $7093eea63dce9286$export$ee15e0cd1efafcb4);
        (0, $hhMVP.setCachedIsCompactValue)(defaultState, key);
    }
    const { isInSidePanelExperiment: isInSidePanelExperiment } = (0, $k1L82.useIssueLayoutActivitySidePanel)();
    const query = isInSidePanelExperiment ? $db79d17d45755de5$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY_SIDE_PANEL : $db79d17d45755de5$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY;
    const [isCompact, setIsCompact] = (0, $5uXOq.useState)(defaultState);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($db79d17d45755de5$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8kj45.ContainerQueryObserver), {
        query: query,
        onChange: (state)=>{
            (0, $hhMVP.setCachedIsCompactValue)(state, key);
            setIsCompact(state);
        },
        defaultState: defaultState
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($db79d17d45755de5$var$Provider, {
        value: isCompact
    }, children));
};
const $db79d17d45755de5$export$20feb77b5b617e44 = $db79d17d45755de5$var$Consumer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $db79d17d45755de5$var$StyledWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
const $7093eea63dce9286$export$ee15e0cd1efafcb4 = false;

parcelRegister("8kj45", function(module, exports) {

$parcel$export(module.exports, "ContainerQueryObserver", () => $ed10e3c030ea0408$export$e9574287678b8467);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

const $ed10e3c030ea0408$var$QueryContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
let $ed10e3c030ea0408$var$currentIdSeed = 0;
function $ed10e3c030ea0408$var$generateAttributeValue() {
    return `indicator-span-${$ed10e3c030ea0408$var$currentIdSeed++}`;
}
function $ed10e3c030ea0408$export$e9574287678b8467({ children: children, query: query, onChange: onChange, defaultState: defaultState = (0, $7093eea63dce9286$export$ee15e0cd1efafcb4) }) {
    const [active, setActive] = (0, $5uXOq.useState)(defaultState);
    const handleQueryStatusChange = (0, $5uXOq.useCallback)((isContainerQueryActive)=>{
        onChange?.(isContainerQueryActive);
        setActive(isContainerQueryActive);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed10e3c030ea0408$var$QueryContext.Provider, {
        value: active
    }, !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed10e3c030ea0408$var$IntersectionIndicator, {
        query: query,
        notifyIntersectionStatusChanged: handleQueryStatusChange
    }), children);
}
function $ed10e3c030ea0408$export$b66a67697973e01() {
    const currentState = (0, $5uXOq.useContext)($ed10e3c030ea0408$var$QueryContext);
    if (currentState === undefined) throw new Error('The component must be wrapped in a ContainerQueryObserver to use useContainerQueryState');
    return currentState;
}
function $ed10e3c030ea0408$var$IntersectionIndicator({ notifyIntersectionStatusChanged: handleChange, query: query }) {
    const attributeValue = (0, $5uXOq.useMemo)(()=>$ed10e3c030ea0408$var$generateAttributeValue(), []);
    const spanRef = (0, $5uXOq.useRef)(null);
    const containerRef = (0, $5uXOq.useRef)(null);
    const currentState = $ed10e3c030ea0408$export$b66a67697973e01();
    (0, $5uXOq.useLayoutEffect)(()=>{
        const queryStatusChangedCallback = (entries)=>{
            // This means that the parent container is either empty or loading, we should not notify of any change in this case.
            if (!containerRef.current || containerRef.current.clientWidth === 0) return;
            if (entries.length > 0) {
                // only ever going to be one entry max
                const isContainerQueryActive = entries[0].isIntersecting;
                if (isContainerQueryActive !== currentState) handleChange(isContainerQueryActive);
            }
        };
        const intersectionObserver = new IntersectionObserver(queryStatusChangedCallback);
        const spanElement = spanRef.current;
        spanElement && intersectionObserver.observe(spanElement);
        return ()=>{
            spanElement && intersectionObserver.unobserve(spanElement);
            intersectionObserver.disconnect();
        };
    }, [
        currentState,
        handleChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed10e3c030ea0408$var$ContainerToBeQueried, {
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("style", {
        type: "text/css"
    }, `
                    [data-container-query-indicator-id="${attributeValue}"] {
                        display: none;
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100vh;
                        pointer-events: none;
                    }
                    @container ${query} {
                        [data-container-query-indicator-id="${attributeValue}"] {
                            display: inherit;
                        }
                    }`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        ref: spanRef,
        "data-container-query-indicator-id": attributeValue
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ed10e3c030ea0408$var$ContainerToBeQueried = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqsw1if8 _lcxvglyw _154iidpf _7ccakre2",
            __cmplp.className
        ])
    });
});

});

parcelRegister("k1L82", function(module, exports) {

$parcel$export(module.exports, "useIssueLayoutContainers", () => $725285d3420dc4d6$export$d146dfa0384f99a3);
$parcel$export(module.exports, "useLayoutContainerByType", () => $725285d3420dc4d6$export$5f49a43487b268);
$parcel$export(module.exports, "useIssueLayoutGlance", () => $725285d3420dc4d6$export$fd7f0cc3d2b405e6);
$parcel$export(module.exports, "useIssueLayoutContextPanel", () => $725285d3420dc4d6$export$5962da0433486667);
$parcel$export(module.exports, "useIssueLayoutActivitySidePanel", () => $725285d3420dc4d6$export$8105ff1c0f6ac8a9);
$parcel$export(module.exports, "useIssueLayoutActions", () => $725285d3420dc4d6$export$1e5e9fc877a47cd9);

var $5uXOq = parcelRequire("5uXOq");

var $egBua = parcelRequire("egBua");

var $6s1PB = parcelRequire("6s1PB");

var $eNNkf = parcelRequire("eNNkf");

var $2gCtH = parcelRequire("2gCtH");


var $93Yeu = parcelRequire("93Yeu");

var $2vSU6 = parcelRequire("2vSU6");

var $2YZCu = parcelRequire("2YZCu");

var $4R6GH = parcelRequire("4R6GH");

var $bCdIp = parcelRequire("bCdIp");

var $kI4MM = parcelRequire("kI4MM");

var $cNJ33 = parcelRequire("cNJ33");
const $725285d3420dc4d6$export$d146dfa0384f99a3 = (issueKey)=>{
    const [containers] = (0, $kI4MM.useIssueLayoutContainersStore)(issueKey);
    return [
        containers
    ];
};
const $725285d3420dc4d6$export$5f49a43487b268 = (issueKey, type)=>{
    const [containers] = (0, $kI4MM.useIssueLayoutContainersStore)(issueKey);
    const container = containers.find((innerContainer)=>innerContainer.containerType === type);
    // Forge app with UI Modifications module can hide selected fields using
    // UI modifications Field API. We are removing them here from the layout fields
    const fieldsHiddenByUim = (0, $egBua.useEnabledHiddenFields)();
    return [
        (0, $cNJ33.filterOutItemsWithProvidedIds)(container?.items.nodes ?? [], fieldsHiddenByUim)
    ];
};
const $725285d3420dc4d6$export$fd7f0cc3d2b405e6 = (issueKey)=>{
    const [glance] = (0, $kI4MM.useIssueLayoutGlanceStore)(issueKey);
    return [
        glance
    ];
};
const $725285d3420dc4d6$export$5962da0433486667 = (issueKey)=>{
    const [contextPanel] = (0, $kI4MM.useIssueLayoutContextPanelStore)(issueKey);
    return [
        contextPanel
    ];
};
const $725285d3420dc4d6$export$8105ff1c0f6ac8a9 = ()=>{
    try {
        /* eslint-disable react-hooks/rules-of-hooks */ if (!(0, $4R6GH.fg)('issue-view-side-panel-activity-kill-switch')) return {
            isActivityInVerticalSidePanel: false,
            isInSidePanelExperiment: false,
            activityLayoutView: null
        };
        // Get required values
        const isFullIssueView = (0, $2gCtH.useIsFullPageIssueView)();
        const [activityLayoutView] = (0, $eNNkf.useUserPreferencesValue)((0, $31848aa9a0db89de$export$2cf981c493d79a21));
        const issueKey = (0, $2gCtH.useIssueKey)();
        const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
        const projectType = (0, $93Yeu.useProjectType)(projectKey);
        const isMobile = (0, $bCdIp.default)();
        /* eslint-enable react-hooks/rules-of-hooks */ const isJiraIssue = projectType === (0, $2vSU6.SOFTWARE_PROJECT) || projectType === (0, $2vSU6.CORE_PROJECT);
        // Determine if in experiment condition based on project type, view and inline experiment evaluation
        const isInSidePanelExperiment = !isMobile && isJiraIssue && isFullIssueView && (0, $6s1PB.expVal)('issue-view-side-panel-activity', 'isActivityInSidePanel', false);
        // Compute final values directly
        const isActivityInVerticalSidePanel = isInSidePanelExperiment && activityLayoutView === 'VERTICAL';
        // Return object with named properties
        return {
            isActivityInVerticalSidePanel: Boolean(isActivityInVerticalSidePanel),
            isInSidePanelExperiment: Boolean(isInSidePanelExperiment),
            activityLayoutView: activityLayoutView
        };
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('issue-view-layout.services.main', `Error in useIssueLayoutActivitySidePanel : ${error}`);
        return {
            isActivityInVerticalSidePanel: false,
            isInSidePanelExperiment: false,
            activityLayoutView: null
        };
    }
};
const $725285d3420dc4d6$export$1e5e9fc877a47cd9 = ()=>{
    const [, actions] = (0, $kI4MM.useIssueLayoutActionsStore)();
    const setIssueViewContainersLayout = (0, $5uXOq.useCallback)((issueKey, containersByType)=>{
        actions.setIssueViewContainersLayout(issueKey, containersByType);
    }, [
        actions
    ]);
    const setIssueViewLayoutGlance = (0, $5uXOq.useCallback)((issueKey, glance)=>{
        actions.setIssueViewLayoutGlance(issueKey, glance);
    }, [
        actions
    ]);
    const setIssueViewLayoutContextPanel = (0, $5uXOq.useCallback)((issueKey, newContextPanel)=>{
        actions.setIssueViewLayoutContextPanel(issueKey, newContextPanel);
    }, [
        actions
    ]);
    return [
        null,
        {
            setIssueViewContainersLayout: setIssueViewContainersLayout,
            setIssueViewLayoutGlance: setIssueViewLayoutGlance,
            setIssueViewLayoutContextPanel: setIssueViewLayoutContextPanel
        }
    ];
};

});
parcelRegister("egBua", function(module, exports) {

$parcel$export(module.exports, "useEnabledHiddenFields", () => $ea65d07999c73532$export$bb6c2b9159c3f32b);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $jrwZp = parcelRequire("jrwZp");

var $eoznE = parcelRequire("eoznE");
const $ea65d07999c73532$export$bb6c2b9159c3f32b = ()=>{
    (0, $gKZoD.di)((0, $jrwZp.useAdjustmentsEnabled), (0, $eoznE.useHiddenFields));
    const adjustmentsAreEnabled = (0, $jrwZp.useAdjustmentsEnabled)();
    const hiddenFields = (0, $eoznE.useHiddenFields)();
    return (0, $5uXOq.useMemo)(()=>{
        if (!adjustmentsAreEnabled) return [];
        return hiddenFields;
    }, [
        adjustmentsAreEnabled,
        hiddenFields
    ]);
};

});
parcelRegister("jrwZp", function(module, exports) {

$parcel$export(module.exports, "store", () => $db4845f733e81d44$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustmentsEnabled", () => $db4845f733e81d44$export$358ad850b2f6d6fe);
$parcel$export(module.exports, "useAdjustmentsContextActions", () => $db4845f733e81d44$export$4f2729981f4b81d2);
$parcel$export(module.exports, "UiModificationContextContainer", () => $db4845f733e81d44$export$5eb9c167b683d125);

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
const $db4845f733e81d44$var$initialState = {
    shouldUiModificationsLoad: 'unknown',
    hasFinishedLoading: false,
    adjustmentsAreEnabled: false,
    uiModificationsConsentStatus: {}
};
const $db4845f733e81d44$export$e324594224ef24da = {
    resetAdjustmentContext: ()=>({ setState: setState })=>{
            setState($db4845f733e81d44$var$initialState);
        },
    setShouldUiModificationsLoad: (status)=>({ setState: setState })=>{
            setState({
                shouldUiModificationsLoad: status
            });
        },
    setHasFinishedLoading: (hasFinishedLoading)=>({ setState: setState })=>{
            setState({
                hasFinishedLoading: hasFinishedLoading
            });
        },
    setAdjustmentsAreEnabled: (enabled)=>({ setState: setState })=>{
            setState({
                adjustmentsAreEnabled: enabled
            });
        },
    setUIModificationsConsentStatus: ({ appId: appId, status: status })=>({ setState: setState, getState: getState })=>{
            const currentConsentState = getState().uiModificationsConsentStatus;
            setState({
                uiModificationsConsentStatus: {
                    ...currentConsentState,
                    [appId]: status
                }
            });
        }
};
const $db4845f733e81d44$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'issue-adjustments-context',
    initialState: $db4845f733e81d44$var$initialState,
    actions: $db4845f733e81d44$export$e324594224ef24da
});
const $db4845f733e81d44$export$a12f82a132dee079 = (0, $3sQ5x.createHook)($db4845f733e81d44$export$6f57813fe9f31bf9);
const $db4845f733e81d44$export$358ad850b2f6d6fe = (0, $3sQ5x.createStateHook)($db4845f733e81d44$export$6f57813fe9f31bf9, {
    selector: (state)=>state.adjustmentsAreEnabled
});
const $db4845f733e81d44$export$4f2729981f4b81d2 = (0, $3sQ5x.createActionsHook)($db4845f733e81d44$export$6f57813fe9f31bf9);
const $db4845f733e81d44$export$5eb9c167b683d125 = (0, $gg7kZ.createContainer)($db4845f733e81d44$export$6f57813fe9f31bf9, {
    displayName: 'UiModificationContextContainer'
});

});

parcelRegister("eoznE", function(module, exports) {

$parcel$export(module.exports, "useHiddenFields", () => $8c7bafd209de1659$export$de6fdc67c945e596);

var $6dDSs = parcelRequire("6dDSs");
var $3sQ5x = parcelRequire("3sQ5x");

var $1YewZ = parcelRequire("1YewZ");
const $8c7bafd209de1659$var$selectHiddenFields = (0, $6dDSs.createSelector)((state)=>state.formData, (state)=>state.appliedChanges, (formData, appliedChanges)=>{
    if (formData === null) return [];
    return Object.entries(formData).filter(([fieldId, field])=>appliedChanges?.[fieldId]?.isVisible !== undefined ? !appliedChanges[fieldId].isVisible : !field.isVisible).map(([fieldId])=>fieldId);
});
const $8c7bafd209de1659$export$de6fdc67c945e596 = (0, $3sQ5x.createStateHook)((0, $1YewZ.store), {
    selector: $8c7bafd209de1659$var$selectHiddenFields
});

});
parcelRegister("1YewZ", function(module, exports) {

$parcel$export(module.exports, "store", () => $cf6a6312e4141eb7$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustedField", () => $cf6a6312e4141eb7$export$df4b0714e8177e0e);
$parcel$export(module.exports, "useIssueAdjustmentsActions", () => $cf6a6312e4141eb7$export$cb9a014ec14556d8);
$parcel$export(module.exports, "useAdjustedScreenTabs", () => $cf6a6312e4141eb7$export$677b3e34bd14c681);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $3whHg = parcelRequire("3whHg");

var $hyCnL = parcelRequire("hyCnL");

var $boEP0 = parcelRequire("boEP0");

var $2NMWZ = parcelRequire("2NMWZ");

var $d30F5 = parcelRequire("d30F5");

var $8e24q = parcelRequire("8e24q");

var $cTj8m = parcelRequire("cTj8m");

var $i4uue = parcelRequire("i4uue");

var $3iUv8 = parcelRequire("3iUv8");

var $b8ZsE = parcelRequire("b8ZsE");

var $jDMtG = parcelRequire("jDMtG");

var $l0b2q = parcelRequire("l0b2q");

var $4MJXd = parcelRequire("4MJXd");

var $gHQFd = parcelRequire("gHQFd");

var $7JtDe = parcelRequire("7JtDe");
const $cf6a6312e4141eb7$var$name = 'issue-adjustments';
const $cf6a6312e4141eb7$export$d4c72bab9d6cc13a = {
    formData: null,
    screenTabs: null,
    appliedChanges: null,
    error: null,
    registeredFieldsDeprecated: {},
    registeredFields: {},
    triggerFieldInitializationKey: 0,
    // Selector checks if this is not equal 0 in the useFieldReady
    numberOfSupportedFields: 0,
    internalFormMetadata: {},
    viewType: null,
    experienceDataIsLoading: false,
    lastProcessedChange: null,
    fieldsInitialization: {
        startTime: null,
        timeoutId: undefined,
        status: 'notStarted'
    },
    appliedChangesHistory: {},
    appsErrors: {},
    notification: null
};
// triggerFieldInitializationKey, viewType and numberOfSupportedFields should not be reset on project or issue type change
const { triggerFieldInitializationKey: $cf6a6312e4141eb7$var$triggerFieldInitializationKey, viewType: $cf6a6312e4141eb7$var$scopedViewType, numberOfSupportedFields: $cf6a6312e4141eb7$var$numberOfSupportedFields, ...$cf6a6312e4141eb7$var$stateForResetAllFields } = $cf6a6312e4141eb7$export$d4c72bab9d6cc13a;
const $cf6a6312e4141eb7$export$e324594224ef24da = {
    triggerFieldInitialization: ()=>({ getState: getState, setState: setState })=>{
            setState({
                triggerFieldInitializationKey: getState().triggerFieldInitializationKey + 1
            });
        },
    processChange: $b8ZsE.processChange,
    setFieldValue: $l0b2q.setFieldValue,
    initializeField: $8e24q.initializeField,
    initializeFields: $8e24q.initializeFields,
    startFieldsInitialisationTimeout: $d30F5.startFieldsInitialisationTimeout,
    successFieldsInitalisation: $d30F5.successFieldsInitalisation,
    registerFields: $jDMtG.registerFields,
    unregisterFields: $jDMtG.unregisterFields,
    updateFields: $gHQFd.updateFields,
    clearAppliedValue: (fieldId)=>({ setState: setState, getState: getState })=>{
            const previousState = getState().appliedChanges || {};
            if (previousState[fieldId]) {
                const { value: value, ...otherFieldChanges } = previousState[fieldId];
                setState({
                    appliedChanges: {
                        ...previousState,
                        [fieldId]: otherFieldChanges
                    }
                });
            }
        },
    resetAllFields: ()=>({ setState: setState, getState: getState })=>{
            // Clear the fieldsInitialization timeout to avoid potetianl side effects.
            clearTimeout(getState().fieldsInitialization.timeoutId);
            setState($cf6a6312e4141eb7$var$stateForResetAllFields);
        },
    setError: $2NMWZ.setError,
    resetError: $2NMWZ.resetError,
    setNumberOfSupportedFields: (numberOfAllSupportedFields)=>({ setState: setState })=>{
            setState({
                numberOfSupportedFields: numberOfAllSupportedFields
            });
        },
    /**
	 * This is used to block onInit for specific case like Issue View background refresh loading.
	 */ setExperienceDataIsLoading: (experienceDataIsLoading)=>({ setState: setState })=>{
            setState({
                experienceDataIsLoading: experienceDataIsLoading
            });
        },
    setAppErrors: $3whHg.setAppErrors,
    resetAppErrors: $3whHg.resetAppErrors,
    addAppsErrors: $3whHg.addAppsErrors,
    initializeNoScreenTab: $cTj8m.initializeNoScreenTab,
    initializeScreenTabs: $i4uue.initializeScreenTabs,
    updateScreenTabs: $7JtDe.updateScreenTabs,
    updateActiveScreenTab: $4MJXd.updateActiveScreenTab,
    detectAppliedChangesConflicts: $hyCnL.detectAppliedChangesConflicts,
    collectScreenTabsAppliedChangesHistory: $boEP0.collectScreenTabsAppliedChangesHistory,
    collectFieldsAppliedChangesHistory: $boEP0.collectFieldsAppliedChangesHistory,
    setNotification: $3iUv8.setNotification,
    resetNotification: $3iUv8.resetNotification
};
const $cf6a6312e4141eb7$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: $cf6a6312e4141eb7$var$name,
    initialState: $cf6a6312e4141eb7$export$d4c72bab9d6cc13a,
    actions: $cf6a6312e4141eb7$export$e324594224ef24da
});
const $cf6a6312e4141eb7$export$37792a602e748c08 = (0, $3sQ5x.createHook)($cf6a6312e4141eb7$export$6f57813fe9f31bf9);
const $cf6a6312e4141eb7$var$stableEmptyFieldFromIframe = {};
const $cf6a6312e4141eb7$export$c76e674a29843e21 = (0, $3sQ5x.createHook)($cf6a6312e4141eb7$export$6f57813fe9f31bf9, {
    selector: (state)=>state.appliedChanges
});
const $cf6a6312e4141eb7$export$df4b0714e8177e0e = (0, $3sQ5x.createHook)($cf6a6312e4141eb7$export$6f57813fe9f31bf9, {
    selector: (state, fieldId)=>state.appliedChanges?.[fieldId] || $cf6a6312e4141eb7$var$stableEmptyFieldFromIframe
});
const $cf6a6312e4141eb7$export$cb9a014ec14556d8 = (0, $3sQ5x.createActionsHook)($cf6a6312e4141eb7$export$6f57813fe9f31bf9);
const $cf6a6312e4141eb7$export$677b3e34bd14c681 = (0, $3sQ5x.createHook)($cf6a6312e4141eb7$export$6f57813fe9f31bf9, {
    selector: (state)=>state.screenTabs
});

});
parcelRegister("3whHg", function(module, exports) {

$parcel$export(module.exports, "setAppErrors", () => $87bccf3deeafaa75$export$7054e2f8e68cf0dd);
$parcel$export(module.exports, "addAppsErrors", () => $87bccf3deeafaa75$export$903d525e420c7d00);
$parcel$export(module.exports, "resetAppErrors", () => $87bccf3deeafaa75$export$24c821207687a907);
const $87bccf3deeafaa75$export$7054e2f8e68cf0dd = ({ errors: errors, appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: errors
            }
        });
    };
const $87bccf3deeafaa75$export$903d525e420c7d00 = ({ errors: errors })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        const appsErrors = Object.entries(errors).reduce((acc, [appId, appErrors])=>{
            acc[appId] = [
                ...acc[appId] ?? [],
                ...appErrors
            ];
            return acc;
        }, {
            ...previousState
        });
        setState({
            appsErrors: appsErrors
        });
    };
const $87bccf3deeafaa75$export$24c821207687a907 = ({ appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: null
            }
        });
    };

});

parcelRegister("hyCnL", function(module, exports) {

$parcel$export(module.exports, "detectAppliedChangesConflicts", () => $4c0b86f075c0ff6b$export$90d94f20d157e756);

var $gKZoD = parcelRequire("gKZoD");

var $2jyqu = parcelRequire("2jyqu");


var $3whHg = parcelRequire("3whHg");

var $3iUv8 = parcelRequire("3iUv8");

var $lLAXK = parcelRequire("lLAXK");
const $4c0b86f075c0ff6b$var$HISTORY_LOG_TTL = 60000;
/**
 * Tidies up applied changes history by removing old entries by TTL.
 * It keeps the current changeId in history.
 */ const $4c0b86f075c0ff6b$var$tidyUpAppliedChangesHistory = (appliedChangesHistory, changeId)=>Object.fromEntries(Object.entries(appliedChangesHistory).filter(([existingChangeId, history])=>{
        return Date.now() - history.createdAt <= $4c0b86f075c0ff6b$var$HISTORY_LOG_TTL || existingChangeId === changeId;
    }));
const $4c0b86f075c0ff6b$export$90d94f20d157e756 = ({ appId: appId, changeId: changeId })=>({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
        (0, $gKZoD.di)((0, $2jyqu.fireOperationalEvent));
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        const tidyAppliedChangesHistory = $4c0b86f075c0ff6b$var$tidyUpAppliedChangesHistory(appliedChangesHistory, changeId);
        setState({
            appliedChangesHistory: tidyAppliedChangesHistory
        });
        const appliedChangesHistoryChangeId = tidyAppliedChangesHistory[changeId];
        const newChanges = appliedChangesHistoryChangeId?.apps[appId];
        if (!appliedChangesHistoryChangeId || !newChanges || // No need to run conflicts checks for the first item in history
        Object.keys(appliedChangesHistoryChangeId.apps).length <= 1) return;
        const lifecycleHook = changeId === (0, $19ec31e354320eb2$export$415cc1afa6445f90) ? 'onInit' : 'onChange';
        const { appErrorsMap: appErrorsMap, conflicts: conflicts } = (0, $lLAXK.collectConflicts)({
            appliedChangesHistory: appliedChangesHistoryChangeId.apps,
            newChanges: newChanges,
            appIdOfNewChanges: appId,
            lifecycleHook: lifecycleHook
        });
        if (conflicts.length) {
            (0, $2jyqu.fireOperationalEvent)(createAnalyticsEvent, {
                action: 'conflicted',
                actionSubject: 'jiraUiModifications.appliedChangesHistory',
                attributes: {
                    conflictsCount: conflicts.length,
                    conflicts: conflicts,
                    conflictedApps: Object.keys(appErrorsMap),
                    viewType: viewType
                }
            });
            dispatch((0, $3whHg.addAppsErrors)({
                errors: appErrorsMap
            }));
            dispatch((0, $3iUv8.setNotification)({
                type: 'MULTIPLE_APPS_CONFLICTS'
            }));
        }
    };

});
parcelRegister("2jyqu", function(module, exports) {

$parcel$export(module.exports, "fireOperationalEvent", () => $9253211b05747618$export$a1fb57756f0de62b);

var $gB4mS = parcelRequire("gB4mS");


const $9253211b05747618$export$a1fb57756f0de62b = (createAnalyticsEvent, eventPayload)=>{
    (0, $gB4mS.default)((0, $aded369bac156944$export$8280e5c6104c5b40))({
        ...eventPayload,
        analyticsType: (0, $6e65040b988c460f$export$12346a674644c156)
    })(createAnalyticsEvent);
};

});
const $6e65040b988c460f$export$f636b5b56f1d624a = 'Screen';
const $6e65040b988c460f$export$9d2de6eebf7462b5 = 'Drawer';
const $6e65040b988c460f$export$1171103ea9083ffa = 'Modal';
const $6e65040b988c460f$export$cae2783c9279926 = 'InlineDialog';
const $6e65040b988c460f$export$d1123261ca8831d2 = 'Dropdown';
const $6e65040b988c460f$export$a1562d08625f5d7e = 'UI';
const $6e65040b988c460f$export$947dac6c72b26f81 = 'TRACK';
const $6e65040b988c460f$export$f1d537d508d2945a = 'SCREEN';
const $6e65040b988c460f$export$12346a674644c156 = 'OPERATIONAL';
const $6e65040b988c460f$export$2ceccf177fae277c = 'analyticsBridge';

const $aded369bac156944$export$8280e5c6104c5b40 = 'ui-modifications';


const $19ec31e354320eb2$export$415cc1afa6445f90 = 'onInitChangeId';
const $19ec31e354320eb2$export$811b7f067a43b422 = 'jira:uiModifications';

parcelRegister("3iUv8", function(module, exports) {

$parcel$export(module.exports, "setNotification", () => $547ed651019edc98$export$b9c5e783593ff01d);
$parcel$export(module.exports, "resetNotification", () => $547ed651019edc98$export$caafa3945f199bc7);
const $547ed651019edc98$export$b9c5e783593ff01d = (notificationProperties)=>({ setState: setState })=>{
        setState({
            notification: {
                type: notificationProperties.type
            }
        });
    };
const $547ed651019edc98$export$caafa3945f199bc7 = ()=>({ setState: setState })=>{
        setState({
            notification: null
        });
    };

});

parcelRegister("lLAXK", function(module, exports) {

$parcel$export(module.exports, "collectConflicts", () => $5d47c6c300e4a9ca$export$a06103ec99e4e394);

var $fr1K2 = parcelRequire("fr1K2");


var $bCvSM = parcelRequire("bCvSM");

const $5d47c6c300e4a9ca$var$MESSAGE_SUFFIX = 'Modifications have been applied, but it may lead to inconsistency for the user.';
const $5d47c6c300e4a9ca$var$mapToAppErrors = ({ conflicts: conflicts, lifecycleHook: lifecycleHook })=>{
    const appErrors = conflicts.map((change)=>{
        if (change.type === (0, $78805f0b93715186$export$f674b7a3bbd94b5)) return {
            type: (0, $ca611ff348f89182$export$2a3fdceaae2188d5),
            cause: (0, $ca611ff348f89182$export$877da1000325f8b5),
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified screen tabs in the '${lifecycleHook}' at the same trigger. ${$5d47c6c300e4a9ca$var$MESSAGE_SUFFIX}`
        };
        const { fieldId: fieldId, fieldType: fieldType, property: property } = change;
        const method = (0, $bCvSM.mapFieldPropertyToApiMethod)(property);
        return {
            type: (0, $ca611ff348f89182$export$2a3fdceaae2188d5),
            cause: (0, $ca611ff348f89182$export$e4ac32edd5da2ee7),
            fieldId: fieldId,
            fieldType: fieldType,
            method: method,
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified the same field: '${fieldId}' by its method: '${method}' in the '${lifecycleHook}' at the same trigger. ${$5d47c6c300e4a9ca$var$MESSAGE_SUFFIX}`
        };
    });
    return appErrors;
};
const $5d47c6c300e4a9ca$export$a06103ec99e4e394 = ({ appliedChangesHistory: appliedChangesHistory, newChanges: newChanges, appIdOfNewChanges: appIdOfNewChanges, lifecycleHook: lifecycleHook })=>{
    return Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(appliedChangesHistory, appIdOfNewChanges)).reduce((acc, [appId, previousChanges])=>{
        const previousChangesKeys = Object.keys(previousChanges);
        // Compares previous changes with new changes keys
        const conflicts = Object.entries(newChanges).filter(([changeKey, _])=>previousChangesKeys.includes(changeKey)).map(([_, change])=>({
                ...change,
                lifecycleHook: lifecycleHook,
                appIds: [
                    appId,
                    appIdOfNewChanges
                ]
            }));
        acc.conflicts.push(...conflicts);
        // Maps conflicts to app errors
        const appErrors = $5d47c6c300e4a9ca$var$mapToAppErrors({
            conflicts: conflicts,
            lifecycleHook: lifecycleHook
        });
        if (appErrors.length > 0) {
            acc.appErrorsMap[appId] = appErrors;
            // App errors for `appIdOfNewChanges` may already exists from the previous iteration.
            // We need to merge them to avoid overwriting and keep all errors.
            acc.appErrorsMap[appIdOfNewChanges] = [
                ...acc.appErrorsMap[appIdOfNewChanges] ?? [],
                ...appErrors
            ];
        }
        return acc;
    }, {
        appErrorsMap: {},
        conflicts: []
    });
};

});
const $ca611ff348f89182$export$fd26696d109785a0 = 'SCREENTABS_VALIDATION_FAILED';
const $ca611ff348f89182$export$d1996cb46a690190 = 'FIELD_VALIDATION_FAILED';
const $ca611ff348f89182$export$8042247b663edbcc = 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD';
const $ca611ff348f89182$export$2a3fdceaae2188d5 = 'MULTIPLE_APPS_CONFLICT';
const $ca611ff348f89182$export$e4ac32edd5da2ee7 = 'FIELD';
const $ca611ff348f89182$export$877da1000325f8b5 = 'SCREENTABS';

parcelRegister("bCvSM", function(module, exports) {

$parcel$export(module.exports, "mapFieldPropertyToApiMethod", () => $b1dea33557091402$export$e1cc7da28a1c4bb7);
const $b1dea33557091402$var$SET_NAME_METHOD = 'setName';
const $b1dea33557091402$var$SET_DESCRIPTION_METHOD = 'setDescription';
const $b1dea33557091402$var$SET_VISIBLE_METHOD = 'setVisible';
const $b1dea33557091402$var$SET_READ_ONLY_METHOD = 'setReadOnly';
const $b1dea33557091402$var$SET_VALUE_METHOD = 'setValue';
const $b1dea33557091402$var$SET_REQUIRED_METHOD = 'setRequired';
const $b1dea33557091402$var$SET_OPTIONS_VISIBILITY_METHOD = 'setOptionsVisibility';
const $b1dea33557091402$export$8325709d137b2606 = {
    fieldName: $b1dea33557091402$var$SET_NAME_METHOD,
    description: $b1dea33557091402$var$SET_DESCRIPTION_METHOD,
    isVisible: $b1dea33557091402$var$SET_VISIBLE_METHOD,
    isReadOnly: $b1dea33557091402$var$SET_READ_ONLY_METHOD,
    value: $b1dea33557091402$var$SET_VALUE_METHOD,
    isRequired: $b1dea33557091402$var$SET_REQUIRED_METHOD,
    optionsVisibility: $b1dea33557091402$var$SET_OPTIONS_VISIBILITY_METHOD
};
const $b1dea33557091402$export$e1cc7da28a1c4bb7 = (fieldProperty)=>{
    const method = $b1dea33557091402$export$8325709d137b2606[fieldProperty];
    if (!method) throw new Error(`No method found for field property: ${fieldProperty}`);
    return method;
};

});

const $78805f0b93715186$export$f674b7a3bbd94b5 = 'SCREEN_TABS';
const $78805f0b93715186$export$4a9f236a0db33834 = 'FIELD';



parcelRegister("boEP0", function(module, exports) {

$parcel$export(module.exports, "collectScreenTabsAppliedChangesHistory", () => $f5288ff27f25fb7e$export$1d2b7abeeea36239);
$parcel$export(module.exports, "collectFieldsAppliedChangesHistory", () => $f5288ff27f25fb7e$export$7d0f534e5b16dcc9);


var $3vp6H = parcelRequire("3vp6H");
const $f5288ff27f25fb7e$var$prepareAppliedChangesHistoryForSingleChange = ({ currentAppliedChangesHistory: currentAppliedChangesHistory, appId: appId, changeId: changeId, newSingleAppChange: newSingleAppChange })=>{
    const appliedChangesHistoryChangeId = currentAppliedChangesHistory[changeId] ?? {};
    const appliedChangesHistoryChangeIdApp = appliedChangesHistoryChangeId.apps?.[appId] ?? {};
    return {
        ...currentAppliedChangesHistory,
        [changeId]: {
            apps: {
                ...appliedChangesHistoryChangeId.apps,
                [appId]: {
                    ...appliedChangesHistoryChangeIdApp,
                    ...newSingleAppChange
                }
            },
            createdAt: appliedChangesHistoryChangeId.createdAt ?? Date.now()
        }
    };
};
const $f5288ff27f25fb7e$export$1d2b7abeeea36239 = ({ appId: appId, changeId: changeId, screenTabs: screenTabs })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        if (!screenTabs.length) return;
        const newAppliedChangesHistory = $f5288ff27f25fb7e$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: {
                tabs: {
                    type: (0, $78805f0b93715186$export$f674b7a3bbd94b5)
                }
            }
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };
const $f5288ff27f25fb7e$export$7d0f534e5b16dcc9 = ({ appId: appId, changeId: changeId, fieldsChanges: fieldsChanges })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory, internalFormMetadata: internalFormMetadata } = getState();
        const singleAppChange = (0, $3vp6H.normalizeFieldsAppliedChangesForHistory)({
            fieldsChanges: fieldsChanges,
            internalFormMetadata: internalFormMetadata
        });
        const newAppliedChangesHistory = $f5288ff27f25fb7e$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: singleAppChange
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };

});
parcelRegister("3vp6H", function(module, exports) {

$parcel$export(module.exports, "normalizeFieldsAppliedChangesForHistory", () => $23bcfa1804fc8fad$export$8a23b3e9a1749620);

const $23bcfa1804fc8fad$var$normalizeFieldForHistory = (fieldId, fieldChanges, fieldMetadata)=>{
    // Can't type Object.keys in a better way
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(fieldChanges).reduce((acc, property)=>{
        const normalizedKey = `${fieldId}|${property}`;
        acc[normalizedKey] = {
            fieldId: fieldId,
            fieldType: fieldMetadata.fieldType,
            property: property,
            type: (0, $78805f0b93715186$export$4a9f236a0db33834)
        };
        return acc;
    }, {});
};
const $23bcfa1804fc8fad$export$8a23b3e9a1749620 = ({ fieldsChanges: fieldsChanges, internalFormMetadata: internalFormMetadata })=>{
    return Object.entries(fieldsChanges).reduce((acc, [fieldId, fieldChanges])=>{
        const fieldMetadata = internalFormMetadata[fieldId];
        if (!fieldMetadata) return acc;
        const normalizedFieldHistory = $23bcfa1804fc8fad$var$normalizeFieldForHistory(fieldId, fieldChanges, fieldMetadata);
        Object.assign(acc, normalizedFieldHistory);
        return acc;
    }, {});
};

});


parcelRegister("2NMWZ", function(module, exports) {

$parcel$export(module.exports, "setError", () => $13e2b126ca97f7fe$export$b8d0bb2aa0adefe5);
$parcel$export(module.exports, "resetError", () => $13e2b126ca97f7fe$export$7e5930c6217b1d4e);
const $13e2b126ca97f7fe$export$b8d0bb2aa0adefe5 = (errorProperties)=>({ setState: setState })=>{
        setState({
            error: {
                errorCode: errorProperties.errorCode,
                fieldName: errorProperties.fieldName
            }
        });
    };
const $13e2b126ca97f7fe$export$7e5930c6217b1d4e = ()=>({ setState: setState })=>{
        setState({
            error: null
        });
    };

});

parcelRegister("d30F5", function(module, exports) {

$parcel$export(module.exports, "startFieldsInitialisationTimeout", () => $e08f4de833312075$export$2c0f020b89dfa30b);
$parcel$export(module.exports, "successFieldsInitalisation", () => $e08f4de833312075$export$cf768a695e83eefa);

var $gKZoD = parcelRequire("gKZoD");

var $2jyqu = parcelRequire("2jyqu");

var $1FDIy = parcelRequire("1FDIy");

var $2NMWZ = parcelRequire("2NMWZ");
const $e08f4de833312075$var$getTimeout = ()=>50000;
const $e08f4de833312075$var$getFieldsInitializationTime = (startTime)=>startTime !== null ? performance.now() - startTime : null;
const $e08f4de833312075$var$isFieldInitialisationComplete = (status)=>status === 'success' || status === 'timedOut';
const $e08f4de833312075$export$2c0f020b89dfa30b = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { fieldsInitialization: fieldsInitialization } = getState();
        if (fieldsInitialization.timeoutId === undefined && fieldsInitialization.status === 'notStarted') {
            const timeoutId = setTimeout(()=>dispatch($e08f4de833312075$export$8ce83a9201590a5e({
                    createAnalyticsEvent: createAnalyticsEvent
                })), $e08f4de833312075$var$getTimeout());
            setState({
                fieldsInitialization: {
                    startTime: performance.now(),
                    timeoutId: timeoutId,
                    status: 'inProgress'
                }
            });
        }
    };
const $e08f4de833312075$export$8ce83a9201590a5e = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState, dispatch: dispatch }, { viewType: viewType })=>{
        (0, $gKZoD.di)((0, $2jyqu.fireOperationalEvent));
        const { formData: formData, experienceDataIsLoading: experienceDataIsLoading, numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { startTime: startTime, status: status } = fieldsInitialization;
        if ($e08f4de833312075$var$isFieldInitialisationComplete(status) || (0, $1FDIy.selectReadyPublicDataForOnInit)(getState(), {
            viewType: viewType
        }) !== null) return;
        dispatch((0, $2NMWZ.setError)({
            errorCode: 'ON_INIT_FIELDS_INITIALIZATION_TIMEOUT'
        }));
        (0, $2jyqu.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'timedOut',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                configuredTimeout: $e08f4de833312075$var$getTimeout(),
                fieldsInitializationTime: $e08f4de833312075$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: Object.keys(formData ?? {}).length,
                experienceDataIsLoading: experienceDataIsLoading,
                supportedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'timedOut'
            }
        });
    };
const $e08f4de833312075$export$cf768a695e83eefa = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        (0, $gKZoD.di)((0, $2jyqu.fireOperationalEvent));
        const { status: status } = getState().fieldsInitialization;
        if ($e08f4de833312075$var$isFieldInitialisationComplete(status)) return;
        const { numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { timeoutId: timeoutId, startTime: startTime } = fieldsInitialization;
        clearTimeout(timeoutId);
        (0, $2jyqu.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                fieldsInitializationTime: $e08f4de833312075$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'success'
            }
        });
    };

});
parcelRegister("1FDIy", function(module, exports) {

$parcel$export(module.exports, "selectReadyPublicDataForOnInit", () => $9ea7c26aba3c4975$export$4cadeedb8c3f31f7);

var $6dDSs = parcelRequire("6dDSs");
const $9ea7c26aba3c4975$export$4cadeedb8c3f31f7 = (0, $6dDSs.createSelector)((state)=>state.formData, (state)=>state.numberOfSupportedFields, (state)=>state.screenTabs, (state)=>state.experienceDataIsLoading, (formData, numberOfSupportedFields, screenTabsData, experienceDataIsLoading)=>{
    if (formData !== null && screenTabsData !== null && numberOfSupportedFields !== 0 && experienceDataIsLoading === false && Object.keys(formData).length === numberOfSupportedFields) return {
        formData: formData,
        screenTabsData: screenTabsData
    };
    return null;
});

});


parcelRegister("8e24q", function(module, exports) {

$parcel$export(module.exports, "initializeField", () => $c1b779e01c06a231$export$6b51e123e61a9615);
$parcel$export(module.exports, "initializeFields", () => $c1b779e01c06a231$export$4a6b4707110b0552);

var $iLSUx = parcelRequire("iLSUx");
const $c1b779e01c06a231$export$6b51e123e61a9615 = ({ field: field, metadata: metadata })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData = {} } = getState();
        const fieldMetadata = {
            allowedValues: field.allowedValues,
            isReadOnlyBySystem: field.isReadOnly,
            isRequiredBySystem: field.isRequired,
            fieldRenderer: metadata?.fieldRenderer,
            fieldType: field.fieldType
        };
        const publicValue = (0, $iLSUx.mapFieldValueFromInternalToPublic)({
            fieldMetadata: fieldMetadata,
            internalFieldValue: field.value,
            fieldType: field.fieldType,
            viewType: viewType
        });
        setState({
            formData: {
                ...formData,
                [field.fieldId]: {
                    fieldId: field.fieldId,
                    fieldName: field.fieldName,
                    description: field.description,
                    isVisible: field.isVisible,
                    fieldType: field.fieldType,
                    isReadOnly: field.isReadOnly,
                    isRequired: field.isRequired,
                    value: publicValue,
                    optionsVisibility: undefined
                }
            },
            internalFormMetadata: {
                ...internalFormMetadata,
                [field.fieldId]: fieldMetadata
            }
        });
    };
const $c1b779e01c06a231$export$4a6b4707110b0552 = (fields)=>({ setState: setState }, { viewType: viewType })=>{
        const { formData: formData, internalFormMetadata: internalFormMetadata } = fields.reduce((acc, { field: field, metadata: metadata })=>{
            const fieldMetadata = {
                allowedValues: field.allowedValues,
                isReadOnlyBySystem: field.isReadOnly,
                isRequiredBySystem: field.isRequired,
                fieldRenderer: metadata?.fieldRenderer,
                fieldType: field.fieldType
            };
            const publicValue = (0, $iLSUx.mapFieldValueFromInternalToPublic)({
                fieldMetadata: fieldMetadata,
                internalFieldValue: field.value,
                fieldType: field.fieldType,
                viewType: viewType
            });
            acc.formData[field.fieldId] = {
                fieldId: field.fieldId,
                fieldName: field.fieldName,
                description: field.description,
                isVisible: field.isVisible,
                fieldType: field.fieldType,
                isReadOnly: field.isReadOnly,
                isRequired: field.isRequired,
                value: publicValue,
                optionsVisibility: undefined
            };
            acc.internalFormMetadata[field.fieldId] = fieldMetadata;
            return acc;
        }, {
            internalFormMetadata: {},
            formData: {}
        });
        setState({
            formData: formData,
            internalFormMetadata: internalFormMetadata,
            numberOfSupportedFields: fields.length
        });
    };

});
parcelRegister("iLSUx", function(module, exports) {

$parcel$export(module.exports, "mapFieldValueFromInternalToPublic", () => $4854c3676fce92c1$export$50806045b617d116);

var $gKZoD = parcelRequire("gKZoD");

var $cmmj3 = parcelRequire("cmmj3");

var $gL80q = parcelRequire("gL80q");
const $4854c3676fce92c1$export$50806045b617d116 = ({ fieldMetadata: fieldMetadata, internalFieldValue: internalFieldValue, fieldType: fieldType, viewType: viewType })=>{
    (0, $gKZoD.di)((0, $cmmj3.fireErrorAnalytics), (0, $gL80q.getSupportedFieldConfiguration));
    if (fieldMetadata === undefined) throw new Error('Attempt to set value for the uninitialized field');
    let value = internalFieldValue;
    try {
        const valueTransformer = (0, $gL80q.getSupportedFieldConfiguration)(viewType, fieldType)?.internalToPublicTransformers.value;
        if (valueTransformer) /**
			 * We trust that the internal field data is in the correct shape.
			 * Data that is in the incorrect shape will result in error events
			 * being logged for further investigation. In this error case we will
			 * pass `null` as the value to unblock onInit for the apps
			 *
			 * The `fieldRenderer` passed to the `valueTransformer` is used only for
			 * rich text fields and will be `undefined` for most of the executions
			 */ value = valueTransformer(internalFieldValue, fieldMetadata?.fieldRenderer);
    } catch (error) {
        value = null;
        (0, $cmmj3.fireErrorAnalytics)({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return value;
};

});
parcelRegister("cmmj3", function(module, exports) {

$parcel$export(module.exports, "fireErrorAnalytics", () => $1359a69054531aa4$export$a27c21aa3ed8f0f1);

var $1nF7O = parcelRequire("1nF7O");

var $z11xo = parcelRequire("z11xo");
const $1359a69054531aa4$export$1bee4e6be783dd26 = (message)=>message.replaceAll(/\w+@[\w.]+/gi, '***@***');
const $1359a69054531aa4$export$a27c21aa3ed8f0f1 = ({ error: error, id: id, viewType: viewType, attributes: attributes = {}, event: event })=>{
    const errorType = (0, $z11xo.getErrorType)(error);
    const packageName = `${viewType}jiraUiModifications`;
    (0, $1nF7O.fireErrorAnalytics)({
        event: event,
        meta: {
            id: id,
            packageName: packageName,
            teamName: 'unbox'
        },
        error: error,
        attributes: {
            errorType: errorType,
            errorMessage: typeof error.message === 'string' ? $1359a69054531aa4$export$1bee4e6be783dd26(error.message) : error.message,
            ...attributes
        }
    });
};

});
parcelRegister("z11xo", function(module, exports) {

$parcel$export(module.exports, "getErrorType", () => $df5192e881ed2750$export$e19f9f08a6d79fd2);

var $3HlI9 = parcelRequire("3HlI9");
const $df5192e881ed2750$var$commonErrors = {
    MUST_INCLUDE_ACCOUNT_ID: 'Response ended with an error message: Requests from this source must include an accountId',
    OPERATION_ABORTED: 'The operation was aborted. ',
    CANCELLED: 'cancelled',
    UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
    NETWORK_CONNECTION_LOST: 'The network connection was lost.',
    TIMEOUT: 'The request timed out.',
    AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS: 'Response ended with an error message: Authorization failed: Principal has insufficient permissions',
    GATEWAY_TIMEOUT: 'Response ended with an error message: The underlying service call failed. The underlying service cs_extensions status code is : 504'
};
const $df5192e881ed2750$export$23de3198bfe70090 = 'DATA_CLASSIFICATION_NO_ACCESS';
const $df5192e881ed2750$export$f52aa41ccd776f01 = 'FAILED_TO_FETCH';
const $df5192e881ed2750$export$31d2ab0be67934f0 = 'AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS';
const $df5192e881ed2750$export$7a1bd8c001e7e9c = 'RATE_LIMITING';
const $df5192e881ed2750$export$89a175d4190df42e = 'Invoke value functions failed:';
const $df5192e881ed2750$export$215c097832f3122d = 'AGG_UNDERLYING_SERVICE_TIMEOUT';
const $df5192e881ed2750$export$dddade71b333c01d = new RegExp('The user did not consent to use the app', 'i');
const $df5192e881ed2750$var$BAD_REQUEST = 400;
const $df5192e881ed2750$var$REQUEST_TIMEOUT = 408;
const $df5192e881ed2750$export$8a5d666d6e5b82fc = (error)=>{
    // React loosely lazy chunk load error type
    if (typeof error === 'object' && error.name === 'ChunkLoadError') return true;
    // Other chunk load error types
    // In theory it should be handled by a common isClientFetchError, but it ignores TypeError error types
    const KNOWN_NETWORK_ERRORS = [
        'Failed to fetch dynamically imported module',
        'error loading dynamically imported module',
        'Importing a module script failed',
        'Cannot find module'
    ];
    const isClientFetchErrorMessage = (message)=>Boolean(message) && !!KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
            // are sometimes wrapped to provide additional context, e.g.
            // "Something went wrong: ${error.message}"
            message.includes(networkErrorMessage));
    return Boolean(error) && typeof error === 'object' && (isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && error.cause && 'message' in error.cause && isClientFetchErrorMessage(String(error.cause.message)));
};
const $df5192e881ed2750$export$e19f9f08a6d79fd2 = (_error)=>{
    if (_error == null) return 'NULL_OR_UNDEFINED';
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = _error;
    const message = String(error instanceof Error ? error.message : error).trim();
    const isTimeoutError = (timedOutResource)=>Boolean(typeof error === 'object' && error.name === 'TimeoutError' && error.stack?.includes(timedOutResource));
    if (message === "A hidden extension shouldn't be rendered") return 'HIDDEN_EXTENSION_RENDER_ATTEMPT';
    const circuitBreakerErrorRegex = new RegExp("We couldn't show this extension", 'i');
    if (circuitBreakerErrorRegex.test(message)) return 'CIRCUIT_BREAKER_ERROR';
    const rateLimitingRegex = new RegExp("Response ended with an error message: You are trying to access '.*' too often", 'i');
    const rateLimitingDataClassificationRegex = new RegExp('Data classification request failed: Error server response: 429');
    if (rateLimitingRegex.test(message) || rateLimitingDataClassificationRegex.test(message)) return $df5192e881ed2750$export$7a1bd8c001e7e9c;
    const serverErrorRegex = new RegExp('^Error server response: (\\d+)$', 'i');
    if (serverErrorRegex.test(message)) {
        const match = message.match(serverErrorRegex);
        const statusCode = match ? match[1] : 'NO_STATUS_CODE';
        return `ERROR_SERVER_RESPONSE_${statusCode}`;
    }
    const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
    if (aggGiraServerErrorRegex.test(message)) {
        const match = message.match(aggGiraServerErrorRegex);
        const statusCode = match?.[1] ?? 'NO_STATUS_CODE';
        return `AGG_GIRA_ERROR_${statusCode}`;
    }
    const dataClassification404ErrorRegex = new RegExp('Data classification request failed: Error server response: 404', 'i');
    const dataClassification401ErrorRegex = new RegExp('Data classification request failed: Error server response: 401', 'i');
    if (dataClassification401ErrorRegex.test(message) || dataClassification404ErrorRegex.test(message)) return $df5192e881ed2750$export$23de3198bfe70090;
    // Add here errors related to a broken app configuration/manifest
    if (message.startsWith('Function definition is invalid.')) return 'APP_DEV_ERROR';
    const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
    if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
    if ($df5192e881ed2750$export$dddade71b333c01d.test(message)) return 'USER_DIDNT_CONSENT_ERROR';
    const aggUnderlyingServiceTimeoutRegex = new RegExp('The underlying service call timed out', 'i');
    if (aggUnderlyingServiceTimeoutRegex.test(message)) return $df5192e881ed2750$export$215c097832f3122d;
    const appValueFunction = new RegExp("The app's value function failed", 'i');
    const serverValueFunction408ErrorRegex = new RegExp('Invoke value functions failed: Error server response: 408', 'i');
    const invokeValueFunctionFailed = new RegExp($df5192e881ed2750$export$89a175d4190df42e, 'i');
    /**
	 * In case when we get bad request(400) from the BE it should be treated as an app error as there
	 * are many ways to fail the value function
	 */ const valueFunctionAppsBadRequest = invokeValueFunctionFailed.test(message) && 'statusCode' in error && error.statusCode === $df5192e881ed2750$var$BAD_REQUEST;
    /**
	 * In case when we get request timeout(408) from the XIS invocation it should be treated as an app error.
	 * Error occurs when invocation exceeds 25s threshold e.g.too long time to execute request to external API
	 */ const valueFunctionTimeoutError = serverValueFunction408ErrorRegex.test(message) && 'statusCode' in error && error.statusCode === $df5192e881ed2750$var$REQUEST_TIMEOUT;
    if (appValueFunction.test(message) || valueFunctionTimeoutError || valueFunctionAppsBadRequest) return 'VALUE_FUNCTION_APP_ERROR';
    /*
	 * 	Whole message:
	 *	Fetching formatted value after edit failed: FetchError: Fetch call failed with status code: 429
	 */ const valueFunctionEditRateLimitedRegex = new RegExp('Fetch call failed with status code: 429', 'i');
    /*
	 * 	Whole message:
	 *	Invoke value functions failed: Error server response: 429
	 */ const valueFunctionInvokeRateLimitedRegex = new RegExp('Error server response: 429', 'i');
    if (valueFunctionEditRateLimitedRegex.test(message) || valueFunctionInvokeRateLimitedRegex.test(message)) return $df5192e881ed2750$export$7a1bd8c001e7e9c;
    // The full message states:
    // Extension "extension name" does not exist, the app may have changed or no longer be installed in this context
    const extensionDoesntExistRegex = new RegExp('^Extension "(.*)" does not exist', 'i');
    if (extensionDoesntExistRegex.test(message)) return 'EXTENSION_DOESNT_EXIST';
    // In case of React error message:
    // Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.
    const removeChildOnNodeRegex = new RegExp("^Failed to execute 'removeChild' on 'Node'", 'i');
    if (removeChildOnNodeRegex.test(message)) return 'REMOVE_CHILD_ERROR';
    if ($df5192e881ed2750$export$8a5d666d6e5b82fc(error)) return 'CHUNK_LOAD';
    if (isTimeoutError('FORGE_PROJECT_MODULE')) return 'TIMEOUT_PROJECT_MODULE';
    if (isTimeoutError('FORGE_PROJECT_SETTINGS_MODULE')) return 'TIMEOUT_PROJECT_SETTINGS_MODULE';
    if (isTimeoutError('PROJECT_CONTEXT')) return 'TIMEOUT_PROJECT_CONTEXT';
    const entry = Object.entries($df5192e881ed2750$var$commonErrors).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
    if (entry) return entry[0];
    if ((0, $3HlI9.isClientFetchError)(error)) return $df5192e881ed2750$export$f52aa41ccd776f01;
    if (error != null && 'statusCode' in error && error.statusCode === 429) return 'RATE_LIMITING';
    return 'OTHER';
};

});
parcelRegister("3HlI9", function(module, exports) {

$parcel$export(module.exports, "isClientFetchError", () => $cbf82ad04131c769$export$2e7adc44463c3f4f);
// Copied from jira/src/packages/platform/utils/fetch/src/utils/is-error.tsx
// Exclude client connectivity and HTTP client network errors as a SLO failure
// e.g. during quick SPA transition when a network call haven't finished yet,
// or when the user's internet connection drops out.
const $cbf82ad04131c769$export$c748438cec453c9f = [
    '... is not valid JSON',
    'server with the specified hostname could not be found',
    'cannot parse response',
    'connection failure',
    'Failed to fetch',
    'in JSON at position 0',
    'JSON.parse: unexpected character at line 1 column 1 of the JSON data',
    'JSON.parse: unexpected end of data at line 1 column 1 of the JSON data',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'Syntax or http error',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted',
    'Unable to fetch manifest',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'dynamically imported module',
    'Importing a module script failed'
];
const $cbf82ad04131c769$export$3876cb851aa46193 = [
    'AbortError',
    'AuthError',
    'ChunkLoadError',
    'NetworkError'
];
const $cbf82ad04131c769$var$isClientFetchErrorMessage = (message)=>Boolean(message) && $cbf82ad04131c769$export$c748438cec453c9f.some((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
const $cbf82ad04131c769$export$2e7adc44463c3f4f = (error)=>Boolean(error) && typeof error === 'object' && ($cbf82ad04131c769$export$3876cb851aa46193.includes(error.name) || $cbf82ad04131c769$var$isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && ($cbf82ad04131c769$export$3876cb851aa46193.includes(error.cause.name) || $cbf82ad04131c769$var$isClientFetchErrorMessage(error.cause.message)));

});



parcelRegister("gL80q", function(module, exports) {

$parcel$export(module.exports, "getSupportedFieldConfiguration", () => $968cd36658e5c86e$export$8fc8d6775f1842b8);
$parcel$export(module.exports, "isFieldTypeSupported", () => $968cd36658e5c86e$export$b47920a5dd99844f);
$parcel$export(module.exports, "getConsentMessage", () => $968cd36658e5c86e$export$20eabd2b3ada6bf3);
$parcel$export(module.exports, "isExecutionContextSupported", () => $968cd36658e5c86e$export$b768d6a95f7a930);
$parcel$export(module.exports, "getAnalytics", () => $968cd36658e5c86e$export$b0297573c90085aa);
$parcel$export(module.exports, "isTriggerPointSupported", () => $968cd36658e5c86e$export$ef45e4471aa21b27);

var $cmmj3 = parcelRequire("cmmj3");

var $3OTqu = parcelRequire("3OTqu");
const $968cd36658e5c86e$var$isKeyOf = (key, object)=>object[key] !== undefined;
const $968cd36658e5c86e$var$getConfigurationByViewType = ({ viewType: viewType })=>{
    const viewConfiguration = (0, $3OTqu.getViewConfiguration)(viewType);
    if (!viewConfiguration) throw new Error(`Unsupported view type ${viewType} in getConfigurationByViewType.`);
    return viewConfiguration;
};
function $968cd36658e5c86e$export$8fc8d6775f1842b8(viewType, fieldType) {
    const fieldsConfiguration = $968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldsConfiguration();
    if (!$968cd36658e5c86e$var$isKeyOf(fieldType, fieldsConfiguration)) {
        (0, $cmmj3.fireErrorAnalytics)({
            error: new Error('Unsupported field type.'),
            id: 'getSupportedFieldConfiguration',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
        return undefined;
    }
    return fieldsConfiguration[fieldType];
}
const $968cd36658e5c86e$export$e4330d77fd93d1de = (viewType)=>$968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldTypes();
function $968cd36658e5c86e$export$b47920a5dd99844f(viewType, fieldType) {
    return fieldType !== undefined && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $968cd36658e5c86e$export$e4330d77fd93d1de(viewType).includes(fieldType);
}
function $968cd36658e5c86e$export$20eabd2b3ada6bf3(viewType) {
    return $968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: viewType
    }).getConsentMessage();
}
function $968cd36658e5c86e$export$b768d6a95f7a930(context) {
    return $968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: context.viewType
    }).isExecutionContextSupported({
        context: context
    });
}
function $968cd36658e5c86e$export$b0297573c90085aa(viewType) {
    return $968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: viewType
    }).getAnalytics();
}
function $968cd36658e5c86e$export$c0728caa743a409e(viewType) {
    return $968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedTriggerPointsConfiguration();
}
const $968cd36658e5c86e$export$ef45e4471aa21b27 = (viewType, triggerPoint)=>triggerPoint !== undefined && $968cd36658e5c86e$export$c0728caa743a409e(viewType).has(triggerPoint);

});
parcelRegister("3OTqu", function(module, exports) {

$parcel$export(module.exports, "getViewConfiguration", () => $b8beb3418915829f$export$176b6e68da08ffa2);
$parcel$export(module.exports, "useLoadViewConfiguration", () => $b8beb3418915829f$export$f0022a21ccd1f6be);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");
const $b8beb3418915829f$var$VIEW_CONFIGURATIONS = new Map();
const $b8beb3418915829f$export$cda1ad403b37fe70 = (viewType, configuration)=>{
    if (!$b8beb3418915829f$var$VIEW_CONFIGURATIONS.has(viewType)) $b8beb3418915829f$var$VIEW_CONFIGURATIONS.set(viewType, configuration);
};
const $b8beb3418915829f$export$176b6e68da08ffa2 = (viewType)=>$b8beb3418915829f$var$VIEW_CONFIGURATIONS.get(viewType);
const $b8beb3418915829f$export$e8091eff40c4f16e = ()=>{
    $b8beb3418915829f$var$VIEW_CONFIGURATIONS.clear();
};
const $b8beb3418915829f$export$f0022a21ccd1f6be = (viewType, configurationClass)=>{
    (0, $gKZoD.di)($b8beb3418915829f$export$cda1ad403b37fe70);
    /**
	 * Uses useState to load view configuration on component mount, before rendering.
	 */ (0, $5uXOq.useState)(()=>{
        $b8beb3418915829f$export$cda1ad403b37fe70(viewType, new configurationClass());
    });
};

});




parcelRegister("cTj8m", function(module, exports) {

$parcel$export(module.exports, "initializeNoScreenTab", () => $b87f070d69e40149$export$93459ad9bfd6c380);
const $b87f070d69e40149$export$93459ad9bfd6c380 = ()=>({ setState: setState })=>{
        setState({
            screenTabs: []
        });
    };

});

parcelRegister("i4uue", function(module, exports) {

$parcel$export(module.exports, "initializeScreenTabs", () => $559bbe3e01414de7$export$7f7be235f64f029b);
const $559bbe3e01414de7$export$7f7be235f64f029b = ({ tabs: tabs, selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: internalScreenTabs } = getState();
        const previouslySelected = internalScreenTabs?.findIndex((tab)=>tab.isActive);
        setState({
            screenTabs: tabs.map(({ id: id }, index)=>({
                    id: id,
                    isVisible: true,
                    isActive: index === selected || index === previouslySelected
                }))
        });
    };

});

parcelRegister("b8ZsE", function(module, exports) {

$parcel$export(module.exports, "processChange", () => $926b03f8c2e312a1$export$352dfcce04d66748);

var $3ZT8o = parcelRequire("3ZT8o");

var $gKZoD = parcelRequire("gKZoD");

var $gL80q = parcelRequire("gL80q");

var $l6AQO = parcelRequire("l6AQO");
const $926b03f8c2e312a1$export$352dfcce04d66748 = ({ fieldId: fieldId, fieldValue: fieldValue, eventType: eventType })=>({ setState: setState, getState: getState }, { viewType: viewType })=>{
        (0, $gKZoD.di)((0, (/*@__PURE__*/$parcel$interopDefault($3ZT8o))));
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        const fieldType = internalFormMetadata[fieldId]?.fieldType;
        if (!fieldType) return;
        const emitChangeOn = (0, $gL80q.getSupportedFieldConfiguration)(viewType, fieldType)?.emitChangeOn;
        if (emitChangeOn !== eventType) return;
        const nextFormData = (0, $l6AQO.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        /**
		 * setTimeout justification - we need to delay the state update to the next tick to avoid batched updates.
		 * Otherwise, UIM app may not be notified about every single change.
		 */ setTimeout(()=>{
            const changeId = (0, (/*@__PURE__*/$parcel$interopDefault($3ZT8o)))();
            setState({
                lastProcessedChange: {
                    fieldId: fieldId,
                    changeId: changeId
                },
                formData: nextFormData
            });
        }, 0);
    };

});
parcelRegister("3ZT8o", function(module, exports) {

var $jJVtR = parcelRequire("jJVtR");
/** Used to generate unique IDs. */ var $2e91d6202798e8a1$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $2e91d6202798e8a1$var$uniqueId(prefix) {
    var id = ++$2e91d6202798e8a1$var$idCounter;
    return $jJVtR(prefix) + id;
}
module.exports = $2e91d6202798e8a1$var$uniqueId;

});

parcelRegister("l6AQO", function(module, exports) {

$parcel$export(module.exports, "calculateNextFormValue", () => $2b658e9f553d1ad3$export$25441a03bb8f1cb0);

var $ajpes = parcelRequire("ajpes");

var $iLSUx = parcelRequire("iLSUx");
const $2b658e9f553d1ad3$export$25441a03bb8f1cb0 = ({ internalFormMetadata: internalFormMetadata, formData: formData, fieldId: fieldId, fieldValue: fieldValue, fieldType: fieldType, viewType: viewType })=>{
    if (formData === null) return null;
    let newPublicValue;
    try {
        newPublicValue = (0, $iLSUx.mapFieldValueFromInternalToPublic)({
            fieldMetadata: internalFormMetadata[fieldId],
            internalFieldValue: fieldValue,
            fieldType: fieldType,
            viewType: viewType
        });
    } catch (e) {
        return null;
    }
    const currentPublicValue = formData[fieldId]?.value;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(newPublicValue, currentPublicValue)) return null;
    return {
        ...formData,
        [fieldId]: {
            ...formData[fieldId],
            value: newPublicValue
        }
    };
};

});


parcelRegister("jDMtG", function(module, exports) {

$parcel$export(module.exports, "registerFields", () => $5e78d8ed1ee13321$export$d4eb181b231cf88d);
$parcel$export(module.exports, "unregisterFields", () => $5e78d8ed1ee13321$export$1ca69a85bb7273de);

var $fr1K2 = parcelRequire("fr1K2");

var $kGsr8 = parcelRequire("kGsr8");
const $5e78d8ed1ee13321$export$d4eb181b231cf88d = ({ changeId: changeId, fieldsToBeRegistered: fieldsToBeRegistered, appId: appId })=>({ setState: setState, getState: getState })=>{
        if (!Array.isArray(fieldsToBeRegistered)) return;
        const { registeredFields: registeredFields } = getState();
        const appFields = registeredFields[appId] ?? {};
        const appChangeIdFields = appFields[changeId] ?? [];
        const nextRegisteredFields = {
            ...registeredFields,
            [appId]: {
                ...appFields,
                [changeId]: (0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))([
                    ...appChangeIdFields,
                    ...fieldsToBeRegistered
                ])
            }
        };
        setState({
            registeredFields: nextRegisteredFields
        });
    };
const $5e78d8ed1ee13321$export$1ca69a85bb7273de = ({ changeId: changeId, appId: appId })=>({ setState: setState, getState: getState })=>{
        const { registeredFields: registeredFields } = getState();
        const registeredAppFields = registeredFields[appId] ?? {};
        const nextRegisteredAppFields = (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(registeredAppFields, changeId);
        setState({
            registeredFields: {
                ...registeredFields,
                [appId]: nextRegisteredAppFields
            }
        });
    };

});

parcelRegister("l0b2q", function(module, exports) {

$parcel$export(module.exports, "setFieldValue", () => $da1080104d423ca2$export$6556d46d2662453c);

var $l6AQO = parcelRequire("l6AQO");
const $da1080104d423ca2$export$6556d46d2662453c = ({ fieldId: fieldId, fieldType: fieldType, fieldValue: fieldValue })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        /**
		 * We can set new field value only if the field was initialized.
		 * This checks the field metedata that indicates the successfull initialization.
		 */ if (!internalFormMetadata[fieldId]) return;
        const nextFormData = (0, $l6AQO.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        setState({
            formData: nextFormData
        });
    };

});

parcelRegister("4MJXd", function(module, exports) {

$parcel$export(module.exports, "updateActiveScreenTab", () => $104b1b4dd763f6ee$export$21363496760d39cd);
const $104b1b4dd763f6ee$export$21363496760d39cd = ({ selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: screenTabs } = getState();
        if (screenTabs) setState({
            screenTabs: screenTabs.map((tab, index)=>({
                    ...tab,
                    isActive: index === selected
                }))
        });
    };

});

parcelRegister("gHQFd", function(module, exports) {

$parcel$export(module.exports, "updateFields", () => $069ce0e12537855c$export$cceae62fd4d1ef0a);

var $gccSB = parcelRequire("gccSB");

var $gKZoD = parcelRequire("gKZoD");

var $2jyqu = parcelRequire("2jyqu");


var $ajglJ = parcelRequire("ajglJ");

var $dA2NP = parcelRequire("dA2NP");

var $fKje4 = parcelRequire("fKje4");

var $dwG9p = parcelRequire("dwG9p");

var $dRfi6 = parcelRequire("dRfi6");

var $3whHg = parcelRequire("3whHg");

var $boEP0 = parcelRequire("boEP0");

var $hzAKL = parcelRequire("hzAKL");
const $069ce0e12537855c$export$cceae62fd4d1ef0a = ({ changeId: changeId, fieldsChanges: fieldsChanges, lookupDataFromApi: lookupDataFromApi, tenantContext: tenantContext, executionContext: executionContext, environment: environment, appId: appId, intl: intl, createAnalyticsEvent: createAnalyticsEvent })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType })=>{
        (0, $gKZoD.di)((0, $boEP0.collectFieldsAppliedChangesHistory));
        const appliedChanges = getState().appliedChanges ?? {};
        const formData = getState().formData ?? {};
        const { internalFormMetadata: internalFormMetadata, registeredFields: registeredFields } = getState();
        const { changesToApply: changesToApply, incomingFormData: incomingFormData, errorsByField: errorsByField, newAppliedChangesPublic: newAppliedChangesPublic } = await Object.keys(fieldsChanges).reduce(async (acc, fieldId)=>{
            // Do not update fields that are not inside initialized data.
            // Validates if the field that comes from Iframe is supported
            // - because we add to formData only the supported ones.
            const fieldData = formData[fieldId];
            const internalMetadata = internalFormMetadata[fieldId];
            const fieldIsRegistered = (0, $dA2NP.fieldWasRegistered)(registeredFields, changeId, fieldId, appId);
            // Only registered field Ids can be updated.
            if (!fieldIsRegistered || !fieldData) {
                const { fieldType: fieldType } = fieldData ?? {};
                dispatch((0, $3whHg.addAppsErrors)({
                    errors: {
                        [appId]: [
                            {
                                fieldType: fieldType,
                                fieldId: fieldId,
                                type: 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD',
                                message: 'Application tried to apply changes to unregistered field'
                            }
                        ]
                    }
                }));
                (0, $2jyqu.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'unregisteredField',
                    actionSubject: 'jiraUiModifications.applyChanges',
                    attributes: {
                        message: 'Attempt to apply changes to a field that was not registered',
                        fieldId: fieldId,
                        viewType: viewType
                    }
                });
                return acc;
            }
            const lookupData = {
                [(0, $80e7f3d73b333b84$export$a1cacdcf198da901)]: internalMetadata.allowedValues,
                [(0, $80e7f3d73b333b84$export$3a106242c8f57ac2)]: lookupDataFromApi[0, $80e7f3d73b333b84$export$3a106242c8f57ac2]
            };
            // It updates properties in each field to avoid removing unchanged props for
            // selected field by another app or another onChange update.
            // Only supported properties are allowed.
            const supportedFieldChanges = await (0, $hzAKL.transformFieldChangesToInternalShape)({
                fieldType: fieldData.fieldType,
                fieldId: fieldId,
                fieldFromIframe: fieldsChanges?.[fieldId],
                lookupData: lookupData,
                viewType: viewType,
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                intl: intl
            });
            if (supportedFieldChanges.isValid === false) {
                (await acc).errorsByField[fieldId] = supportedFieldChanges.errors;
                return acc;
            }
            // It converts changes to 'public' format to update the formData
            const publicShapeChanges = (0, $dRfi6.transformFieldToIframe)(supportedFieldChanges.data, viewType, fieldData.fieldType, lookupData, fieldsChanges?.[fieldId], internalMetadata);
            const transformedFieldChanges = (0, $fKje4.mapFieldPropertyNamesToInternal)(supportedFieldChanges.data, viewType, fieldData.fieldType);
            const combinedChangesToApply = {
                ...appliedChanges[fieldId],
                ...transformedFieldChanges
            };
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(combinedChangesToApply)) {
                (await acc).newAppliedChangesPublic[fieldId] = publicShapeChanges;
                (await acc).changesToApply[fieldId] = combinedChangesToApply;
                (await acc).incomingFormData[fieldId] = {
                    ...formData[fieldId],
                    ...publicShapeChanges
                };
            }
            return acc;
        }, Promise.resolve({
            changesToApply: {
                ...appliedChanges
            },
            incomingFormData: {
                ...formData
            },
            newAppliedChangesPublic: {},
            errorsByField: {}
        }));
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(errorsByField)) throw new (0, $ajglJ.UiModificationsFieldsValidationError)('Transformation failed', {
            errors: (0, $dwG9p.prepareErrorsArray)(errorsByField)
        });
        setState({
            appliedChanges: changesToApply,
            formData: incomingFormData
        });
        dispatch((0, $boEP0.collectFieldsAppliedChangesHistory)({
            appId: appId,
            changeId: changeId,
            fieldsChanges: newAppliedChangesPublic
        }));
    };

});
const $80e7f3d73b333b84$export$a1cacdcf198da901 = 'LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY';
const $80e7f3d73b333b84$export$3a106242c8f57ac2 = 'LOOKUP_SOURCE_USERS_ASYNC_DATA';
const $80e7f3d73b333b84$export$f5d5f6bb902f1027 = '-1';
const $80e7f3d73b333b84$export$106087dcfd4fb129 = 100;

parcelRegister("ajglJ", function(module, exports) {

$parcel$export(module.exports, "UiModificationsFieldsValidationError", () => $907938b0f57574ed$export$9e8b5e552e255163);

var $2jqAp = parcelRequire("2jqAp");
class $907938b0f57574ed$export$9e8b5e552e255163 extends (0, $2jqAp.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'fields', cause);
    }
}

});
parcelRegister("2jqAp", function(module, exports) {

$parcel$export(module.exports, "UiModificationsValidationError", () => $b8ce6491bf34e535$export$6e8165c81a6a65df);
class $b8ce6491bf34e535$export$6e8165c81a6a65df extends Error {
    constructor(message, attributes, validationErrorType, cause){
        super(message, cause);
        this.attributes = attributes;
        this.validationErrorType = validationErrorType;
    }
}

});


parcelRegister("dA2NP", function(module, exports) {

$parcel$export(module.exports, "fieldWasRegistered", () => $aff4a3261c4c9b6e$export$fbe9157c12cb4e7b);
const $aff4a3261c4c9b6e$export$fbe9157c12cb4e7b = (registeredFields, changeId, fieldId, appId)=>!!registeredFields[appId]?.[changeId]?.includes(fieldId);

});

parcelRegister("fKje4", function(module, exports) {

$parcel$export(module.exports, "mapFieldPropertyNamesToInternal", () => $620a721e65ec1dbe$export$460820f27643954e);

var $gL80q = parcelRequire("gL80q");
const $620a721e65ec1dbe$export$460820f27643954e = (properties, viewType, fieldType)=>{
    const fieldConfiguration = (0, $gL80q.getSupportedFieldConfiguration)(viewType, fieldType);
    const propertyMapping = fieldConfiguration?.propertyMapping;
    if (!propertyMapping) return properties;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(properties).reduce((acc, propertyName)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const propertyMappingValue = propertyMapping[propertyName];
        acc[propertyMappingValue ?? propertyName] = properties[propertyName];
        return acc;
    }, {});
};

});

parcelRegister("dwG9p", function(module, exports) {

$parcel$export(module.exports, "prepareErrorsArray", () => $8d92968018d86237$export$e1fce51bc5be90b7);
const $8d92968018d86237$export$e1fce51bc5be90b7 = (errorsById)=>Object.values(errorsById).flat();

});

parcelRegister("dRfi6", function(module, exports) {

$parcel$export(module.exports, "transformFieldToIframe", () => $cc6b08557666e682$export$aa453854f74fab);

var $cmmj3 = parcelRequire("cmmj3");

var $gL80q = parcelRequire("gL80q");
const $cc6b08557666e682$export$aa453854f74fab = (fieldChanges, viewType, fieldType, lookupData, fieldFromIframe, fieldMetadata)=>{
    const fieldConfiguration = (0, $gL80q.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldInternalToPublicTransformers = fieldConfiguration?.internalToPublicTransformers;
    const publicShapeField = {
        ...fieldChanges
    };
    if (publicShapeField.value !== undefined && fieldInternalToPublicTransformers?.value) try {
        publicShapeField.value = fieldInternalToPublicTransformers?.value(fieldChanges.value, fieldMetadata.fieldRenderer);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $cmmj3.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    if (fieldFromIframe.optionsVisibility !== undefined && fieldInternalToPublicTransformers?.optionsVisibility) try {
        const lookupSource = fieldConfiguration?.lookupSource;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - lookupData is not types on CI somehow
        const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
        publicShapeField.optionsVisibility = fieldInternalToPublicTransformers?.optionsVisibility(fieldFromIframe.optionsVisibility, lookupValues);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $cmmj3.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicOptionsVisibilityTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return publicShapeField;
};

});

parcelRegister("hzAKL", function(module, exports) {

$parcel$export(module.exports, "transformFieldChangesToInternalShape", () => $422557008e0dbc71$export$d14f85c01e334a1);

var $gccSB = parcelRequire("gccSB");

var $gKZoD = parcelRequire("gKZoD");

var $7NDId = parcelRequire("7NDId");

var $gL80q = parcelRequire("gL80q");


var $bCvSM = parcelRequire("bCvSM");

var $2J6IF = parcelRequire("2J6IF");

var $hwDyF = parcelRequire("hwDyF");
const $422557008e0dbc71$export$d14f85c01e334a1 = async ({ fieldType: fieldType, fieldId: fieldId, fieldFromIframe: fieldFromIframe, lookupData: lookupData, viewType: viewType, tenantContext: tenantContext, executionContext: executionContext, environment: environment, intl: intl })=>{
    (0, $gKZoD.di)((0, $gL80q.getSupportedFieldConfiguration));
    const fieldConfiguration = (0, $gL80q.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldTransformers = fieldConfiguration?.publicToInternalTransformers;
    const fieldValidators = fieldConfiguration?.publicShapeValidators;
    if (!fieldFromIframe || !fieldTransformers || !fieldValidators) return {
        ...(0, $2J6IF.VALID_RESULT),
        data: {}
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const validatorsArray = Object.keys(fieldValidators);
    const lookupSource = fieldConfiguration?.lookupSource;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - lookupData is not types on CI somehow
    const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
    const fieldTransformationResults = await Promise.all(validatorsArray.map(async (propertyName)=>{
        if (!Object.prototype.hasOwnProperty.call(fieldFromIframe, propertyName)) return 0, $2J6IF.VALID_RESULT;
        const propertyValue = fieldFromIframe[propertyName];
        const transformer = fieldTransformers[propertyName];
        const fieldContext = {
            fieldId: fieldId
        };
        // We need to catch lookup values discrepancies and react accordingly
        // to how we react to validation errors - throw an error
        // if the set value wasn't found in the array of lookupValues
        try {
            const data = transformer ? await transformer(propertyValue, lookupValues, {
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                fieldContext: fieldContext,
                intl: intl
            }) : propertyValue;
            return {
                isValid: true,
                data: {
                    [propertyName]: data
                }
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            // FieldValueLookupError will be thrown from the transformer
            // when the lookup value wasn't found
            if (err instanceof (0, $7NDId.FieldValueLookupError)) {
                // For single value fields its straightforward to just pass
                // the faulty propertyValue into error message,
                // but for multi value fields we should find out the faulty values from the array
                // thats why we should propagate the faulty values as a comma separated string
                // by using the error's message
                const faultyValue = err.message || propertyValue;
                return {
                    isValid: false,
                    error: {
                        fieldId: fieldId,
                        fieldType: fieldType,
                        type: (0, $ca611ff348f89182$export$d1996cb46a690190),
                        method: (0, $bCvSM.mapFieldPropertyToApiMethod)(propertyName),
                        message: `Invalid IDs provided: ${faultyValue}`
                    }
                };
            }
            throw err;
        }
    }));
    const invalidTransformationResults = (0, $hwDyF.filterInvalidResults)(fieldTransformationResults);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(invalidTransformationResults)) return {
        isValid: false,
        errors: invalidTransformationResults.map((result)=>result.error)
    };
    return (0, $hwDyF.mapValidResultsToFieldInternalShape)(fieldTransformationResults);
};

});
parcelRegister("7NDId", function(module, exports) {

$parcel$export(module.exports, "FieldValueLookupError", () => $64626586c22c486e$export$73c2f0689b6c4a5a);
class $64626586c22c486e$export$73c2f0689b6c4a5a extends Error {
}

});

parcelRegister("2J6IF", function(module, exports) {

$parcel$export(module.exports, "VALID_RESULT", () => $5fbccb776f84792e$export$ee79e3ab53b8db79);
const $5fbccb776f84792e$export$ee79e3ab53b8db79 = {
    isValid: true
};

});

parcelRegister("hwDyF", function(module, exports) {

$parcel$export(module.exports, "mapValidResultsToFieldInternalShape", () => $e8aa8431ce8b786b$export$a60dd8f1b025f23d);
$parcel$export(module.exports, "filterInvalidResults", () => $e8aa8431ce8b786b$export$ddd005554aecd409);
const $e8aa8431ce8b786b$export$a60dd8f1b025f23d = (results)=>results.reduce((acc, result)=>{
        if (result.isValid === true && Object.prototype.hasOwnProperty.call(result, 'data')) acc.data = {
            ...acc.data,
            ...result.data
        };
        return acc;
    }, {
        isValid: true,
        data: {}
    });
const $e8aa8431ce8b786b$export$ddd005554aecd409 = (validationResults)=>validationResults.reduce((acc, result)=>{
        if (result.isValid === false) acc.push(result);
        return acc;
    }, []);

});



parcelRegister("7JtDe", function(module, exports) {

$parcel$export(module.exports, "updateScreenTabs", () => $c6c7124cbfc0022b$export$131c67fd312b8a11);

var $gKZoD = parcelRequire("gKZoD");

var $iUvwD = parcelRequire("iUvwD");

var $50ech = parcelRequire("50ech");

var $boEP0 = parcelRequire("boEP0");

var $iiEdL = parcelRequire("iiEdL");
const $c6c7124cbfc0022b$export$131c67fd312b8a11 = ({ screenTabsChanges: screenTabsFromIframe, changeId: changeId, appId: appId })=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        (0, $gKZoD.di)((0, $boEP0.collectScreenTabsAppliedChangesHistory), (0, $iiEdL.getScreenTabsPublicToInternalValidationErrors));
        const { screenTabs: internalScreenTabs } = getState();
        // If screenTabsFromIframe is empty it means that the app does not provide srceenTabs changes.
        if (Array.isArray(screenTabsFromIframe) && !screenTabsFromIframe.length) return;
        if (internalScreenTabs && (0, $iiEdL.screenTabsPublicToInternalValidator)(internalScreenTabs, screenTabsFromIframe)) {
            const newScreenTabs = (0, $iiEdL.screenTabsPublicToInternalTransformer)(internalScreenTabs, screenTabsFromIframe);
            setState({
                screenTabs: newScreenTabs
            });
            dispatch((0, $boEP0.collectScreenTabsAppliedChangesHistory)({
                appId: appId,
                changeId: changeId,
                screenTabs: newScreenTabs
            }));
        } else throw new (0, $iUvwD.UiModificationsScreenTabsValidationError)('Transformation failed', {
            errors: (0, $iiEdL.getScreenTabsPublicToInternalValidationErrors)(internalScreenTabs, screenTabsFromIframe).map((0, $50ech.toScreenTabsValidationError))
        });
    };

});
parcelRegister("iUvwD", function(module, exports) {

$parcel$export(module.exports, "UiModificationsScreenTabsValidationError", () => $2febbf39fb2cebbc$export$faf1f1824ee0a136);

var $2jqAp = parcelRequire("2jqAp");
class $2febbf39fb2cebbc$export$faf1f1824ee0a136 extends (0, $2jqAp.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'screenTabs', cause);
    }
}

});

parcelRegister("50ech", function(module, exports) {

$parcel$export(module.exports, "toScreenTabsValidationError", () => $32af3bb8fe161d39$export$b2675440ade984fb);

const $32af3bb8fe161d39$export$b2675440ade984fb = (message)=>({
        message: message,
        type: (0, $ca611ff348f89182$export$fd26696d109785a0)
    });

});

parcelRegister("iiEdL", function(module, exports) {

$parcel$export(module.exports, "screenTabsPublicToInternalTransformer", () => $5d43d6affeb19d8a$export$9ca9b35e7b6a8bbc);
$parcel$export(module.exports, "screenTabsPublicToInternalValidator", () => $5d43d6affeb19d8a$export$e7a91e7e430e691a);
$parcel$export(module.exports, "getScreenTabsPublicToInternalValidationErrors", () => $5d43d6affeb19d8a$export$62d63af83dac7315);
const $5d43d6affeb19d8a$export$582443c7ead02173 = (value)=>typeof value === 'string' && value !== '';
const $5d43d6affeb19d8a$var$isValidScreenTabId = (internalScreenTabs, id)=>$5d43d6affeb19d8a$export$582443c7ead02173(id) && internalScreenTabs.find((tab)=>tab.id === id) !== undefined;
const $5d43d6affeb19d8a$var$isValidScreenTabIsActive = (isActive)=>typeof isActive === 'boolean' || typeof isActive === 'undefined';
const $5d43d6affeb19d8a$var$isValidScreenTabIsVisible = (isVisible)=>typeof isVisible === 'boolean' || typeof isVisible === 'undefined';
const $5d43d6affeb19d8a$var$isValidScreenTabData = (internalScreenTabs, { id: id, isVisible: isVisible, isActive: isActive })=>$5d43d6affeb19d8a$var$isValidScreenTabId(internalScreenTabs, id) && $5d43d6affeb19d8a$var$isValidScreenTabIsVisible(isVisible) && $5d43d6affeb19d8a$var$isValidScreenTabIsActive(isActive);
const $5d43d6affeb19d8a$var$countNumberOfActiveScreenTabs = (acc, { isActive: isActive })=>{
    if ($5d43d6affeb19d8a$var$isValidScreenTabIsActive(isActive) && isActive) return acc + 1;
    return acc;
};
const $5d43d6affeb19d8a$var$countNumberOfHiddenActiveScreenTabs = (acc, { isActive: isActive, isVisible: isVisible })=>{
    if ($5d43d6affeb19d8a$var$isValidScreenTabIsActive(isActive) && isActive && $5d43d6affeb19d8a$var$isValidScreenTabIsVisible(isVisible) && !isVisible) return acc + 1;
    return acc;
};
const $5d43d6affeb19d8a$export$9ca9b35e7b6a8bbc = (internalScreenTabs, screenTabsFromApp)=>{
    let numberOfActiveScreenTabs = 0;
    const internalActiveScreenTabIndex = internalScreenTabs.findIndex((tab)=>tab.isActive === true);
    const screenTabsInternalUpdated = internalScreenTabs.map((screenTabInternal)=>{
        const screenTabFromApp = screenTabsFromApp.find((tab)=>tab.id === screenTabInternal.id);
        if (!screenTabFromApp) return screenTabInternal;
        numberOfActiveScreenTabs += screenTabFromApp.isActive === true ? 1 : 0;
        return {
            id: screenTabInternal.id,
            isVisible: screenTabFromApp.isVisible ?? true,
            isActive: screenTabFromApp.isActive
        };
    });
    // if no active tab is specified. default to the first
    if (numberOfActiveScreenTabs === 0 && internalActiveScreenTabIndex === -1 && typeof screenTabsInternalUpdated[0]?.isActive !== 'undefined') screenTabsInternalUpdated[0].isActive = true;
    return screenTabsInternalUpdated;
};
const $5d43d6affeb19d8a$export$e7a91e7e430e691a = (internalScreenTabs, screenTabsFromApp)=>{
    if (!Array.isArray(screenTabsFromApp)) return false;
    const screenTabsFromAppFiltered = screenTabsFromApp.filter((data)=>$5d43d6affeb19d8a$var$isValidScreenTabData(internalScreenTabs, data));
    const numberOfActiveScreenTabs = screenTabsFromApp.reduce($5d43d6affeb19d8a$var$countNumberOfActiveScreenTabs, 0);
    const numberOfHiddenActiveScreenTabs = screenTabsFromApp.reduce($5d43d6affeb19d8a$var$countNumberOfHiddenActiveScreenTabs, 0);
    return numberOfActiveScreenTabs <= 1 && screenTabsFromApp.length === screenTabsFromAppFiltered.length && numberOfHiddenActiveScreenTabs === 0;
};
const $5d43d6affeb19d8a$export$62d63af83dac7315 = (internalScreenTabs, screenTabsFromApp)=>{
    if (!internalScreenTabs) return [
        'There are no screen tabs in the current view.'
    ];
    if (!Array.isArray(screenTabsFromApp)) return [
        'Your app must return screen tabs as an array.'
    ];
    const errors = [];
    if (screenTabsFromApp.reduce($5d43d6affeb19d8a$var$countNumberOfActiveScreenTabs, 0) > 1) errors.push('Only one screen tab can be in focus.');
    if (screenTabsFromApp.reduce($5d43d6affeb19d8a$var$countNumberOfHiddenActiveScreenTabs, 0) > 0) errors.push("You can't hide a screen tab that's currently in focus.");
    return errors;
};

});





const $31848aa9a0db89de$export$a763454c55d057f2 = 'jira.user.issue.clickthrough-banner.lastinteracted';
const $31848aa9a0db89de$export$8c6b5c30f78ab338 = 'jira.user.issue.changeboarding.lastinteracted';
const $31848aa9a0db89de$export$5530d4ea250d4125 = 'jira.user.issue.attachment.view';
const $31848aa9a0db89de$export$a274dca8eb47fc4a = 'jira.user.issue.sidebar.resize-ratio';
const $31848aa9a0db89de$export$4c9f7f9f8a4000e1 = 'jira.user.issue.filter.hide-done-subtasks';
const $31848aa9a0db89de$export$2cf981c493d79a21 = 'jira.user.issue.details.activity-layout-setting';
const $31848aa9a0db89de$export$25f5ee1223725a65 = 'jira.user.issue.comment-summaries.enabled';
const $31848aa9a0db89de$export$4936b1621439c095 = 'jira.user.issue.details.details-panel-fields-order';
const $31848aa9a0db89de$export$32a0b5eafccd5141 = 'jira.user.issue.comment-slack-flag.dismissed';

parcelRegister("kI4MM", function(module, exports) {

$parcel$export(module.exports, "useIssueLayoutContainersStore", () => $189406269e224200$export$5c4a1f63cea7b5b3);
$parcel$export(module.exports, "useIssueLayoutGlanceStore", () => $189406269e224200$export$769bbe2bda9a43ce);
$parcel$export(module.exports, "useIssueLayoutContextPanelStore", () => $189406269e224200$export$3aa9017e11451546);
$parcel$export(module.exports, "useIssueLayoutActionsStore", () => $189406269e224200$export$5513f3c310d101f5);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $kjjoM = parcelRequire("kjjoM");
const $189406269e224200$var$getIssueViewLayoutContainers = (state, issueKey)=>state[String(issueKey)]?.containers || [];
const $189406269e224200$var$getIssueViewLayoutGlance = (state, issueKey)=>state[String(issueKey)]?.glance;
const $189406269e224200$var$getIssueViewLayoutContextPanel = (state, issueKey)=>state[String(issueKey)]?.contextPanel;
const $189406269e224200$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'issue-view-layout-service',
    initialState: {},
    actions: $kjjoM
});
const $189406269e224200$export$5c4a1f63cea7b5b3 = (0, $3sQ5x.createHook)($189406269e224200$export$6f57813fe9f31bf9, {
    selector: $189406269e224200$var$getIssueViewLayoutContainers
});
const $189406269e224200$export$769bbe2bda9a43ce = (0, $3sQ5x.createHook)($189406269e224200$export$6f57813fe9f31bf9, {
    selector: $189406269e224200$var$getIssueViewLayoutGlance
});
const $189406269e224200$export$3aa9017e11451546 = (0, $3sQ5x.createHook)($189406269e224200$export$6f57813fe9f31bf9, {
    selector: $189406269e224200$var$getIssueViewLayoutContextPanel
});
const $189406269e224200$export$5513f3c310d101f5 = (0, $3sQ5x.createHook)($189406269e224200$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("kjjoM", function(module, exports) {

$parcel$export(module.exports, "setIssueViewContainersLayout", () => $09c52f32f4231bd8$export$e956c64a7167b73a);
$parcel$export(module.exports, "setIssueViewLayoutGlance", () => $09c52f32f4231bd8$export$6a9b24c2efe66bb7);
$parcel$export(module.exports, "setIssueViewLayoutContextPanel", () => $09c52f32f4231bd8$export$9a04e4b958ebc410);
const $09c52f32f4231bd8$export$e956c64a7167b73a = (issueKey, containersByType)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                containers: containersByType?.containers || []
            }
        });
    };
const $09c52f32f4231bd8$export$6a9b24c2efe66bb7 = (issueKey, glance)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                glance: glance
            }
        });
    };
const $09c52f32f4231bd8$export$9a04e4b958ebc410 = (issueKey, contextPanel)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                contextPanel: contextPanel
            }
        });
    };

});


parcelRegister("cNJ33", function(module, exports) {

$parcel$export(module.exports, "getLayoutItemId", () => $0c6b6ff40aad7732$export$fec1c0749fa149f4);
$parcel$export(module.exports, "filterOutItemsWithProvidedIds", () => $0c6b6ff40aad7732$export$355607dae809ec65);

var $41gqO = parcelRequire("41gqO");
const $0c6b6ff40aad7732$export$fec1c0749fa149f4 = (layoutItem)=>{
    switch(layoutItem.type){
        case (0, $41gqO.layoutContainerItemTypes).field:
            return layoutItem.fieldItemId;
        case (0, $41gqO.layoutContainerItemTypes).panel:
            return layoutItem.panelItemId;
        case (0, $41gqO.layoutContainerItemTypes).tab:
            return layoutItem.tabContainerId;
        default:
            return layoutItem.id;
    }
};
const $0c6b6ff40aad7732$export$355607dae809ec65 = (items, idsToBeFilteredOut)=>{
    const filteredOutIdsSet = new Set(idsToBeFilteredOut);
    return items// Filter out items with the provided Ids
    .filter((item)=>!filteredOutIdsSet.has($0c6b6ff40aad7732$export$fec1c0749fa149f4(item)))// Filter out items with the provided Ids nested in the container tab items
    .map((item)=>{
        if (item.type === (0, $41gqO.layoutContainerItemTypes).tab && item.items?.nodes) return {
            ...item,
            items: {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                nodes: $0c6b6ff40aad7732$export$355607dae809ec65(item.items.nodes, idsToBeFilteredOut)
            }
        };
        return item;
    });
};

});
parcelRegister("41gqO", function(module, exports) {

$parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", () => $b08b2795aecf222d$export$99ad62164189f781);
$parcel$export(module.exports, "FORGE_GLANCE_TYPE", () => $b08b2795aecf222d$export$7719ef6e9283671);
$parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", () => $b08b2795aecf222d$export$bfebea5ce2e1887a);
$parcel$export(module.exports, "FORGE_CONTEXT_TYPE", () => $b08b2795aecf222d$export$be8e68fb1aed253e);
$parcel$export(module.exports, "CONTEXT_AREA", () => $b08b2795aecf222d$export$7bf561e6ab380ea1);
$parcel$export(module.exports, "CONTENT_AREA", () => $b08b2795aecf222d$export$f42c11634d75863e);
$parcel$export(module.exports, "CONTENT_REQUEST_AREA", () => $b08b2795aecf222d$export$b38842736b6dbc1d);
$parcel$export(module.exports, "REACT_KEY_SUMMARY", () => $b08b2795aecf222d$export$605c43f1b33ab69);
$parcel$export(module.exports, "CUSTOM_ITEM_TYPE", () => $b08b2795aecf222d$export$e655b77b9efe622f);
$parcel$export(module.exports, "layoutContainerItemTypes", () => $b08b2795aecf222d$export$5507f31126c8b283);
$parcel$export(module.exports, "isLayoutContainerTabItem", () => $b08b2795aecf222d$export$ad3536b13febb432);
const $b08b2795aecf222d$export$99ad62164189f781 = 'ecosystemGlance';
const $b08b2795aecf222d$export$7719ef6e9283671 = 'forgeGlance';
const $b08b2795aecf222d$export$bfebea5ce2e1887a = 'ecosystemContext';
const $b08b2795aecf222d$export$be8e68fb1aed253e = 'forgeContext';
const $b08b2795aecf222d$export$7bf561e6ab380ea1 = 'context';
const $b08b2795aecf222d$export$f42c11634d75863e = 'content';
const $b08b2795aecf222d$export$b38842736b6dbc1d = 'content-request';
const $b08b2795aecf222d$export$bc9fa2d93b5fabae = 'FIELD';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$STATUS_TYPE = 'STATUS';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$TAB_TYPE = 'TAB';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$PANEL_TYPE = 'PANEL';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$ECOSYSTEM_TYPE = 'ECOSYSTEM';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$FORGE_TYPE = 'FORGE';
const $b08b2795aecf222d$export$605c43f1b33ab69 = 'SUMMARY';
const $b08b2795aecf222d$export$e655b77b9efe622f = 'CustomItem';
const $b08b2795aecf222d$export$5cf403de05e9bea = 'FieldSectionItem';
const $b08b2795aecf222d$export$30f7f9a86f182492 = 'TabLayout';
const $b08b2795aecf222d$export$196e597ad9a97f7a = 'PanelSectionItem';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$ECOSYSTEM_SECTION_ITEM = 'EcosystemSectionItem';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$FORGE_SECTION_ITEM = 'ForgeSectionItem';
const $b08b2795aecf222d$export$5507f31126c8b283 = {
    field: 'JiraIssueItemFieldItem',
    panel: 'JiraIssueItemPanelItem',
    tab: 'JiraIssueItemTabContainer'
};
const $b08b2795aecf222d$export$ad3536b13febb432 = (node)=>node.type === $b08b2795aecf222d$export$5507f31126c8b283.tab;

});



parcelRegister("hhMVP", function(module, exports) {

$parcel$export(module.exports, "getCachedIsCompactValue", () => $cd61c7d28b4f2500$export$c47621d55d10906c);
$parcel$export(module.exports, "setCachedIsCompactValue", () => $cd61c7d28b4f2500$export$568b2dd75c2027b4);
$parcel$export(module.exports, "invalidateCacheIfRouteChanged", () => $cd61c7d28b4f2500$export$a81477a3594bcaab);
// Cleared on window refresh, unique to each window
const $cd61c7d28b4f2500$var$cachedIsCompactValues = {};
let $cd61c7d28b4f2500$var$previousRouteKey;
function $cd61c7d28b4f2500$export$c47621d55d10906c(key) {
    return $cd61c7d28b4f2500$var$cachedIsCompactValues[key];
}
function $cd61c7d28b4f2500$export$568b2dd75c2027b4(isCompactValue, key) {
    $cd61c7d28b4f2500$var$cachedIsCompactValues[key] = isCompactValue;
}
function $cd61c7d28b4f2500$export$a81477a3594bcaab(currentRouteKey) {
    // If we navigate away from the route we can't assume that the cached value will stay valid when we come back
    if (currentRouteKey !== $cd61c7d28b4f2500$var$previousRouteKey) {
        $cd61c7d28b4f2500$var$previousRouteKey = currentRouteKey;
        delete $cd61c7d28b4f2500$var$cachedIsCompactValues[$cd61c7d28b4f2500$var$previousRouteKey];
    }
}

});


parcelRegister("3441h", function(module, exports) {
module.exports = new URL("issue-app-skeleton.tpl.e425fdce.svg", import.meta.url).toString();

});



parcelRegister("gKgRy", function(module, exports) {

$parcel$export(module.exports, "setIssueViewOpenFeedbackMark", () => $5bcb7ccbda2dac65$export$2c1211bae6c14a9);
$parcel$export(module.exports, "setIssueViewOpenFinishMark", () => $5bcb7ccbda2dac65$export$74c6496311688a4d);

var $k12ix = parcelRequire("k12ix");

var $8hVbJ = parcelRequire("8hVbJ");
const $5bcb7ccbda2dac65$export$2c1211bae6c14a9 = ()=>{
    (0, $8hVbJ.issueViewOpenInteraction).mark('feedback');
};
const $5bcb7ccbda2dac65$export$74c6496311688a4d = (isSideBar, backlogCardCount, isCompanyManaged)=>{
    (0, $8hVbJ.issueViewOpenInteraction).stop({
        customData: {
            ...(0, $k12ix.getNormalisedPerformanceFFs)(),
            ...backlogCardCount,
            isSideBar: isSideBar,
            isCompanyManaged: isCompanyManaged
        }
    });
};

});

parcelRegister("56RoY", function(module, exports) {

$parcel$export(module.exports, "PreIssueViewMountFeedbackMark", () => $f7b36c748e55dc2e$export$e17cfe6a40740e70);

var $5uXOq = parcelRequire("5uXOq");

var $8hVbJ = parcelRequire("8hVbJ");
const $f7b36c748e55dc2e$export$e17cfe6a40740e70 = ({ issueKey: issueKey })=>{
    (0, $5uXOq.useEffect)(()=>{
        (0, $8hVbJ.issueViewOpenInteraction).mark('feedbackPreMountEnd');
    }, [
        issueKey
    ]);
    return null;
};

});

parcelRegister("iPF14", function(module, exports) {

let $db5cce6427597049$var$load = (parcelRequire("28QjX"))(4);










module.exports = Promise.all([
    (parcelRequire("avM1e"))('redaction_onboarding_iv_llc', function() {
        return Promise.all([
            $db5cce6427597049$var$load("czPin")
        ]);
    }, function() {
        return Promise.all([
            $db5cce6427597049$var$load("iGvP4")
        ]);
    }),
    (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-small-nodes', function() {
        return Promise.all([
            $db5cce6427597049$var$load("d5z58"),
            $db5cce6427597049$var$load("kvRbA"),
            $db5cce6427597049$var$load("ffQaD"),
            $db5cce6427597049$var$load("l253H"),
            $db5cce6427597049$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $db5cce6427597049$var$load("f771T")
        ]);
    }),
    (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-media-nodes', function() {
        return Promise.all([
            $db5cce6427597049$var$load("gXEyJ"),
            $db5cce6427597049$var$load("l253H"),
            $db5cce6427597049$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $db5cce6427597049$var$load("hy7ba")
        ]);
    }),
    (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-card-nodes', function() {
        return Promise.all([
            $db5cce6427597049$var$load("lh7CA"),
            $db5cce6427597049$var$load("kNFvF"),
            $db5cce6427597049$var$load("kvRbA"),
            $db5cce6427597049$var$load("ffQaD"),
            $db5cce6427597049$var$load("l253H"),
            $db5cce6427597049$var$load("76n7a"),
            $db5cce6427597049$var$load("fliVL")
        ]);
    }, function() {
        return Promise.all([
            $db5cce6427597049$var$load("jrRVX")
        ]);
    }),
    (parcelRequire("avM1e"))('jira_amplitude_sr', function() {
        return Promise.all([
            $db5cce6427597049$var$load("8EtZR"),
            $db5cce6427597049$var$load("kVX56")
        ]);
    }, function() {
        return Promise.all([
            $db5cce6427597049$var$load("6jOz3")
        ]);
    }),
    (parcelRequire("avM1e"))('details_loader_to_entrypoint_iv_llc_dev_panel', function() {
        return Promise.all([
            $db5cce6427597049$var$load("84z1X")
        ]);
    }, function() {
        return Promise.all([
            $db5cce6427597049$var$load("eBkr0")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $db5cce6427597049$var$load("czifk"),
            $db5cce6427597049$var$load("kvRbA"),
            $db5cce6427597049$var$load("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $db5cce6427597049$var$load("kcs34")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $db5cce6427597049$var$load("cTJTG"),
            $db5cce6427597049$var$load("l253H"),
            $db5cce6427597049$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $db5cce6427597049$var$load("4Qxp7")
        ]);
    }),
    (parcelRequire("avM1e"))('improve_rendering_child_issues_summary_bar', function() {
        return Promise.all([
            $db5cce6427597049$var$load("juSGb")
        ]);
    }, function() {
        return Promise.all([
            $db5cce6427597049$var$load("5FVQh")
        ]);
    }),
    (parcelRequire("avM1e"))('link_paste_recommendations', function() {
        return Promise.all([]);
    }, function() {
        return Promise.all([
            $db5cce6427597049$var$load("7ClEP")
        ]);
    }),
    $db5cce6427597049$var$load("3yAl4"),
    $db5cce6427597049$var$load("fliVL"),
    $db5cce6427597049$var$load("7mIf9"),
    $db5cce6427597049$var$load("jXweD"),
    $db5cce6427597049$var$load("jbxE1"),
    $db5cce6427597049$var$load("7imUH"),
    $db5cce6427597049$var$load("kVX56"),
    $db5cce6427597049$var$load("kNFvF"),
    $db5cce6427597049$var$load("ffQaD"),
    $db5cce6427597049$var$load("kvRbA"),
    $db5cce6427597049$var$load("76n7a"),
    $db5cce6427597049$var$load("l253H"),
    $db5cce6427597049$var$load("gaip1")
]).then(()=>parcelRequire('6qbjz'));

});


parcelRegister("kGoMd", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a52c2d89f45d4a6$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $FTaAj = parcelRequire("FTaAj");

var $9PAwV = parcelRequire("9PAwV");

var $lfTZh = parcelRequire("lfTZh");

var $3bPZM = parcelRequire("3bPZM");

var $jQ7vZ = parcelRequire("jQ7vZ");

var $f6RVN = parcelRequire("f6RVN");


var $fSgHa = parcelRequire("fSgHa");

var $czw5V = parcelRequire("czw5V");

var $c060Z = parcelRequire("c060Z");

var $lXGRu = parcelRequire("lXGRu");

var $64dTY = parcelRequire("64dTY");

var $5KJMz = parcelRequire("5KJMz");
const $6a52c2d89f45d4a6$var$REFETCH_EPIC_PANELS_EVENTS = [
    (0, $FTaAj.ChangeEventTypes).FIELD_CHANGED,
    (0, $FTaAj.ChangeEventTypes).ISSUE_RELATIONSHIP_UPDATED,
    (0, $FTaAj.ChangeEventTypes).CHILD_ISSUE_ADDED,
    (0, $FTaAj.ChangeEventTypes).ISSUE_TYPE_CHANGED
];
const $6a52c2d89f45d4a6$export$d51fb174c0dd91e9 = ({ parentWidth: parentWidth, cardKey: cardKey, rapidViewId: rapidViewId, onClose: onClose, onChange: onChange, onDelete: onDelete, timestamp: timestamp, onCloseInsightsClick: onCloseInsightsClick, onCloseViewSettingsPanelClick: onCloseViewSettingsPanelClick, isBacklogWithSprints: isBacklogWithSprints, externalAction: externalAction, backlogSessionId: backlogSessionId, IssueWrapper: IssueWrapper })=>{
    const [issueKey, setIssueKey] = (0, $jQ7vZ.useQueryParam)((0, $4f4a02cead13bb5a$export$3a0c4bc79274bbaa));
    const issueKeyOrCardKey = issueKey || cardKey;
    const onIssueKeyChange = (0, $5uXOq.useCallback)(({ toIssueKey: toIssueKey })=>setIssueKey(toIssueKey), [
        setIssueKey
    ]);
    const isInsightsOpen = (0, $czw5V.useIsInsightsPanelOpen)();
    const isViewSettingsPanelOpen = (0, $c060Z.useIsViewSettingsPanelOpen)();
    const isCompanyManaged = (0, $fSgHa.useIsCMPBacklog)();
    const [_, { triggerEpicPanelRefetch: triggerEpicPanelRefetch }] = (0, $3bPZM.useShouldRefetchEpicPanel)();
    const handleChange = (0, $5uXOq.useCallback)((event)=>{
        onChange(event);
        if (isCompanyManaged && $6a52c2d89f45d4a6$var$REFETCH_EPIC_PANELS_EVENTS.includes(event.type)) triggerEpicPanelRefetch();
    }, [
        isCompanyManaged,
        onChange,
        triggerEpicPanelRefetch
    ]);
    const handleIssueDelete = (0, $5uXOq.useCallback)((data)=>{
        onDelete(data);
        if (isCompanyManaged) triggerEpicPanelRefetch();
    }, [
        isCompanyManaged,
        onDelete,
        triggerEpicPanelRefetch
    ]);
    const getBacklogInsightsPanel = (0, $5uXOq.useCallback)(()=>isInsightsOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6a52c2d89f45d4a6$var$DetailsPanelContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: "backlog-insights-panel",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lXGRu.AsyncBacklogInsightsPanel), {
            isOpen: isInsightsOpen,
            onClose: onCloseInsightsClick
        })))) : null, [
        isInsightsOpen,
        onCloseInsightsClick
    ]);
    const getBacklogViewSettingsPanel = (0, $5uXOq.useCallback)(()=>isViewSettingsPanelOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $6a52c2d89f45d4a6$var$ViewSettingsPanelContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KJMz.ViewSettingsPanel), {
            isPanelOpen: isViewSettingsPanelOpen,
            onPanelClose: onCloseViewSettingsPanelClick
        })) : null, [
        isViewSettingsPanelOpen,
        onCloseViewSettingsPanelClick
    ]);
    return (0, $f6RVN.isViewSettingAsPanelExpEnabledWithNoExposure)() && isViewSettingsPanelOpen ? getBacklogViewSettingsPanel() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9PAwV.JiraDetailPanel), null, (setDetailPanelWidth)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $64dTY.Resizer), {
            parentWidth: parentWidth,
            onResize: setDetailPanelWidth
        }, issueKeyOrCardKey !== null && issueKeyOrCardKey !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6a52c2d89f45d4a6$var$DetailsWrapper, {
            hide: isInsightsOpen
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IssueWrapper, {
            key: issueKeyOrCardKey + timestamp,
            issueKey: issueKeyOrCardKey,
            onClose: onClose,
            onChange: handleChange,
            onIssueDeleteSuccess: handleIssueDelete,
            rapidViewId: Number(rapidViewId),
            isAgilityBoard: true,
            isLoadedWithPage: true,
            onIssueKeyChange: onIssueKeyChange,
            history: null,
            externalAction: externalAction,
            backlogSessionId: backlogSessionId
        })), isBacklogWithSprints && getBacklogInsightsPanel()));
};
var $6a52c2d89f45d4a6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($6a52c2d89f45d4a6$export$d51fb174c0dd91e9);
const $6a52c2d89f45d4a6$var$ViewSettingsPanelContainerStyles = (0, $8CUq3.xcss)({
    overflowX: 'hidden',
    overflowY: 'auto',
    paddingRight: 'space.500',
    paddingLeft: 'space.300',
    paddingBottom: 'space.300'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6a52c2d89f45d4a6$var$DetailsWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hide: hide, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _4t3i1osq _1reo15vq",
            __cmplp.hide && "_1e0cglyw",
            __cmplp.className
        ])
    });
});
const $6a52c2d89f45d4a6$var$DetailsPanelContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _kqswh2mm _4t3i1osq _1reo15vq _18m915zi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9PAwV", function(module, exports) {

$parcel$export(module.exports, "JiraDetailPanel", () => $90f8c6fec93ae563$export$93acb63f4e179357);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $34ck9 = parcelRequire("34ck9");

var $b71gk = parcelRequire("b71gk");

var $5e5zm = parcelRequire("5e5zm");
const $90f8c6fec93ae563$var$DetailPanel = ({ children: children, panelWidth: panelWidth })=>{
    const { setWidth: setWidth } = (0, $5e5zm.useDetailPanelActions)();
    (0, $5uXOq.useEffect)(()=>{
        if (panelWidth !== undefined) setWidth(panelWidth);
        return ()=>setWidth(0);
    }, [
        panelWidth,
        setWidth
    ]);
    const throttleSetWidth = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))(setWidth, 50, {
            leading: true,
            trailing: true
        }), [
        setWidth
    ]);
    return typeof children === 'function' ? children(throttleSetWidth) : children;
};
const $90f8c6fec93ae563$export$93acb63f4e179357 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "jira-detail-panel",
        packageName: "jira-bottom-right-corner-controller",
        render: ()=>typeof props.children === 'function' ? props.children((0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))) : props.children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($90f8c6fec93ae563$var$DetailPanel, props));

});

parcelRegister("lXGRu", function(module, exports) {

$parcel$export(module.exports, "AsyncBacklogInsightsPanel", () => $7e3676499c49c6c4$export$ad767ebad8b61f5b);

var $kxZPA = parcelRequire("kxZPA");

const $7e3676499c49c6c4$export$ad767ebad8b61f5b = (0, $kxZPA.lazy)(()=>(parcelRequire("ckr6k")).then((module)=>module.default), {
    moduleId: "./src/packages/software/backlog/src/view/backlog-content/insights-panel/index.tsx"
});

});
parcelRegister("ckr6k", function(module, exports) {

let $8f9c5ffe0908f6de$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8f9c5ffe0908f6de$var$load("7Dqsm").then(()=>parcelRequire('jWG5D'));

});


parcelRegister("64dTY", function(module, exports) {

$parcel$export(module.exports, "Resizer", () => $3746486a9e6a787e$export$48a76196cafe3b93);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $7wqBZ = parcelRequire("7wqBZ");

var $bv8GQ = parcelRequire("bv8GQ");

var $7D59a = parcelRequire("7D59a");

var $4R6GH = parcelRequire("4R6GH");

var $3FUwR = parcelRequire("3FUwR");
const $3746486a9e6a787e$export$a497a0788dce8ef4 = 495;
const $3746486a9e6a787e$export$b4e0432c87affda2 = 440;
const $3746486a9e6a787e$export$177615fff7f0b5c6 = 440;
// remove getMinDetailsWidthIssue and update value in MIN_DETAILS_WIDTH_ISSUE when fix_reply_editor_width is cleaned up
const $3746486a9e6a787e$var$getMinDetailsWidthIssue = ()=>{
    return (0, $4R6GH.fg)('fix_reply_editor_width') ? $3746486a9e6a787e$export$a497a0788dce8ef4 : $3746486a9e6a787e$export$b4e0432c87affda2;
};
function $3746486a9e6a787e$export$48a76196cafe3b93({ setWidth: widthProp, onResize: onResize, children: children, parentWidth: parentWidth, onResizeEnd: onResizeEnd }) {
    const [width, setWidth] = (0, $5uXOq.useState)(()=>{
        const initValue = (0, $3FUwR.getDetailViewWidthRatio)();
        return Math.max(parentWidth * initValue, $3746486a9e6a787e$var$getMinDetailsWidthIssue());
    });
    const startX = (0, $5uXOq.useRef)(0);
    const extraWidth = (0, $5uXOq.useRef)(0);
    (0, $5uXOq.useEffect)(()=>{
        const initValue = (0, $3FUwR.getDetailViewWidthRatio)();
        setWidth(Math.max(parentWidth * initValue, $3746486a9e6a787e$var$getMinDetailsWidthIssue()));
    }, [
        parentWidth
    ]);
    (0, $5uXOq.useEffect)(()=>{
        onResize?.(widthProp !== undefined && widthProp !== 0 ? widthProp : width);
    }, [
        onResize,
        width,
        widthProp
    ]);
    const onMouseUp = (0, $7D59a.useEvent)(()=>{
        startX.current = 0;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.removeEventListener('mousemove', onMouseMove);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.removeEventListener('mouseup', onMouseUp);
        const widthRatio = width === $3746486a9e6a787e$var$getMinDetailsWidthIssue() ? 0 : width / parentWidth;
        (0, $3FUwR.setDetailViewWidthRatio)(widthRatio);
        (0, $7wqBZ.getLongTasksMetrics)('detail-view-resizer').stop((0, $bv8GQ.softwareGenericLongTasksReporter)('detail-view-resizer'));
        onResizeEnd && onResizeEnd(width / parentWidth);
    });
    const onMouseDown = (0, $7D59a.useEvent)((e)=>{
        startX.current = e.clientX + (width - $3746486a9e6a787e$var$getMinDetailsWidthIssue());
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('mousemove', onMouseMove);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('mouseup', onMouseUp);
        (0, $7wqBZ.getLongTasksMetrics)('detail-view-resizer').start('jira-backlog-detail-view-resizer');
    });
    const onMouseMove = (0, $7D59a.useEvent)((e)=>{
        extraWidth.current = Math.max(startX.current - e.clientX, 0);
        const newValue = Math.min($3746486a9e6a787e$var$getMinDetailsWidthIssue() + extraWidth.current, parentWidth / 2);
        if (newValue === width) return;
        setWidth(newValue);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $3746486a9e6a787e$var$containerStyle,
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            width: widthProp != null && widthProp !== 0 ? widthProp : width
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $3746486a9e6a787e$var$resizeHandleStyle,
        onMouseDown: onMouseDown,
        testId: "software-backlog.detail-view.resizer.resize-handle"
    }), children);
}
const $3746486a9e6a787e$var$containerStyle = (0, $8CUq3.xcss)({
    overflowY: 'auto',
    overflowX: 'hidden',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start'
});
const $3746486a9e6a787e$var$resizeHandleStyle = (0, $8CUq3.xcss)({
    width: "var(--ds-space-100, 8px)",
    cursor: 'ew-resize',
    borderLeftStyle: 'solid',
    borderLeftWidth: '2px',
    borderLeftColor: 'transparent',
    alignSelf: 'stretch',
    ':hover': {
        borderLeftColor: 'color.border.focused'
    },
    ':focus': {
        borderLeftColor: 'color.border.focused'
    },
    transition: 'border-color 0.5s'
});

});

parcelRegister("5KJMz", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsPanel", () => $715312da2e3c3528$export$3a81a9760a380951);

var $5uXOq = parcelRequire("5uXOq");

var $gccSB = parcelRequire("gccSB");

var $a4XJc = parcelRequire("a4XJc");

var $jB6yt = parcelRequire("jB6yt");

var $a7yHf = parcelRequire("a7yHf");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $9Pc1U = parcelRequire("9Pc1U");

var $l9VFH = parcelRequire("l9VFH");

var $1z1J7 = parcelRequire("1z1J7");

var $fpDLy = parcelRequire("fpDLy");

var $le1bQ = parcelRequire("le1bQ");

var $k35me = parcelRequire("k35me");
const $715312da2e3c3528$export$3a81a9760a380951 = ({ isPanelOpen: isPanelOpen, onPanelClose: onPanelClose })=>{
    const boardId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getRapidViewId));
    const isCMPBoard = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
    const showEpicAsPanel = (0, $c1MAf.useBacklogSelector)((0, $9Pc1U.getShowEpicAsPanel));
    const allCardGroups = (0, $le1bQ.useAllCardGroups)();
    const isQuickFiltersAvailable = (0, $c1MAf.useBacklogSelector)((0, $l9VFH.getCMPFilters)).length > 0;
    const isVersionsEnabled = (0, $c1MAf.useBacklogSelector)((0, $fpDLy.isVersionsFeatureEnabled));
    const showFilterBarToggle = isCMPBoard && isQuickFiltersAvailable;
    const config = (0, $c1MAf.useBacklogSelector)((0, $9Pc1U.getConfig));
    const epicCustomName = config.hierarchyNomenclature?.firstLevelName;
    const canEdit = (0, $c1MAf.useBacklogSelector)((0, $1z1J7.canEditBoardConfig));
    const shouldShowSubtasks = (0, $5uXOq.useMemo)(()=>!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(allCardGroups), [
        allCardGroups
    ]);
    const areAllSubtasksExpanded = (0, $5uXOq.useMemo)(()=>allCardGroups.every((card)=>!card.isCollapsed), [
        allCardGroups
    ]);
    const areAllSubtasksCollapsed = (0, $5uXOq.useMemo)(()=>allCardGroups.every((card)=>card.isCollapsed), [
        allCardGroups
    ]);
    const handleExpandSubtasks = (0, $c1MAf.useBacklogActionCreator)(()=>(0, $a7yHf.setExpandedCardGroups)(allCardGroups.map((card)=>card.parentId.toString())));
    const handleCollapseSubtasks = (0, $c1MAf.useBacklogActionCreator)(()=>(0, $a7yHf.collapseAllCardGroups)());
    const cardExtraFields = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCardExtraFields));
    const hasCardsWithStoryPoint = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasStoryPoints));
    const hasCardsWithEstimate = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasEstimates));
    const isDueDateEnabled = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasDueDate));
    const isPriorityEnabled = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasPriority));
    const isShowBoardNameEnabled = (0, $c1MAf.useBacklogSelector)((0, $k35me.makeIsShowBoardNameVisible));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jB6yt.default), {
        view: (0, $a4XJc.View).BACKLOG,
        viewAs: (0, $a4XJc.ViewAs).PANEL,
        isViewPanelOpen: isPanelOpen,
        onViewPanelClose: onPanelClose,
        boardId: Number(boardId),
        isClassic: isCMPBoard,
        areSubtasksEnabled: isCMPBoard && shouldShowSubtasks,
        onSubtasksExpandAll: handleExpandSubtasks,
        onSubtasksCollapseAll: handleCollapseSubtasks,
        areAllSubtasksExpanded: areAllSubtasksExpanded,
        areAllSubtasksCollapsed: areAllSubtasksCollapsed,
        showEpicAsPanel: showEpicAsPanel,
        epicCustomName: epicCustomName,
        isVersionsEnabled: isVersionsEnabled,
        showFilterBarToggle: showFilterBarToggle,
        cardExtraFields: cardExtraFields,
        isEstimateEnabled: hasCardsWithStoryPoint || hasCardsWithEstimate,
        isDueDateEnabled: isDueDateEnabled,
        isPriorityEnabled: isPriorityEnabled,
        isAddPeopleButtonEnabled: canEdit,
        isShowBoardNameEnabled: isShowBoardNameEnabled
    });
};

});
parcelRegister("jB6yt", function(module, exports) {

$parcel$export(module.exports, "default", () => $36c97328c4dc150e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $MHKc7 = parcelRequire("MHKc7");

var $jgJNO = parcelRequire("jgJNO");

var $7CMCs = parcelRequire("7CMCs");

var $1v6HV = parcelRequire("1v6HV");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");

var $hchBL = parcelRequire("hchBL");

var $duOMW = parcelRequire("duOMW");

var $4cYhQ = parcelRequire("4cYhQ");

var $a4XJc = parcelRequire("a4XJc");

var $lngWe = parcelRequire("lngWe");

var $3uPqt = parcelRequire("3uPqt");

var $cYeCp = parcelRequire("cYeCp");

var $5iXkq = parcelRequire("5iXkq");

var $jCs82 = parcelRequire("jCs82");

var $1wxxD = parcelRequire("1wxxD");

var $8vQbt = parcelRequire("8vQbt");

var $iDGXn = parcelRequire("iDGXn");

var $3ykoc = parcelRequire("3ykoc");

var $38RF4 = parcelRequire("38RF4");

var $2ucDS = parcelRequire("2ucDS");

const $36c97328c4dc150e$var$ViewSettings = ({ view: view, boardId: boardId, isClassic: isClassic, epicCustomName: epicCustomName, showEpicAsPanel: showEpicAsPanel = false, showFilterBarToggle: showFilterBarToggle = false, showCardDetails: showCardDetails = true, isVersionsEnabled: isVersionsEnabled = false, viewAs: viewAs = (0, $a4XJc.ViewAs).POPUP, isViewPanelOpen: isViewPanelOpen = false, onViewPanelClose: onViewPanelClose = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), areSubtasksEnabled: areSubtasksEnabled, onSubtasksExpandAll: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onSubtasksExpandAll = ()=>{}, onSubtasksCollapseAll: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onSubtasksCollapseAll = ()=>{}, onToggleWorkSuggestions: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onToggleWorkSuggestions = ()=>{}, onLinkedIssuesStatsToggledOn: // eslint-disable-next-line @typescript-eslint/no-empty-function
onLinkedIssuesStatsToggledOn = ()=>{}, onShowCardCoversToggledOn: // eslint-disable-next-line @typescript-eslint/no-empty-function
onShowCardCoversToggledOn = ()=>{}, areAllSubtasksExpanded: areAllSubtasksExpanded = false, areAllSubtasksCollapsed: areAllSubtasksCollapsed = false, isSwimlanesEnabled: isSwimlanesEnabled = false, onSwimlaneExpandAll: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onSwimlaneExpandAll = ()=>{}, onSwimlaneCollapseAll: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onSwimlaneCollapseAll = ()=>{}, isDaysInColumnEnabled: isDaysInColumnEnabled = false, showLinkedIssueStatsToggle: showLinkedIssueStatsToggle = false, cardExtraFields: cardExtraFields = [], isEstimateEnabled: isEstimateEnabled = false, isDueDateEnabled: isDueDateEnabled = false, isLabelsEnabled: isLabelsEnabled = false, isPriorityEnabled: isPriorityEnabled = false, isDevelopmentEnabled: isDevelopmentEnabled = false, isWorkSuggestionsEnabled: isWorkSuggestionsEnabled = false, showWorkSuggestions: showWorkSuggestions = false, dependencyIssueOptions: dependencyIssueOptions = {}, analyticsData: analyticsData, isShowBoardNameEnabled: isShowBoardNameEnabled, shouldRenderPopupToParent: shouldRenderPopupToParent, isThemed: isThemed = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const sendAnalyticsEvent = (0, $3uPqt.useSendAnalyticsEvent)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const panelRef = (0, $5uXOq.useRef)(null);
    const [{ activeViewSettingsSpotlight: activeViewSettingsSpotlight }, { setOpenViewSettings: setOpenViewSettings, onViewSettingsSpotlightEnd: onViewSettingsSpotlightEnd }] = (0, $1v6HV.useBoardWorkSuggestionsSpotlightContainer)();
    const handleViewPanelClose = ()=>{
        onViewPanelClose();
    };
    const handleClose = ()=>{
        setIsOpen(false);
        if (activeViewSettingsSpotlight === 1 && onViewSettingsSpotlightEnd) // To end the spotlight if the popup is closed
        onViewSettingsSpotlightEnd();
    };
    const handleClick = ()=>{
        setIsOpen(!isOpen);
        sendAnalyticsEvent('clicked', 'button', (0, $4cYhQ.AnalyticsEvent).UI_EVENT, {
            isClassic: isClassic,
            app: view
        }, viewAs === (0, $a4XJc.ViewAs).PANEL && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() ? (0, $a4XJc.ViewAs).PANEL : 'popupMenu');
    };
    const openViewSettings = (0, $5uXOq.useCallback)(()=>{
        if (isOpen) return;
        setIsOpen(true);
        sendAnalyticsEvent('clicked', 'button', (0, $4cYhQ.AnalyticsEvent).UI_EVENT, {
            isClassic: isClassic,
            app: view
        }, viewAs === (0, $a4XJc.ViewAs).PANEL && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() ? (0, $a4XJc.ViewAs).PANEL : 'popupMenu');
    }, [
        sendAnalyticsEvent,
        isClassic,
        view,
        viewAs,
        isOpen
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (setOpenViewSettings) setOpenViewSettings(openViewSettings);
    }, [
        openViewSettings,
        setOpenViewSettings
    ]);
    const viewSettingsBtnLG = (0, $hchBL.useGlobalRef)((0, $duOMW.VIEW_SETTINGS_BUTTON_LG))[0];
    const viewSettingsBtnSM = (0, $hchBL.useGlobalRef)((0, $duOMW.VIEW_SETTINGS_BUTTON_SM))[0];
    const viewSettingsBtnResponsive = (0, $hchBL.useGlobalRef)((0, $duOMW.VIEW_SETTINGS_BUTTON_RESPONSIVE))[0];
    const [, { register: register }] = (0, $hchBL.useGlobalRefStoreActions)();
    (0, $5uXOq.useEffect)(()=>{
        // register view settings panel global ref
        register((0, $3795a016b6403547$export$989661c424340ff8), panelRef.current);
        const focusOnCloseButton = ()=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const closeButton = panelRef.current?.querySelector(`[data-testid="${(0, $duOMW.VIEW_SETTINGS_PANEL_CLOSE_BUTTON_TEST_ID)}"]`);
            closeButton?.focus();
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (document.activeElement === viewSettingsBtnLG) {
            focusOnCloseButton();
            return ()=>viewSettingsBtnLG?.focus();
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (document.activeElement === viewSettingsBtnSM) {
            focusOnCloseButton();
            return ()=>viewSettingsBtnSM?.focus();
        }
        if (// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.activeElement === viewSettingsBtnResponsive) {
            focusOnCloseButton();
            return ()=>viewSettingsBtnResponsive?.focus();
        }
    }, [
        register,
        viewSettingsBtnLG,
        viewSettingsBtnResponsive,
        viewSettingsBtnSM
    ]);
    const conditionallyRenderViewSettingsButtonWithAria = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38RF4.ViewSettingsButton), {
            isSelected: isOpen,
            onClick: handleClick,
            isThemedButton: isThemed,
            ...props
        });
    const viewAsPopup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        messageId: "software-view-settings.ui.popup",
        messageType: "transactional",
        "data-testid": "software-view-settings.ui.popup",
        isOpen: isOpen,
        onClose: handleClose,
        placement: "bottom-end",
        content: (props)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2ucDS.ViewSettingsMenu), {
                view: view,
                viewAs: (0, $a4XJc.ViewAs).POPUP,
                boardId: boardId,
                isClassic: isClassic,
                showFilterBarToggle: showFilterBarToggle,
                showEpicAsPanel: showEpicAsPanel,
                epicCustomName: epicCustomName,
                showCardDetails: showCardDetails,
                isWorkSuggestionsEnabled: isWorkSuggestionsEnabled,
                showWorkSuggestions: showWorkSuggestions,
                isVersionsEnabled: isVersionsEnabled,
                areSubtasksEnabled: areSubtasksEnabled,
                onSubtasksExpandAll: onSubtasksExpandAll,
                onSubtasksCollapseAll: onSubtasksCollapseAll,
                areAllSubtasksExpanded: areAllSubtasksExpanded,
                areAllSubtasksCollapsed: areAllSubtasksCollapsed,
                isSwimlanesEnabled: isSwimlanesEnabled,
                onSwimlaneExpandAll: onSwimlaneExpandAll,
                onSwimlaneCollapseAll: onSwimlaneCollapseAll,
                onToggleWorkSuggestions: onToggleWorkSuggestions,
                showLinkedIssueStatsToggle: showLinkedIssueStatsToggle,
                onLinkedIssuesStatsToggledOn: onLinkedIssuesStatsToggledOn,
                onShowCardCoversToggledOn: onShowCardCoversToggledOn,
                dependencyIssueOptions: dependencyIssueOptions,
                onUpdate: props.update,
                onClose: props.onClose,
                analyticsData: analyticsData,
                isShowBoardNameEnabled: isShowBoardNameEnabled
            });
        },
        shouldRenderToParent: shouldRenderPopupToParent,
        trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
                ref: ref
            }, conditionallyRenderViewSettingsButtonWithAria({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup
            }))
    });
    const viewAsPanel = isViewPanelOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: panelRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lngWe.Panel), {
        title: formatMessage((0, $3ykoc.default).panelTitle),
        onClose: handleViewPanelClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2ucDS.ViewSettingsMenu), {
        view: view,
        viewAs: (0, $a4XJc.ViewAs).PANEL,
        boardId: boardId,
        isClassic: isClassic,
        showFilterBarToggle: showFilterBarToggle,
        showEpicAsPanel: showEpicAsPanel,
        epicCustomName: epicCustomName,
        showCardDetails: showCardDetails,
        isVersionsEnabled: isVersionsEnabled,
        isWorkSuggestionsEnabled: isWorkSuggestionsEnabled,
        showWorkSuggestions: showWorkSuggestions,
        areSubtasksEnabled: areSubtasksEnabled,
        onSubtasksExpandAll: onSubtasksExpandAll,
        onSubtasksCollapseAll: onSubtasksCollapseAll,
        areAllSubtasksExpanded: areAllSubtasksExpanded,
        areAllSubtasksCollapsed: areAllSubtasksCollapsed,
        isSwimlanesEnabled: isSwimlanesEnabled,
        onSwimlaneExpandAll: onSwimlaneExpandAll,
        onSwimlaneCollapseAll: onSwimlaneCollapseAll,
        onToggleWorkSuggestions: onToggleWorkSuggestions,
        isDaysInColumnEnabled: isDaysInColumnEnabled,
        showLinkedIssueStatsToggle: showLinkedIssueStatsToggle,
        cardExtraFields: cardExtraFields,
        isEstimateEnabled: isEstimateEnabled,
        isDueDateEnabled: isDueDateEnabled,
        isLabelsEnabled: isLabelsEnabled,
        isPriorityEnabled: isPriorityEnabled,
        isDevelopmentEnabled: isDevelopmentEnabled,
        onLinkedIssuesStatsToggledOn: onLinkedIssuesStatsToggledOn,
        onShowCardCoversToggledOn: onShowCardCoversToggledOn,
        dependencyIssueOptions: dependencyIssueOptions,
        analyticsData: analyticsData,
        isShowBoardNameEnabled: isShowBoardNameEnabled
    })));
    (0, $jCs82.useOnBacklog)(boardId, view, showEpicAsPanel, isVersionsEnabled);
    (0, $8vQbt.useSyncFromLocalStorage)(boardId, view, cardExtraFields, isDaysInColumnEnabled, isDueDateEnabled, isLabelsEnabled, isEstimateEnabled, isPriorityEnabled);
    (0, $5iXkq.useCardDetailsInitialState)(boardId, view, isDaysInColumnEnabled, isDueDateEnabled, isLabelsEnabled, isEstimateEnabled, isPriorityEnabled);
    // Initialise local storage for Increment Planning board
    (0, $1wxxD.useOnIncrementPlanningBoard)(boardId, view, dependencyIssueOptions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: viewAs === (0, $a4XJc.ViewAs).PANEL ? 'viewSettingsPanel' : 'viewSettingsMenu',
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iDGXn.ViewSettingsContainer), {
        view: view,
        isGlobal: true
    }, viewAs === (0, $a4XJc.ViewAs).PANEL && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() ? viewAsPanel : viewAsPopup));
};
const $36c97328c4dc150e$var$ViewSettingsWithErrorBoundary = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "errorBoundary",
        packageName: "jiraSoftwareViewSettings",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($36c97328c4dc150e$var$ViewSettings, props));
var $36c97328c4dc150e$export$2e2bcd8739ae039 = $36c97328c4dc150e$var$ViewSettingsWithErrorBoundary;

});
parcelRegister("1v6HV", function(module, exports) {

$parcel$export(module.exports, "BoardWorkSuggestionsSpotlightContainer", () => $335a8c33b51043c3$export$f2c5bcc872636b8b);
$parcel$export(module.exports, "useBoardWorkSuggestionsSpotlightContainer", () => $335a8c33b51043c3$export$bb014eea394e52e2);
$parcel$export(module.exports, "useBoardWorkSuggestionsSpotlightActions", () => $335a8c33b51043c3$export$a4afcad29be76e47);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
var $bKpgX = parcelRequire("bKpgX");

var $j2ixf = parcelRequire("j2ixf");
const $335a8c33b51043c3$var$initialState = {
    activeViewSettingsSpotlight: null,
    hasViewedViewSettingsSpotlight: true,
    openViewSettings: null,
    viewSettingsTogglePulses: false
};
const $335a8c33b51043c3$var$Store = (0, $iXqE5.createStore)({
    initialState: $335a8c33b51043c3$var$initialState,
    actions: $j2ixf.actions,
    name: 'jsw.board.work-suggestions-spotlight-store'
});
const $335a8c33b51043c3$export$272a3bae21574897 = ()=>(0, $bKpgX.defaultRegistry).deleteStore($335a8c33b51043c3$var$Store);
const $335a8c33b51043c3$export$f2c5bcc872636b8b = (0, $gg7kZ.createContainer)($335a8c33b51043c3$var$Store);
const $335a8c33b51043c3$export$bb014eea394e52e2 = (0, $3sQ5x.createHook)($335a8c33b51043c3$var$Store);
const $335a8c33b51043c3$export$a4afcad29be76e47 = (0, $3sQ5x.createActionsHook)($335a8c33b51043c3$var$Store);

});
parcelRegister("j2ixf", function(module, exports) {

$parcel$export(module.exports, "actions", () => $cfc7cb03065719c0$export$e324594224ef24da);
const $cfc7cb03065719c0$export$e324594224ef24da = {
    onViewSettingsSpotlightInit: ()=>({ setState: setState })=>{
            setState({
                hasViewedViewSettingsSpotlight: false
            });
        },
    onViewSettingsSpotlightStart: ()=>({ setState: setState })=>{
            setState({
                activeViewSettingsSpotlight: 0
            });
        },
    onViewSettingsSpotlightNext: ()=>({ setState: setState })=>{
            setState({
                activeViewSettingsSpotlight: 1
            });
        },
    onViewSettingsSpotlightEnd: ()=>({ setState: setState })=>{
            setState({
                hasViewedViewSettingsSpotlight: true,
                activeViewSettingsSpotlight: null
            });
        },
    setOpenViewSettings: (openViewSettingsCallback)=>({ getState: getState, setState: setState })=>{
            if (!getState().openViewSettings) setState({
                openViewSettings: openViewSettingsCallback
            });
        },
    setViewSettingsTogglePulses: (viewSettingsTogglePulses)=>({ setState: setState })=>{
            setState({
                viewSettingsTogglePulses: viewSettingsTogglePulses
            });
        }
};

});


parcelRegister("hchBL", function(module, exports) {

$parcel$export(module.exports, "useGlobalRef", () => $b03364e48d8512c5$export$361e4f658203e95);
$parcel$export(module.exports, "useGlobalRefStoreActions", () => $b03364e48d8512c5$export$3c6c6911d09d7d8a);
$parcel$export(module.exports, "withGlobalRef", () => $b03364e48d8512c5$export$6b4b878b04fd3017);

var $5uXOq = parcelRequire("5uXOq");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $b03364e48d8512c5$var$store = (0, $iXqE5.createStore)({
    initialState: {},
    actions: {
        register: (key, ref)=>({ setState: setState })=>{
                setState({
                    [key]: ref || undefined
                });
            }
    },
    name: 'refs-store'
});
const $b03364e48d8512c5$export$4beaa3baa53198e4 = (0, $gg7kZ.createContainer)($b03364e48d8512c5$var$store);
const $b03364e48d8512c5$var$useGlobalRefStateSelector = (0, $3sQ5x.createStateHook)($b03364e48d8512c5$var$store, {
    selector: (state, key)=>state[key]
});
const $b03364e48d8512c5$export$361e4f658203e95 = (key)=>[
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        $b03364e48d8512c5$var$useGlobalRefStateSelector(key)
    ];
const $b03364e48d8512c5$export$3c6c6911d09d7d8a = (0, $3sQ5x.createHook)($b03364e48d8512c5$var$store, {
    selector: null
});
const $b03364e48d8512c5$export$6b4b878b04fd3017 = (propName, refName)=>(Component)=>(props)=>{
            const [ref] = $b03364e48d8512c5$export$361e4f658203e95(refName);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
                ...props,
                [propName]: ref
            });
        };

});

parcelRegister("4cYhQ", function(module, exports) {

$parcel$export(module.exports, "Action", () => $9022cae0997d5594$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "ActionSubject", () => $9022cae0997d5594$export$7f97440769de1377);
$parcel$export(module.exports, "AnalyticsEvent", () => $9022cae0997d5594$export$30b7662faa307ee);
$parcel$export(module.exports, "ToggleKey", () => $9022cae0997d5594$export$3679582258ad0fad);
$parcel$export(module.exports, "IncrementPlanningAnalyticsKey", () => $9022cae0997d5594$export$75cb7f2b113e0230);
const $9022cae0997d5594$export$e19cd5f9376f8cee = {
    CLICKED: 'clicked',
    CHANGED: 'changed'
};
const $9022cae0997d5594$export$7f97440769de1377 = {
    BUTTON: 'button',
    TOGGLE: 'toggle',
    SELECT: 'select'
};
const $9022cae0997d5594$export$30b7662faa307ee = {
    UI_EVENT: 'UI_EVENT',
    OPERATIONAL_EVENT: 'OPERATIONAL_EVENT',
    TRACK_EVENT: 'TRACK_EVENT'
};
const $9022cae0997d5594$export$3679582258ad0fad = {
    VERSION_PANEL_TOGGLE: 'versionPanel',
    EPIC_PANEL_TOGGLE: 'epicPanel',
    QUICK_FILTERS_TOGGLE: 'quickFilters',
    COMPACT_MODE_TOGGLE: 'compactMode',
    CARD_DENSITY: 'cardDensity',
    SHOW_VERSIONS_TOGGLE: 'showVersions',
    SHOW_EPICS_TOGGLE: 'showEpics',
    SHOW_STATUSES_TOGGLE: 'showStatuses',
    SHOW_ISSUE_TYPE: 'showIssueType',
    SHOW_ISSUE_KEY: 'showIssueKey',
    SHOW_ESTIMATE: 'showEstimate',
    SHOW_PRIORITY: 'showPriority',
    SHOW_DEVELOPMENT: 'showDevelopment',
    SHOW_ASSIGNEE: 'showAssignee',
    SHOW_ISSUE_LINKS_STATS: 'showIssueLinksStats',
    OPEN_ISSUES_IN_SIDEBAR_TOGGLE: 'openIssuesInSidebar',
    SUBTASKS_EXPAND_ALL: 'subtasksExpandAll',
    SUBTASKS_COLLAPSE_ALL: 'subtasksCollapseAll',
    SWIMLANE_EXPAND_ALL: 'swimlaneExpandAll',
    SWIMLANE_COLLAPSE_ALL: 'swimlaneCollapseAll',
    SHOW_DAYS_IN_COLUMN: 'showDaysInColumn',
    SHOW_DUE_DATE: 'showDueDate',
    SHOW_LABELS: 'showLabels',
    SHOW_EXTRA_FIELD: 'showExtraField',
    WORK_SUGGESTIONS_TOGGLE: 'workSuggestions',
    SHOW_CARD_COVERS: 'showCardCovers',
    SHOW_BOARD_NAME: 'showBoardName'
};
const $9022cae0997d5594$export$75cb7f2b113e0230 = {
    UNSCHEDULED_COLUMN_TOGGLE: 'unscheduledColumnToggle',
    ISSUE_IDS_TO_SHOW_DEPENDENCIES: 'issueIdsToShowDependencies',
    SHOW_OFFTRACK_DEPENDENCY_LINES: 'showOfftrackDependencyLines'
};
const $9022cae0997d5594$export$d87506c7d891276d = {
    ...$9022cae0997d5594$export$3679582258ad0fad,
    ...$9022cae0997d5594$export$75cb7f2b113e0230
};

});

parcelRegister("lngWe", function(module, exports) {

$parcel$export(module.exports, "Panel", () => $a08ab407f5b09128$export$2ddb90ad54e5f587);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $84THj = parcelRequire("84THj");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $h9kUS = parcelRequire("h9kUS");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $a2e2Q = parcelRequire("a2e2Q");

var $duOMW = parcelRequire("duOMW");

var $jvrqw = parcelRequire("jvrqw");
const $a08ab407f5b09128$export$2ddb90ad54e5f587 = ({ title: title = '', onClose: onClose = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), children: children })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const headerTitleId = 'view-settings.ui.panel.header-title';
    const { isSoftwareFullTheming: isSoftwareFullTheming } = (0, $a2e2Q.useSoftwareProjectTheming)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        alignInline: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $a08ab407f5b09128$var$panelStyles,
            isSoftwareFullTheming && $a08ab407f5b09128$var$dialogStyles
        ],
        role: "dialog",
        "aria-modal": "false",
        "aria-labelledby": headerTitleId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        grow: "fill",
        spread: "space-between",
        xcss: $a08ab407f5b09128$var$headerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: (0, $4R6GH.fg)('view-settings-title-size-fix') ? 'small' : 'medium',
        as: "h2",
        id: headerTitleId
    }, title || formatMessage((0, $jvrqw.default).defaultTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $a08ab407f5b09128$var$ButtonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        spacing: "none",
        onClick: onClose,
        testId: (0, $duOMW.VIEW_SETTINGS_PANEL_CLOSE_BUTTON_TEST_ID)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $a08ab407f5b09128$var$IconWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($84THj))), {
        spacing: "spacious",
        label: formatMessage((0, $jvrqw.default).closeButtonLabel)
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), null, children)));
};
const $a08ab407f5b09128$var$headerStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.100'
});
const $a08ab407f5b09128$var$panelStyles = (0, $8CUq3.xcss)({
    border: `1px solid ${"var(--ds-border, #091E4224)"}`,
    borderRadius: 'border.radius.200',
    width: '280px',
    padding: 'space.300',
    [(0, $h9kUS.media).above.lg]: {
        width: '300px'
    }
});
const $a08ab407f5b09128$var$ButtonWrapperStyles = (0, $8CUq3.xcss)({
    width: "var(--ds-space-400, 32px)",
    height: "var(--ds-space-400, 32px)"
});
const $a08ab407f5b09128$var$IconWrapperStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: "var(--ds-space-400, 32px)",
    height: "var(--ds-space-400, 32px)"
});
const $a08ab407f5b09128$var$dialogStyles = (0, $8CUq3.xcss)({
    background: "var(--ds-surface, #FFFFFF)",
    boxShadow: 'elevation.shadow.overlay'
});

});
parcelRegister("jvrqw", function(module, exports) {

$parcel$export(module.exports, "default", () => $12af5ef45aa68e18$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $12af5ef45aa68e18$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    defaultTitle: {
        "id": "software-view-settings.common.panel.default-title",
        "defaultMessage": "View settings"
    },
    closeButtonLabel: {
        "id": "software-view-settings.common.panel.close-button-label",
        "defaultMessage": "Close"
    }
});

});


parcelRegister("3uPqt", function(module, exports) {

$parcel$export(module.exports, "useSendAnalyticsEvent", () => $2125a8f3d8eb70be$export$4b1735907ca3ab2f);

var $fjcgS = parcelRequire("fjcgS");

var $4cYhQ = parcelRequire("4cYhQ");
const $2125a8f3d8eb70be$export$7d2f3f483d8e6742 = 'viewSettings';
const $2125a8f3d8eb70be$export$4b1735907ca3ab2f = ()=>{
    const sendAnalyticsEvent = (action, actionSubject, eventType, attributes = {}, source)=>{
        (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
            const analyticsClient = client.getInstance();
            if (!analyticsClient) return Promise.resolve();
            const event = {
                action: action,
                actionSubject: actionSubject,
                actionSubjectId: $2125a8f3d8eb70be$export$7d2f3f483d8e6742,
                attributes: {
                    ...attributes
                },
                source: source
            };
            switch(eventType){
                case (0, $4cYhQ.AnalyticsEvent).UI_EVENT:
                    return analyticsClient.sendUIEvent(event);
                case (0, $4cYhQ.AnalyticsEvent).OPERATIONAL_EVENT:
                    return analyticsClient.sendOperationalEvent(event);
                case (0, $4cYhQ.AnalyticsEvent).TRACK_EVENT:
                    return analyticsClient.sendTrackEvent(event);
                default:
            }
            return undefined;
        });
    };
    return sendAnalyticsEvent;
};

});

parcelRegister("5iXkq", function(module, exports) {

$parcel$export(module.exports, "useCardDetailsInitialState", () => $fd36b5bdce43621b$export$2e9f932053c78b66);

var $5uXOq = parcelRequire("5uXOq");

var $fr1K2 = parcelRequire("fr1K2");

var $doZTA = parcelRequire("doZTA");

var $duOMW = parcelRequire("duOMW");

var $9pP0g = parcelRequire("9pP0g");

var $cYeCp = parcelRequire("cYeCp");

var $8zmNw = parcelRequire("8zmNw");

var $iDGXn = parcelRequire("iDGXn");
const $fd36b5bdce43621b$export$428c87746d3e32da = {
    [(0, $9pP0g.ViewSetting).SHOW_EPICS]: 'showEpics',
    [(0, $9pP0g.ViewSetting).SHOW_STATUSES]: 'showStatuses',
    [(0, $9pP0g.ViewSetting).SHOW_VERSIONS]: 'showVersions',
    [(0, $9pP0g.ViewSetting).SHOW_ASSIGNEE]: 'showAssignee',
    [(0, $9pP0g.ViewSetting).SHOW_DAYS_IN_COLUMN]: 'showDaysInColumn',
    [(0, $9pP0g.ViewSetting).SHOW_ESTIMATE]: 'showEstimate',
    [(0, $9pP0g.ViewSetting).SHOW_ISSUE_KEY]: 'showIssueKey',
    [(0, $9pP0g.ViewSetting).SHOW_ISSUE_LINKS_STATS]: 'showIssueLinksStats',
    [(0, $9pP0g.ViewSetting).SHOW_DUE_DATE]: 'showDueDate',
    [(0, $9pP0g.ViewSetting).SHOW_ISSUE_TYPE]: 'showIssueType',
    [(0, $9pP0g.ViewSetting).SHOW_PRIORITY]: 'showPriority',
    [(0, $9pP0g.ViewSetting).SHOW_DEVELOPMENT]: 'showDevelopment',
    [(0, $9pP0g.ViewSetting).SHOW_LABELS]: 'showLabels',
    [(0, $9pP0g.ViewSetting).SHOW_CARD_COVERS]: 'showCardCovers',
    [(0, $9pP0g.ViewSetting).SHOW_BOARD_NAME]: 'showBoardName'
};
const $fd36b5bdce43621b$export$2e9f932053c78b66 = (boardId, view, isDaysInColumnEnabled, isDueDateEnabled, isLabelsEnabled, isEstimateEnabled, isPriorityEnabled)=>{
    const [{ location: location, query: query }, { replace: replace }] = (0, $doZTA.useRouter)();
    const { setViewSettingsCardDetails: setViewSettingsCardDetails } = (0, $iDGXn.useViewSettingsActions)();
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() || !query) return;
        const cardDetailsFromLocalStorage = (0, $8zmNw.getViewSettingsCardDetails)({
            boardId: boardId,
            view: view,
            isDaysInColumnEnabled: isDaysInColumnEnabled,
            isDueDateEnabled: isDueDateEnabled,
            isLabelsEnabled: isLabelsEnabled,
            isEstimateEnabled: isEstimateEnabled,
            isPriorityEnabled: isPriorityEnabled
        });
        const getInitialCardValue = (stateKey)=>{
            const queryKey = $fd36b5bdce43621b$export$428c87746d3e32da[stateKey];
            return query[queryKey] ? query[queryKey] === (0, $duOMW.QUERY_ENABLED_VALUE) : cardDetailsFromLocalStorage[stateKey];
        };
        const cardDetailsState = {
            [(0, $9pP0g.ViewSetting).SHOW_EPICS]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_EPICS),
            [(0, $9pP0g.ViewSetting).SHOW_STATUSES]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_STATUSES),
            [(0, $9pP0g.ViewSetting).SHOW_VERSIONS]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_VERSIONS),
            [(0, $9pP0g.ViewSetting).SHOW_ASSIGNEE]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_ASSIGNEE),
            [(0, $9pP0g.ViewSetting).SHOW_DAYS_IN_COLUMN]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_DAYS_IN_COLUMN),
            [(0, $9pP0g.ViewSetting).SHOW_ESTIMATE]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_ESTIMATE),
            [(0, $9pP0g.ViewSetting).SHOW_ISSUE_KEY]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_ISSUE_KEY),
            [(0, $9pP0g.ViewSetting).SHOW_ISSUE_LINKS_STATS]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_ISSUE_LINKS_STATS),
            [(0, $9pP0g.ViewSetting).SHOW_ISSUE_TYPE]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_ISSUE_TYPE),
            [(0, $9pP0g.ViewSetting).SHOW_PRIORITY]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_PRIORITY),
            [(0, $9pP0g.ViewSetting).SHOW_DEVELOPMENT]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_DEVELOPMENT),
            [(0, $9pP0g.ViewSetting).SHOW_DUE_DATE]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_DUE_DATE),
            [(0, $9pP0g.ViewSetting).SHOW_LABELS]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_LABELS),
            [(0, $9pP0g.ViewSetting).SHOW_CARD_COVERS]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_CARD_COVERS),
            [(0, $9pP0g.ViewSetting).SHOW_BOARD_NAME]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_BOARD_NAME)
        };
        setViewSettingsCardDetails({
            boardId: boardId,
            view: view,
            cardDetailsState: cardDetailsState
        });
        // remove card view initial settings param
        replace({
            ...location,
            search: new URLSearchParams((0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(query, Object.values($fd36b5bdce43621b$export$428c87746d3e32da))).toString()
        });
    // we want to run this hook on initial render only
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

});

parcelRegister("jCs82", function(module, exports) {

$parcel$export(module.exports, "useOnBacklog", () => $39756d5f22d21cd8$export$9c6bcc9d56a57470);

var $5uXOq = parcelRequire("5uXOq");

var $doZTA = parcelRequire("doZTA");
var $lVJAU = parcelRequire("lVJAU");

var $a4XJc = parcelRequire("a4XJc");

var $cYeCp = parcelRequire("cYeCp");

var $8zmNw = parcelRequire("8zmNw");

var $iDGXn = parcelRequire("iDGXn");
const $39756d5f22d21cd8$export$9c6bcc9d56a57470 = (boardId, view, showEpicAsPanel = false, isVersionsEnabled = false)=>{
    const [{ location: location }] = (0, $doZTA.useRouter)();
    const showPanels = (0, $iDGXn.useShowPanels)();
    const { setViewSettingsPanels: setViewSettingsPanels } = (0, $iDGXn.useViewSettingsActions)();
    const { replace: replace } = (0, $lVJAU.useRouterActions)();
    // Sync react-sweet-state store with URL or localStorage state on mount.
    (0, $5uXOq.useEffect)(()=>{
        if (view !== (0, $a4XJc.View).BACKLOG) return;
        const panelsFromQuery = (0, $cYeCp.parseSearchQuery)(location.search);
        const panelsFromLocalStorage = (0, $8zmNw.getViewSettingsPanels)({
            boardId: boardId,
            view: view
        });
        // Search query state takes precedence over localStorage state, which supersedes react-sweet-state state.
        // If there are panels from the search query, update localStorage and react-sweet-state.
        // If not, update react-sweet-state using localStorage instead.
        let panelState = panelsFromLocalStorage;
        if (Object.values(panelsFromQuery).filter(Boolean).length !== 0) {
            const queryPanelState = {
                EPIC_PANEL: panelsFromQuery.EPIC_PANEL ?? false,
                VERSION_PANEL: panelsFromQuery.VERSION_PANEL ?? false
            };
            panelState = queryPanelState;
        }
        setViewSettingsPanels({
            boardId: boardId,
            view: view,
            panelState: panelState
        });
    // Removed `location.search` from the dependency array since we only want this hook to fire once (on mount).
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        boardId,
        isVersionsEnabled,
        setViewSettingsPanels,
        showEpicAsPanel,
        view
    ]);
    // Sync URL with react-sweet-state store on mount and when react-sweet-state store changes.
    (0, $5uXOq.useEffect)(()=>{
        if (view !== (0, $a4XJc.View).BACKLOG) return;
        const url = (0, $cYeCp.setPanels)(showPanels, location);
        if (location.search !== `?${url.search}`) replace(url);
    // `Location` has a `hash` attribute which causes unnecessary calls, so we are only using `search` in the dependency array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        location.search,
        showPanels,
        replace,
        view
    ]);
};

});

parcelRegister("1wxxD", function(module, exports) {

$parcel$export(module.exports, "useOnIncrementPlanningBoard", () => $c2daf95593322126$export$14539b3beca7ada3);

var $5uXOq = parcelRequire("5uXOq");

var $doZTA = parcelRequire("doZTA");
var $lVJAU = parcelRequire("lVJAU");

var $a4XJc = parcelRequire("a4XJc");

var $cYeCp = parcelRequire("cYeCp");

var $8zmNw = parcelRequire("8zmNw");

var $iDGXn = parcelRequire("iDGXn");
const $c2daf95593322126$export$14539b3beca7ada3 = (boardId, view, dependencyIssueOptions)=>{
    const { setShowUnscheduledColumn: setShowUnscheduledColumn, setShowOfftrackDependencyLines: setShowOfftrackDependencyLines, setIssueIdsToShowDependencies: setIssueIdsToShowDependencies } = (0, $iDGXn.useViewSettingsActions)();
    const [{ location: location }] = (0, $doZTA.useRouter)();
    const { replace: replace } = (0, $lVJAU.useRouterActions)();
    const isUnscheduledColumnVisible = (0, $iDGXn.useShowUnscheduledColumn)();
    const isOfftrackDependencyLinesVisible = (0, $iDGXn.useShowOfftrackDependencyLines)();
    const issueIdsToShowDependencies = (0, $iDGXn.useIssueIdsToShowDependencies)();
    (0, $5uXOq.useEffect)(()=>{
        if (view !== (0, $a4XJc.View).INCREMENT_PLANNING_BOARD) return;
        const unscheduledColumnFromLocalStorage = (0, $8zmNw.getShowUnscheduledColumn)(boardId);
        const settingsFromQuery = (0, $cYeCp.parseSearchQueryForIPBoard)(location.search);
        // Search query state takes precedence over localStorage state, which supersedes react-sweet-state state.
        // If there are IP board settings from the search query, update localStorage and react-sweet-state.
        // If not, update react-sweet-state using localStorage instead.
        const showUnscheduledColumn = settingsFromQuery.SHOW_UNSCHEDULED_COLUMN !== undefined ? settingsFromQuery.SHOW_UNSCHEDULED_COLUMN : unscheduledColumnFromLocalStorage;
        setShowUnscheduledColumn(boardId, showUnscheduledColumn);
        const offtrackDependencyLinesFromLocalStorage = (0, $8zmNw.getShowOfftrackDependencyLines)(boardId);
        const issueIdsToShowDependenciesFromLocalStorage = (0, $8zmNw.getIssueIdsToShowDependencies)(boardId);
        const showOfftrackDependencyLines = settingsFromQuery.SHOW_OFFTRACK_DEPENDENCY_LINES !== undefined ? settingsFromQuery.SHOW_OFFTRACK_DEPENDENCY_LINES : offtrackDependencyLinesFromLocalStorage;
        setShowOfftrackDependencyLines(boardId, showOfftrackDependencyLines);
        const issuesIdsToShowDependencies = settingsFromQuery.ISSUE_IDS_TO_SHOW_DEPENDENCIES && settingsFromQuery.ISSUE_IDS_TO_SHOW_DEPENDENCIES.length ? settingsFromQuery.ISSUE_IDS_TO_SHOW_DEPENDENCIES : issueIdsToShowDependenciesFromLocalStorage;
        const filteredIssueIds = Array.isArray(issuesIdsToShowDependencies) ? issuesIdsToShowDependencies.filter((issueId)=>dependencyIssueOptions[issueId] !== undefined) : [];
        setIssueIdsToShowDependencies(boardId, filteredIssueIds);
    }, [
        boardId,
        view,
        dependencyIssueOptions,
        location.search,
        setShowUnscheduledColumn,
        setShowOfftrackDependencyLines,
        setIssueIdsToShowDependencies
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (view !== (0, $a4XJc.View).INCREMENT_PLANNING_BOARD) return;
        const url = (0, $cYeCp.setIncrementPlanningSettingsQuery)({
            SHOW_UNSCHEDULED_COLUMN: isUnscheduledColumnVisible,
            SHOW_OFFTRACK_DEPENDENCY_LINES: isOfftrackDependencyLinesVisible,
            ISSUE_IDS_TO_SHOW_DEPENDENCIES: issueIdsToShowDependencies
        }, location);
        if (location.search !== `?${url.search}`) replace(url);
    // `Location` has a `hash` attribute which causes unnecessary calls, so we are only using `search` in the dependency array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        view,
        isUnscheduledColumnVisible,
        isOfftrackDependencyLinesVisible,
        issueIdsToShowDependencies,
        location.search,
        replace
    ]);
};

});

parcelRegister("8vQbt", function(module, exports) {

$parcel$export(module.exports, "useSyncFromLocalStorage", () => $9a1dab6fcae5bc71$export$88f2270d613c342b);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $cYeCp = parcelRequire("cYeCp");

var $8zmNw = parcelRequire("8zmNw");

var $iDGXn = parcelRequire("iDGXn");
const $9a1dab6fcae5bc71$export$88f2270d613c342b = (boardId, view, cardExtraFields, isDaysInColumnEnabled, isDueDateEnabled, isLabelsEnabled, isEstimateEnabled, isPriorityEnabled)=>{
    const { setIsFullscreen: setIsFullscreen, setViewSettingsCardDetails: setViewSettingsCardDetails, setViewSettingsQuickFilters: setViewSettingsQuickFilters, setViewSettingsCompactMode: setViewSettingsCompactMode, setViewSettingsCardExtraFields: setViewSettingsCardExtraFields } = (0, $iDGXn.useViewSettingsActions)();
    const hasRendered = (0, $5uXOq.useRef)(false);
    if (hasRendered.current === false && (0, $4R6GH.fg)('backlog-view-settings-all-fields-setimmediate')) {
        if (!(0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)()) {
            const cardDetailsFromLocalStorage = (0, $8zmNw.getViewSettingsCardDetails)({
                boardId: boardId,
                view: view
            });
            setViewSettingsCardDetails({
                boardId: boardId,
                cardDetailsState: cardDetailsFromLocalStorage,
                view: view
            });
        }
        const quickFiltersFromLocalStorage = (0, $8zmNw.getViewSettingsQuickFilters)({
            boardId: boardId,
            view: view
        });
        setViewSettingsQuickFilters({
            boardId: boardId,
            view: view,
            showQuickFilters: quickFiltersFromLocalStorage
        });
        const compactModeFromLocalStorage = (0, $8zmNw.getViewSettingsCompactMode)({
            boardId: boardId,
            view: view
        });
        setViewSettingsCompactMode({
            boardId: boardId,
            view: view,
            showCompactMode: compactModeFromLocalStorage
        });
        const isFullscreenFromLocalStorage = (0, $8zmNw.getViewSettingsIsFullscreen)({
            boardId: boardId,
            view: view
        });
        setIsFullscreen({
            boardId: boardId,
            isFullscreen: isFullscreenFromLocalStorage,
            view: view
        });
        const cardExtraFieldsState = (0, $8zmNw.getViewSettingsCardExtraFields)({
            boardId: boardId,
            view: view,
            cardExtraFields: cardExtraFields
        });
        setViewSettingsCardExtraFields({
            boardId: boardId,
            cardExtraFieldsState: cardExtraFieldsState,
            view: view
        });
        hasRendered.current = true;
        return;
    }
    if ((0, $4R6GH.fg)('backlog-view-settings-all-fields-setimmediate')) return;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>{
        // card details initial state moved to `useCardDetailsInitialState`
        if (!(0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)()) {
            const cardDetailsFromLocalStorage = (0, $8zmNw.getViewSettingsCardDetails)({
                boardId: boardId,
                view: view
            });
            setViewSettingsCardDetails({
                boardId: boardId,
                cardDetailsState: cardDetailsFromLocalStorage,
                view: view
            });
        }
        const quickFiltersFromLocalStorage = (0, $8zmNw.getViewSettingsQuickFilters)({
            boardId: boardId,
            view: view
        });
        setViewSettingsQuickFilters({
            boardId: boardId,
            view: view,
            showQuickFilters: quickFiltersFromLocalStorage
        });
        const compactModeFromLocalStorage = (0, $8zmNw.getViewSettingsCompactMode)({
            boardId: boardId,
            view: view
        });
        setViewSettingsCompactMode({
            boardId: boardId,
            view: view,
            showCompactMode: compactModeFromLocalStorage
        });
        const isFullscreenFromLocalStorage = (0, $8zmNw.getViewSettingsIsFullscreen)({
            boardId: boardId,
            view: view
        });
        setIsFullscreen({
            boardId: boardId,
            isFullscreen: isFullscreenFromLocalStorage,
            view: view
        });
    }, [
        boardId,
        view,
        isDaysInColumnEnabled,
        isDueDateEnabled,
        isLabelsEnabled,
        isEstimateEnabled,
        isPriorityEnabled,
        setIsFullscreen,
        setViewSettingsCardDetails,
        setViewSettingsCompactMode,
        setViewSettingsQuickFilters,
        setViewSettingsCardExtraFields
    ]);
    // Remove this when cleaning up backlog-view-settings-extra-fields-immediate-set
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>{
        const cardExtraFieldsFromLocalStorage = (0, $8zmNw.getViewSettingsCardExtraFields)({
            boardId: boardId,
            view: view,
            cardExtraFields: cardExtraFields
        });
        setViewSettingsCardExtraFields({
            boardId: boardId,
            cardExtraFieldsState: cardExtraFieldsFromLocalStorage,
            view: view
        });
    }, [
        boardId,
        view,
        cardExtraFields,
        setViewSettingsCardExtraFields
    ]);
};

});

parcelRegister("3ykoc", function(module, exports) {

$parcel$export(module.exports, "default", () => $a98a1024295d65c6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a98a1024295d65c6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    panelTitle: {
        "id": "software-view-settings.panel-title",
        "defaultMessage": "View settings"
    }
});

});

parcelRegister("38RF4", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsSyncFromLocalStorageWrapper", () => $434e13d035e4d1d0$export$8c976c7ba46200ff);
$parcel$export(module.exports, "ViewSettingsButton", () => $434e13d035e4d1d0$export$805802ea39f3d804);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $42CjB = parcelRequire("42CjB");

var $4QAwn = parcelRequire("4QAwn");

var $3bDjY = parcelRequire("3bDjY");

var $4R6GH = parcelRequire("4R6GH");

var $1v6HV = parcelRequire("1v6HV");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $59KYj = parcelRequire("59KYj");

var $22OQR = parcelRequire("22OQR");

var $hchBL = parcelRequire("hchBL");

var $dCm1o = parcelRequire("dCm1o");

var $hCCtP = parcelRequire("hCCtP");

var $duOMW = parcelRequire("duOMW");

var $5iXkq = parcelRequire("5iXkq");

var $jCs82 = parcelRequire("jCs82");

var $8vQbt = parcelRequire("8vQbt");

var $iIMX5 = parcelRequire("iIMX5");
const $434e13d035e4d1d0$export$8c976c7ba46200ff = ({ boardId: boardId, view: view, cardExtraFields: cardExtraFields = [], isDaysInColumnEnabled: isDaysInColumnEnabled = false, isDueDateEnabled: isDueDateEnabled = false, isLabelsEnabled: isLabelsEnabled = false, isEstimateEnabled: isEstimateEnabled = false, children: children, showEpicAsPanel: showEpicAsPanel = false, isVersionsEnabled: isVersionsEnabled = false, isPriorityEnabled: isPriorityEnabled = false })=>{
    (0, $jCs82.useOnBacklog)(boardId, view, showEpicAsPanel, isVersionsEnabled);
    (0, $8vQbt.useSyncFromLocalStorage)(boardId, view, cardExtraFields, isDaysInColumnEnabled, isDueDateEnabled, isLabelsEnabled, isEstimateEnabled, isPriorityEnabled);
    (0, $5iXkq.useCardDetailsInitialState)(boardId, view, isDaysInColumnEnabled, isDueDateEnabled, isLabelsEnabled, isEstimateEnabled, isPriorityEnabled);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $434e13d035e4d1d0$export$805802ea39f3d804 = ({ isSelected: isSelected, onClick: onClick = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isThemedButton: isThemedButton = false, ...restProps })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(isSelected);
    const [, { register: register }] = (0, $hchBL.useGlobalRefStoreActions)();
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'viewSettingsButton');
        setIsOpen(!isOpen);
        onClick(!isOpen);
    }, [
        createAnalyticsEvent,
        isOpen,
        onClick
    ]);
    const openViewSettings = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'viewSettingsButton');
        setIsOpen(true);
        setTimeout(()=>onClick(true));
    }, [
        createAnalyticsEvent,
        onClick
    ]);
    const { setOpenViewSettings: setOpenViewSettings } = (0, $1v6HV.useBoardWorkSuggestionsSpotlightActions)();
    (0, $5uXOq.useEffect)(()=>{
        if (setOpenViewSettings) setOpenViewSettings(openViewSettings);
    }, [
        openViewSettings,
        setOpenViewSettings
    ]);
    const onRefButtonResponsive = (0, $5uXOq.useCallback)((ref)=>{
        register((0, $duOMW.VIEW_SETTINGS_BUTTON_RESPONSIVE), ref);
    }, [
        register
    ]);
    (0, $5uXOq.useEffect)(()=>{
        setIsOpen(isSelected);
    }, [
        isSelected
    ]);
    if ((0, $dCm1o.isVisualRefreshEnabled)()) {
        const themedButton = (0, $4R6GH.fg)('visual-refresh-headers-buttons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCCtP.ThemedIconButton), {
            testId: "software-view-settings.ui.view-settings-button.responsive-button",
            appearance: "default",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($4QAwn))),
            label: formatMessage((0, $iIMX5.default).buttonLabel),
            isSelected: isOpen,
            onClick: handleClick,
            ref: onRefButtonResponsive,
            "aria-expanded": restProps.ariaExpanded ?? isSelected,
            "aria-controls": restProps.ariaControls,
            "aria-haspopup": restProps.ariaHasPopup ?? true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
            testId: "software-view-settings.ui.view-settings-button.responsive-button",
            appearance: "default",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4QAwn))), {
                label: "",
                color: "currentColor",
                spacing: "spacious"
            }),
            label: formatMessage((0, $iIMX5.default).buttonLabel),
            isSelected: isOpen,
            onClick: handleClick,
            ref: onRefButtonResponsive,
            "aria-label": formatMessage((0, $iIMX5.default).buttonLabel),
            "aria-expanded": restProps.ariaExpanded ?? isSelected,
            "aria-controls": restProps.ariaControls,
            "aria-haspopup": restProps.ariaHasPopup ?? true
        });
        return isThemedButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $iIMX5.default).buttonLabel)
        }, themedButton) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            testId: "software-view-settings.ui.view-settings-button.icon-button",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($4QAwn))),
            label: formatMessage((0, $iIMX5.default).buttonLabel),
            isSelected: isOpen,
            onClick: handleClick,
            ref: onRefButtonResponsive,
            "aria-expanded": restProps.ariaExpanded ?? isSelected,
            "aria-controls": restProps.ariaControls,
            "aria-haspopup": restProps.ariaHasPopup ?? true,
            isTooltipDisabled: false
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $59KYj.ResponsiveThemedButton), {
        testId: "software-view-settings.ui.view-settings-button.responsive-button",
        appearance: "default",
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4QAwn))), {
            label: "",
            color: "currentColor",
            spacing: "spacious"
        }),
        label: formatMessage((0, $iIMX5.default).buttonLabel),
        isSelected: isOpen,
        onClick: handleClick,
        ref: onRefButtonResponsive,
        "aria-label": formatMessage((0, $iIMX5.default).buttonLabel),
        "aria-expanded": restProps.ariaExpanded ?? isSelected,
        "aria-controls": restProps.ariaControls,
        "aria-haspopup": restProps.ariaHasPopup ?? true
    });
};

});
parcelRegister("59KYj", function(module, exports) {

$parcel$export(module.exports, "ResponsiveThemedButton", () => $04660f59ffb4326c$export$6f42949f4ea1e733);
/* ResponsiveThemedButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $2rqOp = parcelRequire("2rqOp");

var $f5TWP = parcelRequire("f5TWP");

var $1kVqg = parcelRequire("1kVqg");
var $oGXFy = parcelRequire("oGXFy");

var $3bDjY = parcelRequire("3bDjY");
const $04660f59ffb4326c$export$4161299bcae84c4f = 'responsive-themed-button';
const $04660f59ffb4326c$export$6f42949f4ea1e733 = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, ...props }, ref)=>{
    const { icon: icon, label: label, breakpoint: breakpoint = 'lg', appearance: appearance, testId: testId, 'aria-label': ariaLabel, ...restProps } = props;
    const mediaQueryBreakpoint = (0, $oGXFy.UNSAFE_useMediaQuery)(`above.${breakpoint}`, (event)=>setIsAboveBreakpoint(event.matches));
    const [isAboveBreakpoint, setIsAboveBreakpoint] = (0, $5uXOq.useState)(mediaQueryBreakpoint?.matches);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1kVqg.Show), {
        below: breakpoint ?? 'lg'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04660f59ffb4326c$var$CustomButton, {
        ...restProps,
        as: as,
        ref: !isAboveBreakpoint ? ref : undefined,
        appearance: appearance ?? 'default',
        iconBefore: icon,
        testId: `${testId ?? $04660f59ffb4326c$export$4161299bcae84c4f}.collapsed`,
        "aria-label": ariaLabel || label
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1kVqg.Show), {
        above: breakpoint ?? 'lg'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04660f59ffb4326c$var$CustomButton, {
        ...restProps,
        as: as,
        ref: isAboveBreakpoint ? ref : undefined,
        appearance: appearance ?? 'default',
        iconBefore: icon,
        testId: `${testId ?? $04660f59ffb4326c$export$4161299bcae84c4f}.expanded`,
        "aria-label": ariaLabel || label
    }, label)));
}));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $04660f59ffb4326c$var$CustomButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $2rqOp.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1qt3kjry _1g9h1tex _1umfuwj9 _6l8r3x59 _9se5176f _12rallho _zk5uzt2a _18vg2zyf _192e1jcw _fnp717ga _1xjgvy9e _jeiefrbu _nkzo1ag4 _1u0u14e8 _17z218zq _7n83frbu _n2ul1jo4 _1cf1r7td _1d7c1ag4 _nwukvy9e _fsjd4zrn _z1i3eyly",
            __cmplp.className
        ])
    });
});

});

parcelRegister("iIMX5", function(module, exports) {

$parcel$export(module.exports, "default", () => $77495ee3efb7180c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $77495ee3efb7180c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    buttonLabel: {
        "id": "software-view-settings.view-settings-button.button-label",
        "defaultMessage": "View settings"
    }
});

});


parcelRegister("2ucDS", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsMenu", () => $24ad572d0ea302a2$export$14138a347411ebf);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $4cYhQ = parcelRequire("4cYhQ");

var $a4XJc = parcelRequire("a4XJc");

var $3uPqt = parcelRequire("3uPqt");

var $jlxRF = parcelRequire("jlxRF");

var $140hX = parcelRequire("140hX");

var $1ESRw = parcelRequire("1ESRw");
const $24ad572d0ea302a2$export$14138a347411ebf = ({ boardId: boardId, isClassic: isClassic, view: view, viewAs: viewAs = (0, $a4XJc.ViewAs).POPUP, showEpicAsPanel: showEpicAsPanel, isVersionsEnabled: isVersionsEnabled, epicCustomName: epicCustomName = 'Epic', showFilterBarToggle: showFilterBarToggle = false, showCardDetails: showCardDetails = true, areSubtasksEnabled: areSubtasksEnabled = false, showWorkSuggestions: showWorkSuggestions = false, onSubtasksExpandAll: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onSubtasksExpandAll = ()=>{}, onSubtasksCollapseAll: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onSubtasksCollapseAll = ()=>{}, areAllSubtasksExpanded: areAllSubtasksExpanded = false, areAllSubtasksCollapsed: areAllSubtasksCollapsed = false, isSwimlanesEnabled: isSwimlanesEnabled = false, onSwimlaneExpandAll: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onSwimlaneExpandAll = ()=>{}, onSwimlaneCollapseAll: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onSwimlaneCollapseAll = ()=>{}, onToggleWorkSuggestions: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onToggleWorkSuggestions = ()=>{}, onLinkedIssuesStatsToggledOn: // eslint-disable-next-line @typescript-eslint/no-empty-function
onLinkedIssuesStatsToggledOn = ()=>{}, onShowCardCoversToggledOn: // eslint-disable-next-line @typescript-eslint/no-empty-function
onShowCardCoversToggledOn = ()=>{}, isDaysInColumnEnabled: isDaysInColumnEnabled = false, showLinkedIssueStatsToggle: showLinkedIssueStatsToggle = false, cardExtraFields: cardExtraFields = [], isEstimateEnabled: isEstimateEnabled = false, isDueDateEnabled: isDueDateEnabled = false, isLabelsEnabled: isLabelsEnabled = false, isPriorityEnabled: isPriorityEnabled = false, isDevelopmentEnabled: isDevelopmentEnabled = false, isWorkSuggestionsEnabled: isWorkSuggestionsEnabled = false, dependencyIssueOptions: dependencyIssueOptions = {}, disableScrollbar: disableScrollbar = false, onUpdate: onUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onClose: onClose, analyticsData: analyticsData, isShowBoardNameEnabled: isShowBoardNameEnabled })=>{
    const sendAnalyticsEvent = (0, $3uPqt.useSendAnalyticsEvent)();
    const handleChange = (actionSubject, attributes)=>{
        sendAnalyticsEvent((0, $4cYhQ.Action).CLICKED, actionSubject, (0, $4cYhQ.AnalyticsEvent).UI_EVENT, {
            ...attributes,
            isClassic: isClassic
        }, view);
    };
    const incrementPlanningHandleChange = (actionSubject, attributes, action)=>{
        sendAnalyticsEvent(action ?? (0, $4cYhQ.Action).CLICKED, actionSubject, (0, $4cYhQ.AnalyticsEvent).UI_EVENT, {
            ...attributes,
            isClassic: isClassic
        }, view);
    };
    switch(view){
        case (0, $a4XJc.View).BACKLOG:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jlxRF.BacklogMenu), {
                viewAs: viewAs,
                boardId: boardId,
                onHandleChange: handleChange,
                showCardDetails: showCardDetails,
                isClassic: isClassic,
                isVersionsEnabled: isVersionsEnabled,
                showEpicAsPanel: showEpicAsPanel,
                showFilterBarToggle: showFilterBarToggle,
                epicCustomName: epicCustomName,
                areSubtasksEnabled: areSubtasksEnabled,
                areAllSubtasksExpanded: areAllSubtasksExpanded,
                areAllSubtasksCollapsed: areAllSubtasksCollapsed,
                onSubtasksExpandAll: onSubtasksExpandAll,
                onSubtasksCollapseAll: onSubtasksCollapseAll,
                cardExtraFields: cardExtraFields,
                isEstimateEnabled: isEstimateEnabled,
                isDueDateEnabled: isDueDateEnabled,
                isPriorityEnabled: isPriorityEnabled,
                isShowBoardNameEnabled: isShowBoardNameEnabled
            });
        case (0, $a4XJc.View).BOARD:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $140hX.BoardMenu), {
                viewAs: viewAs,
                boardId: boardId,
                isClassic: isClassic,
                isSwimlanesEnabled: isSwimlanesEnabled,
                onHandleChange: handleChange,
                onSwimlaneExpandAll: onSwimlaneExpandAll,
                onSwimlaneCollapseAll: onSwimlaneCollapseAll,
                showFilterBarToggle: showFilterBarToggle,
                showLinkedIssueStatsToggle: showLinkedIssueStatsToggle,
                showCardDetails: showCardDetails,
                epicCustomName: epicCustomName,
                isDaysInColumnEnabled: isDaysInColumnEnabled,
                cardExtraFields: cardExtraFields,
                isEstimateEnabled: isEstimateEnabled,
                isDueDateEnabled: isDueDateEnabled,
                isLabelsEnabled: isLabelsEnabled,
                isPriorityEnabled: isPriorityEnabled,
                isDevelopmentEnabled: isDevelopmentEnabled,
                showWorkSuggestions: showWorkSuggestions,
                onToggleWorkSuggestions: onToggleWorkSuggestions,
                isWorkSuggestionsEnabled: isWorkSuggestionsEnabled,
                onLinkedIssuesStatsToggledOn: onLinkedIssuesStatsToggledOn,
                onShowCardCoversToggledOn: onShowCardCoversToggledOn
            });
        case (0, $a4XJc.View).JSM_BOARD:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $140hX.BoardMenu), {
                viewAs: viewAs,
                boardId: boardId,
                isSwimlanesEnabled: isSwimlanesEnabled,
                onHandleChange: handleChange,
                showFilterBarToggle: showFilterBarToggle,
                showCardDetails: false,
                onSwimlaneExpandAll: onSwimlaneExpandAll,
                onSwimlaneCollapseAll: onSwimlaneCollapseAll
            });
        case (0, $a4XJc.View).INCREMENT_PLANNING_BOARD:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1ESRw.IncrementPlanningBoardMenu), {
                viewAs: viewAs,
                boardId: boardId,
                isSwimlanesEnabled: isSwimlanesEnabled,
                dependencyIssueOptions: dependencyIssueOptions,
                onHandleChange: incrementPlanningHandleChange,
                onSwimlaneExpandAll: onSwimlaneExpandAll,
                onSwimlaneCollapseAll: onSwimlaneCollapseAll,
                onUpdate: onUpdate,
                epicCustomName: epicCustomName,
                onClose: onClose,
                disableScrollbar: disableScrollbar,
                analyticsData: analyticsData
            });
        default:
            return null;
    }
};

});
parcelRegister("jlxRF", function(module, exports) {

$parcel$export(module.exports, "BacklogMenu", () => $61210b60d484d0b3$export$baf646a48a139934);

var $5uXOq = parcelRequire("5uXOq");

var $kJpBP = parcelRequire("kJpBP");
var $eZUJu = parcelRequire("eZUJu");
var $9UCCQ = parcelRequire("9UCCQ");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $jldZL = parcelRequire("jldZL");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $5oFIy = parcelRequire("5oFIy");

var $duOMW = parcelRequire("duOMW");

var $cACY7 = parcelRequire("cACY7");

var $4cYhQ = parcelRequire("4cYhQ");

var $a4XJc = parcelRequire("a4XJc");

var $9pP0g = parcelRequire("9pP0g");

var $1wNfX = parcelRequire("1wNfX");

var $e2hHN = parcelRequire("e2hHN");

var $9EmtZ = parcelRequire("9EmtZ");

var $htuq0 = parcelRequire("htuq0");

var $cYeCp = parcelRequire("cYeCp");

var $iDGXn = parcelRequire("iDGXn");

var $evv5v = parcelRequire("evv5v");

var $lWTHR = parcelRequire("lWTHR");
const $61210b60d484d0b3$export$baf646a48a139934 = ({ viewAs: viewAs, boardId: boardId, isClassic: isClassic, isVersionsEnabled: isVersionsEnabled, showEpicAsPanel: showEpicAsPanel, showFilterBarToggle: showFilterBarToggle = false, epicCustomName: epicCustomName = 'Epic', areSubtasksEnabled: areSubtasksEnabled = false, areAllSubtasksExpanded: areAllSubtasksExpanded = false, areAllSubtasksCollapsed: areAllSubtasksCollapsed = false, showCardDetails: showCardDetails = true, isEstimateEnabled: isEstimateEnabled = false, onHandleChange: onHandleChange, onSubtasksExpandAll: // eslint-disable-next-line @typescript-eslint/no-empty-function
onSubtasksExpandAll = ()=>{}, onSubtasksCollapseAll: // eslint-disable-next-line @typescript-eslint/no-empty-function
onSubtasksCollapseAll = ()=>{}, cardExtraFields: cardExtraFields = [], isDueDateEnabled: isDueDateEnabled = false, isPriorityEnabled: isPriorityEnabled = false, isShowBoardNameEnabled: isShowBoardNameEnabled = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [state, actions] = (0, $iDGXn.useViewSettings)();
    const Section = viewAs === (0, $a4XJc.ViewAs).PANEL ? (0, $e2hHN.PanelSection) : (0, $9UCCQ.default);
    const Group = viewAs === (0, $a4XJc.ViewAs).PANEL ? (0, $1wNfX.PanelGroup) : (0, $eZUJu.default);
    const cardDetailsTitle = viewAs === (0, $a4XJc.ViewAs).PANEL ? formatMessage((0, $cACY7.default).cardFields) : formatMessage((0, $cACY7.default).cardDetails);
    const { toggleViewSetting: toggleViewSetting, toggleShowEpics: toggleShowEpics, toggleShowStatuses: toggleShowStatuses, toggleShowVersions: toggleShowVersions, setViewSettingsCompactMode: setViewSettingsCompactMode, toggleExtraField: toggleExtraField, toggleShowDueDate: toggleShowDueDate } = actions;
    const hasCardExtraFields = cardExtraFields.length > 0;
    const fields = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showIssueTypeToggle,
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cACY7.default).cardDetailIssueTypeIssueTermRefresh : (0, $cACY7.default).cardDetailIssueType),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG,
                setting: (0, $9pP0g.ViewSetting).SHOW_ISSUE_TYPE
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ISSUE_TYPE,
                state: !state.showIssueType
            });
        },
        isChecked: state.showIssueType,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showIssueKeyToggle,
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cACY7.default).cardDetailIssueKeyIssueTermRefresh : (0, $cACY7.default).cardDetailIssueKey),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG,
                setting: (0, $9pP0g.ViewSetting).SHOW_ISSUE_KEY
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ISSUE_KEY,
                state: !state.showIssueKey
            });
        },
        isChecked: state.showIssueKey,
        viewAs: viewAs
    })), isVersionsEnabled && isClassic && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showVersionsToggle,
        title: formatMessage((0, $cACY7.default).cardDetailVersion),
        onChange: ()=>{
            toggleShowVersions({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_VERSIONS_TOGGLE,
                state: !state.showVersions
            });
        },
        isChecked: state.showVersions,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showEpicsToggle,
        title: epicCustomName,
        onChange: ()=>{
            toggleShowEpics({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_EPICS_TOGGLE,
                state: !state.showEpics
            });
        },
        isChecked: state.showEpics,
        viewAs: viewAs
    }), (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && isDueDateEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showDueDateToggle,
        title: formatMessage((0, $cACY7.default).dueDate),
        onChange: ()=>{
            toggleShowDueDate({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_DUE_DATE,
                state: !state.showDueDate
            });
        },
        isChecked: state.showDueDate,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showStatusToggle,
        title: formatMessage((0, $cACY7.default).cardDetailStatus),
        onChange: ()=>{
            toggleShowStatuses({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_STATUSES_TOGGLE,
                state: !state.showStatuses
            });
        },
        isChecked: state.showStatuses,
        viewAs: viewAs
    }), (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isEstimateEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showEstimateToggle,
        title: formatMessage((0, $cACY7.default).cardDetailEstimate),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG,
                setting: (0, $9pP0g.ViewSetting).SHOW_ESTIMATE
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ESTIMATE,
                state: !state.showEstimate
            });
        },
        isChecked: state.showEstimate,
        viewAs: viewAs
    }), isPriorityEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showPriorityToggle,
        title: formatMessage((0, $cACY7.default).cardDetailPriority),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG,
                setting: (0, $9pP0g.ViewSetting).SHOW_PRIORITY
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_PRIORITY,
                state: !state.showPriority
            });
        },
        isChecked: state.showPriority,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showAssigneeToggle,
        title: formatMessage((0, $cACY7.default).cardDetailAssignee),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG,
                setting: (0, $9pP0g.ViewSetting).SHOW_ASSIGNEE
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ASSIGNEE,
                state: !state.showAssignee
            });
        },
        isChecked: state.showAssignee,
        viewAs: viewAs
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Group, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, null, isVersionsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showVersionPanelToggle,
        title: formatMessage((0, $cACY7.default).versionPanel),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG,
                setting: (0, $9pP0g.ViewSetting).VERSION_PANEL
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).VERSION_PANEL_TOGGLE,
                state: !state.showVersionPanel
            });
        },
        keyboardShortcut: (0, $a4XJc.KeyboardShortcut).VERSION_PANEL_SHORTCUT,
        isChecked: state.showVersionPanel,
        viewAs: viewAs
    }), showEpicAsPanel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showEpicPanelToggle,
        title: formatMessage((0, $cACY7.default).epicPanel, {
            epicName: epicCustomName
        }),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG,
                setting: (0, $9pP0g.ViewSetting).EPIC_PANEL
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).EPIC_PANEL_TOGGLE,
                state: !state.showEpicPanel
            });
        },
        keyboardShortcut: (0, $a4XJc.KeyboardShortcut).ISSUE_PARENT_PANEL_SHORTCUT,
        isChecked: state.showEpicPanel,
        viewAs: viewAs
    }), showFilterBarToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showQuickFiltersToggle,
        title: formatMessage((0, $cACY7.default).quickFilters),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG,
                setting: (0, $9pP0g.ViewSetting).QUICK_FILTERS
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).QUICK_FILTERS_TOGGLE,
                state: !state.showQuickFilters
            });
        },
        isChecked: state.showQuickFilters,
        viewAs: viewAs
    }), isShowBoardNameEnabled && (0, $6s1PB.expValEquals)('surface_origin_board_on_sprint_containers', 'cohort', 'test') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showBoardNameToggle,
        title: formatMessage((0, $cACY7.default).boardName),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG,
                setting: (0, $9pP0g.ViewSetting).SHOW_BOARD_NAME
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_BOARD_NAME,
                state: !state.showBoardName
            });
        },
        isChecked: state.showBoardName,
        viewAs: viewAs
    }), viewAs === (0, $a4XJc.ViewAs).PANEL ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        title: formatMessage((0, $cACY7.default).cardDensity),
        hasSeparator: true,
        "data-testId": (0, $duOMW.backlogViewTestIds).cardLayoutSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9EmtZ.ViewSettingsRadioGroup), {
        testId: (0, $duOMW.backlogViewTestIds).cardLayoutRadioGroup,
        onSelect: (value)=>{
            setViewSettingsCompactMode({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG,
                showCompactMode: value === 'compact'
            });
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).CARD_DENSITY,
                state: value
            });
        },
        value: state.showCompactMode ? 'compact' : 'default',
        options: [
            {
                name: 'card-layout',
                value: 'default',
                label: 'Default',
                icon: (0, $lWTHR.CardLayoutDefaultIcon)
            },
            {
                name: 'card-layout',
                value: 'compact',
                label: 'Compact',
                icon: (0, $evv5v.CardLayoutCompactIcon)
            }
        ],
        viewAs: viewAs,
        ariaLabel: formatMessage((0, $cACY7.default).cardDensity)
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showCompactModeToggle,
        title: formatMessage((0, $cACY7.default).compactMode),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG,
                setting: (0, $9pP0g.ViewSetting).COMPACT_MODE
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).COMPACT_MODE_TOGGLE,
                state: !state.showCompactMode
            });
        },
        isChecked: state.showCompactMode,
        viewAs: viewAs
    })), areSubtasksEnabled && viewAs !== (0, $a4XJc.ViewAs).PANEL && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        title: formatMessage((0, $cACY7.default).subtasks),
        hasSeparator: true,
        "data-testId": (0, $duOMW.backlogViewTestIds).subtaskSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        testId: (0, $duOMW.backlogViewTestIds).subtaskExpandAll,
        isDisabled: areAllSubtasksExpanded,
        onClick: ()=>{
            onSubtasksExpandAll();
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).SUBTASKS_EXPAND_ALL,
                state: (0, $a4XJc.ExpandableState).EXPANDED
            });
        }
    }, formatMessage((0, $cACY7.default).expandAllSubtasks)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        testId: (0, $duOMW.backlogViewTestIds).subtaskCollapseAll,
        isDisabled: areAllSubtasksCollapsed,
        onClick: ()=>{
            onSubtasksCollapseAll();
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).SUBTASKS_COLLAPSE_ALL,
                state: (0, $a4XJc.ExpandableState).COLLAPSED
            });
        }
    }, formatMessage((0, $cACY7.default).collapseAllSubtasks))), showCardDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        testId: (0, $duOMW.backlogViewTestIds).cardDetailsSection,
        title: cardDetailsTitle,
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("fieldset", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("legend", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jldZL.default), null, cardDetailsTitle)), fields)), hasCardExtraFields && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        testId: (0, $duOMW.backlogViewTestIds).customFieldsSection,
        hasSeparator: true
    }, cardExtraFields.map((field)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
            key: field.id,
            testId: `software-view-settings.ui.view-settings-menu.views.backlog.show-${field.id}-toggle-backlog`,
            title: field.label,
            onChange: ()=>{
                toggleExtraField({
                    boardId: boardId,
                    view: (0, $a4XJc.View).BACKLOG,
                    fieldId: field.id
                });
                onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                    key: `${(0, $4cYhQ.ToggleKey).SHOW_EXTRA_FIELD}_${field.id}`,
                    state: !state.cardExtraFields[field.id]
                });
            },
            isChecked: state.cardExtraFields[field.id],
            viewAs: viewAs
        }))), areSubtasksEnabled && viewAs === (0, $a4XJc.ViewAs).PANEL && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        title: formatMessage((0, $cACY7.default).subtasks),
        hasSeparator: true,
        "data-testId": (0, $duOMW.backlogViewTestIds).subtaskSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $61210b60d484d0b3$var$buttonItemContainerPanelModeStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        testId: (0, $duOMW.backlogViewTestIds).subtaskExpandAll,
        isDisabled: areAllSubtasksExpanded,
        onClick: ()=>{
            onSubtasksExpandAll();
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).SUBTASKS_EXPAND_ALL,
                state: (0, $a4XJc.ExpandableState).EXPANDED
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingInline: "space.100"
    }, formatMessage((0, $cACY7.default).expandAllSubtasks))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        testId: (0, $duOMW.backlogViewTestIds).subtaskCollapseAll,
        isDisabled: areAllSubtasksCollapsed,
        onClick: ()=>{
            onSubtasksCollapseAll();
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).SUBTASKS_COLLAPSE_ALL,
                state: (0, $a4XJc.ExpandableState).COLLAPSED
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingInline: "space.100"
    }, formatMessage((0, $cACY7.default).collapseAllSubtasks)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            viewSettingsState: state
        }
    }));
};
const $61210b60d484d0b3$var$buttonItemContainerPanelModeStyles = (0, $8CUq3.xcss)({
    position: 'relative',
    left: '-24px',
    width: 'calc(100% + 48px)'
});

});
parcelRegister("cACY7", function(module, exports) {

$parcel$export(module.exports, "default", () => $32380dcb5ffcf2df$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $32380dcb5ffcf2df$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    buttonLabel: {
        "id": "software-view-settings.common.button-label",
        "defaultMessage": "View settings"
    },
    panelSection: {
        "id": "software-view-settings.common.panel-section",
        "defaultMessage": "Panels"
    },
    versionPanel: {
        "id": "software-view-settings.common.version-panel",
        "defaultMessage": "Version panel"
    },
    epicPanel: {
        "id": "software-view-settings.common.epic-panel",
        "defaultMessage": "{epicName} panel"
    },
    generalViewSettings: {
        "id": "software-view-settings.general-settings",
        "defaultMessage": "General view settings"
    },
    quickFilters: {
        "id": "software-view-settings.common.quick-filters",
        "defaultMessage": "Quick filters"
    },
    workSuggestions: {
        "id": "software-view-settings.common.work-suggestions",
        "defaultMessage": "Work suggestions"
    },
    compactMode: {
        "id": "software-view-settings.common.compact-mode",
        "defaultMessage": "Compact mode"
    },
    cardDetails: {
        "id": "software-view-settings.common.card-details",
        "defaultMessage": "Card details"
    },
    cardFields: {
        "id": "software-view-settings.common.card-fields",
        "defaultMessage": "Fields"
    },
    cardDetailVersion: {
        "id": "software-view-settings.common.card-detail-version",
        "defaultMessage": "Version"
    },
    cardDetailStatus: {
        "id": "software-view-settings.common.card-detail-status",
        "defaultMessage": "Status"
    },
    cardDetailIssueType: {
        "id": "software-view-settings.common.card-detail-issue-type",
        "defaultMessage": "Issue type"
    },
    cardDetailIssueKey: {
        "id": "software-view-settings.common.card-detail-issue-key",
        "defaultMessage": "Issue key"
    },
    cardDetailEstimate: {
        "id": "software-view-settings.common.card-detail-estimate",
        "defaultMessage": "Estimate"
    },
    cardDetailPriority: {
        "id": "software-view-settings.common.card-detail-priority",
        "defaultMessage": "Priority"
    },
    cardDetailDevelopment: {
        "id": "software-view-settings.common.card-detail-development",
        "defaultMessage": "Development"
    },
    cardDetailAssignee: {
        "id": "software-view-settings.common.card-detail-assignee",
        "defaultMessage": "Assignee"
    },
    swimlanes: {
        "id": "software-view-settings.common.swimlanes",
        "defaultMessage": "Swimlanes"
    },
    expandAll: {
        "id": "software-view-settings.common.expand-all",
        "defaultMessage": "Expand all"
    },
    collapseAll: {
        "id": "software-view-settings.common.collapse-all",
        "defaultMessage": "Collapse all"
    },
    expandAllSwimlanes: {
        "id": "software-view-settings.common.expand-all-swimlanes",
        "defaultMessage": "Expand all Swimlanes"
    },
    collapseAllSwimlanes: {
        "id": "software-view-settings.common.collapse-all-swimlanes",
        "defaultMessage": "Collapse all Swimlanes"
    },
    openIssuesInSidebar: {
        "id": "software-view-settings.common.open-issues-in-sidebar",
        "defaultMessage": "Open issues in sidebar"
    },
    subtasks: {
        "id": "software-view-settings.common.subtasks",
        "defaultMessage": "Subtasks"
    },
    expandAllSubtasks: {
        "id": "software-view-settings.common.expand-all-subtasks",
        "defaultMessage": "Expand all"
    },
    collapseAllSubtasks: {
        "id": "software-view-settings.common.collapse-all-subtasks",
        "defaultMessage": "Collapse all"
    },
    showUnscheduledWork: {
        "id": "software-view-settings.common.show-unscheduled-work",
        "defaultMessage": "Show unscheduled work"
    },
    cardLayout: {
        "id": "software-view-settings.common.card-layout",
        "defaultMessage": "Card layout"
    },
    cardDensity: {
        "id": "software-view-settings.common.card-density",
        "defaultMessage": "Density"
    },
    daysInColumn: {
        "id": "software-view-settings.common.days-in-column",
        "defaultMessage": "Days in column"
    },
    dueDate: {
        "id": "software-view-settings.common.due-date",
        "defaultMessage": "Due date"
    },
    labels: {
        "id": "software-view-settings.common.labels",
        "defaultMessage": "Labels"
    },
    linkedIssues: {
        "id": "software-view-settings.common.linked-issues",
        "defaultMessage": "Linked issues"
    },
    cardCovers: {
        "id": "software-view-settings.common.card-covers",
        "defaultMessage": "Cover images"
    },
    toggleHint: {
        "id": "software-view-settings.common.toggle-hint",
        "defaultMessage": "Press {key} to open and close {panel}"
    },
    beta: {
        "id": "software-view-settings.common.beta",
        "defaultMessage": "Beta"
    },
    maxDependenciesError: {
        "id": "software-view-settings.common.max-dependencies-error",
        "defaultMessage": "You can only show dependencies for {maxDeps, plural, one {# issue} other {# issues}} at one time"
    },
    maxDependenciesErrorIssueTermRefresh: {
        "id": "software-view-settings.common.max-dependencies-error-issue-term-refresh",
        "defaultMessage": "You can only show dependencies for {maxDeps, plural, one {# work item} other {# work items}} at one time"
    },
    cardDetailIssueTypeIssueTermRefresh: {
        "id": "software-view-settings.common.card-detail-issue-type-issue-term-refresh",
        "defaultMessage": "Work type"
    },
    cardDetailIssueKeyIssueTermRefresh: {
        "id": "software-view-settings.common.card-detail-issue-key-issue-term-refresh",
        "defaultMessage": "Work item key"
    },
    openIssuesInSidebarIssueTermRefresh: {
        "id": "software-view-settings.common.open-issues-in-sidebar-issue-term-refresh",
        "defaultMessage": "Open work items in sidebar"
    },
    linkedIssuesIssueTermRefresh: {
        "id": "software-view-settings.common.linked-issues-issue-term-refresh",
        "defaultMessage": "Linked work items"
    },
    boardName: {
        "id": "software-view-settings.common.board-name",
        "defaultMessage": "Board name"
    }
});

});

parcelRegister("1wNfX", function(module, exports) {

$parcel$export(module.exports, "PanelGroup", () => $95e55479a51ab212$export$1d05749f6f573bb);

var $5uXOq = parcelRequire("5uXOq");
const $95e55479a51ab212$export$1d05749f6f573bb = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);

});

parcelRegister("e2hHN", function(module, exports) {

$parcel$export(module.exports, "PanelSection", () => $52c1e5c9c03f984a$export$15906978feb79aa6);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $l1N8i = parcelRequire("l1N8i");

var $4R6GH = parcelRequire("4R6GH");
const $52c1e5c9c03f984a$export$15906978feb79aa6 = ({ title: title, hasSeparator: hasSeparator, children: children, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlockEnd: title ? 'space.0' : 'space.050',
        testId: testId
    }, hasSeparator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($52c1e5c9c03f984a$var$Separator, null), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $52c1e5c9c03f984a$var$textStyles
    }, (0, $4R6GH.fg)('jfp_a11y_scrum_backlog_heading') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: (0, $4R6GH.fg)('view-settings-title-size-fix') ? 'xsmall' : 'medium',
        as: (0, $4R6GH.fg)('view-settings-title-size-fix') ? 'h3' : undefined
    }, title) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "strong"
    }, title)), children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $52c1e5c9c03f984a$var$Separator = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_x3dozgxb _19pk12x7 _otyr12x7",
            __cmplp.className
        ])
    });
});
const $52c1e5c9c03f984a$var$textStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});

});

parcelRegister("9EmtZ", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsRadioGroup", () => $4233393bcdedbcd3$export$1e1eee2ec7833bf1);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $jouoW = parcelRequire("jouoW");

var $a4XJc = parcelRequire("a4XJc");
const $4233393bcdedbcd3$export$1e1eee2ec7833bf1 = ({ options: options, value: value, onSelect: onSelect, testId: testId, viewAs: viewAs = (0, $a4XJc.ViewAs).POPUP, ariaLabel: ariaLabel })=>{
    const onChange = (0, $5uXOq.useCallback)((e)=>{
        onSelect(e.target.value);
    }, [
        onSelect
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: viewAs === (0, $a4XJc.ViewAs).PANEL ? $4233393bcdedbcd3$var$panelContainerStyles : $4233393bcdedbcd3$var$popupContainerStyles,
        testId: testId,
        role: "radiogroup",
        "aria-label": ariaLabel
    }, options.map((option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            xcss: $4233393bcdedbcd3$var$radioOptionContainerStyles,
            key: option.value
        }, option.value && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jouoW.default), {
            isChecked: option.value === value,
            onChange: onChange,
            name: option.name,
            label: option.label,
            value: option.value
        }), option.icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $4233393bcdedbcd3$var$iconContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
            glyph: option.icon,
            label: "",
            primaryColor: "var(--ds-icon-subtle, #626F86)"
        })))));
};
const $4233393bcdedbcd3$var$popupContainerStyles = (0, $8CUq3.xcss)({
    marginBlock: '0',
    marginInline: 'space.200',
    minWidth: '200px'
});
const $4233393bcdedbcd3$var$panelContainerStyles = (0, $8CUq3.xcss)({
    marginBlock: 'space.100',
    marginInline: 'auto',
    minWidth: '200px'
});
const $4233393bcdedbcd3$var$radioOptionContainerStyles = (0, $8CUq3.xcss)({
    paddingBlock: 'space.075',
    alignItems: 'center',
    justifyContent: 'space-between'
});
const $4233393bcdedbcd3$var$iconContainerStyles = (0, $8CUq3.xcss)({
    opacity: 0.3
});

});
parcelRegister("jouoW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d22fafff331be84$export$2e2bcd8739ae039);
/* radio.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $VSDnB = parcelRequire("VSDnB");
const $5d22fafff331be84$var$packageName = "platform-pkg";
const $5d22fafff331be84$var$packageVersion = "0.0.0-use.local";
const $5d22fafff331be84$var$noop = (0, $eGmKJ.default);
const $5d22fafff331be84$var$labelPaddingStyles = null;
const $5d22fafff331be84$var$labelStyles = null;
const $5d22fafff331be84$var$radioStyles = null;
const $5d22fafff331be84$var$newRadioStyles = null;
const $5d22fafff331be84$var$InnerRadio = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function Radio(props, ref) {
    const { ariaLabel: ariaLabel, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, name: name, onChange: onChange = $5d22fafff331be84$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, // events and all other input props
    ...rest } = props;
    const onChangeAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'radio',
        packageName: $5d22fafff331be84$var$packageName,
        packageVersion: $5d22fafff331be84$var$packageVersion
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("label", {
        "data-testid": testId && `${testId}--radio-label`,
        "data-disabled": isDisabled ? 'true' : undefined,
        className: (0, $bwpsq.default)([
            "_11c82smr _1e0c1txw _vchhusvi _kqswh2mm _4cvr1y6m _syazj3m3 _mqf81tvo _g7st13gf"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                ...rest,
                tabIndex: 0,
                "aria-label": ariaLabel,
                checked: isChecked,
                disabled: isDisabled,
                name: name,
                onChange: onChangeAnalytics,
                required: isRequired,
                type: "radio",
                value: value,
                "data-testid": testId && `${testId}--radio-input`,
                // use :invalid selector
                "data-invalid": isInvalid ? 'true' : undefined,
                ref: ref,
                className: (0, $bwpsq.default)([
                    "_18s8ze3t _19it3vzd _2rko1q5u _12ji1r31 _1qu2glyw _12y31o36 _v56415j1 _1e0c1txw _1bsb1tcg _4t3i1tcg _kqswh2mm _4cvr1h6o _1bah1h6o _1o9zidpf _bfhk4t47 _13diglyw _1q6qmag2 _11511fmg _1s6w1qbb _tqbwidpf _t9ec1s1q _s7n4jp4b _wstuglyw _16r2ucr4 _14mj1q5u _qc5orqeg _z0ai1cbz _1qdg1cbz _18postnw _aetrb3bt _1peq1xmd _iosizyvw _11jyzyvw _f3ett94y _19ybk8x7 _1d7pk8x7 _j5dh13gf _scgf13gf _1gcs13gf _1x1a13gf _6hp813gf _4rya1y1w _o1bd1y1w _nxi61y1w _neoe1y1w _1el21y1w _lekrzcs9 _11v7zcs9 _1f8czcs9 _s2ftzcs9 _17a1zcs9 _x48a15t7 _1ib215t7 _1yk915t7 _gdmb15t7 _pmm415t7 _y2mvehbj _1bg4jfq9 _6tjkehbj _awqnjfq9 _1rvq10ko _1p9j1fmg _x2tzhh5a _1iwzhh5a _sj8y1wq0 _jckox2ru _1dvd1fmg _60ak1dzn",
                    (0, $VSDnB.fg)('platform-visual-refresh-icons') && "_t9ec1soj _z0ai120g _1qdg120g"
                ])
            }),
            label ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                className: (0, $bwpsq.default)([
                    "_85i5v77o _1q51v77o _y4ti1b66 _bozg1b66"
                ]),
                children: label
            }) : null
        ]
    });
}); /**
     * __Radio__
     *
     * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
     *
     * - [Examples](https://atlassian.design/components/radio/examples)
     * - [Code](https://atlassian.design/components/radio/code)
     * - [Usage](https://atlassian.design/components/radio/usage)
     */ 
const $5d22fafff331be84$var$Radio = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Radio(props, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)($5d22fafff331be84$var$InnerRadio, {
        ...props,
        ref: ref
    });
}));
var $5d22fafff331be84$export$2e2bcd8739ae039 = $5d22fafff331be84$var$Radio;

});


parcelRegister("htuq0", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsToggle", () => $5bf54757b2a57348$export$aacc18ae911f8e05);

var $5uXOq = parcelRequire("5uXOq");

var $3T6Xo = parcelRequire("3T6Xo");

var $3u0c5 = parcelRequire("3u0c5");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $dTlW6 = parcelRequire("dTlW6");

var $dqoiX = parcelRequire("dqoiX");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $cACY7 = parcelRequire("cACY7");

var $a4XJc = parcelRequire("a4XJc");

var $cYeCp = parcelRequire("cYeCp");
const $5bf54757b2a57348$export$aacc18ae911f8e05 = ({ title: title, isChecked: isChecked, isDisabled: isDisabled, onChange: onChange, keyboardShortcut: keyboardShortcut, subtitleLozenge: subtitleLozenge, testId: testId, viewAs: viewAs = (0, $a4XJc.ViewAs).POPUP, footer: footer })=>{
    const id = (0, (/*@__PURE__*/$parcel$interopDefault($3T6Xo)))(`jira-software-view-settings-${title}`);
    const descriptionId = `${id}-description`;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: viewAs === (0, $a4XJc.ViewAs).PANEL && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() ? $5bf54757b2a57348$var$panelContainerStyles : $5bf54757b2a57348$var$popupContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.200",
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("label", {
        "data-testid": testId,
        htmlFor: id
    }, title), subtitleLozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
        appearance: "new"
    }, subtitleLozenge)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: (0, $dCm1o.isVisualRefreshEnabled)() ? $5bf54757b2a57348$var$tooltipContainerStyles : $5bf54757b2a57348$var$tooltipContainerStylesOld
    }, keyboardShortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), null, keyboardShortcut), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dTlW6.default), {
        id: id,
        isChecked: isChecked,
        onChange: onChange,
        isDisabled: isDisabled,
        ...keyboardShortcut && {
            descriptionId: descriptionId
        }
    }), keyboardShortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), {
        id: descriptionId
    }, formatMessage((0, $cACY7.default).toggleHint, {
        key: keyboardShortcut,
        panel: title
    })))), footer);
};
const $5bf54757b2a57348$var$popupContainerStyles = (0, $8CUq3.xcss)({
    marginBlock: 'space.100',
    marginInline: 'space.200',
    minWidth: '200px'
});
const $5bf54757b2a57348$var$panelContainerStyles = (0, $8CUq3.xcss)({
    marginBlock: 'space.100',
    marginInline: 'auto',
    minWidth: '200px'
});
const $5bf54757b2a57348$var$tooltipContainerStylesOld = (0, $8CUq3.xcss)({
    color: 'color.text.subtlest',
    whiteSpace: 'nowrap',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 0
});
const $5bf54757b2a57348$var$tooltipContainerStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtlest',
    whiteSpace: 'nowrap',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 0,
    display: 'flex',
    alignItems: 'center'
});

});
parcelRegister("dTlW6", function(module, exports) {

$parcel$export(module.exports, "default", () => $3db77843cf29c460$export$2e2bcd8739ae039);
/* toggle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $9KnKW = parcelRequire("9KnKW");

var $7fA4P = parcelRequire("7fA4P");

var $aFYTH = parcelRequire("aFYTH");

var $VSDnB = parcelRequire("VSDnB");

var $lahQ6 = parcelRequire("lahQ6");
const $3db77843cf29c460$var$basicStyles = null;
const $3db77843cf29c460$var$borderStyles = null;
const $3db77843cf29c460$var$iconStyles = null;
const $3db77843cf29c460$var$sizeStyles = {
    regular: "_2rkopxbi _4t3ipxbi _1bsbxy5q _kfgtutpp _1mp41crf _p9c41fbe",
    large: "_2rkov47k _4t3iv47k _1bsb1jfw _kfgtpxbi _1mp47vkz _p9c4w12q"
};
const $3db77843cf29c460$var$noop = (0, $eGmKJ.default);
const $3db77843cf29c460$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $3db77843cf29c460$var$iconSizeMap = {
    regular: 'small',
    large: 'medium'
}; /**
    * __Toggle__
    *
    * A toggle is used to view or switch between enabled or disabled states.
    *
    * - [Examples](https://atlassian.design/components/toggle/examples)
    * - [Code](https://atlassian.design/components/toggle/code)
    * - [Usage](https://atlassian.design/components/toggle/usage)
    */ 
const $3db77843cf29c460$var$Toggle = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $3db77843cf29c460$var$noop, onChange: providedChange = $3db77843cf29c460$var$noop, onFocus: providedFocus = $3db77843cf29c460$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $5uXOq.useState)(defaultChecked);
    const [isKeyboardUsed, setIsKeyboardUsed] = (0, $5uXOq.useState)(true);
    const wrapperRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (id && wrapperRef.current && wrapperRef.current.parentElement) {
            /*
      	DSP-21524 Handling the click on <label> that is linked via "for" attribute.
      	By default click on the label fires absolutely same onclick event as click on the input element.
      	To differentiate keyboard click from mouse we need this additional listener.
      */ const linkedLabel = wrapperRef.current.parentElement.querySelector(`label[for="${id}"]`);
            if (linkedLabel) {
                const unbind = (0, $cBeZP.bindAll)(linkedLabel, [
                    {
                        type: 'click',
                        listener: (event)=>{
                            setIsKeyboardUsed(false);
                            if (event?.detail > 1) /*
              DSP-21524 double or triple click on label initiating the text selection for label text and adds additional step to tab order.
              So here we set the isKeyboardUsed to true, to display focus ring on next Tab press
              */ setIsKeyboardUsed(true);
                        }
                    }
                ]);
                return unbind;
            }
        }
    }, [
        id,
        wrapperRef,
        isKeyboardUsed
    ]);
    const handleBlur = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (!isKeyboardUsed) setIsKeyboardUsed(true);
            providedOnBlur(event, analyticsEvent);
        },
        action: 'blur',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const handleFocus = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const handleChange = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked)=>!checked);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const onLabelKeyDown = (event)=>{
        if ([
            ' ',
            'Tab',
            'Space'
        ].includes(event.key)) setIsKeyboardUsed(true);
    };
    const shouldChecked = isControlled ? checked : isChecked;
    const controlProps = {
        'data-checked': shouldChecked ? shouldChecked : undefined,
        'data-disabled': isDisabled ? isDisabled : undefined,
        'data-size': size,
        'data-testid': testId ? testId : undefined,
        // DSP-21524 Because label gets focus ring via focus-within and focus-within also triggers by mouse click we have to manually control the ring appearance.
        onKeyDown: onLabelKeyDown,
        onMouseDown: ()=>{
            setIsKeyboardUsed(false);
        }
    };
    const legacyIconSize = $3db77843cf29c460$var$iconSizeMap[size];
    const labelId = (0, $9KnKW.useId)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("label", {
        ...controlProps,
        ref: wrapperRef,
        className: (0, $bwpsq.default)([
            "_v564kete _1h6d3acm _1dqonqa1 _189eyh40 _1e0c1o8l _vchh18uv _kqswh2mm _1y1m1ntv _bfhk76s1 _syaz5w2r _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5v77o _1q51v77o _y4tiv77o _bozgv77o _1i2uidpf _1i3tidpf _se28idpf _3tunidpf _1423idpf _1hrtidpf _1bz2idpf _rqfvidpf _1yc0glyw _onsr1snc _1vgmagmp _1av610yn _1ulhidpf _rfx31q5u _pdykkete _1cs8stnw _1rus5w2r _1kt9b3bt _1fkr1y44 _z5wt1y44 _7dwzglyw _1bki1y1w _1flt1y1w _3xv21y1w _9471g4a2 _ucab5w2r _mqf815t7 _3dj215t7 _1dl915t7 _1div5w2r _1il8kb7n _y54d5w2r _irr353wy _d0altlke _19ja13gf _8muf13gf _1k1q13gf _1plud4ly _1uo853wy _178c1y1w _16rslghj _ogf41r31 _1rtbnqa1 _5gg9t94y",
            isKeyboardUsed && "_jyzf194a _1r4mnqa1 _1t9pyh40",
            size === 'large' && !(0, $VSDnB.fg)('platform-visual-refresh-icons') && "_1n82gktf _19vpgktf",
            $3db77843cf29c460$var$sizeStyles[size]
        ]),
        children: [
            label ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                id: labelId,
                hidden: true,
                children: label
            }) : null,
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                ref: ref,
                checked: shouldChecked,
                disabled: isDisabled,
                id: id,
                name: name,
                onBlur: handleBlur,
                onChange: handleChange,
                onFocus: handleFocus,
                type: "checkbox",
                value: value,
                "data-testid": testId && `${testId}--input`,
                "aria-labelledby": label ? labelId : undefined,
                "aria-describedby": descriptionId
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lahQ6.default), {
                size: size,
                isHidden: !shouldChecked,
                position: "left",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7fA4P))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-check-icon`
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lahQ6.default), {
                size: size,
                isHidden: shouldChecked,
                position: "right",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aFYTH))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-cross-icon`
                })
            })
        ]
    });
}));
$3db77843cf29c460$var$Toggle.displayName = 'Toggle';
var $3db77843cf29c460$export$2e2bcd8739ae039 = $3db77843cf29c460$var$Toggle;

});
parcelRegister("7fA4P", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::90a6c328ce4531920c578790d71561aa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5475eb3f94e0b044$var$_react = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5475eb3f94e0b044$var$_checkMark = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("f22iM")));

var $5475eb3f94e0b044$var$_done = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("4DXCl")));
function $5475eb3f94e0b044$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5475eb3f94e0b044$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $5475eb3f94e0b044$var$_react.default.createElement($5475eb3f94e0b044$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $5475eb3f94e0b044$var$_done.default
    }, props));
$5475eb3f94e0b044$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $5475eb3f94e0b044$var$_default = module.exports.default = $5475eb3f94e0b044$var$CheckMarkIcon;

});
parcelRegister("f22iM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f681ccdbe722d68d6bd374c0928f0bd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af18d40ba5b744b4$var$_react = $af18d40ba5b744b4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $af18d40ba5b744b4$var$_baseNew = $af18d40ba5b744b4$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $af18d40ba5b744b4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $af18d40ba5b744b4$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $af18d40ba5b744b4$var$_react.default.createElement($af18d40ba5b744b4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m11.06 3-6.25 7a.75.75 0 0 1-1.15-.037l-2.75-3.5 1.18-.926 2.197 2.796L9.94 2z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$af18d40ba5b744b4$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $af18d40ba5b744b4$var$_default = module.exports.default = $af18d40ba5b744b4$var$CheckMarkIcon;

});

parcelRegister("4DXCl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36190cbd288fec69$var$_react = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $36190cbd288fec69$var$_checkMark = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("bjo8S")));
function $36190cbd288fec69$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $36190cbd288fec69$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $36190cbd288fec69$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props, {
        newIcon: $36190cbd288fec69$var$_checkMark.default
    }));
$36190cbd288fec69$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $36190cbd288fec69$var$_default = module.exports.default = $36190cbd288fec69$var$EditorDoneIcon;

});
parcelRegister("bjo8S", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3e71f4112aeb66b16fbd284cc49bbc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83c43234bc70a485$var$_react = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $83c43234bc70a485$var$_baseNew = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $83c43234bc70a485$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $83c43234bc70a485$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $83c43234bc70a485$var$_react.default.createElement($83c43234bc70a485$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m15.076 3.23-8.75 10.5a.75.75 0 0 1-1.159-.008l-4.25-5.25 1.166-.944 3.675 4.54 8.166-9.798z" clip-rule="evenodd"/>`
    }, props));
$83c43234bc70a485$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $83c43234bc70a485$var$_default = module.exports.default = $83c43234bc70a485$var$CheckMarkIcon;

});



parcelRegister("lahQ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca1cdaa1eb34599d$export$2e2bcd8739ae039);
/* icon-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
const $ca1cdaa1eb34599d$var$styles = {
    iconContainer: "_v5641hrg _1e0c116y _4cvr1h6o _1bah1h6o _kqswstnw _152tv77o",
    iconContainerRegular: "_1bsb7vkz _4t3i7vkz",
    iconContainerLarge: "_1bsbgktf _4t3igktf",
    hidden: "_tzy4idpf",
    left: "_1e021l7b",
    right: "_rjxp1l7b"
};
/**
 * __Icon container__
 *
 * Positions a toggle's check and close icons.
 */ const $ca1cdaa1eb34599d$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "span",
        xcss: (0, $3JT92.cx)($ca1cdaa1eb34599d$var$styles.iconContainer, isHidden && (0, $VSDnB.fg)('platform-visual-refresh-icons') && $ca1cdaa1eb34599d$var$styles.hidden, size === 'regular' && $ca1cdaa1eb34599d$var$styles.iconContainerRegular, size === 'large' && $ca1cdaa1eb34599d$var$styles.iconContainerLarge, position === 'left' && $ca1cdaa1eb34599d$var$styles.left, position === 'right' && $ca1cdaa1eb34599d$var$styles.right),
        children: children
    });
};
var $ca1cdaa1eb34599d$export$2e2bcd8739ae039 = $ca1cdaa1eb34599d$var$IconContainer;

});



parcelRegister("evv5v", function(module, exports) {

$parcel$export(module.exports, "CardLayoutCompactIcon", () => $ca4072fbbcba385a$export$73c305db8d999c47);
// SVG with custom colours

var $5uXOq = parcelRequire("5uXOq");
const $ca4072fbbcba385a$export$73c305db8d999c47 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "58",
        height: "28",
        viewBox: "0 0 58 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label']
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M0.5 2C0.5 1.17157 1.17157 0.5 2 0.5H56C56.8284 0.5 57.5 1.17157 57.5 2V9.5H0.5V2Z",
        stroke: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M57 10V18H59V10H57ZM1 18V10H-1V18H1Z",
        fill: "currentColor",
        mask: "url(#path-2-inside-1_1311_59)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M0.5 18.5H57.5V26C57.5 26.8284 56.8284 27.5 56 27.5H2C1.17157 27.5 0.5 26.8284 0.5 26V18.5Z",
        stroke: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "5",
        y: "3",
        width: "4",
        height: "4",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "5",
        y: "12",
        width: "4",
        height: "4",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "5",
        y: "21",
        width: "4",
        height: "4",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "12",
        y: "4",
        width: "41",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "12",
        y: "13",
        width: "41",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "12",
        y: "22",
        width: "41",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }));

});

parcelRegister("lWTHR", function(module, exports) {

$parcel$export(module.exports, "CardLayoutDefaultIcon", () => $f330d0d9ada9ffbb$export$b1c73e945668f4c2);
// SVG with custom colours

var $5uXOq = parcelRequire("5uXOq");
const $f330d0d9ada9ffbb$export$b1c73e945668f4c2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "58",
        height: "27",
        viewBox: "0 0 58 27",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label']
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M0 14H58H0ZM59 25C59 26.6569 57.6569 28 56 28H2C0.343146 28 -1 26.6569 -1 25H1C1 25.5523 1.44772 26 2 26H56C56.5523 26 57 25.5523 57 25H59ZM2 28C0.343146 28 -1 26.6569 -1 25V14H1V25C1 25.5523 1.44772 26 2 26V28ZM59 14V25C59 26.6569 57.6569 28 56 28V26C56.5523 26 57 25.5523 57 25V14H59Z",
        fill: "currentColor",
        mask: "url(#path-1-inside-1_1311_46)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M0.5 2C0.5 1.17157 1.17157 0.5 2 0.5H56C56.8284 0.5 57.5 1.17157 57.5 2V13.5H0.5V2Z",
        stroke: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "5",
        y: "5",
        width: "4",
        height: "4",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "5",
        y: "18",
        width: "4",
        height: "4",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "12",
        y: "6",
        width: "41",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "12",
        y: "19",
        width: "41",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }));

});


parcelRegister("140hX", function(module, exports) {

$parcel$export(module.exports, "BoardMenu", () => $0229f37a37892c4a$export$17445232de9c085a);

var $5uXOq = parcelRequire("5uXOq");

var $kJpBP = parcelRequire("kJpBP");
var $eZUJu = parcelRequire("eZUJu");
var $9UCCQ = parcelRequire("9UCCQ");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $jldZL = parcelRequire("jldZL");

var $c04PQ = parcelRequire("c04PQ");

var $6s1PB = parcelRequire("6s1PB");

var $axmY8 = parcelRequire("axmY8");

var $2DjOQ = parcelRequire("2DjOQ");

var $koVbs = parcelRequire("koVbs");

var $2gCtH = parcelRequire("2gCtH");

var $5oFIy = parcelRequire("5oFIy");

var $4R6GH = parcelRequire("4R6GH");

var $cSD7y = parcelRequire("cSD7y");

var $duOMW = parcelRequire("duOMW");

var $cACY7 = parcelRequire("cACY7");

var $4cYhQ = parcelRequire("4cYhQ");

var $a4XJc = parcelRequire("a4XJc");

var $9pP0g = parcelRequire("9pP0g");

var $1wNfX = parcelRequire("1wNfX");

var $e2hHN = parcelRequire("e2hHN");

var $htuq0 = parcelRequire("htuq0");

var $cYeCp = parcelRequire("cYeCp");

var $iDGXn = parcelRequire("iDGXn");
const $0229f37a37892c4a$export$17445232de9c085a = ({ viewAs: viewAs, boardId: boardId, showFilterBarToggle: showFilterBarToggle = false, showLinkedIssueStatsToggle: showLinkedIssueStatsToggle = false, isSwimlanesEnabled: isSwimlanesEnabled = false, showCardDetails: showCardDetails = true, epicCustomName: epicCustomName = 'Epic', onHandleChange: onHandleChange, onSwimlaneExpandAll: // eslint-disable-next-line @typescript-eslint/no-empty-function
onSwimlaneExpandAll = ()=>{}, onSwimlaneCollapseAll: // eslint-disable-next-line @typescript-eslint/no-empty-function
onSwimlaneCollapseAll = ()=>{}, onToggleWorkSuggestions: // eslint-disable-next-line @typescript-eslint/no-empty-function
onToggleWorkSuggestions = ()=>{}, onLinkedIssuesStatsToggledOn: // eslint-disable-next-line @typescript-eslint/no-empty-function
onLinkedIssuesStatsToggledOn = ()=>{}, onShowCardCoversToggledOn: // eslint-disable-next-line @typescript-eslint/no-empty-function
onShowCardCoversToggledOn = ()=>{}, isClassic: isClassic = false, isDaysInColumnEnabled: isDaysInColumnEnabled = false, isEstimateEnabled: isEstimateEnabled = false, isDueDateEnabled: isDueDateEnabled = false, isLabelsEnabled: isLabelsEnabled = false, isPriorityEnabled: isPriorityEnabled = false, isDevelopmentEnabled: isDevelopmentEnabled = false, isWorkSuggestionsEnabled: isWorkSuggestionsEnabled = false, showWorkSuggestions: showWorkSuggestions = false, cardExtraFields: cardExtraFields = [] })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [state, actions] = (0, $iDGXn.useViewSettings)();
    const { view: view } = state;
    const { toggleViewSetting: toggleViewSetting, toggleShowEpics: toggleShowEpics, toggleShowLinkedIssuesStats: toggleShowLinkedIssuesStats, toggleShowDaysInColumn: toggleShowDaysInColumn, toggleShowDueDate: toggleShowDueDate, toggleExtraField: toggleExtraField, toggleShowLabels: toggleShowLabels } = actions;
    const viewMode = (0, $2gCtH.useViewMode)();
    const [, { setDetailViewAsSidebar: setDetailViewAsSidebar, setDetailViewAsModal: setDetailViewAsModal }] = (0, $2gCtH.useIssueContextActions)();
    const Section = viewAs === (0, $a4XJc.ViewAs).PANEL ? (0, $e2hHN.PanelSection) : (0, $9UCCQ.default);
    const Group = viewAs === (0, $a4XJc.ViewAs).PANEL ? (0, $1wNfX.PanelGroup) : (0, $eZUJu.default);
    const cardDetailsTitle = viewAs === (0, $a4XJc.ViewAs).PANEL ? formatMessage((0, $cACY7.default).cardFields) : formatMessage((0, $cACY7.default).cardDetails);
    const handleBoardViewModeClick = ()=>{
        if (viewMode === 'SIDEBAR') setDetailViewAsModal();
        else setDetailViewAsSidebar();
    };
    const hasCardExtraFields = cardExtraFields.length > 0;
    const handleLinkedIssuesStatsToggleChange = (0, $5uXOq.useCallback)(()=>{
        const showIssueLinksStatsState = state.showIssueLinksStats;
        toggleShowLinkedIssuesStats({
            boardId: boardId,
            view: (0, $a4XJc.View).BOARD
        });
        onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
            key: (0, $4cYhQ.ToggleKey).SHOW_ISSUE_LINKS_STATS,
            state: !showIssueLinksStatsState
        });
        // start fetching issue links stats if the user turned on toggle
        if (!showIssueLinksStatsState) onLinkedIssuesStatsToggledOn();
    }, [
        boardId,
        onHandleChange,
        onLinkedIssuesStatsToggledOn,
        state.showIssueLinksStats,
        toggleShowLinkedIssuesStats
    ]);
    const handleShowCardCoversToggleChange = (0, $5uXOq.useCallback)(()=>{
        const showCardCoversState = state.showCardCovers;
        toggleViewSetting({
            boardId: boardId,
            view: (0, $a4XJc.View).BOARD,
            setting: (0, $9pP0g.ViewSetting).SHOW_CARD_COVERS
        });
        onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
            key: (0, $4cYhQ.ToggleKey).SHOW_CARD_COVERS,
            state: !state.showCardCovers
        });
        // start fetching card cover data if the user turned on toggle
        if (!showCardCoversState) onShowCardCoversToggledOn();
    }, [
        boardId,
        onHandleChange,
        onShowCardCoversToggledOn,
        state.showCardCovers,
        toggleViewSetting
    ]);
    const fields = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, view === (0, $a4XJc.View).BOARD && isClassic && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showCardCoversToggle,
        title: formatMessage((0, $cACY7.default).cardCovers),
        onChange: handleShowCardCoversToggleChange,
        isChecked: state.showCardCovers,
        viewAs: viewAs
    }), view === (0, $a4XJc.View).BOARD && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showIssueTypeToggle,
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cACY7.default).cardDetailIssueTypeIssueTermRefresh : (0, $cACY7.default).cardDetailIssueType),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_ISSUE_TYPE
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ISSUE_TYPE,
                state: !state.showIssueType
            });
        },
        isChecked: state.showIssueType,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showIssueKeyToggle,
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cACY7.default).cardDetailIssueKeyIssueTermRefresh : (0, $cACY7.default).cardDetailIssueKey),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_ISSUE_KEY
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ISSUE_KEY,
                state: !state.showIssueKey
            });
        },
        isChecked: state.showIssueKey,
        viewAs: viewAs
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showEpicsToggle,
        title: epicCustomName,
        onChange: ()=>{
            toggleShowEpics({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_EPICS_TOGGLE,
                state: !state.showEpics
            });
        },
        isChecked: state.showEpics,
        viewAs: viewAs
    }), isDueDateEnabled && view === (0, $a4XJc.View).BOARD && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showDueDateToggle,
        title: formatMessage((0, $cACY7.default).dueDate),
        onChange: ()=>{
            toggleShowDueDate({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_DUE_DATE,
                state: !state.showDueDate
            });
        },
        isChecked: state.showDueDate,
        viewAs: viewAs
    }), isLabelsEnabled && view === (0, $a4XJc.View).BOARD && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showLabelsToggle,
        title: formatMessage((0, $cACY7.default).labels),
        onChange: ()=>{
            toggleShowLabels({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_LABELS,
                state: !state.showLabels
            });
        },
        isChecked: state.showLabels,
        viewAs: viewAs
    }), isEstimateEnabled && view === (0, $a4XJc.View).BOARD && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showEstimateToggle,
        title: formatMessage((0, $cACY7.default).cardDetailEstimate),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_ESTIMATE
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ESTIMATE,
                state: !state.showEstimate
            });
        },
        isChecked: state.showEstimate,
        viewAs: viewAs
    }), isDaysInColumnEnabled && view === (0, $a4XJc.View).BOARD && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showDaysInColumnToggle,
        title: formatMessage((0, $cACY7.default).daysInColumn),
        onChange: ()=>{
            toggleShowDaysInColumn({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_DAYS_IN_COLUMN,
                state: !state.showDaysInColumn
            });
        },
        isChecked: state.showDaysInColumn,
        viewAs: viewAs
    }), showLinkedIssueStatsToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showLinkedIssueStatsToggle,
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cACY7.default).linkedIssuesIssueTermRefresh : (0, $cACY7.default).linkedIssues),
        onChange: handleLinkedIssuesStatsToggleChange,
        isChecked: state.showIssueLinksStats,
        viewAs: viewAs
    }), view === (0, $a4XJc.View).BOARD && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isDevelopmentEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showDevelopmentToggle,
        title: formatMessage((0, $cACY7.default).cardDetailDevelopment),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_DEVELOPMENT
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_DEVELOPMENT,
                state: !state.showDevelopment
            });
        },
        isChecked: state.showDevelopment,
        viewAs: viewAs
    }), isPriorityEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showPriorityToggle,
        title: formatMessage((0, $cACY7.default).cardDetailPriority),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_PRIORITY
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_PRIORITY,
                state: !state.showPriority
            });
        },
        isChecked: state.showPriority,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showAssigneeToggle,
        title: formatMessage((0, $cACY7.default).cardDetailAssignee),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_ASSIGNEE
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ASSIGNEE,
                state: !state.showAssignee
            });
        },
        isChecked: state.showAssignee,
        viewAs: viewAs
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Group, {
        "data-testId": (0, $duOMW.boardViewTestIds).viewSettingsBoardMenu
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0229f37a37892c4a$var$ConditionalFieldSet, null, (0, $4R6GH.fg)('tanuki_a11y_q4') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("legend", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jldZL.default), null, formatMessage((0, $cACY7.default).generalViewSettings))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).openIssuesInSidebarToggle,
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cACY7.default).openIssuesInSidebarIssueTermRefresh : (0, $cACY7.default).openIssuesInSidebar),
        onChange: ()=>{
            handleBoardViewModeClick();
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).OPEN_ISSUES_IN_SIDEBAR_TOGGLE,
                state: viewMode === 'SIDEBAR' ? (0, $a4XJc.ViewLocation).MODAL : (0, $a4XJc.ViewLocation).SIDEBAR
            });
        },
        isChecked: viewMode === 'SIDEBAR',
        viewAs: viewAs
    }), showFilterBarToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showQuickFiltersToggle,
        title: formatMessage((0, $cACY7.default).quickFilters),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD,
                setting: (0, $9pP0g.ViewSetting).QUICK_FILTERS
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).QUICK_FILTERS_TOGGLE,
                state: !state.showQuickFilters
            });
        },
        isChecked: state.showQuickFilters,
        viewAs: viewAs
    }), !(0, $c04PQ.isFedRamp)() && showWorkSuggestions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0229f37a37892c4a$var$WorkSuggestionsSpotlightTarget, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2DjOQ.ViewSettingsTogglePulse), {
        isPanelView: viewAs === (0, $a4XJc.ViewAs).PANEL
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showWorkSuggestionsToggle,
        title: formatMessage((0, $cACY7.default).workSuggestions),
        onChange: (_, analyticsEvent)=>{
            onToggleWorkSuggestions(analyticsEvent);
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).WORK_SUGGESTIONS_TOGGLE,
                state: !isWorkSuggestionsEnabled
            });
        },
        isChecked: isWorkSuggestionsEnabled,
        viewAs: viewAs
    }))))), isSwimlanesEnabled && viewAs !== (0, $a4XJc.ViewAs).PANEL && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        title: formatMessage((0, $cACY7.default).swimlanes),
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        "data-testid": (0, $duOMW.boardViewTestIds).swimlaneExpandAll,
        onClick: ()=>{
            onSwimlaneExpandAll();
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).SWIMLANE_EXPAND_ALL,
                state: (0, $a4XJc.ExpandableState).EXPANDED
            });
        }
    }, formatMessage((0, $cACY7.default).expandAll)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        "data-testid": (0, $duOMW.boardViewTestIds).swimlaneCollapseAll,
        onClick: ()=>{
            onSwimlaneCollapseAll();
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).SWIMLANE_COLLAPSE_ALL,
                state: (0, $a4XJc.ExpandableState).COLLAPSED
            });
        }
    }, formatMessage((0, $cACY7.default).collapseAll))), showCardDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        testId: (0, $duOMW.boardViewTestIds).cardDetailsSection,
        title: cardDetailsTitle,
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("fieldset", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("legend", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jldZL.default), null, cardDetailsTitle)), fields)), hasCardExtraFields && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        testId: (0, $duOMW.boardViewTestIds).customFieldsSection,
        hasSeparator: true
    }, cardExtraFields.map((field)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
            key: field.id,
            testId: `software-view-settings.ui.view-settings-menu.views.board.show-${field.id}-toggle-board`,
            title: field.label,
            onChange: ()=>{
                toggleExtraField({
                    boardId: boardId,
                    view: (0, $a4XJc.View).BOARD,
                    fieldId: field.id
                });
                onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                    key: `${(0, $4cYhQ.ToggleKey).SHOW_EXTRA_FIELD}_${field.id}`,
                    state: !state.cardExtraFields[field.id]
                });
            },
            isChecked: state.cardExtraFields[field.id],
            viewAs: viewAs
        }))), isSwimlanesEnabled && viewAs === (0, $a4XJc.ViewAs).PANEL && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        title: formatMessage((0, $cACY7.default).swimlanes),
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $0229f37a37892c4a$var$buttonItemContainerPanelModeStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        "data-testid": (0, $duOMW.boardViewTestIds).swimlaneExpandAll,
        onClick: ()=>{
            onSwimlaneExpandAll();
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).SWIMLANE_EXPAND_ALL,
                state: (0, $a4XJc.ExpandableState).EXPANDED
            });
        },
        "aria-label": (0, $4R6GH.fg)('jfp_a11y_team_scrum_board_non_descriptive_label') ? formatMessage((0, $cACY7.default).expandAllSwimlanes) : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingInline: "space.100"
    }, formatMessage((0, $cACY7.default).expandAll))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        "data-testid": (0, $duOMW.boardViewTestIds).swimlaneCollapseAll,
        onClick: ()=>{
            onSwimlaneCollapseAll();
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).SWIMLANE_COLLAPSE_ALL,
                state: (0, $a4XJc.ExpandableState).COLLAPSED
            });
        },
        "aria-label": (0, $4R6GH.fg)('jfp_a11y_team_scrum_board_non_descriptive_label') ? formatMessage((0, $cACY7.default).collapseAllSwimlanes) : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingInline: "space.100"
    }, formatMessage((0, $cACY7.default).collapseAll)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            viewSettingsState: state
        }
    }));
};
const $0229f37a37892c4a$var$ConditionalFieldSet = (0, $cSD7y.componentWithFG)('tanuki_a11y_q4', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("fieldset", null, children), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children));
const $0229f37a37892c4a$var$WorkSuggestionsSpotlightTarget = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: (0, $axmY8.WORK_SUGGESTIONS_VIEW_SETTINGS_SPOTLIGHT_VIEW_SETTINGS_STEP_NAME)
    }, children);
const $0229f37a37892c4a$var$buttonItemContainerPanelModeStyles = (0, $8CUq3.xcss)({
    position: 'relative',
    left: '-24px',
    width: 'calc(100% + 48px)'
});

});
parcelRegister("axmY8", function(module, exports) {

$parcel$export(module.exports, "WORK_SUGGESTIONS_TASK_TYPES", () => $1c70475fc99a2c16$export$3fee72c065a0af0e);
$parcel$export(module.exports, "PACKAGE_NAME", () => $1c70475fc99a2c16$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "ITEMS_PER_BATCH", () => $1c70475fc99a2c16$export$9e952e4d801fa8ed);
$parcel$export(module.exports, "NEXT_BEST_TASK_ANALYTICS", () => $1c70475fc99a2c16$export$55230ca85072e545);
$parcel$export(module.exports, "ERROR_BOUNDARY_PACKAGE", () => $1c70475fc99a2c16$export$e6c43e0cbc9a213a);
$parcel$export(module.exports, "PANEL_WIDTH", () => $1c70475fc99a2c16$export$e05cfff20e9274e6);
$parcel$export(module.exports, "PANEL_WIDTH_WITH_MARGIN", () => $1c70475fc99a2c16$export$8603bff3dda8aaad);
$parcel$export(module.exports, "PANEL_HEADER_HEIGHT", () => $1c70475fc99a2c16$export$c33dba4345ee2db8);
$parcel$export(module.exports, "ANIMATION_TIMEOUT", () => $1c70475fc99a2c16$export$fdd30d204cbe80e6);
$parcel$export(module.exports, "ARTICLE_ID", () => $1c70475fc99a2c16$export$7147685613ef9998);
$parcel$export(module.exports, "DEV_DETAILS_DIALOG_SCOPE_ID", () => $1c70475fc99a2c16$export$6bc465585d114926);
$parcel$export(module.exports, "DEV_DETAILS_DEPLOYMENT_PANEL_TYPE", () => $1c70475fc99a2c16$export$5653d49c1e9688e9);
$parcel$export(module.exports, "DEV_DETAILS_BUILD_PANEL_TYPE", () => $1c70475fc99a2c16$export$43925e5456315f);
$parcel$export(module.exports, "NEXT_BEST_TASK_USER_PROPERTIES_SCOPE", () => $1c70475fc99a2c16$export$ec5e18bceb05348c);
$parcel$export(module.exports, "WORK_SUGGESTIONS_VIEW_SETTINGS_SPOTLIGHT_PANEL_NAME", () => $1c70475fc99a2c16$export$a038bf8f85264e8b);
$parcel$export(module.exports, "WORK_SUGGESTIONS_VIEW_SETTINGS_SPOTLIGHT_VIEW_SETTINGS_STEP_NAME", () => $1c70475fc99a2c16$export$3a12d4773adf4b46);
$parcel$export(module.exports, "GITHUB_ONBOARDING_LOCAL_STORAGE_FINISHED_NAMESPACE", () => $1c70475fc99a2c16$export$a95989662296427);
$parcel$export(module.exports, "GITHUB_ONBOARDING_FINISHED_LOCAL_STORAGE_TTL_IN_MS", () => $1c70475fc99a2c16$export$4a742eb709905e27);
$parcel$export(module.exports, "WORK_SUGGESTIONS_SPOTLIGHT_MESSAGE_ID", () => $1c70475fc99a2c16$export$7d212d7793dfc186);


const $1c70475fc99a2c16$var$TASK_TYPES = {
    PULL_REQUEST_REVIEW: 'PR_REVIEW',
    PULL_REQUEST_NEEDS_WORK: 'PR_NEEDS_WORK',
    FAILED_DEPLOYMENT: 'DEPLOYMENT_FAILED',
    FAILED_BUILD: 'BUILD_FAILED',
    CRIT_VULN: 'CRIT_VULN',
    BLOCKING_ISSUE: 'BLOCKING_ISSUE',
    PR_DRAFT: 'PR_DRAFT',
    PR_STALE: 'PR_STALE',
    PR_MERGEABLE: 'PR_MERGEABLE',
    PR_COMMENTS: 'PR_COMMENTS',
    ISSUE_DUE_SOON: 'ISSUE_DUE_SOON'
};
const $1c70475fc99a2c16$export$3fee72c065a0af0e = {
    WorkSuggestionsBuildTask: 'BUILD_FAILED',
    WorkSuggestionsDeploymentTask: 'DEPLOYMENT_FAILED',
    WorkSuggestionsPullRequestReviewTask: 'PR_REVIEW',
    WorkSuggestionsPullRequestNeedsWorkTask: 'PR_NEEDS_WORK',
    WorkSuggestionsCriticalVulnerabilityTask: 'CRIT_VULN',
    WorkSuggestionsBlockingIssueTask: 'BLOCKING_ISSUE',
    WorkSuggestionsPullRequestDraftTask: 'PR_DRAFT',
    WorkSuggestionsPullRequestInactiveTask: 'PR_STALE',
    WorkSuggestionsPRMergeableTask: 'PR_MERGEABLE',
    WorkSuggestionsPRCommentsTask: 'PR_COMMENTS',
    WorkSuggestionsIssueDueSoonTask: 'ISSUE_DUE_SOON'
};
const $1c70475fc99a2c16$export$206ba94a466bfde8 = {
    REPO: 'repo',
    APPROVALS: 'approvals',
    COMMENT: 'comment',
    ISSUEKEY: 'issuekey',
    ENVIRONMENT: 'environment',
    UPDATED: 'updated',
    SECURITY_CONTAINER_NAME: 'securityContainerName',
    STATUS: 'status',
    TITLE: 'title',
    INTRODUCED_DATE: 'introducedDate'
};
const $1c70475fc99a2c16$export$b8b9d90f9e5bd72b = 'jira.next-best-task';
const $1c70475fc99a2c16$export$9e952e4d801fa8ed = 3;
const $1c70475fc99a2c16$var$NEXT_BEST_TASK_ID = 'nextBestTask';
const $1c70475fc99a2c16$export$55230ca85072e545 = `${(0, $b0e6fec6a4686296$export$d3996f57ffa8448f)}.${$1c70475fc99a2c16$var$NEXT_BEST_TASK_ID}`;
const $1c70475fc99a2c16$var$LOGGING_KEY = 'jira.next-best-task';
const $1c70475fc99a2c16$export$e6c43e0cbc9a213a = $1c70475fc99a2c16$var$LOGGING_KEY;
const $1c70475fc99a2c16$export$e05cfff20e9274e6 = 272;
const $1c70475fc99a2c16$export$8603bff3dda8aaad = $1c70475fc99a2c16$export$e05cfff20e9274e6 + 2;
const $1c70475fc99a2c16$var$panelHeaderHeight = 49;
const $1c70475fc99a2c16$export$c33dba4345ee2db8 = $1c70475fc99a2c16$var$panelHeaderHeight;
const $1c70475fc99a2c16$export$fdd30d204cbe80e6 = 600;
const $1c70475fc99a2c16$export$7147685613ef9998 = '2HtqtVTfYoilHIuYJIGD1T';
const $1c70475fc99a2c16$export$6bc465585d114926 = 'jira-insights-next-best-task';
const $1c70475fc99a2c16$export$5653d49c1e9688e9 = (0, $61a2cd6236d50c20$export$90cac6260ae9ced5);
const $1c70475fc99a2c16$export$43925e5456315f = (0, $61a2cd6236d50c20$export$74a388a09f2a004e);
const $1c70475fc99a2c16$export$ec5e18bceb05348c = 'jira.insights.next-best-task.user-properties';
const $1c70475fc99a2c16$export$a038bf8f85264e8b = 'workSuggestionsViewSettingsSpotlightPanel';
const $1c70475fc99a2c16$export$3a12d4773adf4b46 = 'workSuggestionsViewSettingsSpotlightViewSettings';
const $1c70475fc99a2c16$export$a95989662296427 = 'work-suggestions-github-onboarding-finished';
const $1c70475fc99a2c16$export$4a742eb709905e27 = 259200000; // 3 days
const $1c70475fc99a2c16$export$7d212d7793dfc186 = 'jira-work-suggestions-spotlight';

});
const $61a2cd6236d50c20$export$e18d81f044132a0e = 'branch';
const $61a2cd6236d50c20$export$74a388a09f2a004e = 'build';
const $61a2cd6236d50c20$export$2e42513c7764d5f3 = 'repository';
const $61a2cd6236d50c20$export$3f1e2b276d607490 = 'review';
const $61a2cd6236d50c20$export$90cac6260ae9ced5 = 'deployment-environment';
const $61a2cd6236d50c20$export$6f74b53d652f13f3 = 'pullrequest';
const $61a2cd6236d50c20$export$c69477f358d30f7e = 'feature-flags';
const $61a2cd6236d50c20$export$56470bdd9cd798d0 = 'remote-links';
const $61a2cd6236d50c20$export$b4bb784d069c9ab = 'development.details.details-header';

const $b0e6fec6a4686296$export$d3996f57ffa8448f = 'jira.insights';
const $b0e6fec6a4686296$export$c9290acd1ba498ff = `${$b0e6fec6a4686296$export$d3996f57ffa8448f}.board`;
const $b0e6fec6a4686296$export$2fd6d7f902b01d67 = `${$b0e6fec6a4686296$export$d3996f57ffa8448f}.backlog`;
const $b0e6fec6a4686296$export$8e66b21ec141a0bd = `${$b0e6fec6a4686296$export$d3996f57ffa8448f}.board-simplified`;
const $b0e6fec6a4686296$export$75eb9639a5b0ba25 = `${$b0e6fec6a4686296$export$d3996f57ffa8448f}.backlog-simplified`;
const $b0e6fec6a4686296$export$1269ea4f2b198811 = `${$b0e6fec6a4686296$export$d3996f57ffa8448f}.error-boundary`;


parcelRegister("2DjOQ", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsTogglePulse", () => $1beb4c3f15b5459d$export$1cb4eacfdb188bc8);

var $5uXOq = parcelRequire("5uXOq");

var $k6T4f = parcelRequire("k6T4f");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $1v6HV = parcelRequire("1v6HV");
const $1beb4c3f15b5459d$var$PULSE_DURATION = 7950;
const $1beb4c3f15b5459d$export$1cb4eacfdb188bc8 = ({ children: children, isPanelView: isPanelView })=>{
    const [{ viewSettingsTogglePulses: viewSettingsTogglePulses }, { setViewSettingsTogglePulses: setViewSettingsTogglePulses }] = (0, $1v6HV.useBoardWorkSuggestionsSpotlightContainer)();
    (0, $5uXOq.useEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            setViewSettingsTogglePulses(false);
        }, $1beb4c3f15b5459d$var$PULSE_DURATION);
        return ()=>{
            clearTimeout(timeoutId);
            setViewSettingsTogglePulses(false);
        };
    }, [
        setViewSettingsTogglePulses
    ]);
    if (!viewSettingsTogglePulses) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    return isPanelView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $1beb4c3f15b5459d$var$negativePadding
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k6T4f.Pulse), {
        radius: 5
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $1beb4c3f15b5459d$var$positivePadding
    }, children))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $1beb4c3f15b5459d$var$positivePadding
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k6T4f.Pulse), {
        radius: 5
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $1beb4c3f15b5459d$var$negativePadding
    }, children)));
};
const $1beb4c3f15b5459d$var$negativePadding = (0, $8CUq3.xcss)({
    marginLeft: 'space.negative.050',
    marginRight: 'space.negative.050'
});
const $1beb4c3f15b5459d$var$positivePadding = (0, $8CUq3.xcss)({
    marginLeft: 'space.050',
    marginRight: 'space.050'
});

});


parcelRegister("1ESRw", function(module, exports) {

$parcel$export(module.exports, "IncrementPlanningBoardMenu", () => $6f58092168c61151$export$9a207652c43c8852);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $6tRzQ = parcelRequire("6tRzQ");

var $42CjB = parcelRequire("42CjB");

var $5qRwM = parcelRequire("5qRwM");

var $e4yMr = parcelRequire("e4yMr");

var $kJpBP = parcelRequire("kJpBP");
var $eZUJu = parcelRequire("eZUJu");
var $9UCCQ = parcelRequire("9UCCQ");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $jldZL = parcelRequire("jldZL");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $5Zxxp = parcelRequire("5Zxxp");

var $koVbs = parcelRequire("koVbs");

var $hsmeR = parcelRequire("hsmeR");

var $4jAPy = parcelRequire("4jAPy");

var $bdYfL = parcelRequire("bdYfL");

var $cACY7 = parcelRequire("cACY7");

var $4cYhQ = parcelRequire("4cYhQ");

var $a4XJc = parcelRequire("a4XJc");

var $9pP0g = parcelRequire("9pP0g");

var $kfO2I = parcelRequire("kfO2I");

var $htuq0 = parcelRequire("htuq0");

var $iDGXn = parcelRequire("iDGXn");

var $bkrRB = parcelRequire("bkrRB");
const $6f58092168c61151$var$MAX_OPTIONS_LENGTH = 20;
const $6f58092168c61151$var$InfoIconWithTooltip = ({ tooltipContent: tooltipContent })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $6f58092168c61151$var$infoIconWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6tRzQ))),
        label: tooltipContent,
        appearance: "subtle",
        isTooltipDisabled: false,
        spacing: "compact"
    }));
const $6f58092168c61151$var$MAX_SELECTED_ISSUES = 10;
const $6f58092168c61151$export$9a207652c43c8852 = ({ viewAs: viewAs, boardId: boardId, isSwimlanesEnabled: isSwimlanesEnabled = false, epicCustomName: epicCustomName = 'Epic', disableScrollbar: disableScrollbar = false, onHandleChange: // hide scrollbar for storybook
onHandleChange, onSwimlaneExpandAll: // eslint-disable-next-line @typescript-eslint/no-empty-function
onSwimlaneExpandAll = ()=>{}, onSwimlaneCollapseAll: // eslint-disable-next-line @typescript-eslint/no-empty-function
onSwimlaneCollapseAll = ()=>{}, dependencyIssueOptions: dependencyIssueOptions = {}, onUpdate: // eslint-disable-next-line @typescript-eslint/no-empty-function
onUpdate = ()=>{}, onClose: onClose, analyticsData: analyticsData })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [state, actions] = (0, $iDGXn.useViewSettings)();
    const rightPanelState = (0, $hsmeR.useActiveRightSidebarState)();
    const issueOptions = (0, $5uXOq.useMemo)(()=>Object.values(dependencyIssueOptions).map((issue)=>({
                value: issue.id,
                label: `${issue.key} ${issue.summary}`,
                iconUrl: issue.typeUrl
            })), [
        dependencyIssueOptions
    ]);
    const [slicedOptions, setSlicedOptions] = (0, $5uXOq.useState)(issueOptions.slice(0, $6f58092168c61151$var$MAX_OPTIONS_LENGTH));
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(rightPanelState?.panelId)) onUpdate();
    }, [
        rightPanelState?.panelId,
        onUpdate
    ]);
    const { setShowUnscheduledColumn: setShowUnscheduledColumn, setShowOfftrackDependencyLines: setShowOfftrackDependencyLines, setIssueIdsToShowDependencies: setIssueIdsToShowDependencies, toggleViewSetting: toggleViewSetting } = actions;
    const onFormatOptionLabel = (option, formatOptionLabelMeta)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            space: "space.050",
            alignBlock: "start"
        }, option.iconUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: formatOptionLabelMeta.context === 'menu' ? $6f58092168c61151$var$menuIconStyles : $6f58092168c61151$var$valueIconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
            src: option.iconUrl,
            alt: ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, option.label));
    };
    const selectedIssueOptions = (0, $5uXOq.useMemo)(()=>{
        if (Array.isArray(state.issueIdsToShowDependencies)) {
            const tempDefaultIssueOptions = [];
            state.issueIdsToShowDependencies.forEach((issueId)=>{
                const issue = dependencyIssueOptions[issueId];
                if (issue) tempDefaultIssueOptions.push({
                    value: issue.id,
                    label: `${issue.key} ${issue.summary}`,
                    iconUrl: issue.typeUrl
                });
            });
            return tempDefaultIssueOptions;
        }
        return [];
    }, [
        state.issueIdsToShowDependencies,
        dependencyIssueOptions
    ]);
    const onInputChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
        if (actionMeta.action === 'input-change') {
            if (newValue.trim().length === 0) setSlicedOptions(issueOptions.slice(0, $6f58092168c61151$var$MAX_OPTIONS_LENGTH));
            else {
                const filteredInOptions = issueOptions.filter((o)=>(o?.label || '').toLowerCase().includes(newValue.toLowerCase()));
                setSlicedOptions(filteredInOptions.slice(0, $6f58092168c61151$var$MAX_OPTIONS_LENGTH));
            }
        }
    }, [
        issueOptions,
        setSlicedOptions
    ]);
    const getViewSettingsValidationMessage = ()=>{
        if (state.issueIdsToShowDependencies.length > $6f58092168c61151$var$MAX_SELECTED_ISSUES) return formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cACY7.default).maxDependenciesErrorIssueTermRefresh : (0, $cACY7.default).maxDependenciesError, {
            maxDeps: $6f58092168c61151$var$MAX_SELECTED_ISSUES
        });
        return undefined;
    };
    const getMenuGroupMaxHeight = (0, $5uXOq.useMemo)(()=>{
        return disableScrollbar ? {} : {
            maxHeight: 600
        };
    }, [
        disableScrollbar
    ]);
    const fields = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: "software-view-settings.ui.view-settings-menu.views.increment-planning-board.show-type-toggle",
        title: formatMessage((0, $cACY7.default).cardDetailIssueType),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_ISSUE_TYPE
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ISSUE_TYPE,
                state: !state.showIssueType
            });
        },
        isChecked: state.showIssueType,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: "software-view-settings.ui.view-settings-menu.views.increment-planning-board.show-issue-key-toggle",
        title: formatMessage((0, $cACY7.default).cardDetailIssueKey),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_ISSUE_KEY
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ISSUE_KEY,
                state: !state.showIssueKey
            }, (0, $4cYhQ.Action).CLICKED);
        },
        isChecked: state.showIssueKey,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: "software-view-settings.ui.view-settings-menu.views.increment-planning-board.show-epics-toggle",
        title: epicCustomName,
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_EPICS
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_EPICS_TOGGLE,
                state: !state.showEpics
            }, (0, $4cYhQ.Action).CLICKED);
        },
        isChecked: state.showEpics,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: "software-view-settings.ui.view-settings-menu.views.increment-planning-board.show-estimate-toggle",
        title: formatMessage((0, $cACY7.default).cardDetailEstimate),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_ESTIMATE
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ESTIMATE,
                state: !state.showEstimate
            }, (0, $4cYhQ.Action).CLICKED);
        },
        isChecked: state.showEstimate,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: "software-view-settings.ui.view-settings-menu.views.increment-planning-board.show-assignee-toggle",
        title: formatMessage((0, $cACY7.default).cardDetailAssignee),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_ASSIGNEE
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ASSIGNEE,
                state: !state.showAssignee
            }, (0, $4cYhQ.Action).CLICKED);
        },
        isChecked: state.showAssignee,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: "software-view-settings.ui.view-settings-menu.views.increment-planning-board.show-status-toggle",
        title: formatMessage((0, $cACY7.default).cardDetailStatus),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_STATUSES
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_STATUSES_TOGGLE,
                state: !state.showStatuses
            }, (0, $4cYhQ.Action).CLICKED);
        },
        isChecked: state.showStatuses,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: "software-view-settings.ui.view-settings-menu.views.increment-planning-board.show-priority-toggle",
        title: formatMessage((0, $cACY7.default).cardDetailPriority),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_PRIORITY
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_PRIORITY,
                state: !state.showPriority
            }, (0, $4cYhQ.Action).CLICKED);
        },
        isChecked: state.showPriority,
        viewAs: viewAs
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), {
        "data-testId": "software-view-settings.ui.view-settings-menu.menu-increment-planning-board",
        ...getMenuGroupMaxHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: "software-view-settings.ui.view-settings-menu.views.increment-planning-board.show-unscheduled-column-toggle",
        title: formatMessage((0, $cACY7.default).showUnscheduledWork),
        onChange: ()=>{
            setShowUnscheduledColumn(boardId, !state.showUnscheduledColumn);
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.IncrementPlanningAnalyticsKey).UNSCHEDULED_COLUMN_TOGGLE,
                state: !state.showUnscheduledColumn
            }, (0, $4cYhQ.Action).CLICKED);
        },
        isChecked: state.showUnscheduledColumn,
        viewAs: viewAs
    })), isSwimlanesEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        title: formatMessage((0, $cACY7.default).swimlanes),
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        "data-testid": "software-view-settings.ui.view-settings-menu.views.increment-planning-board.expand-all",
        onClick: ()=>{
            onSwimlaneExpandAll();
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).SWIMLANE_EXPAND_ALL,
                state: (0, $a4XJc.ExpandableState).EXPANDED
            }, (0, $4cYhQ.Action).CLICKED);
        }
    }, formatMessage((0, $cACY7.default).expandAll)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        "data-testid": "software-view-settings.ui.view-settings-menu.views.increment-planning-board.collapse-all",
        onClick: ()=>{
            onSwimlaneCollapseAll();
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).SWIMLANE_COLLAPSE_ALL,
                state: (0, $a4XJc.ExpandableState).COLLAPSED
            }, (0, $4cYhQ.Action).CLICKED);
        }
    }, formatMessage((0, $cACY7.default).collapseAll))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        title: formatMessage((0, $bkrRB.default).dependencyLinesSection),
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: "software-view-settings.ui.view-settings-menu.views.increment-planning-board.offtrack-dependencies-toggle",
        title: formatMessage((0, $bkrRB.default).showOfftrackDependencyLines),
        onChange: ()=>{
            setShowOfftrackDependencyLines(boardId, !state.showOfftrackDependencyLines);
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.IncrementPlanningAnalyticsKey).SHOW_OFFTRACK_DEPENDENCY_LINES,
                state: !state.showOfftrackDependencyLines
            }, (0, $4cYhQ.Action).CLICKED);
        },
        isChecked: state.showOfftrackDependencyLines,
        viewAs: viewAs,
        footer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Zxxp.default), {
            articleId: (0, $4jAPy.IPH_IDS).OFFTRACK_DEPENDENCIES,
            appearance: "link",
            spacing: "none",
            fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
                href: (0, $4jAPy.DOC_LINKS).OFFTRACK_DEPENDENCIES,
                target: "_blank"
            }, formatMessage((0, $bkrRB.default).offtrackDependenciesHelpLink)),
            onClick: (event)=>{
                event.stopPropagation();
                onClose && onClose(event);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            color: "color.text.accent.blue"
        }, formatMessage((0, $bkrRB.default).offtrackDependenciesHelpLink)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $6f58092168c61151$var$selectWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kfO2I.ViewSettingsSelect), {
        title: formatMessage((0, $bkrRB.default).showDependenciesOnIssues),
        titleIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6f58092168c61151$var$InfoIconWithTooltip, {
            tooltipContent: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $bkrRB.default).onlyShowScheduledIssueDependencyLinesTooltipIssueTermRefresh : (0, $bkrRB.default).onlyShowScheduledIssueDependencyLinesTooltip)
        }),
        testId: "software-view-settings.ui.view-settings-menu.views.increment-planning-board.dependency-lines-select",
        isMulti: true,
        isSearchable: true,
        options: slicedOptions,
        formatOptionLabel: onFormatOptionLabel,
        viewAs: viewAs,
        value: selectedIssueOptions,
        placeholder: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $bkrRB.default).chooseIssueIssueTermRefresh : (0, $bkrRB.default).chooseIssue),
        isInvalid: state.issueIdsToShowDependencies.length > $6f58092168c61151$var$MAX_SELECTED_ISSUES,
        validationErrorMessage: getViewSettingsValidationMessage(),
        menuIsOpen: // undefined is default value for menuIsOpen prop where it's controlled by the click. Setting it to false will prevent the menu from opening
        state.issueIdsToShowDependencies.length <= $6f58092168c61151$var$MAX_SELECTED_ISSUES ? undefined : false,
        menuPlacement: "auto" // menuPlacement is to ensure the dropdown is repositioned based on the window height
        ,
        onInputChange: onInputChange,
        onChange: (selectedOptions, actionMeta)=>{
            let selectedIssueIds = [];
            if (Array.isArray(selectedOptions)) selectedIssueIds = selectedOptions.map((option)=>option.value);
            else if (selectedOptions && 'value' in selectedOptions) selectedIssueIds = selectedOptions ? [
                selectedOptions.value
            ] : [];
            setIssueIdsToShowDependencies(boardId, selectedIssueIds);
            const id = actionMeta.action === 'select-option' ? actionMeta?.option?.value : actionMeta.removedValue?.value;
            const issue = analyticsData?.issuesWithLinksById[id ?? ''];
            const issueLinks = issue?.issueLinks;
            const attributes = (0, $bdYfL.getIssueLinksAnalytics)(issueLinks, id, analyticsData?.issueLinkTypes, analyticsData?.issuesWithLinksById, analyticsData?.issueTypes);
            onHandleChange((0, $4cYhQ.ActionSubject).SELECT, {
                key: (0, $4cYhQ.IncrementPlanningAnalyticsKey).ISSUE_IDS_TO_SHOW_DEPENDENCIES,
                NumberOfCardDependencies: issue?.issueLinks?.length || 0,
                ToggledOn: actionMeta.action === 'select-option',
                isScenarioIssue: (0, $bdYfL.isScenarioIssue)(id),
                ...attributes
            }, (0, $4cYhQ.Action).CHANGED);
        }
    }))), (0, $4R6GH.fg)('issue_cards_in_program_board') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        title: formatMessage((0, $cACY7.default).cardFields),
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("fieldset", {
        "data-testid": "software-view-settings.ui.view-settings-menu.views.increment-planning-board.fieldset"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("legend", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jldZL.default), null, formatMessage((0, $cACY7.default).cardFields))), fields)));
};
const $6f58092168c61151$var$menuIconStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.025',
    width: '16px',
    minWidth: '16px',
    height: '16px',
    minHeight: '16px'
});
const $6f58092168c61151$var$valueIconStyles = (0, $8CUq3.xcss)({
    width: '16px',
    minWidth: '16px',
    height: '16px',
    minHeight: '16px'
});
const $6f58092168c61151$var$selectWrapper = (0, $8CUq3.xcss)({
    width: '450px'
});
const $6f58092168c61151$var$infoIconWrapperStyles = (0, $8CUq3.xcss)({
    height: '24px',
    display: 'flex',
    alignItems: 'center'
});

});
parcelRegister("4jAPy", function(module, exports) {

$parcel$export(module.exports, "SCRUM_TEAM", () => $acaa4e836b6925cd$export$103a728db4a941f8);
$parcel$export(module.exports, "KANBAN_TEAM", () => $acaa4e836b6925cd$export$f43662b315e78f32);
$parcel$export(module.exports, "BOARD_ISSUE_SOURCE", () => $acaa4e836b6925cd$export$4c4602fa98384024);
$parcel$export(module.exports, "SINGLE_CUSTOM_FIELD_TYPE_KEY", () => $acaa4e836b6925cd$export$7a7b05cceb7cc8a9);
$parcel$export(module.exports, "MULTI_CUSTOM_FIELD_TYPE_KEY", () => $acaa4e836b6925cd$export$2afd90c3608e7105);
$parcel$export(module.exports, "SYSTEM_LABEL_FIELD_ID", () => $acaa4e836b6925cd$export$84bf4e4e31fe4475);
$parcel$export(module.exports, "CUSTOM_FIELD_OPTION_MISSED_ERROR", () => $acaa4e836b6925cd$export$aa4bdec93afa2924);
$parcel$export(module.exports, "FILTER_FIELD_ERROR", () => $acaa4e836b6925cd$export$a497a01fd14a64af);
$parcel$export(module.exports, "MAX_ACTIVE_BOARDS_OLD", () => $acaa4e836b6925cd$export$d9f307ebf9c533d2);
$parcel$export(module.exports, "MAX_ACTIVE_BOARDS", () => $acaa4e836b6925cd$export$70493a18b15fa2cc);
$parcel$export(module.exports, "IP_BOARD_STORY_POINTS_PLANNING_UNIT", () => $acaa4e836b6925cd$export$e2ffaae341a16c5e);
$parcel$export(module.exports, "IP_BOARD_HOURS_PLANNING_UNIT", () => $acaa4e836b6925cd$export$9a6e823d5b9e62be);
$parcel$export(module.exports, "IP_BOARD_DAYS_PLANNING_UNIT", () => $acaa4e836b6925cd$export$ad92792f1d38ffba);
$parcel$export(module.exports, "ERROR_REPORTING_TEAM", () => $acaa4e836b6925cd$export$cfeee2ee86ead336);
$parcel$export(module.exports, "PACKAGE_NAME", () => $acaa4e836b6925cd$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "SERVICES_ERROR_ID", () => $acaa4e836b6925cd$export$7930b6315c134d49);
$parcel$export(module.exports, "DOC_LINKS", () => $acaa4e836b6925cd$export$f8975d2c25cd8c82);
$parcel$export(module.exports, "IPH_IDS", () => $acaa4e836b6925cd$export$253194752488840a);
$parcel$export(module.exports, "MARK_SYNC_SPRINTS_PREFIX", () => $acaa4e836b6925cd$export$c78721cd39b97424);
$parcel$export(module.exports, "MARK_SYNC_SPRINTS_START", () => $acaa4e836b6925cd$export$1bb2633f6c6f66d1);
$parcel$export(module.exports, "MARK_SYNC_SPRINTS_END", () => $acaa4e836b6925cd$export$9583c6ba8c6caee3);
$parcel$export(module.exports, "BOARD_SCOPE_FILTER_NONE", () => $acaa4e836b6925cd$export$f2ee1113933b4540);
$parcel$export(module.exports, "BOARD_SCOPE_FILTER_LABEL", () => $acaa4e836b6925cd$export$3212503575d06ffd);
$parcel$export(module.exports, "BOARD_SCOPE_FILTER_SINGLE_SELECT", () => $acaa4e836b6925cd$export$ba991b7dc2732ca3);
$parcel$export(module.exports, "BOARD_SCOPE_FILTER_MULTI_SELECT", () => $acaa4e836b6925cd$export$df2129225b939441);
$parcel$export(module.exports, "DEFAULT_ITERATION_LENGTH", () => $acaa4e836b6925cd$export$8400d4ac050fc755);
$parcel$export(module.exports, "DEFAULT_ITERATIONS_COUNT", () => $acaa4e836b6925cd$export$b83f977709573647);
$parcel$export(module.exports, "ITERATIONS_COUNT_OPTIONS", () => $acaa4e836b6925cd$export$f16a2b8db5d397c);
$parcel$export(module.exports, "TEAM", () => $acaa4e836b6925cd$export$bc8b984358922f81);
$parcel$export(module.exports, "SWIMLANE_TEAMLESS", () => $acaa4e836b6925cd$export$b5d1b5cc4a0cc53c);
$parcel$export(module.exports, "MAX_SELECTED_ISSUES_FOR_DEPENDENCY_LINES", () => $acaa4e836b6925cd$export$ca464ff38a49aee8);
$parcel$export(module.exports, "UNSCHEDULED_WORK_COLUMN_SWIMLANE_ID_SUFFIX", () => $acaa4e836b6925cd$export$184668482d48a5f3);
$parcel$export(module.exports, "SCENARIO_ISSUE_ID_PREFIX", () => $acaa4e836b6925cd$export$c8c7cce628cf5c4e);
$parcel$export(module.exports, "PLANS_USER_AUTOCOMPLETE_URL", () => $acaa4e836b6925cd$export$95c182fe3d93ab19);
const $acaa4e836b6925cd$export$103a728db4a941f8 = 'Scrum';
const $acaa4e836b6925cd$export$f43662b315e78f32 = 'Kanban';
const $acaa4e836b6925cd$export$4c4602fa98384024 = 'Board';
const $acaa4e836b6925cd$export$ab08f53e1080ee4f = 'Project';
const $acaa4e836b6925cd$export$e5b9ed989e245a1a = 'Filter';
const $acaa4e836b6925cd$export$7a7b05cceb7cc8a9 = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
const $acaa4e836b6925cd$export$2afd90c3608e7105 = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
const $acaa4e836b6925cd$export$84bf4e4e31fe4475 = 'labels';
const $acaa4e836b6925cd$export$aa4bdec93afa2924 = 'CUSTOM_FIELD_OPTION_MISSED';
const $acaa4e836b6925cd$export$a497a01fd14a64af = {
    NOT_FOUND: 'CUSTOM_FIELD_NOT_FOUND',
    TRASHED: 'CUSTOM_FIELD_TRASHED',
    NOT_IN_PLAN: 'CUSTOM_FIELD_NOT_IN_PLAN',
    OPTION_NOT_FOUND: 'CUSTOM_FIELD_OPTION_NOT_FOUND'
};
const $acaa4e836b6925cd$export$d9f307ebf9c533d2 = 2; // remove when jpo_adjust_program_board_active_limit is cleaned up
const $acaa4e836b6925cd$export$70493a18b15fa2cc = 10;
const $acaa4e836b6925cd$export$e2ffaae341a16c5e = 'StoryPoints';
const $acaa4e836b6925cd$export$9a6e823d5b9e62be = 'Hours';
const $acaa4e836b6925cd$export$ad92792f1d38ffba = 'Days';
const $acaa4e836b6925cd$export$cfeee2ee86ead336 = 'axolotl';
const $acaa4e836b6925cd$export$b8b9d90f9e5bd72b = 'jiraPortfolio3PlanIncrementCommon';
const $acaa4e836b6925cd$export$7930b6315c134d49 = 'services';
const $acaa4e836b6925cd$export$f8975d2c25cd8c82 = {
    PROGRAM_BOARD: 'https://support.atlassian.com/jira-software-cloud/docs/what-is-the-program-board-in-my-plan/',
    LINK_SPRINTS: 'https://support.atlassian.com/jira-software-cloud/docs/add-and-change-sprints-on-the-program-board-in-your-plan/',
    CREATION: 'https://support.atlassian.com/jira-software-cloud/docs/what-does-the-program-board-show/',
    CAPACITY_PLANNING: 'https://support.atlassian.com/jira-software-cloud/docs/enable-capacity-planning-in-advanced-roadmaps/',
    OFFTRACK_DEPENDENCIES: 'https://support.atlassian.com/jira-software-cloud/docs/what-are-dependencies-in-advanced-roadmaps/',
    PROGRAM_BOARD_RECOMMENDATIONS: 'https://support.atlassian.com/jira-software-cloud/docs/recommended-preparations-before-using-the-program-board/'
};
const $acaa4e836b6925cd$export$253194752488840a = {
    PROGRAM_BOARDS_CREATE: '6gJCMknYvLjnUgKrm4BKIj',
    PROGRAM_BOARDS_SETTINGS: '1pdnvDJUBHtLdAcH6F03rm',
    CAPACITY_PLANNING: '4kDm3TUQ7LwIEubH72m3Gk',
    OFFTRACK_DEPENDENCIES: '2HQv4dgTi14DCpGY1YU2ZF',
    PROGRAM_BOARD_RECOMMENDATIONS: '7CJiNQmImx2kqJa9MhpEwt'
};
const $acaa4e836b6925cd$export$c78721cd39b97424 = 'plan-increment.sync-sprints:';
const $acaa4e836b6925cd$export$1bb2633f6c6f66d1 = `${$acaa4e836b6925cd$export$c78721cd39b97424}start`;
const $acaa4e836b6925cd$export$9583c6ba8c6caee3 = `${$acaa4e836b6925cd$export$c78721cd39b97424}end`;
const $acaa4e836b6925cd$export$f2ee1113933b4540 = 'none';
const $acaa4e836b6925cd$export$3212503575d06ffd = 'label';
const $acaa4e836b6925cd$export$ba991b7dc2732ca3 = 'select';
const $acaa4e836b6925cd$export$df2129225b939441 = 'multiselect';
const $acaa4e836b6925cd$export$8400d4ac050fc755 = 2;
const $acaa4e836b6925cd$export$b83f977709573647 = 6;
const $acaa4e836b6925cd$export$f16a2b8db5d397c = [
    {
        label: '3',
        value: 3
    },
    {
        label: '4',
        value: 4
    },
    {
        label: '5',
        value: 5
    },
    {
        label: '6',
        value: 6
    },
    {
        label: '7',
        value: 7
    },
    {
        label: '8',
        value: 8
    },
    {
        label: '9',
        value: 9
    },
    {
        label: '10',
        value: 10
    },
    {
        label: '11',
        value: 11
    },
    {
        label: '12',
        value: 12
    },
    {
        label: '13',
        value: 13
    }
];
const $acaa4e836b6925cd$export$bc8b984358922f81 = 'TEAM';
const $acaa4e836b6925cd$export$b5d1b5cc4a0cc53c = '$teamless$';
const $acaa4e836b6925cd$export$ca464ff38a49aee8 = 10;
const $acaa4e836b6925cd$export$184668482d48a5f3 = '-unscheduled';
const $acaa4e836b6925cd$export$c8c7cce628cf5c4e = 'SCEN-';
const $acaa4e836b6925cd$export$95c182fe3d93ab19 = '/rest/teams/1.0/persons/find';

});

parcelRegister("bdYfL", function(module, exports) {

$parcel$export(module.exports, "getBoardScopeFilterType", () => $f1501fc223d29b95$export$27ef735461d030e);
$parcel$export(module.exports, "getPlanId", () => $f1501fc223d29b95$export$203ed8b65c3b2a28);
$parcel$export(module.exports, "urls", () => $f1501fc223d29b95$export$bcae9ba627f604b6);
$parcel$export(module.exports, "getBoardUrl", () => $f1501fc223d29b95$export$505a9f131607d070);
$parcel$export(module.exports, "getManageBoardSettingsUrl", () => $f1501fc223d29b95$export$ba13e822080a5be4);
$parcel$export(module.exports, "convertCapacity", () => $f1501fc223d29b95$export$48e790d731821dac);
$parcel$export(module.exports, "getCapacityUnitMessage", () => $f1501fc223d29b95$export$fb95ed64ed4e0e59);
$parcel$export(module.exports, "getSprintStateLabel", () => $f1501fc223d29b95$export$6f891d146561f05a);
$parcel$export(module.exports, "convertCapacityFromPlanningUnitToSeconds", () => $f1501fc223d29b95$export$acbcfbe3e761e0b4);
$parcel$export(module.exports, "isScenarioPlanonlyTeamCheck", () => $f1501fc223d29b95$export$458ffa13814d195c);
$parcel$export(module.exports, "isScenarioIssue", () => $f1501fc223d29b95$export$44ef32448ae567e6);
$parcel$export(module.exports, "getIssueLinksAnalytics", () => $f1501fc223d29b95$export$b7de722f7c014dc8);
$parcel$export(module.exports, "truncateUnscheduledWorkSwimlaneId", () => $f1501fc223d29b95$export$728fdc4d4544b775);
$parcel$export(module.exports, "appendUnscheduledWorkSwimlaneIdSuffix", () => $f1501fc223d29b95$export$1ca85b4c3d462fa1);

var $6icp6 = parcelRequire("6icp6");

var $hGgHi = parcelRequire("hGgHi");

var $4R6GH = parcelRequire("4R6GH");

var $3spCR = parcelRequire("3spCR");

var $gBj4V = parcelRequire("gBj4V");

var $4jAPy = parcelRequire("4jAPy");

var $gZK1Z = parcelRequire("gZK1Z");
const $f1501fc223d29b95$export$27ef735461d030e = (boardScopeFilter)=>{
    if (boardScopeFilter === undefined) return 0, $4jAPy.BOARD_SCOPE_FILTER_NONE;
    if (boardScopeFilter.filterFieldId === (0, $4jAPy.SYSTEM_LABEL_FIELD_ID)) return 0, $4jAPy.BOARD_SCOPE_FILTER_LABEL;
    if (boardScopeFilter.filterFieldTypeKey === (0, $4jAPy.SINGLE_CUSTOM_FIELD_TYPE_KEY)) return 0, $4jAPy.BOARD_SCOPE_FILTER_SINGLE_SELECT;
    if (boardScopeFilter.filterFieldTypeKey === (0, $4jAPy.MULTI_CUSTOM_FIELD_TYPE_KEY)) return 0, $4jAPy.BOARD_SCOPE_FILTER_MULTI_SELECT;
    return 0, $4jAPy.BOARD_SCOPE_FILTER_NONE;
};
const $f1501fc223d29b95$var$PLAN_PARAMS = {
    PLAN: 'plans',
    SCENARIO: 'scenarios',
    BOARD: 'program',
    ROADMAP: 'backlog'
};
const $f1501fc223d29b95$var$parsePathParams = (path, param)=>{
    const regex = new RegExp(`/${param}/(\\w+)`, 'g');
    const matches = Array.from(path.matchAll(regex), (match)=>match[1]);
    return matches[0];
};
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $f1501fc223d29b95$var$getPathParams = (param)=>$f1501fc223d29b95$var$parsePathParams(window.location.pathname, param);
const $f1501fc223d29b95$export$203ed8b65c3b2a28 = ()=>+$f1501fc223d29b95$var$getPathParams($f1501fc223d29b95$var$PLAN_PARAMS.PLAN) || undefined;
const $f1501fc223d29b95$export$8572797243a693b9 = ()=>+$f1501fc223d29b95$var$getPathParams($f1501fc223d29b95$var$PLAN_PARAMS.SCENARIO) || undefined;
const $f1501fc223d29b95$export$bcae9ba627f604b6 = {
    managePortfolio: '/jira/plans/'
};
const $f1501fc223d29b95$export$505a9f131607d070 = (boardId, isEmbed = false)=>`/jira/${$f1501fc223d29b95$var$PLAN_PARAMS.PLAN}/${$f1501fc223d29b95$export$203ed8b65c3b2a28()}/${$f1501fc223d29b95$var$PLAN_PARAMS.SCENARIO}/${$f1501fc223d29b95$export$8572797243a693b9()}/${$f1501fc223d29b95$var$PLAN_PARAMS.BOARD}/${boardId}${isEmbed && (0, $4R6GH.fg)('smart_links_for_plans') ? '/embed' : ''}`;
const $f1501fc223d29b95$export$ba13e822080a5be4 = (planId, scenarioId)=>`/jira/plans/${planId}/scenarios/${scenarioId}/settings/program-boards`;
const $f1501fc223d29b95$export$48e790d731821dac = (capacity, planningUnit, workingHoursPerDay)=>{
    if (planningUnit === (0, $4jAPy.IP_BOARD_DAYS_PLANNING_UNIT)) return (0, (/*@__PURE__*/$parcel$interopDefault($6icp6)))(capacity / workingHoursPerDay / (0, $gBj4V.SECONDS_PER_HOUR), 2);
    if (planningUnit === (0, $4jAPy.IP_BOARD_HOURS_PLANNING_UNIT)) return (0, (/*@__PURE__*/$parcel$interopDefault($6icp6)))(capacity / (0, $gBj4V.SECONDS_PER_HOUR), 2);
    return capacity;
};
const $f1501fc223d29b95$export$fb95ed64ed4e0e59 = (planningUnit, formatMessage, originalCapacity)=>{
    // if the originalCapacity is undefined, assign the capacity to 2 to get the plural unit
    const capacity = (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(originalCapacity) ? 2 : originalCapacity;
    switch(planningUnit){
        case 0, $4jAPy.IP_BOARD_DAYS_PLANNING_UNIT:
            return formatMessage((0, $gZK1Z.default).dayUnit, {
                days: capacity
            });
        case 0, $4jAPy.IP_BOARD_HOURS_PLANNING_UNIT:
            return formatMessage((0, $gZK1Z.default).hourUnit, {
                hours: capacity
            });
        default:
            return formatMessage((0, $gZK1Z.default).storyPointUnit, {
                points: capacity
            });
    }
};
const $f1501fc223d29b95$export$6f891d146561f05a = (sprintState, formatMessage)=>{
    switch(sprintState){
        case (0, $3spCR.SPRINT_STATES).ACTIVE:
            return formatMessage((0, $gZK1Z.default).activeSprint);
        case (0, $3spCR.SPRINT_STATES).CLOSED:
            return formatMessage((0, $gZK1Z.default).closedSprint);
        case (0, $3spCR.SPRINT_STATES).FUTURE:
        default:
            return formatMessage((0, $gZK1Z.default).futureSprint);
    }
};
const $f1501fc223d29b95$export$acbcfbe3e761e0b4 = ({ capacity: capacity, planningUnit: planningUnit, workingHours: workingHours })=>{
    switch(planningUnit){
        case 0, $4jAPy.IP_BOARD_DAYS_PLANNING_UNIT:
            return capacity * (0, $gBj4V.SECONDS_PER_HOUR) * workingHours;
        case 0, $4jAPy.IP_BOARD_HOURS_PLANNING_UNIT:
            return capacity * (0, $gBj4V.SECONDS_PER_HOUR);
        default:
            return capacity;
    }
};
const $f1501fc223d29b95$export$458ffa13814d195c = (teamId)=>Number.isNaN(parseInt(teamId, 10));
const $f1501fc223d29b95$export$44ef32448ae567e6 = (issueId)=>!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issueId) && String(issueId).startsWith((0, $4jAPy.SCENARIO_ISSUE_ID_PREFIX));
const $f1501fc223d29b95$export$b7de722f7c014dc8 = (issueLinks, id, issueLinkTypes, issuesWithLinksById, issueTypes)=>{
    if (!issueLinks || !id || !issueLinkTypes || !issuesWithLinksById || !issueTypes) return {};
    const attributes = issueLinks.reduce((acc, link)=>{
        const linkType = issueLinkTypes.find((l)=>l.id === link.linkTypeId);
        const isSource = link.sourceId === id;
        const linkedIssueId = isSource ? link.destinationId : link.sourceId;
        const issueTypeId = issuesWithLinksById[linkedIssueId]?.typeId;
        const isBaseLevel = issueTypes[issueTypeId]?.hierarchyLevelType === 'BASE';
        if (isSource) {
            if (linkType?.isOutward) isBaseLevel ? acc.BlockingStoriesCount++ : acc.BlockingEpicsCount++;
            else isBaseLevel ? acc.BlockedByStoriesCount++ : acc.BlockedByEpicsCount++;
        } else if (linkType?.isOutward) isBaseLevel ? acc.BlockedByStoriesCount++ : acc.BlockedByEpicsCount++;
        else isBaseLevel ? acc.BlockingStoriesCount++ : acc.BlockingEpicsCount++;
        return acc;
    }, {
        BlockedByStoriesCount: 0,
        BlockedByEpicsCount: 0,
        BlockingStoriesCount: 0,
        BlockingEpicsCount: 0
    });
    return attributes;
};
const $f1501fc223d29b95$export$728fdc4d4544b775 = (swimlaneId, isUnscheduledColumn)=>isUnscheduledColumn && swimlaneId.endsWith((0, $4jAPy.UNSCHEDULED_WORK_COLUMN_SWIMLANE_ID_SUFFIX)) ? swimlaneId.slice(0, -(0, $4jAPy.UNSCHEDULED_WORK_COLUMN_SWIMLANE_ID_SUFFIX).length) : swimlaneId;
const $f1501fc223d29b95$export$1ca85b4c3d462fa1 = (swimlaneId)=>`${swimlaneId}${0, $4jAPy.UNSCHEDULED_WORK_COLUMN_SWIMLANE_ID_SUFFIX}`;

});
parcelRegister("6icp6", function(module, exports) {

var $aza9E = parcelRequire("aza9E");
/**
 * Computes `number` rounded down to `precision`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Math
 * @param {number} number The number to round down.
 * @param {number} [precision=0] The precision to round down to.
 * @returns {number} Returns the rounded down number.
 * @example
 *
 * _.floor(4.006);
 * // => 4
 *
 * _.floor(0.046, 2);
 * // => 0.04
 *
 * _.floor(4060, -2);
 * // => 4000
 */ var $494e0ba682121fe5$var$floor = $aza9E('floor');
module.exports = $494e0ba682121fe5$var$floor;

});
parcelRegister("aza9E", function(module, exports) {

var $1V15E = parcelRequire("1V15E");

var $kPZpS = parcelRequire("kPZpS");

var $1sXeC = parcelRequire("1sXeC");

var $jJVtR = parcelRequire("jJVtR");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7b150cc928607d87$var$nativeIsFinite = $1V15E.isFinite, $7b150cc928607d87$var$nativeMin = Math.min;
/**
 * Creates a function like `_.round`.
 *
 * @private
 * @param {string} methodName The name of the `Math` method to use when rounding.
 * @returns {Function} Returns the new round function.
 */ function $7b150cc928607d87$var$createRound(methodName) {
    var func = Math[methodName];
    return function(number, precision) {
        number = $1sXeC(number);
        precision = precision == null ? 0 : $7b150cc928607d87$var$nativeMin($kPZpS(precision), 292);
        if (precision && $7b150cc928607d87$var$nativeIsFinite(number)) {
            // Shift with exponential notation to avoid floating-point issues.
            // See [MDN](https://mdn.io/round#Examples) for more details.
            var pair = ($jJVtR(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
            pair = ($jJVtR(value) + 'e').split('e');
            return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
    };
}
module.exports = $7b150cc928607d87$var$createRound;

});


parcelRegister("3spCR", function(module, exports) {

$parcel$export(module.exports, "ACTIVE_SPRINT_STATE", () => $113c1ed08a0bda4f$export$3ebc9911a79d714f);
$parcel$export(module.exports, "FUTURE_SPRINT_STATE", () => $113c1ed08a0bda4f$export$863e42082c6bde5);
$parcel$export(module.exports, "CLOSED_SPRINT_STATE", () => $113c1ed08a0bda4f$export$86cdef09a89e8c4b);
$parcel$export(module.exports, "SPRINT_STATES", () => $113c1ed08a0bda4f$export$73a0206a4dc59760);
const $113c1ed08a0bda4f$export$3ebc9911a79d714f = 'ACTIVE';
const $113c1ed08a0bda4f$export$863e42082c6bde5 = 'FUTURE';
const $113c1ed08a0bda4f$export$86cdef09a89e8c4b = 'CLOSED';
const $113c1ed08a0bda4f$export$73a0206a4dc59760 = {
    ACTIVE: $113c1ed08a0bda4f$export$3ebc9911a79d714f,
    CLOSED: $113c1ed08a0bda4f$export$86cdef09a89e8c4b,
    FUTURE: $113c1ed08a0bda4f$export$863e42082c6bde5
};

});

parcelRegister("gZK1Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fb4520eab764533$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9fb4520eab764533$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    backToBoards: {
        "id": "portfolio-3-plan-increment-common.common.back-to-boards",
        "defaultMessage": "Choose another board"
    },
    dayUnit: {
        "id": "portfolio-3-plan-increment-common.common.day-unit",
        "defaultMessage": "{days, plural, one {day} other {days}}"
    },
    hourUnit: {
        "id": "portfolio-3-plan-increment-common.common.hour-unit",
        "defaultMessage": "{hours, plural, one {hour} other {hours}}"
    },
    storyPointUnit: {
        "id": "portfolio-3-plan-increment-common.common.story-point-unit",
        "defaultMessage": "{points, plural, one {point} other {points}}"
    },
    activeSprint: {
        "id": "portfolio-3-plan-increment-common.common.active-sprint",
        "defaultMessage": "ACTIVE"
    },
    closedSprint: {
        "id": "portfolio-3-plan-increment-common.common.closed-sprint",
        "defaultMessage": "COMPLETED"
    },
    futureSprint: {
        "id": "portfolio-3-plan-increment-common.common.future-sprint",
        "defaultMessage": "FUTURE"
    },
    apiErrorFlagTitle: {
        "id": "portfolio-3-plan-increment-common.common.api-error-flag-title",
        "defaultMessage": "Something went wrong."
    },
    apiErrorFlagDescription: {
        "id": "portfolio-3-plan-increment-common.common.api-error-flag-description",
        "defaultMessage": "Refresh the page and try that again. "
    },
    editCapacityLabel: {
        "id": "portfolio-3-plan-increment-common.common.edit-capacity-label",
        "defaultMessage": "Edit capacity"
    },
    confirmButtonLabel: {
        "id": "portfolio-3-plan-increment-common.common.confirm-button-label",
        "defaultMessage": "Confirm"
    },
    cancelButtonLabel: {
        "id": "portfolio-3-plan-increment-common.common.cancel-button-label",
        "defaultMessage": "Cancel"
    }
});

});


parcelRegister("kfO2I", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsSelect", () => $3769930931d22483$export$88e7b5a47d581b96);

var $5uXOq = parcelRequire("5uXOq");

var $3T6Xo = parcelRequire("3T6Xo");

var $qfj8c = parcelRequire("qfj8c");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $7K5PP = parcelRequire("7K5PP");

var $gwIPs = parcelRequire("gwIPs");

var $a4XJc = parcelRequire("a4XJc");

var $cYeCp = parcelRequire("cYeCp");
const $3769930931d22483$export$88e7b5a47d581b96 = ({ title: title, testId: testId, viewAs: viewAs = (0, $a4XJc.ViewAs).POPUP, validationErrorMessage: validationErrorMessage, titleIcon: titleIcon, ...restProps })=>{
    const id = (0, (/*@__PURE__*/$parcel$interopDefault($3T6Xo)))(`jira-software-view-settings-${title}`);
    const errorId = (0, (/*@__PURE__*/$parcel$interopDefault($3T6Xo)))(`jira-software-view-settings-${title}-error`);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: viewAs === (0, $a4XJc.ViewAs).PANEL && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() ? $3769930931d22483$var$panelContainerStyles : $3769930931d22483$var$popupContainerStyles,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $3769930931d22483$var$labelWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("label", {
        htmlFor: id
    }, title), titleIcon)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        inputId: id,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        menuPortalTarget: document.body,
        styles: {
            menuPortal: (base)=>({
                    ...base,
                    zIndex: (0, $gwIPs.layers).layer
                })
        },
        "aria-invalid": !!validationErrorMessage,
        "aria-errormessage": errorId,
        ...restProps
    }), validationErrorMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        "aria-live": "polite",
        id: errorId
    }, validationErrorMessage)));
};
const $3769930931d22483$var$labelWrapperStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.050'
});
const $3769930931d22483$var$popupContainerStyles = (0, $8CUq3.xcss)({
    marginBlock: 'space.200',
    marginInline: 'space.200',
    minWidth: '200px'
});
const $3769930931d22483$var$panelContainerStyles = (0, $8CUq3.xcss)({
    marginBlock: 'space.200',
    marginInline: 'auto',
    minWidth: '200px'
});

});
parcelRegister("qfj8c", function(module, exports) {

$parcel$export(module.exports, "HelperMessage", () => $b2d5b368fed948c9$export$8fbe3c7d0ed2c683);
$parcel$export(module.exports, "ErrorMessage", () => $b2d5b368fed948c9$export$915e9e7bd4f0f96d);
$parcel$export(module.exports, "ValidMessage", () => $b2d5b368fed948c9$export$5505afb209a532c8);
$parcel$export(module.exports, "MessageWrapper", () => $b2d5b368fed948c9$export$ec445f12f63100a5);
/* messages.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $059q9 = parcelRequire("059q9");

var $g4M8x = parcelRequire("g4M8x");

var $dRN65 = parcelRequire("dRN65");
const $b2d5b368fed948c9$var$messageStyles = null;
const $b2d5b368fed948c9$var$messageAppearanceStyles = {
    default: "_syaz1wmz",
    error: "_syaze6sf",
    valid: "_syazy73q"
};
const $b2d5b368fed948c9$var$iconWrapperStyles = {
    root: "_1e0c1txw _4t3i7vkz _4cvr1h6o"
};
const $b2d5b368fed948c9$var$IconWrapper = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            $b2d5b368fed948c9$var$iconWrapperStyles.root
        ]),
        children: children
    });
const $b2d5b368fed948c9$var$messageIcons = {
    error: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($059q9))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "error"
    }),
    valid: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g4M8x))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "success"
    })
};
const $b2d5b368fed948c9$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
    const icon = $b2d5b368fed948c9$var$messageIcons[appearance];
    const messageRef = (0, $5uXOq.useRef)(null);
    const [hasMessageWrapper, setHasMessageWrapper] = (0, $5uXOq.useState)(false);
    const { isWrapper: isWrapper } = (0, $5uXOq.useContext)($b2d5b368fed948c9$var$MessageWrapperContext);
    (0, $5uXOq.useEffect)(()=>{
        if (messageRef.current) setHasMessageWrapper(isWrapper);
    }, [
        isWrapper
    ]);
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ const content = typeof children === 'string' ? children : /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        children: children
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-testid": testId,
        id: fieldId,
        ref: messageRef,
        // For backwards compatability, if there is a wrapper, aria-live is not needed
        "aria-live": !hasMessageWrapper ? 'polite' : undefined,
        className: (0, $bwpsq.default)([
            "_zulp12x7 _11c8dcr7 _1e0c1txw _1bah1q9y _1pfh1b66",
            $b2d5b368fed948c9$var$messageAppearanceStyles[appearance]
        ]),
        children: [
            icon && /*#__PURE__*/ (0, $2OMIu.jsx)($b2d5b368fed948c9$var$IconWrapper, {
                children: icon
            }),
            content
        ]
    });
};
const $b2d5b368fed948c9$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dRN65.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $2OMIu.jsx)($b2d5b368fed948c9$var$Message, {
                fieldId: fieldId ? `${fieldId}-helper` : undefined,
                testId: testId,
                children: children
            })
    });
const $b2d5b368fed948c9$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dRN65.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $2OMIu.jsx)($b2d5b368fed948c9$var$Message, {
                appearance: "error",
                fieldId: fieldId ? `${fieldId}-error` : undefined,
                testId: testId,
                children: children
            })
    });
const $b2d5b368fed948c9$export$5505afb209a532c8 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dRN65.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $2OMIu.jsx)($b2d5b368fed948c9$var$Message, {
                appearance: "valid",
                fieldId: fieldId ? `${fieldId}-valid` : undefined,
                testId: testId,
                children: children
            })
    });
/**
 * __Message wrapper context__
 *
 * A message wrapper context allows the children to check
 * if it is contained within the MessageWrapper.
 */ const $b2d5b368fed948c9$var$MessageWrapperContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isWrapper: false
});
const $b2d5b368fed948c9$export$ec445f12f63100a5 = ({ children: children })=>{
    const contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)($b2d5b368fed948c9$var$MessageWrapperContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "aria-live": "polite",
            "data-testid": "message-wrapper",
            children: children
        })
    });
};

});
parcelRegister("059q9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::98606756a92a07f2e7585c76d3cbd084>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $00f7c68b1ac9eeb3$var$_react = $00f7c68b1ac9eeb3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $00f7c68b1ac9eeb3$var$_error = $00f7c68b1ac9eeb3$var$_interopRequireDefault((parcelRequire("hAZqC")));

var $00f7c68b1ac9eeb3$var$_error2 = $00f7c68b1ac9eeb3$var$_interopRequireDefault((parcelRequire("7nnPp")));
function $00f7c68b1ac9eeb3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ErrorIcon.
 * This component is ErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $00f7c68b1ac9eeb3$var$ErrorIcon = (props)=>/*#__PURE__*/ $00f7c68b1ac9eeb3$var$_react.default.createElement($00f7c68b1ac9eeb3$var$_error.default, Object.assign({
        LEGACY_fallbackIcon: $00f7c68b1ac9eeb3$var$_error2.default
    }, props));
$00f7c68b1ac9eeb3$var$ErrorIcon.Name = 'ErrorIconMigration';
var $00f7c68b1ac9eeb3$var$_default = module.exports.default = $00f7c68b1ac9eeb3$var$ErrorIcon;

});

parcelRegister("g4M8x", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d345d1980a5e7ce7680063890c36f7e3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bb425bfe72dc5677$var$_react = $bb425bfe72dc5677$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $bb425bfe72dc5677$var$_success = $bb425bfe72dc5677$var$_interopRequireDefault((parcelRequire("hs3k8")));

var $bb425bfe72dc5677$var$_success2 = $bb425bfe72dc5677$var$_interopRequireDefault((parcelRequire("kJ541")));
function $bb425bfe72dc5677$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SuccessIcon.
 * This component is SuccessIcon, with `UNSAFE_fallbackIcon` set to "EditorSuccessIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bb425bfe72dc5677$var$SuccessIcon = (props)=>/*#__PURE__*/ $bb425bfe72dc5677$var$_react.default.createElement($bb425bfe72dc5677$var$_success.default, Object.assign({
        LEGACY_fallbackIcon: $bb425bfe72dc5677$var$_success2.default
    }, props));
$bb425bfe72dc5677$var$SuccessIcon.Name = 'SuccessIconMigration';
var $bb425bfe72dc5677$var$_default = module.exports.default = $bb425bfe72dc5677$var$SuccessIcon;

});
parcelRegister("hs3k8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b91b2ac4848db507d9eb71a2b738b7fc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0347594f5084a834$var$_react = $0347594f5084a834$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0347594f5084a834$var$_baseNew = $0347594f5084a834$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $0347594f5084a834$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Success".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0347594f5084a834$var$SuccessIcon = (props)=>/*#__PURE__*/ $0347594f5084a834$var$_react.default.createElement($0347594f5084a834$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 6a6 6 0 1 1 12 0A6 6 0 0 1 0 6m9.389-1.77-1.153-.96-3.174 3.808L3.765 5.52l-1.153.96 1.875 2.25a.75.75 0 0 0 1.153 0z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$0347594f5084a834$var$SuccessIcon.displayName = 'SuccessIcon';
var $0347594f5084a834$var$_default = module.exports.default = $0347594f5084a834$var$SuccessIcon;

});

parcelRegister("kJ541", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f16bf031974cd311$var$_react = $f16bf031974cd311$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $f16bf031974cd311$var$_success = $f16bf031974cd311$var$_interopRequireDefault((parcelRequire("b0JGA")));
function $f16bf031974cd311$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f16bf031974cd311$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $f16bf031974cd311$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
    }, props, {
        newIcon: $f16bf031974cd311$var$_success.default
    }));
$f16bf031974cd311$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
var $f16bf031974cd311$var$_default = module.exports.default = $f16bf031974cd311$var$EditorSuccessIcon;

});


parcelRegister("dRN65", function(module, exports) {

$parcel$export(module.exports, "FieldId", () => $706cd4dbd4574fd7$export$3c4232819458a302);

var $5uXOq = parcelRequire("5uXOq");
const $706cd4dbd4574fd7$export$3c4232819458a302 = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);

});



parcelRegister("bkrRB", function(module, exports) {

$parcel$export(module.exports, "default", () => $edba0a4edd60a46b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $edba0a4edd60a46b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    dependencyLinesSection: {
        "id": "software-view-settings.view-settings-menu.views.increment-planning-board.dependency-lines-section",
        "defaultMessage": "Dependency lines"
    },
    showOfftrackDependencyLines: {
        "id": "software-view-settings.view-settings-menu.views.increment-planning-board.show-offtrack-dependency-lines",
        "defaultMessage": "Show lines for all off-track dependencies"
    },
    offtrackDependenciesHelpLink: {
        "id": "software-view-settings.view-settings-menu.views.increment-planning-board.offtrack-dependencies-help-link",
        "defaultMessage": "What are off-track dependencies?"
    },
    showDependenciesOnIssues: {
        "id": "software-view-settings.view-settings-menu.views.increment-planning-board.show-dependencies-on-issues",
        "defaultMessage": "Show lines for dependencies linked to"
    },
    chooseIssue: {
        "id": "software-view-settings.view-settings-menu.views.increment-planning-board.choose-issue",
        "defaultMessage": "Choose issue..."
    },
    onlyShowScheduledIssueDependencyLinesTooltip: {
        "id": "software-view-settings.view-settings-menu.views.increment-planning-board.only-show-scheduled-issue-dependency-lines-tooltip",
        "defaultMessage": "Lines only show once an issue has been scheduled"
    },
    chooseIssueIssueTermRefresh: {
        "id": "software-view-settings.view-settings-menu.views.increment-planning-board.choose-issue-issue-term-refresh",
        "defaultMessage": "Choose work item..."
    },
    onlyShowScheduledIssueDependencyLinesTooltipIssueTermRefresh: {
        "id": "software-view-settings.view-settings-menu.views.increment-planning-board.only-show-scheduled-issue-dependency-lines-tooltip-issue-term-refresh",
        "defaultMessage": "Lines only show once a work item has been scheduled"
    }
});

});



const $3795a016b6403547$export$8be246eeba922980 = 'jsw-tailored-board-view-onboarding';
const $3795a016b6403547$export$a57856d4380e4bb8 = 'viewSettingsButtonTarget';
const $3795a016b6403547$export$989661c424340ff8 = 'viewSettingsPanelTarget';
const $3795a016b6403547$export$4a16d41d3ff730bf = 'addPeopleButtonTarget';


parcelRegister("le1bQ", function(module, exports) {

$parcel$export(module.exports, "useAllCardGroups", () => $a48f57b5dc3a0ae9$export$c3f5757fe39cf802);

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");
const $a48f57b5dc3a0ae9$export$c3f5757fe39cf802 = ()=>{
    const allCardGroups = (0, $c1MAf.useBacklogSelector)((0, $dGljH.makeGetAllAttachedToParentCardGroupEntries))();
    return allCardGroups;
};

});





parcelRegister("e2Elo", function(module, exports) {

$parcel$export(module.exports, "PanelWrapper", () => $7b02c43f9e7d11dc$export$f537a9b13aef4d02);
$parcel$export(module.exports, "EpicPanelWithErrorBoundary", () => $7b02c43f9e7d11dc$export$852c474275ac8b90);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7CMCs = parcelRequire("7CMCs");

var $iXVV6 = parcelRequire("iXVV6");

var $5NBkv = parcelRequire("5NBkv");

var $dZggJ = parcelRequire("dZggJ");

var $eSUJA = parcelRequire("eSUJA");

var $c1MAf = parcelRequire("c1MAf");

var $74oBv = parcelRequire("74oBv");

var $dGljH = parcelRequire("dGljH");

var $lDDqj = parcelRequire("lDDqj");

var $f9Swb = parcelRequire("f9Swb");

var $1z1J7 = parcelRequire("1z1J7");

var $fSgHa = parcelRequire("fSgHa");

var $zM1Qq = parcelRequire("zM1Qq");

var $dM9vk = parcelRequire("dM9vk");
const $7b02c43f9e7d11dc$export$f69665587e333870 = ({ boardId: boardId, selectedIssues: selectedIssues, issueHierarchyLevel: issueHierarchyLevel, epicLinkFieldId: epicLinkFieldId, onEpicPanelClose: onEpicPanelClose, onCardDetailClick: onCardDetailClick, onEpicCreate: onEpicCreate, onEpicAssign: onEpicAssign, isCompanyManaged: isCompanyManaged })=>{
    const isEpicPanelOpen = (0, $zM1Qq.useIsEpicPanelOpen)();
    const baseLevelCardTypes = (0, $c1MAf.useBacklogSelector)((0, $74oBv.getBaseLevelCardTypes));
    const selectedIssuesWithTypeHierarchyLevel = (0, $c1MAf.useBacklogSelector)((0, $dGljH.selectedPartialCardsWithTypeHierarchyLevelSelector));
    const canCreate = (0, $c1MAf.useBacklogSelector)((0, $1z1J7.canCreateIssues));
    const canEdit = (0, $c1MAf.useBacklogSelector)((0, $1z1J7.canEditIssue));
    const firstLevelHierarchyName = (0, $c1MAf.useBacklogSelector)((0, $f9Swb.getFirstLevelHierarchyName));
    const isCmpManaged = (0, $fSgHa.useIsCMPBacklog)();
    const sourceDroppableType = (0, $c1MAf.useBacklogSelector)((0, $lDDqj.getSourceDroppableType));
    return isEpicPanelOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dM9vk.default), {
        experienceTarget: "epic panel",
        experienceTargetId: `${boardId}`,
        experienceSource: (0, $dZggJ.EXPERIENCE_TRACKER_PROVIDER_SOURCE)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            analyticsSource: (0, $dZggJ.ANALYTICS_SOURCE_EPIC_PANEL),
            issueHierarchyLevel: issueHierarchyLevel
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7b02c43f9e7d11dc$export$f537a9b13aef4d02, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eSUJA.PanelDataProvider), {
        sourceDroppableType: sourceDroppableType,
        boardId: boardId,
        isCompanyManaged: isCmpManaged
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5NBkv.default), {
        selectedIssues: isCompanyManaged ? selectedIssuesWithTypeHierarchyLevel : selectedIssues,
        defaultIssueCreateIssueTypeId: baseLevelCardTypes[0]?.id.toString(),
        onClose: onEpicPanelClose,
        onCardDetailClick: onCardDetailClick,
        onEpicCreate: onEpicCreate,
        onEpicAssign: onEpicAssign,
        isCompanyManaged: isCompanyManaged,
        epicLinkFieldId: epicLinkFieldId,
        hierarchyName: firstLevelHierarchyName,
        canCreate: canCreate,
        canEdit: canEdit
    }))))) : null;
};
const $7b02c43f9e7d11dc$export$852c474275ac8b90 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "backlogContentEpicPanel",
        teamName: "a4t-tanuki",
        packageName: "jiraSoftwareBacklog",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7b02c43f9e7d11dc$export$f69665587e333870, props));
const $7b02c43f9e7d11dc$export$f537a9b13aef4d02 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _ca0qidpf _u5f3u2gc _n3tdidpf _19bvidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("f9Swb", function(module, exports) {

$parcel$export(module.exports, "getFirstLevelHierarchyName", () => $e53306d45f784739$export$ef3b2d218d80725);

var $9Pc1U = parcelRequire("9Pc1U");
const $e53306d45f784739$export$ef3b2d218d80725 = (state)=>(0, $9Pc1U.getConfig)(state).hierarchyNomenclature?.firstLevelName ?? null;

});

parcelRegister("dM9vk", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa94a3ab92e4f7fb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $e4eHl = parcelRequire("e4eHl");

var $3T6Xo = parcelRequire("3T6Xo");

var $aD4Nm = parcelRequire("aD4Nm");

var $2i4sA = parcelRequire("2i4sA");

var $01Rn4 = parcelRequire("01Rn4");

var $efvDm = parcelRequire("efvDm");

var $gk7Z3 = parcelRequire("gk7Z3");

var $9OXo1 = parcelRequire("9OXo1");


var $fSgHa = parcelRequire("fSgHa");
const $fa94a3ab92e4f7fb$var$SLAExperienceTracker = ({ experienceTarget: experienceTarget = '', experienceTargetId: experienceTargetId = '', experienceSource: experienceSource = (0, $a9c483c0d986286a$export$840e3848643f7781), additionalAttributes: additionalAttributes = {}, children: children })=>{
    const { appEditions: { software: software } } = (0, $9OXo1.useTenantContext)();
    const isCompanyManaged = (0, $fSgHa.useIsCMPBacklog)();
    const experienceTargetKey = (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(experienceTarget);
    const experienceId = experienceTargetId ? `${experienceTargetKey}-${experienceTargetId}` : experienceTargetKey;
    const experience = `view${experienceTargetKey.charAt(0).toUpperCase()}${experienceTargetKey.slice(1)}`;
    const experienceLocation = experienceTarget ? `${0, $a9c483c0d986286a$export$b6e4306772e8a60d}-${(0, (/*@__PURE__*/$parcel$interopDefault($3T6Xo)))(experienceTarget)}` : (0, $a9c483c0d986286a$export$b6e4306772e8a60d);
    const onSuccess = ({ onExperienceSuccess: onExperienceSuccess })=>()=>{
            onExperienceSuccess();
        };
    const onError = ({ onExperienceFailure: onExperienceFailure })=>(location, error)=>{
            onExperienceFailure(undefined, (0, $gk7Z3.getErrorAttributes)(error));
        };
    const viewExperienceTracker = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aD4Nm.ExperienceTracker), {
        location: experienceLocation
    }, (trackerCallbacks)=>typeof children === 'function' ? children({
            onSuccess: onSuccess(trackerCallbacks),
            onError: onError(trackerCallbacks)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01Rn4.default), {
            op: trackerCallbacks.onExperienceSuccess
        })));
    return experienceTarget ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2i4sA.ViewExperienceTrackingProvider), {
        experienceId: experienceId,
        experience: experience,
        analyticsSource: experienceSource,
        edition: software,
        application: (0, $efvDm.JIRA_SOFTWARE),
        additionalAttributes: {
            isUIF: true,
            isClassic: isCompanyManaged,
            ...additionalAttributes
        }
    }, viewExperienceTracker) : viewExperienceTracker;
};
var $fa94a3ab92e4f7fb$export$2e2bcd8739ae039 = $fa94a3ab92e4f7fb$var$SLAExperienceTracker;

});


parcelRegister("jg0aS", function(module, exports) {

$parcel$export(module.exports, "MoreResults", () => $04dab9ba2b61efe8$export$1f344df69afb392e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-html-button */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cC5ib = parcelRequire("cC5ib");

var $ls8Y7 = parcelRequire("ls8Y7");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $5tMAe = parcelRequire("5tMAe");

var $c1MAf = parcelRequire("c1MAf");

var $l9VFH = parcelRequire("l9VFH");

var $fxK3Z = parcelRequire("fxK3Z");
const $04dab9ba2b61efe8$export$1f344df69afb392e = ({ scrollableParentRef: scrollableParentRef })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const filters = (0, $c1MAf.useBacklogSelector)((0, $l9VFH.getFilters));
    const [{ isLastResultMarkerBelowFold: isLastResultMarkerBelowFold }] = (0, $5tMAe.useMoreResultsStore)();
    const filtersAreApplied = Object.keys(filters).length > 0;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleClick = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'moreResultsButton'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent);
        if (scrollableParentRef.current) scrollableParentRef.current.scrollTo({
            top: scrollableParentRef.current.scrollTop + scrollableParentRef.current.clientHeight,
            behavior: 'smooth'
        });
    };
    if (!filtersAreApplied || !isLastResultMarkerBelowFold) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04dab9ba2b61efe8$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04dab9ba2b61efe8$var$SeeMoreButton, {
        onClick: handleClick,
        tabIndex: -1,
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cC5ib))), {
        label: formatMessage((0, $fxK3Z.default).downArrowIconLabel),
        spacing: "spacious",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($ls8Y7))),
        color: "var(--ds-icon, #44546F)"
    }), formatMessage((0, $fxK3Z.default).moreResults)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $04dab9ba2b61efe8$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqsw1if8 _1pbyb4wl _1ltvidpf _1xi2idpf _94n51ejb _1e0c1txw _1bah1h6o _lcxvglyw _4t3iidpf",
            __cmplp.className
        ])
    });
});
const $04dab9ba2b61efe8$var$SeeMoreButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19itglyw _2rko7vkz _1e0c1txw _4cvr1h6o _1bsb1ns9 _4t3i1ns9 _ca0q1b66 _u5f3utpp _n3td1b66 _19bvutpp _syaz1gjq _bfhk1bhr _16qs1cd0 _80omtlke _lcxv1wug _irr31v33 _9h8hpnps _1di6i1yw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cC5ib", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d7f5a6659a6d5dd6eaa41936b6c8533f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $92ed238f23140736$var$_react = $92ed238f23140736$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $92ed238f23140736$var$_baseNew = $92ed238f23140736$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $92ed238f23140736$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $92ed238f23140736$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $92ed238f23140736$var$_react.default.createElement($92ed238f23140736$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v11.44l3.72-3.72 1.06 1.06-5 5a.75.75 0 0 1-1.06 0l-5-5 1.06-1.06 3.72 3.72V1z" clip-rule="evenodd"/>`
    }, props));
$92ed238f23140736$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $92ed238f23140736$var$_default = module.exports.default = $92ed238f23140736$var$ArrowDownIcon;

});

parcelRegister("ls8Y7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f9e32b81d01f795b$var$_react = $f9e32b81d01f795b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $f9e32b81d01f795b$var$_arrowDown = $f9e32b81d01f795b$var$_interopRequireDefault((parcelRequire("cC5ib")));
function $f9e32b81d01f795b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f9e32b81d01f795b$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $f9e32b81d01f795b$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11 6v9.586l-3.793-3.793a1 1 0 0 0-1.414 0c-.39.39-.39 1.024 0 1.415l5.5 5.499A1 1 0 0 0 12 19a1 1 0 0 0 .707-.293l5.5-5.499a1 1 0 1 0-1.414-1.415L13 15.586V6a1 1 0 0 0-2 0"/></svg>`
    }, props, {
        newIcon: $f9e32b81d01f795b$var$_arrowDown.default
    }));
$f9e32b81d01f795b$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $f9e32b81d01f795b$var$_default = module.exports.default = $f9e32b81d01f795b$var$ArrowDownIcon;

});

parcelRegister("5tMAe", function(module, exports) {

$parcel$export(module.exports, "useMoreResultsStore", () => $8ee95b61ca54be42$export$2562d6b68d41f3d2);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $8ee95b61ca54be42$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        isLastResultMarkerBelowFold: false
    },
    actions: {
        setIsLastResultMarkerBelowFold: (isLastResultMarkerBelowFold)=>({ setState: setState })=>{
                setState({
                    isLastResultMarkerBelowFold: isLastResultMarkerBelowFold
                });
            }
    },
    name: 'more-results'
});
const $8ee95b61ca54be42$export$2562d6b68d41f3d2 = (0, $3sQ5x.createHook)($8ee95b61ca54be42$var$Store);

});

parcelRegister("fxK3Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $1344643ed085ae13$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1344643ed085ae13$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    moreResults: {
        "id": "backlog.backlog-content.more-results.more-results",
        "defaultMessage": "More results"
    },
    downArrowIconLabel: {
        "id": "backlog.backlog-content.more-results.down-arrow-icon-label",
        "defaultMessage": "Down arrow"
    }
});

});


parcelRegister("eX9XD", function(module, exports) {

$parcel$export(module.exports, "useAutoScroller", () => $fb572b128a540b81$export$f9101ea66b86493d);

var $5uXOq = parcelRequire("5uXOq");

var $41Tr4 = parcelRequire("41Tr4");

var $7gWdR = parcelRequire("7gWdR");
const $fb572b128a540b81$export$ec5b303098bc4b7f = {
    onDragStart: ({ location: location })=>{
        (0, $41Tr4.autoScroller).start({
            input: location.current.input
        });
    },
    onDrop: ()=>{
        (0, $41Tr4.autoScroller).stop();
    },
    onDrag: ({ location: location })=>{
        (0, $41Tr4.autoScroller).updateInput({
            input: location.current.input
        });
    }
};
function $fb572b128a540b81$export$f9101ea66b86493d() {
    (0, $5uXOq.useEffect)(()=>(0, $7gWdR.monitorForElements)($fb572b128a540b81$export$ec5b303098bc4b7f), []);
}

});
parcelRegister("41Tr4", function(module, exports) {

$parcel$export(module.exports, "createAutoScroller", () => $109b883638d1460e$export$fbda4b72e803ec38);
$parcel$export(module.exports, "autoScroller", () => $109b883638d1460e$export$d19940cfc7560cd8);

var $bKki5 = parcelRequire("bKki5");
const $109b883638d1460e$var$scrollElement = (element, change)=>{
    element.scrollBy(change.x, change.y);
};
const $109b883638d1460e$var$scrollWindow = (change)=>{
    window.scrollBy(change.x, change.y);
};
const $109b883638d1460e$export$fbda4b72e803ec38 = ()=>{
    let dragging = null;
    function tryScroll(fakeScrollCallback) {
        if (dragging == null) return;
        (0, $bKki5.scroll)({
            input: dragging.latestInput,
            dragStartTime: dragging.dragStartTime,
            shouldUseTimeDampening: dragging.shouldUseTimeDampening,
            behavior: dragging.behavior,
            scrollElement: fakeScrollCallback ?? $109b883638d1460e$var$scrollElement,
            scrollWindow: fakeScrollCallback ?? $109b883638d1460e$var$scrollWindow
        });
    }
    // Every animation frame use the latest user input to scroll
    // We do this loop manually rather than in response to `onDrag`
    // events as `onDrag` can drop to 50-100ms between events when
    // the user is not actively moving their pointer
    function loop() {
        if (!dragging) return;
        dragging.loopFrameId = requestAnimationFrame(()=>{
            tryScroll();
            loop();
        });
    }
    const start = ({ input: input, behavior: behavior = 'window-then-container' })=>{
        const dragStartTime = Date.now();
        dragging = {
            dragStartTime: dragStartTime,
            latestInput: input,
            loopFrameId: null,
            shouldUseTimeDampening: false,
            behavior: behavior
        };
        // we only use time dampening when auto scrolling starts on lift.
        const fakeScrollCallback = ()=>{
            if (dragging) dragging.shouldUseTimeDampening = true;
        };
        tryScroll(fakeScrollCallback);
        loop();
    };
    function updateInput({ input: input }) {
        if (!dragging) return;
        dragging.latestInput = input;
    }
    const stop = ()=>{
        // can be called defensively
        if (!dragging) return;
        if (dragging.loopFrameId) cancelAnimationFrame(dragging.loopFrameId);
        dragging = null;
    };
    return {
        start: start,
        updateInput: updateInput,
        stop: stop
    };
};
const $109b883638d1460e$export$d19940cfc7560cd8 = $109b883638d1460e$export$fbda4b72e803ec38();

});
parcelRegister("bKki5", function(module, exports) {

$parcel$export(module.exports, "scroll", () => $fa05b34874c18386$export$209876d7b1ac8f3);
parcelRequire("i6e0j");
var $kKgsQ = parcelRequire("kKgsQ");

var $8IFZn = parcelRequire("8IFZn");

var $cd0ri = parcelRequire("cd0ri");

var $bUPhs = parcelRequire("bUPhs");

var $2tkrf = parcelRequire("2tkrf");

var $lVsVC = parcelRequire("lVsVC");
const $fa05b34874c18386$export$209876d7b1ac8f3 = ({ input: input, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening, scrollElement: scrollElement, scrollWindow: scrollWindow, behavior: behavior })=>{
    const tryScrollWindow = ()=>{
        const viewport = (0, $lVsVC.default)();
        const windowScrollChange = (0, $2tkrf.default)({
            dragStartTime: dragStartTime,
            viewport: viewport,
            center: {
                x: input.clientX + viewport.scroll.current.x,
                y: input.clientY + viewport.scroll.current.y
            },
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        if (windowScrollChange) {
            scrollWindow(windowScrollChange);
            return true;
        }
        return false;
    };
    const tryScrollContainer = ()=>{
        const over = (0, $kKgsQ.getElementFromPointWithoutHoneypot)({
            x: input.clientX,
            y: input.clientY
        });
        const closestScrollable = (0, $8IFZn.getClosestScrollableElement)(over);
        if (!closestScrollable) return false;
        const scrollable = (0, $cd0ri.getScrollable)({
            closestScrollable: closestScrollable
        });
        const scrollableScrollChange = (0, $bUPhs.default)({
            dragStartTime: dragStartTime,
            scrollable: scrollable,
            center: {
                x: input.clientX,
                y: input.clientY
            },
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        if (scrollableScrollChange) {
            scrollElement(closestScrollable, scrollableScrollChange);
            return true;
        }
        return false;
    };
    if (behavior === 'container-only') tryScrollContainer();
    if (behavior === 'window-only') tryScrollWindow();
    if (behavior === 'container-then-window') tryScrollContainer() || tryScrollWindow();
    if (behavior === 'window-then-container') tryScrollWindow() || tryScrollContainer();
};

});
parcelRegister("i6e0j", function(module, exports) {

$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => (parcelRequire("kKgsQ")).getElementFromPointWithoutHoneypot);

var $kKgsQ = parcelRequire("kKgsQ");

});

parcelRegister("8IFZn", function(module, exports) {

$parcel$export(module.exports, "getClosestScrollableElement", () => $d89049a655de884c$export$f39f407dd5a0ebdb);
// Source: https://github.com/atlassian/react-beautiful-dnd
const $d89049a655de884c$var$isEqual = (base)=>(value)=>base === value;
const $d89049a655de884c$var$isScroll = $d89049a655de884c$var$isEqual('scroll');
const $d89049a655de884c$var$isAuto = $d89049a655de884c$var$isEqual('auto');
const $d89049a655de884c$var$isEither = (overflow, fn)=>fn(overflow.overflowX) || fn(overflow.overflowY);
const $d89049a655de884c$var$isElementScrollable = (el)=>{
    const style = window.getComputedStyle(el);
    const overflow = {
        overflowX: style.overflowX,
        overflowY: style.overflowY
    };
    return $d89049a655de884c$var$isEither(overflow, $d89049a655de884c$var$isScroll) || $d89049a655de884c$var$isEither(overflow, $d89049a655de884c$var$isAuto);
};
const $d89049a655de884c$export$f39f407dd5a0ebdb = (el)=>{
    // cannot do anything else!
    if (!el) return null;
    // not allowing us to go higher then body
    if (el === document.body || el === document.documentElement) return null;
    if (!$d89049a655de884c$var$isElementScrollable(el)) // keep recursing
    return $d89049a655de884c$export$f39f407dd5a0ebdb(el.parentElement);
    // success!
    return el;
};

});

parcelRegister("cd0ri", function(module, exports) {

$parcel$export(module.exports, "getScrollable", () => $3bb4723f24ee5351$export$9b7238c949d126e9);

var $3YKxB = parcelRequire("3YKxB");
const $3bb4723f24ee5351$export$9b7238c949d126e9 = ({ closestScrollable: closestScrollable })=>{
    const rect = closestScrollable.getBoundingClientRect();
    const scrollPosition = {
        x: closestScrollable.scrollLeft,
        y: closestScrollable.scrollTop
    };
    return {
        container: (0, $3YKxB.getRect)(rect),
        scroll: {
            current: scrollPosition,
            max: {
                x: closestScrollable.scrollWidth - closestScrollable.clientWidth,
                y: closestScrollable.scrollHeight - closestScrollable.clientHeight
            }
        }
    };
};

});
parcelRegister("3YKxB", function(module, exports) {

$parcel$export(module.exports, "getRect", () => $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe);
$parcel$export(module.exports, "expand", () => $2e5b13c1f6ee9f8a$export$9f77e0932fb78f72);
$parcel$export(module.exports, "createBox", () => $2e5b13c1f6ee9f8a$export$6459fc9e86be362e);
$parcel$export(module.exports, "offset", () => $2e5b13c1f6ee9f8a$export$cc800923e997bb8);
$parcel$export(module.exports, "withScroll", () => $2e5b13c1f6ee9f8a$export$1d0caec378d7d0ae);
$parcel$export(module.exports, "calculateBox", () => $2e5b13c1f6ee9f8a$export$b8dfc5d4e552b8e1);
$parcel$export(module.exports, "getBox", () => $2e5b13c1f6ee9f8a$export$34928e660d2a8702);

var $3joPi = parcelRequire("3joPi");
var $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe = function getRect(_ref) {
    var top = _ref.top, right = _ref.right, bottom = _ref.bottom, left = _ref.left;
    var width = right - left;
    var height = bottom - top;
    var rect = {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        width: width,
        height: height,
        x: left,
        y: top,
        center: {
            x: (right + left) / 2,
            y: (bottom + top) / 2
        }
    };
    return rect;
};
var $2e5b13c1f6ee9f8a$export$9f77e0932fb78f72 = function expand(target, expandBy) {
    return {
        top: target.top - expandBy.top,
        left: target.left - expandBy.left,
        bottom: target.bottom + expandBy.bottom,
        right: target.right + expandBy.right
    };
};
var $2e5b13c1f6ee9f8a$export$8b1f3092f5e28575 = function shrink(target, shrinkBy) {
    return {
        top: target.top + shrinkBy.top,
        left: target.left + shrinkBy.left,
        bottom: target.bottom - shrinkBy.bottom,
        right: target.right - shrinkBy.right
    };
};
var $2e5b13c1f6ee9f8a$var$shift = function shift(target, shiftBy) {
    return {
        top: target.top + shiftBy.y,
        left: target.left + shiftBy.x,
        bottom: target.bottom + shiftBy.y,
        right: target.right + shiftBy.x
    };
};
var $2e5b13c1f6ee9f8a$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $2e5b13c1f6ee9f8a$export$6459fc9e86be362e = function createBox(_ref2) {
    var borderBox = _ref2.borderBox, _ref2$margin = _ref2.margin, margin = _ref2$margin === void 0 ? $2e5b13c1f6ee9f8a$var$noSpacing : _ref2$margin, _ref2$border = _ref2.border, border = _ref2$border === void 0 ? $2e5b13c1f6ee9f8a$var$noSpacing : _ref2$border, _ref2$padding = _ref2.padding, padding = _ref2$padding === void 0 ? $2e5b13c1f6ee9f8a$var$noSpacing : _ref2$padding;
    var marginBox = $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe($2e5b13c1f6ee9f8a$export$9f77e0932fb78f72(borderBox, margin));
    var paddingBox = $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe($2e5b13c1f6ee9f8a$export$8b1f3092f5e28575(borderBox, border));
    var contentBox = $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe($2e5b13c1f6ee9f8a$export$8b1f3092f5e28575(paddingBox, padding));
    return {
        marginBox: marginBox,
        borderBox: $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe(borderBox),
        paddingBox: paddingBox,
        contentBox: contentBox,
        margin: margin,
        border: border,
        padding: padding
    };
};
var $2e5b13c1f6ee9f8a$var$parse = function parse(raw) {
    var value = raw.slice(0, -2);
    var suffix = raw.slice(-2);
    if (suffix !== 'px') return 0;
    var result = Number(value);
    !!isNaN(result) && (0, $3joPi.default)(false);
    return result;
};
var $2e5b13c1f6ee9f8a$var$getWindowScroll = function getWindowScroll() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
var $2e5b13c1f6ee9f8a$export$cc800923e997bb8 = function offset(original, change) {
    var borderBox = original.borderBox, border = original.border, margin = original.margin, padding = original.padding;
    var shifted = $2e5b13c1f6ee9f8a$var$shift(borderBox, change);
    return $2e5b13c1f6ee9f8a$export$6459fc9e86be362e({
        borderBox: shifted,
        border: border,
        margin: margin,
        padding: padding
    });
};
var $2e5b13c1f6ee9f8a$export$1d0caec378d7d0ae = function withScroll(original, scroll) {
    if (scroll === void 0) scroll = $2e5b13c1f6ee9f8a$var$getWindowScroll();
    return $2e5b13c1f6ee9f8a$export$cc800923e997bb8(original, scroll);
};
var $2e5b13c1f6ee9f8a$export$b8dfc5d4e552b8e1 = function calculateBox(borderBox, styles) {
    var margin = {
        top: $2e5b13c1f6ee9f8a$var$parse(styles.marginTop),
        right: $2e5b13c1f6ee9f8a$var$parse(styles.marginRight),
        bottom: $2e5b13c1f6ee9f8a$var$parse(styles.marginBottom),
        left: $2e5b13c1f6ee9f8a$var$parse(styles.marginLeft)
    };
    var padding = {
        top: $2e5b13c1f6ee9f8a$var$parse(styles.paddingTop),
        right: $2e5b13c1f6ee9f8a$var$parse(styles.paddingRight),
        bottom: $2e5b13c1f6ee9f8a$var$parse(styles.paddingBottom),
        left: $2e5b13c1f6ee9f8a$var$parse(styles.paddingLeft)
    };
    var border = {
        top: $2e5b13c1f6ee9f8a$var$parse(styles.borderTopWidth),
        right: $2e5b13c1f6ee9f8a$var$parse(styles.borderRightWidth),
        bottom: $2e5b13c1f6ee9f8a$var$parse(styles.borderBottomWidth),
        left: $2e5b13c1f6ee9f8a$var$parse(styles.borderLeftWidth)
    };
    return $2e5b13c1f6ee9f8a$export$6459fc9e86be362e({
        borderBox: borderBox,
        margin: margin,
        padding: padding,
        border: border
    });
};
var $2e5b13c1f6ee9f8a$export$34928e660d2a8702 = function getBox(el) {
    var borderBox = el.getBoundingClientRect();
    var styles = window.getComputedStyle(el);
    return $2e5b13c1f6ee9f8a$export$b8dfc5d4e552b8e1(borderBox, styles);
};

});


parcelRegister("bUPhs", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac1c10c5ae151830$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $g2R1U = parcelRequire("g2R1U");

var $elgbz = parcelRequire("elgbz");
var $ac1c10c5ae151830$export$2e2bcd8739ae039 = ({ scrollable: scrollable, center: center, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening })=>{
    const scroll = (0, $elgbz.default)({
        dragStartTime: dragStartTime,
        container: scrollable.container,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && (0, $g2R1U.canScrollScrollable)(scrollable, scroll) ? scroll : null;
};

});
parcelRegister("g2R1U", function(module, exports) {

$parcel$export(module.exports, "canScrollWindow", () => $e4b7c0460454dc35$export$cbd1e6fd5e887f10);
$parcel$export(module.exports, "canScrollScrollable", () => $e4b7c0460454dc35$export$57c21b61d76c9819);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $72Pcv = parcelRequire("72Pcv");
const $e4b7c0460454dc35$var$smallestSigned = (0, $72Pcv.apply)((value)=>{
    if (value === 0) return 0;
    return value > 0 ? 1 : -1;
});
const $e4b7c0460454dc35$export$6b13012b06f8f95b = (()=>{
    const getRemainder = (target, max)=>{
        if (target < 0) return target;
        if (target > max) return target - max;
        return 0;
    };
    return ({ current: current, max: max, change: change })=>{
        const targetScroll = (0, $72Pcv.add)(current, change);
        const overlap = {
            x: getRemainder(targetScroll.x, max.x),
            y: getRemainder(targetScroll.y, max.y)
        };
        if ((0, $72Pcv.isEqual)(overlap, (0, $72Pcv.origin))) return null;
        return overlap;
    };
})();
const $e4b7c0460454dc35$export$dbc3ad6130556cf6 = ({ max: rawMax, current: current, change: change })=>{
    // It is possible for the max scroll to be greater than the current scroll
    // when there are scrollbars on the cross axis. We adjust for this by
    // increasing the max scroll point if needed
    // This will allow movements backwards even if the current scroll is greater than the max scroll
    const max = {
        x: Math.max(current.x, rawMax.x),
        y: Math.max(current.y, rawMax.y)
    };
    // Only need to be able to move the smallest amount in the desired direction
    const smallestChange = $e4b7c0460454dc35$var$smallestSigned(change);
    const overlap = $e4b7c0460454dc35$export$6b13012b06f8f95b({
        max: max,
        current: current,
        change: smallestChange
    });
    // no overlap at all - we can move there!
    if (!overlap) return true;
    // if there was an x value, but there is no x overlap - then we can scroll on the x!
    if (smallestChange.x !== 0 && overlap.x === 0) return true;
    // if there was an y value, but there is no y overlap - then we can scroll on the y!
    if (smallestChange.y !== 0 && overlap.y === 0) return true;
    return false;
};
const $e4b7c0460454dc35$export$cbd1e6fd5e887f10 = (viewport, change)=>$e4b7c0460454dc35$export$dbc3ad6130556cf6({
        current: viewport.scroll.current,
        max: viewport.scroll.max,
        change: change
    });
const $e4b7c0460454dc35$export$2f1f3b9e315c6096 = (viewport, change)=>{
    if (!$e4b7c0460454dc35$export$cbd1e6fd5e887f10(viewport, change)) return null;
    const max = viewport.scroll.max;
    const current = viewport.scroll.current;
    return $e4b7c0460454dc35$export$6b13012b06f8f95b({
        current: current,
        max: max,
        change: change
    });
};
const $e4b7c0460454dc35$export$57c21b61d76c9819 = (scrollable, change)=>{
    return $e4b7c0460454dc35$export$dbc3ad6130556cf6({
        current: scrollable.scroll.current,
        max: scrollable.scroll.max,
        change: change
    });
};
const $e4b7c0460454dc35$export$d88a6b2979421049 = (scrollable, change)=>{
    if (!$e4b7c0460454dc35$export$57c21b61d76c9819(scrollable, change)) return null;
    return $e4b7c0460454dc35$export$6b13012b06f8f95b({
        current: scrollable.scroll.current,
        max: scrollable.scroll.max,
        change: change
    });
};

});
parcelRegister("72Pcv", function(module, exports) {

$parcel$export(module.exports, "origin", () => $6ab9ddd38a038691$export$f710a83a91838a36);
$parcel$export(module.exports, "apply", () => $6ab9ddd38a038691$export$5635d7ef4b8fee1c);
$parcel$export(module.exports, "isEqual", () => $6ab9ddd38a038691$export$248d38f6296296c5);
$parcel$export(module.exports, "add", () => $6ab9ddd38a038691$export$e16d8520af44a096);
$parcel$export(module.exports, "subtract", () => $6ab9ddd38a038691$export$4e2d2ead65e5f7e3);
// Source: https://github.com/atlassian/react-beautiful-dnd
const $6ab9ddd38a038691$export$f710a83a91838a36 = {
    x: 0,
    y: 0
};
const $6ab9ddd38a038691$export$5635d7ef4b8fee1c = (fn)=>(point)=>({
            x: fn(point.x),
            y: fn(point.y)
        });
const $6ab9ddd38a038691$export$248d38f6296296c5 = (point1, point2)=>point1.x === point2.x && point1.y === point2.y;
const $6ab9ddd38a038691$export$e16d8520af44a096 = (point1, point2)=>({
        x: point1.x + point2.x,
        y: point1.y + point2.y
    });
const $6ab9ddd38a038691$export$4e2d2ead65e5f7e3 = (point1, point2)=>({
        x: point1.x - point2.x,
        y: point1.y - point2.y
    });

});


parcelRegister("elgbz", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bd53a776b729d8f$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $8x8E3 = parcelRequire("8x8E3");

var $72Pcv = parcelRequire("72Pcv");

var $3hu7o = parcelRequire("3hu7o");
// will replace -0 and replace with +0
const $7bd53a776b729d8f$var$clean = (0, $72Pcv.apply)((value)=>value === 0 ? 0 : value);
var $7bd53a776b729d8f$export$2e2bcd8739ae039 = ({ dragStartTime: dragStartTime, container: container, center: center, shouldUseTimeDampening: shouldUseTimeDampening })=>{
    // get distance to each edge
    const distanceToEdges = {
        top: center.y - container.top,
        right: container.right - center.x,
        bottom: container.bottom - center.y,
        left: center.x - container.left
    };
    // 1. Figure out which x,y values are the best target
    // 2. Can the container scroll in that direction at all?
    // If no for both directions, then return null
    // 3. Is the center close enough to a edge to start a drag?
    // 4. Based on the distance, calculate the speed at which a scroll should occur
    // The lower distance value the faster the scroll should be.
    // Maximum speed value should be hit before the distance is 0
    // Negative values to not continue to increase the speed
    const y = (0, $3hu7o.default)({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: (0, $8x8E3.vertical),
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    const x = (0, $3hu7o.default)({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: (0, $8x8E3.horizontal),
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    const required = $7bd53a776b729d8f$var$clean({
        x: x,
        y: y
    });
    // nothing required
    if ((0, $72Pcv.isEqual)(required, (0, $72Pcv.origin))) return null;
    return required;
};

});
parcelRegister("8x8E3", function(module, exports) {

$parcel$export(module.exports, "minScroll", () => $bf32c7b0b1170f48$export$67e2de1e1e796844);
$parcel$export(module.exports, "vertical", () => $bf32c7b0b1170f48$export$32f8a6eb41d46820);
$parcel$export(module.exports, "horizontal", () => $bf32c7b0b1170f48$export$641ecd0b2bc39508);
const $bf32c7b0b1170f48$export$67e2de1e1e796844 = 1;
const $bf32c7b0b1170f48$export$32f8a6eb41d46820 = {
    direction: 'vertical',
    start: 'top',
    end: 'bottom',
    size: 'height',
    scrollAxis: 'scrollTop'
};
const $bf32c7b0b1170f48$export$641ecd0b2bc39508 = {
    direction: 'horizontal',
    start: 'left',
    end: 'right',
    size: 'width',
    scrollAxis: 'scrollLeft'
};
const $bf32c7b0b1170f48$export$1a8fc111f6979e7a = [
    $bf32c7b0b1170f48$export$641ecd0b2bc39508.direction,
    $bf32c7b0b1170f48$export$32f8a6eb41d46820.direction
];

});

parcelRegister("3hu7o", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9df84024ef20482$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $TN11L = parcelRequire("TN11L");

var $h91se = parcelRequire("h91se");
var $a9df84024ef20482$export$2e2bcd8739ae039 = ({ container: container, distanceToEdges: distanceToEdges, dragStartTime: dragStartTime, axis: axis, shouldUseTimeDampening: shouldUseTimeDampening })=>{
    const thresholds = (0, $TN11L.default)(container, axis);
    const isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];
    if (isCloserToEnd) return (0, $h91se.default)({
        distanceToEdge: distanceToEdges[axis.end],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return -1 * (0, $h91se.default)({
        distanceToEdge: distanceToEdges[axis.start],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
};

});
parcelRegister("TN11L", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3b60bb9d8221ac4$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $2gHPS = parcelRequire("2gHPS");
const $e3b60bb9d8221ac4$export$79446fee27934459 = (container, axis)=>{
    const startScrollingFrom = container[axis.size] * (0, $2gHPS.default).startFromPercentage;
    const maxScrollValueAt = container[axis.size] * (0, $2gHPS.default).maxScrollAtPercentage;
    const thresholds = {
        startScrollingFrom: startScrollingFrom,
        maxScrollValueAt: maxScrollValueAt
    };
    return thresholds;
};
var $e3b60bb9d8221ac4$export$2e2bcd8739ae039 = $e3b60bb9d8221ac4$export$79446fee27934459;

});
parcelRegister("2gHPS", function(module, exports) {

$parcel$export(module.exports, "default", () => $372e7e4331f931a5$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd
// Values used to control how the fluid auto scroll feels
const $372e7e4331f931a5$var$config = {
    // percentage distance from edge of container:
    startFromPercentage: 0.25,
    maxScrollAtPercentage: 0.05,
    // pixels per frame
    maxPixelScroll: 28,
    // A function used to ease a percentage value
    // A simple linear function would be: (percentage) => percentage;
    // percentage is between 0 and 1
    // result must be between 0 and 1
    ease: (percentage)=>Math.pow(percentage, 2),
    durationDampening: {
        // ms: how long to dampen the speed of an auto scroll from the start of a drag
        stopDampeningAt: 1200,
        // ms: when to start accelerating the reduction of duration dampening
        accelerateAt: 360
    }
};
var $372e7e4331f931a5$export$2e2bcd8739ae039 = $372e7e4331f931a5$var$config;

});


parcelRegister("h91se", function(module, exports) {

$parcel$export(module.exports, "default", () => $46ce8abe6474bdaa$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $8x8E3 = parcelRequire("8x8E3");

var $edWdS = parcelRequire("edWdS");

var $7vxL6 = parcelRequire("7vxL6");
const $46ce8abe6474bdaa$export$bf7199a9ebcb84a9 = ({ distanceToEdge: distanceToEdge, thresholds: thresholds, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening })=>{
    const scroll = (0, $7vxL6.getValueFromDistance)(distanceToEdge, thresholds);
    // not enough distance to trigger a minimum scroll
    // we can bail here
    if (scroll === 0) return 0;
    // Dampen an auto scroll speed based on duration of drag
    if (!shouldUseTimeDampening) return scroll;
    // Once we know an auto scroll should occur based on distance,
    // we must let at least 1px through to trigger a scroll event an
    // another auto scroll call
    return Math.max((0, $edWdS.dampenValueByTime)(scroll, dragStartTime), (0, $8x8E3.minScroll));
};
var $46ce8abe6474bdaa$export$2e2bcd8739ae039 = $46ce8abe6474bdaa$export$bf7199a9ebcb84a9;

});
parcelRegister("edWdS", function(module, exports) {

$parcel$export(module.exports, "dampenValueByTime", () => $b46522d5c480b17a$export$2fe468ff7a999ed6);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $2gHPS = parcelRequire("2gHPS");

var $8x8E3 = parcelRequire("8x8E3");

var $5yDwA = parcelRequire("5yDwA");
const $b46522d5c480b17a$var$accelerateAt = (0, $2gHPS.default).durationDampening.accelerateAt;
const $b46522d5c480b17a$var$stopAt = (0, $2gHPS.default).durationDampening.stopDampeningAt;
const $b46522d5c480b17a$export$2fe468ff7a999ed6 = (proposedScroll, dragStartTime)=>{
    const startOfRange = dragStartTime;
    const endOfRange = $b46522d5c480b17a$var$stopAt;
    const now = Date.now();
    const runTime = now - startOfRange;
    // we have finished the time dampening period
    if (runTime >= $b46522d5c480b17a$var$stopAt) return proposedScroll;
    // Up to this point we know there is a proposed scroll
    // but we have not reached our accelerate point
    // Return the minimum amount of scroll
    if (runTime < $b46522d5c480b17a$var$accelerateAt) return 0, $8x8E3.minScroll;
    const betweenAccelerateAtAndStopAtPercentage = (0, $5yDwA.getPercentage)({
        startOfRange: $b46522d5c480b17a$var$accelerateAt,
        endOfRange: endOfRange,
        current: runTime
    });
    const scroll = proposedScroll * (0, $2gHPS.default).ease(betweenAccelerateAtAndStopAtPercentage);
    return Math.ceil(scroll);
};

});
parcelRegister("5yDwA", function(module, exports) {

$parcel$export(module.exports, "getPercentage", () => $9599504fdea7da9c$export$6712e0f6cd0ea03);
// Source: https://github.com/atlassian/react-beautiful-dnd
const $9599504fdea7da9c$export$6712e0f6cd0ea03 = ({ startOfRange: startOfRange, endOfRange: endOfRange, current: current })=>{
    const range = endOfRange - startOfRange;
    if (range === 0) /**
		 * Detected distance range of 0 in the auto scroller
		 * This is unexpected and would cause a divide by 0 issue.
		 * Not allowing an auto scroll
		 */ return 0;
    const currentInRange = current - startOfRange;
    const percentage = currentInRange / range;
    return percentage;
};

});


parcelRegister("7vxL6", function(module, exports) {

$parcel$export(module.exports, "getValueFromDistance", () => $fa6f09f36cc6d31c$export$f3e495573a199c91);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $2gHPS = parcelRequire("2gHPS");

var $8x8E3 = parcelRequire("8x8E3");

var $5yDwA = parcelRequire("5yDwA");
const $fa6f09f36cc6d31c$export$f3e495573a199c91 = (distanceToEdge, thresholds)=>{
    /*
  // This function only looks at the distance to one edge
  // Example: looking at bottom edge
  |----------------------------------|
  |                                  |
  |                                  |
  |                                  |
  |                                  |
  |                                  | => no scroll in this range
  |                                  |
  |                                  |
  |  startScrollingFrom (eg 100px)   |
  |                                  |
  |                                  | => increased scroll value the closer to maxScrollValueAt
  |  maxScrollValueAt (eg 10px)      |
  |                                  | => max scroll value in this range
  |----------------------------------|
  */ // too far away to auto scroll
    if (distanceToEdge > thresholds.startScrollingFrom) return 0;
    // use max speed when on or over boundary
    if (distanceToEdge <= thresholds.maxScrollValueAt) return (0, $2gHPS.default).maxPixelScroll;
    // when just going on the boundary return the minimum integer
    if (distanceToEdge === thresholds.startScrollingFrom) return 0, $8x8E3.minScroll;
    // to get the % past startScrollingFrom we will calculate
    // the % the value is from maxScrollValueAt and then invert it
    const percentageFromMaxScrollValueAt = (0, $5yDwA.getPercentage)({
        startOfRange: thresholds.maxScrollValueAt,
        endOfRange: thresholds.startScrollingFrom,
        current: distanceToEdge
    });
    const percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
    const scroll = (0, $2gHPS.default).maxPixelScroll * (0, $2gHPS.default).ease(percentageFromStartScrollingFrom);
    // scroll will always be a positive integer
    return Math.ceil(scroll);
};

});





parcelRegister("2tkrf", function(module, exports) {

$parcel$export(module.exports, "default", () => $d272222f271a432a$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $g2R1U = parcelRequire("g2R1U");

var $elgbz = parcelRequire("elgbz");
var $d272222f271a432a$export$2e2bcd8739ae039 = ({ viewport: viewport, center: center, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening })=>{
    const scroll = (0, $elgbz.default)({
        dragStartTime: dragStartTime,
        container: viewport.container,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && (0, $g2R1U.canScrollWindow)(viewport, scroll) ? scroll : null;
};

});

parcelRegister("lVsVC", function(module, exports) {

$parcel$export(module.exports, "default", () => $3afd8185a3fe1873$export$2e2bcd8739ae039);

var $3YKxB = parcelRequire("3YKxB");

var $bsp0B = parcelRequire("bsp0B");

var $feNdz = parcelRequire("feNdz");
var $3afd8185a3fe1873$export$2e2bcd8739ae039 = ()=>{
    const scroll = (0, $feNdz.default)();
    const maxScroll = (0, $bsp0B.default)();
    const top = scroll.y;
    const left = scroll.x;
    // window.innerHeight: includes scrollbars (not what we want)
    // document.clientHeight gives us the correct value when using the html5 doctype
    const doc = document.documentElement;
    // Using these values as they do not consider scrollbars
    // padding box, without scrollbar
    const width = doc.clientWidth;
    const height = doc.clientHeight;
    // Computed
    const right = left + width;
    const bottom = top + height;
    const container = (0, $3YKxB.getRect)({
        top: top,
        left: left,
        right: right,
        bottom: bottom
    });
    const viewport = {
        container: container,
        scroll: {
            current: scroll,
            max: maxScroll
        }
    };
    return viewport;
};

});
parcelRegister("bsp0B", function(module, exports) {

$parcel$export(module.exports, "default", () => $e50ed177aa05ce5d$export$2e2bcd8739ae039);

var $bX8yW = parcelRequire("bX8yW");
var $e50ed177aa05ce5d$export$2e2bcd8739ae039 = ()=>{
    const doc = document.documentElement;
    const maxScroll = (0, $bX8yW.default)({
        // unclipped padding box, with scrollbar
        scrollHeight: doc.scrollHeight,
        scrollWidth: doc.scrollWidth,
        // clipped padding box, without scrollbar
        width: doc.clientWidth,
        height: doc.clientHeight
    });
    return maxScroll;
};

});
parcelRegister("bX8yW", function(module, exports) {

$parcel$export(module.exports, "default", () => $2927a2a5ef61b637$export$2e2bcd8739ae039);

var $72Pcv = parcelRequire("72Pcv");
var $2927a2a5ef61b637$export$2e2bcd8739ae039 = ({ scrollHeight: scrollHeight, scrollWidth: scrollWidth, height: height, width: width })=>{
    const maxScroll = (0, $72Pcv.subtract)(// full size
    {
        x: scrollWidth,
        y: scrollHeight
    }, // viewport size
    {
        x: width,
        y: height
    });
    const adjustedMaxScroll = {
        x: Math.max(0, maxScroll.x),
        y: Math.max(0, maxScroll.y)
    };
    return adjustedMaxScroll;
};

});


parcelRegister("feNdz", function(module, exports) {

$parcel$export(module.exports, "default", () => $31ea253008c58ece$export$2e2bcd8739ae039);
var // The browsers update document.documentElement.scrollTop and window.pageYOffset
// differently as the window scrolls.
// Webkit
// documentElement.scrollTop: no update. Stays at 0
// window.pageYOffset: updates to whole number
// Chrome
// documentElement.scrollTop: update with fractional value
// window.pageYOffset: update with fractional value
// FireFox
// documentElement.scrollTop: updates to whole number
// window.pageYOffset: updates to whole number
// IE11 (same as firefox)
// documentElement.scrollTop: updates to whole number
// window.pageYOffset: updates to whole number
// Edge (same as webkit)
// documentElement.scrollTop: no update. Stays at 0
// window.pageYOffset: updates to whole number
$31ea253008c58ece$export$2e2bcd8739ae039 = ()=>({
        x: window.pageXOffset,
        y: window.pageYOffset
    });

});





parcelRegister("fDXV9", function(module, exports) {

$parcel$export(module.exports, "useDragAnalytics", () => $5357a3fbb01800a4$export$660832909d6574f);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $7gWdR = parcelRequire("7gWdR");

var $8zOmE = parcelRequire("8zOmE");

const $5357a3fbb01800a4$export$5dd4ed888d5b12ca = ({ createAnalyticsEvent: createAnalyticsEvent, defaultIssueHierarchyLevel: defaultIssueHierarchyLevel })=>({
        onDragStart: ({ source: source })=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'dragStarted',
                actionSubject: 'card'
            });
            const isSubtask = !!source.data.cardIsSubtask;
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, {
                isDivider: source.data.type === 'DIVIDER',
                issueHierarchyLevel: isSubtask ? -1 : defaultIssueHierarchyLevel
            });
        },
        onDrop: ({ source: source, location: location })=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'dragEnded',
                actionSubject: 'card'
            });
            const isAbort = location.current.dropTargets.length === 0;
            const isRank = location.current.dropTargets[0]?.data.type === (0, $b6a5a61e3f2f3f09$export$4d4e6ab48cd5be5b);
            const isDivider = source.data.type === 'DIVIDER';
            // When moving from card list to epic/version panel cardListId wont exist in location.
            const isListMove = isDivider || typeof location.current.dropTargets[0]?.data.cardListId !== 'undefined' && location.current.dropTargets[0]?.data.cardListId !== source.data.cardListId;
            const isSubtask = !!source.data.cardIsSubtask;
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, {
                isDivider: isDivider,
                ...isAbort ? {
                    isAbort: isAbort
                } : {
                    isAbort: isAbort,
                    isRank: isRank,
                    isListMove: isListMove
                },
                issueHierarchyLevel: isSubtask ? -1 : defaultIssueHierarchyLevel
            });
        }
    });
function $5357a3fbb01800a4$export$660832909d6574f(defaultIssueHierarchyLevel) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>(0, $7gWdR.monitorForElements)($5357a3fbb01800a4$export$5dd4ed888d5b12ca({
            createAnalyticsEvent: createAnalyticsEvent,
            defaultIssueHierarchyLevel: defaultIssueHierarchyLevel
        })), [
        createAnalyticsEvent,
        defaultIssueHierarchyLevel
    ]);
}

});
const $b6a5a61e3f2f3f09$export$4d4e6ab48cd5be5b = 'CARD_DRAGGABLE_ID';


parcelRegister("5eblm", function(module, exports) {

$parcel$export(module.exports, "useInitEpicData", () => $053ba97b12ac7960$export$be92c37578cc55ba);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $ksXL1 = parcelRequire("ksXL1");

var $cuSOd = parcelRequire("cuSOd");

var $8zmNw = parcelRequire("8zmNw");

var $a4XJc = parcelRequire("a4XJc");

var $4R6GH = parcelRequire("4R6GH");

var $4xRpX = parcelRequire("4xRpX");

var $aCC3Y = parcelRequire("aCC3Y");

var $c1MAf = parcelRequire("c1MAf");

var $f9Swb = parcelRequire("f9Swb");

var $fSgHa = parcelRequire("fSgHa");

var $ks5Z4 = parcelRequire("ks5Z4");
const $053ba97b12ac7960$export$be92c37578cc55ba = (boardId)=>{
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const isCompanyManaged = (0, $fSgHa.useIsCMPBacklog)();
    const firstLevelHierarchyName = (0, $c1MAf.useBacklogSelector)((0, $f9Swb.getFirstLevelHierarchyName));
    const [isInitialised, { initState: initState, resetState: resetState, updateQueryState: updateQueryState, updateEpicsAttributes: updateEpicsAttributes }] = (0, $ksXL1.useEpicsStoreIsInitialised)();
    const [hasFullFetchStarted] = (0, $ksXL1.useHasFullFetchStarted)();
    let prefetch = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    if ((0, $4R6GH.fg)('prefetch-epics-data-backlog')) // eslint-disable-next-line react-hooks/rules-of-hooks
    prefetch = (0, $cuSOd.useEpicsPrefetch)({
        boardId: boardId,
        isCompanyManaged: isCompanyManaged
    }).prefetch;
    const { data: data, loading: loading, error: error } = (0, $4xRpX.useEpicQueryLite)(boardId, isCompanyManaged);
    const initData = (0, $5uXOq.useMemo)(()=>(0, $ks5Z4.transformLiteQueryData)(data, isCompanyManaged, firstLevelHierarchyName), [
        data,
        firstLevelHierarchyName,
        isCompanyManaged
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (error) updateEpicsAttributes({
            isLoading: false,
            hasError: true
        });
        updateQueryState({
            loading: loading,
            error: error
        });
    }, [
        loading,
        error,
        updateQueryState,
        updateEpicsAttributes
    ]);
    // Populate redux store with issue parents data
    (0, $5uXOq.useEffect)(()=>{
        if (isInitialised || loading) return;
        if (error) {
            dispatch((0, $aCC3Y.loadIssueParentsFailure)());
            return;
        }
        const issueParents = (0, $ks5Z4.getIssueParents)(initData.cards);
        issueParents && dispatch((0, $aCC3Y.loadIssueParentsSuccess)(issueParents));
    }, [
        initData,
        isInitialised,
        dispatch,
        loading,
        error
    ]);
    // Initialise epic store
    (0, $5uXOq.useEffect)(()=>{
        if (data && !loading && !isInitialised) initState({
            ...initData
        });
    }, [
        boardId,
        data,
        initData,
        initState,
        isCompanyManaged,
        isInitialised,
        loading
    ]);
    // Prefetch full epic details if the epic panel is open in the initial render
    if ((0, $4R6GH.fg)('prefetch-epics-data-backlog')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>{
        const { EPIC_PANEL: EPIC_PANEL } = (0, $8zmNw.getViewSettingsPanels)({
            boardId: boardId,
            view: (0, $a4XJc.View).BACKLOG
        });
        if (EPIC_PANEL && !hasFullFetchStarted) prefetch();
    }, [
        hasFullFetchStarted,
        prefetch,
        boardId
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            resetState();
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
};

});
parcelRegister("cuSOd", function(module, exports) {

$parcel$export(module.exports, "useEpicsRefetch", () => $67bcd1100649d2b7$export$3eab7b40883a6f84);
$parcel$export(module.exports, "useEpicsPrefetch", () => $67bcd1100649d2b7$export$5d46641887a1c5);

var $5uXOq = parcelRequire("5uXOq");

var $e3a3O = parcelRequire("e3a3O");

var $ksXL1 = parcelRequire("ksXL1");

var $fZneA = parcelRequire("fZneA");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $gk7Z3 = parcelRequire("gk7Z3");

var $4R6GH = parcelRequire("4R6GH");

var $dZggJ = parcelRequire("dZggJ");

var $eSUJA = parcelRequire("eSUJA");

var $5ZVKE = parcelRequire("5ZVKE");

var $6kSke = parcelRequire("6kSke");

var $5Hcmr = parcelRequire("5Hcmr");

var $jOahA = parcelRequire("jOahA");
const $67bcd1100649d2b7$var$UNMOUNTED_FETCH_ID = -1;
const $67bcd1100649d2b7$export$196aa12fac133e76 = ({ boardId: boardId, isCompanyManaged: isCompanyManaged })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({});
    const { refetch: refetch } = (0, $5ZVKE.useEpicDetailsQuery)({
        boardId: boardId,
        isCompanyManaged: isCompanyManaged
    });
    const fetchIdRef = (0, $5uXOq.useRef)(0);
    const [, { updateEpicsAttributes: updateEpicsAttributes, updateQueryState: updateQueryState }] = (0, $ksXL1.useEpicsStoreActions)();
    const fetchPage = (0, $5uXOq.useCallback)(async ({ onFetch: onFetch, fetchId: fetchId = fetchIdRef.current, startCursor: startCursor, count: count = 0 })=>{
        if (fetchId !== fetchIdRef.current) {
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'epicPanelRefetch aborted', {
                epicsCount: count
            });
            return;
        }
        if (!startCursor) (0, $5Hcmr.epicPanelPaginationMetric).start();
        try {
            const { data: data, errors: errors } = await refetch({
                boardId: String(boardId),
                isCompanyManaged: isCompanyManaged,
                pageSize: (0, $dZggJ.PAGE_SIZE),
                startCursor: startCursor
            });
            if (errors?.length) throw new (0, $e3a3O.ApolloError)({
                graphQLErrors: errors
            });
            const parents = data?.boardScope?.parents;
            const newCount = count + (parents?.edges?.length ?? 0);
            const hasNextPage = parents?.pageInfo?.hasNextPage ?? false;
            const endCursor = parents?.pageInfo?.endCursor;
            if (!startCursor) (0, $5Hcmr.epicPanelPaginationMetric).mark((0, $5Hcmr.BACKLOG_EPIC_PANEL_FIRST_CHUNK_END_MARK));
            if (!hasNextPage) {
                (0, $5Hcmr.epicPanelPaginationMetric).stop({
                    customData: {
                        isCompanyManaged: isCompanyManaged,
                        epicsCount: newCount
                    }
                });
                (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'epicPanelRefetch succeeded', {
                    // Kept for investigation purposes in Splunk
                    epicsCount: newCount
                });
                // Separate event to avoid high cardinality
                (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'epicPanelRefetch bucket', {
                    bucket: (0, $jOahA.mapEpicsCountToBucket)(newCount)
                });
            }
            onFetch(parents, count);
            hasNextPage && endCursor && fetchPage({
                onFetch: onFetch,
                fetchId: fetchId,
                startCursor: endCursor,
                count: newCount
            });
        } catch (error) {
            if (!(error instanceof Error) || fetchIdRef.current === $67bcd1100649d2b7$var$UNMOUNTED_FETCH_ID) /**
					 * there is a case where refetch still runs after the epic panel is unmounted which
					 * throws an error, but we ignore this case.
					 * https://github.com/apollographql/react-apollo/issues/3862
					 *
					 * We still throw any other errors for the error boundary to catch.
					 */ return;
            // erroring epic cards in the panel that have yet to be loaded
            updateEpicsAttributes({
                isLoading: false,
                hasError: true
            }, count);
            (0, $5Hcmr.epicPanelPaginationMetric).cancel();
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'epicPanelRefetch failed', {
                epicsCount: count,
                error: error,
                isClientFetchError: (0, $fZneA.isClientFetchError)(error) || (0, $gk7Z3.isHttpClientErrorResponse)(error)
            });
            if (error instanceof (0, $e3a3O.ApolloError)) updateQueryState({
                refetchError: error
            });
            else throw error;
        }
    }, [
        analyticsEvent,
        boardId,
        isCompanyManaged,
        refetch,
        updateEpicsAttributes,
        updateQueryState
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            fetchIdRef.current = $67bcd1100649d2b7$var$UNMOUNTED_FETCH_ID;
        }, []);
    return {
        fetch: ({ onFetch: onFetch })=>fetchPage({
                onFetch: onFetch,
                fetchId: ++fetchIdRef.current
            })
    };
};
const $67bcd1100649d2b7$export$3eab7b40883a6f84 = ()=>{
    const [hasFullFetchStarted, { updateQueryState: updateQueryState, updateEpics: updateEpics, updateEpicsAttributes: updateEpicsAttributes, updateHasFullFetchStarted: updateHasFullFetchStarted }] = (0, $ksXL1.useHasFullFetchStarted)();
    const [hasStartedFullFetchOld, setHasStartedFullFetchOld] = (0, $5uXOq.useState)(false);
    const { boardId: boardId, isCompanyManaged: isCompanyManaged } = (0, $eSUJA.usePanelData)();
    const { fetch: fetch } = $67bcd1100649d2b7$export$196aa12fac133e76({
        boardId: boardId,
        isCompanyManaged: isCompanyManaged
    });
    const updateEpicsStore = (0, $5uXOq.useCallback)((parents, startIndex)=>{
        const updatedCards = parents?.edges?.flatMap((edge)=>edge?.node ? (0, $6kSke.transformFullCard)(edge.node) : []) ?? [];
        updateEpics({
            updatedCards: updatedCards,
            startIndex: startIndex,
            hasNextPage: parents?.pageInfo.hasNextPage ?? false
        });
    }, [
        updateEpics
    ]);
    const fetchData = (0, $5uXOq.useCallback)(({ triggerLoadingState: triggerLoadingState = false } = {})=>{
        if ((0, $4R6GH.fg)('prefetch-epics-data-backlog')) updateHasFullFetchStarted(true);
        else setHasStartedFullFetchOld(true);
        updateQueryState({
            error: undefined,
            refetchError: undefined
        });
        triggerLoadingState && updateEpicsAttributes({
            isLoading: true
        });
        fetch({
            onFetch: updateEpicsStore
        });
    }, [
        updateQueryState,
        updateEpicsAttributes,
        fetch,
        updateEpicsStore,
        updateHasFullFetchStarted
    ]);
    return {
        refetch: fetchData,
        hasFullFetched: (0, $4R6GH.fg)('prefetch-epics-data-backlog') ? hasFullFetchStarted : hasStartedFullFetchOld
    };
};
const $67bcd1100649d2b7$export$5d46641887a1c5 = ({ boardId: boardId, isCompanyManaged: isCompanyManaged })=>{
    const { fetch: fetch } = $67bcd1100649d2b7$export$196aa12fac133e76({
        boardId: boardId,
        isCompanyManaged: isCompanyManaged
    });
    const [hasFullFetchStarted, { updateQueryState: updateQueryState, updateEpics: updateEpics, updateHasFullFetchStarted: updateHasFullFetchStarted }] = (0, $ksXL1.useHasFullFetchStarted)();
    const updateEpicsStore = (0, $5uXOq.useCallback)((parents, startIndex)=>{
        const updatedCards = parents?.edges?.flatMap((edge)=>edge?.node ? (0, $6kSke.transformFullCard)(edge.node) : []) ?? [];
        updateEpics({
            updatedCards: updatedCards,
            startIndex: startIndex,
            hasNextPage: parents?.pageInfo.hasNextPage ?? false
        });
        updateQueryState({
            loading: false
        });
    }, [
        updateEpics,
        updateQueryState
    ]);
    const prefetchData = (0, $5uXOq.useCallback)(()=>{
        updateHasFullFetchStarted(true);
        updateQueryState({
            loading: true,
            error: undefined,
            refetchError: undefined
        });
        fetch({
            onFetch: updateEpicsStore
        });
    }, [
        updateQueryState,
        fetch,
        updateEpicsStore,
        updateHasFullFetchStarted
    ]);
    return {
        hasFullFetchStarted: hasFullFetchStarted,
        prefetch: prefetchData
    };
};

});
parcelRegister("6kSke", function(module, exports) {

$parcel$export(module.exports, "transformFullCard", () => $488d6951ad97ea77$export$7b09839985806501);

var $kQZsR = parcelRequire("kQZsR");

var $4R6GH = parcelRequire("4R6GH");
const $488d6951ad97ea77$var$isEpicLoadingBecauseOfOptimisticCreation = (epicId)=>Number(epicId) < 0;
const $488d6951ad97ea77$export$ac8d104fa0f53892 = (estimation)=>{
    const { details: { estimationType: estimationType, name: name }, childrenEstimationStats: { doneEstimate: doneEstimate, totalEstimate: totalEstimate, percentageCompleted: percentageCompleted, notEstimated: notEstimated } } = estimation;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($kQZsR)))(estimationType) || (0, (/*@__PURE__*/$parcel$interopDefault($kQZsR)))(name) || (0, (/*@__PURE__*/$parcel$interopDefault($kQZsR)))(doneEstimate) || (0, (/*@__PURE__*/$parcel$interopDefault($kQZsR)))(totalEstimate) || (0, (/*@__PURE__*/$parcel$interopDefault($kQZsR)))(percentageCompleted) || (0, (/*@__PURE__*/$parcel$interopDefault($kQZsR)))(notEstimated)) return null;
    return {
        estimationType: estimationType,
        name: name,
        doneEstimate: doneEstimate,
        totalEstimate: totalEstimate,
        percentageCompleted: percentageCompleted / 100,
        notEstimated: notEstimated
    };
};
const $488d6951ad97ea77$export$7b09839985806501 = ({ id: id, key: key, summary: summary, color: color, childrenInfo: childrenInfo, estimationInfo: estimationInfo, startDate: startDate, dueDate: dueDate })=>{
    const epicData = {
        id: Number(id),
        key: key,
        name: summary,
        color: (0, (/*@__PURE__*/$parcel$interopDefault($kQZsR)))(color) ? undefined : color,
        isLoading: (0, $4R6GH.fg)('prefetch-epics-data-backlog') ? undefined : $488d6951ad97ea77$var$isEpicLoadingBecauseOfOptimisticCreation(id),
        hasError: false,
        startDate: (0, (/*@__PURE__*/$parcel$interopDefault($kQZsR)))(startDate) ? undefined : startDate,
        dueDate: (0, (/*@__PURE__*/$parcel$interopDefault($kQZsR)))(dueDate) ? undefined : dueDate
    };
    const { todoStats: todoStats, inProgressStats: inProgressStats, doneStats: doneStats } = childrenInfo || {};
    const toDo = todoStats && !(0, (/*@__PURE__*/$parcel$interopDefault($kQZsR)))(todoStats.issueCount) ? todoStats.issueCount : 0;
    const inProgress = inProgressStats && !(0, (/*@__PURE__*/$parcel$interopDefault($kQZsR)))(inProgressStats.issueCount) ? inProgressStats.issueCount : 0;
    const done = doneStats && !(0, (/*@__PURE__*/$parcel$interopDefault($kQZsR)))(doneStats.issueCount) ? doneStats.issueCount : 0;
    return {
        epic: epicData,
        progress: {
            status: {
                toDo: {
                    issueCount: toDo
                },
                inProgress: {
                    issueCount: inProgress
                },
                done: {
                    issueCount: done
                }
            },
            totalIssues: toDo + inProgress + done
        },
        estimation: estimationInfo ? $488d6951ad97ea77$export$ac8d104fa0f53892(estimationInfo) : null
    };
};

});
parcelRegister("kQZsR", function(module, exports) {
/**
 * Checks if `value` is `null`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
 * @example
 *
 * _.isNull(null);
 * // => true
 *
 * _.isNull(void 0);
 * // => false
 */ function $f2e8578be8331871$var$isNull(value) {
    return value === null;
}
module.exports = $f2e8578be8331871$var$isNull;

});


parcelRegister("5Hcmr", function(module, exports) {

$parcel$export(module.exports, "setBacklogEpicPanelLoadStartMark", () => $0601c3eb5349c4a9$export$49f1574259ee6703);
$parcel$export(module.exports, "setBacklogEpicPanelLoadCancelMark", () => $0601c3eb5349c4a9$export$39df2b01594d3328);
$parcel$export(module.exports, "setBacklogEpicPanelLoadStopMark", () => $0601c3eb5349c4a9$export$42088bebafcba64c);
$parcel$export(module.exports, "BACKLOG_EPIC_PANEL_FIRST_CHUNK_END_MARK", () => $0601c3eb5349c4a9$export$d6d456cfea80cd);
$parcel$export(module.exports, "epicPanelPaginationMetric", () => $0601c3eb5349c4a9$export$cf16b273af91bf79);

var $dGrdR = parcelRequire("dGrdR");
const $0601c3eb5349c4a9$export$369befba14e9571a = (0, $dGrdR.metrics).custom({
    key: 'backlog-epic-panel-load'
});
const $0601c3eb5349c4a9$export$49f1574259ee6703 = ()=>{
    $0601c3eb5349c4a9$export$369befba14e9571a.start();
};
const $0601c3eb5349c4a9$export$39df2b01594d3328 = ()=>{
    $0601c3eb5349c4a9$export$369befba14e9571a.cancel();
};
const $0601c3eb5349c4a9$export$42088bebafcba64c = (isCompanyManaged)=>{
    $0601c3eb5349c4a9$export$369befba14e9571a.stop({
        customData: {
            isCompanyManaged: isCompanyManaged
        }
    });
};
const $0601c3eb5349c4a9$export$d6d456cfea80cd = 'FIRST_CHUNK_END_MARK';
const $0601c3eb5349c4a9$export$cf16b273af91bf79 = (0, $dGrdR.metrics).custom({
    key: 'epic-panel-pagination-load',
    histogram: {
        duration: '1000_2000_3000_4000_5000_7000_10000'
    },
    timings: [
        {
            key: 'first-chunk-load',
            endMark: $0601c3eb5349c4a9$export$d6d456cfea80cd
        }
    ]
});

});

parcelRegister("jOahA", function(module, exports) {

$parcel$export(module.exports, "mapEpicsCountToBucket", () => $7710e9c4eeff28a3$export$92d984d0a2097213);
const $7710e9c4eeff28a3$var$EPICS_COUNT_BUCKETS = [
    0,
    10,
    20,
    30,
    50,
    100,
    200,
    500
];
const $7710e9c4eeff28a3$export$92d984d0a2097213 = (epicsCount)=>{
    if (epicsCount === 0) return '0';
    const bucketIndex = $7710e9c4eeff28a3$var$EPICS_COUNT_BUCKETS.findIndex((bucket)=>epicsCount <= bucket);
    return bucketIndex >= 0 ? `${$7710e9c4eeff28a3$var$EPICS_COUNT_BUCKETS[bucketIndex - 1]}_${$7710e9c4eeff28a3$var$EPICS_COUNT_BUCKETS[bucketIndex]}` : '500+';
};

});


parcelRegister("4xRpX", function(module, exports) {

$parcel$export(module.exports, "useEpicQueryLite", () => $c29b91030b35fa03$export$8bc41fa6ebe01467);

var $5tTFS = parcelRequire("5tTFS");

var $5cllN = parcelRequire("5cllN");

var $hcKre = parcelRequire("hcKre");
const $c29b91030b35fa03$export$446e7345ee07982d = (0, $5cllN.default)`
    ${(0, $hcKre.timeTrackingOptionsFragment)}
    ${(0, $hcKre.epicLiteFragment)}
    ${(0, $hcKre.projectLocationFragment)}
    ${(0, $hcKre.issueParentTypeConfigFragment)}
    ${(0, $hcKre.boardFragment)}
    query EpicsLite($boardId: ID!, $isCompanyManaged: Boolean!) {
        jira @include(if: $isCompanyManaged) {
            timeTrackingOptions {
                ...TimeTrackingOptionsFragment
            }
        }
        boardScope(boardId: $boardId, isCMP: $isCompanyManaged) {
            parents {
                edges {
                    node {
                        ...IssueParentLiteFragment
                    }
                }
            }
            board @include(if: $isCompanyManaged) {
                ...BoardFragment
            }
            projectLocation @skip(if: $isCompanyManaged) {
                ...ProjectLocationFragment
            }
        }
        globalConfig @include(if: $isCompanyManaged) {
            issueParentTypeConfig {
                ...IssueParentTypeConfigFragment
            }
        }
    }
`;
const $c29b91030b35fa03$export$8bc41fa6ebe01467 = (boardId, isCompanyManaged)=>(0, $5tTFS.useQuery)($c29b91030b35fa03$export$446e7345ee07982d, {
        skip: false,
        context: {
            headers: {
                'is-company-managed-board': isCompanyManaged
            }
        },
        variables: {
            boardId: String(boardId),
            isCompanyManaged: isCompanyManaged
        },
        fetchPolicy: 'network-only'
    });

});
parcelRegister("hcKre", function(module, exports) {

$parcel$export(module.exports, "projectLocationFragment", () => $cce6a4edb0555822$export$25c256efca3597d1);
$parcel$export(module.exports, "timeTrackingOptionsFragment", () => $cce6a4edb0555822$export$ad6d7391facb841b);
$parcel$export(module.exports, "epicLiteFragment", () => $cce6a4edb0555822$export$ee1de0b7a9498416);
$parcel$export(module.exports, "issueParentTypeConfigFragment", () => $cce6a4edb0555822$export$9d88616d202f6817);
$parcel$export(module.exports, "boardFragment", () => $cce6a4edb0555822$export$e1c6fa95c54eabf5);

var $5cllN = parcelRequire("5cllN");
const $cce6a4edb0555822$export$25c256efca3597d1 = (0, $5cllN.default)`
    fragment ProjectLocationFragment on Project {
        id
        issueTypes {
            id
            name
            hierarchyLevelType
            iconUrl
            hasRequiredFields
        }
    }
`;
const $cce6a4edb0555822$export$ad6d7391facb841b = (0, $5cllN.default)`
    fragment TimeTrackingOptionsFragment on TimeTrackingOptions {
        workingHoursPerDay
        workingDaysPerWeek
        defaultUnit
        timeFormat
    }
`;
const $cce6a4edb0555822$export$ee1de0b7a9498416 = (0, $5cllN.default)`
    fragment IssueParentLiteFragment on IssueParent {
        id
        key
        summary
        color
        issueTypeDetails {
            id
            name
            iconUrl
        }
    }
`;
const $cce6a4edb0555822$export$9d88616d202f6817 = (0, $5cllN.default)`
    fragment IssueParentTypeConfigFragment on IssueParentTypeConfig {
        id
        name
        iconUrl
        hierarchyLevelType
    }
`;
const $cce6a4edb0555822$export$e1c6fa95c54eabf5 = (0, $5cllN.default)`
    fragment BoardFragment on Board {
        rankCustomFieldId
    }
`;

});


parcelRegister("ks5Z4", function(module, exports) {

$parcel$export(module.exports, "transformLiteQueryData", () => $d53069394b467672$export$af76d046c1d42215);
$parcel$export(module.exports, "getIssueParents", () => $d53069394b467672$export$df9259146e40d32c);

var $dfl35 = parcelRequire("dfl35");

var $kQZsR = parcelRequire("kQZsR");

var $7SCny = parcelRequire("7SCny");

var $g4tDr = parcelRequire("g4tDr");

var $4R6GH = parcelRequire("4R6GH");

var $guzeq = parcelRequire("guzeq");
const $d53069394b467672$var$RANK_DISABLED_ID = '0';
const $d53069394b467672$var$EMPTY_ISSUE_TYPE = {
    name: '',
    iconUrl: '',
    id: ''
};
const $d53069394b467672$export$66ccee7e75897cc1 = ({ id: id, key: key, summary: summary, color: color, issueTypeDetails: issueTypeDetails }, defaultIssueType)=>{
    const epicData = {
        id: Number(id),
        key: key,
        name: summary,
        color: (0, (/*@__PURE__*/$parcel$interopDefault($kQZsR)))(color) ? undefined : color,
        issueType: (0, (/*@__PURE__*/$parcel$interopDefault($dfl35)))({
            name: issueTypeDetails?.name,
            iconUrl: issueTypeDetails?.iconUrl,
            id: issueTypeDetails?.id
        }, {
            name: defaultIssueType?.name,
            iconUrl: defaultIssueType?.iconUrl,
            id: defaultIssueType?.id
        }, $d53069394b467672$var$EMPTY_ISSUE_TYPE),
        isLoading: (0, $4R6GH.fg)('prefetch-epics-data-backlog') ? undefined : true,
        hasError: false
    };
    return {
        epic: epicData,
        progress: {
            status: {
                toDo: {
                    issueCount: 0
                },
                inProgress: {
                    issueCount: 0
                },
                done: {
                    issueCount: 0
                }
            },
            totalIssues: 0
        }
    };
};
const $d53069394b467672$export$af76d046c1d42215 = (data, isCompanyManaged, firstLevelHierarchyName)=>{
    const globalConfig = data?.globalConfig;
    const board = data?.boardScope?.board;
    let isEpicIssueTypeAvailable = false;
    let epicIssueType;
    let epicIssueTypeName = (0, $guzeq.DEFAULT_PARENT_ISSUE_TYPE_NAME);
    const cards = data?.boardScope?.parents?.edges?.flatMap((edge)=>edge?.node ? $d53069394b467672$export$66ccee7e75897cc1(edge.node, globalConfig?.issueParentTypeConfig) : []) ?? [];
    if (isCompanyManaged) {
        isEpicIssueTypeAvailable = globalConfig?.issueParentTypeConfig.hierarchyLevelType === (0, $g4tDr.PARENT_HIERARCHY_TYPE);
        epicIssueType = globalConfig?.issueParentTypeConfig;
        epicIssueTypeName = firstLevelHierarchyName || globalConfig?.issueParentTypeConfig.name || (0, $guzeq.DEFAULT_PARENT_ISSUE_TYPE_NAME);
    } else {
        epicIssueType = data?.boardScope?.projectLocation?.issueTypes.find(({ hierarchyLevelType: hierarchyLevelType })=>hierarchyLevelType === (0, $g4tDr.PARENT_HIERARCHY_TYPE));
        isEpicIssueTypeAvailable = Boolean(epicIssueType);
        if (epicIssueType) epicIssueTypeName = epicIssueType.name;
    }
    return {
        cards: cards,
        isEpicIssueTypeAvailable: isEpicIssueTypeAvailable,
        epicIssueType: {
            id: epicIssueType?.id ?? 0,
            name: epicIssueTypeName,
            hasRequiredFields: epicIssueType?.hasRequiredFields ?? false
        },
        epicIssueTypeName: epicIssueTypeName,
        ...data?.jira && {
            timeTrackingOptions: data.jira.timeTrackingOptions
        },
        isRankingEnabled: board?.rankCustomFieldId ? board.rankCustomFieldId !== $d53069394b467672$var$RANK_DISABLED_ID : true
    };
};
const $d53069394b467672$export$df9259146e40d32c = (cards)=>cards.map(({ epic: issueParent })=>{
        return {
            id: String(issueParent.id),
            key: issueParent.key,
            summary: issueParent.name,
            issueType: {
                id: String(issueParent?.issueType?.id) || '',
                name: issueParent?.issueType?.name || '',
                iconUrl: issueParent?.issueType?.iconUrl || ''
            },
            color: issueParent.color || (0, $7SCny.COLORS)[0]
        };
    });

});
parcelRegister("dfl35", function(module, exports) {

var $g7i7g = parcelRequire("g7i7g");

var $dGT4U = parcelRequire("dGT4U");

var $4rDUz = parcelRequire("4rDUz");

var $lbyKY = parcelRequire("lbyKY");
/** Used for built-in method references. */ var $9a4d00e997b9e158$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9a4d00e997b9e158$var$hasOwnProperty = $9a4d00e997b9e158$var$objectProto.hasOwnProperty;
/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */ var $9a4d00e997b9e158$var$defaults = $g7i7g(function(object, sources) {
    object = Object(object);
    var index = -1;
    var length = sources.length;
    var guard = length > 2 ? sources[2] : undefined;
    if (guard && $4rDUz(sources[0], sources[1], guard)) length = 1;
    while(++index < length){
        var source = sources[index];
        var props = $lbyKY(source);
        var propsIndex = -1;
        var propsLength = props.length;
        while(++propsIndex < propsLength){
            var key = props[propsIndex];
            var value = object[key];
            if (value === undefined || $dGT4U(value, $9a4d00e997b9e158$var$objectProto[key]) && !$9a4d00e997b9e158$var$hasOwnProperty.call(object, key)) object[key] = source[key];
        }
    }
    return object;
});
module.exports = $9a4d00e997b9e158$var$defaults;

});



parcelRegister("cc2av", function(module, exports) {

$parcel$export(module.exports, "VersionsPanelWithErrorBoundary", () => $dc3d37d20a3c6e6b$export$d6f535b626aa9a12);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $7CMCs = parcelRequire("7CMCs");

var $iXVV6 = parcelRequire("iXVV6");

var $eSUJA = parcelRequire("eSUJA");


var $hGRp0 = parcelRequire("hGRp0");

var $iQClv = parcelRequire("iQClv");

var $4GPQ6 = parcelRequire("4GPQ6");

var $c1MAf = parcelRequire("c1MAf");

var $lDDqj = parcelRequire("lDDqj");

var $fSgHa = parcelRequire("fSgHa");

var $kuePT = parcelRequire("kuePT");

var $e2Elo = parcelRequire("e2Elo");
const $dc3d37d20a3c6e6b$export$c91390ee18658a60 = (props)=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject, stopMetric: stopMetric } = (0, $5uXOq.useContext)((0, $4GPQ6.VersionPanelEntrypointContext));
    const isVersionsOpen = (0, $kuePT.useIsVersionsPanelOpen)();
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            ...props,
            onReady: stopMetric
        }), [
        props,
        stopMetric
    ]);
    const isCompanyManaged = (0, $fSgHa.useIsCMPBacklog)();
    const sourceDroppableType = (0, $c1MAf.useBacklogSelector)((0, $lDDqj.getSourceDroppableType));
    return isVersionsOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e2Elo.PanelWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            analyticsSource: (0, $f9ec0e1408d9f044$export$71b7a97b7c858c63)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eSUJA.PanelDataProvider), {
        sourceDroppableType: sourceDroppableType,
        isCompanyManaged: isCompanyManaged,
        boardId: props.boardId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jira.backlog.version.panel",
        packageName: "jiraSoftwareVersionBacklogPanelRelay",
        errorFallback: "flag",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hGRp0.LoadingSkeleton), null),
        runtimeProps: runtimeProps
    })))) : null;
};
const $dc3d37d20a3c6e6b$export$d6f535b626aa9a12 = (props)=>{
    const { fireErrorBoundaryExperienceFail: fireErrorBoundaryExperienceFail } = (0, $iQClv.useViewVersionPanelExperienceTracker)({
        isClassic: props.isCompanyManaged
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iQClv.VersionBacklogPanelExperienceStart), {
        experienceId: `${props.boardId}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "backlogContentVersionsPanel",
        packageName: "software-backlog",
        fallback: "flag",
        onError: fireErrorBoundaryExperienceFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dc3d37d20a3c6e6b$export$c91390ee18658a60, props)));
};

});
const $f9ec0e1408d9f044$export$d76071d5de2774fc = 'version-panel';
const $f9ec0e1408d9f044$export$28ad8b364940d9aa = 'VERSION-';
const $f9ec0e1408d9f044$export$71b7a97b7c858c63 = 'version-panel';
const $f9ec0e1408d9f044$export$b8b9d90f9e5bd72b = 'jiraSoftwareVersionBacklogPanelRelay';

parcelRegister("hGRp0", function(module, exports) {

$parcel$export(module.exports, "LoadingSkeleton", () => $165a74bd05c9838d$export$44c18d210d5de37b);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");

var $3WsOp = parcelRequire("3WsOp");
const $165a74bd05c9838d$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "software-version-backlog-panel-relay.common.loading-skeleton.title",
        "defaultMessage": "Versions"
    }
});
const $165a74bd05c9838d$export$44c18d210d5de37b = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3WsOp.default), {
        title: formatMessage($165a74bd05c9838d$var$messages.title),
        onClose: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        justifyContent: "center",
        xcss: $165a74bd05c9838d$var$loadingWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "medium"
    })));
};
const $165a74bd05c9838d$var$loadingWrapper = (0, $8CUq3.xcss)({
    paddingBlock: 'space.600'
});

});

parcelRegister("iQClv", function(module, exports) {

$parcel$export(module.exports, "ASSIGN_ABORT_PERMISSION", () => $ccbcd70726f763d5$export$a7086850d534ca7c);
$parcel$export(module.exports, "ASSIGN_ABORT_CROSS_PROJECT", () => $ccbcd70726f763d5$export$2c16bbee73016c79);
$parcel$export(module.exports, "UNASSIGN_ABORT_PERMISSION", () => $ccbcd70726f763d5$export$4a65d324cd30dfb7);
$parcel$export(module.exports, "useViewVersionPanelExperienceTracker", () => $ccbcd70726f763d5$export$aa37233cd44da53c);
$parcel$export(module.exports, "VersionBacklogPanelExperienceStart", () => $ccbcd70726f763d5$export$792847156522cd4d);
$parcel$export(module.exports, "VersionBacklogPanelExperienceSuccessTracker", () => $ccbcd70726f763d5$export$af4d2f7ac24077d1);
$parcel$export(module.exports, "useAssignExperienceTracker", () => $ccbcd70726f763d5$export$e087867f6020c859);
$parcel$export(module.exports, "useUnassignExperienceTracker", () => $ccbcd70726f763d5$export$cb1163ce9c396ad5);

var $5uXOq = parcelRequire("5uXOq");

var $a6ebl = parcelRequire("a6ebl");

var $evKjT = parcelRequire("evKjT");

var $4MGZC = parcelRequire("4MGZC");

const $ccbcd70726f763d5$export$d95354974e5f5020 = 'viewVersionBacklogPanel';
const $ccbcd70726f763d5$export$4669ca9d7c97effc = 'assignVersionPanel';
const $ccbcd70726f763d5$export$a7086850d534ca7c = 'ASSIGN_PERMISSION';
const $ccbcd70726f763d5$export$2c16bbee73016c79 = 'ASSIGN_CROSS_PROJECT';
const $ccbcd70726f763d5$export$1eb1042763fdc7c3 = 'unassignVersionPanel';
const $ccbcd70726f763d5$export$4a65d324cd30dfb7 = 'UNASSIGN_PERMISSION';
const $ccbcd70726f763d5$export$aa37233cd44da53c = (attributes = {})=>(0, $a6ebl.useExperienceTracker)((0, $f9ec0e1408d9f044$export$d76071d5de2774fc), $ccbcd70726f763d5$export$d95354974e5f5020, (0, $f9ec0e1408d9f044$export$71b7a97b7c858c63), attributes);
const $ccbcd70726f763d5$export$792847156522cd4d = ({ experienceId: experienceId = (0, $f9ec0e1408d9f044$export$d76071d5de2774fc) })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $evKjT.SoftwareExperienceStart), {
        experienceId: experienceId,
        experience: $ccbcd70726f763d5$export$d95354974e5f5020,
        analyticsSource: (0, $f9ec0e1408d9f044$export$71b7a97b7c858c63)
    });
const $ccbcd70726f763d5$export$af4d2f7ac24077d1 = ({ attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4MGZC.SoftwareExperienceSuccess), {
        experience: $ccbcd70726f763d5$export$d95354974e5f5020,
        attributes: attributes
    });
const $ccbcd70726f763d5$export$e087867f6020c859 = (attributes = {})=>(0, $a6ebl.useExperienceTracker)((0, $f9ec0e1408d9f044$export$d76071d5de2774fc), $ccbcd70726f763d5$export$4669ca9d7c97effc, (0, $f9ec0e1408d9f044$export$71b7a97b7c858c63), attributes);
const $ccbcd70726f763d5$export$cb1163ce9c396ad5 = (attributes = {})=>(0, $a6ebl.useExperienceTracker)((0, $f9ec0e1408d9f044$export$d76071d5de2774fc), $ccbcd70726f763d5$export$1eb1042763fdc7c3, (0, $f9ec0e1408d9f044$export$71b7a97b7c858c63), attributes);

});
parcelRegister("evKjT", function(module, exports) {

$parcel$export(module.exports, "SoftwareExperienceStart", () => $b3e565df34dd9264$export$e18be0cd3b92dda1);

var $5uXOq = parcelRequire("5uXOq");

var $kaHBi = parcelRequire("kaHBi");

var $efvDm = parcelRequire("efvDm");

var $k9JTq = parcelRequire("k9JTq");
const $b3e565df34dd9264$export$e18be0cd3b92dda1 = ({ experienceId: experienceId, experience: experience, analyticsSource: analyticsSource })=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kaHBi.ExperienceStart), {
        experienceId: experienceId,
        experience: experience,
        analyticsSource: analyticsSource,
        edition: appEditions.software,
        application: (0, $efvDm.JIRA_SOFTWARE)
    });
};

});

parcelRegister("4MGZC", function(module, exports) {

$parcel$export(module.exports, "SoftwareExperienceSuccess", () => $02ad6433b9e23713$export$a06ece3d589f4c88);

var $5uXOq = parcelRequire("5uXOq");

var $3bQtK = parcelRequire("3bQtK");

var $gk7Z3 = parcelRequire("gk7Z3");
const $02ad6433b9e23713$export$a06ece3d589f4c88 = ({ experience: experience, attributes: attributes })=>{
    const experienceAttributes = (0, $5uXOq.useMemo)(()=>(0, $gk7Z3.createCommonAttributes)(attributes), [
        attributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bQtK.ExperienceSuccess), {
        experience: experience,
        attributes: experienceAttributes
    });
};

});





parcelRegister("2jVnP", function(module, exports) {

$parcel$export(module.exports, "BulkOperationsLoader", () => $3a6155dc05042d97$export$3af81192d3c2a190);

var $5uXOq = parcelRequire("5uXOq");

var $6aXrw = parcelRequire("6aXrw");

var $acDhY = parcelRequire("acDhY");

var $6s1PB = parcelRequire("6s1PB");

var $3lQDd = parcelRequire("3lQDd");

var $3bmrC = parcelRequire("3bmrC");

var $eSSqy = parcelRequire("eSSqy");

var $7X18B = parcelRequire("7X18B");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $45Qwd = parcelRequire("45Qwd");

var $1z1J7 = parcelRequire("1z1J7");

var $3VzmQ = parcelRequire("3VzmQ");

var $4RzmK = parcelRequire("4RzmK");

var $tDHjp = parcelRequire("tDHjp");
const $3a6155dc05042d97$export$3a055e4082f2e2d5 = ()=>(0, $c1MAf.useBacklogSelector)((0, $dGljH.getSelectedCards));
const $3a6155dc05042d97$export$fad9b4c285937b2c = ()=>(0, $c1MAf.useBacklogSelector)((0, $1z1J7.canBulkEditIssues));
const $3a6155dc05042d97$export$9af2fbf60e113c02 = ()=>(0, $c1MAf.useBacklogSelector)((0, $dGljH.getVisibleCardIds));
const $3a6155dc05042d97$export$2b501a9ab802e6f9 = ()=>(0, $c1MAf.useBacklogSelector)((0, $45Qwd.getEstimationFieldId));
const $3a6155dc05042d97$export$70c1fca7746d50c3 = ()=>(0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
const $3a6155dc05042d97$export$3af81192d3c2a190 = ({ bulkOperationsForm: bulkOperationsForm, onOpenSidebar: onOpenSidebar, onCloseSidebar: onCloseSidebar })=>{
    const shouldShowCheckbox = (0, $3VzmQ.useShowCheckbox)();
    const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: entryPointActions } = (0, $acDhY.useBulkOpsEntryPoint)();
    const selectedCardIds = $3a6155dc05042d97$export$3a055e4082f2e2d5();
    const hasBulkEditPermission = $3a6155dc05042d97$export$fad9b4c285937b2c();
    const cardEntities = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCards));
    const visibleCardIds = $3a6155dc05042d97$export$9af2fbf60e113c02();
    const { selectAllVisible: selectAllVisible, clearAll: clearAll, clearAllVisible: clearAllVisible, extraAnalyticsAttributes: extraAnalyticsAttributes } = (0, $tDHjp.useSelectActions)();
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const estimationFieldId = $3a6155dc05042d97$export$2b501a9ab802e6f9();
    const isCMP = $3a6155dc05042d97$export$70c1fca7746d50c3();
    const { openIssueView: openIssueView, closeIssueView: closeIssueView } = (0, $3bmrC.useCloseIssueViewOnBulkOpsEdit)();
    const optimisticId = (0, $5uXOq.useRef)();
    const currentBulkOperationType = (0, $5uXOq.useRef)();
    const useAgentPickerActions = (0, $3lQDd.useFloatingtoolbarPickerContentAction)(selectedCardIds.map(String));
    const onUpdateStart = (0, $5uXOq.useCallback)((payload)=>{
        const cardsData = payload.map(({ issueIds: issueIds, data: data })=>{
            const issuesData = (0, $4RzmK.getBulkOperationsData)({
                data: data,
                estimationFieldId: estimationFieldId,
                isCMP: isCMP
            });
            return {
                cardIds: issueIds,
                data: issuesData
            };
        });
        const bulkOperationType = payload[0]?.bulkOperationType;
        const action = bulkOperationType === 'BULK_DELETE' && (0, $6s1PB.expVal)('bulk_delete_experiment', 'isEnabled', false) ? (0, $7X18B.cardsBulkOperationsDeleteRequests)(cardsData) : (0, $eSSqy.cardsBulkOperationsRequests)(cardsData);
        optimisticId.current = action.meta.optimistic.id;
        if ((0, $6s1PB.expVal)('bulk_delete_experiment', 'isEnabled', false)) currentBulkOperationType.current = bulkOperationType;
        dispatch(action);
    }, [
        dispatch,
        estimationFieldId,
        isCMP
    ]);
    /*
    This function is a temporary workaround to open the legacy bulk edit page.
    The Bulk Transition doesn't have support to return the issueKeys so this implementation was done here
    and will be removed when we implement Bulk Transition with multiple workflows.
    Project Plan: https://hello.atlassian.net/wiki/spaces/JSDee/pages/3388755384/Bulk+Transition+Project+Plan
    */ const onLegacyBulkEditRequest = (0, $5uXOq.useCallback)((issueIds)=>{
        const issueKeys = issueIds.map((id)=>cardEntities[String(id)]?.key);
        const url = `/secure/GHBulkChange.jspa?issueKeys=${encodeURIComponent(issueKeys.join(','))}`;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.open(url, '_blank');
    }, [
        cardEntities
    ]);
    const onUpdateError = (0, $5uXOq.useCallback)((cardIds)=>{
        if (!optimisticId.current) return;
        if (currentBulkOperationType.current === 'BULK_DELETE' && (0, $6s1PB.expVal)('bulk_delete_experiment', 'isEnabled', false)) dispatch((0, $7X18B.cardsBulkOperationsDeleteFailure)(optimisticId.current, cardIds));
        else dispatch((0, $eSSqy.cardsBulkOperationsFailure)(optimisticId.current, cardIds));
    }, [
        dispatch
    ]);
    const onUpdateSuccess = (0, $5uXOq.useCallback)((cardIds)=>{
        if (!optimisticId.current) return;
        if (currentBulkOperationType.current === 'BULK_DELETE' && (0, $6s1PB.expVal)('bulk_delete_experiment', 'isEnabled', false)) dispatch((0, $7X18B.cardsBulkOperationsDeleteSuccess)(optimisticId.current, cardIds));
        else dispatch((0, $eSSqy.cardsBulkOperationsSuccess)(optimisticId.current, cardIds));
    }, [
        dispatch
    ]);
    const onOpenForm = (0, $5uXOq.useCallback)(()=>{
        onOpenSidebar();
        closeIssueView();
    }, [
        closeIssueView,
        onOpenSidebar
    ]);
    const onCloseForm = (0, $5uXOq.useCallback)(()=>{
        onCloseSidebar();
        openIssueView();
    }, [
        openIssueView,
        onCloseSidebar
    ]);
    // TODO: remove this - https://hello.jira.atlassian.cloud/browse/DEE-6120
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (selectedCardIds.length > 0) entryPointActions.load();
    }, [
        entryPointActions,
        selectedCardIds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6aXrw.BulkOpsCoreWithToolbar), {
        shouldHideToolbar: (0, $6s1PB.expVal)('bulk_operations_in_nin_experiment', 'isEnabled', false) ? !hasBulkEditPermission : false,
        bulkOpsCoreEntryPointReference: entryPointReferenceSubject,
        bulkOperationsForm: bulkOperationsForm,
        onOpenForm: onOpenForm,
        onCloseForm: onCloseForm,
        onUpdateError: onUpdateError,
        onUpdateSuccess: onUpdateSuccess,
        onLegacyBulkEditRequest: onLegacyBulkEditRequest,
        onSelectAll: selectAllVisible,
        selectableIssueIds: visibleCardIds,
        extraAnalyticsAttributes: extraAnalyticsAttributes,
        onClearAll: clearAll,
        onClearAllVisible: clearAllVisible,
        hasBulkEditPermission: hasBulkEditPermission,
        onUpdateStart: onUpdateStart,
        selectedIssueIds: shouldShowCheckbox ? selectedCardIds : [],
        extraToolbarButtons: [
            ...useAgentPickerActions
        ]
    });
};

});
parcelRegister("6aXrw", function(module, exports) {

$parcel$export(module.exports, "AsyncBulkOpsCore", () => $dd195193bf05f4ed$export$ac7b39f8b8a9f5cd);
$parcel$export(module.exports, "BulkOpsCoreWithToolbar", () => $dd195193bf05f4ed$export$e277fa5a9b41268f);

var $5uXOq = parcelRequire("5uXOq");

var $Pdfe3 = parcelRequire("Pdfe3");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $8G5F5 = parcelRequire("8G5F5");

var $91LZJ = parcelRequire("91LZJ");

var $2NMNM = parcelRequire("2NMNM");

var $lWYYR = parcelRequire("lWYYR");

var $9by3l = parcelRequire("9by3l");

var $6s1PB = parcelRequire("6s1PB");

var $fvbIR = parcelRequire("fvbIR");
const $dd195193bf05f4ed$var$entryPointParams = {};
const $dd195193bf05f4ed$export$ac7b39f8b8a9f5cd = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $fvbIR.asyncBulkOpsCoreEntryPoint), $dd195193bf05f4ed$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "jira.backlog.bulk.operations.core",
        packageName: "jiraBulkOperationsCore",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
        runtimeProps: props
    });
};
const $dd195193bf05f4ed$export$e277fa5a9b41268f = ({ bulkOpsCoreEntryPointReference: bulkOpsCoreEntryPointReference, ...props })=>{
    const hasSelectAllButton = Boolean(props.onSelectAll);
    const extraToolbarButtonsSkeleton = props.extraToolbarButtons?.map((button)=>({
            hasIcon: Boolean(button.icon),
            text: button.name
        })) || [];
    const { dismissBulkOperation: dismissBulkOperation } = (0, $91LZJ.useBulkOperationsActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onDeselectAll = (0, $5uXOq.useCallback)(()=>{
        dismissBulkOperation({
            createAnalyticsEvent: createAnalyticsEvent,
            dismissType: 'DESELECT_ALL_ISSUES'
        });
    }, [
        createAnalyticsEvent,
        dismissBulkOperation
    ]);
    // TODO: move this back to the bottom when cleaning up bulk_delete_experiment AND isLegacyBulkOperations
    const toolbarWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8G5F5.ToolbarWrapper), {
        show: props.selectedIssueIds.length > 0,
        width: "calc(100% - var(--leftSidebarWidth, 0px))",
        onDeselectAll: onDeselectAll
    }, bulkOpsCoreEntryPointReference && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "jiraAsyncBulkOperationsCoreWithToolBar",
        packageName: "jiraBulkOperationsCoreWithToolBar",
        teamName: "deliveroo",
        entryPointReferenceSubject: bulkOpsCoreEntryPointReference,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Pdfe3.BulkOperationsToolbarSkeleton), {
            buttons: extraToolbarButtonsSkeleton,
            hasSelectAllButton: hasSelectAllButton
        }),
        runtimeProps: props
    }));
    if (!(0, $6s1PB.expVal)('bulk_delete_experiment', 'isEnabled', false) || props.isLegacyBulkOperations) return toolbarWrapper;
    const formProps = {
        selectedIssueIds: props.selectedIssueIds,
        onOpenForm: props.onOpenForm,
        onCloseForm: props.onCloseForm,
        onUpdateError: props.onUpdateError,
        onUpdateSuccess: props.onUpdateSuccess,
        onLegacyBulkEditRequest: props.onLegacyBulkEditRequest,
        onUpdateStart: props.onUpdateStart
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lWYYR.FormSubmissionStatusContainer), {
        isGlobal: true,
        ...formProps
    }, toolbarWrapper, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9by3l.EditFormSubmitStatus), null));
};

});
parcelRegister("Pdfe3", function(module, exports) {

$parcel$export(module.exports, "BulkOperationsToolbarSkeleton", () => $b74ffcc19e228775$export$59bb23e2f88d002d);

var $5uXOq = parcelRequire("5uXOq");

var $eNciG = parcelRequire("eNciG");

var $koVbs = parcelRequire("koVbs");

var $6s1PB = parcelRequire("6s1PB");

var $a1sGj = parcelRequire("a1sGj");

var $dgVef = parcelRequire("dgVef");

var $jx5JX = parcelRequire("jx5JX");

var $RR58o = parcelRequire("RR58o");
const $b74ffcc19e228775$export$59bb23e2f88d002d = ({ hasSelectAllButton: hasSelectAllButton, buttons: buttons })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const allButtons = [
        {
            text: formatMessage((0, $dgVef.messages).editButton),
            hasIcon: true
        },
        {
            text: formatMessage((0, $a1sGj.messages).changeStatus),
            hasIcon: true
        },
        ...(0, $6s1PB.expVal)('bulk_delete_experiment', 'isEnabled', false) ? [
            {
                text: formatMessage((0, $jx5JX.messages).deleteButton),
                hasIcon: true
            }
        ] : [],
        ...(0, $6s1PB.expVal)('bulk_watch_unwatch', 'isEnabled', false) ? [
            {
                text: formatMessage((0, $RR58o.messages).watchOptions),
                hasIcon: true
            }
        ] : [],
        ...buttons
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eNciG.ToolbarSkeleton), {
        hasSelectAllButton: hasSelectAllButton,
        buttons: allButtons
    });
};

});
parcelRegister("eNciG", function(module, exports) {

$parcel$export(module.exports, "ToolbarSkeleton", () => $ff19fad29388fb19$export$5e29225d56ca7c7d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $1DVhQ = parcelRequire("1DVhQ");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $eyjpj = parcelRequire("eyjpj");

var $hGxOR = parcelRequire("hGxOR");
const $ff19fad29388fb19$var$SkeletonBase = (props)=>/*#__PURE__*/ $5uXOq.createElement((0, $1DVhQ.default), {
        ...props,
        height: "7px",
        isShimmering: true,
        color: "var(--ds-background-accent-gray-subtle, #8590A2)",
        ShimmeringEndColor: "var(--ds-background-accent-gray-bolder, #626F86)",
        width: props.width || '100%',
        "aria-hidden": "true"
    });
const $ff19fad29388fb19$var$SkeletonActionButton = ({ width: width, text: text, hasIcon: hasIcon })=>{
    return /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        xcss: $ff19fad29388fb19$var$skeletonButtonStyles,
        "aria-hidden": "true",
        testId: "floating-toolbar.ui.skeleton.box"
    }, /*#__PURE__*/ $5uXOq.createElement($ff19fad29388fb19$var$SkeletonBase, {
        width: width
    }), /*#__PURE__*/ $5uXOq.createElement((0, $f5TWP.default), null, /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        xcss: $ff19fad29388fb19$var$invisibleTextStyles
    }, text), /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        xcss: hasIcon ? $ff19fad29388fb19$var$iconSpacerStyles : $ff19fad29388fb19$var$noIconSpacerStyles
    })));
};
const $ff19fad29388fb19$var$SkeletonCloseIcon = ()=>/*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        xcss: $ff19fad29388fb19$var$closeIconContainerStyles
    }, /*#__PURE__*/ $5uXOq.createElement($ff19fad29388fb19$var$SkeletonBase, {
        width: "16px"
    })); // These props are used to calculate a more appropriate skeleton
const $ff19fad29388fb19$export$5e29225d56ca7c7d = ({ hasSelectAllButton: hasSelectAllButton, buttons: buttons })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ $5uXOq.createElement((0, $eyjpj.FloatingToolbarContainer), null, /*#__PURE__*/ $5uXOq.createElement((0, $eyjpj.FloatingToolbarContent), null, /*#__PURE__*/ $5uXOq.createElement((0, $eyjpj.FloatingToolbarSideContent), null, /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), null, /*#__PURE__*/ $5uXOq.createElement($ff19fad29388fb19$var$SkeletonBase, null), /*#__PURE__*/ $5uXOq.createElement((0, $f5TWP.default), {
        space: "space.050",
        "aria-hidden": "true"
    }, /*#__PURE__*/ $5uXOq.createElement("h2", {
        className: (0, $bwpsq.default)([
            "_11c82smr _1e0c1txw _1n261g80 _4cvr1h6o _ae4v1h6o _3um015vq _4t3iidpf"
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $ousew.default), {
        ...(0, $hGxOR.default).selectedItemsLabel,
        values: {
            numberOfSelectedItems: 1,
            numberSelected: /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
                xcss: $ff19fad29388fb19$var$numberSelectedStyles
            }, 1)
        }
    }))))), hasSelectAllButton && /*#__PURE__*/ $5uXOq.createElement($ff19fad29388fb19$var$SkeletonActionButton, {
        text: formatMessage((0, $hGxOR.default).selectAllButtonLabel),
        hasIcon: true
    }), /*#__PURE__*/ $5uXOq.createElement((0, $eyjpj.FloatingToolbarSeparator), null), /*#__PURE__*/ $5uXOq.createElement((0, $f5TWP.default), {
        alignBlock: "center"
    }, buttons.map((button)=>{
        return /*#__PURE__*/ $5uXOq.createElement($ff19fad29388fb19$var$SkeletonActionButton, {
            key: button.text,
            ...button
        });
    }), /*#__PURE__*/ $5uXOq.createElement($ff19fad29388fb19$var$SkeletonCloseIcon, null))));
};
const $ff19fad29388fb19$var$skeletonButtonStyles = (0, $8CUq3.xcss)({
    paddingInlineStart: 'space.100',
    paddingInlineEnd: 'space.150'
});
const $ff19fad29388fb19$var$closeIconContainerStyles = (0, $8CUq3.xcss)({
    paddingInlineStart: 'space.100',
    paddingInlineEnd: 'space.100'
});
const $ff19fad29388fb19$var$selectedContainer = null;
const $ff19fad29388fb19$var$iconSpacerStyles = (0, $8CUq3.xcss)({
    width: '26px'
});
const $ff19fad29388fb19$var$noIconSpacerStyles = (0, $8CUq3.xcss)({
    width: '4px'
});
const $ff19fad29388fb19$var$invisibleTextStyles = (0, $8CUq3.xcss)({
    height: '0',
    visibility: 'hidden'
});
const $ff19fad29388fb19$var$numberSelectedStyles = (0, $8CUq3.xcss)({
    width: '24px',
    marginRight: 'space.050'
});

});
parcelRegister("eyjpj", function(module, exports) {

$parcel$export(module.exports, "FloatingToolbarContainer", () => $65d4363d5da90d3d$export$da9876c16f406ff3);
$parcel$export(module.exports, "FloatingToolbarContent", () => $65d4363d5da90d3d$export$634954b758f92d4);
$parcel$export(module.exports, "FloatingToolbarSeparator", () => $65d4363d5da90d3d$export$e9d27765ebab091b);
$parcel$export(module.exports, "FloatingToolbarSideContent", () => $65d4363d5da90d3d$export$fcfdbfa230cd1442);
$parcel$export(module.exports, "ContentSlider", () => $65d4363d5da90d3d$export$ff7934be9f806b5f);

var $5uXOq = parcelRequire("5uXOq");

var $35XSW = parcelRequire("35XSW");
var $8Sbj3 = parcelRequire("8Sbj3");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $faL1o = parcelRequire("faL1o");
const $65d4363d5da90d3d$export$da9876c16f406ff3 = ({ children: children, onKeyDown: onKeyDown })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        role: "toolbar",
        xcss: $65d4363d5da90d3d$var$floatingContainerStyles,
        "aria-label": formatMessage((0, $faL1o.messages).toolbarName),
        onKeyDown: onKeyDown
    }, children);
};
const $65d4363d5da90d3d$export$634954b758f92d4 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $65d4363d5da90d3d$var$contentContainerStyles,
        alignBlock: "center"
    }, children);
const $65d4363d5da90d3d$export$e9d27765ebab091b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $65d4363d5da90d3d$var$separatorStyles
    });
const $65d4363d5da90d3d$export$fcfdbfa230cd1442 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $65d4363d5da90d3d$var$sideContentContainer
    }, children);
const $65d4363d5da90d3d$export$ff7934be9f806b5f = ({ children: children, show: show })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $35XSW.default), null, show && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Sbj3.default), {
        enterFrom: "bottom",
        fade: "inout"
    }, (slideInProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", slideInProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $65d4363d5da90d3d$var$mainContainerStyles
        }, children))));
const $65d4363d5da90d3d$var$floatingContainerStyles = (0, $8CUq3.xcss)({
    padding: 'space.100',
    backgroundColor: 'color.background.neutral.bold.pressed',
    borderRadius: '6px',
    boxShadow: 'elevation.shadow.overlay'
});
const $65d4363d5da90d3d$var$contentContainerStyles = (0, $8CUq3.xcss)({
    height: '32px',
    color: 'color.text.inverse',
    fontVariantNumeric: 'tabular-nums'
});
const $65d4363d5da90d3d$var$separatorStyles = (0, $8CUq3.xcss)({
    height: '16px',
    width: '1px',
    backgroundColor: 'elevation.surface.raised',
    borderRadius: '2px',
    marginLeft: 'space.100',
    marginRight: 'space.100'
});
const $65d4363d5da90d3d$var$sideContentContainer = (0, $8CUq3.xcss)({
    paddingLeft: 'space.100',
    paddingRight: 'space.100'
});
const $65d4363d5da90d3d$var$mainContainerStyles = (0, $8CUq3.xcss)({
    pointerEvents: 'auto'
});

});
parcelRegister("faL1o", function(module, exports) {

$parcel$export(module.exports, "messages", () => $39ec34d441f2b8b5$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $39ec34d441f2b8b5$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    toolbarName: {
        "id": "floating-toolbar.common.toolbar-name",
        "defaultMessage": "Bulk actions"
    }
});

});


parcelRegister("hGxOR", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5f61683952119ea$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d5f61683952119ea$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    selectedItemsLabel: {
        "id": "floating-toolbar.selected-items-label",
        "defaultMessage": "{numberSelected} {numberOfSelectedItems, plural, one {selected} other {selected}}"
    },
    clearAllButton: {
        "id": "floating-toolbar.clear-all-button",
        "defaultMessage": "Clear all"
    },
    selectAllButtonLabel: {
        "id": "floating-toolbar.select-all-button-label",
        "defaultMessage": "Select all"
    }
});

});


parcelRegister("a1sGj", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7df5795053ce776c$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $7df5795053ce776c$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    changeStatus: {
        "id": "bulk-operations-core.toolbar.use-status-action.change-status",
        "defaultMessage": "Change status"
    }
});

});

parcelRegister("dgVef", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2f1b529e937c824e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $2f1b529e937c824e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    editButton: {
        "id": "bulk-operations-core.toolbar.use-edit-action.edit-button",
        "defaultMessage": "Edit fields"
    }
});

});

parcelRegister("jx5JX", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f8d6851d0038f949$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $f8d6851d0038f949$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    deleteButton: {
        "id": "bulk-operations-core.toolbar.use-bulk-delete-action.detele-button",
        "defaultMessage": "Delete"
    }
});

});

parcelRegister("RR58o", function(module, exports) {

$parcel$export(module.exports, "messages", () => $3ac9a4f547ce95d9$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $3ac9a4f547ce95d9$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    watchOptions: {
        "id": "bulk-operations-core.toolbar.use-watch-action.watch-options",
        "defaultMessage": "Watch options"
    },
    startWatching: {
        "id": "bulk-operations-core.toolbar.use-watch-action.start-watching",
        "defaultMessage": "Start watching"
    },
    stopWatching: {
        "id": "bulk-operations-core.toolbar.use-watch-action.stop-watching",
        "defaultMessage": "Stop watching"
    },
    successFlagDescriptionStartWatching: {
        "id": "bulk-operations-core.toolbar.use-watch-action.success-flag-description-start-watching",
        "defaultMessage": "You're watching {itemCount, plural, one {this work item} other {# work items}}."
    },
    successFlagDescriptionStopWatching: {
        "id": "bulk-operations-core.toolbar.use-watch-action.success-flag-description-stop-watching",
        "defaultMessage": "You aren't watching {itemCount, plural, one {this work item} other {# work items}}."
    }
});

});


parcelRegister("8G5F5", function(module, exports) {

$parcel$export(module.exports, "ToolbarWrapper", () => $bb1a9147c120653f$export$b705b0380e6fe1b0);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $1XJ20 = parcelRequire("1XJ20");

var $eyjpj = parcelRequire("eyjpj");
const $bb1a9147c120653f$export$b705b0380e6fe1b0 = ({ children: children, show: show, width: width, onDeselectAll: onDeselectAll })=>{
    const previousShow = (0, $1XJ20.usePrevious)(show);
    (0, $5uXOq.useEffect)(()=>{
        if (previousShow && !show) onDeselectAll?.();
    }, [
        onDeselectAll,
        previousShow,
        show
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $bb1a9147c120653f$var$floatingPositionerStyles
        ],
        // eslint-disable-next-line jira/react/no-style-attribute -- width of component can change depending on the consumer
        style: {
            width: width || '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eyjpj.ContentSlider), {
        show: show
    }, children));
};
const $bb1a9147c120653f$var$floatingPositionerStyles = (0, $8CUq3.xcss)({
    position: 'fixed',
    bottom: 'space.100',
    zIndex: 'layer',
    pointerEvents: 'none',
    display: 'flex',
    justifyContent: 'center',
    transition: 'width 300ms cubic-bezier(0.2, 0, 0, 1)'
});

});

parcelRegister("91LZJ", function(module, exports) {

$parcel$export(module.exports, "useBulkOperations", () => $655e95f3b81da53e$export$940587be18a93fc4);
$parcel$export(module.exports, "useBulkOperationsActions", () => $655e95f3b81da53e$export$355499dfde532d1a);
$parcel$export(module.exports, "useIsBulkOperationsInProgress", () => $655e95f3b81da53e$export$760458c2204457a1);
$parcel$export(module.exports, "useShouldRenderSpotlight", () => $655e95f3b81da53e$export$4a165cf2377f023a);
$parcel$export(module.exports, "useBulkTransitionsStage", () => $655e95f3b81da53e$export$b3afff39a0c663ad);
$parcel$export(module.exports, "useBulkOperationInForm", () => $655e95f3b81da53e$export$6794339387d6d562);
$parcel$export(module.exports, "useBulkOperationType", () => $655e95f3b81da53e$export$4289f82da677ffac);
$parcel$export(module.exports, "useCancelDialogTrigger", () => $655e95f3b81da53e$export$babceeeb2408337b);
$parcel$export(module.exports, "useCurrentView", () => $655e95f3b81da53e$export$8ce7af7b2f8c770);

var $8zOmE = parcelRequire("8zOmE");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $5ltfA = parcelRequire("5ltfA");

var $liV8G = parcelRequire("liV8G");
const $655e95f3b81da53e$export$d4c72bab9d6cc13a = {
    operationType: null,
    isSidebarOpen: false,
    cancelDialogTrigger: undefined,
    currentView: 'edit',
    firstFieldId: undefined,
    operationStartTime: null
};
const $655e95f3b81da53e$var$actions = {
    setSummaryView: ()=>({ setState: setState })=>{
            setState({
                currentView: 'summary'
            });
        },
    setFirstFieldId: (firstFieldId)=>({ setState: setState })=>{
            setState({
                firstFieldId: firstFieldId
            });
        },
    setEditView: ()=>({ setState: setState })=>{
            setState({
                currentView: 'edit'
            });
        },
    setCancelDialogTrigger: (newTrigger = 'user-triggered')=>({ setState: setState, getState: getState })=>{
            const { cancelDialogTrigger: currentTrigger } = getState();
            /* Sometimes both events can be fired (route change & onclick) in one loop
					We need to prioritise route-change event  */ if (currentTrigger === 'route-change' && newTrigger === 'user-triggered') return;
            setState({
                cancelDialogTrigger: newTrigger
            });
        },
    clearDialogTrigger: ()=>({ setState: setState })=>{
            setState({
                cancelDialogTrigger: undefined
            });
        },
    startEdit: (args)=>({ setState: setState })=>{
            const { shouldRenderSpotlight: shouldRenderSpotlight } = args || {
                shouldRenderSpotlight: false
            };
            setState({
                operationType: {
                    type: (0, $liV8G.BulkOperationsTypes).BULK_EDIT
                },
                shouldRenderSpotlight: shouldRenderSpotlight,
                isSidebarOpen: true,
                operationStartTime: performance.now()
            });
        },
    loadTransitions: ()=>({ setState: setState })=>{
            setState({
                operationType: {
                    type: (0, $liV8G.BulkOperationsTypes).BULK_TRANSITION,
                    stage: (0, $liV8G.BulkTransitionsStage).LOAD_BULK_TRANSITIONS
                },
                isSidebarOpen: false
            });
        },
    startQuickTransitions: ()=>({ setState: setState })=>{
            setState({
                operationType: {
                    type: (0, $liV8G.BulkOperationsTypes).BULK_TRANSITION,
                    stage: (0, $liV8G.BulkTransitionsStage).START_QUICK_TRANSITIONS
                },
                isSidebarOpen: false,
                operationStartTime: performance.now()
            });
        },
    startSidebarTransition: ()=>({ setState: setState })=>{
            setState({
                operationType: {
                    type: (0, $liV8G.BulkOperationsTypes).BULK_TRANSITION,
                    stage: (0, $liV8G.BulkTransitionsStage).START_SIDEBAR_TRANSITION
                },
                isSidebarOpen: true,
                operationStartTime: performance.now()
            });
        },
    startTransitionScreen: ()=>({ setState: setState })=>{
            setState({
                operationType: {
                    type: (0, $liV8G.BulkOperationsTypes).BULK_TRANSITION,
                    stage: (0, $liV8G.BulkTransitionsStage).START_TRANSITION_SCREEN
                },
                isSidebarOpen: true
            });
        },
    dismissBulkOperation: ({ createAnalyticsEvent: createAnalyticsEvent, dismissType: dismissType })=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const analyticsEvent = createAnalyticsEvent({});
            const operationEndTime = performance.now();
            const operationTimeTaken = currentState.operationStartTime ? operationEndTime - currentState.operationStartTime : null;
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'dismissed bulkOperations', {
                dismissType: dismissType,
                operationTimeTaken: operationTimeTaken
            });
            (0, $5ltfA.extraFormDataService).clear();
            setState($655e95f3b81da53e$export$d4c72bab9d6cc13a);
        }
};
const $655e95f3b81da53e$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    initialState: $655e95f3b81da53e$export$d4c72bab9d6cc13a,
    actions: $655e95f3b81da53e$var$actions,
    name: 'bulk-operations-store'
});
const $655e95f3b81da53e$export$940587be18a93fc4 = (0, $3sQ5x.createHook)($655e95f3b81da53e$export$6f57813fe9f31bf9);
const $655e95f3b81da53e$export$355499dfde532d1a = (0, $3sQ5x.createActionsHook)($655e95f3b81da53e$export$6f57813fe9f31bf9);
const $655e95f3b81da53e$export$760458c2204457a1 = (0, $3sQ5x.createStateHook)($655e95f3b81da53e$export$6f57813fe9f31bf9, {
    selector: (state)=>state.operationType !== null
});
const $655e95f3b81da53e$export$4a165cf2377f023a = (0, $3sQ5x.createStateHook)($655e95f3b81da53e$export$6f57813fe9f31bf9, {
    selector: (state)=>!!state.shouldRenderSpotlight
});
const $655e95f3b81da53e$export$b3afff39a0c663ad = (0, $3sQ5x.createStateHook)($655e95f3b81da53e$export$6f57813fe9f31bf9, {
    selector: (state)=>{
        const { operationType: operationType } = state;
        if (operationType?.type === (0, $liV8G.BulkOperationsTypes).BULK_TRANSITION) return operationType.stage;
        return null;
    }
});
const $655e95f3b81da53e$export$6794339387d6d562 = (0, $3sQ5x.createStateHook)($655e95f3b81da53e$export$6f57813fe9f31bf9, {
    selector: (state)=>{
        if (state.isSidebarOpen && state.operationType) return state.operationType.type;
        return null;
    }
});
const $655e95f3b81da53e$export$4289f82da677ffac = (0, $3sQ5x.createStateHook)($655e95f3b81da53e$export$6f57813fe9f31bf9, {
    selector: (state)=>state.operationType
});
const $655e95f3b81da53e$export$babceeeb2408337b = (0, $3sQ5x.createStateHook)($655e95f3b81da53e$export$6f57813fe9f31bf9, {
    selector: (state)=>state.cancelDialogTrigger
});
const $655e95f3b81da53e$export$8ce7af7b2f8c770 = (0, $3sQ5x.createStateHook)($655e95f3b81da53e$export$6f57813fe9f31bf9, {
    selector: (state)=>state.currentView
});

});
parcelRegister("5ltfA", function(module, exports) {

$parcel$export(module.exports, "extraFormDataService", () => $3546d70b36caa00c$export$3cd9d97d155e8e66);
class $3546d70b36caa00c$var$ExtraFormData {
    clear() {
        this.data = {};
    }
    addByKey(key, value) {
        this.data[key] = value;
    }
    getByKey(key) {
        return this.data[key];
    }
    getAll() {
        return this.data;
    }
    constructor(){
        this.data = {};
    }
}
const $3546d70b36caa00c$var$extraFormData = new $3546d70b36caa00c$var$ExtraFormData();
const $3546d70b36caa00c$var$addDataByKey = (key, value)=>{
    $3546d70b36caa00c$var$extraFormData.addByKey(key, value);
};
const $3546d70b36caa00c$var$clear = ()=>{
    $3546d70b36caa00c$var$extraFormData.clear();
};
const $3546d70b36caa00c$var$getDataByKey = (key)=>$3546d70b36caa00c$var$extraFormData.getByKey(key);
const $3546d70b36caa00c$var$getData = ()=>$3546d70b36caa00c$var$extraFormData.getAll();
const $3546d70b36caa00c$export$3cd9d97d155e8e66 = {
    addDataByKey: $3546d70b36caa00c$var$addDataByKey,
    getDataByKey: $3546d70b36caa00c$var$getDataByKey,
    clear: $3546d70b36caa00c$var$clear,
    getData: $3546d70b36caa00c$var$getData
};

});

parcelRegister("liV8G", function(module, exports) {

$parcel$export(module.exports, "BulkOperationsTypes", () => $41c61f309c49c414$export$7ec2782f56bb6e02);
$parcel$export(module.exports, "BulkTransitionsStage", () => $41c61f309c49c414$export$a6f51fa6c8971716);
const $41c61f309c49c414$export$7ec2782f56bb6e02 = {
    BULK_EDIT: 'BULK_EDIT',
    BULK_TRANSITION: 'BULK_TRANSITION',
    BULK_DELETE: 'BULK_DELETE',
    BULK_WATCH: 'BULK_WATCH',
    BULK_UNWATCH: 'BULK_UNWATCH'
};
const $41c61f309c49c414$export$a6f51fa6c8971716 = {
    LOAD_BULK_TRANSITIONS: 'LOAD_BULK_TRANSITIONS',
    START_QUICK_TRANSITIONS: 'START_QUICK_TRANSITIONS',
    START_SIDEBAR_TRANSITION: 'START_SIDEBAR_TRANSITION',
    START_TRANSITION_SCREEN: 'START_TRANSITION_SCREEN'
};
const $41c61f309c49c414$export$1550a2cc6d56ae33 = {
    // ERRORS //
    ERROR_BULK_EDIT: 'ERROR_BULK_EDIT',
    ERROR_BULK_TRANSITION: 'ERROR_BULK_TRANSITION',
    ERROR_BULK_TRANSITION_SCREEN_MOUNT: 'ERROR_BULK_TRANSITION_SCREEN_MOUNT',
    // BULK EDIT //
    EDIT_FORM_PRISTINE_CANCEL: 'EDIT_FORM_PRISTINE_CANCEL',
    EDIT_FORM_DIRTY_CANCEL: 'EDIT_FORM_DIRTY_CANCEL',
    EDIT_FORM_SUMMARY_CANCEL: 'EDIT_FORM_SUMMARY_CANCEL',
    EDIT_ATTEMPT_SUBMIT: 'EDIT_ATTEMPT_SUBMIT',
    // TRANSITION DIALOG //
    TRANSITION_DIALOG_PRISTINE_CANCEL: 'TRANSITION_DIALOG_PRISTINE_CANCEL',
    TRANSITION_DIALOG_DIRTY_CANCEL: 'TRANSITION_DIALOG_DIRTY_CANCEL',
    TRANSITION_DIALOG_CANT_CONTINUE_WARNING: 'TRANSITION_DIALOG_CANT_CONTINUE_WARNING',
    TRANSITION_DIALOG_ATTEMPT_SUBMIT: 'TRANSITION_DIALOG_ATTEMPT_SUBMIT',
    // TRANSITION FORM //
    TRANSITION_FORM_PRISTINE_CANCEL: 'TRANSITION_FORM_PRISTINE_CANCEL',
    TRANSITION_FORM_DIRTY_CANCEL: 'TRANSITION_FORM_DIRTY_CANCEL',
    TRANSITION_FORM_ATTEMPT_SUBMIT: 'TRANSITION_FORM_ATTEMPT_SUBMIT',
    // TRANSITION WITH SCREEN //
    TRANSITION_WITH_SCREEN_LEGACY_LINK: 'TRANSITION_WITH_SCREEN_LEGACY_LINK',
    TRANSITION_WITH_SCREEN_SUMMARY_CANCEL: 'TRANSITION_WITH_SCREEN_SUMMARY_CANCEL',
    TRANSITION_WITH_SCREEN_CANCEL: 'TRANSITION_WITH_SCREEN_CANCEL',
    // BULK DELETE //
    DELETE_ATTEMPT_SUBMIT: 'DELETE_ATTEMPT_SUBMIT',
    DELETE_ATTEMPT_CANCEL: 'DELETE_CANCEL',
    // BULK WATCH //
    WATCH_ATTEMPT_SUBMIT: 'WATCH_ATTEMPT_SUBMIT',
    // BULK UNWATCH //
    UNWATCH_ATTEMPT_SUBMIT: 'UNWATCH_ATTEMPT_SUBMIT',
    // OTHER //
    NAVIGATION: 'NAVIGATION',
    DESELECT_ALL_ISSUES: 'DESELECT_ALL_ISSUES'
};

});


parcelRegister("lWYYR", function(module, exports) {

$parcel$export(module.exports, "FormSubmissionStatusContainer", () => $55cb7d47e9fb8082$export$89eaa1757634ea57);
$parcel$export(module.exports, "useBulkOperationsFormSubmissionActions", () => $55cb7d47e9fb8082$export$497042634f495a36);
$parcel$export(module.exports, "useFormSubmitStatus", () => $55cb7d47e9fb8082$export$18b9f82ace8120bc);
$parcel$export(module.exports, "useFormSubmitProgressData", () => $55cb7d47e9fb8082$export$f978a44c91fecf30);
$parcel$export(module.exports, "useFormSubmitSuccessData", () => $55cb7d47e9fb8082$export$6def2d73afa09050);
$parcel$export(module.exports, "useFormSubmitIssueIds", () => $55cb7d47e9fb8082$export$ec939e52c2362761);
$parcel$export(module.exports, "useFormSubmitErrorData", () => $55cb7d47e9fb8082$export$1b826b4651e625bf);
$parcel$export(module.exports, "useFormSubmitFlagData", () => $55cb7d47e9fb8082$export$f99368b86d418226);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $gDmIh = parcelRequire("gDmIh");

var $2SnjZ = parcelRequire("2SnjZ");
const $55cb7d47e9fb8082$var$initialState = {
    flagStatus: (0, $2SnjZ.SubmitFlagStatus).NoFlag,
    flagData: undefined,
    data: undefined,
    callbacks: {},
    issueIds: []
};
const $55cb7d47e9fb8082$var$Store = (0, $iXqE5.createStore)({
    initialState: $55cb7d47e9fb8082$var$initialState,
    actions: $gDmIh.actions,
    name: 'bulk-operations-form-submit-state'
});
const $55cb7d47e9fb8082$export$31c34f2147c0d0ae = (0, $3sQ5x.createHook)($55cb7d47e9fb8082$var$Store);
const $55cb7d47e9fb8082$export$c88ec44e7ac83ded = ()=>({ setState: setState }, { selectedIssueIds: selectedIssueIds, ...callbacks })=>{
        setState({
            callbacks: callbacks,
            issueIds: selectedIssueIds
        });
    };
const $55cb7d47e9fb8082$export$89eaa1757634ea57 = (0, $gg7kZ.createContainer)($55cb7d47e9fb8082$var$Store, {
    onInit: $55cb7d47e9fb8082$export$c88ec44e7ac83ded,
    onUpdate: $55cb7d47e9fb8082$export$c88ec44e7ac83ded
});
const $55cb7d47e9fb8082$export$497042634f495a36 = (0, $3sQ5x.createActionsHook)($55cb7d47e9fb8082$var$Store);
const $55cb7d47e9fb8082$var$getFormSubmitStatus = (state)=>state.flagStatus;
const $55cb7d47e9fb8082$export$18b9f82ace8120bc = (0, $3sQ5x.createStateHook)($55cb7d47e9fb8082$var$Store, {
    selector: $55cb7d47e9fb8082$var$getFormSubmitStatus
});
const $55cb7d47e9fb8082$var$getFormSubmitProgressData = (state)=>{
    if (state.flagStatus === (0, $2SnjZ.SubmitFlagStatus).ProgressFlag || state.flagStatus === (0, $2SnjZ.SubmitFlagStatus).NoFlag) return state.data;
    return undefined;
};
const $55cb7d47e9fb8082$export$f978a44c91fecf30 = (0, $3sQ5x.createStateHook)($55cb7d47e9fb8082$var$Store, {
    selector: $55cb7d47e9fb8082$var$getFormSubmitProgressData
});
const $55cb7d47e9fb8082$var$getFormSubmitSuccessData = (state)=>{
    if (state.flagStatus === (0, $2SnjZ.SubmitFlagStatus).SuccessFlag) return state.data.numberOfIssuesUpdated;
    return undefined;
};
const $55cb7d47e9fb8082$export$6def2d73afa09050 = (0, $3sQ5x.createStateHook)($55cb7d47e9fb8082$var$Store, {
    selector: $55cb7d47e9fb8082$var$getFormSubmitSuccessData
});
const $55cb7d47e9fb8082$var$getFormSubmitIssueIds = (state)=>state.issueIds;
const $55cb7d47e9fb8082$export$ec939e52c2362761 = (0, $3sQ5x.createStateHook)($55cb7d47e9fb8082$var$Store, {
    selector: $55cb7d47e9fb8082$var$getFormSubmitIssueIds
});
const $55cb7d47e9fb8082$var$getFormSubmitErrorData = (state)=>{
    if (state.flagStatus === (0, $2SnjZ.SubmitFlagStatus).PartialErrorFlag) return state.data;
    return undefined;
};
const $55cb7d47e9fb8082$export$1b826b4651e625bf = (0, $3sQ5x.createStateHook)($55cb7d47e9fb8082$var$Store, {
    selector: $55cb7d47e9fb8082$var$getFormSubmitErrorData
});
const $55cb7d47e9fb8082$var$getFormSubmitFlagData = (state)=>state.flagData;
const $55cb7d47e9fb8082$export$f99368b86d418226 = (0, $3sQ5x.createStateHook)($55cb7d47e9fb8082$var$Store, {
    selector: $55cb7d47e9fb8082$var$getFormSubmitFlagData
});

});
parcelRegister("gDmIh", function(module, exports) {

$parcel$export(module.exports, "actions", () => $2a881fd5be32e130$export$e324594224ef24da);

var $e7WVN = parcelRequire("e7WVN");

var $6s1PB = parcelRequire("6s1PB");

var $dNaZ2 = parcelRequire("dNaZ2");

var $2SnjZ = parcelRequire("2SnjZ");
const $2a881fd5be32e130$export$e324594224ef24da = {
    startSubmit: (interactionSource)=>({ setState: setState })=>{
            setState({
                flagStatus: (0, $2SnjZ.SubmitFlagStatus).NoFlag,
                data: undefined,
                interactionSource: interactionSource
            });
        },
    setIdle: ()=>({ setState: setState })=>{
            setState({
                flagStatus: (0, $2SnjZ.SubmitFlagStatus).NoFlag,
                data: undefined
            });
        },
    dismissPollingFlag: ()=>({ setState: setState, getState: getState })=>{
            const { flagStatus: flagStatus, data: data } = getState();
            if (flagStatus === (0, $2SnjZ.SubmitFlagStatus).ProgressFlag) setState({
                flagStatus: (0, $2SnjZ.SubmitFlagStatus).NoFlag,
                flagData: undefined,
                data: data
            });
        },
    setPollingStart: (taskId, inputData, flagData)=>({ setState: setState, getState: getState })=>{
            const { callbacks: callbacks } = getState();
            callbacks.onUpdateStart?.(inputData.map(({ issueIds: issueIds, data: data, bulkOperationType: bulkOperationType })=>({
                    data: data,
                    issueIds: (0, $dNaZ2.transformIssueArisToIds)(issueIds),
                    bulkOperationType: (0, $6s1PB.expVal)('bulk_operations_in_nin_experiment', 'isEnabled', false) ? bulkOperationType : undefined
                })));
            setState({
                flagStatus: (0, $2SnjZ.SubmitFlagStatus).ProgressFlag,
                flagData: flagData,
                data: {
                    taskId: taskId
                }
            });
        },
    /*
		This action is a temporary workaround to open the legacy bulk edit page.
		The Bulk Transition doesn't have support to return the issueKeys so this implementation was done here
		and will be removed when we implement Bulk Transition with multiple workflows.
		Project Plan: https://hello.atlassian.net/wiki/spaces/JSDee/pages/3388755384/Bulk+Transition+Project+Plan
		*/ redirectToLegacyBulkTransition: ()=>({ getState: getState })=>{
            const { callbacks: callbacks, issueIds: issueIds } = getState();
            callbacks.onLegacyBulkEditRequest?.(issueIds);
        },
    updateProgress: (progress)=>({ setState: setState, getState: getState })=>{
            const { flagStatus: flagStatus, data: data } = getState();
            if (flagStatus !== (0, $2SnjZ.SubmitFlagStatus).ProgressFlag) return;
            setState({
                flagStatus: (0, $2SnjZ.SubmitFlagStatus).ProgressFlag,
                data: {
                    progress: progress,
                    taskId: data.taskId
                }
            });
        },
    setError: ()=>({ setState: setState, getState: getState })=>{
            const { callbacks: callbacks, issueIds: issueIds, interactionSource: interactionSource } = getState();
            if (interactionSource) (0, $e7WVN.setInteractionError)(interactionSource, {
                name: 'errorSubmitBulkEdit',
                errorMessage: `Error submitting changes for issues:${issueIds}`
            });
            callbacks.onUpdateError?.(issueIds);
            setState({
                flagStatus: (0, $2SnjZ.SubmitFlagStatus).ErrorFlag,
                data: {}
            });
        },
    setPartialError: (totalCount, failedCount, failedIssueKeys, failedIssueIds)=>({ setState: setState, getState: getState })=>{
            const { callbacks: callbacks } = getState();
            callbacks.onUpdateError?.(failedIssueIds.map(Number));
            setState({
                flagStatus: (0, $2SnjZ.SubmitFlagStatus).PartialErrorFlag,
                data: {
                    totalCount: totalCount,
                    failedCount: failedCount,
                    issueKeys: failedIssueKeys
                }
            });
        },
    setSuccess: (numberOfIssuesUpdated)=>({ setState: setState, getState: getState })=>{
            const { callbacks: callbacks, issueIds: issueIds } = getState();
            callbacks.onUpdateSuccess?.(issueIds);
            setState({
                flagStatus: (0, $2SnjZ.SubmitFlagStatus).SuccessFlag,
                data: {
                    numberOfIssuesUpdated: numberOfIssuesUpdated
                }
            });
        }
};

});
parcelRegister("dNaZ2", function(module, exports) {

$parcel$export(module.exports, "transformIssueArisToIds", () => $5b70fe4cf077e0c7$export$98b993b1def7c51b);

var $jUlV7 = parcelRequire("jUlV7");
const $5b70fe4cf077e0c7$export$98b993b1def7c51b = (issueAris)=>issueAris.map((issueAri)=>parseInt((0, $jUlV7.JiraIssueAri).parse(issueAri).issueId, 10));

});

parcelRegister("2SnjZ", function(module, exports) {

$parcel$export(module.exports, "SubmitFlagStatus", () => $525bc18cc622d8e9$export$1f723227c515b0bc);
const $525bc18cc622d8e9$export$1f723227c515b0bc = {
    ProgressFlag: 'ProgressFlag',
    SuccessFlag: 'SuccessFlag',
    ErrorFlag: 'ErrorFlag',
    PartialErrorFlag: 'PartialErrorFlag',
    NoFlag: 'NoFlag'
};

});



parcelRegister("9by3l", function(module, exports) {

$parcel$export(module.exports, "EditFormSubmitStatus", () => $e83c157517cc4c24$export$ef11ca2bf4b4dcc1);

var $5uXOq = parcelRequire("5uXOq");

var $fJBgF = parcelRequire("fJBgF");

var $i39RY = parcelRequire("i39RY");

var $6B3QB = parcelRequire("6B3QB");
const $e83c157517cc4c24$export$ef11ca2bf4b4dcc1 = ()=>{
    (0, $6B3QB.useEditFormStatusFlags)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fJBgF.BulkOperationsErrorBoundary), {
        id: "bulk-operations.core.edit-form.submit-status.progress-polling"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i39RY.EditFormSubmitStatusProgressPolling), null));
};

});
parcelRegister("fJBgF", function(module, exports) {

$parcel$export(module.exports, "BulkOperationsErrorBoundary", () => $b64a81991de189c5$export$d8d35fe42889b9a4);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");
const $b64a81991de189c5$export$d8d35fe42889b9a4 = ({ id: id, children: children, fallback: fallback, onError: onError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: id,
        packageName: "jiraBulkOperationsCommon",
        fallback: fallback || 'unmount',
        teamName: "deliveroo",
        onError: onError
    }, children);

});

parcelRegister("i39RY", function(module, exports) {

$parcel$export(module.exports, "EditFormSubmitStatusProgressPolling", () => $efb450c3ebbd83c0$export$6777d6eee8444c89);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $lfTZh = parcelRequire("lfTZh");

var $fMYkx = parcelRequire("fMYkx");

var $koeKL = parcelRequire("koeKL");

var $lWYYR = parcelRequire("lWYYR");

var $5ZcSp = parcelRequire("5ZcSp");

var $g1FBI = parcelRequire("g1FBI");
const $efb450c3ebbd83c0$export$6777d6eee8444c89 = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { taskId: taskId } = (0, $lWYYR.useFormSubmitProgressData)() || {};
    const reset = (0, $5ZcSp.useResetFormSubmissionState)();
    const [queryReference, fetchFormStatus, disposeQuery] = (0, $8Uumt.useQueryLoader)((0, $fMYkx.default));
    const refetch = (0, $5uXOq.useCallback)((id)=>{
        fetchFormStatus({
            taskId: id,
            cloudId: cloudId
        }, {
            fetchPolicy: 'network-only'
        });
    }, [
        cloudId,
        fetchFormStatus
    ]);
    (0, $5uXOq.useEffect)(()=>reset, [
        reset
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (taskId) refetch(taskId);
    }, [
        refetch,
        taskId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!taskId) disposeQuery();
    }, [
        disposeQuery,
        taskId
    ]);
    return queryReference && taskId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "bulk-operations.core.form.submit-status.progress-polling",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g1FBI.ProgressPolling), {
        taskId: taskId,
        queryReference: queryReference,
        refetch: refetch
    })) : null;
};

});
parcelRegister("fMYkx", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2ea417a9f0cf75c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<40d6ef912a0c10b81e4bb6bf5d4de0cd>>
 * @relayHash 7fbd44b7b195b0263a244f68b9781379
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0ff9d3b1123e3ca95975e3b78d63122ba5c367587628b46eb1310db36a26717c
const $c2ea417a9f0cf75c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "taskId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "taskId",
            "variableName": "taskId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "progress"
    }, v3 = {
        "kind": "ScalarField",
        "name": "taskId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "status"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "mainEditFormSubmitStatus_progressPollingQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssueBulkOperationProgress",
                            "kind": "LinkedField",
                            "name": "bulkOperationProgress",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "kind": "FragmentSpread",
                                    "name": "processResponse_bulkOperationsCommon"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "mainEditFormSubmitStatus_progressPollingQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssueBulkOperationProgress",
                            "kind": "LinkedField",
                            "name": "bulkOperationProgress",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "totalIssueCount"
                                },
                                {
                                    "concreteType": "JiraIssueBulkOperationFailureConnection",
                                    "kind": "LinkedField",
                                    "name": "failedAccessibleIssues",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueBulkOperationFailureEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueBulkOperationFailure",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssue",
                                                            "kind": "LinkedField",
                                                            "name": "issue",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "issueId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "key"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "id"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0ff9d3b1123e3ca95975e3b78d63122ba5c367587628b46eb1310db36a26717c",
            "metadata": {},
            "name": "mainEditFormSubmitStatus_progressPollingQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c2ea417a9f0cf75c$var$node.hash = "5fda96b9fc7b0bf909c4b82c92314696";
var $c2ea417a9f0cf75c$export$2e2bcd8739ae039 = $c2ea417a9f0cf75c$var$node;

});

parcelRegister("5ZcSp", function(module, exports) {

$parcel$export(module.exports, "useFormStatusFlags", () => $3edf48c04f4e1eb8$export$6c43148bc841854a);
$parcel$export(module.exports, "useResetFormSubmissionState", () => $3edf48c04f4e1eb8$export$fc35d2af96f6134d);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $lWYYR = parcelRequire("lWYYR");

var $2SnjZ = parcelRequire("2SnjZ");
const $3edf48c04f4e1eb8$export$6c43148bc841854a = ({ renderSuccessFlag: renderSuccessFlag, renderInProgressFlag: renderInProgressFlag, renderErrorFlag: renderErrorFlag, renderPartialErrorFlag: renderPartialErrorFlag })=>{
    const submitStatus = (0, $lWYYR.useFormSubmitStatus)();
    const existingFlagId = (0, $5uXOq.useRef)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const { setIdle: setIdle, dismissPollingFlag: dismissPollingFlag } = (0, $lWYYR.useBulkOperationsFormSubmissionActions)();
    const dismissExistingFlag = (0, $5uXOq.useCallback)(()=>{
        if (existingFlagId.current) {
            dismissFlag(existingFlagId.current);
            existingFlagId.current = undefined;
        }
    }, [
        dismissFlag
    ]);
    const flags = (0, $5uXOq.useMemo)(()=>({
            [(0, $2SnjZ.SubmitFlagStatus).ProgressFlag]: {
                id: 'in-progress-flag',
                render: (props)=>renderInProgressFlag({
                        ...props,
                        onDismissed: dismissPollingFlag
                    })
            },
            [(0, $2SnjZ.SubmitFlagStatus).ErrorFlag]: {
                id: 'error-flag',
                render: (props)=>renderErrorFlag({
                        ...props,
                        onDismissed: setIdle
                    })
            },
            [(0, $2SnjZ.SubmitFlagStatus).PartialErrorFlag]: {
                id: 'partial-error-flag',
                render: (props)=>renderPartialErrorFlag({
                        ...props,
                        onDismissed: setIdle
                    })
            },
            [(0, $2SnjZ.SubmitFlagStatus).SuccessFlag]: {
                id: 'success-flag',
                render: (props)=>renderSuccessFlag({
                        ...props,
                        onDismissed: setIdle
                    })
            }
        }), [
        dismissPollingFlag,
        renderErrorFlag,
        renderInProgressFlag,
        renderPartialErrorFlag,
        renderSuccessFlag,
        setIdle
    ]);
    (0, $5uXOq.useEffect)(()=>dismissExistingFlag, [
        dismissExistingFlag
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const flag = flags[submitStatus];
        if (!flag) {
            dismissExistingFlag();
            return;
        }
        if (existingFlagId.current) setTimeout(()=>{
            existingFlagId.current = showFlag(flag);
            dismissFlag('in-progress-flag');
        }, 200);
        else existingFlagId.current = showFlag(flag);
    }, [
        dismissFlag,
        dismissExistingFlag,
        setIdle,
        flags,
        submitStatus,
        showFlag
    ]);
};
const $3edf48c04f4e1eb8$export$fc35d2af96f6134d = ()=>{
    const { setIdle: setIdle } = (0, $lWYYR.useBulkOperationsFormSubmissionActions)();
    return setIdle;
};

});

parcelRegister("g1FBI", function(module, exports) {

$parcel$export(module.exports, "ProgressPolling", () => $46ecdfb4535e4c5d$export$906b2a9d5f88a9d9);

var $fMYkx = parcelRequire("fMYkx");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jcw0u = parcelRequire("jcw0u");

var $8cuDP = parcelRequire("8cuDP");

var $lWYYR = parcelRequire("lWYYR");

var $dCXqh = parcelRequire("dCXqh");

var $4ZuCq = parcelRequire("4ZuCq");
const $46ecdfb4535e4c5d$export$7f111648ca05f056 = 'bulkEditProgressPolling';
const $46ecdfb4535e4c5d$export$5578b12147815e51 = ()=>(0, $5uXOq.useRef)();
const $46ecdfb4535e4c5d$export$906b2a9d5f88a9d9 = ({ queryReference: queryReference, refetch: refetch, taskId: taskId })=>{
    const { logRetryAttempt: logRetryAttempt, retryStatus: retryStatus, resetRetryCount: resetRetryCount } = (0, $4ZuCq.useAllowedRetries)();
    const previousProgress = $46ecdfb4535e4c5d$export$5578b12147815e51();
    const { setError: setError } = (0, $lWYYR.useBulkOperationsFormSubmissionActions)();
    const data = (0, $8Uumt.usePreloadedQuery)((0, $fMYkx.default), queryReference);
    const { status: status, taskId: dataTaskId, progress: progress } = data.jira?.bulkOperationProgress || {};
    const retry = (0, $5uXOq.useCallback)(()=>{
        if (previousProgress.current !== progress) resetRetryCount();
        else /*  Log retry attempt as task error when no status/taskId returned.
               Task errors happen because there is a delay before task reaches progress queue.
               Delay P99 is ~1s. */ logRetryAttempt(!status || !dataTaskId);
        previousProgress.current = progress;
        refetch(dataTaskId || taskId);
    }, [
        progress,
        previousProgress,
        refetch,
        dataTaskId,
        taskId,
        resetRetryCount,
        logRetryAttempt,
        status
    ]);
    const clearRetryInterval = (0, $4ZuCq.useRetryInterval)(taskId, retry);
    (0, $5uXOq.useEffect)(()=>{
        if (retryStatus !== 'underLimit') {
            setError();
            if (retryStatus === 'maxTaskErrorAttemptsReached') (0, $jcw0u.default)({
                meta: (0, $8cuDP.getAnalyticsMeta)($46ecdfb4535e4c5d$export$7f111648ca05f056),
                error: new Error('jira.bulkOperationProgress is null or undefined')
            });
            clearRetryInterval();
        }
    }, [
        clearRetryInterval,
        retryStatus,
        setError
    ]);
    return data.jira?.bulkOperationProgress ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dCXqh.ProcessResponse), {
        fragmentRef: data.jira.bulkOperationProgress,
        onStopRetry: clearRetryInterval,
        retryStatus: retryStatus
    }) : null;
};

});
parcelRegister("8cuDP", function(module, exports) {

$parcel$export(module.exports, "generateButtonAction", () => $6c52ae02037233ac$export$523c4156c8b6dfec);
$parcel$export(module.exports, "getAnalyticsMeta", () => $6c52ae02037233ac$export$f43befd82d0c5b42);
const $6c52ae02037233ac$export$523c4156c8b6dfec = ({ onClick: onClick, text: text, width: width, onFocus: onFocus, appearance: appearance })=>({
        onClick: onClick,
        onFocus: onFocus,
        text: text,
        appearance: appearance,
        theme: (current, themeProps)=>appearance === 'link' ? {
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    color: "var(--ds-text-discovery, #5E4DB2)"
                },
                spinnerStyles: current(themeProps).spinnerStyles
            } : {
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    backgroundColor: "var(--ds-icon-discovery, #8270DB)",
                    color: "var(--ds-text-inverse, #FFFFFF)",
                    width: width && width
                },
                spinnerStyles: current(themeProps).spinnerStyles
            }
    });
const $6c52ae02037233ac$export$f43befd82d0c5b42 = (id)=>({
        id: id,
        packageName: 'jiraBulkOperationsCommon',
        teamName: 'deliveroo'
    });

});

parcelRegister("dCXqh", function(module, exports) {

$parcel$export(module.exports, "ProcessResponse", () => $14b2ad7a3e4a1b5b$export$e9b0d96d75994f3f);

var $6Y7c3 = parcelRequire("6Y7c3");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jcw0u = parcelRequire("jcw0u");

var $8cuDP = parcelRequire("8cuDP");

var $lWYYR = parcelRequire("lWYYR");
const $14b2ad7a3e4a1b5b$export$7f111648ca05f056 = 'bulkEditProgressPolling';
const $14b2ad7a3e4a1b5b$var$CANCELLED = 'CANCELLED';
const $14b2ad7a3e4a1b5b$var$DEAD = 'DEAD';
const $14b2ad7a3e4a1b5b$var$FAILED = 'FAILED';
const $14b2ad7a3e4a1b5b$var$COMPLETE = 'COMPLETE';
const $14b2ad7a3e4a1b5b$export$e8667bfb18d4707c = [
    $14b2ad7a3e4a1b5b$var$CANCELLED,
    $14b2ad7a3e4a1b5b$var$DEAD,
    $14b2ad7a3e4a1b5b$var$FAILED
];
const $14b2ad7a3e4a1b5b$export$e9b0d96d75994f3f = /*#__PURE__*/ (0, $5uXOq.memo)(({ fragmentRef: fragmentRef, onStopRetry: onStopRetry, retryStatus: retryStatus })=>{
    const { setError: setError, setSuccess: setSuccess, updateProgress: updateProgress, setPartialError: setPartialError } = (0, $lWYYR.useBulkOperationsFormSubmissionActions)();
    const data = (0, $8Uumt.useFragment)((0, $6Y7c3.default), fragmentRef);
    const { status: status, totalIssueCount: totalIssueCount, progress: progress, failedAccessibleIssues: failedAccessibleIssues } = data;
    const { failedIds: failedIds, failedKeys: failedKeys } = (0, $5uXOq.useMemo)(()=>{
        const initial = {
            failedIds: [],
            failedKeys: []
        };
        return (failedAccessibleIssues?.edges || []).reduce((acc, curr)=>{
            const issue = curr?.node?.issue;
            if (issue?.issueId) acc.failedIds.push(Number(issue.issueId));
            if (issue?.key) acc.failedKeys.push(issue.key);
            return acc;
        }, initial);
    }, [
        failedAccessibleIssues
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (retryStatus !== 'underLimit') return;
        const isProgressFinished = status === $14b2ad7a3e4a1b5b$var$COMPLETE || $14b2ad7a3e4a1b5b$export$e8667bfb18d4707c.includes(status);
        const isPartialError = (status === $14b2ad7a3e4a1b5b$var$FAILED || status === $14b2ad7a3e4a1b5b$var$COMPLETE) && totalIssueCount && failedAccessibleIssues?.edges?.length;
        if (status === $14b2ad7a3e4a1b5b$var$COMPLETE && !totalIssueCount) (0, $jcw0u.default)({
            meta: (0, $8cuDP.getAnalyticsMeta)($14b2ad7a3e4a1b5b$export$7f111648ca05f056),
            error: new Error('jira.bulkOperationProgress.totalIssueCount is 0, null or undefined on task complete'),
            attributes: {
                totalIssueCount: totalIssueCount,
                failures: JSON.stringify(failedAccessibleIssues)
            }
        });
        if (isProgressFinished) {
            if (isPartialError) {
                const failedCount = failedIds.length;
                setPartialError(totalIssueCount, failedCount, failedKeys, failedIds.map(Number));
            } else if (status !== $14b2ad7a3e4a1b5b$var$COMPLETE) setError();
            onStopRetry();
            if (!isPartialError && status === $14b2ad7a3e4a1b5b$var$COMPLETE) setSuccess(totalIssueCount || 0);
            return;
        }
        if (progress) updateProgress(progress / 100);
    }, [
        failedAccessibleIssues,
        failedAccessibleIssues?.edges?.length,
        failedIds,
        failedKeys,
        onStopRetry,
        progress,
        retryStatus,
        setError,
        setPartialError,
        setSuccess,
        status,
        totalIssueCount,
        updateProgress
    ]);
    return null;
});

});
parcelRegister("6Y7c3", function(module, exports) {

$parcel$export(module.exports, "default", () => $253e67fdaf7e1c3a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ac9d636d8d9008c1a9afc7eb05dd5e9e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $253e67fdaf7e1c3a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "processResponse_bulkOperationsCommon",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "progress"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        },
        {
            "kind": "ScalarField",
            "name": "totalIssueCount"
        },
        {
            "concreteType": "JiraIssueBulkOperationFailureConnection",
            "kind": "LinkedField",
            "name": "failedAccessibleIssues",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueBulkOperationFailureEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraIssueBulkOperationFailure",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "issue",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "issueId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueBulkOperationProgress"
};
$253e67fdaf7e1c3a$var$node.hash = "6fd178055d35ff262e914a98799a4f45";
var $253e67fdaf7e1c3a$export$2e2bcd8739ae039 = $253e67fdaf7e1c3a$var$node;

});


parcelRegister("4ZuCq", function(module, exports) {

$parcel$export(module.exports, "useAllowedRetries", () => $49861852d9be3429$export$4ae93933b6be0be6);
$parcel$export(module.exports, "useRetryInterval", () => $49861852d9be3429$export$f61ff7daea15ab2c);

var $5uXOq = parcelRequire("5uXOq");
const $49861852d9be3429$export$dc3de1463a3f7c7c = 5;
const $49861852d9be3429$export$9359b1dc19be60fe = 2;
const $49861852d9be3429$export$996964a131ee58eb = 1500;
const $49861852d9be3429$export$4ae93933b6be0be6 = ()=>{
    const [retryStatus, setRetryStatus] = (0, $5uXOq.useState)('underLimit');
    const numberOfAttempts = (0, $5uXOq.useRef)(0);
    const isPreviousTaskError = (0, $5uXOq.useRef)();
    const logRetryAttempt = (0, $5uXOq.useCallback)((isTaskError)=>{
        if (isPreviousTaskError.current !== undefined && isPreviousTaskError.current !== isTaskError) numberOfAttempts.current = 0;
        numberOfAttempts.current += 1;
        if (numberOfAttempts.current >= (isTaskError ? $49861852d9be3429$export$9359b1dc19be60fe : $49861852d9be3429$export$dc3de1463a3f7c7c)) setRetryStatus(isTaskError ? 'maxTaskErrorAttemptsReached' : 'maxAttemptsReached');
        isPreviousTaskError.current = isTaskError;
    }, []);
    const resetRetryCount = (0, $5uXOq.useCallback)(()=>{
        setRetryStatus('underLimit');
        numberOfAttempts.current = 0;
    }, []);
    return {
        logRetryAttempt: logRetryAttempt,
        retryStatus: retryStatus,
        resetRetryCount: resetRetryCount
    };
};
const $49861852d9be3429$export$f61ff7daea15ab2c = (taskId, callback)=>{
    const callbackRef = (0, $5uXOq.useRef)(callback);
    (0, $5uXOq.useEffect)(()=>{
        // make a reference to the retry callback for setInterval to invoke.
        callbackRef.current = callback;
    }, [
        callback
    ]);
    const intervalId = (0, $5uXOq.useRef)();
    const clearRetryInterval = (0, $5uXOq.useCallback)(()=>{
        if (intervalId.current) {
            clearInterval(intervalId.current);
            intervalId.current = undefined;
        }
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (taskId) {
            const retry = ()=>{
                callbackRef.current();
            };
            intervalId.current = typeof window !== 'undefined' ? window.setInterval(retry, $49861852d9be3429$export$996964a131ee58eb) : undefined;
        }
        return clearRetryInterval;
    }, [
        clearRetryInterval,
        taskId
    ]);
    return clearRetryInterval;
};

});



parcelRegister("6B3QB", function(module, exports) {

$parcel$export(module.exports, "useEditFormStatusFlags", () => $28ccccb1017e9f12$export$7aafd3aa5686e9e5);

var $5uXOq = parcelRequire("5uXOq");

var $iAbh9 = parcelRequire("iAbh9");

var $5ZcSp = parcelRequire("5ZcSp");

var $1a1SF = parcelRequire("1a1SF");

var $4qiYI = parcelRequire("4qiYI");

var $eAH0D = parcelRequire("eAH0D");

var $KgqBB = parcelRequire("KgqBB");
const $28ccccb1017e9f12$export$7aafd3aa5686e9e5 = ()=>{
    const bulkOpsFlow = (0, $iAbh9.useBulkOpsSessionContext)();
    const renderInProgressFlag = (0, $5uXOq.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4qiYI.InProgressFlag), props), []);
    const renderSuccessFlag = (0, $5uXOq.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $KgqBB.OperationSuccessFlag), {
            ...props,
            bulkOpsFlow: bulkOpsFlow
        }), [
        bulkOpsFlow
    ]);
    const renderErrorFlag = (0, $5uXOq.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1a1SF.OperationErrorFlag), {
            ...props,
            bulkOpsFlow: bulkOpsFlow
        }), [
        bulkOpsFlow
    ]);
    const renderPartialErrorFlag = (0, $5uXOq.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eAH0D.OperationPartialErrorFlag), {
            ...props,
            bulkOpsFlow: bulkOpsFlow
        }), [
        bulkOpsFlow
    ]);
    (0, $5ZcSp.useFormStatusFlags)({
        renderInProgressFlag: renderInProgressFlag,
        renderSuccessFlag: renderSuccessFlag,
        renderErrorFlag: renderErrorFlag,
        renderPartialErrorFlag: renderPartialErrorFlag
    });
};

});
parcelRegister("1a1SF", function(module, exports) {

$parcel$export(module.exports, "OperationErrorFlag", () => $eaaa41da1a7ecf26$export$e8ce457da529d993);

var $5uXOq = parcelRequire("5uXOq");

var $3KRpp = parcelRequire("3KRpp");

var $koVbs = parcelRequire("koVbs");

var $lFyfa = parcelRequire("lFyfa");

var $lWYYR = parcelRequire("lWYYR");


var $5spBe = parcelRequire("5spBe");
const $eaaa41da1a7ecf26$export$e8ce457da529d993 = ({ onDismissed: onDismissed, bulkOpsFlow: bulkOpsFlow, ...props })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const issueIds = (0, $lWYYR.useFormSubmitIssueIds)();
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
            numSelectedCards: issueIds.length ?? 0,
            flagType: 'error'
        }), [
        issueIds.length
    ]);
    (0, $lFyfa.useFlagAnalytics)(analyticsAttributes, bulkOpsFlow);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.ErrorFlag), {
        ...props,
        testId: (0, $2ab1dd31d2bd7e94$export$a7bb072605d6094c),
        id: (0, $2ab1dd31d2bd7e94$export$5881677fb314e6d9),
        title: formatMessage((0, $5spBe.default).title),
        description: formatMessage((0, $5spBe.default).description),
        onDismissed: onDismissed,
        messageId: "bulk-operations-common.ui.submit-status.flags.error-flag",
        messageType: "transactional"
    });
};

});
parcelRegister("lFyfa", function(module, exports) {

$parcel$export(module.exports, "useFlagAnalytics", () => $962929ab66118301$export$f367641684fed076);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $962929ab66118301$export$f367641684fed076 = (attributes, bulkOpsFlow)=>{
    const analyticsEventFired = (0, $5uXOq.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (!analyticsEventFired.current) {
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'bulkProcess',
                action: 'complete'
            });
            const actionSubjectId = bulkOpsFlow?.bulkOperationType;
            const analyticsAttributes = {
                ...attributes,
                bulkOpsSessionID: bulkOpsFlow?.sessionID
            };
            if (actionSubjectId) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, actionSubjectId, analyticsAttributes);
            else (0, $8zOmE.fireUIAnalytics)(analyticsEvent, analyticsAttributes);
            bulkOpsFlow?.setBulkOperationType(undefined);
            analyticsEventFired.current = true;
        }
    }, [
        createAnalyticsEvent,
        bulkOpsFlow,
        attributes
    ]);
};

});

const $2ab1dd31d2bd7e94$export$5881677fb314e6d9 = 'bulk-operations-core.edit-form.edit-form-status-flags.error-flag';
const $2ab1dd31d2bd7e94$export$a7bb072605d6094c = 'bulk-operations-core.ui.edit-form.edit-form-status-flags.error-flag';

parcelRegister("5spBe", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f294a6f2114edb8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8f294a6f2114edb8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "bulk-operations-common.submit-status.flags.error-flag.title",
        "defaultMessage": "Failed to update"
    },
    description: {
        "id": "bulk-operations-common.submit-status.flags.error-flag.description",
        "defaultMessage": "We were unable to make those changes. Try again, or view the items that failed to update."
    }
});

});


parcelRegister("4qiYI", function(module, exports) {

$parcel$export(module.exports, "InProgressFlag", () => $d48b48811f386cd7$export$e75d6d3573e1e6fe);

var $5uXOq = parcelRequire("5uXOq");

var $1jWct = parcelRequire("1jWct");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $32MQk = parcelRequire("32MQk");

var $3KRpp = parcelRequire("3KRpp");

var $koVbs = parcelRequire("koVbs");

var $lWYYR = parcelRequire("lWYYR");


var $467wt = parcelRequire("467wt");
const $d48b48811f386cd7$export$e75d6d3573e1e6fe = ({ onDismissed: onDismissed, ...props })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const progressData = (0, $lWYYR.useFormSubmitProgressData)();
    const progress = progressData?.progress;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.InfoFlag), {
        ...props,
        testId: (0, $8d8e2c7303082419$export$a7bb072605d6094c),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1jWct))), {
            spacing: "spacious",
            color: "var(--ds-icon-information, #1D7AFC)",
            label: ""
        }),
        id: (0, $8d8e2c7303082419$export$5881677fb314e6d9),
        title: formatMessage((0, $467wt.default).title),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, $467wt.default).description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $d48b48811f386cd7$var$progressBarContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $32MQk.default), {
            ariaLabel: formatMessage((0, $467wt.default).title),
            isIndeterminate: !progress,
            value: progress
        }))),
        onDismissed: onDismissed,
        messageId: "bulk-operations-common.ui.submit-status.flags.in-progress-flag.info-flag.in-progress-flag",
        messageType: "transactional"
    });
};
const $d48b48811f386cd7$var$progressBarContainerStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.200'
});

});
parcelRegister("32MQk", function(module, exports) {

$parcel$export(module.exports, "default", () => $baa3bacea9c957c9$export$2e2bcd8739ae039);
/* progress-bar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");
const $baa3bacea9c957c9$var$MIN_VALUE = 0;
const $baa3bacea9c957c9$var$MAX_VALUE = 1;
const $baa3bacea9c957c9$var$increasingBarAnimation = null;
const $baa3bacea9c957c9$var$decreasingBarAnimation = null;
const $baa3bacea9c957c9$var$containerStyles = null;
const $baa3bacea9c957c9$var$containerAppearance = {
    default: "_bfhk1t45",
    success: "_bfhk1t45",
    inverse: "_bfhklgn7"
};
const $baa3bacea9c957c9$var$barAppearance = {
    default: "_bfhk1wby",
    success: "_bfhk1bh5",
    inverse: "_bfhkvuon"
};
const $baa3bacea9c957c9$var$barStyles = null;
const $baa3bacea9c957c9$var$determinateBarStyles = null;
const $baa3bacea9c957c9$var$increasingBarStyles = null;
const $baa3bacea9c957c9$var$decreasingBarStyles = null;
/**
 * __Progress bar__
 *
 * A progress bar displays the status of a given process.
 *
 * - [Examples](https://atlassian.design/components/progress-bar/examples)
 * - [Code](https://atlassian.design/components/progress-bar/code)
 * - [Usage](https://atlassian.design/components/progress-bar/usage)
 */ const $baa3bacea9c957c9$var$ProgressBar = ({ appearance: appearance = 'default', ariaLabel: ariaLabel, isIndeterminate: isIndeterminate = false, testId: testId = 'progress-bar', value: value = 0 })=>{
    const valueParsed = isIndeterminate ? $baa3bacea9c957c9$var$MIN_VALUE : Math.max($baa3bacea9c957c9$var$MIN_VALUE, Math.min(value, $baa3bacea9c957c9$var$MAX_VALUE));
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "progressbar",
        "aria-label": ariaLabel,
        "aria-valuemin": $baa3bacea9c957c9$var$MIN_VALUE,
        "aria-valuenow": valueParsed,
        "aria-valuemax": $baa3bacea9c957c9$var$MAX_VALUE,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_2rko1sit _1reo15vq _18m915vq _1bsb1osq _4t3ii2wt _kqswh2mm _bfhk1t45",
            $baa3bacea9c957c9$var$containerAppearance[appearance]
        ]),
        children: isIndeterminate ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    className: (0, $bwpsq.default)([
                        "_2rko1sit _1e0c1ule _4t3ii2wt _kqswstnw",
                        $baa3bacea9c957c9$var$barAppearance[appearance],
                        "_5sagymdr _tip812c5 _j7hq7g40"
                    ])
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    className: (0, $bwpsq.default)([
                        "_2rko1sit _1e0c1ule _4t3ii2wt _kqswstnw",
                        $baa3bacea9c957c9$var$barAppearance[appearance],
                        "_ju251bs3 _5sagymdr _tip812c5 _j7hqio0v"
                    ])
                })
            ]
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            style: {
                width: `${Number(value) * 100}%`
            },
            className: (0, $bwpsq.default)([
                "_2rko1sit _1e0c1ule _4t3ii2wt _kqswstnw",
                $baa3bacea9c957c9$var$barAppearance[appearance],
                "_v564calv"
            ])
        })
    });
};
var $baa3bacea9c957c9$export$2e2bcd8739ae039 = $baa3bacea9c957c9$var$ProgressBar;

});

const $8d8e2c7303082419$export$5881677fb314e6d9 = 'bulk-operations-core.edit-form.edit-form-status-flags.in-progress-flag';
const $8d8e2c7303082419$export$a7bb072605d6094c = 'bulk-operations-core.ui.edit-form.edit-form-status-flags.in-progress-flag';

parcelRegister("467wt", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad0f48248e41a6f7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ad0f48248e41a6f7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "bulk-operations-common.submit-status.flags.in-progress-flag.title",
        "defaultMessage": "Bulk action in progress"
    },
    description: {
        "id": "bulk-operations-common.submit-status.flags.in-progress-flag.description",
        "defaultMessage": "Stay on this page until the bulk action is finished."
    }
});

});


parcelRegister("eAH0D", function(module, exports) {

$parcel$export(module.exports, "OperationPartialErrorFlag", () => $3e92f97fd9b21aaf$export$3229b80e24d6bab4);

var $5uXOq = parcelRequire("5uXOq");

var $3KRpp = parcelRequire("3KRpp");

var $5Zxxp = parcelRequire("5Zxxp");

var $koVbs = parcelRequire("koVbs");

var $lFyfa = parcelRequire("lFyfa");

var $lWYYR = parcelRequire("lWYYR");


var $3sBIG = parcelRequire("3sBIG");
const $3e92f97fd9b21aaf$export$3229b80e24d6bab4 = ({ onDismissed: onDismissed, bulkOpsFlow: bulkOpsFlow, ...props })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const issueIds = (0, $lWYYR.useFormSubmitIssueIds)();
    const errorData = (0, $lWYYR.useFormSubmitErrorData)();
    const openInProductHelp = (0, $5Zxxp.useHelpPanelLink)();
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
            numSelectedCards: issueIds.length ?? 0,
            numFailedCards: errorData?.failedCount ?? 0,
            failedIssueKeys: errorData?.issueKeys ?? [],
            flagType: 'error'
        }), [
        errorData?.failedCount,
        errorData?.issueKeys,
        issueIds.length
    ]);
    (0, $lFyfa.useFlagAnalytics)(analyticsAttributes, bulkOpsFlow);
    const getViewSummaryURL = (0, $5uXOq.useMemo)(()=>{
        const errorDataIssueIds = errorData?.issueKeys?.join(',');
        const jqlSearch = encodeURIComponent(`issueKey in (${errorDataIssueIds})`);
        return `/issues/?jql=${jqlSearch}`;
    }, [
        errorData?.issueKeys
    ]);
    const handleLearnMoreClick = (0, $5uXOq.useCallback)(()=>{
        openInProductHelp((0, $cd9a3566c0552310$export$353a2cc7a64c70f2));
    }, [
        openInProductHelp
    ]);
    const flagActions = (0, $5uXOq.useMemo)(()=>[
            {
                content: formatMessage((0, $3sBIG.default).viewSummary),
                href: getViewSummaryURL,
                target: '_blank'
            },
            {
                content: formatMessage((0, $3sBIG.default).learnMore),
                onClick: handleLearnMoreClick
            }
        ], [
        formatMessage,
        getViewSummaryURL,
        handleLearnMoreClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.ErrorFlag), {
        ...props,
        testId: (0, $cd9a3566c0552310$export$a7bb072605d6094c),
        id: (0, $cd9a3566c0552310$export$5881677fb314e6d9),
        title: formatMessage((0, $3sBIG.default).title, {
            failedCount: errorData?.failedCount,
            totalCount: errorData?.totalCount
        }),
        description: formatMessage((0, $3sBIG.default).description),
        onDismissed: onDismissed,
        messageId: "bulk-operations-common.ui.submit-status.flags.partial-error-flag.error-flag",
        messageType: "transactional",
        actions: flagActions
    });
};

});
const $cd9a3566c0552310$export$5881677fb314e6d9 = 'bulk-operations-core.edit-form.edit-form-status-flags.partial-error-flag';
const $cd9a3566c0552310$export$a7bb072605d6094c = 'bulk-operations-core.ui.edit-form.edit-form-status-flags.partial-error-flag';
const $cd9a3566c0552310$export$353a2cc7a64c70f2 = '62h4g5fA9BUhungZSSNyEl';

parcelRegister("3sBIG", function(module, exports) {

$parcel$export(module.exports, "default", () => $d677c629c32f2537$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d677c629c32f2537$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "bulk-operations-common.submit-status.flags.partial-error-flag.title",
        "defaultMessage": "{failedCount}/{totalCount} items not updated"
    },
    description: {
        "id": "bulk-operations-common.submit-status.flags.partial-error-flag.description",
        "defaultMessage": "We were unable to update some of the items. View summary to view the items that failed to update."
    },
    viewSummary: {
        "id": "bulk-operations-common.submit-status.flags.partial-error-flag.view-summary",
        "defaultMessage": "View summary"
    },
    learnMore: {
        "id": "bulk-operations-common.submit-status.flags.partial-error-flag.learn-more",
        "defaultMessage": "Learn more"
    }
});

});


parcelRegister("KgqBB", function(module, exports) {

$parcel$export(module.exports, "OperationSuccessFlag", () => $bce6226a9eee46d7$export$3a6420f74b01547e);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $3KRpp = parcelRequire("3KRpp");

var $koVbs = parcelRequire("koVbs");

var $lFyfa = parcelRequire("lFyfa");

var $lWYYR = parcelRequire("lWYYR");


var $6Kmv8 = parcelRequire("6Kmv8");
const $bce6226a9eee46d7$export$3a6420f74b01547e = ({ onDismissed: onDismissed, bulkOpsFlow: bulkOpsFlow, ...props })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const flagData = (0, $lWYYR.useFormSubmitFlagData)();
    const issueIds = (0, $lWYYR.useFormSubmitIssueIds)();
    const count = (0, $5uXOq.useRef)((0, $lWYYR.useFormSubmitSuccessData)());
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
            numSelectedCards: issueIds.length,
            flagType: 'success',
            numCardsUpdated: count.current
        }), [
        issueIds.length
    ]);
    (0, $lFyfa.useFlagAnalytics)(analyticsAttributes, bulkOpsFlow);
    const flagDescription = (0, $5uXOq.useMemo)(()=>{
        if (flagData && flagData.customDescription && (0, $6s1PB.expVal)('bulk_watch_unwatch', 'isEnabled', false)) return flagData.customDescription;
        if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return formatMessage((0, $6Kmv8.default).descriptionIssueTermRefresh, {
            count: count.current
        });
        return formatMessage((0, $6Kmv8.default).description, {
            count: count.current
        });
    }, [
        flagData,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.SuccessFlag), {
        ...props,
        testId: (0, $e16d5662adf0a415$export$a7bb072605d6094c),
        id: (0, $e16d5662adf0a415$export$5881677fb314e6d9),
        title: formatMessage((0, $6Kmv8.default).title),
        description: flagDescription,
        onDismissed: onDismissed,
        messageId: "bulk-operations-common.ui.submit-status.flags.success-flag",
        messageType: "transactional"
    });
};

});
const $e16d5662adf0a415$export$5881677fb314e6d9 = 'bulk-operations-core.edit-form.edit-form-status-flags.submit-success-flag';
const $e16d5662adf0a415$export$a7bb072605d6094c = 'bulk-operations-core.ui.edit-form.edit-form-status-flags.operation-success-flag';

parcelRegister("6Kmv8", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecab86bc54831efa$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ecab86bc54831efa$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "bulk-operations-common.submit-status.flags.success-flag.title",
        "defaultMessage": "Bulk action complete"
    },
    description: {
        "id": "bulk-operations-common.submit-status.flags.success-flag.description",
        "defaultMessage": "You\u2019ve edited {count, plural, one {# issue} other {# issues}}."
    },
    descriptionIssueTermRefresh: {
        "id": "bulk-operations-common.submit-status.flags.success-flag.description-issue-term-refresh",
        "defaultMessage": "You\u2019ve edited {count, plural, one {# work item} other {# work items}}."
    }
});

});





parcelRegister("3lQDd", function(module, exports) {

$parcel$export(module.exports, "AgentPickerBulk", () => $6b8057548f8ac80b$export$5b1ad97133b8696f);
$parcel$export(module.exports, "useFloatingtoolbarPickerContentAction", () => $6b8057548f8ac80b$export$58018e13ca8ef41);

var $d42oA = parcelRequire("d42oA");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $eZJjh = parcelRequire("eZJjh");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $hYRTO = parcelRequire("hYRTO");

var $4V6HW = parcelRequire("4V6HW");

var $4R6GH = parcelRequire("4R6GH");

var $7CMCs = parcelRequire("7CMCs");

var $koeKL = parcelRequire("koeKL");

var $fo4yK = parcelRequire("fo4yK");

var $d42oA = parcelRequire("d42oA");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $90yGq = parcelRequire("90yGq");

var $a4KlA = parcelRequire("a4KlA");

var $5yJb9 = parcelRequire("5yJb9");

var $6uqUb = parcelRequire("6uqUb");

var $llaYv = parcelRequire("llaYv");

var $dzV1a = parcelRequire("dzV1a");
const $6b8057548f8ac80b$var$AgentPickerBulkInner = ({ queryRef: queryRef, issueIds: issueIds, menuContextLocation: menuContextLocation, onClose: onClose })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const issueAris = issueIds.map((issueId)=>(0, $llaYv.createIssueAri)(cloudId, issueId));
    const data = (0, $8Uumt.usePreloadedQuery)((0, $d42oA.default), queryRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$d1123261ca8831d2),
        sourceName: "agentPickerBulk",
        attributes: {
            menuContext: menuContextLocation,
            numIssues: issueIds.length
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        eventName: "viewed popupContent"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fo4yK.PickerContent), {
        jobRef: null,
        agentsFragRef: data,
        issueAris: issueAris,
        jobListRelayStoreId: null,
        onClose: onClose
    }));
};
const $6b8057548f8ac80b$var$Loading = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $6b8057548f8ac80b$var$loadingWrapperStyles,
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "medium"
    }));
};
const $6b8057548f8ac80b$export$8a7ad05c3ee0c78a = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        justifyContent: "center",
        xcss: $6b8057548f8ac80b$var$errorWrapperStyles
    }, formatMessage((0, $dzV1a.default).unexpectedErrorMessage));
};
const $6b8057548f8ac80b$export$2cabe1cf2f1a6a15 = (props)=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { issueIds: issueIds } = props;
    const issueAris = issueIds.map((issueId)=>(0, $llaYv.createIssueAri)(cloudId, issueId));
    const memoizedIssueAris = (0, $llaYv.useMemoizedIssueAris)(issueAris);
    const [queryRef, loadQuery] = (0, $8Uumt.useQueryLoader)((0, $d42oA.default));
    (0, $5uXOq.useEffect)(()=>{
        loadQuery({
            cloudId: cloudId,
            issueAris: memoizedIssueAris
        });
    }, [
        cloudId,
        memoizedIssueAris,
        loadQuery
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hYRTO.default), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6b8057548f8ac80b$var$Loading, null),
        name: "jiraAutodevBacklogAgentPicker"
    }, queryRef == null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6b8057548f8ac80b$var$Loading, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6b8057548f8ac80b$var$AgentPickerBulkInner, {
        queryRef: queryRef,
        ...props
    }));
};
const $6b8057548f8ac80b$export$5b1ad97133b8696f = (props)=>{
    const agentMenuOpenExpFail = (0, $6uqUb.useAgentPickerBulkOpenMenuExpFail)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: $6b8057548f8ac80b$export$8a7ad05c3ee0c78a,
        packageName: "jiraAutodevBacklogAgentPicker",
        teamName: "Autodev",
        id: "use-agent-backlog-menu-item",
        sendToPrivacyUnsafeSplunk: true,
        onError: (location, error)=>{
            agentMenuOpenExpFail(location, error);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6b8057548f8ac80b$export$2cabe1cf2f1a6a15, props));
};
const $6b8057548f8ac80b$export$58018e13ca8ef41 = (issueIds)=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const agentMenuOpenExpStart = (0, $6uqUb.useAgentPickerBulkOpenMenuExpStart)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const atlassianAccountId = (0, $90yGq.useAccountId)();
    const [isAutoDevEnabled] = (0, $a4KlA.useIsAutoDevEnabled)(atlassianAccountId, cloudId, (0, $5yJb9.default)());
    if (!(0, $4R6GH.fg)('autodev-verticals-bulk-agents-backlog') || !isAutoDevEnabled) return [];
    return [
        {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($4V6HW))),
            name: formatMessage((0, $dzV1a.default).useAgentLabel),
            type: 'popup',
            role: 'menu',
            isOpen: isOpen,
            onClick: ()=>{
                if (!isOpen) agentMenuOpenExpStart();
                setIsOpen(!isOpen);
            },
            onClose: ()=>{
                setIsOpen(false);
            },
            content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6b8057548f8ac80b$export$5b1ad97133b8696f, {
                    issueIds: issueIds.map(String),
                    menuContextLocation: "backlog_bulk_action_toolbar",
                    onClose: ()=>setIsOpen(false)
                })
        }
    ];
};
const $6b8057548f8ac80b$var$loadingWrapperStyles = (0, $8CUq3.xcss)({
    width: '320px',
    height: '280px'
});
const $6b8057548f8ac80b$var$errorWrapperStyles = (0, $8CUq3.xcss)({
    width: '320px',
    padding: 'space.200'
});

});
parcelRegister("d42oA", function(module, exports) {

$parcel$export(module.exports, "default", () => $1620b04b8dd7e52a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<91f6198a6af2d06eb560f9d77cf41b8c>>
 * @relayHash ea0362969658f3f13a71b84dce4ae5a7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 557b7eb486bef62394d91c3ca7042f73f84419b128c3df13eaab034514badcaf

var $4FMJN = parcelRequire("4FMJN");
const $1620b04b8dd7e52a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueAris"
    }, v2 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ui_autodevAgentPickerBulkQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "issueAris",
                            "variableName": "issueAris"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "pickerContent_autodevAgentPicker_agentsFragRef"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcautodevisverticalsagentpickerenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "ui_autodevAgentPickerBulkQuery",
            "selections": [
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcautodevisverticalsagentpickerenabledrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 20
                                },
                                {
                                    "kind": "Variable",
                                    "name": "issueIds",
                                    "variableName": "issueAris"
                                }
                            ],
                            "concreteType": "DevAiRovoAgentConnection",
                            "kind": "LinkedField",
                            "name": "devai_autodevRovoAgents",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isRankingLimitApplied"
                                },
                                {
                                    "concreteType": "DevAiRovoAgentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "DevAiRovoAgent",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "description"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "identityAccountId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "externalConfigReference"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "rankCategory"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "devai_autodevRovoTemplates",
                            "args": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 1
                                },
                                {
                                    "kind": "Literal",
                                    "name": "templatesFilter",
                                    "value": "ONLY"
                                }
                            ],
                            "concreteType": "DevAiRovoAgentConnection",
                            "kind": "LinkedField",
                            "name": "devai_autodevRovoAgents",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "DevAiRovoAgentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "DevAiRovoAgent",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "557b7eb486bef62394d91c3ca7042f73f84419b128c3df13eaab034514badcaf",
            "metadata": {},
            "name": "ui_autodevAgentPickerBulkQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcautodevisverticalsagentpickerenabledrelayprovider": (0, $4FMJN.default)
            }
        }
    };
}();
$1620b04b8dd7e52a$var$node.hash = "fac0ed7e2f112b00391a0c79b3d87b29";
var $1620b04b8dd7e52a$export$2e2bcd8739ae039 = $1620b04b8dd7e52a$var$node;

});
parcelRegister("4FMJN", function(module, exports) {

$parcel$export(module.exports, "default", () => $fde6a58ecda61f0c$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $fde6a58ecda61f0c$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('autodev_verticals_issueview_agent_dropdown_enabled');
    }
};

});


parcelRegister("4V6HW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ec2830ef4a5653740a2b8f60e21924b6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3951b0552a35072b$var$_react = $3951b0552a35072b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3951b0552a35072b$var$_baseNew = $3951b0552a35072b$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3951b0552a35072b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiAgent".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Rovo Agent.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3951b0552a35072b$var$AiAgentIcon = (props)=>/*#__PURE__*/ $3951b0552a35072b$var$_react.default.createElement($3951b0552a35072b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.971.493a2 2 0 0 1 2.058 0l5 3A2 2 0 0 1 15 5.208v5.584a2 2 0 0 1-.971 1.715l-5 3a2 2 0 0 1-2.058 0l-5-3A2 2 0 0 1 1 10.792V5.208a2 2 0 0 1 .971-1.715zm1.286 1.286a.5.5 0 0 0-.514 0l-5 3a.5.5 0 0 0-.243.429v5.584a.5.5 0 0 0 .243.429l1.098.66a4.25 4.25 0 1 1 8.318 0l1.098-.66a.5.5 0 0 0 .243-.429V5.208a.5.5 0 0 0-.243-.429zM8 8.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5" clip-rule="evenodd"/>`
    }, props));
$3951b0552a35072b$var$AiAgentIcon.displayName = 'AiAgentIcon';
var $3951b0552a35072b$var$_default = module.exports.default = $3951b0552a35072b$var$AiAgentIcon;

});

parcelRegister("fo4yK", function(module, exports) {

$parcel$export(module.exports, "PickerContentLoading", () => $9aa46efaed19eb31$export$b38b081229e865c);
$parcel$export(module.exports, "AgentPickerQueryWrapper", () => $9aa46efaed19eb31$export$8054c3ef46a1e408);
$parcel$export(module.exports, "PickerContent", () => $9aa46efaed19eb31$export$5e7537ebe01762a4);

var $7di1H = parcelRequire("7di1H");

var $i5a5S = parcelRequire("i5a5S");

var $2t4wB = parcelRequire("2t4wB");

var $jk2ED = parcelRequire("jk2ED");

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $5ILhZ = parcelRequire("5ILhZ");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $hyOJh = parcelRequire("hyOJh");

var $kY99m = parcelRequire("kY99m");

var $eZJjh = parcelRequire("eZJjh");

var $8S93R = parcelRequire("8S93R");

var $jSlaY = parcelRequire("jSlaY");

var $6uqUb = parcelRequire("6uqUb");

var $9fuVs = parcelRequire("9fuVs");

var $4R6GH = parcelRequire("4R6GH");

var $koeKL = parcelRequire("koeKL");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $hbznT = parcelRequire("hbznT");

var $1othz = parcelRequire("1othz");

var $kekQh = parcelRequire("kekQh");

var $7Fi3v = parcelRequire("7Fi3v");

var $bmKPg = parcelRequire("bmKPg");

var $5TzXF = parcelRequire("5TzXF");

var $6AbJv = parcelRequire("6AbJv");

var $21dMx = parcelRequire("21dMx");

var $fLMSN = parcelRequire("fLMSN");


var $e7nrc = parcelRequire("e7nrc");

var $gY6Pn = parcelRequire("gY6Pn");

var $Q234Y = parcelRequire("Q234Y");
const $9aa46efaed19eb31$export$8a82bff895521bd9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $9aa46efaed19eb31$var$searchIconWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hyOJh))), {
        spacing: "none",
        label: "",
        color: "var(--ds-icon, #44546F)"
    }));
const $9aa46efaed19eb31$export$b38b081229e865c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $9aa46efaed19eb31$var$loadingWrapperStyles,
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "medium"
    }));
const $9aa46efaed19eb31$export$8054c3ef46a1e408 = (props)=>{
    const data = (0, $8Uumt.usePreloadedQuery)((0, $jk2ED.default), props.queryRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9aa46efaed19eb31$export$5e7537ebe01762a4, {
        ...props,
        agentsFragRef: data
    });
};
const $9aa46efaed19eb31$export$5e7537ebe01762a4 = ({ jobRef: jobRef, onRefreshJob: onRefreshJob, agentsFragRef: agentsFragRef, setIsTriggeringAutodevInprogress: setIsTriggeringAutodevInprogress, issueAris: issueAris, jobListRelayStoreId: jobListRelayStoreId, onRunAutodevClicked: onRunAutodevClicked, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    // The standard URL must have projectKey path param
    const [projectKey = ''] = (0, $bmKPg.usePathParam)('projectKey');
    const cloudId = (0, $koeKL.useCloudId)();
    const job = (0, $8Uumt.useFragment)((0, $2t4wB.default), jobRef);
    const currentJobId = job?.id ?? null;
    const [isRestartConfirmationModalOpen, setIsRestartConfirmationModalOpen] = (0, $5uXOq.useState)(false);
    // This is to distinguish between real empty state or when user delete search string to empty
    // This is important(DO NOT REMOVE), not to make UI flakers when search string is removed from something to none
    const [hasBeenSearched, setHasBeenSearched] = (0, $5uXOq.useState)(false);
    const [selectedAgent, setSelectedAgent] = (0, $5uXOq.useState)(null);
    const [agentSearchStr, setAgentSearchStr] = (0, $5uXOq.useState)('');
    const onTriggerMutationCompleted = (0, $fLMSN.useOnTrigggerAgentMutationCompleted)(issueAris[0], ()=>{
        setIsTriggeringAutodevInprogress?.(true);
        // Forcibly refresh the job after triggering mutation is finished, until BE does this in triggeringAgent mutation in the future.
        onRefreshJob?.('network-only', ()=>setIsTriggeringAutodevInprogress?.(false));
    }, setIsTriggeringAutodevInprogress);
    const onTriggerMutationError = (0, $fLMSN.useOnTriggerAgentMutationError)(issueAris[0]);
    const { onTriggerMutationInBulkCompleted: onTriggerMutationInBulkCompleted, onTriggerMutationInBulkStarted: onTriggerMutationInBulkStarted, onTriggerMutationInBulkOverLimit: onTriggerMutationInBulkOverLimit } = (0, $fLMSN.useOnTrigggerAgentInBulkMutationCallbacks)(issueAris, projectKey);
    const onTriggerMutationInBulkError = (0, $fLMSN.useOnTriggerAgentInBulkMutationError)(issueAris, projectKey);
    const [data, refetch] = (0, $8Uumt.useRefetchableFragment)((0, $i5a5S.default), agentsFragRef);
    const [triggerAutodev] = (0, $8Uumt.useMutation)((0, $fLMSN.InvokeAgentMutation));
    const [deleteJob] = (0, $8Uumt.useMutation)((0, $7di1H.default));
    const [suspenselessRefetch, isRefetchLoading] = (0, $1othz.useSuspenselessRefetch)((0, $hbznT.default), refetch, {
        fetchPolicy: 'store-or-network' // Assume that agent is rarely changed, therefore choosing store-or-network
    });
    if (data == null) return null;
    const onSearchStrChange = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((searchStr)=>{
        if (searchStr !== '') setHasBeenSearched(true);
        setAgentSearchStr(searchStr);
        suspenselessRefetch({
            searchStr: searchStr,
            cloudId: cloudId,
            issueAris: issueAris,
            isVerticalsAgentPickerEnabled: (0, $4R6GH.fg)('autodev_verticals_issueview_agent_dropdown_enabled')
        });
    }, 300);
    const agents = (data.devai_autodevRovoAgents?.edges ?? []).filter(Boolean).map((edge)=>edge.node);
    const hasAutodevTemplates = (data.devai_autodevRovoTemplates?.edges ?? []).filter(Boolean).length > 0;
    const triggerAutodevJob = (agentId, agentName, analyticsEvent)=>{
        setIsTriggeringAutodevInprogress?.(true);
        // We try to maintain only one job per issue as per the requirement. If there is an existing job, we try to delete it together.
        // In the future when the mutation is moved to devai-service, we will delete job in triggerAgent mutation in BE, but for now we are deleting in FE.
        if (currentJobId != null) {
            const commonAttrs = {
                id: 'deleteJobTriggeringRovoAgent',
                jobId: currentJobId,
                agentId: agentId
            };
            deleteJob({
                variables: {
                    issueAri: issueAris[0],
                    jobId: currentJobId
                },
                onCompleted: (response)=>{
                    const result = response.jira?.devOps?.deleteAutodevJob;
                    if (result?.success !== true) (0, $kekQh.fireAutodevErrorAnalytics)({
                        ...commonAttrs,
                        error: new Error(result?.errors?.map((error)=>error?.message).join(', '))
                    });
                },
                onError: (error)=>{
                    (0, $kekQh.fireAutodevErrorAnalytics)({
                        ...commonAttrs,
                        error: error
                    });
                },
                updater: (store, response)=>{
                    (0, $fLMSN.onDeleteJobMutationUpdater)(store, response?.jira?.devOps?.deleteAutodevJob?.success ?? false, jobListRelayStoreId);
                },
                optimisticUpdater: (store)=>{
                    (0, $fLMSN.emptyJobListStore)(store, jobListRelayStoreId);
                }
            });
        }
        if ((0, $4R6GH.fg)('autodev_-_invoke_agent_slow_endpoint')) {
            // We will probably need a better way than this, but this should be pretty reliable for now. onRefreshJob is only needed in the issue view.
            // Intentionally defining named variable to indicate the meaning
            // Even for a single issue, we need to go to bulk run experience, since the result feedback UX differs.
            const isFromBacklog = onRefreshJob == null;
            if (isFromBacklog) {
                // We limit this to 20 for now. https://hello.atlassian.net/wiki/spaces/AIDO/pages/4966188488
                if (issueAris.length > (0, $da07cd02a4c3461e$export$59dc7fa89ac047ce)) {
                    onTriggerMutationInBulkOverLimit(issueAris.length);
                    return;
                }
                onClose?.();
                onTriggerMutationInBulkStarted(agentName, issueAris.length);
                (0, $fLMSN.triggerAutodevBulkSlowEndpoint)({
                    agentId: agentId,
                    agentName: agentName,
                    issueCount: issueAris.length,
                    issueAris: issueAris,
                    onTriggerMutationInBulkCompleted: onTriggerMutationInBulkCompleted,
                    onTriggerMutationInBulkError: onTriggerMutationInBulkError
                });
                return;
            }
            (0, $fLMSN.triggerAutodevSlowEndpoint)({
                agentId: agentId,
                issueAris: issueAris,
                onTriggerMutationCompleted: onTriggerMutationCompleted,
                onTriggerMutationError: onTriggerMutationError,
                setIsTriggeringAutodevInprogress: setIsTriggeringAutodevInprogress
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'autodevRunAgent', {
                agentId: agentId
            });
        } else {
            // Bulk does not work in this FG off case.
            const start = Date.now();
            triggerAutodev({
                variables: {
                    issueAri: issueAris[0],
                    agentId: agentId
                },
                onCompleted: (mutationResponse)=>{
                    const duration = Date.now() - start;
                    onTriggerMutationCompleted(mutationResponse, agentId, duration);
                },
                onError: (e)=>{
                    const duration = Date.now() - start;
                    setIsTriggeringAutodevInprogress?.(false);
                    onTriggerMutationError(agentId, duration, e);
                }
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'autodevRunAgent', {
                agentId: agentId
            });
        }
    };
    const runAutodev = (event, analyticEvent)=>{
        // We try to maintain only one job per issue as per the requirement. If there is an existing job, we try to delete it together.
        // In the future when the mutation is moved to devai-service, we will delete job in triggerAgent mutation in BE, but for now we are deleting in FE.
        if (currentJobId != null) {
            const commonAttrs = {
                id: 'deleteJobTriggeringRovoAgent',
                jobId: currentJobId
            };
            deleteJob({
                variables: {
                    issueAri: issueAris[0],
                    jobId: currentJobId
                },
                onCompleted: (response)=>{
                    const result = response.jira?.devOps?.deleteAutodevJob;
                    if (result?.success !== true) (0, $kekQh.fireAutodevErrorAnalytics)({
                        ...commonAttrs,
                        error: new Error(result?.errors?.map((error)=>error?.message).join(', '))
                    });
                    // It is important to trigger this when deletion is succesfully done, otherwise we will open Autodev modal with the existing job.
                    onRunAutodevClicked?.(event, analyticEvent);
                },
                onError: (error)=>{
                    (0, $kekQh.fireAutodevErrorAnalytics)({
                        ...commonAttrs,
                        error: error
                    });
                },
                updater: (store, response)=>{
                    (0, $fLMSN.onDeleteJobMutationUpdater)(store, response?.jira?.devOps?.deleteAutodevJob?.success ?? false, jobListRelayStoreId);
                },
                optimisticUpdater: (store)=>{
                    (0, $fLMSN.emptyJobListStore)(store, jobListRelayStoreId);
                }
            });
        } else onRunAutodevClicked?.(event, analyticEvent);
    };
    const onTriggerAutodevClicked = (agentId, agentName, event, analyticEvent)=>{
        if (currentJobId != null) {
            setIsRestartConfirmationModalOpen(true);
            setSelectedAgent({
                agentId: agentId,
                agentName: agentName,
                event: event,
                analyticEvent: analyticEvent
            });
        } else {
            if (agentId === 'AUTODEV') runAutodev(event, analyticEvent);
            else triggerAutodevJob(agentId, agentName, analyticEvent);
            onClose?.();
        }
    };
    const cancelRestartAutodev = ()=>{
        setSelectedAgent(null);
        setIsRestartConfirmationModalOpen(false);
        onClose?.();
    };
    const restartAutodev = ()=>{
        if (selectedAgent == null) return;
        if (selectedAgent.agentId === 'AUTODEV') runAutodev(selectedAgent.event, selectedAgent.analyticEvent);
        else triggerAutodevJob(selectedAgent.agentId, selectedAgent.agentName, selectedAgent.analyticEvent);
        setSelectedAgent(null);
        setIsRestartConfirmationModalOpen(false);
        onClose?.();
    };
    const isEmptyState = agents.length === 0 && agentSearchStr === '' && !hasBeenSearched;
    const isRankingLimitApplied = data.devai_autodevRovoAgents?.isRankingLimitApplied === true;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $9aa46efaed19eb31$var$contentWrapper
    }, !isEmptyState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $9aa46efaed19eb31$var$searchTextWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
        role: "searchbox",
        label: formatMessage((0, $6AbJv.default).triggerPlaceholder),
        onChange: ({ currentTarget: { value: value } })=>{
            onSearchStrChange(value);
        },
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9aa46efaed19eb31$export$8a82bff895521bd9, null),
        placeholder: formatMessage((0, $6AbJv.default).triggerPlaceholder),
        testId: "autodev-agent-picker.ui.picker-content.agent-search-input"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        justifyContent: "space-between",
        xcss: $9aa46efaed19eb31$var$agentLabelWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "UNSAFE_small",
        weight: "bold"
    }, formatMessage(isRankingLimitApplied ? (0, $6AbJv.default).codingAgents : (0, $6AbJv.default).suggestedAgents)))), !isEmptyState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        direction: "column",
        xcss: $9aa46efaed19eb31$var$agentListStyles
    }, agents.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $21dMx.EmptyAgentResult), null), agents.map((agent)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
            key: agent.id,
            xcss: $9aa46efaed19eb31$var$pressableButtonStyles,
            padding: "space.075",
            onClick: (_event, _analyticEvent)=>{
                onTriggerAutodevClicked(agent.id, agent.name, _event, _analyticEvent);
            },
            testId: "autodev-agent-picker.ui.picker-content.suggested-agent"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            xcss: $9aa46efaed19eb31$var$iconWrapperStyles,
            alignItems: "center",
            justifyContent: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8S93R.AgentAvatar), {
            // this plays important rule to determine the avatar icon and its color. This is exactly same as how BrowseAgent modal uses AgentAvatar component
            agentIdentityAccountId: agent.identityAccountId ?? null,
            agentId: agent.id,
            size: "small",
            showBorder: false,
            // This will be used to recognize OOTB agents
            agentNamedId: agent.externalConfigReference ?? undefined
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
            xcss: $9aa46efaed19eb31$var$titleSubTitleWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            alignItems: "center",
            justifyContent: "space-between"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            as: "span",
            xcss: $9aa46efaed19eb31$var$truncateTextStyles
        }, agent.name), agent.rankCategory === 'GOOD_MATCH' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Q234Y.GoodRankIndictor), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            as: "span",
            xcss: [
                $9aa46efaed19eb31$var$subLabelStyles,
                $9aa46efaed19eb31$var$truncateTextStyles
            ]
        }, agent.description ?? '')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: isRefetchLoading ? [
            $9aa46efaed19eb31$var$spinnerWrapperStyles
        ] : [
            $9aa46efaed19eb31$var$spinnerWrapperStyles,
            $9aa46efaed19eb31$var$spinnerWrapperHiddenStyles
        ],
        justifyContent: "center",
        alignItems: "center"
    }, isRefetchLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "medium"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e7nrc.BrowseTemplateModalDropdownItem), null), hasAutodevTemplates && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gY6Pn.CreateDeveloperAgentDropdownItem), null), onRunAutodevClicked != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
        xcss: [
            $9aa46efaed19eb31$var$pressableButtonStyles,
            $9aa46efaed19eb31$var$triggerWrapperStyles
        ],
        onClick: (event, analyticEvent)=>{
            onTriggerAutodevClicked('AUTODEV', 'AUTODEV', event, analyticEvent);
        },
        testId: "autodev-agent-picker.ui.picker-content.run-autodev-button",
        interactionName: (0, $7Fi3v.Interactions).AGENT_RUN_AUTODEV_BUTTON
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $9aa46efaed19eb31$var$iconWrapperStyles,
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jSlaY))), {
        label: formatMessage((0, $6AbJv.default).runAiCodingToolButtonLabel)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        xcss: $9aa46efaed19eb31$var$titleSubTitleWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span",
        xcss: [
            $9aa46efaed19eb31$var$subLabelStyles,
            $9aa46efaed19eb31$var$truncateTextStyles
        ]
    }, formatMessage((0, $6AbJv.default).runAiCodingToolButtonSubheading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span",
        xcss: [
            $9aa46efaed19eb31$var$truncateTextStyles
        ]
    }, formatMessage((0, $6AbJv.default).runAiCodingToolButtonLabel)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6uqUb.AgentPickerBulkOpenMenuExpSuccess), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6uqUb.AgentPickerSingleIssueOpenMenuExpSuccess), null)), isRestartConfirmationModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5TzXF.RestartConfirmationModal), {
        onRestart: restartAutodev,
        onCancel: cancelRestartAutodev
    }));
};
const $9aa46efaed19eb31$var$pressableButtonStyles = (0, $8CUq3.xcss)({
    background: 'none',
    font: 'inherit',
    cursor: 'pointer',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    display: 'flex',
    alignItems: 'center',
    gap: 'space.150',
    paddingInline: 'space.100',
    ':focus': {
        // This does not work now, but it will be fixed in the future by Design system team
        // Thread: https://atlassian.slack.com/archives/CFJ9DU39U/p1744091263720689
        outlineOffset: 'space.negative.025'
    },
    ':focus-visible': {
        // This does not work now, but it will be fixed in the future by Design system team
        // Thread: https://atlassian.slack.com/archives/CFJ9DU39U/p1744091263720689
        outlineOffset: 'space.negative.025'
    }
});
const $9aa46efaed19eb31$var$triggerWrapperStyles = (0, $8CUq3.xcss)({
    height: '48px',
    boxSizing: 'content-box',
    paddingBlock: 'space.025',
    // -(n)px should be aligned with paddingLeft+paddingRight amount ////
    width: 'calc(100% - 8px)',
    paddingLeft: 'space.100',
    paddingRight: 'space.0'
});
const $9aa46efaed19eb31$var$searchTextWrapperStyles = (0, $8CUq3.xcss)({
    padding: 'space.100'
});
const $9aa46efaed19eb31$var$contentWrapper = (0, $8CUq3.xcss)({
    maxWidth: '320px',
    width: '320px'
});
const $9aa46efaed19eb31$var$searchIconWrapperStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    marginRight: 'space.0',
    marginLeft: 'space.075'
});
const $9aa46efaed19eb31$var$agentLabelWrapperStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.100',
    marginBottom: 'space.100',
    paddingInline: 'space.100'
});
const $9aa46efaed19eb31$var$agentListStyles = (0, $8CUq3.xcss)({
    overflowY: 'auto',
    maxHeight: '180px',
    overflowX: 'hidden',
    position: 'relative',
    borderBottom: '1px solid',
    borderColor: 'color.border'
});
const $9aa46efaed19eb31$var$spinnerWrapperStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    top: '0',
    bottom: '0',
    left: '0',
    right: '0'
});
const $9aa46efaed19eb31$var$spinnerWrapperHiddenStyles = (0, $8CUq3.xcss)({
    display: 'none'
});
const $9aa46efaed19eb31$var$truncateTextStyles = (0, $8CUq3.xcss)({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $9aa46efaed19eb31$var$subLabelStyles = (0, $8CUq3.xcss)({
    minWidth: '0',
    color: 'color.text.subtlest',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $9aa46efaed19eb31$var$iconWrapperStyles = (0, $8CUq3.xcss)({
    width: '34px'
});
const $9aa46efaed19eb31$var$titleSubTitleWrapperStyles = (0, $8CUq3.xcss)({
    minWidth: '0',
    height: '100%',
    textAlign: 'left',
    flex: 1,
    justifyContent: 'center'
});
const $9aa46efaed19eb31$var$loadingWrapperStyles = (0, $8CUq3.xcss)({
    width: '320px',
    height: '280px'
});

});
parcelRegister("7di1H", function(module, exports) {

$parcel$export(module.exports, "default", () => $4aaea8de289d017a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<55ca3559b0cf46ddc25587fff5695354>>
 * @relayHash 03967eb9e177c3a1a352312198fc035e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 71c0ffe4f6a59417c860e1739d36f54c6c5cfdc03eafd674d14b1ddcd3b6f6e3
const $4aaea8de289d017a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jobId"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraDevOpsMutation",
                    "kind": "LinkedField",
                    "name": "devOps",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "issueAri",
                                    "variableName": "issueAri"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "jobId",
                                    "variableName": "jobId"
                                }
                            ],
                            "concreteType": "JiraAutodevBasicPayload",
                            "kind": "LinkedField",
                            "name": "deleteAutodevJob",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "success"
                                },
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "pickerContent_deleteJobMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "pickerContent_deleteJobMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "71c0ffe4f6a59417c860e1739d36f54c6c5cfdc03eafd674d14b1ddcd3b6f6e3",
            "metadata": {},
            "name": "pickerContent_deleteJobMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$4aaea8de289d017a$var$node.hash = "3960b60fc26cbe32f7f394c08faee40f";
var $4aaea8de289d017a$export$2e2bcd8739ae039 = $4aaea8de289d017a$var$node;

});

parcelRegister("i5a5S", function(module, exports) {

$parcel$export(module.exports, "default", () => $96a40644c8b18b7d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6c88aeb27eefb66b83de3ef8e1d8adc7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $hbznT = parcelRequire("hbznT");
const $96a40644c8b18b7d$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v1 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcautodevisverticalsagentpickerenabledrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "issueAris"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "searchStr"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "refetch": {
                "fragmentPathInResult": [],
                "operation": (0, $hbznT.default)
            }
        },
        "name": "pickerContent_autodevAgentPicker_agentsFragRef",
        "selections": [
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcautodevisverticalsagentpickerenabledrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "args": [
                            v0 /*: any*/ ,
                            {
                                "kind": "Literal",
                                "name": "first",
                                "value": 20
                            },
                            {
                                "kind": "Variable",
                                "name": "issueIds",
                                "variableName": "issueAris"
                            },
                            {
                                "kind": "Variable",
                                "name": "query",
                                "variableName": "searchStr"
                            }
                        ],
                        "concreteType": "DevAiRovoAgentConnection",
                        "kind": "LinkedField",
                        "name": "devai_autodevRovoAgents",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isRankingLimitApplied"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "DevAiRovoAgentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "DevAiRovoAgent",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        "action": "THROW",
                                                        "path": "devai_autodevRovoAgents.edges.node.name"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v1 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "devai_autodevRovoAgents.edges.node.id"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "description"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "identityAccountId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "externalConfigReference"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "rankCategory"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "devai_autodevRovoAgents.edges.node"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "devai_autodevRovoAgents.edges"
                            }
                        ]
                    },
                    {
                        "alias": "devai_autodevRovoTemplates",
                        "args": [
                            v0 /*: any*/ ,
                            {
                                "kind": "Literal",
                                "name": "first",
                                "value": 1
                            },
                            {
                                "kind": "Literal",
                                "name": "templatesFilter",
                                "value": "ONLY"
                            }
                        ],
                        "concreteType": "DevAiRovoAgentConnection",
                        "kind": "LinkedField",
                        "name": "devai_autodevRovoAgents",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "DevAiRovoAgentEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "DevAiRovoAgent",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v1 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$96a40644c8b18b7d$var$node.hash = "65925d27b3d9c10f0688064be6ba36b8";
var $96a40644c8b18b7d$export$2e2bcd8739ae039 = $96a40644c8b18b7d$var$node;

});
parcelRegister("hbznT", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e5b1a72d015b184$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2bef5a68e73845977560a35a74d628b9>>
 * @relayHash bad76220882353ff5097c73e46fdde44
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6a5754a94adba5ddc122b86b4f7ca5dd231c4f19f973069395e284274ee475ae

var $4FMJN = parcelRequire("4FMJN");
const $7e5b1a72d015b184$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isVerticalsAgentPickerEnabled"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueAris"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchStr"
    }, v4 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "pickerContentRefetchQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "issueAris",
                            "variableName": "issueAris"
                        },
                        {
                            "kind": "Variable",
                            "name": "searchStr",
                            "variableName": "searchStr"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "pickerContent_autodevAgentPicker_agentsFragRef"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcautodevisverticalsagentpickerenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "pickerContentRefetchQuery",
            "selections": [
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcautodevisverticalsagentpickerenabledrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 20
                                },
                                {
                                    "kind": "Variable",
                                    "name": "issueIds",
                                    "variableName": "issueAris"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "query",
                                    "variableName": "searchStr"
                                }
                            ],
                            "concreteType": "DevAiRovoAgentConnection",
                            "kind": "LinkedField",
                            "name": "devai_autodevRovoAgents",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isRankingLimitApplied"
                                },
                                {
                                    "concreteType": "DevAiRovoAgentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "DevAiRovoAgent",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "description"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "identityAccountId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "externalConfigReference"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "rankCategory"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "devai_autodevRovoTemplates",
                            "args": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 1
                                },
                                {
                                    "kind": "Literal",
                                    "name": "templatesFilter",
                                    "value": "ONLY"
                                }
                            ],
                            "concreteType": "DevAiRovoAgentConnection",
                            "kind": "LinkedField",
                            "name": "devai_autodevRovoAgents",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "DevAiRovoAgentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "DevAiRovoAgent",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6a5754a94adba5ddc122b86b4f7ca5dd231c4f19f973069395e284274ee475ae",
            "metadata": {},
            "name": "pickerContentRefetchQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "isVerticalsAgentPickerEnabled": (0, $4FMJN.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcautodevisverticalsagentpickerenabledrelayprovider": (0, $4FMJN.default)
            }
        }
    };
}();
$7e5b1a72d015b184$var$node.hash = "65925d27b3d9c10f0688064be6ba36b8";
var $7e5b1a72d015b184$export$2e2bcd8739ae039 = $7e5b1a72d015b184$var$node;

});


parcelRegister("2t4wB", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbb4aa99943ca84b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5656824de22cb293bbe80bf46d11fb90>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bbb4aa99943ca84b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "pickerContent_autodevAgentPicker_jobRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        }
    ],
    "type": "JiraAutodevJob"
};
$bbb4aa99943ca84b$var$node.hash = "5c5ad61bde20dbf862a689570aa375a6";
var $bbb4aa99943ca84b$export$2e2bcd8739ae039 = $bbb4aa99943ca84b$var$node;

});

parcelRegister("jk2ED", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2388fe24873e950$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6cef5adbd77e3fd9b31916ee444a042b>>
 * @relayHash 0618afef43e98b8a0e3ecf228b03a626
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID afcb86496fe802de8128106d8b8a619070156d15c464caac6f365e7f72878ebf

var $4FMJN = parcelRequire("4FMJN");
const $c2388fe24873e950$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueAris"
    }, v2 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "pickerContentQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "issueAris",
                            "variableName": "issueAris"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "pickerContent_autodevAgentPicker_agentsFragRef"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcautodevisverticalsagentpickerenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "pickerContentQuery",
            "selections": [
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcautodevisverticalsagentpickerenabledrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 20
                                },
                                {
                                    "kind": "Variable",
                                    "name": "issueIds",
                                    "variableName": "issueAris"
                                }
                            ],
                            "concreteType": "DevAiRovoAgentConnection",
                            "kind": "LinkedField",
                            "name": "devai_autodevRovoAgents",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isRankingLimitApplied"
                                },
                                {
                                    "concreteType": "DevAiRovoAgentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "DevAiRovoAgent",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "description"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "identityAccountId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "externalConfigReference"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "rankCategory"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "devai_autodevRovoTemplates",
                            "args": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 1
                                },
                                {
                                    "kind": "Literal",
                                    "name": "templatesFilter",
                                    "value": "ONLY"
                                }
                            ],
                            "concreteType": "DevAiRovoAgentConnection",
                            "kind": "LinkedField",
                            "name": "devai_autodevRovoAgents",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "DevAiRovoAgentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "DevAiRovoAgent",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "afcb86496fe802de8128106d8b8a619070156d15c464caac6f365e7f72878ebf",
            "metadata": {},
            "name": "pickerContentQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcautodevisverticalsagentpickerenabledrelayprovider": (0, $4FMJN.default)
            }
        }
    };
}();
$c2388fe24873e950$var$node.hash = "3550a100e40c5dbf5f732444d35e37b3";
var $c2388fe24873e950$export$2e2bcd8739ae039 = $c2388fe24873e950$var$node;

});

parcelRegister("8S93R", function(module, exports) {

$parcel$export(module.exports, "AgentAvatar", () => $5b0f0a8770070c77$export$38b71b080e1832c8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $vIiRg = parcelRequire("vIiRg");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $5OOAU = parcelRequire("5OOAU");

var $jidQP = parcelRequire("jidQP");
const $5b0f0a8770070c77$var$styles = {
    agentAvatar: "_1e0c1txw _1bah1h6o _4cvr1h6o _mkrz1k6g",
    image: "_5ral1dfr _4t3i1osq _1bsb1osq",
    avatarContentContainer: "_1bsb1osq _4t3i1osq _1e0c1txw _1bah1h6o _4cvr1h6o"
};
const $5b0f0a8770070c77$var$stylesCompiled = {
    innerShape: "_4t3i1lk2 _1bsb1lk2 _mkrz1k6g"
};
const $5b0f0a8770070c77$export$38b71b080e1832c8 = ({ imageUrl: imageUrl, size: size = 'medium', label: label, name: name, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, agentNamedId: agentNamedId, showBorder: showBorder = true, isForgeAgent: isForgeAgent, forgeAgentIconUrl: forgeAgentIconUrl })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const imgUrl = isForgeAgent && forgeAgentIconUrl ? forgeAgentIconUrl : imageUrl;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        "aria-label": label,
        xcss: $5b0f0a8770070c77$var$styles.agentAvatar,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            height: (0, $vIiRg.AVATAR_SIZES)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            width: (0, $vIiRg.AVATAR_SIZES)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/ensure-design-token-usage
            ...showBorder ? {
                backgroundColor: '#fff'
            } : {},
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...(0, $VSDnB.fg)('rovo_chat_bugfix_agent_avatar_squish') ? {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                minHeight: (0, $vIiRg.AVATAR_SIZES)[size],
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                minWidth: (0, $vIiRg.AVATAR_SIZES)[size]
            } : {}
        },
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            className: (0, $bwpsq.default)([
                $5b0f0a8770070c77$var$stylesCompiled.innerShape
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                xcss: $5b0f0a8770070c77$var$styles.avatarContentContainer,
                children: imgUrl ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    as: "img",
                    xcss: $5b0f0a8770070c77$var$styles.image,
                    src: imgUrl,
                    alt: name || label || formatMessage((0, $jidQP.messages).agentAvatarLabel)
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5OOAU.GeneratedAvatar), {
                    agentId: agentId,
                    agentNamedId: agentNamedId,
                    agentIdentityAccountId: agentIdentityAccountId,
                    size: size
                })
            })
        })
    });
};

});
parcelRegister("5OOAU", function(module, exports) {

$parcel$export(module.exports, "AgentBanner", () => $5bf0564183cfbb33$export$6efaefb8ad2fba40);
$parcel$export(module.exports, "GeneratedAvatar", () => $5bf0564183cfbb33$export$96bb253b7de22616);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $vIiRg = parcelRequire("vIiRg");

var $3JT92 = parcelRequire("3JT92");

var $MHKc7 = parcelRequire("MHKc7");
const $5bf0564183cfbb33$var$styles = {
    image: "_5ral1dfr _4t3i1osq _1bsb1osq _1e0c1txw _1bah1h6o _4cvr1h6o",
    banner: "_1bsb1osq",
    bannerFillSpace: "_1bsb1osq _4t3i1osq _5ral1dfr"
};

const $5bf0564183cfbb33$var$AutoDevAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("ebYDx")));

const $5bf0564183cfbb33$var$AutoFixAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("clsL1")));

const $5bf0564183cfbb33$var$AutoReviewAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("enJSB")));

const $5bf0564183cfbb33$var$BacklogBuddyAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("8s2sN")));

const $5bf0564183cfbb33$var$CommsCrafterAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("aSceX")));

const $5bf0564183cfbb33$var$CultureAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("dum6h")));

const $5bf0564183cfbb33$var$CustomerInsightAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("goAX7")));

const $5bf0564183cfbb33$var$DecisionDirectorAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("16FPl")));

const $5bf0564183cfbb33$var$FeatureFlagAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("7tf3M")));

const $5bf0564183cfbb33$var$GenericAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("eVT5O")));

const $5bf0564183cfbb33$var$HireWriterAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("2pXsj")));

const $5bf0564183cfbb33$var$MarketingMessageMaestroAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("ihdBU")));

const $5bf0564183cfbb33$var$MyUserManualAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("lKGQJ")));

const $5bf0564183cfbb33$var$OkrOracleAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("77a7o")));

const $5bf0564183cfbb33$var$OpsAgentAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("7whAK")));

const $5bf0564183cfbb33$var$PitchPerfectorAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("knS67")));

const $5bf0564183cfbb33$var$ProductRequirementAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("fptBL")));

const $5bf0564183cfbb33$var$ReleaseNotesAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("cCJHu")));

const $5bf0564183cfbb33$var$ResearchScoutAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("gCGxk")));

const $5bf0564183cfbb33$var$SocialMediaScribeAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("2yuUw")));

const $5bf0564183cfbb33$var$TeamConnectionAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("jtfXW")));

const $5bf0564183cfbb33$var$WorkflowBuilderAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("C11fi")));
const $5bf0564183cfbb33$export$cf7c9ad03f4a70b2 = {
    primary: '#FCA700',
    secondary: '#FFC716'
};
const $5bf0564183cfbb33$export$3e344798f7855e62 = {
    primary: '#BF63F3',
    secondary: '#D8A0F7'
};
const $5bf0564183cfbb33$export$a3d0897f023251ae = {
    primary: '#82B536',
    secondary: '#B3DF72'
};
const $5bf0564183cfbb33$export$d933daaf7b69e6ee = {
    primary: '#357DE8',
    secondary: '#669DF1'
};
const $5bf0564183cfbb33$var$colorList = [
    $5bf0564183cfbb33$export$cf7c9ad03f4a70b2,
    $5bf0564183cfbb33$export$3e344798f7855e62,
    $5bf0564183cfbb33$export$a3d0897f023251ae,
    $5bf0564183cfbb33$export$d933daaf7b69e6ee
];
const $5bf0564183cfbb33$var$avatarList = [
    $5bf0564183cfbb33$var$CustomerInsightAvatar,
    $5bf0564183cfbb33$var$BacklogBuddyAvatar,
    $5bf0564183cfbb33$var$DecisionDirectorAvatar,
    $5bf0564183cfbb33$var$CommsCrafterAvatar,
    $5bf0564183cfbb33$var$AutoDevAvatar,
    $5bf0564183cfbb33$var$OkrOracleAvatar,
    $5bf0564183cfbb33$var$CultureAvatar,
    $5bf0564183cfbb33$var$SocialMediaScribeAvatar,
    $5bf0564183cfbb33$var$TeamConnectionAvatar,
    $5bf0564183cfbb33$var$HireWriterAvatar,
    $5bf0564183cfbb33$var$OpsAgentAvatar,
    $5bf0564183cfbb33$var$ResearchScoutAvatar,
    $5bf0564183cfbb33$var$ReleaseNotesAvatar,
    $5bf0564183cfbb33$var$MyUserManualAvatar,
    $5bf0564183cfbb33$var$PitchPerfectorAvatar,
    $5bf0564183cfbb33$var$AutoDevAvatar,
    $5bf0564183cfbb33$var$AutoFixAvatar,
    $5bf0564183cfbb33$var$AutoReviewAvatar,
    $5bf0564183cfbb33$var$MarketingMessageMaestroAvatar,
    $5bf0564183cfbb33$var$FeatureFlagAvatar,
    $5bf0564183cfbb33$var$ProductRequirementAvatar
];
const $5bf0564183cfbb33$export$a834793a4d0d739e = $5bf0564183cfbb33$var$avatarList.length * $5bf0564183cfbb33$var$colorList.length;
const $5bf0564183cfbb33$var$outOfTheBoxAgentAvatar = {
    autodev_template_unit_test_creator: {
        getRender: (size)=>/*#__PURE__*/ (0, $2OMIu.jsx)($5bf0564183cfbb33$var$AutoFixAvatar, {
                size: (0, $vIiRg.AVATAR_SIZES)[size],
                primaryColor: $5bf0564183cfbb33$export$a3d0897f023251ae.primary,
                secondaryColor: $5bf0564183cfbb33$export$a3d0897f023251ae.secondary
            }),
        color: $5bf0564183cfbb33$export$a3d0897f023251ae
    },
    autodev_template_migration_config_changer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $2OMIu.jsx)($5bf0564183cfbb33$var$OpsAgentAvatar, {
                size: (0, $vIiRg.AVATAR_SIZES)[size],
                primaryColor: $5bf0564183cfbb33$export$a3d0897f023251ae.primary,
                secondaryColor: $5bf0564183cfbb33$export$a3d0897f023251ae.secondary
            }),
        color: $5bf0564183cfbb33$export$a3d0897f023251ae
    },
    autodev_template_vulnerable_dependency_updater_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $2OMIu.jsx)($5bf0564183cfbb33$var$MarketingMessageMaestroAvatar, {
                size: (0, $vIiRg.AVATAR_SIZES)[size],
                primaryColor: $5bf0564183cfbb33$export$a3d0897f023251ae.primary,
                secondaryColor: $5bf0564183cfbb33$export$a3d0897f023251ae.secondary
            }),
        color: $5bf0564183cfbb33$export$a3d0897f023251ae
    },
    autodev_template_code_standardizer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $2OMIu.jsx)($5bf0564183cfbb33$var$MyUserManualAvatar, {
                size: (0, $vIiRg.AVATAR_SIZES)[size],
                primaryColor: $5bf0564183cfbb33$export$a3d0897f023251ae.primary,
                secondaryColor: $5bf0564183cfbb33$export$a3d0897f023251ae.secondary
            }),
        color: $5bf0564183cfbb33$export$a3d0897f023251ae
    },
    autodev_template_code_observer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $2OMIu.jsx)($5bf0564183cfbb33$var$ResearchScoutAvatar, {
                size: (0, $vIiRg.AVATAR_SIZES)[size],
                primaryColor: $5bf0564183cfbb33$export$a3d0897f023251ae.primary,
                secondaryColor: $5bf0564183cfbb33$export$a3d0897f023251ae.secondary
            }),
        color: $5bf0564183cfbb33$export$a3d0897f023251ae
    },
    autodev_template_code_accessibility_checker_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $2OMIu.jsx)($5bf0564183cfbb33$var$HireWriterAvatar, {
                size: (0, $vIiRg.AVATAR_SIZES)[size],
                primaryColor: $5bf0564183cfbb33$export$a3d0897f023251ae.primary,
                secondaryColor: $5bf0564183cfbb33$export$a3d0897f023251ae.secondary
            }),
        color: $5bf0564183cfbb33$export$a3d0897f023251ae
    },
    autodev_code_documentation_writer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $2OMIu.jsx)($5bf0564183cfbb33$var$SocialMediaScribeAvatar, {
                size: (0, $vIiRg.AVATAR_SIZES)[size],
                primaryColor: $5bf0564183cfbb33$export$a3d0897f023251ae.primary,
                secondaryColor: $5bf0564183cfbb33$export$a3d0897f023251ae.secondary
            }),
        color: $5bf0564183cfbb33$export$a3d0897f023251ae
    },
    autodev_feature_flag_cleaner_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $2OMIu.jsx)($5bf0564183cfbb33$var$FeatureFlagAvatar, {
                size: (0, $vIiRg.AVATAR_SIZES)[size],
                primaryColor: $5bf0564183cfbb33$export$a3d0897f023251ae.primary,
                secondaryColor: $5bf0564183cfbb33$export$a3d0897f023251ae.secondary
            }),
        color: $5bf0564183cfbb33$export$a3d0897f023251ae
    },
    decision_director_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $2OMIu.jsx)($5bf0564183cfbb33$var$DecisionDirectorAvatar, {
                size: (0, $vIiRg.AVATAR_SIZES)[size],
                primaryColor: $5bf0564183cfbb33$export$a3d0897f023251ae.primary,
                secondaryColor: $5bf0564183cfbb33$export$a3d0897f023251ae.secondary
            }),
        color: $5bf0564183cfbb33$export$a3d0897f023251ae
    },
    user_manual_writer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $2OMIu.jsx)($5bf0564183cfbb33$var$MyUserManualAvatar, {
                size: (0, $vIiRg.AVATAR_SIZES)[size],
                primaryColor: $5bf0564183cfbb33$export$cf7c9ad03f4a70b2.primary,
                secondaryColor: $5bf0564183cfbb33$export$cf7c9ad03f4a70b2.secondary
            }),
        color: $5bf0564183cfbb33$export$cf7c9ad03f4a70b2
    },
    product_requirements_expert_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $2OMIu.jsx)($5bf0564183cfbb33$var$ProductRequirementAvatar, {
                size: (0, $vIiRg.AVATAR_SIZES)[size],
                primaryColor: $5bf0564183cfbb33$export$cf7c9ad03f4a70b2.primary,
                secondaryColor: $5bf0564183cfbb33$export$cf7c9ad03f4a70b2.secondary
            }),
        color: $5bf0564183cfbb33$export$cf7c9ad03f4a70b2
    },
    issue_organizer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $2OMIu.jsx)($5bf0564183cfbb33$var$BacklogBuddyAvatar, {
                size: (0, $vIiRg.AVATAR_SIZES)[size],
                primaryColor: $5bf0564183cfbb33$export$a3d0897f023251ae.primary,
                secondaryColor: $5bf0564183cfbb33$export$a3d0897f023251ae.secondary
            }),
        color: $5bf0564183cfbb33$export$a3d0897f023251ae
    },
    ops_guide_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $2OMIu.jsx)($5bf0564183cfbb33$var$OpsAgentAvatar, {
                size: (0, $vIiRg.AVATAR_SIZES)[size],
                primaryColor: $5bf0564183cfbb33$export$cf7c9ad03f4a70b2.primary,
                secondaryColor: $5bf0564183cfbb33$export$cf7c9ad03f4a70b2.secondary
            }),
        color: $5bf0564183cfbb33$export$cf7c9ad03f4a70b2
    },
    jira_workflow_wizard_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $2OMIu.jsx)($5bf0564183cfbb33$var$WorkflowBuilderAvatar, {
                size: (0, $vIiRg.AVATAR_SIZES)[size],
                primaryColor: $5bf0564183cfbb33$export$d933daaf7b69e6ee.primary,
                secondaryColor: $5bf0564183cfbb33$export$d933daaf7b69e6ee.secondary
            }),
        color: $5bf0564183cfbb33$export$d933daaf7b69e6ee
    },
    itops_rca_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $2OMIu.jsx)($5bf0564183cfbb33$var$AutoReviewAvatar, {
                size: (0, $vIiRg.AVATAR_SIZES)[size],
                primaryColor: $5bf0564183cfbb33$export$cf7c9ad03f4a70b2.primary,
                secondaryColor: $5bf0564183cfbb33$export$cf7c9ad03f4a70b2.secondary
            }),
        color: $5bf0564183cfbb33$export$cf7c9ad03f4a70b2
    }
};
const $5bf0564183cfbb33$export$c84eb7708138dd4 = ({ agentIdentityAccountId: agentIdentityAccountId, agentId: agentId })=>{
    // we prioritise agentIdentityAccountId first if it is available
    // this is because agentIdentityAccountId is more widely available (e.g. in ProfilePage)
    const idForAgentAvatar = agentIdentityAccountId || agentId;
    if (idForAgentAvatar) {
        // Take the last 8 characters of the id because JS can't handle 16 digit numbers
        const trimmedId = idForAgentAvatar.slice(-8).replace(/[-:]/g, '');
        const parsedId = parseInt(trimmedId, 16);
        if (isNaN(parsedId)) return 0;
        else return parsedId;
    }
    return null;
};
const $5bf0564183cfbb33$var$getAvatarRender = ({ agentNamedId: agentNamedId, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, size: size })=>{
    if (typeof agentNamedId === 'string' && $5bf0564183cfbb33$var$outOfTheBoxAgentAvatar[agentNamedId]) {
        const ootbAvatarResult = $5bf0564183cfbb33$var$outOfTheBoxAgentAvatar[agentNamedId];
        return {
            render: ootbAvatarResult.getRender(size),
            color: ootbAvatarResult.color
        };
    }
    const numberId = $5bf0564183cfbb33$export$c84eb7708138dd4({
        agentIdentityAccountId: agentIdentityAccountId,
        agentId: agentId
    });
    if (numberId !== null) {
        /**
     * this create all possible combinations of avatars and colors
     * e.g. [[avatar1, color1], [avatar1, color2], [avatar2, color1], [avatar2, color2]]
     * then choose 1 based on agentId
     */ const totalCombinations = $5bf0564183cfbb33$var$avatarList.length * $5bf0564183cfbb33$var$colorList.length;
        const combinationIndex = numberId % totalCombinations;
        const avatarIndex = Math.floor(combinationIndex / $5bf0564183cfbb33$var$colorList.length);
        const colorIndex = combinationIndex % $5bf0564183cfbb33$var$colorList.length;
        const Avatar = $5bf0564183cfbb33$var$avatarList[avatarIndex];
        const color = $5bf0564183cfbb33$var$colorList[colorIndex];
        return {
            render: /*#__PURE__*/ (0, $2OMIu.jsx)(Avatar, {
                size: (0, $vIiRg.AVATAR_SIZES)[size],
                primaryColor: color.primary,
                secondaryColor: color.secondary
            }),
            color: color
        };
    }
    return {
        render: /*#__PURE__*/ (0, $2OMIu.jsx)($5bf0564183cfbb33$var$GenericAvatar, {
            size: (0, $vIiRg.AVATAR_SIZES)[size],
            primaryColor: $5bf0564183cfbb33$export$d933daaf7b69e6ee.primary,
            secondaryColor: $5bf0564183cfbb33$export$d933daaf7b69e6ee.secondary
        }),
        color: $5bf0564183cfbb33$export$d933daaf7b69e6ee
    };
};
const $5bf0564183cfbb33$export$6efaefb8ad2fba40 = ({ agentNamedId: agentNamedId, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, height: height, fillSpace: fillSpace })=>{
    const { color: color } = $5bf0564183cfbb33$var$getAvatarRender({
        agentNamedId: agentNamedId,
        agentId: agentId,
        agentIdentityAccountId: agentIdentityAccountId,
        size: 'medium'
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($5bf0564183cfbb33$var$styles.banner, fillSpace ? $5bf0564183cfbb33$var$styles.bannerFillSpace : undefined),
        style: {
            backgroundColor: color.primary,
            height: height ? `${height}px` : undefined
        }
    });
};
const $5bf0564183cfbb33$export$96bb253b7de22616 = (props)=>{
    const { render: render, color: color } = $5bf0564183cfbb33$var$getAvatarRender(props);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $5bf0564183cfbb33$var$styles.image,
        style: {
            backgroundColor: color.primary
        },
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
            fallback: null,
            children: render
        })
    });
};

});
parcelRegister("ebYDx", function(module, exports) {

let $a55120f20eb3e0d6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a55120f20eb3e0d6$var$load("4JN0P").then(()=>parcelRequire('lOwq3'));

});

parcelRegister("clsL1", function(module, exports) {

let $8fcdc0d5ae9bddd0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8fcdc0d5ae9bddd0$var$load("b8In5").then(()=>parcelRequire('k9HyI'));

});

parcelRegister("enJSB", function(module, exports) {

let $a786cd68520d8a3c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a786cd68520d8a3c$var$load("i8Qu6").then(()=>parcelRequire('7r7QW'));

});

parcelRegister("8s2sN", function(module, exports) {

let $6272d9765c9f3a93$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6272d9765c9f3a93$var$load("eC7og").then(()=>parcelRequire('27sCb'));

});

parcelRegister("aSceX", function(module, exports) {

let $7ea87135783687cd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7ea87135783687cd$var$load("82aZO").then(()=>parcelRequire('k9RFh'));

});

parcelRegister("dum6h", function(module, exports) {

let $9d1f38615a9f22ec$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9d1f38615a9f22ec$var$load("lUywR").then(()=>parcelRequire('dB6SD'));

});

parcelRegister("goAX7", function(module, exports) {

let $befb8d42592673b0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $befb8d42592673b0$var$load("23G1j").then(()=>parcelRequire('kbU5P'));

});

parcelRegister("16FPl", function(module, exports) {

let $0ce6cbfd6d41ba25$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0ce6cbfd6d41ba25$var$load("bpkjs").then(()=>parcelRequire('4Ta6A'));

});

parcelRegister("7tf3M", function(module, exports) {

let $5706ec743eb724b9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5706ec743eb724b9$var$load("2HEXN").then(()=>parcelRequire('cT52Z'));

});

parcelRegister("eVT5O", function(module, exports) {

let $adf11fce8cf998a2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $adf11fce8cf998a2$var$load("59PjM").then(()=>parcelRequire('fvSGg'));

});

parcelRegister("2pXsj", function(module, exports) {

let $1c2c0936443ab303$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1c2c0936443ab303$var$load("euRWW").then(()=>parcelRequire('kOgKS'));

});

parcelRegister("ihdBU", function(module, exports) {

let $d4e45f475472e4ad$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d4e45f475472e4ad$var$load("6eqHi").then(()=>parcelRequire('gDfXS'));

});

parcelRegister("lKGQJ", function(module, exports) {

let $fd5f21dc295d6893$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fd5f21dc295d6893$var$load("kGHPZ").then(()=>parcelRequire('6fzX4'));

});

parcelRegister("77a7o", function(module, exports) {

let $52e109191ca7d73c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $52e109191ca7d73c$var$load("aA6PQ").then(()=>parcelRequire('1sn78'));

});

parcelRegister("7whAK", function(module, exports) {

let $0169b23da7e0493e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0169b23da7e0493e$var$load("ceOJB").then(()=>parcelRequire('ljkz0'));

});

parcelRegister("knS67", function(module, exports) {

let $ed6feb4a918e14cd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ed6feb4a918e14cd$var$load("b2aMO").then(()=>parcelRequire('djrSm'));

});

parcelRegister("fptBL", function(module, exports) {

let $b3802859eb3e77d5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b3802859eb3e77d5$var$load("28cGJ").then(()=>parcelRequire('W7C9N'));

});

parcelRegister("cCJHu", function(module, exports) {

let $930c7bd3006500b2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $930c7bd3006500b2$var$load("jqsqq").then(()=>parcelRequire('3pZFQ'));

});

parcelRegister("gCGxk", function(module, exports) {

let $c1a130d266d7d789$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c1a130d266d7d789$var$load("5lxo7").then(()=>parcelRequire('icyRb'));

});

parcelRegister("2yuUw", function(module, exports) {

let $1dc6bbefa2989483$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1dc6bbefa2989483$var$load("3kEuJ").then(()=>parcelRequire('f4CgX'));

});

parcelRegister("jtfXW", function(module, exports) {

let $e2cd1c3b12b28ad9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e2cd1c3b12b28ad9$var$load("cPRyg").then(()=>parcelRequire('l3PeX'));

});

parcelRegister("C11fi", function(module, exports) {

let $07245718597b6e42$var$load = (parcelRequire("28QjX"))(4);
module.exports = $07245718597b6e42$var$load("835xx").then(()=>parcelRequire('7vi3o'));

});


parcelRegister("jidQP", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0b07736d81cebc8d$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $0b07736d81cebc8d$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    agentAvatarLabel: {
        id: 'ai-mate.agent-avatar-label',
        defaultMessage: 'Agent avatar',
        description: 'Accessible label for agent avatar img'
    }
});

});


parcelRegister("jSlaY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::196b600e7960a1af1a5f6fffc09ddaa0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e7837c8d7e1becd0$var$_react = $e7837c8d7e1becd0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e7837c8d7e1becd0$var$_baseNew = $e7837c8d7e1becd0$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e7837c8d7e1becd0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AngleBrackets".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e7837c8d7e1becd0$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $e7837c8d7e1becd0$var$_react.default.createElement($e7837c8d7e1becd0$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.315 14.445 6-13.5 1.37.61-6 13.5zM13.982 10l-2.925 2.145.886 1.21 3.75-2.75a.75.75 0 0 0 0-1.21l-3.75-2.75-.886 1.21zM2.018 6l2.926 2.145-.888 1.21-3.75-2.75a.75.75 0 0 1 0-1.21l3.75-2.75.888 1.21z" clip-rule="evenodd"/>`
    }, props));
$e7837c8d7e1becd0$var$AngleBracketsIcon.displayName = 'AngleBracketsIcon';
var $e7837c8d7e1becd0$var$_default = module.exports.default = $e7837c8d7e1becd0$var$AngleBracketsIcon;

});

parcelRegister("6uqUb", function(module, exports) {

$parcel$export(module.exports, "useAgentPickerBulkOpenMenuExpStart", () => $b8b73efab4f4aee0$export$9b4aca6f40c05f7c);
$parcel$export(module.exports, "useAgentPickerBulkOpenMenuExpFail", () => $b8b73efab4f4aee0$export$2e447af3d0d40799);
$parcel$export(module.exports, "AgentPickerBulkOpenMenuExpSuccess", () => $b8b73efab4f4aee0$export$2cf246a858bf9605);
$parcel$export(module.exports, "useAgentPickerSingleIssueOpenMenuExpStart", () => $b8b73efab4f4aee0$export$9bed2aef2a5e18a5);
$parcel$export(module.exports, "useAgentPickerSingleIssueOpenMenuExpFail", () => $b8b73efab4f4aee0$export$1587a92b59f36fca);
$parcel$export(module.exports, "AgentPickerSingleIssueOpenMenuExpSuccess", () => $b8b73efab4f4aee0$export$c7af9c7f4a55959e);

var $5uXOq = parcelRequire("5uXOq");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $efvDm = parcelRequire("efvDm");

var $7Fi3v = parcelRequire("7Fi3v");
const $b8b73efab4f4aee0$var$ANALYTICS_SOURCE = 'agentPickerBulk';
const $b8b73efab4f4aee0$export$9b4aca6f40c05f7c = ()=>{
    return (0, $kaHBi.useExperienceStart)({
        experience: (0, $7Fi3v.ExperienceTrackersNames).AGENT_PICKER_DROPDOWN_TRIGGER_BACKLOG_BULK_ISSUES_OPEN_MENU,
        experienceId: `${Date.now()}`,
        analyticsSource: $b8b73efab4f4aee0$var$ANALYTICS_SOURCE,
        application: (0, $efvDm.JIRA_SOFTWARE)
    });
};
const $b8b73efab4f4aee0$export$2e447af3d0d40799 = ()=>(0, $93jKl.useExperienceFail)({
        experience: (0, $7Fi3v.ExperienceTrackersNames).AGENT_PICKER_DROPDOWN_TRIGGER_BACKLOG_BULK_ISSUES_OPEN_MENU
    });
const $b8b73efab4f4aee0$export$2cf246a858bf9605 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bQtK.ExperienceSuccess), {
        experience: (0, $7Fi3v.ExperienceTrackersNames).AGENT_PICKER_DROPDOWN_TRIGGER_BACKLOG_BULK_ISSUES_OPEN_MENU
    });
const $b8b73efab4f4aee0$export$9bed2aef2a5e18a5 = ()=>{
    return (0, $kaHBi.useExperienceStart)({
        experience: (0, $7Fi3v.ExperienceTrackersNames).AGENT_PICKER_DROPDOWN_TRIGGER_SINGLE_ISSUE_OPEN_MENU,
        experienceId: `${Date.now()}`,
        analyticsSource: $b8b73efab4f4aee0$var$ANALYTICS_SOURCE,
        application: (0, $efvDm.JIRA_SOFTWARE)
    });
};
const $b8b73efab4f4aee0$export$1587a92b59f36fca = ()=>(0, $93jKl.useExperienceFail)({
        experience: (0, $7Fi3v.ExperienceTrackersNames).AGENT_PICKER_DROPDOWN_TRIGGER_SINGLE_ISSUE_OPEN_MENU
    });
const $b8b73efab4f4aee0$export$c7af9c7f4a55959e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bQtK.ExperienceSuccess), {
        experience: (0, $7Fi3v.ExperienceTrackersNames).AGENT_PICKER_DROPDOWN_TRIGGER_SINGLE_ISSUE_OPEN_MENU
    });

});
parcelRegister("7Fi3v", function(module, exports) {

$parcel$export(module.exports, "PROCESSING_SCREENS", () => $fe63dfce96320516$export$427c5a6a2f134a37);
$parcel$export(module.exports, "CODE_CONTENT_SCREENS", () => $fe63dfce96320516$export$777b75332adaa1ea);
$parcel$export(module.exports, "AUTODEV_MODAL_QUERYPARAM_KEY", () => $fe63dfce96320516$export$87fc7a5f600ee3e7);
$parcel$export(module.exports, "ROVO_CHAT_QUERYPARAM_KEY", () => $fe63dfce96320516$export$2d15817c255fcae8);
$parcel$export(module.exports, "ADDITIONAL_LINES_CHUNK_SIZE", () => $fe63dfce96320516$export$387546441140c7cd);
$parcel$export(module.exports, "Interactions", () => $fe63dfce96320516$export$bf175643665dd6f);
$parcel$export(module.exports, "ExperienceTrackersNames", () => $fe63dfce96320516$export$4ee813af8eb209ef);
const $fe63dfce96320516$export$427c5a6a2f134a37 = [
    'plan_generating',
    'coding_task',
    're_coding_task'
];
const $fe63dfce96320516$export$777b75332adaa1ea = [
    'coding_task',
    're_coding_task',
    'code_generation_success'
];
const $fe63dfce96320516$export$87fc7a5f600ee3e7 = 'showAutodev';
const $fe63dfce96320516$export$2d15817c255fcae8 = 'openConversation';
const $fe63dfce96320516$export$387546441140c7cd = 10;
const $fe63dfce96320516$export$bf175643665dd6f = {
    AGENT_RUN_AUTODEV_BUTTON: 'autodev-agent-picker.run-autodev-button',
    AGENT_RESTART_JOB_BUTTON: 'autodev-agent-picker.restart-job-button',
    AUTODEV_BUTTON: 'autodev.button',
    GENERATE_PLAN: 'autodev.generate-plan',
    RETRY_GENERATE_PLAN: 'autodev.retry-generate-plan',
    RETRY_GENERATE_CODE: 'autodev.retry-generate-code',
    GENERATE_CODE: 'autodev.generate-code',
    DISCARD_PLAN: 'autodev.discard-plan',
    STOP_CODE_GEN: 'autodev.discard-plan',
    DELETE_JOB: 'autodev.delete-job',
    MAKE_CODE_CHANGE: 'autodev.make-code-change',
    REGENERATE_PLAN: 'autodev.regenerate-plan',
    DELETE_PLAN_STEP: 'autodev.delete-plan-step',
    UPDATE_PLAN_STEP: 'autodev.update-plan-step',
    DISCARD_JOB: 'autodev.discard-plan',
    ADD_PLAN_STEP: 'autodev.add-plan-step',
    ADD_PLAN_STEP_TASK: 'autodev.add-plan-step-task',
    UPDATE_PLAN_STEP_TASK: 'autodev.update-plan-step-task',
    DELETE_PLAN_STEP_TASK: 'autodev.delete-plan-step-task',
    RE_RUN_JOB: 'autodev.re-run-job'
};
const $fe63dfce96320516$export$4ee813af8eb209ef = {
    AGENT_PICKER_DROPDOWN_TRIGGER_SINGLE_ISSUE_OPEN_MENU: 'autodev-agent-picker.dropdown.trigger.single-issue.open-menu',
    AGENT_PICKER_DROPDOWN_TRIGGER_BACKLOG_BULK_ISSUES_OPEN_MENU: 'autodev-agent-picker.dropdown.trigger.backlog.bulk-issues.open-menu'
};

});


parcelRegister("1othz", function(module, exports) {

$parcel$export(module.exports, "useSuspenselessRefetchStateless", () => $7714fce489d6815b$export$ae1adabf094b2244);
$parcel$export(module.exports, "useSuspenselessRefetch", () => $7714fce489d6815b$export$c7ce5f64dc007896);
// eslint-disable-next-line jira/restricted/react-18

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $biQrn = parcelRequire("biQrn");

var $4R6GH = parcelRequire("4R6GH");

var $c1haS = parcelRequire("c1haS");
const $7714fce489d6815b$var$useInFlightRequests = ({ setIsLoading: setIsLoading })=>{
    const inFlightRequestsRef = (0, $5uXOq.useRef)([]);
    return (0, $5uXOq.useMemo)(()=>({
            onNewRequest: (request)=>{
                inFlightRequestsRef.current.push(request);
            },
            onRequestFinish: (request, /**
				 * Called only if the request hasn't been superceded by a more recent request's success / failure
				 */ onIfRequestIsRelevant)=>{
                // find the first occurrence of this request
                const inFlightRequestIndex = inFlightRequestsRef.current.indexOf(request);
                // If the current request is still considered "in flight"
                if (inFlightRequestIndex !== -1) {
                    onIfRequestIsRelevant?.();
                    // Cut out the current and all proceeding requests from the in-flight queue
                    inFlightRequestsRef.current = inFlightRequestsRef.current.slice(inFlightRequestIndex + 1);
                    // Update isLoading to reflect the current number of in-flight requests
                    setIsLoading?.(!!inFlightRequestsRef.current.length);
                }
            }
        }), [
        setIsLoading
    ]);
};
const $7714fce489d6815b$var$useTransitionNoop = ()=>[
        null,
        null
    ];
const $7714fce489d6815b$export$ae1adabf094b2244 = (// Relay-generated query from the @refetchable annotation in a useRefetchableFragment
// or usePaginationFragment
query, // Refetch function from a useRefetchableFragment or usePaginationFragment
// (which ordinarily would trigger suspense)
refetch, { setIsLoading: setIsLoading, setLastFetchError: setLastFetchError, fetchPolicy: fetchPolicy = 'store-or-network', networkCacheConfig: networkCacheConfig } = {})=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const isMounted = (0, $biQrn.useIsMounted)();
    const { onNewRequest: onNewRequest, onRequestFinish: onRequestFinish } = $7714fce489d6815b$var$useInFlightRequests({
        setIsLoading: setIsLoading
    });
    const useTransitionFG = (0, $c1haS.getIsConcurrentEnabled)() && (0, $4R6GH.fg)('jira-concurrent-suspenseless-refetch') // Done to prevent react-hooks/rules-of-hooks eslint error that is being ratcheted against
     ? (0, $5uXOq.useTransition) : $7714fce489d6815b$var$useTransitionNoop;
    const [_, startTransition] = useTransitionFG();
    return (0, $5uXOq.useCallback)((variables)=>{
        if (isMounted.current) setIsLoading?.(true);
        onNewRequest(variables);
        return (0, $8Uumt.fetchQuery)(environment, query, variables, {
            fetchPolicy: fetchPolicy,
            networkCacheConfig: networkCacheConfig
        }).subscribe({
            complete () {
                if (isMounted.current) {
                    if (startTransition && (0, $c1haS.getIsConcurrentEnabled)() && (0, $4R6GH.fg)('jira-concurrent-suspenseless-refetch')) // we need concurrent mode for useTransition to work
                    startTransition(()=>{
                        setLastFetchError?.(null);
                        onRequestFinish(variables, ()=>{
                            refetch(variables, {
                                fetchPolicy: 'store-only'
                            });
                        });
                    });
                    else {
                        setLastFetchError?.(null);
                        onRequestFinish(variables, ()=>{
                            refetch(variables, {
                                fetchPolicy: 'store-only'
                            });
                        });
                    }
                }
            },
            error (e) {
                if (isMounted.current) onRequestFinish(variables, ()=>setLastFetchError?.(e));
            }
        });
    }, [
        environment,
        fetchPolicy,
        isMounted,
        networkCacheConfig,
        onNewRequest,
        onRequestFinish,
        query,
        refetch,
        setIsLoading,
        setLastFetchError,
        startTransition
    ]);
};
const $7714fce489d6815b$export$c7ce5f64dc007896 = (query, refetch, options)=>{
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [lastFetchError, setLastFetchError] = (0, $5uXOq.useState)(null);
    const refetchFunction = $7714fce489d6815b$export$ae1adabf094b2244(query, refetch, {
        ...options,
        setIsLoading: setIsLoading,
        setLastFetchError: setLastFetchError
    });
    return [
        refetchFunction,
        isLoading,
        lastFetchError
    ];
};

});
parcelRegister("biQrn", function(module, exports) {

$parcel$export(module.exports, "useIsMounted", () => $c6adaed2787020bf$export$80c2a3957bcb42ea);

var $5uXOq = parcelRequire("5uXOq");
const $c6adaed2787020bf$export$80c2a3957bcb42ea = ()=>{
    const isMounted = (0, $5uXOq.useRef)(true);
    (0, $5uXOq.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, [
        isMounted
    ]);
    return isMounted;
};

});


parcelRegister("kekQh", function(module, exports) {

$parcel$export(module.exports, "fireAutodevErrorAnalytics", () => $36369ab594edeaeb$export$622cd0a7e24da08e);
$parcel$export(module.exports, "getRepoName", () => $36369ab594edeaeb$export$b7ccd31e87ef49c9);
$parcel$export(module.exports, "usePrevious", () => $36369ab594edeaeb$export$5cae361ad82dce8b);
$parcel$export(module.exports, "isAgentTriggeredJobInProgress", () => $36369ab594edeaeb$export$90bdf7ddb6623896);
$parcel$export(module.exports, "useIsOverflowWidth", () => $36369ab594edeaeb$export$2dcd60313c8d761b);
$parcel$export(module.exports, "sanitiseFilePath", () => $36369ab594edeaeb$export$78352563ece59bf6);
$parcel$export(module.exports, "assertUnreachable", () => $36369ab594edeaeb$export$f2525c1d596f8d46);
$parcel$export(module.exports, "isGithubWorkflowFile", () => $36369ab594edeaeb$export$4822959bf103a423);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");
const $36369ab594edeaeb$export$622cd0a7e24da08e = ({ id: id, jobId: jobId, jobWorkflow: jobWorkflow, agentId: agentId, error: error })=>(0, $jcw0u.default)({
        error: error,
        meta: {
            id: id,
            packageName: 'jiraAutodev',
            teamName: 'autodev'
        },
        attributes: {
            jobId: jobId,
            jobWorkflow: jobWorkflow,
            agentId: agentId
        },
        sendToPrivacyUnsafeSplunk: true
    });
const $36369ab594edeaeb$export$b7ccd31e87ef49c9 = (repoUrl)=>repoUrl.replace(/https:\/\/(bitbucket\.org|github\.com|integration\.bb-inf\.net|gitlab\.com)\//, '');
function $36369ab594edeaeb$export$5cae361ad82dce8b(value) {
    const ref = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}
const $36369ab594edeaeb$export$90bdf7ddb6623896 = (jobPhase, jobStatus)=>jobPhase === 'CODE_GENERATING' && jobStatus === 'IN_PROGRESS' || jobPhase === 'CODE_GENERATING' && jobStatus === 'PENDING';
const $36369ab594edeaeb$export$2dcd60313c8d761b = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
ref, callback)=>{
    const [isOverflow, setIsOverflow] = (0, $5uXOq.useState)(false);
    const observer = (0, $5uXOq.useRef)();
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (observer.current) observer.current.disconnect();
        const { current: current } = ref;
        const trigger = ()=>{
            const hasOverflow = current.scrollWidth > current.clientWidth;
            setIsOverflow(hasOverflow);
            if (callback) callback(hasOverflow);
        };
        if ('ResizeObserver' in window) observer.current = new ResizeObserver(trigger);
        if (current) observer.current?.observe(current);
        trigger();
        return ()=>{
            observer.current?.disconnect();
        };
    }, [
        callback,
        ref
    ]);
    return isOverflow;
};
const $36369ab594edeaeb$export$78352563ece59bf6 = (value)=>value// Remove leading whitespace.
    .trimStart()// Replace inner whitespace with dashes.
    // We shouldn't really need to do this, but the backend isn't escaping things properly yet :|
    .replace(/\s+/g, '-')// Strip all special characters except for obviously-valid ones (forward-slashes, full-stops, and underscores).
    .replace(/[^a-zA-Z0-9\\/\\_\-\\.]/g, '');
const $36369ab594edeaeb$export$f2525c1d596f8d46 = (_)=>{
    throw new Error('Unreachable code reached');
};
const $36369ab594edeaeb$export$4822959bf103a423 = (filename)=>{
    return filename.includes('.github/workflows/');
};

});

parcelRegister("5TzXF", function(module, exports) {

$parcel$export(module.exports, "RestartConfirmationModal", () => $df07b5cea40291ae$export$7bdb6c4c25581d80);

var $5uXOq = parcelRequire("5uXOq");

var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");

var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");

var $eCeGD = parcelRequire("eCeGD");

var $7NYq5 = parcelRequire("7NYq5");

var $koVbs = parcelRequire("koVbs");

var $7Fi3v = parcelRequire("7Fi3v");

var $9EJC4 = parcelRequire("9EJC4");
const $df07b5cea40291ae$export$7bdb6c4c25581d80 = ({ onRestart: onRestart, onCancel: onCancel })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        messageId: "autodev-agent-picker.ui.picker-content.restart-confirmation-modal.modal",
        messageType: "transactional",
        onClose: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), {
        appearance: "warning"
    }, formatMessage((0, $9EJC4.default).headerTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p"
    }, formatMessage((0, $9EJC4.default).warningText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p"
    }, formatMessage((0, $9EJC4.default).confirmationText)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "default",
        onClick: onCancel,
        testId: "autodev-agent-picker.ui.picker-content.restart-confirmation-modal.cancel-button"
    }, formatMessage((0, $9EJC4.default).cancelButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        // eslint-disable-next-line jira/ufo/valid-labels
        interactionName: (0, $7Fi3v.Interactions).AGENT_RESTART_JOB_BUTTON,
        appearance: "warning",
        onClick: onRestart,
        testId: "autodev-agent-picker.ui.picker-content.restart-confirmation-modal.restart-button"
    }, formatMessage((0, $9EJC4.default).restartButtonText))));
};

});
parcelRegister("9EJC4", function(module, exports) {

$parcel$export(module.exports, "default", () => $2844f61eba7b1322$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2844f61eba7b1322$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    headerTitle: {
        "id": "autodev.confirmation-modal.header-title",
        "defaultMessage": "Generate code with another agent?"
    },
    warningText: {
        "id": "autodev.confirmation-modal.warning-text",
        "defaultMessage": "Coding with another AI agent will delete the generated code you have available today."
    },
    confirmationText: {
        "id": "autodev.confirmation-modal.confirmation-text",
        "defaultMessage": "Are you sure you want to restart coding with another agent?"
    },
    restartButtonText: {
        "id": "autodev.confirmation-modal.restart-button-text",
        "defaultMessage": "Restart code with another agent"
    },
    cancelButtonText: {
        "id": "autodev.confirmation-modal.cancel-button-text",
        "defaultMessage": "Cancel"
    }
});

});


parcelRegister("6AbJv", function(module, exports) {

$parcel$export(module.exports, "default", () => $27b229092dc88510$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $27b229092dc88510$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    agentPickerErrorFlagDescription: {
        "id": "autodev.agent-picker.trigger-agent-error-flag-description",
        "defaultMessage": "Something went wrong. Please try again."
    },
    agentPickerErrorFlagTitle: {
        "id": "autodev.agent-picker.trigger-agent-error-flag-title",
        "defaultMessage": "Failed to trigger the Rovo agent"
    },
    agentPickerErrorFlagAction: {
        "id": "autodev.agent-picker.trigger-agent-error-flag-action",
        "defaultMessage": "Review error in Rovo chat"
    },
    agentPickerInBulkAllSuccessFlagTitle: {
        "id": "autodev.agent-picker.trigger-agent-all-success-flag-title",
        "defaultMessage": "\"{agentName}\" is coding {issueCount} work {issueCount, plural, one {item} other {items}}"
    },
    agentPickerInBulkAllSuccessFlagDescriptionBeforeDevHub: {
        "id": "autodev.agent-picker.trigger-agent-all-success-flag-description-before-devhub",
        "defaultMessage": "Check each work item to see the progress."
    },
    agentPickerInBulkStartInfoFlagTitle: {
        "id": "autodev.agent-picker.trigger-agent-start-info-flag-in-bulk-title",
        "defaultMessage": "Asking \"{agentName}\" to code {issueCount} work {issueCount, plural, one {item} other {items}}"
    },
    agentPickerInBulkStartInfoFlagDescription: {
        "id": "autodev.agent-picker.trigger-agent-start-info-flag-in-bulk-description",
        "defaultMessage": "We'll let you know when they're ready to review."
    },
    viewInDevelopment: {
        "id": "autodev.agent-picker.trigger-agent-view-in-development",
        "defaultMessage": "View in Development"
    },
    agentPickerInBulkAttemptedOverLimitFlagTitle: {
        "id": "autodev.agent-picker.trigger-agent-in-bulk-attempted-over-limit-flag-title",
        "defaultMessage": "Bulk limit is applied"
    },
    agentPickerInBulkAttemptedOverLimitFlagDescription: {
        "id": "autodev.agent-picker.trigger-agent-in-bulk-attempted-over-limit-flag-description",
        "defaultMessage": "Sorry, we support up to {limit} work {limit, plural, one {item} other {items}} for bulk run."
    },
    agentPickerInBulkAttemptedOverLimitFlagDescription2: {
        "id": "autodev.agent-picker.trigger-agent-in-bulk-attempted-over-limit-flag-description2",
        "defaultMessage": "Please try to select less than or equal to {limit} work {limit, plural, one {item} other {items}}"
    },
    agentPickerInBulkErrorUnexpectedFlagTitle: {
        "id": "autodev.agent-picker.trigger-agent-unexpected-error-flag-in-bulk-title",
        "defaultMessage": "Something went wrong. Please try again or contact support for help."
    },
    agentPickerInBulkErrorFlagTitle: {
        "id": "autodev.agent-picker.trigger-agent-error-flag-in-bulk-title",
        "defaultMessage": "\"{agentName}\" couldn't generate code for {errorIssueCount} {errorIssueCount, plural, one {work item} other {work items}}."
    },
    agentPickerInBulkErrorFlagDescription: {
        "id": "autodev.agent-picker.trigger-agent-error-flag-in-bulk-description",
        "defaultMessage": "Chat to the agent:"
    },
    agentPickerInBulkErrorFlagDescriptionManyFailure: {
        "id": "autodev.agent-picker.trigger-agent-error-flag-in-bulk-description-many-failure",
        "defaultMessage": "We will send Jira/email notifications soon with links to chat with the agent for each work item."
    },
    triggerPlaceholder: {
        "id": "autodev.agent-picker.trigger-placeholder",
        "defaultMessage": "Search agents"
    },
    suggestedAgents: {
        "id": "autodev.agent-picker.suggested-agents",
        "defaultMessage": "Suggested agents"
    },
    codingAgents: {
        "id": "autodev.agent-picker.coding-agents",
        "defaultMessage": "Coding agents"
    },
    runAiCodingToolButtonLabel: {
        "id": "autodev.agent-picker.run-ai-coding-tool-button-label",
        "defaultMessage": "Use AI coding tool"
    },
    runAiCodingToolButtonSubheading: {
        "id": "autodev.agent-picker.run-ai-coding-tool-button-subheading",
        "defaultMessage": "Can't find an agent for your task?"
    },
    newLozengeLabel: {
        "id": "autodev.agent-picker.new-lozenge-label",
        "defaultMessage": "new"
    }
});

});

parcelRegister("21dMx", function(module, exports) {

$parcel$export(module.exports, "EmptyAgentResult", () => $81240d342fcbd172$export$1a6c5d8350c8c858);

var $5uXOq = parcelRequire("5uXOq");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $jmx4a = parcelRequire("jmx4a");
const $81240d342fcbd172$export$1a6c5d8350c8c858 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $81240d342fcbd172$var$wrppaerStyles,
        alignItems: "center",
        justifyContent: "center"
    }, formatMessage((0, $jmx4a.default).noResult));
};
const $81240d342fcbd172$var$wrppaerStyles = (0, $8CUq3.xcss)({
    width: '100%',
    height: '120px'
});

});
parcelRegister("jmx4a", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd2d2f2716c7ce09$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fd2d2f2716c7ce09$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noResult: {
        "id": "autodev.agent-picker.picker-content.empty-agent-result",
        "defaultMessage": "We didn't find any matches for your search."
    }
});

});


parcelRegister("fLMSN", function(module, exports) {

$parcel$export(module.exports, "useOnTriggerAgentMutationError", () => $1f37ea409bd72633$export$c9c1a31fbe7c9a32);
$parcel$export(module.exports, "useOnTrigggerAgentMutationCompleted", () => $1f37ea409bd72633$export$ffeb8f8d83474);
$parcel$export(module.exports, "useOnTriggerAgentInBulkMutationError", () => $1f37ea409bd72633$export$3190bbd5a99c2ef5);
$parcel$export(module.exports, "useOnTrigggerAgentInBulkMutationCallbacks", () => $1f37ea409bd72633$export$4a8c7959a26fb397);
$parcel$export(module.exports, "emptyJobListStore", () => $1f37ea409bd72633$export$a13948faa08c2141);
$parcel$export(module.exports, "onDeleteJobMutationUpdater", () => $1f37ea409bd72633$export$d0fec9375e84056d);
$parcel$export(module.exports, "shouldShowJobLoadingState", () => $1f37ea409bd72633$export$fb80077dd047b87f);
$parcel$export(module.exports, "InvokeAgentMutation", () => $1f37ea409bd72633$export$d976531ae7e54b2d);
$parcel$export(module.exports, "triggerAutodevSlowEndpoint", () => $1f37ea409bd72633$export$a1429ab3f44abf59);
$parcel$export(module.exports, "triggerAutodevBulkSlowEndpoint", () => $1f37ea409bd72633$export$b0987920a4db4fef);

var $2S7Jv = parcelRequire("2S7Jv");

var $49Oxg = parcelRequire("49Oxg");

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $8Uumt = parcelRequire("8Uumt");

var $hjiMw = parcelRequire("hjiMw");

var $5yJb9 = parcelRequire("5yJb9");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $jcw0u = parcelRequire("jcw0u");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $7HGHK = parcelRequire("7HGHK");

var $kekQh = parcelRequire("kekQh");

var $7Fi3v = parcelRequire("7Fi3v");

var $6AbJv = parcelRequire("6AbJv");

const $1f37ea409bd72633$var$onTriggerAgentError = ({ agentId: agentId, issueAri: issueAri, showFlag: showFlag, dismissFlag: dismissFlag, formatMessage: formatMessage, error: error, errorDetails: errorDetails, duration: duration, openChat: openChat })=>{
    const flagId = (0, $7Jxgt.v4)();
    (0, $jcw0u.default)({
        error: error ?? new Error('Failed to trigger Autodev Rovo agent'),
        meta: {
            id: 'triggerAutodevRovoAgent',
            packageName: 'jiraAutodev',
            teamName: 'autodev'
        },
        attributes: {
            agentId: agentId,
            issueAri: issueAri,
            duration: duration,
            ...errorDetails ?? {}
        },
        sendToPrivacyUnsafeSplunk: true
    });
    showFlag({
        messageId: 'autodev-agent-picker.ui.picker-content.show-flag.error',
        messageType: 'transactional',
        id: flagId,
        type: 'error',
        title: formatMessage((0, $6AbJv.default).agentPickerErrorFlagTitle),
        description: formatMessage((0, $6AbJv.default).agentPickerErrorFlagDescription),
        actions: openChat ? [
            {
                content: formatMessage((0, $6AbJv.default).agentPickerErrorFlagAction),
                onClick: ()=>{
                    openChat();
                    dismissFlag({
                        id: flagId,
                        command: (0, $7HGHK.DISMISS_COMMAND)
                    });
                }
            }
        ] : []
    });
};
const $1f37ea409bd72633$export$c9c1a31fbe7c9a32 = (issueAri)=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return (agentId, duration, e)=>$1f37ea409bd72633$var$onTriggerAgentError({
            agentId: agentId,
            issueAri: issueAri,
            showFlag: showFlag,
            dismissFlag: dismissFlag,
            formatMessage: formatMessage,
            error: e,
            duration: duration
        });
};
const $1f37ea409bd72633$var$extractErrorFromResponse = (data)=>{
    const { extensions: extensions, message: message } = data.devai_invokeAutodevRovoAgent?.errors?.[0] ?? {
        message: 'Failed to trigger Autodev Rovo agent',
        extensions: null
    };
    const { errorType: errorType, statusCode: statusCode } = extensions ?? {
        errorType: 'unknown',
        statusCode: 500
    };
    const errorDetails = {
        statusCode: statusCode,
        errorType: errorType
    };
    return {
        errorDetails: errorDetails,
        message: message
    };
};
const $1f37ea409bd72633$export$ffeb8f8d83474 = (issueAri, onMutationSuccess, setIsTriggeringAutodevInprogress)=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { openChat: openChat } = $1f37ea409bd72633$export$690ebf882589fc18();
    return (data, agentId, duration)=>{
        if (data.devai_invokeAutodevRovoAgent?.success !== true) {
            const { message: message, errorDetails: errorDetails } = $1f37ea409bd72633$var$extractErrorFromResponse(data);
            const conversationId = data.devai_invokeAutodevRovoAgent?.conversationId;
            const shouldReviewInRovoChat = [
                'action_not_returned',
                'action_execution_failed'
            ].includes(errorDetails.errorType ?? '');
            setIsTriggeringAutodevInprogress?.(false);
            $1f37ea409bd72633$var$onTriggerAgentError({
                agentId: agentId,
                issueAri: issueAri,
                showFlag: showFlag,
                dismissFlag: dismissFlag,
                formatMessage: formatMessage,
                duration: duration,
                error: message ? new Error(message) : undefined,
                errorDetails: errorDetails,
                openChat: shouldReviewInRovoChat && conversationId != null ? ()=>openChat(conversationId) : undefined
            });
            return;
        }
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'triggerAutodevRovoAgent success', {
            agentId: agentId,
            issueAri: issueAri,
            duration: duration
        });
        onMutationSuccess();
    };
};
const $1f37ea409bd72633$var$onTriggerAgentInBulkError = ({ agentId: agentId, agentName: agentName, failedIssueInfo: failedIssueInfo, issueAris: issueAris, projectKey: projectKey, showFlag: showFlag, formatMessage: formatMessage, error: error, errorDetails: errorDetails, duration: duration, isSimplifiedProject: isSimplifiedProject })=>{
    (0, $jcw0u.default)({
        error: error,
        meta: {
            id: 'triggerAutodevRovoAgentInBulk',
            packageName: 'jiraAutodev',
            teamName: 'autodev'
        },
        attributes: {
            agentId: agentId,
            issueAris: issueAris.toString(),
            duration: duration,
            numTotalIssues: issueAris.length,
            numFailedIssues: failedIssueInfo.length,
            numFailedIssuesWithoutConversationId: failedIssueInfo.filter((failedIssue)=>failedIssue.conversationId == null).length,
            ...errorDetails ?? {}
        },
        sendToPrivacyUnsafeSplunk: true
    });
    const issuesWithErrorCount = failedIssueInfo.length;
    if (issuesWithErrorCount === 0) {
        // This is success: false case that should rarely happen in real world, when something went seriously wrong.
        showFlag({
            messageId: 'autodev-agent-picker.ui.picker-content.show-flag.error.picker-content-bulk-run-unexpected.show-flag.error',
            messageType: 'transactional',
            type: 'error',
            title: formatMessage((0, $6AbJv.default).agentPickerInBulkErrorUnexpectedFlagTitle),
            testId: 'autodev-agent-picker.ui.picker-content.invoke-autodev-failure-flag'
        });
        return;
    }
    const successfulIssueCount = issueAris.length - failedIssueInfo.length;
    if (successfulIssueCount > 0) showFlag({
        messageId: 'autodev-agent-picker.ui.picker-content.show-flag.success.error.picker-content-bulk-run.show-flag.error',
        messageType: 'transactional',
        type: 'success',
        title: formatMessage((0, $6AbJv.default).agentPickerInBulkAllSuccessFlagTitle, {
            agentName: agentName,
            issueCount: successfulIssueCount
        }),
        description: undefined,
        actions: [
            {
                content: formatMessage((0, $6AbJv.default).viewInDevelopment),
                href: `/jira/software/${isSimplifiedProject ? '' : 'c/'}projects/${projectKey}/development?tab=AGENTS`,
                target: '_blank',
                onClick: (_, analyticsEvent)=>{
                    if (analyticsEvent != null) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'viewInDevelopment', {
                        flagType: 'afterSomeFailed'
                    });
                }
            }
        ]
    });
    // Error flag can't display too many actions that will just overflow its flag height. This is temp fix until we improve the triggering UX
    // https://atlassian.slack.com/archives/CFJ9DU39U/p1744268439473649
    const showActions = failedIssueInfo.length <= 10;
    showFlag({
        messageId: 'autodev-agent-picker.ui.picker-content.show-flag.error.picker-content-bulk-run.show-flag.error',
        messageType: 'transactional',
        type: 'error',
        title: formatMessage((0, $6AbJv.default).agentPickerInBulkErrorFlagTitle, {
            agentName: agentName,
            errorIssueCount: issuesWithErrorCount
        }),
        description: showActions ? formatMessage((0, $6AbJv.default).agentPickerInBulkErrorFlagDescription) : formatMessage((0, $6AbJv.default).agentPickerInBulkErrorFlagDescriptionManyFailure),
        actions: showActions ? failedIssueInfo// We can't do much when there isn't conversaion id returned, but this should not happen in real world.
        .filter((failedIssue)=>failedIssue.conversationId != null).map((failedIssue)=>({
                content: failedIssue.issueKey,
                href: `${failedIssue.issueUrl}?${0, $7Fi3v.ROVO_CHAT_QUERYPARAM_KEY}=${failedIssue.conversationId}`,
                target: '_blank',
                onClick: (_, analyticsEvent)=>{
                    if (analyticsEvent != null) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'agentBulkErrorLink');
                }
            })) : undefined,
        testId: 'autodev-agent-picker.ui.picker-content.invoke-autodev-partial-failure-flag'
    });
};
const $1f37ea409bd72633$export$3190bbd5a99c2ef5 = (issueAris, projectKey)=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isSimplifiedProject = $1f37ea409bd72633$var$getIsSimplifiedProject();
    return ({ agentId: agentId, agentName: agentName, duration: duration, e: e, failedIssueInfo: failedIssueInfo })=>$1f37ea409bd72633$var$onTriggerAgentInBulkError({
            agentId: agentId,
            agentName: agentName,
            issueAris: issueAris,
            projectKey: projectKey,
            failedIssueInfo: failedIssueInfo,
            showFlag: showFlag,
            formatMessage: formatMessage,
            error: e,
            duration: duration,
            isSimplifiedProject: isSimplifiedProject
        });
};
const $1f37ea409bd72633$var$extractErrorFromBulkMutationResponse = (data)=>{
    const { extensions: extensions, message: message } = data.devai_invokeAutodevRovoAgentInBulk?.errors?.[0] ?? {
        message: 'Failed to trigger Autodev Rovo agent in bulk',
        extensions: null
    };
    const { errorType: errorType, statusCode: statusCode } = extensions ?? {
        errorType: 'unknown',
        statusCode: 500
    };
    const errorDetails = {
        statusCode: statusCode,
        errorType: errorType
    };
    return {
        errorDetails: errorDetails,
        message: message
    };
};
const $1f37ea409bd72633$export$4a8c7959a26fb397 = (issueAris, projectKey)=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isSimplifiedProject = $1f37ea409bd72633$var$getIsSimplifiedProject();
    return {
        onTriggerMutationInBulkCompleted: ({ data: data, agentId: agentId, agentName: agentName, issueCount: issueCount, duration: duration })=>{
            const failedIssues = data.devai_invokeAutodevRovoAgentInBulk?.failedIssues ?? [];
            const successfulIssues = data.devai_invokeAutodevRovoAgentInBulk?.succeededIssues ?? [];
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'jiraFlag viewed', 'agentBulkFlagResult', {
                numSuccessfulIssues: successfulIssues.length,
                numFailedIssues: failedIssues.length
            });
            if (data.devai_invokeAutodevRovoAgentInBulk?.success !== true || failedIssues.length > 0) {
                const { message: message, errorDetails: errorDetails } = $1f37ea409bd72633$var$extractErrorFromBulkMutationResponse(data);
                const errorToReport = failedIssues.length > 0 ? new Error('Some issues failed to trigger Agent') : new Error(message ?? 'Failed to trigger Autodev Rovo agent in bulk');
                $1f37ea409bd72633$var$onTriggerAgentInBulkError({
                    failedIssueInfo: failedIssues.filter(Boolean).map((failedIssue)=>({
                            issueKey: failedIssue?.issue?.key ?? '',
                            conversationId: failedIssue?.conversationId ?? '',
                            issueUrl: failedIssue?.issue?.webUrl ?? ''
                        })),
                    agentId: agentId,
                    agentName: agentName,
                    issueAris: issueAris,
                    projectKey: projectKey,
                    showFlag: showFlag,
                    formatMessage: formatMessage,
                    duration: duration,
                    error: errorToReport,
                    errorDetails: failedIssues.length > 0 ? undefined : errorDetails,
                    isSimplifiedProject: isSimplifiedProject
                });
                return;
            }
            // All succeeded
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'triggerAutodevRovoAgentInBulk success', {
                agentId: agentId,
                issueAris: issueAris.toString(),
                duration: duration,
                totalIssues: issueAris.length,
                failedIssues: failedIssues.length,
                failedIssuesWithoutConversationId: failedIssues.filter((failedIssue)=>failedIssue?.conversationId == null)
            });
            showFlag({
                messageId: 'autodev-agent-picker.ui.picker-content.show-flag.success.picker-content-bulk-run.show-flag.all-succeeded',
                messageType: 'transactional',
                type: 'success',
                title: formatMessage((0, $6AbJv.default).agentPickerInBulkAllSuccessFlagTitle, {
                    agentName: agentName,
                    issueCount: issueCount
                }),
                description: undefined,
                actions: [
                    {
                        content: formatMessage((0, $6AbJv.default).viewInDevelopment),
                        href: `/jira/software/${isSimplifiedProject ? '' : 'c/'}projects/${projectKey}/development?tab=AGENTS`,
                        target: '_blank',
                        onClick: (_, analyticsEvent)=>{
                            if (analyticsEvent != null) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'viewInDevelopment', {
                                flagType: 'afterAllSuccessful'
                            });
                        }
                    }
                ],
                testId: 'autodev-agent-picker.ui.picker-content.invoke-autodev-success-flag'
            });
        },
        onTriggerMutationInBulkStarted: (agentName, issueCount)=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'agentPickerBulk');
            showFlag({
                messageId: 'autodev-agent-picker.ui.picker-content.show-flag.info.picker-content-bulk-run.show-flag.started',
                messageType: 'transactional',
                type: 'info',
                title: formatMessage((0, $6AbJv.default).agentPickerInBulkStartInfoFlagTitle, {
                    agentName: agentName,
                    issueCount: issueCount
                }),
                description: formatMessage((0, $6AbJv.default).agentPickerInBulkStartInfoFlagDescription),
                testId: 'autodev-agent-picker.ui.picker-content.invoke-autodev-started-flag'
            });
        },
        onTriggerMutationInBulkOverLimit: ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'agentPickerBulk', {
                isLimitReached: true
            });
            showFlag({
                messageId: 'autodev-agent-picker.ui.picker-content.show-flag.error.flag.error.show-flag.error.info.picker-content-bulk-run-over-limit-error-flag',
                messageType: 'transactional',
                type: 'error',
                title: formatMessage((0, $6AbJv.default).agentPickerInBulkAttemptedOverLimitFlagTitle),
                description: `${formatMessage((0, $6AbJv.default).agentPickerInBulkAttemptedOverLimitFlagDescription, {
                    limit: (0, $da07cd02a4c3461e$export$59dc7fa89ac047ce)
                })} ${formatMessage((0, $6AbJv.default).agentPickerInBulkAttemptedOverLimitFlagDescription2, {
                    limit: (0, $da07cd02a4c3461e$export$59dc7fa89ac047ce)
                })}`
            });
        }
    };
};
const $1f37ea409bd72633$export$a13948faa08c2141 = (store, jobListRelayStoreId)=>{
    const jobListRecord = store.get(jobListRelayStoreId ?? '');
    if (!jobListRecord) return;
    jobListRecord.setLinkedRecords([], 'nodes');
};
const $1f37ea409bd72633$export$d0fec9375e84056d = (store, isSuccessful, jobListRelayStoreId)=>{
    if (isSuccessful) $1f37ea409bd72633$export$a13948faa08c2141(store, jobListRelayStoreId);
};
const $1f37ea409bd72633$export$690ebf882589fc18 = ()=>{
    const publish = (0, $hjiMw.usePublish)('ai-mate');
    const openChat = (0, $5uXOq.useCallback)((channelId)=>{
        publish({
            type: 'chat-open',
            product: 'jira',
            data: {
                channelId: channelId
            },
            source: 'autodev'
        });
    }, [
        publish
    ]);
    return {
        openChat: openChat
    };
};
const $1f37ea409bd72633$export$fb80077dd047b87f = ({ screen: screen, isTriggeringAutodevInprogress: isTriggeringAutodevInprogress, jobPhase: jobPhase, jobStatus: jobStatus, isAgentJob: isAgentJob })=>{
    if (isTriggeringAutodevInprogress) // We need this check to because we can't know isAgentJob before job is returned from the network until mutation response comes back with job info
    return true;
    if (isAgentJob) return isTriggeringAutodevInprogress || (0, $kekQh.isAgentTriggeredJobInProgress)(jobPhase, jobStatus);
    // If the user has clicked the trigger button in the normal Autodev flow,
    // we optimistically show the processing screen until the actual job is returned
    // from the network
    return (0, $7Fi3v.PROCESSING_SCREENS).includes(screen);
};
const $1f37ea409bd72633$export$d976531ae7e54b2d = (0, $49Oxg.default);
const $1f37ea409bd72633$export$a1429ab3f44abf59 = ({ agentId: agentId, issueAris: issueAris, onTriggerMutationCompleted: onTriggerMutationCompleted, onTriggerMutationError: onTriggerMutationError, setIsTriggeringAutodevInprogress: setIsTriggeringAutodevInprogress })=>{
    const start = Date.now();
    (0, $8Uumt.commitMutation)((0, $5yJb9.default)(), {
        mutation: $1f37ea409bd72633$export$d976531ae7e54b2d,
        cacheConfig: {
            metadata: {
                META_SLOW_ENDPOINT: true
            }
        },
        variables: {
            issueAri: issueAris[0],
            agentId: agentId
        },
        onCompleted: (mutationResponse)=>{
            const duration = Date.now() - start;
            onTriggerMutationCompleted(mutationResponse, agentId, duration);
        },
        onError: (e)=>{
            const duration = Date.now() - start;
            setIsTriggeringAutodevInprogress?.(false);
            onTriggerMutationError(agentId, duration, e);
        }
    });
};
const $1f37ea409bd72633$export$b0987920a4db4fef = ({ agentId: agentId, agentName: agentName, issueCount: issueCount, issueAris: issueAris, onTriggerMutationInBulkCompleted: onTriggerMutationInBulkCompleted, onTriggerMutationInBulkError: onTriggerMutationInBulkError })=>{
    const start = Date.now();
    (0, $8Uumt.commitMutation)((0, $5yJb9.default)(), {
        // eslint-disable-next-line @atlassian/relay/must-use-inline -- Special case for slow endpoint
        mutation: (0, $2S7Jv.default),
        cacheConfig: {
            metadata: {
                META_SLOW_ENDPOINT: true
            }
        },
        variables: {
            issueAris: issueAris,
            agentId: agentId
        },
        onCompleted: (mutationResponse)=>{
            const duration = Date.now() - start;
            onTriggerMutationInBulkCompleted({
                data: mutationResponse,
                agentId: agentId,
                agentName: agentName,
                issueCount: issueCount,
                duration: duration
            });
        },
        onError: (e)=>{
            const duration = Date.now() - start;
            onTriggerMutationInBulkError({
                agentId: agentId,
                agentName: agentName,
                duration: duration,
                e: e,
                failedIssueInfo: []
            });
        }
    });
};
const $1f37ea409bd72633$var$getIsSimplifiedProject = ()=>{
    // TODO: Fix this properly. Our original `useIsSimplifiedProject` approach didn't work consistently because
    // the project context isn't always available outside of the issue view. We should fetch it via Relay instead.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.location.pathname.includes('/c/') === false;
};

});
parcelRegister("2S7Jv", function(module, exports) {

$parcel$export(module.exports, "default", () => $02602d8dcc8fcf46$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ecdf2719376f1eed9330fe1c441f1df5>>
 * @relayHash b3232d7b92ac553b47d3583f5d7896c3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 657198e5f5de7fb58234d83366348f1e6bc455797a0a585d72acdc8bd0087e33
const $02602d8dcc8fcf46$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "agentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueAris"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "agentId",
            "variableName": "agentId"
        },
        {
            "kind": "Variable",
            "name": "issueIds",
            "variableName": "issueAris"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "conversationId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "key"
    }, v6 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v7 = {
        "concreteType": "DevAiInvokeAutodevRovoAgentInBulkIssueResult",
        "kind": "LinkedField",
        "name": "succeededIssues",
        "plural": true,
        "selections": [
            v3 /*: any*/ ,
            v4 /*: any*/ 
        ]
    }, v8 = {
        "kind": "ScalarField",
        "name": "success"
    }, v9 = {
        "kind": "ScalarField",
        "name": "message"
    }, v10 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v11 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v12 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "utils_triggerRovoAgentInBulkMutation",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "DevAiInvokeAutodevRovoAgentInBulkPayload",
                    "kind": "LinkedField",
                    "name": "devai_invokeAutodevRovoAgentInBulk",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "DevAiInvokeAutodevRovoAgentInBulkIssueResult",
                            "kind": "LinkedField",
                            "name": "failedIssues",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "issue",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "utils_triggerRovoAgentInBulkMutation",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "DevAiInvokeAutodevRovoAgentInBulkPayload",
                    "kind": "LinkedField",
                    "name": "devai_invokeAutodevRovoAgentInBulk",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "DevAiInvokeAutodevRovoAgentInBulkIssueResult",
                            "kind": "LinkedField",
                            "name": "failedIssues",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "issue",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v12 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v12 /*: any*/ 
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "657198e5f5de7fb58234d83366348f1e6bc455797a0a585d72acdc8bd0087e33",
            "metadata": {},
            "name": "utils_triggerRovoAgentInBulkMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$02602d8dcc8fcf46$var$node.hash = "56fe382d6a3a0be60c2eeb8706e10093";
var $02602d8dcc8fcf46$export$2e2bcd8739ae039 = $02602d8dcc8fcf46$var$node;

});

parcelRegister("49Oxg", function(module, exports) {

$parcel$export(module.exports, "default", () => $e74c7fc060f400bb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<70e6e74ef9fbef623b5bd1599e432c51>>
 * @relayHash e7f5ae3e2fe43434e83ecc989b3f3f0e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 754349f913fd3517ba0b47d0f538b86026d50c09588408409e925c0487acda93
const $e74c7fc060f400bb$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "agentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueAri"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "agentId",
            "variableName": "agentId"
        },
        {
            "kind": "Variable",
            "name": "issueId",
            "variableName": "issueAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "conversationId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "success"
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v7 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "utils_triggerRovoAgentMutation",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "DevAiInvokeAutodevRovoAgentPayload",
                    "kind": "LinkedField",
                    "name": "devai_invokeAutodevRovoAgent",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "utils_triggerRovoAgentMutation",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "DevAiInvokeAutodevRovoAgentPayload",
                    "kind": "LinkedField",
                    "name": "devai_invokeAutodevRovoAgent",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "754349f913fd3517ba0b47d0f538b86026d50c09588408409e925c0487acda93",
            "metadata": {},
            "name": "utils_triggerRovoAgentMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$e74c7fc060f400bb$var$node.hash = "78107f5766d4a88329a1609dc07c3bb4";
var $e74c7fc060f400bb$export$2e2bcd8739ae039 = $e74c7fc060f400bb$var$node;

});

const $da07cd02a4c3461e$export$59dc7fa89ac047ce = 20;


parcelRegister("e7nrc", function(module, exports) {

$parcel$export(module.exports, "BrowseTemplateModalDropdownItem", () => $c178ecfa31d4ad40$export$568c53495ead9a0e);

var $5uXOq = parcelRequire("5uXOq");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $4V6HW = parcelRequire("4V6HW");

var $lXAdy = parcelRequire("lXAdy");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $koVbs = parcelRequire("koVbs");

var $c9AIG = parcelRequire("c9AIG");

var $9CZCe = parcelRequire("9CZCe");
const $c178ecfa31d4ad40$export$568c53495ead9a0e = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lXAdy.ModalEntryPointDropdownItemTrigger), {
        entryPoint: (0, $c9AIG.browseTemplateModalEntryPoint),
        entryPointProps: {},
        interactionName: "browse-agent-template-open-modal-button",
        useInternalModal: false,
        onClick: ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'moreRovodevAgentsButtonClicked');
        },
        // Moved inside after test is written
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "autodev-agent-picker.ui.picker-content.more-agents-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        xcss: $c178ecfa31d4ad40$var$buttonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $c178ecfa31d4ad40$var$iconWrapperStyles,
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4V6HW))), {
        label: formatMessage((0, $9CZCe.default).runAiCodingToolButtonLabel)
    })), formatMessage((0, $9CZCe.default).browseAllAgentsButtonLabel)));
};
const $c178ecfa31d4ad40$var$buttonStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});
const $c178ecfa31d4ad40$var$iconWrapperStyles = (0, $8CUq3.xcss)({
    width: '16px',
    marginRight: 'space.250'
});

});
parcelRegister("c9AIG", function(module, exports) {

$parcel$export(module.exports, "browseTemplateModalEntryPoint", () => $1245499d079db525$export$ac9a364229ef884a);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $1245499d079db525$export$ac9a364229ef884a = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("gn9Dj")).then((module)=>module.BrowseTemplateModalEntryPointComponent), {
        moduleId: "38e5b124"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("gn9Dj", function(module, exports) {

let $beb6443bfa3f6b5e$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $beb6443bfa3f6b5e$var$load("ffQaD"),
    $beb6443bfa3f6b5e$var$load("kvRbA"),
    $beb6443bfa3f6b5e$var$load("76n7a"),
    $beb6443bfa3f6b5e$var$load("l253H"),
    $beb6443bfa3f6b5e$var$load("fliVL"),
    $beb6443bfa3f6b5e$var$load("e4hYO")
]).then(()=>parcelRequire('j6DvF'));

});


parcelRegister("9CZCe", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b9f518102de5c2d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8b9f518102de5c2d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    browseAllAgentsButtonLabel: {
        "id": "autodev.agent-picker.browse-all-template-modal-entry-label",
        "defaultMessage": "Browse all agents"
    },
    runAiCodingToolButtonLabel: {
        "id": "autodev.agent-picker.run-ai-coding-tool-button-label",
        "defaultMessage": "Use AI coding tool"
    }
});

});


parcelRegister("gY6Pn", function(module, exports) {

$parcel$export(module.exports, "CreateDeveloperAgentDropdownItem", () => $8d31eb9da43d0d71$export$5e32907c1cbd2f1);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $dZbEw = parcelRequire("dZbEw");

var $lXAdy = parcelRequire("lXAdy");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $koVbs = parcelRequire("koVbs");

var $69lTT = parcelRequire("69lTT");

var $41OnD = parcelRequire("41OnD");
const $8d31eb9da43d0d71$export$5e32907c1cbd2f1 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lXAdy.ModalEntryPointDropdownItemTrigger), {
        entryPoint: (0, $69lTT.browseTemplateModalEntryPoint),
        entryPointProps: {},
        interactionName: "create-developer-agent-open-modal-button",
        useInternalModal: false,
        onClick: ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'createCodingAgentTemplateDropdownItem');
        },
        // Moved inside after test is written
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "autodev-agent-picker.ui.picker-content.create-coding-agent-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $8d31eb9da43d0d71$var$iconWrapperStyles,
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))), {
        label: formatMessage((0, $41OnD.default).createCodingAgentButtonLabel)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        xcss: $8d31eb9da43d0d71$var$titleSubTitleWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span",
        xcss: $8d31eb9da43d0d71$var$truncateTextStyles
    }, formatMessage((0, $41OnD.default).createCodingAgentButtonLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span",
        xcss: [
            $8d31eb9da43d0d71$var$subLabelStyles,
            $8d31eb9da43d0d71$var$truncateTextStyles
        ]
    }, formatMessage((0, $41OnD.default).createCodingAgentButtonSubLabel)))));
};
const $8d31eb9da43d0d71$var$iconWrapperStyles = (0, $8CUq3.xcss)({
    width: '16px',
    marginRight: 'space.250'
});
const $8d31eb9da43d0d71$var$titleSubTitleWrapperStyles = (0, $8CUq3.xcss)({
    minWidth: '0',
    height: '100%',
    textAlign: 'left',
    flex: 1,
    justifyContent: 'center',
    paddingRight: 'space.100'
});
const $8d31eb9da43d0d71$var$truncateTextStyles = (0, $8CUq3.xcss)({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $8d31eb9da43d0d71$var$subLabelStyles = (0, $8CUq3.xcss)({
    minWidth: '0',
    color: 'color.text.subtlest',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});

});
parcelRegister("69lTT", function(module, exports) {

$parcel$export(module.exports, "browseTemplateModalEntryPoint", () => $cfcecea42304e3e7$export$ac9a364229ef884a);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $cfcecea42304e3e7$export$ac9a364229ef884a = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("5GRxq")).then((module)=>module.BrowseTemplateModalEntryPointComponent), {
        moduleId: "592596b6"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("5GRxq", function(module, exports) {

let $424a678a80590ecd$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $424a678a80590ecd$var$load("ffQaD"),
    $424a678a80590ecd$var$load("kvRbA"),
    $424a678a80590ecd$var$load("76n7a"),
    $424a678a80590ecd$var$load("l253H"),
    $424a678a80590ecd$var$load("fliVL"),
    $424a678a80590ecd$var$load("jrkYX")
]).then(()=>parcelRequire('dybsg'));

});


parcelRegister("41OnD", function(module, exports) {

$parcel$export(module.exports, "default", () => $f624d3284090160a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f624d3284090160a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createCodingAgentButtonLabel: {
        "id": "autodev.agent-picker.create-coding-agent-button-label",
        "defaultMessage": "Create a developer agent"
    },
    createCodingAgentButtonSubLabel: {
        "id": "autodev.agent-picker.create-coding-agent-button-sub-label",
        "defaultMessage": "Use a template to customize a new agent"
    }
});

});


parcelRegister("Q234Y", function(module, exports) {

$parcel$export(module.exports, "GoodRankIndictor", () => $6dca21da9c6ac698$export$edefbb51d5032094);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $7eFYp = parcelRequire("7eFYp");
const $6dca21da9c6ac698$export$edefbb51d5032094 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $7eFYp.default).tooltipMessage)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $6dca21da9c6ac698$var$rankIndicatorStyles,
        testId: "autodev-agent-picker.ui.picker-content.good-rank-indicator"
    }));
};
const $6dca21da9c6ac698$var$rankIndicatorStyles = (0, $8CUq3.xcss)({
    width: '12px',
    height: '12px',
    borderRadius: '6px',
    backgroundColor: 'color.background.success.bold'
});

});
parcelRegister("7eFYp", function(module, exports) {

$parcel$export(module.exports, "default", () => $65b5152c6840a6a9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $65b5152c6840a6a9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tooltipMessage: {
        "id": "autodev.agent-picker.good-rank-indicator-tooltip-message",
        "defaultMessage": "This is likely to be a good fit for this task"
    }
});

});



parcelRegister("a4KlA", function(module, exports) {

$parcel$export(module.exports, "Status", () => $23b808c4c77a0f85$export$96e9906d6d93a972);
$parcel$export(module.exports, "useIsAutoDevEnabled", () => $23b808c4c77a0f85$export$4c4ab362d8a15770);

var $fFAIy = parcelRequire("fFAIy");

var $5uXOq = parcelRequire("5uXOq");

var $eiowN = parcelRequire("eiowN");

var $4R6GH = parcelRequire("4R6GH");
const $23b808c4c77a0f85$export$96e9906d6d93a972 = {
    NOT_DETERMINED: 0,
    PROCESSING: 1,
    DETERMINED: 2
};
const $23b808c4c77a0f85$export$4c4ab362d8a15770 = (atlassianAccountId, cloudId, relayEnv, isRovoRequired = true)=>{
    const [isAutoDevEnabled, setIsAutoDevEnabled] = (0, $5uXOq.useState)(false);
    const [isDetermined, setIsDetermined] = (0, $5uXOq.useState)($23b808c4c77a0f85$export$96e9906d6d93a972.NOT_DETERMINED);
    (0, $5uXOq.useEffect)(()=>{
        const determineDevAIEnabled = async ()=>{
            if (atlassianAccountId === null || atlassianAccountId.trim() === '') {
                setIsAutoDevEnabled(false);
                setIsDetermined($23b808c4c77a0f85$export$96e9906d6d93a972.DETERMINED);
            } else $23b808c4c77a0f85$export$dee0c91847f2a763({
                atlassianAccountId: atlassianAccountId,
                cloudId: cloudId,
                relayEnv: relayEnv
            }).then((response)=>{
                const hasProductAccess = response?.hasProductAccess ?? false;
                const rovoEnabled = response?.isRovoEnabled ?? false;
                setIsDetermined($23b808c4c77a0f85$export$96e9906d6d93a972.DETERMINED);
                setIsAutoDevEnabled(hasProductAccess && (isRovoRequired ? rovoEnabled : true));
            }).catch(()=>{
                setIsAutoDevEnabled(false);
                setIsDetermined($23b808c4c77a0f85$export$96e9906d6d93a972.DETERMINED);
            });
        };
        if (isDetermined === $23b808c4c77a0f85$export$96e9906d6d93a972.NOT_DETERMINED && atlassianAccountId !== '') {
            setIsDetermined($23b808c4c77a0f85$export$96e9906d6d93a972.PROCESSING);
            if ((0, $4R6GH.fg)('coding-agents-limited-beta')) determineDevAIEnabled();
            else {
                setIsDetermined($23b808c4c77a0f85$export$96e9906d6d93a972.DETERMINED);
                setIsAutoDevEnabled(false);
            }
        }
    }, [
        atlassianAccountId,
        isDetermined,
        cloudId,
        relayEnv,
        isRovoRequired
    ]);
    return [
        isAutoDevEnabled,
        isDetermined
    ];
};
const $23b808c4c77a0f85$export$dee0c91847f2a763 = async ({ atlassianAccountId: atlassianAccountId, cloudId: cloudId, relayEnv: relayEnv })=>{
    const result = await (0, $eiowN.fetchQuery)(relayEnv, (0, $fFAIy.default), {
        atlassianAccountId: atlassianAccountId,
        cloudId: cloudId,
        isAutodevBetaEnabled: (0, $4R6GH.fg)('coding-agents-limited-beta')
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise().then((response)=>{
        return {
            hasProductAccess: response?.devai_rovoDevAgentsUser?.hasProductAccess ?? false,
            isAdmin: response?.devai_rovoDevAgentsUser?.isAdmin ?? false,
            isRovoEnabled: response?.jira?.isRovoEnabled ?? false
        };
    });
    return result;
};

});
parcelRegister("fFAIy", function(module, exports) {

$parcel$export(module.exports, "default", () => $61455f63387e5670$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<617855ec21de464b6fa2c4294ef59e04>>
 * @relayHash 835cf47f6749ab86fa6fd796e566b197
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e046b4c1327a28b7d4c765a0380da862200507908d5b6a7b0d1bf782e0a87057
const $61455f63387e5670$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "atlassianAccountId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isAutodevBetaEnabled"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "args": [
            {
                "kind": "Variable",
                "name": "atlassianAccountId",
                "variableName": "atlassianAccountId"
            },
            v1 /*: any*/ 
        ],
        "concreteType": "DevAiUser",
        "kind": "LinkedField",
        "name": "devai_rovoDevAgentsUser",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasProductAccess"
            },
            {
                "kind": "ScalarField",
                "name": "isAdmin"
            }
        ]
    }, v3 = {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
            {
                "condition": "isAutodevBetaEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "args": [
                            v1 /*: any*/ 
                        ],
                        "kind": "ScalarField",
                        "name": "isRovoEnabled"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsAutodevEnabledQuery",
            "selections": [
                {
                    "condition": "isAutodevBetaEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v2 /*: any*/ ,
                            "action": "THROW",
                            "path": "devai_rovoDevAgentsUser"
                        }
                    ]
                },
                v3 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsAutodevEnabledQuery",
            "selections": [
                {
                    "condition": "isAutodevBetaEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        v2 /*: any*/ 
                    ]
                },
                v3 /*: any*/ 
            ]
        },
        "params": {
            "id": "e046b4c1327a28b7d4c765a0380da862200507908d5b6a7b0d1bf782e0a87057",
            "metadata": {},
            "name": "useIsAutodevEnabledQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$61455f63387e5670$var$node.hash = "35a2fac16cf075dfe6102fcdda3a7299";
var $61455f63387e5670$export$2e2bcd8739ae039 = $61455f63387e5670$var$node;

});


parcelRegister("llaYv", function(module, exports) {

$parcel$export(module.exports, "createIssueAri", () => $5aad283ccb509d0b$export$6b0ec881a3540845);
$parcel$export(module.exports, "useMemoizedIssueAris", () => $5aad283ccb509d0b$export$f4f73900c93e8d2b);

var $5uXOq = parcelRequire("5uXOq");

var $dXq4S = parcelRequire("dXq4S");
const $5aad283ccb509d0b$export$6b0ec881a3540845 = (cloudId, issueId)=>(0, $dXq4S.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'issue',
        resourceId: issueId
    });
const $5aad283ccb509d0b$export$f4f73900c93e8d2b = (issueAris)=>{
    const previousArrayRef = (0, $5uXOq.useRef)();
    const sortedArray = [
        ...issueAris
    ].sort();
    (0, $5uXOq.useEffect)(()=>{
        const previousArray = previousArrayRef.current;
        if (previousArray == null || previousArray.length !== sortedArray.length) previousArrayRef.current = sortedArray;
        else {
            const arraysAreEqual = previousArray.every((value, index)=>value === sortedArray[index]);
            if (!arraysAreEqual) previousArrayRef.current = sortedArray;
        }
    }, [
        sortedArray
    ]);
    return previousArrayRef.current == null ? sortedArray : previousArrayRef.current;
};

});

parcelRegister("dzV1a", function(module, exports) {

$parcel$export(module.exports, "default", () => $674d5ac15b568582$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $674d5ac15b568582$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    useAgentLabel: {
        "id": "autodev.agent-picker-bulk.use-agent-label",
        "defaultMessage": "Use coding agent"
    },
    unexpectedErrorMessage: {
        "id": "autodev.agent-picker-bulk.use-agent-unexpected-error-message",
        "defaultMessage": "Something went wrong"
    }
});

});


parcelRegister("3bmrC", function(module, exports) {

$parcel$export(module.exports, "useCloseIssueViewOnBulkOpsEdit", () => $69f643f955e59150$export$7c7315d3993c325e);

var $5uXOq = parcelRequire("5uXOq");

var $doZTA = parcelRequire("doZTA");

var $38qhf = parcelRequire("38qhf");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");
const $69f643f955e59150$export$7c7315d3993c325e = ()=>{
    const handleCloseIssueView = (0, $c1MAf.useBacklogActionCreator)((0, $38qhf.closeDetailView));
    const handleOpenIssueView = (0, $c1MAf.useBacklogActionCreator)((0, $38qhf.openDetailView));
    const openIssue = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getDetailView));
    const getIssueKey = (0, $c1MAf.useBacklogSelector)((0, $dGljH.makeCardKeyFromCardId));
    const lastDetailViewOpen = (0, $5uXOq.useRef)(null);
    const [routerState, { replaceTo: replaceTo }] = (0, $doZTA.useRouter)();
    const closeIssueView = (0, $5uXOq.useCallback)(()=>{
        if (!lastDetailViewOpen.current) {
            lastDetailViewOpen.current = openIssue;
            handleCloseIssueView();
        }
    }, [
        handleCloseIssueView,
        openIssue
    ]);
    const openIssueView = (0, $5uXOq.useCallback)(()=>{
        if (lastDetailViewOpen.current) {
            const { cardId: cardId, externalAction: externalAction } = lastDetailViewOpen.current;
            const selectedIssue = getIssueKey(cardId);
            lastDetailViewOpen.current = null;
            handleOpenIssueView(cardId, externalAction);
            replaceTo(routerState.route, {
                params: routerState.match.params,
                query: {
                    ...routerState.query,
                    selectedIssue: selectedIssue
                }
            });
        }
    }, [
        getIssueKey,
        handleOpenIssueView,
        replaceTo,
        routerState.match.params,
        routerState.query,
        routerState.route
    ]);
    return {
        closeIssueView: closeIssueView,
        openIssueView: openIssueView
    };
};

});

parcelRegister("4RzmK", function(module, exports) {

$parcel$export(module.exports, "getBulkOperationsData", () => $31a707c120f93d10$export$3adfa80a98ae5d22);

var $gULOk = parcelRequire("gULOk");

var $5fc53 = parcelRequire("5fc53");
const $31a707c120f93d10$var$getStoryPointValue = (value)=>{
    if (value === null) return null;
    if (typeof value === 'string' && value.trim() === '') return null;
    const valueAsNumber = Number(value);
    if (Number.isNaN(valueAsNumber)) return undefined;
    return parseFloat(valueAsNumber.toFixed(3));
};
const $31a707c120f93d10$export$3adfa80a98ae5d22 = ({ data: data, estimationFieldId: estimationFieldId, isCMP: isCMP })=>Object.keys(data).reduce((acc, key)=>{
        if (key === (0, $5fc53.ASSIGNEE_TYPE)) {
            const value = data[key];
            if (value === undefined) return acc;
            acc.assignee = // TODO: update logic when automatic option is fixed
            // https://hello.atlassian.net/browse/DEE-3217
            value === null ? null : {
                id: value.accountId || '',
                displayName: value.displayName,
                avatarUrl: value.avatarUrls['48x48']
            };
        }
        if (key === (0, $5fc53.LABELS_TYPE)) {
            const labels = data[key];
            if (labels === undefined) return acc;
            const { value: value, action: action } = labels;
            acc.labels = {
                action: action,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                value: Array.isArray(value) ? value.map((label)=>label.label) : [
                    value.label
                ]
            };
        }
        if (key === (0, $5fc53.PRIORITY_TYPE)) {
            const value = data[key];
            if (value === undefined) return acc;
            acc.priority = {
                name: value.label,
                iconUrl: value.iconUrl
            };
        }
        if (key === (0, $5fc53.DUE_DATE_TYPE)) {
            const value = data[key];
            if (value === undefined) return acc;
            acc.dueDate = value;
        }
        if (key === (0, $5fc53.FIX_VERSIONS_TYPE)) {
            const fixVersions = data[key];
            if (fixVersions === undefined) return acc;
            const { value: value, action: action } = fixVersions;
            acc.fixVersions = {
                action: action,
                value: value.map((version)=>version.value)
            };
        }
        if (key === estimationFieldId) {
            // Temporary solution, when estimate field is available in bulk operations
            // conditions needs to be added to check against estimationFieldId
            // value (eg. timeoriginalestimate (TIME_ESTIMATE_TYPE))
            const storyPoints = $31a707c120f93d10$var$getStoryPointValue(data[key]);
            if (storyPoints !== undefined) acc.estimate = {
                storyPoints: storyPoints,
                originalEstimate: null,
                timeRemainingEstimate: null
            };
        }
        if (key === (0, $5fc53.PARENT_TYPE)) {
            const value = data[key];
            if (value === undefined) return acc;
            acc.parentId = value ? Number(value.id) : null;
        }
        if (key === (0, $5fc53.STATUS_TYPE)) {
            const value = data[key];
            if (value !== undefined && value !== null) {
                acc.statusId = value.statusId;
                if (!isCMP) acc.isDone = value.statusCategoryId === `${(0, $gULOk.StatusCategoryIds)[(0, $gULOk.StatusCategoryTypes).DONE]}`;
            }
        }
        return acc;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    }, {});

});

parcelRegister("tDHjp", function(module, exports) {

$parcel$export(module.exports, "useSelectActions", () => $e7b9bdbf67e8248b$export$d419676870909930);

var $5uXOq = parcelRequire("5uXOq");

var $8SI0F = parcelRequire("8SI0F");

var $4mqko = parcelRequire("4mqko");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");
const $e7b9bdbf67e8248b$export$d419676870909930 = ()=>{
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const visibleCardIds = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getVisibleCardIds));
    const visibleCardListIds = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getVisibleCardListIds));
    const selectAllVisible = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $4mqko.cardMultiSelectExtend)(visibleCardIds));
    }, [
        dispatch,
        visibleCardIds
    ]);
    const clearAll = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $4mqko.cardMultiSelect)([]));
        dispatch((0, $4mqko.cardClearRelativeCard)());
        dispatch((0, $8SI0F.setCheckboxSelectionMode)(false));
    }, [
        dispatch
    ]);
    const clearAllVisible = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $4mqko.cardMultiRemove)(visibleCardIds));
        dispatch((0, $8SI0F.setCheckboxSelectionMode)(false));
    }, [
        dispatch,
        visibleCardIds
    ]);
    const extraAnalyticsAttributes = (0, $5uXOq.useMemo)(()=>({
            selectAll: {
                checkbox: {
                    issue_ids: visibleCardIds,
                    numSelectedSprints: visibleCardListIds.length,
                    numSelectedCards: visibleCardIds.length
                },
                option: {
                    numSelectedCards: visibleCardIds.length
                }
            },
            clearAll: {
                checkbox: {
                    issue_ids: [],
                    numSelectedSprints: 0,
                    numSelectedCards: 0
                },
                option: {
                    numSelectedCards: 0
                }
            }
        }), [
        visibleCardIds,
        visibleCardListIds
    ]);
    return {
        selectAllVisible: selectAllVisible,
        clearAll: clearAll,
        clearAllVisible: clearAllVisible,
        extraAnalyticsAttributes: extraAnalyticsAttributes
    };
};

});


parcelRegister("gz0if", function(module, exports) {

$parcel$export(module.exports, "BulkOperationsSidebar", () => $5298899093cded53$export$82c880c0082507d0);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $9PAwV = parcelRequire("9PAwV");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $a2e2Q = parcelRequire("a2e2Q");

var $lmBAt = parcelRequire("lmBAt");

var $64dTY = parcelRequire("64dTY");
const $5298899093cded53$export$82c880c0082507d0 = ({ parentWidth: parentWidth, isOpen: isOpen, bulkOperationsForm: bulkOperationsForm })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { isSoftwareFullTheming: isSoftwareFullTheming } = (0, $lmBAt.getIsSoftwareThemingM2Enabled)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $a2e2Q.useSoftwareProjectTheming)() : {
        isSoftwareFullTheming: false
    };
    const fireResizeAnalytics = (0, $5uXOq.useCallback)((ratio)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'resized',
            actionSubject: 'bulkMenu'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'bulkEdit', {
            width: ratio
        });
    }, [
        createAnalyticsEvent
    ]);
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9PAwV.JiraDetailPanel), null, (setDetailPanelWidth)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $64dTY.Resizer), {
            parentWidth: parentWidth,
            onResize: setDetailPanelWidth,
            onResizeEnd: fireResizeAnalytics
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: [
                $5298899093cded53$var$sidebarContainerStyle,
                isSoftwareFullTheming && $5298899093cded53$var$themedContainerStyles
            ],
            ref: bulkOperationsForm.setRef,
            testId: "software-backlog.bulk-operations-sidebar.bulkops-sidebar"
        })));
};
const $5298899093cded53$var$sidebarContainerStyle = (0, $8CUq3.xcss)({
    width: `calc(100% - ${"var(--ds-space-100, 8px)"})`,
    height: '100%'
});
const $5298899093cded53$var$themedContainerStyles = (0, $8CUq3.xcss)({
    borderRadius: 'border.radius.100',
    backgroundColor: 'elevation.surface.raised',
    boxShadow: 'elevation.shadow.overlay'
});

});

parcelRegister("ab9TP", function(module, exports) {

$parcel$export(module.exports, "default", () => $36708e32bf5e8e7c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $91LZJ = parcelRequire("91LZJ");

var $9pe79 = parcelRequire("9pe79");

var $dCm1o = parcelRequire("dCm1o");

var $guzeq = parcelRequire("guzeq");

var $fvfVu = parcelRequire("fvfVu");

var $cir2B = parcelRequire("cir2B");

var $f5uwQ = parcelRequire("f5uwQ");

var $a7yHf = parcelRequire("a7yHf");

var $jkFPs = parcelRequire("jkFPs");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $9Pc1U = parcelRequire("9Pc1U");

var $lDDqj = parcelRequire("lDDqj");

var $1z1J7 = parcelRequire("1z1J7");

var $k35me = parcelRequire("k35me");

var $gTtxS = parcelRequire("gTtxS");

var $ixOVD = parcelRequire("ixOVD");
const $36708e32bf5e8e7c$var$CardListContainer = ({ id: id, isFirstList: isFirstList, isFirstNonEmptyList: isFirstNonEmptyList, isLastNonEmptyList: isLastNonEmptyList, justCreated: justCreated })=>{
    const canEditIssue = (0, $c1MAf.useBacklogSelector)((0, $1z1J7.canEditIssue));
    const isBacklogEmpty = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.getFlattenOrderedCardIds)(state).length === 0);
    const isActiveSprint = (0, $c1MAf.useBacklogSelector)((0, $k35me.makeIsCardListActiveSprint));
    const isIccEnabled = (0, $c1MAf.useBacklogSelector)((state)=>(0, $9Pc1U.isInlineIssueCreateAvailableForCurrentUser)(state) && ((0, $jG5HW.getIsCompanyManaged)(state) || (0, $dGljH.hasCardTypesSelector)(state)) && // ICC is disabled for CMP kanban board card list or active sprint
        !((0, $jG5HW.getIsCompanyManaged)(state) && (id === (0, $guzeq.BOARD) || isActiveSprint(id))));
    const isBulkOpsInProgress = (0, $91LZJ.useIsBulkOperationsInProgress)();
    const isDisabled = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.makeIsCardListDisabled)(state)(id)) || isBulkOpsInProgress;
    const isSprintMenuVisible = (0, $c1MAf.useBacklogSelector)((state)=>(0, $k35me.makeIsSprintMenuVisible)(state)(id));
    const isCreateSprintButtonDisabled = (0, $c1MAf.useBacklogSelector)((0, $dGljH.isAnyOptimisticCardList));
    const isCreateSprintButtonVisible = (0, $c1MAf.useBacklogSelector)((state)=>(0, $k35me.makeIsCreateSprintVisible)(state)(id));
    const isStartSprintButtonVisible = (0, $c1MAf.useBacklogSelector)((state)=>(0, $k35me.makeIsStartSprintVisible)(state)(id, isFirstList));
    const canEditSprint = (0, $c1MAf.useBacklogSelector)((state)=>(0, $k35me.makeCanEditSprint)(state)(id));
    const canManageSprints = (0, $c1MAf.useBacklogSelector)((state)=>(0, $1z1J7.canManageSprints)(state));
    const isStartSprintEnabled = (0, $c1MAf.useBacklogSelector)((state)=>(0, $k35me.makeIsStartSprintEnabled)(state)(id, isFirstList));
    const isCompleteSprintButtonVisible = (0, $c1MAf.useBacklogSelector)((state)=>(0, $k35me.makeIsCompleteSprintVisible)(state)(id));
    const isCompleteSprintButtonDisabled = (0, $c1MAf.useBacklogSelector)((state)=>!(0, $k35me.makeCanEditSprint)(state)(id));
    const cardIds = (0, $c1MAf.useBacklogSelector)((state)=>false ? (0, $dGljH.getOrderedCardIdsByCardListIdWithLimit)(state)[id] : (0, $dGljH.getOrderedCardIdsByCardListId)(state)[id]);
    const isAddSprintDatesButtonVisible = (0, $c1MAf.useBacklogSelector)((state)=>(0, $k35me.makeIsAddSprintDatesButtonVisible)(state, {
            cardListId: id
        }));
    const isCollapsed = (0, $c1MAf.useBacklogSelector)((state)=>false ? (0, $dGljH.makeIsCardListCollapsed)(state)(id) || !(0, $dGljH.getOrderedCardIdsByCardListIdWithLimit)(state)[id].length && !!(0, $dGljH.getOrderedCardIdsByCardListId)(state)[id].length : (0, $dGljH.makeIsCardListCollapsed)(state)(id));
    const isWorkloadByAssigneeEnabled = (0, $c1MAf.useBacklogSelector)((0, $k35me.isBacklogWithSprints));
    const isDraggingSubtask = (0, $c1MAf.useBacklogSelector)((0, $lDDqj.getIsSubtaskDrag));
    const isCmpKanbanBacklog = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.isCmpKanbanProject));
    const allCardIds = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.getOrderedCardIdsByCardListId)(state)[id]);
    const cardListName = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.getCardLists)(state)[id].name);
    const cardListType = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.getCardLists)(state)[id].type);
    const typeForAnalytics = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.makeGetCardListAnalyticsTypeById)(state)(id));
    const cardListSprintData = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.getCardLists)(state)[id].sprintData, (0, $9pe79.default));
    const isDragging = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getIsDragging));
    const isCurrentCardListDragSource = (0, $c1MAf.useBacklogSelector)((state)=>isDragging ? (0, $dGljH.getIsCardListDragInProgress)(state, id) : false);
    const cardMoveDisabled = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.isCardMoveDisabled));
    const minColumnLimit = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.makeGetMinColumnLimit)(state)(id));
    const maxColumnLimit = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.makeGetMaxColumnLimit)(state)(id));
    const isMinLimitReached = !!minColumnLimit && minColumnLimit > allCardIds.length;
    const isMaxLimitReached = !!maxColumnLimit && maxColumnLimit < allCardIds.length;
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const onToggle = (0, $5uXOq.useCallback)(()=>{
        (0, $cir2B.setCardListToggleStart)();
        dispatch((0, $a7yHf.cardListToggle)(id));
        (0, $cir2B.scheduleCardListToggleFinish)();
    }, [
        dispatch,
        id
    ]);
    const onCreateSprint = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        dispatch((0, $jkFPs.sprintCreateRequest)(analyticsEvent));
    }, [
        dispatch
    ]);
    const showTransitionZone = (0, $gTtxS.shouldShowTransitionZone)(isDragging, isCurrentCardListDragSource, cardMoveDisabled, isDraggingSubtask, isCmpKanbanBacklog);
    const getCardOrderExcludingSubtasks = (0, $c1MAf.useBacklogSelector)((state)=>false ? (0, $dGljH.makeOrderedVisibleCardsExcludingSubtasksForCardListWithLimit)(state) : (0, $dGljH.makeOrderedVisibleCardsExcludingSubtasksForCardList)(state));
    const getTotalCardCountExcludingSubtasks = (0, $c1MAf.useBacklogSelector)((state)=>false ? (0, $dGljH.makeOrderedCardIdsByCardListIdWithLimitExcludingSubtasks)(state) : (0, $dGljH.makeOrderedCardIdsByCardListIdExcludingSubtasks)(state));
    const sprintLifecycleContextValue = (0, $5uXOq.useMemo)(()=>{
        return {
            canEditSprint: canEditSprint,
            canManageSprints: canManageSprints,
            isAddSprintDatesButtonVisible: isAddSprintDatesButtonVisible,
            isCompleteSprintButtonVisible: isCompleteSprintButtonVisible,
            isCompleteSprintButtonDisabled: isCompleteSprintButtonDisabled,
            isCreateSprintButtonDisabled: isCreateSprintButtonDisabled,
            isSprintMenuVisible: isSprintMenuVisible,
            isStartSprintButtonVisible: isStartSprintButtonVisible,
            isStartSprintEnabled: isStartSprintEnabled
        };
    }, [
        canEditSprint,
        canManageSprints,
        isAddSprintDatesButtonVisible,
        isCompleteSprintButtonVisible,
        isCompleteSprintButtonDisabled,
        isCreateSprintButtonDisabled,
        isSprintMenuVisible,
        isStartSprintButtonVisible,
        isStartSprintEnabled
    ]);
    const cardListContextValue = (0, $5uXOq.useMemo)(()=>{
        return {
            cardCountExcludingSubtasks: getTotalCardCountExcludingSubtasks(id).length,
            cardIds: cardIds,
            cardListId: id,
            isCollapsed: isCollapsed,
            isFirstList: isFirstList,
            isMaxLimitReached: isMaxLimitReached,
            isMinLimitReached: isMinLimitReached,
            maxColumnLimit: maxColumnLimit ?? undefined,
            minColumnLimit: minColumnLimit ?? undefined,
            listName: cardListName,
            sprintData: cardListSprintData,
            type: cardListType,
            visibleCardAmount: getCardOrderExcludingSubtasks(id).length,
            isDisabled: isDisabled
        };
    }, [
        cardIds,
        cardListName,
        cardListSprintData,
        cardListType,
        getCardOrderExcludingSubtasks,
        getTotalCardCountExcludingSubtasks,
        id,
        isCollapsed,
        isFirstList,
        isMaxLimitReached,
        isMinLimitReached,
        maxColumnLimit,
        minColumnLimit,
        isDisabled
    ]);
    // Clean up when visual refresh is removed
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ixOVD.default), {
        cardListId: id,
        type: cardListType,
        typeForAnalytics: typeForAnalytics,
        name: cardListName,
        sprintData: cardListSprintData,
        canEditIssue: canEditIssue,
        canEditSprint: canEditSprint,
        canManageSprints: canManageSprints,
        isBacklogEmpty: isBacklogEmpty,
        isFirstList: isFirstList,
        isFirstNonEmptyList: isFirstNonEmptyList,
        isLastNonEmptyList: isLastNonEmptyList,
        justCreated: justCreated,
        isIccEnabled: isIccEnabled,
        isDisabled: isDisabled,
        isCollapsed: isCollapsed,
        isActiveSprint: isActiveSprint(id),
        isSprintMenuVisible: isSprintMenuVisible,
        isCreateSprintButtonDisabled: isCreateSprintButtonDisabled,
        isCreateSprintButtonVisible: isCreateSprintButtonVisible,
        isStartSprintButtonVisible: isStartSprintButtonVisible,
        isCompleteSprintButtonVisible: isCompleteSprintButtonVisible,
        isCompleteSprintButtonDisabled: isCompleteSprintButtonDisabled,
        isAddSprintDatesButtonVisible: isAddSprintDatesButtonVisible,
        cardIds: cardIds,
        allCardIds: allCardIds,
        cardCountExcludingSubtasks: getTotalCardCountExcludingSubtasks(id).length,
        visibleCardAmount: getCardOrderExcludingSubtasks(id).length,
        onToggle: onToggle,
        onCreateSprint: onCreateSprint,
        isStartSprintEnabled: isStartSprintEnabled,
        showTransitionZone: showTransitionZone,
        minColumnLimit: minColumnLimit,
        maxColumnLimit: maxColumnLimit,
        isWorkloadByAssigneeEnabled: isWorkloadByAssigneeEnabled
    });
    if ((0, $dCm1o.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5uwQ.SprintLifecycleContext).Provider, {
        value: sprintLifecycleContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fvfVu.CardListContext).Provider, {
        value: cardListContextValue
    }, content));
    return content;
};
var $36708e32bf5e8e7c$export$2e2bcd8739ae039 = $36708e32bf5e8e7c$var$CardListContainer;

});
parcelRegister("fvfVu", function(module, exports) {

$parcel$export(module.exports, "CardListContext", () => $a186fb45d15514e5$export$7ef917cfa7129eee);
$parcel$export(module.exports, "useCardListContext", () => $a186fb45d15514e5$export$f126ab8a47b4f36c);

var $5uXOq = parcelRequire("5uXOq");
const $a186fb45d15514e5$export$7ef917cfa7129eee = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $a186fb45d15514e5$export$f126ab8a47b4f36c = ()=>{
    const context = (0, $5uXOq.useContext)($a186fb45d15514e5$export$7ef917cfa7129eee);
    if (!context) throw new Error('useCardListContext must be used within a CardListContextProvider');
    return context;
};

});

parcelRegister("cir2B", function(module, exports) {

$parcel$export(module.exports, "setCardListToggleStart", () => $a44b451933bb6186$export$d309e05c8f7a64b2);
$parcel$export(module.exports, "scheduleCardListToggleFinish", () => $a44b451933bb6186$export$de99a97dc0f8d91f);

var $eTXmK = parcelRequire("eTXmK");

var $k12ix = parcelRequire("k12ix");

var $4G04L = parcelRequire("4G04L");

var $8hVbJ = parcelRequire("8hVbJ");
const $a44b451933bb6186$export$d309e05c8f7a64b2 = ()=>{
    (0, $eTXmK.default)('backlog-card-list-toggle');
    (0, $8hVbJ.cardListToggleInteraction).start();
};
const $a44b451933bb6186$export$3f196abd7d0c8243 = ()=>{
    (0, $8hVbJ.cardListToggleInteraction).stop({
        customData: {
            ...(0, $k12ix.getNormalisedPerformanceFFs)()
        }
    });
};
const $a44b451933bb6186$export$de99a97dc0f8d91f = ()=>{
    (0, $4G04L.scheduleAfterRender)(()=>{
        $a44b451933bb6186$export$3f196abd7d0c8243();
    });
};

});

parcelRegister("f5uwQ", function(module, exports) {

$parcel$export(module.exports, "SprintLifecycleContext", () => $7edb3e135b52e8ec$export$36f89e977dd8a424);
$parcel$export(module.exports, "useSprintLifecycleContext", () => $7edb3e135b52e8ec$export$5c8c6417162dd990);

var $5uXOq = parcelRequire("5uXOq");
const $7edb3e135b52e8ec$export$36f89e977dd8a424 = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $7edb3e135b52e8ec$export$5c8c6417162dd990 = ()=>{
    const context = (0, $5uXOq.useContext)($7edb3e135b52e8ec$export$36f89e977dd8a424);
    if (!context) throw new Error('useSprintLifecycleContext must be used within a SprintLifecycleContext.Provider');
    return context;
};

});

parcelRegister("gTtxS", function(module, exports) {

$parcel$export(module.exports, "darkerButtonTheme", () => $18d2e600ad4c6d51$export$39794a566394c250);
$parcel$export(module.exports, "shouldShowTransitionZone", () => $18d2e600ad4c6d51$export$d2114dbf8a186566);
$parcel$export(module.exports, "getSprintState", () => $18d2e600ad4c6d51$export$9cbf48c04feaac07);

var $guzeq = parcelRequire("guzeq");
const $18d2e600ad4c6d51$export$9e32cd4b2f78e398 = (buttonThemeOverrides)=>(currentTheme, themeProps)=>{
        const { buttonStyles: buttonStyles, ...rest } = currentTheme(themeProps);
        const { appearance: appearance, state: state, mode: mode } = themeProps;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type '"" | Appearance' can't be used to index type 'ButtonTheme'.
        const customThemeAppearance = buttonThemeOverrides[`${appearance || ''}`];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let customStyles = {};
        if (customThemeAppearance) // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Record<string, any>'.
        customStyles = Object.keys(customThemeAppearance).reduce((acc, key)=>{
            const value = customThemeAppearance[key];
            if (value[state]) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'ThemeTokens'.
            acc[key] = value[state][mode];
            return acc;
        }, // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'CSSObject'. | TS2322 - Type 'null' is not assignable to type 'CSSObject'.
        {
            buttonStyles: null,
            spinnerStyles: null
        });
        return {
            ...rest,
            buttonStyles: {
                ...buttonStyles,
                ...customStyles
            }
        };
    };
const $18d2e600ad4c6d51$var$darkerButtonThemeOverrides = {
    default: {
        background: {
            default: {
                light: "var(--ds-background-neutral, #091E420F)"
            },
            hover: {
                light: "var(--ds-background-neutral-hovered, #091E4224)"
            }
        }
    }
};
const $18d2e600ad4c6d51$export$39794a566394c250 = $18d2e600ad4c6d51$export$9e32cd4b2f78e398($18d2e600ad4c6d51$var$darkerButtonThemeOverrides);
const $18d2e600ad4c6d51$export$64a0edfb15b72dba = (sourceCardList, destinationCardList, sourceCardIndex, destinationCardIndex, destinationCardListCardOrder, selectedCards)=>{
    const isBottomOfOtherList = sourceCardList !== destinationCardList && destinationCardIndex === destinationCardListCardOrder.length;
    if (isBottomOfOtherList) return true;
    const isMovedFromAbove = sourceCardIndex < destinationCardIndex;
    // Is true when the destinationCardIndex is the last index in the list OR
    // ever card below this index is a selected card
    const isBottomOfSameList = sourceCardList === destinationCardList && (destinationCardIndex === destinationCardListCardOrder.length - 1 || destinationCardListCardOrder.slice(destinationCardIndex + (isMovedFromAbove ? 1 : 0)).every((cardId)=>selectedCards.includes(cardId)));
    return isBottomOfSameList;
};
const $18d2e600ad4c6d51$export$f9cab8a22421fe72 = (cardGroup, sourceCardIndex, destinationCardIndex, destinationCardListCardOrder, selectedCards)=>{
    const currentCardAtDestinationIndex = destinationCardListCardOrder[destinationCardIndex];
    const isDestinationBottomOfCardGroup = currentCardAtDestinationIndex === cardGroup.cardIds[cardGroup.cardIds.length - 1];
    if (isDestinationBottomOfCardGroup) return true;
    const isMovedFromAbove = sourceCardIndex < destinationCardIndex;
    const destinationCardIndexWithinCardGroup = cardGroup.cardIds.findIndex((id)=>id === currentCardAtDestinationIndex);
    // Is considered bottom of card group when every
    // card beneath destinationCardIndex is selected
    return cardGroup.cardIds.slice(destinationCardIndexWithinCardGroup + (isMovedFromAbove ? 1 : 0)).every((cardId)=>selectedCards.includes(cardId));
};
const $18d2e600ad4c6d51$export$53e40513eb32c9ca = (sourceCardList, destinationCardList, sourceCardIndex, destinationCardIndex, destinationCardListCardOrder, selectedCards)=>{
    let cardIndex = destinationCardIndex;
    const correction = sourceCardList === destinationCardList && sourceCardIndex < destinationCardIndex ? 1 : 0;
    cardIndex = destinationCardListCardOrder.findIndex((cardId, index)=>index < cardIndex + correction ? false : !selectedCards.includes(cardId));
    return destinationCardListCardOrder[cardIndex];
};
const $18d2e600ad4c6d51$export$d2114dbf8a186566 = (isDragging, isCurrentCardListDragSource, cardMoveDisabled, isDraggingSubtask, isCmpKanbanBacklog)=>isDragging && !isCurrentCardListDragSource && (cardMoveDisabled && (!isDraggingSubtask || isCmpKanbanBacklog) || isDraggingSubtask && isCmpKanbanBacklog);
const $18d2e600ad4c6d51$export$9cbf48c04feaac07 = (state)=>{
    if (!state) return undefined;
    switch(state){
        case 0, $guzeq.SPRINT_STATE_FUTURE:
            return 'future';
        case 0, $guzeq.SPRINT_STATE_ACTIVE:
            return 'active';
        default:
            return 'future';
    }
};

});

parcelRegister("ixOVD", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc0013909ff1f6e1$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $8Rkzz = parcelRequire("8Rkzz");

var $fW62l = parcelRequire("fW62l");

var $9dZ1c = parcelRequire("9dZ1c");

var $daJ0i = parcelRequire("daJ0i");

var $eCeGD = parcelRequire("eCeGD");

var $l1N8i = parcelRequire("l1N8i");

var $6Ingq = parcelRequire("6Ingq");

var $ebd3R = parcelRequire("ebd3R");

var $hORKG = parcelRequire("hORKG");

var $3dGN0 = parcelRequire("3dGN0");

var $jhVLw = parcelRequire("jhVLw");

var $3u0c5 = parcelRequire("3u0c5");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $dqoiX = parcelRequire("dqoiX");

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $8Bc5A = parcelRequire("8Bc5A");

var $cE2Qr = parcelRequire("cE2Qr");

var $jDrwg = parcelRequire("jDrwg");

var $8zOmE = parcelRequire("8zOmE");


var $3t5QD = parcelRequire("3t5QD");

var $hZ46s = parcelRequire("hZ46s");

var $emeAH = parcelRequire("emeAH");

var $013U5 = parcelRequire("013U5");

var $4lQkG = parcelRequire("4lQkG");

var $ayaAN = parcelRequire("ayaAN");

var $dCm1o = parcelRequire("dCm1o");

var $jOXuX = parcelRequire("jOXuX");

var $lmBAt = parcelRequire("lmBAt");

var $a2e2Q = parcelRequire("a2e2Q");

var $2lpqS = parcelRequire("2lpqS");

var $guzeq = parcelRequire("guzeq");

var $ee1tL = parcelRequire("ee1tL");

var $9tZuw = parcelRequire("9tZuw");

var $c1MAf = parcelRequire("c1MAf");

var $fSgHa = parcelRequire("fSgHa");

var $fLVJv = parcelRequire("fLVJv");

var $7ekti = parcelRequire("7ekti");

var $kARaY = parcelRequire("kARaY");

var $b7YUC = parcelRequire("b7YUC");

var $aJ0IJ = parcelRequire("aJ0IJ");

var $kaE44 = parcelRequire("kaE44");

var $hTJrU = parcelRequire("hTJrU");

var $elctU = parcelRequire("elctU");

var $bs6dR = parcelRequire("bs6dR");


var $3pyss = parcelRequire("3pyss");

var $2dBGm = parcelRequire("2dBGm");

var $l4p68 = parcelRequire("l4p68");

var $9u5My = parcelRequire("9u5My");

var $5iS2L = parcelRequire("5iS2L");

var $3JQPC = parcelRequire("3JQPC");

var $1hEu3 = parcelRequire("1hEu3");

var $ldRVl = parcelRequire("ldRVl");

var $6bzbn = parcelRequire("6bzbn");

var $hkjgs = parcelRequire("hkjgs");

var $cOAVR = parcelRequire("cOAVR");

var $iiJr8 = parcelRequire("iiJr8");

var $gcvrq = parcelRequire("gcvrq");

var $gTtxS = parcelRequire("gTtxS");

var $c4Chf = parcelRequire("c4Chf");

var $fiE4O = parcelRequire("fiE4O");

var $heLGs = parcelRequire("heLGs");
const $cc0013909ff1f6e1$var$BacklogAccordionNudgeAsyncWithFullWidth = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$FullWidthWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZ46s.BacklogAccordionNudgeAsync), null, children));
const $cc0013909ff1f6e1$var$EmptyList = ({ cardCount: cardCount, type: type, isActiveSprint: isActiveSprint, isFirstList: isFirstList })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (cardCount) return formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $6bzbn.default).emptyListFilteredIssueTermRefresh : (0, $6bzbn.default).emptyListFiltered);
    switch(type){
        case 0, $guzeq.BOARD:
            return formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $6bzbn.default).emptyBoardIssueTermRefresh : (0, $6bzbn.default).emptyBoard);
        case 0, $guzeq.BACKLOG:
            return formatMessage((0, $6bzbn.default).emptyBacklog);
        case 0, $guzeq.SPRINT:
            if (isActiveSprint) return formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $6bzbn.default).emptyStartedSprintIssueTermRefresh : (0, $6bzbn.default).emptyStartedSprint);
            if (isFirstList) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9u5My.default), null);
            return formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $6bzbn.default).emptyNotStartedSprintIssueTermRefresh : (0, $6bzbn.default).emptyNotStartedSprint);
        default:
            return '';
    }
};
const $cc0013909ff1f6e1$var$Icon = ({ isCollapsed: isCollapsed })=>isCollapsed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3dGN0))), {
        label: "expand",
        color: "var(--ds-icon, #44546F)",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($ebd3R))),
        LEGACY_primaryColor: "var(--ds-icon, #44546F)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hORKG))), {
        label: "collapse",
        color: "var(--ds-icon, #44546F)",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($6Ingq))),
        LEGACY_primaryColor: "var(--ds-icon, #44546F)"
    });
const $cc0013909ff1f6e1$var$ColumnLimits = ({ isFirstList: isFirstList, minColumnLimit: minColumnLimit, isMinLimitReached: isMinLimitReached, maxColumnLimit: maxColumnLimit, isMaxLimitReached: isMaxLimitReached })=>isFirstList && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, minColumnLimit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$ColumnLimit, {
        "data-testid": (0, $0226f08d081871ec$export$54c7326f7173c649)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
        appearance: isMinLimitReached ? 'moved' : 'default',
        isBold: isMinLimitReached
    }, `MIN ${minColumnLimit}`)) : null, maxColumnLimit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$ColumnLimit, {
        "data-testid": (0, $0226f08d081871ec$export$54c7326f7173c649)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
        appearance: isMaxLimitReached ? 'removed' : 'default',
        isBold: isMaxLimitReached
    }, `MAX ${maxColumnLimit}`)) : null);
const $cc0013909ff1f6e1$var$CreateSprint = ({ canManageSprints: canManageSprints, isCreateSprintButtonDisabled: isCreateSprintButtonDisabled, onCreateSprint: onCreateSprint })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [nudgeStep] = (0, $cE2Qr.useNudgeStep)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$RightSide, {
        "data-testid": "software-backlog.card-list.create-sprint-button-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3t5QD.ConditionalNudgeWrapper), {
        Wrapper: (0, $4lQkG.BacklogCreateSprintNudgeAsync),
        conditionsToApplyWrapper: nudgeStep === (0, $8Bc5A.BACKLOG_CREATE_SPRINT_NUDGE_ID) && !(0, $jOXuX.isTailoredOnboardingScrumAndSoftwareKanbanEnabled)()
    }, !canManageSprints ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $elctU.DisabledButtonHelper), null, formatMessage((0, $6bzbn.default).createSprint)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        onClick: onCreateSprint,
        isDisabled: isCreateSprintButtonDisabled,
        testId: "software-backlog.card-list.create-sprint-button",
        spacing: (0, $dCm1o.isVisualRefreshEnabled)() ? 'compact' : undefined
    }, formatMessage((0, $6bzbn.default).createSprint))));
};
const $cc0013909ff1f6e1$var$A11yScreenReaderInfo = ({ listName: listName, cardListId: cardListId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": `${(0, $2lpqS.HEADER_DROPPABLE_ID_PREFIX)}${cardListId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), {
        "aria-live": "assertive",
        id: `${(0, $2lpqS.HEADER_DROPPABLE_ID_PREFIX)}${cardListId}`
    }, formatMessage((0, $6bzbn.default).createdSprintAriaLive, {
        sprintName: listName
    })));
};
const $cc0013909ff1f6e1$var$CompleteSprintButtonWithNudge = ({ cardListId: cardListId, isCompleteSprintButtonDisabled: isCompleteSprintButtonDisabled })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [nudgeStep] = (0, $cE2Qr.useNudgeStep)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3t5QD.ConditionalNudgeWrapper), {
        Wrapper: (0, $emeAH.BacklogCompleteSprintNudgeAsync),
        conditionsToApplyWrapper: nudgeStep === (0, $dbbf68c32d8c4308$export$63b61f654ce3da3d) && !(0, $jOXuX.isTailoredOnboardingScrumAndSoftwareKanbanEnabled)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$CardListButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bs6dR.default), {
        theme: (0, $dCm1o.isVisualRefreshEnabled)() ? undefined : (0, $gTtxS.darkerButtonTheme),
        sprintId: cardListId,
        testId: "software-backlog.card-list.complete-sprint-button",
        isDisabled: isCompleteSprintButtonDisabled
    }, formatMessage((0, $6bzbn.default).completeSprint))));
};
const $cc0013909ff1f6e1$var$IccWithNudge = ({ aiPanelContainerRef: aiPanelContainerRef, isBacklogCardList: isBacklogCardList, cardListId: cardListId, isFirstList: isFirstList, isBacklogEmpty: isBacklogEmpty, iccAriaLabelledById: iccAriaLabelledById, setAiPanelSubject: setAiPanelSubject })=>{
    const [nudgeStep] = (0, $cE2Qr.useNudgeStep)();
    const isFocusMovedToAiPanel = ()=>{
        if (typeof document !== 'undefined') {
            const activeElement = document.activeElement;
            return !!aiPanelContainerRef.current?.contains(activeElement);
        }
        return false;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3t5QD.ConditionalNudgeWrapper), {
        Wrapper: (0, $013U5.BacklogCreateIssueNudgeAsync),
        conditionsToApplyWrapper: !!nudgeStep && isBacklogCardList && !(0, $jOXuX.isTailoredOnboardingScrumAndSoftwareKanbanEnabled)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1hEu3.default), {
        listId: cardListId,
        isOpenByDefault: isFirstList && isBacklogEmpty,
        ariaLabelledBy: iccAriaLabelledById,
        onSetAiWorkCreatePanelSubject: setAiPanelSubject,
        isFocusMovedToAiPanel: isFocusMovedToAiPanel,
        ...(0, $jOXuX.isTailoredOnboardingScrumAndSoftwareKanbanEnabled)() ? {
            isFirstList: isFirstList,
            isBacklogCardList: isBacklogCardList
        } : {}
    }));
};
const $cc0013909ff1f6e1$var$StartSprintButtonWithNudge = ({ totalCards: totalCards, isFirstList: isFirstList, isStartSprintEnabled: isStartSprintEnabled, cardListId: cardListId, canEditSprint: canEditSprint })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isEmpty = totalCards === 0;
    const shouldShowPrimaryButton = !isEmpty && isFirstList;
    const isStartSprintButtonDisabled = !isStartSprintEnabled || isEmpty;
    const { ref: startSprintButtonNudgeRef } = (0, $9dZ1c.useRegisterNudgeTarget)((0, $jOXuX.isTailoredOnboardingScrumAndSoftwareKanbanEnabled)() ? (0, $dbbf68c32d8c4308$export$6770a2081a63fc15) : 'start-sprint-button', isFirstList);
    const [isOnboardingDismissed] = (0, $cE2Qr.useIsDismissed)();
    const possiblyNudgeWrappedButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3t5QD.ConditionalNudgeWrapper), {
        conditionsToApplyWrapper: isFirstList && // optimise and don't load the nudge if QS is dismissed since that's currently the only trigger
        ((0, $jOXuX.isTailoredOnboardingScrumAndSoftwareKanbanEnabled)() ? !isOnboardingDismissed : true),
        Wrapper: (0, $ayaAN.BacklogStartSprintNudgeAsync)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$CardListButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cOAVR.default // This test-id is being used for the Jira Software NextGen Sprint Lifecycle pollinator test
    ), {
        testId: "software-backlog.card-list.start-sprint-button",
        sprintId: cardListId,
        theme: !shouldShowPrimaryButton && !(0, $dCm1o.isVisualRefreshEnabled)() ? (0, $gTtxS.darkerButtonTheme) : null,
        appearance: shouldShowPrimaryButton ? 'primary' : 'default',
        isDisabled: isStartSprintButtonDisabled,
        shouldShowManageSprintHelper: !canEditSprint,
        ref: startSprintButtonNudgeRef
    }, formatMessage((0, $6bzbn.default).startSprint))));
    if (isStartSprintButtonDisabled && canEditSprint) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$DisabledStartSprintTooltip, null, totalCards === 0 ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $6bzbn.default).disabledStartSprintButtonEmptyIssueTermRefresh : (0, $6bzbn.default).disabledStartSprintButtonEmpty) : formatMessage((0, $6bzbn.default).disabledStartSprintButtonNoParallel))
    }, possiblyNudgeWrappedButton);
    return possiblyNudgeWrappedButton;
};
const $cc0013909ff1f6e1$var$SprintHeader = ({ totalCards: totalCards, isStartSprintEnabled: isStartSprintEnabled, cardListId: cardListId, isStartSprintButtonVisible: isStartSprintButtonVisible, canEditSprint: canEditSprint, isFirstList: isFirstList, isCompleteSprintButtonVisible: isCompleteSprintButtonVisible, isCompleteSprintButtonDisabled: isCompleteSprintButtonDisabled, isSprintMenuVisible: isSprintMenuVisible, type: type, name: name })=>{
    const isEmpty = totalCards === 0;
    const isStartSprintButtonDisabled = !isStartSprintEnabled || isEmpty;
    const isShowingRecommendations = !isStartSprintButtonDisabled;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$RightSide, {
        "data-testid": "software-backlog.card-list.estimations-and-actions-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2dBGm.default), {
        cardListId: cardListId,
        isShowingRecommendations: isShowingRecommendations
    }), (0, $dCm1o.isVisualRefreshEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        xcss: $cc0013909ff1f6e1$var$cardMenuActionsStyles
    }, isStartSprintButtonVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$StartSprintButtonWithNudge, {
        canEditSprint: canEditSprint,
        cardListId: cardListId,
        isFirstList: isFirstList,
        isStartSprintEnabled: isStartSprintEnabled,
        totalCards: totalCards
    }), isCompleteSprintButtonVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$CompleteSprintButtonWithNudge, {
        cardListId: cardListId,
        isCompleteSprintButtonDisabled: isCompleteSprintButtonDisabled
    }), isSprintMenuVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hkjgs.default), {
        cardListId: cardListId,
        cardListType: type,
        cardListName: name
    })), !(0, $dCm1o.isVisualRefreshEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$CardMenuActionsWrapper, null, isStartSprintButtonVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$StartSprintButtonWithNudge, {
        canEditSprint: canEditSprint,
        cardListId: cardListId,
        isFirstList: isFirstList,
        isStartSprintEnabled: isStartSprintEnabled,
        totalCards: totalCards
    }), isCompleteSprintButtonVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$CompleteSprintButtonWithNudge, {
        cardListId: cardListId,
        isCompleteSprintButtonDisabled: isCompleteSprintButtonDisabled
    }), isSprintMenuVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hkjgs.default), {
        cardListId: cardListId,
        cardListType: type,
        cardListName: name
    })));
};
const $cc0013909ff1f6e1$var$LeftSideContainer = ({ isCollapsed: isCollapsed, cardListId: cardListId, onToggle: onToggleProp, justCreated: justCreated, listName: listName, sprintData: sprintData, isAddSprintDatesButtonVisible: isAddSprintDatesButtonVisible, type: type, visibleCardAmount: visibleCardAmount, cardCountExcludingSubtasks: cardCountExcludingSubtasks, isFirstList: isFirstList, isMaxLimitReached: isMaxLimitReached, isMinLimitReached: isMinLimitReached, maxColumnLimit: maxColumnLimit, minColumnLimit: minColumnLimit, isDisabled: isDisabled = false })=>{
    const leftSideRef = (0, $5uXOq.useRef)(null);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    (0, $5uXOq.useEffect)(()=>{
        if (justCreated) leftSideRef?.current?.focus();
    }, [
        justCreated
    ]);
    const onToggle = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
        onToggleProp();
    }, [
        onToggleProp
    ]);
    const onHeaderKeyDown = (0, $5uXOq.useCallback)((event)=>{
        if (event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('enter') || event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('space')) {
            event.preventDefault();
            onToggleProp();
        }
    }, [
        onToggleProp
    ]);
    const formatDate = (0, $5iS2L.useFormatDate)();
    const stopPropogation = (e)=>e.stopPropagation();
    const numberOfVisibleCardsText = (0, $5uXOq.useMemo)(()=>{
        const totalCardAmountUntruncated = cardCountExcludingSubtasks;
        if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return totalCardAmountUntruncated !== visibleCardAmount ? formatMessage((0, $6bzbn.default).visibleCardAmountIssueTermRefresh, {
            totalCardAmount: totalCardAmountUntruncated,
            cardAmount: visibleCardAmount
        }) : formatMessage((0, $6bzbn.default).cardAmountIssueTermRefresh, {
            cardAmount: totalCardAmountUntruncated
        });
        return totalCardAmountUntruncated !== visibleCardAmount ? formatMessage((0, $6bzbn.default).visibleCardAmount, {
            totalCardAmount: totalCardAmountUntruncated,
            cardAmount: visibleCardAmount
        }) : formatMessage((0, $6bzbn.default).cardAmount, {
            cardAmount: totalCardAmountUntruncated
        });
    }, [
        cardCountExcludingSubtasks,
        formatMessage,
        visibleCardAmount
    ]);
    const containerId = `leftside-container-${cardListId}`;
    if ((0, $4R6GH.fg)('tanuki_enghealth_28041')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$LeftSide, {
        onClick: onToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhVLw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $cc0013909ff1f6e1$var$cardListHeadingWrapper.pseudo,
        testId: (0, $0226f08d081871ec$export$483ac6106791f695),
        role: "button",
        tabIndex: isDisabled && (0, $4R6GH.fg)('tanuki_a11y_q4') ? -1 : 0,
        "aria-controls": !isCollapsed ? `backlog-accordion-${cardListId}` : undefined,
        "aria-labelledby": containerId,
        onKeyDown: onHeaderKeyDown,
        "aria-expanded": !isCollapsed,
        ref: leftSideRef
    })), (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $cc0013909ff1f6e1$var$chevronIconStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$Icon, {
        isCollapsed: isCollapsed
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$Icon, {
        isCollapsed: isCollapsed
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        id: containerId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "baseline"
    }, (0, $6s1PB.expValEquals)('surface_origin_board_on_sprint_containers', 'cohort', 'test') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heLGs.CardListHeading), {
        listName: listName,
        boardName: sprintData?.originBoard?.boardName,
        rapidViewId: sprintData?.originBoard?.rapidViewId,
        isBacklog: type === (0, $guzeq.BACKLOG)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "div",
        size: "xsmall"
    }, listName), sprintData && !isAddSprintDatesButtonVisible && sprintData.startDate && sprintData.endDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$DatesWrapper, null, `${formatDate(sprintData.startDate)} \u{2013} ${formatDate(sprintData.endDate)}`), sprintData && isAddSprintDatesButtonVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$AddSprintDatesButtonWrapper, {
        onClick: stopPropogation,
        onKeyDown: stopPropogation,
        "data-testid": "software-backlog.card-list.add-sprint-date-button-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kARaY.default), {
        cardListId: Number(cardListId)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$VisibleCardsInCardListHeader, null, "(", numberOfVisibleCardsText, ")"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$ColumnLimits, {
        isFirstList: isFirstList,
        isMaxLimitReached: isMaxLimitReached,
        isMinLimitReached: isMinLimitReached,
        maxColumnLimit: maxColumnLimit,
        minColumnLimit: minColumnLimit
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": `${(0, $0226f08d081871ec$export$483ac6106791f695)}-${type}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), {
        "aria-live": "polite",
        role: "status"
    }, listName, " ", numberOfVisibleCardsText)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$LeftSide, {
        "data-testid": (0, $0226f08d081871ec$export$483ac6106791f695),
        role: "button",
        tabIndex: isDisabled && (0, $4R6GH.fg)('tanuki_a11y_q4') ? -1 : 0,
        "aria-controls": !isCollapsed ? `backlog-accordion-${cardListId}` : undefined,
        onClick: onToggle,
        onKeyDown: onHeaderKeyDown,
        "aria-expanded": !isCollapsed,
        ref: leftSideRef
    }, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $cc0013909ff1f6e1$var$chevronIconStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$Icon, {
        isCollapsed: isCollapsed
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$Icon, {
        isCollapsed: isCollapsed
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "baseline"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $6s1PB.expValEquals)('surface_origin_board_on_sprint_containers', 'cohort', 'test') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heLGs.CardListHeading), {
        listName: listName,
        boardName: sprintData?.originBoard?.boardName,
        rapidViewId: sprintData?.originBoard?.rapidViewId,
        isBacklog: type === (0, $guzeq.BACKLOG)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "div",
        size: "xsmall"
    }, listName), sprintData && !isAddSprintDatesButtonVisible && sprintData.startDate && sprintData.endDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$DatesWrapper, null, `${formatDate(sprintData.startDate)} \u{2013} ${formatDate(sprintData.endDate)}`), sprintData && isAddSprintDatesButtonVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$AddSprintDatesButtonWrapper, {
        onClick: stopPropogation,
        onKeyDown: stopPropogation,
        "data-testid": "software-backlog.card-list.add-sprint-date-button-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kARaY.default), {
        cardListId: Number(cardListId)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$VisibleCardsInCardListHeader, null, "(", numberOfVisibleCardsText, ")"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": `${(0, $0226f08d081871ec$export$483ac6106791f695)}-${type}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), {
        "aria-live": "polite",
        role: "status"
    }, listName, " ", numberOfVisibleCardsText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$ColumnLimits, {
        isFirstList: isFirstList,
        isMaxLimitReached: isMaxLimitReached,
        isMinLimitReached: isMinLimitReached,
        maxColumnLimit: maxColumnLimit,
        minColumnLimit: minColumnLimit
    }))));
};
const $cc0013909ff1f6e1$var$HeaderContainer = ({ isMinLimitReached: isMinLimitReached, isMaxLimitReached: isMaxLimitReached, listName: listName, cardListId: cardListId, isDisabled: isDisabled, type: type, cardCountExcludingSubtasks: cardCountExcludingSubtasks, isAddSprintDatesButtonVisible: isAddSprintDatesButtonVisible, isCollapsed: isCollapsed, isFirstList: isFirstList, justCreated: justCreated, maxColumnLimit: maxColumnLimit, minColumnLimit: minColumnLimit, onToggle: onToggle, sprintData: sprintData, visibleCardAmount: visibleCardAmount, canEditSprint: canEditSprint, isCompleteSprintButtonDisabled: isCompleteSprintButtonDisabled, isCompleteSprintButtonVisible: isCompleteSprintButtonVisible, name: name, isSprintMenuVisible: isSprintMenuVisible, isStartSprintButtonVisible: isStartSprintButtonVisible, isStartSprintEnabled: isStartSprintEnabled, totalCards: totalCards, whiteboardsTouchpoint: whiteboardsTouchpoint, isCreateSprintButtonVisible: isCreateSprintButtonVisible, canManageSprints: canManageSprints, isCreateSprintButtonDisabled: isCreateSprintButtonDisabled, onCreateSprint: onCreateSprintProp })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOnboardingDismissed] = (0, $cE2Qr.useIsDismissed)();
    const onCreateSprint = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'createSprint');
        onCreateSprintProp(analyticsEvent);
    }, [
        onCreateSprintProp
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$CardListHeaderContainer, {
        isMinLimitReached: isMinLimitReached,
        isMaxLimitReached: isMaxLimitReached,
        isVisualRefreshEnabled: (0, $dCm1o.isVisualRefreshEnabled)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTJrU.CardListCheckbox), {
        cardListId: cardListId,
        isDisabled: isDisabled,
        listName: `${type === (0, $guzeq.SPRINT) ? `${formatMessage((0, $6bzbn.default).sprintListNamePrefix)} ` : ''}${listName}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3t5QD.ConditionalNudgeWrapper), {
        Wrapper: $cc0013909ff1f6e1$var$BacklogAccordionNudgeAsyncWithFullWidth,
        conditionsToApplyWrapper: !isOnboardingDismissed && type === (0, $guzeq.BACKLOG)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$HeadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$LeftSideContainer, {
        cardCountExcludingSubtasks: cardCountExcludingSubtasks,
        cardListId: cardListId,
        isAddSprintDatesButtonVisible: isAddSprintDatesButtonVisible,
        isCollapsed: isCollapsed,
        isFirstList: isFirstList,
        isMaxLimitReached: isMaxLimitReached,
        isMinLimitReached: isMinLimitReached,
        justCreated: justCreated,
        listName: listName,
        maxColumnLimit: maxColumnLimit,
        minColumnLimit: minColumnLimit,
        onToggle: onToggle,
        sprintData: sprintData,
        type: type,
        visibleCardAmount: visibleCardAmount,
        isDisabled: (0, $4R6GH.fg)('tanuki_a11y_q4') ? isDisabled : undefined
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$SprintHeader, {
        canEditSprint: canEditSprint,
        cardListId: cardListId,
        isCompleteSprintButtonDisabled: isCompleteSprintButtonDisabled,
        isCompleteSprintButtonVisible: isCompleteSprintButtonVisible,
        isFirstList: isFirstList,
        isSprintMenuVisible: isSprintMenuVisible,
        isStartSprintButtonVisible: isStartSprintButtonVisible,
        isStartSprintEnabled: isStartSprintEnabled,
        name: name,
        totalCards: totalCards,
        type: type
    }), type === (0, $guzeq.BACKLOG) && (0, $4R6GH.fg)('sprint_planning_whiteboards_gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $cc0013909ff1f6e1$var$whiteboardsContainer
    }, whiteboardsTouchpoint), type === (0, $guzeq.BACKLOG) && (0, $4R6GH.fg)('grw_1037_expand_plan_in_whiteboards_gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fLVJv.WhiteboardsAllJiras), null), isCreateSprintButtonVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$CreateSprint, {
        canManageSprints: canManageSprints,
        isCreateSprintButtonDisabled: isCreateSprintButtonDisabled,
        onCreateSprint: onCreateSprint
    }));
};
function $cc0013909ff1f6e1$var$CardList({ cardListId: cardListId, type: type, typeForAnalytics: typeForAnalytics, name: name, sprintData: sprintData, isBacklogEmpty: isBacklogEmpty = false, isFirstList: isFirstList = false, isFirstNonEmptyList: isFirstNonEmptyList = false, isLastNonEmptyList: isLastNonEmptyList = false, isIccEnabled: isIccEnabled = false, isDisabled: isDisabled = false, isCollapsed: isCollapsed = false, isActiveSprint: isActiveSprint = false, isSprintMenuVisible: isSprintMenuVisible = false, isStartSprintEnabled: isStartSprintEnabled = false, isCreateSprintButtonDisabled: isCreateSprintButtonDisabled = false, isCreateSprintButtonVisible: isCreateSprintButtonVisible = false, isAddSprintDatesButtonVisible: isAddSprintDatesButtonVisible = false, isStartSprintButtonVisible: isStartSprintButtonVisible = false, isCompleteSprintButtonVisible: isCompleteSprintButtonVisible = false, isCompleteSprintButtonDisabled: isCompleteSprintButtonDisabled = false, canEditIssue: canEditIssue = false, canEditSprint: canEditSprint = false, canManageSprints: canManageSprints = false, visibleCardAmount: visibleCardAmount = 0, justCreated: justCreated = false, onToggle: onToggleProp = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onCreateSprint: onCreateSprintProp = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), cardIds: cardIds, allCardIds: allCardIds, cardCountExcludingSubtasks: cardCountExcludingSubtasks, minColumnLimit: minColumnLimit, maxColumnLimit: maxColumnLimit, showTransitionZone: showTransitionZone, isWorkloadByAssigneeEnabled: isWorkloadByAssigneeEnabled = false }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isCompanyManaged = (0, $fSgHa.useIsCMPBacklog)();
    const listRef = (0, $5uXOq.useRef)(null);
    const backlogContainerSize = (0, $3JQPC.useBacklogContainerSize)({
        ref: listRef
    });
    const leftSideRef = (0, $5uXOq.useRef)(null);
    const isBacklogCardList = type === (0, $guzeq.BACKLOG);
    const [nudgeStep] = (0, $cE2Qr.useNudgeStep)();
    const [isOnboardingDismissed] = (0, $cE2Qr.useIsDismissed)();
    const { isSoftwareFullTheming: isSoftwareFullTheming } = (0, $lmBAt.getIsSoftwareThemingM2Enabled)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $a2e2Q.useSoftwareProjectTheming)() : {
        isSoftwareFullTheming: false
    };
    (0, $5uXOq.useEffect)(()=>{
        if (justCreated) leftSideRef?.current?.focus();
    }, [
        justCreated
    ]);
    const formatDate = (0, $5iS2L.useFormatDate)();
    const { ref: startSprintButtonNudgeRef } = (0, $9dZ1c.useRegisterNudgeTarget)('start-sprint-button', isFirstList);
    const isMinLimitReached = !!minColumnLimit && minColumnLimit > allCardIds.length;
    const isMaxLimitReached = !!maxColumnLimit && maxColumnLimit < allCardIds.length;
    const onToggle = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
        onToggleProp();
    }, [
        onToggleProp
    ]);
    const renderRichCardDelay = 300;
    const setRichActiveCard = (0, $c1MAf.useBacklogActionCreator)((0, $9tZuw.setRichActiveCard));
    const [setRichActiveCardDebounced] = (0, $jDrwg.default)((cardID)=>{
        setRichActiveCard(cardID);
    }, renderRichCardDelay);
    const onHeaderKeyDown = (0, $5uXOq.useCallback)((event)=>{
        if (event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('enter') || event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('space')) {
            event.preventDefault();
            onToggleProp();
        }
    }, [
        onToggleProp
    ]);
    const onCreateSprint = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'createSprint');
        onCreateSprintProp(analyticsEvent);
    }, [
        onCreateSprintProp
    ]);
    const { whiteboardsTouchpoint: whiteboardsTouchpoint, whiteboardsBanner: whiteboardsBanner } = (0, $7ekti.useWhiteboardsTouchpoint)({
        skipExposure: type !== (0, $guzeq.BACKLOG),
        isCreateSprintButtonVisible: isCreateSprintButtonVisible
    });
    const listName = (0, $5uXOq.useMemo)(()=>{
        switch(type){
            case 0, $guzeq.BOARD:
                // Only use name if default name is different
                if (isCompanyManaged) return name;
                return formatMessage((0, $6bzbn.default).boardListName);
            case 0, $guzeq.BACKLOG:
                return formatMessage((0, $6bzbn.default).backlogListName);
            case 0, $guzeq.SPRINT:
                return name;
            default:
                return '';
        }
    }, [
        formatMessage,
        isCompanyManaged,
        name,
        type
    ]);
    const getEmptyList = (0, $5uXOq.useCallback)(()=>{
        if (cardIds.length) return formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $6bzbn.default).emptyListFilteredIssueTermRefresh : (0, $6bzbn.default).emptyListFiltered);
        switch(type){
            case 0, $guzeq.BOARD:
                return formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $6bzbn.default).emptyBoardIssueTermRefresh : (0, $6bzbn.default).emptyBoard);
            case 0, $guzeq.BACKLOG:
                return formatMessage((0, $6bzbn.default).emptyBacklog);
            case 0, $guzeq.SPRINT:
                if (isActiveSprint) return formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $6bzbn.default).emptyStartedSprintIssueTermRefresh : (0, $6bzbn.default).emptyStartedSprint);
                if (isFirstList) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9u5My.default), null);
                return formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $6bzbn.default).emptyNotStartedSprintIssueTermRefresh : (0, $6bzbn.default).emptyNotStartedSprint);
            default:
                return '';
        }
    }, [
        cardIds.length,
        formatMessage,
        isActiveSprint,
        isFirstList,
        type
    ]);
    const renderIcon = (0, $5uXOq.useCallback)(()=>isCollapsed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3dGN0))), {
            label: "expand",
            color: "var(--ds-icon, #44546F)",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($ebd3R))),
            LEGACY_primaryColor: "var(--ds-icon, #44546F)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hORKG))), {
            label: "collapse",
            color: "var(--ds-icon, #44546F)",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($6Ingq))),
            LEGACY_primaryColor: "var(--ds-icon, #44546F)"
        }), [
        isCollapsed
    ]);
    const renderNumberOfVisibleCardsText = (0, $5uXOq.useCallback)(()=>{
        const totalCardAmountUntruncated = cardCountExcludingSubtasks;
        const getText = ()=>{
            if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return totalCardAmountUntruncated !== visibleCardAmount ? formatMessage((0, $6bzbn.default).visibleCardAmountIssueTermRefresh, {
                totalCardAmount: totalCardAmountUntruncated,
                cardAmount: visibleCardAmount
            }) : formatMessage((0, $6bzbn.default).cardAmountIssueTermRefresh, {
                cardAmount: totalCardAmountUntruncated
            });
            return totalCardAmountUntruncated !== visibleCardAmount ? formatMessage((0, $6bzbn.default).visibleCardAmount, {
                totalCardAmount: totalCardAmountUntruncated,
                cardAmount: visibleCardAmount
            }) : formatMessage((0, $6bzbn.default).cardAmount, {
                cardAmount: totalCardAmountUntruncated
            });
        };
        return getText();
    }, [
        cardCountExcludingSubtasks,
        formatMessage,
        visibleCardAmount
    ]);
    const renderStartSprintButton = (0, $5uXOq.useCallback)(()=>{
        const totalCardAmount = cardIds.length;
        const isEmpty = totalCardAmount === 0;
        const shouldShowPrimaryButton = !isEmpty && isFirstList;
        const isStartSprintButtonDisabled = !isStartSprintEnabled || isEmpty;
        const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$CardListButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cOAVR.default // This test-id is being used for the Jira Software NextGen Sprint Lifecycle pollinator test
        ), {
            testId: "software-backlog.card-list.start-sprint-button",
            sprintId: cardListId,
            theme: !shouldShowPrimaryButton && !(0, $dCm1o.isVisualRefreshEnabled)() ? (0, $gTtxS.darkerButtonTheme) : null,
            appearance: shouldShowPrimaryButton ? 'primary' : 'default',
            isDisabled: isStartSprintButtonDisabled,
            shouldShowManageSprintHelper: !canEditSprint,
            ref: startSprintButtonNudgeRef
        }, formatMessage((0, $6bzbn.default).startSprint)));
        const possiblyNudgeWrappedButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3t5QD.ConditionalNudgeWrapper), {
            conditionsToApplyWrapper: isFirstList,
            Wrapper: (0, $ayaAN.BacklogStartSprintNudgeAsync)
        }, button);
        if (isStartSprintButtonDisabled && canEditSprint) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$DisabledStartSprintTooltip, null, totalCardAmount === 0 ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $6bzbn.default).disabledStartSprintButtonEmptyIssueTermRefresh : (0, $6bzbn.default).disabledStartSprintButtonEmpty) : formatMessage((0, $6bzbn.default).disabledStartSprintButtonNoParallel))
        }, possiblyNudgeWrappedButton);
        return possiblyNudgeWrappedButton;
    }, [
        canEditSprint,
        cardIds.length,
        cardListId,
        formatMessage,
        isFirstList,
        isStartSprintEnabled,
        startSprintButtonNudgeRef
    ]);
    const renderCompleteSprintButton = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3t5QD.ConditionalNudgeWrapper), {
            Wrapper: (0, $emeAH.BacklogCompleteSprintNudgeAsync),
            conditionsToApplyWrapper: nudgeStep === (0, $dbbf68c32d8c4308$export$63b61f654ce3da3d)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$CardListButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bs6dR.default), {
            theme: (0, $dCm1o.isVisualRefreshEnabled)() ? undefined : (0, $gTtxS.darkerButtonTheme),
            sprintId: cardListId,
            testId: "software-backlog.card-list.complete-sprint-button",
            ...isCompleteSprintButtonDisabled ? {
                isDisabled: true
            } : {}
        }, formatMessage((0, $6bzbn.default).completeSprint)))), [
        cardListId,
        formatMessage,
        isCompleteSprintButtonDisabled,
        nudgeStep
    ]);
    const renderSprintHeader = (0, $5uXOq.useCallback)(()=>{
        const totalCardAmount = cardIds.length;
        const isEmpty = totalCardAmount === 0;
        const isStartSprintButtonDisabled = !isStartSprintEnabled || isEmpty;
        const isShowingRecommendations = !isStartSprintButtonDisabled;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$RightSide, {
            "data-testid": "software-backlog.card-list.estimations-and-actions-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2dBGm.default), {
            cardListId: cardListId,
            isShowingRecommendations: isShowingRecommendations
        }), (0, $dCm1o.isVisualRefreshEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            alignItems: "center",
            xcss: $cc0013909ff1f6e1$var$cardMenuActionsStyles
        }, isStartSprintButtonVisible && renderStartSprintButton(), isCompleteSprintButtonVisible && renderCompleteSprintButton(), isSprintMenuVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hkjgs.default), {
            cardListId: cardListId,
            cardListType: type,
            cardListName: name
        })), !(0, $dCm1o.isVisualRefreshEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$CardMenuActionsWrapper, null, isStartSprintButtonVisible && renderStartSprintButton(), isCompleteSprintButtonVisible && renderCompleteSprintButton(), isSprintMenuVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hkjgs.default), {
            cardListId: cardListId,
            cardListType: type,
            cardListName: name
        })));
    }, [
        cardIds.length,
        cardListId,
        isCompleteSprintButtonVisible,
        isSprintMenuVisible,
        isStartSprintButtonVisible,
        isStartSprintEnabled,
        name,
        renderCompleteSprintButton,
        renderStartSprintButton,
        type
    ]);
    const renderCreateSprint = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$RightSide, {
            "data-test-id": "software-backlog.card-list.create-sprint-button-container",
            "data-testid": "software-backlog.card-list.create-sprint-button-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3t5QD.ConditionalNudgeWrapper), {
            Wrapper: (0, $4lQkG.BacklogCreateSprintNudgeAsync),
            conditionsToApplyWrapper: nudgeStep === (0, $8Bc5A.BACKLOG_CREATE_SPRINT_NUDGE_ID) && !(0, $jOXuX.isTailoredOnboardingScrumAndSoftwareKanbanEnabled)()
        }, !canManageSprints ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $elctU.DisabledButtonHelper), null, formatMessage((0, $6bzbn.default).createSprint)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            onClick: onCreateSprint,
            isDisabled: isCreateSprintButtonDisabled,
            testId: "software-backlog.card-list.create-sprint-button",
            spacing: (0, $dCm1o.isVisualRefreshEnabled)() ? 'compact' : undefined
        }, formatMessage((0, $6bzbn.default).createSprint)))), [
        canManageSprints,
        formatMessage,
        isCreateSprintButtonDisabled,
        nudgeStep,
        onCreateSprint
    ]);
    const renderAddSprintDatesButton = (0, $5uXOq.useCallback)(()=>{
        const stopPropogation = (e)=>e.stopPropagation();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$AddSprintDatesButtonWrapper, {
            onClick: stopPropogation,
            onKeyDown: stopPropogation,
            "data-test-id": "software-backlog.card-list.add-sprint-date-button-container",
            "data-testid": "software-backlog.card-list.add-sprint-date-button-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kARaY.default), {
            cardListId: Number(cardListId)
        }));
    }, [
        cardListId
    ]);
    const renderSprintData = (0, $5uXOq.useCallback)(()=>{
        if (!sprintData) return null;
        const { goal: goal } = sprintData;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, goal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$GoalWrapper, null, goal));
    }, [
        sprintData
    ]);
    const renderColumnLimits = (0, $5uXOq.useCallback)(()=>isFirstList && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, minColumnLimit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$ColumnLimit, {
            "data-testid": (0, $0226f08d081871ec$export$54c7326f7173c649)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
            appearance: isMinLimitReached ? 'moved' : 'default',
            isBold: isMinLimitReached
        }, `MIN ${minColumnLimit}`)) : null, maxColumnLimit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$ColumnLimit, {
            "data-testid": (0, $0226f08d081871ec$export$54c7326f7173c649)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
            appearance: isMaxLimitReached ? 'removed' : 'default',
            isBold: isMaxLimitReached
        }, `MAX ${maxColumnLimit}`)) : null), [
        isFirstList,
        isMaxLimitReached,
        isMinLimitReached,
        maxColumnLimit,
        minColumnLimit
    ]);
    const containerId = `leftside-container-${cardListId}`;
    const renderLeftSide = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$LeftSide, {
            onClick: onToggle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhVLw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $cc0013909ff1f6e1$var$cardListHeadingWrapper.pseudo,
            testId: (0, $0226f08d081871ec$export$483ac6106791f695),
            role: "button",
            tabIndex: isDisabled && (0, $4R6GH.fg)('tanuki_a11y_q4') ? -1 : 0,
            "aria-controls": !isCollapsed ? `backlog-accordion-${cardListId}` : undefined,
            "aria-labelledby": containerId,
            onKeyDown: onHeaderKeyDown,
            "aria-expanded": !isCollapsed,
            ref: leftSideRef
        })), (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $cc0013909ff1f6e1$var$chevronIconStyles
        }, renderIcon()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$IconContainer, null, renderIcon()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            id: containerId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            alignItems: "baseline"
        }, (0, $6s1PB.expValEquals)('surface_origin_board_on_sprint_containers', 'cohort', 'test') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heLGs.CardListHeading), {
            listName: listName,
            boardName: sprintData?.originBoard?.boardName,
            rapidViewId: sprintData?.originBoard?.rapidViewId,
            isBacklog: type === (0, $guzeq.BACKLOG)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$ListName, null, listName), sprintData && !isAddSprintDatesButtonVisible && sprintData.startDate && sprintData.endDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$DatesWrapper, null, `${formatDate(sprintData.startDate)} \u{2013} ${formatDate(sprintData.endDate)}`), sprintData && isAddSprintDatesButtonVisible && renderAddSprintDatesButton(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$VisibleCardsInCardListHeader, null, "(", renderNumberOfVisibleCardsText(), ")"), renderColumnLimits())), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
            "data-testid": `${(0, $0226f08d081871ec$export$483ac6106791f695)}-${type}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), {
            "aria-live": "polite",
            role: "status"
        }, listName, " ", renderNumberOfVisibleCardsText()))), [
        cardListId,
        formatDate,
        listName,
        isAddSprintDatesButtonVisible,
        isCollapsed,
        onHeaderKeyDown,
        onToggle,
        renderAddSprintDatesButton,
        renderColumnLimits,
        renderIcon,
        renderNumberOfVisibleCardsText,
        sprintData,
        type,
        isDisabled,
        containerId
    ]);
    const renderLeftSideOld = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$LeftSide, {
            "data-testid": (0, $0226f08d081871ec$export$483ac6106791f695),
            role: "button",
            tabIndex: isDisabled && (0, $4R6GH.fg)('tanuki_a11y_q4') ? -1 : 0,
            "aria-controls": !isCollapsed ? `backlog-accordion-${cardListId}` : undefined,
            onClick: onToggle,
            onKeyDown: onHeaderKeyDown,
            "aria-expanded": !isCollapsed,
            ref: leftSideRef
        }, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $cc0013909ff1f6e1$var$chevronIconStyles
        }, renderIcon()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$IconContainer, null, renderIcon()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            alignItems: "baseline"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $6s1PB.expValEquals)('surface_origin_board_on_sprint_containers', 'cohort', 'test') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heLGs.CardListHeading), {
            listName: listName,
            boardName: sprintData?.originBoard?.boardName,
            rapidViewId: sprintData?.originBoard?.rapidViewId,
            isBacklog: type === (0, $guzeq.BACKLOG)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$ListName, null, listName), sprintData && !isAddSprintDatesButtonVisible && sprintData.startDate && sprintData.endDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$DatesWrapper, null, `${formatDate(sprintData.startDate)} \u{2013} ${formatDate(sprintData.endDate)}`), sprintData && isAddSprintDatesButtonVisible && renderAddSprintDatesButton(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$VisibleCardsInCardListHeader, null, "(", renderNumberOfVisibleCardsText(), ")"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
            "data-testid": `${(0, $0226f08d081871ec$export$483ac6106791f695)}-${type}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), {
            "aria-live": "polite",
            role: "status"
        }, listName, " ", renderNumberOfVisibleCardsText())), renderColumnLimits()))), [
        cardListId,
        formatDate,
        listName,
        isAddSprintDatesButtonVisible,
        isCollapsed,
        onHeaderKeyDown,
        onToggle,
        renderAddSprintDatesButton,
        renderColumnLimits,
        renderIcon,
        renderNumberOfVisibleCardsText,
        sprintData,
        type,
        isDisabled
    ]);
    const renderHeader = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$CardListHeaderContainer, {
            isMinLimitReached: isMinLimitReached,
            isMaxLimitReached: isMaxLimitReached,
            isVisualRefreshEnabled: (0, $dCm1o.isVisualRefreshEnabled)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTJrU.CardListCheckbox), {
            cardListId: cardListId,
            isDisabled: isDisabled,
            listName: `${type === (0, $guzeq.SPRINT) ? `${formatMessage((0, $6bzbn.default).sprintListNamePrefix)} ` : ''}${listName}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3t5QD.ConditionalNudgeWrapper), {
            Wrapper: $cc0013909ff1f6e1$var$BacklogAccordionNudgeAsyncWithFullWidth,
            conditionsToApplyWrapper: !isOnboardingDismissed && type === (0, $guzeq.BACKLOG)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$HeadingWrapper, null, (0, $4R6GH.fg)('tanuki_enghealth_28041') ? renderLeftSide() : renderLeftSideOld())), renderSprintHeader(), type === (0, $guzeq.BACKLOG) && (0, $4R6GH.fg)('sprint_planning_whiteboards_gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $cc0013909ff1f6e1$var$whiteboardsContainer
        }, whiteboardsTouchpoint), type === (0, $guzeq.BACKLOG) && (0, $4R6GH.fg)('grw_1037_expand_plan_in_whiteboards_gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fLVJv.WhiteboardsAllJiras), null), isCreateSprintButtonVisible && renderCreateSprint()), [
        cardListId,
        formatMessage,
        listName,
        isCreateSprintButtonVisible,
        isDisabled,
        isMaxLimitReached,
        isMinLimitReached,
        isOnboardingDismissed,
        renderCreateSprint,
        renderLeftSide,
        renderLeftSideOld,
        renderSprintHeader,
        type,
        whiteboardsTouchpoint
    ]);
    const renderIccCard = (0, $5uXOq.useCallback)((cardEntry, row, isScrolling, shouldBeAbsolutePositioned)=>{
        if ((0, $ee1tL.isCardEntryGroup)(cardEntry)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aJ0IJ.CardGroup), {
            key: (0, $ee1tL.getCardEntryGroupKey)(cardEntry, cardListId),
            isScrolling: isScrolling,
            isVisible: row.isVisible,
            cardListId: cardListId,
            cardGroup: cardEntry,
            setRichActiveCard: setRichActiveCardDebounced,
            shouldBeAbsolutePositioned: shouldBeAbsolutePositioned
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b7YUC.default), {
            cardListId: cardListId,
            cardId: cardEntry.cardId,
            isVisible: row.isVisible,
            isScrolling: isScrolling,
            isAttachedToParent: false,
            setRichActiveCard: setRichActiveCardDebounced
        });
    }, [
        cardListId,
        setRichActiveCardDebounced
    ]);
    const renderA11yScreenReaderInfo = (0, $5uXOq.useCallback)(()=>justCreated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
            "data-testid": `${(0, $2lpqS.HEADER_DROPPABLE_ID_PREFIX)}${cardListId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), {
            "aria-live": "assertive",
            id: `${(0, $2lpqS.HEADER_DROPPABLE_ID_PREFIX)}${cardListId}`
        }, formatMessage((0, $6bzbn.default).createdSprintAriaLive, {
            sprintName: listName
        }))), [
        cardListId,
        formatMessage,
        listName,
        justCreated
    ]);
    const isHeaderDropDisabled = !isCollapsed || isDisabled;
    const isDividerHidden = !canEditIssue || type === (0, $guzeq.BACKLOG) || isActiveSprint || isCollapsed && type === (0, $guzeq.SPRINT);
    const headerRef = (0, $5uXOq.useRef)(null);
    const transitionZoneElementRef = (0, $5uXOq.useRef)(null);
    const { isDragOver: isDragOver, isDragOverTransitionZone: isDragOverTransitionZone } = (0, $gcvrq.useCardListDropTarget)({
        headerElementRef: headerRef,
        transitionZoneElementRef: transitionZoneElementRef,
        cardListId: cardListId,
        isHeaderDropDisabled: isHeaderDropDisabled
    }); // TODO: Inline this, no need for the useMemo here
    const header = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$CollapsedDropzoneWrapper, {
            ref: headerRef
        }, !isHeaderDropDisabled && isDragOver && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$CollapsedDropzone, null), !(0, $dCm1o.isVisualRefreshEnabled)() && ((0, $4R6GH.fg)('jsw-backlog-card-list-refactor') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$HeaderContainer, {
            canEditSprint: canEditSprint,
            canManageSprints: canManageSprints,
            cardCountExcludingSubtasks: cardCountExcludingSubtasks,
            cardListId: cardListId,
            isAddSprintDatesButtonVisible: isAddSprintDatesButtonVisible,
            isCollapsed: isCollapsed,
            isCompleteSprintButtonDisabled: isCompleteSprintButtonDisabled,
            isCompleteSprintButtonVisible: isCompleteSprintButtonVisible,
            isCreateSprintButtonDisabled: isCreateSprintButtonDisabled,
            isCreateSprintButtonVisible: isCreateSprintButtonVisible,
            isDisabled: isDisabled,
            isFirstList: isFirstList,
            isMaxLimitReached: isMaxLimitReached,
            isMinLimitReached: isMinLimitReached,
            isSprintMenuVisible: isSprintMenuVisible,
            isStartSprintButtonVisible: isStartSprintButtonVisible,
            isStartSprintEnabled: isStartSprintEnabled,
            justCreated: justCreated,
            listName: listName,
            maxColumnLimit: maxColumnLimit,
            minColumnLimit: minColumnLimit,
            name: name,
            onCreateSprint: onCreateSprintProp,
            onToggle: onToggleProp,
            sprintData: sprintData,
            totalCards: cardIds.length,
            type: type,
            visibleCardAmount: visibleCardAmount,
            whiteboardsTouchpoint: whiteboardsTouchpoint
        }) : renderHeader()), (0, $dCm1o.isVisualRefreshEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kaE44.CardListHeader), {
            isCreateSprintButtonVisible: isCreateSprintButtonVisible,
            isDisabled: isDisabled,
            isMaxLimitReached: isMaxLimitReached,
            isMinLimitReached: isMinLimitReached,
            onCreateSprint: onCreateSprintProp,
            onToggle: onToggleProp,
            whiteboardsTouchpoint: whiteboardsTouchpoint
        })), [
        isCreateSprintButtonVisible,
        isDisabled,
        isDragOver,
        isHeaderDropDisabled,
        isMaxLimitReached,
        isMinLimitReached,
        onCreateSprintProp,
        onToggleProp,
        renderHeader,
        whiteboardsTouchpoint,
        canEditSprint,
        canManageSprints,
        cardCountExcludingSubtasks,
        cardIds.length,
        cardListId,
        isAddSprintDatesButtonVisible,
        isCollapsed,
        isCompleteSprintButtonDisabled,
        isCompleteSprintButtonVisible,
        isCreateSprintButtonDisabled,
        isFirstList,
        isSprintMenuVisible,
        isStartSprintButtonVisible,
        isStartSprintEnabled,
        justCreated,
        listName,
        maxColumnLimit,
        minColumnLimit,
        name,
        sprintData,
        type,
        visibleCardAmount
    ]);
    const list = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3JQPC.ContainerSizeContext).Provider, {
            value: {
                size: backlogContainerSize
            }
        }, type === (0, $guzeq.BACKLOG) && whiteboardsBanner && (0, $4R6GH.fg)('sprint_planning_whiteboards_gate') ? whiteboardsBanner : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l4p68.default), {
            cardListId: cardListId,
            renderCard: renderIccCard,
            isDropDisabled: isDisabled || showTransitionZone,
            emptyList: getEmptyList()
        })), [
        backlogContainerSize,
        cardListId,
        getEmptyList,
        isDisabled,
        renderIccCard,
        showTransitionZone,
        type,
        whiteboardsBanner
    ]);
    const aiPanelContainerRef = (0, $5uXOq.useRef)(null);
    const [aiPanelSubject, setAiPanelSubject] = (0, $4R6GH.fg)('ai_powered_backlog_inline_create_gate') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useState)() : [
        undefined,
        (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    ];
    const iccAriaLabelledById = `icc-${name.replace(/\s/g, '-')}`.toLowerCase();
    const iccWithNudge = (0, $5uXOq.useCallback)(()=>{
        if (!isIccEnabled) return null;
        const isFocusMovedToAiPanel = ()=>{
            if (typeof document !== 'undefined') {
                const activeElement = document.activeElement;
                return !!aiPanelContainerRef.current?.contains(activeElement);
            }
            return false;
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3t5QD.ConditionalNudgeWrapper), {
            Wrapper: (0, $013U5.BacklogCreateIssueNudgeAsync),
            conditionsToApplyWrapper: !!nudgeStep && isBacklogCardList && !(0, $jOXuX.isTailoredOnboardingScrumAndSoftwareKanbanEnabled)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1hEu3.default), {
            listId: cardListId,
            isOpenByDefault: isFirstList && isBacklogEmpty,
            ariaLabelledBy: iccAriaLabelledById,
            onSetAiWorkCreatePanelSubject: setAiPanelSubject,
            isFocusMovedToAiPanel: isFocusMovedToAiPanel,
            ...(0, $jOXuX.isTailoredOnboardingScrumAndSoftwareKanbanEnabled)() ? {
                isFirstList: isFirstList,
                isBacklogCardList: isBacklogCardList
            } : {}
        }));
    }, [
        cardListId,
        iccAriaLabelledById,
        isBacklogCardList,
        isBacklogEmpty,
        isFirstList,
        isIccEnabled,
        nudgeStep,
        setAiPanelSubject
    ]);
    const workloadByAssignee = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c4Chf.default), {
            cardListId: cardListId,
            sprintName: name
        }), [
        cardListId,
        name
    ]);
    const showWorkloadByAssignee = !isBacklogCardList && isCompanyManaged && isWorkloadByAssigneeEnabled;
    const workloadByAssigneeGated = (0, $4R6GH.fg)('backlog_reduce_workload_card_avatar_rerenders_') ? workloadByAssignee : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c4Chf.default), {
        cardListId: cardListId,
        sprintName: name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $daJ0i.default), {
        data: {
            attributes: {
                cardListType: typeForAnalytics
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$Container, {
        hasSpaceBetweenCardLists: canEditIssue ? isActiveSprint && !isCollapsed : false,
        isBacklogCardList: (0, $dCm1o.isVisualRefreshEnabled)() ? false : isBacklogCardList,
        isVisualRefreshEnabled: (0, $dCm1o.isVisualRefreshEnabled)(),
        isDisabled: isDisabled,
        isThemed: isSoftwareFullTheming,
        "aria-controls": justCreated ? `${0, $2lpqS.HEADER_DROPPABLE_ID_PREFIX}${cardListId}` : undefined,
        "data-testid": `software-backlog.card-list.container.${cardListId}`,
        "aria-hidden": isDisabled
    }, (0, $4R6GH.fg)('jsw-backlog-card-list-refactor') ? justCreated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$A11yScreenReaderInfo, {
        cardListId: cardListId,
        listName: listName
    }) : renderA11yScreenReaderInfo(), header, !isCollapsed && ((0, $4R6GH.fg)('jsw-backlog-card-list-refactor') ? sprintData?.goal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$GoalWrapper, null, sprintData.goal)) : renderSprintData()), !isCollapsed && showWorkloadByAssignee && workloadByAssigneeGated, !isCollapsed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$ListContainer, {
        id: `backlog-accordion-${cardListId}`,
        "data-testid": "software-backlog.card-list.accordion",
        ref: listRef,
        isFirstNonEmptyList: isFirstNonEmptyList
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iiJr8.default), {
        isVisible: showTransitionZone,
        ref: transitionZoneElementRef,
        isDragOver: isDragOverTransitionZone
    }), (0, $4R6GH.fg)('jsw-backlog-card-list-refactor') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3JQPC.ContainerSizeContext).Provider, {
        value: {
            size: backlogContainerSize
        }
    }, type === (0, $guzeq.BACKLOG) && whiteboardsBanner && (0, $4R6GH.fg)('sprint_planning_whiteboards_gate') ? whiteboardsBanner : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l4p68.default), {
        cardListId: cardListId,
        renderCard: renderIccCard,
        isDropDisabled: isDisabled || showTransitionZone,
        emptyList: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$EmptyList, {
            cardCount: cardIds.length,
            isActiveSprint: isActiveSprint,
            isFirstList: isFirstList,
            type: type
        })
    })) : list, isIccEnabled && (0, $4R6GH.fg)('jsw-backlog-card-list-refactor') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$IccWithNudge, {
        aiPanelContainerRef: aiPanelContainerRef,
        cardListId: cardListId,
        iccAriaLabelledById: iccAriaLabelledById,
        isBacklogCardList: isBacklogCardList,
        isBacklogEmpty: isBacklogEmpty,
        isFirstList: isFirstList,
        setAiPanelSubject: setAiPanelSubject
    }) : iccWithNudge(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$VisuallyHidden, {
        as: "p",
        id: iccAriaLabelledById
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $6bzbn.default).inlineCardCreateAriaLabelIssueTermRefresh : (0, $6bzbn.default).inlineCardCreateAriaLabel, {
        sprintName: listName
    }))), !isCollapsed && ((0, $4R6GH.fg)('ai_powered_backlog_inline_create-create_in_sprint') || type === (0, $guzeq.BACKLOG)) && aiPanelSubject && (0, $4R6GH.fg)('aiwc_backlog_render_panel_in_card_list') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fiE4O.AiWorkCreatePanel), {
        subject: aiPanelSubject,
        ref: aiPanelContainerRef,
        ...(0, $4R6GH.fg)('ai_powered_backlog_inline_create-create_in_sprint') ? {
            listId: cardListId
        } : {}
    }), isLastNonEmptyList && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldRVl.LastResultMarker), null), isDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$export$c5de3e2a02009dcf, null)), ((0, $4R6GH.fg)('ai_powered_backlog_inline_create-create_in_sprint') || type === (0, $guzeq.BACKLOG)) && aiPanelSubject && !(0, $4R6GH.fg)('aiwc_backlog_render_panel_in_card_list') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fiE4O.AiWorkCreatePanel), {
        subject: aiPanelSubject,
        ref: aiPanelContainerRef,
        ...(0, $4R6GH.fg)('ai_powered_backlog_inline_create-create_in_sprint') ? {
            listId: cardListId
        } : {}
    }), !isDividerHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3pyss.default), {
        id: cardListId
    }));
}
var $cc0013909ff1f6e1$export$2e2bcd8739ae039 // Exported for unit testing
 = /*#__PURE__*/ (0, $5uXOq.memo)($cc0013909ff1f6e1$var$CardList);
const $cc0013909ff1f6e1$export$c5de3e2a02009dcf = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $cc0013909ff1f6e1$var$blanketBoxStyles
    });
const $cc0013909ff1f6e1$var$ListName = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "div",
        size: "xsmall"
    }, children); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc0013909ff1f6e1$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasSpaceBetweenCardLists: hasSpaceBetweenCardLists, isDisabled: isDisabled, isBacklogCardList: isBacklogCardList, isThemed: isThemed, isVisualRefreshEnabled: isVisualRefreshEnabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ul9cs0k _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _kqswh2mm",
            __cmplp.hasSpaceBetweenCardLists ? "_18s81km1" : "_18s861nu",
            __cmplp.isDisabled && "_tzy4105o",
            __cmplp.isDisabled && "_lcxvglyw",
            !__cmplp.isBacklogCardList && (__cmplp.isThemed ? "_bfhk1jc5" : "_bfhkqbzx"),
            __cmplp.isVisualRefreshEnabled ? "_2rko12x7" : "_2rkou2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $cc0013909ff1f6e1$var$CardListHeaderContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisualRefreshEnabled: isVisualRefreshEnabled, isMinLimitReached: isMinLimitReached, isMaxLimitReached: isMaxLimitReached, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_12sp1nw": (0, $lD23V.default)(__cmplp.isMaxLimitReached ? "var(--ds-background-accent-red-subtlest, #FFECEB)" : "var(--ds-background-accent-yellow-subtlest, #FFF7D6)")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o",
            __cmplp.isVisualRefreshEnabled ? "_1tke1jfw" : "_1tkezwfg",
            (__cmplp.isMinLimitReached || __cmplp.isMaxLimitReached) && "_bfhksts9 _19pk1bs0 _2hwx1vh9 _otyr1bs0 _18u01vh9 _ca0qftgi _u5f31crf _n3tdftgi _19bv1crf _13liftgi _qrwqftgi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc0013909ff1f6e1$var$CardMenuActionsWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19bvu2gc _1e0c1txw _2lx2vrvc _fiawglyw",
            __cmplp.className
        ])
    });
});
const $cc0013909ff1f6e1$var$cardMenuActionsStyles = (0, $8CUq3.xcss)({
    paddingLeft: 'space.100',
    ':empty': {
        display: 'none'
    }
});
const $cc0013909ff1f6e1$var$ListContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pku2gc _2hwxidpf _otyridpf _18u0idpf _kqswh2mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc0013909ff1f6e1$var$IconContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_lcxvglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc0013909ff1f6e1$var$VisibleCardsInCardListHeader = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _syaz131l _19pkze3t _2hwxze3t _otyrze3t _18u0u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc0013909ff1f6e1$var$ColumnLimit = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_k48pi7a9 _19pkze3t _2hwxze3t _otyrze3t _18u0u2gc _1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc0013909ff1f6e1$var$CollapsedDropzoneWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $cc0013909ff1f6e1$var$CollapsedDropzone = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko15p7 _189eyh40 _1dqogq9o _1h6dmuej _kqswstnw _1bsb1osq _4t3i1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc0013909ff1f6e1$var$LeftSideOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx2vrvc _4cvr1h6o _80omtlke _kqswh2mm _19pkidpf _2hwxu2gc _otyridpf _18u0idpf _nt751r31 _49pcglyw _1hvw1o36 _7ehi1vm4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc0013909ff1f6e1$var$LeftSideNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _zulp1b66 _1e0c1txw _2lx2vrvc _4cvr1h6o _80omtlke _kqswh2mm _19pkidpf _2hwxu2gc _otyridpf _18u0idpf _mizu1r31 _ra3xglyw _128m1o36 _1ejj1vm4",
            __cmplp.className
        ])
    });
});
const $cc0013909ff1f6e1$var$LeftSide = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $cc0013909ff1f6e1$var$LeftSideNew, $cc0013909ff1f6e1$var$LeftSideOld); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc0013909ff1f6e1$var$RightSide = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o _19bvu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc0013909ff1f6e1$var$DisabledStartSprintTooltip = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _y3gn1h6o _vwz410nf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc0013909ff1f6e1$var$GoalWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81o8v _1reo15vq _18m915vq _syaz131l _19pkv77o _2hwxze3t _otyrze3t _18u0ze3t _19bvpxbi _u5f3v47k _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc0013909ff1f6e1$var$DatesWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _19pkze3t _2hwxze3t _otyrze3t _18u0u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc0013909ff1f6e1$var$CardListButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwxu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc0013909ff1f6e1$var$AddSprintDatesButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkze3t _2hwxze3t _otyrze3t _18u0u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc0013909ff1f6e1$var$FullWidthWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc0013909ff1f6e1$var$HeadingWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8n7od _1e0c1bgi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc0013909ff1f6e1$var$VisuallyHidden = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _ogtohxbz _mkrz1wmp _4t3it94y _kqswstnw _o5721q9c _1bsbt94y",
            __cmplp.className
        ])
    });
});
const $cc0013909ff1f6e1$var$chevronIconStyles = (0, $8CUq3.xcss)({
    pointerEvents: 'none',
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $cc0013909ff1f6e1$var$blanketBoxStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    opacity: 0.5,
    top: 'space.0',
    bottom: 'space.0',
    left: 'space.0',
    right: 'space.0',
    pointerEvents: 'all'
});
const $cc0013909ff1f6e1$var$whiteboardsContainer = (0, $8CUq3.xcss)({
    paddingLeft: 'space.100'
});
const $cc0013909ff1f6e1$var$cardListHeadingWrapper = {
    pseudo: "_kqswstnw _154iidpf _1ltvidpf _1xi2idpf _94n5idpf"
};

});
parcelRegister("jDrwg", function(module, exports) {

$parcel$export(module.exports, "default", () => $049f084810e3e7c4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");
function $049f084810e3e7c4$export$2e2bcd8739ae039(callback, delay, options) {
    const optionsRef = (0, $5uXOq.useRef)(options);
    // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    const callbackRef = (0, $5uXOq.useRef)((...args)=>{
        callback(...args);
    });
    callbackRef.current = callback;
    const debouncedCallBack = (0, $5uXOq.useMemo)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((...args)=>callbackRef.current(...args), delay, optionsRef.current), [
        delay
    ]);
    (0, $5uXOq.useEffect)(()=>debouncedCallBack.cancel, [
        debouncedCallBack
    ]);
    return [
        debouncedCallBack,
        debouncedCallBack.cancel
    ];
}

});

const $dbbf68c32d8c4308$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $dbbf68c32d8c4308$export$6770a2081a63fc15 = 'backlogStartSprintNudge';
const $dbbf68c32d8c4308$export$63b61f654ce3da3d = 'backlogCompleteSprintNudge';
const $dbbf68c32d8c4308$export$1c7a80b00ad9619 = 'backlogInsightsNudge';
const $dbbf68c32d8c4308$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingNudges';
const $dbbf68c32d8c4308$export$65fb0c4e534f03fc = 'asyncScrumTourNudge';
const $dbbf68c32d8c4308$export$f2fe211acb4aa81a = 'asyncKanbanTourNudge';
const $dbbf68c32d8c4308$export$fb9c6e63a7490968 = 'asyncJWMCalendarTourNudge';
const $dbbf68c32d8c4308$export$df53a339af97f102 = 'asyncJWMCalendarAndTimelineTourNudge';
const $dbbf68c32d8c4308$export$573d4bf1da6d2bc6 = 'asyncJWMBoardTourNudge';
const $dbbf68c32d8c4308$export$501e36925fa10eef = 'asyncJWMListTourNudge';
const $dbbf68c32d8c4308$export$2f06a16c987cc1a2 = 'asyncJWMTimelineTourNudge';
const $dbbf68c32d8c4308$export$226bdcb034c75951 = 'asyncJWMFormTourNudge';
const $dbbf68c32d8c4308$export$b72fce9f4cf11b5c = 'asyncJWMTrelloKeyDifferencesTourNudge';
const $dbbf68c32d8c4308$export$306510c7b1760652 = 'asyncJWMSummaryAndReportsTabNudge';
const $dbbf68c32d8c4308$export$cf1943561be3a3c2 = 'asyncJWMSummaryViewNudge';
const $dbbf68c32d8c4308$export$f8bf435a6066832c = 'button clicked';
const $dbbf68c32d8c4308$export$3bc551fe07069f89 = 'asyncJWMInviteTeamNudge';
const $dbbf68c32d8c4308$export$d99767a37baddfc = 'sampleProjectDataNudge';
const $dbbf68c32d8c4308$export$2ef41782ca91324c = 'businessSampleDataNudge';
const $dbbf68c32d8c4308$export$4db327e1949c2108 = 'boardInProgressColumnNudge';
const $dbbf68c32d8c4308$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $dbbf68c32d8c4308$export$1e174cd1e0212f3a = 'navigateCalendarNudge';
const $dbbf68c32d8c4308$export$a1398a6ef9526001 = 'inlineEditListNudge';
const $dbbf68c32d8c4308$export$5908fa8acd2c0739 = 'filterListNudge';
const $dbbf68c32d8c4308$export$50192b0fdc9bdacf = 'moreDropdownListNudge';
const $dbbf68c32d8c4308$export$e34e81ed4f255f6e = 'timelineAddDateNudge';
const $dbbf68c32d8c4308$export$aac6e5779d47ef37 = 'timelineAddChildItemNudge';
const $dbbf68c32d8c4308$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $dbbf68c32d8c4308$export$1e0e647cc08bb4d8 = 'trelloKeyDifferencesIssueNudge';
const $dbbf68c32d8c4308$export$762576896c225bd6 = 'trelloKeyDifferencesSummaryNudge';
const $dbbf68c32d8c4308$export$5a96f813312dc7fa = 'trelloKeyDifferencesBoardNudge';
const $dbbf68c32d8c4308$export$ae8eeb04e0b1e9af = 'availableFieldsFormNudge';
const $dbbf68c32d8c4308$export$a54d77300f1dddea = 'changeIssueTypeFormNudge';
const $dbbf68c32d8c4308$export$6afdc7e5f6d2e915 = 'previewSaveFormNudge';
const $dbbf68c32d8c4308$export$eb0b199de90a7ec2 = 'backgroundColorNudge';
const $dbbf68c32d8c4308$export$e9e47a7ad42e71f5 = 'feedbackNudge';
const $dbbf68c32d8c4308$export$791f56b3d78403cc = 'calendarReleasesNudge';
const $dbbf68c32d8c4308$export$a1be34032ee24f78 = 'shareProjectNudge';
const $dbbf68c32d8c4308$export$29fe6611cc093756 = 'summaryTabNudge';
const $dbbf68c32d8c4308$export$f107c06c0830f09d = 'reportsTabNudge';
const $dbbf68c32d8c4308$export$9749a972a54ad7ba = 'boardContainerNudge';
const $dbbf68c32d8c4308$export$fb4f98ca3ff0420 = 'businessSampleDataNudge';
const $dbbf68c32d8c4308$export$b7fd448c62b5fb97 = 'listview';
const $dbbf68c32d8c4308$export$10c63dc5c09466d2 = 'boardview';
const $dbbf68c32d8c4308$export$75b8d65228d517e9 = 'sampleProjectScrumTourNudge';
const $dbbf68c32d8c4308$export$59a47f76d45b99 = 'sampleProjectScrumSprintNudge';
const $dbbf68c32d8c4308$export$513a9459cd6c3f96 = 'sampleProjectScrumBacklogNudge';
const $dbbf68c32d8c4308$export$657cdc4d7e8d9e5f = 'sampleProjectScrumBoardNudge';
const $dbbf68c32d8c4308$export$e16b25a220be9f3b = 'sampleProjectBoardNudge';
const $dbbf68c32d8c4308$export$c2f124710ac3a3ab = 'sampleProjectListNudge';
const $dbbf68c32d8c4308$export$b1c1e2ff4cbedbe = 'sampleProjectScrumSprintNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$b230ed22c9a186d5 = 'sampleProjectScrumBacklogNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$a321b777cf077071 = 'sampleProjectScrumBoardNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$b51b409cb5508624 = 'sampleProjectBoardNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$9757a1f68dc7a9b = 'sampleProjectListNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$63a886637b84800 = 'sampleProjectNavTourNudge';
const $dbbf68c32d8c4308$export$bb40993d16db4a4b = 'SampleProjectNavNudge';
const $dbbf68c32d8c4308$export$8c300ac9d8c53332 = 'SampleProjectNavNudgeErrorBoundary';

parcelRegister("hZ46s", function(module, exports) {

$parcel$export(module.exports, "BacklogAccordionNudgeAsync", () => $b4a74cc5c51cd8ff$export$42c8a8a359e4c141);

var $5uXOq = parcelRequire("5uXOq");


var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $b4a74cc5c51cd8ff$var$BacklogAccordionNudgeLazy = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("fYCiB")).then((exportedModule)=>exportedModule.BacklogAccordionNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/scrum-onboarding-tour/backlog-accordion/index.tsx"
});
const $b4a74cc5c51cd8ff$export$42c8a8a359e4c141 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $dbbf68c32d8c4308$export$65fb0c4e534f03fc),
        attributes: {
            nudgeId: (0, $6784cbc7d62e5d7c$export$b1a6ab17737f33e)
        },
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-onboarding-backlog-accordion-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b4a74cc5c51cd8ff$var$BacklogAccordionNudgeLazy, null, children)));
$b4a74cc5c51cd8ff$export$42c8a8a359e4c141.displayName = 'BacklogAccordionNudgeAsync';

});
parcelRegister("fYCiB", function(module, exports) {

let $ba1a2b01c830eb06$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ba1a2b01c830eb06$var$load("67oFO").then(()=>parcelRequire('jlBUT'));

});


parcelRegister("emeAH", function(module, exports) {

$parcel$export(module.exports, "BacklogCompleteSprintNudgeAsync", () => $8443c19cd20bb91b$export$ac45d9b04f7ab6cb);

var $5uXOq = parcelRequire("5uXOq");

var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $8443c19cd20bb91b$var$BacklogCompleteSprintNudgeLazy = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("5GtCn")).then((exportedModule)=>exportedModule.BacklogCompleteSprintNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/scrum-onboarding-tour/backlog-complete-sprint/index.tsx"
});
const $8443c19cd20bb91b$export$ac45d9b04f7ab6cb = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $dbbf68c32d8c4308$export$65fb0c4e534f03fc),
        fallback: children,
        attributes: {
            nudgeId: (0, $dbbf68c32d8c4308$export$63b61f654ce3da3d)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-onboarding-backlog-complete-sprint-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8443c19cd20bb91b$var$BacklogCompleteSprintNudgeLazy, null, children)));
$8443c19cd20bb91b$export$ac45d9b04f7ab6cb.displayName = 'BacklogCompleteSprintNudgeAsync';

});
parcelRegister("5GtCn", function(module, exports) {

let $01116abbd55e76e6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $01116abbd55e76e6$var$load("c7bmm").then(()=>parcelRequire('llVsO'));

});


parcelRegister("013U5", function(module, exports) {

$parcel$export(module.exports, "BacklogCreateIssueNudgeAsync", () => $dcc531286adcd54b$export$c82c69976e89b06);

var $5uXOq = parcelRequire("5uXOq");

var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");



// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $dcc531286adcd54b$var$BacklogCreateIssueNudgeLazy = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("aaxYH")).then((exportedModule)=>exportedModule.BacklogCreateIssueNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/scrum-onboarding-tour/backlog-create-issue/index.tsx"
});
const $dcc531286adcd54b$export$c82c69976e89b06 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $dbbf68c32d8c4308$export$65fb0c4e534f03fc),
        fallback: children,
        attributes: {
            nudgeId: (0, $6784cbc7d62e5d7c$export$64d75060ee6ba425)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-software-onboarding-backlog-create-issue-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dcc531286adcd54b$var$BacklogCreateIssueNudgeLazy, null, children)));
$dcc531286adcd54b$export$c82c69976e89b06.displayName = 'BacklogCreateIssueNudgeAsync';

});
parcelRegister("aaxYH", function(module, exports) {

let $767531e6a0d4a762$var$load = (parcelRequire("28QjX"))(4);
module.exports = $767531e6a0d4a762$var$load("czBrZ").then(()=>parcelRequire('aafXz'));

});


parcelRegister("4lQkG", function(module, exports) {

$parcel$export(module.exports, "BacklogCreateSprintNudgeAsync", () => $84eda15ec395a74a$export$e8f8b0e825812dde);

var $5uXOq = parcelRequire("5uXOq");

var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $84eda15ec395a74a$var$BacklogCreateSprintNudgeLazy = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("azDAT")).then((exportedModule)=>exportedModule.BacklogCreateSprintNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/scrum-onboarding-tour/backlog-create-sprint/index.tsx"
});
const $84eda15ec395a74a$export$e8f8b0e825812dde = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $dbbf68c32d8c4308$export$65fb0c4e534f03fc),
        fallback: children,
        attributes: {
            nudgeId: (0, $dbbf68c32d8c4308$export$e0197e09cccd4e50)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-onboarding-backlog-create-sprint-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84eda15ec395a74a$var$BacklogCreateSprintNudgeLazy, null, children)));
$84eda15ec395a74a$export$e8f8b0e825812dde.displayName = 'BacklogCreateSprintNudgeAsync';

});
parcelRegister("azDAT", function(module, exports) {

let $7b2be2d47adb9265$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7b2be2d47adb9265$var$load("62eOA").then(()=>parcelRequire('3ylMW'));

});


parcelRegister("ayaAN", function(module, exports) {

$parcel$export(module.exports, "BacklogStartSprintNudgeAsync", () => $1f1e0a523bf7e02e$export$fa791bd23efa3d8e);

var $5uXOq = parcelRequire("5uXOq");

var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1f1e0a523bf7e02e$var$BacklogStartSprintNudgeLazy = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("jPdal")).then((exportedModule)=>exportedModule.BacklogStartSprintNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/scrum-onboarding-tour/backlog-start-sprint/index.tsx"
});
const $1f1e0a523bf7e02e$export$fa791bd23efa3d8e = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $dbbf68c32d8c4308$export$65fb0c4e534f03fc),
        fallback: children,
        attributes: {
            nudgeId: (0, $dbbf68c32d8c4308$export$6770a2081a63fc15)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-onboarding-backlog-start-sprint-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1f1e0a523bf7e02e$var$BacklogStartSprintNudgeLazy, null, children)));
$1f1e0a523bf7e02e$export$fa791bd23efa3d8e.displayName = 'BacklogStartSprintNudgeAsync';

});
parcelRegister("jPdal", function(module, exports) {

let $e6ecfe2f62775bef$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e6ecfe2f62775bef$var$load("3JpF2").then(()=>parcelRequire('9hvRa'));

});


parcelRegister("fLVJv", function(module, exports) {

$parcel$export(module.exports, "WhiteboardsAllJiras", () => $1b22fea7df4cabaa$export$1bb50c8490ee00cd);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $iXVV6 = parcelRequire("iXVV6");

var $9VVCC = parcelRequire("9VVCC");
const $1b22fea7df4cabaa$export$1bb50c8490ee00cd = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "whiteboards-all-jiras-button",
        packageName: "jira-software-backlog",
        teamName: "starburst"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "planOnWhiteboardBacklogButton",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        attributes: {
            growthInitiative: 'cross-flow',
            experiment: 'expandPlanOnWhiteboardsToAllJiras'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9VVCC.WhiteboardsAllJirasButton), null)));
};

});
parcelRegister("9VVCC", function(module, exports) {

$parcel$export(module.exports, "WhiteboardsAllJirasButton", () => $44db2f0e3a0f7a10$export$1edb615631ac8339);

var $5uXOq = parcelRequire("5uXOq");

var $bHpB9 = parcelRequire("bHpB9");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $eCeGD = parcelRequire("eCeGD");

var $3u0c5 = parcelRequire("3u0c5");

var $koVbs = parcelRequire("koVbs");

var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $7IKPD = parcelRequire("7IKPD");

var $3DKih = parcelRequire("3DKih");

var $crgSa = parcelRequire("crgSa");

var $3L1UG = parcelRequire("3L1UG");

var $5uBAa = parcelRequire("5uBAa");

var $58veY = parcelRequire("58veY");
const $44db2f0e3a0f7a10$export$1edb615631ac8339 = ()=>{
    const { flow: flow, isVariantEligible: isVariantEligible } = (0, $58veY.useIsExperimentEligible)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const crossflow = (0, $bHpB9.useCrossFlow)();
    // Extract project name and project id
    const projectName = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getProjectName));
    const projectId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.projectIdSelector));
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const crossFlowEligible = flow === 'crossFlow';
    const coUseEligible = flow === 'coUse';
    const url = (0, $3L1UG.useCoUseFlow)(coUseEligible);
    const onPlanOnWhiteboard = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), (0, $7IKPD.CTA_SOURCE_CONTEXT), {
            sourceComponent: (0, $7IKPD.CTA_SOURCE_COMPONENT),
            sourceContext: (0, $7IKPD.CTA_SOURCE_CONTEXT)
        });
        (0, $3DKih.onClickCTA)({
            createAnalyticsEvent: createAnalyticsEvent,
            crossFlowEligible: crossFlowEligible,
            crossflow: crossflow,
            projectId: projectId,
            projectName: projectName,
            component: (0, $7IKPD.CTA_SOURCE_COMPONENT),
            context: (0, $7IKPD.CTA_SOURCE_CONTEXT),
            coUseEligible: coUseEligible,
            url: url
        });
        dispatch((0, $5uBAa.setHasXflowFromWhiteboardsTouchpoint)(true));
    }, [
        projectId,
        projectName,
        crossflow,
        createAnalyticsEvent,
        crossFlowEligible,
        coUseEligible,
        url,
        dispatch
    ]);
    if (isVariantEligible) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $44db2f0e3a0f7a10$var$CTAContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        onClick: onPlanOnWhiteboard
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        space: "space.050"
    }, formatMessage((0, $crgSa.default).planOnWhiteboard), crossFlowEligible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
        appearance: "new"
    }, formatMessage((0, $crgSa.default).planOnWhiteboardTry))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            crossFlowEligible: crossFlowEligible,
            coUseEligible: coUseEligible
        }
    }));
    return null;
};
const $44db2f0e3a0f7a10$var$CTAContainer = (0, $8CUq3.xcss)({
    paddingLeft: 'space.100'
});

});
parcelRegister("3DKih", function(module, exports) {

$parcel$export(module.exports, "onClickCTA", () => $6b33359cee0f3410$export$5765570e868a3d49);

var $bHpB9 = parcelRequire("bHpB9");
var $jWY5k = parcelRequire("jWY5k");

var $8zOmE = parcelRequire("8zOmE");
const $6b33359cee0f3410$export$5765570e868a3d49 = ({ createAnalyticsEvent: createAnalyticsEvent, crossFlowEligible: crossFlowEligible, crossflow: crossflow, projectId: projectId, projectName: projectName, component: component, context: context, coUseEligible: coUseEligible, url: url, crossJoinEligible: crossJoinEligible })=>{
    if (crossFlowEligible) {
        if (!crossflow.isEnabled) return;
        if (!!projectId && !!projectName) crossflow.api.open({
            sourceComponent: component,
            sourceContext: context,
            targetProduct: (0, $jWY5k.Targets).CONFLUENCE,
            journey: (0, $bHpB9.Journeys).GET_STARTED,
            experimentalOptions: {
                projectId: projectId,
                projectName: projectName
            }
        });
        else (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'projectInfo missing', {
            isCrossFlowEligible: crossFlowEligible,
            isCoUseEligible: coUseEligible,
            projectId: projectId,
            projectName: projectName
        });
    } else if (coUseEligible) globalThis.window.open(url, '_blank');
    else if (crossJoinEligible) globalThis.window.open('/wiki', '_blank');
};

});

parcelRegister("crgSa", function(module, exports) {

$parcel$export(module.exports, "default", () => $567878f9577fb49b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $567878f9577fb49b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    planOnWhiteboard: {
        "id": "backlog.whiteboards-entrypoint-experiment.plan-on-whiteboard",
        "defaultMessage": "Plan on whiteboard"
    },
    planOnWhiteboardTry: {
        "id": "backlog.whiteboards-entrypoint-experiment.plan-on-whiteboard-try",
        "defaultMessage": "Try"
    },
    spotlightHeading: {
        "id": "backlog.whiteboards-entrypoint-experiment.spotlight-heading",
        "defaultMessage": "Plan in a whiteboard"
    },
    spotlightContent: {
        "id": "backlog.whiteboards-entrypoint-experiment.spotlight-content",
        "defaultMessage": "Link, organize, and plan your work however you want."
    },
    spotlightContentForCrossJoinUsers: {
        "id": "backlog.whiteboards-entrypoint-experiment.spotlight-content-for-cross-join-users",
        "defaultMessage": "Join your team on Confluence to link, organize, and plan your work however you want."
    },
    spotlightCta: {
        "id": "backlog.whiteboards-entrypoint-experiment.spotlight-cta",
        "defaultMessage": "Try now"
    },
    privacyPolicy: {
        "id": "backlog.whiteboards-entrypoint-experiment.privacy-policy",
        "defaultMessage": "Learn more about your data privacy with Atlassian"
    },
    dismissFlagTitle: {
        "id": "backlog.whiteboards-entrypoint-experiment.dismiss-flag-title",
        "defaultMessage": "Thanks for letting us know"
    },
    dismissFlagDescription: {
        "id": "backlog.whiteboards-entrypoint-experiment.dismiss-flag-description",
        "defaultMessage": "You won\u2019t see this ad here again."
    },
    reasonsModalTitle: {
        "id": "backlog.whiteboards-entrypoint-experiment.reasons-modal-title",
        "defaultMessage": "Why am I seeing this?"
    },
    reasonsModalExplanation: {
        "id": "backlog.whiteboards-entrypoint-experiment.reasons-modal-explanation",
        "defaultMessage": "We think <strong>Confluence whiteboards</strong> will improve your team's productivity. The recommendation is based on:"
    },
    reasonsModalBulletOne: {
        "id": "backlog.whiteboards-entrypoint-experiment.reasons-modal-bullet-one",
        "defaultMessage": "the size of your team"
    },
    reasonsModalBulletTwo: {
        "id": "backlog.whiteboards-entrypoint-experiment.reasons-modal-bullet-two",
        "defaultMessage": "your existing Atlassian products"
    },
    reasonsModalBulletOneForCrossJoinUsers: {
        "id": "backlog.whiteboards-entrypoint-experiment.reasons-modal-bullet-one-for-cross-join-users",
        "defaultMessage": "your team\u2019s Atlassian products"
    },
    reasonsModalBulletTwoForCrossJoinUsers: {
        "id": "backlog.whiteboards-entrypoint-experiment.reasons-modal-bullet-two-for-cross-join-users",
        "defaultMessage": "the Atlassian products you have access to"
    },
    adControls: {
        "id": "backlog.whiteboards-entrypoint-experiment.ad-controls",
        "defaultMessage": "Ad controls"
    },
    bannerIcon: {
        "id": "backlog.whiteboards-entrypoint-experiment.banner-icon",
        "defaultMessage": "Whiteboards banner icon"
    },
    banner: {
        "id": "backlog.whiteboards-entrypoint-experiment.banner",
        "defaultMessage": "Create a whiteboard to plan your work"
    },
    bannerForCrossJoinUsers: {
        "id": "backlog.whiteboards-entrypoint-experiment.banner-for-cross-join-users",
        "defaultMessage": "Create a Confluence whiteboard to plan your work"
    },
    bannerDismiss: {
        "id": "backlog.whiteboards-entrypoint-experiment.banner-dismiss",
        "defaultMessage": "Dismiss whiteboard banner"
    }
});

});

parcelRegister("3L1UG", function(module, exports) {

$parcel$export(module.exports, "useCoUseFlow", () => $6ef631c53c91a5d8$export$69587f2db02847d5);

var $5uXOq = parcelRequire("5uXOq");

var $koeKL = parcelRequire("koeKL");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $aSijV = parcelRequire("aSijV");
const $6ef631c53c91a5d8$export$69587f2db02847d5 = (coUseEligible)=>{
    const projects = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getProjects));
    const projectId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.projectIdSelector));
    // In company managed projects project name is actually the project key, that's why we cannot rely on it to search for a space, we will still default to it if no project matches are found.
    const projectName = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getProjectName));
    const project = (0, $5uXOq.useMemo)(()=>projects?.find?.((it)=>it.id === projectId), [
        projects,
        projectId
    ]);
    const name = project?.name ?? projectName;
    const spaceKey = (0, $aSijV.useGetSpaceKey)(name, coUseEligible);
    const cloudId = (0, $koeKL.useCloudId)();
    return `/wiki/create-content/whiteboard?openJiraImportTool=true&cloudId=${cloudId}&projectUuid=${projectId}&insertTemplateWithKey=prioritization-experiment&spaceKey=${spaceKey}&withFallback=True`;
};

});
parcelRegister("aSijV", function(module, exports) {

$parcel$export(module.exports, "useGetSpaceKey", () => $cef2af2fe3579f0b$export$42371466d4d0aa3);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $jJZqs = parcelRequire("jJZqs");

var $7IKPD = parcelRequire("7IKPD");
const $cef2af2fe3579f0b$var$meta = {
    id: 'GetSpaceKey',
    packageName: 'jiraSoftwareBacklog',
    teamName: 'starburst'
};
const $cef2af2fe3579f0b$export$42371466d4d0aa3 = (projectName, coUseEligible)=>{
    const [spaceKey, setSpaceKey] = (0, $5uXOq.useState)('');
    const checkForConfluenceSpace = (0, $5uXOq.useCallback)(async ()=>{
        if (coUseEligible && projectName) try {
            const cachedKey = (0, $7IKPD.getSpaceKey)();
            if (cachedKey) {
                setSpaceKey(cachedKey);
                return;
            }
            const cql = `type = space and title = "${projectName}"`;
            const api = `/wiki/rest/api/search?cql=${encodeURIComponent(cql)}`;
            const res = await (0, $eusud.performGetRequest)(api);
            const key = res?.results?.[0]?.space?.key;
            if (typeof key === 'string') {
                (0, $7IKPD.setSpaceKey)(key);
                setSpaceKey(key);
            }
        } catch (error) {
            if ((0, $jJZqs.isFetchError)(error)) {
                if (error.statusCode === 403) return;
                (0, $jcw0u.default)({
                    meta: $cef2af2fe3579f0b$var$meta,
                    attributes: {
                        traceId: error.traceId,
                        statusCode: error.statusCode
                    },
                    error: new Error(`Fetch Error when searching for a space key with a given project name, status code: ${error.statusCode}`)
                });
            /* eslint-disable-next-line @typescript-eslint/consistent-type-assertions */ } else if ((0, $jJZqs.isValidationError)(error)) {
                /* eslint-disable-next-line @typescript-eslint/consistent-type-assertions */ const validationError = error;
                (0, $jcw0u.default)({
                    meta: $cef2af2fe3579f0b$var$meta,
                    attributes: {
                        traceId: validationError.traceId,
                        statusCode: validationError.statusCode
                    },
                    error: new Error(`Validation Error when searching for a space key with a given project name, status code: ${validationError.statusCode}`)
                });
            } else if (error instanceof Error) (0, $jcw0u.default)({
                meta: $cef2af2fe3579f0b$var$meta,
                skipSentry: true,
                error: new Error('Unknown error when searching for a space key with a given project name')
            });
            setSpaceKey('');
        }
    }, [
        coUseEligible,
        projectName
    ]);
    (0, $5uXOq.useEffect)(()=>{
        checkForConfluenceSpace();
    }, [
        checkForConfluenceSpace
    ]);
    return spaceKey;
};

});


parcelRegister("58veY", function(module, exports) {

$parcel$export(module.exports, "useIsExperimentEligible", () => $7d36d4983e704de2$export$31f9aca3adff10f7);

var $6s1PB = parcelRequire("6s1PB");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $eoB0b = parcelRequire("eoB0b");

var $c1MAf = parcelRequire("c1MAf");

var $7IKPD = parcelRequire("7IKPD");

var $4jqAD = parcelRequire("4jqAD");
const $7d36d4983e704de2$export$31f9aca3adff10f7 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const crossFlowEligible = (0, $4jqAD.useIsCrossFlowEligibleAllJiras)();
    const coUseEligible = (0, $4jqAD.useIsCoUseEligibleAllJiras)();
    const hasXflowFromWhiteboardsTouchpoint = (0, $c1MAf.useBacklogSelector)((0, $eoB0b.getHasXflowFromWhiteboardsTouchPoint));
    let isVariantEligible = false;
    let cohort = (0, $7IKPD.NOT_ENROLLED);
    let flow = 'none';
    if (crossFlowEligible) {
        cohort = (0, $6s1PB.expVal)('grw_1037_expand_plan_in_whiteboards', 'cohort', 'not-enrolled');
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'expandPlanOnWhiteboardsToAllJiras exposed', {
            cohort: cohort
        });
        if (cohort === (0, $7IKPD.VARIATION)) {
            flow = 'crossFlow';
            isVariantEligible = true;
        }
    } else if (coUseEligible && hasXflowFromWhiteboardsTouchpoint) {
        flow = 'coUse';
        isVariantEligible = true;
    }
    return {
        flow: flow,
        isVariantEligible: isVariantEligible
    };
};

});
parcelRegister("4jqAD", function(module, exports) {

$parcel$export(module.exports, "useIsBacklogCardListSizeGreaterThanTwo", () => $05828c95ab191dbf$export$c5a56ee9e6924da4);
$parcel$export(module.exports, "useIsCrossFlowEligible", () => $05828c95ab191dbf$export$ff76dd1cdd043d2b);
$parcel$export(module.exports, "useIsCrossFlowEligibleAllJiras", () => $05828c95ab191dbf$export$e5a2dc020c63a7d6);
$parcel$export(module.exports, "useIsCoUseEligible", () => $05828c95ab191dbf$export$9d3b05f7271c5614);
$parcel$export(module.exports, "useIsCoUseEligibleAllJiras", () => $05828c95ab191dbf$export$9aae0f5db38cfe5a);
$parcel$export(module.exports, "useIsCrossJoinEligible", () => $05828c95ab191dbf$export$2f18dcab48a813fd);

var $itmJb = parcelRequire("itmJb");

var $9OXo1 = parcelRequire("9OXo1");

var $guzeq = parcelRequire("guzeq");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");

var $eoB0b = parcelRequire("eoB0b");
const $05828c95ab191dbf$export$c5a56ee9e6924da4 = ()=>(0, $c1MAf.useBacklogSelector)((0, $dGljH.getOrderedCardIdsByCardListId))[0, $guzeq.BACKLOG]?.length > 2;
// Checks it the tenant has Confluence site
const $05828c95ab191dbf$var$useTenantHasConfluence = ()=>{
    const { licensedProducts: licensedProducts } = (0, $9OXo1.useTenantContext)();
    return licensedProducts?.confluence === true;
};
const $05828c95ab191dbf$var$useTenantHasProductSuggestionsEnabled = ()=>{
    const { areProductSuggestionsEnabled: areProductSuggestionsEnabled } = (0, $9OXo1.useTenantContext)();
    return areProductSuggestionsEnabled;
};
const $05828c95ab191dbf$export$ff76dd1cdd043d2b = ()=>{
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const hasConfluence = $05828c95ab191dbf$var$useTenantHasConfluence();
    return $05828c95ab191dbf$var$useTenantHasProductSuggestionsEnabled() && !hasConfluence && isAdmin;
};
const $05828c95ab191dbf$export$e5a2dc020c63a7d6 = ()=>{
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const hasConfluence = $05828c95ab191dbf$var$useTenantHasConfluence();
    const crossFlowEligible = $05828c95ab191dbf$var$useTenantHasProductSuggestionsEnabled() && !hasConfluence && isAdmin;
    const backlogCardListSizeGreaterThanTwo = $05828c95ab191dbf$export$c5a56ee9e6924da4();
    return crossFlowEligible && backlogCardListSizeGreaterThanTwo;
};
const $05828c95ab191dbf$export$9d3b05f7271c5614 = ()=>{
    const hasAccess = (0, $c1MAf.useBacklogSelector)((0, $eoB0b.getHasConfluenceAccess));
    const hasSpaces = (0, $c1MAf.useBacklogSelector)((0, $eoB0b.getHasConfluenceSpaces));
    return $05828c95ab191dbf$var$useTenantHasConfluence() && hasAccess && hasSpaces;
};
const $05828c95ab191dbf$export$9aae0f5db38cfe5a = ()=>{
    const hasAccess = (0, $c1MAf.useBacklogSelector)((0, $eoB0b.getHasConfluenceAccess));
    const hasSpaces = (0, $c1MAf.useBacklogSelector)((0, $eoB0b.getHasConfluenceSpaces));
    const coUseEligible = $05828c95ab191dbf$var$useTenantHasConfluence() && hasAccess && hasSpaces;
    const backlogCardListSizeGreaterThanTwo = $05828c95ab191dbf$export$c5a56ee9e6924da4();
    return coUseEligible && backlogCardListSizeGreaterThanTwo;
};
const $05828c95ab191dbf$export$2f18dcab48a813fd = ()=>{
    const crossJoinEligible = (0, $c1MAf.useBacklogSelector)((0, $eoB0b.getHasConfluenceRequestOrDirectAccess));
    return $05828c95ab191dbf$var$useTenantHasConfluence() && crossJoinEligible;
};

});




parcelRegister("7ekti", function(module, exports) {

$parcel$export(module.exports, "useWhiteboardsTouchpoint", () => $317313b8b3db7edb$export$4aab01ee39982b69);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $iXVV6 = parcelRequire("iXVV6");

var $cWTTi = parcelRequire("cWTTi");

var $5b0JV = parcelRequire("5b0JV");

var $2BEi6 = parcelRequire("2BEi6");

var $7IKPD = parcelRequire("7IKPD");

var $hG4Aw = parcelRequire("hG4Aw");
const $317313b8b3db7edb$export$4aab01ee39982b69 = ({ skipExposure: skipExposure, isCreateSprintButtonVisible: isCreateSprintButtonVisible })=>{
    const { flow: flow, isVariantEligible: isVariantEligible } = (0, $2BEi6.useIsExperimentEligible)(skipExposure);
    const [hoverPulse, setHoverPulse] = (0, $5uXOq.useState)(false);
    const whiteboardsTouchpoint = isVariantEligible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: (0, $7IKPD.ELEMENT_IDS).TOUCHPOINT,
        packageName: "jira-software-backlog",
        teamName: "starburst"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cWTTi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "planOnWhiteboardBacklogButton",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        attributes: {
            growthInitiative: 'cross-flow'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5b0JV.BacklogButtonRefresh), {
        flow: flow,
        hoverPulse: hoverPulse
    })))) : null;
    const whiteboardsBanner = isVariantEligible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: (0, $7IKPD.ELEMENT_IDS).BANNER,
        packageName: "jira-software-backlog",
        teamName: "starburst"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cWTTi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "planOnWhiteboardBacklogBanner",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        attributes: {
            growthInitiative: 'cross-flow'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hG4Aw.Banner), {
        flow: flow,
        setHoverPulse: setHoverPulse,
        isCreateSprintButtonVisible: isCreateSprintButtonVisible,
        hoverPulse: hoverPulse
    })))) : null;
    return {
        whiteboardsTouchpoint: whiteboardsTouchpoint,
        whiteboardsBanner: whiteboardsBanner
    };
};

});
parcelRegister("5b0JV", function(module, exports) {

$parcel$export(module.exports, "BacklogButtonRefresh", () => $6d8d47e195bd6dd6$export$c876cd03a57dfccd);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable jira/react-no-inline-function-prop */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $jWY5k = parcelRequire("jWY5k");
var $bHpB9 = parcelRequire("bHpB9");

var $42CjB = parcelRequire("42CjB");

var $fVnbM = parcelRequire("fVnbM");

var $imZsD = parcelRequire("imZsD");
var $k6T4f = parcelRequire("k6T4f");
var $5Fk4Z = parcelRequire("5Fk4Z");
var $1QiBP = parcelRequire("1QiBP");

var $h5fUN = parcelRequire("h5fUN");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $l1N8i = parcelRequire("l1N8i");

var $cmVQ7 = parcelRequire("cmVQ7");

var $ehdJY = parcelRequire("ehdJY");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4mO32 = parcelRequire("4mO32");

var $7XluA = parcelRequire("7XluA");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $3L1UG = parcelRequire("3L1UG");

var $7IKPD = parcelRequire("7IKPD");

var $3DKih = parcelRequire("3DKih");

var $4jqAD = parcelRequire("4jqAD");

var $crgSa = parcelRequire("crgSa");

var $j4a1R = parcelRequire("j4a1R");

var $eJMZH = parcelRequire("eJMZH");

var $37I5l = parcelRequire("37I5l");
const $6d8d47e195bd6dd6$export$c876cd03a57dfccd = ({ flow: flow, hoverPulse: hoverPulse })=>{
    const coUseEligible = flow === 'coUse';
    const crossFlowEligible = flow === 'crossFlow';
    const crossJoinEligible = flow === 'crossJoin';
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { fireInteractedUIEvent: fireInteractedUIEvent, fireViewedScreenEvent: fireViewedScreenEvent } = (0, $cmVQ7.useFireCrossFlowAnalyticsEvents)();
    const crossflow = (0, $bHpB9.useCrossFlow)();
    const { hasDismissed: hasDismissed, dismiss: dismiss } = (0, $eJMZH.useAdControls)({
        crossJoinEligible: crossJoinEligible
    });
    const url = (0, $3L1UG.useCoUseFlow)(coUseEligible); // Extract project name and project id
    const projectName = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getProjectName));
    const projectId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.projectIdSelector));
    const [isSpotlightActive, setIsSpotlightActive] = (0, $5uXOq.useState)(false);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $37I5l.entryPoint), {});
    const onPlanOnWhiteboard = (0, $5uXOq.useCallback)((actionSubjectId)=>{
        if (coUseEligible) (0, $7IKPD.setHasClickedOnPulse)();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), actionSubjectId, {
            experiment: 'backlogButtonRefresh',
            isCrossFlowEligible: crossFlowEligible,
            isCoUseEligible: coUseEligible,
            isCrossJoinEligible: crossJoinEligible
        }); // UCIA event
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $7IKPD.CTA_SOURCE_CONTEXT)
        }, {
            targetProductId: (0, $jWY5k.Targets).CONFLUENCE,
            recommendedProductIds: [
                (0, $jWY5k.Targets).CONFLUENCE
            ],
            source: (0, $7IKPD.CTA_SOURCE_COMPONENT)
        });
        (0, $3DKih.onClickCTA)({
            createAnalyticsEvent: createAnalyticsEvent,
            crossFlowEligible: crossFlowEligible,
            crossflow: crossflow,
            projectId: projectId,
            projectName: projectName,
            component: (0, $7IKPD.CTA_SOURCE_COMPONENT),
            context: (0, $7IKPD.CTA_SOURCE_CONTEXT),
            coUseEligible: coUseEligible,
            crossJoinEligible: crossJoinEligible,
            url: url
        });
    }, [
        coUseEligible,
        createAnalyticsEvent,
        crossFlowEligible,
        crossJoinEligible,
        fireInteractedUIEvent,
        crossflow,
        projectId,
        projectName,
        url
    ]);
    const handleDismissEntrypoint = (0, $5uXOq.useCallback)(async ()=>{
        await dismiss((0, $7IKPD.USER_PROPERTY_KEY_NAMES).WHITEBOARDS_BACKLOG_ENTRYPOINT_DISMISSED);
    }, [
        dismiss
    ]);
    const openSpotlight = (0, $5uXOq.useCallback)(()=>{
        entryPointActions.load();
        setIsSpotlightActive(true);
    }, [
        entryPointActions
    ]);
    const closeSpotlight = (0, $5uXOq.useCallback)(()=>{
        entryPointActions.unload();
        setIsSpotlightActive(false);
    }, [
        entryPointActions
    ]);
    const hasClickedOnPulse = (0, $7IKPD.getHasClickedOnPulse)();
    const shouldRenderPulse = (0, $4jqAD.useIsBacklogCardListSizeGreaterThanTwo)() && coUseEligible && !isSpotlightActive && !hasClickedOnPulse || crossFlowEligible && hoverPulse || crossJoinEligible && hoverPulse;
    (0, $5uXOq.useEffect)(()=>{
        if (!hasDismissed) // UCIA event
        fireViewedScreenEvent('planOnWhiteboardsButtonCTAScreen', {
            recommendedProductIds: [
                (0, $jWY5k.Targets).CONFLUENCE
            ]
        });
    }, [
        hasDismissed,
        fireViewedScreenEvent
    ]);
    if (hasDismissed) return null;
    const footer = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j4a1R.AdControls), {
            isCta: true,
            onDismissAd: handleDismissEntrypoint,
            crossJoinEligible: crossJoinEligible
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "default",
            onClick: ()=>onPlanOnWhiteboard((0, $7IKPD.CTA_SPOTLIGHT_SOURCE_CONTEXT)),
            id: (0, $7IKPD.ELEMENT_IDS).CTA_BUTTON,
            className: (0, $bwpsq.default)([
                "_syaz1gfe _bfhk1vck _30l31gfe"
            ])
        }, formatMessage((0, $crgSa.default).spotlightCta)));
    const spotlightContent = crossJoinEligible ? formatMessage((0, $crgSa.default).spotlightContentForCrossJoinUsers) : formatMessage((0, $crgSa.default).spotlightContent);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), {
        blanketIsTinted: false,
        onBlanketClicked: closeSpotlight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "whiteboards"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k6T4f.Pulse), {
        radius: 3,
        pulse: shouldRenderPulse,
        testId: "software-backlog.whiteboards-entrypoint-experiment.backlog-button-refresh.pulse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        id: (0, $7IKPD.ELEMENT_IDS).TOUCHPOINT,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($h5fUN))),
        onClick: ()=>onPlanOnWhiteboard((0, $7IKPD.CTA_SOURCE_CONTEXT)),
        spacing: "compact",
        label: formatMessage((0, $crgSa.default).planOnWhiteboard),
        onMouseEnter: crossFlowEligible || crossJoinEligible ? openSpotlight : undefined,
        isTooltipDisabled: crossFlowEligible || crossJoinEligible
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, isSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "planOnWhiteboardSpotlight",
        sourceType: (0, $4d5e0871c06cee03$export$9d2de6eebf7462b5)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        actions: [
            {
                onClick: ()=>onPlanOnWhiteboard((0, $7IKPD.CTA_SPOTLIGHT_SOURCE_CONTEXT)),
                text: formatMessage((0, $crgSa.default).spotlightCta)
            }
        ],
        target: "whiteboards",
        targetRadius: 3,
        dialogWidth: 320,
        dialogPlacement: "bottom right",
        pulse: false,
        targetOnClick: ()=>onPlanOnWhiteboard((0, $7IKPD.CTA_SOURCE_CONTEXT)),
        messageType: "engagement",
        messageId: "software-backlog.whiteboards-entrypoint-experiment.backlog-button-refresh.jira-spotlight.whiteboards",
        testId: "software-backlog.whiteboards-entrypoint-experiment.backlog-button-refresh.whiteboards-spotlight",
        key: "software-backlog.whiteboards-entrypoint-experiment.backlog-button-refresh.jira-spotlight.whiteboards",
        footer: footer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $6d8d47e195bd6dd6$var$styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "whiteboards-entrypoint-backlog-button-refresh-animation",
        runtimeProps: {}
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        padding: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "medium"
    }, formatMessage((0, $crgSa.default).spotlightHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, spotlightContent)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            crossFlowEligible: crossFlowEligible,
            coUseEligible: coUseEligible,
            crossJoinEligible: crossJoinEligible,
            experiment: 'backlogButtonRefresh'
        }
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            crossFlowEligible: crossFlowEligible,
            coUseEligible: coUseEligible,
            crossJoinEligible: crossJoinEligible,
            experiment: 'backlogButtonRefresh'
        }
    }));
};
const $6d8d47e195bd6dd6$var$buttonStyles = null; /**
                            * Unfortunately there is no way to alter the padding of the spotlight content other than adding negative margins.
                            */ 
const $6d8d47e195bd6dd6$var$styles = (0, $8CUq3.xcss)({
    marginTop: 'space.negative.250',
    marginRight: 'space.negative.250',
    marginBottom: 'space.negative.250',
    marginLeft: 'space.negative.250'
});

});
parcelRegister("h5fUN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e4cad5a4ce9de3d8f027113d1b7910c8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6ff3fae3688d83c$var$_react = $c6ff3fae3688d83c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c6ff3fae3688d83c$var$_baseNew = $c6ff3fae3688d83c$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $c6ff3fae3688d83c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Whiteboard".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for whiteboards in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c6ff3fae3688d83c$var$WhiteboardIcon = (props)=>/*#__PURE__*/ $c6ff3fae3688d83c$var$_react.default.createElement($c6ff3fae3688d83c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.162 2.178c-.714.282-1.28.816-1.449 1.338l-1.426-.463C6.637 1.97 7.633 1.169 8.61.783c.943-.373 2.248-.49 3.09.374.346.356.536.778.548 1.237.011.436-.14.827-.323 1.144-.228.393-.557.76-.876 1.074 1.466-.137 2.717.238 3.421 1.133.827 1.05.644 2.464-.256 3.698l-1.212-.885c.66-.905.556-1.547.29-1.885-.305-.387-1.095-.756-2.524-.512-.521.09-.935.139-1.236.13a1.4 1.4 0 0 1-.537-.109.9.9 0 0 1-.345-.278.85.85 0 0 1-.164-.496 1.02 1.02 0 0 1 .197-.586c.077-.112.171-.215.256-.3.14-.143.323-.306.499-.464l.101-.09c.453-.407.87-.806 1.087-1.18.102-.179.124-.292.123-.355-.002-.04-.01-.112-.124-.23-.2-.204-.716-.32-1.464-.025M3.75 5.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M0 7.75a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0m10.25.75a.75.75 0 0 1 .643.364l3 5A.75.75 0 0 1 13.25 15h-6a.75.75 0 0 1-.643-1.136l3-5a.75.75 0 0 1 .643-.364m-1.675 5h3.35l-1.675-2.792z" clip-rule="evenodd"/>`
    }, props));
$c6ff3fae3688d83c$var$WhiteboardIcon.displayName = 'WhiteboardIcon';
var $c6ff3fae3688d83c$var$_default = module.exports.default = $c6ff3fae3688d83c$var$WhiteboardIcon;

});

parcelRegister("j4a1R", function(module, exports) {

$parcel$export(module.exports, "AdControls", () => $e6f9ea45e824fc3b$export$c25b8b7217045de9);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $e4yMr = parcelRequire("e4yMr");

var $42CjB = parcelRequire("42CjB");

var $l1N8i = parcelRequire("l1N8i");

var $bUmQV = parcelRequire("bUmQV");
var $dS3PR = parcelRequire("dS3PR");

var $8U6zd = parcelRequire("8U6zd");

var $bdFM8 = parcelRequire("bdFM8");
var $iB3Ak = parcelRequire("iB3Ak");
var $G85VY = parcelRequire("G85VY");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $koVbs = parcelRequire("koVbs");

var $crgSa = parcelRequire("crgSa");

var $7IKPD = parcelRequire("7IKPD");
const $e6f9ea45e824fc3b$var$AdControlsReasonsModal = ({ crossJoinEligible: crossJoinEligible })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const clickedLinkBaseEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'link'
    });
    const onClickPrivacyPolicy = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(clickedLinkBaseEvent, 'adControlsPrivacyPolicy');
    }, [
        clickedLinkBaseEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "adControlsReasons",
        sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa)
    }, formatMessage((0, $crgSa.default).reasonsModalExplanation, {
        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
                as: "strong"
            }, chunks)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("ul", {
        className: (0, $bwpsq.default)([
            "_otyrutpp"
        ])
    }, crossJoinEligible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", null, formatMessage((0, $crgSa.default).reasonsModalBulletOneForCrossJoinUsers)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", null, formatMessage((0, $crgSa.default).reasonsModalBulletTwoForCrossJoinUsers))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", null, formatMessage((0, $crgSa.default).reasonsModalBulletOne)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", null, formatMessage((0, $crgSa.default).reasonsModalBulletTwo)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
        href: (0, $7IKPD.DATA_PRIVACY_LINK),
        target: "_blank",
        onClick: onClickPrivacyPolicy
    }, formatMessage((0, $crgSa.default).privacyPolicy)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            crossJoinEligible: crossJoinEligible
        }
    }));
};
const $e6f9ea45e824fc3b$export$c25b8b7217045de9 = ({ isCta: isCta, onDismissAd: onDismissAd, crossJoinEligible: crossJoinEligible, children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isCrossJoinEligible = crossJoinEligible ?? false;
    const ctaIcon = (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8U6zd))), {
            ...iconProps,
            color: "var(--ds-text-inverse, #FFFFFF)"
        });
    const bannerIcon = (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8U6zd))), {
            ...iconProps,
            color: "var(--ds-icon, #44546F)"
        });
    const moreIcon = isCta ? ctaIcon : bannerIcon;
    const onClickDropdown = (0, $5uXOq.useCallback)((onClick, data)=>{
        onClick(data);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'adControlsDropdown', {
            crossJoinEligible: isCrossJoinEligible
        });
    }, [
        createAnalyticsEvent,
        isCrossJoinEligible
    ]);
    const trigger = ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            ...props,
            onClick: (data)=>onClickDropdown(props.onClick, data),
            ref: triggerRef,
            icon: moreIcon,
            label: formatMessage((0, $crgSa.default).adControls),
            isSelected: false,
            appearance: "subtle"
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), {
        alignItems: "center",
        justifyContent: "end",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bdFM8.default), {
        itemId: "placeholder-template-ad-controls",
        trigger: trigger,
        zIndex: 1000,
        placement: "bottom-start"
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iB3Ak.default), {
            ...props,
            flagProps: {
                title: formatMessage((0, $crgSa.default).dismissFlagTitle),
                description: formatMessage((0, $crgSa.default).dismissFlagDescription)
            },
            onClick: onDismissAd
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $G85VY.default), {
            ...props,
            modalProps: {
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
                    size: "medium"
                }, formatMessage((0, $crgSa.default).reasonsModalTitle)),
                body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e6f9ea45e824fc3b$var$AdControlsReasonsModal, {
                    crossJoinEligible: isCrossJoinEligible
                })
            }
        }))), children);
};
const $e6f9ea45e824fc3b$var$listStyle = null;

});

parcelRegister("eJMZH", function(module, exports) {

$parcel$export(module.exports, "useAdControls", () => $47d40fe19ac73925$export$3d5a0025b89da917);

var $5uXOq = parcelRequire("5uXOq");

var $89SaW = parcelRequire("89SaW");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $90yGq = parcelRequire("90yGq");

var $eNf8a = parcelRequire("eNf8a");

var $c1MAf = parcelRequire("c1MAf");

var $eoB0b = parcelRequire("eoB0b");

var $7IKPD = parcelRequire("7IKPD");

var $5uBAa = parcelRequire("5uBAa");
const $47d40fe19ac73925$export$3d5a0025b89da917 = ({ crossJoinEligible: crossJoinEligible })=>{
    const hasDismissed = (0, $c1MAf.useBacklogSelector)((0, $eoB0b.hasDismissedWhiteboardsEntrypoint));
    const hasDismissedBanner = (0, $c1MAf.useBacklogSelector)((0, $eoB0b.hasDismissedBanner));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const accountId = (0, $90yGq.useAccountId)();
    const dismiss = (0, $5uXOq.useCallback)(async (userPropertyKey)=>{
        try {
            const expirableStorage = (0, $eNf8a.createSessionExpirableStorageProvider)((0, $7IKPD.STORAGE_PROVIDER_PREFIX));
            expirableStorage.remove((0, $7IKPD.CACHE_KEYS).USER_PROPERTIES);
            dispatch((0, $5uBAa.setUserPropertyKey)(userPropertyKey));
            if (accountId) await (0, $89SaW.setUserProperties)(accountId, userPropertyKey, JSON.stringify(true));
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'whiteboards-set-user-property',
                    packageName: 'src/packages/software/backlog',
                    teamName: 'starburst'
                },
                attributes: {
                    key: userPropertyKey,
                    message: 'Unable to update user property for whtieboards backlog touchpoint',
                    statusCode: error instanceof (0, $jJZqs.default) ? error.statusCode : null,
                    traceId: error instanceof (0, $jJZqs.default) ? error.traceId : null
                }
            });
        }
        const clickedButtonBaseEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $8zOmE.fireUIAnalytics)(clickedButtonBaseEvent, 'notInterested', {
            crossJoinEligible: crossJoinEligible
        });
    }, [
        createAnalyticsEvent,
        crossJoinEligible,
        dispatch,
        accountId
    ]);
    return {
        hasDismissed: hasDismissed,
        hasDismissedBanner: hasDismissedBanner,
        dismiss: dismiss
    };
};

});

parcelRegister("37I5l", function(module, exports) {

$parcel$export(module.exports, "entryPoint", () => $9b5d615270991ff0$export$6333901e831d7af0);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $9b5d615270991ff0$export$6333901e831d7af0 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("hbKDV")), {
        moduleId: "08af5eaf"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("hbKDV", function(module, exports) {

let $c837a514568fd245$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c837a514568fd245$var$load("1uyXb").then(()=>parcelRequire('kaI5K'));

});



parcelRegister("2BEi6", function(module, exports) {

$parcel$export(module.exports, "useIsExperimentEligible", () => $1ad3e914e0b3a048$export$31f9aca3adff10f7);

var $6s1PB = parcelRequire("6s1PB");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4R6GH = parcelRequire("4R6GH");

var $7IKPD = parcelRequire("7IKPD");

var $4jqAD = parcelRequire("4jqAD");
const $1ad3e914e0b3a048$export$31f9aca3adff10f7 = (skipExposure)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const crossFlowEligible = (0, $4jqAD.useIsCrossFlowEligible)();
    const coUseEligible = (0, $4jqAD.useIsCoUseEligible)();
    const crossJoinEligible = (0, $4jqAD.useIsCrossJoinEligible)();
    let isVariantEligible = false;
    let cohort = (0, $7IKPD.NOT_ENROLLED);
    let flow = 'none';
    if (!skipExposure) {
        if (crossFlowEligible || coUseEligible) {
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'backlogButtonRefresh exposed');
            flow = crossFlowEligible ? 'crossFlow' : 'coUse';
            isVariantEligible = true;
        } else if (crossJoinEligible) {
            if ((0, $4R6GH.fg)('cc_virality_cross_join_whiteboard_conf_gate')) {
                cohort = (0, $6s1PB.expVal)('cc_virality_cross_join_whiteboard_touchpoint_conf', 'cohort', 'not-enrolled');
                if (cohort === (0, $7IKPD.VARIATION)) {
                    flow = 'crossJoin';
                    isVariantEligible = true;
                }
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'backlogButtonRefresh exposed', {
                    crossJoinEligible: crossJoinEligible,
                    cohort: cohort,
                    flow: flow,
                    isVariantEligible: isVariantEligible,
                    experiment: 'crossJoinFromWhiteboardTouchpointToConfluence'
                });
            }
        }
    }
    return {
        flow: flow,
        isVariantEligible: isVariantEligible
    };
};

});

parcelRegister("hG4Aw", function(module, exports) {

$parcel$export(module.exports, "Banner", () => $901bfdc2d976568e$export$3b4e64e77073e307);

var $5uXOq = parcelRequire("5uXOq");

var $bHpB9 = parcelRequire("bHpB9");

var $42CjB = parcelRequire("42CjB");

var $i28qQ = parcelRequire("i28qQ");

var $h5fUN = parcelRequire("h5fUN");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $3u0c5 = parcelRequire("3u0c5");

var $koVbs = parcelRequire("koVbs");

var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $7IKPD = parcelRequire("7IKPD");

var $4jqAD = parcelRequire("4jqAD");

var $crgSa = parcelRequire("crgSa");

var $3DKih = parcelRequire("3DKih");

var $j4a1R = parcelRequire("j4a1R");

var $eJMZH = parcelRequire("eJMZH");

var $2fTni = parcelRequire("2fTni");
const $901bfdc2d976568e$export$3b4e64e77073e307 = ({ isCreateSprintButtonVisible: isCreateSprintButtonVisible, flow: flow, hoverPulse: hoverPulse, setHoverPulse: setHoverPulse })=>{
    const crossFlowEligible = flow === 'crossFlow';
    const crossJoinEligible = flow === 'crossJoin';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const crossflow = (0, $bHpB9.useCrossFlow)();
    const threeIssues = (0, $4jqAD.useIsBacklogCardListSizeGreaterThanTwo)();
    const { hasDismissed: hasDismissed, hasDismissedBanner: hasDismissedBanner, dismiss: dismiss } = (0, $eJMZH.useAdControls)({
        crossJoinEligible: crossJoinEligible
    });
    const projectName = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getProjectName));
    const projectId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.projectIdSelector));
    const onClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'planOnWhiteboardBanner', {
            crossJoinEligible: crossJoinEligible
        });
        (0, $3DKih.onClickCTA)({
            createAnalyticsEvent: createAnalyticsEvent,
            crossFlowEligible: crossFlowEligible,
            crossflow: crossflow,
            projectId: projectId,
            projectName: projectName,
            component: (0, $7IKPD.CTA_SOURCE_COMPONENT),
            context: (0, $7IKPD.CTA_SOURCE_CONTEXT),
            coUseEligible: false,
            crossJoinEligible: crossJoinEligible,
            url: ''
        });
    }, [
        createAnalyticsEvent,
        crossFlowEligible,
        crossflow,
        projectId,
        projectName,
        crossJoinEligible
    ]);
    const onMouseEnter = (0, $5uXOq.useCallback)(()=>{
        setHoverPulse(true);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'hovered',
            actionSubject: 'banner'
        }), 'planOnWhiteboardBanner', {
            crossJoinEligible: crossJoinEligible
        });
    }, [
        setHoverPulse,
        createAnalyticsEvent,
        crossJoinEligible
    ]);
    const onMouseLeave = (0, $5uXOq.useCallback)(()=>{
        setHoverPulse(false);
    }, [
        setHoverPulse
    ]);
    const handleDismissEntrypoint = (0, $5uXOq.useCallback)(async ()=>{
        await dismiss((0, $7IKPD.USER_PROPERTY_KEY_NAMES).WHITEBOARDS_BACKLOG_ENTRYPOINT_DISMISSED);
    }, [
        dismiss
    ]);
    const handleDismissBanner = (0, $5uXOq.useCallback)(async ()=>{
        await dismiss((0, $7IKPD.USER_PROPERTY_KEY_NAMES).BANNER_DISMISSED);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'dismissWhiteboardBanner', {
            crossJoinEligible: crossJoinEligible
        });
    }, [
        dismiss,
        createAnalyticsEvent,
        crossJoinEligible
    ]);
    if (!(crossFlowEligible || crossJoinEligible) || !threeIssues || hasDismissed || hasDismissedBanner) return null;
    const bannerMessage = crossJoinEligible ? formatMessage((0, $crgSa.default).bannerForCrossJoinUsers) : formatMessage((0, $crgSa.default).banner);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $901bfdc2d976568e$var$outterContainer,
        id: (0, $7IKPD.ELEMENT_IDS).BANNER
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        onClick: onClick,
        xcss: $901bfdc2d976568e$var$container,
        testId: "software-backlog.whiteboards-entrypoint-experiment.backlog-button-refresh.banner",
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.150",
        alignBlock: "center",
        xcss: $901bfdc2d976568e$var$content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $901bfdc2d976568e$var$icon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h5fUN))), {
        label: formatMessage((0, $crgSa.default).bannerIcon),
        color: "var(--ds-icon-accent-purple, #8270DB)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, bannerMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
        appearance: "new"
    }, formatMessage((0, $crgSa.default).planOnWhiteboardTry)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100",
        alignBlock: "center",
        xcss: $901bfdc2d976568e$var$buttons
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j4a1R.AdControls), {
        isCta: false,
        onDismissAd: handleDismissEntrypoint,
        crossJoinEligible: crossJoinEligible
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        onClick: handleDismissBanner,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($i28qQ))),
        label: formatMessage((0, $crgSa.default).bannerDismiss),
        appearance: "subtle"
    })), hoverPulse && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2fTni.Arrow), {
        fromElementId: (0, $7IKPD.ELEMENT_IDS).BANNER,
        toElementId: (0, $7IKPD.ELEMENT_IDS).TOUCHPOINT,
        fromCenter: !isCreateSprintButtonVisible,
        color: "var(--ds-text, #172B4D)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            crossJoinEligible: crossJoinEligible
        }
    }));
};
const $901bfdc2d976568e$var$outterContainer = (0, $8CUq3.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingLeft: 'space.075',
    paddingRight: 'space.150',
    height: '40px',
    width: '100%',
    position: 'relative',
    borderTop: `1px solid ${"var(--ds-border, #091E4224)"}`,
    borderRight: `1px solid ${"var(--ds-border, #091E4224)"}`,
    borderLeft: `1px solid ${"var(--ds-border, #091E4224)"}`,
    backgroundColor: 'color.background.input.pressed',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    }
});
const $901bfdc2d976568e$var$container = (0, $8CUq3.xcss)({
    display: 'flex',
    paddingLeft: 'space.150',
    paddingRight: 'space.050',
    alignItems: 'center',
    flex: '1 0 0',
    alignSelf: 'stretch',
    ':hover': {
        cursor: 'pointer'
    }
});
const $901bfdc2d976568e$var$icon = (0, $8CUq3.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '24px',
    width: '24px',
    backgroundColor: 'color.background.accent.purple.subtlest',
    borderRadius: '4px'
});
const $901bfdc2d976568e$var$content = (0, $8CUq3.xcss)({
    display: 'flex',
    flex: '1 0 0'
});
const $901bfdc2d976568e$var$buttons = (0, $8CUq3.xcss)({
    display: 'flex'
});

});
parcelRegister("2fTni", function(module, exports) {

$parcel$export(module.exports, "Arrow", () => $b730b2d04ae96a50$export$21b07c8f274aebd5);
/* arrow.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $b730b2d04ae96a50$var$FROM_X_OFFSET = 55;
const $b730b2d04ae96a50$var$FROM_X_CENTER_OFFSET = 130;
const $b730b2d04ae96a50$var$FROM_Y_OFFSET = 5;
const $b730b2d04ae96a50$var$CONTROL_X_OFFSET = 10;
const $b730b2d04ae96a50$var$CONTROL_X_CENTER_OFFSET = -12;
const $b730b2d04ae96a50$var$CONTROL_Y_OFFSET = 20;
const $b730b2d04ae96a50$var$TO_Y_TOP_OFFSET = 10;
const $b730b2d04ae96a50$var$TO_Y_BOTTOM_OFFSET = 10;
const $b730b2d04ae96a50$var$ARROW_ANGLE = Math.PI / 4;
const $b730b2d04ae96a50$var$ARROW_LENGTH = 8;
const $b730b2d04ae96a50$export$21b07c8f274aebd5 = ({ fromCenter: fromCenter, fromElementId: fromElementId, toElementId: toElementId, strokeWidth: strokeWidth = 2, color: color = 'white' })=>{
    const [svgPosition, setSvgPosition] = (0, $5uXOq.useState)({
        left: 0,
        top: 0,
        width: 0,
        height: 0,
        path: ''
    });
    const calculatePath = (0, $5uXOq.useCallback)(()=>{
        const fromElement = globalThis.document.getElementById(fromElementId);
        const toElement = globalThis.document.getElementById(toElementId);
        const parentElement = fromElement?.offsetParent;
        if (!fromElement || !toElement || !parentElement) return;
        const fromRect = fromElement.getBoundingClientRect();
        const toRect = toElement.getBoundingClientRect();
        const parentRect = parentElement.getBoundingClientRect();
        // Calculate the positions relative to the parent container
        const fromX = (fromCenter ? toRect.left - $b730b2d04ae96a50$var$FROM_X_CENTER_OFFSET : toRect.left - $b730b2d04ae96a50$var$FROM_X_OFFSET) - parentRect.left;
        const fromY = fromRect.top + (fromRect.height / 2 + $b730b2d04ae96a50$var$FROM_Y_OFFSET) - parentRect.top;
        const toX = fromX + $b730b2d04ae96a50$var$FROM_X_OFFSET + 5;
        const toY = Math.max(toRect.bottom - $b730b2d04ae96a50$var$TO_Y_BOTTOM_OFFSET, fromRect.top + $b730b2d04ae96a50$var$TO_Y_TOP_OFFSET) - parentRect.top;
        const midX = (fromX + toX) / 2;
        const midY = (fromY + toY) / 2;
        // Offset the midpoint vertically to create an elliptical arc
        const controlX = fromCenter ? midX + $b730b2d04ae96a50$var$CONTROL_X_CENTER_OFFSET : midX + $b730b2d04ae96a50$var$CONTROL_X_OFFSET;
        const controlY = midY + $b730b2d04ae96a50$var$CONTROL_Y_OFFSET;
        const dx = toX - controlX;
        const dy = toY - controlY;
        const angle = Math.atan2(dy, dx);
        const arrowPoint1X = toX - $b730b2d04ae96a50$var$ARROW_LENGTH * Math.cos(angle - $b730b2d04ae96a50$var$ARROW_ANGLE);
        const arrowPoint1Y = toY - $b730b2d04ae96a50$var$ARROW_LENGTH * Math.sin(angle - $b730b2d04ae96a50$var$ARROW_ANGLE);
        const arrowPoint2X = toX - $b730b2d04ae96a50$var$ARROW_LENGTH * Math.cos(angle + $b730b2d04ae96a50$var$ARROW_ANGLE);
        const arrowPoint2Y = toY - $b730b2d04ae96a50$var$ARROW_LENGTH * Math.sin(angle + $b730b2d04ae96a50$var$ARROW_ANGLE);
        const path = `
			M ${fromX} ${fromY}
			Q ${controlX} ${controlY}, ${toX} ${toY}
			M ${toX} ${toY}
			L ${arrowPoint1X} ${arrowPoint1Y}
			M ${toX} ${toY}
			L ${arrowPoint2X} ${arrowPoint2Y}
		`;
        const minX = Math.min(fromX, toX) - $b730b2d04ae96a50$var$ARROW_LENGTH;
        const minY = Math.min(fromY, toY) - $b730b2d04ae96a50$var$ARROW_LENGTH;
        const maxX = Math.max(fromX, toX) + $b730b2d04ae96a50$var$ARROW_LENGTH;
        const maxY = Math.max(fromY, toY) + $b730b2d04ae96a50$var$ARROW_LENGTH;
        setSvgPosition({
            left: minX,
            top: Math.min(minY, fromY),
            width: maxX - minX,
            height: maxY - minY,
            path: path
        });
    }, [
        fromElementId,
        toElementId,
        fromCenter
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const updateArrow = ()=>{
            requestAnimationFrame(calculatePath);
        };
        updateArrow();
        globalThis.window.addEventListener('resize', updateArrow);
        return ()=>{
            globalThis.window.removeEventListener('resize', updateArrow);
        };
    }, [
        fromElementId,
        toElementId,
        calculatePath
    ]);
    return /*#__PURE__*/ $5uXOq.createElement("svg", {
        width: svgPosition.width,
        height: svgPosition.height,
        viewBox: `0 0 ${svgPosition.width} ${svgPosition.height}`,
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            left: svgPosition.left,
            top: svgPosition.top
        },
        className: (0, $bwpsq.default)([
            "_1pbykb7n _kqswstnw _lcxvglyw"
        ])
    }, /*#__PURE__*/ $5uXOq.createElement("path", {
        d: svgPosition.path,
        stroke: color,
        strokeWidth: strokeWidth,
        fill: "none",
        transform: `translate(${-svgPosition.left}, ${-svgPosition.top})`
    }));
};
const $b730b2d04ae96a50$var$styles = null;

});



parcelRegister("kARaY", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbd299d884dfbf90$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $5nRKm = parcelRequire("5nRKm");

var $avBcG = parcelRequire("avBcG");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $iKdRC = parcelRequire("iKdRC");

var $93II4 = parcelRequire("93II4");

var $6bzbn = parcelRequire("6bzbn");
const $dbd299d884dfbf90$var$ADD_SPRINT_DATES_BUTTON_ICON_SELECTOR = 'software-backlog-add-sprint-dates-button-icon';
const $dbd299d884dfbf90$var$AddSprintDates = ({ cardListId: cardListId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isEditSprintModalOpen, setIsEditSprintModalOpen] = (0, $5uXOq.useState)(false);
    const onEditSprintClick = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        event.stopPropagation();
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'openAddSprintDates');
        setIsEditSprintModalOpen(true);
    }, []);
    const onEditSprintModalCloseClick = (0, $5uXOq.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'closeAddSprintDates');
        setIsEditSprintModalOpen(false);
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isEditSprintModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $93II4.default), {
        cardListId: cardListId,
        onClose: onEditSprintModalCloseClick,
        onSubmit: onEditSprintModalCloseClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dbd299d884dfbf90$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iKdRC.ModalTriggerButton), {
        appearance: "subtle",
        spacing: "compact",
        onClick: onEditSprintClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dbd299d884dfbf90$var$ButtonContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dbd299d884dfbf90$var$ButtonIcon, {
        "data-component-selector": $dbd299d884dfbf90$var$ADD_SPRINT_DATES_BUTTON_ICON_SELECTOR
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5nRKm))), {
        label: "",
        color: "var(--ds-icon, #44546F)",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($avBcG))),
        LEGACY_size: "small",
        LEGACY_primaryColor: "var(--ds-icon, #44546F)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dbd299d884dfbf90$var$ButtonText, null, formatMessage((0, $6bzbn.default).addSprintDates))))));
};
var $dbd299d884dfbf90$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $dbd299d884dfbf90$var$AddSprintDates;
const $dbd299d884dfbf90$var$ButtonText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dbd299d884dfbf90$var$ButtonIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _4t3i7vkz _2hwxv77o",
            __cmplp.className
        ])
    });
});
const $dbd299d884dfbf90$var$ButtonContentContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _4djwglyw",
            __cmplp.className
        ])
    });
});
const $dbd299d884dfbf90$var$ButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _1gflze3t _yhjmv77o _1gqnze3t _11lvv77o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5nRKm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ce3559d453dff44735097f553c900f9f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3eb8cab3ab465b93$var$_react = $3eb8cab3ab465b93$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3eb8cab3ab465b93$var$_baseNew = $3eb8cab3ab465b93$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3eb8cab3ab465b93$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3eb8cab3ab465b93$var$EditIcon = (props)=>/*#__PURE__*/ $3eb8cab3ab465b93$var$_react.default.createElement($3eb8cab3ab465b93$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.707zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.217l-.54 1.89 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-3H15v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$3eb8cab3ab465b93$var$EditIcon.displayName = 'EditIcon';
var $3eb8cab3ab465b93$var$_default = module.exports.default = $3eb8cab3ab465b93$var$EditIcon;

});

parcelRegister("avBcG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7a69a877f42e31b8$var$_react = $7a69a877f42e31b8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $7a69a877f42e31b8$var$_edit = $7a69a877f42e31b8$var$_interopRequireDefault((parcelRequire("5nRKm")));
function $7a69a877f42e31b8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7a69a877f42e31b8$var$EditFilledIcon = (props)=>/*#__PURE__*/ $7a69a877f42e31b8$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zM19.84 6.71l-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $7a69a877f42e31b8$var$_edit.default
    }));
$7a69a877f42e31b8$var$EditFilledIcon.displayName = 'EditFilledIcon';
var $7a69a877f42e31b8$var$_default = module.exports.default = $7a69a877f42e31b8$var$EditFilledIcon;

});

parcelRegister("93II4", function(module, exports) {

$parcel$export(module.exports, "default", () => $660b345bfa093b4f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dXq4S = parcelRequire("dXq4S");

var $2WlZM = parcelRequire("2WlZM");

var $3psiG = parcelRequire("3psiG");

var $koeKL = parcelRequire("koeKL");

var $ksKI7 = parcelRequire("ksKI7");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $fSgHa = parcelRequire("fSgHa");
const $660b345bfa093b4f$var$EditSprintModalRelay = (props)=>{
    const { cardListId: cardListId, ...rest } = props;
    const boardId = (0, $c1MAf.useBacklogSelector)((state)=>Number((0, $jG5HW.getRapidViewId)(state)));
    const cloudId = (0, $koeKL.useCloudId)();
    const isCompanyManaged = (0, $fSgHa.useIsCMPBacklog)();
    const [queryReference, loadQuery] = (0, $8Uumt.useQueryLoader)((0, $2WlZM.default));
    const boardAri = (0, $5uXOq.useMemo)(()=>(0, $dXq4S.createAri)({
            resourceOwner: 'jira-software',
            cloudId: cloudId,
            resourceType: 'board',
            resourceId: String(boardId)
        }), [
        boardId,
        cloudId
    ]);
    const sprintAri = (0, $5uXOq.useMemo)(()=>(0, $dXq4S.createAri)({
            resourceOwner: 'jira-software',
            cloudId: cloudId,
            resourceType: 'sprint',
            resourceId: String(cardListId)
        }), [
        cloudId,
        cardListId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        loadQuery({
            boardId: boardAri,
            sprintId: sprintAri,
            fetchSprints: false
        }, {
            fetchPolicy: 'network-only'
        });
    }, [
        boardAri,
        loadQuery,
        sprintAri
    ]);
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const onSubmit = (data, submitPromise)=>{
        props.onSubmit(data, submitPromise);
        const { name: name, goal: goal, startDate: startDate, endDate: endDate } = data;
        const action = (0, $ksKI7.editSprintRequest)(cardListId, name, goal, startDate, endDate);
        const { meta: { optimistic: { id: optimisticId } } } = action;
        dispatch(action);
        submitPromise.then(()=>{
            dispatch((0, $ksKI7.editSprintSuccess)(optimisticId));
        }).catch(()=>{
            dispatch((0, $ksKI7.editSprintFailure)(optimisticId));
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3psiG.default), {
        ...rest,
        onSubmit: onSubmit,
        boardAri: boardAri,
        queryReference: queryReference,
        isCompanyManaged: isCompanyManaged
    });
};
var $660b345bfa093b4f$export$2e2bcd8739ae039 = $660b345bfa093b4f$var$EditSprintModalRelay;

});
parcelRegister("2WlZM", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff98ac7fe1a83638$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<deb8dc548bac2381f539e8316cad3232>>
 * @relayHash a7c5c4d6570548dfbbb896009ae5fc47
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 90bffcc09f8865bee8f7861946866baaa79e714bb9afc19568bc71a86050977b

var $eiowN = parcelRequire("eiowN");
const $ff98ac7fe1a83638$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "boardId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fetchSprints"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sprintId"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "sprintId",
            "variableName": "sprintId"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "goal"
    }, v8 = {
        "kind": "ScalarField",
        "name": "startDate"
    }, v9 = {
        "kind": "ScalarField",
        "name": "endDate"
    }, v10 = {
        "kind": "ScalarField",
        "name": "sprintState"
    }, v11 = [
        v5 /*: any*/ ,
        v6 /*: any*/ ,
        v7 /*: any*/ ,
        v8 /*: any*/ ,
        v9 /*: any*/ ,
        v10 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "uiJiraSoftwareEditSprintModalQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v3 /*: any*/ ,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "Sprint",
                                    "kind": "LinkedField",
                                    "name": "sprint",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "RequiredField",
                                            "field": v6 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.sprint.name"
                                        },
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "RequiredField",
                                            "field": v10 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.sprint.sprintState"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.sprint"
                            },
                            {
                                "condition": "fetchSprints",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "concreteType": "Sprint",
                                        "kind": "LinkedField",
                                        "name": "sprints",
                                        "plural": true,
                                        "selections": [
                                            v5 /*: any*/ ,
                                            {
                                                "kind": "RequiredField",
                                                "field": v6 /*: any*/ ,
                                                "action": "THROW",
                                                "path": "boardScope.sprints.name"
                                            },
                                            v7 /*: any*/ ,
                                            v8 /*: any*/ ,
                                            v9 /*: any*/ ,
                                            {
                                                "kind": "RequiredField",
                                                "field": v10 /*: any*/ ,
                                                "action": "THROW",
                                                "path": "boardScope.sprints.sprintState"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "boardScope"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "uiJiraSoftwareEditSprintModalQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "Sprint",
                            "kind": "LinkedField",
                            "name": "sprint",
                            "plural": false,
                            "selections": v11 /*: any*/ 
                        },
                        {
                            "condition": "fetchSprints",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "Sprint",
                                    "kind": "LinkedField",
                                    "name": "sprints",
                                    "plural": true,
                                    "selections": v11 /*: any*/ 
                                }
                            ]
                        },
                        v5 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "90bffcc09f8865bee8f7861946866baaa79e714bb9afc19568bc71a86050977b",
            "metadata": {},
            "name": "uiJiraSoftwareEditSprintModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ff98ac7fe1a83638$var$node.hash = "c7b9c1c33647526da24d1f5d937ea327";
(0, $eiowN.PreloadableQueryRegistry).set($ff98ac7fe1a83638$var$node.params.id, $ff98ac7fe1a83638$var$node);
var $ff98ac7fe1a83638$export$2e2bcd8739ae039 = $ff98ac7fe1a83638$var$node;

});

parcelRegister("3psiG", function(module, exports) {

$parcel$export(module.exports, "default", () => $58a40ac7c61cb3ec$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gjEtj = parcelRequire("gjEtj");

var $lfTZh = parcelRequire("lfTZh");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $kxZPA = parcelRequire("kxZPA");

var $cYsq9 = parcelRequire("cYsq9");

const $58a40ac7c61cb3ec$var$LazyEditSprintModal = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("luYgm")), {
    moduleId: "./src/packages/software/edit-sprint-modal-relay/src/index.tsx"
});
const $58a40ac7c61cb3ec$var$EditSprintModal = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onError = ()=>{
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskFail', {
            isRelay: true,
            task: 'loadEditSprintModal'
        });
        (0, $cYsq9.editSprintModalLoad).cancel();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjEtj.ModalBoundary), {
        id: "edit-sprint-modal",
        packageName: "editSprintModalRelay",
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "edit-sprint-modal-relay",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($58a40ac7c61cb3ec$var$LazyEditSprintModal, props)));
};
var $58a40ac7c61cb3ec$export$2e2bcd8739ae039 = $58a40ac7c61cb3ec$var$EditSprintModal;

});
parcelRegister("cYsq9", function(module, exports) {

$parcel$export(module.exports, "clickEditSprintInteraction", () => $c290b89d2730547b$export$9c57106ef5795d9a);
$parcel$export(module.exports, "editSprintModalLoad", () => $c290b89d2730547b$export$c39d6b5415c8a491);

var $dGrdR = parcelRequire("dGrdR");
const $c290b89d2730547b$export$9c57106ef5795d9a = (0, $dGrdR.metrics).interaction({
    key: 'sprint-edit-click'
});
const $c290b89d2730547b$export$c39d6b5415c8a491 = (0, $dGrdR.metrics).interaction({
    key: 'edit-sprint-modal-load'
});

});

parcelRegister("luYgm", function(module, exports) {

let $fa6b254269b8ccfb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fa6b254269b8ccfb$var$load("gQovc").then(()=>parcelRequire('3emwb'));

});



parcelRegister("6bzbn", function(module, exports) {

$parcel$export(module.exports, "default", () => $99f26848a4b108c2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $99f26848a4b108c2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    backlogListName: {
        "id": "backlog.card-list.backlog-list-name",
        "defaultMessage": "Backlog"
    },
    boardListName: {
        "id": "backlog.card-list.board-list-name",
        "defaultMessage": "Board"
    },
    cardAmount: {
        "id": "backlog.card-list.card-amount",
        "defaultMessage": "{cardAmount} {cardAmount, plural, one {issue} other {issues}}"
    },
    visibleCardAmount: {
        "id": "backlog.card-list.visible-card-amount",
        "defaultMessage": "{cardAmount} of {totalCardAmount} {totalCardAmount, plural, one {issue} other {issues}} visible"
    },
    emptyListFiltered: {
        "id": "backlog.card-list.empty-list-filtered",
        "defaultMessage": "There are no issues that match your current filter."
    },
    emptyBoard: {
        "id": "backlog.card-list.empty-board",
        "defaultMessage": "There are no issues on the board."
    },
    emptyBacklog: {
        "id": "backlog.card-list.empty-backlog",
        "defaultMessage": "Your backlog is empty."
    },
    emptyNotStartedSprint: {
        "id": "backlog.card-list.empty-not-started-sprint",
        "defaultMessage": "Plan a sprint by dragging the sprint footer down below some issues, or by dragging issues here."
    },
    emptyStartedSprint: {
        "id": "backlog.card-list.empty-started-sprint",
        "defaultMessage": "There are no issues in this sprint."
    },
    startSprint: {
        "id": "backlog.card-list.start-sprint",
        "defaultMessage": "Start sprint"
    },
    createSprint: {
        "id": "backlog.card-list.create-sprint",
        "defaultMessage": "Create sprint"
    },
    completeSprint: {
        "id": "backlog.card-list.complete-sprint",
        "defaultMessage": "Complete sprint"
    },
    addSprintDates: {
        "id": "backlog.card-list.add-sprint-dates",
        "defaultMessage": "Add dates"
    },
    disabledStartSprintButtonEmpty: {
        "id": "backlog.card-list.disabled-start-sprint-button-empty",
        "defaultMessage": "Sprint cannot be started because it contains no issues"
    },
    disabledStartSprintButtonNoParallel: {
        "id": "backlog.card-list.disabled-start-sprint-button-no-parallel",
        "defaultMessage": "Can be planned but not started until the completion of above active sprint"
    },
    createdSprintAriaLive: {
        "id": "backlog.card-list.created-sprint-aria-live",
        "defaultMessage": "{sprintName} created"
    },
    inlineCardCreateAriaLabel: {
        "id": "backlog.card-list.inline-card-create-aria-label",
        "defaultMessage": "Create issue for {sprintName}"
    },
    sprintListNamePrefix: {
        "id": "backlog.card-list.sprint-list-name-prefix",
        "defaultMessage": "sprint"
    },
    emptyListFilteredIssueTermRefresh: {
        "id": "backlog.card-list.empty-list-filtered-issue-term-refresh",
        "defaultMessage": "There's nothing that matches this filter"
    },
    emptyBoardIssueTermRefresh: {
        "id": "backlog.card-list.empty-board-issue-term-refresh",
        "defaultMessage": "There's nothing on this board"
    },
    emptyNotStartedSprintIssueTermRefresh: {
        "id": "backlog.card-list.empty-not-started-sprint-issue-term-refresh",
        "defaultMessage": "Plan a sprint by dragging work items into it, or by dragging the sprint footer."
    },
    emptyStartedSprintIssueTermRefresh: {
        "id": "backlog.card-list.empty-started-sprint-issue-term-refresh",
        "defaultMessage": "There's nothing in this sprint"
    },
    disabledStartSprintButtonEmptyIssueTermRefresh: {
        "id": "backlog.card-list.disabled-start-sprint-button-empty-issue-term-refresh",
        "defaultMessage": "The sprint can't be started because it contains no work items"
    },
    inlineCardCreateAriaLabelIssueTermRefresh: {
        "id": "backlog.card-list.inline-card-create-aria-label-issue-term-refresh",
        "defaultMessage": "Create work items for {sprintName}"
    },
    visibleCardAmountIssueTermRefresh: {
        "id": "backlog.card-list.visible-card-amount-issue-term-refresh",
        "defaultMessage": "{cardAmount} of {totalCardAmount} {totalCardAmount, plural, one {work item} other {work items}} visible"
    },
    cardAmountIssueTermRefresh: {
        "id": "backlog.card-list.card-amount-issue-term-refresh",
        "defaultMessage": "{cardAmount} {cardAmount, plural, one {work item} other {work items}}"
    }
});

});


parcelRegister("b7YUC", function(module, exports) {

$parcel$export(module.exports, "default", () => $79841489a061bb4b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kLOCW = parcelRequire("kLOCW");

var $iuO0E = parcelRequire("iuO0E");

var $3mWFd = parcelRequire("3mWFd");
const $79841489a061bb4b$var$CardContainer = /*#__PURE__*/ (0, $5uXOq.memo)(({ cardListId: cardListId, cardId: cardId, isScrolling: isScrolling, isVisible: isVisible, isAttachedToParent: isAttachedToParent, forciblyRenderRichCard: forciblyRenderRichCard, setRichActiveCard: setRichActiveCard })=>{
    const renderFullCard = (0, $3mWFd.useRenderFullItem)({
        isVisible: isVisible,
        isScrolling: isScrolling
    });
    if (!renderFullCard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kLOCW.default), {
        id: typeof cardId === 'string' ? parseInt(cardId, 10) : cardId,
        key: cardId,
        cardListId: cardListId,
        isAttachedToParent: isAttachedToParent
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iuO0E.default), {
        key: cardId,
        cardId: cardId,
        cardListId: cardListId,
        isAttachedToParent: isAttachedToParent,
        forciblyRenderRichCard: forciblyRenderRichCard,
        setRichActiveCard: setRichActiveCard
    });
});
var $79841489a061bb4b$export$2e2bcd8739ae039 = $79841489a061bb4b$var$CardContainer;

});
parcelRegister("kLOCW", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8e7fdcc1d4ad227$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gccSB = parcelRequire("gccSB");

var $6Ingq = parcelRequire("6Ingq");

var $ebd3R = parcelRequire("ebd3R");

var $hORKG = parcelRequire("hORKG");

var $3dGN0 = parcelRequire("3dGN0");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $gwIPs = parcelRequire("gwIPs");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $fE0Ry = parcelRequire("fE0Ry");

var $g4tDr = parcelRequire("g4tDr");

var $iDGXn = parcelRequire("iDGXn");

var $dCm1o = parcelRequire("dCm1o");

var $2lpqS = parcelRequire("2lpqS");

var $f6RVN = parcelRequire("f6RVN");

var $c1MAf = parcelRequire("c1MAf");

var $ld0jI = parcelRequire("ld0jI");

var $dGljH = parcelRequire("dGljH");

var $fSgHa = parcelRequire("fSgHa");

var $3VzmQ = parcelRequire("3VzmQ");

var $ekU0X = parcelRequire("ekU0X");

var $g1Kbb = parcelRequire("g1Kbb");

var $hCPhj = parcelRequire("hCPhj");


var $7q84v = parcelRequire("7q84v");

var $kM28N = parcelRequire("kM28N");

var $khnfQ = parcelRequire("khnfQ");

var $3JQPC = parcelRequire("3JQPC");

var $4w5xH = parcelRequire("4w5xH");

var $1OiOR = parcelRequire("1OiOR");

var $46Lnx = parcelRequire("46Lnx");

var $dzwJA = parcelRequire("dzwJA");

var $MdcUe = parcelRequire("MdcUe");

var $5GU7f = parcelRequire("5GU7f");

var $7eYN2 = parcelRequire("7eYN2");

var $gQmIm = parcelRequire("gQmIm");

var $epPSJ = parcelRequire("epPSJ");
const $a8e7fdcc1d4ad227$var$CardLiteExtended = ({ style: style = {}, id: id, cardListId: cardListId, isAttachedToParent: isAttachedToParent = false })=>{
    const cards = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCards));
    const card = cards[String(id)] || {};
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { key: cardKey, summary: cardSummary, icon: icon, isDone: isDone, isFlagged: isFlagged, extraFields: extraFields, typeHierarchyLevel: typeHierarchyLevel, parentKey: parentKey } = card; // TODO: Collect these at a higher level and pass them down
    const shouldRenderPriorityColumn = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasPriority));
    const shouldRenderEstimatesColumn = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasEstimates));
    const shouldRenderInlineAddFlag = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasFlaggedCards));
    const orderedVersions = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getOrderedVersions));
    const viewSettings = (0, $f6RVN.isViewSettingAsPanelExpEnabledWithNoExposure)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $iDGXn.useCardFieldsSettings)() : {
        showIssueType: true,
        showIssueKey: true,
        showPriority: true,
        showAssignee: true,
        showEstimate: true,
        showDueDate: true,
        cardExtraFields: undefined
    };
    const cardGroup = (0, $c1MAf.useBacklogSelector)((0, $ld0jI.makeGetCardGroupByParentId))(cardListId, id);
    const isCardGroupExpanded = (0, $c1MAf.useBacklogSelector)((0, $dGljH.makeGetCardGroupExpanded))(id);
    const subtaskIds = cardGroup && cardGroup.cardIds;
    const hasLinkedSubtasks = subtaskIds !== undefined && subtaskIds.length > 0;
    const isSelected = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.isCardSelected)(state)(id));
    const shouldShowChevron = hasLinkedSubtasks;
    const isSubtask = (0, $g4tDr.isSubtaskHierarchyLevel)(typeHierarchyLevel);
    const hasExtraFields = extraFields ? extraFields?.length > 0 : false;
    const isCompanyManagedKanban = (0, $fSgHa.useIsCMPKanbanBacklog)();
    const isCompanyManaged = (0, $fSgHa.useIsCMPBacklog)();
    const { size: backlogContainerSize } = (0, $3JQPC.useContainerSize)();
    const shouldShowCheckbox = (0, $3VzmQ.useShowCheckbox)();
    const showCompactMode = (0, $iDGXn.useShowCompactMode)();
    const isCompactView = backlogContainerSize === (0, $khnfQ.ScreenSize).EXTRA_SMALL;
    const renderParentKey = ()=>{
        const parentKeyText = parentKey !== undefined ? formatMessage((0, $7q84v.default).parentKeyText, {
            parentKey: parentKey
        }) : '';
        return parentKey !== undefined && isSubtask && !isAttachedToParent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.CardGroupKey), null, `${parentKeyText}`) : null;
    };
    const renderCardColor = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ekU0X.CardColor), {
            id: card.id
        });
    const showCardExtraFieldsColumnBasedOnViewSettings = (0, $f6RVN.isViewSettingAsPanelExpEnabledWithNoExposure)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $iDGXn.useHasCardExtraFields)() : true;
    const renderExtraFields = ()=>hasExtraFields && extraFields && showCardExtraFieldsColumnBasedOnViewSettings && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.ExtraFieldsContainer), {
            isSmartCardEnabled: (0, $6s1PB.expValEquals)('jsw_perf_format-links-in-custom-fields', 'board-and-backlog', true),
            isAttachedToParent: isAttachedToParent && isCompanyManaged
        }, extraFields.filter((field)=>viewSettings.cardExtraFields?.[field.id] ?? true).map((field, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
                key: field.id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g1Kbb.CardExtraField), {
                field: field
            }), index < extraFields?.length - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCPhj.FieldSeparator), {
                "aria-hidden": "true",
                key: `${field.id}-separator`
            }, "\u2022"))));
    const getCheckboxContainerMargin = (shouldAddMargin)=>{
        if (shouldAddMargin && isAttachedToParent) return 'space.500';
        if (shouldAddMargin) return 'space.300';
        return 'space.0';
    };
    const getChevronIcon = ()=>isCardGroupExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hORKG))), {
            label: "",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($6Ingq))),
            color: "var(--ds-icon, #44546F)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3dGN0))), {
            label: "",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($ebd3R))),
            color: "var(--ds-icon, #44546F)"
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a8e7fdcc1d4ad227$var$Container // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    , {
        style: style,
        hasExtraFields: hasExtraFields,
        isCompact: showCompactMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ekU0X.CardColor), {
        id: id
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.CardContainer), {
        isCompanyManagedKanban: isCompanyManagedKanban,
        isCompact: showCompactMode,
        shouldShowChevron: shouldShowChevron,
        isFlagged: isFlagged,
        isDraggable: false,
        isDragHandle: false,
        hasExtraFields: hasExtraFields,
        lowerOpacity: false,
        isSelected: isSelected,
        hideTypeIcon: !viewSettings.showIssueType,
        isAssigneeShown: viewSettings.showAssignee,
        "data-component-selector": (0, $f836df2846e6254b$export$fb374ae0d58ab29b),
        isVisualRefreshBeta: (0, $dCm1o.isVisualRefreshEnabled)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    ), {
        xcss: (0, $8CUq3.xcss)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginRight: getCheckboxContainerMargin(isCompanyManaged && !shouldShowChevron)
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.CheckboxContainer), {
        shouldShowCheckbox: shouldShowCheckbox
    })), renderCardColor(), hasLinkedSubtasks && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a8e7fdcc1d4ad227$var$IconWrapper, null, getChevronIcon()), viewSettings.showIssueType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.ImageContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a8e7fdcc1d4ad227$var$Icon, {
        src: icon
    })), viewSettings.showIssueKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.KeyContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a8e7fdcc1d4ad227$var$Key, {
        done: isDone,
        cardKey: cardKey
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.SummaryAndParentContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a8e7fdcc1d4ad227$var$Summary, {
        cardSummary: cardSummary
    })), renderParentKey(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.OptionalFieldsContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $epPSJ.Versions), {
        card: card,
        isCompanyManaged: isCompanyManaged,
        backlogContainerSize: backlogContainerSize,
        isCardListContainsVersion: !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(orderedVersions)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $46Lnx.EpicLiteWrapper), {
        card: card,
        backlogContainerSize: backlogContainerSize,
        isCompactView: isCompactView,
        isSubtask: isSubtask
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7eYN2.Status), {
        cardKey: cardKey,
        backlogContainerSize: backlogContainerSize
    }), viewSettings.showDueDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1OiOR.DueDate), {
        dueDate: card?.dueDate,
        isDone: isDone
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MdcUe.Flag), {
        isFlagged: isFlagged,
        shouldRenderInlineAddFlag: shouldRenderInlineAddFlag
    }), viewSettings.showEstimate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dzwJA.EstimateLite), {
        shouldRenderEstimatesColumn: shouldRenderEstimatesColumn
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gQmIm.StoryPointLite), {
        issue: card
    })), viewSettings.showPriority && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5GU7f.PriorityLite), {
        shouldRenderPriorityColumn: shouldRenderPriorityColumn,
        issueKey: cardKey
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.AssigneeContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fE0Ry.AvatarWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4w5xH.AssigneeLite), {
        issueKey: cardKey
    }))), renderExtraFields()));
};
const $a8e7fdcc1d4ad227$var$CardLiteExtendedMemo = /*#__PURE__*/ (0, $5uXOq.memo)($a8e7fdcc1d4ad227$var$CardLiteExtended);
var $a8e7fdcc1d4ad227$export$2e2bcd8739ae039 = $a8e7fdcc1d4ad227$var$CardLiteExtendedMemo;
const $a8e7fdcc1d4ad227$var$Summary = ({ cardSummary: cardSummary })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div" // eslint-disable-next-line jira/react/no-style-attribute
    , {
        style: {
            color: `${"var(--ds-text, #172B4D)"}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            whiteSpace: 'nowrap',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            textOverflow: 'ellipsis',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            minWidth: 0
        }
    }, cardSummary);
const $a8e7fdcc1d4ad227$var$Key = ({ cardKey: cardKey, done: done })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div" // eslint-disable-next-line jira/react/no-style-attribute
    , {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            color: "var(--ds-text-subtle, #44546F)",
            fontWeight: (0, $dCm1o.isVisualRefreshEnabled)() ? "var(--ds-font-weight-regular, 400)" : "var(--ds-font-weight-semibold, 600)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            outline: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginTop: '0',
            textDecoration: `${done ? 'line-through' : 'none'}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            whiteSpace: 'nowrap',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            paddingRight: "var(--ds-space-100, 8px)"
        }
    }, cardKey);
const $a8e7fdcc1d4ad227$var$Icon = ({ src: src })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        alt: "" // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        ,
        style: {
            width: (0, $gwIPs.gridSize) * 2,
            height: (0, $gwIPs.gridSize) * 2,
            verticalAlign: 'text-bottom'
        },
        src: src
    });
const $a8e7fdcc1d4ad227$var$Container = ({ children: children, style: style, hasExtraFields: hasExtraFields, isCompact: isCompact })=>{
    const cardRowHeight = isCompact ? (0, $2lpqS.COMPACT_CARD_ROW_HEIGHT) : (0, $2lpqS.CARD_ROW_HEIGHT);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div" // eslint-disable-next-line jira/react/no-style-attribute
    , {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...style,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            backgroundColor: "var(--ds-surface-raised, #FFFFFF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            height: `${hasExtraFields ? cardRowHeight + (0, $2lpqS.EXTRA_CARD_ROW_HEIGHT) : cardRowHeight}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            textDecoration: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'grid',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            alignItems: 'center',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flexDirection: 'column',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'relative'
        }
    }, children);
}; // Chevron icon wrapper, keep it consistent with src/packages/software/backlog/src/view/card-list/card/card-contents/view.tsx
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a8e7fdcc1d4ad227$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_yyhy14f8 _1ii7wtyw _1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fE0Ry", function(module, exports) {

$parcel$export(module.exports, "AssigneePickerView", () => $7dd7529f3295a136$export$7df43f1214c1ab94);
$parcel$export(module.exports, "AvatarWrapper", () => $7dd7529f3295a136$export$f7513421c53ce141);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ujWmd = parcelRequire("ujWmd");

var $3bDjY = parcelRequire("3bDjY");

var $aWse0 = parcelRequire("aWse0");


var $fhSLy = parcelRequire("fhSLy");

var $evUrF = parcelRequire("evUrF");
const $7dd7529f3295a136$export$7df43f1214c1ab94 = ({ value: value })=>{
    const intl = (0, $aWse0.useIntlV2)();
    const unassigned = (0, $fhSLy.getUnassignedUser)(intl);
    const user = value || unassigned;
    const assigneeName = user.accountId === (0, $c1e3a0a8493b8e86$export$bdab9bfb39981463) ? user.displayName : intl.formatMessage((0, $evUrF.default).assigneeTooltip, {
        name: user.displayName
    });
    const avatarUrl = (0, $fhSLy.getUserAvatarUrl)(user);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7dd7529f3295a136$export$f7513421c53ce141, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: assigneeName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        testId: "issue-field-assignee.common.ui.read-view.popover.avatar",
        size: "small",
        src: avatarUrl,
        name: assigneeName,
        borderColor: "transparent"
    })));
};
var $7dd7529f3295a136$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
 = $7dd7529f3295a136$export$7df43f1214c1ab94;
const $7dd7529f3295a136$export$f7513421c53ce141 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1f4h _4t3i1f4h _vchhusvi _80om73ad",
            __cmplp.className
        ])
    });
});

});
parcelRegister("evUrF", function(module, exports) {

$parcel$export(module.exports, "default", () => $027660e13143d610$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $027660e13143d610$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    assigneeTooltip: {
        "id": "issue-field-assignee.common.read-view.popover.assignee-tooltip",
        "defaultMessage": "Assignee: {name}"
    }
});

});


parcelRegister("ekU0X", function(module, exports) {

$parcel$export(module.exports, "CardColor", () => $f7387e350322f232$export$d6da217c85de72a2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");
function $f7387e350322f232$export$d6da217c85de72a2({ id: id }) {
    const color = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.getCardColor)(state, id));
    if (!color) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f7387e350322f232$var$Container, {
        role: "presentation",
        color: color
    });
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f7387e350322f232$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $lD23V.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _154iidpf _1ltvidpf _94n5idpf _1bsb1y44 _bfhk1cj8",
            __cmplp.className
        ])
    });
});

});

parcelRegister("g1Kbb", function(module, exports) {

$parcel$export(module.exports, "CardExtraField", () => $9e20187649cdd628$export$29842e7d338e26a1);

var $5uXOq = parcelRequire("5uXOq");

var $eaTAr = parcelRequire("eaTAr");

var $8nQtm = parcelRequire("8nQtm");

var $bwyRv = parcelRequire("bwyRv");

var $XIGKP = parcelRequire("XIGKP");

var $7omaD = parcelRequire("7omaD");

var $lTDsc = parcelRequire("lTDsc");
function $9e20187649cdd628$export$29842e7d338e26a1({ field: field, isLite: isLite }) {
    if ((0, $eaTAr.isExtraFieldThumbnail)(field)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lTDsc.ThumbnailField), {
        field: field
    });
    if ((0, $eaTAr.isExtraFieldLabel)(field)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $XIGKP.LabelsField), {
        field: field,
        isLite: isLite
    });
    if ((0, $eaTAr.isExtraFieldHtml)(field)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bwyRv.HtmlField), {
        field: field
    });
    if ((0, $eaTAr.isExtraFieldDate)(field)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8nQtm.DateField), {
        field: field
    });
    if ((0, $eaTAr.isExtraFieldText)(field)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7omaD.TextField), {
        field: field
    });
    return null;
}

});
parcelRegister("8nQtm", function(module, exports) {

$parcel$export(module.exports, "DateField", () => $4e396ac70e049afc$export$d9781c7894a82487);

var $5uXOq = parcelRequire("5uXOq");

var $hXLCJ = parcelRequire("hXLCJ");

var $3bDjY = parcelRequire("3bDjY");

var $hCPhj = parcelRequire("hCPhj");

var $dRBdt = parcelRequire("dRBdt");
function $4e396ac70e049afc$export$d9781c7894a82487({ field: field }) {
    let content = (0, $dRBdt.parseContent)(field.html);
    if ((0, $dRBdt.isDefault)(content)) content = (0, $dRBdt.parseContent)(field.text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: field.label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCPhj.Container), {
        as: "time",
        // @ts-expect-error Property 'dateTime' does not exist on type 'IntrinsicAttributes & { isDefault: boolean; } & ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & StyledProps & { ...; }'.
        dateTime: field.text,
        "aria-hidden": (0, $dRBdt.isDefault)(content) ? 'true' : 'false',
        "aria-label": field.label,
        isDefault: (0, $dRBdt.isDefault)(content),
        dangerouslySetInnerHTML: {
            __html: (0, (/*@__PURE__*/$parcel$interopDefault($hXLCJ))).sanitize(content)
        }
    }));
}

});
parcelRegister("hXLCJ", function(module, exports) {
/*! @license DOMPurify 2.5.7 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.5.7/LICENSE */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _construct(Parent, args, Class) {
        if (_isNativeReflectConstruct()) _construct = Reflect.construct;
        else _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
        return _construct.apply(null, arguments);
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var hasOwnProperty = Object.hasOwnProperty, setPrototypeOf = Object.setPrototypeOf, isFrozen = Object.isFrozen, getPrototypeOf = Object.getPrototypeOf, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var freeze = Object.freeze, seal = Object.seal, create = Object.create; // eslint-disable-line import/no-mutable-exports
    var _ref = typeof Reflect !== 'undefined' && Reflect, apply = _ref.apply, construct = _ref.construct;
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!construct) construct = function construct(Func, args) {
        return _construct(Func, _toConsumableArray(args));
    };
    var arrayForEach = unapply(Array.prototype.forEach);
    var arrayPop = unapply(Array.prototype.pop);
    var arrayPush = unapply(Array.prototype.push);
    var stringToLowerCase = unapply(String.prototype.toLowerCase);
    var stringToString = unapply(String.prototype.toString);
    var stringMatch = unapply(String.prototype.match);
    var stringReplace = unapply(String.prototype.replace);
    var stringIndexOf = unapply(String.prototype.indexOf);
    var stringTrim = unapply(String.prototype.trim);
    var regExpTest = unapply(RegExp.prototype.test);
    var typeErrorCreate = unconstruct(TypeError);
    function unapply(func) {
        return function(thisArg) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /* Add properties to a lookup table */ function addToSet(set, array, transformCaseFunc) {
        var _transformCaseFunc;
        transformCaseFunc = (_transformCaseFunc = transformCaseFunc) !== null && _transformCaseFunc !== void 0 ? _transformCaseFunc : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        var l = array.length;
        while(l--){
            var element = array[l];
            if (typeof element === 'string') {
                var lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /* Shallow clone an object */ function clone(object) {
        var newObject = create(null);
        var property;
        for(property in object)if (apply(hasOwnProperty, object, [
            property
        ]) === true) newObject[property] = object[property];
        return newObject;
    }
    /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */ function lookupGetter(object, prop) {
        while(object !== null){
            var desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue(element) {
            console.warn('fallback value for', element);
            return null;
        }
        return fallbackValue;
    }
    var html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'section',
        'select',
        'shadow',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    // SVG
    var svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    var svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    var svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'fedropshadow',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    var mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    var mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    var text = freeze([
        '#text'
    ]);
    var html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'pattern',
        'placeholder',
        'playsinline',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'xmlns',
        'slot'
    ]);
    var svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    var mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnsalign',
        'columnlines',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lspace',
        'lquote',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    var xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    // eslint-disable-next-line unicorn/better-regex
    var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
    var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape
    var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    var DOCTYPE_NAME = seal(/^html$/i);
    var CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */ var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
        if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        var suffix = null;
        var ATTR_NAME = 'data-tt-policy-suffix';
        if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) suffix = document.currentScript.getAttribute(ATTR_NAME);
        var policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML: function createHTML(html) {
                    return html;
                },
                createScriptURL: function createScriptURL(scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    function createDOMPurify() {
        var window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        var DOMPurify = function DOMPurify(root) {
            return createDOMPurify(root);
        };
        /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */ DOMPurify.version = '2.5.7';
        /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */ DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== 9) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        var originalDocument = window1.document;
        var document = window1.document;
        var DocumentFragment = window1.DocumentFragment, HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter, _window$NamedNodeMap = window1.NamedNodeMap, NamedNodeMap = _window$NamedNodeMap === void 0 ? window1.NamedNodeMap || window1.MozNamedAttrMap : _window$NamedNodeMap, HTMLFormElement = window1.HTMLFormElement, DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
        var ElementPrototype = Element.prototype;
        var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        var getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            var template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
        var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
        var _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
        var importNode = originalDocument.importNode;
        var documentMode = {};
        try {
            documentMode = clone(document).documentMode ? document.documentMode : {};
        } catch (_) {}
        var hooks = {};
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined && documentMode !== 9;
        var MUSTACHE_EXPR$1 = MUSTACHE_EXPR, ERB_EXPR$1 = ERB_EXPR, TMPLIT_EXPR$1 = TMPLIT_EXPR, DATA_ATTR$1 = DATA_ATTR, ARIA_ATTR$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = ATTR_WHITESPACE, CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
        var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ var ALLOWED_TAGS = null;
        var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
        /* Allowed attribute names */ var ALLOWED_ATTR = null;
        var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
        /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ var FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ var FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ var ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ var ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ var ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ var ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ var SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ var SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ var WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ var SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ var FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ var RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ var RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ var RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ var SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ var SANITIZE_NAMED_PROPS = false;
        var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ var KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ var IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ var USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ var FORBID_CONTENTS = null;
        var DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ var DATA_URI_TAGS = null;
        var DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ var URI_SAFE_ATTRIBUTES = null;
        var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ var NAMESPACE = HTML_NAMESPACE;
        var IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ var ALLOWED_NAMESPACES = null;
        var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        /* Parsing of strict XHTML documents */ var PARSER_MEDIA_TYPE;
        var SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        var transformCaseFunc;
        /* Keep a reference to config to pass to hooks */ var CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ var formElement = document.createElement('form');
        var isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */ // eslint-disable-next-line complexity
        var _parseConfig = function _parseConfig(cfg) {
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || _typeof(cfg) !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
            cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
            cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
            FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
            USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        var HTML_INTEGRATION_POINTS = addToSet({}, [
            'annotation-xml'
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ var ALL_SVG_TAGS = addToSet({}, svg$1);
        addToSet(ALL_SVG_TAGS, svgFilters);
        addToSet(ALL_SVG_TAGS, svgDisallowed);
        var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
        addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
        /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ var _checkValidNamespace = function _checkValidNamespace(element) {
            var parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            var tagName = stringToLowerCase(element.tagName);
            var parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */ var _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                node.parentNode.removeChild(node);
            } catch (_) {
                try {
                    node.outerHTML = emptyHTML;
                } catch (_) {
                    node.remove();
                }
            }
        };
        /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */ var _removeAttribute = function _removeAttribute(name, node) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: node.getAttributeNode(name),
                    from: node
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: node
                });
            }
            node.removeAttribute(name);
            // We void attribute values for unremovable "is"" attributes
            if (name === 'is' && !ALLOWED_ATTR[name]) {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(node);
                } catch (_) {}
                else try {
                    node.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */ var _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ var doc;
            var leadingWhitespace;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ var matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            var body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */ var _createIterator = function _createIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null, false);
        };
        /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */ var _isClobbered = function _isClobbered(elm) {
            return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
        };
        /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */ var _isNode = function _isNode(object) {
            return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
        };
        /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */ var _executeHook = function _executeHook(entryPoint, currentNode, data) {
            if (!hooks[entryPoint]) return;
            arrayForEach(hooks[entryPoint], function(hook) {
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        };
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */ var _sanitizeElements = function _sanitizeElements(currentNode) {
            var content;
            /* Execute a hook if present */ _executeHook('beforeSanitizeElements', currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Check if tagname contains Unicode */ if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ var tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHook('uponSanitizeElement', currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Mitigate a problem with templates inside select */ if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any ocurrence of processing instructions */ if (currentNode.nodeType === 7) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === 8 && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    var parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    var childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        var childCount = childNodes.length;
                        for(var i = childCount - 1; i >= 0; --i){
                            var childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
                /* Get the element's text content */ content = currentNode.textContent;
                content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
                content = stringReplace(content, ERB_EXPR$1, ' ');
                content = stringReplace(content, TMPLIT_EXPR$1, ' ');
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeElements', currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */ var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
            return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT$1);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */ var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            var attr;
            var value;
            var lcName;
            var l;
            /* Execute a hook if present */ _executeHook('beforeSanitizeAttributes', currentNode, null);
            var attributes = currentNode.attributes;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes) return;
            var hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR
            };
            l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                attr = attributes[l];
                var _attr = attr, name = _attr.name, namespaceURI = _attr.namespaceURI;
                value = name === 'value' ? attr.value : stringTrim(attr.value);
                lcName = transformCaseFunc(name);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) {
                    value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
                    value = stringReplace(value, ERB_EXPR$1, ' ');
                    value = stringReplace(value, TMPLIT_EXPR$1, ' ');
                }
                /* Is `value` valid for this attribute? */ var lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) continue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case 'TrustedHTML':
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case 'TrustedScriptURL':
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {}
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeAttributes', currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */ var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            var shadowNode;
            var shadowIterator = _createIterator(fragment);
            /* Execute a hook if present */ _executeHook('beforeSanitizeShadowDOM', fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHook('uponSanitizeShadowNode', shadowNode, null);
                /* Sanitize tags and elements */ if (_sanitizeElements(shadowNode)) continue;
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(shadowNode);
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeShadowDOM', fragment, null);
        };
        /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */ // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var body;
            var importedNode;
            var currentNode;
            var oldNode;
            var returnNode;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                if (typeof dirty.toString === 'function') {
                    dirty = dirty.toString();
                    if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
                } else throw typeErrorCreate('toString is not a function');
            }
            /* Check we can run. Otherwise fall back or ignore */ if (!DOMPurify.isSupported) {
                if (_typeof(window1.toStaticHTML) === 'object' || typeof window1.toStaticHTML === 'function') {
                    if (typeof dirty === 'string') return window1.toStaticHTML(dirty);
                    if (_isNode(dirty)) return window1.toStaticHTML(dirty.outerHTML);
                }
                return dirty;
            }
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    var tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Fix IE's strange behavior with manipulated textNodes #89 */ if (currentNode.nodeType === 3 && currentNode === oldNode) continue;
                /* Sanitize tags and elements */ if (_sanitizeElements(currentNode)) continue;
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(currentNode);
                oldNode = currentNode;
            }
            oldNode = null;
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) {
                serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
            }
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */ DOMPurify.setConfig = function(cfg) {
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        /**
     * Public method to remove the configuration
     * clearConfig
     *
     */ DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */ DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            var lcTag = transformCaseFunc(tag);
            var lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */ DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            hooks[entryPoint] = hooks[entryPoint] || [];
            arrayPush(hooks[entryPoint], hookFunction);
        };
        /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */ DOMPurify.removeHook = function(entryPoint) {
            if (hooks[entryPoint]) return arrayPop(hooks[entryPoint]);
        };
        /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */ DOMPurify.removeHooks = function(entryPoint) {
            if (hooks[entryPoint]) hooks[entryPoint] = [];
        };
        /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */ DOMPurify.removeAllHooks = function() {
            hooks = {};
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});

});

parcelRegister("hCPhj", function(module, exports) {

$parcel$export(module.exports, "Container", () => $211e50fd69ae0f6d$export$42a852a2b6b56249);
$parcel$export(module.exports, "FieldSeparator", () => $211e50fd69ae0f6d$export$35646e337882f8c7);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $211e50fd69ae0f6d$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDefault: isDefault, isLink: isLink, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _syaz131l _1ul9idpf _o5721q9c _3l5f15vq _1eex15vq _rvu71q9c _lyiy1l2s _r07x15vq _6e8f15vq _1b6lhxbz _mfe41wmp _1rnet94y _nd9nstnw _qb0y1q9c _1fy5t94y _1bsk1osq _1y8m1wug _la1rnkob _bqe6nkob _1md0idpf _qehnidpf _18vridpf _1nlwidpf _12isidpf _1ci4idpf _1qwe1ule _gzx61wug _odtp1b66 _1udf15vq _1d0q15vq _ufkk15vq _vtsa15vq _r7d31l2s _1bz61q9c _1g851fxt _3vx9dcr7 _xc9z1b66 _13psze3t _rf3yusvi _153f1txw _x0hj1h6o _1rip1kw7 _jyubze3t _7x3gze3t _175dze3t _1invze3t _121u4cjx _47za1txw _i6cz1kw7",
            __cmplp.isDefault ? "_zg8l1m30" : "_zg8l1kw7",
            __cmplp.isLink ? "_19pk1i6y" : "_19pk1kw7",
            __cmplp.isLink ? "_4t3i1ejb" : "_4t3iv47k",
            __cmplp.className
        ])
    });
});
const $211e50fd69ae0f6d$export$35646e337882f8c7 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1t05",
            __cmplp.className
        ])
    });
});

});

parcelRegister("dRBdt", function(module, exports) {

$parcel$export(module.exports, "isDefault", () => $28becdc44a135b68$export$75abdbb028a7ab06);
$parcel$export(module.exports, "parseContent", () => $28becdc44a135b68$export$4cf5403beffb0fc1);

var $gccSB = parcelRequire("gccSB");

var $2nvJN = parcelRequire("2nvJN");

const $28becdc44a135b68$export$75abdbb028a7ab06 = (content)=>content === (0, $7aa9ed31c5ab3869$export$2c9ef5d2c18593f7);
const $28becdc44a135b68$var$isNonBreakingSpace = (content)=>content === (0, $7aa9ed31c5ab3869$export$b6fa73900e7ac785);
const $28becdc44a135b68$var$isEmptyOrBlank = (content)=>!content || (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))((0, (/*@__PURE__*/$parcel$interopDefault($2nvJN)))(content));
const $28becdc44a135b68$var$isContentInvalid = (content)=>$28becdc44a135b68$var$isNonBreakingSpace(content) || $28becdc44a135b68$var$isEmptyOrBlank(content);
const $28becdc44a135b68$export$4cf5403beffb0fc1 = (content)=>$28becdc44a135b68$var$isContentInvalid(content) ? (0, $7aa9ed31c5ab3869$export$2c9ef5d2c18593f7) : (0, (/*@__PURE__*/$parcel$interopDefault($2nvJN)))(content);

});
const $7aa9ed31c5ab3869$export$b6fa73900e7ac785 = '&nbsp;';
const $7aa9ed31c5ab3869$export$2c9ef5d2c18593f7 = 'None';



parcelRegister("bwyRv", function(module, exports) {

$parcel$export(module.exports, "HtmlField", () => $37bb6fa1bfde042a$export$9cda3940184cdf77);

var $5uXOq = parcelRequire("5uXOq");

var $hXLCJ = parcelRequire("hXLCJ");

var $3bDjY = parcelRequire("3bDjY");

var $hCPhj = parcelRequire("hCPhj");

var $dRBdt = parcelRequire("dRBdt");
function $37bb6fa1bfde042a$export$9cda3940184cdf77({ field: field }) {
    const content = (0, $dRBdt.parseContent)(field.html);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: field.label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCPhj.Container), {
        "aria-label": field.label,
        "aria-hidden": (0, $dRBdt.isDefault)(content) ? 'true' : 'false',
        isDefault: (0, $dRBdt.isDefault)(content),
        dangerouslySetInnerHTML: {
            __html: (0, (/*@__PURE__*/$parcel$interopDefault($hXLCJ))).sanitize(content)
        }
    }));
}

});

parcelRegister("XIGKP", function(module, exports) {

$parcel$export(module.exports, "LabelsField", () => $7274ee43ca72500a$export$b5a86c9a622796ff);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gccSB = parcelRequire("gccSB");

var $d9xxV = parcelRequire("d9xxV");

var $3bDjY = parcelRequire("3bDjY");

var $55feQ = parcelRequire("55feQ");


var $dRBdt = parcelRequire("dRBdt");
const $7274ee43ca72500a$var$parseLabels = (text)=>{
    const content = (0, $dRBdt.parseContent)(text);
    return (0, $dRBdt.isDefault)(content) ? [] : (0, $55feQ.toLabels)(content);
};
const $7274ee43ca72500a$var$ItemRenderer = ({ item: item, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9xxV.default), {
        "aria-label": label,
        key: item,
        text: item
    });
function $7274ee43ca72500a$export$b5a86c9a622796ff({ field: field, isLite: isLite }) {
    const content = $7274ee43ca72500a$var$parseLabels(field.text);
    const wrap = (children)=>isLite ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: field.label
        }, children);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(content)) return wrap(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7274ee43ca72500a$var$Container, {
        "aria-hidden": "true",
        isDefault: true
    }, (0, $7aa9ed31c5ab3869$export$2c9ef5d2c18593f7)));
    return wrap(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7274ee43ca72500a$var$Container, {
        "aria-hidden": "true",
        isDefault: false
    }, content.map((item, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7274ee43ca72500a$var$ItemRenderer, {
            key: i,
            item: item,
            label: item
        }))));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7274ee43ca72500a$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDefault: isDefault, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _syaz131l _1ul9idpf _p12f1osq _o5721q9c _kqswh2mm _16r260i3 _aetrb3bt _19doidpf _15l2idpf _1ywu1ule _1qdg1osq _z0ai1osq _18postnw _e9q69hw4 _1nvfidpf",
            __cmplp.isDefault ? "_zg8l1m30" : "_zg8l1kw7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("d9xxV", function(module, exports) {

$parcel$export(module.exports, "default", () => $87927dab24395a15$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5oSQr = parcelRequire("5oSQr");

var $aXLIT = parcelRequire("aXLIT");

var $eYXIO = parcelRequire("eYXIO");
const $87927dab24395a15$var$SimpleTagComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, color: color = 'standard', href: href, testId: testId, text: text = '', linkComponent: linkComponent }, ref)=>{
    const content = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eYXIO.default), {
        elemBefore: elemBefore,
        isRemovable: false,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5oSQr.default), {
        ref: ref,
        testId: testId,
        href: href,
        appearance: appearance,
        color: color,
        before: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aXLIT.default), {
            elemBefore: elemBefore
        }),
        contentElement: content
    });
});
/**
 * __Simple tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * `SimpleTag` is the default form of a tag, where text is required. Tags with static text can be used as a flag or as a reference to an object or attribute.
 *
 * - [Examples](https://atlassian.design/components/tag/examples)
 * - [Code](https://atlassian.design/components/tag/code)
 * - [Usage](https://atlassian.design/components/tag/usage)
 */ const $87927dab24395a15$var$SimpleTag = /*#__PURE__*/ (0, $5uXOq.memo)($87927dab24395a15$var$SimpleTagComponent);
var $87927dab24395a15$export$2e2bcd8739ae039 = $87927dab24395a15$var$SimpleTag;

});
parcelRegister("5oSQr", function(module, exports) {

$parcel$export(module.exports, "default", () => $db35d9df42c66ff0$export$2e2bcd8739ae039);
/* base.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $2hnSR = parcelRequire("2hnSR");
const $db35d9df42c66ff0$var$borderColorCssVar = '--ds-bc';
const $db35d9df42c66ff0$var$focusRingCssVar = '--ds-cfr';
const $db35d9df42c66ff0$var$textLinkCssVar = '--ds-ctl';
const $db35d9df42c66ff0$var$textDefaultCssVar = '--ds-ct';
const $db35d9df42c66ff0$var$textHoverCssVar = '--ds-cth';
const $db35d9df42c66ff0$var$textActiveCssVar = '--ds-ctp';
const $db35d9df42c66ff0$var$backgroundDefaultCssVar = '--ds-cb';
const $db35d9df42c66ff0$var$backgroundHoverCssVar = '--ds-cbh';
const $db35d9df42c66ff0$var$backgroundActiveCssVar = '--ds-cba';
const $db35d9df42c66ff0$var$removeButtonDefaultCssVar = '--ds-rb';
const $db35d9df42c66ff0$var$removeButtonHoverCssVar = '--ds-rbh';
const $db35d9df42c66ff0$var$borderRadiusCssVar = '--ds-br';
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$baseStylesOld = null;
const $db35d9df42c66ff0$var$baseStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$interactiveStylesOld = null;
const $db35d9df42c66ff0$var$interactiveStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$focusRingStylesOld = null;
const $db35d9df42c66ff0$var$focusRingStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$nonStandardLinkStyles = null;
const $db35d9df42c66ff0$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(function BaseTag({ before: before, contentElement: contentElement, after: after, testId: testId, appearance: appearance = 'default', style: style, color: color = 'standard', href: href, className: className, ...other }, ref) {
    const isLink = Boolean(href);
    const isRemovable = Boolean(after);
    const isInteractive = isLink || isRemovable;
    const isStandardLink = isLink && color === 'standard';
    // Change link text color if  the tag is standard color
    const textLinkColors = isStandardLink ? (0, $2hnSR.textColors)['standardLink'] : (0, $2hnSR.textColors)[color];
    const backgroundHoverColors = isRemovable && !isLink ? (0, $2hnSR.backgroundColors)[color] : (0, $2hnSR.linkHoverBackgroundColors)[color];
    const backgroundActiveColors = isRemovable && !isLink ? (0, $2hnSR.backgroundColors)[color] : (0, $2hnSR.linkActiveBackgroundColors)[color];
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
        ...other,
        ref: ref,
        style: {
            // NOTE: The vast majority of these styles have zero purpose to be runtime computed
            // This can all be migrated to statically distributed atomic CSS with Compiled in the future
            // The main reason for not touching this is there is to avoid excessive changes in the same PR on non-visual-refresh code
            /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ [$db35d9df42c66ff0$var$borderColorCssVar]: (0, $2hnSR.borderColors)[color],
            [$db35d9df42c66ff0$var$textDefaultCssVar]: (0, $2hnSR.textColors)[color],
            [$db35d9df42c66ff0$var$textHoverCssVar]: (0, $2hnSR.textHoverColors)[color],
            [$db35d9df42c66ff0$var$textActiveCssVar]: (0, $2hnSR.textActiveColors)[color],
            [$db35d9df42c66ff0$var$textLinkCssVar]: textLinkColors,
            [$db35d9df42c66ff0$var$backgroundDefaultCssVar]: (0, $2hnSR.backgroundColors)[color],
            [$db35d9df42c66ff0$var$backgroundHoverCssVar]: backgroundHoverColors,
            [$db35d9df42c66ff0$var$backgroundActiveCssVar]: backgroundActiveColors,
            [$db35d9df42c66ff0$var$focusRingCssVar]: (0, $2hnSR.focusRingColors),
            [$db35d9df42c66ff0$var$removeButtonDefaultCssVar]: (0, $2hnSR.removeButtonColors)[color],
            [$db35d9df42c66ff0$var$removeButtonHoverCssVar]: (0, $2hnSR.removeButtonHoverColors)[color],
            [$db35d9df42c66ff0$var$borderRadiusCssVar]: appearance === 'rounded' ? '10px' : '3px',
            /* eslint-enable @atlaskit/ui-styling-standard/enforce-style-prop */ /* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...style
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_zulp1b66 _2rko1sit _1h6d2fso _1dqonqa1 _189ee4h9 _1mou1b66 _195g1b66 _18zr1b66 _1e0c116y _vchhusvi _1ul9idpf _4t3iv47k _kqswh2mm _4cvr1h6o _bfhk1w7a _syaz1fxt _80om73ad" : "_2rko1l5z _1mou1b66 _195g1b66 _1rjcze3t _18zrze3t _1e0c116y _1ul9idpf _4t3iv47k _kqswh2mm _bfhklsll _syaz148y _80om73ad",
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_1e38ugt7 _7glxv77o" : "_1guj1r31 _pbhaglyw _11ow1o36 _1u6lnr64",
            isLink && (0, $VSDnB.fg)('platform-component-visual-refresh') && "_irr3166n _1di61dty",
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && isLink && !isStandardLink && "_9h8h1348",
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && isInteractive && "_irr31lyj _1di6oo20",
            className
        ]),
        "data-testid": testId,
        children: [
            before,
            contentElement,
            after
        ]
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$db35d9df42c66ff0$export$2e2bcd8739ae039 = $db35d9df42c66ff0$var$BaseTag;

});
parcelRegister("2hnSR", function(module, exports) {

$parcel$export(module.exports, "textColors", () => $5b444d8505b9cc3c$export$daa0ace263cb20d2);
$parcel$export(module.exports, "borderColors", () => $5b444d8505b9cc3c$export$1c1b571cf296eca7);
$parcel$export(module.exports, "textHoverColors", () => $5b444d8505b9cc3c$export$7c7104a5f052cab7);
$parcel$export(module.exports, "textActiveColors", () => $5b444d8505b9cc3c$export$382469baad253eb7);
$parcel$export(module.exports, "backgroundColors", () => $5b444d8505b9cc3c$export$b9d7c59a579c23c6);
$parcel$export(module.exports, "linkHoverBackgroundColors", () => $5b444d8505b9cc3c$export$4410079763249c74);
$parcel$export(module.exports, "linkActiveBackgroundColors", () => $5b444d8505b9cc3c$export$76be99c5e13e3566);
$parcel$export(module.exports, "focusRingColors", () => $5b444d8505b9cc3c$export$2a31dbe82788f940);
$parcel$export(module.exports, "removalHoverBackgroundColors", () => $5b444d8505b9cc3c$export$1202b7eb21da7b58);
$parcel$export(module.exports, "removalActiveBackgroundColors", () => $5b444d8505b9cc3c$export$62ace793ebb16bda);
$parcel$export(module.exports, "removalTextColors", () => $5b444d8505b9cc3c$export$17d206ccea111bbb);
$parcel$export(module.exports, "removeButtonColors", () => $5b444d8505b9cc3c$export$f64c7641cbc22da7);
$parcel$export(module.exports, "removeButtonHoverColors", () => $5b444d8505b9cc3c$export$b03fbc2a369c563e);
// Text colors
const $5b444d8505b9cc3c$export$daa0ace263cb20d2 = {
    standard: "var(--ds-text, #253858)",
    standardLink: "var(--ds-link, #0052CC)",
    blue: "var(--ds-text-accent-blue-bolder, #172B4D)",
    red: "var(--ds-text-accent-red-bolder, #172B4D)",
    yellow: "var(--ds-text-accent-yellow-bolder, #172B4D)",
    green: "var(--ds-text-accent-green-bolder, #172B4D)",
    teal: "var(--ds-text-accent-teal-bolder, #172B4D)",
    purple: "var(--ds-text-accent-purple-bolder, #172B4D)",
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: "var(--ds-text-accent-gray-bolder, #FFFFFF)",
    blueLight: "var(--ds-text-accent-blue, #0747A6)",
    redLight: "var(--ds-text-accent-red, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow, #42526E)",
    greenLight: "var(--ds-text-accent-green, #006644)",
    tealLight: "var(--ds-text-accent-teal, #42526E)",
    purpleLight: "var(--ds-text-accent-purple, #403294)",
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: "var(--ds-text-accent-gray, #42526E)"
};
const $5b444d8505b9cc3c$export$1c1b571cf296eca7 = {
    standard: '#B7B9BE',
    blue: '#669DF1',
    red: '#F87168',
    yellow: '#DDB30E',
    green: '#4BCE97',
    teal: '#6CC3E0',
    purple: '#C97CF4',
    lime: '#94C748',
    magenta: '#E774BB',
    orange: '#FCA700',
    grey: '#B7B9BE',
    standardLink: '#B7B9BE',
    blueLight: '#669DF1',
    redLight: '#F87168',
    yellowLight: '#DDB30E',
    greenLight: '#4BCE97',
    tealLight: '#6CC3E0',
    purpleLight: '#C97CF4',
    limeLight: '#94C748',
    magentaLight: '#E774BB',
    orangeLight: '#FCA700',
    greyLight: '#B7B9BE'
};
const $5b444d8505b9cc3c$export$7c7104a5f052cab7 = {
    standard: "var(--ds-link, #0065FF)",
    blue: "var(--ds-text-accent-blue-bolder, #172B4D)",
    red: "var(--ds-text-accent-red-bolder, #172B4D)",
    yellow: "var(--ds-text-accent-yellow-bolder, #172B4D)",
    green: "var(--ds-text-accent-green-bolder, #172B4D)",
    teal: "var(--ds-text-accent-teal-bolder, #172B4D)",
    purple: "var(--ds-text-accent-purple-bolder, #172B4D)",
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: "var(--ds-text-accent-gray-bolder, #FFFFFF)",
    blueLight: "var(--ds-text-accent-blue, #0747A6)",
    redLight: "var(--ds-text-accent-red, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow, #42526E)",
    greenLight: "var(--ds-text-accent-green, #006644)",
    tealLight: "var(--ds-text-accent-teal, #42526E)",
    purpleLight: "var(--ds-text-accent-purple, #403294)",
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: "var(--ds-text-accent-gray, #42526E)"
};
const $5b444d8505b9cc3c$export$382469baad253eb7 = {
    standard: "var(--ds-link-pressed, #0065FF)",
    blue: "var(--ds-text-accent-blue, #172B4D)",
    red: "var(--ds-text-accent-red, #172B4D)",
    yellow: "var(--ds-text-accent-yellow, #172B4D)",
    green: "var(--ds-text-accent-green, #172B4D)",
    teal: "var(--ds-text-accent-teal, #172B4D)",
    purple: "var(--ds-text-accent-purple, #172B4D)",
    lime: "var(--ds-text-accent-lime, #4C6B1F)",
    magenta: "var(--ds-text-accent-magenta, #943D73)",
    orange: "var(--ds-text-accent-orange, #974F0C)",
    grey: "var(--ds-text-accent-gray, #FFFFFF)",
    blueLight: "var(--ds-text-accent-blue-bolder, #0747A6)",
    redLight: "var(--ds-text-accent-red-bolder, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow-bolder, #42526E)",
    greenLight: "var(--ds-text-accent-green-bolder, #006644)",
    tealLight: "var(--ds-text-accent-teal-bolder, #42526E)",
    purpleLight: "var(--ds-text-accent-purple-bolder, #403294)",
    limeLight: "var(--ds-text-accent-lime-bolder, #37471F)",
    magentaLight: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orangeLight: "var(--ds-text-accent-orange-bolder, #5F3811)",
    greyLight: "var(--ds-text-accent-gray-bolder, #42526E)"
};
const $5b444d8505b9cc3c$export$b9d7c59a579c23c6 = {
    standard: "var(--ds-background-neutral, #F4F5F7)",
    blue: "var(--ds-background-accent-blue-subtle, #4C9AFF)",
    red: "var(--ds-background-accent-red-subtle, #FF8F73)",
    yellow: "var(--ds-background-accent-yellow-subtle, #FFC400)",
    green: "var(--ds-background-accent-green-subtle, #57D9A3)",
    teal: "var(--ds-background-accent-teal-subtle, #00C7E6)",
    purple: "var(--ds-background-accent-purple-subtle, #998DD9)",
    lime: "var(--ds-background-accent-lime-subtle, #94C748)",
    magenta: "var(--ds-background-accent-magenta-subtle, #E774BB)",
    orange: "var(--ds-background-accent-orange-subtle, #FAA53D)",
    grey: "var(--ds-background-accent-gray-subtle, #42526E)",
    blueLight: "var(--ds-background-accent-blue-subtler, #B3D4FF)",
    redLight: "var(--ds-background-accent-red-subtler, #FFBDAD)",
    yellowLight: "var(--ds-background-accent-yellow-subtler, #FFE380)",
    greenLight: "var(--ds-background-accent-green-subtler, #79F2C0)",
    tealLight: "var(--ds-background-accent-teal-subtler, #79E2F2)",
    purpleLight: "var(--ds-background-accent-purple-subtler, #C0B6F2)",
    limeLight: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    magentaLight: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    orangeLight: "var(--ds-background-accent-orange-subtler, #FFE2BD)",
    greyLight: "var(--ds-background-accent-gray-subtler, #EBECF0)"
};
const $5b444d8505b9cc3c$export$4410079763249c74 = {
    standard: "var(--ds-background-neutral-hovered, #EBECF0)",
    blue: "var(--ds-background-accent-blue-subtle-hovered, #B3D4FF)",
    red: "var(--ds-background-accent-red-subtle-hovered, #FFBDAD)",
    yellow: "var(--ds-background-accent-yellow-subtle-hovered, #FFE380)",
    green: "var(--ds-background-accent-green-subtle-hovered, #79F2C0)",
    teal: "var(--ds-background-accent-teal-subtle-hovered, #79E2F2)",
    purple: "var(--ds-background-accent-purple-subtle-hovered, #C0B6F2)",
    lime: "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    magenta: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    orange: "var(--ds-background-accent-orange-subtle-hovered, #FEC57B)",
    grey: "var(--ds-background-accent-gray-subtle-hovered, #505F79)",
    blueLight: "var(--ds-background-accent-blue-subtler-hovered, #DEEBFF)",
    redLight: "var(--ds-background-accent-red-subtler-hovered, #FFEBE6)",
    yellowLight: "var(--ds-background-accent-yellow-subtler-hovered, #FFF0B3)",
    greenLight: "var(--ds-background-accent-green-subtler-hovered, #ABF5D1)",
    tealLight: "var(--ds-background-accent-teal-subtler-hovered, #B3F5FF)",
    purpleLight: "var(--ds-background-accent-purple-subtler-hovered, #EAE6FF)",
    limeLight: "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    orangeLight: "var(--ds-background-accent-orange-subtler-hovered, #FEC57B)",
    greyLight: "var(--ds-background-accent-gray-subtler-hovered, #DFE1E6)"
};
const $5b444d8505b9cc3c$export$76be99c5e13e3566 = {
    standard: "var(--ds-background-neutral-pressed, #EBECF0)",
    blue: "var(--ds-background-accent-blue-subtle-pressed, #DEEBFF)",
    red: "var(--ds-background-accent-red-subtle-pressed, #FFEBE6)",
    yellow: "var(--ds-background-accent-yellow-subtle-pressed, #FFF0B3)",
    green: "var(--ds-background-accent-green-subtle-pressed, #ABF5D1)",
    teal: "var(--ds-background-accent-teal-subtle-pressed, #B3F5FF)",
    purple: "var(--ds-background-accent-purple-subtle-pressed, #EAE6FF)",
    grey: "var(--ds-background-accent-gray-subtle-pressed, #5E6C84)",
    lime: "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    magenta: "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    orange: "var(--ds-background-accent-orange-subtle-pressed, #FFE2BD)",
    blueLight: "var(--ds-background-accent-blue-subtler-pressed, #4C9AFF)",
    redLight: "var(--ds-background-accent-red-subtler-pressed, #FF8F73)",
    yellowLight: "var(--ds-background-accent-yellow-subtler-pressed, #FFC400)",
    greenLight: "var(--ds-background-accent-green-subtler-pressed, #57D9A3)",
    tealLight: "var(--ds-background-accent-teal-subtler-pressed, #00C7E6)",
    purpleLight: "var(--ds-background-accent-purple-subtler-pressed, #998DD9)",
    limeLight: "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    orangeLight: "var(--ds-background-accent-orange-subtler-pressed, #FAA53D)",
    greyLight: "var(--ds-background-accent-gray-subtler-pressed, #C1C7D0)"
};
const $5b444d8505b9cc3c$export$2a31dbe82788f940 = "var(--ds-border-focused, #4C9AFF)";
const $5b444d8505b9cc3c$export$1202b7eb21da7b58 = "var(--ds-background-danger, #FFEBE6)";
const $5b444d8505b9cc3c$export$62ace793ebb16bda = "var(--ds-background-danger-hovered, #FFEBE6)";
const $5b444d8505b9cc3c$export$17d206ccea111bbb = "var(--ds-text-danger, #BF2600)";
const $5b444d8505b9cc3c$export$f64c7641cbc22da7 = {
    standard: "var(--ds-text, #42526E)",
    blue: "var(--ds-text-accent-blue-bolder, #42526E)",
    red: "var(--ds-text-accent-red-bolder, #42526E)",
    yellow: "var(--ds-text-accent-yellow-bolder, #42526E)",
    green: "var(--ds-text-accent-green-bolder, #42526E)",
    teal: "var(--ds-text-accent-teal-bolder, #42526E)",
    purple: "var(--ds-text-accent-purple-bolder, #42526E)",
    lime: "var(--ds-text-accent-lime-bolder, #42526E)",
    magenta: "var(--ds-text-accent-magenta-bolder, #42526E)",
    orange: "var(--ds-text-accent-orange-bolder, #42526E)",
    grey: "var(--ds-text-accent-gray-bolder, #42526E)",
    blueLight: "var(--ds-text-accent-blue, #42526E)",
    redLight: "var(--ds-text-accent-red, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow, #42526E)",
    greenLight: "var(--ds-text-accent-green, #42526E)",
    tealLight: "var(--ds-text-accent-teal, #42526E)",
    purpleLight: "var(--ds-text-accent-purple, #42526E)",
    limeLight: "var(--ds-text-accent-lime, #42526E)",
    magentaLight: "var(--ds-text-accent-magenta, #42526E)",
    orangeLight: "var(--ds-text-accent-orange, #42526E)",
    greyLight: "var(--ds-text-accent-gray, #42526E)"
};
const $5b444d8505b9cc3c$export$b03fbc2a369c563e = {
    standard: "var(--ds-text-danger, #253858)",
    standardLink: "var(--ds-text-danger, #0052CC)",
    blue: "var(--ds-text-danger, #172B4D)",
    red: "var(--ds-text-danger, #172B4D)",
    yellow: "var(--ds-text-danger, #172B4D)",
    green: "var(--ds-text-danger, #172B4D)",
    teal: "var(--ds-text-danger, #172B4D)",
    purple: "var(--ds-text-danger, #172B4D)",
    lime: "var(--ds-text-danger, #172B4D)",
    magenta: "var(--ds-text-danger, #172B4D)",
    orange: "var(--ds-text-danger, #172B4D)",
    grey: "var(--ds-text-danger, #FFFFFF)",
    blueLight: "var(--ds-text-danger, #0747A6)",
    redLight: "var(--ds-text-danger, #42526E)",
    yellowLight: "var(--ds-text-danger, #42526E)",
    greenLight: "var(--ds-text-danger, #006644)",
    tealLight: "var(--ds-text-danger, #42526E)",
    purpleLight: "var(--ds-text-danger, #403294)",
    limeLight: "var(--ds-text-danger, #403294)",
    magentaLight: "var(--ds-text-danger, #403294)",
    orangeLight: "var(--ds-text-danger, #403294)",
    greyLight: "var(--ds-text-danger, #42526E)"
};

});


parcelRegister("aXLIT", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b11e671062d0fc5$export$2e2bcd8739ae039);
/* before.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");
const $4b11e671062d0fc5$var$beforeElementStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $4b11e671062d0fc5$var$beforeElementStylesOld = null;
const $4b11e671062d0fc5$var$Before = ({ elemBefore: elemBefore })=>elemBefore ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_1e0c1txw _4t3i7vkz _4cvr1h6o _1bah1h6o _152tze3t" : "_2rko1l5z _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _152tze3t"
        ]),
        children: elemBefore
    }) : null;
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4b11e671062d0fc5$export$2e2bcd8739ae039 = $4b11e671062d0fc5$var$Before;

});

parcelRegister("eYXIO", function(module, exports) {

$parcel$export(module.exports, "default", () => $c46b06918fbe54e8$export$2e2bcd8739ae039);
/* content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");
// To be removed with platform-component-visual-refresh (BLU-2992)
const $c46b06918fbe54e8$var$baseStylesOld = null;
const $c46b06918fbe54e8$var$baseStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $c46b06918fbe54e8$var$linkStylesOld = null;
const $c46b06918fbe54e8$var$linkStyles = null;
const $c46b06918fbe54e8$var$hasAfterStylesOld = null;
const $c46b06918fbe54e8$var$hasAfterStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $c46b06918fbe54e8$var$hasBeforeStyles = null;
const $c46b06918fbe54e8$var$Content = ({ elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, linkComponent: linkComponent })=>{
    const Link = linkComponent ?? 'a';
    if (href) return /*#__PURE__*/ (0, $2OMIu.jsx)(Link, {
        href: href,
        "data-color": color,
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_11c82smr _1reo15vq _18m915vq _p12fmgvx _1bto1l2s _o5721q9c" : "_11c82smr _1reo15vq _18m915vq _p12fmgvx _y4ti1b66 _bozg1b66 _1bto1l2s _o5721q9c",
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_4bfu18uv _1hmsglyw _ajmmnqa1 _syaz1fxt _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik18uv _1bnx8stv _jf4cnqa1 _30l31fxt _1nrm18uv _c2wa8stv _1iohnqa1 _9h8h1fxt" : "_4bfu18uv _1hmsglyw _ajmmnqa1 _syazs5nr _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik18uv _1bnx8stv _jf4cnqa1 _30l3117u _1nrm18uv _c2wa8stv _1iohnqa1 _9h8h1348",
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && elemBefore && "_ahbqv47k",
            isRemovable && (0, $VSDnB.fg)('platform-component-visual-refresh') && "_p12f1lit",
            isRemovable && !(0, $VSDnB.fg)('platform-component-visual-refresh') && "_p12f1lit _y4tipxbi"
        ]),
        children: text
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_11c82smr _1reo15vq _18m915vq _p12fmgvx _1bto1l2s _o5721q9c" : "_11c82smr _1reo15vq _18m915vq _p12fmgvx _y4ti1b66 _bozg1b66 _1bto1l2s _o5721q9c",
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && elemBefore && "_ahbqv47k",
            isRemovable && (0, $VSDnB.fg)('platform-component-visual-refresh') && "_p12f1lit",
            isRemovable && !(0, $VSDnB.fg)('platform-component-visual-refresh') && "_p12f1lit _y4tipxbi"
        ]),
        children: text
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c46b06918fbe54e8$export$2e2bcd8739ae039 = $c46b06918fbe54e8$var$Content;

});


parcelRegister("55feQ", function(module, exports) {

$parcel$export(module.exports, "toLabels", () => $757bdacfe0ffe1b6$export$c17335eb990c7305);

var $kPH5D = parcelRequire("kPH5D");

var $80afZ = parcelRequire("80afZ");

var $lwKXv = parcelRequire("lwKXv");

var $2nvJN = parcelRequire("2nvJN");

var $2lpqS = parcelRequire("2lpqS");
function $757bdacfe0ffe1b6$var$notEmpty(value) {
    return Boolean(value);
}
const $757bdacfe0ffe1b6$export$c17335eb990c7305 = (content)=>{
    if (!content) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return [];
    return (0, (/*@__PURE__*/$parcel$interopDefault($kPH5D)))((0, (/*@__PURE__*/$parcel$interopDefault($80afZ)))((0, (/*@__PURE__*/$parcel$interopDefault($lwKXv)))(content, (0, $2lpqS.LABELS_FIELD_SEPARATOR)), (0, (/*@__PURE__*/$parcel$interopDefault($2nvJN)))), $757bdacfe0ffe1b6$var$notEmpty);
};

});
parcelRegister("lwKXv", function(module, exports) {

var $kHBB0 = parcelRequire("kHBB0");

var $gvFfr = parcelRequire("gvFfr");

var $axH2S = parcelRequire("axH2S");

var $4rDUz = parcelRequire("4rDUz");

var $cErmc = parcelRequire("cErmc");

var $jx6Tp = parcelRequire("jx6Tp");

var $jJVtR = parcelRequire("jJVtR");
/** Used as references for the maximum length and index of an array. */ var $fac1032dfd313195$var$MAX_ARRAY_LENGTH = 4294967295;
/**
 * Splits `string` by `separator`.
 *
 * **Note:** This method is based on
 * [`String#split`](https://mdn.io/String/split).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to split.
 * @param {RegExp|string} separator The separator pattern to split by.
 * @param {number} [limit] The length to truncate results to.
 * @returns {Array} Returns the string segments.
 * @example
 *
 * _.split('a-b-c', '-', 2);
 * // => ['a', 'b']
 */ function $fac1032dfd313195$var$split(string, separator, limit) {
    if (limit && typeof limit != 'number' && $4rDUz(string, separator, limit)) separator = limit = undefined;
    limit = limit === undefined ? $fac1032dfd313195$var$MAX_ARRAY_LENGTH : limit >>> 0;
    if (!limit) return [];
    string = $jJVtR(string);
    if (string && (typeof separator == 'string' || separator != null && !$cErmc(separator))) {
        separator = $kHBB0(separator);
        if (!separator && $axH2S(string)) return $gvFfr($jx6Tp(string), 0, limit);
    }
    return string.split(separator, limit);
}
module.exports = $fac1032dfd313195$var$split;

});
parcelRegister("cErmc", function(module, exports) {

var $3euyi = parcelRequire("3euyi");

var $cW28x = parcelRequire("cW28x");

var $lMQGH = parcelRequire("lMQGH");
/* Node.js helper references. */ var $935e70fe57caa939$var$nodeIsRegExp = $lMQGH && $lMQGH.isRegExp;
/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */ var $935e70fe57caa939$var$isRegExp = $935e70fe57caa939$var$nodeIsRegExp ? $cW28x($935e70fe57caa939$var$nodeIsRegExp) : $3euyi;
module.exports = $935e70fe57caa939$var$isRegExp;

});
parcelRegister("3euyi", function(module, exports) {

var $beQoo = parcelRequire("beQoo");

var $fC1Kz = parcelRequire("fC1Kz");
/** `Object#toString` result references. */ var $25aa60f3dfdc1028$var$regexpTag = '[object RegExp]';
/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */ function $25aa60f3dfdc1028$var$baseIsRegExp(value) {
    return $fC1Kz(value) && $beQoo(value) == $25aa60f3dfdc1028$var$regexpTag;
}
module.exports = $25aa60f3dfdc1028$var$baseIsRegExp;

});





parcelRegister("7omaD", function(module, exports) {

$parcel$export(module.exports, "TextField", () => $faae5645873154f5$export$2c73285ae9390cec);

var $5uXOq = parcelRequire("5uXOq");

var $iZOJ9 = parcelRequire("iZOJ9");

var $3bDjY = parcelRequire("3bDjY");

var $6s1PB = parcelRequire("6s1PB");

var $1RMb0 = parcelRequire("1RMb0");

var $hCPhj = parcelRequire("hCPhj");

var $dRBdt = parcelRequire("dRBdt");
function $faae5645873154f5$export$2c73285ae9390cec({ field: field }) {
    const isLink = field.renderer === 'url' && !!field.text.trim() && (0, $iZOJ9.isSafeUrl)(field.text) && (0, $6s1PB.expValEquals)('jsw_perf_format-links-in-custom-fields', 'board-and-backlog', true);
    const content = (0, $dRBdt.parseContent)(field.text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: field.label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCPhj.Container), {
        "aria-label": field.label,
        "aria-hidden": (0, $dRBdt.isDefault)(content) ? 'true' : 'false',
        isDefault: (0, $dRBdt.isDefault)(content),
        isLink: isLink
    }, isLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1RMb0.LazySingleLineSmartLink), {
        anchorTarget: "_blank",
        url: content
    }) : content));
}

});
parcelRegister("1RMb0", function(module, exports) {

$parcel$export(module.exports, "LazySingleLineSmartLink", () => $1520f3a29774e13a$export$80092fcb07ccc4b4);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $7c22Q = parcelRequire("7c22Q");
const $1520f3a29774e13a$var$entryPointParams = {};
const $1520f3a29774e13a$export$80092fcb07ccc4b4 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $7c22Q.SingleLineSmartLinkEntryPoint), $1520f3a29774e13a$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "jira.issue-field.single-line-smart-link",
        packageName: "issue-field-smart-link",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props
    });
};

});
parcelRegister("7c22Q", function(module, exports) {

$parcel$export(module.exports, "SingleLineSmartLinkEntryPoint", () => $5f4ae65db2a1976a$export$e236c9b35543c8d);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $5f4ae65db2a1976a$export$e236c9b35543c8d = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("lEZC9")).then((module)=>module.SingleLineSmartLink), {
        moduleId: "97818dc4"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("lEZC9", function(module, exports) {

let $fc4d20b9422643e9$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $fc4d20b9422643e9$var$load("fliVL"),
    $fc4d20b9422643e9$var$load("eVTNs")
]).then(()=>parcelRequire('k2J4N'));

});




parcelRegister("lTDsc", function(module, exports) {

$parcel$export(module.exports, "ThumbnailField", () => $357a48b1bf1d8f71$export$1ed5c8a60ea7f0e6);

var $5uXOq = parcelRequire("5uXOq");

var $dP8up = parcelRequire("dP8up");

var $j3Vfq = parcelRequire("j3Vfq");

var $3bDjY = parcelRequire("3bDjY");

var $hCPhj = parcelRequire("hCPhj");

var $dRBdt = parcelRequire("dRBdt");

var $35nE2 = parcelRequire("35nE2");
function $357a48b1bf1d8f71$export$1ed5c8a60ea7f0e6({ field: field }) {
    const content = (0, $dRBdt.parseContent)(field.html);
    if ((0, $dRBdt.isDefault)(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: field.label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCPhj.Container), {
        "aria-hidden": "true",
        isDefault: (0, $dRBdt.isDefault)(content)
    }, content));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $35nE2.Thumbnail), {
            label: field.label,
            content: content
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dP8up))), {
        "aria-label": field.label,
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($j3Vfq))),
        LEGACY_size: "small",
        label: "",
        color: "var(--ds-icon, #44546F)"
    }));
}

});
parcelRegister("dP8up", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::174ee51c60633f76b0dbf1c968e4afc5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a1069f9774dbd57c$var$_react = $a1069f9774dbd57c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a1069f9774dbd57c$var$_baseNew = $a1069f9774dbd57c$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $a1069f9774dbd57c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Attachment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for attaching files to work types or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a1069f9774dbd57c$var$AttachmentIcon = (props)=>/*#__PURE__*/ $a1069f9774dbd57c$var$_react.default.createElement($a1069f9774dbd57c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m5.22 8.47 4.5-4.5 1.06 1.06-4.5 4.5a.664.664 0 0 0 .94.94l4.5-4.5a2.079 2.079 0 0 0-2.94-2.94l-4.5 4.5a3.492 3.492 0 0 0 4.94 4.94l2.5-2.5 1.06 1.06-2.5 2.5a4.993 4.993 0 0 1-7.06-7.06l4.5-4.5a3.578 3.578 0 0 1 5.06 5.06l-4.5 4.5a2.165 2.165 0 0 1-3.06-3.06"/>`
    }, props));
$a1069f9774dbd57c$var$AttachmentIcon.displayName = 'AttachmentIcon';
var $a1069f9774dbd57c$var$_default = module.exports.default = $a1069f9774dbd57c$var$AttachmentIcon;

});

parcelRegister("j3Vfq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $de0ab45660c611f8$var$_react = $de0ab45660c611f8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $de0ab45660c611f8$var$_attachment = $de0ab45660c611f8$var$_interopRequireDefault((parcelRequire("dP8up")));
function $de0ab45660c611f8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $de0ab45660c611f8$var$AttachmentIcon = (props)=>/*#__PURE__*/ $de0ab45660c611f8$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.643 17.965c-1.53 1.495-4.016 1.496-5.542.004a3.773 3.773 0 0 1 .002-5.412l7.147-6.985a2.316 2.316 0 0 1 3.233-.003c.893.873.895 2.282.004 3.153l-6.703 6.55a.653.653 0 0 1-.914-.008.62.62 0 0 1 0-.902l6.229-6.087a.94.94 0 0 0 0-1.353.995.995 0 0 0-1.384 0l-6.23 6.087a2.5 2.5 0 0 0 0 3.607 2.643 2.643 0 0 0 3.683.009l6.703-6.55a4.074 4.074 0 0 0-.003-5.859 4.306 4.306 0 0 0-6.002.003l-7.148 6.985a5.655 5.655 0 0 0-.001 8.118c2.29 2.239 6.015 2.238 8.31-.005l6.686-6.533a.94.94 0 0 0 0-1.353.995.995 0 0 0-1.384 0z"/></svg>`
    }, props, {
        newIcon: $de0ab45660c611f8$var$_attachment.default
    }));
$de0ab45660c611f8$var$AttachmentIcon.displayName = 'AttachmentIcon';
var $de0ab45660c611f8$var$_default = module.exports.default = $de0ab45660c611f8$var$AttachmentIcon;

});

parcelRegister("35nE2", function(module, exports) {

$parcel$export(module.exports, "Thumbnail", () => $77a779874f565d3f$export$1cd1efc78cb52ca5);

var $5uXOq = parcelRequire("5uXOq");

var $hXLCJ = parcelRequire("hXLCJ");
function $77a779874f565d3f$export$1cd1efc78cb52ca5({ label: label, content: content }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        dangerouslySetInnerHTML: {
            __html: (0, (/*@__PURE__*/$parcel$interopDefault($hXLCJ))).sanitize(content)
        }
    }));
}

});



const $f836df2846e6254b$export$ca45cc072d50480d = 'software-backlog.card-list.card.card-contents.context-menu.menu_placeholder';
const $f836df2846e6254b$export$fb374ae0d58ab29b = 'software-backlog-card-container';

parcelRegister("7q84v", function(module, exports) {

$parcel$export(module.exports, "default", () => $f792d98d36f7133b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f792d98d36f7133b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    childIssuesMetadataTooltip: {
        "id": "backlog.card-list.card.child-issues-metadata-tooltip",
        "defaultMessage": "{complete} of {total, plural, one {# child issue} other {# child issues}} complete"
    },
    cardFocusScreenreaderText: {
        "id": "backlog.card-list.card.card-focus-screenreader-text",
        "defaultMessage": "Use the enter key to load the issue view. Use the space key to move the issue."
    },
    epicLozenge: {
        "id": "backlog.card-list.card.epic-lozenge",
        "defaultMessage": "epic"
    },
    flaggedTooltip: {
        "id": "backlog.card-list.card.flagged-tooltip",
        "defaultMessage": "Flagged"
    },
    addFlagTooltip: {
        "id": "backlog.card-list.card.add-flag-tooltip",
        "defaultMessage": "Add Flag"
    },
    storyPointsTooltip: {
        "id": "backlog.card-list.card.story-points-tooltip",
        "defaultMessage": "Story points"
    },
    storyPointsAriaLabel: {
        "id": "backlog.card-list.card.story-points-aria-label",
        "defaultMessage": "Story points: {storyPointValue}"
    },
    storyPointsAriaLabelNullValue: {
        "id": "backlog.card-list.card.story-points-aria-label-null-value",
        "defaultMessage": "No estimate set"
    },
    statusTooltip: {
        "id": "backlog.card-list.card.status-tooltip",
        "defaultMessage": "Status"
    },
    numberOfChildrenText: {
        "id": "backlog.card-list.card.number-of-children-text",
        "defaultMessage": "{numberOfChildren} {numberOfChildren, plural, one {subtask} other {subtasks}}"
    },
    parentKeyText: {
        "id": "backlog.card-list.card.parent-key-text",
        "defaultMessage": "Subtask of {parentKey}"
    },
    cardGroupToggleExpandedAriaLabel: {
        "id": "backlog.card-list.card.card-group-toggle-expanded-aria-label",
        "defaultMessage": "Hide subtasks for {issueKey} {summary}"
    },
    cardGroupToggleCollapsedAriaLabel: {
        "id": "backlog.card-list.card.card-group-toggle-collapsed-aria-label",
        "defaultMessage": "Show subtasks for {issueKey} {summary}"
    },
    cardGroupToggleTooltipExpand: {
        "id": "backlog.card-list.card.card-group-toggle-tooltip-expand",
        "defaultMessage": "Expand"
    },
    cardGroupToggleTooltipCollapse: {
        "id": "backlog.card-list.card.card-group-toggle-tooltip-collapse",
        "defaultMessage": "Collapse"
    },
    childIssuesMetadataTooltipIssueTermRefresh: {
        "id": "backlog.card-list.card.child-issues-metadata-tooltip-issue-term-refresh",
        "defaultMessage": "{complete} of {total, plural, one {# child work item} other {# child work items}} complete"
    },
    cardFocusScreenreaderTextIssueTermRefresh: {
        "id": "backlog.card-list.card.card-focus-screenreader-text-issue-term-refresh",
        "defaultMessage": "Use the enter key to load the work item. Use the space key to move the work item."
    },
    cardCheckboxLabel: {
        "id": "backlog.card-list.card.checkbox.label",
        "defaultMessage": "Select {cardKey} {summary}"
    }
});

});

parcelRegister("kM28N", function(module, exports) {

$parcel$export(module.exports, "Key", () => $7890ada1e2d232ce$export$cd0f44441c3b7719);
$parcel$export(module.exports, "Img", () => $7890ada1e2d232ce$export$cc7b5f925acc71d3);
$parcel$export(module.exports, "CheckboxContainer", () => $7890ada1e2d232ce$export$be6fcc6a7e078caa);
$parcel$export(module.exports, "ImageContainer", () => $7890ada1e2d232ce$export$94026ee33dbabc26);
$parcel$export(module.exports, "KeyContainer", () => $7890ada1e2d232ce$export$87cb5a8bc2c72dc8);
$parcel$export(module.exports, "ScreenReaderKey", () => $7890ada1e2d232ce$export$543895d0ab5334d);
$parcel$export(module.exports, "SummaryAndParentContainer", () => $7890ada1e2d232ce$export$b2027db09cc3f848);
$parcel$export(module.exports, "SummaryWrapper", () => $7890ada1e2d232ce$export$b13648308b87115);
$parcel$export(module.exports, "Summary", () => $7890ada1e2d232ce$export$46453a0401d6cd1a);
$parcel$export(module.exports, "EpicWrapper", () => $7890ada1e2d232ce$export$6dc4dd6105cae5b0);
$parcel$export(module.exports, "ExtraFieldsContainer", () => $7890ada1e2d232ce$export$716284ed33ba9160);
$parcel$export(module.exports, "AssigneeContainer", () => $7890ada1e2d232ce$export$35cb5ad1a5a164c6);
$parcel$export(module.exports, "MenuPlaceholderOld", () => $7890ada1e2d232ce$export$d171f3928c2698c7);
$parcel$export(module.exports, "DragHandleCardsAmount", () => $7890ada1e2d232ce$export$574576b1d7c68429);
$parcel$export(module.exports, "StyledSpinner", () => $7890ada1e2d232ce$export$a7b75c5e23a48343);
$parcel$export(module.exports, "OptionalFieldsContainer", () => $7890ada1e2d232ce$export$2c60bada4ddd3b79);
$parcel$export(module.exports, "CardContainer", () => $7890ada1e2d232ce$export$8a23e74e5cf3ca41);
$parcel$export(module.exports, "ContentContainer", () => $7890ada1e2d232ce$export$9d2b4227a95687cc);
$parcel$export(module.exports, "CardGroupKey", () => $7890ada1e2d232ce$export$18c03323864bfda5);
$parcel$export(module.exports, "VersionIconWrapper", () => $7890ada1e2d232ce$export$e010d58e8595e079);
$parcel$export(module.exports, "VersionIconNumber", () => $7890ada1e2d232ce$export$b224c3920d5dc114);
$parcel$export(module.exports, "SubtaskIconWrapper", () => $7890ada1e2d232ce$export$bafafde73fef7397);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $fVnbM = parcelRequire("fVnbM");

var $gwIPs = parcelRequire("gwIPs");

var $dCm1o = parcelRequire("dCm1o");

var $2lpqS = parcelRequire("2lpqS");
const $7890ada1e2d232ce$export$122b84414b9478ae = (isSelected, isFlagged, isVisualRefreshBeta)=>{
    let bgColor = "var(--ds-surface-raised, #FFFFFF)";
    if (isFlagged && isSelected) bgColor = isVisualRefreshBeta ? "var(--ds-background-accent-red-subtlest-pressed, #FD9891)" : "var(--ds-background-warning-pressed, #F5CD47)";
    else if (isFlagged) bgColor = isVisualRefreshBeta ? "var(--ds-background-accent-red-subtlest, #FFECEB)" : "var(--ds-background-warning, #FFF7D6)";
    else if (isSelected) bgColor = "var(--ds-background-selected, #E9F2FF)";
    return bgColor;
};
const $7890ada1e2d232ce$var$getHoverBgColor = (isSelected, isFlagged, isVisualRefreshBeta)=>{
    let hoverBgColor = "var(--ds-background-neutral-subtle-hovered, #091E420F)";
    if (isFlagged) hoverBgColor = isVisualRefreshBeta ? "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)" : "var(--ds-background-warning-hovered, #F8E6A0)";
    else if (isSelected) hoverBgColor = "var(--ds-background-selected-hovered, #CCE0FF)";
    return hoverBgColor;
};
const $7890ada1e2d232ce$export$cd0f44441c3b7719 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDone: isDone, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _12ji1r31 _1qu2glyw _12y31o36 _syaz1gjq _19pkidpf _o5721q9c",
            (0, $dCm1o.isVisualRefreshEnabled)() ? "_k48pi7a9" : "_k48p1pd9",
            (0, $dCm1o.isVisualRefreshEnabled)() && "_1x821ts4",
            __cmplp.isDone ?? false ? "_4bfu1r81 _1hms1cog _ajmmvv82" : "_4bfu1r81 _1hmsagmp _ajmmvv82",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$cc7b5f925acc71d3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb7vkz _4t3i7vkz _s7n41ndm",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$be6fcc6a7e078caa = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldShowCheckbox: shouldShowCheckbox, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_yyhy168a _1ii7wtyw _1bsb7vkz _1pbykb7n _1e0c1txw _1bah1h6o",
            __cmplp.shouldShowCheckbox ? "_3um0ewfl" : "_3um015vq",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$fc8eb8928c84ef7b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1reo15vq _18m915vq _1bsbdlk8 _4t3idlk8",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$94026ee33dbabc26 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_yyhy11t1 _1ii7wtyw",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$87cb5a8bc2c72dc8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_yyhy1l0g _1ii7wtyw _kqswh2mm _1pbykb7n",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$543895d0ab5334d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $7890ada1e2d232ce$export$cd0f44441c3b7719, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1nagidpf _172jidpf _1lrxidpf _1akkidpf _14tvidpf _1k9z15vq _xghe15vq _1ma0t94y _1ybtt94y _nxshstnw _142m7mnp _1n1p1q9c _nt751r31 _49pcglyw _1hvw1o36 _7ehi1vm4 _twmeglyw _1q5t1r31 _1ohyglyw _1r9x1o36",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$b2027db09cc3f848 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSummaryFieldEditing: isSummaryFieldEditing, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _yyhy1uzv _1ii7wtyw _1e0c1txw _vchhusvi _uiztglyw _4cvr1h6o _1ul9idpf _1ouwidpf",
            __cmplp.isSummaryFieldEditing ? "_kqswh2mm" : "_kqswn7od",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$b13648308b87115 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSummaryFieldEditing: isSummaryFieldEditing, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_19g2etl": (0, $lD23V.default)(__cmplp.isSummaryFieldEditing && '100%')
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_12ji1r31 _1qu2glyw _12y31o36 _1bsbstyr",
            __cmplp.isSummaryFieldEditing ? "_1pbycs5v" : "_1pbykb7n",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$46453a0401d6cd1a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _syaz1fxt _o5721q9c _1bto1l2s _1kt9b3bt _cfu11ule",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$6dc4dd6105cae5b0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { widthMultiplier: widthMultiplier, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_uu7jbp": (0, $lD23V.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `repeat(auto-fit,${(0, $gwIPs.gridSize) * __cmplp.widthMultiplier}px)`),
            "--_ichgug": (0, $lD23V.default)(`${(0, $gwIPs.gridSize) * __cmplp.widthMultiplier}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c11p5 _6a6zv2br _yv0e105t _1ul9bcwo",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$56fba512661ff388 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { widthMultiplier: widthMultiplier, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_uu7jbp": (0, $lD23V.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `repeat(auto-fit,${(0, $gwIPs.gridSize) * __cmplp.widthMultiplier}px)`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c11p5 _1pbykb7n _1bto1l2s _4cvr1h6o _6a6zv2br _lcxvglyw _yv0e105t",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$d6d2b7ad039cd190 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1pbykb7n",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$15529022dcaf3eec = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { widthMultiplier: widthMultiplier, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_uu7jbp": (0, $lD23V.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `repeat(auto-fit,${(0, $gwIPs.gridSize) * __cmplp.widthMultiplier}px)`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo1kw7 _18m91kw7 _1e0c11p5 _4t3i1tcg _lcxvglyw _yv0e105t",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$716284ed33ba9160 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hideTypeIcon: hideTypeIcon, isSmartCardEnabled: isSmartCardEnabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1ii7pazf _1e0c11p5 _vchhusvi _yv0eql95 _4cvrv2br _syaz131l _gy1p1b66 _1ouwidpf _vqbzkb7n",
            __cmplp.hideTypeIcon ? "_yyhy4co5" : "_yyhydpws",
            __cmplp.isSmartCardEnabled ? "_4t3i1ejb" : "_4t3i1ul9",
            __cmplp.isSmartCardEnabled ? "_ca0qv77o" : "_ca0qze3t",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$35cb5ad1a5a164c6 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_yyhy1eaj _1ii7wtyw",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$d171f3928c2698c7 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isMenuOpen: isMenuOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_yyhy1m0k _1ii7wtyw _1ul9xy5q _kqswh2mm",
            __cmplp.isMenuOpen ? "_3um0ewfl" : "_3um015vq",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$444c71687e56d76e = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1pbyqfx8 _154iidpf _1xi2idpf _t9ec1tul",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$574576b1d7c68429 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1pbyqfx8 _154ir5cr _1ltvr5cr _t9ec1tul",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$a7b75c5e23a48343 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_yyhy1m0k _1ii7wtyw",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$2c60bada4ddd3b79 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_yyhy1sd3 _1ii7wtyw _yv0e1gmk _1e0c1txw _vchhusvi _4cvr1h6o _1nvfidpf _1nei1b66 _rt2pidpf _bmks1b66 _1bmuidpf _1uu8idpf",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$c20c19c635a1723f = ()=>'[start checkbox] min-content ';
const $7890ada1e2d232ce$export$cf4b3a0da67596a8 = (gridTemplateColumnsValue, shouldShowChevron)=>{
    if (shouldShowChevron) {
        if (gridTemplateColumnsValue) return '[chevron] 20px';
        return '[start chevron] 12px ';
    }
    return '';
};
const $7890ada1e2d232ce$export$73efac7034b68854 = (gridTemplateColumnsValue)=>{
    if (gridTemplateColumnsValue) return '[issue-type] 16px ';
    return '[start issue-type] 16px ';
};
const $7890ada1e2d232ce$export$4439a7282ef88de8 = ({ isOptimistic: isOptimistic })=>{
    if (isOptimistic) return `0 ${(0, $gwIPs.gridSize) / 2}px 0 ${(0, $gwIPs.gridSize) * 3.5}px`;
    return `0 ${(0, $gwIPs.gridSize) / 2}px 0 ${(0, $gwIPs.gridSize) * 1.5}px`;
};
const $7890ada1e2d232ce$var$calculateGridTemplateValues = ({ hasExtraFields: hasExtraFields, shouldShowChevron: shouldShowChevron, isDragHandle: isDragHandle, isCompact: isCompact = false, hideTypeIcon: hideTypeIcon = false, isAssigneeShown: isAssigneeShown = true })=>{
    let gridTemplateColumnsValue = '';
    let gridTemplateRowsValue = '';
    gridTemplateColumnsValue += $7890ada1e2d232ce$export$c20c19c635a1723f();
    gridTemplateColumnsValue += $7890ada1e2d232ce$export$cf4b3a0da67596a8(gridTemplateColumnsValue, shouldShowChevron);
    if (!hideTypeIcon) gridTemplateColumnsValue += $7890ada1e2d232ce$export$73efac7034b68854(gridTemplateColumnsValue);
    gridTemplateColumnsValue += '[issue-key] min-content [summary] 1fr';
    if (!isDragHandle) {
        gridTemplateColumnsValue += ' ';
        gridTemplateColumnsValue += '[card-group-key] max-content ';
        gridTemplateColumnsValue += [
            '[optional-fields] max-content',
            /* These values have to be in PX to ensure the elements take exactly the amount of space they need. Using a token/REM causes issues if browser's font size settings are set to smaller or larger */ `[assignee] ${isAssigneeShown ? 'calc(8px * 3.5)' : "var(--ds-space-0, 0px)"}`,
            '[menu] 32px',
            '[end]'
        ].join(' ');
    }
    // Minus 1 to fix layout issues
    // We need to totally rework the layout to do this properly
    gridTemplateRowsValue += `[start card-detail] ${(isCompact ? (0, $2lpqS.COMPACT_CARD_ROW_HEIGHT) : (0, $2lpqS.CARD_ROW_HEIGHT)) - 1}px `;
    if (!isDragHandle && hasExtraFields) gridTemplateRowsValue += `[card-extra-fields] ${0, $2lpqS.EXTRA_CARD_ROW_HEIGHT}px [end]`;
    else gridTemplateRowsValue += '[end]';
    return {
        gridTemplateColumnsValue: gridTemplateColumnsValue,
        gridTemplateRowsValue: gridTemplateRowsValue
    };
};
const $7890ada1e2d232ce$export$8a23e74e5cf3ca41 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, isFlagged: isFlagged, isVisualRefreshBeta: isVisualRefreshBeta, isDraggable: isDraggable, lowerOpacity: lowerOpacity, hasExtraFields: hasExtraFields, shouldShowChevron: shouldShowChevron, isDragHandle: isDragHandle, isCompact: isCompact, hideTypeIcon: hideTypeIcon, isAssigneeShown: isAssigneeShown, isOptimistic: isOptimistic, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1mup0wr": (0, $lD23V.default)($7890ada1e2d232ce$export$122b84414b9478ae(__cmplp.isSelected ?? false, __cmplp.isFlagged ?? false, __cmplp.isVisualRefreshBeta)),
            "--_183xcfk": (0, $lD23V.default)($7890ada1e2d232ce$var$calculateGridTemplateValues({
                hasExtraFields: __cmplp.hasExtraFields,
                shouldShowChevron: __cmplp.shouldShowChevron,
                isDragHandle: __cmplp.isDragHandle,
                isCompact: __cmplp.isCompact ?? false,
                hideTypeIcon: __cmplp.hideTypeIcon ?? false,
                isAssigneeShown: __cmplp.isAssigneeShown ?? true
            }).gridTemplateColumnsValue),
            "--_1d7lvij": (0, $lD23V.default)($7890ada1e2d232ce$var$calculateGridTemplateValues({
                hasExtraFields: __cmplp.hasExtraFields,
                shouldShowChevron: __cmplp.shouldShowChevron,
                isDragHandle: __cmplp.isDragHandle,
                isCompact: __cmplp.isCompact ?? false,
                hideTypeIcon: __cmplp.hideTypeIcon ?? false,
                isAssigneeShown: __cmplp.isAssigneeShown ?? true
            }).gridTemplateRowsValue),
            "--_vwvgr5": (0, $lD23V.default)((()=>{
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                const cardRowHeight = __cmplp.isCompact ?? false ? (0, $2lpqS.COMPACT_CARD_ROW_HEIGHT) : (0, $2lpqS.CARD_ROW_HEIGHT);
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                return __cmplp.hasExtraFields ? `${cardRowHeight + (0, $2lpqS.EXTRA_CARD_ROW_HEIGHT)}px` : `${cardRowHeight}px`;
            })()),
            "--_xn0y17": (0, $lD23V.default)($7890ada1e2d232ce$export$4439a7282ef88de8({
                isOptimistic: __cmplp.isOptimistic
            })),
            "--_1htjs8": (0, $lD23V.default)($7890ada1e2d232ce$var$getHoverBgColor(__cmplp.isSelected ?? false, __cmplp.isFlagged ?? false, __cmplp.isVisualRefreshBeta)),
            "--_13xqh42": (0, $lD23V.default)($7890ada1e2d232ce$var$getHoverBgColor(__cmplp.isSelected ?? false, __cmplp.isFlagged ?? false)),
            "--_fbeie2": (0, $lD23V.default)($7890ada1e2d232ce$export$122b84414b9478ae(__cmplp.isSelected ?? false, __cmplp.isFlagged ?? false))
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt414ue _4bfu18uv _1hmsglyw _ajmmnqa1 _189et94y _1dqonqa1 _1h6dmuej _bfhkp6r5 _1e0c11p5 _yv0es54b _2z05kxnq _gy1p1b66 _1p57idpf _4cvr1h6o _kqswh2mm _4t3i8lrv _19pk1i6y _1tvzbi58 _145ekb7n _1fn0kb7n _v8f3ewfl _f48lewfl _1jy6ewfl _16cmewfl _irr31udv _nhtqmtee _o0l1kb7n _kb9newfl _7zc6ewfl",
            __cmplp.isDraggable === true ? "_80omtlke" : "_80om73ad",
            __cmplp.lowerOpacity ? "_tzy41ou4" : "_tzy41kw7",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$9d2b4227a95687cc = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_12ji1r31 _1qu2glyw _12y31o36 _bfhkhp5a",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$18c03323864bfda5 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $7890ada1e2d232ce$export$cd0f44441c3b7719, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqsw1kw7 _1e0c1bgi",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$e010d58e8595e079 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx2vrvc",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$b224c3920d5dc114 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81o8v _kqswh2mm _syaz131l _k48pmoej _19bvv77o",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$44715ef83bdcca01 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_v564ch4h _tzy4idpf _19pkr5cr _2hwxr5cr _otyrr5cr _18u0r5cr _19lcglyw _16l4kb7n",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$bafafde73fef7397 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1pbykb7n",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$2780fb0d195b1a91 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldRenderColumn: shouldRenderColumn, hasDueDate: hasDueDate, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_13v9lkb": (0, $lD23V.default)(__cmplp.hasDueDate ? `${(0, $gwIPs.gridSize) * 7.5}px` : `${(0, $gwIPs.gridSize) * 8}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.shouldRenderColumn && "_1ul9n9pv",
            __cmplp.className
        ])
    });
});

});

parcelRegister("khnfQ", function(module, exports) {

$parcel$export(module.exports, "ScreenThreshold", () => $5825eef39a1eb963$export$e533650b80af8cf3);
$parcel$export(module.exports, "ScreenSize", () => $5825eef39a1eb963$export$9098989df19ab765);
const $5825eef39a1eb963$export$e533650b80af8cf3 = {
    EXTRA_SMALL: 768,
    SMALL: 1024,
    MEDIUM: 1440,
    LARGE: 1760
};
const $5825eef39a1eb963$export$9098989df19ab765 = {
    EXTRA_SMALL: 'xs',
    SMALL: 'sm',
    MEDIUM: 'md',
    LARGE: 'lg',
    EXTRA_LARGE: 'xl'
};

});

parcelRegister("3JQPC", function(module, exports) {

$parcel$export(module.exports, "ContainerSizeContext", () => $2f896c9192634f12$export$a78b219fc961f8cd);
$parcel$export(module.exports, "useContainerSize", () => $2f896c9192634f12$export$1b2c18f86b4398c2);
$parcel$export(module.exports, "useBacklogContainerSize", () => $2f896c9192634f12$export$d6913af4e936e4ae);

var $5uXOq = parcelRequire("5uXOq");

var $2m0b6 = parcelRequire("2m0b6");

var $khnfQ = parcelRequire("khnfQ");
const $2f896c9192634f12$export$a78b219fc961f8cd = /*#__PURE__*/ (0, $5uXOq.createContext)({
    size: (0, $khnfQ.ScreenSize).MEDIUM
});
const $2f896c9192634f12$export$1b2c18f86b4398c2 = ()=>(0, $5uXOq.useContext)($2f896c9192634f12$export$a78b219fc961f8cd);
function $2f896c9192634f12$var$getBacklogContainerSize(offsetWidth) {
    if (offsetWidth === undefined) return (0, $khnfQ.ScreenSize).MEDIUM;
    if (offsetWidth < (0, $khnfQ.ScreenThreshold).EXTRA_SMALL) return (0, $khnfQ.ScreenSize).EXTRA_SMALL;
    if (offsetWidth > (0, $khnfQ.ScreenThreshold).EXTRA_SMALL && offsetWidth < (0, $khnfQ.ScreenThreshold).SMALL) return (0, $khnfQ.ScreenSize).SMALL;
    if (offsetWidth > (0, $khnfQ.ScreenThreshold).SMALL && offsetWidth < (0, $khnfQ.ScreenThreshold).MEDIUM) return (0, $khnfQ.ScreenSize).MEDIUM;
    if (offsetWidth > (0, $khnfQ.ScreenThreshold).MEDIUM && (0, $khnfQ.ScreenThreshold).LARGE) return (0, $khnfQ.ScreenSize).LARGE;
    return (0, $khnfQ.ScreenSize).EXTRA_LARGE;
}
function $2f896c9192634f12$export$d6913af4e936e4ae({ ref: ref }) {
    const [backlogContainerSize, setBacklogContainerSize] = (0, $5uXOq.useState)(ref.current?.offsetWidth !== undefined ? $2f896c9192634f12$var$getBacklogContainerSize(ref.current?.offsetWidth) : (0, $khnfQ.ScreenSize).MEDIUM);
    (0, $2m0b6.useResizeObserver)({
        ref: ref,
        onResize () {
            if (ref.current) {
                const { offsetWidth: offsetWidth } = ref.current;
                setBacklogContainerSize(offsetWidth !== undefined ? $2f896c9192634f12$var$getBacklogContainerSize(offsetWidth) : (0, $khnfQ.ScreenSize).MEDIUM);
            }
        }
    });
    return backlogContainerSize;
}

});

parcelRegister("4w5xH", function(module, exports) {

$parcel$export(module.exports, "AssigneeLite", () => $d9374eb07d3643c0$export$a031037f4a309a04);

var $5uXOq = parcelRequire("5uXOq");

var $ujWmd = parcelRequire("ujWmd");

var $3fAi8 = parcelRequire("3fAi8");


var $iDGXn = parcelRequire("iDGXn");

var $kAodW = parcelRequire("kAodW");
const $d9374eb07d3643c0$export$a031037f4a309a04 = ({ issueKey: issueKey })=>{
    const showAssignee = (0, $iDGXn.useShowAssignee)();
    const [assigneeFieldValue] = (0, $3fAi8.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $e9be48d6d2c01760$export$e18419056f3d184a)
    });
    const value = assigneeFieldValue ? {
        id: assigneeFieldValue.accountId,
        displayName: assigneeFieldValue.displayName,
        avatarUrl: assigneeFieldValue.avatarUrls?.['48x48']
    } : null;
    return showAssignee ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kAodW.AvatarWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        src: value?.avatarUrl,
        size: "small",
        borderColor: "transparent"
    })) : null;
};

});
parcelRegister("kAodW", function(module, exports) {

$parcel$export(module.exports, "AvatarWrapper", () => $1c29bb03d4c1e343$export$f7513421c53ce141);
$parcel$export(module.exports, "default", () => $1c29bb03d4c1e343$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ujWmd = parcelRequire("ujWmd");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $8Wp1B = parcelRequire("8Wp1B");
const $1c29bb03d4c1e343$export$20dedc39b82b5168 = ({ value: value })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const name = value?.id ? formatMessage((0, $8Wp1B.default).assigneeTooltip, {
        name: value.displayName
    }) : formatMessage((0, $8Wp1B.default).assigneeTooltipUnassigned);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1c29bb03d4c1e343$export$f7513421c53ce141, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        src: value?.avatarUrl,
        name: name,
        size: "small",
        borderColor: "transparent"
    })));
};
var $1c29bb03d4c1e343$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($1c29bb03d4c1e343$export$20dedc39b82b5168);
const $1c29bb03d4c1e343$export$f7513421c53ce141 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1f4h _80om73ad",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8Wp1B", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b55e76c620f1978$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2b55e76c620f1978$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    assigneeTooltip: {
        "id": "backlog.card-list.card.card-contents.assignee-field.assignee-field-static.assignee-tooltip",
        "defaultMessage": "Assignee: {name}"
    },
    assigneeTooltipUnassigned: {
        "id": "backlog.card-list.card.card-contents.assignee-field.assignee-field-static.assignee-tooltip-unassigned",
        "defaultMessage": "Unassigned"
    }
});

});



parcelRegister("1OiOR", function(module, exports) {

$parcel$export(module.exports, "DueDate", () => $5513aeaaa590b47f$export$4c248a4717685909);

var $5uXOq = parcelRequire("5uXOq");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");

var $13fTq = parcelRequire("13fTq");
const $5513aeaaa590b47f$export$4c248a4717685909 = (props)=>{
    const shouldRenderDueDateColumn = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasDueDate));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $13fTq.DueDate), {
        ...props,
        shouldRenderDueDateColumn: shouldRenderDueDateColumn
    });
};

});
parcelRegister("13fTq", function(module, exports) {

$parcel$export(module.exports, "DueDate", () => $7bddcbbc6ff4e4a5$export$4c248a4717685909);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $gwIPs = parcelRequire("gwIPs");

var $itzcE = parcelRequire("itzcE");

var $dCm1o = parcelRequire("dCm1o");
const $7bddcbbc6ff4e4a5$export$4c248a4717685909 = ({ dueDate: dueDate, shouldRenderDueDateColumn: shouldRenderDueDateColumn, isDone: isDone })=>{
    const cardDueDate = dueDate || '';
    const dueDateNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $itzcE.CardDueDate), {
        dueDate: cardDueDate,
        isCompleted: isDone,
        isShortFormat: true
    });
    return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: "software-backlog.card-list.card.card-contents.due-date",
        xcss: [
            $7bddcbbc6ff4e4a5$var$wrapperStyles,
            shouldRenderDueDateColumn && $7bddcbbc6ff4e4a5$var$wrapperStylesWithColumn
        ]
    }, cardDueDate ? dueDateNode : null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7bddcbbc6ff4e4a5$var$CardDueDateWrapper, {
        shouldRenderColumn: shouldRenderDueDateColumn,
        hasDueDate: dueDate !== null,
        "data-testid": "software-backlog.card-list.card.card-contents.due-date",
        visualRefresh: (0, $dCm1o.isVisualRefreshEnabled)()
    }, cardDueDate ? dueDateNode : null);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7bddcbbc6ff4e4a5$var$CardDueDateWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldRenderColumn: shouldRenderColumn, visualRefresh: visualRefresh, hasDueDate: hasDueDate, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1s2raoz": (0, $lD23V.default)(__cmplp.visualRefresh ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            `${__cmplp.hasDueDate ? `${(0, $gwIPs.gridSize) * 7.5}px` : `${(0, $gwIPs.gridSize) * 9.6}px`}` : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            `${__cmplp.hasDueDate ? `${(0, $gwIPs.gridSize) * 7.5}px` : `${(0, $gwIPs.gridSize) * 8}px`}`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.shouldRenderColumn && "_1ul99em0",
            __cmplp.className
        ])
    });
});
const $7bddcbbc6ff4e4a5$var$wrapperStyles = (0, $8CUq3.xcss)({
    display: 'flex'
});
const $7bddcbbc6ff4e4a5$var$wrapperStylesWithColumn = (0, $8CUq3.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    minWidth: `${(0, $gwIPs.gridSize) * 10.2}px`
});

});
parcelRegister("itzcE", function(module, exports) {

$parcel$export(module.exports, "CardDueDate", () => $1f73e6aec72eb1bf$export$9e242219cf1cc36c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4mBKK = parcelRequire("4mBKK");
var $70Rr2 = parcelRequire("70Rr2");
var $k7m40 = parcelRequire("k7m40");
var $eZDAP = parcelRequire("eZDAP");
var $it1wb = parcelRequire("it1wb");

var $3u0c5 = parcelRequire("3u0c5");

var $3bDjY = parcelRequire("3bDjY");

var $d9xxV = parcelRequire("d9xxV");

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $f1akg = parcelRequire("f1akg");

var $8uZt8 = parcelRequire("8uZt8");


var $eDs1Y = parcelRequire("eDs1Y");
const $1f73e6aec72eb1bf$export$9e242219cf1cc36c = (props)=>{
    const { isCompleted: isCompleted, dueDate: dueDate, dateFormat: dateFormat, isShortFormat: isShortFormat = false } = props;
    const dueDateEndOfDay = (0, $70Rr2.default)((0, $eZDAP.default)(dueDate));
    const currentDate = (0, $it1wb.default)(new Date());
    const diffInDays = (0, $4mBKK.default)(dueDateEndOfDay, currentDate);
    const isDueBeforeToday = diffInDays <= 0;
    const isOverDue = isCompleted !== true && isDueBeforeToday;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const formattedDueDate = dateFormat !== undefined && dateFormat !== null ? (0, $k7m40.default)(dueDateEndOfDay, dateFormat) : (0, $k7m40.default)(dueDateEndOfDay, 'dd MMM');
    const formattedTooltip = formatMessage((0, $eDs1Y.messages).text, {
        date: (0, $k7m40.default)(dueDateEndOfDay, 'dd MMMM yyyy')
    });
    if ((0, $dCm1o.isVisualRefreshEnabled)()) {
        if (!dueDate) return null;
        return (0, $6s1PB.expVal)('color_due_date_all_views', 'showColoredDueDate', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f1akg.ColoredDueDate), {
            dateString: dueDate,
            pastDue: isCompleted !== true && diffInDays < 0,
            dueToday: diffInDays === 0,
            warningIconTestId: "platform-card.common.ui.due-date.warning-icon",
            clockIconTestId: "platform-card.common.ui.due-date.clock-icon",
            calendarIconTestId: "platform-card.common.ui.due-date.calendar-icon",
            tooltipTestId: "platform-card.common.ui.due-date.tooltip",
            isShortFormat: isShortFormat
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formattedTooltip,
            testId: "platform-card.common.ui.due-date.tooltip"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1f73e6aec72eb1bf$var$TagHack, {
            tagColor: $1f73e6aec72eb1bf$var$dueDateLozengeStyle(isOverDue).color
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9xxV.default), {
            testId: "platform-card.common.ui.due-date.tag",
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8uZt8.default), {
                type: (0, $6d6eac2504286faf$export$d4ee7b46933c494f),
                label: formattedTooltip
            }),
            text: formattedDueDate
        })));
    }
    /* eslint-disable jira/react/no-style-attribute */ return dueDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    ), {
        style: $1f73e6aec72eb1bf$var$dueDateLozengeStyle(isOverDue),
        testId: "platform-card.common.ui.due-date.lozenge"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formattedTooltip,
        testId: "platform-card.common.ui.due-date.tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1f73e6aec72eb1bf$var$Content, {
        "aria-label": formattedTooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8uZt8.default), {
        type: (0, $6d6eac2504286faf$export$d4ee7b46933c494f),
        label: formattedTooltip
    }), formattedDueDate))) : null; /* eslint-enable jira/react/no-style-attribute */ 
};
$1f73e6aec72eb1bf$export$9e242219cf1cc36c.defaultProps = {
    isCompleted: false
};
var $1f73e6aec72eb1bf$export$2e2bcd8739ae039 //! This is used to override the default theme as Tag doesn't support custom styles.
 = $1f73e6aec72eb1bf$export$9e242219cf1cc36c;
const $1f73e6aec72eb1bf$var$tagHackStyles = null;
const $1f73e6aec72eb1bf$var$TagHack = ({ tagColor: tagColor, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div" // eslint-disable-next-line jira/react/no-style-attribute
    , {
        style: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {
            '--due-date-tag-color': tagColor
        },
        className: (0, $bwpsq.default)([
            "_1e0c116y _1npcidpf _1gicidpf _1e09idpf _1mspidpf _1h4r19ik _1m9k19ik"
        ])
    }, children);
const $1f73e6aec72eb1bf$var$dueDateLozengeStyle = (isOverDue)=>isOverDue ? {
        color: "var(--ds-text-accent-red, #AE2E24)",
        backgroundColor: "var(--ds-background-danger, #FFECEB)"
    } : {
        color: "var(--ds-text-subtle, #44546F)",
        backgroundColor: "var(--ds-background-neutral, #091E420F)"
    }; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1f73e6aec72eb1bf$var$ContentOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1n261g80",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1f73e6aec72eb1bf$var$ContentNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1b66 _1e0c1txw _4cvr1h6o _1n261g80 _1x821ts4 _1ul9t9kd",
            __cmplp.className
        ])
    });
});
const $1f73e6aec72eb1bf$var$Content = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $1f73e6aec72eb1bf$var$ContentNew, $1f73e6aec72eb1bf$var$ContentOld);

});
parcelRegister("f1akg", function(module, exports) {

$parcel$export(module.exports, "ColoredDueDate", () => $3f739dd1d004c9d2$export$63c54814247cca36);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $jpopi = parcelRequire("jpopi");

var $acknU = parcelRequire("acknU");

var $hyKRO = parcelRequire("hyKRO");

var $jCESp = parcelRequire("jCESp");

var $3bDjY = parcelRequire("3bDjY");

var $DVljb = parcelRequire("DVljb");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $1eyaH = parcelRequire("1eyaH");

var $cpjnU = parcelRequire("cpjnU");

var $CKlOf = parcelRequire("CKlOf");
const $3f739dd1d004c9d2$var$RecurringWorkItemIcon = ({ testId: testId })=>{
    const { issueProperties: issueProperties, isUpdatingRule: isUpdatingRule } = (0, $1eyaH.useRecurWorkItemState)();
    if (!issueProperties && !isUpdatingRule || (0, $cpjnU.isRecurOnCompleteToggleRule)(issueProperties)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jpopi))), {
        label: "",
        testId: testId
    });
};
const $3f739dd1d004c9d2$export$63c54814247cca36 = ({ dateString: dateString, pastDue: pastDue, dueToday: dueToday, warningIconTestId: warningIconTestId, clockIconTestId: clockIconTestId, calendarIconTestId: calendarIconTestId, tooltipTestId: tooltipTestId, isShortFormat: isShortFormat = false, maybeShowRecurIcon: maybeShowRecurIcon = false, recurIconTestId: recurIconTestId })=>{
    const locale = (0, $DVljb.useLocale)();
    const localeString = locale.replace('_', '-');
    const formatter = new Intl.DateTimeFormat(localeString, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        timeZone: 'UTC',
        timeZoneName: 'short'
    });
    const parts = formatter.formatToParts(new Date(dateString));
    const formatDateParts = ({ dateParts: dateParts, includeYear: includeYear = true, includeTimezone: includeTimezone = false })=>{
        let result = '';
        dateParts.forEach((part, index)=>{
            const nextPart = dateParts[index + 1];
            const skipCurrentPart = !includeTimezone && nextPart?.type === 'timeZoneName' && part.type === 'literal' && part.value === ', ';
            if (!skipCurrentPart && (part.type === 'year' && includeYear || part.type === 'timeZoneName' && includeTimezone || part.type !== 'year' && part.type !== 'timeZoneName')) result += part.value;
        });
        return result;
    };
    const displayDate = isShortFormat ? formatDateParts({
        dateParts: parts,
        includeYear: false
    }) : formatDateParts({
        dateParts: parts
    });
    const tooltipDate = formatDateParts({
        dateParts: parts,
        includeYear: true,
        includeTimezone: true
    });
    const dueMessage = pastDue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $CKlOf.messages).overdue,
        values: {
            date: tooltipDate
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $CKlOf.messages).due,
        values: {
            date: tooltipDate
        }
    });
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const iconLabel = pastDue ? formatMessage((0, $CKlOf.messages).overdue, {
        date: tooltipDate
    }) : formatMessage((0, $CKlOf.messages).due, {
        date: tooltipDate
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: dueMessage,
        position: "top",
        testId: tooltipTestId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $3f739dd1d004c9d2$var$styles.dateTag,
            $3f739dd1d004c9d2$var$styles.flexContainer,
            pastDue ? $3f739dd1d004c9d2$var$styles.overdue : undefined,
            dueToday ? $3f739dd1d004c9d2$var$styles.dueToday : undefined,
            !pastDue && !dueToday ? $3f739dd1d004c9d2$var$styles.normalDate : undefined
        ],
        testId: "coloured-due-date.ui.colored-due-date-container",
        tabIndex: 0,
        role: "button",
        "aria-label": iconLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $3f739dd1d004c9d2$var$styles.dueDateIcon,
        testId: "coloured-due-date.ui.tooltip-container"
    }, pastDue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jCESp))), {
        LEGACY_size: "medium",
        label: iconLabel,
        color: "var(--ds-text-danger, #AE2E24)",
        testId: warningIconTestId
    }), dueToday && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hyKRO))), {
        LEGACY_size: "medium",
        label: iconLabel,
        color: "var(--ds-text-warning, #A54800)",
        testId: clockIconTestId
    }), !dueToday && !pastDue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acknU))), {
        label: iconLabel,
        color: "var(--ds-text, #172B4D)",
        LEGACY_size: "medium",
        testId: calendarIconTestId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "aria-hidden": "true"
    }, displayDate), maybeShowRecurIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3f739dd1d004c9d2$var$RecurringWorkItemIcon, {
        testId: recurIconTestId
    })));
};
const $3f739dd1d004c9d2$var$styles = {
    dateTag: (0, $8CUq3.xcss)({
        paddingLeft: 'space.075',
        paddingRight: 'space.075',
        borderStyle: 'solid',
        borderRadius: 'border.radius.100',
        borderWidth: 'border.width',
        color: 'color.text',
        cursor: 'pointer'
    }),
    flexContainer: (0, $8CUq3.xcss)({
        display: 'flex',
        alignItems: 'center',
        gap: 'space.050'
    }),
    overdue: (0, $8CUq3.xcss)({
        color: 'color.text.danger',
        borderColor: 'color.border.danger'
    }),
    dueToday: (0, $8CUq3.xcss)({
        color: 'color.text.warning',
        borderColor: 'color.border.warning'
    }),
    normalDate: (0, $8CUq3.xcss)({
        color: 'color.text',
        borderColor: 'color.border'
    }),
    dueDateIcon: (0, $8CUq3.xcss)({
        display: 'flex',
        alignItems: 'center'
    })
};

});
parcelRegister("jpopi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a88758e67a65d8683bdcd5e828d8b686>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e21348dd48989821$var$_react = $e21348dd48989821$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e21348dd48989821$var$_baseNew = $e21348dd48989821$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e21348dd48989821$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Repeat".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for setting objects to recur (eg Work items, Forms)
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e21348dd48989821$var$RepeatIcon = (props)=>/*#__PURE__*/ $e21348dd48989821$var$_react.default.createElement($e21348dd48989821$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m8.78 3.72-3-3-1.06 1.06L6.44 3.5H4.5a4.5 4.5 0 0 0 0 9h1V11h-1a3 3 0 0 1 0-6h1.94L4.72 6.72l1.06 1.06 3-3a.75.75 0 0 0 0-1.06M11.5 5a3 3 0 1 1 0 6H9.56l1.72-1.72-1.06-1.06-3 3a.75.75 0 0 0 0 1.06l3 3 1.06-1.06-1.72-1.72h1.94a4.5 4.5 0 1 0 0-9h-1V5z" clip-rule="evenodd"/>`
    }, props));
$e21348dd48989821$var$RepeatIcon.displayName = 'RepeatIcon';
var $e21348dd48989821$var$_default = module.exports.default = $e21348dd48989821$var$RepeatIcon;

});

parcelRegister("acknU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9571ec76557171a7f54748c218c48225>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76cad653a4883392$var$_react = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $76cad653a4883392$var$_calendar = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("3fesp")));

var $76cad653a4883392$var$_calendar2 = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("cTemL")));
function $76cad653a4883392$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CalendarIcon.
 * This component is CalendarIcon, with `UNSAFE_fallbackIcon` set to "CalendarIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $76cad653a4883392$var$CalendarIcon = (props)=>/*#__PURE__*/ $76cad653a4883392$var$_react.default.createElement($76cad653a4883392$var$_calendar.default, Object.assign({
        LEGACY_fallbackIcon: $76cad653a4883392$var$_calendar2.default
    }, props));
$76cad653a4883392$var$CalendarIcon.Name = 'CalendarIconMigration';
var $76cad653a4883392$var$_default = module.exports.default = $76cad653a4883392$var$CalendarIcon;

});
parcelRegister("3fesp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43a4f9fcd22489798c1322bda48936cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25cdfcb8bb836404$var$_react = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $25cdfcb8bb836404$var$_baseNew = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $25cdfcb8bb836404$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25cdfcb8bb836404$var$CalendarIcon = (props)=>/*#__PURE__*/ $25cdfcb8bb836404$var$_react.default.createElement($25cdfcb8bb836404$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$25cdfcb8bb836404$var$CalendarIcon.displayName = 'CalendarIcon';
var $25cdfcb8bb836404$var$_default = module.exports.default = $25cdfcb8bb836404$var$CalendarIcon;

});

parcelRegister("cTemL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9625c3edd02eaf26$var$_react = $9625c3edd02eaf26$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $9625c3edd02eaf26$var$_calendar = $9625c3edd02eaf26$var$_interopRequireDefault((parcelRequire("3fesp")));
function $9625c3edd02eaf26$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9625c3edd02eaf26$var$CalendarIcon = (props)=>/*#__PURE__*/ $9625c3edd02eaf26$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
    }, props, {
        newIcon: $9625c3edd02eaf26$var$_calendar.default
    }));
$9625c3edd02eaf26$var$CalendarIcon.displayName = 'CalendarIcon';
var $9625c3edd02eaf26$var$_default = module.exports.default = $9625c3edd02eaf26$var$CalendarIcon;

});


parcelRegister("jCESp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::22f154a5d93289d4bcc4dadb1207abea>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e49146301a0d3a89$var$_react = $e49146301a0d3a89$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e49146301a0d3a89$var$_baseNew = $e49146301a0d3a89$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e49146301a0d3a89$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WarningOutline".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Low-impact warnings. Overdue dates in Atlassian Home.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e49146301a0d3a89$var$WarningOutlineIcon = (props)=>/*#__PURE__*/ $e49146301a0d3a89$var$_react.default.createElement($e49146301a0d3a89$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.7 1.384c.996-1.816 3.605-1.818 4.602-.003l5.35 9.73C16.612 12.86 15.346 15 13.35 15H2.667C.67 15-.594 12.862.365 11.113zm3.288.72a1.125 1.125 0 0 0-1.972 0l-5.336 9.73c-.41.75.132 1.666.987 1.666H13.35c.855 0 1.398-.917.986-1.667z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7.25 9V4h1.5v5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$e49146301a0d3a89$var$WarningOutlineIcon.displayName = 'WarningOutlineIcon';
var $e49146301a0d3a89$var$_default = module.exports.default = $e49146301a0d3a89$var$WarningOutlineIcon;

});

parcelRegister("1eyaH", function(module, exports) {

$parcel$export(module.exports, "RecurWorkItemContainer", () => $299cd71373520f02$export$32458a51e0870d6c);
$parcel$export(module.exports, "useRecurWorkItemState", () => $299cd71373520f02$export$5730c874dfb9803f);
$parcel$export(module.exports, "useRecurWorkItemActions", () => $299cd71373520f02$export$eb9ad4e1e739768e);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $koeKL = parcelRequire("koeKL");

var $2tT7R = parcelRequire("2tT7R");

var $93Yeu = parcelRequire("93Yeu");

var $cYlk7 = parcelRequire("cYlk7");

var $2YZCu = parcelRequire("2YZCu");

var $hVn1P = parcelRequire("hVn1P");

var $lQupu = parcelRequire("lQupu");
const $299cd71373520f02$var$RecurWorkItemStoreContainer = (0, $gg7kZ.createContainer)();
const $299cd71373520f02$export$32458a51e0870d6c = ({ children: children, issueKey: issueKey })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const environment = (0, $2tT7R.useEnvironment)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectId = (0, $93Yeu.useProjectId)(projectKey);
    const { data: currentUser } = (0, $cYlk7.useCurrentUser)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    if (!projectId) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jira-recur-work-item.src.controllers.RecurWorkItemContainer', 'Error initialising RecurWorkItemContainer, could not retrieve projectId');
        return children;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($299cd71373520f02$var$RecurWorkItemStoreContainer, {
        scope: `recur-${issueKey}`,
        issueKey: issueKey,
        environment: environment,
        cloudId: cloudId,
        currentUserAccountId: currentUser.user.accountId,
        projectId: projectId,
        createAnalyticsEvent: createAnalyticsEvent
    }, children);
};
const $299cd71373520f02$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    name: 'RecurWorkItemStore',
    initialState: (0, $lQupu.INITIAL_STATE),
    actions: $hVn1P.actions,
    containedBy: $299cd71373520f02$var$RecurWorkItemStoreContainer,
    handlers: {
        onInit: ()=>async ({ dispatch: dispatch })=>{
                await dispatch((0, $hVn1P.actions).fetch());
            }
    }
});
const $299cd71373520f02$export$6630e454597fb59c = (0, $3sQ5x.createHook)($299cd71373520f02$export$390f32400eaf98c9);
const $299cd71373520f02$export$5730c874dfb9803f = (0, $3sQ5x.createStateHook)($299cd71373520f02$export$390f32400eaf98c9);
const $299cd71373520f02$export$eb9ad4e1e739768e = (0, $3sQ5x.createActionsHook)($299cd71373520f02$export$390f32400eaf98c9);

});
parcelRegister("hVn1P", function(module, exports) {

$parcel$export(module.exports, "actions", () => $a7f343d49f172fdb$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $7Sl82 = parcelRequire("7Sl82");

var $l9xxv = parcelRequire("l9xxv");

var $bvhsR = parcelRequire("bvhsR");

var $c8g0F = parcelRequire("c8g0F");
const $a7f343d49f172fdb$export$5153917efea4a83d = (issueProperties)=>({ setState: setState })=>{
        setState({
            issueProperties: issueProperties
        });
    };
const $a7f343d49f172fdb$export$e324594224ef24da = {
    fetch: $7Sl82.fetch,
    setIssueProperties: $a7f343d49f172fdb$export$5153917efea4a83d,
    setAsNonRecurringIssue: $l9xxv.setAsNonRecurringIssue,
    setAsRecurringIssue: $bvhsR.setAsRecurringIssue,
    updateRule: $c8g0F.updateRule
};

});
parcelRegister("7Sl82", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $88fd35b220315252$export$e7aa7bc5c1b3cfb3);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4R6GH = parcelRequire("4R6GH");

var $m8SHd = parcelRequire("m8SHd");

var $ahBjy = parcelRequire("ahBjy");

var $fAJ3G = parcelRequire("fAJ3G");

var $519t2 = parcelRequire("519t2");

var $cpjnU = parcelRequire("cpjnU");
const $88fd35b220315252$export$e7aa7bc5c1b3cfb3 = ()=>async ({ setState: setState }, { createAnalyticsEvent: createAnalyticsEvent, issueKey: issueKey, environment: environment, cloudId: cloudId, projectId: projectId, currentUserAccountId: currentUserAccountId })=>{
        setState({
            isFetching: true,
            errors: null
        });
        try {
            // First fetch issue-properties
            const { value: issueProperties } = await (0, $519t2.callServiceWithAnalytics)(createAnalyticsEvent({}), (0, $m8SHd.fetchIssueProperties)(issueKey), 'fetchIssueProperties');
            let ruleSummary;
            // Only fetch rule summary if a rule exists in issue-properties and not a grandfathered recur-on-complete rule
            if (issueProperties?.automationRuleUuid) {
                ruleSummary = await (0, $519t2.callServiceWithAnalytics)(createAnalyticsEvent({}), (0, $m8SHd.fetchRuleSummary)(environment, cloudId, projectId, issueProperties.automationRuleUuid), 'fetchRuleSummary');
                // If rule doesn't exist or is disabled, delete issue-properties
                if (!ruleSummary || ruleSummary?.ruleState === (0, $ahBjy.RuleState).DISABLED) {
                    await (0, $519t2.callServiceWithAnalytics)(createAnalyticsEvent({}), (0, $fAJ3G.deleteIssueProperties)({
                        issueKey: issueKey
                    }), 'deleteIssueProperties');
                    setState({
                        isFetching: false,
                        hasFetched: true,
                        issueProperties: null
                    });
                    return;
                }
            }
            let isRuleOwner;
            if ((0, $cpjnU.isRecurOnCompleteToggleRule)(issueProperties)) isRuleOwner = true;
            else if (ruleSummary) isRuleOwner = ruleSummary.authorAccountId === currentUserAccountId;
            else isRuleOwner = null;
            setState({
                isFetching: false,
                hasFetched: true,
                issueProperties: issueProperties,
                isRuleOwner: isRuleOwner,
                ...(0, $4R6GH.fg)('jira-recur-single-work-item-on-sched-due-date-gate') && {
                    hasBootstrapError: false
                }
            });
        } catch (error) {
            setState({
                isFetching: false,
                hasFetched: true,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                errors: [
                    error
                ],
                hasBootstrapError: true
            });
        }
    };

});
parcelRegister("m8SHd", function(module, exports) {

$parcel$export(module.exports, "fetchIssueProperties", () => $85e12c64cfd21e7a$export$efa35964e975bd30);
$parcel$export(module.exports, "fetchRuleSummary", () => $85e12c64cfd21e7a$export$3cada9835f092161);

var $c5wox = parcelRequire("c5wox");

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");
const $85e12c64cfd21e7a$export$efa35964e975bd30 = async (issueKey)=>{
    const recurrenceConfigEndpoint = `/rest/api/2/issue/${issueKey}/properties/recurrence-config`;
    try {
        return await (0, $eusud.performGetRequest)(recurrenceConfigEndpoint);
    } catch (error) {
        if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) return Promise.resolve({
            value: null
        });
        throw error;
    }
};
const $85e12c64cfd21e7a$export$3cada9835f092161 = async (environment, cloudId, projectId, ruleUuid)=>{
    const automationStack = await (0, $c5wox.getAutomationStack)(environment, cloudId);
    const summaryEndpoint = `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/${projectId}/rule/${ruleUuid}/summary`;
    try {
        return await (0, $eusud.performGetRequest)(summaryEndpoint);
    } catch (error) {
        if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) return null;
        throw error;
    }
};

});
parcelRegister("c5wox", function(module, exports) {

$parcel$export(module.exports, "getAutomationStack", () => $8833cfad9f41bd36$export$6123178d3f5fb24d);
$parcel$export(module.exports, "getAutomationRecommendationsUrl", () => $8833cfad9f41bd36$export$38f41aa7b608011d);
$parcel$export(module.exports, "getBaseAutomationUrl", () => $8833cfad9f41bd36$export$8e479e490e1e69bc);

var $bSSG7 = parcelRequire("bSSG7");

var $4R6GH = parcelRequire("4R6GH");
const $8833cfad9f41bd36$var$localStorage = (0, $bSSG7.createLocalStorageProvider)('automation-menu');
const $8833cfad9f41bd36$var$getLatestStack = async (cloudId)=>fetch(`/gateway/api/automation/internal-api/jira/${cloudId}/pro/rest/environments`).then((response)=>response.json()).then((response)=>{
        const stacks = response.prod.otherStacks.filter(({ releasedSuccessfully: releasedSuccessfully })=>!releasedSuccessfully).map(({ stack: stack })=>stack);
        return stacks.length > 0 ? stacks[0] : null;
    }).catch(()=>null);
const $8833cfad9f41bd36$export$6123178d3f5fb24d = async (env, cloudId)=>{
    if (env === 'prod') {
        if ((0, $4R6GH.fg)('automation-platform-pre-prod-instance')) {
            const stack = await $8833cfad9f41bd36$var$getLatestStack(cloudId);
            return stack ?? 'pro';
        }
        return 'pro';
    }
    // Set this manually to your Automation dev stack e.g. devesukmajaya. The full key is: __storejs_automation-menu_automationStack
    const stackOverride = $8833cfad9f41bd36$var$localStorage.get('automationStack');
    return stackOverride || 'staging';
};
const $8833cfad9f41bd36$export$45ce04a98782e28a = async (env, cloudId, projectId)=>{
    const automationStack = await $8833cfad9f41bd36$export$6123178d3f5fb24d(env, cloudId);
    return `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/rules/invocation/${projectId}`;
};
const $8833cfad9f41bd36$export$f8e019b45a22d26a = async (env, cloudId, ruleId)=>{
    const automationStack = await $8833cfad9f41bd36$export$6123178d3f5fb24d(env, cloudId);
    return `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/rules/invocation/${ruleId}`;
};
const $8833cfad9f41bd36$export$38f41aa7b608011d = async ({ env: env, cloudId: cloudId, target: target })=>{
    const automationStack = await $8833cfad9f41bd36$export$6123178d3f5fb24d(env, cloudId);
    return `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/v1/recommendation/templates?target=${target}`;
};
const $8833cfad9f41bd36$export$8e479e490e1e69bc = ({ projectKey: projectKey, projectType: projectType, isSimplified: isSimplified })=>{
    /**
	 * Confusing mapping of urls here.
	 * Classic Projects - always under /automate
	 * Next Gen Projects - under /automation for all project types except JSD
	 */ if ((0, $4R6GH.fg)('jcs_project_type_m3')) switch(projectType){
        case 'customer_service':
        case 'service_desk':
            return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
        case 'business':
            return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
        default:
            return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    }
    switch(projectType){
        case 'service_desk':
            return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
        case 'business':
            return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
        default:
            return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    }
};

});


parcelRegister("ahBjy", function(module, exports) {

$parcel$export(module.exports, "RuleState", () => $50cbc517c5c98dcf$export$c22ef3527b5f5563);
$parcel$export(module.exports, "CONDITION", () => $50cbc517c5c98dcf$export$1cfe08df32bc8f76);
$parcel$export(module.exports, "FORM_TITLE_ID", () => $50cbc517c5c98dcf$export$66f4c6e4b9206abf);
$parcel$export(module.exports, "SOFTWARE_END_USER_TEMPLATE_2", () => $50cbc517c5c98dcf$export$c07ca23c166d6344);
const $50cbc517c5c98dcf$export$c22ef3527b5f5563 = {
    DISABLED: 'DISABLED',
    ENABLED: 'ENABLED',
    MISSING_PERMS: 'MISSING_PERMS'
};
const $50cbc517c5c98dcf$export$1cfe08df32bc8f76 = {
    SCHEDULE: 'SCHEDULE',
    SCHEDULE_IF_COMPLETE: 'SCHEDULE_IF_COMPLETE'
};
const $50cbc517c5c98dcf$export$f7109619a5e9e0d6 = 'recurWorkItemForm';
const $50cbc517c5c98dcf$export$66f4c6e4b9206abf = 'recur-work-item-form-title';
const $50cbc517c5c98dcf$export$c07ca23c166d6344 = 'software_end_user_template_2';

});

parcelRegister("fAJ3G", function(module, exports) {

$parcel$export(module.exports, "deleteRule", () => $dcc2b085f6f8ace7$export$988cba38e738f27d);
$parcel$export(module.exports, "deleteIssueProperties", () => $dcc2b085f6f8ace7$export$3906c12f20991cd1);
$parcel$export(module.exports, "disableRule", () => $dcc2b085f6f8ace7$export$44bd9fdb7edbb04a);

var $c5wox = parcelRequire("c5wox");

var $eusud = parcelRequire("eusud");
const $dcc2b085f6f8ace7$export$988cba38e738f27d = async ({ environment: environment, cloudId: cloudId, projectId: projectId, ruleUuid: ruleUuid })=>{
    const automationStack = await (0, $c5wox.getAutomationStack)(environment, cloudId);
    const DELETE_RULE_URL = `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/${projectId}/rule/${ruleUuid}`;
    return (0, $eusud.performDeleteRequest)(DELETE_RULE_URL);
};
const $dcc2b085f6f8ace7$export$3906c12f20991cd1 = async ({ issueKey: issueKey })=>{
    const ruleConfigEndpoint = `/rest/api/2/issue/${issueKey}/properties/recurrence-config`;
    return (0, $eusud.performDeleteRequest)(ruleConfigEndpoint);
};
const $dcc2b085f6f8ace7$export$44bd9fdb7edbb04a = async ({ environment: environment, cloudId: cloudId, projectId: projectId, ruleUuid: ruleUuid })=>{
    const automationStack = await (0, $c5wox.getAutomationStack)(environment, cloudId);
    const disableRuleEndpoint = `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/${projectId}/rule/${ruleUuid}/disable`;
    return (0, $eusud.performPatchRequest)(disableRuleEndpoint);
};

});

parcelRegister("519t2", function(module, exports) {

$parcel$export(module.exports, "callServiceWithAnalytics", () => $ad2a8aebaff4128f$export$7ad2acdaf7d8c23c);

var $jJZqs = parcelRequire("jJZqs");

var $8zOmE = parcelRequire("8zOmE");
const $ad2a8aebaff4128f$var$getErrorAttributes = (error)=>{
    if (error instanceof Error) return {
        errorMessage: error.message,
        ...error instanceof (0, $jJZqs.default) && {
            statusCode: error.statusCode
        }
    };
    return {};
};
const $ad2a8aebaff4128f$export$7ad2acdaf7d8c23c = async (analyticsEvent, requestPromise, requestName, attributes = {})=>{
    try {
        const response = await requestPromise;
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, `${requestName} succeeded`, {
            ...attributes
        });
        return response;
    } catch (err) {
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, `${requestName} failed`, {
            ...attributes,
            ...$ad2a8aebaff4128f$var$getErrorAttributes(err)
        });
        throw err;
    }
};

});

parcelRegister("cpjnU", function(module, exports) {

$parcel$export(module.exports, "mapFrequencyToRRule", () => $c35d2016d68e7b8d$export$e01411a3db8dd3d7);
$parcel$export(module.exports, "mapFrequencyToSmartOffsetValue", () => $c35d2016d68e7b8d$export$777fffdd861d4f20);
$parcel$export(module.exports, "getFrequencyFromRRule", () => $c35d2016d68e7b8d$export$71b17ee07540e13b);
$parcel$export(module.exports, "getRecurMenuItemLabel", () => $c35d2016d68e7b8d$export$c7198a7e75d4478b);
$parcel$export(module.exports, "getSuccessFlagContent", () => $c35d2016d68e7b8d$export$8eef89c3d24cb712);
$parcel$export(module.exports, "isRecurOnCompleteToggleRule", () => $c35d2016d68e7b8d$export$b57843f38b80b500);
$parcel$export(module.exports, "hasRuleChanged", () => $c35d2016d68e7b8d$export$8dc77b9e863f46b);
$parcel$export(module.exports, "applyUserTimezone", () => $c35d2016d68e7b8d$export$555109634e8a63b6);

var $ajpes = parcelRequire("ajpes");

var $1GF3c = parcelRequire("1GF3c");

var $gwejS = parcelRequire("gwejS");

var $7jns1 = parcelRequire("7jns1");

var $bbVsP = parcelRequire("bbVsP");
var $jpR5P = parcelRequire("jpR5P");

var $9eJ96 = parcelRequire("9eJ96");

var $5D9Ji = parcelRequire("5D9Ji");
const $c35d2016d68e7b8d$export$e01411a3db8dd3d7 = (timeframe, recurWeeklyConfig)=>{
    switch(timeframe){
        case 'DAILY':
            return {
                frequency: (0, $9eJ96.Frequencies).DAILY,
                interval: 1
            };
        case 'WEEKDAY':
            return {
                frequency: (0, $9eJ96.Frequencies).DAILY,
                byDay: [
                    (0, $9eJ96.Days).MO,
                    (0, $9eJ96.Days).TU,
                    (0, $9eJ96.Days).WE,
                    (0, $9eJ96.Days).TH,
                    (0, $9eJ96.Days).FR
                ],
                interval: 1
            };
        case 'WEEKLY':
            return {
                frequency: (0, $9eJ96.Frequencies).WEEKLY,
                byDay: recurWeeklyConfig,
                interval: 1
            };
        case 'FORTNIGHTLY':
            // There is no native FORTNIGHTLY frequency for ical, so we need to combine WEEKLY with interval 2
            return {
                frequency: (0, $9eJ96.Frequencies).WEEKLY,
                byDay: recurWeeklyConfig,
                interval: 2
            };
        default:
            throw new Error(`Unknown timeframe: ${timeframe}`);
    }
};
const $c35d2016d68e7b8d$export$777fffdd861d4f20 = (timeframe)=>{
    switch(timeframe){
        case 'DAILY':
            return '{{now.plusDays(1)}}';
        case 'WEEKDAY':
            return '{{now.plusBusinessDays(1)}}';
        case 'WEEKLY':
            return '{{now.plusWeeks(1)}}';
        case 'FORTNIGHTLY':
            return '{{now.plusWeeks(2)}}';
        default:
            throw new Error(`Could not calculate due date smart offset value: ${timeframe}`);
    }
};
const $c35d2016d68e7b8d$export$71b17ee07540e13b = (rrule)=>{
    if (rrule.frequency === (0, $9eJ96.Frequencies).DAILY) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(rrule.byDay, [
            (0, $9eJ96.Days).MO,
            (0, $9eJ96.Days).TU,
            (0, $9eJ96.Days).WE,
            (0, $9eJ96.Days).TH,
            (0, $9eJ96.Days).FR
        ])) return 'WEEKDAY';
        return 'DAILY';
    }
    if (rrule.frequency === (0, $9eJ96.Frequencies).WEEKLY) {
        if (rrule.interval === 2) return 'FORTNIGHTLY';
        return 'WEEKLY';
    }
};
const $c35d2016d68e7b8d$export$c7198a7e75d4478b = (rrule, isRecurOnComplete = false)=>{
    if (isRecurOnComplete) return (0, $5D9Ji.default).recursOnComplete;
    const frequency = $c35d2016d68e7b8d$export$71b17ee07540e13b(rrule);
    // Every business day (Monday to Friday)
    if (frequency === 'WEEKDAY') return (0, $5D9Ji.default).recursEveryWeekday;
    // Daily
    if (frequency === 'DAILY') return (0, $5D9Ji.default).recursDaily;
    // Fortnightly
    if (frequency === 'FORTNIGHTLY') return (0, $5D9Ji.default).recursEveryTwoWeeks;
    // Weekly
    if (frequency === 'WEEKLY') return (0, $5D9Ji.default).recursWeekly;
    return (0, $5D9Ji.default).setToRecur;
};
const $c35d2016d68e7b8d$var$byDayOptions = Object.values((0, $9eJ96.Days));
const $c35d2016d68e7b8d$var$getWeekDayNameFromByDay = (byDayValue, intl)=>{
    const dayIndex = $c35d2016d68e7b8d$var$byDayOptions.indexOf(byDayValue);
    if (dayIndex < 0) throw new Error(`Invalid ByDay value provided: ${byDayValue}. Valid options: ${$c35d2016d68e7b8d$var$byDayOptions}`);
    const firstDayOfWeek = (0, $1GF3c.default)(new Date(), {
        weekStartsOn: 1
    });
    const day = (0, $gwejS.default)(firstDayOfWeek, dayIndex);
    return intl.formatDate(day, {
        weekday: 'long'
    });
};
const $c35d2016d68e7b8d$export$5c6d45150d1588c0 = ({ byDayValues: byDayValues, intl: intl, standardizedLocale: standardizedLocale })=>new Intl.ListFormat(standardizedLocale, {
        style: 'long',
        type: 'conjunction'
    }).format(Array.from(byDayValues, (byDayValue)=>$c35d2016d68e7b8d$var$getWeekDayNameFromByDay(byDayValue, intl)));
const $c35d2016d68e7b8d$export$8eef89c3d24cb712 = ({ frequency: frequency, recurCondition: recurCondition, recurWeeklyConfig: recurWeeklyConfig, intl: intl, standardizedLocale: standardizedLocale, issueKey: issueKey, issueType: issueType })=>{
    const issueTypeLowercase = issueType.toLocaleLowerCase(standardizedLocale);
    switch(recurCondition){
        case 'SCHEDULE_IF_COMPLETE':
            switch(frequency){
                case 'DAILY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleIfCompleteDaily, {
                            issueKey: issueKey
                        }),
                        description: intl.formatMessage((0, $5D9Ji.default).successFlagDescriptionRecurOnScheduleIfCompleteDaily, {
                            issueType: issueTypeLowercase
                        })
                    };
                case 'WEEKDAY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleIfCompleteWeekday, {
                            issueKey: issueKey
                        }),
                        description: intl.formatMessage((0, $5D9Ji.default).successFlagDescriptionRecurOnScheduleIfCompleteWeekday, {
                            issueType: issueTypeLowercase
                        })
                    };
                case 'WEEKLY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleIfCompleteWeekly, {
                            issueKey: issueKey
                        }),
                        description: intl.formatMessage((0, $5D9Ji.default).successFlagDescriptionRecurOnScheduleIfCompleteWeekly, {
                            issueType: issueTypeLowercase,
                            weekDayNames: $c35d2016d68e7b8d$export$5c6d45150d1588c0({
                                byDayValues: recurWeeklyConfig ?? [],
                                intl: intl,
                                standardizedLocale: standardizedLocale
                            })
                        })
                    };
                case 'FORTNIGHTLY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleIfCompleteFortnightly, {
                            issueKey: issueKey
                        }),
                        description: intl.formatMessage((0, $5D9Ji.default).successFlagDescriptionRecurOnScheduleIfCompleteFortnightly, {
                            issueType: issueTypeLowercase,
                            weekDayNames: $c35d2016d68e7b8d$export$5c6d45150d1588c0({
                                byDayValues: recurWeeklyConfig ?? [],
                                intl: intl,
                                standardizedLocale: standardizedLocale
                            })
                        })
                    };
                default:
                    throw new Error(`Unknown frequency: ${frequency}`);
            }
        case 'SCHEDULE':
            switch(frequency){
                case 'DAILY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleDaily, {
                            issueKey: issueKey
                        })
                    };
                case 'WEEKDAY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleWeekday, {
                            issueKey: issueKey
                        })
                    };
                case 'WEEKLY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleWeekly, {
                            issueKey: issueKey,
                            weekDayNames: $c35d2016d68e7b8d$export$5c6d45150d1588c0({
                                byDayValues: recurWeeklyConfig ?? [],
                                intl: intl,
                                standardizedLocale: standardizedLocale
                            })
                        })
                    };
                case 'FORTNIGHTLY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleFortnightly, {
                            issueKey: issueKey,
                            weekDayNames: $c35d2016d68e7b8d$export$5c6d45150d1588c0({
                                byDayValues: recurWeeklyConfig ?? [],
                                intl: intl,
                                standardizedLocale: standardizedLocale
                            })
                        })
                    };
                default:
                    throw new Error(`Unknown frequency: ${frequency}`);
            }
        default:
            throw new Error(`Unknown recur condition: ${recurCondition}`);
    }
};
const $c35d2016d68e7b8d$export$b57843f38b80b500 = (issueProperties)=>{
    return !!issueProperties && !!issueProperties.token && (issueProperties.recurOnScheduleConfig === null || issueProperties.recurOnScheduleConfig === undefined);
};
const $c35d2016d68e7b8d$var$areByDaysEqual = ({ byDays: byDays, anotherByDays: anotherByDays })=>{
    // assumes lists have a consistent order
    if (byDays === undefined) return anotherByDays === undefined;
    if (anotherByDays === undefined) return false;
    if (byDays.length !== anotherByDays.length) return false;
    return byDays.every((byDay, index)=>byDay === anotherByDays[index]);
};
const $c35d2016d68e7b8d$var$areDatesEqual = (date1, date2)=>{
    if (date1 === undefined || date2 === undefined) return date1 === date2;
    // We only care about checking the date equality, not the time
    return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
};
const $c35d2016d68e7b8d$export$8dc77b9e863f46b = ({ formInput: formInput, formOutput: formOutput })=>{
    // comparing 2 recur-on-schedule rules
    if (formInput.frequency !== formOutput.frequency || formInput.condition !== formOutput.condition || !$c35d2016d68e7b8d$var$areDatesEqual(formInput.endsOn, formOutput.endsOn)) return true;
    if (formInput.frequency === 'WEEKLY' || formInput.frequency === 'FORTNIGHTLY') return !$c35d2016d68e7b8d$var$areByDaysEqual({
        byDays: formInput.byDay,
        anotherByDays: formOutput.byDay
    });
    return false;
};
const $c35d2016d68e7b8d$export$555109634e8a63b6 = (date, browserTimezone, userTimezone)=>{
    const browserTimezoneOffsetMs = (0, $7jns1.default)(browserTimezone);
    const userTimezoneOffsetMs = (0, $7jns1.default)(userTimezone);
    return (0, $bbVsP.default)((0, $jpR5P.default)(date, browserTimezoneOffsetMs), userTimezoneOffsetMs);
};

});
parcelRegister("9eJ96", function(module, exports) {

$parcel$export(module.exports, "NEWLINE_REGEX", () => $1079d16957e265b2$export$665ca7211e0c33c);
$parcel$export(module.exports, "FOLD_LINES_REGEX", () => $1079d16957e265b2$export$4b7f22f32fbb5949);
$parcel$export(module.exports, "LF", () => $1079d16957e265b2$export$606cfc2a8896c91f);
$parcel$export(module.exports, "NewlineCharacters", () => $1079d16957e265b2$export$ccae594c20078277);
$parcel$export(module.exports, "NewlineCharacterValues", () => $1079d16957e265b2$export$c3edd2b21ac02f88);
$parcel$export(module.exports, "Frequencies", () => $1079d16957e265b2$export$895ee510b2e84ade);
$parcel$export(module.exports, "Days", () => $1079d16957e265b2$export$d3134eff2123aadb);
$parcel$export(module.exports, "BEGIN_VEVENT", () => $1079d16957e265b2$export$67de00e87412dc6f);
$parcel$export(module.exports, "END_VEVENT", () => $1079d16957e265b2$export$987d86d2e891c4cb);
$parcel$export(module.exports, "DTSTART", () => $1079d16957e265b2$export$fd1a0e011a586e26);
$parcel$export(module.exports, "RRULE", () => $1079d16957e265b2$export$d86ed937a45b0291);
$parcel$export(module.exports, "ICalSpecificationFields", () => $1079d16957e265b2$export$98eba4d8ff00c139);
$parcel$export(module.exports, "ICalSupportedFields", () => $1079d16957e265b2$export$38b1323f325ffd22);
$parcel$export(module.exports, "TZID", () => $1079d16957e265b2$export$5b9a78912028c06d);
$parcel$export(module.exports, "DTStartProperties", () => $1079d16957e265b2$export$20184b745430719e);
$parcel$export(module.exports, "FREQ", () => $1079d16957e265b2$export$fb124b4fa837b262);
$parcel$export(module.exports, "UNTIL", () => $1079d16957e265b2$export$4cc4f35131ed029c);
$parcel$export(module.exports, "INTERVAL", () => $1079d16957e265b2$export$7dea0e6e08f87a8a);
$parcel$export(module.exports, "BYHOUR", () => $1079d16957e265b2$export$a764ed9c4884f76d);
$parcel$export(module.exports, "BYMINUTE", () => $1079d16957e265b2$export$7a96578de7a037b6);
$parcel$export(module.exports, "BYSECOND", () => $1079d16957e265b2$export$55bcca3bd8d3041f);
$parcel$export(module.exports, "BYDAY", () => $1079d16957e265b2$export$f512ea3e90612d03);
$parcel$export(module.exports, "BYMONTH", () => $1079d16957e265b2$export$b3203f635d74ce88);
$parcel$export(module.exports, "BYMONTHDAY", () => $1079d16957e265b2$export$15623ad945e92c4c);
$parcel$export(module.exports, "RRuleProperties", () => $1079d16957e265b2$export$7898bd020dba0a27);
$parcel$export(module.exports, "MISSING", () => $1079d16957e265b2$export$64c81710c321f252);
$parcel$export(module.exports, "EMPTY", () => $1079d16957e265b2$export$ccb33e29d92c9a58);
$parcel$export(module.exports, "INVALID", () => $1079d16957e265b2$export$9a105a556e65c2c0);
$parcel$export(module.exports, "VALID", () => $1079d16957e265b2$export$f3abe3d006c81602);
const $1079d16957e265b2$export$665ca7211e0c33c = /\r?\n/;
const $1079d16957e265b2$export$4b7f22f32fbb5949 = /\r?\n[ \t]/g; // match line breaks followed by a whitespace character (space or tab)
const $1079d16957e265b2$export$ae9ea0d00d3d8982 = 'CRLF';
const $1079d16957e265b2$export$a1f3f1ef020bdc3a = '\r\n';
const $1079d16957e265b2$export$606cfc2a8896c91f = 'LF';
const $1079d16957e265b2$export$477fea8aa280bb1e = '\n';
const $1079d16957e265b2$export$ccae594c20078277 = {
    CRLF: $1079d16957e265b2$export$ae9ea0d00d3d8982,
    LF: $1079d16957e265b2$export$606cfc2a8896c91f
};
const $1079d16957e265b2$export$c3edd2b21ac02f88 = {
    [$1079d16957e265b2$export$ae9ea0d00d3d8982]: $1079d16957e265b2$export$a1f3f1ef020bdc3a,
    [$1079d16957e265b2$export$606cfc2a8896c91f]: $1079d16957e265b2$export$477fea8aa280bb1e
};
const $1079d16957e265b2$export$895ee510b2e84ade = {
    SECONDLY: 'SECONDLY',
    MINUTELY: 'MINUTELY',
    HOURLY: 'HOURLY',
    DAILY: 'DAILY',
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY',
    YEARLY: 'YEARLY'
};
const $1079d16957e265b2$export$d3134eff2123aadb = {
    MO: 'MO',
    TU: 'TU',
    WE: 'WE',
    TH: 'TH',
    FR: 'FR',
    SA: 'SA',
    SU: 'SU'
};
const $1079d16957e265b2$export$f62540a8bebc4ed3 = 'BEGIN';
const $1079d16957e265b2$export$32239d68d9c6cb49 = 'END';
const $1079d16957e265b2$export$67de00e87412dc6f = 'BEGIN:VEVENT';
const $1079d16957e265b2$export$987d86d2e891c4cb = 'END:VEVENT';
const $1079d16957e265b2$export$fd1a0e011a586e26 = 'DTSTART';
const $1079d16957e265b2$export$d86ed937a45b0291 = 'RRULE';
const $1079d16957e265b2$export$913055729e1380b2 = 'SUMMARY';
const $1079d16957e265b2$export$87d0ca22edb7493a = 'LOCATION';
const $1079d16957e265b2$export$d44826c816b5619b = 'DESCRIPTION';
const $1079d16957e265b2$export$c8b4a4d253b84ce0 = 'UID';
const $1079d16957e265b2$export$34694f8d8b23ee2a = 'SEQUENCE';
const $1079d16957e265b2$export$e50006273435e7d4 = 'STATUS';
const $1079d16957e265b2$export$36034111438e3f25 = 'TRANSP';
const $1079d16957e265b2$export$bb34f3538ba26c7e = 'PRIORITY';
const $1079d16957e265b2$export$30dbcad954808285 = 'DTEND';
const $1079d16957e265b2$export$bacc88974c736870 = 'DURATION';
const $1079d16957e265b2$export$da3a32b38cbf59ba = 'ATTACH';
const $1079d16957e265b2$export$5e0bdf8bba8d5088 = 'ATTENDEE';
const $1079d16957e265b2$export$a513ea61a7bee91c = 'CATEGORIES';
const $1079d16957e265b2$export$a29989082612d0d9 = 'COMMENT';
const $1079d16957e265b2$export$11038cc09fdccb91 = 'CONTACT';
const $1079d16957e265b2$export$133ffe3c8efbf133 = 'EXDATE';
const $1079d16957e265b2$export$7e27a94778a9d7d7 = 'EXRULE';
const $1079d16957e265b2$export$3d166b1dacd2503a = 'RDATE';
const $1079d16957e265b2$export$47a1d4cd38dddc05 = 'RELATED-TO';
const $1079d16957e265b2$export$4e841128923ef26 = 'RESOURCES';
const $1079d16957e265b2$export$1c0dd28c42f2741e = 'RECURRENCE-ID';
const $1079d16957e265b2$export$61abde59b50deb8e = 'URL';
const $1079d16957e265b2$export$ff39ebd4bb12b718 = 'CREATED';
const $1079d16957e265b2$export$2ebcefe61501d5fe = 'DTSTAMP';
const $1079d16957e265b2$export$90812500f628da64 = 'LAST-MODIFIED';
const $1079d16957e265b2$export$5409f4c14bda7ac = 'ORGANIZER';
const $1079d16957e265b2$export$9fe99b3b71be9378 = 'REQUEST-STATUS';
const $1079d16957e265b2$export$98eba4d8ff00c139 = {
    BEGIN: $1079d16957e265b2$export$f62540a8bebc4ed3,
    END: $1079d16957e265b2$export$32239d68d9c6cb49,
    BEGIN_VEVENT: $1079d16957e265b2$export$67de00e87412dc6f,
    END_VEVENT: $1079d16957e265b2$export$987d86d2e891c4cb,
    SUMMARY: $1079d16957e265b2$export$913055729e1380b2,
    LOCATION: $1079d16957e265b2$export$87d0ca22edb7493a,
    DESCRIPTION: $1079d16957e265b2$export$d44826c816b5619b,
    UID: $1079d16957e265b2$export$c8b4a4d253b84ce0,
    SEQUENCE: $1079d16957e265b2$export$34694f8d8b23ee2a,
    STATUS: $1079d16957e265b2$export$e50006273435e7d4,
    TRANSP: $1079d16957e265b2$export$36034111438e3f25,
    PRIORITY: $1079d16957e265b2$export$bb34f3538ba26c7e,
    DTSTART: $1079d16957e265b2$export$fd1a0e011a586e26,
    RRULE: $1079d16957e265b2$export$d86ed937a45b0291,
    DTEND: $1079d16957e265b2$export$30dbcad954808285,
    DURATION: $1079d16957e265b2$export$bacc88974c736870,
    ATTACH: $1079d16957e265b2$export$da3a32b38cbf59ba,
    ATTENDEE: $1079d16957e265b2$export$5e0bdf8bba8d5088,
    CATEGORIES: $1079d16957e265b2$export$a513ea61a7bee91c,
    COMMENT: $1079d16957e265b2$export$a29989082612d0d9,
    CONTACT: $1079d16957e265b2$export$11038cc09fdccb91,
    EXDATE: $1079d16957e265b2$export$133ffe3c8efbf133,
    EXRULE: $1079d16957e265b2$export$7e27a94778a9d7d7,
    RDATE: $1079d16957e265b2$export$3d166b1dacd2503a,
    RELATED_TO: $1079d16957e265b2$export$47a1d4cd38dddc05,
    RESOURCES: $1079d16957e265b2$export$4e841128923ef26,
    RECURRENCE_ID: $1079d16957e265b2$export$1c0dd28c42f2741e,
    URL: $1079d16957e265b2$export$61abde59b50deb8e,
    CREATED: $1079d16957e265b2$export$ff39ebd4bb12b718,
    DTSTAMP: $1079d16957e265b2$export$2ebcefe61501d5fe,
    LAST_MODIFIED: $1079d16957e265b2$export$90812500f628da64,
    ORGANIZER: $1079d16957e265b2$export$5409f4c14bda7ac,
    REQUEST_STATUS: $1079d16957e265b2$export$9fe99b3b71be9378
};
const $1079d16957e265b2$export$38b1323f325ffd22 = {
    DTSTART: $1079d16957e265b2$export$fd1a0e011a586e26,
    RRULE: $1079d16957e265b2$export$d86ed937a45b0291
};
const $1079d16957e265b2$export$5b9a78912028c06d = 'TZID';
const $1079d16957e265b2$export$20184b745430719e = {
    DTSTART: $1079d16957e265b2$export$fd1a0e011a586e26,
    TZID: $1079d16957e265b2$export$5b9a78912028c06d
};
const $1079d16957e265b2$export$fb124b4fa837b262 = 'FREQ';
const $1079d16957e265b2$export$4cc4f35131ed029c = 'UNTIL';
const $1079d16957e265b2$export$7dea0e6e08f87a8a = 'INTERVAL';
const $1079d16957e265b2$export$a764ed9c4884f76d = 'BYHOUR';
const $1079d16957e265b2$export$7a96578de7a037b6 = 'BYMINUTE';
const $1079d16957e265b2$export$55bcca3bd8d3041f = 'BYSECOND';
const $1079d16957e265b2$export$f512ea3e90612d03 = 'BYDAY';
const $1079d16957e265b2$export$b3203f635d74ce88 = 'BYMONTH';
const $1079d16957e265b2$export$15623ad945e92c4c = 'BYMONTHDAY';
const $1079d16957e265b2$export$7898bd020dba0a27 = {
    FREQ: $1079d16957e265b2$export$fb124b4fa837b262,
    UNTIL: $1079d16957e265b2$export$4cc4f35131ed029c,
    INTERVAL: $1079d16957e265b2$export$7dea0e6e08f87a8a,
    BYHOUR: $1079d16957e265b2$export$a764ed9c4884f76d,
    BYMINUTE: $1079d16957e265b2$export$7a96578de7a037b6,
    BYSECOND: $1079d16957e265b2$export$55bcca3bd8d3041f,
    BYDAY: $1079d16957e265b2$export$f512ea3e90612d03,
    BYMONTH: $1079d16957e265b2$export$b3203f635d74ce88,
    BYMONTHDAY: $1079d16957e265b2$export$15623ad945e92c4c
};
const $1079d16957e265b2$export$64c81710c321f252 = 'MISSING';
const $1079d16957e265b2$export$ccb33e29d92c9a58 = 'EMPTY';
const $1079d16957e265b2$export$9a105a556e65c2c0 = 'INVALID';
const $1079d16957e265b2$export$f3abe3d006c81602 = 'VALID';

});

parcelRegister("5D9Ji", function(module, exports) {

$parcel$export(module.exports, "default", () => $f056e68da25dd6c2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f056e68da25dd6c2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    formTitle: {
        "id": "recur-work-item.form-title",
        "defaultMessage": "Set to recur"
    },
    saveButtonText: {
        "id": "recur-work-item.save-button-text",
        "defaultMessage": "Save"
    },
    cancelButtonText: {
        "id": "recur-work-item.cancel-button-text",
        "defaultMessage": "Cancel"
    },
    deleteButtonText: {
        "id": "recur-work-item.delete-button-text",
        "defaultMessage": "Delete"
    },
    recurFieldsLabel: {
        "id": "recur-work-item.recur-fields-label",
        "defaultMessage": "Recur"
    },
    setToRecur: {
        "id": "recur-work-item.set-to-recur",
        "defaultMessage": "Set to recur"
    },
    recursDaily: {
        "id": "recur-work-item.recurs-daily",
        "defaultMessage": "Recurs daily"
    },
    recursEveryWeekday: {
        "id": "recur-work-item.recurs-every-weekday",
        "defaultMessage": "Every weekday (Monday to Friday)"
    },
    recursWeekly: {
        "id": "recur-work-item.recurs-weekly",
        "defaultMessage": "Recurs weekly"
    },
    recursEveryTwoWeeks: {
        "id": "recur-work-item.recurs-every-two-weeks",
        "defaultMessage": "Recurs every 2 weeks"
    },
    recursOnComplete: {
        "id": "recur-work-item.recurs-on-complete",
        "defaultMessage": "Recurs when completed"
    },
    successFlagTitleRecurOnScheduleIfCompleteDaily: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-if-complete-daily",
        "defaultMessage": "{issueKey} recurs every day"
    },
    successFlagTitleRecurOnScheduleIfCompleteWeekday: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-if-complete-weekday",
        "defaultMessage": "{issueKey} recurs every weekday"
    },
    successFlagTitleRecurOnScheduleIfCompleteWeekly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-if-complete-weekly",
        "defaultMessage": "{issueKey} recurs every week"
    },
    successFlagTitleRecurOnScheduleIfCompleteFortnightly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-if-complete-fortnightly",
        "defaultMessage": "{issueKey} recurs every 2 weeks"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteDaily: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-daily",
        "defaultMessage": "This {issueType} recurs daily when completed"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteWeekday: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-weekday",
        "defaultMessage": "This {issueType} recurs every weekday when completed"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteWeekly: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-weekly",
        "defaultMessage": "This {issueType} recurs weekly on {weekDayNames} when completed"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteFortnightly: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-fortnightly",
        "defaultMessage": "This {issueType} recurs every 2 weeks on {weekDayNames} when completed"
    },
    successFlagTitleRecurOnScheduleDaily: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-daily",
        "defaultMessage": "{issueKey} recurs every day"
    },
    successFlagTitleRecurOnScheduleWeekday: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-weekday",
        "defaultMessage": "{issueKey} recurs every weekday"
    },
    successFlagTitleRecurOnScheduleWeekly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-weekly",
        "defaultMessage": "{issueKey} recurs every week on {weekDayNames}"
    },
    successFlagTitleRecurOnScheduleFortnightly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-fortnightly",
        "defaultMessage": "{issueKey} recurs every 2 weeks on {weekDayNames}"
    },
    goBackLabel: {
        "id": "recur-work-item.go-back-label",
        "defaultMessage": "Go back"
    },
    errorFlagReloadPageButton: {
        "id": "recur-work-item.error-flag-reload-page-button",
        "defaultMessage": "Reload page"
    },
    errorFlagDescription: {
        "id": "recur-work-item.error-flag-description",
        "defaultMessage": "If this keeps happening, share this information with your admin, who should <link>contact support</link>."
    },
    errorFlagTitle: {
        "id": "recur-work-item.error-flag-title",
        "defaultMessage": "Something went wrong on our end"
    }
});

});



parcelRegister("l9xxv", function(module, exports) {

$parcel$export(module.exports, "setAsNonRecurringIssue", () => $867e9b1c0261db63$export$7b76980c59e9a391);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8zOmE = parcelRequire("8zOmE");

var $lQupu = parcelRequire("lQupu");

var $fAJ3G = parcelRequire("fAJ3G");

var $519t2 = parcelRequire("519t2");
const $867e9b1c0261db63$export$7b76980c59e9a391 = ({ isProjectAdmin: isProjectAdmin, isRuleOwner: isRuleOwner, isSiteAdmin: isSiteAdmin, skipDeletingIssueProperties: skipDeletingIssueProperties = false })=>async ({ setState: setState, getState: getState }, { createAnalyticsEvent: createAnalyticsEvent, issueKey: issueKey, environment: environment, cloudId: cloudId, projectId: projectId })=>{
        const { issueProperties: issueProperties, errors: errors, isUpdatingRule: isUpdatingRule } = getState();
        // this can't be !automationRuleUuid because recur-on-complete rules won't have an
        // automationRuleUuid, but they will have issueProperties
        if (!issueProperties) {
            const error = new Error('User is trying to delete a rule before the rule data has been stored.');
            setState({
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
            throw error;
        }
        if (!isSiteAdmin && !isProjectAdmin && !isRuleOwner) {
            const error = new Error('User does not have permission to set issue as non-recurring.');
            setState({
                // TODO: decide if we want to be appending to this list or overwriting it
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
            throw error;
        }
        const { automationRuleUuid: ruleUuid, templateId: templateId, recurOnScheduleConfig: recurOnScheduleConfig } = issueProperties;
        if (skipDeletingIssueProperties && !ruleUuid) // nothing to do
        return;
        setState({
            isDeletingRule: true
        });
        const analyticsEvent = createAnalyticsEvent({});
        // delete or disable the rule if we know the rule UUID
        if (ruleUuid) try {
            if (isRuleOwner || isSiteAdmin) {
                await (0, $519t2.callServiceWithAnalytics)(analyticsEvent, (0, $fAJ3G.deleteRule)({
                    environment: environment,
                    cloudId: cloudId,
                    projectId: projectId,
                    ruleUuid: ruleUuid
                }), 'deleteRule');
                (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'recurringRule deleted', {
                    issueKey: // TODO: add ruleId attribute
                    issueKey,
                    ruleUuid: ruleUuid,
                    templateId: templateId,
                    recurCondition: recurOnScheduleConfig?.recurCondition,
                    isUpdateForExistingRule: isUpdatingRule
                });
            } else {
                await (0, $519t2.callServiceWithAnalytics)(analyticsEvent, (0, $fAJ3G.disableRule)({
                    environment: environment,
                    cloudId: cloudId,
                    projectId: projectId,
                    ruleUuid: ruleUuid
                }), 'disableRule');
                (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'recurringRule disabled', {
                    issueKey: // TODO: add ruleId attribute
                    issueKey,
                    ruleUuid: ruleUuid,
                    templateId: templateId,
                    recurCondition: recurOnScheduleConfig?.recurCondition,
                    isUpdateForExistingRule: isUpdatingRule
                });
            }
        } catch (error) {
            // abort if the rule cannot be deleted/disabled
            setState({
                isDeletingRule: false,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
            throw error;
        }
        if (skipDeletingIssueProperties) {
            // we only get here if we've successfully deleted/disabled a recur-on-schedule rule.
            // it's not possible to re-enable disabled rules, so we can assume that the rule will
            // no longer generate future work items. this means that the issue's issue properties
            // are no longer important to store.
            setState({
                isDeletingRule: false,
                ...(0, $lQupu.NO_RULE_PARTIAL_STATE)
            });
            return;
        }
        try {
            await (0, $519t2.callServiceWithAnalytics)(analyticsEvent, (0, $fAJ3G.deleteIssueProperties)({
                issueKey: issueKey
            }), 'deleteIssueProperties');
            setState({
                isDeletingRule: false,
                ...(0, $lQupu.NO_RULE_PARTIAL_STATE)
            });
        } catch (error) {
            if (!ruleUuid) {
                // in this case, we haven't deleted or disabled the rule, so the rule can still generate
                // future work items. we leave the rule stored in state unchanged and rethrow the error.
                setState({
                    isDeletingRule: false,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    errors: [
                        ...errors ?? [],
                        error
                    ]
                });
                throw error;
            }
            // don't rethrow because from the user's perspective, the work item is no longer recurring.
            setState({
                isDeletingRule: false,
                ...(0, $lQupu.NO_RULE_PARTIAL_STATE),
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
        }
    };

});
parcelRegister("lQupu", function(module, exports) {

$parcel$export(module.exports, "INITIAL_STATE", () => $6bdecc95b0135cf9$export$36d128238e6b60f5);
$parcel$export(module.exports, "NO_RULE_PARTIAL_STATE", () => $6bdecc95b0135cf9$export$a1b15f9b9ceb0f70);
const $6bdecc95b0135cf9$export$36d128238e6b60f5 = {
    hasFetched: false,
    isFetching: false,
    isCreatingRule: false,
    isDeletingRule: false,
    isUpdatingRule: false,
    errors: null,
    hasBootstrapError: false,
    isRuleOwner: null,
    issueProperties: null
};
const $6bdecc95b0135cf9$export$a1b15f9b9ceb0f70 = {
    isRuleOwner: null,
    issueProperties: null
};

});


parcelRegister("bvhsR", function(module, exports) {

$parcel$export(module.exports, "setAsRecurringIssue", () => $fe7808073e642503$export$5d9cc8e9f9314f21);

var $7Jxgt = parcelRequire("7Jxgt");

var $8zOmE = parcelRequire("8zOmE");

var $cS75I = parcelRequire("cS75I");

var $ahBjy = parcelRequire("ahBjy");

var $519t2 = parcelRequire("519t2");
const $fe7808073e642503$export$5d9cc8e9f9314f21 = ({ recurOnScheduleConfig: { rRule: rRule, recurCondition: recurCondition, dueDateOffsetSmartValue: dueDateOffsetSmartValue } })=>async ({ setState: setState, getState: getState }, { createAnalyticsEvent: createAnalyticsEvent, issueKey: issueKey, environment: environment, cloudId: cloudId, projectId: projectId })=>{
        const { errors: errors, isUpdatingRule: isUpdatingRule } = getState();
        setState({
            isCreatingRule: true
        });
        const recurrenceToken = (0, $7Jxgt.v4)();
        const templateId = (0, $ahBjy.SOFTWARE_END_USER_TEMPLATE_2);
        const analyticsEvent = createAnalyticsEvent({});
        try {
            const createTemplateResponse = await (0, $519t2.callServiceWithAnalytics)(analyticsEvent, (0, $cS75I.createTemplate)({
                environment: environment,
                cloudId: cloudId,
                projectId: projectId,
                recurrenceToken: recurrenceToken,
                recurCondition: recurCondition,
                rRule: rRule,
                dueDateOffsetSmartValue: dueDateOffsetSmartValue
            }), 'createTemplate');
            if (createTemplateResponse?.ruleUuid) {
                await (0, $519t2.callServiceWithAnalytics)(analyticsEvent, (0, $cS75I.setIssueProperties)({
                    issueKey: issueKey,
                    recurrenceToken: recurrenceToken,
                    ruleUuid: createTemplateResponse.ruleUuid,
                    recurCondition: recurCondition,
                    rRule: rRule,
                    templateId: templateId,
                    dueDateOffsetSmartValue: dueDateOffsetSmartValue
                }), 'setIssueProperties');
                (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'recurringRule created', {
                    issueKey: // TODO: add ruleId attribute
                    issueKey,
                    ruleUuid: createTemplateResponse.ruleUuid,
                    templateId: templateId,
                    recurCondition: recurCondition,
                    isUpdateForExistingRule: isUpdatingRule
                });
                const issueProperties = {
                    automationRuleUuid: createTemplateResponse.ruleUuid,
                    token: recurrenceToken,
                    templateId: templateId,
                    recurOnScheduleConfig: {
                        rRule: rRule,
                        dueDateOffsetSmartValue: dueDateOffsetSmartValue,
                        recurCondition: recurCondition
                    }
                };
                setState({
                    isCreatingRule: false,
                    issueProperties: issueProperties,
                    isRuleOwner: true
                });
            } else throw new Error('New rule failed to be created.');
        } catch (error) {
            setState({
                isCreatingRule: false,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
            throw error;
        }
    };

});
parcelRegister("cS75I", function(module, exports) {

$parcel$export(module.exports, "createTemplate", () => $d425ed86c31f35f6$export$7b7ae612b60e1630);
$parcel$export(module.exports, "setIssueProperties", () => $d425ed86c31f35f6$export$5153917efea4a83d);

var $kV9ss = parcelRequire("kV9ss");

var $c5wox = parcelRequire("c5wox");

var $eusud = parcelRequire("eusud");

var $ahBjy = parcelRequire("ahBjy");
const $d425ed86c31f35f6$export$7b7ae612b60e1630 = async ({ environment: environment, cloudId: cloudId, projectId: projectId, recurrenceToken: recurrenceToken, recurCondition: recurCondition, rRule: rRule, dueDateOffsetSmartValue: dueDateOffsetSmartValue })=>{
    const automationStack = await (0, $c5wox.getAutomationStack)(environment, cloudId);
    const CREATE_TEMPLATE_URL = `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/public/rest/v1/template/create`;
    const ruleHomeARI = (0, $kV9ss.JiraProjectAri).create({
        siteId: cloudId,
        projectId: String(projectId)
    });
    const payload = {
        ruleHome: ruleHomeARI,
        templateId: (0, $ahBjy.SOFTWARE_END_USER_TEMPLATE_2),
        parameters: {
            recurrenceToken: {
                value: recurrenceToken,
                type: 'TEXT'
            },
            rRule: {
                value: rRule,
                type: 'TEXT'
            },
            dueDateOffsetSmartValue: {
                value: dueDateOffsetSmartValue,
                type: 'TEXT'
            },
            recurCondition: {
                value: recurCondition,
                type: 'TEXT'
            }
        }
    };
    return (0, $eusud.performPostRequest)(CREATE_TEMPLATE_URL, {
        body: JSON.stringify(payload)
    });
};
const $d425ed86c31f35f6$export$5153917efea4a83d = async ({ issueKey: issueKey, ruleUuid: ruleUuid, recurrenceToken: recurrenceToken, recurCondition: recurCondition, rRule: rRule, templateId: templateId, dueDateOffsetSmartValue: dueDateOffsetSmartValue })=>{
    const issuePropertiesEndpoint = `/rest/api/2/issue/${issueKey}/properties/recurrence-config`;
    const requestBody = {
        automationRuleUuid: ruleUuid,
        token: recurrenceToken,
        templateId: templateId,
        recurOnScheduleConfig: {
            rRule: rRule,
            dueDateOffsetSmartValue: dueDateOffsetSmartValue,
            recurCondition: recurCondition
        }
    };
    return (0, $eusud.performPutRequest)(issuePropertiesEndpoint, {
        body: JSON.stringify(requestBody)
    });
};

});


parcelRegister("c8g0F", function(module, exports) {

$parcel$export(module.exports, "updateRule", () => $257e932348ccd8c0$export$b2ebf395d72c5a4c);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8zOmE = parcelRequire("8zOmE");

var $fAJ3G = parcelRequire("fAJ3G");

var $519t2 = parcelRequire("519t2");

var $bvhsR = parcelRequire("bvhsR");

var $l9xxv = parcelRequire("l9xxv");
const $257e932348ccd8c0$export$b2ebf395d72c5a4c = ({ isProjectAdmin: isProjectAdmin, isRuleOwner: isRuleOwner, isSiteAdmin: isSiteAdmin, recurOnScheduleConfig: recurOnScheduleConfig })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { createAnalyticsEvent: createAnalyticsEvent, issueKey: issueKey })=>{
        const { issueProperties: issueProperties, errors: errors } = getState();
        if (!issueProperties) {
            // if there is no existing rule, then create a new rule and update issue properties
            await dispatch((0, $bvhsR.setAsRecurringIssue)({
                recurOnScheduleConfig: recurOnScheduleConfig
            }));
            return;
        }
        const { automationRuleUuid: ruleUuid, templateId: templateId } = issueProperties;
        setState({
            isUpdatingRule: true
        });
        try {
            await dispatch((0, $l9xxv.setAsNonRecurringIssue)({
                isProjectAdmin: isProjectAdmin,
                isRuleOwner: isRuleOwner,
                isSiteAdmin: isSiteAdmin,
                // we'll update issue properties later
                skipDeletingIssueProperties: true
            }));
        } catch (error) {
            // don't need to save the error to state because setAsNonRecurringIssue should already do this
            setState({
                isUpdatingRule: false
            });
            throw error;
        }
        // create the new rule
        try {
            await dispatch((0, $bvhsR.setAsRecurringIssue)({
                recurOnScheduleConfig: recurOnScheduleConfig
            }));
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'recurringRule updated', {
                issueKey: // TODO: add ruleId attribute
                issueKey,
                ruleUuid: ruleUuid,
                templateId: templateId,
                recurCondition: recurOnScheduleConfig?.recurCondition,
                isUpdateForExistingRule: true
            });
            setState({
                isUpdatingRule: false
            });
        } catch (error) {
            // if we fail to create the rule and update issue properties, then we need to go back and remove the
            // original recurring rule config from issue properties
            try {
                setState({
                    isDeletingRule: true
                });
                await (0, $519t2.callServiceWithAnalytics)(createAnalyticsEvent({}), (0, $fAJ3G.deleteIssueProperties)({
                    issueKey: issueKey
                }), 'deleteIssueProperties');
                setState({
                    isDeletingRule: false,
                    isUpdatingRule: false,
                    issueProperties: null,
                    isRuleOwner: null,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    errors: [
                        ...errors ?? [],
                        error
                    ]
                });
            } catch (anotherError) {
                // we've made no changes to the rule config since we called `setAsNonRecurringIssue` above,
                // so we don't need to update ruleSummary or issueProperties.
                setState({
                    isDeletingRule: false,
                    isUpdatingRule: false,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    errors: [
                        ...errors ?? [],
                        error,
                        anotherError
                    ]
                });
                throw anotherError;
            }
            // we've just successfully deleted the existing rule; we haven't actually created a new one.
            throw error;
        }
    };

});



parcelRegister("CKlOf", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d9e9728e1365538b$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $d9e9728e1365538b$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    overdue: {
        "id": "business.list.ui.list-view.date-cell.overdue",
        "defaultMessage": "Overdue since {date}"
    },
    due: {
        "id": "business.list.ui.list-view.date-cell.due",
        "defaultMessage": "Due on {date}"
    }
});

});


parcelRegister("8uZt8", function(module, exports) {

$parcel$export(module.exports, "default", () => $72d11d6903be96d2$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $3fesp = parcelRequire("3fesp");

var $9ADwJ = parcelRequire("9ADwJ");

var $dC5iT = parcelRequire("dC5iT");

var $dCm1o = parcelRequire("dCm1o");

var $6OCZm = parcelRequire("6OCZm");

const $72d11d6903be96d2$var$renderIcon = (type)=>{
    switch(type){
        case 0, $6d6eac2504286faf$export$3b43f1ca008dad23:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.ChildIssuesGlyph), null);
        case 0, $6d6eac2504286faf$export$aac403da0d127706:
            return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9ADwJ))), {
                color: "var(--ds-icon-danger, #C9372C)",
                label: ""
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.FlagGlyph), null);
        case 0, $6d6eac2504286faf$export$540a31b23d6b9abd:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.CheckGlyph), null);
        case 0, $6d6eac2504286faf$export$352da558a3a09227:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.UploadGlyph), null);
        case 0, $6d6eac2504286faf$export$178cb2e5b5fc68e8:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.BitbucketBranchesGlyph), null);
        case 0, $6d6eac2504286faf$export$a153e0417183b79:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.BitbucketCommitsGlyph), null);
        case 0, $6d6eac2504286faf$export$555f9a88a8c5f309:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.BitbucketPullrequestsGlyph), null);
        case 0, $6d6eac2504286faf$export$82a1ca282cb5e4e5:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.EmojiFrequentGlyph), null);
        case 0, $6d6eac2504286faf$export$423cd243bf1888bc:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.MoreGlyph), null);
        case 0, $6d6eac2504286faf$export$30a9be92cbb6f382:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.PersonGlyph), null);
        case 0, $6d6eac2504286faf$export$d4ee7b46933c494f:
            return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                paddingInlineEnd: "space.050",
                paddingBlock: "space.025"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fesp))), {
                label: "",
                color: "currentColor"
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.DueDateGlyph), null);
        default:
            throw Error(`Invalid Icon type - ${type}`);
    }
};
const $72d11d6903be96d2$var$CardIcon = (props)=>{
    const { label: label, primaryColor: primaryColor, type: type } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($72d11d6903be96d2$var$Container, {
        role: "img",
        "aria-label": label,
        primaryColor: primaryColor
    }, $72d11d6903be96d2$var$renderIcon(type));
};
var $72d11d6903be96d2$export$2e2bcd8739ae039 = $72d11d6903be96d2$var$CardIcon;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $72d11d6903be96d2$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { primaryColor: primaryColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_yk4yla": (0, $lD23V.default)(__cmplp.primaryColor || undefined)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _1o9zidpf _vwz4kb7n _1veoyfq0 _1ksv19wz",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9ADwJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::88c1f65a7c2db6559a42eb4e9e9ef8e7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6fb6230d529aad86$var$_react = $6fb6230d529aad86$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6fb6230d529aad86$var$_baseNew = $6fb6230d529aad86$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $6fb6230d529aad86$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FlagFilled".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: active feature flags.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6fb6230d529aad86$var$FlagFilledIcon = (props)=>/*#__PURE__*/ $6fb6230d529aad86$var$_react.default.createElement($6fb6230d529aad86$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 1.75A.75.75 0 0 1 2.75 1H14a.75.75 0 0 1 .6 1.2l-2.662 3.55L14.6 9.3a.75.75 0 0 1-.6 1.2H3.5V15H2z" clip-rule="evenodd"/>`
    }, props));
$6fb6230d529aad86$var$FlagFilledIcon.displayName = 'FlagFilledIcon';
var $6fb6230d529aad86$var$_default = module.exports.default = $6fb6230d529aad86$var$FlagFilledIcon;

});

parcelRegister("6OCZm", function(module, exports) {

$parcel$export(module.exports, "ChildIssuesGlyph", () => $9f38e13816957edc$export$e45c85830644abc5);
$parcel$export(module.exports, "FlagGlyph", () => $9f38e13816957edc$export$cef8dc8280f1c02c);
$parcel$export(module.exports, "CheckGlyph", () => $9f38e13816957edc$export$50963481dc57ac5c);
$parcel$export(module.exports, "UploadGlyph", () => $9f38e13816957edc$export$330e95d855f0ff0);
$parcel$export(module.exports, "BitbucketBranchesGlyph", () => $9f38e13816957edc$export$5aa1ec710367c05);
$parcel$export(module.exports, "BitbucketCommitsGlyph", () => $9f38e13816957edc$export$4f751361dc2785a8);
$parcel$export(module.exports, "BitbucketPullrequestsGlyph", () => $9f38e13816957edc$export$314907f846d12b79);
$parcel$export(module.exports, "EmojiFrequentGlyph", () => $9f38e13816957edc$export$e6da30a8001300c0);
$parcel$export(module.exports, "MoreGlyph", () => $9f38e13816957edc$export$f291c054d6e2e898);
$parcel$export(module.exports, "PersonGlyph", () => $9f38e13816957edc$export$b59bd42a398a2b3c);
$parcel$export(module.exports, "DueDateGlyph", () => $9f38e13816957edc$export$45e4820251213456);

var $5uXOq = parcelRequire("5uXOq");
const $9f38e13816957edc$export$e45c85830644abc5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M11 7h2v5h-2zm5 6h2v3h-2zM6 13h2v3H6z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M7 11h10a1 1 0 011 1v1H6v-1a1 1 0 011-1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M5 18v1h4v-1H5zm0-2h4a2 2 0 012 2v1a2 2 0 01-2 2H5a2 2 0 01-2-2v-1a2 2 0 012-2zm10 2v1h4v-1h-4zm0-2h4a2 2 0 012 2v1a2 2 0 01-2 2h-4a2 2 0 01-2-2v-1a2 2 0 012-2zM10 5v1h4V5h-4zm0-2h4a2 2 0 012 2v1a2 2 0 01-2 2h-4a2 2 0 01-2-2V5a2 2 0 012-2z",
        fillRule: "nonzero"
    })));
const $9f38e13816957edc$export$cef8dc8280f1c02c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M6 12.235v6.446c0 .537.45.977 1 .977s1-.44 1-.977v-5.778c1.17-.341 2.389-.045 3.768.29.982.238 2.036.495 3.13.495a5.73 5.73 0 002.547-.567 1 1 0 00.563-.9V5.466a.998.998 0 00-1.437-.9c-1.345.654-2.731.317-4.331-.071-1.729-.42-3.687-.895-5.678.072A1 1 0 006 5.466v6.769z",
        fill: "currentColor"
    }));
const $9f38e13816957edc$export$50963481dc57ac5c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M6.735 12.322a1 1 0 00-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2335.638 2335.638 0 003.939-3.883l.04-.04a492.598 492.598 0 003.658-3.643 1 1 0 00-1.424-1.404 518.42 518.42 0 01-3.64 3.625l-.04.04a2049.114 2049.114 0 01-3.775 3.722l-3.098-3.363z",
        fill: "currentColor"
    }));
const $9f38e13816957edc$export$330e95d855f0ff0 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        height: "24",
        width: "24",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M11.208 9.32L9.29 11.253a1 1 0 000 1.409.982.982 0 001.397 0l1.29-1.301 1.336 1.347a.982.982 0 001.397.001 1.002 1.002 0 00.001-1.408l-1.965-1.98a1.08 1.08 0 00-1.538-.001z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M11 10.007l.001 9.986c0 .557.448 1.008 1 1.007.553 0 1-.45 1-1.007L13 10.006C13 9.451 12.552 9 12 9s-1.001.451-1 1.007z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M7.938 5.481a4.8 4.8 0 00-.777-.063C4.356 5.419 2 7.62 2 10.499 2 13.408 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.051.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.119a4.14 4.14 0 014.069 3.644l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-1.999-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.021-3.901.901-5.038 2.481z"
    })));
const $9f38e13816957edc$export$5aa1ec710367c05 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M19 11c0 1.3-.8 2.4-2 2.8V15c0 2.2-1.8 4-4 4h-2.2c-.4 1.2-1.5 2-2.8 2-1.7 0-3-1.3-3-3 0-1.3.8-2.4 2-2.8V8.8C5.9 8.4 5 7.3 5 6c0-1.7 1.3-3 3-3s3 1.3 3 3c0 1.3-.8 2.4-2.1 2.8v6.4c.9.3 1.6.9 1.9 1.8H13c1.1 0 2-.9 2-2v-1.2c-1.2-.4-2-1.5-2-2.8 0-1.7 1.3-3 3-3s3 1.3 3 3zM8 5c-.5 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1zm8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1zm-8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $9f38e13816957edc$export$4f751361dc2785a8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M16 12c0-1.9-1.3-3.4-3-3.9V4c0-.6-.4-1-1-1s-1 .4-1 1v4.1c-1.7.4-3 2-3 3.9s1.3 3.4 3 3.9V20c0 .6.4 1 1 1s1-.4 1-1v-4.1c1.7-.5 3-2 3-3.9zm-4 2c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $9f38e13816957edc$export$314907f846d12b79 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M18 15.2V11c0-1.7-1.3-3-3-3h-1.9l.8-.8c.3-.3.3-.8 0-1.1-.3-.3-.8-.3-1.1 0l-2.3 2.3c-.3.4-.3.9 0 1.2l2.3 2.3c.2.2.3.2.5.2s.4-.1.6-.3c.3-.3.3-.8 0-1.1l-.7-.7H15c.6 0 1 .4 1 1v4.2c-1.2.4-2 1.5-2 2.8 0 1.7 1.3 3 3 3s3-1.3 3-3c0-1.3-.8-2.4-2-2.8zM17 19c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zM7 3C5.4 3 4 4.3 4 6c0 1.3.8 2.4 2 2.8V20c0 .6.4 1 1 1s1-.4 1-1V8.8c1.2-.4 2-1.5 2-2.8 0-1.7-1.3-3-3-3zm0 4c-.5 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $9f38e13816957edc$export$e6da30a8001300c0 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8zm0 14.222A6.23 6.23 0 015.778 12 6.23 6.23 0 0112 5.778 6.23 6.23 0 0118.222 12 6.23 6.23 0 0112 18.222zm.889-6.59V8.448c0-.489-.4-.889-.889-.889s-.889.4-.889.89v3.555c0 .248.103.471.268.633l2.195 2.194a.891.891 0 001.257 0 .891.891 0 000-1.256l-1.942-1.943z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $9f38e13816957edc$export$f291c054d6e2e898 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "5",
        cy: "12",
        r: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "12",
        cy: "12",
        r: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "19",
        cy: "12",
        r: "2"
    })));
const $9f38e13816957edc$export$b59bd42a398a2b3c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        height: "24",
        width: "24",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M6 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0V14z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "12",
        cy: "7",
        r: "4"
    })));
const $9f38e13816957edc$export$45e4820251213456 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0119.005 21H4.995A1.995 1.995 0 013 19.006V6.994C3 5.893 3.892 5 4.995 5zM5 9v9a1 1 0 001 1h12a1 1 0 001-1V9H5zm1-5a1 1 0 012 0v1H6V4zm10 0a1 1 0 012 0v1h-2V4zm-9 9v-2.001h2V13H7zm8 0v-2.001h2V13h-2zm-4 0v-2.001h2.001V13H11zm-4 4v-2h2v2H7zm4 0v-2h2.001v2H11zm4 0v-2h2v2h-2z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));

});

const $6d6eac2504286faf$export$3b43f1ca008dad23 = 'child-issues';
const $6d6eac2504286faf$export$aac403da0d127706 = 'flag';
const $6d6eac2504286faf$export$540a31b23d6b9abd = 'tick';
const $6d6eac2504286faf$export$352da558a3a09227 = 'upload';
const $6d6eac2504286faf$export$178cb2e5b5fc68e8 = 'bitbucket-branches';
const $6d6eac2504286faf$export$a153e0417183b79 = 'bitbucket-commits';
const $6d6eac2504286faf$export$555f9a88a8c5f309 = 'bitbucket-pullrequests';
const $6d6eac2504286faf$export$82a1ca282cb5e4e5 = 'emoji-frequent';
const $6d6eac2504286faf$export$423cd243bf1888bc = 'more';
const $6d6eac2504286faf$export$30a9be92cbb6f382 = 'person';
const $6d6eac2504286faf$export$d4ee7b46933c494f = 'due-date';


parcelRegister("eDs1Y", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9d2a4fa84ab79be6$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $9d2a4fa84ab79be6$export$593a022a1631ee1e = 'Due Date: ';
const $9d2a4fa84ab79be6$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    text: {
        "id": "due-date.text",
        "defaultMessage": "Due Date: {date}"
    }
});

});




parcelRegister("46Lnx", function(module, exports) {

$parcel$export(module.exports, "EpicLiteWrapper", () => $1234998e468059c1$export$bb3aabd940f6f405);

var $5uXOq = parcelRequire("5uXOq");

var $iDGXn = parcelRequire("iDGXn");

var $96018 = parcelRequire("96018");
const $1234998e468059c1$export$bb3aabd940f6f405 = ({ card: card, backlogContainerSize: backlogContainerSize, isCompactView: isCompactView })=>{
    const showEpics = (0, $iDGXn.useShowEpics)();
    if (showEpics) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96018.EpicLite), {
        card: card,
        screenSize: backlogContainerSize,
        isCompactView: isCompactView
    });
    return null;
};

});
parcelRegister("96018", function(module, exports) {

$parcel$export(module.exports, "EpicLite", () => $8d3811cd0e9398e5$export$84103c8f50e5bb46);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $7SCny = parcelRequire("7SCny");

var $3fAi8 = parcelRequire("3fAi8");

var $g4tDr = parcelRequire("g4tDr");

var $5fc53 = parcelRequire("5fc53");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");

var $fmuR9 = parcelRequire("fmuR9");

var $3xj9Y = parcelRequire("3xj9Y");

var $8wOzB = parcelRequire("8wOzB");

var $963tu = parcelRequire("963tu");

var $kM28N = parcelRequire("kM28N");
const $8d3811cd0e9398e5$var$EpicLozengeForAllNonEpicsLite = ({ card: card, isCompactView: isCompactView, screenSize: screenSize })=>{
    const parents = (0, $c1MAf.useBacklogSelector)((0, $fmuR9.issueParentsSelector));
    const [parentValue] = (0, $3fAi8.useFieldValue)({
        issueKey: card.key,
        fieldKey: (0, $5fc53.PARENT_TYPE)
    });
    const isSubtask = (0, $g4tDr.isSubtaskHierarchyLevel)(card.typeHierarchyLevel);
    const mappedParent = card.parentId ? parents.find(({ id: id })=>Number(id) === Number(card.parentId)) : null;
    // Check if the card and parent are different as `useFieldValue` can fail and fallback to
    // the current card's summary which is VERY wrong. We need to check this and not show
    // a lozenge if that happens.
    const isParentValueSameAsCard = card.id === parentValue?.id || card.key === parentValue?.key;
    // Use mapped parent first, fallback to parentValue
    const color = mappedParent?.color || parentValue?.color || (0, $7SCny.PURPLE);
    let summary = mappedParent?.summary;
    // If we couldn't get summary from mapped parent, try to add it from parentValue if
    // we got a valid value from useFieldValue.
    if (!summary && !isParentValueSameAsCard) summary = parentValue?.fields?.summary;
    // There are multiple ways that the backlog will fetch the epic. It will either exist in redux
    // OR we will need to retrieve it from the issue fields sweet state.
    const hasValidEpic = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(summary) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(color);
    return(// Using placeholderWidthMultiplier so that with change in container width the width of placeholder changes
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.EpicWrapper), {
        widthMultiplier: (0, $963tu.getLabelWidthMultiplier)((0, $963tu.LabelType).EPIC, screenSize),
        // To avoid any extra space show the placeholder only on cards not linked to any epic and are not subtasks
        showPlaceholder: card.parentId === null && !isSubtask
    }, hasValidEpic && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8wOzB.default), {
        color: color,
        summary: summary ?? '',
        isCompactView: isCompactView
    })));
};
const $8d3811cd0e9398e5$export$84103c8f50e5bb46 = (props)=>{
    const { card: card, screenSize: screenSize } = props;
    const cardHierarchyLevel = (0, $c1MAf.useBacklogSelector)((0, $dGljH.makeGetCardHierarchyLevel));
    const isEpic = (0, $g4tDr.isEpicHierarchyLevel)(cardHierarchyLevel(card.id));
    if (isEpic) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.EpicWrapper), {
        widthMultiplier: (0, $963tu.getLabelWidthMultiplier)((0, $963tu.LabelType).EPIC, screenSize),
        // To avoid any extra space show the placeholder only on cards not linked to any epic and are not subtasks
        showPlaceholder: card.parentId === null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3xj9Y.default), {
        issueId: card.id,
        issueKey: card.key,
        ...props
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8d3811cd0e9398e5$var$EpicLozengeForAllNonEpicsLite, props);
};

});
parcelRegister("3xj9Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae93275362a6a5b5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iHPnC = parcelRequire("iHPnC");

var $3fAi8 = parcelRequire("3fAi8");

var $5fc53 = parcelRequire("5fc53");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");

var $9Pc1U = parcelRequire("9Pc1U");

var $8wOzB = parcelRequire("8wOzB");
const $ae93275362a6a5b5$var$EpicLozengeField = ({ issueKey: issueKey, issueId: issueId, isCompactView: isCompactView })=>{
    const epicColorFieldId = (0, $c1MAf.useBacklogSelector)((0, $9Pc1U.getEpicColorFieldId));
    const cardColor = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.getCardEpicColor)(state, issueId));
    const [epicColorFromFieldsStore] = (0, $3fAi8.useFieldValue)({
        issueKey: issueKey,
        fieldKey: epicColorFieldId ?? ''
    });
    const [epicSummary] = (0, $3fAi8.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $5fc53.SUMMARY_TYPE)
    });
    const color = (0, $iHPnC.asColor)(epicColorFromFieldsStore || cardColor);
    return epicSummary ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8wOzB.default), {
        color: (0, $iHPnC.asColor)(color),
        summary: epicSummary,
        isCompactView: isCompactView
    }) : null;
};
var $ae93275362a6a5b5$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($ae93275362a6a5b5$var$EpicLozengeField);

});
parcelRegister("8wOzB", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc81db34a04dd013$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koOOC = parcelRequire("koOOC");
const $bc81db34a04dd013$export$2fe14dcf8683ace1 = ({ color: color, summary: summary, isCompactView: isCompactView })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bc81db34a04dd013$var$StaticLozengeWrapper, {
        isCompactView: isCompactView
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $koOOC.EpicLozenge), {
        color: color,
        summary: summary,
        isCompactView: isCompactView
    }));
var $bc81db34a04dd013$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($bc81db34a04dd013$export$2fe14dcf8683ace1);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bc81db34a04dd013$var$StaticLozengeWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCompactView: isCompactView, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1txw _4cvresu3 _o5721q9c _1bto1l2s _vchhusvi _p12f1osq _172pidpf _1hcdidpf _1oyyidpf _19h8idpf",
            !__cmplp.isCompactView && "_19bvu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("koOOC", function(module, exports) {

$parcel$export(module.exports, "EpicLozenge", () => $415a24051fa911e5$export$2e623d726e27c97);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $3u0c5 = parcelRequire("3u0c5");

var $3bDjY = parcelRequire("3bDjY");

var $7XYc4 = parcelRequire("7XYc4");

var $iHPnC = parcelRequire("iHPnC");

var $dCm1o = parcelRequire("dCm1o");

var $k8qVk = parcelRequire("k8qVk");

var $7Fute = parcelRequire("7Fute");
const $415a24051fa911e5$export$2e623d726e27c97 = ({ color: color, summary: summary, maxWidth: maxWidth, isCompactView: isCompactView })=>{
    const paletteColorValues = (0, $iHPnC.transformColorToTheme)((colorSchema)=>colorSchema.primary);
    const selectedColor = color && paletteColorValues[color] || '';
    return isCompactView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: summary
    }, selectedColor && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($415a24051fa911e5$export$d9d9ccbf5da84ba4, {
        "data-component-selector": "parent-switcher-epic-lozenge-wrapper",
        color: selectedColor
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($415a24051fa911e5$var$LozengeWrapper, {
        "data-component-selector": "parent-switcher-epic-lozenge-wrapper",
        "data-testid": (0, $k8qVk.PARENT_SWITCHER_LOZENGE_TEST_ID)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: summary,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $7Fute.getLozengeThemeByColor)(color),
        maxWidth: maxWidth,
        testId: "issue-field-parent-switcher.common.ui.epic-lozenge.lozenge"
    }, summary)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $415a24051fa911e5$var$LozengeWrapperOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o _p12f1osq _vwz4kb7n _6ndb1osq _1ksmjp4b",
            __cmplp.className
        ])
    });
});
const $415a24051fa911e5$var$LozengeWrapperNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o _p12f1osq _vwz4kb7n _8x2o1r31 _ce7mglyw _7r681o36 _1ksmjp4b _6ndb1osq",
            __cmplp.className
        ])
    });
});
const $415a24051fa911e5$var$LozengeWrapper = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $415a24051fa911e5$var$LozengeWrapperNew, $415a24051fa911e5$var$LozengeWrapperOld);
const $415a24051fa911e5$export$d9d9ccbf5da84ba4 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $lD23V.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _11q71cj8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1o9zidpf _1bsb7vkz _4t3i7vkz",
            __cmplp.className
        ])
    });
});

});



parcelRegister("963tu", function(module, exports) {

$parcel$export(module.exports, "LabelType", () => $4fbf68de04360380$export$db162f9c7976a7ea);
$parcel$export(module.exports, "getLabelWidthMultiplier", () => $4fbf68de04360380$export$f9a98c799935274d);

var $khnfQ = parcelRequire("khnfQ");
const $4fbf68de04360380$export$db162f9c7976a7ea = {
    VERSION: 'version',
    EPIC: 'epic',
    STATUS: 'status'
};
const $4fbf68de04360380$export$f9a98c799935274d = (labelType, containerWidth)=>{
    switch(containerWidth){
        case (0, $khnfQ.ScreenSize).EXTRA_SMALL:
            if (labelType === $4fbf68de04360380$export$db162f9c7976a7ea.VERSION) return 3;
            if (labelType === $4fbf68de04360380$export$db162f9c7976a7ea.EPIC) return 3;
            return 12.5;
        case (0, $khnfQ.ScreenSize).SMALL:
            if (labelType === $4fbf68de04360380$export$db162f9c7976a7ea.VERSION) return 3;
            return 12.5;
        case (0, $khnfQ.ScreenSize).MEDIUM:
            return 18.75;
        case (0, $khnfQ.ScreenSize).LARGE:
            return 18.75;
        case (0, $khnfQ.ScreenSize).EXTRA_LARGE:
            return 25;
        default:
            return 12.5;
    }
};

});



parcelRegister("dzwJA", function(module, exports) {

$parcel$export(module.exports, "EstimateLite", () => $86030bc50e153025$export$30d0f48cab624df4);

var $5uXOq = parcelRequire("5uXOq");

var $guzeq = parcelRequire("guzeq");

var $c1MAf = parcelRequire("c1MAf");

var $45Qwd = parcelRequire("45Qwd");

var $80uDK = parcelRequire("80uDK");
const $86030bc50e153025$export$30d0f48cab624df4 = ({ shouldRenderEstimatesColumn: shouldRenderEstimatesColumn })=>{
    const estimationType = (0, $c1MAf.useBacklogSelector)((0, $45Qwd.getEstimationType));
    if (estimationType !== (0, $guzeq.ORIGINAL_ESTIMATE)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $80uDK.default), {
        hasEstimate: shouldRenderEstimatesColumn,
        value: undefined
    });
};

});
parcelRegister("80uDK", function(module, exports) {

$parcel$export(module.exports, "default", () => $68646e058dc9ae00$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $16T6Y = parcelRequire("16T6Y");

var $koVbs = parcelRequire("koVbs");

var $etKNj = parcelRequire("etKNj");

var $gnK7n = parcelRequire("gnK7n");

var $ayyYR = parcelRequire("ayyYR");
const $68646e058dc9ae00$var$DEFAULT_NO_VALUE = '0m';
const $68646e058dc9ae00$export$fdcfaf17c0796808 = ({ value: value, hasEstimate: hasEstimate, valueInSeconds: valueInSeconds, timeTrackingOptions: timeTrackingOptions })=>{
    const intl = (0, $koVbs.default)();
    const longFormValue = hasEstimate && valueInSeconds && timeTrackingOptions ? (0, $etKNj.timeTrackingFormatterLongForm)(valueInSeconds, timeTrackingOptions, intl) : undefined;
    const ariaLabel = longFormValue ? `${intl.formatMessage((0, $ayyYR.default).originalEstimateAriaLabel)}: ${longFormValue}` : `${intl.formatMessage((0, $ayyYR.default).originalEstimateAriaLabel)}: ${intl.formatMessage((0, $ayyYR.default).originalEstimateAriaLabelNullValue)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($68646e058dc9ae00$var$OriginalEstimateContainer, null, hasEstimate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gnK7n.default), {
        tooltipLabel: intl.formatMessage((0, $ayyYR.default).originalEstimateTooltip),
        ariaLabel: ariaLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($68646e058dc9ae00$var$OriginalEstimateWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16T6Y.default), {
        appearance: "default"
    }, value ?? $68646e058dc9ae00$var$DEFAULT_NO_VALUE))));
};
var $68646e058dc9ae00$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $5uXOq.memo)($68646e058dc9ae00$export$fdcfaf17c0796808);
const $68646e058dc9ae00$var$OriginalEstimateWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo1kw7 _18m91kw7 _189eyh40 _1dqonqa1 _1h6d3acm _1e0c1txw _2lx21bp4 _4cvr1y6m _vchhusvi _o5721q9c _80om73ad _1bsb1ns9 _1ul9ys9h _18j015vq _d38j15vq _ks4fys9h _1w7e18uv _z6uakb7n _1sqt1q9c _14hh1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $68646e058dc9ae00$var$OriginalEstimateContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ul9ys9h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gnK7n", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a4393c280aa53fe$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3bDjY = parcelRequire("3bDjY");

var $cizWc = parcelRequire("cizWc");
const $2a4393c280aa53fe$var$EstimateFieldWrapper = ({ tooltipLabel: tooltipLabel, ariaLabel: ariaLabel, children: children, tooltipPosition: tooltipPosition = 'bottom' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2a4393c280aa53fe$var$EstimateFieldContainer, {
        role: "group",
        "aria-label": ariaLabel,
        "data-testid": (0, $cizWc.ESTIMATE_FIELD_WRAPPER_TEST_ID)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: tooltipLabel,
        position: tooltipPosition
    }, children));
var $2a4393c280aa53fe$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($2a4393c280aa53fe$var$EstimateFieldWrapper);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a4393c280aa53fe$var$EstimateFieldContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12f1tcg _4t3i1osq _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cizWc", function(module, exports) {

$parcel$export(module.exports, "CHECKBOX_TESTID", () => $ca62fade11f0de7f$export$6fe7aa6a89a9b29);
$parcel$export(module.exports, "CARD_CONTAINER_TESTID", () => $ca62fade11f0de7f$export$b28b0b4c916693a4);
$parcel$export(module.exports, "CARDS_AMOUNT_BADGE_TESTID", () => $ca62fade11f0de7f$export$d1903e0c7f8ee5c7);
$parcel$export(module.exports, "CMD_CLICK_ANALYTICS_ID", () => $ca62fade11f0de7f$export$532ecc85a046702a);
$parcel$export(module.exports, "CHECKBOX_ANALYTICS_ID", () => $ca62fade11f0de7f$export$88f95597995c9129);
$parcel$export(module.exports, "SHIFT_CLICK_ANALYTICS_ID", () => $ca62fade11f0de7f$export$416730846dcfbfdb);
$parcel$export(module.exports, "CMD_SHIFT_CLICK_ANALYTICS_ID", () => $ca62fade11f0de7f$export$757f7ef32cfa3ff);
$parcel$export(module.exports, "CHECKBOX_COMPONENT_SELECTOR", () => $ca62fade11f0de7f$export$40d8217ec5a8ae9a);
$parcel$export(module.exports, "KEY_COMPONENT_SELECTOR", () => $ca62fade11f0de7f$export$eb017f8fc9323651);
$parcel$export(module.exports, "KEY_CONTAINER_TEST_ID", () => $ca62fade11f0de7f$export$3ca3a5ea5b54742d);
$parcel$export(module.exports, "SCREEN_READER_KEY_TEST_ID", () => $ca62fade11f0de7f$export$d30ca8490ead1b3b);
$parcel$export(module.exports, "FLAG_CONTAINER_TEST_ID", () => $ca62fade11f0de7f$export$97794d9709da94ad);
$parcel$export(module.exports, "FLAGGED_BUTTON_TEST_ID", () => $ca62fade11f0de7f$export$f84ddfbd95bff080);
$parcel$export(module.exports, "ADD_FLAG_BUTTON_TEST_ID", () => $ca62fade11f0de7f$export$1dd60f3ce6926cb);
$parcel$export(module.exports, "ESTIMATE_FIELD_WRAPPER_TEST_ID", () => $ca62fade11f0de7f$export$5242fed4d28f1249);
$parcel$export(module.exports, "SUMMARY_TEST_ID", () => $ca62fade11f0de7f$export$b6840ddc4661f707);

var $gwIPs = parcelRequire("gwIPs");
const $ca62fade11f0de7f$export$6fe7aa6a89a9b29 = 'software-backlog.card-list.card.card-contents.checkbox';
const $ca62fade11f0de7f$export$b28b0b4c916693a4 = 'software-backlog.card-list.card.card-contents.card-container';
const $ca62fade11f0de7f$export$d1903e0c7f8ee5c7 = 'software-backlog.card-list.card.card-contents.cards-amount-badge';
const $ca62fade11f0de7f$export$532ecc85a046702a = 'cmdclick';
const $ca62fade11f0de7f$export$88f95597995c9129 = 'checkbox';
const $ca62fade11f0de7f$export$416730846dcfbfdb = 'shiftclick';
const $ca62fade11f0de7f$export$757f7ef32cfa3ff = 'cmdshiftclick';
const $ca62fade11f0de7f$export$40d8217ec5a8ae9a = 'software-backlog-card-card-contents-checkbox-container';
const $ca62fade11f0de7f$export$eb017f8fc9323651 = 'software-backlog.card-list.card.card-contents.key';
const $ca62fade11f0de7f$export$3ca3a5ea5b54742d = 'software-backlog.card-list.card.card-contents.accessible-card-key';
const $ca62fade11f0de7f$export$d30ca8490ead1b3b = 'software-backlog.card-list.card.card-contents.screen-reader-key';
const $ca62fade11f0de7f$export$97794d9709da94ad = 'software-backlog.card-list.card.card-contents.flag-container';
const $ca62fade11f0de7f$export$f84ddfbd95bff080 = 'software-backlog.card-list.card.card-contents.flagged-button';
const $ca62fade11f0de7f$export$1dd60f3ce6926cb = 'software-backlog.card-list.card.card-contents.add-flag-button';
const $ca62fade11f0de7f$export$5242fed4d28f1249 = 'software-backlog.card-list.card.card-contents.estimate-field-wrapper';
const $ca62fade11f0de7f$export$b6840ddc4661f707 = 'software-backlog.card-list.card.card-contents.summary';
const $ca62fade11f0de7f$export$a7e851dd01b7bece = (0, $gwIPs.gridSize) * 2;

});


parcelRegister("ayyYR", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b997f17803ac882$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4b997f17803ac882$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    originalEstimateTooltip: {
        "id": "backlog.card-list.card.card-contents.original-estimate-field.original-estimate-tooltip",
        "defaultMessage": "Original estimate"
    },
    originalEstimateAriaLabel: {
        "id": "backlog.card-list.card.card-contents.original-estimate-field.original-estimate-aria-label",
        "defaultMessage": "Original estimate"
    },
    originalEstimateAriaLabelNullValue: {
        "id": "backlog.card-list.card.card-contents.original-estimate-field.original-estimate-aria-label-null-value",
        "defaultMessage": "No estimate set"
    },
    invalidTimeFormatMessage: {
        "id": "backlog.card-list.card.card-contents.original-estimate-field.invalid-time-format-message",
        "defaultMessage": "Your estimate must be in the format {format}."
    }
});

});



parcelRegister("MdcUe", function(module, exports) {

$parcel$export(module.exports, "Flag", () => $50f4f7d0b168b8e8$export$48ea269755562084);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9ADwJ = parcelRequire("9ADwJ");

var $iyN9w = parcelRequire("iyN9w");
const $50f4f7d0b168b8e8$export$48ea269755562084 = ({ shouldRenderInlineAddFlag: shouldRenderInlineAddFlag, isFlagged: isFlagged })=>{
    const inlineFlag = shouldRenderInlineAddFlag ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($50f4f7d0b168b8e8$var$FlagPlaceHolder, null) : null;
    const flagIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9ADwJ))), {
        label: "Flagged icon",
        color: "var(--ds-icon-danger, #C9372C)",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($iyN9w))),
        LEGACY_size: "small",
        LEGACY_primaryColor: "var(--ds-icon-danger, #C9372C)"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($50f4f7d0b168b8e8$var$FlagContainer, null, isFlagged ? flagIcon : inlineFlag);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $50f4f7d0b168b8e8$var$FlagContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1pbykb7n",
            __cmplp.className
        ])
    });
});
const $50f4f7d0b168b8e8$var$FlagPlaceHolder = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb7vkz _4t3i1tcg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iyN9w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d83187a0eb7b20f4$var$_react = $d83187a0eb7b20f4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $d83187a0eb7b20f4$var$_flagFilled = $d83187a0eb7b20f4$var$_interopRequireDefault((parcelRequire("9ADwJ")));
function $d83187a0eb7b20f4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d83187a0eb7b20f4$var$FlagFilledIcon = (props)=>/*#__PURE__*/ $d83187a0eb7b20f4$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6 12.235v6.446c0 .537.45.977 1 .977s1-.44 1-.977v-5.778c1.17-.341 2.389-.045 3.768.29.982.238 2.036.495 3.13.495a5.7 5.7 0 0 0 2.547-.567 1 1 0 0 0 .563-.9V5.466a.998.998 0 0 0-1.437-.9c-1.345.654-2.731.317-4.331-.071-1.729-.42-3.687-.895-5.678.072A1 1 0 0 0 6 5.466z"/></svg>`
    }, props, {
        newIcon: $d83187a0eb7b20f4$var$_flagFilled.default
    }));
$d83187a0eb7b20f4$var$FlagFilledIcon.displayName = 'FlagFilledIcon';
var $d83187a0eb7b20f4$var$_default = module.exports.default = $d83187a0eb7b20f4$var$FlagFilledIcon;

});


parcelRegister("5GU7f", function(module, exports) {

$parcel$export(module.exports, "PriorityLite", () => $7dc996f90b69552f$export$919bb9d97260bc8d);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $3fAi8 = parcelRequire("3fAi8");

var $5fc53 = parcelRequire("5fc53");

var $4EUws = parcelRequire("4EUws");

var $aHbBN = parcelRequire("aHbBN");
const $7dc996f90b69552f$export$919bb9d97260bc8d = ({ issueKey: issueKey, shouldRenderPriorityColumn: shouldRenderPriorityColumn })=>{
    const [priorityFieldValue] = (0, $3fAi8.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $5fc53.PRIORITY_TYPE)
    });
    // Matching src/packages/software/backlog/src/view/card-list/card/card-contents/priority-field/index.tsx
    if (!shouldRenderPriorityColumn) return null;
    const hasPriority = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(priorityFieldValue) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(priorityFieldValue.name) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(priorityFieldValue.iconUrl);
    const priorityFieldStatic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4EUws.StaticPriorityFieldWrapper), {
        shouldRenderColumn: shouldRenderPriorityColumn
    }, hasPriority ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aHbBN.default), {
        name: priorityFieldValue.name,
        iconUrl: priorityFieldValue.iconUrl
    }) : null);
    return priorityFieldStatic;
};

});
parcelRegister("4EUws", function(module, exports) {

$parcel$export(module.exports, "StaticPriorityFieldWrapper", () => $5d2c811b08f9b18f$export$82aa3dc89c56ae53);
$parcel$export(module.exports, "default", () => $5d2c811b08f9b18f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $hGgHi = parcelRequire("hGgHi");

var $gwIPs = parcelRequire("gwIPs");

var $4R6GH = parcelRequire("4R6GH");

var $3fAi8 = parcelRequire("3fAi8");

var $hTfH8 = parcelRequire("hTfH8");

var $5fc53 = parcelRequire("5fc53");

var $iXVV6 = parcelRequire("iXVV6");

var $kxZPA = parcelRequire("kxZPA");


var $dM9vk = parcelRequire("dM9vk");

var $aHbBN = parcelRequire("aHbBN");

const $5d2c811b08f9b18f$export$dbf159d6b5b6b5ad = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("aVYod")).then(({ PriorityChipField: PriorityChipField })=>PriorityChipField), {
    moduleId: "./src/packages/issue/fields/priority-chip/src/index.tsx"
});
const $5d2c811b08f9b18f$var$PriorityField = ({ isUserAtLeastMember: isUserAtLeastMember, shouldRenderRichCard: shouldRenderRichCard, issueKey: issueKey, shouldRenderColumn: shouldRenderColumn, name: name, iconUrl: iconUrl })=>{
    const [priorityFieldValue] = (0, $3fAi8.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $5fc53.PRIORITY_TYPE)
    });
    // Do not render the priority column if no card on backlog has priority
    if (!shouldRenderColumn && ((0, $4R6GH.fg)('jsw-backlog-priority-field-render') ? !name || !iconUrl : (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(priorityFieldValue) || !priorityFieldValue.name || !priorityFieldValue.iconUrl)) return null;
    const hasPriority = (0, $4R6GH.fg)('jsw-backlog-priority-field-render') ? !!name && !!iconUrl : !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(priorityFieldValue) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(priorityFieldValue.name) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(priorityFieldValue.iconUrl);
    const priorityFieldStatic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5d2c811b08f9b18f$export$82aa3dc89c56ae53, {
        shouldRenderColumn: shouldRenderColumn
    }, hasPriority ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aHbBN.default), {
        name: (0, $4R6GH.fg)('jsw-backlog-priority-field-render') ? name : priorityFieldValue.name,
        iconUrl: (0, $4R6GH.fg)('jsw-backlog-priority-field-render') ? iconUrl : priorityFieldValue.iconUrl
    }) : null);
    if (isUserAtLeastMember && shouldRenderRichCard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTfH8.PriorityChipFieldBoundary), {
        packageName: (0, $a9c483c0d986286a$export$dfd208682d29484c),
        fallback: priorityFieldStatic
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dM9vk.default), {
        experienceTarget: (0, $5fc53.PRIORITY_TYPE),
        experienceTargetId: issueKey,
        additionalAttributes: {
            issueKey: issueKey
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5d2c811b08f9b18f$var$PriorityFieldWrapper, {
        shouldRenderColumn: shouldRenderColumn
    }, hasPriority ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            isInlineEditing: true
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5d2c811b08f9b18f$export$dbf159d6b5b6b5ad, {
        issueKey: issueKey
    })) : null)));
    return priorityFieldStatic;
};
var $5d2c811b08f9b18f$export$2e2bcd8739ae039 // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
 = /*#__PURE__*/ (0, $5uXOq.memo)($5d2c811b08f9b18f$var$PriorityField);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5d2c811b08f9b18f$var$PriorityFieldWrapper = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-178nh9s-0"
})`position:relative;display:flex;align-items:center;cursor:default;min-width:${({ shouldRenderColumn: shouldRenderColumn })=>shouldRenderColumn ? `${(0, $gwIPs.gridSize) * 3}px` : null};max-width:${({ shouldRenderColumn: shouldRenderColumn })=>shouldRenderColumn ? `${(0, $gwIPs.gridSize) * 3}px` : null};& > button + div{position:absolute !important;top:${"var(--ds-space-400, 32px)"} !important;left:auto !important;right:${"var(--ds-space-negative-025, -2px)"} !important;transform:none !important;}&:focus,&:focus-within{outline:none;}`;
const $5d2c811b08f9b18f$export$82aa3dc89c56ae53 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldRenderColumn: shouldRenderColumn, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.shouldRenderColumn && "_1ul91tcg _p12f1tcg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hTfH8", function(module, exports) {

$parcel$export(module.exports, "PriorityChipFieldBoundary", () => $c88604a3dedf5694$export$9d18c32154d1536);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");
const $c88604a3dedf5694$export$9d18c32154d1536 = ({ children: children, fallback: fallback, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "issue-priority-chip",
        packageName: packageName,
        render: ()=>fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-priority-chip-boundary",
        fallback: fallback
    }, children));

const $c88604a3dedf5694$export$104c599231a6d317 = (0, $kxZPA.lazy)(()=>(parcelRequire("jqtGq")).then(({ PriorityChipField: PriorityChipField })=>PriorityChipField), {
    moduleId: "./src/packages/issue/fields/priority-chip/src/ui/main.tsx"
});

});
parcelRegister("jqtGq", function(module, exports) {

let $e247787c30f8e4e3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e247787c30f8e4e3$var$load("9l0DZ").then(()=>parcelRequire('72HZ8'));

});


parcelRegister("aHbBN", function(module, exports) {

$parcel$export(module.exports, "default", () => $13293c200f360bb1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7Y70r = parcelRequire("7Y70r");
const $13293c200f360bb1$export$2ccb5d74629a741d = ({ name: name, iconUrl: iconUrl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Y70r.PriorityChipRead), {
        name: name,
        iconUrl: iconUrl
    });
var $13293c200f360bb1$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($13293c200f360bb1$export$2ccb5d74629a741d);

});
parcelRegister("7Y70r", function(module, exports) {

$parcel$export(module.exports, "PriorityChipRead", () => $cdcd5a4499ede0a2$export$92ecdadfd000de84);

var $5uXOq = parcelRequire("5uXOq");

var $1tQVG = parcelRequire("1tQVG");
const $cdcd5a4499ede0a2$export$92ecdadfd000de84 = ({ name: name, iconUrl: iconUrl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1tQVG.PriorityIcon), {
        name: name,
        iconUrl: iconUrl
    });

});
parcelRegister("1tQVG", function(module, exports) {

$parcel$export(module.exports, "PriorityIcon", () => $6684e89be4f617c8$export$3abf8cb3bcb0225);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3bDjY = parcelRequire("3bDjY");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $a5ldi = parcelRequire("a5ldi");
const $6684e89be4f617c8$export$3abf8cb3bcb0225 = ({ name: name, iconUrl: iconUrl })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    let priorityName = name;
    if ((0, $4R6GH.fg)('sea-2830-improve-accessibility-of-priority-field')) priorityName = formatMessage((0, $a5ldi.default).priorityTooltip, {
        name: name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: priorityName,
        testId: "issue-field-priority-chip.common.ui.priority-icon.tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6684e89be4f617c8$export$be58b4326e23250f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6684e89be4f617c8$export$f04a61298a47a40f, {
        alt: priorityName,
        src: iconUrl
    })));
};
const $6684e89be4f617c8$export$be58b4326e23250f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4cvr1h6o _1e0c1txw _1bah1h6o _4t3i1tcg _1bsb1tcg",
            __cmplp.className
        ])
    });
});
const $6684e89be4f617c8$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3if6fq _1bsbf6fq _s7n41ndm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("a5ldi", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7d1a749f620728b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d7d1a749f620728b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    priorityTooltip: {
        "id": "issue-field-priority-chip.common.priority-icon.priority-tooltip",
        "defaultMessage": "Priority: {name}"
    }
});

});




parcelRegister("aVYod", function(module, exports) {

let $7f5e125d3f043e3d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7f5e125d3f043e3d$var$load("fT1qw").then(()=>parcelRequire('h16RV'));

});



parcelRegister("7eYN2", function(module, exports) {

$parcel$export(module.exports, "Status", () => $b66cfc821f3ed707$export$96e9906d6d93a972);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $gwIPs = parcelRequire("gwIPs");

var $iDGXn = parcelRequire("iDGXn");

var $c1MAf = parcelRequire("c1MAf");

var $9Pc1U = parcelRequire("9Pc1U");

var $963tu = parcelRequire("963tu");

var $bhQK9 = parcelRequire("bhQK9");
const $b66cfc821f3ed707$export$96e9906d6d93a972 = ({ cardKey: cardKey, backlogContainerSize: backlogContainerSize })=>{
    const isUserAtLeastMember = (0, $c1MAf.useBacklogSelector)((0, $9Pc1U.isUserAtLeastMemberOfProject));
    const showStatuses = (0, $iDGXn.useShowStatuses)();
    return showStatuses ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b66cfc821f3ed707$var$StatusContainer, {
        widthMultiplier: (0, $963tu.getLabelWidthMultiplier)((0, $963tu.LabelType).STATUS, backlogContainerSize)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bhQK9.StatusLite), {
        isUserAtLeastMember: isUserAtLeastMember,
        issueKey: cardKey
    })) : null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b66cfc821f3ed707$var$StatusContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { widthMultiplier: widthMultiplier, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_uu7jbp": (0, $lD23V.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `repeat(auto-fit,${(0, $gwIPs.gridSize) * __cmplp.widthMultiplier}px)`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo1kw7 _18m91kw7 _1e0c11p5 _4t3i1tcg _lcxvglyw _yv0e105t",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bhQK9", function(module, exports) {

$parcel$export(module.exports, "StatusLite", () => $a5bc8bd5d47cbd27$export$8c32e03375f9b492);

var $5uXOq = parcelRequire("5uXOq");

var $ggSx2 = parcelRequire("ggSx2");

var $hGgHi = parcelRequire("hGgHi");

var $gULOk = parcelRequire("gULOk");

var $3fAi8 = parcelRequire("3fAi8");


var $7I9R8 = parcelRequire("7I9R8");
const $a5bc8bd5d47cbd27$export$8c32e03375f9b492 = ({ issueKey: issueKey, isUserAtLeastMember: isUserAtLeastMember })=>{
    const [statusFieldValue] = (0, $3fAi8.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $e9be48d6d2c01760$export$4420b7468f889692)
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(statusFieldValue) || !statusFieldValue.id || !statusFieldValue.name) return null;
    const value = {
        id: statusFieldValue.id,
        name: statusFieldValue.name,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        category: (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))((0, $gULOk.StatusCategoryIds))[statusFieldValue.statusCategory.id] || (0, $gULOk.StatusCategoryTypes).UNDEFINED
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7I9R8.default), {
        isUserAtLeastMember: isUserAtLeastMember,
        value: value
    });
};

});
parcelRegister("7I9R8", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e8d993c1e4fcd4a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8QpSo = parcelRequire("8QpSo");

var $5LWLA = parcelRequire("5LWLA");

var $3u0c5 = parcelRequire("3u0c5");

var $dqoiX = parcelRequire("dqoiX");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $dz8QR = parcelRequire("dz8QR");

var $e9UTK = parcelRequire("e9UTK");
const $7e8d993c1e4fcd4a$export$5aa9263ebcef0dab = ({ isUserAtLeastMember: isUserAtLeastMember, value: value, name: nameProp, category: categoryProp })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const name = (0, $4R6GH.fg)('use_backlog_card_data_for_rendering') ? nameProp : value?.name;
    const category = (0, $4R6GH.fg)('use_backlog_card_data_for_rendering') ? categoryProp : value?.category;
    if (category === undefined) return null;
    const ChevronDownGlyph = (0, $8QpSo.default)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
            width: 12,
            height: 12,
            viewBox: "5 5 13 13"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M8.292 10.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0z",
            fill: "currentColor",
            fillRule: "evenodd"
        })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7e8d993c1e4fcd4a$var$StaticLozengeWrapper, {
        visualRefresh: !(0, $dCm1o.isVisualRefreshEnabled)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), null, formatMessage((0, $dz8QR.default).statusLozenge)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
        appearance: (0, $e9UTK.getStatusAppearance)(category),
        ...(0, $dCm1o.isVisualRefreshEnabled)() ? {
            isBold: true
        } : {}
    }, isUserAtLeastMember ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7e8d993c1e4fcd4a$var$StaticLozengeContentWrapper, null, name, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        glyph: ChevronDownGlyph,
        label: ""
    })) : name));
};
var $7e8d993c1e4fcd4a$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $5uXOq.memo)($7e8d993c1e4fcd4a$export$5aa9263ebcef0dab);
const $7e8d993c1e4fcd4a$var$StaticLozengeContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bsb1osq _1e0c1o8l _s7n4jp4b _4cvr1h6o _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7e8d993c1e4fcd4a$var$StaticLozengeWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { visualRefresh: visualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _1bto1l2s _o5721q9c _1npcyh40 _1gicyh40 _1e09yh40 _1mspyh40 _1at8idpf _hjaq1b66 _1cjoidpf _1yg61b66 _172pidpf _1hcdidpf _1oyyidpf _19h8idpf _26sdmoej",
            !(0, $dCm1o.isVisualRefreshEnabled)() && "_1r9u1o8v",
            __cmplp.visualRefresh && "_jbwymoej",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dz8QR", function(module, exports) {

$parcel$export(module.exports, "default", () => $69f388fba4641d64$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $69f388fba4641d64$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    statusLozenge: {
        "id": "backlog.card-list.card.card-contents.status-field.status-field-static.status-lozenge",
        "defaultMessage": "status"
    }
});

});

parcelRegister("e9UTK", function(module, exports) {

$parcel$export(module.exports, "getStatusAppearance", () => $e688dc4afbe8e1d9$export$548966735f47dde3);

var $gULOk = parcelRequire("gULOk");

var $b8gJu = parcelRequire("b8gJu");
const $e688dc4afbe8e1d9$export$548966735f47dde3 = (statusCategory)=>{
    const { default: defaultAppearance, inprogress: inprogress, success: success } = (0, $b8gJu.LOZENGE_APPEARANCE);
    const StatusCategoryAppearances = Object.freeze({
        [(0, $gULOk.StatusCategoryTypes).UNDEFINED]: defaultAppearance,
        [(0, $gULOk.StatusCategoryTypes).NEW]: defaultAppearance,
        [(0, $gULOk.StatusCategoryTypes).DONE]: success,
        [(0, $gULOk.StatusCategoryTypes).INDETERMINATE]: inprogress
    });
    return StatusCategoryAppearances[statusCategory] || defaultAppearance;
};

});
parcelRegister("b8gJu", function(module, exports) {

$parcel$export(module.exports, "LOZENGE_APPEARANCE", () => $5730f4b91f5d7ebc$export$7e4a71985d57222c);
$parcel$export(module.exports, "CARD_CONTAINER_SELECTOR_NAME", () => $5730f4b91f5d7ebc$export$7608524551986a84);
$parcel$export(module.exports, "CARD_CONTAINER_SELECTOR", () => $5730f4b91f5d7ebc$export$fb374ae0d58ab29b);
$parcel$export(module.exports, "COLUMN_TITLE_SELECTOR_NAME", () => $5730f4b91f5d7ebc$export$c2a2d9d97661439b);
$parcel$export(module.exports, "COLUMN_TITLE_LOZENGES_SELECTOR_NAME", () => $5730f4b91f5d7ebc$export$675d25966b2d2499);
$parcel$export(module.exports, "COLUMN_WRAPPER_FORM_SELECTOR_NAME", () => $5730f4b91f5d7ebc$export$6c814df87e7543d5);
$parcel$export(module.exports, "DRAGGABLE_COLUMN_SELECTOR_NAME", () => $5730f4b91f5d7ebc$export$4167d13afb6ba84b);
$parcel$export(module.exports, "DRAGGABLE_COLUMN_SELECTOR", () => $5730f4b91f5d7ebc$export$9d54b3872a1af680);
$parcel$export(module.exports, "UPDATE_BOARD_SCROLL_POSITION", () => $5730f4b91f5d7ebc$export$d339f9637e1ca3b4);
$parcel$export(module.exports, "DATA_ANNOUNCED_IGNORE_DND_TYPE", () => $5730f4b91f5d7ebc$export$e1beb09058b7dca1);
$parcel$export(module.exports, "DATA_ANNOUNCED_COLUMN_HEADER", () => $5730f4b91f5d7ebc$export$eb11bcee172fa7de);
$parcel$export(module.exports, "DATA_ANNOUNCED_CARD_HEADER", () => $5730f4b91f5d7ebc$export$f06ed7eae652ab20);
$parcel$export(module.exports, "BoardView", () => $5730f4b91f5d7ebc$export$373e09b633948dc);

const $5730f4b91f5d7ebc$export$7e4a71985d57222c = {
    default: 'default',
    inprogress: 'inprogress',
    moved: 'moved',
    new: 'default',
    removed: 'removed',
    success: 'success'
};
const $5730f4b91f5d7ebc$export$7608524551986a84 = 'platform-board-kit.ui.card-container';
const $5730f4b91f5d7ebc$export$fb374ae0d58ab29b = `[data-component-selector="${$5730f4b91f5d7ebc$export$7608524551986a84}"]`;
const $5730f4b91f5d7ebc$export$c2a2d9d97661439b = 'platform-board-kit.ui.column-title';
const $5730f4b91f5d7ebc$export$bb13afdd2dbe0316 = `[data-component-selector="${$5730f4b91f5d7ebc$export$c2a2d9d97661439b}"]`;
const $5730f4b91f5d7ebc$export$675d25966b2d2499 = 'platform-board-kit.ui.column-title.lozenges';
const $5730f4b91f5d7ebc$export$1be96bcf0abb2b8e = `[data-component-selector="${$5730f4b91f5d7ebc$export$675d25966b2d2499}"]`;
const $5730f4b91f5d7ebc$export$6c814df87e7543d5 = 'platform-board-kit.ui.column.column-create.form.column-wrapper';
const $5730f4b91f5d7ebc$export$4167d13afb6ba84b = 'platform-board-kit.ui.column.draggable-column';
const $5730f4b91f5d7ebc$export$9d54b3872a1af680 = `[data-component-selector="${$5730f4b91f5d7ebc$export$4167d13afb6ba84b}"]`;
const $5730f4b91f5d7ebc$export$d339f9637e1ca3b4 = 'update-board-scroll-position';
const $5730f4b91f5d7ebc$export$e1beb09058b7dca1 = 'data-announced-ignore-dnd-type';
const $5730f4b91f5d7ebc$export$eb11bcee172fa7de = 'data-announced-column-header';
const $5730f4b91f5d7ebc$export$f06ed7eae652ab20 = 'data-announced-card-header';
const $5730f4b91f5d7ebc$export$373e09b633948dc = {
    JSW_BOARD: 'jsw-board',
    INCREMENT_PLANNING_BOARD: 'increment-planning-board',
    JSM_BOARD: 'jsm-board'
};

});





parcelRegister("gQmIm", function(module, exports) {

$parcel$export(module.exports, "StoryPointLite", () => $67f641da665c9bfd$export$314bcc76f8a35673);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $3fAi8 = parcelRequire("3fAi8");

var $guzeq = parcelRequire("guzeq");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $45Qwd = parcelRequire("45Qwd");

var $81g2L = parcelRequire("81g2L");
const $67f641da665c9bfd$export$314bcc76f8a35673 = ({ issue: issue })=>{
    const estimationType = (0, $c1MAf.useBacklogSelector)((0, $45Qwd.getEstimationType));
    const shouldRenderStoryPointColumn = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasStoryPoints));
    const storyPointFieldId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getStoryPointFieldId));
    const storyPointKey = storyPointFieldId || '';
    const [storyPointFieldValue] = (0, $3fAi8.useFieldValue)({
        issueKey: issue.key,
        fieldKey: storyPointKey
    });
    const hasEstimate = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issue.estimate);
    if (!shouldRenderStoryPointColumn && (!storyPointKey || estimationType !== (0, $guzeq.STORY_POINTS))) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $81g2L.default), {
        value: storyPointFieldValue ?? undefined,
        hasStoryPoints: hasEstimate,
        shouldRenderStoryPointColumn: shouldRenderStoryPointColumn
    });
};

});
parcelRegister("81g2L", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a1535cf7b32b551$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hGgHi = parcelRequire("hGgHi");

var $16T6Y = parcelRequire("16T6Y");

var $MHKc7 = parcelRequire("MHKc7");

var $koVbs = parcelRequire("koVbs");

var $7q84v = parcelRequire("7q84v");

var $gnK7n = parcelRequire("gnK7n");
const $2a1535cf7b32b551$var$DEFAULT_NO_VALUE = '-';
const $2a1535cf7b32b551$export$fdd6fddc555f3cc5 = ({ value: value, hasStoryPoints: hasStoryPoints, shouldRenderStoryPointColumn: shouldRenderStoryPointColumn })=>{
    const { formatNumber: formatNumber, formatMessage: formatMessage } = (0, $koVbs.default)();
    const ariaLabelWithValue = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value) ? formatMessage((0, $7q84v.default).storyPointsAriaLabel, {
        storyPointValue: formatNumber(value)
    }) : formatMessage((0, $7q84v.default).storyPointsAriaLabelNullValue);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2a1535cf7b32b551$var$StoryPointWrapper, {
        shouldRenderStoryPointColumn: shouldRenderStoryPointColumn
    }, hasStoryPoints && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gnK7n.default), {
        tooltipLabel: formatMessage((0, $7q84v.default).storyPointsTooltip),
        ariaLabel: ariaLabelWithValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16T6Y.default), {
        appearance: "default"
    }, !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value) ? formatNumber(value) : $2a1535cf7b32b551$var$DEFAULT_NO_VALUE))));
};
var $2a1535cf7b32b551$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $5uXOq.memo)($2a1535cf7b32b551$export$fdd6fddc555f3cc5);
const $2a1535cf7b32b551$var$StoryPointWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldRenderStoryPointColumn: shouldRenderStoryPointColumn, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _2lx21bp4 _4cvr1h6o _vchhusvi _vwz4kb7n _o5721q9c _80om73ad",
            __cmplp.shouldRenderStoryPointColumn && "_1reo1kw7 _18m91kw7 _1bsb1ns9 _1ul91shb _p12f1shb _18j015vq _d38j15vq _ks4f1shb _1w7e1ule _1sqt1q9c _14hh1l2s",
            __cmplp.className
        ])
    });
});

});


parcelRegister("epPSJ", function(module, exports) {

$parcel$export(module.exports, "Versions", () => $40c735510e80905d$export$4893a37082435e75);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $iDGXn = parcelRequire("iDGXn");

var $963tu = parcelRequire("963tu");

var $a6e3u = parcelRequire("a6e3u");
const $40c735510e80905d$export$4893a37082435e75 = ({ card: card, isCompanyManaged: isCompanyManaged, backlogContainerSize: backlogContainerSize, isCardListContainsVersion: isCardListContainsVersion })=>{
    const shouldDisplayVersions = isCompanyManaged && isCardListContainsVersion;
    const showVersions = (0, $iDGXn.useShowVersions)();
    if (shouldDisplayVersions && showVersions) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($40c735510e80905d$var$VersionsContainer, {
        widthMultiplier: (0, $963tu.getLabelWidthMultiplier)((0, $963tu.LabelType).VERSION, backlogContainerSize)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a6e3u.VersionsField), {
        cardId: card.id,
        backlogContainerSize: backlogContainerSize
    }));
    return null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $40c735510e80905d$var$VersionsContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { widthMultiplier: widthMultiplier, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ewl67i": (0, $lD23V.default)(`repeat(auto-fit, calc(${"var(--ds-space-100, 8px)"} * ${__cmplp.widthMultiplier}))`),
            "--_1qtnkr6": (0, $lD23V.default)(`calc(${"var(--ds-space-100, 8px)"} * ${__cmplp.widthMultiplier})`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c11p5 _1pbykb7n _1bto1l2s _4cvr1h6o _6a6zv2br _lcxvglyw _yv0epq74 _1ul9dike",
            __cmplp.className
        ])
    });
});

});
parcelRegister("a6e3u", function(module, exports) {

$parcel$export(module.exports, "VersionsField", () => $50fd536bb47da793$export$5413999baebac1f7);

var $5uXOq = parcelRequire("5uXOq");

var $2Ljwn = parcelRequire("2Ljwn");

var $jUUuf = parcelRequire("jUUuf");

var $3u0c5 = parcelRequire("3u0c5");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");

var $khnfQ = parcelRequire("khnfQ");

var $kM28N = parcelRequire("kM28N");

var $aYeHZ = parcelRequire("aYeHZ");
function $50fd536bb47da793$export$5413999baebac1f7({ cardId: cardId, backlogContainerSize: backlogContainerSize }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const versions = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.cardVersionsSelector)(state, cardId));
    const tooltipText = (0, $5uXOq.useMemo)(()=>versions.map((version)=>version.name).join(', '), [
        versions
    ]);
    const text = (0, $5uXOq.useMemo)(()=>versions.length === 1 ? versions[0].name : formatMessage((0, $aYeHZ.messages).text, {
            count: versions.length
        }), [
        formatMessage,
        versions
    ]);
    if (!versions.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $50fd536bb47da793$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: tooltipText
    }, backlogContainerSize === (0, $khnfQ.ScreenSize).EXTRA_SMALL || backlogContainerSize === (0, $khnfQ.ScreenSize).SMALL ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.VersionIconWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2Ljwn))), {
        label: "version icon",
        color: "var(--ds-text-subtlest, #626F86)",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jUUuf))),
        LEGACY_primaryColor: "var(--ds-text-subtlest, #626F86)",
        LEGACY_size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.VersionIconNumber), null, versions.length)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), null, text)));
}
const $50fd536bb47da793$var$containerStyles = (0, $8CUq3.xcss)({
    maxWidth: '100%',
    pointerEvents: 'all'
});

});
parcelRegister("aYeHZ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9749e76c88603657$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $9749e76c88603657$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    text: {
        "id": "backlog.card-list.card.card-contents.versions-field.text",
        "defaultMessage": "{count} versions"
    },
    ariaLabel: {
        "id": "backlog.card-list.card.card-contents.versions-field.aria-label",
        "defaultMessage": "{versions} {count, plural, one {version} other {versions}}"
    }
});

});




parcelRegister("iuO0E", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1234dacecf6943c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $guzeq = parcelRequire("guzeq");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $ld0jI = parcelRequire("ld0jI");

var $dGljH = parcelRequire("dGljH");

var $9Pc1U = parcelRequire("9Pc1U");

var $k35me = parcelRequire("k35me");

var $7YAWr = parcelRequire("7YAWr");
const $d1234dacecf6943c$export$7b43361c37f3a9e7 = (cardListType)=>cardListType !== (0, $guzeq.BACKLOG);
function $d1234dacecf6943c$var$ConnectedCardWithIccWrapperInner(props) {
    const { cardId: cardId, cardListId: cardListId, isAttachedToParent: isAttachedToParent, forciblyRenderRichCard: forciblyRenderRichCard, setRichActiveCard: setRichActiveCard } = props;
    // Redux hook
    const cardList = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.getCardLists)(state)[cardListId]);
    // Check if the card is not in the backlog (we don't show status lozenges in the backlog)
    const canShowStatusLozengeOnCards = $d1234dacecf6943c$export$7b43361c37f3a9e7(cardList.type);
    const visibleCardIds = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.makeGetVisibleCardOrderFromCardEntries)(state)(cardListId));
    // cards that are being hidden by the filter will have index -1.
    // Dnd does not officially support this but it works fine.
    const draggableIndex = visibleCardIds.indexOf(cardId);
    const isActiveSprint = (0, $c1MAf.useBacklogSelector)((state)=>(0, $k35me.makeIsCardListActiveSprint)(state)(cardListId));
    const isIccEnabled = (0, $c1MAf.useBacklogSelector)((state)=>!(0, $jG5HW.getIsCompanyManaged)(state) && (0, $9Pc1U.isInlineIssueCreateAvailableForCurrentUser)(state) && (0, $dGljH.hasCardTypesSelector)(state));
    const isVisible = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.makeIsCardVisible)(state)(cardId));
    const shouldRenderRichCard = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.shouldRenderRichElements)(state, {
            cardId: cardId
        })) || forciblyRenderRichCard === true;
    const hasIccOpen = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.hasICCOpen)(state, {
            cardId: cardId
        }));
    // This will be defined if this card is a parent of a card group
    const cardGroup = (0, $c1MAf.useBacklogSelector)((0, $ld0jI.makeGetCardGroupByParentId))(cardListId, cardId);
    const subtaskIds = cardGroup && cardGroup.cardIds;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7YAWr.CardWithIccWrapper), {
        ...props,
        isVisible: isVisible,
        shouldRenderRichCard: shouldRenderRichCard,
        hasIccOpen: hasIccOpen,
        setRichActiveCard: setRichActiveCard,
        isIccEnabled: isIccEnabled,
        draggableIndex: draggableIndex,
        isActiveSprint: isActiveSprint,
        canShowStatusLozengeOnCards: canShowStatusLozengeOnCards,
        isAttachedToParent: isAttachedToParent,
        subtaskIds: subtaskIds
    });
}
const $d1234dacecf6943c$var$ConnectedCardWithIccWrapper = /*#__PURE__*/ (0, $5uXOq.memo)($d1234dacecf6943c$var$ConnectedCardWithIccWrapperInner);
var $d1234dacecf6943c$export$2e2bcd8739ae039 = $d1234dacecf6943c$var$ConnectedCardWithIccWrapper;

});
parcelRegister("7YAWr", function(module, exports) {

$parcel$export(module.exports, "CardWithIccWrapper", () => $7641ddb99215ff69$export$55a2755069cf4bed);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $gUWxi = parcelRequire("gUWxi");

var $gSExi = parcelRequire("gSExi");

var $4R6GH = parcelRequire("4R6GH");

var $1fZVH = parcelRequire("1fZVH");

var $7D59a = parcelRequire("7D59a");

var $hQh4f = parcelRequire("hQh4f");

var $1hEu3 = parcelRequire("1hEu3");

var $hyUTn = parcelRequire("hyUTn");
const $7641ddb99215ff69$var$CardWithIccWrapperInner = ({ cardId: cardId, cardListId: cardListId, isVisible: isVisible, shouldRenderRichCard: shouldRenderRichCard, hasIccOpen: hasIccOpen, setRichActiveCard: setRichActiveCard, isIccEnabled: isIccEnabled, draggableIndex: draggableIndex, canShowStatusLozengeOnCards: canShowStatusLozengeOnCards, isAttachedToParent: isAttachedToParent, subtaskIds: subtaskIds })=>{
    const containerRef = (0, $5uXOq.useRef)(null);
    const hasRenderedRichElements = (0, $5uXOq.useRef)(false);
    const pendingHoverAction = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>()=>clearTimeout(pendingHoverAction.current), [
        pendingHoverAction
    ]);
    const autobatch = (0, $1fZVH.useAutobatch)();
    const onMouseEnter = (0, $7D59a.useEvent)((e)=>{
        autobatch(()=>{
            (0, $gUWxi.default)('backlog.card-hover', e);
            setRichActiveCard(cardId);
        });
    });
    const onFocus = (0, $7D59a.useEvent)(()=>{
        setRichActiveCard(cardId);
    });
    const onMouseLeave = (0, $7D59a.useEvent)(()=>{
        const containerElement = containerRef.current;
        if (!containerElement) return;
         // Remove pending setRichActiveCard if it hasn't already fired
        if (pendingHoverAction) {
            clearTimeout(pendingHoverAction.current);
            pendingHoverAction.current = undefined;
        }
        const activeElement = (0, $hyUTn.getActiveElement)(); // Ignore event if focused on a child
        if (activeElement instanceof Node && containerElement.contains(activeElement)) return;
        setRichActiveCard(null);
    });
    const onBlur = (0, $7D59a.useEvent)((e)=>{
        const { relatedTarget: relatedTarget } = e;
        if (containerRef.current && relatedTarget instanceof Node && !containerRef.current.contains(relatedTarget)) setRichActiveCard(null);
    });
    if (shouldRenderRichCard && !hasRenderedRichElements.current) hasRenderedRichElements.current = true;
     // First card on the list always renders ICC above itself so tab works from the list header
    const canUseICC = isIccEnabled && cardId > 0;
    const shouldRenderICCAbove = canUseICC && (draggableIndex === 0 || hasIccOpen || shouldRenderRichCard || hasRenderedRichElements.current);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7641ddb99215ff69$export$6236cfcd981152cf, {
        isVisible: isVisible,
        innerRef: containerRef,
        onFocus: onFocus,
        onBlur: onBlur,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }, shouldRenderICCAbove && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1hEu3.default), {
        listId: cardListId,
        insertBefore: cardId,
        isBetweenCards: true,
        isFormVisible: (0, $4R6GH.fg)('jira-backlog-close-icc-on-drag') ? hasIccOpen : undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hQh4f.default), {
        id: cardId,
        cardListId: cardListId,
        canShowStatus: canShowStatusLozengeOnCards,
        draggableIndex: draggableIndex,
        shouldRenderRichCard: shouldRenderRichCard || hasRenderedRichElements.current,
        isAttachedToParent: isAttachedToParent,
        subtaskIds: subtaskIds
    }));
};
const $7641ddb99215ff69$export$55a2755069cf4bed = /*#__PURE__*/ (0, $5uXOq.memo)($7641ddb99215ff69$var$CardWithIccWrapperInner); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $7641ddb99215ff69$var$CardWithICCControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1tdshev-0"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        display: props.isVisible ? 'block' : 'none'
    })); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7641ddb99215ff69$var$CardWithICCExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisible: isVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.isVisible ? "_1e0c1ule" : "_1e0cglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $7641ddb99215ff69$export$6236cfcd981152cf = (0, $gSExi.styledComponentWithCondition)(()=>(0, $4R6GH.fg)('jsw_compiled_migration_tanuki'), $7641ddb99215ff69$var$CardWithICCExperiment, $7641ddb99215ff69$var$CardWithICCControl);

});
parcelRegister("gUWxi", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8ab553ad1c79bab$export$2e2bcd8739ae039);

var $7Jxgt = parcelRequire("7Jxgt");

var $5gx4p = parcelRequire("5gx4p");

var $fe1wc = parcelRequire("fe1wc");

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");

var $9AgLs = parcelRequire("9AgLs");
function $f8ab553ad1c79bab$var$mapToInteractionType(eventType) {
    if (eventType === 'click' || eventType === 'dblclick' || eventType === 'mousedown') return 'press';
    if (eventType === 'mouseenter' || eventType === 'mouseover') return 'hover';
    return undefined;
}
function $f8ab553ad1c79bab$var$traceUFOInteraction(name, event) {
    if (!event || !event.isTrusted) return;
    const interactionType = $f8ab553ad1c79bab$var$mapToInteractionType(event.type);
    if (!interactionType) // when interactionType is falsy we do not yet support this type of event. should we blow up with throwing error instead?
    return;
    const rate = (0, $fe1wc.getInteractionRate)(name, interactionType);
    const pressInteractionsList = (0, $fe1wc.getDoNotAbortActivePressInteraction)();
    if (pressInteractionsList?.includes(name)) {
        const interaction = (0, $bFU4G.getActiveInteraction)();
        if (interaction?.ufoName !== 'unknown' && interaction?.type === 'press') return;
    }
    if ((0, $5gx4p.default)(rate)) {
        (0, $bFU4G.abortAll)('new_interaction', name);
        const startTimestamp = event.timeStamp ?? performance.now();
        const newId = (0, $7Jxgt.v4)();
        (0, $1u4q7.DefaultInteractionID).current = newId;
        (0, $bFU4G.addNewInteraction)(newId, name, 'press', startTimestamp, rate, [], (0, $9AgLs.default).current);
    }
}
var $f8ab553ad1c79bab$export$2e2bcd8739ae039 = $f8ab553ad1c79bab$var$traceUFOInteraction;

});

parcelRegister("gSExi", function(module, exports) {

$parcel$export(module.exports, "styledComponentWithCondition", () => $cd06fcc13efa32a5$export$62d8d8fbf238d6af);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");
const $cd06fcc13efa32a5$export$62d8d8fbf238d6af = (useCompiled, CompiledComponent, StyledComponent)=>// Couldn't destructure like {innerRef, ...rest} as
    // typescript is suspcious on destructing generics
    ({ innerRef: innerRef, ...rest })=>useCompiled() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CompiledComponent, {
            ...rest,
            ref: innerRef
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(StyledComponent, {
            ...rest,
            innerRef: innerRef
        });
const $cd06fcc13efa32a5$export$f5b752428255ba78 = (useCompiled, CompiledComponent, StyledComponent)=>({ innerRef: innerRef, ...rest })=>useCompiled() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CompiledComponent, {
            ...rest,
            ref: innerRef
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(StyledComponent, {
            ...rest,
            innerRef: innerRef
        });

});

parcelRegister("hQh4f", function(module, exports) {

$parcel$export(module.exports, "default", () => $e82b26b42582d534$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eZJjh = parcelRequire("eZJjh");

var $3bDjY = parcelRequire("3bDjY");

var $7wqBZ = parcelRequire("7wqBZ");

var $bv8GQ = parcelRequire("bv8GQ");

var $7D59a = parcelRequire("7D59a");

var $iDGXn = parcelRequire("iDGXn");

var $guzeq = parcelRequire("guzeq");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");

var $fSgHa = parcelRequire("fSgHa");

var $gFfOq = parcelRequire("gFfOq");


var $h5zHO = parcelRequire("h5zHO");

var $kM28N = parcelRequire("kM28N");

var $lzKXg = parcelRequire("lzKXg");
const $e82b26b42582d534$export$60332b2344f7fe41 = ({ id: id, cardListId: cardListId, canShowStatus: canShowStatus = false, shouldRenderRichCard: shouldRenderRichCard = true, isAttachedToParent: isAttachedToParent = false, subtaskIds: subtaskIds })=>{
    const card = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.getCards)(state)[String(id)]);
    const isCompanyManaged = (0, $fSgHa.useIsCMPBacklog)();
    const showCompactMode = (0, $iDGXn.useShowCompactMode)();
    const onMouseDown = (0, $7D59a.useEvent)(()=>{
        // Clear any text selection to prevent unexpected dragging behaviour
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.getSelection()?.removeAllRanges();
        (0, $7wqBZ.getLongTasksMetrics)('dnd').start('backlog', (0, $guzeq.BACKLOG_LONG_TASKS_DND_MARK_NAME));
    });
    const onMouseUp = (0, $7D59a.useEvent)(()=>{
        (0, $7wqBZ.getLongTasksMetrics)('dnd').stop((0, $bv8GQ.softwareGenericLongTasksReporter)('dnd'));
    });
    const getHasExtraFields = (0, $c1MAf.useBacklogSelector)((0, $dGljH.hasCardExtraFields));
    const elementRef = (0, $5uXOq.useRef)(null);
    const { isDragging: isDragging, dragPreview: dragPreview, closestEdge: closestEdge, dropState: dropState } = (0, $lzKXg.useDraggableCard)({
        elementRef: elementRef,
        cardListId: cardListId,
        cardId: id
    });
    if (!card) return null;
    const key = card.key;
    const summary = card.summary;
    const icon = card.icon;
    const isOptimistic = id < 0;
    if (isOptimistic) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.CardContainer), {
        isCompact: showCompactMode,
        lowerOpacity: false,
        isSelected: false,
        isFlagged: false,
        isDraggable: true,
        isDragHandle: false,
        hasExtraFields: getHasExtraFields,
        isOptimistic: true,
        shouldShowChevron: isCompanyManaged,
        "data-component-selector": (0, $f836df2846e6254b$export$fb374ae0d58ab29b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.ImageContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.Img), {
        role: "presentation",
        src: icon
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.SummaryAndParentContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: summary
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.Summary), null, summary))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.StyledSpinner), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "small"
    })));
    const testIdProps = {
        'data-test-id': `software-backlog.card-list.card.content-container.${key}`,
        'data-testid': `software-backlog.card-list.card.content-container.${key}`
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.ContentContainer), {
        ref: elementRef,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        tabIndex: -1,
        ...testIdProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gFfOq.default), {
        id: id,
        canShowStatus: canShowStatus,
        isDragging: isDragging,
        shouldRenderRichCard: shouldRenderRichCard,
        isAttachedToParent: isAttachedToParent,
        subtaskIds: subtaskIds
    }), closestEdge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h5zHO.DropIndicator), {
        dropStatisticsCardListId: dropState?.cardListIfDivider ?? undefined,
        droppingOverCardListId: cardListId,
        droppingOverCardId: id,
        edge: closestEdge
    }), dragPreview);
};
var $e82b26b42582d534$export$2e2bcd8739ae039 = $e82b26b42582d534$export$60332b2344f7fe41;

});
parcelRegister("gFfOq", function(module, exports) {

$parcel$export(module.exports, "default", () => $b51b02e8ed71c16e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gccSB = parcelRequire("gccSB");

var $acDhY = parcelRequire("acDhY");

var $7wqBZ = parcelRequire("7wqBZ");

var $g4tDr = parcelRequire("g4tDr");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $a4GLz = parcelRequire("a4GLz");

var $6U9Sv = parcelRequire("6U9Sv");

var $7D59a = parcelRequire("7D59a");

var $4R6GH = parcelRequire("4R6GH");


var $a7yHf = parcelRequire("a7yHf");

var $lReb9 = parcelRequire("lReb9");

var $4mqko = parcelRequire("4mqko");

var $5Eoed = parcelRequire("5Eoed");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $9Pc1U = parcelRequire("9Pc1U");

var $45Qwd = parcelRequire("45Qwd");

var $l9VFH = parcelRequire("l9VFH");

var $fmuR9 = parcelRequire("fmuR9");

var $1z1J7 = parcelRequire("1z1J7");

var $74oBv = parcelRequire("74oBv");

var $bAfUr = parcelRequire("bAfUr");

var $fopK0 = parcelRequire("fopK0");

var $bIoVa = parcelRequire("bIoVa");
function $b51b02e8ed71c16e$var$CardContentsContainer({ id: id, isDragging: isDragging, isDragHandle: isDragHandle, shouldRenderRichCard: shouldRenderRichCard, isAttachedToParent: isAttachedToParent = false, subtaskIds: subtaskIds }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isCompanyManaged = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
    const cards = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCards));
    // There is always the possibility that the card selected does not exist.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const card = cards[String(id)];
    const storyPointFieldId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getStoryPointFieldId));
    const estimationType = (0, $c1MAf.useBacklogSelector)((0, $45Qwd.getEstimationType));
    const timeTrackingOptions = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getTimeTrackingOptions));
    const isUserAtLeastMember = (0, $c1MAf.useBacklogSelector)((0, $9Pc1U.isUserAtLeastMemberOfProject));
    const canUserEditIssue = (0, $c1MAf.useBacklogSelector)((0, $1z1J7.canEditIssue));
    const currentProjectId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.projectIdSelector));
    const projectIds = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getProjectIds));
    const projectAris = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getProjectAris));
    const parents = (0, $c1MAf.useBacklogSelector)((0, $fmuR9.issueParentsSelector));
    const selectedCards = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getSelectedCards));
    const isFocused = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.getFocusedCard)(state) === id);
    const isSelected = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.isCardSelected)(state)(id));
    const highlightText = (0, $c1MAf.useBacklogSelector)((state)=>(0, $l9VFH.getFilters)(state).TEXT ?? null);
    const hasExtraFields = (0, $c1MAf.useBacklogSelector)((0, $dGljH.hasCardExtraFields));
    const isCheckboxSelectionMode = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCheckboxSelectionMode));
    const status = (0, $c1MAf.useBacklogSelector)((state)=>card ? (0, $bAfUr.getColumnStatusByStatusId)(card.statusId)(state) : null);
    const fireCheckboxAnalytics = (0, $6U9Sv.useFireCheckboxAnalytics)();
    const { entryPointActions: entryPointActions } = (0, $acDhY.useBulkOpsEntryPoint)();
    const issueHierarchyLevel = card?.typeHierarchyLevel;
    const workType = card?.issueTypeName;
    const onClick = (0, $c1MAf.useBacklogActionCreator)((withCmd, withShift, source, // eslint-disable-next-line @typescript-eslint/no-inferrable-types
    viaCheckbox = false, externalAction)=>{
        (0, $7wqBZ.getLongTasksMetrics)('bento').start('backlog');
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'issue'
        }), 'backlogCard', {
            source: source,
            issueHierarchyLevel: issueHierarchyLevel
        });
        const fireSelectionAnalytics = (extraAttr)=>{
            if (viaCheckbox || withCmd || withShift && extraAttr.numSelectedCards > 1) fireCheckboxAnalytics?.(createAnalyticsEvent({
                action: 'changed',
                actionSubject: 'checkbox'
            }), 'backlogCard', {
                ...extraAttr,
                inputSource: (0, $fopK0.getCardSelectionAnalyticsInputSource)(withShift, withCmd, viaCheckbox),
                isCheckboxChecked: !isSelected,
                issueHierarchyLevel: issueHierarchyLevel,
                selectType: 'individual',
                issueId: id
            });
        };
        (withCmd || withShift) && entryPointActions.load();
        return (0, $4mqko.cardClick)(id, withCmd, withShift, viaCheckbox, fireSelectionAnalytics, externalAction);
    });
    const singleSelectCard = (0, $c1MAf.useBacklogActionCreator)(()=>(0, $4mqko.cardSingleSelect)(id));
    const onContextMenu = (0, $7D59a.useEvent)(()=>{
        const isCardOutsideOfSelectedCards = !selectedCards.includes(id);
        if (isCardOutsideOfSelectedCards) singleSelectCard();
    });
    const onFocus = (0, $c1MAf.useBacklogActionCreator)(()=>(0, $lReb9.cardFocus)(id));
    const onBlur = (0, $c1MAf.useBacklogActionCreator)((0, $lReb9.cardBlur));
    const onToggleCardGroup = (0, $c1MAf.useBacklogActionCreator)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'changed',
            actionSubject: 'expansionState'
        }), 'backlogCardGroup', {
            issueHierarchyLevel: issueHierarchyLevel
        });
        return (0, $a7yHf.cardGroupToggle)(id);
    });
    const isGroupExpanded = (0, $c1MAf.useBacklogSelector)((state)=>false ? (0, $dGljH.makeGetCardGroupExpanded)(state)(id) || !!(0, $dGljH.getOrderedCardIdsByCardListIdWithLimit)(state)[id].length : (0, $dGljH.makeGetCardGroupExpanded)(state)(id));
    const selectedCardsForFlagWithCommentModalOld = (0, $4R6GH.fg)('reduce_backlog_card_render_times') ? [] // eslint-disable-next-line react-hooks/rules-of-hooks
     : (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.cardsForFlagWithCommentModalFromCardIdsSelector)(state)([
            id
        ]));
    const cardTypes = (0, $c1MAf.useBacklogSelector)((0, $74oBv.getCardTypesForFilter));
    const onAddFlag = (0, $c1MAf.useBacklogActionCreator)((_)=>{
        const { key: key, summary: summary, typeId: typeId } = cards[id];
        const type = cardTypes.find((it)=>it.id === String(typeId)) ?? {
            id: String(typeId),
            name: '',
            iconUrl: ''
        };
        const selectedCardsForFlagWithCommentModal = [
            {
                id: id,
                key: key,
                summary: summary,
                type: type
            }
        ];
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'inlineCardField'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'addFlag');
        return (0, $5Eoed.openModal)({
            type: (0, $b107c54ec82f76f2$export$34f52cb2089ddc40),
            payload: {
                flagAction: (0, $a4GLz.ADD),
                cards: (0, $4R6GH.fg)('reduce_backlog_card_render_times') ? selectedCardsForFlagWithCommentModal : selectedCardsForFlagWithCommentModalOld
            }
        });
    });
    const hasFlaggedCards = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasFlaggedCards));
    const hasCardsWithPriority = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasPriority));
    const hasCardsWithDueDate = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasDueDate));
    const hasCardsWithStoryPoint = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasStoryPoints));
    const hasCardsWithEstimate = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasEstimates));
    const orderedVersions = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getOrderedVersions));
    if (!card) return null;
    const { key: cardKey, priority: priority, summary: summary, issueUrl: issueUrl, isDone: isDone, icon: icon, numCompleteChildren: numCompleteChildren, numTotalChildren: numTotalChildren, parentId: parentId, parentKey: parentKey, dueDate: dueDate, isFlagged: isFlagged, extraFields: extraFields, assignee: assignee, parent: parent } = card;
    /*
	 * as long as there is a single card having fix version, the orderedVersions is not empty
	 * checking the orderedVersions value against empty to determine if we should preserve the space for version
	 * even this card has no version
	 * the reason to do that is to to make sure the subtask text and subtask icons are aligned.
	 * https://hello.jira.atlassian.cloud/browse/FTFNS-54
	 * https://hello.jira.atlassian.cloud/browse/FTFNS-55
	 */ const shouldDisplayVersions = isCompanyManaged && !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(orderedVersions);
    const isSubtask = (0, $g4tDr.isSubtaskHierarchyLevel)(issueHierarchyLevel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            issueHierarchyLevel: issueHierarchyLevel
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bIoVa.default), {
        cardId: id,
        isSelected: isSelected,
        selectedCards: selectedCards,
        numSelectedCards: selectedCards.length,
        parents: parents,
        currentProjectId: currentProjectId,
        projectIds: projectIds,
        projectAris: projectAris,
        storyPointFieldId: storyPointFieldId,
        isUserAtLeastMember: isUserAtLeastMember,
        canUserEditIssue: canUserEditIssue,
        isDragging: isDragging,
        isDragHandle: isDragHandle,
        estimationType: estimationType,
        timeTrackingOptions: timeTrackingOptions,
        shouldRenderRichCard: shouldRenderRichCard,
        highlightText: highlightText,
        isFocused: isFocused,
        hasExtraFields: hasExtraFields,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onContextMenu: onContextMenu,
        isAttachedToParent: isAttachedToParent,
        isSubtask: isSubtask,
        subtaskIds: subtaskIds,
        isCardGroupExpanded: isGroupExpanded,
        onToggleCardGroup: onToggleCardGroup,
        cardKey: cardKey,
        dueDate: dueDate,
        icon: icon,
        isDone: isDone,
        isFlagged: isFlagged,
        issueUrl: issueUrl,
        numCompleteChildren: numCompleteChildren,
        numTotalChildren: numTotalChildren,
        parentId: parentId,
        parentKey: parentKey,
        parent: (0, $4R6GH.fg)('jsw-backlog-parent-field-render') ? parent : null,
        priority: priority,
        assignee: assignee,
        shouldDisplayVersions: shouldDisplayVersions,
        summary: summary,
        status: status,
        extraFields: extraFields,
        onAddFlag: onAddFlag,
        shouldRenderInlineAddFlag: hasFlaggedCards,
        shouldRenderPriorityColumn: hasCardsWithPriority,
        shouldRenderDueDateColumn: hasCardsWithDueDate,
        shouldRenderStoryPointColumn: hasCardsWithStoryPoint,
        shouldRenderEstimatesColumn: hasCardsWithEstimate,
        isCheckboxSelectionMode: isCheckboxSelectionMode,
        workType: workType
    }));
}
var $b51b02e8ed71c16e$export$2e2bcd8739ae039 = $b51b02e8ed71c16e$var$CardContentsContainer;

});
parcelRegister("a4GLz", function(module, exports) {

$parcel$export(module.exports, "ADD", () => $65b7e6dbe70f8139$export$bb6389024b71c2ae);
$parcel$export(module.exports, "REMOVE", () => $65b7e6dbe70f8139$export$29d55e1f664a246b);
$parcel$export(module.exports, "FLAG_REMOVED_PREFIX", () => $65b7e6dbe70f8139$export$43b00f69c32e9a5);
$parcel$export(module.exports, "FLAG_ADDED_PREFIX", () => $65b7e6dbe70f8139$export$625f394c78645dcd);
const $65b7e6dbe70f8139$export$bb6389024b71c2ae = 'ADD';
const $65b7e6dbe70f8139$export$29d55e1f664a246b = 'REMOVE';
const $65b7e6dbe70f8139$export$43b00f69c32e9a5 = {
    content: [
        {
            type: 'paragraph',
            content: [
                {
                    type: 'emoji',
                    attrs: {
                        shortName: ':flag_off:',
                        id: 'atlassian-flag_off',
                        text: ':flag_off:'
                    }
                },
                {
                    type: 'text',
                    text: ' Flag removed '
                }
            ]
        }
    ],
    type: 'doc',
    version: 1
};
const $65b7e6dbe70f8139$export$625f394c78645dcd = {
    content: [
        {
            type: 'paragraph',
            content: [
                {
                    type: 'emoji',
                    attrs: {
                        shortName: ':flag_on:',
                        id: 'atlassian-flag_on',
                        text: ':flag_on:'
                    }
                },
                {
                    type: 'text',
                    text: ' Flag added '
                }
            ]
        }
    ],
    type: 'doc',
    version: 1
};

});

parcelRegister("fopK0", function(module, exports) {

$parcel$export(module.exports, "getCardSelectionAnalyticsInputSource", () => $34e2155564843a3b$export$cddca765560eae90);

var $cizWc = parcelRequire("cizWc");
const $34e2155564843a3b$export$cddca765560eae90 = (withShift, withCmd, viaCheckbox)=>{
    if (withShift && withCmd) return 0, $cizWc.CMD_SHIFT_CLICK_ANALYTICS_ID;
    if (withShift) return 0, $cizWc.SHIFT_CLICK_ANALYTICS_ID;
    if (viaCheckbox) return 0, $cizWc.CHECKBOX_ANALYTICS_ID;
    return 0, $cizWc.CMD_CLICK_ANALYTICS_ID;
};

});

parcelRegister("bIoVa", function(module, exports) {

$parcel$export(module.exports, "default", () => $6036f9f2482e6fb8$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8Uumt = parcelRequire("8Uumt");

var $bpC55 = parcelRequire("bpC55");

var $iy9RA = parcelRequire("iy9RA");

var $16T6Y = parcelRequire("16T6Y");

var $iRvAI = parcelRequire("iRvAI");

var $6Ingq = parcelRequire("6Ingq");

var $ebd3R = parcelRequire("ebd3R");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");

var $3bDjY = parcelRequire("3bDjY");

var $42CjB = parcelRequire("42CjB");

var $91LZJ = parcelRequire("91LZJ");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $g4tDr = parcelRequire("g4tDr");

var $hrjFc = parcelRequire("hrjFc");


var $lu5k0 = parcelRequire("lu5k0");

var $iDGXn = parcelRequire("iDGXn");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $cSD7y = parcelRequire("cSD7y");

var $f6RVN = parcelRequire("f6RVN");

var $guzeq = parcelRequire("guzeq");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");

var $fSgHa = parcelRequire("fSgHa");

var $3VzmQ = parcelRequire("3VzmQ");

var $khnfQ = parcelRequire("khnfQ");

var $3JQPC = parcelRequire("3JQPC");


var $d9htP = parcelRequire("d9htP");

var $7q84v = parcelRequire("7q84v");

var $kM28N = parcelRequire("kM28N");

var $5OkdV = parcelRequire("5OkdV");

var $iJZfp = parcelRequire("iJZfp");

var $lM9Tp = parcelRequire("lM9Tp");

var $ekU0X = parcelRequire("ekU0X");

var $cizWc = parcelRequire("cizWc");

var $13fTq = parcelRequire("13fTq");

var $g1Kbb = parcelRequire("g1Kbb");

var $hCPhj = parcelRequire("hCPhj");

var $2JHi9 = parcelRequire("2JHi9");

var $9U5Ic = parcelRequire("9U5Ic");

var $5U2yP = parcelRequire("5U2yP");

var $fuplg = parcelRequire("fuplg");

var $bTzpK = parcelRequire("bTzpK");

var $4EUws = parcelRequire("4EUws");

var $lNMv0 = parcelRequire("lNMv0");

var $9MiEY = parcelRequire("9MiEY");

var $1D3VD = parcelRequire("1D3VD");

var $1e5mE = parcelRequire("1e5mE");

var $xEBl6 = parcelRequire("xEBl6");
const $6036f9f2482e6fb8$var$CardContents = ({ cardId: cardId, cardKey: cardKey, onClick: onClick, onFocus: onFocus, onBlur: onBlur, onContextMenu: onContextMenu, highlightText: highlightText, summary: summary, status: status, parents: parents, parentId: parentId, parent: parent, priority: priority, assignee: assignee, currentProjectId: currentProjectId, projectIds: projectIds, projectAris: projectAris, issueUrl: issueUrl, icon: icon, dueDate: dueDate, estimationType: estimationType, storyPointFieldId: storyPointFieldId, timeTrackingOptions: timeTrackingOptions, extraFields: extraFields, hasExtraFields: hasExtraFields, canUserEditIssue: canUserEditIssue, isUserAtLeastMember: isUserAtLeastMember, isDone: isDone, isFocused: isFocused, isFlagged: isFlagged = false, isSelected: isSelected = false, isDragging: isDragging = false, isDragHandle: isDragHandle = false, shouldRenderRichCard: shouldRenderRichCard = true, selectedCards: selectedCards, numCompleteChildren: numCompleteChildren, numTotalChildren: numTotalChildren, shouldDisplayVersions: shouldDisplayVersions, isAttachedToParent: isAttachedToParent = false, isSubtask: isSubtask = false, subtaskIds: subtaskIds, parentKey: parentKey, isCardGroupExpanded: isCardGroupExpanded = false, onToggleCardGroup: onToggleCardGroupProp = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onAddFlag: onAddFlag, shouldRenderInlineAddFlag: shouldRenderInlineAddFlag, shouldRenderPriorityColumn: shouldRenderPriorityColumn, shouldRenderDueDateColumn: shouldRenderDueDateColumn, shouldRenderStoryPointColumn: shouldRenderStoryPointColumn, shouldRenderEstimatesColumn: shouldRenderEstimatesColumn, isCheckboxSelectionMode: isCheckboxSelectionMode, workType: workType })=>{
    const { size: backlogContainerSize } = (0, $3JQPC.useContainerSize)();
    const isCompactView = backlogContainerSize === (0, $khnfQ.ScreenSize).EXTRA_SMALL;
    const [isActionMenuOpen, setIsActionMenuOpen] = (0, $5uXOq.useState)(false); // TODO move to <SummaryAndParents /> during NON UIF clean up
    const [isSummaryFieldEditing, setIsSummaryFieldEditing] = (0, $5uXOq.useState)(false);
    const [isActionMenuTriggerVisible] = (0, $5uXOq.useState)(true);
    const cardHierarchyLevel = (0, $c1MAf.useBacklogSelector)((0, $dGljH.makeGetCardHierarchyLevel));
    const isEpic = (0, $g4tDr.isEpicHierarchyLevel)(cardHierarchyLevel(cardId));
    const isCompanyManaged = (0, $fSgHa.useIsCMPBacklog)();
    const isCompanyManagedKanban = (0, $fSgHa.useIsCMPKanbanBacklog)();
    const showEpics = (0, $iDGXn.useShowEpics)();
    const showCompactMode = (0, $iDGXn.useShowCompactMode)();
    const isCompactModeEnabled = showCompactMode;
    const returnFocusTo = (0, $lu5k0.useReturnFocusTo)();
    const { setReturnFocusTo: setReturnFocusTo } = (0, $lu5k0.useModalDialogActions)();
    const menuTriggerRef = (0, $5uXOq.useRef)(null);
    const isBulkOpsInProgress = (0, $91LZJ.useIsBulkOperationsInProgress)();
    const shouldShowCheckbox = (0, $3VzmQ.useShowCheckbox)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const viewSettings = (0, $f6RVN.isViewSettingAsPanelExpEnabledWithNoExposure)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $iDGXn.useCardFieldsSettings)() : {
        showIssueType: true,
        showIssueKey: true,
        showPriority: true,
        showAssignee: true,
        showEstimate: true,
        showDueDate: true,
        cardExtraFields: undefined
    };
    const handleClick = (0, $5uXOq.useCallback)((e)=>{
        e.stopPropagation();
        if (e.defaultPrevented) return;
        const withCmd = e.ctrlKey || e.metaKey;
        const withShift = e.shiftKey;
        onClick(withCmd, withShift, 'mouse');
    }, [
        onClick
    ]);
    const onClickThrough = (0, $5uXOq.useCallback)((e)=>{
        const withCmd = e.ctrlKey || e.metaKey;
        const withShift = e.shiftKey;
        if (withCmd || withShift) onFocus();
        handleClick(e);
    }, [
        onFocus,
        handleClick
    ]);
    const onKeyDown = (0, $5uXOq.useCallback)((e)=>{
        const withCmd = e.ctrlKey || e.metaKey;
        const withShift = e.shiftKey;
        if (e.key !== 'Enter' || isDragging) return;
        onClick(withCmd, withShift, 'keyboard');
    }, [
        isDragging,
        onClick
    ]); // TODO move to <SummaryAndParents /> on non UIF clean up
    const onSummaryEditStateChange = (0, $5uXOq.useCallback)((isEditing)=>{
        setIsSummaryFieldEditing(isEditing);
    }, []);
    const onRightClickOutside = (0, $5uXOq.useCallback)((_e)=>{
        setIsActionMenuOpen(false);
    }, []);
    const [versionMenuQueryRef, loadVersionMenuQuery] = (0, $8Uumt.useQueryLoader)((0, $hrjFc.default));
    (0, $5uXOq.useEffect)(()=>{
        if (!versionMenuQueryRef && loadVersionMenuQuery != null && shouldRenderRichCard) loadVersionMenuQuery({
            jiraProjectIds: projectAris,
            first: 500,
            after: null
        });
    }, [
        versionMenuQueryRef,
        loadVersionMenuQuery,
        shouldRenderRichCard,
        projectAris
    ]);
    const renderCardColor = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ekU0X.CardColor), {
            id: cardId
        });
    const handleMenuOpenChange = (0, $5uXOq.useCallback)((isOpen)=>{
        if (isOpen && menuTriggerRef?.current) setReturnFocusTo(menuTriggerRef);
        setIsActionMenuOpen(isOpen);
    }, [
        setReturnFocusTo
    ]);
    const getMenuComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9htP.ContextMenu), {
            appearance: (0, $d9cdb1c71f9dbf8c$export$ee5015c6ad52cf0b),
            onOpenChange: handleMenuOpenChange,
            issueId: cardId,
            issueKey: cardKey,
            summary: summary,
            selectedCardIds: selectedCards,
            versionMenuQueryRef: versionMenuQueryRef,
            triggerRef: menuTriggerRef
        });
    const renderMenu = ()=>{
        const shouldRenderMenu = (isActionMenuOpen || shouldRenderRichCard) && isActionMenuTriggerVisible;
        const triggerIsFocused = returnFocusTo?.current && menuTriggerRef.current && returnFocusTo?.current === menuTriggerRef.current;
        const isMenuOpen = isActionMenuOpen || Boolean(triggerIsFocused);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6036f9f2482e6fb8$var$MenuPlaceholder, {
            isMenuOpen: isMenuOpen,
            "data-test-id": "software-backlog.card-list.card.card-contents.context-menu",
            "data-testid": "software-backlog.card-list.card.card-contents.context-menu",
            "data-component-selector": (0, $f836df2846e6254b$export$ca45cc072d50480d)
        }, shouldRenderMenu ? getMenuComponent() : null);
    };
    const renderInteractionLayer = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9U5Ic.default), {
            isFocused: isFocused,
            cardKey: cardKey,
            summary: summary,
            onFocus: onFocus,
            onBlur: onBlur,
            onClick: handleClick,
            onKeyDown: onKeyDown
        });
    const renderOriginalEstimateField = ()=>{
        const estimateField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fuplg.default), {
            issueId: cardId,
            issueKey: cardKey,
            estimationType: estimationType,
            timeTrackingOptions: timeTrackingOptions,
            isUserAtLeastMember: isUserAtLeastMember,
            shouldRenderRichCard: shouldRenderRichCard,
            shouldRenderEstimatesColumn: shouldRenderEstimatesColumn
        });
        return estimationType === (0, $guzeq.ORIGINAL_ESTIMATE) ? estimateField : null;
    };
    const renderStoryPointField = ()=>{
        const estimateField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9MiEY.default), {
            issueId: cardId,
            issueKey: cardKey,
            storyPointFieldId: storyPointFieldId,
            estimationType: estimationType,
            isUserAtLeastMember: isUserAtLeastMember,
            shouldRenderRichCard: shouldRenderRichCard,
            shouldRenderStoryPointColumn: shouldRenderStoryPointColumn
        });
        return storyPointFieldId || estimationType === (0, $guzeq.STORY_POINTS) ? estimateField : null;
    };
    const renderAssigneeField = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.AssigneeContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5OkdV.default), {
            isUserAtLeastMember: isUserAtLeastMember,
            shouldRenderRichCard: shouldRenderRichCard,
            issueKey: cardKey,
            issueId: (0, $4R6GH.fg)('one_event_iteration_3') ? cardId.toString() : undefined,
            assignee: assignee
        }));
    const assigneeField = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.AssigneeContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5OkdV.default), {
            isUserAtLeastMember: isUserAtLeastMember,
            shouldRenderRichCard: shouldRenderRichCard,
            issueKey: cardKey,
            issueId: (0, $4R6GH.fg)('one_event_iteration_3') ? cardId.toString() : undefined,
            assignee: assignee
        })), [
        assignee,
        cardId,
        cardKey,
        isUserAtLeastMember,
        shouldRenderRichCard
    ]);
    const assigneeFieldGated = (0, $4R6GH.fg)('backlog_reduce_workload_card_avatar_rerenders_') ? assigneeField : renderAssigneeField();
    const parentKeyText = parentKey !== undefined ? formatMessage((0, $7q84v.default).parentKeyText, {
        parentKey: parentKey
    }) : '';
    const renderParentKey = ()=>parentKey !== undefined && isSubtask && !isAttachedToParent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: parentKeyText,
            position: "mouse"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.CardGroupKey), null, `${parentKeyText}`)) : null;
    const hasLinkedSubtasks = subtaskIds !== undefined && subtaskIds.length > 0;
    const numberOfLinkedSubtasks = hasLinkedSubtasks ? formatMessage((0, $7q84v.default).numberOfChildrenText, {
        numberOfChildren: subtaskIds.length
    }) : '';
    const shouldShowChevron = hasLinkedSubtasks && !isDragHandle;
    const onToggleCardGroup = (event)=>{
        event.preventDefault();
        onToggleCardGroupProp();
    };
    const isExpanded = isCardGroupExpanded;
    const getChevronIcon = ()=>{
        if (isExpanded) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iy9RA))), {
            label: "",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($6Ingq))),
            color: "var(--ds-icon, #44546F)",
            size: "small"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bpC55))), {
            label: "",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($ebd3R))),
            color: "var(--ds-icon, #44546F)",
            size: "small"
        });
    };
    const getAriaLabel = ()=>{
        if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return formatMessage(isExpanded ? (0, $7q84v.default).cardGroupToggleExpandedAriaLabel : (0, $7q84v.default).cardGroupToggleCollapsedAriaLabel, {
            issueKey: cardKey,
            summary: summary
        });
        return formatMessage(isExpanded ? (0, $7q84v.default).cardGroupToggleExpandedAriaLabel : (0, $7q84v.default).cardGroupToggleCollapsedAriaLabel, {
            issueKey: cardKey,
            summary: summary
        });
    };
    const renderCardGroupToggle = ()=>{
        if (!shouldShowChevron) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage(isExpanded ? (0, $7q84v.default).cardGroupToggleTooltipCollapse : (0, $7q84v.default).cardGroupToggleTooltipExpand)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            justifyContent: "center",
            xcss: $6036f9f2482e6fb8$var$iconWrapperStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            isTooltipDisabled: true,
            appearance: "subtle",
            onClick: onToggleCardGroup,
            spacing: "compact",
            icon: getChevronIcon,
            label: getAriaLabel(),
            testId: "software-backlog.card-list.card.card-contents.subtask"
        })));
    };
    const getCheckboxContainerMargin = (shouldAddMargin)=>{
        if (shouldAddMargin && isAttachedToParent) return 'space.500';
        if (shouldAddMargin) return 'space.300';
        return 'space.0';
    };
    const renderCheckbox = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        ), {
            xcss: (0, $8CUq3.xcss)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                marginRight: getCheckboxContainerMargin(isCompanyManaged && !shouldShowChevron)
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.CheckboxContainer), {
            "data-component-selector": (0, $cizWc.CHECKBOX_COMPONENT_SELECTOR),
            "data-testid": (0, $cizWc.CHECKBOX_TESTID),
            shouldShowCheckbox: shouldShowCheckbox
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iJZfp.default), {
            isSelected: isSelected,
            onClick: onClick,
            isDisabled: isBulkOpsInProgress,
            shouldShowCheckbox: shouldShowCheckbox,
            label: formatMessage((0, $7q84v.default).cardCheckboxLabel, {
                cardKey: cardKey,
                summary: summary
            }),
            isCheckboxSelectionMode: isCheckboxSelectionMode
        })));
    const showCardExtraFieldsColumnBasedOnViewSettings = (0, $f6RVN.isViewSettingAsPanelExpEnabledWithNoExposure)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $iDGXn.useHasCardExtraFields)() : true;
    const renderExtraFields = ()=>hasExtraFields && extraFields && showCardExtraFieldsColumnBasedOnViewSettings && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.ExtraFieldsContainer), {
            isSmartCardEnabled: (0, $6s1PB.expValEquals)('jsw_perf_format-links-in-custom-fields', 'board-and-backlog', true),
            isAttachedToParent: isAttachedToParent && isCompanyManaged,
            hideTypeIcon: !viewSettings.showIssueType
        }, extraFields.filter((field)=>viewSettings.cardExtraFields?.[field.id] === undefined ? true : viewSettings.cardExtraFields[field.id]).map((field, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
                key: field.id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g1Kbb.CardExtraField), {
                field: field
            }), index < extraFields?.length - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCPhj.FieldSeparator), {
                "aria-hidden": "true",
                key: `${field.id}-separator`
            }, "\u2022"))));
    const renderCmpChildIssuesMetadata = ()=>hasLinkedSubtasks ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.SubtaskIconWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: numberOfLinkedSubtasks,
            position: "mouse"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRvAI))), {
            color: "var(--ds-icon-subtle, #626F86)",
            LEGACY_primaryColor: "var(--ds-icon-subtle, #626F86)",
            LEGACY_size: "small",
            label: "subtaskIcon"
        }))) : null;
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('contextmenu', onRightClickOutside);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('contextmenu', onRightClickOutside);
        };
    }, [
        onRightClickOutside
    ]);
    const getDraggingCardIds = (0, $c1MAf.useBacklogSelector)((0, $dGljH.makeGetDraggingCardIds));
    const isVisualRefreshBeta = (0, $dCm1o.isVisualRefreshEnabled)();
    const isOptimistic = cardId < 0;
    if (isOptimistic) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.CardContainer), {
        lowerOpacity: false,
        isSelected: isSelected,
        isFlagged: isFlagged,
        isDraggable: canUserEditIssue,
        isDragHandle: isDragHandle,
        hasExtraFields: hasExtraFields,
        isCompact: isCompactModeEnabled,
        "data-component-selector": (0, $f836df2846e6254b$export$fb374ae0d58ab29b),
        isVisualRefreshBeta: isVisualRefreshBeta
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1e5mE.TypeIcon), {
        icon: icon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1D3VD.SummaryAndParents), {
        cardId: cardId,
        cardKey: cardKey,
        summary: summary,
        highlightText: highlightText,
        isUserAtLeastMember: isUserAtLeastMember,
        shouldRenderRichCard: shouldRenderRichCard,
        isSummaryFieldEditing: isSummaryFieldEditing,
        onClickThrough: onClickThrough,
        onSummaryEditStateChange: onSummaryEditStateChange
    }), !isDragHandle && renderExtraFields(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.StyledSpinner), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "small"
    })));
    const numSelected = getDraggingCardIds(cardId).length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9htP.ContextMenu), {
        appearance: (0, $d9cdb1c71f9dbf8c$export$bb79bd28759ee895),
        issueId: cardId,
        issueKey: cardKey,
        selectedCardIds: selectedCards,
        versionMenuQueryRef: versionMenuQueryRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.CardContainer), {
        "data-testid": (0, $cizWc.CARD_CONTAINER_TESTID),
        shouldShowChevron: shouldShowChevron,
        isCompanyManagedKanban: isCompanyManagedKanban,
        isCompact: isCompactModeEnabled,
        isAttachedToParent: isAttachedToParent,
        isSelected: !isDragHandle && isSelected,
        isFlagged: isFlagged,
        lowerOpacity: isDragging && !isDragHandle,
        isDragHandle: isDragHandle,
        isDraggable: canUserEditIssue,
        hasExtraFields: !isDragHandle && hasExtraFields && showCardExtraFieldsColumnBasedOnViewSettings,
        onContextMenu: onContextMenu,
        hideTypeIcon: !viewSettings.showIssueType,
        isAssigneeShown: viewSettings.showAssignee,
        "data-component-selector": (0, $f836df2846e6254b$export$fb374ae0d58ab29b),
        isVisualRefreshBeta: isVisualRefreshBeta
    }, !isDragHandle ? renderInteractionLayer() : null, !isDragHandle ? renderCheckbox() : null, renderCardColor(), renderCardGroupToggle(), viewSettings.showIssueType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1e5mE.TypeIcon), {
        icon: icon
    }), viewSettings.showIssueKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5U2yP.Key), {
        isDone: isDone,
        cardKey: cardKey,
        issueUrl: issueUrl,
        summary: summary,
        highlightText: highlightText,
        onClick: onClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1D3VD.SummaryAndParents), {
        cardId: cardId,
        cardKey: cardKey,
        summary: summary,
        highlightText: highlightText,
        isUserAtLeastMember: isUserAtLeastMember,
        shouldRenderRichCard: shouldRenderRichCard,
        isSummaryFieldEditing: isSummaryFieldEditing,
        onClickThrough: onClickThrough,
        onSummaryEditStateChange: onSummaryEditStateChange
    }), renderParentKey(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.OptionalFieldsContainer), null, !isDragHandle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lM9Tp.ChildIssuesMetadata), {
        numTotalChildren: numTotalChildren,
        numCompleteChildren: numCompleteChildren,
        onClickThrough: onClickThrough
    }), renderCmpChildIssuesMetadata(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $xEBl6.VersionsWrapper), {
        shouldDisplayVersions: shouldDisplayVersions,
        backlogContainerSize: backlogContainerSize,
        cardId: cardId
    }), showEpics && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bTzpK.Parent), {
        cardId: cardId,
        cardKey: cardKey,
        isUserAtLeastMember: isUserAtLeastMember,
        parents: parents,
        parentId: parentId,
        parent: parent,
        currentProjectId: currentProjectId,
        projectIds: projectIds,
        canUserEditIssue: canUserEditIssue,
        shouldRenderRichCard: shouldRenderRichCard,
        backlogContainerSize: backlogContainerSize,
        isCompactView: isCompactView,
        isSubtask: isSubtask,
        isEpic: isEpic,
        isCompanyManaged: isCompanyManaged,
        workType: workType
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lNMv0.StatusFieldWrapper), {
        isUserAtLeastMember: isUserAtLeastMember,
        shouldRenderRichCard: shouldRenderRichCard,
        cardKey: cardKey,
        cardId: cardId,
        status: status
    })), !isDragHandle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, viewSettings.showDueDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $13fTq.DueDate), {
        dueDate: dueDate,
        shouldRenderDueDateColumn: shouldRenderDueDateColumn,
        isDone: isDone
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2JHi9.Flag), {
        isFlagged: isFlagged,
        shouldRenderInlineAddFlag: shouldRenderInlineAddFlag,
        onAddFlag: onAddFlag
    }), viewSettings.showEstimate && renderOriginalEstimateField(), viewSettings.showEstimate && renderStoryPointField(), viewSettings.showPriority && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4EUws.default), {
        key: `priority-${cardKey}`,
        isUserAtLeastMember: isUserAtLeastMember,
        issueKey: cardKey,
        shouldRenderRichCard: shouldRenderRichCard,
        shouldRenderColumn: shouldRenderPriorityColumn,
        name: priority?.name,
        iconUrl: priority?.iconUrl
    }))), !isDragHandle && viewSettings.showAssignee && assigneeFieldGated, !isDragHandle && renderMenu()), !isDragHandle && renderExtraFields())), isDragHandle && numSelected > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.DragHandleCardsAmount), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16T6Y.default), {
        appearance: "primary",
        testId: (0, $cizWc.CARDS_AMOUNT_BADGE_TESTID)
    }, numSelected)));
};
var $6036f9f2482e6fb8$export$2e2bcd8739ae039 = (0, $cSD7y.componentWithFG)('jfp-magma-concurrent-backlog-reduce-rerenders', /*#__PURE__*/ (0, $5uXOq.memo)($6036f9f2482e6fb8$var$CardContents), $6036f9f2482e6fb8$var$CardContents);
const $6036f9f2482e6fb8$var$iconWrapperStyle = (0, $8CUq3.xcss)({
    gridColumn: 'chevron / span 1',
    gridRow: 'card-detail / span 1',
    minWidth: '24px'
});
const $6036f9f2482e6fb8$var$MenuPlaceholder = (0, $cSD7y.componentWithFG)('tanuki_a11y_q4', ({ children: children, isMenuOpen: isMenuOpen, 'data-testid': testId, 'data-component-selector': componentSelector })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": testId,
        "data-component-selector": componentSelector,
        className: (0, $bwpsq.default)([
            $6036f9f2482e6fb8$var$menuPlaceholderStyles.root,
            isMenuOpen ? $6036f9f2482e6fb8$var$menuPlaceholderStyles.visible : $6036f9f2482e6fb8$var$menuPlaceholderStyles.hidden
        ])
    }, children);
}, (0, $kM28N.MenuPlaceholderOld));
const $6036f9f2482e6fb8$var$menuPlaceholderStyles = {
    root: "_yyhy1m0k _1ii7wtyw _1ul9zwfg _kqswh2mm",
    visible: "_tzy4kb7n",
    hidden: "_tzy4idpf"
};

});
parcelRegister("iRvAI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cb1eed99abd44e812ae4cb98f136c93f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dbb5ae8ec700c853$var$_react = $dbb5ae8ec700c853$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $dbb5ae8ec700c853$var$_baseNew = $dbb5ae8ec700c853$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $dbb5ae8ec700c853$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Subtasks".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for subtask work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dbb5ae8ec700c853$var$SubtasksIcon = (props)=>/*#__PURE__*/ $dbb5ae8ec700c853$var$_react.default.createElement($dbb5ae8ec700c853$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 9.25a.5.5 0 0 0-.5-.5H8.75V13a.5.5 0 0 0 .5.5H13a.5.5 0 0 0 .5-.5zM7.25 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v3.75a.5.5 0 0 0 .5.5h4.25zm1.5 4.25H13a2 2 0 0 1 2 2V13a2 2 0 0 1-2 2H9.25a2 2 0 0 1-2-2V8.75H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3.75a2 2 0 0 1 2 2z"/>`
    }, props));
$dbb5ae8ec700c853$var$SubtasksIcon.displayName = 'SubtasksIcon';
var $dbb5ae8ec700c853$var$_default = module.exports.default = $dbb5ae8ec700c853$var$SubtasksIcon;

});

parcelRegister("hrjFc", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa4efd6a31187219$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d89330a12e304d1decdadfb7c7a699ca>>
 * @relayHash 93c0d8d16c4e77e0b03ed1162c0f98a5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8de8818cd89ed97037d20d3a42434b738449fd91fe983e253e41993b4d843c3c
const $fa4efd6a31187219$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraProjectIds"
    }, v3 = {
        "kind": "Literal",
        "name": "filter",
        "value": [
            "RELEASED",
            "UNRELEASED"
        ]
    }, v4 = {
        "kind": "Variable",
        "name": "jiraProjectIds",
        "variableName": "jiraProjectIds"
    }, v5 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v8 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        v3 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v4 /*: any*/ 
    ], v9 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "versionMenuQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "versionsForProjects",
                                    "args": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ],
                                    "concreteType": "JiraVersionConnection",
                                    "kind": "LinkedField",
                                    "name": "__versionBacklogPanelRelay_versionsForProjects_connection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraVersionEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "versionMenu_softwareBacklog_VersionMenuContent"
                                                    },
                                                    v5 /*: any*/ ,
                                                    {
                                                        "concreteType": "JiraVersion",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v6 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.versionsForProjects.edges"
                                        },
                                        v7 /*: any*/ 
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.versionsForProjects"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "versionMenuQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "concreteType": "JiraVersionConnection",
                            "kind": "LinkedField",
                            "name": "versionsForProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraVersionEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraVersion",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "versionId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "status"
                                                },
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "project",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectId"
                                                        },
                                                        v9 /*: any*/ 
                                                    ]
                                                },
                                                v9 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        },
                                        v5 /*: any*/ 
                                    ]
                                },
                                v7 /*: any*/ 
                            ]
                        },
                        {
                            "args": v8 /*: any*/ ,
                            "filters": [
                                "jiraProjectIds",
                                "filter"
                            ],
                            "handle": "connection",
                            "key": "versionBacklogPanelRelay_versionsForProjects",
                            "kind": "LinkedHandle",
                            "name": "versionsForProjects"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8de8818cd89ed97037d20d3a42434b738449fd91fe983e253e41993b4d843c3c",
            "metadata": {
                "connection": [
                    {
                        "count": "first",
                        "cursor": "after",
                        "direction": "forward",
                        "path": [
                            "jira",
                            "versionsForProjects"
                        ]
                    }
                ]
            },
            "name": "versionMenuQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$fa4efd6a31187219$var$node.hash = "ad42f90f36561f245c5fce9acfe51923";
var $fa4efd6a31187219$export$2e2bcd8739ae039 = $fa4efd6a31187219$var$node;

});

parcelRegister("d9htP", function(module, exports) {

$parcel$export(module.exports, "ContextMenu", () => $31c28be4e7773897$export$8dc6765e8be191c7);

var $5uXOq = parcelRequire("5uXOq");


var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $4tD4f = parcelRequire("4tD4f");


var $jUyjb = parcelRequire("jUyjb");

var $iDGXn = parcelRequire("iDGXn");

var $dqoiX = parcelRequire("dqoiX");

var $fSgHa = parcelRequire("fSgHa");

var $1UfRw = parcelRequire("1UfRw");

var $9nlJl = parcelRequire("9nlJl");

var $iaKyE = parcelRequire("iaKyE");

var $7bfQN = parcelRequire("7bfQN");

var $9UPwF = parcelRequire("9UPwF");

var $18PeT = parcelRequire("18PeT");

var $hksaN = parcelRequire("hksaN");

var $7MVky = parcelRequire("7MVky");

var $iTQ6G = parcelRequire("iTQ6G");

var $1otSd = parcelRequire("1otSd");

var $bEQvq = parcelRequire("bEQvq");

var $4AddN = parcelRequire("4AddN");

var $5lrV3 = parcelRequire("5lrV3");

var $02921 = parcelRequire("02921");

var $7sDhu = parcelRequire("7sDhu");

var $ekjae = parcelRequire("ekjae");

var $ct9uH = parcelRequire("ct9uH");

var $9ZFOK = parcelRequire("9ZFOK");

var $chkmj = parcelRequire("chkmj");

var $5Mhvq = parcelRequire("5Mhvq");

var $jN95k = parcelRequire("jN95k");
const $31c28be4e7773897$export$88a94aa401c6dbd6 = ({ selectedCardIds: selectedCardIds, versionMenuQueryRef: versionMenuQueryRef })=>{
    const priority = (0, $7sDhu.usePriority)({
        selectedCardIds: selectedCardIds
    });
    const assignee = (0, $iaKyE.useAssignee)({
        selectedCardIds: selectedCardIds
    });
    const estimate = (0, $iTQ6G.useEstimate)({
        selectedCardIds: selectedCardIds
    });
    const parent = (0, $02921.useParent)(selectedCardIds);
    const version = (0, $9ZFOK.useVersion)({
        selectedCardIds: selectedCardIds,
        versionMenuQueryRef: versionMenuQueryRef
    });
    const isCompanyManaged = (0, $fSgHa.useIsCMPBacklog)();
    const isWithinIssueLimit = selectedCardIds.length <= (0, $e6c5355277661284$export$d05ca0d31d3ffa06);
    return isWithinIssueLimit ? [
        ...assignee,
        ...priority,
        ...version,
        ...parent,
        ...!isCompanyManaged ? estimate : []
    ] : [];
};
const $31c28be4e7773897$export$c087a1fcddb96d21 = ({ issueId: issueId, issueKey: issueKey, selectedCardIds: selectedCardIds, versionMenuQueryRef: versionMenuQueryRef, onScreenReaderAnnounce: onScreenReaderAnnounce })=>{
    const cardIds = (0, $5uXOq.useMemo)(()=>selectedCardIds.includes(issueId) ? selectedCardIds : [
            issueId
        ], [
        issueId,
        selectedCardIds
    ]);
    const isMultiSelect = cardIds?.length > 1;
    const subtasksWithoutParentsAreSelected = (0, $jN95k.default)(cardIds);
    const header = (0, $4AddN.useHeader)({
        selectedCardIds: cardIds
    });
    const moveToActions = (0, $5lrV3.useMoveTo)({
        issueId: issueId,
        cardIds: cardIds,
        hide: subtasksWithoutParentsAreSelected,
        onScreenReaderAnnounce: onScreenReaderAnnounce
    });
    const flag = (0, $1otSd.useFlag)({
        cardIds: cardIds
    });
    const splitIssue = (0, $ct9uH.useSplitIssue)({
        issueId: issueId,
        isMultiSelect: isMultiSelect
    });
    const cloneIssue = (0, $9UPwF.useCloneIssue)({
        issueKey: issueKey,
        issueId: issueId,
        isMultiSelect: isMultiSelect
    });
    const deleteIssue = (0, $7MVky.useDeleteIssue)({
        issueId: issueId,
        selectedCardIds: cardIds
    });
    const copyIssueLink = (0, $hksaN.useCopyIssueLink)({
        selectedCardIds: cardIds,
        issueKey: issueKey
    });
    const copyIssueKey = (0, $18PeT.useCopyIssueKey)({
        selectedCardIds: cardIds,
        issueKey: issueKey
    });
    const viewInIssueSearch = (0, $chkmj.useViewInIssueSearch)({
        selectedCardIds: cardIds
    });
    const gotoBulkEditor = (0, $bEQvq.useGoToBulkEditor)({
        selectedCardIds: cardIds
    });
    const fieldBulkOperations = $31c28be4e7773897$export$88a94aa401c6dbd6({
        selectedCardIds: cardIds,
        versionMenuQueryRef: versionMenuQueryRef
    });
    const moveTo = moveToActions.length ? [
        ...moveToActions,
        (0, $ekjae.createSeparator)('move-to-actions')
    ] : [];
    const bulkActions = [
        ...flag,
        ...fieldBulkOperations,
        ...splitIssue
    ];
    const issueActions = [
        ...copyIssueLink,
        ...copyIssueKey,
        ...viewInIssueSearch
    ];
    const useAgentAction = (0, $7bfQN.useUseAgent)(cardIds);
    const deleteAndBulkEditorActions = gotoBulkEditor.length || deleteIssue.length ? [
        (0, $ekjae.createSeparator)('delete-and-bulk-editor-actions'),
        ...gotoBulkEditor,
        ...deleteIssue
    ] : [];
    const otherActions = gotoBulkEditor.length || deleteIssue.length || cloneIssue.length ? [
        (0, $ekjae.createSeparator)('other-actions'),
        ...gotoBulkEditor,
        ...cloneIssue,
        ...deleteIssue
    ] : [];
    return [
        ...header,
        ...moveTo,
        ...issueActions,
        ...useAgentAction,
        ...bulkActions.length ? [
            (0, $ekjae.createSeparator)('bulk-actions'),
            ...bulkActions
        ] : [],
        ...(0, $6s1PB.expVal)('cloning_tasks_entrypoints', 'isEnabled', false) ? otherActions : deleteAndBulkEditorActions
    ];
};
const $31c28be4e7773897$var$MenuRendererWithMenuItems = /*#__PURE__*/ (0, $5uXOq.memo)(({ issueId: issueId, issueKey: issueKey, selectedCardIds: selectedCardIds, scope: scope, triggerRef: triggerRef, versionMenuQueryRef: versionMenuQueryRef, onScreenReaderAnnounce: onScreenReaderAnnounce })=>{
    const menuItems = $31c28be4e7773897$export$c087a1fcddb96d21({
        issueId: issueId,
        issueKey: issueKey,
        selectedCardIds: selectedCardIds,
        versionMenuQueryRef: versionMenuQueryRef,
        onScreenReaderAnnounce: onScreenReaderAnnounce
    });
    return(// Prevents drag events being propogated to the parent card
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1UfRw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4tD4f.AsyncMenuRenderer), {
        scope: scope,
        menuItems: menuItems,
        triggerRef: triggerRef
    })));
});
const $31c28be4e7773897$export$8dc6765e8be191c7 = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>{
    const { issueId: issueId, issueKey: issueKey, selectedCardIds: selectedCardIds, appearance: appearance, versionMenuQueryRef: versionMenuQueryRef } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const showCompactMode = (0, $iDGXn.useShowCompactMode)();
    const triggerRef = 'triggerRef' in props ? props.triggerRef : null;
    const [screenReaderText, setScreenReaderText] = (0, $5uXOq.useState)('');
    const onScreenReaderAnnounce = (0, $5uXOq.useCallback)((message)=>{
        setScreenReaderText('');
        setTimeout(()=>setScreenReaderText(message), 50);
    }, []);
    const renderMenu = (0, $5uXOq.useCallback)((scope, menuTriggerRef)=>{
        if (triggerRef && menuTriggerRef?.current) triggerRef.current = menuTriggerRef.current;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($31c28be4e7773897$var$MenuRendererWithMenuItems, {
            issueId: issueId,
            issueKey: issueKey,
            selectedCardIds: selectedCardIds,
            versionMenuQueryRef: versionMenuQueryRef,
            scope: scope,
            triggerRef: menuTriggerRef,
            onScreenReaderAnnounce: onScreenReaderAnnounce
        });
    }, [
        triggerRef,
        issueId,
        issueKey,
        selectedCardIds,
        versionMenuQueryRef,
        onScreenReaderAnnounce
    ]);
    const handleEscape = (e)=>{
        // this is to prevent the escape key from closing the issue view
        if (e.key === 'Escape') {
            e.stopPropagation();
            e.nativeEvent.stopImmediatePropagation();
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            if (document.activeElement instanceof HTMLElement) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.activeElement.blur();
        }
    };
    const renderScreenReaderText = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), {
            key: `${screenReaderText}-${issueId}`,
            "aria-live": "polite",
            role: "alert"
        }, screenReaderText);
    if (appearance === (0, $d9cdb1c71f9dbf8c$export$bb79bd28759ee895)) {
        const { children: children } = props;
        return(// disabling the eslint rule since it asks us to turn this into a button which does not fit our use case
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            onKeyDown: handleEscape,
            "data-testid": (0, $9nlJl.ESCAPE_WRAPPER_TESTID),
            role: "presentation"
        }, screenReaderText !== '' && renderScreenReaderText(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jUyjb.SoftwareContextMenu), {
            scope: `${issueId}`,
            renderMenu: renderMenu,
            selectedCardIds: selectedCardIds,
            cardId: issueId,
            analyticsMapping: (0, $9nlJl.ANALYTICS_MAPPING_TABLE),
            jsErrorBoundaryProps: {
                id: 'backlogCardListCardContextMenu',
                packageName: 'software-backlog',
                teamName: 'a4t-tanuki'
            }
        }, children)));
    }
    if (appearance === (0, $d9cdb1c71f9dbf8c$export$ee5015c6ad52cf0b)) {
        const { summary: summary, onOpenChange: onOpenChange } = props;
        const getAriaLabelMessage = ()=>{
            if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return formatMessage(selectedCardIds.length > 1 ? (0, $5Mhvq.default).menuTriggerMoreCardsIssueTermRefresh : (0, $5Mhvq.default).menuTriggerOneCard, {
                summary: summary,
                issueKey: issueKey
            });
            return formatMessage(selectedCardIds.length > 1 ? (0, $5Mhvq.default).menuTriggerMoreCards : (0, $5Mhvq.default).menuTriggerOneCard, {
                summary: summary,
                issueKey: issueKey
            });
        };
        const ariaLabelMessage = getAriaLabelMessage();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, screenReaderText !== '' && renderScreenReaderText(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4tD4f.AsyncMeatballMenu), {
            scope: `${issueId}`,
            renderMenu: renderMenu,
            onOpenChange: onOpenChange,
            selectedCardIds: selectedCardIds,
            cardId: issueId,
            analyticsMapping: (0, $9nlJl.ANALYTICS_MAPPING_TABLE),
            ariaLabel: ariaLabelMessage,
            isCompact: showCompactMode,
            jsErrorBoundaryProps: {
                id: 'backlogCardListCardMeatballMenu',
                packageName: 'software-backlog',
                teamName: 'a4t-tanuki'
            }
        }));
    }
    return null;
});

});
const $e6c5355277661284$export$d05ca0d31d3ffa06 = 50; // backlog contextual menu still depends on this constant
const $e6c5355277661284$export$45a421fb1ade804f = 1000;
const $e6c5355277661284$export$57c169ab3300018e = 3;
const $e6c5355277661284$export$71fcb0373c771639 = 'bulk-operations-core.ui.form.form-wrapper';
const $e6c5355277661284$export$39f1bbbd67c1f72 = 'bulk-operations-core.common.ui.view-footer.cancel-button';
const $e6c5355277661284$export$a350e08f5290ad98 = 'bulk-operations-core.common.ui.view-footer.back-button';
const $e6c5355277661284$export$256c8e48a4b7d900 = 'bulk-operations-core.common.ui.view-footer.next-button';
const $e6c5355277661284$export$3d1cf6035bb6e5e6 = 40;
const $e6c5355277661284$export$2bf1ff09810ebfaa = 50;

parcelRegister("jUyjb", function(module, exports) {

$parcel$export(module.exports, "SoftwareContextMenu", () => $b46123cf94546d90$export$b89cae60b0c2d978);

var $5uXOq = parcelRequire("5uXOq");

var $c1wAv = parcelRequire("c1wAv");

var $g5XcP = parcelRequire("g5XcP");

var $gjL94 = parcelRequire("gjL94");
const $b46123cf94546d90$export$b89cae60b0c2d978 = (props)=>{
    const openContextMenuRef = (0, $5uXOq.useRef)(null);
    const childrenRef = (0, $5uXOq.useRef)(null);
    const { onContextMenu: onContextMenu } = (0, $g5XcP.useOnContextMenu)({
        childrenRef: childrenRef,
        openContextMenuRef: openContextMenuRef
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c1wAv.ChildrenWrapperWithAnalytics), {
        onChildrenContextMenu: onContextMenu,
        ref: childrenRef
    }, props.children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjL94.ContextMenu), {
        ...props,
        openContextMenuRef: openContextMenuRef
    }));
};

});
parcelRegister("c1wAv", function(module, exports) {

$parcel$export(module.exports, "ChildrenWrapperWithAnalytics", () => $5fcbc6bc21c0dd31$export$1249ce36e893a19b);

var $5uXOq = parcelRequire("5uXOq");

var $2OMDV = parcelRequire("2OMDV");
var $iXVV6 = parcelRequire("iXVV6");

const $5fcbc6bc21c0dd31$var$WrapperWithAnalytics = (0, $2OMDV.AnalyticsEventToProps)('contextMenu', {
    onContextMenu: 'opened'
})(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ createAnalyticsEvent: createAnalyticsEvent, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ...props,
        ref: ref
    })));
const $5fcbc6bc21c0dd31$export$1249ce36e893a19b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, onChildrenContextMenu: onChildrenContextMenu }, ref)=>{
    const WrapperWithAnalyticsComponent = $5fcbc6bc21c0dd31$var$WrapperWithAnalytics;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            inputSource: 'rightClick'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrapperWithAnalyticsComponent, {
        ref: ref,
        onContextMenu: onChildrenContextMenu,
        "data-testid": (0, $c261fa84ee29a782$export$1790245723dd00ad)
    }, children));
});

});
const $c261fa84ee29a782$export$1790245723dd00ad = 'software-context-menu.ui.context-menu.children-wrapper';


parcelRegister("g5XcP", function(module, exports) {

$parcel$export(module.exports, "useOnContextMenu", () => $f82fb67b9a97c056$export$ca7798d25343efd8);

var $jcw0u = parcelRequire("jcw0u");

var $7D59a = parcelRequire("7D59a");
const $f82fb67b9a97c056$export$ca7798d25343efd8 = ({ childrenRef: childrenRef, openContextMenuRef: openContextMenuRef })=>{
    const onContextMenu = (0, $7D59a.useEvent)((e, analyticsEvent)=>{
        e.stopPropagation();
        if (!childrenRef?.current || !openContextMenuRef?.current) {
            !childrenRef?.current && (0, $jcw0u.default)({
                error: new Error('Trying to open a context menu while childrenRef is undefined'),
                meta: {
                    id: 'jira-software-context-menu-controller-on-container-update-flow-start-error',
                    packageName: 'jiraSoftwareContextMenu',
                    teamName: 'deliveroo'
                }
            });
            return;
        }
        e.preventDefault();
        const { top: top, left: left } = childrenRef.current.getBoundingClientRect();
        const position = {
            x: e.clientX - left,
            y: e.clientY - top
        };
        openContextMenuRef.current.onOpenContextMenu({
            position: position,
            analyticsEvent: analyticsEvent
        });
    });
    return {
        onContextMenu: onContextMenu
    };
};

});

parcelRegister("gjL94", function(module, exports) {

$parcel$export(module.exports, "ContextMenu", () => $4b3b6d0eac56b850$export$8dc6765e8be191c7);

var $5uXOq = parcelRequire("5uXOq");

var $iAbh9 = parcelRequire("iAbh9");

var $6U9Sv = parcelRequire("6U9Sv");

var $ewaBk = parcelRequire("ewaBk");

var $2sMT6 = parcelRequire("2sMT6");

var $g74eh = parcelRequire("g74eh");
const $4b3b6d0eac56b850$export$8dc6765e8be191c7 = ({ cardId: cardId, selectedCardIds: selectedCardIds, analyticsMapping: analyticsMapping, scope: scope, ...props })=>{
    const fullScope = (0, $g74eh.makeScope)(scope, 'context');
    const bulkOpsFlow = (0, $iAbh9.useBulkOpsSessionContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ewaBk.ContextMenuContainer), {
        isGlobal: true,
        selectedCardIds: selectedCardIds,
        analyticsMapping: analyticsMapping,
        cardId: cardId,
        bulkOpsFlow: bulkOpsFlow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6U9Sv.ContextMenuAnalytics), {
        scope: fullScope,
        cardId: cardId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2sMT6.ContextMenu), {
        scope: fullScope,
        ...props
    })));
};

});
parcelRegister("2sMT6", function(module, exports) {

$parcel$export(module.exports, "ContextMenu", () => $a851f60f5a7b5635$export$8dc6765e8be191c7);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $7CMCs = parcelRequire("7CMCs");

var $koVbs = parcelRequire("koVbs");

var $jgJNO = parcelRequire("jgJNO");

var $4R6GH = parcelRequire("4R6GH");

var $ewaBk = parcelRequire("ewaBk");

var $5rXNu = parcelRequire("5rXNu");


var $58mnS = parcelRequire("58mnS");
const $a851f60f5a7b5635$export$8dc6765e8be191c7 = ({ renderMenu: renderMenu, scope: scope, openContextMenuRef: openContextMenuRef, jsErrorBoundaryProps: jsErrorBoundaryProps })=>{
    (0, $5rXNu.useSetOpenContextMenuRef)({
        scope: scope,
        openContextMenuRef: openContextMenuRef
    });
    const [{ menus: menus }] = (0, $ewaBk.useContextMenuStore)();
    const position = menus[scope]?.position || {
        x: 0,
        y: 0
    };
    const isOpen = (0, $ewaBk.useIsMenuOpen)({
        scope: scope
    });
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const renderContent = (0, $5uXOq.useCallback)(({ isOpen: isContentOpen })=>isContentOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
            fallback: "unmount",
            ...jsErrorBoundaryProps
        }, renderMenu(scope)) : null, [
        jsErrorBoundaryProps,
        renderMenu,
        scope
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        offset: [
            0,
            0
        ],
        placement: "bottom-start",
        content: renderContent,
        shouldRenderToParent: true,
        messageId: "software-context-menu.ui.context-menu.popup",
        messageType: "transactional",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a851f60f5a7b5635$export$fa7a3a6ce2191e98, {
                "data-testid": (0, $f46d826c522a20f8$export$5694c1f4d72b68ad),
                position: position,
                role: "button",
                "aria-hidden": (0, $4R6GH.fg)('tanuki_a11y_q4') ? true : undefined,
                ...triggerProps,
                "aria-label": formatMessage((0, $58mnS.default).contextMenuAriaLabel)
            })
    });
};
const $a851f60f5a7b5635$export$fa7a3a6ce2191e98 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { position: position, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_16yv8lz": (0, $lD23V.default)(__cmplp.position.y, "px"),
            "--_1fbn7yv": (0, $lD23V.default)(__cmplp.position.x, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw",
            !!__cmplp.position && __cmplp.position.x && __cmplp.position.y && "_154is04s _1ltvkw7u",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5rXNu", function(module, exports) {

$parcel$export(module.exports, "useSetOpenContextMenuRef", () => $04235c4c7bb590da$export$d7bda04d92fd2eab);

var $5uXOq = parcelRequire("5uXOq");

var $ewaBk = parcelRequire("ewaBk");
const $04235c4c7bb590da$export$d7bda04d92fd2eab = ({ scope: scope, openContextMenuRef: openContextMenuRef })=>{
    const { openMenu: openMenu } = (0, $ewaBk.useContextMenuActions)();
    const onOpenContextMenu = ({ position: position, analyticsEvent: analyticsEvent })=>{
        openMenu({
            position: position,
            analyticsEvent: analyticsEvent,
            scope: scope,
            openedFrom: 'rightClick'
        });
    };
    (0, $5uXOq.useImperativeHandle)(openContextMenuRef, ()=>({
            onOpenContextMenu: onOpenContextMenu
        }));
};

});

const $f46d826c522a20f8$export$5694c1f4d72b68ad = 'software-context-menu.ui.context-menu';

parcelRegister("58mnS", function(module, exports) {

$parcel$export(module.exports, "default", () => $c731817a43b6474e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c731817a43b6474e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    contextMenuAriaLabel: {
        "id": "software-context-menu.context-menu.context-menu-aria-label",
        "defaultMessage": "Open menu"
    }
});

});




parcelRegister("1UfRw", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4a09dc1dca19ef4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $e4a09dc1dca19ef4$var$stopDrag = (e)=>{
    e.preventDefault();
    e.stopPropagation();
};
/**
 * Prevents `dragstart` events from within child elements from bubbling
 */ const $e4a09dc1dca19ef4$var$BlockDrag = ({ children: children })=>// Need to mark this as `draggable` in order for `onDragStart`
    // to fire when attempting to drag child elements
    // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop, jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        draggable: true,
        onDragStart: $e4a09dc1dca19ef4$var$stopDrag
    }, children);
var $e4a09dc1dca19ef4$export$2e2bcd8739ae039 = $e4a09dc1dca19ef4$var$BlockDrag;

});

parcelRegister("9nlJl", function(module, exports) {

$parcel$export(module.exports, "MOVE_TO_MENU_ID", () => $fafb6f2662f0482c$export$5645be38d58b5483);
$parcel$export(module.exports, "MOVE_TO_TOP_OF_BACKLOG_MENU_ID", () => $fafb6f2662f0482c$export$13ba6c00d633f348);
$parcel$export(module.exports, "MOVE_TO_BOTTOM_OF_BACKLOG_MENU_ID", () => $fafb6f2662f0482c$export$319beca788666a0d);
$parcel$export(module.exports, "MOVE_TO_BOARD_MENU_ID", () => $fafb6f2662f0482c$export$4afa86666270dba0);
$parcel$export(module.exports, "MOVE_TO_SEARCH_MENU_ID", () => $fafb6f2662f0482c$export$b54531036348079);
$parcel$export(module.exports, "RANK_MENU_UP_ID", () => $fafb6f2662f0482c$export$10226786f3562a0a);
$parcel$export(module.exports, "RANK_MENU_DOWN_ID", () => $fafb6f2662f0482c$export$ff981f621183205f);
$parcel$export(module.exports, "FLAG_MENU_ID", () => $fafb6f2662f0482c$export$63cb4152f50d2665);
$parcel$export(module.exports, "FLAG_ADD_FLAG_MENU_ID", () => $fafb6f2662f0482c$export$efe455e4d4b4aca9);
$parcel$export(module.exports, "FLAG_REMOVE_FLAG_MENU_ID", () => $fafb6f2662f0482c$export$356329b49381740c);
$parcel$export(module.exports, "COPY_ISSUE_LINK_MENU_ID", () => $fafb6f2662f0482c$export$34b38d58090a7162);
$parcel$export(module.exports, "COPY_ISSUE_KEY_MENU_ID", () => $fafb6f2662f0482c$export$2e74ac183d49087);
$parcel$export(module.exports, "HEADER_BULK_INDICATOR_MENU_ID", () => $fafb6f2662f0482c$export$bdfa217711a39d8d);
$parcel$export(module.exports, "VIEW_IN_ISSUE_SEARCH_MENU_ID", () => $fafb6f2662f0482c$export$4231ab934953c1bc);
$parcel$export(module.exports, "SPLIT_ISSUE_MENU_ID", () => $fafb6f2662f0482c$export$b7bce247cd0b2a49);
$parcel$export(module.exports, "DELETE_ISSUE_MENU_ID", () => $fafb6f2662f0482c$export$b35363b92f22bb89);
$parcel$export(module.exports, "CLONE_ISSUE_MENU_ID", () => $fafb6f2662f0482c$export$45f7afb383d46279);
$parcel$export(module.exports, "SEPARATOR_MENU_ID", () => $fafb6f2662f0482c$export$1fa1533b8d6efd51);
$parcel$export(module.exports, "STORY_POINTS_MENU_ID", () => $fafb6f2662f0482c$export$38cc7f6fd54f040a);
$parcel$export(module.exports, "STORY_POINTS_EDIT_MENU_ID", () => $fafb6f2662f0482c$export$d913180634f6bb7a);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE_MENU_ID", () => $fafb6f2662f0482c$export$f44075570bbdc5a9);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE_EDIT_MENU_ID", () => $fafb6f2662f0482c$export$e7a2177d793805f9);
$parcel$export(module.exports, "PARENT_MENU_ID", () => $fafb6f2662f0482c$export$744dc4889ca2fd20);
$parcel$export(module.exports, "PARENT_SEARCH_MENU_ID", () => $fafb6f2662f0482c$export$21f306406b358f4f);
$parcel$export(module.exports, "VERSION_MENU_ID", () => $fafb6f2662f0482c$export$bd3b3ff7a0a9e25a);
$parcel$export(module.exports, "PRIORITY_MENU_ID", () => $fafb6f2662f0482c$export$203cb0fa00d01abe);
$parcel$export(module.exports, "USE_AGENT_MENU_ID", () => $fafb6f2662f0482c$export$f163e91c638bb703);
$parcel$export(module.exports, "USE_AGENT_NODE_MENU_ID", () => $fafb6f2662f0482c$export$d73e2f4063a0141d);
$parcel$export(module.exports, "ASSIGNEE_MENU_ID", () => $fafb6f2662f0482c$export$c3421a7192b5f002);
$parcel$export(module.exports, "ASSIGNEE_SEARCH_MENU_ID", () => $fafb6f2662f0482c$export$ddf4731675705ca4);
$parcel$export(module.exports, "GO_TO_BULK_EDITOR_MENU_ID", () => $fafb6f2662f0482c$export$109f329d0ffd3326);
$parcel$export(module.exports, "ANALYTICS_MAPPING_TABLE", () => $fafb6f2662f0482c$export$77ab83fd54e2c3c);
$parcel$export(module.exports, "ESCAPE_WRAPPER_TESTID", () => $fafb6f2662f0482c$export$341cb34540d073ad);

var $5fc53 = parcelRequire("5fc53");
const $fafb6f2662f0482c$export$5645be38d58b5483 = 'actions/move-to';
const $fafb6f2662f0482c$export$13ba6c00d633f348 = 'actions/move-to/top-of-backlog';
const $fafb6f2662f0482c$export$319beca788666a0d = 'actions/move-to/bottom-of-backlog';
const $fafb6f2662f0482c$export$4afa86666270dba0 = 'actions/move-to/board';
const $fafb6f2662f0482c$export$b54531036348079 = 'actions/move-to/search';
const $fafb6f2662f0482c$export$10226786f3562a0a = 'actions/move-to/rank-up';
const $fafb6f2662f0482c$export$ff981f621183205f = 'actions/move-to/rank-down';
const $fafb6f2662f0482c$export$63cb4152f50d2665 = 'actions/flag';
const $fafb6f2662f0482c$export$efe455e4d4b4aca9 = 'actions/flag/add-flag';
const $fafb6f2662f0482c$export$356329b49381740c = 'actions/flag/remove-flag';
const $fafb6f2662f0482c$export$34b38d58090a7162 = 'actions/copy-issue-link';
const $fafb6f2662f0482c$export$2e74ac183d49087 = 'actions/copy-issue-key';
const $fafb6f2662f0482c$export$bdfa217711a39d8d = 'bulk-indicator';
const $fafb6f2662f0482c$export$4231ab934953c1bc = 'actions/view-in-issue-search';
const $fafb6f2662f0482c$export$b7bce247cd0b2a49 = 'actions/split-issue';
const $fafb6f2662f0482c$export$b35363b92f22bb89 = 'actions/delete-issue';
const $fafb6f2662f0482c$export$45f7afb383d46279 = 'actions/clone-issue';
const $fafb6f2662f0482c$export$1fa1533b8d6efd51 = 'separator';
const $fafb6f2662f0482c$export$38cc7f6fd54f040a = 'actions/story-point';
const $fafb6f2662f0482c$export$d913180634f6bb7a = 'actions/story-point/edit';
const $fafb6f2662f0482c$export$f44075570bbdc5a9 = 'actions/original-estimate';
const $fafb6f2662f0482c$export$e7a2177d793805f9 = 'actions/original-estimate/edit';
const $fafb6f2662f0482c$export$744dc4889ca2fd20 = 'actions/parent';
const $fafb6f2662f0482c$export$21f306406b358f4f = 'actions/parent/search';
const $fafb6f2662f0482c$export$bd3b3ff7a0a9e25a = 'actions/version';
const $fafb6f2662f0482c$export$203cb0fa00d01abe = 'actions/priority';
const $fafb6f2662f0482c$export$f163e91c638bb703 = 'actions/use-agent';
const $fafb6f2662f0482c$export$d73e2f4063a0141d = 'actions/use-agent/search';
const $fafb6f2662f0482c$export$c3421a7192b5f002 = 'actions/assignee';
const $fafb6f2662f0482c$export$ddf4731675705ca4 = 'actions/assignee/search';
const $fafb6f2662f0482c$export$109f329d0ffd3326 = 'actions/go-to-bulk-editor';
const $fafb6f2662f0482c$export$b7344797d0384ac5 = 'actions/plan-on-whiteboard';
const $fafb6f2662f0482c$var$MOVE_ANALYTICS = {
    attributes: {
        actionGroup: 'move'
    }
};
const $fafb6f2662f0482c$var$UPDATE_ANALYTICS = {
    attributes: {
        actionGroup: 'update'
    }
};
const $fafb6f2662f0482c$export$77ab83fd54e2c3c = {
    [$fafb6f2662f0482c$export$5645be38d58b5483]: {
        actionSubjectId: 'moveToSprintDropdownItem',
        ...$fafb6f2662f0482c$var$MOVE_ANALYTICS
    },
    [$fafb6f2662f0482c$export$13ba6c00d633f348]: {
        actionSubjectId: 'moveToTopBacklogDropdownItem',
        ...$fafb6f2662f0482c$var$MOVE_ANALYTICS
    },
    [$fafb6f2662f0482c$export$319beca788666a0d]: {
        actionSubjectId: 'moveToBottomBacklogDropdownItem',
        ...$fafb6f2662f0482c$var$MOVE_ANALYTICS
    },
    [$fafb6f2662f0482c$export$4afa86666270dba0]: {
        actionSubjectId: 'moveToBoardDropdownItem',
        ...$fafb6f2662f0482c$var$MOVE_ANALYTICS
    },
    [$fafb6f2662f0482c$export$efe455e4d4b4aca9]: {
        actionSubjectId: 'addFlagDropdownItem',
        ...$fafb6f2662f0482c$var$UPDATE_ANALYTICS
    },
    [$fafb6f2662f0482c$export$356329b49381740c]: {
        actionSubjectId: 'removeFlagDropdownItem',
        ...$fafb6f2662f0482c$var$UPDATE_ANALYTICS
    },
    [$fafb6f2662f0482c$export$4231ab934953c1bc]: 'viewIssueSearchDropdownItem',
    [$fafb6f2662f0482c$export$109f329d0ffd3326]: 'goToBulkEditorDropdownItem',
    [$fafb6f2662f0482c$export$b7bce247cd0b2a49]: 'splitIssueDropdownItem',
    [$fafb6f2662f0482c$export$b35363b92f22bb89]: 'deleteDropdownItem',
    [$fafb6f2662f0482c$export$45f7afb383d46279]: 'cloneIssueDropdownItem',
    [$fafb6f2662f0482c$export$34b38d58090a7162]: 'copyIssueLink',
    [$fafb6f2662f0482c$export$2e74ac183d49087]: 'copyIssueKey',
    [$fafb6f2662f0482c$export$d913180634f6bb7a]: {
        actionSubjectId: 'updateEstimateDropdownItem',
        attributes: {
            ...$fafb6f2662f0482c$var$UPDATE_ANALYTICS.attributes,
            fieldKey: 'storyPointEstimate'
        }
    },
    [$fafb6f2662f0482c$export$e7a2177d793805f9]: {
        actionSubjectId: 'updateEstimateDropdownItem',
        attributes: {
            ...$fafb6f2662f0482c$var$UPDATE_ANALYTICS.attributes,
            fieldKey: (0, $5fc53.TIME_ESTIMATE_TYPE)
        }
    },
    [$fafb6f2662f0482c$export$c3421a7192b5f002]: {
        actionSubjectId: 'updateAssigneeDropdownItem',
        attributes: {
            ...$fafb6f2662f0482c$var$UPDATE_ANALYTICS.attributes,
            fieldKey: (0, $5fc53.ASSIGNEE_TYPE)
        }
    },
    [$fafb6f2662f0482c$export$203cb0fa00d01abe]: {
        actionSubjectId: 'updatePriorityDropdownItem',
        attributes: {
            ...$fafb6f2662f0482c$var$UPDATE_ANALYTICS.attributes,
            fieldKey: (0, $5fc53.PRIORITY_TYPE)
        }
    },
    [$fafb6f2662f0482c$export$744dc4889ca2fd20]: {
        actionSubjectId: 'updateParentDropdownItem',
        attributes: {
            ...$fafb6f2662f0482c$var$UPDATE_ANALYTICS.attributes,
            fieldKey: (0, $5fc53.PARENT_TYPE)
        }
    }
};
const $fafb6f2662f0482c$export$341cb34540d073ad = 'software-backlog.card-list.card.context-menu.escape-wrapper';

});

parcelRegister("iaKyE", function(module, exports) {

$parcel$export(module.exports, "useAssignee", () => $ec4bf711ffbd69d1$export$db27ad834dc313f2);

var $5uXOq = parcelRequire("5uXOq");

var $aB8eX = parcelRequire("aB8eX");

var $8Rkzz = parcelRequire("8Rkzz");

var $ujWmd = parcelRequire("ujWmd");

var $4R6GH = parcelRequire("4R6GH");

var $7f4tk = parcelRequire("7f4tk");

var $koVbs = parcelRequire("koVbs");

var $aWse0 = parcelRequire("aWse0");

var $ctrpc = parcelRequire("ctrpc");


var $fhSLy = parcelRequire("fhSLy");

var $fOGZN = parcelRequire("fOGZN");

var $2NMNM = parcelRequire("2NMNM");

var $1HF4Y = parcelRequire("1HF4Y");

var $leRCk = parcelRequire("leRCk");

var $gJl8A = parcelRequire("gJl8A");

var $2HxVZ = parcelRequire("2HxVZ");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");

var $1z1J7 = parcelRequire("1z1J7");

var $9nlJl = parcelRequire("9nlJl");

var $5Mhvq = parcelRequire("5Mhvq");
const $ec4bf711ffbd69d1$export$f3d2344ae01372eb = ({ options: options, isLoading: isLoading, canAssign: canAssign, setQuery: setQuery, selectedCardIds: selectedCardIds })=>{
    const onMouseEnter = (0, $gJl8A.useContextStartAnalytics)({
        selectedCardIds: selectedCardIds ?? [],
        fieldType: (0, $fOGZN.ASSIGNEE),
        fieldKey: (0, $fOGZN.ASSIGNEE)
    });
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return canAssign ? [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: formatMessage((0, $5Mhvq.default).assignee),
            id: (0, $9nlJl.ASSIGNEE_MENU_ID),
            submenuWidth: 284,
            children: [
                {
                    type: (0, $1HF4Y.MenuNodeType).Search,
                    id: (0, $9nlJl.ASSIGNEE_SEARCH_MENU_ID),
                    children: options,
                    hasSearch: true,
                    isAsyncSearch: true,
                    isLoading: isLoading,
                    onChange: (value)=>setQuery(value),
                    ariaLabel: formatMessage((0, $5Mhvq.default).ariaLabel)
                }
            ],
            ...(0, $4R6GH.fg)('one_event_rules_them_all_fg') && {
                onMouseEnter: onMouseEnter
            }
        }
    ] : [];
};
const $ec4bf711ffbd69d1$export$2bf6f142ce284479 = ()=>{
    const getCurrentAssignee = (0, $c1MAf.useBacklogSelector)((0, $dGljH.makeGetCardAssignee));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (cardId, newValue)=>{
        const previousValue = getCurrentAssignee(cardId);
        (0, $ctrpc.getUpdateAnalyticsFlowHelper)().setActionTakenAttributes((0, $fOGZN.ASSIGNEE), previousValue?.id, newValue?.id ?? null);
        (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd((0, $fOGZN.ASSIGNEE), {
            analytics: createAnalyticsEvent({}),
            attributes: {
                fieldType: (0, $fOGZN.ASSIGNEE)
            }
        });
    };
};
const $ec4bf711ffbd69d1$export$db27ad834dc313f2 = ({ selectedCardIds: selectedCardIds })=>{
    const intl = (0, $aWse0.useIntlV2)(); // used to obtain unassigned and automatic user options
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [assignees, setAssignees] = (0, $5uXOq.useState)([]);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [query, setQuery] = (0, $5uXOq.useState)('');
    const getIssueKey = (0, $c1MAf.useBacklogSelector)((0, $dGljH.makeCardKeyFromCardId));
    const [{ data: loggedInUser }] = (0, $leRCk.useUserSubscriber)();
    const unassigned = (0, $5uXOq.useMemo)(()=>(0, $fhSLy.getUserOptionFromUser)((0, $fhSLy.getUnassignedUser)(intl)), [
        intl
    ]);
    const automatic = (0, $5uXOq.useMemo)(()=>(0, $fhSLy.getUserOptionFromUser)((0, $fhSLy.getAutomaticUserOption)(intl)), [
        intl
    ]);
    const fireAnalyticsEnd = (0, $4R6GH.fg)('one_event_rules_them_all_fg') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    $ec4bf711ffbd69d1$export$2bf6f142ce284479() : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    const assignToMe = (0, $5uXOq.useMemo)(()=>loggedInUser ? (0, $fhSLy.getUserOptionFromUser)({
            ...loggedInUser,
            displayName: formatMessage((0, $5Mhvq.default).assignToMe)
        }) : null, [
        formatMessage,
        loggedInUser
    ]);
    const defaultOptions = (0, $5uXOq.useMemo)(()=>[
            unassigned,
            automatic,
            ...assignToMe ? [
                assignToMe
            ] : []
        ], [
        assignToMe,
        automatic,
        unassigned
    ]);
    const onAssigneeClick = (0, $c1MAf.useBacklogActionCreator)((assignee, analyticsEvent)=>{
        if (selectedCardIds.length === 1 && (0, $4R6GH.fg)('one_event_rules_them_all_fg')) fireAnalyticsEnd(selectedCardIds[0], assignee.id === (0, $c1e3a0a8493b8e86$export$bdab9bfb39981463) ? null : assignee);
        return (0, $aB8eX.batchActions)(selectedCardIds.map((id)=>(0, $2HxVZ.cardAssigneeSetOptimistic)({
                cardId: id,
                assignee: assignee.id === (0, $c1e3a0a8493b8e86$export$bdab9bfb39981463) ? null : {
                    avatarUrl: assignee.avatarUrl,
                    displayName: assignee.name,
                    id: assignee.id
                }
            }, getIssueKey(id), analyticsEvent)));
    });
    const fetchUsers = (keywords)=>(0, $7f4tk.default)(`/rest/api/2/user/search?query=${keywords}`);
    (0, $5uXOq.useEffect)(()=>{
        const handleSearch = async (value)=>{
            setIsLoading(true);
            try {
                const response = await fetchUsers(value);
                setAssignees(response.length ? response.map((0, $fhSLy.getUserOptionFromUser)) : []);
            } catch  {
                setAssignees(defaultOptions);
            }
            setIsLoading(false);
        };
        if (query.length) handleSearch(query);
        else setAssignees(defaultOptions);
    }, [
        query,
        defaultOptions
    ]);
    const options = (0, $5uXOq.useMemo)(()=>assignees.map((assignee)=>({
                type: (0, $1HF4Y.MenuNodeType).Item,
                label: assignee.name,
                id: `${0, $9nlJl.ASSIGNEE_MENU_ID}__value_${assignee.id}`,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
                    src: assignee.avatarUrl,
                    size: "small"
                }),
                onClick: (analyticsEvent)=>onAssigneeClick(assignee, analyticsEvent)
            })), [
        assignees,
        onAssigneeClick
    ]);
    const canBulkEdit = (0, $c1MAf.useBacklogSelector)((0, $1z1J7.canBulkEditIssues));
    const canAssignIssue = (0, $c1MAf.useBacklogSelector)((0, $1z1J7.canAssignIssues));
    const canAssign = canAssignIssue && canBulkEdit;
    return $ec4bf711ffbd69d1$export$f3d2344ae01372eb({
        options: options,
        isLoading: isLoading,
        canAssign: canAssign,
        setQuery: setQuery,
        ...(0, $4R6GH.fg)('one_event_rules_them_all_fg') && {
            selectedCardIds: selectedCardIds
        }
    });
};

});
parcelRegister("gJl8A", function(module, exports) {

$parcel$export(module.exports, "useContextStartAnalytics", () => $349fd3349699af49$export$2bc45e6134c5101e);

var $8Rkzz = parcelRequire("8Rkzz");

var $4R6GH = parcelRequire("4R6GH");

var $ctrpc = parcelRequire("ctrpc");

var $2NMNM = parcelRequire("2NMNM");
const $349fd3349699af49$export$2bc45e6134c5101e = ({ selectedCardIds: selectedCardIds, fieldType: fieldType, fieldKey: fieldKey })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    if (!(0, $4R6GH.fg)('one_event_rules_them_all_fg')) return 0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz));
    return ()=>{
        if (selectedCardIds.length === 1) (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsStart(fieldKey, {
            analytics: createAnalyticsEvent({}),
            attributes: {
                fieldType: fieldType,
                isContextMenuEditing: true,
                ...(0, $4R6GH.fg)('one_event_improvements_1') && {
                    issueId: Number(selectedCardIds[0])
                }
            }
        });
    };
};

});

parcelRegister("5Mhvq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f746ba74f8a38cfb$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f746ba74f8a38cfb$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    moveTo: {
        "id": "backlog.card-list.card.context-menu.move-to",
        "defaultMessage": "Move to"
    },
    moveWorkItem: {
        "id": "backlog.card-list.card.context-menu.move-work-item",
        "defaultMessage": "Move work item"
    },
    topOfTheBacklog: {
        "id": "backlog.card-list.card.context-menu.top-of-the-backlog",
        "defaultMessage": "Top of backlog"
    },
    bottomOfTheBacklog: {
        "id": "backlog.card-list.card.context-menu.bottom-of-the-backlog",
        "defaultMessage": "Bottom of backlog"
    },
    toTheTopOfTheBacklog: {
        "id": "backlog.card-list.card.context-menu.to-the-top-of-the-backlog",
        "defaultMessage": "To top of backlog"
    },
    toTheBottomOfTheBacklog: {
        "id": "backlog.card-list.card.context-menu.to-the-bottom-of-the-backlog",
        "defaultMessage": "To bottom of backlog"
    },
    board: {
        "id": "backlog.card-list.card.context-menu.board",
        "defaultMessage": "Board"
    },
    delete: {
        "id": "backlog.card-list.card.context-menu.delete",
        "defaultMessage": "Delete"
    },
    archive: {
        "id": "backlog.card-list.card.context-menu.archive",
        "defaultMessage": "Archive"
    },
    clone: {
        "id": "backlog.card-list.card.context-menu.clone",
        "defaultMessage": "Clone"
    },
    flag: {
        "id": "backlog.card-list.card.context-menu.flag",
        "defaultMessage": "Flag"
    },
    addFlag: {
        "id": "backlog.card-list.card.context-menu.add-flag",
        "defaultMessage": "Add flag"
    },
    removeFlag: {
        "id": "backlog.card-list.card.context-menu.remove-flag",
        "defaultMessage": "Remove flag"
    },
    copyIssueLink: {
        "id": "backlog.card-list.card.context-menu.copy-issue-link",
        "defaultMessage": "Copy issue link"
    },
    copyIssueKey: {
        "id": "backlog.card-list.card.context-menu.copy-issue-key",
        "defaultMessage": "Copy issue key"
    },
    viewInIssueSearch: {
        "id": "backlog.card-list.card.context-menu.view-in-issue-search",
        "defaultMessage": "View in issue search"
    },
    splitIssue: {
        "id": "backlog.card-list.card.context-menu.split-issue",
        "defaultMessage": "Split issue"
    },
    addIssueParent: {
        "id": "backlog.card-list.card.context-menu.add-issue-parent",
        "defaultMessage": "Add parent"
    },
    changeIssueParent: {
        "id": "backlog.card-list.card.context-menu.change-issue-parent",
        "defaultMessage": "Change parent"
    },
    parentOptionLabel: {
        "id": "backlog.card-list.card.context-menu.parent-option-label",
        "defaultMessage": "Parent"
    },
    parentUnlinkOptionLabel: {
        "id": "backlog.card-list.card.context-menu.parent-unlink-option-label",
        "defaultMessage": "Unlink"
    },
    versionOptionLabel: {
        "id": "backlog.card-list.card.context-menu.version-option-label",
        "defaultMessage": "Version"
    },
    versionUnlinkOptionLabel: {
        "id": "backlog.card-list.card.context-menu.version-unlink-option-label",
        "defaultMessage": "Unlink"
    },
    originalEstimate: {
        "id": "backlog.card-list.card.context-menu.original-estimate",
        "defaultMessage": "Original estimate"
    },
    storyPointEstimate: {
        "id": "backlog.card-list.card.context-menu.story-point-estimate",
        "defaultMessage": "Story point estimate"
    },
    priority: {
        "id": "backlog.card-list.card.context-menu.priority",
        "defaultMessage": "Priority"
    },
    assignee: {
        "id": "backlog.card-list.card.context-menu.assignee",
        "defaultMessage": "Assignee"
    },
    assignToMe: {
        "id": "backlog.card-list.card.context-menu.assign-to-me",
        "defaultMessage": "Assign to me"
    },
    bulkChange: {
        "id": "backlog.card-list.card.context-menu.bulk-change",
        "defaultMessage": "Bulk change"
    },
    goToBulkEditorIconLabel: {
        "id": "backlog.card-list.card.context-menu.go-to-bulk-editor-icon-label",
        "defaultMessage": "Open in new window"
    },
    menuTriggerOneCard: {
        "id": "backlog.card-list.card.context-menu.menu-trigger-one-card",
        "defaultMessage": "More actions for {issueKey} {summary}"
    },
    menuTriggerMoreCards: {
        "id": "backlog.card-list.card.context-menu.menu-trigger-more-cards",
        "defaultMessage": "More actions for {issueKey} {summary} and other selected issues"
    },
    rankUp: {
        "id": "backlog.card-list.card.context-menu.rank-up",
        "defaultMessage": "Move up"
    },
    up: {
        "id": "backlog.card-list.card.context-menu.up",
        "defaultMessage": "Up"
    },
    movedUp: {
        "id": "backlog.card-list.card.context-menu.moved-item-up",
        "defaultMessage": "Moved work item up"
    },
    rankDown: {
        "id": "backlog.card-list.card.context-menu.rank-down",
        "defaultMessage": "Move down"
    },
    down: {
        "id": "backlog.card-list.card.context-menu.down",
        "defaultMessage": "Down"
    },
    movedDown: {
        "id": "backlog.card-list.card.context-menu.moved-item-down",
        "defaultMessage": "Moved work item down"
    },
    copyIssueKeySuccessTitle: {
        "id": "backlog.card-list.card.context-menu.copy-issue-key-success-title",
        "defaultMessage": "Issue key copied"
    },
    copyIssueKeySuccessDescription: {
        "id": "backlog.card-list.card.context-menu.copy-issue-key-success-description",
        "defaultMessage": "Issue key successfully copied to your clipboard"
    },
    ariaLabel: {
        "id": "backlog.card-list.card.context-menu.aria-label",
        "defaultMessage": "Select assignee"
    },
    sprintSearchPlaceholder: {
        "id": "backlog.card-list.card.context-menu.sprint-search-placeholder",
        "defaultMessage": "Search sprints"
    },
    copyIssueLinkIssueTermRefresh: {
        "id": "backlog.card-list.card.context-menu.copy-issue-link-issue-term-refresh",
        "defaultMessage": "Copy link"
    },
    copyIssueKeyIssueTermRefresh: {
        "id": "backlog.card-list.card.context-menu.copy-issue-key-issue-term-refresh",
        "defaultMessage": "Copy key"
    },
    viewInIssueSearchIssueTermRefresh: {
        "id": "backlog.card-list.card.context-menu.view-in-issue-search-issue-term-refresh",
        "defaultMessage": "View in work item search"
    },
    splitIssueIssueTermRefresh: {
        "id": "backlog.card-list.card.context-menu.split-issue-issue-term-refresh",
        "defaultMessage": "Split work item"
    },
    menuTriggerMoreCardsIssueTermRefresh: {
        "id": "backlog.card-list.card.context-menu.menu-trigger-more-cards-issue-term-refresh",
        "defaultMessage": "More actions for {issueKey} {summary} and other selected work items"
    },
    copyIssueKeySuccessTitleIssueTermRefresh: {
        "id": "backlog.card-list.card.context-menu.copy-issue-key-success-title-issue-term-refresh",
        "defaultMessage": "Key copied"
    },
    copyIssueKeySuccessDescriptionIssueTermRefresh: {
        "id": "backlog.card-list.card.context-menu.copy-issue-key-success-description-issue-term-refresh",
        "defaultMessage": "Key successfully copied to your clipboard"
    },
    copySuccessTitle: {
        "id": "backlog.card-list.card.context-menu.copy-to-clipboard.copy-success-title",
        "defaultMessage": "Issue link copied"
    },
    copySuccessMessage: {
        "id": "backlog.card-list.card.context-menu.copy-to-clipboard.copy-success-message",
        "defaultMessage": "Issue link successfully copied to your clipboard"
    },
    copySuccessTitleIssueTermRefresh: {
        "id": "backlog.card-list.card.context-menu.copy-to-clipboard.copy-success-title-issue-term-refresh",
        "defaultMessage": "Link copied"
    },
    copySuccessMessageIssueTermRefresh: {
        "id": "backlog.card-list.card.context-menu.copy-to-clipboard.copy-success-message-issue-term-refresh",
        "defaultMessage": "Link successfully copied to your clipboard"
    },
    copySuccessMessageIssueTerminologyRefreshM4: {
        "id": "backlog.card-list.card.context-menu.copy-to-clipboard.copy-success-message-issue-terminology-refresh-m4",
        "defaultMessage": "You\u2019ve copied the link to the {workType} {key} to your clipboard"
    },
    splitIssueIssueTerminologyRefreshM4: {
        "id": "backlog.card-list.card.context-menu.split-issue-issue-terminology-refresh-m4",
        "defaultMessage": "Split {workType}"
    }
});

});


parcelRegister("7bfQN", function(module, exports) {

$parcel$export(module.exports, "useUseAgent", () => $f0fe229f0c4ffb95$export$851a1afcd9278df1);

var $5uXOq = parcelRequire("5uXOq");

var $1HF4Y = parcelRequire("1HF4Y");

var $4R6GH = parcelRequire("4R6GH");

var $3lQDd = parcelRequire("3lQDd");

var $koVbs = parcelRequire("koVbs");

var $90yGq = parcelRequire("90yGq");

var $a4KlA = parcelRequire("a4KlA");

var $koeKL = parcelRequire("koeKL");

var $5yJb9 = parcelRequire("5yJb9");

var $6uqUb = parcelRequire("6uqUb");

var $9nlJl = parcelRequire("9nlJl");

var $ekjae = parcelRequire("ekjae");

var $bG3Cw = parcelRequire("bG3Cw");
const $f0fe229f0c4ffb95$export$851a1afcd9278df1 = (cardIds)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const atlassianAccountId = (0, $90yGq.useAccountId)();
    const agentMenuOpenExpStart = (0, $6uqUb.useAgentPickerBulkOpenMenuExpStart)();
    const [isAutoDevEnabled] = (0, $a4KlA.useIsAutoDevEnabled)(atlassianAccountId, cloudId, (0, $5yJb9.default)());
    if (!(0, $4R6GH.fg)('autodev-verticals-bulk-agents-backlog') || !isAutoDevEnabled) return [];
    return [
        (0, $ekjae.createSeparator)((0, $9nlJl.USE_AGENT_MENU_ID)),
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: formatMessage((0, $bG3Cw.default).useAgent),
            id: (0, $9nlJl.USE_AGENT_MENU_ID),
            submenuWidth: 320,
            children: [
                {
                    type: (0, $1HF4Y.MenuNodeType).Node,
                    id: (0, $9nlJl.USE_AGENT_NODE_MENU_ID),
                    node: ({ closeMenu: closeMenu })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3lQDd.AgentPickerBulk), {
                            issueIds: cardIds.map(String),
                            menuContextLocation: "backlog_context_menu",
                            onClose: closeMenu
                        })
                }
            ],
            onMouseEnter: ()=>{
                agentMenuOpenExpStart();
            }
        }
    ];
};

});
parcelRegister("ekjae", function(module, exports) {

$parcel$export(module.exports, "createSeparator", () => $d3a46bd3c0c1e7be$export$2f446885d1462a2f);

var $gJBT6 = parcelRequire("gJBT6");

var $1HF4Y = parcelRequire("1HF4Y");

var $9nlJl = parcelRequire("9nlJl");
const $d3a46bd3c0c1e7be$export$2f446885d1462a2f = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((id)=>({
        id: `${0, $9nlJl.SEPARATOR_MENU_ID}/${id}`,
        type: (0, $1HF4Y.MenuNodeType).Separator
    }));

});

parcelRegister("bG3Cw", function(module, exports) {

$parcel$export(module.exports, "default", () => $09bfb07235aad0ce$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $09bfb07235aad0ce$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    useAgent: {
        "id": "backlog.card-list.card.context-menu.use-agent-non-final",
        "defaultMessage": "Use Agent"
    }
});

});


parcelRegister("9UPwF", function(module, exports) {

$parcel$export(module.exports, "useCloneIssue", () => $d7edcab99f0df0cf$export$7027dc5eeff1ac8c);

var $5uXOq = parcelRequire("5uXOq");

var $jDDM6 = parcelRequire("jDDM6");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $2gCtH = parcelRequire("2gCtH");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $93Yeu = parcelRequire("93Yeu");

var $1HF4Y = parcelRequire("1HF4Y");

var $2KAtx = parcelRequire("2KAtx");

var $8l12q = parcelRequire("8l12q");

var $byRc1 = parcelRequire("byRc1");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");

var $1z1J7 = parcelRequire("1z1J7");

var $9nlJl = parcelRequire("9nlJl");

var $5Mhvq = parcelRequire("5Mhvq");
const $d7edcab99f0df0cf$export$737c881ed115dc13 = ({ issueKey: issueKey, issueId: issueId, isCloneEnabled: isCloneEnabled, onCloneIssue: onCloneIssue })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!isCloneEnabled) return [];
    if ((0, $4R6GH.fg)('jira_context_menu_clone_dialog')) return [
        {
            type: (0, $1HF4Y.MenuNodeType).Node,
            id: (0, $9nlJl.CLONE_ISSUE_MENU_ID),
            node: ({ closeMenu: closeMenu })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
                    entryPoint: (0, $8l12q.asyncIssueCloneModalEntryPoint),
                    entryPointProps: {
                        issueKey: issueKey,
                        issueId: issueId.toString()
                    },
                    interactionName: (0, $9nlJl.CLONE_ISSUE_MENU_ID),
                    useInternalModal: false
                }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $byRc1.ContextMenuItemButton), {
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        ref: ref,
                        menuItem: {
                            type: (0, $1HF4Y.MenuNodeType).Item,
                            id: `${(0, $9nlJl.CLONE_ISSUE_MENU_ID)}-item`,
                            label: formatMessage((0, $5Mhvq.default).clone)
                        },
                        onClick: closeMenu,
                        hasChildren: false
                    }))
        }
    ];
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: formatMessage((0, $5Mhvq.default).clone),
            id: (0, $9nlJl.CLONE_ISSUE_MENU_ID),
            onClick: onCloneIssue
        }
    ];
};
const $d7edcab99f0df0cf$export$7027dc5eeff1ac8c = ({ issueKey: issueKey, issueId: issueId, isMultiSelect: isMultiSelect })=>{
    const projectKey = (0, $2gCtH.useProjectKey)();
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    const [, makeCloneRequest] = (0, $jDDM6.useCloneService)(issueKey, projectType || null);
    const issue = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.getCards)(state)[String(issueId)]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onCloneIssue = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'cloneIssue');
        if ((0, $4R6GH.fg)('jira_context_menu_clone_dialog')) return;
        makeCloneRequest({
            summary: `CLONE - ${issue.summary}`
        });
    }, [
        createAnalyticsEvent,
        makeCloneRequest,
        issue.summary
    ]);
    const canClone = (0, $c1MAf.useBacklogSelector)((0, $1z1J7.canCreateIssues));
    return $d7edcab99f0df0cf$export$737c881ed115dc13({
        issueKey: issueKey,
        issueId: issueId,
        isCloneEnabled: canClone && !isMultiSelect,
        onCloneIssue: onCloneIssue
    });
};

});
parcelRegister("jDDM6", function(module, exports) {

$parcel$export(module.exports, "useCloneService", () => $e9ee8f289c652c3e$export$8b487a17f0174b06);

var $alF9a = parcelRequire("alF9a");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $jJZqs = parcelRequire("jJZqs");

var $pa9q9 = parcelRequire("pa9q9");

var $gXz4p = parcelRequire("gXz4p");

var $k9JTq = parcelRequire("k9JTq");

var $koeKL = parcelRequire("koeKL");

var $6s1PB = parcelRequire("6s1PB");

var $koiRX = parcelRequire("koiRX");

var $64qgp = parcelRequire("64qgp");

var $7EJw7 = parcelRequire("7EJw7");

var $1GpXU = parcelRequire("1GpXU");

var $7hFxW = parcelRequire("7hFxW");

var $dMdDY = parcelRequire("dMdDY");
const $e9ee8f289c652c3e$var$getCloneUrl = (issueKey)=>`/rest/internal/2/issue/${issueKey}/clone`;
const $e9ee8f289c652c3e$var$getCloneProgressUrl = (taskId)=>`/rest/api/3/task/${taskId}`;
const $e9ee8f289c652c3e$var$getIssueKeyUrl = (issueId)=>`/rest/api/3/issue/${issueId}?fields=key`;
const $e9ee8f289c652c3e$var$getYourWorkUrl = ()=>'/jira/your-work';
const $e9ee8f289c652c3e$export$8b487a17f0174b06 = (issueKey, projectType)=>{
    const cloneUrl = $e9ee8f289c652c3e$var$getCloneUrl(issueKey);
    const appEditions = (0, $k9JTq.useAppEditions)();
    const [cloneFetchStatus, { setCloneFetchStatus: setCloneFetchStatus }] = (0, $dMdDY.useCloneStatus)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const flagId = (0, $5uXOq.useRef)();
    const progressTaskId = (0, $5uXOq.useRef)('0');
    const cloudId = (0, $koeKL.useCloudId)();
    // For retries
    const payloadRef = (0, $5uXOq.useRef)();
    const onTryAgainClicked = (0, $5uXOq.useRef)();
    const [commit] = (0, $8Uumt.useMutation)((0, $alF9a.default));
    const dismissFlagIfNeeded = (0, $5uXOq.useCallback)(()=>{
        if (flagId.current) dismissFlag(flagId.current);
    }, [
        dismissFlag
    ]);
    const onFailure = (0, $5uXOq.useCallback)((stage, errorMessage, errorStatusCode, failedReason, traceId)=>{
        setCloneFetchStatus((0, $7EJw7.CloneStatus).FAILED);
        dismissFlagIfNeeded();
        // For 4xx erros, we will send it as taskFail events but at SLO level we will filter it
        if (errorStatusCode !== null && errorStatusCode !== undefined && errorStatusCode !== 0) {
            const successStatusCodes = (0, $4R6GH.fg)('bento_send_4xx_to_task_fail_gate_1') ? [
                200,
                201,
                202
            ] : [
                200,
                401,
                403,
                404
            ];
            const wasSuccessful = successStatusCodes.includes(errorStatusCode);
            const errorMessageIfFailed = wasSuccessful ? undefined : `${errorMessage} (Status: ${errorStatusCode})`;
            (0, $gXz4p.sendExperienceAnalytics)((0, $1GpXU.cloneIssueExperienceDescription)(wasSuccessful, stage, 'clone-issue', projectType, appEditions, errorMessageIfFailed, errorStatusCode, traceId));
        }
        flagId.current = showFlag({
            messageId: 'clone-issue.services.clone.show-flag.error.clone-failed',
            messageType: 'transactional',
            type: 'error',
            isAutoDismiss: false,
            title: [
                (0, $7hFxW.default).cloneFailedTitle,
                {
                    issueKey: issueKey
                }
            ],
            description: failedReason ? [
                (0, $7hFxW.default).cloneFailedWorkflow,
                {
                    failedReason: failedReason
                }
            ] : (0, $7hFxW.default).cloneStartFailed,
            actions: [
                {
                    onClick: onTryAgainClicked.current,
                    content: (0, $7hFxW.default).tryAgain
                }
            ]
        });
    }, [
        setCloneFetchStatus,
        dismissFlagIfNeeded,
        projectType,
        showFlag,
        issueKey,
        appEditions
    ]);
    const [workType] = (0, $koiRX.useIssueTypeName)();
    const showVagueSuccessFlag = (0, $5uXOq.useCallback)(()=>{
        // Clone was successful but we somehow lost the result or don't have the cloned issue key
        flagId.current = showFlag({
            messageId: 'clone-issue.services.clone.show-flag.success.clone-success',
            messageType: 'transactional',
            type: 'success',
            isAutoDismiss: true,
            title: [
                workType && (0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false) ? (0, $7hFxW.default).cloneSuccessTitleIssueTerminologyRefreshM4 : (0, $7hFxW.default).cloneSuccessTitle,
                {
                    workType: workType,
                    issueKey: issueKey
                }
            ],
            description: [
                (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $7hFxW.default).cloneSuccessButLostResultDescriptionIssueTermRefresh : (0, $7hFxW.default).cloneSuccessButLostResultDescription,
                {
                    oldIssueKey: issueKey
                }
            ],
            actions: [
                {
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    onClick: ()=>window.open($e9ee8f289c652c3e$var$getYourWorkUrl(), '_blank'),
                    content: (0, $7hFxW.default).goToYourWork
                }
            ]
        });
    }, [
        issueKey,
        showFlag,
        workType
    ]);
    const onSuccess = (0, $5uXOq.useCallback)((result)=>{
        dismissFlagIfNeeded();
        (0, $gXz4p.sendExperienceAnalytics)((0, $1GpXU.cloneIssueExperienceDescription)(true, 'CLONE', 'clone-issue', projectType, appEditions));
        if (!result || typeof result === 'string') {
            showVagueSuccessFlag();
            return;
        }
        fetch($e9ee8f289c652c3e$var$getIssueKeyUrl(result.issueId), {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((response)=>{
            if (!response.ok) {
                const traceId = (0, $4R6GH.fg)('thor_add_missing_attributes_across_issue_view_1') ? response.headers.get('Atl-Traceid') || undefined : undefined;
                throw new (0, $jJZqs.default)(response.status, response.statusText, traceId);
            }
            return response.json();
        }).then(({ key: clonedKey })=>{
            const getSuccessFlagDescription = ()=>{
                if (workType && (0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return (0, $7hFxW.default).cloneSuccessDescriptionIssueTerminologyRefreshM4;
                if ((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3')) return (0, $7hFxW.default).cloneSuccessDescriptionIssueTermRefresh;
                return (0, $7hFxW.default).cloneSuccessDescription;
            };
            const getSuccessFlagAction = ()=>{
                if (workType && (0, $64qgp.isWorkTypeAvgLength)(workType) && (0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return (0, $7hFxW.default).cloneSuccessLinkIssueTerminologyRefreshM4;
                if ((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3')) return (0, $7hFxW.default).cloneSuccessLinkIssueTermRefresh;
                return (0, $7hFxW.default).cloneSuccessLink;
            };
            const clonedIssueLink = `/browse/${clonedKey}`;
            flagId.current = showFlag({
                messageId: 'clone-issue.services.clone.show-flag.success.clone-success.1',
                messageType: 'transactional',
                type: 'success',
                isAutoDismiss: false,
                title: [
                    workType && (0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false) ? (0, $7hFxW.default).cloneSuccessTitleIssueTerminologyRefreshM4 : (0, $7hFxW.default).cloneSuccessTitle,
                    {
                        workType: workType,
                        issueKey: issueKey
                    }
                ],
                description: [
                    getSuccessFlagDescription(),
                    {
                        clonedIssueKey: clonedKey,
                        oldIssueKey: issueKey,
                        workType: workType
                    }
                ],
                actions: [
                    {
                        onClick: ()=>{
                            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                            window.open(clonedIssueLink, '_blank');
                            dismissFlagIfNeeded();
                        },
                        content: [
                            getSuccessFlagAction(),
                            {
                                workType: workType
                            }
                        ]
                    }
                ]
            });
        }).catch(()=>{
            showVagueSuccessFlag();
        });
    }, [
        dismissFlagIfNeeded,
        issueKey,
        projectType,
        showFlag,
        showVagueSuccessFlag,
        appEditions,
        workType
    ]);
    const pollProgressAfterMs = (0, $5uXOq.useCallback)((delayMs)=>{
        const progressUrl = $e9ee8f289c652c3e$var$getCloneProgressUrl(progressTaskId.current);
        setTimeout(()=>{
            fetch(progressUrl, {
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then((response)=>{
                if (!response.ok) {
                    const traceId = (0, $4R6GH.fg)('thor_add_missing_attributes_across_issue_view_1') ? response.headers.get('Atl-Traceid') || undefined : undefined;
                    throw new (0, $jJZqs.default)(response.status, response.statusText, traceId);
                }
                return response.json();
            }).then((json)=>{
                const { status: status, message: message, result: result } = json;
                setCloneFetchStatus(status);
                if ((0, $7EJw7.cloneStatusIsInProgress)(status)) pollProgressAfterMs(Math.min(delayMs + 2000, 10000));
                else if ((0, $7EJw7.cloneStatusIsComplete)(status)) onSuccess(result);
                else if ((0, $7EJw7.cloneStatusIsFailed)(status) || (0, $7EJw7.cloneStatusIsCancelled)(status)) onFailure('CLONE', `${status || 'NO_STATUS'}: ${message}`, 200, typeof result === 'string' ? result : undefined);
            }).catch((error)=>{
                onFailure('FETCH', error.message, error.statusCode, undefined, error.traceId);
            });
        }, delayMs);
    }, [
        onFailure,
        onSuccess,
        setCloneFetchStatus
    ]);
    const makeCloneRequest = (0, $5uXOq.useCallback)(async (payload)=>{
        setCloneFetchStatus((0, $7EJw7.CloneStatus).ENQUEUED);
        dismissFlagIfNeeded();
        // Saved for retries if needed
        payloadRef.current = payload;
        flagId.current = showFlag({
            messageId: 'clone-issue.services.clone.show-flag.info.clone-start',
            messageType: 'transactional',
            type: 'info',
            isAutoDismiss: true,
            title: [
                (0, $7hFxW.default).cloneStartTitle,
                {
                    issueKey: issueKey
                }
            ],
            description: [
                (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $7hFxW.default).cloneStartDescriptionIssueTermRefresh : (0, $7hFxW.default).cloneStartDescription,
                {
                    issueKey: issueKey
                }
            ]
        });
        /**
     * issueId does not exist in the previous payload. Hence, using this to differentiate between the old and new clone call.
     */ if (payload?.issueId && (0, $6s1PB.expVal)('enhance-clone-issue-capability-jracloud-5052-ga', 'enhancedIssueCloneEnabled', false)) {
            const optionalFields = Object.keys(payload.optionalFields ?? {})?.map((key)=>({
                    fieldId: key,
                    shouldClone: payload.optionalFields?.[key] ?? false
                }));
            commit({
                variables: {
                    input: {
                        issueId: `ari:cloud:jira:${cloudId}:issue/${payload.issueId}`,
                        summary: payload?.summary,
                        includeAttachments: payload?.includeAttachments ?? false,
                        includeLinks: payload?.includeLinks ?? false,
                        includeComments: payload?.includeComments ?? false,
                        includeSubtasksOrChildren: payload?.includeSubtasksOrChildren ?? false,
                        ...(0, $4R6GH.fg)('jira-clone-epic-child-issues-and-subtasks') ? {
                            includeChildrenWithSubtasks: payload?.includeChildrenWithSubtasks ?? false
                        } : {},
                        assignee: payload?.assignee,
                        reporter: payload?.reporter,
                        optionalFields: optionalFields
                    }
                },
                onCompleted: (response)=>{
                    if (response?.jira?.cloneIssue?.errors && response.jira.cloneIssue.errors.length > 0) {
                        const errors = response.jira.cloneIssue.errors;
                        const error = errors[0];
                        onFailure('CLONE', error.message ?? 'No error returned', error.extensions?.statusCode ?? 0);
                        return;
                    }
                    progressTaskId.current = response?.jira?.cloneIssue?.taskId ?? '';
                    pollProgressAfterMs(1000);
                },
                onError: (error)=>{
                    let statusCode = 0;
                    if (error instanceof (0, $jJZqs.default)) statusCode = error.statusCode;
                    onFailure('CLONE', error.message, statusCode);
                }
            });
        } else fetch(cloneUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        }).then((response)=>{
            if (!response.ok) {
                const traceId = (0, $4R6GH.fg)('thor_add_missing_attributes_across_issue_view_1') ? response.headers.get('Atl-Traceid') || undefined : undefined;
                throw new (0, $jJZqs.default)(response.status, response.statusText, traceId);
            }
            return response.json();
        }).then((json)=>{
            const { status: status, taskId: taskId } = json;
            // Failure on initiation is very unlikely
            if ((0, $7EJw7.cloneStatusIsFailed)(status) || !taskId) throw new Error(`Clone task (ID: ${taskId}) failed on initiation with status: ${status || 'null'}`);
            progressTaskId.current = taskId;
            pollProgressAfterMs(1000);
        }).catch((error)=>{
            onFailure('CLONE', error.message, error.statusCode, undefined, error.traceId);
        });
    }, [
        setCloneFetchStatus,
        dismissFlagIfNeeded,
        showFlag,
        issueKey,
        cloneUrl,
        pollProgressAfterMs,
        onFailure,
        commit,
        cloudId
    ]);
    onTryAgainClicked.current = (0, $5uXOq.useCallback)(()=>{
        const payload = payloadRef.current || {};
        makeCloneRequest(payload);
    }, [
        makeCloneRequest
    ]);
    return [
        cloneFetchStatus,
        makeCloneRequest
    ];
};

});
parcelRegister("alF9a", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2949eaec2540442$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<da1463290e86a01242e846443d4243e7>>
 * @relayHash 2338b790df7ebc66fe2543fb4c270170
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a5881abf38b02300f367b288249bcf7115bf7b130ca999a33676b1422ffdbc7f
const $c2949eaec2540442$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "taskId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "taskStatus"
    }, v8 = {
        "kind": "ScalarField",
        "name": "taskDescription"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "cloneIssueMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraCloneIssueResponse",
                            "kind": "LinkedField",
                            "name": "cloneIssue",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "cloneIssueMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraCloneIssueResponse",
                            "kind": "LinkedField",
                            "name": "cloneIssue",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a5881abf38b02300f367b288249bcf7115bf7b130ca999a33676b1422ffdbc7f",
            "metadata": {},
            "name": "cloneIssueMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$c2949eaec2540442$var$node.hash = "bcc3082af70fed04b401430419a8fc63";
var $c2949eaec2540442$export$2e2bcd8739ae039 = $c2949eaec2540442$var$node;

});

parcelRegister("gXz4p", function(module, exports) {

$parcel$export(module.exports, "sendExperienceAnalytics", () => $b28eb6b892a8c2f7$export$4a95ada1b8228562);

var $1UikQ = parcelRequire("1UikQ");

var $gSA3s = parcelRequire("gSA3s");

var $hh0bW = parcelRequire("hh0bW");

var $j8DrX = parcelRequire("j8DrX");

var $4R6GH = parcelRequire("4R6GH");
const $b28eb6b892a8c2f7$var$isSynthetic = ()=>(0, $j8DrX.default)('ajs-is-synthetic') === 'true';
const $b28eb6b892a8c2f7$var$shouldAddConnectivityAttribute = (experienceDescription)=>{
    // Return false if feature flag is off
    if (!(0, $4R6GH.fg)('thor_refine_taskfail_offline_failed_events')) return false;
    // Return false if not a taskFail action
    if (experienceDescription.wasExperienceSuccesful) return false;
    const isKnownExperience = [
        'transitionIssue',
        'getTransitions',
        'startWatching',
        'stopWatching'
    ].includes(experienceDescription.experience);
    // Return false if not a known experience
    if (!isKnownExperience) return false;
    const hasStatusCode = !!experienceDescription.additionalAttributes?.statusCode;
    // Return false if status code is present
    return !hasStatusCode;
};
function $b28eb6b892a8c2f7$export$4a95ada1b8228562(experienceDescription) {
    const additionalContext = {};
    const shard = (0, $j8DrX.default)('ajs-shard');
    const region = (0, $j8DrX.default)('ajs-region');
    Object.assign(additionalContext, {
        shard: shard,
        region: region
    });
    const enabledFeatureFlags = Object.fromEntries([
        ...(0, $gSA3s.allFeatureFlagsAccessed)
    ].filter(([, value])=>value));
    Object.assign(additionalContext, {
        enabledFeatureFlags: enabledFeatureFlags
    });
    if ($b28eb6b892a8c2f7$var$shouldAddConnectivityAttribute(experienceDescription)) {
        const isOnline = typeof globalThis.window !== 'undefined' && globalThis.window?.navigator?.onLine;
        Object.assign(additionalContext, {
            isOnline: isOnline
        });
    }
    const synthetics = {
        additionalAttributes: {
            synthetic: $b28eb6b892a8c2f7$var$isSynthetic(),
            ...additionalContext
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(experienceDescription, synthetics);
    (0, $hh0bW.default)(experienceDescription);
}

});

parcelRegister("7EJw7", function(module, exports) {

$parcel$export(module.exports, "CloneStatus", () => $dfad5f02f36a9ef6$export$44ea4f4230515e14);
$parcel$export(module.exports, "cloneStatusIsFailed", () => $dfad5f02f36a9ef6$export$7c807819f8838495);
$parcel$export(module.exports, "cloneStatusIsCancelled", () => $dfad5f02f36a9ef6$export$c1692c1b24576a1c);
$parcel$export(module.exports, "cloneStatusIsComplete", () => $dfad5f02f36a9ef6$export$c37ed04c1f512796);
$parcel$export(module.exports, "cloneStatusIsInProgress", () => $dfad5f02f36a9ef6$export$ce5efaea28f8601d);
const $dfad5f02f36a9ef6$export$44ea4f4230515e14 = {
    ENQUEUED: 'ENQUEUED',
    RUNNING: 'RUNNING',
    COMPLETE: 'COMPLETE',
    FAILED: 'FAILED',
    CANCEL_REQUESTED: 'CANCEL_REQUESTED',
    CANCELLED: 'CANCELLED',
    DEAD: 'DEAD'
};
const $dfad5f02f36a9ef6$export$7c807819f8838495 = (status)=>{
    switch(status){
        case $dfad5f02f36a9ef6$export$44ea4f4230515e14.ENQUEUED:
        case $dfad5f02f36a9ef6$export$44ea4f4230515e14.RUNNING:
        case $dfad5f02f36a9ef6$export$44ea4f4230515e14.COMPLETE:
        case $dfad5f02f36a9ef6$export$44ea4f4230515e14.CANCEL_REQUESTED:
        case $dfad5f02f36a9ef6$export$44ea4f4230515e14.CANCELLED:
            return false;
        case $dfad5f02f36a9ef6$export$44ea4f4230515e14.FAILED:
        case $dfad5f02f36a9ef6$export$44ea4f4230515e14.DEAD:
        default:
            return true;
    }
};
const $dfad5f02f36a9ef6$export$c1692c1b24576a1c = (status)=>status === $dfad5f02f36a9ef6$export$44ea4f4230515e14.CANCELLED;
const $dfad5f02f36a9ef6$export$c37ed04c1f512796 = (status)=>status === $dfad5f02f36a9ef6$export$44ea4f4230515e14.COMPLETE;
const $dfad5f02f36a9ef6$export$ce5efaea28f8601d = (status)=>{
    switch(status){
        case $dfad5f02f36a9ef6$export$44ea4f4230515e14.ENQUEUED:
        case $dfad5f02f36a9ef6$export$44ea4f4230515e14.CANCEL_REQUESTED:
        case $dfad5f02f36a9ef6$export$44ea4f4230515e14.RUNNING:
            return true;
        default:
            return false;
    }
};

});

parcelRegister("1GpXU", function(module, exports) {

$parcel$export(module.exports, "cloneIssueExperienceDescription", () => $0654dd154b6ded25$export$f35e6f9d40f5647e);

var $4R6GH = parcelRequire("4R6GH");

var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");
const $0654dd154b6ded25$export$f35e6f9d40f5647e = (wasSuccessful, stage, analyticsSource, projectType, appEditions, errorMessage, statusCode, traceId)=>{
    let application = null;
    let edition = null;
    if (projectType !== null) try {
        application = (0, $efvDm.getApplicationForProject)(projectType);
        edition = (0, $ldyPw.getEdition)(application, appEditions);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // application and edition already default to null.
    }
    return {
        experience: 'cloneIssue',
        wasExperienceSuccesful: wasSuccessful,
        analyticsSource: analyticsSource,
        application: application,
        edition: edition,
        additionalAttributes: {
            stage: stage,
            ...errorMessage !== undefined && errorMessage !== null ? {
                errorMessage: errorMessage
            } : {},
            ...statusCode && (0, $4R6GH.fg)('thor_add_missing_attributes_across_issue_view_1') ? {
                statusCode: statusCode
            } : {},
            ...traceId && (0, $4R6GH.fg)('thor_add_missing_attributes_across_issue_view_1') ? {
                traceId: traceId
            } : {}
        }
    };
};

});

parcelRegister("7hFxW", function(module, exports) {

$parcel$export(module.exports, "default", () => $e600e726d7f34a86$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e600e726d7f34a86$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    cloneFailedTitle: {
        "id": "clone-issue.services.clone-failed-title",
        "defaultMessage": "We couldn't clone {issueKey}"
    },
    cloneStartFailed: {
        "id": "clone-issue.services.clone-start-failed",
        "defaultMessage": "Check your connection and then try again."
    },
    cloneFailedWorkflow: {
        "id": "clone-issue.services.clone-failed-workflow",
        "defaultMessage": "{failedReason}"
    },
    tryAgain: {
        "id": "clone-issue.services.try-again",
        "defaultMessage": "Try again"
    },
    cloneStartTitle: {
        "id": "clone-issue.services.clone-start-title",
        "defaultMessage": "Cloning {issueKey}"
    },
    cloneStartDescription: {
        "id": "clone-issue.services.clone-start-description",
        "defaultMessage": "When cloning is complete, the cloned issue will be linked to {issueKey} and you'll receive another pop-up here just like this one."
    },
    cloneSuccessTitle: {
        "id": "clone-issue.services.clone-success-title",
        "defaultMessage": "Cloning complete"
    },
    cloneSuccessLink: {
        "id": "clone-issue.services.clone-success-link",
        "defaultMessage": "Open cloned issue"
    },
    cloneSuccessDescription: {
        "id": "clone-issue.services.clone-success-description",
        "defaultMessage": "You can find the cloned issue {clonedIssueKey} linked to {oldIssueKey} or by clicking the link below."
    },
    cloneSuccessButLostResultDescription: {
        "id": "clone-issue.services.clone-success-but-lost-result-description",
        "defaultMessage": "You can find the cloned issue linked to {oldIssueKey} or by opening it from Your work."
    },
    goToYourWork: {
        "id": "clone-issue.services.go-to-your-work",
        "defaultMessage": "Go to 'Your work'"
    },
    cloneStartDescriptionIssueTermRefresh: {
        "id": "clone-issue.services.clone-start-description-issue-term-refresh",
        "defaultMessage": "When cloning is complete, the cloned work item will be linked to {issueKey} and you'll receive another pop-up here just like this one."
    },
    cloneSuccessLinkIssueTermRefresh: {
        "id": "clone-issue.services.clone-success-link-issue-term-refresh",
        "defaultMessage": "Open cloned work item"
    },
    cloneSuccessDescriptionIssueTermRefresh: {
        "id": "clone-issue.services.clone-success-description-issue-term-refresh",
        "defaultMessage": "You can find the cloned work item {clonedIssueKey} linked to {oldIssueKey} or by clicking the link below."
    },
    cloneSuccessButLostResultDescriptionIssueTermRefresh: {
        "id": "clone-issue.services.clone-success-but-lost-result-description-issue-term-refresh",
        "defaultMessage": "You can find the cloned work item linked to {oldIssueKey} or by opening it from Your work."
    },
    cloneSuccessTitleIssueTerminologyRefreshM4: {
        "id": "clone-issue.services.clone-success-title-issue-terminology-refresh-m4",
        "defaultMessage": "{workType} {issueKey} cloned"
    },
    cloneSuccessLinkIssueTerminologyRefreshM4: {
        "id": "clone-issue.services.clone-success-link-issue-terminology-refresh-m4",
        "defaultMessage": "View cloned {workType}"
    },
    cloneSuccessDescriptionIssueTerminologyRefreshM4: {
        "id": "clone-issue.services.clone-success-description-issue-terminology-refresh-m4",
        "defaultMessage": "This {workType} is linked to {clonedIssueKey}. Please translate as \u201Cwork type {workType}\u201D"
    }
});

});

parcelRegister("dMdDY", function(module, exports) {

$parcel$export(module.exports, "useCloneStatus", () => $2ece5f1150cbf7c4$export$956a07703075dbac);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");

var $gMecq = parcelRequire("gMecq");
const $2ece5f1150cbf7c4$var$getCloneStatus = (state)=>state.cloneFetchStatus;
const $2ece5f1150cbf7c4$export$956a07703075dbac = (0, $3sQ5x.createHook)((0, $gMecq.store), {
    selector: $2ece5f1150cbf7c4$var$getCloneStatus
});

});
parcelRegister("gMecq", function(module, exports) {

$parcel$export(module.exports, "store", () => $bb7b52dfd424c119$export$6f57813fe9f31bf9);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iXqE5 = parcelRequire("iXqE5");

var $4Xm86 = parcelRequire("4Xm86");
const $bb7b52dfd424c119$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'issue-clone',
    initialState: {
        canModifyReporter: true,
        cloneFetchStatus: null
    },
    actions: $4Xm86
});

});
parcelRegister("4Xm86", function(module, exports) {

$parcel$export(module.exports, "setCloneFetchStatus", () => (parcelRequire("bGZsq")).setCloneFetchStatus);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $bGZsq = parcelRequire("bGZsq");

});
parcelRegister("bGZsq", function(module, exports) {

$parcel$export(module.exports, "setCloneFetchStatus", () => $5be5ce0212d36e0a$export$354b4b5426518f74);
const $5be5ce0212d36e0a$export$354b4b5426518f74 = (cloneFetchStatus)=>({ setState: setState })=>{
        setState({
            cloneFetchStatus: cloneFetchStatus
        });
    };

});





parcelRegister("8l12q", function(module, exports) {

$parcel$export(module.exports, "asyncIssueCloneModalEntryPoint", () => $a1396a6eb1234278$export$c1f75d3cbc44ebc);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $a1396a6eb1234278$export$c1f75d3cbc44ebc = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("5tHRd")).then(({ AsyncCloneModal: AsyncCloneModal })=>AsyncCloneModal), {
        moduleId: "07604322"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("5tHRd", function(module, exports) {

let $3fd1ae58e1dad643$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $3fd1ae58e1dad643$var$load("kNFvF"),
    $3fd1ae58e1dad643$var$load("ffQaD"),
    $3fd1ae58e1dad643$var$load("kvRbA"),
    $3fd1ae58e1dad643$var$load("ad2ge")
]).then(()=>parcelRequire('fsX0a'));

});


parcelRegister("byRc1", function(module, exports) {

$parcel$export(module.exports, "ContextMenuItemButton", () => $e9c66628c383ba02$export$c41377fb9346496d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $3uzfU = parcelRequire("3uzfU");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $2OMDV = parcelRequire("2OMDV");

var $7D59a = parcelRequire("7D59a");

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $e9c66628c383ba02$var$ContextMenuItemButtonAnalyticsWrapper = (0, $2OMDV.AnalyticsEventToProps)('dropdownItem', {
    onClick: 'clicked'
})(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ createAnalyticsEvent: createAnalyticsEvent, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e9c66628c383ba02$var$StyledContextMenuItemButton, {
        ...props,
        ref: ref
    })));
const $e9c66628c383ba02$export$90c1cb250e648e1f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ menuItem: menuItem, hasChildren: hasChildren }, ref)=>{
    const getContextMenuLabel = ()=>{
        const menuItemLabel = typeof menuItem.label === 'string' ? menuItem.label : menuItem.label();
        if (menuItem.elemAfterLabel) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            alignItems: "center",
            as: "span",
            ref: ref,
            testId: (0, $d9cdb1c71f9dbf8c$export$ae734f89618d3c5f),
            xcss: $e9c66628c383ba02$var$menuItemLabelWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            maxLines: 1
        }, menuItemLabel), menuItem.elemAfterLabel);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e9c66628c383ba02$var$ContextMenuLabel, {
            ref: ref,
            "data-testid": (0, $d9cdb1c71f9dbf8c$export$ae734f89618d3c5f)
        }, menuItemLabel);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, menuItem.icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e9c66628c383ba02$var$contextMenuIconStyles
    }, menuItem.icon), getContextMenuLabel(), hasChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3uzfU))), {
        spacing: "spacious",
        label: "",
        testId: (0, $d9cdb1c71f9dbf8c$export$ef86d72244e00c00)
    }));
});
const $e9c66628c383ba02$export$7387ff9c7ca7b0ae = ()=>(0, $5uXOq.useRef)(null);
const $e9c66628c383ba02$export$c41377fb9346496d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ menuItem: menuItem, isOpen: isOpen, onMouseEnter: onMouseEnter, onClick: onClick, hasChildren: hasChildren, onOpenWithKeyboard: onOpenWithKeyboard }, ref)=>{
    const [hasEllipsis, setHasEllipsis] = (0, $5uXOq.useState)(false);
    const labelRef = $e9c66628c383ba02$export$7387ff9c7ca7b0ae();
    const onMouseEnterHandler = (0, $7D59a.useEvent)(()=>onMouseEnter && onMouseEnter(menuItem));
    const onHandleClick = (0, $7D59a.useEvent)((e, analyticsEvent)=>{
        e.preventDefault();
        e.stopPropagation();
        if (e.detail === 0) onOpenWithKeyboard?.();
        onClick(menuItem, analyticsEvent);
    });
    const onHandleKeyDown = (0, $7D59a.useEvent)((e)=>{
        if (e.key === 'Enter') e.stopPropagation();
    });
    (0, $5uXOq.useEffect)(()=>{
        if (labelRef.current) {
            const isContentOverflowing = labelRef.current.scrollWidth > labelRef.current.clientWidth;
            setHasEllipsis(isContentOverflowing);
        }
    }, [
        labelRef
    ]);
    const commonProps = {
        'data-testid': (0, $d9cdb1c71f9dbf8c$export$8e765acf3440e0b),
        ref: ref,
        isOpen: isOpen,
        onClick: onHandleClick,
        onMouseEnter: onMouseEnterHandler,
        onKeyDown: onHandleKeyDown
    };
    return hasEllipsis ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        testId: (0, $d9cdb1c71f9dbf8c$export$602eb83148423ac6),
        content: typeof menuItem.label === 'string' ? menuItem.label : menuItem.label()
    }, ({ ref: tooltipRef, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e9c66628c383ba02$var$ContextMenuItemButtonAnalyticsWrapper, {
            ...rest,
            ...commonProps,
            ...hasChildren && {
                'aria-expanded': !!isOpen
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e9c66628c383ba02$export$90c1cb250e648e1f, {
            hasChildren: hasChildren,
            menuItem: menuItem,
            ref: (r)=>{
                labelRef.current = r;
                tooltipRef(r);
            }
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e9c66628c383ba02$var$ContextMenuItemButtonAnalyticsWrapper, {
        ...commonProps,
        ...hasChildren && {
            'aria-expanded': !!isOpen
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e9c66628c383ba02$export$90c1cb250e648e1f, {
        hasChildren: hasChildren,
        menuItem: menuItem,
        ref: labelRef
    }));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e9c66628c383ba02$var$StyledContextMenuItemButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isOpen: isOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19itglyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _zulp1b66 _1bsb1osq _y3gn1e5h _ca0qu2gc _u5f3v47k _n3tdu2gc _19bvv47k _1e0c1txw _1bah1h6o _4cvr1h6o _4t3izwfg _7ehiglyw _1bg41i6y",
            __cmplp.isOpen ? "_bfhkfg4m" : "_bfhk1kw7",
            __cmplp.isOpen ? "_syazaqb7" : "_syaz1fxt",
            __cmplp.isOpen ? "_irr3fg4m" : "_irr3166n",
            __cmplp.className
        ])
    });
});
const $e9c66628c383ba02$var$ContextMenuLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $e9c66628c383ba02$var$menuItemLabelWrapperStyles = (0, $8CUq3.xcss)({
    flex: 1,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $e9c66628c383ba02$var$contextMenuIconStyles = (0, $8CUq3.xcss)({
    paddingRight: 'space.100'
});

});


parcelRegister("18PeT", function(module, exports) {

$parcel$export(module.exports, "useCopyIssueKey", () => $d14c3528abbda418$export$e5e3fbcc29675793);

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $467lJ = parcelRequire("467lJ");
var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $1HF4Y = parcelRequire("1HF4Y");

var $9nlJl = parcelRequire("9nlJl");

var $5Mhvq = parcelRequire("5Mhvq");
const $d14c3528abbda418$export$e5e3fbcc29675793 = ({ issueKey: issueKey, selectedCardIds: selectedCardIds })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    if (selectedCardIds.length > 1) return [];
    const onCopyIssueKey = ()=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        ((0, $4R6GH.fg)('jfp-magma-undefined-navigator') ? globalThis.navigator.clipboard : navigator.clipboard).writeText(issueKey).then(()=>{
            showFlag({
                messageId: 'software-backlog.card-list.card.context-menu.menu-items.copy-issue-key.show-flag.success',
                messageType: 'transactional',
                type: 'success',
                title: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5Mhvq.default).copyIssueKeySuccessTitleIssueTermRefresh : (0, $5Mhvq.default).copyIssueKeySuccessTitle,
                description: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5Mhvq.default).copyIssueKeySuccessDescriptionIssueTermRefresh : (0, $5Mhvq.default).copyIssueKeySuccessDescription
            });
        }).catch(()=>{
            showFlag((0, $467lJ.default).genericError());
        });
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5Mhvq.default).copyIssueKeyIssueTermRefresh : (0, $5Mhvq.default).copyIssueKey),
            id: (0, $9nlJl.COPY_ISSUE_KEY_MENU_ID),
            onClick: onCopyIssueKey
        }
    ];
};

});

parcelRegister("hksaN", function(module, exports) {

$parcel$export(module.exports, "useCopyIssueLink", () => $24eaec907af0c229$export$8fa8485fafd17cef);

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $467lJ = parcelRequire("467lJ");
var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $1HF4Y = parcelRequire("1HF4Y");

var $9nlJl = parcelRequire("9nlJl");

var $5Mhvq = parcelRequire("5Mhvq");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");
const $24eaec907af0c229$export$9fd15e3f1d1c1c2a = (flagDescription)=>({
        messageId: 'software-backlog.card-list.card.context-menu.menu-items.copy-issue-link.flag.success.show-flag.success',
        messageType: 'transactional',
        type: 'success',
        title: (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $5Mhvq.default).copySuccessTitleIssueTermRefresh : (0, $5Mhvq.default).copySuccessTitle,
        description: flagDescription
    });
const $24eaec907af0c229$var$getFlagDescription = (formatMessage, cardType, issueKey)=>{
    if (cardType && (0, $6s1PB.expVal)('jira-itr-m4-exp-3', 'isEnabled', false)) return formatMessage((0, $5Mhvq.default).copySuccessMessageIssueTerminologyRefreshM4, {
        workType: cardType,
        key: issueKey
    });
    return formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5Mhvq.default).copySuccessMessageIssueTermRefresh : (0, $5Mhvq.default).copySuccessMessage);
};
const $24eaec907af0c229$export$30a9fe39fb33160d = ({ issueKey: issueKey, selectedCardIds: selectedCardIds })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const cards = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCards));
    const cardType = Object.values(cards).find((card)=>card.key === issueKey)?.issueTypeName;
    const flagDescription = $24eaec907af0c229$var$getFlagDescription(formatMessage, cardType, issueKey);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const issueUrl = `${window.location.protocol}//${window.location.hostname}/browse/${issueKey}`;
    if (selectedCardIds.length > 1) return [];
    const onCopyIssueLink = ()=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        ((0, $4R6GH.fg)('jfp-magma-undefined-navigator') ? globalThis.navigator.clipboard : navigator.clipboard).writeText(issueUrl).then(()=>{
            showFlag($24eaec907af0c229$export$9fd15e3f1d1c1c2a(flagDescription));
        }).catch(()=>{
            showFlag((0, $467lJ.default).genericError());
        });
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5Mhvq.default).copyIssueLinkIssueTermRefresh : (0, $5Mhvq.default).copyIssueLink),
            id: (0, $9nlJl.COPY_ISSUE_LINK_MENU_ID),
            onClick: onCopyIssueLink
        }
    ];
};
const $24eaec907af0c229$export$8fa8485fafd17cef = ({ issueKey: issueKey, selectedCardIds: selectedCardIds })=>$24eaec907af0c229$export$30a9fe39fb33160d({
        issueKey: issueKey,
        selectedCardIds: selectedCardIds
    });

});

parcelRegister("7MVky", function(module, exports) {

$parcel$export(module.exports, "useDeleteIssue", () => $c80f04e236a539e4$export$43383fdc9fe04fe6);

var $koVbs = parcelRequire("koVbs");

var $1HF4Y = parcelRequire("1HF4Y");


var $5Eoed = parcelRequire("5Eoed");

var $c1MAf = parcelRequire("c1MAf");

var $1z1J7 = parcelRequire("1z1J7");

var $9nlJl = parcelRequire("9nlJl");

var $5Mhvq = parcelRequire("5Mhvq");
const $c80f04e236a539e4$export$33577be3a49c7499 = ({ isDeleteEnabled: isDeleteEnabled, onDeleteIssue: onDeleteIssue, selectedCardIds: selectedCardIds })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!isDeleteEnabled || selectedCardIds.length > 1) return [];
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: formatMessage((0, $5Mhvq.default).delete),
            id: (0, $9nlJl.DELETE_ISSUE_MENU_ID),
            onClick: onDeleteIssue
        }
    ];
};
const $c80f04e236a539e4$export$43383fdc9fe04fe6 = ({ issueId: issueId, selectedCardIds: selectedCardIds })=>{
    const isDeleteEnabled = (0, $c1MAf.useBacklogSelector)((0, $1z1J7.canDeleteIssues));
    const onDeleteIssue = (0, $c1MAf.useBacklogActionCreator)(()=>(0, $5Eoed.openModal)({
            type: (0, $b107c54ec82f76f2$export$87c7cb14aa706e2d),
            payload: {
                cardId: issueId
            }
        }));
    return $c80f04e236a539e4$export$33577be3a49c7499({
        isDeleteEnabled: isDeleteEnabled,
        onDeleteIssue: onDeleteIssue,
        selectedCardIds: selectedCardIds
    });
};

});

parcelRegister("iTQ6G", function(module, exports) {

$parcel$export(module.exports, "useEstimate", () => $26c8abb2f6c88fa7$export$3c38ee13c0bb43f6);

var $5uXOq = parcelRequire("5uXOq");

var $aB8eX = parcelRequire("aB8eX");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $8ikZj = parcelRequire("8ikZj");

var $ctrpc = parcelRequire("ctrpc");

var $5fc53 = parcelRequire("5fc53");

var $2NMNM = parcelRequire("2NMNM");

var $1HF4Y = parcelRequire("1HF4Y");

var $gJl8A = parcelRequire("gJl8A");

var $guzeq = parcelRequire("guzeq");

var $3EtSK = parcelRequire("3EtSK");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $45Qwd = parcelRequire("45Qwd");

var $1z1J7 = parcelRequire("1z1J7");

var $9nlJl = parcelRequire("9nlJl");

var $5Mhvq = parcelRequire("5Mhvq");

var $cghR2 = parcelRequire("cghR2");

var $bdIhZ = parcelRequire("bdIhZ");
const $26c8abb2f6c88fa7$export$5fc1a8ac15e506ee = ({ onSubmit: onSubmit, onCancel: onCancel, selectedCardIds: selectedCardIds })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const createConfirmHandler = (0, $5uXOq.useCallback)((scope, closeMenu, analyticsEvent)=>(value)=>onSubmit({
                scope: scope,
                value: value,
                closeMenu: closeMenu,
                analyticsEvent: analyticsEvent
            }), [
        onSubmit
    ]);
    const createCancelHandler = (0, $5uXOq.useCallback)((scope, closeMenu, analyticsEvent)=>()=>onCancel({
                scope: scope,
                closeMenu: closeMenu,
                analyticsEvent: analyticsEvent
            }), [
        onCancel
    ]);
    const onMouseEnter = (0, $gJl8A.useContextStartAnalytics)({
        selectedCardIds: selectedCardIds ?? [],
        fieldType: (0, $8ikZj.FIELD_TYPE_MAP)[0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE],
        fieldKey: (0, $8ikZj.FIELD_TYPE_MAP)[0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE]
    });
    const storyPointNode = {
        type: (0, $1HF4Y.MenuNodeType).Node,
        id: (0, $9nlJl.STORY_POINTS_EDIT_MENU_ID),
        node: ({ scope: scope, closeMenu: closeMenu, analyticsEvent: analyticsEvent })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bdIhZ.AsyncStoryPointField), {
                onConfirm: createConfirmHandler(scope, closeMenu, analyticsEvent),
                onCancel: createCancelHandler(scope, closeMenu, analyticsEvent)
            })
    };
    const children = (0, $4R6GH.fg)('jfp_a11y_team_boards_list_markup_used_incorrectly') ? storyPointNode : [
        storyPointNode
    ];
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            id: (0, $9nlJl.STORY_POINTS_MENU_ID),
            label: formatMessage((0, $5Mhvq.default).storyPointEstimate),
            shouldOverflowChildren: true,
            submenuWidth: 86,
            children: children,
            ...(0, $4R6GH.fg)('one_event_rules_them_all_fg') && {
                onMouseEnter: onMouseEnter
            }
        }
    ];
};
const $26c8abb2f6c88fa7$export$14002335a55c84dc = ({ onSubmit: onSubmit, onCancel: onCancel, timeTrackingOptions: timeTrackingOptions, selectedCardIds: selectedCardIds })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const createConfirmHandler = (0, $5uXOq.useCallback)((scope, closeMenu, analyticsEvent)=>(estimate)=>onSubmit({
                scope: scope,
                estimate: estimate,
                closeMenu: closeMenu,
                analyticsEvent: analyticsEvent
            }), [
        onSubmit
    ]);
    const createCancelHandler = (0, $5uXOq.useCallback)((scope, closeMenu, analyticsEvent)=>()=>onCancel({
                scope: scope,
                closeMenu: closeMenu,
                analyticsEvent: analyticsEvent
            }), [
        onCancel
    ]);
    const onMouseEnter = (0, $gJl8A.useContextStartAnalytics)({
        selectedCardIds: selectedCardIds ?? [],
        fieldType: (0, $5fc53.TIME_ESTIMATE_TYPE),
        fieldKey: (0, $5fc53.TIME_ESTIMATE_TYPE)
    });
    if (!timeTrackingOptions) return [];
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            id: (0, $9nlJl.ORIGINAL_ESTIMATE_MENU_ID),
            label: formatMessage((0, $5Mhvq.default).originalEstimate),
            shouldOverflowChildren: true,
            submenuWidth: 126,
            children: [
                {
                    type: (0, $1HF4Y.MenuNodeType).Node,
                    id: (0, $9nlJl.ORIGINAL_ESTIMATE_EDIT_MENU_ID),
                    node: ({ scope: scope, closeMenu: closeMenu, analyticsEvent: analyticsEvent })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cghR2.AsyncOriginalEstimateField), {
                            onConfirm: createConfirmHandler(scope, closeMenu, analyticsEvent),
                            onCancel: createCancelHandler(scope, closeMenu, analyticsEvent),
                            timeTrackingOptions: timeTrackingOptions
                        })
                }
            ],
            ...(0, $4R6GH.fg)('one_event_rules_them_all_fg') && {
                onMouseEnter: onMouseEnter
            }
        }
    ];
};
const $26c8abb2f6c88fa7$export$3c38ee13c0bb43f6 = ({ selectedCardIds: selectedCardIds })=>{
    const estimationType = (0, $c1MAf.useBacklogSelector)((state)=>(0, $45Qwd.getEstimationType)(state));
    const timeTrackingOptions = (0, $c1MAf.useBacklogSelector)((state)=>(0, $jG5HW.getTimeTrackingOptions)(state));
    const estimationFieldId = (0, $c1MAf.useBacklogSelector)((0, $45Qwd.getEstimationFieldId));
    const getIssueKey = (0, $c1MAf.useBacklogSelector)((0, $dGljH.makeCardKeyFromCardId));
    const canBulkEdit = (0, $c1MAf.useBacklogSelector)((0, $1z1J7.canBulkEditIssues));
    const canEdit = (0, $c1MAf.useBacklogSelector)((0, $1z1J7.canEditIssue));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleCancel = (0, $5uXOq.useCallback)(({ closeMenu: closeMenu })=>{
        closeMenu();
    }, []);
    const handleSubmitStoryPoint = (0, $c1MAf.useBacklogActionCreator)(({ value: value, closeMenu: closeMenu, analyticsEvent: analyticsEvent })=>{
        closeMenu();
        if (selectedCardIds.length === 1 && (0, $4R6GH.fg)('one_event_rules_them_all_fg')) (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd((0, $8ikZj.FIELD_TYPE_MAP)[0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE], {
            analytics: createAnalyticsEvent({}),
            attributes: {
                fieldType: (0, $8ikZj.FIELD_TYPE_MAP)[0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE]
            }
        });
        const actions = selectedCardIds.map((id)=>(0, $3EtSK.cardEstimateSetOptimistic)({
                cardId: id,
                estimate: {
                    storyPoints: value
                }
            }, {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                estimationFieldId: estimationFieldId,
                issueKey: getIssueKey(id)
            }, analyticsEvent));
        return (0, $aB8eX.batchActions)(actions);
    });
    const handleSubmitOriginalEstimate = (0, $c1MAf.useBacklogActionCreator)(({ estimate: estimate, closeMenu: closeMenu, analyticsEvent: analyticsEvent })=>{
        closeMenu();
        if (selectedCardIds.length === 1 && (0, $4R6GH.fg)('one_event_rules_them_all_fg')) (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd((0, $5fc53.TIME_ESTIMATE_TYPE), {
            analytics: createAnalyticsEvent({}),
            attributes: {
                fieldType: (0, $5fc53.TIME_ESTIMATE_TYPE)
            }
        });
        const actions = selectedCardIds.map((id)=>(0, $3EtSK.cardEstimateSetOptimistic)({
                cardId: id,
                estimate: {
                    originalEstimate: {
                        value: estimate.value || 0,
                        valueAsText: estimate.valueAsText
                    }
                }
            }, {
                estimationFieldId: (0, $5fc53.TIME_TRACKING_TYPE),
                issueKey: getIssueKey(id)
            }, analyticsEvent));
        return (0, $aB8eX.batchActions)(actions);
    });
    const storyPointContent = $26c8abb2f6c88fa7$export$5fc1a8ac15e506ee({
        onSubmit: handleSubmitStoryPoint,
        onCancel: handleCancel,
        ...(0, $4R6GH.fg)('one_event_rules_them_all_fg') && {
            selectedCardIds: selectedCardIds
        }
    });
    const originalEstimateContent = $26c8abb2f6c88fa7$export$14002335a55c84dc({
        onSubmit: handleSubmitOriginalEstimate,
        onCancel: handleCancel,
        timeTrackingOptions: timeTrackingOptions,
        ...(0, $4R6GH.fg)('one_event_rules_them_all_fg') && {
            selectedCardIds: selectedCardIds
        }
    });
    const canEditEstimate = canBulkEdit && canEdit && !!estimationFieldId;
    if (canEditEstimate && estimationType === (0, $guzeq.STORY_POINTS)) return storyPointContent;
    if (canEditEstimate && estimationType === (0, $guzeq.ORIGINAL_ESTIMATE)) return originalEstimateContent;
    return [];
};

});
parcelRegister("cghR2", function(module, exports) {

$parcel$export(module.exports, "AsyncOriginalEstimateField", () => $755de874a30d79d8$export$46675481a7613e3e);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $755de874a30d79d8$var$OriginalEstimateFieldLazy = (0, $kxZPA.lazy)(()=>(parcelRequire("8kZxb")).then((module)=>module.OriginalEstimateField), {
    moduleId: "./src/packages/software/backlog/src/view/card-list/card/context-menu/menu-items/estimate/original-estimate-field/view.tsx"
});
const $755de874a30d79d8$export$46675481a7613e3e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "bulkops-original-estimate-field",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($755de874a30d79d8$var$OriginalEstimateFieldLazy, props));

});
parcelRegister("8kZxb", function(module, exports) {

let $611fec66304bb163$var$load = (parcelRequire("28QjX"))(4);
module.exports = $611fec66304bb163$var$load("iA5oj").then(()=>parcelRequire('7Kfhk'));

});


parcelRegister("bdIhZ", function(module, exports) {

$parcel$export(module.exports, "AsyncStoryPointField", () => $e8be4e1cdb48e2bd$export$91cc9e87752d0bf8);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $e8be4e1cdb48e2bd$var$StoryPointFieldLazy = (0, $kxZPA.lazy)(()=>(parcelRequire("2oQUK")).then((module)=>module.StoryPointField), {
    moduleId: "./src/packages/software/backlog/src/view/card-list/card/context-menu/menu-items/estimate/story-point-field/view.tsx"
});
const $e8be4e1cdb48e2bd$export$91cc9e87752d0bf8 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "bulkops-story-point-field",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e8be4e1cdb48e2bd$var$StoryPointFieldLazy, props));

});
parcelRegister("2oQUK", function(module, exports) {

let $1bf6de5bb555fb98$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1bf6de5bb555fb98$var$load("4amkp").then(()=>parcelRequire('kG3wv'));

});



parcelRegister("1otSd", function(module, exports) {

$parcel$export(module.exports, "useFlag", () => $effa488c9b5feb05$export$983b9b54330812cb);

var $5uXOq = parcelRequire("5uXOq");

var $arE9H = parcelRequire("arE9H");

var $9ADwJ = parcelRequire("9ADwJ");

var $jQ66g = parcelRequire("jQ66g");

var $iyN9w = parcelRequire("iyN9w");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $8ikZj = parcelRequire("8ikZj");

var $ctrpc = parcelRequire("ctrpc");

var $5fc53 = parcelRequire("5fc53");

var $2NMNM = parcelRequire("2NMNM");

var $a4GLz = parcelRequire("a4GLz");

var $1HF4Y = parcelRequire("1HF4Y");


var $5Eoed = parcelRequire("5Eoed");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");

var $1z1J7 = parcelRequire("1z1J7");

var $9nlJl = parcelRequire("9nlJl");

var $5Mhvq = parcelRequire("5Mhvq");

var $ihygG = parcelRequire("ihygG");
const $effa488c9b5feb05$export$81c94ca566d6fb97 = ({ cardIds: cardIds })=>{
    const cards = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCards));
    const flaggedStates = cardIds.map((cardId)=>cards[cardId]?.isFlagged);
    if (flaggedStates.every((isFlagged)=>isFlagged)) return (0, $ihygG.SelectedIssueFlaggedState).ALL_FLAGGED;
    if (flaggedStates.every((isFlagged)=>!isFlagged)) return (0, $ihygG.SelectedIssueFlaggedState).NONE_FLAGGED;
    return (0, $ihygG.SelectedIssueFlaggedState).INDETERMINATE;
};
const $effa488c9b5feb05$export$64037f4178ea2950 = ({ selectedIssuesFlaggedState: selectedIssuesFlaggedState, onToggleFlag: onToggleFlag, canFlag: canFlag })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!canFlag) return [];
    const addFlag = {
        type: (0, $1HF4Y.MenuNodeType).Item,
        id: (0, $9nlJl.FLAG_ADD_FLAG_MENU_ID),
        label: formatMessage((0, $5Mhvq.default).addFlag),
        onClick: ()=>onToggleFlag(true)
    };
    const removeFlag = {
        type: (0, $1HF4Y.MenuNodeType).Item,
        id: (0, $9nlJl.FLAG_REMOVE_FLAG_MENU_ID),
        label: formatMessage((0, $5Mhvq.default).removeFlag),
        onClick: ()=>onToggleFlag(false)
    };
    switch(selectedIssuesFlaggedState){
        case (0, $ihygG.SelectedIssueFlaggedState).NONE_FLAGGED:
            return [
                addFlag
            ];
        case (0, $ihygG.SelectedIssueFlaggedState).ALL_FLAGGED:
            return [
                removeFlag
            ];
        case (0, $ihygG.SelectedIssueFlaggedState).INDETERMINATE:
        default:
            return [
                {
                    type: (0, $1HF4Y.MenuNodeType).Item,
                    label: formatMessage((0, $5Mhvq.default).flag),
                    id: (0, $9nlJl.FLAG_MENU_ID),
                    children: [
                        {
                            ...addFlag,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9ADwJ))), {
                                label: formatMessage((0, $5Mhvq.default).addFlag),
                                color: "var(--ds-icon-danger, #C9372C)",
                                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($iyN9w))),
                                LEGACY_primaryColor: "var(--ds-icon-danger, #C9372C)"
                            })
                        },
                        {
                            ...removeFlag,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($arE9H))), {
                                label: formatMessage((0, $5Mhvq.default).removeFlag),
                                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jQ66g))),
                                color: "var(--ds-icon, #44546F)"
                            })
                        }
                    ]
                }
            ];
    }
};
const $effa488c9b5feb05$export$983b9b54330812cb = ({ cardIds: cardIds })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const selectedCardsForFlagWithCommentModal = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.cardsForFlagWithCommentModalFromCardIdsSelector)(state)(cardIds));
    const onToggleFlag = (0, $c1MAf.useBacklogActionCreator)((flag)=>{
        if (cardIds.length === 1 && (0, $4R6GH.fg)('one_event_rules_them_all_fg')) (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsStart((0, $8ikZj.FIELD_TYPE_MAP)[0, $5fc53.FLAGGED_CF_TYPE], {
            analytics: createAnalyticsEvent({}),
            attributes: {
                fieldType: (0, $5fc53.FLAGGED_CF_TYPE),
                isContextMenuEditing: true,
                ...(0, $4R6GH.fg)('one_event_improvements_1') && {
                    issueId: Number(cardIds[0])
                }
            }
        });
        return (0, $5Eoed.openModal)({
            type: (0, $b107c54ec82f76f2$export$34f52cb2089ddc40),
            payload: {
                flagAction: flag ? (0, $a4GLz.ADD) : (0, $a4GLz.REMOVE),
                cards: selectedCardsForFlagWithCommentModal
            }
        });
    });
    const canFlag = (0, $c1MAf.useBacklogSelector)((0, $1z1J7.canEditIssue));
    const selectedIssuesFlaggedState = $effa488c9b5feb05$export$81c94ca566d6fb97({
        cardIds: cardIds
    });
    return $effa488c9b5feb05$export$64037f4178ea2950({
        selectedIssuesFlaggedState: selectedIssuesFlaggedState,
        onToggleFlag: onToggleFlag,
        canFlag: canFlag
    });
};

});
parcelRegister("arE9H", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::16a72127bfc0e3d91a970ca1d9129c37>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $79ab9304c84464c1$var$_react = $79ab9304c84464c1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $79ab9304c84464c1$var$_baseNew = $79ab9304c84464c1$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $79ab9304c84464c1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Flag".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: flags in Editor, feature flags.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $79ab9304c84464c1$var$FlagIcon = (props)=>/*#__PURE__*/ $79ab9304c84464c1$var$_react.default.createElement($79ab9304c84464c1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.22 1.22A.75.75 0 0 1 2.75 1H14a.75.75 0 0 1 .6 1.2l-2.662 3.55L14.6 9.3a.75.75 0 0 1-.6 1.2H3.5V15H2V1.75a.75.75 0 0 1 .22-.53M3.5 9h9l-2.1-2.8a.75.75 0 0 1 0-.9l2.1-2.8h-9z" clip-rule="evenodd"/>`
    }, props));
$79ab9304c84464c1$var$FlagIcon.displayName = 'FlagIcon';
var $79ab9304c84464c1$var$_default = module.exports.default = $79ab9304c84464c1$var$FlagIcon;

});

parcelRegister("jQ66g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e7179b016029ea03$var$_react = $e7179b016029ea03$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $e7179b016029ea03$var$_flag = $e7179b016029ea03$var$_interopRequireDefault((parcelRequire("arE9H")));
function $e7179b016029ea03$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e7179b016029ea03$var$EmojiFlagsIcon = (props)=>/*#__PURE__*/ $e7179b016029ea03$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 12.235v6.446c0 .537.45.977 1 .977s1-.44 1-.977v-5.778c1.17-.341 2.389-.045 3.768.29.982.238 2.036.495 3.13.495a5.7 5.7 0 0 0 2.547-.567 1 1 0 0 0 .563-.9V5.466a.998.998 0 0 0-1.437-.9c-1.345.654-2.731.317-4.331-.071-1.729-.42-3.687-.895-5.678.072A1 1 0 0 0 6 5.466zm3.111-1.48c1.094 0 2.148.256 3.129.495 1.381.335 2.6.63 3.768.289V6.836c-1.488.27-2.93-.08-4.24-.398-1.379-.335-2.598-.632-3.768-.29v4.704a6 6 0 0 1 1.111-.097"/></svg>`
    }, props, {
        newIcon: $e7179b016029ea03$var$_flag.default
    }));
$e7179b016029ea03$var$EmojiFlagsIcon.displayName = 'EmojiFlagsIcon';
var $e7179b016029ea03$var$_default = module.exports.default = $e7179b016029ea03$var$EmojiFlagsIcon;

});

parcelRegister("ihygG", function(module, exports) {

$parcel$export(module.exports, "SelectedIssueFlaggedState", () => $7c17b5e67a95d552$export$c7c32a893388b4e4);
const $7c17b5e67a95d552$export$c7c32a893388b4e4 = {
    ALL_FLAGGED: 'ALL_FLAGGED',
    NONE_FLAGGED: 'NONE_FLAGGED',
    INDETERMINATE: 'INDETERMINATE'
};

});


parcelRegister("bEQvq", function(module, exports) {

$parcel$export(module.exports, "useGoToBulkEditor", () => $0606d669d77f5fea$export$ef32b88fc4df461d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ggICg = parcelRequire("ggICg");

var $17Ngn = parcelRequire("17Ngn");

var $koVbs = parcelRequire("koVbs");

var $1HF4Y = parcelRequire("1HF4Y");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");

var $1z1J7 = parcelRequire("1z1J7");

var $9nlJl = parcelRequire("9nlJl");

var $5Mhvq = parcelRequire("5Mhvq");
const $0606d669d77f5fea$export$f62a4789211eedd7 = ({ onGoToBulkEditor: onGoToBulkEditor })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0606d669d77f5fea$var$LabelWrapper, null, formatMessage((0, $5Mhvq.default).bulkChange), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0606d669d77f5fea$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ggICg))), {
                    label: formatMessage((0, $5Mhvq.default).goToBulkEditorIconLabel),
                    color: "var(--ds-icon, #44546F)",
                    LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($17Ngn))),
                    LEGACY_primaryColor: "var(--ds-icon, #44546F)",
                    LEGACY_size: "small"
                }))),
            id: (0, $9nlJl.GO_TO_BULK_EDITOR_MENU_ID),
            onClick: onGoToBulkEditor
        }
    ];
};
const $0606d669d77f5fea$export$ef32b88fc4df461d = ({ selectedCardIds: selectedCardIds })=>{
    const cardEntities = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCards));
    const canBulkEdit = (0, $c1MAf.useBacklogSelector)((0, $1z1J7.canBulkEditIssues));
    const isGoToBulkEditorVisible = canBulkEdit && selectedCardIds.length > 1;
    const handleOnGoToBulkEditor = ()=>{
        const issueKeys = selectedCardIds.map((id)=>cardEntities[String(id)].key);
        const url = `/secure/GHBulkChange.jspa?issueKeys=${encodeURIComponent(issueKeys.join(','))}`; // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.open(url, '_blank');
    };
    const bulkEditorContent = $0606d669d77f5fea$export$f62a4789211eedd7({
        onGoToBulkEditor: handleOnGoToBulkEditor
    });
    return isGoToBulkEditorVisible ? bulkEditorContent : [];
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0606d669d77f5fea$var$LabelWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1b66 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0606d669d77f5fea$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _154iv77o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("4AddN", function(module, exports) {

$parcel$export(module.exports, "useHeader", () => $45ea26ac19b6fc69$export$ae602290ebd82f8e);

var $1HF4Y = parcelRequire("1HF4Y");

var $9nlJl = parcelRequire("9nlJl");

var $ekjae = parcelRequire("ekjae");
const $45ea26ac19b6fc69$export$ae602290ebd82f8e = ({ selectedCardIds: selectedCardIds })=>{
    const separator = (0, $ekjae.createSeparator)((0, $9nlJl.HEADER_BULK_INDICATOR_MENU_ID));
    return selectedCardIds?.length > 1 ? [
        {
            id: (0, $9nlJl.HEADER_BULK_INDICATOR_MENU_ID),
            type: (0, $1HF4Y.MenuNodeType).BulkIndicator,
            selectedCount: selectedCardIds.length
        },
        separator
    ] : [];
};

});

parcelRegister("5lrV3", function(module, exports) {

$parcel$export(module.exports, "useMoveTo", () => $f89386024ef31699$export$f91d8f33a4d36cb0);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $8ikZj = parcelRequire("8ikZj");

var $5fc53 = parcelRequire("5fc53");

var $1HF4Y = parcelRequire("1HF4Y");

var $gJl8A = parcelRequire("gJl8A");

var $guzeq = parcelRequire("guzeq");

var $lReb9 = parcelRequire("lReb9");

var $6GNN7 = parcelRequire("6GNN7");

var $4mqko = parcelRequire("4mqko");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $1z1J7 = parcelRequire("1z1J7");

var $k35me = parcelRequire("k35me");

var $fSgHa = parcelRequire("fSgHa");

var $9nlJl = parcelRequire("9nlJl");

var $5Mhvq = parcelRequire("5Mhvq");

var $g5WXi = parcelRequire("g5WXi");

var $92lqN = parcelRequire("92lqN");
const $f89386024ef31699$export$53fb05810700cd9c = 5;
const $f89386024ef31699$export$ba5a2e46cd05ad01 = ({ sprints: sprints, filteredSprints: filteredSprints, onMoveToSprint: onMoveToSprint, onMoveToBacklog: onMoveToBacklog, onMoveToBoard: onMoveToBoard, canMoveIssue: canMoveIssue, isMoveToBoardEnabled: isMoveToBoardEnabled, setQuery: setQuery, isSearching: isSearching, numOfSelectedSprints: numOfSelectedSprints, sprintId: sprintId, issueId: issueId, selectedCardIds: selectedCardIds, onScreenReaderAnnounce: onScreenReaderAnnounce })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onMouseEnter = (0, $gJl8A.useContextStartAnalytics)({
        selectedCardIds: selectedCardIds ?? [],
        fieldType: (0, $5fc53.SPRINT_TYPE),
        fieldKey: (0, $8ikZj.FIELD_TYPE_MAP)[0, $5fc53.SPRINT_TYPE]
    });
    const sprintOptions = filteredSprints.map((sprint)=>({
            type: (0, $1HF4Y.MenuNodeType).Item,
            id: `actions/move-to/${sprint.id}`,
            label: sprint.name,
            analytics: {
                ...isSearching && {
                    actionSubjectId: 'moveToSprintSearchDropdownItem'
                },
                attributes: {
                    numOfSelectedSprints: numOfSelectedSprints,
                    sprintId: sprintId ?? 'backlog'
                }
            },
            onClick: (analyticsEvent)=>onMoveToSprint(sprint.id, analyticsEvent)
        }));
    const sprintsSearchMenu = [
        {
            type: (0, $1HF4Y.MenuNodeType).Search,
            id: (0, $9nlJl.MOVE_TO_SEARCH_MENU_ID),
            children: sprintOptions,
            hasSearch: sprints.length > $f89386024ef31699$export$53fb05810700cd9c,
            onChange: (value)=>setQuery(value),
            isAsyncSearch: false,
            ariaLabel: formatMessage((0, $5Mhvq.default).sprintSearchPlaceholder)
        }
    ];
    const boardLabel = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCardLists))[0, $guzeq.BOARD]?.name;
    const isCMPBoard = (0, $fSgHa.useIsCMPBacklog)();
    const moveToBoard = isMoveToBoardEnabled ? [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            id: (0, $9nlJl.MOVE_TO_BOARD_MENU_ID),
            label: isCMPBoard && boardLabel ? boardLabel : formatMessage((0, $5Mhvq.default).board),
            analytics: {
                attributes: {
                    numOfSelectedSprints: numOfSelectedSprints,
                    sprintId: sprintId ?? 'backlog'
                }
            },
            onClick: onMoveToBoard
        }
    ] : [];
    const menuWithSeparator = sprints.length || moveToBoard.length ? [
        ...moveToBoard.length ? moveToBoard : sprintsSearchMenu,
        {
            id: (0, $9nlJl.SEPARATOR_MENU_ID),
            type: (0, $1HF4Y.MenuNodeType).Separator
        }
    ] : [];
    const rankIssueItems = (0, $g5WXi.useRankIssueItems)({
        issueId: issueId,
        onScreenReaderAnnounce: onScreenReaderAnnounce
    });
    return canMoveIssue ? [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: (0, $4R6GH.fg)('move_work_item_context_menu') ? formatMessage((0, $5Mhvq.default).moveWorkItem) : formatMessage((0, $5Mhvq.default).moveTo),
            id: (0, $9nlJl.MOVE_TO_MENU_ID),
            children: [
                ...menuWithSeparator,
                {
                    type: (0, $1HF4Y.MenuNodeType).Item,
                    id: (0, $9nlJl.MOVE_TO_TOP_OF_BACKLOG_MENU_ID),
                    label: (0, $4R6GH.fg)('move_work_item_context_menu') ? formatMessage((0, $5Mhvq.default).toTheTopOfTheBacklog) : formatMessage((0, $5Mhvq.default).topOfTheBacklog),
                    analytics: {
                        attributes: {
                            numOfSelectedSprints: numOfSelectedSprints,
                            sprintId: sprintId ?? 'backlog'
                        }
                    },
                    onClick: (analyticsEvent)=>onMoveToBacklog((0, $guzeq.TOP_OF_LIST), analyticsEvent)
                },
                ...rankIssueItems,
                {
                    type: (0, $1HF4Y.MenuNodeType).Item,
                    id: (0, $9nlJl.MOVE_TO_BOTTOM_OF_BACKLOG_MENU_ID),
                    label: (0, $4R6GH.fg)('move_work_item_context_menu') ? formatMessage((0, $5Mhvq.default).toTheBottomOfTheBacklog) : formatMessage((0, $5Mhvq.default).bottomOfTheBacklog),
                    analytics: {
                        attributes: {
                            numOfSelectedSprints: numOfSelectedSprints,
                            sprintId: sprintId ?? 'backlog'
                        }
                    },
                    onClick: (analyticsEvent)=>onMoveToBacklog((0, $guzeq.BOTTOM_OF_LIST), analyticsEvent)
                }
            ],
            ...(0, $4R6GH.fg)('one_event_rules_them_all_fg') && {
                onMouseEnter: onMouseEnter
            }
        }
    ] : [];
};
const $f89386024ef31699$export$f91d8f33a4d36cb0 = ({ issueId: issueId, cardIds: cardIds, hide: hide = false, onScreenReaderAnnounce: onScreenReaderAnnounce })=>{
    const [query, setQuery] = (0, $5uXOq.useState)('');
    const [filteredSprints, setFilteredSprints] = (0, $5uXOq.useState)([]);
    const fireAnalyticsEnd = (0, $92lqN.useSprintEndAnalytics)({
        cardIds: cardIds
    });
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const backlogStrategy = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getBacklogStrategy));
    const getCardListIdByCardId = (0, $c1MAf.useBacklogSelector)((0, $dGljH.makeGetCardListIdByCardId));
    const originCardListId = (0, $5uXOq.useMemo)(()=>getCardListIdByCardId(issueId), [
        getCardListIdByCardId,
        issueId
    ]);
    const numOfSelectedSprints = (0, $5uXOq.useMemo)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    ()=>new Set(cardIds.map(getCardListIdByCardId)).size, [
        cardIds,
        getCardListIdByCardId
    ]);
    const isFromActiveSprint = (0, $c1MAf.useBacklogSelector)((state)=>(0, $k35me.makeIsCardListActiveSprint)(state)(originCardListId || ''));
    const showAllSprints = !!numOfSelectedSprints && numOfSelectedSprints > 1;
    const sprints = (0, $c1MAf.useBacklogSelector)((state)=>showAllSprints ? (0, $k35me.getAllSprints)(state) : (0, $k35me.makeGetOtherOrderedSprints)(state)(originCardListId || ''), (before, after)=>before.length === after.length && before.every((sprint, index)=>sprint.name === after[index].name));
    const isMoveToBoardEnabled = (0, $c1MAf.useBacklogSelector)((state)=>!(0, $dGljH.makeIsCardOnBoard)(state)(issueId) && (backlogStrategy === (0, $guzeq.ISSUE_LIST_BACKLOG_STRATEGY) || backlogStrategy === (0, $guzeq.KANBAN_BACKLOG_STRATEGY)) && sprints.length === 0);
    (0, $5uXOq.useEffect)(()=>{
        setFilteredSprints(sprints.filter((sprint)=>sprint.name.toLowerCase().includes(query.toLowerCase())));
    }, [
        query,
        sprints
    ]);
    const onMoveToSprint = (0, $c1MAf.useBacklogActionCreator)((id, analyticsEvent)=>{
        if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) fireAnalyticsEnd(originCardListId, id, isFromActiveSprint);
        return (0, $6GNN7.cardsMove)({
            cardListId: id,
            placement: (0, $guzeq.BOTTOM_OF_LIST),
            isBetweenLists: originCardListId !== id,
            isFromActiveSprint: isFromActiveSprint,
            cardIds: cardIds
        }, analyticsEvent);
    });
    const onMoveToBacklog = (0, $5uXOq.useCallback)((placement, analyticsEvent)=>{
        if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) fireAnalyticsEnd(originCardListId, (0, $guzeq.BACKLOG), isFromActiveSprint);
        const moveCardsAction = (0, $6GNN7.cardsMove)({
            cardListId: (0, $guzeq.BACKLOG),
            placement: placement,
            isBetweenLists: originCardListId !== (0, $guzeq.BACKLOG),
            isFromActiveSprint: isFromActiveSprint,
            cardIds: cardIds
        }, analyticsEvent);
        dispatch(moveCardsAction);
        dispatch((0, $4mqko.cardSingleSelect)(issueId));
        dispatch((0, $lReb9.cardFocus)(issueId));
    }, [
        originCardListId,
        isFromActiveSprint,
        cardIds,
        dispatch,
        issueId,
        fireAnalyticsEnd
    ]);
    const onMoveToBoard = (0, $c1MAf.useBacklogActionCreator)((analyticsEvent)=>{
        if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) fireAnalyticsEnd(originCardListId, (0, $guzeq.BOARD));
        return (0, $6GNN7.cardsMove)({
            cardListId: (0, $guzeq.BOARD),
            placement: (0, $guzeq.BOTTOM_OF_LIST),
            isBetweenLists: originCardListId !== (0, $guzeq.BOARD),
            isFromActiveSprint: false,
            cardIds: cardIds
        }, analyticsEvent);
    });
    const canEdit = (0, $c1MAf.useBacklogSelector)((0, $1z1J7.canEditIssue));
    const canMoveIssue = canEdit && !hide;
    return $f89386024ef31699$export$ba5a2e46cd05ad01({
        sprints: sprints,
        issueId: issueId,
        filteredSprints: filteredSprints,
        isMoveToBoardEnabled: isMoveToBoardEnabled,
        onMoveToSprint: onMoveToSprint,
        onMoveToBacklog: onMoveToBacklog,
        onMoveToBoard: onMoveToBoard,
        setQuery: setQuery,
        canMoveIssue: canMoveIssue,
        isSearching: !!query,
        numOfSelectedSprints: numOfSelectedSprints,
        sprintId: originCardListId || '',
        onScreenReaderAnnounce: onScreenReaderAnnounce,
        ...(0, $4R6GH.fg)('one_event_rules_them_all_fg') && {
            selectedCardIds: cardIds
        }
    });
};

});
parcelRegister("g5WXi", function(module, exports) {

$parcel$export(module.exports, "useRankIssueItems", () => $984f36f425f2fd38$export$fbee3c551294933d);

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $8ikZj = parcelRequire("8ikZj");

var $ctrpc = parcelRequire("ctrpc");

var $5fc53 = parcelRequire("5fc53");

var $2NMNM = parcelRequire("2NMNM");

var $1HF4Y = parcelRequire("1HF4Y");

var $lReb9 = parcelRequire("lReb9");

var $4mqko = parcelRequire("4mqko");

var $c1MAf = parcelRequire("c1MAf");

var $jyQw0 = parcelRequire("jyQw0");

var $9nlJl = parcelRequire("9nlJl");

var $5Mhvq = parcelRequire("5Mhvq");
function $984f36f425f2fd38$export$fbee3c551294933d({ issueId: issueId, onScreenReaderAnnounce: onScreenReaderAnnounce }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const moveCards = (0, $jyQw0.useSimplyMoveCards)();
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onClick = (type)=>{
        moveCards({
            source: {
                cardId: issueId
            },
            location: {
                type: type
            }
        });
        dispatch((0, $4mqko.cardSingleSelect)(issueId));
        dispatch((0, $lReb9.cardFocus)(issueId));
        if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd((0, $8ikZj.FIELD_TYPE_MAP)[0, $5fc53.SPRINT_TYPE], {
            analytics: createAnalyticsEvent({}),
            attributes: {
                fieldType: (0, $5fc53.SPRINT_TYPE),
                hasRankChanged: true
            }
        });
    };
    const onClickRankUp = ()=>onClick('rank-up');
    const onClickRankDown = ()=>onClick('rank-down');
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            id: (0, $9nlJl.RANK_MENU_UP_ID),
            label: (0, $4R6GH.fg)('move_work_item_context_menu') ? formatMessage((0, $5Mhvq.default).up) : formatMessage((0, $5Mhvq.default).rankUp),
            onClick: ()=>{
                onScreenReaderAnnounce?.(formatMessage((0, $5Mhvq.default).movedUp));
                onClickRankUp();
            }
        },
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            id: (0, $9nlJl.RANK_MENU_DOWN_ID),
            label: (0, $4R6GH.fg)('move_work_item_context_menu') ? formatMessage((0, $5Mhvq.default).down) : formatMessage((0, $5Mhvq.default).rankDown),
            onClick: ()=>{
                onScreenReaderAnnounce?.(formatMessage((0, $5Mhvq.default).movedDown));
                onClickRankDown();
            }
        }
    ];
}

});
parcelRegister("jyQw0", function(module, exports) {

$parcel$export(module.exports, "useSimplyMoveCards", () => $2829c9efe0f1d21c$export$acad231ea38305d4);

var $2NMNM = parcelRequire("2NMNM");

var $g4tDr = parcelRequire("g4tDr");

var $7D59a = parcelRequire("7D59a");

var $2lpqS = parcelRequire("2lpqS");

var $guzeq = parcelRequire("guzeq");

var $6GNN7 = parcelRequire("6GNN7");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $4VAKv = parcelRequire("4VAKv");

var $k35me = parcelRequire("k35me");
function $2829c9efe0f1d21c$export$20b62d0c0d6c07df(cardIdsByCardListId, cardId) {
    const cardListIds = Object.keys(cardIdsByCardListId);
    for(let i = 0; i < cardListIds.length; i += 1){
        const cardListId = cardListIds[i];
        const cardIds = cardIdsByCardListId[cardListId];
        const maybeCardIndex = cardIds.indexOf(cardId);
        if (maybeCardIndex !== -1) return {
            cardListId: cardListId,
            index: maybeCardIndex
        };
    }
    return null;
}
function $2829c9efe0f1d21c$export$53e40513eb32c9ca({ location: location, targetList: targetList, targetIndex: targetIndex, isCardSubtask: isCardSubtask, cards: cards, card: card, isParentExpanded: isParentExpanded, cardsToMove: cardsToMove }) {
    let index = Math.max(0, targetIndex);
    if (location.type === 'after') index += 1;
    // If the card to move are the target, e.g.: we're moving cards onto themselves, then we
    // scan the list to find the next non-selected card to move before.
    const cardsToMoveSet = new Set(cardsToMove ?? []);
    while(index < targetList.length && cardsToMoveSet.has(targetList[index]))index += 1;
    let beforeCardId = targetList[index] ?? null;
    if (beforeCardId != null && isCardSubtask === false && (0, $g4tDr.isSubtaskHierarchyLevel)(cards[beforeCardId]?.typeHierarchyLevel) && (!isParentExpanded || location.type === 'rank-down')) {
        // find next non subtask related to parent, if none, then set null
        const parentId = cards[beforeCardId]?.parentId;
        const offset = location.type === 'rank-down' && card?.id === parentId ? 2 : 1;
        const nextGroupOffset = targetList.slice(targetIndex + 1).findIndex((id)=>parentId !== cards[id]?.parentId);
        const offsetCard = targetList[targetIndex + nextGroupOffset + offset] ?? null;
        beforeCardId = nextGroupOffset > -1 ? offsetCard : null;
    }
    if (beforeCardId == null) return {
        type: 'bottom'
    };
    // When the ticket user is dragging over is a subtask then we send through the parent ID instead of the subtask id
    if (isCardSubtask === false && (0, $g4tDr.isSubtaskHierarchyLevel)(cards[beforeCardId]?.typeHierarchyLevel)) beforeCardId = cards[beforeCardId]?.parentId ?? beforeCardId;
    return {
        type: 'card',
        beforeCardId: beforeCardId
    };
}
const $2829c9efe0f1d21c$var$getSubtasksIfShouldMoveWithParent = (state, cardIdsByCardListId, cards, cardsToMove)=>{
    const isCardGroupCollapsed = (parentId)=>!(0, $dGljH.makeGetCardGroupExpanded)(state)(parentId);
    // If it's a CMP scum project, move all subtasks with parent regardless of expansion state
    // Otherwise, move the subtasks with the parent only if it is collapsed
    const shouldMoveSubtasksIfExpanded = (0, $jG5HW.isCMPScrumBacklog)(state);
    const cardsToCheck = shouldMoveSubtasksIfExpanded ? cardsToMove : cardsToMove.filter(isCardGroupCollapsed);
    return cardsToCheck.flatMap((cardGroupId)=>{
        const list = $2829c9efe0f1d21c$export$20b62d0c0d6c07df(cardIdsByCardListId, cardGroupId);
        return list ? cardIdsByCardListId[list.cardListId].filter((cardId)=>(0, $g4tDr.isSubtaskHierarchyLevel)(cards[cardId]?.typeHierarchyLevel) && cards[cardId]?.parentId === cardGroupId) : [];
    });
};
function $2829c9efe0f1d21c$export$b5e42ff2ff97d25d(state, source, location, createAnalyticsEvent) {
    const cardIdsByCardListId = (0, $dGljH.getOrderedCardIdsByCardListId)(state);
    const sourceCardPosition = $2829c9efe0f1d21c$export$20b62d0c0d6c07df(cardIdsByCardListId, source.cardId);
    const targetCardPosition = $2829c9efe0f1d21c$export$20b62d0c0d6c07df(cardIdsByCardListId, location.target);
    if (!sourceCardPosition || !targetCardPosition) return null;
    const selectedCardIds = (0, $dGljH.getSelectedCards)(state);
    const cardsToMove = selectedCardIds.includes(source.cardId) ? selectedCardIds : [
        source.cardId
    ];
    const cards = (0, $dGljH.getCards)(state);
    const card = cards[source.cardId];
    const extraCards = $2829c9efe0f1d21c$var$getSubtasksIfShouldMoveWithParent(state, cardIdsByCardListId, cards, cardsToMove);
    const allCardsToMove = cardsToMove.concat(extraCards);
    const isFromActiveSprint = (0, $k35me.makeIsCardListActiveSprint)(state)(sourceCardPosition.cardListId);
    const isBetweenLists = sourceCardPosition.cardListId !== targetCardPosition.cardListId || selectedCardIds.some((cardId)=>Object.keys(cardIdsByCardListId).some((key)=>{
            if (key === targetCardPosition.cardListId) return false;
            return cardIdsByCardListId[key].includes(cardId);
        }));
    const basePayload = {
        cardIds: allCardsToMove,
        cardListId: targetCardPosition.cardListId,
        isBetweenLists: isBetweenLists,
        isFromActiveSprint: isFromActiveSprint
    };
    const targetList = cardIdsByCardListId[targetCardPosition.cardListId];
    const isParentExpanded = (0, $dGljH.makeGetCardGroupExpanded)(state)(cards[location.target]?.id);
    const beforeCardIdResult = $2829c9efe0f1d21c$export$53e40513eb32c9ca({
        location: location,
        targetList: targetList,
        targetIndex: targetCardPosition.index,
        isCardSubtask: (0, $g4tDr.isSubtaskHierarchyLevel)(card.typeHierarchyLevel),
        cardsToMove: allCardsToMove,
        cards: cards,
        card: card,
        isParentExpanded: isParentExpanded
    });
    const event = createAnalyticsEvent({
        attributes: {
            target: targetCardPosition.cardListId,
            source: sourceCardPosition.cardListId
        }
    });
    if (beforeCardIdResult.type === 'bottom') return (0, $6GNN7.cardsMove)({
        ...basePayload,
        placement: (0, $guzeq.BOTTOM_OF_LIST)
    }, event);
    // Ignore dragging a card onto its own leading and trailing edges
    const beforeCardIndex = targetList.indexOf(beforeCardIdResult.beforeCardId);
    const isNoopChange = card.id !== beforeCardIdResult.beforeCardId && allCardsToMove.every((cardId)=>beforeCardIdResult.beforeCardId === cardId || targetList[beforeCardIndex - 1] === cardId);
    if (isNoopChange) return null;
    const isAllSelectedSiblingSubtasks = (0, $4VAKv.makeIsAllSelectedSiblingSubtasks)(state);
    // If the card is a subtask and all selected cards are siblings, then they can only be moved in the group
    // If the "before" card doesn't have a parent it will mean that they have been moved to the last in the group
    const targetCard = cards[beforeCardIdResult.beforeCardId];
    if (card && targetCard && isAllSelectedSiblingSubtasks && (0, $g4tDr.isSubtaskHierarchyLevel)(card.typeHierarchyLevel) && !(0, $g4tDr.isSubtaskHierarchyLevel)(targetCard.typeHierarchyLevel)) return (0, $6GNN7.cardsMove)({
        ...basePayload,
        placement: (0, $guzeq.BOTTOM_OF_CARD_GROUP)
    }, event);
    return (0, $6GNN7.cardsMove)({
        ...basePayload,
        beforeCardId: beforeCardIdResult.beforeCardId,
        placement: (0, $guzeq.BEFORE_CARD)
    }, event);
}
function $2829c9efe0f1d21c$export$b50dfd72a14689ae(state, source, location, createAnalyticsEvent) {
    const cardIdsByCardListId = (0, $dGljH.getOrderedCardIdsByCardListId)(state);
    const sourceCardPosition = $2829c9efe0f1d21c$export$20b62d0c0d6c07df(cardIdsByCardListId, source.cardId);
    if (!sourceCardPosition) return null;
    const orderedCardIds = cardIdsByCardListId[sourceCardPosition.cardListId];
    const targetIndex = location.type === 'rank-up' ? sourceCardPosition.index - 1 : sourceCardPosition.index + 2;
    const basePayload = {
        cardIds: [
            source.cardId
        ],
        cardListId: sourceCardPosition.cardListId,
        isBetweenLists: false,
        isFromActiveSprint: false
    };
    const cards = (0, $dGljH.getCards)(state);
    const card = cards[source.cardId];
    const beforeCardIdResult = $2829c9efe0f1d21c$export$53e40513eb32c9ca({
        cards: cards,
        card: card,
        isCardSubtask: (0, $g4tDr.isSubtaskHierarchyLevel)(card?.typeHierarchyLevel),
        location: location,
        targetIndex: targetIndex,
        targetList: orderedCardIds,
        isParentExpanded: (0, $dGljH.makeGetCardGroupExpanded)(state)(cards[orderedCardIds[targetIndex]]?.id)
    });
    const event = createAnalyticsEvent({
        attributes: {
            source: sourceCardPosition.cardListId,
            target: sourceCardPosition.cardListId
        }
    });
    if (beforeCardIdResult.type === 'bottom') return (0, $6GNN7.cardsMove)({
        ...basePayload,
        placement: (0, $guzeq.BOTTOM_OF_LIST)
    }, event);
    // If the card is a subtask and the "before" card is not, then move to the bottom of the card list
    const targetCard = cards[beforeCardIdResult.beforeCardId];
    if (card && targetCard && (0, $g4tDr.isSubtaskHierarchyLevel)(card.typeHierarchyLevel) && !(0, $g4tDr.isSubtaskHierarchyLevel)(targetCard.typeHierarchyLevel)) return (0, $6GNN7.cardsMove)({
        ...basePayload,
        placement: (0, $guzeq.BOTTOM_OF_CARD_GROUP)
    }, event);
    return (0, $6GNN7.cardsMove)({
        ...basePayload,
        beforeCardId: beforeCardIdResult.beforeCardId,
        placement: (0, $guzeq.BEFORE_CARD)
    }, event);
}
function $2829c9efe0f1d21c$export$a8306ae9a42a578c(state, source, location, createAnalyticsEvent) {
    const cardIdsByCardListId = (0, $dGljH.getOrderedCardIdsByCardListId)(state);
    const selectedCardIds = (0, $dGljH.getSelectedCards)(state);
    const cardsToMove = selectedCardIds.includes(source.cardId) ? selectedCardIds : [
        source.cardId
    ];
    const sourceCardPosition = $2829c9efe0f1d21c$export$20b62d0c0d6c07df(cardIdsByCardListId, source.cardId);
    const cards = (0, $dGljH.getCards)(state);
    const extraCards = $2829c9efe0f1d21c$var$getSubtasksIfShouldMoveWithParent(state, cardIdsByCardListId, cards, cardsToMove);
    const allCardsToMove = cardsToMove.concat(extraCards);
    // Quit if any of the cards are missing from the state
    const cardPositions = allCardsToMove.map((cardId)=>$2829c9efe0f1d21c$export$20b62d0c0d6c07df(cardIdsByCardListId, cardId));
    if (cardPositions.some((cardPosition)=>!cardPosition)) return null;
    // Quit if noop
    const isBetweenLists = cardPositions.some((cardPosition)=>cardPosition?.cardListId !== location.targetListId);
    if (!isBetweenLists) return null;
    // Treat as from active sprint if any of the cards is in the active sprint
    const isFromActiveSprint = cardPositions.some((cardPosition)=>cardPosition && (0, $k35me.makeIsCardListActiveSprint)(state)(cardPosition.cardListId));
    return (0, $6GNN7.cardsMove)({
        cardIds: allCardsToMove,
        cardListId: location.targetListId,
        isBetweenLists: true,
        isFromActiveSprint: isFromActiveSprint,
        placement: (0, $guzeq.BOTTOM_OF_LIST)
    }, createAnalyticsEvent({
        attributes: {
            source: sourceCardPosition?.cardListId,
            target: location.targetListId
        }
    }));
}
/**
 * Returns a filter function that prevents subtasks from being left behind moved without their parents
 * Pass if:
 *  card is not a subtask OR
 *  card's parent is also included in cardsToMove OR
 *  card's parent is in the list we are moving to
 */ function $2829c9efe0f1d21c$var$removeOrphanSubtasks(state, targetList) {
    return (cardId, index, cardsToMove)=>{
        const cardIdsByCardListId = (0, $dGljH.getFilteredOrderedCardIdsByCardListId)(state);
        const cards = (0, $dGljH.getCards)(state);
        const isSubtask = (0, $g4tDr.isSubtaskHierarchyLevel)(cards[cardId]?.typeHierarchyLevel);
        const { parentId: parentId } = cards[cardId];
        if (!parentId) return true;
        const parentInTargetList = cardIdsByCardListId[targetList].includes(parentId);
        const parentIsIncluded = cardsToMove.includes(parentId);
        return !isSubtask || parentIsIncluded || parentInTargetList;
    };
}
function $2829c9efe0f1d21c$export$5d7be4628e37c837(state, source, location, createAnalyticsEvent) {
    const cardIdsByCardListId = (0, $dGljH.getFilteredOrderedCardIdsByCardListId)(state);
    const targetCardPosition = $2829c9efe0f1d21c$export$20b62d0c0d6c07df(cardIdsByCardListId, location.target);
    if (!targetCardPosition) return null;
    const cardListOrder = (0, $dGljH.getOrderedCardListIds)(state);
    const sourceCardListId = source.cardListId;
    const dividerListIndex = cardListOrder.indexOf(sourceCardListId);
    if (dividerListIndex === -1) return null;
    const isFromActiveSprint = (0, $k35me.makeIsCardListActiveSprint)(state)(sourceCardListId);
    const targetIndex = cardListOrder.findIndex((val)=>val === targetCardPosition.cardListId);
    const sourceIndex = cardListOrder.findIndex((val)=>val === source.cardListId);
    const direction = sourceIndex < targetIndex ? 'down' : 'up';
    const cardsFromOtherLists = cardListOrder.slice(direction === 'down' ? sourceIndex + 1 : targetIndex + 1, direction === 'down' ? targetIndex : sourceIndex + 1).flatMap((key)=>cardIdsByCardListId[key]);
    // We will move the divider list's cards to the list under it
    // This happens when dragging the divider up into a list above
    if (direction === 'up') {
        const targetList = cardListOrder[sourceIndex + 1];
        const cardsToMove = cardIdsByCardListId[targetCardPosition.cardListId].slice(location.type === 'before' ? targetCardPosition.index : targetCardPosition.index + 1).concat(cardsFromOtherLists).filter($2829c9efe0f1d21c$var$removeOrphanSubtasks(state, targetList));
        return (0, $6GNN7.cardsMove)({
            cardIds: cardsToMove,
            cardListId: targetList,
            isBetweenLists: true,
            isFromActiveSprint: isFromActiveSprint,
            placement: (0, $guzeq.TOP_OF_LIST)
        }, createAnalyticsEvent({
            attributes: {
                type: (0, $2lpqS.DND_TARGET_DIVIDER),
                source: sourceCardListId,
                target: targetCardPosition.cardListId
            }
        }));
    }
    // We will move target list's cards to the divider list
    // This happens when dragging the divider down into a list under it
    const cardsToMove = cardsFromOtherLists.concat(cardIdsByCardListId[targetCardPosition.cardListId].slice(0, location.type === 'before' ? targetCardPosition.index : targetCardPosition.index + 1)).filter($2829c9efe0f1d21c$var$removeOrphanSubtasks(state, cardListOrder[sourceIndex]));
    return (0, $6GNN7.cardsMove)({
        cardIds: cardsToMove,
        cardListId: sourceCardListId,
        isBetweenLists: true,
        isFromActiveSprint: isFromActiveSprint,
        placement: (0, $guzeq.BOTTOM_OF_LIST)
    }, createAnalyticsEvent({
        attributes: {
            type: (0, $2lpqS.DND_TARGET_DIVIDER),
            // ? With the divider here the source and target are swapped
            target: sourceCardListId,
            source: targetCardPosition.cardListId
        }
    }));
}
function $2829c9efe0f1d21c$export$5c5a9714d8f54364(store, { source: source, location: location }, createAnalyticsEvent) {
    const state = store.getState();
    if ('type' in source && source.type === 'divider' && (location.type === 'before' || location.type === 'after')) return $2829c9efe0f1d21c$export$5d7be4628e37c837(state, source, location, createAnalyticsEvent);
    if (!('cardId' in source)) return null;
    if (location.type === 'before' || location.type === 'after') return $2829c9efe0f1d21c$export$b5e42ff2ff97d25d(state, source, location, createAnalyticsEvent);
    if (location.type === 'rank-up' || location.type === 'rank-down') return $2829c9efe0f1d21c$export$b50dfd72a14689ae(state, source, location, createAnalyticsEvent);
    if (location.type === 'list') return $2829c9efe0f1d21c$export$a8306ae9a42a578c(state, source, location, createAnalyticsEvent);
    return null;
}
function $2829c9efe0f1d21c$export$acad231ea38305d4() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const store = (0, $c1MAf.useBacklogStore)();
    return (0, $7D59a.useEvent)((payload)=>{
        const action = $2829c9efe0f1d21c$export$5c5a9714d8f54364(store, payload, createAnalyticsEvent);
        if (action) store.dispatch(action);
    });
}

});
parcelRegister("4VAKv", function(module, exports) {

$parcel$export(module.exports, "makeIsAnySelectedOrphanedSubtasks", () => $986a9adf5ab52bc5$export$18dee6c39753b5ad);
$parcel$export(module.exports, "makeIsAllSelectedSiblingSubtasks", () => $986a9adf5ab52bc5$export$a018c3db49ab6617);

var $k8IPx = parcelRequire("k8IPx");

var $24ebX = parcelRequire("24ebX");

var $g4tDr = parcelRequire("g4tDr");

var $ld0jI = parcelRequire("ld0jI");

var $dGljH = parcelRequire("dGljH");
const $986a9adf5ab52bc5$export$18dee6c39753b5ad = (0, $24ebX.createSelector)([
    (0, $dGljH.getSelectedCards),
    (0, $dGljH.getCards)
], (selectedCards, cards)=>selectedCards.some((cardId)=>{
        const card = cards[cardId];
        const isSubtask = !!card && (0, $g4tDr.isSubtaskHierarchyLevel)(card.typeHierarchyLevel);
        const isOrphaned = !!card?.parentId && !selectedCards.includes(card.parentId);
        return isSubtask && isOrphaned;
    }));
const $986a9adf5ab52bc5$export$a018c3db49ab6617 = (0, $24ebX.createSelector)([
    (0, $dGljH.getSelectedCards),
    (0, $dGljH.getCards),
    (0, $ld0jI.makeGetCardGroupByChildId)
], (selectedCards, cards, getCardGroupByChildId)=>!!selectedCards.length && selectedCards.every((cardId)=>{
        const card = cards[cardId];
        const isSubtask = !!card && (0, $g4tDr.isSubtaskHierarchyLevel)(card.typeHierarchyLevel);
        if (isSubtask) {
            const cardGroup = getCardGroupByChildId(cardId);
            return !!cardGroup && (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(selectedCards, cardGroup.cardIds).length === 0;
        }
        return false;
    }));

});



parcelRegister("92lqN", function(module, exports) {

$parcel$export(module.exports, "useSprintEndAnalytics", () => $dd427b4886a32102$export$3d104c374c073ba0);

var $8Rkzz = parcelRequire("8Rkzz");

var $4R6GH = parcelRequire("4R6GH");

var $8ikZj = parcelRequire("8ikZj");

var $ctrpc = parcelRequire("ctrpc");

var $5fc53 = parcelRequire("5fc53");

var $2NMNM = parcelRequire("2NMNM");

var $c1MAf = parcelRequire("c1MAf");

var $k35me = parcelRequire("k35me");

var $f01qr = parcelRequire("f01qr");
const $dd427b4886a32102$export$3d104c374c073ba0 = ({ cardIds: cardIds })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const getIsToActiveSprint = (0, $c1MAf.useBacklogSelector)((0, $k35me.makeIsCardListActiveSprint));
    if (!(0, $4R6GH.fg)('one_event_rules_them_all_fg')) return 0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz));
    if (cardIds.length !== 1) return 0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz));
    return (oldValId, newValId, isFromActiveSprint = false)=>{
        const actionTaken = (0, $f01qr.getEndAnalyticsSprintActionTaken)(oldValId, newValId);
        if (!actionTaken) {
            (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd((0, $8ikZj.FIELD_TYPE_MAP)[0, $5fc53.SPRINT_TYPE], {
                analytics: createAnalyticsEvent({}),
                attributes: {
                    fieldType: (0, $5fc53.SPRINT_TYPE),
                    hasRankChanged: true
                }
            });
            return;
        }
        (0, $ctrpc.getUpdateAnalyticsFlowHelper)().setAttributes((0, $8ikZj.FIELD_TYPE_MAP)[0, $5fc53.SPRINT_TYPE], {
            actionTaken: actionTaken
        });
        const isToActiveSprint = getIsToActiveSprint(newValId);
        if (isFromActiveSprint || isToActiveSprint) // end analytics will fire at modal confirm
        return;
        (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd((0, $8ikZj.FIELD_TYPE_MAP)[0, $5fc53.SPRINT_TYPE], {
            analytics: createAnalyticsEvent({}),
            attributes: {
                fieldType: (0, $5fc53.SPRINT_TYPE)
            }
        });
    };
};

});


parcelRegister("02921", function(module, exports) {

$parcel$export(module.exports, "useParent", () => $7862c68ba7c7071c$export$c1a4e24309a2ec52);

var $5uXOq = parcelRequire("5uXOq");

var $aB8eX = parcelRequire("aB8eX");

var $8Rkzz = parcelRequire("8Rkzz");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $ctrpc = parcelRequire("ctrpc");

var $5fc53 = parcelRequire("5fc53");

var $2NMNM = parcelRequire("2NMNM");

var $1HF4Y = parcelRequire("1HF4Y");

var $gu244 = parcelRequire("gu244");

var $gJl8A = parcelRequire("gJl8A");

var $gkSeR = parcelRequire("gkSeR");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");

var $9nlJl = parcelRequire("9nlJl");

var $5Mhvq = parcelRequire("5Mhvq");

var $kJXVt = parcelRequire("kJXVt");
const $7862c68ba7c7071c$export$2e6dd7b2ab013cea = 6;
const $7862c68ba7c7071c$var$UNLINK = 'unlink';
const $7862c68ba7c7071c$var$isUnlinkMenuOption = (option)=>'type' in option && option.type === $7862c68ba7c7071c$var$UNLINK;
const $7862c68ba7c7071c$var$transformOptionToString = (option)=>{
    if ($7862c68ba7c7071c$var$isUnlinkMenuOption(option)) return option.label;
    return `${option.key} ${option.summary}`;
};
const $7862c68ba7c7071c$export$9e34a407c5c18c2f = ({ issueParents: issueParents, loading: loading, cardSelectionValid: cardSelectionValid, showUnlinkMenuItem: showUnlinkMenuItem, onUpdateParent: onUpdateParent, selectedCardIds: selectedCardIds })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const menuOptions = (0, $5uXOq.useMemo)(()=>[
            ...showUnlinkMenuItem ? [
                {
                    type: $7862c68ba7c7071c$var$UNLINK,
                    label: formatMessage((0, $5Mhvq.default).parentUnlinkOptionLabel)
                }
            ] : [],
            ...issueParents
        ], [
        formatMessage,
        issueParents,
        showUnlinkMenuItem
    ]);
    const [filteredMenuOptions, updateFilter] = (0, $gu244.useTextFilter)(menuOptions, $7862c68ba7c7071c$var$transformOptionToString);
    const onMouseEnter = (0, $gJl8A.useContextStartAnalytics)({
        selectedCardIds: selectedCardIds ?? [],
        fieldType: (0, $5fc53.PARENT_TYPE),
        fieldKey: (0, $5fc53.PARENT_TYPE)
    });
    return (0, $5uXOq.useMemo)(()=>{
        if (!cardSelectionValid || !issueParents.length && !showUnlinkMenuItem) return [];
        const options = filteredMenuOptions.map((option)=>$7862c68ba7c7071c$var$isUnlinkMenuOption(option) ? {
                type: (0, $1HF4Y.MenuNodeType).Item,
                id: `${0, $9nlJl.PARENT_MENU_ID}/value__unlink`,
                label: option.label,
                onClick: (analyticsEvent)=>{
                    onUpdateParent(null, analyticsEvent);
                }
            } : {
                type: (0, $1HF4Y.MenuNodeType).Item,
                id: `${0, $9nlJl.PARENT_MENU_ID}/value__${option.id}`,
                label: $7862c68ba7c7071c$var$transformOptionToString(option),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
                    width: "var(--ds-space-200, 16px)",
                    height: "var(--ds-space-200, 16px)",
                    src: option.issueType?.iconUrl,
                    alt: ""
                }),
                onClick: (analyticsEvent)=>{
                    onUpdateParent(option, analyticsEvent);
                }
            });
        const showSearch = issueParents.length + (showUnlinkMenuItem ? 1 : 0) > $7862c68ba7c7071c$export$2e6dd7b2ab013cea;
        const subMenu = showSearch ? [
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            {
                type: (0, $1HF4Y.MenuNodeType).Search,
                id: (0, $9nlJl.PARENT_SEARCH_MENU_ID),
                children: options,
                hasSearch: true,
                // Parents are only fetched async once during mount
                isAsyncSearch: false,
                isLoading: loading,
                onChange: updateFilter,
                resultsCount: filteredMenuOptions.length
            }
        ] : options;
        return [
            {
                type: (0, $1HF4Y.MenuNodeType).Item,
                id: (0, $9nlJl.PARENT_MENU_ID),
                label: formatMessage((0, $5Mhvq.default).parentOptionLabel),
                submenuWidth: 284,
                children: subMenu,
                ...(0, $4R6GH.fg)('one_event_rules_them_all_fg') && {
                    onMouseEnter: onMouseEnter
                }
            }
        ];
    }, [
        cardSelectionValid,
        issueParents.length,
        showUnlinkMenuItem,
        filteredMenuOptions,
        loading,
        updateFilter,
        formatMessage,
        onMouseEnter,
        onUpdateParent
    ]);
};
const $7862c68ba7c7071c$export$aba8ea72cfd1ccc1 = (oldParentId)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (newValue)=>{
        (0, $ctrpc.getUpdateAnalyticsFlowHelper)().setActionTakenAttributes((0, $5fc53.PARENT_TYPE), oldParentId, newValue ?? null);
        (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd((0, $5fc53.PARENT_TYPE), {
            analytics: createAnalyticsEvent({}),
            attributes: {
                fieldType: (0, $5fc53.PARENT_TYPE)
            }
        });
    };
};
const $7862c68ba7c7071c$export$c1a4e24309a2ec52 = (selectedCardIds)=>{
    const getIssueKey = (0, $c1MAf.useBacklogSelector)((0, $dGljH.makeCardKeyFromCardId));
    const allCards = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCards));
    const selectedCards = (0, $5uXOq.useMemo)(()=>selectedCardIds.map((cardId)=>allCards[cardId]).filter(Boolean), [
        allCards,
        selectedCardIds
    ]);
    const firstCardParentId = selectedCards.length ? selectedCards[0].parentId : null;
    const fireAnalyticsEnd = (0, $4R6GH.fg)('one_event_rules_them_all_fg') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    $7862c68ba7c7071c$export$aba8ea72cfd1ccc1(firstCardParentId) : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    const { issueParents: allIssueParents, loading: loading, cardSelectionValid: cardSelectionValid } = (0, $kJXVt.useIssueParents)(selectedCards);
    const multipleCardsSelected = selectedCardIds.length > 1;
    const showUnlinkMenuItem = selectedCards.some((card)=>card.parentId !== null);
    // If we're only editing a single card, remove any
    // epic from the list that's assigned to this card
    const issueParents = (0, $5uXOq.useMemo)(()=>!multipleCardsSelected && firstCardParentId ? allIssueParents.filter((parent)=>parent.id !== String(firstCardParentId)) : allIssueParents, [
        allIssueParents,
        firstCardParentId,
        multipleCardsSelected
    ]);
    const onUpdateParent = (0, $c1MAf.useBacklogActionCreator)((parent, analyticsEvent)=>{
        if (selectedCardIds.length === 1 && (0, $4R6GH.fg)('one_event_rules_them_all_fg')) fireAnalyticsEnd(parent?.id);
        return (0, $aB8eX.batchActions)(selectedCardIds.map((id)=>(0, $gkSeR.cardParentSetOptimistic)({
                cardId: id,
                parent: parent
            }, getIssueKey(id), analyticsEvent)));
    });
    return $7862c68ba7c7071c$export$9e34a407c5c18c2f({
        issueParents: issueParents,
        onUpdateParent: onUpdateParent,
        showUnlinkMenuItem: showUnlinkMenuItem,
        loading: loading,
        cardSelectionValid: cardSelectionValid,
        ...(0, $4R6GH.fg)('one_event_rules_them_all_fg') && {
            selectedCardIds: selectedCardIds
        }
    });
};

});
parcelRegister("gu244", function(module, exports) {

$parcel$export(module.exports, "useTextFilter", () => $5d5db767318aa751$export$de949492119ddd44);

var $5uXOq = parcelRequire("5uXOq");
const $5d5db767318aa751$var$removeAccents = (text)=>text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
const $5d5db767318aa751$var$doesStringContainText = (itemString, text)=>itemString.toLowerCase().includes(text.toLowerCase()) || $5d5db767318aa751$var$removeAccents(itemString).toLowerCase().includes(text.toLowerCase());
const $5d5db767318aa751$export$de949492119ddd44 = (items, itemToStringTransformer, defaultFilterValue = '')=>{
    const [filterValue, setFilterValue] = (0, $5uXOq.useState)(defaultFilterValue);
    const filteredItems = (0, $5uXOq.useMemo)(()=>{
        if (!filterValue) return items;
        return items.filter((item)=>$5d5db767318aa751$var$doesStringContainText(itemToStringTransformer(item), filterValue));
    }, [
        filterValue,
        itemToStringTransformer,
        items
    ]);
    return [
        filteredItems,
        setFilterValue
    ];
};

});

parcelRegister("kJXVt", function(module, exports) {

$parcel$export(module.exports, "useIssueParents", () => $012fa3a5c174d68b$export$b72cf91ed30503ee);

var $5uXOq = parcelRequire("5uXOq");

var $5fc53 = parcelRequire("5fc53");

var $2LYS2 = parcelRequire("2LYS2");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $fmuR9 = parcelRequire("fmuR9");

var $fzhrh = parcelRequire("fzhrh");
const $012fa3a5c174d68b$var$SEARCH_FIELDS = [
    (0, $5fc53.SUMMARY_TYPE),
    (0, $5fc53.ISSUE_TYPE)
];
const $012fa3a5c174d68b$var$constructSearchJql = (projectIds)=>`project in (${projectIds.join(',')}) AND hierarchyLevel=1 ORDER BY lastViewed DESC, updated DESC, priority DESC`;
const $012fa3a5c174d68b$var$transformSearchResponse = (response)=>response.issues.map((issue)=>{
        const { id: id, name: name, iconUrl: iconUrl } = issue.fields.issuetype;
        return {
            id: issue.id,
            key: issue.key,
            summary: issue.fields.summary,
            issueType: {
                id: id,
                name: name,
                iconUrl: iconUrl
            },
            color: undefined
        };
    });
const $012fa3a5c174d68b$var$EMPTY_ARRAY = [];
const $012fa3a5c174d68b$export$b72cf91ed30503ee = (selectedCards)=>{
    const allProjects = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getProjects));
    const issueParentsInState = (0, $c1MAf.useBacklogSelector)((0, $fmuR9.issueParentsSelector));
    const isCompanyManaged = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
    const projectId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.projectIdSelector));
    // Array of projects from which a valid parent selection can be made
    const applicableProjects = (0, $5uXOq.useMemo)(()=>isCompanyManaged ? (0, $fzhrh.getAllPossibleProjectsForSelection)(selectedCards, allProjects) : [], [
        allProjects,
        isCompanyManaged,
        selectedCards
    ]);
    // Array of valid issue parents from state
    const filteredIssueParentsInState = (0, $5uXOq.useMemo)(()=>isCompanyManaged ? (0, $fzhrh.filterIssueParentsByProjects)(issueParentsInState, applicableProjects) : issueParentsInState, [
        isCompanyManaged,
        issueParentsInState,
        applicableProjects
    ]);
    // TMP projects do not require validation as they do not
    // include epic or subtasks cards and cross-project boards
    const isCardSelectionValid = isCompanyManaged ? (0, $fzhrh.validateSelectedCards)(selectedCards, allProjects) : true;
    const { data: data, loading: loading, fetch: fetch } = (0, $2LYS2.useIssueSearch)();
    const issueParentsFromSearch = (0, $5uXOq.useMemo)(()=>data && $012fa3a5c174d68b$var$transformSearchResponse(data), [
        data
    ]);
    const issueParents = isCardSelectionValid ? issueParentsFromSearch || filteredIssueParentsInState : $012fa3a5c174d68b$var$EMPTY_ARRAY;
    (0, $5uXOq.useEffect)(()=>{
        if (isCardSelectionValid) {
            const projectIds = isCompanyManaged ? applicableProjects.map((project)=>project.id) : [
                projectId
            ];
            fetch({
                jql: $012fa3a5c174d68b$var$constructSearchJql(projectIds),
                fields: $012fa3a5c174d68b$var$SEARCH_FIELDS
            });
        }
    }, [
        applicableProjects,
        fetch,
        isCardSelectionValid,
        isCompanyManaged,
        projectId
    ]);
    return {
        issueParents: issueParents,
        loading: loading,
        cardSelectionValid: isCardSelectionValid
    };
};

});
parcelRegister("2LYS2", function(module, exports) {

$parcel$export(module.exports, "useIssueSearch", () => $3d22472943f3524e$export$2047aaca681570b0);

var $ebyGx = parcelRequire("ebyGx");

var $ld2hZ = parcelRequire("ld2hZ");

var $eusud = parcelRequire("eusud");
const $3d22472943f3524e$var$BASE_URL = '/rest/api/3/search';
const $3d22472943f3524e$var$search = ({ jql: jql, fields: fields = [], maxResults: maxResults = 50 })=>{
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
        jql: jql,
        fields: fields,
        maxResults: maxResults
    });
    return (0, $eusud.performGetRequest)(`${$3d22472943f3524e$var$BASE_URL}?${query}`);
};
const $3d22472943f3524e$export$2047aaca681570b0 = ()=>(0, $ld2hZ.useService)($3d22472943f3524e$var$search);

});

parcelRegister("fzhrh", function(module, exports) {

$parcel$export(module.exports, "getAllPossibleProjectsForSelection", () => $3cc06988f0b52507$export$73fb4b63f0b800bc);
$parcel$export(module.exports, "filterIssueParentsByProjects", () => $3cc06988f0b52507$export$6d89fd51639f36fe);
$parcel$export(module.exports, "validateSelectedCards", () => $3cc06988f0b52507$export$7b9297714722993a);

var $kGsr8 = parcelRequire("kGsr8");

var $g4tDr = parcelRequire("g4tDr");
const $3cc06988f0b52507$var$EMPTY_ARRAY = [];
const $3cc06988f0b52507$export$191ca7f80b22e275 = (selectedCards, allProjects)=>{
    const projectIdsOfSelection = (0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))(selectedCards.map((card)=>card.projectId));
    return allProjects.filter((project)=>projectIdsOfSelection.includes(project.id));
};
const $3cc06988f0b52507$export$73fb4b63f0b800bc = (selectedCards, allProjects)=>{
    if (!(selectedCards.length && allProjects.length)) return $3cc06988f0b52507$var$EMPTY_ARRAY;
    const projectsOfSelection = $3cc06988f0b52507$export$191ca7f80b22e275(selectedCards, allProjects);
    if (!projectsOfSelection.length) return $3cc06988f0b52507$var$EMPTY_ARRAY;
    const isTmp = projectsOfSelection[0].isSimplified;
    if (isTmp) return [
        projectsOfSelection[0]
    ];
    return allProjects.filter((project)=>!project.isSimplified);
};
const $3cc06988f0b52507$export$6d89fd51639f36fe = (issueParents, projects)=>{
    const projectKeys = new Set(projects.map((project)=>project.key));
    return issueParents.filter((parent)=>{
        const [projectKey] = parent.key.split('-');
        return projectKeys.has(projectKey);
    });
};
const $3cc06988f0b52507$export$7b9297714722993a = (selectedCards, allProjects)=>{
    const projectsOfSelection = $3cc06988f0b52507$export$191ca7f80b22e275(selectedCards, allProjects);
    if (!projectsOfSelection.length) return false;
    const subtasksOrEpicsAreSelected = selectedCards.some(({ typeHierarchyLevel: typeHierarchyLevel })=>!(0, $g4tDr.isBaseHierarchyLevel)(typeHierarchyLevel));
    const [firstProject, ...remainingProjects] = projectsOfSelection;
    const projectsAreOfDifferentType = remainingProjects.length ? remainingProjects.some((project)=>project.isSimplified !== firstProject.isSimplified) : false;
    const multipleTmpProjectsHaveSelections = !projectsAreOfDifferentType && firstProject.isSimplified && remainingProjects.length > 0;
    return !(subtasksOrEpicsAreSelected || projectsAreOfDifferentType || multipleTmpProjectsHaveSelections);
};

});



parcelRegister("7sDhu", function(module, exports) {

$parcel$export(module.exports, "usePriority", () => $18e1a6ad2ad970b4$export$5b10fbc9ee011cb3);

var $5uXOq = parcelRequire("5uXOq");

var $aB8eX = parcelRequire("aB8eX");

var $jjlQu = parcelRequire("jjlQu");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $ctrpc = parcelRequire("ctrpc");

var $5fc53 = parcelRequire("5fc53");

var $2NMNM = parcelRequire("2NMNM");

var $1HF4Y = parcelRequire("1HF4Y");

var $gJl8A = parcelRequire("gJl8A");

var $c7Xu8 = parcelRequire("c7Xu8");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");

var $1z1J7 = parcelRequire("1z1J7");

var $c96gv = parcelRequire("c96gv");

var $9nlJl = parcelRequire("9nlJl");

var $5Mhvq = parcelRequire("5Mhvq");
const $18e1a6ad2ad970b4$export$7499acaeff5d6912 = ({ isPriorityEnabled: isPriorityEnabled, priorities: priorities, canChangePriority: canChangePriority, onClick: onClick, selectedCardIds: selectedCardIds })=>{
    const onMouseEnter = (0, $gJl8A.useContextStartAnalytics)({
        selectedCardIds: selectedCardIds ?? [],
        fieldType: (0, $5fc53.PRIORITY_TYPE),
        fieldKey: (0, $5fc53.PRIORITY_TYPE)
    });
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!isPriorityEnabled || !canChangePriority) return [];
    const priorityOptions = priorities.map((value)=>({
            type: (0, $1HF4Y.MenuNodeType).Item,
            id: `${0, $9nlJl.PRIORITY_MENU_ID}/value__${value.id}`,
            label: value.name,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jjlQu.default), {
                url: value.iconUrl
            }),
            onClick: (analyticsEvent)=>onClick(value, analyticsEvent)
        }));
    if (priorityOptions.length === 0) return [];
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            id: (0, $9nlJl.PRIORITY_MENU_ID),
            label: formatMessage((0, $5Mhvq.default).priority),
            children: priorityOptions,
            ...(0, $4R6GH.fg)('one_event_rules_them_all_fg') && {
                onMouseEnter: onMouseEnter
            }
        }
    ];
};
const $18e1a6ad2ad970b4$export$5b10fbc9ee011cb3 = ({ selectedCardIds: selectedCardIds })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const priorities = (0, $c1MAf.useBacklogSelector)((0, $c96gv.getPriorities));
    const cardEntities = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCards));
    const getIssueKey = (0, $c1MAf.useBacklogSelector)((0, $dGljH.makeCardKeyFromCardId));
    const canBulkEdit = (0, $c1MAf.useBacklogSelector)((0, $1z1J7.canBulkEditIssues));
    const canEdit = (0, $c1MAf.useBacklogSelector)((0, $1z1J7.canEditIssue));
    const canChangePriority = canBulkEdit && canEdit;
    const onPriorityClick = (0, $c1MAf.useBacklogActionCreator)((priority, analyticsEvent)=>{
        if (selectedCardIds.length === 1 && (0, $4R6GH.fg)('one_event_rules_them_all_fg')) {
            const cardId = selectedCardIds[0];
            const oldValueId = priorities.find((p)=>p.name === cardEntities[String(cardId)]?.priority?.name)?.id;
            (0, $ctrpc.getUpdateAnalyticsFlowHelper)().setActionTakenAttributes((0, $5fc53.PRIORITY_TYPE), oldValueId, priority.id);
            (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd((0, $5fc53.PRIORITY_TYPE), {
                analytics: createAnalyticsEvent({}),
                attributes: {
                    fieldType: (0, $5fc53.PRIORITY_TYPE)
                }
            });
        }
        return (0, $aB8eX.batchActions)(selectedCardIds.map((id)=>(0, $c7Xu8.cardPrioritySetOptimistic)({
                cardId: id,
                priority: priority
            }, getIssueKey(id), analyticsEvent)));
    });
    const isPriorityEnabled = (0, $5uXOq.useMemo)(()=>selectedCardIds.some((cardId)=>cardEntities[String(cardId)]?.priority), [
        selectedCardIds,
        cardEntities
    ]);
    return $18e1a6ad2ad970b4$export$7499acaeff5d6912({
        isPriorityEnabled: isPriorityEnabled,
        priorities: priorities,
        canChangePriority: canChangePriority,
        onClick: (priority, analyticsEvent)=>onPriorityClick(priority, analyticsEvent),
        ...(0, $4R6GH.fg)('one_event_rules_them_all_fg') && {
            selectedCardIds: selectedCardIds
        }
    });
};

});
parcelRegister("jjlQu", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7f7206d8a029d15$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable jira/react/handler-naming */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $gwIPs = parcelRequire("gwIPs");
const $e7f7206d8a029d15$export$c6d2b2df39d78e5b = (0, $gwIPs.gridSize) * 2;
class $e7f7206d8a029d15$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            url: undefined,
            title: undefined,
            alt: undefined,
            width: $e7f7206d8a029d15$export$c6d2b2df39d78e5b,
            height: $e7f7206d8a029d15$export$c6d2b2df39d78e5b,
            fallback: undefined
        };
    }
    render() {
        const { title: title, url: url, alt: alt, fallback: fallback } = this.props;
        const width = this.convertSize(this.props.width);
        const height = this.convertSize(this.props.height);
        if (this.state.isBroken && fallback) return fallback();
        if (url) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e7f7206d8a029d15$var$Image, {
            src: url,
            width: width,
            height: height,
            title: title ?? undefined,
            alt: alt ?? '',
            onError: this.onError,
            /**
       * Disabling dragging so drags happen on the parent instead of this icon.
       */ draggable: false,
            "data-vc": "common-components-async-icon"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $e7f7206d8a029d15$var$placeholderStyles,
            // eslint-disable-next-line jira/react/no-style-attribute
            style: {
                height: height,
                width: width
            },
            backgroundColor: "color.background.input.hovered",
            testId: "common-components-async-icon.placeholder"
        });
    }
    constructor(...args){
        super(...args), this.state = {
            isBroken: false
        }, this.onError = ()=>{
            this.setState({
                isBroken: true
            });
        }, this.convertSize = (size)=>size ? `${size}px` : '0';
    }
}
const $e7f7206d8a029d15$var$placeholderStyles = (0, $8CUq3.xcss)({
    borderRadius: '3px',
    display: 'flex',
    flex: 'none'
});
// Firefox displays the alt text when the image can't load, the narrow provided width
// means this alt text leaks into the summary vertically if overflow is allowed
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e7f7206d8a029d15$var$Image = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
});

});

parcelRegister("c96gv", function(module, exports) {

$parcel$export(module.exports, "getPriorities", () => $410cea2ba39bc35d$export$489e9c0d7da0a5e2);

var $e5nhF = parcelRequire("e5nhF");
const $410cea2ba39bc35d$export$489e9c0d7da0a5e2 = (state)=>(0, $e5nhF.getEntities)(state).priorities;

});


parcelRegister("ct9uH", function(module, exports) {

$parcel$export(module.exports, "useSplitIssue", () => $dea5bc936768ba59$export$ca834a1ba255430d);

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $1HF4Y = parcelRequire("1HF4Y");


var $5Eoed = parcelRequire("5Eoed");

var $c1MAf = parcelRequire("c1MAf");

var $1z1J7 = parcelRequire("1z1J7");

var $9nlJl = parcelRequire("9nlJl");

var $5Mhvq = parcelRequire("5Mhvq");

var $dGljH = parcelRequire("dGljH");
const $dea5bc936768ba59$var$getSplitIssueLabel = (formatMessage, cardType)=>{
    if (cardType && (0, $6s1PB.expVal)('jira-itr-m4-exp-3', 'isEnabled', false)) return formatMessage((0, $5Mhvq.default).splitIssueIssueTerminologyRefreshM4, {
        workType: cardType
    });
    return formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5Mhvq.default).splitIssueIssueTermRefresh : (0, $5Mhvq.default).splitIssue);
};
const $dea5bc936768ba59$export$5f7e384ce14f24a6 = ({ onSplitIssue: onSplitIssue, canSplitIssue: canSplitIssue, isMultiSelect: isMultiSelect, issueId: issueId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cards = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCards));
    const cardType = cards[issueId]?.issueTypeName;
    const label = $dea5bc936768ba59$var$getSplitIssueLabel(formatMessage, cardType);
    return isMultiSelect || !canSplitIssue ? [] : [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: label,
            id: (0, $9nlJl.SPLIT_ISSUE_MENU_ID),
            onClick: onSplitIssue
        }
    ];
};
const $dea5bc936768ba59$export$ca834a1ba255430d = ({ issueId: issueId, isMultiSelect: isMultiSelect })=>{
    const onSplitIssue = (0, $c1MAf.useBacklogActionCreator)(()=>(0, $5Eoed.openModal)({
            type: (0, $b107c54ec82f76f2$export$77e94846ed2f57d7),
            payload: {
                cardId: issueId
            }
        }));
    const canCreate = (0, $c1MAf.useBacklogSelector)((0, $1z1J7.canCreateIssues));
    const canEdit = (0, $c1MAf.useBacklogSelector)((0, $1z1J7.canEditIssue));
    const canSplitIssue = canCreate && canEdit;
    return $dea5bc936768ba59$export$5f7e384ce14f24a6({
        issueId: issueId,
        onSplitIssue: onSplitIssue,
        canSplitIssue: canSplitIssue,
        isMultiSelect: isMultiSelect
    });
};

});

parcelRegister("9ZFOK", function(module, exports) {

$parcel$export(module.exports, "useVersion", () => $4599610fe42edc80$export$d01fd6c038443a68);

var $5uXOq = parcelRequire("5uXOq");

var $kGsr8 = parcelRequire("kGsr8");

var $7CMCs = parcelRequire("7CMCs");

var $1HF4Y = parcelRequire("1HF4Y");


var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");

var $9nlJl = parcelRequire("9nlJl");

var $elDM1 = parcelRequire("elDM1");
const $4599610fe42edc80$export$356153774e3dba20 = (versionMenuProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        packageName: (0, $a9c483c0d986286a$export$dfd208682d29484c),
        id: "jira.backlog.context-menu.version"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Suspense, {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $elDM1.VersionMenu), versionMenuProps)));
const $4599610fe42edc80$var$EMPTY_ARR = [];
const $4599610fe42edc80$export$d01fd6c038443a68 = ({ selectedCardIds: selectedCardIds, versionMenuQueryRef: versionMenuQueryRef })=>{
    const cards = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCards));
    return (0, $5uXOq.useMemo)(()=>{
        if (!versionMenuQueryRef) return $4599610fe42edc80$var$EMPTY_ARR;
        const selectedCards = selectedCardIds.map((cardId)=>cards[cardId]).filter(Boolean);
        // Selected cards are valid if they belong to the same project
        const isCardSelectionValid = (0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))(selectedCards.map((card)=>card.projectId)).length === 1;
        if (!isCardSelectionValid) return $4599610fe42edc80$var$EMPTY_ARR;
        const menuItemNode = {
            type: (0, $1HF4Y.MenuNodeType).Node,
            id: `${(0, $9nlJl.VERSION_MENU_ID)}/node`,
            node: (menuItemNodeArgs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4599610fe42edc80$export$356153774e3dba20, {
                    selectedCardIds: selectedCardIds,
                    selectedCards: selectedCards,
                    versionMenuQueryRef: versionMenuQueryRef,
                    menuItemNodeArgs: menuItemNodeArgs
                })
        };
        return [
            menuItemNode
        ];
    }, [
        cards,
        selectedCardIds,
        versionMenuQueryRef
    ]);
};

});
parcelRegister("elDM1", function(module, exports) {

$parcel$export(module.exports, "VersionMenu", () => $07ae86e06a2a730f$export$ff839af10c1133ea);

var $caDhG = parcelRequire("caDhG");

var $hrjFc = parcelRequire("hrjFc");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $5fc53 = parcelRequire("5fc53");

var $1HF4Y = parcelRequire("1HF4Y");

var $gu244 = parcelRequire("gu244");

var $42KkK = parcelRequire("42KkK");

var $1z3OV = parcelRequire("1z3OV");

var $9Mj0A = parcelRequire("9Mj0A");

var $gJl8A = parcelRequire("gJl8A");

var $9nlJl = parcelRequire("9nlJl");

var $5Mhvq = parcelRequire("5Mhvq");

var $64FxD = parcelRequire("64FxD");

var $cHomS = parcelRequire("cHomS");
const $07ae86e06a2a730f$var$OptionType = {
    Version: 'version',
    Unlink: 'unlink'
};
const $07ae86e06a2a730f$var$transformOptionToString = (option)=>option.type === $07ae86e06a2a730f$var$OptionType.Version ? option.edge.node.name : option.label;
const $07ae86e06a2a730f$export$6a451aef481e8837 = (0, $hrjFc.default);
const $07ae86e06a2a730f$export$ff839af10c1133ea = ({ versionMenuQueryRef: versionMenuQueryRef, ...props })=>{
    const data = (0, $8Uumt.usePreloadedQuery)($07ae86e06a2a730f$export$6a451aef481e8837, versionMenuQueryRef);
    const versionEdges = (0, $5uXOq.useMemo)(()=>data.jira.versionsForProjects.edges.filter(Boolean), [
        data
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($07ae86e06a2a730f$var$VersionMenuContent, {
        ...props,
        versionEdges: versionEdges
    });
};
const $07ae86e06a2a730f$var$VersionMenuContent = ({ selectedCardIds: selectedCardIds, selectedCards: selectedCards, menuItemNodeArgs: menuItemNodeArgs, versionEdges: versionEdges })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    // Without breaking the edges between query and fragment, we cannot make the fields here required due to the connection
    const versions = (0, $8Uumt.useFragment)((0, $caDhG.default), versionEdges);
    const versionOptions = (0, $5uXOq.useMemo)(()=>{
        // Menu's only rendered if selected cards belong to the same project, so we can filter the versions using it
        const projectId = String(selectedCards[0].projectId);
        const filteredVersions = versions.filter(({ node: node })=>node.status === 'UNRELEASED' && node.project.projectId === projectId);
        // If there's only 1 card selected, ensure any already assigned versions are removed from the list
        const firstCardVersionIds = selectedCards[0]?.fixVersions ?? [];
        const availableVersions = selectedCards.length === 1 && firstCardVersionIds.length > 0 ? filteredVersions.filter(({ node: node })=>!firstCardVersionIds.includes(node.versionId)) : filteredVersions;
        return availableVersions.map((edge)=>({
                type: $07ae86e06a2a730f$var$OptionType.Version,
                edge: edge
            }));
    }, [
        versions,
        selectedCards
    ]);
    // Show unlink option if any card's version can be found in our queried versions
    const versionIdsSet = (0, $5uXOq.useMemo)(()=>new Set(versions.map(({ node: node })=>node.versionId)), [
        versions
    ]);
    const showUnlinkMenuItem = (0, $5uXOq.useMemo)(()=>selectedCards.some((card)=>card.fixVersions?.some((versionId)=>versionIdsSet.has(versionId)) ?? false), [
        selectedCards,
        versionIdsSet
    ]);
    const options = (0, $5uXOq.useMemo)(()=>showUnlinkMenuItem ? [
            {
                type: $07ae86e06a2a730f$var$OptionType.Unlink,
                label: formatMessage((0, $5Mhvq.default).versionUnlinkOptionLabel)
            },
            ...versionOptions
        ] : versionOptions, [
        versionOptions,
        formatMessage,
        showUnlinkMenuItem
    ]);
    const [filteredOptions, updateFilter] = (0, $gu244.useTextFilter)(options, $07ae86e06a2a730f$var$transformOptionToString);
    const onMouseEnter = (0, $gJl8A.useContextStartAnalytics)({
        selectedCardIds: selectedCardIds,
        fieldType: (0, $5fc53.VERSION_CF_TYPE),
        fieldKey: (0, $5fc53.FIX_VERSIONS_TYPE)
    });
    return versionOptions.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1z3OV.ContextMenuNode), {
        ...menuItemNodeArgs,
        menuNode: {
            type: (0, $1HF4Y.MenuNodeType).Item,
            id: `${(0, $9nlJl.VERSION_MENU_ID)}/menu`,
            label: formatMessage((0, $5Mhvq.default).versionOptionLabel),
            submenuWidth: 284,
            element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42KkK.ContextMenuSearch), {
                onChange: updateFilter,
                autoFocus: true,
                isAsyncSearch: false,
                isLoading: false,
                hasSearch: options.length > 6,
                hasResult: filteredOptions.length > 0,
                resultsCount: filteredOptions.length
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Mj0A.A11yList), null, filteredOptions.map((option)=>option.type === $07ae86e06a2a730f$var$OptionType.Version ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Mj0A.A11yListItem), {
                    key: option.edge.node.versionId
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cHomS.VersionMenuItem), {
                    selectedCardIds: selectedCardIds,
                    versionEdge: option.edge,
                    menuItemNodeArgs: menuItemNodeArgs
                })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Mj0A.A11yListItem), {
                    key: "unlink"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $64FxD.UnlinkMenuItem), {
                    key: "unlink",
                    selectedCardIds: selectedCardIds,
                    label: option.label,
                    menuItemNodeArgs: menuItemNodeArgs
                }))))),
            ...(0, $4R6GH.fg)('one_event_rules_them_all_fg') && {
                onMouseEnter: onMouseEnter
            }
        }
    }) : null;
};

});
parcelRegister("caDhG", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f48978273e20a0a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<982c324b2465f44e22128f5709dfdd89>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0f48978273e20a0a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "plural": true
    },
    "name": "versionMenu_softwareBacklog_VersionMenuContent",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraVersion",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "versionId"
                        },
                        "action": "THROW",
                        "path": "node.versionId"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        "action": "THROW",
                        "path": "node.name"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        "action": "THROW",
                        "path": "node.status"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "projectId"
                                    },
                                    "action": "THROW",
                                    "path": "node.project.projectId"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "node.project"
                    }
                ]
            },
            "action": "THROW",
            "path": "node"
        },
        {
            "kind": "FragmentSpread",
            "name": "versionMenuItem_softwareBacklog"
        }
    ],
    "type": "JiraVersionEdge"
};
$0f48978273e20a0a$var$node.hash = "a4cdeffafe39db4bddd6ce699b40af53";
var $0f48978273e20a0a$export$2e2bcd8739ae039 = $0f48978273e20a0a$var$node;

});

parcelRegister("42KkK", function(module, exports) {

$parcel$export(module.exports, "ContextMenuSearch", () => $25a4fcce187183d2$export$800c7f2ae9d8f14d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $lFKmC = parcelRequire("lFKmC");

var $26g7Y = parcelRequire("26g7Y");

var $kY99m = parcelRequire("kY99m");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");


var $kqKGs = parcelRequire("kqKGs");

var $lPUo5 = parcelRequire("lPUo5");
const $25a4fcce187183d2$export$800c7f2ae9d8f14d = ({ onChange: onChange, autoFocus: autoFocus = true, hasSearch: hasSearch = true, maxViewportItems: maxViewportItems = (0, $d9cdb1c71f9dbf8c$export$dce8cd449abd1f77), isLoading: isLoading = false, hasResult: hasResult = false, isAsyncSearch: isAsyncSearch, children: children, ariaLabel: ariaLabel, resultsCount: resultsCount })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [query, setQuery] = (0, $5uXOq.useState)('');
    (0, $5uXOq.useEffect)(()=>()=>{
            onChange?.(''); // reset the filter result when the component unmounts
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const debouncedOnChange = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((value)=>{
            onChange?.(value);
        }, (0, $d9cdb1c71f9dbf8c$export$1ec3328eed0aedd9)), [
        onChange
    ]);
    const handleChange = (0, $5uXOq.useCallback)((e)=>{
        const { value: value } = e.target;
        debouncedOnChange(value);
        setQuery(value);
    }, [
        debouncedOnChange,
        setQuery
    ]);
    const handleKeyDown = (e)=>{
        if (e.key === 'Escape' && query !== '') {
            e.preventDefault();
            e.stopPropagation();
            onChange?.('');
            setQuery('');
        }
        if (e.key === 'Enter' && (0, $4R6GH.fg)('issue_cards_in_program_board')) e.preventDefault();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": (0, $d9cdb1c71f9dbf8c$export$90350df905144507)
    }, hasSearch && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($25a4fcce187183d2$var$SearchWrapper, {
        role: "search"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
        role: "searchbox",
        "aria-label": ariaLabel,
        "aria-autocomplete": "list",
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($25a4fcce187183d2$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($26g7Y))), {
            label: "",
            LEGACY_size: "small"
        })),
        onChange: handleChange,
        onKeyDown: handleKeyDown,
        placeholder: formatMessage((0, $kqKGs.default).search),
        isCompact: true,
        value: query,
        autoFocus: autoFocus
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lPUo5.default), {
        resultsCount: resultsCount,
        query: query,
        isAsyncSearch: isAsyncSearch,
        isLoading: isLoading
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($25a4fcce187183d2$var$ContextMenuSearchContent, {
        maxViewportItems: maxViewportItems,
        "data-testid": (0, $d9cdb1c71f9dbf8c$export$328d05d650390cfd)
    }, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($25a4fcce187183d2$var$ContextMenuSearchMessage, {
        "data-testid": (0, $d9cdb1c71f9dbf8c$export$1245780b529c0d82)
    }, formatMessage((0, $kqKGs.default).loading)), !isLoading && !hasResult && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($25a4fcce187183d2$var$ContextMenuSearchMessage, {
        "data-testid": (0, $d9cdb1c71f9dbf8c$export$803f51dcf576f554)
    }, formatMessage((0, $kqKGs.default).noResults)), !isLoading && hasResult && children));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $25a4fcce187183d2$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syazwdcn _18u0u2gc _1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $25a4fcce187183d2$var$SearchWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "form", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_n7zlzgxb _ca0q12x7 _u5f3u2gc _n3td12x7 _19bvu2gc _4t3izwfg _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $25a4fcce187183d2$var$ContextMenuSearchContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { maxViewportItems: maxViewportItems, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_8dv613": (0, $lD23V.default)(`${(0, $d9cdb1c71f9dbf8c$export$b9e05b29ae05bdd9) * __cmplp.maxViewportItems}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_c71lx1ju _18m91wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $25a4fcce187183d2$var$ContextMenuSearchMessage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3izwfg _1e0c1txw _1bah1h6o _4cvr1h6o _syaz1gjq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kqKGs", function(module, exports) {

$parcel$export(module.exports, "default", () => $e62d973eb0093b5e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e62d973eb0093b5e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    search: {
        "id": "software-context-menu.menu-renderer.context-menu-inner.context-menu-node.context-menu-search.search",
        "defaultMessage": "Search"
    },
    loading: {
        "id": "software-context-menu.menu-renderer.context-menu-inner.context-menu-node.context-menu-search.loading",
        "defaultMessage": "Loading..."
    },
    noResults: {
        "id": "software-context-menu.menu-renderer.context-menu-inner.context-menu-node.context-menu-search.no-results",
        "defaultMessage": "No results"
    }
});

});

parcelRegister("lPUo5", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b1e43b54ce9834d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $fraBZ = parcelRequire("fraBZ");

var $koVbs = parcelRequire("koVbs");


var $ll7Ps = parcelRequire("ll7Ps");
/** Generate a JSX friendly string filled with spaces */ const $5b1e43b54ce9834d$var$generateRandomSpaces = (max = 100)=>{
    const numSpaces = Math.round(Math.random() * max);
    return new Array(numSpaces).fill('\u00a0').join('');
};
const $5b1e43b54ce9834d$var$appendRandomSpacesToString = (text)=>`${text}${$5b1e43b54ce9834d$var$generateRandomSpaces()}`;
/**
 *
 * Triggers screenreader announcements of loading state and search result count
 */ const $5b1e43b54ce9834d$var$ResultsAnnouncer = ({ query: query, resultsCount: resultsCount, isAsyncSearch: isAsyncSearch, isLoading: isLoading })=>{
    const [message, setMessage] = (0, $5uXOq.useState)('');
    const hasMounted = (0, $5uXOq.useRef)(false);
    const prevLoading = (0, $5uXOq.useRef)(false);
    const prevQuery = (0, $5uXOq.useRef)(query);
    const prevCount = (0, $5uXOq.useRef)(resultsCount);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const setResultsMessage = (0, $5uXOq.useCallback)((count)=>{
        setMessage(/**
     * We need to append a random number of empty spaces to messages to
     * make them unique and force a re-announcement for two reasons:
     * 1) When the query has changed but the results count is the same,
     *    so the message wouldn't have changed
     * 2) During VoiceOver testing, it appeared that on ocassion the same
     *    message being output in a short space of time; even when a
     *    unique message was sandwiched in between; lead to messages being
     *    ignored by the screenreader.
     *
     * Although in theory AnnouncerV2 is built to handle these scenarios,
     * in testing this was not the case.
     */ $5b1e43b54ce9834d$var$appendRandomSpacesToString(formatMessage((0, $ll7Ps.default).resultsAnnouncement, {
            count: count
        })));
    }, [
        formatMessage
    ]);
    /**
   * The updating of the message is debounced as 'query'
   * updates in real time, but the on change callback
   * that triggers the updating of results is itself debounced.
   * We only want to update the message once we've received the
   * new results, not everytime the query changes.
   */ const setMessageDebounced = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((newCount, newQuery, loading)=>{
            if (loading) setMessage($5b1e43b54ce9834d$var$appendRandomSpacesToString(formatMessage((0, $ll7Ps.default).loading)));
            else if (isAsyncSearch && prevLoading.current) setResultsMessage(newCount);
            else if (!isAsyncSearch && newQuery !== prevQuery.current) setResultsMessage(newCount);
            prevLoading.current = loading;
            prevCount.current = newCount;
            prevQuery.current = newQuery;
        }, (0, $d9cdb1c71f9dbf8c$export$1ec3328eed0aedd9) + 50), [
        isAsyncSearch,
        formatMessage,
        setResultsMessage
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!hasMounted.current) hasMounted.current = true;
        else setMessageDebounced(resultsCount, query, isLoading);
    }, [
        isLoading,
        query,
        resultsCount,
        setMessageDebounced
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fraBZ.AnnouncerV2), {
        message: message
    });
};
var $5b1e43b54ce9834d$export$2e2bcd8739ae039 = $5b1e43b54ce9834d$var$ResultsAnnouncer;

});
parcelRegister("ll7Ps", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3de096429e18f50$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e3de096429e18f50$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    resultsAnnouncement: {
        "id": "software-context-menu.menu-renderer.context-menu-inner.context-menu-node.context-menu-search.results-announcer.results-announcement",
        "defaultMessage": "{count, plural, =0 {no results found} one {one result found} other {# results found}}"
    },
    loading: {
        "id": "software-context-menu.menu-renderer.context-menu-inner.context-menu-node.context-menu-search.results-announcer.loading",
        "defaultMessage": "Loading results"
    }
});

});



parcelRegister("1z3OV", function(module, exports) {

$parcel$export(module.exports, "ContextMenuNode", () => $e9e5f3b0ca8b78ac$export$b809af7ff33fc17d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $2NMNM = parcelRequire("2NMNM");

var $1HF4Y = parcelRequire("1HF4Y");

var $duCCb = parcelRequire("duCCb");

var $6U9Sv = parcelRequire("6U9Sv");

var $ewaBk = parcelRequire("ewaBk");

var $5wSOB = parcelRequire("5wSOB");


var $569Yl = parcelRequire("569Yl");

var $42KkK = parcelRequire("42KkK");

var $5u1jX = parcelRequire("5u1jX");
const $e9e5f3b0ca8b78ac$export$b809af7ff33fc17d = ({ scope: scope, menuNode: menuNode, onClick: onClick, onMouseEnter: onMouseEnter, shouldRenderToParent: shouldRenderToParent = true })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { addMappedAnalyticsToEvent: addMappedAnalyticsToEvent, fireUIAnalyticsForNode: fireUIAnalyticsForNode } = (0, $6U9Sv.useContextMenuAnalytics)();
    const { closeMenu: closeMenu } = (0, $ewaBk.useContextMenuActions)();
    const getMenuItemNodeProps = (0, $5uXOq.useCallback)((menuItem)=>{
        const analyticsEvent = addMappedAnalyticsToEvent(createAnalyticsEvent({
            actionSubject: 'dropdownItem',
            action: 'clicked'
        }), menuItem.id, menuItem.analytics);
        return {
            scope: scope,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            analyticsEvent: analyticsEvent.clone(),
            closeMenu: ()=>{
                closeMenu(scope);
                fireUIAnalyticsForNode(analyticsEvent, menuItem.id, menuItem.analytics);
            },
            onClick: onClick,
            onMouseEnter: onMouseEnter
        };
    }, [
        createAnalyticsEvent,
        fireUIAnalyticsForNode,
        addMappedAnalyticsToEvent,
        closeMenu,
        scope,
        onClick,
        onMouseEnter
    ]);
    const renderNode = (0, $5uXOq.useCallback)((node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e9e5f3b0ca8b78ac$export$b809af7ff33fc17d, {
            scope: scope,
            menuNode: node,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            shouldRenderToParent: shouldRenderToParent
        }), [
        onClick,
        onMouseEnter,
        scope,
        shouldRenderToParent
    ]);
    if (menuNode.type === (0, $1HF4Y.MenuNodeType).Section) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5u1jX.ContextMenuSection), {
        section: menuNode
    }, menuNode.children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $duCCb.ContextMenuNodeList), {
        menuNodes: menuNode.children,
        renderNode: renderNode
    }));
    if (menuNode.type === (0, $1HF4Y.MenuNodeType).Item) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6U9Sv.ContextualAnalyticsDataFromNode), {
        id: menuNode.id,
        updater: menuNode.analytics
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $569Yl.ContextMenuItem), {
        scope: scope,
        menuItem: menuNode,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        shouldRenderToParent: shouldRenderToParent
    }, /*#__PURE__*/ (0, $5uXOq.isValidElement)(menuNode.element) ? menuNode.element : menuNode.children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $duCCb.ContextMenuNodeList), {
        menuNodes: menuNode.children,
        renderNode: renderNode
    })));
    if (menuNode.type === (0, $1HF4Y.MenuNodeType).Node) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6U9Sv.ContextualAnalyticsDataFromNode), {
        id: menuNode.id,
        updater: menuNode.analytics
    }, typeof menuNode.node === 'function' ? menuNode.node(getMenuItemNodeProps(menuNode)) : menuNode.node);
    if (menuNode.type === (0, $1HF4Y.MenuNodeType).Separator) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e9e5f3b0ca8b78ac$var$ContextMenuSeparator, {
        tabIndex: -1,
        "data-testid": (0, $b6a39f6f0587f06b$export$c1dbf4585c850e82)
    });
    if (menuNode.type === (0, $1HF4Y.MenuNodeType).BulkIndicator) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5wSOB.BulkIndicator), {
        selectedCount: menuNode.selectedCount,
        "data-testid": (0, $b6a39f6f0587f06b$export$4502867028c77602)
    });
    if (menuNode.type === (0, $1HF4Y.MenuNodeType).Search) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42KkK.ContextMenuSearch), {
        onChange: menuNode.onChange,
        autoFocus: menuNode.autoFocus,
        maxViewportItems: menuNode.maxViewportItems,
        hasSearch: menuNode.hasSearch,
        isAsyncSearch: menuNode.isAsyncSearch,
        isLoading: menuNode.isLoading ?? false,
        hasResult: !!menuNode.children?.length,
        ariaLabel: menuNode.ariaLabel,
        resultsCount: menuNode.children.length
    }, !menuNode.isLoading && !!menuNode.children?.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $duCCb.ContextMenuNodeList), {
        menuNodes: menuNode.children,
        renderNode: renderNode
    }));
    return null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e9e5f3b0ca8b78ac$var$ContextMenuSeparator = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3it94y _1bsb1osq _bfhkmuej _19pk1b66 _2hwxidpf _otyr1b66 _18u0idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("duCCb", function(module, exports) {

$parcel$export(module.exports, "ContextMenuNodeList", () => $47ad7749cf48ddcf$export$59ef8d374540d9f8);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $4R6GH = parcelRequire("4R6GH");
const $47ad7749cf48ddcf$var$listStyles = (0, $8CUq3.xcss)({
    listStyle: 'none',
    padding: 'space.0',
    margin: 'space.0'
});
const $47ad7749cf48ddcf$var$listItemStyles = (0, $8CUq3.xcss)({
    padding: 'space.0',
    margin: 'space.0'
});
const $47ad7749cf48ddcf$export$59ef8d374540d9f8 = /*#__PURE__*/ (0, $5uXOq.memo)(({ menuNodes: menuNodes, renderNode: renderNode })=>{
    if (Array.isArray(menuNodes)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "ul",
        xcss: $47ad7749cf48ddcf$var$listStyles
    }, menuNodes.map((menuNode)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            as: "li",
            key: menuNode.id,
            xcss: $47ad7749cf48ddcf$var$listItemStyles
        }, renderNode(menuNode))));
    if (!Array.isArray(menuNodes) && (0, $4R6GH.fg)('jfp_a11y_team_boards_list_markup_used_incorrectly')) return renderNode(menuNodes);
});

});

parcelRegister("5wSOB", function(module, exports) {

$parcel$export(module.exports, "BulkIndicator", () => $2482d2d0b9107db7$export$1dde12b63932e6bf);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $16T6Y = parcelRequire("16T6Y");

var $koVbs = parcelRequire("koVbs");

var $6vzTF = parcelRequire("6vzTF");
const $2482d2d0b9107db7$export$1dde12b63932e6bf = ({ selectedCount: selectedCount })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2482d2d0b9107db7$var$BulkIndicatorContainer, {
        tabIndex: -1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16T6Y.default), {
        appearance: "primary"
    }, selectedCount), " ", formatMessage((0, $6vzTF.messages).selected));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2482d2d0b9107db7$var$BulkIndicatorContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _zulpu2gc _4t3izwfg _1e0c1txw _ca0qidpf _u5f3v47k _n3tdidpf _19bvv47k _4cvr1h6o _1p1dangw _syaz1gjq _k48p1wq8",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6vzTF", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9948278016d09b9e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $9948278016d09b9e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    selected: {
        "id": "software-context-menu.menu-renderer.context-menu-inner.context-menu-node.bulk-indicator.selected",
        "defaultMessage": "Selected"
    }
});

});


const $b6a39f6f0587f06b$export$c1dbf4585c850e82 = 'software-context-menu.ui.context-menu-inner.context-menu-node.context-menu-separator';
const $b6a39f6f0587f06b$export$4502867028c77602 = 'software-context-menu.ui.context-menu-inner.context-menu-node.context-menu-bulk-indicator';

parcelRegister("569Yl", function(module, exports) {

$parcel$export(module.exports, "ContextMenuItem", () => $78a51cd7033d0a1b$export$16a26dc176a49100);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $jgJNO = parcelRequire("jgJNO");


var $ewaBk = parcelRequire("ewaBk");

var $byRc1 = parcelRequire("byRc1");

var $eskuB = parcelRequire("eskuB");

var $lCAQO = parcelRequire("lCAQO");
const $78a51cd7033d0a1b$var$OverflowVisiblePopupContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($78a51cd7033d0a1b$var$OverflowVisiblePopupContainerStyled, {
        ...props,
        ref: ref,
        "data-testid": (0, $d9cdb1c71f9dbf8c$export$75f77b2251314894)
    }, children));
const $78a51cd7033d0a1b$export$16a26dc176a49100 = ({ scope: scope, menuItem: menuItem, children: children, onMouseEnter: onMouseEnter, shouldRenderToParent: shouldRenderToParent = true, ...others })=>{
    const ref = (0, $5uXOq.useRef)(null);
    const { setForcedFocusPath: setForcedFocusPath } = (0, $ewaBk.useContextMenuActions)();
    const shouldFocus = (0, $ewaBk.useShouldForceFocus)({
        scope: scope,
        menuItem: menuItem
    });
    const { persistentFocus: persistentFocus, enablePersistentFocus: enablePersistentFocus, disablePersistentFocus: disablePersistentFocus, isOpen: isOpen } = (0, $lCAQO.useSubmenuPersistentFocus)({
        menuItem: menuItem,
        scope: scope
    });
    (0, $5uXOq.useLayoutEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (ref.current !== null && document.activeElement !== ref.current) {
            if (shouldFocus) {
                ref.current?.focus();
                setForcedFocusPath(scope, undefined);
            }
        }
    }, [
        shouldFocus,
        scope,
        setForcedFocusPath
    ]);
    const Content = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eskuB.SubmenuContainer), {
            width: menuItem.submenuWidth,
            shouldOverflowChildren: menuItem.shouldOverflowChildren,
            persistentFocus: persistentFocus
        }, children), [
        menuItem.submenuWidth,
        menuItem.shouldOverflowChildren,
        children,
        persistentFocus
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        autoFocus: false,
        offset: [
            0,
            0
        ],
        isOpen: !!isOpen && !!children,
        popupComponent: menuItem.shouldOverflowChildren ? $78a51cd7033d0a1b$var$OverflowVisiblePopupContainer : undefined,
        content: Content,
        placement: "right-start",
        messageId: "software-context-menu.ui.menu-renderer.context-menu-inner.context-menu-node.context-menu-item.popup",
        messageType: "transactional",
        shouldRenderToParent: shouldRenderToParent,
        trigger: ({ ref: popupRef, ...popupProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $byRc1.ContextMenuItemButton), {
                ...popupProps,
                ref: (r)=>{
                    if (popupRef) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    popupRef(r);
                    ref.current = r;
                },
                isOpen: isOpen,
                hasChildren: !!children,
                menuItem: menuItem,
                onOpenWithKeyboard: enablePersistentFocus,
                onMouseEnter: (node)=>{
                    disablePersistentFocus();
                    onMouseEnter && onMouseEnter(node);
                },
                ...others
            })
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $78a51cd7033d0a1b$var$OverflowVisiblePopupContainerStyled = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reoewfl _18m9ewfl _2rko1l7b _16qs1cd0",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eskuB", function(module, exports) {

$parcel$export(module.exports, "SubmenuContainer", () => $b53c71158999a9c9$export$5e6b4e3ac9115f51);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $ao4Ml = parcelRequire("ao4Ml");

const $b53c71158999a9c9$var$stopPropagation = (e)=>{
    e.stopPropagation();
};
const $b53c71158999a9c9$export$5e6b4e3ac9115f51 = ({ children: children, width: width = (0, $d9cdb1c71f9dbf8c$export$6b4c950ad6cadf50), shouldOverflowChildren: shouldOverflowChildren, persistentFocus: persistentFocus = false })=>{
    const contextMenuContainerRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        const eventRef = contextMenuContainerRef.current;
        eventRef?.addEventListener('mousedown', $b53c71158999a9c9$var$stopPropagation);
        return ()=>{
            eventRef?.removeEventListener('mousedown', $b53c71158999a9c9$var$stopPropagation);
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ao4Ml.default), {
        disabled: !persistentFocus,
        persistentFocus: persistentFocus,
        autoFocus: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b53c71158999a9c9$export$4f48a5067cf73390, {
        width: width,
        ref: contextMenuContainerRef,
        "data-testid": (0, $d9cdb1c71f9dbf8c$export$b3f11e5d123cdbe9),
        shouldOverflowChildren: shouldOverflowChildren
    }, children));
};
const $b53c71158999a9c9$export$4f48a5067cf73390 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldOverflowChildren: shouldOverflowChildren, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_6f8077": (0, $lD23V.default)(`${__cmplp.width}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _bfhk1bhr _c71l1kdj _vchhusvi _1pby16oo _1e0c1ule _1bsb1hdq",
            __cmplp.shouldOverflowChildren ? "_1reoewfl" : "_1reo15vq",
            __cmplp.shouldOverflowChildren ? "_18m9ewfl" : "_18m91wug",
            __cmplp.className
        ])
    });
});

});

parcelRegister("lCAQO", function(module, exports) {

$parcel$export(module.exports, "useSubmenuPersistentFocus", () => $867263bf48b9fe05$export$c220508d7e1c51c3);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $1HF4Y = parcelRequire("1HF4Y");

var $ewaBk = parcelRequire("ewaBk");
const $867263bf48b9fe05$export$c220508d7e1c51c3 = ({ scope: scope, menuItem: menuItem })=>{
    const isOpen = (0, $ewaBk.useMenuItemCheckOpen)({
        scope: scope,
        menuItem: menuItem
    });
    const hasSearchOld = (0, $5uXOq.useMemo)(()=>{
        if (!Array.isArray(menuItem.children)) return false;
        return /*#__PURE__*/ (0, $5uXOq.isValidElement)(menuItem.element) ? menuItem.element.props.hasSearch : menuItem.children?.some((s)=>s.type === (0, $1HF4Y.MenuNodeType).Search && s.hasSearch);
    }, [
        menuItem.element,
        menuItem.children
    ]);
    const hasSearchNew = (0, $5uXOq.useMemo)(()=>{
        if (/*#__PURE__*/ (0, $5uXOq.isValidElement)(menuItem.element)) return menuItem.element.props.hasSearch;
        const children = Array.isArray(menuItem.children) ? menuItem.children : [
            menuItem.children
        ];
        return children.some((child)=>child?.type === (0, $1HF4Y.MenuNodeType).Search && child.hasSearch);
    }, [
        menuItem.element,
        menuItem.children
    ]);
    const hasSearch = (0, $4R6GH.fg)('jfp_a11y_team_boards_list_markup_used_incorrectly') ? hasSearchNew : hasSearchOld;
    const [persistentFocus, setPersistentFocus] = (0, $5uXOq.useState)(hasSearch);
    const disablePersistentFocus = (0, $5uXOq.useCallback)(()=>{
        if (!hasSearch) setPersistentFocus(false);
    }, [
        hasSearch
    ]);
    return {
        persistentFocus: persistentFocus && isOpen,
        enablePersistentFocus: ()=>{
            setPersistentFocus(true);
        },
        disablePersistentFocus: disablePersistentFocus,
        isOpen: isOpen
    };
};

});


parcelRegister("5u1jX", function(module, exports) {

$parcel$export(module.exports, "ContextMenuSection", () => $daff62afbe1eff3f$export$804016f6c3dde223);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

const $daff62afbe1eff3f$export$804016f6c3dde223 = ({ section: section, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": (0, $b98e06fd6c153c34$export$6f322a4f1f85b809)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($daff62afbe1eff3f$var$ContextMenuSectionLabel, null, section.label), children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $daff62afbe1eff3f$var$ContextMenuSectionLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81o8v _syaz1gjq _ca0q1b66 _u5f3u2gc _n3td1b66 _19bvu2gc _1p1dangw",
            __cmplp.className
        ])
    });
});

});
const $b98e06fd6c153c34$export$6f322a4f1f85b809 = 'software-context-menu.ui.context-menu-inner.context-menu-node.context-menu-section';



parcelRegister("9Mj0A", function(module, exports) {

$parcel$export(module.exports, "ContextMenuInner", () => $c120d179a7545147$export$bcdb1c07321c5951);
$parcel$export(module.exports, "A11yList", () => $c120d179a7545147$export$eb8d03735465a5c2);
$parcel$export(module.exports, "A11yListItem", () => $c120d179a7545147$export$c545894512c6d817);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $iAbh9 = parcelRequire("iAbh9");

var $4R6GH = parcelRequire("4R6GH");

var $7D59a = parcelRequire("7D59a");

var $1HF4Y = parcelRequire("1HF4Y");

var $duCCb = parcelRequire("duCCb");

var $6U9Sv = parcelRequire("6U9Sv");

var $ewaBk = parcelRequire("ewaBk");

var $1z3OV = parcelRequire("1z3OV");

var $9uF0N = parcelRequire("9uF0N");

var $8KGNe = parcelRequire("8KGNe");
const $c120d179a7545147$export$bcdb1c07321c5951 = ({ scope: scope, menuItems: menuItems, openPath: openPath, shouldRenderToParent: shouldRenderToParent = true })=>{
    const { closeMenu: closeMenu, openSubMenu: openSubMenu, closeSubMenu: closeSubMenu, setForcedFocusPath: setForcedFocusPath, setPersistentFocus: setPersistentFocus } = (0, $ewaBk.useContextMenuActions)();
    const previousItemFocusPath = (0, $5uXOq.useRef)(undefined);
    const { addMappedAnalyticsToEvent: addMappedAnalyticsToEvent, fireUIAnalyticsForNode: fireUIAnalyticsForNode } = (0, $6U9Sv.useContextMenuAnalytics)();
    const bulkOpsFlow = (0, $iAbh9.useBulkOpsSessionContext)();
    const isPersistentFocus = (0, $ewaBk.useIsPersistentFocus)();
    const handleOpenSubMenu = (0, $5uXOq.useCallback)((menuItem)=>{
        previousItemFocusPath.current = menuItem.id;
        openSubMenu(scope, menuItem);
    }, [
        scope,
        openSubMenu
    ]);
    const handleCloseSubMenu = (0, $5uXOq.useCallback)(()=>{
        closeSubMenu(scope);
    }, [
        scope,
        closeSubMenu
    ]);
    const onClickContentMenuNode = (0, $7D59a.useEvent)((menuItem, analyticsEvent)=>{
        if (menuItem.type === (0, $1HF4Y.MenuNodeType).Item) {
            if ((0, $8KGNe.hasSubmenuItems)(menuItem)) {
                if (!(0, $8KGNe.isSubmenuOpen)(openPath)) // clicked on menu item - submenu closed
                handleOpenSubMenu(menuItem);
                else if ((0, $8KGNe.isSubmenuOpenForNode)(menuItem, openPath)) // click on opened menu item - submenu open
                handleCloseSubMenu();
                else if (!(0, $8KGNe.isSubmenuOpenForNode)(menuItem, openPath)) {
                    // clicked on different menu item - submenu open
                    handleCloseSubMenu();
                    handleOpenSubMenu(menuItem);
                }
            } else {
                // clicked on root menu item
                const event = addMappedAnalyticsToEvent(analyticsEvent, menuItem.id, menuItem.analytics);
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                menuItem.onClick?.(event.clone());
                bulkOpsFlow?.executeAction();
                const attributes = bulkOpsFlow?.getFlowAttributes();
                fireUIAnalyticsForNode(event, menuItem.id, menuItem.analytics, attributes);
                closeMenu(scope);
            }
        }
    });
    const onMouseEnter = (0, $7D59a.useEvent)((menuItem)=>{
        if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) {
            if (menuItem.type === (0, $1HF4Y.MenuNodeType).Item) menuItem.onMouseEnter?.();
        }
        if (isPersistentFocus) setPersistentFocus(false);
        if (!(0, $8KGNe.isSubmenuOpenForNode)(menuItem, openPath) && menuItem.type === (0, $1HF4Y.MenuNodeType).Item && (0, $8KGNe.hasSubmenuItems)(menuItem)) {
            /*
                 setTimeout is needed to avoid conflicting situation, when 2 updates are being kicked off
                 at the same time because react-sweet-state batches updates.
                */ setTimeout(()=>{
                // hovered on menu item - submenu closed
                handleOpenSubMenu(menuItem);
            }, 0);
            return;
        }
        if ((0, $8KGNe.isSubmenuOpen)(openPath) && !(0, $8KGNe.isSubmenuOpenForNode)(menuItem, openPath)) {
            // We don't want to focus any element when closing a submenu because of `mouseLeave`
            previousItemFocusPath.current = undefined;
            closeSubMenu(scope);
        }
        if (!(0, $4R6GH.fg)('one_event_rules_them_all_fg')) {
            if (menuItem.type === (0, $1HF4Y.MenuNodeType).Item) menuItem.onMouseEnter?.();
        }
    });
    const renderNode = (0, $5uXOq.useCallback)((node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1z3OV.ContextMenuNode), {
            scope: scope,
            menuNode: node,
            onClick: onClickContentMenuNode,
            onMouseEnter: onMouseEnter,
            shouldRenderToParent: shouldRenderToParent
        }), [
        onClickContentMenuNode,
        onMouseEnter,
        scope,
        shouldRenderToParent
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, $8KGNe.isSubmenuOpen)(openPath) && previousItemFocusPath.current !== undefined) {
            setForcedFocusPath(scope, previousItemFocusPath.current);
            previousItemFocusPath.current = undefined;
        }
    }, [
        openPath,
        scope,
        setForcedFocusPath
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const handleEscapeNavigation = (ev)=>{
            if (ev.key === 'Escape') {
                ev.preventDefault();
                if ((0, $8KGNe.isSubmenuOpen)(openPath)) handleCloseSubMenu();
                else closeMenu(scope);
            }
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('keyup', handleEscapeNavigation);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('keyup', handleEscapeNavigation);
        };
    }, [
        scope,
        closeMenu,
        handleCloseSubMenu,
        openPath
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9uF0N.FocusLockedWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $duCCb.ContextMenuNodeList), {
        menuNodes: menuItems,
        renderNode: renderNode
    }));
};
const $c120d179a7545147$export$eb8d03735465a5c2 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
});
const $c120d179a7545147$export$c545894512c6d817 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9uF0N", function(module, exports) {

$parcel$export(module.exports, "FocusLockedWrapper", () => $d7f44222f705e1f7$export$788065bfcceceaa3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $ao4Ml = parcelRequire("ao4Ml");


var $6ssLS = parcelRequire("6ssLS");

var $ewaBk = parcelRequire("ewaBk");
const $d7f44222f705e1f7$var$WrapperDiv = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ onFocus: onFocus, children: children }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d7f44222f705e1f7$var$ContextMenuInnerContainer, {
        ref: ref,
        onFocus: onFocus,
        "data-testid": (0, $d9cdb1c71f9dbf8c$export$f4f3847a7eaec9e9)
    }, children));
const $d7f44222f705e1f7$export$788065bfcceceaa3 = ({ children: children })=>{
    const isPersistentFocus = (0, $ewaBk.useIsPersistentFocus)();
    const [focuslockDisabled, setFocuslockDisabled] = (0, $5uXOq.useState)(!isPersistentFocus);
    const ref = (0, $5uXOq.useRef)(null);
    const onFocus = (0, $5uXOq.useCallback)((e)=>{
        if (focuslockDisabled && ref.current?.contains(e.target)) setFocuslockDisabled(false);
    }, [
        focuslockDisabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d7f44222f705e1f7$var$WrapperDiv, {
        onFocus: onFocus,
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ao4Ml.default), {
        disabled: focuslockDisabled,
        persistentFocus: isPersistentFocus,
        autoFocus: false
    }, children));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d7f44222f705e1f7$var$ContextMenuInnerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $6ssLS.MenuContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1pby1nn1 _1reoewfl _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});

parcelRegister("8KGNe", function(module, exports) {

$parcel$export(module.exports, "hasSubmenuItems", () => $c903fbd3aaf7f502$export$a141a5e74a818335);
$parcel$export(module.exports, "isSubmenuOpen", () => $c903fbd3aaf7f502$export$5870693bd83d8526);
$parcel$export(module.exports, "isSubmenuOpenForNode", () => $c903fbd3aaf7f502$export$e36cf825fe8902f3);

var $5uXOq = parcelRequire("5uXOq");

var $gccSB = parcelRequire("gccSB");
const $c903fbd3aaf7f502$var$hasChildren = (children)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(children)) return false;
    return Array.isArray(children) ? children.length > 0 : true;
};
const $c903fbd3aaf7f502$export$a141a5e74a818335 = (menuNode)=>/*#__PURE__*/ (0, $5uXOq.isValidElement)(menuNode.element) || $c903fbd3aaf7f502$var$hasChildren(menuNode.children);
const $c903fbd3aaf7f502$export$5870693bd83d8526 = (openPath)=>!!openPath;
const $c903fbd3aaf7f502$export$e36cf825fe8902f3 = (menuNode, openPath)=>$c903fbd3aaf7f502$export$5870693bd83d8526(openPath) && menuNode.id.startsWith(openPath);

});


parcelRegister("64FxD", function(module, exports) {

$parcel$export(module.exports, "UnlinkMenuItem", () => $afa52bde1cb88c47$export$bbb2afae2486e136);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $1HF4Y = parcelRequire("1HF4Y");

var $569Yl = parcelRequire("569Yl");

var $5L7dD = parcelRequire("5L7dD");

var $9nlJl = parcelRequire("9nlJl");

var $3qT29 = parcelRequire("3qT29");
const $afa52bde1cb88c47$export$bbb2afae2486e136 = ({ selectedCardIds: selectedCardIds, label: label, menuItemNodeArgs: menuItemNodeArgs })=>{
    const removeIssuesFromAllVersions = (0, $5L7dD.useRemoveIssuesFromAllVersionsMutation)();
    const fireAnalyticsEnd = (0, $3qT29.useVersionEndAnalytics)({
        selectedCardIds: selectedCardIds
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $569Yl.ContextMenuItem), {
        ...menuItemNodeArgs,
        menuItem: {
            type: (0, $1HF4Y.MenuNodeType).Item,
            id: `${(0, $9nlJl.VERSION_MENU_ID)}/menu/value__unlink`,
            label: label,
            onClick: (analyticsEvent)=>{
                removeIssuesFromAllVersions(selectedCardIds, analyticsEvent);
                if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) fireAnalyticsEnd();
            }
        }
    });
};

});
parcelRegister("5L7dD", function(module, exports) {

$parcel$export(module.exports, "useRemoveIssuesFromAllVersionsMutation", () => $b825e2a5e9ece079$export$a54d2e97907396b7);

var $3k05e = parcelRequire("3k05e");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $2YZCu = parcelRequire("2YZCu");

var $pa9q9 = parcelRequire("pa9q9");

var $8zOmE = parcelRequire("8zOmE");

var $98kub = parcelRequire("98kub");

var $koeKL = parcelRequire("koeKL");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $87wCD = parcelRequire("87wCD");


var $66hgZ = parcelRequire("66hgZ");
const $b825e2a5e9ece079$export$a54d2e97907396b7 = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const boardId = (0, $c1MAf.useBacklogSelector)((state)=>Number((0, $jG5HW.getRapidViewId)(state)));
    const boardAri = (0, $98kub.createBoardAri)(cloudId, boardId);
    const onIssueVersionsUpdated = (0, $87wCD.useOnIssueVersionsUpdated)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const [commitFn] = (0, $8Uumt.useMutation)((0, $3k05e.default));
    const removeIssuesFromAllVersionsCallback = (0, $5uXOq.useCallback)((issueIds, analyticsEvent)=>{
        commitFn({
            variables: {
                input: {
                    issueIds: (0, $98kub.createIssueAris)(cloudId, issueIds)
                },
                boardId: boardAri
            },
            onCompleted: ()=>{
                // Request card data refresh for redux state and detail view if its open
                onIssueVersionsUpdated(issueIds);
                (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'field updated', {
                    analyticsSource: (0, $a9c483c0d986286a$export$840e3848643f7781),
                    operation: 'removeIssuesFromAllVersions',
                    isContextualEditing: true
                });
            },
            onError: (error)=>{
                showFlag({
                    messageId: 'software-backlog.common.hooks.use-remove-issues-from-all-versions-mutation.show-flag.error',
                    messageType: 'transactional',
                    type: 'error',
                    title: (0, $66hgZ.default).versionUpdateErrorTitle,
                    description: (0, $66hgZ.default).versionUpdateErrorDescription
                });
                (0, $2YZCu.default).safeErrorWithoutCustomerData('jiraSoftwareContextMenu.jira.backlog.version.removeVersions', 'An error occurred when removing versions from issues in AGG', error);
                (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'field updateFailed', {
                    operation: 'removeIssuesFromAllVersions',
                    analyticsSource: (0, $a9c483c0d986286a$export$840e3848643f7781),
                    error: error,
                    isContextualEditing: true
                });
            }
        });
    }, [
        cloudId,
        boardAri,
        commitFn,
        onIssueVersionsUpdated,
        showFlag
    ]);
    return removeIssuesFromAllVersionsCallback;
};

});
parcelRegister("3k05e", function(module, exports) {

$parcel$export(module.exports, "default", () => $c283a660b1b1edf9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ddedc87a4159eb73f26313774687d3e9>>
 * @relayHash 683e4da8626dcc0d474626254f8c4451
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 84693c66373eb6838bde9f4971edaeeae3cd72edb831112d21dce98c601aee8e

var $i7FzY = parcelRequire("i7FzY");
const $c283a660b1b1edf9$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "boardId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "concreteType": "JiraVersionIssueUpdateResult",
        "kind": "LinkedField",
        "name": "issueUpdateResults",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "issueId"
            },
            {
                "kind": "ScalarField",
                "name": "updated"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useRemoveIssuesFromAllVersionsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraRemoveIssuesFromAllFixVersionsPayload",
                            "kind": "LinkedField",
                            "name": "removeIssuesFromAllFixVersions",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "versions",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "content_softwareVersionBacklogPanelRelay_jiraVersionFragment"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcismanageversionspermissionenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "useRemoveIssuesFromAllVersionsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraRemoveIssuesFromAllFixVersionsPayload",
                            "kind": "LinkedField",
                            "name": "removeIssuesFromAllFixVersions",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "versions",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "versionId"
                                        },
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "description"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "status"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "startDate"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "releaseDate"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "boardId",
                                                    "variableName": "boardId"
                                                }
                                            ],
                                            "concreteType": "JiraVersionStatistics",
                                            "kind": "LinkedField",
                                            "name": "statistics",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "doneEstimate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "totalEstimate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "percentageCompleted"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "notEstimated"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "done"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "totalIssueCount"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "toDo"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "inProgress"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "key"
                                                },
                                                v6 /*: any*/ ,
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcismanageversionspermissionenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "alias": "editProjectConfig",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "type",
                                                                    "value": "EDIT_PROJECT_CONFIG"
                                                                }
                                                            ],
                                                            "concreteType": "JiraProjectAction",
                                                            "kind": "LinkedField",
                                                            "name": "action",
                                                            "plural": false,
                                                            "selections": v7 /*: any*/ ,
                                                            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcismanageversionspermissionenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "alias": "canManageVersions",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "type",
                                                                    "value": "MANAGE_VERSIONS"
                                                                }
                                                            ],
                                                            "concreteType": "JiraProjectAction",
                                                            "kind": "LinkedField",
                                                            "name": "action",
                                                            "plural": false,
                                                            "selections": v7 /*: any*/ ,
                                                            "storageKey": "action(type:\"MANAGE_VERSIONS\")"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ClientExtension",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__id"
                                                }
                                            ]
                                        },
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "84693c66373eb6838bde9f4971edaeeae3cd72edb831112d21dce98c601aee8e",
            "metadata": {},
            "name": "useRemoveIssuesFromAllVersionsMutation",
            "operationKind": "mutation",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcismanageversionspermissionenabledrelayprovider": (0, $i7FzY.default)
            }
        }
    };
}();
$c283a660b1b1edf9$var$node.hash = "d60aafd65f63c4583af72cc4c256ebbf";
var $c283a660b1b1edf9$export$2e2bcd8739ae039 = $c283a660b1b1edf9$var$node;

});

parcelRegister("98kub", function(module, exports) {

$parcel$export(module.exports, "createBoardAri", () => $cad1f489de8b3413$export$a9ef0ce47eb35304);
$parcel$export(module.exports, "createIssueAris", () => $cad1f489de8b3413$export$7a8bc17d57772015);

var $dXq4S = parcelRequire("dXq4S");
const $cad1f489de8b3413$export$a9ef0ce47eb35304 = (cloudId, boardId)=>(0, $dXq4S.createAri)({
        resourceOwner: 'jira-software',
        cloudId: cloudId,
        resourceType: 'board',
        resourceId: String(boardId)
    });
const $cad1f489de8b3413$export$6b0ec881a3540845 = (cloudId, issueId)=>(0, $dXq4S.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'issue',
        resourceId: issueId.toString()
    });
const $cad1f489de8b3413$export$7a8bc17d57772015 = (cloudId, issueIds)=>issueIds.map((issueId)=>$cad1f489de8b3413$export$6b0ec881a3540845(cloudId, issueId));

});

parcelRegister("66hgZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $76c80fa85725559e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $76c80fa85725559e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    // non-final until text is finalised
    versionUpdateErrorTitle: {
        "id": "backlog.common.hooks.version-update-error-title-non-final",
        "defaultMessage": "Failed to update"
    },
    versionUpdateErrorDescription: {
        "id": "backlog.common.hooks.version-update-error-description-non-final",
        "defaultMessage": "Refresh the page and try again."
    }
});

});


parcelRegister("3qT29", function(module, exports) {

$parcel$export(module.exports, "useVersionEndAnalytics", () => $f80db69cb869a595$export$de31a932841c0a87);

var $4R6GH = parcelRequire("4R6GH");

var $ctrpc = parcelRequire("ctrpc");

var $5fc53 = parcelRequire("5fc53");

var $2NMNM = parcelRequire("2NMNM");
const $f80db69cb869a595$export$de31a932841c0a87 = ({ selectedCardIds: selectedCardIds })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return ()=>{
        if (!(0, $4R6GH.fg)('one_event_rules_them_all_fg')) return;
        if (selectedCardIds.length !== 1) return;
        (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd((0, $5fc53.FIX_VERSIONS_TYPE), {
            analytics: createAnalyticsEvent({}),
            attributes: {
                fieldType: (0, $5fc53.VERSION_CF_TYPE)
            }
        });
    };
};

});


parcelRegister("cHomS", function(module, exports) {

$parcel$export(module.exports, "VersionMenuItem", () => $80374c424d657fc6$export$ea9d65dd05b6ef3d);

var $c8QhZ = parcelRequire("c8QhZ");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $1HF4Y = parcelRequire("1HF4Y");

var $569Yl = parcelRequire("569Yl");

var $5lB2h = parcelRequire("5lB2h");

var $9nlJl = parcelRequire("9nlJl");

var $3qT29 = parcelRequire("3qT29");
const $80374c424d657fc6$export$ea9d65dd05b6ef3d = ({ selectedCardIds: selectedCardIds, versionEdge: versionEdge, menuItemNodeArgs: menuItemNodeArgs })=>{
    const { node: { id: versionAri, versionId: versionId, name: name } } = (0, $8Uumt.useFragment)((0, $c8QhZ.default), versionEdge);
    const addIssuesToVersionMutation = (0, $5lB2h.useAddIssuesToVersionMutation)();
    const fireAnalyticsEnd = (0, $3qT29.useVersionEndAnalytics)({
        selectedCardIds: selectedCardIds
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $569Yl.ContextMenuItem), {
        ...menuItemNodeArgs,
        menuItem: {
            type: (0, $1HF4Y.MenuNodeType).Item,
            id: `${(0, $9nlJl.VERSION_MENU_ID)}/menu/value__${versionId}`,
            label: name,
            onClick: (analyticsEvent)=>{
                addIssuesToVersionMutation(selectedCardIds, versionAri, analyticsEvent);
                if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) fireAnalyticsEnd();
            }
        }
    });
};

});
parcelRegister("c8QhZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdc119bf92adc52a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fdc3b26ca7718aac65ae162c41620f87>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $cdc119bf92adc52a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "versionMenuItem_softwareBacklog",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraVersion",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        "action": "THROW",
                        "path": "node.id"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "versionId"
                        },
                        "action": "THROW",
                        "path": "node.versionId"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        "action": "THROW",
                        "path": "node.name"
                    }
                ]
            },
            "action": "THROW",
            "path": "node"
        }
    ],
    "type": "JiraVersionEdge"
};
$cdc119bf92adc52a$var$node.hash = "abd3a2327d76d6cec48e7802950c72b4";
var $cdc119bf92adc52a$export$2e2bcd8739ae039 = $cdc119bf92adc52a$var$node;

});

parcelRegister("5lB2h", function(module, exports) {

$parcel$export(module.exports, "useAddIssuesToVersionMutation", () => $61933e51e48e09a3$export$af7b1139de7c94fd);

var $1MyL6 = parcelRequire("1MyL6");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $2YZCu = parcelRequire("2YZCu");

var $pa9q9 = parcelRequire("pa9q9");

var $8zOmE = parcelRequire("8zOmE");

var $98kub = parcelRequire("98kub");

var $koeKL = parcelRequire("koeKL");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $87wCD = parcelRequire("87wCD");


var $66hgZ = parcelRequire("66hgZ");
const $61933e51e48e09a3$export$af7b1139de7c94fd = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const boardId = (0, $c1MAf.useBacklogSelector)((state)=>Number((0, $jG5HW.getRapidViewId)(state)));
    const boardAri = (0, $98kub.createBoardAri)(cloudId, boardId);
    const onIssueVersionsUpdated = (0, $87wCD.useOnIssueVersionsUpdated)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const [commitFn] = (0, $8Uumt.useMutation)((0, $1MyL6.default));
    const addIssuesToVersionCallback = (0, $5uXOq.useCallback)((issueIds, versionAri, analyticsEvent)=>{
        commitFn({
            variables: {
                input: {
                    issueIds: (0, $98kub.createIssueAris)(cloudId, issueIds),
                    versionId: versionAri
                },
                boardId: boardAri
            },
            onCompleted: ()=>{
                // Request card data refresh for redux state and detail view if its open
                onIssueVersionsUpdated(issueIds);
                (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'field updated', {
                    analyticsSource: (0, $a9c483c0d986286a$export$840e3848643f7781),
                    operation: 'addIssuesToVersion',
                    versionAri: versionAri,
                    isContextualEditing: true
                });
            },
            onError: (error)=>{
                showFlag({
                    messageId: 'software-backlog.common.hooks.use-add-issues-to-version-mutation.show-flag.error',
                    messageType: 'transactional',
                    type: 'error',
                    title: (0, $66hgZ.default).versionUpdateErrorTitle,
                    description: (0, $66hgZ.default).versionUpdateErrorDescription
                });
                (0, $2YZCu.default).safeErrorWithoutCustomerData('jiraSoftwareContextMenu.jira.backlog.version.addVersion', 'An error occurred when adding a version to issues in AGG', error);
                (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'field updateFailed', {
                    analyticsSource: (0, $a9c483c0d986286a$export$840e3848643f7781),
                    operation: 'addIssuesToVersion',
                    error: error,
                    versionAri: versionAri,
                    isContextualEditing: true
                });
            }
        });
    }, [
        cloudId,
        boardAri,
        commitFn,
        onIssueVersionsUpdated,
        showFlag
    ]);
    return addIssuesToVersionCallback;
};

});
parcelRegister("1MyL6", function(module, exports) {

$parcel$export(module.exports, "default", () => $74458424bfb38374$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e6a1a91d8dc944329e121d857733d6be>>
 * @relayHash 1e6bcc98dd35ec6eaeb74632645b2d13
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 827fd8b06471c896a386a75971cfc509f66d7643e7d62f44335d91fa45b2e8f5

var $i7FzY = parcelRequire("i7FzY");

var $iWXRl = parcelRequire("iWXRl");
const $74458424bfb38374$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "boardId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ], v7 = [
        {
            "alias": "editProjectConfig",
            "args": [
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "EDIT_PROJECT_CONFIG"
                }
            ],
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": v6 /*: any*/ ,
            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useAddIssuesToVersionMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraAddIssuesToFixVersionPayload",
                            "kind": "LinkedField",
                            "name": "addIssuesToFixVersion",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "versionCard_softwareVersionBacklogPanelRelay_jiraVersionFragment"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcvisualrefresheap2relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcismanageversionspermissionenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "useAddIssuesToVersionMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraAddIssuesToFixVersionPayload",
                            "kind": "LinkedField",
                            "name": "addIssuesToFixVersion",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "versionId"
                                        },
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "description"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "status"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "startDate"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "releaseDate"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "boardId",
                                                    "variableName": "boardId"
                                                }
                                            ],
                                            "concreteType": "JiraVersionStatistics",
                                            "kind": "LinkedField",
                                            "name": "statistics",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "doneEstimate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "totalEstimate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "percentageCompleted"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "notEstimated"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "done"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "totalIssueCount"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "toDo"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "inProgress"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "key"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcismanageversionspermissionenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": v7 /*: any*/ 
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcismanageversionspermissionenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "alias": "canManageVersions",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "type",
                                                                    "value": "MANAGE_VERSIONS"
                                                                }
                                                            ],
                                                            "concreteType": "JiraProjectAction",
                                                            "kind": "LinkedField",
                                                            "name": "action",
                                                            "plural": false,
                                                            "selections": v6 /*: any*/ ,
                                                            "storageKey": "action(type:\"MANAGE_VERSIONS\")"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcvisualrefresheap2relayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": v7 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ClientExtension",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__id"
                                                }
                                            ]
                                        },
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "827fd8b06471c896a386a75971cfc509f66d7643e7d62f44335d91fa45b2e8f5",
            "metadata": {},
            "name": "useAddIssuesToVersionMutation",
            "operationKind": "mutation",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcvisualrefresheap2relayprovider": (0, $iWXRl.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcismanageversionspermissionenabledrelayprovider": (0, $i7FzY.default)
            }
        }
    };
}();
$74458424bfb38374$var$node.hash = "78cd3b934e90c86f1f62037be8c3d343";
var $74458424bfb38374$export$2e2bcd8739ae039 = $74458424bfb38374$var$node;

});





parcelRegister("chkmj", function(module, exports) {

$parcel$export(module.exports, "useViewInIssueSearch", () => $5288dd69845cfb78$export$95e4f0766878a325);

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $1HF4Y = parcelRequire("1HF4Y");

var $lVJAU = parcelRequire("lVJAU");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");

var $9nlJl = parcelRequire("9nlJl");

var $5Mhvq = parcelRequire("5Mhvq");
const $5288dd69845cfb78$export$b95edc2172de41fe = ({ selectedCardIds: selectedCardIds, cardEntities: cardEntities })=>{
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleClick = ()=>{
        const issueKeys = selectedCardIds.map((id)=>cardEntities[String(id)].key);
        const query = encodeURIComponent(`issuekey IN (${issueKeys.join(',')})`);
        push(`/issues/?jql=${query}`);
    };
    if (selectedCardIds.length < 2) return [];
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5Mhvq.default).viewInIssueSearchIssueTermRefresh : (0, $5Mhvq.default).viewInIssueSearch),
            id: (0, $9nlJl.VIEW_IN_ISSUE_SEARCH_MENU_ID),
            onClick: handleClick
        }
    ];
};
const $5288dd69845cfb78$export$95e4f0766878a325 = ({ selectedCardIds: selectedCardIds })=>{
    const cardEntities = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCards));
    return $5288dd69845cfb78$export$b95edc2172de41fe({
        selectedCardIds: selectedCardIds,
        cardEntities: cardEntities
    });
};

});

parcelRegister("jN95k", function(module, exports) {

$parcel$export(module.exports, "default", () => $78470904968aca83$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $g4tDr = parcelRequire("g4tDr");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");
const $78470904968aca83$var$useCardsIncludeSubtasksWithoutParents = (cardIds)=>{
    const selectedCards = (0, $c1MAf.useBacklogSelector)((state)=>{
        const allCards = (0, $dGljH.getCards)(state);
        return cardIds.map((cardId)=>allCards[cardId]).filter(Boolean);
    });
    const selectedSubtasks = (0, $5uXOq.useMemo)(()=>selectedCards.filter(({ typeHierarchyLevel: typeHierarchyLevel })=>(0, $g4tDr.isSubtaskHierarchyLevel)(typeHierarchyLevel)), [
        selectedCards
    ]);
    return (0, $5uXOq.useMemo)(()=>selectedSubtasks.some(({ parentId: parentId })=>parentId && !cardIds.includes(parentId)), [
        cardIds,
        selectedSubtasks
    ]);
};
var $78470904968aca83$export$2e2bcd8739ae039 = $78470904968aca83$var$useCardsIncludeSubtasksWithoutParents;

});


parcelRegister("5OkdV", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f17efb921d4520a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4R6GH = parcelRequire("4R6GH");

var $2eMTS = parcelRequire("2eMTS");

var $3fAi8 = parcelRequire("3fAi8");


var $kxZPA = parcelRequire("kxZPA");


var $dspDn = parcelRequire("dspDn");

var $fSgHa = parcelRequire("fSgHa");

var $dM9vk = parcelRequire("dM9vk");

var $kAodW = parcelRequire("kAodW");

const $2f17efb921d4520a$export$3ddafe6eb894bff8 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("TXhYQ")), {
    moduleId: "./src/packages/issue/fields/assignee/src/ui/popover/index.tsx"
});
const $2f17efb921d4520a$var$AssigneeField = ({ isUserAtLeastMember: isUserAtLeastMember, shouldRenderRichCard: shouldRenderRichCard, issueKey: issueKey, issueId: issueId, assignee: assignee })=>{
    const isCompanyManaged = (0, $fSgHa.useIsCMPBacklog)();
    const [assigneeFieldValue] = (0, $3fAi8.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $e9be48d6d2c01760$export$e18419056f3d184a)
    });
    const value = assigneeFieldValue ? {
        id: assigneeFieldValue.accountId,
        displayName: assigneeFieldValue.displayName,
        avatarUrl: assigneeFieldValue.avatarUrls?.['48x48']
    } : null;
    const issueAssigneeFieldStatic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kAodW.default), {
        value: (0, $4R6GH.fg)('jsw-backlog-assignee-field-render') ? assignee : value
    });
    const handleChange = (0, $5uXOq.useCallback)(()=>{
        (0, $dspDn.setInlineEditAssigneeInteractionStartMark)();
    }, []);
    const handleUpdate = (0, $5uXOq.useCallback)(()=>{
        (0, $dspDn.setInlineEditAssigneeInteractionStopMark)(isCompanyManaged);
    }, [
        isCompanyManaged
    ]);
    const handleFailure = (0, $5uXOq.useCallback)(()=>{
        (0, $dspDn.cancelInlineEditAssigneeInteractionMark)();
    }, []);
    if (isUserAtLeastMember && shouldRenderRichCard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2eMTS.IssueAssigneeFieldBoundary), {
        packageName: (0, $a9c483c0d986286a$export$dfd208682d29484c),
        fallback: issueAssigneeFieldStatic
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dM9vk.default), {
        experienceTarget: "inline assignee",
        experienceTargetId: issueKey,
        additionalAttributes: {
            issueKey: issueKey
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2f17efb921d4520a$var$AssigneeFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2f17efb921d4520a$export$3ddafe6eb894bff8, {
        issueKey: issueKey,
        issueId: issueId,
        shouldPreloadAssignToMe: true,
        onChange: handleChange,
        onUpdate: handleUpdate,
        onFailure: handleFailure
    }))));
    return issueAssigneeFieldStatic;
};
var $2f17efb921d4520a$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $5uXOq.memo)($2f17efb921d4520a$var$AssigneeField);
const $2f17efb921d4520a$var$AssigneeFieldWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1e0c1txw _4cvr1h6o _vsj07079 _qedf1kev _c6p11h90 _15m21prr _96l5agmp _1hgltlke _1j3t6smz",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2eMTS", function(module, exports) {

$parcel$export(module.exports, "AsyncLazyIssueAssigneeField", () => $40ac4b7314747a71$export$3eed76542de607d2);
$parcel$export(module.exports, "AsyncIssueAssigneeField", () => $40ac4b7314747a71$export$5cdab73b9e0803a1);
$parcel$export(module.exports, "IssueAssigneeFieldBoundary", () => $40ac4b7314747a71$export$9b541007f4ef3ffe);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $fE0Ry = parcelRequire("fE0Ry");

const $40ac4b7314747a71$export$3eed76542de607d2 = (0, $kxZPA.lazy)(()=>(parcelRequire("TXhYQ")), {
    moduleId: "./src/packages/issue/fields/assignee/src/ui/popover/index.tsx"
});
const $40ac4b7314747a71$export$5cdab73b9e0803a1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "issue-field-assignee",
        packageName: "jira-issue-field-assignee",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fE0Ry.AssigneePickerView), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-assignee-field",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fE0Ry.AssigneePickerView), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($40ac4b7314747a71$export$3eed76542de607d2, props)));
const $40ac4b7314747a71$export$9b541007f4ef3ffe = ({ children: children, fallback: fallback, packageName: packageName, onError: onError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "issue-assignee-field",
        packageName: packageName,
        fallback: fallback ? ()=>fallback : undefined,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-assignee-field-boundary",
        fallback: fallback
    }, children));

});
parcelRegister("TXhYQ", function(module, exports) {

let $0a8320bb08c13612$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0a8320bb08c13612$var$load("2i2PS").then(()=>parcelRequire('278RC'));

});


parcelRegister("dspDn", function(module, exports) {

$parcel$export(module.exports, "setInlineEditStatusInteractionStartMark", () => $c55f61321be216c5$export$1c8cae5dc9b7d34a);
$parcel$export(module.exports, "setInlineEditStatusInteractionStopMark", () => $c55f61321be216c5$export$b1acd52e03abb3b2);
$parcel$export(module.exports, "cancelInlineEditStatusInteractionMark", () => $c55f61321be216c5$export$cdaa2d2685d8101e);
$parcel$export(module.exports, "setInlineEditAssigneeInteractionStartMark", () => $c55f61321be216c5$export$931331f1846e934f);
$parcel$export(module.exports, "setInlineEditAssigneeInteractionStopMark", () => $c55f61321be216c5$export$40692731bc6535c7);
$parcel$export(module.exports, "cancelInlineEditAssigneeInteractionMark", () => $c55f61321be216c5$export$afc1cc386d2100be);
$parcel$export(module.exports, "setInlineEditStoryPointInteractionStartMark", () => $c55f61321be216c5$export$463102067393e83b);
$parcel$export(module.exports, "setInlineEditStoryPointInteractionStopMark", () => $c55f61321be216c5$export$bb93666f630b9a57);
$parcel$export(module.exports, "cancelInlineEditStoryPointInteractionMark", () => $c55f61321be216c5$export$d0a680c7e3623e7b);
$parcel$export(module.exports, "setInlineEditOriginalEstimateInteractionStartMark", () => $c55f61321be216c5$export$781c8c2cc1ad3945);
$parcel$export(module.exports, "setInlineEditOriginalEstimateInteractionStopMark", () => $c55f61321be216c5$export$65678122e1338f09);
$parcel$export(module.exports, "cancelInlineEditOriginalEstimateInteractionMark", () => $c55f61321be216c5$export$b728cf17d787205d);

var $8hVbJ = parcelRequire("8hVbJ");
const $c55f61321be216c5$export$1c8cae5dc9b7d34a = ()=>{
    (0, $8hVbJ.inlineEditStatusInteraction).start();
};
const $c55f61321be216c5$export$b1acd52e03abb3b2 = (isCompanyManaged)=>{
    (0, $8hVbJ.inlineEditStatusInteraction).stop({
        customData: {
            isCompanyManaged: isCompanyManaged
        }
    });
};
const $c55f61321be216c5$export$cdaa2d2685d8101e = ()=>{
    (0, $8hVbJ.inlineEditStatusInteraction).cancel();
};
const $c55f61321be216c5$export$931331f1846e934f = ()=>{
    (0, $8hVbJ.inlineEditAssigneeInteraction).start();
};
const $c55f61321be216c5$export$40692731bc6535c7 = (isCompanyManaged)=>{
    (0, $8hVbJ.inlineEditAssigneeInteraction).stop({
        customData: {
            isCompanyManaged: isCompanyManaged
        }
    });
};
const $c55f61321be216c5$export$afc1cc386d2100be = ()=>{
    (0, $8hVbJ.inlineEditAssigneeInteraction).cancel();
};
const $c55f61321be216c5$export$463102067393e83b = ()=>{
    (0, $8hVbJ.inlineEditStoryPointInteraction).start();
};
const $c55f61321be216c5$export$bb93666f630b9a57 = (isCompanyManaged)=>{
    (0, $8hVbJ.inlineEditStoryPointInteraction).stop({
        customData: {
            isCompanyManaged: isCompanyManaged
        }
    });
};
const $c55f61321be216c5$export$d0a680c7e3623e7b = ()=>{
    (0, $8hVbJ.inlineEditStoryPointInteraction).cancel();
};
const $c55f61321be216c5$export$781c8c2cc1ad3945 = ()=>{
    (0, $8hVbJ.inlineEditOriginalEstimateInteraction).start();
};
const $c55f61321be216c5$export$65678122e1338f09 = (isCompanyManaged)=>{
    (0, $8hVbJ.inlineEditOriginalEstimateInteraction).stop({
        customData: {
            isCompanyManaged: isCompanyManaged
        }
    });
};
const $c55f61321be216c5$export$b728cf17d787205d = ()=>{
    (0, $8hVbJ.inlineEditOriginalEstimateInteraction).cancel();
};

});


parcelRegister("iJZfp", function(module, exports) {

$parcel$export(module.exports, "default", () => $baaa5a692f73b76e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $kkJfY = parcelRequire("kkJfY");

var $iAbh9 = parcelRequire("iAbh9");

var $acDhY = parcelRequire("acDhY");

var $6U9Sv = parcelRequire("6U9Sv");

var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");

var $8SI0F = parcelRequire("8SI0F");

var $c1MAf = parcelRequire("c1MAf");

var $fopK0 = parcelRequire("fopK0");

var $4mqko = parcelRequire("4mqko");

var $fvfVu = parcelRequire("fvfVu");
const $baaa5a692f73b76e$var$CheckboxField = ({ isSelected: isSelected, onClick: onClick, isDisabled: isDisabled, shouldShowCheckbox: shouldShowCheckbox, label: label, isCheckboxSelectionMode: isCheckboxSelectionMode })=>{
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const sessionAttributes = (0, $iAbh9.useBulkOpsSessionContext)()?.getFlowAttributes();
    const { entryPointActions: entryPointActions } = (0, $acDhY.useBulkOpsEntryPoint)();
    const fireCheckboxAnalytics = (0, $6U9Sv.useFireCheckboxAnalytics)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { isDisabled: isCardListDisabled } = (0, $dCm1o.isVisualRefreshEnabled)() ? (0, $fvfVu.useCardListContext)() : {
        isDisabled: false
    };
    const handleKeyDown = (e)=>{
        const withCmd = true; /* always considered true for checkbox as it is used for multiple selection */ 
        const withShift = e.shiftKey;
        if (e.key === 'Space') {
            entryPointActions.load();
            if (!isSelected && !isCheckboxSelectionMode) dispatch((0, $4mqko.cardEmptySelection)());
            if (isSelected && !shouldShowCheckbox) {
                dispatch((0, $8SI0F.setCheckboxSelectionMode)(true));
                return;
            }
            onClick(withCmd, withShift, 'keyboard', true);
        }
    };
    const handleClickCheckbox = (e)=>{
        const withCmd = true; /* always considered true for checkbox as it is used for multiple selection */ 
        const withShift = e.shiftKey;
        entryPointActions.load();
        if (!isSelected && !isCheckboxSelectionMode) dispatch((0, $4mqko.cardEmptySelection)());
        if (isSelected && !shouldShowCheckbox) {
            dispatch((0, $8SI0F.setCheckboxSelectionMode)(true));
            fireCheckboxAnalytics(createAnalyticsEvent({
                action: 'changed',
                actionSubject: 'checkbox'
            }), 'backlogCard', {
                isIssueDetailVisible: true,
                numSelectedCards: 1,
                inputSource: (0, $fopK0.getCardSelectionAnalyticsInputSource)(withShift, withCmd, true),
                isCheckboxChecked: isSelected,
                bulkOpsSessionID: sessionAttributes?.bulkOpsSessionID
            });
            return;
        }
        onClick(withCmd, withShift, 'mouse', true);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
        isChecked: isSelected && shouldShowCheckbox,
        onKeyDown: handleKeyDown,
        onClick: handleClickCheckbox,
        isDisabled: isDisabled,
        "aria-label": label,
        tabIndex: isCardListDisabled && (0, $4R6GH.fg)('tanuki_a11y_q4') ? -1 : undefined
    });
};
var $baaa5a692f73b76e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($baaa5a692f73b76e$var$CheckboxField);

});
parcelRegister("kkJfY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3106eb14f9b0a593$export$2e2bcd8739ae039);
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6QvkM = parcelRequire("6QvkM");

var $5JjdN = parcelRequire("5JjdN");

var $kag1C = parcelRequire("kag1C");
var $7xteU = parcelRequire("7xteU");
var $hsLv2 = parcelRequire("hsLv2");
var $e62YQ = parcelRequire("e62YQ");
const $3106eb14f9b0a593$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf _r050fibj _9bg71mn3 _19op11so _a30fhteq _1610e4h9 _13wo93zu _q5a61gyf _8gq114p8 _wje2mov0 _1fo21cni _eyedglyw _1ef7js4s _1h6rjs4s _smzgj3jf _1dk7j3jf _l71j1i6y _t34a1i6y _y32gkivo _1ah9199y _1frj180l _h78e1g3k _dwvb1ps2 _1bok170n _1mhr17cl _fx2i3rva _10oaq2ws _w12s155b _15y61vek _e6ww155b _sg1j1vek _rphw18jz _y9y9mz2b _141bmz2b _255gmz2b _jj67mz2b _swhgmz2b _axq81diq _1jiz1diq _s9051diq _1efy1diq _1oav1diq _10y313gf _1wt913gf _qq8613gf _1adw13gf _12sr13gf _16jiglyw _693jglyw _1niqglyw _cl9tglyw _1jbnglyw _j1ta1hou _18qu1ps2 _1g52170n _1log17cl _32hzmz2b _1vv91diq _yjhd1hou _w1cowc43 _jdqn1onz _4y4t1onz _lvfrwc43 _g68dwc43 _13dk1onz _w1el1onz _a9yw1onz _1l3g1onz _dcdpgir2 _wobcgir2 _rp9wgir2 _9ebfwc43 _e43iwc43 _1tkuwc43 _1lehwc43 _b9q3wc43 _tu2918qt _1uxv18qt _1ufw18qt _opo918qt _1e8318qt _1k3d18qt _25yv18qt _1igz18qt _c7cc18qt _1swg18qt"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $3106eb14f9b0a593$var$Checkbox = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $5uXOq.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $5uXOq.useRef)(null);
    const mergedRefs = (0, $5JjdN.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $5uXOq.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $7xteU.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $bwpsq.default)([
                    $3106eb14f9b0a593$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kag1C.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $hsLv2.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e62YQ.default), {})
                ]
            })
        ]
    });
}));
$3106eb14f9b0a593$var$Checkbox.displayName = 'Checkbox';
var $3106eb14f9b0a593$export$2e2bcd8739ae039 = $3106eb14f9b0a593$var$Checkbox;

});
parcelRegister("kag1C", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0746a27410bc168$export$2e2bcd8739ae039);
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dV6Te = parcelRequire("dV6Te");

var $VSDnB = parcelRequire("VSDnB");
function $a0746a27410bc168$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
    }
    if (isChecked) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
    }
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $a0746a27410bc168$var$CheckboxIcon = /*#__PURE__*/ (0, $5uXOq.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $5uXOq.useMemo)(()=>$a0746a27410bc168$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dV6Te.default), {
        label: "",
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                (0, $VSDnB.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5"
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    fill: "currentColor",
                    x: "6",
                    y: "6",
                    width: "12",
                    height: "12",
                    rx: "2"
                }),
                icon
            ]
        })
    });
});
var $a0746a27410bc168$export$2e2bcd8739ae039 = $a0746a27410bc168$var$CheckboxIcon;

});

parcelRegister("7xteU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b368d644c230660$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $7b368d644c230660$var$baseStyles = null;
const $7b368d644c230660$var$textLabelLayoutStyles = null;
const $7b368d644c230660$var$disabledStyles = null;
const $7b368d644c230660$var$labelStyles = null;
function $7b368d644c230660$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("label", {
        className: (0, $bwpsq.default)([
            "_11c82smr _1e0c11p5 _1ejihkll _umai184x _syazj3m3 _80om73ad",
            label && "_zulp1nu5 _yv0ey09t",
            isDisabled && "_syaz1tvo _80om13gf",
            "_h5e3mag2 _1nzs11d3 _1eszzyvw _yp0jhh5a _ay2w1y1w _d51u10ko _phft1fmg _1g1funzk _l6wkzyvw _1dikhh5a _1sfg1q3k _fpdj1y1w _1yjc194a _oaj11fmg _1j3h1q3k _eawb1dzn _1rda1qbb _18q015t7 _13hr3acm",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("hsLv2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce636d67b4ff1120$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $ce636d67b4ff1120$var$labelTextStyles = null;
function $ce636d67b4ff1120$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("e62YQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2156c28a3894cac$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $d2156c28a3894cac$var$requiredIndicatorStyles = null;
function $d2156c28a3894cac$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "aria-hidden": true,
        className: (0, $bwpsq.default)([
            "_syaz1gtz _bozgv77o"
        ]),
        children: "*"
    });
}

});



parcelRegister("lM9Tp", function(module, exports) {

$parcel$export(module.exports, "ChildIssuesMetadata", () => $eebdc4e31971c249$export$56b7a8e50535249e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $a5U1O = parcelRequire("a5U1O");

var $hxodJ = parcelRequire("hxodJ");

var $3bDjY = parcelRequire("3bDjY");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $cSD7y = parcelRequire("cSD7y");

var $2EHfW = parcelRequire("2EHfW");
const $eebdc4e31971c249$export$56b7a8e50535249e = ({ numTotalChildren: numTotalChildren, numCompleteChildren: numCompleteChildren, onClickThrough: onClickThrough })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!numTotalChildren) return null;
    const message = formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $2EHfW.default).childIssuesMetadataTooltipIssueTermRefresh : (0, $2EHfW.default).childIssuesMetadataTooltip, {
        complete: numCompleteChildren,
        total: numTotalChildren
    });
    return /*#__PURE__*/ $5uXOq.createElement($eebdc4e31971c249$var$ChildIssuesMetadataWrapper, {
        onClick: onClickThrough,
        tabIndex: (0, $4R6GH.fg)('tanuki_a11y_fixes_drop_2') ? 0 : -1,
        "aria-label": (0, $4R6GH.fg)('tanuki_a11y_fixes_drop_2') ? message : undefined,
        "data-testid": "software-backlog.card-list.card.card-contents.child-issues-metadata"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $3bDjY.default), {
        content: message,
        testId: "software-backlog.card-list.card.card-contents.child-issues-metadata.tooltip"
    }, /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($a5U1O))), {
        testId: "software-backlog.card-list.card.card-contents.child-issues-metadata.child-issues-icon",
        label: "",
        color: "var(--ds-icon-subtle, #626F86)",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($hxodJ))),
        LEGACY_primaryColor: "var(--ds-icon-subtle, #626F86)",
        LEGACY_size: "small"
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $eebdc4e31971c249$var$ChildIssuesMetadataWrapperOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_12ji1r31 _1qu2glyw _12y31o36 _yyhy54tg _1ii7wtyw _1pbykb7n _3rss1txw",
            __cmplp.className
        ])
    });
});
const $eebdc4e31971c249$var$wrapperStyle = null;
const $eebdc4e31971c249$var$ChildIssuesMetadataWrapper = (0, $cSD7y.componentWithFG)('tanuki_a11y_fixes_drop_2', ({ children: children, ...props })=>/*#__PURE__*/ $5uXOq.createElement("div", {
        role: "tooltip",
        ...props,
        className: (0, $bwpsq.default)([
            "_yyhy54tg _1ii7wtyw _1pbykb7n _3rss1txw _19h6gqwt _11ow1bk5 _pbhanqa1 _7glxv77o _1guj1p6i"
        ])
    }, children), $eebdc4e31971c249$var$ChildIssuesMetadataWrapperOld);

});
parcelRegister("a5U1O", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0a33c20b0e9684239e470bd9fc395b3e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7595d510a7cf11ee$var$_react = $7595d510a7cf11ee$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7595d510a7cf11ee$var$_baseNew = $7595d510a7cf11ee$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $7595d510a7cf11ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChildIssues".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for child work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7595d510a7cf11ee$var$ChildIssuesIcon = (props)=>/*#__PURE__*/ $7595d510a7cf11ee$var$_react.default.createElement($7595d510a7cf11ee$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5 4.5V1H1v10a2 2 0 0 0 2 2h4v.75c0 .69.56 1.25 1.25 1.25h5.5c.69 0 1.25-.56 1.25-1.25v-3c0-.69-.56-1.25-1.25-1.25h-5.5c-.69 0-1.25.56-1.25 1.25v.75H3a.5.5 0 0 1-.5-.5V6H7v.75C7 7.44 7.56 8 8.25 8h5.5C14.44 8 15 7.44 15 6.75v-3c0-.69-.56-1.25-1.25-1.25h-5.5C7.56 2.5 7 3.06 7 3.75v.75zm6-.5v2.5h5V4zm0 7v2.5h5V11z" clip-rule="evenodd"/>`
    }, props));
$7595d510a7cf11ee$var$ChildIssuesIcon.displayName = 'ChildIssuesIcon';
var $7595d510a7cf11ee$var$_default = module.exports.default = $7595d510a7cf11ee$var$ChildIssuesIcon;

});

parcelRegister("hxodJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cc484e6d94653edf$var$_react = $cc484e6d94653edf$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $cc484e6d94653edf$var$_childIssues = $cc484e6d94653edf$var$_interopRequireDefault((parcelRequire("a5U1O")));
function $cc484e6d94653edf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $cc484e6d94653edf$var$ChildIssuesIcon = (props)=>/*#__PURE__*/ $cc484e6d94653edf$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11 7h2v5h-2zm5 6h2v3h-2zM6 13h2v3H6z"/><path d="M7 11h10a1 1 0 0 1 1 1v1H6v-1a1 1 0 0 1 1-1"/><path fill-rule="nonzero" d="M5 18v1h4v-1zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2m10 2v1h4v-1zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2M10 5v1h4V5zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2"/></g></svg>`
    }, props, {
        newIcon: $cc484e6d94653edf$var$_childIssues.default
    }));
$cc484e6d94653edf$var$ChildIssuesIcon.displayName = 'ChildIssuesIcon';
var $cc484e6d94653edf$var$_default = module.exports.default = $cc484e6d94653edf$var$ChildIssuesIcon;

});

parcelRegister("2EHfW", function(module, exports) {

$parcel$export(module.exports, "default", () => $567ae6b1bc7ab77c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $567ae6b1bc7ab77c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    childIssuesMetadataTooltip: {
        "id": "backlog.card-list.card.card-contents.child-issues-metadata.child-issues-metadata-tooltip",
        "defaultMessage": "{complete} of {total, plural, one {# child issue} other {# child issues}} complete"
    },
    childIssuesMetadataTooltipIssueTermRefresh: {
        "id": "backlog.card-list.card.card-contents.child-issues-metadata.child-issues-metadata-tooltip-issue-term-refresh",
        "defaultMessage": "{complete} of {total, plural, one {# child work item} other {# child work items}} complete"
    }
});

});


parcelRegister("2JHi9", function(module, exports) {

$parcel$export(module.exports, "Flag", () => $cfab57ca8e812411$export$48ea269755562084);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $42CjB = parcelRequire("42CjB");

var $9ADwJ = parcelRequire("9ADwJ");

var $iyN9w = parcelRequire("iyN9w");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $ctrpc = parcelRequire("ctrpc");

var $2NMNM = parcelRequire("2NMNM");


var $7q84v = parcelRequire("7q84v");

var $cizWc = parcelRequire("cizWc");
const $cfab57ca8e812411$export$48ea269755562084 = ({ isFlagged: isFlagged, shouldRenderInlineAddFlag: shouldRenderInlineAddFlag, onAddFlag: onAddFlag })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleOnAddFlag = (0, $4R6GH.fg)('one_event_rules_them_all_fg') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useCallback)((event)=>{
        onAddFlag(event);
        (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsStart((0, $e9be48d6d2c01760$export$f7a17147527dd688), {
            analytics: createAnalyticsEvent({}),
            attributes: {
                fieldType: (0, $e9be48d6d2c01760$export$f7a17147527dd688),
                actionTaken: 'add',
                isInlineEditing: true
            }
        });
    }, [
        createAnalyticsEvent,
        onAddFlag
    ]) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfab57ca8e812411$var$FlagContainer, {
        "data-testid": (0, $cizWc.FLAG_CONTAINER_TEST_ID)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: isFlagged ? formatMessage((0, $7q84v.default).flaggedTooltip) : formatMessage((0, $7q84v.default).addFlagTooltip)
    }, isFlagged && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9ADwJ))), {
        testId: (0, $cizWc.FLAGGED_BUTTON_TEST_ID),
        label: "Add flag icon",
        color: "var(--ds-icon-danger, #C9372C)",
        spacing: "spacious",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($iyN9w))),
        LEGACY_size: "small",
        LEGACY_primaryColor: "var(--ds-icon-danger, #C9372C)"
    }), !isFlagged && shouldRenderInlineAddFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $cfab57ca8e812411$var$buttonContainerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        label: "Add Flag" // eslint-disable-next-line jira/react-no-inline-function-prop
        ,
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9ADwJ))), {
                ...iconProps,
                label: "Add flag icon",
                color: "var(--ds-text-subtlest, #626F86)",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($iyN9w))),
                LEGACY_size: "small",
                LEGACY_primaryColor: "var(--ds-text-subtlest, #626F86)"
            }),
        appearance: "subtle",
        spacing: "compact",
        onClick: (0, $4R6GH.fg)('one_event_rules_them_all_fg') ? handleOnAddFlag : onAddFlag,
        testId: (0, $cizWc.ADD_FLAG_BUTTON_TEST_ID)
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cfab57ca8e812411$var$FlagContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1pbykb7n",
            __cmplp.className
        ])
    });
});
const $cfab57ca8e812411$var$buttonContainerStyle = (0, $8CUq3.xcss)({
    display: 'inline-block',
    opacity: '0',
    transition: 'opacity .35s ease',
    ':hover': {
        opacity: '1',
        background: 'none'
    }
});

});

parcelRegister("9U5Ic", function(module, exports) {

$parcel$export(module.exports, "default", () => $adb2c821efde046e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $2NMNM = parcelRequire("2NMNM");

var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");

var $7q84v = parcelRequire("7q84v");

var $fvfVu = parcelRequire("fvfVu");
const $adb2c821efde046e$var$InteractionLayer = ({ cardKey: cardKey, summary: summary, onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onBlur: onBlur = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isFocused: isFocused = false })=>{
    const ref = (0, $5uXOq.useRef)(null);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (isFocused === true && ref.current !== null && document.activeElement !== ref.current) ref.current.focus();
    }, [
        isFocused
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleClick = (0, $5uXOq.useCallback)((e)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'issue'
        });
        onClick(e, analyticsEvent);
    }, [
        onClick,
        createAnalyticsEvent
    ]);
    const handleKeyDown = (0, $5uXOq.useCallback)((e)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'issue'
        });
        onKeyDown(e, analyticsEvent);
    }, [
        onKeyDown,
        createAnalyticsEvent
    ]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { isDisabled: isDisabled = false } = (0, $dCm1o.isVisualRefreshEnabled)() ? (0, $fvfVu.useCardListContext)() : {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($adb2c821efde046e$export$42a852a2b6b56249, {
        onClick: handleClick,
        onKeyDown: handleKeyDown,
        tabIndex: isDisabled && (0, $4R6GH.fg)('tanuki_a11y_q4') ? -1 : 0,
        role: "button",
        "aria-label": `${cardKey} ${summary}. ${formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7q84v.default).cardFocusScreenreaderTextIssueTermRefresh : (0, $7q84v.default).cardFocusScreenreaderText)}`,
        "data-testid": "software-backlog.card-list.card.card-contents.interaction-layer.accessible-card",
        onFocus: onFocus,
        onBlur: onBlur,
        ref: ref
    });
};
var $adb2c821efde046e$export$2e2bcd8739ae039 = $adb2c821efde046e$var$InteractionLayer;
const $adb2c821efde046e$var$cardFocusStyles = {
    content: '',
    display: 'block',
    position: 'absolute',
    zIndex: 1,
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    boxShadow: `0 0 0 2px ${"var(--ds-border-focused, #388BFF)"}`,
    pointerEvents: 'none'
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- To migrate as part of go/ui-styling-standard
const $adb2c821efde046e$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _154iidpf _94n5idpf _1ltvidpf _1xi2idpf _nt751r31 _49pcglyw _1hvw1o36 _q5c0kb7n _1lztewfl _h10pb3bt _j7gt1ule _1tfxstnw _1v98kb7n _1a07idpf _ti30idpf _44x7idpf _gabdidpf _1n511vm4 _6q10glyw _zjd3b3bt _1vfc1ule _hkspstnw _1hl4kb7n _ehfnidpf _1btaidpf _1vdbidpf _o6k0idpf _1m551vm4 _1191glyw _1m5564oc _bwdwb3bt _6ycq1ule _1h9dstnw _i6g0kb7n _9jtdidpf _1snmidpf _1jstidpf _pnw9idpf _xp6a1vm4 _15y0glyw _xp6a64oc",
            __cmplp.className
        ])
    });
});

});

parcelRegister("5U2yP", function(module, exports) {

$parcel$export(module.exports, "Key", () => $5747c4050e3d8f18$export$cd0f44441c3b7719);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dqoiX = parcelRequire("dqoiX");

var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");

var $kM28N = parcelRequire("kM28N");

var $cizWc = parcelRequire("cizWc");

var $fvfVu = parcelRequire("fvfVu");

var $1SqXg = parcelRequire("1SqXg");
const $5747c4050e3d8f18$var$stopPropagation = (event)=>event.stopPropagation();
const $5747c4050e3d8f18$export$cd0f44441c3b7719 = ({ isDone: isDone, cardKey: cardKey, issueUrl: issueUrl, summary: summary, highlightText: highlightText, onClick: cardOnClick })=>{
    const onKeyClick = (0, $5uXOq.useCallback)((e)=>{
        const withCmd = e.ctrlKey || e.metaKey;
        if (!withCmd) {
            e.preventDefault();
            cardOnClick(false, false, 'mouse');
        }
    }, [
        cardOnClick
    ]);
    const { isDisabled: isDisabled = false } = (0, $dCm1o.isVisualRefreshEnabled)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $fvfVu.useCardListContext)() : {};
    // When the ScreenReaderKey is focused, it becomes visible and its sibling
    // Key is hidden. This allows the key to behave as a regular link for keyboard
    // users without compromising dnd functionality for mouse users.
    // Previously, the issue page could not be accessed directly via keyboard.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5747c4050e3d8f18$var$KeyContainer, {
        "data-testid": (0, $cizWc.KEY_CONTAINER_TEST_ID),
        onContextMenu: $5747c4050e3d8f18$var$stopPropagation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.ScreenReaderKey), {
        href: issueUrl,
        isDone: isDone,
        "data-testid": (0, $cizWc.SCREEN_READER_KEY_TEST_ID),
        tabIndex: isDisabled && (0, $4R6GH.fg)('tanuki_a11y_q4') ? -1 : undefined
    }, cardKey, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), null, summary)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1SqXg.default), {
        highlightText: highlightText,
        issueUrl: issueUrl,
        isDone: isDone,
        issueKey: cardKey,
        onClick: onKeyClick
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5747c4050e3d8f18$var$KeyContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_yyhy1l0g _1ii7wtyw _kqswh2mm _1pbykb7n _u5f3u2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1SqXg", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad0abff13d9b3091$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $jhmo0 = parcelRequire("jhmo0");

var $2NMNM = parcelRequire("2NMNM");

var $k2wwp = parcelRequire("k2wwp");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $kM28N = parcelRequire("kM28N");

var $cizWc = parcelRequire("cizWc");
const $ad0abff13d9b3091$var$KeyWithAnalytics = ({ issueUrl: issueUrl, issueKey: issueKey, isDone: isDone, onClick: onClick, highlightText: highlightText })=>{
    const highlight = (0, $5uXOq.useMemo)(()=>highlightText != null ? [
            highlightText
        ] : [], [
        highlightText
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleClick = (0, $5uXOq.useCallback)((e)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'issue'
        });
        onClick(e, analyticsEvent);
    }, [
        onClick,
        createAnalyticsEvent
    ]);
    const handleOnContextMenu = (0, $5uXOq.useCallback)((e)=>{
        e.stopPropagation();
    }, []);
    if ((0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('backlog_key_refresh')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhmo0.default), {
        xcss: (0, $3JT92.cx)($ad0abff13d9b3091$var$keyStyles.default, isDone && $ad0abff13d9b3091$var$keyStyles.done),
        href: issueUrl,
        tabIndex: -1,
        onClick: handleClick,
        "aria-hidden": "true",
        onContextMenu: handleOnContextMenu,
        "data-component-selector": (0, $cizWc.KEY_COMPONENT_SELECTOR),
        testId: (0, $cizWc.KEY_COMPONENT_SELECTOR)
    }, highlightText != null && highlightText !== '' && issueKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k2wwp.default), {
        text: issueKey,
        highlight: highlight
    }) : issueKey);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.Key), {
        href: issueUrl,
        tabIndex: -1,
        isDone: isDone,
        onClick: handleClick,
        "aria-hidden": "true",
        onContextMenu: handleOnContextMenu,
        "data-component-selector": (0, $cizWc.KEY_COMPONENT_SELECTOR),
        "data-testid": (0, $cizWc.KEY_COMPONENT_SELECTOR)
    }, highlightText != null && highlightText !== '' && issueKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k2wwp.default), {
        text: issueKey,
        highlight: highlight
    }) : issueKey);
};
var $ad0abff13d9b3091$export$2e2bcd8739ae039 = $ad0abff13d9b3091$var$KeyWithAnalytics;
const $ad0abff13d9b3091$var$keyStyles = {
    default: "_11c82smr _12ji1r31 _1qu2glyw _12y31o36 _4bfu18uv _1hmsglyw _ajmmnqa1 _1x821ts4 _syaz1gjq _o5721q9c _9oik18uv _1bnx8stv _jf4cnqa1",
    done: "_4bfu18uv _1hms1911 _ajmmnqa1"
};

});
parcelRegister("k2wwp", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e37bd657627b5db$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1H6kL = parcelRequire("1H6kL");

var $cM7El = parcelRequire("cM7El");
const $5e37bd657627b5db$var$HighlightTextWithParser = /*#__PURE__*/ (0, $5uXOq.memo)(({ text: text, highlight: highlight })=>{
    const parts = (0, $1H6kL.getParts)(highlight, text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cM7El.default), {
        parts: parts
    });
});
var $5e37bd657627b5db$export$2e2bcd8739ae039 = $5e37bd657627b5db$var$HighlightTextWithParser;

});
parcelRegister("1H6kL", function(module, exports) {

$parcel$export(module.exports, "removeAccents", () => $0b92ef830f5aa8e4$export$f3f2882e8b11d731);
$parcel$export(module.exports, "getParts", () => $0b92ef830f5aa8e4$export$a3aee8a24a54661f);

var $8QDwl = parcelRequire("8QDwl");

var $ajpes = parcelRequire("ajpes");

var $3JOCw = parcelRequire("3JOCw");

var $8QpSo = parcelRequire("8QpSo");
const $0b92ef830f5aa8e4$export$f3f2882e8b11d731 = (0, $8QpSo.default)((text)=>text.normalize('NFD').replace(/[\u0300-\u036f]/g, ''));
const $0b92ef830f5aa8e4$export$1633667427d99697 = (0, $8QpSo.default)((highlight)=>{
    const escapedFilter = highlight.map((phrase)=>(0, (/*@__PURE__*/$parcel$interopDefault($8QDwl)))(phrase)).join('|');
    return new RegExp(escapedFilter, 'gmi');
}, (newArgs, lastArgs)=>{
    if (newArgs.length !== lastArgs.length) return false;
    const equalityFn = (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)));
    return newArgs.every((newArg, index)=>equalityFn(newArg, lastArgs[index]));
});
const $0b92ef830f5aa8e4$export$2235873b95f89ea = (content)=>({
        type: 'text',
        content: content
    });
const $0b92ef830f5aa8e4$export$39ae7d355c29b45f = (content)=>({
        type: 'highlight',
        content: content
    });
const $0b92ef830f5aa8e4$export$c05c39859172f90c = (str, regExp)=>{
    const ms = [];
    let m = regExp.exec(str);
    while(m){
        ms.push(m);
        m = regExp.exec(str);
    }
    return ms;
};
const $0b92ef830f5aa8e4$export$a3aee8a24a54661f = (highlight, text)=>{
    if (highlight == null || highlight.filter((phrase)=>phrase !== '').length === 0) return [
        $0b92ef830f5aa8e4$export$2235873b95f89ea(text)
    ];
    const parts = [];
    // Long text lengths will cause "Invalid regular expression" error
    const truncatedHighlight = highlight.map((phrase)=>phrase.substring(0, 255));
    const highlightRegExp = $0b92ef830f5aa8e4$export$1633667427d99697(truncatedHighlight.filter((phrase)=>phrase !== ''));
    const textWithoutAccents = $0b92ef830f5aa8e4$export$f3f2882e8b11d731(text);
    const textMatches = $0b92ef830f5aa8e4$export$c05c39859172f90c(text, highlightRegExp);
    const textWithoutAccentsMatches = $0b92ef830f5aa8e4$export$c05c39859172f90c(textWithoutAccents, highlightRegExp);
    const highlightMatches = (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))([
        ...textWithoutAccentsMatches,
        ...textMatches
    ], 'index');
    let currentPosition = 0;
    highlightMatches.forEach((match)=>{
        const matchText = text.slice(match.index, match.index + match[0].length);
        const leading = text.slice(currentPosition, match.index);
        if (leading !== '') parts.push($0b92ef830f5aa8e4$export$2235873b95f89ea(leading));
        parts.push($0b92ef830f5aa8e4$export$39ae7d355c29b45f(matchText));
        currentPosition = match.index + matchText.length;
    });
    const trailing = text.slice(currentPosition);
    if (trailing !== '') parts.push($0b92ef830f5aa8e4$export$2235873b95f89ea(trailing));
    return parts;
};

});

parcelRegister("cM7El", function(module, exports) {

$parcel$export(module.exports, "default", () => $328475be93221885$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $328475be93221885$var$Mark = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "mark", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_bfhki1yw _syaz1fxt",
            __cmplp.className
        ])
    });
});
const $328475be93221885$var$HighlightText = ({ parts: parts })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, parts.map((part, i)=>{
        if (part.type === 'text') return part.content;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($328475be93221885$var$Mark, {
            key: i
        }, part.content);
    }));
var $328475be93221885$export$2e2bcd8739ae039 = $328475be93221885$var$HighlightText;

});




parcelRegister("fuplg", function(module, exports) {

$parcel$export(module.exports, "default", () => $696609a8ce9192b2$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hGgHi = parcelRequire("hGgHi");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $3fAi8 = parcelRequire("3fAi8");

var $ciMkN = parcelRequire("ciMkN");


var $3bPZM = parcelRequire("3bPZM");

var $etKNj = parcelRequire("etKNj");

var $kxZPA = parcelRequire("kxZPA");


var $guzeq = parcelRequire("guzeq");

var $dspDn = parcelRequire("dspDn");

var $gwOHY = parcelRequire("gwOHY");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");

var $fSgHa = parcelRequire("fSgHa");

var $dM9vk = parcelRequire("dM9vk");

var $gnK7n = parcelRequire("gnK7n");

var $ayyYR = parcelRequire("ayyYR");

var $80uDK = parcelRequire("80uDK");

var $k4laV = parcelRequire("k4laV");

const $696609a8ce9192b2$export$b4142fd4d9b62ec6 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("8bJ9E")), {
    moduleId: "./src/packages/issue/fields/original-estimate/src/index.tsx"
});
const $696609a8ce9192b2$var$OriginalEstimateField = ({ issueId: issueId, issueKey: issueKey, estimationType: estimationType, timeTrackingOptions: timeTrackingOptions, isUserAtLeastMember: isUserAtLeastMember, shouldRenderRichCard: shouldRenderRichCard, shouldRenderEstimatesColumn: shouldRenderEstimatesColumn })=>{
    const isCompanyManaged = (0, $fSgHa.useIsCMPBacklog)();
    const hasEstimate = (0, $c1MAf.useBacklogSelector)((state)=>!!(0, $dGljH.getCards)(state)[String(issueId)]?.estimate);
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const [_, { triggerEpicPanelRefetch: triggerEpicPanelRefetch }] = (0, $3bPZM.useShouldRefetchEpicPanel)();
    const intl = (0, $koVbs.default)();
    const [originalEstimateFieldValue] = (0, $3fAi8.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $e9be48d6d2c01760$export$5fbd3b15555b9ef2)
    });
    const handleConfirm = (0, $5uXOq.useCallback)(()=>{
        (0, $dspDn.setInlineEditOriginalEstimateInteractionStartMark)();
    }, []);
    const handleUpdate = (0, $5uXOq.useCallback)(()=>{
        (0, $dspDn.setInlineEditOriginalEstimateInteractionStopMark)(isCompanyManaged);
        dispatch((0, $gwOHY.refetchVersions)());
        if (isCompanyManaged) triggerEpicPanelRefetch();
    }, [
        dispatch,
        isCompanyManaged,
        triggerEpicPanelRefetch
    ]);
    const handleFailure = (0, $5uXOq.useCallback)(()=>{
        (0, $dspDn.cancelInlineEditOriginalEstimateInteractionMark)();
    }, []);
    if (!shouldRenderEstimatesColumn && (estimationType !== (0, $guzeq.ORIGINAL_ESTIMATE) || !hasEstimate)) return null;
    const isOriginalEstimateAccessible = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(originalEstimateFieldValue);
    const value = isOriginalEstimateAccessible ? (0, $etKNj.timeTrackingFormatter)(originalEstimateFieldValue, timeTrackingOptions, intl) : undefined;
    const placeholder = '2w 4d 6h 45m';
    const invalidTimeFormatMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $ayyYR.default).invalidTimeFormatMessage,
        values: {
            format: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, placeholder)
        }
    });
    const longFormValue = isOriginalEstimateAccessible && originalEstimateFieldValue > 0 ? (0, $etKNj.timeTrackingFormatterLongForm)(originalEstimateFieldValue, timeTrackingOptions, intl) : undefined;
    const ariaLabel = longFormValue ? `${intl.formatMessage((0, $ayyYR.default).originalEstimateAriaLabel)}: ${longFormValue}` : `${intl.formatMessage((0, $ayyYR.default).originalEstimateAriaLabel)}: ${intl.formatMessage((0, $ayyYR.default).originalEstimateAriaLabelNullValue)}`;
    const issueOriginalEstimateFieldStatic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $80uDK.default), {
        value: value,
        valueInSeconds: originalEstimateFieldValue,
        hasEstimate: hasEstimate,
        timeTrackingOptions: timeTrackingOptions
    });
    if (isUserAtLeastMember && shouldRenderRichCard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ciMkN.IssueOriginalEstimateFieldBoundary), {
        packageName: (0, $a9c483c0d986286a$export$dfd208682d29484c),
        fallback: issueOriginalEstimateFieldStatic
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dM9vk.default), {
        experienceTarget: "inline original estimate",
        experienceTargetId: issueKey,
        additionalAttributes: {
            issueKey: issueKey
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($696609a8ce9192b2$var$OriginalEstimateFieldWrapper, {
        shouldRenderEstimatesColumn: shouldRenderEstimatesColumn
    }, hasEstimate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($696609a8ce9192b2$var$OriginalEstimateFieldContainer, {
        hasValue: isOriginalEstimateAccessible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gnK7n.default), {
        tooltipLabel: intl.formatMessage((0, $ayyYR.default).originalEstimateTooltip),
        ariaLabel: ariaLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($696609a8ce9192b2$export$b4142fd4d9b62ec6, {
        isEditable: true,
        isMobile: false,
        isFitContainerWidthReadView: true,
        fieldId: (0, $e9be48d6d2c01760$export$5fbd3b15555b9ef2),
        issueId: String(issueId),
        issueKey: issueKey,
        config: (0, $k4laV.timeTrackingConfigTransformer)(timeTrackingOptions),
        placeholder: placeholder,
        timeTrackingValue: {},
        invalidTimeFormatMessage: invalidTimeFormatMessage,
        isBacklogComponent: true,
        onUpdate: handleUpdate,
        onConfirm: handleConfirm,
        onFailure: handleFailure
    }))))));
    return issueOriginalEstimateFieldStatic;
};
var $696609a8ce9192b2$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($696609a8ce9192b2$var$OriginalEstimateField);
const $696609a8ce9192b2$var$OriginalEstimateFieldContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo1kw7 _18m91kw7 _80om73ad _1ul9ys9h _1e0c1txw _4t3i1osq _4cvr1h6o _1udr15vq _nmyy15vq _1n1y15vq _2jfx15vq _1lab1ule _9xlo1q9c _pgqw1l2s _13mo1ule _1ny3ys9h _g5ay1q9c _ox3r1l2s _tkqh1txw _9t8gglyw _1la1idpf _n0ewu2gc _cgnyidpf _10gfidpf _joadidpf _18vj1txw _18kq1kw7 _1jsw1kw7 _3p7d1kw7 _j88e1kw7 _1ksg1kw7 _zpal1kw7 _wnsb1kw7 _bwtn1kw7 _wlgl1kw7 _1n6k1kw7 _tq0k1kw7 _xzt01kw7 _nt751r31 _1guj1r31 _49pcglyw _pbhaglyw _1hvw1o36 _11ow1o36",
            __cmplp.className
        ])
    });
}); // empty column for the cards that without original estimates
const $696609a8ce9192b2$var$OriginalEstimateFieldWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldRenderEstimatesColumn: shouldRenderEstimatesColumn, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1wpz1fhb _4cvr1h6o",
            __cmplp.shouldRenderEstimatesColumn && "_1ul9ys9h _p12fys9h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ciMkN", function(module, exports) {

$parcel$export(module.exports, "IssueOriginalEstimateFieldBoundary", () => $cd2046d273882d40$export$1c6d9e9bdb2427ab);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $cd2046d273882d40$export$1c6d9e9bdb2427ab = ({ children: children, fallback: fallback, packageName: packageName, onError: onError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "issue-original-estimate-field",
        packageName: packageName,
        fallback: fallback ? ()=>fallback : undefined,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-original-estimate-field-boundary",
        fallback: fallback
    }, children));

const $cd2046d273882d40$export$572c30be3fc4b061 = (0, $kxZPA.lazy)(()=>(parcelRequire("d4jzg")).then((IssueOriginalEstimateField)=>IssueOriginalEstimateField), {
    moduleId: "./src/packages/issue/fields/original-estimate/src/ui/index.tsx"
});

});
parcelRegister("d4jzg", function(module, exports) {

let $983ad3cfe0d11847$var$load = (parcelRequire("28QjX"))(4);
module.exports = $983ad3cfe0d11847$var$load("bKlGk").then(()=>parcelRequire('9HayT'));

});


parcelRegister("k4laV", function(module, exports) {

$parcel$export(module.exports, "timeTrackingConfigTransformer", () => $f545cf974bf70a21$export$5507631896590474);
const $f545cf974bf70a21$export$5507631896590474 = ({ workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, defaultUnit: defaultUnit, timeFormat: timeFormat })=>({
        isTimeTrackingEnabled: true,
        daysPerWeek: workingDaysPerWeek,
        hoursPerDay: workingHoursPerDay,
        defaultUnit: defaultUnit,
        format: timeFormat
    });

});

parcelRegister("8bJ9E", function(module, exports) {

let $5f626098ad2f239b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5f626098ad2f239b$var$load("RyzJq").then(()=>parcelRequire('4pygV'));

});


parcelRegister("bTzpK", function(module, exports) {

$parcel$export(module.exports, "Parent", () => $4af02e2826e9a973$export$ef39aebeb16866ce);

var $5uXOq = parcelRequire("5uXOq");

var $kM28N = parcelRequire("kM28N");

var $3xj9Y = parcelRequire("3xj9Y");

var $kKQ57 = parcelRequire("kKQ57");

var $963tu = parcelRequire("963tu");
const $4af02e2826e9a973$export$ef39aebeb16866ce = ({ cardId: cardId, cardKey: cardKey, isUserAtLeastMember: isUserAtLeastMember, parents: parents, parentId: parentId, parent: parent, currentProjectId: currentProjectId, projectIds: projectIds, canUserEditIssue: canUserEditIssue, shouldRenderRichCard: shouldRenderRichCard, backlogContainerSize: backlogContainerSize, isCompactView: isCompactView, isSubtask: isSubtask, isEpic: isEpic, isCompanyManaged: isCompanyManaged, workType: workType })=>// Using placeholderWidthMultiplier so that with change in container width the width of placeholder changes
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.EpicWrapper), {
        widthMultiplier: (0, $963tu.getLabelWidthMultiplier)((0, $963tu.LabelType).EPIC, backlogContainerSize),
        // To avoid any extra space show the placeholder only on cards not linked to any epic and are not subtasks
        showPlaceholder: parentId === null && !isSubtask
    }, isEpic && isCompanyManaged ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3xj9Y.default), {
        issueKey: cardKey,
        issueId: cardId,
        isCompactView: isCompactView
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kKQ57.default), {
        issueId: cardId,
        issueKey: cardKey,
        isUserAtLeastMember: isUserAtLeastMember,
        parents: parents,
        parentId: parentId,
        parent: parent,
        currentProjectId: currentProjectId,
        projectIds: projectIds,
        forceEditable: canUserEditIssue,
        shouldRenderRichCard: shouldRenderRichCard,
        isCompactView: isCompactView,
        workType: workType
    }));

});
parcelRegister("kKQ57", function(module, exports) {

$parcel$export(module.exports, "default", () => $575becd3ec2f8837$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hGgHi = parcelRequire("hGgHi");

var $7SCny = parcelRequire("7SCny");

var $3fAi8 = parcelRequire("3fAi8");

var $7Fute = parcelRequire("7Fute");

var $jRmmq = parcelRequire("jRmmq");

var $5fc53 = parcelRequire("5fc53");

var $iXVV6 = parcelRequire("iXVV6");

var $3bPZM = parcelRequire("3bPZM");

var $kxZPA = parcelRequire("kxZPA");

var $4R6GH = parcelRequire("4R6GH");


var $fSgHa = parcelRequire("fSgHa");

var $dM9vk = parcelRequire("dM9vk");

var $c1MAf = parcelRequire("c1MAf");

var $9Pc1U = parcelRequire("9Pc1U");

var $8wOzB = parcelRequire("8wOzB");

const $575becd3ec2f8837$export$470a9ca634922e36 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("5S0MB")).then(({ ParentSwitcherField: ParentSwitcherField })=>ParentSwitcherField), {
    moduleId: "./src/packages/issue/fields/parent-switcher/src/index.tsx"
});
const $575becd3ec2f8837$var$ParentField = ({ issueId: issueId, issueKey: issueKey, isUserAtLeastMember: isUserAtLeastMember, parents: parents = [], currentProjectId: currentProjectId, projectIds: projectIds, shouldRenderRichCard: shouldRenderRichCard, forceEditable: forceEditable, parentId: parentId, parent: parent, isCompactView: isCompactView, workType: workType })=>{
    // Remove when cleaning up jsw-backlog-parent-field-render
    const [parentValue] = (0, $3fAi8.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $5fc53.PARENT_TYPE)
    });
    const isCompanyManaged = (0, $fSgHa.useIsCMPBacklog)();
    const levelOneHierarchyName = (0, $c1MAf.useBacklogSelector)((state)=>(0, $4R6GH.fg)('jsw_backlog_fix_inline_setting_parent_text_issue') ? (0, $9Pc1U.getConfig)(state)?.hierarchyNomenclature?.firstLevelName : undefined);
    const [_, { triggerEpicPanelRefetch: triggerEpicPanelRefetch }] = (0, $3bPZM.useShouldRefetchEpicPanel)(); /**
                                     * This outputs the same thing as the parent, it just changes the type to Epic
                                     */ 
    // Remove when cleaning up jsw-backlog-parent-field-render
    // @ts-expect-error Change of type affects transformToEpic type
    const transformedEpic = (0, $5uXOq.useMemo)(()=>parents.map((p)=>(0, $7Fute.transformToEpic)(p)), [
        parents
    ]); // Mapped parent is required to get the epic/parent's color
    // Remove when cleaning up jsw-backlog-parent-field-render
    const mappedParent = (0, $5uXOq.useMemo)(()=>parentId ? parents.find(({ id: id })=>Number(id) === Number(parentId)) : null, [
        parentId,
        parents
    ]); // Remove when cleaning up jsw-backlog-parent-field-render
    const renderParentFieldStatic = (0, $5uXOq.useCallback)(()=>{
        const color = mappedParent?.color || parentValue?.color || (0, $7SCny.PURPLE);
        const summary = mappedParent?.summary || parentValue?.fields?.summary;
        return summary ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8wOzB.default), {
            color: color,
            summary: summary,
            isCompactView: isCompactView
        }) : null;
    }, [
        isCompactView,
        mappedParent,
        parentValue?.color,
        parentValue?.fields?.summary
    ]);
    const color = (0, $4R6GH.fg)('jsw-backlog-parent-field-render') ? parent?.color || mappedParent?.color || parentValue?.color || (0, $7SCny.PURPLE) : null;
    const summary = (0, $4R6GH.fg)('jsw-backlog-parent-field-render') ? parent?.summary || mappedParent?.summary || parentValue?.fields?.summary : null;
    const parentFieldStatic = summary && (0, $4R6GH.fg)('jsw-backlog-parent-field-render') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8wOzB.default), {
        color: color,
        summary: summary,
        isCompactView: isCompactView
    }) : null;
    const handleSuccess = (0, $5uXOq.useCallback)(()=>{
        if (isCompanyManaged) triggerEpicPanelRefetch();
    }, [
        isCompanyManaged,
        triggerEpicPanelRefetch
    ]); // in the storybook, it first displays the static epic lozenge.
    // but when we mouse over on a card, the epic field would disappear due to missing hierarchy-level-above value in the sweet state
    if (isUserAtLeastMember && shouldRenderRichCard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jRmmq.ParentSwitcherBoundary), {
        packageName: (0, $a9c483c0d986286a$export$dfd208682d29484c),
        fallback: (0, $4R6GH.fg)('jsw-backlog-parent-field-render') ? parentFieldStatic : renderParentFieldStatic()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dM9vk.default), {
        experienceTarget: "inline epic",
        experienceTargetId: issueKey,
        additionalAttributes: {
            issueKey: issueKey
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($575becd3ec2f8837$var$ParentFieldWrapper, {
        hasValue: (0, $4R6GH.fg)('jsw-backlog-parent-field-render') ? !!parent : !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(parentValue),
        isCompactView: isCompactView
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            isInlineEditing: true
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($575becd3ec2f8837$export$470a9ca634922e36, {
        onSuccess: handleSuccess,
        issueKey: issueKey,
        issueId: String(issueId),
        epics: (0, $4R6GH.fg)('jsw-backlog-parent-field-render') ? parents : transformedEpic,
        levelOneHierarchyName: levelOneHierarchyName,
        forceEditable: forceEditable,
        isSimplifiedProject: !isCompanyManaged,
        currentProjectId: currentProjectId,
        projectIds: projectIds,
        isCompactView: isCompactView,
        workType: workType
    })))));
    return (0, $4R6GH.fg)('jsw-backlog-parent-field-render') ? parentFieldStatic : renderParentFieldStatic();
};
var $575becd3ec2f8837$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
 = /*#__PURE__*/ (0, $5uXOq.memo)($575becd3ec2f8837$var$ParentField);
const $575becd3ec2f8837$var$ParentFieldWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCompactView: isCompactView, hasValue: hasValue, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvresu3 _kqswh2mm _80om73ad _p12f1osq _vchhusvi _5ci27079 _907j1kev _1rt91h90 _1u4t126e _nyj2agmp _1ksg1kw7 _zpal1kw7 _wnsb1kw7 _bwtn1kw7",
            !__cmplp.isCompactView && "_19bvu2gc",
            !__cmplp.hasValue && "_tzy4idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jRmmq", function(module, exports) {

$parcel$export(module.exports, "ParentSwitcherBoundary", () => $363a63430d7d18c1$export$5fd31a263aabeb24);
$parcel$export(module.exports, "AsyncLazyParentSwitcherField", () => $363a63430d7d18c1$export$690bf5ebb9d6daf8);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");
const $363a63430d7d18c1$export$5fd31a263aabeb24 = ({ children: children, fallback: fallback, packageName: packageName, onError: onError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "issue-parent-switcher",
        packageName: packageName,
        fallback: fallback ? ()=>fallback : undefined,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-parent-switcher-boundary",
        fallback: fallback
    }, children));

const $363a63430d7d18c1$export$690bf5ebb9d6daf8 = (0, $kxZPA.lazy)(()=>(parcelRequire("14G2D")).then(({ ParentSwitcherField: ParentSwitcherField })=>ParentSwitcherField), {
    moduleId: "./src/packages/issue/fields/parent-switcher/src/ui/main.tsx"
});

});
parcelRegister("14G2D", function(module, exports) {

let $0c86c6b8281cd8a0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0c86c6b8281cd8a0$var$load("7jnHK").then(()=>parcelRequire('1vozy'));

});


parcelRegister("5S0MB", function(module, exports) {

let $44629a5910df9c7a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $44629a5910df9c7a$var$load("dIUvL").then(()=>parcelRequire('6wu0G'));

});



parcelRegister("lNMv0", function(module, exports) {

$parcel$export(module.exports, "StatusFieldWrapper", () => $2f4a9a997cc0237d$export$b298de36b54f1050);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $gwIPs = parcelRequire("gwIPs");

var $iDGXn = parcelRequire("iDGXn");

var $3JQPC = parcelRequire("3JQPC");

var $963tu = parcelRequire("963tu");

var $1QXjd = parcelRequire("1QXjd");
const $2f4a9a997cc0237d$export$b298de36b54f1050 = ({ isUserAtLeastMember: isUserAtLeastMember, shouldRenderRichCard: shouldRenderRichCard, cardKey: cardKey, cardId: cardId, status: status })=>{
    const showStatuses = (0, $iDGXn.useShowStatuses)();
    const { size: backlogContainerSize } = (0, $3JQPC.useContainerSize)();
    if (showStatuses) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2f4a9a997cc0237d$var$StatusContainer, {
        "data-testid": "software-backlog.card-list.card.card-contents.status-field.status-field-wrapper.status-container",
        widthMultiplier: (0, $963tu.getLabelWidthMultiplier)((0, $963tu.LabelType).STATUS, backlogContainerSize)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QXjd.default), {
        isUserAtLeastMember: isUserAtLeastMember,
        shouldRenderRichCard: shouldRenderRichCard,
        issueKey: cardKey,
        issueId: String(cardId),
        widthMultiplier: (0, $963tu.getLabelWidthMultiplier)((0, $963tu.LabelType).STATUS, backlogContainerSize),
        status: status
    }));
    return null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2f4a9a997cc0237d$var$StatusContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { widthMultiplier: widthMultiplier, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_uu7jbp": (0, $lD23V.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `repeat(auto-fit,${(0, $gwIPs.gridSize) * __cmplp.widthMultiplier}px)`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo1kw7 _18m91kw7 _1e0c11p5 _lcxvglyw _yv0e105t",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1QXjd", function(module, exports) {

$parcel$export(module.exports, "default", () => $342ba4724accfebb$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $ggSx2 = parcelRequire("ggSx2");

var $hGgHi = parcelRequire("hGgHi");

var $gULOk = parcelRequire("gULOk");

var $3fAi8 = parcelRequire("3fAi8");

var $9fZKh = parcelRequire("9fZKh");


var $3bPZM = parcelRequire("3bPZM");

var $dCm1o = parcelRequire("dCm1o");

var $kxZPA = parcelRequire("kxZPA");

var $4R6GH = parcelRequire("4R6GH");


var $dspDn = parcelRequire("dspDn");

var $czUNp = parcelRequire("czUNp");

var $gwOHY = parcelRequire("gwOHY");

var $c1MAf = parcelRequire("c1MAf");

var $fSgHa = parcelRequire("fSgHa");

var $dM9vk = parcelRequire("dM9vk");

var $7I9R8 = parcelRequire("7I9R8");

const $342ba4724accfebb$export$58bec2551a247e1d = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("cZuHy")), {
    moduleId: "./src/packages/issue/fields/status/src/index.tsx"
});
const $342ba4724accfebb$var$StatusField = ({ isUserAtLeastMember: isUserAtLeastMember, shouldRenderRichCard: shouldRenderRichCard, issueKey: issueKey, widthMultiplier: widthMultiplier, issueId: issueId, status: status })=>{
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const [statusFieldValue] = (0, $3fAi8.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $e9be48d6d2c01760$export$4420b7468f889692)
    });
    const isCompanyManaged = (0, $fSgHa.useIsCMPBacklog)();
    const [_, { triggerEpicPanelRefetch: triggerEpicPanelRefetch }] = (0, $3bPZM.useShouldRefetchEpicPanel)();
    const handleSubmit = (0, $5uXOq.useCallback)(()=>{
        (0, $dspDn.setInlineEditStatusInteractionStartMark)();
    }, []);
    const handleSuccess = (0, $5uXOq.useCallback)((value)=>{
        (0, $dspDn.setInlineEditStatusInteractionStopMark)(isCompanyManaged);
        dispatch((0, $gwOHY.refetchVersions)());
        if (issueId !== undefined) {
            const cardId = Number.parseInt(issueId, 10);
            dispatch((0, $czUNp.cardStatusSet)(cardId, statusFieldValue.id, value.id, statusFieldValue.id, isCompanyManaged));
        }
        if (isCompanyManaged) triggerEpicPanelRefetch();
    }, [
        dispatch,
        isCompanyManaged,
        issueId,
        statusFieldValue,
        triggerEpicPanelRefetch
    ]);
    const handleFailure = (0, $5uXOq.useCallback)(()=>{
        (0, $dspDn.cancelInlineEditStatusInteractionMark)();
    }, []);
    let issueStatusFieldStatic = null;
    if ((0, $4R6GH.fg)('use_backlog_card_data_for_rendering')) {
        if (!status?.name || !status?.category) return null;
        issueStatusFieldStatic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7I9R8.default), {
            isUserAtLeastMember: isUserAtLeastMember,
            name: status?.name,
            category: status?.category
        });
    } else {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(statusFieldValue) || !statusFieldValue.id || !statusFieldValue.name) return null;
        const value = {
            id: statusFieldValue.id,
            name: statusFieldValue.name,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            category: (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))((0, $gULOk.StatusCategoryIds))[statusFieldValue.statusCategory.id] || (0, $gULOk.StatusCategoryTypes).UNDEFINED
        };
        issueStatusFieldStatic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7I9R8.default), {
            isUserAtLeastMember: isUserAtLeastMember,
            value: value
        });
    }
    if (isUserAtLeastMember && shouldRenderRichCard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fZKh.IssueStatusFieldBoundary), {
        packageName: (0, $a9c483c0d986286a$export$dfd208682d29484c),
        fallback: issueStatusFieldStatic
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dM9vk.default), {
        experienceTarget: "inline status",
        experienceTargetId: issueKey,
        additionalAttributes: {
            issueKey: issueKey
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($342ba4724accfebb$export$653fc70614ecd562, {
        widthMultiplier: widthMultiplier
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($342ba4724accfebb$export$58bec2551a247e1d, {
        appearance: "lozenge",
        issueKey: issueKey,
        issueId: issueId,
        initialValue: statusFieldValue,
        onSubmit: handleSubmit,
        onSuccess: handleSuccess,
        onFailure: handleFailure
    }))));
    return issueStatusFieldStatic;
};
var $342ba4724accfebb$export$2e2bcd8739ae039 // NOTE: The div is needed here because StatusLozenge is an async component and
 = /*#__PURE__*/ (0, $5uXOq.memo)($342ba4724accfebb$var$StatusField);
const $342ba4724accfebb$export$653fc70614ecd562 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { widthMultiplier: widthMultiplier, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_4lcd6e": (0, $lD23V.default)(__cmplp.widthMultiplier * 8 - 4, "px"),
            "--_hikewg": (0, $lD23V.default)(__cmplp.widthMultiplier * 8, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _4cvr1h6o _rcmc11p5 _1i661h6o _5th9v2br _9u161rj4 _1a191qo1 _bvcr7079 _1sgz1wje _es1l1prr _1o3v1h90 _ewzg1h90 _1dg1agmp _132g1h90 _1v5x1q9c",
            (0, $dCm1o.isVisualRefreshEnabled)() ? "_1d7yl1s9" : "_1d7y1ljj",
            (0, $dCm1o.isVisualRefreshEnabled)() ? "_d2c8yh40" : "_d2c8idpf",
            (0, $dCm1o.isVisualRefreshEnabled)() ? "_1a5tyh40" : "_1a5tidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9fZKh", function(module, exports) {

$parcel$export(module.exports, "AsyncIssueStatusField", () => $0cd8b9cfe3ba1e4a$export$ddd324b06f34200);
$parcel$export(module.exports, "IssueStatusFieldBoundary", () => $0cd8b9cfe3ba1e4a$export$dba9e9c892560f60);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $fQeLt = parcelRequire("fQeLt");

const $0cd8b9cfe3ba1e4a$export$6dbb1a485af348f = (0, $kxZPA.lazy)(()=>(parcelRequire("4NgFR")), {
    moduleId: "./src/packages/issue/fields/status/src/ui/main.tsx"
});
const $0cd8b9cfe3ba1e4a$export$ddd324b06f34200 = (props)=>{
    const { initialValue: initialValue, value: value } = props;
    const errorProps = {
        initialValue: initialValue,
        value: value
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "issue-field-status",
        packageName: "jira-issue-field-status",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fQeLt.StatusLozengeWithDropdownIndicator), errorProps)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-status-field",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fQeLt.StatusLozengeWithDropdownIndicator), errorProps)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0cd8b9cfe3ba1e4a$export$6dbb1a485af348f, props)));
};
const $0cd8b9cfe3ba1e4a$export$dba9e9c892560f60 = ({ children: children, fallback: fallback, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "issue-status-field",
        packageName: packageName,
        render: ()=>fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-status-field-boundary",
        fallback: fallback
    }, children));

});
parcelRegister("fQeLt", function(module, exports) {

$parcel$export(module.exports, "StatusLozenge", () => $e065d549cea5a7d0$export$f72db4ad1e9b3e6d);
$parcel$export(module.exports, "StatusLozengeWithDropdownIndicator", () => $e065d549cea5a7d0$export$9f5070a985b0679b);

var $5uXOq = parcelRequire("5uXOq");

var $17mYr = parcelRequire("17mYr");
const $e065d549cea5a7d0$export$f72db4ad1e9b3e6d = (props)=>{
    const status = props.value || props.initialValue;
    if (!status) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $17mYr.WrappedStatusLozenge), {
        status: status,
        isEditable: false,
        hasHoverState: false,
        focused: false,
        contentRef: props.contentRef
    });
};
const $e065d549cea5a7d0$export$9f5070a985b0679b = (props)=>{
    const status = props.value || props.initialValue;
    if (!status) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $17mYr.WrappedStatusLozenge), {
        status: status,
        isEditable: false,
        hasHoverState: false,
        focused: false,
        shouldShowDropdownIndication: true
    });
};

});
parcelRegister("17mYr", function(module, exports) {

$parcel$export(module.exports, "TEST_ID_PREFIX", () => $390c5e7bc7d9c77b$export$9cbc201c09a37b3f);
$parcel$export(module.exports, "StatusLozenge", () => $390c5e7bc7d9c77b$export$f72db4ad1e9b3e6d);
$parcel$export(module.exports, "WrappedStatusLozenge", () => $390c5e7bc7d9c77b$export$69ea4907eefa8e7b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react-component-props

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $9yOBd = parcelRequire("9yOBd");

var $5LWLA = parcelRequire("5LWLA");

var $dC5iT = parcelRequire("dC5iT");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $aQhlk = parcelRequire("aQhlk");

var $7XYc4 = parcelRequire("7XYc4");

var $dCm1o = parcelRequire("dCm1o");

var $5Ax7l = parcelRequire("5Ax7l");

var $4YeLF = parcelRequire("4YeLF");
const $390c5e7bc7d9c77b$export$9cbc201c09a37b3f = 'issue.fields.status.common.ui.status-lozenge.';
const $390c5e7bc7d9c77b$var$CustomChevronDownGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: 12,
        height: 12,
        viewBox: "5 5 13 13"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M8.292 10.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $390c5e7bc7d9c77b$var$StatusLozengeNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ status: { name: name, statusCategory: statusCategory }, isEditable: isEditable, hasHoverState: hasHoverState, shouldShowDropdownIndication: shouldShowDropdownIndication, isDisabled: isDisabled = false }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StatusContentWrapper, {
        "data-testid": `${$390c5e7bc7d9c77b$export$9cbc201c09a37b3f}${statusCategory.id}`,
        ref: ref
    }, isEditable === true || shouldShowDropdownIndication === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Ax7l.Lozenge), {
        statusCategoryId: statusCategory.id,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StyledLozengeContentWrapper, null, name, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        glyph: $390c5e7bc7d9c77b$var$CustomChevronDownGlyph,
        label: ""
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Ax7l.Lozenge), {
        statusCategoryId: statusCategory.id,
        isDisabled: isDisabled
    }, name)), hasHoverState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $390c5e7bc7d9c77b$var$hoverOverlayStyles
    })));
const $390c5e7bc7d9c77b$var$WrappedStatusLozengeNew = (props)=>{
    const { ariaLabel: ariaLabel, isEditable: isEditable, isOpen: isOpen, targetRef: targetRef, contentRef: contentRef, triggerProps: triggerProps = {}, ...others } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
        xcss: $390c5e7bc7d9c77b$var$pressableStyles,
        ref: targetRef,
        "aria-label": ariaLabel,
        "aria-expanded": isOpen,
        isDisabled: !isEditable,
        // the popup.
        // The logic here may look incorrect, but it turns out that when clicking this button the
        // `isOpen` toggle happens before the `onClick` handler that sends the press tracing.
        // We need to disable the `jira/ufo/valid-labels` lint rule
        // because for this particular interaction we only want to track
        // opening the status popup.
        interactionName: isOpen ? 'issue.fields.status.popup.open' : undefined,
        ...triggerProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StatusLozengeNew, {
        ...others,
        isEditable: isEditable,
        ref: contentRef
    }));
};
const $390c5e7bc7d9c77b$var$EditableLozenge = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4YeLF.LozengeOld), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StyledLozengeContentWrapper, null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        glyph: $390c5e7bc7d9c77b$var$CustomChevronDownGlyph,
        label: ""
    })));
const $390c5e7bc7d9c77b$var$StatusLozengeOld = ({ status: { name: name, statusCategory: statusCategory }, isEditable: isEditable, hasHoverState: hasHoverState, targetRef: targetRef, shouldShowDropdownIndication: shouldShowDropdownIndication, isDisabled: isDisabled = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StyledLozenge, {
        hasHoverState: hasHoverState,
        statusCategoryId: statusCategory.id,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StatusContentWrapper, {
        ref: targetRef,
        "data-testid": `${$390c5e7bc7d9c77b$export$9cbc201c09a37b3f}${statusCategory.id}`
    }, isEditable === true || shouldShowDropdownIndication === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$EditableLozenge, null, name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4YeLF.LozengeOld), null, name)));
const $390c5e7bc7d9c77b$var$WrappedStatusLozengeOld = (props)=>{
    const { ariaLabel: ariaLabel, error: error, isEditable: isEditable, isOpen: isOpen, targetRef: targetRef, triggerProps: triggerProps = {}, ...other } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yOBd.default), {
        ref: targetRef,
        appearance: "subtle",
        "aria-label": ariaLabel,
        "aria-expanded": isOpen,
        isDisabled: !isEditable,
        theme: (currentTheme, themeProps)=>{
            const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
            return {
                buttonStyles: {
                    ...buttonStyles,
                    backgroundColor: 'transparent',
                    margin: 0,
                    width: 'auto',
                    height: 'auto',
                    padding: 0,
                    border: `2px solid ${error ? "var(--ds-border-danger, #E2483D)" : 'transparent'}`,
                    borderRadius: '5px',
                    ...isEditable === true ? undefined : {
                        cursor: 'auto'
                    },
                    outline: 0,
                    boxShadow: `0 0 0 2px ${isOpen === true ? "var(--ds-border-focused, #388BFF)" : 'transparent'}`,
                    '& > span': {
                        margin: 0
                    },
                    '&:focus, &:focus-within': {
                        boxShadow: `0 0 0 2px ${"var(--ds-border-focused, #388BFF)"}`
                    }
                },
                spinnerStyles: spinnerStyles
            };
        },
        // the popup.
        // The logic here may look incorrect, but it turns out that when clicking this button the
        // `isOpen` toggle happens before the `onClick` handler that sends the press tracing.
        // We need to disable the `jira/ufo/valid-labels` lint rule
        // because for this particular interaction we only want to track
        // opening the status popup.
        // eslint-disable-next-line jira/ufo/valid-labels
        interactionName: isOpen ? 'issue.fields.status.popup.open' : undefined,
        ...triggerProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StatusLozengeOld, {
        ...other,
        isEditable: isEditable
    }));
};
const $390c5e7bc7d9c77b$export$f72db4ad1e9b3e6d = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $390c5e7bc7d9c77b$var$StatusLozengeNew, $390c5e7bc7d9c77b$var$StatusLozengeOld);
const $390c5e7bc7d9c77b$export$69ea4907eefa8e7b = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $390c5e7bc7d9c77b$var$WrappedStatusLozengeNew, $390c5e7bc7d9c77b$var$WrappedStatusLozengeOld); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $390c5e7bc7d9c77b$var$StyledLozenge = /*#__PURE__*/ (0, $47bDC.default).span.withConfig({
    componentId: "wv585u-0"
})`display:flex;align-items:center;> div{display:flex;line-height:initial;outline:0;> span{padding:${"var(--ds-space-025, 2px)"} 0;vertical-align:text-bottom;color:${(props)=>// eslint-disable-next-line no-nested-ternary
    props.isDisabled ? (0, $aQhlk.disabledColor).text : !(0, $dCm1o.isVisualRefreshEnabled)() ? (0, $aQhlk.textColor)[(0, $aQhlk.statusCategoryToThemeMap)[props.statusCategoryId]] : (0, $aQhlk.textColorOld)[(0, $aQhlk.statusCategoryToThemeMap)[props.statusCategoryId]]};background-color:${(props)=>props.isDisabled ? (0, $aQhlk.disabledColor).bg : (0, $aQhlk.bgColor)[(0, $aQhlk.statusCategoryToThemeMap)[props.statusCategoryId]]};${(props)=>props.hasHoverState ? `&:hover {
                        color: ${props.isDisabled ? (0, $aQhlk.disabledColor).text : (0, $aQhlk.textHoverColor)[(0, $aQhlk.statusCategoryToThemeMap)[props.statusCategoryId]]};
                        background-color: ${props.isDisabled ? (0, $aQhlk.disabledColor).bg : (0, $aQhlk.bgHoverColor)[(0, $aQhlk.statusCategoryToThemeMap)[props.statusCategoryId]]};
                    }` : ''};${(props)=>props.isDisabled && (0, $47bDC.css)({
        pointerEvents: 'none'
    })}}}`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $390c5e7bc7d9c77b$var$StyledLozengeContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4cvr1h6o _1e0c1bgi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $390c5e7bc7d9c77b$var$StatusContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $390c5e7bc7d9c77b$var$pressableStyles = (0, $8CUq3.xcss)({
    border: 'none',
    padding: 'space.0',
    borderRadius: '3px',
    background: 'transparent',
    position: 'relative',
    maxWidth: '100%',
    marginLeft: 'space.025'
});
const $390c5e7bc7d9c77b$var$hoverOverlayStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    inset: '0',
    borderRadius: '3px',
    marginRight: 'space.025',
    ':hover': {
        opacity: 0.3,
        backgroundColor: 'color.background.inverse.subtle'
    }
});

});
parcelRegister("aQhlk", function(module, exports) {

$parcel$export(module.exports, "statusCategoryToThemeMap", () => $58bc751e3aa4b554$export$d9e35f42afe1e488);
$parcel$export(module.exports, "bgColor", () => $58bc751e3aa4b554$export$7dcbec377a25efc6);
$parcel$export(module.exports, "textColor", () => $58bc751e3aa4b554$export$32f78bffcd82ff28);
$parcel$export(module.exports, "textColorOld", () => $58bc751e3aa4b554$export$26ac04004fa4ead4);
$parcel$export(module.exports, "bgHoverColor", () => $58bc751e3aa4b554$export$69fdf3ba928b4c77);
$parcel$export(module.exports, "textHoverColor", () => $58bc751e3aa4b554$export$99ec0cf2cf1b2082);
$parcel$export(module.exports, "disabledColor", () => $58bc751e3aa4b554$export$b70f10fc4a6ba453);
const $58bc751e3aa4b554$export$61137dce61763ec3 = 'default';
const $58bc751e3aa4b554$export$132676d06d92ad48 = 'success';
const $58bc751e3aa4b554$export$5c1f3b72419aa125 = 'inprogress';
const $58bc751e3aa4b554$export$d9e35f42afe1e488 = {
    '1': $58bc751e3aa4b554$export$61137dce61763ec3,
    '2': $58bc751e3aa4b554$export$61137dce61763ec3,
    '3': $58bc751e3aa4b554$export$132676d06d92ad48,
    '4': $58bc751e3aa4b554$export$5c1f3b72419aa125
};
const $58bc751e3aa4b554$export$7dcbec377a25efc6 = {
    [$58bc751e3aa4b554$export$61137dce61763ec3]: "var(--ds-background-neutral, #091E420F)",
    [$58bc751e3aa4b554$export$132676d06d92ad48]: "var(--ds-background-success, #DCFFF1)",
    [$58bc751e3aa4b554$export$5c1f3b72419aa125]: "var(--ds-background-information, #E9F2FF)"
};
const $58bc751e3aa4b554$export$32f78bffcd82ff28 = {
    [$58bc751e3aa4b554$export$61137dce61763ec3]: "var(--ds-text-subtle, #44546F)",
    [$58bc751e3aa4b554$export$132676d06d92ad48]: "var(--ds-text-success, #216E4E)",
    [$58bc751e3aa4b554$export$5c1f3b72419aa125]: "var(--ds-text-information, #0055CC)"
};
const $58bc751e3aa4b554$export$26ac04004fa4ead4 = {
    [$58bc751e3aa4b554$export$61137dce61763ec3]: "var(--ds-text, #172B4D)",
    [$58bc751e3aa4b554$export$132676d06d92ad48]: "var(--ds-text-success, #216E4E)",
    [$58bc751e3aa4b554$export$5c1f3b72419aa125]: "var(--ds-text-information, #0055CC)"
};
const $58bc751e3aa4b554$export$69fdf3ba928b4c77 = {
    [$58bc751e3aa4b554$export$61137dce61763ec3]: "var(--ds-background-neutral-hovered, #091E4224)",
    [$58bc751e3aa4b554$export$132676d06d92ad48]: "var(--ds-background-success-hovered, #BAF3DB)",
    [$58bc751e3aa4b554$export$5c1f3b72419aa125]: "var(--ds-background-information-hovered, #CCE0FF)"
};
const $58bc751e3aa4b554$export$99ec0cf2cf1b2082 = {
    [$58bc751e3aa4b554$export$61137dce61763ec3]: "var(--ds-text, #172B4D)",
    [$58bc751e3aa4b554$export$132676d06d92ad48]: "var(--ds-text-success, #216E4E)",
    [$58bc751e3aa4b554$export$5c1f3b72419aa125]: "var(--ds-text-information, #0055CC)"
};
const $58bc751e3aa4b554$export$b70f10fc4a6ba453 = {
    bg: "var(--ds-background-neutral, #091E420F)",
    text: "var(--ds-text-disabled, #091E424F)"
};

});

parcelRegister("5Ax7l", function(module, exports) {

$parcel$export(module.exports, "Lozenge", () => $bcba81c28add5d02$export$a31cbe1bf5463979);

var $5uXOq = parcelRequire("5uXOq");

var $3u0c5 = parcelRequire("3u0c5");

var $aQhlk = parcelRequire("aQhlk");

const $bcba81c28add5d02$export$a31cbe1bf5463979 = ({ children: children, statusCategoryId: statusCategoryId, isDisabled: isDisabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        appearance: (0, $aQhlk.statusCategoryToThemeMap)[statusCategoryId],
        isBold: true,
        ...isDisabled ? {
            style: {
                color: (0, $aQhlk.disabledColor).text,
                backgroundColor: (0, $aQhlk.disabledColor).bg
            }
        } : {}
    }, children);

});

parcelRegister("4YeLF", function(module, exports) {

$parcel$export(module.exports, "LozengeOld", () => $bbacf745a667099a$export$26089816624d22fc);
// TODO - delete this file when cleaning up visual-refresh

var $5uXOq = parcelRequire("5uXOq");
const $bbacf745a667099a$var$containerStyles = {
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage -- The token value "4px" and fallback "3px" do not match and can't be replaced automatically.
    borderRadius: "var(--ds-border-radius, 3px)",
    boxSizing: 'border-box',
    display: 'inline-block',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    maxWidth: '100%',
    padding: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: 'uppercase',
    verticalAlign: 'top'
};
const $bbacf745a667099a$var$contentStyles = {
    boxSizing: 'border-box',
    display: 'inline-block',
    maxWidth: 200,
    overflow: 'hidden',
    padding: `0 ${"var(--ds-space-050, 4px)"}`,
    textOverflow: 'ellipsis',
    verticalAlign: 'top',
    whiteSpace: 'nowrap',
    width: '100%'
};
const $bbacf745a667099a$export$26089816624d22fc = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: $bbacf745a667099a$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: $bbacf745a667099a$var$contentStyles
    }, children));
$bbacf745a667099a$export$26089816624d22fc.displayName = 'Lozenge';

});



parcelRegister("4NgFR", function(module, exports) {

let $37d8ac25b7f13bad$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $37d8ac25b7f13bad$var$load("7mIf9"),
    $37d8ac25b7f13bad$var$load("jXweD"),
    $37d8ac25b7f13bad$var$load("76n7a"),
    $37d8ac25b7f13bad$var$load("l253H"),
    $37d8ac25b7f13bad$var$load("ffQaD"),
    $37d8ac25b7f13bad$var$load("kvRbA"),
    $37d8ac25b7f13bad$var$load("gp6Ye")
]).then(()=>parcelRequire('2azQI'));

});


parcelRegister("cZuHy", function(module, exports) {

let $9752ff3427f8f4d6$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $9752ff3427f8f4d6$var$load("7mIf9"),
    $9752ff3427f8f4d6$var$load("jXweD"),
    $9752ff3427f8f4d6$var$load("76n7a"),
    $9752ff3427f8f4d6$var$load("l253H"),
    $9752ff3427f8f4d6$var$load("ffQaD"),
    $9752ff3427f8f4d6$var$load("kvRbA"),
    $9752ff3427f8f4d6$var$load("g25GD")
]).then(()=>parcelRequire('gUKTg'));

});



parcelRegister("9MiEY", function(module, exports) {

$parcel$export(module.exports, "default", () => $82ca48db4553a327$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hGgHi = parcelRequire("hGgHi");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $8ikZj = parcelRequire("8ikZj");

var $ctrpc = parcelRequire("ctrpc");

var $3fAi8 = parcelRequire("3fAi8");

var $fUvM9 = parcelRequire("fUvM9");


var $bJ2M7 = parcelRequire("bJ2M7");

var $5fc53 = parcelRequire("5fc53");

var $iXVV6 = parcelRequire("iXVV6");
var $2NMNM = parcelRequire("2NMNM");

var $3XO6n = parcelRequire("3XO6n");

var $3bPZM = parcelRequire("3bPZM");

var $kxZPA = parcelRequire("kxZPA");


var $guzeq = parcelRequire("guzeq");

var $dspDn = parcelRequire("dspDn");

var $3EtSK = parcelRequire("3EtSK");

var $gwOHY = parcelRequire("gwOHY");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");

var $fSgHa = parcelRequire("fSgHa");

var $dM9vk = parcelRequire("dM9vk");

var $7q84v = parcelRequire("7q84v");

var $gnK7n = parcelRequire("gnK7n");

var $81g2L = parcelRequire("81g2L");

const $82ca48db4553a327$export$88b57365e3a3cb92 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("kxnJE")), {
    moduleId: "./src/packages/issue/fields/number/src/index.tsx"
});
const $82ca48db4553a327$var$StoryPointField = ({ issueKey: issueKey, storyPointFieldId: storyPointFieldId, estimationType: estimationType, issueId: issueId, isUserAtLeastMember: isUserAtLeastMember, shouldRenderRichCard: shouldRenderRichCard, shouldRenderStoryPointColumn: shouldRenderStoryPointColumn })=>{
    const isCompanyManaged = (0, $fSgHa.useIsCMPBacklog)();
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const { formatMessage: formatMessage, formatNumber: formatNumber } = (0, $koVbs.default)();
    const [isEditing, setIsEditing] = (0, $5uXOq.useState)(false);
    const [_, { triggerEpicPanelRefetch: triggerEpicPanelRefetch }] = (0, $3bPZM.useShouldRefetchEpicPanel)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const storyPointKey = storyPointFieldId || '';
    const [storyPointFieldValue] = (0, $3fAi8.useFieldValue)({
        issueKey: issueKey,
        fieldKey: storyPointKey
    });
    const ariaLabelWithValue = storyPointFieldValue ? formatMessage((0, $7q84v.default).storyPointsAriaLabel, {
        storyPointValue: formatNumber(storyPointFieldValue)
    }) : formatMessage((0, $7q84v.default).storyPointsAriaLabelNullValue); // I think this is more correct since hasEstimate only checks THIS issue but there could be
    // other issues on the backlog that do have estimates. That will mess up the layout
    // and shift all the content slightly across to make space for the story point field
    const shouldRenderEstimatesColumn = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasEstimates));
    const hasEstimate = (0, $c1MAf.useBacklogSelector)((state)=>!!(0, $dGljH.getCards)(state)[String(issueId)]?.estimate);
    const saveCompanyManaged = (0, $5uXOq.useCallback)((iKey, fieldKey, newValue, baseURL)=>(0, $fUvM9.saveField)(String(issueId), fieldKey, newValue, baseURL), [
        issueId
    ]);
    const handleEdit = (0, $5uXOq.useCallback)(()=>{
        if (storyPointKey && (0, $4R6GH.fg)('one_event_rules_them_all_fg')) (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsStart(storyPointKey, {
            analytics: createAnalyticsEvent({}),
            attributes: {
                fieldType: (0, $8ikZj.FIELD_TYPE_MAP)[0, $5fc53.STORY_POINTS_TYPE],
                isInlineEditing: true
            }
        });
        setIsEditing(true);
    }, [
        createAnalyticsEvent,
        storyPointKey
    ]);
    const handleConfirm = (0, $5uXOq.useCallback)(()=>{
        (0, $dspDn.setInlineEditStoryPointInteractionStartMark)();
        setIsEditing(false);
    }, []);
    const handleUpdate = (0, $5uXOq.useCallback)((value)=>{
        (0, $dspDn.setInlineEditStoryPointInteractionStopMark)(isCompanyManaged);
        dispatch((0, $gwOHY.refetchVersions)());
        if (value !== undefined && typeof value === 'number') dispatch((0, $3EtSK.cardEstimateSet)(issueId, {
            storyPoints: value
        }));
        if (isCompanyManaged) triggerEpicPanelRefetch();
        setIsEditing(false);
    }, [
        dispatch,
        isCompanyManaged,
        triggerEpicPanelRefetch,
        issueId
    ]);
    const handleFailure = (0, $5uXOq.useCallback)(()=>{
        (0, $dspDn.cancelInlineEditStoryPointInteractionMark)();
        setIsEditing(false);
    }, []);
    const handleCancel = (0, $5uXOq.useCallback)(()=>{
        (0, $dspDn.cancelInlineEditStoryPointInteractionMark)();
        setIsEditing(false);
    }, [
        setIsEditing
    ]);
    if (!shouldRenderStoryPointColumn && (!storyPointKey || estimationType !== (0, $guzeq.STORY_POINTS) || shouldRenderEstimatesColumn)) return null;
    const isStoryPointAccessible = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(storyPointFieldValue);
    const issueStoryPointFieldStatic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $81g2L.default), {
        value: storyPointFieldValue ?? undefined,
        hasStoryPoints: hasEstimate,
        shouldRenderStoryPointColumn: shouldRenderStoryPointColumn
    });
    const renderStorypointField = ()=>// We should always render the container otherwise the layout gets all messed up
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($82ca48db4553a327$var$StoryPointFieldWrapper, {
            shouldRenderStoryPointColumn: shouldRenderStoryPointColumn
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gnK7n.default), {
            tooltipLabel: formatMessage((0, $7q84v.default).storyPointsTooltip),
            ariaLabel: ariaLabelWithValue,
            tooltipPosition: isEditing ? 'top' : 'bottom'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($82ca48db4553a327$var$StoryPointFieldContainer, {
            hasValue: isStoryPointAccessible,
            useInlineEditIndexFix: (0, $4R6GH.fg)('tnk-693-basic-estimate-inline-edit-input')
        }, hasEstimate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($82ca48db4553a327$export$88b57365e3a3cb92, {
            issueKey: issueKey,
            fieldKey: storyPointKey,
            fieldFocusStyle: (0, $a4c5fe4dcf7753af$export$44f42916442b37c3),
            fieldEditStyle: (0, $a4c5fe4dcf7753af$export$1ff9623b26415f8),
            onEdit: handleEdit,
            onUpdate: handleUpdate,
            onConfirm: handleConfirm,
            onFailure: handleFailure,
            onCancel: handleCancel,
            saveField: isCompanyManaged ? saveCompanyManaged : undefined
        }))));
    if (isUserAtLeastMember && shouldRenderRichCard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bJ2M7.IssueNumberFieldBoundary), {
        packageName: (0, $a9c483c0d986286a$export$dfd208682d29484c),
        fallback: issueStoryPointFieldStatic
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dM9vk.default), {
        experienceTarget: "inline story point",
        experienceTargetId: issueKey,
        additionalAttributes: {
            issueKey: issueKey
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            fieldName: (0, $3XO6n.STORY_POINT_ESTIMATE_CF_ANALYTIC_TYPE)
        }
    }, renderStorypointField())));
    return issueStoryPointFieldStatic;
};
var $82ca48db4553a327$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($82ca48db4553a327$var$StoryPointField);
const $82ca48db4553a327$var$StoryPointFieldContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { useInlineEditIndexFix: useInlineEditIndexFix, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_80om73ad _1e0c1txw _18kq1kw7 _1jsw1kw7 _3p7d1kw7 _j88e1kw7 _1ksg1kw7 _zpal1kw7 _wnsb1kw7 _bwtn1kw7 _wlgl1kw7 _1n6k1kw7 _tq0k1kw7 _xzt01kw7 _13g31txw _y5xnglyw _1la1idpf _n0ewu2gc _cgnyidpf _10gfidpf _joadidpf _18vj1txw _nt751r31 _1guj1r31 _49pcglyw _pbhaglyw _1hvw1o36 _11ow1o36",
            __cmplp.useInlineEditIndexFix && "_1opmcs5v _p587kb7n",
            __cmplp.className
        ])
    });
}); // empty column for the cards that without storyPoint
const $82ca48db4553a327$var$StoryPointFieldWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldRenderStoryPointColumn: shouldRenderStoryPointColumn, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.shouldRenderStoryPointColumn && "_1ul91shb _p12f1shb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fUvM9", function(module, exports) {

$parcel$export(module.exports, "saveField", () => $f0796cdd3cd63a15$export$72a8b15fb4557735);
$parcel$export(module.exports, "useClassicStoryPointField", () => $f0796cdd3cd63a15$export$aa8e8a51326640a2);

var $9XE6b = parcelRequire("9XE6b");

var $ebyGx = parcelRequire("ebyGx");

var $eusud = parcelRequire("eusud");

var $lQE94 = parcelRequire("lQE94");

var $54wEF = parcelRequire("54wEF");

var $4tcSU = parcelRequire("4tcSU");

var $g5X3G = parcelRequire("g5X3G");
const $f0796cdd3cd63a15$export$72a8b15fb4557735 = async (issueId, fieldKey, newValue, _baseUrl)=>(0, $eusud.performPostRequest)('/secure/AjaxIssueAction.jspa?decorator=none', {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: (0, $ebyGx.stringify)({
            [fieldKey]: newValue,
            issueId: issueId,
            skipScreenCheck: true,
            atl_token: (0, $4tcSU.default)(),
            singleFieldEdit: true
        })
    });
const $f0796cdd3cd63a15$export$aa8e8a51326640a2 = ({ issueKey: issueKey, issueId: issueId, fieldKey: fieldKey, onSuccess: onSuccess })=>{
    // useFieldConfig now returns an object { value, loading } instead of just the fieldConfig value
    // if possible when touching this, try and refactor to pass the new object instead of just the value
    const [{ value: fieldConfig }] = (0, $54wEF.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(fieldConfig, 'schema.type', 'number');
    const saveClassicField = (_issueKey, _fieldKey, newValue, baseUrl)=>$f0796cdd3cd63a15$export$72a8b15fb4557735((0, $g5X3G.toIssueKey)(issueId.toString()), fieldKey, newValue, baseUrl);
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $lQE94.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        saveField: saveClassicField,
        onSuccess: onSuccess,
        analyticsFieldTypeAlias: 'classicstorypoint'
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});
parcelRegister("lQE94", function(module, exports) {

$parcel$export(module.exports, "useContextualIssueIdForIssueKey", () => $c31e2d123e024ddc$export$76d937477b5f784a);
$parcel$export(module.exports, "useEditField", () => $c31e2d123e024ddc$export$343e962d356c0af1);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $3BIWb = parcelRequire("3BIWb");

var $2YZCu = parcelRequire("2YZCu");

var $4R6GH = parcelRequire("4R6GH");

var $jJZqs = parcelRequire("jJZqs");

var $fZneA = parcelRequire("fZneA");

var $ctrpc = parcelRequire("ctrpc");

var $d6AeP = parcelRequire("d6AeP");

var $2gCtH = parcelRequire("2gCtH");

var $afs7f = parcelRequire("afs7f");

var $15WDX = parcelRequire("15WDX");

var $biQrn = parcelRequire("biQrn");

var $8zOmE = parcelRequire("8zOmE");

var $3fAi8 = parcelRequire("3fAi8");

var $99cgx = parcelRequire("99cgx");
/**
 * Some responses contain `fields` property without `fieldKey`.
 * We must avoid changing the state of this fields by checking `fieldKey` property in the `fields`.
 * @param response
 * @param fieldKey
 */ const $c31e2d123e024ddc$var$getFieldValue = (response, fieldKey)=>{
    if (!response) return null;
    if (response.fields) {
        if (Object.hasOwnProperty.call(response.fields, fieldKey)) return response.fields[fieldKey];
        return null;
    }
    return response;
};
const $c31e2d123e024ddc$var$shouldCallSetFieldValue = (response, fieldKey)=>{
    if (!response) return false;
    if (response.fields) return !!Object.hasOwnProperty.call(response.fields, fieldKey);
    return true;
};
const $c31e2d123e024ddc$export$3796d3fdbc2e6b54 = (fieldOptions)=>{
    // di-ignore - Please fix parent-switcher examples
    const baseUrl = '';
    const { issueKey: issueKey, issueId: issueId, fieldKey: fieldKey, fieldType: fieldType, initialValue: initialValue, analyticsFieldKeyAlias: analyticsFieldKeyAlias, analyticsFieldTypeAlias: analyticsFieldTypeAlias, mapNonOptimisticResponse: mapNonOptimisticResponse = $c31e2d123e024ddc$var$getFieldValue, saveField: saveField = (0, $99cgx.defaultSaveField), saveFieldById: saveFieldById = (0, $99cgx.defaultSaveFieldById), addValuesToField: addValuesToField = (0, $99cgx.defaultAddValuesToField), removeValuesFromField: removeValuesFromField = (0, $99cgx.defaultRemoveValuesFromField), onSubmit: onSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onSuccess: onSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onFailure: onFailure = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) } = fieldOptions;
    // We need to track the mounted state as it is possible that a component
    // using this hook can be unmounted before the async edit operation is completed.
    // Causing a react warning about setting state on an unmounted component.
    const isMounted = (0, $biQrn.useIsMounted)();
    const [fieldPersistedValue, { setFieldValue: setFieldValue }] = (0, $3fAi8.useFieldValue)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const fieldValue = fieldPersistedValue !== undefined ? fieldPersistedValue : initialValue;
    const [error, setError] = (0, $5uXOq.useState)(null);
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    const resetError = (0, $5uXOq.useCallback)(()=>{
        if (isMounted.current) setError(null);
    }, [
        setError,
        isMounted
    ]);
    const editFieldValue = (0, $5uXOq.useCallback)(async (editOperation, editOperationType, valuesForOperation, valuesForUI, meta, analyticsEvent, options = {
        isOptimistic: true
    })=>{
        let result;
        const actualFieldType = analyticsFieldTypeAlias ?? fieldType;
        const analyticsData = {
            editOperationType: editOperationType,
            issueId: issueId,
            fieldKey: analyticsFieldKeyAlias ?? fieldKey,
            fieldType: actualFieldType
        };
        if (isMounted.current) {
            setLoading(true);
            setError(null);
        }
        try {
            onSubmit(fieldValue, valuesForOperation, meta, analyticsEvent);
            if (options.isOptimistic) setFieldValue(issueKey, fieldKey, valuesForUI);
            result = await editOperation(issueKey, fieldKey, valuesForOperation, baseUrl, meta);
            const fieldValueResponse = mapNonOptimisticResponse(result, fieldKey);
            $c31e2d123e024ddc$var$shouldCallSetFieldValue(result, fieldKey) && setFieldValue(issueKey, fieldKey, fieldValueResponse);
            onSuccess(fieldValueResponse ?? valuesForOperation, analyticsEvent, meta);
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'field updated', analyticsData);
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'field updateSucceeded', analyticsData);
            if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd(fieldKey, {
                analytics: analyticsEvent,
                attributes: {
                    fieldType: actualFieldType,
                    isInlineEditing: !(0, $d6AeP.getIsEditFromIssueView)(analyticsEvent),
                    ...(0, $4R6GH.fg)('one_event_improvements_1') && {
                        issueId: issueId
                    }
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (ex) {
            result = Promise.reject(ex);
            onFailure(ex, valuesForOperation);
            setFieldValue(issueKey, fieldKey, fieldValue);
            if (isMounted.current) setError(ex);
            const isValidationError = ex instanceof (0, $jJZqs.ValidationError);
            if (!isValidationError) (0, $2YZCu.default).safeErrorWithoutCustomerData('issue-field.save-value', `Failed to update field ${fieldKey} of type ${fieldType}`, ex);
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'field updateFailed', {
                fieldKey: fieldKey,
                fieldType: analyticsFieldTypeAlias ?? fieldType,
                isValidationError: isValidationError,
                isClientFetchError: (0, $fZneA.isClientFetchError)(ex)
            });
            if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) (0, $ctrpc.getUpdateAnalyticsFlowHelper)().endSession(fieldKey);
        }
        if (isMounted.current) setLoading(false);
        return result;
    }, [
        issueId,
        analyticsFieldKeyAlias,
        fieldKey,
        analyticsFieldTypeAlias,
        fieldType,
        isMounted,
        onSubmit,
        fieldValue,
        setFieldValue,
        issueKey,
        onSuccess,
        onFailure,
        mapNonOptimisticResponse
    ]);
    const saveValue = (0, $5uXOq.useCallback)(async (newValue, meta, analyticsEvent)=>editFieldValue(saveField, 'set', newValue, newValue, meta, analyticsEvent), [
        editFieldValue,
        saveField
    ]);
    const saveById = (0, $5uXOq.useCallback)(async (newValue, meta, analyticsEvent)=>editFieldValue(saveFieldById, 'set', newValue, newValue, meta, analyticsEvent, {
            isOptimistic: false
        }), [
        editFieldValue,
        saveFieldById
    ]);
    const addValues = (0, $5uXOq.useCallback)(async (valuesToAdd, expectedValuesAfterAdding, meta, analyticsEvent)=>editFieldValue(addValuesToField, 'add', valuesToAdd, expectedValuesAfterAdding, meta, analyticsEvent), [
        editFieldValue,
        addValuesToField
    ]);
    const removeValues = (0, $5uXOq.useCallback)(async (valuesToRemove, expectedValuesAfterRemoval, meta, analyticsEvent)=>editFieldValue(removeValuesFromField, 'remove', valuesToRemove, expectedValuesAfterRemoval, meta, analyticsEvent), [
        editFieldValue,
        removeValuesFromField
    ]);
    return [
        {
            value: fieldValue,
            loading: loading,
            error: error
        },
        {
            saveById: saveById,
            saveValue: saveValue,
            addValues: addValues,
            removeValues: removeValues,
            resetError: resetError
        }
    ];
};
const $c31e2d123e024ddc$export$76d937477b5f784a = (issueKey)=>{
    const contextualIssueId = (0, $2gCtH.useIssueId)();
    const contextualIssueKey = (0, $2gCtH.useIssueKey)();
    return contextualIssueKey === issueKey ? contextualIssueId : null;
};
const $c31e2d123e024ddc$var$getAdditionalProperties = (meta, isEditFromIssueView)=>{
    if (!meta || typeof meta === 'object') return {
        ...meta ?? {},
        isEditFromIssueView: isEditFromIssueView
    };
    return meta;
};
const $c31e2d123e024ddc$export$343e962d356c0af1 = (fieldOptions)=>{
    const { fieldKey: fieldKey, issueId: issueIdFromFieldOptions, issueKey: issueKey, onSubmit: onSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onSuccess: onSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onFailure: onFailure = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), shouldPreventIssueViewSoftRefresh: shouldPreventIssueViewSoftRefresh = false } = fieldOptions;
    const [, { fieldChanged: fieldChanged, fieldChangeFailed: fieldChangeFailed, fieldChangeRequested: fieldChangeRequested }] = (0, $15WDX.useIssueViewFieldUpdateEvents)();
    const contextualIssueId = $c31e2d123e024ddc$export$76d937477b5f784a(issueKey);
    const issueId = issueIdFromFieldOptions ?? contextualIssueId;
    const onSubmitFn = (0, $5uXOq.useCallback)((oldValue, newValue, meta, event)=>{
        onSubmit(oldValue, newValue, meta, event);
        issueId && fieldChangeRequested(issueId, fieldKey, newValue, meta);
    }, [
        fieldChangeRequested,
        fieldKey,
        issueId,
        onSubmit
    ]);
    const onSuccessFn = (0, $5uXOq.useCallback)(async (fieldValue, event, meta)=>{
        onSuccess(fieldValue);
        issueId && fieldChanged(issueId, fieldKey, fieldValue, undefined, (0, $4R6GH.fg)('one_event_rules_them_all_fg') ? $c31e2d123e024ddc$var$getAdditionalProperties(meta, (0, $d6AeP.getIsEditFromIssueView)(event)) : meta);
        if (!shouldPreventIssueViewSoftRefresh && !(0, $d6AeP.getIsEditFromIssueView)(event)) try {
            const reason = (0, $afs7f.Reason).SoftRefresh;
            await (0, $3BIWb.default).refreshIssuePageThrowable(issueKey, reason);
        } catch (error) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.fields.use-edit-field.refresh', error instanceof Error ? error.message : 'useEditField issue refresh failed');
        }
    }, [
        fieldChanged,
        fieldKey,
        shouldPreventIssueViewSoftRefresh,
        issueId,
        issueKey,
        onSuccess
    ]);
    const onFailureFn = (0, $5uXOq.useCallback)((error, failedValue)=>{
        onFailure(error, failedValue);
        issueId && fieldChangeFailed(issueId, fieldKey);
    }, [
        fieldChangeFailed,
        fieldKey,
        issueId,
        onFailure
    ]);
    return $c31e2d123e024ddc$export$3796d3fdbc2e6b54({
        ...fieldOptions,
        onSubmit: onSubmitFn,
        onSuccess: onSuccessFn,
        onFailure: onFailureFn
    });
};

});
parcelRegister("3BIWb", function(module, exports) {

$parcel$export(module.exports, "default", () => $b65e83eb4ced9ce9$export$2e2bcd8739ae039);
const $b65e83eb4ced9ce9$var$REFRESH_ISSUE_PAGE_EVENT = 'legacy_refreshIssuePage';
const $b65e83eb4ced9ce9$var$UPDATE_ISSUE_GLANCE_EVENT = 'legacy_updateIssueGlance';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b65e83eb4ced9ce9$var$addEventListener = (event, callback)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.addEventListener(event, callback);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b65e83eb4ced9ce9$var$removeEventListener = (event, callback)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.removeEventListener(event, callback);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b65e83eb4ced9ce9$var$addRefreshIssueListener = (callback)=>$b65e83eb4ced9ce9$var$addEventListener($b65e83eb4ced9ce9$var$REFRESH_ISSUE_PAGE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b65e83eb4ced9ce9$var$removeRefreshIssueListener = (callback)=>$b65e83eb4ced9ce9$var$removeEventListener($b65e83eb4ced9ce9$var$REFRESH_ISSUE_PAGE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b65e83eb4ced9ce9$var$addUpdateIssueGlanceListener = (callback)=>$b65e83eb4ced9ce9$var$addEventListener($b65e83eb4ced9ce9$var$UPDATE_ISSUE_GLANCE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b65e83eb4ced9ce9$var$removeUpdateIssueGlanceListener = (callback)=>$b65e83eb4ced9ce9$var$removeEventListener($b65e83eb4ced9ce9$var$UPDATE_ISSUE_GLANCE_EVENT, callback);
const $b65e83eb4ced9ce9$var$refreshIssuePageThrowable = (issueKey, reason = 'ON_DEMAND')=>{
    try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.dispatchEvent(new CustomEvent($b65e83eb4ced9ce9$var$REFRESH_ISSUE_PAGE_EVENT, {
            detail: [
                issueKey,
                {
                    mergeIntoCurrent: false,
                    reason: reason
                }
            ]
        }));
        return Promise.resolve();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return Promise.reject(e);
    }
};
const $b65e83eb4ced9ce9$var$refreshIssuePage = (issueKey)=>// Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    $b65e83eb4ced9ce9$var$refreshIssuePageThrowable(issueKey).catch(()=>{});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b65e83eb4ced9ce9$export$2e2bcd8739ae039 = {
    addRefreshIssueListener: $b65e83eb4ced9ce9$var$addRefreshIssueListener,
    removeRefreshIssueListener: $b65e83eb4ced9ce9$var$removeRefreshIssueListener,
    addUpdateIssueGlanceListener: $b65e83eb4ced9ce9$var$addUpdateIssueGlanceListener,
    removeUpdateIssueGlanceListener: $b65e83eb4ced9ce9$var$removeUpdateIssueGlanceListener,
    refreshIssuePageThrowable: $b65e83eb4ced9ce9$var$refreshIssuePageThrowable,
    refreshIssuePage: $b65e83eb4ced9ce9$var$refreshIssuePage
};

});

parcelRegister("d6AeP", function(module, exports) {

$parcel$export(module.exports, "getIsEditFromIssueView", () => $843704b157f0fa59$export$8846558eb0b5fa3);

var $hBuqR = parcelRequire("hBuqR");

var $lhVtI = parcelRequire("lhVtI");
const $843704b157f0fa59$export$8846558eb0b5fa3 = (event)=>{
    const ISSUE_VIEW_SOURCES = [
        'fullIssueScreen',
        'boardIssueViewScreen',
        'agility-backlogScreen',
        'issueNavigatorEmbeddedIssueViewScreen',
        'globalIssueNavigatorIssueScreen',
        'mobileIssueScreen',
        'classicRoadmapScreen',
        'roadmapScreen',
        'versionDetailsIssueScreen',
        'bitbucketIssueScreen',
        'jsmQueueAgentViewSidebarScreen',
        'viewQueueIssueScreen',
        'jswModalIssueAppScreen',
        'jwmModalIssueAppScreen',
        'jswSidebarIssueAppScreen',
        'jwmSidebarIssueAppScreen'
    ];
    const { payload: { source: source } } = (0, $lhVtI.getEvent)(event);
    if (!source) return false;
    if (ISSUE_VIEW_SOURCES.includes(source)) // event originated from issue view location
    return true;
    if (source.startsWith((0, $hBuqR.PACKAGE_NAME_GASV3))) // event originated from forge app, which can only be mounted in issue view for field editing
    return true;
    return false;
};

});

parcelRegister("afs7f", function(module, exports) {

$parcel$export(module.exports, "Reason", () => $90b3aba4b3cc23bb$export$fe867595c4640fb1);
const $90b3aba4b3cc23bb$export$fe867595c4640fb1 = {
    /**
	 * Aka hard refresh, used by Ecosystem apps to refresh issue view on demand
	 * 1) Full issue view refresh
	 * 2) Hard Ecosystem apps refresh (causes remounting of the apps)
	 */ OnDemand: 'ON_DEMAND',
    /**
	 * Used by Jira internally to update issue view on demand without forcing Ecosystem apps to rerender
	 * 1) Full issue view refresh only
	 * 2) Ecosystem app aren't hard refreshed, however, if field's value has changed, Forge custom field will rerender
	 */ SoftRefresh: 'SOFT_REFRESH',
    /**
	 * Issue view refresh caused by Realtime service (Jirt)
	 */ Realtime: 'REALTIME'
};

});

parcelRegister("15WDX", function(module, exports) {

$parcel$export(module.exports, "useIssueViewFieldUpdateEvents", () => $947bdf396d8056bc$export$444af741f6d8f512);
$parcel$export(module.exports, "IssueViewFieldUpdateEventContainer", () => $947bdf396d8056bc$export$f9eb49cc2f0e28ce);

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $5YMLs = parcelRequire("5YMLs");

var $3z81P = parcelRequire("3z81P");
const $947bdf396d8056bc$var$registerEventHandler = (type, eventHandler)=>({ getState: getState, setState: setState })=>{
        if (typeof eventHandler !== 'function') // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        const { eventHandlers: eventHandlers } = getState();
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ onChange: OnChangeHandler[]; }'.
        const typeEventHandlers = eventHandlers[type];
        setState({
            eventHandlers: {
                ...eventHandlers,
                [type]: typeEventHandlers.concat([
                    eventHandler
                ])
            }
        });
        return ()=>{
            const { eventHandlers: eventHandlersForUnregister } = getState();
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ onChange: OnChangeHandler[]; }'.
            const typeEventHandlersForUnregister = eventHandlersForUnregister[type];
            const newTypeEventHandlers = typeEventHandlersForUnregister.filter(// @ts-expect-error - TS7006 - Parameter 'handler' implicitly has an 'any' type.
            (handler)=>handler !== eventHandler);
            setState({
                eventHandlers: {
                    ...eventHandlersForUnregister,
                    [type]: newTypeEventHandlers
                }
            });
        };
    };
const $947bdf396d8056bc$var$fieldChanged = (issueId, fieldId, fieldValue, aggFieldChangeProps, additionalProperties)=>({ getState: getState })=>{
        let value = fieldValue;
        if (aggFieldChangeProps) value = (0, $5YMLs.transformAggToLegacy)({
            fieldValue: fieldValue,
            aggFieldChangeProps: aggFieldChangeProps
        });
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                fieldId: // field id is required to be compatible with v1 onChange API
                fieldId,
                meta: {
                    fieldId: fieldId,
                    fieldValue: value,
                    additionalProperties: additionalProperties
                },
                type: (0, $3z81P.ChangeEventTypes).FIELD_CHANGED
            });
        });
    };
const $947bdf396d8056bc$var$fieldChangeFailed = (issueId, fieldId)=>({ getState: getState })=>{
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                meta: {
                    fieldId: fieldId
                },
                type: (0, $3z81P.ChangeEventTypes).FIELD_CHANGE_FAILED
            });
        });
    };
const $947bdf396d8056bc$var$fieldChangeRequested = (issueId, fieldId, fieldValue, additionalProperties, aggFieldChangeProps)=>({ getState: getState })=>{
        let value = fieldValue;
        if (aggFieldChangeProps) value = (0, $5YMLs.transformAggToLegacy)({
            fieldValue: fieldValue,
            aggFieldChangeProps: aggFieldChangeProps
        });
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                meta: {
                    fieldId: fieldId,
                    fieldValue: value,
                    additionalProperties: additionalProperties
                },
                type: (0, $3z81P.ChangeEventTypes).FIELD_CHANGE_REQUESTED
            });
        });
    };
const $947bdf396d8056bc$var$actions = {
    fieldChanged: $947bdf396d8056bc$var$fieldChanged,
    fieldChangeFailed: $947bdf396d8056bc$var$fieldChangeFailed,
    fieldChangeRequested: $947bdf396d8056bc$var$fieldChangeRequested,
    registerEventHandler: $947bdf396d8056bc$var$registerEventHandler
};
// this is a global state
const $947bdf396d8056bc$var$store = (0, $iXqE5.createStore)({
    name: 'issue-view-field-update-events',
    initialState: {
        eventHandlers: {
            onChange: []
        }
    },
    actions: $947bdf396d8056bc$var$actions
});
const $947bdf396d8056bc$export$444af741f6d8f512 = (0, $3sQ5x.createHook)($947bdf396d8056bc$var$store, {
    selector: null
});
const $947bdf396d8056bc$export$f9eb49cc2f0e28ce = (0, $gg7kZ.createContainer)($947bdf396d8056bc$var$store);

});
parcelRegister("5YMLs", function(module, exports) {

$parcel$export(module.exports, "transformAggToLegacy", () => $1da8cbd2b672325c$export$d951e3c38e10736d);

var $bMD69 = parcelRequire("bMD69");

var $5fc53 = parcelRequire("5fc53");

var $1pF6B = parcelRequire("1pF6B");

var $lTnWS = parcelRequire("lTnWS");
const $1da8cbd2b672325c$export$d951e3c38e10736d = ({ fieldValue: fieldValue, aggFieldChangeProps: aggFieldChangeProps })=>{
    if (!aggFieldChangeProps?.__typename) throw new Error('node did not have __typename');
    switch(aggFieldChangeProps.__typename){
        // These fields require context for their transform in transformAggFieldToLegacyField so need to be manually implemented
        // This is not an exhaustive list, I did a quick check is all, so best to check the transform works as expected as you migrate fields to relay
        // These are commented out because they are not implemented and due to types can't just be added here until implemented
        // case JSM_PEOPLE_GQL_FIELD:
        // case ISSUE_RESTRICTION_GQL_FIELD:
        // otherwise we can default to the existing package
        case 0, $5fc53.RADIO_GQL_FIELD:
        case 0, $5fc53.TEAM_VIEW_GQL_FIELD:
        case 0, $5fc53.MULTI_GROUP_PICKER_GQL_FIELD:
        case 0, $5fc53.SINGLE_GROUP_PICKER_GQL_FIELD:
        case 0, $5fc53.MULTI_USER_PICKER_GQL_FIELD:
        case 0, $5fc53.PEOPLE_GQL_FIELD:
        case 0, $5fc53.SECURITY_GQL_FIELD:
        case 0, $5fc53.NUMBER_GQL_FIELD:
        case 0, $5fc53.TEXT_GQL_FIELD:
        case 0, $5fc53.USER_PICKER_GQL_FIELD:
        case 0, $5fc53.PRIORITY_GQL_FIELD:
        case 0, $5fc53.URL_GQL_FIELD:
        case 0, $5fc53.DATE_PICKER_GQL_FIELD:
        case 0, $5fc53.PROJECT_GQL_FIELD:
        case 0, $5fc53.DATE_TIME_GQL_FIELD:
        case 0, $5fc53.COLOR_GQL_FIELD:
        case 0, $5fc53.ORIGINAL_ESTIMATE_GQL_FIELD:
        case 0, $5fc53.ISSUE_TYPE_GQL_FIELD:
        case 0, $5fc53.VOTES_GQL_FIELD:
        case 0, $5fc53.WATCHES_GQL_FIELD:
        case 0, $5fc53.RESOLUTION_GQL_FIELD:
        case 0, $5fc53.STATUS_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $bMD69.transformAggFieldToLegacyField)({
                [$1da8cbd2b672325c$var$getValueKey(aggFieldChangeProps.__typename)]: fieldValue,
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type
            })?.value;
        case 0, $5fc53.RICH_TEXT_GQL_FIELD:
            return (0, $lTnWS.transformAggRichTextFieldValueToLegacyFieldValue)(fieldValue, aggFieldChangeProps.renderer);
        case 0, $5fc53.PARENT_GQL_FIELD:
            return (0, $1pF6B.transformAggParentFieldValueToLegacyFieldValue)(fieldValue);
        case 0, $5fc53.SPRINT_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $bMD69.transformAggFieldToLegacyField)({
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type,
                ...fieldValue
            })?.value;
        case 0, $5fc53.TIME_TRACKING_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $bMD69.transformAggFieldToLegacyField)({
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type,
                originalEstimate: fieldValue.originalEstimate,
                remainingEstimate: fieldValue.remainingEstimate,
                timeSpent: fieldValue.timeSpent
            })?.value;
        case 0, $5fc53.CHECKBOX_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $bMD69.transformAggFieldToLegacyField)({
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type,
                selectedOptions: fieldValue.selectedOptions,
                checkboxesFieldOptions: fieldValue.fieldOptions
            })?.value;
        case 0, $5fc53.COMPONENTS_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $bMD69.transformAggFieldToLegacyField)({
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type,
                selectedComponentsConnection: fieldValue.selectedComponentsConnection
            })?.value;
        default:
            throw new Error('__typename not implemented');
    }
};
const $1da8cbd2b672325c$var$getValueKey = (__typename)=>{
    const VALUE_KEYS = {
        [(0, $5fc53.TEXT_GQL_FIELD)]: 'text',
        [(0, $5fc53.NUMBER_GQL_FIELD)]: 'number',
        [(0, $5fc53.PRIORITY_GQL_FIELD)]: 'priority',
        [(0, $5fc53.USER_PICKER_GQL_FIELD)]: 'user',
        [(0, $5fc53.DATE_PICKER_GQL_FIELD)]: 'date',
        [(0, $5fc53.PROJECT_GQL_FIELD)]: 'project',
        [(0, $5fc53.DATE_TIME_GQL_FIELD)]: 'dateTime',
        [(0, $5fc53.ORIGINAL_ESTIMATE_GQL_FIELD)]: 'originalEstimate',
        [(0, $5fc53.URL_GQL_FIELD)]: 'uri',
        [(0, $5fc53.SECURITY_GQL_FIELD)]: 'securityLevel',
        [(0, $5fc53.PEOPLE_GQL_FIELD)]: 'selectedUsersConnection',
        [(0, $5fc53.WATCHES_GQL_FIELD)]: 'watch',
        [(0, $5fc53.VOTES_GQL_FIELD)]: 'vote',
        [(0, $5fc53.COLOR_GQL_FIELD)]: 'color',
        [(0, $5fc53.MULTI_USER_PICKER_GQL_FIELD)]: 'selectedUsersConnection',
        [(0, $5fc53.ISSUE_TYPE_GQL_FIELD)]: 'issueType',
        [(0, $5fc53.RESOLUTION_GQL_FIELD)]: 'resolution',
        [(0, $5fc53.MULTI_GROUP_PICKER_GQL_FIELD)]: 'selectedGroupsConnection',
        [(0, $5fc53.SINGLE_GROUP_PICKER_GQL_FIELD)]: 'selectedGroup',
        [(0, $5fc53.TEAM_VIEW_GQL_FIELD)]: 'selectedTeam',
        [(0, $5fc53.STATUS_GQL_FIELD)]: 'status',
        [(0, $5fc53.RADIO_GQL_FIELD)]: 'selectedOption',
        [(0, $5fc53.RICH_TEXT_GQL_FIELD)]: 'richText'
    };
    const value = VALUE_KEYS[__typename];
    if (value) return value;
    throw new Error(`Did you forget to implement getValueKey for your field type? Couldn't find a value in the map for ${__typename}`);
};

});
parcelRegister("bMD69", function(module, exports) {

$parcel$export(module.exports, "transformAggFieldToLegacyField", () => $af5e8bab0defb9c8$export$586ba15cbf3d3031);
$parcel$export(module.exports, "transformAggFieldsToLegacyFields", () => $af5e8bab0defb9c8$export$ba106ff8c087e6b1);

var $8QpSo = parcelRequire("8QpSo");

var $5fc53 = parcelRequire("5fc53");

var $9bgym = parcelRequire("9bgym");

var $6iJEF = parcelRequire("6iJEF");

var $9UrtF = parcelRequire("9UrtF");

var $hsEaK = parcelRequire("hsEaK");

var $2qu1N = parcelRequire("2qu1N");

var $16Zia = parcelRequire("16Zia");

var $iv8Rf = parcelRequire("iv8Rf");

var $hDlc2 = parcelRequire("hDlc2");

var $c3LW9 = parcelRequire("c3LW9");

var $h92P3 = parcelRequire("h92P3");

var $aeO9V = parcelRequire("aeO9V");

var $6Tnq8 = parcelRequire("6Tnq8");

var $6mbsj = parcelRequire("6mbsj");

var $d3nG3 = parcelRequire("d3nG3");

var $1xW6n = parcelRequire("1xW6n");

var $fW9XR = parcelRequire("fW9XR");

var $bKMMB = parcelRequire("bKMMB");

var $7JL37 = parcelRequire("7JL37");

var $dulCG = parcelRequire("dulCG");

var $6vno6 = parcelRequire("6vno6");

var $as0vY = parcelRequire("as0vY");

var $6dPLd = parcelRequire("6dPLd");

var $gKccZ = parcelRequire("gKccZ");

var $jnUrZ = parcelRequire("jnUrZ");

var $iJtmd = parcelRequire("iJtmd");

var $iPyq0 = parcelRequire("iPyq0");

var $384lj = parcelRequire("384lj");

var $axTS6 = parcelRequire("axTS6");

var $lfJ6H = parcelRequire("lfJ6H");

var $9UXU7 = parcelRequire("9UXU7");

var $b6BoU = parcelRequire("b6BoU");

var $gak3n = parcelRequire("gak3n");

var $i47fO = parcelRequire("i47fO");

var $gvljZ = parcelRequire("gvljZ");

var $6XFn2 = parcelRequire("6XFn2");

var $6e1Ya = parcelRequire("6e1Ya");

var $640u2 = parcelRequire("640u2");

var $hBEiJ = parcelRequire("hBEiJ");

var $1XNj2 = parcelRequire("1XNj2");

var $f6zXW = parcelRequire("f6zXW");

var $fB4wX = parcelRequire("fB4wX");

var $cXBkk = parcelRequire("cXBkk");

var $iDKu3 = parcelRequire("iDKu3");

var $aGv90 = parcelRequire("aGv90");

var $19DRh = parcelRequire("19DRh");

var $lkW3a = parcelRequire("lkW3a");

var $lQAwK = parcelRequire("lQAwK");

var $8qOI6 = parcelRequire("8qOI6");

var $cbd7V = parcelRequire("cbd7V");

var $6hj44 = parcelRequire("6hj44");

var $4nh4C = parcelRequire("4nh4C");

var $hA3EZ = parcelRequire("hA3EZ");

var $2z4xE = parcelRequire("2z4xE");

var $cO2KQ = parcelRequire("cO2KQ");

var $5sETx = parcelRequire("5sETx");

var $f454b = parcelRequire("f454b");

var $aafIf = parcelRequire("aafIf");

var $2yWre = parcelRequire("2yWre");

var $lUeQj = parcelRequire("lUeQj");

var $6SWOK = parcelRequire("6SWOK");

var $cMc7B = parcelRequire("cMc7B");

var $38GNL = parcelRequire("38GNL");

var $avV20 = parcelRequire("avV20");

var $cbXvu = parcelRequire("cbXvu");

var $aSXJi = parcelRequire("aSXJi");

var $8uxcU = parcelRequire("8uxcU");

var $arKlm = parcelRequire("arKlm");

var $hCKV6 = parcelRequire("hCKV6");

var $d8wC0 = parcelRequire("d8wC0");
// We're memoising this just in case we FF another field
const $af5e8bab0defb9c8$var$getTransformersNonMemoised = ()=>({
        [(0, $5fc53.AFFECTED_SERVICES_GQL_FIELD)]: (0, $9bgym.transformAggAffectedServicesToLegacyField),
        [(0, $5fc53.BOOLEAN_GQL_FIELD)]: (0, $9UrtF.transformAggBooleanToLegacyField),
        [(0, $5fc53.CASCADING_SELECT_GQL_FIELD)]: (0, $hsEaK.transformAggCascadingSelectToLegacyField),
        [(0, $5fc53.CHECKBOX_GQL_FIELD)]: (0, $2qu1N.transformAggCheckboxToLegacyField),
        [(0, $5fc53.CMDB_GQL_FIELD)]: (0, $16Zia.transformAggCMDBToLegacyField),
        [(0, $5fc53.MULTI_SELECT_GQL_FIELD)]: (0, $19DRh.transformAggMultipleSelectToLegacyField),
        [(0, $5fc53.COMPONENTS_GQL_FIELD)]: (0, $hDlc2.transformAggComponentsToLegacyField),
        [(0, $5fc53.CONNECT_DATE_TIME_GQL_FIELD)]: (0, $c3LW9.transformAggConnectDateTimeToLegacyField),
        [(0, $5fc53.CONNECT_MULTI_SELECT_GQL_FIELD)]: (0, $h92P3.transformAggConnectMultipleSelectToLegacyField),
        [(0, $5fc53.CONNECT_NUMBER_GQL_FIELD)]: (0, $aeO9V.transformAggConnectNumberToLegacyField),
        [(0, $5fc53.CONNECT_RICH_TEXT_GQL_FIELD)]: (0, $6Tnq8.transformAggConnectRichTextToLegacyField),
        [(0, $5fc53.CONNECT_SINGLE_SELECT_GQL_FIELD)]: (0, $6mbsj.transformAggConnectSingleSelectToLegacyField),
        [(0, $5fc53.CONNECT_TEXT_GQL_FIELD)]: (0, $d3nG3.transformAggConnectTextToLegacyField),
        [(0, $5fc53.COLOR_GQL_FIELD)]: (0, $iv8Rf.transformAggColorToLegacyField),
        [(0, $5fc53.DATE_PICKER_GQL_FIELD)]: (0, $fW9XR.transformAggDatePickerToLegacyField),
        [(0, $5fc53.DATE_TIME_GQL_FIELD)]: (0, $bKMMB.transformAggDateTimePickerToLegacyField),
        [(0, $5fc53.EPIC_LINK_GQL_FIELD)]: (0, $7JL37.transformAggEpicLinkToLegacyField),
        [(0, $5fc53.FLAG_GQL_FIELD)]: (0, $dulCG.transformAggFlagToLegacyField),
        [(0, $5fc53.FORGE_DATETIME_GQL_FIELD)]: (0, $as0vY.transformAggForgeDateTimeToLegacyField),
        [(0, $5fc53.FORGE_DATE_GQL_FIELD)]: (0, $6vno6.transformAggForgeDateToLegacyField),
        [(0, $5fc53.FORGE_GROUP_GQL_FIELD)]: (0, $6dPLd.transformAggForgeGroupToLegacyField),
        [(0, $5fc53.FORGE_GROUPS_GQL_FIELD)]: (0, $gKccZ.transformAggForgeGroupsToLegacyField),
        [(0, $5fc53.FORGE_NUMBER_GQL_FIELD)]: (0, $jnUrZ.transformAggForgeNumberToLegacyField),
        [(0, $5fc53.FORGE_OBJECT_GQL_FIELD)]: (0, $iJtmd.transformAggForgeObjectToLegacyField),
        [(0, $5fc53.FORGE_STRING_GQL_FIELD)]: (0, $iPyq0.transformAggForgeStringToLegacyField),
        [(0, $5fc53.FORGE_STRINGS_GQL_FIELD)]: (0, $384lj.transformAggForgeStringsToLegacyField),
        [(0, $5fc53.FORGE_USER_GQL_FIELD)]: (0, $axTS6.transformAggForgeUserToLegacyField),
        [(0, $5fc53.FORGE_USERS_GQL_FIELD)]: (0, $lfJ6H.transformAggForgeUsersToLegacyField),
        [(0, $5fc53.ISSUE_RESTRICTION_GQL_FIELD)]: (0, $b6BoU.transformAggIssueRestrictionToLegacyField),
        [(0, $5fc53.ISSUE_TYPE_GQL_FIELD)]: (0, $gak3n.transformAggIssueTypeToLegacyField),
        [(0, $5fc53.JSM_APPROVAL_GQL_FIELD)]: (0, $i47fO.transformAggJSMApprovalsToLegacyField),
        [(0, $5fc53.JSM_ASSETS_GQL_FIELD)]: (0, $6iJEF.transformAggAssetToLegacyField),
        [(0, $5fc53.JSM_MAJOR_INCIDENT_FIELD)]: (0, $6XFn2.transformAggJSMMajorIncidentToLegacyField),
        [(0, $5fc53.JSM_ORGANIZATION_GQL_FIELD)]: (0, $6e1Ya.transformAggJSMOrganizationToLegacyField),
        [(0, $5fc53.JSM_ENTITLEMENTS_GQL_FIELD)]: (0, $gvljZ.transformAggJSMEntitlementsToLegacyField),
        [(0, $5fc53.JSM_SENTIMENT_GQL_FIELD)]: (0, $cXBkk.transformAggJSMSentimentToLegacyField),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        [(0, $5fc53.JSM_PEOPLE_GQL_FIELD)]: (0, $lkW3a.transformAggMultipleUserPickerToLegacyField),
        [(0, $5fc53.JSM_REQUEST_FEEDBACK_GQL_FIELD)]: (0, $hBEiJ.transformAggJSMRequestFeedbackToLegacyField),
        [(0, $5fc53.JSM_REQUEST_LANGUAGE_GQL_FIELD)]: (0, $1XNj2.transformAggJSMRequestLanguageToLegacyField),
        [(0, $5fc53.JSM_REQUEST_TYPE_GQL_FIELD)]: (0, $f6zXW.transformAggJSMRequestTypeToLegacyField),
        [(0, $5fc53.JSM_RESPONDERS_GQL_FIELD)]: (0, $fB4wX.transformAggJSMRespondersToLegacyField),
        [(0, $5fc53.LABEL_GQL_FIELD)]: (0, $iDKu3.transformAggLabelsNodeToLegacyField),
        [(0, $5fc53.PRIORITY_GQL_FIELD)]: (0, $6hj44.transformAggPriorityToLegacyField),
        [(0, $5fc53.MULTI_GROUP_PICKER_GQL_FIELD)]: (0, $aGv90.transformAggMultiGroupPickerToLegacyField),
        [(0, $5fc53.MULTI_USER_PICKER_GQL_FIELD)]: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $lkW3a.transformAggMultipleUserPickerToLegacyField),
        [(0, $5fc53.NUMBER_GQL_FIELD)]: (0, $8qOI6.transformAggNumberToLegacyField),
        [(0, $5fc53.ORIGINAL_ESTIMATE_GQL_FIELD)]: (0, $cbd7V.transformAggOriginalEstimateToLegacyField),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        [(0, $5fc53.PEOPLE_GQL_FIELD)]: (0, $lkW3a.transformAggMultipleUserPickerToLegacyField),
        [(0, $5fc53.PROFORMA_FORMS_GQL_FIELD)]: (0, $4nh4C.transformAggProformaFormsToLegacyField),
        [(0, $5fc53.PROJECT_GQL_FIELD)]: (0, $hA3EZ.transformAggProjectToLegacyField),
        [(0, $5fc53.MULTI_VERSION_GQL_FIELD)]: (0, $lQAwK.transformAggMultipleVersionPickerToLegacyField),
        [(0, $5fc53.RADIO_GQL_FIELD)]: (0, $2z4xE.transformAggRadioSelectToLegacyField),
        [(0, $5fc53.RICH_TEXT_GQL_FIELD)]: (0, $5sETx.transformAggRichTextToLegacyField),
        [(0, $5fc53.RESOLUTION_GQL_FIELD)]: (0, $cO2KQ.transformAggResolutionToLegacyField),
        [(0, $5fc53.SECURITY_GQL_FIELD)]: (0, $f454b.transformAggSecurityLevelToLegacyField),
        [(0, $5fc53.SPRINT_GQL_FIELD)]: (0, $38GNL.transformAggSprintToLegacyField),
        [(0, $5fc53.STATUS_GQL_FIELD)]: (0, $avV20.transformAggStatusToLegacyField),
        [(0, $5fc53.SINGLE_GROUP_PICKER_GQL_FIELD)]: (0, $aafIf.transformAggSingleGroupPickerToLegacyField),
        [(0, $5fc53.SINGLE_SELECT_GQL_FIELD)]: (0, $lUeQj.transformAggSingleSelectToLegacyField),
        [(0, $5fc53.TEAM_GQL_FIELD)]: (0, $cbXvu.transformAggTeamToLegacyField),
        [(0, $5fc53.TEAM_VIEW_GQL_FIELD)]: (0, $aSXJi.transformAggTeamViewToLegacyField),
        [(0, $5fc53.TEXT_GQL_FIELD)]: (0, $2yWre.transformAggSingleLineTextToLegacyField),
        [(0, $5fc53.TIME_TRACKING_GQL_FIELD)]: (0, $8uxcU.transformAggTimeTrackingToLegacyField),
        [(0, $5fc53.USER_PICKER_GQL_FIELD)]: (0, $6SWOK.transformAggSingleSelectUserPickerToLegacyField),
        [(0, $5fc53.URL_GQL_FIELD)]: (0, $arKlm.transformAggUrlToLegacyField),
        [(0, $5fc53.VERSION_GQL_FIELD)]: (0, $cMc7B.transformAggSingleVersionPickerToLegacyField),
        [(0, $5fc53.VOTES_GQL_FIELD)]: (0, $hCKV6.transformAggVotesToLegacyField),
        [(0, $5fc53.WATCHES_GQL_FIELD)]: (0, $d8wC0.transformAggWatchesToLegacyField),
        [(0, $5fc53.DATA_CLASSIFICATION_FIELD)]: (0, $1xW6n.transformAggDataClassificationToLegacyField),
        [(0, $5fc53.GOALS_GQL_FIELD)]: (0, $9UXU7.transformAggGoalsToLegacyField),
        [(0, $5fc53.JCS_ORGANIZATION_GQL_FIELD)]: (0, $640u2.transformAggJCSOrganizationToLegacyField)
    });
const $af5e8bab0defb9c8$var$getTransformers = (0, $8QpSo.default)($af5e8bab0defb9c8$var$getTransformersNonMemoised);
const $af5e8bab0defb9c8$export$586ba15cbf3d3031 = (node, projectContext)=>{
    const typename = node.__typename;
    const transformer = $af5e8bab0defb9c8$var$getTransformers()[typename];
    return transformer ? transformer(node, projectContext) : undefined;
};
const $af5e8bab0defb9c8$export$ba106ff8c087e6b1 = (fields, projectField)=>{
    if (fields == null) return {};
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return fields.reduce((fieldsState, fieldEdge)=>{
        if (fieldEdge?.node != null) {
            const projectContext = projectField != null ? projectField : (0, $hA3EZ.getProjectField)(fields)?.project;
            const transformedField = $af5e8bab0defb9c8$export$586ba15cbf3d3031(fieldEdge.node, projectContext);
            if (transformedField != null) {
                const fieldData = 'key' in transformedField ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {
                    [transformedField.key]: transformedField
                } : transformedField;
                Object.assign(fieldsState, fieldData);
            }
        }
        return fieldsState;
    }, {});
};

});
parcelRegister("9bgym", function(module, exports) {

$parcel$export(module.exports, "transformAggAffectedServicesToLegacyField", () => $0bce5d1c363f27e8$export$231e0419515441d4);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $0bce5d1c363f27e8$var$transformJiraServicesToLegacyServices = ({ serviceId: serviceId, name: name })=>({
        id: serviceId,
        name: name ?? undefined
    });
const $0bce5d1c363f27e8$export$231e0419515441d4 = (node)=>{
    if (node.type !== (0, $5fc53.SERVICE_ENTITY_CF_TYPE)) return undefined;
    const hasValue = Boolean(node.selectedAffectedServicesConnection?.edges?.length);
    const value = hasValue ? (0, $o7K5u.transformAggConnection)(node.selectedAffectedServicesConnection, $0bce5d1c363f27e8$var$transformJiraServicesToLegacyServices) : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?query=` : null,
        value: value,
        schema: {
            configuration: null,
            custom: (0, $5fc53.SERVICE_ENTITY_CF_TYPE),
            items: 'service-entity-field',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});
const $650578330a102f55$export$89b8c5d86c10a68c = 'atlassian-wiki-renderer';
const $650578330a102f55$export$a4a240cb4053b29f = 'jira-text-renderer';
const $650578330a102f55$export$840ed33fa94f7693 = 'frother-control-renderer';

parcelRegister("o7K5u", function(module, exports) {

$parcel$export(module.exports, "transformAggNodeToLegacyField", () => $cfa10031dfb7ad46$export$e7ea61856a169c36);
$parcel$export(module.exports, "transformAggConnection", () => $cfa10031dfb7ad46$export$daf92cda81d86cdc);
$parcel$export(module.exports, "toLegacyConnectOption", () => $cfa10031dfb7ad46$export$b5de5f3d2de73afc);
const $cfa10031dfb7ad46$export$e7ea61856a169c36 = (node)=>({
        ari: 'id' in node ? node.id : undefined,
        key: 'fieldId' in node && !!node.fieldId ? node.fieldId : '',
        title: 'name' in node ? node.name : '',
        editable: Boolean('isEditableInIssueView' in node ? node.isEditableInIssueView : 'fieldConfig' in node && node.fieldConfig != null && 'isEditable' in node.fieldConfig && node.fieldConfig.isEditable),
        required: Boolean('fieldConfig' in node && node.fieldConfig != null && 'isRequired' in node.fieldConfig && node.fieldConfig.isRequired),
        autoCompleteUrl: 'searchUrl' in node ? node.searchUrl : null,
        allowedValues: [],
        value: null,
        schema: {
            type: 'type' in node ? node.type : '',
            custom: null,
            system: null
        },
        description: 'description' in node && node.description ? node.description : undefined
    });
const $cfa10031dfb7ad46$export$daf92cda81d86cdc = (connection, transformCallback)=>{
    const edges = connection?.edges ?? [];
    if (transformCallback) return edges.map((edge)=>edge?.node != null ? transformCallback(edge.node) : null).filter(Boolean);
    return edges.map((edge)=>edge?.node).filter(Boolean);
};
const $cfa10031dfb7ad46$export$b5de5f3d2de73afc = (node)=>{
    if (!node) return null;
    return {
        value: node.value ?? null,
        id: parseInt(node.optionId, 10)
    };
};

});


parcelRegister("6iJEF", function(module, exports) {

$parcel$export(module.exports, "transformAggAssetToLegacyField", () => $b9f6b8590a60f3b3$export$2136dcd78a2ef18f);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b9f6b8590a60f3b3$export$2136dcd78a2ef18f = (node)=>{
    switch(node.type){
        case 0, $5fc53.ASSETS_CF_TYPE:
            {
                const hasValue = Boolean(node.selectedAssetsConnection?.edges?.length);
                const assetValue = hasValue ? (0, $o7K5u.transformAggConnection)(node.selectedAssetsConnection, ({ appKey: appKey, originId: originId, serializedOrigin: serializedOrigin, value: value })=>({
                        appKey: appKey,
                        originId: originId,
                        serializedOrigin: serializedOrigin,
                        value: value
                    })) : null;
                return {
                    ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                    autoCompleteUrl: node.searchUrl,
                    value: assetValue,
                    schema: {
                        custom: node.type,
                        system: null,
                        items: 'sd-asset',
                        type: 'array',
                        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                        configuration: null
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("9UrtF", function(module, exports) {

$parcel$export(module.exports, "transformAggBooleanToLegacyField", () => $474331244347ccdb$export$4bd89b95f0d10de9);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $474331244347ccdb$export$4bd89b95f0d10de9 = (node)=>{
    switch(node.type){
        case 0, $5fc53.SERVICEDESK_INCIDENT_MANAGEMENT_TYPE:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: {
                    alertLinking: {
                        enabled: node.value
                    }
                },
                schema: {
                    configuration: null,
                    items: null,
                    renderer: null,
                    custom: null,
                    system: (0, $5fc53.SERVICEDESK_INCIDENT_MANAGEMENT_TYPE),
                    type: (0, $5fc53.SERVICEDESK_INCIDENT_MANAGEMENT_TYPE)
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("hsEaK", function(module, exports) {

$parcel$export(module.exports, "transformAggCascadingSelectToLegacyField", () => $afb6a8576bf8d731$export$a8778af5ceb1017c);


var $o7K5u = parcelRequire("o7K5u");
const $afb6a8576bf8d731$export$a8778af5ceb1017c = (node)=>{
    let value = null;
    if (node.cascadingOption) {
        const { childOptionValue: childOptionValue, parentOptionValue: parentOptionValue } = node.cascadingOption;
        const child = childOptionValue ? {
            child: {
                id: childOptionValue.optionId,
                value: childOptionValue.value
            }
        } : {};
        value = {
            // assigned in the statement above
            id: parentOptionValue?.optionId,
            value: parentOptionValue?.value,
            ...child
        };
    }
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: [],
        schema: {
            type: 'option-with-child',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("2qu1N", function(module, exports) {

$parcel$export(module.exports, "transformAggCheckboxToLegacyField", () => $3efe07b8b545ea99$export$baa5afdbd8fd12d3);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $3efe07b8b545ea99$export$baa5afdbd8fd12d3 = (node)=>{
    switch(node.type){
        case 0, $5fc53.MULTI_CHECKBOXES_CF_TYPE:
            {
                // We're inlining the transformers per field here so it'll be easy to remove them once we make the allowedValues async
                const value = (0, $o7K5u.transformAggConnection)(node.selectedOptions, (option)=>({
                        id: option.optionId,
                        value: option.value ?? null,
                        ari: option.id
                    }));
                const allowedValues = (0, $o7K5u.transformAggConnection)(node.checkboxesFieldOptions, (option)=>({
                        id: option.optionId,
                        value: option.value ?? null,
                        ari: option.id
                    }));
                return {
                    ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                    value: value.length ? value : null,
                    allowedValues: allowedValues,
                    schema: {
                        type: 'array',
                        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                        custom: node.type,
                        system: null,
                        items: 'option',
                        configuration: null
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("16Zia", function(module, exports) {

$parcel$export(module.exports, "transformAggCMDBToLegacyField", () => $4d2c21f2e394ef74$export$93506453d9bb56ae);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $4d2c21f2e394ef74$var$transformObjectTypeToLegacy = (attribute, workspaceId)=>({
        workspaceId: workspaceId,
        id: `${workspaceId}:${attribute.objectTypeId}`,
        name: attribute.name,
        objectSchemaId: attribute.objectSchemaId,
        objectTypeId: attribute.objectTypeId,
        // `icon` is unused
        icon: {
            id: attribute.icon.id,
            name: attribute.icon.name,
            url16: attribute.icon.url16,
            url48: attribute.icon.url48
        }
    });
const $4d2c21f2e394ef74$var$transformCMDBConfigurationToLegacyConfiguration = (node)=>{
    if (!node.cmdbFieldConfig) return node.isInsightAvailable === false ? {
        isInsightAvailable: node.isInsightAvailable
    } : {};
    return {
        cmdbFieldConfig: {
            multiple: node.cmdbFieldConfig.multiple,
            objectSchemaId: node.cmdbFieldConfig.objectSchemaId.split('/')[2],
            attributesDisplayedOnIssue: (0, $o7K5u.transformAggConnection)(node.cmdbFieldConfig?.attributesDisplayedOnIssue),
            attributesIncludedInAutoCompleteSearch: (0, $o7K5u.transformAggConnection)(node.cmdbFieldConfig?.attributesIncludedInAutoCompleteSearch)
        },
        isInsightAvailable: node.isInsightAvailable,
        wasInsightRequestSuccessful: node.wasInsightRequestSuccessful
    };
};
const $4d2c21f2e394ef74$var$transformObjectTypeAttributeToLegacy = (type)=>{
    switch(type){
        case 'REFERENCED_OBJECT':
            return 1;
        case 'USER':
            return 2;
        case 'GROUP':
            return 4;
        case 'PROJECT':
            return 6;
        case 'STATUS':
            return 7;
        case 'BITBUCKET_REPO':
            return 8;
        case 'OPSGENIE_TEAM':
            return 9;
        case 'DEFAULT':
            return 0;
        default:
            // eslint-disable-next-line no-console
            console.error(new Error(`Unknown attribute type found in transformObjectTypeAttributeToLegacy: ${type}. Mapping type to '-1'`));
            return -1;
    }
};
const $4d2c21f2e394ef74$var$transformReferencedObject = (node)=>({
        id: node.objectGlobalId,
        workspaceId: node.workspaceId,
        objectKey: node.objectKey,
        label: node.label,
        avatar: node.avatar,
        objectId: node.objectId
    });
const $4d2c21f2e394ef74$var$transformCmdbUser = (node)=>({
        avatarUrl: node.picture,
        displayName: node.name,
        name: node.name,
        key: node.accountId
    });
const $4d2c21f2e394ef74$var$transformCmdbGroup = (node)=>({
        name: node.name
    });
const $4d2c21f2e394ef74$var$transformCmdbProject = (node)=>({
        avatarUrl: node.avatar?.large,
        id: Number(node.id),
        key: node.key,
        name: node.name
    });
const $4d2c21f2e394ef74$var$transformCmdbBitbucketRepo = (node)=>({
        uuid: node.uuid,
        name: node.name,
        url: node.url,
        avatarUrl: node.avatarUrl
    });
const $4d2c21f2e394ef74$var$transformCmdbOpsgenieTeam = (node)=>({
        id: node.id,
        name: node.name,
        url: node.url
    });
const $4d2c21f2e394ef74$var$transformCmdbStatus = (node)=>({
        id: node.id,
        name: node.name,
        category: node.category
    });
const $4d2c21f2e394ef74$var$transformObjectAttributeValuesToLegacy = (node)=>{
    if (!node) return null;
    const defaultObjectValue = {
        displayValue: node.displayValue,
        searchValue: node.searchValue,
        ...node.value != null ? {
            value: node.value
        } : {}
    };
    if (node.referencedObject) return {
        ...defaultObjectValue,
        referencedObject: $4d2c21f2e394ef74$var$transformReferencedObject(node.referencedObject)
    };
    if (node.user) return {
        ...defaultObjectValue,
        user: $4d2c21f2e394ef74$var$transformCmdbUser(node.user)
    };
    if (node.group) return {
        ...defaultObjectValue,
        group: $4d2c21f2e394ef74$var$transformCmdbGroup(node.group)
    };
    if (node.project) return {
        ...defaultObjectValue,
        project: $4d2c21f2e394ef74$var$transformCmdbProject(node.project)
    };
    if (node.bitbucketRepo) return {
        ...defaultObjectValue,
        bitbucketRepo: $4d2c21f2e394ef74$var$transformCmdbBitbucketRepo(node.bitbucketRepo)
    };
    if (node.opsgenieTeam) return {
        ...defaultObjectValue,
        opsgenieTeam: $4d2c21f2e394ef74$var$transformCmdbOpsgenieTeam(node.opsgenieTeam)
    };
    if (node.status) return {
        ...defaultObjectValue,
        status: $4d2c21f2e394ef74$var$transformCmdbStatus(node.status)
    };
    return defaultObjectValue;
};
const $4d2c21f2e394ef74$var$transformObjectAttributesToLegacyObjectAttributes = (node, workspaceId)=>{
    if (!node) return null;
    const { objectTypeAttributeId: objectTypeAttributeId, objectTypeAttribute: objectTypeAttribute } = node;
    return {
        objectTypeAttributeId: objectTypeAttributeId,
        workspaceId: workspaceId,
        objectAttributeValues: (0, $o7K5u.transformAggConnection)(node.objectAttributeValues, $4d2c21f2e394ef74$var$transformObjectAttributeValuesToLegacy),
        objectTypeAttribute: {
            id: objectTypeAttributeId,
            label: objectTypeAttribute.label,
            name: objectTypeAttribute.name,
            workspaceId: workspaceId,
            type: $4d2c21f2e394ef74$var$transformObjectTypeAttributeToLegacy(objectTypeAttribute.type),
            ...objectTypeAttribute.defaultType ? {
                defaultType: {
                    id: objectTypeAttribute.defaultType.id,
                    name: objectTypeAttribute.defaultType.name
                }
            } : {}
        }
    };
};
const $4d2c21f2e394ef74$var$transformJiraCMDBToLegacyCMDB = (node)=>{
    if (!node) return null;
    const { label: label, objectGlobalId: objectGlobalId, objectId: objectId, objectKey: objectKey, workspaceId: workspaceId, webUrl: webUrl, avatar: avatar } = node;
    return {
        attributes: (0, $o7K5u.transformAggConnection)(node.attributes, (nodeAttribute)=>$4d2c21f2e394ef74$var$transformObjectAttributesToLegacyObjectAttributes(nodeAttribute, workspaceId)),
        avatar: avatar,
        label: label,
        id: objectGlobalId,
        objectId: objectId,
        objectKey: objectKey,
        workspaceId: workspaceId,
        links: {
            self: webUrl
        },
        objectType: $4d2c21f2e394ef74$var$transformObjectTypeToLegacy(node.objectType, workspaceId)
    };
};
const $4d2c21f2e394ef74$export$93506453d9bb56ae = (node)=>{
    if (node.type !== (0, $5fc53.CMDB_OBJECT_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?` : null,
        configuration: $4d2c21f2e394ef74$var$transformCMDBConfigurationToLegacyConfiguration(node),
        value: (0, $o7K5u.transformAggConnection)(node.selectedCmdbObjectsConnection, $4d2c21f2e394ef74$var$transformJiraCMDBToLegacyCMDB),
        schema: {
            configuration: null,
            custom: (0, $5fc53.CMDB_OBJECT_CF_TYPE),
            items: 'cmdb-object-field',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("iv8Rf", function(module, exports) {

$parcel$export(module.exports, "transformAggColorToLegacyField", () => $b83a62ddd17b4586$export$587c178f1b45e5e9);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b83a62ddd17b4586$export$587c178f1b45e5e9 = (node)=>{
    const value = node.color?.colorKey ?? null;
    switch(node.type){
        case 0, $5fc53.EPIC_COLOR_TYPE:
        case 0, $5fc53.COLOR_CF_TYPE:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: value,
                schema: {
                    configuration: null,
                    type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
                    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                    custom: node.type,
                    system: null,
                    items: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("hDlc2", function(module, exports) {

$parcel$export(module.exports, "transformAggComponentsToLegacyField", () => $315456e18e2330f5$export$97a9275777684b77);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
// @DoNotExport Flow is deriving component's type
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $315456e18e2330f5$var$transformJiraComponentToLegacyComponent = (component)=>{
    if (component == null) return null;
    return {
        id: component.componentId,
        name: component.name,
        ari: component.ari,
        metadata: component.metadata
    };
};
const $315456e18e2330f5$export$97a9275777684b77 = (node)=>{
    if (node.type !== (0, $5fc53.COMPONENTS_TYPE)) return undefined;
    const value = (0, $o7K5u.transformAggConnection)(node.selectedComponentsConnection, $315456e18e2330f5$var$transformJiraComponentToLegacyComponent);
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        allowedValues: [],
        value: value,
        schema: {
            configuration: null,
            items: 'component',
            renderer: (0, $650578330a102f55$export$840ed33fa94f7693),
            type: (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
            custom: null,
            system: (0, $5fc53.COMPONENTS_TYPE)
        }
    };
};

});

parcelRegister("c3LW9", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectDateTimeToLegacyField", () => $e80217ec1ee321d5$export$e6d015aa746cbdaf);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $e80217ec1ee321d5$export$e6d015aa746cbdaf = (node)=>({
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.dateTime ?? null,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            custom: node.type,
            type: (0, $5fc53.ISSUE_FIELD_DATETIME_CF_TYPE)
        }
    });

});

parcelRegister("h92P3", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectMultipleSelectToLegacyField", () => $1bb7cdf99e93ff64$export$edf5c98d20696686);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $1bb7cdf99e93ff64$export$edf5c98d20696686 = (node)=>{
    const value = (0, $o7K5u.transformAggConnection)(node.selectedOptions, (0, $o7K5u.toLegacyConnectOption));
    const allowedValues = (0, $o7K5u.transformAggConnection)(node.connectMultiSelectFieldOptions, (0, $o7K5u.toLegacyConnectOption));
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value.length ? value : null,
        allowedValues: allowedValues,
        schema: {
            type: (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: (0, $5fc53.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE),
            configuration: null
        }
    };
};

});

parcelRegister("aeO9V", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectNumberToLegacyField", () => $b8a5823753f7873f$export$4638a5dd3285d8f2);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b8a5823753f7873f$export$4638a5dd3285d8f2 = (node)=>({
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.number ?? null,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            custom: node.type,
            type: (0, $5fc53.ISSUE_FIELD_NUMBER_CF_TYPE)
        }
    });

});

parcelRegister("6Tnq8", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectRichTextToLegacyField", () => $f9558299012f1c2e$export$11063e1f9210f191);

var $kz2lw = parcelRequire("kz2lw");


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $f9558299012f1c2e$var$emptyAdfObject = (0, $kz2lw.getEmptyADF)();
const $f9558299012f1c2e$var$getPlainTextValue = (node)=>{
    if (!node.richText) return null;
    if (node.richText.plainText == null) return '';
    return node.richText.plainText;
};
const $f9558299012f1c2e$export$11063e1f9210f191 = (node)=>{
    const { renderer: renderer } = node;
    if ((0, $dMYPq.default)(node)) return undefined;
    const isPlainTextRenderer = renderer === (0, $650578330a102f55$export$a4a240cb4053b29f);
    const values = isPlainTextRenderer ? {
        value: $f9558299012f1c2e$var$getPlainTextValue(node)
    } : {
        adfValue: node.richText?.adfValue?.json || $f9558299012f1c2e$var$emptyAdfObject
    };
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        ...values,
        schema: {
            custom: (0, $5fc53.TEXT_AREA_CF_TYPE),
            renderer: renderer,
            type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
            system: null,
            configuration: null,
            items: null
        }
    };
};

});
parcelRegister("dMYPq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4fed9edf4c76e19$export$2e2bcd8739ae039);

var $2YZCu = parcelRequire("2YZCu");
const $f4fed9edf4c76e19$export$c63f561360bafed1 = 'issue.agg-field-transformers.missing-renderer';
// If the renderer is missing, log an error and return true.
// This was added as part of https://jplat.atlassian.net/browse/JIV-14881 to help identify why
// fields are sometimes missing the renderer.
const $f4fed9edf4c76e19$var$isFieldMissingRenderer = (field)=>{
    try {
        // Narrow the type of field to fields with a renderer
        if (!('renderer' in field)) return false;
        if (field?.renderer) return false;
        (0, $2YZCu.default).safeErrorWithoutCustomerData($f4fed9edf4c76e19$export$c63f561360bafed1, `Field ${field.fieldId} of type ${field.__typename} has missing renderer: ${field.renderer}`);
        return true;
    } catch  {
        return false;
    }
};
var $f4fed9edf4c76e19$export$2e2bcd8739ae039 = $f4fed9edf4c76e19$var$isFieldMissingRenderer;

});


parcelRegister("6mbsj", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectSingleSelectToLegacyField", () => $ceb0872dd5eafe49$export$e44db7cf61369a28);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $ceb0872dd5eafe49$export$e44db7cf61369a28 = (node)=>{
    let value = null;
    if (node.fieldOption != null) value = {
        id: parseInt(node.fieldOption?.optionId, 10),
        value: node.fieldOption?.value
    };
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: (0, $o7K5u.transformAggConnection)(node.connectSingleSelectFieldOptions, (0, $o7K5u.toLegacyConnectOption)),
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            custom: node.type,
            type: (0, $5fc53.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("d3nG3", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectTextToLegacyField", () => $145b645a3d2e801e$export$dd05277f5aa90657);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $145b645a3d2e801e$export$dd05277f5aa90657 = (node)=>({
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.text,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE)
        }
    });

});

parcelRegister("1xW6n", function(module, exports) {

$parcel$export(module.exports, "transformAggDataClassificationToLegacyField", () => $1a8d4561538d1d2b$export$b5edfdc89a7a2932);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $1a8d4561538d1d2b$export$b5edfdc89a7a2932 = (node)=>({
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        key: (0, $5fc53.DATA_CLASSIFICATION_TYPE),
        value: node,
        schema: {
            configuration: null,
            items: null,
            renderer: null,
            custom: null,
            system: null,
            type: (0, $5fc53.DATA_CLASSIFICATION_TYPE)
        }
    });

});

parcelRegister("fW9XR", function(module, exports) {

$parcel$export(module.exports, "transformAggDatePickerToLegacyField", () => $c44a652aaa9bff90$export$3d6e51d37c0454a9);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $c44a652aaa9bff90$export$3d6e51d37c0454a9 = (node)=>{
    switch(node.type){
        case 0, $5fc53.DUE_DATE_TYPE:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: typeof node.date === 'string' ? node.date : null,
                schema: {
                    type: (0, $5fc53.ISSUE_FIELD_DATE_CF_TYPE),
                    configuration: null,
                    system: node.type,
                    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                    custom: null,
                    items: null
                }
            };
        case 0, $5fc53.DATE_CF_TYPE:
        case 0, $5fc53.BASELINE_START_CF_TYPE:
        case 0, $5fc53.BASELINE_END_CF_TYPE:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: typeof node.date === 'string' ? node.date : null,
                schema: {
                    type: (0, $5fc53.ISSUE_FIELD_DATE_CF_TYPE),
                    custom: node.type,
                    configuration: null,
                    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                    system: null,
                    items: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("bKMMB", function(module, exports) {

$parcel$export(module.exports, "transformAggDateTimePickerToLegacyField", () => $fb29b1af2f1467e0$export$3de22f1277f0c239);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $fb29b1af2f1467e0$var$defaultSchema = {
    type: (0, $5fc53.ISSUE_FIELD_DATETIME_CF_TYPE),
    custom: null,
    system: null,
    configuration: null,
    items: null,
    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f)
};
const $fb29b1af2f1467e0$export$3de22f1277f0c239 = (node)=>{
    switch(node.type){
        case 0, $5fc53.CREATED:
        case 0, $5fc53.UPDATED:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: node.dateTime || '',
                schema: {
                    ...$fb29b1af2f1467e0$var$defaultSchema,
                    system: node.type,
                    renderer: null
                }
            };
        case 0, $5fc53.RESOLUTION_DATE:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: node.dateTime ?? null,
                schema: {
                    ...$fb29b1af2f1467e0$var$defaultSchema,
                    system: node.type,
                    renderer: null
                }
            };
        case 0, $5fc53.DATETIME_CF_TYPE:
        case 0, $5fc53.FIRST_RESPONSE_DATE_CF_TYPE:
        case 0, $5fc53.REQUEST_FEEDBACK_DATE_CF_TYPE:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: node.dateTime ?? null,
                schema: {
                    ...$fb29b1af2f1467e0$var$defaultSchema,
                    custom: node.type
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("7JL37", function(module, exports) {

$parcel$export(module.exports, "transformAggEpicLinkToLegacyField", () => $3279d658ea1a4982$export$1311f30c94840aa2);

var $7SCny = parcelRequire("7SCny");

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $3279d658ea1a4982$var$transformJiraEpicToLegacyEpicLink = (epic)=>{
    if (epic == null) return null;
    return {
        id: Number(epic.issueId),
        key: epic.key || '',
        done: !!epic.done,
        name: epic.name || '',
        summary: epic.summary || '',
        color: {
            key: epic.color ?? (0, $7SCny.AgileColors).AGILE_COLOR_1
        },
        // This can only be set from cache handlers
        fromCache: false
    };
};
const $3279d658ea1a4982$export$1311f30c94840aa2 = (node)=>{
    if (node.type !== (0, $5fc53.EPIC_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        value: $3279d658ea1a4982$var$transformJiraEpicToLegacyEpicLink(node.epic),
        schema: {
            configuration: null,
            items: null,
            renderer: 'jira-text-renderer',
            type: 'any',
            custom: (0, $5fc53.EPIC_TYPE),
            system: null
        }
    };
};

});

parcelRegister("dulCG", function(module, exports) {

$parcel$export(module.exports, "transformAggFlagToLegacyField", () => $f31e97d89b497c1c$export$31555b6ea19f4c2);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $f31e97d89b497c1c$var$transformJiraFlagToLegacyFlag = (flag)=>{
    if (flag == null || flag.isFlagged == null) return null;
    return [
        {
            value: flag.isFlagged
        }
    ];
};
const $f31e97d89b497c1c$export$31555b6ea19f4c2 = (node)=>{
    // Agg flag field comes back as multichecbox CF type instead of current graphql flagged CF type
    if (node.type !== (0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: $f31e97d89b497c1c$var$transformJiraFlagToLegacyFlag(node.flag),
        schema: {
            configuration: null,
            custom: (0, $5fc53.FLAGGED_CF_TYPE),
            items: 'option',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("6vno6", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeDateToLegacyField", () => $f5e60b2709763004$export$30fccfce22948120);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $f5e60b2709763004$export$30fccfce22948120 = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.date,
        autoCompleteUrl: null,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_DATE_CF_TYPE)
        }
    };
};

});

parcelRegister("as0vY", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeDateTimeToLegacyField", () => $3520698819975afe$export$61b1f0cbd04c7b9c);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $3520698819975afe$export$61b1f0cbd04c7b9c = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.dateTime,
        autoCompleteUrl: null,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_DATETIME_CF_TYPE)
        }
    };
};

});

parcelRegister("6dPLd", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeGroupToLegacyField", () => $ce6b58a5b1f45912$export$60b03d63015cbb9f);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $ce6b58a5b1f45912$export$60b03d63015cbb9f = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.selectedGroup ? {
            name: node.selectedGroup.name
        } : null,
        autoCompleteUrl: null,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_SINGLE_GROUP_CF_TYPE)
        }
    };
};

});

parcelRegister("gKccZ", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeGroupsToLegacyField", () => $256d8054300c3cdf$export$2dfa4944fba5d1f5);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $256d8054300c3cdf$export$2dfa4944fba5d1f5 = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    const value = node.selectedGroupsConnection?.edges?.length ? (0, $o7K5u.transformAggConnection)(node.selectedGroupsConnection, ({ name: name })=>({
            name: name
        })) : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            items: (0, $5fc53.ISSUE_FIELD_SINGLE_GROUP_CF_TYPE),
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("jnUrZ", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeNumberToLegacyField", () => $c68528ed0dfd109c$export$5dab8986dc45db07);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $c68528ed0dfd109c$export$5dab8986dc45db07 = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.number,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_NUMBER_CF_TYPE)
        }
    };
};

});

parcelRegister("iJtmd", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeObjectToLegacyField", () => $c814454c00552e79$export$fbdabdbae2a203b9);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $c814454c00552e79$export$fbdabdbae2a203b9 = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    const value = (()=>{
        if (node.object == null) return null;
        try {
            return JSON.parse(node.object);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            throw new Error('Failed to transform forge object field: node.object was invalid JSON object');
        }
    })();
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_OBJECT_CF_TYPE)
        }
    };
};

});

parcelRegister("iPyq0", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeStringToLegacyField", () => $29f719811f573640$export$3a581fb4b3e578bd);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $29f719811f573640$export$3a581fb4b3e578bd = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.text,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE)
        }
    };
};

});

parcelRegister("384lj", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeStringsToLegacyField", () => $0d30cb879c19e1ba$export$418a06cb5dc6aba5);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $0d30cb879c19e1ba$export$418a06cb5dc6aba5 = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    const hasValue = Boolean(node.selectedLabelsConnection?.edges?.length);
    const value = hasValue ? (0, $o7K5u.transformAggConnection)(node.selectedLabelsConnection, ({ name: name })=>name) : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        autoCompleteUrl: node.searchUrl,
        schema: {
            configuration: null,
            items: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("axTS6", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeUserToLegacyField", () => $0669940239efeaff$export$bc73c7a747f907e5);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");

var $iob0v = parcelRequire("iob0v");
const $0669940239efeaff$export$bc73c7a747f907e5 = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.user ? (0, $iob0v.transformJiraUserToLegacyServerUser)(node.user) : null,
        autoCompleteUrl: node.searchUrl,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_USER_CF_TYPE)
        }
    };
};

});
parcelRegister("iob0v", function(module, exports) {

$parcel$export(module.exports, "transformJiraUserToLegacyServerUser", () => $42550039db1edc00$export$d7b231260a016eaf);

const $42550039db1edc00$var$getAccountType = (objectType)=>{
    switch(objectType){
        case 'AtlassianAccountUser':
            return 0, $145004f7a92e2423$export$981400c14dd99bc0;
        case 'CustomerUser':
            return 0, $145004f7a92e2423$export$2823897fb92cd040;
        case 'AppUser':
            return 0, $145004f7a92e2423$export$1973ca62b6c5abfe;
        default:
            return 0, $145004f7a92e2423$export$d1f5101c0939e3fe;
    }
};
const $42550039db1edc00$var$generateAvatarUrls = (url)=>({
        '16x16': url,
        '24x24': url,
        '32x32': url,
        '48x48': url
    });
const $42550039db1edc00$export$d7b231260a016eaf = (user)=>{
    if (!user) return null;
    const userOptionalKeysMap = {
        emailAddress: 'email',
        locale: 'locale',
        timeZone: 'zoneinfo'
    };
    const optionalValues = {};
    Object.entries(userOptionalKeysMap).forEach(([key, aggKey])=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const aggValue = user[aggKey];
        if (aggValue !== undefined && aggValue !== null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        optionalValues[key] = aggValue;
    });
    const avatars = user.picture != null ? {
        avatarUrl: user.picture,
        avatarUrls: $42550039db1edc00$var$generateAvatarUrls(user.picture)
    } : {};
    return {
        ...avatars,
        ...optionalValues,
        accountId: user.accountId,
        accountType: $42550039db1edc00$var$getAccountType(user.__typename),
        active: user.accountStatus === 'active',
        displayName: user.name
    };
};

});
const $145004f7a92e2423$export$981400c14dd99bc0 = 'atlassian';
const $145004f7a92e2423$export$2823897fb92cd040 = 'customer';
const $145004f7a92e2423$export$1973ca62b6c5abfe = 'app';
const $145004f7a92e2423$export$d1f5101c0939e3fe = 'unknown';



parcelRegister("lfJ6H", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeUsersToLegacyField", () => $eb3ddd1fb571c94a$export$bbfea2e2f2c853b8);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");

var $iob0v = parcelRequire("iob0v");
const $eb3ddd1fb571c94a$export$bbfea2e2f2c853b8 = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    const value = node.selectedUsersConnection?.edges?.length ? (0, $o7K5u.transformAggConnection)(node.selectedUsersConnection, (0, $iob0v.transformJiraUserToLegacyServerUser)) : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            items: (0, $5fc53.ISSUE_FIELD_USER_CF_TYPE),
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("9UXU7", function(module, exports) {

$parcel$export(module.exports, "transformAggGoalsToLegacyField", () => $a8d444f432651533$export$158301a02ae4cbe7);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $a8d444f432651533$export$158301a02ae4cbe7 = (node)=>{
    if (node.type !== (0, $5fc53.GOALS_CF_TYPE)) return undefined;
    const value = node.selectedGoals ? {
        goals: node.selectedGoals?.edges?.filter((edge)=>edge?.node !== null).map((edge)=>({
                id: edge?.node?.id || '',
                name: edge?.node?.name || '',
                status: edge?.node?.status || null
            })) || [],
        totalCount: node.selectedGoals?.totalCount || 0
    } : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            custom: (0, $5fc53.GOALS_CF_TYPE),
            items: null,
            renderer: null,
            system: null,
            type: (0, $5fc53.GOALS_CF_TYPE)
        }
    };
};

});

parcelRegister("b6BoU", function(module, exports) {

$parcel$export(module.exports, "transformAggIssueRestrictionToLegacyField", () => $d0a0e03637cc83cd$export$62db794d5816e28e);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $d0a0e03637cc83cd$var$transformJiraRoleToRestriction = (role)=>{
    if (role == null) return null;
    return {
        restrictionValue: role.roleId
    };
};
const $d0a0e03637cc83cd$export$62db794d5816e28e = (node, projectContext)=>{
    if (node.type !== (0, $5fc53.ISSUE_RESTRICTION_TYPE)) return undefined;
    const roles = (0, $o7K5u.transformAggConnection)(node.selectedRolesConnection, $d0a0e03637cc83cd$var$transformJiraRoleToRestriction);
    const restrictions = roles.length > 0 ? {
        projectrole: roles
    } : {};
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: {
            shouldDisplay: projectContext?.canSetIssueRestriction === true,
            issuerestrictions: restrictions
        },
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            type: (0, $5fc53.ISSUE_RESTRICTION_TYPE),
            custom: null,
            system: node.type
        }
    };
};

});

parcelRegister("gak3n", function(module, exports) {

$parcel$export(module.exports, "getSystemAggJiraIssueType", () => $4f9b530de681b60e$export$b4644a0cc2f2935e);
$parcel$export(module.exports, "transformJiraIssueTypeToLegacyIssueType", () => $4f9b530de681b60e$export$2356062173546155);
$parcel$export(module.exports, "transformAggIssueTypeToLegacyField", () => $4f9b530de681b60e$export$de2eb3b47c7c887b);


var $imYFg = parcelRequire("imYFg");

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $4f9b530de681b60e$export$d95e76b2d065f98d = {
    avatarId: 0,
    self: ''
};
const $4f9b530de681b60e$export$b4644a0cc2f2935e = (fields)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const issueTypeField = fields?.find((edge)=>edge?.node != null && edge.node.__typename === (0, $5fc53.ISSUE_TYPE_GQL_FIELD) && edge.node.type === (0, $5fc53.ISSUE_TYPE))?.node;
    if (issueTypeField == null || issueTypeField.__typename !== (0, $5fc53.ISSUE_TYPE_GQL_FIELD) || issueTypeField.type !== (0, $5fc53.ISSUE_TYPE)) throw new Error(`Failed to get system issue type: ${(0, $5fc53.ISSUE_TYPE_GQL_FIELD)} with ${(0, $5fc53.ISSUE_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(fields ?? '')}]`);
    if (issueTypeField.issueType == null) throw new Error(`Failed to get system issue type: ${(0, $5fc53.ISSUE_TYPE_GQL_FIELD)}.issueType is missing [${JSON.stringify(issueTypeField)}]`);
    return issueTypeField.issueType;
};
const $4f9b530de681b60e$export$2356062173546155 = (issueType)=>({
        ...$4f9b530de681b60e$export$d95e76b2d065f98d,
        id: issueType.issueTypeId,
        iconUrl: issueType.avatar?.medium ?? '',
        name: issueType.name,
        description: 'description' in issueType && issueType.description != null ? issueType.description : '',
        hierarchyLevel: issueType.hierarchy.level,
        subtask: issueType.hierarchy.level === (0, $imYFg.ISSUE_TYPE_HIERARCHY_LEVEL).SUBTASK_LEVEL
    });
const $4f9b530de681b60e$export$de2eb3b47c7c887b = (node)=>{
    if (node.type !== (0, $5fc53.ISSUE_TYPE) || node.issueType == null) throw new Error(`Failed to transform ${(0, $5fc53.ISSUE_TYPE_GQL_FIELD)}: type is not ${(0, $5fc53.ISSUE_TYPE)} or 'issueType' is empty [${JSON.stringify(node)}]`);
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: $4f9b530de681b60e$export$2356062173546155(node.issueType),
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: (0, $5fc53.ISSUE_TYPE),
            type: (0, $5fc53.ISSUE_TYPE)
        }
    };
};

});
parcelRegister("imYFg", function(module, exports) {

$parcel$export(module.exports, "ISSUE_TYPE_HIERARCHY_LEVEL", () => $ccb1a8095461a82a$export$2fe6880f0073407c);

var $g4tDr = parcelRequire("g4tDr");
const $ccb1a8095461a82a$export$2fe6880f0073407c = {
    SUBTASK_LEVEL: (0, $g4tDr.ISSUE_HIERARCHY_LEVEL_SUBTASK),
    BASE_LEVEL: (0, $g4tDr.ISSUE_HIERARCHY_LEVEL_BASE),
    LEVEL_ONE: (0, $g4tDr.ISSUE_HIERARCHY_LEVEL_EPIC),
    LEVEL_TWO: 2
};

});


parcelRegister("i47fO", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMApprovalsToLegacyField", () => $448e6754d8bf50d1$export$b14d30f2a9e4c343);

var $9ar3z = parcelRequire("9ar3z");

var $5fc53 = parcelRequire("5fc53");

var $g5X3G = parcelRequire("g5X3G");

var $o7K5u = parcelRequire("o7K5u");

var $iob0v = parcelRequire("iob0v");
const $448e6754d8bf50d1$var$transformApproverPrincipalsToLegacy = (approverPrincipal)=>{
    if (!approverPrincipal) return undefined;
    switch(approverPrincipal.__typename){
        case 0, $5fc53.JSM_USER_APPROVER_PRINCIPAL_FIELD:
            return {
                id: (0, $g5X3G.toAccountId)(approverPrincipal.user.accountId),
                name: approverPrincipal.user.name,
                meta: {
                    jiraRest: approverPrincipal.jiraRest
                },
                type: 'user',
                avatarUrl: approverPrincipal.user.picture
            };
        case 0, $5fc53.JSM_GROUP_APPROVER_PRINCIPAL_FIELD:
            return {
                id: (0, $9ar3z.toGroupId)(approverPrincipal.groupId),
                meta: {
                    memberCount: approverPrincipal.memberCount,
                    approvedCount: approverPrincipal.approvedCount
                },
                name: approverPrincipal.name,
                type: 'group'
            };
        default:
            return undefined;
    }
};
const $448e6754d8bf50d1$var$getApproverDecision = (decision)=>{
    switch(decision){
        case 0, $9ar3z.APPROVER_APPROVED:
            return 0, $9ar3z.APPROVER_APPROVED;
        case 0, $9ar3z.APPROVER_DECLINED:
            return 0, $9ar3z.APPROVER_DECLINED;
        case 0, $9ar3z.APPROVER_PENDING:
        default:
            return 0, $9ar3z.APPROVER_PENDING;
    }
};
const $448e6754d8bf50d1$var$transformApproverToLegacy = (approvalNode)=>{
    if (!approvalNode) return undefined;
    const approver = (0, $iob0v.transformJiraUserToLegacyServerUser)(approvalNode.approver);
    if (!approver) return undefined;
    return {
        approverDecision: $448e6754d8bf50d1$var$getApproverDecision(approvalNode.approverDecision),
        approver: approver
    };
};
const $448e6754d8bf50d1$var$transformConfigurationToLegacy = (configurations)=>{
    // This function contains a lot of null checks and default empty values to satisfy flow because
    // the AGG type coming back is in the shape of [JiraServiceManagementApprovalConfiguration]
    // Which means technically it can be an empty array. Even though we will always only ever
    // get 1 object back.
    const { approversConfigurations: approversConfigurations = [], condition: condition } = configurations?.[0] || {};
    const approverConfiguration = approversConfigurations[0];
    return {
        approvers: {
            type: approverConfiguration?.type ?? '',
            customFieldName: approverConfiguration?.fieldName ?? '',
            customFieldId: approverConfiguration?.fieldId ?? ''
        },
        condition: {
            type: condition?.type ?? '',
            value: condition?.value ?? ''
        }
    };
};
const $448e6754d8bf50d1$var$transformDateToLegacy = (date)=>({
        epochMillis: new Date(date).valueOf()
    });
const $448e6754d8bf50d1$var$transformStatusToLegacy = (status)=>({
        name: status.name || '',
        category: Number(status.categoryId)
    });
const $448e6754d8bf50d1$var$transformActiveApprovalToLegacy = (activeApproval)=>{
    const { id: id, configurations: configurations, status: status, createdDate: createdDate, canAnswerApproval: canAnswerApproval, pendingApprovalCount: pendingApprovalCount, name: name, finalDecision: finalDecision, approvalState: approvalState, approvedStatus: approvedStatus } = activeApproval;
    return {
        id: id,
        approvalState: approvalState,
        approvedStatus: approvedStatus,
        finalDecision: $448e6754d8bf50d1$var$getApproverDecision(finalDecision),
        name: name,
        pendingApprovalCount: pendingApprovalCount,
        canAnswerApproval: canAnswerApproval,
        approverPrincipals: (0, $o7K5u.transformAggConnection)(activeApproval.approverPrincipals, $448e6754d8bf50d1$var$transformApproverPrincipalsToLegacy),
        approvers: (0, $o7K5u.transformAggConnection)(activeApproval.approvers, $448e6754d8bf50d1$var$transformApproverToLegacy),
        configuration: $448e6754d8bf50d1$var$transformConfigurationToLegacy(configurations),
        createdDate: $448e6754d8bf50d1$var$transformDateToLegacy(createdDate ?? ''),
        decisions: (0, $o7K5u.transformAggConnection)(activeApproval.decisions, $448e6754d8bf50d1$var$transformApproverToLegacy),
        excludedApprovers: (0, $o7K5u.transformAggConnection)(activeApproval.excludedApprovers, (0, $iob0v.transformJiraUserToLegacyServerUser)),
        status: status ? $448e6754d8bf50d1$var$transformStatusToLegacy(status) : null
    };
};
const $448e6754d8bf50d1$var$transformCompletedApprovalToLegacy = (completedApproval)=>{
    if (!completedApproval) return undefined;
    const { id: id, name: name, finalDecision: finalDecision, createdDate: createdDate, completedDate: completedDate, status: status } = completedApproval;
    return {
        id: id,
        name: name,
        finalDecision: $448e6754d8bf50d1$var$getApproverDecision(finalDecision),
        createdDate: $448e6754d8bf50d1$var$transformDateToLegacy(createdDate ?? ''),
        completedDate: $448e6754d8bf50d1$var$transformDateToLegacy(completedDate),
        status: status ? $448e6754d8bf50d1$var$transformStatusToLegacy(status) : null,
        approvers: (0, $o7K5u.transformAggConnection)(completedApproval.approvers, $448e6754d8bf50d1$var$transformApproverToLegacy)
    };
};
const $448e6754d8bf50d1$export$b14d30f2a9e4c343 = (node)=>{
    if (node.type !== (0, $5fc53.SERVICEDESK_APPROVAL_TYPE)) return undefined;
    const activeApproval = node.activeApproval ? {
        activeApproval: $448e6754d8bf50d1$var$transformActiveApprovalToLegacy(node.activeApproval)
    } : {};
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: {
            ...activeApproval,
            completedApprovals: (0, $o7K5u.transformAggConnection)(node.completedApprovalsConnection, $448e6754d8bf50d1$var$transformCompletedApprovalToLegacy)
        },
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: null,
            system: (0, $5fc53.SERVICEDESK_APPROVAL_TYPE),
            type: (0, $5fc53.SERVICEDESK_APPROVAL_TYPE)
        }
    };
};

});
parcelRegister("9ar3z", function(module, exports) {

$parcel$export(module.exports, "toGroupId", () => $4a7fc5eda3865b0e$export$779c261480444a4d);
$parcel$export(module.exports, "APPROVER_PENDING", () => $4a7fc5eda3865b0e$export$3b59c4db06f5829b);
$parcel$export(module.exports, "APPROVER_APPROVED", () => $4a7fc5eda3865b0e$export$e17ae8ca1010e2a4);
$parcel$export(module.exports, "APPROVER_DECLINED", () => $4a7fc5eda3865b0e$export$b5a0d270c9cd7435);
$parcel$export(module.exports, "APPROVAL_OK", () => $4a7fc5eda3865b0e$export$2e6187b6a4348938);
const $4a7fc5eda3865b0e$export$779c261480444a4d = (x)=>x;
const $4a7fc5eda3865b0e$export$3b59c4db06f5829b = 'pending';
const $4a7fc5eda3865b0e$export$e17ae8ca1010e2a4 = 'approved';
const $4a7fc5eda3865b0e$export$b5a0d270c9cd7435 = 'declined';
const $4a7fc5eda3865b0e$export$2e6187b6a4348938 = 'OK';
const $4a7fc5eda3865b0e$export$b5d660d719b8009 = 'INSUFFICIENT_APPROVERS';

});


parcelRegister("gvljZ", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMEntitlementsToLegacyField", () => $b281bef34e07e20f$export$850fadda8a5e6f27);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b281bef34e07e20f$export$850fadda8a5e6f27 = (node)=>{
    if (node.type !== (0, $5fc53.ENTITLEMENT_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.selectedEntitlement,
        schema: {
            configuration: null,
            custom: (0, $5fc53.ENTITLEMENT_CF_TYPE),
            items: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("6XFn2", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMMajorIncidentToLegacyField", () => $926c732f6621d9fd$export$d4e0b2288fb31144);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $926c732f6621d9fd$export$d4e0b2288fb31144 = (node)=>({
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.majorIncident,
        renderedValue: null,
        configuration: {},
        schema: {
            configuration: null,
            custom: (0, $5fc53.MAJOR_INCIDENT_CF_TYPE),
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE)
        }
    });

});

parcelRegister("6e1Ya", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMOrganizationToLegacyField", () => $0e4eebb31cef7087$export$7bd14951253a7c5f);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $0e4eebb31cef7087$export$7bd14951253a7c5f = (node)=>{
    if (node.type !== (0, $5fc53.ORGANIZATIONS_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: (0, $o7K5u.transformAggConnection)(node.selectedOrganizationsConnection, (selectedNode)=>({
                id: selectedNode.organizationId,
                name: selectedNode.organizationName
            })),
        schema: {
            configuration: null,
            custom: (0, $5fc53.ORGANIZATIONS_CF_TYPE),
            items: 'sd-customerorganization',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("640u2", function(module, exports) {

$parcel$export(module.exports, "transformAggJCSOrganizationToLegacyField", () => $84b085b51db539b3$export$81bfe5b16f9be413);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $84b085b51db539b3$export$81bfe5b16f9be413 = (node)=>{
    if (node.type !== (0, $5fc53.ORGANIZATION_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.selectedOrganization,
        schema: {
            configuration: null,
            custom: (0, $5fc53.ORGANIZATION_CF_TYPE),
            items: 'sd-customerorganization',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("hBEiJ", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRequestFeedbackToLegacyField", () => $841fa8e5b9308ced$export$c52c6988b335096);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $841fa8e5b9308ced$export$c52c6988b335096 = (node)=>{
    if (node.type !== (0, $5fc53.REQUEST_FEEDBACK_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.feedback,
        schema: {
            type: 'sd-feedback',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: (0, $5fc53.REQUEST_FEEDBACK_CF_TYPE),
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("1XNj2", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRequestLanguageToLegacyField", () => $1edf1c9b37cdb462$export$6a53240e225f742);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $1edf1c9b37cdb462$export$6a53240e225f742 = (node)=>{
    if (node.type !== (0, $5fc53.REQUEST_LANGUAGE_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.language,
        allowedValues: [
            ...node.languages ?? []
        ],
        schema: {
            type: 'sd-request-lang',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: (0, $5fc53.REQUEST_LANGUAGE_CF_TYPE),
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("f6zXW", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRequestTypeToLegacyField", () => $8030de3237296d5c$export$5ffaab1383177efa);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $8030de3237296d5c$var$transformRequestTypeToLegacy = (requestType)=>{
    if (!requestType) return null;
    return {
        requestType: {
            id: parseInt(requestType.requestTypeId, 10),
            issueTypeId: requestType.issueType?.issueTypeId || '',
            name: requestType.name || '',
            icon: {
                _links: {
                    iconUrls: {
                        '48x48': requestType.avatar?.large || ''
                    }
                }
            }
        }
    };
};
const $8030de3237296d5c$export$5ffaab1383177efa = (node)=>{
    if (node.type !== (0, $5fc53.REQUEST_TYPE_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        // @ts-expect-error - Argument of type '{ readonly avatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly id: string; readonly issueType: { ...; } | ... 1 more ... | undefined; readonly name: strin...' is not assignable to parameter of type '{ readonly avatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly id: string; readonly issueType: { ...; } | ... 1 more ... | undefined; readonly name: strin...'.
        value: $8030de3237296d5c$var$transformRequestTypeToLegacy(node.requestType),
        schema: {
            configuration: null,
            custom: (0, $5fc53.REQUEST_TYPE_CF_TYPE),
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'sd-customerrequesttype'
        }
    };
};

});

parcelRegister("fB4wX", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRespondersToLegacyField", () => $0ea07ade045943f7$export$5171c4d1ae5bcde5);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $0ea07ade045943f7$var$transformJiraResponderToLegacyResponder = (responder)=>{
    if (responder == null) return undefined;
    switch(responder.__typename){
        case 0, $5fc53.JSM_USER_RESPONDER_GQL_FIELD:
            if (responder.user === null) return undefined;
            return {
                // @ts-expect-error - 'responder.user' is possibly 'undefined'.
                ari: responder.user.canonicalAccountId,
                // @ts-expect-error - 'responder.user' is possibly 'undefined'.
                avatarUrl: responder.user.picture,
                // @ts-expect-error - 'responder.user' is possibly 'undefined'.
                name: responder.user.name,
                type: 'user'
            };
        case 0, $5fc53.JSM_TEAM_RESPONDER_FIELD:
            return {
                // @ts-expect-error - Type 'string | null | undefined' is not assignable to type 'string | null'.
                ari: responder.teamId,
                // @ts-expect-error - Type 'string | null | undefined' is not assignable to type 'string | null'.
                name: responder.teamName,
                type: 'team'
            };
        default:
            return undefined;
    }
};
const $0ea07ade045943f7$export$5171c4d1ae5bcde5 = (node)=>{
    if (node.type !== (0, $5fc53.RESPONDERS_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?query=` : null,
        value: (0, $o7K5u.transformAggConnection)(node.respondersConnection, $0ea07ade045943f7$var$transformJiraResponderToLegacyResponder),
        schema: {
            configuration: null,
            custom: (0, $5fc53.RESPONDERS_CF_TYPE),
            items: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("cXBkk", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMSentimentToLegacyField", () => $5dcf9f49c6a1536d$export$702d3754a4c7d90a);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $5dcf9f49c6a1536d$export$702d3754a4c7d90a = (node)=>{
    if (node.type !== (0, $5fc53.SENTIMENT_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.sentiment,
        schema: {
            configuration: null,
            custom: (0, $5fc53.SENTIMENT_CF_TYPE),
            items: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("iDKu3", function(module, exports) {

$parcel$export(module.exports, "transformAggLabelsNodeToLegacyField", () => $5345161012c71e28$export$98e4f56e2e6c44fe);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $5345161012c71e28$var$defaultSchema = {
    configuration: null,
    items: 'string',
    type: (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f)
};
const $5345161012c71e28$export$98e4f56e2e6c44fe = (node)=>{
    const selectedLabels = (0, $o7K5u.transformAggConnection)(node.selectedLabelsConnection, ({ name: name })=>name);
    switch(node.type){
        case 0, $5fc53.LABELS_TYPE:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: selectedLabels,
                schema: {
                    ...$5345161012c71e28$var$defaultSchema,
                    custom: null,
                    system: node.type
                }
            };
        case 0, $5fc53.LABELS_CF_TYPE:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                // empty value for custom labels field is null while system labels field is `[]`
                value: selectedLabels.length === 0 ? null : selectedLabels,
                schema: {
                    ...$5345161012c71e28$var$defaultSchema,
                    custom: node.type,
                    system: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("aGv90", function(module, exports) {

$parcel$export(module.exports, "transformAggMultiGroupPickerToLegacyField", () => $ee565846dd4aef42$export$f968da580693597d);


var $o7K5u = parcelRequire("o7K5u");
const $ee565846dd4aef42$export$f968da580693597d = (node)=>{
    const value = (0, $o7K5u.transformAggConnection)(node.selectedGroupsConnection, (groupNode)=>({
            groupId: groupNode.groupId,
            name: groupNode.name
        }));
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value.length > 0 ? value : null,
        schema: {
            type: 'array',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: 'group',
            configuration: null
        }
    };
};

});

parcelRegister("19DRh", function(module, exports) {

$parcel$export(module.exports, "transformAggMultipleSelectToLegacyField", () => $d83d25c034b1d99f$export$869fb8fbcb97e0ee);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $d83d25c034b1d99f$export$869fb8fbcb97e0ee = (node)=>{
    switch(node.type){
        case 0, $5fc53.MULTI_SELECT_CF_TYPE:
            {
                const value = (0, $o7K5u.transformAggConnection)(node.selectedOptions, (option)=>({
                        id: option.optionId,
                        value: option.value ?? null,
                        ari: option.id
                    }));
                return {
                    ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                    value: value.length ? value : null,
                    allowedValues: [],
                    schema: {
                        type: 'array',
                        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                        custom: node.type,
                        system: null,
                        items: 'option',
                        configuration: null
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("lkW3a", function(module, exports) {

$parcel$export(module.exports, "transformAggMultipleUserPickerToLegacyField", () => $9b1f1d40e628c968$export$cdd9991119eb040e);

var $2vSU6 = parcelRequire("2vSU6");


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $hA3EZ = parcelRequire("hA3EZ");

var $iob0v = parcelRequire("iob0v");
const $9b1f1d40e628c968$export$cdd9991119eb040e = (node, projectContext)=>{
    const value = (0, $o7K5u.transformAggConnection)(node.selectedUsersConnection, (0, $iob0v.transformJiraUserToLegacyServerUser));
    const legacyFieldValues = {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value.length > 0 ? value : null,
        schema: {
            configuration: null,
            custom: node.type,
            items: 'user',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
    switch(node.type){
        case 0, $5fc53.REQUEST_PARTICIPANTS_CF_TYPE:
            if (node.__typename === (0, $5fc53.MULTI_USER_PICKER_GQL_FIELD)) return {
                ...legacyFieldValues,
                value: value
            };
            if ((0, $hA3EZ.getProjectType)(projectContext?.projectType) !== (0, $2vSU6.SERVICE_DESK_PROJECT)) return undefined;
            // Empty array is the expected value when there are no request
            // participants.
            return {
                ...legacyFieldValues,
                value: value
            };
        case 0, $5fc53.PARTICIPANTS_CF_TYPE:
        case 0, $5fc53.MULTI_USER_CF_TYPE:
            return legacyFieldValues;
        case 0, $5fc53.APPROVERS_LIST_CF_TYPE:
        case 0, $5fc53.PEOPLE_CF_TYPE:
            {
                const schemaConfig = 'isMulti' in node && node.isMulti != null ? [
                    {
                        key: 'isMulti',
                        value: String(node.isMulti)
                    }
                ] : null;
                return {
                    ...legacyFieldValues,
                    autoCompleteUrl: node.searchUrl,
                    schema: {
                        ...legacyFieldValues.schema,
                        configuration: schemaConfig
                    }
                };
            }
        default:
            return undefined;
    }
};

});
parcelRegister("hA3EZ", function(module, exports) {

$parcel$export(module.exports, "getProjectType", () => $e3d5807b112803bd$export$3dd0da95519c1a33);
$parcel$export(module.exports, "getProjectField", () => $e3d5807b112803bd$export$b19207d974ad5e77);
$parcel$export(module.exports, "getSystemAggJiraProject", () => $e3d5807b112803bd$export$d100105d56da4a0a);
$parcel$export(module.exports, "isAggJiraProjectClassic", () => $e3d5807b112803bd$export$3502ed01c034e451);
$parcel$export(module.exports, "transformAggSystemProjectToProjectContext", () => $e3d5807b112803bd$export$77162d1422f22f47);
$parcel$export(module.exports, "transformAggProjectToLegacyField", () => $e3d5807b112803bd$export$30c14b802399f417);

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");



var $5fc53 = parcelRequire("5fc53");

var $g5X3G = parcelRequire("g5X3G");

var $o7K5u = parcelRequire("o7K5u");
const $e3d5807b112803bd$var$getProjectStatus = (status)=>{
    switch(status){
        case 'ACTIVE':
            return 0, $cd476f3ecebdab63$export$62113557945f790a;
        case 'ARCHIVED':
            return 0, $cd476f3ecebdab63$export$4ccc35479ba9ad1;
        case 'DELETED':
            return 0, $cd476f3ecebdab63$export$a95d71e582b8bc0;
        default:
            // Based on `getProjectStatus` from src/packages/issue/issue-view/src/common/service/issue/issue-transformer.js
            return 0, $cd476f3ecebdab63$export$62113557945f790a;
    }
};
const $e3d5807b112803bd$export$3dd0da95519c1a33 = (projectType)=>{
    if (projectType === 'CUSTOMER_SERVICE' && (0, $4R6GH.fg)('jcs_project_type_m3')) return 0, $2vSU6.CUSTOMER_SERVICE_PROJECT;
    switch(projectType){
        case 'SERVICE_DESK':
            return 0, $2vSU6.SERVICE_DESK_PROJECT;
        case 'BUSINESS':
            return 0, $2vSU6.CORE_PROJECT;
        case 'SOFTWARE':
            return 0, $2vSU6.SOFTWARE_PROJECT;
        case 'PRODUCT_DISCOVERY':
            return 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT;
        default:
            return null;
    }
};
const $e3d5807b112803bd$export$b19207d974ad5e77 = (fields)=>{
    /**
	 * The only way to get the type to return an optional value with `AggJiraProject` type
	 * is to re-assign the type wihtout throwing an error.
	 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return fields?.find((edge)=>edge?.node?.__typename === (0, $5fc53.PROJECT_GQL_FIELD) && edge?.node?.type != null && edge.node.type === (0, $5fc53.PROJECT_TYPE))?.node;
};
const $e3d5807b112803bd$export$d100105d56da4a0a = (fields)=>{
    /**
	 * We only want the system `PROJECT_TYPE` field.
	 * For custom fields, e.g., project picker, see `transformAggProjectToLegacyField`
	 */ const projectField = $e3d5807b112803bd$export$b19207d974ad5e77(fields);
    // Needs the `PROJECT_GQL_FIELD` refinement so we can return as `AggJiraProject`
    if (projectField == null || projectField.__typename !== (0, $5fc53.PROJECT_GQL_FIELD)) throw new Error(`Failed to get system project data: ${(0, $5fc53.PROJECT_GQL_FIELD)} with ${(0, $5fc53.PROJECT_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(fields ?? '')}]`);
    if (projectField.project == null) throw new Error(`Failed to get system project data: ${(0, $5fc53.PROJECT_GQL_FIELD)}.project is missing [${JSON.stringify(projectField)}]`);
    return projectField.project;
};
const $e3d5807b112803bd$export$f7d5cb97957d02e3 = (project)=>project?.projectStyle === 'TEAM_MANAGED_PROJECT';
const $e3d5807b112803bd$export$3502ed01c034e451 = (project)=>!$e3d5807b112803bd$export$f7d5cb97957d02e3(project);
const $e3d5807b112803bd$var$transformAggProjectToServerProjectOption = (project)=>{
    if (project == null) return null;
    const { projectId: projectId, key: key, name: name, avatar: avatar } = project;
    return {
        name: name,
        id: projectId ?? undefined,
        key: (0, $g5X3G.toProjectKey)(key),
        avatarUrls: {
            '48x48': avatar?.large || ''
        }
    };
};
const $e3d5807b112803bd$export$77162d1422f22f47 = (project)=>{
    const { projectId: projectId, name: name, key: key, avatar: avatar, status: status, projectType: type, navigationMetadata: navigationMetadata } = project;
    const projectType = $e3d5807b112803bd$export$3dd0da95519c1a33(type);
    if (projectType == null) throw new Error(`Failed to transform system project: projectType ${String(type)} was invalid`);
    return {
        projectId: projectId,
        projectType: projectType,
        projectName: name,
        projectKey: key,
        projectStatus: $e3d5807b112803bd$var$getProjectStatus(status),
        avatarUrl: avatar?.medium,
        isSimplified: $e3d5807b112803bd$export$f7d5cb97957d02e3(project),
        boardId: navigationMetadata?.boardId
    };
};
const $e3d5807b112803bd$export$275f121d4e6f5165 = (fields)=>{
    const project = $e3d5807b112803bd$export$d100105d56da4a0a(fields);
    return $e3d5807b112803bd$export$77162d1422f22f47(project);
};
const $e3d5807b112803bd$var$transformAggProjectToLegacyProjectPickerField = (node)=>({
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        allowedValues: [],
        value: $e3d5807b112803bd$var$transformAggProjectToServerProjectOption(node.project),
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            type: (0, $5fc53.PROJECT_TYPE),
            custom: (0, $5fc53.PROJECT_PICKER_CF_TYPE),
            system: null
        }
    });
const $e3d5807b112803bd$var$transformAggProjectToLegacySimilarIssuesField = (node)=>{
    // Similar issues field only exist in JSM projects
    if ($e3d5807b112803bd$export$3dd0da95519c1a33(node.project?.projectType) !== (0, $2vSU6.SERVICE_DESK_PROJECT)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        key: (0, $5fc53.SIMILAR_ISSUES_TYPE),
        title: (0, $5fc53.SIMILAR_ISSUES_TYPE),
        value: node.project?.similarIssues?.featureEnabled === true,
        schema: {
            configuration: null,
            items: null,
            renderer: null,
            type: (0, $5fc53.SIMILAR_ISSUES_TYPE),
            custom: null,
            system: (0, $5fc53.SIMILAR_ISSUES_TYPE)
        }
    };
};
const $e3d5807b112803bd$var$transformAggProjectToLegacyProjectField = (node)=>{
    if (node?.__typename !== (0, $5fc53.PROJECT_GQL_FIELD) || node?.type === null || node?.type !== (0, $5fc53.PROJECT_TYPE)) throw new Error(`Failed to get system project data: ${(0, $5fc53.PROJECT_GQL_FIELD)} with ${(0, $5fc53.PROJECT_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(node)}]`);
    const projectField = node;
    if (projectField == null || projectField.__typename !== (0, $5fc53.PROJECT_GQL_FIELD)) throw new Error(`Failed to get system project data: ${(0, $5fc53.PROJECT_GQL_FIELD)} with ${(0, $5fc53.PROJECT_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(node ?? '')}]`);
    if (projectField.project == null) throw new Error(`Failed to get system project data: ${(0, $5fc53.PROJECT_GQL_FIELD)}.project is missing [${JSON.stringify(projectField)}]`);
    const project = projectField.project;
    const { projectType: type } = project;
    const projectType = $e3d5807b112803bd$export$3dd0da95519c1a33(type);
    if (projectType == null) throw new Error(`Failed to transform project: projectType ${String(project?.projectType)} was invalid`);
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: {
            projectType: projectType
        }
    };
};
const $e3d5807b112803bd$var$transformAggProjectToLegacyFieldByType = (node)=>{
    const projectType = $e3d5807b112803bd$export$3dd0da95519c1a33(node.project?.projectType);
    if (projectType === (0, $2vSU6.SERVICE_DESK_PROJECT)) // Similar issues field only exist in JSM projects
    return $e3d5807b112803bd$var$transformAggProjectToLegacySimilarIssuesField(node);
    if (projectType === (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)) return $e3d5807b112803bd$var$transformAggProjectToLegacyProjectField(node);
    return undefined;
};
const $e3d5807b112803bd$export$30c14b802399f417 = (node)=>{
    if ((0, $4R6GH.fg)('jpd_idea_panel_in_issue_view')) switch(node.type){
        case 0, $5fc53.PROJECT_PICKER_CF_TYPE:
            return $e3d5807b112803bd$var$transformAggProjectToLegacyProjectPickerField(node);
        case 0, $5fc53.PROJECT_TYPE:
            // For the system project, see `transformAggProjectToProjectContext`
            return $e3d5807b112803bd$var$transformAggProjectToLegacyFieldByType(node);
        default:
            return undefined;
    }
    else switch(node.type){
        case 0, $5fc53.PROJECT_PICKER_CF_TYPE:
            return $e3d5807b112803bd$var$transformAggProjectToLegacyProjectPickerField(node);
        case 0, $5fc53.PROJECT_TYPE:
            // For the system project, see `transformAggProjectToProjectContext`
            return $e3d5807b112803bd$var$transformAggProjectToLegacySimilarIssuesField(node);
        default:
            return undefined;
    }
};

});
const $cd476f3ecebdab63$export$62113557945f790a = 'PROJECT_ACTIVE';
const $cd476f3ecebdab63$export$4ccc35479ba9ad1 = 'PROJECT_ARCHIVED';
const $cd476f3ecebdab63$export$a95d71e582b8bc0 = 'PROJECT_TRASHED';



parcelRegister("lQAwK", function(module, exports) {

$parcel$export(module.exports, "transformAggMultipleVersionPickerToLegacyField", () => $dc0acfee4cadcdcd$export$6207ea60703068d8);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $149sa = parcelRequire("149sa");
const $dc0acfee4cadcdcd$var$defaultSchema = {
    configuration: null,
    custom: null,
    items: 'version',
    renderer: (0, $650578330a102f55$export$840ed33fa94f7693),
    system: null,
    type: 'array'
};
const $dc0acfee4cadcdcd$export$6207ea60703068d8 = (node)=>{
    if (node.type !== (0, $5fc53.MULTI_VERSION_CF_TYPE) && node.type !== (0, $5fc53.AFFECTS_VERSIONS_TYPE) && node.type !== (0, $5fc53.FIX_VERSIONS_TYPE)) return undefined;
    const legacyFieldValues = {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        allowedValues: [],
        value: (0, $o7K5u.transformAggConnection)(node.selectedVersionsConnection, (0, $149sa.transformAggVersionToLegacyVersion))
    };
    switch(node.type){
        case 0, $5fc53.MULTI_VERSION_CF_TYPE:
            return {
                ...legacyFieldValues,
                value: legacyFieldValues.value.length === 0 ? null : legacyFieldValues.value,
                schema: {
                    ...$dc0acfee4cadcdcd$var$defaultSchema,
                    custom: (0, $5fc53.MULTI_VERSION_CF_TYPE)
                }
            };
        case 0, $5fc53.AFFECTS_VERSIONS_TYPE:
        case 0, $5fc53.FIX_VERSIONS_TYPE:
            return {
                ...legacyFieldValues,
                schema: {
                    ...$dc0acfee4cadcdcd$var$defaultSchema,
                    system: node.type
                }
            };
        default:
            return undefined;
    }
};

});
parcelRegister("149sa", function(module, exports) {

$parcel$export(module.exports, "transformAggVersionToLegacyVersion", () => $4617842fe98d5759$export$becef8d087e8b62b);

var $jPhQo = parcelRequire("jPhQo");
const $4617842fe98d5759$export$becef8d087e8b62b = (version)=>({
        id: version.versionId ?? '',
        name: version.name ?? '',
        description: version.description ?? '',
        archived: version.status === (0, $jPhQo.VersionStatus).ARCHIVED,
        released: version.status === (0, $jPhQo.VersionStatus).RELEASED,
        ari: version.id
    });

});
parcelRegister("jPhQo", function(module, exports) {

$parcel$export(module.exports, "VersionStatus", () => $b5bd69c03cab3461$export$8c6e0f93bfb5c6a4);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports




var $imYFg = parcelRequire("imYFg");

var $5fc53 = parcelRequire("5fc53");

const $b5bd69c03cab3461$export$8c6e0f93bfb5c6a4 = {
    ARCHIVED: 'ARCHIVED',
    RELEASED: 'RELEASED',
    UNRELEASED: 'UNRELEASED'
};

});



parcelRegister("8qOI6", function(module, exports) {

$parcel$export(module.exports, "transformAggNumberToLegacyField", () => $b542e2b397d83c88$export$d754a24ed0096d2f);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b542e2b397d83c88$export$d754a24ed0096d2f = (node)=>{
    const fieldType = node.isStoryPointField === true ? (0, $5fc53.STORY_POINTS_TYPE) : node.type;
    switch(fieldType){
        case 0, $5fc53.NUMBER_CF_TYPE:
        case 0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE:
        case 0, $5fc53.STORY_POINTS_TYPE:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: node.number ?? null,
                schema: {
                    configuration: null,
                    items: null,
                    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                    custom: fieldType,
                    system: null,
                    type: (0, $5fc53.ISSUE_FIELD_NUMBER_CF_TYPE)
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("cbd7V", function(module, exports) {

$parcel$export(module.exports, "transformAggOriginalEstimateToLegacyField", () => $47597066e94f8347$export$f08d02fdc74f920e);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $47597066e94f8347$export$f08d02fdc74f920e = (node)=>{
    if (node.type !== (0, $5fc53.TIME_ESTIMATE_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.originalEstimate?.timeInSeconds ?? null,
        schema: {
            configuration: null,
            custom: null,
            system: node.type,
            items: null,
            type: (0, $5fc53.ISSUE_FIELD_NUMBER_CF_TYPE),
            renderer: null
        }
    };
};

});

parcelRegister("6hj44", function(module, exports) {

$parcel$export(module.exports, "transformAggPriorityToLegacyField", () => $47c25f6616be0140$export$9e966ce605f800d2);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $47c25f6616be0140$var$transformJiraPriorityToLegacyPriority = (priority)=>{
    if (priority == null) return null;
    return {
        id: priority.priorityId,
        iconUrl: String(priority.iconUrl || ''),
        name: priority.name || '',
        sequence: priority.sequence || undefined
    };
};
const $47c25f6616be0140$export$9e966ce605f800d2 = (node)=>{
    if (node.type !== (0, $5fc53.PRIORITY_TYPE)) return undefined;
    const allowedValues = (0, $o7K5u.transformAggConnection)('priorities' in node ? node.priorities : null, $47c25f6616be0140$var$transformJiraPriorityToLegacyPriority);
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        allowedValues: allowedValues,
        // @ts-expect-error - Argument of type '{ readonly color: string | null | undefined; readonly iconUrl: string | null | undefined; readonly name: string | null | undefined; readonly priorityId: string; } | { readonly iconUrl: string | ... 1 more ... | undefined; readonly name: string | ... 1 more ... | undefined; readonly priorityId: string; } | { ...; } |...' is not assignable to parameter of type 'AggJiraPriority | null'.
        value: $47c25f6616be0140$var$transformJiraPriorityToLegacyPriority(node.priority),
        schema: {
            type: (0, $5fc53.PRIORITY_TYPE),
            custom: null,
            system: (0, $5fc53.PRIORITY_TYPE),
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f)
        }
    };
};

});

parcelRegister("4nh4C", function(module, exports) {

$parcel$export(module.exports, "transformAggProformaFormsToLegacyField", () => $27d464e5749e1114$export$fdcdbf17b0d4e36f);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $27d464e5749e1114$export$fdcdbf17b0d4e36f = (node)=>{
    if (node.type !== (0, $5fc53.PROFORMA_FORMS)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.proformaForms,
        schema: {
            configuration: null,
            items: null,
            system: (0, $5fc53.PROFORMA_FORMS),
            custom: null,
            renderer: null,
            type: (0, $5fc53.PROFORMA_FORMS)
        }
    };
};

});

parcelRegister("2z4xE", function(module, exports) {

$parcel$export(module.exports, "transformAggRadioSelectToLegacyField", () => $b545e68fef1c7c25$export$f147f1eb3a15ccfc);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b545e68fef1c7c25$export$f147f1eb3a15ccfc = (node)=>{
    if (node.type !== (0, $5fc53.RADIO_BUTTONS_CF_TYPE)) return undefined;
    const value = node.selectedOption ? {
        id: node.selectedOption?.optionId,
        value: node.selectedOption?.value,
        isDisabled: node.selectedOption?.isDisabled
    } : null;
    const allowedValues = (0, $o7K5u.transformAggConnection)(node.radioSelectFieldOptions, (option)=>({
            id: option.optionId,
            value: option.value ?? null,
            ari: option.id
        }));
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: allowedValues,
        schema: {
            type: 'option',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("cO2KQ", function(module, exports) {

$parcel$export(module.exports, "transformAggResolutionToLegacyField", () => $b13d1a2c3ca9d3cb$export$179f600c7e1d0230);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b13d1a2c3ca9d3cb$var$resolutionTransformer = (resolution)=>{
    if (resolution == null) return null;
    return {
        id: resolution.resolutionId,
        name: resolution.name || ''
    };
};
const $b13d1a2c3ca9d3cb$export$179f600c7e1d0230 = (node)=>{
    if (node.type !== (0, $5fc53.RESOLUTION_TYPE)) return undefined;
    const value = $b13d1a2c3ca9d3cb$var$resolutionTransformer(node.resolution);
    const allowedValues = (0, $o7K5u.transformAggConnection)(node.resolutions, $b13d1a2c3ca9d3cb$var$resolutionTransformer);
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: allowedValues,
        schema: {
            type: (0, $5fc53.RESOLUTION_TYPE),
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: null,
            system: (0, $5fc53.RESOLUTION_TYPE),
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("5sETx", function(module, exports) {

$parcel$export(module.exports, "transformAggRichTextToLegacyField", () => $181b5722dae42ee4$export$e65ff2ce94be106e);

var $kz2lw = parcelRequire("kz2lw");


var $5fc53 = parcelRequire("5fc53");

var $fCo6Y = parcelRequire("fCo6Y");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $181b5722dae42ee4$var$emptyAdfObject = (0, $kz2lw.getEmptyADF)();
const $181b5722dae42ee4$var$getSchema = (aggType, renderer)=>{
    switch(aggType){
        case 0, $5fc53.TEXT_AREA_CF_TYPE:
            return {
                custom: aggType,
                renderer: renderer,
                type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
                system: null,
                configuration: null,
                items: null
            };
        case 0, $5fc53.DESCRIPTION_TYPE:
        case 0, $5fc53.ENVIRONMENT_TYPE:
        default:
            return {
                system: aggType,
                renderer: renderer,
                type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
                custom: null,
                configuration: null,
                items: null
            };
    }
};
// Exactly match the legacy /graphql value, handling the case where the field is empty and has never been edited
// There's no functional difference between `null` or empty string when rendering the field in the issue view.
const $181b5722dae42ee4$var$getPlainTextValue = (node)=>{
    // When the field is empty and a value has never been set
    if (!node.richText) return null;
    // When the field has been set to a value, and then set back to empty
    if (node.richText?.plainText == null) return '';
    return node.richText?.plainText;
};
const $181b5722dae42ee4$export$e65ff2ce94be106e = (node)=>{
    // Description field always renders with ADF
    const { renderer: renderer } = node;
    if ((0, $dMYPq.default)(node)) return undefined;
    const isPlainTextRenderer = node.type !== (0, $5fc53.DESCRIPTION_TYPE) && renderer === (0, $650578330a102f55$export$a4a240cb4053b29f);
    if (isPlainTextRenderer) return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: $181b5722dae42ee4$var$getPlainTextValue(node),
        schema: $181b5722dae42ee4$var$getSchema(node.type, renderer)
    };
    const adfValueJson = node.richText?.adfValue?.json ?? null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        // The usages of the collection is deprecated.
        adfValue: adfValueJson ? (0, $fCo6Y.removeCollectionFromAdf)(adfValueJson) : $181b5722dae42ee4$var$emptyAdfObject,
        value: null,
        schema: $181b5722dae42ee4$var$getSchema(node.type, renderer)
    };
};

});
parcelRegister("fCo6Y", function(module, exports) {

$parcel$export(module.exports, "emptyAdfObject", () => $79bd166f69131b05$export$202742e99f678c60);
$parcel$export(module.exports, "removeCollectionFromAdf", () => $79bd166f69131b05$export$9e9311e676291037);
$parcel$export(module.exports, "convertAdfStringToObject", () => $79bd166f69131b05$export$ee70d4eb14697455);
$parcel$export(module.exports, "isOnlyWhitespaceAdf", () => $79bd166f69131b05$export$cf4bde415465976c);
$parcel$export(module.exports, "removeNewLineCharactersFromAdf", () => $79bd166f69131b05$export$d6ce0667c33b94ff);
$parcel$export(module.exports, "removeTrailingNewLineCharacters", () => $79bd166f69131b05$export$3688e35a300432d6);
$parcel$export(module.exports, "simplifyAdf", () => $79bd166f69131b05$export$def86d25f0c7f0bc);
$parcel$export(module.exports, "hasEmojiNode", () => $79bd166f69131b05$export$8c6c40d1455b914a);
$parcel$export(module.exports, "hasMediaFileNodes", () => $79bd166f69131b05$export$9a632b58fb9b287c);
$parcel$export(module.exports, "hasMediaFileNodesUpdated", () => $79bd166f69131b05$export$80a6e90c7b29d88c);

var $lmhF9 = parcelRequire("lmhF9");
var $l1C1k = parcelRequire("l1C1k");

var $2YZCu = parcelRequire("2YZCu");
const $79bd166f69131b05$export$202742e99f678c60 = {
    type: 'doc',
    version: 1,
    content: []
};
const $79bd166f69131b05$export$9e9311e676291037 = (adf)=>{
    if (adf === null || adf === undefined) return null;
    if (adf.type === 'media' && adf.attrs) return {
        ...adf,
        attrs: {
            ...adf.attrs,
            collection: ''
        }
    };
    if (adf.type === 'mediaInline' && adf.attrs) return {
        ...adf,
        attrs: {
            ...adf.attrs,
            collection: ''
        }
    };
    if (adf.content) return {
        ...adf,
        content: adf.content.map($79bd166f69131b05$export$9e9311e676291037)
    };
    return adf;
};
const $79bd166f69131b05$export$ee70d4eb14697455 = (adf)=>{
    if (typeof adf === 'string') try {
        return $79bd166f69131b05$export$9e9311e676291037(JSON.parse(adf));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('rich-content.convert-adf-to-object', 'Failed to parse rich content', error);
        return null;
    }
    return $79bd166f69131b05$export$9e9311e676291037(adf);
};
const $79bd166f69131b05$export$cf4bde415465976c = (adf)=>adf && adf.content ? adf.content.every((content)=>{
        if (content.type === 'paragraph') return !content.content || content.content.length === 0 || content.content.every((innerContent)=>innerContent.type === 'text' ? (innerContent.text || '').match(/^\s*$/) !== null : false);
        return false;
    }) : false;
const $79bd166f69131b05$export$d6ce0667c33b94ff = (adf)=>{
    if (!adf || !adf.content) return $79bd166f69131b05$export$202742e99f678c60;
    let len;
    for(len = adf.content.length - 1; len >= 0 && adf.content[len].content && adf.content[len].type === 'paragraph' && adf.content[len].content.length === 0; len -= 1){
        // if the last item of the node is of type mediaGroup, we don't want to strip newline character as
        // it practically makes it unclickable. Leave a new line character so there is still some space for ppl to click
        if (len > 0 && adf.content[len - 1].type === 'mediaGroup') break;
    }
    return {
        ...adf,
        content: adf.content.slice(0, len + 1)
    };
};
const $79bd166f69131b05$export$3688e35a300432d6 = (text)=>text.replace(/[\r\n]+$/, '');
const $79bd166f69131b05$export$def86d25f0c7f0bc = (adf)=>$79bd166f69131b05$export$cf4bde415465976c(adf) ? $79bd166f69131b05$export$202742e99f678c60 : adf;
const $79bd166f69131b05$export$8c6c40d1455b914a = (doc)=>{
    let hasEmoji = false;
    (0, $l1C1k.traverse)(doc, {
        emoji: ()=>{
            hasEmoji = true;
            return false; // stop traversing
        }
    });
    return hasEmoji;
};
const $79bd166f69131b05$export$9a632b58fb9b287c = (doc)=>{
    const mediaNodes = new Map();
    (0, $l1C1k.traverse)(doc, {
        media: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaNode = node;
            if (mediaNode.attrs.type === 'external') return;
            mediaNodes.set(mediaNode.attrs.id, node);
        },
        mediaInline: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaInlineNode = node;
            mediaNodes.set(mediaInlineNode.attrs.id, node);
        }
    });
    return mediaNodes.size > 0;
};
const $79bd166f69131b05$export$80a6e90c7b29d88c = (currentDoc, newDoc)=>{
    const currentMediaNodes = new Set();
    const newMediaNodes = new Set();
    const updatedMediaNodes = new Set();
    if (newDoc) (0, $l1C1k.traverse)(newDoc, {
        media: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaNode = node;
            if (mediaNode.attrs.type === 'external') return;
            newMediaNodes.add(mediaNode.attrs.id);
        },
        mediaInline: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaInlineNode = node;
            newMediaNodes.add(mediaInlineNode.attrs.id);
        }
    });
    if (currentDoc) (0, $l1C1k.traverse)(currentDoc, {
        media: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaNode = node;
            if (mediaNode.attrs.type === 'external') return;
            currentMediaNodes.add(mediaNode.attrs.id);
            if (newMediaNodes.size) {
                const matchedNode = newMediaNodes.has(mediaNode.attrs.id);
                if (!matchedNode) updatedMediaNodes.add(mediaNode.attrs.id);
            }
        },
        mediaInline: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaInlineNode = node;
            currentMediaNodes.add(mediaInlineNode.attrs.id);
            if (newMediaNodes.size) {
                const matchedNode = newMediaNodes.has(mediaInlineNode.attrs.id);
                if (!matchedNode) updatedMediaNodes.add(mediaInlineNode.attrs.id);
            }
        }
    });
    return currentMediaNodes.size !== newMediaNodes.size || !!updatedMediaNodes.size;
};
const $79bd166f69131b05$export$ddf077301434502d = (doc)=>{
    if (doc === null || doc === undefined) return false;
    const nonSimpleTextNodes = (0, $lmhF9.filter)(doc, (node)=>node.type !== 'paragraph' && node.type !== 'doc' && node.type !== 'text');
    return nonSimpleTextNodes.length === 0;
};



const $79bd166f69131b05$export$2277e89f0b6d4ed = async (node)=>{
    // the imports here were kept async so as not to blow the bundle sizes for everyone
    const { defaultSchema: defaultSchema } = await Promise.resolve((parcelRequire("kOFhM")));
    const { WikiMarkupTransformer: WikiMarkupTransformer } = await (parcelRequire("7y1vK"));
    const { JSONTransformer: JSONTransformer } = await Promise.resolve((parcelRequire("hYNZx")));
    const jsonTransformer = new JSONTransformer();
    const wikiMarkupTransformer = new WikiMarkupTransformer(defaultSchema);
    if (node === null || node === undefined) return '';
    const pmNode = jsonTransformer.parse(node);
    return wikiMarkupTransformer.encode(pmNode);
};

});
parcelRegister("lmhF9", function(module, exports) {

$parcel$export(module.exports, "filter", () => $cb7d90be6f5f5975$export$3dea766d36a8935f);

var $l1C1k = parcelRequire("l1C1k");
function $cb7d90be6f5f5975$export$3dea766d36a8935f(adf, callback) {
    const result = [];
    (0, $l1C1k.traverse)(adf, {
        any: (node)=>{
            if (callback(node)) result.push(node);
        }
    });
    return result;
}

});

parcelRegister("7y1vK", function(module, exports) {

let $57ece16cf096b3ea$var$load = (parcelRequire("28QjX"))(4);
module.exports = $57ece16cf096b3ea$var$load("9ZhML").then(()=>parcelRequire('dN5CS'));

});



parcelRegister("f454b", function(module, exports) {

$parcel$export(module.exports, "transformAggSecurityLevelToLegacyField", () => $811c3c0495fb451c$export$45e25e2a6750ea5a);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $811c3c0495fb451c$var$transformJiraSecurityLevel = (securityLevel)=>{
    if (securityLevel == null) return null;
    return {
        id: securityLevel.securityId,
        description: securityLevel.description || '',
        name: securityLevel.name || ''
    };
};
const $811c3c0495fb451c$export$45e25e2a6750ea5a = (node)=>({
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: $811c3c0495fb451c$var$transformJiraSecurityLevel(node.securityLevel),
        allowedValues: (0, $o7K5u.transformAggConnection)(node.securityLevels, $811c3c0495fb451c$var$transformJiraSecurityLevel),
        schema: {
            configuration: null,
            type: (0, $5fc53.SECURITY_LEVEL_TYPE_OVERRIDE),
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: null,
            system: (0, $5fc53.SECURITY_LEVEL_TYPE),
            items: null
        }
    });

});

parcelRegister("aafIf", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleGroupPickerToLegacyField", () => $950a9b8297396bb3$export$e6697ec5bdac9ec0);


var $o7K5u = parcelRequire("o7K5u");
const $950a9b8297396bb3$export$e6697ec5bdac9ec0 = (node)=>{
    const value = node.selectedGroup != null ? {
        groupId: node.selectedGroup.groupId,
        name: node.selectedGroup.name
    } : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            type: 'group',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("2yWre", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleLineTextToLegacyField", () => $f5309f9bc8791ddf$export$31f32b3fd9e5ab6);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $f5309f9bc8791ddf$var$defaultSchema = {
    configuration: null,
    items: null,
    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f)
};
const $f5309f9bc8791ddf$export$31f32b3fd9e5ab6 = (node)=>{
    const defaultTransformedField = {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.text
    };
    switch(node.type){
        case 0, $5fc53.EPIC_NAME_TYPE:
        case 0, $5fc53.MESSAGE_EDIT_CF_TYPE:
        case 0, $5fc53.MESSAGE_VIEW_CF_TYPE:
        case 0, $5fc53.READ_ONLY_CF_TYPE:
        case 0, $5fc53.TEXT_CF_TYPE:
        case 0, $5fc53.USER_PROPERTY_CF_TYPE:
            return {
                ...defaultTransformedField,
                schema: {
                    ...$f5309f9bc8791ddf$var$defaultSchema,
                    custom: node.type,
                    system: null,
                    type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE)
                }
            };
        case 0, $5fc53.RANK_CF_TYPE:
            return {
                ...defaultTransformedField,
                schema: {
                    ...$f5309f9bc8791ddf$var$defaultSchema,
                    custom: node.type,
                    system: null,
                    type: (0, $5fc53.ISSUE_FIELD_ANY_CF_TYPE)
                }
            };
        case 0, $5fc53.SUMMARY_TYPE:
            return {
                ...defaultTransformedField,
                schema: {
                    ...$f5309f9bc8791ddf$var$defaultSchema,
                    type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
                    custom: null,
                    system: node.type
                }
            };
        case 0, $5fc53.SERVICEDESK_PRACTICES_TYPE:
            // Transform field only if the practice has a value
            return node.text != null ? {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: [
                    node.text
                ],
                schema: {
                    ...$f5309f9bc8791ddf$var$defaultSchema,
                    renderer: null,
                    custom: null,
                    system: node.type,
                    type: (0, $5fc53.SERVICEDESK_PRACTICES_TYPE)
                }
            } : undefined;
        default:
            return undefined;
    }
};

});

parcelRegister("lUeQj", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleSelectToLegacyField", () => $9513f3f43c691d67$export$4e113f935e09d226);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $9513f3f43c691d67$var$getField = (node, customType)=>{
    const value = node.fieldOption != null ? {
        ari: node.fieldOption.id,
        id: node.fieldOption.optionId,
        value: node.fieldOption.value
    } : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            type: 'option',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: customType || node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};
const $9513f3f43c691d67$export$4e113f935e09d226 = (node)=>{
    switch(node.type){
        case 0, $5fc53.EPIC_STATUS_TYPE:
        case 0, $5fc53.SELECT_CF_TYPE:
            return $9513f3f43c691d67$var$getField(node);
        case 0, $5fc53.CATEGORY_TYPE:
            return $9513f3f43c691d67$var$getField(node, (0, $5fc53.SELECT_CF_TYPE));
        default:
            return undefined;
    }
};

});

parcelRegister("6SWOK", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleSelectUserPickerToLegacyField", () => $7348765074cf60a5$export$7bf73fc06c6d71be);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $iob0v = parcelRequire("iob0v");
const $7348765074cf60a5$export$7bf73fc06c6d71be = (node)=>{
    const legacyField = {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.user ? (0, $iob0v.transformJiraUserToLegacyServerUser)(node.user) : null
    };
    switch(node.type){
        case 0, $5fc53.ASSIGNEE_TYPE:
        case 0, $5fc53.REPORTER_TYPE:
            return {
                ...legacyField,
                schema: {
                    type: (0, $5fc53.ISSUE_FIELD_USER_CF_TYPE),
                    custom: null,
                    system: node.type,
                    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                    configuration: null,
                    items: null
                }
            };
        case 0, $5fc53.USER_CF_TYPE:
        case 0, $5fc53.LAST_UPDATER_OR_COMMENTER_CF_TYPE:
            return {
                ...legacyField,
                schema: {
                    type: (0, $5fc53.ISSUE_FIELD_USER_CF_TYPE),
                    custom: node.type,
                    system: null,
                    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                    configuration: null,
                    items: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("cMc7B", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleVersionPickerToLegacyField", () => $1c34fc6a70d0e0b4$export$d03f622577260442);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $149sa = parcelRequire("149sa");
const $1c34fc6a70d0e0b4$export$d03f622577260442 = (node)=>{
    if (node.type !== (0, $5fc53.VERSION_CF_TYPE)) return undefined;
    const allowedValues = (0, $o7K5u.transformAggConnection)(null, (0, $149sa.transformAggVersionToLegacyVersion));
    const value = node.version ? (0, $149sa.transformAggVersionToLegacyVersion)(node.version) : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        allowedValues: allowedValues,
        value: value,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            type: (0, $5fc53.ISSUE_FIELD_VERSION_CF_TYPE),
            custom: (0, $5fc53.VERSION_CF_TYPE),
            system: null
        }
    };
};

});

parcelRegister("38GNL", function(module, exports) {

$parcel$export(module.exports, "transformAggSprintToLegacyField", () => $05e0b9d6b707c3a6$export$9b5bb05d50970021);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $05e0b9d6b707c3a6$var$SprintOptionalKeyMap = {
    goal: 'goal',
    completeDate: 'completionDate',
    startDate: 'startDate',
    endDate: 'endDate'
};
const $05e0b9d6b707c3a6$var$transformAggSprintToLegacySprint = (sprint)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const optionalValues = {};
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys($05e0b9d6b707c3a6$var$SprintOptionalKeyMap).forEach((key)=>{
        const aggKey = $05e0b9d6b707c3a6$var$SprintOptionalKeyMap[key];
        const aggValue = sprint[aggKey];
        if (aggValue !== undefined && aggValue !== null) optionalValues[key] = aggValue;
    });
    return {
        id: Number(sprint.sprintId),
        name: sprint.name,
        state: sprint.state?.toLowerCase(),
        boardId: Number(sprint.boardName) || 0,
        ...optionalValues
    };
};
const $05e0b9d6b707c3a6$export$9b5bb05d50970021 = (node)=>{
    if (node.type !== (0, $5fc53.SPRINT_TYPE)) return undefined;
    const sprints = (0, $o7K5u.transformAggConnection)(node.selectedSprintsConnection, $05e0b9d6b707c3a6$var$transformAggSprintToLegacySprint);
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: sprints,
        schema: {
            configuration: null,
            custom: (0, $5fc53.SPRINT_TYPE),
            items: 'json',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("avV20", function(module, exports) {

$parcel$export(module.exports, "getStatusesDeprecatedValue", () => $e8b60f3bf3251c5a$export$b80ec59d806c2f94);
$parcel$export(module.exports, "transformAggStatusToLegacyField", () => $e8b60f3bf3251c5a$export$c80e5acb1c882c48);

var $gULOk = parcelRequire("gULOk");

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $e8b60f3bf3251c5a$export$b80ec59d806c2f94 = (fields)=>{
    const { status: status } = fields;
    if (!status || status.value == null) return {};
    const { value: value } = status;
    return {
        [value.id]: {
            id: value.id,
            name: value.name,
            statusCategory: (0, $gULOk.statusCategoryForId)(value.statusCategory?.id)
        }
    };
};
const $e8b60f3bf3251c5a$var$transformJiraStatusToLegacyStatus = (status)=>{
    if (status == null) return null;
    const { statusCategory: statusCategory } = status;
    return {
        id: status.statusId,
        name: status.name || '',
        statusCategory: {
            id: Number(statusCategory.statusCategoryId)
        }
    };
};
const $e8b60f3bf3251c5a$export$c80e5acb1c882c48 = (node)=>{
    if (node.type !== (0, $5fc53.STATUS_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: $e8b60f3bf3251c5a$var$transformJiraStatusToLegacyStatus(node.status),
        schema: {
            configuration: null,
            items: null,
            renderer: null,
            type: (0, $5fc53.STATUS_TYPE),
            custom: null,
            system: (0, $5fc53.STATUS_TYPE)
        }
    };
};

});

parcelRegister("cbXvu", function(module, exports) {

$parcel$export(module.exports, "transformAggTeamToLegacyField", () => $2c8c4053c45e92fb$export$fb1b80497e96456f);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $2c8c4053c45e92fb$export$fb1b80497e96456f = (node)=>{
    if (node.type !== (0, $5fc53.TEAM_CF_TYPE)) return undefined;
    const value = node.selectedTeam ? {
        id: node.selectedTeam.teamId,
        title: node.selectedTeam.name,
        isShared: node.selectedTeam.isShared,
        avatarUrl: node.selectedTeam.avatar?.medium
    } : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            custom: (0, $5fc53.TEAM_CF_TYPE),
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: (0, $5fc53.ISSUE_FIELD_ANY_CF_TYPE)
        }
    };
};

});

parcelRegister("aSXJi", function(module, exports) {

$parcel$export(module.exports, "transformAggTeamViewToLegacyField", () => $b1861ddba2f2c1e6$export$6f6aaafb49bd4769);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b1861ddba2f2c1e6$var$transformAggTeamViewToLegacyTeam = (team)=>{
    if (team == null) return null;
    return {
        id: team.jiraSuppliedTeamId,
        name: team.jiraSuppliedName || '',
        isVisible: team.jiraSuppliedVisibility || false,
        avatarUrl: team.jiraSuppliedAvatar?.xsmall || '',
        isVerified: team.jiraSuppliedIsVerified || false
    };
};
const $b1861ddba2f2c1e6$export$6f6aaafb49bd4769 = (node)=>{
    if (node.type !== (0, $5fc53.TEAMS_PLATFORM_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        // @ts-expect-error - Argument of type '{ readonly jiraSuppliedAvatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly jiraSuppliedId: string; readonly jiraSuppliedName: string | ... 1 more ... | un...' is not assignable to parameter of type '{ readonly jiraSuppliedAvatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly jiraSuppliedId: string; readonly jiraSuppliedName: string | ... 1 more ... | un...'.
        value: $b1861ddba2f2c1e6$var$transformAggTeamViewToLegacyTeam(node.selectedTeam),
        schema: {
            configuration: null,
            custom: (0, $5fc53.TEAMS_PLATFORM_CF_TYPE),
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'team'
        }
    };
};

});

parcelRegister("8uxcU", function(module, exports) {

$parcel$export(module.exports, "transformAggTimeTrackingToLegacyField", () => $63b0d60fa2cc1a3e$export$874d9bd14269ec6f);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $63b0d60fa2cc1a3e$var$getEstimateValues = (estimate, key)=>{
    if (estimate) return {
        [key]: estimate.timeInSeconds || 0
    };
    return {};
};
const $63b0d60fa2cc1a3e$export$874d9bd14269ec6f = (node)=>{
    if (node.type !== (0, $5fc53.TIME_TRACKING_TYPE)) return undefined;
    const originalEstimate = $63b0d60fa2cc1a3e$var$getEstimateValues(node.originalEstimate || null, 'originalEstimateSeconds');
    const remainingEstimate = $63b0d60fa2cc1a3e$var$getEstimateValues(node.remainingEstimate || null, 'remainingEstimateSeconds');
    const timeSpent = $63b0d60fa2cc1a3e$var$getEstimateValues(node.timeSpent || null, 'timeSpentSeconds');
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: {
            ...originalEstimate,
            ...remainingEstimate,
            ...timeSpent
        },
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: (0, $5fc53.TIME_TRACKING_TYPE),
            type: (0, $5fc53.TIME_TRACKING_TYPE)
        }
    };
};

});

parcelRegister("arKlm", function(module, exports) {

$parcel$export(module.exports, "transformAggUrlToLegacyField", () => $86ba2c1106803d01$export$6e950e0ec9801f6c);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $86ba2c1106803d01$export$6e950e0ec9801f6c = (node)=>{
    if (node.type !== (0, $5fc53.URL_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.uri ?? null,
        schema: {
            configuration: null,
            custom: (0, $5fc53.URL_CF_TYPE),
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE)
        }
    };
};

});

parcelRegister("hCKV6", function(module, exports) {

$parcel$export(module.exports, "transformAggVotesToLegacyField", () => $78b4a5963398330d$export$8966614b8594736);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $78b4a5963398330d$var$transformAggVoteToLegacyVote = (vote)=>({
        votes: vote.count != null ? Number(vote.count) : 0,
        hasVoted: vote.hasVoted ?? false
    });
const $78b4a5963398330d$export$8966614b8594736 = (node)=>{
    if (node.type !== (0, $5fc53.VOTES_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.vote ? $78b4a5963398330d$var$transformAggVoteToLegacyVote(node.vote) : null,
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: null,
            system: (0, $5fc53.VOTES_TYPE),
            type: (0, $5fc53.VOTES_TYPE)
        }
    };
};

});

parcelRegister("d8wC0", function(module, exports) {

$parcel$export(module.exports, "transformAggWatchesToLegacyField", () => $a83bab4858993b2f$export$6730cb17d10d6156);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $a83bab4858993b2f$var$transformAggWatchesToLegacyWatches = (watch)=>({
        watchCount: watch.count != null ? Number(watch.count) : 0,
        isWatching: watch.isWatching ?? false
    });
const $a83bab4858993b2f$export$6730cb17d10d6156 = (node)=>{
    if (node.type !== (0, $5fc53.WATCHES_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.watch ? $a83bab4858993b2f$var$transformAggWatchesToLegacyWatches(node.watch) : null,
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: null,
            system: (0, $5fc53.WATCHES_TYPE),
            type: (0, $5fc53.WATCHES_TYPE)
        }
    };
};

});


parcelRegister("1pF6B", function(module, exports) {

$parcel$export(module.exports, "transformAggParentFieldValueToLegacyFieldValue", () => $f8196a61a82995ed$export$d8a5feb2bb0425b4);
const $f8196a61a82995ed$export$d8a5feb2bb0425b4 = (parentIssue)=>{
    if (!parentIssue) return null;
    return {
        id: parentIssue.issueId,
        ari: parentIssue.id,
        key: parentIssue.key,
        self: parentIssue.webUrl,
        color: parentIssue.issueColorField?.color?.colorKey,
        fields: {
            summary: parentIssue.summaryField?.text,
            issuetype: {
                name: parentIssue.issueTypeField?.issueType?.name,
                iconUrl: parentIssue.issueTypeField?.issueType?.avatar?.xsmall,
                // We do not have this data
                id: '',
                self: '',
                description: '',
                subtask: false,
                avatarId: 0,
                hierarchyLevel: 0
            }
        }
    };
};

});

parcelRegister("lTnWS", function(module, exports) {

$parcel$export(module.exports, "transformAggRichTextFieldValueToLegacyFieldValue", () => $51ceecc021979aad$export$b3a2c3992977726e);

var $kz2lw = parcelRequire("kz2lw");


var $fCo6Y = parcelRequire("fCo6Y");
const $51ceecc021979aad$var$emptyAdfObject = (0, $kz2lw.getEmptyADF)();
const $51ceecc021979aad$export$b3a2c3992977726e = (richText, renderer)=>{
    if (!renderer) throw new Error('aggFieldChangeProps did not have renderer');
    if (renderer === (0, $650578330a102f55$export$a4a240cb4053b29f)) {
        if (richText.plainText !== undefined) return richText.plainText;
        return richText?.adfValue?.convertedPlainText?.plainText;
    }
    return richText?.adfValue?.json ? (0, $fCo6Y.removeCollectionFromAdf)(richText?.adfValue?.json) : $51ceecc021979aad$var$emptyAdfObject;
};

});


parcelRegister("3z81P", function(module, exports) {

$parcel$export(module.exports, "ChangeEventTypes", () => $c6ffe75554a4bac3$export$8db21fc94823e1cc);
// Copied over from `src/packages/issue/issue-view/src/model/change-type.js`
const $c6ffe75554a4bac3$var$FIELD_CHANGE_REQUESTED = 'FIELD_CHANGE_REQUESTED';
const $c6ffe75554a4bac3$var$FIELD_CHANGED = 'FIELD_CHANGED';
const $c6ffe75554a4bac3$var$FIELD_CHANGE_FAILED = 'FIELD_CHANGE_FAILED';
const $c6ffe75554a4bac3$export$8db21fc94823e1cc = {
    [$c6ffe75554a4bac3$var$FIELD_CHANGE_REQUESTED]: $c6ffe75554a4bac3$var$FIELD_CHANGE_REQUESTED,
    [$c6ffe75554a4bac3$var$FIELD_CHANGE_FAILED]: $c6ffe75554a4bac3$var$FIELD_CHANGE_FAILED,
    [$c6ffe75554a4bac3$var$FIELD_CHANGED]: $c6ffe75554a4bac3$var$FIELD_CHANGED
};

});


parcelRegister("99cgx", function(module, exports) {

$parcel$export(module.exports, "defaultSaveField", () => $2a246664763defba$export$b74e6b7f831f1cb2);
$parcel$export(module.exports, "defaultSaveFieldById", () => $2a246664763defba$export$b2c49aae5d84cced);
$parcel$export(module.exports, "defaultAddValuesToField", () => $2a246664763defba$export$c46c7284cd9c5d3);
$parcel$export(module.exports, "defaultRemoveValuesFromField", () => $2a246664763defba$export$33b78476f5d734b3);

var $eusud = parcelRequire("eusud");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2a246664763defba$var$getFieldUpdate = (fieldKey, value)=>({
        fields: {
            [fieldKey]: value
        }
    });
const $2a246664763defba$export$b74e6b7f831f1cb2 = async (issueKey, fieldKey, newValue, _baseUrl)=>(0, $eusud.performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify($2a246664763defba$var$getFieldUpdate(fieldKey, newValue))
    });
const $2a246664763defba$export$b2c49aae5d84cced = async (issueKey, fieldKey, newValue, _baseUrl)=>(0, $eusud.performPutRequest)(`/rest/api/3/issue/${issueKey}/?returnIssue=true`, {
        body: JSON.stringify($2a246664763defba$var$getFieldUpdate(fieldKey, newValue))
    });
const $2a246664763defba$export$c46c7284cd9c5d3 = async (issueKey, fieldKey, valuesToAdd, _baseUrl)=>{
    const updateParam = {
        update: {
            [fieldKey]: [
                {
                    operation: 'add',
                    value: valuesToAdd
                }
            ]
        }
    };
    return (0, $eusud.performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify(updateParam)
    });
};
const $2a246664763defba$export$33b78476f5d734b3 = async (issueKey, fieldKey, valuesToRemove, _baseUrl)=>{
    const updateParam = {
        update: {
            [fieldKey]: [
                {
                    operation: 'remove',
                    value: valuesToRemove
                }
            ]
        }
    };
    return (0, $eusud.performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify(updateParam)
    });
};

});


parcelRegister("54wEF", function(module, exports) {

$parcel$export(module.exports, "useIssueFieldConfig", () => $a5085d8f4019d625$export$5406c21e0d275680);
$parcel$export(module.exports, "useIssueFieldConfigWithoutRefetch", () => $a5085d8f4019d625$export$217a0e2f2962f4ae);
$parcel$export(module.exports, "useIssueFieldConfigWithoutUimOverrides", () => $a5085d8f4019d625$export$5f641a998c6dfa06);
$parcel$export(module.exports, "useFieldConfig", () => $a5085d8f4019d625$export$70da50df1be2dbe1);
$parcel$export(module.exports, "useFieldConfigWithoutRefetch", () => $a5085d8f4019d625$export$1eed575f8f3334eb);
$parcel$export(module.exports, "useFieldConfigActions", () => $a5085d8f4019d625$export$28a22fd0dedf31b7);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $4R6GH = parcelRequire("4R6GH");

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");

var $iZIvy = parcelRequire("iZIvy");

var $eDXka = parcelRequire("eDXka");

var $gXz4p = parcelRequire("gXz4p");

var $biQrn = parcelRequire("biQrn");

var $2N3tQ = parcelRequire("2N3tQ");
const $a5085d8f4019d625$export$9715ac6597e498fd = ()=>`
  query fieldConfigurationQuery($issueKey: String) {
    issue(issueIdOrKey: $issueKey, latestVersion: true, screen: "view") {
      fields {
        key
        schema {
          type
          custom
          customId
          system
          renderer
        }
        autoCompleteUrl
        allowedValues
        operations
        required
        editable
        title
        description
      }
    }
  }`;
const $a5085d8f4019d625$var$fieldConfigurationQueryExperienceDescription = ({ wasExperienceSuccessful: wasExperienceSuccessful, errorMessage: errorMessage, traceId: traceId })=>{
    const errorMessageItem = errorMessage != null ? {
        errorMessage: errorMessage
    } : {};
    const traceIdItem = traceId != null ? {
        traceId: traceId
    } : {};
    return {
        experience: (0, $eDXka.IssueViewFetchOperations).FIELD_CONFIGURATION,
        wasExperienceSuccesful: wasExperienceSuccessful,
        analyticsSource: 'Issue View Field Configuration Query',
        additionalAttributes: {
            method: 'GET',
            ...errorMessageItem,
            ...traceIdItem
        },
        application: null,
        edition: null
    };
};
const $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking = ({ wasExperienceSuccessful: wasExperienceSuccessful, error: error })=>{
    (0, $gXz4p.sendExperienceAnalytics)($a5085d8f4019d625$var$fieldConfigurationQueryExperienceDescription({
        wasExperienceSuccessful: wasExperienceSuccessful,
        ...error?.message != null ? {
            errorMessage: error.message
        } : {},
        ...error instanceof (0, $jJZqs.default) && error.traceId != null ? {
            traceId: error.traceId
        } : {}
    }));
};
const $a5085d8f4019d625$var$fetchData = async (issueKey)=>{
    try {
        const response = await (0, $eusud.performPostRequest)((0, $iZIvy.getGraphQlUrl)('', (0, $eDXka.IssueViewFetchOperations).FIELD_CONFIGURATION), {
            body: JSON.stringify({
                query: $a5085d8f4019d625$export$9715ac6597e498fd(),
                variables: {
                    issueKey: issueKey
                }
            })
        });
        if (response?.data?.issue?.fields) {
            const fieldConfigData = response.data.issue.fields.reduce(// @ts-expect-error - TS7006 - Parameter 'result' implicitly has an 'any' type. | TS7006 - Parameter 'field' implicitly has an 'any' type.
            (result, field)=>({
                    // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                    ...result,
                    [field.key]: {
                        autoCompleteUrl: field.autoCompleteUrl,
                        allowedValues: field.allowedValues,
                        isEditable: field.editable,
                        isRequired: field.required,
                        schema: field.schema,
                        title: field.title,
                        ...field.description ? {
                            description: field.description
                        } : {}
                    }
                }), {});
            $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking({
                wasExperienceSuccessful: true
            });
            return fieldConfigData;
        }
        $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking({
            wasExperienceSuccessful: false,
            error: new Error('Unexpected field configuration response')
        });
        return null;
    } catch (error) {
        $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking({
            wasExperienceSuccessful: false,
            error: error instanceof (0, $jJZqs.default) ? error : undefined
        });
        return null;
    }
};
const $a5085d8f4019d625$var$requestSet = new Set();
const $a5085d8f4019d625$var$issueFieldConfigServiceDefaultOptions = {
    skipRefresh: false
};
const $a5085d8f4019d625$var$useIssueFieldConfigRefetch = (issueKey, value, { skipRefresh: skipRefresh } = $a5085d8f4019d625$var$issueFieldConfigServiceDefaultOptions)=>{
    const isMounted = (0, $biQrn.useIsMounted)();
    const [, { setIssueConfig: setIssueConfig }] = (0, $2N3tQ.useFieldConfigStoreActions)();
    const [loading, setLoading] = (0, $5uXOq.useState)(()=>!skipRefresh && value === undefined && !$a5085d8f4019d625$var$requestSet.has(issueKey));
    const getData = (0, $5uXOq.useCallback)(async ()=>{
        setLoading(true);
        $a5085d8f4019d625$var$requestSet.add(issueKey);
        const result = await $a5085d8f4019d625$var$fetchData(issueKey);
        setIssueConfig(issueKey, result);
        $a5085d8f4019d625$var$requestSet.delete(issueKey);
        if (isMounted.current) setLoading(false);
    }, [
        isMounted,
        issueKey,
        setIssueConfig
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const shouldGetData = (0, $4R6GH.fg)('jiv-19312-fix-fieldconfigurationquery-refetch') ? !skipRefresh && !$a5085d8f4019d625$var$requestSet.has(issueKey) && value === undefined && issueKey !== '' : !skipRefresh && !$a5085d8f4019d625$var$requestSet.has(issueKey) && value === undefined;
        if (shouldGetData) getData();
    }, [
        issueKey,
        value,
        getData,
        skipRefresh
    ]);
    return [
        {
            loading: loading
        }
    ];
};
const $a5085d8f4019d625$var$useIssueFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey })=>{
    const [value] = (0, $2N3tQ.useIssueFieldConfigStore)({
        issueKey: issueKey
    });
    const [overrides] = (0, $2N3tQ.useIssueOverridesStore)({
        issueKey: issueKey
    });
    return (0, $5uXOq.useMemo)(()=>{
        if (// When fields configurations are not valid, we don't want overrides
        !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value) && // We should not override if UI modifications is not available in general or for the field
        overrides !== undefined) {
            // Iteration over the base fields (`value`) prevents creation of partial configs with just UIM overrides.
            const issueWithOverrides = Object.entries(value).reduce((acc, [fieldKey, fieldValues])=>{
                acc[fieldKey] = {
                    ...fieldValues,
                    ...overrides[fieldKey]
                };
                return acc;
            }, {});
            return [
                issueWithOverrides
            ];
        }
        return [
            value
        ];
    }, [
        value,
        overrides
    ]);
};
const $a5085d8f4019d625$var$useFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey, fieldKey: fieldKey })=>{
    const [value] = (0, $2N3tQ.useFieldConfigStore)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const [overrides] = (0, $2N3tQ.useFieldOverridesStore)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    if (// When fields configurations are not valid, we don't want overrides
    !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value) && // We should not override if UI modifications is not available in general or for the field
    overrides !== undefined) return [
        {
            ...value,
            ...overrides
        }
    ];
    return [
        value
    ];
};
const $a5085d8f4019d625$export$5406c21e0d275680 = (issueKey)=>{
    const [value] = $a5085d8f4019d625$var$useIssueFieldConfigStoreWithUimOverrides({
        issueKey: issueKey
    });
    const [{ loading: loading }] = $a5085d8f4019d625$var$useIssueFieldConfigRefetch(issueKey, value);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $a5085d8f4019d625$export$217a0e2f2962f4ae = (issueKey)=>{
    const [value] = $a5085d8f4019d625$var$useIssueFieldConfigStoreWithUimOverrides({
        issueKey: issueKey
    });
    return [
        {
            value: value
        }
    ];
};
const $a5085d8f4019d625$export$5f641a998c6dfa06 = ({ issueKey: issueKey })=>{
    const [value] = (0, $2N3tQ.useIssueFieldConfigStore)({
        issueKey: issueKey
    });
    const [{ loading: loading }] = $a5085d8f4019d625$var$useIssueFieldConfigRefetch(issueKey, value);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $a5085d8f4019d625$export$70da50df1be2dbe1 = (issueKey, fieldKey, options = $a5085d8f4019d625$var$issueFieldConfigServiceDefaultOptions)=>{
    const [value] = $a5085d8f4019d625$var$useFieldConfigStoreWithUimOverrides({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const [{ loading: loading }] = $a5085d8f4019d625$var$useIssueFieldConfigRefetch(issueKey, value, options);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $a5085d8f4019d625$export$1eed575f8f3334eb = (issueKey, fieldKey)=>{
    const [value] = $a5085d8f4019d625$var$useFieldConfigStoreWithUimOverrides({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    return [
        {
            value: value
        }
    ];
};
const $a5085d8f4019d625$export$28a22fd0dedf31b7 = ()=>{
    const [, setIssueConfigActions] = (0, $2N3tQ.useFieldConfigStoreActions)();
    const actions = (0, $5uXOq.useMemo)(()=>{
        const setIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.setIssueConfig(issueKey, issueConfig);
        const setIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.setIssuesConfig(issuesWithConfigurations);
        const mergeIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.mergeIssueConfig(issueKey, issueConfig);
        const mergeIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.mergeIssuesConfig(issuesWithConfigurations);
        const setFieldConfigValue = (issueKey, fieldKey, fieldConfigValue)=>setIssueConfigActions.setFieldConfigValue(issueKey, fieldKey, fieldConfigValue);
        return {
            setIssueConfig: setIssueConfig,
            setIssuesConfig: setIssuesConfig,
            mergeIssueConfig: mergeIssueConfig,
            mergeIssuesConfig: mergeIssuesConfig,
            setFieldConfigValue: setFieldConfigValue
        };
    }, [
        setIssueConfigActions
    ]);
    return [
        null,
        actions
    ];
};

});
parcelRegister("iZIvy", function(module, exports) {

$parcel$export(module.exports, "getGraphQlUrl", () => $ef2130f553e5234b$export$5647e6bbf2b3526f);
$parcel$export(module.exports, "getFieldDataOptions", () => $ef2130f553e5234b$export$f2fec0cacdfabaaf);

var $96nmc = parcelRequire("96nmc");

var $chLKn = parcelRequire("chLKn");

const $ef2130f553e5234b$export$5647e6bbf2b3526f = (baseUrl, operation)=>`${baseUrl}/rest/graphql/1/${(0, $96nmc.appendOperationQuery)(operation)}`;
const $ef2130f553e5234b$export$f2fec0cacdfabaaf = (issueKey, projectKey)=>({
        method: 'POST',
        body: JSON.stringify({
            query: (0, $chLKn.default)(issueKey, projectKey)
        })
    });

});
parcelRegister("96nmc", function(module, exports) {

$parcel$export(module.exports, "appendOperationQuery", () => $8119dcf59ebfcad5$export$69694c3add0f6058);
const $8119dcf59ebfcad5$export$69694c3add0f6058 = (operation)=>operation ? `?operation=${operation}` : '';

});

parcelRegister("chLKn", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c7dcb170a6dfaf0$export$2e2bcd8739ae039);
const $2c7dcb170a6dfaf0$export$ecc155df19ba52ff = (literals, ...substitutions)=>{
    let result = '';
    // run the loop only for the substitution count
    substitutions.forEach((key, i)=>{
        result += literals[i];
        result += key.toString();
    });
    // add the last literal
    result += literals[literals.length - 1];
    return result;
};
const $2c7dcb170a6dfaf0$var$getIsHybridAgilityProjectQuery = ()=>`
    isHybridAgilityProject
    `;
const $2c7dcb170a6dfaf0$var$getEnvironmentQuery = ()=>`environmentAdf {
        value
    }`;
const $2c7dcb170a6dfaf0$var$getAgileQuery = ()=>`
    agile {
        epic {
          key
        },
    }`;
const $2c7dcb170a6dfaf0$var$getCustomFieldSchemaConfiguration = ()=>`configuration {
        key
        value
    }
    `;
const $2c7dcb170a6dfaf0$var$getProjectQuery = (projectKey)=>`
        project(projectIdOrKey: "${projectKey}") {
            id
            name
            key
            projectTypeKey
            simplified
            avatarUrls {
                key
                value
            }
            archived
            deleted
        }`;
var // Disable this eslint rule temporarily so we can query for configuration
// eslint-disable-next-line jira/import/no-anonymous-default-export
$2c7dcb170a6dfaf0$export$2e2bcd8739ae039 = (issueKey, projectKey)=>$2c7dcb170a6dfaf0$export$ecc155df19ba52ff`query issueDataQuery {
        issue(issueIdOrKey: "${issueKey}", latestVersion: true, screen: "view") {
            id
            viewScreenId
            fields {
                key
                title
                editable
                required
                autoCompleteUrl
                allowedValues
                content
                renderedContent
                schema {
                    custom
                    system
                    ${$2c7dcb170a6dfaf0$var$getCustomFieldSchemaConfiguration()}
                    items
                    type
                    renderer
                }
                configuration
            }
            expandAssigneeInSubtasks
            expandAssigneeInIssuelinks
            expandTimeTrackingInSubtasks
            systemFields {
                descriptionAdf {
                    value
                }
                ${$2c7dcb170a6dfaf0$var$getEnvironmentQuery()}
            }
            customFields {
                textareaAdf {
                    key
                    value
                }
            }
            ${$2c7dcb170a6dfaf0$var$getIsHybridAgilityProjectQuery()}
            ${$2c7dcb170a6dfaf0$var$getAgileQuery()}
        }
        ${$2c7dcb170a6dfaf0$var$getProjectQuery(projectKey)}
    }`;

});


parcelRegister("eDXka", function(module, exports) {

$parcel$export(module.exports, "TIMESTAMP_DISPLAY_SETTING", () => $9f0f96bc04f1e77a$export$9f4ee8e6dc9a0a55);
$parcel$export(module.exports, "CHILD_ISSUES_LIMIT_BEST_PRACTICE_FLAG_DISMISSED", () => $9f0f96bc04f1e77a$export$e7d75f9d93dfa3df);
$parcel$export(module.exports, "IssueViewFetchOperations", () => $9f0f96bc04f1e77a$export$b38f30d67f730bc4);
const $9f0f96bc04f1e77a$export$9f4ee8e6dc9a0a55 = 'jira.user.issue.details.timestamp-display-setting';
const $9f0f96bc04f1e77a$export$e7d75f9d93dfa3df = 'jira.user.issue.child-issues-limit.best-practice-flag.dismissed';
const $9f0f96bc04f1e77a$export$b38f30d67f730bc4 = {
    EARLY_FETCH_GRAPHQL: 'earlyFetchIssueDataQuery',
    INITIAL_GRAPHQL: 'issueDataQuery',
    EARLY_FETCH_GIRA: 'earlyFetchIssueViewInteractiveQuery',
    INITIAL_GIRA: 'issueViewInteractiveQuery',
    EARLY_FETCH_AGG: 'earlyFetchMainIssueAggQuery',
    INITIAL_AGG: 'mainIssueAggQuery',
    EARLY_FETCH_NON_CRITICAL_GIRA: 'earlyFetchIssueViewNonCriticalGiraQuery',
    NON_CRITICAL_GIRA: 'issueViewNonCriticalGiraQuery',
    VIEW_SCREEN_ID: 'viewScreenIdQuery',
    FIELD_CONFIGURATION: 'fieldConfigurationQuery',
    FIELD_DESCRIPTION: 'fieldDescriptionQuery',
    ATTACHMENT: 'attachmentsQuery'
};

});

parcelRegister("2N3tQ", function(module, exports) {

$parcel$export(module.exports, "useIssueFieldConfigStore", () => $0471f3f4df57179c$export$52f51db4e2b3da57);
$parcel$export(module.exports, "useFieldConfigStore", () => $0471f3f4df57179c$export$f9beb98c7488fd61);
$parcel$export(module.exports, "useFieldConfigStoreActions", () => $0471f3f4df57179c$export$314199caf05d245);
$parcel$export(module.exports, "useIssueOverridesStore", () => $0471f3f4df57179c$export$ff357cf5a96ec0c6);
$parcel$export(module.exports, "useFieldOverridesStore", () => $0471f3f4df57179c$export$6e41e9c34587d557);
$parcel$export(module.exports, "useFieldOverridesStoreWithLabel", () => $0471f3f4df57179c$export$e704d739927bd1d6);
$parcel$export(module.exports, "useOverridesStoreActions", () => $0471f3f4df57179c$export$d94ae842140da412);
$parcel$export(module.exports, "useFieldOptionsOverrides", () => $0471f3f4df57179c$export$bfea9bb9bad7bc8f);
$parcel$export(module.exports, "useIsFieldBusy", () => $0471f3f4df57179c$export$982ff1008c2e2780);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
var $dGvGJ = parcelRequire("dGvGJ");

var $1UikQ = parcelRequire("1UikQ");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $0471f3f4df57179c$var$setIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState })=>{
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: IssueConfiguration | null; }' is not assignable to parameter of type 'Partial<Partial<Record<string, IssueConfiguration>>>'.
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: issueConfiguration
        });
    };
const $0471f3f4df57179c$var$mergeIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, getState()[issueKey], issueConfiguration)
        });
    };
const $0471f3f4df57179c$var$setIssuesConfig = (issuesWithConfigurations)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = issuesWithConfigurations.reduce((acc, issue)=>({
                ...acc,
                ...issue
            }), {});
        setState(newIssues);
    };
const $0471f3f4df57179c$var$mergeIssuesConfig = (issuesWithConfigurations)=>({ setState: setState, getState: getState })=>{
        if (issuesWithConfigurations.length === 0) return;
        const newIssues = {};
        issuesWithConfigurations.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, getState(), newIssues));
    };
const $0471f3f4df57179c$var$setFieldConfigValue = (issueKey, fieldKey, fieldConfiguration)=>({ setState: setState, getState: getState })=>{
        const issueKeyFieldConfiguration = getState()[issueKey];
        if (issueKeyFieldConfiguration && issueKeyFieldConfiguration[fieldKey]) setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: {
                    ...getState()[issueKey][fieldKey],
                    ...fieldConfiguration
                }
            }
        });
    };
const $0471f3f4df57179c$var$actions = {
    setIssueConfig: $0471f3f4df57179c$var$setIssueConfig,
    setIssuesConfig: $0471f3f4df57179c$var$setIssuesConfig,
    mergeIssueConfig: $0471f3f4df57179c$var$mergeIssueConfig,
    mergeIssuesConfig: $0471f3f4df57179c$var$mergeIssuesConfig,
    setFieldConfigValue: $0471f3f4df57179c$var$setFieldConfigValue
};
// this is a global state
const $0471f3f4df57179c$var$store = (0, $iXqE5.createStore)({
    name: 'issue-field-config',
    initialState: {},
    actions: $0471f3f4df57179c$var$actions
});
const $0471f3f4df57179c$var$getIssueFieldConfig = (0, $dGvGJ.createSelector)((state, props)=>state[props.issueKey], (issue)=>issue);
const $0471f3f4df57179c$export$52f51db4e2b3da57 = (0, $3sQ5x.createHook)($0471f3f4df57179c$var$store, {
    selector: $0471f3f4df57179c$var$getIssueFieldConfig
});
const $0471f3f4df57179c$var$getFieldConfig = (0, $dGvGJ.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
    // issue being undefined means we haven't fetched it yet
    // issue being null means it doesn't exist.
    // either way we just return that value
    if (issue == null) return issue;
    // if we have the field key, return it. Otherwise return null to show
    // we have done a data fetch of the issue but the field doesn't exist
    return issue[fieldKey] ? issue[fieldKey] : null;
});
const $0471f3f4df57179c$var$getFieldConfigWithLabel = (0, $dGvGJ.createSelector)($0471f3f4df57179c$var$getFieldConfig, (fieldConfig)=>{
    if (fieldConfig?.title === undefined) return fieldConfig;
    return {
        ...fieldConfig,
        label: fieldConfig.title
    };
});
const $0471f3f4df57179c$var$getFieldOptionsOverrides = (0, $dGvGJ.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
    // issue being undefined means we haven't fetched it yet
    // issue being null means it doesn't exist.
    // either way we just return that value
    if (issue == null) return issue;
    // if we have the field key, return it. Otherwise return null to show
    // we have done a data fetch of the issue but the field doesn't exist
    return issue[fieldKey] ? issue[fieldKey].allowedValuesOverrides : null;
});
const $0471f3f4df57179c$export$f9beb98c7488fd61 = (0, $3sQ5x.createHook)($0471f3f4df57179c$var$store, {
    selector: $0471f3f4df57179c$var$getFieldConfig
});
const $0471f3f4df57179c$export$314199caf05d245 = (0, $3sQ5x.createHook)($0471f3f4df57179c$var$store, {
    selector: null
});
const $0471f3f4df57179c$var$setOverrides = (issueKey, fieldKey, fieldConfigOverrides)=>({ setState: setState, getState: getState })=>{
        const issueKeyFieldConfigurationWithOverrides = getState()[issueKey] ?? {};
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...issueKeyFieldConfigurationWithOverrides,
                [fieldKey]: {
                    ...issueKeyFieldConfigurationWithOverrides[fieldKey],
                    ...fieldConfigOverrides
                }
            }
        });
    };
const $0471f3f4df57179c$var$resetOverridesStore = (issueKey)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [issueKey]: undefined
        });
    };
const $0471f3f4df57179c$var$overridesActions = {
    setFieldConfigOverridesValue: $0471f3f4df57179c$var$setOverrides,
    resetOverridesStore: $0471f3f4df57179c$var$resetOverridesStore
};
// Store contains overrides to the field config. It is used by UI modifications to override field config properties by apps.
// UI modifications is a Forge extension point providing apps JS API to override field's properties: name, description, isEditable
// and limit visibility of select fields options.
const $0471f3f4df57179c$var$overridesStore = (0, $iXqE5.createStore)({
    name: 'issue-field-overrides',
    initialState: {},
    actions: $0471f3f4df57179c$var$overridesActions
});
const $0471f3f4df57179c$export$ff357cf5a96ec0c6 = (0, $3sQ5x.createHook)($0471f3f4df57179c$var$overridesStore, {
    selector: $0471f3f4df57179c$var$getIssueFieldConfig
});
const $0471f3f4df57179c$export$6e41e9c34587d557 = (0, $3sQ5x.createHook)($0471f3f4df57179c$var$overridesStore, {
    selector: $0471f3f4df57179c$var$getFieldConfig
});
const $0471f3f4df57179c$export$e704d739927bd1d6 = (0, $3sQ5x.createStateHook)($0471f3f4df57179c$var$overridesStore, {
    selector: $0471f3f4df57179c$var$getFieldConfigWithLabel
});
const $0471f3f4df57179c$export$d94ae842140da412 = (0, $3sQ5x.createActionsHook)($0471f3f4df57179c$var$overridesStore);
const $0471f3f4df57179c$export$bfea9bb9bad7bc8f = (0, $3sQ5x.createHook)($0471f3f4df57179c$var$overridesStore, {
    selector: $0471f3f4df57179c$var$getFieldOptionsOverrides
});
const $0471f3f4df57179c$var$getIsFieldBusySelector = (state, args)=>{
    const { fieldId: fieldId, issueKey: issueKey } = args;
    return fieldId !== undefined && !!state[issueKey]?.[fieldId]?.isBusy;
};
const $0471f3f4df57179c$export$982ff1008c2e2780 = (0, $3sQ5x.createStateHook)($0471f3f4df57179c$var$overridesStore, {
    selector: $0471f3f4df57179c$var$getIsFieldBusySelector
});

});



const $a4c5fe4dcf7753af$export$1ff9623b26415f8 = 'INLINE';
const $a4c5fe4dcf7753af$export$44f42916442b37c3 = 'LOZENGE';
const $a4c5fe4dcf7753af$export$eade6b6091579183 = 'NORMAL';
const $a4c5fe4dcf7753af$export$797ed91ebb8db1c5 = 'CHILD_ISSUE_LOZENGE';

parcelRegister("bJ2M7", function(module, exports) {

$parcel$export(module.exports, "IssueNumberFieldBoundary", () => $7558df822eaca863$export$5efed0d3367e90db);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $hXYQI = parcelRequire("hXYQI");

const $7558df822eaca863$export$17e6ae9e4022a01f = (0, $kxZPA.lazy)(()=>(parcelRequire("epKfy")), {
    moduleId: "./src/packages/issue/fields/number/src/ui/index.tsx"
});
const $7558df822eaca863$export$e170b9657d273707 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "issue-field-number",
        packageName: "jira-issue-field-number",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hXYQI.NumberView), {
                isEditable: props.isEditable !== undefined ? props.isEditable : false
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-field-number-readonly",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hXYQI.NumberView), {
            isEditable: props.isEditable !== undefined ? props.isEditable : false
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7558df822eaca863$export$17e6ae9e4022a01f, props)));
const $7558df822eaca863$export$5efed0d3367e90db = ({ children: children, fallback: fallback, packageName: packageName, onError: onError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "issue-number-field",
        packageName: packageName,
        fallback: fallback ? ()=>fallback : undefined,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-number-field-boundary",
        fallback: fallback
    }, children));

});
parcelRegister("hXYQI", function(module, exports) {

$parcel$export(module.exports, "NumberView", () => $667e08b0b18f78dd$export$3a0cbbcc23d8ca3d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $16T6Y = parcelRequire("16T6Y");

var $aWse0 = parcelRequire("aWse0");

const $667e08b0b18f78dd$var$noValueText = '-';
const $667e08b0b18f78dd$export$3a0cbbcc23d8ca3d = ({ isEditable: isEditable, value: value, setIsEditing: setIsEditing })=>{
    const { formatNumber: formatNumber } = (0, $aWse0.useIntlV2)();
    const handleOnClick = (0, $5uXOq.useCallback)(()=>{
        setIsEditing?.(true);
    }, [
        setIsEditing
    ]);
    if (value === undefined) return null;
    const displayValue = value === null ? $667e08b0b18f78dd$var$noValueText : formatNumber(value);
    const BadgeComp = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16T6Y.default), {
        testId: (0, $ea286d2db1e9f268$export$ddb0dcfa9074309f)
    }, displayValue);
    const BadgeComponent = isEditable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($667e08b0b18f78dd$var$HoverContainer, {
        "data-testid": `${(0, $ea286d2db1e9f268$export$ddb0dcfa9074309f)}-hover-container`,
        onClick: handleOnClick
    }, BadgeComp) : BadgeComp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($667e08b0b18f78dd$var$BadgeWrapper, null, BadgeComponent);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $667e08b0b18f78dd$var$HoverContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_80omtlke _ll8p16l4 _1lgi1hek",
            __cmplp.className
        ])
    });
});
const $667e08b0b18f78dd$var$BadgeWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_189eyh40 _1dqonqa1 _1h6d3acm",
            __cmplp.className
        ])
    });
});

});
const $ea286d2db1e9f268$export$195635d59130784a = 'issue-field-number.ui.issue-field-number';
const $ea286d2db1e9f268$export$5dadcbcc34de35f = 'issue-field-number.ui.issue-field-number--container';
const $ea286d2db1e9f268$export$ddb0dcfa9074309f = 'issue-field-number.ui.badge';
const $ea286d2db1e9f268$export$3cb3b73ace5de3d1 = `${$ea286d2db1e9f268$export$ddb0dcfa9074309f}-hover-container`;
const $ea286d2db1e9f268$export$ac421571f56485b8 = 'issue-field-number.edit.warning-icon';


parcelRegister("epKfy", function(module, exports) {

let $a7e746bd1ec93713$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a7e746bd1ec93713$var$load("iFgA7").then(()=>parcelRequire('jojgm'));

});


parcelRegister("kxnJE", function(module, exports) {

let $ef394d0aaefbdd67$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ef394d0aaefbdd67$var$load("4zXLA").then(()=>parcelRequire('ge1Lf'));

});


parcelRegister("1D3VD", function(module, exports) {

$parcel$export(module.exports, "SummaryAndParents", () => $8794a2b0e6b8c6a9$export$819decb1869bab94);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8QpSo = parcelRequire("8QpSo");

var $k2wwp = parcelRequire("k2wwp");

var $kM28N = parcelRequire("kM28N");

var $cizWc = parcelRequire("cizWc");

var $3FjKF = parcelRequire("3FjKF");
const $8794a2b0e6b8c6a9$export$819decb1869bab94 = ({ cardId: cardId, cardKey: cardKey, summary: summary, highlightText: highlightText, isUserAtLeastMember: isUserAtLeastMember, shouldRenderRichCard: shouldRenderRichCard, isSummaryFieldEditing: isSummaryFieldEditing, onClickThrough: onClickThrough, onSummaryEditStateChange: onSummaryEditStateChange, children: children })=>{
    const getHighlightText = (0, $8QpSo.default)((highlightedText)=>[
            highlightedText
        ]);
    const highlightTextEl = // Possibility that summary is null/undefined
    highlightText !== null && highlightText !== '' && summary ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k2wwp.default), {
        text: summary,
        highlight: getHighlightText(highlightText)
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.SummaryAndParentContainer), {
        isSummaryFieldEditing: isSummaryFieldEditing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.SummaryWrapper), {
        tabIndex: -1,
        isSummaryFieldEditing: isSummaryFieldEditing,
        onClick: isSummaryFieldEditing ? (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) : onClickThrough,
        "data-testid": (0, $cizWc.SUMMARY_TEST_ID)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3FjKF.default), {
        issueId: cardId.toString(),
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        issueKey: cardKey,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        isUserAtLeastMember: isUserAtLeastMember,
        shouldRenderRichCard: shouldRenderRichCard ?? false,
        summary: summary,
        highlightText: highlightTextEl,
        onSummaryEditStateChange: onSummaryEditStateChange
    })), children);
};

});
parcelRegister("3FjKF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b14a5dc71d40567a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7XYc4 = parcelRequire("7XYc4");

var $1UppJ = parcelRequire("1UppJ");

var $5fc53 = parcelRequire("5fc53");

var $iXVV6 = parcelRequire("iXVV6");

var $kxZPA = parcelRequire("kxZPA");

var $19Udk = parcelRequire("19Udk");

var $4R6GH = parcelRequire("4R6GH");


var $dM9vk = parcelRequire("dM9vk");

var $JMY9i = parcelRequire("JMY9i");

// MultilineInlineSummary is actually just a proxy for @atlassian/jira-issue-field-summary-inline-edit-link
const $b14a5dc71d40567a$var$MultilineInlineSummaryLazyOld = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("13HYM")).then(({ MultilineInlineSummary: MultilineInlineSummary })=>MultilineInlineSummary), {
    moduleId: "./src/packages/issue/fields/summary/src/ui/multiline-inline-summary/index.tsx"
});
const $b14a5dc71d40567a$export$55fbdf721796dfc0 = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jfp-magma-summary-field-suspense-fix'), (0, $19Udk.AsyncSummaryInlineEditLink), $b14a5dc71d40567a$var$MultilineInlineSummaryLazyOld);
const $b14a5dc71d40567a$var$SummaryField = ({ shouldRenderRichCard: shouldRenderRichCard, issueId: issueId, issueKey: issueKey, highlightText: highlightText, onSummaryEditStateChange: onSummaryEditStateChange, summary: summary, isUserAtLeastMember: isUserAtLeastMember })=>{
    const summaryFieldStatic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $JMY9i.StaticSummaryField), {
        highlightText: highlightText,
        summary: summary
    });
    if (shouldRenderRichCard && isUserAtLeastMember) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1UppJ.IssueSummaryFieldBoundary), {
        packageName: (0, $a9c483c0d986286a$export$dfd208682d29484c),
        fallback: summaryFieldStatic
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dM9vk.default), {
        experienceTarget: (0, $5fc53.SUMMARY_TYPE),
        experienceTargetId: issueKey,
        additionalAttributes: {
            issueKey: issueKey
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b14a5dc71d40567a$var$MultilineSummaryFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            isInlineEditing: true
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b14a5dc71d40567a$export$55fbdf721796dfc0, {
        issueId: issueId,
        issueKey: issueKey,
        highlightText: highlightText,
        onEditStateChange: onSummaryEditStateChange
    })))));
    return summaryFieldStatic;
};
var $b14a5dc71d40567a$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
 = /*#__PURE__*/ (0, $5uXOq.memo)($b14a5dc71d40567a$var$SummaryField);
const $b14a5dc71d40567a$var$MultilineSummaryFieldWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0x0bf _2hwxx0bf _gjxvze3t _132nmgjw _192wstnw _11041osq _1q8jgrf3 _1s8q1txw _wryf13la _122i13la _570a13la _1kwi13la",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1UppJ", function(module, exports) {

$parcel$export(module.exports, "IssueSummaryFieldBoundary", () => $d01ef8c87f783d29$export$f8e4f73217de638d);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");

const $d01ef8c87f783d29$export$f8e4f73217de638d = ({ children: children, fallback: fallback, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "issue-summary-field",
        packageName: packageName,
        render: ()=>fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-summary-field-boundary",
        fallback: fallback
    }, children));

});

parcelRegister("19Udk", function(module, exports) {

$parcel$export(module.exports, "AsyncSummaryInlineEditLink", () => $b05382bb46a2aa04$export$4e1f6ecc0e44aa05);

var $kxZPA = parcelRequire("kxZPA");

const $b05382bb46a2aa04$export$4e1f6ecc0e44aa05 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("2pja9")).then(({ SummaryInlineEditLink: SummaryInlineEditLink })=>SummaryInlineEditLink), {
    moduleId: "./src/packages/issue/fields/summary-components/summary-inline-edit-link/src/ui/main.tsx"
});

});
parcelRegister("2pja9", function(module, exports) {

let $1c0cc7e4cd33b4e5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1c0cc7e4cd33b4e5$var$load("hPMLo").then(()=>parcelRequire('5NfeB'));

});


parcelRegister("JMY9i", function(module, exports) {

$parcel$export(module.exports, "StaticSummaryField", () => $e86b4bd2962f74b0$export$852299389cd57d63);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $kM28N = parcelRequire("kM28N");
const $e86b4bd2962f74b0$export$852299389cd57d63 = ({ summary: summary, highlightText: highlightText })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: summary
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.Summary), null, highlightText ?? summary));

});

parcelRegister("13HYM", function(module, exports) {

let $0c582f9c85318fb8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0c582f9c85318fb8$var$load("8lPsK").then(()=>parcelRequire('fyJFY'));

});



parcelRegister("1e5mE", function(module, exports) {

$parcel$export(module.exports, "TypeIcon", () => $c41cf15b3b40645a$export$ad8f8fc3bcd61b4a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $c41cf15b3b40645a$export$ad8f8fc3bcd61b4a = ({ icon: icon })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c41cf15b3b40645a$var$ImageContainer, {
        "data-testid": "software-backlog.card-list.card.card-contents.type-icon.type"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c41cf15b3b40645a$var$Img, {
        role: "presentation",
        src: icon
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c41cf15b3b40645a$var$ImageContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_yyhy11t1 _1ii7wtyw",
            __cmplp.className
        ])
    });
});
const $c41cf15b3b40645a$var$Img = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb7vkz _4t3i7vkz _s7n41ndm",
            __cmplp.className
        ])
    });
});

});

parcelRegister("xEBl6", function(module, exports) {

$parcel$export(module.exports, "VersionsWrapper", () => $9030fd3a889ff9ec$export$5c54d44b9c100bd1);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $iDGXn = parcelRequire("iDGXn");

var $963tu = parcelRequire("963tu");

var $a6e3u = parcelRequire("a6e3u");
const $9030fd3a889ff9ec$export$5c54d44b9c100bd1 = ({ shouldDisplayVersions: shouldDisplayVersions, backlogContainerSize: backlogContainerSize, cardId: cardId })=>{
    const showVersions = (0, $iDGXn.useShowVersions)();
    if (shouldDisplayVersions && showVersions) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9030fd3a889ff9ec$var$VersionsContainer, {
        "data-testid": "software-backlog.card-list.card.card-contents.versions-field.version-field-wrapper.versions-container",
        widthMultiplier: (0, $963tu.getLabelWidthMultiplier)((0, $963tu.LabelType).VERSION, backlogContainerSize)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a6e3u.VersionsField), {
        cardId: cardId,
        backlogContainerSize: backlogContainerSize
    }));
    return null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9030fd3a889ff9ec$var$VersionsContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { widthMultiplier: widthMultiplier, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ewl67i": (0, $lD23V.default)(`repeat(auto-fit, calc(${"var(--ds-space-100, 8px)"} * ${__cmplp.widthMultiplier}))`),
            "--_1qtnkr6": (0, $lD23V.default)(`calc(${"var(--ds-space-100, 8px)"} * ${__cmplp.widthMultiplier})`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c11p5 _1pbykb7n _1bto1l2s _4cvr1h6o _6a6zv2br _lcxvglyw _yv0epq74 _1ul9dike",
            __cmplp.className
        ])
    });
});

});



parcelRegister("h5zHO", function(module, exports) {

$parcel$export(module.exports, "DropIndicator", () => $8ec67faa5923f21e$export$62ed72bc21f6b8a6);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $dCm1o = parcelRequire("dCm1o");

var $ibJfd = parcelRequire("ibJfd");
function $8ec67faa5923f21e$export$62ed72bc21f6b8a6({ edge: edge, droppingOverCardId: droppingOverCardId, droppingOverCardListId: droppingOverCardListId, dropStatisticsCardListId: dropStatisticsCardListId }) {
    return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: [
            $8ec67faa5923f21e$var$dropLineStyles,
            edge === 'top' && $8ec67faa5923f21e$var$topStyles,
            edge === 'bottom' && $8ec67faa5923f21e$var$bottomStyles
        ]
    }, dropStatisticsCardListId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $8ec67faa5923f21e$var$informationPillStyles,
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ibJfd.DividerStatistics), {
        dividerCardListId: dropStatisticsCardListId,
        isDragIndicator: true,
        edge: edge === 'top' ? 'top' : 'bottom',
        droppingOverCardListId: droppingOverCardListId,
        droppingOverCardId: droppingOverCardId
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8ec67faa5923f21e$var$DropLine, {
        edge: edge
    }, dropStatisticsCardListId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8ec67faa5923f21e$var$InformationPill, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ibJfd.DividerStatistics), {
        dividerCardListId: dropStatisticsCardListId,
        isDragIndicator: true,
        edge: edge === 'top' ? 'top' : 'bottom',
        droppingOverCardListId: droppingOverCardListId,
        droppingOverCardId: droppingOverCardId
    })));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8ec67faa5923f21e$var$DropLine = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { edge: edge, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1ltvidpf _1bsb1osq _4t3iyh40 _1pbykb7n _1e0c1txw _1bah1y6m _4cvr1h6o _bfhkbku0 _lcxvglyw _rfx31ssb _3l88yh40 _kzdanqa1 _15m613er _1kt9b3bt _1cs8stnw _kfgt1y44 _1mp41y44 _1aukj39m _qnec16fl",
            __cmplp.edge === 'top' && "_154i1i6y",
            __cmplp.edge === 'bottom' && "_94n5ze3t",
            __cmplp.className
        ])
    });
});
const $8ec67faa5923f21e$var$InformationPill = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1tcg _bfhkbku0 _1e0c1txw _4cvr1h6o _1bah1h6o _ca0q1b66 _u5f3u2gc _n3td1b66 _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $8ec67faa5923f21e$var$dropLineStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    left: "var(--ds-space-050, 4px)",
    width: `calc(100% - ${"var(--ds-space-050, 4px)"})`,
    height: '2px',
    zIndex: 'card',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    backgroundColor: 'color.background.selected.bold',
    pointerEvents: 'none',
    '::before': {
        content: "''",
        position: 'absolute',
        height: '4px',
        width: '4px',
        top: '-3px',
        left: '-7px',
        borderRadius: '50%',
        border: `2px solid ${"var(--ds-border-brand, #0C66E4)"}`
    }
});
const $8ec67faa5923f21e$var$topStyles = (0, $8CUq3.xcss)({
    top: "var(--ds-space-negative-025, -2px)"
});
const $8ec67faa5923f21e$var$bottomStyles = (0, $8CUq3.xcss)({
    bottom: "var(--ds-space-0, 0px)"
});
const $8ec67faa5923f21e$var$informationPillStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.selected.bold',
    borderRadius: '4px',
    paddingBlock: 'space.075',
    paddingInline: 'space.150',
    position: 'absolute',
    marginLeft: 'space.100'
});

});
parcelRegister("ibJfd", function(module, exports) {

$parcel$export(module.exports, "DividerStatistics", () => $cce02bdbcbe8b2c4$export$6542605af85d934);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gccSB = parcelRequire("gccSB");

var $kgoHi = parcelRequire("kgoHi");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $guzeq = parcelRequire("guzeq");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $45Qwd = parcelRequire("45Qwd");

var $l9VFH = parcelRequire("l9VFH");

var $4NOUT = parcelRequire("4NOUT");

var $enPV1 = parcelRequire("enPV1");

var $6diJT = parcelRequire("6diJT");
function $cce02bdbcbe8b2c4$export$6542605af85d934(props) {
    const { dividerCardListId: dividerCardListId, isDragIndicator: isDragIndicator } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const estimationType = (0, $c1MAf.useBacklogSelector)((0, $45Qwd.getEstimationType));
    const isCompanyManaged = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
    const totalIssues = (0, $c1MAf.useBacklogSelector)((state)=>(0, $6diJT.getTotalIssues)(state, {
            cardListId: dividerCardListId,
            dropIndicator: isDragIndicator === true ? props : undefined
        }));
    const remainingEstimates = (0, $c1MAf.useBacklogSelector)((state)=>(0, $6diJT.getRemainingEstimate)(state, {
            cardListId: dividerCardListId,
            dropIndicator: isDragIndicator === true ? props : undefined
        }));
    const filteredIssues = (0, $6diJT.useFilteredIssueCount)(dividerCardListId);
    const filters = (0, $c1MAf.useBacklogSelector)((0, $l9VFH.getFilters));
    const isFilterOn = !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters);
    const isDisplayRemainTimeEnabled = (0, $c1MAf.useBacklogSelector)((0, $4NOUT.getIsRemainingTimeTrackingEnabledSelector));
    const shouldShowFilteredCount = isFilterOn && !isDragIndicator;
    const filteredRemainingEstimates = (0, $6diJT.useFilteredRemainingEstimate)(dividerCardListId);
    const isRemainDifferentFromOriginal = shouldShowFilteredCount ? filteredRemainingEstimates.originalTimeEstimate !== filteredRemainingEstimates.remainingTimeEstimate : remainingEstimates.originalTimeEstimate !== remainingEstimates.remainingTimeEstimate;
    const formatEstimationValue = (0, $6diJT.useFormatEstimationValue)();
    const formatTimeTrackingValue = (0, $6diJT.useFormatTimeTrackingValue)();
    const formatStrong = (0, $5uXOq.useCallback)((chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            size: "medium",
            color: (0, $dCm1o.isVisualRefreshEnabled)() && isDragIndicator ? 'color.text.inverse' : undefined,
            as: "strong",
            weight: (0, $dCm1o.isVisualRefreshEnabled)() && isDragIndicator ? 'bold' : undefined
        }, chunks), [
        isDragIndicator
    ]);
    const getElementsText = (0, $5uXOq.useMemo)(()=>{
        if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return shouldShowFilteredCount ? formatMessage((0, $enPV1.messages).filteredAmountCardsIssueTermRefresh, {
            cardAmount: totalIssues,
            filteredIssues: filteredIssues,
            strong: (chunks)=>formatStrong(chunks)
        }) : formatMessage(isDragIndicator && (0, $dCm1o.isVisualRefreshEnabled)() ? (0, $enPV1.messages).totalCardsDragIndicatorIssueTermRefresh : (0, $enPV1.messages).totalCardsIssueTermRefresh, {
            cardAmount: totalIssues,
            strong: (chunks)=>formatStrong(chunks)
        });
        return shouldShowFilteredCount ? formatMessage((0, $enPV1.messages).filteredAmountCards, {
            cardAmount: totalIssues,
            filteredIssues: filteredIssues,
            strong: (chunks)=>formatStrong(chunks)
        }) : formatMessage(isDragIndicator && (0, $dCm1o.isVisualRefreshEnabled)() ? (0, $enPV1.messages).totalCardsDragIndicator : (0, $enPV1.messages).totalCards, {
            cardAmount: totalIssues,
            strong: (chunks)=>formatStrong(chunks)
        });
    }, [
        filteredIssues,
        formatMessage,
        formatStrong,
        isDragIndicator,
        shouldShowFilteredCount,
        totalIssues
    ]);
    const elements = [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            key: "total"
        }, getElementsText)
    ];
    const infoVerticalDivider = (prefix)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cce02bdbcbe8b2c4$var$InfoVerticalDivider, {
            key: `${prefix}VerticalDivider`,
            isDragIndicator: isDragIndicator
        });
    const remainingEstimateState = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        key: "remainingEstimate"
    }, shouldShowFilteredCount ? formatMessage((0, $enPV1.messages).filteredRemainingLabel, {
        estimate: formatTimeTrackingValue(remainingEstimates.remainingTimeEstimate),
        filteredEstimate: formatTimeTrackingValue(filteredRemainingEstimates.remainingTimeEstimate),
        strong: (chunks)=>formatStrong(chunks)
    }) : formatMessage((0, $enPV1.messages).remainingLabel, {
        estimate: formatTimeTrackingValue(remainingEstimates.remainingTimeEstimate),
        strong: (chunks)=>formatStrong(chunks)
    }));
    const storyPointState = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        key: "storyPoints"
    }, shouldShowFilteredCount ? formatMessage((0, $enPV1.messages).filteredEstimateLabel, {
        estimate: formatEstimationValue(remainingEstimates.storyPoints),
        filteredEstimate: formatEstimationValue(filteredRemainingEstimates.storyPoints),
        strong: (chunks)=>formatStrong(chunks)
    }) : formatMessage((0, $enPV1.messages).estimateLabel, {
        estimate: formatEstimationValue(remainingEstimates.storyPoints),
        strong: (chunks)=>formatStrong(chunks)
    }));
    const originalEstimateState = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        key: "originalEstimate"
    }, shouldShowFilteredCount ? formatMessage((0, $enPV1.messages).filteredEstimateLabel, {
        estimate: formatEstimationValue(remainingEstimates.originalTimeEstimate),
        filteredEstimate: formatEstimationValue(filteredRemainingEstimates.originalTimeEstimate),
        strong: (chunks)=>formatStrong(chunks)
    }) : formatMessage((0, $enPV1.messages).estimateLabel, {
        estimate: formatEstimationValue(remainingEstimates.originalTimeEstimate),
        strong: (chunks)=>formatStrong(chunks)
    }));
    if (estimationType === (0, $guzeq.STORY_POINTS)) {
        if (isCompanyManaged && isDisplayRemainTimeEnabled) elements.push(...[
            infoVerticalDivider('remaining'),
            remainingEstimateState
        ]);
        elements.push(...[
            infoVerticalDivider('storyPoint'),
            storyPointState
        ]);
    } else if (estimationType === (0, $guzeq.ORIGINAL_ESTIMATE)) {
        if (isCompanyManaged) {
            // in a CMP board
            // show remaining estimate only if it's different from original estimate
            // and Time Tracking is set to "Remaining Estimate and Time Spent"
            isDisplayRemainTimeEnabled && isRemainDifferentFromOriginal && elements.push(...[
                infoVerticalDivider('remaining'),
                remainingEstimateState
            ]); // always show original estimate
            elements.push(...[
                infoVerticalDivider('originalEstimate'),
                originalEstimateState
            ]);
        } else {
            // TMP
            if (remainingEstimates.remainingTimeEstimate > 0) elements.push(...[
                infoVerticalDivider('remaining'),
                remainingEstimateState
            ]);
            if (remainingEstimates.originalTimeEstimate > 0) elements.push(...[
                infoVerticalDivider('originalEstimate'),
                originalEstimateState
            ]);
        }
    }
    return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        justifyContent: "start",
        xcss: [
            $cce02bdbcbe8b2c4$var$dividerStatisticsContainerStyles,
            isDragIndicator ? $cce02bdbcbe8b2c4$var$dragIndicatorTextStyles : $cce02bdbcbe8b2c4$var$defaultTextStyles
        ]
    }, elements) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cce02bdbcbe8b2c4$var$DividerStatisticsContainer, {
        isDragIndicator: isDragIndicator
    }, elements);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cce02bdbcbe8b2c4$var$DividerStatisticsContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDragIndicator: isDragIndicator, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _1e0c1txw _4cvr1h6o _gy1putpp _1bahv2br _1n261g80 _18u0u2gc",
            __cmplp.isDragIndicator ? "_syaz15cr" : "_syaz131l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cce02bdbcbe8b2c4$var$InfoVerticalDivider = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDragIndicator: isDragIndicator, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbt94y _4t3ipxbi _1apgnqa1 _hr4jt94y _tzy41ou4",
            __cmplp.isDragIndicator ? "_mowc15cr" : "_mowc131l",
            __cmplp.className
        ])
    });
});
const $cce02bdbcbe8b2c4$var$dividerStatisticsContainerStyles = (0, $8CUq3.xcss)({
    font: 'font.body',
    columnGap: 'space.100',
    flexWrap: 'wrap'
});
const $cce02bdbcbe8b2c4$var$dragIndicatorTextStyles = (0, $8CUq3.xcss)({
    color: 'color.text.inverse'
});
const $cce02bdbcbe8b2c4$var$defaultTextStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtlest'
});

});
parcelRegister("4NOUT", function(module, exports) {

$parcel$export(module.exports, "getIsRemainingTimeTrackingEnabledSelector", () => $978174931084ba01$export$8570c81ed161c2ff);

var $dGvGJ = parcelRequire("dGvGJ");

var $guzeq = parcelRequire("guzeq");

var $e5nhF = parcelRequire("e5nhF");
const $978174931084ba01$export$bbf9cd07c2eaa1ef = (state)=>(0, $e5nhF.getEntities)(state).tracking;
const $978174931084ba01$export$8570c81ed161c2ff = (0, $dGvGJ.createSelector)($978174931084ba01$export$bbf9cd07c2eaa1ef, ({ fieldId: fieldId, isEnabled: isEnabled })=>fieldId === (0, $guzeq.REMAINING_TIME_ESTIMATE) && isEnabled);

});

parcelRegister("enPV1", function(module, exports) {

$parcel$export(module.exports, "messages", () => $3068047a3cbdcd8e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $3068047a3cbdcd8e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    totalCards: {
        "id": "backlog.card-list.divider.divider-statistics.total-cards",
        "defaultMessage": "{cardAmount} {cardAmount, plural, one {issue} other {issues}}"
    },
    totalCardsDragIndicator: {
        "id": "backlog.card-list.divider.divider-statistics.total-cards-drag-indicator",
        "defaultMessage": "{cardAmount} {cardAmount, plural, one {issue} other {issues}}"
    },
    remainingLabel: {
        "id": "backlog.card-list.divider.divider-statistics.remaining-label",
        "defaultMessage": "Remaining: <strong> {estimate}</strong>"
    },
    estimateLabel: {
        "id": "backlog.card-list.divider.divider-statistics.estimate-label",
        "defaultMessage": "Estimate: <strong> {estimate}</strong>"
    },
    filteredAmountCards: {
        "id": "backlog.card-list.divider.divider-statistics.filtered-amount-cards",
        "defaultMessage": "{filteredIssues} of {cardAmount} {cardAmount, plural, one {issue} other {issues}} visible"
    },
    filteredRemainingLabel: {
        "id": "backlog.card-list.divider.divider-statistics.filtered-remaining-label",
        "defaultMessage": "Remaining: <strong>{filteredEstimate}</strong> of <strong> {estimate}</strong>"
    },
    filteredEstimateLabel: {
        "id": "backlog.card-list.divider.divider-statistics.filtered-estimate-label",
        "defaultMessage": "Estimate: <strong>{filteredEstimate}</strong> of <strong> {estimate}</strong>"
    },
    totalCardsDragIndicatorIssueTermRefresh: {
        "id": "backlog.card-list.divider.divider-statistics.total-cards-drag-indicator-issue-term-refresh",
        "defaultMessage": "{cardAmount} {cardAmount, plural, one {work item} other {work items}}"
    },
    totalCardsIssueTermRefresh: {
        "id": "backlog.card-list.divider.divider-statistics.total-cards-issue-term-refresh",
        "defaultMessage": "{cardAmount} {cardAmount, plural, one {work item} other {work items}}"
    },
    filteredAmountCardsIssueTermRefresh: {
        "id": "backlog.card-list.divider.divider-statistics.filtered-amount-cards-issue-term-refresh",
        "defaultMessage": "{filteredIssues} of {cardAmount} {cardAmount, plural, one {work item} other {work items}} visible"
    }
});

});

parcelRegister("6diJT", function(module, exports) {

$parcel$export(module.exports, "getTotalIssues", () => $ca06649e502e40d5$export$ccdde37230173dca);
$parcel$export(module.exports, "useFilteredIssueCount", () => $ca06649e502e40d5$export$e00b7e9864c0aea);
$parcel$export(module.exports, "getRemainingEstimate", () => $ca06649e502e40d5$export$f7a6085461cb8569);
$parcel$export(module.exports, "useFilteredRemainingEstimate", () => $ca06649e502e40d5$export$c02472649cbf065e);
$parcel$export(module.exports, "useFormatEstimationValue", () => $ca06649e502e40d5$export$272fec22eab6d7a0);
$parcel$export(module.exports, "useFormatTimeTrackingValue", () => $ca06649e502e40d5$export$4098419827dc90d2);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $g4tDr = parcelRequire("g4tDr");

var $etKNj = parcelRequire("etKNj");

var $cL3Uo = parcelRequire("cL3Uo");

var $guzeq = parcelRequire("guzeq");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $e5nhF = parcelRequire("e5nhF");

var $45Qwd = parcelRequire("45Qwd");
function $ca06649e502e40d5$export$a9dc09a05e35644a(state, { cardListId: cardListId, dropIndicator: dropIndicator }) {
    const cardIds = (0, $e5nhF.getEntities)(state).cardOrder[cardListId] ?? [];
    if (!dropIndicator) return cardIds;
    const cardListOrder = (0, $e5nhF.getEntities)(state).cardListOrder ?? [];
    const filteredCards = (0, $dGljH.getFilteredOrderedCardIdsByCardListId)(state)[cardListId] ?? [];
    const targetListIndex = cardListOrder.indexOf(dropIndicator.droppingOverCardListId);
    const sourceListIndex = cardListOrder.indexOf(cardListId);
    // When dragging up into a previous list
    if (targetListIndex < sourceListIndex) return cardIds.filter((cardId)=>filteredCards.includes(cardId) === false);
    if (dropIndicator.droppingOverCardListId === cardListId) {
        const { droppingOverCardId: droppingOverCardId, edge: edge } = dropIndicator;
        const targetIndex = filteredCards?.indexOf(droppingOverCardId);
        const limitIndex = edge === 'bottom' ? targetIndex + 1 : targetIndex;
        const cardsToInclude = new Set(filteredCards.slice(0, limitIndex));
        const filteredCardsSet = new Set(filteredCards);
        return cardIds.filter((cardId)=>filteredCardsSet.has(cardId) === false || cardsToInclude.has(cardId));
    }
    const { droppingOverCardId: droppingOverCardId, edge: edge } = dropIndicator;
    const targetListCardIds = (0, $dGljH.getFilteredOrderedCardIdsByCardListId)(state)[dropIndicator.droppingOverCardListId] ?? [];
    const targetIndex = targetListCardIds?.indexOf(droppingOverCardId);
    const limitIndex = edge === 'bottom' ? targetIndex + 1 : targetIndex;
    const extraCards = targetListCardIds.slice(0, limitIndex);
    const betweenListsCardIds = cardListOrder.slice(sourceListIndex + 1, targetListIndex).flatMap((listId)=>(0, $dGljH.getFilteredOrderedCardIdsByCardListId)(state)[listId]);
    return cardIds.concat(betweenListsCardIds).concat(extraCards);
}
function $ca06649e502e40d5$export$ccdde37230173dca(state, { cardListId: cardListId, dropIndicator: dropIndicator }) {
    const dividerCardIds = $ca06649e502e40d5$export$a9dc09a05e35644a(state, {
        cardListId: cardListId,
        dropIndicator: dropIndicator
    });
    const cards = dividerCardIds.map((cardId)=>(0, $e5nhF.getEntities)(state).card[cardId]);
    const dividerCardIdsExcludingSubtasks = cards.filter((card)=>!(0, $g4tDr.isSubtaskHierarchyLevel)(card.typeHierarchyLevel)).map((card)=>card.id);
    return dividerCardIdsExcludingSubtasks.length;
}
const $ca06649e502e40d5$export$e00b7e9864c0aea = (cardListId)=>{
    const cardIds = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.getFilteredOrderedCardIdsByCardListId)(state)[cardListId]) || [];
    const allCards = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCards));
    const cardIdsExcludingSubtasks = cardIds.filter((cardId)=>{
        const card = allCards[cardId];
        return !(0, $g4tDr.isSubtaskHierarchyLevel)(card.typeHierarchyLevel);
    });
    return cardIdsExcludingSubtasks?.length ?? 0;
};
function $ca06649e502e40d5$export$20385ed8ed7319fa(card) {
    if (card.isDone) return {
        storyPoints: 0,
        originalTimeEstimate: 0,
        remainingTimeEstimate: 0
    };
    return {
        storyPoints: card.estimate?.storyPoints ?? 0,
        originalTimeEstimate: card.estimate?.originalEstimate?.value ?? 0,
        remainingTimeEstimate: card.estimate?.timeRemainingEstimate?.value ?? 0
    };
}
function $ca06649e502e40d5$export$f7a6085461cb8569(state, { cardListId: cardListId, dropIndicator: dropIndicator }) {
    const cardIds = $ca06649e502e40d5$export$a9dc09a05e35644a(state, {
        cardListId: cardListId,
        dropIndicator: dropIndicator
    });
    const cards = cardIds.map((cardId)=>(0, $e5nhF.getEntities)(state).card[cardId]);
    const estimates = cards.map((card)=>$ca06649e502e40d5$export$20385ed8ed7319fa(card));
    return estimates.reduce((acc, { storyPoints: storyPoints, originalTimeEstimate: originalTimeEstimate, remainingTimeEstimate: remainingTimeEstimate })=>({
            totalIssues: acc.totalIssues + 1,
            storyPoints: acc.storyPoints + storyPoints,
            originalTimeEstimate: acc.originalTimeEstimate + originalTimeEstimate,
            remainingTimeEstimate: acc.remainingTimeEstimate + remainingTimeEstimate
        }), {
        storyPoints: 0,
        originalTimeEstimate: 0,
        remainingTimeEstimate: 0,
        totalIssues: 0
    });
}
function $ca06649e502e40d5$export$c02472649cbf065e(cardListId) {
    const cardIds = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.getFilteredOrderedCardIdsByCardListId)(state)[cardListId] ?? []);
    const allCards = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCards));
    return (0, $5uXOq.useMemo)(()=>{
        const cards = cardIds.map((cardId)=>allCards[cardId]);
        const estimates = cards.map((card)=>$ca06649e502e40d5$export$20385ed8ed7319fa(card));
        return estimates.reduce((acc, { storyPoints: storyPoints, originalTimeEstimate: originalTimeEstimate, remainingTimeEstimate: remainingTimeEstimate })=>({
                totalIssues: acc.totalIssues + 1,
                storyPoints: acc.storyPoints + storyPoints,
                originalTimeEstimate: acc.originalTimeEstimate + originalTimeEstimate,
                remainingTimeEstimate: acc.remainingTimeEstimate + remainingTimeEstimate
            }), {
            storyPoints: 0,
            originalTimeEstimate: 0,
            remainingTimeEstimate: 0,
            totalIssues: 0
        });
    }, [
        cardIds,
        allCards
    ]);
}
function $ca06649e502e40d5$export$272fec22eab6d7a0() {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const timeTrackingOptions = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getTimeTrackingOptions));
    const estimationType = (0, $c1MAf.useBacklogSelector)((0, $45Qwd.getEstimationType));
    const formatStoryPointsTotal = (0, $cL3Uo.useFormatStoryPointsTotal)();
    return (value)=>{
        if (estimationType === (0, $guzeq.ORIGINAL_ESTIMATE)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return (0, $etKNj.timeTrackingFormatter)(value, timeTrackingOptions, {
            formatMessage: formatMessage
        });
        return formatStoryPointsTotal(value);
    };
}
const $ca06649e502e40d5$export$4098419827dc90d2 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const timeTrackingOptions = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getTimeTrackingOptions));
    return (value)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $etKNj.timeTrackingFormatter)(value, timeTrackingOptions, {
            formatMessage: formatMessage
        });
};

});
parcelRegister("cL3Uo", function(module, exports) {

$parcel$export(module.exports, "useFormatStoryPointsTotal", () => $027176c8dd096f8f$export$1d30858fcd85be3);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");
const $027176c8dd096f8f$export$1d30858fcd85be3 = ()=>{
    const { formatNumber: formatNumber } = (0, $koVbs.default)();
    // fix for floating point math issues (like 0.1 + 0.2 becomes 0.30000000000000004)
    // as the numbers end with lots of zeroes followed by a single digit, trimming
    // after 8 decimal points results in a sane representation
    return (0, $5uXOq.useCallback)((total)=>formatNumber(total, {
            maximumFractionDigits: 8
        }), [
        formatNumber
    ]);
};

});




parcelRegister("lzKXg", function(module, exports) {

$parcel$export(module.exports, "useDraggableCard", () => $7af680f370d0a17c$export$ee9f6369c1b523a9);
/**
 * This module implements the view handling of drag-and-drop for cards on the backlog.
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $gccSB = parcelRequire("gccSB");

var $8Rkzz = parcelRequire("8Rkzz");

var $biEfA = parcelRequire("biEfA");

var $4hDdm = parcelRequire("4hDdm");

var $7gWdR = parcelRequire("7gWdR");
parcelRequire("2Uxmu");
var $hJNa8 = parcelRequire("hJNa8");
parcelRequire("erBEN");
var $kpXwZ = parcelRequire("kpXwZ");

var $g4tDr = parcelRequire("g4tDr");

var $1fZVH = parcelRequire("1fZVH");

var $4R6GH = parcelRequire("4R6GH");

var $ctrpc = parcelRequire("ctrpc");

var $8ikZj = parcelRequire("8ikZj");

var $2NMNM = parcelRequire("2NMNM");

var $lowQN = parcelRequire("lowQN");

var $2lpqS = parcelRequire("2lpqS");


var $a7yHf = parcelRequire("a7yHf");

var $6GNN7 = parcelRequire("6GNN7");

var $eMLHT = parcelRequire("eMLHT");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $4VAKv = parcelRequire("4VAKv");

var $cYzNd = parcelRequire("cYzNd");

var $jyQw0 = parcelRequire("jyQw0");

var $kPjMF = parcelRequire("kPjMF");

var $fivuU = parcelRequire("fivuU");
function $7af680f370d0a17c$export$3e7309cd70331d59({ args: args, into: { cardId: cardId, cardParentId: cardParentId, cardIsSubtask: cardIsSubtask, cardIndex: cardIndex, cardOrderList: cardOrderList, cards: cards }, isAllSelectedSiblingSubtasks: isAllSelectedSiblingSubtasks, isAnySelectedOrphanedSubtask: isAnySelectedOrphanedSubtask }) {
    if (args.source.data.type === 'DIVIDER') return !cardIsSubtask;
    if (args.source.data.type !== (0, $b6a5a61e3f2f3f09$export$4d4e6ab48cd5be5b)) return false;
    if (args.source.data.cardId === cardId) return false;
    if (!args.source.data.cardIsSubtask && cardOrderList.length === 1) return true;
    // ? Parent is in list and next card is subtask and has same parent
    if (cardIsSubtask && args.source.data.cardIsSubtask === false && cardOrderList.find((id)=>id === cardParentId)) return !((0, $g4tDr.isSubtaskHierarchyLevel)(cards[cardOrderList[cardIndex + 1]]?.typeHierarchyLevel) && cardParentId === cards[cardOrderList[cardIndex + 1]]?.parentId);
    // ? Parent is not in list and prev and next card is subtask
    if (cardIsSubtask && args.source.data.cardIsSubtask === false && cardOrderList.find((id)=>id === cardParentId) === undefined) return !((0, $g4tDr.isSubtaskHierarchyLevel)(cards[cardOrderList[cardIndex - 1]]?.typeHierarchyLevel) && (0, $g4tDr.isSubtaskHierarchyLevel)(cards[cardOrderList[cardIndex + 1]]?.typeHierarchyLevel) && cardParentId === cards[cardOrderList[cardIndex - 1]]?.parentId && cardParentId === cards[cardOrderList[cardIndex + 1]]?.parentId);
    // rerank within parent card group if only subtasks within that group are selected
    if (cardIsSubtask) return args.source.data.cardParentId === cardParentId && isAllSelectedSiblingSubtasks;
    return !isAnySelectedOrphanedSubtask;
}
function $7af680f370d0a17c$export$e2e8fa6a19b7160b({ isCmpKanban: isCmpKanban, isAnySelectedOrphanedSubtask: isAnySelectedOrphanedSubtask, isAllSelectedSiblingSubtasks: isAllSelectedSiblingSubtasks }) {
    if (isCmpKanban) return true;
    // disable drag if orphaned subtasks have been selected with other cards
    return !(isAnySelectedOrphanedSubtask && !isAllSelectedSiblingSubtasks);
}
function $7af680f370d0a17c$export$d195ad1a96bdcc9b({ isCmpKanban: isCmpKanban, isAnySelectedOrphanedSubtask: isAnySelectedOrphanedSubtask, isInvalidDropTarget: isInvalidDropTarget }) {
    return !isCmpKanban && isAnySelectedOrphanedSubtask && isInvalidDropTarget;
}
function $7af680f370d0a17c$export$c20a17931b5f1f2d({ source: source, into: into, orderedCardIds: orderedCardIds, cards: cards, isAnySelectedOrphanedSubtask: isAnySelectedOrphanedSubtask, isAllSelectedSiblingSubtasks: isAllSelectedSiblingSubtasks, isCmpKanban: isCmpKanban }) {
    const intoCard = cards[orderedCardIds[into.index]];
    // Cards above and under the *target* card
    const intoCardTop = cards[orderedCardIds[into.index - 1]];
    const intoCardBottom = cards[orderedCardIds[into.index + 1]];
    // Dragging sub-task alone or with its own siblings onto its parent group
    if (source.isSubtask && !into.isSubtask && source.parentId === intoCard?.id && isAllSelectedSiblingSubtasks) return into.isCollapsed ? [] : [
        'bottom'
    ];
    // Dragging sub-task into any of its siblings
    if (source.isSubtask && into.isSubtask && source.parentId === into.parentId) return [
        'top',
        'bottom'
    ];
    // Can't drag sub-task on other cases if their parent isn't also selected
    if (source.isSubtask && isAnySelectedOrphanedSubtask) return [];
    if (isAnySelectedOrphanedSubtask && !isAllSelectedSiblingSubtasks && !isCmpKanban) return [];
    // Dragging task into a parent group
    const isDroppingIntoParentAttachedToGroup = !into.isSubtask && intoCardBottom?.parentId === intoCard?.id && !into.isCollapsed;
    if (isDroppingIntoParentAttachedToGroup) return [
        'top'
    ];
    // Test function for if a card is the same "card group" as the target
    const isSameGroup = (cardToTest)=>{
        if (cardToTest?.id === into.parentId) return true;
        if (cardToTest && (0, $g4tDr.isSubtaskHierarchyLevel)(cardToTest.typeHierarchyLevel) && cardToTest?.parentId === into.parentId) return true;
        return false;
    };
    // Dragging task into a detached sub-task group's first card
    // * target is sub-task
    // * card above it is not or is missing
    // * card above it is not this card's parent
    // This is the "first sub-task in a group without parent"
    const isDetachedSubtaskTopCard = into.isSubtask && !isSameGroup(intoCardTop);
    if (isDetachedSubtaskTopCard) return [
        'top'
    ];
    // This is the "last sub-task in a group with or without parent"
    const isBottomSubtask = into.isSubtask && !isSameGroup(intoCardBottom);
    if (isBottomSubtask) return [
        'bottom'
    ];
    // Dragging task into another task
    return into.isSubtask ? [] : [
        'bottom',
        'top'
    ];
}
function $7af680f370d0a17c$export$ee9f6369c1b523a9({ elementRef: elementRef, cardId: cardId, cardListId: cardListId }) {
    const [dragState, setDragState] = (0, $5uXOq.useState)({
        type: 'idle'
    });
    const [dropState, setDropState] = (0, $5uXOq.useState)(null);
    const selectSingleCard = (0, $cYzNd.useSelectSingleCard)();
    const cards = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCards));
    const card = cards[cardId];
    const cardListKeys = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCardListsKeys));
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const cardOrderList = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getOrderedCardIdsByCardListId));
    const getIsParentExpanded = (0, $c1MAf.useBacklogSelector)((0, $dGljH.makeGetCardGroupExpanded));
    const autobatch = (0, $1fZVH.useAutobatch)();
    const selectedCards = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getSelectedCards));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isAnySelectedOrphanedSubtask = (0, $c1MAf.useBacklogSelector)((0, $4VAKv.makeIsAnySelectedOrphanedSubtasks));
    const isAllSelectedSiblingSubtasks = (0, $c1MAf.useBacklogSelector)((0, $4VAKv.makeIsAllSelectedSiblingSubtasks));
    const isCmpKanban = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.isCmpKanbanProject));
    const moveCards = (0, $jyQw0.useSimplyMoveCards)();
    const { fireEndEvent: fireEndEvent } = (0, $4R6GH.fg)('one_event_rules_them_all_fg') ? (0, $fivuU.useSprintEndAnalytics)() : {
        fireEndEvent: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    };
    (0, $5uXOq.useEffect)(()=>{
        if (!elementRef.current) return undefined;
        if (!card) return undefined;
        const cardParentId = card.parentId;
        const cardIsSubtask = (0, $g4tDr.isSubtaskHierarchyLevel)(card.typeHierarchyLevel);
        const cardIndex = cardOrderList[cardListId].indexOf(cardId);
        return (0, $4hDdm.combine)((0, $7gWdR.draggable)({
            element: elementRef.current,
            getInitialData: ()=>({
                    type: (0, $b6a5a61e3f2f3f09$export$4d4e6ab48cd5be5b),
                    cardId: cardId,
                    cardIsSubtask: cardIsSubtask,
                    cardParentId: cardParentId,
                    cardListId: cardListId
                }),
            onDragStart: ()=>{
                autobatch(()=>{
                    selectSingleCard(cardId);
                    const sourceCardGroupType = cardIsSubtask === true && cardListId && cardParentId ? (0, $lowQN.createCardGroupDroppableId)(cardParentId, cardListId) : (0, $2lpqS.CARD_LIST_DROPPABLE_TYPE);
                    dispatch((0, $eMLHT.beforeCapture)(sourceCardGroupType, cardListId, cardIsSubtask, cardParentId ?? undefined));
                    dispatch((0, $a7yHf.cardListDragStart)(cardListKeys, cardListId, cardParentId ? `${cardParentId}-${cardListId}` : undefined));
                    dispatch((0, $eMLHT.dragStart)());
                    if (selectedCards.length === 1 && (0, $4R6GH.fg)('one_event_rules_them_all_fg')) (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsStart((0, $8ikZj.DRAG_DROP_UNKNOWN_FIELD_ID), {
                        analytics: createAnalyticsEvent({}),
                        attributes: {
                            fieldType: (0, $8ikZj.DRAG_DROP_UNKNOWN_FIELD_ID),
                            isDragEditing: true,
                            ...(0, $4R6GH.fg)('one_event_improvements_1') && {
                                issueId: cardId
                            }
                        }
                    });
                });
            },
            onDrop: (_args)=>{
                autobatch(()=>{
                    const isInvalidDropTarget = (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(_args.location.current.dropTargets);
                    const showHelperFunction = $7af680f370d0a17c$export$d195ad1a96bdcc9b({
                        isCmpKanban: isCmpKanban,
                        isAnySelectedOrphanedSubtask: isAnySelectedOrphanedSubtask,
                        isInvalidDropTarget: isInvalidDropTarget
                    });
                    if (showHelperFunction) dispatch((0, $6GNN7.cardDragDisallowed)());
                    if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) {
                        const dropTarget = _args.location.current.dropTargets[0];
                        const isCardMoved = dropTarget?.data.type === (0, $b6a5a61e3f2f3f09$export$4d4e6ab48cd5be5b);
                        if (isCardMoved) {
                            const destinationCardListId = String(dropTarget.data.cardListId);
                            fireEndEvent(selectedCards, cardListId, destinationCardListId);
                        }
                    }
                    setDragState({
                        type: 'idle'
                    });
                    dispatch((0, $a7yHf.cardListDragEnd)());
                });
            },
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                (0, $kpXwZ.setCustomNativeDragPreview)({
                    getOffset: (0, $hJNa8.pointerOutsideOfPreview)({
                        x: '8px',
                        y: '8px'
                    }),
                    render ({ container: container }) {
                        setDragState({
                            type: 'dragging',
                            container: container
                        });
                        return ()=>setDragState({
                                type: 'idle'
                            });
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            }
        }), (0, $7gWdR.dropTargetForElements)({
            element: elementRef.current,
            getIsSticky: ()=>true,
            getData: ({ input: input, element: element, source: source })=>{
                const data = {
                    type: (0, $b6a5a61e3f2f3f09$export$4d4e6ab48cd5be5b),
                    cardId: cardId,
                    cardListId: cardListId
                };
                const allowedEdges = $7af680f370d0a17c$export$c20a17931b5f1f2d({
                    source: {
                        isSubtask: Boolean(source.data.cardIsSubtask),
                        cardId: Number(source.data.cardId),
                        parentId: source.data.cardParentId != null ? Number(source.data.cardParentId) : null
                    },
                    into: {
                        index: cardIndex,
                        isSubtask: cardIsSubtask,
                        cardId: cardId,
                        parentId: cardParentId,
                        isCollapsed: !getIsParentExpanded(cardId)
                    },
                    orderedCardIds: cardOrderList[cardListId],
                    cards: cards,
                    isAnySelectedOrphanedSubtask: isAnySelectedOrphanedSubtask,
                    isAllSelectedSiblingSubtasks: isAllSelectedSiblingSubtasks,
                    isCmpKanban: isCmpKanban
                });
                return (0, $biEfA.attachClosestEdge)(data, {
                    input: input,
                    element: element,
                    allowedEdges: allowedEdges
                });
            },
            onDrag: (args)=>{
                autobatch(()=>{
                    if (args.source.data.cardId !== cardId) {
                        const edge = (0, $biEfA.extractClosestEdge)(args.self.data);
                        setDropState(edge && {
                            edge: edge,
                            cardListIfDivider: args.source.data.type === 'DIVIDER' ? String(args.source.data.cardListId) : null
                        });
                    }
                });
            },
            onDragEnter: (args)=>{
                autobatch(()=>{
                    if (args.source.data.cardId !== cardId) {
                        const edge = (0, $biEfA.extractClosestEdge)(args.self.data);
                        setDropState(edge && {
                            edge: edge,
                            cardListIfDivider: args.source.data.type === 'DIVIDER' ? String(args.self.data.cardListId) : null
                        });
                    }
                });
            },
            onDragLeave: (_args)=>{
                autobatch(()=>{
                    setDropState(null);
                });
            },
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onDropTargetChange: (_args)=>{},
            canDrop: (args)=>$7af680f370d0a17c$export$3e7309cd70331d59({
                    args: args,
                    into: {
                        cardId: cardId,
                        cardParentId: cardParentId,
                        cardIsSubtask: cardIsSubtask,
                        cardIndex: cardIndex,
                        cardOrderList: cardOrderList[cardListId],
                        cards: cards
                    },
                    isAllSelectedSiblingSubtasks: isAllSelectedSiblingSubtasks,
                    isAnySelectedOrphanedSubtask: isAnySelectedOrphanedSubtask
                }),
            onDrop: (args)=>{
                autobatch(()=>{
                    const location = {
                        type: dropState?.edge === 'top' ? 'before' : 'after',
                        target: cardId
                    };
                    if (args.source.data.type === 'DIVIDER') moveCards({
                        source: {
                            type: 'divider',
                            cardListId: String(args.source.data.cardListId)
                        },
                        location: location
                    });
                    if (args.source.data.type === (0, $b6a5a61e3f2f3f09$export$4d4e6ab48cd5be5b)) moveCards({
                        source: {
                            cardId: Number(args.source.data.cardId)
                        },
                        location: location
                    });
                    setDropState(null);
                    dispatch((0, $eMLHT.dragEnd)());
                });
            }
        }));
    }, [
        card,
        cardId,
        cardListId,
        dispatch,
        moveCards,
        dropState?.edge,
        elementRef,
        selectSingleCard,
        cardListKeys,
        cardOrderList,
        cards,
        getIsParentExpanded,
        autobatch,
        isAnySelectedOrphanedSubtask,
        isAllSelectedSiblingSubtasks,
        isCmpKanban,
        selectedCards.length,
        createAnalyticsEvent,
        fireEndEvent,
        dropState,
        selectedCards
    ]);
    return {
        isDragging: dragState.type === 'dragging',
        dragPreview: dragState.type === 'dragging' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kPjMF.CardDragPreview), {
            id: cardId
        }), dragState.container) : null,
        closestEdge: dropState?.edge ?? null,
        dropState: dropState
    };
}

});
parcelRegister("lowQN", function(module, exports) {

$parcel$export(module.exports, "createCardGroupDroppableId", () => $109391da4a112ce1$export$307280e35e15ee59);

var $2lpqS = parcelRequire("2lpqS");
const $109391da4a112ce1$export$307280e35e15ee59 = (parentId, cardListId)=>`${0, $2lpqS.CARD_GROUP_DROPPABLE_TYPE}::${parentId}::${cardListId}`;
const $109391da4a112ce1$export$241ac0b55520e68e = (droppableId)=>{
    const [prefix, parentId, cardListId] = droppableId.split('::');
    if (prefix === (0, $2lpqS.CARD_GROUP_DROPPABLE_TYPE) && parentId && cardListId) return {
        parentId: Number(parentId),
        cardListId: cardListId
    };
    return null;
};

});

parcelRegister("cYzNd", function(module, exports) {

$parcel$export(module.exports, "useSelectSingleCard", () => $9139c3fc9e0d318a$export$a8cb27a008b03fe0);

var $7D59a = parcelRequire("7D59a");

var $4mqko = parcelRequire("4mqko");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");
function $9139c3fc9e0d318a$export$a8cb27a008b03fe0() {
    const selectedCards = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getSelectedCards));
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    return (0, $7D59a.useEvent)((cardId)=>{
        if (!selectedCards.includes(cardId)) dispatch((0, $4mqko.cardSingleSelect)(cardId));
    });
}

});

parcelRegister("kPjMF", function(module, exports) {

$parcel$export(module.exports, "CardDragPreview", () => $d6f6f8f102e59d9e$export$4b9ac0eff1e3aa75);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $gFfOq = parcelRequire("gFfOq");
function $d6f6f8f102e59d9e$export$4b9ac0eff1e3aa75({ id: id }) {
    const isCmpKanbanBacklog = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.isCmpKanbanProject));
    const getDraggingCardIds = (0, $c1MAf.useBacklogSelector)((0, $dGljH.makeGetDraggingCardIds));
    const getChildIdsByParentId = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getChildIdsByParentIdSelector));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d6f6f8f102e59d9e$var$CardDragPreviewContainer, null, getDraggingCardIds(id).slice(0, 5).map((contentsId, index)=>{
        const subtaskIds = isCmpKanbanBacklog ? [] : getChildIdsByParentId[contentsId];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gFfOq.default), {
            id: contentsId,
            key: contentsId,
            canShowStatus: false,
            isDragging: index === 0,
            isDragHandle: true,
            shouldRenderRichCard: false,
            isAttachedToParent: false,
            subtaskIds: subtaskIds
        });
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d6f6f8f102e59d9e$var$CardDragPreviewContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _p12fgx0z",
            __cmplp.className
        ])
    });
});

});

parcelRegister("fivuU", function(module, exports) {

$parcel$export(module.exports, "useSprintEndAnalytics", () => $a73e9b67baf4f6f1$export$3d104c374c073ba0);

var $5uXOq = parcelRequire("5uXOq");

var $8ikZj = parcelRequire("8ikZj");

var $ctrpc = parcelRequire("ctrpc");

var $5fc53 = parcelRequire("5fc53");

var $2NMNM = parcelRequire("2NMNM");

var $4R6GH = parcelRequire("4R6GH");

var $k35me = parcelRequire("k35me");

var $c1MAf = parcelRequire("c1MAf");

var $f01qr = parcelRequire("f01qr");
const $a73e9b67baf4f6f1$export$3d104c374c073ba0 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const getIsActiveSprint = (0, $c1MAf.useBacklogSelector)((0, $k35me.makeIsCardListActiveSprint));
    const fireEndEvent = (0, $5uXOq.useCallback)((selectedCards, sourceCardListId, destinationCardListId)=>{
        if (selectedCards.length !== 1) return;
        const actionTaken = (0, $f01qr.getEndAnalyticsSprintActionTaken)(sourceCardListId, destinationCardListId);
        if (!actionTaken) {
            (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd((0, $8ikZj.DRAG_DROP_UNKNOWN_FIELD_ID), {
                analytics: createAnalyticsEvent({}),
                attributes: {
                    fieldType: (0, $5fc53.SPRINT_TYPE),
                    fieldKey: (0, $8ikZj.FIELD_TYPE_MAP)[0, $5fc53.SPRINT_TYPE],
                    hasRankChanged: true,
                    isDragEditing: true,
                    ...(0, $4R6GH.fg)('one_event_improvements_1') && {
                        issueId: selectedCards[0]
                    }
                }
            });
            return;
        }
        const isToActiveSprint = getIsActiveSprint(destinationCardListId);
        const isFromActiveSprint = getIsActiveSprint(sourceCardListId || '');
        if (isFromActiveSprint || isToActiveSprint) // end analytics will fire at modal confirm
        return;
        (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd((0, $8ikZj.DRAG_DROP_UNKNOWN_FIELD_ID), {
            analytics: createAnalyticsEvent({}),
            attributes: {
                fieldKey: (0, $8ikZj.FIELD_TYPE_MAP)[0, $5fc53.SPRINT_TYPE],
                fieldType: (0, $5fc53.SPRINT_TYPE),
                isDragEditing: true,
                actionTaken: actionTaken,
                ...(0, $4R6GH.fg)('one_event_improvements_1') && {
                    issueId: selectedCards[0]
                }
            }
        });
    }, [
        createAnalyticsEvent,
        getIsActiveSprint
    ]);
    return {
        fireEndEvent: fireEndEvent
    };
};

});



parcelRegister("1hEu3", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffe4a2ecb92b3234$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $9dZ1c = parcelRequire("9dZ1c");

var $bSSG7 = parcelRequire("bSSG7");


var $h1sEN = parcelRequire("h1sEN");

var $hIWd8 = parcelRequire("hIWd8");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dCm1o = parcelRequire("dCm1o");

var $4mO32 = parcelRequire("4mO32");

var $7XluA = parcelRequire("7XluA");

var $kuJWB = parcelRequire("kuJWB");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $6s1PB = parcelRequire("6s1PB");


var $jOXuX = parcelRequire("jOXuX");

var $18zd0 = parcelRequire("18zd0");

var $atbUC = parcelRequire("atbUC");


var $1jxD5 = parcelRequire("1jxD5");

var $10Ngv = parcelRequire("10Ngv");


var $hf5c2 = parcelRequire("hf5c2");

var $9tZuw = parcelRequire("9tZuw");

var $7zF3i = parcelRequire("7zF3i");

var $5Eoed = parcelRequire("5Eoed");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $3QmBe = parcelRequire("3QmBe");

var $74oBv = parcelRequire("74oBv");

var $dGljH = parcelRequire("dGljH");

var $l9VFH = parcelRequire("l9VFH");

var $aU3CO = parcelRequire("aU3CO");

var $fmuR9 = parcelRequire("fmuR9");

var $1z1J7 = parcelRequire("1z1J7");

var $2iHbn = parcelRequire("2iHbn");

var $aXMy2 = parcelRequire("aXMy2");

var $fFWk3 = parcelRequire("fFWk3");

var $kWseG = parcelRequire("kWseG");

var $fJ5Eq = parcelRequire("fJ5Eq");

var $231hY = parcelRequire("231hY");

var $8mHuU = parcelRequire("8mHuU");

var $2prwO = parcelRequire("2prwO");
// Not ideal, but have to do it for now to react backwards compatibility with current ICC.
let $ffe4a2ecb92b3234$var$lastCardId = 0;
const $ffe4a2ecb92b3234$var$generateId = ()=>{
    $ffe4a2ecb92b3234$var$lastCardId -= 1;
    return $ffe4a2ecb92b3234$var$lastCardId;
};
const $ffe4a2ecb92b3234$var$StyledTypeSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const isCompanyManaged = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ffe4a2ecb92b3234$var$TypeSelectWrapper, {
        shouldShowChevron: isCompanyManaged,
        isVisualRefresh: (0, $dCm1o.isVisualRefreshEnabled)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h1sEN.default), {
        ...props,
        ref: ref
    }));
});
const $ffe4a2ecb92b3234$var$localStorage = (0, $bSSG7.createLocalStorageProvider)('backlog');
const $ffe4a2ecb92b3234$var$SELECTED_ISSUE_TYPE_KEY = 'selectedIssueType';
const $ffe4a2ecb92b3234$var$InlineCardCreate = ({ isBetweenCards: isBetweenCards = false, isOpenByDefault: isOpenByDefault = false, messages: messages, insertBefore: insertBefore = null, listId: listId, placeholderText: placeholderText = '', triggerLabel: triggerLabel = '', ariaLabelledBy: ariaLabelledBy, isFormVisible: isFormVisibleProp, onSetAiWorkCreatePanelSubject: onSetAiWorkCreatePanelSubject, isFocusMovedToAiPanel: isFocusMovedToAiPanel, isFirstList: isFirstList, isBacklogCardList: isBacklogCardList })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const initialCardTypes = (0, $c1MAf.useBacklogSelector)((0, $aU3CO.getCardTypesForICC));
    const parentId = (0, $c1MAf.useBacklogSelector)((0, $3QmBe.getLastAppliedParentFilters));
    const manageIssueTypesLink = (0, $c1MAf.useBacklogSelector)((state)=>{
        if ((0, $1z1J7.canEditBoardConfig)(state)) return (0, $74oBv.manageIssueTypesSelector)(state);
        return null;
    });
    const enabledFilters = (0, $c1MAf.useBacklogSelector)((0, $l9VFH.getFilters));
    const hasICCOpen = (0, $c1MAf.useBacklogSelector)((state)=>insertBefore != null ? (0, $dGljH.hasICCOpen)(state, {
            cardId: insertBefore
        }) : false);
    const issueParents = (0, $c1MAf.useBacklogSelector)((state)=>(0, $fmuR9.issueParentsSelector)(state));
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const { storeFieldsFromCardCreateData: storeFieldsFromCardCreateData, storeFieldsFromFetchIssuesData: storeFieldsFromFetchIssuesData } = (0, $10Ngv.useStoreFields)({
        issueParents: issueParents
    });
    const isCompanyManaged = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
    const isBoardCrossProject = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsBoardCrossProject));
    const inlineCreateSessionId = (0, $c1MAf.useBacklogSelector)((0, $aU3CO.getInlineCreateSessionId));
    const defaultCardTypeId = $ffe4a2ecb92b3234$var$localStorage.get($ffe4a2ecb92b3234$var$SELECTED_ISSUE_TYPE_KEY) || null;
    const hasEditBoardConfigPermission = (0, $c1MAf.useBacklogSelector)((state)=>(0, $1z1J7.canEditBoardConfig)(state));
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $kuJWB.SmartLinkEditorEntryPointComponent), {});
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)(); // @deprecated Use `source` from `useAiWorkCreatePanelEntryPoint` instead
    const [accessibleConfluenceLink, setAccessibleConfluenceLink] = (0, $5uXOq.useState)(undefined);
    let isAiEnabled = false;
    if ((0, $4R6GH.fg)('ai_powered_backlog_inline_create_gate')) {
        if ((0, $4R6GH.fg)('crocs-load_ai_enablement_in_backlog_router')) // eslint-disable-next-line react-hooks/rules-of-hooks
        isAiEnabled = Boolean((0, $1jxD5.useAiEntitlementResource)()?.data?.isAiEnabledForJiraSoftware);
        else // eslint-disable-next-line react-hooks/rules-of-hooks
        isAiEnabled = (0, $2iHbn.useIsAiEnabledBacklog)();
    }
    const shouldShowAiBacklogInlineCreate = isAiEnabled && !isBetweenCards && (0, $4R6GH.fg)('ai_powered_backlog_inline_create_gate') && // enable to BACKLOG card list, or SPRINT card list when experiment is on
    (listId === 'BACKLOG' || listId !== 'BOARD' && (0, $6s1PB.expValEquals)('ai_powered_backlog_inline_create_iter2', 'isEnabled', true, false));
    const [isPlaceholderLinkPickerOpen, setIsPlaceholderLinkPickerOpen] = (0, $5uXOq.useState)(false);
    const editorApiRef = (0, $5uXOq.useRef)(null); // When the experiment is on, we need to manually manage the form visibility state with callbacks from the hook
    // When the experiment is off, we fallback to existing behavior (isFormVisibleProp) and callbacks (showForm etc) don't do anything
    const { isFormVisible: isFormVisible, showForm: showForm, hideForm: hideForm, shouldSkipFormCloseOnBlur: shouldSkipFormCloseOnBlur } = (0, $4R6GH.fg)('ai_powered_backlog_inline_create_gate') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $231hY.useIsFormVisible)({
        isFocusMovedToAiPanel: isFocusMovedToAiPanel,
        isPlaceholderLinkPickerOpen: isPlaceholderLinkPickerOpen,
        isFormVisibleOverride: isFormVisibleProp,
        isFormVisibleByDefault: isOpenByDefault || hasICCOpen
    }) : {
        isFormVisible: isFormVisibleProp,
        showForm: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        hideForm: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        shouldSkipFormCloseOnBlur: ()=>false
    };
    const { selectedIssueType: selectedIssueTypeForAiPanel, onChangeIssueType: onChangeIssueTypeForAiPanel } = (0, $4R6GH.fg)('ai_powered_backlog_inline_create_gate') // eslint-disable-next-line react-hooks/rules-of-hooks
     ? (0, $fJ5Eq.useSelectedIssueType)({
        defaultCardTypeId: defaultCardTypeId,
        initialCardTypes: initialCardTypes,
        filteredIssueTypes: enabledFilters?.ISSUE_TYPE
    }) : {
        selectedIssueType: initialCardTypes[0],
        onChangeIssueType: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    };
    const { unloadAiWorkCreatePanel: unloadAiWorkCreatePanel, loadAndShowAiWorkCreatePanel: loadAndShowAiWorkCreatePanel, loadAndShowAiWorkCreatePanelForSource: loadAndShowAiWorkCreatePanelForSource, preloadAiWorkCreatePanel: preloadAiWorkCreatePanel } = (0, $4R6GH.fg)('ai_powered_backlog_inline_create_gate') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $kWseG.useAiWorkCreatePanelEntryPoint)({
        selectedIssueType: selectedIssueTypeForAiPanel,
        sourceLink: accessibleConfluenceLink,
        cardListId: listId,
        onSetAiWorkCreatePanelSubject: onSetAiWorkCreatePanelSubject,
        onAllSuggestionsActioned: editorApiRef.current?.clearContent
    }) : {
        unloadAiWorkCreatePanel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        loadAndShowAiWorkCreatePanel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        preloadAiWorkCreatePanel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        loadAndShowAiWorkCreatePanelForSource: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    };
    (0, $5uXOq.useEffect)(()=>{
        if (!isFormVisible && shouldShowAiBacklogInlineCreate && (0, $6s1PB.expValEquals)('ai_powered_backlog_inline_create_iter2', 'isEnabled', false, false) // not in Test cohort
        ) unloadAiWorkCreatePanel();
    }, [
        unloadAiWorkCreatePanel,
        isFormVisible,
        shouldShowAiBacklogInlineCreate
    ]);
    const onAutoOpen = (0, $5uXOq.useCallback)((sessionId)=>{
        // start event for auto open icc
        const startAutoOpenICCAnalyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }); // firing start event for icc that is auto open - same as onTriggerClickCallback
        // @ts-expect-error Second argument should be of format "actionSubject action"
        (0, $8zOmE.fireUIAnalytics)(startAutoOpenICCAnalyticsEvent, 'triggerClicked', 'triggerButton', {
            formWasOpen: isFormVisible,
            triggerAppearance: isBetweenCards ? (0, $7462c685f739ed5a$export$d2f7b3f0efb6e208) : (0, $7462c685f739ed5a$export$dda6912361cddac9),
            sessionId: sessionId,
            isAutoOpen: true
        });
        shouldShowAiBacklogInlineCreate && entryPointActions.load();
        dispatch((0, $7zF3i.setInlineCreateSessionId)({
            sessionId: sessionId
        }));
    }, [
        createAnalyticsEvent,
        dispatch,
        entryPointActions,
        isBetweenCards,
        isFormVisible,
        shouldShowAiBacklogInlineCreate
    ]);
    const onTriggerClick = (sessionId)=>{
        const shouldOpenGICModal = isCompanyManaged && (isBoardCrossProject || !initialCardTypes?.length);
        if (shouldOpenGICModal) {
            const fixVersions = enabledFilters.VERSION || [];
            const cardTypeId = initialCardTypes?.[0]?.id ?? null;
            dispatch((0, $5Eoed.openModal)({
                type: (0, $b107c54ec82f76f2$export$55cae6fd3c958bc5),
                payload: {
                    cardListId: listId,
                    cardParentId: parentId,
                    cardSummary: '',
                    cardTypeId: cardTypeId,
                    rankBeforeCardId: insertBefore,
                    fixVersions: fixVersions,
                    sessionId: inlineCreateSessionId
                }
            }));
        } else {
            // Dispatch session id.
            if (sessionId) dispatch((0, $7zF3i.setInlineCreateSessionId)({
                sessionId: sessionId
            }));
            shouldShowAiBacklogInlineCreate && entryPointActions.load();
            dispatch((0, $9tZuw.setCardIdWithAboveICCOpen)(insertBefore));
        }
        showForm();
    };
    const onCancel = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $9tZuw.setCardIdWithAboveICCOpen)(null));
    }, [
        dispatch
    ]);
    const onCreate = (0, $5uXOq.useCallback)((inlineCards)=>{
        const { cardTypeId: cardTypeId } = inlineCards[0];
        const cardTypeEntity = initialCardTypes.find((ct)=>ct.id === cardTypeId);
        const fixVersions = enabledFilters.VERSION || [];
        const tempIds = inlineCards.map(()=>$ffe4a2ecb92b3234$var$generateId());
        const doesCardTypeHaveRequiredFields = !!cardTypeEntity?.hasRequiredFields;
        if (doesCardTypeHaveRequiredFields) {
            dispatch((0, $5Eoed.openModal)({
                type: (0, $b107c54ec82f76f2$export$55cae6fd3c958bc5),
                payload: {
                    cardListId: listId,
                    cardParentId: parentId,
                    // With requiredfield multiple card creation is disabled
                    cardSummary: inlineCards[0].summary,
                    cardTypeId: Number(cardTypeId),
                    rankBeforeCardId: insertBefore,
                    fixVersions: fixVersions,
                    sessionId: inlineCreateSessionId
                }
            }));
            return;
        } /** Analytics: We indicate to the analytics for issue creation that the inline creation ended up finishing inline creation (With session ID) */ 
        const analyticsEvent = createAnalyticsEvent({
            action: 'created',
            actionSubject: 'issue',
            sessionId: inlineCreateSessionId
        });
        dispatch((0, $hf5c2.cardCreateMultipleRequest)({
            tempIds: tempIds,
            summaries: inlineCards.map((inlineCard)=>inlineCard.summary),
            typeId: Number(cardTypeId),
            typeIcon: cardTypeEntity ? cardTypeEntity.iconUrl : '',
            parentId: parentId,
            fixVersions: fixVersions,
            insertBefore: insertBefore,
            listId: listId,
            storeFieldsFromCardCreateData: storeFieldsFromCardCreateData,
            storeFieldsFromFetchIssuesData: storeFieldsFromFetchIssuesData,
            analyticsEvent: analyticsEvent
        }));
        $ffe4a2ecb92b3234$var$localStorage.set($ffe4a2ecb92b3234$var$SELECTED_ISSUE_TYPE_KEY, cardTypeId);
    }, [
        initialCardTypes,
        enabledFilters.VERSION,
        createAnalyticsEvent,
        dispatch,
        parentId,
        insertBefore,
        listId,
        storeFieldsFromCardCreateData,
        storeFieldsFromFetchIssuesData,
        inlineCreateSessionId
    ]);
    const onBlurWrapper = (0, $5uXOq.useCallback)(()=>{
        // skip only if the experiment is on
        if (shouldShowAiBacklogInlineCreate && shouldSkipFormCloseOnBlur()) return;
        hideForm();
        onCancel();
    }, [
        shouldSkipFormCloseOnBlur,
        shouldShowAiBacklogInlineCreate,
        hideForm,
        onCancel
    ]);
    const onCancelWrapper = (0, $5uXOq.useCallback)(()=>{
        hideForm();
        onCancel();
    }, [
        onCancel,
        hideForm
    ]);
    const onIccCreate = (0, $5uXOq.useCallback)((issues)=>{
        onCreate(issues.map((issue)=>({
                summary: issue.summary,
                cardTypeId: Number(issue.cardTypeId)
            })));
    }, [
        onCreate
    ]);
    const isFormHidden = isCompanyManaged && (isBoardCrossProject || !initialCardTypes?.length);
    const [showAiSuggestButton, setShowAiSuggestButton] = (0, $5uXOq.useState)(false);
    const [editorDocCardState, setEditorDocCardState] = (0, $5uXOq.useState)(undefined); // @deprecated: being replaced by onSuggestFromSource; used in iter1 flow only
    const onSuggest = loadAndShowAiWorkCreatePanel;
    const onSuggestFromSource = (0, $5uXOq.useCallback)((sourceLink)=>{
        loadAndShowAiWorkCreatePanelForSource(sourceLink);
        onCancelWrapper();
    }, [
        loadAndShowAiWorkCreatePanelForSource,
        onCancelWrapper
    ]);
    const preload = ()=>entryPointActions.preload();
    const cancelPreload = ()=>entryPointActions.cancelPreload(); // Lazy loaded for performance, HoverBox contains preload to load editor on intent
    const renderSmartLinkEditor = (0, $5uXOq.useCallback)((props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "smartLinkEditor",
            packageName: "backlog",
            errorFallback: "unmount",
            teamName: "Crocs",
            runtimeProps: {
                ...props,
                accessibleConfluenceLink: accessibleConfluenceLink,
                setAccessibleConfluenceLink: setAccessibleConfluenceLink,
                setShowAiSuggestButton: setShowAiSuggestButton,
                setIsLinkPickerOpen: setIsPlaceholderLinkPickerOpen,
                setEditorDocCardState: setEditorDocCardState,
                showAiSuggestButton: showAiSuggestButton,
                onSuggest: onSuggest,
                editorDocCardState: editorDocCardState,
                isLinkPickerOpen: isPlaceholderLinkPickerOpen,
                editorApiRef: editorApiRef
            }
        });
    }, [
        entryPointReferenceSubject,
        accessibleConfluenceLink,
        showAiSuggestButton,
        onSuggest,
        editorDocCardState,
        isPlaceholderLinkPickerOpen
    ]);
    const renderPlaceholder = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8mHuU.PlaceholderWithLinkPicker), {
            onLinkSelected: onSuggestFromSource,
            setIsLinkPickerOpen: setIsPlaceholderLinkPickerOpen,
            isLinkPickerOpen: isPlaceholderLinkPickerOpen
        }), [
        isPlaceholderLinkPickerOpen,
        onSuggestFromSource
    ]);
    const renderAiSuggestButton = (0, $5uXOq.useCallback)(()=>{
        return showAiSuggestButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fFWk3.AiSuggestButton), {
            onClick: onSuggest
        });
    }, [
        onSuggest,
        showAiSuggestButton
    ]);
    let nudgeId = '';
    const isEligibleIccForBacklogCreateSprintIssueNudge = (0, $jOXuX.isTailoredOnboardingScrumAndSoftwareKanbanEnabled)() && isFirstList && !isBacklogCardList && !isBetweenCards;
    const isEligibleIccForBacklogCreateIssueNudge = (0, $jOXuX.isTailoredOnboardingScrumAndSoftwareKanbanEnabled)() && isBacklogCardList && !isBetweenCards;
    if (isEligibleIccForBacklogCreateIssueNudge) nudgeId = (0, $6784cbc7d62e5d7c$export$64d75060ee6ba425);
    else if (isEligibleIccForBacklogCreateSprintIssueNudge) nudgeId = (0, $6784cbc7d62e5d7c$export$eb64d5f1a091478b);
    const { ref: iccContainerRef } = (0, $9dZ1c.useRegisterNudgeTarget)(nudgeId, // Only register if we're in a valid InlineCardCreate for one of the nudge targets
    (0, $jOXuX.isTailoredOnboardingScrumAndSoftwareKanbanEnabled)() && Boolean(nudgeId));
    const showIssueTypeConfigOptions = !isCompanyManaged && hasEditBoardConfigPermission;
    const shouldLoadICCNudge = !isCompanyManaged || !(0, $4R6GH.fg)('load_icc_nudge_conditionally_on_backlog'); /**
                                                                                                   * When ai_powered_backlog_inline_create_gate is OFF, don't return any values
                                                                                                   * When ai_powered_backlog_inline_create_gate is ON:
                                                                                                   * - ai_powered_backlog_inline_create_iter2 is TEST show placeholder experiment
                                                                                                   * - ai_powered_backlog_inline_create_iter2 is CONTROL show original editor experiment
                                                                                                   */ 
    const getExperimentalAiValues = ()=>{
        if (shouldShowAiBacklogInlineCreate) return (0, $6s1PB.expValEquals)('ai_powered_backlog_inline_create_iter2', 'isEnabled', true, false) ? {
            renderCompactViewPlaceholderExperimental: renderPlaceholder
        } : {
            renderCompactViewEditorExperimental: renderSmartLinkEditor,
            renderCompactViewActionButtonExperimental: renderAiSuggestButton
        };
        return undefined;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isEligibleIccForBacklogCreateIssueNudge && shouldLoadICCNudge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $atbUC.BacklogCreateIssueNudgePortalledAsync), null), isEligibleIccForBacklogCreateSprintIssueNudge && shouldLoadICCNudge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $18zd0.BacklogCreateSprintIssueNudgeAsync), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2prwO.HoverBox), {
        onMouseEnter: preload,
        onMouseLeave: cancelPreload,
        shouldRenderHoverBox: shouldShowAiBacklogInlineCreate,
        onLinkPicked: onSuggestFromSource,
        onLinkPickerMounted: preloadAiWorkCreatePanel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hIWd8.default), {
        cardTypes: initialCardTypes,
        extraItems: manageIssueTypesLink && [
            {
                url: manageIssueTypesLink
            }
        ] || undefined,
        numFilters: Object.keys(enabledFilters).length,
        onCreate: onIccCreate,
        onTriggerClick: onTriggerClick,
        onCancel: onCancelWrapper,
        onBlur: onBlurWrapper,
        appearance: (0, $7462c685f739ed5a$export$db1cdb8627b81f84),
        triggerAppearance: isBetweenCards ? (0, $7462c685f739ed5a$export$d2f7b3f0efb6e208) : (0, $7462c685f739ed5a$export$dda6912361cddac9),
        isFormVisibleDefault: isFormHidden ? false : isOpenByDefault || hasICCOpen,
        messages: messages,
        placeholderText: placeholderText,
        triggerLabel: shouldShowAiBacklogInlineCreate && (!(0, $4R6GH.fg)('ai_powered_backlog_inline_create-create_in_sprint') || isBacklogCardList) ? formatMessage((0, $aXMy2.default).triggerLabelForAiWorkCreate) : triggerLabel,
        ariaLabelledBy: ariaLabelledBy,
        defaultCardTypeId: defaultCardTypeId,
        isFormVisible: isFormHidden ? false : isFormVisible,
        TypeSelect: $ffe4a2ecb92b3234$var$StyledTypeSelect,
        onAutoOpen: onAutoOpen,
        onChangeCardType: onChangeIssueTypeForAiPanel,
        showIssueTypeConfigOptions: showIssueTypeConfigOptions,
        configSource: (0, $f1340a435190eeda$export$bd8f63529bb9357f),
        containerRef: (0, $jOXuX.isTailoredOnboardingScrumAndSoftwareKanbanEnabled)() ? iccContainerRef : undefined,
        ...getExperimentalAiValues()
    })));
};
var $ffe4a2ecb92b3234$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $ffe4a2ecb92b3234$var$InlineCardCreate;
const $ffe4a2ecb92b3234$var$TypeSelectWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldShowChevron: shouldShowChevron, isVisualRefresh: isVisualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1kl7oyrj",
            __cmplp.shouldShowChevron ? "_18u01jfw" : __cmplp.isVisualRefresh ? "_18u0u2gc" : "_18u0v47k",
            __cmplp.className
        ])
    });
});

});
parcelRegister("h1sEN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5ada8b7065598a5$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $gccSB = parcelRequire("gccSB");

var $gZL7V = parcelRequire("gZL7V");

var $8Rkzz = parcelRequire("8Rkzz");

var $gKZoD = parcelRequire("gKZoD");

var $fVnbM = parcelRequire("fVnbM");

var $eCeGD = parcelRequire("eCeGD");

var $c8Oei = parcelRequire("c8Oei");

var $cEqbp = parcelRequire("cEqbp");

var $hORKG = parcelRequire("hORKG");

var $jj3Gi = parcelRequire("jj3Gi");

var $1wCbV = parcelRequire("1wCbV");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $bChGW = parcelRequire("bChGW");
var $b9dFI = parcelRequire("b9dFI");

var $3bDjY = parcelRequire("3bDjY");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dCm1o = parcelRequire("dCm1o");


var $1nb22 = parcelRequire("1nb22");

var $lODMY = parcelRequire("lODMY");

var $4R6GH = parcelRequire("4R6GH");


var $99Ozp = parcelRequire("99Ozp");

var $cjDfJ = parcelRequire("cjDfJ");

var $2ehBu = parcelRequire("2ehBu");
const $d5ada8b7065598a5$var$ANALYTICS_SUBJECT = 'iccTypeSelect'; // NOTE: Compiled/css rules needs to be defined at the top of the component (Otherwise Cypress tests failing)
// ----------------------------------------------------------------------------------------------------------
// kept here the negative margins from the original dropdown component but ideally these shouldn't exist
const $d5ada8b7065598a5$var$containerStyles = null;
const $d5ada8b7065598a5$var$optionWrapperStyles = null;
const $d5ada8b7065598a5$var$triggerContentStylesOld = null;
const $d5ada8b7065598a5$var$singValueContainerStyles = null;
const $d5ada8b7065598a5$var$extraLinksGroupStyles = null;
const $d5ada8b7065598a5$var$optionContentStyles = null;
const $d5ada8b7065598a5$var$Option = ({ children: children, ...props })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)(); // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { cardType: cardType, renderAdditionalContent: renderAdditionalContent, showConfigOptions: showConfigOptions } = props.data;
    return showConfigOptions && (0, $6s1PB.expVal)('jsw_board_view_inline_issue_type_config', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "platform-inline-card-create.ui.form.type-select.option",
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o"
        ])
    }, !!cardType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2ehBu.default), {
        styles: {
            marginRight: "var(--ds-space-100, 8px)"
        },
        cardType: cardType
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug"
        ])
    }, children), !!cardType && !!renderAdditionalContent && renderAdditionalContent(cardType))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "platform-inline-card-create.ui.form.type-select.option",
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o"
        ])
    }, !!cardType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2ehBu.default), {
        styles: {
            marginRight: "var(--ds-space-100, 8px)"
        },
        cardType: cardType
    }), !cardType && (0, $dCm1o.isVisualRefreshEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d5ada8b7065598a5$var$manageTypesIconContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1wCbV))), {
        label: formatMessage((0, $cjDfJ.default).manageTypes),
        color: "var(--ds-icon, #44546F)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug"
        ])
    }, children), !!cardType && !!renderAdditionalContent && renderAdditionalContent(cardType)));
};
const $d5ada8b7065598a5$var$Group = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_x3doudwz _19pk1b66 _ca0q1b66"
        ])
    }, children);
const $d5ada8b7065598a5$var$COMPONENTS_OLD = {
    Option: $d5ada8b7065598a5$var$Option,
    Group: $d5ada8b7065598a5$var$Group
};
const $d5ada8b7065598a5$var$COMPONENTS = {
    Option: $d5ada8b7065598a5$var$Option
};
const $d5ada8b7065598a5$var$makeOption = (cardType, renderAdditionalContent, showConfigOptions)=>({
        label: cardType.name,
        value: cardType.id,
        cardType: cardType,
        optionType: 'card',
        renderAdditionalContent: renderAdditionalContent,
        showConfigOptions: showConfigOptions
    });
const $d5ada8b7065598a5$var$useRouteSelector = (0, $lODMY.createRouterSelector)((state)=>({
        match: state.match,
        query: state.query
    }));
const $d5ada8b7065598a5$var$TypeSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ cardTypes: cardTypes, selectedCardTypeId: selectedCardTypeId, extraItems: extraItems, shouldRenderToParent: shouldRenderToParent = false, onSelectCardType: onSelectCardType, renderAdditionalOptionContent: renderAdditionalOptionContent, showConfigOptions: showConfigOptions = false, configSource: configSource = (0, $f1340a435190eeda$export$8f4fd516b77f8d43), setIsConfiguringIssueType: // this unknown source is temporary until this parameter is required
setIsConfiguringIssueType = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isConfiguringIssueType: isConfiguringIssueType = false }, ref)=>{
    (0, $gKZoD.di)(window);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isDefaultItem = cardTypes[0]?.id === selectedCardTypeId; // Shouldn't fire exposure for when the component is not open
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [inlineIssueTypeConfigExpConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jsw_board_view_inline_issue_type_config'); // Temporarily needed for jsw_board_view_inline_issue_type_config exposures
    const [isMenuOpen, setIsMenuOpen] = (0, $5uXOq.useState)(false);
    let projectKey = '';
    if (inlineIssueTypeConfigExpConfig.get('isEnabled', false)) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { match: match, query: query } = $d5ada8b7065598a5$var$useRouteSelector();
        projectKey = (0, $1nb22.getProjectKey)(match, query);
    }
    const value = (0, $5uXOq.useMemo)(()=>{
        const selectedType = cardTypes.find((type)=>type.id === selectedCardTypeId);
        return selectedType ? $d5ada8b7065598a5$var$makeOption(selectedType, renderAdditionalOptionContent, showConfigOptions) : null;
    }, [
        cardTypes,
        selectedCardTypeId,
        renderAdditionalOptionContent,
        showConfigOptions
    ]);
    const options = (0, $5uXOq.useMemo)(()=>{
        const result = cardTypes.filter((type)=>type.id !== selectedCardTypeId).map((type)=>$d5ada8b7065598a5$var$makeOption(type, renderAdditionalOptionContent, showConfigOptions)); // add extra links if there are any
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(extraItems) && !(showConfigOptions && inlineIssueTypeConfigExpConfig.get('isEnabled', false))) {
            let message;
            if ((0, $dCm1o.isVisualRefreshEnabled)()) message = (0, $cjDfJ.default).manageTypes;
            else message = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cjDfJ.default).manageIssueTypesIssueTermRefresh : (0, $cjDfJ.default).manageIssueTypes;
            const linkOptions = extraItems.map((item)=>({
                    label: item.name != null ? item.name : formatMessage(message),
                    value: item.url,
                    url: item.url,
                    onItemSelect: item.onItemSelect,
                    openNewTab: item.openNewTab ?? false,
                    optionType: 'link'
                })); // if there are no other options, or if visual-refresh is enabled, add them flat
            if ((0, $dCm1o.isVisualRefreshEnabled)() || !result.length) result.push(...linkOptions);
            else // if there are other options already, group the extra links in a new section
            result.push({
                options: linkOptions,
                optionType: 'links'
            });
        }
        return result;
    }, [
        cardTypes,
        extraItems,
        formatMessage,
        renderAdditionalOptionContent,
        selectedCardTypeId,
        showConfigOptions,
        inlineIssueTypeConfigExpConfig
    ]);
    const isOptionDisabled = (0, $5uXOq.useCallback)((option)=>option.optionType === 'card' && option.cardType.isDisabled === true, []);
    const trigger = (0, $5uXOq.useCallback)(({ isOpen: isOpen, ...triggerProps })=>{
        const triggerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: value?.label ?? null,
            delay: (0, $7462c685f739ed5a$export$f9e3e7ede9ba929d),
            hideTooltipOnClick: true
        }, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            ...triggerProps,
            appearance: "subtle",
            isSelected: isOpen,
            "aria-label": formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cjDfJ.default).ariaLabelIssueTermRefresh : (0, $cjDfJ.default).ariaLabel, {
                value: value?.label ?? formatMessage((0, $cjDfJ.default).invalid)
            }),
            testId: "platform-inline-card-create.ui.form.type-select.trigger",
            spacing: "compact"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            alignItems: "center",
            justifyContent: "center",
            gap: "space.075",
            xcss: $d5ada8b7065598a5$var$triggerContentStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2ehBu.default), {
            cardType: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(value, 'cardType')
        }), isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jj3Gi))), {
            label: "",
            color: "var(--ds-icon, #44546F)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hORKG))), {
            label: "",
            color: "var(--ds-icon, #44546F)"
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, $bwpsq.default)([
                "_18u0r5cr _2hwxr5cr"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            ...triggerProps,
            appearance: "subtle",
            spacing: "none",
            isSelected: isOpen,
            "aria-label": formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cjDfJ.default).ariaLabelIssueTermRefresh : (0, $cjDfJ.default).ariaLabel, {
                value: value?.label ?? formatMessage((0, $cjDfJ.default).invalid)
            }),
            testId: "platform-inline-card-create.ui.form.type-select.trigger"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, $bwpsq.default)([
                "_1e0c1txw _4cvr1h6o _18u01b66"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2ehBu.default), {
            cardType: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(value, 'cardType')
        }), isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cEqbp))), {
            spacing: "spacious",
            label: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
            spacing: "spacious",
            label: ""
        })))));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $d5ada8b7065598a5$var$typeContainerStyles
        }, triggerContent);
    }, [
        formatMessage,
        value
    ]);
    const onChange = (0, $5uXOq.useCallback)((option)=>{
        if (option && 'cardType' in option && option.cardType != null) {
            onSelectCardType(option.cardType.id);
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'selectedType',
                actionSubject: $d5ada8b7065598a5$var$ANALYTICS_SUBJECT
            }), {
                issueTypesCount: cardTypes.length
            });
        }
        if (option && 'url' in option && option.url != null) {
            if (option.openNewTab === true) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(option.url, '_blank');
            else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.location.assign(option.url);
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'selectedExtraItem',
                actionSubject: $d5ada8b7065598a5$var$ANALYTICS_SUBJECT
            }), {
                issueTypesCount: cardTypes.length
            });
        }
        if (option && 'onItemSelect' in option && option.onItemSelect) option.onItemSelect();
    }, [
        cardTypes.length,
        createAnalyticsEvent,
        onSelectCardType
    ]);
    const onMenuOpen = (0, $5uXOq.useCallback)(()=>{
        setIsMenuOpen(true);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'opened',
            actionSubject: $d5ada8b7065598a5$var$ANALYTICS_SUBJECT
        }), {
            isDefaultItem: isDefaultItem
        });
    }, [
        createAnalyticsEvent,
        isDefaultItem
    ]);
    const setRefNode = (0, $5uXOq.useCallback)((popupSelectRef)=>{
        ref && popupSelectRef && (0, (/*@__PURE__*/$parcel$interopDefault($gZL7V)))(ref, 'current.node', popupSelectRef);
    }, [
        ref
    ]);
    let linkOptionButtons = null;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(extraItems)) {
        const linkOptions = extraItems.map((item)=>({
                label: item.name != null ? item.name : formatMessage((0, $cjDfJ.default).manage),
                value: item.url,
                url: item.url,
                onItemSelect: item.onItemSelect,
                openNewTab: item.openNewTab ?? false,
                optionType: 'link'
            }));
        linkOptionButtons = linkOptions.map((linkOption)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
                xcss: $d5ada8b7065598a5$var$footerButtonStyles,
                onClick: ()=>onChange(linkOption),
                key: linkOption.label
            }, linkOption.label));
    }
    const renderFooter = (0, $5uXOq.useCallback)(()=>{
        if (isMenuOpen && (0, $6s1PB.expVal)('jsw_board_view_inline_issue_type_config', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            direction: "column",
            xcss: $d5ada8b7065598a5$var$statusViewFooterStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $99Ozp.CreateIssueTypeButton), {
            configSource: configSource,
            onIssueTypeCreated: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            projectKey: projectKey,
            setIsConfiguringIssueType: setIsConfiguringIssueType
        }), linkOptionButtons);
    }, [
        isMenuOpen,
        configSource,
        projectKey,
        linkOptionButtons,
        setIsConfiguringIssueType
    ]);
    if (cardTypes.length === 1 && (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(extraItems) && !(showConfigOptions && inlineIssueTypeConfigExpConfig.get('isEnabled', false))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: value?.label ?? null,
        delay: (0, $7462c685f739ed5a$export$f9e3e7ede9ba929d)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_18u0r5cr _2hwxr5cr",
            "_1e0c116y _4cvr1h6o _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2ehBu.default), {
        cardType: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(value, 'cardType')
    })));
     // to render popup next to the trigger element to achieve DOM order
    const popupStrategy = shouldRenderToParent ? 'fixed' : 'absolute';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b9dFI.default // @ts-expect-error — Type 'T | null' is not assignable to type 'PopupSelect<SelectOption, false, ModifierList>'
    ), {
        ref: setRefNode,
        components: (0, $dCm1o.isVisualRefreshEnabled)() ? $d5ada8b7065598a5$var$COMPONENTS : $d5ada8b7065598a5$var$COMPONENTS_OLD,
        target: trigger,
        options: options,
        isOptionDisabled: isOptionDisabled,
        value: value,
        onChange: onChange,
        onMenuOpen: onMenuOpen,
        isSearchable: false,
        searchThreshold: Number.MAX_SAFE_INTEGER,
        minMenuWidth: "auto",
        classNamePrefix: "inline-card-create-type-select",
        testId: "platform-inline-card-create.ui.form.type-select.type-select",
        popperProps: {
            strategy: popupStrategy,
            ...(0, $4R6GH.fg)('jira_ai_work_create_from_backlog_icc_changes') ? {
                modifiers: [
                    {
                        name: 'preventOverflow',
                        enabled: false
                    }
                ]
            } : {}
        },
        footer: showConfigOptions ? renderFooter() : undefined,
        shouldCloseMenuOnTab: !(showConfigOptions && inlineIssueTypeConfigExpConfig.get('isEnabled', false)),
        isOpen: isConfiguringIssueType ? false : undefined
    });
});
const $d5ada8b7065598a5$var$typeContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    flexShrink: 0
});
const $d5ada8b7065598a5$var$triggerContentStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.025'
});
const $d5ada8b7065598a5$var$manageTypesIconContainer = (0, $8CUq3.xcss)({
    paddingInline: 'space.025',
    marginRight: 'space.100'
});
const $d5ada8b7065598a5$var$statusViewFooterStyles = (0, $8CUq3.xcss)({
    borderTop: `2px solid ${"var(--ds-border, #091E4224)"}`
});
const $d5ada8b7065598a5$var$footerButtonStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    height: "var(--ds-space-500, 40px)",
    width: '100%',
    color: 'color.text',
    backgroundColor: 'color.background.neutral.subtle',
    alignItems: 'center',
    textAlign: 'left',
    paddingLeft: 'space.150',
    paddingRight: 'space.150',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    }
});
var $d5ada8b7065598a5$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($d5ada8b7065598a5$var$TypeSelect);

});
parcelRegister("cEqbp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e58b02424147679c6e4b17a279d99cac>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $935d87e1572638ec$var$_react = $935d87e1572638ec$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $935d87e1572638ec$var$_chevronUp = $935d87e1572638ec$var$_interopRequireDefault((parcelRequire("jj3Gi")));

var $935d87e1572638ec$var$_chevronUp2 = $935d87e1572638ec$var$_interopRequireDefault((parcelRequire("6Pmud")));
function $935d87e1572638ec$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronUpIcon.
 * This component is ChevronUpIcon, with `UNSAFE_fallbackIcon` set to "ChevronUpIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for accordions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $935d87e1572638ec$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $935d87e1572638ec$var$_react.default.createElement($935d87e1572638ec$var$_chevronUp.default, Object.assign({
        LEGACY_fallbackIcon: $935d87e1572638ec$var$_chevronUp2.default
    }, props));
$935d87e1572638ec$var$ChevronUpIcon.Name = 'ChevronUpIconMigration';
var $935d87e1572638ec$var$_default = module.exports.default = $935d87e1572638ec$var$ChevronUpIcon;

});
parcelRegister("6Pmud", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f88f2d3e506ed12$var$_react = $4f88f2d3e506ed12$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $4f88f2d3e506ed12$var$_chevronUp = $4f88f2d3e506ed12$var$_interopRequireDefault((parcelRequire("dVd7B")));
function $4f88f2d3e506ed12$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4f88f2d3e506ed12$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $4f88f2d3e506ed12$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.221 9.322-2.929 2.955a1.01 1.01 0 0 0 0 1.419.986.986 0 0 0 1.405 0l2.298-2.317 2.307 2.327a.99.99 0 0 0 1.407 0 1.01 1.01 0 0 0 0-1.419l-2.94-2.965A1.1 1.1 0 0 0 11.991 9c-.279 0-.557.107-.77.322"/></svg>`
    }, props, {
        newIcon: $4f88f2d3e506ed12$var$_chevronUp.default
    }));
$4f88f2d3e506ed12$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $4f88f2d3e506ed12$var$_default = module.exports.default = $4f88f2d3e506ed12$var$ChevronUpIcon;

});


const $f1340a435190eeda$export$c766acff4513a976 = 'summaryView';
const $f1340a435190eeda$export$4edb790587638895 = 'listView';
const $f1340a435190eeda$export$cafb161c2b21b455 = 'issueView';
const $f1340a435190eeda$export$66397ed56abea4ca = 'gicView';
const $f1340a435190eeda$export$a1077f863a923e94 = 'gicViewNoResults';
const $f1340a435190eeda$export$7f04bd1df3763938 = 'jswBoard';
const $f1340a435190eeda$export$bd8f63529bb9357f = 'jswBacklog';
const $f1340a435190eeda$export$57eacdfdee901d4c = 'jswTimeline';
const $f1340a435190eeda$export$8f4fd516b77f8d43 = 'unknown';
const $f1340a435190eeda$export$334975a13cb19c35 = 'editIssueTypeButton';
const $f1340a435190eeda$export$e970abb363c8ec67 = 'deleteIssueTypeButton';

parcelRegister("99Ozp", function(module, exports) {

$parcel$export(module.exports, "CreateIssueTypeButton", () => $77c086035bf62902$export$6a624961ca7b5320);

var $5uXOq = parcelRequire("5uXOq");

var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $2awBM = parcelRequire("2awBM");

var $4R6GH = parcelRequire("4R6GH");

var $2KAtx = parcelRequire("2KAtx");

var $havAj = parcelRequire("havAj");

var $koVbs = parcelRequire("koVbs");

var $koeKL = parcelRequire("koeKL");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $ceHCF = parcelRequire("ceHCF");

var $cjDfJ = parcelRequire("cjDfJ");
const $77c086035bf62902$var$ISSUE_TYPE_COUNT_LIMIT = 30;
const $77c086035bf62902$export$6a624961ca7b5320 = ({ onIssueTypeCreated: onIssueTypeCreated, projectKey: projectKey, configSource: configSource, setIsConfiguringIssueType: setIsConfiguringIssueType })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleCreateIssueTypeButtonClick = ()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'createIssueTypeButton');
    };
    const handleCreateIssueTypeModalClose = ()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'inlineCreateIssueTypeModal',
            action: 'closed'
        }), {
            calledFrom: configSource
        });
        setIsConfiguringIssueType(false);
    };
    const entryPointProps = {
        onIssueTypeCreated: onIssueTypeCreated,
        onClose: handleCreateIssueTypeModalClose,
        onOpen: ()=>setIsConfiguringIssueType(true),
        issueTypesCountLimit: $77c086035bf62902$var$ISSUE_TYPE_COUNT_LIMIT,
        ufoExperience: (0, $ceHCF.createIssueTypeExperience),
        source: configSource
    };
    const entryPointParams = {
        projectKey: projectKey,
        cloudId: cloudId
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $2awBM.asyncCreateIssueTypeModalEntryPoint),
        entryPointProps: entryPointProps,
        entryPointParams: entryPointParams,
        interactionName: "create-issue-type-modal",
        modalProps: (0, $havAj.defaultModalProps),
        useInternalModal: false
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
            onClick: handleCreateIssueTypeButtonClick,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref: ref,
            xcss: $77c086035bf62902$var$footerButtonStyles
        }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $cjDfJ.default).createWorkTypeButton : (0, $cjDfJ.default).createIssueTypeButton)));
};
const $77c086035bf62902$var$footerButtonStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    height: "var(--ds-space-500, 40px)",
    width: '100%',
    color: 'color.text',
    backgroundColor: 'color.background.neutral.subtle',
    alignItems: 'center',
    textAlign: 'left',
    paddingLeft: 'space.150',
    paddingRight: 'space.150',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    }
});

});
parcelRegister("2awBM", function(module, exports) {

$parcel$export(module.exports, "asyncCreateIssueTypeModalEntryPoint", () => $5d94d7bcabd38106$export$7f9428aac5b01dff);

var $ekCoo = parcelRequire("ekCoo");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $5d94d7bcabd38106$export$7f9428aac5b01dff = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("3zpeP")), {
        moduleId: "0ca2b96c"
    }),
    getPreloadProps: ({ projectKey: projectKey, cloudId: cloudId, shouldFetchProjectData: shouldFetchProjectData })=>({
            queries: {
                createIssueTypeModal: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $ekCoo.default,
                    variables: {
                        projectKey: projectKey,
                        cloudId: cloudId,
                        shouldFetchProjectData: shouldFetchProjectData
                    }
                }
            }
        })
});

});
parcelRegister("ekCoo", function(module, exports) {

$parcel$export(module.exports, "default", () => $1115b945d8dda421$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<36277921a8012e0702a65f1227cbbd1b>>
 * @relayHash 4a7b622560b3b3e20bb696680e8560ab
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d8c35e32d8548b68e2966c6dacdbc893c0768a3dd5dc31d2dfca58cd3e11bc76
const $1115b945d8dda421$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "shouldFetchProjectData"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "srcAsyncCreateIssueTypeQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraIssueTypeConnection",
                                                "kind": "LinkedField",
                                                "name": "issueTypes",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "ui_createIssueTypeModal_CreateIssueTypeModalWrapper_createIssueTypeFragmentRef"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.issueTypes"
                                        },
                                        {
                                            "condition": "shouldFetchProjectData",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "ui_createIssueTypeModal_CreateIssueTypeModalWrapper_projectDataFragmentRef"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProjectByKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "srcAsyncCreateIssueTypeQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "issueTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "totalCount"
                                        },
                                        {
                                            "concreteType": "JiraIssueTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueTypeHierarchyLevel",
                                                            "kind": "LinkedField",
                                                            "name": "hierarchy",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "level"
                                                                }
                                                            ]
                                                        },
                                                        v3 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "shouldFetchProjectData",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectType"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectStyle"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "status"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "uuid"
                                        },
                                        v2 /*: any*/ ,
                                        {
                                            "concreteType": "JiraAvatar",
                                            "kind": "LinkedField",
                                            "name": "avatar",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "medium"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d8c35e32d8548b68e2966c6dacdbc893c0768a3dd5dc31d2dfca58cd3e11bc76",
            "metadata": {},
            "name": "srcAsyncCreateIssueTypeQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1115b945d8dda421$var$node.hash = "b50515a18d5488758aa762560868c40c";
var $1115b945d8dda421$export$2e2bcd8739ae039 = $1115b945d8dda421$var$node;

});

parcelRegister("3zpeP", function(module, exports) {

let $299837c6d07f38d0$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $299837c6d07f38d0$var$load("76n7a"),
    $299837c6d07f38d0$var$load("l253H"),
    $299837c6d07f38d0$var$load("ffQaD"),
    $299837c6d07f38d0$var$load("kvRbA"),
    $299837c6d07f38d0$var$load("kNFvF"),
    $299837c6d07f38d0$var$load("7utVE")
]).then(()=>parcelRequire('djJpq'));

});


parcelRegister("havAj", function(module, exports) {

$parcel$export(module.exports, "defaultModalProps", () => $15c81a62c11e20dc$export$14c11acc66fd51b3);
const $15c81a62c11e20dc$export$14c11acc66fd51b3 = {
    width: 'small'
};

});

parcelRegister("ceHCF", function(module, exports) {

$parcel$export(module.exports, "createIssueTypeExperience", () => $344701e2b73b2e9b$export$884137c1a8b65a81);

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
const $344701e2b73b2e9b$export$884137c1a8b65a81 = new (0, $duUGa.UFOExperience)('inline-card-create.edit-issue-type', {
    type: (0, $atdLB.ExperienceTypes).Operation,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom
});

});

parcelRegister("cjDfJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $98179f22ec008310$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $98179f22ec008310$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    ariaLabel: {
        "id": "inline-card-create.form.type-select.aria-label",
        "defaultMessage": "The current issue type is {value}. Press the 'Space' key to change the issue type."
    },
    invalid: {
        "id": "inline-card-create.form.type-select.invalid",
        "defaultMessage": "invalid"
    },
    // Delete this message when cleaning up visual-refresh FG
    manageIssueTypes: {
        "id": "inline-card-create.form.type-select.manage-issue-types",
        "defaultMessage": "Manage issue types"
    },
    manageTypes: {
        "id": "inline-card-create.form.type-select.manage-types",
        "defaultMessage": "Manage types"
    },
    manage: {
        "id": "inline-card-create.form.type-select.manage",
        "defaultMessage": "Manage"
    },
    addIssueType: {
        "id": "inline-card-create.form.type-select.add-issue-type",
        "defaultMessage": "Add issue type"
    },
    ariaLabelIssueTermRefresh: {
        "id": "inline-card-create.form.type-select.aria-label-issue-term-refresh",
        "defaultMessage": "The current work type is {value}. Press the 'Space' key to change the work type."
    },
    manageIssueTypesIssueTermRefresh: {
        "id": "inline-card-create.form.type-select.manage-issue-types-issue-term-refresh",
        "defaultMessage": "Manage work types"
    },
    addIssueTypeIssueTermRefresh: {
        "id": "inline-card-create.form.type-select.add-issue-type-issue-term-refresh",
        "defaultMessage": "Add work type"
    },
    createIssueTypeButton: {
        "id": "inline-card-create.form.type-select.create-issue-type-button",
        "defaultMessage": "Create issue type"
    },
    createWorkTypeButton: {
        "id": "inline-card-create.form.type-select.create-work-type-button",
        "defaultMessage": "Create work type"
    }
});

});


parcelRegister("2ehBu", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9af3d59273fe1f1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable jira/react/no-style-attribute */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");
const $f9af3d59273fe1f1$export$9fbe3594a958ae08 = '/icons/issuetypes/genericissue.svg';
const $f9af3d59273fe1f1$var$cardTypeImageStyles = null;
const $f9af3d59273fe1f1$var$TypeIcon = ({ cardType: cardType, styles: styles, className: className })=>cardType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: cardType.iconUrl,
        alt: (0, $4R6GH.fg)('jfp_a11y_team_scrum_board_cmp_unnecessary_alt_text') ? '' : cardType.name,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_4t3i7vkz _1bsb7vkz",
            className
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: styles
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        alt: "",
        src: $f9af3d59273fe1f1$export$9fbe3594a958ae08,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_4t3i7vkz _1bsb7vkz",
            className
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: styles
    });
var $f9af3d59273fe1f1$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($f9af3d59273fe1f1$var$TypeIcon);

});


parcelRegister("kuJWB", function(module, exports) {

$parcel$export(module.exports, "SmartLinkEditorEntryPointComponent", () => $1eb8eba30a3e3163$export$79e664defa13940f);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $1eb8eba30a3e3163$export$79e664defa13940f = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("aVkqd")).then((module)=>module.SmartLinkEditorEntryPointComponent), {
        moduleId: "ac586a1a"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("aVkqd", function(module, exports) {

let $7f3f11995b99dcad$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $7f3f11995b99dcad$var$load("ffQaD"),
    $7f3f11995b99dcad$var$load("kvRbA"),
    $7f3f11995b99dcad$var$load("fliVL"),
    $7f3f11995b99dcad$var$load("6kARU")
]).then(()=>parcelRequire('ekrwT'));

});


parcelRegister("18zd0", function(module, exports) {

$parcel$export(module.exports, "BacklogCreateSprintIssueNudgeAsync", () => $9ce603ff8ccd7ae6$export$25a858f9761762ce);

var $5uXOq = parcelRequire("5uXOq");

var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");



// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9ce603ff8ccd7ae6$var$BacklogCreateSprintIssueNudgeLazy = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("Q9DOt")).then((exportedModule)=>exportedModule.BacklogCreateSprintIssueNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/scrum-onboarding-tour/backlog-create-sprint-issue/index.tsx"
});
const $9ce603ff8ccd7ae6$export$25a858f9761762ce = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $dbbf68c32d8c4308$export$65fb0c4e534f03fc),
        fallback: null,
        attributes: {
            nudgeId: (0, $6784cbc7d62e5d7c$export$eb64d5f1a091478b)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-software-onboarding-backlog-create-sprint-issue-nudge",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9ce603ff8ccd7ae6$var$BacklogCreateSprintIssueNudgeLazy, null)));
$9ce603ff8ccd7ae6$export$25a858f9761762ce.displayName = 'BacklogCreateSprintIssueNudgeAsync';

});
parcelRegister("Q9DOt", function(module, exports) {

let $09cc55f9734e904b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $09cc55f9734e904b$var$load("6FyjY").then(()=>parcelRequire('gp7oK'));

});


parcelRegister("atbUC", function(module, exports) {

$parcel$export(module.exports, "BacklogCreateIssueNudgePortalledAsync", () => $e551bb135fb15c9e$export$98a1445e6b99ead7);

var $5uXOq = parcelRequire("5uXOq");

var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");



// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $e551bb135fb15c9e$var$BacklogCreateIssueNudgePortalledLazy = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("3GAk4")).then((exportedModule)=>exportedModule.BacklogCreateIssueNudgePortalled), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/scrum-onboarding-tour/backlog-create-issue-portalled/index.tsx"
});
const $e551bb135fb15c9e$export$98a1445e6b99ead7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $dbbf68c32d8c4308$export$65fb0c4e534f03fc),
        fallback: null,
        attributes: {
            nudgeId: (0, $6784cbc7d62e5d7c$export$64d75060ee6ba425)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-software-onboarding-backlog-create-issue-nudge-portalled",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e551bb135fb15c9e$var$BacklogCreateIssueNudgePortalledLazy, null)));
$e551bb135fb15c9e$export$98a1445e6b99ead7.displayName = 'BacklogCreateIssueNudgePortalledAsync';

});
parcelRegister("3GAk4", function(module, exports) {

let $2af1784c4cf2d178$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2af1784c4cf2d178$var$load("e1n6F").then(()=>parcelRequire('igORe'));

});


parcelRegister("1jxD5", function(module, exports) {

$parcel$export(module.exports, "aiEntitlementResource", () => $f1ad36205823a0c5$export$1d7e36ec4890154f);
$parcel$export(module.exports, "useAiEntitlementResource", () => $f1ad36205823a0c5$export$58958385d85a6e72);

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

var $e7VcZ = parcelRequire("e7VcZ");
const $f1ad36205823a0c5$var$RESOURCE_TYPE_AI_ENTITLEMENT = 'AI_ENTITLEMENT';
const $f1ad36205823a0c5$export$1d7e36ec4890154f = (0, $2M1hQ.createResource)({
    type: $f1ad36205823a0c5$var$RESOURCE_TYPE_AI_ENTITLEMENT,
    getKey: ()=>$f1ad36205823a0c5$var$RESOURCE_TYPE_AI_ENTITLEMENT,
    getData: ()=>(0, $e7VcZ.fetchAiEnablement)(),
    maxAge: 3600000
});
const $f1ad36205823a0c5$export$58958385d85a6e72 = ()=>(0, $2YP9W.useResource)($f1ad36205823a0c5$export$1d7e36ec4890154f);

});
parcelRegister("e7VcZ", function(module, exports) {

$parcel$export(module.exports, "fetchAiEnablement", () => $d2a02eb2068290e1$export$ad4105850d0ce824);

var $7f4tk = parcelRequire("7f4tk");
const $d2a02eb2068290e1$var$JIRA_SOFTWARE_AI_ENABLED_URL = '/rest/api/1/aiconfig/ai-enabled/jira-software';
const $d2a02eb2068290e1$export$ad4105850d0ce824 = async ()=>{
    // We could check for other jira products / confluence when we need to
    // Not doing that right now as it adds complexity & we need software only now
    // See `@atlassian/jira-platform-react-hooks-use-is-admin-hub-ai-enabled`
    const entitlementData = {
        isAiEnabledForJiraSoftware: null
    };
    try {
        const response = await (0, $7f4tk.default)($d2a02eb2068290e1$var$JIRA_SOFTWARE_AI_ENABLED_URL, {
            method: 'GET'
        });
        entitlementData.isAiEnabledForJiraSoftware = response.isEnabled;
    } catch (_) {
        entitlementData.isAiEnabledForJiraSoftware = null;
    }
    return entitlementData;
};

});


parcelRegister("2iHbn", function(module, exports) {

$parcel$export(module.exports, "useIsAiEnabledBacklog", () => $6b9ac3d7faf82ef9$export$2677ebf58c14693a);

var $5uXOq = parcelRequire("5uXOq");

var $kJP8l = parcelRequire("kJP8l");

var $2WqFA = parcelRequire("2WqFA");

var $eTrP2 = parcelRequire("eTrP2");
const $6b9ac3d7faf82ef9$export$2677ebf58c14693a = ()=>{
    const productName = (0, $kJP8l.useProductName)();
    const adminHubAiProductName = (0, $eTrP2.getProductForAdminHubAi)(productName);
    const { data: isAiEnabled, fetchAIEnablement: fetchAIEnablement, error: error } = (0, $2WqFA.default)(adminHubAiProductName);
    (0, $5uXOq.useEffect)(()=>{
        fetchAIEnablement();
    }, [
        fetchAIEnablement
    ]);
    // Boolean constructor used as it can be null
    return !error && Boolean(isAiEnabled);
};

});
parcelRegister("2WqFA", function(module, exports) {

$parcel$export(module.exports, "default", () => $18bf020f3f366501$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $29jfS = parcelRequire("29jfS");
const $18bf020f3f366501$var$useIsAdminHubAIEnabled = (jiraProduct, version)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isAdminHubAiToggleEnabled, setIsAdminHubAiToggleEnabled] = (0, $5uXOq.useState)(null);
    const [loading, setLoading] = (0, $5uXOq.useState)(true);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const fetchData = (0, $5uXOq.useCallback)(async ()=>{
        setLoading(true);
        setError(null);
        try {
            const response = await (0, $29jfS.fetchAiEnablement)(jiraProduct, version);
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchAiEnablementStatus succeeded');
            setIsAdminHubAiToggleEnabled(response.isEnabled);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setError(err);
            (0, $jcw0u.default)({
                error: err,
                meta: {
                    id: 'fetchAiEnablementStatus failed'
                }
            });
        } finally{
            setLoading(false);
        }
    }, [
        createAnalyticsEvent,
        jiraProduct,
        version
    ]);
    return {
        data: isAdminHubAiToggleEnabled,
        loading: loading,
        error: error,
        fetchAIEnablement: fetchData
    };
};
var $18bf020f3f366501$export$2e2bcd8739ae039 = $18bf020f3f366501$var$useIsAdminHubAIEnabled;

});
parcelRegister("29jfS", function(module, exports) {

$parcel$export(module.exports, "fetchAiEnablement", () => $f8e2a461a4c2e420$export$ad4105850d0ce824);

var $7f4tk = parcelRequire("7f4tk");
const $f8e2a461a4c2e420$export$2171a423b572256a = (jiraProduct, version = '1')=>`/rest/api/${version}/aiconfig/ai-enabled/${jiraProduct}`;
const $f8e2a461a4c2e420$export$ad4105850d0ce824 = (jiraProduct, version = '1')=>{
    const url = $f8e2a461a4c2e420$export$2171a423b572256a(jiraProduct, version);
    return (0, $7f4tk.default)(url, {
        method: 'GET'
    });
};

});


parcelRegister("eTrP2", function(module, exports) {

$parcel$export(module.exports, "getProductForAdminHubAi", () => $862159cfd48e7f1a$export$a26765b70278d921);
const $862159cfd48e7f1a$export$a75e537c279a265a = {
    CORE: 'core',
    JIRA: 'jira',
    SERVICEDESK: 'serviceDesk',
    SOFTWARE: 'software',
    PRODUCT_DISCOVERY: 'product-discovery',
    CUSTOMER_SERVICE: 'customer-service'
};
const $862159cfd48e7f1a$export$7565d78c961a10de = {
    JIRA_CORE: 'jira-core',
    JIRA_SERVICEDESK: 'jira-servicedesk',
    JIRA_CUSTOMER_SERVICE: 'jira-customer-service',
    JIRA_SOFTWARE: 'jira-software',
    JIRA_PRODUCT_DISCOVERY: 'jira-product-discovery'
};
const $862159cfd48e7f1a$export$a26765b70278d921 = (product)=>{
    switch(product){
        case $862159cfd48e7f1a$export$a75e537c279a265a.CORE:
            return $862159cfd48e7f1a$export$7565d78c961a10de.JIRA_CORE;
        case $862159cfd48e7f1a$export$a75e537c279a265a.SERVICEDESK:
            return $862159cfd48e7f1a$export$7565d78c961a10de.JIRA_SERVICEDESK;
        case $862159cfd48e7f1a$export$a75e537c279a265a.CUSTOMER_SERVICE:
            return $862159cfd48e7f1a$export$7565d78c961a10de.JIRA_CUSTOMER_SERVICE;
        case $862159cfd48e7f1a$export$a75e537c279a265a.PRODUCT_DISCOVERY:
            return $862159cfd48e7f1a$export$7565d78c961a10de.JIRA_PRODUCT_DISCOVERY;
        case $862159cfd48e7f1a$export$a75e537c279a265a.SOFTWARE:
        case $862159cfd48e7f1a$export$a75e537c279a265a.JIRA:
        default:
            return $862159cfd48e7f1a$export$7565d78c961a10de.JIRA_SOFTWARE;
    }
};

});


parcelRegister("aXMy2", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcb91641cde72d96$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bcb91641cde72d96$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    triggerLabelForAiWorkCreate: {
        "id": "software-backlog-panel.epic.epic-panel.epic-inline-card-create.trigger-label-for-ai-work-create",
        "defaultMessage": "Create work item or create from Confluence page"
    }
});

});

parcelRegister("fFWk3", function(module, exports) {

$parcel$export(module.exports, "AiSuggestButton", () => $2d3698efe8c35a71$export$27b9904e37317ed6);

var $5uXOq = parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");

var $jps85 = parcelRequire("jps85");

var $koVbs = parcelRequire("koVbs");

var $gYXaS = parcelRequire("gYXaS");
const $2d3698efe8c35a71$export$27b9904e37317ed6 = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "default",
        spacing: "compact",
        onClick: onClick,
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($jps85))),
        interactionName: "backlog-ai-suggest-work-items-button"
    }, formatMessage((0, $gYXaS.default).buttonLabelSuggestWorkItems));
};

});
parcelRegister("jps85", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b8054c1d672105cf334f7f37a83f0cf2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e2162c0618e136c6$var$_react = $e2162c0618e136c6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e2162c0618e136c6$var$_baseNew = $e2162c0618e136c6$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e2162c0618e136c6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AtlassianIntelligence".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Atlassian Intelligence products or experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e2162c0618e136c6$var$AtlassianIntelligenceIcon = (props)=>/*#__PURE__*/ $e2162c0618e136c6$var$_react.default.createElement($e2162c0618e136c6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 4V1h1.5v3zM5.47 6.53l-4-4 1.06-1.06 4 4zm4-1.06 4-4 1.06 1.06-4 4zM1 7.25h3v1.5H1zm11 0h3v1.5h-3zM1.47 13.47l4-4 1.06 1.06-4 4zm12 1.06-4-4 1.06-1.06 4 4zM7.25 15v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$e2162c0618e136c6$var$AtlassianIntelligenceIcon.displayName = 'AtlassianIntelligenceIcon';
var $e2162c0618e136c6$var$_default = module.exports.default = $e2162c0618e136c6$var$AtlassianIntelligenceIcon;

});

parcelRegister("gYXaS", function(module, exports) {

$parcel$export(module.exports, "default", () => $551917b476f16a6e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $551917b476f16a6e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    buttonLabelSuggestWorkItems: {
        "id": "backlog.card-list.inline-card-create.ai-assisted-create.ai-suggest-button.button-label-suggest-work-items",
        "defaultMessage": "Suggest Work Items"
    }
});

});


parcelRegister("kWseG", function(module, exports) {

$parcel$export(module.exports, "useAiWorkCreatePanelEntryPoint", () => $628f7e6645a76a5b$export$1be574c2b618f993);

var $5uXOq = parcelRequire("5uXOq");

var $4qmaa = parcelRequire("4qmaa");

var $4mO32 = parcelRequire("4mO32");

var $6s1PB = parcelRequire("6s1PB");
let $628f7e6645a76a5b$var$previousPanelCardListId;
let $628f7e6645a76a5b$var$cleanUpPreviousPanel;
const $628f7e6645a76a5b$export$b27f8f518504a180 = ()=>{
    $628f7e6645a76a5b$var$cleanUpPreviousPanel = undefined;
    $628f7e6645a76a5b$var$previousPanelCardListId = undefined;
};
const $628f7e6645a76a5b$export$1be574c2b618f993 = ({ selectedIssueType: selectedIssueType, sourceLink: sourceLink, onSetAiWorkCreatePanelSubject: onSetAiWorkCreatePanelSubject, onAllSuggestionsActioned: onAllSuggestionsActioned, cardListId: cardListId })=>{
    // used to notify AI Panel to refetch
    const [retryTrigger, setRetryTrigger] = (0, $5uXOq.useState)(0);
    const [source, setSource] = (0, $5uXOq.useState)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            selectedIssueType: selectedIssueType,
            sourceLink: source ?? sourceLink ?? '',
            retryTrigger: retryTrigger,
            onAllSuggestionsActioned: onAllSuggestionsActioned
        }), [
        source,
        sourceLink,
        retryTrigger,
        selectedIssueType,
        onAllSuggestionsActioned
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $4qmaa.BacklogAiWorkCreationPanelEntryPoint), entryPointParams, undefined, {
        preloadMaxAge: 0
    });
    (0, $5uXOq.useEffect)(()=>{
        if (sourceLink && (0, $6s1PB.expValEquals)('ai_powered_backlog_inline_create_iter2', 'isEnabled', false, false)) entryPointActions.preload();
    }, [
        entryPointActions,
        sourceLink
    ]);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (entryPointParams.sourceLink && (0, $6s1PB.expValEquals)('ai_powered_backlog_inline_create_iter2', 'isEnabled', true, false)) {
            onSetAiWorkCreatePanelSubject?.(entryPointReferenceSubject);
            entryPointActions.load();
        }
    }, // Re-run on retryTrigger change is a workaround right now - ideally we want to use `entryPointActions` or `entryPointParams` here
    // But `entryPointParams` turns out not to be stable in backlog ICC (because `initialCardTypes` is not stable causing selectedIssueType to change)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        retryTrigger
    ]);
    /**
	 * @deprecated Use `loadAndShowAiWorkCreatePanelForSource` instead
	 *
	// Invoked only by iter1 flow, assuming `entryPointActions` is updated with latest source
	 */ const loadAndShowAiWorkCreatePanel = (0, $5uXOq.useCallback)(()=>{
        onSetAiWorkCreatePanelSubject?.(entryPointReferenceSubject);
        entryPointActions.load();
        setRetryTrigger((prev)=>prev + 1);
    }, [
        entryPointActions,
        entryPointReferenceSubject,
        onSetAiWorkCreatePanelSubject
    ]);
    // Invoked only by iter2 flow, load panel with provided source
    // No need to use sourceLink
    const loadAndShowAiWorkCreatePanelForSource = (0, $5uXOq.useCallback)((loadSource)=>{
        if ($628f7e6645a76a5b$var$previousPanelCardListId !== cardListId) $628f7e6645a76a5b$var$cleanUpPreviousPanel?.();
        setSource(loadSource);
        setRetryTrigger((prev)=>prev + 1);
        $628f7e6645a76a5b$var$cleanUpPreviousPanel = entryPointActions.unload;
        $628f7e6645a76a5b$var$previousPanelCardListId = cardListId;
    }, [
        entryPointActions,
        cardListId
    ]);
    return {
        unloadAiWorkCreatePanel: entryPointActions.unload,
        preloadAiWorkCreatePanel: entryPointActions.preload,
        loadAndShowAiWorkCreatePanel: loadAndShowAiWorkCreatePanel,
        loadAndShowAiWorkCreatePanelForSource: loadAndShowAiWorkCreatePanelForSource
    };
};

});
parcelRegister("4qmaa", function(module, exports) {

$parcel$export(module.exports, "BacklogAiWorkCreationPanelEntryPoint", () => $3951f6355eeab7c6$export$cff8ff0963b9cff9);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $3951f6355eeab7c6$export$cff8ff0963b9cff9 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("dDG9T")).then((module)=>module.BacklogAiWorkCreationPanelEntryPointComponent), {
        moduleId: "ccde7876"
    }),
    getPreloadProps: ({ sourceLink: sourceLink, retryTrigger: retryTrigger, selectedIssueType: selectedIssueType, onAllSuggestionsActioned: onAllSuggestionsActioned })=>({
            extraProps: {
                sourceLink: sourceLink,
                retryTrigger: retryTrigger,
                selectedIssueType: selectedIssueType,
                onAllSuggestionsActioned: onAllSuggestionsActioned
            }
        })
});

});
parcelRegister("dDG9T", function(module, exports) {

let $9edf9eae02e42375$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $9edf9eae02e42375$var$load("fliVL"),
    $9edf9eae02e42375$var$load("joEBL")
]).then(()=>parcelRequire('kA5r2'));

});



parcelRegister("fJ5Eq", function(module, exports) {

$parcel$export(module.exports, "useSelectedIssueType", () => $12b1641adbca4767$export$599cab6d0d6318e5);

var $5uXOq = parcelRequire("5uXOq");
const $12b1641adbca4767$export$599cab6d0d6318e5 = ({ defaultCardTypeId: defaultCardTypeId, initialCardTypes: initialCardTypes, filteredIssueTypes: filteredIssueTypes })=>{
    // issue type dropdown always selects last issue type to be selected by the filter
    const lastFilteredIssueTypeId = filteredIssueTypes?.at(-1) ?? undefined;
    const [selectedIssueTypeId, setSelectedIssueTypeId] = (0, $5uXOq.useState)(Number(defaultCardTypeId) || initialCardTypes[0]?.id);
    // If filtered issue type ID is available, set to filter issue type
    // When defaultCardTypeId not set: default to first card type
    (0, $5uXOq.useEffect)(()=>{
        if (lastFilteredIssueTypeId) {
            setSelectedIssueTypeId(Number(lastFilteredIssueTypeId));
            return;
        }
        if (!defaultCardTypeId && initialCardTypes.length) setSelectedIssueTypeId(initialCardTypes[0].id);
    }, [
        defaultCardTypeId,
        initialCardTypes,
        lastFilteredIssueTypeId
    ]);
    const onChangeIssueType = (0, $5uXOq.useCallback)((cardTypeId)=>{
        setSelectedIssueTypeId(Number(cardTypeId));
    }, []);
    return {
        selectedIssueType: initialCardTypes.find(({ id: id })=>id === selectedIssueTypeId) || initialCardTypes[0],
        onChangeIssueType: onChangeIssueType
    };
};

});

parcelRegister("231hY", function(module, exports) {

$parcel$export(module.exports, "useIsFormVisible", () => $f826549e302a3af6$export$5243eae5fa113f21);

var $5uXOq = parcelRequire("5uXOq");

var $dseDh = parcelRequire("dseDh");

var $6s1PB = parcelRequire("6s1PB");

var $c1MAf = parcelRequire("c1MAf");

var $fC5rN = parcelRequire("fC5rN");

const $f826549e302a3af6$export$5243eae5fa113f21 = ({ isFocusMovedToAiPanel: isFocusMovedToAiPanel, isPlaceholderLinkPickerOpen: isPlaceholderLinkPickerOpen, isFormVisibleOverride: isFormVisibleOverride, isFormVisibleByDefault: isFormVisibleByDefault = false })=>{
    const [isFormVisible, setIsFormVisible] = (0, $5uXOq.useState)(isFormVisibleByDefault);
    const [{ isFeedbackCollectorOpen: isFeedbackCollectorOpen }] = (0, $dseDh.useFeedbackCollector)();
    const isModalOpen = (0, $c1MAf.useBacklogSelector)((0, $fC5rN.makeIsModalOpen));
    const isGlobalIssueCreateModal = isModalOpen((0, $b107c54ec82f76f2$export$55cae6fd3c958bc5));
    const shouldKeepIccOpenOnBlur = Boolean(isGlobalIssueCreateModal || isPlaceholderLinkPickerOpen || isFeedbackCollectorOpen);
    const shouldSkipFormCloseOnBlur = (0, $5uXOq.useCallback)(()=>{
        if ((0, $6s1PB.expValEquals)('ai_powered_backlog_inline_create_iter2', 'isEnabled', false, false)) {
            const isClickOnAlert = typeof document !== 'undefined' && document.activeElement?.closest('[role="alert"]');
            return isFocusMovedToAiPanel?.() || shouldKeepIccOpenOnBlur || isClickOnAlert;
        }
        return isPlaceholderLinkPickerOpen;
    }, [
        isFocusMovedToAiPanel,
        shouldKeepIccOpenOnBlur,
        isPlaceholderLinkPickerOpen
    ]);
    const showForm = (0, $5uXOq.useCallback)(()=>{
        setIsFormVisible(true);
    }, []);
    const hideForm = (0, $5uXOq.useCallback)(()=>{
        setIsFormVisible(false);
    }, []);
    return {
        isFormVisible: isFormVisibleOverride ?? isFormVisible,
        showForm: showForm,
        hideForm: hideForm,
        shouldSkipFormCloseOnBlur: shouldSkipFormCloseOnBlur
    };
};

});
parcelRegister("fC5rN", function(module, exports) {

$parcel$export(module.exports, "getOpenModalData", () => $63d2f18f3a07e22e$export$580d73f81f464028);
$parcel$export(module.exports, "makeIsModalOpen", () => $63d2f18f3a07e22e$export$95fc19f697e2a886);
$parcel$export(module.exports, "isAnyModalOpen", () => $63d2f18f3a07e22e$export$5160f01afdf30a59);

var $dGvGJ = parcelRequire("dGvGJ");
const $63d2f18f3a07e22e$export$580d73f81f464028 = (state)=>state.ui.modals;
const $63d2f18f3a07e22e$export$95fc19f697e2a886 = (0, $dGvGJ.createSelector)([
    $63d2f18f3a07e22e$export$580d73f81f464028
], (modalData)=>{
    const isModalOpen = (modalType)=>modalData !== null && modalData.type === modalType;
    return isModalOpen;
});
const $63d2f18f3a07e22e$export$5160f01afdf30a59 = (0, $dGvGJ.createSelector)([
    $63d2f18f3a07e22e$export$580d73f81f464028
], (modalData)=>modalData !== null);

});


parcelRegister("8mHuU", function(module, exports) {

$parcel$export(module.exports, "PlaceholderWithLinkPicker", () => $79e7e25e4bec0355$export$fa4d34c30373beda);

var $5uXOq = parcelRequire("5uXOq");

var $5ILhZ = parcelRequire("5ILhZ");

var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $jgJNO = parcelRequire("jgJNO");

var $ousew = parcelRequire("ousew");

var $jMVum = parcelRequire("jMVum");

var $8nxpO = parcelRequire("8nxpO");
function $79e7e25e4bec0355$export$fa4d34c30373beda({ onLinkSelected: onLinkSelected, isLinkPickerOpen: isLinkPickerOpen, setIsLinkPickerOpen: setIsLinkPickerOpen, placement: placement = 'top' }) {
    const closeLinkPicker = (0, $5uXOq.useCallback)(()=>{
        setIsLinkPickerOpen(false);
    }, [
        setIsLinkPickerOpen
    ]);
    const openLinkPicker = (0, $5uXOq.useCallback)(()=>{
        setIsLinkPickerOpen(true);
    }, [
        setIsLinkPickerOpen
    ]);
    const renderLinkPicker = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jMVum.AiWorkCreateLinkPicker), {
            onLinkSelected: onLinkSelected,
            onCloseLinkPicker: closeLinkPicker
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        alignBlock: "center",
        xcss: $79e7e25e4bec0355$var$placeholderStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $79e7e25e4bec0355$var$placeholderTextStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $8nxpO.default).placeholderSmartLinkEditor,
        values: {
            link: (chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
                    messageId: "software-backlog.card-list.inline-card-create.ai-work-create.placeholder-with-link-picker.popup",
                    messageType: "transactional",
                    isOpen: isLinkPickerOpen,
                    onClose: closeLinkPicker,
                    content: renderLinkPicker,
                    placement: placement,
                    // need to pass in chunk, disabling
                    // eslint-disable-next-line jira/react-no-inline-function-prop
                    trigger: ({ ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
                            "data-testId": "software-backlog.card-list.inline-card-create.ai-work-create.placeholder-with-link-picker.link",
                            paddingInline: "space.0",
                            xcss: $79e7e25e4bec0355$var$linkPickerPromptStyles,
                            onClick: openLinkPicker,
                            ...triggerProps
                        }, chunk)
                })
        }
    })));
}
const $79e7e25e4bec0355$var$placeholderStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    color: 'color.text.subtlest',
    pointerEvents: 'none',
    zIndex: 'layer',
    height: '100%'
});
const $79e7e25e4bec0355$var$linkPickerPromptStyles = (0, $8CUq3.xcss)({
    pointerEvents: 'auto',
    color: 'color.link',
    textDecoration: 'underline',
    background: 'none'
});
const $79e7e25e4bec0355$var$placeholderTextStyles = (0, $8CUq3.xcss)({
    whiteSpace: 'pre-wrap'
});

});
parcelRegister("jMVum", function(module, exports) {

$parcel$export(module.exports, "AiWorkCreateLinkPicker", () => $bae9b2165c543fa7$export$33cffda5eb81dadb);

var $5uXOq = parcelRequire("5uXOq");

var $lDuTe = parcelRequire("lDuTe");

var $iXVV6 = parcelRequire("iXVV6");

var $bCh6z = parcelRequire("bCh6z");
var $8Xhz6 = parcelRequire("8Xhz6");

var $koeKL = parcelRequire("koeKL");

var $4cO73 = parcelRequire("4cO73");
const $bae9b2165c543fa7$var$analyticsContextData = {
    componentName: 'aiWorkCreateLinkPicker'
};
function $bae9b2165c543fa7$export$33cffda5eb81dadb({ onLinkSelected: onLinkSelected, onCloseLinkPicker: onCloseLinkPicker, onMounted: onMounted }) {
    const cloudId = (0, $koeKL.useCloudId)();
    const pluginsConf = (0, $5uXOq.useMemo)(()=>[
            {
                cloudIds: [
                    cloudId
                ],
                products: [
                    'confluence'
                ],
                scope: (0, $bCh6z.Scope).ConfluencePageBlog
            }
        ], [
        cloudId
    ]);
    const plugins = (0, $8Xhz6.useAtlassianPlugins)(pluginsConf);
    const onLinkPickerSubmit = (0, $5uXOq.useCallback)((payload)=>{
        onLinkSelected(payload.url);
        onCloseLinkPicker();
    }, [
        onCloseLinkPicker,
        onLinkSelected
    ]);
    (0, $5uXOq.useEffect)(()=>{
        onMounted?.();
    }, [
        onMounted
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: $bae9b2165c543fa7$var$analyticsContextData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lDuTe.default), {
        onSubmit: onLinkPickerSubmit,
        onCancel: onCloseLinkPicker,
        plugins: plugins,
        customMessages: (0, $4cO73.default),
        hideDisplayText: true
    }));
}

});
parcelRegister("lDuTe", function(module, exports) {

$parcel$export(module.exports, "DeprecatedLazyLinkPickerExport", () => $06adca73f1cf4268$export$23942968e751dbea);
$parcel$export(module.exports, "default", () => $06adca73f1cf4268$export$2e2bcd8739ae039);

var $bYgrr = parcelRequire("bYgrr");

var $5UISO = parcelRequire("5UISO");

var $1WP7T = parcelRequire("1WP7T");
const $06adca73f1cf4268$export$23942968e751dbea = (0, $bYgrr.default);
var // Must be a default export to be able to support prop docs
// eslint-disable-next-line import/no-default-export
$06adca73f1cf4268$export$2e2bcd8739ae039 = (0, $1WP7T.composeLinkPicker)((0, $5UISO.LinkPicker));

});
parcelRegister("bYgrr", function(module, exports) {

$parcel$export(module.exports, "default", () => $292e4b24cbca310f$export$2e2bcd8739ae039);

var $kc9vJ = parcelRequire("kc9vJ");

var $1WP7T = parcelRequire("1WP7T");

const $292e4b24cbca310f$var$LazyLinkPickerComponent = (0, $kc9vJ.lazyForPaint)(()=>Promise.resolve((parcelRequire("5UISO"))).then(({ LinkPicker: LinkPicker })=>({
            default: LinkPicker
        })));
var // Must be a default export to be able to support prop docs
// eslint-disable-next-line import/no-default-export
$292e4b24cbca310f$export$2e2bcd8739ae039 = (0, $1WP7T.composeLinkPicker)($292e4b24cbca310f$var$LazyLinkPickerComponent);

});
parcelRegister("1WP7T", function(module, exports) {

$parcel$export(module.exports, "composeLinkPicker", () => $4f4b692e16311c64$export$922eb685ceb4a294);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $kc9vJ = parcelRequire("kc9vJ");

var $daJ0i = parcelRequire("daJ0i");

var $VSDnB = parcelRequire("VSDnB");


var $4tvHl = parcelRequire("4tvHl");

var $6MmH3 = parcelRequire("6MmH3");

var $bs2KT = parcelRequire("bs2KT");

var $1tHfS = parcelRequire("1tHfS");
const $4f4b692e16311c64$export$800daf5fbbe96aff = {
    linkPickerRoot: 'link-picker-root'
};
const $4f4b692e16311c64$export$a2495bb1f182689d = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local",
    componentName: (0, $27f53d4100568677$export$fc44104665f4d1e5),
    source: (0, $27f53d4100568677$export$fc44104665f4d1e5)
};
const $4f4b692e16311c64$var$DefaultRootComponent = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": $4f4b692e16311c64$export$800daf5fbbe96aff.linkPickerRoot,
        children: children
    });
};
const $4f4b692e16311c64$var$fixedWidthContainerStyles = null;
const $4f4b692e16311c64$var$FixedWidthContainer = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...(0, $VSDnB.fg)('platform-link-picker-a11y-label') ? {
            role: 'dialog',
            'aria-modal': 'false',
            'aria-label': 'link-picker'
        } : {},
        ...props,
        className: (0, $bwpsq.default)([
            "_1bsb1ubl"
        ])
    });
};
const $4f4b692e16311c64$export$922eb685ceb4a294 = (Component)=>{
    return /*#__PURE__*/ (0, $5uXOq.memo)((props)=>{
        const { component: component } = props;
        const RootComponent = component ?? $4f4b692e16311c64$var$DefaultRootComponent;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $daJ0i.default), {
            data: $4f4b692e16311c64$export$a2495bb1f182689d,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4tvHl.LinkPickerSessionProvider), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1tHfS.MessagesProvider), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        style: {
                            ['--link-picker-width']: props.disableWidth ? '100%' : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                            `${0, $27f53d4100568677$export$bf31a09f182d5584}px`,
                            ['--link-picker-padding-left']: props.paddingLeft ?? "var(--ds-space-200, 16px)",
                            ['--link-picker-padding-right']: props.paddingRight ?? "var(--ds-space-200, 16px)",
                            ['--link-picker-padding-top']: props.paddingTop ?? "var(--ds-space-200, 16px)",
                            ['--link-picker-padding-bottom']: props.paddingBottom ?? "var(--ds-space-200, 16px)"
                        },
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)($4f4b692e16311c64$var$FixedWidthContainer, {
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6MmH3.ErrorBoundary), {
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kc9vJ.LazySuspense), {
                                    fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bs2KT.LoaderFallback), {
                                        url: props.url,
                                        hideDisplayText: props.hideDisplayText,
                                        isLoadingPlugins: props.isLoadingPlugins,
                                        plugins: props.plugins
                                    }),
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)(RootComponent, {
                                        ...props,
                                        "data-testid": $4f4b692e16311c64$export$800daf5fbbe96aff.linkPickerRoot,
                                        children: /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                                            ...props
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        });
    });
};

});
const $27f53d4100568677$export$85183a312807388d = 'media';
const $27f53d4100568677$export$fc44104665f4d1e5 = 'linkPicker';
const $27f53d4100568677$export$452f1062ecf44be7 = 5;
const $27f53d4100568677$export$bf31a09f182d5584 = 342;
const $27f53d4100568677$export$542fb16962bf430c = '290px';

parcelRegister("4tvHl", function(module, exports) {

$parcel$export(module.exports, "LinkPickerSessionProvider", () => $2694ae59f2d43701$export$2f19832fd2d620ca);
$parcel$export(module.exports, "useLinkPickerSessionId", () => $2694ae59f2d43701$export$36ecc935abdc3636);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $gmGSi = parcelRequire("gmGSi");
const $2694ae59f2d43701$export$c07727f5eddb98f = 'SESSION_UNINITIALIZED';
const $2694ae59f2d43701$export$3285420c698bc605 = /*#__PURE__*/ (0, $5uXOq.createContext)($2694ae59f2d43701$export$c07727f5eddb98f);
const $2694ae59f2d43701$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $5uXOq.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $2694ae59f2d43701$export$2f19832fd2d620ca = ({ children: children })=>{
    const { current: sessionId } = (0, $5uXOq.useRef)((0, $7Jxgt.v4)());
    (0, $5uXOq.useEffect)(()=>{
        return ()=>(0, $gmGSi.abortUfoExperience)((0, $gmGSi.ufoExperience).mounted, sessionId);
    }, [
        sessionId
    ]);
    $2694ae59f2d43701$var$useConstructor(()=>(0, $gmGSi.startUfoExperience)((0, $gmGSi.ufoExperience).mounted, sessionId));
    return /*#__PURE__*/ (0, $2OMIu.jsx)($2694ae59f2d43701$export$3285420c698bc605.Provider, {
        value: sessionId,
        children: children
    });
};
const $2694ae59f2d43701$export$36ecc935abdc3636 = ()=>(0, $5uXOq.useContext)($2694ae59f2d43701$export$3285420c698bc605);

});
parcelRegister("gmGSi", function(module, exports) {

$parcel$export(module.exports, "ufoExperience", () => $0befcde02902b9dd$export$f9c7780c574346a2);
$parcel$export(module.exports, "startUfoExperience", () => $0befcde02902b9dd$export$5e9287b6a10f8075);
$parcel$export(module.exports, "succeedUfoExperience", () => $0befcde02902b9dd$export$c5a5cf072c836c0e);
$parcel$export(module.exports, "failUfoExperience", () => $0befcde02902b9dd$export$8dda83bafca11b77);
$parcel$export(module.exports, "abortUfoExperience", () => $0befcde02902b9dd$export$b1021040eb94cdca);

var $cBycP = parcelRequire("cBycP");
var $7Zbvr = parcelRequire("7Zbvr");
const $0befcde02902b9dd$export$f9c7780c574346a2 = {
    mounted: 'component-mounted'
};
const $0befcde02902b9dd$var$ufoExperiences = {
    [$0befcde02902b9dd$export$f9c7780c574346a2.mounted]: new (0, $cBycP.ConcurrentExperience)($0befcde02902b9dd$export$f9c7780c574346a2.mounted, {
        type: (0, $7Zbvr.ExperienceTypes).Load,
        performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).PageSegmentLoad,
        platform: {
            component: 'link-picker'
        }
    })
};
const $0befcde02902b9dd$export$5e9287b6a10f8075 = (experienceName, id, metadata)=>{
    const experience = $0befcde02902b9dd$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (metadata) experience.addMetadata(metadata);
};
const $0befcde02902b9dd$export$c5a5cf072c836c0e = (experienceName, id, metadata)=>{
    const experience = $0befcde02902b9dd$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: metadata
    });
};
const $0befcde02902b9dd$export$8dda83bafca11b77 = (experienceName, id, metadata)=>{
    const experience = $0befcde02902b9dd$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: metadata
    });
};
const $0befcde02902b9dd$export$b1021040eb94cdca = (experienceName, id, metadata)=>{
    const experience = $0befcde02902b9dd$var$ufoExperiences[experienceName].getInstance(id);
    experience.abort({
        metadata: metadata
    });
};

});


parcelRegister("6MmH3", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $a31421eb288e6506$export$e926676385687eaf);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $gmGSi = parcelRequire("gmGSi");


var $eTwyk = parcelRequire("eTwyk");

var $4tvHl = parcelRequire("4tvHl");

var $eOoN4 = parcelRequire("eOoN4");

var $iUFh3 = parcelRequire("iUFh3");
function $a31421eb288e6506$export$e926676385687eaf({ children: children }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const linkPickerSessionId = (0, $4tvHl.useLinkPickerSessionId)();
    const handleError = (0, $5uXOq.useCallback)((error, info)=>{
        // Fire Analytics event
        createAnalyticsEvent((0, $eTwyk.default)('ui.linkPicker.unhandledErrorCaught', {
            browserInfo: window?.navigator?.userAgent || 'unknown',
            error: error.toString(),
            componentStack: info?.componentStack ?? ''
        })).fire((0, $27f53d4100568677$export$85183a312807388d));
        // Fire UFO failed experience
        (0, $gmGSi.failUfoExperience)((0, $gmGSi.ufoExperience).mounted, linkPickerSessionId);
    }, [
        createAnalyticsEvent,
        linkPickerSessionId
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eOoN4.BaseErrorBoundary), {
        onError: handleError,
        ErrorComponent: (0, $iUFh3.ErrorBoundaryFallback),
        children: children
    });
}

});
parcelRegister("eTwyk", function(module, exports) {

$parcel$export(module.exports, "default", () => $221eef4bea14ce3e$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::cd5b926575a5c379425d0d72e5339f12>>
 * @codegenCommand yarn workspace @atlaskit/link-picker run codegen-analytics
 */ function $221eef4bea14ce3e$var$createEventPayload(eventKey, attributes) {
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        action: action,
        attributes: attributes
    };
}
var $221eef4bea14ce3e$export$2e2bcd8739ae039 = $221eef4bea14ce3e$var$createEventPayload;

});

parcelRegister("eOoN4", function(module, exports) {

$parcel$export(module.exports, "BaseErrorBoundary", () => $93e98841d934b802$export$688779ac61ee945f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
class $93e98841d934b802$export$688779ac61ee945f extends (0, $5uXOq.Component) {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    componentDidCatch(error, info) {
        const { onError: onError } = this.props;
        onError && onError(error, info);
        this.setState({
            hasError: true
        });
    }
    render() {
        const { children: children, ErrorComponent: ErrorComponent } = this.props;
        const { hasError: hasError } = this.state;
        if (hasError && ErrorComponent) return /*#__PURE__*/ (0, $2OMIu.jsx)(ErrorComponent, {});
        return children;
    }
}

});

parcelRegister("iUFh3", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundaryFallback", () => $1632729b10cbec8f$export$8a28b7e38e4685dd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");

var $VSDnB = parcelRequire("VSDnB");


var $czNpL = parcelRequire("czNpL");

var $kDdjl = parcelRequire("kDdjl");

var $1aIRG = parcelRequire("1aIRG");

var $7OUbW = parcelRequire("7OUbW");
const $1632729b10cbec8f$var$errorBoundaryFallbackStyles = null;
const $1632729b10cbec8f$var$oldErrorBoundaryFallbackStyles = null;
const $1632729b10cbec8f$var$messages = (0, $7VHMR.defineMessages)({
    heading: {
        defaultMessage: 'Something went wrong!',
        description: 'Heading displayed when an unhandled error occurs.',
        id: 'fabric.linkPicker.unhandledError.heading'
    },
    description: {
        defaultMessage: 'Try reloading the page.',
        description: 'Body message shown underneath the heading when an unhandled error occurs.',
        id: 'fabric.linkPicker.unhandledError.description'
    }
});
const $1632729b10cbec8f$export$8a28b7e38e4685dd = ()=>{
    const intl = (0, $koVbs.default)();
    const header = intl.formatMessage($1632729b10cbec8f$var$messages.heading);
    const description = intl.formatMessage($1632729b10cbec8f$var$messages.description);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7OUbW.MinHeightContainer), {
        minHeight: (0, $27f53d4100568677$export$542fb16962bf430c),
        "data-testid": "link-picker-root-error-boundary-ui",
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_11c81vhk" : "_vwz44jg8"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1aIRG.EmptyState), {
            header: header,
            renderImage: (0, $VSDnB.fg)('platform-linking-visual-refresh-link-picker') ? ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kDdjl.GenericErrorSVGV2), {}) : ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $czNpL.GenericErrorSVG), {}),
            description: description
        })
    });
};

});
parcelRegister("czNpL", function(module, exports) {

$parcel$export(module.exports, "GenericErrorSVG", () => $7540c2e2574c2930$export$e54420a1a27457a4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $7540c2e2574c2930$var$HEIGHT = 90;
const $7540c2e2574c2930$var$genericErrorStyles = null;
const $7540c2e2574c2930$export$e54420a1a27457a4 = (props)=>{
    const id = 'link-picker-ui-generic-error-svg';
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        height: "90",
        viewBox: "0 0 164 212",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        className: (0, $bwpsq.default)([
            "_4t3il1r9 _1e0c1ule"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "m95.43 74.16 66.44 115.08c5.84 10.12-1.46 22.76-13.14 22.76H15.85c-11.68 0-18.98-12.65-13.14-22.76L69.15 74.16c5.84-10.12 20.44-10.12 26.28 0Zm-7.56 83.55 2.88-44.35c.34-5.29-3.86-9.78-9.16-9.78-5.31 0-9.51 4.48-9.16 9.78l2.88 44.35a6.3 6.3 0 0 0 6.28 5.89c3.31 0 6.06-2.58 6.28-5.89Zm-15.84 23.54c0 5.66 4.76 10.1 10.39 9.58 4.85-.45 8.73-4.5 8.83-9.37.11-5.45-4.31-9.94-9.73-9.94-5.23-.01-9.49 4.37-9.49 9.73Z",
                fill: `url(#${id})`
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                opacity: ".6",
                d: "M93.35 27.17 85.94.45c-.17-.62-1.07-.58-1.19.05l-4.66 25.1-5.8-1.08a.612.612 0 0 0-.7.76L81 52c.17.62 1.07.58 1.19-.05l4.66-25.1 5.8 1.08c.45.08.82-.33.7-.76ZM66.77 41.81 55.9 33.26c-.22-.18-.53.07-.41.33l5.53 11.43-2.66 1.29c-.18.09-.2.33-.05.45l10.87 8.55c.22.18.53-.07.41-.33l-5.53-11.43 2.66-1.29c.17-.08.2-.33.05-.45Z",
                fill: "#C1C7D0"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                opacity: ".6",
                d: "M102.78 56.75a.993.993 0 0 1-.92-1.38c-.24-.77-2.29-2.85-3.54-4.11-2.97-3.01-4.93-5-3.84-6.49 1.09-1.48 3.58-.22 7.35 1.7 1.32.67 3.35 1.7 4.45 2.03-.64-.95-2.24-2.58-3.28-3.63-2.97-3.01-4.93-5-3.84-6.49 1.08-1.48 3.58-.22 7.34 1.7 1.32.67 3.34 1.7 4.45 2.03-.64-.95-2.24-2.57-3.28-3.62-2.97-3.01-4.93-5-3.84-6.49 1.08-1.48 3.57-.22 7.34 1.7 1.58.8 4.18 2.13 4.98 2.13a1.005 1.005 0 0 1 1.46 1.36c-1.09 1.48-3.57.22-7.34-1.7-1.32-.67-3.34-1.7-4.44-2.03.64.95 2.24 2.57 3.28 3.62 2.97 3.01 4.93 5 3.84 6.49-1.08 1.48-3.57.22-7.34-1.7-1.32-.67-3.35-1.7-4.45-2.03.64.95 2.24 2.57 3.28 3.63 2.97 3.01 4.93 5 3.84 6.49-1.09 1.48-3.58.22-7.35-1.7-1.32-.67-3.35-1.71-4.45-2.03.64.95 2.24 2.58 3.28 3.63 2.97 3.01 4.93 5 3.84 6.49-.21.26-.51.4-.82.4Zm5.56 14.32c-.35 0-.69-.19-.88-.52-1.04-1.88-2.22-4.02-.91-5.21 1.31-1.2 3.34.18 5.49 1.63.87.59 2.26 1.53 2.93 1.71-.12-.68-.93-2.15-1.45-3.07-1.26-2.27-2.45-4.41-1.14-5.61 1.31-1.2 3.34.18 5.49 1.63.96.65 2.54 1.72 3.1 1.74a1 1 0 0 1 1.27 1.54c-1.31 1.2-3.34-.17-5.49-1.63-.87-.59-2.26-1.53-2.93-1.71.12.68.93 2.15 1.45 3.07 1.26 2.27 2.45 4.41 1.14 5.61-1.31 1.2-3.34-.18-5.49-1.63-.87-.59-2.26-1.53-2.93-1.71.12.68.93 2.14 1.22 2.67.27.48.09 1.09-.39 1.36-.15.09-.32.13-.48.13Zm-54.32-2.89c-.22 0-.44-.04-.67-.14-1.64-.69-1.24-3.11-.81-5.67.17-1.04.45-2.7.33-3.38-.57.39-1.56 1.75-2.18 2.6-1.53 2.09-2.99 4.07-4.62 3.38a.991.991 0 0 1-.53-1.31c.2-.48.73-.72 1.21-.57.52-.21 1.65-1.75 2.34-2.68 1.53-2.09 2.98-4.08 4.62-3.38 1.64.69 1.24 3.11.81 5.67-.17 1.04-.45 2.7-.33 3.38.57-.39 1.56-1.75 2.18-2.6 1.53-2.09 2.98-4.08 4.62-3.38 1.63.69 1.24 3.09.89 5.21-.09.54-.6.91-1.15.83-.54-.09-.92-.6-.83-1.15.1-.59.37-2.24.26-2.92-.57.39-1.56 1.75-2.18 2.6-1.33 1.79-2.59 3.51-3.96 3.51Z",
                fill: "#B3BAC5"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("defs", {
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                    id: id,
                    x1: "26.169",
                    y1: "228.621",
                    x2: "138.408",
                    y2: "116.382",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                            stopColor: "#C1C7D0"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                            offset: ".297",
                            stopColor: "#C6CBD4",
                            stopOpacity: ".881"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                            offset: ".63",
                            stopColor: "#D3D7DE",
                            stopOpacity: ".748"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                            offset: ".98",
                            stopColor: "#E9EBEF",
                            stopOpacity: ".608"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                            offset: "1",
                            stopColor: "#EBECF0",
                            stopOpacity: ".6"
                        })
                    ]
                })
            })
        ]
    });
};

});

parcelRegister("kDdjl", function(module, exports) {

$parcel$export(module.exports, "GenericErrorSVGV2", () => $3f7dddc5723e881c$export$c890415b8eb68ca7);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $3f7dddc5723e881c$var$SIZE = 96;
const $3f7dddc5723e881c$var$genericErrorStyles = null;
const $3f7dddc5723e881c$export$c890415b8eb68ca7 = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        viewBox: "0 0 96 96",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        className: (0, $bwpsq.default)([
            "_1bsb16xz _4t3i16xz _1e0c1ule"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fill: "#fff",
                d: "M64.861 32.06a27.753 27.753 0 0 0-2.667-4.133 28.187 28.187 0 0 0-3.376-3.669c-6.985-6.311-15.57-6.89-23.609-2.53a30.226 30.226 0 0 0-4.056 2.656 30.624 30.624 0 0 0-3.735 3.4c-6.225 6.717-7.82 15.154-3.505 23.462a28.108 28.108 0 0 0 2.698 4.193 27.67 27.67 0 0 0 3.33 3.62c6.94 6.266 15.518 6.85 23.596 2.507a30.492 30.492 0 0 0 4.23-2.758 30.07 30.07 0 0 0 3.593-3.257c6.252-6.692 7.847-15.161 3.494-23.49h.007Z"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fill: "#DDDEE1",
                d: "M43.092 66.774c-5.306 0-10.382-1.997-14.75-5.938a30.405 30.405 0 0 1-3.62-3.93 30.243 30.243 0 0 1-2.928-4.553c-4.657-8.961-3.247-18.509 3.871-26.192a33.271 33.271 0 0 1 4.025-3.67 32.834 32.834 0 0 1 4.378-2.869c9.209-4.995 18.816-3.951 26.353 2.86a30.945 30.945 0 0 1 3.665 3.98 30.303 30.303 0 0 1 2.898 4.488c4.705 9.003 3.295 18.565-3.868 26.231a32.148 32.148 0 0 1-3.879 3.515 33.415 33.415 0 0 1-4.562 2.975c-3.858 2.073-7.782 3.1-11.583 3.1v.003Zm2.53-45.486c-3.019 0-6.147.84-9.275 2.54a28.433 28.433 0 0 0-3.735 2.448 28.059 28.059 0 0 0-3.442 3.135c-5.746 6.203-6.86 13.566-3.135 20.736a25.395 25.395 0 0 0 2.472 3.83 25.304 25.304 0 0 0 3.044 3.309c5.99 5.41 13.398 6.182 20.862 2.175a28.02 28.02 0 0 0 3.899-2.545 28.03 28.03 0 0 0 3.31-2.999c5.777-6.182 6.883-13.552 3.124-20.75a25.553 25.553 0 0 0-2.44-3.777 25.848 25.848 0 0 0-3.087-3.358c-3.49-3.153-7.442-4.744-11.59-4.744h-.006Z"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fill: "#DDDEE1",
                d: "M62.822 59.694c-1.235-1.72-2.562-1.71-3.857-.708-1.215.939-1.54 2.21-.244 3.882l1.48 1.913 4.102-3.174-1.48-1.913Z"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fill: "#DDDEE1",
                d: "m65.334 60.811-6.159 4.762L70.748 80.54l6.16-4.761L65.333 60.81Z"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fill: "#B7B9BE",
                d: "m64.344 61.577-4.178 3.23 3.925 5.076 4.178-3.23-3.925-5.076Z"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fill: "#DDDEE1",
                fillRule: "evenodd",
                d: "M55.057 33.452 36.213 52.296l-2.468-2.469 18.844-18.844 2.468 2.469Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fill: "#DDDEE1",
                fillRule: "evenodd",
                d: "M52.589 52.296 33.745 33.452l2.468-2.469 18.844 18.844-2.468 2.469Z",
                clipRule: "evenodd"
            })
        ]
    });
};

});

parcelRegister("1aIRG", function(module, exports) {

$parcel$export(module.exports, "EmptyState", () => $07ecb85b552d1f4c$export$fddf379e22a74b00);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $VSDnB = parcelRequire("VSDnB");

var $bUmQV = parcelRequire("bUmQV");
var $dS3PR = parcelRequire("dS3PR");
const $07ecb85b552d1f4c$var$styles = {
    container: "_1pfhoahv _6rthoahv _y3gn1h6o",
    containerV2: "_ca0q1ejb _u5f3oahv _19bvoahv _n3td1jfw _y3gn1h6o"
};
const $07ecb85b552d1f4c$export$fddf379e22a74b00 = ({ testId: testId, header: header, description: description, action: action, renderImage: renderImage })=>{
    if ((0, $VSDnB.fg)('platform-linking-visual-refresh-link-picker')) return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bUmQV.default), {
        xcss: $07ecb85b552d1f4c$var$styles.containerV2,
        testId: testId,
        direction: "column",
        alignItems: "center",
        gap: "space.200",
        children: [
            renderImage?.(),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                size: "small",
                as: "h2",
                children: header
            }),
            description && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                as: "p",
                color: "color.text",
                children: description
            }),
            action && action
        ]
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bUmQV.default), {
        xcss: $07ecb85b552d1f4c$var$styles.container,
        testId: testId,
        direction: "column",
        alignItems: "center",
        gap: "space.300",
        children: [
            renderImage?.(),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bUmQV.default), {
                direction: "column",
                alignItems: "center",
                gap: "space.200",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                        size: "medium",
                        as: "h2",
                        children: header
                    }),
                    description && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                        as: "p",
                        color: "color.text",
                        children: description
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("7OUbW", function(module, exports) {

$parcel$export(module.exports, "MinHeightContainer", () => $0aea99783ced9613$export$42134e2a251518b3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");
const $0aea99783ced9613$var$minHeightComponentStyles = null;
const $0aea99783ced9613$export$42134e2a251518b3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ className: className, minHeight: minHeight, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1fhb _1bah1h6o _1tke16li",
            className
        ]),
        ...props,
        style: {
            ['--link-picker-min-height']: minHeight
        }
    });
});

});



parcelRegister("bs2KT", function(module, exports) {

$parcel$export(module.exports, "LoaderFallback", () => $e4be65be0752e81a$export$d96e921133238c41);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eZJjh = parcelRequire("eZJjh");

var $7OUbW = parcelRequire("7OUbW");
const $e4be65be0752e81a$var$styles = null;
const $e4be65be0752e81a$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT = '472px';
const $e4be65be0752e81a$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT = '550px';
const $e4be65be0752e81a$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT = '505px';
const $e4be65be0752e81a$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT = '429px';
const $e4be65be0752e81a$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT = '218px';
const $e4be65be0752e81a$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT = '141px';
const $e4be65be0752e81a$var$getEstimatedMinHeight = ({ hideDisplayText: hideDisplayText, isLoadingPlugins: isLoadingPlugins, plugins: plugins, url: url })=>{
    /**
   * "Insert mode" (search results shown initially)
   */ if (!url) {
        /**
     * With tabs
     */ if (plugins && plugins.length > 1 || isLoadingPlugins) return hideDisplayText ? $e4be65be0752e81a$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT : $e4be65be0752e81a$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT;
        /**
     * Without tabs
     */ if (plugins?.length === 1) return hideDisplayText ? $e4be65be0752e81a$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT : $e4be65be0752e81a$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT;
    }
    return hideDisplayText ? $e4be65be0752e81a$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT : $e4be65be0752e81a$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT;
};
const $e4be65be0752e81a$export$d96e921133238c41 = (props)=>{
    const minHeight = $e4be65be0752e81a$var$getEstimatedMinHeight(props);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7OUbW.MinHeightContainer), {
        minHeight: minHeight,
        "data-testid": "link-picker-root-loader-boundary-ui",
        className: (0, $bwpsq.default)([
            "_4cvr1h6o"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
            testId: "link-picker.component-loading-indicator",
            interactionName: props.name || 'link-picker-loading',
            size: "medium"
        })
    });
};

});

parcelRegister("1tHfS", function(module, exports) {

$parcel$export(module.exports, "MessagesProvider", () => $cfc46959224b6657$export$54320b51a950d54a);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $kAHGP = parcelRequire("kAHGP");
const $cfc46959224b6657$export$54320b51a950d54a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kAHGP.LazyMessagesProvider), {
        children: children
    });
};

});
parcelRegister("kAHGP", function(module, exports) {

$parcel$export(module.exports, "LazyMessagesProvider", () => $0b8930421407a29b$export$d013d33430f9fb4b);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $96nTn = parcelRequire("96nTn");

var $6JvbH = parcelRequire("6JvbH");

var $9qeGT = parcelRequire("9qeGT");
const $0b8930421407a29b$export$d013d33430f9fb4b = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $96nTn.default), {
        defaultMessages: (0, $6JvbH.default),
        loaderFn: (0, $9qeGT.fetchMessagesForLocale),
        children: children
    });
};

});
parcelRegister("6JvbH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e60a6ae0bcd067f5$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $e60a6ae0bcd067f5$export$2e2bcd8739ae039 = {
    'fabric.linkPicker.button.cancel': 'Cancel',
    'fabric.linkPicker.button.insert': 'Insert',
    'fabric.linkPicker.button.save': 'Save',
    'fabric.linkPicker.clearLink': 'Clear',
    'fabric.linkPicker.clearLinkText': 'Clear text',
    'fabric.linkPicker.hyperlink.searchLinkResults': '{count, plural, =0 {no results} one {# result} other {# results}} found',
    'fabric.linkPicker.linkAriaLabel': 'Type or paste a link into the field',
    'fabric.linkPicker.linkHelperTextAriaLabel': 'Link display helper text',
    'fabric.linkPicker.linkHelperTextLabel': 'Give this link a title or description',
    'fabric.linkPicker.linkInvalid': 'Enter a valid URL.',
    'fabric.linkPicker.linkLabel': 'Link',
    'fabric.linkPicker.linkPlaceholder': 'Paste a link',
    'fabric.linkPicker.linkTextAriaLabel': 'Link display text',
    'fabric.linkPicker.linkTextLabel': 'Display text (optional)',
    'fabric.linkPicker.linkTextPlaceholder': 'Text to display',
    'fabric.linkPicker.listTitle.recentlyViewed': 'Recently Viewed',
    'fabric.linkPicker.listTitle.results': 'Results',
    'fabric.linkPicker.search.error.description': 'Refresh the page, or contact <a>Atlassian Support</a> if this keeps happening.',
    'fabric.linkPicker.search.error.heading': "We\u2019re having trouble loading data.",
    'fabric.linkPicker.search.error.retry': 'Refresh',
    'fabric.linkPicker.search.linkAriaLabel': 'Suggestions will appear below as you type into the field',
    'fabric.linkPicker.search.linkLabel': 'Search or paste a link',
    'fabric.linkPicker.search.linkPlaceholder': 'Find recent links or paste a new link',
    'fabric.linkPicker.search.noResults.description': 'Try again with a different term.',
    'fabric.linkPicker.search.noResults.heading': "We couldn\u2019t find anything matching your search.",
    'fabric.linkPicker.status.submitting': 'Submitting',
    'fabric.linkPicker.time.message.updated': 'Updated {time}',
    'fabric.linkPicker.time.message.viewed': 'Viewed {time}',
    'fabric.linkPicker.unhandledError.description': 'Try reloading the page.',
    'fabric.linkPicker.unhandledError.heading': 'Something went wrong!',
    foo: 'Default string'
};

});

parcelRegister("9qeGT", function(module, exports) {

$parcel$export(module.exports, "fetchMessagesForLocale", () => $1b4e714d67ee4b58$export$2b153a2030b0feb2);

var $82GLV = parcelRequire("82GLV");
const $1b4e714d67ee4b58$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const localeKey = locale.replace('-', '_');
        if (localeKey in (0, $82GLV.locales)) {
            const messages = await (0, $82GLV.locales)[localeKey]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        if (parentLocale in (0, $82GLV.locales)) {
            const messages = await (0, $82GLV.locales)[parentLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
};

});
parcelRegister("82GLV", function(module, exports) {

$parcel$export(module.exports, "locales", () => $4eb6bd651e0fd6dc$export$df1c34db1371eeed);

























const $4eb6bd651e0fd6dc$export$df1c34db1371eeed = {
    cs: ()=>(parcelRequire("iWpVc")),
    da: ()=>(parcelRequire("lQT2J")),
    de: ()=>(parcelRequire("exeTo")),
    en_GB: ()=>(parcelRequire("9bJE8")),
    en_ZZ: ()=>(parcelRequire("gli0Q")),
    en: ()=>Promise.resolve((parcelRequire("6JvbH"))),
    es: ()=>(parcelRequire("fDjO3")),
    fi: ()=>(parcelRequire("e0rTh")),
    fr: ()=>(parcelRequire("1rC2K")),
    hu: ()=>(parcelRequire("6oMTl")),
    it: ()=>(parcelRequire("k2TNi")),
    ja: ()=>(parcelRequire("eOkJs")),
    ko: ()=>(parcelRequire("2qOU6")),
    nb: ()=>(parcelRequire("ewF7D")),
    nl: ()=>(parcelRequire("cPrOt")),
    pl: ()=>(parcelRequire("qONjj")),
    pt_BR: ()=>(parcelRequire("2VNBN")),
    ru: ()=>(parcelRequire("bKUUY")),
    sv: ()=>(parcelRequire("jIyu7")),
    th: ()=>(parcelRequire("7yFJa")),
    tr: ()=>(parcelRequire("lNQcp")),
    uk: ()=>(parcelRequire("hRaCQ")),
    vi: ()=>(parcelRequire("aPFKw")),
    zh_TW: ()=>(parcelRequire("dxSeQ")),
    zh: ()=>(parcelRequire("nYdGI"))
};

});
parcelRegister("iWpVc", function(module, exports) {

let $dca1c03c65038a2b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $dca1c03c65038a2b$var$load("6hBVK").then(()=>parcelRequire('hxTpR'));

});

parcelRegister("lQT2J", function(module, exports) {

let $fe8926b49d6bf4ff$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fe8926b49d6bf4ff$var$load("e4h4P").then(()=>parcelRequire('6zDV7'));

});

parcelRegister("exeTo", function(module, exports) {

let $a94fb3158d1ce04a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a94fb3158d1ce04a$var$load("6cp8c").then(()=>parcelRequire('3pHpm'));

});

parcelRegister("9bJE8", function(module, exports) {

let $6b088c8c403881d1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6b088c8c403881d1$var$load("d03Lb").then(()=>parcelRequire('lV04b'));

});

parcelRegister("gli0Q", function(module, exports) {

let $be5c9476e09c2488$var$load = (parcelRequire("28QjX"))(4);
module.exports = $be5c9476e09c2488$var$load("bleJt").then(()=>parcelRequire('khAmU'));

});

parcelRegister("fDjO3", function(module, exports) {

let $b619dca708cf5b41$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b619dca708cf5b41$var$load("25r0L").then(()=>parcelRequire('8GUOz'));

});

parcelRegister("e0rTh", function(module, exports) {

let $a326b34000e4ff71$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a326b34000e4ff71$var$load("l5ljU").then(()=>parcelRequire('4QluW'));

});

parcelRegister("1rC2K", function(module, exports) {

let $10d5d2aa27287ae6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $10d5d2aa27287ae6$var$load("g813d").then(()=>parcelRequire('hLNj0'));

});

parcelRegister("6oMTl", function(module, exports) {

let $4a8ae8d1901df04a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4a8ae8d1901df04a$var$load("cWZHg").then(()=>parcelRequire('8XZGW'));

});

parcelRegister("k2TNi", function(module, exports) {

let $e97f4619ee3468fe$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e97f4619ee3468fe$var$load("dLcQ9").then(()=>parcelRequire('ibOo1'));

});

parcelRegister("eOkJs", function(module, exports) {

let $ac85d127feee22d9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ac85d127feee22d9$var$load("hZKcK").then(()=>parcelRequire('eHx02'));

});

parcelRegister("2qOU6", function(module, exports) {

let $1c557ef2a06780d0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1c557ef2a06780d0$var$load("evNfQ").then(()=>parcelRequire('bjfCW'));

});

parcelRegister("ewF7D", function(module, exports) {

let $a933f3d6eec736a7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a933f3d6eec736a7$var$load("e3wLR").then(()=>parcelRequire('86hzk'));

});

parcelRegister("cPrOt", function(module, exports) {

let $956fd28a576a0094$var$load = (parcelRequire("28QjX"))(4);
module.exports = $956fd28a576a0094$var$load("hLvb6").then(()=>parcelRequire('bpOU2'));

});

parcelRegister("qONjj", function(module, exports) {

let $0509d484dc0f927b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0509d484dc0f927b$var$load("la8cf").then(()=>parcelRequire('9B1xP'));

});

parcelRegister("2VNBN", function(module, exports) {

let $222762dcce05b7d7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $222762dcce05b7d7$var$load("hRFEQ").then(()=>parcelRequire('iOkVk'));

});

parcelRegister("bKUUY", function(module, exports) {

let $88f02448fc2f0cce$var$load = (parcelRequire("28QjX"))(4);
module.exports = $88f02448fc2f0cce$var$load("luWdK").then(()=>parcelRequire('84wGJ'));

});

parcelRegister("jIyu7", function(module, exports) {

let $e5ace057cd47c2df$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e5ace057cd47c2df$var$load("6Za1J").then(()=>parcelRequire('9U5fj'));

});

parcelRegister("7yFJa", function(module, exports) {

let $580c139bc9c9bd8c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $580c139bc9c9bd8c$var$load("6DgQw").then(()=>parcelRequire('eAdVI'));

});

parcelRegister("lNQcp", function(module, exports) {

let $fdf6aa3f580adf9a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fdf6aa3f580adf9a$var$load("6O0Ad").then(()=>parcelRequire('gb3Xv'));

});

parcelRegister("hRaCQ", function(module, exports) {

let $cfffa0ea99d0fd2a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cfffa0ea99d0fd2a$var$load("3mmmm").then(()=>parcelRequire('933Ox'));

});

parcelRegister("aPFKw", function(module, exports) {

let $7e2f0d5cd25d63f9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7e2f0d5cd25d63f9$var$load("2XCUS").then(()=>parcelRequire('hQPuK'));

});

parcelRegister("dxSeQ", function(module, exports) {

let $9dc86e11d71bc855$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9dc86e11d71bc855$var$load("5QaBz").then(()=>parcelRequire('9nhwi'));

});

parcelRegister("nYdGI", function(module, exports) {

let $0480dc7d6dbb6970$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0480dc7d6dbb6970$var$load("irHqQ").then(()=>parcelRequire('s579P'));

});







parcelRegister("5UISO", function(module, exports) {

$parcel$export(module.exports, "LinkPicker", () => $7b540b3fc96df6b6$export$901b688e8da62820);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $7Jxgt = parcelRequire("7Jxgt");

var $2NMNM = parcelRequire("2NMNM");

var $qfj8c = parcelRequire("qfj8c");

var $7cFR3 = parcelRequire("7cFR3");

var $57Lhk = parcelRequire("57Lhk");

var $b6uPu = parcelRequire("b6uPu");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $iHvAB = parcelRequire("iHvAB");

var $jldZL = parcelRequire("jldZL");

var $lFfL4 = parcelRequire("lFfL4");
var $8xwTn = parcelRequire("8xwTn");


var $eTwyk = parcelRequire("eTwyk");

var $4ghTo = parcelRequire("4ghTo");

var $cVNWU = parcelRequire("cVNWU");

var $5pDOa = parcelRequire("5pDOa");

var $cLOqK = parcelRequire("cLOqK");

var $hFJqt = parcelRequire("hFJqt");

var $dzP3c = parcelRequire("dzP3c");

var $4iG8d = parcelRequire("4iG8d");

var $eUvbr = parcelRequire("eUvbr");

var $9Oh9U = parcelRequire("9Oh9U");

var $y118H = parcelRequire("y118H");

var $5w02V = parcelRequire("5w02V");
const $7b540b3fc96df6b6$var$styles = {
    fullWidthSubmitButton: "_19pkpxbi _1e0c1txw _2lx21bp4",
    linkDisplayHelperTextContainer: "_19pk1b66 _syaz1be1",
    linkDisplayHelperText: "_11c81o8v"
};
const $7b540b3fc96df6b6$var$baseRootContainerStyles = null;
// To be removed when platform-linking-visual-refresh-v1 is removed
const $7b540b3fc96df6b6$var$oldRootContainerStyles = null;
const $7b540b3fc96df6b6$var$formFooterMargin = null;
const $7b540b3fc96df6b6$export$800daf5fbbe96aff = {
    linkPickerRoot: 'link-picker-root',
    linkPicker: 'link-picker',
    urlInputField: 'link-url',
    textInputField: 'link-text',
    linkHelperText: 'link-helper-text',
    ...(0, $eUvbr.testIds),
    ...(0, $hFJqt.testIds),
    ...(0, $9Oh9U.testIds)
};
const $7b540b3fc96df6b6$var$initState = {
    url: '',
    displayText: '',
    activeIndex: -1,
    selectedIndex: -1,
    invalidUrl: false,
    activeTab: 0,
    preventHidingRecents: false,
    hasPreview: true
};
function $7b540b3fc96df6b6$var$reducer(state, payload) {
    if (payload.url && state.url !== payload.url) return {
        ...state,
        invalidUrl: false,
        hasPreview: true,
        selectedIndex: (0, $57Lhk.isSafeUrl)(payload.url) && payload.url.length ? -1 : state.selectedIndex,
        ...payload
    };
    return {
        ...state,
        ...payload
    };
}
/**
 * Bind input fields to analytics tracking
 */ const $7b540b3fc96df6b6$var$getLinkFieldContent = (value)=>{
    if (!Boolean(value)) return null;
    return (0, $57Lhk.isSafeUrl)(value) ? 'url' : 'text_string';
};
const $7b540b3fc96df6b6$var$LinkInputField = (0, $8xwTn.withInputFieldTracking)((0, $9Oh9U.TextInput), 'link', (event, attributes)=>({
        ...attributes,
        linkFieldContent: $7b540b3fc96df6b6$var$getLinkFieldContent(event.currentTarget.value)
    }));
const $7b540b3fc96df6b6$var$DisplayTextInputField = (0, $8xwTn.withInputFieldTracking)((0, $9Oh9U.TextInput), 'displayText');
const $7b540b3fc96df6b6$var$client = new (0, $7cFR3.default)();
const $7b540b3fc96df6b6$export$901b688e8da62820 = (0, $lFfL4.withLinkPickerAnalyticsContext)(/*#__PURE__*/ (0, $5uXOq.memo)(({ onSubmit: onSubmit, onCancel: onCancel, onContentResize: onContentResize, plugins: plugins, isLoadingPlugins: isLoadingPlugins, url: initUrl, displayText: initDisplayText, hideDisplayText: hideDisplayText, featureFlags: featureFlags, customMessages: customMessages, isSubmitting: isSubmitting = false, adaptiveHeight: adaptiveHeight = false, moveSubmitButton: moveSubmitButton = false, inputRef: inputRef, previewableLinksOnly: previewableLinksOnly = false, additionalError: additionalError })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [state, dispatch] = (0, $5uXOq.useReducer)($7b540b3fc96df6b6$var$reducer, {
        ...$7b540b3fc96df6b6$var$initState,
        url: (0, $57Lhk.normalizeUrl)(initUrl) || '',
        displayText: initDisplayText || ''
    });
    const { activeIndex: activeIndex, selectedIndex: selectedIndex, url: url, displayText: displayText, invalidUrl: invalidUrl, activeTab: activeTab, hasPreview: hasPreview } = state;
    const intl = (0, $koVbs.default)();
    const queryState = (0, $5pDOa.useSearchQuery)(state);
    const { items: items, isLoading: isLoadingResults, isActivePlugin: isActivePlugin, activePlugin: activePlugin, tabs: tabs, error: error, retry: retry, pluginAction: pluginAction } = (0, $cVNWU.usePlugins)(queryState, activeTab, plugins);
    const isEditing = !!initUrl;
    const selectedItem = items?.[selectedIndex];
    const isSelectedItem = selectedItem?.url === url;
    const previewableOnly = (0, $VSDnB.fg)('platform-linking-link-picker-previewable-only') && previewableLinksOnly;
    const { trackAttribute: trackAttribute, getAttributes: getAttributes } = (0, $lFfL4.useLinkPickerAnalytics)();
    const submitMessageId = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))(), []);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (onContentResize) onContentResize();
    }, [
        onContentResize,
        items,
        isLoadingResults,
        isActivePlugin,
        tabs
    ]);
    const handleChangeUrl = (0, $5uXOq.useCallback)((e)=>{
        if (isSubmitting) // Prevent changing url while submitting
        return;
        /** Any on change event is triggered by manual input or paste, so source is null */ trackAttribute('linkFieldContentInputSource', null);
        dispatch({
            url: e.currentTarget.value,
            // If the last action was changing tabs, make sure we're now allowing recents to be hidden
            preventHidingRecents: false
        });
    }, [
        dispatch,
        trackAttribute,
        isSubmitting
    ]);
    const handleChangeText = (0, $5uXOq.useCallback)((e)=>{
        dispatch({
            displayText: e.currentTarget.value
        });
    }, [
        dispatch
    ]);
    const handleClear = (0, $5uXOq.useCallback)((field)=>{
        dispatch({
            activeIndex: -1,
            selectedIndex: -1,
            [field]: '',
            hasPreview: true
        });
    }, [
        dispatch
    ]);
    const handleUrlClear = (0, $5uXOq.useCallback)(()=>{
        if (isSubmitting) // Prevent clearing url while submitting
        return;
        trackAttribute('linkFieldContentInputSource', null);
        handleClear('url');
    }, [
        trackAttribute,
        handleClear,
        isSubmitting
    ]);
    const handleInsert = (0, $5uXOq.useCallback)((url, title, inputType, data)=>{
        const event = createAnalyticsEvent((0, $eTwyk.default)('ui.form.submitted.linkPicker', {}));
        // Clone the event so that it can be emitted for consumer usage
        // This must happen BEFORE the original event is fired!
        const consumerEvent = event.clone();
        // Cloned event doesnt have the attributes that are added by
        // the analytics listener in the LinkPickerAnalyticsContext, add them here
        consumerEvent?.update({
            attributes: getAttributes()
        });
        // Dispatch the original event to our channel
        event.fire((0, $27f53d4100568677$export$85183a312807388d));
        onSubmit({
            url: url,
            displayText: displayText || null,
            title: title || null,
            meta: {
                inputMethod: inputType
            },
            data: data,
            ...inputType === 'manual' ? {
                rawUrl: state.url
            } : {}
        }, consumerEvent);
    }, [
        displayText,
        onSubmit,
        state.url,
        createAnalyticsEvent,
        getAttributes
    ]);
    const handleSelected = (0, $5uXOq.useCallback)((objectId)=>{
        if (isSubmitting) // Prevent changing selection while submitting
        return;
        const selectedItem = items?.find((item)=>item.objectId === objectId);
        if (selectedItem) {
            const { url: url, name: name } = selectedItem;
            /**
       * Manually track that the url has been updated using searchResult method
       */ dispatchEvent(new Event('submit'));
            trackAttribute('linkFieldContent', $7b540b3fc96df6b6$var$getLinkFieldContent(url));
            trackAttribute('linkFieldContentInputMethod', 'searchResult');
            trackAttribute('linkFieldContentInputSource', (0, $5w02V.getDataSource)(selectedItem, activePlugin));
            handleInsert(url, name, 'typeAhead', {
                ...selectedItem
            });
        }
    }, [
        handleInsert,
        trackAttribute,
        items,
        activePlugin,
        isSubmitting
    ]);
    const handleSubmit = (0, $5uXOq.useCallback)(async (event)=>{
        event?.preventDefault();
        if (isSubmitting) // Prevent submit while submitting
        return;
        if (isSelectedItem && selectedItem) return handleInsert(selectedItem.url, selectedItem.name, 'typeAhead');
        const normalized = (0, $57Lhk.normalizeUrl)(url);
        if (normalized) {
            if (previewableOnly) try {
                const urlResponse = await $7b540b3fc96df6b6$var$client.fetchData(normalized);
                const responseObject = urlResponse?.data;
                if (responseObject && 'preview' in responseObject) return handleInsert(normalized, null, 'manual');
                else return dispatch({
                    invalidUrl: true,
                    hasPreview: false
                });
            } catch (error) {
                return dispatch({
                    invalidUrl: true
                });
            }
            else return handleInsert(normalized, null, 'manual');
        }
        return dispatch({
            invalidUrl: true
        });
    }, [
        dispatch,
        handleInsert,
        isSelectedItem,
        selectedItem,
        url,
        isSubmitting,
        previewableOnly
    ]);
    const handleTabChange = (0, $5uXOq.useCallback)((activeTab)=>{
        dispatch({
            // We don't want any selection to exist after changing tab, as the selection
            // wouldn't mean anything.
            activeIndex: -1,
            selectedIndex: -1,
            // We don't want recents to be hidden, even though we don't have a selection
            preventHidingRecents: true,
            invalidUrl: false,
            hasPreview: true,
            activeTab: activeTab
        });
        trackAttribute('tab', plugins?.[activeTab]?.tabKey ?? null);
    }, [
        dispatch,
        plugins,
        trackAttribute
    ]);
    const handleSearchListOnChange = (id)=>{
        if (isSubmitting) // Prevent changing item while submitting
        return;
        const index = items?.findIndex((item)=>item.objectId === id);
        if (typeof index === 'number') {
            const item = items?.[index];
            if (item) {
                /**
         * Manually track that the url has been updated using searchResult method
         */ trackAttribute('linkFieldContent', $7b540b3fc96df6b6$var$getLinkFieldContent(item.url));
                trackAttribute('linkFieldContentInputMethod', 'searchResult');
                trackAttribute('linkFieldContentInputSource', (0, $5w02V.getDataSource)(item, activePlugin));
                dispatch({
                    activeIndex: index,
                    selectedIndex: index,
                    url: item.url,
                    invalidUrl: false,
                    hasPreview: true
                });
            }
        }
    };
    const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
        if (!items?.length) return;
        let updatedIndex = activeIndex;
        if (event.key === 'Enter') {
            event.preventDefault();
            if (selectedItem) handleSelected(selectedItem.objectId);
            else // triggers validation error message
            handleSubmit();
        } else updatedIndex = (0, $4ghTo.handleNavKeyDown)(event, items.length, activeIndex);
        const item = items[updatedIndex];
        if ([
            'Enter',
            'ArrowDown',
            'ArrowUp',
            'Home',
            'End'
        ].includes(event.key) && item) {
            /**
       * Manually track that the url has been updated using searchResult method
       */ trackAttribute('linkFieldContent', $7b540b3fc96df6b6$var$getLinkFieldContent(item.url));
            trackAttribute('linkFieldContentInputMethod', 'searchResult');
            trackAttribute('linkFieldContentInputSource', (0, $5w02V.getDataSource)(item, activePlugin));
            dispatch({
                activeIndex: updatedIndex,
                selectedIndex: updatedIndex,
                url: item.url,
                invalidUrl: false,
                hasPreview: true
            });
        }
    }, [
        items,
        activeIndex,
        selectedItem,
        handleSelected,
        handleSubmit,
        trackAttribute,
        activePlugin
    ]);
    const messages = isActivePlugin ? (0, $4iG8d.searchMessages) : (0, $4iG8d.linkMessages);
    const screenReaderDescriptionId = 'search-recent-links-field-description';
    const linkSearchListId = 'link-picker-search-list';
    const ariaActiveDescendant = selectedIndex > -1 ? `link-search-list-item-${selectedIndex}` : '';
    const a11yList = isActivePlugin || isLoadingPlugins ? {
        role: 'combobox',
        // When a combobox popup is not visible, the element with role combobox has aria-expanded set to false
        // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-expanded#combobox
        'aria-expanded': !!items?.length,
        'aria-autocomplete': 'list',
        'aria-controls': linkSearchListId,
        'aria-activedescendant': ariaActiveDescendant,
        'aria-describedby': screenReaderDescriptionId
    } : undefined;
    // Added workaround with a screen reader Announcer specifically for VoiceOver + Safari
    // as the Aria design pattern for combobox does not work in this case
    // for details: https://a11y-internal.atlassian.net/browse/AK-740
    const screenReaderText = (0, $b6uPu.browser)().safari && (0, $5w02V.getScreenReaderText)(items ?? [], selectedIndex, intl);
    const customSubmitButtonLabel = customMessages?.submitButtonLabel ? customMessages.submitButtonLabel : undefined;
    const additionalErrorMessage = (0, $VSDnB.fg)('platform-linking-link-picker-previewable-only') && additionalError;
    const errorMessage = invalidUrl ? previewableOnly && !hasPreview ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...(0, $4iG8d.formMessages).noEmbedAvailable,
        values: {
            a: (chunk)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $iHvAB.default), {
                    target: "_blank",
                    href: "https://support.atlassian.com/platform-experiences/docs/smart-links-from-jira-and-other-products/",
                    children: chunk
                })
        }
    }) : intl.formatMessage((0, $4iG8d.formMessages).linkInvalid) : null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("form", {
        "data-testid": $7b540b3fc96df6b6$export$800daf5fbbe96aff.linkPicker,
        // Use onSubmitCapture instead of onSubmit so that any possible parent form isn't submitted
        onSubmitCapture: handleSubmit,
        className: (0, $bwpsq.default)([
            "_19bv164s _u5f31pah _ca0q1k79 _n3td1t3k _vchhusvi _1e0ctcjq",
            !(0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_vwz44jg8"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $y118H.TrackMount), {}),
            isActivePlugin && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
                children: [
                    screenReaderText && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cLOqK.Announcer), {
                        ariaLive: "assertive",
                        text: screenReaderText,
                        ariaRelevant: "additions",
                        delay: 250
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jldZL.default), {
                        id: screenReaderDescriptionId,
                        children: customMessages?.linkAriaLabel ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...customMessages.linkAriaLabel
                        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...messages.linkAriaLabel
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)($7b540b3fc96df6b6$var$LinkInputField, {
                name: "url",
                autoComplete: "off",
                testId: $7b540b3fc96df6b6$export$800daf5fbbe96aff.urlInputField,
                label: customMessages?.linkLabel ? intl.formatMessage(customMessages.linkLabel) : intl.formatMessage(messages.linkLabel),
                placeholder: customMessages?.linkPlaceholder ? intl.formatMessage(customMessages?.linkPlaceholder) : intl.formatMessage(messages.linkPlaceholder),
                value: url,
                autoFocus: true,
                clearLabel: intl.formatMessage((0, $4iG8d.formMessages).clearLink),
                error: errorMessage || additionalErrorMessage,
                spotlightTargetName: "link-picker-search-field-spotlight-target",
                "aria-readonly": isSubmitting,
                ...a11yList,
                onClear: handleUrlClear,
                onKeyDown: handleKeyDown,
                onChange: handleChangeUrl,
                inputRef: inputRef
            }),
            !hideDisplayText && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)($7b540b3fc96df6b6$var$DisplayTextInputField, {
                        autoComplete: "off",
                        name: "displayText",
                        testId: $7b540b3fc96df6b6$export$800daf5fbbe96aff.textInputField,
                        value: displayText,
                        label: customMessages?.linkTextLabel ? intl.formatMessage(customMessages.linkTextLabel) : intl.formatMessage((0, $4iG8d.linkTextMessages).linkTextLabel),
                        placeholder: customMessages?.linkTextPlaceholder ? intl.formatMessage(customMessages?.linkTextPlaceholder) : intl.formatMessage((0, $4iG8d.linkTextMessages).linkTextPlaceholder),
                        clearLabel: intl.formatMessage((0, $4iG8d.linkTextMessages).clearLinkText),
                        readOnly: isSubmitting,
                        onClear: handleClear,
                        onChange: handleChangeText
                    }),
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-link-picker') && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $qfj8c.HelperMessage), {
                        testId: $7b540b3fc96df6b6$export$800daf5fbbe96aff.linkHelperText,
                        children: customMessages?.linkHelperTextLabel ? intl.formatMessage(customMessages?.linkHelperTextLabel) : intl.formatMessage((0, $4iG8d.linkTextMessages).linkHelperTextLabel)
                    })
                ]
            }),
            moveSubmitButton && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                xcss: $7b540b3fc96df6b6$var$styles.fullWidthSubmitButton,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dzP3c.LinkPickerSubmitButton), {
                    isEditing: isEditing,
                    isLoading: isLoadingResults || !!isLoadingPlugins,
                    isSubmitting: isSubmitting,
                    customSubmitButtonLabel: customSubmitButtonLabel,
                    error: error,
                    items: items,
                    queryState: queryState,
                    submitMessageId: submitMessageId,
                    testId: $7b540b3fc96df6b6$export$800daf5fbbe96aff.insertButton,
                    url: url
                })
            }),
            !!queryState && (isLoadingPlugins || isActivePlugin) && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eUvbr.SearchResults), {
                activeTab: activeTab,
                tabs: tabs,
                activePlugin: activePlugin,
                isLoadingResults: isLoadingResults,
                isLoadingPlugins: isLoadingPlugins,
                isSubmitting: isSubmitting,
                linkSearchListId: linkSearchListId,
                error: error,
                featureFlags: featureFlags,
                activeIndex: activeIndex,
                selectedIndex: selectedIndex,
                items: items,
                queryState: queryState,
                handleKeyDown: handleKeyDown,
                handleSelected: handleSelected,
                handleTabChange: handleTabChange,
                handleSearchListOnChange: handleSearchListOnChange,
                adaptiveHeight: adaptiveHeight,
                retry: retry
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hFJqt.FormFooter), {
                error: error,
                items: items,
                /** If the results section appears to be loading, impact whether the submit button is disabled */ isLoading: isLoadingResults || !!isLoadingPlugins,
                isSubmitting: isSubmitting,
                queryState: queryState,
                url: url,
                isEditing: isEditing,
                onCancel: onCancel,
                action: pluginAction,
                customSubmitButtonLabel: customSubmitButtonLabel,
                submitMessageId: submitMessageId,
                hideSubmitButton: moveSubmitButton,
                className: (0, $bwpsq.default)([
                    (!queryState || !plugins?.length) && "_19pkpxbi"
                ])
            })
        ]
    });
}));

});
parcelRegister("7cFR3", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d96ed473518bd99$export$2e2bcd8739ae039);

var $hhZW9 = parcelRequire("hhZW9");

var $hj8yn = parcelRequire("hj8yn");

var $hLXaJ = parcelRequire("hLXaJ");

var $kDZ6Z = parcelRequire("kDZ6Z");
var $itO4f = parcelRequire("itO4f");
var $fiKQs = parcelRequire("fiKQs");
var $dV0Jy = parcelRequire("dV0Jy");

var $4Bkrp = parcelRequire("4Bkrp");

var $iwKVT = parcelRequire("iwKVT");
const $8d96ed473518bd99$var$MAX_BATCH_SIZE = 50;
const $8d96ed473518bd99$var$MIN_TIME_BETWEEN_BATCHES = 250;
const $8d96ed473518bd99$var$URL_RESPONSE_CACHE_SIZE = 100;
const $8d96ed473518bd99$export$d6a66073b5d79eb3 = new (0, $iwKVT.LRUMap)($8d96ed473518bd99$var$URL_RESPONSE_CACHE_SIZE);
class $8d96ed473518bd99$export$2e2bcd8739ae039 {
    constructor(envKey, baseUrlOverride){
        this.postBatchResolve = async (resources, resourceType = 'URL')=>{
            // De-duplicate requested URLs (see `this.createLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = [
                ...new Set(resources)
            ];
            let resolvedResources = [];
            const headers = {
                /**
			 * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
			 * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
			 */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $dV0Jy.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources.map((resourceUrl)=>({
                        resourceUrl: resourceUrl
                    })), headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $dV0Jy.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources.map((ari)=>({
                        ari: ari
                    })), headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $4Bkrp.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[resource] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[originalResource]);
        };
        // Endpoint for batch resolve url
        this.batchResolve = async (urls)=>{
            return this.postBatchResolve(urls, 'URL');
        };
        // Endpoint for batch resolve ari
        this.batchResolveAris = async (aris)=>{
            return this.postBatchResolve(aris, 'ARI');
        };
        this.resolverUrl = (0, $itO4f.getResolverUrl)(envKey, baseUrlOverride);
        this.loadersByDomain = {};
        this.retryConfig = {
            retries: 2
        };
        this.resolvedCache = {};
        this.envKey = envKey;
        this.baseUrlOverride = baseUrlOverride;
    }
    setProduct(product) {
        this.product = product;
    }
    createLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($hLXaJ)))({
            limit: 1,
            interval: $8d96ed473518bd99$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolve);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($hhZW9)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $8d96ed473518bd99$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolve`.
            cache: false
        });
    }
    getLoader(hostname) {
        if (!this.loadersByDomain[hostname]) this.loadersByDomain[hostname] = this.createLoader();
        return this.loadersByDomain[hostname];
    }
    async resolveUrl(url, force = false) {
        const hostname = new URL(url).hostname;
        const loader = this.getLoader(hostname);
        let responsePromise;
        responsePromise = $8d96ed473518bd99$export$d6a66073b5d79eb3.get(url);
        if (!responsePromise || force) {
            responsePromise = loader.load(url);
            $8d96ed473518bd99$export$d6a66073b5d79eb3.set(url, responsePromise);
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $8d96ed473518bd99$export$d6a66073b5d79eb3.delete(url);
            throw e;
        }
        const isUnresolvedLink = !(0, $4Bkrp.isSuccessfulResponse)(response) || (0, $fiKQs.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $8d96ed473518bd99$export$d6a66073b5d79eb3.delete(url);
        return response;
    }
    async prefetchData(url) {
        // 1. Queue the URL as part of a dataloader batch.
        const response = await this.resolveUrl(url, false);
        if ((0, $4Bkrp.isSuccessfulResponse)(response)) // 2. If the URL resolves, send it back.
        return response.body;
        else try {
            // 3. If the URL does not resolve, retry it with exponential backoff.
            // This is done so that we avoid the scenario where users are unable to
            // see a resolved Smart Link, when their expectation is to be able to.
            const retriedResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($hj8yn)))(async ()=>{
                // We check if the link has resolved in the cache and stop trying if so.
                // We do this by triggering an error that the link has already been resolved.
                // This cascades <retryCount> times after which it is handled like a normal
                // 'error', returning `undefined`.
                if (!this.resolvedCache[url]) {
                    const response = await this.resolveUrl(url, false);
                    if ((0, $4Bkrp.isSuccessfulResponse)(response)) return response;
                    else throw new Error('Retry for URL failed');
                } else // Short-circuit each of the retries, as described above.
                throw new Error('Retry unneeded - link has been resolved.');
            }, this.retryConfig);
            // Trigger callback after successful backoff.
            return retriedResponse.body;
        } catch (err) {
            // Do nothing in the case of an error - prefetching
            // failures should be silent. Once a link is visible,
            // it will be re-fetched anyhow, in which case a
            // user-facing error is required.
            return undefined;
        }
    }
    isRateLimitError(response) {
        return (0, $4Bkrp.isErrorResponse)(response) && response.error.status === 429;
    }
    // Fetch data from URL
    async fetchData(url, force) {
        let response = await this.resolveUrl(url, force);
        if (this.isRateLimitError(response)) response = await (0, (/*@__PURE__*/$parcel$interopDefault($hj8yn)))(async ()=>{
            const retryResponse = await this.resolveUrl(url, false);
            if (this.isRateLimitError(retryResponse)) throw this.mapErrorResponse(retryResponse, new URL(url).hostname);
            return retryResponse;
        }, this.retryConfig);
        if (!(0, $4Bkrp.isSuccessfulResponse)(response)) throw this.mapErrorResponse(response, new URL(url).hostname);
        // Set a flag in the `resolvedCache` for this URL. The intent of this is
        // to ensure that the exponential backoff method in `prefetchData` does
        // not continue to retry fetching for this URL, especially if it was previously
        // in a failed state. Note: this scenario only occurs on initial page load, if the
        // user scrolls through the page very fast. Once the URL is visible, prefetching
        // no longer takes place.
        this.resolvedCache[url] = true;
        // Return the JSON-LD response back up!
        return response.body;
    }
    /**
	 * Fetch data for multiple ARIs (batch) in one operation
	 * @param aris Array of ARIs to fetch data for
	 */ async fetchDataAris(aris) {
        return await this.batchResolveAris(aris);
    }
    async postData(data) {
        const requestData = {
            key: data.key,
            action: data.action,
            context: data.context
        };
        return await (0, $dV0Jy.request)('post', `${this.resolverUrl}/invoke`, requestData);
    }
    /**
	 * Make request to the Search endpoint See `InvocationRequest` in ORS openapi.yaml for backend
	 * spec.
	 * @param data Payload including the search provider key and query. An empty search query string
	 * results in recent results being returned (pre-query).
	 * @returns JsonLd collection of search results.
	 */ async search(data) {
        const { key: key, action: action } = data;
        // Note: context in action is different to context in data, see types.
        const { query: query, context: context } = action;
        const requestData = {
            key: key,
            search: {
                query: query,
                context: context
            }
        };
        const response = await (0, $dV0Jy.request)('post', `${this.resolverUrl}/invoke/search`, requestData);
        if ((0, $4Bkrp.isErrorResponse)(response)) // There is no hostname/it is not known. Hostname is not logged anyway as it's considered PII.
        throw this.mapErrorResponse(response);
        return response;
    }
    async fetchAvailableSearchProviders() {
        const response = await (0, $dV0Jy.request)('post', `${this.resolverUrl}/providers`, {
            type: 'search'
        });
        return response.providers;
    }
    mapErrorResponse(response, hostname = '') {
        // Catch non-200 server responses to fallback or return useful information.
        if (response?.error) {
            const errorType = response.error.type;
            const errorMessage = response.error.message;
            const extensionKey = response.error.extensionKey;
            // this means there was a network error and we fallback to blue link
            // without impacting SLO's
            if (response.error instanceof (0, $dV0Jy.NetworkError)) return new (0, $kDZ6Z.APIError)('fallback', hostname, errorMessage, errorType);
            switch(errorType){
                // BadRequestError - indicative of an API error, render
                // a blue link to mitigate customer impact.
                case 'ResolveBadRequestError':
                case 'SearchBadRequestError':
                case 'BadRequestError':
                    return new (0, $kDZ6Z.APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                // AuthError - if the user logs in, we may be able
                // to recover. Render an unauthorized card.
                case 'ResolveAuthError':
                case 'SearchAuthError':
                case 'AuthError':
                    return new (0, $kDZ6Z.APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                // UnsupportedError - we do not know how to render this URL.
                // Bail out and ask the Editor to render as a blue link.
                case 'ResolveUnsupportedError':
                case 'SearchUnsupportedError':
                case 'UnsupportedError':
                    return new (0, $kDZ6Z.APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                case 'ResolveFailedError':
                case 'SearchFailedError':
                case 'ResolveTimeoutError':
                case 'SearchTimeoutError':
                case 'SearchRateLimitError':
                case 'ResolveRateLimitError':
                case 'InternalServerError':
                case 'TimeoutError':
                case 'RateLimitError':
                    return new (0, $kDZ6Z.APIError)('error', hostname, errorMessage, errorType, extensionKey);
            }
        }
        // Catch all: we don't know this error, bail out.
        const { error: error, ...rest } = response || {};
        return new (0, $kDZ6Z.APIError)('fatal', hostname, // reason we stringify the error differently is because
        // JSON.stringify will return "{}" if it is an instance of Error
        // e.g. JSON.stringify(new Error('something went wrong')) will return '{}'
        // reason is JSON.stringify method only serializes enumerable properties but properties like "message" and "stack" are non enumerable
        // e.g. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/message
        // more info here https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
        // we assume 'rest'  to "serializable" meaning all its properties are enumerable
        response ? `${this.stringifyError(error)} ${JSON.stringify(rest)}` : 'Response undefined', 'UnexpectedError');
    }
    /**
	 * This method will strigify both enumerable and  non enumerable properties of an object
	 * @param err
	 * @returns object serialized to JSON with both enumerable and non enumerable objects
	 */ stringifyError(err) {
        /**
		 * By default JSON.stringify only serializes enumerable properties of an object. In order for us to
		 * serialize non enumerable properties out of an error we need to expclitily provide the non enumerable property names.
		 * the second parameter to JSON.stringify gets the properties that will be serialized from the object passed in the first argument
		 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyNames
		 */ return JSON.stringify(err, //In ES5, if the argument to getOwnPropertyNames method is not an object (a primitive), then it will cause a TypeError
        typeof err === 'object' ? Object.getOwnPropertyNames(err) : undefined);
    }
}

});
parcelRegister("hj8yn", function(module, exports) {
// Packages

var $8DmlG = parcelRequire("8DmlG");
function $c99ad890679d3578$var$retry(fn, opts) {
    function run(resolve, reject) {
        var options = opts || {};
        var op;
        // Default `randomize` to true
        if (!('randomize' in options)) options.randomize = true;
        op = $8DmlG.operation(options);
        // We allow the user to abort retrying
        // this makes sense in the cases where
        // knowledge is obtained that retrying
        // would be futile (e.g.: auth errors)
        function bail(err) {
            reject(err || new Error('Aborted'));
        }
        function onError(err, num) {
            if (err.bail) {
                bail(err);
                return;
            }
            if (!op.retry(err)) reject(op.mainError());
            else if (options.onRetry) options.onRetry(err, num);
        }
        function runAttempt(num) {
            var val;
            try {
                val = fn(bail, num);
            } catch (err) {
                onError(err, num);
                return;
            }
            Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                onError(err, num);
            });
        }
        op.attempt(runAttempt);
    }
    return new Promise(run);
}
module.exports = $c99ad890679d3578$var$retry;

});
parcelRegister("8DmlG", function(module, exports) {

module.exports = (parcelRequire("j1SyJ"));

});
parcelRegister("j1SyJ", function(module, exports) {

var $gRLb1 = parcelRequire("gRLb1");
exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $gRLb1(timeouts, {
        forever: options && (options.forever || options.retries === Infinity),
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * Math.max(opts.minTimeout, 1) * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});
parcelRegister("gRLb1", function(module, exports) {
function $c47630e585ca345b$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === 'boolean') options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    this._timer = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $c47630e585ca345b$var$RetryOperation;
$c47630e585ca345b$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts.slice(0);
};
$c47630e585ca345b$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    if (this._timer) clearTimeout(this._timer);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$c47630e585ca345b$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.push(err);
        this._errors.unshift(new Error('RetryOperation timeout occurred'));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(0, this._errors.length - 1);
            timeout = this._cachedTimeouts.slice(-1);
        } else return false;
    }
    var self = this;
    this._timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) this._timer.unref();
    return true;
};
$c47630e585ca345b$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$c47630e585ca345b$var$RetryOperation.prototype.try = function(fn) {
    console.log('Using RetryOperation.try() is deprecated');
    this.attempt(fn);
};
$c47630e585ca345b$var$RetryOperation.prototype.start = function(fn) {
    console.log('Using RetryOperation.start() is deprecated');
    this.attempt(fn);
};
$c47630e585ca345b$var$RetryOperation.prototype.start = $c47630e585ca345b$var$RetryOperation.prototype.try;
$c47630e585ca345b$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$c47630e585ca345b$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$c47630e585ca345b$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});




parcelRegister("hLXaJ", function(module, exports) {
'use strict';
class $cf04b9d0ddc5d8fc$var$AbortError extends Error {
    constructor(){
        super('Throttled function aborted');
        this.name = 'AbortError';
    }
}
const $cf04b9d0ddc5d8fc$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
    if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
    if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        const earliestTime = strictTicks.shift() + interval;
        if (now >= earliestTime) {
            strictTicks.push(now);
            return 0;
        }
        strictTicks.push(earliestTime);
        return earliestTime - now;
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...args) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
            let timeout;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, args));
                    queue.delete(timeout);
                };
                timeout = setTimeout(execute, getDelay());
                queue.set(timeout, reject);
            });
        };
        throttled.abort = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(new $cf04b9d0ddc5d8fc$var$AbortError());
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        throttled.isEnabled = true;
        return throttled;
    };
};
module.exports = $cf04b9d0ddc5d8fc$var$pThrottle;
module.exports.AbortError = $cf04b9d0ddc5d8fc$var$AbortError;

});

parcelRegister("kDZ6Z", function(module, exports) {

$parcel$export(module.exports, "APIError", () => $8c263ecf028a2c14$export$3e5b797e39668f84);
class $8c263ecf028a2c14$export$3e5b797e39668f84 extends Error {
    constructor(kind, hostname, message, type, extensionKey){
        super(`${kind}: ${message}`), this.kind = kind, this.hostname = hostname, this.message = message, this.type = type, this.extensionKey = extensionKey;
        this.name = 'APIError';
        // The error type received from the server.
        this.type = type;
        // The kind mapped to on the client.
        this.kind = kind;
        // The message received from the server.
        this.message = message;
        // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
        this.hostname = hostname;
        // The extensionKey passed from the error response from ORS
        this.extensionKey = extensionKey;
    }
}

});

parcelRegister("itO4f", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $21a0efece812cd9a$export$f654b28f82155665);
$parcel$export(module.exports, "getResolverUrl", () => $21a0efece812cd9a$export$dc37652c1696f231);
const $21a0efece812cd9a$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
const $21a0efece812cd9a$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
const $21a0efece812cd9a$var$prodBaseUrl = 'https://api-private.atlassian.com';
const $21a0efece812cd9a$export$e2b040f052407032 = {
    dev: $21a0efece812cd9a$var$devBaseUrl,
    development: $21a0efece812cd9a$var$devBaseUrl,
    stg: $21a0efece812cd9a$var$stgBaseUrl,
    staging: $21a0efece812cd9a$var$stgBaseUrl,
    prd: $21a0efece812cd9a$var$prodBaseUrl,
    prod: $21a0efece812cd9a$var$prodBaseUrl,
    production: $21a0efece812cd9a$var$prodBaseUrl
};
const $21a0efece812cd9a$export$f654b28f82155665 = (envKey)=>{
    // If an environment is provided, then use Stargate.
    if (envKey) return envKey in $21a0efece812cd9a$export$e2b040f052407032 ? $21a0efece812cd9a$export$e2b040f052407032[envKey] : $21a0efece812cd9a$var$prodBaseUrl;
    // Otherwise, use the current origin of the page.
    return typeof window.location !== 'undefined' ? window.location.origin : '';
};
const $21a0efece812cd9a$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
    // If an environment is provided, then use Stargate directly for requests.
    if (envKey || baseUrlOverride) {
        const baseUrl = baseUrlOverride || $21a0efece812cd9a$export$f654b28f82155665(envKey);
        return `${baseUrl}/object-resolver`;
    } else // Otherwise, we fallback to using the Edge Proxy to access Stargate,
    // which fixes some cookie issues with strict Browser policies.
    return '/gateway/api/object-resolver';
};
var $21a0efece812cd9a$export$2e2bcd8739ae039 = $21a0efece812cd9a$export$e2b040f052407032;

});

parcelRegister("fiKQs", function(module, exports) {

$parcel$export(module.exports, "getStatus", () => $5c2f531cb20db568$export$b70265791d2079d4);
const $5c2f531cb20db568$var$getStatusForNotFoundVisibility = (meta)=>{
    const accessType = meta.requestAccess?.accessType;
    if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
    // for the rest of the accessTypes we will return forbidden,see https://product-fabric.atlassian.net/browse/EDM-7125
    return 'forbidden';
};
const $5c2f531cb20db568$export$b70265791d2079d4 = ({ meta: meta })=>{
    const { access: access, visibility: visibility } = meta;
    switch(access){
        case 'forbidden':
            if (visibility === 'not_found') return $5c2f531cb20db568$var$getStatusForNotFoundVisibility(meta);
            else return 'forbidden';
        case 'unauthorized':
            return 'unauthorized';
        default:
            return 'resolved';
    }
};

});

parcelRegister("dV0Jy", function(module, exports) {

$parcel$export(module.exports, "NetworkError", () => $5576d4e9d0a3858d$export$bae979e68e4dc802);
$parcel$export(module.exports, "request", () => $5576d4e9d0a3858d$export$b5fe3f66a567bec0);
const $5576d4e9d0a3858d$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
class $5576d4e9d0a3858d$export$bae979e68e4dc802 extends Error {
    constructor(error){
        super(error);
    }
}
async function $5576d4e9d0a3858d$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $5576d4e9d0a3858d$var$ALLOWED_RESPONSE_STATUS_CODES) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || statuses?.includes(response.status)) {
            if (statuses.includes(204)) {
                const text = await response.text();
                return text ? JSON.parse(text) : undefined;
            } else return await response.json();
        }
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new $5576d4e9d0a3858d$export$bae979e68e4dc802(error);
        throw error;
    }
}

});

parcelRegister("4Bkrp", function(module, exports) {

$parcel$export(module.exports, "isSuccessfulResponse", () => $1e00e4fd9b26eb0f$export$1b59fe731a28a49d);
$parcel$export(module.exports, "isErrorResponse", () => $1e00e4fd9b26eb0f$export$bea7bee8a87e7c52);
const $1e00e4fd9b26eb0f$export$1b59fe731a28a49d = (response)=>{
    if (!response) return false;
    const hasSuccessfulStatus = response.status === 200;
    const hasSuccessBody = 'body' in response;
    return hasSuccessfulStatus && hasSuccessBody;
};
const $1e00e4fd9b26eb0f$export$bea7bee8a87e7c52 = (response)=>{
    if (!response) return false;
    const hasStatus = 'status' in response && response.status >= 200;
    const hasErrorBody = 'error' in response;
    return hasStatus && hasErrorBody;
};

});


parcelRegister("lFfL4", function(module, exports) {

$parcel$export(module.exports, "useLinkPickerAnalytics", () => $96aef9ab4e2c5d16$export$15407343803f36c);
$parcel$export(module.exports, "withLinkPickerAnalyticsContext", () => $96aef9ab4e2c5d16$export$13f45cdb81bd4384);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bvUB1 = parcelRequire("bvUB1");

var $57Lhk = parcelRequire("57Lhk");

const $96aef9ab4e2c5d16$var$DEFAULT_CONTEXT_ATTRIBUTES = {
    linkState: 'newLink',
    linkFieldContent: null,
    linkFieldContentInputMethod: null,
    linkFieldContentInputSource: null,
    displayTextFieldContent: null,
    displayTextFieldContentInputMethod: null,
    tab: null
};
const $96aef9ab4e2c5d16$var$LinkPickerAnalyticsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    trackAttribute: ()=>{},
    trackAttributes: ()=>{},
    getAttributes: ()=>$96aef9ab4e2c5d16$var$DEFAULT_CONTEXT_ATTRIBUTES
});
/**
 * TODO: Should we hook this into the form state/reducer?
 * This function continues to duplicate / assume logic that runs in the picker
 */ const $96aef9ab4e2c5d16$var$contextAttributesFromIntialProps = (props)=>{
    return {
        linkState: (0, $57Lhk.normalizeUrl)(props.url) ? 'editLink' : 'newLink',
        linkFieldContent: (0, $57Lhk.normalizeUrl)(props.url) ? 'url' : null,
        displayTextFieldContent: Boolean(props.displayText) ? 'text_string' : null,
        // TODO: Assumes we alway load the first plugin as the current tab
        tab: props.plugins?.[0]?.tabKey ?? null
    };
};
/**
 * Context for tracking attributes to deliver at a context-level
 */ const $96aef9ab4e2c5d16$var$LinkPickerAnalytics = ({ initialContext: initialContext, children: children })=>{
    const dataRef = (0, $5uXOq.useRef)({
        ...$96aef9ab4e2c5d16$var$DEFAULT_CONTEXT_ATTRIBUTES,
        ...initialContext
    });
    const methods = (0, $5uXOq.useMemo)(()=>({
            trackAttribute: (key, value)=>{
                dataRef.current[key] = value;
            },
            trackAttributes: (attributes)=>{
                dataRef.current = {
                    ...dataRef.current,
                    ...attributes
                };
            },
            getAttributes: ()=>dataRef.current
        }), []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($96aef9ab4e2c5d16$var$LinkPickerAnalyticsContext.Provider, {
        value: methods,
        children: children
    });
};
const $96aef9ab4e2c5d16$export$15407343803f36c = ()=>(0, $5uXOq.useContext)($96aef9ab4e2c5d16$var$LinkPickerAnalyticsContext);
/**
 * Wrap component in "attributes" context store and initialise the initial context attributes from props.
 */ function $96aef9ab4e2c5d16$var$withLinkPickerAnalytics(WrappedComponent) {
    return (props)=>{
        const [initialContext] = (0, $5uXOq.useState)(()=>$96aef9ab4e2c5d16$var$contextAttributesFromIntialProps(props));
        return /*#__PURE__*/ (0, $2OMIu.jsx)($96aef9ab4e2c5d16$var$LinkPickerAnalytics, {
            initialContext: initialContext,
            ...props,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
                ...props
            })
        });
    };
}
function $96aef9ab4e2c5d16$export$13f45cdb81bd4384(WrappedComponent) {
    return $96aef9ab4e2c5d16$var$withLinkPickerAnalytics((props)=>{
        const { getAttributes: getAttributes } = $96aef9ab4e2c5d16$export$15407343803f36c();
        const onEvent = (0, $5uXOq.useCallback)((event)=>{
            event.update({
                attributes: {
                    ...getAttributes(),
                    ...event.payload.attributes ?? {}
                }
            });
        }, [
            getAttributes
        ]);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bvUB1.default), {
            channel: (0, $27f53d4100568677$export$85183a312807388d),
            onEvent: onEvent,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
                ...props
            })
        });
    });
}

});

parcelRegister("8xwTn", function(module, exports) {

$parcel$export(module.exports, "withInputFieldTracking", () => $3ea79d54b4ab7ae4$export$493cbe8965becd2d);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $eTwyk = parcelRequire("eTwyk");


var $lFfL4 = parcelRequire("lFfL4");
const $3ea79d54b4ab7ae4$var$isEventWithInputType = (e)=>{
    return typeof e === 'object' && e !== null && 'inputType' in e;
};
const $3ea79d54b4ab7ae4$var$getChangeEventInputMethodType = (event)=>{
    if ($3ea79d54b4ab7ae4$var$isEventWithInputType(event.nativeEvent) && typeof event.nativeEvent.inputType === 'string' && event.nativeEvent.inputType.includes('insertFromPaste')) return 'paste';
    return 'manual';
};
const $3ea79d54b4ab7ae4$export$493cbe8965becd2d = (WrappedComponent, field, filterOnChangeEventAttrs = (_, attributes)=>attributes)=>{
    return (props)=>{
        const { onBlur: onBlur, onChange: onChange, onClear: onClear, onFocus: onFocus } = props;
        const { trackAttribute: trackAttribute, trackAttributes: trackAttributes } = (0, $lFfL4.useLinkPickerAnalytics)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
        // Ref to track if the value of the field has changed between focus and blur
        const valueOnFocus = (0, $5uXOq.useRef)(null);
        // Track the content and input method on every direct change to the input
        const handleOnChange = (0, $5uXOq.useCallback)((event)=>{
            // TODO: See above re template literal, improve typesafety here
            // trackAttribute(`${field}FieldContent`, contentTypeFn(event.currentTarget.value));
            // trackAttribute(`${field}FieldContentInputMethod`, methodTypeFn(event));
            trackAttributes(filterOnChangeEventAttrs(event, {
                [`${field}FieldContent`]: Boolean(event.currentTarget.value) ? 'text_string' : null,
                [`${field}FieldContentInputMethod`]: $3ea79d54b4ab7ae4$var$getChangeEventInputMethodType(event)
            }));
            onChange?.(event);
        }, [
            onChange,
            trackAttributes
        ]);
        // Store the value of the field at the time the field is focused so we can know if it changes when the user's focus leaves
        const handleOnFocus = (0, $5uXOq.useCallback)((event)=>{
            valueOnFocus.current = event.currentTarget.value;
            onFocus?.(event);
        }, [
            onFocus
        ]);
        // Fire updated events only when the user's focus leaves the field
        const handleOnBlur = (0, $5uXOq.useCallback)((event)=>{
            // Only fire if the value has changed since the field was focused (we are only concerned with the net change to the field)
            if (event.currentTarget.value !== valueOnFocus.current) createAnalyticsEvent((0, $eTwyk.default)(`ui.textField.updated.${field}Field`, {})).fire((0, $27f53d4100568677$export$85183a312807388d));
            onBlur?.(event);
        }, [
            onBlur,
            createAnalyticsEvent
        ]);
        // Track the values as null when the text field is cleared
        const handleOnClear = (0, $5uXOq.useCallback)((...args)=>{
            trackAttribute(`${field}FieldContent`, null);
            trackAttribute(`${field}FieldContentInputMethod`, null);
            onClear?.(...args);
        }, [
            onClear,
            trackAttribute
        ]);
        return /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
            ...props,
            onBlur: handleOnBlur,
            onChange: handleOnChange,
            onClear: handleOnClear,
            onFocus: handleOnFocus
        });
    };
};

});

parcelRegister("4ghTo", function(module, exports) {

$parcel$export(module.exports, "handleNavKeyDown", () => $530aea3925ce4578$export$6c8bbb3c4f84f876);
const $530aea3925ce4578$export$6c8bbb3c4f84f876 = (event, itemsLength, activeIndex)=>{
    let updatedIndex = activeIndex;
    switch(event.key){
        case 'ArrowDown':
            event.preventDefault();
            updatedIndex = (activeIndex + 1) % itemsLength;
            break;
        case 'ArrowUp':
            event.preventDefault();
            updatedIndex = activeIndex > 0 ? activeIndex - 1 : itemsLength - 1;
            break;
        case 'Home':
            event.preventDefault();
            updatedIndex = 0;
            break;
        case 'End':
            event.preventDefault();
            updatedIndex = itemsLength - 1;
            break;
    }
    return updatedIndex;
};

});

parcelRegister("cVNWU", function(module, exports) {

$parcel$export(module.exports, "usePlugins", () => $60c4422245885c0f$export$c41e96fd89bc6106);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $lLItl = parcelRequire("lLItl");

var $lFfL4 = parcelRequire("lFfL4");


var $eTwyk = parcelRequire("eTwyk");

var $1xm4Z = parcelRequire("1xm4Z");

var $3ocoJ = parcelRequire("3ocoJ");
function $60c4422245885c0f$export$c41e96fd89bc6106(state, activeTab, plugins) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [retries, setRetries] = (0, $5uXOq.useState)(0);
    const [pluginState, dispatch] = (0, $1xm4Z.usePluginReducer)();
    const { trackAttribute: trackAttribute } = (0, $lFfL4.useLinkPickerAnalytics)();
    const activePlugin = plugins?.[activeTab];
    trackAttribute('tab', activePlugin?.tabKey ?? null);
    // This useEffect block must be called before any other to ensure onActivation is fired at before resolve
    (0, $5uXOq.useEffect)(()=>{
        if (activePlugin && activePlugin.UNSAFE_onActivation) activePlugin.UNSAFE_onActivation();
    }, [
        activePlugin
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!activePlugin) return;
        if (!state) {
            dispatch({
                type: 'CLEAR'
            });
            return;
        }
        dispatch({
            type: 'LOADING'
        });
        const { next: next, cancel: cancel } = (0, $3ocoJ.resolvePluginUpdates)(activePlugin, state);
        const updateResults = async ()=>{
            try {
                let isLoading = true;
                while(isLoading){
                    const { value: value, done: done } = await next();
                    isLoading = !done;
                    dispatch({
                        type: 'SUCCESS',
                        payload: {
                            items: $60c4422245885c0f$var$limit(value.data),
                            isLoading: !done
                        }
                    });
                }
            } catch (error) {
                if (!(error instanceof (0, $3ocoJ.CancellationError))) {
                    dispatch({
                        type: 'ERROR',
                        payload: error
                    });
                    createAnalyticsEvent((0, $eTwyk.default)('operational.resultsResolve.failed', {
                        error: (0, $lLItl.default)(error).toString()
                    })).fire((0, $27f53d4100568677$export$85183a312807388d));
                }
            }
        };
        updateResults();
        return cancel;
    }, [
        activePlugin,
        state,
        retries,
        createAnalyticsEvent,
        dispatch
    ]);
    const tabs = (0, $5uXOq.useMemo)(()=>{
        if (!plugins || plugins.length <= 1) return [];
        return plugins.filter((plugin)=>!!plugin.tabTitle).map((plugin)=>({
                tabTitle: plugin.tabTitle
            }));
    }, [
        plugins
    ]);
    const handleRetry = (0, $5uXOq.useCallback)(()=>{
        setRetries((prev)=>++prev);
    }, []);
    const { items: items, isLoading: isLoading, error: error } = pluginState;
    return {
        tabs: tabs,
        items: items,
        isLoading: isLoading,
        activePlugin: activePlugin,
        isActivePlugin: !!activePlugin,
        error: error,
        retry: handleRetry,
        errorFallback: activePlugin?.errorFallback,
        pluginAction: activePlugin?.action
    };
}
function $60c4422245885c0f$var$limit(items) {
    return items.slice(0, (0, $27f53d4100568677$export$452f1062ecf44be7));
}

});
parcelRegister("lLItl", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7435f92b90f1f57$export$2e2bcd8739ae039);
const $b7435f92b90f1f57$var$convertToError = (e)=>{
    let error;
    if (e instanceof Error) error = e;
    else if (typeof e === 'string') error = new Error(e);
    else if (typeof e === 'object') try {
        error = new Error('Object error instance thrown for operation: ' + JSON.stringify(e));
    } catch (jsonError) {
        error = new Error('Object serialisation error thrown during operation: ' + String(e));
    }
    else error = new Error('No error instance thrown for operation: ' + String(e));
    return error;
};
var $b7435f92b90f1f57$export$2e2bcd8739ae039 = $b7435f92b90f1f57$var$convertToError;

});

parcelRegister("1xm4Z", function(module, exports) {

$parcel$export(module.exports, "usePluginReducer", () => $033d8afd77baa01f$export$d2118aa240a45264);

var $5uXOq = parcelRequire("5uXOq");
const $033d8afd77baa01f$export$d80b4deb39f4a4a1 = 'CLEAR';
const $033d8afd77baa01f$export$f1146e148fe924c8 = 'LOADING';
const $033d8afd77baa01f$export$cee65e9a71e7c6c2 = 'SUCCESS';
const $033d8afd77baa01f$export$425634cce7676b34 = 'ERROR';
const $033d8afd77baa01f$export$36d128238e6b60f5 = {
    items: null,
    error: null,
    isLoading: false
};
function $033d8afd77baa01f$export$1650419e431d3ba3(state, action) {
    switch(action.type){
        case $033d8afd77baa01f$export$d80b4deb39f4a4a1:
            return {
                ...$033d8afd77baa01f$export$36d128238e6b60f5
            };
        case $033d8afd77baa01f$export$f1146e148fe924c8:
            return {
                ...$033d8afd77baa01f$export$36d128238e6b60f5,
                isLoading: true
            };
        case $033d8afd77baa01f$export$cee65e9a71e7c6c2:
            return {
                ...state,
                ...action.payload,
                error: null
            };
        case $033d8afd77baa01f$export$425634cce7676b34:
            return {
                ...$033d8afd77baa01f$export$36d128238e6b60f5,
                error: action.payload
            };
        default:
            return state;
    }
}
const $033d8afd77baa01f$export$d2118aa240a45264 = ()=>(0, $5uXOq.useReducer)($033d8afd77baa01f$export$1650419e431d3ba3, $033d8afd77baa01f$export$36d128238e6b60f5);

});

parcelRegister("3ocoJ", function(module, exports) {

$parcel$export(module.exports, "CancellationError", () => $fd10b66178aa4a30$export$63884d8ee23c8f42);
$parcel$export(module.exports, "resolvePluginUpdates", () => $fd10b66178aa4a30$export$e4aab3e7990eda97);
class $fd10b66178aa4a30$export$63884d8ee23c8f42 extends Error {
}
const $fd10b66178aa4a30$export$6f8f74cdc4a691c1 = (promise)=>{
    let reject;
    return {
        promise: new Promise((resolve, _reject)=>{
            reject = _reject;
            promise.then(resolve, reject);
        }),
        cancel: ()=>{
            reject(new $fd10b66178aa4a30$export$63884d8ee23c8f42('Promise cancelled'));
        }
    };
};
const $fd10b66178aa4a30$export$e4aab3e7990eda97 = (plugin, state)=>{
    const updates = plugin.resolve(state);
    // Promise plugin
    if (updates instanceof Promise) {
        const { promise: promise, cancel: cancel } = $fd10b66178aa4a30$export$6f8f74cdc4a691c1(updates);
        return {
            cancel: cancel,
            next: async ()=>({
                    value: await promise,
                    done: true
                })
        };
    }
    // Generator plugin
    const cancellationCallbacks = [];
    let cancelled = false;
    return {
        cancel: ()=>{
            cancelled = true;
            cancellationCallbacks.forEach((cb)=>cb());
        },
        next: ()=>{
            const { promise: promise, cancel: cancel } = $fd10b66178aa4a30$export$6f8f74cdc4a691c1(updates.next());
            if (cancelled) cancel();
            else cancellationCallbacks.push(cancel);
            return promise;
        }
    };
};

});


parcelRegister("5pDOa", function(module, exports) {

$parcel$export(module.exports, "useSearchQuery", () => $b225507d7c5d100b$export$e985158d10c27e34);

var $5uXOq = parcelRequire("5uXOq");

var $57Lhk = parcelRequire("57Lhk");
function $b225507d7c5d100b$export$e985158d10c27e34(state) {
    const queryState = (0, $5uXOq.useRef)(null);
    /*
	 * When state contains a valid url AND is NOT selected from results, and the url was updated
	 * from the textbox, queryState should be null to clear the items in plugin state.
	 *
	 * Checking `lastEditedBy` prevents the items being cleared when the tab is changed.
	 */ if ((0, $57Lhk.isSafeUrl)(state.url) && state.selectedIndex === -1 && !state.preventHidingRecents) queryState.current = null;
    /*
	 * When state contains a search term e.g. Not a valid url return a query
	 */ if (queryState.current?.query !== state.url && !(0, $57Lhk.isSafeUrl)(state.url)) queryState.current = {
        query: state.url
    };
    /*
	 * When state contains a valid url and is selected from the list
	 * return current state to prevent triger a new plugin search
	 */ return queryState.current;
}

});

parcelRegister("cLOqK", function(module, exports) {

$parcel$export(module.exports, "Announcer", () => $ada330478fc8aeb4$export$356577adb5b194fa);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
// Note: Flag 'contentRendered' resolves bug with duplicates messages (NVDA + Firefox)
// https://github.com/nvaccess/nvda/labels/bug%2Fdouble-speaking
let $ada330478fc8aeb4$var$timer;
const $ada330478fc8aeb4$export$356577adb5b194fa = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ ariaAtomic: ariaAtomic = 'true', ariaLive: ariaLive = 'polite', ariaRelevant: ariaRelevant = 'all', role: role = 'status', text: text = '', delay: delay = 0 }, ref)=>{
    const [contentRendered, setContentRendered] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        clearTimeout($ada330478fc8aeb4$var$timer);
        setContentRendered(false);
        $ada330478fc8aeb4$var$timer = setTimeout(()=>{
            setContentRendered(true);
        }, delay);
        return ()=>clearTimeout($ada330478fc8aeb4$var$timer);
    }, [
        text,
        delay
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "assistive",
        ref: ref,
        role: role,
        "aria-atomic": ariaAtomic,
        "aria-relevant": ariaRelevant,
        "aria-live": ariaLive,
        children: contentRendered && /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            children: text
        })
    });
}));

});

parcelRegister("hFJqt", function(module, exports) {

$parcel$export(module.exports, "testIds", () => $aea2226d69c73be9$export$800daf5fbbe96aff);
$parcel$export(module.exports, "FormFooter", () => $aea2226d69c73be9$export$e7277fd05612133d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");

var $ldJSL = parcelRequire("ldJSL");
var $fVnbM = parcelRequire("fVnbM");

var $eCeGD = parcelRequire("eCeGD");

var $9lMrf = parcelRequire("9lMrf");

var $dIWbq = parcelRequire("dIWbq");

var $VSDnB = parcelRequire("VSDnB");

var $jldZL = parcelRequire("jldZL");

var $9mPdV = parcelRequire("9mPdV");

var $dzP3c = parcelRequire("dzP3c");
const $aea2226d69c73be9$var$formFooterStyles = null;
const $aea2226d69c73be9$var$formFooterV2Styles = null;
const $aea2226d69c73be9$var$formFooterActionStyles = null;
const $aea2226d69c73be9$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    cancelButton: {
        id: 'fabric.linkPicker.button.cancel',
        defaultMessage: 'Cancel',
        description: 'Button to cancel and dismiss the link picker'
    },
    submittingStatusMessage: {
        id: 'fabric.linkPicker.status.submitting',
        defaultMessage: 'Submitting',
        description: 'Accessibility text to indicate the form has been submitted, and submission is in-progress'
    }
});
const $aea2226d69c73be9$export$800daf5fbbe96aff = {
    insertButton: 'link-picker-insert-button',
    cancelButton: 'link-picker-cancel-button',
    actionButton: 'link-picker-action-button',
    submitStatusA11yIndicator: 'link-picker-submit-status-a11y-indicator'
};
const $aea2226d69c73be9$export$e7277fd05612133d = /*#__PURE__*/ (0, $5uXOq.memo)(({ isLoading: isLoading, isSubmitting: isSubmitting = false, error: error, url: url, queryState: queryState, items: items, isEditing: isEditing, onCancel: onCancel, action: action, customSubmitButtonLabel: customSubmitButtonLabel, submitMessageId: submitMessageId, hideSubmitButton: hideSubmitButton, className: className, ...restProps })=>{
    const intl = (0, $koVbs.default)();
    if (error && error instanceof (0, $9mPdV.UnauthenticatedError)) return null;
    const createButton = (pluginAction)=>(0, $VSDnB.fg)('platform-link-picker-remove-legacy-button') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
            testId: $aea2226d69c73be9$export$800daf5fbbe96aff.actionButton,
            onClick: pluginAction.callback,
            appearance: "default",
            iconBefore: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dIWbq))), {
                    label: "",
                    LEGACY_size: "medium",
                    LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($9lMrf))),
                    color: "currentColor"
                }),
            isDisabled: isSubmitting,
            "aria-labelledby": isSubmitting ? submitMessageId : undefined,
            children: typeof pluginAction.label === 'string' ? pluginAction.label : intl.formatMessage(pluginAction.label)
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
            testId: $aea2226d69c73be9$export$800daf5fbbe96aff.actionButton,
            onClick: pluginAction.callback,
            appearance: "default",
            iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dIWbq))), {
                label: "",
                LEGACY_size: "medium",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($9lMrf))),
                color: "currentColor"
            }),
            isDisabled: isSubmitting,
            "aria-labelledby": isSubmitting ? submitMessageId : undefined,
            children: typeof pluginAction.label === 'string' ? pluginAction.label : intl.formatMessage(pluginAction.label)
        });
    const ButtonComponent = (0, $VSDnB.fg)('platform-link-picker-remove-legacy-button') ? (0, $eCeGD.default) : (0, $fVnbM.default);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("footer", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-linking-visual-refresh-link-picker') ? "_1e0c1txw _1bahesu3 _ca0qpxbi" : "_1e0c1txw _1bahesu3",
            className
        ]),
        ...restProps,
        children: [
            isSubmitting && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jldZL.default), {
                role: "status",
                id: submitMessageId,
                testId: $aea2226d69c73be9$export$800daf5fbbe96aff.submitStatusA11yIndicator,
                children: intl.formatMessage($aea2226d69c73be9$export$defe85febe8b728c.submittingStatusMessage)
            }),
            action && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    "_2hwx1wug"
                ]),
                children: createButton(action)
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $ldJSL.default), {
                children: [
                    onCancel && /*#__PURE__*/ (0, $2OMIu.jsx)(ButtonComponent, {
                        appearance: "subtle",
                        onClick: onCancel,
                        testId: $aea2226d69c73be9$export$800daf5fbbe96aff.cancelButton,
                        isDisabled: isSubmitting,
                        "aria-labelledby": isSubmitting ? submitMessageId : undefined,
                        children: intl.formatMessage($aea2226d69c73be9$export$defe85febe8b728c.cancelButton)
                    }),
                    !hideSubmitButton && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dzP3c.LinkPickerSubmitButton), {
                        isEditing: isEditing,
                        isLoading: isLoading,
                        isSubmitting: isSubmitting,
                        customSubmitButtonLabel: customSubmitButtonLabel,
                        error: error,
                        items: items,
                        queryState: queryState,
                        submitMessageId: submitMessageId,
                        testId: $aea2226d69c73be9$export$800daf5fbbe96aff.insertButton,
                        url: url
                    })
                ]
            })
        ]
    });
});

});
parcelRegister("dIWbq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::73693506539a99d0ae3d26d395e92ac2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9fdc846ce7ffa27e$var$_react = $9fdc846ce7ffa27e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9fdc846ce7ffa27e$var$_baseNew = $9fdc846ce7ffa27e$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $9fdc846ce7ffa27e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Add".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for creating and adding an object as a secondary/tertiary action in a menu item.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9fdc846ce7ffa27e$var$AddIcon = (props)=>/*#__PURE__*/ $9fdc846ce7ffa27e$var$_react.default.createElement($9fdc846ce7ffa27e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.25 6.75V11h1.5V6.75H11v-1.5H6.75V1h-1.5v4.25H1v1.5z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$9fdc846ce7ffa27e$var$AddIcon.displayName = 'AddIcon';
var $9fdc846ce7ffa27e$var$_default = module.exports.default = $9fdc846ce7ffa27e$var$AddIcon;

});

parcelRegister("9mPdV", function(module, exports) {

$parcel$export(module.exports, "UnauthenticatedError", () => $3cbb70a22e35fdf2$export$c7e58b539e03d4b2);
class $3cbb70a22e35fdf2$export$c7e58b539e03d4b2 extends Error {
    constructor(iconUrl, authUrl, description){
        super('The user is not authenticated'), this.iconUrl = iconUrl, this.authUrl = authUrl, this.description = description;
    }
}

});

parcelRegister("dzP3c", function(module, exports) {

$parcel$export(module.exports, "LinkPickerSubmitButton", () => $8d671706a6e005e7$export$a05513b9b425948d);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");

var $2rqOp = parcelRequire("2rqOp");

var $eCeGD = parcelRequire("eCeGD");

var $VSDnB = parcelRequire("VSDnB");

var $c727X = parcelRequire("c727X");
const $8d671706a6e005e7$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    saveButton: {
        id: 'fabric.linkPicker.button.save',
        defaultMessage: 'Save',
        description: 'Button to save edited link'
    },
    insertButton: {
        id: 'fabric.linkPicker.button.insert',
        defaultMessage: 'Insert',
        description: 'Button to insert searched or selected link'
    }
});
const $8d671706a6e005e7$export$a05513b9b425948d = ({ isEditing: isEditing, isLoading: isLoading, isSubmitting: isSubmitting, customSubmitButtonLabel: customSubmitButtonLabel, error: error, items: items, queryState: queryState, submitMessageId: submitMessageId, testId: testId, url: url })=>{
    const intl = (0, $koVbs.default)();
    const insertButtonMsg = isEditing ? $8d671706a6e005e7$export$defe85febe8b728c.saveButton : $8d671706a6e005e7$export$defe85febe8b728c.insertButton;
    const isSubmitDisabled = (0, $c727X.checkSubmitDisabled)(isLoading, isSubmitting, error, url, queryState, items);
    const ButtonComponent = (0, $VSDnB.fg)('platform-link-picker-remove-legacy-button') ? (0, $eCeGD.default) : (0, $2rqOp.default);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(ButtonComponent, {
        type: "submit",
        appearance: "primary",
        testId: testId,
        isDisabled: isSubmitDisabled,
        "aria-labelledby": isSubmitting ? submitMessageId : undefined,
        isLoading: isSubmitting,
        children: customSubmitButtonLabel ? intl.formatMessage(customSubmitButtonLabel) : intl.formatMessage(insertButtonMsg)
    });
};

});
parcelRegister("c727X", function(module, exports) {

$parcel$export(module.exports, "checkSubmitDisabled", () => $5b2ff58aba0d1843$export$3c2c41558ed676ed);

var $57Lhk = parcelRequire("57Lhk");
const $5b2ff58aba0d1843$export$3c2c41558ed676ed = (isLoading, isSubmitting, error, url, queryState, items)=>{
    /*
	 * Enable insert when search term is a valid url and it can be normalized
	 * Need to explicitly enable it here otherwise next condition could meet
	 *
	 * This should effectively be the validation function for the form, ie if the form
	 * could be submitted, then it should not be disabled
	 */ if (isSubmitting) return true;
    if (url && (0, $57Lhk.normalizeUrl)(url)) return false;
    /*
	 * Disable insert button when plugin returns no results,
	 * but not if it is a valid url
	 */ if (queryState && items?.length === 0) return true;
    /*
	 * Disable insert button when is plugin is loading or
	 * for any search error
	 */ if (isLoading || error) return true;
    return false;
};

});



parcelRegister("4iG8d", function(module, exports) {

$parcel$export(module.exports, "searchMessages", () => $cec3e9e00ec7bb3a$export$219f1e8ed9be6c42);
$parcel$export(module.exports, "linkMessages", () => $cec3e9e00ec7bb3a$export$4ce3884394d6d9);
$parcel$export(module.exports, "formMessages", () => $cec3e9e00ec7bb3a$export$60faecfb75056413);
$parcel$export(module.exports, "linkTextMessages", () => $cec3e9e00ec7bb3a$export$89b842e86ff57fca);
$parcel$export(module.exports, "timeMessages", () => $cec3e9e00ec7bb3a$export$c9477bd8c8ba0419);

var $7VHMR = parcelRequire("7VHMR");
const $cec3e9e00ec7bb3a$export$219f1e8ed9be6c42 = (0, $7VHMR.defineMessages)({
    linkLabel: {
        id: 'fabric.linkPicker.search.linkLabel',
        defaultMessage: 'Search or paste a link',
        description: 'Label for the link input'
    },
    linkAriaLabel: {
        id: 'fabric.linkPicker.search.linkAriaLabel',
        defaultMessage: 'Suggestions will appear below as you type into the field',
        description: 'Aria label for the link input'
    },
    linkPlaceholder: {
        id: 'fabric.linkPicker.search.linkPlaceholder',
        defaultMessage: 'Find recent links or paste a new link',
        description: 'Placeholder text for the link input'
    }
});
const $cec3e9e00ec7bb3a$export$4ce3884394d6d9 = (0, $7VHMR.defineMessages)({
    linkLabel: {
        id: 'fabric.linkPicker.linkLabel',
        defaultMessage: 'Link',
        description: 'Label for the link input'
    },
    linkAriaLabel: {
        id: 'fabric.linkPicker.linkAriaLabel',
        defaultMessage: 'Type or paste a link into the field',
        description: 'Aria label for the link input'
    },
    linkPlaceholder: {
        id: 'fabric.linkPicker.linkPlaceholder',
        defaultMessage: 'Paste a link',
        description: 'Placeholder text for the link input'
    }
});
const $cec3e9e00ec7bb3a$export$60faecfb75056413 = (0, $7VHMR.defineMessages)({
    linkInvalid: {
        id: 'fabric.linkPicker.linkInvalid',
        defaultMessage: 'Enter a valid URL.',
        description: 'Error message shown for invalid links'
    },
    clearLink: {
        id: 'fabric.linkPicker.clearLink',
        defaultMessage: 'Clear',
        description: 'Tooltip message for link input clear button'
    },
    noEmbedAvailable: {
        id: 'fabric.linkPicker.noEmbed',
        defaultMessage: "Embed view isn't supported for this link. <a>More about why some Smart Links don't display content.</a>",
        description: 'Error message shown for links without embeds'
    }
});
const $cec3e9e00ec7bb3a$export$89b842e86ff57fca = (0, $7VHMR.defineMessages)({
    linkTextLabel: {
        id: 'fabric.linkPicker.linkTextLabel',
        defaultMessage: 'Display text (optional)',
        description: 'Label for the link display input'
    },
    linkTextAriaLabel: {
        id: 'fabric.linkPicker.linkTextAriaLabel',
        defaultMessage: 'Link display text',
        description: 'Aria label for the link display input'
    },
    linkTextPlaceholder: {
        id: 'fabric.linkPicker.linkTextPlaceholder',
        defaultMessage: 'Text to display',
        description: 'Placeholder text for the link display input'
    },
    clearLinkText: {
        id: 'fabric.linkPicker.clearLinkText',
        defaultMessage: 'Clear text',
        description: 'Tooltip message for link input clear button'
    },
    linkHelperTextLabel: {
        id: 'fabric.linkPicker.linkHelperTextLabel',
        defaultMessage: 'Give this link a title or description',
        description: 'Helper text for the link display input'
    },
    linkHelperTextAriaLabel: {
        id: 'fabric.linkPicker.linkHelperTextAriaLabel',
        defaultMessage: 'Link display helper text',
        description: 'Aria label for the helper text of the link display input'
    }
});
const $cec3e9e00ec7bb3a$export$c9477bd8c8ba0419 = (0, $7VHMR.defineMessages)({
    updated: {
        id: 'fabric.linkPicker.time.message.updated',
        defaultMessage: 'Updated {time}',
        description: 'Time last updated where {time} can be an absolute value e.g. June 5, 2023 or a relative value e.g. 3 hours ago'
    },
    viewed: {
        id: 'fabric.linkPicker.time.message.viewed',
        defaultMessage: 'Viewed {time}',
        description: 'Time last viewed where {time} can be an absolute value e.g. June 5, 2023 or a relative value e.g. 3 hours ago'
    }
});

});

parcelRegister("eUvbr", function(module, exports) {

$parcel$export(module.exports, "testIds", () => $6943a46536585bf3$export$800daf5fbbe96aff);
$parcel$export(module.exports, "SearchResults", () => $6943a46536585bf3$export$aee53da69e9839be);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $eZJjh = parcelRequire("eZJjh");

var $fphHl = parcelRequire("fphHl");
var $jxIT3 = parcelRequire("jxIT3");
var $cte3m = parcelRequire("cte3m");

var $9118a = parcelRequire("9118a");

var $bi77C = parcelRequire("bi77C");

var $9YuVg = parcelRequire("9YuVg");

var $lRkud = parcelRequire("lRkud");

var $cth18 = parcelRequire("cth18");
const $6943a46536585bf3$var$styles = {
    tabsWrapper: "_19pkutpp"
};
const $6943a46536585bf3$var$spinnerContainerStyles = null;
const $6943a46536585bf3$export$800daf5fbbe96aff = {
    ...(0, $9118a.testIds),
    ...(0, $bi77C.testIds),
    tabsLoadingIndicator: 'link-picker.tabs-loading-indicator',
    tabList: 'link-picker-tabs',
    tabItem: 'link-picker-tab'
};
const $6943a46536585bf3$export$aee53da69e9839be = ({ tabs: tabs, activeTab: activeTab, activePlugin: activePlugin, isLoadingPlugins: isLoadingPlugins, isLoadingResults: isLoadingResults, isSubmitting: isSubmitting, handleTabChange: handleTabChange, handleSearchListOnChange: handleSearchListOnChange, featureFlags: featureFlags, linkSearchListId: linkSearchListId, error: error, queryState: queryState, items: items, activeIndex: activeIndex, selectedIndex: selectedIndex, handleSelected: handleSelected, handleKeyDown: handleKeyDown, adaptiveHeight: adaptiveHeight, retry: retry })=>{
    const isActivePlugin = !!activePlugin;
    const tabList = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cte3m.default), {
        children: tabs.map((tab)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $jxIT3.default), {
                testId: $6943a46536585bf3$export$800daf5fbbe96aff.tabItem,
                children: tab.tabTitle
            }, tab.tabTitle))
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $lRkud.SearchResultsContainer), {
        hasTabs: !!tabs.length || isLoadingPlugins,
        adaptiveHeight: adaptiveHeight,
        isLoadingResults: isLoadingResults,
        children: [
            isLoadingPlugins && !!queryState && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    "_1tkeys9h _1e0c1txw _4cvr1h6o _1bah1h6o _1wpz1h6o _16jlkb7n"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
                    testId: $6943a46536585bf3$export$800daf5fbbe96aff.tabsLoadingIndicator,
                    interactionName: "link-picker-tabs-loading",
                    size: "medium"
                })
            }),
            !isLoadingPlugins && isActivePlugin && !!queryState && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
                children: [
                    tabs.length > 0 && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $MHKc7.default), {
                        xcss: $6943a46536585bf3$var$styles.tabsWrapper,
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fphHl.default), {
                                id: $6943a46536585bf3$export$800daf5fbbe96aff.tabList,
                                testId: $6943a46536585bf3$export$800daf5fbbe96aff.tabList,
                                selected: activeTab,
                                onChange: handleTabChange,
                                children: featureFlags?.scrollingTabs ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9YuVg.ScrollingTabList), {
                                    children: tabList
                                }) : tabList
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cth18.TrackTabViewed), {
                                activePlugin: activePlugin
                            })
                        ]
                    }),
                    !error && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bi77C.LinkSearchList), {
                        id: linkSearchListId,
                        role: "listbox",
                        ariaReadOnly: isSubmitting,
                        items: items,
                        isLoading: isLoadingResults,
                        selectedIndex: selectedIndex,
                        activeIndex: activeIndex,
                        onSelect: handleSelected,
                        onChange: handleSearchListOnChange,
                        onKeyDown: handleKeyDown,
                        hasSearchTerm: !!queryState?.query.length,
                        activePlugin: activePlugin,
                        adaptiveHeight: adaptiveHeight,
                        tabPanelId: `${$6943a46536585bf3$export$800daf5fbbe96aff.tabList}-${activeTab}-tab`
                    }),
                    error ? activePlugin?.errorFallback?.(error, retry) ?? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9118a.LinkSearchError), {
                        onRetry: (0, $VSDnB.fg)('platform-linking-visual-refresh-link-picker') ? retry : undefined
                    }) : null
                ]
            })
        ]
    });
};

});
parcelRegister("fphHl", function(module, exports) {

$parcel$export(module.exports, "default", () => $4810d6c8b7d5c95d$export$2e2bcd8739ae039);
/* tabs.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6QvkM = parcelRequire("6QvkM");

var $dWD6q = parcelRequire("dWD6q");
const $4810d6c8b7d5c95d$var$baseStyles = null;
const $4810d6c8b7d5c95d$var$tabsStyles = null;
const $4810d6c8b7d5c95d$var$analyticsAttributes = {
    componentName: 'tabs',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $4810d6c8b7d5c95d$var$getTabPanelWithContext = ({ tabPanel: tabPanel, index: index, isSelected: isSelected, tabsId: tabsId })=>// Ensure tabPanel exists in case it has been removed
    tabPanel && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dWD6q.TabPanelContext).Provider, {
        value: {
            role: 'tabpanel',
            id: `${tabsId}-${index}-tab`,
            hidden: isSelected ? undefined : true,
            'aria-labelledby': `${tabsId}-${index}`,
            tabIndex: isSelected ? 0 : -1
        },
        children: tabPanel
    }, index); /**
                                * __Tabs__
                                *
                                * Tabs acts as a container for all Tab components.
                                *
                                * - [Examples](https://atlassian.design/components/tabs/examples)
                                * - [Code](https://atlassian.design/components/tabs/code)
                                * - [Usage](https://atlassian.design/components/tabs/usage)
                                */ 
const $4810d6c8b7d5c95d$var$Tabs = (props)=>{
    const { shouldUnmountTabPanelOnChange: shouldUnmountTabPanelOnChange = false, selected: SelectedType, defaultSelected: defaultSelected, onChange: onChangeProp, id: id, analyticsContext: analyticsContext, children: children, testId: testId } = props;
    const [selectedState, setSelected] = (0, $5uXOq.useState)(SelectedType || defaultSelected || 0);
    const selected = SelectedType === undefined ? selectedState : SelectedType;
    const childrenArray = (0, $5uXOq.Children).toArray(children) // Don't include any conditional children
    .filter((child)=>Boolean(child)); // First child should be a tabList followed by tab panels
    const [tabList, ...tabPanels] = childrenArray; // Keep track of visited and add to a set
    const visited = (0, $5uXOq.useRef)(new Set([
        selected
    ]));
    if (!visited.current.has(selected)) visited.current.add(selected);
    const onChange = (0, $5uXOq.useCallback)((index, analyticsEvent)=>{
        if (onChangeProp) onChangeProp(index, analyticsEvent);
        setSelected(index);
    }, [
        onChangeProp
    ]);
    const onChangeAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$4810d6c8b7d5c95d$var$analyticsAttributes
    });
    const tabPanelsWithContext = shouldUnmountTabPanelOnChange ? $4810d6c8b7d5c95d$var$getTabPanelWithContext({
        tabPanel: tabPanels[selected],
        index: selected,
        isSelected: true,
        tabsId: id
    }) : // If a panel has already been visited, don't unmount it
    Array.from(visited.current).map((tabIndex)=>$4810d6c8b7d5c95d$var$getTabPanelWithContext({
            tabPanel: tabPanels[tabIndex],
            index: tabIndex,
            isSelected: tabIndex === selected,
            tabsId: id
        }));
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _p12f1osq _1tkeidpf _i0dl1osq _2lx21bp4 _16jlkb7n",
            "_1c3y1txw _ftfaidpf _18i0kb7n _185bglyw"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dWD6q.TabListContext).Provider, {
                value: {
                    selected: selected,
                    onChange: onChangeAnalytics,
                    tabsId: id
                },
                children: tabList
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
                children: tabPanelsWithContext
            })
        ]
    });
};
var $4810d6c8b7d5c95d$export$2e2bcd8739ae039 = $4810d6c8b7d5c95d$var$Tabs;

});
parcelRegister("dWD6q", function(module, exports) {

$parcel$export(module.exports, "TabContext", () => $b47499898157cfdc$export$5a5d356ca5f10a0a);
$parcel$export(module.exports, "TabListContext", () => $b47499898157cfdc$export$aa6907f9fd69e93b);
$parcel$export(module.exports, "TabPanelContext", () => $b47499898157cfdc$export$2054129d247c3102);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $5uXOq = parcelRequire("5uXOq");
const $b47499898157cfdc$export$5a5d356ca5f10a0a = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $b47499898157cfdc$export$aa6907f9fd69e93b = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $b47499898157cfdc$export$2054129d247c3102 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);

});


parcelRegister("jxIT3", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a23bdf24c904bdb$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jhVLw = parcelRequire("jhVLw");

var $dS3PR = parcelRequire("dS3PR");

var $eQ4wW = parcelRequire("eQ4wW");
/**
 * __Tab__
 *
 * Tab represents an indivudal Tab displayed in a TabList.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $5a23bdf24c904bdb$var$Tab = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function Tab({ children: children, testId: testId }, ref) {
    const { onClick: onClick, id: id, 'aria-controls': ariaControls, 'aria-posinset': ariaPosinset, 'aria-selected': ariaSelected, 'aria-setsize': ariaSetsize, onKeyDown: onKeyDown, role: role, tabIndex: tabIndex } = (0, $eQ4wW.useTab)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jhVLw.default), {
        isInset: true,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "data-testid": testId,
            onClick: onClick,
            id: id,
            "aria-controls": ariaControls,
            "aria-posinset": ariaPosinset,
            "aria-selected": ariaSelected,
            "aria-setsize": ariaSetsize,
            onKeyDown: onKeyDown,
            role: role,
            tabIndex: tabIndex,
            ref: ref,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                weight: "medium",
                color: "inherit",
                maxLines: 1,
                children: children
            })
        })
    });
});
var $5a23bdf24c904bdb$export$2e2bcd8739ae039 = $5a23bdf24c904bdb$var$Tab;

});
parcelRegister("eQ4wW", function(module, exports) {

$parcel$export(module.exports, "useTab", () => $4d8616502e4de6b0$export$fdf4756d5b8ef90a);
$parcel$export(module.exports, "useTabList", () => $4d8616502e4de6b0$export$773e389e644c5874);
$parcel$export(module.exports, "useTabPanel", () => $4d8616502e4de6b0$export$fae0121b5afe572d);

var $5uXOq = parcelRequire("5uXOq");

var $dWD6q = parcelRequire("dWD6q");
const $4d8616502e4de6b0$export$fdf4756d5b8ef90a = ()=>{
    const tabData = (0, $5uXOq.useContext)((0, $dWD6q.TabContext));
    if (tabData == null || typeof tabData === 'undefined') throw Error('@atlaskit/tabs: A Tab must have a TabList parent.');
    return tabData;
};
const $4d8616502e4de6b0$export$773e389e644c5874 = ()=>{
    const tabListData = (0, $5uXOq.useContext)((0, $dWD6q.TabListContext));
    if (tabListData === null || typeof tabListData === 'undefined') throw Error('@atlaskit/tabs: A TabList must have a Tabs parent.');
    return tabListData;
};
const $4d8616502e4de6b0$export$fae0121b5afe572d = ()=>{
    const tabPanelData = (0, $5uXOq.useContext)((0, $dWD6q.TabPanelContext));
    if (tabPanelData === null || typeof tabPanelData === 'undefined') throw Error('@atlaskit/tabs:  A TabPanel must have a Tabs parent.');
    return tabPanelData;
};

});


parcelRegister("cte3m", function(module, exports) {

$parcel$export(module.exports, "default", () => $e15f9538b451f314$export$2e2bcd8739ae039);
/* tab-list.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $eQ4wW = parcelRequire("eQ4wW");

var $dWD6q = parcelRequire("dWD6q");
const $e15f9538b451f314$var$baseStyles = null;
const $e15f9538b451f314$var$tabListStyles = null;
const $e15f9538b451f314$var$tabListStylesOld = null;
/**
 * __TabList__
 *
 * A TabList groups `Tab` components together.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $e15f9538b451f314$var$TabList = ({ children: children })=>{
    const { tabsId: tabsId, selected: selected, onChange: onChange } = (0, $eQ4wW.useTabList)();
    const ref = /*#__PURE__*/ (0, $5uXOq.createRef)();
    // Don't include any conditional children
    const childrenArray = (0, $5uXOq.Children).toArray(children).filter(Boolean);
    const length = childrenArray.length;
    const selectTabByIndex = (0, $5uXOq.useCallback)((index)=>{
        const newSelectedNode = ref.current?.querySelector(`[id='${tabsId}-${index}']`);
        if (newSelectedNode) newSelectedNode.focus();
        onChange(index);
    }, [
        tabsId,
        ref,
        onChange
    ]);
    const onKeyDown = (0, $5uXOq.useCallback)((e)=>{
        if (![
            'ArrowRight',
            'ArrowLeft',
            'Home',
            'End'
        ].includes(e.key)) return;
        // preventing horizontal or vertical scroll
        e.preventDefault();
        const lastTabIndex = length - 1;
        if ([
            'Home',
            'End'
        ].includes(e.key)) {
            const newSelected = e.key === 'Home' ? 0 : lastTabIndex;
            selectTabByIndex(newSelected);
            return;
        }
        // We use aria-posinset so we don't rely on the selected variable
        // If we used the selected variable this would regenerate each time
        // and create an unstable reference
        const selectedIndex = parseInt(e.currentTarget.getAttribute('aria-posinset') || '0') - 1;
        const modifier = e.key === 'ArrowRight' ? 1 : -1;
        let newSelected = selectedIndex + modifier;
        if (newSelected < 0 || newSelected >= length) // Cycling focus to move from last to first and from first to last
        newSelected = newSelected < 0 ? lastTabIndex : 0;
        selectTabByIndex(newSelected);
    }, [
        length,
        selectTabByIndex
    ]);
    // Memoized so the function isn't recreated each time
    const getTabWithContext = (0, $5uXOq.useCallback)(({ tab: tab, isSelected: isSelected, index: index })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dWD6q.TabContext).Provider, {
            value: {
                onClick: ()=>onChange(index),
                onKeyDown: onKeyDown,
                'aria-setsize': length,
                role: 'tab',
                id: `${tabsId}-${index}`,
                'aria-posinset': index + 1,
                'aria-selected': isSelected,
                'aria-controls': `${tabsId}-${index}-tab`,
                tabIndex: isSelected ? 0 : -1
            },
            children: tab
        }, index), [
        length,
        onKeyDown,
        onChange,
        tabsId
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "tablist",
        ref: ref,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswh2mm _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_k48p1wq8 _ahbqx0bf _gpbcidpf _10vzidpf _1mmwidpf _15plidpf _7hip15vq _1fud15vq _bb0mh2mm _1quzjjyb _rzxytlke _1ofh12x7 _pryi12x7 _1a85u2gc _rmpau2gc _1dze1l2s _1tms1q9c _fiizidpf _1xrmidpf _xyihidpf _166qidpf _1lzu8zxi _24g71kw7 _140sidpf _lycustnw _15d8b3bt _1fztidpf _wd7eu2gc _1olcu2gc _1oazdud1 _w9ewidpf _170tidpf _y1g1idpf _1nvfidpf _1b8d8zxi _1n121kw7 _7p9oidpf _o2e1stnw _16u6b3bt _1yk1idpf _1lbou2gc _1c9uu2gc _1i201ouy _bppridpf _1mbxidpf _kn0bidpf _wsgdidpf _rsmz174y _1m0e1kw7 _93pdidpf _1sglstnw _1ksob3bt _1p9sidpf _1qa1u2gc _1jjcu2gc _fiem1ldt _pascidpf _eid3idpf _zr3eidpf _fntnidpf _1mp41kw7 _kfgte4h9 _1cs8stnw _1rushloo _1kt9b3bt _1fkridpf _1enwidpf _z5wtu2gc" : "_k48p1wq8 _ahbqx0bf _gpbcidpf _10vzidpf _1mmwidpf _15plidpf _7hip15vq _1fud15vq _bb0mh2mm _1quzjjyb _rzxytlke _1ofh12x7 _pryi12x7 _1a85u2gc _rmpau2gc _1dze1l2s _1tms1q9c _fiizidpf _1xrmidpf _xyihidpf _166qidpf _17hygqwt _1lzu1eqa _24g71kw7 _140sidpf _lycustnw _15d8b3bt _1fztidpf _wd7eu2gc _1olcu2gc _1oazdud1 _w9ewidpf _170tidpf _y1g1idpf _1nvfidpf _1jakgqwt _1b8d1eqa _1n121kw7 _7p9oidpf _o2e1stnw _16u6b3bt _1yk1idpf _1lbou2gc _1c9uu2gc _1i201ouy _bppridpf _1mbxidpf _kn0bidpf _wsgdidpf _9r9ugqwt _rsmz1gcm _1m0e1kw7 _93pdidpf _1sglstnw _1ksob3bt _1p9sidpf _1qa1u2gc _1jjcu2gc _fiem1ldt _pascidpf _eid3idpf _zr3eidpf _fntnidpf _rfx3gqwt _1mp41kw7 _kfgt1bk5 _1cs8stnw _1rushloo _1kt9b3bt _1fkridpf _1enwidpf _z5wtu2gc"
        ]),
        children: childrenArray.map((child, index)=>getTabWithContext({
                tab: child,
                index: index,
                isSelected: index === selected
            }))
    });
};
var $e15f9538b451f314$export$2e2bcd8739ae039 = $e15f9538b451f314$var$TabList;

});

parcelRegister("9118a", function(module, exports) {

$parcel$export(module.exports, "testIds", () => $4c8fcf982270bf8f$export$800daf5fbbe96aff);
$parcel$export(module.exports, "LinkSearchError", () => $4c8fcf982270bf8f$export$a27962a79a9dfbfb);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $c04PQ = parcelRequire("c04PQ");

var $fVnbM = parcelRequire("fVnbM");

var $eCeGD = parcelRequire("eCeGD");

var $e4yMr = parcelRequire("e4yMr");

var $VSDnB = parcelRequire("VSDnB");

var $czNpL = parcelRequire("czNpL");

var $kDdjl = parcelRequire("kDdjl");

var $1aIRG = parcelRequire("1aIRG");
const $4c8fcf982270bf8f$export$d763cac210faabff = 'https://support.atlassian.com/contact/';
const $4c8fcf982270bf8f$export$ad6f8b23d496abfa = 'https://gcs.atlassian-us-gov-mod.net/servicedesk/customer/portals';
const $4c8fcf982270bf8f$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    searchErrorHeader: {
        id: 'fabric.linkPicker.search.error.heading',
        defaultMessage: "We\u2019re having trouble loading data.",
        description: 'Heading message shown when a search throws an error'
    },
    searchErrorDescription: {
        id: 'fabric.linkPicker.search.error.description',
        defaultMessage: 'Refresh the page, or contact <a>Atlassian Support</a> if this keeps happening.',
        description: 'Describes possible actions when search throws an error'
    },
    searchErrorAction: {
        id: 'fabric.linkPicker.search.error.retry',
        defaultMessage: 'Refresh',
        description: 'Describe the action user can take to retry the search'
    }
});
const $4c8fcf982270bf8f$export$800daf5fbbe96aff = {
    searchError: 'link-search-error'
};
const $4c8fcf982270bf8f$export$a27962a79a9dfbfb = ({ onRetry: onRetry })=>{
    const intl = (0, $koVbs.default)();
    const ButtonComponent = (0, $VSDnB.fg)('platform-link-picker-remove-legacy-button') ? (0, $eCeGD.default) : (0, $fVnbM.default);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1aIRG.EmptyState), {
        testId: $4c8fcf982270bf8f$export$800daf5fbbe96aff.searchError,
        header: intl.formatMessage($4c8fcf982270bf8f$export$defe85febe8b728c.searchErrorHeader),
        description: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...$4c8fcf982270bf8f$export$defe85febe8b728c.searchErrorDescription,
            values: {
                a: (label)=>(0, $VSDnB.fg)('platform-link-picker-remove-legacy-button') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e4yMr.default), {
                        href: (0, $c04PQ.isFedRamp)() ? $4c8fcf982270bf8f$export$ad6f8b23d496abfa : $4c8fcf982270bf8f$export$d763cac210faabff,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: label
                    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                        appearance: "link",
                        spacing: "none",
                        href: (0, $c04PQ.isFedRamp)() ? $4c8fcf982270bf8f$export$ad6f8b23d496abfa : $4c8fcf982270bf8f$export$d763cac210faabff,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: label
                    })
            }
        }),
        action: onRetry && (0, $VSDnB.fg)('platform-linking-visual-refresh-link-picker') ? /*#__PURE__*/ (0, $2OMIu.jsx)(ButtonComponent, {
            appearance: "primary",
            onClick: onRetry,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...$4c8fcf982270bf8f$export$defe85febe8b728c.searchErrorAction
            })
        }) : null,
        renderImage: (0, $VSDnB.fg)('platform-linking-visual-refresh-link-picker') ? ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kDdjl.GenericErrorSVGV2), {}) : ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $czNpL.GenericErrorSVG), {})
    });
};

});

parcelRegister("bi77C", function(module, exports) {

$parcel$export(module.exports, "testIds", () => $fd4ce11410a39923$export$800daf5fbbe96aff);
$parcel$export(module.exports, "LinkSearchList", () => $fd4ce11410a39923$export$b6c5ba19d54350b3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7VHMR = parcelRequire("7VHMR");
var $ousew = parcelRequire("ousew");

var $VSDnB = parcelRequire("VSDnB");

var $eZJjh = parcelRequire("eZJjh");

var $jldZL = parcelRequire("jldZL");

var $7OUbW = parcelRequire("7OUbW");

var $4ghTo = parcelRequire("4ghTo");

var $1mYMA = parcelRequire("1mYMA");

var $bucLG = parcelRequire("bucLG");

var $1QsQg = parcelRequire("1QsQg");
const $fd4ce11410a39923$var$styles = {
    emptyStateNoResultsWrapper: "_1tkepxbi"
};
const $fd4ce11410a39923$var$listContainerStyles = null;
const $fd4ce11410a39923$var$spinnerContainerStyles = null;
const $fd4ce11410a39923$var$listStyles = null;
const $fd4ce11410a39923$var$baseListTitleStyles = null;
const $fd4ce11410a39923$var$oldListTitleStyles = null;
const $fd4ce11410a39923$var$newListTitleStyles = null;
const $fd4ce11410a39923$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    titleRecentlyViewed: {
        id: 'fabric.linkPicker.listTitle.recentlyViewed',
        defaultMessage: 'Recently Viewed',
        description: 'Describes type of items shown in the list for screen-reader users'
    },
    titleResults: {
        id: 'fabric.linkPicker.listTitle.results',
        defaultMessage: 'Results',
        description: 'Describes type of items shown in the list for screen-reader users'
    },
    searchLinkResults: {
        id: 'fabric.linkPicker.hyperlink.searchLinkResults',
        defaultMessage: '{count, plural, =0 {no results} one {# result} other {# results}} found',
        description: 'Announce search results for screen-reader users.'
    }
});
const $fd4ce11410a39923$export$800daf5fbbe96aff = {
    ...(0, $1mYMA.testIds),
    ...(0, $bucLG.testIds),
    resultListTitle: 'link-picker-list-title',
    searchResultList: 'link-search-list',
    searchResultLoadingIndicator: 'link-picker.results-loading-indicator',
    tabsLoadingIndicator: 'link-picker.tabs-loading-indicator'
};
const $fd4ce11410a39923$export$b6c5ba19d54350b3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ onChange: onChange, onSelect: onSelect, onKeyDown: onKeyDown, items: items, activeIndex: activeIndex, selectedIndex: selectedIndex, isLoading: isLoading, ariaControls: ariaControls, ariaLabelledBy: ariaLabelledBy, ariaReadOnly: ariaReadOnly, role: role, id: id, hasSearchTerm: hasSearchTerm, activePlugin: activePlugin, adaptiveHeight: adaptiveHeight, className: className, tabPanelId: tabPanelId, ...restProps }, ref)=>{
    let itemsContent;
    let loadingContent;
    const linkListTitle = hasSearchTerm ? $fd4ce11410a39923$export$defe85febe8b728c.titleResults : $fd4ce11410a39923$export$defe85febe8b728c.titleRecentlyViewed;
    (0, $1QsQg.useTrackResultsShown)(isLoading, items, hasSearchTerm);
    const itemRefs = (0, $5uXOq.useRef)({});
    const itemRefCallback = (0, $5uXOq.useCallback)((el, id)=>{
        if (el === null) delete itemRefs.current[id];
        else itemRefs.current[id] = el;
    }, []);
    const getTabIndex = (0, $5uXOq.useCallback)((index)=>{
        if (selectedIndex > -1) return selectedIndex === index ? 0 : -1;
        if (index === 0) return 0;
        return -1;
    }, [
        selectedIndex
    ]);
    const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
        let updatedIndex = activeIndex;
        if (onKeyDown) onKeyDown(event);
        if (!items?.length) return;
        updatedIndex = (0, $4ghTo.handleNavKeyDown)(event, items.length, activeIndex);
        const item = items?.[updatedIndex];
        if ([
            'ArrowDown',
            'ArrowUp',
            'Home',
            'End'
        ].includes(event.key) && item) {
            if (itemRefs.current) itemRefs.current[item.objectId]?.focus();
        }
    }, [
        activeIndex,
        items,
        onKeyDown
    ]);
    if (items?.length === 0) {
        if (!hasSearchTerm) {
            const emptyState = activePlugin?.emptyStateNoResults?.();
            if (emptyState) return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                id: tabPanelId,
                className: (0, $bwpsq.default)([
                    $fd4ce11410a39923$var$styles.emptyStateNoResultsWrapper
                ]),
                children: emptyState
            });
        }
        return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            id: tabPanelId,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1mYMA.NoResults), {})
        });
    }
    const listItemNameMaxLines = activePlugin?.uiOptions?.listItemNameMaxLines;
    if (items && items.length > 0) itemsContent = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                id: $fd4ce11410a39923$export$800daf5fbbe96aff.resultListTitle,
                "data-testid": $fd4ce11410a39923$export$800daf5fbbe96aff.resultListTitle,
                className: (0, $bwpsq.default)([
                    "_11c81o8v _k48pmoej _otyr1b66",
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') ? "_syaz1gjq" : "_syaz131l"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...linkListTitle
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jldZL.default), {
                id: "fabric.smartcard.linkpicker.suggested.results",
                children: hasSearchTerm && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...$fd4ce11410a39923$export$defe85febe8b728c.searchLinkResults,
                    values: {
                        count: items.length
                    },
                    "aria-live": "polite",
                    "aria-atomic": "true"
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("ul", {
                id: id,
                role: role,
                "aria-controls": "fabric.smartcard.linkpicker.suggested.results",
                "aria-labelledby": $fd4ce11410a39923$export$800daf5fbbe96aff.resultListTitle,
                "aria-readonly": ariaReadOnly,
                "data-testid": $fd4ce11410a39923$export$800daf5fbbe96aff.searchResultList,
                className: (0, $bwpsq.default)([
                    "_qtt8glyw _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _19pkze3t _otyrze3t _18u01mjz _2hwxum63"
                ]),
                children: items.map((item, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $bucLG.LinkSearchListItem), {
                        id: `${$fd4ce11410a39923$export$800daf5fbbe96aff.searchResultItem}-${index}`,
                        role: role && 'option',
                        item: item,
                        selected: selectedIndex === index,
                        active: activeIndex === index,
                        onFocus: ()=>onChange(item.objectId),
                        onKeyDown: handleKeyDown,
                        onSelect: onSelect,
                        tabIndex: getTabIndex(index),
                        ref: (el)=>itemRefCallback(el, item.objectId),
                        nameMaxLines: listItemNameMaxLines
                    }, item.objectId))
            })
        ]
    });
    if (isLoading) loadingContent = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7OUbW.MinHeightContainer), {
        minHeight: adaptiveHeight ? '80px' : '50px',
        className: (0, $bwpsq.default)([
            "_16jlkb7n _2lx21bp4 _4cvr1h6o"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
            testId: $fd4ce11410a39923$export$800daf5fbbe96aff.searchResultLoadingIndicator,
            interactionName: "link-picker-search-list-loading",
            size: "medium"
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        id: tabPanelId,
        ref: ref,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _ca0qidpf _1tkeys9h _19pkpxbi _otyrpxbi _16jlkb7n _1e0c1txw _2lx21bp4",
            className
        ]),
        ...restProps,
        children: [
            itemsContent,
            loadingContent
        ]
    });
});

});
parcelRegister("1mYMA", function(module, exports) {

$parcel$export(module.exports, "testIds", () => $d69e937613f72f13$export$800daf5fbbe96aff);
$parcel$export(module.exports, "NoResults", () => $d69e937613f72f13$export$ef6006467f04ee41);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");

var $VSDnB = parcelRequire("VSDnB");

var $1aIRG = parcelRequire("1aIRG");

var $4BirR = parcelRequire("4BirR");

var $b2D5N = parcelRequire("b2D5N");
const $d69e937613f72f13$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    noResults: {
        id: 'fabric.linkPicker.search.noResults.heading',
        defaultMessage: "We couldn\u2019t find anything matching your search.",
        description: 'Heading message shown when a search has no results'
    },
    noResultsDescription: {
        id: 'fabric.linkPicker.search.noResults.description',
        defaultMessage: 'Try again with a different term.',
        description: 'Describes possible action when a search returns no results'
    }
});
const $d69e937613f72f13$export$800daf5fbbe96aff = {
    emptyResultPage: 'link-search-no-results'
};
const $d69e937613f72f13$export$ef6006467f04ee41 = ()=>{
    const intl = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1aIRG.EmptyState), {
        testId: $d69e937613f72f13$export$800daf5fbbe96aff.emptyResultPage,
        header: intl.formatMessage($d69e937613f72f13$export$defe85febe8b728c.noResults),
        description: intl.formatMessage($d69e937613f72f13$export$defe85febe8b728c.noResultsDescription),
        renderImage: (0, $VSDnB.fg)('platform-linking-visual-refresh-link-picker') ? ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $b2D5N.NoResultsV2SVG), {}) : ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $4BirR.NoResultsSVG), {})
    });
};

});
parcelRegister("4BirR", function(module, exports) {

$parcel$export(module.exports, "NoResultsSVG", () => $6e81b20a9105f55a$export$5485715da946f3be);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $6e81b20a9105f55a$var$HEIGHT = 120;
const $6e81b20a9105f55a$var$noResultsSVGStyles = null;
const $6e81b20a9105f55a$export$5485715da946f3be = ()=>{
    const id = 'link-picker-ui-no-results-svg';
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        height: "120",
        viewBox: "0 0 208 191",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $bwpsq.default)([
            "_4t3i68cl _1e0c1ule"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                clipPath: `url(#${id}-a)`,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        opacity: ".3",
                        d: "M105.28 190.44c-.93.03-1.86.05-2.79.06-1.3.01-2.36-1.04-2.36-2.34-.01-1.27 1-2.32 2.27-2.36h.07c5.93-.03 11.95-.67 17.74-1.9a2.352 2.352 0 0 1 .98 4.6 94.236 94.236 0 0 1-15.91 1.94ZM89.77 189.649c-.13 0-.27 0-.41-.02a91.17 91.17 0 0 1-18.27-4.49 2.353 2.353 0 1 1 1.59-4.43 85.94 85.94 0 0 0 17.32 4.25c1.29.18 2.19 1.36 2.01 2.65-.15 1.16-1.12 2-2.24 2.04ZM133.08 184.98c-.99.03-1.93-.56-2.29-1.54-.45-1.22.17-2.57 1.39-3.02a87.114 87.114 0 0 0 16.01-7.87 2.35 2.35 0 1 1 2.5 3.98c-5.32 3.33-11 6.13-16.87 8.3-.25.1-.49.14-.74.15ZM60.25 180.089c-.4.01-.81-.07-1.18-.27a92.004 92.004 0 0 1-15.61-10.48 2.35 2.35 0 0 1-.31-3.31c.83-1 2.31-1.14 3.31-.31a87.13 87.13 0 0 0 14.81 9.94c1.15.61 1.58 2.03.97 3.18a2.31 2.31 0 0 1-1.99 1.25ZM35.79 161.01c-.67.02-1.35-.24-1.83-.77a91.583 91.583 0 0 1-11.11-15.17 2.353 2.353 0 1 1 4.06-2.38c3 5.13 6.55 9.97 10.54 14.39.87.96.8 2.45-.17 3.32-.43.39-.96.59-1.49.61ZM179.7 145.469c-.42.01-.86-.08-1.25-.31a2.346 2.346 0 0 1-.87-3.21 86.618 86.618 0 0 0 7.22-16.31c.4-1.24 1.73-1.91 2.96-1.51 1.24.4 1.91 1.73 1.51 2.96a91.279 91.279 0 0 1-7.62 17.19c-.41.74-1.16 1.16-1.95 1.19ZM19.3 134.749c-.96.03-1.88-.53-2.26-1.47a90.64 90.64 0 0 1-5.23-18.06 2.35 2.35 0 0 1 1.9-2.73c1.28-.23 2.5.62 2.73 1.9a87.04 87.04 0 0 0 4.96 17.13c.49 1.2-.09 2.58-1.3 3.06-.26.1-.53.16-.8.17ZM190.19 116.26a2.346 2.346 0 0 1-2.4-2.74c1-5.84 1.39-11.83 1.18-17.8l-.01-.2c-.05-1.3.97-2.39 2.27-2.43 1.3-.05 2.39.97 2.43 2.27l.01.2c.22 6.29-.2 12.6-1.25 18.76a2.345 2.345 0 0 1-2.23 1.94ZM12.82 104.36c-1.3.05-2.39-.92-2.43-2.22v-.1c-.22-6.26.19-12.54 1.23-18.66a2.36 2.36 0 0 1 2.71-1.93 2.36 2.36 0 0 1 1.93 2.71 87.974 87.974 0 0 0-1.17 17.7c.05 1.31-.97 2.45-2.27 2.5ZM190 85.05a2.35 2.35 0 0 1-2.39-1.93A86.803 86.803 0 0 0 182.63 66a2.36 2.36 0 0 1 1.29-3.07c1.2-.49 2.58.09 3.07 1.29 2.36 5.8 4.13 11.88 5.25 18.06.23 1.28-.61 2.5-1.89 2.74l-.35.03ZM17.07 73.668c-.27.01-.54-.03-.81-.11a2.347 2.347 0 0 1-1.51-2.96 91.288 91.288 0 0 1 7.6-17.2 2.355 2.355 0 0 1 3.21-.88c1.13.64 1.52 2.08.88 3.21a87.027 87.027 0 0 0-7.21 16.32c-.32.96-1.2 1.59-2.16 1.62ZM179.22 55.98a2.34 2.34 0 0 1-2.11-1.16 87.748 87.748 0 0 0-10.56-14.38c-.87-.96-.8-2.45.17-3.32.96-.87 2.45-.8 3.32.17 4.22 4.66 7.96 9.75 11.13 15.15.66 1.12.28 2.56-.84 3.22-.35.2-.73.3-1.11.32ZM31.61 46.26c-.53.02-1.07-.14-1.53-.5a2.354 2.354 0 0 1-.41-3.3 92.27 92.27 0 0 1 13.01-13.57 2.36 2.36 0 0 1 3.32.27c.84.99.72 2.47-.27 3.32a87.993 87.993 0 0 0-12.35 12.88c-.44.57-1.1.88-1.77.9ZM159.12 32.35c-.56.02-1.12-.16-1.58-.54-4.59-3.8-9.57-7.14-14.83-9.93a2.35 2.35 0 0 1-.98-3.18 2.359 2.359 0 0 1 3.18-.98 91.78 91.78 0 0 1 15.62 10.46c1 .83 1.14 2.31.31 3.31-.44.54-1.08.83-1.72.86ZM54.62 25.45c-.81.03-1.61-.36-2.08-1.1a2.35 2.35 0 0 1 .74-3.24 91.806 91.806 0 0 1 16.87-8.32c1.22-.45 2.57.17 3.02 1.39.45 1.22-.17 2.57-1.39 3.02a86.792 86.792 0 0 0-16 7.89c-.36.23-.76.35-1.16.36ZM132.16 16.979c-.29.01-.59-.03-.87-.14-5.6-2-11.43-3.42-17.33-4.23a2.353 2.353 0 0 1 .64-4.66c6.22.85 12.36 2.35 18.27 4.46 1.22.44 1.86 1.78 1.42 3.01-.33.93-1.2 1.53-2.13 1.56ZM83.36 13.78a2.352 2.352 0 0 1-.57-4.65 93.98 93.98 0 0 1 18.69-2.03 2.356 2.356 0 0 1 .1 4.71h-.07c-5.93.03-11.95.69-17.74 1.92-.14.03-.28.04-.41.05Z",
                        fill: "#B3BAC5"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        opacity: ".3",
                        d: "M190.8 34.81a.522.522 0 0 1-.39-.56l.06-.45c.05-.29.11-.6.19-.92.3-1.15.85-2.18 1.64-3.09.79-.91 1.93-1.67 3.4-2.26l2.48-1.01c1.48-.59 2.39-1.57 2.75-2.92.13-.49.17-.99.12-1.51a3.44 3.44 0 0 0-.47-1.46c-.27-.45-.64-.86-1.13-1.22-.49-.36-1.09-.63-1.81-.82-.78-.2-1.47-.23-2.09-.09-.62.14-1.17.39-1.65.74s-.88.8-1.2 1.34c-.33.54-.57 1.12-.73 1.72-.05.18-.09.36-.12.52-.09.47-.56.75-1.02.61L187 22.26c-.36-.11-.61-.46-.57-.83.01-.12.03-.24.05-.36.06-.34.13-.66.21-.98.3-1.15.81-2.22 1.53-3.21.72-.99 1.61-1.8 2.67-2.43 1.06-.63 2.26-1.04 3.62-1.24 1.36-.2 2.84-.08 4.45.34 1.67.44 3.07 1.07 4.2 1.89 1.14.82 2.03 1.74 2.68 2.75.65 1.02 1.06 2.1 1.22 3.25.16 1.15.1 2.27-.19 3.36-.45 1.72-1.23 3.09-2.32 4.11-1.1 1.02-2.41 1.82-3.95 2.39l-2.09.79c-.59.19-1.47.58-2.2 1.38-.07.08-.37.41-.67.92-.22.38-.38.75-.49 1.07-.09.26-.37.4-.63.33l-3.72-.98Zm-3.06 5.87c.25-.95.79-1.67 1.63-2.17.84-.5 1.73-.63 2.68-.38.95.25 1.67.8 2.17 1.65.5.85.62 1.75.37 2.7-.25.95-.8 1.66-1.65 2.15-.85.48-1.75.6-2.69.35-.95-.25-1.67-.79-2.15-1.62-.49-.84-.61-1.73-.36-2.68ZM18.51 21.94a.518.518 0 0 1-.35-.58l.09-.45c.07-.29.15-.59.26-.9.38-1.13.99-2.12 1.85-2.97.85-.86 2.03-1.53 3.55-2.03l2.54-.84c1.51-.49 2.49-1.4 2.94-2.73.16-.48.24-.98.22-1.5-.01-.52-.14-1.02-.37-1.49-.23-.47-.58-.9-1.05-1.29-.46-.39-1.05-.7-1.75-.94-.76-.26-1.46-.33-2.08-.23-.63.1-1.19.31-1.69.63s-.93.74-1.29 1.26a6.16 6.16 0 0 0-.86 1.67c-.06.18-.11.35-.15.51-.12.46-.61.71-1.06.54l-3.74-1.42a.803.803 0 0 1-.51-.87c.02-.12.05-.24.08-.36.08-.33.17-.65.28-.96.38-1.13.96-2.16 1.75-3.1s1.73-1.69 2.82-2.25c1.1-.56 2.33-.89 3.69-.99 1.37-.1 2.84.11 4.41.64 1.63.55 2.99 1.27 4.07 2.17 1.08.9 1.91 1.87 2.49 2.93.58 1.06.92 2.16 1 3.32a8.52 8.52 0 0 1-.42 3.34c-.57 1.69-1.43 3-2.6 3.94-1.16.94-2.53 1.65-4.1 2.12l-2.14.64c-.6.15-1.51.48-2.29 1.23-.08.08-.4.39-.73.87-.25.37-.43.72-.56 1.03a.52.52 0 0 1-.65.29l-3.65-1.23Zm-3.45 5.65c.31-.93.9-1.62 1.77-2.06.87-.44 1.77-.51 2.7-.2.93.31 1.61.91 2.05 1.79.44.88.5 1.79.19 2.72-.31.93-.91 1.61-1.79 2.03-.88.42-1.78.48-2.71.17-.93-.31-1.61-.9-2.04-1.77-.42-.85-.48-1.75-.17-2.68ZM12.39 180.998c-.24.09-.52 0-.64-.23-.07-.13-.14-.27-.21-.41-.13-.27-.25-.56-.37-.86a7.553 7.553 0 0 1-.43-3.47c.13-1.2.62-2.47 1.49-3.81l1.45-2.25c.87-1.33 1.06-2.66.57-3.97a4.47 4.47 0 0 0-.77-1.31c-.34-.4-.74-.71-1.22-.93-.48-.22-1.02-.33-1.63-.35-.61-.01-1.26.11-1.95.37-.75.28-1.34.65-1.77 1.13-.43.47-.73.99-.92 1.55-.19.56-.26 1.16-.22 1.79.04.63.17 1.24.39 1.83.07.18.13.34.2.49a.8.8 0 0 1-.48 1.09l-3.8 1.24a.788.788 0 0 1-.94-.36c-.06-.11-.11-.22-.17-.33-.15-.31-.28-.62-.39-.92a9.594 9.594 0 0 1-.59-3.51c.02-1.23.28-2.4.79-3.52.5-1.12 1.25-2.15 2.25-3.09s2.28-1.7 3.84-2.27c1.62-.6 3.12-.89 4.52-.87 1.4.02 2.66.26 3.78.71 1.12.46 2.07 1.11 2.86 1.96.79.85 1.38 1.8 1.77 2.86.62 1.67.77 3.24.46 4.7s-.93 2.87-1.86 4.23l-1.26 1.85c-.37.5-.87 1.32-1.01 2.39-.01.11-.07.55-.02 1.13.04.44.12.83.22 1.15a.53.53 0 0 1-.33.64l-3.61 1.35Zm.87 6.56c-.34-.92-.31-1.82.09-2.72.4-.89 1.06-1.51 1.98-1.85.92-.34 1.83-.3 2.72.11.9.41 1.52 1.08 1.86 2 .34.92.3 1.82-.12 2.7-.42.88-1.09 1.49-2 1.83-.92.34-1.82.31-2.7-.09-.88-.4-1.49-1.06-1.83-1.98Z",
                        fill: "#C1C7D0"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "m149.36 134.209-7.15-6.93-9.63 9.95 7.15 6.93c1.83 1.77 3.11 4.02 3.71 6.49.6 2.47 1.89 4.72 3.71 6.49l29.03 28.1c4.4 4.26 11.41 4.14 15.67-.25 4.26-4.4 4.14-11.41-.25-15.67l-29.03-28.1a13.457 13.457 0 0 0-6.61-3.5 13.65 13.65 0 0 1-6.6-3.51Z",
                        fill: "#CFD4DB"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M155.68 137.628c-2.37-.55-4.56-1.73-6.31-3.43l-2.18-2.11a6.92 6.92 0 0 0-9.79.16 6.92 6.92 0 0 0 .16 9.79l2.18 2.11c1.75 1.7 3 3.84 3.63 6.19 2.35-1.78 4.57-3.75 6.66-5.91 2.07-2.13 3.95-4.41 5.65-6.8Z",
                        fill: "#B3BAC5"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M101.95 156.619c-15.47.25-30.11-5.54-41.22-16.3-22.95-22.21-23.54-58.95-1.33-81.9 10.76-11.11 25.21-17.37 40.67-17.63 15.47-.25 30.11 5.54 41.22 16.3 11.12 10.76 17.37 25.21 17.63 40.67.25 15.47-5.54 30.11-16.3 41.22-10.75 11.13-25.2 17.39-40.67 17.64Zm-1.65-102c-11.78.19-22.77 4.96-30.97 13.42-16.91 17.47-16.46 45.44 1.01 62.35 8.46 8.19 19.61 12.6 31.39 12.41 11.78-.19 22.77-4.96 30.97-13.42 8.19-8.46 12.6-19.61 12.41-31.39-.19-11.78-4.96-22.77-13.42-30.97-8.47-8.18-19.61-12.59-31.39-12.4Z",
                        fill: `url(#${id}-b)`
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "m118.92 85.84-5.34-5.25c-.79-.77-2.05-.76-2.83.03l-9.79 9.97-9.97-9.79c-.79-.77-2.05-.76-2.83.03l-5.25 5.34c-.77.79-.76 2.05.03 2.83l9.97 9.79-9.79 9.97c-.77.79-.76 2.05.03 2.83l5.34 5.25c.79.77 2.05.76 2.83-.03l9.79-9.97 9.97 9.79c.79.77 2.05.76 2.83-.03l5.25-5.34c.77-.79.76-2.05-.03-2.83l-9.97-9.79 9.79-9.97c.77-.79.76-2.06-.03-2.83Z",
                        fill: "#C1C7D0"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: `${id}-b`,
                        x1: "60.062",
                        y1: "139.664",
                        x2: "141.969",
                        y2: "57.757",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: ".557",
                                stopColor: "#C1C7D0"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: ".966",
                                stopColor: "#E9EBEF",
                                stopOpacity: ".5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("clipPath", {
                        id: `${id}-a`,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(0 .62)",
                            d: "M0 0h207.16v189.87H0z"
                        })
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("b2D5N", function(module, exports) {

$parcel$export(module.exports, "NoResultsV2SVG", () => $aacea49522f25c91$export$7b48ba69cdd908a3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $aacea49522f25c91$var$SIZE = 96;
const $aacea49522f25c91$var$noResultsSVGStyles = null;
const $aacea49522f25c91$export$7b48ba69cdd908a3 = ()=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        viewBox: "0 0 96 96",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $bwpsq.default)([
            "_1bsb16xz _4t3i16xz _1e0c1ule"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fill: "#fff",
                d: "M64.861 32.06a27.747 27.747 0 0 0-2.667-4.133 28.188 28.188 0 0 0-3.376-3.669c-6.985-6.311-15.57-6.89-23.609-2.53a30.246 30.246 0 0 0-4.056 2.656 30.624 30.624 0 0 0-3.735 3.4c-6.225 6.717-7.82 15.154-3.505 23.463a28.103 28.103 0 0 0 2.698 4.192 27.67 27.67 0 0 0 3.33 3.62c6.94 6.267 15.518 6.85 23.596 2.507a30.502 30.502 0 0 0 4.23-2.758 30.071 30.071 0 0 0 3.593-3.257c6.252-6.692 7.847-15.161 3.494-23.49h.007Z"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fill: "#DDDEE1",
                d: "M43.092 66.774c-5.306 0-10.382-1.997-14.75-5.938a30.405 30.405 0 0 1-3.62-3.93 30.222 30.222 0 0 1-2.928-4.553c-4.657-8.96-3.247-18.509 3.871-26.192a33.27 33.27 0 0 1 4.025-3.669 32.825 32.825 0 0 1 4.378-2.87c9.209-4.995 18.816-3.951 26.353 2.86a30.96 30.96 0 0 1 3.665 3.98 30.302 30.302 0 0 1 2.898 4.489c4.706 9.003 3.295 18.564-3.868 26.23a32.157 32.157 0 0 1-3.879 3.516 33.436 33.436 0 0 1-4.562 2.974c-3.858 2.073-7.781 3.1-11.583 3.1v.003Zm2.53-45.486c-3.019 0-6.147.841-9.274 2.541a28.43 28.43 0 0 0-3.736 2.447 28.058 28.058 0 0 0-3.442 3.135c-5.746 6.203-6.86 13.566-3.135 20.736a25.4 25.4 0 0 0 2.472 3.83 25.297 25.297 0 0 0 3.044 3.309c5.99 5.41 13.398 6.182 20.862 2.175a28.01 28.01 0 0 0 3.9-2.545 28.04 28.04 0 0 0 3.308-2.999c5.778-6.182 6.885-13.552 3.125-20.75a25.545 25.545 0 0 0-2.44-3.777 25.854 25.854 0 0 0-3.086-3.358c-3.491-3.152-7.443-4.744-11.59-4.744h-.007Z"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fill: "#DDDEE1",
                d: "M62.822 59.695c-1.235-1.721-2.562-1.71-3.857-.709-1.215.939-1.54 2.21-.244 3.882l1.48 1.913 4.102-3.173-1.48-1.913Z"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fill: "#DDDEE1",
                d: "m65.334 60.811-6.158 4.762 11.573 14.969 6.159-4.762L65.334 60.81Z"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fill: "#B7B9BE",
                d: "m64.344 61.577-4.178 3.23 3.925 5.076 4.178-3.23-3.925-5.076Z"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fill: "#DDDEE1",
                d: "M46.496 47.476h-3.492v-.221c-.119-2.484 1.29-5.174 3.295-6.274l.038-.02c.054-.028.107-.061.157-.095 1.094-.705 1.717-1.92 1.678-3.257-.038-1.326-.722-2.49-1.829-3.117a4.596 4.596 0 0 0-2.256-.605c-2.365 0-4.289 1.938-4.289 4.319h-3.492c0-4.32 3.49-7.835 7.78-7.835 1.375 0 2.747.365 3.967 1.055 2.186 1.237 3.536 3.51 3.61 6.082.074 2.583-1.15 4.943-3.272 6.312-.143.093-.289.18-.433.256-.832.468-1.529 1.907-1.465 3.033l.003.367Z"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fill: "#DDDEE1",
                fillRule: "evenodd",
                d: "M44.413 49.492a3.465 3.465 0 0 1 1.119-.003c1.138.187 2.064.985 2.289 2.229l.002.009.001.01a3.419 3.419 0 0 1-.001 1.126v.004c-.22 1.256-1.161 2.052-2.295 2.236a3.5 3.5 0 0 1-1.108-.003h-.001c-1.14-.184-2.07-.981-2.296-2.224l-.002-.01-.001-.01a3.37 3.37 0 0 1 0-1.12l.001-.01.002-.01c.227-1.249 1.161-2.034 2.288-2.223h.002Z",
                clipRule: "evenodd"
            })
        ]
    });
};

});


parcelRegister("bucLG", function(module, exports) {

$parcel$export(module.exports, "testIds", () => $1dbd111751ef340b$export$800daf5fbbe96aff);
$parcel$export(module.exports, "LinkSearchListItem", () => $1dbd111751ef340b$export$42975d65146c61a1);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $VSDnB = parcelRequire("VSDnB");

var $dS3PR = parcelRequire("dS3PR");

var $hA5US = parcelRequire("hA5US");

var $5k7LC = parcelRequire("5k7LC");
var $1dbd111751ef340b$require$Buffer = $5k7LC.Buffer;
const $1dbd111751ef340b$export$800daf5fbbe96aff = {
    searchResultItem: 'link-search-list-item',
    searchResultIcon: 'link-search-list-item-icon'
};
const $1dbd111751ef340b$var$isSVG = (icon)=>icon.startsWith('<svg') && icon.endsWith('</svg>');
const $1dbd111751ef340b$var$base64SVG = (icon)=>`data:image/svg+xml;base64,${$1dbd111751ef340b$require$Buffer.from(icon).toString('base64')}`;
const $1dbd111751ef340b$var$itemIconStyles = null;
const $1dbd111751ef340b$var$listItemContextStyles = null;
const $1dbd111751ef340b$var$listItemContainerStyles = null;
const $1dbd111751ef340b$var$listItemContainerInnerStyles = null;
const $1dbd111751ef340b$var$listItemContainerInnerStylesA11yRefresh = null;
const $1dbd111751ef340b$var$listItemContainerInnerStylesSeparatorLinkPickerRefresh = null;
const $1dbd111751ef340b$var$itemNameStyles = null;
const $1dbd111751ef340b$var$imgStyles = null;
const $1dbd111751ef340b$var$listItemBaseStyles = null;
const $1dbd111751ef340b$var$ListItemIcon = (props)=>{
    const { item: item, intl: intl } = props;
    const { icon: icon, iconAlt: iconAlt } = item;
    if (!icon) return null;
    const alt = typeof iconAlt === 'string' ? iconAlt : intl.formatMessage(iconAlt);
    if (typeof icon !== 'string') {
        const Glyph = icon;
        return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            className: (0, $bwpsq.default)([
                "_1ul9pxbi _19pk1b66 _2hwxutpp"
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Glyph, {
                alt: alt,
                "data-testid": $1dbd111751ef340b$export$800daf5fbbe96aff.searchResultIcon
            })
        });
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            "_1ul9pxbi _19pk1b66 _2hwxutpp"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
            "data-testid": $1dbd111751ef340b$export$800daf5fbbe96aff.searchResultIcon,
            src: $1dbd111751ef340b$var$isSVG(icon) ? $1dbd111751ef340b$var$base64SVG(icon) : icon,
            alt: alt,
            className: (0, $bwpsq.default)([
                "_p12fpxbi"
            ])
        })
    });
};
const $1dbd111751ef340b$var$ListItemSubtitle = ({ items: [firstItem, secondItem] })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-testid": `${$1dbd111751ef340b$export$800daf5fbbe96aff.searchResultItem}-subtitle`,
        className: (0, $bwpsq.default)([
            "_11c81o8v _syaz14xw _1e0c1txw"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    "_1reo15vq _18m915vq _1bto1l2s"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    className: (0, $bwpsq.default)([
                        (0, $VSDnB.fg)('bandicoots-a11y-link-picker-styling') ? "_syaz1a45 _o5721q9c" : "_syaz1wmz _o5721q9c"
                    ]),
                    children: firstItem
                })
            }),
            secondItem && /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                className: (0, $bwpsq.default)([
                    (0, $VSDnB.fg)('bandicoots-a11y-link-picker-styling') ? "_syaz1a45 _o5721q9c" : "_syaz1wmz _o5721q9c"
                ]),
                children: [
                    (0, $VSDnB.fg)('platform-linking-visual-refresh-link-picker') ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                        className: (0, $bwpsq.default)([
                            "_syaz1fzn"
                        ]),
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
                            children: "\xa0 \u2022\xa0 "
                        })
                    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
                        children: "\xa0 \u2022\xa0 "
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
                        children: secondItem
                    })
                ]
            })
        ]
    });
};
const $1dbd111751ef340b$var$getDefaultSubtitleItems = (item, intl)=>{
    const container = item.container;
    const date = (0, $hA5US.transformTimeStamp)(intl, item.lastViewedDate, item.lastUpdatedDate);
    if (container) {
        if (date) return [
            container,
            date
        ];
        return [
            container
        ];
    }
    if (date) return [
        date
    ];
    return undefined;
};
const $1dbd111751ef340b$var$listItemActive = null;
const $1dbd111751ef340b$var$listItemSelected = null;
const $1dbd111751ef340b$var$listItemFocusStyles = null;
const $1dbd111751ef340b$export$42975d65146c61a1 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ item: item, selected: selected, id: id, role: role, onSelect: onSelect, tabIndex: tabIndex, onKeyDown: onKeyDown, onFocus: onFocus, nameMaxLines: nameMaxLines = 1 }, ref)=>{
    const intl = (0, $koVbs.default)();
    const handleSelect = ()=>onSelect(item.objectId);
    const subtitleItems = item.subtitleItems || $1dbd111751ef340b$var$getDefaultSubtitleItems(item, intl);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        role: role,
        id: id,
        "aria-selected": selected,
        "data-testid": $1dbd111751ef340b$export$800daf5fbbe96aff.searchResultItem,
        onKeyDown: onKeyDown,
        onClick: handleSelect,
        onFocus: onFocus,
        tabIndex: tabIndex,
        ref: ref,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _ca0qu2gc _n3tdu2gc _19bvsy6a _u5f3fxbg _80omtlke",
            !selected && "_irr31dko _1dbz1l95",
            selected && "_bfhk29zg _16qs1l95",
            "_nt751r31 _49pcglyw _1hvw1o36 _1a3b18uv _4fprglyw _5goinqa1 _7ehi1tx3"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)($1dbd111751ef340b$var$ListItemIcon, {
                item: item,
                intl: intl
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                className: (0, $bwpsq.default)([
                    "_1reo15vq _18m915vq _ae4v1h6o _1bsb1osq"
                ]),
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                        maxLines: nameMaxLines,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                            "data-testid": `${$1dbd111751ef340b$export$800daf5fbbe96aff.searchResultItem}-title`,
                            title: item.name,
                            children: item.name
                        })
                    }),
                    subtitleItems && /*#__PURE__*/ (0, $2OMIu.jsx)($1dbd111751ef340b$var$ListItemSubtitle, {
                        items: subtitleItems
                    })
                ]
            })
        ]
    });
});

});
parcelRegister("hA5US", function(module, exports) {

$parcel$export(module.exports, "transformTimeStamp", () => $7179f84afea0863e$export$439b9bb86eb9f500);

var $iMVUf = parcelRequire("iMVUf");

var $eseJG = parcelRequire("eseJG");

var $iI6oL = parcelRequire("iI6oL");

var $4iG8d = parcelRequire("4iG8d");
const $7179f84afea0863e$var$formatTime = (timeStamp, intl)=>{
    const isAbsolute = (0, $eseJG.isMoreThanOneWeekAgo)(timeStamp);
    if (isAbsolute) return intl.formatDate(timeStamp, {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
    });
    const { value: value, unit: unit } = (0, $iI6oL.selectUnit)(timeStamp, new Date(), {
        day: 7
    });
    //formats as 'yesterday' instead of '1 day ago'
    if ((0, $iMVUf.default)(timeStamp)) return intl.formatRelativeTime(value, unit, {
        numeric: 'auto'
    });
    return intl.formatRelativeTime(value, unit);
};
const $7179f84afea0863e$var$renderAbsoluteOrRelativeDate = (timeStamp, pageAction, intl)=>{
    return intl.formatMessage((0, $4iG8d.timeMessages)[pageAction], {
        time: $7179f84afea0863e$var$formatTime(timeStamp, intl)
    });
};
const $7179f84afea0863e$export$439b9bb86eb9f500 = (intl, lastViewedDate, lastUpdatedDate)=>{
    if (lastViewedDate) return $7179f84afea0863e$var$renderAbsoluteOrRelativeDate(lastViewedDate, 'viewed', intl);
    if (lastUpdatedDate) return $7179f84afea0863e$var$renderAbsoluteOrRelativeDate(lastUpdatedDate, 'updated', intl);
};

});
parcelRegister("eseJG", function(module, exports) {

$parcel$export(module.exports, "isMoreThanOneWeekAgo", () => $284f97eca47edda0$export$e873c799b137eec4);

var $kUxFz = parcelRequire("kUxFz");

var $it1wb = parcelRequire("it1wb");

var $4PxOH = parcelRequire("4PxOH");
function $284f97eca47edda0$export$e873c799b137eec4(date) {
    return (0, $kUxFz.default)(new Date(date), $284f97eca47edda0$var$startOfOneWeekAgo());
}
function $284f97eca47edda0$var$startOfOneWeekAgo() {
    return (0, $it1wb.default)((0, $4PxOH.default)(new Date(), 1));
}

});

parcelRegister("iI6oL", function(module, exports) {

$parcel$export(module.exports, "selectUnit", () => $9d65e33023fcb591$export$b8f7189986dd5395);
//copied from packages/activity-platform/recent-work-ui/src/common/ui/activity-event-type-message/utils.ts
const $9d65e33023fcb591$var$MS_PER_SECOND = 1e3;
const $9d65e33023fcb591$var$SECS_PER_MIN = 60;
const $9d65e33023fcb591$var$SECS_PER_HOUR = $9d65e33023fcb591$var$SECS_PER_MIN * 60;
const $9d65e33023fcb591$var$SECS_PER_DAY = $9d65e33023fcb591$var$SECS_PER_HOUR * 24;
const $9d65e33023fcb591$var$SECS_PER_WEEK = $9d65e33023fcb591$var$SECS_PER_DAY * 7;
function $9d65e33023fcb591$export$b8f7189986dd5395(from, to = Date.now(), thresholds = {}) {
    const resolvedThresholds = {
        ...$9d65e33023fcb591$export$f4fd60e41371f80d,
        ...thresholds || {}
    };
    const secs = (+from - +to) / $9d65e33023fcb591$var$MS_PER_SECOND;
    if (Math.abs(secs) < resolvedThresholds.second) return {
        value: Math.round(secs),
        unit: 'second'
    };
    const mins = secs / $9d65e33023fcb591$var$SECS_PER_MIN;
    if (Math.abs(mins) < resolvedThresholds.minute) return {
        value: Math.round(mins),
        unit: 'minute'
    };
    const hours = secs / $9d65e33023fcb591$var$SECS_PER_HOUR;
    if (Math.abs(hours) < resolvedThresholds.hour) return {
        value: Math.round(hours),
        unit: 'hour'
    };
    const days = secs / $9d65e33023fcb591$var$SECS_PER_DAY;
    if (Math.abs(days) < resolvedThresholds.day) return {
        value: Math.round(days),
        unit: 'day'
    };
    const weeks = secs / $9d65e33023fcb591$var$SECS_PER_WEEK;
    return {
        value: Math.round(weeks),
        unit: 'week'
    };
}
const $9d65e33023fcb591$export$f4fd60e41371f80d = {
    second: 45,
    minute: 45,
    hour: 22,
    day: 5
};

});



parcelRegister("1QsQg", function(module, exports) {

$parcel$export(module.exports, "useTrackResultsShown", () => $03b90aa34c57743a$export$529828fad68c73fb);

var $5uXOq = parcelRequire("5uXOq");

var $ixeyz = parcelRequire("ixeyz");

var $2NMNM = parcelRequire("2NMNM");


var $eTwyk = parcelRequire("eTwyk");
const $03b90aa34c57743a$var$DEBOUNCE_MS = 400;
const $03b90aa34c57743a$export$529828fad68c73fb = (isLoading, items, hasSearchTerm)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const hasSearchTermRef = (0, $5uXOq.useRef)(hasSearchTerm);
    // Using ref so that not required in the dependency array
    // Analytics should be entirely dependent on change of items being viewed
    (0, $5uXOq.useEffect)(()=>{
        hasSearchTermRef.current = hasSearchTerm;
    }, [
        hasSearchTerm
    ]);
    // Filters isLoading/items to only return the array of items if no longer loading more items
    // Loading state IS a factor here because some tabs will
    // load intermediate results whilst loading additional results (Atlassian tab)
    // Considered to only have "shown" results once we are in a final state (no longer loading)
    const finalItems = (0, $5uXOq.useMemo)(()=>!isLoading ? items : null, [
        isLoading,
        items
    ]);
    // Because Atlassian tab resolves intermediate results on every keystroke (may never be loading)
    // Debounce the items so that we only consider the results to have been shown
    // after they have been stable for DEBOUNCE_MS
    const [debouncedItems] = (0, $ixeyz.default)(finalItems, $03b90aa34c57743a$var$DEBOUNCE_MS);
    (0, $5uXOq.useEffect)(()=>{
        if (debouncedItems) {
            const event = !hasSearchTermRef.current ? 'ui.searchResults.shown.preQuerySearchResults' : 'ui.searchResults.shown.postQuerySearchResults';
            createAnalyticsEvent((0, $eTwyk.default)(event, {
                resultCount: debouncedItems.length
            })).fire((0, $27f53d4100568677$export$85183a312807388d));
        }
    }, [
        debouncedItems,
        createAnalyticsEvent
    ]);
};

});
parcelRegister("ixeyz", function(module, exports) {

$parcel$export(module.exports, "default", () => $037b761777bba5d1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $laWvb = parcelRequire("laWvb");
function $037b761777bba5d1$var$valueEquality(left, right) {
    return left === right;
}
function $037b761777bba5d1$export$2e2bcd8739ae039(value, delay, options) {
    var eq = options && options.equalityFn ? options.equalityFn : $037b761777bba5d1$var$valueEquality;
    var _a = (0, $5uXOq.useState)(value), state = _a[0], dispatch = _a[1];
    var _b = (0, $laWvb.default)((0, $5uXOq.useCallback)(function(value) {
        return dispatch(value);
    }, []), delay, options), callback = _b[0], cancel = _b[1], callPending = _b[2];
    var previousValue = (0, $5uXOq.useRef)(value);
    (0, $5uXOq.useEffect)(function() {
        // We need to use this condition otherwise we will run debounce timer for the first render (including maxWait option)
        if (!eq(previousValue.current, value)) {
            callback(value);
            previousValue.current = value;
        }
    }, [
        value,
        callback,
        eq
    ]);
    return [
        state,
        cancel,
        callPending
    ];
}

});
parcelRegister("laWvb", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6a7e96a5e9b4bd2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $f6a7e96a5e9b4bd2$export$2e2bcd8739ae039(callback, delay, options) {
    if (options === void 0) options = {};
    var maxWait = options.maxWait;
    var maxWaitHandler = (0, $5uXOq.useRef)(null);
    var maxWaitArgs = (0, $5uXOq.useRef)([]);
    var leading = options.leading;
    var trailing = options.trailing === undefined ? true : options.trailing;
    var leadingCall = (0, $5uXOq.useRef)(false);
    var functionTimeoutHandler = (0, $5uXOq.useRef)(null);
    var isComponentUnmounted = (0, $5uXOq.useRef)(false);
    var debouncedFunction = (0, $5uXOq.useRef)(callback);
    debouncedFunction.current = callback;
    var cancelDebouncedCallback = (0, $5uXOq.useCallback)(function() {
        clearTimeout(functionTimeoutHandler.current);
        clearTimeout(maxWaitHandler.current);
        maxWaitHandler.current = null;
        maxWaitArgs.current = [];
        functionTimeoutHandler.current = null;
        leadingCall.current = false;
    }, []);
    (0, $5uXOq.useEffect)(function() {
        return function() {
            // we use flag, as we allow to call callPending outside the hook
            isComponentUnmounted.current = true;
        };
    }, []);
    var debouncedCallback = (0, $5uXOq.useCallback)(function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        maxWaitArgs.current = args;
        clearTimeout(functionTimeoutHandler.current);
        if (leadingCall.current) leadingCall.current = false;
        if (!functionTimeoutHandler.current && leading && !leadingCall.current) {
            debouncedFunction.current.apply(debouncedFunction, args);
            leadingCall.current = true;
        }
        functionTimeoutHandler.current = setTimeout(function() {
            var shouldCallFunction = true;
            if (leading && leadingCall.current) shouldCallFunction = false;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current && trailing && shouldCallFunction) debouncedFunction.current.apply(debouncedFunction, args);
        }, delay);
        if (maxWait && !maxWaitHandler.current && trailing) maxWaitHandler.current = setTimeout(function() {
            var args = maxWaitArgs.current;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current) debouncedFunction.current.apply(null, args);
        }, maxWait);
    }, [
        maxWait,
        delay,
        cancelDebouncedCallback,
        leading,
        trailing
    ]);
    var callPending = (0, $5uXOq.useCallback)(function() {
        // Call pending callback only if we have anything in our queue
        if (!functionTimeoutHandler.current) return;
        debouncedFunction.current.apply(null, maxWaitArgs.current);
        cancelDebouncedCallback();
    }, [
        cancelDebouncedCallback
    ]);
    // At the moment, we use 3 args array so that we save backward compatibility
    return [
        debouncedCallback,
        cancelDebouncedCallback,
        callPending
    ];
}

});




parcelRegister("9YuVg", function(module, exports) {

$parcel$export(module.exports, "ScrollingTabList", () => $1432a42a6cdbdc05$export$3f4889bfcd7e2a0f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $3Qiip = parcelRequire("3Qiip");

var $hWZau = parcelRequire("hWZau");

var $jtuto = parcelRequire("jtuto");
function $1432a42a6cdbdc05$var$isTouchDevice() {
    return 'ontouchstart' in window || // eslint-disable-next-line compat/compat
    navigator.maxTouchPoints > 0;
}
const $1432a42a6cdbdc05$var$initialConditionalButtonsState = {
    back: false,
    forward: false
};
const $1432a42a6cdbdc05$var$scrollingContainerStyles = null;
const $1432a42a6cdbdc05$var$containerStyles = null;
const $1432a42a6cdbdc05$var$backButtonStyles = null;
const $1432a42a6cdbdc05$var$nextButtonStyles = null;
const $1432a42a6cdbdc05$export$3f4889bfcd7e2a0f = (props)=>{
    const ref = (0, $5uXOq.useRef)(null);
    const [conditionalButtons, setConditionalButtons] = (0, $5uXOq.useState)($1432a42a6cdbdc05$var$initialConditionalButtonsState);
    const ghost = (0, $5uXOq.useMemo)(()=>(0, $jtuto.createGhost)(), []);
    const onTabClick = (0, $5uXOq.useCallback)((e)=>{
        const target = e.currentTarget;
        if (target) target.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center'
        });
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useLayoutEffect(()=>{
        const container = ref.current;
        let scrollingContainer;
        let tabs;
        const handleConditionalButtonsChange = ()=>{
            const buttons = (0, $jtuto.calculateConditionalButtons)(scrollingContainer, $1432a42a6cdbdc05$var$isTouchDevice());
            setConditionalButtons(buttons);
        };
        const observerCallback = (mutationList)=>{
            const tablist = (0, $jtuto.getTabList)(ref);
            for (const mutation of mutationList)if (mutation.type === 'childList') {
                const addedNodes = Array.from(mutation.addedNodes);
                const found = addedNodes.find((node)=>node.getAttribute('role') === 'tab');
                if (found && tablist) {
                    ghost.remove();
                    const tabs = Array.from(tablist.children);
                    tabs.forEach((tab)=>{
                        tab.removeEventListener('click', onTabClick);
                        tab.addEventListener('click', onTabClick);
                    });
                    tablist.appendChild(ghost);
                    handleConditionalButtonsChange();
                }
            }
        };
        const observer = new MutationObserver(observerCallback);
        if (container) {
            const tablist = (0, $jtuto.getTabList)(ref);
            scrollingContainer = tablist?.parentElement;
            observer.observe(container, {
                attributes: false,
                childList: true,
                subtree: true
            });
            if (scrollingContainer instanceof HTMLElement && tablist) {
                tablist.appendChild(ghost);
                tabs = Array.from(tablist.children);
                tabs.forEach((tab)=>tab.addEventListener('click', onTabClick));
                handleConditionalButtonsChange();
                scrollingContainer.addEventListener('scroll', handleConditionalButtonsChange);
            }
            return ()=>{
                if (scrollingContainer) // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                scrollingContainer.removeEventListener('scroll', handleConditionalButtonsChange);
                if (tabs.length) tabs.forEach((tab)=>tab.removeEventListener('click', onTabClick));
            };
        }
    }, [
        onTabClick,
        ghost,
        ref
    ]);
    const buttonProps = {
        appearance: 'subtle',
        spacing: 'compact'
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        ref: ref,
        "data-testid": "scrolling-tabs",
        className: (0, $bwpsq.default)([
            "_kqswh2mm _18q9glyw _7hip261p _1fud261p _1dze261p"
        ]),
        children: [
            conditionalButtons.back && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    "_kqswstnw _154i1b66 _1pby18h8 _bfhkvuon _1ltvidpf",
                    "back"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                    "data-test-id": "back",
                    onClick: ()=>(0, $jtuto.scrollBack)(ref),
                    label: "back",
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($3Qiip))),
                    ...buttonProps
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    "_1bh4vqrj _1reo1wug _1dm8q5uf _1fjgglyw _rfx3yh40 _pascidpf _eid3idpf _zr3eidpf _fntnidpf _1kt9b3bt _19woidpf _1cs8stnw _1mp41kw7 _qnecu2gc _oounu2gc _kfgtyh40 _1rushloo _1cicglyw"
                ]),
                children: props.children
            }),
            conditionalButtons.forward && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    "_kqswstnw _154i1b66 _1pby18h8 _bfhkvuon _1xi2idpf"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                    "data-test-id": "forward",
                    onClick: ()=>(0, $jtuto.scrollForward)(ref),
                    ...buttonProps,
                    label: "forward",
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($hWZau)))
                })
            })
        ]
    });
};

});
parcelRegister("3Qiip", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::50eb0536eed3191cdc1ef30e9478909d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2cc46ba193f64324$var$_react = $2cc46ba193f64324$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2cc46ba193f64324$var$_chevronLeft = $2cc46ba193f64324$var$_interopRequireDefault((parcelRequire("lRheX")));

var $2cc46ba193f64324$var$_chevronLeft2 = $2cc46ba193f64324$var$_interopRequireDefault((parcelRequire("nHhrH")));
function $2cc46ba193f64324$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2cc46ba193f64324$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $2cc46ba193f64324$var$_react.default.createElement($2cc46ba193f64324$var$_chevronLeft.default, Object.assign({
        LEGACY_fallbackIcon: $2cc46ba193f64324$var$_chevronLeft2.default
    }, props));
$2cc46ba193f64324$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
var $2cc46ba193f64324$var$_default = module.exports.default = $2cc46ba193f64324$var$ChevronLeftIcon;

});
parcelRegister("lRheX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::29f3eb59553566fe46c3ae42f5cce545>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fe9bebc953515e63$var$_react = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $fe9bebc953515e63$var$_baseNew = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $fe9bebc953515e63$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fe9bebc953515e63$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $fe9bebc953515e63$var$_react.default.createElement($fe9bebc953515e63$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.06 6 3.97-3.97L6.97.97l-4.5 4.5a.75.75 0 0 0 0 1.06l4.5 4.5 1.06-1.06z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$fe9bebc953515e63$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $fe9bebc953515e63$var$_default = module.exports.default = $fe9bebc953515e63$var$ChevronLeftIcon;

});

parcelRegister("nHhrH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0473b8ae11c957a6$var$_react = $0473b8ae11c957a6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $0473b8ae11c957a6$var$_chevronLeft = $0473b8ae11c957a6$var$_interopRequireDefault((parcelRequire("ks8FD")));
function $0473b8ae11c957a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0473b8ae11c957a6$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $0473b8ae11c957a6$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13.706 9.698a.99.99 0 0 0 0-1.407 1.01 1.01 0 0 0-1.419 0l-2.965 2.94a1.09 1.09 0 0 0 0 1.548l2.955 2.93a1.01 1.01 0 0 0 1.42 0 .99.99 0 0 0 0-1.407l-2.318-2.297z"/></svg>`
    }, props, {
        newIcon: $0473b8ae11c957a6$var$_chevronLeft.default
    }));
$0473b8ae11c957a6$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $0473b8ae11c957a6$var$_default = module.exports.default = $0473b8ae11c957a6$var$ChevronLeftIcon;

});
parcelRegister("ks8FD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b851fec559156e1edca3c5f214f4a7f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ee3d25fb52825f26$var$_react = $ee3d25fb52825f26$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ee3d25fb52825f26$var$_baseNew = $ee3d25fb52825f26$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $ee3d25fb52825f26$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ee3d25fb52825f26$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $ee3d25fb52825f26$var$_react.default.createElement($ee3d25fb52825f26$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m9.97 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L5.56 8l5.47-5.47z"/>`
    }, props));
$ee3d25fb52825f26$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $ee3d25fb52825f26$var$_default = module.exports.default = $ee3d25fb52825f26$var$ChevronLeftIcon;

});



parcelRegister("jtuto", function(module, exports) {

$parcel$export(module.exports, "scrollBack", () => $6886b923b19d835a$export$78dcacdb9059402);
$parcel$export(module.exports, "scrollForward", () => $6886b923b19d835a$export$aa243477c3593c09);
$parcel$export(module.exports, "calculateConditionalButtons", () => $6886b923b19d835a$export$ea1b0fdd88adfa3b);
$parcel$export(module.exports, "createGhost", () => $6886b923b19d835a$export$570f57abe0c473cb);
$parcel$export(module.exports, "getTabList", () => $6886b923b19d835a$export$83daafa4ec439dec);
const $6886b923b19d835a$var$BUTTON_SIZE = 24;
const $6886b923b19d835a$var$GUTTER = 48;
const $6886b923b19d835a$var$GHOST_WIDTH = 342 - $6886b923b19d835a$var$GUTTER - 40;
const $6886b923b19d835a$export$78dcacdb9059402 = (ref)=>{
    $6886b923b19d835a$var$moveTabsScroll(ref, $6886b923b19d835a$var$findPrevious);
};
const $6886b923b19d835a$export$aa243477c3593c09 = (ref)=>{
    $6886b923b19d835a$var$moveTabsScroll(ref, $6886b923b19d835a$var$findNext);
};
const $6886b923b19d835a$export$ea1b0fdd88adfa3b = (container, hideButtons)=>{
    const initialState = {
        back: false,
        forward: false
    };
    if (!container || hideButtons) return initialState;
    const maxScrollValue = container.scrollWidth - container.clientWidth;
    return {
        back: container.scrollLeft > 0,
        forward: container.scrollLeft < maxScrollValue - $6886b923b19d835a$var$GHOST_WIDTH
    };
};
const $6886b923b19d835a$export$570f57abe0c473cb = ()=>{
    const ghost = document.createElement('div');
    ghost.setAttribute('id', 'scrolling-tabs-ghost');
    ghost.style.minWidth = `${$6886b923b19d835a$var$GHOST_WIDTH}px`;
    ghost.style.pointerEvents = 'none';
    return ghost;
};
const $6886b923b19d835a$var$moveTabsScroll = (ref, findFn)=>{
    const container = $6886b923b19d835a$export$49f5bf502122d4f7(ref);
    if (container) {
        const tablist = container.children[0];
        const tabs = Array.from(tablist.children);
        if (tabs.length > 0) {
            const target = findFn(container, tabs);
            if (target) {
                const left = container.scrollLeft + target.getBoundingClientRect().left - container.getBoundingClientRect().left - $6886b923b19d835a$var$BUTTON_SIZE;
                $6886b923b19d835a$var$scrollTo(container, left);
            }
        }
    }
};
const $6886b923b19d835a$var$scrollTo = (container, left)=>{
    container.scrollTo({
        left: left
    });
};
const $6886b923b19d835a$export$83daafa4ec439dec = (ref)=>ref.current?.querySelector('[role="tablist"]');
const $6886b923b19d835a$export$49f5bf502122d4f7 = (ref)=>$6886b923b19d835a$export$83daafa4ec439dec(ref)?.parentElement;
const $6886b923b19d835a$var$findPrevious = (container, tabs)=>{
    const previousTabs = tabs.filter((tab)=>{
        const [containerRect, tabRect] = [
            container.getBoundingClientRect(),
            tab.getBoundingClientRect()
        ];
        const [containerArea, tabArea] = [
            containerRect.left + container.scrollLeft - $6886b923b19d835a$var$GUTTER,
            container.scrollLeft + tabRect.left + tabRect.width
        ];
        return containerArea > tabArea;
    });
    if (previousTabs.length < 3) return previousTabs[0];
    return previousTabs[previousTabs.length - 1];
};
const $6886b923b19d835a$var$findNext = (container, tabs)=>{
    const containerRect = container.getBoundingClientRect();
    return tabs.find((tab)=>{
        const tabRect = tab.getBoundingClientRect();
        const [containerArea, tabArea] = [
            container.clientWidth + containerRect.left - $6886b923b19d835a$var$GUTTER,
            tabRect.left + tabRect.width
        ];
        return containerArea < tabArea;
    });
};

});


parcelRegister("lRkud", function(module, exports) {

$parcel$export(module.exports, "SearchResultsContainer", () => $e1fef58661b5c38e$export$e04042801ea527f0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $7OUbW = parcelRequire("7OUbW");
const $e1fef58661b5c38e$var$flexColumn = null;
const $e1fef58661b5c38e$export$e04042801ea527f0 = ({ hasTabs: hasTabs, adaptiveHeight: adaptiveHeight, isLoadingResults: isLoadingResults, children: children })=>{
    const ref = (0, $5uXOq.useRef)(null);
    const currentHeight = (0, $5uXOq.useRef)(null);
    const fixedMinHeight = (0, $VSDnB.fg)('platform-linking-visual-refresh-link-picker') ? hasTabs ? '296px' : '251px' : hasTabs ? '347px' : '302px';
    const adaptiveMinHeight = isLoadingResults && !!currentHeight.current ? `${currentHeight.current}px` : 'auto';
    const minheight = adaptiveHeight ? adaptiveMinHeight : fixedMinHeight;
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (ref.current && adaptiveHeight && !isLoadingResults) currentHeight.current = ref.current.getBoundingClientRect().height;
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7OUbW.MinHeightContainer), {
        ref: ref,
        minHeight: minheight,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _1bah1y6m _1bsb1osq"
        ]),
        children: children
    });
};

});

parcelRegister("cth18", function(module, exports) {

$parcel$export(module.exports, "TrackTabViewed", () => $db16e2f8780c4c4a$export$e6d7e677c5e4edcf);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");


var $eTwyk = parcelRequire("eTwyk");
function $db16e2f8780c4c4a$export$e6d7e677c5e4edcf({ activePlugin: activePlugin }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (activePlugin) createAnalyticsEvent((0, $eTwyk.default)('ui.tab.viewed', {})).fire((0, $27f53d4100568677$export$85183a312807388d));
    }, [
        activePlugin,
        createAnalyticsEvent
    ]);
    return null;
}

});


parcelRegister("9Oh9U", function(module, exports) {

$parcel$export(module.exports, "testIds", () => $50845db83647846e$export$800daf5fbbe96aff);
$parcel$export(module.exports, "TextInput", () => $50845db83647846e$export$c86715117507e8e5);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $3Du7S = parcelRequire("3Du7S");

var $qfj8c = parcelRequire("qfj8c");
var $7O4UO = parcelRequire("7O4UO");

var $ip0rq = parcelRequire("ip0rq");

var $VSDnB = parcelRequire("VSDnB");

var $3Lty3 = parcelRequire("3Lty3");

var $kY99m = parcelRequire("kY99m");

var $3bDjY = parcelRequire("3bDjY");

var $dorxj = parcelRequire("dorxj");

var $bC8Fl = parcelRequire("bC8Fl");
const $50845db83647846e$var$styles = {
    clearTextButton: "_19itglyw _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _2hwx1b66 _bfhk1w7a _s7n4nkob"
};
/**
 * Overriding text input margin top which design system provides as a default spacer
 * but it gets in the way of our layout
 */ const $50845db83647846e$var$baseFieldStyles = null;
const $50845db83647846e$var$newFieldStyles = null;
const $50845db83647846e$export$800daf5fbbe96aff = {
    urlError: 'link-error',
    clearUrlButton: 'clear-text'
};
const $50845db83647846e$export$c86715117507e8e5 = ({ name: name, label: label, autoFocus: autoFocus, onRedo: onRedo, onUndo: onUndo, onKeyDown: onKeyDown, onClear: onClear, clearLabel: clearLabel, error: error, spotlightTargetName: spotlightTargetName, inputRef: inputRefProp, ...restProps })=>{
    const inputRef = (0, $5uXOq.useRef)(null);
    const handleRef = (0, $5uXOq.useCallback)((input)=>{
        if (input) {
            inputRef.current = input;
            if (autoFocus) // Need this to prevent jumping when we render TextInput inside Portal @see ED-2992
            input.focus({
                preventScroll: true
            });
        }
    }, [
        autoFocus
    ]);
    let textfieldRef;
    if ((0, $VSDnB.fg)('jsc_inline_editing_field_refactor')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const refs = (0, $5uXOq.useMemo)(()=>[
                handleRef,
                inputRefProp
            ].filter(Boolean), [
            handleRef,
            inputRefProp
        ]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        textfieldRef = (0, $3Du7S.useMergeRefs)(refs);
    } else textfieldRef = handleRef;
    const handleKeydown = (0, $5uXOq.useCallback)((e)=>{
        if (typeof onUndo === 'function' && (0, $bC8Fl.isUndoEvent)(e)) {
            e.preventDefault();
            onUndo();
        } else if (typeof onRedo === 'function' && (0, $bC8Fl.isRedoEvent)(e)) {
            e.preventDefault();
            onRedo();
        }
        if (onKeyDown) onKeyDown(e);
    }, [
        onUndo,
        onRedo,
        onKeyDown
    ]);
    const handleClear = (0, $5uXOq.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        onClear?.(name);
        inputRef.current?.focus();
    }, [
        name,
        onClear
    ]);
    const clearText = restProps.value !== '' && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: clearLabel,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
            xcss: $50845db83647846e$var$styles.clearTextButton,
            onClick: handleClear,
            testId: $50845db83647846e$export$800daf5fbbe96aff.clearUrlButton,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ip0rq))), {
                LEGACY_size: "medium",
                label: clearLabel || '',
                color: "var(--ds-icon-subtle, #626F86)",
                spacing: "spacious"
            })
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_7yjtidpf _onzypxbi",
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && "_11c81vhk"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7O4UO.default), {
            label: label,
            name: name,
            children: ({ fieldProps: fieldProps })=>{
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dorxj.ConditionalSpotlightTargetWrapper), {
                    spotlightTargetName: spotlightTargetName,
                    children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kY99m.default), {
                                ...fieldProps,
                                ...restProps,
                                onKeyDown: handleKeydown,
                                ref: textfieldRef,
                                elemAfterInput: clearText,
                                isInvalid: !!error
                            }),
                            error && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $qfj8c.ErrorMessage), {
                                testId: $50845db83647846e$export$800daf5fbbe96aff.urlError,
                                children: error
                            })
                        ]
                    })
                });
            }
        })
    });
};

});
parcelRegister("7O4UO", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e20204ce79b642c$export$2e2bcd8739ae039);
/* field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("3joPi");

var $9KnKW = parcelRequire("9KnKW");

var $dRN65 = parcelRequire("dRN65");

var $efXp3 = parcelRequire("efXp3");

var $2x3Cb = parcelRequire("2x3Cb");

var $kxqHl = parcelRequire("kxqHl");

var $6cAn5 = parcelRequire("6cAn5");
const $7e20204ce79b642c$var$fieldWrapperStyles = null;
function $7e20204ce79b642c$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $7e20204ce79b642c$var$isFunction(x) {
    return typeof x === 'function';
}
function $7e20204ce79b642c$var$usePreviousRef(current) {
    const ref = (0, $5uXOq.useRef)(current);
    // will be updated on the next render
    (0, $5uXOq.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $7e20204ce79b642c$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $7e20204ce79b642c$export$2e2bcd8739ae039(props) {
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $5uXOq.useContext)((0, $efXp3.FormContext));
    const isDisabled = (0, $5uXOq.useContext)((0, $efXp3.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $7e20204ce79b642c$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $7e20204ce79b642c$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$7e20204ce79b642c$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $5uXOq.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explicitly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $7e20204ce79b642c$var$usePreviousRef(state);
    (0, $5uXOq.useEffect)(()=>{
        typeof $6cAn5;
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $7e20204ce79b642c$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($7e20204ce79b642c$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    const uid = (0, $9KnKW.useId)();
    const fieldId = (0, $5uXOq.useMemo)(()=>{
        return props.id ? props.id : `${props.name}-${uid}`;
    }, [
        props.id,
        props.name,
        uid
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-testid": props.testId,
        className: (0, $bwpsq.default)([
            "_1pfhu2gc"
        ]),
        children: [
            props.label && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2x3Cb.Label), {
                htmlFor: fieldId,
                id: `${fieldId}-label`,
                testId: props.testId && `${props.testId}--label`,
                children: [
                    props.label,
                    props.isRequired && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kxqHl.default), {}),
                    props.elementAfterLabel
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dRN65.FieldId).Provider, {
                value: fieldId,
                children: props.children({
                    fieldProps: extendedFieldProps,
                    error: state.error,
                    valid: state.valid,
                    meta: state.meta
                })
            })
        ]
    });
}

});
parcelRegister("efXp3", function(module, exports) {

$parcel$export(module.exports, "FormContext", () => $987e2ff089e89967$export$c24727297075ec6a);
$parcel$export(module.exports, "IsDisabledContext", () => $987e2ff089e89967$export$c17cf6b332a82dbc);
$parcel$export(module.exports, "default", () => $987e2ff089e89967$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $lqWDn = parcelRequire("lqWDn");

var $8tHJX = parcelRequire("8tHJX");

var $gZL7V = parcelRequire("gZL7V");
const $987e2ff089e89967$export$c24727297075ec6a = /*#__PURE__*/ (0, $5uXOq.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});
const $987e2ff089e89967$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
function $987e2ff089e89967$export$2e2bcd8739ae039(props) {
    const formRef = (0, $5uXOq.useRef)(null);
    const onSubmitRef = (0, $5uXOq.useRef)(props.onSubmit);
    onSubmitRef.current = props.onSubmit;
    const [form] = (0, $5uXOq.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $lqWDn.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        (0, (/*@__PURE__*/$parcel$interopDefault($gZL7V)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($gZL7V)))(values, name, value);
                    }
                }
            }
        });
        (0, $8tHJX.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $5uXOq.useState)({
        dirty: false,
        submitting: false
    });
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $5uXOq.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
	 * This method is needed in FormContext to use it on the field level
	 * to check the current value of the field in case of the component re-mounting.
	 */ const getCurrentValue = (0, $5uXOq.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $5uXOq.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    const childrenContent = (()=>{
        if (typeof children === 'function') {
            const result = children.length > 0 ? children({
                formProps: {
                    onSubmit: handleSubmit,
                    ref: formRef,
                    onKeyDown: handleKeyDown
                },
                dirty: dirty,
                reset: handleReset,
                submitting: submitting,
                disabled: isDisabled,
                getState: ()=>form.getState(),
                getValues: ()=>form.getState().values,
                setFieldValue: form.change
            }) : children();
            return result === undefined ? null : result;
        }
        return children;
    })();
    return /*#__PURE__*/ (0, $2OMIu.jsx)($987e2ff089e89967$export$c24727297075ec6a.Provider, {
        value: FormContextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($987e2ff089e89967$export$c17cf6b332a82dbc.Provider, {
            value: isDisabled,
            children: childrenContent
        })
    });
}

});
parcelRegister("lqWDn", function(module, exports) {

$parcel$export(module.exports, "getIn", () => $f9a9822f8af64e2a$export$c52e5867d5879e24);
$parcel$export(module.exports, "FORM_ERROR", () => $f9a9822f8af64e2a$export$97cd7fc25dd32915);
$parcel$export(module.exports, "ARRAY_ERROR", () => $f9a9822f8af64e2a$export$735bebc8ffabf28a);
$parcel$export(module.exports, "fieldSubscriptionItems", () => $f9a9822f8af64e2a$export$41e855cb628c1b55);
$parcel$export(module.exports, "formSubscriptionItems", () => $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3);
$parcel$export(module.exports, "version", () => $f9a9822f8af64e2a$export$83d89fbfd8236492);
$parcel$export(module.exports, "createForm", () => $f9a9822f8af64e2a$export$f681a8129d2e9d28);

var $bS32t = parcelRequire("bS32t");

var $ddEsc = parcelRequire("ddEsc");
//      
var $f9a9822f8af64e2a$var$charCodeOfDot = ".".charCodeAt(0);
var $f9a9822f8af64e2a$var$reEscapeChar = /\\(\\)?/g;
var $f9a9822f8af64e2a$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f9a9822f8af64e2a$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $f9a9822f8af64e2a$var$charCodeOfDot) result.push("");
    string.replace($f9a9822f8af64e2a$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($f9a9822f8af64e2a$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $f9a9822f8af64e2a$var$keysCache = {};
var $f9a9822f8af64e2a$var$keysRegex = /[.[\]]+/;
var $f9a9822f8af64e2a$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($f9a9822f8af64e2a$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $f9a9822f8af64e2a$var$keysCache[key] = key.split($f9a9822f8af64e2a$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $f9a9822f8af64e2a$var$keysCache[key] = $f9a9822f8af64e2a$var$stringToPath(key);
    }
    return $f9a9822f8af64e2a$var$keysCache[key];
};
//      
var $f9a9822f8af64e2a$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $f9a9822f8af64e2a$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $f9a9822f8af64e2a$var$_toPropertyKey(arg) {
    var key = $f9a9822f8af64e2a$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $f9a9822f8af64e2a$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $f9a9822f8af64e2a$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $ddEsc.default)(current, [
                key
            ].map($f9a9822f8af64e2a$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $bS32t.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $f9a9822f8af64e2a$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $f9a9822f8af64e2a$var$setInRecursor(state, 0, $f9a9822f8af64e2a$var$toPath(key), value1, destroyArrays);
};
var $f9a9822f8af64e2a$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $f9a9822f8af64e2a$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $f9a9822f8af64e2a$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(values, name);
    var error = $f9a9822f8af64e2a$export$c52e5867d5879e24(errors, name);
    if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) error = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
    var submitError = submitErrors && $f9a9822f8af64e2a$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $f9a9822f8af64e2a$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $f9a9822f8af64e2a$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $f9a9822f8af64e2a$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $f9a9822f8af64e2a$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$f9a9822f8af64e2a$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $f9a9822f8af64e2a$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $f9a9822f8af64e2a$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$41e855cb628c1b55, $f9a9822f8af64e2a$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $f9a9822f8af64e2a$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $f9a9822f8af64e2a$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3, $f9a9822f8af64e2a$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $f9a9822f8af64e2a$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$f9a9822f8af64e2a$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $f9a9822f8af64e2a$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $f9a9822f8af64e2a$export$83d89fbfd8236492 = "4.20.10";
var $f9a9822f8af64e2a$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $f9a9822f8af64e2a$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $f9a9822f8af64e2a$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $f9a9822f8af64e2a$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $f9a9822f8af64e2a$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $f9a9822f8af64e2a$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $f9a9822f8af64e2a$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $f9a9822f8af64e2a$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $bS32t.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $bS32t.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $bS32t.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $bS32t.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $bS32t.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $f9a9822f8af64e2a$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $f9a9822f8af64e2a$export$e6bdf135a54e021b,
                    shallowEqual: $f9a9822f8af64e2a$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $bS32t.default)({}, state.formState.values)); // clone to avoid writing
            if ($f9a9822f8af64e2a$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $f9a9822f8af64e2a$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $f9a9822f8af64e2a$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $bS32t.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $f9a9822f8af64e2a$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) {
                    var existing = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$f9a9822f8af64e2a$export$735bebc8ffabf28a] = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
                    merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$f9a9822f8af64e2a$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $f9a9822f8af64e2a$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $f9a9822f8af64e2a$var$notify(fieldSubscriber, fieldState, lastFieldState, $f9a9822f8af64e2a$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $f9a9822f8af64e2a$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$f9a9822f8af64e2a$var$hasAnyError(formState.errors) && !(formState.submitErrors && $f9a9822f8af64e2a$var$hasAnyError(formState.submitErrors));
        var nextFormState = $f9a9822f8af64e2a$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $f9a9822f8af64e2a$var$notify(state.subscribers, nextFormState, lastFormState, $f9a9822f8af64e2a$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $bS32t.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $bS32t.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $f9a9822f8af64e2a$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $f9a9822f8af64e2a$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $f9a9822f8af64e2a$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $f9a9822f8af64e2a$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $f9a9822f8af64e2a$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $f9a9822f8af64e2a$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $f9a9822f8af64e2a$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("8tHJX", function(module, exports) {

$parcel$export(module.exports, "default", () => $62c2f612c5adb35a$export$2e2bcd8739ae039);

var $lqWDn = parcelRequire("lqWDn");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $62c2f612c5adb35a$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $62c2f612c5adb35a$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $62c2f612c5adb35a$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $lqWDn.getIn)(errors, input.name);
    });
};
//      
var $62c2f612c5adb35a$var$noop = function noop() {};
var $62c2f612c5adb35a$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $62c2f612c5adb35a$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $62c2f612c5adb35a$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $62c2f612c5adb35a$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $62c2f612c5adb35a$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$62c2f612c5adb35a$export$2e2bcd8739ae039 = $62c2f612c5adb35a$var$createDecorator;

});


parcelRegister("2x3Cb", function(module, exports) {

$parcel$export(module.exports, "Label", () => $987b76a5b7a0ea9b$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Legend", () => $987b76a5b7a0ea9b$export$ed247974535929c7);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $987b76a5b7a0ea9b$var$fieldsetLabelStyles = null;
const $987b76a5b7a0ea9b$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("label", {
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
const $987b76a5b7a0ea9b$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("legend", {
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
};

});

parcelRegister("kxqHl", function(module, exports) {

$parcel$export(module.exports, "default", () => $d55ac25356e81a33$export$2e2bcd8739ae039);
/* required-asterisk.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $d55ac25356e81a33$var$requiredIndicatorStyles = null;
function $d55ac25356e81a33$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "aria-hidden": "true",
        title: "required",
        className: (0, $bwpsq.default)([
            "_syaz1ick _ect41gqc _bozgv77o"
        ]),
        children: "*"
    });
}

});


parcelRegister("ip0rq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::32d605899e0518e58ac6527dead74482>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d65ae76e92cae981$var$_react = $d65ae76e92cae981$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d65ae76e92cae981$var$_crossCircle = $d65ae76e92cae981$var$_interopRequireDefault((parcelRequire("hI6SY")));

var $d65ae76e92cae981$var$_selectClear = $d65ae76e92cae981$var$_interopRequireDefault((parcelRequire("673MF")));
function $d65ae76e92cae981$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "SelectClearIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d65ae76e92cae981$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $d65ae76e92cae981$var$_react.default.createElement($d65ae76e92cae981$var$_crossCircle.default, Object.assign({
        LEGACY_fallbackIcon: $d65ae76e92cae981$var$_selectClear.default
    }, props));
$d65ae76e92cae981$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
var $d65ae76e92cae981$var$_default = module.exports.default = $d65ae76e92cae981$var$CrossCircleIcon;

});
parcelRegister("673MF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $473654f205f53fc4$var$_react = $473654f205f53fc4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $473654f205f53fc4$var$_crossCircle = $473654f205f53fc4$var$_interopRequireDefault((parcelRequire("hI6SY")));
function $473654f205f53fc4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $473654f205f53fc4$var$SelectClearIcon = (props)=>/*#__PURE__*/ $473654f205f53fc4$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
    }, props, {
        newIcon: $473654f205f53fc4$var$_crossCircle.default
    }));
$473654f205f53fc4$var$SelectClearIcon.displayName = 'SelectClearIcon';
var $473654f205f53fc4$var$_default = module.exports.default = $473654f205f53fc4$var$SelectClearIcon;

});


parcelRegister("dorxj", function(module, exports) {

$parcel$export(module.exports, "ConditionalSpotlightTargetWrapper", () => $92a0e109522107ed$export$19a90839c6257c07);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5Fk4Z = parcelRequire("5Fk4Z");
const $92a0e109522107ed$export$19a90839c6257c07 = ({ spotlightTargetName: spotlightTargetName, children: children })=>{
    return spotlightTargetName ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5Fk4Z.default), {
        name: spotlightTargetName,
        children: children
    }) : children;
};

});

parcelRegister("bC8Fl", function(module, exports) {

$parcel$export(module.exports, "isUndoEvent", () => $9eb9c166f5366616$export$d0c11e21a5e80c44);
$parcel$export(module.exports, "isRedoEvent", () => $9eb9c166f5366616$export$83612bb10212ddf3);

var $b6uPu = parcelRequire("b6uPu");
const $9eb9c166f5366616$var$KeyZCode = 90;
const $9eb9c166f5366616$var$KeyYCode = 89;
const $9eb9c166f5366616$export$d0c11e21a5e80c44 = (e)=>{
    const { mac: mac } = (0, $b6uPu.browser)();
    return e.keyCode === $9eb9c166f5366616$var$KeyZCode && // cmd + z for mac
    (mac && e.metaKey && !e.shiftKey || // ctrl + z for non-mac
    !mac && e.ctrlKey);
};
const $9eb9c166f5366616$export$83612bb10212ddf3 = (e)=>{
    const { mac: mac } = (0, $b6uPu.browser)();
    return(// ctrl + y for non-mac
    !mac && e.ctrlKey && e.keyCode === $9eb9c166f5366616$var$KeyYCode || mac && e.metaKey && e.shiftKey && e.keyCode === $9eb9c166f5366616$var$KeyZCode || e.ctrlKey && e.shiftKey && e.keyCode === $9eb9c166f5366616$var$KeyZCode);
};

});


parcelRegister("y118H", function(module, exports) {

$parcel$export(module.exports, "TrackMount", () => $1fca21382b8d7ca3$export$21b400a8c8ebc91a);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $gmGSi = parcelRequire("gmGSi");


var $eTwyk = parcelRequire("eTwyk");

var $4tvHl = parcelRequire("4tvHl");
function $1fca21382b8d7ca3$export$21b400a8c8ebc91a() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const linkPickerSessionId = (0, $4tvHl.useLinkPickerSessionId)();
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $gmGSi.succeedUfoExperience)((0, $gmGSi.ufoExperience).mounted, linkPickerSessionId);
    }, [
        linkPickerSessionId
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        // Anything in here is fired on component mount.
        createAnalyticsEvent((0, $eTwyk.default)('ui.inlineDialog.viewed.linkPicker', {})).fire((0, $27f53d4100568677$export$85183a312807388d));
        return ()=>{
            // Anything in here is fired on component unmount.
            createAnalyticsEvent((0, $eTwyk.default)('ui.inlineDialog.closed.linkPicker', {})).fire((0, $27f53d4100568677$export$85183a312807388d));
        };
    }, [
        createAnalyticsEvent
    ]);
    return null;
}

});

parcelRegister("5w02V", function(module, exports) {

$parcel$export(module.exports, "getDataSource", () => $95c691f13c7b12a4$export$de16705e2b70ea0f);
$parcel$export(module.exports, "getScreenReaderText", () => $95c691f13c7b12a4$export$3d132448e5b05f93);

var $hA5US = parcelRequire("hA5US");
const $95c691f13c7b12a4$export$de16705e2b70ea0f = (item, plugin)=>{
    return item.meta?.source ?? plugin?.meta?.source ?? 'unknown';
};
function $95c691f13c7b12a4$export$3d132448e5b05f93(items, selectedIndex, intl) {
    if (items.length && selectedIndex > -1) {
        const { name: name, container: container, lastUpdatedDate: lastUpdatedDate, lastViewedDate: lastViewedDate } = items[selectedIndex];
        const date = (0, $hA5US.transformTimeStamp)(intl, lastViewedDate, lastUpdatedDate);
        return [
            name,
            container,
            date
        ].filter(Boolean).join(', ');
    }
}

});



parcelRegister("bCh6z", function(module, exports) {

$parcel$export(module.exports, "Scope", () => $0ca4b4469a8e9ab5$export$775b6bb06e53a214);

var $9iE8c = parcelRequire("9iE8c");

var $lVlZn = parcelRequire("lVlZn");

var $k20CO = parcelRequire("k20CO");

var $d3xjQ = parcelRequire("d3xjQ");
var $0ca4b4469a8e9ab5$export$92e44ea1079b9ec6 = /*#__PURE__*/ function(Products) {
    Products["jira"] = "JIRA";
    Products["confluence"] = "CONFLUENCE";
    Products["townsquare"] = "TOWNSQUARE";
    Products["trello"] = "TRELLO";
    Products["bitbucket"] = "BITBUCKET";
    Products["other"] = "OTHER";
    return Products;
}({});
const $0ca4b4469a8e9ab5$export$775b6bb06e53a214 = {
    ...(0, $9iE8c.Scope),
    ...(0, $lVlZn.Scope),
    ...(0, $d3xjQ.TownsquareScope),
    ...(0, $k20CO.Scope)
};

});
parcelRegister("9iE8c", function(module, exports) {

$parcel$export(module.exports, "Scope", () => $745dccc780f801d1$export$775b6bb06e53a214);
/**
 * Instead of enum types for ResultType, AnalyticsType and ContentType we use a list of typed strings.
 * Typescript has issues when using types that require specific enum values (https://github.com/microsoft/TypeScript/issues/28102).
 *
 * There doesn't appear to be a working solution soon and as such we will manually type each value separately using strings.
 */ var $745dccc780f801d1$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["ConfluencePageBlogAttachment"] = "confluence.page,blogpost,attachment";
    Scope["ConfluencePageBlog"] = "confluence.page,blogpost";
    Scope["ConfluenceExperimentsPageBlogAttachment"] = "confluence_experiments.page,blogpost,attachment";
    Scope["ConfluenceSpace"] = "confluence.space";
    Scope["UserConfluence"] = "urs.user-confluence";
    Scope["ConfluencePageBlogWhiteboard"] = "confluence.page,blogpost,whiteboard";
    Scope["ConfluenceContentType"] = "confluence.page,blogpost,whiteboard,database,embed";
    return Scope;
}({});
const $745dccc780f801d1$export$b6316c73fe562220 = 'confluence.page,blogpost,attachment';
const $745dccc780f801d1$export$da1906f69c8621ca = 'confluence.page,blogpost';
const $745dccc780f801d1$export$a300dffead5808fd = 'confluence_experiments.page,blogpost,attachment';
const $745dccc780f801d1$export$7694915d49dbf79 = 'confluence_experiments.page,blogpost,whiteboard';
const $745dccc780f801d1$export$2d908678acc2f256 = 'confluence_experiments.page,blogpost,whiteboard,database,embed';
const $745dccc780f801d1$export$80a5be864676016b = 'confluence.space';
const $745dccc780f801d1$export$70542451ad6057d2 = 'urs.user-confluence';
const $745dccc780f801d1$export$6ec00f56b27cdc1d = 'generic-container-result';
const $745dccc780f801d1$export$ca1a50bc869949e = 'person-result';
const $745dccc780f801d1$export$a99961038e9d5471 = 'confluence-object-result';
const $745dccc780f801d1$export$18c69de2b4aa679c = 'recent-confluence';
const $745dccc780f801d1$export$dc31f0db54ab1a30 = 'result-confluence';
const $745dccc780f801d1$export$cb8b6c470492bee8 = 'recent-person';
const $745dccc780f801d1$export$ebb42dafe7a39a20 = 'result-person';
const $745dccc780f801d1$export$602b44a55c824e30 = 'advanced-search-confluence';
const $745dccc780f801d1$export$3eb1eaefdca3e463 = 'advanced-search-people';
const $745dccc780f801d1$export$bbd1709e62826142 = 'confluence-page';
const $745dccc780f801d1$export$4a1ec8cc030bc82a = 'confluence-blogpost';
const $745dccc780f801d1$export$b441f0c13fd510b9 = 'confluence-attachment';
const $745dccc780f801d1$export$8ee8726ca4e2f8bd = 'confluence-space';
const $745dccc780f801d1$export$d0e824889e01c751 = 'person';
const $745dccc780f801d1$export$b0c74445b9c9b57 = 'confluence-app';

});

parcelRegister("lVlZn", function(module, exports) {

$parcel$export(module.exports, "Scope", () => $656a9f09c37a4e93$export$775b6bb06e53a214);
/**
 * Instead of enum types for ResultType and ContentType we use a list of typed strings.
 * Typescript has issues when using types that require specific enum values (https://github.com/microsoft/TypeScript/issues/28102).
 *
 * There doesn't appear to be a working solution soon and as such we will manually type each value separately using strings.
 */ var $656a9f09c37a4e93$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["JiraIssue"] = "jira.issue";
    Scope["JiraPlan"] = "jira.plan";
    Scope["JiraDashboard"] = "jira.dashboard";
    Scope["JiraIssueDashboardBoardProjectFilter"] = "jira.issue,dashboard,board,project,filter";
    Scope["JiraBoardProjectFilter"] = "jira.board,project,filter";
    Scope["JiraBoardProjectFilterPlan"] = "jira.board,project,filter,plan";
    Scope["JiraProject"] = "jira.project";
    Scope["People"] = "urs.user-jira";
    return Scope;
}({});
var $656a9f09c37a4e93$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["JiraIssue"] = "jira-issue";
    ContentType["JiraDashboard"] = "jira-dashboard";
    ContentType["JiraBoard"] = "jira-board";
    ContentType["JiraProject"] = "jira-project";
    ContentType["JiraFilter"] = "jira-filter";
    ContentType["JiraPlan"] = "jira-plan";
    ContentType["JiraPeople"] = "jira-people";
    return ContentType;
}({});
function $656a9f09c37a4e93$export$b3b8cefe01df28d2(avatar) {
    return Object.prototype.hasOwnProperty.call(avatar, 'url');
}
function $656a9f09c37a4e93$export$496f9fe01bbac92b(avatar) {
    return Object.prototype.hasOwnProperty.call(avatar, 'urls');
}
var $656a9f09c37a4e93$export$d31c6c64cddbeeac = /*#__PURE__*/ function(AttributeType) {
    AttributeType["issue"] = "issue";
    AttributeType["dashboard"] = "dashboard";
    AttributeType["board"] = "board";
    AttributeType["project"] = "project";
    AttributeType["filter"] = "filter";
    AttributeType["plan"] = "plan";
    AttributeType["people"] = "people";
    return AttributeType;
}({});

});

parcelRegister("k20CO", function(module, exports) {

$parcel$export(module.exports, "Scope", () => $92a2a9bd23b17a3b$export$775b6bb06e53a214);
var $92a2a9bd23b17a3b$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["Loom"] = "loom.loom";
    return Scope;
}({});

});

parcelRegister("d3xjQ", function(module, exports) {

$parcel$export(module.exports, "TownsquareScope", () => $8b268bc46d9a7144$export$fca43c5c12a4e3fa);
var $8b268bc46d9a7144$export$fca43c5c12a4e3fa = /*#__PURE__*/ function(TownsquareScope) {
    TownsquareScope["TownsquareProject"] = "townsquare.project";
    TownsquareScope["TownsquareGoal"] = "townsquare.goal";
    TownsquareScope["TownsquareHelpLink"] = "townsquare.help-pointer";
    TownsquareScope["TownsquareQuestion"] = "townsquare.question";
    TownsquareScope["TownsquareTag"] = "townsquare.tag";
    TownsquareScope["TownsquareLearning"] = "townsquare.learning";
    TownsquareScope["People"] = "townsquare.people";
    TownsquareScope["Teams"] = "townsquare.teams";
    return TownsquareScope;
}({});
 // End of copied code.

});


parcelRegister("8Xhz6", function(module, exports) {

$parcel$export(module.exports, "useAtlassianPlugins", () => $4d1b16387ffb25eb$export$679584c8d36ab911);

var $5uXOq = parcelRequire("5uXOq");

var $9rFGE = parcelRequire("9rFGE");
const $4d1b16387ffb25eb$export$679584c8d36ab911 = (configs)=>{
    const [atlassianPlugins] = (0, $5uXOq.useState)(()=>new WeakMap());
    return (0, $5uXOq.useMemo)(()=>configs.map((config)=>{
            const existingPlugin = atlassianPlugins.get(config);
            if (existingPlugin) return existingPlugin;
            // If we haven't already created a plugin for this config, create one now
            // and store it in the map.
            const newPlugin = new (0, $9rFGE.default)(config);
            atlassianPlugins.set(config, newPlugin);
            return newPlugin;
        }), [
        atlassianPlugins,
        configs
    ]);
};

});
parcelRegister("9rFGE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e86b4f9c4481d5b3$export$2e2bcd8739ae039);

var $6WYgG = parcelRequire("6WYgG");
var $eWkSY = parcelRequire("eWkSY");

var $VSDnB = parcelRequire("VSDnB");

var $hoYXe = parcelRequire("hoYXe");

var $bCh6z = parcelRequire("bCh6z");

var $hmhqC = parcelRequire("hmhqC");

var $3ZomH = parcelRequire("3ZomH");

var $hiZ5q = parcelRequire("hiZ5q");
const $e86b4f9c4481d5b3$export$452f1062ecf44be7 = 5;
const $e86b4f9c4481d5b3$var$DEBOUNCE_MS = 400;
/**
 * Plugin responsible for handling fetching + caching of Atlassian Link Picker results
 */ class $e86b4f9c4481d5b3$var$AtlassianLinkPickerPlugin {
    constructor(config){
        this.analyticsIdentifier = 'link-picker-quick-search';
        this.useConfluenceTypeInAri = true;
        const { tabConfig: tabConfig, activityClientEndpoint: activityClientEndpoint, disableActivityClient: disableActivityClient = false, searchProvider: searchProvider, cloudId: cloudId, cloudIds: cloudIds, scope: scope, products: products, aggregatorUrl: aggregatorUrl, action: action, itemFilter: itemFilter, dataFilter: dataFilter, allowMultiSiteRecents: allowMultiSiteRecents } = config ?? {};
        const { tabKey: tabKey, tabTitle: tabTitle } = tabConfig ?? {};
        this._tabKey = tabKey || 'Atlassian';
        this._tabTitle = tabTitle || 'Atlassian';
        this.products = products;
        this.cloudId = cloudId;
        this.cloudIds = cloudIds;
        this.isMultisiteSearch = (this.cloudIds?.length ?? 0) > 0;
        this.allowMultiSiteRecents = this.isMultisiteSearch && allowMultiSiteRecents;
        this._action = action;
        this._scope = scope;
        this._pluginItemFilter = itemFilter;
        this._pluginDataFilter = dataFilter;
        this.searchProvider = searchProvider || this.createSearchProvider(scope, aggregatorUrl, this.analyticsIdentifier, this.useConfluenceTypeInAri);
        if (!disableActivityClient) this.activityClient = (0, $hoYXe.createActivityClient)('v3', 'link_picker_atlassian_plugin', undefined, activityClientEndpoint);
        this.debouncedSearch = (0, $eWkSY.promiseDebounce)(async (query)=>{
            if (!this.searchProvider) return [];
            const searchProvider = await this.searchProvider;
            return searchProvider.quickSearch(query, $e86b4f9c4481d5b3$export$452f1062ecf44be7);
        }, $e86b4f9c4481d5b3$var$DEBOUNCE_MS);
    }
    /**
	 * Create search provider if config params are provided
	 */ createSearchProvider(scope, aggregatorUrl, analyticsIdentifier, useConfluenceTypeInAri) {
        if (!this.cloudId || !scope) return undefined;
        return Promise.resolve(new (0, $hmhqC.default)(this.cloudId, scope, aggregatorUrl, analyticsIdentifier, useConfluenceTypeInAri, this.cloudIds));
    }
    /**
	 * Filter out fields from recent or search items.
	 * @param items The recent items to remove fields from.
	 * @returns Items with fields removed.
	 */ filterListItemFields(items) {
        // Assume this.products won't change during function call
        const products = this.products;
        // We can't filter out items if we don't have a product or we have more than one product,
        // as we can't tell which product a given item is from.
        if (products?.length !== 1) return items;
        // Config of map of products to fields to filter out from each item
        const productFieldsMap = {
            townsquare: [
                'lastViewedDate',
                'lastUpdatedDate',
                'container'
            ]
        };
        return items.map((item)=>{
            const newItem = {
                ...item
            };
            // Set fields to be undefined when they have been specified to be based on a given product in productFieldsMap
            for (const [productToCheck, fieldsToCheck] of Object.entries(productFieldsMap)){
                if (products[0] === productToCheck) for (const field of fieldsToCheck)newItem[field] = undefined;
            }
            return newItem;
        });
    }
    /**
	 * Set lastUpdatedDate for Loom search results and unset lastViewedDate.
	 * @param items The recent Loom items .
	 * @returns Items with lastUpdatedDate set.
	 */ setLoomRecentItemsDateField(items) {
        return items.map((item)=>{
            const newItem = {
                ...item
            };
            newItem.lastViewedDate = item.lastUpdatedDate;
            newItem.lastUpdatedDate = undefined;
            return newItem;
        });
    }
    /**
	 * Retrieve recent items from the activity provider
	 */ async getRecentItems() {
        if (!this.activityClient) return [];
        if (!this.recentItems) {
            const { viewed: items } = await this.activityClient.fetchActivities([
                50,
                125,
                250
            ], {
                limit: 100,
                products: this.products,
                rootContainerIds: this.allowMultiSiteRecents ? this.cloudIds?.reduce((acc, cloudId)=>acc.concat(...(0, $hiZ5q.getArisForProducts)(this.products, cloudId)), []) : this.cloudId !== undefined && !this.isMultisiteSearch ? (0, $hiZ5q.getArisForProducts)(this.products, this.cloudId) : undefined
            }, [
                'viewed'
            ], true);
            this.recentItems = items.map((0, $hiZ5q.mapActivityClientResultToLinkSearchItemData));
            this.recentItems = this.filterListItemFields(this.recentItems);
        }
        return this.recentItems;
    }
    /**
	 * Given a query, search the activity provider for recent activity
	 */ async searchRecentItems({ query: query }) {
        if (!this.recentItems) await this.getRecentItems();
        return (0, $hiZ5q.filterItems)(this.recentItems, query);
    }
    async quickSearch(state) {
        const isLoomRecentSearch = this._scope === (0, $bCh6z.Scope).Loom && state.query.length === 0;
        // similar to getRecentItems() we return the initial recent result when query string is reset
        if (isLoomRecentSearch && this._loomRecentItems) return this._loomRecentItems;
        const items = await this.debouncedSearch(state.query);
        let searchListItems = items.map((0, $hiZ5q.mapSearchProviderResultToLinkSearchItemData));
        // For Loom both recent and search results are fetched from search client. When search query is empty
        // the search returns recent items, when the query is not empty it returns searched items.
        // The setLoomRecentItemsDateField method sets the correct date field for the UI to consume.
        if (isLoomRecentSearch) {
            searchListItems = this.setLoomRecentItemsDateField(searchListItems);
            this._loomRecentItems = searchListItems;
        }
        return this.filterListItemFields(searchListItems);
    }
    /**
	 * Merge list of recent items and search items, and dedupes
	 */ mergeResults(itemsA, itemsB) {
        // Dedupe the items based on the URL
        return (0, $6WYgG.filterUniqueItems)([
            ...itemsA,
            ...itemsB
        ], (itemA, itemB)=>itemA.url === itemB.url);
    }
    applyPluginFilter(items) {
        if ((0, $VSDnB.fg)('jsc_inline_editing_field_refactor')) return items.filter(({ objectId: objectId })=>this._pluginItemFilter?.(objectId) ?? true).filter(({ objectId: objectId, url: url })=>this._pluginDataFilter?.({
                id: objectId,
                url: url
            }) ?? true);
        return this._pluginItemFilter ? items.filter(({ objectId: objectId })=>this._pluginItemFilter?.(objectId)) : items;
    }
    /**
	 * Given link picker state yields updates to the list of link picker results
	 * The plugin is considered to be in a loading state until the generator returns a final value
	 * The plugin can yield intermediate lists of results to present the user with initial results
	 * while loading additional results to update the list with.
	 */ async *resolve(state) {
        if (this.activityClient && state.query.length === 0) return {
            data: this.applyPluginFilter(await this.getRecentItems())
        };
        // Filter recents based on current state
        const filteredRecentItems = this.applyPluginFilter(await this.searchRecentItems(state));
        // If we have enough results, or there's no search provider to fetch more, return what we have
        if (filteredRecentItems.length >= $e86b4f9c4481d5b3$export$452f1062ecf44be7 || !this.searchProvider) return {
            data: filteredRecentItems
        };
        if (filteredRecentItems.length) // Update with what we have while we search for more
        yield {
            data: filteredRecentItems
        };
        // Get more results and return them merged with recents
        const searchResults = this.applyPluginFilter(await this.quickSearch(state));
        return {
            data: this.mergeResults(filteredRecentItems, searchResults)
        };
    }
    emptyStateNoResults() {
        if ((0, $VSDnB.fg)('link-picker-atl-plugin-empty-state')) {
            if (!this.activityClient) return null; // recent activity isn't supported, so leave this as blank
            if (!this.products || this.products.length !== 1) // don't support multi-product, as message gets too confusing
            return null;
            return (0, $3ZomH.renderEmptyStateNoResults)(this.products[0], this.action, this.cloudId, this.isMultisiteSearch);
        }
        return null;
    }
    get tabKey() {
        return this._tabKey;
    }
    get tabTitle() {
        return this._tabTitle;
    }
    get action() {
        return this._action;
    }
}
var $e86b4f9c4481d5b3$export$2e2bcd8739ae039 = $e86b4f9c4481d5b3$var$AtlassianLinkPickerPlugin;

});
parcelRegister("6WYgG", function(module, exports) {

$parcel$export(module.exports, "filterUniqueItems", () => $1f9431ad88e72ba1$export$8437fc55448c6e05);
/**
 * Filters array to a set of unique items given a predicate/comparator function
 * @param arr Initial array of items
 * @param comparator Predicate function
 * @returns Array of filtered / unique items
 */ function $1f9431ad88e72ba1$export$8437fc55448c6e05(arr, comparator) {
    return arr.filter((firstItem, index, self)=>{
        return self.findIndex((secondItem)=>comparator ? comparator(firstItem, secondItem) : firstItem === secondItem) === index;
    });
}

});

parcelRegister("eWkSY", function(module, exports) {

$parcel$export(module.exports, "promiseDebounce", () => $1c8f387e21e6b092$export$390f1673aa3d5232);
/**
 * Given a callback function returns a promise that resolves to the result of calling the callback function but is
 * debounced (execution is cancelled and promise will remain pending if `promiseDebounce` is re-called within the `time` interval)
 * @param cb Callback which returns result to be resolved
 * @param time Debounce interval
 * @returns Function that returns debounced promise
 */ function $1c8f387e21e6b092$export$390f1673aa3d5232(cb, time) {
    let timeoutId;
    // Returns a promise that fires the debounce fn and pushes a resolver
    // to have the debounced result resolved
    return (...args)=>{
        timeoutId && clearTimeout(timeoutId);
        return new Promise((resolve, reject)=>{
            timeoutId = setTimeout(()=>{
                cb(...args).then(resolve).catch(reject);
            }, time);
        });
    };
}

});

parcelRegister("hoYXe", function(module, exports) {

$parcel$export(module.exports, "createActivityClient", () => $30574e88272de3f4$export$224367b01f71f2aa);

var $9yZqs = parcelRequire("9yZqs");

var $7trIV = parcelRequire("7trIV");
let $30574e88272de3f4$var$previousClientVersion;
const $30574e88272de3f4$export$224367b01f71f2aa = (version, product, logger, baseUrl, configFetch)=>{
    if ($30574e88272de3f4$var$previousClientVersion && $30574e88272de3f4$var$previousClientVersion !== version && logger?.captureWarning) logger.captureWarning(`ActivityClient version has changed, is this intentional?`);
    $30574e88272de3f4$var$previousClientVersion = version || 'v3';
    if (version === 'v2') return new (0, $9yZqs.ActivityClientV2)(product, baseUrl);
    return new (0, $7trIV.ActivityClientV3)(product, baseUrl, logger, configFetch);
};

});
parcelRegister("9yZqs", function(module, exports) {

$parcel$export(module.exports, "ActivityClientV2", () => $fff1f13eb7277558$export$330ab0047f2fb745);

var $cXq43 = parcelRequire("cXq43");

var $3Bknq = parcelRequire("3Bknq");

var $gVYg8 = parcelRequire("gVYg8");
class $fff1f13eb7277558$export$330ab0047f2fb745 extends (0, $3Bknq.ActivityClient) {
    constructor(product, baseUrl){
        super('v2', product, undefined, baseUrl), this.fetchActivities = async (retryMS, filters, activityQueries)=>{
            return (0, $cXq43.fetchActivitiesWithExperience)((experience)=>(0, $gVYg8.fetchActivitiesV2)({
                    experience: experience,
                    product: this.product,
                    retryMS: retryMS,
                    filters: filters,
                    activityQueries: activityQueries,
                    baseUrl: this.baseUrl
                }), 'v2');
        }, this.setProduct = (product)=>{
            this.product = product;
        };
    }
}

});
parcelRegister("cXq43", function(module, exports) {

$parcel$export(module.exports, "fetchActivitiesWithExperience", () => $12ea6ddffbcd8f57$export$4a906f16800734f3);

var $iFmUA = parcelRequire("iFmUA");

var $1b4ym = parcelRequire("1b4ym");

var $4cDQS = parcelRequire("4cDQS");
async function $12ea6ddffbcd8f57$export$4a906f16800734f3(fetchActivities, clientVersion) {
    const experience = clientVersion === 'v2' ? (0, $4cDQS.recentWorkClientExperienceV2)() : (0, $4cDQS.recentWorkClientExperienceV3)();
    try {
        experience.start();
        experience.addMetadata({
            clientVersion: clientVersion,
            packageName: $1b4ym.packageName,
            packageVersion: $1b4ym.packageVersion
        });
        const data = await fetchActivities(experience);
        experience.success();
        return data;
    } catch (e) {
        experience.failure({
            metadata: {
                error: $12ea6ddffbcd8f57$export$f33622abb5224195(e)
            }
        });
        throw e;
    }
}
const $12ea6ddffbcd8f57$export$f33622abb5224195 = (e)=>{
    if (e instanceof (0, $iFmUA.default)) return {
        ...e,
        xRequestId: e.xRequestId ?? undefined,
        cause: undefined
    };
    return e instanceof Error ? {
        ...e,
        cause: undefined
    } : 'unknown';
};

});
parcelRegister("iFmUA", function(module, exports) {

$parcel$export(module.exports, "default", () => $0aef1aaaf8d64fa1$export$2e2bcd8739ae039);
class $0aef1aaaf8d64fa1$export$2e2bcd8739ae039 extends Error {
    constructor({ message: message, statusCode: statusCode, path: path, method: method, xRequestId: xRequestId, headers: headers }){
        super();
        this.name = 'HttpError';
        this.message = message;
        const p = path.split('?')[0];
        this.path = /^[/-a-z]+$/i.test(p) ? p : '';
        this.method = method;
        this.statusCode = statusCode;
        this.xRequestId = xRequestId;
        // @ts-ignore - Property 'entries' does not exist on type 'Headers'.
        // This was added when enrolling `@atlassian/recent-work-client` into JFE local consumption
        this.headers = Array.from(headers.entries()).map((value, key)=>`${key}:${value}`).sort().join(',');
    }
}
const $0aef1aaaf8d64fa1$export$97b788730ba59845 = (e)=>e instanceof $0aef1aaaf8d64fa1$export$2e2bcd8739ae039;

});

parcelRegister("1b4ym", function(module, exports) {

$parcel$export(module.exports, "packageName", () => $42bb1ba4b82855c2$export$9345d7360ffe0722);
$parcel$export(module.exports, "packageVersion", () => $42bb1ba4b82855c2$export$91546b032799aa40);
const $42bb1ba4b82855c2$export$9345d7360ffe0722 = "platform-pkg";
const $42bb1ba4b82855c2$export$91546b032799aa40 = "0.0.0-use.local";

});

parcelRegister("4cDQS", function(module, exports) {

$parcel$export(module.exports, "recentWorkClientExperienceV2", () => $cf5f22aa1bc15bc4$export$d7769758f5eaa63b);
$parcel$export(module.exports, "recentWorkClientExperienceV3", () => $cf5f22aa1bc15bc4$export$9e32a4ed888f4717);

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
const $cf5f22aa1bc15bc4$var$keyToTiming = (key)=>({
        key: key,
        startMark: `${key}_start`,
        endMark: `${key}_end`
    });
const $cf5f22aa1bc15bc4$var$timings = [
    'FetchedActivities',
    'TransformedActivityItems',
    'GeneratedQueryWithFilters'
].map($cf5f22aa1bc15bc4$var$keyToTiming);
const $cf5f22aa1bc15bc4$export$d7769758f5eaa63b = ()=>{
    return new (0, $duUGa.UFOExperience)('client', {
        type: (0, $atdLB.ExperienceTypes).Load,
        performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
        platform: {
            component: 'recent-work'
        },
        timings: $cf5f22aa1bc15bc4$var$timings
    });
};
const $cf5f22aa1bc15bc4$export$9e32a4ed888f4717 = ()=>new (0, $duUGa.UFOExperience)('client-v3', {
        type: (0, $atdLB.ExperienceTypes).Load,
        performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
        platform: {
            component: 'recent-work'
        },
        timings: $cf5f22aa1bc15bc4$var$timings
    });

});


parcelRegister("3Bknq", function(module, exports) {

$parcel$export(module.exports, "ActivityClient", () => $d3363d88c8d5ff9b$export$157740f5433f3dbe);

var $3l0ly = parcelRequire("3l0ly");
class $d3363d88c8d5ff9b$export$157740f5433f3dbe {
    constructor(clientVersion, product, headers, baseUrl){
        this.product = 'unknown';
        this.baseUrl = (0, $3l0ly.GRAPHQL_GATEWAY_PATH);
        if (product) this.product = product;
        this.clientVersion = clientVersion;
        this.headers = headers ?? {};
        if (baseUrl) this.baseUrl = baseUrl;
    }
}

});
parcelRegister("3l0ly", function(module, exports) {

$parcel$export(module.exports, "GRAPHQL_GATEWAY_PATH", () => $4167449aedd1da1b$export$851c5df667ca24c8);
$parcel$export(module.exports, "WORKED_EVENT", () => $4167449aedd1da1b$export$eb4e9f525aef1cc3);
const $4167449aedd1da1b$export$851c5df667ca24c8 = '/gateway/api/graphql';
var $4167449aedd1da1b$export$d245b105c09339d8 = /*#__PURE__*/ function(VIEWED_EVENT) {
    VIEWED_EVENT["VIEWED"] = "viewed";
    return VIEWED_EVENT;
}({});
var $4167449aedd1da1b$export$eb4e9f525aef1cc3 = /*#__PURE__*/ function(WORKED_EVENT) {
    WORKED_EVENT["COMMENTED"] = "commented";
    WORKED_EVENT["CREATED"] = "created";
    WORKED_EVENT["EDITED"] = "edited";
    WORKED_EVENT["PUBLISHED"] = "published";
    WORKED_EVENT["UPDATED"] = "updated";
    return WORKED_EVENT;
}({});
var $4167449aedd1da1b$export$d02a56686be43f69 = /*#__PURE__*/ function(ActivityObjectType) {
    ActivityObjectType["BLOGPOST"] = "BLOGPOST";
    ActivityObjectType["COMMENT"] = "COMMENT";
    ActivityObjectType["ISSUE"] = "ISSUE";
    ActivityObjectType["PAGE"] = "PAGE";
    ActivityObjectType["PROJECT"] = "PROJECT";
    ActivityObjectType["SITE"] = "SITE";
    ActivityObjectType["SPACE"] = "SPACE";
    ActivityObjectType["TASK"] = "TASK";
    return ActivityObjectType;
}({});

});


parcelRegister("gVYg8", function(module, exports) {

$parcel$export(module.exports, "fetchActivitiesV2", () => $9bc87a88656ac7d1$export$750ec7816fdd2f9e);

var $f3gfD = parcelRequire("f3gfD");

var $e35Gx = parcelRequire("e35Gx");

var $aHtVh = parcelRequire("aHtVh");

var $lB6CZ = parcelRequire("lB6CZ");
const $9bc87a88656ac7d1$var$ACTIVITIES_LIMIT = 50;
// typescript guard for validating the activities connection type
const $9bc87a88656ac7d1$var$isMyActivitiesConnection = (activities)=>{
    return activities.myActivities !== undefined;
};
const $9bc87a88656ac7d1$var$V2_AVAILABLE_PRODUCTS = [
    'teamCentral',
    'editor',
    'people',
    'jira',
    'townsquare',
    'apOnboarding',
    'worklens',
    'confluence',
    'start'
];
const $9bc87a88656ac7d1$export$750ec7816fdd2f9e = async ({ experience: experience, product: product, retryMS: retryMS, filters: filters = {}, activityQueries: activityQueries, baseUrl: baseUrl })=>{
    const { limit: // we want to default limit if not applied
    limit = $9bc87a88656ac7d1$var$ACTIVITIES_LIMIT, ...restFilters } = filters;
    experience.mark('GeneratedQueryWithFilters_start');
    const { query: query, queryFilters: queryFilters } = (0, $aHtVh.generateActivityQueryWithFilters)(product, restFilters, activityQueries);
    experience.mark('GeneratedQueryWithFilters_end');
    // This is to make v2 forwards compatible. Defaulting to start as the product
    const operationProduct = $9bc87a88656ac7d1$var$V2_AVAILABLE_PRODUCTS.includes(product) ? product : 'start';
    experience.mark('FetchedActivities_start');
    let response;
    try {
        response = await (0, $e35Gx.postResource)(baseUrl, {
            operationName: (0, $f3gfD.getOperationName)(operationProduct),
            query: query,
            variables: {
                first: limit,
                filters: queryFilters
            }
        }, retryMS);
    } catch (error) {
        if (!error || error.statusCode !== 401 && error.message !== 'The operation was aborted.') throw error;
    }
    experience.mark('FetchedActivities_end');
    let workedOn = [], viewed = [], all = [];
    if (!response || !response.data?.activities) return {
        all: all,
        workedOn: workedOn,
        viewed: viewed
    };
    experience.mark('TransformedActivityItems_start');
    if ($9bc87a88656ac7d1$var$isMyActivitiesConnection(response.data.activities)) {
        if (response.data.activities.myActivities.workedOn && activityQueries.includes('workedOn')) workedOn = (0, $lB6CZ.transformActivitiesItems)('workedOn', response.data.activities.myActivities.workedOn);
        if (response.data.activities.myActivities.viewed && activityQueries.includes('viewed')) viewed = (0, $lB6CZ.transformActivitiesItems)('viewed', response.data.activities.myActivities.viewed);
        if (response.data.activities.myActivities.all && activityQueries.includes('all')) all = (0, $lB6CZ.transformActivitiesItems)('all', response.data.activities.myActivities.all);
    } else {
        if (response.data.activities.workedOn && activityQueries.includes('workedOn')) workedOn = (0, $lB6CZ.transformActivitiesItems)('workedOn', response.data.activities.workedOn);
        if (response.data.activities.all && activityQueries.includes('all')) all = (0, $lB6CZ.transformActivitiesItems)('all', response.data.activities.all);
    }
    experience.mark('TransformedActivityItems_end');
    return {
        all: all,
        viewed: viewed,
        workedOn: workedOn
    };
};

});
parcelRegister("f3gfD", function(module, exports) {

$parcel$export(module.exports, "getOperationName", () => $461d79ecc23ca794$export$41bca9dc6871dd4e);

var $e4eHl = parcelRequire("e4eHl");
const $461d79ecc23ca794$export$ad1e21d37f385bcb = (product)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(product);
};
const $461d79ecc23ca794$export$41bca9dc6871dd4e = (product)=>{
    return `${$461d79ecc23ca794$export$ad1e21d37f385bcb(product)}_activity_recentWorkClient`;
};

});

parcelRegister("e35Gx", function(module, exports) {

$parcel$export(module.exports, "postResource", () => $e89fe5eb68802860$export$2ff3e1f219ccfad6);

var $6fYNv = parcelRequire("6fYNv");

var $lP65p = parcelRequire("lP65p");

var $iFmUA = parcelRequire("iFmUA");
const $e89fe5eb68802860$var$fetchResource = async (path, method, options = {})=>{
    const url = (0, $lP65p.getFullUrl)(path);
    const response = await fetch(url, {
        credentials: 'include',
        method: method,
        ...options
    }).catch((error)=>{
        throw new (0, $6fYNv.FailedFetchError)({
            error: error,
            path: path,
            method: method
        });
    });
    const statusCode = response.status;
    if (!response.ok) {
        statusCode;
        const text = $e89fe5eb68802860$var$scrubTimestampFromErrorBody(await response.text());
        const httpError = new (0, $iFmUA.default)({
            message: text,
            method: method,
            path: path,
            statusCode: statusCode,
            xRequestId: response.headers.get('x-request-id'),
            headers: response.headers
        });
        throw httpError;
    }
    return response;
};
const $e89fe5eb68802860$var$makeJsonRquest = async (path, method, additionalFetchOptions = {})=>{
    const response = await $e89fe5eb68802860$var$fetchResource(path, method, additionalFetchOptions);
    const text = await response.text();
    // trying to parse empty response as JSON throws an error, but endpoints can return empty response in case of success
    return text ? JSON.parse(text) : {};
};
const $e89fe5eb68802860$export$2ff3e1f219ccfad6 = async (path, data, retryMS, extraHeaders)=>(0, $6fYNv.retryOnException)(()=>$e89fe5eb68802860$var$makeJsonRquest(path, 'POST', {
            body: JSON.stringify(data),
            headers: {
                'content-type': 'application/json',
                ...extraHeaders
            }
        }), {
        intervalsMS: retryMS ?? []
    });
// to dedup sentry, scrub non-unique 'timestamp' field from the error body
function $e89fe5eb68802860$var$scrubTimestampFromErrorBody(text) {
    let json;
    try {
        json = JSON.parse(text);
    } catch (err) {
        return text;
    }
    delete json.timestamp;
    return JSON.stringify(json);
}

});
parcelRegister("lP65p", function(module, exports) {

$parcel$export(module.exports, "getFullUrl", () => $196111106f21b511$export$2414511207262909);
const $196111106f21b511$var$urlRegex = new RegExp(/^https?:\/\//);
function $196111106f21b511$export$2414511207262909(path, // Add this param so we can test this function better
hostConfig = {
    host: window.location.hostname,
    port: window.location.port
}) {
    // always return a just the URL if one is provided
    if ($196111106f21b511$var$urlRegex.test(path)) return path;
    return hostConfig.host === 'localhost' ? `http://${hostConfig.host}:${hostConfig.port}${path}` : path;
}

});


parcelRegister("aHtVh", function(module, exports) {

$parcel$export(module.exports, "generateActivityQueryWithFilters", () => $3a68129fd7fbdd1f$export$855cd08371c65b8c);

var $f3gfD = parcelRequire("f3gfD");

var $dcvAS = parcelRequire("dcvAS");
const $3a68129fd7fbdd1f$var$ACTIVITIES = `
  nodes {
    id
    timestamp
    object {
      id
      name
      cloudId
      localResourceId
      product
      type
      url
      iconUrl
      containers {
        name
      }
      contributors {
        profile {
          accountId
          name
          picture
        }
      }
      events {
        eventType
      }
      extension {
        ... on ActivitiesJiraIssue {
          issueKey
        }
      }
    }
  }
`;
const $3a68129fd7fbdd1f$var$WORKED_ON_QUERY = `
   workedOn(first: $first, filters: $filters) {
     ${$3a68129fd7fbdd1f$var$ACTIVITIES}
   }
`;
const $3a68129fd7fbdd1f$var$VIEWED__QUERY = `
   viewed(first: $first, filters: $filters) {
     ${$3a68129fd7fbdd1f$var$ACTIVITIES}
   }
`;
const $3a68129fd7fbdd1f$var$ALL__QUERY = `
    all(first: $first, filters: $filters) {
      ${$3a68129fd7fbdd1f$var$ACTIVITIES}
    }
`;
const $3a68129fd7fbdd1f$var$activityQueryMap = new Map([
    [
        'workedOn',
        $3a68129fd7fbdd1f$var$WORKED_ON_QUERY
    ],
    [
        'viewed',
        $3a68129fd7fbdd1f$var$VIEWED__QUERY
    ],
    [
        'all',
        $3a68129fd7fbdd1f$var$ALL__QUERY
    ]
]);
const $3a68129fd7fbdd1f$var$getMyActivitiesQuery = (queries)=>`
      myActivities {
        ${queries.join('\n')}
      }
`;
const $3a68129fd7fbdd1f$var$getActivitiesQuery = (product, content)=>`
    query ${(0, $f3gfD.getOperationName)(product)}($first: Int, $filters: [ActivitiesFilter!]) {
      activities {
        ${content}
      }
    }
`;
const $3a68129fd7fbdd1f$export$855cd08371c65b8c = (product, filters, activityQueries)=>{
    /**
	 * If we are filtering by `accountIds` then we can't use the `myActivity` query.
	 */ if (Array.isArray(filters.actors)) {
        // you can't view `viewed` events for other accounts
        const filteredAccountQueries = activityQueries.filter((query)=>query !== 'viewed');
        return {
            query: $3a68129fd7fbdd1f$var$getActivitiesQuery(product, filteredAccountQueries.map((query)=>$3a68129fd7fbdd1f$var$activityQueryMap.get(query)).join('\n')),
            queryFilters: (0, $dcvAS.ACTIVITY_FILTER_COLLECTION).v2.get('activities')(filters)
        };
    } else return {
        query: $3a68129fd7fbdd1f$var$getActivitiesQuery(product, $3a68129fd7fbdd1f$var$getMyActivitiesQuery(activityQueries.map((query)=>$3a68129fd7fbdd1f$var$activityQueryMap.get(query)))),
        queryFilters: (0, $dcvAS.ACTIVITY_FILTER_COLLECTION).v2.get('myActivity')(filters)
    };
};

});
parcelRegister("dcvAS", function(module, exports) {

$parcel$export(module.exports, "ACTIVITY_FILTER_COLLECTION", () => $1d4997441d4b8586$export$5201d39848130041);

var $1THyP = parcelRequire("1THyP");

var $62oeH = parcelRequire("62oeH");
const $1d4997441d4b8586$export$5201d39848130041 = {
    v2: (0, $1THyP.ACTIVITY_FILTER_V2_MAP),
    v3: (0, $62oeH.ACTIVITY_FILTER_V3_MAP)
};

});
parcelRegister("1THyP", function(module, exports) {

$parcel$export(module.exports, "ACTIVITY_FILTER_V2_MAP", () => $a1a68e27645236e3$export$1dca7bc1ec360897);

var $4hkqF = parcelRequire("4hkqF");

var $afWIG = parcelRequire("afWIG");
const $a1a68e27645236e3$export$1dca7bc1ec360897 = new Map([
    [
        'myActivity',
        (0, $afWIG.default)
    ],
    [
        'activities',
        (0, $4hkqF.default)
    ]
]);

});
parcelRegister("4hkqF", function(module, exports) {

$parcel$export(module.exports, "default", () => $46c6a95053cc1f7b$export$2e2bcd8739ae039);

var $74JGD = parcelRequire("74JGD");
/**
 * This is the query builder for the v2 - activities API
 *
 * @param filters
 */ const $46c6a95053cc1f7b$var$generateV2ActivitiesFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, // TODO: Enable the below code as we support multi-user queries and enable them in the main ActivityFilters interface
    // actors,
    // rootContainerIds,
    ...restFilters } = filters;
    return (0, $74JGD.generateActivityFiltersV2)(restFilters);
};
var $46c6a95053cc1f7b$export$2e2bcd8739ae039 = $46c6a95053cc1f7b$var$generateV2ActivitiesFilters;

});
parcelRegister("74JGD", function(module, exports) {

$parcel$export(module.exports, "generateActivityFiltersV2", () => $683b63762cac319c$export$ebef9c1f1e15c057);

var $MQuHl = parcelRequire("MQuHl");
// in V2 API the values for certain filters should be in UPPERCASE as are ENUMs in the GraphQL
// likewise for the V3 handler we should ensure we do appropriate lowercase conversion
const $683b63762cac319c$var$FILTERS_TO_TRANSFORM__UPPERCASE = [
    'products',
    'eventTypes',
    'objectTypes'
];
const $683b63762cac319c$var$KEYS_TO_TRANSFROM = new Map([
    [
        'actors',
        'accountIds'
    ]
]);
const $683b63762cac319c$export$ebef9c1f1e15c057 = (filters = {})=>(0, $MQuHl.generateActivityFilters)(filters, (originalkey, originalFilter)=>{
        const filter = Array.isArray(originalFilter) && $683b63762cac319c$var$FILTERS_TO_TRANSFORM__UPPERCASE.includes(originalkey) ? originalFilter.map((f)=>f.toUpperCase()) : originalFilter;
        const key = $683b63762cac319c$var$KEYS_TO_TRANSFROM.has(originalkey) ? $683b63762cac319c$var$KEYS_TO_TRANSFROM.get(originalkey) : originalkey;
        return {
            [key]: filter
        };
    });

});
parcelRegister("MQuHl", function(module, exports) {

$parcel$export(module.exports, "generateActivityFilters", () => $0ef7a6884f8128bf$export$23c75313f46dd54e);
const $0ef7a6884f8128bf$export$23c75313f46dd54e = (filters = {}, transform, rootLevelFilters)=>{
    return Object.entries(filters).reduce((acc, [key, filter])=>{
        const entry = transform ? transform(key, filter) : {
            [key]: filter
        };
        return rootLevelFilters?.includes(key) ? {
            ...acc,
            ...entry
        } : {
            ...acc,
            arguments: {
                ...acc.arguments,
                ...entry
            }
        };
    }, {
        type: 'AND',
        arguments: {}
    });
};

});



parcelRegister("afWIG", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3c453a00bc0f6ca$export$2e2bcd8739ae039);

var $74JGD = parcelRequire("74JGD");
/**
 * This is the query builder for the v2 - myActivity API
 *
 * @param filters
 */ const $b3c453a00bc0f6ca$var$generateV2MyActivityFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, actors: actors, // TODO: Enable the below code as we support multi-user queries and enable them in the main ActivityFilters interface
    // actors,
    // rootContainerIds,
    ...restFilters } = filters;
    return (0, $74JGD.generateActivityFiltersV2)(restFilters);
};
var $b3c453a00bc0f6ca$export$2e2bcd8739ae039 = $b3c453a00bc0f6ca$var$generateV2MyActivityFilters;

});


parcelRegister("62oeH", function(module, exports) {

$parcel$export(module.exports, "ACTIVITY_FILTER_V3_MAP", () => $a356d323f8207676$export$9a1782843b6e99d2);

var $hU3MB = parcelRequire("hU3MB");

var $gQxYK = parcelRequire("gQxYK");
const $a356d323f8207676$export$9a1782843b6e99d2 = new Map([
    [
        'myActivity',
        (0, $gQxYK.default)
    ],
    [
        'activities',
        (0, $hU3MB.default)
    ]
]);

});
parcelRegister("hU3MB", function(module, exports) {

$parcel$export(module.exports, "default", () => $84a6b56b296ed055$export$2e2bcd8739ae039);

var $glhs7 = parcelRequire("glhs7");
/**
 * This is the query builder for the v3 - activities API
 *
 * @param filters
 */ const $84a6b56b296ed055$var$generateV3ActivityFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, ...restFilters } = filters;
    return (0, $glhs7.generateActivityFiltersV3)(restFilters);
};
var $84a6b56b296ed055$export$2e2bcd8739ae039 = $84a6b56b296ed055$var$generateV3ActivityFilters;

});
parcelRegister("glhs7", function(module, exports) {

$parcel$export(module.exports, "generateActivityFiltersV3", () => $3cb34394a8624fd6$export$e73fe7ded3fe2664);

var $MQuHl = parcelRequire("MQuHl");
// in V2 API the values for certain filters should be in UPPERCASE as are ENUMs in the GraphQL
// likewise for the V3 handler we should ensure we do appropriate lowercase conversion
const $3cb34394a8624fd6$var$FILTERS_TO_TRANSFORM__LOWERCASE = [
    'products',
    'eventTypes',
    'objectTypes'
];
const $3cb34394a8624fd6$var$ROOT_LEVEL_FILTERS = [
    'actors',
    'rootContainerIds'
];
const $3cb34394a8624fd6$export$e73fe7ded3fe2664 = (filters = {})=>(0, $MQuHl.generateActivityFilters)(filters, (key, filter)=>Array.isArray(filter) && $3cb34394a8624fd6$var$FILTERS_TO_TRANSFORM__LOWERCASE.includes(key) ? {
            [key]: filter.map((f)=>f.toLowerCase())
        } : {
            [key]: filter
        }, $3cb34394a8624fd6$var$ROOT_LEVEL_FILTERS);

});


parcelRegister("gQxYK", function(module, exports) {

$parcel$export(module.exports, "default", () => $840ac7ca8bd740a4$export$2e2bcd8739ae039);

var $glhs7 = parcelRequire("glhs7");
/**
 * This is the query builder for the v3 - myActivity API
 *
 * @param filters
 */ const $840ac7ca8bd740a4$var$generateV3MyActivityFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, actors: actors, ...restFilters } = filters;
    return (0, $glhs7.generateActivityFiltersV3)(restFilters);
};
var $840ac7ca8bd740a4$export$2e2bcd8739ae039 = $840ac7ca8bd740a4$var$generateV3MyActivityFilters;

});




parcelRegister("lB6CZ", function(module, exports) {

$parcel$export(module.exports, "transformActivitiesItems", () => $ccb3637438790056$export$306a8b649360ca6f);
const $ccb3637438790056$var$SITE_ARI_PREFIX = 'ari:cloud:platform::site/';
function $ccb3637438790056$export$306a8b649360ca6f(query, activities = {}) {
    if (!activities || !activities.nodes) return [];
    return activities.nodes.map((item)=>{
        const { object: object, timestamp: timestamp } = item;
        const { cloudId: cloudId, events: events, extension: extension, iconUrl: iconUrl, id: id, localResourceId: localResourceId, name: name, product: product, url: url, type: type } = object;
        // V2 returns eventType captilised, V3 returns lowercase
        const eventType = events[0].eventType.toLowerCase();
        const issueKey = extension && extension.issueKey;
        let containers = [];
        if (issueKey) containers.push({
            name: issueKey
        });
        if (Array.isArray(object.containers)) containers = containers.concat(object.containers);
        containers = containers.filter((container)=>!!container.name);
        return {
            query: query,
            containers: containers,
            contributors: (object.contributors || []).reduce((contributors, contributor)=>{
                if (contributor.profile) {
                    const { accountId: accountId, picture: picture } = contributor.profile;
                    contributors.push({
                        accountId: accountId,
                        name: contributor.profile.name,
                        picture: picture
                    });
                }
                return contributors;
            }, []),
            eventType: eventType,
            object: {
                rootContainerIdentifier: {
                    id: cloudId,
                    type: 'SITE',
                    ari: `${$ccb3637438790056$var$SITE_ARI_PREFIX}${cloudId}`
                },
                deduplicateId: id,
                icon: {
                    type: 'URL',
                    value: iconUrl
                },
                id: id,
                localResourceId: localResourceId,
                name: name,
                product: product,
                subProduct: null,
                type: type,
                url: url
            },
            timestamp: timestamp
        };
    });
}

});



parcelRegister("7trIV", function(module, exports) {

$parcel$export(module.exports, "ActivityClientV3", () => $36bf5d2659940c95$export$3c3c237c92ca1fb9);

var $6fYNv = parcelRequire("6fYNv");

var $VSDnB = parcelRequire("VSDnB");

var $3l0ly = parcelRequire("3l0ly");

var $1b4ym = parcelRequire("1b4ym");

var $cXq43 = parcelRequire("cXq43");

var $e35Gx = parcelRequire("e35Gx");

var $dMJiM = parcelRequire("dMJiM");

var $4HxlV = parcelRequire("4HxlV");

var $fTeQf = parcelRequire("fTeQf");

var $jkCM1 = parcelRequire("jkCM1");

var $65vGW = parcelRequire("65vGW");

var $3LJ9C = parcelRequire("3LJ9C");

var $3Bknq = parcelRequire("3Bknq");

var $55Gxu = parcelRequire("55Gxu");

var $66K4V = parcelRequire("66K4V");

var $hTLIi = parcelRequire("hTLIi");
const $36bf5d2659940c95$var$CONFLUENCE_COMMENT_TYPENAMES = [
    'ConfluenceComment',
    'ConfluenceFooterComment',
    'ConfluenceInlineComment'
];
const $36bf5d2659940c95$var$IGNORED_HTTP_ERRORS = new Map([
    // ignore all 401 errors
    [
        401,
        [
            /.*/
        ]
    ],
    [
        403,
        [
            /Invalid CORS request/
        ]
    ]
]);
const $36bf5d2659940c95$var$IGNORED_ERROR_MESSAGES = [
    'The operation was aborted.'
];
const $36bf5d2659940c95$var$DEFAULT_TAGS = {
    source: (0, $1b4ym.packageName),
    sourcePackageVersion: (0, $1b4ym.packageVersion)
};
class $36bf5d2659940c95$export$3c3c237c92ca1fb9 extends (0, $3Bknq.ActivityClient) {
    constructor(product, baseUrl, logger, configFetch){
        super('v3', product, {
            'X-ExperimentalApi': 'ActivityV3Api'
        }, baseUrl), this.setProduct = (product)=>{
            this.product = product;
        }, this.captureException = (error, tags)=>{
            if (this.clientHandlers) this.clientHandlers.captureException(error, {
                ...$36bf5d2659940c95$var$DEFAULT_TAGS,
                ...tags
            });
        }, this.captureWarning = (message, tags)=>{
            if (this.clientHandlers) this.clientHandlers.captureWarning(message, {
                ...$36bf5d2659940c95$var$DEFAULT_TAGS,
                ...tags
            });
        }, this.fetchHydratorConfig = async ()=>await this.hydratorConfigClient.fetchConfig(), this.handleGraphQLErrors = (errors)=>{
            const invalidFragments = [];
            if (Array.isArray(errors)) {
                for (const err of errors){
                    this.captureException(new (0, $4HxlV.GraphQLJSError)(err));
                    const invalidFragment = (0, $55Gxu.default)(err);
                    if (invalidFragment) invalidFragments.push(invalidFragment);
                }
                return invalidFragments;
            }
            return [];
        }, this.fetchActivitiesV3 = async (experience, retryMS, filters, activityQueries, deduplicateActivities = true)=>{
            let { fragments: fragments, hydrators: hydrators } = await this.fetchHydratorConfig();
            experience.mark('GeneratedQueryWithFilters_start');
            let response;
            try {
                response = await (0, $6fYNv.retryOnException)(async ()=>{
                    const request = (0, $66K4V.generateGraphQLRequest)(this.product, filters, activityQueries, fragments);
                    experience.mark('GeneratedQueryWithFilters_end');
                    experience.mark('FetchedActivities_start');
                    experience.addMetadata({
                        filters: (0, $hTLIi.filtersToMetadata)(filters)
                    });
                    const res = await (0, $e35Gx.postResource)(this.baseUrl, request, retryMS, {
                        ...this.headers
                    });
                    experience.mark('FetchedActivities_end');
                    const invalidFragments = this.handleGraphQLErrors(res?.errors);
                    if (invalidFragments.length > 0) {
                        fragments = (0, $hTLIi.filterInvalidFragments)(invalidFragments, fragments);
                        throw new (0, $dMJiM.GraphQLFragmentError)(`Missing fragments: [${invalidFragments.toString()}]`);
                    }
                    return res;
                }, {
                    intervalsMS: [
                        0,
                        0,
                        0
                    ],
                    retryOn: (err)=>[
                            (0, $dMJiM.GraphQLFragmentError)
                        ].some((retriableErr)=>err instanceof retriableErr),
                    captureException: this.captureException
                });
            } catch (error) {
                if (!error || !$36bf5d2659940c95$var$IGNORED_HTTP_ERRORS.get(error.statusCode)?.some((regExp)=>regExp.test(error.message)) && !$36bf5d2659940c95$var$IGNORED_ERROR_MESSAGES.includes(error.message)) throw error;
            }
            if ((0, $hTLIi.isEmptyActivitiesWithErrorsResponse)(response)) throw new (0, $fTeQf.GraphQLNoResultsError)(response.errors);
            if (!response || !response.data?.activity) return {
                workedOn: [],
                viewed: [],
                all: []
            };
            experience.mark('TransformedActivityItems_start');
            const workedOn = $36bf5d2659940c95$var$transformActivityItem('workedOn', (0, $hTLIi.activityRoot)(response.data.activity)?.workedOn?.edges || [], hydrators, this.captureException);
            // We don't need the activity root function here as viewed only exists on myActivity
            const viewed = $36bf5d2659940c95$var$transformActivityItem('viewed', response.data.activity?.myActivity?.viewed?.edges || [], hydrators, this.captureException);
            const all = $36bf5d2659940c95$var$transformActivityItem('all', (0, $hTLIi.activityRoot)(response.data.activity)?.all?.edges || [], hydrators, this.captureException);
            experience.mark('TransformedActivityItems_end');
            const activities = {
                viewed: viewed,
                workedOn: workedOn,
                all: all
            };
            return deduplicateActivities ? (0, $hTLIi.rollupActivitiesData)(activities) : activities;
        }, this.fetchActivities = async (retryMS, filters, activityQueries, deduplicateActivities = true)=>{
            return (0, $cXq43.fetchActivitiesWithExperience)((experience)=>this.fetchActivitiesV3(experience, retryMS, filters, activityQueries, deduplicateActivities), 'v3');
        };
        this.clientHandlers = logger;
        this.hydratorConfigClient = new (0, $3LJ9C.default)({
            captureException: this.captureException,
            captureWarning: this.captureWarning
        }, product, configFetch);
    }
}
const $36bf5d2659940c95$var$setIconHydration = (object, hydratedData)=>{
    const isLiveDoc = object.data.__typename === 'ConfluencePage' && (0, $65vGW.hydratedValueToString)(hydratedData.subtype) === 'LIVE';
    if (isLiveDoc && (0, $VSDnB.fg)('platform_support_live_doc_icons_in_link_picker')) return (0, $65vGW.hydrateIcon)(hydratedData.icon, hydratedData.staticFallbacks, 'confluenceLiveDocIcon');
    return $36bf5d2659940c95$var$CONFLUENCE_COMMENT_TYPENAMES.includes(object.data.__typename) ? (0, $65vGW.hydrateConfluenceIcon)(object.data?.container?.__typename || object.data.__typename, hydratedData.icon, hydratedData.staticFallbacks) : (0, $65vGW.hydrateIcon)(hydratedData.icon, hydratedData.staticFallbacks);
};
function $36bf5d2659940c95$var$transformActivityItem(query, activities, hydrators, captureException) {
    return activities.reduce((acc, item)=>{
        if (item && item.node && item.node.object && item.node.event) {
            const { object: object, event: event } = item.node;
            if (!object.product || !object.type) return acc;
            const containers = [];
            let c = object.contributors || [];
            const contributors = c.reduce((contributors, contributor)=>{
                if (contributor.profile) {
                    const { accountId: accountId, picture: picture } = contributor.profile;
                    contributors.push({
                        accountId: accountId,
                        name: contributor.profile.name,
                        picture: picture
                    });
                }
                return contributors;
            }, []);
            const hydratedData = (0, $jkCM1.hydratePolymorphicData)(hydrators, object.data, captureException);
            if (hydratedData) {
                if (hydratedData.key) containers.push({
                    name: (0, $65vGW.hydratedValueToString)(hydratedData.key, ' ')
                });
                if (hydratedData.containers) containers.push({
                    name: (0, $65vGW.hydratedValueToString)(hydratedData.containers, ' ')
                });
                const actor = event.actor ? {
                    name: event.actor.name,
                    picture: event.actor.picture,
                    accountId: event.actor.accountId
                } : undefined;
                // The V3 API returns "Created" for a new comment, we want this to display as "Commented"
                const eventType = object.type === 'comment' && event.eventType === (0, $3l0ly.WORKED_EVENT).CREATED ? (0, $3l0ly.WORKED_EVENT).COMMENTED : event.eventType;
                acc.push({
                    actor: actor,
                    query: query,
                    containers: containers,
                    contributors: contributors,
                    eventType: eventType,
                    object: {
                        rootContainerIdentifier: (0, $hTLIi.parseRootContainerARI)(object.rootContainerId),
                        icon: $36bf5d2659940c95$var$setIconHydration(object, hydratedData),
                        id: object.id,
                        deduplicateId: (0, $65vGW.hydratedValueToString)(hydratedData.deduplicateId) || object.id,
                        localResourceId: (0, $65vGW.hydratedValueToString)(hydratedData.localResourceId),
                        name: (0, $65vGW.hydratedValueToString)(hydratedData.name, ' '),
                        product: object.product,
                        subProduct: object.subProduct,
                        type: object.type,
                        subtype: object.data.subtype,
                        url: (0, $65vGW.hydratedValueToString)(hydratedData.url),
                        objectTypeName: (0, $65vGW.hydratedValueToString)(hydratedData.objectTypeName)
                    },
                    timestamp: event.timestamp
                });
            }
        }
        return acc;
    }, []);
}

});
parcelRegister("dMJiM", function(module, exports) {

$parcel$export(module.exports, "GraphQLFragmentError", () => $37a211a3da9949b9$export$2d1b192199788179);
class $37a211a3da9949b9$export$2d1b192199788179 extends Error {
    constructor(message){
        super(message);
        this.name = 'GraphQLFragmentError';
        this.message = message;
    }
}

});

parcelRegister("4HxlV", function(module, exports) {

$parcel$export(module.exports, "GraphQLJSError", () => $098e0a3de69a420c$export$8d4af49ee2a0fbe2);
class $098e0a3de69a420c$export$8d4af49ee2a0fbe2 extends Error {
    constructor(graphQLError){
        super(graphQLError.message);
        this.name = 'GraphQLJSError';
        this.error = graphQLError;
        this.message = graphQLError.message;
    }
}

});

parcelRegister("fTeQf", function(module, exports) {

$parcel$export(module.exports, "GraphQLNoResultsError", () => $9ec383f2a327fd66$export$3f19ff30d409b70);
class $9ec383f2a327fd66$export$3f19ff30d409b70 extends Error {
    constructor(graphQLErrors){
        super();
        this.name = 'GraphQLNoResultsError';
        this.errors = graphQLErrors;
        this.message = 'GraphQL returned errors & no results';
        this.errorMessages = graphQLErrors.map((error)=>error.message);
    }
}

});

parcelRegister("jkCM1", function(module, exports) {

$parcel$export(module.exports, "hydratePolymorphicData", () => $d64b966f022ff0ad$export$d658049bf1a63492);

var $9XE6b = parcelRequire("9XE6b");

var $9cIED = parcelRequire("9cIED");
const $d64b966f022ff0ad$export$d658049bf1a63492 = (hydrators, data, captureException)=>{
    if (data) {
        if ('__typename' in data) {
            const hydrator = hydrators[data.__typename];
            if (hydrator) try {
                return $d64b966f022ff0ad$var$hydrateData(data, hydrator);
            } catch (error) {
                captureException && captureException(new (0, $9cIED.default)({
                    error: error,
                    message: `Hydrator failed for [${data.__typename}].`
                }));
            }
            else captureException && captureException(new (0, $9cIED.default)({
                message: `Missing hydrator for [${data.__typename}].`
            }));
        } else captureException && captureException(new (0, $9cIED.default)({
            message: `Missing [__typename] field from data.`
        }));
    }
    return null;
};
function $d64b966f022ff0ad$var$getOrSearch(object, path) {
    if (!object) return object;
    if (path.includes(':')) {
        const [searchField, searchValue] = path.split(':');
        return $d64b966f022ff0ad$var$findNodeByField(object, searchField.trim(), searchValue.trim().replace(/"/g, ''));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(object, path);
}
function $d64b966f022ff0ad$var$resolvePath(object, path) {
    // Split the path on each bracket
    const splitPath = path.split(/\(|\)./);
    // Traverse the split path as a tree, resolving as we go
    let current = object;
    for (const split of splitPath)current = $d64b966f022ff0ad$var$getOrSearch(current, split);
    return current;
}
function $d64b966f022ff0ad$var$findNodeByField(edges, fieldId, searchValue) {
    return edges.find((edge)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(edge, fieldId) === searchValue);
}
function $d64b966f022ff0ad$export$a5c4301012ad6f07(object, paths) {
    return paths.map((path)=>$d64b966f022ff0ad$var$resolvePath(object, path));
}
const $d64b966f022ff0ad$var$hydrateData = (data, hydrator)=>{
    const { hydratorPaths: hydratorPaths, staticFallbacks: staticFallbacks } = hydrator;
    return {
        staticFallbacks: staticFallbacks,
        ...Object.entries(hydratorPaths).reduce((acc, [key, dataValue])=>{
            const item = $d64b966f022ff0ad$export$a5c4301012ad6f07(data, dataValue);
            if (item) acc[key] = item;
            else throw new Error(`Bad hydrator path: ${key}`);
            return acc;
        }, {})
    };
};

});
parcelRegister("9cIED", function(module, exports) {

$parcel$export(module.exports, "default", () => $5eebec53575108e7$export$2e2bcd8739ae039);
class $5eebec53575108e7$export$2e2bcd8739ae039 extends Error {
    constructor({ error: error, message: message }){
        super();
        const err = error instanceof Error ? error : new Error();
        this.name = 'HydratorError';
        this.message = message;
        this.originalMessage = err.message;
        this.stack = err.stack;
        this.originalName = err.name;
    }
}

});


parcelRegister("65vGW", function(module, exports) {

$parcel$export(module.exports, "hydratedValueToString", () => $e885246460d7ca94$export$c5cea44a1f75b431);
$parcel$export(module.exports, "hydrateConfluenceIcon", () => $e885246460d7ca94$export$86b9f44277b105a6);
$parcel$export(module.exports, "hydrateIcon", () => $e885246460d7ca94$export$a328b2bb0d21d984);
const $e885246460d7ca94$export$c5cea44a1f75b431 = (value, separator = '')=>{
    if (!value) return null;
    return Array.isArray(value) ? value.join(separator) : value;
};
function $e885246460d7ca94$var$isURL(icon) {
    return typeof icon === 'string';
}
function $e885246460d7ca94$var$isValidEmoji(icon) {
    return typeof icon === 'object' && icon.value !== undefined && !!icon.value;
}
const $e885246460d7ca94$export$86b9f44277b105a6 = (confluenceContainerType, icons, fallbacks)=>{
    switch(confluenceContainerType){
        case 'ConfluenceBlogPost':
            return $e885246460d7ca94$export$a328b2bb0d21d984(icons, fallbacks, 'confluenceBlogIcon') || $e885246460d7ca94$export$a328b2bb0d21d984(icons, fallbacks);
        case 'ConfluencePage':
            return $e885246460d7ca94$export$a328b2bb0d21d984(icons, fallbacks, 'confluencePageIcon') || $e885246460d7ca94$export$a328b2bb0d21d984(icons, fallbacks);
        default:
            return $e885246460d7ca94$export$a328b2bb0d21d984(icons, fallbacks);
    }
};
const $e885246460d7ca94$export$a328b2bb0d21d984 = (icons, fallbacks, fallbackKey = 'icon')=>{
    if (Array.isArray(icons) && icons.length > 0) {
        const emojiIcons = icons.filter($e885246460d7ca94$var$isValidEmoji);
        if (emojiIcons.length > 0) return {
            type: 'EMOJI',
            value: emojiIcons[0].value,
            fallback: fallbacks?.[fallbackKey]
        };
        const urlIcons = icons.filter($e885246460d7ca94$var$isURL);
        if (urlIcons.length > 0) {
            const hydratedIcons = $e885246460d7ca94$export$c5cea44a1f75b431(urlIcons);
            if (hydratedIcons !== null) return {
                type: 'URL',
                value: hydratedIcons
            };
        }
    }
    if (fallbacks && fallbackKey in fallbacks && fallbacks[fallbackKey]) return {
        type: 'URL',
        value: fallbacks[fallbackKey]
    };
    return null;
};

});

parcelRegister("3LJ9C", function(module, exports) {

$parcel$export(module.exports, "FD_CLIENT_FETCH_PROPS", () => $974e1d856d308c8e$export$c270c412a04ff3e6);
$parcel$export(module.exports, "default", () => $974e1d856d308c8e$export$2e2bcd8739ae039);

var $6HV40 = parcelRequire("6HV40");

var $4Zo3D = parcelRequire("4Zo3D");
const $974e1d856d308c8e$var$RECENT_WORK_ARTIFACT = 'recent-work-service';
const $974e1d856d308c8e$var$FD_ENVIRONMENT = 'prod';
const $974e1d856d308c8e$export$c270c412a04ff3e6 = {
    name: $974e1d856d308c8e$var$RECENT_WORK_ARTIFACT,
    dimensions: {
        environmentType: $974e1d856d308c8e$var$FD_ENVIRONMENT
    }
};
class $974e1d856d308c8e$export$2e2bcd8739ae039 {
    constructor(handlers, product, artifactFetch){
        this.fetchConfig = async ()=>{
            const artifact = await this.fetchArtifact();
            const { queryFragments: fragments, hydrators: hydrators } = artifact;
            return {
                fragments: fragments,
                hydrators: hydrators
            };
        };
        this.flightDeck = new (0, $6HV40.default)(product || 'recent-work-client', {
            handlers: handlers
        }, [
            {
                name: 'recent-work-service',
                dimensions: {
                    environmentType: $974e1d856d308c8e$var$FD_ENVIRONMENT
                },
                value: (0, $4Zo3D.default)
            }
        ]);
        this.artifactFetch = artifactFetch;
    }
    async fetchArtifact() {
        if (this.artifactFetch) return this.artifactFetch();
        return this.flightDeck.fetchConfigFromFlightDeck($974e1d856d308c8e$export$c270c412a04ff3e6, // Retries are for the background refresh, so not too aggressive
        {
            intervalsMS: [
                100,
                500
            ]
        });
    }
}

});
parcelRegister("4Zo3D", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc65f19f715aa294$export$2e2bcd8739ae039);
var $cc65f19f715aa294$export$2e2bcd8739ae039 = {
    localization: {
        eventTypes: {
            commented: {
                absolute: 'You commented on {absoluteTime}',
                relative: 'You commented {relativeTime}',
                standalone: 'You commented',
                multiAbsolute: 'Commented on {absoluteTime}',
                multiRelative: 'Commented {relativeTime}',
                multiStandalone: 'Commented'
            },
            created: {
                absolute: 'You created on {absoluteTime}',
                relative: 'You created {relativeTime}',
                standalone: 'You created',
                multiAbsolute: 'Created on {absoluteTime}',
                multiRelative: 'Created {relativeTime}',
                multiStandalone: 'Created'
            },
            edited: {
                absolute: 'You edited on {absoluteTime}',
                relative: 'You edited {relativeTime}',
                standalone: 'You edited',
                multiAbsolute: 'Edited on {absoluteTime}',
                multiRelative: 'Edited {relativeTime}',
                multiStandalone: 'Edited'
            },
            published: {
                absolute: 'You published on {absoluteTime}',
                relative: 'You published {relativeTime}',
                standalone: 'You published',
                multiAbsolute: 'Published on {absoluteTime}',
                multiRelative: 'Published {relativeTime}',
                multiStandalone: 'Published'
            },
            updated: {
                absolute: 'You updated on {absoluteTime}',
                relative: 'You updated {relativeTime}',
                standalone: 'You updated',
                multiAbsolute: 'Updated on {absoluteTime}',
                multiRelative: 'Updated {relativeTime}',
                multiStandalone: 'Updated'
            },
            viewed: {
                absolute: 'You viewed on {absoluteTime}',
                relative: 'You viewed {relativeTime}',
                standalone: 'You viewed',
                multiAbsolute: 'Viewed on {absoluteTime}',
                multiRelative: 'Viewed {relativeTime}',
                multiStandalone: 'Viewed'
            }
        }
    },
    hydrators: {
        TownsquareGoal: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                key: [
                    'key'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                icon: [
                    'iconData'
                ]
            }
        },
        TownsquareProject: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                key: [
                    'key'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                icon: [
                    'iconData'
                ]
            }
        },
        TownsquareComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                key: [
                    'container.key'
                ],
                name: [
                    'container.name'
                ],
                url: [
                    'container.url'
                ],
                icon: [
                    'container.iconData'
                ],
                deduplicateId: [
                    'container.id'
                ]
            }
        },
        ConfluencePage: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'pageId'
                ],
                subtype: [
                    'subtype'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg',
                confluenceLiveDocIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/live-doc.svg'
            }
        },
        ConfluenceBlogPost: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'blogPostId'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg'
            }
        },
        ConfluenceComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'container.title'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'container.space.name'
                ],
                deduplicateId: [
                    'container.id'
                ]
            },
            staticFallbacks: {
                icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg',
                confluenceBlogIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg',
                confluencePageIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg'
            }
        },
        ConfluenceFooterComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'container.title'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'container.space.name'
                ],
                deduplicateId: [
                    'container.id'
                ]
            },
            staticFallbacks: {
                icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg',
                confluenceBlogIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg',
                confluencePageIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg'
            }
        },
        ConfluenceInlineComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'container.title'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'container.space.name'
                ],
                deduplicateId: [
                    'container.id'
                ]
            },
            staticFallbacks: {
                icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg',
                confluenceBlogIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg',
                confluencePageIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg'
            }
        },
        JiraIssue: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    'webUrl'
                ],
                containers: [
                    'fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                icon: [
                    'fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.xsmall'
                ],
                key: [
                    'key'
                ]
            }
        },
        JiraPlatformComment: {
            hydratorPaths: {
                id: [
                    'commentId'
                ],
                name: [
                    'issue.fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    'webUrl'
                ],
                containers: [
                    'issue.fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                icon: [
                    'issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.xsmall'
                ],
                key: [
                    'issue.key'
                ],
                deduplicateId: [
                    'issue.id'
                ]
            }
        },
        JiraServiceManagementComment: {
            hydratorPaths: {
                id: [
                    'commentId'
                ],
                name: [
                    'issue.fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    'webUrl'
                ],
                containers: [
                    'issue.fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                icon: [
                    'issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.xsmall'
                ],
                key: [
                    'issue.key'
                ],
                deduplicateId: [
                    'issue.id'
                ]
            }
        }
    },
    queryFragments: '\n\n  fragment townsquareGoal on TownsquareGoal {\n    id\n    key\n    name\n    url\n    iconData\n  }\n\n\n  fragment townsquareProject on TownsquareProject {\n    id\n    key\n    name\n    url\n    iconData\n  }\n\n\n  fragment townsquareComment on TownsquareComment {\n    id\n    url\n    container {\n      __typename\n      ...townsquareGoal\n      ...townsquareProject\n    }\n  }\n\n\n  fragment confluencePage on ConfluencePage {\n    id\n    title\n    pageId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceBlogPost on ConfluenceBlogPost {\n    id\n    title\n    blogPostId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceComment on ConfluenceComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n    }\n  }\n\n\n  fragment confluenceFooterComment on ConfluenceFooterComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n    }\n  }\n\n\n  fragment confluenceInlineComment on ConfluenceInlineComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n    }\n  }\n\n\nfragment jiraIssue on JiraIssue {\n  id\n  key\n  webUrl\n  fieldsById(ids: ["summary", "issuetype", "project"]) {\n    edges {\n      node {\n        __typename\n        fieldId\n        ...jiraSingleLineTextField\n        ...jiraIssueTypeField\n        ...jiraProjectField\n      }\n    }\n  }\n}\nfragment jiraSingleLineTextField on JiraSingleLineTextField {\n  text\n}\nfragment jiraIssueTypeField on JiraIssueTypeField {\n  issueType {\n    avatar {\n      xsmall\n    }\n  }\n}\nfragment jiraProjectField on JiraProjectField {\n  project {\n    name\n  }\n}\n\n\nfragment jiraPlatformComment on JiraPlatformComment {\n  commentId\n  webUrl\n  issue {\n    ...jiraIssue\n  }\n}\n\n\nfragment jiraServiceManagementComment on JiraServiceManagementComment {\n  commentId\n  webUrl\n  issue {\n    ...jiraIssue\n  }\n}\n\nfragment activityItemEdge on ActivityItemEdge {\n  cursor\n  node {\n    id\n    object {\n      id\n      type\n      product\n      subProduct\n      rootContainerId\n      contributors {\n        profile {\n          name\n          picture\n          accountId\n        }\n      }\n      data {\n        __typename\n\t...townsquareGoal\n\t...townsquareProject\n\t...townsquareComment\n\t...confluencePage\n\t...confluenceBlogPost\n\t...confluenceComment\n\t...confluenceFooterComment\n\t...confluenceInlineComment\n\t...jiraIssue\n\t...jiraPlatformComment\n\t...jiraServiceManagementComment\n      }\n    }\n    event {\n      id\n      timestamp\n      eventType\n      actor {\n        name\n        picture\n        accountId\n      }\n    }\n  }\n}\nfragment activityItemConnection on ActivityConnection {\n  edges {\n    ...activityItemEdge\n  }\n}\n\n'
};

});


parcelRegister("55Gxu", function(module, exports) {

$parcel$export(module.exports, "default", () => $33cd97b94b378eac$export$2e2bcd8739ae039);

var $fQ0JV = parcelRequire("fQ0JV");
const $33cd97b94b378eac$var$errorHandlerMap = new Map([
    [
        'ValidationError',
        (0, $fQ0JV.default)
    ]
]);
const $33cd97b94b378eac$var$graphQLErrorHandler = (err)=>{
    const errorHandler = $33cd97b94b378eac$var$errorHandlerMap.get(err.extensions.classification);
    if (typeof errorHandler === 'function') return errorHandler(err);
    return null;
};
var $33cd97b94b378eac$export$2e2bcd8739ae039 = $33cd97b94b378eac$var$graphQLErrorHandler;

});
parcelRegister("fQ0JV", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc94d91a337842e7$export$2e2bcd8739ae039);
/**
 * ^Validation error - look for validation errors from the start
 * .*?@ ' - look through everything up to the first instance of "@ '"
 * (\w+) - capture the first word, that's our invalid fragment
 */ const $cc94d91a337842e7$var$captureRegex = new RegExp(/^Validation error.*?@ '(\w+)/);
const $cc94d91a337842e7$var$validationErrorHandler = (graphQLError)=>{
    const invalidFragmentMatch = $cc94d91a337842e7$var$captureRegex.exec(graphQLError.message);
    if (Array.isArray(invalidFragmentMatch)) {
        const invalidFragment = invalidFragmentMatch[1];
        if (invalidFragment) return invalidFragment;
    }
    return null;
};
var $cc94d91a337842e7$export$2e2bcd8739ae039 = $cc94d91a337842e7$var$validationErrorHandler;

});


parcelRegister("66K4V", function(module, exports) {

$parcel$export(module.exports, "generateGraphQLRequest", () => $cf1fca899d4c9068$export$7489a6ef09862e48);

var $f3gfD = parcelRequire("f3gfD");

var $dcvAS = parcelRequire("dcvAS");
const $cf1fca899d4c9068$var$ACTIVITIES_LIMIT = 50;
const $cf1fca899d4c9068$var$WORKED_ON_QUERY = `
   workedOn(first: $first, filter: $filter) {
     ...activityItemConnection
   }
`;
const $cf1fca899d4c9068$var$VIEWED__QUERY = `
   viewed(first: $first, filter: $filter) {
     ...activityItemConnection
   }
`;
const $cf1fca899d4c9068$var$ALL__QUERY = `
    all(first: $first, filter: $filter) {
      ...activityItemConnection
    }
`;
const $cf1fca899d4c9068$var$activityQueryMap = new Map([
    [
        'workedOn',
        $cf1fca899d4c9068$var$WORKED_ON_QUERY
    ],
    [
        'viewed',
        $cf1fca899d4c9068$var$VIEWED__QUERY
    ],
    [
        'all',
        $cf1fca899d4c9068$var$ALL__QUERY
    ]
]);
const $cf1fca899d4c9068$var$getMyActivitiesQuery = (queries)=>`
      myActivity {
        ${queries.join('\n')}
      }
`;
const $cf1fca899d4c9068$var$getActivitiesQuery = (product, content, fragments, activityFilterType = 'ActivityFilter')=>`
    query ${(0, $f3gfD.getOperationName)(product)}($first: Int, $filter: ${activityFilterType}) {
      activity {
        ${content}
      }
    }
${fragments}
`;
const $cf1fca899d4c9068$export$855cd08371c65b8c = (product, filters, activityQueries, fragments)=>{
    /**
	 * If we are filtering by `actors` then we can't use the `myActivity` query.
	 */ if (Array.isArray(filters.actors)) {
        // you can't view `viewed` events for other accounts
        const filteredAccountQueries = activityQueries.filter((query)=>query !== 'viewed');
        return {
            query: $cf1fca899d4c9068$var$getActivitiesQuery(product, filteredAccountQueries.map((query)=>$cf1fca899d4c9068$var$activityQueryMap.get(query)).join('\n'), fragments, 'ActivityFilter'),
            queryFilters: (0, $dcvAS.ACTIVITY_FILTER_COLLECTION).v3.get('activities')(filters)
        };
    } else return {
        query: $cf1fca899d4c9068$var$getActivitiesQuery(product, $cf1fca899d4c9068$var$getMyActivitiesQuery(activityQueries.map((query)=>$cf1fca899d4c9068$var$activityQueryMap.get(query))), fragments, 'MyActivityFilter'),
        queryFilters: (0, $dcvAS.ACTIVITY_FILTER_COLLECTION).v3.get('myActivity')(filters)
    };
};
const $cf1fca899d4c9068$export$7489a6ef09862e48 = (product, filters, activityQueries, fragments)=>{
    const { limit: // we want to default limit if not applied
    limit = $cf1fca899d4c9068$var$ACTIVITIES_LIMIT, ...restFilters } = filters;
    const { query: query, queryFilters: queryFilters } = $cf1fca899d4c9068$export$855cd08371c65b8c(product, restFilters, activityQueries, fragments);
    return {
        operationName: (0, $f3gfD.getOperationName)(product),
        query: query,
        variables: {
            first: limit,
            filter: queryFilters
        }
    };
};

});

parcelRegister("hTLIi", function(module, exports) {

$parcel$export(module.exports, "rollupActivitiesData", () => $56093000e314999c$export$750d93207e30f59a);
$parcel$export(module.exports, "activityRoot", () => $56093000e314999c$export$ea55e8e0446efa94);
$parcel$export(module.exports, "parseRootContainerARI", () => $56093000e314999c$export$788e6013936a6bb4);
$parcel$export(module.exports, "filtersToMetadata", () => $56093000e314999c$export$e8f56bed6776c7ea);
$parcel$export(module.exports, "filterInvalidFragments", () => $56093000e314999c$export$e22863ec502608d2);
$parcel$export(module.exports, "isEmptyActivitiesWithErrorsResponse", () => $56093000e314999c$export$c939d6148e47244a);
function $56093000e314999c$export$750d93207e30f59a(activitiesData) {
    const { all: all, viewed: viewed, workedOn: workedOn } = activitiesData;
    return {
        all: $56093000e314999c$var$rollUpActivityItems(all),
        viewed: $56093000e314999c$var$rollUpActivityItems(viewed),
        workedOn: $56093000e314999c$var$rollUpActivityItems(workedOn)
    };
}
function $56093000e314999c$var$rollUpActivityItems(activityItems) {
    // https://stackoverflow.com/a/49460534
    // creates an ordered 'hashmap' containing unique ids in the same order that the activity items appear
    const latestActivityItemsObjectWithLatestTimestamp = activityItems.reduce((acc, activityItem)=>{
        const deduplicateId = activityItem.object.deduplicateId || activityItem.object.id;
        const existingItem = acc[deduplicateId];
        if (existingItem) {
            const aggregatedItems = existingItem.aggregatedActivityItems || [];
            if (Date.parse(existingItem.timestamp) < Date.parse(activityItem.timestamp)) {
                activityItem.aggregatedActivityItems = [
                    ...aggregatedItems,
                    existingItem
                ];
                // remove the current activity for that id so when we add the more recent activity it is in the order that it appears
                delete acc[deduplicateId];
                acc[deduplicateId] = activityItem;
            } else acc[deduplicateId].aggregatedActivityItems = [
                ...aggregatedItems,
                activityItem
            ];
        } else acc[deduplicateId] = activityItem;
        return acc;
    }, {});
    return Object.values(latestActivityItemsObjectWithLatestTimestamp);
}
const $56093000e314999c$export$213ba2e9f2d143b9 = (key)=>{
    return new RegExp(`fragment ${$56093000e314999c$var$fragmentName(key)} on ${$56093000e314999c$var$fragmentType(key)} ({(.|\\n)+?(?=fragment))`, 'gm');
};
const $56093000e314999c$var$fragmentName = (key)=>key.charAt(0).toLowerCase() + key.slice(1);
const $56093000e314999c$var$fragmentType = (key)=>key.charAt(0).toUpperCase() + key.slice(1);
const $56093000e314999c$export$ea55e8e0446efa94 = (activity)=>{
    if (activity.myActivity) return activity.myActivity;
    return activity;
};
const $56093000e314999c$var$SITE_ARI_PREFIX = 'ari:cloud:platform::site/';
const $56093000e314999c$var$containerMapTypes = new Map([
    [
        $56093000e314999c$var$SITE_ARI_PREFIX,
        'SITE'
    ]
]);
function $56093000e314999c$export$788e6013936a6bb4(rootContainerARI) {
    // the "ID" portion of the ARI begins after the first '/'
    const ariSplitIndex = rootContainerARI.indexOf('/');
    return {
        ari: rootContainerARI,
        id: rootContainerARI.slice(ariSplitIndex + 1),
        type: $56093000e314999c$var$containerMapTypes.get(rootContainerARI.slice(0, ariSplitIndex + 1)) || 'OTHER'
    };
}
function $56093000e314999c$export$e8f56bed6776c7ea(filters) {
    return {
        ...filters,
        // These have V high cardinality, so using a length
        actors: filters.actors?.length,
        containerIds: filters.containerIds?.length,
        // comma separated lists
        products: filters.products?.join(','),
        eventTypes: filters.eventTypes?.join(','),
        objectTypes: filters.objectTypes?.join(','),
        rootContainerIds: filters.rootContainerIds?.join(',')
    };
}
/**
 * These fragments are the core of our query, without them it will always fail,
 * so we shouldn't remove them. It is possible that removing other offending fragments
 * will fix the error in these core fragments. (e.g. Field conflict)
 */ const $56093000e314999c$var$RESTRICTED_FRAGMENTS = [
    'activity',
    'all',
    'myActivity',
    'workedOn',
    'viewed',
    'activityItemConnection',
    'activityItemEdge'
];
function $56093000e314999c$export$e22863ec502608d2(invalidFragments, allFragments) {
    return invalidFragments.filter((fragment)=>!$56093000e314999c$var$RESTRICTED_FRAGMENTS.includes(fragment)).reduce((acc, invalidFragment)=>{
        return acc.replace(new RegExp(`...${invalidFragment}\n`, 'g'), '').replace($56093000e314999c$export$213ba2e9f2d143b9(invalidFragment), '');
    }, allFragments);
}
const $56093000e314999c$var$IGNORED_ERROR_CLASSIFICATIONS = [
    'IncorrectAuthException'
];
function $56093000e314999c$export$c939d6148e47244a(response) {
    if (!response?.data || !Array.isArray(response.errors)) return false;
    const filteredAggErrors = response.errors.filter((e)=>!e.extensions.classification || !$56093000e314999c$var$IGNORED_ERROR_CLASSIFICATIONS.includes(e.extensions.classification));
    return filteredAggErrors.length > 0 && $56093000e314999c$export$884573c560ed3600(response.data);
}
function $56093000e314999c$export$884573c560ed3600(queryData) {
    return !queryData.activity || $56093000e314999c$export$ea55e8e0446efa94(queryData.activity).all?.edges?.length === 0 && $56093000e314999c$export$ea55e8e0446efa94(queryData.activity).workedOn?.edges?.length === 0 && queryData.activity?.myActivity?.viewed?.edges?.length === 0;
}

});



parcelRegister("hmhqC", function(module, exports) {

$parcel$export(module.exports, "default", () => $d673c2c7cb7fd227$export$2e2bcd8739ae039);

var $jbrzS = parcelRequire("jbrzS");

var $bCZuG = parcelRequire("bCZuG");
var $bCh6z = parcelRequire("bCh6z");
const $d673c2c7cb7fd227$var$ANALYTICS_IDENTIFIER = 'link-picker';
const $d673c2c7cb7fd227$var$JIRA_DASHBOARD_URL_PATTERN = new RegExp(/(.*)\/issues\/\?dashboard=(\d+)$/);
class $d673c2c7cb7fd227$export$2e2bcd8739ae039 {
    constructor(cloudId, scope, aggregatorUrl, analyticsIdentifier = $d673c2c7cb7fd227$var$ANALYTICS_IDENTIFIER, useConfluenceTypeInAri = false, cloudIds = []){
        switch(scope){
            case (0, $bCh6z.Scope).ConfluencePageBlog:
            case (0, $bCh6z.Scope).ConfluencePageBlogWhiteboard:
            case (0, $bCh6z.Scope).ConfluenceContentType:
            case (0, $bCh6z.Scope).JiraIssue:
            case (0, $bCh6z.Scope).JiraDashboard:
            case (0, $bCh6z.Scope).JiraIssueDashboardBoardProjectFilter:
            case (0, $bCh6z.Scope).TownsquareProject:
            case (0, $bCh6z.Scope).TownsquareGoal:
            case (0, $bCh6z.Scope).Loom:
                break;
            default:
                throw new Error(`Unsupported scope - ${scope}`);
        }
        this.scope = scope;
        this.cloudId = cloudId;
        this.cloudIds = cloudIds;
        this.analyticsIdentifier = analyticsIdentifier;
        this.useConfluenceTypeInAri = useConfluenceTypeInAri;
        const config = {
            cloudId: cloudId,
            aggregatorUrl: aggregatorUrl
        };
        this.client = (0, $bCZuG.createClient)(config);
    }
    getAriString(opt) {
        try {
            return new (0, $jbrzS.ResourceIdentifier)(opt).toString();
        } catch (e) {
            return '';
        }
    }
    confluencePageBlogResponseTransformer(response) {
        if (!response) return [];
        return response.results.map((item)=>{
            const result = {
                title: item.title,
                // The `item.url` is only the relative path so we need to prefix the `item.baseUrl`
                url: item.baseUrl + item.url,
                container: item.container.title,
                contentType: this.mapToContentType(item.content && item.content.type),
                updatedTimestamp: item.lastModified,
                objectId: this.cloudIds.length === 0 ? this.getAriString({
                    resourceOwner: 'confluence',
                    cloudId: this.cloudId,
                    resourceType: this.useConfluenceTypeInAri && item.content?.type || 'content',
                    resourceId: item.content && item.content.id
                }) : item.baseUrl + item.url
            };
            if (item.subtype) result.subtype = item.subtype;
            return result;
        });
    }
    getIconUrlFromAvatar(avatar) {
        if ('urls' in avatar) return avatar.urls['16x16'];
        else return avatar.url;
    }
    jiraResponseTransformer(response) {
        if (!response) return [];
        return response.results.map((item)=>{
            // The `item.url` here for Jira content is _usually_ absolute url, except for dashboard where the url is wrong
            // It respond with https://site/issues/?dashboard={dashboardId}, but the url needs to be
            // https://site/jira/dashboards/{dashboardId}
            const dashboardMatch = $d673c2c7cb7fd227$var$JIRA_DASHBOARD_URL_PATTERN.exec(item.url);
            const url = dashboardMatch ? `${dashboardMatch[1]}/jira/dashboards/${dashboardMatch[2]}` : item.url;
            return {
                title: item.name,
                url: url,
                container: 'container' in item.attributes && item.attributes.container && item.attributes.container.title || '',
                contentType: this.mapToContentType(item.attributes['@type'], 'issueTypeName' in item.attributes ? item.attributes.issueTypeName : undefined),
                updatedTimestamp: 'updated' in item.attributes ? item.attributes.updated : undefined,
                iconUrl: 'avatar' in item.attributes && item.attributes.avatar ? this.getIconUrlFromAvatar(item.attributes.avatar) : undefined,
                objectId: this.cloudIds.length === 0 ? this.getAriString({
                    resourceOwner: 'jira',
                    cloudId: this.cloudId,
                    resourceType: item.attributes['@type'],
                    resourceId: item.id
                }) : url
            };
        });
    }
    townsquareProjectResponseTransformer(response) {
        if (!response) return [];
        const townsquareResponseToQuickSearch = (item)=>{
            const { title: title, url: url, iconUrl: iconUrl } = item;
            return {
                title: title,
                url: // The `item.url` in Townsquare/Atlas response is absolute url
                url,
                iconUrl: iconUrl,
                // There isn't any container like attribute in the response
                container: '',
                contentType: this.mapToContentType('townsquareProject'),
                objectId: url
            };
        };
        return response.results.map(townsquareResponseToQuickSearch);
    }
    townsquareGoalResponseTransformer(response) {
        if (!response) return [];
        const townsquareResponseToQuickSearch = (item)=>{
            const { id: id, title: title, url: url, iconUrl: iconUrl } = item;
            return {
                title: title,
                url: // The `item.url` in Townsquare/Atlas response is absolute url
                url,
                iconUrl: iconUrl,
                // There isn't any container like attribute in the response
                container: '',
                contentType: this.mapToContentType('townsquareGoal'),
                objectId: id
            };
        };
        return response.results.map(townsquareResponseToQuickSearch);
    }
    LoomResponseTransformer(response) {
        if (!response) return [];
        return response.results.map((item)=>({
                title: item.name,
                url: item.url,
                container: item.workspaceName,
                contentType: this.mapToContentType('loom'),
                objectId: item.url,
                updatedTimestamp: item.activityDate || item.createdAt
            }));
    }
    mapToContentType(type, subType) {
        switch(type){
            case 'issue':
                switch(subType){
                    case 'Bug':
                        return 'jira.issue.bug';
                    case 'Story':
                        return 'jira.issue.story';
                    case 'Task':
                        return 'jira.issue.task';
                    case 'Epic':
                        return 'jira.issue.epic';
                    default:
                        return 'jira.issue';
                }
            case 'project':
                return 'jira.project';
            case 'board':
                return 'jira.board';
            case 'filter':
                return 'jira.filter';
            case 'dashboard':
                return 'jira.dashboard';
            case 'townsquareProject':
                return 'townsquare.project';
            case 'townsquareGoal':
                return 'townsquare.goal';
            case 'page':
                return 'confluence.page';
            case 'blogpost':
                return 'confluence.blogpost';
            case 'whiteboard':
                return 'confluence.whiteboard';
            case 'database':
                return 'confluence.database';
            case 'embed':
                return 'confluence.embed';
            case 'loom':
                return 'loom.video';
            default:
                return 'default';
        }
    }
    async quickSearch(query, limit) {
        const result = await this.client.search({
            query: query,
            scopes: [
                this.scope
            ],
            analytics: {
                identifier: this.analyticsIdentifier
            },
            resultLimit: limit,
            sites: this.cloudIds
        });
        if (this.scope === (0, $bCh6z.Scope).ConfluencePageBlog || this.scope === (0, $bCh6z.Scope).ConfluencePageBlogWhiteboard || this.scope === (0, $bCh6z.Scope).ConfluenceContentType) {
            const scopeResult = result.response.retrieveScope(this.scope);
            return this.confluencePageBlogResponseTransformer(scopeResult);
        } else if (this.scope === (0, $bCh6z.Scope).JiraIssue || this.scope === (0, $bCh6z.Scope).JiraIssueDashboardBoardProjectFilter) {
            const scopeResult = result.response.retrieveScope(this.scope);
            return this.jiraResponseTransformer(scopeResult);
        } else if (this.scope === (0, $bCh6z.Scope).TownsquareProject) {
            const scopeResult = result.response.retrieveScope(this.scope);
            return this.townsquareProjectResponseTransformer(scopeResult);
        } else if (this.scope === (0, $bCh6z.Scope).TownsquareGoal) {
            const scopeResult = result.response.retrieveScope(this.scope);
            return this.townsquareGoalResponseTransformer(scopeResult);
        } else if (this.scope === (0, $bCh6z.Scope).Loom) {
            const scopeResult = result.response.retrieveScope(this.scope);
            return this.LoomResponseTransformer(scopeResult);
        } else throw new Error(`Unsupported scope - ${this.scope}`);
    }
}

});
parcelRegister("jbrzS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3VFsf = parcelRequire("3VFsf");

var $aRXoY = parcelRequire("aRXoY");

$3VFsf.__exportStar((parcelRequire("8T6Ee")), module.exports);
/**
 * InvalidAriError - an error thrown if an invalid Ari is constructed
 */ class $df746fbe0ba5443e$var$InvalidAriError extends Error {
    /**
     * Construct an InvalidAriError given an error message
     *
     * @param {string} ariString - the ARI that failed to parse
     * @param {string|undefined} description - The error message
     */ constructor(ariString, description){
        super(`Invalid ari string: ${ariString}${description ? '. ' + description : ''}`);
        this.ariString = ariString;
        // Support correct inheritance in ES5
        Object.setPrototypeOf(this, $df746fbe0ba5443e$var$InvalidAriError.prototype);
    }
    /**
     * Construct an InvalidAriError given some constraint violations
     *
     * @param {string} ariString - the ARI that failed to parse
     * @param {ConstraintViolation<Object>[]} violations - The array of constraint errors
     */ static withConstraintViolations(ariString, violations) {
        return new $df746fbe0ba5443e$var$InvalidAriError(ariString, violations.map((v)=>v.toString()).join('\n'));
    }
}
module.exports.InvalidAriError = $df746fbe0ba5443e$var$InvalidAriError;
function $df746fbe0ba5443e$var$matchesSegment(value1, value2) {
    if (value1 === value2) return true;
    else if (value1 === undefined) return true;
    return false;
}
// constraints are based on draft of v2 spec https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0#AtlassianResourceIdentifierSpec(draft-2.0)-Syntax
const $df746fbe0ba5443e$var$basicCharConstraint = $aRXoY.pattern(/^[a-z][a-z.-]*$/);
/**
 * resourceType allows for capitalized letters to support Identity ARIs (`ari:cloud:identity::userGrant/<...>`)
 * It's a violation of the spec, but we still need to support that.
 * See https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0
 */ const $df746fbe0ba5443e$var$resourceTypeCharConstraints = $aRXoY.pattern(/^[a-z][a-z.-]*$/i);
const $df746fbe0ba5443e$var$resourceOwnerConstraints = [
    $aRXoY.lengthBetween(3, 255),
    $df746fbe0ba5443e$var$basicCharConstraint
];
const $df746fbe0ba5443e$var$resourceTypeConstraints = [
    $aRXoY.lengthBetween(3, 255),
    $df746fbe0ba5443e$var$resourceTypeCharConstraints
];
const $df746fbe0ba5443e$var$cloudIdConstraints = [
    $aRXoY.lengthBetween(3, 255)
];
const $df746fbe0ba5443e$var$siteResourceType = 'site';
const $df746fbe0ba5443e$var$resourceIdChars = /[\w-._~:@#]/.source;
const $df746fbe0ba5443e$var$resourceIdConstraints = [
    $aRXoY.pattern(new RegExp(`^${$df746fbe0ba5443e$var$resourceIdChars}+(/${$df746fbe0ba5443e$var$resourceIdChars}*)*(;v=${$df746fbe0ba5443e$var$resourceIdChars}*)*$`))
];
/**
 * Returns an Ari that is of the latest version of the Ari spec that we support. Any legacy formats
 * (like those for site wide ARIs) are upgraded to their latest form.
 */ function $df746fbe0ba5443e$var$upgrade(values) {
    const { resourceId: resourceId, resourceOwner: resourceOwner, cloudId: cloudId } = values;
    // note: The new ARI spec has not defined a format for system wide contexts so we exclude them from upgrade
    if (!resourceId && cloudId) return {
        resourceOwner: resourceOwner,
        resourceType: $df746fbe0ba5443e$var$siteResourceType,
        resourceId: cloudId
    };
    else return values;
}
class $df746fbe0ba5443e$var$ResourceIdentifier {
    get cloudId() {
        if (this.resourceType === $df746fbe0ba5443e$var$siteResourceType) return this.internalCloudId ? this.internalCloudId : this.resourceId;
        return this.internalCloudId;
    }
    /**
     * Create a new Ari
     *
     * Only the resourceOwner is a required field, any other field can be omitted.
     * Older format types are converted on creation
     *
     * @param {string} values.resourceOwner - the owner of this resource (e.g. hipchat, confluence or jira)
     * @param {string|undefined} values.cloudId - the cloud id for this identifier, defined in AID
     * @param {string|undefined} values.resourceType - the resource type this Ari is associated with (e.g. conversation in hipchat)
     * @param {string|undefined} values.resourceId - a resource identifier, if this is specified the associated resourceType *must* be provided.
     *
     * @throws {InvalidAriError} if the provided segments fail to pass validation
     */ constructor(values){
        const { resourceId: resourceId, resourceOwner: resourceOwner, resourceType: resourceType, cloudId: cloudId } = $df746fbe0ba5443e$var$upgrade(values);
        this.resourceOwner = resourceOwner;
        this.internalCloudId = cloudId;
        this.resourceType = resourceType;
        this.resourceId = resourceId;
        this.validate();
    }
    /**
    * Parse a string as an Ari
    *
    * @param {string} ariString - the string to parse
    * @returns {Ari} the parsed ari
    * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
    */ static parse(ariString) {
        if (!ariString) throw new $df746fbe0ba5443e$var$InvalidAriError(ariString);
        const match = ariString.match(/^ari:cloud:([^:/]+):([^:/]*):([^:/]*)\/(.*)$/);
        if (!match || match.length !== 5) throw new $df746fbe0ba5443e$var$InvalidAriError(ariString);
        const terms = match.map((a)=>a && a.length > 0 ? a : undefined);
        const resourceOwner = terms[1];
        if (!resourceOwner) throw new $df746fbe0ba5443e$var$InvalidAriError(ariString);
        return new $df746fbe0ba5443e$var$ResourceIdentifier({
            resourceOwner: resourceOwner,
            cloudId: terms[2],
            resourceType: terms[3],
            resourceId: terms[4]
        });
    }
    static parseEncoded(encodedAriString) {
        return $df746fbe0ba5443e$var$parse(decodeURIComponent(encodedAriString));
    }
    /**
     * Converts this Ari to a string.
     */ toString() {
        if (!this.ariString) {
            const resourceId = this.resourceType === $df746fbe0ba5443e$var$siteResourceType && this.internalCloudId ? this.internalCloudId : this.resourceId || '';
            const resourceType = this.resourceType || '';
            const sanitizedCloudId = this.resourceType === $df746fbe0ba5443e$var$siteResourceType ? '' : this.internalCloudId || '';
            this.ariString = `ari:cloud:${this.resourceOwner}:${sanitizedCloudId}:${resourceType}/${resourceId}`;
        }
        return this.ariString;
    }
    /**
     * Converts this object to its json representation
     */ toJSON() {
        return this.toString();
    }
    /**
     * Checks if this context is the same as another context
     *
     * @param {Ari} other - the other parameter to match with
     * @returns {boolean} - true if all segments of both Aris are equal, false otherwise
     */ equals(other) {
        return other instanceof $df746fbe0ba5443e$var$ResourceIdentifier && this.resourceOwner === other.resourceOwner && this.cloudId === other.cloudId && this.resourceType === other.resourceType && this.resourceId === other.resourceId;
    }
    /**
     * This method checks if the current context contains the other context.
     *
     * Note: it does that by transforming a site context  (e.g. `ari:cloud:<resource owner>:site/<cloud id>`)
     * if required to an "any" resource type context (e.g. `ari:cloud:<resource owner>:<cloud id>:/`)
     *
     * @param {Ari} other
     * @returns {boolean}
     */ contains(other) {
        return this.matches(new $df746fbe0ba5443e$var$ResourceIdentifier(other));
    }
    /**
     * Checks if this context is the same as or contains the provided context.
     *
     * Undefined segments in this ARI are treated as wildcards for matching purposes, but must exactly
     *  match if they are provided in the `other` Ari - i.e. this method is not commutative.
     *
     * e.g.
     * ```
     * parse('ari:cloud:hipchat::/').contains(parse('ari:cloud:hipchat:cloudid:conversation/blah')) === true
     * parse('ari:cloud:hipchat:cloudid:conversation/blah').contains(parse('ari:cloud:hipchat::/')) === false
     *
     * @param {Ari} other - the other parameter to match with
     * @returns {boolean} true if this Ari is the same as the other Ari, or matches the other Ari. False otherwise.
     */ matches(other) {
        return $df746fbe0ba5443e$var$matchesSegment(this.resourceOwner, other.resourceOwner) && $df746fbe0ba5443e$var$matchesSegment(this.cloudId, other.cloudId) && (this.resourceType === $df746fbe0ba5443e$var$siteResourceType && !!other.resourceType || $df746fbe0ba5443e$var$matchesSegment(this.resourceType, other.resourceType)) && (this.resourceType === $df746fbe0ba5443e$var$siteResourceType && !!other.resourceType || $df746fbe0ba5443e$var$matchesSegment(this.resourceId, other.resourceId));
    }
    validateSiteWide() {
        const { resourceType: resourceType, cloudId: cloudId } = this;
        if (resourceType === $df746fbe0ba5443e$var$siteResourceType && !cloudId) return new $aRXoY.GeneralValidationError('site wide ARIs must have a cloudId');
    }
    validate() {
        const constraintViolations = [
            $aRXoY.validateField(this, 'resourceOwner', $df746fbe0ba5443e$var$resourceOwnerConstraints),
            $aRXoY.validateField(this, 'resourceType', $df746fbe0ba5443e$var$resourceTypeConstraints),
            $aRXoY.validateField(this, 'resourceId', $df746fbe0ba5443e$var$resourceIdConstraints),
            $aRXoY.validateField(this, 'cloudId', $df746fbe0ba5443e$var$cloudIdConstraints),
            this.validateSiteWide()
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $df746fbe0ba5443e$var$InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
        if (this.resourceId !== undefined && this.resourceType === undefined) throw new $df746fbe0ba5443e$var$InvalidAriError(this.toString(), 'The resource type must be specified if the resource id is defined.');
    }
    urlEncode() {
        return encodeURIComponent(this.toString());
    }
    urlDecode() {
        return decodeURIComponent(this.toString());
    }
}
module.exports.ResourceIdentifier = $df746fbe0ba5443e$var$ResourceIdentifier;
/**
 * Parse a string as an Ari
 *
 * @param {string} ariString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $df746fbe0ba5443e$var$parse(ariString) {
    return $df746fbe0ba5443e$var$ResourceIdentifier.parse(ariString);
}
module.exports.parse = $df746fbe0ba5443e$var$parse;
/**
 * Parse a URL encoded string as an Ari
 *
 * @param {string} encodedAriString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $df746fbe0ba5443e$var$parseEncoded(encodedAriString) {
    return $df746fbe0ba5443e$var$ResourceIdentifier.parseEncoded(encodedAriString);
}
module.exports.parseEncoded = $df746fbe0ba5443e$var$parseEncoded;

});
parcelRegister("aRXoY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aB0SS = parcelRequire("aB0SS");
class $7e9cee950eba220a$var$LengthConstraint {
    constructor(min, max){
        this.min = min;
        this.max = max;
    }
    get description() {
        return `length must be between ${this.min} and ${this.max}`;
    }
    isValid(value) {
        return !value || value.length >= this.min && value.length <= this.max;
    }
}
module.exports.LengthConstraint = $7e9cee950eba220a$var$LengthConstraint;
class $7e9cee950eba220a$var$RegexConstraint {
    constructor(regex){
        this.regex = regex;
    }
    get description() {
        return `value must match regex ${this.regex.source}`;
    }
    isValid(value) {
        return !value || this.regex.test(value);
    }
}
module.exports.RegexConstraint = $7e9cee950eba220a$var$RegexConstraint;
class $7e9cee950eba220a$var$GeneralValidationError {
    constructor(error){
        this.error = error;
    }
    toString() {
        return this.error;
    }
}
module.exports.GeneralValidationError = $7e9cee950eba220a$var$GeneralValidationError;
class $7e9cee950eba220a$var$ConstraintViolation {
    constructor(fieldName, value, constraints){
        this.fieldName = fieldName;
        this.value = value;
        this.constraints = constraints;
    }
    toString() {
        const constraintSummary = this.constraints.map((c)=>`  - ${c.description}`).join('\n');
        return `'${this.value}' is not a valid value for ${this.fieldName} as it violates the following constraints:\n${constraintSummary}`;
    }
}
module.exports.ConstraintViolation = $7e9cee950eba220a$var$ConstraintViolation;
function $7e9cee950eba220a$var$lengthBetween(min, max) {
    return new $7e9cee950eba220a$var$LengthConstraint(min, max);
}
module.exports.lengthBetween = $7e9cee950eba220a$var$lengthBetween;
function $7e9cee950eba220a$var$pattern(regex) {
    return new $7e9cee950eba220a$var$RegexConstraint(regex);
}
module.exports.pattern = $7e9cee950eba220a$var$pattern;
function $7e9cee950eba220a$var$validateField(object, fieldName, constraints) {
    const value = object[fieldName];
    const violatedConstraints = constraints.map((c)=>{
        return c.isValid(value) ? undefined : c;
    }).filter($aB0SS.isDefined);
    return violatedConstraints.length > 0 ? new $7e9cee950eba220a$var$ConstraintViolation(fieldName, value, violatedConstraints) : undefined;
}
module.exports.validateField = $7e9cee950eba220a$var$validateField;

});
parcelRegister("aB0SS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hasValueAtKey = module.exports.hasPresentKey = module.exports.isFilled = module.exports.isDefined = module.exports.isPresent = void 0;
function $7b6e0ba147b061df$var$isPresent(t) {
    return t !== undefined && t !== null;
}
module.exports.isPresent = $7b6e0ba147b061df$var$isPresent;
function $7b6e0ba147b061df$var$isDefined(t) {
    return t !== undefined;
}
module.exports.isDefined = $7b6e0ba147b061df$var$isDefined;
function $7b6e0ba147b061df$var$isFilled(t) {
    return t !== null;
}
module.exports.isFilled = $7b6e0ba147b061df$var$isFilled;
/**
 * Returns a function that can be used to filter down objects
 * to the ones that have a defined non-null value under the key `k`.
 *
 * @example
 * ```ts
 * const filesWithUrl = files.filter(file => file.url);
 * files[0].url // In this case, TS might still treat this as undefined/null
 *
 * const filesWithUrl = files.filter(hasPresentKey("url"));
 * files[0].url // TS will know that this is present
 * ```
 *
 * See https://github.com/microsoft/TypeScript/issues/16069
 * why is that useful.
 */ function $7b6e0ba147b061df$var$hasPresentKey(k) {
    return function(a) {
        return a[k] !== undefined && a[k] !== null;
    };
}
module.exports.hasPresentKey = $7b6e0ba147b061df$var$hasPresentKey;
/**
 * Returns a function that can be used to filter down objects
 * to the ones that have a specific value V under a key `k`.
 *
 * @example
 * ```ts
 * type File = { type: "image", imageUrl: string } | { type: "pdf", pdfUrl: string };
 * const files: File[] = [];
 *
 * const imageFiles = files.filter(file => file.type === "image");
 * files[0].type // In this case, TS will still treat it  as `"image" | "pdf"`
 *
 * const filesWithUrl = files.filter(hasValueKey("type", "image" as const));
 * files[0].type // TS will now know that this is "image"
 * files[0].imageUrl // TS will know this is present, because already it excluded the other union members.
 *
 * Note: the cast `as const` is necessary, otherwise TS will only know that type is a string.
 * ```
 *
 * See https://github.com/microsoft/TypeScript/issues/16069
 * why is that useful.
 */ function $7b6e0ba147b061df$var$hasValueAtKey(k, v) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(a) {
        return a[k] === v;
    };
}
module.exports.hasValueAtKey = $7b6e0ba147b061df$var$hasValueAtKey;

});


parcelRegister("8T6Ee", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kQInL = parcelRequire("kQInL");
var $67889de6c03493da$var$AppFamilyAri;
(function(AppFamilyAri) {
    AppFamilyAri.resourceOwner = 'ecosystem';
    AppFamilyAri.appResourceType = 'app';
    AppFamilyAri.environmentResourceType = 'environment';
    AppFamilyAri.extensionGroupResourceType = 'extension-group';
    AppFamilyAri.extensionResourceType = 'extension';
    AppFamilyAri.appFamilyResourceTypes = [
        AppFamilyAri.appResourceType,
        AppFamilyAri.environmentResourceType,
        AppFamilyAri.extensionGroupResourceType,
        AppFamilyAri.extensionResourceType
    ];
})($67889de6c03493da$var$AppFamilyAri = module.exports.AppFamilyAri || (module.exports.AppFamilyAri = {}));
class $67889de6c03493da$var$AppFamilyAriError extends Error {
    constructor(message, cause){
        super(message);
        this.cause = cause;
    }
}
module.exports.AppFamilyAriError = $67889de6c03493da$var$AppFamilyAriError;
class $67889de6c03493da$var$NotAppFamilyAriError extends $67889de6c03493da$var$AppFamilyAriError {
    constructor(ari, reason){
        super(`ari is not a valid App family ari: ${ari.toString()} as ${reason}`);
        this.reason = reason;
    }
}
module.exports.NotAppFamilyAriError = $67889de6c03493da$var$NotAppFamilyAriError;
class $67889de6c03493da$var$NotExpectedAppFamilyAriTypeError extends $67889de6c03493da$var$AppFamilyAriError {
    constructor(type, ari, cause){
        super(`App family ari (${ari.toString()}) is not of expected type: ${type}`, cause);
        this.cause = cause;
    }
}
module.exports.NotExpectedAppFamilyAriTypeError = $67889de6c03493da$var$NotExpectedAppFamilyAriTypeError;
/**
 * throws NotAppFamilyAriError if not a valid app family ari
 */ function $67889de6c03493da$var$parseAppAri(ari) {
    return $kQInL.AppFamilyAriImpl.parse(ari);
}
module.exports.parseAppAri = $67889de6c03493da$var$parseAppAri;
function $67889de6c03493da$var$createAppAri(json) {
    return new $kQInL.AppFamilyAriImpl(json);
}
module.exports.createAppAri = $67889de6c03493da$var$createAppAri;

});
parcelRegister("kQInL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8T6Ee = parcelRequire("8T6Ee");

var $jbrzS = parcelRequire("jbrzS");

var $aRXoY = parcelRequire("aRXoY");
const $f2db175f2d527230$var$versionPrefix = ';v=';
const $f2db175f2d527230$var$uuidRegExpString = '[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}';
const $f2db175f2d527230$var$uuidConstraints = [
    $aRXoY.pattern(new RegExp(`^${$f2db175f2d527230$var$uuidRegExpString}$`, 'i'))
];
const $f2db175f2d527230$var$extensionGroupIdConstraints = [
    $aRXoY.pattern(new RegExp(`^(${$f2db175f2d527230$var$uuidRegExpString}|static)$`, 'i'))
];
class $f2db175f2d527230$var$AppFamilyAriImpl {
    constructor(json){
        this.json = json;
        this.validate();
    }
    get appId() {
        return this.json.appId;
    }
    get environmentId() {
        return this.json.environmentId;
    }
    get version() {
        return this.json.version;
    }
    get extensionGroupId() {
        return this.json.extensionGroupId;
    }
    get extensionKey() {
        return this.json.extensionKey;
    }
    toJSON() {
        return this.json;
    }
    static parse(ari) {
        const { resourceOwner: resourceOwner, resourceType: resourceType, resourceId: resourceId } = ari;
        if (resourceOwner !== $8T6Ee.AppFamilyAri.resourceOwner) throw new $8T6Ee.NotAppFamilyAriError(ari, `resourceOwner (${resourceOwner}) must be ${$8T6Ee.AppFamilyAri.resourceOwner}`);
        if (!resourceType || $8T6Ee.AppFamilyAri.appFamilyResourceTypes.indexOf(resourceType) < 0) throw new $8T6Ee.NotAppFamilyAriError(ari, `resourceType must be one of ${$8T6Ee.AppFamilyAri.appFamilyResourceTypes}`);
        if (!resourceId) throw new $8T6Ee.NotAppFamilyAriError(ari, 'resourceId is must be provided');
        const versionIndex = resourceId.indexOf($f2db175f2d527230$var$versionPrefix);
        if (versionIndex > 0 && resourceId.lastIndexOf($f2db175f2d527230$var$versionPrefix) > versionIndex) throw new $8T6Ee.NotAppFamilyAriError(ari, 'can only include one version suffix');
        const [mainResourceId, version] = resourceId.split($f2db175f2d527230$var$versionPrefix);
        const segments = mainResourceId.split('/').map($f2db175f2d527230$var$stripToUndefined);
        if (segments.length > 4) throw new $8T6Ee.NotAppFamilyAriError(ari, `no path segments can be added after extensionKey ${segments.slice(4)}`);
        const [appId, environmentId, providedExtensionGroupId, extensionKey] = segments;
        if (!appId) throw new $8T6Ee.NotAppFamilyAriError(ari, 'appId must be included');
        const extensionGroupId = providedExtensionGroupId || (resourceType === $8T6Ee.AppFamilyAri.extensionGroupResourceType || resourceType === $8T6Ee.AppFamilyAri.extensionResourceType ? 'static' : undefined);
        if (resourceType === $8T6Ee.AppFamilyAri.extensionResourceType && !(environmentId && providedExtensionGroupId && extensionKey)) throw new $8T6Ee.NotAppFamilyAriError(ari, `environmentId, extensionGroupId, extensionKey must all be provided for resourceType ${$8T6Ee.AppFamilyAri.extensionResourceType}`);
        else if (resourceType === $8T6Ee.AppFamilyAri.extensionGroupResourceType && (!(environmentId && extensionGroupId) || extensionKey)) throw new $8T6Ee.NotAppFamilyAriError(ari, `environmentId, extensionGroupId must all be provided for resourceType ${$8T6Ee.AppFamilyAri.extensionGroupResourceType}`);
        else if (resourceType === $8T6Ee.AppFamilyAri.environmentResourceType && (!environmentId || providedExtensionGroupId || extensionKey)) throw new $8T6Ee.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$8T6Ee.AppFamilyAri.environmentResourceType}`);
        else if (resourceType === $8T6Ee.AppFamilyAri.appResourceType && (environmentId || providedExtensionGroupId || extensionKey)) throw new $8T6Ee.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$8T6Ee.AppFamilyAri.environmentResourceType}`);
        return new $f2db175f2d527230$var$AppFamilyAriImpl({
            appId: appId,
            environmentId: environmentId,
            extensionGroupId: extensionGroupId,
            extensionKey: extensionKey,
            version: version
        });
    }
    asAppAri() {
        return this.returnIf(()=>this.isAppAri(), 'app');
    }
    asAppEnvironmentAri() {
        return this.returnIf(()=>this.isAppEnvironmentAri(), 'environment');
    }
    asExtensionGroupAri() {
        return this.returnIf(()=>this.isExtensionGroupAri(), 'extension-group');
    }
    asExtensionAri() {
        return this.returnIf(()=>this.isExtensionAri(), 'extension');
    }
    isAppAri() {
        return !this.isAtLeastAppEnvironmentAri;
    }
    isAppEnvironmentAri() {
        return this.isAtLeastAppEnvironmentAri && !this.isAtLeastExtensionGroupAri;
    }
    isExtensionGroupAri() {
        return this.isAtLeastExtensionGroupAri && !this.isExtensionAri();
    }
    isExtensionAri() {
        return this.isAtLeastExtensionGroupAri && this.extensionKey !== undefined;
    }
    returnIf(check, type) {
        if (!check()) throw new $8T6Ee.NotExpectedAppFamilyAriTypeError(type, this);
        return this; // :sadpanda:
    }
    get isAtLeastAppEnvironmentAri() {
        return this.environmentId !== undefined;
    }
    get isAtLeastExtensionGroupAri() {
        return this.isAtLeastAppEnvironmentAri && this.extensionGroupId !== undefined;
    }
    validate() {
        const constraintViolations = [
            $aRXoY.validateField(this, 'environmentId', $f2db175f2d527230$var$uuidConstraints),
            $aRXoY.validateField(this, 'appId', $f2db175f2d527230$var$uuidConstraints),
            $aRXoY.validateField(this, 'extensionGroupId', $f2db175f2d527230$var$extensionGroupIdConstraints)
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $jbrzS.InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
    }
    toAri() {
        const resourceOwner = $8T6Ee.AppFamilyAri.resourceOwner;
        const { appId: appId, environmentId: environmentId, extensionGroupId: extensionGroupId, extensionKey: extensionKey, version: version } = this.toJSON();
        function withVersion(segments) {
            const path = segments.join('/');
            if (!version) return path;
            else return `${path}${$f2db175f2d527230$var$versionPrefix}${version}`;
        }
        if (this.isExtensionAri()) return new $jbrzS.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $8T6Ee.AppFamilyAri.extensionResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId,
                extensionKey
            ])
        });
        else if (this.isExtensionGroupAri()) return new $jbrzS.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $8T6Ee.AppFamilyAri.extensionGroupResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId
            ])
        });
        else if (this.isAppEnvironmentAri()) return new $jbrzS.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $8T6Ee.AppFamilyAri.environmentResourceType,
            resourceId: withVersion([
                appId,
                environmentId
            ])
        });
        else return new $jbrzS.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $8T6Ee.AppFamilyAri.appResourceType,
            resourceId: appId
        });
    }
    toString() {
        return this.toAri().toString();
    }
}
module.exports.AppFamilyAriImpl = $f2db175f2d527230$var$AppFamilyAriImpl;
function $f2db175f2d527230$var$stripToUndefined(str) {
    if (!str) return undefined;
    const trimmed = str.trim();
    if (trimmed.length === 0) return undefined;
    return trimmed;
}

});



parcelRegister("bCZuG", function(module, exports) {

$parcel$export(module.exports, "createClient", () => $02a11d9a300d6cdf$export$5d730b7aed1a3eb0);

var $dS9cn = parcelRequire("dS9cn");

var $iDXmr = parcelRequire("iDXmr");
const $02a11d9a300d6cdf$var$MAX_SITES_INITIAL_QUERY = 3;
const $02a11d9a300d6cdf$var$limitToMaxSiteUsage = (sites = [])=>{
    return sites.slice(0, $02a11d9a300d6cdf$var$MAX_SITES_INITIAL_QUERY);
};
class $02a11d9a300d6cdf$var$AggregatorClient {
    static{
        this.QUICKSEARCH_API_URL = 'quicksearch/v1';
    }
    static{
        this.AUTO_CORRECT_API_URL = 'autocorrect';
    }
    constructor({ url: url, cloudId: cloudId, siteMasterList: siteMasterList }){
        this.makePostRequest = (path, body)=>{
            const options = {
                path: path,
                requestInit: {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(body)
                }
            };
            return (0, $dS9cn.utils).requestService(this.serviceConfig, options);
        };
        this.serviceConfig = {
            url: url
        };
        this.cloudId = cloudId;
        this.siteMasterList = siteMasterList;
    }
    async getAutoCorrection({ query: query }) {
        const cloudId = this.cloudId;
        // The language is hardcoded to 'en' as the backend does not support other languages
        // Also the frontend only auto corrects in English locale
        const body = {
            query: query,
            language: 'en',
            cloudId: cloudId
        };
        const response = await this.makePostRequest($02a11d9a300d6cdf$var$AggregatorClient.AUTO_CORRECT_API_URL, body);
        return response.fullCorrection;
    }
    async search({ query: query, context: context, scopes: scopes, modelParams: modelParams, resultLimit: resultLimit, filters: filters = [], experience: experience, sites: sites = [] }) {
        const cloudId = this.cloudId;
        const cloudIdsToFilterOn = sites.length > 0 ? sites : $02a11d9a300d6cdf$var$limitToMaxSiteUsage(this.siteMasterList).map((site)=>site.cloudId);
        const body = {
            query: query,
            cloudId: cloudId,
            limit: resultLimit,
            scopes: scopes,
            filters: filters,
            searchSession: context,
            ...modelParams.length > 0 ? {
                modelParams: modelParams
            } : {},
            experience: experience,
            cloudIds: cloudIdsToFilterOn
        };
        const { result: response, durationMs: requestDurationMs } = await (0, $iDXmr.timed)(this.makePostRequest($02a11d9a300d6cdf$var$AggregatorClient.QUICKSEARCH_API_URL, body));
        return {
            response: {
                rawData: response,
                retrieveScope: (scope)=>// @ts-expect-error TS2367: This comparison appears to be unintentional because the types 'Scope' and 'SingleScope' have no overlap
                    response.scopes.find((s)=>s.id === scope) || null
            },
            requestDurationMs: requestDurationMs
        };
    }
}
const $02a11d9a300d6cdf$export$5d730b7aed1a3eb0 = ({ cloudId: cloudId, aggregatorUrl: aggregatorUrl, aggregatorHostName: aggregatorHostName })=>{
    const aggregatorClient = new $02a11d9a300d6cdf$var$AggregatorClient({
        cloudId: cloudId,
        url: aggregatorUrl || `${aggregatorHostName || ''}/gateway/api/xpsearch-aggregator`,
        siteMasterList: []
    });
    async function getAutoCorrection({ query: query }) {
        return aggregatorClient.getAutoCorrection({
            query: query
        });
    }
    async function search({ query: query, scopes: scopes, resultLimit: resultLimit, analytics: analytics, sites: sites = [] }) {
        return aggregatorClient.search({
            query: query,
            context: {
                sessionId: analytics.sessionId ? analytics.sessionId : 'not-applicable',
                referrerId: null
            },
            scopes: scopes,
            modelParams: [],
            resultLimit: resultLimit,
            filters: [],
            experience: `external-${analytics.identifier}`,
            sites: sites
        });
    }
    return {
        search: search,
        getAutoCorrection: getAutoCorrection
    };
};

});
parcelRegister("iDXmr", function(module, exports) {

$parcel$export(module.exports, "timed", () => $25a965beaeacf82d$export$d35186a762cd39c8);
const $25a965beaeacf82d$export$d35186a762cd39c8 = async (promise)=>{
    const startTime = Date.now();
    const result = await promise;
    const duration = Date.now() - startTime;
    return {
        result: result,
        durationMs: duration
    };
};

});



parcelRegister("3ZomH", function(module, exports) {

$parcel$export(module.exports, "renderEmptyStateNoResults", () => $6a6ba10c9082addf$export$74b0c6644317c84d);
$parcel$export(module.exports, "getIconFromContentType", () => $6a6ba10c9082addf$export$d71678bb4eba5b81);
$parcel$export(module.exports, "getIconFromIconUrl", () => $6a6ba10c9082addf$export$fd251dec3e575ea1);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $iRZQl = parcelRequire("iRZQl");

var $iAkpb = parcelRequire("iAkpb");

var $gAdQO = parcelRequire("gAdQO");

var $kQSMP = parcelRequire("kQSMP");

var $4Atwu = parcelRequire("4Atwu");

var $liajA = parcelRequire("liajA");

var $kvhCa = parcelRequire("kvhCa");

var $ercGv = parcelRequire("ercGv");

var $letJZ = parcelRequire("letJZ");

var $VSDnB = parcelRequire("VSDnB");

var $kFr5w = parcelRequire("kFr5w");

var $3BIkw = parcelRequire("3BIkw");

var $eDPtC = parcelRequire("eDPtC");
var $6a6ba10c9082addf$var$LinkContentType = /*#__PURE__*/ function(LinkContentType) {
    LinkContentType[LinkContentType["jira.issue"] = 0] = "jira.issue";
    LinkContentType[LinkContentType["jira.issue.bug"] = 1] = "jira.issue.bug";
    LinkContentType[LinkContentType["jira.issue.story"] = 2] = "jira.issue.story";
    LinkContentType[LinkContentType["jira.issue.task"] = 3] = "jira.issue.task";
    LinkContentType[LinkContentType["jira.issue.epic"] = 4] = "jira.issue.epic";
    LinkContentType[LinkContentType["jira.dashboard"] = 5] = "jira.dashboard";
    LinkContentType[LinkContentType["jira.board"] = 6] = "jira.board";
    LinkContentType[LinkContentType["jira.project"] = 7] = "jira.project";
    LinkContentType[LinkContentType["jira.filter"] = 8] = "jira.filter";
    LinkContentType[LinkContentType["confluence.page"] = 9] = "confluence.page";
    LinkContentType[LinkContentType["confluence.blogpost"] = 10] = "confluence.blogpost";
    LinkContentType[LinkContentType["confluence.whiteboard"] = 11] = "confluence.whiteboard";
    LinkContentType[LinkContentType["loom.video"] = 12] = "loom.video";
    LinkContentType[LinkContentType["confluence.database"] = 13] = "confluence.database";
    LinkContentType[LinkContentType["confluence.embed"] = 14] = "confluence.embed";
    return LinkContentType;
}($6a6ba10c9082addf$var$LinkContentType || {});
const $6a6ba10c9082addf$export$74b0c6644317c84d = (product, action, cloudId, isMultisiteSearch)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3BIkw.EmptyStateNoResults), {
        product: product,
        action: action,
        cloudId: cloudId,
        isMultisiteSearch: isMultisiteSearch
    });
};
const $6a6ba10c9082addf$export$f642707b43bbbafc = (contentType)=>{
    return Boolean(contentType && Object.keys($6a6ba10c9082addf$var$LinkContentType).includes(contentType));
};
const $6a6ba10c9082addf$export$80e948449ec854a9 = {
    'jira.issue': {
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19539
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kQSMP.default), {
                label: alt
            }),
        iconAlt: (0, $eDPtC.messages).hyperlinkIconIssueLabel
    },
    'jira.issue.bug': {
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19539
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $iAkpb.default), {
                label: alt
            }),
        iconAlt: (0, $eDPtC.messages).hyperlinkIconBugLabel
    },
    'jira.issue.story': {
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19539
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kvhCa.default), {
                label: alt
            }),
        iconAlt: (0, $eDPtC.messages).hyperlinkIconStoryLabel
    },
    'jira.issue.task': {
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19539
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ercGv.default), {
                label: alt
            }),
        iconAlt: (0, $eDPtC.messages).hyperlinkIconTaskLabel
    },
    'jira.issue.epic': {
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19539
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $gAdQO.default), {
                label: alt
            }),
        iconAlt: (0, $eDPtC.messages).hyperlinkIconEpicLabel
    },
    'jira.dashboard': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $letJZ.JiraIcon), {
                label: alt,
                size: "xxsmall",
                appearance: "brand"
            }),
        iconAlt: (0, $eDPtC.messages).hyperlinkIconDashboardLabel
    },
    'jira.board': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $letJZ.JiraIcon), {
                label: alt,
                size: "xxsmall",
                appearance: "brand"
            }),
        iconAlt: (0, $eDPtC.messages).hyperlinkIconBoardLabel
    },
    'jira.project': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $letJZ.JiraIcon), {
                label: alt,
                size: "xxsmall",
                appearance: "brand"
            }),
        iconAlt: (0, $eDPtC.messages).hyperlinkIconProjectLabel
    },
    'jira.filter': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $letJZ.JiraIcon), {
                label: alt,
                size: "xxsmall",
                appearance: "brand"
            }),
        iconAlt: (0, $eDPtC.messages).hyperlinkIconFilterLabel
    },
    'confluence.page': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $liajA.default), {
                label: alt
            }),
        iconAlt: (0, $eDPtC.messages).hyperlinkIconPageLabel
    },
    'confluence.blogpost': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $iRZQl.default), {
                label: alt
            }),
        iconAlt: (0, $eDPtC.messages).hyperlinkIconBlogLabel
    },
    'confluence.whiteboard': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kFr5w.Whiteboard16Icon), {
                label: alt
            }),
        iconAlt: (0, $eDPtC.messages).hyperlinkIconWhiteboardLabel
    },
    'loom.video': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kFr5w.Loom16Icon), {
                label: alt
            }),
        iconAlt: (0, $eDPtC.messages).hyperlinkIconLoomLabel
    },
    'confluence.database': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kFr5w.Database16Icon), {
                label: alt
            }),
        iconAlt: (0, $eDPtC.messages).hyperlinkIconDatabaseLabel
    },
    'confluence.embed': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kFr5w.Embed16Icon), {
                label: alt
            }),
        iconAlt: (0, $eDPtC.messages).hyperlinkIconEmbedLabel
    }
};
const $6a6ba10c9082addf$export$d71678bb4eba5b81 = (contentType, subtype)=>{
    if (!$6a6ba10c9082addf$export$f642707b43bbbafc(contentType)) return {
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19539
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $liajA.default), {
                label: alt
            }),
        iconAlt: (0, $eDPtC.messages).defaultAltText
    };
    if (contentType === 'jira.issue' && (0, $VSDnB.fg)('confluence-issue-terminology-refresh')) return {
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19539
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kQSMP.default), {
                label: alt
            }),
        iconAlt: (0, $eDPtC.messages).hyperlinkIconIssueLabelIssueTermRefresh
    };
    if (contentType === 'confluence.page' && subtype === 'live' && (0, $VSDnB.fg)('platform_support_live_doc_icons_in_link_picker')) return {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $4Atwu.default), {
                label: alt
            }),
        iconAlt: (0, $eDPtC.messages).hyperlinkIconLiveDocLabel
    };
    return $6a6ba10c9082addf$export$80e948449ec854a9[contentType];
};
const $6a6ba10c9082addf$export$ac1fda7301622804 = (iconUrl)=>{
    let alt = (0, $eDPtC.messages).defaultAltText;
    // TODO add in extra cases for V3 api
    if (iconUrl.includes('story.svg')) alt = (0, $eDPtC.messages).story;
    if (iconUrl.includes('epic.svg')) alt = (0, $eDPtC.messages).epic;
    if (iconUrl.includes('avatarId=10318')) alt = (0, $eDPtC.messages).task;
    if (iconUrl.includes('avatarId=10303')) alt = (0, $eDPtC.messages).bug;
    if (iconUrl.includes('avatarId=10518')) alt = (0, $eDPtC.messages).subTask;
    if (iconUrl.includes('avatarId=10310')) alt = (0, $eDPtC.messages).improvement;
    return alt;
};
const $6a6ba10c9082addf$export$fd251dec3e575ea1 = (iconUrl)=>{
    return {
        icon: iconUrl,
        iconAlt: $6a6ba10c9082addf$export$ac1fda7301622804(iconUrl)
    };
};

});
parcelRegister("iRZQl", function(module, exports) {

$parcel$export(module.exports, "default", () => $24299d4e22463111$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::845767e81b63ae055da0ba81295847f0>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $2UiHO = parcelRequire("2UiHO");

var $VSDnB = parcelRequire("VSDnB");

var $hZgcq = parcelRequire("hZgcq");
/**
 * __16px `blog` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $24299d4e22463111$var$Blog16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2UiHO))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hZgcq.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hZgcq.default), {
        label: label,
        testId: testId
    });
};
$24299d4e22463111$var$Blog16Icon.displayName = 'Blog16Icon';
var $24299d4e22463111$export$2e2bcd8739ae039 = $24299d4e22463111$var$Blog16Icon;

});
parcelRegister("cwmS5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a921419639fe8f6f$export$2e2bcd8739ae039);
/* icon-tile.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");
const $a921419639fe8f6f$var$sizeMap = {
    '16': "_1bsb7vkz _4t3i7vkz",
    '24': "_1bsb1tcg _4t3i1tcg",
    '32': "_1bsbzwfg _4t3izwfg",
    '40': "_1bsb1ylp _4t3i1ylp",
    '48': "_1bsbckbl _4t3ickbl"
};
const $a921419639fe8f6f$var$appearanceMap = {
    grayBold: "_bfhk1t1b _syaz5w2r",
    limeBold: "_bfhktde4 _syaz5w2r",
    greenBold: "_bfhk1e5c _syaz5w2r",
    blueBold: "_bfhkc8cv _syaz5w2r",
    redBold: "_bfhkuibq _syaz5w2r",
    purpleBold: "_bfhkygwo _syaz5w2r",
    magentaBold: "_bfhkc3uk _syaz5w2r",
    tealBold: "_bfhk2c8p _syaz5w2r",
    orangeBold: "_bfhkjgng _syaz5w2r",
    yellowBold: "_bfhk1vop _syaz5w2r",
    gray: "_bfhk1v33 _syaz16ni",
    lime: "_bfhkz2ec _syaz8645",
    orange: "_bfhkf2vu _syaz7r97",
    magenta: "_bfhkv9ra _syazv8hk",
    green: "_bfhk1wnw _syaz17hp",
    blue: "_bfhk4v9p _syaz1ov1",
    red: "_bfhk1rtt _syaznbxb",
    purple: "_bfhk1jkz _syaz5yjc",
    teal: "_bfhk1a17 _syaz8uof",
    yellow: "_bfhk3fv2 _syaz1oqg"
};
const $a921419639fe8f6f$var$shapeMap = {
    square: "_2rkoiti9",
    circle: "_2rko14q2"
};
const $a921419639fe8f6f$var$iconTileStyles = null;
function $a921419639fe8f6f$export$2e2bcd8739ae039(props) {
    const { icon: Icon, label: label, appearance: appearance, size: size = '24', shape: shape = 'square', LEGACY_fallbackComponent: LEGACY_fallbackComponent, testId: testId } = props;
    const ExpandedIcon = Icon;
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (LEGACY_fallbackComponent && !(0, $VSDnB.fg)('platform-visual-refresh-icons')) return LEGACY_fallbackComponent;
    else return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1wybidpf",
            $a921419639fe8f6f$var$appearanceMap[appearance],
            $a921419639fe8f6f$var$sizeMap[size],
            $a921419639fe8f6f$var$shapeMap[shape]
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)(ExpandedIcon, {
            color: "currentColor",
            label: label,
            spacing: "spacious",
            shouldScale: true
        })
    });
}

});

parcelRegister("2UiHO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::295e96fa490818737b2d2c8ee4291bb5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $21df524c58bafc58$var$_react = $21df524c58bafc58$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $21df524c58bafc58$var$_baseNew = $21df524c58bafc58$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $21df524c58bafc58$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuotationMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: blockquote, comment, testimonial, blogs in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $21df524c58bafc58$var$QuotationMarkIcon = (props)=>/*#__PURE__*/ $21df524c58bafc58$var$_react.default.createElement($21df524c58bafc58$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5A2.5 2.5 0 0 0 5.5 10V9H2a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5zM9 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5a2.5 2.5 0 0 0 2.5-2.5V9H11a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$21df524c58bafc58$var$QuotationMarkIcon.displayName = 'QuotationMarkIcon';
var $21df524c58bafc58$var$_default = module.exports.default = $21df524c58bafc58$var$QuotationMarkIcon;

});

parcelRegister("hZgcq", function(module, exports) {

$parcel$export(module.exports, "default", () => $47749dc4aba4294e$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::387cb99b24103ef6908201cae0580f7c>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $47749dc4aba4294e$var$Blog16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M6.972 6.128a2.5 2.5 0 1 0-2.37 2.87q-.416.59-1.016 1.265a.916.916 0 0 0-.058 1.147.607.607 0 0 0 .948.043q2.908-3.331 2.496-5.325m7 0a2.5 2.5 0 1 0-2.37 2.87q-.416.59-1.016 1.265a.916.916 0 0 0-.058 1.147.607.607 0 0 0 .948.043q2.908-3.331 2.496-5.325M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$47749dc4aba4294e$var$Blog16Icon.displayName = 'Blog16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$47749dc4aba4294e$export$2e2bcd8739ae039 = $47749dc4aba4294e$var$Blog16Icon;

});


parcelRegister("iAkpb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $95722ca43be940d9$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::54f047f6f7bd48e9a2ba7394ee23b095>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $i6z47 = parcelRequire("i6z47");

var $VSDnB = parcelRequire("VSDnB");

var $dTB4u = parcelRequire("dTB4u");
/**
 * __16px `bug` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $95722ca43be940d9$var$Bug16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($i6z47))),
        appearance: "redBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dTB4u.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dTB4u.default), {
        label: label,
        testId: testId
    });
};
$95722ca43be940d9$var$Bug16Icon.displayName = 'Bug16Icon';
var $95722ca43be940d9$export$2e2bcd8739ae039 = $95722ca43be940d9$var$Bug16Icon;

});
parcelRegister("i6z47", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ab25c6896d727bd4806885f3b789ade9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d2e3fcca8ec2d82f$var$_react = $d2e3fcca8ec2d82f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d2e3fcca8ec2d82f$var$_baseNew = $d2e3fcca8ec2d82f$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $d2e3fcca8ec2d82f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Bug".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Request types in JSM, bugs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d2e3fcca8ec2d82f$var$BugIcon = (props)=>/*#__PURE__*/ $d2e3fcca8ec2d82f$var$_react.default.createElement($d2e3fcca8ec2d82f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 2.5A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 8 2.5m3 1.52V4a3 3 0 0 0-6 0v.02c-.29.05-.553.182-.761.372l-.887-.633-.917-2.064-1.37.61.944 2.125c.09.204.234.38.416.51l1.325.946V7H.5v1.5h3.25v1.149l-1.15.958a1.25 1.25 0 0 0-.318.401L1.08 13.415l1.342.67 1.18-2.36.46-.383A4.25 4.25 0 0 0 8.001 14h.249A4 4 0 0 0 12 11.393l.4.333 1.18 2.36 1.34-.671-1.202-2.407a1.25 1.25 0 0 0-.318-.401l-1.15-.958V8.5h3.25V7h-3.25V5.886l1.325-.946a1.25 1.25 0 0 0 .416-.51l.944-2.125-1.37-.61-.917 2.064-.887.633A1.5 1.5 0 0 0 11 4.02M10.75 10V5.5h-5.5v4.443l.035.226A2.75 2.75 0 0 0 8 12.5h.249a2.5 2.5 0 0 0 2.5-2.5" clip-rule="evenodd"/>`
    }, props));
$d2e3fcca8ec2d82f$var$BugIcon.displayName = 'BugIcon';
var $d2e3fcca8ec2d82f$var$_default = module.exports.default = $d2e3fcca8ec2d82f$var$BugIcon;

});

parcelRegister("dTB4u", function(module, exports) {

$parcel$export(module.exports, "default", () => $d35369c9d3f28a25$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::508e97af907f08dc14fc66e28b081e3b>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $d35369c9d3f28a25$var$Bug16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`,
        ...props,
        size: "small"
    });
$d35369c9d3f28a25$var$Bug16Icon.displayName = 'Bug16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d35369c9d3f28a25$export$2e2bcd8739ae039 = $d35369c9d3f28a25$var$Bug16Icon;

});


parcelRegister("gAdQO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $45d4358dfe9bfcd5$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5fec5072b15ea4111438ac6700ce61b6>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $5AZiN = parcelRequire("5AZiN");

var $VSDnB = parcelRequire("VSDnB");

var $37F19 = parcelRequire("37F19");
/**
 * __16px `epic` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $45d4358dfe9bfcd5$var$Epic16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5AZiN))),
        appearance: "purpleBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $37F19.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $37F19.default), {
        label: label,
        testId: testId
    });
};
$45d4358dfe9bfcd5$var$Epic16Icon.displayName = 'Epic16Icon';
var $45d4358dfe9bfcd5$export$2e2bcd8739ae039 = $45d4358dfe9bfcd5$var$Epic16Icon;

});
parcelRegister("5AZiN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::69c5703d29cce34dd1176fbc8fceb659>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $412fddddb485461d$var$_react = $412fddddb485461d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $412fddddb485461d$var$_baseNew = $412fddddb485461d$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $412fddddb485461d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Epic".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for epics in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $412fddddb485461d$var$EpicIcon = (props)=>/*#__PURE__*/ $412fddddb485461d$var$_react.default.createElement($412fddddb485461d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.271.05a.75.75 0 0 1 .479.7v4.635l3.147.63a.75.75 0 0 1 .407 1.24l-7.75 8.5a.75.75 0 0 1-1.304-.505v-4.635l-3.147-.63a.75.75 0 0 1-.407-1.24l7.75-8.5A.75.75 0 0 1 10.27.05M3.698 8.776l3.052.61v3.93l5.552-6.09-3.052-.61v-3.93z" clip-rule="evenodd"/>`
    }, props));
$412fddddb485461d$var$EpicIcon.displayName = 'EpicIcon';
var $412fddddb485461d$var$_default = module.exports.default = $412fddddb485461d$var$EpicIcon;

});

parcelRegister("37F19", function(module, exports) {

$parcel$export(module.exports, "default", () => $43bfed8f132140c5$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2cb559f656356bdb13b54acac6c1eee2>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $43bfed8f132140c5$var$Epic16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#6554c0" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m9.912 7.767A.5.5 0 0 0 12 7.5a.5.5 0 0 0-.5-.5H9V3.5a.495.495 0 0 0-.872-.327l-.002-.001-3.977 4.973-.008.009-.028.036.002.004A.5.5 0 0 0 4 8.5a.5.5 0 0 0 .5.5c.028 0 .051-.011.077-.016H7V12.5a.5.5 0 0 0 .5.5c.124 0 .234-.05.321-.124l.004.001.007-.009c.03-.027.051-.059.074-.092l3.934-4.913c.019-.018.031-.039.047-.06l.027-.033z"/></svg>`,
        ...props,
        size: "small"
    });
$43bfed8f132140c5$var$Epic16Icon.displayName = 'Epic16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$43bfed8f132140c5$export$2e2bcd8739ae039 = $43bfed8f132140c5$var$Epic16Icon;

});


parcelRegister("kQSMP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7ed36b810abfd088$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6546d4aeab39dc918bda403f727c61ae>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $lhPtH = parcelRequire("lhPtH");

var $VSDnB = parcelRequire("VSDnB");

var $8oSh9 = parcelRequire("8oSh9");
/**
 * __16px `issue` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $7ed36b810abfd088$var$Issue16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lhPtH))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8oSh9.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8oSh9.default), {
        label: label,
        testId: testId
    });
};
$7ed36b810abfd088$var$Issue16Icon.displayName = 'Issue16Icon';
var $7ed36b810abfd088$export$2e2bcd8739ae039 = $7ed36b810abfd088$var$Issue16Icon;

});
parcelRegister("lhPtH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::16b1a013266ea85d8875a6b5e1d2412a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f7f31df16698d05e$var$_react = $f7f31df16698d05e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f7f31df16698d05e$var$_baseNew = $f7f31df16698d05e$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $f7f31df16698d05e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItem".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f7f31df16698d05e$var$WorkItemIcon = (props)=>/*#__PURE__*/ $f7f31df16698d05e$var$_react.default.createElement($f7f31df16698d05e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 4a.5.5 0 0 0-.4-.49L14 3.5H2a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5zm-2.927 1.983-4 4.75a.75.75 0 0 1-1.146 0l-2-2.375 1.146-.966L7 9.085l3.427-4.068zM16 12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12l.204.01A2 2 0 0 1 16 4z"/>`
    }, props));
$f7f31df16698d05e$var$WorkItemIcon.displayName = 'WorkItemIcon';
var $f7f31df16698d05e$var$_default = module.exports.default = $f7f31df16698d05e$var$WorkItemIcon;

});

parcelRegister("8oSh9", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0610242619823e8$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a9a249fb572b3dfc8cacf8f2a204c85>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $d0610242619823e8$var$Issue16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1 4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm1 2v4h8V6z"/></svg>`,
        ...props,
        size: "small"
    });
$d0610242619823e8$var$Issue16Icon.displayName = 'Issue16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d0610242619823e8$export$2e2bcd8739ae039 = $d0610242619823e8$var$Issue16Icon;

});


parcelRegister("4Atwu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $67f5211f96bd858e$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c1228c9bdd9840505938b56c7ed44212>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $2OgES = parcelRequire("2OgES");

var $VSDnB = parcelRequire("VSDnB");

var $i0wCi = parcelRequire("i0wCi");
/**
 * __16px `page-live-doc` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $67f5211f96bd858e$var$PageLiveDoc16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2OgES))),
        appearance: "magentaBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i0wCi.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i0wCi.default), {
        label: label,
        testId: testId
    });
};
$67f5211f96bd858e$var$PageLiveDoc16Icon.displayName = 'PageLiveDoc16Icon';
var $67f5211f96bd858e$export$2e2bcd8739ae039 = $67f5211f96bd858e$var$PageLiveDoc16Icon;

});
parcelRegister("2OgES", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::692b62fec4c56cd82ae8d8d02e2d3f2e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $20bd2c4c7f421719$var$_react = $20bd2c4c7f421719$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $20bd2c4c7f421719$var$_baseNew = $20bd2c4c7f421719$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $20bd2c4c7f421719$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $20bd2c4c7f421719$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $20bd2c4c7f421719$var$_react.default.createElement($20bd2c4c7f421719$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$20bd2c4c7f421719$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $20bd2c4c7f421719$var$_default = module.exports.default = $20bd2c4c7f421719$var$PageLiveDocIcon;

});

parcelRegister("i0wCi", function(module, exports) {

$parcel$export(module.exports, "default", () => $e01b6db3f29618ed$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bbb561a99c36d24f949f1ade9ed1fa72>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $e01b6db3f29618ed$var$PageLiveDoc16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#cd519d" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.293 3.293A1 1 0 0 0 4 5h8a1 1 0 1 0 0-2H4a1 1 0 0 0-.707.293m0 4A1 1 0 0 0 4 9h2a1 1 0 0 0 0-2H4a1 1 0 0 0-.707.293m0 4A1 1 0 0 0 4 13h2a1 1 0 0 0 0-2H4a1 1 0 0 0-.707.293m6.703-4.161a1 1 0 0 0-1.466 1.11l1 4a1 1 0 0 0 1.94 0L11.78 11H13a1 1 0 0 0 .496-1.868z" clip-rule="evenodd"/></svg>`,
        ...props,
        size: "small"
    });
$e01b6db3f29618ed$var$PageLiveDoc16Icon.displayName = 'PageLiveDoc16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e01b6db3f29618ed$export$2e2bcd8739ae039 = $e01b6db3f29618ed$var$PageLiveDoc16Icon;

});


parcelRegister("liajA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c41b90368f925c6c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79077d9339ad2083a3901f522ad14f6b>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $kdfZa = parcelRequire("kdfZa");

var $VSDnB = parcelRequire("VSDnB");

var $kZjZ3 = parcelRequire("kZjZ3");
/**
 * __16px `page` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $c41b90368f925c6c$var$Page16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kdfZa))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kZjZ3.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kZjZ3.default), {
        label: label,
        testId: testId
    });
};
$c41b90368f925c6c$var$Page16Icon.displayName = 'Page16Icon';
var $c41b90368f925c6c$export$2e2bcd8739ae039 = $c41b90368f925c6c$var$Page16Icon;

});
parcelRegister("kZjZ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb586f8874bd1e95$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8396146cc2fa60842aed7101fb3015b2>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $fb586f8874bd1e95$var$Page16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z"/></svg>`,
        ...props,
        size: "small"
    });
$fb586f8874bd1e95$var$Page16Icon.displayName = 'Page16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fb586f8874bd1e95$export$2e2bcd8739ae039 = $fb586f8874bd1e95$var$Page16Icon;

});


parcelRegister("kvhCa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $58497e342f0afaee$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7dc9560f1e0ba735793d18700483c5f5>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $7Fct1 = parcelRequire("7Fct1");

var $VSDnB = parcelRequire("VSDnB");

var $fjoZ1 = parcelRequire("fjoZ1");
/**
 * __16px `story` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $58497e342f0afaee$var$Story16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7Fct1))),
        appearance: "greenBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fjoZ1.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fjoZ1.default), {
        label: label,
        testId: testId
    });
};
$58497e342f0afaee$var$Story16Icon.displayName = 'Story16Icon';
var $58497e342f0afaee$export$2e2bcd8739ae039 = $58497e342f0afaee$var$Story16Icon;

});
parcelRegister("7Fct1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::57b828e09f9287500323fc5bcdd6b33d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $594608750eb4424e$var$_react = $594608750eb4424e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $594608750eb4424e$var$_baseNew = $594608750eb4424e$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $594608750eb4424e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Story".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for story work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $594608750eb4424e$var$StoryIcon = (props)=>/*#__PURE__*/ $594608750eb4424e$var$_react.default.createElement($594608750eb4424e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11.518 3a.5.5 0 0 0-.5-.5H4.983a.5.5 0 0 0-.5.5v9.806L8 10.333l.431.304 3.087 2.169zm1.5 11.202a.776.776 0 0 1-1.122.694l-.099-.06L8 12.166l-3.796 2.67a.775.775 0 0 1-1.22-.634V3a2 2 0 0 1 2-2h6.035a2 2 0 0 1 2 2z"/>`
    }, props));
$594608750eb4424e$var$StoryIcon.displayName = 'StoryIcon';
var $594608750eb4424e$var$_default = module.exports.default = $594608750eb4424e$var$StoryIcon;

});

parcelRegister("fjoZ1", function(module, exports) {

$parcel$export(module.exports, "default", () => $d38a9d1e30071735$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9fd8d8228b7585fa76e9cb13da3baf72>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $d38a9d1e30071735$var$Story16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 11-2.863 1.822c-.42.38-1.137.111-1.137-.427v-8.19C4 3.54 4.596 3 5.333 3h5.334C11.403 3 12 3.539 12 4.206v8.19c0 .537-.719.806-1.139.426zm0-2.371 2 1.274V5H6v4.902z"/></svg>`,
        ...props,
        size: "small"
    });
$d38a9d1e30071735$var$Story16Icon.displayName = 'Story16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d38a9d1e30071735$export$2e2bcd8739ae039 = $d38a9d1e30071735$var$Story16Icon;

});


parcelRegister("ercGv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $95e8963209f4e129$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5cb120ef54d45ebd04018c195938778f>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $4xPlE = parcelRequire("4xPlE");

var $VSDnB = parcelRequire("VSDnB");

var $2BNVE = parcelRequire("2BNVE");
/**
 * __16px `task` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $95e8963209f4e129$var$Task16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4xPlE))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2BNVE.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2BNVE.default), {
        label: label,
        testId: testId
    });
};
$95e8963209f4e129$var$Task16Icon.displayName = 'Task16Icon';
var $95e8963209f4e129$export$2e2bcd8739ae039 = $95e8963209f4e129$var$Task16Icon;

});
parcelRegister("4xPlE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f1fa22b134d342ddb8339c9dc89d7524>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $34f2132ab88342e6$var$_react = $34f2132ab88342e6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $34f2132ab88342e6$var$_baseNew = $34f2132ab88342e6$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $34f2132ab88342e6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Task".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $34f2132ab88342e6$var$TaskIcon = (props)=>/*#__PURE__*/ $34f2132ab88342e6$var$_react.default.createElement($34f2132ab88342e6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm9.326 2.98-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308z" clip-rule="evenodd"/>`
    }, props));
$34f2132ab88342e6$var$TaskIcon.displayName = 'TaskIcon';
var $34f2132ab88342e6$var$_default = module.exports.default = $34f2132ab88342e6$var$TaskIcon;

});

parcelRegister("2BNVE", function(module, exports) {

$parcel$export(module.exports, "default", () => $95ed5bdbe4530df8$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::73d9ff981bcfc769f66de456322c40e3>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $95ed5bdbe4530df8$var$Task16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006zM4.667 3C3.747 3 3 3.746 3 4.667v6.666C3 12.253 3.746 13 4.667 13h6.666c.92 0 1.667-.746 1.667-1.667V4.667C13 3.747 12.254 3 11.333 3zM5 5v6h6V5z"/></svg>`,
        ...props,
        size: "small"
    });
$95ed5bdbe4530df8$var$Task16Icon.displayName = 'Task16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$95ed5bdbe4530df8$export$2e2bcd8739ae039 = $95ed5bdbe4530df8$var$Task16Icon;

});


parcelRegister("kFr5w", function(module, exports) {

$parcel$export(module.exports, "Whiteboard16Icon", () => $8747fb85a635a4da$export$3feee2bd05046f06);
$parcel$export(module.exports, "Loom16Icon", () => $8747fb85a635a4da$export$447c9c87a9a95e03);
$parcel$export(module.exports, "Database16Icon", () => $8747fb85a635a4da$export$edcbc8c5e08152a2);
$parcel$export(module.exports, "Embed16Icon", () => $8747fb85a635a4da$export$1777e190ef1e8c7e);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");

const $8747fb85a635a4da$export$3feee2bd05046f06 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
        ...props,
        glyph: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2ZM6.76162 3.41159C7.86083 2.11703 9.46511 1.64478 10.6195 2.27467C10.7705 2.35706 10.9977 2.49509 11.1722 2.71987C11.373 2.97851 11.4727 3.31107 11.409 3.68304C11.3524 4.01358 11.1765 4.31922 10.9546 4.60153C10.8863 4.68851 10.8097 4.77814 10.7246 4.87072C11.674 4.60241 12.5151 4.65073 13.1473 5.09225C13.9681 5.6655 14.1134 6.66452 13.9141 7.50611C13.8187 7.90918 13.4146 8.15858 13.0115 8.06316C12.6084 7.96774 12.359 7.56363 12.4545 7.16056C12.5709 6.6688 12.4237 6.41651 12.2884 6.32204C12.1286 6.21042 11.6364 6.05866 10.5554 6.52127C10.3091 6.62667 10.0224 6.63652 9.81961 6.62447C9.59851 6.61132 9.32166 6.56256 9.07282 6.44016C8.84101 6.32614 8.43506 6.03646 8.43173 5.48745C8.42884 5.01198 8.74599 4.65814 9.01233 4.43019C9.3922 4.10508 9.63128 3.85787 9.77522 3.67471C9.8072 3.63401 9.83276 3.59864 9.85315 3.56837C9.50001 3.41882 8.68015 3.4696 7.90504 4.38247C7.63694 4.69821 7.16364 4.73684 6.84789 4.46874C6.53215 4.20064 6.49352 3.72734 6.76162 3.41159ZM4.83333 9.41667C5.56971 9.41667 6.16667 8.81971 6.16667 8.08333C6.16667 7.34695 5.56971 6.75 4.83333 6.75C4.09695 6.75 3.5 7.34695 3.5 8.08333C3.5 8.81971 4.09695 9.41667 4.83333 9.41667ZM4.83333 10.9167C6.39814 10.9167 7.66667 9.64814 7.66667 8.08333C7.66667 6.51853 6.39814 5.25 4.83333 5.25C3.26853 5.25 2 6.51853 2 8.08333C2 9.64814 3.26853 10.9167 4.83333 10.9167ZM9.14834 8.88394C9.53883 8.2494 10.4612 8.2494 10.8517 8.88394L13.0621 12.4759C13.4721 13.1422 12.9928 14 12.2104 14H7.78956C7.00724 14 6.52789 13.1422 6.9379 12.4759L9.14834 8.88394ZM8.68435 12.5L10 10.3621L11.3157 12.5H8.68435Z",
                    fill: "#00A3BF"
                })
            }),
        size: "small"
    });
const $8747fb85a635a4da$export$447c9c87a9a95e03 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
        ...props,
        glyph: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    d: "M16 7.1H11.3L15.35 4.75L14.5 3.25L10.45 5.6L12.75 1.5L11.2 0.6L8.85 4.65V0H7.05V4.7L4.75 0.65L3.25 1.5L5.6 5.55L1.5 3.25L0.65 4.75L4.7 7.1H0V8.9H4.7L0.65 11.25L1.5 12.75L5.55 10.4L3.25 14.5L4.8 15.4L7.15 11.35V16H8.95V11.3L11.3 15.35L12.85 14.45L10.5 10.4L14.55 12.75L15.45 11.2L11.4 8.85H16V7.1ZM8 10.4C6.65 10.4 5.55 9.3 5.55 7.95C5.55 6.6 6.65 5.5 8 5.5C9.35 5.5 10.45 6.6 10.45 7.95C10.45 9.35 9.35 10.4 8 10.4Z",
                    fill: "#625DF5"
                })
            }),
        size: "small"
    });
const $8747fb85a635a4da$export$edcbc8c5e08152a2 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
        ...props,
        glyph: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2ZM3 4C3 3.44772 3.44772 3 4 3H5C5.55228 3 6 3.44772 6 4C6 4.55228 5.55228 5 5 5H4C3.44772 5 3 4.55228 3 4ZM4 7C3.44772 7 3 7.44772 3 8C3 8.55229 3.44772 9 4 9H5C5.55228 9 6 8.55229 6 8C6 7.44772 5.55228 7 5 7H4ZM3 12C3 11.4477 3.44772 11 4 11H5C5.55228 11 6 11.4477 6 12C6 12.5523 5.55228 13 5 13H4C3.44772 13 3 12.5523 3 12ZM8 3C7.44772 3 7 3.44772 7 4C7 4.55228 7.44772 5 8 5H12C12.5523 5 13 4.55228 13 4C13 3.44772 12.5523 3 12 3H8ZM7 8C7 7.44772 7.44772 7 8 7H12C12.5523 7 13 7.44772 13 8C13 8.55229 12.5523 9 12 9H8C7.44772 9 7 8.55229 7 8ZM8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13H12C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11H8Z",
                    fill: "#8270DB"
                })
            }),
        size: "small"
    });
const $8747fb85a635a4da$export$1777e190ef1e8c7e = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
        ...props,
        glyph: ()=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                        width: "16",
                        height: "16",
                        rx: "3",
                        fill: "#82B536"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M8.57067 3.638L7.946 4.25133C7.88196 4.31359 7.83105 4.38805 7.79628 4.47033C7.76152 4.5526 7.7436 4.64101 7.7436 4.73033C7.7436 4.81965 7.76152 4.90806 7.79628 4.99033C7.83105 5.07261 7.88196 5.14708 7.946 5.20933C8.0764 5.33666 8.25142 5.40795 8.43367 5.40795C8.61592 5.40795 8.79095 5.33666 8.92134 5.20933L9.57734 4.56533C10.222 3.932 11.272 3.80866 11.9787 4.37333C12.1677 4.52241 12.3227 4.71006 12.4334 4.92377C12.5442 5.13749 12.6081 5.37236 12.6209 5.61272C12.6337 5.85308 12.5951 6.09341 12.5077 6.31768C12.4203 6.54196 12.2861 6.74502 12.114 6.91333L10.1787 8.81466C9.84918 9.1362 9.40705 9.31618 8.94667 9.31618C8.48629 9.31618 8.04416 9.1362 7.71467 8.81466L6.97467 8.088L6 9.04666L6.73867 9.77266C7.95334 10.9647 9.94 10.9647 11.1533 9.77266L13.09 7.87133C13.3971 7.56973 13.6367 7.20631 13.7928 6.80515C13.9489 6.40399 14.018 5.97424 13.9955 5.54437C13.973 5.1145 13.8594 4.69431 13.6623 4.31164C13.4651 3.92897 13.189 3.59255 12.852 3.32466C11.59 2.31333 9.722 2.50733 8.57067 3.638Z",
                        fill: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M7.42934 13.0287L8.054 12.4153C8.11805 12.3531 8.16896 12.2786 8.20373 12.1963C8.23849 12.1141 8.2564 12.0256 8.2564 11.9363C8.2564 11.847 8.23849 11.7586 8.20373 11.6763C8.16896 11.5941 8.11805 11.5196 8.054 11.4573C7.92364 11.3302 7.74876 11.259 7.56667 11.259C7.38458 11.259 7.2097 11.3302 7.07934 11.4573L6.42267 12.1013C5.778 12.7347 4.728 12.858 4.02134 12.2933C3.83236 12.1443 3.67733 11.9566 3.56659 11.7429C3.45585 11.5292 3.39195 11.2943 3.37914 11.0539C3.36633 10.8136 3.40492 10.5733 3.49232 10.349C3.57972 10.1247 3.71393 9.92164 3.886 9.75333L5.82134 7.852C6.15083 7.53046 6.59296 7.35048 7.05334 7.35048C7.51371 7.35048 7.95585 7.53046 8.28534 7.852L9.02534 8.57866L10 7.62L9.26134 6.894C8.04667 5.702 6.06 5.702 4.84667 6.894L2.91 8.79533C2.60286 9.09693 2.36331 9.46035 2.20721 9.86151C2.05111 10.2627 1.98202 10.6924 2.00452 11.1223C2.02702 11.5522 2.1406 11.9724 2.33773 12.355C2.53487 12.7377 2.81105 13.0741 3.148 13.342C4.41 14.3533 6.278 14.1593 7.42934 13.0287Z",
                        fill: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
                    })
                ]
            }),
        size: "small"
    });

});

parcelRegister("3BIkw", function(module, exports) {

$parcel$export(module.exports, "EmptyStateNoResults", () => $5811bca1a7c19263$export$e661eeb828fb7b2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");

var $hTEpF = parcelRequire("hTEpF");

var $e4yMr = parcelRequire("e4yMr");

var $jgjqq = parcelRequire("jgjqq");

var $dE8RC = parcelRequire("dE8RC");

var $VSDnB = parcelRequire("VSDnB");

var $ilZnf = parcelRequire("ilZnf");

var $86c0g = parcelRequire("86c0g");
const $5811bca1a7c19263$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    noResults: {
        id: 'fabric.linkPickerAtlassianPlugin.emptyStateNoResults.heading',
        defaultMessage: 'Get started with {productName}.',
        description: 'Heading message shown when there are no results, but the search form is empty'
    },
    noResultsConfluenceDescription: {
        id: 'fabric.linkPickerAtlassianPlugin.emptyStateNoResults.confluenceDescription',
        defaultMessage: 'Recently viewed pages will appear once you <link>start using Confluence</link>.',
        description: 'Describes possible action when there are no results for Confluence, but search form is empty'
    },
    noResultsJiraDescription: {
        id: 'fabric.linkPickerAtlassianPlugin.emptyStateNoResults.jiraDescription',
        defaultMessage: 'Recently viewed issues will appear once you <link>start using Jira</link>.',
        description: 'Describes possible action when there are no results for Jira, but search form is empty'
    },
    noResultsJiraDescriptionIssueTerminologyRefreshM4: {
        id: 'fabric.linkPickerAtlassianPlugin.emptyStateNoResults.jiraDescription-issue-terminology-refresh-m4',
        defaultMessage: 'Recently viewed work items will appear once you <link>start using Jira</link>.',
        description: 'Describes possible action when there are no results for Jira, but search form is empty'
    },
    noResultsDefaultDescription: {
        id: 'fabric.linkPickerAtlassianPlugin.emptyStateNoResults.defaultDescription',
        defaultMessage: 'Recently viewed items will appear once you <link>start using {productName}</link>.',
        description: 'Describes possible action when there are no results for a given product, but search form is empty'
    },
    noResultsConfluenceCreateOption: {
        id: 'fabric.linkPickerAtlassianPlugin.emptyStateNoResults.description',
        defaultMessage: 'You can also create a new page.',
        description: 'Describes optional call to action of creating a page'
    }
});
const $5811bca1a7c19263$export$800daf5fbbe96aff = {
    emptyStateNoResults: 'link-picker-empty-state-no-results'
};
const $5811bca1a7c19263$var$emptyStateWrapperStyles = null;
const $5811bca1a7c19263$export$e661eeb828fb7b2 = ({ product: product, action: action, cloudId: cloudId, isMultisiteSearch: isMultisiteSearch })=>{
    const intl = (0, $koVbs.default)();
    const { data: data } = (0, $jgjqq.useAvailableSites)();
    const isConfluence = product === 'confluence'; // confluence has some special cases
    const productDetails = $5811bca1a7c19263$export$dc8a6c8f6bc81cdd(product);
    if (!productDetails) return null; // unsupported product
    // find the first matching site for this product
    const firstMatchingSite = data.find($5811bca1a7c19263$export$5e557b52f4095909(productDetails.availableSitesProduct, cloudId, isMultisiteSearch));
    if (firstMatchingSite) {
        let baseUrl = firstMatchingSite.url;
        // Confluence is a special case where the baseUrl is the same as Jira's, so we need to add the path
        if (isConfluence) baseUrl += '/wiki';
        const intlDescription = intl.formatMessage(productDetails.description, {
            productName: productDetails.productName,
            link: (str)=>(0, $VSDnB.fg)('platform-link-picker-remove-legacy-button') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e4yMr.default), {
                    href: baseUrl,
                    children: str
                }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
                    href: baseUrl,
                    children: str
                })
        });
        // Confluence is a special case because it has an optional "create", which we'll list as a call to action
        const intlConfCreate = isConfluence && (action || (0, $VSDnB.fg)('platform-linking-visual-refresh-link-picker')) ? intl.formatMessage($5811bca1a7c19263$export$defe85febe8b728c.noResultsConfluenceCreateOption) : '';
        return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            className: (0, $bwpsq.default)([
                "_otyrmgjw _clfdidpf _11pqidpf _q0a5idpf _c3k8idpf"
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hTEpF.default), {
                testId: $5811bca1a7c19263$export$800daf5fbbe96aff.emptyStateNoResults,
                header: intl.formatMessage($5811bca1a7c19263$export$defe85febe8b728c.noResults, {
                    productName: productDetails.productName
                }),
                description: /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
                    children: [
                        intlDescription,
                        " ",
                        intlConfCreate
                    ]
                }),
                renderImage: (0, $VSDnB.fg)('platform-linking-visual-refresh-link-picker') ? ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $86c0g.EmptyStateNoResultsSVGV2), {}) : ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ilZnf.EmptyStateNoResultsSVG), {})
            })
        });
    }
    return null;
};
const $5811bca1a7c19263$export$dc8a6c8f6bc81cdd = (product)=>{
    switch(product){
        case 'confluence':
            return {
                availableSitesProduct: (0, $dE8RC.AvailableSitesProductType).CONFLUENCE,
                productName: 'Confluence',
                description: $5811bca1a7c19263$export$defe85febe8b728c.noResultsConfluenceDescription
            };
        case 'jira':
            return {
                availableSitesProduct: (0, $dE8RC.AvailableSitesProductType).JIRA_SOFTWARE,
                productName: 'Jira',
                description: (0, $VSDnB.fg)('jira-issue-terminology-update-m4') ? $5811bca1a7c19263$export$defe85febe8b728c.noResultsJiraDescriptionIssueTerminologyRefreshM4 : $5811bca1a7c19263$export$defe85febe8b728c.noResultsJiraDescription
            };
        case 'atlas':
            return {
                availableSitesProduct: (0, $dE8RC.AvailableSitesProductType).ATLAS,
                productName: 'Atlas',
                description: $5811bca1a7c19263$export$defe85febe8b728c.noResultsDefaultDescription
            };
        default:
            return undefined;
    }
};
const $5811bca1a7c19263$export$5e557b52f4095909 = (availableSitesProduct, cloudId, isMultisiteSearch)=>{
    return (site)=>{
        // if the product doesn't match, this site doesn't match
        if (!site.products.includes(availableSitesProduct)) return false;
        // if the cloudId is undefined, this site matches (match everything)
        if (!cloudId) return true;
        // if we're mutlisite, match everything - this is probably a mistake,
        // but I'm not going to fix that here, and sticking to consistency with AtlassianLinkPickerPlugin.getRecentItems
        if (isMultisiteSearch) return true;
        // otherwise the site has to match the cloudId
        return site.cloudId === cloudId;
    };
};

});
parcelRegister("jgjqq", function(module, exports) {

$parcel$export(module.exports, "useAvailableSites", () => $4f70b2f9286d8c9f$export$3738ff0cbe469211);
$parcel$export(module.exports, "useAvailableSitesV2", () => $4f70b2f9286d8c9f$export$3f59b707a86875c4);

var $5uXOq = parcelRequire("5uXOq");

var $dE8RC = parcelRequire("dE8RC");

var $7PM1v = parcelRequire("7PM1v");


var $2NMNM = parcelRequire("2NMNM");

var $aLqqq = parcelRequire("aLqqq");

var $2rGGF = parcelRequire("2rGGF");
const $4f70b2f9286d8c9f$var$defaultProducts = [
    (0, $dE8RC.AvailableSitesProductType).WHITEBOARD,
    (0, $dE8RC.AvailableSitesProductType).BEACON,
    (0, $dE8RC.AvailableSitesProductType).COMPASS,
    (0, $dE8RC.AvailableSitesProductType).CONFLUENCE,
    (0, $dE8RC.AvailableSitesProductType).JIRA_BUSINESS,
    (0, $dE8RC.AvailableSitesProductType).JIRA_INCIDENT_MANAGER,
    (0, $dE8RC.AvailableSitesProductType).JIRA_PRODUCT_DISCOVERY,
    (0, $dE8RC.AvailableSitesProductType).JIRA_SERVICE_DESK,
    (0, $dE8RC.AvailableSitesProductType).JIRA_SOFTWARE,
    (0, $dE8RC.AvailableSitesProductType).MERCURY,
    (0, $dE8RC.AvailableSitesProductType).OPSGENIE,
    (0, $dE8RC.AvailableSitesProductType).STATUS_PAGE,
    (0, $dE8RC.AvailableSitesProductType).ATLAS,
    (0, $dE8RC.AvailableSitesProductType).LOOM
];
const $4f70b2f9286d8c9f$export$3738ff0cbe469211 = ({ gatewayBaseUrl: gatewayBaseUrl } = {})=>{
    const [state, setState] = (0, $5uXOq.useState)({
        data: [],
        loading: true
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        const fetchSites = async ()=>{
            try {
                const { sites: sites } = await $4f70b2f9286d8c9f$var$getAvailableSites({
                    products: $4f70b2f9286d8c9f$var$defaultProducts,
                    gatewayBaseUrl: gatewayBaseUrl
                });
                setState({
                    data: sites,
                    loading: false,
                    error: undefined
                });
            } catch (err) {
                createAnalyticsEvent((0, $7PM1v.default)('operational.getAvailableSitesResolve.failed', (0, $2rGGF.getOperationFailedAttributes)(err))).fire((0, $44fe84ed19a5b32b$export$85183a312807388d));
                const error = err instanceof Error ? err : new Error('unknown error');
                setState({
                    data: [],
                    loading: false,
                    error: error
                });
            }
        };
        fetchSites();
    }, [
        createAnalyticsEvent,
        gatewayBaseUrl
    ]);
    return state;
};
const $4f70b2f9286d8c9f$export$3f59b707a86875c4 = ({ gatewayBaseUrl: gatewayBaseUrl })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isMounted = (0, $aLqqq.useIsMounted)();
    const [state, setState] = (0, $5uXOq.useState)({
        data: [],
        loading: true
    });
    (0, $5uXOq.useEffect)(()=>{
        const fetchSites = async ()=>{
            try {
                const { sites: sites } = await $4f70b2f9286d8c9f$var$getAvailableSites({
                    products: $4f70b2f9286d8c9f$var$defaultProducts,
                    gatewayBaseUrl: gatewayBaseUrl
                });
                if (isMounted()) setState({
                    data: sites,
                    loading: false,
                    error: undefined
                });
            } catch (error) {
                if (isMounted()) setState({
                    data: [],
                    loading: false,
                    error: error
                });
            }
        };
        fetchSites();
    }, [
        createAnalyticsEvent,
        gatewayBaseUrl,
        isMounted
    ]);
    return state;
};
async function $4f70b2f9286d8c9f$var$getAvailableSites({ products: products, gatewayBaseUrl: gatewayBaseUrl }) {
    const requestConfig = {
        method: 'POST',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            products: products
        })
    };
    const response = await window.fetch(gatewayBaseUrl ? `${gatewayBaseUrl}/gateway/api/available-sites` : '/gateway/api/available-sites', requestConfig);
    if (response.ok) return response.json();
    throw response;
}

});
parcelRegister("dE8RC", function(module, exports) {

$parcel$export(module.exports, "AvailableSitesProductType", () => $cc5255ed5908c137$export$16bdf84263b17cf0);
var $cc5255ed5908c137$export$16bdf84263b17cf0 = /*#__PURE__*/ function(AvailableSitesProductType) {
    AvailableSitesProductType["WHITEBOARD"] = "atlassian-whiteboard";
    AvailableSitesProductType["BEACON"] = "beacon";
    AvailableSitesProductType["COMPASS"] = "compass";
    AvailableSitesProductType["CONFLUENCE"] = "confluence.ondemand";
    AvailableSitesProductType["JIRA_BUSINESS"] = "jira-core.ondemand";
    AvailableSitesProductType["JIRA_INCIDENT_MANAGER"] = "jira-incident-manager.ondemand";
    AvailableSitesProductType["JIRA_PRODUCT_DISCOVERY"] = "jira-product-discovery";
    AvailableSitesProductType["JIRA_SERVICE_DESK"] = "jira-servicedesk.ondemand";
    AvailableSitesProductType["JIRA_SOFTWARE"] = "jira-software.ondemand";
    AvailableSitesProductType["MERCURY"] = "mercury";
    AvailableSitesProductType["OPSGENIE"] = "opsgenie";
    AvailableSitesProductType["STATUS_PAGE"] = "statuspage";
    AvailableSitesProductType["ATLAS"] = "townsquare";
    AvailableSitesProductType["LOOM"] = "loom";
    return AvailableSitesProductType;
}({});

});

parcelRegister("7PM1v", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a8c7a52d7711c8d$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::6aeaf735bb1855a8d29ca67bd7a680b4>>
 * @codegenCommand yarn workspace @atlaskit/linking-common run codegen-analytics
 */ function $2a8c7a52d7711c8d$var$createEventPayload(eventKey, attributes) {
    const event = eventKey.split('.');
    return {
        eventType: event[0],
        actionSubject: event[1],
        action: event[2],
        actionSubjectId: event[3],
        attributes: attributes
    };
}
var $2a8c7a52d7711c8d$export$2e2bcd8739ae039 = $2a8c7a52d7711c8d$var$createEventPayload;

});

const $44fe84ed19a5b32b$export$85183a312807388d = 'media';
const $44fe84ed19a5b32b$export$60efea3f80310017 = 'wide';

parcelRegister("aLqqq", function(module, exports) {

$parcel$export(module.exports, "useIsMounted", () => $7a708a08bcc4bd39$export$80c2a3957bcb42ea);

var $5uXOq = parcelRequire("5uXOq");
function $7a708a08bcc4bd39$export$80c2a3957bcb42ea() {
    const isMounted = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return (0, $5uXOq.useCallback)(()=>isMounted.current, []);
}

});

parcelRegister("2rGGF", function(module, exports) {

$parcel$export(module.exports, "getOperationFailedAttributes", () => $e08352ec85f7239a$export$b2d107ab31565d0b);

var $5n8l4 = parcelRequire("5n8l4");
const $e08352ec85f7239a$var$getUrlPath = (url)=>{
    try {
        return new URL(url).pathname;
    } catch  {
        return 'Failed to parse pathname from url';
    }
};
const $e08352ec85f7239a$export$294520aca64d4e59 = (error)=>{
    if (error instanceof Response) return {
        traceId: (0, $5n8l4.getTraceId)(error),
        status: error.status,
        path: $e08352ec85f7239a$var$getUrlPath(error.url)
    };
    return {
        traceId: null,
        status: null,
        path: null
    };
};
const $e08352ec85f7239a$export$e19f9f08a6d79fd2 = (error)=>{
    if (error instanceof Response) return 'NetworkError';
    if (error instanceof Error) return error.name;
    return typeof error;
};
const $e08352ec85f7239a$export$b2d107ab31565d0b = (err)=>{
    if (err instanceof Response) return {
        error: 'NetworkError',
        errorType: 'NetworkError',
        ...$e08352ec85f7239a$export$294520aca64d4e59(err)
    };
    const error = err instanceof Error ? err : new Error('unknown error');
    return {
        error: error.name,
        errorType: error.name,
        traceId: null,
        status: null,
        path: null
    };
};

});
parcelRegister("5n8l4", function(module, exports) {

$parcel$export(module.exports, "getTraceId", () => $7e57d95ecb18182b$export$e88cb5bfb57ce9c4);
function $7e57d95ecb18182b$export$e88cb5bfb57ce9c4(response) {
    try {
        return response.headers.get('x-trace-id') ?? response.headers.get('atl-traceid') ?? null;
    } catch  {
        return null;
    }
}

});



parcelRegister("ilZnf", function(module, exports) {

$parcel$export(module.exports, "EmptyStateNoResultsSVG", () => $c31ef20caa88c9cf$export$88f98178b806da03);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $c31ef20caa88c9cf$var$noResultsSVGStyles = null;
const $c31ef20caa88c9cf$var$noResultsSVGStyles_handle = null;
const $c31ef20caa88c9cf$export$88f98178b806da03 = ()=>{
    const id = 'link-picker-ui-empty-state-no-results-svg';
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        height: "202",
        viewBox: "0 0 201 202",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, $bwpsq.default)([
            "_4t3i68cl _19pkidpf _2hwx1wug _otyr1ejb _18u01wug _1e0c1ule"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                clipPath: `url(#${id}-a)`,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                        width: "200.6",
                        height: "201.4",
                        transform: "translate(0 0.400391)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M126.8 141.901L117.3 132.501L130.4 119.301L139.9 128.701C142.319 131.083 145.375 132.716 148.7 133.401C152.017 134.165 155.061 135.826 157.5 138.201L196.1 176.301C198.905 179.083 200.5 182.859 200.537 186.81C200.575 190.76 199.052 194.566 196.3 197.401C193.505 200.193 189.721 201.769 185.771 201.788C181.82 201.807 178.022 200.266 175.2 197.501L136.6 159.401C134.176 156.984 132.478 153.935 131.7 150.601C130.98 147.273 129.272 144.241 126.8 141.901Z",
                        fill: "#CFD4DB"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M126.8 141.901L123.9 139.001C123.032 138.145 122.343 137.126 121.873 136.001C121.403 134.877 121.16 133.67 121.16 132.451C121.16 131.232 121.403 130.026 121.873 128.901C122.343 127.777 123.032 126.757 123.9 125.901C124.749 125.027 125.764 124.33 126.885 123.851C128.005 123.372 129.21 123.121 130.429 123.112C131.648 123.102 132.856 123.335 133.984 123.797C135.112 124.259 136.137 124.94 137 125.801L139.9 128.701C142.319 131.084 145.375 132.716 148.7 133.401C152.017 134.166 155.061 135.826 157.5 138.201L196.1 176.301C198.905 179.083 200.5 182.859 200.537 186.81C200.575 190.761 199.052 194.567 196.3 197.401C193.505 200.193 189.721 201.77 185.771 201.788C181.82 201.807 178.021 200.267 175.2 197.501L136.6 159.401C134.176 156.984 132.478 153.935 131.7 150.601C130.98 147.274 129.272 144.242 126.8 141.901Z",
                        fill: `url(#${id}-b)`
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("g", {
                        className: (0, $bwpsq.default)([
                            "_1o2w1n0t"
                        ]),
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            d: "M131.6 150.301C130.831 147.102 129.166 144.188 126.8 141.901L123.9 139.001C123.032 138.145 122.343 137.126 121.873 136.001C121.403 134.877 121.16 133.67 121.16 132.451C121.16 131.232 121.403 130.026 121.873 128.901C122.343 127.777 123.032 126.757 123.9 125.901C124.749 125.027 125.764 124.33 126.885 123.851C128.005 123.372 129.21 123.121 130.429 123.112C131.648 123.102 132.856 123.335 133.984 123.797C135.112 124.259 136.137 124.94 137 125.801L139.9 128.701C142.201 131.008 145.117 132.605 148.3 133.301C145.957 136.549 143.384 139.623 140.6 142.501C137.789 145.311 134.781 147.918 131.6 150.301Z",
                            fill: "#FFE380"
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M155.5 77.6001C155.377 62.2312 150.705 47.243 142.073 34.5266C133.441 21.8102 121.236 11.9354 106.998 6.14812C92.7594 0.360847 77.1261 -1.07958 62.0702 2.00857C47.0142 5.09673 33.2102 12.5751 22.3999 23.5001C15.2082 30.7469 9.52542 39.3483 5.68044 48.8062C1.83546 58.2642 -0.095298 68.3909 -5.8712e-05 78.6001C0.0416033 88.8071 2.10435 98.9048 6.06912 108.31C10.0339 117.716 15.8222 126.243 23.0999 133.4C34.0491 144.187 47.948 151.489 63.0429 154.385C78.1378 157.281 93.7522 155.641 107.916 149.671C122.08 143.702 134.158 133.671 142.626 120.844C151.095 108.018 155.575 92.9701 155.5 77.6001Z",
                        fill: "#0065FF"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M35.5999 36.5011C42.4408 29.5751 50.8841 24.443 60.1821 21.5593C69.48 18.6756 79.3456 18.1294 88.905 19.9689C98.4645 21.8084 107.423 25.9769 114.987 32.1052C122.55 38.2336 128.486 46.1326 132.268 55.1028C136.05 64.0729 137.562 73.8373 136.669 83.5311C135.776 93.2249 132.507 102.549 127.15 110.678C121.794 118.806 114.515 125.488 105.959 130.132C97.4035 134.776 87.8346 137.238 78.0999 137.301C66.4111 137.329 54.9748 133.902 45.2277 127.45C35.4807 120.999 27.8577 111.81 23.3165 101.04C18.7753 90.2691 17.5185 78.3966 19.704 66.9139C21.8894 55.4312 27.4197 44.8505 35.5999 36.5011Z",
                        fill: "#DEEBFF"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M40.2 33.3C34.2324 38.2795 29.3188 44.4 25.7471 51.303C22.1754 58.2059 20.0176 65.7524 19.4 73.5C18.0987 89.132 23.0546 104.641 33.1793 116.622C43.3041 128.603 57.7699 136.076 73.4 137.4C85.0685 138.416 96.7757 135.941 107.035 130.291C117.295 124.64 125.644 116.069 131.023 105.664C136.402 95.2598 138.568 83.4917 137.247 71.8538C135.925 60.216 131.175 49.2333 123.6 40.3C118.59 34.3552 112.456 29.4574 105.549 25.8872C98.6428 22.3169 91.0999 20.1444 83.3525 19.4942C75.6052 18.8439 67.8056 19.7287 60.4008 22.0977C52.9959 24.4668 46.1312 28.2736 40.2 33.3Z",
                        fill: "#B2D4FF"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M78.7001 26.7001C70.961 26.045 63.1687 26.9271 55.7718 29.2955C48.3749 31.6639 41.5195 35.4718 35.6001 40.5001C32.1218 43.4231 29.0002 46.746 26.3001 50.4001C21.631 59.038 19.1877 68.7031 19.1909 78.5222C19.1941 88.3412 21.6438 98.0047 26.3185 106.64C30.9932 115.274 37.7457 122.608 45.9659 127.979C54.186 133.35 63.6147 136.588 73.4001 137.4C81.1501 138.105 88.9628 137.256 96.3807 134.903C103.799 132.551 110.673 128.742 116.6 123.7C120.055 120.715 123.173 117.362 125.9 113.7C130.545 105.051 132.965 95.3828 132.944 85.5657C132.923 75.7485 130.461 66.0907 125.78 57.4617C121.098 48.8326 114.344 41.5033 106.126 36.1334C97.9076 30.7636 88.4828 27.5219 78.7001 26.7001Z",
                        fill: "#DEEBFF"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M77.7002 115.3L120.9 72.0996H92.1002L77.7002 115.3Z",
                        fill: "#0065FF"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M63.4001 72.0996L77.7001 115.3L92.1001 72.0996H63.4001Z",
                        fill: "#2684FF"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M34.6001 72.0996L77.7001 115.3L63.4001 72.0996H34.6001Z",
                        fill: "#B2D4FF"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M106.5 53.6992L92.1001 72.0992H120.9L106.5 53.6992Z",
                        fill: "#2684FF"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M77.7001 53.6992L63.4001 72.0992H92.1001L77.7001 53.6992Z",
                        fill: "#4C9AFF"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M63.4 72.0992L77.7 53.6992H49L63.4 72.0992Z",
                        fill: "#B2D4FF"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M92.1002 72.0992L106.5 53.6992H77.7002L92.1002 72.0992Z",
                        fill: "#0065FF"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M49.0001 53.6992L34.6001 72.0992H63.4001L49.0001 53.6992Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M49 64C49.5559 61.496 50.8086 59.2003 52.6134 57.3778C54.4182 55.5553 56.7016 54.2803 59.2001 53.7C56.6989 53.1611 54.4063 51.9121 52.5971 50.1029C50.7879 48.2938 49.539 46.0012 49 43.5C48.4384 45.9907 47.182 48.2711 45.3766 50.0766C43.5712 51.882 41.2908 53.1384 38.8 53.7C41.2933 54.2912 43.5709 55.5697 45.3739 57.3904C47.177 59.2112 48.4332 61.5011 49 64Z",
                        fill: "#4C9AFF"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M109.5 115.3C109.908 113.493 110.82 111.839 112.13 110.53C113.439 109.22 115.093 108.308 116.9 107.9C115.104 107.47 113.461 106.551 112.155 105.245C110.849 103.939 109.93 102.297 109.5 100.5C109.092 102.307 108.18 103.961 106.871 105.27C105.561 106.58 103.907 107.492 102.1 107.9C103.912 108.297 105.572 109.205 106.884 110.516C108.195 111.828 109.103 113.488 109.5 115.3Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: `${id}-b`,
                        x1: "200.56",
                        y1: "162.451",
                        x2: "121.18",
                        y2: "162.451",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#FF991F"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFC400"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("clipPath", {
                        id: `${id}-a`,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                            width: "200.6",
                            height: "201.4",
                            fill: "white",
                            transform: "translate(0 0.400391)"
                        })
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("86c0g", function(module, exports) {

$parcel$export(module.exports, "EmptyStateNoResultsSVGV2", () => $b6cf5bf48d4ac6b3$export$d36b20731cdf9213);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $b6cf5bf48d4ac6b3$var$noResultsSVGStyles = null;
const $b6cf5bf48d4ac6b3$export$d36b20731cdf9213 = ()=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 96 96",
        className: (0, $bwpsq.default)([
            "_1bsb16xz _4t3i16xz _19pkidpf _2hwx1wug _otyrpxbi _18u01wug _1e0c1ule"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fill: "#FCA700",
                d: "M74.189 55.386c.318-1.787.485-3.69.485-5.697a32.59 32.59 0 0 0-.496-5.774c-1.933-10.773-9.418-17.412-19.912-19.12-1.79-.29-3.669-.44-5.62-.44s-3.994.161-5.854.472c-10.5 1.752-17.971 8.375-19.909 19.088a32.362 32.362 0 0 0-.5 5.774c0 2.039.169 3.91.49 5.697 1.923 10.7 9.4 17.333 19.919 19.089 1.86.31 3.815.471 5.854.471s3.83-.15 5.62-.44c10.512-1.71 18.003-8.36 19.923-19.12Z"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fill: "#1868DB",
                d: "M40.02 77.477c-.248 6.944 3.225 9.59 8.598 9.59 5.044 0 8.434-2.646 8.434-9.59V69.54H40.02v7.938Z"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fill: "#101214",
                d: "M50.807 58.42c-.07.901-.133 1.802-.175 2.702 0 0-.035.29-.077.758a42.187 42.187 0 0 0-.146 1.808c-.088 1.404-.119 3.044-.021 3.98a81.585 81.585 0 0 0 .14 7.037s.062.734.174 1.571c.108.838.255 1.784.377 2.214.147.537.283.876.377.939.206.125.181-.862-.14-3.655.007-.035.007-.15.021-.164-.38-2.954-.248-5.83-.21-8.85-.052.039-.09-.063-.059-.157l.063.035c-.073-2.021.206-3.264.144-5.121 0 0 .066.216.066.22.122-1.571.314-3.292.576-5.052.136-.851.377-1.703.914-2.251.27-.276.615-.485.964-.562.349-.077.691-.014.97.188.283.2.507.53.618.901.056.185.087.377.087.566 0 .195-.024.397-.07.596-.184.8-.708 1.564-1.284 2.228a9.32 9.32 0 0 1-2.01 1.665c-.748.43-1.533.76-2.322.995h.035l-.01.014c.15-.032.44-.102.792-.192.335-.13.754-.245 1.113-.437.182-.09.367-.167.527-.258l.426-.255c.252-.143.395-.258.395-.258-.796.796-1.92 1.354-3.11 1.64-1.194.29-2.444.322-3.624.213l.024-.08c1.016.098 1.924-.042 2.273-.129-.9.105-2.05.112-3.257-.164-.597-.147-1.218-.328-1.805-.621-.147-.07-.293-.144-.443-.213l-.42-.262a4.987 4.987 0 0 1-.785-.573c-.474-.433-.88-.953-1.138-1.5a3.304 3.304 0 0 1-.258-.832 2.151 2.151 0 0 1 .038-.782c.143-.488.458-.88.866-1.078.402-.213.859-.266 1.257-.245-.038-.038-.31-.038-.594-.003-.279.038-.565.112-.715.084.74-.356 1.69-.283 2.426.059-.028.06-.143.035-.262-.007-.122-.031-.251-.077-.297-.08.144.073.754.223 1.362.83.286.3.586.751.803 1.285.22.541.373 1.184.454 1.896.083.712.097 1.487.09 2.307 0 .82-.017 1.672-.056 2.542a91.086 91.086 0 0 1-.373 5.257c-.339 3.453-.785 6.622-.992 8.486-.209 1.864-.195 2.416.213.618l.042.196c.308-1.875.559-3.428.946-5.373.025-.279.042-.31-.024-.317 0-.074-.004-.2-.038-.171-.168.007-.028-.597 0-.866.237.195.443-1.33.551-3.016.115-1.683.108-3.523.136-3.952.262-.157.077-1.69.185-2.206.007.038.063.268.07.3.042-.115.06-.684.042-1.435-.01-.747-.056-1.69-.196-2.541-.254-1.718-1.096-2.912-.436-1.97a4.525 4.525 0 0 0-.967-1.608 3.86 3.86 0 0 0-1.83-1.006 3.41 3.41 0 0 0-1.12-.094 2.874 2.874 0 0 0-1.155.321c-.37.196-.698.496-.936.859a2.7 2.7 0 0 0-.405 1.225c-.07.883.27 1.704.723 2.395.227.349.503.663.8.956.296.287.635.566.99.772l.531.325c.182.097.374.181.563.272.37.195.778.3 1.169.447.806.213 1.637.384 2.478.39l.315.015.314-.01.628-.029.622-.08.31-.042.308-.066.61-.136.597-.189.297-.094.29-.119.572-.24c1.487-.727 2.814-1.778 3.718-3.104.45-.657.828-1.407.911-2.245.087-.841-.188-1.71-.796-2.314-.303-.3-.712-.52-1.141-.59a2.392 2.392 0 0 0-1.232.129c-.744.283-1.32.845-1.673 1.46l.067-.06c-.056.073-.16.324-.217.37a7.214 7.214 0 0 0-.258 1.016c-.07.39-.119.81-.157 1.19l-.133 1.39-.003-.008Zm-4.675 3.376s-.014.01-.007.014c0-.014-.314-.063-.635-.108a8.793 8.793 0 0 1-.66-.154l.028-.077c.629.12 1.655.315 2.196.416.272.06.422.08.325.105-.098.028-.447.003-1.145-.105-.098.007-.091-.063-.105-.094l.003.003Zm-4.726-7.128c.213-.07.453-.126.719-.14a2.898 2.898 0 0 0-1.061.401c-.329.213-.597.52-.772.887-.373.733-.265 1.655.108 2.426.374.779.957 1.47 1.655 1.976.175.126.363.23.541.346l.272.167c.095.05.189.091.283.137.189.087.377.174.566.254.195.063.387.123.576.185-.573.018-1.47-.324-2.28-.872-.824-.566-1.435-1.418-1.735-2.053-.366-.6-.572-1.445-.342-2.217.119-.377.332-.712.593-.97.259-.266.587-.42.88-.52l-.003-.007ZM45.944 70.1l.042.01-.01.102s-.025-.014-.029-.035a.14.14 0 0 1-.003-.077Zm5.26-13.182c-.041-.223.147-1.022.179-.464-.05.133-.046.538-.178.464Zm-6.678-1.63c.039-.06.283.073.475.272.2.196.315.444.241.496a4.06 4.06 0 0 0-.715-.768Zm6.078 9.51c.133.286-.028.198-.122.29.025-.07.042-.326.108-.27l.014-.02Zm0 4.953c.074.07.122.349.13.482-.046.342-.19-.325-.13-.482Zm.527 8.14c.08 0 .13.193.056.256-.063-.014-.133-.245-.045-.287 0 0-.01.014-.01.032Zm-5.058-18.204c-.13-.133-.164-.433-.199-.761-.031-.328-.073-.685-.164-.915.126.024.202.265.244.552.042.286.046.61.084.799.014.136.025.24.032.321l.003.004Zm9.635-4.217c-.105.007-.119-.22-.182-.482-.056-.265-.185-.559-.296-.663l.07-.046c.279.374.44.674.408 1.173v.021-.003Zm-15.158.576c.014.097-.031.195-.066.303-.028.109-.08.217-.077.307-.028 0-.052-.052-.06-.125 0-.07.008-.164.025-.255.06-.171.14-.314.182-.234l-.004.004Zm5.254 5.264c.025.133-.394.017-.513-.01.09 0 .258-.05.36-.039.07.01.083.028.153.049Zm9.97-5.474a3.445 3.445 0 0 1-.363 1.18l-.07-.049c.182-.373.308-.76.35-1.152l.08.018.003.003Zm-2.203 3.327-.055-.063c.363-.464.558-.366.066.053l-.01.01Zm-.984-4.776c.042-.038.108-.1.147-.14.29-.264.276-.146.178-.02-.098.125-.248.3-.328.16h.003Zm-1.065 4.2c0 .087.014.206 0 .297-.08.607-.202-.091 0-.297ZM38.864 13.967l-.233-.314s-.112-.65-.392-.828l-.254-.946s-.189-.366-.353-.44a.488.488 0 0 0-.29-.041c-.17.038-.265.216-.073.565-.007.007-.014.028-.028.035.262.35.185.8.353 1.19.045-.02.09-.02.07 0l-.063.018c.216.223.08.457.373.628h-.09c.335.82.656 1.98 1.075 2.845l.007-.007h.01c.032-.104-.024-.537-.024-.537.401.195.216.646.342.96l-.08.024a.659.659 0 0 0-.179-.286c.07.534.405 1.536.699 1.969.055-.035-.13-.136.052-.241.045.122.119.234.154.35-.126.044-.105-.04-.133-.043-.066.248 1.229 4.336 1.42 3.184h.074c-.06-.258-.112-.471-.077-.775-.024-.032-.01-.042-.077-.018-.014-.006-.038-.017-.062 0-.157.06-.123-.041-.14-.076.506-.13-.237-.824-.258-.943.227-.105-.07-.223.003-.328.01 0 .073.014.084.014.13-.115-.646-.97-.255-.785.07-1.358-1.288-3.296-1.316-4.727l-.024.02s-.021-.038.01-.059c-.14-.094-.328-.401-.328-.401l.003-.007Zm.768 3.034s.014 0 .014-.004c-.024.01.05.168.046.178l-.077.028c-.21-.112.185-.684.084-.237.024.007-.042.028-.067.041v-.006Zm.514 1.462c0 .032.007.063.014.101-.381-.293-.259-.91-.52-1.288.397.018.334.423.376.608.144.153.123.398.13.576v.003Zm.81 2.465.041-.014v.014s-.02.007-.024.007c-.01 0-.018 0-.014-.007h-.004Zm-2.203-6.696c.073.007.073.123-.074.098.014-.024-.063-.056.074-.098Zm1.448 4.692c.13-.045.203.084.028.147-.02-.046-.024-.098-.028-.147Zm-1.951-5.68c-.15.01.007-.031.087-.073-.014.018-.01.052-.077.066l-.01.007Zm-.314-.621c-.07.014-.126-.007-.136-.024.035-.063.188-.018.136.024Zm-.391-1.068c-.077.024-.112.007-.039-.025.056-.017.112 0 .025.035 0 0 .01-.003.014-.01Zm2.611 8.11c-.237.041-.101-.151-.185-.196.23-.063.108.115.164.153a.229.229 0 0 0 .021.042Zm-1.445-4.235c-.2.073-.091-.126-.15-.157l.077-.028c.045.063.111.087.073.181v.004Zm.918 2.96c-.087 0-.032-.07-.042-.098.112-.038.171.07.038.098h.004Zm-.391-1.194c.119-.049.08.031.098.042-.028 0-.112 0-.115-.01 0-.011.01-.018.017-.032Zm-.433-1.742a1.4 1.4 0 0 1 .056.171l-.08.025a4.814 4.814 0 0 1-.056-.171l.08-.025Zm.077.6-.077.029c-.101-.056.094-.133.077-.028Zm-.423-1.284v.031c.05.112-.293.053 0-.031Zm-.29-.573s-.045-.014-.045-.028c-.02-.083.203-.062.046.028ZM51.327 14.843l-.007-.303s.28-.416.164-.67c.115-.22.237-.433.356-.65 0 0 .073-.304-.003-.44a.52.52 0 0 0-.196-.202c-.153-.087-.328-.053-.394.251-.01 0-.025.007-.042 0-.01.346-.335.541-.433.855.049.014.084.042.052.039l-.059-.028c.038.248-.206.3-.07.565l-.07-.052c-.206.65-.586 1.498-.694 2.238h.017c.08-.05.265-.332.265-.332.227.325-.164.492-.22.75l-.08-.024a.409.409 0 0 0 0-.262c-.223.356-.45 1.142-.412 1.55.063.004-.042-.143.164-.125-.02.097-.014.199-.038.29-.13-.032-.073-.074-.094-.088-.088.06-.356.89-.468 1.63-.112.74-.087 1.376.244 1.027l.067.028c.059-.196.104-.357.272-.538-.007-.031.007-.031-.06-.042a.093.093 0 0 0-.055-.028c-.164-.024-.091-.077-.091-.108.506.122.16-.628.199-.716.248.032.042-.174.157-.206.007.007.06.039.066.046.16-.014-.1-.894.15-.604.353-.405.482-1.047.632-1.704.147-.653.321-1.32.702-1.72h-.032s.008-.036.042-.029c-.059-.125-.041-.401-.041-.401l.01.003Zm-1.002 2.137.014.003c-.024-.007-.045.126-.052.13l-.08-.025c-.116-.175.506-.314.191-.101.018.014-.049-.004-.076-.01l.003.003Zm-.304 1.134c-.014.021-.024.042-.038.07-.185-.36.23-.68.203-1.033.32.206.07.415.01.551.045.161-.09.3-.178.412h.003Zm-.453 1.906.041.007v.01s-.028-.006-.03-.01c-.008 0-.015-.007-.011-.01v.003Zm1.522-5.093c.055.046-.01.112-.112.014.024-.007-.017-.066.112-.014Zm-1.243 3.498c.133.031.136.147-.049.105.007-.039.028-.07.049-.105ZM51.25 14.1c-.122-.08.025-.014.112.01-.021 0-.038.021-.098-.007h-.014V14.1Zm.115-.52c-.062-.035-.09-.08-.09-.095.063-.014.153.102.09.095Zm.332-.796c-.073-.035-.087-.063-.014-.035.052.028.084.07 0 .035h.014Zm-2.248 6.084c-.227-.08-.014-.14-.066-.21.23.064.034.123.07.172 0 .014-.004.024 0 .035l-.004.003Zm.946-3.288c-.2-.066-.004-.122-.035-.175l.077.028c0 .063.042.112-.042.143v.004Zm-.779 2.245c-.076-.042.01-.06.014-.08.116.027.112.125-.014.08Zm.276-.925c.126.03.053.059.06.076-.025-.017-.095-.056-.091-.066.003-.007.017-.003.031-.01Zm.566-1.254a.961.961 0 0 1-.046.13l-.076-.028c.014-.046.031-.088.045-.13l.077.028Zm-.262.388-.08-.025c-.056-.087.15-.028.08.025Zm.36-.97s-.018.013-.018.017c-.02.09-.265-.133.018-.018Zm.087-.486s-.028-.031-.021-.042c.031-.06.195.08.02.042ZM62.638 15.643l.17-.367s.528-.43.552-.768l.726-.708s.238-.353.227-.535a.489.489 0 0 0-.101-.279c-.115-.132-.321-.122-.541.224-.01 0-.028 0-.042-.007-.189.408-.628.572-.897.918.042.031.063.066.035.06l-.046-.046c-.097.303-.373.303-.384.649l-.042-.08c-.572.712-1.459 1.588-2.035 2.401h.01l.008.011c.108-.028.467-.293.467-.293.014.453-.474.52-.698.792l-.06-.056c.102-.111.165-.237.172-.303-.443.335-1.18 1.141-1.428 1.62.056.03.06-.182.237-.077-.087.1-.153.223-.237.314-.101-.087-.017-.112-.028-.14-.251.066-3.295 3.299-2.171 2.877l.035.066c.202-.185.37-.339.66-.464.017-.039.031-.032-.021-.077 0-.014-.004-.042-.028-.056-.126-.108-.021-.13 0-.164.36.38.621-.628.719-.709.202.147.167-.178.297-.164l.027.08c.165.056.559-1.064.584-.624 1.25-.632 2.335-2.821 3.606-3.575l-.028-.01s.028-.039.059-.021c.017-.172.203-.493.203-.493l-.008.004Zm-2.35 2.223s.007.011.01.011c-.02-.017-.125.13-.136.13l-.062-.057c0-.24.701-.185.254-.049.007.025-.045-.02-.07-.038l.004.003Zm-1.068 1.201a.653.653 0 0 0-.084.063c.08-.485.691-.694.904-1.117.175.36-.22.51-.363.646-.066.202-.3.314-.454.408h-.003Zm-1.815 1.973.031.028-.01.01s-.018-.017-.021-.024c-.004-.007-.007-.018 0-.018v.004Zm4.94-5.362c.03.07-.078.129-.123-.014.032 0 .021-.084.122.014Zm-3.51 3.676c.102.09.022.223-.118.097.032-.041.077-.07.119-.097Zm4.155-4.622c-.084-.126.032-.01.108.038-.02-.007-.052.018-.097-.035l-.01-.007v.004Zm.408-.594c-.045-.056-.052-.115-.041-.129.073 0 .104.157.041.13Zm.768-.89c-.059-.052-.059-.094.004-.045.042.042.056.097-.017.038 0 0 .01.007.013.007Zm-6.014 6.44c-.15-.188.087-.163.087-.265.168.172-.052.154-.06.224-.013.014-.02.028-.027.038v.004Zm3.1-3.434c-.161-.14.07-.143.07-.213l.062.056c-.035.073-.024.143-.129.157h-.003Zm-2.214 2.321c-.041-.077.05-.063.067-.084.087.08.017.189-.07.084h.003Zm.887-.953c.101.08.01.087.01.108-.01-.028-.055-.097-.045-.108.007-.007.021 0 .035 0Zm1.351-1.27c-.038.045-.084.094-.126.14l-.059-.057c.042-.045.084-.094.126-.136l.059.056v-.004Zm-.5.37-.062-.056c0-.12.164.014.063.052v.003Zm.947-1.027s-.025.01-.028.018c-.077.1-.185-.23.028-.018Zm.373-.548s-.007-.045 0-.056c.067-.06.15.147 0 .056Z"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fill: "#09326C",
                d: "M40.02 69.542v4.336a31.13 31.13 0 0 0 2.771.597c1.861.31 3.816.471 5.855.471 2.038 0 3.83-.15 5.62-.44a30.493 30.493 0 0 0 2.786-.586v-4.378H40.02Z"
            })
        ]
    });
};

});


parcelRegister("eDPtC", function(module, exports) {

$parcel$export(module.exports, "messages", () => $37f91689b35d8472$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $37f91689b35d8472$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    hyperlinkIconIssueLabel: {
        id: 'fabric.linkPicker.headingLink.hyperlinkIconIssueLabel',
        defaultMessage: 'Issue',
        description: 'icon label for a jira issue'
    },
    hyperlinkIconBugLabel: {
        id: 'fabric.linkPicker.headingLink.hyperlinkIconBugLabel',
        defaultMessage: 'Bug',
        description: 'icon label for a jira bug'
    },
    hyperlinkIconStoryLabel: {
        id: 'fabric.linkPicker.headingLink.hyperlinkIconStoryLabel',
        defaultMessage: 'Story',
        description: 'icon label for a jira story'
    },
    hyperlinkIconTaskLabel: {
        id: 'fabric.linkPicker.headingLink.hyperlinkIconTaskLabel',
        defaultMessage: 'Task',
        description: 'icon label for a jira task'
    },
    hyperlinkIconEpicLabel: {
        id: 'fabric.linkPicker.headingLink.hyperlinkIconEpicLabel',
        defaultMessage: 'Epic',
        description: 'icon label for a jira epic'
    },
    hyperlinkIconDashboardLabel: {
        id: 'fabric.linkPicker.headingLink.hyperlinkIconDashboardLabel',
        defaultMessage: 'Dashboard',
        description: 'icon label for a jira dashboard'
    },
    hyperlinkIconBoardLabel: {
        id: 'fabric.linkPicker.headingLink.hyperlinkIconBoardLabel',
        defaultMessage: 'Board',
        description: 'icon label for a jira board'
    },
    hyperlinkIconProjectLabel: {
        id: 'fabric.linkPicker.headingLink.hyperlinkIconProjectLabel',
        defaultMessage: 'Task',
        description: 'icon label for a jira project'
    },
    hyperlinkIconPlanLabel: {
        id: 'fabric.linkPicker.headingLink.hyperlinkIconPlanLabel',
        defaultMessage: 'Plan',
        description: 'icon label for a jira plan'
    },
    hyperlinkIconFilterLabel: {
        id: 'fabric.linkPicker.headingLink.hyperlinkIconFilterLabel',
        defaultMessage: 'Filter',
        description: 'icon label for a jira filter'
    },
    hyperlinkIconPageLabel: {
        id: 'fabric.linkPicker.headingLink.hyperlinkIconPageLabel',
        defaultMessage: 'Page',
        description: 'icon label for a confluence page'
    },
    hyperlinkIconBlogLabel: {
        id: 'fabric.linkPicker.headingLink.hyperlinkIconBlogLabel',
        defaultMessage: 'Blog',
        description: 'icon label for a confluence blog'
    },
    hyperlinkIconWhiteboardLabel: {
        id: 'fabric.linkPicker.headingLink.hyperlinkIconWhiteboardLabel',
        defaultMessage: 'Whiteboard',
        description: 'icon label for a confluence whiteboard'
    },
    hyperlinkIconDatabaseLabel: {
        id: 'fabric.linkPicker.headingLink.hyperlinkIconDatabaseLabel',
        defaultMessage: 'Database',
        description: 'icon label for a confluence database'
    },
    hyperlinkIconEmbedLabel: {
        id: 'fabric.linkPicker.headingLink.hyperlinkIconEmbedLabel',
        defaultMessage: 'Smart Link',
        description: 'icon label for a confluence smart link'
    },
    hyperlinkIconLoomLabel: {
        id: 'fabric.linkPicker.headingLink.hyperlinkIconLoomLabel',
        defaultMessage: 'Loom',
        description: 'icon label for a confluence loom'
    },
    hyperlinkIconLiveDocLabel: {
        id: 'fabric.linkPicker.headingLink.hyperlinkIconLiveDocLabel',
        defaultMessage: 'Live Doc',
        description: 'icon label for a confluence live doc'
    },
    story: {
        id: 'fabric.linkPicker.story',
        defaultMessage: 'Story',
        description: 'Alt text for Story'
    },
    epic: {
        id: 'fabric.linkPicker.epic',
        defaultMessage: 'Epic',
        description: 'Alt text for Epic'
    },
    task: {
        id: 'fabric.linkPicker.task',
        defaultMessage: 'Task',
        description: 'Alt text for Task'
    },
    bug: {
        id: 'fabric.linkPicker.bug',
        defaultMessage: 'Bug',
        description: 'Alt text for Bug'
    },
    subTask: {
        id: 'fabric.linkPicker.subTask',
        defaultMessage: 'Sub-task',
        description: 'Alt text for Sub-task'
    },
    improvement: {
        id: 'fabric.linkPicker.improvement',
        defaultMessage: 'Improvement',
        description: 'Alt text for Improvement'
    },
    defaultAltText: {
        id: 'fabric.linkPicker.defaultAltText',
        defaultMessage: 'List item',
        description: 'Default alt text for ListItem image'
    },
    hyperlinkIconIssueLabelIssueTermRefresh: {
        id: 'fabric.linkPicker.headingLink.hyperlinkIconIssueLabel-issue-term-refresh',
        defaultMessage: 'Work item',
        description: 'icon label for a jira issue'
    }
});

});


parcelRegister("hiZ5q", function(module, exports) {

$parcel$export(module.exports, "mapActivityClientResultToLinkSearchItemData", () => $93cc780fde36901f$export$d82137ca931458ca);
$parcel$export(module.exports, "filterItems", () => $93cc780fde36901f$export$16c4c0987c894b8c);
$parcel$export(module.exports, "mapSearchProviderResultToLinkSearchItemData", () => $93cc780fde36901f$export$b76efb0c656bea6e);
$parcel$export(module.exports, "getArisForProducts", () => $93cc780fde36901f$export$4b7ffcf66d37c47b);

var $VSDnB = parcelRequire("VSDnB");

var $3ZomH = parcelRequire("3ZomH");
function $93cc780fde36901f$export$8437fc55448c6e05(arr, comparator) {
    return arr.filter((firstItem, index, self)=>{
        return self.findIndex((secondItem)=>comparator ? comparator(firstItem, secondItem) : firstItem === secondItem) === index;
    });
}
const $93cc780fde36901f$export$d82137ca931458ca = ({ object: object, containers: containers, timestamp: timestamp })=>{
    let iconUrl = object.icon?.value || '';
    if (object.icon?.type === 'EMOJI') iconUrl = object.icon.fallback || '';
    const iconData = object.product === 'confluence' && (0, $VSDnB.fg)('platform-linking-visual-refresh-link-picker') ? (0, $3ZomH.getIconFromContentType)(object.product + '.' + object.type.toLowerCase(), object.subtype?.toLowerCase()) : (0, $3ZomH.getIconFromIconUrl)(iconUrl);
    return {
        objectId: object.id,
        name: object.name || '',
        container: $93cc780fde36901f$var$getContainerName(containers),
        url: object.url,
        ...iconData,
        lastViewedDate: timestamp ? new Date(timestamp) : undefined,
        prefetch: true,
        meta: {
            source: 'recent-work'
        }
    };
};
const $93cc780fde36901f$export$16c4c0987c894b8c = (items, searchTerm)=>{
    if (!searchTerm || !items) return [];
    return items.filter((item)=>{
        return item.name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
    });
};
const $93cc780fde36901f$export$b76efb0c656bea6e = ({ objectId: objectId, container: container, title: title, contentType: contentType, url: url, updatedTimestamp: updatedTimestamp, iconUrl: iconUrl, subtype: subtype })=>({
        objectId: objectId,
        name: title,
        container: container,
        url: url,
        ...// which return defaultAlt if no icon is found. Otherwise find an icon by looking up the content type
        iconUrl ? {
            icon: iconUrl,
            iconAlt: (0, $3ZomH.getIconFromContentType)(contentType, subtype).iconAlt
        } : (0, $3ZomH.getIconFromContentType)(contentType, subtype),
        lastUpdatedDate: updatedTimestamp ? new Date(updatedTimestamp) : undefined,
        prefetch: false,
        meta: {
            source: 'xp-search'
        }
    });
const $93cc780fde36901f$var$getContainerName = (containers)=>{
    for(let i = containers.length - 1; i >= 0; --i){
        const containerName = containers[i].name;
        if (containerName) return containerName;
    }
    return '';
};
/** No results returned for townsquare (Atlas) if `platform` is used in filter
 * https://atlassian.slack.com/archives/CGZMUTRUL/p1684729057252109?thread_ts=1684727786.451419&cid=CGZMUTRUL
 */ /**
 * Generate the ARI for particular product to send to the recent items API.
 */ function $93cc780fde36901f$var$generateProductSpecificAri(product, cloudId) {
    if (product === 'townsquare') /** No results returned for townsquare (Atlas) if `platform` is used in filter
		 * https://atlassian.slack.com/archives/CGZMUTRUL/p1684729057252109?thread_ts=1684727786.451419&cid=CGZMUTRUL
		 */ return `ari:cloud:townsquare::site/${cloudId}`;
    return `ari:cloud:platform::site/${cloudId}`;
}
function $93cc780fde36901f$export$4b7ffcf66d37c47b(products, cloudId) {
    const defaultAri = `ari:cloud:platform::site/${cloudId}`;
    if (products === undefined) return [
        defaultAri
    ];
    const allAris = products.map((product)=>$93cc780fde36901f$var$generateProductSpecificAri(product, cloudId));
    // Deduplicate
    return allAris.filter((value, index)=>allAris.indexOf(value) === index);
}

});



parcelRegister("4cO73", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb7f2e19a35f3294$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fb7f2e19a35f3294$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    submitButtonLabel: {
        "id": "software-backlog-ai-work-creation.ai-work-create-link-picker.submit-button-label",
        "defaultMessage": "Suggest work items"
    }
});

});


parcelRegister("8nxpO", function(module, exports) {

$parcel$export(module.exports, "default", () => $aba1deb570ccefd3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $aba1deb570ccefd3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    placeholderSmartLinkEditor: {
        "id": "backlog-ai-work-creation-panel.src.view.smart-link-editor.placeholder-smart-link-editor",
        "defaultMessage": "Describe what needs to be done, or <link>search Confluence</link>."
    }
});

});


parcelRegister("2prwO", function(module, exports) {

$parcel$export(module.exports, "HoverBox", () => $db9e1aa6f61e2e1f$export$d05bb914a6bf2e74);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $jAy2o = parcelRequire("jAy2o");

var $42CjB = parcelRequire("42CjB");

var $35XSW = parcelRequire("35XSW");
var $8Sbj3 = parcelRequire("8Sbj3");

var $fhbwe = parcelRequire("fhbwe");

var $jMVum = parcelRequire("jMVum");

var $jgJNO = parcelRequire("jgJNO");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $6s1PB = parcelRequire("6s1PB");

var $aoocK = parcelRequire("aoocK");
const $db9e1aa6f61e2e1f$var$HoverBoxNew = ({ shouldRenderHoverBox: shouldRenderHoverBox, children: children, onMouseEnter: onMouseEnterProp, onMouseLeave: onMouseLeaveProp, onLinkPicked: onLinkPicked = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onLinkPickerMounted: onLinkPickerMounted = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) })=>{
    const [isHovering, setIsHovering] = (0, $5uXOq.useState)(false);
    const [isLinkPickerOpen, setIsLinkPickerOpen] = (0, $5uXOq.useState)(false);
    const shouldShowTriggerButtons = isHovering || isLinkPickerOpen;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onMouseEnter = (0, $5uXOq.useCallback)(()=>{
        setIsHovering(true);
        onMouseEnterProp();
    }, [
        onMouseEnterProp
    ]);
    const onMouseLeave = (0, $5uXOq.useCallback)(()=>{
        setIsHovering(false);
        onMouseLeaveProp();
    }, [
        onMouseLeaveProp
    ]);
    const onCloseLinkPicker = (0, $5uXOq.useCallback)(()=>{
        setIsLinkPickerOpen(false);
        setIsHovering(false);
    }, []);
    const onCreateFromConfluenceButtonClick = (0, $5uXOq.useCallback)(()=>{
        setIsLinkPickerOpen(true);
    }, []);
    // this should never happen - just in case
    if (!shouldRenderHoverBox) return (0, $5uXOq.Children).only(children);
    const renderLinkPicker = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jMVum.AiWorkCreateLinkPicker), {
            onMounted: onLinkPickerMounted,
            onLinkSelected: onLinkPicked,
            onCloseLinkPicker: onCloseLinkPicker
        });
    const renderGenerateFromConfluenceButton = ({ ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            appearance: "subtle",
            label: formatMessage((0, $aoocK.default).buttonLabelGenerateFromConfluence),
            isTooltipDisabled: false,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jAy2o))),
            onClick: onCreateFromConfluenceButtonClick,
            isSelected: isLinkPickerOpen,
            ...triggerProps
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        xcss: $db9e1aa6f61e2e1f$var$hoverContainerStyles
    }, (0, $5uXOq.Children).only(children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $db9e1aa6f61e2e1f$var$triggerOverlayStyles
    }, shouldShowTriggerButtons && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $35XSW.default), {
        appear: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Sbj3.default), {
        enterFrom: "bottom",
        fade: "in"
    }, ({ className: className, ref: ref })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            className: className,
            ref: ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
            messageId: "software-backlog.card-list.inline-card-create.ai-work-create.hover-box.popup.placeholder-with-link-picker.popup",
            messageType: "transactional",
            isOpen: isLinkPickerOpen,
            onClose: onCloseLinkPicker,
            content: renderLinkPicker,
            trigger: renderGenerateFromConfluenceButton
        }), (0, $4R6GH.fg)('ai_powered_backlog_inline_create_from_image') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            appearance: "subtle",
            label: formatMessage((0, $aoocK.default).buttonLabelGenerateFromImage),
            isTooltipDisabled: false,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($fhbwe)))
        }))))));
};
const $db9e1aa6f61e2e1f$var$HoverBoxOld = ({ children: children, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, shouldRenderHoverBox: shouldRenderHoverBox })=>shouldRenderHoverBox ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }, (0, $5uXOq.Children).only(children)) : (0, $5uXOq.Children).only(children);
const $db9e1aa6f61e2e1f$export$d05bb914a6bf2e74 = (props)=>(0, $6s1PB.expValEquals)('ai_powered_backlog_inline_create_iter2', 'isEnabled', true, false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($db9e1aa6f61e2e1f$var$HoverBoxNew, props) // when in iter 2 experiment Test
     : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($db9e1aa6f61e2e1f$var$HoverBoxOld, props); // when in iter 2 experiment Control, or not in experiment
const $db9e1aa6f61e2e1f$var$hoverContainerStyles = (0, $8CUq3.xcss)({
    position: 'relative',
    overflow: 'hidden'
});
const $db9e1aa6f61e2e1f$var$triggerOverlayStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    top: 'space.0',
    right: 'space.050',
    bottom: 'space.0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
});

});
parcelRegister("fhbwe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::92d4dfc113a3924af0f8a9fba22d539c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b1f160f6235a0c00$var$_react = $b1f160f6235a0c00$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b1f160f6235a0c00$var$_baseNew = $b1f160f6235a0c00$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $b1f160f6235a0c00$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Image".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: images, image upload.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b1f160f6235a0c00$var$ImageIcon = (props)=>/*#__PURE__*/ $b1f160f6235a0c00$var$_react.default.createElement($b1f160f6235a0c00$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.75 4a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5"/><path fill="currentcolor" fill-rule="evenodd" d="M13 1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zM3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h.644l6.274-7.723.053-.058a.75.75 0 0 1 1.06 0L13.5 8.19V3a.5.5 0 0 0-.5-.5zm2.575 11H13a.5.5 0 0 0 .5-.5v-2.69l-2.943-2.943z" clip-rule="evenodd"/>`
    }, props));
$b1f160f6235a0c00$var$ImageIcon.displayName = 'ImageIcon';
var $b1f160f6235a0c00$var$_default = module.exports.default = $b1f160f6235a0c00$var$ImageIcon;

});

parcelRegister("aoocK", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a54e14495555282$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2a54e14495555282$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    buttonLabelGenerateFromConfluence: {
        "id": "backlog.card-list.inline-card-create.ai-assisted-create.hover-box.button-label-generate-from-confluence",
        "defaultMessage": "Generate from Confluence"
    },
    buttonLabelGenerateFromImage: {
        "id": "backlog.card-list.inline-card-create.ai-assisted-create.hover-box.button-label-generate-from-image",
        "defaultMessage": "Generate from image"
    }
});

});



parcelRegister("hyUTn", function(module, exports) {

$parcel$export(module.exports, "getActiveElement", () => $7a91e61e41af25ec$export$cd4e5573fbe2b576);
/**
 * This is here to make testing easier.
 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
const $7a91e61e41af25ec$export$cd4e5573fbe2b576 = ()=>document.activeElement;

});



parcelRegister("3mWFd", function(module, exports) {

$parcel$export(module.exports, "useRenderFullItem", () => $ad658e0d8f102510$export$f774065b6ff9b006);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");
/**
 * Version of requestIdleCallback with fallback to setTimeout of 200ms.
 */ const $ad658e0d8f102510$var$scheduleIdle = (cb)=>{
    if (typeof requestIdleCallback === 'undefined') {
        const timer = setTimeout(cb, 200);
        return ()=>{
            clearTimeout(timer);
        };
    }
    const idleCallback = requestIdleCallback(cb);
    return ()=>{
        cancelIdleCallback(idleCallback);
    };
};
const $ad658e0d8f102510$export$f774065b6ff9b006 = ({ isVisible: isVisible, isScrolling: isScrolling })=>{
    const [renderFullCard, setRenderFullCard] = (0, $5uXOq.useState)((0, $4R6GH.fg)('jira-concurrent-backlog-perf') ? isVisible && !isScrolling : false);
    (0, $5uXOq.useEffect)(()=>{
        if (isScrolling) return undefined;
        if (isVisible) {
            setRenderFullCard(true);
            return undefined;
        }
        return $ad658e0d8f102510$var$scheduleIdle(()=>{
            setRenderFullCard(true);
        });
    }, [
        isScrolling,
        isVisible
    ]);
    return renderFullCard;
};

});


parcelRegister("aJ0IJ", function(module, exports) {

$parcel$export(module.exports, "CardGroup", () => $20061fd03e670f1c$export$9acc0474485b44b2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $iDGXn = parcelRequire("iDGXn");

var $4R6GH = parcelRequire("4R6GH");

var $2lpqS = parcelRequire("2lpqS");

var $f6RVN = parcelRequire("f6RVN");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");

var $b7YUC = parcelRequire("b7YUC");
function $20061fd03e670f1c$export$9acc0474485b44b2({ cardGroup: { cardIds: cardIds, isAttachedToParent: isAttachedToParent, isCollapsed: isCollapsed }, isVisible: isVisible, isScrolling: isScrolling, cardListId: cardListId, setRichActiveCard: setRichActiveCard, shouldBeAbsolutePositioned: shouldBeAbsolutePositioned }) {
    const isCompactMode = (0, $iDGXn.useShowCompactMode)();
    /**
   * Checking if the card has extra fields set from board configuration
   */ const hasExtraFields = (0, $c1MAf.useBacklogSelector)((0, $dGljH.hasCardExtraFields));
    /**
   * Checking if the extra fields is off from view settings
   */ const shouldRenderExtraFields = (0, $iDGXn.useHasCardExtraFields)();
    const hasExtraCardHeight = (0, $f6RVN.isViewSettingAsPanelExpEnabledWithNoExposure)() ? shouldRenderExtraFields && hasExtraFields : hasExtraFields;
    let cardRowHeight = isCompactMode ? (0, $2lpqS.COMPACT_CARD_ROW_HEIGHT) : (0, $2lpqS.CARD_ROW_HEIGHT);
    cardRowHeight = hasExtraCardHeight ? cardRowHeight + (0, $2lpqS.EXTRA_CARD_ROW_HEIGHT) : cardRowHeight;
    const content = !isCollapsed ? cardIds.map((cardId, index)=>{
        const cardContainerEl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b7YUC.default), {
            isVisible: isVisible,
            isScrolling: isScrolling,
            cardId: cardId,
            cardListId: cardListId,
            isAttachedToParent: isAttachedToParent,
            setRichActiveCard: setRichActiveCard
        });
        const cardStyles = shouldBeAbsolutePositioned || !(0, $4R6GH.fg)('relatively_position_cards_on_initial_load') ? {
            position: 'absolute',
            top: index * cardRowHeight
        } : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($20061fd03e670f1c$var$CardWrapper, {
            key: cardId,
            // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop
            style: cardStyles
        }, cardContainerEl);
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($20061fd03e670f1c$var$CardGroupWrapper, null, content);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $20061fd03e670f1c$var$CardGroupWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $20061fd03e670f1c$var$CardWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("kaE44", function(module, exports) {

$parcel$export(module.exports, "CardListHeader", () => $1f3231f9110617b8$export$4b6322f1b24707fd);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $cE2Qr = parcelRequire("cE2Qr");

var $3t5QD = parcelRequire("3t5QD");

var $hZ46s = parcelRequire("hZ46s");

var $guzeq = parcelRequire("guzeq");

var $fvfVu = parcelRequire("fvfVu");

var $fLVJv = parcelRequire("fLVJv");

var $hTJrU = parcelRequire("hTJrU");

var $lusSu = parcelRequire("lusSu");

var $fSrcf = parcelRequire("fSrcf");

var $kykx0 = parcelRequire("kykx0");

var $klxs8 = parcelRequire("klxs8");
const $1f3231f9110617b8$var$BacklogAccordionNudgeAsyncWithFullWidth = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $1f3231f9110617b8$var$backlogAccordionNudgeAsyncStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZ46s.BacklogAccordionNudgeAsync), null, children));
const $1f3231f9110617b8$export$4b6322f1b24707fd = ({ isCreateSprintButtonVisible: isCreateSprintButtonVisible, isDisabled: isDisabled, isMaxLimitReached: isMaxLimitReached, isMinLimitReached: isMinLimitReached, onCreateSprint: onCreateSprint, onToggle: onToggle = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), whiteboardsTouchpoint: whiteboardsTouchpoint })=>{
    const { cardListId: cardListId, type: type, listName: listName } = (0, $fvfVu.useCardListContext)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOnboardingDismissed] = (0, $cE2Qr.useIsDismissed)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: [
            $1f3231f9110617b8$var$cardListHeaderStyles,
            isMaxLimitReached && $1f3231f9110617b8$var$maxLimitReachedStyles,
            isMinLimitReached && $1f3231f9110617b8$var$minLimitReachedStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTJrU.CardListCheckbox), {
        cardListId: cardListId,
        isDisabled: isDisabled,
        listName: `${type === (0, $guzeq.SPRINT) ? `${formatMessage((0, $kykx0.default).sprintListNamePrefix)} ` : ''}${listName}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3t5QD.ConditionalNudgeWrapper), {
        Wrapper: $1f3231f9110617b8$var$BacklogAccordionNudgeAsyncWithFullWidth,
        conditionsToApplyWrapper: !isOnboardingDismissed && type === (0, $guzeq.BACKLOG)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lusSu.CardListAccordionButton), {
        onToggle: onToggle
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $klxs8.SprintHeader), null), type === (0, $guzeq.BACKLOG) && (0, $4R6GH.fg)('sprint_planning_whiteboards_gate') && whiteboardsTouchpoint, type === (0, $guzeq.BACKLOG) && (0, $4R6GH.fg)('grw_1037_expand_plan_in_whiteboards_gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fLVJv.WhiteboardsAllJiras), null), isCreateSprintButtonVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fSrcf.CreateSprintButton), {
        onCreateSprint: onCreateSprint
    })));
};
const $1f3231f9110617b8$var$cardListHeaderStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 'space.100',
    minHeight: "var(--ds-space-400, 32px)",
    paddingInline: 'space.100',
    // Added the 1px border so that we get 9px of padding on the left and right of the header.
    // We do this so that the checkbox aligns with the checkboxes in the card list.
    borderLeft: '1px solid transparent',
    borderRight: '1px solid transparent'
});
const $1f3231f9110617b8$var$minLimitReachedStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.accent.yellow.subtlest'
});
const $1f3231f9110617b8$var$maxLimitReachedStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.accent.red.subtlest'
});
const $1f3231f9110617b8$var$backlogAccordionNudgeAsyncStyles = (0, $8CUq3.xcss)({
    flex: '1'
});

});
parcelRegister("hTJrU", function(module, exports) {

$parcel$export(module.exports, "CardListCheckbox", () => $da9473345a1fc6db$export$e5861b404a98a88f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $kkJfY = parcelRequire("kkJfY");

var $acDhY = parcelRequire("acDhY");

var $i2bSr = parcelRequire("i2bSr");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dCm1o = parcelRequire("dCm1o");

var $8SI0F = parcelRequire("8SI0F");

var $4mqko = parcelRequire("4mqko");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $3aKtu = parcelRequire("3aKtu");

var $5dyvY = parcelRequire("5dyvY");
const $da9473345a1fc6db$export$3a055e4082f2e2d5 = ()=>(0, $c1MAf.useBacklogSelector)((0, $dGljH.getSelectedCards));
const $da9473345a1fc6db$export$2cfb87b4e8fba2a2 = (cardListId)=>(0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.makeOrderedVisibleCardsForCardList)(state)(cardListId));
const $da9473345a1fc6db$export$18cc44b9c48de32 = ()=>(0, $c1MAf.useBacklogSelector)((0, $jG5HW.isCheckboxSelectionMode));
const $da9473345a1fc6db$export$e5861b404a98a88f = ({ cardListId: cardListId, isDisabled: isDisabled, listName: listName })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { entryPointActions: entryPointActions } = (0, $acDhY.useBulkOpsEntryPoint)();
    const selectedCards = $da9473345a1fc6db$export$3a055e4082f2e2d5();
    const selectableCards = $da9473345a1fc6db$export$2cfb87b4e8fba2a2(cardListId);
    const selectionMode = $da9473345a1fc6db$export$18cc44b9c48de32();
    const selectableIssueIds = (0, $5uXOq.useMemo)(()=>selectableCards.map((card)=>card.id), [
        selectableCards
    ]);
    const selectedCardsSet = (0, $5uXOq.useMemo)(()=>new Set(selectedCards), [
        selectedCards
    ]);
    const selectedIssueIds = (0, $5uXOq.useMemo)(()=>selectableIssueIds.filter((id)=>selectedCardsSet.has(id)), [
        selectableIssueIds,
        selectedCardsSet
    ]);
    const extraAnalyticsAttributes = (0, $5uXOq.useMemo)(()=>({
            selectAll: {
                checkbox: {
                    issue_ids: selectableIssueIds,
                    numSelectedCards: selectableIssueIds.length,
                    selectType: 'sprint',
                    isCheckboxChecked: true
                }
            },
            clearAll: {
                checkbox: {
                    issue_ids: [],
                    numSelectedCards: 0,
                    selectType: 'sprint',
                    isCheckboxChecked: false
                }
            }
        }), [
        selectableIssueIds
    ]);
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const onSelectAll = (0, $5uXOq.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed',
            actionSubject: 'checkbox'
        });
        dispatch((0, $4mqko.cardMultiSelectExtend)(selectableIssueIds));
        dispatch((0, $8SI0F.setCheckboxSelectionMode)(true));
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'bulkSelectCardList', {
            ...extraAnalyticsAttributes.selectAll.checkbox
        });
    }, [
        createAnalyticsEvent,
        dispatch,
        extraAnalyticsAttributes.selectAll.checkbox,
        selectableIssueIds
    ]);
    const onClearAll = (0, $5uXOq.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed',
            actionSubject: 'checkbox'
        });
        dispatch((0, $4mqko.cardMultiRemove)(selectedIssueIds));
        if (selectedCards.length === selectedIssueIds.length) dispatch((0, $8SI0F.setCheckboxSelectionMode)(false));
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'bulkSelectCardList', {
            ...extraAnalyticsAttributes.clearAll.checkbox
        });
    }, [
        createAnalyticsEvent,
        dispatch,
        extraAnalyticsAttributes.clearAll.checkbox,
        selectedCards.length,
        selectedIssueIds
    ]);
    const checkboxState = (0, $5uXOq.useMemo)(()=>(0, $5dyvY.getCardListCheckboxState)({
            selectedIssueIds: selectedIssueIds,
            selectableIssueIds: selectableIssueIds,
            selectionMode: selectionMode
        }), [
        selectedIssueIds,
        selectableIssueIds,
        selectionMode
    ]);
    const onCheckboxClick = (0, $5uXOq.useCallback)((event)=>{
        event.stopPropagation();
        if (checkboxState === (0, $i2bSr.CheckboxState).CHECKED) onClearAll();
        else if (checkboxState === (0, $i2bSr.CheckboxState).UNCHECKED || checkboxState === (0, $i2bSr.CheckboxState).INDETERMINATE) {
            if (!selectionMode) dispatch((0, $4mqko.cardEmptySelection)());
            entryPointActions.load();
            onSelectAll();
        }
    }, [
        selectionMode,
        checkboxState,
        dispatch,
        onClearAll,
        entryPointActions,
        onSelectAll
    ]);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const getLabel = (0, $5uXOq.useMemo)(()=>{
        if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return checkboxState === (0, $i2bSr.CheckboxState).CHECKED ? formatMessage((0, $3aKtu.messages).deselectCheckboxLabelIssueTermRefresh, {
            listName: listName
        }) : formatMessage((0, $3aKtu.messages).selectCheckboxLabelIssueTermRefresh, {
            listName: listName
        });
        return checkboxState === (0, $i2bSr.CheckboxState).CHECKED ? formatMessage((0, $3aKtu.messages).deselectCheckboxLabel, {
            listName: listName
        }) : formatMessage((0, $3aKtu.messages).selectCheckboxLabel, {
            listName: listName
        });
    }, [
        checkboxState,
        formatMessage,
        listName
    ]);
    if ((0, $dCm1o.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
        testId: "software-backlog.card-list.cardlist-checkbox.checkbox",
        onClick: onCheckboxClick,
        isChecked: checkboxState === (0, $i2bSr.CheckboxState).CHECKED || checkboxState === (0, $i2bSr.CheckboxState).INDETERMINATE,
        isIndeterminate: checkboxState === (0, $i2bSr.CheckboxState).INDETERMINATE,
        isDisabled: isDisabled || selectableIssueIds.length === 0,
        "aria-label": getLabel,
        "aria-disabled": isDisabled || selectableIssueIds.length === 0
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($da9473345a1fc6db$var$StyledCardListCheckbox, {
        "data-testid": "software-backlog.card-list.cardlist-checkbox.checkbox"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
        onClick: onCheckboxClick,
        isChecked: checkboxState === (0, $i2bSr.CheckboxState).CHECKED || checkboxState === (0, $i2bSr.CheckboxState).INDETERMINATE,
        isIndeterminate: checkboxState === (0, $i2bSr.CheckboxState).INDETERMINATE,
        isDisabled: isDisabled || selectableIssueIds.length === 0,
        "aria-label": getLabel,
        "aria-disabled": isDisabled || selectableIssueIds.length === 0
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $da9473345a1fc6db$var$StyledCardListCheckbox = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_189et94y _1dqonqa1 _1h6d3acm _19bvu2gc _1bsbgktf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("i2bSr", function(module, exports) {

$parcel$export(module.exports, "CheckboxState", () => $cf7acea0ad7120b6$export$10d1ecb0f8412c60);
const $cf7acea0ad7120b6$export$10d1ecb0f8412c60 = {
    CHECKED: 'checked',
    UNCHECKED: 'unchecked',
    INDETERMINATE: 'indeterminate'
};

});

parcelRegister("3aKtu", function(module, exports) {

$parcel$export(module.exports, "messages", () => $78527b0a4741fb8f$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $78527b0a4741fb8f$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    deselectCheckboxLabelOld: {
        "id": "backlog.card-list.cardlist-checkbox.deselect-checkbox-label-old",
        "defaultMessage": "Deselect all issues in sprint"
    },
    selectCheckboxLabelOld: {
        "id": "backlog.card-list.cardlist-checkbox.select-checkbox-label-old",
        "defaultMessage": "Select all issues in sprint"
    },
    deselectCheckboxLabel: {
        "id": "backlog.card-list.cardlist-checkbox.deselect-checkbox-label",
        "defaultMessage": "Deselect all issues in {listName}"
    },
    selectCheckboxLabel: {
        "id": "backlog.card-list.cardlist-checkbox.select-checkbox-label",
        "defaultMessage": "Select all issues in {listName}"
    },
    selectCheckboxLabelIssueTermRefresh: {
        "id": "backlog.card-list.cardlist-checkbox.select-checkbox-label-issue-term-refresh",
        "defaultMessage": "Select all work items in {listName}"
    },
    deselectCheckboxLabelIssueTermRefresh: {
        "id": "backlog.card-list.cardlist-checkbox.deselect-checkbox-label-issue-term-refresh",
        "defaultMessage": "Deselect all work items in {listName}"
    },
    deselectCheckboxLabelOldIssueTermRefresh: {
        "id": "backlog.card-list.cardlist-checkbox.deselect-checkbox-label-old-issue-term-refresh",
        "defaultMessage": "Deselect all work items in sprint"
    },
    selectCheckboxLabelOldIssueTermRefresh: {
        "id": "backlog.card-list.cardlist-checkbox.select-checkbox-label-old-issue-term-refresh",
        "defaultMessage": "Select all work items in sprint"
    }
});

});

parcelRegister("5dyvY", function(module, exports) {

$parcel$export(module.exports, "getCardListCheckboxState", () => $91355c9856c0ba56$export$ff0019101ecd17c9);

var $i2bSr = parcelRequire("i2bSr");
const $91355c9856c0ba56$export$ff0019101ecd17c9 = ({ selectedIssueIds: selectedIssueIds, selectableIssueIds: selectableIssueIds, selectionMode: selectionMode })=>{
    const selectedSelectableIssueIds = selectableIssueIds.filter((id)=>selectedIssueIds.includes(id));
    if (selectableIssueIds.length === selectedSelectableIssueIds.length && selectedSelectableIssueIds.length > 0 && selectionMode) return (0, $i2bSr.CheckboxState).CHECKED;
    if (selectedIssueIds.length > 0) {
        if (selectedIssueIds.length === 1) {
            if (selectionMode) return (0, $i2bSr.CheckboxState).INDETERMINATE;
            return (0, $i2bSr.CheckboxState).UNCHECKED;
        }
        return (0, $i2bSr.CheckboxState).INDETERMINATE;
    }
    return (0, $i2bSr.CheckboxState).UNCHECKED;
};

});


parcelRegister("lusSu", function(module, exports) {

$parcel$export(module.exports, "CardListAccordionButton", () => $30f16cff590cebe3$export$6651856fa745dad);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $fW62l = parcelRequire("fW62l");

var $jhVLw = parcelRequire("jhVLw");

var $l1N8i = parcelRequire("l1N8i");

var $6Ingq = parcelRequire("6Ingq");

var $ebd3R = parcelRequire("ebd3R");

var $hORKG = parcelRequire("hORKG");

var $3dGN0 = parcelRequire("3dGN0");

var $3u0c5 = parcelRequire("3u0c5");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $dqoiX = parcelRequire("dqoiX");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $fvfVu = parcelRequire("fvfVu");

var $f5uwQ = parcelRequire("f5uwQ");

var $kARaY = parcelRequire("kARaY");


var $5iS2L = parcelRequire("5iS2L");

var $kykx0 = parcelRequire("kykx0");

var $guzeq = parcelRequire("guzeq");

var $heLGs = parcelRequire("heLGs");
const $30f16cff590cebe3$export$6651856fa745dad = ({ onToggle: onToggle })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const formatDate = (0, $5iS2L.useFormatDate)();
    const { cardCountExcludingSubtasks: cardCountExcludingSubtasks, cardListId: cardListId, isCollapsed: isCollapsed, isFirstList: isFirstList, isMaxLimitReached: isMaxLimitReached, isMinLimitReached: isMinLimitReached, maxColumnLimit: maxColumnLimit, minColumnLimit: minColumnLimit, listName: listName, sprintData: sprintData, type: type, visibleCardAmount: visibleCardAmount, isDisabled: isDisabled } = (0, $fvfVu.useCardListContext)();
    const { isAddSprintDatesButtonVisible: isAddSprintDatesButtonVisible } = (0, $f5uwQ.useSprintLifecycleContext)();
    const chevronRightIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3dGN0))), {
        label: (0, $4R6GH.fg)('jfp-a11y-remove-aria-lable-expand-icon') ? '' : formatMessage((0, $kykx0.default).expandAccessabilityLabel),
        testId: "software-backlog.card-list.card-list-header.card-list-accordion-button.expand-icon",
        color: "var(--ds-icon, #44546F)",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($ebd3R))),
        LEGACY_primaryColor: "var(--ds-icon, #44546F)"
    });
    const chevronDownIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hORKG))), {
        label: (0, $4R6GH.fg)('jfp-a11y-remove-aria-lable-expand-icon') ? '' : formatMessage((0, $kykx0.default).collapseAccessabilityLabel),
        testId: "software-backlog.card-list.card-list-header.card-list-accordion-button.collapse-icon",
        color: "var(--ds-icon, #44546F)",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($6Ingq))),
        LEGACY_primaryColor: "var(--ds-icon, #44546F)"
    });
    const renderIcon = ()=>isCollapsed ? chevronRightIcon : chevronDownIcon;
    const leftSideRef = (0, $5uXOq.useRef)(null);
    const handleToggle = (event)=>{
        event.preventDefault();
        onToggle();
    };
    const handleHeaderKeyDown = (event)=>{
        if (event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('enter') || event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('space')) {
            event.preventDefault();
            onToggle();
        }
    };
    const renderNumberOfVisibleCardsText = ()=>{
        if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return cardCountExcludingSubtasks !== visibleCardAmount ? formatMessage((0, $kykx0.default).visibleCardAmountIssueTermRefresh, {
            totalCardAmount: cardCountExcludingSubtasks,
            cardAmount: visibleCardAmount
        }) : formatMessage((0, $kykx0.default).cardAmountIssueTermRefresh, {
            cardAmount: cardCountExcludingSubtasks
        });
        return cardCountExcludingSubtasks !== visibleCardAmount ? formatMessage((0, $kykx0.default).visibleCardAmount, {
            totalCardAmount: cardCountExcludingSubtasks,
            cardAmount: visibleCardAmount
        }) : formatMessage((0, $kykx0.default).cardAmount, {
            cardAmount: cardCountExcludingSubtasks
        });
    };
    const renderAddSprintDatesButton = ()=>{
        const stopPropagation = (e)=>e.stopPropagation();
        return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            onClick: stopPropagation,
            onKeyDown: stopPropagation,
            testId: "software-backlog.card-list.card-list-header.card-list-accordion-button.add-sprint-date-button-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kARaY.default), {
            cardListId: Number(cardListId)
        })));
    };
    const renderColumnLimits = ()=>isFirstList && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, minColumnLimit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            testId: (0, $0226f08d081871ec$export$54c7326f7173c649)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
            appearance: isMinLimitReached ? 'moved' : 'default',
            isBold: isMinLimitReached
        }, `MIN ${minColumnLimit}`)) : null, maxColumnLimit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            testId: (0, $0226f08d081871ec$export$54c7326f7173c649)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
            appearance: isMaxLimitReached ? 'removed' : 'default',
            isBold: isMaxLimitReached
        }, `MAX ${maxColumnLimit}`)) : null);
    if ((0, $4R6GH.fg)('tanuki_enghealth_28041')) {
        const containerId = `leftside-container-${cardListId}`;
        return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $30f16cff590cebe3$var$leftSideStyles,
            onClick: handleToggle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhVLw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $30f16cff590cebe3$var$cardListHeadingWrapper.pseudo,
            role: "button",
            tabIndex: isDisabled && (0, $4R6GH.fg)('tanuki_a11y_q4') ? -1 : 0,
            "aria-controls": !isCollapsed ? `backlog-accordion-${cardListId}` : undefined,
            onKeyDown: handleHeaderKeyDown,
            "aria-expanded": !isCollapsed,
            "aria-labelledby": containerId,
            testId: (0, $0226f08d081871ec$export$483ac6106791f695),
            ref: leftSideRef
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            alignItems: "center",
            justifyContent: "center",
            xcss: $30f16cff590cebe3$var$iconStyles
        }, renderIcon()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            id: containerId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            alignItems: "center",
            gap: "space.100"
        }, (0, $6s1PB.expValEquals)('surface_origin_board_on_sprint_containers', 'cohort', 'test') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heLGs.CardListHeading), {
            listName: listName,
            boardName: sprintData?.originBoard?.boardName,
            rapidViewId: sprintData?.originBoard?.rapidViewId,
            isBacklog: type === (0, $guzeq.BACKLOG)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
            as: "h2",
            size: "xsmall"
        }, listName), sprintData && isAddSprintDatesButtonVisible && renderAddSprintDatesButton(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, sprintData && !isAddSprintDatesButtonVisible && sprintData.startDate && sprintData.endDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            size: "medium",
            color: "color.text.subtle"
        }, `${formatDate(sprintData.startDate)} \u{2013} ${formatDate(sprintData.endDate)}`), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            size: "medium",
            color: "color.text.subtle"
        }, "(", renderNumberOfVisibleCardsText(), ")")), renderColumnLimits())), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
            "data-testid": `${(0, $0226f08d081871ec$export$483ac6106791f695)}-${type}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), {
            "aria-live": "polite",
            role: "status"
        }, listName, " ", renderNumberOfVisibleCardsText()))));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhVLw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $30f16cff590cebe3$var$leftSideStyles,
        testId: (0, $0226f08d081871ec$export$483ac6106791f695),
        role: "button",
        tabIndex: isDisabled && (0, $4R6GH.fg)('tanuki_a11y_q4') ? -1 : 0,
        "aria-controls": !isCollapsed ? `backlog-accordion-${cardListId}` : undefined,
        onClick: handleToggle,
        onKeyDown: handleHeaderKeyDown,
        "aria-expanded": !isCollapsed,
        ref: leftSideRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        justifyContent: "center",
        xcss: $30f16cff590cebe3$var$iconStyles
    }, renderIcon()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        gap: "space.100"
    }, (0, $6s1PB.expValEquals)('surface_origin_board_on_sprint_containers', 'cohort', 'test') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heLGs.CardListHeading), {
        listName: listName,
        boardName: sprintData?.originBoard?.boardName,
        rapidViewId: sprintData?.originBoard?.rapidViewId,
        isBacklog: type === (0, $guzeq.BACKLOG)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "xsmall"
    }, listName), sprintData && isAddSprintDatesButtonVisible && renderAddSprintDatesButton(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, sprintData && !isAddSprintDatesButtonVisible && sprintData.startDate && sprintData.endDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "medium",
        color: "color.text.subtle"
    }, `${formatDate(sprintData.startDate)} \u{2013} ${formatDate(sprintData.endDate)}`), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "medium",
        color: "color.text.subtle"
    }, "(", renderNumberOfVisibleCardsText(), ")")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": `${(0, $0226f08d081871ec$export$483ac6106791f695)}-${type}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), {
        "aria-live": "polite",
        role: "status"
    }, listName, " ", renderNumberOfVisibleCardsText())), renderColumnLimits())));
};
const $30f16cff590cebe3$var$leftSideStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    cursor: 'pointer',
    flex: 1,
    gap: 'space.050',
    position: 'relative'
});
const $30f16cff590cebe3$var$cardListHeadingWrapper = {
    pseudo: "_kqswstnw _154iidpf _1ltvidpf _1xi2idpf _94n5idpf"
};
const $30f16cff590cebe3$var$iconStyles = (0, $8CUq3.xcss)({
    pointerEvents: 'none',
    width: '24px',
    height: '24px'
});

});
const $0226f08d081871ec$export$483ac6106791f695 = 'software-backlog.card-list.left-side';
const $0226f08d081871ec$export$54c7326f7173c649 = 'software-backlog.card-list.column-limit';

parcelRegister("5iS2L", function(module, exports) {

$parcel$export(module.exports, "useFormatDate", () => $5cb8518452b7be6a$export$fc5db2b57ab9d291);

var $5uXOq = parcelRequire("5uXOq");

var $jovBr = parcelRequire("jovBr");

var $7jns1 = parcelRequire("7jns1");

var $lzeFL = parcelRequire("lzeFL");

var $koVbs = parcelRequire("koVbs");

var $1p96B = parcelRequire("1p96B");

var $leRCk = parcelRequire("leRCk");

var $guzeq = parcelRequire("guzeq");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $ie0h1 = parcelRequire("ie0h1");
const $5cb8518452b7be6a$var$MS_IN_HOURS = 3600000;
const $5cb8518452b7be6a$export$fc5db2b57ab9d291 = ()=>{
    const [{ data: loggedInUser }] = (0, $leRCk.useUserSubscriber)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const locale = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getLocale)) || (0, $lzeFL.defaultLocale);
    return (0, $5uXOq.useCallback)((date)=>{
        const utcOffset = Math.floor((0, $7jns1.default)(loggedInUser?.timeZone ?? 'utc') / $5cb8518452b7be6a$var$MS_IN_HOURS);
        const parsedDate = (0, $1p96B.setNumberOffsetToISODate)(date, utcOffset);
        return (0, $jovBr.default)(parsedDate) ? (0, $1p96B.formatWithLocale)(parsedDate, (0, $guzeq.DEFAULT_DATE_DISPLAY_FORMAT), locale) : formatMessage((0, $ie0h1.default).invalidDate);
    }, [
        formatMessage,
        locale,
        loggedInUser?.timeZone
    ]);
};

});
parcelRegister("ie0h1", function(module, exports) {

$parcel$export(module.exports, "default", () => $343319cf1ab5fb37$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $343319cf1ab5fb37$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    invalidDate: {
        "id": "backlog.card-list.hooks.use-format-date.invalid-date",
        "defaultMessage": "Invalid date"
    }
});

});


parcelRegister("kykx0", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c4ade00f55a5206$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7c4ade00f55a5206$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    cardAmount: {
        "id": "backlog.card-list.card-list-header.card-amount",
        "defaultMessage": "{cardAmount} {cardAmount, plural, one {issue} other {issues}}"
    },
    visibleCardAmount: {
        "id": "backlog.card-list.card-list-header.visible-card-amount",
        "defaultMessage": "{cardAmount} of {totalCardAmount} {totalCardAmount, plural, one {issue} other {issues}} visible"
    },
    startSprint: {
        "id": "backlog.card-list.card-list-header.start-sprint",
        "defaultMessage": "Start sprint"
    },
    createSprint: {
        "id": "backlog.card-list.card-list-header.create-sprint",
        "defaultMessage": "Create sprint"
    },
    completeSprint: {
        "id": "backlog.card-list.card-list-header.complete-sprint",
        "defaultMessage": "Complete sprint"
    },
    disabledStartSprintButtonEmpty: {
        "id": "backlog.card-list.card-list-header.disabled-start-sprint-button-empty",
        "defaultMessage": "Sprint cannot be started because it contains no issues"
    },
    disabledStartSprintButtonNoParallel: {
        "id": "backlog.card-list.card-list-header.disabled-start-sprint-button-no-parallel",
        "defaultMessage": "Can be planned but not started until the completion of above active sprint"
    },
    sprintListNamePrefix: {
        "id": "backlog.card-list.card-list-header.sprint-list-name-prefix",
        "defaultMessage": "sprint"
    },
    expandAccessabilityLabel: {
        "id": "backlog.card-list.card-list-header.expand-accessability-label",
        "defaultMessage": "Expand"
    },
    collapseAccessabilityLabel: {
        "id": "backlog.card-list.card-list-header.collapse-accessability-label",
        "defaultMessage": "Collapse"
    },
    disabledStartSprintButtonEmptyIssueTermRefresh: {
        "id": "backlog.card-list.card-list-header.disabled-start-sprint-button-empty-issue-term-refresh",
        "defaultMessage": "Sprint cannot be started because it contains no work items"
    },
    visibleCardAmountIssueTermRefresh: {
        "id": "backlog.card-list.card-list-header.visible-card-amount-issue-term-refresh",
        "defaultMessage": "{cardAmount} of {totalCardAmount} {totalCardAmount, plural, one {work item} other {work items}} visible"
    },
    cardAmountIssueTermRefresh: {
        "id": "backlog.card-list.card-list-header.card-amount-issue-term-refresh",
        "defaultMessage": "{cardAmount} {cardAmount, plural, one {work item} other {work items}}"
    }
});

});

parcelRegister("heLGs", function(module, exports) {

$parcel$export(module.exports, "CardListHeading", () => $f48bc247a4c7a899$export$92ec75b6d54d4578);

var $5uXOq = parcelRequire("5uXOq");

var $fW62l = parcelRequire("fW62l");

var $l1N8i = parcelRequire("l1N8i");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $8EsNC = parcelRequire("8EsNC");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $iDGXn = parcelRequire("iDGXn");

var $81jzU = parcelRequire("81jzU");

var $fSgHa = parcelRequire("fSgHa");

var $c1MAf = parcelRequire("c1MAf");

var $c0C8a = parcelRequire("c0C8a");

var $aARAn = parcelRequire("aARAn");
const $f48bc247a4c7a899$var$BaseHeading = ({ listName: listName })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "xsmall"
    }, listName);
};
const $f48bc247a4c7a899$export$92ec75b6d54d4578 = ({ rapidViewId: rapidViewId, boardName: boardName, listName: listName, isBacklog: isBacklog })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const boardId = (0, $81jzU.useBoardId)();
    const isCMP = (0, $fSgHa.useIsCMPBacklog)();
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const showBoardName = (0, $iDGXn.useShowBoardName)();
    const onEnterLink = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'clicked sprintOriginBoardLink');
        if (!rapidViewId) return;
        const action = (0, $c0C8a.sprintBoardLinkClickRequest)(rapidViewId, analyticsEvent);
        dispatch(action);
    }, [
        rapidViewId,
        dispatch
    ]);
    const onClick = (0, $5uXOq.useCallback)((event)=>{
        event.stopPropagation();
        event.preventDefault();
        const analyticsEvent = createAnalyticsEvent({});
        onEnterLink(analyticsEvent);
    }, [
        createAnalyticsEvent,
        onEnterLink
    ]);
    const onKeyDown = (0, $5uXOq.useCallback)((event)=>{
        if (event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('enter') || event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('space')) {
            event.stopPropagation();
            event.preventDefault();
            const analyticsEvent = createAnalyticsEvent({});
            onEnterLink(analyticsEvent);
        }
    }, [
        onEnterLink,
        createAnalyticsEvent
    ]);
    const getBoardLink = (0, $5uXOq.useCallback)((externalBoardName)=>{
        if (externalBoardName === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            alignBlock: "center",
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8EsNC))), {
            label: formatMessage((0, $aARAn.default).boardIconLabel)
        }), formatMessage((0, $aARAn.default).restrictedBoard));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
            role: "link",
            padding: "space.0",
            xcss: $f48bc247a4c7a899$var$LinkButtonStyles,
            onClick: onClick,
            onKeyDown: onKeyDown
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            alignBlock: "center",
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8EsNC))), {
            label: formatMessage((0, $aARAn.default).boardIconLabel)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $f48bc247a4c7a899$var$LinkStyles
        }, externalBoardName ?? formatMessage((0, $aARAn.default).restrictedBoard))));
    }, [
        formatMessage,
        onClick,
        onKeyDown
    ]);
    if (!isCMP || !showBoardName || !rapidViewId || rapidViewId === boardId || isBacklog) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f48bc247a4c7a899$var$BaseHeading, {
        listName: listName
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f48bc247a4c7a899$var$BaseHeading, {
        listName: listName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $aARAn.default).originBoardLink,
        values: {
            boardName: getBoardLink(boardName)
        }
    }));
};
const $f48bc247a4c7a899$var$LinkStyles = (0, $8CUq3.xcss)({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '150px',
    display: 'inline-block'
});
const $f48bc247a4c7a899$var$LinkButtonStyles = (0, $8CUq3.xcss)({
    textDecoration: 'underline',
    background: 'none',
    border: 'none',
    color: 'color.link',
    position: 'relative',
    ':hover': {
        color: 'color.link',
        textDecoration: 'none'
    },
    ':active': {
        color: 'color.link.pressed',
        textDecoration: 'none'
    },
    ':focus': {
        color: 'color.link',
        textDecoration: 'underline'
    }
});

});
parcelRegister("81jzU", function(module, exports) {

$parcel$export(module.exports, "useBoardId", () => $4fb47cdcd90a7bc3$export$b49754504c41149f);

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");
const $4fb47cdcd90a7bc3$export$b49754504c41149f = ()=>Number((0, $c1MAf.useBacklogSelector)((0, $jG5HW.getRapidViewId)));

});

parcelRegister("aARAn", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fbc210d9958f944$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0fbc210d9958f944$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    restrictedBoard: {
        "id": "backlog.card-list.card-list-header.card-list-accordion-button.card-list-heading.restricted-board",
        "defaultMessage": "Restricted Board"
    },
    boardIconLabel: {
        "id": "backlog.card-list.card-list-header.card-list-accordion-button.card-list-heading.board-icon-label",
        "defaultMessage": "Origin Board"
    },
    noPermissionFlagHeader: {
        "id": "backlog.card-list.card-list-header.card-list-accordion-button.card-list-heading.no-permission-flag-header",
        "defaultMessage": "You don't have permission to access this project"
    },
    noPermissionFlagBody: {
        "id": "backlog.card-list.card-list-header.card-list-accordion-button.card-list-heading.no-permission-flag-body",
        "defaultMessage": "Speak to your Jira admin or Project admin to get access"
    },
    originBoardLink: {
        "id": "backlog.card-list.card-list-header.card-list-accordion-button.card-list-heading.origin-board-link",
        "defaultMessage": "from {boardName}"
    }
});

});



parcelRegister("fSrcf", function(module, exports) {

$parcel$export(module.exports, "CreateSprintButton", () => $4c578b2b09c33ffa$export$e3fcc84403d55941);

var $5uXOq = parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");

var $bUmQV = parcelRequire("bUmQV");

var $koVbs = parcelRequire("koVbs");

var $8Bc5A = parcelRequire("8Bc5A");

var $cE2Qr = parcelRequire("cE2Qr");

var $8zOmE = parcelRequire("8zOmE");

var $3t5QD = parcelRequire("3t5QD");

var $4lQkG = parcelRequire("4lQkG");

var $f5uwQ = parcelRequire("f5uwQ");

var $elctU = parcelRequire("elctU");

var $kykx0 = parcelRequire("kykx0");
const $4c578b2b09c33ffa$export$e3fcc84403d55941 = ({ onCreateSprint: onCreateSprint })=>{
    const [nudgeStep] = (0, $cE2Qr.useNudgeStep)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { canManageSprints: canManageSprints, isCreateSprintButtonDisabled: isCreateSprintButtonDisabled } = (0, $f5uwQ.useSprintLifecycleContext)();
    const handleCreateSprint = (event, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'createSprint');
        onCreateSprint(analyticsEvent);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), {
        direction: "row",
        alignItems: "center",
        testId: "software-backlog.card-list.card-list-header.create-sprint-button.create-sprint-button-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3t5QD.ConditionalNudgeWrapper), {
        Wrapper: (0, $4lQkG.BacklogCreateSprintNudgeAsync),
        conditionsToApplyWrapper: nudgeStep === (0, $8Bc5A.BACKLOG_CREATE_SPRINT_NUDGE_ID)
    }, !canManageSprints ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $elctU.DisabledButtonHelper), null, formatMessage((0, $kykx0.default).createSprint)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        onClick: handleCreateSprint,
        isDisabled: isCreateSprintButtonDisabled,
        testId: "software-backlog.card-list.card-list-header.create-sprint-button",
        spacing: "compact"
    }, formatMessage((0, $kykx0.default).createSprint))));
};

});
parcelRegister("elctU", function(module, exports) {

$parcel$export(module.exports, "DisabledButtonHelper", () => $8fecce8b5a414d33$export$7407340f59537358);

var $5uXOq = parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");

var $1I7E8 = parcelRequire("1I7E8");

var $jldZL = parcelRequire("jldZL");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $983oH = parcelRequire("983oH");

var $5h5VW = parcelRequire("5h5VW");
const $8fecce8b5a414d33$var$A11Y_HELPER_TEXT_ID = 'software-backlog.card-list.common.sprint-actions.disabled-button-helper.disabled-button-trigger.a11y-helper-text';
const $8fecce8b5a414d33$export$7407340f59537358 = (props)=>{
    const { children: children } = props;
    const [isDisabledButtonPopupOpen, setIsDisabledButtonPopupOpen] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onDisabledButtonPopupClose = (0, $5uXOq.useCallback)(()=>{
        setIsDisabledButtonPopupOpen(false);
    }, []);
    const handleDisabledButtonClick = (0, $5uXOq.useCallback)(()=>{
        setIsDisabledButtonPopupOpen((prevState)=>!prevState);
    }, []);
    const disabledButtonTrigger = ({ ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            ...triggerProps,
            isSelected: isDisabledButtonPopupOpen,
            onClick: handleDisabledButtonClick,
            testId: "software-backlog.card-list.common.sprint-actions.disabled-button-helper.disabled-button-trigger",
            "aria-describedby": $8fecce8b5a414d33$var$A11Y_HELPER_TEXT_ID,
            "aria-disabled": true,
            spacing: (0, $dCm1o.isVisualRefreshEnabled)() ? 'compact' : undefined
        }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
        isOpen: isDisabledButtonPopupOpen,
        onClose: onDisabledButtonPopupClose,
        content: (0, $983oH.default),
        trigger: disabledButtonTrigger,
        placement: "bottom-end",
        testId: "software-backlog.card-list.common.sprint-actions.disabled-button-helper.disabled-button-popup"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jldZL.default), {
        id: $8fecce8b5a414d33$var$A11Y_HELPER_TEXT_ID,
        testId: "software-backlog.card-list.common.sprint-actions.disabled-button-helper.a-11-y-sr-text"
    }, formatMessage((0, $5h5VW.messages).disabledButtonHelperHeading), "\xa0", formatMessage((0, $5h5VW.messages).disabledButtonHelperBody)));
};

});
parcelRegister("983oH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7cd672f25698af9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $a3mGm = parcelRequire("a3mGm");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $5h5VW = parcelRequire("5h5VW");
const $f7cd672f25698af9$var$DisabledButtonContent = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        gap: "space.100",
        xcss: $f7cd672f25698af9$var$widthWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3mGm))), {
        spacing: "spacious",
        label: "",
        color: "var(--ds-icon-danger, #C9372C)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlockStart: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xsmall",
        as: "h2"
    }, formatMessage((0, $5h5VW.messages).disabledButtonHelperHeading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p"
    }, formatMessage((0, $5h5VW.messages).disabledButtonHelperBody))));
};
const $f7cd672f25698af9$var$widthWrapperStyles = (0, $8CUq3.xcss)({
    /**
   * fixed width to keep title on a single line
   */ width: '410px',
    padding: 'space.250'
});
var $f7cd672f25698af9$export$2e2bcd8739ae039 = $f7cd672f25698af9$var$DisabledButtonContent;

});
parcelRegister("a3mGm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::766864a6ad12ee0b57d7ed41e0a75cca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $751bc76853fe58bc$var$_react = $751bc76853fe58bc$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $751bc76853fe58bc$var$_lockLocked = $751bc76853fe58bc$var$_interopRequireDefault((parcelRequire("bwyQI")));

var $751bc76853fe58bc$var$_lock = $751bc76853fe58bc$var$_interopRequireDefault((parcelRequire("3G2gB")));
function $751bc76853fe58bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LockLockedIcon.
 * This component is LockLockedIcon, with `UNSAFE_fallbackIcon` set to "LockIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $751bc76853fe58bc$var$LockLockedIcon = (props)=>/*#__PURE__*/ $751bc76853fe58bc$var$_react.default.createElement($751bc76853fe58bc$var$_lockLocked.default, Object.assign({
        LEGACY_fallbackIcon: $751bc76853fe58bc$var$_lock.default
    }, props));
$751bc76853fe58bc$var$LockLockedIcon.Name = 'LockLockedIconMigration';
var $751bc76853fe58bc$var$_default = module.exports.default = $751bc76853fe58bc$var$LockLockedIcon;

});
parcelRegister("bwyQI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::86c9de42fef4ccbc35a6164a0094138a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $863db7350f859785$var$_react = $863db7350f859785$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $863db7350f859785$var$_baseNew = $863db7350f859785$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $863db7350f859785$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $863db7350f859785$var$LockLockedIcon = (props)=>/*#__PURE__*/ $863db7350f859785$var$_react.default.createElement($863db7350f859785$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3h5V4A2.5 2.5 0 0 0 8 1.5M12 7V4a4 4 0 0 0-8 0v3a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M4 8.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM7.25 13v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$863db7350f859785$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $863db7350f859785$var$_default = module.exports.default = $863db7350f859785$var$LockLockedIcon;

});

parcelRegister("3G2gB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ad70d7fd26028c0$var$_react = $2ad70d7fd26028c0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $2ad70d7fd26028c0$var$_lockLocked = $2ad70d7fd26028c0$var$_interopRequireDefault((parcelRequire("bwyQI")));
function $2ad70d7fd26028c0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2ad70d7fd26028c0$var$LockIcon = (props)=>/*#__PURE__*/ $2ad70d7fd26028c0$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M16 11V9h-2V7.002A2 2 0 0 0 12 5c-1.102 0-2 .898-2 2.002V9H8v2H7v8h10v-8zm-2 0h-4V9h4zM8 9V7.002A4.004 4.004 0 0 1 12 3a4 4 0 0 1 4 4.002V9h.994A2.01 2.01 0 0 1 19 11.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01C5 9.899 5.897 9 7.006 9zm0 0h2v2H8zm6 0h2v2h-2z"/><circle cx="12" cy="15" r="2"/></g></svg>`
    }, props, {
        newIcon: $2ad70d7fd26028c0$var$_lockLocked.default
    }));
$2ad70d7fd26028c0$var$LockIcon.displayName = 'LockIcon';
var $2ad70d7fd26028c0$var$_default = module.exports.default = $2ad70d7fd26028c0$var$LockIcon;

});


parcelRegister("5h5VW", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1be02b70241dbd6e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $1be02b70241dbd6e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    disabledButtonHelperHeading: {
        "id": "software.main.header.complete-sprint-button.complete-sprint-button-disabled-info-heading",
        "defaultMessage": "You don't have 'Manage sprints' permission"
    },
    disabledButtonHelperBody: {
        "id": "software.main.header.complete-sprint-button.complete-sprint-button-disabled-info-body",
        "defaultMessage": "Ask an administrator to grant you the permission for all projects in the board filter."
    }
});

});




parcelRegister("klxs8", function(module, exports) {

$parcel$export(module.exports, "SprintHeader", () => $b1fc2d85299762af$export$75b8174ace1d568);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $9dZ1c = parcelRequire("9dZ1c");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $cE2Qr = parcelRequire("cE2Qr");


var $3t5QD = parcelRequire("3t5QD");

var $emeAH = parcelRequire("emeAH");

var $ayaAN = parcelRequire("ayaAN");

var $dCm1o = parcelRequire("dCm1o");

var $jOXuX = parcelRequire("jOXuX");

var $fvfVu = parcelRequire("fvfVu");

var $f5uwQ = parcelRequire("f5uwQ");

var $bs6dR = parcelRequire("bs6dR");

var $2dBGm = parcelRequire("2dBGm");

var $hkjgs = parcelRequire("hkjgs");

var $cOAVR = parcelRequire("cOAVR");

var $kykx0 = parcelRequire("kykx0");
const $b1fc2d85299762af$export$75b8174ace1d568 = ()=>{
    const { cardIds: cardIds, cardListId: cardListId, type: type, listName: listName, isFirstList: isFirstList } = (0, $fvfVu.useCardListContext)();
    const { canEditSprint: canEditSprint, isStartSprintEnabled: isStartSprintEnabled, isStartSprintButtonVisible: isStartSprintButtonVisible, isCompleteSprintButtonVisible: isCompleteSprintButtonVisible, isCompleteSprintButtonDisabled: isCompleteSprintButtonDisabled, isSprintMenuVisible: isSprintMenuVisible } = (0, $f5uwQ.useSprintLifecycleContext)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [nudgeStep] = (0, $cE2Qr.useNudgeStep)();
    const { ref: startSprintButtonNudgeRef } = (0, $9dZ1c.useRegisterNudgeTarget)((0, $jOXuX.isTailoredOnboardingScrumAndSoftwareKanbanEnabled)() ? (0, $dbbf68c32d8c4308$export$6770a2081a63fc15) : 'start-sprint-button', isFirstList);
    const [isOnboardingDismissed] = (0, $cE2Qr.useIsDismissed)();
    const totalCardAmount = cardIds.length;
    const isEmpty = totalCardAmount === 0;
    const isStartSprintButtonDisabled = !isStartSprintEnabled || isEmpty;
    const isShowingRecommendations = !isStartSprintButtonDisabled;
    const renderStartSprintButton = ()=>{
        const shouldShowPrimaryButton = !isEmpty && isFirstList;
        const appearanceValue = shouldShowPrimaryButton ? 'primary' : 'default';
        const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cOAVR.default), {
            // This test-id is being used for the Jira Software NextGen Sprint Lifecycle pollinator test
            testId: "software-backlog.card-list.card-list-header.sprint-header.start-sprint-button",
            sprintId: cardListId,
            appearance: (0, $dCm1o.isVisualRefreshEnabled)() ? undefined : appearanceValue,
            isDisabled: isStartSprintButtonDisabled,
            shouldShowManageSprintHelper: !canEditSprint,
            ref: startSprintButtonNudgeRef,
            // Missing on original implementation
            onSave: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            redirectTo: ""
        }, formatMessage((0, $kykx0.default).startSprint));
        const possiblyNudgeWrappedButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3t5QD.ConditionalNudgeWrapper), {
            conditionsToApplyWrapper: isFirstList && // optimise and don't load the nudge if QS is dismissed since that's currently the only trigger
            ((0, $jOXuX.isTailoredOnboardingScrumAndSoftwareKanbanEnabled)() ? !isOnboardingDismissed : true),
            Wrapper: (0, $ayaAN.BacklogStartSprintNudgeAsync)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, button));
        if (isStartSprintButtonDisabled && canEditSprint) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: totalCardAmount === 0 ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $kykx0.default).disabledStartSprintButtonEmptyIssueTermRefresh : (0, $kykx0.default).disabledStartSprintButtonEmpty) : formatMessage((0, $kykx0.default).disabledStartSprintButtonNoParallel)
        }, possiblyNudgeWrappedButton);
        return possiblyNudgeWrappedButton;
    };
    const renderCompleteSprintButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3t5QD.ConditionalNudgeWrapper), {
            Wrapper: (0, $emeAH.BacklogCompleteSprintNudgeAsync),
            conditionsToApplyWrapper: nudgeStep === (0, $dbbf68c32d8c4308$export$63b61f654ce3da3d)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bs6dR.default), {
            sprintId: cardListId,
            // This test-id is being used for the Jira Software NextGen Sprint Lifecycle pollinator test
            testId: "software-backlog.card-list.card-list-header.sprint-header.complete-sprint-button",
            isDisabled: isCompleteSprintButtonDisabled
        }, formatMessage((0, $kykx0.default).completeSprint)));
    // This test-id is being used for the Jira Software NextGen Sprint Lifecycle pollinator test
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        direction: "row",
        alignItems: "center",
        testId: "software-backlog.card-list.card-list-header.sprint-header.estimations-and-actions-container",
        gap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2dBGm.default), {
        cardListId: cardListId,
        isShowingRecommendations: isShowingRecommendations
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        gap: "space.100",
        xcss: $b1fc2d85299762af$var$cardMenuActionsStyles
    }, isStartSprintButtonVisible && renderStartSprintButton(), isCompleteSprintButtonVisible && renderCompleteSprintButton(), isSprintMenuVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hkjgs.default), {
        cardListId: cardListId,
        cardListType: type,
        cardListName: listName
    })));
};
const $b1fc2d85299762af$var$cardMenuActionsStyles = (0, $8CUq3.xcss)({
    paddingLeft: 'space.100',
    ':empty': {
        display: 'none'
    }
});

});
parcelRegister("bs6dR", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c891abf9152dbab$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jj52j = parcelRequire("jj52j");
var $it1wb = parcelRequire("it1wb");
var $gn1v9 = parcelRequire("gn1v9");

var $hZ1SC = parcelRequire("hZ1SC");

var $47gW9 = parcelRequire("47gW9");

var $ivDCs = parcelRequire("ivDCs");

var $4mO32 = parcelRequire("4mO32");

var $dXq4S = parcelRequire("dXq4S");

var $dAfqg = parcelRequire("dAfqg");

var $bOsIL = parcelRequire("bOsIL");

var $iKdRC = parcelRequire("iKdRC");


var $b0yad = parcelRequire("b0yad");

var $koeKL = parcelRequire("koeKL");

var $dCm1o = parcelRequire("dCm1o");


var $guzeq = parcelRequire("guzeq");

var $8hVbJ = parcelRequire("8hVbJ");

var $3lZ6i = parcelRequire("3lZ6i");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $elctU = parcelRequire("elctU");
const $0c891abf9152dbab$var$CompleteSprintButton = ({ children: children, sprintId: sprintId, testId: testId, theme: theme, isDisabled: isDisabled })=>{
    const boardId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getRapidViewId));
    const cloudId = (0, $koeKL.useCloudId)();
    const { data: project } = (0, $dAfqg.useProjectContext)();
    const jiraProjectAri = (0, $dXq4S.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'project',
        resourceId: String(project?.projectId)
    });
    const sourceIssueNo = (0, $c1MAf.useBacklogSelector)((0, $dGljH.cardsSelector)).length;
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const boardIdAri = (0, $dXq4S.createAri)({
        cloudId: cloudId,
        resourceId: String(boardId),
        resourceOwner: 'jira-software',
        resourceType: 'board'
    });
    const sprintIdAri = (0, $dXq4S.createAri)({
        cloudId: cloudId,
        resourceId: sprintId,
        resourceOwner: 'jira-software',
        resourceType: 'sprint'
    });
    const isCompanyManaged = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
    const showRetrosModal = (0, $hZ1SC.useShowCreateRetroOrCrossSellModal)();
    const onCompleted = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $3lZ6i.refreshDataRequest)((0, $guzeq.REFRESH_SOURCE_SPRINT_COMPLETE)));
        (0, $b0yad.triggerResourceCacheInvalidation)((0, $8631d6ce464ccf2e$export$dedbdcc35e955187), 'COMPLETE_SPRINT_MODAL_COMPLETE');
        showRetrosModal();
    }, [
        dispatch,
        showRetrosModal
    ]);
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            jiraProjectAri: jiraProjectAri,
            // Date of 12 weeks ago as we want to fetch deployments date updated at most 12 weeks ago for deployments report nudge on sprint completion
            updatedFromDeploymentsDate: (0, $jj52j.default)((0, $it1wb.default)((0, $gn1v9.default)(Date.now(), {
                weeks: 12
            }))),
            boardId: boardIdAri,
            activeSprintIds: [
                sprintIdAri
            ],
            isCompanyManaged: isCompanyManaged
        }), [
        jiraProjectAri,
        boardIdAri,
        sprintIdAri,
        isCompanyManaged
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject, stopMetric: stopMetric } = (0, $4mO32.useEntryPoint)((0, $bOsIL.completeSprintModalEntryPoint), entryPointParams, (0, $8hVbJ.completeSprintModalLoad));
    const entryPointTriggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    const props = (0, $5uXOq.useMemo)(()=>({
            analyticsSource: 'software-backlog',
            boardId: boardIdAri,
            onCompleted: onCompleted,
            sourceIssueNo: sourceIssueNo,
            sprintId: sprintId,
            onReady: stopMetric,
            isCompanyManaged: isCompanyManaged
        }), [
        boardIdAri,
        onCompleted,
        sourceIssueNo,
        sprintId,
        stopMetric,
        isCompanyManaged
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $elctU.DisabledButtonHelper), null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iKdRC.ModalTriggerButton), {
        ref: entryPointTriggerRef,
        ...!theme && (0, $dCm1o.isVisualRefreshEnabled)() ? {} : {
            theme: theme
        },
        testId: testId,
        spacing: (0, $dCm1o.isVisualRefreshEnabled)() ? 'compact' : undefined
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ivDCs.ModalEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "complete-sprint-modal",
        teamName: "a4t-pandora",
        packageName: (0, $a9c483c0d986286a$export$dfd208682d29484c),
        entryPointActions: entryPointActions,
        runtimeProps: props
    }));
};
var $0c891abf9152dbab$export$2e2bcd8739ae039 = $0c891abf9152dbab$var$CompleteSprintButton;

});
parcelRegister("hZ1SC", function(module, exports) {

$parcel$export(module.exports, "useShowCreateRetroOrCrossSellModal", () => $b6bc1441fa7da9d1$export$3918442dc3bc3c6b);

var $5uXOq = parcelRequire("5uXOq");

var $cyA39 = parcelRequire("cyA39");

var $hqBSi = parcelRequire("hqBSi");

var $4R6GH = parcelRequire("4R6GH");

var $9LoyA = parcelRequire("9LoyA");
const $b6bc1441fa7da9d1$export$3918442dc3bc3c6b = ()=>{
    const [retrosState, retrosActions] = (0, $9LoyA.useRetros)();
    const licensedProducts = (0, $hqBSi.useLicensedProducts)();
    const { hasAccess: hasAccess } = (0, $cyA39.useUserHasConfluenceAccess)();
    return (0, $5uXOq.useCallback)(()=>{
        if (!retrosState.shouldCreateRetro) return;
        let action = retrosActions.setLoadCreateRetroModal;
        if (licensedProducts.confluence && !hasAccess && (0, $4R6GH.fg)('jira_sprint_completion_cross_join_confluence')) action = retrosActions.setLoadCrossJoinModal;
        action(true);
    }, [
        licensedProducts,
        hasAccess,
        retrosState.shouldCreateRetro,
        retrosActions
    ]);
};

});
parcelRegister("cyA39", function(module, exports) {

$parcel$export(module.exports, "useUserHasConfluenceAccess", () => $e1d1047ca6c0e736$export$bddce71054147149);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $eNf8a = parcelRequire("eNf8a");

var $imVeH = parcelRequire("imVeH");

var $jcw0u = parcelRequire("jcw0u");

var $koeKL = parcelRequire("koeKL");

var $9KYrx = parcelRequire("9KYrx");

var $cu7Vs = parcelRequire("cu7Vs");

var $cpyFY = parcelRequire("cpyFY");

var $8o1o1 = parcelRequire("8o1o1");
const $e1d1047ca6c0e736$var$TIME_TO_LIVE = 1800000; // 30 minutes
const $e1d1047ca6c0e736$var$storage = (0, $eNf8a.createSessionStorageProvider)((0, $9KYrx.CONFLUENCE_ACCESS_STORAGE_PROVIDER_KEY));
const $e1d1047ca6c0e736$export$704f81dd3d993adb = (0, $8QpSo.default)((0, $cu7Vs.fetchConfluenceUserPermissions));
const $e1d1047ca6c0e736$export$bddce71054147149 = (embeddedConfluenceSource, skip = false)=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const fireAnalyticsEvent = (0, $8o1o1.useEmbeddedPageTracking)();
    const tenantHasConfluence = (0, $imVeH.useTenantHasConfluence)();
    const [hasAccess, setHasAccess] = (0, $5uXOq.useState)(false);
    const permitted = (0, $5uXOq.useMemo)(()=>(0, $cpyFY.getSessionStorageData)((0, $9KYrx.CONFLUENCE_ACCESS_STORAGE_KEY), $e1d1047ca6c0e736$var$storage)?.permitted, []);
    const getConfluencePermissions = (0, $5uXOq.useCallback)(async ()=>{
        try {
            if (!cloudId) return;
            const response = await $e1d1047ca6c0e736$export$704f81dd3d993adb(cloudId);
            fireAnalyticsEvent({
                action: 'success',
                eventName: 'userConfluenceAccess',
                embeddedConfluenceSource: embeddedConfluenceSource
            });
            (0, $cpyFY.setSessionStorageData)({
                key: (0, $9KYrx.CONFLUENCE_ACCESS_STORAGE_KEY),
                value: response,
                ttl: $e1d1047ca6c0e736$var$TIME_TO_LIVE,
                storage: $e1d1047ca6c0e736$var$storage
            });
            setHasAccess(response?.permitted);
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'userConfluenceAccess',
                    teamName: 'confluence-better-together'
                },
                attributes: {
                    embeddedConfluenceSource: embeddedConfluenceSource
                },
                error: new Error(`Failed to get user confluence access status: ${error}`)
            });
        }
    }, [
        cloudId,
        embeddedConfluenceSource,
        fireAnalyticsEvent
    ]);
    const refetchHasAccess = (0, $5uXOq.useCallback)(async ()=>{
        (0, $cpyFY.setSessionStorageData)({
            key: (0, $9KYrx.CONFLUENCE_ACCESS_STORAGE_KEY),
            value: {},
            ttl: $e1d1047ca6c0e736$var$TIME_TO_LIVE,
            storage: $e1d1047ca6c0e736$var$storage
        });
        $e1d1047ca6c0e736$export$704f81dd3d993adb.clear();
        await getConfluencePermissions();
    }, [
        getConfluencePermissions
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (skip) return;
        if (!(0, $cpyFY.getSessionStorageData)((0, $9KYrx.CONFLUENCE_ACCESS_STORAGE_KEY), $e1d1047ca6c0e736$var$storage)) (0, $cpyFY.setSessionStorageData)({
            key: (0, $9KYrx.CONFLUENCE_ACCESS_STORAGE_KEY),
            value: {},
            ttl: $e1d1047ca6c0e736$var$TIME_TO_LIVE,
            storage: $e1d1047ca6c0e736$var$storage
        });
        if (!(0, $cpyFY.isStorageKeyExpired)((0, $9KYrx.CONFLUENCE_ACCESS_STORAGE_KEY), $e1d1047ca6c0e736$var$storage) && permitted !== undefined) {
            setHasAccess(permitted);
            return;
        }
        if (!tenantHasConfluence) {
            (0, $cpyFY.setSessionStorageData)({
                key: (0, $9KYrx.CONFLUENCE_ACCESS_STORAGE_KEY),
                value: {
                    permitted: false
                },
                ttl: $e1d1047ca6c0e736$var$TIME_TO_LIVE,
                storage: $e1d1047ca6c0e736$var$storage
            });
            setHasAccess(false);
            return;
        }
        getConfluencePermissions();
    }, [
        embeddedConfluenceSource,
        fireAnalyticsEvent,
        getConfluencePermissions,
        permitted,
        skip,
        tenantHasConfluence
    ]);
    return {
        hasAccess: hasAccess,
        refetchHasAccess: refetchHasAccess
    };
};

});
parcelRegister("imVeH", function(module, exports) {

$parcel$export(module.exports, "useTenantHasConfluence", () => $734552c5f3b177b5$export$964fe2dd9242a588);

var $4Pf62 = parcelRequire("4Pf62");

var $hqBSi = parcelRequire("hqBSi");
const $734552c5f3b177b5$export$964fe2dd9242a588 = ()=>{
    const licensedProducts = (0, $hqBSi.useLicensedProducts)();
    return Boolean(licensedProducts[(0, $4Pf62.LICENSED_PRODUCTS).CONFLUENCE]);
};

});

parcelRegister("cu7Vs", function(module, exports) {

$parcel$export(module.exports, "fetchConfluenceUserPermissions", () => $c0391b42dbea5292$export$e1aee708fe0c56c2);

var $7f4tk = parcelRequire("7f4tk");
const $c0391b42dbea5292$export$e1aee708fe0c56c2 = async (cloudId)=>{
    const response = (0, $7f4tk.default)('/gateway/api/permissions/permitted', {
        method: 'POST',
        body: JSON.stringify({
            resourceId: `ari:cloud:confluence::site/${cloudId}`,
            permissionId: 'write'
        }),
        headers: {
            Accept: 'application/json'
        }
    });
    return response;
};

});

parcelRegister("cpyFY", function(module, exports) {

$parcel$export(module.exports, "getSessionStorageData", () => $bcceba29d01fe1ab$export$af84d82ff1eea56d);
$parcel$export(module.exports, "setSessionStorageData", () => $bcceba29d01fe1ab$export$be8cb7c8f1a1db6b);
$parcel$export(module.exports, "isStorageKeyExpired", () => $bcceba29d01fe1ab$export$59dd918a314efec0);
const $bcceba29d01fe1ab$var$createTTLTimestamp = (ttl)=>Date.now() + ttl;
const $bcceba29d01fe1ab$export$af84d82ff1eea56d = (key, storage)=>storage.get(key);
const $bcceba29d01fe1ab$export$be8cb7c8f1a1db6b = ({ key: key, value: value, ttl: ttl, storage: storage })=>{
    const expiresAt = $bcceba29d01fe1ab$var$createTTLTimestamp(ttl);
    storage.set(key, {
        ...value,
        expiresAt: expiresAt
    });
};
const $bcceba29d01fe1ab$export$59dd918a314efec0 = (key, storage)=>{
    if (!$bcceba29d01fe1ab$export$af84d82ff1eea56d(key, storage)) return true;
    const expiresAt = $bcceba29d01fe1ab$export$af84d82ff1eea56d(key, storage)?.expiresAt;
    return expiresAt ? new Date().getTime() >= expiresAt : true;
};
const $bcceba29d01fe1ab$export$47001de47bd4a961 = (key, storage)=>storage.remove(key);

});

parcelRegister("8o1o1", function(module, exports) {

$parcel$export(module.exports, "useEmbeddedPageTracking", () => $66febf67b379b5c1$export$9fcd107e4ed1de75);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $2gCtH = parcelRequire("2gCtH");

var $2NMNM = parcelRequire("2NMNM");

var $9OXo1 = parcelRequire("9OXo1");

var $j8Srb = parcelRequire("j8Srb");
const $66febf67b379b5c1$var$getParentProduct = (projectType)=>{
    switch(projectType){
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return 'JSM';
        case 0, $2vSU6.SOFTWARE_PROJECT:
            return 'JSW';
        case 0, $2vSU6.CORE_PROJECT:
            return 'JWM';
        default:
            return 'JSW';
    }
};
const $66febf67b379b5c1$export$9fcd107e4ed1de75 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const source = (0, $2gCtH.useAnalyticsSource)();
    const trackEmbeddedConfluence = (0, $5uXOq.useCallback)(({ eventName: eventName, action: action, actionSubject: actionSubject, projectType: projectType, embeddedConfluenceSource: embeddedConfluenceSource = 'jiraIssueView', eventType: eventType = 'ui', userHasConfluenceAccess: userHasConfluenceAccess, tenantHasConfluence: tenantHasConfluence, crossJoinStatus: crossJoinStatus, originProduct: originProduct, requestedProduct: requestedProduct })=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject ?? `${eventName}`
        });
        const attributes = {
            parentProduct: $66febf67b379b5c1$var$getParentProduct(projectType),
            tenantEditions: tenantContext?.appEditions,
            productEntitlementDetails: tenantContext?.productEntitlementDetails,
            embeddedConfluenceSource: embeddedConfluenceSource,
            jiraIssueSurfaceArea: source,
            userHasConfluenceAccess: userHasConfluenceAccess,
            tenantHasConfluence: tenantHasConfluence,
            crossJoinStatus: crossJoinStatus,
            originProduct: originProduct,
            requestedProduct: requestedProduct
        };
        (0, $j8Srb.fireEmbeddedConfluenceAnalytics)({
            analyticsEvent: analyticsEvent,
            attributes: attributes,
            eventType: eventType,
            eventName: `${actionSubject ?? eventName} ${action}`
        });
    }, [
        source,
        tenantContext,
        createAnalyticsEvent
    ]);
    return trackEmbeddedConfluence;
};

});
parcelRegister("j8Srb", function(module, exports) {

$parcel$export(module.exports, "fireEmbeddedConfluenceAnalytics", () => $da71518e42bc9539$export$864bc2da9014e8e9);

var $8zOmE = parcelRequire("8zOmE");
const $da71518e42bc9539$export$864bc2da9014e8e9 = ({ analyticsEvent: analyticsEvent, attributes: attributes, eventType: eventType, eventName: eventName })=>{
    switch(eventType){
        case 'ui':
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, attributes);
            break;
        case 'operational':
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, `${eventName}`, attributes);
            break;
        case 'track':
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, `${eventName}`, attributes);
            break;
        default:
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, attributes);
            break;
    }
};

});



parcelRegister("9LoyA", function(module, exports) {

$parcel$export(module.exports, "useRetros", () => $27c0746d7d3517fa$export$70e27f56232e4ea8);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $bkZLr = parcelRequire("bkZLr");

var $c85ZN = parcelRequire("c85ZN");

const $27c0746d7d3517fa$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    initialState: $c85ZN.initialState,
    actions: $bkZLr.default,
    name: 'create-retros'
});
const $27c0746d7d3517fa$export$70e27f56232e4ea8 = (0, $3sQ5x.createHook)($27c0746d7d3517fa$export$390f32400eaf98c9);

});
parcelRegister("bkZLr", function(module, exports) {

$parcel$export(module.exports, "default", () => $48222d4aa85b1c99$export$2e2bcd8739ae039);

var $8LQ84 = parcelRequire("8LQ84");

var $1QOns = parcelRequire("1QOns");

var $agVdz = parcelRequire("agVdz");

var $jJZqs = parcelRequire("jJZqs");

var $4R6GH = parcelRequire("4R6GH");

var $42TYq = parcelRequire("42TYq");

var $b7gdg = parcelRequire("b7gdg");

var $c85ZN = parcelRequire("c85ZN");
const $48222d4aa85b1c99$var$resetState = ()=>({ setState: setState })=>{
        setState((0, $c85ZN.initialState));
    };
const $48222d4aa85b1c99$var$resetCreatedData = ()=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            createRetroPage: (0, $c85ZN.initialState).createRetroPage,
            createWhiteboard: (0, $c85ZN.initialState).createWhiteboard
        });
    };
const $48222d4aa85b1c99$var$setSprintId = (sprintId)=>({ setState: setState })=>{
        setState({
            sprintId: sprintId
        });
    };
const $48222d4aa85b1c99$var$setShouldCreateRetro = (shouldCreateRetro)=>({ setState: setState })=>{
        setState({
            shouldCreateRetro: shouldCreateRetro
        });
    };
const $48222d4aa85b1c99$var$setLoadCreateRetroModal = (loadCreateRetroModal)=>({ setState: setState })=>{
        setState({
            loadCreateRetroModal: loadCreateRetroModal
        });
    };
const $48222d4aa85b1c99$var$setLoadCrossFlowModal = (loadCrossFlowModal)=>({ setState: setState })=>{
        setState({
            loadCrossFlowModal: loadCrossFlowModal
        });
    };
const $48222d4aa85b1c99$var$setLoadCrossJoinModal = (loadCrossJoinModal)=>({ setState: setState })=>{
        setState({
            loadCrossJoinModal: loadCrossJoinModal
        });
    };
const $48222d4aa85b1c99$var$setIsRetroLinked = (isRetroLinked)=>({ setState: setState })=>{
        setState({
            isRetroLinked: isRetroLinked
        });
    };
const $48222d4aa85b1c99$var$setIsRetroLinking = (isRetroLinking)=>({ setState: setState })=>{
        setState({
            isRetroLinking: isRetroLinking
        });
    };
const $48222d4aa85b1c99$var$setRetroLinkingError = (retroLinkingError)=>({ setState: setState })=>{
        setState({
            retroLinkingError: retroLinkingError
        });
    };
const $48222d4aa85b1c99$var$setIsRetroPublished = (isRetroPublished)=>({ setState: setState })=>{
        setState({
            isRetroPublished: isRetroPublished
        });
    };
const $48222d4aa85b1c99$var$setConfluenceData = (data)=>({ getState: getState, setState: setState })=>{
        const { confluenceData: confluenceData } = getState();
        setState({
            confluenceData: {
                ...confluenceData,
                ...data
            }
        });
    };
const $48222d4aa85b1c99$var$setRetroType = (retroType)=>({ setState: setState })=>{
        setState({
            retroType: retroType
        });
    };
const $48222d4aa85b1c99$var$createRetroPage = (cloudId, spaceKey, parentPageId, sprintId, blueprintId)=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            createRetroPage: {
                ...state.createRetroPage,
                loading: true,
                error: undefined
            }
        });
        try {
            const retroPage = await (0, $42TYq.createRetro)(cloudId, spaceKey, parentPageId, sprintId, blueprintId, (0, $4R6GH.fg)('confluence_live_pages_enabled_in_jira'));
            setState({
                createRetroPage: {
                    ...state.createRetroPage,
                    loading: false,
                    data: retroPage
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                createRetroPage: {
                    ...state.createRetroPage,
                    loading: false,
                    error: error
                }
            });
        }
    };
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $48222d4aa85b1c99$var$isConfluenceWhiteboardsError = (error)=>(0, (/*@__PURE__*/$parcel$interopDefault($1QOns)))(error) && (0, (/*@__PURE__*/$parcel$interopDefault($8LQ84)))(error.errors) && // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error.errors.every((e)=>(0, (/*@__PURE__*/$parcel$interopDefault($1QOns)))(e) && (0, (/*@__PURE__*/$parcel$interopDefault($agVdz)))(e.title) && (0, (/*@__PURE__*/$parcel$interopDefault($agVdz)))(e.code));
const $48222d4aa85b1c99$var$isConfluenceWhiteboardsDisabled = async (error)=>{
    if (!(error instanceof (0, $jJZqs.default) && error.originalResponse)) return false;
    const errorResponse = await error.originalResponse.json();
    // Check for title until more specific error code is available (CBT-3079)
    return $48222d4aa85b1c99$var$isConfluenceWhiteboardsError(errorResponse) && errorResponse.errors[0].title === 'Whiteboards are not enabled';
};
const $48222d4aa85b1c99$var$createRetroWhiteboard = (cloudId, spaceId, parentId, templateKey)=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            createWhiteboard: {
                ...state.createWhiteboard,
                loading: true,
                error: undefined
            }
        });
        try {
            const whiteboard = await (0, $b7gdg.createWhiteboard)(cloudId, spaceId, parentId, templateKey);
            setState({
                createWhiteboard: {
                    ...state.createWhiteboard,
                    loading: false,
                    data: whiteboard
                }
            });
        } catch (error) {
            setState({
                isWhiteboardsDisabled: state.isWhiteboardsDisabled || await $48222d4aa85b1c99$var$isConfluenceWhiteboardsDisabled(error),
                createWhiteboard: {
                    ...state.createWhiteboard,
                    loading: false,
                    error: error instanceof Error ? error : undefined
                }
            });
        }
    };
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$48222d4aa85b1c99$export$2e2bcd8739ae039 = {
    resetState: $48222d4aa85b1c99$var$resetState,
    resetCreatedData: $48222d4aa85b1c99$var$resetCreatedData,
    setSprintId: $48222d4aa85b1c99$var$setSprintId,
    setShouldCreateRetro: $48222d4aa85b1c99$var$setShouldCreateRetro,
    setLoadCreateRetroModal: $48222d4aa85b1c99$var$setLoadCreateRetroModal,
    setLoadCrossFlowModal: $48222d4aa85b1c99$var$setLoadCrossFlowModal,
    setLoadCrossJoinModal: $48222d4aa85b1c99$var$setLoadCrossJoinModal,
    setIsRetroLinked: $48222d4aa85b1c99$var$setIsRetroLinked,
    setIsRetroLinking: $48222d4aa85b1c99$var$setIsRetroLinking,
    setRetroLinkingError: $48222d4aa85b1c99$var$setRetroLinkingError,
    setIsRetroPublished: $48222d4aa85b1c99$var$setIsRetroPublished,
    setConfluenceData: $48222d4aa85b1c99$var$setConfluenceData,
    createRetroPage: $48222d4aa85b1c99$var$createRetroPage,
    setRetroType: $48222d4aa85b1c99$var$setRetroType,
    createRetroWhiteboard: $48222d4aa85b1c99$var$createRetroWhiteboard
};

});
parcelRegister("42TYq", function(module, exports) {

$parcel$export(module.exports, "createRetro", () => $f4242736fa792950$export$a63913da797715a6);

var $7f4tk = parcelRequire("7f4tk");


var $cYuHt = parcelRequire("cYuHt");
const $f4242736fa792950$export$a63913da797715a6 = async (cloudId, spaceKey, parentPageId, sprintId, blueprintId, isLiveDoc)=>{
    const [sprint] = await Promise.all([
        (0, $cYuHt.getSprint)(sprintId)
    ]);
    const title = `Retrospective: ${sprint.name}`;
    if (!blueprintId) throw new Error('User attempted to create a Confluence page retro, but no retro blueprint was found');
    return (0, $7f4tk.default)(`/gateway/api/ex/confluence/${cloudId}/wiki/rest/create-dialog/1.0/content/blueprint/${(0, $63b79f4ff36af7f3$export$48a96ef844462313)}/instance`, {
        method: 'POST',
        body: JSON.stringify({
            content: {
                type: 'page',
                title: title,
                status: 'draft',
                ancestors: parentPageId ? [
                    {
                        id: parentPageId
                    }
                ] : undefined,
                space: {
                    key: spaceKey
                },
                // these values are required to create an NCS page
                metadata: {
                    properties: {
                        editor: {
                            value: 'v2'
                        }
                    },
                    frontend: {
                        embedded: true
                    }
                },
                ...isLiveDoc && {
                    subType: 'live'
                }
            },
            contentBlueprintSpec: {
                context: {
                    spaceKey: spaceKey,
                    parentPageId: parentPageId
                },
                blueprintId: blueprintId
            }
        })
    });
};

});
const $63b79f4ff36af7f3$export$48a96ef844462313 = 'com.atlassian.confluence.plugins.confluence-software-blueprints:retrospectives-blueprint';

parcelRegister("cYuHt", function(module, exports) {

$parcel$export(module.exports, "getSprint", () => $28d2a59892eb2d5b$export$4402d4ed26f26131);

var $7f4tk = parcelRequire("7f4tk");
const $28d2a59892eb2d5b$export$4402d4ed26f26131 = async (sprintId)=>(0, $7f4tk.default)(`/rest/agile/1.0/sprint/${sprintId}`);

});


parcelRegister("b7gdg", function(module, exports) {

$parcel$export(module.exports, "createWhiteboard", () => $ed7d58a2374be2eb$export$36ce0aac6b5c6804);

var $7f4tk = parcelRequire("7f4tk");
const $ed7d58a2374be2eb$export$36ce0aac6b5c6804 = async (cloudId, spaceId, parentId, templateKey)=>(0, $7f4tk.default)(`/gateway/api/ex/confluence/${cloudId}/wiki/api/v2/whiteboards`, {
        method: 'POST',
        body: JSON.stringify({
            spaceId: spaceId,
            parentId: parentId || null,
            templateKey: templateKey
        })
    });

});

parcelRegister("c85ZN", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $c4ef19a54ae6936a$export$d4c72bab9d6cc13a);

var $kGefV = parcelRequire("kGefV");
const $c4ef19a54ae6936a$export$d4c72bab9d6cc13a = {
    sprintId: undefined,
    shouldCreateRetro: false,
    loadCreateRetroModal: false,
    loadCrossFlowModal: false,
    loadCrossJoinModal: false,
    isRetroLinked: false,
    isRetroLinking: false,
    isRetroPublished: false,
    isWhiteboardsDisabled: false,
    retroLinkingError: undefined,
    retroType: (0, $kGefV.RetroTypes).WHITEBOARD,
    confluenceData: {
        spaceKey: undefined,
        parentPageId: undefined,
        spaceId: undefined
    },
    createRetroPage: {
        data: undefined,
        loading: false,
        error: undefined
    },
    createWhiteboard: {
        data: undefined,
        loading: false,
        error: undefined
    }
};

});
parcelRegister("kGefV", function(module, exports) {

$parcel$export(module.exports, "RetroTypes", () => $030b4200896d24ad$export$1da38a077679bab0);
const $030b4200896d24ad$export$1da38a077679bab0 = {
    WHITEBOARD: 'whiteboard',
    PAGE: 'page'
};

});





parcelRegister("bOsIL", function(module, exports) {

$parcel$export(module.exports, "completeSprintModalEntryPoint", () => $da8db933301c2e65$export$e19f219885fe8c5f);

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $j4C5v = parcelRequire("j4C5v");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $da8db933301c2e65$export$e19f219885fe8c5f = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("aAjI0")), {
        moduleId: "3d417b0d"
    }),
    getPreloadProps: ({ jiraProjectAri: jiraProjectAri, updatedFromDeploymentsDate: updatedFromDeploymentsDate, boardId: boardId, activeSprintIds: activeSprintIds })=>({
            queries: {
                completeSprintMetadata: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $j4C5v.default,
                    variables: {
                        jiraProjectAri: jiraProjectAri,
                        updatedFromDeploymentsDate: updatedFromDeploymentsDate,
                        boardId: boardId,
                        activeSprintIds: activeSprintIds,
                        isCssReductionEnabled: // eslint-disable-next-line jira/ff/no-preconditioning
                        (0, $4R6GH.fg)('incomplete_issues_when_closing_a_sprint_gate') && (0, $6s1PB.expValEquals)('incomplete_issues_when_closing_a_sprint', 'cohort', 'test')
                    }
                }
            }
        })
});

});
parcelRegister("j4C5v", function(module, exports) {

$parcel$export(module.exports, "default", () => $65bc3007e99f5743$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7bf9edb2c7b6d9d66214e51140f8e3c1>>
 * @relayHash 27527c08f2750b205f0c72f03077cd6e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fdad91f830d5bcb6a2dba58d5b2d28d9cceb4f17e31ee5115b4e9591b0f830ac
const $65bc3007e99f5743$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "fdad91f830d5bcb6a2dba58d5b2d28d9cceb4f17e31ee5115b4e9591b0f830ac",
        "metadata": {},
        "name": "mainCompleteSprintMetadataQuery",
        "operationKind": "query",
        "text": null
    }
};
var $65bc3007e99f5743$export$2e2bcd8739ae039 = $65bc3007e99f5743$var$node;

});

parcelRegister("aAjI0", function(module, exports) {

let $7b4c8df082673dee$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7b4c8df082673dee$var$load("1xx1S").then(()=>parcelRequire('4gPTd'));

});



parcelRegister("2dBGm", function(module, exports) {

$parcel$export(module.exports, "default", () => $45258e61f7660708$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");


var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $kwBUh = parcelRequire("kwBUh");

var $45Qwd = parcelRequire("45Qwd");

var $k35me = parcelRequire("k35me");

var $fSgHa = parcelRequire("fSgHa");

var $9g0YE = parcelRequire("9g0YE");

var $dZ8RF = parcelRequire("dZ8RF");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$45258e61f7660708$export$2e2bcd8739ae039 = ({ cardListId: cardListId, isShowingRecommendations: isShowingRecommendations })=>{
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const columns = (0, $c1MAf.useBacklogSelector)((0, $kwBUh.getColumns));
    const estimations = (0, $c1MAf.useBacklogSelector)((state)=>columns !== null || (0, $4R6GH.fg)('eager_rendering_estimations_in_backlog') ? (0, $k35me.makeGetSprintEstimations)(state)(cardListId) : null);
    const estimationType = (0, $c1MAf.useBacklogSelector)((0, $45Qwd.getEstimationType));
    const timeTrackingOptions = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getTimeTrackingOptions));
    const isCompanyManaged = (0, $fSgHa.useIsCMPBacklog)();
    const estimationName = (0, $c1MAf.useBacklogSelector)((0, $45Qwd.getEstimationName));
    const totalEstimations = estimations ? Object.values(estimations).reduce((a, b)=>a + b, 0) : 0;
    const cardOrder = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getOrderedCardIdsByCardListId));
    const totalCards = cardOrder[cardListId]?.length ?? 0;
    const columnCounts = isCompanyManaged ? (0, $kwBUh.getColumnCount)(columns) : undefined;
    const rapidViewId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getRapidViewId));
    const onToggleInsightsPanel = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $9g0YE.togglePanel)((0, $c35fd6591a78fffe$export$29d7f2210b16d662)));
    }, [
        dispatch
    ]);
    const props = {
        estimations: estimations,
        estimationType: estimationType,
        timeTrackingOptions: timeTrackingOptions,
        isCompanyManaged: isCompanyManaged,
        estimationName: estimationName,
        totalEstimations: totalEstimations,
        totalCards: totalCards,
        columnCounts: columnCounts,
        rapidViewId: rapidViewId,
        onToggleInsightsPanel: onToggleInsightsPanel,
        isShowingRecommendations: isShowingRecommendations
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZ8RF.Estimations), props);
};

});
parcelRegister("dZ8RF", function(module, exports) {

$parcel$export(module.exports, "Estimations", () => $34324323f3a3472b$export$df255ecd06d2abc3);

var $5uXOq = parcelRequire("5uXOq");

var $dS3PR = parcelRequire("dS3PR");

var $fNobW = parcelRequire("fNobW");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $5bOnh = parcelRequire("5bOnh");

var $etKNj = parcelRequire("etKNj");

var $dCm1o = parcelRequire("dCm1o");

var $7CMCs = parcelRequire("7CMCs");

var $cL3Uo = parcelRequire("cL3Uo");

var $guzeq = parcelRequire("guzeq");


var $3KA8f = parcelRequire("3KA8f");

var $6hYI0 = parcelRequire("6hYI0");
const $34324323f3a3472b$export$df255ecd06d2abc3 = ({ estimations: estimations, estimationType: estimationType, timeTrackingOptions: timeTrackingOptions, isCompanyManaged: isCompanyManaged, estimationName: estimationName, totalEstimations: totalEstimations, totalCards: totalCards, columnCounts: columnCounts, tooltipDelay: tooltipDelay, rapidViewId: rapidViewId, onToggleInsightsPanel: onToggleInsightsPanel, isShowingRecommendations: isShowingRecommendations })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const formatStoryPointsTotal = (0, $cL3Uo.useFormatStoryPointsTotal)();
    const formatEstimationValue = (value)=>{
        if (estimationType === (0, $guzeq.ORIGINAL_ESTIMATE)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return (0, $etKNj.timeTrackingFormatter)(value, timeTrackingOptions, {
            formatMessage: formatMessage
        });
        // fix for floating point math issues (like 0.1 + 0.2 becomes 0.30000000000000004)
        // as the numbers end with lots of zeroes followed by a single digit, trimming
        // after 8 decimal points results in a sane representation
        return formatStoryPointsTotal(value);
    };
    const getTotal = ()=>{
        if (estimationType === (0, $guzeq.ORIGINAL_ESTIMATE)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return (0, $etKNj.timeTrackingFormatter)(totalEstimations, timeTrackingOptions, {
            formatMessage: formatMessage
        });
        return formatEstimationValue(estimationType === (0, $guzeq.STORY_POINTS) ? totalEstimations : totalCards);
    };
    const makeStatusWithoutDescription = (statusMessage, estimationFormatted, total, tooltipTarget)=>`${formatMessage(statusMessage)}: ${formatMessage((0, $6hYI0.default).tooltip, {
            count: estimationFormatted,
            total: total,
            estimationName: (isCompanyManaged && estimationName && estimationName !== (0, $7aa9ed31c5ab3869$export$2c9ef5d2c18593f7) ? estimationName : tooltipTarget).toLowerCase()
        })}`;
    const makeTooltipContent = (statusMessage, total, tooltipTarget, estimationCount, statusDescription)=>{
        if (isCompanyManaged) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
            as: "strong",
            color: "color.text.inverse"
        }, formatMessage(statusMessage)), statusDescription ? ` (${formatMessage(statusDescription.statusDescriptionMessage, {
            ...statusDescription.statusDescriptionMessageParams
        })})` : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null), formatMessage((0, $6hYI0.default).tooltip, {
            count: estimationCount,
            total: total,
            estimationName: (isCompanyManaged && estimationName && estimationName !== (0, $7aa9ed31c5ab3869$export$2c9ef5d2c18593f7) ? estimationName : tooltipTarget).toLowerCase()
        }));
        return makeStatusWithoutDescription(statusMessage, estimationCount, total, tooltipTarget);
    };
    const makeScreenReaderMessage = (statusMessage, total, tooltipTarget, estimateCount, statusDescription)=>{
        if (isCompanyManaged) return `${formatMessage(statusMessage)}${statusDescription ? ` (${formatMessage(statusDescription.statusDescriptionMessage, {
            ...statusDescription.statusDescriptionMessageParams
        })})` : ''}: ${formatMessage((0, $6hYI0.default).tooltip, {
            count: estimateCount,
            total: total,
            estimationName: (isCompanyManaged && estimationName && estimationName !== (0, $7aa9ed31c5ab3869$export$2c9ef5d2c18593f7) ? estimationName : tooltipTarget).toLowerCase()
        })}`;
        return makeStatusWithoutDescription(statusMessage, estimateCount, total, tooltipTarget);
    };
    const formatEstimation = (estimationValue)=>{
        const value = estimationValue || 0;
        return estimationType === (0, $guzeq.ORIGINAL_ESTIMATE) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $etKNj.timeTrackingFormatter)(value, timeTrackingOptions, {
            formatMessage: formatMessage
        }) : formatEstimationValue(value);
    };
    const makeTooltipContentForEstimationGroups = ()=>{
        const { inProgressColumnCount: inProgressColumnCount } = columnCounts || {};
        const showStatusDescriptionForNotStartedAndDone = inProgressColumnCount && inProgressColumnCount > 0;
        const notStarted = {
            status: isCompanyManaged ? (0, $6hYI0.default).notStartedV2 : (0, $6hYI0.default).notStarted,
            statusDescription: isCompanyManaged && showStatusDescriptionForNotStartedAndDone ? {
                message: (0, $6hYI0.default).leftmostColumn
            } : undefined,
            estimationValue: formatEstimation(estimations?.NOT_STARTED)
        };
        const inProgress = {
            status: isCompanyManaged ? (0, $6hYI0.default).inProgressV2 : (0, $6hYI0.default).inProgress,
            statusDescription: undefined,
            estimationValue: formatEstimation(estimations?.IN_PROGRESS)
        };
        const done = {
            status: isCompanyManaged ? (0, $6hYI0.default).completed : (0, $6hYI0.default).done,
            statusDescription: isCompanyManaged && showStatusDescriptionForNotStartedAndDone ? {
                message: (0, $6hYI0.default).rightmostColumn
            } : undefined,
            estimationValue: formatEstimation(estimations?.DONE)
        };
        const tooltipTypes = Object.freeze({
            [(0, $guzeq.ORIGINAL_ESTIMATE)]: (0, $6hYI0.default).originalEstimate,
            [(0, $guzeq.STORY_POINTS)]: (0, $6hYI0.default).storyPoints,
            [(0, $guzeq.ISSUE_COUNT)]: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $6hYI0.default).issueCountIssueTermRefresh : (0, $6hYI0.default).issueCount
        });
        const tooltipTarget = formatMessage(tooltipTypes[estimationType] || ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $6hYI0.default).issueCountIssueTermRefresh : (0, $6hYI0.default).issueCount));
        const total = getTotal();
        return {
            notStarted: notStarted,
            inProgress: inProgress,
            done: done,
            tooltipTarget: tooltipTarget,
            total: total
        };
    };
    if (estimations) {
        const { notStarted: notStarted, inProgress: inProgress, done: done, tooltipTarget: tooltipTarget, total: total } = makeTooltipContentForEstimationGroups();
        const { inProgressColumnCount: inProgressColumnCount, doneColumnCount: doneColumnCount } = columnCounts || {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KA8f.default), {
            appearance: "default",
            max: (0, $guzeq.ESTIMATION_ROLLUP_BADGE_MAX),
            tooltipContent: makeTooltipContent(notStarted.status, total, tooltipTarget, notStarted.estimationValue, notStarted.statusDescription ? {
                statusDescriptionMessage: notStarted.statusDescription.message
            } : undefined),
            tooltipDelay: tooltipDelay,
            screenReaderMessage: makeScreenReaderMessage(notStarted.status, total, tooltipTarget, notStarted.estimationValue, notStarted.statusDescription ? {
                statusDescriptionMessage: notStarted.statusDescription.message
            } : undefined)
        }, formatEstimationValue(estimations.NOT_STARTED)), (inProgressColumnCount && inProgressColumnCount > 0 || !isCompanyManaged) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KA8f.default), {
            // eslint-disable-next-line jira/react/no-style-attribute
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                backgroundColor: "var(--ds-border-information, #1D7AFC)"
            },
            appearance: "primary",
            max: (0, $guzeq.ESTIMATION_ROLLUP_BADGE_MAX),
            tooltipContent: makeTooltipContent(inProgress.status, total, tooltipTarget, inProgress.estimationValue, undefined),
            tooltipDelay: tooltipDelay,
            screenReaderMessage: makeScreenReaderMessage(inProgress.status, total, tooltipTarget, inProgress.estimationValue, inProgress.statusDescription)
        }, formatEstimationValue(estimations.IN_PROGRESS)), (doneColumnCount && doneColumnCount === 1 || !isCompanyManaged) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KA8f.default), {
            appearance: (0, $dCm1o.isVisualRefreshEnabled)() ? 'added' : undefined,
            // eslint-disable-next-line jira/react/no-style-attribute
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                backgroundColor: "var(--ds-border-success, #22A06B)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                color: "var(--ds-text-inverse, #FFFFFF)"
            },
            max: (0, $guzeq.ESTIMATION_ROLLUP_BADGE_MAX),
            tooltipContent: makeTooltipContent(done.status, total, tooltipTarget, done.estimationValue, done.statusDescription ? {
                statusDescriptionMessage: done.statusDescription.message
            } : undefined),
            tooltipDelay: tooltipDelay,
            screenReaderMessage: makeScreenReaderMessage(done.status, total, tooltipTarget, done.estimationValue, done.statusDescription ? {
                statusDescriptionMessage: done.statusDescription.message
            } : undefined)
        }, formatEstimationValue(estimations.DONE)), isShowingRecommendations && (0, $6s1PB.expValEquals)('jira_insights_backlog_recommendations', 'cohort', 'variation') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
            fallback: "unmount",
            id: "sprintCommitmentIndicator",
            packageName: "jiraSprintCommitmentIndicator",
            teamName: "helios-reports"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5bOnh.SprintCommitmentIndicator), {
            rapidViewId: rapidViewId,
            committed: totalEstimations,
            estimationType: estimationType === 'ORIGINAL_ESTIMATE' ? 'TIME_TRACKING' : estimationType,
            onToggleInsightsPanel: onToggleInsightsPanel
        })) : null);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: "estimations"
    }, null);
};

});
parcelRegister("5bOnh", function(module, exports) {

$parcel$export(module.exports, "SprintCommitmentIndicator", () => $09f0fae4a1c37801$export$8fcbb9b1158abf8b);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");

var $eCeGD = parcelRequire("eCeGD");
var $42CjB = parcelRequire("42CjB");

var $7EZ5v = parcelRequire("7EZ5v");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $koeKL = parcelRequire("koeKL");

var $cpUUk = parcelRequire("cpUUk");

var $jgJNO = parcelRequire("jgJNO");

var $etKNj = parcelRequire("etKNj");

var $7L5ar = parcelRequire("7L5ar");

var $8zOmE = parcelRequire("8zOmE");

var $bSSG7 = parcelRequire("bSSG7");

var $7aoh6 = parcelRequire("7aoh6");

var $3iiba = parcelRequire("3iiba");

var $e4xeo = parcelRequire("e4xeo");

var $5Gv28 = parcelRequire("5Gv28");

var $8wntT = parcelRequire("8wntT");
const $09f0fae4a1c37801$var$useJqlStorage = (0, $bSSG7.createLocalStorageProvider)((0, $7aoh6.USE_JQL_STORAGE).namespace);
const $09f0fae4a1c37801$export$8fcbb9b1158abf8b = ({ rapidViewId: rapidViewId, committed: committed, estimationType: estimationType, onToggleInsightsPanel: onToggleInsightsPanel })=>{
    const intl = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    /*
   * This requires the backlog or board button to render to populate this value via <CheckClassicViewAggregatedDataPermission />.
   * This can be removed and harcoded to true once insights-use_jql_query_for_enabled_users is cleaned up
   *
   * Defaulting this to "true" because this is valid whether user has view aggregated data permission or not.
   * It may be set to false if user has permission to view aggregated data and the flag is not rolled out.
   */ const shouldUseJQLData = $09f0fae4a1c37801$var$useJqlStorage.get((0, $7aoh6.USE_JQL_STORAGE).key) ?? true;
    const onClick = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        setIsOpen(false);
        onToggleInsightsPanel();
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'toggleInsightsPanel', {
            source: 'sprintCommitmentIndicator'
        });
    }, [
        onToggleInsightsPanel
    ]);
    const formatter = (0, $5uXOq.useCallback)((value)=>estimationType === (0, $cpUUk.EstimationUnit).TIME_TRACKING ? (0, $etKNj.timeTrackingFormatter)(value || 0, (0, $7L5ar.TIME_FORMAT_DEFAULT), intl) : value, [
        estimationType,
        intl
    ]);
    const [{ fetched: fetched, loading: loading, data: untypedData, error: error }, { doFetch: doFetch }] = (0, $3iiba.useSprintCommitmentFetcher)({
        getParams: ()=>({
                cloudId: cloudId,
                rapidViewId: rapidViewId,
                shouldUseJQLData: shouldUseJQLData
            })
    }, [
        cloudId,
        rapidViewId
    ]);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const data = untypedData;
    // Note: When an error is present, fetched is NOT set to true.
    if (!fetched && !loading && !data && !error) {
        doFetch({
            cloudId: cloudId,
            rapidViewId: rapidViewId,
            shouldUseJQLData: shouldUseJQLData
        });
        return null;
    }
    if (loading || !data || error) return null;
    const transform = (0, $5Gv28.getSprintEstimationTransformer)({
        committed: committed,
        estimationType: estimationType
    });
    const { range: range, recommendationStatus: recommendationStatus } = transform(data);
    if (recommendationStatus === 'NO_TARGET' || !range) return null;
    const message = ((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $8wntT.TooltipMessages) : (0, $8wntT.TooltipMessagesOld))[estimationType][recommendationStatus];
    const label = (0, $8wntT.RecommendationLabel)[recommendationStatus];
    const { Icon: Icon, iconColor: iconColor } = (0, $8wntT.RecommendationIcon)[recommendationStatus];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-end",
        messageId: "sprint-commitment-indicator.ui.popup",
        messageType: "transactional",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                paddingBlock: "space.200",
                paddingInline: "space.300"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
                alignInline: "start",
                space: "space.100"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, intl.formatMessage(message, {
                committed: formatter(committed),
                lowTarget: formatter(range.lower),
                highTarget: formatter(range.upper)
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
                iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($7EZ5v))),
                onClick: onClick
            }, intl.formatMessage((0, $e4xeo.default).insightsButton)))),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
                ...triggerProps,
                appearance: "subtle",
                icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
                        ...iconProps,
                        color: iconColor
                    }),
                label: formatMessage(label),
                onClick: (_, analyticsEvent)=>{
                    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'sprintCommitmentIndicator');
                    setIsOpen(!isOpen);
                },
                spacing: "compact"
            })
    });
};

});
parcelRegister("cpUUk", function(module, exports) {

$parcel$export(module.exports, "EstimationUnit", () => $e74c6047a4f07896$export$65cc899e447718b8);
const $e74c6047a4f07896$export$65cc899e447718b8 = {
    STORY_POINTS: 'STORY_POINTS',
    ISSUE_COUNT: 'ISSUE_COUNT',
    TIME_TRACKING: 'TIME_TRACKING',
    OTHER: 'OTHER'
};
const $e74c6047a4f07896$export$c17e0027053340c = 'OTHER';

});

parcelRegister("7L5ar", function(module, exports) {

$parcel$export(module.exports, "BEACON_ID", () => $190abaa7d2ef04d9$export$b9a866157fdcb65e);
$parcel$export(module.exports, "ARTICLE_ID_NOT_SUPPORTED_ESTIMATION_CMP", () => $190abaa7d2ef04d9$export$94cfff03fd5b4367);
$parcel$export(module.exports, "ARTICLE_ID_NOT_SUPPORTED_ESTIMATION_TMP", () => $190abaa7d2ef04d9$export$cee1962eb5050206);
$parcel$export(module.exports, "ARTICLE_ID", () => $190abaa7d2ef04d9$export$7147685613ef9998);
$parcel$export(module.exports, "ERROR_MESSAGE", () => $190abaa7d2ef04d9$export$3f27bc10068ef877);
$parcel$export(module.exports, "ARTICLE_ID_NO_SPRINT_CMP", () => $190abaa7d2ef04d9$export$5076138ba551bde6);
$parcel$export(module.exports, "ARTICLE_ID_NO_SPRINT_TMP", () => $190abaa7d2ef04d9$export$24fd8b92acb06ff5);
$parcel$export(module.exports, "supportedEstimationTypes", () => $190abaa7d2ef04d9$export$9bb69560090dc79f);
$parcel$export(module.exports, "SPRINT_COMMITMENT_INFO_PANEL_ID", () => $190abaa7d2ef04d9$export$21aed699890df444);
$parcel$export(module.exports, "RecommendationStatus", () => $190abaa7d2ef04d9$export$b6c25459278323a0);
$parcel$export(module.exports, "responseTypes", () => $190abaa7d2ef04d9$export$a6f212d4ee888d8c);
$parcel$export(module.exports, "SPRINT_COMMITMENT_RECALCULATING", () => $190abaa7d2ef04d9$export$f3ff0bca6c5c6e55);
$parcel$export(module.exports, "TIME_FORMAT_DEFAULT", () => $190abaa7d2ef04d9$export$94fc4eee82b1f769);

var $cpUUk = parcelRequire("cpUUk");

var $gBj4V = parcelRequire("gBj4V");
const $190abaa7d2ef04d9$export$b9a866157fdcb65e = 'sprint-commitment';
const $190abaa7d2ef04d9$export$94cfff03fd5b4367 = '6brtL6Kql0YzSBOpfc96Bx';
const $190abaa7d2ef04d9$export$cee1962eb5050206 = '1Qh9BVeOgie6iCQEEWe7Ng';
const $190abaa7d2ef04d9$export$7147685613ef9998 = '5GAjYfj1sNAmiG6ajBmZ8k';
const $190abaa7d2ef04d9$export$3f27bc10068ef877 = 'No estimations';
const $190abaa7d2ef04d9$export$5076138ba551bde6 = '7oORaI2BNlPTvZaUnzJV71';
const $190abaa7d2ef04d9$export$24fd8b92acb06ff5 = '17PhFKPmse8Z7KWZcPMulA';
const $190abaa7d2ef04d9$export$9bb69560090dc79f = [
    (0, $cpUUk.EstimationUnit).STORY_POINTS,
    (0, $cpUUk.EstimationUnit).ISSUE_COUNT,
    (0, $cpUUk.EstimationUnit).TIME_TRACKING
];
const $190abaa7d2ef04d9$export$21aed699890df444 = 'insights.sprint-commitment.info-panel.id';
const $190abaa7d2ef04d9$export$b6c25459278323a0 = {
    BELOW_TARGET: 'BELOW_TARGET',
    ABOVE_TARGET: 'ABOVE_TARGET',
    WITHIN_TARGET: 'WITHIN_TARGET',
    NO_TARGET: 'NO_TARGET'
};
const $190abaa7d2ef04d9$var$RECALCULATING = 'RECALCULATING';
const $190abaa7d2ef04d9$export$a6f212d4ee888d8c = {
    SUCCESS: 'SUCCESS',
    RECALCULATING: $190abaa7d2ef04d9$var$RECALCULATING
};
const $190abaa7d2ef04d9$export$f3ff0bca6c5c6e55 = {
    type: $190abaa7d2ef04d9$export$a6f212d4ee888d8c.RECALCULATING
};
const $190abaa7d2ef04d9$export$94fc4eee82b1f769 = {
    workingDaysPerWeek: 0,
    workingHoursPerDay: 0,
    timeFormat: (0, $gBj4V.TimeFormats).PRETTY,
    defaultUnit: (0, $gBj4V.TimeUnits).HOUR
};

});

parcelRegister("7aoh6", function(module, exports) {

$parcel$export(module.exports, "INSIGHT_PERMISSION_ACTION_SUBJECT_ID", () => $4de57a9072cf4c55$export$5dad270161d08a8c);
$parcel$export(module.exports, "USE_JQL_STORAGE", () => $4de57a9072cf4c55$export$36d083914f36b177);
const $4de57a9072cf4c55$export$5dad270161d08a8c = 'check-insight-permission';
const $4de57a9072cf4c55$export$36d083914f36b177 = {
    namespace: 'jira-insights-should-use-jql',
    key: 'shouldUseJQLQuery'
};

});

parcelRegister("3iiba", function(module, exports) {

$parcel$export(module.exports, "useSprintCommitmentFetcher", () => $c31e636a8a02c3f3$export$4297ae7b2909b6c4);

var $9JAGR = parcelRequire("9JAGR");

var $9tkyc = parcelRequire("9tkyc");
const $c31e636a8a02c3f3$var$PACKAGE_NAME = 'jiraSprintCommitmentIndicator';
const $c31e636a8a02c3f3$export$cdd903a3c2fc437e = 'getSprintCommitment';
const $c31e636a8a02c3f3$var$Store = (0, $9JAGR.createFetchStore)({
    name: 'sprint-commitment-store'
});
const $c31e636a8a02c3f3$export$a909522614781344 = (0, $9JAGR.createFetcher)({
    getKey: ({ cloudId: cloudId, rapidViewId: rapidViewId })=>`sprint-commitment-${cloudId}-${rapidViewId}`,
    getData: (fetchOptions, { cloudId: cloudId, rapidViewId: rapidViewId, shouldUseJQLData: shouldUseJQLData })=>{
        return (0, $9tkyc.fetchArisSprintCommitmentResponseSuccess)({
            cloudId: cloudId,
            rapidViewId: rapidViewId,
            shouldUseJQLData: shouldUseJQLData
        }, fetchOptions);
    },
    getProps: ()=>({
            analyticsTracking: {
                actionSubject: `useFetch.${$c31e636a8a02c3f3$export$cdd903a3c2fc437e}`,
                packageName: $c31e636a8a02c3f3$var$PACKAGE_NAME,
                action: 'dataFetch'
            },
            loggingKey: `${$c31e636a8a02c3f3$var$PACKAGE_NAME}.${$c31e636a8a02c3f3$export$cdd903a3c2fc437e}`,
            isAutoFetchable: false
        })
});
const $c31e636a8a02c3f3$export$4297ae7b2909b6c4 = (0, $9JAGR.createFetchHook)($c31e636a8a02c3f3$export$a909522614781344, $c31e636a8a02c3f3$var$Store);

});
parcelRegister("9JAGR", function(module, exports) {

$parcel$export(module.exports, "createFetchStore", () => $3987e07a58d028f6$export$2223335fbc973928);
$parcel$export(module.exports, "createFetcher", () => $3987e07a58d028f6$export$be9296b8fbc3de66);
$parcel$export(module.exports, "createFetchHook", () => $3987e07a58d028f6$export$ba2072f3f3221e6e);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $aAhmV = parcelRequire("aAhmV");

var $gLPHG = parcelRequire("gLPHG");

var $dg0bO = parcelRequire("dg0bO");
const $3987e07a58d028f6$var$initialStoreState = {
    fetchables: {}
};
const $3987e07a58d028f6$var$actions = (0, $aAhmV.buildSweetStateActionDispatchers)();
const $3987e07a58d028f6$export$2223335fbc973928 = ({ name: name })=>(0, $iXqE5.createStore)({
        initialState: $3987e07a58d028f6$var$initialStoreState,
        actions: $3987e07a58d028f6$var$actions,
        name: `use-fetch-store:${name}`
    });
const $3987e07a58d028f6$export$be9296b8fbc3de66 = (config)=>{
    if (config.getProps === undefined) return {
        key: config.getKey,
        fetch: config.getData,
        props: ()=>({})
    };
    return {
        key: config.getKey,
        fetch: config.getData,
        props: config.getProps
    };
};
const $3987e07a58d028f6$export$ba2072f3f3221e6e = (fetcher, FetchStore)=>{
    const useFetchSweetState = (0, $3sQ5x.createHook)(FetchStore, {
        selector: (state, { key: key })=>key && state.fetchables[key] || (0, $dg0bO.initialState)
    });
    const useFetchState = ({ initialData: initialData, key: key = 'static' })=>{
        const [state, sweetStateActions] = useFetchSweetState({
            key: key
        });
        const memoActions = (0, $5uXOq.useMemo)(()=>(0, $aAhmV.hydrateSweetStateActionsDispatchers)({
                // @ts-expect-error - TS2322 - Type 'BoundActions<SweetState, BuildSweetStateActionDispatchersProps>' is not assignable to type 'BuildSweetStateActionDispatchersProps'.
                actions: sweetStateActions,
                key: key,
                initialData: initialData
            }), [
            sweetStateActions,
            initialData,
            key
        ]);
        return [
            state,
            memoActions
        ];
    };
    // @ts-expect-error - TS2322 - Type '({ initialData, key }: UseFetchStateProps) => readonly [any, BuildActionDispatchersProps]' is not assignable to type 'UseFetchReducer'.
    const dynamicHook = (0, $gLPHG.buildHook)({
        useFetchState: useFetchState
    });
    return ({ getParams: getParams } = {}, effects)=>{
        const params = getParams?.();
        const { onFetch: onFetch, key: key, props: props } = (0, $5uXOq.useMemo)(()=>{
            const sliceKey = fetcher.key(params);
            const fetch = (signal)=>fetcher.fetch(signal, params);
            const propsHook = fetcher.props(params);
            return {
                onFetch: fetch,
                key: sliceKey,
                props: propsHook
            };
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, effects);
        return dynamicHook({
            onFetch: onFetch,
            key: key,
            ...props
        }, effects);
    };
};

});
parcelRegister("aAhmV", function(module, exports) {

$parcel$export(module.exports, "buildActionDispatchers", () => $b5443ab87e9d487f$export$5297818927df1cbf);
$parcel$export(module.exports, "buildSweetStateActionDispatchers", () => $b5443ab87e9d487f$export$25b8423a7d935d64);
$parcel$export(module.exports, "hydrateSweetStateActionsDispatchers", () => $b5443ab87e9d487f$export$7f88d514aa0ad345);

var $aTJxm = parcelRequire("aTJxm");
const $b5443ab87e9d487f$export$5297818927df1cbf = (dispatch)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys((0, $aTJxm.strategies)).reduce((accumulator, strategy)=>{
        accumulator[strategy] = (payload)=>dispatch({
                type: strategy,
                payload: payload
            });
        return accumulator;
    }, {});
const $b5443ab87e9d487f$export$25b8423a7d935d64 = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys((0, $aTJxm.strategies)).reduce((accumulator, strategy)=>{
        accumulator[strategy] = (key, initialData, payload)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const sliceState = state.fetchables[key] || initialData;
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly resetInitialState: () => { readonly initialized: false; readonly loading: false; readonly fetched: false; readonly hasError: false; readonly aborted: false; readonly error: undefined; readonly data: undefined; }; ... 4 more ...; readonly default: (state: FetchState) => FetchState; }'.
                const nextSliceState = (0, $aTJxm.strategies)[strategy](sliceState, {
                    type: strategy,
                    payload: payload
                });
                const nextState = {
                    ...state,
                    fetchables: {
                        ...state.fetchables,
                        [key]: nextSliceState
                    }
                };
                setState(nextState);
            };
        return accumulator;
    }, {});
const $b5443ab87e9d487f$export$7f88d514aa0ad345 = ({ actions: actions, key: key, initialData: initialData })=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(actions).reduce((accumulator, strategy)=>{
        const actionExecutor = actions[strategy];
        accumulator[strategy] = (payload)=>{
            actionExecutor(key, initialData, payload);
        };
        return accumulator;
    }, {});

});
parcelRegister("aTJxm", function(module, exports) {

$parcel$export(module.exports, "strategies", () => $e708554df9e0cc9d$export$c5491a8691a23b9e);

var $dg0bO = parcelRequire("dg0bO");
const $e708554df9e0cc9d$var$resetInitialState = ()=>(0, $dg0bO.initialState);
const $e708554df9e0cc9d$var$setFetchStart = (state)=>({
        ...state,
        initialized: true,
        loading: true,
        fetched: false,
        hasError: false,
        aborted: false
    });
const $e708554df9e0cc9d$var$setFetchEnd = (_, action)=>({
        initialized: true,
        loading: false,
        fetched: true,
        hasError: false,
        aborted: false,
        data: action.payload
    });
const $e708554df9e0cc9d$var$setError = (_, action)=>({
        error: action.payload,
        initialized: true,
        loading: false,
        fetched: false,
        hasError: true,
        aborted: false
    });
const $e708554df9e0cc9d$var$setAborted = ()=>({
        initialized: true,
        loading: false,
        fetched: false,
        hasError: false,
        aborted: true
    });
const $e708554df9e0cc9d$var$setDefault = (state)=>state;
const $e708554df9e0cc9d$export$c5491a8691a23b9e = {
    resetInitialState: $e708554df9e0cc9d$var$resetInitialState,
    setFetchStart: $e708554df9e0cc9d$var$setFetchStart,
    setFetchEnd: $e708554df9e0cc9d$var$setFetchEnd,
    setError: $e708554df9e0cc9d$var$setError,
    setAborted: $e708554df9e0cc9d$var$setAborted,
    default: $e708554df9e0cc9d$var$setDefault
};

});
parcelRegister("dg0bO", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $147c98f07a60815a$export$d4c72bab9d6cc13a);
const $147c98f07a60815a$export$d4c72bab9d6cc13a = {
    initialized: false,
    loading: false,
    fetched: false,
    hasError: false,
    aborted: false,
    error: undefined,
    data: undefined
};

});



parcelRegister("gLPHG", function(module, exports) {

$parcel$export(module.exports, "buildHook", () => $a16ff850ca7f7d56$export$fc035abcdd1a05a2);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $d6Xq4 = parcelRequire("d6Xq4");

var $lUlda = parcelRequire("lUlda");

var $eW4Xh = parcelRequire("eW4Xh");
const $a16ff850ca7f7d56$export$fc035abcdd1a05a2 = // @ts-expect-error - TS2741 - Property 'useFetchState' is missing in type '{}' but required in type 'BuildHookProps'.
({ useFetchState: useFetchState } = {})=>(hookProps, fetchDependencies)=>{
        const { isAutoFetchable: isAutoFetchable = true, analyticsTracking: analyticsTracking, browserMetricsKey: browserMetricsKey, loggingKey: loggingKey, initialData: initialData, isAbortable: isAbortable = true, onFetch: onFetch, key: key } = hookProps;
        const [state, actions] = useFetchState({
            initialData: initialData,
            key: key
        });
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
        const { initialized: initialized, fetched: fetched, loading: loading } = state;
        const abortControllerRef = (0, $5uXOq.useRef)();
        const fetchDependenciesRef = (0, $5uXOq.useRef)(fetchDependencies);
        const isMounted = (0, $5uXOq.useRef)(true);
        const getAbortController = (0, $5uXOq.useCallback)(()=>{
            const controller = abortControllerRef.current;
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            if (!abortControllerRef.current || controller?.signal.aborted) abortControllerRef.current = new AbortController();
            return abortControllerRef.current;
        }, []);
        const callFetch = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
        (...args)=>{
            // @ts-expect-error - TS2339 - Property 'signal' does not exist on type 'unknown'.
            const { signal: signal } = getAbortController();
            (0, $eW4Xh.thunks).fetch({
                onFetch: async ()=>{
                    try {
                        return await onFetch({
                            signal: signal
                        }, ...args);
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } catch (e) {
                        throw new (0, $d6Xq4.UseFetchHandledError)(isMounted.current, e);
                    }
                },
                analyticsTracking: analyticsTracking,
                createAnalyticsEvent: createAnalyticsEvent,
                browserMetricsKey: browserMetricsKey,
                loggingKey: loggingKey,
                signal: signal
            })({
                actions: actions
            });
        }, [
            onFetch,
            analyticsTracking,
            browserMetricsKey,
            createAnalyticsEvent,
            loggingKey,
            getAbortController,
            actions
        ]);
        const doAbort = (0, $5uXOq.useCallback)(()=>{
            if (isAbortable) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            getAbortController().abort();
        }, [
            getAbortController,
            isAbortable
        ]);
        const doFetch = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (...args)=>{
            if (loading) doAbort();
            callFetch(...args);
        }, [
            loading,
            callFetch,
            doAbort
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const hasEffectsChanged = (0, $lUlda.isShallowDifferent)(fetchDependenciesRef.current, fetchDependencies);
            if (!initialized && !fetched || hasEffectsChanged) {
                if (hasEffectsChanged) fetchDependenciesRef.current = fetchDependencies;
                if (hasEffectsChanged) doAbort();
                if (isAutoFetchable) callFetch();
                else if (initialized && hasEffectsChanged) // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
                actions.resetInitialState();
            }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            initialized,
            doAbort,
            fetched,
            callFetch,
            isAutoFetchable,
            ...fetchDependencies
        ]);
        (0, $5uXOq.useEffect)(()=>{
            isMounted.current = true;
            return ()=>{
                isMounted.current = false;
                doAbort();
            };
        }, [
            doAbort
        ]);
        return [
            state,
            {
                doFetch: doFetch,
                doAbort: doAbort
            }
        ];
    };

});
parcelRegister("d6Xq4", function(module, exports) {

$parcel$export(module.exports, "UseFetchHandledError", () => $7de9d917d4a5c394$export$2801d9c787d65a99);
class $7de9d917d4a5c394$export$2801d9c787d65a99 extends Error {
    constructor(componentMounted, e){
        super(e?.message || 'Unknown');
        this.originalError = e;
        this.componentMounted = !!componentMounted;
    }
}

});

parcelRegister("lUlda", function(module, exports) {

$parcel$export(module.exports, "isShallowDifferent", () => $76bb872f5000fbec$export$a42e2ec7d66a0c03);
const $76bb872f5000fbec$export$a42e2ec7d66a0c03 = (arrayA, arrayB)=>arrayA.length !== arrayB.length || arrayA.some((currentElement, index)=>currentElement !== arrayB[index]);

});

parcelRegister("eW4Xh", function(module, exports) {

$parcel$export(module.exports, "thunks", () => $4eddb453cf1aa4e2$export$eb2332b8a94a914a);

var $eUcR1 = parcelRequire("eUcR1");

var $dTD3b = parcelRequire("dTD3b");

var $7lFwJ = parcelRequire("7lFwJ");
const $4eddb453cf1aa4e2$export$eb2332b8a94a914a = {
    fetch: ({ onFetch: onFetch, analyticsTracking: analyticsTracking, browserMetricsKey: browserMetricsKey, loggingKey: loggingKey, signal: signal, createAnalyticsEvent: createAnalyticsEvent })=>{
        const metricsTracker = (0, $eUcR1.trackBrowserMetricsForJira)({
            browserMetricsKey: browserMetricsKey
        });
        const logger = (0, $7lFwJ.loggingHandler)({
            loggingKey: loggingKey
        });
        return async ({ actions: actions })=>{
            const analyticsTracker = (0, $dTD3b.trackDataFetchAnalytics)({
                ...analyticsTracking,
                createAnalyticsEvent: createAnalyticsEvent
            });
            metricsTracker.start();
            analyticsTracker.start();
            // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
            actions.setFetchStart();
            try {
                const data = await onFetch({
                    signal: signal
                });
                actions.setFetchEnd(data);
                metricsTracker.end();
                analyticsTracker.succeeded();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                metricsTracker.cancel();
                if (e.componentMounted) {
                    if (signal.aborted) {
                        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
                        actions.setAborted();
                        analyticsTracker.aborted();
                    } else {
                        const thrownError = e.originalError;
                        actions.setError(thrownError);
                        analyticsTracker.failed(thrownError);
                        logger.error(thrownError);
                    }
                }
            }
        };
    }
};

});
parcelRegister("eUcR1", function(module, exports) {

$parcel$export(module.exports, "trackBrowserMetricsForJira", () => $ce81c3c268f844ac$export$d8b2320f7d41dc1d);

var $dGrdR = parcelRequire("dGrdR");

var $30KM0 = parcelRequire("30KM0");
const $ce81c3c268f844ac$export$d8b2320f7d41dc1d = ({ browserMetricsKey: browserMetricsKey, attributes: attributes, histogram: // Define bucket sizes for histogram. e.g.: '100_500_1000_2500_5000_10000'. Default to '500_1000_1500_4000_7000'.
histogram })=>{
    if (browserMetricsKey === null || browserMetricsKey === undefined) return {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        start: ()=>{},
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        end: ()=>{},
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        cancel: ()=>{}
    };
    const bm3MetricsTracker = (0, $dGrdR.metrics).interaction({
        key: browserMetricsKey,
        // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string | undefined; }' but required in type 'InteractionHistogramConfig'.
        histogram: {
            result: histogram || (0, $30KM0.DEFAULT_HISTOGRAM_BUCKETS)
        }
    });
    const startHandler = ()=>{
        bm3MetricsTracker.start();
    };
    const endHandler = ()=>{
        bm3MetricsTracker.stop({
            customData: attributes
        });
    };
    const cancelHandler = ()=>{
        bm3MetricsTracker.cancel();
    };
    return {
        start: startHandler,
        end: endHandler,
        cancel: cancelHandler
    };
};

});
parcelRegister("30KM0", function(module, exports) {

$parcel$export(module.exports, "STORE_NAME", () => $b92906e2cd9ec8a5$export$cd79d01fb3d2f506);
$parcel$export(module.exports, "experiences", () => $b92906e2cd9ec8a5$export$9848ee2a7d21002f);
$parcel$export(module.exports, "TIMEOUT_IN_MS", () => $b92906e2cd9ec8a5$export$9ebf97d10ce21f3b);
$parcel$export(module.exports, "DEFAULT_HISTOGRAM_BUCKETS", () => $b92906e2cd9ec8a5$export$e3b77a602bc4d0e6);

const $b92906e2cd9ec8a5$export$cd79d01fb3d2f506 = `${(0, $b0e6fec6a4686296$export$d3996f57ffa8448f)}.experience-tracker-store`;
const $b92906e2cd9ec8a5$export$9848ee2a7d21002f = {
    RENDER: 'render'
};
const $b92906e2cd9ec8a5$export$9ebf97d10ce21f3b = 7000;
const $b92906e2cd9ec8a5$export$e3b77a602bc4d0e6 = '500_1000_1500_4000_7000';

});


parcelRegister("dTD3b", function(module, exports) {

$parcel$export(module.exports, "trackDataFetchAnalytics", () => $e920ac60c98f1376$export$bc65acfb4b442c00);

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $fZneA = parcelRequire("fZneA");

var $8zOmE = parcelRequire("8zOmE");

var $93kZ7 = parcelRequire("93kZ7");
const $e920ac60c98f1376$export$d14e9b22afc87cb3 = (statusCode)=>{
    if (statusCode === null) return (0, $93kZ7.statusCodeGroups).UNKNOWN;
    if (statusCode >= 100 && statusCode <= 199) return (0, $93kZ7.statusCodeGroups).INFORMATIONAL_RESPONSES;
    if (statusCode >= 200 && statusCode <= 299) return (0, $93kZ7.statusCodeGroups).SUCCESS_RESPONSES;
    if (statusCode >= 300 && statusCode <= 399) return (0, $93kZ7.statusCodeGroups).REDIRECTS;
    if (statusCode >= 400 && statusCode <= 499) return (0, $93kZ7.statusCodeGroups).CLIENT_ERRORS;
    if (statusCode >= 500 && statusCode <= 599) return (0, $93kZ7.statusCodeGroups).SERVER_ERRORS;
    return (0, $93kZ7.statusCodeGroups).UNKNOWN;
};
const $e920ac60c98f1376$var$includeSample = (sampleRate)=>Math.random() <= 1 / sampleRate;
const $e920ac60c98f1376$var$noopAnalytics = Object.freeze({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    start: ()=>{},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    succeeded: ()=>{},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    failed: ()=>{},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    aborted: ()=>{}
});
const $e920ac60c98f1376$export$bc65acfb4b442c00 = ({ action: action = 'dataFetch', actionSubject: actionSubject, packageName: packageName, createAnalyticsEvent: createAnalyticsEvent, sampleRate: sampleRate })=>{
    if (actionSubject == null) return $e920ac60c98f1376$var$noopAnalytics;
    if (sampleRate != null && !$e920ac60c98f1376$var$includeSample(sampleRate)) return $e920ac60c98f1376$var$noopAnalytics;
    // Note: Operational analytics do NOT use actionSubjectId!
    const actionSubjectAndAction = `${actionSubject} ${action}`;
    return Object.freeze({
        start: ()=>{
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), actionSubjectAndAction, {
                status: (0, $93kZ7.analyticsStatuses).STARTED,
                packageName: packageName
            });
        },
        succeeded: ()=>{
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), actionSubjectAndAction, {
                statusCodeGroup: '2xx',
                status: (0, $93kZ7.analyticsStatuses).SUCCEEDED,
                packageName: packageName
            });
        },
        failed: (e)=>{
            const error = e !== null && e !== undefined ? e : new Error('Unknown error, e should be present');
            if (!(0, $fZneA.isClientFetchError)(e)) {
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), actionSubjectAndAction, {
                    statusCodeGroup: $e920ac60c98f1376$export$d14e9b22afc87cb3(error instanceof (0, $jJZqs.default) ? error.statusCode : -1),
                    status: (0, $93kZ7.analyticsStatuses).FAILED,
                    packageName: packageName
                });
                return;
            }
            // No network connection error
            (0, $jcw0u.default)({
                meta: {
                    id: actionSubject,
                    packageName: packageName
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        },
        aborted: ()=>{
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), actionSubjectAndAction, {
                status: (0, $93kZ7.analyticsStatuses).ABORTED,
                packageName: packageName
            });
        }
    });
};

});
parcelRegister("93kZ7", function(module, exports) {

$parcel$export(module.exports, "statusCodeGroups", () => $88683eadd8082ef6$export$fddea1bcaead87d5);
$parcel$export(module.exports, "analyticsStatuses", () => $88683eadd8082ef6$export$f0fa81eb65b496a1);
const $88683eadd8082ef6$export$fddea1bcaead87d5 = {
    INFORMATIONAL_RESPONSES: '1xx',
    SUCCESS_RESPONSES: '2xx',
    REDIRECTS: '3xx',
    CLIENT_ERRORS: '4xx',
    SERVER_ERRORS: '5xx',
    UNKNOWN: 'unknown'
};
const $88683eadd8082ef6$export$f0fa81eb65b496a1 = {
    SUCCEEDED: 'succeeded',
    FAILED: 'failed',
    ABORTED: 'aborted',
    STARTED: 'started'
};

});


parcelRegister("7lFwJ", function(module, exports) {

$parcel$export(module.exports, "loggingHandler", () => $81689b1ad2d5cba4$export$f35316da257b76e4);

var $2YZCu = parcelRequire("2YZCu");

var $fZneA = parcelRequire("fZneA");
const $81689b1ad2d5cba4$export$f35316da257b76e4 = ({ loggingKey: loggingKey })=>{
    if (loggingKey === null || loggingKey === undefined) return {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        error: ()=>{}
    };
    const errorHandler = (thrownError)=>{
        if (!(0, $fZneA.isClientFetchError)(thrownError)) (0, $2YZCu.default).safeErrorWithoutCustomerData(loggingKey, 'Error fetching data', thrownError);
    };
    return {
        error: errorHandler
    };
};

});




parcelRegister("9tkyc", function(module, exports) {

$parcel$export(module.exports, "fetchArisSprintCommitmentResponseSuccess", () => $010d41e77ba79957$export$a8f476521e48a505);

var $48DMb = parcelRequire("48DMb");

var $7L5ar = parcelRequire("7L5ar");

var $72Dc6 = parcelRequire("72Dc6");
const $010d41e77ba79957$var$buildUrl = (cloudId, rapidViewId, shouldUseJQLData)=>`/gateway/api/aris/jira/${cloudId}/board/${rapidViewId}/sprint-commitment?useJQL=${shouldUseJQLData}`;
function $010d41e77ba79957$var$isRecalculating(response) {
    return response.responseMeta.type === (0, $7L5ar.responseTypes).RECALCULATING;
}
const $010d41e77ba79957$export$a8f476521e48a505 = async ({ cloudId: cloudId, rapidViewId: rapidViewId, shouldUseJQLData: shouldUseJQLData }, options)=>{
    const url = $010d41e77ba79957$var$buildUrl(cloudId, rapidViewId, shouldUseJQLData);
    const response = await (0, $48DMb.fetchJson)(url, options);
    if ($010d41e77ba79957$var$isRecalculating(response)) throw new (0, $72Dc6.SprintCommitmentRecalculatingError)();
    return response;
};

});
parcelRegister("48DMb", function(module, exports) {

$parcel$export(module.exports, "fetchJson", () => $cfd862e6e9d86034$export$6d71b655afe1638d);

var $7f4tk = parcelRequire("7f4tk");

var $3wzQ9 = parcelRequire("3wzQ9");
const $cfd862e6e9d86034$export$6d71b655afe1638d = async (url, options = {})=>(0, $7f4tk.default)(url, options).catch((error)=>{
        throw new (0, $3wzQ9.FetchUrlError)(url, error);
    });

});
parcelRegister("3wzQ9", function(module, exports) {

$parcel$export(module.exports, "FetchUrlError", () => $f57667a2adaf29d3$export$5cdfc90b27d7ab6c);

var $jJZqs = parcelRequire("jJZqs");

var $fZneA = parcelRequire("fZneA");

var $bw7Gm = parcelRequire("bw7Gm");

var $kFy8J = parcelRequire("kFy8J");
const $f57667a2adaf29d3$var$getStatusCodeGroup = (statusCode)=>{
    if (statusCode === null) return (0, $kFy8J.statusCodeGroups).UNKNOWN;
    if (statusCode >= 100 && statusCode <= 199) return (0, $kFy8J.statusCodeGroups).INFORMATIONAL_RESPONSES;
    if (statusCode >= 200 && statusCode <= 299) return (0, $kFy8J.statusCodeGroups).SUCCESS_RESPONSES;
    if (statusCode >= 300 && statusCode <= 399) return (0, $kFy8J.statusCodeGroups).REDIRECTS;
    if (statusCode >= 400 && statusCode <= 499) return (0, $kFy8J.statusCodeGroups).CLIENT_ERRORS;
    if (statusCode >= 500 && statusCode <= 599) return (0, $kFy8J.statusCodeGroups).SERVER_ERRORS;
    return (0, $kFy8J.statusCodeGroups).UNKNOWN;
};
const $f57667a2adaf29d3$var$stringifySafe = (obj)=>{
    try {
        return JSON.stringify(obj);
    } catch  {
        return null;
    }
};
class $f57667a2adaf29d3$export$5cdfc90b27d7ab6c extends (0, $jJZqs.default) {
    constructor(url, fetchError){
        if (fetchError instanceof (0, $jJZqs.default)) super(fetchError.statusCode, fetchError.message, fetchError.traceId);
        else super(-1, fetchError.message);
        this.name = 'FetchUrlError';
        this.url = (0, $bw7Gm.default)(url);
        this.aborted = fetchError.name === (0, $jJZqs.ABORT_ERROR_NAME);
        this.isClientError = (0, $fZneA.isClientFetchError)(fetchError) || this.statusCode === -1;
        this.statusCodeGroup = $f57667a2adaf29d3$var$getStatusCodeGroup(fetchError instanceof (0, $jJZqs.default) ? fetchError.statusCode : null);
        // NOTE: logging does not support nested objects!
        this.cause = $f57667a2adaf29d3$var$stringifySafe(fetchError);
    }
}

});
parcelRegister("kFy8J", function(module, exports) {

$parcel$export(module.exports, "statusCodeGroups", () => $cb89e2c05d3c28e8$export$fddea1bcaead87d5);
const $cb89e2c05d3c28e8$export$fddea1bcaead87d5 = {
    INFORMATIONAL_RESPONSES: '1xx',
    SUCCESS_RESPONSES: '2xx',
    REDIRECTS: '3xx',
    CLIENT_ERRORS: '4xx',
    SERVER_ERRORS: '5xx',
    UNKNOWN: 'unknown'
};

});



parcelRegister("72Dc6", function(module, exports) {

$parcel$export(module.exports, "SprintCommitmentRecalculatingError", () => $eabf238f9d8fcb6f$export$33a6592cab93d824);
class $eabf238f9d8fcb6f$export$33a6592cab93d824 extends Error {
    constructor(){
        super();
        this.message = 'sprint commitment recalculating';
    }
}

});



parcelRegister("e4xeo", function(module, exports) {

$parcel$export(module.exports, "default", () => $303cc71f27f766f6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $303cc71f27f766f6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    storyPointsBelowTargetTooltip: {
        "id": "sprint-commitment-indicator.story-points-below-target-tooltip",
        "defaultMessage": "{committed, plural, one {# story point} other {# story points}} committed (under recommended target of {lowTarget}-{highTarget})"
    },
    storyPointsWithinTargetTooltip: {
        "id": "sprint-commitment-indicator.story-points-within-target-tooltip",
        "defaultMessage": "{committed, plural, one {# story point} other {# story points}} committed (falls within recommended target of {lowTarget}-{highTarget})"
    },
    storyPointsAboveTargetTooltip: {
        "id": "sprint-commitment-indicator.story-points-above-target-tooltip",
        "defaultMessage": "{committed, plural, one {# story point} other {# story points}} committed (over recommended target of {lowTarget}-{highTarget})"
    },
    issueCountBelowTargetTooltip: {
        "id": "sprint-commitment-indicator.issue-count-below-target-tooltip",
        "defaultMessage": "{committed, plural, one {# issue} other {# issues}} committed (under recommended target of {lowTarget}-{highTarget})"
    },
    issueCountWithinTargetTooltip: {
        "id": "sprint-commitment-indicator.issue-count-within-target-tooltip",
        "defaultMessage": "{committed, plural, one {# issue} other {# issues}} committed (falls within recommended target of {lowTarget}-{highTarget})"
    },
    issueCountAboveTargetTooltip: {
        "id": "sprint-commitment-indicator.issue-count-above-target-tooltip",
        "defaultMessage": "{committed, plural, one {# issue} other {# issues}} committed (over recommended target of {lowTarget}-{highTarget})"
    },
    timeTrackingBelowTargetTooltip: {
        "id": "sprint-commitment-indicator.time-tracking-below-target-tooltip",
        "defaultMessage": "{committed} committed (under recommended target of {lowTarget}-{highTarget})"
    },
    timeTrackingWithinTargetTooltip: {
        "id": "sprint-commitment-indicator.time-tracking-within-target-tooltip",
        "defaultMessage": "{committed} committed (falls within recommended target of {lowTarget}-{highTarget})"
    },
    timeTrackingAboveTargetTooltip: {
        "id": "sprint-commitment-indicator.time-tracking-above-target-tooltip",
        "defaultMessage": "{committed} committed (over recommended target of {lowTarget}-{highTarget})"
    },
    belowTargetLabel: {
        "id": "sprint-commitment-indicator.below-target-label",
        "defaultMessage": "Sprint below target"
    },
    withinTargetLabel: {
        "id": "sprint-commitment-indicator.within-target-label",
        "defaultMessage": "Sprint within target"
    },
    aboveTargetLabel: {
        "id": "sprint-commitment-indicator.above-target-label",
        "defaultMessage": "Sprint above target"
    },
    insightsButton: {
        "id": "sprint-commitment-indicator.insights-button",
        "defaultMessage": "Insights"
    },
    issueCountBelowTargetTooltipIssueTerminologyRefreshM4: {
        "id": "sprint-commitment-indicator.issue-count-below-target-tooltip-issue-terminology-refresh-m4",
        "defaultMessage": "{committed, plural, one {# work item} other {# work items}} committed (under recommended target of {lowTarget}-{highTarget})"
    },
    issueCountWithinTargetTooltipIssueTerminologyRefreshM4: {
        "id": "sprint-commitment-indicator.issue-count-within-target-tooltip-issue-terminology-refresh-m4",
        "defaultMessage": "{committed, plural, one {# work item} other {# work items}} committed (falls within recommended target of {lowTarget}-{highTarget})"
    },
    issueCountAboveTargetTooltipIssueTerminologyRefreshM4: {
        "id": "sprint-commitment-indicator.issue-count-above-target-tooltip-issue-terminology-refresh-m4",
        "defaultMessage": "{committed, plural, one {# work item} other {# work items}} committed (over recommended target of {lowTarget}-{highTarget})"
    }
});

});

parcelRegister("5Gv28", function(module, exports) {

$parcel$export(module.exports, "getSprintEstimationTransformer", () => $e4c0794a681aeed8$export$48bd8595d19ced8e);

var $9puhQ = parcelRequire("9puhQ");

var $3CsaP = parcelRequire("3CsaP");
const $e4c0794a681aeed8$export$48bd8595d19ced8e = ({ estimationType: estimationType, committed: committed })=>(apiResponse)=>{
        const formatSprint = (0, $3CsaP.transformSprintData)(estimationType);
        const sprints = apiResponse.sprintCommitmentResult.values.map(formatSprint);
        const total = sprints.reduce((acc, sprint)=>acc + sprint.completed, 0);
        const average = total / sprints.length;
        const { recommendationStatus: recommendationStatus, range: range } = (0, $9puhQ.getRecommendationStatus)({
            average: average,
            value: committed,
            estimationUnit: estimationType
        });
        return {
            total: total,
            average: average,
            sprints: sprints,
            recommendationStatus: recommendationStatus,
            range: range
        };
    };

});
parcelRegister("9puhQ", function(module, exports) {

$parcel$export(module.exports, "getTargetBoundsFromAverage", () => $1e8095f566afd0f5$export$3972456334a68faf);
$parcel$export(module.exports, "getRecommendationStatus", () => $1e8095f566afd0f5$export$81a9483b31ce949a);

var $gBj4V = parcelRequire("gBj4V");

var $7L5ar = parcelRequire("7L5ar");
const $1e8095f566afd0f5$var$MINIMUM_UNITS = 0;
const $1e8095f566afd0f5$export$3972456334a68faf = ({ average: average })=>{
    const targetLower = Math.round(Math.min(Math.max(average - 1, $1e8095f566afd0f5$var$MINIMUM_UNITS), average * 0.9));
    const targetUpper = Math.round(Math.max(average * 1.1, average + 1));
    return {
        targetLower: targetLower,
        targetUpper: targetUpper
    };
};
const $1e8095f566afd0f5$export$47d555ff5354096f = ({ seconds: seconds })=>Math.floor(seconds / (0, $gBj4V.SECONDS_PER_HOUR));
const $1e8095f566afd0f5$export$81a9483b31ce949a = ({ average: average, value: value, estimationUnit: estimationUnit })=>{
    if (!average) return {
        recommendationStatus: (0, $7L5ar.RecommendationStatus).NO_TARGET,
        range: null
    };
    const { targetLower: targetLower, targetUpper: targetUpper } = $1e8095f566afd0f5$export$3972456334a68faf({
        average: average
    });
    const convertedLower = estimationUnit === 'TIME_TRACKING' ? Math.floor(targetLower / (0, $gBj4V.SECONDS_PER_HOUR)) * (0, $gBj4V.SECONDS_PER_HOUR) : targetLower;
    const convertedUpper = estimationUnit === 'TIME_TRACKING' ? Math.ceil(targetUpper / (0, $gBj4V.SECONDS_PER_HOUR)) * (0, $gBj4V.SECONDS_PER_HOUR) : targetUpper;
    let recommendationStatus;
    if (value < convertedLower) recommendationStatus = (0, $7L5ar.RecommendationStatus).BELOW_TARGET;
    else if (value > convertedUpper) recommendationStatus = (0, $7L5ar.RecommendationStatus).ABOVE_TARGET;
    else recommendationStatus = (0, $7L5ar.RecommendationStatus).WITHIN_TARGET;
    return {
        recommendationStatus: recommendationStatus,
        range: {
            lower: convertedLower,
            upper: convertedUpper
        }
    };
};
const $1e8095f566afd0f5$export$19605add20c645a5 = (textContent)=>(content, node)=>{
        const hasText = (newNode)=>newNode != null && newNode.textContent === textContent;
        const nodeHasText = hasText(node);
        const childrenDontHaveText = !node || Array.from(node.children).every((child)=>!hasText(child));
        return nodeHasText && childrenDontHaveText;
    };

});

parcelRegister("3CsaP", function(module, exports) {

$parcel$export(module.exports, "transformSprintData", () => $775c188ec90f70cd$export$67bd64ec8f2779df);
$parcel$export(module.exports, "transformArisData", () => $775c188ec90f70cd$export$c0fb07c02b9dbc9a);

var $6s1PB = parcelRequire("6s1PB");

var $9YlLW = parcelRequire("9YlLW");
const $775c188ec90f70cd$export$67bd64ec8f2779df = (estimationUnit)=>(sprintData)=>{
        const completed = sprintData.completed ? (0, $9YlLW.getEstimatedUnit)(estimationUnit, sprintData.completed) : 0;
        const estimated = (0, $9YlLW.getEstimatedUnit)(estimationUnit, sprintData.committed);
        return {
            id: Number(sprintData.sprint.id),
            estimated: estimated,
            completed: completed,
            name: sprintData.sprint.name
        };
    };
const $775c188ec90f70cd$export$c0fb07c02b9dbc9a = (data)=>{
    const { sprintHistory: sprintHistory, sprintProgress: sprintProgress, currentSprintId: currentSprintId } = data;
    const { estimationUnit: estimationUnit } = data.configuration;
    let currentSprintEstimated = 0;
    let total = 0;
    let sprints = [];
    if (sprintProgress) {
        const { progress: { todo: todo, inProgress: inProgress, done: done } } = sprintProgress;
        currentSprintEstimated = todo.value + inProgress.value + done.value;
    }
    // average
    if (sprintHistory != null) {
        if ((0, $6s1PB.expValEquals)('jira_insights_backlog_recommendations', 'cohort', 'control')) sprints = sprintHistory.values.reverse().map((sprintData)=>{
            const completed = sprintData.completed ? (0, $9YlLW.getEstimatedUnit)(estimationUnit, sprintData.completed) : 0;
            const estimated = (0, $9YlLW.getEstimatedUnit)(estimationUnit, sprintData.committed);
            total += completed;
            return {
                id: Number(sprintData.sprint.id),
                estimated: estimated,
                completed: completed,
                name: sprintData.sprint.name
            };
        });
        else {
            sprints = sprintHistory.values.reverse().map($775c188ec90f70cd$export$67bd64ec8f2779df(estimationUnit));
            total = sprints.reduce((acc, sprint)=>acc + sprint.completed, 0);
        }
    }
    const average = sprints.length > 0 ? total / sprints.length : 0;
    return {
        average: average,
        currentSprint: {
            estimated: currentSprintEstimated,
            id: currentSprintId
        },
        estimationUnit: estimationUnit,
        sprints: sprints,
        type: 'SUCCESS'
    };
};

});
parcelRegister("9YlLW", function(module, exports) {

$parcel$export(module.exports, "getMessageFromEstimationUnit", () => $74b4eed620b03a26$export$680a8efbdf2f2020);
$parcel$export(module.exports, "getCommonMessageDescriptorFromEstimationUnit", () => $74b4eed620b03a26$export$c0f3281b1c14f2e6);
$parcel$export(module.exports, "getEstimatedUnit", () => $74b4eed620b03a26$export$120f64ac447e3a5a);
$parcel$export(module.exports, "getUpdatedEstimation", () => $74b4eed620b03a26$export$5ec90264a55fd048);
$parcel$export(module.exports, "getPermissionEnum", () => $74b4eed620b03a26$export$8e09a9f3c4b56097);
$parcel$export(module.exports, "isValidBoardId", () => $74b4eed620b03a26$export$e168d1e9d0082d6a);
$parcel$export(module.exports, "useDueDatePulse", () => $74b4eed620b03a26$export$9698ff82f4fc10e6);

var $5uXOq = parcelRequire("5uXOq");

var $e4eHl = parcelRequire("e4eHl");

var $kbqIt = parcelRequire("kbqIt");

var $eGLgs = parcelRequire("eGLgs");

var $6s1PB = parcelRequire("6s1PB");


var $cpUUk = parcelRequire("cpUUk");

var $koeKL = parcelRequire("koeKL");

var $8uXQO = parcelRequire("8uXQO");
const $74b4eed620b03a26$export$680a8efbdf2f2020 = ({ estimationUnit: estimationUnit, messages: messages })=>{
    if (!messages[estimationUnit]) throw new Error(`Unsupported estimationUnit: ${estimationUnit} for ${JSON.stringify(messages)}`);
    return messages[estimationUnit];
};
const $74b4eed620b03a26$export$c0f3281b1c14f2e6 = (estimationUnit)=>{
    let issueTermRefreshSuffix = '';
    if (estimationUnit === 'ISSUE_COUNT' && (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) issueTermRefreshSuffix = 'IssueTermRefresh';
    const estimationUnitCamelCase = (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(estimationUnit);
    const labelDescriptorName = `${estimationUnitCamelCase}Label${issueTermRefreshSuffix}`;
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ issueCountLabel: MessageDescriptorV2; storyPointsLabel: MessageDescriptorV2; timeOriginalEstimateLabel: MessageDescriptorV2; sprints: MessageDescriptorV2; issueCount: MessageDescriptorV2; storyPoints: MessageDescriptorV2; }'.
    if (!(0, $8uXQO.messages)[labelDescriptorName]) throw new Error(`Unsupported estimationUnit: ${estimationUnit}, label not found for ${labelDescriptorName}} in ${JSON.stringify(Object.keys((0, $8uXQO.messages)))}`);
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ issueCountLabel: MessageDescriptorV2; storyPointsLabel: MessageDescriptorV2; timeOriginalEstimateLabel: MessageDescriptorV2; sprints: MessageDescriptorV2; issueCount: MessageDescriptorV2; storyPoints: MessageDescriptorV2; }'.
    return (0, $8uXQO.messages)[labelDescriptorName];
};
const $74b4eed620b03a26$export$120f64ac447e3a5a = (estimationUnit, estimation)=>{
    // these endpoints returning null shouldn't happen, so let's degrade gracefully
    switch(estimationUnit){
        case (0, $cpUUk.EstimationUnit).ISSUE_COUNT:
            return estimation.issueCount || 0;
        case (0, $cpUUk.EstimationUnit).STORY_POINTS:
            return estimation.storyPoints != null ? parseFloat(estimation.storyPoints.toFixed(1)) : 0;
        case (0, $cpUUk.EstimationUnit).TIME_TRACKING:
            return estimation.time || 0;
        default:
            throw new Error(`Unexpected estimation type: ${estimationUnit}`);
    }
};
const $74b4eed620b03a26$export$5ec90264a55fd048 = (estimationUnit, estimation, value)=>{
    switch(estimationUnit){
        case (0, $cpUUk.EstimationUnit).ISSUE_COUNT:
            return {
                ...estimation,
                issueCount: value
            };
        case (0, $cpUUk.EstimationUnit).STORY_POINTS:
            return {
                ...estimation,
                storyPoints: value
            };
        case (0, $cpUUk.EstimationUnit).TIME_TRACKING:
            return {
                ...estimation,
                time: value
            };
        default:
            throw new Error(`Unexpected estimation type: ${estimationUnit}`);
    }
};
const $74b4eed620b03a26$export$8e09a9f3c4b56097 = (value, defaultValue)=>value === null || value === undefined ? defaultValue : value;
const $74b4eed620b03a26$export$8081780e7051e8dd = (boardId)=>`print-halfway-alert-${boardId ?? (0, $b298cf836b53195d$export$bc8ae8b96c2da16b)}`;
const $74b4eed620b03a26$export$9eca4630c417f1b = (boardId)=>`auto-expand-halfway-alert-${boardId ?? (0, $b298cf836b53195d$export$bc8ae8b96c2da16b)}`;
const $74b4eed620b03a26$export$e168d1e9d0082d6a = ({ boardId: boardId })=>{
    // BoardId must be a positive integer
    if (boardId === undefined || boardId === null || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    !(Number.isInteger(boardId) && boardId > 0)) return false;
    return true;
};
const $74b4eed620b03a26$export$2e033b8f7ea3f02a = ({ boardId: boardId })=>{
    if (typeof boardId !== 'string') return false;
    return /^[0-9]+$/.test(boardId) && Number.parseInt(boardId, 10) > 0;
};
const $74b4eed620b03a26$export$9698ff82f4fc10e6 = ()=>{
    const DUE_DATE_EXPERIMENT_ENGAGEMENT_ID = 'jira-insights-due-tab-button-pulse';
    const STARGATE_URL = '/gateway/api';
    const cloudId = (0, $koeKL.useCloudId)();
    const coordinationClient = (0, $5uXOq.useMemo)(// eslint-disable-next-line jira/choreographer/choreographer-context-required
    ()=>new (0, $eGLgs.CoordinationClient)(cloudId, STARGATE_URL, false, '', 'engagement'), [
        cloudId
    ]);
    const [shouldStartPulse, stopPulse] = (0, $kbqIt.useCoordination)(coordinationClient, DUE_DATE_EXPERIMENT_ENGAGEMENT_ID);
    return {
        coordinationClient: coordinationClient,
        shouldStartPulse: shouldStartPulse,
        stopPulse: stopPulse
    };
};

});
const $b298cf836b53195d$export$5c425db6689b9aae = 'no-account-id';
const $b298cf836b53195d$export$bc8ae8b96c2da16b = 'no-board-id';

parcelRegister("8uXQO", function(module, exports) {

$parcel$export(module.exports, "messages", () => $34dd4dbb16b250cb$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $34dd4dbb16b250cb$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    storyPoints: {
        "id": "insights-common.common.story-points",
        "defaultMessage": "{value, plural, one {point} other {points}}"
    },
    issueCount: {
        "id": "insights-common.common.issue-count",
        "defaultMessage": "{value, plural, one {issue} other {issues}}"
    },
    sprints: {
        "id": "insights-common.common.sprints",
        "defaultMessage": "{sprintCount, plural, one {sprint} other {sprints}}"
    },
    timeTrackingLabel: {
        "id": "insights-common.common.time-tracking-label",
        "defaultMessage": "time estimation"
    },
    storyPointsLabel: {
        "id": "insights-common.common.story-points-label",
        "defaultMessage": "story points"
    },
    issueCountLabel: {
        "id": "insights-common.common.issue-count-label",
        "defaultMessage": "issue count"
    },
    issueCountIssueTermRefresh: {
        "id": "insights-common.common.issue-count-issue-term-refresh",
        "defaultMessage": "{value, plural, one {work item} other {work items}}"
    },
    issueCountLabelIssueTermRefresh: {
        "id": "insights-common.common.issue-count-label-issue-term-refresh",
        "defaultMessage": "work item count"
    }
});

});




parcelRegister("8wntT", function(module, exports) {

$parcel$export(module.exports, "RecommendationIcon", () => $6e3d2db401e037e9$export$472452cf732965c3);
$parcel$export(module.exports, "RecommendationLabel", () => $6e3d2db401e037e9$export$ff563649ab15814b);
$parcel$export(module.exports, "TooltipMessages", () => $6e3d2db401e037e9$export$fa97320be2ac21e3);
$parcel$export(module.exports, "TooltipMessagesOld", () => $6e3d2db401e037e9$export$3ad2a5d208c51008);

var $34Rrn = parcelRequire("34Rrn");

var $b0JGA = parcelRequire("b0JGA");

var $7L5ar = parcelRequire("7L5ar");

var $cpUUk = parcelRequire("cpUUk");

var $e4xeo = parcelRequire("e4xeo");
const $6e3d2db401e037e9$export$472452cf732965c3 = {
    [(0, $7L5ar.RecommendationStatus).BELOW_TARGET]: {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($34Rrn))),
        iconColor: "var(--ds-icon-warning, #E56910)"
    },
    [(0, $7L5ar.RecommendationStatus).ABOVE_TARGET]: {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($34Rrn))),
        iconColor: "var(--ds-icon-warning, #E56910)"
    },
    [(0, $7L5ar.RecommendationStatus).WITHIN_TARGET]: {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($b0JGA))),
        iconColor: "var(--ds-icon-success, #22A06B)"
    }
};
const $6e3d2db401e037e9$export$ff563649ab15814b = {
    [(0, $7L5ar.RecommendationStatus).BELOW_TARGET]: (0, $e4xeo.default).belowTargetLabel,
    [(0, $7L5ar.RecommendationStatus).ABOVE_TARGET]: (0, $e4xeo.default).aboveTargetLabel,
    [(0, $7L5ar.RecommendationStatus).WITHIN_TARGET]: (0, $e4xeo.default).withinTargetLabel
};
const $6e3d2db401e037e9$export$fa97320be2ac21e3 = {
    [(0, $cpUUk.EstimationUnit).STORY_POINTS]: {
        [(0, $7L5ar.RecommendationStatus).BELOW_TARGET]: (0, $e4xeo.default).storyPointsBelowTargetTooltip,
        [(0, $7L5ar.RecommendationStatus).WITHIN_TARGET]: (0, $e4xeo.default).storyPointsWithinTargetTooltip,
        [(0, $7L5ar.RecommendationStatus).ABOVE_TARGET]: (0, $e4xeo.default).storyPointsAboveTargetTooltip
    },
    [(0, $cpUUk.EstimationUnit).ISSUE_COUNT]: {
        [(0, $7L5ar.RecommendationStatus).BELOW_TARGET]: (0, $e4xeo.default).issueCountBelowTargetTooltipIssueTerminologyRefreshM4,
        [(0, $7L5ar.RecommendationStatus).WITHIN_TARGET]: (0, $e4xeo.default).issueCountWithinTargetTooltipIssueTerminologyRefreshM4,
        [(0, $7L5ar.RecommendationStatus).ABOVE_TARGET]: (0, $e4xeo.default).issueCountAboveTargetTooltipIssueTerminologyRefreshM4
    },
    [(0, $cpUUk.EstimationUnit).TIME_TRACKING]: {
        [(0, $7L5ar.RecommendationStatus).BELOW_TARGET]: (0, $e4xeo.default).timeTrackingBelowTargetTooltip,
        [(0, $7L5ar.RecommendationStatus).WITHIN_TARGET]: (0, $e4xeo.default).timeTrackingWithinTargetTooltip,
        [(0, $7L5ar.RecommendationStatus).ABOVE_TARGET]: (0, $e4xeo.default).timeTrackingAboveTargetTooltip
    }
};
const $6e3d2db401e037e9$export$3ad2a5d208c51008 = {
    [(0, $cpUUk.EstimationUnit).STORY_POINTS]: {
        [(0, $7L5ar.RecommendationStatus).BELOW_TARGET]: (0, $e4xeo.default).storyPointsBelowTargetTooltip,
        [(0, $7L5ar.RecommendationStatus).WITHIN_TARGET]: (0, $e4xeo.default).storyPointsWithinTargetTooltip,
        [(0, $7L5ar.RecommendationStatus).ABOVE_TARGET]: (0, $e4xeo.default).storyPointsAboveTargetTooltip
    },
    [(0, $cpUUk.EstimationUnit).ISSUE_COUNT]: {
        [(0, $7L5ar.RecommendationStatus).BELOW_TARGET]: (0, $e4xeo.default).issueCountBelowTargetTooltip,
        [(0, $7L5ar.RecommendationStatus).WITHIN_TARGET]: (0, $e4xeo.default).issueCountWithinTargetTooltip,
        [(0, $7L5ar.RecommendationStatus).ABOVE_TARGET]: (0, $e4xeo.default).issueCountAboveTargetTooltip
    },
    [(0, $cpUUk.EstimationUnit).TIME_TRACKING]: {
        [(0, $7L5ar.RecommendationStatus).BELOW_TARGET]: (0, $e4xeo.default).timeTrackingBelowTargetTooltip,
        [(0, $7L5ar.RecommendationStatus).WITHIN_TARGET]: (0, $e4xeo.default).timeTrackingWithinTargetTooltip,
        [(0, $7L5ar.RecommendationStatus).ABOVE_TARGET]: (0, $e4xeo.default).timeTrackingAboveTargetTooltip
    }
};

});


parcelRegister("3KA8f", function(module, exports) {

$parcel$export(module.exports, "default", () => $001bc48f35c4b5ee$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fW62l = parcelRequire("fW62l");

var $16T6Y = parcelRequire("16T6Y");

var $MHKc7 = parcelRequire("MHKc7");

var $3bDjY = parcelRequire("3bDjY");

var $jldZL = parcelRequire("jldZL");

var $dCm1o = parcelRequire("dCm1o");
const $001bc48f35c4b5ee$var$styles = {
    estimationBadgeWrapperOld: "_18u01b66 _k48pmoej _1e0c116y",
    estimationBadgeWrapper: "_k48pmoej _1e0c116y _80om73ad"
};
const $001bc48f35c4b5ee$var$EstimationsBadge = ({ appearance: appearance, style: style, children: children, max: max, screenReaderMessage: screenReaderMessage, tooltipContent: tooltipContent, tooltipDelay: tooltipDelay })=>{
    const [active, setActive] = (0, $5uXOq.useState)(false);
    const onFocus = (0, $5uXOq.useCallback)(()=>{
        setActive(true);
    }, []);
    const onBlur = (0, $5uXOq.useCallback)(()=>{
        setActive(false);
    }, []);
    const onKeyDown = (0, $5uXOq.useCallback)((event)=>{
        if (event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('enter') || event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('space')) {
            event.preventDefault();
            setActive((prev)=>!prev);
        }
    }, []);
    const tooltipMessage = active ? tooltipContent : '';
    const content = (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16T6Y.default), {
        appearance: appearance,
        max: max
    }, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16T6Y.default), {
        appearance: appearance,
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        max: max
    }, children));
    const screenReaderId = screenReaderMessage.replaceAll(' ', '-');
    const visuallyRefreshedBadgeWrapper = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
            onFocus: onFocus,
            onBlur: onBlur,
            onMouseLeave: onBlur,
            onMouseEnter: onFocus,
            onKeyDown: onKeyDown,
            role: "status",
            "aria-live": "polite",
            testId: "software-backlog.card-list.estimations.badge.estimation-badge-wrapper",
            xcss: $001bc48f35c4b5ee$var$styles.estimationBadgeWrapper,
            "aria-labelledby": screenReaderId
        }, content), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jldZL.default), {
            id: screenReaderId
        }, screenReaderMessage));
    const nonVisuallyRefreshedBadgeWrapper = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($001bc48f35c4b5ee$var$EstimationBadgeWrapper, {
            onFocus: onFocus,
            onBlur: onBlur,
            onMouseLeave: onBlur,
            onMouseEnter: onFocus,
            onKeyDown: onKeyDown,
            role: "status",
            "aria-live": "polite",
            "aria-labelledby": screenReaderId,
            "data-testid": "software-backlog.card-list.estimations.badge.estimation-badge-wrapper",
            className: (0, $bwpsq.default)([
                $001bc48f35c4b5ee$var$legacyEstimationBadgeWrapperStyle.default
            ])
        }, content), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jldZL.default), {
            id: screenReaderId
        }, screenReaderMessage));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: tooltipMessage,
        delay: tooltipDelay
    }, (0, $dCm1o.isVisualRefreshEnabled)() ? visuallyRefreshedBadgeWrapper() : nonVisuallyRefreshedBadgeWrapper());
};
var $001bc48f35c4b5ee$export$2e2bcd8739ae039 = $001bc48f35c4b5ee$var$EstimationsBadge;
const $001bc48f35c4b5ee$var$legacyEstimationBadgeWrapperStyle = {
    default: "_1e0c116y"
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $001bc48f35c4b5ee$var$EstimationBadgeWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01b66 _k48pmoej",
            __cmplp.className
        ])
    });
});

});

parcelRegister("6hYI0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4174f9cf4973f96d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $4174f9cf4973f96d$var$messages = (0, $7VHMR.defineMessages)({
    notStarted: {
        "id": "backlog.card-list.estimations.not-started",
        "defaultMessage": "To Do"
    },
    inProgress: {
        "id": "backlog.card-list.estimations.in-progress",
        "defaultMessage": "In Progress"
    },
    done: {
        "id": "backlog.card-list.estimations.done",
        "defaultMessage": "Done"
    },
    notStartedV2: {
        "id": "backlog.card-list.estimations.not-started-v-2",
        "defaultMessage": "Not started"
    },
    inProgressV2: {
        "id": "backlog.card-list.estimations.in-progress-v-2",
        "defaultMessage": "In progress"
    },
    completed: {
        "id": "backlog.card-list.estimations.completed",
        "defaultMessage": "Completed"
    },
    tooltip: {
        "id": "backlog.card-list.estimations.tooltip",
        "defaultMessage": "{count} of {total} ({estimationName})"
    },
    storyPoints: {
        "id": "backlog.card-list.estimations.story-points",
        "defaultMessage": "Story points"
    },
    originalEstimate: {
        "id": "backlog.card-list.estimations.original-estimate",
        "defaultMessage": "Original estimate"
    },
    issueCount: {
        "id": "backlog.card-list.estimations.issue-count",
        "defaultMessage": "Issue count"
    },
    leftmostColumn: {
        "id": "backlog.card-list.estimations.leftmost-column",
        "defaultMessage": "leftmost column"
    },
    rightmostColumn: {
        "id": "backlog.card-list.estimations.rightmost-column",
        "defaultMessage": "rightmost column"
    },
    issueCountIssueTermRefresh: {
        "id": "backlog.card-list.estimations.issue-count-issue-term-refresh",
        "defaultMessage": "Work item count"
    }
});
var $4174f9cf4973f96d$export$2e2bcd8739ae039 = $4174f9cf4973f96d$var$messages;

});



parcelRegister("hkjgs", function(module, exports) {

$parcel$export(module.exports, "default", () => $137da169bccf5172$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9yOBd = parcelRequire("9yOBd");

var $42CjB = parcelRequire("42CjB");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");

var $bJeNF = parcelRequire("bJeNF");

var $8U6zd = parcelRequire("8U6zd");

var $3oUqw = parcelRequire("3oUqw");

var $8oe80 = parcelRequire("8oe80");

var $jDKvL = parcelRequire("jDKvL");

var $koVbs = parcelRequire("koVbs");

var $2HbP2 = parcelRequire("2HbP2");

var $lXAdy = parcelRequire("lXAdy");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $5L7z2 = parcelRequire("5L7z2");

var $cYsq9 = parcelRequire("cYsq9");

var $lu5k0 = parcelRequire("lu5k0");

var $dCm1o = parcelRequire("dCm1o");

var $guzeq = parcelRequire("guzeq");

var $dkxyn = parcelRequire("dkxyn");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");

var $k35me = parcelRequire("k35me");

var $fSgHa = parcelRequire("fSgHa");

var $93II4 = parcelRequire("93II4");

var $2F0OA = parcelRequire("2F0OA");

var $gTtxS = parcelRequire("gTtxS");

var $7ay7C = parcelRequire("7ay7C");

var $bwwYO = parcelRequire("bwwYO");

var $kseO3 = parcelRequire("kseO3");
const $137da169bccf5172$var$DropdownItemWithAnalytics = (0, $8oe80.default)('dropdownItem', {
    onClick: 'clicked'
})((0, $6B7KL.default));
function $137da169bccf5172$export$2e2bcd8739ae039({ cardListId: cardListId, cardListName: cardListName, cardListType: cardListType }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isCMPBoard = (0, $fSgHa.useIsCMPBacklog)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { setReturnFocusTo: setReturnFocusTo } = (0, $lu5k0.useModalDialogActions)();
    const element = (0, $5uXOq.useRef)(null);
    const [isEditSprintModalOpen, setIsEditSprintModalOpen] = (0, $5uXOq.useState)(false);
    const sprint = (0, $c1MAf.useBacklogSelector)((state)=>(0, $k35me.makeGetSprint)(state)(cardListId));
    const previousSprintId = (0, $c1MAf.useBacklogSelector)((state)=>(0, $k35me.makeGetPreviousNotStartedSprintId)(state)(cardListId));
    const nextSprintId = (0, $c1MAf.useBacklogSelector)((state)=>(0, $k35me.makeGetNextSprintId)(state)(cardListId));
    const firstInactiveSprintId = (0, $c1MAf.useBacklogSelector)((0, $k35me.getFirstInactiveSprintId));
    const lastInactiveSprintId = (0, $c1MAf.useBacklogSelector)((0, $k35me.getLastInactiveSprintId));
    const isCardListActiveSprint = (0, $c1MAf.useBacklogSelector)((state)=>(0, $k35me.makeIsCardListActiveSprint)(state)(cardListId));
    const sprintCardList = (0, $c1MAf.useBacklogSelector)((state)=>cardListId ? (0, $dGljH.getCardLists)(state)[String(cardListId)] : null);
    const canMoveSprintUp = previousSprintId !== null;
    const canMoveSprintDown = !isCardListActiveSprint && nextSprintId !== null;
    const enabledMenuActions = cardListType !== (0, $guzeq.SPRINT) ? {} : {
        MOVE_SPRINT_TO_TOP: canMoveSprintUp,
        MOVE_SPRINT_UP: canMoveSprintUp,
        MOVE_SPRINT_DOWN: canMoveSprintDown,
        MOVE_SPRINT_TO_BOTTOM: canMoveSprintDown,
        EDIT_SPRINT: true,
        DELETE_SPRINT: true
    };
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const renderTrigger = (0, $5uXOq.useCallback)(({ triggerRef: triggerRef, onClick: onClick, ...props })=>{
        const handleRef = (refElement)=>{
            if (typeof triggerRef === 'function') triggerRef(refElement);
            if (refElement) element.current = refElement;
        };
        const handleClick = (event)=>{
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'dropdownMenu',
                action: 'toggled'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'sprintsMenu');
            if (onClick) onClick(event);
        };
        // TODO: remove this icon on visual-refresh cleanup
        const moreIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8U6zd))), {
            label: "More actions",
            color: "var(--ds-icon, #44546F)",
            spacing: "spacious",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($3oUqw))),
            LEGACY_primaryColor: "var(--ds-icon, #44546F)"
        });
        return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            ...props,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))),
            label: formatMessage((0, $kseO3.default).menuTrigger, {
                sprintName: cardListName
            }),
            ref: handleRef,
            appearance: "subtle",
            spacing: "compact",
            testId: `software-backlog.card-list.sprints-menu.${cardListName}`,
            onClick: handleClick,
            isTooltipDisabled: false,
            tooltip: {
                content: formatMessage((0, $kseO3.default).moreActionsTooltip),
                hideTooltipOnClick: true
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yOBd.default), {
            ...props,
            ref: handleRef,
            iconBefore: moreIcon,
            "aria-label": formatMessage((0, $kseO3.default).menuTrigger, {
                sprintName: cardListName
            }),
            theme: (0, $gTtxS.darkerButtonTheme),
            testId: `software-backlog.card-list.sprints-menu.${cardListName}`,
            onClick: handleClick
        });
    }, [
        cardListName,
        formatMessage,
        createAnalyticsEvent
    ]);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const handleOpenChange = (0, $5uXOq.useCallback)((attrs)=>{
        setReturnFocusTo(element);
        setIsOpen(attrs.isOpen);
    }, [
        element,
        setReturnFocusTo,
        setIsOpen
    ]);
    // handle close when not initiated by user interaction. e.g. when forge apps finish loading
    const handleNonClickClose = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(false);
    }, [
        setIsOpen
    ]);
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            sprintId: cardListId,
            onClose: ()=>{
                const analyticsEvent = createAnalyticsEvent({
                    actionSubject: 'button',
                    action: 'clicked'
                });
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'cancelButton');
            }
        }), [
        cardListId,
        createAnalyticsEvent
    ]);
    const isVisible = enabledMenuActions && Object.keys(enabledMenuActions).length > 0;
    if (!isVisible) return null;
    const onMoveUp = (event, analyticsEvent)=>{
        if (previousSprintId != null && previousSprintId !== '') dispatch((0, $dkxyn.sprintMoveRequest)({
            sprintId: cardListId,
            targetSprintId: previousSprintId,
            direction: (0, $guzeq.SPRINT_MOVE_UP),
            analyticsEvent: analyticsEvent
        }));
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'moveSprintUp');
    };
    const onMoveToTop = (event, analyticsEvent)=>{
        dispatch((0, $dkxyn.sprintMoveRequest)({
            sprintId: cardListId,
            targetSprintId: firstInactiveSprintId,
            direction: (0, $guzeq.SPRINT_MOVE_TO_TOP),
            analyticsEvent: analyticsEvent
        }));
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'moveSprintToTop');
    };
    const onMoveDown = (event, analyticsEvent)=>{
        if (nextSprintId != null && nextSprintId !== '') dispatch((0, $dkxyn.sprintMoveRequest)({
            sprintId: cardListId,
            targetSprintId: nextSprintId,
            direction: (0, $guzeq.SPRINT_MOVE_DOWN),
            analyticsEvent: analyticsEvent
        }));
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'moveSprintDown');
    };
    const onMoveToBottom = (event, analyticsEvent)=>{
        dispatch((0, $dkxyn.sprintMoveRequest)({
            sprintId: cardListId,
            targetSprintId: lastInactiveSprintId,
            direction: (0, $guzeq.SPRINT_MOVE_TO_BOTTOM),
            analyticsEvent: analyticsEvent
        }));
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'moveSprintToBottom');
    };
    const onEditSprintClick = (event, analyticsEvent)=>{
        setIsEditSprintModalOpen(true);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'openEditSprint');
        (0, $cYsq9.editSprintModalLoad).start();
    };
    const onEditSprintModalCloseClick = ()=>{
        setIsEditSprintModalOpen(false);
    };
    const menuItems = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, enabledMenuActions.MOVE_SPRINT_TO_TOP && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($137da169bccf5172$var$DropdownItemWithAnalytics, {
        "data-testid": "software-backlog.card-list.sprints-menu.sprint-move-to-top",
        onClick: onMoveToTop
    }, formatMessage((0, $kseO3.default).moveSprintToTop)), enabledMenuActions.MOVE_SPRINT_UP && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($137da169bccf5172$var$DropdownItemWithAnalytics, {
        "data-testid": "software-backlog.card-list.sprints-menu.sprint-move-up",
        onClick: onMoveUp
    }, formatMessage((0, $kseO3.default).moveSprintUp)), enabledMenuActions.MOVE_SPRINT_DOWN && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($137da169bccf5172$var$DropdownItemWithAnalytics, {
        "data-testid": "software-backlog.card-list.sprints-menu.sprint-move-down",
        onClick: onMoveDown
    }, formatMessage((0, $kseO3.default).moveSprintDown)), enabledMenuActions.MOVE_SPRINT_TO_BOTTOM && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($137da169bccf5172$var$DropdownItemWithAnalytics, {
        "data-testid": "software-backlog.card-list.sprints-menu.sprint-move-to-bottom",
        onClick: onMoveToBottom
    }, formatMessage((0, $kseO3.default).moveSprintToBottom)), enabledMenuActions.EDIT_SPRINT && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($137da169bccf5172$var$DropdownItemWithAnalytics, {
        "data-testid": "software-backlog.card-list.sprints-menu.sprint-edit",
        onClick: onEditSprintClick
    }, formatMessage((0, $kseO3.default).editSprint)), enabledMenuActions.DELETE_SPRINT && sprintCardList && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lXAdy.ModalEntryPointDropdownItemTrigger), {
        entryPoint: (0, $2F0OA.sprintDeleteModalEntryPoint),
        entryPointProps: entryPointProps,
        interactionName: "sprint-delete-modal",
        testId: "software-backlog.card-list.sprints-menu.sprint-delete",
        useInternalModal: false
    }, formatMessage((0, $kseO3.default).deleteSprint)), isCMPBoard && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5L7z2.SprintActionsConnectMenuItems), {
        sprintId: cardListId,
        location: "sprint-move-actions"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5L7z2.SprintActionsConnectMenuItems), {
        sprintId: cardListId,
        location: "sprint-edit-action"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5L7z2.SprintActionsConnectMenuItems), {
        sprintId: cardListId,
        location: "sprint-delete-action"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ay7C.ForgeSprintActionMenuItems), {
        sprintId: cardListId,
        sprintState: (0, $gTtxS.getSprintState)(sprint?.state)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jDKvL.ForgeAppsContainer), {
        scope: `sprint-action-${cardListId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2HbP2.ModalContextProvider), null, isEditSprintModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $93II4.default), {
        cardListId: Number(cardListId),
        onClose: onEditSprintModalCloseClick,
        onSubmit: onEditSprintModalCloseClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        isOpen: isOpen,
        onOpenChange: handleOpenChange,
        trigger: renderTrigger,
        placement: "bottom-end",
        shouldRenderToParent: true,
        testId: "software-backlog.card-list.sprints-menu.dropdown-menu"
    }, menuItems), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bwwYO.SprintActionForgeRuntimeContainer), {
        onAppsFinishLoading: handleNonClickClose
    })));
}

});
parcelRegister("jDKvL", function(module, exports) {

$parcel$export(module.exports, "ForgeAppsContainer", () => $b68f39b65da4eb25$export$9d26afcb39445b8e);
$parcel$export(module.exports, "useForgeApps", () => $b68f39b65da4eb25$export$a48819842c5a2f15);
$parcel$export(module.exports, "useIsAppLoading", () => $b68f39b65da4eb25$export$24db0add8de543af);
$parcel$export(module.exports, "useIsAnyAppLoading", () => $b68f39b65da4eb25$export$f65d61db50b49f3);

var $7Jxgt = parcelRequire("7Jxgt");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $b68f39b65da4eb25$export$9d26afcb39445b8e = (0, $gg7kZ.createContainer)();
const $b68f39b65da4eb25$var$actions = {
    openApp: (appId, extension, action, extensionData = {})=>({ setState: setState, getState: getState })=>{
            const openedApps = getState().openedApps;
            setState({
                openedApps: [
                    ...openedApps.filter((app)=>app.id !== appId || app.action !== action),
                    {
                        id: appId,
                        extension: extension,
                        extensionData: extensionData,
                        action: action,
                        uuid: (0, $7Jxgt.v4)(),
                        isLoading: true
                    }
                ]
            });
        },
    setAppLoaded: (appId, action)=>({ setState: setState, getState: getState })=>{
            const openedApps = getState().openedApps;
            setState({
                openedApps: openedApps.map((app)=>app.id === appId && app.action === action && app.isLoading ? {
                        ...app,
                        isLoading: false
                    } : app)
            });
        },
    closeApps: ()=>({ setState: setState })=>{
            setState({
                openedApps: []
            });
        },
    closeApp: (appId, action)=>({ setState: setState, getState: getState })=>{
            const openedApps = getState().openedApps;
            setState({
                openedApps: openedApps.filter((app)=>app.id !== appId || app.action !== action)
            });
        }
};
const $b68f39b65da4eb25$var$Store = (0, $iXqE5.createStore)({
    containedBy: $b68f39b65da4eb25$export$9d26afcb39445b8e,
    initialState: {
        openedApps: []
    },
    actions: $b68f39b65da4eb25$var$actions
});
const $b68f39b65da4eb25$export$a48819842c5a2f15 = (0, $3sQ5x.createHook)($b68f39b65da4eb25$var$Store);
const $b68f39b65da4eb25$var$isAppLoading = (state, { appId: appId, action: action })=>{
    return state.openedApps.some((app)=>app.id === appId && app.action === action && app.isLoading);
};
const $b68f39b65da4eb25$export$24db0add8de543af = (0, $3sQ5x.createHook)($b68f39b65da4eb25$var$Store, {
    selector: $b68f39b65da4eb25$var$isAppLoading
});
const $b68f39b65da4eb25$var$isAnyAppLoading = (state)=>state.openedApps.some((app)=>app.isLoading);
const $b68f39b65da4eb25$export$f65d61db50b49f3 = (0, $3sQ5x.createHook)($b68f39b65da4eb25$var$Store, {
    selector: $b68f39b65da4eb25$var$isAnyAppLoading
});

});

parcelRegister("5L7z2", function(module, exports) {

$parcel$export(module.exports, "SprintActionsConnectMenuItems", () => $65eeeccb724af285$export$f9a25247020e32b7);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $2NYED = parcelRequire("2NYED");

var $fNWqR = parcelRequire("fNWqR");
const $65eeeccb724af285$var$SprintActionsConnectInner = ({ sprintId: sprintId, location: location })=>{
    const sprintActions = (0, $fNWqR.useFetchedSprintActions)({
        sprintId: sprintId
    });
    const targetActions = (0, $5uXOq.useMemo)(()=>sprintActions?.[sprintId]?.[location] ?? null, [
        sprintId,
        location,
        sprintActions
    ]);
    if (!sprintActions || !targetActions) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, targetActions.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2NYED.BoardToolSubItem), {
            key: item.id,
            subItem: item
        })));
};
function $65eeeccb724af285$export$f9a25247020e32b7(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "board-connect-toolbar",
        packageName: "@atlassian/jira-software-sprint-actions-connect-items",
        teamName: "a4t-tanuki",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($65eeeccb724af285$var$SprintActionsConnectInner, props));
}

});
parcelRegister("2NYED", function(module, exports) {

$parcel$export(module.exports, "BoardToolWebItemView", () => $d8e9f6c964974fcf$export$37f386501b29905e);
$parcel$export(module.exports, "BoardToolSubItem", () => $d8e9f6c964974fcf$export$dbbc4e042bbab47e);

var $5uXOq = parcelRequire("5uXOq");

var $1GGwS = parcelRequire("1GGwS");

var $BLPHT = parcelRequire("BLPHT");

var $hRf4g = parcelRequire("hRf4g");

var $3dGN0 = parcelRequire("3dGN0");

var $kJpBP = parcelRequire("kJpBP");
var $3Z96c = parcelRequire("3Z96c");
var $eZUJu = parcelRequire("eZUJu");
var $9UCCQ = parcelRequire("9UCCQ");

var $1I7E8 = parcelRequire("1I7E8");

var $3bDjY = parcelRequire("3bDjY");

var $7CMCs = parcelRequire("7CMCs");

var $3HwlS = parcelRequire("3HwlS");

var $kxZPA = parcelRequire("kxZPA");
var $7hSN4 = parcelRequire("7hSN4");

var $hrlU6 = parcelRequire("hrlU6");

const $d8e9f6c964974fcf$export$87f324ad8d8a087a = (0, $kxZPA.lazy)(()=>(parcelRequire("8lzLG")).then(({ BoardToolWebPanelView: BoardToolWebPanelView })=>({
            default: BoardToolWebPanelView
        })), {
    moduleId: "./src/packages/software/connect-toolbar/src/common/ui/tool-sections/board-tool-section-view/board-tool-sub-item/board-tool-web-panel-view/index.tsx"
});
function $d8e9f6c964974fcf$export$37f386501b29905e({ subItem: subItem, mode: mode = 'dropdown-item', onClickWebItem: onClickWebItem, isTabNavigation: isTabNavigation = false }) {
    const { url: url, cssClass: cssClass, label: label } = subItem;
    const webItemRef = (0, $5uXOq.useRef)(null);
    const onWebItemClick = (e)=>{
        /**
     * When using the Board & Backlog header menu (the rightmost meatball menu),
     * the button gets unmounted because the menu closes upon clicking the button.
     * As a result, webItemRef.current becomes null when connectHost.triggerWebItem is called.
     * Therefore, we need to store the webItemRef in a variable for proper reference.
     */ const currentNode = webItemRef.current;
        (0, $hrlU6.withConnectHost)((connectHost)=>{
            if (currentNode) connectHost.triggerWebItem(currentNode, cssClass ?? '', url);
        });
        if ((0, $hrlU6.isConnectDialogWebItem)(cssClass ?? '')) {
            e.preventDefault();
            e.stopPropagation();
            if (onClickWebItem) onClickWebItem();
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, mode === 'dropdown-item' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: isTabNavigation ? label : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Z96c.default), {
        onClick: onWebItemClick,
        iconBefore: (0, $3HwlS.getWillShowNav4)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hRf4g))), {
            label: label,
            color: "var(--ds-icon, #44546F)"
        }),
        testId: "software-connect-toolbar.common.ui.tool-sections.board-tool-section-view.board-tool-sub-item.link-item",
        ref: webItemRef,
        href: url
    }, label)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1GGwS.default), {
        testId: "software-connect-toolbar.common.ui.tool-sections.board-tool-section-view.board-tool-sub-item.link-item",
        onClick: onWebItemClick,
        ref: webItemRef,
        href: url
    }, label));
}
function $d8e9f6c964974fcf$export$dbbc4e042bbab47e({ subItem: subItem, onClickWebItem: onClickWebItem, isTabNavigation: isTabNavigation = false }) {
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    if (subItem.type === 'webItem') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d8e9f6c964974fcf$export$37f386501b29905e, {
        onClickWebItem: onClickWebItem,
        subItem: subItem,
        isTabNavigation: isTabNavigation
    });
    if (subItem.type === 'section') {
        const content = subItem.subItems?.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d8e9f6c964974fcf$export$dbbc4e042bbab47e, {
                key: item.id,
                subItem: item,
                isTabNavigation: isTabNavigation
            }));
        if (subItem.label === '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, content);
        if (isTabNavigation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
            isOpen: isOpen,
            onClose: ()=>setIsOpen(false),
            placement: "left-start",
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                    content: subItem.label
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
                    ...triggerProps,
                    iconBefore: (0, $3HwlS.getWillShowNav4)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hRf4g))), {
                        label: subItem.label,
                        color: "var(--ds-icon, #44546F)"
                    }),
                    iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3dGN0))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)"
                    }),
                    onClick: ()=>setIsOpen(!isOpen),
                    testId: "software-connect-toolbar.common.ui.tool-sections.board-tool-section-view.board-tool-sub-item.popup-menu-trigger"
                }, subItem.label)),
            content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), {
                    maxWidth: 240,
                    onClick: (e)=>e.stopPropagation()
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), null, content))
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
            placement: "right-end",
            trigger: subItem.label,
            testId: "software-connect-toolbar.common.ui.tool-sections.board-tool-section-view.board-tool-sub-item.dropdown-menu"
        }, content);
    }
    if (subItem.type === 'webPanel') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "board-tool-web-panel-view",
        packageName: "@atlassian/jira-software-connect-toolbar",
        teamName: "a4t-tanuki"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7hSN4.LazySuspense), {
        fallback: "Loading..."
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d8e9f6c964974fcf$export$87f324ad8d8a087a, {
        webPanel: subItem
    })));
    return null;
}

});
parcelRegister("8lzLG", function(module, exports) {

let $613c07acd0b27ec7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $613c07acd0b27ec7$var$load("fSRZj").then(()=>parcelRequire('cvEOi'));

});


parcelRegister("fNWqR", function(module, exports) {

$parcel$export(module.exports, "useFetchedToolSections", () => $08c1f6f26ff4abdf$export$32bd6c5ac0419028);
$parcel$export(module.exports, "useHasToolSections", () => $08c1f6f26ff4abdf$export$54be06d39c052cd5);
$parcel$export(module.exports, "useFetchedSprintActions", () => $08c1f6f26ff4abdf$export$d58666d3ff237ccd);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $fjfkx = parcelRequire("fjfkx");

var $78UP2 = parcelRequire("78UP2");

var $lEUlW = parcelRequire("lEUlW");
const $08c1f6f26ff4abdf$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    name: '@atlassian/jira-software-connect-toolbar',
    initialState: {
        toolSections: null,
        key: null,
        isLoading: false,
        sprintActions: null
    },
    actions: $lEUlW
});
const $08c1f6f26ff4abdf$export$d5aeb5eefb04c978 = (0, $3sQ5x.createHook)($08c1f6f26ff4abdf$export$390f32400eaf98c9, {
    selector: (state)=>state.toolSections
});
function $08c1f6f26ff4abdf$export$32bd6c5ac0419028({ boardId: boardId, projectKey: projectKey, mode: mode = 'work' }) {
    const [toolSections, { fetchExtensionData: fetchExtensionData }] = $08c1f6f26ff4abdf$export$d5aeb5eefb04c978();
    (0, $5uXOq.useEffect)(()=>{
        fetchExtensionData({
            boardId: boardId,
            projectKey: projectKey,
            mode: mode
        });
    }, [
        boardId,
        fetchExtensionData,
        mode,
        projectKey
    ]);
    return toolSections;
}
function $08c1f6f26ff4abdf$export$54be06d39c052cd5({ boardId: boardId, projectKey: projectKey, mode: mode = 'work', itemLocations: itemLocations = [] }) {
    const toolSections = $08c1f6f26ff4abdf$export$32bd6c5ac0419028({
        boardId: boardId,
        projectKey: projectKey,
        mode: mode
    });
    const relevantSections = (0, $fjfkx.useConnectPluginSections)(toolSections ?? []);
    const hasRelevantSections = relevantSections ? relevantSections.length > 0 : false;
    const hasTargetSections = itemLocations.some((location)=>((toolSections && (0, $78UP2.findSection)(toolSections, location)?.subItems?.filter((item)=>item.id != null).length) ?? 0) > 0);
    return hasTargetSections || hasRelevantSections;
}
const $08c1f6f26ff4abdf$export$fa6cceef0215e684 = (0, $3sQ5x.createHook)($08c1f6f26ff4abdf$export$390f32400eaf98c9, {
    selector: (state)=>state.sprintActions
});
const $08c1f6f26ff4abdf$export$d58666d3ff237ccd = ({ sprintId: sprintId })=>{
    const [sprintActions, { fetchSprintActionsData: fetchSprintActionsData }] = $08c1f6f26ff4abdf$export$fa6cceef0215e684();
    (0, $5uXOq.useEffect)(()=>{
        fetchSprintActionsData({
            sprintId: sprintId
        });
    }, [
        fetchSprintActionsData,
        sprintId
    ]);
    return sprintActions;
};

});
parcelRegister("fjfkx", function(module, exports) {

$parcel$export(module.exports, "useConnectPluginSections", () => $761d5c3db4b1e977$export$9f557e5e5102c0b2);
$parcel$export(module.exports, "BoardToolsView", () => $761d5c3db4b1e977$export$a97914bd35ac0c68);

var $5uXOq = parcelRequire("5uXOq");

var $2NYED = parcelRequire("2NYED");

var $88pw4 = parcelRequire("88pw4");
function $761d5c3db4b1e977$export$9f557e5e5102c0b2(toolSections) {
    return (0, $5uXOq.useMemo)(()=>toolSections?.filter((section)=>section.id !== 'board-tools-section'), [
        toolSections
    ]);
}
function $761d5c3db4b1e977$export$a97914bd35ac0c68({ toolSections: toolSections, mode: mode = 'button', onClickWebItem: onClickWebItem, isTabNavigation: isTabNavigation = false }) {
    const relevantSections = $761d5c3db4b1e977$export$9f557e5e5102c0b2(toolSections);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, relevantSections?.map((section)=>section.type === 'webItem' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2NYED.BoardToolWebItemView), {
            key: section.id,
            subItem: section,
            mode: mode,
            onClickWebItem: mode === 'dropdown-item' ? onClickWebItem : undefined,
            isTabNavigation: isTabNavigation
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $88pw4.BoardToolSectionView), {
            key: section.id,
            section: section,
            isMenuItem: mode === 'dropdown-item' && isTabNavigation,
            isTabNavigation: isTabNavigation
        })));
}

});
parcelRegister("88pw4", function(module, exports) {

$parcel$export(module.exports, "BoardToolSectionView", () => $298a4a1ba5bb50fb$export$c57d75d82c2414d5);

var $5uXOq = parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");

var $BLPHT = parcelRequire("BLPHT");

var $hRf4g = parcelRequire("hRf4g");

var $hORKG = parcelRequire("hORKG");

var $3dGN0 = parcelRequire("3dGN0");

var $kJpBP = parcelRequire("kJpBP");
var $eZUJu = parcelRequire("eZUJu");
var $9UCCQ = parcelRequire("9UCCQ");

var $1I7E8 = parcelRequire("1I7E8");

var $3bDjY = parcelRequire("3bDjY");

var $3HwlS = parcelRequire("3HwlS");

var $2NYED = parcelRequire("2NYED");
function $298a4a1ba5bb50fb$export$c57d75d82c2414d5({ section: section, isMenuItem: isMenuItem = false, isTabNavigation: isTabNavigation = false }) {
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    if (isTabNavigation) {
        const content = ()=>section.subItems?.map((subItem)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2NYED.BoardToolSubItem), {
                    key: subItem.id,
                    subItem: subItem
                }));
        return isMenuItem ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
            isOpen: isOpen,
            onClose: ()=>setIsOpen(false),
            placement: "left-start",
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                    content: section.label
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
                    ...triggerProps,
                    iconBefore: (0, $3HwlS.getWillShowNav4)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hRf4g))), {
                        label: section.label,
                        color: "var(--ds-icon, #44546F)"
                    }),
                    iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3dGN0))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)"
                    }),
                    onClick: ()=>setIsOpen(!isOpen),
                    testId: "software-connect-toolbar.common.ui.tool-sections.board-tool-section-view.popup-menu-trigger"
                }, section.label)),
            content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), {
                    maxWidth: 240,
                    onClick: (e)=>e.stopPropagation()
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), null, content()))
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
            isOpen: isOpen,
            onClose: ()=>setIsOpen(false),
            placement: "bottom-end",
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                    content: section.label
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
                    ...triggerProps,
                    isSelected: isOpen,
                    iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($hORKG))),
                    onClick: ()=>setIsOpen(!isOpen),
                    testId: "software-connect-toolbar.common.ui.tool-sections.board-tool-section-view.popup-menu-trigger"
                }, section.label)),
            content: content
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        placement: "bottom-end",
        trigger: section.label,
        testId: "software-connect-toolbar.common.ui.tool-sections.board-tool-section-view.dropdown-menu"
    }, section.subItems?.map((subItem)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2NYED.BoardToolSubItem), {
            key: subItem.id,
            subItem: subItem
        })));
}

});


parcelRegister("78UP2", function(module, exports) {

$parcel$export(module.exports, "findSection", () => $003eeb674acde218$export$967ce3543c950aeb);
function $003eeb674acde218$export$967ce3543c950aeb(toolSections, location) {
    for(let i = 0; i < toolSections.length; i += 1){
        const item = toolSections[i];
        if (item.type === 'section' && item.id === location) return item;
        if (item.type === 'section' && item.subItems != null) {
            const candidate = $003eeb674acde218$export$967ce3543c950aeb(item.subItems, location);
            if (candidate != null) return candidate;
        }
    }
    return null;
}

});

parcelRegister("lEUlW", function(module, exports) {

$parcel$export(module.exports, "fetchExtensionData", () => $5344c8cf4b3b110f$export$5fe98ae96d282610);
$parcel$export(module.exports, "fetchSprintActionsData", () => $5344c8cf4b3b110f$export$d50a304a5f5a89a3);

var $2YZCu = parcelRequire("2YZCu");

var $agj21 = parcelRequire("agj21");

var $b1Aqw = parcelRequire("b1Aqw");
const $5344c8cf4b3b110f$export$5fe98ae96d282610 = ({ boardId: boardId, projectKey: projectKey, mode: mode = 'work' })=>async ({ getState: getState, setState: setState })=>{
        const key = JSON.stringify([
            projectKey,
            boardId,
            mode
        ]);
        const state = getState();
        if (state.key === key && state.isLoading) return;
        if (state.key !== key) setState({
            toolSections: null,
            isLoading: true,
            key: key
        });
        else setState({
            isLoading: true
        });
        try {
            const response = await (0, $b1Aqw.fetchCMPExtensionData)({
                boardId: boardId,
                projectKey: projectKey,
                mode: mode
            });
            setState({
                toolSections: response.sections,
                key: key,
                isLoading: false
            });
        } catch (error) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData('software.extension.board-tools', error instanceof Error ? error.message : String(error), error instanceof Error ? error : undefined);
            setState({
                isLoading: false
            });
        }
    };
const $5344c8cf4b3b110f$export$d50a304a5f5a89a3 = ({ sprintId: sprintId })=>async ({ getState: getState, setState: setState })=>{
        const { sprintActions: sprintActions } = getState();
        const findActions = sprintActions?.[sprintId] || {
            isLoading: false,
            hasLoaded: false
        };
        if (findActions.isLoading || findActions.hasLoaded) return;
        // set loading to true to prevent multiple requests
        setState({
            sprintActions: {
                ...sprintActions,
                [sprintId]: {
                    isLoading: true,
                    hasLoaded: false
                }
            }
        });
        try {
            const response = await (0, $b1Aqw.fetchCMPSprintActionsData)({
                sprintId: sprintId
            });
            const actionsForSprint = (0, $agj21.transformSprintActionsResponse)(response);
            setState({
                sprintActions: {
                    ...getState().sprintActions,
                    [sprintId]: {
                        ...actionsForSprint,
                        isLoading: false,
                        hasLoaded: true
                    }
                }
            });
        } catch (error) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData('software.extension.sprint-actions', error instanceof Error ? error.message : String(error), error instanceof Error ? error : undefined);
            setState({
                sprintActions: {
                    ...getState().sprintActions,
                    [sprintId]: {
                        isLoading: false,
                        hasLoaded: false
                    }
                }
            });
        }
    };

});
parcelRegister("agj21", function(module, exports) {

$parcel$export(module.exports, "transformSprintActionsResponse", () => $96e521c26ac919f8$export$bb626d8539383296);
const $96e521c26ac919f8$export$8b3475589327aa1c = (sprintAction)=>({
        id: sprintAction.id,
        type: 'webItem',
        label: sprintAction.name,
        url: sprintAction.url,
        cssClass: sprintAction.styleClass
    });
const $96e521c26ac919f8$export$5365f133b30aefb1 = (sprintAction)=>Boolean(sprintAction.url);
const $96e521c26ac919f8$export$1d427bb13100a4da = (section)=>section.groupId === 'sprint-move-actions' || section.groupId === 'sprint-edit-action' || section.groupId === 'sprint-delete-action';
const $96e521c26ac919f8$export$bb626d8539383296 = (sprintActionsResponse)=>{
    const result = {};
    sprintActionsResponse.sections.filter($96e521c26ac919f8$export$1d427bb13100a4da).forEach((section)=>{
        const actions = section.actions.filter($96e521c26ac919f8$export$5365f133b30aefb1).map($96e521c26ac919f8$export$8b3475589327aa1c);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        result[section.groupId] = actions;
    });
    return result;
};

});

parcelRegister("b1Aqw", function(module, exports) {

$parcel$export(module.exports, "fetchCMPExtensionData", () => $ce9155dcdaa49b1d$export$aa96aae4fab07720);
$parcel$export(module.exports, "fetchCMPSprintActionsData", () => $ce9155dcdaa49b1d$export$2a796a8235b7b986);

var $7f4tk = parcelRequire("7f4tk");
function $ce9155dcdaa49b1d$export$aa96aae4fab07720({ boardId: boardId, projectKey: projectKey, mode: mode = 'work' }) {
    return (0, $7f4tk.default)(`/rest/greenhopper/1.0/xboard/toolSections?mode=${mode}&rapidViewId=${boardId}&selectedProjectKey=${projectKey}&_=${Date.now()}&operation=CMPExtensionData`);
}
function $ce9155dcdaa49b1d$export$2a796a8235b7b986({ sprintId: sprintId }) {
    return (0, $7f4tk.default)(`/rest/greenhopper/1.0/xboard/plan/sprints/actions?sprintId=${sprintId}&_=${Date.now()}`);
}

});




parcelRegister("2F0OA", function(module, exports) {

$parcel$export(module.exports, "sprintDeleteModalEntryPoint", () => $db990fee6dc12c0b$export$60f5a667ca68ee8c);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $db990fee6dc12c0b$export$60f5a667ca68ee8c = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("jitJ9")), {
        moduleId: "a19e1920"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("jitJ9", function(module, exports) {

let $e0c6c1f8b410c98e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e0c6c1f8b410c98e$var$load("21kaJ").then(()=>parcelRequire('fWpr3'));

});


parcelRegister("7ay7C", function(module, exports) {

$parcel$export(module.exports, "ForgeSprintActionMenuItems", () => $29644ab46df6dd7e$export$dfd2d42be9fd075a);

var $5uXOq = parcelRequire("5uXOq");


var $b71gk = parcelRequire("b71gk");

var $bv8Hu = parcelRequire("bv8Hu");

var $k2DRb = parcelRequire("k2DRb");

var $5bkvv = parcelRequire("5bkvv");

var $2YP9W = parcelRequire("2YP9W");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");
const $29644ab46df6dd7e$var$ForgeActionMenuItems = ({ sprintId: sprintId, sprintState: sprintState })=>{
    const { loading: loading, data: extensions } = (0, $2YP9W.useResource)((0, $5bkvv.forgeSprintModuleResource));
    const backlogExtensionData = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getBacklogExtensionData));
    const memoedExtensionData = (0, $5uXOq.useMemo)(()=>({
            ...backlogExtensionData,
            sprint: {
                id: sprintId,
                state: sprintState
            }
        }), [
        backlogExtensionData,
        sprintId,
        sprintState
    ]);
    if (loading || !extensions || extensions.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bv8Hu.ForgeActionMenuItems), {
        module: (0, $k2DRb.SPRINT_ACTION_MODULE),
        analyticsSource: (0, $fcf97b7a09088940$export$53d41ff2666118e1),
        testId: "software-backlog.card-list.sprints-menu.forge-items",
        extensions: extensions,
        extensionData: memoedExtensionData
    });
};
const $29644ab46df6dd7e$export$dfd2d42be9fd075a = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        packageName: "software",
        id: "forge-items"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($29644ab46df6dd7e$var$ForgeActionMenuItems, props)));

});
parcelRegister("bv8Hu", function(module, exports) {

$parcel$export(module.exports, "ForgeActionMenuItems", () => $28755ab592a11290$export$6d48af8c1ac00cc9);

var $5uXOq = parcelRequire("5uXOq");

var $3dGN0 = parcelRequire("3dGN0");

var $kJpBP = parcelRequire("kJpBP");
var $eZUJu = parcelRequire("eZUJu");
var $9UCCQ = parcelRequire("9UCCQ");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");

var $3bDjY = parcelRequire("3bDjY");

var $jDKvL = parcelRequire("jDKvL");

var $h0JHu = parcelRequire("h0JHu");

var $5cmSg = parcelRequire("5cmSg");

var $jgJNO = parcelRequire("jgJNO");

var $l1LNZ = parcelRequire("l1LNZ");

var $5jnXk = parcelRequire("5jnXk");
const $28755ab592a11290$var$stopPropagation = (e)=>e.stopPropagation();
const $28755ab592a11290$var$useExtensions = (data)=>{
    return (0, $5uXOq.useMemo)(()=>data.filter((0, $5cmSg.isExtensionVisible)).sort(({ properties: { title: titleA } }, { properties: { title: titleB } })=>titleA.localeCompare(titleB)), [
        data
    ]);
};
const $28755ab592a11290$export$6d48af8c1ac00cc9 = /*#__PURE__*/ (0, $5uXOq.memo)(({ extensions: rawExtensions, extensionData: extensionData, testId: testId, analyticsSource: analyticsSource, module: module })=>{
    const extensions = $28755ab592a11290$var$useExtensions(rawExtensions);
    const [, { closeApps: closeApps }] = (0, $jDKvL.useForgeApps)();
    // Close all Forge apps when the data is re-fetched
    (0, $5uXOq.useEffect)(()=>{
        closeApps();
    }, [
        extensions,
        closeApps
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        hasSeparator: true,
        testId: testId
    }, extensions.map((extension)=>{
        const actions = extension.properties.actions ?? [];
        if (actions.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($28755ab592a11290$export$b84e0d11207da93f, {
            key: extension.id,
            extension: extension,
            extensionData: extensionData,
            analyticsSource: analyticsSource,
            module: module
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($28755ab592a11290$export$9907687a0b943b6b, {
            key: extension.id,
            extension: extension,
            extensionData: extensionData,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1LNZ.ForgeIcon), {
                url: extension.properties.icon
            }),
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h0JHu.ExtensionTitle), {
                extensionName: extension.properties.title,
                extensionEnvType: extension.environmentType,
                extensionEnvKey: extension.environmentKey,
                autoTruncate: true
            }),
            tooltip: extension.properties.tooltip,
            analyticsSource: analyticsSource,
            module: module
        });
    }));
});
const $28755ab592a11290$export$9907687a0b943b6b = ({ extension: extension, extensionData: extensionData, title: title, actionKey: actionKey, tooltip: tooltip, icon: icon, analyticsSource: analyticsSource, module: module })=>{
    const { fireUiTriggerClickedEvent: fireUiTriggerClickedEvent, TriggerAnalyticsWrapper: TriggerAnalyticsWrapper, ForgeScreenEvent: ForgeScreenEvent } = (0, $5jnXk.useActionMenuAnalyticsComponents)({
        extension: extension,
        analyticsSource: analyticsSource,
        module: module
    });
    const [, { openApp: openApp }] = (0, $jDKvL.useForgeApps)();
    const { id: id } = extension;
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        fireUiTriggerClickedEvent();
        openApp(id, extension, actionKey, extensionData);
    }, [
        fireUiTriggerClickedEvent,
        openApp,
        id,
        extension,
        actionKey,
        extensionData
    ]);
    const [isAppLoading] = (0, $jDKvL.useIsAppLoading)({
        appId: id,
        action: actionKey
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TriggerAnalyticsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($28755ab592a11290$var$TooltipEnabledButtonItem, {
        iconBefore: icon,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($28755ab592a11290$var$LoadingIndicator, {
            isLoading: isAppLoading
        }),
        onClick: handleClick,
        tooltip: tooltip
    }, title, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ForgeScreenEvent, null)));
};
const $28755ab592a11290$export$b84e0d11207da93f = ({ extension: extension, extensionData: extensionData, analyticsSource: analyticsSource, module: module })=>{
    const { fireUiTriggerClickedEvent: fireUiTriggerClickedEvent, TriggerAnalyticsWrapper: TriggerAnalyticsWrapper, ForgeScreenEvent: ForgeScreenEvent } = (0, $5jnXk.useActionMenuAnalyticsComponents)({
        extension: extension,
        analyticsSource: analyticsSource,
        module: module
    });
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const handleClose = (0, $5uXOq.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    const toggleMenu = (0, $5uXOq.useCallback)(()=>{
        fireUiTriggerClickedEvent();
        setIsOpen((opened)=>!opened);
    }, [
        setIsOpen,
        fireUiTriggerClickedEvent
    ]);
    const title = extension.properties?.title ?? '';
    const icon = extension.properties?.icon;
    const tooltip = extension.properties?.tooltip;
    const popupTrigger = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TriggerAnalyticsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($28755ab592a11290$var$TooltipEnabledButtonItem, {
            ...triggerProps,
            tooltip: tooltip,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1LNZ.ForgeIcon), {
                url: icon
            }),
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3dGN0))), {
                label: "",
                color: "var(--ds-icon, #44546F)"
            }),
            onClick: toggleMenu
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h0JHu.ExtensionTitle), {
            extensionName: title,
            extensionEnvType: extension.environmentType,
            extensionEnvKey: extension.environmentKey,
            autoTruncate: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ForgeScreenEvent, null))), [
        TriggerAnalyticsWrapper,
        tooltip,
        icon,
        toggleMenu,
        title,
        extension.environmentType,
        extension.environmentKey,
        ForgeScreenEvent
    ]);
    const popupContent = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), {
            maxWidth: 240,
            onClick: $28755ab592a11290$var$stopPropagation
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), null, (extension.properties.actions ?? []).map((action)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($28755ab592a11290$export$9907687a0b943b6b, {
                key: action.key,
                title: action.title,
                tooltip: action.tooltip,
                actionKey: action.key,
                extension: extension,
                extensionData: extensionData,
                analyticsSource: analyticsSource,
                module: module
            })))), [
        extension,
        extensionData,
        analyticsSource,
        module
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        onClose: handleClose,
        placement: "left-start",
        messageId: "forge-ui-action-apps.ui.action-menu.popup",
        messageType: "transactional",
        trigger: popupTrigger,
        content: popupContent,
        shouldRenderToParent: true
    });
};
const $28755ab592a11290$var$LoadingIndicator = /*#__PURE__*/ (0, $5uXOq.memo)(({ isLoading: isLoading })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $28755ab592a11290$var$indicatorStyle
    }, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "small"
    }));
});
const $28755ab592a11290$var$TooltipEnabledButtonItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ tooltip: tooltip, ...props }, ref)=>{
    return tooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: tooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        ...props,
        ref: ref
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        ...props,
        ref: ref
    });
});
const $28755ab592a11290$var$indicatorStyle = (0, $8CUq3.xcss)({
    width: "var(--ds-space-150, 12px)"
});

});
parcelRegister("5jnXk", function(module, exports) {

$parcel$export(module.exports, "useActionMenuAnalyticsComponents", () => $a6ed3a4f0f134747$export$f12e5e0ff16730d6);

var $5uXOq = parcelRequire("5uXOq");

var $1rTGO = parcelRequire("1rTGO");

var $8uOa6 = parcelRequire("8uOa6");

var $2RhPB = parcelRequire("2RhPB");

var $9BrHy = parcelRequire("9BrHy");

var $8kVg1 = parcelRequire("8kVg1");

var $hBuqR = parcelRequire("hBuqR");

var $4R6GH = parcelRequire("4R6GH");
const $a6ed3a4f0f134747$var$getAnalyticsAttributes = (extension)=>{
    const { moduleType: moduleType, ...attrs } = (0, $2RhPB.getAnalyticsAttributesFromExtension)(extension);
    return attrs;
};
const $a6ed3a4f0f134747$export$a2f2d30e960414ce = (attributes)=>{
    const { module: module, extensionId: extensionId, source: source } = attributes;
    return {
        fireUiTriggerClickedEvent: $a6ed3a4f0f134747$var$makeFireUiTriggerClickedEvent(module, extensionId, source),
        ViewAnalyticsWrapper: $a6ed3a4f0f134747$var$makeViewAnalyticsWrapper(attributes),
        TriggerAnalyticsWrapper: $a6ed3a4f0f134747$var$makeTriggerAnalyticsWrapper(attributes),
        ForgeScreenEvent: $a6ed3a4f0f134747$var$makeScreenEvent(attributes)
    };
};
const $a6ed3a4f0f134747$export$f12e5e0ff16730d6 = ({ module: module, analyticsSource: analyticsSource, extension: extension })=>{
    const extensionAnalyticsAttributes = (0, $5uXOq.useMemo)(()=>({
            ...$a6ed3a4f0f134747$var$getAnalyticsAttributes(extension),
            source: analyticsSource,
            module: module,
            extensionId: extension.id
        }), [
        extension,
        analyticsSource,
        module
    ]);
    return (0, $5uXOq.useMemo)(()=>$a6ed3a4f0f134747$export$a2f2d30e960414ce(extensionAnalyticsAttributes), [
        extensionAnalyticsAttributes
    ]);
};
const $a6ed3a4f0f134747$var$makeViewAnalyticsWrapper = (props)=>{
    return /*#__PURE__*/ (0, $5uXOq.memo)(({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), props, children));
};
const $a6ed3a4f0f134747$var$makeTriggerAnalyticsWrapper = (props)=>{
    return /*#__PURE__*/ (0, $5uXOq.memo)(({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
            ...props,
            moduleType: (0, $hBuqR.MODULE_TYPE_TRIGGER)
        }, children));
};
const $a6ed3a4f0f134747$var$makeScreenEvent = (attributes)=>{
    return /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeScreenEvent), {
            attributes: attributes
        }));
};
const $a6ed3a4f0f134747$var$makeFireUiTriggerClickedEvent = (module, extensionId, source)=>{
    const triggerEventId = (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getEventId)({
        module: module,
        moduleType: (0, $hBuqR.MODULE_TYPE_TRIGGER)
    }) : (0, $9BrHy.getEventIdOld)({
        module: module,
        moduleType: (0, $hBuqR.MODULE_TYPE_TRIGGER)
    });
    return ()=>{
        (0, $8kVg1.forgeModulesConcurrentLoadTime)(extensionId).start({
            startTime: performance.now()
        });
        return (0, $8uOa6.fireUiEvent)((0, $hBuqR.UI_ACTIONS).CLICKED, {
            id: triggerEventId,
            source: source
        });
    };
};

});



parcelRegister("bwwYO", function(module, exports) {

$parcel$export(module.exports, "SprintActionForgeRuntimeContainer", () => $368cb71806f4b24d$export$7f0b055a46162f73);

var $5uXOq = parcelRequire("5uXOq");


var $b71gk = parcelRequire("b71gk");

var $84ZsI = parcelRequire("84ZsI");

var $9rLFK = parcelRequire("9rLFK");

var $k2DRb = parcelRequire("k2DRb");
const $368cb71806f4b24d$export$7f0b055a46162f73 = /*#__PURE__*/ (0, $5uXOq.memo)(({ onAppsFinishLoading: onAppsFinishLoading })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        packageName: "software",
        id: "forge-sprint-action-runtime-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $84ZsI.ActionMenuForgeRuntimeContainer), {
        onAppsFinishLoading: onAppsFinishLoading,
        forgeAppRenderer: (0, $9rLFK.AsyncSprintAction),
        module: (0, $k2DRb.SPRINT_ACTION_MODULE),
        analyticsSource: (0, $fcf97b7a09088940$export$53d41ff2666118e1)
    }));
});

});
parcelRegister("84ZsI", function(module, exports) {

$parcel$export(module.exports, "ActionMenuForgeRuntimeContainer", () => $167dc37a25b2fd5f$export$a65c809543ceb95a);

var $5uXOq = parcelRequire("5uXOq");

var $jDKvL = parcelRequire("jDKvL");

var $bfAsP = parcelRequire("bfAsP");

var $1rTGO = parcelRequire("1rTGO");

var $2RhPB = parcelRequire("2RhPB");
const $167dc37a25b2fd5f$export$a65c809543ceb95a = ({ onAppsFinishLoading: onAppsFinishLoading, forgeAppRenderer: ForgeAppRenderer, analyticsSource: analyticsSource, module: module })=>{
    const [isAnyForgeAppLoading] = (0, $jDKvL.useIsAnyAppLoading)();
    (0, $5uXOq.useEffect)(()=>{
        // this is to close the dropdown when all forge apps are loaded
        if (onAppsFinishLoading && !isAnyForgeAppLoading) onAppsFinishLoading();
    }, [
        isAnyForgeAppLoading,
        onAppsFinishLoading
    ]);
    const AdaptedForgeAppRenderer = (0, $5uXOq.useMemo)(()=>{
        return $167dc37a25b2fd5f$var$makeForgeAppRenderer(ForgeAppRenderer, module, analyticsSource);
    }, [
        ForgeAppRenderer,
        analyticsSource,
        module
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bfAsP.ForgeAppsRuntimeContainer), {
        forgeAppRenderer: AdaptedForgeAppRenderer
    });
};
const $167dc37a25b2fd5f$var$makeForgeAppRenderer = (Renderer, module, analyticsSource)=>{
    return ({ handleError: baseHandleError, app: app, localId: localId, closeApp: closeApp, setLoaded: setLoaded })=>{
        const handleError = (0, $5uXOq.useCallback)(()=>{
            baseHandleError && baseHandleError();
        }, [
            baseHandleError
        ]);
        const analyticsAttributes = (0, $5uXOq.useMemo)(()=>{
            return {
                source: analyticsSource,
                ...(0, $2RhPB.getAnalyticsAttributesFromExtension)(app.extension)
            };
        }, [
            app.extension
        ]);
        const rendererProps = (0, $5uXOq.useMemo)(()=>({
                localId: localId,
                extension: app.extension,
                extensionData: app.extensionData,
                onClose: closeApp,
                analyticsAttributes: analyticsAttributes,
                onLoad: setLoaded,
                onInitialRender: setLoaded,
                onError: handleError
            }), [
            analyticsAttributes,
            app.extension,
            app.extensionData,
            closeApp,
            handleError,
            localId,
            setLoaded
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
            module: module,
            attributes: analyticsAttributes,
            shouldFireInitializedEvent: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Renderer, rendererProps));
    };
};

});
parcelRegister("bfAsP", function(module, exports) {

$parcel$export(module.exports, "ForgeAppsRuntimeContainer", () => $4f172c8b740168bb$export$db56fac1456ccba8);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $4siKa = parcelRequire("4siKa");

var $koVbs = parcelRequire("koVbs");

var $jDKvL = parcelRequire("jDKvL");

var $xd3DV = parcelRequire("xd3DV");
const $4f172c8b740168bb$var$toTargetForgeApp = (app)=>{
    return {
        id: app.id,
        extension: app.extension,
        extensionData: app.action ? {
            ...app.extensionData,
            action: app.action
        } : app.extensionData
    };
};
const $4f172c8b740168bb$var$BaseForgeAppRenderer = ({ app: app, setAppLoaded: setAppLoaded, setAppClose: setAppClose, renderer: ForgeAppRendererComponent })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const localId = app.extensionData.action ? `${app.id},action:${app.extensionData.action}` : app.id;
    const setLoaded = (0, $5uXOq.useCallback)(()=>{
        app.isLoading && setAppLoaded(app.id, app.action);
    }, [
        app.id,
        app.action,
        app.isLoading,
        setAppLoaded
    ]);
    const closeApp = (0, $5uXOq.useCallback)(()=>{
        setAppClose(app.id, app.action);
    }, [
        app.id,
        app.action,
        setAppClose
    ]);
    const targetApp = (0, $5uXOq.useMemo)(()=>$4f172c8b740168bb$var$toTargetForgeApp(app), [
        app
    ]);
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const handleError = (0, $5uXOq.useCallback)((msg)=>{
        showFlag({
            key: localId,
            type: 'error',
            title: formatMessage((0, $xd3DV.messages).appErrorTitle),
            description: msg ?? formatMessage((0, $xd3DV.messages).appErrorDescription),
            messageId: 'forge-action-apps-controller.show-flag.error',
            messageType: 'transactional'
        });
    }, [
        showFlag,
        localId,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ForgeAppRendererComponent, {
        localId: localId,
        app: targetApp,
        setLoaded: setLoaded,
        closeApp: closeApp,
        isLoading: app.isLoading,
        handleError: handleError
    });
};
const $4f172c8b740168bb$export$db56fac1456ccba8 = ({ forgeAppRenderer: forgeAppRenderer })=>{
    const [{ openedApps: openedApps }, { setAppLoaded: setAppLoaded, closeApps: closeApps, closeApp: closeApp }] = (0, $jDKvL.useForgeApps)();
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            closeApps();
        };
    }, [
        closeApps
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4siKa.InvisibleDiv), null, openedApps.map((app)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4f172c8b740168bb$var$BaseForgeAppRenderer, {
            key: app.uuid,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            app: app,
            setAppLoaded: setAppLoaded,
            setAppClose: closeApp,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            renderer: forgeAppRenderer
        })));
};

});
parcelRegister("4siKa", function(module, exports) {

$parcel$export(module.exports, "InvisibleDiv", () => $cfdc7368b5d9a379$export$22ef238a7bbeac70);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $cfdc7368b5d9a379$export$22ef238a7bbeac70 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
});
const $cfdc7368b5d9a379$export$1442582cffa6fcb7 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisible: isVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq",
            __cmplp.isVisible ? "_1e0c1ule" : "_1e0cglyw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("xd3DV", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f35d1e21793a4908$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $f35d1e21793a4908$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    appErrorTitle: {
        "id": "forge-ui-controllers.action-apps-controller.app-error-title",
        "defaultMessage": "App Error"
    },
    appErrorDescription: {
        "id": "forge-ui-controllers.action-apps-controller.app-error-description",
        "defaultMessage": "An error occurred while loading the app"
    }
});

});



parcelRegister("9rLFK", function(module, exports) {

$parcel$export(module.exports, "AsyncSprintAction", () => $376711cf4da171dd$export$89be570e58bedfee);

var $5uXOq = parcelRequire("5uXOq");

var $k2DRb = parcelRequire("k2DRb");

var $lfTZh = parcelRequire("lfTZh");

var $jVbVW = parcelRequire("jVbVW");
const $376711cf4da171dd$export$89be570e58bedfee = (props)=>{
    const { extensionData: extensionData } = props;
    const extensionDataValue = (0, $5uXOq.useMemo)(()=>({
            ...extensionData,
            type: (0, $k2DRb.SPRINT_ACTION_MODULE)
        }), [
        extensionData
    ]);
    const extraProps = (0, $5uXOq.useMemo)(()=>({
            module: (0, $k2DRb.SPRINT_ACTION_MODULE),
            extensionData: extensionDataValue,
            contextToken: (0, $k2DRb.CONTEXT_TOKEN_TYPE_JIRA)
        }), [
        extensionDataValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "sprint-action",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jVbVW.LazyBoardViewForgeExtension), {
        ...props,
        ...extraProps
    }));
};

});
parcelRegister("jVbVW", function(module, exports) {

$parcel$export(module.exports, "LazyBoardViewForgeExtension", () => $38bcce0ad2eac1db$export$d461d27cd7978a77);

var $1rTGO = parcelRequire("1rTGO");

var $kxZPA = parcelRequire("kxZPA");

const $38bcce0ad2eac1db$var$getModule = ()=>(parcelRequire("4xtB4"));
const $38bcce0ad2eac1db$export$d461d27cd7978a77 = (0, $1rTGO.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $kxZPA.lazyForPaint)(()=>$38bcce0ad2eac1db$var$getModule().then((module)=>module.BoardViewForgeExtension), {
    ssr: false
}));

});
parcelRegister("4xtB4", function(module, exports) {

let $34e133cda4d02ef4$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $34e133cda4d02ef4$var$load("3yAl4"),
    $34e133cda4d02ef4$var$load("76n7a"),
    $34e133cda4d02ef4$var$load("l253H"),
    $34e133cda4d02ef4$var$load("kNFvF"),
    $34e133cda4d02ef4$var$load("ffQaD"),
    $34e133cda4d02ef4$var$load("kvRbA"),
    $34e133cda4d02ef4$var$load("jqTxj")
]).then(()=>parcelRequire('lfpoU'));

});




parcelRegister("kseO3", function(module, exports) {

$parcel$export(module.exports, "default", () => $02c3a62095ba21d7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $02c3a62095ba21d7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    menuTrigger: {
        "id": "backlog.card-list.sprints-menu.menu-trigger",
        "defaultMessage": "{sprintName} actions"
    },
    editSprint: {
        "id": "backlog.card-list.sprints-menu.edit-sprint",
        "defaultMessage": "Edit sprint"
    },
    deleteSprint: {
        "id": "backlog.card-list.sprints-menu.delete-sprint",
        "defaultMessage": "Delete sprint"
    },
    moveSprintToTop: {
        "id": "backlog.card-list.sprints-menu.move-sprint-to-top",
        "defaultMessage": "Move sprint to top"
    },
    moveSprintUp: {
        "id": "backlog.card-list.sprints-menu.move-sprint-up",
        "defaultMessage": "Move sprint up"
    },
    moveSprintDown: {
        "id": "backlog.card-list.sprints-menu.move-sprint-down",
        "defaultMessage": "Move sprint down"
    },
    moveSprintToBottom: {
        "id": "backlog.card-list.sprints-menu.move-sprint-to-bottom",
        "defaultMessage": "Move sprint to bottom"
    },
    moreActionsTooltip: {
        "id": "backlog.card-list.sprints-menu.more-actions-tooltip",
        "defaultMessage": "More actions"
    }
});

});


parcelRegister("cOAVR", function(module, exports) {

$parcel$export(module.exports, "default", () => $742dbcf86a84a4d4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dXq4S = parcelRequire("dXq4S");

var $gV01p = parcelRequire("gV01p");

var $iKdRC = parcelRequire("iKdRC");


var $b0yad = parcelRequire("b0yad");

var $koeKL = parcelRequire("koeKL");

var $dCm1o = parcelRequire("dCm1o");

var $75InM = parcelRequire("75InM");

var $8hVbJ = parcelRequire("8hVbJ");

var $e978U = parcelRequire("e978U");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $elctU = parcelRequire("elctU");

var $3fVgL = parcelRequire("3fVgL");
const $742dbcf86a84a4d4$var$StartSprintButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ theme: theme, appearance: appearance, isDisabled: isDisabled, testId: testId, children: children, sprintId: sprintId, shouldShowManageSprintHelper: shouldShowManageSprintHelper = false }, ref)=>{
    const boardId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getRapidViewId));
    const hasActiveSprints = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getHasActiveSprints));
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const isCompanyManaged = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
    const onSave = ()=>{
        // Since the sprint modals don't go through redux we need to fire their invalidations manually
        (0, $b0yad.triggerResourceCacheInvalidation)((0, $8631d6ce464ccf2e$export$dedbdcc35e955187), 'START_SPRINT_MODAL_START');
        dispatch((0, $e978U.showSprintStartedFlagAction)());
    };
    const redirectTo = (0, $75InM.useBoardUrl)(hasActiveSprints ? [
        'sprintStarted=true',
        `sprints=${sprintId}`
    ] : [
        'sprintStarted=true'
    ]) || '';
    const [isModalVisible, setModalVisible] = (0, $5uXOq.useState)(false);
    const cloudId = (0, $koeKL.useCloudId)();
    const [queryReference, loadQuery, disposeQuery] = (0, $8Uumt.useQueryLoader)((0, $gV01p.default));
    const boardIdAri = (0, $dXq4S.createAri)({
        resourceOwner: 'jira-software',
        cloudId: cloudId,
        resourceType: 'board',
        resourceId: String(boardId)
    });
    const sprintIdAri = (0, $dXq4S.createAri)({
        resourceOwner: 'jira-software',
        cloudId: cloudId,
        resourceType: 'sprint',
        resourceId: String(sprintId)
    });
    const onClick = ()=>{
        (0, $8hVbJ.startSprintModalLoad).start();
        loadQuery({
            boardId: boardIdAri,
            sprintId: sprintIdAri,
            isCompanyManaged: isCompanyManaged
        }, {
            fetchPolicy: 'network-only'
        });
        setModalVisible(true);
    };
    const onClose = ()=>{
        setModalVisible(false);
        disposeQuery();
    };
    const onStartSprintSave = ()=>{
        onClose();
        onSave();
    };
    const onReady = ()=>{
        (0, $8hVbJ.startSprintModalLoad).stop({
            customData: {
                relay: true
            }
        });
    };
    const commonProps = {
        onClick: onClick,
        isDisabled: isDisabled,
        testId: testId,
        ref: ref
    };
    const buttonComponent = theme ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iKdRC.ModalTriggerButton), {
        ...commonProps,
        theme: theme,
        spacing: (0, $dCm1o.isVisualRefreshEnabled)() ? 'compact' : undefined
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iKdRC.ModalTriggerButton), {
        ...commonProps,
        appearance: (0, $dCm1o.isVisualRefreshEnabled)() ? undefined : appearance,
        spacing: (0, $dCm1o.isVisualRefreshEnabled)() ? 'compact' : undefined
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, shouldShowManageSprintHelper ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $elctU.DisabledButtonHelper), null, children) : buttonComponent, isModalVisible && queryReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3fVgL.default), {
        analyticsSource: "software-backlog",
        onClose: onClose,
        onSave: onStartSprintSave,
        queryReference: queryReference,
        onReady: onReady,
        sprintId: String(sprintIdAri),
        boardId: String(boardIdAri),
        redirectTo: redirectTo,
        showAlternateHeaderMessage: hasActiveSprints,
        isCompanyManaged: isCompanyManaged
    }) : null);
});
var $742dbcf86a84a4d4$export$2e2bcd8739ae039 = $742dbcf86a84a4d4$var$StartSprintButton;

});
parcelRegister("gV01p", function(module, exports) {

$parcel$export(module.exports, "default", () => $3adc083481f365d7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<911f4b54735595f4170fa024eaa12753>>
 * @relayHash 9203ca1c3f1dd776474f4a1b5b46683a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5a8f0bf7cefdeaf4f8d5660e4437c7f1202cb81fec69b986c0ee85314247d3d1
const $3adc083481f365d7$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "boardId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isCompanyManaged"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sprintId"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        }
    ], v4 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "sprintIds.0",
                    "variableName": "sprintId"
                }
            ],
            "kind": "ListValue",
            "name": "sprintIds"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "goal"
    }, v7 = {
        "kind": "ScalarField",
        "name": "defaultStartDate"
    }, v8 = {
        "kind": "ScalarField",
        "name": "defaultEndDate"
    }, v9 = {
        "kind": "ScalarField",
        "name": "numCompletedIssues"
    }, v10 = {
        "kind": "ScalarField",
        "name": "numOpenIssues"
    }, v11 = {
        "condition": "isCompanyManaged",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "unestimatedIssueKeys"
            },
            {
                "kind": "ScalarField",
                "name": "unestimatedIssueCount"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainJiraSoftwareStartSprintPrototypeQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v3 /*: any*/ ,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "SprintWithStatistics",
                                    "kind": "LinkedField",
                                    "name": "sprintWithStatistics",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v5 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.sprintWithStatistics.name"
                                        },
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "SoftwareSprintMetadata",
                                                "kind": "LinkedField",
                                                "name": "sprintMetadata",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v9 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.sprintWithStatistics.sprintMetadata.numCompletedIssues"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v10 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.sprintWithStatistics.sprintMetadata.numOpenIssues"
                                                    },
                                                    v11 /*: any*/ 
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.sprintWithStatistics.sprintMetadata"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "startSprintPeriod_softwareStartSprintModalRelay"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.sprintWithStatistics"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "boardScope"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainJiraSoftwareStartSprintPrototypeQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "SprintWithStatistics",
                            "kind": "LinkedField",
                            "name": "sprintWithStatistics",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                {
                                    "concreteType": "SoftwareSprintMetadata",
                                    "kind": "LinkedField",
                                    "name": "sprintMetadata",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ]
                                },
                                v12 /*: any*/ 
                            ]
                        },
                        v12 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "5a8f0bf7cefdeaf4f8d5660e4437c7f1202cb81fec69b986c0ee85314247d3d1",
            "metadata": {},
            "name": "mainJiraSoftwareStartSprintPrototypeQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3adc083481f365d7$var$node.hash = "ba728fa4d6b5709cfeaf75a3acfcb693";
var $3adc083481f365d7$export$2e2bcd8739ae039 = $3adc083481f365d7$var$node;

});

parcelRegister("75InM", function(module, exports) {

$parcel$export(module.exports, "useBoardUrl", () => $563c8ce62b3f2234$export$66c8e3658ad37452);

var $5uXOq = parcelRequire("5uXOq");

var $2YZCu = parcelRequire("2YZCu");

var $4DPZY = parcelRequire("4DPZY");

var $gSBIZ = parcelRequire("gSBIZ");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $1fyfD = parcelRequire("1fyfD");
const $563c8ce62b3f2234$export$66c8e3658ad37452 = (additionalParams = [])=>{
    const boardId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getRapidViewId));
    const isCMPBoard = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
    const isEmbedView = (0, $1fyfD.useIsEmbedView)();
    const [{ data: data, error: error }] = (0, $4DPZY.useContainerContext)();
    return (0, $5uXOq.useMemo)(()=>{
        if (!data || error) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData('useBoardUrl', 'Failed getting container context');
            return null;
        }
        const url = (0, $gSBIZ.isUserContext)(data) ? `/jira/people/${data.user.accountId}` : `/jira/software${isCMPBoard ? '/c' : ''}/projects/${data.project.key}`;
        const embed = isEmbedView ? '/embed' : '';
        return `${url}/boards/${boardId}${embed}${additionalParams.length ? `?${additionalParams.join('&')}` : ''}`;
    }, [
        additionalParams,
        boardId,
        data,
        error,
        isCMPBoard,
        isEmbedView
    ]);
};

});

parcelRegister("3fVgL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9a1d189d452ad5d$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $khnQM = parcelRequire("khnQM");

var $kxZPA = parcelRequire("kxZPA");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $a9a1d189d452ad5d$var$StartSprintModal = (0, $kxZPA.lazy)(()=>(parcelRequire("1uKXl")), {
    moduleId: "./src/packages/software/start-sprint-modal-relay/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a9a1d189d452ad5d$export$2e2bcd8739ae039 = ({ ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $khnQM.StartSprintModalBoundary), {
        packageName: (0, $a9c483c0d986286a$export$dfd208682d29484c)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a9a1d189d452ad5d$var$StartSprintModal, props));

});
parcelRegister("khnQM", function(module, exports) {

$parcel$export(module.exports, "StartSprintModalBoundary", () => $38c3d72c70c659fb$export$6cfe815c8e1cbd86);

var $5uXOq = parcelRequire("5uXOq");

var $gjEtj = parcelRequire("gjEtj");
const $38c3d72c70c659fb$export$6cfe815c8e1cbd86 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjEtj.ModalBoundary), {
        id: "start-sprint-modal",
        ...props
    }, children);

});

parcelRegister("1uKXl", function(module, exports) {

let $116d044c13d59d2d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $116d044c13d59d2d$var$load("932mM").then(()=>parcelRequire('lLDJx'));

});





parcelRegister("3pyss", function(module, exports) {

$parcel$export(module.exports, "default", () => $503e57299162bf07$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $5LWLA = parcelRequire("5LWLA");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $ibJfd = parcelRequire("ibJfd");

var $auOJt = parcelRequire("auOJt");

var $gBMim = parcelRequire("gBMim");
const $503e57299162bf07$var$GRABBER_SELECTOR = 'software-backlog-divider-grabber';
const $503e57299162bf07$var$GRABBER_LINE_SELECTOR = 'software-backlog-divider-grabber-line';
const $503e57299162bf07$var$DividerContents = /*#__PURE__*/ (0, $5uXOq.memo)(({ id: id })=>{
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($503e57299162bf07$var$GrabberContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($503e57299162bf07$var$GrabberLine, {
        "data-component-selector": $503e57299162bf07$var$GRABBER_LINE_SELECTOR
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($503e57299162bf07$var$Grabber, {
        "data-component-selector": $503e57299162bf07$var$GRABBER_SELECTOR
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        glyph: (0, $auOJt.GrabberIcon),
        size: "small",
        primaryColor: "var(--ds-icon-subtle, #626F86)",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($503e57299162bf07$var$GrabberContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($503e57299162bf07$var$GrabberLine, {
        "data-component-selector": $503e57299162bf07$var$GRABBER_LINE_SELECTOR
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ibJfd.DividerStatistics), {
        dividerCardListId: id
    })));
    const containerRef = (0, $5uXOq.useRef)(null);
    const { dragPreview: dragPreview } = (0, $gBMim.useDraggableDivider)({
        elementRef: containerRef,
        cardListId: id
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($503e57299162bf07$var$Container, {
        ref: containerRef,
        "data-testid": "software-backlog.card-list.divider.container",
        "aria-hidden": "true",
        visualRefresh: (0, $dCm1o.isVisualRefreshEnabled)(),
        minWidthStyle: (0, $4R6GH.fg)('sprint_footer_responsive_issue')
    }, content), dragPreview);
});
function $503e57299162bf07$export$2e2bcd8739ae039(props) {
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($503e57299162bf07$var$DividerContents, {
        id: props.id
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, content);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $503e57299162bf07$var$GrabberLine = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_v564m7ou _n7zludwz _1e0c116y _16jlkb7n _4t3iidpf _tzy4idpf",
            __cmplp.className
        ])
    });
});
const $503e57299162bf07$var$Grabber = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_v564m7ou _1e0c116y _4t3i7vkz _1bsb7vkz _tzy4txnc _80om776v",
            __cmplp.className
        ])
    });
});
const $503e57299162bf07$var$GrabberContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c116y _i0dlidpf _16jlkb7n _4cvr1h6o _bfhk18uv",
            __cmplp.className
        ])
    });
});
const $503e57299162bf07$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { visualRefresh: visualRefresh, minWidthStyle: minWidthStyle, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _4t3izwfg _1e0c1txw _2lx2vrvc _4cvr1h6o _1bah1h6o _otyrutpp _16jlkb7n _1ov1kb7n _1minkb7n _10n8kb7n _1us6kb7n",
            !__cmplp.visualRefresh && "_1yt4119w",
            __cmplp.minWidthStyle && "_1ul9nfvn",
            __cmplp.className
        ])
    });
});

});
parcelRegister("auOJt", function(module, exports) {

$parcel$export(module.exports, "GrabberIcon", () => $02ed4fa9ff6ac03a$export$1154891bc70a7bd);

var $5uXOq = parcelRequire("5uXOq");
const $02ed4fa9ff6ac03a$export$1154891bc70a7bd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "18px",
        height: "20px",
        viewBox: "0 0 18 20"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        transform: "translate(-3.000000, -2.000000)",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        transform: "translate(3.000000, 2.000000)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "0",
        y: "7",
        width: "18",
        height: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "0",
        y: "11",
        width: "18",
        height: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M5.29175912,15.2930586 C4.90274696,15.685137 4.90274696,16.3202641 5.29175912,16.7123425 L8.23085096,19.6779356 C8.44885778,19.8929786 8.73086659,20 9.00987531,20 C9.28888403,20 9.56589268,19.8929786 9.77889934,19.6779356 L12.7089909,16.7223445 C13.097003,16.3302661 13.097003,15.695139 12.7089909,15.3030606 C12.3199787,14.9109822 11.6909591,14.9109822 11.302947,15.3030606 L9.00487515,17.6205241 L6.69780306,15.2930586 C6.50379699,15.0980196 6.24878902,15 5.99478109,15 C5.73977312,15 5.48476515,15.0980196 5.29175912,15.2930586 Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M5.29175912,0.293058612 C4.90274696,0.685137027 4.90274696,1.32026405 5.29175912,1.71234247 L8.23085096,4.67793559 C8.44885778,4.8929786 8.73086659,5 9.00987531,5 C9.28888403,5 9.56589268,4.8929786 9.77889934,4.67793559 L12.7089909,1.72234447 C13.097003,1.33026605 13.097003,0.695139028 12.7089909,0.303060612 C12.3199787,-0.0890178036 11.6909591,-0.0890178036 11.302947,0.303060612 L9.00487515,2.6205241 L6.69780306,0.293058612 C6.50379699,0.0980196039 6.24878902,0 5.99478109,0 C5.73977312,0 5.48476515,0.0980196039 5.29175912,0.293058612 Z",
        transform: "translate(9.000000, 2.500000) rotate(180.000000) translate(-9.000000, -2.500000) "
    })))));

});

parcelRegister("gBMim", function(module, exports) {

$parcel$export(module.exports, "useDraggableDivider", () => $8769a50639b1284f$export$731cb43729e9cccd);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $5LWLA = parcelRequire("5LWLA");

var $7gWdR = parcelRequire("7gWdR");
parcelRequire("erBEN");
var $kpXwZ = parcelRequire("kpXwZ");

var $4R6GH = parcelRequire("4R6GH");

var $auOJt = parcelRequire("auOJt");

var $c1MAf = parcelRequire("c1MAf");

var $eMLHT = parcelRequire("eMLHT");
function $8769a50639b1284f$export$731cb43729e9cccd({ elementRef: elementRef, cardListId: cardListId }) {
    const [dragState, setDragState] = (0, $5uXOq.useState)({
        type: 'idle'
    });
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    (0, $5uXOq.useEffect)(()=>{
        if (!elementRef.current) return undefined;
        return (0, $7gWdR.draggable)({
            element: elementRef.current,
            getInitialData: ()=>({
                    type: 'DIVIDER',
                    cardListId: cardListId
                }),
            onDragStart: ()=>{
                if ((0, $4R6GH.fg)('relatively_position_cards_on_initial_load')) dispatch((0, $eMLHT.dragStart)());
            },
            onDrop: ()=>{
                if ((0, $4R6GH.fg)('relatively_position_cards_on_initial_load')) dispatch((0, $eMLHT.dragEnd)());
            },
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                (0, $kpXwZ.setCustomNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage,
                    render ({ container: container }) {
                        setDragState({
                            type: 'dragging',
                            container: container
                        });
                        return ()=>setDragState({
                                type: 'idle'
                            });
                    }
                });
            }
        });
    }, [
        cardListId,
        dispatch,
        elementRef
    ]);
    return {
        dragPreview: dragState.type === 'dragging' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
            glyph: (0, $auOJt.GrabberIcon),
            size: "small",
            primaryColor: "var(--ds-icon-subtle, #626F86)",
            label: ""
        }), dragState.container) : null
    };
}

});


parcelRegister("l4p68", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c4f4a1e05b25651$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iDGXn = parcelRequire("iDGXn");

var $2lpqS = parcelRequire("2lpqS");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $453ro = parcelRequire("453ro");
const $0c4f4a1e05b25651$var$FastVirtualListContainer = ({ isDropDisabled: isDropDisabled, cardListId: cardListId, emptyList: emptyList, renderCard: renderCard })=>{
    const cardIdWithAboveIccOpen = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCardIdWithAboveICCOpen));
    const getDefaultRowSize = (0, $c1MAf.useBacklogSelector)((0, $dGljH.makeGetDefaultRowSize));
    const showCompactMode = (0, $iDGXn.useShowCompactMode)();
    const defaultCardHeight = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.getDefaultCardHeight)(state)(showCompactMode));
    const isCmpBacklog = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
    const cardEntries = (0, $c1MAf.useBacklogSelector)((state)=>isCmpBacklog ? (0, $dGljH.makeOrderedVisibleCardEntries)(state)(cardListId) : (0, $dGljH.makeOrderedVisibleCardEntriesOld)(state)(cardListId));
    const cardIds = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.makeGetVisibleCardOrderFromCardEntries)(state)(cardListId));
    const visibleCardAmount = (0, $c1MAf.useBacklogSelector)((state)=>false ? (0, $dGljH.makeOrderVisibleCardIdsForCardListWithLimit)(state)(cardListId).length : (0, $dGljH.makeOrderedVisibleCardIdsForCardList)(state)(cardListId).length);
    const minimumOffset = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.makeGetFastVirtualListMinimumOffSetByCardListId)(state)(cardListId));
    const expandedCardGroups = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getExpandedCardGroups));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $453ro.FastVirtualList), {
        cardIdWithAboveIccOpen: cardIdWithAboveIccOpen,
        cardEntries: cardEntries,
        visibleCardAmount: visibleCardAmount,
        minimumOffset: minimumOffset,
        isDropDisabled: isDropDisabled,
        getDefaultRowSize: getDefaultRowSize,
        defaultCardHeight: defaultCardHeight,
        cardListId: cardListId,
        emptyList: emptyList,
        renderCard: renderCard,
        expandedCardGroups: expandedCardGroups,
        droppableType: (0, $2lpqS.CARD_LIST_DROPPABLE_TYPE),
        cardIds: cardIds
    });
};
var $0c4f4a1e05b25651$export$2e2bcd8739ae039 = $0c4f4a1e05b25651$var$FastVirtualListContainer;

});
parcelRegister("453ro", function(module, exports) {

$parcel$export(module.exports, "FastVirtualList", () => $88f5ea7ff0eb1668$export$32fc6f03ada9e09e);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $47bDC = parcelRequire("47bDC");

var $8Rkzz = parcelRequire("8Rkzz");

var $l1N8i = parcelRequire("l1N8i");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $gSExi = parcelRequire("gSExi");

var $4R6GH = parcelRequire("4R6GH");

var $687vG = parcelRequire("687vG");

var $guFRy = parcelRequire("guFRy");

var $iDGXn = parcelRequire("iDGXn");

var $jDrwg = parcelRequire("jDrwg");

var $9tZuw = parcelRequire("9tZuw");

var $f6RVN = parcelRequire("f6RVN");

var $ee1tL = parcelRequire("ee1tL");

var $c1MAf = parcelRequire("c1MAf");

var $lDDqj = parcelRequire("lDDqj");

var $b7YUC = parcelRequire("b7YUC");

var $aJ0IJ = parcelRequire("aJ0IJ");

var $2ixAa = parcelRequire("2ixAa");

var $g2Dfe = parcelRequire("g2Dfe");

var $fFUiJ = parcelRequire("fFUiJ");

var $i1hCy = parcelRequire("i1hCy");

var $2HNVA = parcelRequire("2HNVA");

var $hzZjw = parcelRequire("hzZjw");
const $88f5ea7ff0eb1668$var$RENDER_RICH_CARD_DELAY = 300;
const $88f5ea7ff0eb1668$export$32fc6f03ada9e09e = ({ cardEntries: cardEntries, renderCard: renderCard, cardIdWithAboveIccOpen: cardIdWithAboveIccOpen, getDefaultRowSize: getDefaultRowSize, defaultCardHeight: defaultCardHeight, cardListId: cardListId, visibleCardAmount: visibleCardAmount, emptyList: emptyList, minimumOffset: minimumOffset, expandedCardGroups: expandedCardGroups, cardIds: cardIds })=>{
    const { ref: listElRef, offsetTop: offsetTop } = (0, $687vG.useElementOffset)({
        initialOffset: minimumOffset
    });
    const cardHeightCache = (0, $g2Dfe.useCardHeightCache)();
    const isCompact = (0, $iDGXn.useShowCompactMode)();
    const shouldBeAbsolutePositioned = (0, $2HNVA.useShouldBeAbsolutePositioned)();
    let prefetchImages = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    if ((0, $4R6GH.fg)('backlog-prefetch-priority-image')) // eslint-disable-next-line react-hooks/rules-of-hooks
    prefetchImages = (0, $hzZjw.useImagePrefetch)();
    const cacheOptions = (0, $5uXOq.useMemo)(()=>({
            cache: cardHeightCache,
            getCacheKey: (index)=>{
                const issueEntry = cardEntries[index];
                if (!issueEntry) return 'none';
                 // If its just 1 extra, we know its the ICC
                if (index === cardEntries.length) return 'ICC';
                if ((0, $ee1tL.isCardEntryGroup)(issueEntry)) return (0, $ee1tL.getCardEntryGroupKey)(issueEntry, cardListId);
                return issueEntry.cardId;
            }
        }), [
        cardEntries,
        cardHeightCache,
        cardListId
    ]);
    const isCardListEmpty = cardEntries.length === 0 || visibleCardAmount === 0;
    (0, $fFUiJ.useEmptyCardListDropTarget)({
        elementRef: listElRef,
        isCardListEmpty: isCardListEmpty,
        cardListId: cardListId
    });
    const overscanHeight = (0, $i1hCy.useOverscanHeight)(cardListId, 400);
    const showCardExtraFieldsColumnBasedOnViewSettings = (0, $f6RVN.isViewSettingAsPanelExpEnabledWithNoExposure)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $iDGXn.useHasCardExtraFields)() : true;
    const { rows: rows, totalSize: totalSize, reinitialize: reinitialize, isScrolling: isScrolling, scrollTo: scrollTo } = (0, $guFRy.useVirtual)({
        rowCount: cardEntries.length,
        overscanHeight: overscanHeight,
        offsetTop: offsetTop,
        cacheOptions: cacheOptions,
        getDefaultRowSize: (index)=>{
            const cardEntry = cardEntries[index];
            const cardId = (0, $ee1tL.isCardEntryGroup)(cardEntry) ? cardEntry?.parentId : cardEntry?.cardId;
            let totalCardsInCardEntry = 1;
            if ((0, $ee1tL.isCardEntryGroup)(cardEntry)) {
                const isCardGroupExpanded = cardEntry.isAttachedToParent === true ? Boolean(expandedCardGroups[cardEntry.parentId]) : true;
                if (isCardGroupExpanded) totalCardsInCardEntry = cardEntry.cardIds.length;
            }
            const height = getDefaultRowSize({
                isInlineCardCreateOpen: cardId === cardIdWithAboveIccOpen,
                numberOfCardsInCardEntry: totalCardsInCardEntry,
                isCompact: isCompact,
                hideExtraFields: !showCardExtraFieldsColumnBasedOnViewSettings
            });
            return height;
        }
    });
    if ((0, $4R6GH.fg)('backlog-prefetch-priority-image')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>{
        const visibleCardIds = rows.filter((row)=>row.isVisible).flatMap((row)=>{
            const cardEntry = cardEntries[row.index];
            if (!cardEntry) return [];
            return (0, $ee1tL.isCardEntryGroup)(cardEntry) ? cardEntry.cardIds.map(String) : String(cardEntry.cardId);
        });
        prefetchImages(visibleCardIds);
    }, [
        cardEntries,
        rows,
        prefetchImages
    ]);
    (0, $2ixAa.useAutoScrollCard)(cardEntries, scrollTo);
    (0, $5uXOq.useEffect)(()=>{
        reinitialize(); // ? We need cardIds in here to make sure the card list is recalculated when things change
    // We need `isCompact` as part of dependencies to make sure the card list is recalculated when compact mode is toggled
    }, [
        cardIdWithAboveIccOpen,
        reinitialize,
        cardIds,
        isCompact,
        showCardExtraFieldsColumnBasedOnViewSettings
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $687vG.runRecalculateSubscribers)();
    }, [
        cardIds,
        isCompact
    ]);
    const isCardDragging = (0, $c1MAf.useBacklogSelector)((0, $lDDqj.isDragging));
    const setRichActiveCard = (0, $c1MAf.useBacklogActionCreator)((0, $9tZuw.setRichActiveCard));
    const [setRichActiveCardDebounced] = (0, $jDrwg.default)((cardID)=>{
        setRichActiveCard(cardID);
    }, $88f5ea7ff0eb1668$var$RENDER_RICH_CARD_DELAY);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: listElRef,
        "data-test-id": `software-backlog.card-list.id-${cardListId}`,
        "data-testid": `software-backlog.card-list.id-${cardListId}`
    }, isCardListEmpty ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($88f5ea7ff0eb1668$var$EmptyCardList // eslint-disable-next-line jira/integration/test-id-by-folder-structure
    , {
        "data-test-id": "software-backlog.card-list.empty-card-list",
        "data-testid": "software-backlog.card-list.fast-virtual-list.empty-card-list",
        isDragging: isCardDragging
    }, emptyList) : null, !isCardListEmpty && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($88f5ea7ff0eb1668$var$ListContainer, {
        hide: !isScrolling || isCardDragging,
        defaultCardHeight: defaultCardHeight,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'relative',
            height: totalSize
        }
    }, rows.map((row)=>{
        const cardEntry = cardEntries[row.index];
        const isGroup = (0, $ee1tL.isCardEntryGroup)(cardEntry);
        const cardId = isGroup ? (0, $ee1tL.getCardEntryGroupKey)(cardEntry, cardListId) : cardEntry?.cardId;
        if (cardId == null) return null;
        const rowStyles = shouldBeAbsolutePositioned || !(0, $4R6GH.fg)('relatively_position_cards_on_initial_load') ? {
            position: 'absolute',
            left: 0,
            top: row.top - offsetTop,
            width: '100%'
        } : undefined;
        return(// eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            key: cardId,
            style: rowStyles
        }, !(0, $4R6GH.fg)('jsw-backlog-fast-virtual-inline-card-render') && renderCard(cardEntry, row, isScrolling, shouldBeAbsolutePositioned), (0, $4R6GH.fg)('jsw-backlog-fast-virtual-inline-card-render') && (isGroup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aJ0IJ.CardGroup), {
            isScrolling: isScrolling,
            isVisible: row.isVisible,
            cardListId: cardListId,
            cardGroup: cardEntry,
            setRichActiveCard: setRichActiveCardDebounced,
            shouldBeAbsolutePositioned: shouldBeAbsolutePositioned
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b7YUC.default), {
            cardListId: cardListId,
            cardId: cardEntry.cardId,
            isVisible: row.isVisible,
            isScrolling: isScrolling,
            isAttachedToParent: false,
            setRichActiveCard: setRichActiveCardDebounced
        }))));
    })));
};
const $88f5ea7ff0eb1668$var$EmptyCardListWrapper = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "div",
        xcss: $88f5ea7ff0eb1668$var$emptyCardListWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xxsmall",
        as: "div"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($88f5ea7ff0eb1668$var$EmptyCardListExperiment, props)));
const $88f5ea7ff0eb1668$var$emptyCardListWrapperStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.0'
}); /**
     * This is a background for the lists, which is:
     *
     * * White
     * * Has stripes that look like the cards' borders
     *
     * This is to fool people looking at the list to think cards are rendered when
     * they're not. Since it's only using CSS it can always be displayed & should
     * be reasonably efficient.
     *
     * While dragging the background is disabled.
     */ 
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $88f5ea7ff0eb1668$var$ListContainerControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1566zr9-0"
})`${({ hide: hide, defaultCardHeight: defaultCardHeight })=>hide ? '' : `
    background-color: ${"var(--ds-surface-raised, #FFFFFF)"};
    background-image: repeating-linear-gradient(
        180deg,
        ${"var(--ds-background-neutral-hovered, #091E4224)"} 0px,
        ${"var(--ds-surface-raised, #FFFFFF)"} 1px,
        ${"var(--ds-surface-raised, #FFFFFF)"} ${defaultCardHeight - 1}px,
        ${"var(--ds-background-neutral-hovered, #091E4224)"} ${defaultCardHeight}px
    );
    box-shadow: inset 0 0 1px 1px ${"var(--ds-border, #091E4224)"};
    `}`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $88f5ea7ff0eb1668$var$ListContainerExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hide: hide, defaultCardHeight: defaultCardHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_xvr9bz": (0, $lD23V.default)("repeating-linear-gradient180deg, " + `${"var(--ds-background-neutral-hovered, #091E4224)"} 0px, ` + `${"var(--ds-surface-raised, #FFFFFF)"} 1px, ` + `${"var(--ds-surface-raised, #FFFFFF)"} ${__cmplp.defaultCardHeight - 1}px, ` + `${"var(--ds-background-neutral-hovered, #091E4224)"} ${__cmplp.defaultCardHeight}px )`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            !__cmplp.hide && "_bfhkhp5a _1itkxvio _16qs1mv9",
            __cmplp.className
        ])
    });
});
const $88f5ea7ff0eb1668$var$ListContainer = (0, $gSExi.styledComponentWithCondition)(()=>(0, $4R6GH.fg)('jsw_compiled_migration_tanuki'), $88f5ea7ff0eb1668$var$ListContainerExperiment, $88f5ea7ff0eb1668$var$ListContainerControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $88f5ea7ff0eb1668$var$EmptyCardListControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1566zr9-1"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        backgroundColor: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        props.isDragging ? "var(--ds-background-selected, #E9F2FF)" : undefined,
        border: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        props.isDragging ? `2px solid ${"var(--ds-border-selected, #0C66E4)"}` : `2px dashed ${"var(--ds-border, #091E4224)"}`,
        borderRadius: '3px',
        padding: "var(--ds-space-150, 12px)",
        textAlign: 'center'
    }), {
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: "var(--ds-text-subtlest, #626F86)",
    marginTop: "var(--ds-space-0, 0px)"
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $88f5ea7ff0eb1668$var$EmptyCardListExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDragging: isDragging, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _y3gn1h6o _k48pi7a9",
            __cmplp.isDragging && "_bfhkfg4m",
            __cmplp.isDragging ? "_19itneh2" : "_19it8zd5",
            __cmplp.className
        ])
    });
});
const $88f5ea7ff0eb1668$var$EmptyCardList = (0, $gSExi.styledComponentWithCondition)(()=>(0, $4R6GH.fg)('jsw_compiled_migration_tanuki'), $88f5ea7ff0eb1668$var$EmptyCardListWrapper, $88f5ea7ff0eb1668$var$EmptyCardListControl);

});
parcelRegister("2ixAa", function(module, exports) {

$parcel$export(module.exports, "useAutoScrollCard", () => $d34bdbd827f67a8e$export$b61f82894f7693a4);

var $5uXOq = parcelRequire("5uXOq");

var $ee1tL = parcelRequire("ee1tL");

var $9Z18E = parcelRequire("9Z18E");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");
const $d34bdbd827f67a8e$export$b61f82894f7693a4 = (cardEntries, scrollTo)=>{
    const autoScroll = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCardAutoScroll));
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    (0, $5uXOq.useEffect)(()=>{
        const autoScrollCardId = autoScroll?.cardId;
        if (!autoScrollCardId) return;
        // NOTE: Auto scrolling to a subtask may not work as expected
        const cardIndex = cardEntries.findIndex((issueEntry)=>(0, $ee1tL.isCardEntryGroup)(issueEntry) ? issueEntry.cardIds.includes(autoScrollCardId) : issueEntry.cardId === autoScrollCardId);
        if (cardIndex === -1) return;
        return scrollTo(cardIndex, {
            immediate: true,
            onComplete: ()=>dispatch((0, $9Z18E.cardAutoScroll)(null))
        });
    }, [
        autoScroll,
        cardEntries,
        dispatch,
        scrollTo
    ]);
};

});

parcelRegister("g2Dfe", function(module, exports) {

$parcel$export(module.exports, "useCardHeightCache", () => $8dc2b4d005c49b2a$export$bd41b84dc563782c);

var $5uXOq = parcelRequire("5uXOq");
const $8dc2b4d005c49b2a$var$CARD_HEIGHTS_CACHE = new Map();
const $8dc2b4d005c49b2a$export$bd41b84dc563782c = ()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $8dc2b4d005c49b2a$var$CARD_HEIGHTS_CACHE;
const $8dc2b4d005c49b2a$export$201114c49d4ccb5a = ()=>{
    (0, $5uXOq.useEffect)(()=>()=>{
            $8dc2b4d005c49b2a$var$CARD_HEIGHTS_CACHE.clear();
        }, []);
};

});

parcelRegister("fFUiJ", function(module, exports) {

$parcel$export(module.exports, "useEmptyCardListDropTarget", () => $fe901f06ece28d7a$export$d05d016cc6925d9c);

var $5uXOq = parcelRequire("5uXOq");

var $4hDdm = parcelRequire("4hDdm");

var $7gWdR = parcelRequire("7gWdR");

var $1fZVH = parcelRequire("1fZVH");

var $eMLHT = parcelRequire("eMLHT");

var $c1MAf = parcelRequire("c1MAf");

var $4VAKv = parcelRequire("4VAKv");

var $jyQw0 = parcelRequire("jyQw0");
function $fe901f06ece28d7a$export$d05d016cc6925d9c({ elementRef: elementRef, isCardListEmpty: isCardListEmpty, cardListId: cardListId }) {
    const autobatch = (0, $1fZVH.useAutobatch)();
    const simplyMoveCards = (0, $jyQw0.useSimplyMoveCards)();
    const isAnySelectedOrphanedSubtask = (0, $c1MAf.useBacklogSelector)((0, $4VAKv.makeIsAnySelectedOrphanedSubtasks));
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    (0, $5uXOq.useEffect)(()=>{
        if (!elementRef.current) return undefined;
        return (0, $4hDdm.combine)((0, $7gWdR.dropTargetForElements)({
            element: elementRef.current,
            // Only accept drop events on empty lists. This is because drop events will bubble from the cards
            // when the lists are non-empty. On that case, the card is itself handling move.
            canDrop: ()=>isCardListEmpty && !isAnySelectedOrphanedSubtask,
            onDrop: (args)=>{
                autobatch(()=>{
                    const sourceCardId = Number(args.source.data.cardId);
                    simplyMoveCards({
                        source: {
                            cardId: sourceCardId
                        },
                        location: {
                            type: 'list',
                            targetListId: cardListId
                        }
                    });
                    dispatch((0, $eMLHT.dragEnd)());
                });
            }
        }));
    }, [
        autobatch,
        cardListId,
        elementRef,
        isCardListEmpty,
        simplyMoveCards,
        isAnySelectedOrphanedSubtask,
        dispatch
    ]);
}

});

parcelRegister("i1hCy", function(module, exports) {

$parcel$export(module.exports, "useOverscanHeight", () => $1403dad59cb5804b$export$9af25d9f90686948);

var $5uXOq = parcelRequire("5uXOq");

var $9Ik53 = parcelRequire("9Ik53");

var $c1MAf = parcelRequire("c1MAf");

var $lDDqj = parcelRequire("lDDqj");
const $1403dad59cb5804b$export$9af25d9f90686948 = (cardListId, defaultOverscanHeight = 0)=>{
    const { scrollTop: scrollTop } = (0, $9Ik53.useScrollState)();
    const isDraggingSubtask = (0, $c1MAf.useBacklogSelector)((state)=>(0, $lDDqj.isDragging)(state) && (0, $lDDqj.getIsSubtaskDrag)(state));
    const isDraggingSourceCardlist = (0, $c1MAf.useBacklogSelector)((state)=>(0, $lDDqj.getSourceCardListId)(state) === cardListId);
    const scrollTopOnDragStart = (0, $5uXOq.useMemo)(()=>isDraggingSubtask && isDraggingSourceCardlist ? scrollTop : undefined, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        isDraggingSubtask,
        isDraggingSourceCardlist
    ]);
    return defaultOverscanHeight + (scrollTopOnDragStart !== undefined ? Math.abs(scrollTop - scrollTopOnDragStart) : 0);
};

});

parcelRegister("2HNVA", function(module, exports) {

$parcel$export(module.exports, "useShouldBeAbsolutePositioned", () => $3ca948deefce1407$export$e8b88e511e6d7e41);

var $5uXOq = parcelRequire("5uXOq");

var $9Ik53 = parcelRequire("9Ik53");

var $c1MAf = parcelRequire("c1MAf");

var $lDDqj = parcelRequire("lDDqj");
const $3ca948deefce1407$export$e8b88e511e6d7e41 = ()=>{
    const { scrollTop: scrollTop } = (0, $9Ik53.useScrollState)();
    const isDragging = (0, $c1MAf.useBacklogSelector)((0, $lDDqj.isDragging));
    const hasInteracted = (0, $5uXOq.useRef)(scrollTop > 0 || isDragging);
    if (hasInteracted.current) return true;
    if (scrollTop > 0 || isDragging) {
        hasInteracted.current = true;
        return true;
    }
    return false;
};

});

parcelRegister("hzZjw", function(module, exports) {

$parcel$export(module.exports, "useImagePrefetch", () => $1b0c1e4c0e1ca075$export$6abd25e9d02fd963);

var $5uXOq = parcelRequire("5uXOq");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");
const $1b0c1e4c0e1ca075$export$6abd25e9d02fd963 = ()=>{
    const cards = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCards));
    const shouldRenderPriorityColumn = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasPriority));
    const prefetchedCardIds = (0, $5uXOq.useRef)(new Set());
    const prefetchedImages = (0, $5uXOq.useRef)(new Set());
    const prefetchImage = (0, $5uXOq.useCallback)((src)=>{
        if (!prefetchedImages.current.has(src)) {
            prefetchedImages.current.add(src);
            new Image().src = src;
        }
    }, []);
    const prefetchPriorityImage = (0, $5uXOq.useCallback)((priority)=>{
        if (shouldRenderPriorityColumn && priority) prefetchImage(priority.iconUrl);
    }, [
        shouldRenderPriorityColumn,
        prefetchImage
    ]);
    const prefetchImages = (0, $5uXOq.useCallback)((cardIds)=>{
        const uniqueCards = cardIds.filter((cardId)=>!prefetchedCardIds.current.has(cardId));
        uniqueCards.forEach((cardId)=>{
            const card = cards[cardId];
            if (!card) return;
            prefetchPriorityImage(card.priority);
            prefetchedCardIds.current.add(cardId);
        });
    }, [
        cards,
        prefetchPriorityImage
    ]);
    return prefetchImages;
};

});



parcelRegister("9u5My", function(module, exports) {

$parcel$export(module.exports, "default", () => $5654b26c413cf285$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $6s1PB = parcelRequire("6s1PB");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $dYPRN = parcelRequire("dYPRN");

var $aGnjp = parcelRequire("aGnjp");

var $1dPBY = parcelRequire("1dPBY");
function $5654b26c413cf285$export$5bf2d993553f05ff() {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const sprintImage = (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dYPRN.default), {
        alt: "",
        height: 128,
        width: 128
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5654b26c413cf285$var$SprintPlanningImage, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5654b26c413cf285$var$FirstSprintPlanning, null, sprintImage, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5654b26c413cf285$var$SprintPlanningMessage, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5654b26c413cf285$var$SprintPlanningTitle, null, formatMessage((0, $1dPBY.default).emptyFirstSprintTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1dPBY.default).emptyFirstSprintDescriptionIssueTermRefresh : (0, $1dPBY.default).emptyFirstSprintDescription,
        values: {
            backlog: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, formatMessage((0, $1dPBY.default).backlog)),
            startSprint: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, formatMessage((0, $1dPBY.default).startSprint))
        }
    }))));
}
var $5654b26c413cf285$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
 = $5654b26c413cf285$export$5bf2d993553f05ff;
const $5654b26c413cf285$var$FirstSprintPlanning = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1e0c1txw _p12f1ogm _y3gn1e5h _4cvr1h6o _1bah1h6o _1tke1lit",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $5654b26c413cf285$var$SprintPlanningImage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_x441qc": (0, $lD23V.default)((0, (/*@__PURE__*/$parcel$interopDefault($aGnjp))), ")", "url(")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1qr7 _1bsb1qr7 _ouxl1ssb _1lrw1f51 _12vemgnk _1itk1ms4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $5654b26c413cf285$var$SprintPlanningMessage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _syaz1fxt _19bvpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5654b26c413cf285$var$SprintPlanningTitle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_k48p1pd9 _n3td1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dYPRN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d51f84832a14da57$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $45gKh = parcelRequire("45gKh");

var $hRtRe = parcelRequire("hRtRe");
const $d51f84832a14da57$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (0, (/*@__PURE__*/$parcel$interopDefault($hRtRe))),
    srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($45gKh)))
});
const $d51f84832a14da57$export$abdf1e325e38b834 = (0, (/*@__PURE__*/$parcel$interopDefault($hRtRe)));
const $d51f84832a14da57$export$87ec2877821a8f12 = (0, (/*@__PURE__*/$parcel$interopDefault($45gKh)));
var $d51f84832a14da57$export$2e2bcd8739ae039 = $d51f84832a14da57$var$Illustration;

});
parcelRegister("45gKh", function(module, exports) {
module.exports = new URL("design-darkmode.c5a2c049.svg", import.meta.url).toString();

});

parcelRegister("hRtRe", function(module, exports) {
module.exports = new URL("design.e096ff32.svg", import.meta.url).toString();

});


parcelRegister("aGnjp", function(module, exports) {
module.exports = new URL("sprint-planning.32ed1a38.svg", import.meta.url).toString();

});

parcelRegister("1dPBY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b78ea6a2945164e4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b78ea6a2945164e4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    emptyFirstSprintTitle: {
        "id": "backlog.card-list.first-sprint-blank-state.empty-first-sprint-title",
        "defaultMessage": "Plan your sprint"
    },
    emptyFirstSprintDescription: {
        "id": "backlog.card-list.first-sprint-blank-state.empty-first-sprint-description",
        "defaultMessage": "Drag issues from the {backlog} section, or create new issues, to plan the work for this sprint. Select {startSprint} when you're ready."
    },
    backlog: {
        "id": "backlog.card-list.first-sprint-blank-state.backlog",
        "defaultMessage": "Backlog"
    },
    startSprint: {
        "id": "backlog.card-list.first-sprint-blank-state.start-sprint",
        "defaultMessage": "Start sprint"
    },
    emptyFirstSprintDescriptionIssueTermRefresh: {
        "id": "backlog.card-list.first-sprint-blank-state.empty-first-sprint-description-issue-term-refresh",
        "defaultMessage": "Drag work items from the {backlog} section or create new ones to plan the work for this sprint. Select {startSprint} when you're ready."
    }
});

});


parcelRegister("ldRVl", function(module, exports) {

$parcel$export(module.exports, "LastResultMarker", () => $67b3a9dce0524621$export$cd661a12882ae547);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $9Ik53 = parcelRequire("9Ik53");

var $5tMAe = parcelRequire("5tMAe");

var $c1MAf = parcelRequire("c1MAf");

var $l9VFH = parcelRequire("l9VFH");
const $67b3a9dce0524621$export$cd661a12882ae547 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    // Only use scrollElement as it wont update as much
    const { scrollElement: scrollElement } = (0, $9Ik53.useScrollState)();
    const markerRef = (0, $5uXOq.useRef)(null);
    const [, actions] = (0, $5tMAe.useMoreResultsStore)();
    const filters = (0, $c1MAf.useBacklogSelector)((0, $l9VFH.getFilters));
    const filtersRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (!window.IntersectionObserver) return undefined;
        const observer = new IntersectionObserver((entries)=>{
            const [entry] = entries;
            const isLastResultBelowFold = !entry.isIntersecting && entry.boundingClientRect.top > (entry.rootBounds?.bottom ?? 0);
            const isFilterApplied = Object.keys(filters).length > 0;
            const isFilterChanged = filters !== filtersRef.current;
            if (isLastResultBelowFold && isFilterChanged && isFilterApplied) {
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'moreResultsButton shown');
                filtersRef.current = filters;
            }
            actions.setIsLastResultMarkerBelowFold(isLastResultBelowFold);
        }, {
            root: scrollElement,
            threshold: 0.5
        });
        const markerElement = markerRef.current;
        if (markerElement && markerRef.current) observer.observe(markerRef.current);
        return ()=>{
            if (markerElement) observer.unobserve(markerElement);
            actions.setIsLastResultMarkerBelowFold(false);
        };
    }, [
        scrollElement,
        actions,
        createAnalyticsEvent,
        filters
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($67b3a9dce0524621$var$Marker, {
        role: "presentation",
        ref: markerRef
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $67b3a9dce0524621$var$Marker = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "hr", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _19itglyw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("iiJr8", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5d3445017986ba9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $eMLHT = parcelRequire("eMLHT");

var $c1MAf = parcelRequire("c1MAf");
const $c5d3445017986ba9$var$TransitionZone = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isVisible: isVisible, isDragOver: isDragOver }, ref)=>{
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const onEnter = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $eMLHT.transitionZoneEnter)());
    }, [
        dispatch
    ]);
    const onLeave = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $eMLHT.transitionZoneLeave)());
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c5d3445017986ba9$var$TransitionZoneOuterContainer, {
        ref: ref,
        isVisible: isVisible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c5d3445017986ba9$var$TransitionZoneInnerContainer, {
        onMouseOver: onEnter,
        onMouseOut: onLeave,
        isDragOver: (0, $4R6GH.fg)('tnk-2613-hover-dropzones') ? isDragOver : undefined,
        "data-testid": "software-backlog.card-list.transition-zone.transition-zone-inner-container"
    }));
});
var $c5d3445017986ba9$export$2e2bcd8739ae039 = $c5d3445017986ba9$var$TransitionZone;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c5d3445017986ba9$var$TransitionZoneOuterContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisible: isVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1bsb1osq _4t3i1osq _1pbycs5v",
            __cmplp.isVisible ? "_3um0ewfl" : "_3um015vq",
            __cmplp.className
        ])
    });
});
const $c5d3445017986ba9$var$TransitionZoneInnerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDragOver: isDragOver, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoi2wt _189eyh40 _1dqonqa1 _1h6d1p6i _vchhusvi _1ul91osq _kqswh2mm _1tke1osq _lcxv4shg _irr3i1yw",
            !__cmplp.isDragOver ? "_bfhkfg4m" : "_bfhki1yw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("gcvrq", function(module, exports) {

$parcel$export(module.exports, "useCardListDropTarget", () => $31ed95224b1ed24b$export$4c4dc2d355187470);

var $5uXOq = parcelRequire("5uXOq");

var $7gWdR = parcelRequire("7gWdR");

var $co1wz = parcelRequire("co1wz");

var $1fZVH = parcelRequire("1fZVH");

var $4R6GH = parcelRequire("4R6GH");

var $2lpqS = parcelRequire("2lpqS");


var $eMLHT = parcelRequire("eMLHT");

var $c1MAf = parcelRequire("c1MAf");

var $fSgHa = parcelRequire("fSgHa");

var $jyQw0 = parcelRequire("jyQw0");
function $31ed95224b1ed24b$var$useCardListHeaderDropTarget({ headerElementRef: headerElementRef, cardListId: cardListId, isHeaderDropDisabled: isHeaderDropDisabled }) {
    const autobatch = (0, $1fZVH.useAutobatch)();
    const moveCards = (0, $jyQw0.useSimplyMoveCards)();
    const [isDragOver, setIsDragOver] = (0, $5uXOq.useState)(false);
    const isCompanyManagedKanban = (0, $fSgHa.useIsCMPKanbanBacklog)();
    (0, $5uXOq.useEffect)(()=>{
        if (!headerElementRef.current) return undefined;
        return (0, $7gWdR.dropTargetForElements)({
            element: headerElementRef.current,
            getData: ()=>({
                    type: (0, $2lpqS.CARD_LIST_DROPPABLE_TYPE)
                }),
            canDrop: (args)=>!isHeaderDropDisabled && args.source.data.type === (0, $b6a5a61e3f2f3f09$export$4d4e6ab48cd5be5b) && (!args.source.data.cardIsSubtask || !!isCompanyManagedKanban),
            onDrop: (args)=>{
                autobatch(()=>{
                    setIsDragOver(false);
                    if (args.source.data.type === (0, $b6a5a61e3f2f3f09$export$4d4e6ab48cd5be5b)) moveCards({
                        source: {
                            cardId: Number(args.source.data.cardId)
                        },
                        location: {
                            type: 'list',
                            targetListId: cardListId
                        }
                    });
                });
            },
            onDragEnter: ()=>setIsDragOver(true),
            onDragLeave: ()=>setIsDragOver(false)
        });
    }, [
        autobatch,
        cardListId,
        headerElementRef,
        isHeaderDropDisabled,
        moveCards,
        isCompanyManagedKanban
    ]);
    return {
        isDragOver: isDragOver
    };
}
function $31ed95224b1ed24b$var$useTransitionZoneDropTarget({ cardListId: cardListId, transitionZoneElementRef: transitionZoneElementRef }) {
    const autobatch = (0, $1fZVH.useAutobatch)();
    const moveCards = (0, $jyQw0.useSimplyMoveCards)();
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const [isDragOver, setIsDragOver] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (!transitionZoneElementRef.current) return undefined;
        return (0, $7gWdR.dropTargetForElements)({
            element: transitionZoneElementRef.current,
            onDragEnter: (0, $4R6GH.fg)('tnk-2613-hover-dropzones') ? ()=>setIsDragOver(true) : undefined,
            onDragLeave: (0, $4R6GH.fg)('tnk-2613-hover-dropzones') ? ()=>setIsDragOver(false) : undefined,
            canDrop: (args)=>args.source.data.type === (0, $b6a5a61e3f2f3f09$export$4d4e6ab48cd5be5b),
            onDrop: (args)=>{
                autobatch(()=>{
                    if ((0, $4R6GH.fg)('tnk-2613-hover-dropzones')) setIsDragOver(false);
                    if (args.source.data.type === (0, $b6a5a61e3f2f3f09$export$4d4e6ab48cd5be5b)) moveCards({
                        source: {
                            cardId: Number(args.source.data.cardId)
                        },
                        location: {
                            type: 'list',
                            targetListId: cardListId
                        }
                    });
                    if ((0, $co1wz.ff)('fix-hanging-low-opacity-after-backlog-card-drag-and-drop_0roex')) dispatch((0, $eMLHT.dragEnd)());
                });
            }
        });
    }, [
        transitionZoneElementRef,
        moveCards,
        cardListId,
        autobatch,
        dispatch
    ]);
    return {
        isDragOver: isDragOver
    };
}
function $31ed95224b1ed24b$export$4c4dc2d355187470({ headerElementRef: headerElementRef, transitionZoneElementRef: transitionZoneElementRef, cardListId: cardListId, isHeaderDropDisabled: isHeaderDropDisabled }) {
    const { isDragOver: isDragOver } = $31ed95224b1ed24b$var$useCardListHeaderDropTarget({
        headerElementRef: headerElementRef,
        cardListId: cardListId,
        isHeaderDropDisabled: isHeaderDropDisabled
    });
    const { isDragOver: isDragOverTransitionZone } = $31ed95224b1ed24b$var$useTransitionZoneDropTarget({
        cardListId: cardListId,
        transitionZoneElementRef: transitionZoneElementRef
    });
    return {
        isDragOver: isDragOver,
        isDragOverTransitionZone: isDragOverTransitionZone
    };
}

});

parcelRegister("c4Chf", function(module, exports) {

$parcel$export(module.exports, "default", () => $95b2bec0c05c9822$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");

var $lHBhO = parcelRequire("lHBhO");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $45Qwd = parcelRequire("45Qwd");

var $62nZT = parcelRequire("62nZT");

var $iKURq = parcelRequire("iKURq");
const $95b2bec0c05c9822$var$WorkLoadByAssigneeContainer = ({ cardListId: cardListId, sprintName: sprintName })=>{
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const assignees = (0, $c1MAf.useBacklogSelector)((0, $62nZT.makeWorkLoadByAssignee))(cardListId);
    const estimationType = (0, $c1MAf.useBacklogSelector)((0, $45Qwd.getEstimationType));
    const estimationFieldName = (0, $c1MAf.useBacklogSelector)((0, $45Qwd.getEstimationName));
    const isRemainingTimeTrackingEnabled = (0, $c1MAf.useBacklogSelector)((0, $45Qwd.getIsRemainingTimeTrackingEnabled));
    const isEstimationEnabled = !!estimationType && estimationType !== 'ISSUE_COUNT';
    const timeTrackingOptions = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getTimeTrackingOptions));
    const includeSubtasks = (0, $c1MAf.useBacklogSelector)((0, $62nZT.getIncludeSubtasks));
    const toggleIncludeSubtasks = (event, analyticsEvent)=>{
        dispatch((0, $lHBhO.toggleIncludeSubtasks)());
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'includeSubtasks', {
            includeSubtasks: !includeSubtasks
        });
    };
    const filterUnassignedAssignees = assignees.filter((assignee)=>assignee.name !== undefined);
    const unassigned = (0, $5uXOq.useMemo)(()=>assignees.find((assignee)=>assignee.name === undefined), [
        assignees
    ]);
    return filterUnassignedAssignees.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iKURq.default), {
        assignees: filterUnassignedAssignees,
        estimationType: estimationType,
        isEstimationEnabled: isEstimationEnabled,
        isRemainingTimeTrackingEnabled: isRemainingTimeTrackingEnabled,
        unassigned: unassigned,
        sprintName: sprintName,
        timeTrackingOptions: timeTrackingOptions,
        estimationFieldName: estimationFieldName,
        includeSubtasks: includeSubtasks,
        onToggleIncludeSubtasks: toggleIncludeSubtasks
    }) : null;
};
var $95b2bec0c05c9822$export$2e2bcd8739ae039 = $95b2bec0c05c9822$var$WorkLoadByAssigneeContainer;

});
parcelRegister("iKURq", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cffc08c0c6f576c$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $ujWmd = parcelRequire("ujWmd");

var $8U6zd = parcelRequire("8U6zd");

var $3oUqw = parcelRequire("3oUqw");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $iXc3K = parcelRequire("iXc3K");

var $8zOmE = parcelRequire("8zOmE");

var $dCm1o = parcelRequire("dCm1o");

var $2zsgE = parcelRequire("2zsgE");

var $bNQzi = parcelRequire("bNQzi");

var $fp05h = parcelRequire("fp05h");

var $iDrrO = parcelRequire("iDrrO");
const $5cffc08c0c6f576c$var$wrapperStyles = null;
const $5cffc08c0c6f576c$var$styles = {
    wrapperStyles: "_1reo1wug _18m91wug _1e0c1txw _4cvr1h6o _1bahv2br _16jlkb7n _19pk1b66 _2hwxu2gc _19bvdlk8 _ca0q1b66 _n3td1b66"
};
const $5cffc08c0c6f576c$var$containerStyles = null;
const $5cffc08c0c6f576c$var$IconComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8U6zd))), {
        label: "More actions",
        color: "var(--ds-icon, #44546F)",
        spacing: "spacious",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($3oUqw))),
        LEGACY_primaryColor: "var(--ds-icon, #44546F)"
    });
const $5cffc08c0c6f576c$var$WorkloadByAssigneeWrapper = ({ isVisuallyRefreshed: isVisuallyRefreshed, children: children })=>{
    if (isVisuallyRefreshed) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $5cffc08c0c6f576c$var$styles.wrapperStyles
        ])
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1reo1wug _18m91wug _1e0c1txw _4cvr1h6o _1bahv2br _16jlkb7n _19pk1b66 _2hwxu2gc _19bvdlk8"
        ])
    }, children);
};
const $5cffc08c0c6f576c$var$WorkLoadByAssigneeView = ({ assignees: assignees, estimationType: estimationType, isEstimationEnabled: isEstimationEnabled, isRemainingTimeTrackingEnabled: isRemainingTimeTrackingEnabled, sprintName: sprintName, unassigned: unassigned, timeTrackingOptions: timeTrackingOptions, estimationFieldName: estimationFieldName, includeSubtasks: includeSubtasks, onToggleIncludeSubtasks: onToggleIncludeSubtasks })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onOpenModal = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        analyticsEvent && (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'openWorkloadModal');
    }, []);
    const firstTenAssignees = (0, $5uXOq.useMemo)(()=>assignees.slice(0, 10), [
        assignees
    ]);
    const assigneeCount = assignees.length;
    const unshownCount = assigneeCount > 10 ? assigneeCount - 10 : undefined;
    const onShowTooltip = (analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'workloadTooltipViewed');
    };
    const summaryModalProps = {
        sprintName: sprintName,
        assignees: assignees,
        unassigned: unassigned,
        isEstimationEnabled: isEstimationEnabled,
        isRemainingTimeTrackingEnabled: isRemainingTimeTrackingEnabled,
        estimationType: estimationType,
        timeTrackingOptions: timeTrackingOptions,
        estimationFieldName: estimationFieldName,
        includeSubtasks: includeSubtasks,
        onToggleIncludeSubtasks: onToggleIncludeSubtasks
    };
    const modalProps = (0, $5uXOq.useMemo)(()=>({
            width: 'medium'
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5cffc08c0c6f576c$var$WorkloadByAssigneeWrapper, {
        isVisuallyRefreshed: (0, $dCm1o.isVisualRefreshEnabled)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_zulp1b66 _1e0c1txw _4cvr1h6o _15zoidpf _g8ht1l7b _tp1zidpf _1olh1l7b _yp0n1h6o _1jot1txw _tkqh1txw _dvzt1h6o _1chiglyw"
        ])
    }, firstTenAssignees.map((assignee, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            onShow: onShowTooltip,
            key: `assignee-tool-tip-${index}`,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fp05h.default), {
                username: assignee.name ?? '',
                storyPoints: assignee.storyPoints,
                remainingTimeEstimateInSeconds: assignee.remainingTimeEstimateInSeconds,
                issueCount: assignee.issueCount,
                estimationType: estimationType,
                isEstimationEnabled: isEstimationEnabled,
                isRemainingTimeTrackingEnabled: isRemainingTimeTrackingEnabled,
                originalTimeEstimateInSeconds: assignee.originalTimeEstimateInSeconds,
                timeTrackingOptions: timeTrackingOptions,
                estimationFieldName: estimationFieldName
            }),
            position: "bottom-start"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
            src: assignee.profilePicture,
            appearance: "circle",
            name: assignee.name,
            size: "small",
            borderColor: "transparent"
        }))), unshownCount && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iDrrO.default), {
        count: unshownCount,
        onClick: onOpenModal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXc3K.ModalEntryPointIconButtonTrigger), {
        appearance: "subtle",
        entryPoint: (0, $bNQzi.workloadByAssigneeEntryPoint),
        entryPointProps: summaryModalProps,
        interactionName: "open-work-load-by-assignee-modal",
        id: "entryPointButtonTrigger",
        testId: "software-backlog.card-list.work-load-by-assignee.entry-point-button-trigger",
        icon: $5cffc08c0c6f576c$var$IconComponent,
        label: formatMessage((0, $2zsgE.default).openModalButtonAriaLabel),
        onClick: onOpenModal,
        modalProps: modalProps,
        useInternalModal: true
    })));
};
var $5cffc08c0c6f576c$export$2e2bcd8739ae039 = $5cffc08c0c6f576c$var$WorkLoadByAssigneeView;

});
parcelRegister("iXc3K", function(module, exports) {

$parcel$export(module.exports, "ModalEntryPointIconButtonTrigger", () => $b0e020063eb1351b$export$7d379857be6c65e7);

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $2KAtx = parcelRequire("2KAtx");
function $b0e020063eb1351b$export$7d379857be6c65e7({ entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, errorAttributes: errorAttributes, Fallback: Fallback, modalTitle: modalTitle, modalProps: modalProps, useInternalModal: useInternalModal, ...buttonProps }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
        entryPoint: entryPoint,
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        errorAttributes: errorAttributes,
        Fallback: Fallback,
        modalTitle: modalTitle,
        modalProps: modalProps,
        useInternalModal: useInternalModal
    }, ({ ref: ref })=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            ref: ref,
            ...buttonProps
        }));
}

});

parcelRegister("2zsgE", function(module, exports) {

$parcel$export(module.exports, "default", () => $96b204b315dd900d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $96b204b315dd900d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    openModalButtonAriaLabel: {
        "id": "backlog.card-list.work-load-by-assignee.open-modal-button-aria-label",
        "defaultMessage": "Open workload by assignee summary modal"
    },
    moreButtonIconLabel: {
        "id": "backlog.card-list.work-load-by-assignee.more-button-icon-label",
        "defaultMessage": "More actions"
    }
});

});

parcelRegister("bNQzi", function(module, exports) {

$parcel$export(module.exports, "workloadByAssigneeEntryPoint", () => $4797267b97a62cea$export$40038863d8211697);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $4797267b97a62cea$export$40038863d8211697 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("lzAht")), {
        moduleId: "70c648cc"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("lzAht", function(module, exports) {

let $fb49027d2c9efb9f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fb49027d2c9efb9f$var$load("7prrX").then(()=>parcelRequire('a5k5R'));

});


parcelRegister("fp05h", function(module, exports) {

$parcel$export(module.exports, "default", () => $9663c285b7dbeb29$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $etKNj = parcelRequire("etKNj");

var $guzeq = parcelRequire("guzeq");

var $3jxXQ = parcelRequire("3jxXQ");
const $9663c285b7dbeb29$var$containerStyles = null;
const $9663c285b7dbeb29$var$containerP = null;
const $9663c285b7dbeb29$var$TooltipContent = ({ username: username, storyPoints: storyPoints, remainingTimeEstimateInSeconds: remainingTimeEstimateInSeconds, originalTimeEstimateInSeconds: originalTimeEstimateInSeconds, issueCount: issueCount, estimationType: estimationType, isEstimationEnabled: isEstimationEnabled, isRemainingTimeTrackingEnabled: isRemainingTimeTrackingEnabled, timeTrackingOptions: timeTrackingOptions, estimationFieldName: estimationFieldName })=>{
    const intl = (0, $koVbs.default)();
    const { formatMessage: formatMessage } = intl;
    const isShowTimeEstimateVisible = isEstimationEnabled && estimationType === (0, $guzeq.ORIGINAL_ESTIMATE);
    const isStoryPointsVisible = isEstimationEnabled && estimationType === (0, $guzeq.STORY_POINTS);
    const remainingTimeEstimate = (0, $5uXOq.useMemo)(()=>(0, $etKNj.timeTrackingFormatter)(remainingTimeEstimateInSeconds, timeTrackingOptions, intl), [
        remainingTimeEstimateInSeconds,
        timeTrackingOptions,
        intl
    ]);
    const originalTimeEstimate = (0, $5uXOq.useMemo)(()=>(0, $etKNj.timeTrackingFormatter)(originalTimeEstimateInSeconds, timeTrackingOptions, intl), [
        originalTimeEstimateInSeconds,
        timeTrackingOptions,
        intl
    ]);
    const originalTimeEstimateField = (0, $5uXOq.useMemo)(()=>`${originalTimeEstimate} ${estimationFieldName.toLowerCase()}`, [
        originalTimeEstimate,
        estimationFieldName
    ]);
    const numericEstimateField = (0, $5uXOq.useMemo)(()=>`${storyPoints} ${estimationFieldName.toLowerCase()}`, [
        storyPoints,
        estimationFieldName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, username), isStoryPointsVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", {
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
        ])
    }, numericEstimateField), isShowTimeEstimateVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", {
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
        ])
    }, originalTimeEstimateField), isRemainingTimeTrackingEnabled && isEstimationEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", {
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
        ])
    }, formatMessage((0, $3jxXQ.default).remainingTimeEstimate, {
        remainingTimeEstimate: remainingTimeEstimate
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", {
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
        ])
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $3jxXQ.default).issueCountIssueTermRefresh : (0, $3jxXQ.default).issueCount, {
        issueCount: issueCount
    })));
};
var $9663c285b7dbeb29$export$2e2bcd8739ae039 = $9663c285b7dbeb29$var$TooltipContent;

});
parcelRegister("3jxXQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7cad33223b72712$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f7cad33223b72712$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    remainingTimeEstimate: {
        "id": "backlog.card-list.work-load-by-assignee.tooltip-content.remaining-time-estimate",
        "defaultMessage": "{remainingTimeEstimate} remaining time estimate"
    },
    issueCount: {
        "id": "backlog.card-list.work-load-by-assignee.tooltip-content.issue-count",
        "defaultMessage": "{issueCount} {issueCount, plural, one {issue} other {issues}}"
    },
    issueCountIssueTermRefresh: {
        "id": "backlog.card-list.work-load-by-assignee.tooltip-content.issue-count-issue-term-refresh",
        "defaultMessage": "{issueCount} {issueCount, plural, one {work item} other {work items}}"
    }
});

});


parcelRegister("iDrrO", function(module, exports) {

$parcel$export(module.exports, "default", () => $96a9b51e293d32e2$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $3Lty3 = parcelRequire("3Lty3");

var $koVbs = parcelRequire("koVbs");

var $iNmtw = parcelRequire("iNmtw");
const $96a9b51e293d32e2$var$styles = {
    button: "_1reo15vq _18m915vq _11c81o8v _2rko14q2 _1bsb1tcg _4t3i1tcg _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _syaz1gjq _bfhkm7j4 _y3gn1h6o _irr315ej"
};
const $96a9b51e293d32e2$var$UnshownCount = ({ count: count, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Lty3.default), {
        onClick: onClick,
        xcss: $96a9b51e293d32e2$var$styles.button,
        "aria-label": formatMessage((0, $iNmtw.default).openModalButtonAriaLabel)
    }, `+${count}`);
};
var $96a9b51e293d32e2$export$2e2bcd8739ae039 = $96a9b51e293d32e2$var$UnshownCount;

});
parcelRegister("iNmtw", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0677d583243d182$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b0677d583243d182$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    openModalButtonAriaLabel: {
        "id": "backlog.card-list.work-load-by-assignee.unshown-count.open-modal-button-aria-label",
        "defaultMessage": "Open workload by assignee summary modal"
    }
});

});




parcelRegister("fiE4O", function(module, exports) {

$parcel$export(module.exports, "AiWorkCreatePanel", () => $0a6582bde541b1fd$export$8f37551e38f16e89);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $5eGnF = parcelRequire("5eGnF");

var $9svjh = parcelRequire("9svjh");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4R6GH = parcelRequire("4R6GH");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $5Eoed = parcelRequire("5Eoed");


var $l9VFH = parcelRequire("l9VFH");

var $hf5c2 = parcelRequire("hf5c2");

var $3QmBe = parcelRequire("3QmBe");

var $10Ngv = parcelRequire("10Ngv");

var $fmuR9 = parcelRequire("fmuR9");

var $aU3CO = parcelRequire("aU3CO");

var $74oBv = parcelRequire("74oBv");

var $f01qr = parcelRequire("f01qr");
// **Following is copied from view/card-list/inline-card-create/index.tsx**
// Hacky way to generate optimistic issue id.
// Not ideal, but have to do it for now to react backwards compatibility with current ICC.
let $0a6582bde541b1fd$var$lastCardId = 0;
const $0a6582bde541b1fd$var$generateId = ()=>{
    $0a6582bde541b1fd$var$lastCardId -= 1;
    return $0a6582bde541b1fd$var$lastCardId;
};
const $0a6582bde541b1fd$export$8f37551e38f16e89 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ subject: subject, listId: listId = 'BACKLOG' }, ref)=>{
    const projectKey = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getProjectKey));
    const projectId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.projectIdSelector));
    const effectiveListId = (0, $4R6GH.fg)('ai_powered_backlog_inline_create-create_in_sprint') ? listId : 'BACKLOG';
    const baseLevelCardTypes = (0, $c1MAf.useBacklogSelector)((0, $74oBv.getBaseLevelCardTypes)).map(({ id: id, hasRequiredFields: hasRequiredFields, ...rest })=>({
            ...rest,
            id: String(id),
            hasRequiredField: Boolean(hasRequiredFields)
        }));
    const parentId = (0, $c1MAf.useBacklogSelector)((0, $3QmBe.getLastAppliedParentFilters));
    const enabledFilters = (0, $c1MAf.useBacklogSelector)((0, $l9VFH.getFilters));
    const issueParents = (0, $c1MAf.useBacklogSelector)((state)=>(0, $fmuR9.issueParentsSelector)(state));
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const onAcceptGic = (0, $5uXOq.useRef)();
    const { subscribe: subscribe } = (0, $9svjh.useGICLifeCycleEvents)();
    const { storeFieldsFromCardCreateData: storeFieldsFromCardCreateData, storeFieldsFromFetchIssuesData: storeFieldsFromFetchIssuesData } = (0, $10Ngv.useStoreFields)({
        issueParents: issueParents
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const inlineCreateSessionId = (0, $c1MAf.useBacklogSelector)((0, $aU3CO.getInlineCreateSessionId));
    const onAccept = (0, $5uXOq.useCallback)((issues)=>{
        const { issueTypeId: issueTypeId } = issues[0];
        const cardTypeEntity = baseLevelCardTypes.find((ct)=>ct.id === issueTypeId);
        const fixVersions = enabledFilters.VERSION || [];
        const tempIds = issues.map(()=>$0a6582bde541b1fd$var$generateId());
        /** Analytics: We indicate to the analytics for issue creation that the inline creation ended up finishing inline creation (With session ID) */ const analyticsEvent = createAnalyticsEvent({
            action: 'created',
            actionSubject: 'issue',
            sessionId: inlineCreateSessionId,
            aiFeatureUsed: 'ai-work-creation-from-link'
        });
        dispatch((0, $hf5c2.cardCreateMultipleRequest)({
            tempIds: tempIds,
            summaries: issues.map((inlineCard)=>inlineCard.summary),
            descriptions: issues.map((inlineCard)=>inlineCard.description),
            typeId: Number(issueTypeId),
            typeIcon: cardTypeEntity ? cardTypeEntity.iconUrl : '',
            parentId: parentId,
            fixVersions: fixVersions,
            insertBefore: null,
            listId: effectiveListId,
            storeFieldsFromCardCreateData: storeFieldsFromCardCreateData,
            storeFieldsFromFetchIssuesData: storeFieldsFromFetchIssuesData,
            analyticsEvent: analyticsEvent
        }));
    }, [
        dispatch,
        baseLevelCardTypes,
        enabledFilters,
        parentId,
        storeFieldsFromCardCreateData,
        storeFieldsFromFetchIssuesData,
        createAnalyticsEvent,
        inlineCreateSessionId,
        effectiveListId
    ]);
    const onEdit = (0, $5uXOq.useCallback)(({ summary: summary, description: description, issueTypeId: issueTypeId }, { onComplete: onComplete })=>{
        const fixVersions = enabledFilters.VERSION || [];
        // should never be a string, off chance that it might be we transform it
        const cardDescription = (0, $f01qr.getCardDescriptionAsADF)(description);
        dispatch((0, $5Eoed.openModal)({
            type: (0, $b107c54ec82f76f2$export$55cae6fd3c958bc5),
            payload: {
                cardListId: effectiveListId,
                cardParentId: parentId,
                cardSummary: summary,
                cardTypeId: parseInt(issueTypeId, 10),
                cardDescription: cardDescription,
                rankBeforeCardId: null,
                fixVersions: fixVersions
            }
        }));
        onAcceptGic.current = onComplete;
    }, [
        dispatch,
        enabledFilters.VERSION,
        effectiveListId,
        parentId
    ]);
    (0, $5uXOq.useEffect)(()=>subscribe?.((0, $5eGnF.GIC_LIFECYCLE_EVENTS).MODAL_CLOSED, async ({ createdIssues: createdIssues })=>{
            // prevent this from being called if GIC is opened elsewhere (e.g. create button next to nav bar)
            if (onAcceptGic.current && createdIssues.length) {
                const analyticsEvent = createAnalyticsEvent({});
                (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'aiResult actioned', 'suggestedWorkItemGicCreated', {
                    aiResultAction: 'recommendationAccepted',
                    acceptedNumber: 1,
                    aiFeatureName: 'backlog-ai-work-creation',
                    isAIFeature: 1,
                    proactiveAIGenerated: 0,
                    userGeneratedAI: 1,
                    userLocation: 'backlog',
                    createdIssueId: createdIssues[0]?.issueId
                });
                onAcceptGic.current?.();
            }
            onAcceptGic.current = null;
        }), [
        createAnalyticsEvent,
        subscribe
    ]);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            onAccept: onAccept,
            onEdit: onEdit,
            projectKey: projectKey,
            projectId: projectId
        }), [
        projectKey,
        onEdit,
        onAccept,
        projectId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: subject,
        id: "aiWorkCreatePanel",
        packageName: "backlog",
        errorFallback: "unmount",
        teamName: "Crocs",
        runtimeProps: runtimeProps
    }));
});

});
parcelRegister("5eGnF", function(module, exports) {

$parcel$export(module.exports, "GIC_LIFECYCLE_EVENTS", () => $700db8c378cd19d9$export$876003a5b887f37e);
const $700db8c378cd19d9$export$876003a5b887f37e = {
    MODAL_OPENED: 'MODAL_OPENED',
    MODAL_CLOSED: 'MODAL_CLOSED',
    MODAL_KEEP_EDITING_EXISTING_ISSUE: 'MODAL_KEEP_EDITING',
    MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE: 'MODAL_DISCARD',
    MODAL_DISCARD_SUGGESTED_ISSUE: 'MODAL_DISCARD_SUGGESTED_ISSUE',
    MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES: 'MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES',
    MODAL_DISCARD_ALL_SUGGESTED_ISSUES: 'MODAL_DISCARD_ALL_SUGGESTED_ISSUES',
    CREATE_FORM_FIELD_CONFIG_UPDATE: 'CREATE_FORM_FIELD_CONFIG_UPDATE',
    CREATE_FORM_FIELD_VALUE_CHANGE: 'CREATE_FORM_FIELD_VALUE_CHANGE',
    ISSUE_CREATE_SUCCESS: 'ISSUE_CREATE_SUCCESS',
    PROJECT_FIELD_VALUE_CHANGE: 'PROJECT_FIELD_VALUE_CHANGE',
    ISSUE_TYPE_FIELD_VALUE_CHANGE: 'ISSUE_TYPE_FIELD_VALUE_CHANGE',
    RESET_FORM_FIELDS_FOR_CREATE_ANOTHER: 'RESET_FORM_FIELDS_FOR_CREATE_ANOTHER',
    USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE: 'USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE',
    STATUS_FIELD_STATE_CHANGE: 'STATUS_FIELD_STATE_CHANGE',
    CREATE_FORM_FIELD_BLUR: 'CREATE_FORM_FIELD_BLUR',
    CLASSIFICATION_LEVEL_FIELD_CHANGE: 'CLASSIFICATION_LEVEL_FIELD_CHANGE',
    FORM_CONTEXT_STATE_CHANGE: 'FORM_CONTEXT_STATE_CHANGE'
};

});

parcelRegister("9svjh", function(module, exports) {

$parcel$export(module.exports, "useGICLifeCycleEvents", () => $d9b2e43e4699b192$export$e3ff72f196296fcc);

var $1mrD8 = parcelRequire("1mrD8");
const $d9b2e43e4699b192$var$GICLifeCycleEventsService = new (0, $1mrD8.PubSubHub)();
const $d9b2e43e4699b192$export$e3ff72f196296fcc = ()=>({
        ...$d9b2e43e4699b192$var$GICLifeCycleEventsService
    });

});
parcelRegister("1mrD8", function(module, exports) {

$parcel$export(module.exports, "PubSubHub", () => $6e9a69c6f6f4fcfe$export$e3607828f8f2c01e);
class $6e9a69c6f6f4fcfe$export$e3607828f8f2c01e {
    constructor(){
        this.subscribers = {};
        this.subscribe = (event, subscriber)=>{
            let subs = this.subscribers[event];
            if (!subs) {
                subs = [];
                this.subscribers[event] = subs;
            }
            subs?.push(subscriber);
            return ()=>this.unsubscribe(event, subscriber);
        };
        this.unsubscribe = (event, subscriber)=>{
            const subs = this.subscribers[event];
            if (subs) this.subscribers[event] = subs.filter((subscription)=>subscription !== subscriber);
        };
        this.publish = (event, data)=>{
            const subs = this.subscribers[event];
            if (subs?.length) subs?.forEach((subscriber)=>subscriber(data));
        };
        this.clearAll = ()=>{
            this.subscribers = {};
        };
    }
}

});





parcelRegister("X8Rcv", function(module, exports) {

$parcel$export(module.exports, "default", () => $9faef35b547e44b9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $id7K0 = parcelRequire("id7K0");

var $koVbs = parcelRequire("koVbs");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $1lTah = parcelRequire("1lTah");
function $9faef35b547e44b9$export$2e2bcd8739ae039() {
    const intl = (0, $koVbs.default)();
    const boardName = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getName));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: intl.formatMessage((0, $1lTah.default).pageTitle, {
            boardName: boardName
        })
    });
}

});
parcelRegister("id7K0", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $938046587fdeeb52$export$dd5ad0b65cf665da);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $4CAXd = parcelRequire("4CAXd");
// eslint-disable-next-line jira/react/no-class-components
class $938046587fdeeb52$var$DocumentTitleOld extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $4CAXd.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber = (0, $4CAXd.DocumentTitleSubscriber) } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CAXd.DocumentTitleHelperOld), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}
const $938046587fdeeb52$export$dd5ad0b65cf665da = (0, $cSD7y.componentWithFG)('jira-concurrent-document-title', (0, $4CAXd.DocumentTitleHelper), $938046587fdeeb52$var$DocumentTitleOld);

});

parcelRegister("1lTah", function(module, exports) {

$parcel$export(module.exports, "default", () => $528e1098b3036ec0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $528e1098b3036ec0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    pageTitle: {
        "id": "backlog.document-title.page-title",
        "defaultMessage": "{boardName} - Backlog"
    }
});

});


parcelRegister("aPfpu", function(module, exports) {

$parcel$export(module.exports, "FiltersStorage", () => $1b96912253cd199c$export$311c7d3073893ae);

var $5uXOq = parcelRequire("5uXOq");

var $wKznQ = parcelRequire("wKznQ");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $fSgHa = parcelRequire("fSgHa");
const $1b96912253cd199c$export$311c7d3073893ae = ()=>{
    const isCMPBacklog = (0, $fSgHa.useIsCMPBacklog)();
    const boardId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getRapidViewId));
    const filters = (0, $c1MAf.useBacklogSelector)((state)=>state.ui.filters);
    (0, $5uXOq.useEffect)(()=>{
        if (isCMPBacklog) (0, $wKznQ.setCachedFilters)('backlog', boardId, filters);
    }, [
        boardId,
        filters,
        isCMPBacklog
    ]);
    return null;
};

});

parcelRegister("bzlhL", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b7129ab0f59cd4a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dF9Z3 = parcelRequire("dF9Z3");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");
function $5b7129ab0f59cd4a$export$2e2bcd8739ae039() {
    const numCards = (0, $c1MAf.useBacklogSelector)((state)=>Object.keys((0, $dGljH.getCards)(state)).length);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dF9Z3.default), {
        analyticsAttributes: {
            numCards: numCards
        }
    });
}

});
parcelRegister("dF9Z3", function(module, exports) {

$parcel$export(module.exports, "isMacOS", () => $3300b05877fade72$export$6159e43e50a41987);
$parcel$export(module.exports, "useGlobalSearch", () => $3300b05877fade72$export$1df85516f1b3e335);
$parcel$export(module.exports, "default", () => $3300b05877fade72$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fW62l = parcelRequire("fW62l");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $3300b05877fade72$export$6159e43e50a41987 = ()=>Boolean(navigator && /^Mac/.test(navigator.platform));
const $3300b05877fade72$export$1df85516f1b3e335 = (/** Callback to be fired when global search is used */ callback, getGlobalDocument = ()=>document)=>{
    (0, $5uXOq.useEffect)(()=>{
        const trackGlobalSearch = (event)=>{
            const isMacOs = $3300b05877fade72$export$6159e43e50a41987();
            if (isMacOs && event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('f') && event.metaKey || !isMacOs && event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('f') && event.ctrlKey) callback({
                isMacOs: isMacOs,
                event: event
            });
        };
        getGlobalDocument().addEventListener('keydown', trackGlobalSearch);
        return ()=>getGlobalDocument().removeEventListener('keydown', trackGlobalSearch);
    }, [
        callback,
        getGlobalDocument
    ]);
};
const $3300b05877fade72$var$GlobalSearchTracker = ({ getGlobalDocument: getGlobalDocument = ()=>document, fireAnalytics: fireAnalytics = (0, $8zOmE.fireTrackAnalytics), analyticsAttributes: analyticsAttributes = {} })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onGlobalSearch = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7031 - Binding element 'isMacOs' implicitly has an 'any' type.
    ({ isMacOs: isMacOs })=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'triggered',
            actionSubject: 'globalSearch'
        });
        const attributes = {
            ...analyticsAttributes,
            isMacOs: isMacOs
        };
        fireAnalytics(analyticsEvent, 'globalSearch triggered', attributes);
    }, [
        analyticsAttributes,
        createAnalyticsEvent,
        fireAnalytics
    ]);
    $3300b05877fade72$export$1df85516f1b3e335(onGlobalSearch, getGlobalDocument);
    return null;
};
var $3300b05877fade72$export$2e2bcd8739ae039 = $3300b05877fade72$var$GlobalSearchTracker;

});


parcelRegister("aammX", function(module, exports) {

$parcel$export(module.exports, "default", () => $89535920340e6239$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $jS4lj = parcelRequire("jS4lj");

var $cS37j = parcelRequire("cS37j");

var $7XYc4 = parcelRequire("7XYc4");

var $1asmd = parcelRequire("1asmd");

var $koVbs = parcelRequire("koVbs");

var $3HwlS = parcelRequire("3HwlS");

var $lmBAt = parcelRequire("lmBAt");

var $iDGXn = parcelRequire("iDGXn");

var $4R6GH = parcelRequire("4R6GH");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $1z1J7 = parcelRequire("1z1J7");

var $eKQP4 = parcelRequire("eKQP4");

var $bONT7 = parcelRequire("bONT7");

var $4hApq = parcelRequire("4hApq");

var $bmw3d = parcelRequire("bmw3d");
const $89535920340e6239$var$styles = {
    root: "_zulpu2gc _ca0qv47k _n3tdv47k _1e0c1txw _1n261tfl _1bah1yb4 _pdlm1ejb _45zz1q9c",
    actions: "_16jlkb7n _1o9zkb7n _i0dl1wug _4cvr1y6m _18u01wug _1e0c1txw _1bahesu3 _10m4idpf _1vdkkb7n _1wzn1wug",
    relativePosition: "_kqswh2mm"
};
const $89535920340e6239$export$2676d4da338c3ba1 = (state)=>(0, $1z1J7.canEditBoardConfig)(state) || (0, $jG5HW.getIsCompanyManaged)(state);
function $89535920340e6239$var$HeaderNew(props) {
    const { customFiltersQueryRef: customFiltersQueryRef, versionFilterRelayQueryRef: versionFilterRelayQueryRef } = props;
    const isMenuVisible = (0, $c1MAf.useBacklogSelector)($89535920340e6239$export$2676d4da338c3ba1);
    const isFilterSelectionBarOpen = (0, $iDGXn.useShowQuickFilters)();
    if ((0, $4R6GH.fg)('blu-7431_fix_backlog_quick_filters_styling')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $89535920340e6239$var$styles.root,
            (0, $lmBAt.getIsSoftwareThemingM2Enabled)('blurry-background') && $89535920340e6239$var$styles.relativePosition
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4hApq.default), {
        customFiltersQueryRef: customFiltersQueryRef,
        versionFilterRelayQueryRef: versionFilterRelayQueryRef
    }), isFilterSelectionBarOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bONT7.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $89535920340e6239$var$styles.actions
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eKQP4.ActionsBar), {
        isMenuVisible: isMenuVisible
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1asmd.PageTopBar), {
        bottomBar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $89535920340e6239$var$controlsBarWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4hApq.default), {
            customFiltersQueryRef: customFiltersQueryRef,
            versionFilterRelayQueryRef: versionFilterRelayQueryRef
        })),
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eKQP4.ActionsBar), {
            isMenuVisible: isMenuVisible
        }),
        wrapAtMd: true
    }), isFilterSelectionBarOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bONT7.default), null));
}
function $89535920340e6239$var$HeaderOld(props) {
    const { customFiltersQueryRef: customFiltersQueryRef, versionFilterRelayQueryRef: versionFilterRelayQueryRef } = props;
    const isMenuVisible = (0, $c1MAf.useBacklogSelector)($89535920340e6239$export$2676d4da338c3ba1);
    const boardType = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getBoardType));
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cS37j.default), {
        truncateTitle: true,
        breadcrumbs: $89535920340e6239$var$breadcrumbs,
        bottomBar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4hApq.default), {
            customFiltersQueryRef: customFiltersQueryRef,
            versionFilterRelayQueryRef: versionFilterRelayQueryRef
        }),
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eKQP4.ActionsBar), {
            isMenuVisible: isMenuVisible,
            boardType: boardType
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($89535920340e6239$var$HeadingStyle, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($89535920340e6239$var$TruncatingTextStyle, null, formatMessage((0, $bmw3d.default).pageTitle))));
}
var $89535920340e6239$export$2e2bcd8739ae039 = (0, $7XYc4.componentWithCondition)(()=>(0, $3HwlS.getWillShowNav4)(), $89535920340e6239$var$HeaderNew, $89535920340e6239$var$HeaderOld);
const $89535920340e6239$var$controlsBarWrapper = (0, $8CUq3.xcss)({
    // enough width to fit expanded search + avatar filter + clear filters button
    minWidth: '480px',
    display: 'flex',
    alignItems: 'end',
    flex: '1 1 auto'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $89535920340e6239$export$c7432936d9c50db7 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11w3glyw",
            __cmplp.className
        ])
    });
});
const $89535920340e6239$var$breadcrumbs = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($89535920340e6239$export$c7432936d9c50db7, {
    "data-fullscreen-id": "fullscreen-backlog-breadcrumbs"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jS4lj.default), null)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $89535920340e6239$var$HeadingStyle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $89535920340e6239$var$TruncatingTextStyle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _16jlidpf _1o9zkb7n _i0dl1wug _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cS37j", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a15efb09f101ecb$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* This is a wrapper around @atlaskit/page-header to patch a bug where text alignment
 in actions is incorrect. This common component is no longer necessary when
 https://ecosystem.atlassian.net/browse/AK-6385 is resolved.
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $57MwZ = parcelRequire("57MwZ");
const $2a15efb09f101ecb$var$PageHeader = ({ actions: actions, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $57MwZ.default), {
        ...props,
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>> | undefined'.
        actions: actions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2a15efb09f101ecb$var$ActionsWrapper, null, actions) : null
    });
var $2a15efb09f101ecb$export$2e2bcd8739ae039 = $2a15efb09f101ecb$var$PageHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a15efb09f101ecb$var$ActionsWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("57MwZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9694e728fd1ea060$export$2e2bcd8739ae039);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eeGIy = parcelRequire("eeGIy");
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ const $9694e728fd1ea060$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false, testId: testId })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eeGIy.OuterWrapper), {
        children: [
            breadcrumbs,
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eeGIy.TitleWrapper), {
                truncateTitle: truncateTitle,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eeGIy.TitleContainer), {
                        truncateTitle: truncateTitle,
                        children: disableTitleStyles ? children : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eeGIy.StyledTitleWrapper), {
                            ref: innerRef,
                            truncateTitle: truncateTitle,
                            id: id,
                            testId: testId,
                            children: children
                        })
                    }),
                    actions && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eeGIy.ActionsWrapper), {
                        children: actions
                    })
                ]
            }),
            bottomBar && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eeGIy.BottomBarWrapper), {
                children: [
                    " ",
                    bottomBar,
                    " "
                ]
            })
        ]
    });
};
var $9694e728fd1ea060$export$2e2bcd8739ae039 = $9694e728fd1ea060$var$PageHeader;

});
parcelRegister("eeGIy", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", () => $0c196d37a4e8266c$export$edaaad985a878983);
$parcel$export(module.exports, "StyledTitleWrapper", () => $0c196d37a4e8266c$export$284be1ee64a3465c);
$parcel$export(module.exports, "TitleWrapper", () => $0c196d37a4e8266c$export$585a3b23e887288b);
$parcel$export(module.exports, "TitleContainer", () => $0c196d37a4e8266c$export$35e09ba17cc51c69);
$parcel$export(module.exports, "ActionsWrapper", () => $0c196d37a4e8266c$export$c8223871eecc8f3a);
$parcel$export(module.exports, "BottomBarWrapper", () => $0c196d37a4e8266c$export$6330225854c30dc);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
const $0c196d37a4e8266c$var$styles = {
    bottomBar: "_1pfhpxbi"
};
const $0c196d37a4e8266c$var$truncateStyles = null;
const $0c196d37a4e8266c$var$outerStyles = null;
const $0c196d37a4e8266c$var$titleStyles = null;
const $0c196d37a4e8266c$var$titleWrapperStyles = null;
const $0c196d37a4e8266c$var$titleWrapperTruncateStyles = null;
const $0c196d37a4e8266c$var$titleContainerStyles = null;
const $0c196d37a4e8266c$var$actionStyles = null;
const $0c196d37a4e8266c$var$titleContainerTruncateStyles = null;
const $0c196d37a4e8266c$export$edaaad985a878983 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_6rthpxbi _1pfh1ejb _12l2idpf _ahbqidpf"
        ]),
        children: children
    });
};
const $0c196d37a4e8266c$export$284be1ee64a3465c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("h1", {
        ref: ref,
        tabIndex: -1,
        id: id,
        "data-testid": testId && `${testId}--title`,
        className: (0, $bwpsq.default)([
            "_11c8nf1z _12ji1r31 _1qu2glyw _12y31o36 _syaz1fxt _1dyz4jg8 _1pfhidpf",
            truncateTitle && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
        ]),
        children: children
    });
});
const $0c196d37a4e8266c$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1y6m _1n261g80",
            truncateTitle && "_1n261q9c"
        ]),
        children: children
    });
};
const $0c196d37a4e8266c$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zidpf _i0dl1wug _1ul9idpf _p12f1osq _6rthu2gc",
            truncateTitle && "_1o9zkb7n"
        ]),
        children: children
    });
};
const $0c196d37a4e8266c$export$c8223871eecc8f3a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _p12f1osq _6rthu2gc _ahbq1wug _bozgxy5q _o5721q9c"
        ]),
        children: children
    });
};
const $0c196d37a4e8266c$export$6330225854c30dc = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $0c196d37a4e8266c$var$styles.bottomBar,
        children: children
    });
};

});



parcelRegister("1asmd", function(module, exports) {

$parcel$export(module.exports, "PageTopBar", () => $a509d50a7a06aca2$export$7e5801dc91bf1819);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $h9kUS = parcelRequire("h9kUS");
var $8CUq3 = parcelRequire("8CUq3");

var $cS37j = parcelRequire("cS37j");

var $3HwlS = parcelRequire("3HwlS");

var $dCm1o = parcelRequire("dCm1o");

const $a509d50a7a06aca2$var$SporkPageTopBar = ({ bottomBar: bottomBar, actions: actions, wrapAtMd: wrapAtMd = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: (0, $2fd65ab7d0fa0d2a$export$90c4434a1e138106),
        xcss: [
            !(0, $dCm1o.isVisualRefreshEnabled)() && $a509d50a7a06aca2$var$wrapperStylesOld2,
            (0, $dCm1o.isVisualRefreshEnabled)() && $a509d50a7a06aca2$var$wrapperStyles,
            wrapAtMd ? $a509d50a7a06aca2$var$wrapAtMdStyle : $a509d50a7a06aca2$var$noWrapStyle
        ]
    }, bottomBar, actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: (0, $2fd65ab7d0fa0d2a$export$1742330ac6a668f0),
        xcss: [
            $a509d50a7a06aca2$var$actionsBoxStyles,
            wrapAtMd && $a509d50a7a06aca2$var$actionsBoxAtMdStyles
        ]
    }, actions));
const $a509d50a7a06aca2$export$7e5801dc91bf1819 = (props)=>(0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a509d50a7a06aca2$var$SporkPageTopBar, {
        bottomBar: props.bottomBar,
        actions: props.actions,
        wrapAtMd: props.wrapAtMd
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cS37j.default), props);
const $a509d50a7a06aca2$var$noWrapStyle = (0, $8CUq3.xcss)({
    flexWrap: 'nowrap'
});
const $a509d50a7a06aca2$var$wrapAtMdStyle = (0, $8CUq3.xcss)({
    flexWrap: 'wrap-reverse',
    [(0, $h9kUS.media).above.md]: {
        flexWrap: 'nowrap'
    }
});
const $a509d50a7a06aca2$var$wrapperStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    paddingTop: 'space.250',
    paddingBottom: 'space.200',
    justifyContent: 'space-between',
    gap: 'space.100',
    [(0, $h9kUS.media).above.md]: {
        gap: 'space.300'
    }
});
const $a509d50a7a06aca2$var$wrapperStylesOld2 = (0, $8CUq3.xcss)({
    display: 'flex',
    paddingTop: 'space.150',
    paddingBottom: 'space.150',
    justifyContent: 'space-between',
    gap: 'space.100',
    [(0, $h9kUS.media).above.md]: {
        gap: 'space.300'
    }
});
const $a509d50a7a06aca2$var$actionsBoxAtMdStyles = (0, $8CUq3.xcss)({
    flex: '1 1 auto',
    [(0, $h9kUS.media).above.md]: {
        flex: '0 1 auto'
    }
});
const $a509d50a7a06aca2$var$actionsBoxStyles = (0, $8CUq3.xcss)({
    marginLeft: 'auto',
    display: 'flex',
    justifyContent: 'flex-end',
    flex: '0 0 auto'
});

});
const $2fd65ab7d0fa0d2a$export$90c4434a1e138106 = 'horizontal-nav-page-topbar.ui.horizontal-nav-page-topbar';
const $2fd65ab7d0fa0d2a$export$1742330ac6a668f0 = 'horizontal-nav-page-topbar.ui.horizontal-nav-page-topbar.actions';


parcelRegister("eKQP4", function(module, exports) {

$parcel$export(module.exports, "ActionsBar", () => $af50ae0f8b822d38$export$8c8e9293b68041de);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ldJSL = parcelRequire("ldJSL");

var $bUmQV = parcelRequire("bUmQV");
var $c0aEF = parcelRequire("c0aEF");

var $7XYc4 = parcelRequire("7XYc4");

var $8CVvd = parcelRequire("8CVvd");

var $3HwlS = parcelRequire("3HwlS");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $fNWqR = parcelRequire("fNWqR");

var $e0kZI = parcelRequire("e0kZI");

var $2ZySJ = parcelRequire("2ZySJ");

var $k9JTq = parcelRequire("k9JTq");

var $dCm1o = parcelRequire("dCm1o");

var $lmBAt = parcelRequire("lmBAt");

var $a2e2Q = parcelRequire("a2e2Q");

var $1fyfD = parcelRequire("1fyfD");

var $9g0YE = parcelRequire("9g0YE");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $iY49l = parcelRequire("iY49l");

var $k35me = parcelRequire("k35me");

var $czw5V = parcelRequire("czw5V");

var $99Ffx = parcelRequire("99Ffx");

var $fxbvZ = parcelRequire("fxbvZ");

var $iLlDl = parcelRequire("iLlDl");

var $jzmeD = parcelRequire("jzmeD");

var $i03cI = parcelRequire("i03cI");

var $lHl5z = parcelRequire("lHl5z");

var $fFw8N = parcelRequire("fFw8N");
const $af50ae0f8b822d38$var$ConditionalButtonGroup = ({ isVisuallyRefreshed: isVisuallyRefreshed, children: children })=>{
    if (isVisuallyRefreshed) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldJSL.default), null, children);
};
const $af50ae0f8b822d38$var$ActionsBarNew = ({ isMenuVisible: isMenuVisible })=>{
    const isEmbedView = (0, $1fyfD.useIsEmbedView)();
    const rapidViewId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getRapidViewId));
    const projectKey = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getProjectKey));
    const appEditions = (0, $k9JTq.useAppEditions)();
    const isInsightsOpen = (0, $czw5V.useIsInsightsPanelOpen)();
    const backlogWithSprints = (0, $c1MAf.useBacklogSelector)((0, $k35me.isBacklogWithSprints));
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const hasOperations = (0, $c1MAf.useBacklogSelector)((0, $iY49l.operationsSelector)).length > 0;
    const isConnectAppsVisible = (0, $fNWqR.useHasToolSections)({
        boardId: rapidViewId,
        projectKey: projectKey,
        mode: 'plan',
        itemLocations: (0, $99Ffx.backlogConnectAppLocations)
    }) || hasOperations;
    const shouldShowFullsceenButton = (0, $8CVvd.getWillShowNav3)();
    const shouldShowMenu = !shouldShowFullsceenButton || isMenuVisible && !isEmbedView || isConnectAppsVisible;
    const handleOnToggle = (0, $5uXOq.useCallback)((panelType)=>{
        dispatch((0, $9g0YE.togglePanel)(panelType));
    }, [
        dispatch
    ]);
    const { isSoftwareFullTheming: isSoftwareFullTheming } = (0, $lmBAt.getIsSoftwareThemingM2Enabled)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $a2e2Q.useSoftwareProjectTheming)() : {
        isSoftwareFullTheming: false
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), {
        justifyContent: "end",
        wrap: "wrap",
        alignItems: (0, $dCm1o.isVisualRefreshEnabled)() ? 'center' : undefined,
        gap: (0, $dCm1o.isVisualRefreshEnabled)() ? 'space.100' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($af50ae0f8b822d38$var$ConditionalButtonGroup, {
        isVisuallyRefreshed: (0, $dCm1o.isVisualRefreshEnabled)()
    }, !isEmbedView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2ZySJ.ImportWorkButton), (0, $lmBAt.getIsSoftwareThemingM2Enabled)() && {
        isThemed: isSoftwareFullTheming
    }), shouldShowFullsceenButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jzmeD.FullscreenButton), {
        boardId: Number(rapidViewId)
    })), backlogWithSprints && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i03cI.InsightsButton), {
        onToggle: handleOnToggle,
        isInsightsPanelOpen: isInsightsOpen,
        boardId: Number(rapidViewId),
        edition: appEditions.software,
        ...(0, $lmBAt.getIsSoftwareThemingM2Enabled)() && {
            isThemed: isSoftwareFullTheming
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fFw8N.BacklogViewSettings), (0, $lmBAt.getIsSoftwareThemingM2Enabled)() && {
        isThemed: isSoftwareFullTheming
    }), shouldShowMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iLlDl.default), (0, $lmBAt.getIsSoftwareThemingM2Enabled)() && {
        isThemed: isSoftwareFullTheming
    })));
};
const $af50ae0f8b822d38$var$ActionsBarOld = ({ isMenuVisible: isMenuVisible, boardType: boardType })=>{
    const isEmbedView = (0, $1fyfD.useIsEmbedView)();
    const isCompanyManaged = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
    const rapidViewId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getRapidViewId));
    const projectKey = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getProjectKey));
    const shareContentType = `${boardType}_backlog`;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onShareButtonClick = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'shareContentType', {
            contentType: shareContentType
        });
    };
    const iconsComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fxbvZ.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lHl5z.ShareButton), {
        shareContentType: shareContentType,
        onTriggerButtonClick: onShareButtonClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jzmeD.FullscreenButton), {
        boardId: Number(rapidViewId)
    }));
    return isEmbedView ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($af50ae0f8b822d38$var$ActionsBarWrapper, null, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
        space: "space.100"
    }, iconsComponent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), null, iconsComponent), isCompanyManaged && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0kZI.BoardConnectToolbar), {
        boardId: rapidViewId,
        projectKey: projectKey,
        mode: "plan"
    }), isMenuVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($af50ae0f8b822d38$var$MenuWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iLlDl.default), null)) : null);
};
const $af50ae0f8b822d38$export$8c8e9293b68041de = (0, $7XYc4.componentWithCondition)(()=>(0, $3HwlS.getWillShowNav4)(), $af50ae0f8b822d38$var$ActionsBarNew, $af50ae0f8b822d38$var$ActionsBarOld);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $af50ae0f8b822d38$var$ActionsBarWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $af50ae0f8b822d38$var$MenuWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("e0kZI", function(module, exports) {

$parcel$export(module.exports, "BoardConnectToolbar", () => $4677f90b43f839a0$export$afbfa45d45a0cda1);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $fjfkx = parcelRequire("fjfkx");

var $fNWqR = parcelRequire("fNWqR");
function $4677f90b43f839a0$var$BoardConnectToolbarInner({ boardId: boardId, projectKey: projectKey, mode: mode }) {
    const toolSections = (0, $fNWqR.useFetchedToolSections)({
        boardId: boardId,
        projectKey: projectKey,
        mode: mode
    });
    if (!toolSections) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fjfkx.BoardToolsView), {
        toolSections: toolSections
    });
}
function $4677f90b43f839a0$export$afbfa45d45a0cda1(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "board-connect-toolbar",
        packageName: "@atlassian/jira-software-board-connect-toolbar",
        teamName: "a4t-tanuki",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4677f90b43f839a0$var$BoardConnectToolbarInner, props));
}

});

parcelRegister("2ZySJ", function(module, exports) {

$parcel$export(module.exports, "ImportWorkButton", () => $650ab30d4dd366bc$export$311dc74043c51081);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $kxZPA = parcelRequire("kxZPA");

var $lfTZh = parcelRequire("lfTZh");

var $4R6GH = parcelRequire("4R6GH");


var $8kda3 = parcelRequire("8kda3");

const $650ab30d4dd366bc$export$1d333e4178627a87 = (0, $kxZPA.lazy)(()=>(parcelRequire("k1rmU")).then(({ ImportWorkButtonInternal: ImportWorkButtonInternal })=>ImportWorkButtonInternal), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-invites/src/ui/import-work-button/index.tsx"
});
const $650ab30d4dd366bc$var$ImportWorkButtonWithTargeting = ({ isThemed: isThemed })=>{
    const isTargeted = (0, $8kda3.useIsTargetedForRaisingAwarenessOfImporter)();
    const inner = isTargeted ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($650ab30d4dd366bc$export$1d333e4178627a87, {
        isThemed: isThemed
    }) : null;
    if ((0, $4R6GH.fg)('jfp-magma-fix-misaligned-suspense-boundaries')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "ImportWorkButtonWithTargeting"
    }, inner);
    return inner;
};
const $650ab30d4dd366bc$export$311dc74043c51081 = ({ isThemed: isThemed })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "importWorkButton",
        packageName: (0, $daef8268a41061ca$export$b8b9d90f9e5bd72b),
        teamName: (0, $daef8268a41061ca$export$d57b6b390e78d90f),
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($650ab30d4dd366bc$var$ImportWorkButtonWithTargeting, {
        isThemed: isThemed
    }));

});
const $daef8268a41061ca$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingInvites';
const $daef8268a41061ca$export$d57b6b390e78d90f = 'jlove-makkuro';
const $daef8268a41061ca$export$719991a6cc456f06 = 'software-onboarding-invites.ui.import-work-button.button';

parcelRegister("8kda3", function(module, exports) {

$parcel$export(module.exports, "useIsTargetedForRaisingAwarenessOfImporter", () => $8571e29361584ab7$export$c45655b60f7ebf1c);

var $2vSU6 = parcelRequire("2vSU6");

var $9y6jE = parcelRequire("9y6jE");

var $dAfqg = parcelRequire("dAfqg");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $cNd4s = parcelRequire("cNd4s");
const $8571e29361584ab7$export$c45655b60f7ebf1c = ()=>{
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const { data: data } = (0, $dAfqg.useProjectContext)();
    const { software: edition } = (0, $k9JTq.useAppEditions)();
    const isWithin30Day = (0, $9y6jE.useIsFirstActivationDateWithinLast30Days)();
    const isSoftwareProject = data?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    return data?.simplified && isSiteAdmin && isWithin30Day && edition === (0, $ldyPw.FREE_EDITION) && isSoftwareProject;
};

});
parcelRegister("9y6jE", function(module, exports) {

$parcel$export(module.exports, "useIsFirstActivationDateWithinLast30Days", () => $e7cd4e878e1b25bc$export$f561835faf21b733);

var $dkqym = parcelRequire("dkqym");

var $at4B6 = parcelRequire("at4B6");
const $e7cd4e878e1b25bc$export$f561835faf21b733 = ()=>{
    const firstActivationDate = (0, $dkqym.useFirstActivationDateMs)();
    return (0, $at4B6.isWithinLast30Days)(firstActivationDate);
};

});
parcelRegister("at4B6", function(module, exports) {

$parcel$export(module.exports, "isWithinLast30Days", () => $6d4f0d42d84e1d91$export$550dea1ca60eaa64);

var $iS3m6 = parcelRequire("iS3m6");
const $6d4f0d42d84e1d91$export$550dea1ca60eaa64 = (0, $iS3m6.isWithinLast)({
    days: 30
});

});
parcelRegister("iS3m6", function(module, exports) {

$parcel$export(module.exports, "isWithinLast", () => $8541d32f174f7876$export$15bc1a874225842d);

var $59y5F = parcelRequire("59y5F");

var $dQChl = parcelRequire("dQChl");

var $2xkYZ = parcelRequire("2xkYZ");
const $8541d32f174f7876$export$15bc1a874225842d = (duration)=>(date)=>{
        if (!(0, $59y5F.default)(date)) return false;
        const end = Date.now();
        const start = (0, $2xkYZ.default)(duration)(end);
        // `isValid` precludes a nullable date.
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return (0, $dQChl.default)({
            start: start,
            end: end
        })(date);
    };

});




parcelRegister("k1rmU", function(module, exports) {

let $e93921727731164a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e93921727731164a$var$load("etx49").then(()=>parcelRequire('eK5YJ'));

});


parcelRegister("iY49l", function(module, exports) {

$parcel$export(module.exports, "operationsSelector", () => $aa236735a293475b$export$5244c0030b3a418e);
const $aa236735a293475b$export$5244c0030b3a418e = (state)=>state.config.extension.operations;

});

parcelRegister("99Ffx", function(module, exports) {

$parcel$export(module.exports, "backlogConnectAppLocations", () => $0dade441d31d1b3b$export$fbdd1b6531aa71e7);
const $0dade441d31d1b3b$export$fbdd1b6531aa71e7 = [
    'board-tools-1',
    'view-actions-print'
];

});

parcelRegister("fxbvZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5de2f583b030ce80$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eCgfP = parcelRequire("eCgfP");

var $c1MAf = parcelRequire("c1MAf");

var $iY49l = parcelRequire("iY49l");
const $5de2f583b030ce80$var$Extensions = ({ isTabNavigation: isTabNavigation = false })=>{
    const operations = (0, $c1MAf.useBacklogSelector)((0, $iY49l.operationsSelector));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCgfP.default), {
        operations: operations,
        isTabNavigation: isTabNavigation
    });
};
var $5de2f583b030ce80$export$2e2bcd8739ae039 = $5de2f583b030ce80$var$Extensions;

});
parcelRegister("eCgfP", function(module, exports) {

$parcel$export(module.exports, "default", () => $30adade8afbc4e74$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $9AYKy = parcelRequire("9AYKy");
function $30adade8afbc4e74$export$2e2bcd8739ae039(props) {
    if (props.isTabNavigation) {
        if (props.operations.length === 0) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.operations.map((op)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9AYKy.default), {
                key: op.url,
                operation: op,
                onModalClose: props.onModalClose,
                isTabNavigation: true
            })));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.operations.map((op)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($30adade8afbc4e74$var$OperationWrapper, {
            key: op.url
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9AYKy.default), {
            operation: op,
            onModalClose: props.onModalClose
        }))));
}
$30adade8afbc4e74$export$2e2bcd8739ae039.defaultProps = {
    operations: [],
    onModalClose: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    isTabNavigation: false
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $30adade8afbc4e74$var$OperationWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwxu2gc _1xoqidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9AYKy", function(module, exports) {

$parcel$export(module.exports, "default", () => $40b405f55a447be3$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $hRf4g = parcelRequire("hRf4g");

var $8vDvO = parcelRequire("8vDvO");

var $kJpBP = parcelRequire("kJpBP");

var $3bDjY = parcelRequire("3bDjY");

var $jjlQu = parcelRequire("jjlQu");

var $gwIPs = parcelRequire("gwIPs");

var $3HwlS = parcelRequire("3HwlS");
const $40b405f55a447be3$var$iconSize = (0, $gwIPs.gridSize) * 3;
class $40b405f55a447be3$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        // go/jfe-eslint
        // eslint-disable-next-line react/sort-comp
        this.defaultProps = {
            operation: {},
            onModalClose: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            isTabNavigation: false
        };
    }
    static{
        this.getFallbackIcon = (name)=>(0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hRf4g))), {
                label: name,
                color: "var(--ds-icon, #44546F)"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8vDvO))), {
                LEGACY_size: "medium",
                spacing: "spacious",
                label: name
            });
    }
    /*
   * ABE-22: The reason for using this 'invisible' anchor with an href is needed, instead of simply
   * passing the href to the component which would then have an underlying anchor, is that the
   * styleClasses list of classes here are needed to trigger the ecosystem addon modal to come
   * up on click. This is in contrast to the component behaviour of a vanilla anchor that
   * currently does not support custom classes, which would redirect to a Jira 404 error page.
   */ renderEcosystemModalLink() {
        const { url: url, styleClass: styleClass } = this.props.operation;
        return(// go/jfe-eslint
        // eslint-disable-next-line @atlaskit/design-system/no-html-anchor, jsx-a11y/anchor-has-content
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
            href: url,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: styleClass,
            ref: this.setEcosystemModalLinkRef,
            // eslint-disable-next-line jira/react/no-style-attribute
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: 'none'
            }
        }));
    }
    renderIcon() {
        const { icon: icon, name: name } = this.props.operation;
        return icon && icon.url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jjlQu.default), {
            title: name,
            url: icon.url,
            width: $40b405f55a447be3$var$iconSize,
            height: $40b405f55a447be3$var$iconSize,
            fallback: ()=>$40b405f55a447be3$export$2e2bcd8739ae039.getFallbackIcon(name || '')
        }) : $40b405f55a447be3$export$2e2bcd8739ae039.getFallbackIcon(name || '');
    }
    renderButton() {
        const { name: name } = this.props.operation;
        const icon = this.renderIcon();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            key: name,
            onClick: this.clickEcosystemModalLinkRef,
            // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactChild | undefined'.
            iconBefore: name ? icon : null,
            testId: "common-components-ecosystem-operations.ecosystem-operation.button"
        }, name || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($40b405f55a447be3$var$OnlyIconWrapper, null, icon), this.renderEcosystemModalLink());
    }
    renderMenuItem() {
        const { name: name } = this.props.operation;
        const icon = this.renderIcon();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
            key: name,
            onClick: this.clickEcosystemModalLinkRef,
            iconBefore: name ? icon : null,
            testId: "common-components-ecosystem-operations.ecosystem-operation.button-item"
        }, name || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($40b405f55a447be3$var$OnlyIconWrapper, null, icon), this.renderEcosystemModalLink());
    }
    render() {
        const { tooltip: tooltip } = this.props.operation;
        const content = this.props.isTabNavigation ? this.renderMenuItem() : this.renderButton();
        if (tooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: tooltip
        }, content);
        return content;
    }
    constructor(...args){
        super(...args), /* not used yet TOTEM-818 */ this.onModalClose = ()=>this.props.onModalClose(), this.setEcosystemModalLinkRef = (element)=>{
            this.ecosystemModalLinkRef = element;
        }, this.clickEcosystemModalLinkRef = ()=>{
            this.ecosystemModalLinkRef && this.ecosystemModalLinkRef.click();
        };
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $40b405f55a447be3$var$OnlyIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});



parcelRegister("iLlDl", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f8ec5296cbf43a9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $fVnbM = parcelRequire("fVnbM");

var $8U6zd = parcelRequire("8U6zd");

var $3oUqw = parcelRequire("3oUqw");

var $1I7E8 = parcelRequire("1I7E8");

var $3Tty1 = parcelRequire("3Tty1");

var $4R6GH = parcelRequire("4R6GH");

var $jDKvL = parcelRequire("jDKvL");

var $koVbs = parcelRequire("koVbs");

var $g7crU = parcelRequire("g7crU");

var $3HwlS = parcelRequire("3HwlS");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dCm1o = parcelRequire("dCm1o");

var $lmBAt = parcelRequire("lmBAt");

var $hCCtP = parcelRequire("hCCtP");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $9Pc1U = parcelRequire("9Pc1U");

var $1z1J7 = parcelRequire("1z1J7");

var $fpDLy = parcelRequire("fpDLy");

var $ffAwz = parcelRequire("ffAwz");

var $8dqGW = parcelRequire("8dqGW");

var $lt367 = parcelRequire("lt367");
const $8f8ec5296cbf43a9$var$BacklogPopupMenuWithFG = ({ isThemed: isThemed })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    // from old props
    const isCompanyManaged = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
    const canEditBoardConfigProp = (0, $c1MAf.useBacklogSelector)((0, $1z1J7.canEditBoardConfig));
    const shouldShowDetailViewItem = (0, $c1MAf.useBacklogSelector)((state)=>!(0, $dGljH.isBacklogEmptySelector)(state));
    const shouldShowEpicAsPanel = (0, $c1MAf.useBacklogSelector)((0, $9Pc1U.getShowEpicAsPanel));
    const shouldShowVersionsPanel = (0, $c1MAf.useBacklogSelector)((0, $fpDLy.isVersionsFeatureEnabled));
    const handleClick = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        setIsOpen(!isOpen);
        analyticsEvent.update({
            action: 'toggled',
            actionSubject: 'dropdownMenu'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'backlogHeaderMenu');
    }, [
        isOpen
    ]);
    const handleClose = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(false);
        const analyticsEvent = createAnalyticsEvent({
            action: 'toggled',
            actionSubject: 'dropdownMenu'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'backlogHeaderMenu');
    }, [
        createAnalyticsEvent
    ]);
    // handle close when not initiated by user interaction. e.g. when forge apps finish loading
    const handleNonClickClose = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(false);
    }, [
        setIsOpen
    ]);
    const getMoreIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8U6zd))), {
            label: formatMessage((0, $lt367.default).dropdownAriaLabel),
            color: "var(--ds-icon, #44546F)",
            spacing: "spacious",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($3oUqw))),
            LEGACY_primaryColor: "var(--ds-icon, #44546F)"
        });
    const [isFullscreen, { setIsFullscreen: setIsFullscreen }] = (0, $g7crU.useIsFullscreen)();
    const toggleFullscreen = (0, $5uXOq.useCallback)(()=>{
        setIsFullscreen(!isFullscreen);
    }, [
        isFullscreen,
        setIsFullscreen
    ]);
    const shortcutsKeyMap = {
        z: {
            callback: toggleFullscreen
        }
    };
    const IconButtonComponent = isThemed && (0, $lmBAt.getIsSoftwareThemingM2Enabled)() ? (0, $hCCtP.ThemedIconButton) : (0, $42CjB.default);
    const renderTrigger = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $dCm1o.isVisualRefreshEnabled)() || (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IconButtonComponent, {
            ...triggerProps,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8U6zd))),
            label: (0, $dCm1o.isVisualRefreshEnabled)() ? formatMessage((0, $lt367.default).buttonLabel) : formatMessage((0, $lt367.default).buttonLabelOld),
            isSelected: isOpen,
            onClick: handleClick,
            isTooltipDisabled: false
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            ...triggerProps,
            iconBefore: getMoreIcon(),
            isSelected: isOpen,
            onClick: handleClick
        }));
    const renderContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ffAwz.default), {
            canEditBoardConfig: canEditBoardConfigProp,
            isCompanyManaged: isCompanyManaged,
            shouldShowDetailViewItem: shouldShowDetailViewItem,
            shouldShowEpicAsPanel: shouldShowEpicAsPanel,
            shouldShowVersionsPanel: shouldShowVersionsPanel,
            onClosePopup: handleClose
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
        placement: "bottom-end",
        isOpen: isOpen,
        onClose: handleClose,
        content: renderContent,
        trigger: renderTrigger,
        shouldRenderToParent: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8dqGW.BacklogActionForgeRuntimeContainer), {
        onAppsFinishLoading: handleNonClickClose
    }), (0, $3HwlS.getWillShowNav4)() && !(0, $4R6GH.fg)('blu-5747-fullscreen-in-nav-header') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Tty1.default), {
        keyMap: shortcutsKeyMap
    }));
};
const $8f8ec5296cbf43a9$var$BacklogPopupMenu = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jDKvL.ForgeAppsContainer), {
        scope: "backlog-action"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8f8ec5296cbf43a9$var$BacklogPopupMenuWithFG, props));
};
var $8f8ec5296cbf43a9$export$2e2bcd8739ae039 = $8f8ec5296cbf43a9$var$BacklogPopupMenu;

});
parcelRegister("ffAwz", function(module, exports) {

$parcel$export(module.exports, "default", () => $247df5f67e9da735$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eZUJu = parcelRequire("eZUJu");
var $9UCCQ = parcelRequire("9UCCQ");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");

var $e8X1M = parcelRequire("e8X1M");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $iY49l = parcelRequire("iY49l");

var $hhmH6 = parcelRequire("hhmH6");

var $bcdwp = parcelRequire("bcdwp");

var $eqhHD = parcelRequire("eqhHD");

var $ctQ5b = parcelRequire("ctQ5b");

var $8fQBb = parcelRequire("8fQBb");

var $gCOKH = parcelRequire("gCOKH");
const $247df5f67e9da735$var$BacklogMenuContentOld = ({ isCompanyManaged: isCompanyManaged, canEditBoardConfig: canEditBoardConfig, onClosePopup: onClosePopup })=>{
    const boardId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getRapidViewId));
    const projectKey = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getProjectKey));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), null, isCompanyManaged ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hhmH6.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e8X1M.BoardConnectMenuItems), {
        boardId: boardId,
        projectKey: projectKey,
        location: "board-tools-1",
        mode: "plan",
        onClickWebItem: onClosePopup
    }), canEditBoardConfig && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bcdwp.CreateBoardMenuItem), {
        onClosePopup: onClosePopup
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e8X1M.BoardConnectMenuItems), {
        boardId: boardId,
        projectKey: projectKey,
        location: "view-actions-print",
        mode: "plan",
        onClickWebItem: onClosePopup
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctQ5b.default), {
        isDisabled: !canEditBoardConfig
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gCOKH.BacklogForgeActionMenuItems), null)));
};
const $247df5f67e9da735$var$BacklogMenuContentNew = ({ isCompanyManaged: isCompanyManaged, canEditBoardConfig: canEditBoardConfig, onClosePopup: onClosePopup })=>{
    const boardId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getRapidViewId));
    const projectKey = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getProjectKey));
    const hasOperations = (0, $c1MAf.useBacklogSelector)((0, $iY49l.operationsSelector)).length > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), {
        maxWidth: 240
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), null, !(0, $4R6GH.fg)('blu-5747-fullscreen-in-nav-header') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eqhHD.FullscreenItem), {
        onClosePopup: onClosePopup
    }), isCompanyManaged ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hhmH6.default), null), canEditBoardConfig && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bcdwp.CreateBoardMenuItem), {
        onClosePopup: onClosePopup
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctQ5b.default), {
        isDisabled: !canEditBoardConfig
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gCOKH.BacklogForgeActionMenuItems), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8fQBb.BoardConnectItems), {
        projectKey: projectKey,
        boardId: boardId,
        hasOperations: hasOperations,
        isCompanyManaged: isCompanyManaged
    }));
};
const $247df5f67e9da735$var$BacklogMenuContent = (0, $7XYc4.componentWithCondition)(()=>(0, $3HwlS.getWillShowNav4)(), $247df5f67e9da735$var$BacklogMenuContentNew, $247df5f67e9da735$var$BacklogMenuContentOld);
var $247df5f67e9da735$export$2e2bcd8739ae039 = $247df5f67e9da735$var$BacklogMenuContent;

});
parcelRegister("e8X1M", function(module, exports) {

$parcel$export(module.exports, "BoardConnectMenuItems", () => $7ffeafe4bb5b3117$export$d8d46adb5b629caf);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $2NYED = parcelRequire("2NYED");

var $fjfkx = parcelRequire("fjfkx");

var $fNWqR = parcelRequire("fNWqR");

var $78UP2 = parcelRequire("78UP2");
function $7ffeafe4bb5b3117$var$BoardConnectMenuItemsInner({ projectKey: projectKey, boardId: boardId, location: location, mode: mode, onClickWebItem: onClickWebItem, isTabNavigation: isTabNavigation = false }) {
    const toolSections = (0, $fNWqR.useFetchedToolSections)({
        boardId: boardId,
        projectKey: projectKey,
        mode: mode
    });
    const targetSection = (0, $5uXOq.useMemo)(()=>toolSections && location && (0, $78UP2.findSection)(toolSections, location), [
        toolSections,
        location
    ]);
    if (!location && isTabNavigation) return toolSections ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fjfkx.BoardToolsView), {
        toolSections: toolSections,
        mode: "dropdown-item",
        onClickWebItem: onClickWebItem,
        isTabNavigation: isTabNavigation
    }) : null;
    if (!toolSections || !targetSection) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, targetSection.subItems?.filter((item)=>item.id != null) // built-in items don't have IDs set
    .map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2NYED.BoardToolSubItem), {
            onClickWebItem: onClickWebItem,
            key: item.id,
            subItem: item,
            isTabNavigation: isTabNavigation
        })) ?? null);
}
function $7ffeafe4bb5b3117$export$d8d46adb5b629caf(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "board-connect-toolbar",
        packageName: "@atlassian/jira-software-board-connect-menu-items",
        teamName: "a4t-tanuki",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7ffeafe4bb5b3117$var$BoardConnectMenuItemsInner, props));
}

});

parcelRegister("hhmH6", function(module, exports) {

$parcel$export(module.exports, "default", () => $55821056826b5b99$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3Z96c = parcelRequire("3Z96c");

var $2YZCu = parcelRequire("2YZCu");

var $koVbs = parcelRequire("koVbs");

var $doZTA = parcelRequire("doZTA");

var $beOOr = parcelRequire("beOOr");

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");

var $bSSG7 = parcelRequire("bSSG7");

var $e5wyW = parcelRequire("e5wyW");

var $l4fDC = parcelRequire("l4fDC");
const $55821056826b5b99$var$storageProvider = (0, $bSSG7.createLocalStorageProvider)('', false);
const $55821056826b5b99$export$444102a091dc311d = ()=>{
    const defaultValue = 'filter';
    let value;
    try {
        if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) value = $55821056826b5b99$var$storageProvider.get('selectedConfigTab');
        else value = localStorage.getItem('selectedConfigTab');
        return value ? JSON.parse(value) : defaultValue;
    } catch (err) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('software-backlog.header.menu.configure-board-item.dropdown-item', `Error reading "selectedConfigTab" value: ${err}`);
        return defaultValue;
    }
};
const $55821056826b5b99$export$cc501cfa2aa02d4e = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const selectedConfigTab = $55821056826b5b99$export$444102a091dc311d();
    const url = $55821056826b5b99$var$useBoardSettingsUrlFn(selectedConfigTab);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Z96c.default), {
        "data-testid": "software-backlog.header.menu.configure-board-item.dropdown-item",
        href: url
    }, formatMessage((0, $l4fDC.default).displayText));
};
const $55821056826b5b99$var$useBoardSettingsUrlFn = (0, $e5wyW.functionWithCondition)(()=>((0, $4R6GH.fg)('blu-7261-change-blu-5799-to-support-nav3') || (0, $3HwlS.getWillShowNav4)()) && // Delete this line when cleaning up blu-7261
    (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route'), $55821056826b5b99$var$useBoardSettingsNew, $55821056826b5b99$var$useBoardSettingsOld);
function $55821056826b5b99$var$useBoardSettingsNew(selectedConfigTab) {
    const settingsUrl = (0, $beOOr.useBoardSettingsUrl)();
    return `${settingsUrl}/${selectedConfigTab}?from-backlog=1`;
}
function $55821056826b5b99$var$useBoardSettingsOld(selectedConfigTab) {
    // This function will be cleaned up soon
    // eslint-disable-next-line jira/router/no-useRouter-in-components
    const [{ location: location }] = (0, $doZTA.useRouter)();
    return `${location.pathname}?config=${selectedConfigTab}`;
}
var $55821056826b5b99$export$2e2bcd8739ae039 = $55821056826b5b99$export$cc501cfa2aa02d4e;

});
parcelRegister("beOOr", function(module, exports) {

$parcel$export(module.exports, "useBoardSettingsUrl", () => $d3a20dcbc1b57686$export$e1ea57ffba968ed5);

var $4IPB4 = parcelRequire("4IPB4");

var $h2QE2 = parcelRequire("h2QE2");
function $d3a20dcbc1b57686$export$e1ea57ffba968ed5() {
    return (0, $h2QE2.getBoardSettingsUrl)((0, $4IPB4.useBoardUrl)());
}

});
parcelRegister("4IPB4", function(module, exports) {

$parcel$export(module.exports, "useBoardUrl", () => $d4170d0ca473b3a2$export$66c8e3658ad37452);

var $5uXOq = parcelRequire("5uXOq");

var $edUVe = parcelRequire("edUVe");

var $b2XdI = parcelRequire("b2XdI");


var $4R6GH = parcelRequire("4R6GH");

var $5w1T1 = parcelRequire("5w1T1");

var $1ilU2 = parcelRequire("1ilU2");

var $dd29Z = parcelRequire("dd29Z");

var $h2QE2 = parcelRequire("h2QE2");

var $f1x6A = parcelRequire("f1x6A");

var $3rvKk = parcelRequire("3rvKk");
function $d4170d0ca473b3a2$export$66c8e3658ad37452(isCMPBoard) {
    const match = (0, $edUVe.useMatch)();
    const { project: project, user: user } = (0, $f1x6A.useBoardAndLocationContext)();
    const isJSMBoard = (0, $3rvKk.useIsJSMBoard)();
    const { queue: queue } = (0, $4R6GH.fg)('jsm_views_configuration_migration') ? (0, $5w1T1.useCurrentQueue)() : {
        queue: undefined
    };
    const isReallyCMPBoard = isCMPBoard !== undefined ? isCMPBoard : !project?.simplified;
    const projectKey = match.params.projectKey ?? '';
    const boardId = match.params.boardId ?? '';
    const category = (0, $1ilU2.toItsmPractice)(match.params.practiceType);
    const { data: jsmFeaturesData } = (0, $4R6GH.fg)('jsm_views_configuration_migration') ? (0, $b2XdI.default)() : {
        data: null
    };
    const isBoardEnabled = isJSMBoard && (0, $4R6GH.fg)('jsm_views_configuration_migration') ? jsmFeaturesData?.['jsm-board']?.status === (0, $3bae7046e293c392$export$e927a5d1b72f0b68) : true;
    return (0, $5uXOq.useMemo)(()=>{
        if (!projectKey && !boardId) throw new Error('useBoardUrl() can only be used with board URLs');
        if (user) return (0, $h2QE2.getUserBoardUrl)(user.accountId, boardId);
        if (queue && (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag')) return `/jira/servicedesk/projects/${projectKey}/${(0, $dd29Z.getQueueFragment)(queue.id, category)}/board/${boardId}`;
        if (isJSMBoard) return isBoardEnabled || !(0, $4R6GH.fg)('jsm_views_configuration_migration') ? (0, $h2QE2.getJSMBoardUrl)(projectKey, boardId) : (0, $h2QE2.getJSMCalendarUrl)(projectKey, boardId);
        return (0, $h2QE2.getBoardUrl)(projectKey, boardId, isReallyCMPBoard);
    }, [
        boardId,
        isJSMBoard,
        isReallyCMPBoard,
        projectKey,
        user,
        isBoardEnabled,
        queue,
        category
    ]);
}

});
parcelRegister("b2XdI", function(module, exports) {

$parcel$export(module.exports, "default", () => $b693b7ac6b5692db$export$2e2bcd8739ae039);

var $6sNnq = parcelRequire("6sNnq");

var $2YP9W = parcelRequire("2YP9W");
const $b693b7ac6b5692db$var$useServiceProjectFeatures = ()=>(0, $2YP9W.useResource)((0, $6sNnq.featuresResource));
var $b693b7ac6b5692db$export$2e2bcd8739ae039 = $b693b7ac6b5692db$var$useServiceProjectFeatures;

});
parcelRegister("6sNnq", function(module, exports) {

$parcel$export(module.exports, "featuresResource", () => $d0a02e466fb63798$export$16f81cc9da2c6c47);

var $9XE6b = parcelRequire("9XE6b");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");


const $d0a02e466fb63798$var$getDataLoader = ()=>(parcelRequire("eYpiZ"));
const $d0a02e466fb63798$var$ONE_DAY_IN_MILLIS = 86400000;
const $d0a02e466fb63798$export$16f81cc9da2c6c47 = (0, $2M1hQ.createResource)({
    type: (0, $68b2e6d16c6e9952$export$3441b129810f29ed),
    getKey: ({ match: match, query: query })=>// projectKey from url path or browse/{issueKey}
        (0, $1nb22.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0],
    getDataLoader: $d0a02e466fb63798$var$getDataLoader,
    maxAge: $d0a02e466fb63798$var$ONE_DAY_IN_MILLIS
});

});
const $68b2e6d16c6e9952$export$3441b129810f29ed = 'SERVICEDESK_FEATURES';

parcelRegister("eYpiZ", function(module, exports) {

let $ae6a4c5f12900e23$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ae6a4c5f12900e23$var$load("kVX56"),
    $ae6a4c5f12900e23$var$load("izbMG")
]).then(()=>parcelRequire('frQmB'));

});



const $3bae7046e293c392$export$b45a36df7873757 = 'alerts';
const $3bae7046e293c392$export$a7952c5a5c371ddd = 'oncall';
const $3bae7046e293c392$export$de0bca182bc46c7f = 'services';
const $3bae7046e293c392$export$ed849d1eb34423e5 = 'similarIssues';
const $3bae7046e293c392$export$d4a1ed8524773042 = 'sentiment-analysis';
const $3bae7046e293c392$export$46f600f4680e5fd0 = 'jsm-ai-context';
const $3bae7046e293c392$export$3d2ce10d3ca55e3c = 'automaticallySetRequestType';
const $3bae7046e293c392$export$cae2404f62c0f4d7 = 'change-management';
const $3bae7046e293c392$export$31ffe79c2b019cf = 'incident-management';
const $3bae7046e293c392$export$3a20074cc38cbf69 = 'problem-management';
const $3bae7046e293c392$export$a364d86306d4a6d4 = 'service-request';
const $3bae7046e293c392$export$71f1a79e03f525 = 'post-incident-review';
const $3bae7046e293c392$export$6860c7a26d6d6d35 = 'csm-customer-context';
const $3bae7046e293c392$export$7c5ee80fcb40e9d3 = 'developer-escalation';
const $3bae7046e293c392$export$28fc94ee6c61f632 = 'products-and-entitlements';
const $3bae7046e293c392$export$93b42272f76473c9 = 'jsm-views';
const $3bae7046e293c392$export$1eb399d8c2d53748 = 'jsm-board';
const $3bae7046e293c392$export$abbcecf25bfa1e87 = 'jsm-calendar';
const $3bae7046e293c392$export$891877b4a4d60ea2 = 'jsm-project-summary';
const $3bae7046e293c392$export$34136c6420474672 = 'journey-builder';
const $3bae7046e293c392$export$66ede2c1de447f8f = 'developer-escalation';
const $3bae7046e293c392$export$c54f3fef3b7893c1 = 'request-type-category'; // remove when cleaning request_type_table_uplift
const $3bae7046e293c392$export$1ee9c534405b9b35 = 'playbooks';
const $3bae7046e293c392$export$ac0832132e8992d7 = 'automation-discoverability';
const $3bae7046e293c392$export$fc77e86331b0e2c7 = 'jcs-customer-support-escalation';
const $3bae7046e293c392$export$e927a5d1b72f0b68 = 'ENABLED';
const $3bae7046e293c392$export$8cd212c10b4124d2 = 'DISABLED';

parcelRegister("5w1T1", function(module, exports) {

$parcel$export(module.exports, "useCurrentQueue", () => $373598bd9a60294b$export$6828a0f92648828d);

var $5uXOq = parcelRequire("5uXOq");

var $bmKPg = parcelRequire("bmKPg");
var $2YP9W = parcelRequire("2YP9W");

var $1ilU2 = parcelRequire("1ilU2");

var $1WlLE = parcelRequire("1WlLE");
const $373598bd9a60294b$export$6828a0f92648828d = ()=>{
    const [queueId] = (0, $bmKPg.usePathParam)('queueId');
    const [practiceType] = (0, $bmKPg.usePathParam)('practiceType');
    const category = (0, $1ilU2.toItsmPractice)(practiceType);
    const { data: allData, loading: loading, error: error, refresh: refresh, update: update } = (0, $2YP9W.useResource)((0, $1WlLE.queuesNavigationItems));
    const categorizedQueues = (0, $5uXOq.useMemo)(()=>allData?.[category]?.queues, [
        allData,
        category
    ]);
    const selectedQueue = categorizedQueues?.find((queue)=>queue.id === Number(queueId));
    const updateCurrentQueue = (data)=>{
        update((currentData)=>({
                ...currentData,
                [category]: {
                    ...currentData[category],
                    queues: categorizedQueues.map((queue)=>{
                        if (queue.id === Number(queueId)) return {
                            ...queue,
                            ...data
                        };
                        return queue;
                    })
                }
            }));
    };
    return {
        queue: selectedQueue,
        loading: loading,
        error: error,
        refreshQueue: refresh,
        updateCurrentQueue: updateCurrentQueue
    };
};

});
parcelRegister("1ilU2", function(module, exports) {

$parcel$export(module.exports, "toItsmPractice", () => $27eaa4458d2c6986$export$1b27246f3c7494c);
$parcel$export(module.exports, "isValidItsmPractice", () => $27eaa4458d2c6986$export$357b94e419749e3d);

var $oCMSG = parcelRequire("oCMSG");
const $27eaa4458d2c6986$export$1b27246f3c7494c = (practiceString)=>{
    switch(practiceString){
        case 'incidents':
            return 0, $oCMSG.INCIDENTS;
        case 'changes':
            return 0, $oCMSG.CHANGES;
        case 'service-requests':
            return 0, $oCMSG.SERVICE_REQUEST;
        case 'problems':
            return 0, $oCMSG.PROBLEMS;
        case 'post-incident-reviews':
            return 0, $oCMSG.POST_INCIDENT_REVIEWS;
        default:
            return 0, $oCMSG.NO_CATEGORY;
    }
};
const $27eaa4458d2c6986$export$357b94e419749e3d = (practiceString)=>{
    switch(practiceString){
        case 0, $oCMSG.INCIDENTS:
        case 0, $oCMSG.CHANGES:
        case 0, $oCMSG.SERVICE_REQUEST:
        case 0, $oCMSG.PROBLEMS:
        case 0, $oCMSG.POST_INCIDENT_REVIEWS:
        case 0, $oCMSG.NO_CATEGORY:
            return true;
        default:
            return false;
    }
};

});

parcelRegister("1WlLE", function(module, exports) {

$parcel$export(module.exports, "queuesNavigationItems", () => $c68314f43531feff$export$4fed8be571897bef);
$parcel$export(module.exports, "priorityGroupResource", () => $c68314f43531feff$export$1f9ab301771fe42e);
$parcel$export(module.exports, "priorityGroupByProjectIdResource", () => $c68314f43531feff$export$f6133a181a1ec201);
$parcel$export(module.exports, "priorityGroupByProjectIdResourceSsr", () => $c68314f43531feff$export$b55fde45b61f13f4);
$parcel$export(module.exports, "issueListSsrResource", () => $c68314f43531feff$export$3d03cbaac8581e65);
$parcel$export(module.exports, "queueSidebarViewAllQueuesResource", () => $c68314f43531feff$export$5b6f88b653545aa1);

var $9XE6b = parcelRequire("9XE6b");

var $jcw0u = parcelRequire("jcw0u");


var $jthxb = parcelRequire("jthxb");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");

var $89SaW = parcelRequire("89SaW");

var $8w6CZ = parcelRequire("8w6CZ");

var $fRrvi = parcelRequire("fRrvi");

const $c68314f43531feff$var$getDataLoader = ()=>(parcelRequire("a2czB"));

const $c68314f43531feff$var$getPriorityGroupDataLoader = ()=>(parcelRequire("dY0qY"));

const $c68314f43531feff$var$fetchIssueListDataLoader = ()=>(parcelRequire("jyyvg"));
const $c68314f43531feff$var$getCombinedProjectKeyAndQueueId = ({ match: match, query: query })=>`${(0, $1nb22.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0]}-${(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(match, 'params.queueId', '')}`;
const $c68314f43531feff$var$getResourceKeyFromProjectKey = ({ match: match, query: query })=>`${(0, $1nb22.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0]}`;
const $c68314f43531feff$export$4fed8be571897bef = (0, $2M1hQ.createResource)({
    type: (0, $8w6CZ.RESOURCE_TYPE_SERVICEDESK_QUEUES_NAVIGATION_ITEMS),
    getKey: $c68314f43531feff$var$getResourceKeyFromProjectKey,
    getDataLoader: $c68314f43531feff$var$getDataLoader,
    maxAge: (0, $8w6CZ.ONE_DAY_IN_MILLIS)
});
const $c68314f43531feff$export$1f9ab301771fe42e = (0, $2M1hQ.createResource)({
    type: (0, $8w6CZ.RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS),
    getKey: $c68314f43531feff$var$getResourceKeyFromProjectKey,
    getDataLoader: $c68314f43531feff$var$getPriorityGroupDataLoader,
    maxAge: (0, $8w6CZ.ONE_DAY_IN_MILLIS),
    /**
	 * This resource will not load in SSR. Because priority group data resides in the JSM Kukama microservice.
	 * If we wanna fetch this resource during SSR, the request we're making from Tesseract -> Kukama is S2S, where Tesseract needs to know cookies information.
	 * We initially skipped SSR for fetching this resource, because we couldn’t retrieve the request cookie from JFE.
	 * Iiuc, the Jira team doesnt doesnt support this due to security concerns (the info is from JSM Queues team).
	 */ isBrowserOnly: true
});
const $c68314f43531feff$var$priorityGroupByProjectIdResourcePayload = {
    type: (0, $8w6CZ.RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS),
    getKey: $c68314f43531feff$var$getResourceKeyFromProjectKey,
    getData: async ({ match: match, query: query, dependencies: dependencies }, { tenantContext: { cloudId: cloudId } })=>{
        const { projectKey: projectKey } = (0, $1nb22.getProjectKeyId)(match, query);
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const { projectId: projectId } = await (0, $jthxb.consumeDependency)(dependencies, (0, $0f463a88567f1621$export$80a60a092d9ab81));
            return (0, $fRrvi.getPriorityGroupDataByProjectId)(projectId, projectKey, cloudId);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'fetchProjectContextError',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            return (0, $fRrvi.getPriorityGroupDataByProjectId)(undefined, projectKey, cloudId);
        }
    },
    maxAge: (0, $8w6CZ.ONE_DAY_IN_MILLIS),
    depends: [
        (0, $0f463a88567f1621$export$80a60a092d9ab81)
    ]
};
const $c68314f43531feff$export$f6133a181a1ec201 = (0, $2M1hQ.createResource)({
    ...$c68314f43531feff$var$priorityGroupByProjectIdResourcePayload,
    isBrowserOnly: true
});
const $c68314f43531feff$export$b55fde45b61f13f4 = (0, $2M1hQ.createResource)($c68314f43531feff$var$priorityGroupByProjectIdResourcePayload);
const $c68314f43531feff$export$3d03cbaac8581e65 = (0, $2M1hQ.createResource)({
    type: (0, $8w6CZ.RESOURCE_TYPE_SERVICEDESK_QUEUES_ISSUE_LIST_SSR),
    getKey: $c68314f43531feff$var$getCombinedProjectKeyAndQueueId,
    getDataLoader: $c68314f43531feff$var$fetchIssueListDataLoader,
    maxAge: 0,
    // run this resource from server only
    skipBrowser: true
});
const $c68314f43531feff$export$5b6f88b653545aa1 = (0, $2M1hQ.createResource)({
    type: (0, $8w6CZ.SERVICEDESK_QUEUES_SIDEBAR_VIEW_ALL_QUEUES),
    getKey: $c68314f43531feff$var$getResourceKeyFromProjectKey,
    getData: async ({ match: match, query: query }, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>{
        const projectKey = $c68314f43531feff$var$getResourceKeyFromProjectKey({
            match: match,
            query: query
        });
        try {
            if (!atlassianAccountId) throw new Error('accountId is missing.');
            const response = await (0, $89SaW.getUserProperty)(atlassianAccountId, `jsm-all-queues-state_is-open-${projectKey}`);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'fetchJsmQueueSidebarViewAllQueuesResourceError',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    },
    maxAge: (0, $8w6CZ.ONE_DAY_IN_MILLIS)
});

});
const $0f463a88567f1621$export$80a60a092d9ab81 = 'PROJECT_CONTEXT';

parcelRegister("jthxb", function(module, exports) {

$parcel$export(module.exports, "consumeDependency", () => $c406e66b8b597668$export$a973ef9e17a326f);
async function $c406e66b8b597668$export$a973ef9e17a326f(dependencies, key) {
    // There is an inflight request, the response is source of truth
    if (dependencies[key]?.loading) return dependencies[key]?.promise;
    if (dependencies[key]?.error) // Our dependency errored out the last time it ran, we don't have the data
    throw dependencies[key]?.error;
    // Last response is what we want
    return dependencies[key]?.data;
}

});

parcelRegister("8w6CZ", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_NAVIGATION_ITEMS", () => $a4c66eaf20e13a4d$export$a401e6d6b205c72b);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS", () => $a4c66eaf20e13a4d$export$2064262c540606ba);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_ISSUE_LIST_SSR", () => $a4c66eaf20e13a4d$export$2733615da5b906f0);
$parcel$export(module.exports, "SERVICEDESK_QUEUES_SIDEBAR_VIEW_ALL_QUEUES", () => $a4c66eaf20e13a4d$export$94bda82b7db2173c);
$parcel$export(module.exports, "ONE_DAY_IN_MILLIS", () => $a4c66eaf20e13a4d$export$5a00268156ea5027);
const $a4c66eaf20e13a4d$export$a401e6d6b205c72b = 'SERVICEDESK_QUEUES_NAVIGATION_ITEMS';
const $a4c66eaf20e13a4d$export$2064262c540606ba = 'SERVICEDESK_QUEUES_PRIORITY_GROUPS';
const $a4c66eaf20e13a4d$export$2733615da5b906f0 = 'SERVICEDESK_QUEUES_ISSUE_LIST_SSR';
const $a4c66eaf20e13a4d$export$94bda82b7db2173c = 'SERVICEDESK_QUEUES_SIDEBAR_VIEW_ALL_QUEUES';
const $a4c66eaf20e13a4d$export$5a00268156ea5027 = 86400000;

});

parcelRegister("fRrvi", function(module, exports) {

$parcel$export(module.exports, "getPriorityGroupDataByProjectId", () => $2d01df2d1057a1ad$export$cf2bd2ec601ed920);

var $aymwz = parcelRequire("aymwz");

var $fn8B5 = parcelRequire("fn8B5");

var $8Uumt = parcelRequire("8Uumt");

var $bFU4G = parcelRequire("bFU4G");

var $5yJb9 = parcelRequire("5yJb9");

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");

var $4R6GH = parcelRequire("4R6GH");
const $2d01df2d1057a1ad$var$fetchGroupsByKey = async (projectKey, cloudId)=>{
    return (0, $7f4tk.default)(`/gateway/api/jsm/queues/cloudid/${cloudId}/api/v1/groups?projectIdOrKey=${projectKey}${(0, $4R6GH.fg)('add-operation-query-param-to-queues-endpoints') ? '&operation=fetchPriorityGroups' : ''}`);
};
const $2d01df2d1057a1ad$var$fetchGroupsById = async (projectId, cloudId)=>{
    return (0, $7f4tk.default)(`/gateway/api/jsm/queues/cloudid/${cloudId}/api/v1/groups?projectId=${projectId}${(0, $4R6GH.fg)('add-operation-query-param-to-queues-endpoints') ? '&operation=fetchPriorityGroupsByProjectId' : ''}`);
};
const $2d01df2d1057a1ad$var$fetchGroupsByIdGraphql = async (projectId, cloudId)=>{
    const projectAri = `ari:cloud:jira:${cloudId}:project/${projectId}`;
    const result = await (0, $8Uumt.fetchQuery)((0, $5yJb9.default)(), (0, $aymwz.default), {
        projectAri: projectAri
    }).toPromise();
    return {
        results: result?.queuesprioritygroups_priorityGroups?.results?.reduce((priorityGroups, priorityGroup)=>{
            // this mapping function is to make types happy
            if (priorityGroup && priorityGroup.id && priorityGroup.name && priorityGroup.category && priorityGroup.queueIds) priorityGroups.push({
                id: priorityGroup.id,
                name: priorityGroup.name,
                category: priorityGroup.category,
                queueIds: priorityGroup.queueIds.reduce((queueIds, queueId)=>{
                    if (queueId !== null && queueId !== undefined) queueIds.push(queueId);
                    return queueIds;
                // we need the below, otherwise reduce things the type is never[]
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                }, []),
                ...priorityGroup.version ? {
                    version: priorityGroup.version
                } : {},
                ...priorityGroup.creationMethod ? {
                    creationMethod: priorityGroup.creationMethod
                } : {}
            });
            return priorityGroups;
        }, // we need the below, otherwise reduce things the type is never[]
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        []) ?? []
    };
};
const $2d01df2d1057a1ad$export$cf2bd2ec601ed920 = async (projectId, projectKey, cloudId)=>{
    const fetchStartTime = performance.now();
    let data;
    if (projectId) {
        (0, $4R6GH.fg)('queues-prioritygroups-relay') ? data = await $2d01df2d1057a1ad$var$fetchGroupsByIdGraphql(projectId, cloudId) : data = await $2d01df2d1057a1ad$var$fetchGroupsById(projectId, cloudId);
        if (!(0, $4R6GH.fg)('add-operation-query-param-to-queues-endpoints')) (0, $bFU4G.addSpanToAll)('fetch', 'fetchPriorityGroupsByProjectId', [
            {
                name: 'network'
            }
        ], fetchStartTime, performance.now());
    } else {
        (0, $jcw0u.default)({
            meta: {
                id: 'fetchPriorityGroupsProjectIdUndefined',
                packageName: 'jiraRouterResourcesServiceDeskQueues',
                teamName: 'jsm-flash'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        data = await $2d01df2d1057a1ad$var$fetchGroupsByKey(projectKey, cloudId);
        if (!(0, $4R6GH.fg)('add-operation-query-param-to-queues-endpoints')) (0, $bFU4G.addSpanToAll)('fetch', 'fetchPriorityGroups', [
            {
                name: 'network'
            }
        ], fetchStartTime, performance.now());
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const processedData = (0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(data.results.map((group)=>({
            ...group,
            queues: group.queueIds || []
        })), 'category');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return processedData;
};

});
parcelRegister("aymwz", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ee8e4029fc17578$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<509a54dc797b22dc5439dcc947ec5646>>
 * @relayHash aa856b961b835b1f9323042c281fa03b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a06f924d3b993614f20cc99cb824d0a15370bb2745568a6f165c081ee7493530
const $2ee8e4029fc17578$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectAri"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "projectId",
                    "variableName": "projectAri"
                }
            ],
            "concreteType": "QueuesPriorityGroupsResults",
            "kind": "LinkedField",
            "name": "queuesprioritygroups_priorityGroups",
            "plural": false,
            "selections": [
                {
                    "concreteType": "QueuesPriorityGroupsResultsGroup",
                    "kind": "LinkedField",
                    "name": "results",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "category"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "queueIds"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "version"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "creationMethod"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "getPriorityGroupDataByProjectIdQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "getPriorityGroupDataByProjectIdQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "a06f924d3b993614f20cc99cb824d0a15370bb2745568a6f165c081ee7493530",
            "metadata": {},
            "name": "getPriorityGroupDataByProjectIdQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$2ee8e4029fc17578$var$node.hash = "e99dcef5a507344c549819dcfbf09d31";
var $2ee8e4029fc17578$export$2e2bcd8739ae039 = $2ee8e4029fc17578$var$node;

});


parcelRegister("a2czB", function(module, exports) {

let $74e3d816256db699$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $74e3d816256db699$var$load("kVX56"),
    $74e3d816256db699$var$load("aG1rf")
]).then(()=>parcelRequire('lini2'));

});

parcelRegister("dY0qY", function(module, exports) {

let $a2b13728cd2933bf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a2b13728cd2933bf$var$load("dg10h").then(()=>parcelRequire('etJR3'));

});

parcelRegister("jyyvg", function(module, exports) {

let $e3cbf4eb1d60bd0a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e3cbf4eb1d60bd0a$var$load("3pKue").then(()=>parcelRequire('bmzqI'));

});



parcelRegister("dd29Z", function(module, exports) {

$parcel$export(module.exports, "QUEUE_ROUTES", () => $10cfdb56a53da9cf$export$410a6306dae101ca);
$parcel$export(module.exports, "navigate", () => $10cfdb56a53da9cf$export$ff7962acd6052c28);
$parcel$export(module.exports, "getQueueFragment", () => $10cfdb56a53da9cf$export$954f428fa284c7);
$parcel$export(module.exports, "getEditQueueFragment", () => $10cfdb56a53da9cf$export$86f6a6d69e87f843);
$parcel$export(module.exports, "getCloneQueueFragment", () => $10cfdb56a53da9cf$export$7a487d215c9c3f76);
$parcel$export(module.exports, "getQueueIssueFragment", () => $10cfdb56a53da9cf$export$773cefb51b60b161);
$parcel$export(module.exports, "getIssueFragment", () => $10cfdb56a53da9cf$export$a796bfaff67c9fae);
$parcel$export(module.exports, "getQueueUrl", () => $10cfdb56a53da9cf$export$a29b42a005fecf0);
$parcel$export(module.exports, "getEditQueueUrlFromManageQueue", () => $10cfdb56a53da9cf$export$91152835d12ca65f);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("9o0uh");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $5viSR = parcelRequire("5viSR");

var $oCMSG = parcelRequire("oCMSG");

var $hzd6p = parcelRequire("hzd6p");
const $10cfdb56a53da9cf$var$LOCATION = 'servicedesk.common.navigation.queues';
let $10cfdb56a53da9cf$var$navigatorPromise;
const $10cfdb56a53da9cf$var$getPushStateNavigator = ()=>{
    if (!$10cfdb56a53da9cf$var$navigatorPromise) $10cfdb56a53da9cf$var$navigatorPromise = (0, $hzd6p.createPushStateNavigator)();
    return $10cfdb56a53da9cf$var$navigatorPromise;
};
const $10cfdb56a53da9cf$export$410a6306dae101ca = {
    [(0, $oCMSG.INCIDENTS)]: 'section/incidents',
    [(0, $oCMSG.CHANGES)]: 'section/changes',
    [(0, $oCMSG.SERVICE_REQUEST)]: 'section/service-requests',
    [(0, $oCMSG.PROBLEMS)]: 'section/problems',
    [(0, $oCMSG.POST_INCIDENT_REVIEWS)]: 'section/post-incident-reviews',
    [(0, $oCMSG.NO_CATEGORY)]: 'queues'
};
const $10cfdb56a53da9cf$var$fromCategory = (category)=>$10cfdb56a53da9cf$export$410a6306dae101ca[category || (0, $oCMSG.NO_CATEGORY)];
const $10cfdb56a53da9cf$export$ff7962acd6052c28 = (projectKey, fragment)=>{
    (0, $5viSR.emitSignal)($10cfdb56a53da9cf$var$LOCATION, {
        projectKey: projectKey,
        fragment: fragment
    });
    return (0, $kVLXA.Observable).fromPromise($10cfdb56a53da9cf$var$getPushStateNavigator()).mergeMap((pushStateNavigator)=>{
        pushStateNavigator.navigateToFragment(fragment);
        return (0, $kVLXA.Observable).empty();
    }).catch(()=>(0, $kVLXA.Observable).empty());
};
const $10cfdb56a53da9cf$export$954f428fa284c7 = (queueId, category)=>{
    const categoryString = $10cfdb56a53da9cf$var$fromCategory(category);
    return queueId != null ? `${categoryString}/custom/${queueId}` : `${categoryString}`;
};
const $10cfdb56a53da9cf$export$86f6a6d69e87f843 = (queueId, category)=>`${$10cfdb56a53da9cf$export$954f428fa284c7(queueId, category)}/edit`;
const $10cfdb56a53da9cf$export$7a487d215c9c3f76 = (queueId, category)=>{
    const categoryString = $10cfdb56a53da9cf$var$fromCategory(category);
    return queueId != null ? `${categoryString}/custom/new?parentId=${queueId}` : `${categoryString}/custom/new`;
};
const $10cfdb56a53da9cf$export$773cefb51b60b161 = (queueId, issueKey, category)=>`${$10cfdb56a53da9cf$export$954f428fa284c7(queueId, category)}/${issueKey}`;
const $10cfdb56a53da9cf$export$a796bfaff67c9fae = (issueKey)=>`${$10cfdb56a53da9cf$export$954f428fa284c7()}/issue/${issueKey}`;
const $10cfdb56a53da9cf$export$a29b42a005fecf0 = ({ projectKey: projectKey, category: category, queueId: queueId, queryParams: queryParams })=>{
    const urlSearchParams = new URLSearchParams();
    if (queryParams) Object.entries(queryParams).forEach(([key, value])=>{
        urlSearchParams.set(key, value);
    });
    const formattedQueryParams = urlSearchParams.toString() ? `?${urlSearchParams.toString()}` : '';
    return `/jira/servicedesk/projects/${projectKey}/${$10cfdb56a53da9cf$export$954f428fa284c7(queueId, category)}${formattedQueryParams}`;
};
const $10cfdb56a53da9cf$export$91152835d12ca65f = (queueId, projectKey, category)=>`/jira/servicedesk/projects/${projectKey}/${$10cfdb56a53da9cf$export$86f6a6d69e87f843(queueId, category)}`;

});
parcelRegister("5viSR", function(module, exports) {

$parcel$export(module.exports, "emitSignal", () => $8dc3d00171ca741d$export$a8a72bca1918549c);
/**
 * A signalling mechanism for Cypress tests.
 *
 * This acts as a bridge between the storybook application and cypress for
 * checking behaviours which cannot be asserted on via the DOM or are
 * otherwise not reflected in application state.
 *
 * This is the 'emit' side of the story. It should be used by
 * production-facing code to emit a signal.
 */ const $8dc3d00171ca741d$var$isProduction = ()=>true;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8dc3d00171ca741d$var$registerSignal = (signal, meta)=>{
    window.cySignals.allSignals.push(signal);
    const signalsByName = window.cySignals.signalsByName;
    if (signalsByName[signal]) signalsByName[signal].push(meta);
    else signalsByName[signal] = [
        meta
    ];
};
const $8dc3d00171ca741d$var$initCySignals = ()=>{
    window.cySignals = {
        signalsByName: {},
        allSignals: []
    };
};
const $8dc3d00171ca741d$export$a8a72bca1918549c = (signal, meta = {})=>{
    if ($8dc3d00171ca741d$var$isProduction()) return;
    if (!window.cySignals) $8dc3d00171ca741d$var$initCySignals();
    $8dc3d00171ca741d$var$registerSignal(signal, meta);
};

});

parcelRegister("hzd6p", function(module, exports) {

$parcel$export(module.exports, "createPushStateNavigator", () => $ddde70bc55609ded$export$d3bf579f8e5cd838);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $6BZYo = parcelRequire("6BZYo");
const $ddde70bc55609ded$var$PUSH_STATE_NAVIGATOR_MODULE = 'servicedesk/internal-api/core/util/push-state-navigator/push-state-navigator';
// Try to require push-state-navigator over 500ms, otherwise we'll fallback.
const $ddde70bc55609ded$var$REQUIRE_TIMEOUT = 100;
const $ddde70bc55609ded$var$REQUIRE_RETRIES = 5;
const $ddde70bc55609ded$export$d3bf579f8e5cd838 = ()=>// eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $6BZYo.loadBridge)({
        name: $ddde70bc55609ded$var$PUSH_STATE_NAVIGATOR_MODULE,
        timeout: $ddde70bc55609ded$var$REQUIRE_TIMEOUT,
        tentatives: $ddde70bc55609ded$var$REQUIRE_RETRIES
    });

});


parcelRegister("h2QE2", function(module, exports) {

$parcel$export(module.exports, "getBoardSettingsHref", () => $34db911e1caaedb7$export$8d54870ff0bbaead);
$parcel$export(module.exports, "isSelected", () => $34db911e1caaedb7$export$e4d153b3e021fb47);
$parcel$export(module.exports, "getBoardUrl", () => $34db911e1caaedb7$export$505a9f131607d070);
$parcel$export(module.exports, "getJSMBoardUrl", () => $34db911e1caaedb7$export$3416b472014eed93);
$parcel$export(module.exports, "getJSMCalendarUrl", () => $34db911e1caaedb7$export$16e1d659b389d4ae);
$parcel$export(module.exports, "getUserBoardUrl", () => $34db911e1caaedb7$export$45f8e28589795b6f);
$parcel$export(module.exports, "getBoardSettingsUrl", () => $34db911e1caaedb7$export$222cc43a27cdf5b1);

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");
function $34db911e1caaedb7$export$8d54870ff0bbaead(view, location) {
    if (((0, $4R6GH.fg)('blu-7261-change-blu-5799-to-support-nav3') || (0, $3HwlS.getWillShowNav4)()) && // Delete line when cleaning up blu-7261
    !$34db911e1caaedb7$var$isServiceDeskLocation(location) && (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route')) {
        const basePath = location.pathname.slice(0, location.pathname.lastIndexOf('/'));
        const query = location.search ? location.search : '';
        return `${basePath}/${view}${query}`;
    }
    return `${location.pathname}?config=${view}`;
}
function $34db911e1caaedb7$export$e4d153b3e021fb47(view, queryConfig = '', pathConfig = '') {
    if (((0, $4R6GH.fg)('blu-7261-change-blu-5799-to-support-nav3') || (0, $3HwlS.getWillShowNav4)()) && // Delete line when cleaning up blu-7261
    (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route')) return pathConfig === view;
    return queryConfig === view;
}
function $34db911e1caaedb7$export$505a9f131607d070(projectKey, boardId, isCMPBoard) {
    return `/jira/software${isCMPBoard ? '/c' : ''}/projects/${projectKey}/boards/${boardId}`;
}
function $34db911e1caaedb7$export$3416b472014eed93(projectKey, boardId) {
    return `/jira/servicedesk/projects/${projectKey}/boards/${boardId}`;
}
function $34db911e1caaedb7$export$16e1d659b389d4ae(projectKey, boardId) {
    return `/jira/servicedesk/projects/${projectKey}/boards/${boardId}/calendar`;
}
function $34db911e1caaedb7$export$45f8e28589795b6f(accountId, boardId) {
    return `/jira/people/${accountId}/boards/${boardId}`;
}
function $34db911e1caaedb7$export$222cc43a27cdf5b1(ordinaryBoardUrl) {
    return `${ordinaryBoardUrl}/settings`;
}
function $34db911e1caaedb7$var$isServiceDeskLocation(location) {
    return location.pathname.includes('/servicedesk');
}

});

parcelRegister("f1x6A", function(module, exports) {

$parcel$export(module.exports, "useBoardAndLocationContext", () => $e82659e28181f12f$export$d2a945b4dfcaff34);

var $gpXo6 = parcelRequire("gpXo6");

var $1J3t1 = parcelRequire("1J3t1");

var $l5L5h = parcelRequire("l5L5h");
const $e82659e28181f12f$export$d2a945b4dfcaff34 = ()=>{
    const isUserLocated = (0, $l5L5h.useIsUserLocatedBoard)();
    // This hook returns project data + board info for project-located boards
    const { data: projectData, error: projectError } = (0, $1J3t1.useJiraSoftwareProjectNavigation)();
    // This hook returns user-located board data
    const { data: userData, error: userError } = (0, $gpXo6.useJiraUserBoardNavigationResource)();
    return {
        project: projectData?.project,
        user: userData?.owner,
        board: isUserLocated ? userData?.boardInfo : projectData?.boardInfo,
        error: isUserLocated ? userError : projectError
    };
};

});
parcelRegister("gpXo6", function(module, exports) {

$parcel$export(module.exports, "useJiraUserBoardNavigationResource", () => $c3c49f06ba708347$export$517acde8347261e3);

var $7xTO3 = parcelRequire("7xTO3");

var $2YP9W = parcelRequire("2YP9W");
const $c3c49f06ba708347$export$517acde8347261e3 = ()=>(0, $2YP9W.useResource)((0, $7xTO3.staticJSWUserBoardSidebarNavigationResource));

});

parcelRegister("l5L5h", function(module, exports) {

$parcel$export(module.exports, "useIsUserLocatedBoard", () => $c0b41c629510b7e8$export$374923c4a1431d8c);

var $5uXOq = parcelRequire("5uXOq");

var $6jY6G = parcelRequire("6jY6G");
const $c0b41c629510b7e8$var$userLocatedBoardRoutes = [
    'rapidboard-user-board',
    'rapidboard-user-backlog',
    'rapidboard-user-board-settings'
];
const $c0b41c629510b7e8$export$374923c4a1431d8c = ()=>{
    const { name: name } = (0, $6jY6G.useCurrentRoute)();
    return (0, $5uXOq.useMemo)(()=>$c0b41c629510b7e8$var$userLocatedBoardRoutes.includes(name), [
        name
    ]);
};

});


parcelRegister("3rvKk", function(module, exports) {

$parcel$export(module.exports, "useIsJSMBoard", () => $f7b28d846fd7ab2d$export$caf439d171aab0ca);

var $5uXOq = parcelRequire("5uXOq");

var $6jY6G = parcelRequire("6jY6G");

var $4R6GH = parcelRequire("4R6GH");

var $k0iPT = parcelRequire("k0iPT");
const $f7b28d846fd7ab2d$export$caf439d171aab0ca = ()=>{
    const { name: name } = (0, $6jY6G.useCurrentRoute)();
    const isJSMBoardRoute = (routeName)=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $k0iPT.JSM_BOARD_ROUTES_SET).has(routeName) : routeName === 'servicedesk-boards';
    return (0, $5uXOq.useMemo)(()=>isJSMBoardRoute(name), [
        name
    ]);
};

});



parcelRegister("l4fDC", function(module, exports) {

$parcel$export(module.exports, "default", () => $285c52b1fe4c8d09$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $285c52b1fe4c8d09$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    displayText: {
        "id": "backlog.header.menu.configure-board-item.display-text",
        "defaultMessage": "Configure board"
    }
});

});


parcelRegister("bcdwp", function(module, exports) {

$parcel$export(module.exports, "CreateBoardMenuItem", () => $a9a6640c869cb525$export$8b66d40068c85a7a);

var $5uXOq = parcelRequire("5uXOq");

var $kJpBP = parcelRequire("kJpBP");

var $2YZCu = parcelRequire("2YZCu");

var $1ADgn = parcelRequire("1ADgn");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $hLpMG = parcelRequire("hLpMG");
function $a9a6640c869cb525$export$8b66d40068c85a7a({ onClosePopup: onClosePopup }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'createBoard clicked',
            actionSubject: 'menuItem'
        }), 'createBoard clicked');
        onClosePopup && onClosePopup();
        (0, $1ADgn.default)().catch((error)=>{
            (0, $2YZCu.default).safeErrorWithoutCustomerData('backlog.modal.create-board.failure', 'Failed to open legacy Create board dialog', error);
        });
    }, [
        createAnalyticsEvent,
        onClosePopup
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        onClick: handleClick
    }, formatMessage((0, $hLpMG.messages).displayText));
}

});
parcelRegister("hLpMG", function(module, exports) {

$parcel$export(module.exports, "messages", () => $039ae69d50f44352$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $039ae69d50f44352$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    displayText: {
        "id": "backlog.header.menu.create-board.display-text",
        "defaultMessage": "Create board"
    }
});

});


parcelRegister("eqhHD", function(module, exports) {

$parcel$export(module.exports, "FullscreenItem", () => $2f64c4b6d458439a$export$ca711206e6b8abca);

var $5uXOq = parcelRequire("5uXOq");

var $kJpBP = parcelRequire("kJpBP");

var $koVbs = parcelRequire("koVbs");

var $g7crU = parcelRequire("g7crU");

var $aCKi5 = parcelRequire("aCKi5");

var $6nTN9 = parcelRequire("6nTN9");
const $2f64c4b6d458439a$export$ca711206e6b8abca = ({ onClosePopup: onClosePopup })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isFullscreen, { setIsFullscreen: setIsFullscreen }] = (0, $g7crU.useIsFullscreen)();
    const toggleFullscreen = (0, $5uXOq.useCallback)(()=>{
        setIsFullscreen(!isFullscreen);
        onClosePopup && onClosePopup();
    }, [
        isFullscreen,
        setIsFullscreen,
        onClosePopup
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aCKi5.ShortcutLabel), {
            text: "Z"
        }),
        onClick: toggleFullscreen,
        "aria-keyshortcuts": "Z"
    }, isFullscreen ? formatMessage((0, $6nTN9.default).exitFullScreen) : formatMessage((0, $6nTN9.default).enterFullScreen));
};

});
parcelRegister("aCKi5", function(module, exports) {

$parcel$export(module.exports, "ShortcutLabel", () => $e8926de4a65ad47f$export$dfa0cc182ab7b0c3);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $e8926de4a65ad47f$export$dfa0cc182ab7b0c3 = ({ text: text })=>// For A11y add `aria-keyshortcuts={yourShortcut}` to the element you are adding this label to
    // Added `aria-hidden` for the screen readers to ignore the label element
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        "aria-hidden": true,
        xcss: $e8926de4a65ad47f$var$ShortcutLabelComponentStyles
    }, text);
const $e8926de4a65ad47f$var$ShortcutLabelComponentStyles = (0, $8CUq3.xcss)({
    display: 'inline-block',
    backgroundColor: 'color.background.neutral',
    borderRadius: 'border.radius.100',
    font: 'font.body.UNSAFE_small',
    paddingTop: 'space.050',
    paddingBottom: 'space.050',
    paddingLeft: 'space.100',
    paddingRight: 'space.100'
});

});

parcelRegister("6nTN9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f2ed9bda0cd8dc3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7f2ed9bda0cd8dc3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    enterFullScreen: {
        "id": "backlog.header.menu.fullscreen-item.enter-full-screen",
        "defaultMessage": "Enter full screen"
    },
    exitFullScreen: {
        "id": "backlog.header.menu.fullscreen-item.exit-full-screen",
        "defaultMessage": "Exit full screen"
    }
});

});


parcelRegister("ctQ5b", function(module, exports) {

$parcel$export(module.exports, "default", () => $290aca59c7cae385$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kJpBP = parcelRequire("kJpBP");

var $koVbs = parcelRequire("koVbs");

var $14uhY = parcelRequire("14uhY");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $lVJAU = parcelRequire("lVJAU");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $7M9S7 = parcelRequire("7M9S7");
const $290aca59c7cae385$export$84a62bf03b005a81 = (boardUrl)=>`${boardUrl}/custom-filters`;
const $290aca59c7cae385$export$538689bb697618b7 = ({ isDisabled: isDisabled })=>{
    const boardId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getRapidViewId));
    const projectKey = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getProjectKey));
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const url = `/jira/software/projects/${projectKey}/settings/boards/${boardId}/custom-filters`;
    const onClick = (0, $5uXOq.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        });
        (0, $14uhY.setReturnToProjectUrl)();
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'clickManageCustomFilterItem');
        push(url);
    }, [
        push,
        url,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        isDisabled: isDisabled,
        onClick: onClick
    }, formatMessage((0, $7M9S7.default).displayText));
};
var $290aca59c7cae385$export$2e2bcd8739ae039 = $290aca59c7cae385$export$538689bb697618b7;

});
parcelRegister("7M9S7", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f9613022e4de36e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1f9613022e4de36e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    displayText: {
        "id": "backlog.header.menu.manage-custom-filters-item.display-text",
        "defaultMessage": "Manage custom filters"
    }
});

});


parcelRegister("8fQBb", function(module, exports) {

$parcel$export(module.exports, "BoardConnectItems", () => $cc7e64a8f648369c$export$2843ddf118c543ac);

var $5uXOq = parcelRequire("5uXOq");

var $9UCCQ = parcelRequire("9UCCQ");

var $fNWqR = parcelRequire("fNWqR");

var $e8X1M = parcelRequire("e8X1M");

var $99Ffx = parcelRequire("99Ffx");

var $fxbvZ = parcelRequire("fxbvZ");
const $cc7e64a8f648369c$export$2843ddf118c543ac = ({ projectKey: projectKey, boardId: boardId, isCompanyManaged: isCompanyManaged, hasOperations: hasOperations })=>{
    const hasToolSections = (0, $fNWqR.useHasToolSections)({
        boardId: boardId,
        projectKey: projectKey,
        mode: 'plan',
        itemLocations: (0, $99Ffx.backlogConnectAppLocations)
    });
    return (hasToolSections || hasOperations) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        hasSeparator: true
    }, isCompanyManaged && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e8X1M.BoardConnectMenuItems), {
        boardId: boardId,
        projectKey: projectKey,
        location: "board-tools-1",
        mode: "plan",
        isTabNavigation: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e8X1M.BoardConnectMenuItems), {
        boardId: boardId,
        projectKey: projectKey,
        location: "view-actions-print",
        mode: "plan",
        isTabNavigation: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e8X1M.BoardConnectMenuItems), {
        boardId: boardId,
        projectKey: projectKey,
        mode: "plan",
        isTabNavigation: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fxbvZ.default), {
        isTabNavigation: true
    }));
};

});

parcelRegister("gCOKH", function(module, exports) {

$parcel$export(module.exports, "BacklogForgeActionMenuItems", () => $f0f38c9a1cab289e$export$6f408483bd5eb443);

var $5uXOq = parcelRequire("5uXOq");


var $b71gk = parcelRequire("b71gk");

var $bv8Hu = parcelRequire("bv8Hu");

var $k2DRb = parcelRequire("k2DRb");

var $5bkvv = parcelRequire("5bkvv");

var $2YP9W = parcelRequire("2YP9W");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");
const $f0f38c9a1cab289e$var$ForgeActionMenuItems = ()=>{
    const { loading: loading, data: extensions } = (0, $2YP9W.useResource)((0, $5bkvv.forgeBacklogModuleResource));
    const extensionData = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getBacklogExtensionData));
    if (loading || !extensions || extensions.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bv8Hu.ForgeActionMenuItems), {
        module: (0, $k2DRb.BACKLOG_ACTION_MODULE),
        analyticsSource: (0, $fcf97b7a09088940$export$53d41ff2666118e1),
        testId: "software-backlog.header.menu.content.forge-items",
        extensions: extensions,
        extensionData: extensionData
    });
};
const $f0f38c9a1cab289e$export$6f408483bd5eb443 = /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        packageName: "software",
        id: "forge-items"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f0f38c9a1cab289e$var$ForgeActionMenuItems, null)));

});


parcelRegister("8dqGW", function(module, exports) {

$parcel$export(module.exports, "BacklogActionForgeRuntimeContainer", () => $48555feb11e5c8ba$export$ab43d403c073d158);

var $5uXOq = parcelRequire("5uXOq");


var $b71gk = parcelRequire("b71gk");

var $84ZsI = parcelRequire("84ZsI");

var $bxgMe = parcelRequire("bxgMe");

var $k2DRb = parcelRequire("k2DRb");
const $48555feb11e5c8ba$export$ab43d403c073d158 = /*#__PURE__*/ (0, $5uXOq.memo)(({ onAppsFinishLoading: onAppsFinishLoading })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        packageName: "software",
        id: "forge-backlog-action-runtime-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $84ZsI.ActionMenuForgeRuntimeContainer), {
        onAppsFinishLoading: onAppsFinishLoading,
        forgeAppRenderer: (0, $bxgMe.AsyncBacklogAction),
        module: (0, $k2DRb.BACKLOG_ACTION_MODULE),
        analyticsSource: (0, $fcf97b7a09088940$export$53d41ff2666118e1)
    }));
});

});
parcelRegister("bxgMe", function(module, exports) {

$parcel$export(module.exports, "AsyncBacklogAction", () => $c73a523fd1551a6d$export$13e411d2616aa5d4);

var $5uXOq = parcelRequire("5uXOq");

var $k2DRb = parcelRequire("k2DRb");

var $lfTZh = parcelRequire("lfTZh");

var $jVbVW = parcelRequire("jVbVW");
const $c73a523fd1551a6d$export$13e411d2616aa5d4 = (props)=>{
    const { extensionData: extensionData } = props;
    const extensionDataValue = (0, $5uXOq.useMemo)(()=>({
            ...extensionData,
            type: (0, $k2DRb.BACKLOG_ACTION_MODULE)
        }), [
        extensionData
    ]);
    const extraProps = (0, $5uXOq.useMemo)(()=>({
            module: (0, $k2DRb.BACKLOG_ACTION_MODULE),
            extensionData: extensionDataValue,
            contextToken: (0, $k2DRb.CONTEXT_TOKEN_TYPE_JIRA)
        }), [
        extensionDataValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "backlog-action",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jVbVW.LazyBoardViewForgeExtension), {
        ...props,
        ...extraProps
    }));
};

});


parcelRegister("lt367", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef9fee212e453f55$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ef9fee212e453f55$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    dropdownAriaLabel: {
        "id": "backlog.header.menu.dropdown-aria-label",
        "defaultMessage": "Backlog menu"
    },
    buttonLabelOld: {
        "id": "backlog.header.menu.button-label-old",
        "defaultMessage": "More"
    },
    buttonLabel: {
        "id": "backlog.header.menu.button-label",
        "defaultMessage": "More actions"
    }
});

});


parcelRegister("jzmeD", function(module, exports) {

$parcel$export(module.exports, "FullscreenButton", () => $e7bca00c8a90878e$export$305be705ce696d42);

var $5uXOq = parcelRequire("5uXOq");

var $99BAr = parcelRequire("99BAr");

var $3HwlS = parcelRequire("3HwlS");

var $iDGXn = parcelRequire("iDGXn");
const $e7bca00c8a90878e$var$getFullscreenRefs = ()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
    Array.from(document.querySelectorAll('[data-fullscreen-id]'));
const $e7bca00c8a90878e$export$305be705ce696d42 = ({ boardId: boardId })=>{
    const { setIsFullscreen: setIsFullscreen } = (0, $iDGXn.useViewSettingsActions)();
    const isFullscreen = (0, $iDGXn.useIsFullscreen)();
    const handleFullscreenToggle = (0, $5uXOq.useCallback)((wasFullscreen)=>{
        setIsFullscreen({
            boardId: boardId,
            isFullscreen: !wasFullscreen
        });
    }, [
        boardId,
        setIsFullscreen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $99BAr.default), {
        testId: "software-backlog.header.actions-bar.fullscreen-button",
        getCustomRefs: $e7bca00c8a90878e$var$getFullscreenRefs,
        withContainerStyles: false,
        onToggle: handleFullscreenToggle,
        isFullscreen: isFullscreen,
        renderAsResponsiveButton: (0, $3HwlS.getWillShowNav4)()
    });
};

});
parcelRegister("99BAr", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6d923fac0cd07eb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $gucb2 = parcelRequire("gucb2");

const $d6d923fac0cd07eb$var$FullscreenButton = ({ testId: testId, onToggle: onToggle, getCustomRefs: getCustomRefs, analyticsAttributes: analyticsAttributes, withContainerStyles: withContainerStyles = true, defaultFullscreen: defaultFullscreen = false, isFullscreen: isFullscreenProp, renderAsResponsiveButton: renderAsResponsiveButton = false, shouldRenderContent: shouldRenderContent = true, isSubtle: isSubtle, isHidden: isHidden })=>{
    const [isFullscreenState, setIsFullscreenState] = (0, $5uXOq.useState)(isFullscreenProp ?? defaultFullscreen);
    const isFullscreen = isFullscreenProp ?? isFullscreenState;
    const handleToggle = (wasFullscreen, globalStyle)=>{
        onToggle(wasFullscreen, globalStyle);
        setIsFullscreenState(!wasFullscreen);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gucb2.default), {
        testId: testId,
        onToggle: handleToggle,
        getCustomRefs: getCustomRefs,
        analyticsAttributes: analyticsAttributes,
        withContainerStyles: withContainerStyles,
        defaultFullscreen: defaultFullscreen,
        isFullscreen: isFullscreen,
        renderAsResponsiveButton: renderAsResponsiveButton,
        shouldRenderContent: shouldRenderContent,
        isSubtle: isSubtle,
        isHidden: isHidden
    });
};
$d6d923fac0cd07eb$var$FullscreenButton.defaultProps = {
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    getCustomRefs: ()=>[],
    analyticsAttributes: {}
};
var $d6d923fac0cd07eb$export$2e2bcd8739ae039 = $d6d923fac0cd07eb$var$FullscreenButton;

});
parcelRegister("gucb2", function(module, exports) {

$parcel$export(module.exports, "default", () => $f59079bf3589c5a6$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $42CjB = parcelRequire("42CjB");

var $5JpK2 = parcelRequire("5JpK2");

var $j2iKG = parcelRequire("j2iKG");

var $3bDjY = parcelRequire("3bDjY");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3Tty1 = parcelRequire("3Tty1");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $g7crU = parcelRequire("g7crU");

var $3HwlS = parcelRequire("3HwlS");

var $8zOmE = parcelRequire("8zOmE");

var $22OQR = parcelRequire("22OQR");

var $6lmg7 = parcelRequire("6lmg7");

var $dCm1o = parcelRequire("dCm1o");

var $gydfO = parcelRequire("gydfO");
const $f59079bf3589c5a6$var$removeFullScreenStyle = (customRefs)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.getElementById('fullscreen-global-style')?.remove();
    if (customRefs) customRefs.forEach((ref)=>{
        if (ref !== null) ref.classList.remove('fullscreen');
    });
};
const $f59079bf3589c5a6$var$FullscreenButton = ({ testId: testId, onToggle: onToggle, getCustomRefs: getCustomRefs, analyticsAttributes: extraAnalyticsAttributes, withContainerStyles: withContainerStyles = true, defaultFullscreen: defaultFullscreen = false, isFullscreen: isFullscreenProp, renderAsResponsiveButton: renderAsResponsiveButton = false, shouldRenderContent: shouldRenderContent = true, isSubtle: isSubtle = false, isHidden: isHidden })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const customRefElements = (0, $5uXOq.useRef)(null);
    const [isFullscreenLayout, { setIsFullscreen: setIsFullScreenLayout }] = (0, $g7crU.useIsFullscreen)();
    let globalStyle = null;
    if ((0, $4R6GH.fg)('blu-5747-fullscreen-in-nav-header')) {
        if (!false) globalStyle = document.createElement('style');
    } else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    globalStyle = document.createElement('style');
    const isFullscreen = (0, $3HwlS.getWillShowNav4)() ? isFullscreenLayout : isFullscreenProp;
    const handleKeysInFullScreen = (0, $5uXOq.useCallback)((e)=>{
        // Ignore if it looks like the user is typing something
        if (e.target instanceof HTMLElement && ([
            'INPUT',
            'TEXTAREA',
            'SELECT'
        ].includes(e.target.tagName.toUpperCase()) || e.target.hasAttribute('contenteditable'))) return;
         // Prevent shortcuts
        const shortcutKeysToPrevent = [
            '/',
            // search
            'h' // help
        ];
        if (shortcutKeysToPrevent.includes(e.key)) e.stopPropagation();
        const navigationShortcuts = [
            '1',
            '2',
            '3',
            '4' // number keys
        ];
        if (!(0, $3HwlS.getWillShowNav4)() && navigationShortcuts.includes(e.key)) {
            // In Nav4 these keyboard shortcuts are rendered by the tab navigation
            // so they are not available in fullscreen mode
            onToggle(true, globalStyle ?? undefined);
            const customRefs = customRefElements.current;
            $f59079bf3589c5a6$var$removeFullScreenStyle(customRefs);
        }
    }, [
        globalStyle,
        onToggle
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isFullscreen) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window?.addEventListener('keydown', handleKeysInFullScreen, true);
        else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window?.removeEventListener('keydown', handleKeysInFullScreen, true);
         // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        return ()=>window?.removeEventListener('keydown', handleKeysInFullScreen, true);
    }, [
        isFullscreen,
        handleKeysInFullScreen
    ]);
    const createFullScreenStyle = (0, $5uXOq.useCallback)(()=>{
        const customElements = customRefElements.current;
        const hiddenStyles = "#ak-jira-navigation, #ak-side-navigation, #right-sidebar-panel-wrapper, [data-skip-link-wrapper='true'] { display: none }"; // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const hiddenStylesNode = document.createTextNode(hiddenStyles);
        if (globalStyle) {
            globalStyle.id = 'fullscreen-global-style';
            globalStyle.appendChild(hiddenStylesNode);
        }
        if (customElements) customElements.forEach((ref)=>{
            if (ref !== null) ref.classList.add('fullscreen');
        });
        if (globalStyle) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.head?.appendChild(globalStyle);
    }, [
        globalStyle
    ]);
    const onClick = (event, analyticsEvent)=>{
        if ((0, $3HwlS.getWillShowNav4)()) {
            const analyticsAttributes = {
                ...extraAnalyticsAttributes,
                expandToFullscreen: !isFullscreenLayout
            };
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'fullscreenButton', analyticsAttributes);
            setIsFullScreenLayout(!isFullscreenLayout);
            onToggle(!isFullscreenLayout);
        } else {
            customRefElements.current = getCustomRefs();
            const customElements = customRefElements.current;
            const analyticsAttributes = {
                ...extraAnalyticsAttributes,
                expandToFullscreen: !isFullscreen
            };
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'fullscreenButton', analyticsAttributes);
            onToggle(isFullscreen, globalStyle ?? undefined);
            if (isFullscreen) $f59079bf3589c5a6$var$removeFullScreenStyle(customElements);
            else createFullScreenStyle();
        }
    };
    (0, $5uXOq.useEffect)(()=>{
        customRefElements.current = getCustomRefs();
        const customElements = customRefElements.current;
        if (isFullscreen) createFullScreenStyle();
        else $f59079bf3589c5a6$var$removeFullScreenStyle(customElements);
        return ()=>$f59079bf3589c5a6$var$removeFullScreenStyle(customElements);
    }, [
        createFullScreenStyle,
        getCustomRefs,
        isFullscreen
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (defaultFullscreen) createFullScreenStyle();
         // Empty dependency array to only apply fullscreen styling once (on mount).
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // remove this useEffect when cleaning up blu-5747-fullscreen-in-nav-header
    (0, $5uXOq.useEffect)(()=>{
        // exit fullscreen mode when moving to a different page
        return ()=>{
            if ((0, $3HwlS.getWillShowNav4)() && !(0, $4R6GH.fg)('blu-5747-fullscreen-in-nav-header')) setIsFullScreenLayout(false);
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const renderButtonWithTooltip = ()=>{
        if ((0, $dCm1o.isVisualRefreshEnabled)()) {
            if ((0, $4R6GH.fg)('blu-5747-fullscreen-in-nav-header')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                    xcss: $f59079bf3589c5a6$var$KeyboardShortcutContainer
                }, formatMessage(isFullscreen ? (0, $gydfO.default).exitFullScreen : (0, $gydfO.default).enterFullScreen), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                    xcss: $f59079bf3589c5a6$var$KeyboardShortcut
                }, formatMessage((0, $gydfO.default).fullScreenShortcut))),
                position: "top"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
                ...withContainerStyles ? {
                    testId: testId
                } : {
                    testId: 'platform.ui.fullscreen-button.fullscreen-button'
                },
                onClick: onClick,
                "aria-keyshortcuts": "Z",
                iconBefore: isFullscreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j2iKG))), {
                    label: formatMessage((0, $gydfO.default).exitFullScreen),
                    spacing: "spacious",
                    color: (0, $4R6GH.fg)('camptasks1101-update-color-tokens-of-icons') ? "var(--ds-icon-subtle, #626F86)" : 'currentColor'
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5JpK2))), {
                    label: formatMessage((0, $gydfO.default).enterFullScreen),
                    spacing: "spacious",
                    color: (0, $4R6GH.fg)('camptasks1101-update-color-tokens-of-icons') ? "var(--ds-icon-subtle, #626F86)" : 'currentColor'
                }),
                appearance: isSubtle ? 'subtle' : 'default',
                "aria-hidden": isHidden,
                tabIndex: isHidden ? -1 : 0
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
                ...withContainerStyles ? {
                    testId: testId
                } : {
                    testId: 'platform.ui.fullscreen-button.fullscreen-button'
                },
                label: isFullscreen ? formatMessage((0, $gydfO.default).exitFullScreen) : formatMessage((0, $gydfO.default).enterFullScreen),
                onClick: onClick,
                icon: isFullscreen ? (0, (/*@__PURE__*/$parcel$interopDefault($j2iKG))) : (0, (/*@__PURE__*/$parcel$interopDefault($5JpK2))),
                appearance: isSubtle ? 'subtle' : 'default',
                isTooltipDisabled: false,
                "aria-hidden": isHidden,
                tabIndex: isHidden ? -1 : 0
            });
        }
        if (renderAsResponsiveButton && !(0, $dCm1o.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6lmg7.ResponsiveButton), {
            label: isFullscreen ? formatMessage((0, $gydfO.default).exitFullScreen) : formatMessage((0, $gydfO.default).enterFullScreen),
            icon: isFullscreen ? (0, (/*@__PURE__*/$parcel$interopDefault($j2iKG))) : (0, (/*@__PURE__*/$parcel$interopDefault($5JpK2))),
            onClick: onClick,
            testId: testId ?? 'platform.ui.fullscreen-button.fullscreen-button',
            "aria-hidden": isHidden,
            tabIndex: isHidden ? -1 : 0
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage(isFullscreen ? (0, $gydfO.default).exitFullScreen : (0, $gydfO.default).enterFullScreen),
            position: "top-end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            ...withContainerStyles ? {
                testId: testId
            } : {
                testId: 'platform.ui.fullscreen-button.fullscreen-button'
            },
            appearance: "subtle",
            onClick: onClick,
            iconBefore: isFullscreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j2iKG))), {
                color: "var(--ds-icon, #44546F)",
                label: formatMessage((0, $gydfO.default).exitFullScreen),
                spacing: "spacious"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5JpK2))), {
                color: "var(--ds-icon, #44546F)",
                label: formatMessage((0, $gydfO.default).enterFullScreen),
                spacing: "spacious"
            }),
            "aria-hidden": isHidden,
            tabIndex: isHidden ? -1 : 0
        }));
    };
    const keyMap = {
        z: {
            callback: ()=>{
                setIsFullScreenLayout(!isFullscreenLayout);
            }
        }
    };
    if (!shouldRenderContent) return null;
    return withContainerStyles ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f59079bf3589c5a6$var$FullscreenButtonContainer, {
        "data-testid": "platform.ui.fullscreen-button.fullscreen-button"
    }, renderButtonWithTooltip(), (0, $3HwlS.getWillShowNav4)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Tty1.default), {
        keyMap: keyMap
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, renderButtonWithTooltip(), (0, $3HwlS.getWillShowNav4)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Tty1.default), {
        keyMap: keyMap
    }));
};
var $f59079bf3589c5a6$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $f59079bf3589c5a6$var$FullscreenButton;
const $f59079bf3589c5a6$var$FullscreenButtonContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1sit _1e0c116y _bfhk1bhr _16qs1cd0",
            __cmplp.className
        ])
    });
});
const $f59079bf3589c5a6$var$KeyboardShortcutContainer = (0, $8CUq3.xcss)({
    display: 'flex',
    lineHeight: 'space.200',
    alignItems: 'center',
    paddingBottom: 'space.025',
    paddingTop: 'space.025'
});
const $f59079bf3589c5a6$var$KeyboardShortcut = (0, $8CUq3.xcss)({
    border: `1px solid ${"var(--ds-text-inverse, #FFFFFF)"}`,
    borderRadius: '2px',
    marginLeft: 'space.050',
    paddingTop: 'space.025',
    paddingBottom: 'space.025',
    paddingRight: 'space.100',
    paddingLeft: 'space.100',
    lineHeight: 'space.200'
});

});
parcelRegister("5JpK2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::95f2961def649e58284c9134f09a8716>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $42c51f70ef43f1c0$var$_react = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $42c51f70ef43f1c0$var$_growDiagonal = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("l14Zy")));

var $42c51f70ef43f1c0$var$_actualSize = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("6LXPU")));
function $42c51f70ef43f1c0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for GrowDiagonalIcon.
 * This component is GrowDiagonalIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesActualSizeIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $42c51f70ef43f1c0$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $42c51f70ef43f1c0$var$_react.default.createElement($42c51f70ef43f1c0$var$_growDiagonal.default, Object.assign({
        LEGACY_fallbackIcon: $42c51f70ef43f1c0$var$_actualSize.default
    }, props));
$42c51f70ef43f1c0$var$GrowDiagonalIcon.Name = 'GrowDiagonalIconMigration';
var $42c51f70ef43f1c0$var$_default = module.exports.default = $42c51f70ef43f1c0$var$GrowDiagonalIcon;

});

parcelRegister("j2iKG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1977529ed36a56b31b9b9f03121ff6d7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ddbcbff50c42c269$var$_react = $ddbcbff50c42c269$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ddbcbff50c42c269$var$_shrinkDiagonal = $ddbcbff50c42c269$var$_interopRequireDefault((parcelRequire("8KRBa")));

var $ddbcbff50c42c269$var$_fitToPage = $ddbcbff50c42c269$var$_interopRequireDefault((parcelRequire("2bcm3")));
function $ddbcbff50c42c269$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShrinkDiagonalIcon.
 * This component is ShrinkDiagonalIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesFitToPageIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shrinking the height and width of modals, panels, media, or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ddbcbff50c42c269$var$ShrinkDiagonalIcon = (props)=>/*#__PURE__*/ $ddbcbff50c42c269$var$_react.default.createElement($ddbcbff50c42c269$var$_shrinkDiagonal.default, Object.assign({
        LEGACY_fallbackIcon: $ddbcbff50c42c269$var$_fitToPage.default
    }, props));
$ddbcbff50c42c269$var$ShrinkDiagonalIcon.Name = 'ShrinkDiagonalIconMigration';
var $ddbcbff50c42c269$var$_default = module.exports.default = $ddbcbff50c42c269$var$ShrinkDiagonalIcon;

});

parcelRegister("6lmg7", function(module, exports) {

$parcel$export(module.exports, "ResponsiveButton", () => $aeaed609d1db7293$export$47e82d861696e68c);
$parcel$export(module.exports, "ResponsiveLinkButton", () => $aeaed609d1db7293$export$50fd17babcd996ef);

var $5uXOq = parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");
var $42CjB = parcelRequire("42CjB");
var $1GGwS = parcelRequire("1GGwS");
var $krXdA = parcelRequire("krXdA");

var $f5TWP = parcelRequire("f5TWP");

var $1kVqg = parcelRequire("1kVqg");
var $oGXFy = parcelRequire("oGXFy");

var $3bDjY = parcelRequire("3bDjY");

var $hCCtP = parcelRequire("hCCtP");

const $aeaed609d1db7293$export$47e82d861696e68c = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { icon: icon, label: label, iconAfter: iconAfter, breakpoint: breakpoint = 'lg', appearance: appearance, testId: testId, 'aria-label': ariaLabel, iconButtonSpacing: iconButtonSpacing, buttonSpacing: buttonSpacing, isThemed: isThemed, ...restProps } = props;
    const mediaQueryBreakpoint = (0, $oGXFy.UNSAFE_useMediaQuery)(`above.${breakpoint}`, (event)=>setIsAboveBreakpoint(event.matches));
    const [isAboveBreakpoint, setIsAboveBreakpoint] = (0, $5uXOq.useState)(mediaQueryBreakpoint?.matches);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1kVqg.Show), {
        below: breakpoint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        ...restProps,
        icon: icon,
        appearance: appearance ?? 'default',
        label: label,
        testId: `${testId ?? (0, $7c15fdea32a398a0$export$9c51afe8741be906)}.collapsed`,
        ref: !isAboveBreakpoint ? ref : undefined,
        spacing: iconButtonSpacing
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1kVqg.Show), {
        above: breakpoint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        ...restProps,
        iconBefore: icon,
        iconAfter: iconAfter,
        appearance: appearance ?? 'default',
        testId: `${testId ?? (0, $7c15fdea32a398a0$export$9c51afe8741be906)}.expanded`,
        ref: isAboveBreakpoint ? ref : undefined,
        "aria-label": ariaLabel,
        spacing: buttonSpacing
    }, label)));
});
const $aeaed609d1db7293$export$50fd17babcd996ef = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { icon: icon, label: label, iconAfter: iconAfter, breakpoint: breakpoint = 'lg', appearance: appearance, testId: testId, 'aria-label': ariaLabel, iconButtonSpacing: iconButtonSpacing, buttonSpacing: buttonSpacing, isThemed: isThemed, ...restProps } = props;
    const mediaQueryBreakpoint = (0, $oGXFy.UNSAFE_useMediaQuery)(`above.${breakpoint}`, (event)=>setIsAboveBreakpoint(event.matches));
    const [isAboveBreakpoint, setIsAboveBreakpoint] = (0, $5uXOq.useState)(mediaQueryBreakpoint?.matches);
    const IconButtonComponent = isThemed ? (0, $hCCtP.ThemedLinkIconButton) : (0, $krXdA.default);
    const ButtonComponent = isThemed ? (0, $hCCtP.ThemedLinkButton) : (0, $1GGwS.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1kVqg.Show), {
        below: breakpoint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IconButtonComponent, {
        ...restProps,
        icon: icon,
        appearance: appearance ?? 'default',
        label: label,
        testId: `${testId ?? (0, $7c15fdea32a398a0$export$9c51afe8741be906)}.collapsed`,
        href: restProps.href,
        ref: !isAboveBreakpoint ? ref : undefined,
        spacing: iconButtonSpacing
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1kVqg.Show), {
        above: breakpoint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ButtonComponent, {
        ...restProps,
        iconBefore: icon,
        iconAfter: iconAfter,
        appearance: appearance ?? 'default',
        testId: `${testId ?? (0, $7c15fdea32a398a0$export$9c51afe8741be906)}.expanded`,
        href: restProps.href,
        ref: isAboveBreakpoint ? ref : undefined,
        "aria-label": ariaLabel,
        spacing: buttonSpacing
    }, label)));
});

});
const $7c15fdea32a398a0$export$9c51afe8741be906 = 'responsive-button.ui.responsive-button';


parcelRegister("gydfO", function(module, exports) {

$parcel$export(module.exports, "default", () => $50014cef8f43c127$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $50014cef8f43c127$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    enterFullScreen: {
        "id": "platform.fullscreen-button.enter-full-screen",
        "defaultMessage": "Enter full screen"
    },
    exitFullScreen: {
        "id": "platform.fullscreen-button.exit-full-screen",
        "defaultMessage": "Exit full screen"
    },
    fullScreenShortcut: {
        "id": "platform.fullscreen-button.full-screen-shortcut",
        "defaultMessage": "Z"
    }
});

});




parcelRegister("i03cI", function(module, exports) {

$parcel$export(module.exports, "InsightsButton", () => $8350c37f9ee6e208$export$95e4a3c3bc863d9c);

var $5uXOq = parcelRequire("5uXOq");

var $1Klyc = parcelRequire("1Klyc");

var $7BuUr = parcelRequire("7BuUr");

var $cE2Qr = parcelRequire("cE2Qr");


var $3t5QD = parcelRequire("3t5QD");

var $5PP3a = parcelRequire("5PP3a");


var $fSgHa = parcelRequire("fSgHa");
const $8350c37f9ee6e208$export$95e4a3c3bc863d9c = ({ onToggle: onToggle, isInsightsPanelOpen: isInsightsPanelOpen, boardId: boardId, edition: edition = null, isThemed: isThemed = false })=>{
    const isSupported = (0, $7BuUr.useIsCurrentBrowserSupported)();
    const isCMPBacklog = (0, $fSgHa.useIsCMPBacklog)();
    const [nudgeStep] = (0, $cE2Qr.useNudgeStep)();
    const onToggleHandler = (0, $5uXOq.useCallback)(()=>{
        onToggle((0, $c35fd6591a78fffe$export$29d7f2210b16d662));
    }, [
        onToggle
    ]);
    if (!isSupported) return null;
    if (!edition) return null;
    return !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3t5QD.ConditionalNudgeWrapper), {
        Wrapper: (0, $5PP3a.BacklogInsightsNudgeAsync),
        conditionsToApplyWrapper: nudgeStep === (0, $dbbf68c32d8c4308$export$1c7a80b00ad9619)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Klyc.BacklogInsightsButton), {
        isSimplifiedProject: !isCMPBacklog,
        isOpen: isInsightsPanelOpen,
        isCompact: false,
        boardId: Number(boardId),
        edition: edition,
        onToggle: onToggleHandler,
        isThemed: isThemed
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Klyc.BacklogInsightsButton), {
        isSimplifiedProject: !isCMPBacklog,
        isOpen: isInsightsPanelOpen,
        isCompact: false,
        boardId: Number(boardId),
        edition: edition,
        onToggle: onToggleHandler
    });
};

});
parcelRegister("1Klyc", function(module, exports) {

$parcel$export(module.exports, "BacklogInsightsButton", () => $a676123686368d41$export$fc456a966efbe170);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");


var $9Y7dM = parcelRequire("9Y7dM");


var $9YlLW = parcelRequire("9YlLW");

var $7BuUr = parcelRequire("7BuUr");

var $0241A = parcelRequire("0241A");

var $6OlO8 = parcelRequire("6OlO8");

var $cOddg = parcelRequire("cOddg");

var $1UEsW = parcelRequire("1UEsW");

var $gkPFQ = parcelRequire("gkPFQ");

var $2KxPr = parcelRequire("2KxPr");

var $6f6NP = parcelRequire("6f6NP");

var $ebnTF = parcelRequire("ebnTF");

var $apoVO = parcelRequire("apoVO");

var $g5uUm = parcelRequire("g5uUm");

var $koVbs = parcelRequire("koVbs");

var $3HwlS = parcelRequire("3HwlS");

var $cfDZ3 = parcelRequire("cfDZ3");

var $iXVV6 = parcelRequire("iXVV6");

var $dCm1o = parcelRequire("dCm1o");

var $4mJDy = parcelRequire("4mJDy");

var $aokXg = parcelRequire("aokXg");
const $a676123686368d41$var$ButtonTooltip = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $aokXg.default).tooltip)
    }, children);
};
const $a676123686368d41$var$BacklogInsightsButtonComponent = ({ isCompact: isCompact = false, isSimplifiedProject: isSimplifiedProject, isOpen: isOpen, boardId: boardId, onToggle: onToggle, edition: edition, projectId: projectId, isThemed: isThemed })=>{
    const userLocation = (0, $cfDZ3.getUserLocation)();
    const isSupported = (0, $7BuUr.useIsCurrentBrowserSupported)();
    const [isOnboardingApplicable, setIsOnboardingApplicable] = (0, $5uXOq.useState)(false);
    const markOnboardingApplicable = (0, $5uXOq.useCallback)(()=>setIsOnboardingApplicable(true), []);
    const markOnboardingInapplicable = (0, $5uXOq.useCallback)(()=>setIsOnboardingApplicable(false), []);
    const [{ info: { isAnyLevelOfAdmin: isAnyLevelOfAdmin, isProjectType: isProjectType, uniqueId: uniqueId }, data: { hasPermission: hasPermission } }, { refreshUniqueId: refreshUniqueId, onDataUpdatedCallback: onDataUpdatedCallback, updateIsDeepLinking: updateIsDeepLinking }] = (0, $6f6NP.useInsightsContainer)();
    (0, $5uXOq.useEffect)(()=>{
        if (!isOpen) updateIsDeepLinking(false);
    }, [
        updateIsDeepLinking,
        isOpen
    ]);
    // refresh experience when insights (panel) is closed
    (0, $0241A.useValueChangeEffect)({
        listener: isOpen,
        callback: (current, previous)=>{
            if (current === false && previous === true) refreshUniqueId();
        }
    }, [
        refreshUniqueId
    ]);
    const currentPermissionStatus = (0, $ebnTF.getTextValue)(hasPermission, (0, $9Y7dM.permissionStatus).LOADING);
    const location = (0, $dCm1o.isVisualRefreshEnabled)() ? (0, $f43e6cbc56ecd5ed$export$7278886766e0567e) : undefined;
    return isSupported ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            boardId: boardId,
            edition: edition,
            experienceId: uniqueId,
            projectId: projectId,
            userLocation: userLocation
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gkPFQ.InsightsSpotlight), {
        onOpenInsightsPanel: ()=>!isOpen && onToggle(),
        onDismiss: markOnboardingInapplicable,
        isOnboardingApplicable: isOnboardingApplicable
    }), currentPermissionStatus === (0, $9Y7dM.permissionStatus).LOADING && (isSimplifiedProject ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cOddg.CheckSimplifiedDataPermission), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cOddg.CheckClassicViewAggregatedDataPermission), {
        boardId: boardId,
        userLocation: userLocation,
        onPermissionLoaded: onDataUpdatedCallback('hasPermission'),
        onInsightsEnabledWithoutPermission: markOnboardingApplicable
    })), (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g5uUm.InsightsButton), {
        boardId: boardId,
        isAnyLevelOfAdmin: !isSimplifiedProject && isAnyLevelOfAdmin,
        isHidden: !isProjectType,
        isInsightsPanelOpen: isOpen,
        isOnboardingDisabled: !isSimplifiedProject ? currentPermissionStatus !== (0, $9Y7dM.permissionStatus).ALLOWED : undefined,
        onToggle: onToggle,
        location: location,
        isThemed: isThemed
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g5uUm.InsightsButton), {
        boardId: boardId,
        isAnyLevelOfAdmin: !isSimplifiedProject && isAnyLevelOfAdmin,
        isCompact: isCompact,
        isHidden: !isProjectType,
        isInsightsPanelOpen: isOpen,
        isOnboardingDisabled: !isSimplifiedProject ? currentPermissionStatus !== (0, $9Y7dM.permissionStatus).ALLOWED : undefined,
        onToggle: onToggle,
        renderTooltip: $a676123686368d41$var$ButtonTooltip,
        location: location
    })) : null;
};
const $a676123686368d41$var$BacklogInsightsButtonWithContainer = (props)=>{
    const scope = (0, $6OlO8.buildBacklogScopeName)({
        isSimplifiedProject: props.isSimplifiedProject,
        boardId: props.boardId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $apoVO.InsightsContainer), {
        scope: scope,
        packageName: (0, $b0e6fec6a4686296$export$d3996f57ffa8448f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a676123686368d41$var$BacklogInsightsButtonComponent, props));
};
const $a676123686368d41$var$BacklogInsightsButtonFinal = $a676123686368d41$var$BacklogInsightsButtonWithContainer;
const $a676123686368d41$var$SafeBacklogInsightsButton = (0, $2KxPr.withComponentSafety)($a676123686368d41$var$BacklogInsightsButtonFinal, {
    condition: ({ boardId: boardId })=>(0, $9YlLW.isValidBoardId)({
            boardId: boardId
        }),
    location: (0, $4mJDy.BACKLOG_BUTTON_ID),
    message: ({ boardId: boardId })=>`Backlog button received invalid boardId: ${boardId}`
});
const $a676123686368d41$export$fc456a966efbe170 = (0, $1UEsW.WithInsightsErrorBoundary)($a676123686368d41$var$SafeBacklogInsightsButton, (0, $b0e6fec6a4686296$export$1269ea4f2b198811), (0, $b0e6fec6a4686296$export$d3996f57ffa8448f));

});
parcelRegister("9Y7dM", function(module, exports) {

$parcel$export(module.exports, "permissionStatus", () => $0d3bfc9bd66c1fa3$export$b7019a8563593449);
const $0d3bfc9bd66c1fa3$export$b7019a8563593449 = {
    LOADING: 'LOADING',
    ALLOWED: 'ALLOWED',
    DISALLOWED: 'DISALLOWED'
};

});

const $f43e6cbc56ecd5ed$export$596021054ee994de = 'backlog';
const $f43e6cbc56ecd5ed$export$20548c7afd11b51e = 'kanban';
const $f43e6cbc56ecd5ed$export$a26d014939cffdb = 'scrum';
const $f43e6cbc56ecd5ed$export$7278886766e0567e = 'backlog-visual-refresh';
const $f43e6cbc56ecd5ed$export$c54b080144f4f954 = 'kanban-visual-refresh';
const $f43e6cbc56ecd5ed$export$9fd46aa549776647 = 'scrum-visual-refresh';

parcelRegister("7BuUr", function(module, exports) {

$parcel$export(module.exports, "useIsCurrentBrowserSupported", () => $8c56e783e1a84cd8$export$e2f83ae69f04608f);

var $5uXOq = parcelRequire("5uXOq");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8c56e783e1a84cd8$var$isDefined = (value)=>value !== null && value !== undefined;
const $8c56e783e1a84cd8$var$isCurrentBrowserSupported = ()=>{
    // Supported from:
    // Chrome 66
    // Safari 12.1
    // Edge 16
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (!$8c56e783e1a84cd8$var$isDefined(window?.AbortController)) return false;
    return true;
};
const $8c56e783e1a84cd8$export$e2f83ae69f04608f = ()=>{
    const isSupported = (0, $5uXOq.useMemo)(()=>$8c56e783e1a84cd8$var$isCurrentBrowserSupported(), []);
    return isSupported;
};

});

parcelRegister("0241A", function(module, exports) {

$parcel$export(module.exports, "useValueChangeEffect", () => $bc4d44bb107dee16$export$7dd9a2cc149d56b3);

var $5uXOq = parcelRequire("5uXOq");
const $bc4d44bb107dee16$export$7dd9a2cc149d56b3 = ({ listener: listener, callback: callback }, deps = [])=>{
    const previous = (0, $5uXOq.useRef)(listener);
    (0, $5uXOq.useEffect)(()=>{
        if (listener !== previous.current) callback(listener, previous.current);
        previous.current = listener;
    /* We do not memoize the callback as this will change every render
		 * But it is important to pass in all dependencies used in the callback */ // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        listener,
        ...deps
    ]);
};

});

parcelRegister("6OlO8", function(module, exports) {

$parcel$export(module.exports, "buildBoardScopeName", () => $9fd1aa0f281e7d95$export$7cfa8d622acbc99f);
$parcel$export(module.exports, "buildBacklogScopeName", () => $9fd1aa0f281e7d95$export$68610636ce5df399);

const $9fd1aa0f281e7d95$export$7cfa8d622acbc99f = ({ isSimplifiedProject: isSimplifiedProject, boardId: boardId })=>`${isSimplifiedProject ? (0, $b0e6fec6a4686296$export$8e66b21ec141a0bd) : (0, $b0e6fec6a4686296$export$c9290acd1ba498ff)}-boardId:${boardId}`;
const $9fd1aa0f281e7d95$export$68610636ce5df399 = ({ isSimplifiedProject: isSimplifiedProject, boardId: boardId })=>`${isSimplifiedProject ? (0, $b0e6fec6a4686296$export$75eb9639a5b0ba25) : (0, $b0e6fec6a4686296$export$2fd6d7f902b01d67)}-boardId:${boardId}`;

});

parcelRegister("cOddg", function(module, exports) {

$parcel$export(module.exports, "CheckClassicViewAggregatedDataPermission", () => $09f9796263d4f1f9$export$379f6e97a42d4a9d);
$parcel$export(module.exports, "CheckSimplifiedDataPermission", () => $09f9796263d4f1f9$export$b5e65dc6f010c84c);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");


var $9Y7dM = parcelRequire("9Y7dM");

var $dfjss = parcelRequire("dfjss");

var $iuEfD = parcelRequire("iuEfD");

var $6WV5x = parcelRequire("6WV5x");

var $47u1P = parcelRequire("47u1P");

var $7aoh6 = parcelRequire("7aoh6");
const $09f9796263d4f1f9$export$379f6e97a42d4a9d = ({ boardId: boardId, userLocation: userLocation, onPermissionLoaded: onPermissionLoaded, onInsightsEnabledWithoutPermission: onInsightsEnabledWithoutPermission })=>{
    const eventFrom = (0, $dfjss.getBoardOrBacklogFromLocation)(userLocation);
    const actionSubject = `${(0, $b0e6fec6a4686296$export$d3996f57ffa8448f)}.${eventFrom}`;
    const [{ data: hasPermission, loading: loading, fetched: fetched, aborted: aborted, hasError: hasError }] = (0, $iuEfD.useFetch)({
        onFetch: (options)=>(0, $6WV5x.fetchInsightPermission)({
                boardId: boardId
            }, options),
        browserMetricsKey: `${actionSubject}.${(0, $7aoh6.INSIGHT_PERMISSION_ACTION_SUBJECT_ID)}`,
        analyticsTracking: {
            actionSubject: `${actionSubject}.${(0, $7aoh6.INSIGHT_PERMISSION_ACTION_SUBJECT_ID)}`,
            packageName: (0, $b0e6fec6a4686296$export$d3996f57ffa8448f)
        },
        loggingKey: (0, $7aoh6.INSIGHT_PERMISSION_ACTION_SUBJECT_ID)
    }, []);
    const [_, setShouldUseJQLData] = (0, $47u1P.useLocalStorage)((0, $7aoh6.USE_JQL_STORAGE).namespace, (0, $7aoh6.USE_JQL_STORAGE).key, {
        defaultValue: false
    });
    (0, $5uXOq.useEffect)(()=>{
        if (loading) onPermissionLoaded((0, $9Y7dM.permissionStatus).LOADING);
        if (fetched && !hasError && !aborted) {
            if (hasPermission) {
                onPermissionLoaded((0, $9Y7dM.permissionStatus).ALLOWED);
                setShouldUseJQLData((0, $4R6GH.fg)('insights-use_jql_query_for_enabled_users'));
            } else {
                onPermissionLoaded((0, $9Y7dM.permissionStatus).ALLOWED);
                onInsightsEnabledWithoutPermission?.();
                setShouldUseJQLData(true);
            }
        }
        if (hasError || aborted) onPermissionLoaded((0, $9Y7dM.permissionStatus).DISALLOWED);
    }, [
        fetched,
        loading,
        aborted,
        hasPermission,
        hasError,
        onPermissionLoaded,
        setShouldUseJQLData,
        onInsightsEnabledWithoutPermission
    ]);
    return null;
};
const $09f9796263d4f1f9$export$b5e65dc6f010c84c = ()=>{
    const [_, setShouldUseJQLData] = (0, $47u1P.useLocalStorage)('jira-insights-should-use-jql', 'shouldUseJQLQuery', {
        defaultValue: false
    });
    (0, $5uXOq.useEffect)(()=>{
        setShouldUseJQLData((0, $4R6GH.fg)('insights-use_jql_query_for_enabled_users'));
    }, [
        setShouldUseJQLData
    ]);
    return null;
};

});
parcelRegister("dfjss", function(module, exports) {

$parcel$export(module.exports, "getBoardOrBacklogFromLocation", () => $8952e8de617aa53a$export$bb6a57ca7b7487bb);

const $8952e8de617aa53a$var$locations = {
    [(0, $b117e2ebd359768a$export$743304c0b847bdee)]: (0, $b117e2ebd359768a$export$dedbdcc35e955187),
    [(0, $b117e2ebd359768a$export$47ae5cd4a7ee5f2a)]: (0, $b117e2ebd359768a$export$dedbdcc35e955187),
    [(0, $b117e2ebd359768a$export$40705e2848d2f6a5)]: (0, $b117e2ebd359768a$export$9b8283d5878d2491),
    [(0, $b117e2ebd359768a$export$f995350d8da9bb90)]: (0, $b117e2ebd359768a$export$9b8283d5878d2491)
};
const $8952e8de617aa53a$export$bb6a57ca7b7487bb = (userLocation)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly "software:software-backlog": "backlog"; readonly "classic-software:rapidboard-backlog": "backlog"; readonly "software:software-boards": "board"; readonly "classic-software:rapidboard-board": "board"; }'.
    $8952e8de617aa53a$var$locations[userLocation] || (0, $b117e2ebd359768a$export$5f4028218eaee319);

});
const $b117e2ebd359768a$export$dedbdcc35e955187 = 'backlog';
const $b117e2ebd359768a$export$9b8283d5878d2491 = 'board';
const $b117e2ebd359768a$export$5f4028218eaee319 = 'unknown';
const $b117e2ebd359768a$export$47ae5cd4a7ee5f2a = 'classic-software:rapidboard-backlog';
const $b117e2ebd359768a$export$f995350d8da9bb90 = 'classic-software:rapidboard-board';
const $b117e2ebd359768a$export$743304c0b847bdee = 'software:software-backlog';
const $b117e2ebd359768a$export$40705e2848d2f6a5 = 'software:software-boards';


parcelRegister("iuEfD", function(module, exports) {

$parcel$export(module.exports, "useFetch", () => $082fa94a7a9fe60c$export$d852f5f778460fa4);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $4R6GH = parcelRequire("4R6GH");

var $aAhmV = parcelRequire("aAhmV");

var $d6Xq4 = parcelRequire("d6Xq4");

var $bYINM = parcelRequire("bYINM");

var $lUlda = parcelRequire("lUlda");

var $dg0bO = parcelRequire("dg0bO");

var $eW4Xh = parcelRequire("eW4Xh");
const $082fa94a7a9fe60c$export$d852f5f778460fa4 = ({ onFetch: onFetch, isAutoFetchable: isAutoFetchable = true, analyticsTracking: analyticsTracking, browserMetricsKey: browserMetricsKey, loggingKey: loggingKey, initialData: initialData, isAbortable: isAbortable = true }, fetchDependencies)=>{
    const [state, dispatch] = (0, $5uXOq.useReducer)((0, $bYINM.reducer), {
        ...(0, $dg0bO.initialState),
        data: initialData
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { initialized: initialized, fetched: fetched, loading: loading } = state;
    const abortControllerRef = (0, $5uXOq.useRef)();
    const fetchDependenciesRef = (0, $5uXOq.useRef)(fetchDependencies);
    const isMounted = (0, $5uXOq.useRef)(true);
    const getAbortController = (0, $5uXOq.useCallback)(()=>{
        const controller = abortControllerRef.current;
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        if (!abortControllerRef.current || controller?.signal.aborted) abortControllerRef.current = new AbortController();
        return abortControllerRef.current;
    }, []);
    const callFetch = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (...args)=>{
        // @ts-expect-error - TS2339 - Property 'signal' does not exist on type 'unknown'.
        const { signal: signal } = getAbortController();
        (0, $eW4Xh.thunks).fetch({
            onFetch: async ()=>{
                try {
                    return await onFetch({
                        signal: signal
                    }, ...args);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (e) {
                    throw new (0, $d6Xq4.UseFetchHandledError)(isMounted.current, e);
                }
            },
            analyticsTracking: analyticsTracking,
            createAnalyticsEvent: createAnalyticsEvent,
            browserMetricsKey: browserMetricsKey,
            loggingKey: loggingKey,
            signal: signal
        })({
            actions: (0, $aAhmV.buildActionDispatchers)(dispatch)
        });
    }, [
        onFetch,
        analyticsTracking,
        browserMetricsKey,
        createAnalyticsEvent,
        loggingKey,
        getAbortController
    ]);
    const doAbort = (0, $5uXOq.useCallback)(()=>{
        if (isAbortable) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        getAbortController().abort();
    }, [
        getAbortController,
        isAbortable
    ]);
    const doFetch = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (...args)=>{
        if (loading) doAbort();
        callFetch(...args);
    }, [
        loading,
        callFetch,
        doAbort
    ]);
    /**
	 * We need this shouldAutoFetch in concurrent mode or we callFetch twice on mount
	 * We can't do a loading check in the hasEffectsChanged useEffect because loading doesn't get updated in time
	 * So we delay it till the next cycle via useEffect
	 */ const [shouldAutoFetch, setShouldAutoFetch] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $4R6GH.fg)('jira-concurrent-board-perf')) {
            if (shouldAutoFetch) {
                setShouldAutoFetch(false);
                if (!loading) callFetch();
            }
        }
    }, [
        shouldAutoFetch,
        callFetch,
        loading
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const hasEffectsChanged = (0, $lUlda.isShallowDifferent)(fetchDependenciesRef.current, fetchDependencies);
        if (!initialized && !fetched || hasEffectsChanged) {
            if (hasEffectsChanged) fetchDependenciesRef.current = fetchDependencies;
            if (hasEffectsChanged) doAbort();
            if (isAutoFetchable) {
                if ((0, $4R6GH.fg)('jira-concurrent-board-perf')) setShouldAutoFetch(true);
                else callFetch();
            } else if (initialized && hasEffectsChanged) dispatch({
                type: 'resetInitialState',
                payload: null
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        initialized,
        doAbort,
        fetched,
        callFetch,
        isAutoFetchable,
        ...fetchDependencies
    ]);
    (0, $5uXOq.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
            doAbort();
        };
    }, [
        doAbort
    ]);
    return [
        state,
        {
            doFetch: doFetch,
            doAbort: doAbort
        }
    ];
};

});
parcelRegister("bYINM", function(module, exports) {

$parcel$export(module.exports, "reducer", () => $82dfd012f8e9e396$export$1650419e431d3ba3);

var $aTJxm = parcelRequire("aTJxm");

var $dg0bO = parcelRequire("dg0bO");
const $82dfd012f8e9e396$export$1650419e431d3ba3 = (state = (0, $dg0bO.initialState), action)=>{
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly resetInitialState: () => { readonly initialized: false; readonly loading: false; readonly fetched: false; readonly hasError: false; readonly aborted: false; readonly error: undefined; readonly data: undefined; }; ... 4 more ...; readonly default: (state: FetchState) => FetchState; }'.
    const transformer = (0, $aTJxm.strategies)[action.type] || (0, $aTJxm.strategies).default;
    return transformer(state, action);
};

});


parcelRegister("6WV5x", function(module, exports) {

$parcel$export(module.exports, "fetchInsightPermission", () => $3d7ce849d39a845d$export$a465feaffcf65c97);

var $48DMb = parcelRequire("48DMb");
const $3d7ce849d39a845d$export$a465feaffcf65c97 = async ({ boardId: boardId }, options)=>{
    const response = await (0, $48DMb.fetchJson)(`/rest/internal/board/${boardId}/insight-permission`, options);
    return response && response.allowed;
};

});

parcelRegister("47u1P", function(module, exports) {

$parcel$export(module.exports, "useLocalStorage", () => $4772a73a96e71e67$export$86e2cef2561044ac);
$parcel$export(module.exports, "useLocalStorageWithExpiry", () => $4772a73a96e71e67$export$9c89ac8256e92fbb);

var $5uXOq = parcelRequire("5uXOq");

var $bSSG7 = parcelRequire("bSSG7");
const $4772a73a96e71e67$var$isSetStateFunction = (setStateAction)=>typeof setStateAction === 'function';
const $4772a73a96e71e67$export$86e2cef2561044ac = (namespace, key, options)=>{
    const localStorage = (0, $bSSG7.createLocalStorageProvider)(namespace);
    const initialValue = localStorage.get(key) ?? options?.defaultValue;
    // used to trigger re-render of components
    const [value, setValueInState] = (0, $5uXOq.useState)(initialValue);
    const setValue = (0, $5uXOq.useCallback)((setStateAction)=>{
        if ($4772a73a96e71e67$var$isSetStateFunction(setStateAction)) setValueInState((prevVal)=>{
            const newVal = setStateAction(prevVal);
            localStorage.set(key, newVal);
            return newVal;
        });
        else {
            localStorage.set(key, setStateAction);
            setValueInState(setStateAction);
        }
    }, [
        key,
        localStorage
    ]);
    return [
        value,
        setValue
    ];
};
const $4772a73a96e71e67$export$9c89ac8256e92fbb = (namespace, key, ttlInMs, options)=>{
    const localStorage = (0, $bSSG7.createLocalExpirableStorageProvider)(namespace);
    const initialValue = localStorage.get(key) ?? options?.defaultValue;
    // used to trigger re-render of components
    const [value, setValueInState] = (0, $5uXOq.useState)(initialValue);
    const setValue = (0, $5uXOq.useCallback)((setStateAction)=>{
        if ($4772a73a96e71e67$var$isSetStateFunction(setStateAction)) setValueInState((prevVal)=>{
            const newVal = setStateAction(prevVal);
            localStorage.set(key, newVal, Date.now() + ttlInMs);
            return newVal;
        });
        else {
            localStorage.set(key, setStateAction, Date.now() + ttlInMs);
            setValueInState(setStateAction);
        }
    }, [
        key,
        localStorage,
        ttlInMs
    ]);
    return [
        value,
        setValue
    ];
};
const $4772a73a96e71e67$export$436c2fd92113c067 = (namespace, key, options)=>{
    const [state, setState] = $4772a73a96e71e67$export$86e2cef2561044ac(namespace, key, options);
    return [
        state,
        // This is for batch update
        (objectKey, value)=>setState((prevState)=>({
                    ...prevState,
                    [objectKey]: value
                }))
    ];
};
const $4772a73a96e71e67$export$db70e245473ac2a = (namespace, key, ttlInMs, options)=>{
    const [state, setState] = $4772a73a96e71e67$export$9c89ac8256e92fbb(namespace, key, ttlInMs, options);
    return [
        state,
        // This is for batch update
        (objectKey, value)=>setState((prevState)=>({
                    ...prevState,
                    [objectKey]: value
                }))
    ];
};

});


parcelRegister("1UEsW", function(module, exports) {

$parcel$export(module.exports, "WithInsightsErrorBoundary", () => $0d7082c2a6c6ecc7$export$b240a041e4bface8);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $7CMCs = parcelRequire("7CMCs");

var $93jKl = parcelRequire("93jKl");

var $1OjhZ = parcelRequire("1OjhZ");

var $4Fbrj = parcelRequire("4Fbrj");


var $1s62S = parcelRequire("1s62S");
const $0d7082c2a6c6ecc7$var$insightsExperience = {
    experience: (0, $4Fbrj.JIRA_INSIGHTS)
};
const $0d7082c2a6c6ecc7$export$eff352405fe6db90 = ({ id: id, packageName: packageName, children: children, onError: onError = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: id,
        packageName: packageName,
        teamName: "helios-headcoach",
        fallback: "flag",
        onError: onError
    }, children);
};
const $0d7082c2a6c6ecc7$var$BaseInsightsErrorBoundaryWithExperienceTracker = ({ children: children })=>{
    const onFail = (0, $93jKl.useExperienceFail)($0d7082c2a6c6ecc7$var$insightsExperience);
    const { fail: fail } = (0, $1s62S.useInsightsExperience)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0d7082c2a6c6ecc7$export$eff352405fe6db90, {
        id: (0, $b0e6fec6a4686296$export$1269ea4f2b198811),
        packageName: (0, $b0e6fec6a4686296$export$d3996f57ffa8448f),
        onError: (...args)=>{
            onFail(...args);
            const [, error] = args;
            fail((0, $4Fbrj.ERROR_BOUNDARY_HIT), error);
        }
    }, children);
};
const $0d7082c2a6c6ecc7$export$cf848bf84642a299 = ({ children: children, experienceIdsToTrack: experienceIdsToTrack = [] })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1s62S.InsightsExperienceTracker), {
        experienceId: (0, $4Fbrj.INSIGHTS_PANEL_EXPERIENCE),
        experienceIdsToCollect: experienceIdsToTrack || [],
        timeoutInMs: (0, $4Fbrj.EXPERIENCE_TIMEOUT_MILLIS),
        packageName: (0, $b0e6fec6a4686296$export$d3996f57ffa8448f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1OjhZ.ExperienceTrackerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0d7082c2a6c6ecc7$var$BaseInsightsErrorBoundaryWithExperienceTracker, null, children)));
const $0d7082c2a6c6ecc7$export$b240a041e4bface8 = (Component, id, packageName)=>(props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0d7082c2a6c6ecc7$export$eff352405fe6db90, {
            id: id,
            packageName: packageName
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, props));
    };

});
parcelRegister("4Fbrj", function(module, exports) {

$parcel$export(module.exports, "JIRA_INSIGHTS", () => $fea73e8d1542f4b4$export$74798a8d8755efe8);
$parcel$export(module.exports, "INSIGHTS_BEACON", () => $fea73e8d1542f4b4$export$36aafe55be325e9c);
$parcel$export(module.exports, "INSIGHTS_PANEL", () => $fea73e8d1542f4b4$export$29d7f2210b16d662);
$parcel$export(module.exports, "EXPERIENCE_TIMEOUT_MILLIS", () => $fea73e8d1542f4b4$export$b50c2fb16a87be63);
$parcel$export(module.exports, "DATA_FETCH_ACTION", () => $fea73e8d1542f4b4$export$4857a322416ea6fc);
$parcel$export(module.exports, "CLIENT_ERROR", () => $fea73e8d1542f4b4$export$cb2bfe2a50a1ece2);
$parcel$export(module.exports, "RENDER_ACTION", () => $fea73e8d1542f4b4$export$e902262516430940);
$parcel$export(module.exports, "dataFetchSuccess", () => $fea73e8d1542f4b4$export$d392c424a6c74b59);
$parcel$export(module.exports, "dataFetchFail", () => $fea73e8d1542f4b4$export$8d035b8b8e3383e);
$parcel$export(module.exports, "INSIGHTS_PANEL_EXPERIENCE", () => $fea73e8d1542f4b4$export$3ea7cf58d679b8d9);
$parcel$export(module.exports, "ERROR_BOUNDARY_HIT", () => $fea73e8d1542f4b4$export$680b36a84ba453e0);
$parcel$export(module.exports, "boardType", () => $fea73e8d1542f4b4$export$6796f2a60fb31770);
$parcel$export(module.exports, "BOARD_KANBAN_PANEL_EXPERIENCE", () => $fea73e8d1542f4b4$export$36467f64abcaaaa5);
$parcel$export(module.exports, "INSIGHTS_BUTTON", () => $fea73e8d1542f4b4$export$28ab2964530cf411);
$parcel$export(module.exports, "INSIGHTS_BUTTON_LG", () => $fea73e8d1542f4b4$export$8a355daa8d0cf830);
$parcel$export(module.exports, "INSIGHTS_BUTTON_SM", () => $fea73e8d1542f4b4$export$f8c16af1b950b647);
$parcel$export(module.exports, "INSIGHTS_BUTTON_RESPONSIVE", () => $fea73e8d1542f4b4$export$e80ae42ddabf80c5);

const $fea73e8d1542f4b4$export$74798a8d8755efe8 = (0, $b0e6fec6a4686296$export$d3996f57ffa8448f);
const $fea73e8d1542f4b4$export$36aafe55be325e9c = `${$fea73e8d1542f4b4$export$74798a8d8755efe8}.beacon`;
const $fea73e8d1542f4b4$export$29d7f2210b16d662 = `${$fea73e8d1542f4b4$export$74798a8d8755efe8}.panel`;
const $fea73e8d1542f4b4$export$8a1dfa6c0a610c5f = `${$fea73e8d1542f4b4$export$29d7f2210b16d662}.help`;
const $fea73e8d1542f4b4$export$956c91960ecaaf52 = `${$fea73e8d1542f4b4$export$74798a8d8755efe8}.location`;
const $fea73e8d1542f4b4$export$b50c2fb16a87be63 = 60000;
const $fea73e8d1542f4b4$export$4857a322416ea6fc = 'dataFetch';
const $fea73e8d1542f4b4$export$cb2bfe2a50a1ece2 = 'clientError';
const $fea73e8d1542f4b4$export$e902262516430940 = 'render';
const $fea73e8d1542f4b4$export$d392c424a6c74b59 = {
    successful: true
};
const $fea73e8d1542f4b4$export$8d035b8b8e3383e = {
    successful: false
};
const $fea73e8d1542f4b4$export$3ea7cf58d679b8d9 = 'panel';
const $fea73e8d1542f4b4$export$680b36a84ba453e0 = 'error-boundary-hit';
const $fea73e8d1542f4b4$export$6796f2a60fb31770 = {
    SCRUM: 'scrum',
    KANBAN: 'kanban'
};
const $fea73e8d1542f4b4$export$36467f64abcaaaa5 = `${$fea73e8d1542f4b4$export$74798a8d8755efe8}.board.${$fea73e8d1542f4b4$export$6796f2a60fb31770.KANBAN}-panel`;
const $fea73e8d1542f4b4$export$28ab2964530cf411 = 'insights-show-insights-button.ui.insights-button';
const $fea73e8d1542f4b4$export$8a355daa8d0cf830 = 'insights-show-insights-button.ui.insights-button-large';
const $fea73e8d1542f4b4$export$f8c16af1b950b647 = 'insights-show-insights-button.ui.insights-button-small';
const $fea73e8d1542f4b4$export$e80ae42ddabf80c5 = 'insights-show-insights-button.ui.insights-button-responsive';

});

parcelRegister("1s62S", function(module, exports) {

$parcel$export(module.exports, "InsightsExperienceTracker", () => $86531a62d14892a7$export$9c32e0183f3330c4);
$parcel$export(module.exports, "useInsightsExperience", () => $86531a62d14892a7$export$6a440957407835a0);
$parcel$export(module.exports, "StartInsightsExperience", () => $86531a62d14892a7$export$d8f7e3f6742303b4);

var $5uXOq = parcelRequire("5uXOq");

var $2YZCu = parcelRequire("2YZCu");

var $dfjss = parcelRequire("dfjss");

var $cfDZ3 = parcelRequire("cfDZ3");

var $30KM0 = parcelRequire("30KM0");

var $2Siis = parcelRequire("2Siis");

var $eUcR1 = parcelRequire("eUcR1");

var $2B9C9 = parcelRequire("2B9C9");

var $bSClU = parcelRequire("bSClU");

var $dfzOH = parcelRequire("dfzOH");
const $86531a62d14892a7$export$9c32e0183f3330c4 = ({ ufoExperience: ufoExperience, experienceId: experienceId, experienceIdsToCollect: experienceIdsToCollect, timeoutInMs: timeoutInMs = (0, $30KM0.TIMEOUT_IN_MS), attributes: attributes, children: children, packageName: packageName })=>{
    const userLocation = (0, $cfDZ3.getUserLocation)();
    const eventFrom = (0, $dfjss.getBoardOrBacklogFromLocation)(userLocation);
    const ufoErrorLogger = (0, $dfzOH.useUfoErrorLogger)({
        eventFrom: eventFrom,
        ufoExperience: ufoExperience
    });
    const insightsPackage = packageName;
    const insightsExperience = `${insightsPackage}.${eventFrom}.${experienceId}`;
    const metricsTracker = (0, $bSClU.useMetricsMemo)(()=>{
        const browserMetricsKey = `${insightsExperience}.${(0, $30KM0.experiences).RENDER}`;
        const metricsAttributes = {
            ...attributes,
            userLocation: userLocation
        };
        const service = (0, $eUcR1.trackBrowserMetricsForJira)({
            browserMetricsKey: browserMetricsKey,
            attributes: metricsAttributes
        });
        return {
            start: ()=>{
                service.start();
                ufoExperience?.start().catch(ufoErrorLogger);
            },
            end: ()=>{
                service.end();
                ufoExperience?.success().catch(ufoErrorLogger);
            },
            cancel: (error)=>{
                // send message to splunk here
                if (error) (0, $2YZCu.default).safeErrorWithoutCustomerData(browserMetricsKey, 'Insights experience failed', new (0, $2Siis.ExperienceError)(error, metricsAttributes));
                service.cancel();
                ufoExperience?.failure().catch(ufoErrorLogger);
            }
        };
    }, [
        insightsExperience,
        userLocation,
        attributes,
        ufoExperience
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2B9C9.InsightsExperienceTrackerStoreContainer), {
        scope: insightsExperience,
        experienceIdsToCollect: experienceIdsToCollect,
        timeoutInMs: timeoutInMs,
        metricsTracker: metricsTracker,
        ufoExperience: ufoExperience
    }, children);
};
const $86531a62d14892a7$export$6a440957407835a0 = ()=>{
    const [, actions] = (0, $2B9C9.useInsightsExperienceTracker)();
    const [isExperienceOwner, setExperienceOwner] = (0, $5uXOq.useState)(false);
    // we only need to expose start, fail and success
    const returnActions = (0, $5uXOq.useMemo)(()=>({
            start: ()=>{
                setExperienceOwner(true);
                actions.start();
            },
            fail: actions.fail,
            success: actions.success
        }), [
        actions,
        setExperienceOwner
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            if (isExperienceOwner === true) actions.reset();
        }, [
        isExperienceOwner,
        actions
    ]);
    return returnActions;
};
const $86531a62d14892a7$export$d8f7e3f6742303b4 = ()=>{
    const { start: start } = $86531a62d14892a7$export$6a440957407835a0();
    (0, $5uXOq.useLayoutEffect)(()=>{
        start();
    }, [
        start
    ]);
    return null;
};

});
parcelRegister("2Siis", function(module, exports) {

$parcel$export(module.exports, "ExperienceError", () => $e57b689d183ecfd7$export$14d796af4fae7309);
class $e57b689d183ecfd7$export$14d796af4fae7309 extends Error {
    constructor(error, extraProps){
        super(error.message);
        this.name = error.name;
        this.stack = error.stack;
        Object.assign(this, {
            ...error
        });
        Object.assign(this, extraProps);
    }
}

});

parcelRegister("2B9C9", function(module, exports) {

$parcel$export(module.exports, "InsightsExperienceTrackerStoreContainer", () => $aa56c148ed849f26$export$ed39ab6b8cf88c60);
$parcel$export(module.exports, "useInsightsExperienceTracker", () => $aa56c148ed849f26$export$941e72d49b686b93);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $30KM0 = parcelRequire("30KM0");

var $fKAQw = parcelRequire("fKAQw");

var $k8iQN = parcelRequire("k8iQN");
const $aa56c148ed849f26$var$Store = (0, $iXqE5.createStore)({
    initialState: // @ts-expect-error - TS2322 - Type '{ readonly status: { readonly hasFailed: false; readonly hasCompleted: false; readonly hasStarted: false; readonly hasTimedOut: false; }; readonly timeoutId: null; readonly eventsSuccess: readonly []; readonly eventsFail: readonly []; }' is not assignable to type 'State'.
    $k8iQN.initialState,
    actions: $fKAQw.actions,
    name: (0, $30KM0.STORE_NAME)
});
const $aa56c148ed849f26$export$ed39ab6b8cf88c60 = (0, $gg7kZ.createContainer)($aa56c148ed849f26$var$Store);
const $aa56c148ed849f26$export$941e72d49b686b93 = (0, $3sQ5x.createHook)($aa56c148ed849f26$var$Store);

});
parcelRegister("fKAQw", function(module, exports) {

$parcel$export(module.exports, "actions", () => $e0f25a0ee99bb826$export$e324594224ef24da);

var $4Fbrj = parcelRequire("4Fbrj");

var $k8iQN = parcelRequire("k8iQN");
const $e0f25a0ee99bb826$var$success = (experienceId)=>({ getState: getState, setState: setState }, { metricsTracker: metricsTracker, experienceIdsToCollect: experienceIdsToCollect, ufoExperience: ufoExperience })=>{
        const state = getState();
        const currentStatus = state.status;
        if (!experienceId) return;
        if (!currentStatus.hasStarted || currentStatus.hasCompleted || currentStatus.hasTimedOut) return;
        if (!experienceIdsToCollect.includes(experienceId)) return;
        if (state.eventsSuccess.includes(experienceId)) return;
        if (ufoExperience != null) ufoExperience.mark(`${experienceId}_success`);
        const nextEventsSuccess = [
            ...state.eventsSuccess,
            experienceId
        ];
        const shouldSetHasCompleted = nextEventsSuccess.length === experienceIdsToCollect.length && !currentStatus.hasCompleted;
        const nextState = {
            status: shouldSetHasCompleted ? {
                ...currentStatus,
                hasCompleted: true
            } : currentStatus,
            timeoutId: state.timeoutId,
            eventsSuccess: [
                ...state.eventsSuccess,
                experienceId
            ],
            eventsFail: state.eventsFail
        };
        setState(nextState);
        if (shouldSetHasCompleted) {
            if (state.timeoutId) clearTimeout(state.timeoutId);
            metricsTracker.end();
        }
    };
const $e0f25a0ee99bb826$var$fail = (experienceId, error)=>({ getState: getState, setState: setState }, { metricsTracker: metricsTracker, experienceIdsToCollect: experienceIdsToCollect, ufoExperience: ufoExperience })=>{
        const state = getState();
        const currentStatus = state.status;
        if (!experienceId) return;
        if (!currentStatus.hasStarted || currentStatus.hasCompleted) return;
        if (!experienceIdsToCollect.includes(experienceId) && // Panel level error boundary hits do not pass in an experienceId,
        // so we accept the constant "error-boundary-hit" in addition to the experienceIds
        // Note: Insight level error boundary hits do pass in experienceId
        experienceId !== (0, $4Fbrj.ERROR_BOUNDARY_HIT)) return;
        if (state.timeoutId) clearTimeout(state.timeoutId);
        if (ufoExperience != null) ufoExperience.mark(`${experienceId}_fail`);
        const nextEventsFail = [
            ...state.eventsFail,
            experienceId
        ];
        const nextState = {
            status: {
                ...currentStatus,
                hasFailed: true
            },
            timeoutId: state.timeoutId,
            eventsSuccess: state.eventsSuccess,
            eventsFail: nextEventsFail
        };
        setState(nextState);
        metricsTracker.cancel(error);
    };
const $e0f25a0ee99bb826$var$timeout = ()=>({ getState: getState, setState: setState }, { metricsTracker: metricsTracker })=>{
        const state = getState();
        const currentStatus = state.status;
        if (!currentStatus.hasStarted || currentStatus.hasCompleted || currentStatus.hasFailed) return;
        const nextState = {
            status: {
                ...currentStatus,
                hasFailed: true,
                hasTimedOut: true
            },
            eventsSuccess: state.eventsSuccess,
            eventsFail: state.eventsFail
        };
        setState(nextState);
        metricsTracker.cancel();
    };
const $e0f25a0ee99bb826$var$start = ()=>({ getState: getState, setState: setState, dispatch: dispatch }, { timeoutInMs: timeoutInMs, metricsTracker: metricsTracker, experienceIdsToCollect: experienceIdsToCollect })=>{
        const state = getState();
        const currentStatus = state.status;
        if (currentStatus.hasCompleted || currentStatus.hasStarted || currentStatus.hasFailed || currentStatus.hasTimedOut || experienceIdsToCollect.length === 0) return;
        const timeoutId = setTimeout(()=>{
            dispatch($e0f25a0ee99bb826$var$timeout());
        }, timeoutInMs);
        const nextState = {
            status: {
                ...currentStatus,
                hasStarted: true
            },
            timeoutId: timeoutId,
            eventsSuccess: [],
            eventsFail: []
        };
        // @ts-expect-error - TS2345 - Argument of type '{ status: { hasStarted: boolean; hasFailed: boolean; hasCompleted: boolean; hasTimedOut: boolean; }; timeoutId: NodeJS.Timeout; eventsSuccess: never[]; eventsFail: never[]; }' is not assignable to parameter of type 'Partial<State>'.
        setState(nextState);
        metricsTracker.start();
    };
const $e0f25a0ee99bb826$var$reset = ()=>({ getState: getState, setState: setState }, { metricsTracker: metricsTracker })=>{
        const state = getState();
        if (state.timeoutId) clearTimeout(state.timeoutId);
        const currentStatus = state.status;
        if (currentStatus.hasStarted && !currentStatus.hasCompleted && !currentStatus.hasFailed && !currentStatus.hasTimedOut) metricsTracker.cancel();
        // @ts-expect-error - TS2345 - Argument of type '{ readonly status: { readonly hasFailed: false; readonly hasCompleted: false; readonly hasStarted: false; readonly hasTimedOut: false; }; readonly timeoutId: null; readonly eventsSuccess: readonly []; readonly eventsFail: readonly []; }' is not assignable to parameter of type 'Partial<State>'.
        setState((0, $k8iQN.initialState));
    };
const $e0f25a0ee99bb826$export$e324594224ef24da = {
    reset: $e0f25a0ee99bb826$var$reset,
    start: $e0f25a0ee99bb826$var$start,
    timeout: $e0f25a0ee99bb826$var$timeout,
    success: $e0f25a0ee99bb826$var$success,
    fail: $e0f25a0ee99bb826$var$fail
};

});
parcelRegister("k8iQN", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $7bb650eee945c3d9$export$d4c72bab9d6cc13a);
const $7bb650eee945c3d9$export$d4c72bab9d6cc13a = {
    status: {
        hasFailed: false,
        hasCompleted: false,
        hasStarted: false,
        hasTimedOut: false
    },
    timeoutId: null,
    eventsSuccess: [],
    eventsFail: []
};

});



parcelRegister("bSClU", function(module, exports) {

$parcel$export(module.exports, "useMetricsMemo", () => $5617a8526f2df6be$export$f5d771045a704f1f);

var $5uXOq = parcelRequire("5uXOq");
const $5617a8526f2df6be$var$isShallowDifferent = (arrayA, arrayB)=>arrayA.length !== arrayB.length || arrayA.some((currentElement, index)=>currentElement !== arrayB[index]);
const $5617a8526f2df6be$export$f5d771045a704f1f = (f, deps)=>{
    const metricsTrackerRef = (0, $5uXOq.useRef)();
    const fetchDependenciesRef = (0, $5uXOq.useRef)(deps);
    (0, $5uXOq.useMemo)(()=>{
        const hasEffectsChanged = $5617a8526f2df6be$var$isShallowDifferent(fetchDependenciesRef.current, deps);
        if (!metricsTrackerRef.current || hasEffectsChanged) {
            if (hasEffectsChanged) fetchDependenciesRef.current = deps;
            // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
            metricsTrackerRef.current = f();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
    // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'T'.
    return metricsTrackerRef.current;
};

});

parcelRegister("dfzOH", function(module, exports) {

$parcel$export(module.exports, "useUfoErrorLogger", () => $b799d4cddaf33695$export$688547a52c1d762b);

var $5uXOq = parcelRequire("5uXOq");

var $2YZCu = parcelRequire("2YZCu");


var $30KM0 = parcelRequire("30KM0");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $b799d4cddaf33695$var$noop = ()=>{};
const $b799d4cddaf33695$export$688547a52c1d762b = ({ eventFrom: eventFrom, ufoExperience: ufoExperience })=>{
    const ufoErrorLogger = (0, $5uXOq.useCallback)((error)=>(0, $2YZCu.default).safeErrorWithoutCustomerData(`${(0, $b0e6fec6a4686296$export$d3996f57ffa8448f)}.${eventFrom}.${ufoExperience?.id || 'unknown'}.${(0, $30KM0.experiences).RENDER}`, 'Insights experience failed', error), [
        eventFrom,
        ufoExperience
    ]);
    return ufoExperience ? ufoErrorLogger : $b799d4cddaf33695$var$noop;
};

});



parcelRegister("gkPFQ", function(module, exports) {

$parcel$export(module.exports, "InsightsSpotlight", () => $7a791a009d9ba36f$export$f441a5f6be0f18a);

var $5uXOq = parcelRequire("5uXOq");

var $1QiBP = parcelRequire("1QiBP");

var $eGLgs = parcelRequire("eGLgs");

var $koVbs = parcelRequire("koVbs");

var $ehdJY = parcelRequire("ehdJY");

var $bMiSe = parcelRequire("bMiSe");
const $7a791a009d9ba36f$var$INSIGHTS_OPEN_UP_MESSAGE_ID = 'jira-insights-open-up-message';
const $7a791a009d9ba36f$export$f441a5f6be0f18a = ({ onOpenInsightsPanel: onOpenInsightsPanel, onDismiss: onDismiss, isOnboardingApplicable: isOnboardingApplicable })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, isOnboardingApplicable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eGLgs.default), {
        messageId: $7a791a009d9ba36f$var$INSIGHTS_OPEN_UP_MESSAGE_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7a791a009d9ba36f$var$CoordinationStopProvider, null, (stopEngagementMessage)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
            actions: [
                {
                    onClick: ()=>{
                        stopEngagementMessage?.();
                        onOpenInsightsPanel();
                        onDismiss();
                    },
                    text: formatMessage((0, $bMiSe.default).viewButtonLabel)
                },
                {
                    onClick: ()=>{
                        stopEngagementMessage?.();
                        onDismiss();
                    },
                    text: formatMessage((0, $bMiSe.default).skipButtonLabel)
                }
            ],
            messageType: "engagement",
            messageId: $7a791a009d9ba36f$var$INSIGHTS_OPEN_UP_MESSAGE_ID,
            target: "jira-insights-button",
            key: $7a791a009d9ba36f$var$INSIGHTS_OPEN_UP_MESSAGE_ID,
            targetRadius: 3,
            dialogPlacement: "bottom right"
        }, formatMessage((0, $bMiSe.default).spotlightContent)))));
};
const $7a791a009d9ba36f$var$CoordinationStopProvider = ({ stop: stop, children: children })=>children(stop);

});
parcelRegister("bMiSe", function(module, exports) {

$parcel$export(module.exports, "default", () => $b00d0f1af606d21a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b00d0f1af606d21a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    skipButtonLabel: {
        "id": "insights-common.insights-spotlight.skip-button-label",
        "defaultMessage": "Skip"
    },
    viewButtonLabel: {
        "id": "insights-common.insights-spotlight.view-button-label",
        "defaultMessage": "View insights"
    },
    spotlightContent: {
        "id": "insights-common.insights-spotlight.spotlight-content",
        "defaultMessage": "Insights have made it to your board and backlog, so you can monitor work and make informed decisions using real-time data."
    }
});

});


parcelRegister("2KxPr", function(module, exports) {

$parcel$export(module.exports, "withComponentSafety", () => $3fc106ae6756d120$export$cb70221ec28d89b);

var $5uXOq = parcelRequire("5uXOq");

var $2YZCu = parcelRequire("2YZCu");
/* condition must return true for component to render */ function $3fc106ae6756d120$export$cb70221ec28d89b(Component, { condition: condition, location: location, message: message = ()=>'withComponentSafety blocked render', Fallback: Fallback = ()=>null }) {
    return (props)=>{
        const isSafe = condition(props);
        const formattedMessage = message(props);
        (0, $5uXOq.useEffect)(()=>{
            if (!isSafe) (0, $2YZCu.default).safeErrorWithoutCustomerData(location, formattedMessage);
        }, [
            isSafe,
            formattedMessage
        ]);
        // @ts-expect-error - Type 'Props' is not assignable to type 'IntrinsicAttributes & Props'.
        return isSafe ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Fallback, props);
    };
}

});

parcelRegister("6f6NP", function(module, exports) {

$parcel$export(module.exports, "useInsightsContainer", () => $19bd560421a87b26$export$8ecf81d0c059927c);

var $5uXOq = parcelRequire("5uXOq");

var $dAfqg = parcelRequire("dAfqg");

var $1NrMQ = parcelRequire("1NrMQ");

var $j8sJY = parcelRequire("j8sJY");
const $19bd560421a87b26$export$8ecf81d0c059927c = ()=>{
    const [containerState, actions] = (0, $j8sJY.useInsightsStoreContainer)();
    const memoCallbacksRef = (0, $5uXOq.useRef)({});
    const toggleAction = actions.toggleProp;
    (0, $1NrMQ.useIsAnyLevelOfAdmin)({
        onIsAnyLevelOfAdminUpdated: actions.setInfo
    });
    const { loading: loading, data: projectContext } = (0, $dAfqg.useProjectContext)();
    const isProjectType = !loading && projectContext != null;
    /*
      This will create a memoized function callback scoped to the current scope + propName so we can easily
      call this function from the onClick of any of the composed components.
      ex:
        <InsightsContainer>
          {({ data: { isPanelOpen } }, { onToggleCallback }) => {
            <HidePanelButton onClick={onToggleCallback('isPanelOpen')}
            <Panel isPanelOpen={isPanelOpen} />
          }}
        <InsightsContainer>
    */ const onToggleCallback = (0, $5uXOq.useCallback)((propName)=>{
        if (!memoCallbacksRef.current) memoCallbacksRef.current = {};
        const callbacksMap = memoCallbacksRef.current;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        if (propName && !callbacksMap[propName]) // this will prevent recreate the callback on each render
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        callbacksMap[propName] = ()=>toggleAction(propName);
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        return callbacksMap[propName];
    }, [
        toggleAction
    ]);
    const updateContainerAction = actions.updateContainer;
    /*
      This will create a memoized function callback scoped to the current scope + propName so we can easily
      call this function from the onClick of any of the composed components.
      ex:
        <InsightsContainer>
          {({ data: { settings } }, { onDataUpdatedCallback }) => {
            <LoadPanelSettings onLoad={onDataUpdatedCallback('settings')}
            <Panel settings={settings} />
          }}
        <InsightsContainer>
    */ const onDataUpdatedCallback = (0, $5uXOq.useCallback)((propName)=>{
        if (!memoCallbacksRef.current) memoCallbacksRef.current = {};
        const callbacksMap = memoCallbacksRef.current;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        if (!callbacksMap[propName]) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        callbacksMap[propName] = (data)=>// this will prevent recreate the callback on each render
            updateContainerAction({
                [propName]: data
            });
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        return callbacksMap[propName];
    }, [
        updateContainerAction
    ]);
    const state = (0, $5uXOq.useMemo)(()=>({
            ...containerState,
            info: {
                ...containerState.info,
                isProjectType: isProjectType
            }
        }), [
        containerState,
        isProjectType
    ]);
    return [
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        state,
        {
            onDataUpdatedCallback: // preferred usage is onDataUpdatedCallback and onToggleCallback
            onDataUpdatedCallback,
            onToggleCallback: onToggleCallback,
            // when we need a big customization and onDataUpdatedCallback and onToggleCallback do not fit
            // to solve the problem, we can use the original implementation onUpdate and onToggle
            doUpdate: actions.updateContainer,
            doToggle: actions.toggleProp,
            doClean: actions.cleanState,
            // pass through actions (from insights container)
            refreshUniqueId: actions.refreshUniqueId,
            updateIsDeepLinking: actions.updateIsDeepLinking
        }
    ];
};

});
parcelRegister("1NrMQ", function(module, exports) {

$parcel$export(module.exports, "useIsAnyLevelOfAdmin", () => $ca08f41fafaf028c$export$b29f514064315678);

var $5uXOq = parcelRequire("5uXOq");

var $dAfqg = parcelRequire("dAfqg");

var $itmJb = parcelRequire("itmJb");

var $cNd4s = parcelRequire("cNd4s");
const $ca08f41fafaf028c$export$b29f514064315678 = ({ onIsAnyLevelOfAdminUpdated: onIsAnyLevelOfAdminUpdated })=>{
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const isProjectAdmin = !!projectContext?.isProjectAdmin;
    (0, $5uXOq.useEffect)(()=>{
        onIsAnyLevelOfAdminUpdated({
            isAnyLevelOfAdmin: !!(isSiteAdmin || isAdmin || isProjectAdmin)
        });
    }, [
        isProjectAdmin,
        isSiteAdmin,
        isAdmin,
        onIsAnyLevelOfAdminUpdated
    ]);
};

});

parcelRegister("j8sJY", function(module, exports) {

$parcel$export(module.exports, "InsightsStoreContainer", () => $1089c091fa1f71a9$export$4b6f97ed14dce97c);
$parcel$export(module.exports, "useInsightsStoreContainer", () => $1089c091fa1f71a9$export$bd382fb3f9d0551e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");


var $hXuQC = parcelRequire("hXuQC");

var $keDMh = parcelRequire("keDMh");
const $1089c091fa1f71a9$var$Store = (0, $iXqE5.createStore)({
    initialState: $keDMh.initialState,
    actions: $hXuQC.actions,
    name: (0, $622cc15065a8e93c$export$cd79d01fb3d2f506)
});
const $1089c091fa1f71a9$export$4b6f97ed14dce97c = (0, $gg7kZ.createContainer)($1089c091fa1f71a9$var$Store);
const $1089c091fa1f71a9$export$bd382fb3f9d0551e = (0, $3sQ5x.createHook)($1089c091fa1f71a9$var$Store);

});
const $622cc15065a8e93c$export$cd79d01fb3d2f506 = 'jira.insights.container-store';

parcelRegister("hXuQC", function(module, exports) {

$parcel$export(module.exports, "actions", () => $dfa05910dfd04d9d$export$e324594224ef24da);

var $7Jxgt = parcelRequire("7Jxgt");

var $keDMh = parcelRequire("keDMh");
const $dfa05910dfd04d9d$var$updateContainer = (data)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const nextState = {
            info: state.info,
            data: {
                ...state.data,
                ...data
            }
        };
        setState(nextState);
    };
const $dfa05910dfd04d9d$var$toggleProp = (propsName)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const nextState = {
            info: state.info,
            data: {
                ...state.data,
                [propsName]: !state.data[propsName]
            }
        };
        setState(nextState);
    };
const $dfa05910dfd04d9d$var$setInfo = (data)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const nextState = {
            data: state.data,
            info: {
                ...state.info,
                ...data
            }
        };
        setState(nextState);
    };
const $dfa05910dfd04d9d$var$refreshUniqueId = ()=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const nextState = {
            data: state.data,
            info: {
                ...state.info,
                uniqueId: (0, $7Jxgt.v4)()
            }
        };
        setState(nextState);
    };
const $dfa05910dfd04d9d$var$cleanState = ()=>({ setState: setState })=>{
        setState((0, $keDMh.initialState));
    };
const $dfa05910dfd04d9d$var$updateIsDeepLinking = (isDeepLinking)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const nextState = {
            data: state.data,
            info: {
                ...state.info,
                isDeepLinking: isDeepLinking
            }
        };
        setState(nextState);
    };
const $dfa05910dfd04d9d$export$e324594224ef24da = {
    setInfo: $dfa05910dfd04d9d$var$setInfo,
    cleanState: $dfa05910dfd04d9d$var$cleanState,
    toggleProp: $dfa05910dfd04d9d$var$toggleProp,
    updateContainer: $dfa05910dfd04d9d$var$updateContainer,
    refreshUniqueId: $dfa05910dfd04d9d$var$refreshUniqueId,
    updateIsDeepLinking: $dfa05910dfd04d9d$var$updateIsDeepLinking
};

});
parcelRegister("keDMh", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $2bb5e17d6b3cb888$export$d4c72bab9d6cc13a);

var $7Jxgt = parcelRequire("7Jxgt");

const $2bb5e17d6b3cb888$var$SSR_UNIQUE_ID = 'ssr-unique-id';
const $2bb5e17d6b3cb888$export$d4c72bab9d6cc13a = {
    info: {
        uniqueId: (0, $cdb023d06c7f62fa$export$19d68f5aa485d903) ? $2bb5e17d6b3cb888$var$SSR_UNIQUE_ID : (0, $7Jxgt.v4)(),
        isDeepLinking: true
    },
    data: {}
};

});




parcelRegister("ebnTF", function(module, exports) {

$parcel$export(module.exports, "getTextValue", () => $ab366a2319b78816$export$6ca03cb7b75bfa13);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ab366a2319b78816$var$isUndefinedOrNull = (value)=>value === null || value === undefined;
const $ab366a2319b78816$export$96252741c837b909 = (value, defaultValue)=>$ab366a2319b78816$var$isUndefinedOrNull(value) ? defaultValue : value;
const $ab366a2319b78816$export$22a0d6ac9d3db3b9 = (value, defaultValue)=>$ab366a2319b78816$var$isUndefinedOrNull(value) ? defaultValue : value;
const $ab366a2319b78816$export$6ca03cb7b75bfa13 = (value, defaultValue)=>$ab366a2319b78816$var$isUndefinedOrNull(value) ? defaultValue : value;
const $ab366a2319b78816$export$e1a3353b722e75de = (value, defaultValue)=>$ab366a2319b78816$var$isUndefinedOrNull(value) ? defaultValue : value;

});

parcelRegister("apoVO", function(module, exports) {

$parcel$export(module.exports, "InsightsContainer", () => $8769e024218efab1$export$af2273df1febba45);

var $5uXOq = parcelRequire("5uXOq");

var $j8sJY = parcelRequire("j8sJY");

var $6f6NP = parcelRequire("6f6NP");
const $8769e024218efab1$var$buildScopeName = (scope, packageName)=>`${scope}-${packageName}`;
const $8769e024218efab1$var$ChildrenWrapperWithHook = ({ children: children })=>{
    const [state, actions] = (0, $6f6NP.useInsightsContainer)();
    return children(state, actions);
};
const $8769e024218efab1$export$af2273df1febba45 = ({ scope: scope, packageName: packageName, children: children })=>{
    const insightsStoreContainerScope = $8769e024218efab1$var$buildScopeName(scope, packageName);
    if (typeof children === 'function') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8sJY.InsightsStoreContainer), {
        scope: insightsStoreContainerScope
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8769e024218efab1$var$ChildrenWrapperWithHook, null, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8sJY.InsightsStoreContainer), {
        scope: insightsStoreContainerScope
    }, children);
};

});

parcelRegister("g5uUm", function(module, exports) {

$parcel$export(module.exports, "InsightsButton", () => $98922b077d0d412f$export$943e069e37d25a04);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $bZNwM = parcelRequire("bZNwM");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $3TyLU = parcelRequire("3TyLU");
var $1kVqg = parcelRequire("1kVqg");

var $42CjB = parcelRequire("42CjB");

var $hCCtP = parcelRequire("hCCtP");

var $7CMCs = parcelRequire("7CMCs");

var $4Fbrj = parcelRequire("4Fbrj");


var $7BuUr = parcelRequire("7BuUr");

var $koVbs = parcelRequire("koVbs");

var $3HwlS = parcelRequire("3HwlS");

var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");

var $hchBL = parcelRequire("hchBL");

var $6lmg7 = parcelRequire("6lmg7");

var $dCm1o = parcelRequire("dCm1o");

var $lmBAt = parcelRequire("lmBAt");

var $2Mspb = parcelRequire("2Mspb");
const $98922b077d0d412f$var$actionSubjectId = 'toggleInsightsPanel';
const $98922b077d0d412f$var$TooltipWrapper = ({ children: children, render: render })=>render != null ? render({
        children: children
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
const $98922b077d0d412f$var$buttonTestId = 'insights-show-insights-button.ui.insights-button';
const $98922b077d0d412f$var$buttonForHiddenTestId = 'insights-show-insights-button.ui.button-test-id-hide';
const $98922b077d0d412f$export$2fdc3445dd252e1 = ({ clickEventAnalytics: clickEventAnalytics, iconAfter: iconAfter, isCompact: isCompact = false, isHidden: isHidden = false, isInsightsPanelOpen: isInsightsPanelOpen, isOnboardingDisabled: isOnboardingDisabled = false, onToggle: onToggle, renderTooltip: renderTooltip, location: location, isThemed: isThemed = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [, { register: register }] = (0, $hchBL.useGlobalRefStoreActions)();
    const onRefSmall = (0, $5uXOq.useCallback)((ref)=>{
        register((0, $4Fbrj.INSIGHTS_BUTTON_SM), ref);
    }, [
        register
    ]);
    const onRefButtonLarge = (0, $5uXOq.useCallback)((ref)=>{
        register((0, $4Fbrj.INSIGHTS_BUTTON_LG), ref);
    }, [
        register
    ]);
    const onRefButtonResponsive = (0, $5uXOq.useCallback)((ref)=>{
        register((0, $4Fbrj.INSIGHTS_BUTTON_RESPONSIVE), ref);
    }, [
        register
    ]);
    const onRefButton = (0, $5uXOq.useCallback)((ref)=>{
        register((0, $4Fbrj.INSIGHTS_BUTTON), ref);
    }, [
        register
    ]);
    const isSupported = (0, $7BuUr.useIsCurrentBrowserSupported)();
    const isDisabled = isOnboardingDisabled;
    const onClick = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, $98922b077d0d412f$var$actionSubjectId, {
            action: isInsightsPanelOpen ? 'close' : 'open',
            isDisabled: isDisabled,
            ...clickEventAnalytics?.attributes || {}
        });
        onToggle(analyticsEvent);
    }, [
        clickEventAnalytics,
        isDisabled,
        isInsightsPanelOpen,
        onToggle
    ]);
    const buttonLabelMap = {
        [(0, $f43e6cbc56ecd5ed$export$7278886766e0567e)]: {
            open: (0, $2Mspb.default).backlogInsightsLabel,
            closed: (0, $2Mspb.default).backlogInsightsLabel
        },
        [(0, $f43e6cbc56ecd5ed$export$c54b080144f4f954)]: {
            open: (0, $2Mspb.default).kanbanInsightsLabel,
            closed: (0, $2Mspb.default).kanbanInsightsLabel
        },
        [(0, $f43e6cbc56ecd5ed$export$9fd46aa549776647)]: {
            open: (0, $2Mspb.default).scrumInsightsLabel,
            closed: (0, $2Mspb.default).scrumInsightsLabel
        },
        default: {
            open: (0, $2Mspb.default).showInsights,
            closed: (0, $2Mspb.default).hideInsights
        }
    };
    const { open: open, closed: closed } = buttonLabelMap[location ?? 'default'] || buttonLabelMap.default;
    const label = isInsightsPanelOpen ? formatMessage(open) : formatMessage(closed);
    if (!isSupported) return null;
    const showInsightsButton = !isHidden;
    if (!showInsightsButton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireOperationalAnalytics), {
        action: "hidden",
        actionSubject: "button",
        actionSubjectId: $98922b077d0d412f$var$actionSubjectId
    });
    const iconColor = isInsightsPanelOpen ? undefined : "var(--ds-icon, #44546F)";
    const IconButtonComponent = isThemed && (0, $lmBAt.getIsSoftwareThemingEnabled)() ? (0, $hCCtP.ThemedIconButton) : (0, $42CjB.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
        action: "rendered",
        actionSubject: "button",
        actionSubjectId: $98922b077d0d412f$var$actionSubjectId
    }), (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "jira-insights-button"
    }, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IconButtonComponent, {
        interactionName: "show-insights-button",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bZNwM))),
        label: label,
        isSelected: isInsightsPanelOpen,
        onClick: onClick,
        testId: $98922b077d0d412f$var$buttonTestId,
        ref: onRefButton,
        isTooltipDisabled: false
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6lmg7.ResponsiveButton), {
        interactionName: "show-insights-button",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bZNwM))),
        label: label,
        iconAfter: typeof iconAfter === 'function' ? iconAfter : undefined,
        isSelected: isInsightsPanelOpen,
        onClick: onClick,
        testId: $98922b077d0d412f$var$buttonTestId,
        ref: onRefButtonResponsive
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "jira-insights-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($98922b077d0d412f$var$TooltipWrapper, {
        render: renderTooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IconButtonComponent, {
        interactionName: "show-insights-button",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bZNwM))),
        label: label,
        isSelected: isInsightsPanelOpen,
        onClick: onClick,
        testId: $98922b077d0d412f$var$buttonTestId,
        ref: onRefButton
    }))) : isCompact ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "jira-insights-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($98922b077d0d412f$var$TooltipWrapper, {
        render: renderTooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        interactionName: "show-insights-button",
        appearance: "subtle",
        spacing: "none",
        isSelected: isInsightsPanelOpen,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bZNwM))), {
            label: label,
            color: iconColor
        }),
        onClick: onClick,
        testId: $98922b077d0d412f$var$buttonTestId,
        ref: onRefSmall
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "jira-insights-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1kVqg.Show), {
        above: "lg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($98922b077d0d412f$var$TooltipWrapper, {
        render: renderTooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        interactionName: "show-insights-button",
        isSelected: isInsightsPanelOpen,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bZNwM))), {
            label: "",
            color: iconColor
        }),
        iconAfter: typeof iconAfter === 'object' ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        iconAfter : undefined,
        onClick: onClick,
        testId: $98922b077d0d412f$var$buttonTestId,
        ref: onRefButtonLarge
    }, label))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3TyLU.Hide), {
        above: "lg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($98922b077d0d412f$var$TooltipWrapper, {
        render: renderTooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        interactionName: "show-insights-button",
        isSelected: isInsightsPanelOpen,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bZNwM))), {
            label: label,
            color: iconColor
        }),
        onClick: onClick,
        testId: $98922b077d0d412f$var$buttonForHiddenTestId,
        ref: onRefSmall
    })))))));
};
const $98922b077d0d412f$export$943e069e37d25a04 = (props)=>{
    const packageName = props?.packageName ? props.packageName : (0, $4Fbrj.JIRA_INSIGHTS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "button",
        packageName: packageName,
        teamName: "helios-headcoach",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($98922b077d0d412f$export$2fdc3445dd252e1, props));
};

});
parcelRegister("bZNwM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::82e1d157ecf30f62ef37497818841c29>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8bbbcf5ce8764439$var$_react = $8bbbcf5ce8764439$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8bbbcf5ce8764439$var$_chartTrend = $8bbbcf5ce8764439$var$_interopRequireDefault((parcelRequire("7EZ5v")));

var $8bbbcf5ce8764439$var$_graphLine = $8bbbcf5ce8764439$var$_interopRequireDefault((parcelRequire("gSPJV")));
function $8bbbcf5ce8764439$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChartTrendIcon.
 * This component is ChartTrendIcon, with `UNSAFE_fallbackIcon` set to "GraphLineIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: charts, reports in Jira, and sprint insights.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8bbbcf5ce8764439$var$ChartTrendIcon = (props)=>/*#__PURE__*/ $8bbbcf5ce8764439$var$_react.default.createElement($8bbbcf5ce8764439$var$_chartTrend.default, Object.assign({
        LEGACY_fallbackIcon: $8bbbcf5ce8764439$var$_graphLine.default
    }, props));
$8bbbcf5ce8764439$var$ChartTrendIcon.Name = 'ChartTrendIconMigration';
var $8bbbcf5ce8764439$var$_default = module.exports.default = $8bbbcf5ce8764439$var$ChartTrendIcon;

});
parcelRegister("gSPJV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c4a9d2eb82ff139c$var$_react = $c4a9d2eb82ff139c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $c4a9d2eb82ff139c$var$_chartTrend = $c4a9d2eb82ff139c$var$_interopRequireDefault((parcelRequire("7EZ5v")));
function $c4a9d2eb82ff139c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c4a9d2eb82ff139c$var$GraphLineIcon = (props)=>/*#__PURE__*/ $c4a9d2eb82ff139c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M21 17H5c-.55 0-1-.45-1-1.01V6a1 1 0 1 0-2 0v9.99A3 3 0 0 0 5 19h16a1 1 0 0 0 0-2m-3-8v3a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1h-4a1 1 0 0 0 0 2z"/><path d="M13.293 13.707a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L14 11.586l-2.293-2.293a1 1 0 0 0-1.414 0l-4 4a1 1 0 0 0 1.414 1.414L11 11.414z"/></g></svg>`
    }, props, {
        newIcon: $c4a9d2eb82ff139c$var$_chartTrend.default
    }));
$c4a9d2eb82ff139c$var$GraphLineIcon.displayName = 'GraphLineIcon';
var $c4a9d2eb82ff139c$var$_default = module.exports.default = $c4a9d2eb82ff139c$var$GraphLineIcon;

});


parcelRegister("3TyLU", function(module, exports) {

$parcel$export(module.exports, "Hide", () => $f53ed0348d5d3206$export$bed28288a051538);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $8CUq3 = parcelRequire("8CUq3");

var $2pf2j = parcelRequire("2pf2j");
const $f53ed0348d5d3206$var$hideAboveQueries = (0, $2pf2j.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'none'
});
const $f53ed0348d5d3206$var$hideBelowQueries = (0, $2pf2j.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'none'
});
const $f53ed0348d5d3206$export$bed28288a051538 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $8CUq3.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            above && $f53ed0348d5d3206$var$hideAboveQueries[above],
            below && $f53ed0348d5d3206$var$hideBelowQueries[below],
            resolvedStyles.emotion
        ]
    }, children);
};

});

parcelRegister("2Mspb", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c41f59518ad2b73$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2c41f59518ad2b73$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    showInsights: {
        "id": "insights-show-insights-button.show-insights",
        "defaultMessage": "Insights"
    },
    hideInsights: {
        "id": "insights-show-insights-button.hide-insights",
        "defaultMessage": "Insights"
    },
    scrumInsightsLabel: {
        "id": "insights-show-insights-button.scrum-insights-label",
        "defaultMessage": "Sprint insights"
    },
    kanbanInsightsLabel: {
        "id": "insights-show-insights-button.kanban-insights-label",
        "defaultMessage": "Board insights"
    },
    backlogInsightsLabel: {
        "id": "insights-show-insights-button.insights-label",
        "defaultMessage": "Backlog insights"
    }
});

});


parcelRegister("4mJDy", function(module, exports) {

$parcel$export(module.exports, "BACKLOG_BUTTON_ID", () => $2b69ae47bb5ef239$export$8587b2c6e52de53f);

const $2b69ae47bb5ef239$export$8587b2c6e52de53f = `${(0, $b0e6fec6a4686296$export$d3996f57ffa8448f)}.backlog-button`;

});

parcelRegister("aokXg", function(module, exports) {

$parcel$export(module.exports, "default", () => $f69d1df268ac3a81$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f69d1df268ac3a81$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tooltip: {
        "id": "insights-backlog-button.tooltip",
        "defaultMessage": "Backlog insights"
    }
});

});


parcelRegister("5PP3a", function(module, exports) {

$parcel$export(module.exports, "BacklogInsightsNudgeAsync", () => $b5c16da729763877$export$bdccb7ceffac5743);

var $5uXOq = parcelRequire("5uXOq");

var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $b5c16da729763877$var$BacklogInsightsNudgeLazy = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("3q0hb")).then((exportedModule)=>exportedModule.BacklogInsightsNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/scrum-onboarding-tour/backlog-insights/index.tsx"
});
const $b5c16da729763877$export$bdccb7ceffac5743 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $dbbf68c32d8c4308$export$65fb0c4e534f03fc),
        fallback: children,
        attributes: {
            nudgeId: (0, $dbbf68c32d8c4308$export$1c7a80b00ad9619)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-onboarding-backlog-insights-nudge",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b5c16da729763877$var$BacklogInsightsNudgeLazy, null, children)));
$b5c16da729763877$export$bdccb7ceffac5743.displayName = 'BacklogInsightsNudgeAsync';

});
parcelRegister("3q0hb", function(module, exports) {

let $27d403a21b75fe64$var$load = (parcelRequire("28QjX"))(4);
module.exports = $27d403a21b75fe64$var$load("5dIkc").then(()=>parcelRequire('3DCtq'));

});



parcelRegister("lHl5z", function(module, exports) {

$parcel$export(module.exports, "ShareButton", () => $86d62f0e47a77ccb$export$e980dfbc2840e8bc);

var $5uXOq = parcelRequire("5uXOq");

var $jZ4fr = parcelRequire("jZ4fr");

var $imZsD = parcelRequire("imZsD");
var $5Fk4Z = parcelRequire("5Fk4Z");

var $koVbs = parcelRequire("koVbs");

var $dXq4S = parcelRequire("dXq4S");

var $5GqLe = parcelRequire("5GqLe");

var $iL8EU = parcelRequire("iL8EU");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $40Whg = parcelRequire("40Whg");
const $86d62f0e47a77ccb$export$e980dfbc2840e8bc = ({ shareContentType: shareContentType, onTriggerButtonClick: onTriggerButtonClick })=>{
    const cloudId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getCloudId));
    const boardId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getRapidViewId));
    const boardName = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getName));
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "ccEcoBoardBacklogShare"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iL8EU.ShareButton), {
        productId: "jira",
        subProductId: "jira-software",
        shareContentType: shareContentType,
        integrationType: (0, $5GqLe.integrationTypes).BOARD,
        shareTitle: boardName,
        shareFormTitle: formatMessage((0, $40Whg.default).shareFormTitle),
        objectAri: (0, $dXq4S.createAri)({
            resourceOwner: 'jira-software',
            cloudId: cloudId,
            resourceType: 'board',
            resourceId: boardId
        }),
        onTriggerButtonClick: onTriggerButtonClick,
        shareFormHelperMessage: formatMessage((0, $40Whg.default).shareHelperMessage)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jZ4fr.EngagementSpotlight), {
        name: "ccEcoBoardBacklogShare"
    }));
};

});
parcelRegister("5GqLe", function(module, exports) {

$parcel$export(module.exports, "integrationTypes", () => $0970fea694a8095f$export$a7359bcfb0ca8e98);
const $0970fea694a8095f$export$a7359bcfb0ca8e98 = {
    BENTO_ISSUE: 'bentoIssue',
    CLASSIC_BOARD: 'classicBoard',
    NEXTGEN_BOARD: 'nextGenBoard',
    ROADMAP: 'roadmap',
    TIMELINE: 'timeline',
    LIST: 'list',
    CALENDAR: 'calendar',
    BOARD: 'board',
    FORM: 'form',
    SUMMARY: 'summary',
    ATTACHMENTS: 'attachments',
    DEPENDENCIES: 'dependencies',
    INCREMENT: 'increment',
    QUEUE: 'queue'
};

});

parcelRegister("iL8EU", function(module, exports) {

$parcel$export(module.exports, "ShareLoadingPlaceholder", () => $4e5335f44d688bbf$export$5619d05bf511476b);
$parcel$export(module.exports, "ShareButtonAnalyticsWrapperWithGating", () => $4e5335f44d688bbf$export$593c5080db936480);
$parcel$export(module.exports, "ShareButton", () => $4e5335f44d688bbf$export$e980dfbc2840e8bc);
$parcel$export(module.exports, "ShareButtonAsync", () => $4e5335f44d688bbf$export$3585ee2128ae4c25);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $kOEld = parcelRequire("kOEld");

var $42CjB = parcelRequire("42CjB");

var $1PVpv = parcelRequire("1PVpv");

var $empdx = parcelRequire("empdx");

var $b71gk = parcelRequire("b71gk");

var $koVbs = parcelRequire("koVbs");

var $cfDZ3 = parcelRequire("cfDZ3");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $itmJb = parcelRequire("itmJb");

var $4R6GH = parcelRequire("4R6GH");

var $dAfqg = parcelRequire("dAfqg");

var $7XYc4 = parcelRequire("7XYc4");

var $67hPg = parcelRequire("67hPg");
var $kNJSJ = parcelRequire("kNJSJ");

var $7CMCs = parcelRequire("7CMCs");

var $iXVV6 = parcelRequire("iXVV6");

var $2vSU6 = parcelRequire("2vSU6");

var $Kpokz = parcelRequire("Kpokz");

var $8BVfN = parcelRequire("8BVfN");
const $4e5335f44d688bbf$export$5619d05bf511476b = ({ triggerButtonStyle: triggerButtonStyle = 'icon-only' })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kOEld))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: formatMessage((0, $Kpokz.messages).shareTriggerButtonText),
            color: "var(--ds-icon, #44546F)"
        }),
        isDisabled: true
    }, triggerButtonStyle === 'icon-with-text' ? formatMessage((0, $Kpokz.messages).shareTriggerButtonText) : null));
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $4e5335f44d688bbf$var$ShareButtonBase = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("dsrMt")), {
    ssr: false,
    moduleId: "./src/packages/growth/share-button/src/ui/index.tsx"
});
const $4e5335f44d688bbf$var$ShareButtonAnalyticsWrapper = ({ children: children })=>{
    const { data: data } = (0, $dAfqg.useProjectContext)();
    const projectKey = data?.projectKey || '';
    const projectType = data?.projectType;
    const projectStyle = data?.simplified ? (0, $2vSU6.TEAM_MANAGED_PROJECT) : (0, $2vSU6.COMPANY_MANAGED_PROJECT);
    const userLocation = (0, $cfDZ3.getUserLocation)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const isProjectAdmin = data?.isProjectAdmin || false;
    const analyticsData = (0, $5uXOq.useMemo)(()=>{
        const projectContextData = projectKey ? {
            projectType: projectType,
            projectStyle: projectStyle,
            isProjectAdmin: isProjectAdmin
        } : undefined;
        return {
            isAdmin: isAdmin,
            userLocation: userLocation,
            ...projectContextData
        };
    }, [
        projectKey,
        projectType,
        projectStyle,
        isProjectAdmin,
        userLocation,
        isAdmin
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: analyticsData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1PVpv.FabricElementsAnalyticsContext), {
        data: analyticsData
    }, children));
};
const $4e5335f44d688bbf$export$593c5080db936480 = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jsw-smart-access-extended-analytics-enabled'), $4e5335f44d688bbf$var$ShareButtonAnalyticsWrapper, (0, $5uXOq.Fragment));
const $4e5335f44d688bbf$export$e980dfbc2840e8bc = (props)=>(0, $4R6GH.fg)('migrate_share_dialog_error_boundary') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$593c5080db936480, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "async.share.button",
        packageName: "share-button",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "share-button",
        fallback: props.renderCustomTriggerButton === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$5619d05bf511476b, {
            triggerButtonStyle: props.triggerButtonStyle
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(props.renderCustomTriggerButton, {
            isDisabled: true,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$var$ShareButtonBase, props)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "async.share.button",
        packageName: "share-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "share-button",
        fallback: props.renderCustomTriggerButton === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$5619d05bf511476b, {
            triggerButtonStyle: props.triggerButtonStyle
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(props.renderCustomTriggerButton, {
            isDisabled: true,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$593c5080db936480, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$var$ShareButtonBase, props))));
const $4e5335f44d688bbf$export$3585ee2128ae4c25 = (props)=>{
    const { Panel: Panel, trigger: trigger } = (0, $kNJSJ.usePanel)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({}), []);
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            ...props
        }), [
        props
    ]);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: props.errorBoundaryId,
        packageName: "jiraShareButton",
        teamName: props.teamName,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $67hPg.Trigger), {
        trigger: trigger,
        entryPoint: (0, $8BVfN.shareButtonEntryPoint),
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps
    }, ({ ref: ref })=>!isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref: ref,
            testId: "share-button.button",
            label: formatMessage((0, $Kpokz.messages).shareTriggerButtonText),
            appearance: "default",
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($empdx))), {
                    spacing: "spacious",
                    label: "",
                    color: "var(--ds-icon, #44546F)"
                }),
            onClick: ()=>setIsOpen(true)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Panel, null));
};

});
parcelRegister("kOEld", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::eddb3c8fd23121248d7a9663e3c0819a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f277c50ed79b6741$var$_react = $f277c50ed79b6741$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f277c50ed79b6741$var$_share = $f277c50ed79b6741$var$_interopRequireDefault((parcelRequire("empdx")));

var $f277c50ed79b6741$var$_share2 = $f277c50ed79b6741$var$_interopRequireDefault((parcelRequire("jZX0t")));
function $f277c50ed79b6741$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShareIcon.
 * This component is ShareIcon, with `UNSAFE_fallbackIcon` set to "ShareIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f277c50ed79b6741$var$ShareIcon = (props)=>/*#__PURE__*/ $f277c50ed79b6741$var$_react.default.createElement($f277c50ed79b6741$var$_share.default, Object.assign({
        LEGACY_fallbackIcon: $f277c50ed79b6741$var$_share2.default
    }, props));
$f277c50ed79b6741$var$ShareIcon.Name = 'ShareIconMigration';
var $f277c50ed79b6741$var$_default = module.exports.default = $f277c50ed79b6741$var$ShareIcon;

});
parcelRegister("jZX0t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e8f17c524b03e26b$var$_react = $e8f17c524b03e26b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $e8f17c524b03e26b$var$_share = $e8f17c524b03e26b$var$_interopRequireDefault((parcelRequire("empdx")));
function $e8f17c524b03e26b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e8f17c524b03e26b$var$ShareIcon = (props)=>/*#__PURE__*/ $e8f17c524b03e26b$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m12-4a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/><path d="m7 13.562 8.66 5 1-1.732-8.66-5z"/><path d="m7 10.83 1 1.732 8.66-5-1-1.732z"/></g></svg>`
    }, props, {
        newIcon: $e8f17c524b03e26b$var$_share.default
    }));
$e8f17c524b03e26b$var$ShareIcon.displayName = 'ShareIcon';
var $e8f17c524b03e26b$var$_default = module.exports.default = $e8f17c524b03e26b$var$ShareIcon;

});


parcelRegister("67hPg", function(module, exports) {

$parcel$export(module.exports, "Trigger", () => $f5abbb29b5666c06$export$41fb9f06171c75f4);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $3Du7S = parcelRequire("3Du7S");

var $7F2yO = parcelRequire("7F2yO");

var $kKgGa = parcelRequire("kKgGa");

var $e2pRJ = parcelRequire("e2pRJ");

var $hDhQq = parcelRequire("hDhQq");
const $f5abbb29b5666c06$var$emptyEntryPointParams = {};
const $f5abbb29b5666c06$var$emptyEntryPointProps = {};
function $f5abbb29b5666c06$export$41fb9f06171c75f4({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, fallback: fallback, errorFallback: errorFallback, forwardedRef: forwardedRef, trigger: trigger }) {
    const { setPanel: setPanel } = trigger;
    const environmentProvider = (0, $e2pRJ.useRelayEnvironmentProvider)();
    const id = (0, $5uXOq.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const load = (0, $5uXOq.useCallback)(()=>(0, $8Uumt.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $f5abbb29b5666c06$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $5uXOq.useCallback)(({ reference: entryPointReference })=>{
        setPanel(/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kKgGa.InternalEntryPointContainer), {
            id: id,
            entryPointReference: entryPointReference,
            fallback: fallback || /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hDhQq.DefaultFallback), {}),
            errorFallback: errorFallback,
            runtimeProps: entryPointProps || $f5abbb29b5666c06$var$emptyEntryPointProps
        }));
    }, [
        setPanel,
        id,
        entryPointProps,
        fallback,
        errorFallback
    ]);
    const triggerRef = (0, $7F2yO.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad
    });
    const mergedRef = (0, $3Du7S.useMergeRefs)([
        triggerRef,
        forwardedRef || null
    ]);
    return children({
        ref: mergedRef
    });
}

});
parcelRegister("hDhQq", function(module, exports) {

$parcel$export(module.exports, "DefaultFallback", () => $5d43ace1d77c91f8$export$93c734e924cdbdaa);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $iwwXK = parcelRequire("iwwXK");
function $5d43ace1d77c91f8$export$93c734e924cdbdaa() {
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iwwXK.default), {}),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iwwXK.default), {}),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iwwXK.default), {}),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iwwXK.default), {})
        ]
    });
}

});


parcelRegister("kNJSJ", function(module, exports) {

$parcel$export(module.exports, "usePanel", () => $0ef0a2f3e739e762$export$9168a42f32e3d071);

var $5uXOq = parcelRequire("5uXOq");
function $0ef0a2f3e739e762$export$9168a42f32e3d071(preloadedPanel) {
    const [panel, setPanel] = (0, $5uXOq.useState)(preloadedPanel);
    const Panel = (0, $5uXOq.useMemo)(()=>{
        const PanelComponent = ()=>panel ?? null;
        return PanelComponent;
    }, [
        panel
    ]);
    const trigger = (0, $5uXOq.useMemo)(()=>({
            setPanel: (panel)=>setPanel(panel)
        }), [
        setPanel
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            Panel: Panel,
            trigger: trigger
        }), [
        Panel,
        trigger
    ]);
}

});

parcelRegister("Kpokz", function(module, exports) {

$parcel$export(module.exports, "messages", () => $026d1258a1c95d57$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $026d1258a1c95d57$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    shareTriggerButtonText: {
        "id": "share-button.share-trigger-button-text",
        "defaultMessage": "Share"
    }
});

});

parcelRegister("8BVfN", function(module, exports) {

$parcel$export(module.exports, "shareButtonEntryPoint", () => $735d063ad5974451$export$ad8b1559c594245d);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $735d063ad5974451$export$ad8b1559c594245d = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>{
        if (!false) return (parcelRequire("2YwsS"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "50ae946e"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("2YwsS", function(module, exports) {

let $22aa5e30b1ec71b3$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $22aa5e30b1ec71b3$var$load("3yAl4"),
    $22aa5e30b1ec71b3$var$load("76n7a"),
    $22aa5e30b1ec71b3$var$load("l253H"),
    $22aa5e30b1ec71b3$var$load("kNFvF"),
    $22aa5e30b1ec71b3$var$load("ffQaD"),
    $22aa5e30b1ec71b3$var$load("kvRbA"),
    $22aa5e30b1ec71b3$var$load("lMH7t")
]).then(()=>parcelRequire('8kufr'));

});


parcelRegister("dsrMt", function(module, exports) {

let $9cc3709afec5d7a8$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $9cc3709afec5d7a8$var$load("3yAl4"),
    $9cc3709afec5d7a8$var$load("76n7a"),
    $9cc3709afec5d7a8$var$load("l253H"),
    $9cc3709afec5d7a8$var$load("kNFvF"),
    $9cc3709afec5d7a8$var$load("ffQaD"),
    $9cc3709afec5d7a8$var$load("kvRbA"),
    $9cc3709afec5d7a8$var$load("61BKk")
]).then(()=>parcelRequire('7aU9g'));

});


parcelRegister("40Whg", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1d20aca9fbb0156$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d1d20aca9fbb0156$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    shareFormTitle: {
        "id": "backlog.header.actions-bar.share-button.share-form-title",
        "defaultMessage": "Share"
    },
    shareHelperMessage: {
        "id": "backlog.header.actions-bar.share-button.share-helper-message",
        "defaultMessage": "This view, along with any applied groups and filters are shared"
    }
});

});


parcelRegister("fFw8N", function(module, exports) {

$parcel$export(module.exports, "BacklogViewSettings", () => $4f4aad3065aa3b41$export$c0bf3e52465abf3b);

var $5uXOq = parcelRequire("5uXOq");

var $gccSB = parcelRequire("gccSB");

var $4R6GH = parcelRequire("4R6GH");

var $a4XJc = parcelRequire("a4XJc");

var $jB6yt = parcelRequire("jB6yt");

var $38RF4 = parcelRequire("38RF4");


var $a7yHf = parcelRequire("a7yHf");

var $c1MAf = parcelRequire("c1MAf");

var $9g0YE = parcelRequire("9g0YE");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $9Pc1U = parcelRequire("9Pc1U");

var $le1bQ = parcelRequire("le1bQ");

var $fpDLy = parcelRequire("fpDLy");

var $c060Z = parcelRequire("c060Z");
const $4f4aad3065aa3b41$export$c0bf3e52465abf3b = ({ isThemed: isThemed })=>{
    const rapidViewId = (0, $c1MAf.useBacklogSelector)((state)=>Number((0, $jG5HW.getRapidViewId)(state)));
    const isClassic = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
    const showEpicAsPanel = (0, $c1MAf.useBacklogSelector)((0, $9Pc1U.getShowEpicAsPanel));
    const isVersionsEnabled = (0, $c1MAf.useBacklogSelector)((0, $fpDLy.isVersionsFeatureEnabled));
    const onTogglePanel = (0, $c1MAf.useBacklogActionCreator)((0, $9g0YE.togglePanel));
    const isCompanyManaged = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
    const config = (0, $c1MAf.useBacklogSelector)((0, $9Pc1U.getConfig));
    const epicCustomName = config.hierarchyNomenclature?.firstLevelName;
    const allCardGroups = (0, $le1bQ.useAllCardGroups)();
    const isDataLoaded = (0, $c1MAf.useBacklogSelector)((0, $9Pc1U.isCriticalDataLoaded));
    const cardExtraFields = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCardExtraFields));
    const hasCardsWithPriority = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasPriority));
    const isDueDateEnabled = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasDueDate));
    const hasCardsWithStoryPoint = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasStoryPoints));
    const hasCardsWithEstimate = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasEstimates));
    const isViewSettingPanelOpen = (0, $c060Z.useIsViewSettingsPanelOpen)();
    const showFilterBarToggle = isCompanyManaged;
    const areAllSubtasksExpanded = (0, $5uXOq.useMemo)(()=>allCardGroups.every((card)=>!card.isCollapsed), [
        allCardGroups
    ]);
    const areAllSubtasksCollapsed = (0, $5uXOq.useMemo)(()=>allCardGroups.every((card)=>card.isCollapsed), [
        allCardGroups
    ]);
    const handleExpandSubtasks = (0, $5uXOq.useCallback)(()=>{
        (0, $a7yHf.setExpandedCardGroups)(allCardGroups.map((card)=>card.parentId.toString()));
    }, [
        allCardGroups
    ]);
    const handleCollapseSubtasks = (0, $5uXOq.useCallback)(()=>{
        (0, $a7yHf.collapseAllCardGroups)();
    }, []);
    const handleViewSettingPanelToggle = (0, $5uXOq.useCallback)(()=>{
        onTogglePanel((0, $c35fd6591a78fffe$export$ba1da943283b9900));
    }, [
        onTogglePanel
    ]);
    const shouldShowSubtasks = (0, $5uXOq.useMemo)(()=>!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(allCardGroups), [
        allCardGroups
    ]);
    return (0, $4R6GH.fg)('jira_view_settings_additional_fields') ? isDataLoaded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38RF4.ViewSettingsSyncFromLocalStorageWrapper), {
        boardId: rapidViewId,
        view: (0, $a4XJc.View).BACKLOG,
        cardExtraFields: cardExtraFields,
        isVersionsEnabled: isVersionsEnabled,
        isEstimateEnabled: hasCardsWithStoryPoint || hasCardsWithEstimate,
        showEpicAsPanel: showEpicAsPanel,
        isDueDateEnabled: !isCompanyManaged && isDueDateEnabled,
        isPriorityEnabled: hasCardsWithPriority
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38RF4.ViewSettingsButton), {
        isSelected: isViewSettingPanelOpen,
        onClick: handleViewSettingPanelToggle,
        isThemedButton: isThemed
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jB6yt.default), {
        view: (0, $a4XJc.View).BACKLOG,
        boardId: rapidViewId,
        isClassic: isClassic,
        areSubtasksEnabled: isCompanyManaged && shouldShowSubtasks,
        onSubtasksExpandAll: handleExpandSubtasks,
        onSubtasksCollapseAll: handleCollapseSubtasks,
        areAllSubtasksExpanded: areAllSubtasksExpanded,
        areAllSubtasksCollapsed: areAllSubtasksCollapsed,
        showEpicAsPanel: showEpicAsPanel,
        epicCustomName: epicCustomName,
        isVersionsEnabled: isVersionsEnabled,
        showFilterBarToggle: showFilterBarToggle,
        isThemed: isThemed
    });
};

});


parcelRegister("bONT7", function(module, exports) {

$parcel$export(module.exports, "default", () => $93b49e9ab60b23fb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $88tXZ = parcelRequire("88tXZ");

var $iU0UM = parcelRequire("iU0UM");


var $8MHVw = parcelRequire("8MHVw");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");

var $l9VFH = parcelRequire("l9VFH");
const $93b49e9ab60b23fb$var$FilterSelectionBarContainer = ()=>{
    const [selectedFilters, { setFilters: setFilters }] = (0, $88tXZ.useFilters)();
    const allFilters = (0, $c1MAf.useBacklogSelector)((0, $l9VFH.getCMPFilters));
    const cardIds = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCardIds));
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const onChange = (0, $5uXOq.useCallback)((filters, analyticsEvent)=>{
        dispatch((0, $8MHVw.filteredCardsRequest)(cardIds, analyticsEvent, filters[0, $41ce9b5576b92b7a$export$68d693c35a8d8866]));
        setFilters({
            ...selectedFilters,
            ...filters
        });
    }, [
        selectedFilters,
        dispatch,
        cardIds,
        setFilters
    ]);
    const selectedFilterSet = (0, $5uXOq.useMemo)(()=>new Set(selectedFilters[0, $41ce9b5576b92b7a$export$68d693c35a8d8866]), [
        selectedFilters
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iU0UM.default), {
        selectedFilters: selectedFilterSet,
        onChange: onChange,
        filters: allFilters
    });
};
var $93b49e9ab60b23fb$export$2e2bcd8739ae039 = $93b49e9ab60b23fb$var$FilterSelectionBarContainer;

});
parcelRegister("iU0UM", function(module, exports) {

$parcel$export(module.exports, "default", () => $8822a2681eb1c63b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $a2e2Q = parcelRequire("a2e2Q");

var $caqPj = parcelRequire("caqPj");

var $euWQZ = parcelRequire("euWQZ");
const $8822a2681eb1c63b$var$FilterSelectionBar = ({ onChange: onChange, selectedFilters: selectedFilters, filters: filters })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { isSoftwareFullTheming: isSoftwareFullTheming } = (0, $a2e2Q.useSoftwareProjectTheming)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("fieldset", {
        "data-testid": "software-filters.ui.filter-selection-bar.filter-selection-bar",
        className: (0, $bwpsq.default)([
            "_1reo1g80 _18m91g80 _zulpu2gc _qtt8glyw _1bsb1osq _1e0c1txw _19pku2gc _1n261g80"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("legend", {
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c"
        ])
    }, formatMessage((0, $euWQZ.default).filterToolBarAriaLabel)), filters.map((filter)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $caqPj.default), {
            key: `filter-option-${filter.id}`,
            onChange: onChange,
            selectedFilters: selectedFilters,
            filter: filter,
            isThemed: isSoftwareFullTheming
        })));
};
var $8822a2681eb1c63b$export$2e2bcd8739ae039 = $8822a2681eb1c63b$var$FilterSelectionBar;
const $8822a2681eb1c63b$var$styles = null;

});
parcelRegister("caqPj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ef490007e1102a8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $2NMNM = parcelRequire("2NMNM");

var $hCCtP = parcelRequire("hCCtP");

var $lmBAt = parcelRequire("lmBAt");

var $4R6GH = parcelRequire("4R6GH");

var $a38Ao = parcelRequire("a38Ao");

var $5MHig = parcelRequire("5MHig");
const $8ef490007e1102a8$var$FilterOption = (props)=>{
    const { onChange: onChange, selectedFilters: selectedFilters, filter: filter, isThemed: isThemed } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isSelected = (0, $5uXOq.useMemo)(()=>selectedFilters.has(filter.id), [
        selectedFilters,
        filter
    ]);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (isSelected) selectedFilters.delete(filter.id);
        else selectedFilters.add(filter.id);
        onChange({
            CUSTOM_FILTER: Array.from(selectedFilters)
        }, createAnalyticsEvent({}));
    }, [
        onChange,
        filter,
        isSelected,
        selectedFilters,
        createAnalyticsEvent
    ]);
    const id = (0, $4R6GH.fg)('jsw-cmp-quick-filter-same-name-issue') ? `checkbox-id-${filter.name}-${filter.id}` : `checkbox-id-${filter.name}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: filter.description,
        position: "bottom",
        "data-testid": "software-filters.ui.filter-selection-bar.filter-option.tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $8ef490007e1102a8$var$maxWidthWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a38Ao.default), {
        id: id,
        checked: isSelected,
        onChange: onClick
    }), isThemed && (0, $lmBAt.getIsSoftwareThemingEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCCtP.ThemedButtonWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        id: id,
        isSelected: isSelected,
        component: (0, $5MHig.default)
    }, filter.name)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        id: id,
        isSelected: isSelected,
        component: (0, $5MHig.default)
    }, filter.name)));
};
var $8ef490007e1102a8$export$2e2bcd8739ae039 = $8ef490007e1102a8$var$FilterOption;
const $8ef490007e1102a8$var$maxWidthWrapperStyles = (0, $8CUq3.xcss)({
    maxWidth: '380px'
});

});
parcelRegister("a38Ao", function(module, exports) {

$parcel$export(module.exports, "default", () => $9843dc35bcc8c6ea$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");
const $9843dc35bcc8c6ea$var$HiddenCheckbox = (props)=>{
    const { id: id, checked: checked, onChange: onChange } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
        id: id,
        type: "checkbox",
        checked: checked,
        onChange: onChange,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c _81qxugt7 _ui4mv77o"
        ])
    });
};
var $9843dc35bcc8c6ea$export$2e2bcd8739ae039 = $9843dc35bcc8c6ea$var$HiddenCheckbox;
const $9843dc35bcc8c6ea$var$styles = null;

});

parcelRegister("5MHig", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd0acb68a7fed3bf$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");
const $dd0acb68a7fed3bf$var$Label = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("label", {
        ref: ref,
        htmlFor: props.id,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_uiztglyw",
            props.className
        ]),
        // eslint-disable-next-line react/no-children-prop
        children: props.children
    }));
var $dd0acb68a7fed3bf$export$2e2bcd8739ae039 = $dd0acb68a7fed3bf$var$Label;
const $dd0acb68a7fed3bf$var$styles = null;

});


parcelRegister("euWQZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d55c59fbc57ecf3b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d55c59fbc57ecf3b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    filterToolBarAriaLabel: {
        "id": "software-filters.filter-selection-bar.filter-tool-bar-aria-label",
        "defaultMessage": "filter tool bar"
    }
});

});



parcelRegister("4hApq", function(module, exports) {

$parcel$export(module.exports, "default", () => $80ce6ab608ed8152$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $a7yHf = parcelRequire("a7yHf");

var $9g0YE = parcelRequire("9g0YE");

var $jG5HW = parcelRequire("jG5HW");

var $9Pc1U = parcelRequire("9Pc1U");

var $k35me = parcelRequire("k35me");

var $fpDLy = parcelRequire("fpDLy");

var $fxbvZ = parcelRequire("fxbvZ");

var $l5nOr = parcelRequire("l5nOr");

var $7ml2y = parcelRequire("7ml2y");
var $80ce6ab608ed8152$export$2e2bcd8739ae039 = (0, $bC2fB.connect)((state)=>({
        rapidViewId: Number((0, $jG5HW.getRapidViewId)(state)),
        isBacklogWithSprints: (0, $k35me.isBacklogWithSprints)(state),
        FilterBar: $l5nOr.default,
        Operations: $fxbvZ.default,
        isClassic: (0, $jG5HW.getIsCompanyManaged)(state),
        showEpicAsPanel: (0, $9Pc1U.getShowEpicAsPanel)(state),
        isVersionsEnabled: (0, $fpDLy.isVersionsFeatureEnabled)(state)
    }), {
    onTogglePanel: (0, $9g0YE.togglePanel),
    onSubtasksExpandAll: (0, $a7yHf.setExpandedCardGroups),
    onSubtasksCollapseAll: (0, $a7yHf.collapseAllCardGroups)
})((0, $7ml2y.ControlsBar));

});
parcelRegister("l5nOr", function(module, exports) {

$parcel$export(module.exports, "default", () => $35d0272eac005333$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $8QpSo = parcelRequire("8QpSo");

var $7wqBZ = parcelRequire("7wqBZ");

var $bC2fB = parcelRequire("bC2fB");

var $88tXZ = parcelRequire("88tXZ");

var $1bQGJ = parcelRequire("1bQGJ");

var $dCm1o = parcelRequire("dCm1o");



var $h9NU3 = parcelRequire("h9NU3");

var $9Z18E = parcelRequire("9Z18E");

var $8MHVw = parcelRequire("8MHVw");

var $9g0YE = parcelRequire("9g0YE");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $l9VFH = parcelRequire("l9VFH");

var $f9Swb = parcelRequire("f9Swb");

var $fmuR9 = parcelRequire("fmuR9");

var $fC5rN = parcelRequire("fC5rN");

var $l89dM = parcelRequire("l89dM");

var $1z1J7 = parcelRequire("1z1J7");

var $fpDLy = parcelRequire("fpDLy");

var $fSgHa = parcelRequire("fSgHa");

var $aTx7m = parcelRequire("aTx7m");

var $cFqzj = parcelRequire("cFqzj");
const $35d0272eac005333$export$148c63f5480aef70 = (state)=>(0, $jG5HW.getIsCompanyManaged)(state) ? true // we always want to show the link so user can see read-only board settings page even with no edit board permission
     : (0, $1z1J7.canEditBoardConfig)(state);
const $35d0272eac005333$var$isVisualRefreshDisabled = ()=>{
    return !(0, $dCm1o.isVisualRefreshEnabled)();
};
const $35d0272eac005333$export$c31df4bd766f9c35 = (state)=>{
    const isCompanyManaged = (0, $jG5HW.getIsCompanyManaged)(state);
    return {
        assignees: (0, $dGljH.getOrderedAssignees)(state),
        filter: (0, $l9VFH.getFilters)(state),
        panels: (0, $l89dM.getPanels)(state),
        labels: (0, $dGljH.getOrderedLabels)(state),
        issueTypes: (0, $dGljH.getOrderedCardTypes)(state),
        maxAvatars: (0, $41ce9b5576b92b7a$export$360e7ca29749d455),
        isAddPeopleButtonEnabled: (0, $1z1J7.canEditBoardConfig)(state) && $35d0272eac005333$var$isVisualRefreshDisabled(),
        isCustomFilterManageLinkEnabled: $35d0272eac005333$export$148c63f5480aef70(state),
        isVersionFilterSpotlightEnabled: (0, $1z1J7.canEditBoardConfig)(state),
        issueParentsLabel: isCompanyManaged ? (0, $f9Swb.getFirstLevelHierarchyName)(state) || (0, $fmuR9.firstParentIssueTypeNameSelector)(state) : (0, $fmuR9.firstParentIssueTypeNameSelector)(state),
        issueParents: (0, $fmuR9.issueParentsToListItemSelector)(state),
        isAnyModalOpen: (0, $fC5rN.isAnyModalOpen)(state),
        boardId: Number((0, $jG5HW.getRapidViewId)(state)),
        isVersionsFeatureEnabled: (0, $fpDLy.isVersionsFeatureEnabled)(state),
        projectId: (0, $jG5HW.projectIdSelector)(state),
        projectName: (0, $jG5HW.getProjectName)(state),
        projectKey: (0, $jG5HW.getProjectKey)(state),
        cardIds: (0, $dGljH.getCardIds)(state),
        isCustomFiltersLoading: (0, $dGljH.isFilteredCardsLoading)(state),
        isEpicPanelOpen: (0, $h9NU3.isIssueParentPanelOpen)(),
        isVersionPanelOpen: (0, $h9NU3.isVersionPanelOpen)(),
        isCompanyManaged: isCompanyManaged
    };
};
const $35d0272eac005333$var$mapDispatchToProps = (dispatch)=>({
        dispatch: dispatch
    });
const $35d0272eac005333$var$getOnChange = (0, $8QpSo.default)((issueIds, dispatch, syncFiltersWithRemoteStore)=>(filters, filterType, _, analyticsEvent)=>{
        if (filterType === (0, $41ce9b5576b92b7a$export$68d693c35a8d8866)) // @ts-expect-error Argument of type 'UIAnalyticsEvent | undefined' is not assignable to parameter of type 'UIAnalyticsEvent'.
        dispatch((0, $8MHVw.filteredCardsRequest)(issueIds, analyticsEvent, filters[0, $41ce9b5576b92b7a$export$68d693c35a8d8866]));
        else (0, $7wqBZ.getLongTasksMetrics)('filter').start('backlog');
        syncFiltersWithRemoteStore(filters);
        if (filterType !== (0, $41ce9b5576b92b7a$export$68d693c35a8d8866)) dispatch((0, $9Z18E.cardAutoScrollRequestOnFilter)());
    });
const $35d0272eac005333$var$getClearAllFilters = (0, $8QpSo.default)((dispatch, isCompanyManaged)=>(event, analyticsEvent)=>{
        isCompanyManaged ? dispatch((0, $8MHVw.clearFilteredCardsRequest)(analyticsEvent)) : dispatch((0, $8MHVw.clearFilteredCards)());
        dispatch((0, $9Z18E.cardAutoScrollRequestOnFilter)());
    });
const $35d0272eac005333$var$getOnToggleParentPanel = (0, $8QpSo.default)((dispatch)=>()=>{
        dispatch((0, $9g0YE.togglePanel)((0, $c35fd6591a78fffe$export$a10c132b86ae798b)));
    });
const $35d0272eac005333$var$getOnToggleVersionsPanel = (0, $8QpSo.default)((dispatch)=>()=>{
        dispatch((0, $9g0YE.togglePanel)((0, $c35fd6591a78fffe$export$41073ac826c57195)));
    });
const $35d0272eac005333$export$9d1611c77c2fe928 = (stateProps, dispatchProps, ownProps)=>{
    const { assignees: assignees, filter: filter, panels: panels, labels: labels, maxAvatars: maxAvatars, isAddPeopleButtonEnabled: isAddPeopleButtonEnabled, isCustomFilterManageLinkEnabled: isCustomFilterManageLinkEnabled, isVersionFilterSpotlightEnabled: isVersionFilterSpotlightEnabled, issueParentsLabel: issueParentsLabel, issueParents: issueParents, issueTypes: issueTypes, boardId: boardId, isVersionsFeatureEnabled: isVersionsFeatureEnabled, projectId: projectId, projectName: projectName, projectKey: projectKey, cardIds: cardIds, isCustomFiltersLoading: isCustomFiltersLoading, isVersionPanelOpen: isVersionsOpen, isEpicPanelOpen: isEpicPanelOpen, isCompanyManaged: isCompanyManaged } = stateProps;
    const { dispatch: dispatch } = dispatchProps;
    const { customFiltersQueryRef: customFiltersQueryRef, versionFilterRelayQueryRef: versionFilterRelayQueryRef } = ownProps;
    return {
        assignees: assignees,
        filter: filter,
        panels: panels,
        labels: labels,
        maxAvatars: maxAvatars,
        isAddPeopleButtonEnabled: isAddPeopleButtonEnabled,
        isCustomFilterManageLinkEnabled: isCustomFilterManageLinkEnabled,
        isVersionFilterSpotlightEnabled: isVersionFilterSpotlightEnabled,
        issueParentsLabel: issueParentsLabel,
        issueParents: issueParents,
        issueTypes: issueTypes,
        AddPeopleModal: $aTx7m.default,
        boardId: boardId,
        isVersionsFeatureEnabled: isVersionsFeatureEnabled,
        isCustomFiltersLoading: isCustomFiltersLoading,
        projectId: projectId,
        projectName: projectName,
        projectKey: projectKey,
        onChange: $35d0272eac005333$var$getOnChange(cardIds, dispatch, ownProps.syncFiltersWithRemoteStore),
        onToggleParentPanel: $35d0272eac005333$var$getOnToggleParentPanel(dispatch),
        isIssueParentPanelToggleChecked: isEpicPanelOpen,
        onToggleVersionsPanel: $35d0272eac005333$var$getOnToggleVersionsPanel(dispatch),
        isVersionPanelToggleChecked: isVersionsOpen,
        onClearAllButtonClicked: $35d0272eac005333$var$getClearAllFilters(dispatch, isCompanyManaged),
        customFiltersQueryRef: customFiltersQueryRef,
        versionFilterRelayQueryRef: versionFilterRelayQueryRef,
        isCompanyManaged: isCompanyManaged
    };
};
const $35d0272eac005333$var$connector = (0, $bC2fB.connect)($35d0272eac005333$export$c31df4bd766f9c35, $35d0272eac005333$var$mapDispatchToProps, $35d0272eac005333$export$9d1611c77c2fe928);
// @ts-expect-error - TS2345 - Argument of type 'ComponentType<WithIntlProps<APIProps & { intl: IntlShapeV2; customFiltersQueryRef?: PreloadedQuery<viewBacklogCustomFiltersQuery, Record<string, unknown>> | null | undefined; versionFilterRelayQueryRef?: PreloadedQuery<...> | ... 1 more ... | undefined; }>>' is not assignable to parameter of type 'Component<{ assignees: Person[]; filter: Filters; panels: PanelState; labels: string[]; maxAvatars: number; isAddPeopleButtonEnabled: boolean; isCustomFilterManageLinkEnabled: boolean; ... 16 more ...; versionFilterRelayQueryRef: PreloadedQuery<...> | ... 1 more ... | undefined; }>'.
const $35d0272eac005333$var$ConnectedFilterBar = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))($35d0272eac005333$var$connector, (0, $1bQGJ.withRouter))((0, $cFqzj.default));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$35d0272eac005333$export$2e2bcd8739ae039 = ({ customFiltersQueryRef: customFiltersQueryRef, versionFilterRelayQueryRef: versionFilterRelayQueryRef })=>{
    const [filters, { setFilters: setFilters }] = (0, $88tXZ.useFilters)();
    const isCompanyManaged = (0, $fSgHa.useIsCMPBacklog)();
    // Temporary remove custom filters from the url on initial load for team-managed backlog.
    // Need to be removed when applying custom filters on initial load.
    const self = (0, $5uXOq.useRef)({
        isMounted: false
    }).current;
    (0, $5uXOq.useEffect)(()=>{
        if (!self.isMounted) {
            if (isCompanyManaged) setFilters(filters);
            else {
                const { [(0, $41ce9b5576b92b7a$export$68d693c35a8d8866)]: customFilters, ...otherFilters } = filters;
                setFilters(otherFilters);
            }
        }
        self.isMounted = true;
    }, [
        self,
        filters,
        setFilters,
        isCompanyManaged
    ]);
    return(// @ts-expect-error - TS2739 - Type '{ syncFiltersWithRemoteStore: (filters: Filters) => void | Promise<void>; customFiltersQueryRef: PreloadedQuery<viewBacklogCustomFiltersQuery, Record<...>> | null | undefined; versionFilterRelayQueryRef: PreloadedQuery<...> | ... 1 more ... | undefined; }' is missing the following properties from type 'RouteContext': location, query, route, match, action.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($35d0272eac005333$var$ConnectedFilterBar, {
        syncFiltersWithRemoteStore: setFilters,
        customFiltersQueryRef: customFiltersQueryRef,
        versionFilterRelayQueryRef: versionFilterRelayQueryRef
    }));
};

});
parcelRegister("aTx7m", function(module, exports) {

$parcel$export(module.exports, "default", () => $539d7fb08de3dccf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $2vSU6 = parcelRequire("2vSU6");

var $fjJ1B = parcelRequire("fjJ1B");

var $kxZPA = parcelRequire("kxZPA");
var $6Lg6A = parcelRequire("6Lg6A");


var $jG5HW = parcelRequire("jG5HW");

var $c1MAf = parcelRequire("c1MAf");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $539d7fb08de3dccf$var$AddPeopleModal = (0, $kxZPA.lazy)(()=>(parcelRequire("4XHmI")), {
    moduleId: "./src/packages/permissions-administration/components/project-add-people/src/index.tsx"
});
const $539d7fb08de3dccf$var$AddPeopleModalWrapper = ({ isOpen: isOpen, onClose: onClose = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onError: onError = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onAddSuccess: onAddSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onStopPerfMetric: onStopPerfMetric = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), ...props })=>{
    const projectId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.projectIdSelector));
    const projectKey = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getProjectKey));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fjJ1B.AddPeopleModalBoundary), {
        packageName: (0, $a9c483c0d986286a$export$dfd208682d29484c)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Lg6A.LazyWait), {
        until: isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($539d7fb08de3dccf$var$AddPeopleModal, {
        projectId: projectId,
        projectKey: projectKey,
        isOpen: isOpen,
        onClose: onClose,
        onError: onError,
        onAddSuccess: onAddSuccess,
        onStopPerfMetric: onStopPerfMetric,
        projectType: (0, $2vSU6.SOFTWARE_PROJECT),
        isAdmin: true,
        analyticsPrefix: "software.backlog",
        allowFlags: true,
        ...props
    })));
};
var $539d7fb08de3dccf$export$2e2bcd8739ae039 = $539d7fb08de3dccf$var$AddPeopleModalWrapper;

});
parcelRegister("fjJ1B", function(module, exports) {

$parcel$export(module.exports, "default", () => $05d4cefe384a250f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "AddPeopleModalBoundary", () => $05d4cefe384a250f$export$374b95de0cd72a02);

var $5uXOq = parcelRequire("5uXOq");

var $gAeCk = parcelRequire("gAeCk");

var $7CMCs = parcelRequire("7CMCs");

var $gjEtj = parcelRequire("gjEtj");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");


const $05d4cefe384a250f$var$LazyComponent = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("4XHmI")), {
    moduleId: "./src/packages/permissions-administration/components/project-add-people/src/index.tsx"
});
const $05d4cefe384a250f$export$c4cbbeec160c9988 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "async-project-add-people-dialog",
        packageName: "project-add-people"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "project-add-people-dialog",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
            metricKey: (0, $f7307e9423a0bb88$export$b68a44ad9e8d6ce)
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($05d4cefe384a250f$var$LazyComponent, props)));
var $05d4cefe384a250f$export$2e2bcd8739ae039 = $05d4cefe384a250f$export$c4cbbeec160c9988;
const $05d4cefe384a250f$export$374b95de0cd72a02 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjEtj.ModalBoundary), {
        id: "add-people-modal",
        metricKey: (0, $f7307e9423a0bb88$export$b68a44ad9e8d6ce),
        ...props
    }, children);

});
const $f7307e9423a0bb88$export$b68a44ad9e8d6ce = 'ADD_PEOPLE_LOAD_START_MARK_KEY';
const $f7307e9423a0bb88$export$656613627a47a509 = 'ADD_PEOPLE_LOAD_END_MARK_KEY';
const $f7307e9423a0bb88$export$61762786d0849c64 = 'ADD_PEOPLE_READY_MARK_KEY';

parcelRegister("4XHmI", function(module, exports) {

let $39ce4f92c98d2430$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $39ce4f92c98d2430$var$load("kNFvF"),
    $39ce4f92c98d2430$var$load("ffQaD"),
    $39ce4f92c98d2430$var$load("kvRbA"),
    $39ce4f92c98d2430$var$load("76n7a"),
    $39ce4f92c98d2430$var$load("l253H"),
    $39ce4f92c98d2430$var$load("jJdCl")
]).then(()=>parcelRequire('jd2mv'));

});



parcelRegister("cFqzj", function(module, exports) {

$parcel$export(module.exports, "default", () => $af814fbd506433e2$export$2e2bcd8739ae039);

var $jgtyX = parcelRequire("jgtyX");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $kV9ss = parcelRequire("kV9ss");

var $ksXL1 = parcelRequire("ksXL1");

var $iFIkB = parcelRequire("iFIkB");

var $7CMCs = parcelRequire("7CMCs");

var $6s1PB = parcelRequire("6s1PB");

var $aMFc7 = parcelRequire("aMFc7");

var $koVbs = parcelRequire("koVbs");

var $7Oku1 = parcelRequire("7Oku1");

var $8KmrC = parcelRequire("8KmrC");

var $9OXo1 = parcelRequire("9OXo1");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $2lpqS = parcelRequire("2lpqS");

var $guzeq = parcelRequire("guzeq");

var $hJnrC = parcelRequire("hJnrC");

var $eY43C = parcelRequire("eY43C");

var $4GPQ6 = parcelRequire("4GPQ6");

var $gwOHY = parcelRequire("gwOHY");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $9Pc1U = parcelRequire("9Pc1U");

var $fSgHa = parcelRequire("fSgHa");

var $5jOz5 = parcelRequire("5jOz5");

var $37oMw = parcelRequire("37oMw");

var $lLAmg = parcelRequire("lLAmg");
// eslint-disable-next-line @atlassian/relay/must-use-inline
const $af814fbd506433e2$var$ViewBacklogVersionFilterRelayQuery = (0, $jgtyX.default);
const $af814fbd506433e2$export$1ac8be34f814ec5b = ({ versionFilterRelayQueryRef: versionFilterRelayQueryRef, ...props })=>{
    const { entryPointActions: entryPointActions } = (0, $5uXOq.useContext)((0, $4GPQ6.VersionPanelEntrypointContext));
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const triggerRef = (0, $iFIkB.useEntryPointToggleTrigger)(entryPointActions);
    const projects = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getProjects));
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const jiraProjectIds = (0, $5uXOq.useMemo)(()=>projects.map((project)=>(0, $kV9ss.JiraProjectAri).create({
                projectId: `${project.id}`,
                siteId: tenantContext.cloudId
            }).toString()), [
        projects,
        tenantContext.cloudId
    ]);
    const [data, setData] = (0, $5uXOq.useState)();
    (0, $5uXOq.useEffect)(()=>{
        if (jiraProjectIds.length > 0) (0, $8Uumt.fetchQuery)(environment, $af814fbd506433e2$var$ViewBacklogVersionFilterRelayQuery, {
            jiraProjectIds: jiraProjectIds,
            first: 500,
            after: null
        }, {
            fetchPolicy: 'store-or-network'
        }).subscribe({
            next: (response)=>{
                setData(response);
            }
        });
    }, [
        jiraProjectIds,
        environment
    ]);
    const versions = (0, $5uXOq.useMemo)(()=>{
        if (!data) return [];
        const transformedVersions = data.jira.versionsForProjects.edges.filter(Boolean).map(({ node: node })=>({
                id: node?.versionId || '',
                name: node?.name || '',
                projectKey: node?.project?.key
            }));
        return transformedVersions;
    }, [
        data
    ]);
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    (0, $5uXOq.useEffect)(()=>{
        if (data) dispatch({
            type: (0, $gwOHY.SET_VERSIONS),
            payload: {
                versions: data.jira.versionsForProjects.edges.filter(Boolean).map((edge)=>edge.node?.versionId).filter(Boolean)
            }
        });
    }, [
        dispatch,
        data
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aMFc7.default), {
        versions: versions,
        isLoading: !data,
        toggleRef: triggerRef,
        ...props
    });
};
const $af814fbd506433e2$var$isShowParentIssueFilter = (isCMPBacklog, isParentIssueTypeValid)=>{
    let showParentIssueFilter;
    if (isCMPBacklog) showParentIssueFilter = true;
    else // TMP backlog
    showParentIssueFilter = isParentIssueTypeValid;
    return showParentIssueFilter;
};
const $af814fbd506433e2$export$7a40f967ca91c4d3 = ({ customFiltersQueryRef: customFiltersQueryRef, versionFilterRelayQueryRef: versionFilterRelayQueryRef, issueTypes: issueTypes, issueParents: reduxIssueParents, ...props })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ cards: parents, isLoading: isLoadingParents, epicIssueTypeName: issueParentsTypeName, isEpicIssueTypeAvailable: isParentIssueTypeAvailable }] = (0, $ksXL1.useEpicsFilterData)();
    const { issueParentsLabel: issueParentsLabel } = props;
    const issueParents = (0, $5uXOq.useMemo)(()=>{
        const target = issueParentsLabel && issueParentsLabel !== (0, $guzeq.DEFAULT_PARENT_ISSUE_TYPE_NAME) ? issueParentsLabel : (0, $guzeq.DEFAULT_PARENT_ISSUE_TYPE_NAME).toLowerCase();
        let partialParents = parents.map((parent)=>({
                id: String(parent.epic.id),
                key: parent.epic.key,
                name: parent.epic.name
            }));
        // the redux store will have a base set of epics we can use to determine filter visibility initially
        // which works to keep the dropdown visually stable in the UI until the paginated request is completed
        if (isLoadingParents === true) partialParents = reduxIssueParents || [];
        return partialParents && partialParents.length ? [
            {
                id: String((0, $2lpqS.UNASSIGNED_EPIC_ID)),
                name: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $37oMw.default).unassignedIssueTermRefresh : (0, $37oMw.default).unassigned, {
                    target: target
                })
            },
            ...partialParents
        ] : partialParents;
    }, [
        formatMessage,
        isLoadingParents,
        issueParentsLabel,
        parents,
        reduxIssueParents
    ]);
    const isCMPBacklog = (0, $fSgHa.useIsCMPBacklog)();
    const showEpicPanelToggle = (0, $c1MAf.useBacklogSelector)((0, $9Pc1U.getShowEpicAsPanel));
    const hasMultipleProjects = (0, $c1MAf.useBacklogSelector)((state)=>(0, $jG5HW.getProjects)(state).length > 1);
    const showParentIssueFilter = $af814fbd506433e2$var$isShowParentIssueFilter(isCMPBacklog, isParentIssueTypeAvailable);
    const versionFilterProps = {
        VersionFilterRelay: $af814fbd506433e2$export$1ac8be34f814ec5b,
        versionFilterRelayQueryRef: versionFilterRelayQueryRef,
        isVersionFilterRelayEnabled: true
    };
    const panelToggleVisibility = {
        showEpicPanelToggle: isCMPBacklog ? showEpicPanelToggle : true,
        showVersionsPanelToggle: true
    };
    const issueTypesToDisplay = (0, $lLAmg.useIssueTypes)(issueTypes);
    const handleRelayRequiredFail = (location, error)=>{
        if (!(0, $7Oku1.isRelayValidationError)(error)) throw error;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "backlogHeaderControlsBarFilterBar",
        packageName: "software-backlog",
        onError: handleRelayRequiredFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8KmrC.default), {
        ...props,
        issueTypes: issueTypesToDisplay,
        issueParents: issueParents,
        issueParentsLabel: issueParentsTypeName,
        showPanelToggle: undefined,
        panelToggleVisibility: panelToggleVisibility,
        showParentIssueMenuIfValuesAreEmpty: (0, $4R6GH.fg)('force_show_empty_parent_and_version_filter_options') || showParentIssueFilter,
        showSearchFilterChangeboarding: true,
        hijackBrowserDefaultSearch: !isCMPBacklog,
        screenName: "backlog",
        onChangeInteractionFeedback: (0, $eY43C.setInteractionFeedbackMark),
        onChangeInteractionStart: (0, $eY43C.setInteractionStartMark),
        onCustomFilterChangeInteractionFeedback: (0, $hJnrC.setCustomFilterInteractionFeedbackMark),
        onCustomFilterChangeInteractionStart: (0, $hJnrC.setCustomFilterInteractionStartMark),
        showCustomFilters: isCMPBacklog,
        customFiltersQueryRef: customFiltersQueryRef,
        // @ts-expect-error - TS2345 - Type 'CustomFiltersQueryRef | undefined' is not assignable to type 'PreloadedQuery<viewBacklogCustomFiltersQuery, Record<string, unknown>>'.
        CustomFilter: (0, $5jOz5.BacklogCustomFilter),
        placeholder: (0, $dCm1o.isVisualRefreshEnabled)() ? formatMessage((0, $37oMw.default).filterPlaceholder) : formatMessage((0, $37oMw.default).textFilter),
        isUnassignedAssigneeOptionEnabled: true,
        isUnassignedVersionOptionEnabled: isCMPBacklog,
        onClearCustomFilterInteractionStart: (0, $hJnrC.setClearCustomFilterInteractionStartMark),
        hasMultipleProjects: hasMultipleProjects,
        ...versionFilterProps
    }));
};
var $af814fbd506433e2$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($af814fbd506433e2$export$7a40f967ca91c4d3);

});
parcelRegister("iFIkB", function(module, exports) {

$parcel$export(module.exports, "useEntryPointToggleTrigger", () => $7b49b15164b51422$export$85854750ad265021);

var $5uXOq = parcelRequire("5uXOq");

var $f9Q5V = parcelRequire("f9Q5V");
const $7b49b15164b51422$export$85854750ad265021 = (actions, offValue = false)=>{
    const removePreviousListeners = (0, $5uXOq.useRef)(null);
    const isMounted = (0, $5uXOq.useRef)(true);
    (0, $5uXOq.useEffect)(()=>()=>{
            removePreviousListeners.current?.();
            removePreviousListeners.current = null;
            isMounted.current = false;
        }, []);
    return (0, $5uXOq.useCallback)((refElement)=>{
        if (!isMounted.current) return;
        removePreviousListeners.current?.();
        if (refElement) {
            const { type: type } = refElement;
            if (type !== 'checkbox' && type !== 'radio') throw new Error(`HTMLInputElement ref of type ${type} cannot be used with useEntryPointToggleTrigger. Try checkbox or radio.`);
            const hoverElement = (0, $f9Q5V.getHoverProxy)(refElement);
            const handlers = {
                load () {
                    if (refElement.checked !== offValue) actions.load();
                },
                preload () {
                    if (refElement.checked === offValue) actions.preload();
                },
                cancelPreload () {
                    if (refElement.checked === offValue) actions.cancelPreload();
                }
            };
            (0, $f9Q5V.addListeners)(handlers, refElement, hoverElement);
            removePreviousListeners.current = ()=>{
                (0, $f9Q5V.removeListeners)(handlers, refElement, hoverElement);
            };
        } else removePreviousListeners.current = null;
    }, [
        actions,
        offValue
    ]);
};

});
parcelRegister("f9Q5V", function(module, exports) {

$parcel$export(module.exports, "getHoverProxy", () => $1f1f6fdef1f8dba5$export$ed19923445ff0a86);
$parcel$export(module.exports, "addListeners", () => $1f1f6fdef1f8dba5$export$95d0815810fa2c63);
$parcel$export(module.exports, "removeListeners", () => $1f1f6fdef1f8dba5$export$5073839cf61ff85c);
const $1f1f6fdef1f8dba5$export$ed19923445ff0a86 = (element)=>element.parentElement?.tagName === 'LABEL' ? element.parentElement : element;
const $1f1f6fdef1f8dba5$export$95d0815810fa2c63 = (handlers, refElement, hoverElement)=>{
    refElement.addEventListener('change', handlers.load);
    refElement.addEventListener('focusin', handlers.preload);
    refElement.addEventListener('focusout', handlers.cancelPreload);
    hoverElement.addEventListener('mouseenter', handlers.preload);
    hoverElement.addEventListener('mouseleave', handlers.cancelPreload);
};
const $1f1f6fdef1f8dba5$export$5073839cf61ff85c = (handlers, refElement, hoverElement)=>{
    refElement.removeEventListener('change', handlers.load);
    refElement.removeEventListener('focusin', handlers.preload);
    refElement.removeEventListener('focusout', handlers.cancelPreload);
    hoverElement.removeEventListener('mouseenter', handlers.preload);
    hoverElement.removeEventListener('mouseleave', handlers.cancelPreload);
};

});


parcelRegister("aMFc7", function(module, exports) {

$parcel$export(module.exports, "default", () => $119ce63ee3cabcee$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $jZ4fr = parcelRequire("jZ4fr");

var $imZsD = parcelRequire("imZsD");
var $5Fk4Z = parcelRequire("5Fk4Z");

var $b71gk = parcelRequire("b71gk");

var $7iJwP = parcelRequire("7iJwP");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $g5X3G = parcelRequire("g5X3G");

var $9pP0g = parcelRequire("9pP0g");

var $iDGXn = parcelRequire("iDGXn");

var $bmKPg = parcelRequire("bmKPg");

var $96s6B = parcelRequire("96s6B");

var $gfbKZ = parcelRequire("gfbKZ");
const $119ce63ee3cabcee$var$VersionFilter = (props)=>{
    const { versions: versions, selectedVersions: selectedVersions, isToggleChecked: isToggleChecked, onTogglePanel: onTogglePanel, isSpotlightEnabled: isSpotlightEnabled, showPanelToggle: showPanelToggle, isNested: isNested, toggleRef: toggleRef, hasMultipleProjects: hasMultipleProjects, isLoading: isLoading } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { toggleViewSetting: toggleViewSetting } = (0, $iDGXn.useViewSettingsActions)();
    const [boardId] = (0, $bmKPg.usePathParam)('boardId');
    const values = (0, $5uXOq.useMemo)(()=>versions.map((version)=>({
                label: version.name,
                // Casting to string normalises the id that may potentially be a number.
                value: String(version.id),
                subLabel: hasMultipleProjects ? version.projectKey : undefined
            })), [
        versions,
        hasMultipleProjects
    ]);
    const onChange = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        props.onChange(entries.map(({ value: value })=>value), analyticAttributes);
    }, [
        props,
        isNested
    ]);
    const handleTogglePanel = (0, $5uXOq.useCallback)(()=>{
        if (boardId) toggleViewSetting({
            boardId: Number(boardId),
            setting: (0, $9pP0g.ViewSetting).VERSION_PANEL
        });
        onTogglePanel();
    }, [
        boardId,
        onTogglePanel,
        toggleViewSetting
    ]);
    const renderContent = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
            label: formatMessage((0, $gfbKZ.default).label),
            toggleLabel: formatMessage((0, $gfbKZ.default).toggleLabel),
            values: values,
            showPanelToggle: showPanelToggle,
            selectedValues: (0, $g5X3G.toStringArray)(selectedVersions),
            isPanelToggleChecked: isToggleChecked,
            onChange: onChange,
            onTogglePanel: handleTogglePanel,
            noOptionsMessage: formatMessage(values.length === 0 ? (0, $gfbKZ.default).noUnreleasedVersions : (0, $gfbKZ.default).noMatchingVersions),
            showMenuIfValuesAreEmpty: true,
            isNested: isNested,
            toggleRef: toggleRef,
            isLoading: isLoading,
            placeholder: formatMessage((0, $gfbKZ.default).placeholder),
            shouldCloseMenuOnTab: showPanelToggle ? false : undefined
        }), [
        formatMessage,
        values,
        showPanelToggle,
        selectedVersions,
        isToggleChecked,
        onChange,
        isNested,
        toggleRef,
        handleTogglePanel,
        isLoading
    ]);
    if (isSpotlightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "fusionBacklogVersionsPanel"
    }, renderContent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jZ4fr.EngagementSpotlight), {
        engagementId: "fusionBacklogVersionsPanel"
    })));
    return renderContent;
};
$119ce63ee3cabcee$var$VersionFilter.displayName = 'VersionFilter';
$119ce63ee3cabcee$var$VersionFilter.whyDidYouRender = true;
const $119ce63ee3cabcee$var$ErrorWrapper = (props)=>{
    if (!props.isVersionsFeatureEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "jira.backlog.version.filter",
        packageName: "jiraFilters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
        id: "jira.backlog.version.filter",
        packageName: "jiraFilters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "versionFilter",
        attributes: {
            isVersionPanelOpen: props.isToggleChecked
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($119ce63ee3cabcee$var$VersionFilter, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null))));
};
$119ce63ee3cabcee$var$ErrorWrapper.defaultProps = {
    versions: [],
    selectedVersions: [],
    isToggleChecked: false,
    isSpotlightEnabled: false,
    showPanelToggle: true,
    isVersionsFeatureEnabled: false,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onTogglePanel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    isNested: false
};
var $119ce63ee3cabcee$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($119ce63ee3cabcee$var$ErrorWrapper);

});
parcelRegister("96s6B", function(module, exports) {

$parcel$export(module.exports, "default", () => $51e7460acbb65361$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $2NMNM = parcelRequire("2NMNM");

var $itpgN = parcelRequire("itpgN");
var $bChGW = parcelRequire("bChGW");
var $b9dFI = parcelRequire("b9dFI");

var $dqoiX = parcelRequire("dqoiX");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $8C9C3 = parcelRequire("8C9C3");

var $dF38k = parcelRequire("dF38k");

var $73s29 = parcelRequire("73s29");

var $d9hVL = parcelRequire("d9hVL");

var $4Mv0u = parcelRequire("4Mv0u");

var $ijTad = parcelRequire("ijTad");
const $51e7460acbb65361$var$MenuListWrapper = ({ children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "filters.common.ui.list.menu-list-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).MenuList, rest, children));
const $51e7460acbb65361$export$fa71ab09534e6447 = ({ isOpen: defaultIsOpen, isTriggerDisabled: isTriggerDisabled, isNested: isNested, isLoading: isLoading, isAsyncSearch: isAsyncSearch, showMenuIfValuesAreEmpty: showMenuIfValuesAreEmpty, label: label, toggleLabel: toggleLabel, buttonType: buttonType, values: values, selectedValues: selectedValueIds, onChange: onChange, onInputChange: onInputChange, onOpenChange: onOpenChange, removeOuterPadding: removeOuterPadding, noOptionsMessage: noOptionsMessage, menuGroupTitle: menuGroupTitle, inputValue: inputValue, maxSelectionAllowed: maxSelectionAllowed, maxSelectionReachedTooltip: maxSelectionReachedTooltip, onMouseEnterToTriggerButton: onMouseEnterToTriggerButton, CustomOptionLabel: CustomOptionLabel, placeholder: placeholder, shouldReturnFocus: shouldReturnFocus, shouldCloseMenuOnTab: shouldCloseMenuOnTab, ...footerProps })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const firstRender = (0, $5uXOq.useRef)(true);
    const options = (0, $5uXOq.useMemo)(()=>(0, $ijTad.getOptionsFromProps)({
            values: values,
            menuGroupTitle: menuGroupTitle
        }), [
        values,
        menuGroupTitle
    ]);
    const { optionsWithSelectedSection: optionsWithSelectedSection, updateSelectedOptionGroup: updateSelectedOptionGroup, shouldTrackExperimentEvents: shouldTrackExperimentEvents } = (0, $ijTad.useGetOptionsWithSelectedOptionGroup)();
    if (firstRender.current === true && defaultIsOpen === true) updateSelectedOptionGroup({
        isOpen: defaultIsOpen,
        options: options,
        selectedValueIds: selectedValueIds
    });
    if (firstRender.current === true) firstRender.current = false;
    const { selectedIdLookup: selectedIdLookup, selectedOptions: selectedOptions } = (0, $5uXOq.useMemo)(()=>(0, $ijTad.getSelectedOptionsFromProps)({
            values: values,
            selectedValueIds: selectedValueIds
        }), [
        values,
        selectedValueIds
    ]);
    const previousSelectedCount = (0, $5uXOq.useRef)(selectedValueIds.length);
    /* Cannot return null here for async search as this would cause the
   * filter to disappear completely when fetch returns no results.
   */ if (!showMenuIfValuesAreEmpty && !isAsyncSearch && values.length === 0) return null;
    // ================= //
    // === Callbacks === //
    // ================= //
    const onChangeHandler = (selected)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        onChange(selected);
        // Temporary analytics for the experiment
        if (shouldTrackExperimentEvents.current === true) {
            if (selected.length > previousSelectedCount.current) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: 'filterItem',
                action: 'selected',
                actionSubjectId: 'listFilter'
            }));
            else if (selected.length < previousSelectedCount.current) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: 'filterItem',
                action: 'deselected',
                actionSubjectId: 'listFilter'
            }));
            previousSelectedCount.current = selected.length;
        }
    };
    const onOpenChangeHandler = (isOpen)=>{
        const analyticsEvent = createAnalyticsEvent((0, $8C9C3.OPEN_CHANGE_PAYLOAD));
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, (0, $8C9C3.OPEN_CHANGE_SUBJECT_ID));
        onOpenChange(isOpen);
        updateSelectedOptionGroup({
            isOpen: isOpen,
            options: options,
            selectedValueIds: selectedValueIds
        });
    };
    const isOptionDisabled = (option)=>selectedOptions.length >= maxSelectionAllowed && !selectedIdLookup.has(option.value.toString());
    // ============== //
    // === RENDER === //
    // ============== //
    // Select expects a function that returns a string, rather than a string primitive
    const getNoOptionsMessage = noOptionsMessage === undefined ? noOptionsMessage : ()=>noOptionsMessage;
    const renderTrigger = (popupProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Mv0u.default), {
            ...popupProps,
            isDisabled: isTriggerDisabled,
            shouldReturnFocus: shouldReturnFocus,
            buttonType: buttonType,
            label: label,
            selectedCount: selectedOptions.length,
            removeOuterPadding: removeOuterPadding,
            isNested: isNested,
            onMouseEnter: onMouseEnterToTriggerButton
        });
    const renderFooter = ()=>(footerProps.showLink || footerProps.showPanelToggle) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dF38k.default), {
            label: label,
            toggleLabel: toggleLabel,
            ...footerProps
        });
    const renderOption = (option)=>{
        const { label: optionLabel, iconUrl: iconUrl, subLabel: subLabel, value: value } = option;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9hVL.default), {
            label: optionLabel,
            subLabel: subLabel,
            iconUrl: iconUrl,
            value: String(value),
            isDisabled: isOptionDisabled(option),
            maxSelectionReachedTooltip: maxSelectionReachedTooltip,
            CustomOptionLabel: CustomOptionLabel ?? (0, $d9hVL.DefaultOptionLabel)
        });
    };
    const onKeyDown = (event)=>{
        if (event.key === 'Escape') event.stopPropagation();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b9dFI.default), {
        label: (0, $4R6GH.fg)('tanuki_a11y_fixes_drop_2') ? formatMessage((0, $73s29.default).selectFilters, {
            label: label
        }) : undefined,
        "aria-label": `Select ${label} filters`,
        // testId="filters.common.ui.list.menu-list-wrapper"
        isMulti: true,
        isLoading: isLoading,
        backspaceRemovesValue: true,
        hideSelectedOptions: false,
        closeMenuOnSelect: false,
        defaultIsOpen: defaultIsOpen,
        options: optionsWithSelectedSection || options,
        value: selectedOptions,
        inputValue: inputValue,
        noOptionsMessage: getNoOptionsMessage,
        placeholder: placeholder ?? formatMessage((0, $73s29.default).placeholder),
        target: renderTrigger,
        footer: renderFooter(),
        formatOptionLabel: renderOption,
        components: {
            Option: (0, $itpgN.CheckboxOption),
            DropdownIndicator: null,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            MenuList: $51e7460acbb65361$var$MenuListWrapper
        },
        popperProps: {
            placement: isNested ? 'right-start' : 'bottom-start',
            // to render popup next to the trigger element to achieve DOM order
            strategy: 'fixed'
        },
        onChange: onChangeHandler,
        onInputChange: onInputChange,
        isOptionDisabled: isOptionDisabled,
        onMenuOpen: ()=>onOpenChangeHandler(true),
        onMenuClose: ()=>onOpenChangeHandler(false),
        onKeyDown: onKeyDown,
        ...(0, $ijTad.getSearchableProps)({
            isAsyncSearch: isAsyncSearch,
            optionsCount: values.length,
            isNested: isNested
        }),
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        styles: optionsWithSelectedSection ? {
            group: (base, props)=>{
                const borderStyles = props.data.label === formatMessage((0, $73s29.default).selectedItemsGroupLabel) ? {
                    borderBottom: `1px solid ${"var(--ds-border, #091E4224)"}`
                } : {};
                return {
                    ...base,
                    ...borderStyles,
                    padding: 0
                };
            },
            groupHeading: (base, props)=>{
                if (props.data.label === formatMessage((0, $73s29.default).selectedItemsGroupLabel)) // Make the text screen reader only
                return 0, $dqoiX.visuallyHiddenStyles;
                return base;
            }
        } : undefined,
        shouldCloseMenuOnTab: shouldCloseMenuOnTab
    });
};
$51e7460acbb65361$export$fa71ab09534e6447.defaultProps = {
    isOpen: false,
    isNested: false,
    isTriggerDisabled: false,
    isLoading: false,
    isAsyncSearch: false,
    isPanelToggleChecked: false,
    showLink: false,
    showPanelToggle: false,
    showMenuIfValuesAreEmpty: false,
    useHrefForUrl: false,
    values: [],
    selectedValues: [],
    menuGroupTitle: undefined,
    noOptionsMessage: undefined,
    maxSelectionAllowed: Number.MAX_SAFE_INTEGER,
    url: undefined,
    linkTitle: undefined,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onInputChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onTogglePanel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onLinkItemClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onMouseEnterToTriggerButton: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    toggleRef: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    shouldCloseMenuOnTab: true
};
var $51e7460acbb65361$export$2e2bcd8739ae039 = $51e7460acbb65361$export$fa71ab09534e6447;

});
parcelRegister("8C9C3", function(module, exports) {

$parcel$export(module.exports, "FILTER_MENU_MIN_WIDTH", () => $e9228ce7bf573a8c$export$84ae3fb9fdba8a12);
$parcel$export(module.exports, "FILTER_MENU_MIN_WIDTH_ON_NESTED", () => $e9228ce7bf573a8c$export$920d89f17cd2fe3d);
$parcel$export(module.exports, "FILTER_MENU_MAX_WIDTH", () => $e9228ce7bf573a8c$export$6ea791ab71b8fa00);
$parcel$export(module.exports, "FILTER_SEARCH_THRESHOLD", () => $e9228ce7bf573a8c$export$1d287c6a8b81eb5b);
$parcel$export(module.exports, "OPEN_CHANGE_PAYLOAD", () => $e9228ce7bf573a8c$export$2f5981b7dbafe3a4);
$parcel$export(module.exports, "OPEN_CHANGE_SUBJECT_ID", () => $e9228ce7bf573a8c$export$b94e5dc1a8a1409);
$parcel$export(module.exports, "MAKE_IT_EASIER_TO_DESELECT_FILTER_ITEMS_THRESHOLD", () => $e9228ce7bf573a8c$export$1c112a3da89526d7);

var $gwIPs = parcelRequire("gwIPs");
const $e9228ce7bf573a8c$export$84ae3fb9fdba8a12 = (0, $gwIPs.gridSize) * 21;
const $e9228ce7bf573a8c$export$920d89f17cd2fe3d = (0, $gwIPs.gridSize) * 25;
const $e9228ce7bf573a8c$export$6ea791ab71b8fa00 = (0, $gwIPs.gridSize) * 48;
const $e9228ce7bf573a8c$export$1d287c6a8b81eb5b = 9;
const $e9228ce7bf573a8c$export$2f5981b7dbafe3a4 = {
    action: 'clicked',
    actionSubject: 'dropdownMenu'
};
const $e9228ce7bf573a8c$export$b94e5dc1a8a1409 = 'filterList';
const $e9228ce7bf573a8c$export$1c112a3da89526d7 = 9;

});

parcelRegister("dF38k", function(module, exports) {

$parcel$export(module.exports, "default", () => $2deb009ebf7ebceb$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8zOmE = parcelRequire("8zOmE");

var $8wifS = parcelRequire("8wifS");

var $l6YPM = parcelRequire("l6YPM");
const $2deb009ebf7ebceb$var$FilterListFooter = ({ isPanelToggleChecked: isPanelToggleChecked, showLink: showLink, showPanelToggle: showPanelToggle, useHrefForUrl: useHrefForUrl, url: url, label: label, toggleLabel: toggleLabel, linkTitle: linkTitle, toggleRef: toggleRef, onTogglePanel: onTogglePanel, onLinkItemClick: onLinkItemClick })=>{
    const onToggleHandler = (_, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent);
        onTogglePanel();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (showPanelToggle || showLink && url && linkTitle) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2deb009ebf7ebceb$var$HorizontalSeparator, {
        role: "presentation",
        "data-testid": "filters.common.ui.list.footer.horizintal-separator"
    }), showPanelToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2deb009ebf7ebceb$var$PanelToggleContainer, {
        "data-testid": "filters.common.ui.list.footer.panel-toggle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l6YPM.default), {
        label: toggleLabel || label,
        panelType: label,
        isChecked: isPanelToggleChecked,
        toggleRef: toggleRef,
        onToggle: onToggleHandler
    })), showLink && url && linkTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8wifS.default), {
        url: url,
        linkTitle: linkTitle,
        onClick: onLinkItemClick,
        useHref: useHrefForUrl
    }));
};
$2deb009ebf7ebceb$var$FilterListFooter.defaultProps = {
    url: undefined,
    linkTitle: undefined,
    showPanel: false,
    showLink: false,
    toggleRef: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
var $2deb009ebf7ebceb$export$2e2bcd8739ae039 = $2deb009ebf7ebceb$var$FilterListFooter;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2deb009ebf7ebceb$var$HorizontalSeparator = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "hr", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19itglyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _4t3iv77o _bfhk15ej",
            __cmplp.className
        ])
    });
});
const $2deb009ebf7ebceb$var$PanelToggleContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0q12x7 _u5f3pxbi _n3td12x7 _19bvpxbi _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8wifS", function(module, exports) {

$parcel$export(module.exports, "default", () => $8743d62747e29a3c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $8oe80 = parcelRequire("8oe80");

var $8zOmE = parcelRequire("8zOmE");

var $lVJAU = parcelRequire("lVJAU");
const $8743d62747e29a3c$var$DropdownItem = (0, $8oe80.default)('dropdownItem', {
    onClick: 'clicked'
})((0, $6B7KL.default));
const $8743d62747e29a3c$var$linkWrapperStyles = null;
const $8743d62747e29a3c$export$532cb6865ebe8946 = ({ url: url, linkTitle: linkTitle, onClick: onClick, useHref: useHref = false })=>{
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const onDropdownClick = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'clickLinkFromFilters');
        onClick && onClick();
        if (!useHref) push(url);
    }, [
        useHref,
        onClick,
        push,
        url
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        role: "menu",
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o _1bsb1osq _n3td1b66 _n3ag1osq _c7j0u2gc _1xjuutpp _16i11v6z _1b6mutpp _hjpp1osq _rbt3u2gc _nf5outpp _rayj1v6z _1uurv47k"
        ])
    }, useHref ? /* @ts-expect-error - Type '(event: SyntheticEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => void' is not assignable to type '(e: MouseEvent<Element, MouseEvent> | KeyboardEvent<Element>, args_1: UIAnalyticsEvent) => any'. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8743d62747e29a3c$var$DropdownItem, {
        href: url,
        onClick: onDropdownClick
    }, linkTitle) : /* @ts-expect-error - Type '(event: SyntheticEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => void' is not assignable to type '(e: MouseEvent<Element, MouseEvent> | KeyboardEvent<Element>, args_1: UIAnalyticsEvent) => any'. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8743d62747e29a3c$var$DropdownItem, {
        onClick: onDropdownClick
    }, linkTitle));
};
var $8743d62747e29a3c$export$2e2bcd8739ae039 = $8743d62747e29a3c$export$532cb6865ebe8946;

});

parcelRegister("l6YPM", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ad247e508ffc141$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $basmW = parcelRequire("basmW");

var $8Rkzz = parcelRequire("8Rkzz");

var $3u0c5 = parcelRequire("3u0c5");

var $dTlW6 = parcelRequire("dTlW6");

var $8oe80 = parcelRequire("8oe80");

var $ousew = parcelRequire("ousew");
var $8RXs9 = parcelRequire("8RXs9");

var $3XFdo = parcelRequire("3XFdo");

var $gCuaO = parcelRequire("gCuaO");
const $4ad247e508ffc141$var$TOGGLE_CHECKBOX_ID = 'filters.common.ui.list.panel-toggle.toggle-checkbox';
const $4ad247e508ffc141$var$TOGGLE_HINT_ID = 'filters.common.ui.list.panel-toggle.toggle-hint';
const $4ad247e508ffc141$var$PanelToggle = (props)=>{
    const { isChecked: isChecked, panelType: panelType, onToggle: onToggle, ariaLabel: ariaLabel, intl: { formatMessage: formatMessage }, toggleRef: toggleRef = null, label: label } = props;
    const panelToggleKeyboardShortcut = (0, $3XFdo.getKeyboardShortcutForPanel)(panelType);
    const toggleLabel = label || formatMessage((0, $gCuaO.default).toggleLabel, {
        panelType: panelType
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4ad247e508ffc141$var$PanelToggleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4ad247e508ffc141$var$PanelToggleControl, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dTlW6.default), {
        label: ariaLabel,
        id: $4ad247e508ffc141$var$TOGGLE_CHECKBOX_ID,
        ref: toggleRef,
        onChange: onToggle,
        isChecked: isChecked,
        testId: "filters.common.ui.list.panel-toggle.panel-toggle",
        descriptionId: $4ad247e508ffc141$var$TOGGLE_HINT_ID
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4ad247e508ffc141$var$PanelToggleLabel, {
        htmlFor: $4ad247e508ffc141$var$TOGGLE_CHECKBOX_ID
    }, toggleLabel)), panelToggleKeyboardShortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4ad247e508ffc141$var$PanelToggleHint, {
        id: $4ad247e508ffc141$var$TOGGLE_HINT_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $gCuaO.default).toggleHint,
        values: {
            kbd: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), null, chunks),
            key: panelToggleKeyboardShortcut
        }
    })));
};
$4ad247e508ffc141$var$PanelToggle.defaultProps = {
    isChecked: false,
    panelType: '',
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
var $4ad247e508ffc141$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $8RXs9.default), (0, $5uXOq.memo), (0, $8oe80.default)('filterPanelToggle', {
    onToggle: 'toggled'
}))($4ad247e508ffc141$var$PanelToggle);
const $4ad247e508ffc141$var$PanelToggleContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4ad247e508ffc141$var$PanelToggleControl = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4ad247e508ffc141$var$PanelToggleLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _18u0v77o _1reo15vq _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4ad247e508ffc141$var$PanelToggleHint = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "small", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _syaz131l _o5721q9c _19pkidpf _19bv12x7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3XFdo", function(module, exports) {

$parcel$export(module.exports, "getKeyboardShortcutForPanel", () => $5bd9980697730d58$export$fa36ece4b5d88abc);

const $5bd9980697730d58$var$panelShortcuts = {
    Epic: (0, $570f28ac9bf58edd$export$9b094cdf6fd7589e),
    Version: (0, $570f28ac9bf58edd$export$6f416a1fb11a53d9)
};
const $5bd9980697730d58$export$fa36ece4b5d88abc = (panelType)=>$5bd9980697730d58$var$panelShortcuts[panelType];

});
const $570f28ac9bf58edd$export$a10c132b86ae798b = 'Epic';
const $570f28ac9bf58edd$export$41073ac826c57195 = 'Version';
const $570f28ac9bf58edd$export$9b094cdf6fd7589e = 'E';
const $570f28ac9bf58edd$export$6f416a1fb11a53d9 = 'V';


parcelRegister("gCuaO", function(module, exports) {

$parcel$export(module.exports, "default", () => $2063ebcfe536a9b7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2063ebcfe536a9b7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    toggleAccessibilityLabel: {
        "id": "software-filters.common.list.panel-toggle.toggle-accessibility-label",
        "defaultMessage": "Toggle panel"
    },
    toggleLabel: {
        "id": "software-filters.common.list.panel-toggle.toggle-label",
        "defaultMessage": "{panelType} panel"
    },
    toggleHint: {
        "id": "software-filters.common.list.panel-toggle.toggle-hint",
        "defaultMessage": "Press <kbd>{key}</kbd> to open and close"
    }
});

});



parcelRegister("73s29", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a49ecd68dc207cc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6a49ecd68dc207cc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    placeholder: {
        "id": "software-filters.common.list.placeholder",
        "defaultMessage": "Search filters\u2026"
    },
    anounceMessage: {
        "id": "software-filters.common.list.anounce-message",
        "defaultMessage": "When selecting from the {field} filter, content in the backlog board will automatically update"
    },
    selectedItemsGroupLabel: {
        "id": "software-filters.common.list.selected-items-group-label",
        "defaultMessage": "Selected Items"
    },
    selectFilters: {
        "id": "software-filters.common.list.select-filter",
        "defaultMessage": "Select {label} filters"
    }
});

});

parcelRegister("d9hVL", function(module, exports) {

$parcel$export(module.exports, "DefaultOptionLabel", () => $3a4e6a305ebc1d35$export$86f820b2f37564e5);
$parcel$export(module.exports, "default", () => $3a4e6a305ebc1d35$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3bDjY = parcelRequire("3bDjY");
const $3a4e6a305ebc1d35$export$86f820b2f37564e5 = ({ label: label, iconUrl: iconUrl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, iconUrl !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3a4e6a305ebc1d35$var$Icon, {
        src: iconUrl,
        role: "presentation"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3a4e6a305ebc1d35$var$SelectOptionLabel, null, label));
const $3a4e6a305ebc1d35$var$ListFilterOption = ({ label: label, subLabel: subLabel, iconUrl: iconUrl, value: value, maxSelectionReachedTooltip: maxSelectionReachedTooltip, isDisabled: isDisabled, CustomOptionLabel: CustomOptionLabel })=>{
    const content = isDisabled && maxSelectionReachedTooltip ? maxSelectionReachedTooltip : label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3a4e6a305ebc1d35$var$SelectOptionWrapper, {
        "data-testid": "filters.common.ui.list.option"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CustomOptionLabel, {
        label: label,
        value: value,
        iconUrl: iconUrl
    })), subLabel !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3a4e6a305ebc1d35$var$SelectOptionSubLabel, null, subLabel));
};
$3a4e6a305ebc1d35$var$ListFilterOption.defaultProps = {
    iconUrl: undefined,
    isDisabled: false
};
var $3a4e6a305ebc1d35$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($3a4e6a305ebc1d35$var$ListFilterOption);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3a4e6a305ebc1d35$var$SelectOptionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1y6m",
            __cmplp.className
        ])
    });
});
const $3a4e6a305ebc1d35$var$SelectOptionLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});
const $3a4e6a305ebc1d35$var$SelectOptionSubLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _11c81o8v _1bto1l2s _o5721q9c _syaz131l",
            __cmplp.className
        ])
    });
});
const $3a4e6a305ebc1d35$var$Icon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1bsb7vkz _4t3i7vkz _u5f3u2gc",
            __cmplp.className
        ])
    });
});

});

parcelRegister("4Mv0u", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd436e148f99ab3e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $16T6Y = parcelRequire("16T6Y");

var $fVnbM = parcelRequire("fVnbM");

var $6Ingq = parcelRequire("6Ingq");

var $ebd3R = parcelRequire("ebd3R");

var $hORKG = parcelRequire("hORKG");

var $3dGN0 = parcelRequire("3dGN0");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $22OQR = parcelRequire("22OQR");

var $a2e2Q = parcelRequire("a2e2Q");

var $lmBAt = parcelRequire("lmBAt");

var $7mPT9 = parcelRequire("7mPT9");

var $iXVV6 = parcelRequire("iXVV6");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");
const $bd436e148f99ab3e$var$badgeStyles = {
    root: "_2rkoglpi _11c81o8v _18zr1b66 _bfhk1vcy _syaz1p4p _1ul91tcg _y3gn1h6o _1e0c116y _1bah1h6o _1kz6184x",
    textWrapper: "_1reo15vq _18m915vq _p12f68cl _o5721q9c _1bto1l2s _y3gn1e5h",
    trigger: "_ca0q12x7 _n3td12x7",
    triggerWithCount: "_1e0c1txw _4cvr1h6o"
};
const $bd436e148f99ab3e$var$CountWrapperFeatureGated = ({ isNested: isNested, testId: testId, children: children })=>(0, $4R6GH.fg)('filters_trigger_fix_badge_style') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $bd436e148f99ab3e$var$badgeStyle,
            isNested && $bd436e148f99ab3e$var$badgeStyleNested
        ],
        testId: `${testId}-badge`
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bd436e148f99ab3e$var$CountWrapper, {
        isNested: isNested,
        "data-testid": `${testId}-badge`
    }, children);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bd436e148f99ab3e$var$FilterListTrigger = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isOpen: isOpen, isNested: isNested, isDisabled: isDisabled, removeOuterPadding: removeOuterPadding, label: label, buttonType: buttonType, selectedCount: selectedCount, onMouseEnter: onMouseEnter, shouldReturnFocus: shouldReturnFocus, ...popupProps }, ref)=>{
    const { isSoftwareFullTheming: isThemed } = (0, $a2e2Q.useSoftwareProjectTheming)();
    const testId = `filters.common.ui.list.${label.toLowerCase().replace(/ /g, '-')}-filter`;
    const primaryColor = !isOpen ? "var(--ds-icon-subtle, #626F86)" : undefined;
    const primaryColorOld = isOpen ? "var(--ds-icon-selected, #0C66E4)" : "var(--ds-icon, #44546F)";
    const isIconDisabled = isDisabled && (0, $4R6GH.fg)('tnk_disable_custom_filter_when_there_are_5k_issues');
    const IconComponent = isNested ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3dGN0))), {
        label: "",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($ebd3R))),
        LEGACY_primaryColor: isIconDisabled ? "var(--ds-icon-disabled, #091E424F)" : primaryColorOld,
        ...(0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-headers-buttons') ? {
            color: isIconDisabled ? "var(--ds-icon-disabled, #091E424F)" : primaryColor
        } : !isThemed && {
            color: isIconDisabled ? "var(--ds-icon-disabled, #091E424F)" : primaryColorOld
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hORKG))), {
        label: "",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($6Ingq))),
        LEGACY_primaryColor: isIconDisabled ? "var(--ds-icon-disabled, #091E424F)" : primaryColorOld,
        ...(0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-headers-buttons') ? {
            color: isIconDisabled ? "var(--ds-icon-disabled, #091E424F)" : primaryColor
        } : !isThemed && {
            color: isIconDisabled ? "var(--ds-icon-disabled, #091E424F)" : primaryColorOld
        }
    });
    const inputRef = (0, $5uXOq.useRef)();
    const isMounted = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (shouldReturnFocus && buttonType === 'QuickFilters' && isMounted.current) inputRef?.current?.focus();
        else isMounted.current = true;
    }, [
        shouldReturnFocus,
        buttonType
    ]);
    const conditionalRef = buttonType === 'QuickFilters' ? (0, $7mPT9.mergeRefs)(ref, inputRef) : ref;
    // eslint-disable-next-line no-nested-ternary
    const ButtonComponent = isThemed ? (0, $22OQR.ThemedButton) : (0, $lmBAt.getIsSoftwareThemingEnabled)() ? (0, $fVnbM.default) : $bd436e148f99ab3e$var$StyledButton;
    const countContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, selectedCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bd436e148f99ab3e$var$CountWrapperFeatureGated, {
        isNested: isNested,
        testId: testId
    }, isThemed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $bd436e148f99ab3e$var$badgeStyles.root
    }, selectedCount, " ") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16T6Y.default), {
        appearance: "primary"
    }, selectedCount)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            !isNested && !removeOuterPadding && $bd436e148f99ab3e$var$horizontalPaddingStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "dropDownMenu",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        attributes: {
            filterType: label
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ButtonComponent, {
        ...popupProps,
        ref: conditionalRef,
        isSelected: isOpen || (0, $dCm1o.isVisualRefreshEnabled)() && selectedCount > 0,
        shouldFitContainer: isNested,
        appearance: (0, $dCm1o.isVisualRefreshEnabled)() && !isNested ? 'default' : 'subtle',
        onMouseEnter: onMouseEnter,
        iconAfter: (0, $dCm1o.isVisualRefreshEnabled)() && selectedCount > 0 ? undefined : IconComponent,
        isDisabled: isDisabled || false,
        ...isThemed && isNested && (0, $lmBAt.getIsSoftwareThemingEnabled)() && {
            css: {
                borderRadius: '0 !important',
                paddingRight: `${"var(--ds-space-050, 4px)"} !important`,
                '&:focus': {
                    outlineOffset: '-2px'
                }
            }
        },
        isNested: isNested
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: label,
        hideTooltipOnClick: true,
        tag: "span"
    }, (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-headers-buttons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: selectedCount > 0 ? $bd436e148f99ab3e$var$badgeStyles.triggerWithCount : $bd436e148f99ab3e$var$badgeStyles.trigger,
        testId: testId,
        as: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $bd436e148f99ab3e$var$badgeStyles.textWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        ...isOpen || selectedCount > 0 ? {
            color: 'inherit'
        } : {
            color: 'color.text.subtle'
        },
        weight: "medium"
    }, label)), countContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bd436e148f99ab3e$var$TriggerContainer, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bd436e148f99ab3e$var$TriggerLabel, null, label), countContent)))));
});
var $bd436e148f99ab3e$export$2e2bcd8739ae039 = $bd436e148f99ab3e$var$FilterListTrigger;
const $bd436e148f99ab3e$var$horizontalPaddingStyles = (0, $8CUq3.xcss)({
    paddingLeft: 'space.050',
    paddingRight: 'space.050'
});
const $bd436e148f99ab3e$var$badgeStyle = (0, $8CUq3.xcss)({
    paddingLeft: 'space.050',
    display: 'flex',
    alignSelf: 'center'
});
const $bd436e148f99ab3e$var$badgeStyleNested = (0, $8CUq3.xcss)({
    paddingLeft: 'space.100',
    marginLeft: 'auto'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $bd436e148f99ab3e$var$StyledButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.isNested && "_2rkogrf3 _u5f3ns44 _1bg412gs",
            __cmplp.className
        ])
    });
});
const $bd436e148f99ab3e$var$CountWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isNested: isNested, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l",
            __cmplp.isNested ? "_18u01wug _19bvftgi" : "_19bv1y44",
            __cmplp.className
        ])
    });
});
const $bd436e148f99ab3e$var$TriggerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $bd436e148f99ab3e$var$TriggerLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _p12f68cl _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});

});

parcelRegister("ijTad", function(module, exports) {

$parcel$export(module.exports, "getOptionsFromProps", () => $a5603fd49981b3bf$export$ecd68164c475a713);
$parcel$export(module.exports, "getSelectedOptionsFromProps", () => $a5603fd49981b3bf$export$94d5b7a6f69b418);
$parcel$export(module.exports, "getSearchableProps", () => $a5603fd49981b3bf$export$62d9d395b3dd2ae8);
$parcel$export(module.exports, "useGetOptionsWithSelectedOptionGroup", () => $a5603fd49981b3bf$export$2729924204b6e540);

var $5uXOq = parcelRequire("5uXOq");

var $5JAlL = parcelRequire("5JAlL");

var $koVbs = parcelRequire("koVbs");

var $8C9C3 = parcelRequire("8C9C3");

var $73s29 = parcelRequire("73s29");
const $a5603fd49981b3bf$var$isValueGroupOption = (value)=>'options' in value;
const $a5603fd49981b3bf$export$67e7296d7bc3550c = (values)=>values.every((value)=>!$a5603fd49981b3bf$var$isValueGroupOption(value));
const $a5603fd49981b3bf$export$ecd68164c475a713 = ({ values: values, menuGroupTitle: menuGroupTitle })=>{
    // menuGroupTitle should be deprecated
    if (menuGroupTitle && $a5603fd49981b3bf$export$67e7296d7bc3550c(values)) return [
        {
            label: menuGroupTitle,
            options: values
        }
    ];
    return values;
};
const $a5603fd49981b3bf$export$94d5b7a6f69b418 = ({ values: values, selectedValueIds: selectedValueIds })=>{
    const selectedIdLookup = selectedValueIds.reduce((acc, cur)=>{
        acc.add(cur);
        return acc;
    }, new Set());
    const valuesToLook = values.flatMap((value)=>$a5603fd49981b3bf$var$isValueGroupOption(value) ? value.options : [
            value
        ]);
    const selectedOptions = valuesToLook.filter(({ value: value })=>selectedIdLookup.has(value));
    return {
        selectedIdLookup: selectedIdLookup,
        selectedOptions: selectedOptions
    };
};
const $a5603fd49981b3bf$export$62d9d395b3dd2ae8 = ({ optionsCount: optionsCount, isAsyncSearch: isAsyncSearch, defaultSearchThreshold: defaultSearchThreshold = (0, $8C9C3.FILTER_SEARCH_THRESHOLD), isNested: isNested })=>{
    // Search input should always be visible for async selects
    const searchThreshold = isAsyncSearch ? -1 : defaultSearchThreshold;
    const isSearchable = optionsCount > searchThreshold;
    // Due to renderToParent the grid size will change so, incresing the min width for low resolutions
    const filterMenuMinWidth = isNested ? (0, $8C9C3.FILTER_MENU_MIN_WIDTH_ON_NESTED) : (0, $8C9C3.FILTER_MENU_MIN_WIDTH);
    const maxMenuWidth = (0, $8C9C3.FILTER_MENU_MAX_WIDTH);
    // Set the min and max width to be the same so updated search results don't cause the menu to resize
    const minMenuWidth = isSearchable ? maxMenuWidth : filterMenuMinWidth;
    // Don't filter anything on the frontend for async selects
    const filter = (0, $5JAlL.createFilter)({
        stringify: (option)=>option.label
    });
    const filterOption = isAsyncSearch ? undefined : filter;
    return {
        minMenuWidth: minMenuWidth,
        maxMenuWidth: maxMenuWidth,
        searchThreshold: searchThreshold,
        filterOption: filterOption
    };
};
const $a5603fd49981b3bf$export$2729924204b6e540 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [optionsWithSelectedSection, setOptionsWithSelectedSection] = (0, $5uXOq.useState)(null);
    const shouldTrackExperimentEvents = (0, $5uXOq.useRef)(false);
    const updateSelectedOptionGroup = ({ isOpen: isOpen, options: options, selectedValueIds: selectedValueIds })=>{
        if (// To avoid annoyingly shifting items around while the user has the dropdown open, when only shuffle items on an opening
        isOpen === true && // At least for now, scope this change so we only have a selected items section if the options don't have any existing groupings
        $a5603fd49981b3bf$export$67e7296d7bc3550c(options) && (options.length > (0, $8C9C3.MAKE_IT_EASIER_TO_DESELECT_FILTER_ITEMS_THRESHOLD) || optionsWithSelectedSection !== null)) {
            if (selectedValueIds.length === 0 || options.length <= (0, $8C9C3.MAKE_IT_EASIER_TO_DESELECT_FILTER_ITEMS_THRESHOLD)) {
                setOptionsWithSelectedSection(null);
                shouldTrackExperimentEvents.current = false;
            } else {
                // reorder selected parents to be at the top
                const selected = options.filter((option)=>selectedValueIds.includes(option.value));
                const unselected = options.filter((option)=>!selectedValueIds.includes(option.value));
                const optionsWithSelectedOptionGroup = [
                    {
                        label: formatMessage((0, $73s29.default).selectedItemsGroupLabel),
                        options: selected
                    },
                    {
                        label: '',
                        options: unselected
                    }
                ];
                setOptionsWithSelectedSection(optionsWithSelectedOptionGroup);
                shouldTrackExperimentEvents.current = true;
            }
        }
    };
    return {
        optionsWithSelectedSection: optionsWithSelectedSection,
        updateSelectedOptionGroup: updateSelectedOptionGroup,
        shouldTrackExperimentEvents: shouldTrackExperimentEvents
    };
};

});


parcelRegister("gfbKZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f065e16be4d58f9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3f065e16be4d58f9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noUnreleasedVersions: {
        "id": "software-filters.filters.version.no-unreleased-versions",
        "defaultMessage": "No unreleased versions in this project"
    },
    noMatchingVersions: {
        "id": "software-filters.filters.version.no-matching-versions",
        "defaultMessage": "No matching versions"
    },
    label: {
        "id": "software-filters.filters.version.label",
        "defaultMessage": "Version"
    },
    placeholder: {
        "id": "software-filters.filters.version.placeholder",
        "defaultMessage": "Search version filters..."
    },
    toggleLabel: {
        "id": "software-filters.filters.version.toggle-label",
        "defaultMessage": "Show version panel"
    }
});

});


parcelRegister("7Oku1", function(module, exports) {

$parcel$export(module.exports, "isRelayValidationError", () => $8940bd8b67d2f481$export$f450dbe0abffdade);
$parcel$export(module.exports, "AGGErrors", () => $8940bd8b67d2f481$export$60d8267243755b9c);

var $ht021 = parcelRequire("ht021");
const $8940bd8b67d2f481$export$321834dc4377cb7 = 'Relay: Missing @required value at path';
const $8940bd8b67d2f481$export$f450dbe0abffdade = (error)=>error.message.includes($8940bd8b67d2f481$export$321834dc4377cb7);
class $8940bd8b67d2f481$export$60d8267243755b9c extends (0, $ht021.default) {
    constructor(errors, traceId){
        // this is used to generate same 'hash' for error flag and sla event attribute
        super(errors[0].message, {
            cause: errors[0]
        }), this.name = 'AGGError';
        this.graphQLErrors = errors;
        this.traceId = traceId;
        this.statusCode = errors[0].extensions?.statusCode ?? undefined;
    }
}

});

parcelRegister("8KmrC", function(module, exports) {

$parcel$export(module.exports, "default", () => $2622f927d259b739$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $ajpes = parcelRequire("ajpes");

var $8Rkzz = parcelRequire("8Rkzz");

var $fr1K2 = parcelRequire("fr1K2");

var $x9xyg = parcelRequire("x9xyg");

var $6RCeq = parcelRequire("6RCeq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");


var $kbfkr = parcelRequire("kbfkr");

var $361on = parcelRequire("361on");
const $2622f927d259b739$var$clearAndSetPerformanceMark = (markKey)=>{
    if ((0, $6RCeq.default) && (0, $6RCeq.default).clearMarks) (0, $6RCeq.default).clearMarks(markKey);
    (0, $x9xyg.setMark)(markKey);
};
const $2622f927d259b739$var$useDebouncedOnChange = (onChange, createAnalyticsEvent)=>{
    const debouncedOnChange = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((filters, filterType, attributes)=>{
            if (createAnalyticsEvent) {
                const analyticsEvent = createAnalyticsEvent({
                    action: 'changed',
                    actionSubject: 'filterBar'
                });
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'changeFilterBar', {
                    ...attributes,
                    filterType: filterType
                });
                onChange((0, $361on.getNormalizedFilters)(filters), filterType, attributes, analyticsEvent);
            } else onChange((0, $361on.getNormalizedFilters)(filters), filterType, attributes);
        }, 5), [
        onChange,
        createAnalyticsEvent
    ]);
    return debouncedOnChange;
};
const $2622f927d259b739$var$useOnChangeFilterValues = (filter, onChange, // @ts-expect-error - TS7006 - Parameter 'onChangeInteractionStart' implicitly has an 'any' type.
onChangeInteractionStart, // @ts-expect-error - TS7006 - Parameter 'onCustomFilterChangeInteractionStart' implicitly has an 'any' type.
onCustomFilterChangeInteractionStart, createAnalyticsEvent, onClearCustomFilterInteractionStart, isCompanyManaged)=>{
    const [localFilter, setFilters] = (0, $5uXOq.useState)(filter);
    (0, $5uXOq.useEffect)(()=>{
        setFilters(filter);
    }, [
        filter
    ]);
    const debouncedOnChange = $2622f927d259b739$var$useDebouncedOnChange(onChange, createAnalyticsEvent);
    const onChangeFilterValues = (0, $5uXOq.useCallback)((filters, fieldType, attributes)=>{
        if (fieldType !== null) {
            $2622f927d259b739$var$clearAndSetPerformanceMark('filterBarStart');
            (0, $361on.onFilterChangeStartInteraction)(fieldType, onChangeInteractionStart, onCustomFilterChangeInteractionStart);
            const values = filters[fieldType] ?? [];
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            let updatedFilter = {
                ...localFilter,
                [fieldType]: values
            };
            if (values.length === 0) {
                isCompanyManaged && onClearCustomFilterInteractionStart();
                updatedFilter = (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(localFilter, fieldType);
            }
            setFilters(updatedFilter);
            // fieldType could in theory not be accurate on a final debounced call,
            // however there's only a 5ms window during which this may happen.
            debouncedOnChange(updatedFilter, fieldType, attributes);
        }
    }, [
        onChangeInteractionStart,
        onCustomFilterChangeInteractionStart,
        setFilters,
        localFilter,
        debouncedOnChange,
        isCompanyManaged,
        onClearCustomFilterInteractionStart
    ]);
    const clearFilter = (0, $5uXOq.useCallback)(()=>{
        const emptyFilters = {
            TEXT: undefined,
            ASSIGNEE: undefined,
            LABEL: undefined,
            SPRINT: undefined,
            ISSUE_PARENT: undefined,
            ISSUE_PROJECT: undefined,
            ISSUE_TYPE: undefined,
            VERSION: undefined,
            REQUEST_TYPE: undefined,
            STATUS_CATEGORY: undefined,
            STATUS: undefined,
            CUSTOM_FILTER: undefined,
            DEPENDENCIES: undefined
        };
        isCompanyManaged && onClearCustomFilterInteractionStart();
        setFilters(emptyFilters);
        // A 2nd `null` argument is required so that the analytics event doesn't get treated as the
        // filter type on filter analytics.
        onChange((0, $361on.getNormalizedFilters)(emptyFilters), null, undefined);
    }, [
        onChange,
        isCompanyManaged,
        onClearCustomFilterInteractionStart
    ]);
    return [
        localFilter,
        onChangeFilterValues,
        clearFilter
    ];
};
const $2622f927d259b739$var$SoftwareFilters = (props)=>{
    const { filter: filter, onChange: onChange, onClearAllButtonClicked: onClearAllButtonClicked, onChangeInteractionFeedback: onChangeInteractionFeedback = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onChangeInteractionStart: onChangeInteractionStart = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onCustomFilterChangeInteractionFeedback: onCustomFilterChangeInteractionFeedback = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onCustomFilterChangeInteractionStart: onCustomFilterChangeInteractionStart = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onExperienceSuccess: onExperienceSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isCompanyManaged: isCompanyManaged = false, onClearCustomFilterInteractionStart: onClearCustomFilterInteractionStart = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [localFilters, onChangeFilterValues, clearFilter] = $2622f927d259b739$var$useOnChangeFilterValues(filter, onChange, onChangeInteractionStart, onCustomFilterChangeInteractionStart, createAnalyticsEvent, onClearCustomFilterInteractionStart, isCompanyManaged);
    (0, $5uXOq.useEffect)(()=>{
        onExperienceSuccess();
    }, [
        onExperienceSuccess
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(filter, localFilters)) {
            $2622f927d259b739$var$clearAndSetPerformanceMark('filterBarStop');
            onChangeInteractionFeedback();
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(filter.CUSTOM_FILTER, localFilters.CUSTOM_FILTER)) onCustomFilterChangeInteractionFeedback();
        }
    }, [
        filter,
        localFilters,
        onChangeInteractionFeedback,
        onCustomFilterChangeInteractionFeedback
    ]);
    $2622f927d259b739$var$clearAndSetPerformanceMark('oldFilterBarStop');
    const onClear = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        // we always have to pass void entityType, so analytics events will always be as third argument
        clearFilter();
        onClearAllButtonClicked && onClearAllButtonClicked(event, analyticsEvent);
        const customAnalyticsEvent = createAnalyticsEvent({
            action: 'changed',
            actionSubject: 'filterBar'
        });
        (0, $8zOmE.fireUIAnalytics)(customAnalyticsEvent, 'changeFilterBar', {
            filterType: (0, $15a528573ccd89ae$export$6c4d37c7f376a1de)
        });
    }, [
        clearFilter,
        onClearAllButtonClicked,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kbfkr.default), {
        ...props,
        filter: localFilters,
        onClearAllButtonClicked: onClear,
        onChange: onChangeFilterValues
    });
};
var $2622f927d259b739$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($2622f927d259b739$var$SoftwareFilters);

});
parcelRegister("kbfkr", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb7c802f0a442491$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $lFKmC = parcelRequire("lFKmC");

var $9XE6b = parcelRequire("9XE6b");

var $hGgHi = parcelRequire("hGgHi");

var $8Rkzz = parcelRequire("8Rkzz");

var $hqTkp = parcelRequire("hqTkp");

var $gKZoD = parcelRequire("gKZoD");

var $eQfWH = parcelRequire("eQfWH");

var $26g7Y = parcelRequire("26g7Y");

var $MHKc7 = parcelRequire("MHKc7");

var $eZJjh = parcelRequire("eZJjh");

var $kY99m = parcelRequire("kY99m");

var $dqoiX = parcelRequire("dqoiX");

var $5p1kJ = parcelRequire("5p1kJ");

var $5rVQI = parcelRequire("5rVQI");

var $eG9rp = parcelRequire("eG9rp");

var $879xD = parcelRequire("879xD");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $6CjZR = parcelRequire("6CjZR");

var $1beWO = parcelRequire("1beWO");

var $3oCwY = parcelRequire("3oCwY");

var $7j6PN = parcelRequire("7j6PN");

var $8bg0N = parcelRequire("8bg0N");

var $kgqZV = parcelRequire("kgqZV");

var $efv79 = parcelRequire("efv79");

var $jKPI1 = parcelRequire("jKPI1");

var $hHL6f = parcelRequire("hHL6f");

var $2fsdj = parcelRequire("2fsdj");

var $bLWKp = parcelRequire("bLWKp");

var $hpA0D = parcelRequire("hpA0D");

var $g65Ek = parcelRequire("g65Ek");

var $jdA4J = parcelRequire("jdA4J");

var $cSFZv = parcelRequire("cSFZv");

var $3f9TT = parcelRequire("3f9TT");

var $aMFc7 = parcelRequire("aMFc7");

var $fJnmW = parcelRequire("fJnmW");

var $koVbs = parcelRequire("koVbs");

var $cTi8P = parcelRequire("cTi8P");

var $2m0b6 = parcelRequire("2m0b6");

var $2xSAL = parcelRequire("2xSAL");

var $g5X3G = parcelRequire("g5X3G");

var $fUHZ2 = parcelRequire("fUHZ2");

var $90yGq = parcelRequire("90yGq");

var $dCm1o = parcelRequire("dCm1o");

var $k9JTq = parcelRequire("k9JTq");

var $ldyPw = parcelRequire("ldyPw");

var $6cG4N = parcelRequire("6cG4N");

var $a2e2Q = parcelRequire("a2e2Q");


var $cM4EP = parcelRequire("cM4EP");

var $2FvdY = parcelRequire("2FvdY");

var $kH9yv = parcelRequire("kH9yv");

var $bBMqL = parcelRequire("bBMqL");

var $l38sT = parcelRequire("l38sT");

var $649U3 = parcelRequire("649U3");
const $cb7c802f0a442491$var$EMPTY_ARRAY = [];
const $cb7c802f0a442491$var$MIN_VISIBLE_USERS = 2;
const $cb7c802f0a442491$var$USER_AVATAR_WIDTH = 30;
const $cb7c802f0a442491$var$DEFAULT_VISIBLE_USERS = 7;
const $cb7c802f0a442491$var$MIN_FILTER_BAR_WIDTH = 510;
const $cb7c802f0a442491$var$LARGE_SEARCH_FILTER_BREAKPOINT = 1440;
const $cb7c802f0a442491$var$SEARCH_ISSUE_DESCRIPTION_SCREEN_READER_ID = 'search-issue-description';
const $cb7c802f0a442491$var$SoftwareFiltersStateless = (props)=>{
    (0, $gKZoD.di)(requestAnimationFrame);
    const { filter: filter, issueParentsLabel: issueParentsLabel, assignees: assignees = [], issueParents: issueParents = [], versions: versions = [], components: components = [], labels: labels = [], issueProjects: issueProjects = {}, issueTypes: issueTypes = [], issueTypeGroups: issueTypeGroups = [], statuses: statuses = [], requestTypes: requestTypes = [], onChange: onChange, onSearchFieldFocus: onSearchFieldFocus = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onExtraAvatarMenuOpen: onExtraAvatarMenuOpen = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onFilterPanelMounted: onFilterPanelMounted = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onClearAllButtonClicked: onClearAllButtonClicked = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onToggleParentPanel: onToggleParentPanel = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onToggleVersionsPanel: onToggleVersionsPanel = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isIssueParentPanelToggleChecked: isIssueParentPanelToggleChecked = false, isVersionPanelToggleChecked: isVersionPanelToggleChecked = false, isAnyModalOpen: isAnyModalOpen = false, AddPeopleModal: AddPeopleModal, showPanelToggle: /**
     * @deprecated `showPanelToggle` used to control visibility of all panel toggles. Use `panelToggleVisibility` instead to control each panel toggle visibility.
     */ showPanelToggle = false, panelToggleVisibility: panelToggleVisibility, showParentIssueMenuIfValuesAreEmpty: showParentIssueMenuIfValuesAreEmpty = false, showSearchFilterChangeboarding: showSearchFilterChangeboarding = false, hijackBrowserDefaultSearch: hijackBrowserDefaultSearch = false, screenName: screenName, isVersionsFeatureEnabled: isVersionsFeatureEnabled = false, isComponentsFeatureEnabled: isComponentsFeatureEnabled = false, isStatusCategoriesFeatureEnabled: isStatusCategoriesFeatureEnabled = true, isIssueParentsFeatureEnabled: isIssueParentsFeatureEnabled = true, isLabelsFeatureEnabled: isLabelsFeatureEnabled = true, isIssueProjectsFeatureEnabled: isIssueProjectsFeatureEnabled = false, isIssueTypesFeatureEnabled: isIssueTypesFeatureEnabled = true, isSprintsFeatureEnabled: isSprintsFeatureEnabled = true, isRequestTypesFeatureEnabled: isRequestTypesFeatureEnabled = false, isStatusesFeatureEnabled: isStatusesFeatureEnabled = false, isGroupIssueTypesEnabled: isGroupIssueTypesEnabled = false, isDependenciesFeatureEnabled: isDependenciesFeatureEnabled = false, onChangeInteractionStart: onChangeInteractionStart = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), projectId: projectId, projectName: projectName, projectKey: projectKey, boardId: boardId, statusCategories: statusCategories = [], customFiltersQueryRef: customFiltersQueryRef, CustomFilter: CustomFilter, showAssigneeFilter: showAssigneeFilter = true, showCustomFilters: showCustomFilters = false, showBoardSwitcher: showBoardSwitcher = false, isBoardSwitcherReadOnly: isBoardSwitcherReadOnly = true, versionFilterRelayQueryRef: versionFilterRelayQueryRef, VersionFilterRelay: VersionFilterRelay, isVersionFilterRelayEnabled: isVersionFilterRelayEnabled = false, isUnassignedAssigneeOptionEnabled: isUnassignedAssigneeOptionEnabled = false, isUnassignedVersionOptionEnabled: isUnassignedVersionOptionEnabled = false, isUnassignedLabelOptionEnabled: isUnassignedLabelOptionEnabled = false, isUnassignedComponentOptionEnabled: isUnassignedComponentOptionEnabled = false, isCustomFiltersLoading: isCustomFiltersLoading = false, placeholder: placeholder = '', screenReaderInstruction: screenReaderInstruction = '', sprints: sprints = [], isAddPeopleButtonEnabled: isAddPeopleButtonEnabled = false, isCustomFilterManageLinkEnabled: isCustomFilterManageLinkEnabled = false, jqlFilters: jqlFilters = [], isCompanyManaged: isCompanyManaged = false, isJSMBoard: isJSMBoard = false, hasMultipleProjects: hasMultipleProjects = false, isGoalsFeatureOptionEnabled: isGoalsFeatureOptionEnabled = false, goals: goals = [], shouldShowUnassignedFilterNudge: shouldShowUnassignedFilterNudge = false } = props;
    const accountId = (0, $90yGq.useAccountId)();
    const isAsyncFilterLoading = isCustomFiltersLoading;
    const [screenReaderInstructionForFilters, setScreenReaderInstructionForFilters] = (0, $5uXOq.useState)(false);
    const { software: software } = (0, $k9JTq.useAppEditions)();
    const shouldDisableAddPeople = isCompanyManaged && software === (0, $ldyPw.FREE_EDITION);
    const keepUnassignedUserOnTop = isUnassignedAssigneeOptionEnabled && screenName === 'board' && (0, $4R6GH.fg)('unassigned_filter_kill_switch');
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const allAssignees = (0, $5uXOq.useMemo)(()=>{
        if (!isUnassignedAssigneeOptionEnabled) return assignees;
        const unassignedUser = {
            id: (0, $g5X3G.toAccountId)((0, $15a528573ccd89ae$export$12e572fd459c10dc)),
            displayName: formatMessage((0, $l38sT.default).unassignedAssigneeDisplayName),
            avatarUrl: undefined
        };
        if (keepUnassignedUserOnTop) return [
            unassignedUser,
            ...assignees
        ];
        return [
            ...assignees,
            unassignedUser
        ];
    }, [
        isUnassignedAssigneeOptionEnabled,
        formatMessage,
        keepUnassignedUserOnTop,
        assignees
    ]);
    const allVersions = (0, $5uXOq.useMemo)(()=>isUnassignedVersionOptionEnabled && versions.length ? [
            {
                id: (0, $15a528573ccd89ae$export$ac95b4b2317d4b33),
                name: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $l38sT.default).unassignedVersionLabelIssueTermRefresh : (0, $l38sT.default).unassignedVersionLabel)
            },
            ...versions
        ] : versions, [
        versions,
        isUnassignedVersionOptionEnabled,
        formatMessage
    ]);
    const unassignedOption = (0, $5uXOq.useMemo)(()=>({
            label: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $l38sT.default).unassignedLabelLabelIssueTermRefresh : (0, $l38sT.default).unassignedLabelLabel),
            value: (0, $15a528573ccd89ae$export$81ef49afbbead0a1)
        }), [
        formatMessage
    ]);
    const allComponents = (0, $5uXOq.useMemo)(()=>isUnassignedComponentOptionEnabled && components.length ? [
            {
                id: (0, $15a528573ccd89ae$export$4b7c755e61199a36),
                name: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $l38sT.default).unassignedComponentLabelIssueTermRefresh : (0, $l38sT.default).unassignedComponentLabel)
            },
            ...components
        ] : components, [
        components,
        isUnassignedComponentOptionEnabled,
        formatMessage
    ]);
    (0, $5uXOq.useEffect)(()=>{
        onFilterPanelMounted();
    }, [
        onFilterPanelMounted
    ]); // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const onSearchChange = (0, $5uXOq.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((newText)=>{
        onChangeInteractionStart();
        onChange({
            [(0, $15a528573ccd89ae$export$d597759d33be802e)]: newText
        }, (0, $15a528573ccd89ae$export$d597759d33be802e), undefined);
    }, 300), [
        onChange,
        onChangeInteractionStart
    ]);
    const assigneeValue = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filter, [
            (0, $15a528573ccd89ae$export$f8f7545d2bb78afb)
        ], $cb7c802f0a442491$var$EMPTY_ARRAY), [
        filter
    ]);
    const onToggleAssignee = (0, $5uXOq.useCallback)((entryId)=>{
        setScreenReaderInstructionForFilters(true);
        setTimeout(()=>{
            setScreenReaderInstructionForFilters(false);
        });
        const withoutValue = (0, (/*@__PURE__*/$parcel$interopDefault($hqTkp)))(assigneeValue, entryId);
        const newFilterValue = withoutValue.length === assigneeValue.length ? withoutValue.concat(entryId) : withoutValue;
        onChange({
            [(0, $15a528573ccd89ae$export$f8f7545d2bb78afb)]: (0, $g5X3G.toAccountIdArray)(newFilterValue)
        }, (0, $15a528573ccd89ae$export$f8f7545d2bb78afb), {
            isUnassignedFilterCta: false,
            // part of experiment unassigned_filter_kill_switch
            isUnassignedSelected: newFilterValue.includes((0, $15a528573ccd89ae$export$12e572fd459c10dc)),
            isOnlyCurrentUserSelected: accountId && newFilterValue.length === 1 && newFilterValue[0] === accountId
        });
    }, [
        assigneeValue,
        onChange,
        accountId
    ]);
    const onClickUnassignedFilterNudge = (0, $5uXOq.useCallback)(()=>{
        setScreenReaderInstructionForFilters(true);
        setTimeout(()=>{
            setScreenReaderInstructionForFilters(false);
        });
        accountId && onChange({
            [(0, $15a528573ccd89ae$export$f8f7545d2bb78afb)]: [
                (0, $15a528573ccd89ae$export$12e572fd459c10dc),
                accountId
            ]
        }, (0, $15a528573ccd89ae$export$f8f7545d2bb78afb), {
            isUnassignedFilterCta: true,
            isUnassignedSelected: true,
            isOnlyCurrentUserSelected: false
        });
    }, [
        onChange,
        accountId
    ]);
    const onChangeParents = (0, $5uXOq.useCallback)((parentIds, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$2a4f270075a033de)]: parentIds
        }, (0, $15a528573ccd89ae$export$2a4f270075a033de), attributes);
    }, [
        onChange
    ]);
    const onChangeVersions = (0, $5uXOq.useCallback)((versionIds, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$a4ad2735b021c132)]: (0, $g5X3G.toVersionIdArray)(versionIds)
        }, (0, $15a528573ccd89ae$export$a4ad2735b021c132), attributes);
    }, [
        onChange
    ]);
    const onChangeComponents = (0, $5uXOq.useCallback)((componentIds, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$af1e30ebbae9df3b)]: (0, $g5X3G.toComponentIdArray)(componentIds)
        }, (0, $15a528573ccd89ae$export$af1e30ebbae9df3b), attributes);
    }, [
        onChange
    ]);
    const onChangeLabels = (0, $5uXOq.useCallback)((newLabels, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$37aee82a3cb1e8f7)]: newLabels
        }, (0, $15a528573ccd89ae$export$37aee82a3cb1e8f7), attributes);
    }, [
        onChange
    ]);
    const onChangeIssueProjects = (0, $5uXOq.useCallback)((newProjects, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$401f4b6eda6a369c)]: newProjects
        }, (0, $15a528573ccd89ae$export$401f4b6eda6a369c), attributes);
    }, [
        onChange
    ]);
    const onChangeIssueTypes = (0, $5uXOq.useCallback)((issueTypeIds, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$ebb48b08205007c5)]: issueTypeIds
        }, (0, $15a528573ccd89ae$export$ebb48b08205007c5), attributes);
    }, [
        onChange
    ]);
    const onChangeStatusCategories = (0, $5uXOq.useCallback)((newStatusCategories, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$f863b019d19144f4)]: newStatusCategories
        }, (0, $15a528573ccd89ae$export$f863b019d19144f4), attributes);
    }, [
        onChange
    ]);
    const onChangeCustomFilters = (0, $5uXOq.useCallback)((newCustomFilters, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$68d693c35a8d8866)]: newCustomFilters
        }, (0, $15a528573ccd89ae$export$68d693c35a8d8866), attributes);
    }, [
        onChange
    ]);
    const onChangeSprints = (0, $5uXOq.useCallback)((newSprintIds, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$a316570a0dbfd2b0)]: newSprintIds
        }, (0, $15a528573ccd89ae$export$a316570a0dbfd2b0), attributes);
    }, [
        onChange
    ]);
    const onChangeStatuses = (0, $5uXOq.useCallback)((newStatuses, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$e50006273435e7d4)]: newStatuses
        }, (0, $15a528573ccd89ae$export$e50006273435e7d4), attributes);
    }, [
        onChange
    ]);
    const onChangeRequestTypes = (0, $5uXOq.useCallback)((newRequestTypeIds, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$92ab80c1dc9baf44)]: newRequestTypeIds
        }, (0, $15a528573ccd89ae$export$92ab80c1dc9baf44), attributes);
    }, [
        onChange
    ]);
    const onChangeQuickFilters = (0, $5uXOq.useCallback)((newQuickFilters, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$1ea95b94fb0c51d9)]: newQuickFilters
        }, (0, $15a528573ccd89ae$export$1ea95b94fb0c51d9), attributes);
    }, [
        onChange
    ]);
    const onChangeGoals = (0, $5uXOq.useCallback)((goalIds, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$871e58afc769b358)]: goalIds
        }, (0, $15a528573ccd89ae$export$871e58afc769b358), attributes);
    }, [
        onChange
    ]);
    const onChangeDependencies = (0, $5uXOq.useCallback)((dependencyOptions, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$db362e2d293fe52e)]: dependencyOptions
        }, (0, $15a528573ccd89ae$export$db362e2d293fe52e), attributes);
    }, [
        onChange
    ]);
    const isClearButtonVisible = (0, $5uXOq.useMemo)(()=>filter && Object.keys(filter).length > 0, [
        filter
    ]);
    const searchInputRef = (0, $5uXOq.useRef)(null);
    const fireShortcutAnalytics = (0, $fUHZ2.useShortcutAnalytics)(screenName);
    const focusSearchInput = (0, $5uXOq.useCallback)(()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(searchInputRef) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(searchInputRef.current)) {
            // This is the same way the global search input prevents
            // the shortcut from being fed into the input
            // See: src/packages/navigation-apps/atlassian-navigation/src/ui/integrations/keyboard-shortcuts/index.tsx
            requestAnimationFrame(()=>{
                searchInputRef.current && searchInputRef.current.focus();
            });
            const analyticsPayload = {
                id: 'focusSearchField',
                key: 'f',
                attributes: {}
            };
            fireShortcutAnalytics(analyticsPayload);
        }
    }, [
        fireShortcutAnalytics,
        searchInputRef
    ]); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const isUserBoard = window.location.pathname.startsWith('/jira/people/');
    const customFilterManageUrl = (0, $649U3.getManageCustomFiltersUrl)(projectKey, boardId.toString(), isCompanyManaged, isUserBoard, isJSMBoard);
    const showEpicPanelToggle = panelToggleVisibility ? panelToggleVisibility.showEpicPanelToggle : showPanelToggle;
    const isMounted = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (isMounted.current) {
            if (!isClearButtonVisible) {
                setScreenReaderInstructionForFilters(true);
                setTimeout(()=>{
                    setScreenReaderInstructionForFilters(false);
                }, 1000);
            }
        } else isMounted.current = true;
    }, [
        isClearButtonVisible
    ]);
    const parentFilter = {
        id: (0, $15a528573ccd89ae$export$2a4f270075a033de),
        isStatic: false,
        isHidden: !isIssueParentsFeatureEnabled,
        renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bLWKp.default), {
                key: "ParentFilter",
                isNested: isNested,
                label: issueParentsLabel,
                parents: issueParents,
                selectedParents: filter[0, $15a528573ccd89ae$export$2a4f270075a033de],
                isToggleChecked: isIssueParentPanelToggleChecked,
                onChange: onChangeParents,
                onTogglePanel: onToggleParentPanel,
                showPanelToggle: showEpicPanelToggle,
                showMenuIfValuesAreEmpty: showParentIssueMenuIfValuesAreEmpty
            })
    };
    const showVersionsPanelToggle = panelToggleVisibility ? panelToggleVisibility.showVersionsPanelToggle : showPanelToggle;
    const versionFilter = {
        id: (0, $15a528573ccd89ae$export$a4ad2735b021c132),
        isStatic: false,
        hidden: !isVersionsFeatureEnabled,
        renderer: (isNested)=>{
            const versionFilterProps = {
                isNested: isNested,
                isToggleChecked: isVersionPanelToggleChecked,
                onChange: onChangeVersions,
                onTogglePanel: onToggleVersionsPanel,
                selectedVersions: filter[0, $15a528573ccd89ae$export$a4ad2735b021c132] ?? $cb7c802f0a442491$var$EMPTY_ARRAY,
                // RLSS-3020 Spotlight will be cleanup soon
                isSpotlightEnabled: false,
                showPanelToggle: showVersionsPanelToggle,
                isVersionsFeatureEnabled: isVersionsFeatureEnabled
            };
            if (isVersionFilterRelayEnabled) {
                if ((0, $4R6GH.fg)('force_show_empty_parent_and_version_filter_options')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBMqL.default), {
                    key: "VersionFilterRelayBoundary",
                    screenName: screenName,
                    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aMFc7.default), {
                        versions: $cb7c802f0a442491$var$EMPTY_ARRAY,
                        hasMultipleProjects: hasMultipleProjects,
                        isLoading: true,
                        ...versionFilterProps
                    })
                }, versionFilterRelayQueryRef != null && VersionFilterRelay != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(VersionFilterRelay, {
                    versionFilterRelayQueryRef: versionFilterRelayQueryRef,
                    isUnassignedVersionOptionEnabled: isUnassignedVersionOptionEnabled,
                    hasMultipleProjects: hasMultipleProjects,
                    ...versionFilterProps
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aMFc7.default), {
                    versions: $cb7c802f0a442491$var$EMPTY_ARRAY,
                    hasMultipleProjects: hasMultipleProjects,
                    isLoading: true,
                    ...versionFilterProps
                }));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBMqL.default), {
                    key: "VersionFilterRelayBoundary",
                    screenName: screenName,
                    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aMFc7.default), {
                        versions: $cb7c802f0a442491$var$EMPTY_ARRAY,
                        hasMultipleProjects: hasMultipleProjects,
                        isLoading: true,
                        ...versionFilterProps
                    })
                }, versionFilterRelayQueryRef != null && VersionFilterRelay != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(VersionFilterRelay, {
                    versionFilterRelayQueryRef: versionFilterRelayQueryRef,
                    isUnassignedVersionOptionEnabled: isUnassignedVersionOptionEnabled,
                    hasMultipleProjects: hasMultipleProjects,
                    ...versionFilterProps
                }) : null);
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aMFc7.default), {
                key: "VersionFilter",
                versions: allVersions,
                ...versionFilterProps
            });
        }
    };
    let overflowItemsBefore = [
        {
            id: (0, $15a528573ccd89ae$export$f863b019d19144f4),
            isStatic: false,
            isHidden: !isStatusCategoriesFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cSFZv.default), {
                    key: "StatusCategoryFilter",
                    isNested: isNested,
                    statusCategories: statusCategories,
                    selectedStatusCategories: filter[0, $15a528573ccd89ae$export$f863b019d19144f4],
                    onChange: onChangeStatusCategories
                })
        },
        /**
   * the "Project" filter is currently only used by the Increment Planning board of Advanced Roadmaps
   * please refer to src/packages/software/board/src/services/filter/filter-url-bindings.tsx
   */ {
            id: (0, $15a528573ccd89ae$export$401f4b6eda6a369c),
            isStatic: false,
            isHidden: !isIssueProjectsFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $efv79.default), {
                    isNested: isNested,
                    issueProjects: issueProjects,
                    key: "IssueProjectFilter",
                    onChange: onChangeIssueProjects,
                    selectedProjects: filter[0, $15a528573ccd89ae$export$401f4b6eda6a369c]
                })
        },
        versionFilter,
        parentFilter,
        {
            id: (0, $15a528573ccd89ae$export$37aee82a3cb1e8f7),
            isStatic: false,
            isHidden: !isLabelsFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2fsdj.default), {
                    key: "LabelFilter",
                    isNested: isNested,
                    ...isUnassignedLabelOptionEnabled && labels.length ? {
                        unassignedOption: unassignedOption
                    } : undefined,
                    labels: labels,
                    selectedLabels: filter[0, $15a528573ccd89ae$export$37aee82a3cb1e8f7],
                    onChange: onChangeLabels
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$ebb48b08205007c5),
            isStatic: false,
            isHidden: !isIssueTypesFeatureEnabled,
            renderer: (isNested)=>isGroupIssueTypesEnabled ? // In the program board, we could have multiple issue types with the same hierarchy level and names coming from multiple TWP project. We group them so there's no visually duplicated items in the dropdown
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jKPI1.default), {
                    key: "IssueTypeGroupFilter",
                    isNested: isNested,
                    issueTypeGroups: issueTypeGroups,
                    selectedIssueTypes: filter[0, $15a528573ccd89ae$export$ebb48b08205007c5],
                    onChange: onChangeIssueTypes
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hHL6f.default), {
                    key: "IssueTypeFilter",
                    isNested: isNested,
                    issueTypes: issueTypes,
                    selectedIssueTypes: filter[0, $15a528573ccd89ae$export$ebb48b08205007c5],
                    onChange: onChangeIssueTypes
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$af1e30ebbae9df3b),
            isStatic: false,
            isHidden: !isComponentsFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7j6PN.default), {
                    key: "ComponentFilter",
                    isNested: isNested,
                    components: allComponents,
                    onChange: onChangeComponents,
                    selectedComponents: filter[0, $15a528573ccd89ae$export$af1e30ebbae9df3b]
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$a316570a0dbfd2b0),
            isStatic: false,
            isHidden: !isSprintsFeatureEnabled || sprints.length <= 1,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jdA4J.default), {
                    key: "SprintFilter",
                    isNested: isNested,
                    sprints: sprints,
                    selectedSprints: filter[0, $15a528573ccd89ae$export$a316570a0dbfd2b0],
                    onChange: onChangeSprints
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$e50006273435e7d4),
            isStatic: false,
            isHidden: !isStatusesFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3f9TT.default), {
                    key: "StatusFilter",
                    isNested: isNested,
                    statuses: statuses,
                    selectedStatuses: filter[0, $15a528573ccd89ae$export$e50006273435e7d4],
                    onChange: onChangeStatuses
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$92ab80c1dc9baf44),
            isStatic: false,
            isHidden: !isRequestTypesFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g65Ek.default), {
                    key: "RequestTypeFilter",
                    isNested: isNested,
                    requestTypes: requestTypes,
                    selectedRequestTypes: filter[0, $15a528573ccd89ae$export$92ab80c1dc9baf44],
                    onChange: onChangeRequestTypes
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$68d693c35a8d8866),
            isStatic: false,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cM4EP.default), {
                    key: "CustomFilterBoundary",
                    screenName: screenName,
                    customFiltersQueryRef: customFiltersQueryRef
                }, (!!customFiltersQueryRef || showCustomFilters) && !!CustomFilter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CustomFilter, {
                    isNested: isNested,
                    customFiltersQueryRef: customFiltersQueryRef,
                    selectedFilters: filter[0, $15a528573ccd89ae$export$68d693c35a8d8866],
                    filters: jqlFilters,
                    onChange: onChangeCustomFilters,
                    showLink: isCustomFilterManageLinkEnabled,
                    manageUrl: customFilterManageUrl,
                    screenName: screenName
                }))
        },
        {
            id: (0, $15a528573ccd89ae$export$1ea95b94fb0c51d9),
            isStatic: false,
            isHidden: showCustomFilters,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hpA0D.default), {
                    key: "QuickFilter",
                    isNested: isNested,
                    filters: jqlFilters,
                    selectedFilters: filter[0, $15a528573ccd89ae$export$1ea95b94fb0c51d9],
                    onChange: onChangeQuickFilters
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$871e58afc769b358),
            isStatic: false,
            isHidden: !isGoalsFeatureOptionEnabled || goals.length === 0,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgqZV.default), {
                    key: "GoalFilter",
                    isNested: isNested,
                    goals: goals,
                    selectedGoals: filter[0, $15a528573ccd89ae$export$871e58afc769b358],
                    onChange: onChangeGoals
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$db362e2d293fe52e),
            isStatic: false,
            isHidden: !isDependenciesFeatureEnabled,
            renderer: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8bg0N.default), {
                    key: "DependenciesFilter",
                    onChange: onChangeDependencies,
                    selectedValues: filter[0, $15a528573ccd89ae$export$db362e2d293fe52e]
                })
        }
    ];
    if ((0, $dCm1o.isVisualRefreshEnabled)()) overflowItemsBefore = [
        versionFilter,
        parentFilter,
        {
            id: (0, $15a528573ccd89ae$export$ebb48b08205007c5),
            isStatic: false,
            isHidden: !isIssueTypesFeatureEnabled,
            renderer: (isNested)=>isGroupIssueTypesEnabled ? // In the program board, we could have multiple issue types with the same hierarchy level and names coming from multiple TWP project. We group them so there's no visually duplicated items in the dropdown
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jKPI1.default), {
                    key: "IssueTypeGroupFilter",
                    isNested: isNested,
                    issueTypeGroups: issueTypeGroups,
                    selectedIssueTypes: filter[0, $15a528573ccd89ae$export$ebb48b08205007c5],
                    onChange: onChangeIssueTypes
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hHL6f.default), {
                    key: "IssueTypeFilter",
                    isNested: isNested,
                    issueTypes: issueTypes,
                    selectedIssueTypes: filter[0, $15a528573ccd89ae$export$ebb48b08205007c5],
                    onChange: onChangeIssueTypes
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$37aee82a3cb1e8f7),
            isStatic: false,
            isHidden: !isLabelsFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2fsdj.default), {
                    key: "LabelFilter",
                    isNested: isNested,
                    ...isUnassignedLabelOptionEnabled && labels.length ? {
                        unassignedOption: unassignedOption
                    } : undefined,
                    labels: labels,
                    selectedLabels: filter[0, $15a528573ccd89ae$export$37aee82a3cb1e8f7],
                    onChange: onChangeLabels
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$e50006273435e7d4),
            isStatic: false,
            isHidden: !isStatusesFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3f9TT.default), {
                    key: "StatusFilter",
                    isNested: isNested,
                    statuses: statuses,
                    selectedStatuses: filter[0, $15a528573ccd89ae$export$e50006273435e7d4],
                    onChange: onChangeStatuses
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$f863b019d19144f4),
            isStatic: false,
            isHidden: !isStatusCategoriesFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cSFZv.default), {
                    key: "StatusCategoryFilter",
                    isNested: isNested,
                    statusCategories: statusCategories,
                    selectedStatusCategories: filter[0, $15a528573ccd89ae$export$f863b019d19144f4],
                    onChange: onChangeStatusCategories
                })
        },
        /**
     * the "Project" filter is currently only used by the Increment Planning board of Advanced Roadmaps
     * please refer to src/packages/software/board/src/services/filter/filter-url-bindings.tsx
     */ {
            id: (0, $15a528573ccd89ae$export$401f4b6eda6a369c),
            isStatic: false,
            isHidden: !isIssueProjectsFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $efv79.default), {
                    isNested: isNested,
                    issueProjects: issueProjects,
                    key: "IssueProjectFilter",
                    onChange: onChangeIssueProjects,
                    selectedProjects: filter[0, $15a528573ccd89ae$export$401f4b6eda6a369c]
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$af1e30ebbae9df3b),
            isStatic: false,
            isHidden: !isComponentsFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7j6PN.default), {
                    key: "ComponentFilter",
                    isNested: isNested,
                    components: allComponents,
                    onChange: onChangeComponents,
                    selectedComponents: filter[0, $15a528573ccd89ae$export$af1e30ebbae9df3b]
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$a316570a0dbfd2b0),
            isStatic: false,
            isHidden: !isSprintsFeatureEnabled || sprints.length <= 1,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jdA4J.default), {
                    key: "SprintFilter",
                    isNested: isNested,
                    sprints: sprints,
                    selectedSprints: filter[0, $15a528573ccd89ae$export$a316570a0dbfd2b0],
                    onChange: onChangeSprints
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$871e58afc769b358),
            isStatic: false,
            isHidden: !isGoalsFeatureOptionEnabled || goals.length === 0,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgqZV.default), {
                    key: "GoalFilter",
                    isNested: isNested,
                    goals: goals,
                    selectedGoals: filter[0, $15a528573ccd89ae$export$871e58afc769b358],
                    onChange: onChangeGoals
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$db362e2d293fe52e),
            isStatic: false,
            isHidden: !isDependenciesFeatureEnabled,
            renderer: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8bg0N.default), {
                    key: "DependenciesFilter",
                    onChange: onChangeDependencies,
                    selectedValues: filter[0, $15a528573ccd89ae$export$db362e2d293fe52e]
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$92ab80c1dc9baf44),
            isStatic: false,
            isHidden: !isRequestTypesFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g65Ek.default), {
                    key: "RequestTypeFilter",
                    isNested: isNested,
                    requestTypes: requestTypes,
                    selectedRequestTypes: filter[0, $15a528573ccd89ae$export$92ab80c1dc9baf44],
                    onChange: onChangeRequestTypes
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$68d693c35a8d8866),
            isStatic: false,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cM4EP.default), {
                    key: "CustomFilterBoundary",
                    screenName: screenName,
                    customFiltersQueryRef: customFiltersQueryRef
                }, (!!customFiltersQueryRef || showCustomFilters) && !!CustomFilter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CustomFilter, {
                    isNested: isNested,
                    customFiltersQueryRef: customFiltersQueryRef,
                    selectedFilters: filter[0, $15a528573ccd89ae$export$68d693c35a8d8866],
                    filters: jqlFilters,
                    onChange: onChangeCustomFilters,
                    showLink: isCustomFilterManageLinkEnabled,
                    manageUrl: customFilterManageUrl,
                    screenName: screenName
                }))
        },
        {
            id: (0, $15a528573ccd89ae$export$1ea95b94fb0c51d9),
            isStatic: false,
            isHidden: showCustomFilters,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hpA0D.default), {
                    key: "QuickFilter",
                    isNested: isNested,
                    filters: jqlFilters,
                    selectedFilters: filter[0, $15a528573ccd89ae$export$1ea95b94fb0c51d9],
                    onChange: onChangeQuickFilters
                })
        }
    ];
    const overflowItemsAfter = [
        {
            id: 'CLEAR_BUTTON',
            // The CLEAR_BUTTON should be non-static until a filter is added, else it causes the More button to appear
            // in the filter bar on small window sizes, due to overflow calculations in <OverflowHandler />
            isStatic: isClearButtonVisible,
            isHidden: !isClearButtonVisible,
            renderer: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3oCwY.default), {
                    key: "ClearButton",
                    onClick: onClearAllButtonClicked
                })
        }
    ];
    if (isAsyncFilterLoading) overflowItemsAfter.push({
        id: 'SPINNER',
        isStatic: true,
        isHidden: !isAsyncFilterLoading,
        renderer: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cb7c802f0a442491$var$SpinnerContainer, {
                key: "SpinnerContainer"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
                size: "small"
            }))
    });
    const { getKeywords: getKeywords } = (0, $eG9rp.useCommandKeywords)();
    const [maxVisibleUsers, setMaxVisibleUsers] = (0, $5uXOq.useState)($cb7c802f0a442491$var$DEFAULT_VISIBLE_USERS);
    const [showLargeSearchFilter, setShowLargeSearchFilter] = (0, $5uXOq.useState)(true);
    const filterBarRef = (0, $5uXOq.useRef)(null);
    const onResize = (0, $5uXOq.useCallback)(()=>{
        if (!filterBarRef.current || !searchInputRef.current) return;
        const completeFilterBarWidth = filterBarRef.current.offsetWidth; // complete bar with input + filter controls
        const searchInputWidth = searchInputRef.current.offsetWidth; // only the input
        const remainingWidth = completeFilterBarWidth - searchInputWidth; // remaining room for avatar, etc.
        // Handle avatar overflow
        if (remainingWidth < $cb7c802f0a442491$var$MIN_FILTER_BAR_WIDTH) {
            const usersToReduce = Math.ceil(($cb7c802f0a442491$var$MIN_FILTER_BAR_WIDTH - remainingWidth) / $cb7c802f0a442491$var$USER_AVATAR_WIDTH);
            const newMax = Math.max($cb7c802f0a442491$var$DEFAULT_VISIBLE_USERS - usersToReduce, $cb7c802f0a442491$var$MIN_VISIBLE_USERS);
            setMaxVisibleUsers(newMax);
        } else setMaxVisibleUsers($cb7c802f0a442491$var$DEFAULT_VISIBLE_USERS);
         // Handle search field width
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        setShowLargeSearchFilter(window.innerWidth >= $cb7c802f0a442491$var$LARGE_SEARCH_FILTER_BREAKPOINT);
    }, []);
    (0, $2m0b6.useResizeObserver)({
        ref: filterBarRef,
        onResize: onResize
    });
    (0, $2m0b6.useResizeObserver)({
        ref: searchInputRef,
        onResize: onResize
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fJnmW.FilterBar), {
        ref: filterBarRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $879xD.CommandShortcuts), {
        keyMap: {
            f: {
                callback: focusSearchInput,
                registerInCommandPalette: {
                    id: 'software-filters-stateless-focus-search-input',
                    name: formatMessage((0, $l38sT.default).searchCurrentPage),
                    keywords: getKeywords('pageSearchSynonyms'),
                    priority: (0, $5rVQI.COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY).searchOnCurrentPage,
                    section: (0, $5p1kJ.COMMAND_PALETTE_SECTIONS).quickActions,
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eQfWH))), {
                                spacing: "spacious",
                                label: formatMessage((0, $l38sT.default).searchCurrentPage)
                            })
                    },
                    analytics: {
                        action: 'searchCurrentPage'
                    }
                }
            }
        },
        location: "software.filters.keyboard-shortcuts"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), {
        id: $cb7c802f0a442491$var$SEARCH_ISSUE_DESCRIPTION_SCREEN_READER_ID
    }, screenReaderInstruction || formatMessage((0, $l38sT.default).screenReaderInstruction)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, screenReaderInstructionForFilters ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), {
        "data-testid": "software-filters.ui.stateless.screen-reader-instruction",
        id: "software-filters.ui.stateless.screen-reader-instruction",
        role: "status",
        "aria-relevant": "all"
    }, formatMessage((0, $l38sT.default).screenReaderInstructionForFilters)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), {
        "data-testid": "software-filters.ui.stateless.screen-reader-instruction",
        id: "software-filters.ui.stateless.screen-reader-instruction",
        role: "status"
    })), hijackBrowserDefaultSearch === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2FvdY.default), {
        onFocusSearch: focusSearchInput,
        isAnyModalOpen: isAnyModalOpen
    }), showSearchFilterChangeboarding === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kH9yv.default), {
        hijackBrowserDefaultSearch: hijackBrowserDefaultSearch,
        screenName: screenName,
        isCompanyManaged: isCompanyManaged
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2xSAL.SearchField), {
        placeholderAlwaysVisible: true,
        describedById: $cb7c802f0a442491$var$SEARCH_ISSUE_DESCRIPTION_SCREEN_READER_ID,
        isAlwaysExpanded: showLargeSearchFilter,
        searchIconVisible: false,
        renderCustomSearchField: $cb7c802f0a442491$var$CustomSearchInput,
        value: filter[0, $15a528573ccd89ae$export$d597759d33be802e] || '',
        placeholder: placeholder || formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $l38sT.default).textFilterIssueTermRefresh : (0, $l38sT.default).textFilter),
        onChange: onSearchChange,
        onFocus: onSearchFieldFocus,
        inputRef: searchInputRef,
        maxLength: 255,
        testId: "software-filters.ui.stateless.search-field",
        ...(0, $dCm1o.isVisualRefreshEnabled)() ? {
            reducedHeight: true
        } : {}
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2xSAL.SearchField), {
        placeholderAlwaysVisible: true,
        describedById: $cb7c802f0a442491$var$SEARCH_ISSUE_DESCRIPTION_SCREEN_READER_ID,
        isAlwaysExpanded: showLargeSearchFilter,
        searchIconVisible: false,
        renderCustomSearchField: $cb7c802f0a442491$var$CustomSearchInput,
        value: filter[0, $15a528573ccd89ae$export$d597759d33be802e] || '',
        placeholder: placeholder || formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $l38sT.default).textFilterIssueTermRefresh : (0, $l38sT.default).textFilter),
        onChange: onSearchChange,
        onFocus: onSearchFieldFocus,
        inputRef: searchInputRef,
        maxLength: 255,
        testId: "software-filters.ui.stateless.search-field",
        ...(0, $dCm1o.isVisualRefreshEnabled)() ? {
            reducedHeight: true
        } : {}
    }), showBoardSwitcher && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cTi8P.default), {
        boardId: boardId,
        isReadOnly: isBoardSwitcherReadOnly
    }), showAssigneeFilter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1beWO.default), {
        maxUsers: maxVisibleUsers,
        users: allAssignees,
        screenName: screenName,
        selectedUsers: assigneeValue,
        onToggle: onToggleAssignee,
        onAssigneeMenuOpen: onExtraAvatarMenuOpen,
        AddPeopleModal: shouldDisableAddPeople ? undefined : AddPeopleModal,
        projectId: projectId,
        projectName: projectName,
        isAddPeopleButtonEnabled: isAddPeopleButtonEnabled,
        projectKey: projectKey,
        shouldShowUnassignedFilterNudge: shouldShowUnassignedFilterNudge,
        onClickUnassignedFilterNudge: onClickUnassignedFilterNudge
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fJnmW.ListFilterContainerNextGen // eslint-disable-next-line jira/integration/test-id-by-folder-structure
    ), {
        "data-testid": "software-filters.ui.list-filter-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6CjZR.default), {
        itemsBefore: overflowItemsBefore,
        itemsAfter: overflowItemsAfter,
        selectedItems: filter
    })));
};
const $cb7c802f0a442491$var$customSearchInputStyles = null;
const $cb7c802f0a442491$var$customSearchInputStylesForTheming = null; // TODO: remove on visual-refresh cleanup
const $cb7c802f0a442491$var$customSearchInputStylesOld = null;
const $cb7c802f0a442491$var$CustomSearchInput = ({ textFieldProps: textFieldProps, searchIcon: searchIcon })=>{
    const { isSoftwareFullTheming: isSoftwareFullTheming } = (0, $a2e2Q.useSoftwareProjectTheming)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
    ), {
        ...textFieldProps,
        elemAfterInput: searchIcon,
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
            paddingInlineStart: "space.100",
            paddingBlockStart: "space.025"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($26g7Y)) // @ts-expect-error - TS2322
        ), {
            color: isSoftwareFullTheming ? (0, $6cG4N.Tokens).COLOR_TEXT_SUBTLE : "var(--ds-icon, #44546F)",
            LEGACY_size: "small",
            label: ""
        })),
        autoComplete: "off",
        testId: "software-filters.ui.stateless.search-field",
        className: (0, $bwpsq.default)([
            (0, $dCm1o.isVisualRefreshEnabled)() ? "_1hxm12x7 _1twg1b66 _12sv7vkz" : "_2rkoq1pp _u5f3ze3t _19bvze3t _1tsv1b66 _ahgx1b66 _hh221b66 _1s0f1b66 _1srlxy5q",
            isSoftwareFullTheming && "_bfhkjjc1 _sg3vjjc1 _w15ajjc1"
        ])
    });
};
var $cb7c802f0a442491$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $5uXOq.memo)($cb7c802f0a442491$var$SoftwareFiltersStateless);
const $cb7c802f0a442491$var$SpinnerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19bv1b66 _4t3i1osq _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6CjZR", function(module, exports) {

$parcel$export(module.exports, "default", () => $0aef8f88c53fc825$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $47bDC = parcelRequire("47bDC");

var $16T6Y = parcelRequire("16T6Y");

var $fVnbM = parcelRequire("fVnbM");

var $c8Oei = parcelRequire("c8Oei");

var $1I7E8 = parcelRequire("1I7E8");

var $3bDjY = parcelRequire("3bDjY");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $gSExi = parcelRequire("gSExi");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $22OQR = parcelRequire("22OQR");

var $a2e2Q = parcelRequire("a2e2Q");

var $lmBAt = parcelRequire("lmBAt");

var $7Hgp8 = parcelRequire("7Hgp8");

var $AOaWd = parcelRequire("AOaWd");

var $5yCxu = parcelRequire("5yCxu");
const $0aef8f88c53fc825$var$BadgeContainerFeatureGated = ({ children: children })=>(0, $4R6GH.fg)('filters_trigger_fix_badge_style') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span",
        xcss: $0aef8f88c53fc825$var$badgeStyle
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0aef8f88c53fc825$var$BadgeContainer, null, children);
const $0aef8f88c53fc825$var$OverflowHandler = ({ itemsBefore: itemsBefore, itemsAfter: itemsAfter, selectedItems: selectedItems = {} })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const overflowContainerRef = (0, $5uXOq.useRef)(null);
    const overflowContainerUlRef = (0, $5uXOq.useRef)(null);
    const moreFilterRef = (0, $5uXOq.useRef)(null);
    const moreFilterLiRef = (0, $5uXOq.useRef)(null);
    const elementsRef = (0, $5uXOq.useRef)({});
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    // There is a flickering bug switching to/from the "more" button https://jplat.atlassian.net/browse/BLU-3488
    // Additional information can also be found in https://jbusiness.atlassian.net/browse/JVRQ-426
    // But can't reproduce in Storybook + lot of pending changes, so won't fix for now.
    // I suspect this is related to this out-of-rerender memorization of data.
    // Next person actively working on this file is welcome to check. See also investigation notes in the ticket above.
    const prevOverflowContainerWidthRef = (0, $5uXOq.useRef)(0);
    const elementsWidthRef = (0, $5uXOq.useRef)({});
    const visibleElementsRef = (0, $5uXOq.useRef)({});
    const prevElementsWidthRef = (0, $5uXOq.useRef)({});
    const [{ overflowableHideState: overflowableHideState, isMoreDropdownHidden: isMoreDropdownHidden }, setOverflowState] = (0, $5uXOq.useState)({
        overflowableHideState: {},
        isMoreDropdownHidden: true
    });
    const { renderedOverflowableItems: renderedOverflowableItems, staticItems: staticItems, renderedItemsBefore: renderedItemsBefore, renderedItemsAfter: renderedItemsAfter } = (0, $5uXOq.useMemo)(()=>{
        const theOverflowable = [];
        const theStatic = [];
        const theRenderedBefore = [];
        const theRenderedAfter = [];
        const categoriseItems = ({ isRenderedBefore: isRenderedBefore })=>{
            (isRenderedBefore ? itemsBefore : itemsAfter).forEach((item)=>{
                const { isStatic: isStatic, isHidden: isHidden = false } = item;
                // Exclude hidden overflowable items from rendering
                if (!isStatic && isHidden) return;
                (isStatic ? theStatic : theOverflowable).push(item);
                (isRenderedBefore ? theRenderedBefore : theRenderedAfter).push(item);
            });
        };
        categoriseItems({
            isRenderedBefore: true
        });
        categoriseItems({
            isRenderedBefore: false
        });
        return {
            renderedOverflowableItems: theOverflowable,
            staticItems: theStatic,
            renderedItemsBefore: theRenderedBefore,
            renderedItemsAfter: theRenderedAfter
        };
    }, [
        itemsBefore,
        itemsAfter
    ]);
    /**
   * Calculate the count for "More" dropdown.
   * It excludes the selected items of the visible items.
   */ const selectedOverflowItemsCount = (0, $5uXOq.useMemo)(()=>(0, $5yCxu.getSelectedItemsCount)(overflowableHideState, selectedItems), [
        overflowableHideState,
        selectedItems
    ]);
    const onResize = (0, $5uXOq.useCallback)(()=>{
        const overflowContainer = (0, $4R6GH.fg)('jfp_a11y_team_fix_filters_missing_list_mark_up') ? overflowContainerUlRef?.current : overflowContainerRef?.current;
        const moreFilter = (0, $4R6GH.fg)('jfp_a11y_team_fix_filters_missing_list_mark_up') ? moreFilterLiRef?.current : moreFilterRef?.current;
        const shouldRecomputeOverflow = (0, $5yCxu.getShouldRecomputeOverflow)(prevOverflowContainerWidthRef.current, overflowContainer?.offsetWidth ?? 0, prevElementsWidthRef.current, elementsWidthRef.current);
        if (!overflowContainer || !moreFilter || !renderedOverflowableItems.length || !shouldRecomputeOverflow) return;
        // Store the widths for comparison
        prevOverflowContainerWidthRef.current = overflowContainer.offsetWidth;
        prevElementsWidthRef.current = {
            ...elementsWidthRef.current
        };
        setOverflowState((0, $5yCxu.calcOverflow)(overflowContainer, moreFilter, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        renderedOverflowableItems, staticItems, elementsRef.current));
    }, [
        renderedOverflowableItems,
        staticItems
    ]);
    (0, $AOaWd.useResizeObserver)((0, $4R6GH.fg)('jfp_a11y_team_fix_filters_missing_list_mark_up') ? overflowContainerUlRef : overflowContainerRef, onResize);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(!isOpen);
    }, [
        isOpen,
        setIsOpen
    ]);
    const onClose = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(false);
    }, [
        setIsOpen
    ]);
    const triggerLabel = formatMessage((0, $7Hgp8.default).more);
    const triggerTooltipText = formatMessage((0, $7Hgp8.default).moreFiltersTooltip);
    const buttonToolTip = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: triggerTooltipText,
            hideTooltipOnClick: true,
            tag: "span"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0aef8f88c53fc825$var$TriggerContainer, {
            "data-testid": "filters.common.ui.overflow-handler.trigger-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0aef8f88c53fc825$var$TriggerLabel, null, triggerLabel), selectedOverflowItemsCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0aef8f88c53fc825$var$BadgeContainerFeatureGated, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16T6Y.default), {
            appearance: "primary"
        }, selectedOverflowItemsCount)))), [
        selectedOverflowItemsCount,
        triggerTooltipText,
        triggerLabel
    ]);
    const content = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0aef8f88c53fc825$var$PopupContainer, null, renderedOverflowableItems.map(({ id: id, renderer: renderer })=>Boolean(overflowableHideState[id]) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
                key: id
            }, renderer(true)))), [
        renderedOverflowableItems,
        overflowableHideState
    ]);
    const renderItems = (items)=>items.map(({ id: id, isStatic: isStatic, isHidden: isHidden = false, renderer: renderer })=>{
            const isItemHidden = isStatic ? isHidden : Boolean(overflowableHideState[id]);
            if ((0, $4R6GH.fg)('jfp_a11y_team_fix_filters_missing_list_mark_up')) {
                const isLiElementHidden = elementsRef?.current?.[id]?.offsetWidth === 0;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", {
                    key: id,
                    ref: (element)=>{
                        elementsRef.current[id] = element;
                        if (element) {
                            elementsWidthRef.current[id] = element.offsetWidth;
                            if (!isHidden) visibleElementsRef.current[id] = {
                                width: element.offsetWidth,
                                height: element.offsetHeight
                            };
                        }
                    },
                    // This ensures elements that do not occupy space are not announced/counted by screen readers
                    "aria-hidden": isItemHidden || isLiElementHidden,
                    className: (0, $bwpsq.default)([
                        isItemHidden || isLiElementHidden ? "_1o9zidpf _1f49cs5v _3um015vq _lcxvglyw _19pkidpf" : "_1o9zidpf _1f49kb7n _3um0ewfl _lcxv1wug _19pkidpf"
                    ])
                }, renderer(false));
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0aef8f88c53fc825$var$ItemWrapper, {
                key: id,
                innerRef: (element)=>{
                    elementsRef.current[id] = element;
                    if (element) {
                        elementsWidthRef.current[id] = element.offsetWidth;
                        if (!isHidden) visibleElementsRef.current[id] = {
                            width: element.offsetWidth,
                            height: element.offsetHeight
                        };
                    }
                },
                "aria-hidden": isItemHidden,
                isHidden: isItemHidden
            }, renderer(false));
        });
    const { isSoftwareFullTheming: isThemed } = (0, $a2e2Q.useSoftwareProjectTheming)();
    const ButtonComponent = isThemed ? (0, $22OQR.ThemedButton) : (0, $fVnbM.default);
    if ((0, $4R6GH.fg)('jfp_a11y_team_fix_filters_missing_list_mark_up')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("ul", {
        ref: overflowContainerUlRef,
        className: (0, $bwpsq.default)([
            (0, $dCm1o.isVisualRefreshEnabled)() ? "_1e0c1txw _1ul9idpf _19pkidpf _2hwxr5cr _otyridpf _18u0r5cr" : "_1e0c1txw _1ul9idpf",
            "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf"
        ])
    }, renderItems(renderedItemsBefore), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", {
        ref: moreFilterLiRef,
        "aria-hidden": isMoreDropdownHidden,
        className: (0, $bwpsq.default)([
            isMoreDropdownHidden ? "_1o9zidpf _1f49cs5v _3um015vq _lcxvglyw _19pkidpf" : "_1o9zidpf _1f49kb7n _3um0ewfl _lcxv1wug _19pkidpf",
            (0, $dCm1o.isVisualRefreshEnabled)() && "_2hwx1b66"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.Popup), {
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ButtonComponent, {
                ...triggerProps,
                appearance: (0, $dCm1o.isVisualRefreshEnabled)() ? 'default' : 'subtle',
                isSelected: isOpen,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
                    label: "",
                    ...!(isThemed && (0, $lmBAt.getIsSoftwareThemingEnabled)()) && {
                        color: "var(--ds-icon, #44546F)"
                    }
                }),
                onClick: onClick
            }, buttonToolTip),
        shouldRenderToParent: true,
        shouldFlip: true,
        isOpen: isOpen,
        placement: "bottom-start",
        content: content,
        onClose: onClose
    })), renderItems(renderedItemsAfter));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: overflowContainerRef,
        className: (0, $bwpsq.default)([
            (0, $dCm1o.isVisualRefreshEnabled)() ? "_1e0c1txw _1ul9idpf _19pkidpf _2hwxr5cr _otyridpf _18u0r5cr" : "_1e0c1txw _1ul9idpf"
        ])
    }, renderItems(renderedItemsBefore), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0aef8f88c53fc825$var$ItemWrapper, {
        innerRef: moreFilterRef,
        "aria-hidden": isMoreDropdownHidden,
        isHidden: isMoreDropdownHidden,
        shouldAddRightMargin: (0, $dCm1o.isVisualRefreshEnabled)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.Popup), {
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ButtonComponent, {
                ...triggerProps,
                appearance: (0, $dCm1o.isVisualRefreshEnabled)() ? 'default' : 'subtle',
                isSelected: isOpen,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
                    label: "",
                    ...!(isThemed && (0, $lmBAt.getIsSoftwareThemingEnabled)()) && {
                        color: "var(--ds-icon, #44546F)"
                    }
                }),
                onClick: onClick
            }, buttonToolTip),
        shouldRenderToParent: true,
        shouldFlip: true,
        isOpen: isOpen,
        placement: "bottom-start",
        content: content,
        onClose: onClose
    })), renderItems(renderedItemsAfter));
};
var $0aef8f88c53fc825$export$2e2bcd8739ae039 = $0aef8f88c53fc825$var$OverflowHandler;
const $0aef8f88c53fc825$var$overflowContainerStylesOld = null;
const $0aef8f88c53fc825$var$overflowContainerStyles = null;
const $0aef8f88c53fc825$var$UlBoxStyles = null;
const $0aef8f88c53fc825$var$liItemHiddenStyles = null;
const $0aef8f88c53fc825$var$liItemVisibleStyles = null;
const $0aef8f88c53fc825$var$liItemWithRightMarginStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0aef8f88c53fc825$var$PopupContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0q1b66 _u5f3idpf _n3td1b66 _19bvidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0aef8f88c53fc825$var$TriggerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0aef8f88c53fc825$var$TriggerLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_o5721q9c",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0aef8f88c53fc825$var$BadgeContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _19bv1b66",
            __cmplp.className
        ])
    });
});
const $0aef8f88c53fc825$var$badgeStyle = (0, $8CUq3.xcss)({
    paddingLeft: 'space.050',
    display: 'flex',
    alignSelf: 'center'
});
const $0aef8f88c53fc825$var$ItemWrapperControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1krxkwp-0"
})((props)=>({
        flexShrink: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        order: props.isHidden ? 2 : 1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        visibility: props.isHidden ? 'hidden' : 'visible',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        pointerEvents: props.isHidden ? 'none' : 'auto'
    })); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0aef8f88c53fc825$var$ItemWrapperExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isHidden: isHidden, shouldAddRightMargin: shouldAddRightMargin, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1vahmbr": (0, $lD23V.default)(__cmplp.shouldAddRightMargin && "var(--ds-space-050, 4px)")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1o9zidpf _2hwx6yr2",
            __cmplp.isHidden ? "_1f49cs5v" : "_1f49kb7n",
            __cmplp.isHidden ? "_3um015vq" : "_3um0ewfl",
            __cmplp.isHidden ? "_lcxvglyw" : "_lcxv1wug",
            __cmplp.className
        ])
    });
});
const $0aef8f88c53fc825$var$ItemWrapper = (0, $gSExi.styledComponentWithCondition)(()=>(0, $4R6GH.fg)('jsw_compiled_migration_tanuki'), $0aef8f88c53fc825$var$ItemWrapperExperiment, $0aef8f88c53fc825$var$ItemWrapperControl);

});
parcelRegister("7Hgp8", function(module, exports) {

$parcel$export(module.exports, "default", () => $cea3021c9215d69b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cea3021c9215d69b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    more: {
        "id": "software-filters.common.overflow-handler.more",
        "defaultMessage": "More"
    },
    moreFiltersTooltip: {
        "id": "software-filters.common.overflow-handler.more-filters-tooltip",
        "defaultMessage": "More filters"
    }
});

});

parcelRegister("AOaWd", function(module, exports) {

$parcel$export(module.exports, "useResizeObserver", () => $d7fe9cd69e6a83c0$export$683480f191c0e3ea);

var $5uXOq = parcelRequire("5uXOq");
let $d7fe9cd69e6a83c0$var$resizeObserver;
const $d7fe9cd69e6a83c0$var$callbacks = new Map();
const $d7fe9cd69e6a83c0$var$runCallbacks = (entries)=>{
    entries.forEach((entry)=>{
        const { target: target } = entry;
        const callback = $d7fe9cd69e6a83c0$var$callbacks.get(target);
        callback?.(entry);
    });
};
const $d7fe9cd69e6a83c0$var$observeElement = (target, callback)=>{
    if (typeof ResizeObserver === 'undefined') return;
    if (!$d7fe9cd69e6a83c0$var$resizeObserver) $d7fe9cd69e6a83c0$var$resizeObserver = new ResizeObserver($d7fe9cd69e6a83c0$var$runCallbacks);
    $d7fe9cd69e6a83c0$var$callbacks.set(target, callback);
    $d7fe9cd69e6a83c0$var$resizeObserver.observe(target);
};
const $d7fe9cd69e6a83c0$var$unobserveElement = (target)=>{
    if (!$d7fe9cd69e6a83c0$var$resizeObserver) return;
    $d7fe9cd69e6a83c0$var$callbacks.delete(target);
    $d7fe9cd69e6a83c0$var$resizeObserver.unobserve(target);
};
const $d7fe9cd69e6a83c0$export$683480f191c0e3ea = (ref, callback)=>{
    (0, $5uXOq.useLayoutEffect)(()=>{
        const element = ref.current;
        element && $d7fe9cd69e6a83c0$var$observeElement(element, callback);
        return ()=>{
            element && $d7fe9cd69e6a83c0$var$unobserveElement(element);
        };
    }, [
        ref,
        callback
    ]);
};

});

parcelRegister("5yCxu", function(module, exports) {

$parcel$export(module.exports, "calcOverflow", () => $6dfc047016dbaaed$export$7128ab9dfe00f62e);
$parcel$export(module.exports, "getShouldRecomputeOverflow", () => $6dfc047016dbaaed$export$2544af09d06b9c65);
$parcel$export(module.exports, "getSelectedItemsCount", () => $6dfc047016dbaaed$export$b0e31612dc0df344);

var $gccSB = parcelRequire("gccSB");
const $6dfc047016dbaaed$export$1fed873882a661c5 = (items, itemElements, spaceLimit)=>{
    const hideState = {};
    let usedSpace = 0;
    let isOverflowingAssumed = false;
    items.forEach(({ id: id })=>{
        const element = itemElements[id];
        if (element) {
            const { offsetWidth: space } = element;
            if ((spaceLimit === undefined || usedSpace + space < spaceLimit) && !isOverflowingAssumed) usedSpace += space;
            else {
                if (!isOverflowingAssumed) isOverflowingAssumed = true;
                hideState[id] = true;
            }
        }
    });
    return {
        usedSpace: usedSpace,
        hideState: hideState
    };
};
const $6dfc047016dbaaed$export$7128ab9dfe00f62e = ({ offsetWidth: availableSpace }, { offsetWidth: moreFilterSpace }, renderedOverflowableItems, staticItems, itemElements)=>{
    const { usedSpace: staticSpace } = $6dfc047016dbaaed$export$1fed873882a661c5(staticItems, itemElements);
    const maxOverflowableSpace = renderedOverflowableItems.reduce((maxSpace, { id: id })=>maxSpace + (itemElements[id]?.offsetWidth ?? 0), 0);
    const isOverflowing = maxOverflowableSpace + staticSpace > availableSpace;
    let overflowableHideState = {};
    if (isOverflowing) {
        const spaceLimit = Math.max(availableSpace - moreFilterSpace - staticSpace, 0);
        const { hideState: hideState } = $6dfc047016dbaaed$export$1fed873882a661c5(renderedOverflowableItems, itemElements, spaceLimit);
        overflowableHideState = hideState;
    }
    return {
        overflowableHideState: overflowableHideState,
        isMoreDropdownHidden: !isOverflowing
    };
};
const $6dfc047016dbaaed$var$BADGE_WIDTH_THRESHOLD = 25; // Width of count badge
const $6dfc047016dbaaed$export$2544af09d06b9c65 = (prevContainerWidth, currContainerWidth, prevElementsWidthRef, currElementsWidthRef)=>{
    const currItemIds = Object.keys(currElementsWidthRef);
    const prevItemIds = Object.keys(prevElementsWidthRef);
    if (prevItemIds.length !== currItemIds.length || prevContainerWidth !== currContainerWidth) return true;
    const hasItemsWidthChange = currItemIds.some((id)=>prevElementsWidthRef[id] === undefined || Math.abs(prevElementsWidthRef[id] - currElementsWidthRef[id]) > $6dfc047016dbaaed$var$BADGE_WIDTH_THRESHOLD);
    return hasItemsWidthChange;
};
const $6dfc047016dbaaed$export$b0e31612dc0df344 = (itemsHiddenState, selectedItems)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(selectedItems) || (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(itemsHiddenState)) return 0;
    return Object.entries(selectedItems).reduce((acc, [key, value])=>{
        if (value === undefined || itemsHiddenState[key] !== true) return acc;
        // selectedItem could be "any" value, if the value is not an Array, it will be counted as 1
        return Array.isArray(value) ? acc + value.length : acc + 1;
    }, 0);
};

});


parcelRegister("1beWO", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f4b1966602deeb5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $6s1PB = parcelRequire("6s1PB");

var $2OMDV = parcelRequire("2OMDV");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $12hlA = parcelRequire("12hlA");


var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");

var $9OXo1 = parcelRequire("9OXo1");

var $cpQgt = parcelRequire("cpQgt");

var $j6etC = parcelRequire("j6etC");

var $eJpZk = parcelRequire("eJpZk");

var $lAu6N = parcelRequire("lAu6N");
const $6f4b1966602deeb5$var$StatelessAssigneeFilterWithAnalytics = (0, $2OMDV.AnalyticsEventToProps)('StatelessAssigneeFilterWithAnalytics', {
    onAddPeopleClick: 'clicked'
})((0, $lAu6N.default));
$6f4b1966602deeb5$var$StatelessAssigneeFilterWithAnalytics.displayName = 'StatelessAssigneeFilterWithAnalytics';
const $6f4b1966602deeb5$export$804bfdea59f89629 = (baseUrl, setShowUpSell, showUpSell, setShowAddPeopleModal, showAddPeopleModal, jswEdition, analyticsEvent, screenName, fireTriggerClickEvent)=>{
    const openAddPeopleModal = ()=>{
        setShowAddPeopleModal(!showAddPeopleModal);
    };
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jsw_allow_project_invite_past_10th_user_on_free');
    if (jswEdition === (0, $ldyPw.toEdition)((0, $ldyPw.FREE_EDITION))) (0, $j6etC.getRemainingSeats)(baseUrl, (0, $c06e1abca7c13910$export$1346c9aa3cbb477d)).then((remainingSeats)=>{
        if (remainingSeats === 0) {
            // When the JSW Free instance is at the user limit and
            // the user is enrolled in the auto-upgrade experiment, fire an exposure event
            if (expConfig.get('cohort', 'not-enrolled') !== 'not-enrolled') {
                const [, fireExposureEvent] = (0, $6s1PB.UNSAFE_noExposureExp)('jsw_allow_project_invite_past_10th_user_on_free');
                fireExposureEvent();
            }
            fireTriggerClickEvent();
            // If the user is in the auto-upgrade experiment variation cohort, show the invite modal.
            // Otherwise, show the upsell dialog.
            if (expConfig.get('cohort', 'not-enrolled') === 'variation') openAddPeopleModal();
            else {
                setShowUpSell(!showUpSell);
                if (!showUpSell) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, `${screenName}AssigneeFilterAddPeople`);
            }
        } else {
            fireTriggerClickEvent();
            openAddPeopleModal();
        }
    }).catch((e)=>{
        fireTriggerClickEvent();
        openAddPeopleModal();
        throw e;
    });
    else {
        fireTriggerClickEvent();
        // If not on JSW Free, always show the invite modal
        openAddPeopleModal();
    }
};
const $6f4b1966602deeb5$var$ConditionalUpsellDialogWrapper = (props)=>{
    const { children: children, showUpsellDialog: showUpsellDialog, setShowUpsellDialog: setShowUpsellDialog, screenName: screenName } = props;
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jsw_allow_project_invite_past_10th_user_on_free');
    if (expConfig.get('cohort', 'not-enrolled') === 'variation') // When the user is in the experiment variation cohort, we won't be showing the upsell dialog.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    const onUpgradeDialogClose = ()=>{
        setShowUpsellDialog(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cpQgt.default), {
        isOpen: showUpsellDialog,
        onClose: onUpgradeDialogClose,
        touchpointId: `${screenName || ''}${screenName ? 'A' : 'a'}ssigneeFilterAddPeople`,
        onUpFlowDismiss: onUpgradeDialogClose
    }, children);
};
const $6f4b1966602deeb5$export$20e0939737a940df = (props)=>{
    const { users: users, maxUsers: maxUsers, AddPeopleModal: AddPeopleModal, screenName: screenName, selectedUsers: selectedUsers, onToggle: onToggle, projectId: projectId, isAddPeopleButtonEnabled: isAddPeopleButtonEnabled, projectName: projectName, projectKey: projectKey, onAssigneeMenuOpen: onAssigneeMenuOpen, shouldShowUnassignedFilterNudge: shouldShowUnassignedFilterNudge, onClickUnassignedFilterNudge: onClickUnassignedFilterNudge } = props;
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const [showAddPeopleModal, setShowAddPeopleModal] = (0, $5uXOq.useState)(false);
    const [showUpSell, setShowUpSell] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const appEdition = (0, $ldyPw.getEdition)((0, $efvDm.JIRA_SOFTWARE), tenantContext.appEditions);
    const onAddPeopleClick = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        const fireAddPeopleClickEvent = ()=>{
            // If neither the upsell dialog nor the invite modal is currently open,
            // then the user is trying to open one of them. When this happens,
            // we fire an analytics event.
            if (!showAddPeopleModal && !showUpSell) {
                const event = createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'button',
                    source: screenName
                });
                (0, $8zOmE.fireUIAnalytics)(event, 'assigneeFilterAddPeople');
            }
        };
        $6f4b1966602deeb5$export$804bfdea59f89629(tenantContext.baseUrl, setShowUpSell, showUpSell, setShowAddPeopleModal, showAddPeopleModal, appEdition, analyticsEvent, screenName || '', fireAddPeopleClickEvent);
    }, [
        createAnalyticsEvent,
        tenantContext.baseUrl,
        showUpSell,
        showAddPeopleModal,
        appEdition,
        screenName
    ]);
    const onAddPeopleModalClose = (0, $5uXOq.useCallback)(()=>{
        setShowAddPeopleModal(false);
    }, []);
    const showAddPeopleButton = AddPeopleModal !== undefined && isAddPeopleButtonEnabled;
    const addButtonRef = (0, $5uXOq.useRef)(null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6f4b1966602deeb5$var$ConditionalUpsellDialogWrapper, {
        showUpsellDialog: showUpSell,
        setShowUpsellDialog: setShowUpSell,
        screenName: screenName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6f4b1966602deeb5$var$StatelessAssigneeFilterWithAnalytics, {
        peopleRef: addButtonRef,
        users: users,
        maxUsers: maxUsers,
        selectedUsers: selectedUsers,
        onToggle: onToggle,
        onAddPeopleClick: onAddPeopleClick,
        showAddPeopleButton: showAddPeopleButton,
        screenName: screenName || '',
        projectId: projectId,
        onAssigneeMenuOpen: onAssigneeMenuOpen,
        shouldShowUnassignedFilterNudge: shouldShowUnassignedFilterNudge,
        onClickUnassignedFilterNudge: onClickUnassignedFilterNudge
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eJpZk.Analytics), {
        baseUrl: tenantContext.baseUrl,
        projectId: projectId,
        screenName: screenName || '',
        showAddPeopleButton: showAddPeopleButton
    }), AddPeopleModal && showAddPeopleModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $12hlA.default), {
        inviteRef: addButtonRef,
        appEdition: appEdition,
        cloudId: tenantContext.cloudId,
        isOpen: true,
        onClose: onAddPeopleModalClose,
        jiraProjectName: projectName,
        projectId: projectId,
        jiraProjectKey: projectKey,
        isSiteAdmin: tenantContext.isSiteAdmin
    }));
};
$6f4b1966602deeb5$export$20e0939737a940df.defaultProps = {
    users: [],
    selectedUsers: [],
    maxUsers: 5,
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onAssigneeMenuOpen: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    AddPeopleModal: undefined,
    isAddPeopleButtonEnabled: false,
    projectId: -1
};
const $6f4b1966602deeb5$var$AssigneeFilterComponent = /*#__PURE__*/ (0, $5uXOq.memo)($6f4b1966602deeb5$export$20e0939737a940df);
$6f4b1966602deeb5$var$AssigneeFilterComponent.displayName = 'AssigneeFilter';
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<{ isAddPeopleButtonEnabled: boolean; readonly projectId: number; } & CommonAssigneeFilterProps & { AddPeopleModal: ComponentType<{ onClose: () => void; isOpen: boolean; }> | undefined; }>'.
$6f4b1966602deeb5$var$AssigneeFilterComponent.whyDidYouRender = true;
var $6f4b1966602deeb5$export$2e2bcd8739ae039 = $6f4b1966602deeb5$var$AssigneeFilterComponent;

});
parcelRegister("12hlA", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bc8c7c74346f034$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0bc8c7c74346f034$var$LazyComponent = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("dc1Hs")), {
    ssr: false,
    moduleId: "./src/packages/project-settings/invite-people-modal-project/src/index.tsx"
});
const $0bc8c7c74346f034$export$6a02a79fa2b0ddab = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "async-project-invite-people-modal",
        packageName: "jira-project-invite-people-modal",
        teamName: "groot-growth"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "project-invite-people-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0bc8c7c74346f034$var$LazyComponent, props)));
var $0bc8c7c74346f034$export$2e2bcd8739ae039 = $0bc8c7c74346f034$export$6a02a79fa2b0ddab;

});
parcelRegister("dc1Hs", function(module, exports) {

let $99adb6ea021a0d60$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $99adb6ea021a0d60$var$load("76n7a"),
    $99adb6ea021a0d60$var$load("l253H"),
    $99adb6ea021a0d60$var$load("ffQaD"),
    $99adb6ea021a0d60$var$load("kvRbA"),
    $99adb6ea021a0d60$var$load("kNFvF"),
    $99adb6ea021a0d60$var$load("jLXj7")
]).then(()=>parcelRequire('3dNZP'));

});


const $c06e1abca7c13910$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $c06e1abca7c13910$export$e9c56aa3b027d98f = 'jira-customer-service';
const $c06e1abca7c13910$export$1346c9aa3cbb477d = 'jira-software';
const $c06e1abca7c13910$export$202f50ee62667e32 = 'jira-product-discovery';
const $c06e1abca7c13910$export$db515c8cec1e6f79 = 'jira-core';
const $c06e1abca7c13910$export$c811f21c9ad05dc2 = 'confluence';
const $c06e1abca7c13910$export$961148c98d198270 = 'opsgenie';

parcelRegister("cpQgt", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fee2ed613b7661e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9yOBd = parcelRequire("9yOBd");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $iMd5l = parcelRequire("iMd5l");

var $cVzoY = parcelRequire("cVzoY");

var $34Vv8 = parcelRequire("34Vv8");

var $eHJxW = parcelRequire("eHJxW");

var $az4zD = parcelRequire("az4zD");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");


var $ldyPw = parcelRequire("ldyPw");

var $9OXo1 = parcelRequire("9OXo1");

var $2hXCB = parcelRequire("2hXCB");

var $02gpZ = parcelRequire("02gpZ");

var $4J6oz = parcelRequire("4J6oz");


var $de8ma = parcelRequire("de8ma");
const $1fee2ed613b7661e$var$fireCTAButtonAnalytics = (analyticsEvent, actionSubjectId, touchpointId, currentEdition)=>{
    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, actionSubjectId, {
        currentEdition: currentEdition,
        touchpointId: touchpointId,
        targetEdition: (0, $4J6oz.applicationEditionToUpFlowEdition)((0, $ldyPw.STANDARD_EDITION)),
        isGrandfathered: false,
        isSiteAdmin: true,
        upFlowVariateFlag: 'experiment'
    });
};
const $1fee2ed613b7661e$var$showTryNowButton = (onClick, label, href, target)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yOBd.default), {
        appearance: "primary",
        onClick: onClick,
        href: href,
        target: target,
        rel: "noopener"
    }, label);
const $1fee2ed613b7661e$var$showLearnMoreButton = (appearance, onClick, label, href, target)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yOBd.default), {
        appearance: appearance,
        onClick: onClick,
        href: href,
        target: target,
        rel: "noopener"
    }, label); // TODO split this file in to proper tangerine app structure, it's getting too big
const $1fee2ed613b7661e$var$UpgradeToAddUsersDialog = (props)=>{
    const { children: children, isOpen: isOpen, onClose: onClose, intl: intl, touchpointId: touchpointId, onUpFlowDismiss: onUpFlowDismiss } = props;
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const explicitlyLicensedProducts = (0, $cVzoY.default)(tenantContext);
    const hasOnlyJSW = explicitlyLicensedProducts.length === 1 && explicitlyLicensedProducts[0] === (0, $c06e1abca7c13910$export$1346c9aa3cbb477d);
    const [upFlowIframeState, setUpFlowIframeState] = (0, $5uXOq.useState)(null);
    const currentEdition = (0, $4J6oz.applicationEditionToUpFlowEdition)((0, $iMd5l.getProductEdition)(explicitlyLicensedProducts[0], tenantContext));
    const upgradeButtonOnClick = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type.
    (_, analyticsEvent)=>{
        const actionSubjectId = (0, $2hXCB.mapActionIdFromType)[0, $2hXCB.UPGRADE];
        $1fee2ed613b7661e$var$fireCTAButtonAnalytics(analyticsEvent, actionSubjectId, touchpointId, currentEdition);
        hasOnlyJSW && setUpFlowIframeState((0, $2hXCB.UPGRADE));
    }, [
        currentEdition,
        hasOnlyJSW,
        touchpointId
    ]);
    const learnMoreButtonOnClick = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type.
    (_, analyticsEvent)=>{
        const actionSubjectId = (0, $2hXCB.mapActionIdFromType)[0, $2hXCB.LEARN_MORE];
        $1fee2ed613b7661e$var$fireCTAButtonAnalytics(analyticsEvent, actionSubjectId, touchpointId, currentEdition);
        hasOnlyJSW && setUpFlowIframeState((0, $2hXCB.LEARN_MORE));
    }, [
        currentEdition,
        hasOnlyJSW,
        touchpointId
    ]);
    const onUpFlowIframeClose = (0, $5uXOq.useCallback)(()=>{
        setUpFlowIframeState(null);
        onUpFlowDismiss();
    }, [
        onUpFlowDismiss
    ]);
    const learnMoreButtonAppearance = tenantContext.isSiteAdmin ? 'link' : 'primary';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: touchpointId,
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHJxW.JiraInlineDialog), {
        messageId: "up-flow-upgrade-to-add-users-dialog.inline-dialog",
        messageType: "transactional",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
            sourceName: "changeEditionGateway",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
            attributes: {
                isSiteAdmin: tenantContext.isSiteAdmin,
                source: touchpointId
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, intl.formatMessage((0, $de8ma.default).upgradeToAddUsersHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1fee2ed613b7661e$var$MultiLineParagraph, null, intl.formatMessage((0, $de8ma.default).upgradeToAddUsersContent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $1fee2ed613b7661e$var$buttonBarStyles
        }, tenantContext.isSiteAdmin ? $1fee2ed613b7661e$var$showTryNowButton(// @ts-expect-error - TS2345 - Argument of type '(_: any, analyticsEvent: UIAnalyticsEventInterface) => void' is not assignable to parameter of type '() => void'.
        upgradeButtonOnClick, intl.formatMessage((0, $de8ma.default).upgradeButtonLabel), hasOnlyJSW ? undefined : (0, $9996ddd22815931e$export$cfca87b5d4683694), hasOnlyJSW ? undefined : '_blank') : null, $1fee2ed613b7661e$var$showLearnMoreButton(learnMoreButtonAppearance, // @ts-expect-error - TS2345 - Argument of type '(_: any, analyticsEvent: UIAnalyticsEventInterface) => void' is not assignable to parameter of type '() => void'.
        learnMoreButtonOnClick, intl.formatMessage((0, $de8ma.default).learnMoreButtonLabel), hasOnlyJSW ? undefined : (0, $9996ddd22815931e$export$997e23a0aec74966), hasOnlyJSW ? undefined : '_blank')), upFlowIframeState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $02gpZ.UpFlowIFrame), {
            targetEdition: (0, $ldyPw.STANDARD_EDITION),
            product: explicitlyLicensedProducts[0],
            flow: upFlowIframeState,
            touchpointId: touchpointId,
            experienceTrackingEnabled: true,
            onClose: onUpFlowIframeClose
        })),
        isOpen: isOpen,
        onClose: onClose,
        placement: "bottom-start"
    }, children));
};
var $1fee2ed613b7661e$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)((0, $34Vv8.default)($1fee2ed613b7661e$var$UpgradeToAddUsersDialog));
const $1fee2ed613b7661e$var$buttonBarStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1fee2ed613b7661e$var$MultiLineParagraph = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_o5726vc6",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eHJxW", function(module, exports) {

$parcel$export(module.exports, "JiraInlineDialog", () => $51c10262cffee11f$export$7ab52478615504b3);

var $5uXOq = parcelRequire("5uXOq");

var $ctg8C = parcelRequire("ctg8C");

var $10xFf = parcelRequire("10xFf");

var $c0dQj = parcelRequire("c0dQj");

var $5uVz7 = parcelRequire("5uVz7");
const $51c10262cffee11f$export$7ab52478615504b3 = (props)=>{
    if ((0, $10xFf.shouldBeChoreographed)(props)) {
        if ((0, $c0dQj.isMobileAndInViewPanelIterationExperiment)()) return null;
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uVz7.ChoreographerInlineDialog), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctg8C.default), rest);
};

});
parcelRegister("5uVz7", function(module, exports) {

$parcel$export(module.exports, "ChoreographerInlineDialog", () => $aa901de21f3fc2ba$export$44a404f218b0e66e);

var $ctg8C = parcelRequire("ctg8C");

var $fG5AJ = parcelRequire("fG5AJ");
const $aa901de21f3fc2ba$export$44a404f218b0e66e = (0, $fG5AJ.withChoreographedToggle)((0, $ctg8C.default), 'isOpen', 'content');

});


parcelRegister("2hXCB", function(module, exports) {

$parcel$export(module.exports, "LEARN_MORE", () => $a61f434346a6f772$export$1979295cc80a7ec1);
$parcel$export(module.exports, "WORKFLOW_EDIT_PERMISSION_LEARN_MORE", () => $a61f434346a6f772$export$779203acbfa8bf12);
$parcel$export(module.exports, "UPGRADE", () => $a61f434346a6f772$export$fe5b785cab515b6e);
$parcel$export(module.exports, "mapActionIdFromType", () => $a61f434346a6f772$export$2bf527ee1645dc7d);
const $a61f434346a6f772$export$1979295cc80a7ec1 = 'learn-more';
const $a61f434346a6f772$export$779203acbfa8bf12 = 'workflow-edit-permission-learn-more';
const $a61f434346a6f772$export$fe5b785cab515b6e = 'upgrade';
const $a61f434346a6f772$export$2bf527ee1645dc7d = {
    [$a61f434346a6f772$export$1979295cc80a7ec1]: 'freeLearnMore',
    [$a61f434346a6f772$export$779203acbfa8bf12]: 'workflowEditLearnMore',
    [$a61f434346a6f772$export$fe5b785cab515b6e]: 'freeTryNow'
};

});

parcelRegister("02gpZ", function(module, exports) {

$parcel$export(module.exports, "UpFlowIFrame", () => $6cdd801078d648f3$export$e9eafd8c579e773d);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");


var $4J6oz = parcelRequire("4J6oz");

var $g6ckq = parcelRequire("g6ckq");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $6cdd801078d648f3$var$UpFlowIFrameLazy = (0, $kxZPA.lazy)(()=>(parcelRequire("jFIm4")), {
    moduleId: "./src/packages/growth/up-flow/up-flow-iframe/src/main.tsx"
});
const $6cdd801078d648f3$export$e9eafd8c579e773d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: (0, $abaf639d63a27f10$export$c73007a11ea7e52),
        packageName: (0, $abaf639d63a27f10$export$c73007a11ea7e52),
        teamName: "luna-growth",
        fallback: (0, $g6ckq.ChunkLoadErrorFlag),
        attributes: (0, $4J6oz.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "flow-iframe-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6cdd801078d648f3$var$UpFlowIFrameLazy, props)));

});
const $abaf639d63a27f10$export$c73007a11ea7e52 = 'jiraUpFlowIframe';
const $abaf639d63a27f10$export$cb7e587097a78810 = 'upsell-edition';
const $abaf639d63a27f10$export$fb320338324d1328 = 'upflowIFrame';
const $abaf639d63a27f10$export$782491eab0c2154d = 'INITIATE_SPA_CLOSE';
const $abaf639d63a27f10$export$dc3263ec2276f3f3 = 'START_EDITION_POLLING';
const $abaf639d63a27f10$export$8a7c66f5574473bd = 'FINISH_EDITION_POLLING';
const $abaf639d63a27f10$export$c012ea75b4437aea = 'TRACK_EXPERIENCE_FAIL';
const $abaf639d63a27f10$export$1b2e801262ba754 = 'TRACK_EXPERIENCE_SUCCESS';
const $abaf639d63a27f10$export$b6cceaecfde9dc91 = 'SPA_READY';

parcelRegister("4J6oz", function(module, exports) {

$parcel$export(module.exports, "applicationEditionToUpFlowEdition", () => $7e87fb5ffa0cfceb$export$b48ea9d6b982b3e1);
$parcel$export(module.exports, "jiraUpFlowIframeUpgradePlanInteraction", () => $7e87fb5ffa0cfceb$export$7d4045a899f62dfd);
$parcel$export(module.exports, "addChunkLoadErrorAnalyticsAttribute", () => $7e87fb5ffa0cfceb$export$94ee0b5fca1e74d2);
$parcel$export(module.exports, "handleError", () => $7e87fb5ffa0cfceb$export$d3da1ecaf1206c58);

var $5uXOq = parcelRequire("5uXOq");

var $dGrdR = parcelRequire("dGrdR");

var $jcw0u = parcelRequire("jcw0u");

var $ldyPw = parcelRequire("ldyPw");

var $bCf8q = parcelRequire("bCf8q");



var $ajCo3 = parcelRequire("ajCo3");
const $7e87fb5ffa0cfceb$export$e4e69593f7c9f3b7 = (attributes, error)=>{
    (0, $jcw0u.default)({
        meta: {
            // We use the same ID for all errors in the package for easier
            // management in data portal, and use attributes to identify an error instead.
            id: (0, $abaf639d63a27f10$export$c73007a11ea7e52),
            packageName: (0, $abaf639d63a27f10$export$c73007a11ea7e52),
            teamName: 'luna-growth'
        },
        attributes: {
            ...attributes
        },
        error: error
    });
};
const $7e87fb5ffa0cfceb$export$b48ea9d6b982b3e1 = (applicationEdition)=>{
    if (applicationEdition === (0, $ldyPw.FREE_EDITION)) return 0, $4c0643787f48cf65$export$e69af2c4378638a2;
    if (applicationEdition === (0, $ldyPw.STANDARD_EDITION)) return 0, $4c0643787f48cf65$export$7bc7dd5faba7ad6b;
    return 0, $4c0643787f48cf65$export$3fd0bbb8c68dc4c7;
};
const $7e87fb5ffa0cfceb$export$7d4045a899f62dfd = (0, $dGrdR.metrics).interaction({
    key: `${(0, $abaf639d63a27f10$export$c73007a11ea7e52)}.upgrade.plan`
});
const $7e87fb5ffa0cfceb$export$94ee0b5fca1e74d2 = (error)=>({
        chunkLoadError: (0, $bCf8q.isLoaderError)(error)
    });
const $7e87fb5ffa0cfceb$export$d3da1ecaf1206c58 = (subject, onClose, apiError)=>{
    $7e87fb5ffa0cfceb$export$e4e69593f7c9f3b7({
        subject: subject,
        message: apiError?.message || ''
    }, apiError);
    $7e87fb5ffa0cfceb$export$7d4045a899f62dfd.cancel();
    onClose();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ajCo3.CommerceApiErrorFlag), null);
};

});
const $4c0643787f48cf65$export$e69af2c4378638a2 = 'free';
const $4c0643787f48cf65$export$7bc7dd5faba7ad6b = 'standard';
const $4c0643787f48cf65$export$3fd0bbb8c68dc4c7 = 'premium';

parcelRegister("ajCo3", function(module, exports) {

$parcel$export(module.exports, "CommerceApiErrorFlag", () => $0ee877bbb47ef7cb$export$7ee77c445dd775b4);

var $pa9q9 = parcelRequire("pa9q9");

var $7HGHK = parcelRequire("7HGHK");

var $cPOtr = parcelRequire("cPOtr");
const $0ee877bbb47ef7cb$export$7ee77c445dd775b4 = ()=>{
    const flagKey = (0, $7HGHK.toFlagId)('commerce-api-error');
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    showFlag({
        id: flagKey,
        key: flagKey,
        type: 'error',
        title: (0, $cPOtr.default).title,
        description: (0, $cPOtr.default).description,
        isAutoDismiss: true,
        messageId: 'up-flow-iframe.common.ui.commerce-api-error-flag.show-flag.error',
        messageType: 'transactional'
    });
    return null;
};

});
parcelRegister("cPOtr", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8891414a165fed2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c8891414a165fed2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "up-flow-iframe.common.commerce-api-error-flag.title",
        "defaultMessage": "We can't upgrade your plan right now"
    },
    description: {
        "id": "up-flow-iframe.common.commerce-api-error-flag.description",
        "defaultMessage": "Try again, or if this keeps happening try contacting support"
    }
});

});



parcelRegister("g6ckq", function(module, exports) {

$parcel$export(module.exports, "ChunkLoadErrorFlag", () => $590350b4061b001a$export$7a9d9407b3a5f50e);

var $pa9q9 = parcelRequire("pa9q9");

var $7HGHK = parcelRequire("7HGHK");

var $bCf8q = parcelRequire("bCf8q");

var $kgvbW = parcelRequire("kgvbW");
const $590350b4061b001a$export$7a9d9407b3a5f50e = ({ error: error })=>{
    const flagKey = (0, $7HGHK.toFlagId)('chunk-load-error');
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    if ((0, $bCf8q.isLoaderError)(error)) showFlag({
        id: flagKey,
        key: flagKey,
        type: 'error',
        title: (0, $kgvbW.default).title,
        description: (0, $kgvbW.default).description,
        isAutoDismiss: true,
        messageId: 'up-flow-iframe.ui.chunk-load-error-flag.show-flag.error',
        messageType: 'transactional',
        actions: [
            {
                content: (0, $kgvbW.default).refreshPageButton,
                onClick: ()=>{
                    dismissFlag(flagKey);
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    window.location.reload();
                }
            }
        ]
    });
    return null;
};

});
parcelRegister("kgvbW", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae312d01f0160cd3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ae312d01f0160cd3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "up-flow-iframe.chunk-load-error-flag.title",
        "defaultMessage": "Something went wrong"
    },
    description: {
        "id": "up-flow-iframe.chunk-load-error-flag.description",
        "defaultMessage": "Refresh the page and try again."
    },
    refreshPageButton: {
        "id": "up-flow-iframe.chunk-load-error-flag.refresh-page-button",
        "defaultMessage": "Refresh page"
    }
});

});


parcelRegister("jFIm4", function(module, exports) {

let $e52440a08cd37502$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e52440a08cd37502$var$load("7mIf9"),
    $e52440a08cd37502$var$load("jXweD"),
    $e52440a08cd37502$var$load("76n7a"),
    $e52440a08cd37502$var$load("l253H"),
    $e52440a08cd37502$var$load("kVX56"),
    $e52440a08cd37502$var$load("kH0d9")
]).then(()=>parcelRequire('1W7nw'));

});


const $9996ddd22815931e$export$997e23a0aec74966 = 'https://confluence.atlassian.com/display/AdminJIRACloud/Jira+Cloud+plans';
const $9996ddd22815931e$export$30ce584c3652886c = 'https://support.atlassian.com/jira-cloud-administration/docs/permissions-for-company-managed-projects/#Edit-Workflows';
const $9996ddd22815931e$export$cfca87b5d4683694 = '/admin/billing/applications';

parcelRegister("de8ma", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc942e740b757f44$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fc942e740b757f44$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    upgradeToAddUsersHeader: {
        "id": "up-flow-upgrade-to-add-users-dialog.upgrade-to-add-users-header",
        "defaultMessage": "Upgrade to add users"
    },
    upgradeToAddUsersContent: {
        "id": "up-flow-upgrade-to-add-users-dialog.upgrade-to-add-users-content",
        "defaultMessage": "You've reached the maximum number of users for your plan.\nRemove existing users or upgrade to grow your team."
    },
    upgradeButtonLabel: {
        "id": "up-flow-upgrade-to-add-users-dialog.upgrade-button-label",
        "defaultMessage": "Try it now"
    },
    learnMoreButtonLabel: {
        "id": "up-flow-upgrade-to-add-users-dialog.learn-more-button-label",
        "defaultMessage": "Learn more"
    }
});

});


parcelRegister("j6etC", function(module, exports) {

$parcel$export(module.exports, "getRemainingSeats", () => $1d52ab7e56655772$export$6397e3bbf35b34e3);

var $eusud = parcelRequire("eusud");
const $1d52ab7e56655772$var$toRemainingSeats = (json)=>json.remainingSeat;
const $1d52ab7e56655772$export$6397e3bbf35b34e3 = (baseUrl, applicationKey)=>(0, $eusud.performGetRequest)(`/rest/internal/2/invite-user/application/remaining-seat?key=${applicationKey}`).then((json)=>$1d52ab7e56655772$var$toRemainingSeats(json));

});

parcelRegister("eJpZk", function(module, exports) {

$parcel$export(module.exports, "Analytics", () => $981a920c7dd6e4e8$export$2b3af6baec22bd98);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $1sLR4 = parcelRequire("1sLR4");

var $1zwpK = parcelRequire("1zwpK");

var $iqJSe = parcelRequire("iqJSe");
const $981a920c7dd6e4e8$export$2b3af6baec22bd98 = (props)=>{
    const { projectId: projectId, baseUrl: baseUrl, showAddPeopleButton: showAddPeopleButton, screenName: screenName } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (projectId >= 0 && showAddPeopleButton) Promise.all([
            (0, $1zwpK.getUserProjectRoles)(baseUrl, projectId),
            (0, $1sLR4.getProjectAccessLevel)(baseUrl, projectId)
        ]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .then(([roleData, projectAccessLevel])=>{
            const projectRoleNames = roleData === null || roleData.projectRoleNames === null ? null : (0, $iqJSe.reduceCustomRoles)(roleData.projectRoleNames);
            (0, $iqJSe.fireAddPeopleRenderedEvent)(createAnalyticsEvent, screenName, projectId, projectRoleNames, projectAccessLevel);
        });
    }, [
        baseUrl,
        createAnalyticsEvent,
        projectId,
        screenName,
        showAddPeopleButton
    ]);
    return null;
};

});
parcelRegister("1sLR4", function(module, exports) {

$parcel$export(module.exports, "getProjectAccessLevel", () => $6d37e68816b91c3b$export$f5f97c28ee230e06);

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");
const $6d37e68816b91c3b$export$128fa18b7194ef = (baseUrl, projectId)=>`${baseUrl}/rest/internal/simplified/1.0/accesslevel/project/${projectId}`;
const $6d37e68816b91c3b$var$transform = (data)=>data.value;
const $6d37e68816b91c3b$export$f5f97c28ee230e06 = (baseUrl, projectId)=>{
    const request = ()=>(0, $eusud.performGetRequest)($6d37e68816b91c3b$export$128fa18b7194ef(baseUrl, projectId));
    return request().then((data)=>$6d37e68816b91c3b$var$transform(data)).catch((error)=>{
        const attributes = error instanceof (0, $jJZqs.default) ? {
            statusCode: error.statusCode,
            traceId: error.traceId
        } : {
            errorMessage: error.message
        };
        (0, $jcw0u.default)({
            meta: {
                id: 'fetchProjectAccessLevel',
                packageName: 'jiraFilters',
                teamName: 'a4t-tanuki'
            },
            error: error,
            attributes: attributes,
            sendToPrivacyUnsafeSplunk: true
        });
        return Promise.resolve(null);
    });
};

});

parcelRegister("1zwpK", function(module, exports) {

$parcel$export(module.exports, "getUserProjectRoles", () => $845d77939718574b$export$3b587d1e1fe73b9d);

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");
const $845d77939718574b$var$MEMBER_ROLE_NAME = 'Member';
const $845d77939718574b$var$VIEWER_ROLE_NAME = 'Viewer';
const $845d77939718574b$var$userProjectRoleNames = (data)=>data.map((projectRole)=>projectRole.name);
const $845d77939718574b$export$5a1a2e9d57f47aee = (data)=>data.some((role)=>role.name === $845d77939718574b$var$MEMBER_ROLE_NAME);
const $845d77939718574b$export$10eeb2d34050404e = (data)=>data.some((role)=>role.admin);
const $845d77939718574b$export$a4d7f3415bee4b75 = (data)=>data.some((role)=>role.name !== $845d77939718574b$var$VIEWER_ROLE_NAME && role.name !== $845d77939718574b$var$MEMBER_ROLE_NAME && !role.admin);
const $845d77939718574b$export$128fa18b7194ef = (baseUrl, projectId)=>`${baseUrl}/rest/api/3/project/${projectId}/roledetails?excludeConnectAddons=true&currentMember=true`;
const $845d77939718574b$export$3b587d1e1fe73b9d = (baseUrl, projectId)=>{
    const request = ()=>(0, $eusud.performGetRequest)($845d77939718574b$export$128fa18b7194ef(baseUrl, projectId));
    return request().then((data)=>({
            isMember: $845d77939718574b$export$5a1a2e9d57f47aee(data),
            isJiraAdmin: $845d77939718574b$export$10eeb2d34050404e(data),
            hasCustomRole: $845d77939718574b$export$a4d7f3415bee4b75(data),
            projectRoleNames: $845d77939718574b$var$userProjectRoleNames(data)
        })).catch((error)=>{
        const attributes = error instanceof (0, $jJZqs.default) ? {
            statusCode: error.statusCode,
            traceId: error.traceId
        } : {
            errorMessage: error.message
        };
        (0, $jcw0u.default)({
            meta: {
                id: 'fetchUserProjectRoles',
                packageName: 'jiraFilters',
                teamName: 'a4t-tanuki'
            },
            error: error,
            attributes: attributes,
            sendToPrivacyUnsafeSplunk: true
        });
        return Promise.resolve(null);
    });
};

});

parcelRegister("iqJSe", function(module, exports) {

$parcel$export(module.exports, "fireAddPeopleRenderedEvent", () => $131644081500a421$export$8014b0c4810b7867);
$parcel$export(module.exports, "reduceCustomRoles", () => $131644081500a421$export$7f2d1c0dab5190f9);

var $8zOmE = parcelRequire("8zOmE");
const $131644081500a421$var$defaultProjectRoles = [
    'Administrator',
    'Member',
    'Viewer'
];
const $131644081500a421$export$ecf9824f02c8a125 = 'Custom Role';
const $131644081500a421$export$8014b0c4810b7867 = (createAnalyticsEvent, source, projectId, userProjectRoles, projectAccessLevel)=>{
    const analyticsEvent = createAnalyticsEvent({
        action: 'rendered',
        actionSubject: 'addPeopleButton',
        source: source
    });
    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, {
        projectId: projectId,
        userProjectRoles: userProjectRoles,
        projectAccessLevel: projectAccessLevel
    });
};
const $131644081500a421$export$7f2d1c0dab5190f9 = (userProjectRoles)=>{
    let hasCustomRole = false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const modifiedProjectRoles = userProjectRoles.reduce((acc, role)=>{
        const isDefaultRole = $131644081500a421$var$defaultProjectRoles.includes(role);
        hasCustomRole = hasCustomRole || !isDefaultRole;
        if (isDefaultRole) acc.push(role);
        return acc;
    }, []);
    if (hasCustomRole) modifiedProjectRoles.push($131644081500a421$export$ecf9824f02c8a125);
    return modifiedProjectRoles;
};

});


parcelRegister("lAu6N", function(module, exports) {

$parcel$export(module.exports, "default", () => $020a81e9686d5942$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $k6T4f = parcelRequire("k6T4f");

var $az4zD = parcelRequire("az4zD");

var $dCm1o = parcelRequire("dCm1o");

var $kpzS0 = parcelRequire("kpzS0");

var $4R6GH = parcelRequire("4R6GH");

var $i9wmu = parcelRequire("i9wmu");

var $gQDFP = parcelRequire("gQDFP");

var $kfN7T = parcelRequire("kfN7T");

var $a43Dp = parcelRequire("a43Dp");

var $2eCzd = parcelRequire("2eCzd");

var $mafYu = parcelRequire("mafYu");
const $020a81e9686d5942$var$AssigneeFilter = (props)=>{
    const { users: users, selectedUsers: selectedUsers, maxUsers: maxUsers, onAddPeopleClick: onAddPeopleClick, showAddPeopleButton: showAddPeopleButton, onToggle: onToggle, onAssigneeMenuOpen: onAssigneeMenuOpen, intl: { formatMessage: formatMessage }, peopleRef: peopleRef, shouldShowUnassignedFilterNudge: shouldShowUnassignedFilterNudge, onClickUnassignedFilterNudge: onClickUnassignedFilterNudge } = props;
    const mainList = (0, $5uXOq.useMemo)(()=>users.length > maxUsers ? users.slice(0, maxUsers - 1) : users.slice(0), [
        users,
        maxUsers
    ]);
    const moreList = (0, $5uXOq.useMemo)(()=>users.length > maxUsers ? users.slice(maxUsers - 1) : [], [
        users,
        maxUsers
    ]);
    const { unassignedFilterNudgeRef: unassignedFilterNudgeRef } = (0, $4R6GH.fg)('unassigned_filter_kill_switch') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $kpzS0.useUnassignedFilterNudge)(!!shouldShowUnassignedFilterNudge && selectedUsers.length === 0) : {
        unassignedFilterNudgeRef: undefined
    };
    const [isDropdownOpen, setIsDropdownOpen] = (0, $5uXOq.useState)(false);
    const handleShowMoreButtonClose = ()=>{
        setIsDropdownOpen(false);
    };
    const handleShowMoreButtonOpen = ()=>{
        setIsDropdownOpen(true);
        onAssigneeMenuOpen();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "fieldset",
        xcss: [
            (0, $dCm1o.isVisualRefreshEnabled)() ? $020a81e9686d5942$var$fieldsetStyles : $020a81e9686d5942$var$fieldsetStylesOld,
            isDropdownOpen && (0, $4R6GH.fg)('tanuki_a11y_q4') && $020a81e9686d5942$var$fieldsetStyleWhenDropdownOpen
        ],
        "data-test-id": "filters.ui.filters.assignee.stateless.assignee-filter",
        testId: "filters.ui.filters.assignee.stateless.assignee-filter" // eslint-disable-next-line react/jsx-props-no-spreading
        ,
        ...!(0, $4R6GH.fg)('tanuki_a11y_q4') && {
            style: {
                // Ensure layering of avatars does not conflict with anything else in the DOM tree
                zIndex: 0
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($020a81e9686d5942$var$AvatarFilterLegend, {
        id: (0, $gQDFP.FILTER_PREFIX)
    }, formatMessage((0, $2eCzd.default).label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($020a81e9686d5942$var$AvatarsList, null, mainList.map((user, index)=>unassignedFilterNudgeRef && user.id === (0, $gQDFP.UNASSIGNED_ID) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            key: user.id,
            ref: unassignedFilterNudgeRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k6T4f.Pulse), {
            radius: 24,
            testId: "filters.ui.filters.assignee.stateless.unassigned-filter-nudge"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a43Dp.default), {
            zIndex: maxUsers - index,
            user: user,
            isSelected: selectedUsers.includes(user.id),
            onToggle: onToggle
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a43Dp.default), {
            key: user.id,
            zIndex: maxUsers - index,
            user: user,
            isSelected: selectedUsers.includes(user.id),
            onToggle: onToggle
        })), moreList.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $mafYu.default), {
        users: moreList,
        selectedUsers: selectedUsers,
        onItemActivated: onToggle,
        onOpen: (0, $4R6GH.fg)('tanuki_a11y_q4') ? handleShowMoreButtonOpen : onAssigneeMenuOpen,
        onClose: (0, $4R6GH.fg)('tanuki_a11y_q4') ? handleShowMoreButtonClose : undefined
    }), showAddPeopleButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kfN7T.default), {
        peopleButtonRef: peopleRef,
        onClick: onAddPeopleClick
    }), unassignedFilterNudgeRef && onClickUnassignedFilterNudge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i9wmu.default), {
        onFilterClick: onClickUnassignedFilterNudge
    })));
};
$020a81e9686d5942$var$AssigneeFilter.defaultProps = {
    onAddPeopleClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onAssigneeMenuOpen: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    showAddPeopleButton: false
};
var $020a81e9686d5942$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($020a81e9686d5942$var$AssigneeFilter);
const $020a81e9686d5942$var$fieldsetStyles = (0, $8CUq3.xcss)({
    flexShrink: 0,
    border: 0
});
const $020a81e9686d5942$var$fieldsetStylesOld = (0, $8CUq3.xcss)({
    flexShrink: 0,
    border: 0,
    marginLeft: 'space.150'
});
const $020a81e9686d5942$var$fieldsetStyleWhenDropdownOpen = (0, $8CUq3.xcss)({
    zIndex: 'navigation'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $020a81e9686d5942$var$AvatarsList = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $020a81e9686d5942$var$AvatarFilterLegend = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "legend", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _kqswstnw _4t3it94y _1bsbt94y _ogto7mnp _o5721q9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kpzS0", function(module, exports) {

$parcel$export(module.exports, "useUnassignedFilterNudge", () => $7d0e9863f15e3edb$export$188562ecba3103e0);

var $9dZ1c = parcelRequire("9dZ1c");

var $4R6GH = parcelRequire("4R6GH");

var $6s1PB = parcelRequire("6s1PB");

var $cWw2k = parcelRequire("cWw2k");

var $LLfvm = parcelRequire("LLfvm");
const $7d0e9863f15e3edb$export$188562ecba3103e0 = (shouldShowUnassignedFilterNudge)=>{
    const { ref: unassignedFilterNudgeRef } = (0, $9dZ1c.useRegisterNudgeTarget)((0, $cWw2k.UNASSIGNED_FILTER_NUDGE_ID), shouldShowUnassignedFilterNudge && (0, $4R6GH.fg)('unassigned_filter_kill_switch'));
    const { isDismissed: isDismissed } = (0, $LLfvm.useDismissal)();
    if (!(0, $4R6GH.fg)('unassigned_filter_kill_switch')) return {
        unassignedFilterNudgeRef: undefined
    };
    const showUnassignedFilterNudge = (!isDismissed && shouldShowUnassignedFilterNudge && (0, $6s1PB.expValEquals)('software_business_board_unassigned_filter_ga', 'isEnabled', true)) === true;
    return {
        unassignedFilterNudgeRef: showUnassignedFilterNudge ? unassignedFilterNudgeRef : undefined
    };
};

});
parcelRegister("cWw2k", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "UNASSIGNED_FILTER_NUDGE_ID", () => $324eab48e202eedd$export$1169d60cf6ebc1dd);
$parcel$export(module.exports, "default", () => $324eab48e202eedd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eX4sQ = parcelRequire("eX4sQ");

var $84THj = parcelRequire("84THj");

var $42CjB = parcelRequire("42CjB");

var $5ujeO = parcelRequire("5ujeO");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $cSWNW = parcelRequire("cSWNW");

var $gwIPs = parcelRequire("gwIPs");

var $LLfvm = parcelRequire("LLfvm");

var $hIQwn = parcelRequire("hIQwn");
const $324eab48e202eedd$export$1169d60cf6ebc1dd = 'unassigned-filter-nudge';
const $324eab48e202eedd$var$UNASSIGNED_FILTER_NUDGE_ANALYTICS_ID = 'unassignedFilterNudge';
const $324eab48e202eedd$var$renderSpotlight = ({ onDismiss: onDismiss, onClick: onClick, formatMessage: formatMessage })=>{
    return /*#__PURE__*/ (0, $5uXOq.forwardRef)((_, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            ref: ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ujeO.default), {
            heading: formatMessage((0, $hIQwn.default).header),
            headingAfterElement: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
                icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($84THj))), {
                        ...iconProps,
                        color: "var(--ds-icon-inverse, #FFFFFF)"
                    }),
                onClick: ()=>onDismiss(false),
                label: formatMessage((0, $hIQwn.default).dismissIconLabel),
                appearance: "subtle"
            }),
            actions: [
                {
                    text: formatMessage((0, $hIQwn.default).turnOnUnassignedFilter),
                    onClick: onClick
                }
            ],
            width: 374
        }, formatMessage((0, $hIQwn.default).content))));
};
const $324eab48e202eedd$var$PortalledNudgeWithChoreograph = (0, $cSWNW.withChoreographedRender)((0, $eX4sQ.PortalledNudge));
const $324eab48e202eedd$var$UnassignedFilterNudge = ({ props: { onFilterClick: onFilterClick } })=>{
    const [isHidden, setIsHidden] = (0, $5uXOq.useState)(false);
    const { hide: hide, dismiss: dismiss, hideCount: hideCount } = (0, $LLfvm.useDismissal)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onRender = (0, $5uXOq.useCallback)(()=>{
        const event = createAnalyticsEvent({});
        (0, $8zOmE.fireUIAnalytics)(event, 'nudgeSpotlightCard viewed', $324eab48e202eedd$var$UNASSIGNED_FILTER_NUDGE_ANALYTICS_ID, {
            viewedCount: hideCount + 1
        });
    }, [
        createAnalyticsEvent,
        hideCount
    ]);
    const onHide = (0, $5uXOq.useCallback)(()=>{
        const event = createAnalyticsEvent({});
        (0, $8zOmE.fireUIAnalytics)(event, 'button clicked', $324eab48e202eedd$var$UNASSIGNED_FILTER_NUDGE_ANALYTICS_ID, {
            isClickOutside: true,
            hideCount: hideCount + 1
        });
        setIsHidden(true);
        hide();
    }, [
        createAnalyticsEvent,
        hide,
        hideCount
    ]);
    const onDismiss = (0, $5uXOq.useCallback)((turnOnUnassignedFilter)=>{
        const event = createAnalyticsEvent({});
        (0, $8zOmE.fireUIAnalytics)(event, 'button clicked', $324eab48e202eedd$var$UNASSIGNED_FILTER_NUDGE_ANALYTICS_ID, {
            isClickOutside: false,
            hideCount: hideCount + 1,
            turnOnUnassignedFilter: turnOnUnassignedFilter
        });
        setIsHidden(true);
        dismiss();
    }, [
        createAnalyticsEvent,
        dismiss,
        hideCount
    ]);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        onFilterClick();
        onDismiss(true);
    }, [
        onDismiss,
        onFilterClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($324eab48e202eedd$var$PortalledNudgeWithChoreograph, {
        key: "unassigneeAvatarSpotlight",
        nudgeTargetId: $324eab48e202eedd$export$1169d60cf6ebc1dd,
        hidden: isHidden,
        setHidden: onHide,
        onOutsideClick: onHide,
        spotlightCard: $324eab48e202eedd$var$renderSpotlight({
            onDismiss: onDismiss,
            onClick: onClick,
            formatMessage: formatMessage
        }),
        position: "bottom-start",
        pulseBorderRadius: 24,
        onRender: onRender,
        messageId: $324eab48e202eedd$export$1169d60cf6ebc1dd,
        zIndex: (0, $gwIPs.layers).card
    });
};
var $324eab48e202eedd$export$2e2bcd8739ae039 = $324eab48e202eedd$var$UnassignedFilterNudge;

});
parcelRegister("eX4sQ", function(module, exports) {

$parcel$export(module.exports, "PortalledNudge", () => $b324ff99d51fd3d9$export$74f8d45d75dfda4f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $fqbGj = parcelRequire("fqbGj");

var $9dZ1c = parcelRequire("9dZ1c");
/**
 * Creates a subscription into this component, that will return a boolean stating if
 * the HTML DOM node is associated with a given target ID.
 */ const $b324ff99d51fd3d9$var$useHasNudgeTargetNode = (id)=>{
    const controller = (0, $9dZ1c.useNudgeController)();
    const [hasRefValue, setHasRefValue] = (0, $5uXOq.useState)(!!controller.nudgeTargetsMap.get(id)?.current);
    (0, $5uXOq.useLayoutEffect)(()=>{
        setHasRefValue(!!controller.nudgeTargetsMap.get(id)?.current);
        const unsubscribe = controller.subscribe(id, ()=>{
            setHasRefValue(!!controller.nudgeTargetsMap.get(id)?.current);
        });
        return ()=>{
            unsubscribe();
        };
    }, [
        controller,
        id
    ]);
    return hasRefValue;
};
/**
 * When the nudge is shown, get and track the rectangle of the target element.
 */ const $b324ff99d51fd3d9$var$useNudgeRectangle = (isShown, id, nudgeContainer)=>{
    const [innerRectangle, setInnerRectangle] = (0, $5uXOq.useState)(null);
    const frameId = (0, $5uXOq.useRef)(null);
    const controller = (0, $9dZ1c.useNudgeController)();
    const nudgeTarget = controller.nudgeTargetsMap.get(id)?.current;
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!isShown || !nudgeTarget || !nudgeContainer.current) {
            // Reset rectangle to eliminate risk of Spotlight rendering at
            // old position when nudge is e.g. hidden then shown in a different place.
            if (innerRectangle !== null) setInnerRectangle(null);
            return undefined;
        }
        // This is one approach to tracking the elements moving. See https://hello.atlassian.net/wiki/spaces/JST/pages/1759637849/Rendering+performance+Async+component+wrappers
        // for other options.
        const loop = ()=>{
            const targetRectangle = controller.nudgeTargetsMap.get(id)?.current?.getBoundingClientRect();
            if (!targetRectangle) return undefined;
            const newRectangle = {
                top: targetRectangle.top,
                left: targetRectangle.left,
                width: targetRectangle.width,
                height: targetRectangle.height
            };
            if (innerRectangle == null || innerRectangle.top !== newRectangle.top || innerRectangle.left !== newRectangle.left || innerRectangle.width !== newRectangle.width || innerRectangle.height !== newRectangle.height) setInnerRectangle(newRectangle);
            else frameId.current = requestAnimationFrame(loop);
        };
        frameId.current = requestAnimationFrame(loop);
        return ()=>{
            if (frameId.current != null) cancelAnimationFrame(frameId.current);
        };
    }, [
        isShown,
        nudgeContainer,
        innerRectangle,
        nudgeTarget,
        controller.nudgeTargetsMap,
        id
    ]);
    return innerRectangle;
};
/**
 * Create and append a DOM node to use for the nudge. This is on a separate root to the rest of the app.
 */ const $b324ff99d51fd3d9$var$usePortalContainer = ()=>{
    const nudgeContainer = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!nudgeContainer.current) {
            nudgeContainer.current = document.createElement('div');
            document.body.appendChild(nudgeContainer.current);
        }
        return ()=>{
            if (nudgeContainer.current) document.body.removeChild(nudgeContainer.current);
        };
    }, []);
    return nudgeContainer;
};
const $b324ff99d51fd3d9$export$74f8d45d75dfda4f = (props)=>{
    const nudgeContainer = $b324ff99d51fd3d9$var$usePortalContainer();
    const hasRefValue = $b324ff99d51fd3d9$var$useHasNudgeTargetNode(props.nudgeTargetId);
    const innerRectangle = $b324ff99d51fd3d9$var$useNudgeRectangle(!props.hidden, props.nudgeTargetId, nudgeContainer);
    const innerRectanglePrevious = (0, $5uXOq.useRef)(innerRectangle);
    const spotlightRef = (0, $5uXOq.useRef)(null);
    // Force update the Popper spotlight when the innerRectangle (nudge position) changes
    (0, $5uXOq.useEffect)(()=>{
        if (innerRectangle !== null && innerRectanglePrevious.current !== innerRectangle && spotlightRef.current !== null) {
            innerRectanglePrevious.current = innerRectangle;
            if (spotlightRef.current.forceUpdateCardPosition) spotlightRef.current.forceUpdateCardPosition();
        }
    }, [
        innerRectangle
    ]);
    const hasNudgeTarget = hasRefValue;
    if (!nudgeContainer.current || !hasNudgeTarget || !innerRectangle) return null;
    return /*#__PURE__*/ (0, $7nsd3.createPortal)(/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'fixed',
            top: innerRectangle.top,
            left: innerRectangle.left,
            height: innerRectangle.height,
            width: innerRectangle.width,
            zIndex: props.zIndex
        },
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fqbGj.NudgeSpotlight), {
            ...props,
            ref: spotlightRef,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                style: {
                    height: innerRectangle.height,
                    width: innerRectangle.width
                }
            })
        })
    }), nudgeContainer.current);
};

});
parcelRegister("fqbGj", function(module, exports) {

$parcel$export(module.exports, "NudgeSpotlight", () => $8ea39cee960047f1$export$eebbda33f5d4d735);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jC4R5 = parcelRequire("jC4R5");

var $k8nZq = parcelRequire("k8nZq");

var $4oNEb = parcelRequire("4oNEb");

var $cBeZP = parcelRequire("cBeZP");

var $4AhK0 = parcelRequire("4AhK0");

var $4aeUu = parcelRequire("4aeUu");

var $ao4Ml = parcelRequire("ao4Ml");
const $8ea39cee960047f1$var$blinkNudge = (nudgeBlinkId, eventTarget, setAnimateIn)=>{
    const nudgeBlinkTriggers = Array.from(document.querySelectorAll(`[data-nudge-blink='${nudgeBlinkId}']`));
    const clickIsInsideTrigger = nudgeBlinkTriggers?.some((triggerElement)=>{
        return triggerElement && triggerElement.contains(eventTarget);
    });
    if (clickIsInsideTrigger) {
        // Blink the nudge
        setAnimateIn(true);
        return true;
    }
    return false;
};
const $8ea39cee960047f1$export$eebbda33f5d4d735 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ hidden: externalHidden, setHidden: setHidden, hideNudgeOnClick: hideNudgeOnClick = true, hideSpotlightCardOnOutsideClick: hideSpotlightCardOnOutsideClick = true, concealSpotlightOnReferenceHidden: concealSpotlightOnReferenceHidden = false, showSpotlightCardOnFirstRender: showSpotlightCardOnFirstRender = true, children: children, spotlightCard: Spotlight = (0, $4AhK0.default), nudge: Nudge = (0, $jC4R5.DefaultNudge), position: position = 'bottom', offset: offset, zIndex: zIndex = 800, onRender: onRender, onShow: onShow, onHide: onHide, onClick: onClick, onOutsideClick: onOutsideClick, pulseColor: pulseColor, pulseShadowColor: pulseShadowColor, pulseBorderRadius: pulseBorderRadius, nudgeBlinkId: nudgeBlinkId, nudgeTestId: nudgeTestId, nudgeTag: nudgeTag, headingId: headingId, ...spotlightCardProps }, nudgeSpotlightRef)=>{
    // Put all listeners inside a ref to avoid misfiring events
    // When the listener functions themselves change.
    const handlers = (0, $5uXOq.useRef)();
    handlers.current = {
        onRender: onRender,
        onHide: onHide,
        onShow: onShow,
        onClick: onClick,
        onOutsideClick: onOutsideClick
    };
    const nudgeRef = (0, $5uXOq.useRef)(null);
    const spotlightCardRef = (0, $5uXOq.useRef)(null);
    const showNudge = !externalHidden;
    const [canShowSpotlight, setCanShowSpotlight] = (0, $5uXOq.useState)(showSpotlightCardOnFirstRender);
    const [showSpotlight, setShowSpotlight] = (0, $5uXOq.useState)(false);
    const [shouldBlink, setShouldBlink] = (0, $5uXOq.useState)(false);
    const stopBlink = (0, $5uXOq.useCallback)(()=>setShouldBlink(false), []);
    const forceUpdateFnRef = (0, $5uXOq.useRef)({
        fn: ()=>{}
    });
    (0, $5uXOq.useImperativeHandle)(nudgeSpotlightRef, ()=>({
            toggleCardVisibility: setCanShowSpotlight,
            forceUpdateCardPosition: ()=>forceUpdateFnRef.current.fn()
        }), [
        setCanShowSpotlight
    ]);
    const markReadyToShow = (0, $5uXOq.useCallback)(()=>showNudge && setCanShowSpotlight(true), [
        showNudge
    ]);
    const onTargetClick = (0, $5uXOq.useCallback)((event)=>{
        if (!externalHidden) {
            if (hideNudgeOnClick) setHidden(event);
            handlers.current?.onClick?.();
        }
    }, [
        externalHidden,
        hideNudgeOnClick,
        setHidden,
        handlers
    ]);
    // Effect for show/hide the spotlight
    (0, $5uXOq.useEffect)(()=>{
        setShowSpotlight(showNudge && canShowSpotlight);
    }, [
        showNudge,
        canShowSpotlight
    ]);
    // Effect for onRender and onHide
    (0, $5uXOq.useEffect)(()=>{
        if (!externalHidden) {
            handlers.current?.onRender?.();
            return ()=>handlers.current?.onHide?.();
        }
    }, [
        externalHidden,
        handlers
    ]);
    // Effect for onShow
    (0, $5uXOq.useEffect)(()=>{
        if (showSpotlight) handlers.current?.onShow?.();
    }, [
        showSpotlight,
        handlers
    ]);
    // Effect to reset showSpotlightCardOnFirstRender when hidden
    (0, $5uXOq.useEffect)(()=>{
        if (externalHidden) setCanShowSpotlight(showSpotlightCardOnFirstRender);
    }, [
        externalHidden,
        showSpotlightCardOnFirstRender
    ]);
    // Effect to hide spotlight on outside click
    (0, $5uXOq.useEffect)(()=>{
        let unbind;
        let timeout;
        if (showSpotlight && hideSpotlightCardOnOutsideClick) timeout = window.setTimeout(()=>{
            unbind = (0, $cBeZP.bind)(window, {
                type: 'click',
                listener: (event)=>{
                    const eventTarget = event.target;
                    if (nudgeRef.current && spotlightCardRef.current && eventTarget instanceof Node && !nudgeRef.current.contains(eventTarget) && !spotlightCardRef.current.contains(eventTarget)) {
                        if (nudgeBlinkId) {
                            const didBlink = $8ea39cee960047f1$var$blinkNudge(nudgeBlinkId, eventTarget, setShouldBlink);
                            if (didBlink) return;
                        }
                        setCanShowSpotlight(false);
                        handlers.current?.onOutsideClick?.();
                        unbind?.();
                    }
                },
                options: {
                    capture: true,
                    passive: true
                }
            });
        });
        return ()=>{
            unbind?.();
            window.clearTimeout(timeout);
        };
    }, [
        showSpotlight,
        hideSpotlightCardOnOutsideClick,
        setHidden,
        handlers,
        nudgeBlinkId
    ]);
    const concealSpotlightOnScrollStyles = (isReferenceHidden)=>concealSpotlightOnReferenceHidden && isReferenceHidden ? {
            display: 'none'
        } : {};
    const cardConfig = (0, $5uXOq.useMemo)(()=>Spotlight === (0, $4AhK0.default) ? {
            ...spotlightCardProps,
            id: nudgeBlinkId
        } : {
            cardTestId: spotlightCardProps.cardTestId
        }, [
        Spotlight,
        spotlightCardProps,
        nudgeBlinkId
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)(Nudge, {
                ref: nudgeRef,
                hasPulse: showNudge,
                onClickCapture: onTargetClick,
                onMouseEnter: markReadyToShow,
                pulseColor: pulseColor,
                pulseShadowColor: pulseShadowColor,
                pulseBorderRadius: pulseBorderRadius,
                nudgeTestId: nudgeTestId,
                tag: nudgeTag,
                children: children
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k8nZq.default), {
                zIndex: zIndex,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4oNEb.Popper), {
                    placement: position,
                    referenceElement: nudgeRef.current || undefined,
                    offset: offset,
                    children: ({ ref: ref, style: popperStyles, forceUpdate: forceUpdate, isReferenceHidden: isReferenceHidden })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $4aeUu.SpotlightContainer), {
                            showSpotlight: showSpotlight,
                            shouldBlink: shouldBlink,
                            stopBlink: stopBlink,
                            zIndex: zIndex,
                            ref: ref,
                            containerStyles: {
                                ...popperStyles,
                                ...concealSpotlightOnScrollStyles(isReferenceHidden)
                            },
                            role: "dialog",
                            ariaLabelledBy: headingId || 'nudge-spot-light-card-heading',
                            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $ao4Ml.default), {
                                children: [
                                    (forceUpdateFnRef.current.fn = forceUpdate) && null,
                                    /*#__PURE__*/ (0, $2OMIu.jsx)(Spotlight, {
                                        ...cardConfig,
                                        ref: spotlightCardRef
                                    })
                                ]
                            })
                        })
                })
            })
        ]
    });
});
var $8ea39cee960047f1$export$2e2bcd8739ae039 = $8ea39cee960047f1$export$eebbda33f5d4d735;

});
parcelRegister("jC4R5", function(module, exports) {

$parcel$export(module.exports, "DefaultNudge", () => $d88355bc6c5eb74c$export$b7d614104f4a4a7c);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5XLZB = parcelRequire("5XLZB");
const $d88355bc6c5eb74c$export$b7d614104f4a4a7c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, nudgeTestId: nudgeTestId, ...rest }, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5XLZB.NudgeTooltipPulse), {
        ...rest,
        ref: ref,
        "data-testid": nudgeTestId,
        children: children
    }));

});
parcelRegister("5XLZB", function(module, exports) {

$parcel$export(module.exports, "NudgeTooltipPulse", () => $589071e97cffed79$export$2d11151259bb3b10);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $k5uoT = parcelRequire("k5uoT");

var $VSDnB = parcelRequire("VSDnB");
function $589071e97cffed79$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $589071e97cffed79$var$baseShadow = '0 0 0 3px';
const $589071e97cffed79$var$basePulseColor = `var(--ds-border-accent-purple, ${(0, $829f609a65d26a98$exports).P75})`;
const $589071e97cffed79$var$basePulseShadowColor = "var(--ds-border-accent-purple, rgba(101, 84, 192, 1))";
const $589071e97cffed79$var$easing = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
const $589071e97cffed79$var$pulseAnimation = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '@keyframes pulseKeyframes': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '0%': {
            opacity: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '50%': {
            opacity: 1
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '100%': {
            opacity: 0
        }
    },
    animationName: 'pulseKeyframes',
    animationDuration: '3000ms',
    animationTimingFunction: $589071e97cffed79$var$easing,
    animationIterationCount: 'infinite'
});
const $589071e97cffed79$var$pseudoStyle = {
    name: "24nntw",
    styles: "content:'';position:absolute;top:0;left:0;width:100%;height:100%"
};
const $589071e97cffed79$export$814d9bf8c56ac913 = ({ hasPulse: hasPulse, pulseBorderRadius: pulseBorderRadius, pulseColor: pulseColor, pulseShadowColor: pulseShadowColor })=>/*#__PURE__*/ (0, $f8Sb3.css)({
        display: 'block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> *': {
            position: 'relative',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            '&::before': [
                $589071e97cffed79$var$pseudoStyle,
                {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    borderRadius: `${pulseBorderRadius}px`,
                    boxShadow: `${$589071e97cffed79$var$baseShadow} ${pulseColor}`,
                    opacity: hasPulse ? 1 : 0,
                    transition: 'opacity 0.1s ease-in-out',
                    pointerEvents: 'none'
                }
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            '&::after': [
                $589071e97cffed79$var$pseudoStyle,
                {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    borderRadius: `${pulseBorderRadius}px`,
                    boxShadow: `${$589071e97cffed79$var$baseShadow} ${pulseColor}, 0 0 11px ${pulseShadowColor}`,
                    opacity: 0,
                    pointerEvents: 'none'
                },
                hasPulse && $589071e97cffed79$var$pulseAnimation
            ]
        }
    });
const $589071e97cffed79$export$2d11151259bb3b10 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ hasPulse: hasPulse, pulseBorderRadius: pulseBorderRadius = (0, $k5uoT.borderRadius)(), pulseColor: pulseColor = $589071e97cffed79$var$basePulseColor, pulseShadowColor: pulseShadowColor = $589071e97cffed79$var$basePulseShadowColor, tag: TargetContainer = 'span', ...rest }, ref)=>{
    // Doing a cast because typescript is struggling to narrow the type
    const CastTargetContainer = TargetContainer;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(CastTargetContainer, {
        css: [
            $589071e97cffed79$export$814d9bf8c56ac913({
                hasPulse: hasPulse,
                pulseBorderRadius: pulseBorderRadius,
                pulseColor: pulseColor,
                pulseShadowColor: pulseShadowColor
            }),
            (0, $VSDnB.fg)('jira_onboarding_experiences_a11y_fixes') && $589071e97cffed79$var$inHeritWidthStyles
        ],
        ref: ref,
        ...rest
    });
});
const $589071e97cffed79$var$inHeritWidthStyles = {
    name: "6n1ert",
    styles: "width:inherit"
};

});


parcelRegister("4AhK0", function(module, exports) {

$parcel$export(module.exports, "default", () => $b690ab706aa80c88$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");


var $f8Sb3 = parcelRequire("f8Sb3");
function $b690ab706aa80c88$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b690ab706aa80c88$var$borderRadius = 3;
const $b690ab706aa80c88$var$containerStyles = {
    color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
    boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`,
    backgroundColor: `var(--ds-background-discovery-bold, ${(0, $829f609a65d26a98$export$b48405b95304b5a1)})`,
    borderRadius: `${$b690ab706aa80c88$var$borderRadius}px`,
    overflow: 'auto'
};
const $b690ab706aa80c88$var$bodyStyles = {
    display: 'flex',
    flexDirection: 'column',
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-250, 20px)"}`
};
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
const $b690ab706aa80c88$var$headingStyles = {
    name: "1m05p0r",
    styles: "font-size:1.42857em;font-style:inherit;line-height:1.2;font-weight:var(--ds-font-weight-medium, 500);margin-top:28px;color:inherit;&:first-child{margin-top:0;}"
};
const $b690ab706aa80c88$var$headerStyles = {
    display: 'flex',
    paddingBottom: "var(--ds-space-100, 8px)",
    alignItems: `baseline`,
    justifyContent: `space-between`
};
const $b690ab706aa80c88$var$footerStyles = {
    display: 'flex',
    paddingTop: "var(--ds-space-100, 8px)",
    alignItems: 'center',
    justifyContent: 'space-between'
};
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
const $b690ab706aa80c88$var$actionItemStyles = (index)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        margin: `0 ${"var(--ds-space-050, 4px)"}`,
        cursor: 'pointer',
        alignItems: 'baseline',
        borderWidth: '0px',
        borderRadius: '3px',
        boxSizing: 'border-box',
        display: 'inline-flex',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography -- TODO: https://product-fabric.atlassian.net/browse/PYX-881
        fontSize: 'inherit',
        fontStyle: 'normal',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        maxWidth: '100%',
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out 0s, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) 0s',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        background: index ? `var(--ds-background-discovery-bold, ${0, $829f609a65d26a98$export$b48405b95304b5a1})` : `var(--ds-background-inverse-subtle, ${0, $829f609a65d26a98$export$c71e4279dd54a18d})`,
        height: '2.28571em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '2.28571em',
        padding: '0px 10px',
        verticalAlign: 'middle',
        width: 'auto',
        justifyContent: 'center',
        color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        '&:hover': {
            backgroundColor: `var(--ds-interaction-hovered, ${(0, $829f609a65d26a98$export$a7175d4e9206bc80)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-interaction-pressed, ${(0, $829f609a65d26a98$export$a7175d4e9206bc80)})`
        }
    });
const $b690ab706aa80c88$var$ActionItem = ({ index: index, ...rest })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        css: $b690ab706aa80c88$var$actionItemStyles(index),
        ...rest
    });
const $b690ab706aa80c88$var$actionItemContainerStyles = {
    display: 'flex',
    margin: `${"var(--ds-space-negative-050, -4px)"}`,
    flexDirection: 'row-reverse'
};
const $b690ab706aa80c88$export$b3ae98194e057550 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ image: image, heading: heading, actions: actions, actionsBeforeElement: actionsBeforeElement, width: width = 300, cardTestId: cardTestId, content: content, id: id }, ref)=>{
    const renderedActions = (0, $5uXOq.useMemo)(()=>actions?.map(({ text: text, onClick: onClick }, index)=>/*#__PURE__*/ (0, $f8Sb3.jsx)($b690ab706aa80c88$var$ActionItem, {
                index: index,
                onClick: onClick,
                key: `${text}-${index}`
            }, text)), [
        actions
    ]);
    const renderHeader = !!heading;
    const renderFooter = !!actionsBeforeElement || !!actions;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            ...$b690ab706aa80c88$var$containerStyles,
            width: `${width}px`
        },
        "data-testid": cardTestId
    }, typeof image === 'string' ? /*#__PURE__*/ (0, $f8Sb3.jsx)("img", {
        src: image,
        alt: ""
    }) : image, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        style: $b690ab706aa80c88$var$bodyStyles,
        id: id
    }, renderHeader && // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        style: $b690ab706aa80c88$var$headerStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        id: "nudge-spot-light-card-heading",
        css: $b690ab706aa80c88$var$headingStyles
    }, heading)), content, renderFooter && // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        style: $b690ab706aa80c88$var$footerStyles
    }, actionsBeforeElement || /*#__PURE__*/ (0, $f8Sb3.jsx)("span", null), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        style: $b690ab706aa80c88$var$actionItemContainerStyles
    }, renderedActions))));
});
var $b690ab706aa80c88$export$2e2bcd8739ae039 = $b690ab706aa80c88$export$b3ae98194e057550;

});

parcelRegister("4aeUu", function(module, exports) {

$parcel$export(module.exports, "SpotlightContainer", () => $99a240fc01f7ca0b$export$d0f55839b708c0a0);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ahdj0 = parcelRequire("ahdj0");

var $k8nZq = parcelRequire("k8nZq");
const $99a240fc01f7ca0b$export$474e8ee88cc7cd8f = 200;
const $99a240fc01f7ca0b$export$3d6f334bf7dc4597 = 120;
const $99a240fc01f7ca0b$var$defaultTransitionStyles = {
    opacity: 0,
    transitionProperty: 'opacity',
    transitionTimingFunction: 'ease-in-out',
    transitionDuration: `${$99a240fc01f7ca0b$export$474e8ee88cc7cd8f}ms`
};
const $99a240fc01f7ca0b$var$statefulTransitionStyles = {
    entering: {},
    entered: {
        opacity: 1
    },
    exiting: {
        transitionDuration: `${$99a240fc01f7ca0b$export$3d6f334bf7dc4597}ms`,
        opacity: 0
    },
    exited: {},
    unmounted: {}
};
const $99a240fc01f7ca0b$var$timeoutDurations = {
    enter: 0,
    exit: $99a240fc01f7ca0b$export$3d6f334bf7dc4597
};
const $99a240fc01f7ca0b$export$d0f55839b708c0a0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ containerStyles: containerStyles, showSpotlight: showSpotlight, shouldBlink: shouldBlink, zIndex: zIndex, stopBlink: stopBlink, ariaLabelledBy: ariaLabelledBy, ...rest }, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ahdj0.default), {
        appear: true,
        in: showSpotlight && !shouldBlink,
        timeout: $99a240fc01f7ca0b$var$timeoutDurations,
        onExited: stopBlink,
        unmountOnExit: !shouldBlink,
        children: (state)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $k8nZq.default), {
                zIndex: zIndex,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        ...containerStyles,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        ...$99a240fc01f7ca0b$var$defaultTransitionStyles,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        ...$99a240fc01f7ca0b$var$statefulTransitionStyles[state]
                    },
                    ref: ref,
                    "aria-labelledby": ariaLabelledBy,
                    ...rest
                })
            })
    }));

});



parcelRegister("LLfvm", function(module, exports) {

$parcel$export(module.exports, "useDismissal", () => $97b8aa505af0168a$export$b3877935e036662a);

var $5uXOq = parcelRequire("5uXOq");

var $1Wlq3 = parcelRequire("1Wlq3");

var $bXemr = parcelRequire("bXemr");

const $97b8aa505af0168a$export$b3877935e036662a = ()=>{
    const [hasSeenItKey, { setHasSeen: setHasSeen }] = (0, $1Wlq3.useHasSeenIt)({
        hasSeenItKey: (0, $f78b94b69e842dbc$export$f8315ba7d2f36d9d),
        skipFetch: false
    });
    const dismissalState = (0, $bXemr.getDismissalLocalStorageState)();
    const hide = (0, $5uXOq.useCallback)(()=>{
        const currentCount = (dismissalState.count ?? 0) + 1;
        // if the user dismisses the nudge 3 times, don't show it again
        if (currentCount > 2) {
            setHasSeen((0, $f78b94b69e842dbc$export$f8315ba7d2f36d9d));
            (0, $bXemr.clearDismissalLocalStorageState)();
            return;
        }
        (0, $bXemr.setDismissalLocalStorageState)({
            count: currentCount,
            dismissUntil: new Date().setHours(23, 59, 59, 999)
        });
    }, [
        dismissalState?.count,
        setHasSeen
    ]);
    const dismiss = (0, $5uXOq.useCallback)(()=>{
        setHasSeen((0, $f78b94b69e842dbc$export$f8315ba7d2f36d9d));
    }, [
        setHasSeen
    ]);
    return {
        isDismissed: !hasSeenItKey || hasSeenItKey.fetchStatus !== 'fetched' ? true : hasSeenItKey.value === true || dismissalState.count > 2 || dismissalState.dismissUntil >= Date.now(),
        hide: hide,
        dismiss: dismiss,
        hideCount: dismissalState?.count ?? 0
    };
};

});
parcelRegister("1Wlq3", function(module, exports) {

$parcel$export(module.exports, "useHasSeenIt", () => $5ab7c0bc4c83a238$export$e45ad3bcdc52605d);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $a6dLQ = parcelRequire("a6dLQ");
// Store inits empty - small optimization in case consumers aren't fetching/needing any keys due to
// what's rendered on the page or code FF'd off etc., keys will be added after first get / set
const $5ab7c0bc4c83a238$var$initialState = {};
// Temporary store we can use for onboarding experiments since have-i-seen-it services is recommended NOT to be used
// Later hopefully we can use Post office/the choreographer/choreographed components instead which should add "seen-it"
// functionality (will be later down the track - they are focusing on solving message collisions first)
const $5ab7c0bc4c83a238$var$store = (0, $iXqE5.createStore)({
    name: 'jira-onboarding-has-seen-it',
    initialState: $5ab7c0bc4c83a238$var$initialState,
    actions: $a6dLQ.actions
});
const $5ab7c0bc4c83a238$export$ef53ed8cd1582794 = (0, $3sQ5x.createHook)($5ab7c0bc4c83a238$var$store, {
    selector: (state, hasSeenItKey)=>{
        return state[hasSeenItKey];
    }
});
const $5ab7c0bc4c83a238$export$e45ad3bcdc52605d = ({ hasSeenItKey: hasSeenItKey, skipFetch: skipFetch = false })=>{
    const useLastFetchedHasSeenItResult = $5ab7c0bc4c83a238$export$ef53ed8cd1582794(hasSeenItKey);
    const [, { fetchHasSeen: fetchHasSeen }] = useLastFetchedHasSeenItResult;
    (0, $5uXOq.useEffect)(()=>{
        if (skipFetch) return;
        fetchHasSeen(hasSeenItKey);
    }, [
        fetchHasSeen,
        hasSeenItKey,
        skipFetch
    ]);
    return useLastFetchedHasSeenItResult;
};

});
parcelRegister("a6dLQ", function(module, exports) {

$parcel$export(module.exports, "actions", () => $617ab3ab1d9db18e$export$e324594224ef24da);

var $4IhVM = parcelRequire("4IhVM");

var $jC5HS = parcelRequire("jC5HS");
const $617ab3ab1d9db18e$export$e324594224ef24da = {
    fetchHasSeen: $4IhVM.fetchHasSeen,
    setHasSeen: $jC5HS.setHasSeen
};

});
parcelRegister("4IhVM", function(module, exports) {

$parcel$export(module.exports, "fetchHasSeen", () => $f019b2d8921642bd$export$e26ab58aa13c0861);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $b8sW5 = parcelRequire("b8sW5");
const $f019b2d8921642bd$export$e26ab58aa13c0861 = (hasSeenKey)=>async ({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const currentStateForHasSeenKey = currentState[hasSeenKey];
        if (currentStateForHasSeenKey?.fetchStatus === 'fetched' || currentStateForHasSeenKey?.fetchStatus === 'fetching' || // currently no retry on error
        currentStateForHasSeenKey?.fetchStatus === 'errored') return;
        setState({
            [hasSeenKey]: {
                fetchStatus: 'fetching'
            }
        });
        const response = await (0, $b8sW5.performFetchHasSeenRequest)(hasSeenKey);
        if (response === 'errored') setState({
            [hasSeenKey]: {
                fetchStatus: 'errored'
            }
        });
        else setState({
            [hasSeenKey]: {
                fetchStatus: 'fetched',
                value: response
            }
        });
    };

});
parcelRegister("b8sW5", function(module, exports) {

$parcel$export(module.exports, "performFetchHasSeenRequest", () => $8438e8b78f570762$export$a32677d9d29a038c);

var $jcw0u = parcelRequire("jcw0u");

var $aHuqL = parcelRequire("aHuqL");

var $gfZHU = parcelRequire("gfZHU");
const $8438e8b78f570762$export$a32677d9d29a038c = async (hasSeenKey)=>{
    try {
        const response = await (0, $aHuqL.userPreferenceAPI).get((0, $gfZHU.createHasSeenPrefixedKey)(hasSeenKey));
        // if response is null, it means the user has not interacted with the feature yet
        if (response === null) return false;
        return response;
    } catch (error) {
        if (error instanceof Error) (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'performFetchHasSeenRequest',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            },
            sendToPrivacyUnsafeSplunk: true,
            skipSentry: true,
            attributes: {
                hasSeenKey: hasSeenKey
            }
        });
        return 'errored';
    }
};

});
parcelRegister("gfZHU", function(module, exports) {

$parcel$export(module.exports, "createHasSeenPrefixedKey", () => $b2f6ddeacfc2ba3f$export$9d92579e0f0fa92e);
const $b2f6ddeacfc2ba3f$export$9d92579e0f0fa92e = (key)=>{
    return `hasSeen-${key}`;
};

});



parcelRegister("jC5HS", function(module, exports) {

$parcel$export(module.exports, "setHasSeen", () => $ced548b195db50e5$export$17c72042607ae07a);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $ayei7 = parcelRequire("ayei7");
const $ced548b195db50e5$export$17c72042607ae07a = (hasSeenKey)=>async ({ setState: setState })=>{
        setState({
            [hasSeenKey]: {
                fetchStatus: 'fetched',
                value: true
            }
        });
        await (0, $ayei7.performSetHasSeenRequest)(hasSeenKey);
    };

});
parcelRegister("ayei7", function(module, exports) {

$parcel$export(module.exports, "performSetHasSeenRequest", () => $ae7ced80c3bbdf32$export$47d7ab51cd61b6bf);

var $jcw0u = parcelRequire("jcw0u");

var $aHuqL = parcelRequire("aHuqL");

var $gfZHU = parcelRequire("gfZHU");
const $ae7ced80c3bbdf32$export$47d7ab51cd61b6bf = async (hasSeenKey)=>{
    try {
        await (0, $aHuqL.userPreferenceAPI).set((0, $gfZHU.createHasSeenPrefixedKey)(hasSeenKey), true);
    } catch (error) {
        if (error instanceof Error) (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'performSetHasSeenRequest',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            },
            sendToPrivacyUnsafeSplunk: true,
            skipSentry: true,
            attributes: {
                hasSeenKey: hasSeenKey
            }
        });
    }
};

});




parcelRegister("bXemr", function(module, exports) {

$parcel$export(module.exports, "getDismissalLocalStorageState", () => $f13d7837aebc3820$export$618769f4481a782d);
$parcel$export(module.exports, "setDismissalLocalStorageState", () => $f13d7837aebc3820$export$43925291024c3f94);
$parcel$export(module.exports, "clearDismissalLocalStorageState", () => $f13d7837aebc3820$export$72901a35bb8540a8);

var $bSSG7 = parcelRequire("bSSG7");

const $f13d7837aebc3820$export$1621c8e1c66f77cd = (0, $bSSG7.createLocalStorageProvider)((0, $f78b94b69e842dbc$export$f610b3e19aab9ad3));
const $f13d7837aebc3820$export$618769f4481a782d = ()=>({
        count: $f13d7837aebc3820$export$1621c8e1c66f77cd.get((0, $f78b94b69e842dbc$export$1c5aea45d8141b3a)) ?? 0,
        dismissUntil: $f13d7837aebc3820$export$1621c8e1c66f77cd.get((0, $f78b94b69e842dbc$export$ef05e80525b51370)) ?? 0
    });
const $f13d7837aebc3820$export$43925291024c3f94 = (dismissalState)=>{
    $f13d7837aebc3820$export$1621c8e1c66f77cd.set((0, $f78b94b69e842dbc$export$1c5aea45d8141b3a), dismissalState.count);
    $f13d7837aebc3820$export$1621c8e1c66f77cd.set((0, $f78b94b69e842dbc$export$ef05e80525b51370), dismissalState.dismissUntil);
};
const $f13d7837aebc3820$export$72901a35bb8540a8 = ()=>{
    $f13d7837aebc3820$export$1621c8e1c66f77cd.remove((0, $f78b94b69e842dbc$export$1c5aea45d8141b3a));
    $f13d7837aebc3820$export$1621c8e1c66f77cd.remove((0, $f78b94b69e842dbc$export$ef05e80525b51370));
};

});
const $f78b94b69e842dbc$export$1c5aea45d8141b3a = 'dismissed-count';
const $f78b94b69e842dbc$export$ef05e80525b51370 = 'dismiss-until';
const $f78b94b69e842dbc$export$f610b3e19aab9ad3 = 'unassigned-filter-spotlight';
const $f78b94b69e842dbc$export$f8315ba7d2f36d9d = 'unassignedFilterNudgeSeenItFlag';



parcelRegister("hIQwn", function(module, exports) {

$parcel$export(module.exports, "default", () => $b96055235773b526$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b96055235773b526$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    header: {
        "id": "software-filters.filters.assignee.stateless.unassigned-filter-nudge.header",
        "defaultMessage": "Find available work faster"
    },
    dismissIconLabel: {
        "id": "software-filters.filters.assignee.stateless.unassigned-filter-nudge.dismiss-icon-label",
        "defaultMessage": "Dismiss"
    },
    turnOnUnassignedFilter: {
        "id": "software-filters.filters.assignee.stateless.unassigned-filter-nudge.turn-on-unassigned-filter",
        "defaultMessage": "Turn on unassigned filter"
    },
    content: {
        "id": "software-filters.filters.assignee.stateless.unassigned-filter-nudge.content",
        "defaultMessage": "See everything unassigned and choose your next work item."
    }
});

});



parcelRegister("i9wmu", function(module, exports) {

$parcel$export(module.exports, "default", () => $7da3753592df93f0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4mO32 = parcelRequire("4mO32");

var $7XluA = parcelRequire("7XluA");

var $bn5li = parcelRequire("bn5li");
const $7da3753592df93f0$var$entryPointParams = {};
const $7da3753592df93f0$var$AsyncUnassignedFilterNudge = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $bn5li.asyncUnassignedFilterNudge), $7da3753592df93f0$var$entryPointParams);
    const hasLoadedEntrypoint = (0, $5uXOq.useRef)(false);
    if (!hasLoadedEntrypoint.current) {
        entryPointActions.load();
        hasLoadedEntrypoint.current = true;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        packageName: "UnassignedFilterNudge",
        id: "UnassignedFilterNudge",
        teamName: "jira-warepil",
        fallback: "unmount",
        runtimeProps: props
    });
};
var $7da3753592df93f0$export$2e2bcd8739ae039 = $7da3753592df93f0$var$AsyncUnassignedFilterNudge;

});
parcelRegister("bn5li", function(module, exports) {

$parcel$export(module.exports, "asyncUnassignedFilterNudge", () => $010fd537150770fe$export$e18caff2cfd81210);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $010fd537150770fe$export$e18caff2cfd81210 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("cWw2k"))), {
        moduleId: "750523bb"
    }),
    getPreloadProps: ()=>({})
});

});


parcelRegister("gQDFP", function(module, exports) {

$parcel$export(module.exports, "FILTER_PREFIX", () => $4ab71e27db0ec1f1$export$d6acfe0d617669c3);
$parcel$export(module.exports, "Z_INDEX", () => $4ab71e27db0ec1f1$export$42310dd57a41067);
$parcel$export(module.exports, "UNASSIGNED_ID", () => $4ab71e27db0ec1f1$export$bdab9bfb39981463);
const $4ab71e27db0ec1f1$export$d6acfe0d617669c3 = 'assignee';
const $4ab71e27db0ec1f1$export$42310dd57a41067 = {
    SELECTED: 1,
    ADD: 2,
    MENU: 3,
    HOVER: 4
};
const $4ab71e27db0ec1f1$export$e70f7f4a08e4d8fb = 10;
const $4ab71e27db0ec1f1$export$75297e3804621b0 = 36;
const $4ab71e27db0ec1f1$export$bdab9bfb39981463 = 'unassigned';

});

parcelRegister("kfN7T", function(module, exports) {

$parcel$export(module.exports, "default", () => $66a6af3ecba65952$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $8Rkzz = parcelRequire("8Rkzz");

var $vIiRg = parcelRequire("vIiRg");

var $3nHDn = parcelRequire("3nHDn");

var $8RXs9 = parcelRequire("8RXs9");

var $cE2Qr = parcelRequire("cE2Qr");

var $hchBL = parcelRequire("hchBL");

var $2XCFo = parcelRequire("2XCFo");

var $gQDFP = parcelRequire("gQDFP");

var $k1LTw = parcelRequire("k1LTw");

var $cWMNe = parcelRequire("cWMNe");

var $7oMpD = parcelRequire("7oMpD");

var $ihiH5 = parcelRequire("ihiH5");
const $66a6af3ecba65952$var$ADD_PEOPLE_BUTTON_TARGET = 'addPeopleButtonTarget';
const $66a6af3ecba65952$var$AddUsersButton = (props)=>{
    const { intl: { formatMessage: formatMessage }, onClick: onClickProp, peopleButtonRef: peopleButtonRef } = props;
    const onClick = (0, $5uXOq.useCallback)((event)=>{
        (0, $cWMNe.onBlur)(event);
        onClickProp();
    }, [
        onClickProp
    ]);
    const [, { register: register }] = (0, $hchBL.useGlobalRefStoreActions)();
    const onRef = (0, $5uXOq.useCallback)((ref)=>{
        register($66a6af3ecba65952$var$ADD_PEOPLE_BUTTON_TARGET, ref);
    }, [
        register
    ]);
    const [isDismissed] = (0, $cE2Qr.useIsDismissed)();
    const NudgeTooltip = !isDismissed ? (0, $2XCFo.AssigneeFilterAddPeopleButtonWrapperNudgeAsync) : (0, $5uXOq.Fragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($66a6af3ecba65952$var$AddButtonWrapper, {
        ref: onRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(NudgeTooltip, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ihiH5.AddPeopleTooltip), {
        content: formatMessage((0, $7oMpD.default).addPeople)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($66a6af3ecba65952$var$ActionAvatarWrapper, {
        ref: peopleButtonRef,
        "data-test-id": "filters.ui.filters.assignee.stateless.add-button",
        "data-testid": "filters.ui.filters.assignee.stateless.add-button",
        "data-pollinator-filter-bar-add-people": true,
        id: `${(0, $gQDFP.FILTER_PREFIX)}-add-person`,
        "aria-label": formatMessage((0, $7oMpD.default).addPeople),
        onClick: onClick,
        "aria-describedby": (0, $gQDFP.FILTER_PREFIX)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($66a6af3ecba65952$var$AddButtonAvatarSpacer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3nHDn))), {
        LEGACY_size: "medium",
        spacing: "spacious",
        label: formatMessage((0, $7oMpD.default).addPeople)
    }))))));
};
$66a6af3ecba65952$var$AddUsersButton.defaultProps = {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
var $66a6af3ecba65952$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $8RXs9.default)($66a6af3ecba65952$var$AddUsersButton);
const $66a6af3ecba65952$var$AddButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $66a6af3ecba65952$var$ActionAvatarWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $k1LTw.ActionAvatar), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1ssb _1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $66a6af3ecba65952$var$AddButtonAvatarSpacer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $k1LTw.ActionAvatarSpacer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1lu4wzb": (0, $lD23V.default)((0, $vIiRg.AVATAR_SIZES).medium, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko12pq _1ul912pq _1bsb1wug _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66 _vchhusvi _bfhkm7j4 _1p9v18uv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $66a6af3ecba65952$export$7ed12d2a5241e393 = {
    ActionAvatarWrapper: $66a6af3ecba65952$var$ActionAvatarWrapper
};

});
parcelRegister("3nHDn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0c28ad36bcbed963277bba2e64773578>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $27655de63feeadee$var$_react = $27655de63feeadee$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $27655de63feeadee$var$_personAdd = $27655de63feeadee$var$_interopRequireDefault((parcelRequire("fvfvk")));

var $27655de63feeadee$var$_inviteTeam = $27655de63feeadee$var$_interopRequireDefault((parcelRequire("ijaND")));
function $27655de63feeadee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PersonAddIcon.
 * This component is PersonAddIcon, with `UNSAFE_fallbackIcon` set to "InviteTeamIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding a user to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $27655de63feeadee$var$PersonAddIcon = (props)=>/*#__PURE__*/ $27655de63feeadee$var$_react.default.createElement($27655de63feeadee$var$_personAdd.default, Object.assign({
        LEGACY_fallbackIcon: $27655de63feeadee$var$_inviteTeam.default
    }, props));
$27655de63feeadee$var$PersonAddIcon.Name = 'PersonAddIconMigration';
var $27655de63feeadee$var$_default = module.exports.default = $27655de63feeadee$var$PersonAddIcon;

});
parcelRegister("fvfvk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a7c8caaba4b6537db98d2e63ce6d8f75>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b495c71cb30b2c7c$var$_react = $b495c71cb30b2c7c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b495c71cb30b2c7c$var$_baseNew = $b495c71cb30b2c7c$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $b495c71cb30b2c7c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding a user to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b495c71cb30b2c7c$var$PersonAddIcon = (props)=>/*#__PURE__*/ $b495c71cb30b2c7c$var$_react.default.createElement($b495c71cb30b2c7c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M1 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m11.25 4.75V11h1.5V8.75H16v-1.5h-2.25V5h-1.5v2.25H10v1.5zm-8.5 1.75a2.25 2.25 0 0 0-2.25 2.25V15H0v-2.25A3.75 3.75 0 0 1 3.75 9h2.5A3.75 3.75 0 0 1 10 12.75V15H8.5v-2.25a2.25 2.25 0 0 0-2.25-2.25z" clip-rule="evenodd"/>`
    }, props));
$b495c71cb30b2c7c$var$PersonAddIcon.displayName = 'PersonAddIcon';
var $b495c71cb30b2c7c$var$_default = module.exports.default = $b495c71cb30b2c7c$var$PersonAddIcon;

});

parcelRegister("ijaND", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d54260e58fec7f9a$var$_react = $d54260e58fec7f9a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $d54260e58fec7f9a$var$_personAdd = $d54260e58fec7f9a$var$_interopRequireDefault((parcelRequire("fvfvk")));
function $d54260e58fec7f9a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d54260e58fec7f9a$var$InviteTeamIcon = (props)=>/*#__PURE__*/ $d54260e58fec7f9a$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="2" height="6" x="18" y="5" rx="1"/><rect width="6" height="2" x="16" y="7" rx="1"/><path d="M5 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0z"/><circle cx="11" cy="7" r="4"/></g></svg>`
    }, props, {
        newIcon: $d54260e58fec7f9a$var$_personAdd.default
    }));
$d54260e58fec7f9a$var$InviteTeamIcon.displayName = 'InviteTeamIcon';
var $d54260e58fec7f9a$var$_default = module.exports.default = $d54260e58fec7f9a$var$InviteTeamIcon;

});


parcelRegister("2XCFo", function(module, exports) {

$parcel$export(module.exports, "AssigneeFilterAddPeopleButtonWrapperNudgeAsync", () => $ca2358eaf62c0b1a$export$4e4097c2567f79b7);

var $5uXOq = parcelRequire("5uXOq");


var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ca2358eaf62c0b1a$var$AssigneeFilterAddPeopleButtonLazy = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("iuXxq")).then((exportedModule)=>exportedModule.AssigneeFilterAddPeopleButtonWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/assignee-filter-add-people/index.tsx"
});
const $ca2358eaf62c0b1a$export$4e4097c2567f79b7 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $6784cbc7d62e5d7c$export$92c7f0eacc8d8d98),
        fallback: children,
        attributes: {
            nudgeId: (0, $6784cbc7d62e5d7c$export$92c7f0eacc8d8d98)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-onboarding-assignee-filter-add-people-nudge",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ca2358eaf62c0b1a$var$AssigneeFilterAddPeopleButtonLazy, {
        nudgeId: (0, $6784cbc7d62e5d7c$export$92c7f0eacc8d8d98)
    }, children)));

});
parcelRegister("iuXxq", function(module, exports) {

let $d779366393ccec97$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d779366393ccec97$var$load("76n7a"),
    $d779366393ccec97$var$load("l253H"),
    $d779366393ccec97$var$load("gYUWo")
]).then(()=>parcelRequire('1Pog6'));

});


parcelRegister("k1LTw", function(module, exports) {

$parcel$export(module.exports, "AvatarWrapper", () => $03be4aba8d3a8915$export$f7513421c53ce141);
$parcel$export(module.exports, "ActionAvatar", () => $03be4aba8d3a8915$export$1a5d4fdc8fa41cfb);
$parcel$export(module.exports, "ActionAvatarSpacer", () => $03be4aba8d3a8915$export$d1aac2da5f30c370);
$parcel$export(module.exports, "AvatarBorder", () => $03be4aba8d3a8915$export$398a7826f6fd570e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $5uXOq = parcelRequire("5uXOq");

var $vIiRg = parcelRequire("vIiRg");

var $7XYc4 = parcelRequire("7XYc4");

var $dCm1o = parcelRequire("dCm1o");

var $cSD7y = parcelRequire("cSD7y");

var $gQDFP = parcelRequire("gQDFP");
const $03be4aba8d3a8915$export$483a2b43be170225 = {
    position: 'absolute',
    width: '100%',
    height: '100%',
    padding: 0,
    border: 0,
    opacity: 0,
    overflow: 'hidden',
    'white-space': 'nowrap',
    cursor: 'pointer'
};
const $03be4aba8d3a8915$export$471e4f36da481c66 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isTanukiSpaceTokenFix: isTanukiSpaceTokenFix, zIndex: zIndex, jiggle: jiggle, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_10xi207": (0, $lD23V.default)(__cmplp.zIndex + (0, $gQDFP.Z_INDEX).SELECTED),
            "--_3qw8s9": (0, $lD23V.default)(__cmplp.zIndex),
            "--_1rh09jt": (0, $lD23V.default)(__cmplp.zIndex + (0, $gQDFP.Z_INDEX).HOVER)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _11q7glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _v5644a6k _2rko1ssb _19itidpf _12ji1r31 _1qu2glyw _12y3idpf _1e0c116y _4cvr1h6o _4t3i1ylp _kqswh2mm _s7n4jp4b _11cpidpf _rk8t1bgr _1dig1bgr _yt1x1bgr _qa15stnw _1tfxstnw _ixiwstnw _1wnsb3bt _h10pb3bt _1boqb3bt _328d1osq _cqfi1osq _rtz31osq _1mhnidpf _44x7idpf _l3jaidpf _1rky1n1a _1a071n1a _1wtq1n1a _1xpg1n1a _ti301n1a _1j2w1n1a _s1sf1mrw _1v981mrw _x2d61mrw _1pcqvab1 _1qb3vab1 _1b1bvab1 _vdzntlke _1virtlke _1y7ctlke",
            __cmplp.isTanukiSpaceTokenFix ? "_18u0x0bf" : "_18u014id",
            __cmplp.selected ? "_1pby1ho9" : "_1pby1hh6",
            __cmplp.jiggle ? "_1bvqr915 _66dkr915 _1llwr915" : "_1bvq1kli _66dk1kli _1llw1kli",
            __cmplp.jiggle ? "_n3lxmyb0 _gabdmyb0 _9di1myb0" : "_n3lxidpf _gabdidpf _9di1idpf",
            __cmplp.className
        ])
    });
});
const $03be4aba8d3a8915$var$AvatarWrapperBaseWithRef = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($03be4aba8d3a8915$export$471e4f36da481c66, {
        ...props,
        isTanukiSpaceTokenFix: true,
        ref: ref
    });
});
const $03be4aba8d3a8915$var$AvatarWrapperOld = (0, $cSD7y.componentWithFG)('tanuki_padding_margin_use_token', $03be4aba8d3a8915$var$AvatarWrapperBaseWithRef, $03be4aba8d3a8915$export$471e4f36da481c66);
const $03be4aba8d3a8915$export$7d5adb020315f211 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $03be4aba8d3a8915$var$AvatarWrapperOld, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19itidpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2rko1ssb _11q7glyw _12ji1r31 _1qu2glyw _12y3idpf _4t3in7od",
            __cmplp.className
        ])
    });
});
const $03be4aba8d3a8915$export$f7513421c53ce141 = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $03be4aba8d3a8915$export$7d5adb020315f211, $03be4aba8d3a8915$var$AvatarWrapperOld);
const $03be4aba8d3a8915$export$1a5d4fdc8fa41cfb = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2rko1ssb _v5644dm8 _189eyh40 _1dqonqa1 _1h6d15cr _bfhkm7j4 _80omtlke _nt751r31 _49pcglyw _1hvw1o36 _7ehi1y2g _irr315ej",
            __cmplp.className
        ])
    });
});
const $03be4aba8d3a8915$export$d1aac2da5f30c370 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1lu4wzb": (0, $lD23V.default)((0, $vIiRg.AVATAR_SIZES).medium, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1ssb _1e0c1txw _4cvr1h6o _1bah1h6o _1bsb12pq _4t3i12pq _bfhk18uv _syaz1fxt _vwz412pq",
            __cmplp.className
        ])
    });
});
const $03be4aba8d3a8915$export$398a7826f6fd570e = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSoftwareFullTheming: isSoftwareFullTheming, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1ssb _189eyh40 _1dqonqa1",
            __cmplp.selected ? __cmplp.isSoftwareFullTheming ? "_1h6deyly" : "_1h6dbku0" : "_1h6d3acm",
            __cmplp.className
        ])
    });
});

});

parcelRegister("cWMNe", function(module, exports) {

$parcel$export(module.exports, "onBlur", () => $3b2d077e6f2bec18$export$5e446bc31724fca4);
$parcel$export(module.exports, "useOnKeyPress", () => $3b2d077e6f2bec18$export$49f6dd346c7dfb52);

var $5uXOq = parcelRequire("5uXOq");
const $3b2d077e6f2bec18$export$5e446bc31724fca4 = (event)=>{
    event.currentTarget.blur();
};
const $3b2d077e6f2bec18$export$49f6dd346c7dfb52 = (callback)=>(0, $5uXOq.useCallback)((event)=>{
        if (event.key === 'Enter') callback(event);
    }, [
        callback
    ]);

});

parcelRegister("7oMpD", function(module, exports) {

$parcel$export(module.exports, "default", () => $84bb6f0a7c1ddc3e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $84bb6f0a7c1ddc3e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addPeople: {
        "id": "software-filters.filters.assignee.stateless.add-button.add-people",
        "defaultMessage": "Add people"
    }
});

});

parcelRegister("ihiH5", function(module, exports) {

$parcel$export(module.exports, "AddPeopleTooltip", () => $936c019622c243d2$export$7d4858372ded9f0e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3bDjY = parcelRequire("3bDjY");
const $936c019622c243d2$export$7d4858372ded9f0e = ({ content: content, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($936c019622c243d2$var$TooltipWrapper, null, children));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $936c019622c243d2$var$TooltipWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_12ji1r31 _1qu2glyw _12y3idpf _1e0c1o8l _kqswh2mm _4t3i14no",
            __cmplp.className
        ])
    });
});

});


parcelRegister("a43Dp", function(module, exports) {

$parcel$export(module.exports, "default", () => $68ed3a89d7efd9a4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $ujWmd = parcelRequire("ujWmd");

var $3bDjY = parcelRequire("3bDjY");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $joX8T = parcelRequire("joX8T");

var $8RXs9 = parcelRequire("8RXs9");

var $2WENx = parcelRequire("2WENx");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $lmBAt = parcelRequire("lmBAt");

var $a2e2Q = parcelRequire("a2e2Q");

var $k1LTw = parcelRequire("k1LTw");

var $cWMNe = parcelRequire("cWMNe");

var $f0vy0 = parcelRequire("f0vy0");

var $iv6Wk = parcelRequire("iv6Wk");
const $68ed3a89d7efd9a4$var$type = 'assignee';
const $68ed3a89d7efd9a4$var$Avatar = (props)=>{
    const { user: user, isSelected: isSelected, zIndex: zIndex, intl: intl } = props;
    const { formatMessage: formatMessage } = intl;
    const { isSoftwareFullTheming: isSoftwareFullTheming } = // eslint-disable-next-line jira/ff/no-preconditioning -- fast follows will rollout after the experiment has started
    (0, $4R6GH.fg)('jira_theming_milestone_1_fast_follows') && (0, $lmBAt.getIsSoftwareThemingEnabled)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $a2e2Q.useSoftwareProjectTheming)() : {
        isSoftwareFullTheming: false
    };
    const userIdentifier = user.id;
    const checkboxId = `${$68ed3a89d7efd9a4$var$type}-${userIdentifier}`;
    const onToggle = (0, $5uXOq.useCallback)(()=>{
        props.onToggle(user.id);
    }, [
        props,
        user.id
    ]);
    const onKeyPress = (0, $cWMNe.useOnKeyPress)(onToggle);
    const { experimentCohort: experimentCohort } = (0, $2WENx.useRealtimePresenceExperiment)();
    const isRealtimePresenceEnabled = experimentCohort === (0, $joX8T.VARIATION);
    const altTextWithPresence = formatMessage(user.presence === 'online' ? (0, $iv6Wk.default).presenceOnlineLabel : (0, $iv6Wk.default).presenceOfflineLabel, {
        name: user.displayName
    });
    const avatarWithTooltip = isRealtimePresenceEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f0vy0.default), {
        content: user.displayName,
        presence: user.presence,
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        testId: "filters.ui.filters.assignee.stateless.avatar.ak-avatar",
        size: (0, $dCm1o.isVisualRefreshEnabled)() ? 'small' : 'medium',
        as: "span",
        src: user.avatarUrl,
        name: user.presence ? altTextWithPresence : user.displayName,
        presence: user.presence
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: user.displayName,
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        testId: "filters.ui.filters.assignee.stateless.avatar.ak-avatar",
        size: (0, $dCm1o.isVisualRefreshEnabled)() ? 'small' : 'medium',
        as: "span",
        src: user.avatarUrl,
        name: user.displayName,
        presence: user.presence
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k1LTw.AvatarWrapper), {
        selected: isSelected,
        zIndex: zIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($68ed3a89d7efd9a4$var$AvatarInputCheckbox, {
        "aria-label": formatMessage((0, $iv6Wk.default).inputCheckboxLabel, {
            username: user.displayName
        }),
        type: "checkbox",
        id: checkboxId,
        name: $68ed3a89d7efd9a4$var$type,
        value: userIdentifier,
        defaultChecked: isSelected,
        onChange: onToggle,
        onKeyPress: onKeyPress,
        onClick: (0, $cWMNe.onBlur)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k1LTw.AvatarBorder), {
        selected: isSelected,
        isSoftwareFullTheming: isSoftwareFullTheming,
        "aria-hidden": (0, $4R6GH.fg)('tanuki_a11y_q4') ? true : undefined
    }, (0, $4R6GH.fg)('tanuki_a11y_q4') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "label",
        testId: "filters.ui.filters.assignee.stateless.avatar.assignee-filter-avatar",
        htmlFor: checkboxId,
        xcss: [
            (0, $dCm1o.isVisualRefreshEnabled)() ? $68ed3a89d7efd9a4$var$avatarLabelBaseWithVrStyles : $68ed3a89d7efd9a4$var$avatarLabelBaseStyles
        ]
    }, avatarWithTooltip) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($68ed3a89d7efd9a4$var$AvatarLabel, {
        "data-test-id": "filters.ui.filters.assignee.stateless.avatar.assignee-filter-avatar",
        "data-testid": "filters.ui.filters.assignee.stateless.avatar.assignee-filter-avatar",
        htmlFor: checkboxId
    }, avatarWithTooltip)));
};
$68ed3a89d7efd9a4$var$Avatar.defaultProps = {
    isSelected: false,
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
var $68ed3a89d7efd9a4$export$2e2bcd8739ae039 = (0, $8RXs9.default)($68ed3a89d7efd9a4$var$Avatar);
const $68ed3a89d7efd9a4$var$avatarLabelBaseStyles = (0, $8CUq3.xcss)({
    height: '36px',
    display: 'block',
    cursor: 'pointer'
});
const $68ed3a89d7efd9a4$var$avatarLabelBaseWithVrStyles = (0, $8CUq3.xcss)({
    height: '28px',
    display: 'block',
    cursor: 'pointer'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $68ed3a89d7efd9a4$var$AvatarLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_vwz4idpf _1e0c1ule _80omtlke",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $68ed3a89d7efd9a4$var$AvatarInputCheckbox = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "input", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _kqswstnw _1bsb1osq _4t3i1osq _tzy4idpf _o5721q9c _80omtlke _1xp4aqb7",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $68ed3a89d7efd9a4$export$7ed12d2a5241e393 = {
    AvatarInputCheckbox: $68ed3a89d7efd9a4$var$AvatarInputCheckbox
};

});
parcelRegister("joX8T", function(module, exports) {

$parcel$export(module.exports, "NOT_ENROLLED", () => $a85d1363752adaec$export$5b7423264d48ab04);
$parcel$export(module.exports, "VARIATION", () => $a85d1363752adaec$export$fa04ad826acc90da);

var $co1wz = parcelRequire("co1wz");
const $a85d1363752adaec$export$3d370c33621572df = 'cohort';
const $a85d1363752adaec$export$5b7423264d48ab04 = 'not-enrolled';
const $a85d1363752adaec$export$43f367b3e957f219 = 'control';
const $a85d1363752adaec$export$9ba2bc3b1bdc1519 = 'experiment';
const $a85d1363752adaec$export$fa04ad826acc90da = 'variation';
const $a85d1363752adaec$export$6486974e39493fa6 = 'variation-1';
const $a85d1363752adaec$export$7d994996134ad562 = 'variation-2';
const $a85d1363752adaec$export$795e7d69b248dcd0 = 'variation-3';
const $a85d1363752adaec$export$c9c947c57470b787 = 'variation-4';
const $a85d1363752adaec$var$DEFAULT_VALID_EXPERIMENT_GROUPS = [
    $a85d1363752adaec$export$5b7423264d48ab04,
    $a85d1363752adaec$export$43f367b3e957f219,
    $a85d1363752adaec$export$9ba2bc3b1bdc1519,
    $a85d1363752adaec$export$fa04ad826acc90da,
    $a85d1363752adaec$export$6486974e39493fa6,
    $a85d1363752adaec$export$7d994996134ad562,
    $a85d1363752adaec$export$795e7d69b248dcd0,
    $a85d1363752adaec$export$c9c947c57470b787
];
var // Use optionalValidExperimentGroups to further restrict the list of cohorts
// eslint-disable-next-line jira/import/no-anonymous-default-export
$a85d1363752adaec$export$2e2bcd8739ae039 = (experimentFeatureFlag, validExperimentGroups = $a85d1363752adaec$var$DEFAULT_VALID_EXPERIMENT_GROUPS)=>(0, $co1wz.getMultivariateFeatureFlag)(experimentFeatureFlag, $a85d1363752adaec$export$5b7423264d48ab04, validExperimentGroups);

});

parcelRegister("2WENx", function(module, exports) {

$parcel$export(module.exports, "useRealtimePresenceExperiment", () => $ef9e8ab383852170$export$ba964695877b24);

var $4mBKK = parcelRequire("4mBKK");

var $6s1PB = parcelRequire("6s1PB");

var $dkqym = parcelRequire("dkqym");
const $ef9e8ab383852170$export$ba964695877b24 = ()=>{
    const firstActivationDateMs = (0, $dkqym.useFirstActivationDateMs)();
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jsw_board_real-time_collaboration_through_presence');
    return {
        experimentCohort: !firstActivationDateMs || (0, $4mBKK.default)(new Date(), firstActivationDateMs) < 30 ? 'not-enrolled' : expConfig.get('cohort', 'not-enrolled')
    };
};

});

parcelRegister("f0vy0", function(module, exports) {

$parcel$export(module.exports, "default", () => $fff18090899dca54$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $hf0Xf = parcelRequire("hf0Xf");
const $fff18090899dca54$var$PresenceTooltip = ({ presence: presence, content: content, children: children, ...restProps })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const contentWithPresence = presence === 'online' ? formatMessage((0, $hf0Xf.default).presenceToolTipOnline, {
        name: String(content)
    }) : formatMessage((0, $hf0Xf.default).presenceToolTipOffline, {
        name: String(content)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: presence ? contentWithPresence : content,
        ...restProps
    }, children);
};
var $fff18090899dca54$export$2e2bcd8739ae039 = $fff18090899dca54$var$PresenceTooltip;

});
parcelRegister("hf0Xf", function(module, exports) {

$parcel$export(module.exports, "default", () => $14a1fa5c7f46c36b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $14a1fa5c7f46c36b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    presenceToolTipOnline: {
        "id": "software-filters.common.presence-tooltip.presence-tool-tip-online",
        "defaultMessage": "{name} is online"
    },
    presenceToolTipOffline: {
        "id": "software-filters.common.presence-tooltip.presence-tool-tip-offline",
        "defaultMessage": "{name} is offline"
    }
});

});


parcelRegister("iv6Wk", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a7903d4e27c8480$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2a7903d4e27c8480$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    presenceOnlineLabel: {
        "id": "software-filters.filters.assignee.stateless.avatar.presence-online-label",
        "defaultMessage": "{name} (online)"
    },
    presenceOfflineLabel: {
        "id": "software-filters.filters.assignee.stateless.avatar.presence-offline-label",
        "defaultMessage": "{name} (offline)"
    },
    avatarInputCheckboxLabel: {
        "id": "software-filters.filters.assignee.stateless.avatar.avatar-input-checkbox-label",
        "defaultMessage": "assignee filter avatar"
    },
    inputCheckboxLabel: {
        "id": "software-filters.filters.assignee.stateless.avatar.input-checkbox-label",
        "defaultMessage": "Filter assignees by {username}"
    }
});

});


parcelRegister("2eCzd", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a3184a04c19fde7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0a3184a04c19fde7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.assignee.stateless.label",
        "defaultMessage": "Filter by assignee"
    },
    showMoreButton: {
        "id": "software-filters.filters.assignee.stateless.show-more",
        "defaultMessage": "Show more assignees"
    }
});

});

parcelRegister("mafYu", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb88f751cbd22241$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $8Rkzz = parcelRequire("8Rkzz");

var $vIiRg = parcelRequire("vIiRg");
var $ujWmd = parcelRequire("ujWmd");

var $BLPHT = parcelRequire("BLPHT");
var $jFrow = parcelRequire("jFrow");

var $3bDjY = parcelRequire("3bDjY");

var $joX8T = parcelRequire("joX8T");

var $2WENx = parcelRequire("2WENx");

var $g5X3G = parcelRequire("g5X3G");

var $dCm1o = parcelRequire("dCm1o");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4R6GH = parcelRequire("4R6GH");

var $gQDFP = parcelRequire("gQDFP");

var $k1LTw = parcelRequire("k1LTw");

var $f0vy0 = parcelRequire("f0vy0");
const $bb88f751cbd22241$var$ShowMoreButton = (props)=>{
    const { users: users, selectedUsers: selectedUsers, onOpen: onOpen, onItemActivated: onItemActivatedProps, onClose: onClose } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onOpenChange = (0, $5uXOq.useCallback)(({ isOpen: isOpenDropDown })=>{
        if (isOpenDropDown) {
            onOpen();
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'showMoreAssignee');
        } else onClose && onClose();
    }, [
        onOpen,
        createAnalyticsEvent,
        onClose
    ]);
    const isSelected = (0, $5uXOq.useMemo)(()=>users.some((user)=>selectedUsers.includes(user.id)), [
        users,
        selectedUsers
    ]);
    const { experimentCohort: experimentCohort } = (0, $2WENx.useRealtimePresenceExperiment)();
    const isRealtimePresenceEnabled = experimentCohort === (0, $joX8T.VARIATION);
    const dropdownItems = (0, $5uXOq.useMemo)(()=>users.map(({ id: id, displayName: displayName, avatarUrl: avatarUrl, presence: presence })=>/*#__PURE__*/ $5uXOq.createElement($bb88f751cbd22241$var$ItemWrapper, {
                key: id
            }, /*#__PURE__*/ $5uXOq.createElement((0, $jFrow.default), {
                id: id,
                isSelected: selectedUsers.includes(id),
                onClick: ()=>{
                    onItemActivatedProps((0, $g5X3G.toAccountId)(String(id)));
                }
            }, /*#__PURE__*/ $5uXOq.createElement($bb88f751cbd22241$var$ItemContent, null, isRealtimePresenceEnabled ? /*#__PURE__*/ $5uXOq.createElement((0, $f0vy0.default), {
                content: displayName,
                presence: presence
            }, /*#__PURE__*/ $5uXOq.createElement($bb88f751cbd22241$var$DropdownAvatarWrapper, null, /*#__PURE__*/ $5uXOq.createElement((0, $ujWmd.default), {
                size: "small",
                src: avatarUrl,
                name: displayName,
                presence: presence
            }))) : /*#__PURE__*/ $5uXOq.createElement((0, $3bDjY.default), {
                content: displayName
            }, /*#__PURE__*/ $5uXOq.createElement($bb88f751cbd22241$var$DropdownAvatarWrapper, null, /*#__PURE__*/ $5uXOq.createElement((0, $ujWmd.default), {
                size: "small",
                src: avatarUrl,
                name: displayName,
                presence: presence
            }))), /*#__PURE__*/ $5uXOq.createElement($bb88f751cbd22241$var$TextContentWrapper, null, /*#__PURE__*/ $5uXOq.createElement($bb88f751cbd22241$var$TextContent, null, displayName)))))), [
        users,
        selectedUsers,
        onItemActivatedProps,
        isRealtimePresenceEnabled
    ]);
    return /*#__PURE__*/ $5uXOq.createElement($bb88f751cbd22241$var$DropdownMenuWrapper, null, /*#__PURE__*/ $5uXOq.createElement((0, $BLPHT.default), {
        onOpenChange: onOpenChange,
        trigger: ({ triggerRef: triggerRef, 'aria-expanded': ariaExpanded, ...triggerProps })=>/*#__PURE__*/ $5uXOq.createElement((0, $k1LTw.AvatarWrapper), {
                ...triggerProps,
                as: "button",
                "aria-expanded": ariaExpanded,
                ref: triggerRef,
                zIndex: (0, $gQDFP.Z_INDEX).MENU,
                "data-testid": "filters.ui.filters.assignee.stateless.show-more-button.assignee-filter-show-more"
            }, /*#__PURE__*/ $5uXOq.createElement((0, $k1LTw.AvatarBorder), {
                selected: isSelected
            }, /*#__PURE__*/ $5uXOq.createElement((0, $k1LTw.ActionAvatar), {
                as: "div",
                tabIndex: -1
            }, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ $5uXOq.createElement($bb88f751cbd22241$var$ShowMoreButtonAvatarSpacer, null, `+${users.length}`) : /*#__PURE__*/ $5uXOq.createElement((0, $k1LTw.ActionAvatarSpacer), null, `+${users.length}`))))
    }, /*#__PURE__*/ $5uXOq.createElement($bb88f751cbd22241$var$DropdownItemsWrapper, null, dropdownItems)));
};
$bb88f751cbd22241$var$ShowMoreButton.defaultProps = {
    onItemActivated: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
var $bb88f751cbd22241$export$2e2bcd8739ae039 = $bb88f751cbd22241$var$ShowMoreButton;
const $bb88f751cbd22241$var$dropdownMenuWrapperStyle = {
    root: "_1e0c116y _4cvr1h6o _18u0x0bf",
    withoutTanukiA11yQ4: "_1pbyidpf",
    withTanukiA11yQ4: "_1pbykb7n"
};
const $bb88f751cbd22241$var$DropdownMenuWrapper = ({ children: children })=>{
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            $bb88f751cbd22241$var$dropdownMenuWrapperStyle.root,
            (0, $4R6GH.fg)('tanuki_a11y_q4') ? $bb88f751cbd22241$var$dropdownMenuWrapperStyle.withTanukiA11yQ4 : $bb88f751cbd22241$var$dropdownMenuWrapperStyle.withoutTanukiA11yQ4
        ])
    }, children);
};
// The old menu dropdown has a max-width of 300px but the new one has 800px.
// We have to set the max-width in the wrapper to keep the same style.
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bb88f751cbd22241$var$DropdownItemsWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12f1mjv _ca0q1b66 _u5f3ze3t _n3td1b66 _19bvze3t",
            __cmplp.className
        ])
    });
});
const $bb88f751cbd22241$var$ItemWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_v6yzze3t _1kf0utpp _156mze3t _m6t6utpp _1ipkze3t _1kdcze3t _3glyze3t _1w2uze3t",
            __cmplp.className
        ])
    });
});
const $bb88f751cbd22241$var$ItemContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $bb88f751cbd22241$var$DropdownAvatarWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _18u0v77o",
            __cmplp.className
        ])
    });
});
const $bb88f751cbd22241$var$TextContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1txw _19pkze3t _2hwxu2gc _otyrze3t _18u0u2gc _ca0qu2gc _u5f3ze3t _n3tdu2gc _19bvze3t",
            __cmplp.className
        ])
    });
});
const $bb88f751cbd22241$var$TextContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});
const $bb88f751cbd22241$var$ShowMoreButtonAvatarSpacer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $k1LTw.ActionAvatarSpacer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_wiw70x": (0, $lD23V.default)((0, $vIiRg.AVATAR_SIZES).small, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81o8v _1bsb1yj7 _4t3i1yj7 _t9ec1win",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jFrow", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d90ebe7a2adf26d$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");

var $j7LBE = parcelRequire("j7LBE");

var $kJpBP = parcelRequire("kJpBP");

var $VSDnB = parcelRequire("VSDnB");

var $hEtee = parcelRequire("hEtee");

var $6PlGW = parcelRequire("6PlGW");

var $l7Q0F = parcelRequire("l7Q0F");

var $6cAn5 = parcelRequire("6cAn5");
/**
 * __Dropdown item checkbox__
 *
 * A dropdown item checkbox creates groups that have multiple selections.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/usage)
 */ const $9d90ebe7a2adf26d$var$DropdownItemCheckbox = ({ children: children, defaultSelected: defaultSelected, description: description, id: id, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, $eGmKJ.default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, testId: testId, interactionName: interactionName, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    typeof $6cAn5;
    const [selected, setSelected] = (0, $6PlGW.default)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    });
    const onClickHandler = (0, $5uXOq.useCallback)((event)=>{
        setSelected((selected)=>!selected);
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    const itemRef = (0, $l7Q0F.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j7LBE.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "none",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kJpBP.default), {
            "aria-checked": selected,
            description: description,
            iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hEtee.default), {
                checked: selected
            }),
            id: id,
            isDisabled: isDisabled,
            isSelected: selected,
            onClick: onClickHandler,
            ref: itemRef,
            role: "menuitemcheckbox",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            ...(0, $VSDnB.fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest,
            children: children
        })
    });
};
var $9d90ebe7a2adf26d$export$2e2bcd8739ae039 = $9d90ebe7a2adf26d$var$DropdownItemCheckbox;

});
parcelRegister("hEtee", function(module, exports) {

$parcel$export(module.exports, "default", () => $181f17e87025e1b2$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dV6Te = parcelRequire("dV6Te");

var $VSDnB = parcelRequire("VSDnB");

/**
 * __Checkbox icon__
 *
 * Used to visually represent the selected state in DropdownItemCheckbox
 *
 * @internal
 */ const $181f17e87025e1b2$var$CheckboxIcon = ({ checked: checked })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dV6Te.default), {
        label: "",
        size: "medium",
        primaryColor: checked ? `var(--ds-background-selected-bold, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-background-input, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})`,
        secondaryColor: checked ? `var(--ds-icon-inverse, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})` : 'transparent',
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("g", {
            fillRule: "evenodd",
            children: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
            (0, $VSDnB.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                        stroke: checked ? `var(--ds-border-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`,
                        x: "5.5",
                        y: "5.5",
                        width: "13",
                        height: "13",
                        rx: "1.5",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                        fill: "inherit"
                    })
                ]
            }) : /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                        fill: "currentColor",
                        x: "6",
                        y: "6",
                        width: "12",
                        height: "12",
                        rx: "2",
                        stroke: checked ? `var(--ds-border-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`,
                        strokeWidth: 1
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z",
                        fill: "inherit"
                    })
                ]
            })
        })
    });
};
var $181f17e87025e1b2$export$2e2bcd8739ae039 = $181f17e87025e1b2$var$CheckboxIcon;

});

parcelRegister("6PlGW", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e2d30248a719600$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5MgQz = parcelRequire("5MgQz");

var $iY6id = parcelRequire("iY6id");
/**
 * Custom hook to handle checkbox state for dropdown menu.
 * It works in tandem with the selection store context when the
 * component is uncontrolled.
 */ const $3e2d30248a719600$var$useCheckboxState = ({ isSelected: isSelected, id: id, defaultSelected: defaultSelected })=>{
    const { setItemState: setItemState, getItemState: getItemState } = (0, $5uXOq.useContext)((0, $iY6id.SelectionStoreContext));
    const groupId = (0, $5uXOq.useContext)((0, $5MgQz.CheckboxGroupContext));
    const persistedIsSelected = getItemState(groupId, id);
    const [localIsSelected, setLocalIsSelected] = (0, $5uXOq.useState)(// Initial state is set depending on value being defined or not.
    // This state is only utilised if the checkbox is uncontrolled.
    ()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
    const setLocalState = (0, $5uXOq.useCallback)((newValue)=>{
        const nextValue = newValue(persistedIsSelected);
        setLocalIsSelected(nextValue);
        setItemState(groupId, id, nextValue);
    }, [
        setItemState,
        persistedIsSelected,
        groupId,
        id
    ]);
    // Checkbox is controlled - do nothing!
    if (typeof isSelected === 'boolean') return [
        isSelected,
        ()=>false
    ];
    // Checkbox is going through its first render pass!
    if (persistedIsSelected === undefined) // Set the item so we have this state to access next time the checkbox renders (either by mounting or re-rendering!)
    setItemState(groupId, id, defaultSelected || false);
    // Return the value and setter!
    // Remember this flow is only returned if the checkbox is uncontrolled.
    return [
        localIsSelected,
        setLocalState
    ];
};
var $3e2d30248a719600$export$2e2bcd8739ae039 = $3e2d30248a719600$var$useCheckboxState;

});
parcelRegister("5MgQz", function(module, exports) {

$parcel$export(module.exports, "CheckboxGroupContext", () => $155fc86a3d14dca7$export$baf37c4be89255b8);

var $5uXOq = parcelRequire("5uXOq");
const $155fc86a3d14dca7$export$baf37c4be89255b8 = /*#__PURE__*/ (0, $5uXOq.createContext)('');

});






parcelRegister("3oCwY", function(module, exports) {

$parcel$export(module.exports, "default", () => $195137f112bf0000$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $22OQR = parcelRequire("22OQR");

var $a2e2Q = parcelRequire("a2e2Q");

var $aVUro = parcelRequire("aVUro");
const $195137f112bf0000$var$ClearFilterButton = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { isSoftwareFullTheming: isThemed } = (0, $a2e2Q.useSoftwareProjectTheming)();
    const ButtonComponent = isThemed ? (0, $22OQR.ThemedButton) : (0, $fVnbM.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            !(0, $dCm1o.isVisualRefreshEnabled)() && $195137f112bf0000$var$styledClearFilterStyles
        ],
        "data-test-id": "filters.ui.filters.clear-button.ak-button",
        testId: "filters.ui.filters.clear-button.ak-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ButtonComponent, {
        appearance: "subtle",
        onClick: props.onClick
    }, props.label || formatMessage((0, $aVUro.default).label)));
};
$195137f112bf0000$var$ClearFilterButton.defaultProps = {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
var $195137f112bf0000$export$2e2bcd8739ae039 = $195137f112bf0000$var$ClearFilterButton;
const $195137f112bf0000$var$styledClearFilterStyles = (0, $8CUq3.xcss)({
    paddingLeft: 'space.050',
    paddingRight: 'space.050'
});

});
parcelRegister("aVUro", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfdad8f510b5e904$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $dfdad8f510b5e904$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.clear-button.label",
        "defaultMessage": "Clear filters"
    }
});

});


parcelRegister("7j6PN", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bf5bd4e554fcb50$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $koVbs = parcelRequire("koVbs");

var $g5X3G = parcelRequire("g5X3G");

var $96s6B = parcelRequire("96s6B");

var $cTznA = parcelRequire("cTznA");
const $1bf5bd4e554fcb50$var$ComponentFilter = ({ components: components = [], selectedComponents: selectedComponents = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const values = (0, $5uXOq.useMemo)(()=>components.map((component)=>({
                label: component.name,
                // Casting to string normalises the id that may potentially be a number.
                value: String(component.id)
            })), [
        components
    ]);
    const onChangeCallback = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map(({ value: value })=>value), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    return (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
            label: formatMessage((0, $cTznA.default).label),
            values: values,
            selectedValues: (0, $g5X3G.toStringArray)(selectedComponents),
            onChange: onChangeCallback,
            isNested: isNested,
            placeholder: formatMessage((0, $cTznA.default).placeholder)
        }), [
        formatMessage,
        onChangeCallback,
        selectedComponents,
        values,
        isNested
    ]);
};
var $1bf5bd4e554fcb50$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($1bf5bd4e554fcb50$var$ComponentFilter);

});
parcelRegister("cTznA", function(module, exports) {

$parcel$export(module.exports, "default", () => $798caf1923191bc1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $798caf1923191bc1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.component.label",
        "defaultMessage": "Components"
    },
    placeholder: {
        "id": "software-filters.filters.component.placeholder",
        "defaultMessage": "Search component filters..."
    }
});

});


parcelRegister("8bg0N", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a3ccb8efb497741$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $koVbs = parcelRequire("koVbs");

var $96s6B = parcelRequire("96s6B");

var $1k18w = parcelRequire("1k18w");

var $kIDH3 = parcelRequire("kIDH3");
const $6a3ccb8efb497741$var$DependenciesFilter = ({ isOpen: isOpen = false, onChange: // only used for VR testing purposes
onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), selectedValues: selectedValues = [] })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onChangeValue = (0, $5uXOq.useCallback)((entries)=>{
        onChange(entries.map(({ value: value })=>value));
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        isOpen: isOpen,
        label: formatMessage((0, $1k18w.default).label),
        onChange: onChangeValue,
        values: [
            {
                // Change label back to  formatMessage(messages.dependencyType) when adding
                // new filter by options such as cross-team and specific dependencies
                label: '',
                options: [
                    {
                        label: formatMessage((0, $1k18w.default).offTrack),
                        value: (0, $kIDH3.DependencyFilterOption).OFF_TRACK
                    },
                    {
                        label: formatMessage((0, $1k18w.default).onTrack),
                        value: (0, $kIDH3.DependencyFilterOption).ON_TRACK
                    }
                ]
            }
        ],
        selectedValues: selectedValues,
        placeholder: formatMessage((0, $1k18w.default).placeholder)
    });
};
$6a3ccb8efb497741$var$DependenciesFilter.displayName = 'DependenciesFilter';
$6a3ccb8efb497741$var$DependenciesFilter.whyDidYouRender = true;
var $6a3ccb8efb497741$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($6a3ccb8efb497741$var$DependenciesFilter);

});
parcelRegister("1k18w", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6bab5f988dfca5a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b6bab5f988dfca5a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.dependencies.label",
        "defaultMessage": "Dependencies"
    },
    placeholder: {
        "id": "software-filters.filters.dependencies.placeholder",
        "defaultMessage": "Search dependencies filters..."
    },
    dependencyType: {
        "id": "software-filters.filters.dependencies.dependency-type",
        "defaultMessage": "Dependency type"
    },
    offTrack: {
        "id": "software-filters.filters.dependencies.off-track",
        "defaultMessage": "Off-track"
    },
    onTrack: {
        "id": "software-filters.filters.dependencies.on-track",
        "defaultMessage": "On-track"
    }
});

});


parcelRegister("kgqZV", function(module, exports) {

$parcel$export(module.exports, "default", () => $089e7ae732d57721$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4Xk2W = parcelRequire("4Xk2W");

var $8Rkzz = parcelRequire("8Rkzz");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $2Ywmz = parcelRequire("2Ywmz");

var $3uePO = parcelRequire("3uePO");

var $96s6B = parcelRequire("96s6B");

var $9vXUM = parcelRequire("9vXUM");

var $BZHAT = parcelRequire("BZHAT");
const $089e7ae732d57721$var$EMPTY_ARRAY = [];
const $089e7ae732d57721$var$GoalCustomOptionLabel = ({ label: label, value: value })=>{
    const goalContext = (0, $5uXOq.useContext)((0, $9vXUM.GoalFilterContext));
    const goalState = goalContext.goals[value]?.state;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.050",
        alignBlock: "center",
        alignInline: "start",
        grow: "fill"
    }, goalState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Ywmz.GoalIcon), {
        state: goalState.value
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span",
        xcss: $089e7ae732d57721$var$goalLabelStyles
    }, label), goalState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3uePO.GoalTracker), {
        label: goalState.label,
        score: goalState.score,
        value: goalState.value
    }));
};
const $089e7ae732d57721$var$GoalFilter = ({ goals: goals, selectedGoals: selectedGoals = $089e7ae732d57721$var$EMPTY_ARRAY, onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onInputChange: onInputChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onOpenChange: onOpenChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onMouseEnterToTriggerButton: onMouseEnterToTriggerButton = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), showMenuIfValuesAreEmpty: showMenuIfValuesAreEmpty = false, inputValue: inputValue, isLoading: isLoading = false, isNested: isNested = false, isOpen: isOpen = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const values = (0, $5uXOq.useMemo)(()=>goals.map((goal)=>({
                label: goal.name,
                value: goal.id,
                data: goal.state
            })), [
        goals
    ]);
    const goalsHash = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(goals, (goal)=>goal.id), [
        goals
    ]);
    const onChangeCallback = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map((entry)=>entry.value), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9vXUM.GoalFilterContext).Provider, {
        value: {
            goals: goalsHash
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        label: formatMessage((0, $BZHAT.default).label),
        values: values,
        isOpen: isOpen,
        selectedValues: selectedGoals,
        isPanelToggleChecked: false,
        onChange: onChangeCallback,
        inputValue: inputValue,
        isLoading: isLoading,
        onInputChange: onInputChange,
        onOpenChange: onOpenChange,
        noOptionsMessage: formatMessage((0, $BZHAT.default).noGoals),
        showMenuIfValuesAreEmpty: showMenuIfValuesAreEmpty,
        isAsyncSearch: false,
        isNested: isNested,
        onMouseEnterToTriggerButton: onMouseEnterToTriggerButton,
        placeholder: formatMessage((0, $BZHAT.default).placeholder),
        CustomOptionLabel: $089e7ae732d57721$var$GoalCustomOptionLabel,
        showPanelToggle: false,
        showLink: false,
        useHrefForUrl: false,
        maxSelectionAllowed: Number.MAX_SAFE_INTEGER,
        onTogglePanel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onLinkItemClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        toggleRef: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    }));
};
var $089e7ae732d57721$export$2e2bcd8739ae039 = $089e7ae732d57721$var$GoalFilter;
const $089e7ae732d57721$var$goalLabelStyles = (0, $8CUq3.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});

});
parcelRegister("2Ywmz", function(module, exports) {

$parcel$export(module.exports, "GoalIcon", () => $7be6a95607230c54$export$134cbcd70c6693b8);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $6yf6t = parcelRequire("6yf6t");

var $4UrMe = parcelRequire("4UrMe");
const $7be6a95607230c54$var$GoalGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        viewBox: "0 0 18 18"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M16 9C16 12.866 12.866 16 9 16C5.13401 16 2 12.866 2 9C2 5.13401 5.13401 2 9 2C12.866 2 16 5.13401 16 9ZM18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9ZM11 9C11 10.1046 10.1046 11 9 11C7.89543 11 7 10.1046 7 9C7 7.89543 7.89543 7 9 7C10.1046 7 11 7.89543 11 9ZM13 9C13 11.2091 11.2091 13 9 13C6.79086 13 5 11.2091 5 9C5 6.79086 6.79086 5 9 5C11.2091 5 13 6.79086 13 9Z",
        fillRule: "evenodd"
    })));
const $7be6a95607230c54$export$134cbcd70c6693b8 = ({ state: state, ariaLabel: ariaLabel })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $7be6a95607230c54$var$iconContainerStyles,
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $6yf6t.mapStateToBgColor)(state)
        },
        "aria-label": ariaLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        glyph: $7be6a95607230c54$var$GoalGlyph,
        label: formatMessage((0, $4UrMe.default).goalIconLabel),
        primaryColor: (0, $6yf6t.mapStateToColor)(state)
    }));
};
const $7be6a95607230c54$var$iconContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '24px',
    minWidth: '24px',
    height: '24px',
    borderRadius: 'border.radius',
    marginRight: 'space.025'
});

});
parcelRegister("6yf6t", function(module, exports) {

$parcel$export(module.exports, "mapStateToBgColor", () => $6a435c3af325b8dc$export$931dac3fa53640b1);
$parcel$export(module.exports, "mapStateToColor", () => $6a435c3af325b8dc$export$163d1ee1b3b2aead);
$parcel$export(module.exports, "mapScoreToBgColor", () => $6a435c3af325b8dc$export$525ec0d5be9572a4);
$parcel$export(module.exports, "extractStatusLabelWithoutScore", () => $6a435c3af325b8dc$export$88bbcb3741dee92d);
const $6a435c3af325b8dc$export$931dac3fa53640b1 = (state)=>{
    switch(state){
        case 'off_track':
            return "var(--ds-background-accent-red-subtlest, #FFECEB)";
        case 'at_risk':
            return "var(--ds-background-accent-yellow-subtlest, #FFF7D6)";
        case 'on_track':
            return "var(--ds-background-accent-green-subtlest, #DCFFF1)";
        case 'archived':
        case 'cancelled':
        case 'done':
        case 'paused':
        case 'pending':
        default:
            return "var(--ds-background-accent-gray-subtlest, #F1F2F4)";
    }
};
const $6a435c3af325b8dc$export$163d1ee1b3b2aead = (state)=>{
    switch(state){
        case 'off_track':
            return "var(--ds-text-accent-red, #AE2E24)";
        case 'at_risk':
            return "var(--ds-text-accent-orange, #A54800)";
        case 'on_track':
            return "var(--ds-text-accent-green, #216E4E)";
        case 'archived':
        case 'cancelled':
        case 'done':
        case 'paused':
        case 'pending':
        default:
            return "var(--ds-text-accent-gray, #44546F)";
    }
};
const $6a435c3af325b8dc$export$525ec0d5be9572a4 = (score)=>{
    if (score < 0.4) return "var(--ds-background-danger-bold, #C9372C)";
    if (score < 0.7) return "var(--ds-background-accent-orange-bolder, #C25100)";
    return "var(--ds-background-success-bold, #1F845A)";
};
const $6a435c3af325b8dc$export$88bbcb3741dee92d = (fullLabel)=>fullLabel.split(' - ')[0];

});

parcelRegister("4UrMe", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ec31bd513378ade$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2ec31bd513378ade$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    goalIconLabel: {
        "id": "software-goals.goal.icon.goal-icon-label",
        "defaultMessage": "Goal"
    }
});

});


parcelRegister("3uePO", function(module, exports) {

$parcel$export(module.exports, "GoalTracker", () => $ec22661ff8271891$export$c0fdf469f92e8578);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $6yf6t = parcelRequire("6yf6t");

var $aabh6 = parcelRequire("aabh6");
const $ec22661ff8271891$export$c0fdf469f92e8578 = ({ value: value, label: label, score: score })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ec22661ff8271891$var$Tracker, {
        backgroundColor: (0, $6yf6t.mapStateToBgColor)(value),
        color: (0, $6yf6t.mapStateToColor)(value)
    }, (0, $6yf6t.extractStatusLabelWithoutScore)(label), score !== undefined && score !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aabh6.Score), {
        score: score
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $ec22661ff8271891$var$Tracker = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1hphqkz": (0, $lD23V.default)(__cmplp.backgroundColor),
            "--_xexnhp": (0, $lD23V.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _11c81o8v _3fcw1q9c _bfhk3qkl _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _k48pmoej _syaz1cj8 _1p1dangw _1e0c1ule _4t3i7vkz",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aabh6", function(module, exports) {

$parcel$export(module.exports, "Score", () => $08dbd54fe256bc26$export$6735cf84ecd2736);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $6yf6t = parcelRequire("6yf6t");
const $08dbd54fe256bc26$export$6735cf84ecd2736 = ({ score: score })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08dbd54fe256bc26$var$ScoreContainer, {
        backgroundColor: (0, $6yf6t.mapScoreToBgColor)(score)
    }, score);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $08dbd54fe256bc26$var$ScoreContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1hphqkz": (0, $lD23V.default)(__cmplp.backgroundColor)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _1e0c116y _bfhk3qkl _syaz15cr _18u01b66 _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66 _4t3i7vkz",
            __cmplp.className
        ])
    });
});

});


parcelRegister("9vXUM", function(module, exports) {

$parcel$export(module.exports, "GoalFilterContext", () => $c20e77c82f0ed08e$export$f656d92d95229cd2);

var $5uXOq = parcelRequire("5uXOq");
const $c20e77c82f0ed08e$export$f656d92d95229cd2 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    goals: {}
});

});

parcelRegister("BZHAT", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfb7fe3166051b6f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $dfb7fe3166051b6f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noGoals: {
        "id": "software-filters.filters.goals.no-goals",
        "defaultMessage": "There are no matching goals"
    },
    placeholder: {
        "id": "software-filters.filters.goals.placeholder",
        "defaultMessage": "Choose goals"
    },
    label: {
        "id": "software-filters.filters.goals.label",
        "defaultMessage": "Goals"
    }
});

});


parcelRegister("efv79", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e07b1cd691dec67$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $koVbs = parcelRequire("koVbs");

var $g5X3G = parcelRequire("g5X3G");

var $96s6B = parcelRequire("96s6B");

var $4c4ZP = parcelRequire("4c4ZP");
const $7e07b1cd691dec67$var$IssueProjectFilter = ({ isOpen: isOpen = false, isNested: // only used for VR testing purposes
isNested = false, issueProjects: issueProjects = {}, onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), selectedProjects: selectedProjects = [] })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const values = (0, $5uXOq.useMemo)(()=>Object.values(issueProjects).map(({ avatar: avatar, id: id, name: name })=>({
                iconUrl: avatar,
                label: name,
                value: String(id)
            })).sort((a, b)=>a.label.localeCompare(b.label)), [
        issueProjects
    ]);
    const onChangeValue = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map(({ value: value })=>(0, $g5X3G.toProjectId)(value)), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        isOpen: isOpen,
        isNested: isNested,
        label: formatMessage((0, $4c4ZP.default).label),
        onChange: onChangeValue,
        selectedValues: selectedProjects.map(String),
        values: values,
        placeholder: formatMessage((0, $4c4ZP.default).placeholder)
    });
};
$7e07b1cd691dec67$var$IssueProjectFilter.displayName = 'IssueProjectFilter';
$7e07b1cd691dec67$var$IssueProjectFilter.whyDidYouRender = true;
var $7e07b1cd691dec67$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($7e07b1cd691dec67$var$IssueProjectFilter);

});
parcelRegister("4c4ZP", function(module, exports) {

$parcel$export(module.exports, "default", () => $01676d3e9ff29bbf$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $01676d3e9ff29bbf$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.issue-project.label",
        "defaultMessage": "Project"
    },
    placeholder: {
        "id": "software-filters.filters.issue-project.placeholder",
        "defaultMessage": "Search project filters..."
    }
});

});


parcelRegister("jKPI1", function(module, exports) {

$parcel$export(module.exports, "default", () => $6442616aa336213b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $koVbs = parcelRequire("koVbs");

var $96s6B = parcelRequire("96s6B");

var $hF6jn = parcelRequire("hF6jn");
const $6442616aa336213b$var$IssueTypeGroupFilter = ({ isOpen: isOpen = false, issueTypeGroups: issueTypeGroups = [], selectedIssueTypes: selectedIssueTypes = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const issueTypeGroupByIssueType = (0, $5uXOq.useMemo)(()=>new Map(issueTypeGroups.flatMap((group)=>group.issueTypes.map((issueType)=>[
                    issueType,
                    group
                ]))), [
        issueTypeGroups
    ]);
    const issueTypeGroupByGroupKey = (0, $5uXOq.useMemo)(()=>new Map(issueTypeGroups.map((group)=>[
                group.key,
                group
            ])), [
        issueTypeGroups
    ]);
    const values = (0, $5uXOq.useMemo)(()=>issueTypeGroups.map((group)=>({
                label: group.name,
                value: group.key,
                iconUrl: group.iconUrl
            })), [
        issueTypeGroups
    ]);
    const selectGroupsByKeys = (0, $5uXOq.useCallback)((keys)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(keys.flatMap((key)=>issueTypeGroupByGroupKey.get(key)?.issueTypes).filter(Boolean), analyticAttributes);
    }, [
        onChange,
        issueTypeGroupByGroupKey,
        isNested
    ]);
    const selectedGroups = (0, $5uXOq.useMemo)(()=>Array.from(new Set(selectedIssueTypes.map((key)=>issueTypeGroupByIssueType.get(key)))), [
        issueTypeGroupByIssueType,
        selectedIssueTypes
    ]);
    const selectedGroupKeys = selectedGroups.map((group)=>group?.key).filter(Boolean);
    const selectedGroupsAllIssueTypes = selectedGroups.flatMap((group)=>group?.issueTypes).filter(Boolean);
    const onChangeCallback = (0, $5uXOq.useCallback)((entries)=>{
        const entryValues = entries.map(({ value: value })=>value);
        selectGroupsByKeys(entryValues);
    }, [
        selectGroupsByKeys
    ]);
    // early exit if we have only one issue type group
    if (issueTypeGroups.length <= 1) return null;
    // if there's mismatch between the filters in the url and the issue groups, e.g. when the url is manually edited or when an issue of a new type is created, we would apply the whole group
    if (selectedGroupsAllIssueTypes.length !== selectedIssueTypes.length) {
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(selectedGroupsAllIssueTypes, analyticAttributes);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        isOpen: isOpen,
        label: formatMessage((0, $hF6jn.default).label),
        values: values,
        selectedValues: selectedGroupKeys,
        onChange: onChangeCallback,
        isNested: isNested,
        placeholder: formatMessage((0, $hF6jn.default).placeholder)
    });
};
$6442616aa336213b$var$IssueTypeGroupFilter.displayName = 'IssueTypeGroupFilter';
$6442616aa336213b$var$IssueTypeGroupFilter.whyDidYouRender = true;
var $6442616aa336213b$export$2e2bcd8739ae039 = $6442616aa336213b$var$IssueTypeGroupFilter;

});
parcelRegister("hF6jn", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d157749564d70c9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1d157749564d70c9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.issue-type-group.label",
        "defaultMessage": "Type"
    },
    placeholder: {
        "id": "software-filters.filters.issue-type-group.placeholder",
        "defaultMessage": "Search type filters..."
    }
});

});


parcelRegister("hHL6f", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b5fa2dd02736e8c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $koVbs = parcelRequire("koVbs");

var $g5X3G = parcelRequire("g5X3G");

var $96s6B = parcelRequire("96s6B");

var $lcsGW = parcelRequire("lcsGW");
const $2b5fa2dd02736e8c$var$IssueTypeFilter = ({ issueTypes: issueTypes = [], selectedIssueTypes: selectedIssueTypes = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const values = (0, $5uXOq.useMemo)(()=>issueTypes.map((issueType)=>({
                label: issueType.name,
                value: issueType.id,
                iconUrl: issueType.iconUrl
            })), [
        issueTypes
    ]);
    const onChangeCallback = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map((entry)=>(0, $g5X3G.toIssueTypeId)(entry.value)), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    // early exit if we have only one issue type
    if (issueTypes.length <= 1) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        label: formatMessage((0, $lcsGW.default).label),
        values: values,
        selectedValues: selectedIssueTypes.map(String),
        onChange: onChangeCallback,
        isNested: isNested,
        placeholder: formatMessage((0, $lcsGW.default).placeholder)
    });
};
const $2b5fa2dd02736e8c$var$IssueTypeFilterComponent = /*#__PURE__*/ (0, $5uXOq.memo)($2b5fa2dd02736e8c$var$IssueTypeFilter);
$2b5fa2dd02736e8c$var$IssueTypeFilterComponent.displayName = 'IssueTypeFilter';
// @ts-expect-error TS2339: Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<Props>'.
$2b5fa2dd02736e8c$var$IssueTypeFilterComponent.whyDidYouRender = true;
var $2b5fa2dd02736e8c$export$2e2bcd8739ae039 = $2b5fa2dd02736e8c$var$IssueTypeFilterComponent;

});
parcelRegister("lcsGW", function(module, exports) {

$parcel$export(module.exports, "default", () => $418d852f97677c87$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $418d852f97677c87$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.issue-type.label",
        "defaultMessage": "Type"
    },
    placeholder: {
        "id": "software-filters.filters.issue-type.placeholder",
        "defaultMessage": "Search type filters..."
    }
});

});


parcelRegister("2fsdj", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f5c968fce1f630e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $koVbs = parcelRequire("koVbs");

var $96s6B = parcelRequire("96s6B");

var $bvI90 = parcelRequire("bvI90");
const $2f5c968fce1f630e$var$LabelFilter = ({ labels: labels = [], selectedLabels: selectedLabels = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isNested: isNested = false, unassignedOption: unassignedOption })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const values = (0, $5uXOq.useMemo)(()=>{
        const options = labels.map((label)=>({
                label: label,
                value: label
            }));
        unassignedOption && options.unshift(unassignedOption);
        return options;
    }, [
        labels,
        unassignedOption
    ]);
    const onChangeMapValues = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map((entry)=>entry.value), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        label: formatMessage((0, $bvI90.default).label),
        values: values,
        selectedValues: selectedLabels,
        onChange: onChangeMapValues,
        isNested: isNested,
        placeholder: formatMessage((0, $bvI90.default).placeholder)
    });
};
const $2f5c968fce1f630e$var$LabelFilterComponent = /*#__PURE__*/ (0, $5uXOq.memo)($2f5c968fce1f630e$var$LabelFilter);
$2f5c968fce1f630e$var$LabelFilterComponent.displayName = 'LabelFilter';
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<Props>'.
$2f5c968fce1f630e$var$LabelFilterComponent.whyDidYouRender = true;
var $2f5c968fce1f630e$export$2e2bcd8739ae039 = $2f5c968fce1f630e$var$LabelFilterComponent;

});
parcelRegister("bvI90", function(module, exports) {

$parcel$export(module.exports, "default", () => $7299efb383111469$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7299efb383111469$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.label.label",
        "defaultMessage": "Label"
    },
    placeholder: {
        "id": "software-filters.filters.label.placeholder",
        "defaultMessage": "Search label filters..."
    }
});

});


parcelRegister("bLWKp", function(module, exports) {

$parcel$export(module.exports, "default", () => $31db5ca9c486657a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $az4zD = parcelRequire("az4zD");

var $iXVV6 = parcelRequire("iXVV6");

var $g5X3G = parcelRequire("g5X3G");

var $9pP0g = parcelRequire("9pP0g");

var $iDGXn = parcelRequire("iDGXn");

var $bmKPg = parcelRequire("bmKPg");

var $96s6B = parcelRequire("96s6B");

var $9oo3F = parcelRequire("9oo3F");
const $31db5ca9c486657a$var$ParentFilter = (props)=>{
    const { label: label, parents: parents, selectedParents: selectedParents, isToggleChecked: isToggleChecked, onTogglePanel: onTogglePanel, onInputChange: onInputChange, onOpenChange: onOpenChange, onMouseEnterToTriggerButton: onMouseEnterToTriggerButton, intl: { formatMessage: formatMessage }, showPanelToggle: showPanelToggle, showMenuIfValuesAreEmpty: showMenuIfValuesAreEmpty, inputValue: inputValue, isLoading: isLoading, isAsyncSearch: isAsyncSearch, isNested: isNested, isOpen: isOpen } = props;
    const [boardId] = (0, $bmKPg.usePathParam)('boardId');
    const { toggleViewSetting: toggleViewSetting } = (0, $iDGXn.useViewSettingsActions)();
    const values = (0, $5uXOq.useMemo)(()=>parents.map((parent)=>({
                label: parent.name,
                value: parent.id,
                subLabel: parent.key
            })), [
        parents
    ]);
    const onChange = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        props.onChange(entries.map((entry)=>(0, $g5X3G.toIssueId)(entry.value)), analyticAttributes);
    }, [
        props,
        isNested
    ]);
    const handleTogglePanel = (0, $5uXOq.useCallback)(()=>{
        if (boardId) toggleViewSetting({
            boardId: Number(boardId),
            setting: (0, $9pP0g.ViewSetting).EPIC_PANEL
        });
        onTogglePanel();
    }, [
        boardId,
        onTogglePanel,
        toggleViewSetting
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "epicPanelToggle",
        attributes: {
            isOpen: !isToggleChecked,
            filterType: label
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        label: label,
        toggleLabel: formatMessage((0, $9oo3F.default).toggleLabel, {
            parentName: label?.toLowerCase()
        }),
        values: values,
        isOpen: isOpen,
        showPanelToggle: showPanelToggle,
        selectedValues: selectedParents.map(String),
        isPanelToggleChecked: isToggleChecked,
        onChange: onChange,
        inputValue: inputValue,
        isLoading: isLoading,
        onInputChange: onInputChange,
        onTogglePanel: handleTogglePanel,
        onOpenChange: onOpenChange,
        noOptionsMessage: formatMessage((0, $9oo3F.default).noParentIssues, {
            parentName: label
        }),
        showMenuIfValuesAreEmpty: showMenuIfValuesAreEmpty,
        isAsyncSearch: isAsyncSearch,
        isNested: isNested,
        onMouseEnterToTriggerButton: onMouseEnterToTriggerButton,
        placeholder: formatMessage((0, $9oo3F.default).placeholder, {
            parentName: label
        }),
        shouldCloseMenuOnTab: showPanelToggle ? false : undefined
    }));
};
$31db5ca9c486657a$var$ParentFilter.defaultProps = {
    selectedParents: [],
    isToggleChecked: false,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onInputChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onTogglePanel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    showPanelToggle: false,
    showMenuIfValuesAreEmpty: false,
    isLoading: false,
    isAsyncSearch: false,
    isNested: false
};
var $31db5ca9c486657a$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($31db5ca9c486657a$var$ParentFilter);

});
parcelRegister("9oo3F", function(module, exports) {

$parcel$export(module.exports, "default", () => $9506229386ae6ee1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9506229386ae6ee1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noParentIssues: {
        "id": "software-filters.filters.parent.no-parent-issues",
        "defaultMessage": "Your project has no {parentName}"
    },
    toggleLabel: {
        "id": "software-filters.filters.parent.toggle-label",
        "defaultMessage": "Show {parentName} panel"
    },
    placeholder: {
        "id": "software-filters.filters.parent.placeholder",
        "defaultMessage": "Search {parentName} filters..."
    }
});

});


parcelRegister("hpA0D", function(module, exports) {

$parcel$export(module.exports, "default", () => $779f77cd70091738$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $aWse0 = parcelRequire("aWse0");

var $96s6B = parcelRequire("96s6B");

var $6DAJ4 = parcelRequire("6DAJ4");
const $779f77cd70091738$var$MAX_SELECTION_ALLOWED = 10;
const $779f77cd70091738$var$QuickFilter = ({ filters: filters = [], selectedFilters: selectedFilters = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const values = (0, $5uXOq.useMemo)(()=>filters.map((filter)=>({
                label: filter.name,
                value: filter.id
            })), [
        filters
    ]);
    const onChangeMapValues = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map((entry)=>entry.value), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    const maxSelectionReachedTooltip = formatMessage((0, $6DAJ4.default).maxSelectionReachedTooltip, {
        maxSelectionAllowed: $779f77cd70091738$var$MAX_SELECTION_ALLOWED
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        label: formatMessage((0, $6DAJ4.default).label),
        values: values,
        selectedValues: selectedFilters,
        onChange: onChangeMapValues,
        maxSelectionAllowed: $779f77cd70091738$var$MAX_SELECTION_ALLOWED,
        maxSelectionReachedTooltip: maxSelectionReachedTooltip,
        isNested: isNested,
        placeholder: formatMessage((0, $6DAJ4.default).placeholder)
    });
};
const $779f77cd70091738$var$QuickFilterComponent = /*#__PURE__*/ (0, $5uXOq.memo)($779f77cd70091738$var$QuickFilter);
$779f77cd70091738$var$QuickFilterComponent.displayName = 'QuickFilter';
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<Props>'.
$779f77cd70091738$var$QuickFilterComponent.whyDidYouRender = true;
var $779f77cd70091738$export$2e2bcd8739ae039 = $779f77cd70091738$var$QuickFilterComponent;

});
parcelRegister("6DAJ4", function(module, exports) {

$parcel$export(module.exports, "default", () => $28d3824050b576c4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $28d3824050b576c4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.quick.label",
        "defaultMessage": "Quick filters"
    },
    placeholder: {
        "id": "software-filters.filters.quick.placeholder",
        "defaultMessage": "Search quick filters..."
    },
    maxSelectionReachedTooltip: {
        "id": "software-filters.filters.quick.max-selection-reached-tooltip",
        "defaultMessage": "You can't select more than {maxSelectionAllowed, plural, one {# quick filter} other {# quick filters}}"
    }
});

});


parcelRegister("g65Ek", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccc78a455db68a11$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $koVbs = parcelRequire("koVbs");

var $96s6B = parcelRequire("96s6B");

var $e0XMB = parcelRequire("e0XMB");
const $ccc78a455db68a11$var$RequestTypeFilter = ({ requestTypes: requestTypes = [], selectedRequestTypes: selectedRequestTypes = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const values = (0, $5uXOq.useMemo)(()=>requestTypes.map((requestType)=>({
                label: requestType.name,
                value: requestType.id,
                iconUrl: requestType.iconUrl
            })), [
        requestTypes
    ]);
    const onChangeCallback = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map((entry)=>entry.value), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    // early exit if we have only one option
    if (requestTypes.length <= 1) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        label: formatMessage((0, $e0XMB.default).label),
        values: values,
        selectedValues: selectedRequestTypes.map(String),
        onChange: onChangeCallback,
        isNested: isNested,
        placeholder: formatMessage((0, $e0XMB.default).placeholder)
    });
};
const $ccc78a455db68a11$var$RequestTypeFilterComponent = /*#__PURE__*/ (0, $5uXOq.memo)($ccc78a455db68a11$var$RequestTypeFilter);
$ccc78a455db68a11$var$RequestTypeFilterComponent.displayName = 'RequestTypeFilter';
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<Props>'.
$ccc78a455db68a11$var$RequestTypeFilterComponent.whyDidYouRender = true;
var $ccc78a455db68a11$export$2e2bcd8739ae039 = $ccc78a455db68a11$var$RequestTypeFilterComponent;

});
parcelRegister("e0XMB", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c7eddbc8ad682f0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4c7eddbc8ad682f0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.request-type.label",
        "defaultMessage": "Request type"
    },
    placeholder: {
        "id": "software-filters.filters.request-type.placeholder",
        "defaultMessage": "Search request type filters..."
    }
});

});


parcelRegister("jdA4J", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6cedc5f723f1df5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $96s6B = parcelRequire("96s6B");

var $6TH6s = parcelRequire("6TH6s");
const $b6cedc5f723f1df5$var$SprintFilter = ({ sprints: sprints = [], selectedSprints: selectedSprints = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'sprintFilter rendered', {
            numberOfSprints: sprints.length
        });
    }, [
        createAnalyticsEvent,
        sprints
    ]);
    const values = (0, $5uXOq.useMemo)(()=>sprints.map((sprint)=>({
                label: sprint.name,
                value: sprint.id.toString()
            })), [
        sprints
    ]);
    const onChangeMapValues = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map((entry)=>entry.value), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        label: formatMessage((0, $6TH6s.default).label),
        values: values,
        selectedValues: selectedSprints,
        onChange: onChangeMapValues,
        isNested: isNested,
        placeholder: formatMessage((0, $6TH6s.default).placeholder)
    });
};
const $b6cedc5f723f1df5$var$SprintFilterComponent = /*#__PURE__*/ (0, $5uXOq.memo)($b6cedc5f723f1df5$var$SprintFilter);
$b6cedc5f723f1df5$var$SprintFilterComponent.displayName = 'SprintFilter';
var $b6cedc5f723f1df5$export$2e2bcd8739ae039 = $b6cedc5f723f1df5$var$SprintFilterComponent;

});
parcelRegister("6TH6s", function(module, exports) {

$parcel$export(module.exports, "default", () => $a136882e810c6f5b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a136882e810c6f5b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.sprint.label",
        "defaultMessage": "Sprint"
    },
    placeholder: {
        "id": "software-filters.filters.sprint.placeholder",
        "defaultMessage": "Search sprint filters..."
    }
});

});


parcelRegister("cSFZv", function(module, exports) {

$parcel$export(module.exports, "default", () => $746f8d9f8aa82396$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $aWse0 = parcelRequire("aWse0");

var $g5X3G = parcelRequire("g5X3G");

var $96s6B = parcelRequire("96s6B");

var $5qiVm = parcelRequire("5qiVm");
const $746f8d9f8aa82396$var$StatusCategoryFilter = ({ statusCategories: statusCategories = [], selectedStatusCategories: selectedStatusCategories = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const values = (0, $5uXOq.useMemo)(()=>statusCategories.map(({ id: id, name: name })=>({
                label: name,
                value: id
            })), [
        statusCategories
    ]);
    const onChangeValue = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map(({ value: value })=>(0, $g5X3G.toIssueStatusCategoryId)(value)), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    // early exit if we have only one option
    if (values.length <= 1) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        label: formatMessage((0, $5qiVm.default).label),
        values: values,
        selectedValues: selectedStatusCategories.map(String),
        onChange: onChangeValue,
        isNested: isNested,
        placeholder: formatMessage((0, $5qiVm.default).placeholder)
    });
};
const $746f8d9f8aa82396$var$StatusCategoryFilterComponent = /*#__PURE__*/ (0, $5uXOq.memo)($746f8d9f8aa82396$var$StatusCategoryFilter);
$746f8d9f8aa82396$var$StatusCategoryFilterComponent.displayName = 'StatusCategoryFilter';
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<Props>'.
$746f8d9f8aa82396$var$StatusCategoryFilterComponent.whyDidYouRender = true;
var $746f8d9f8aa82396$export$2e2bcd8739ae039 = $746f8d9f8aa82396$var$StatusCategoryFilterComponent;

});
parcelRegister("5qiVm", function(module, exports) {

$parcel$export(module.exports, "default", () => $16c5f1e62f5bac0b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $16c5f1e62f5bac0b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.status-category.label",
        "defaultMessage": "Status category"
    },
    placeholder: {
        "id": "software-filters.filters.status-category.placeholder",
        "defaultMessage": "Search status category filters..."
    }
});

});


parcelRegister("3f9TT", function(module, exports) {

$parcel$export(module.exports, "default", () => $45ecaaab2e5e2a52$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $koVbs = parcelRequire("koVbs");

var $g5X3G = parcelRequire("g5X3G");

var $96s6B = parcelRequire("96s6B");

var $33ioU = parcelRequire("33ioU");
const $45ecaaab2e5e2a52$var$StatusFilter = ({ statuses: statuses = [], selectedStatuses: selectedStatuses = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const values = (0, $5uXOq.useMemo)(()=>statuses.map(({ id: id, name: name })=>({
                label: name,
                value: id
            })), [
        statuses
    ]);
    const onChangeValue = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map(({ value: value })=>(0, $g5X3G.toIssueStatusId)(value)), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    // early exit if we have only one option
    if (values.length <= 1) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        label: formatMessage((0, $33ioU.default).label),
        values: values,
        selectedValues: selectedStatuses.map(String),
        onChange: onChangeValue,
        isNested: isNested,
        placeholder: formatMessage((0, $33ioU.default).placeholder)
    });
};
const $45ecaaab2e5e2a52$var$StatusFilterComponent = /*#__PURE__*/ (0, $5uXOq.memo)($45ecaaab2e5e2a52$var$StatusFilter);
$45ecaaab2e5e2a52$var$StatusFilterComponent.displayName = 'StatusFilter';
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<Props>'.
$45ecaaab2e5e2a52$var$StatusFilterComponent.whyDidYouRender = true;
var $45ecaaab2e5e2a52$export$2e2bcd8739ae039 = $45ecaaab2e5e2a52$var$StatusFilterComponent;

});
parcelRegister("33ioU", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee3eff355f28d572$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ee3eff355f28d572$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.status.label",
        "defaultMessage": "Status"
    },
    placeholder: {
        "id": "software-filters.filters.status.placeholder",
        "defaultMessage": "Search status filters..."
    }
});

});


parcelRegister("fJnmW", function(module, exports) {

$parcel$export(module.exports, "FilterBar", () => $fcc1c800bf761f9d$export$56a20ec2552ffba2);
$parcel$export(module.exports, "ListFilterContainerNextGen", () => $fcc1c800bf761f9d$export$4a72bd88f9845459);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7XYc4 = parcelRequire("7XYc4");

var $dCm1o = parcelRequire("dCm1o");
const $fcc1c800bf761f9d$export$9ea8cdcfa806101a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswh2mm _4cvr1h6o _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $fcc1c800bf761f9d$export$35dfe29d505ceb8f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _kqswh2mm _4cvr1h6o _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $fcc1c800bf761f9d$export$56a20ec2552ffba2 = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $fcc1c800bf761f9d$export$35dfe29d505ceb8f, $fcc1c800bf761f9d$export$9ea8cdcfa806101a);
const $fcc1c800bf761f9d$export$847557029097218a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jx1txw _1hftutpp _1uf81b66 _1o94h2mm _79vbb3bt _lpsrstnw _9uwn1ssb _41sd7vkz _be5h1i34 _4amot94y _1omzidpf _rhj9dh45",
            __cmplp.className
        ])
    });
});
const $fcc1c800bf761f9d$export$6fe98dc7be67e1c2 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jx1txw _1hftv77o _1uf81b66 _1o94h2mm _yj55idpf",
            __cmplp.className
        ])
    });
});
const $fcc1c800bf761f9d$export$595be9b8d0603674 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jx1txw _1o94h2mm _yj55idpf",
            __cmplp.className
        ])
    });
});
const $fcc1c800bf761f9d$export$4a72bd88f9845459 = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $fcc1c800bf761f9d$export$595be9b8d0603674, $fcc1c800bf761f9d$export$6fe98dc7be67e1c2);

});

parcelRegister("cTi8P", function(module, exports) {

$parcel$export(module.exports, "default", () => $e898d158ecdd3c47$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $4jAPy = parcelRequire("4jAPy");

var $3Qsxg = parcelRequire("3Qsxg");
const $e898d158ecdd3c47$var$AsyncBoardSwitcher = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $3Qsxg.syncBoardSwitcher), {});
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
        return ()=>{
            entryPointActions.unload();
        };
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "plan-increment-board-switcher",
        packageName: (0, $4jAPy.PACKAGE_NAME),
        teamName: (0, $4jAPy.ERROR_REPORTING_TEAM),
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props
    });
};
var $e898d158ecdd3c47$export$2e2bcd8739ae039 = $e898d158ecdd3c47$var$AsyncBoardSwitcher;

});
parcelRegister("3Qsxg", function(module, exports) {

$parcel$export(module.exports, "syncBoardSwitcher", () => $afceff36abed190f$export$e13b401cdb60e3ed);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $afceff36abed190f$export$e13b401cdb60e3ed = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("l0TEb")).then((module)=>module.AsyncBoardSwitcher), {
        moduleId: "2623f17b"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("l0TEb", function(module, exports) {

let $f4c4c36e3598a244$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f4c4c36e3598a244$var$load("ffQaD"),
    $f4c4c36e3598a244$var$load("kvRbA"),
    $f4c4c36e3598a244$var$load("kNFvF"),
    $f4c4c36e3598a244$var$load("6rjtm")
]).then(()=>parcelRequire('2C9Uz'));

});



parcelRegister("fUHZ2", function(module, exports) {

$parcel$export(module.exports, "useShortcutAnalytics", () => $a45625fee4d71e0e$export$cd482f0b72849b2c);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $8zOmE = parcelRequire("8zOmE");
const $a45625fee4d71e0e$export$56c266726b07692d = (createAnalyticsEvent, { id: id, key: key, attributes: attributes }, shortcutSource)=>{
    const attrs = {
        ...attributes,
        key: key,
        shortcutSource: shortcutSource,
        nextGenProject: true
    };
    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
        action: 'pressed',
        actionSubject: 'keyboardShortcut'
    }), id, attrs);
};
const $a45625fee4d71e0e$export$cd482f0b72849b2c = (shortcutSource)=>{
    // Will fix on FF cleanup
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireAnalytics = (0, $5uXOq.useCallback)((payload)=>{
        $a45625fee4d71e0e$export$56c266726b07692d(createAnalyticsEvent, payload, shortcutSource);
    }, [
        createAnalyticsEvent,
        shortcutSource
    ]);
    return fireAnalytics;
};

});

parcelRegister("cM4EP", function(module, exports) {

$parcel$export(module.exports, "default", () => $93fab47741ff1022$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $i2Rm5 = parcelRequire("i2Rm5");

var $kobfu = parcelRequire("kobfu");

var $fZneA = parcelRequire("fZneA");

var $lfTZh = parcelRequire("lfTZh");

var $8zOmE = parcelRequire("8zOmE");
var $5oFIy = parcelRequire("5oFIy");
var $2NMNM = parcelRequire("2NMNM");

var $5a0Nh = parcelRequire("5a0Nh");

var $7Oku1 = parcelRequire("7Oku1");
class $93fab47741ff1022$export$876b3e4acf4df22c extends (0, $5uXOq.Component) {
    static{
        this.getDerivedStateFromError = (error)=>({
                error: error,
                isRelayValidationError: (0, $7Oku1.isRelayValidationError)(error)
            });
    }
    static getDerivedStateFromProps({ customFiltersQueryRef: customFiltersQueryRef }, state) {
        if (state.error && !state.aggErrors && customFiltersQueryRef) {
            const capturedGQLErrorsInfo = (0, $5a0Nh.stopCaptureGraphQlErrors)(customFiltersQueryRef.fetchKey.toString());
            const validGQLErrorsInfo = capturedGQLErrorsInfo.find((err)=>err.meta.operationName === customFiltersQueryRef.name);
            if (validGQLErrorsInfo?.errors.length) return {
                ...state,
                aggErrors: validGQLErrorsInfo.errors,
                aggErrorsMeta: validGQLErrorsInfo.meta
            };
        }
        return null;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null,
            aggErrors: null,
            aggErrorsMeta: null,
            isRelayValidationError: false
        };
    }
    getCommonErrorAttributes(error) {
        return {
            task: 'loadCustomFilters',
            screenName: this.props.screenName,
            isNetworkError: false,
            isRelayValidationError: this.state.isRelayValidationError,
            hash: (0, $kobfu.getErrorHash)(error) ?? '',
            errorMessage: error.message,
            stack: error.stack
        };
    }
    render() {
        const { error: error, aggErrors: aggErrors, aggErrorsMeta: aggErrorsMeta, isRelayValidationError: isRelayValidationError } = this.state;
        const { children: children } = this.props;
        if (!error) return children;
        if (aggErrors?.length) {
            const aggError = new (0, $7Oku1.AGGErrors)(aggErrors, aggErrorsMeta?.requestId);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireOperationalAnalytics), {
                eventName: "ui taskFail",
                attributes: {
                    traceId: aggError.traceId,
                    statusCode: aggError.statusCode,
                    ...this.getCommonErrorAttributes(aggError)
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i2Rm5.ErrorFlagRenderer), {
                id: "custom-filter-dropdown",
                error: aggError
            }));
        }
        if (isRelayValidationError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireOperationalAnalytics), {
            eventName: "ui taskFail",
            attributes: {
                ...this.getCommonErrorAttributes(error)
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i2Rm5.ErrorFlagRenderer), {
            id: "custom-filter-dropdown",
            error: error
        }));
        // If this isn't an AGG or Relay error, let the upper error boundary handle it
        throw error;
    }
}
const $93fab47741ff1022$var$CustomFilterBoundary = (props)=>{
    const { children: children, screenName: screenName } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onError = (_, error)=>{
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskFail', {
            screenName: screenName,
            task: 'loadCustomFilters',
            isNetworkError: (0, $fZneA.isClientFetchError)(error),
            hash: (0, $kobfu.getErrorHash)(error) ?? '',
            errorMessage: error.message
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "custom-filter-dropdown",
        packageName: "software-filters",
        teamName: "a4t-tanuki",
        fallback: "flag",
        extraEventData: {
            screenName: screenName
        },
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($93fab47741ff1022$export$876b3e4acf4df22c, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "custom-filter-boundary",
        fallback: null
    }, children)));
};
var $93fab47741ff1022$export$2e2bcd8739ae039 = $93fab47741ff1022$var$CustomFilterBoundary;

});

parcelRegister("2FvdY", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb1987110dd76b24$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dF9Z3 = parcelRequire("dF9Z3");
const $fb1987110dd76b24$var$HijackBrowserDefaultSearch = ({ onFocusSearch: onFocusSearch, isAnyModalOpen: isAnyModalOpen = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onGlobalSearch = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7031 - Binding element 'event' implicitly has an 'any' type.
    ({ event: event })=>{
        // Do not hijack browser default search when any modal is open
        if (isAnyModalOpen) return;
        // Hijacks default browser search and directs user to search in filter bar
        event.preventDefault();
        onFocusSearch();
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'hijackBrowserDefaultSearch triggered');
    }, [
        createAnalyticsEvent,
        isAnyModalOpen,
        onFocusSearch
    ]);
    (0, $dF9Z3.useGlobalSearch)(onGlobalSearch);
    return null;
};
var $fb1987110dd76b24$export$2e2bcd8739ae039 = $fb1987110dd76b24$var$HijackBrowserDefaultSearch;

});

parcelRegister("kH9yv", function(module, exports) {

$parcel$export(module.exports, "default", () => $333f125f896ef4d8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $5ujeO = parcelRequire("5ujeO");
var $k6T4f = parcelRequire("k6T4f");

var $MHKc7 = parcelRequire("MHKc7");

var $6s1PB = parcelRequire("6s1PB");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dF9Z3 = parcelRequire("dF9Z3");

var $ew9g5 = parcelRequire("ew9g5");

var $gtlfw = parcelRequire("gtlfw");
const $333f125f896ef4d8$var$SearchFilterChangeboarding = ({ children: children, hijackBrowserDefaultSearch: hijackBrowserDefaultSearch = false, screenName: screenName, isCompanyManaged: isCompanyManaged = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isVisible, setIsVisible] = (0, $5uXOq.useState)(false);
    const hasShown = (0, $5uXOq.useRef)(false);
    const onGlobalSearch = (0, $5uXOq.useCallback)(()=>{
        if (!hasShown.current) {
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'searchFilterChangeboarding shown', {
                isHijackBrowserDefaultSearchEnabled: hijackBrowserDefaultSearch
            });
            setIsVisible(true);
            hasShown.current = true;
            if (screenName === 'backlog' || screenName === 'board' || screenName === 'roadmap') (0, $ew9g5.setUserSeenSearchFieldChangeboarding)(screenName);
        }
    }, [
        createAnalyticsEvent,
        hijackBrowserDefaultSearch,
        screenName
    ]);
    const onDismiss = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'searchFilterChangeboarding dismissed', {
            isHijackBrowserDefaultSearchEnabled: hijackBrowserDefaultSearch
        });
        setIsVisible(false);
    }, [
        createAnalyticsEvent,
        hijackBrowserDefaultSearch
    ]);
    const actions = (0, $5uXOq.useMemo)(()=>[
            {
                text: formatMessage((0, $gtlfw.default).changeboardingConfirmButton),
                onClick: onDismiss
            }
        ], [
        formatMessage,
        onDismiss
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const getUserSeenSearchFieldChangeboarding = async ()=>{
            if (screenName === 'backlog' || screenName === 'board' || screenName === 'roadmap') {
                const seen = await (0, $ew9g5.hasUserSeenSearchFieldChangeboarding)(createAnalyticsEvent({}), screenName);
                if (seen) hasShown.current = true;
            }
        };
        getUserSeenSearchFieldChangeboarding();
    }, [
        createAnalyticsEvent,
        hijackBrowserDefaultSearch,
        screenName
    ]);
    const changeBoardingMessage = ()=>{
        const ctrlKey = (0, $dF9Z3.isMacOS)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($333f125f896ef4d8$var$Code, null, "Cmnd") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($333f125f896ef4d8$var$Code, null, "Ctrl");
        return hijackBrowserDefaultSearch ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $gtlfw.default).hijackingDefaultSearchMessage,
            values: {
                key: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($333f125f896ef4d8$var$Code, null, "F"),
                ctrlKey: ctrlKey
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $gtlfw.default).changeboardingMessage,
            values: {
                key: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($333f125f896ef4d8$var$Code, null, "f")
            }
        });
    };
    let spotlightCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ujeO.default), {
        actions: actions,
        width: 300
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), null, changeBoardingMessage()));
    if (isCompanyManaged) spotlightCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ujeO.default), {
        heading: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $gtlfw.default).changeboardingUifMessageHeadingIssueTermRefresh : (0, $gtlfw.default).changeboardingUifMessageHeading),
        actions: actions,
        width: 300
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), null, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $gtlfw.default).changeboardingUifMessageIssueTermRefresh : (0, $gtlfw.default).changeboardingUifMessage)));
    (0, $dF9Z3.useGlobalSearch)(onGlobalSearch);
    if (isVisible) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($333f125f896ef4d8$var$ChangeboardingContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($333f125f896ef4d8$var$Pulse, null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($333f125f896ef4d8$var$SpolightCardContainer, null, spotlightCard));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
var $333f125f896ef4d8$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $333f125f896ef4d8$var$SearchFilterChangeboarding;
const $333f125f896ef4d8$var$Pulse = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $k6T4f.Pulse), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1pbyowjs",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $333f125f896ef4d8$var$ChangeboardingContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});
const $333f125f896ef4d8$var$spotlightAnimation = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $333f125f896ef4d8$var$SpolightCardContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y44v18t4 _kqswstnw _1pbyowjs _19pku2gc _tzy4idpf _o5724jg8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $333f125f896ef4d8$var$Code = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "code", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _2rko1l7b _bfhk1bhr _syaz1fxt _1e0c1nu9 _1reo1wug _o5721jtm _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ew9g5", function(module, exports) {

$parcel$export(module.exports, "hasUserSeenSearchFieldChangeboarding", () => $f70c479b04e71cf2$export$b5010e3edd313ae1);
$parcel$export(module.exports, "setUserSeenSearchFieldChangeboarding", () => $f70c479b04e71cf2$export$fba51361338c8f18);

var $i205g = parcelRequire("i205g");

var $8zOmE = parcelRequire("8zOmE");
const $f70c479b04e71cf2$var$changeboardingFlags = {
    board: 'jsw.filters.board.search-field-changeboarding.shown',
    backlog: 'jsw.filters.backlog.search-field-changeboarding.shown'
};
const $f70c479b04e71cf2$var$CHANGEBOARDING_TTL_SEEN = 31536000000; // ~ 365 days
const $f70c479b04e71cf2$export$b5010e3edd313ae1 = (analyticsEvent, screenName)=>(0, $i205g.getFlags)({
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly board: "jsw.filters.board.search-field-changeboarding.shown"; readonly backlog: "jsw.filters.backlog.search-field-changeboarding.shown"; }'.
        [$f70c479b04e71cf2$var$changeboardingFlags[screenName]]: {}
    })// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly board: "jsw.filters.board.search-field-changeboarding.shown"; readonly backlog: "jsw.filters.backlog.search-field-changeboarding.shown"; }'.
    .then((res)=>res[$f70c479b04e71cf2$var$changeboardingFlags[screenName]].status).catch(()=>{
        (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'searchFilterChangeboarding checkSeenFailed');
        return false;
    });
const $f70c479b04e71cf2$export$fba51361338c8f18 = (screenName)=>(0, $i205g.setFlag)($f70c479b04e71cf2$var$changeboardingFlags[screenName], $f70c479b04e71cf2$var$CHANGEBOARDING_TTL_SEEN);

});
parcelRegister("i205g", function(module, exports) {

$parcel$export(module.exports, "getFlags", () => $2e5c55e74efea073$export$d5815430bcc75df0);
$parcel$export(module.exports, "setFlag", () => $2e5c55e74efea073$export$5e165df1e30a1331);

var $dPSWJ = parcelRequire("dPSWJ");

var $sLb2Q = parcelRequire("sLb2Q");

var $4Pf62 = parcelRequire("4Pf62");

var $1nokx = parcelRequire("1nokx");

var $7UyIQ = parcelRequire("7UyIQ");
const $2e5c55e74efea073$export$442e3330dfabd1f5 = 3600000; // 1 hour
const $2e5c55e74efea073$export$4d45fa66d41a8ca9 = 2592000000; // ~1 month
const $2e5c55e74efea073$export$d5815430bcc75df0 = async (request)=>{
    const { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const flagKeys = Object.keys(request);
    const retrieveFlagKeysLookup = (0, (/*@__PURE__*/$parcel$interopDefault($sLb2Q)))(flagKeys);
    if (!atlassianAccountId || isAnonymous) return (0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(retrieveFlagKeysLookup, ()=>({
            status: true,
            lastSeenDate: null
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const flags = {};
    if (0, $7UyIQ.default) flagKeys.forEach((flagKey)=>{
        // @ts-expect-error - Object is possibly 'null'.
        const value = (0, $7UyIQ.default).get(flagKey);
        if (value) {
            delete retrieveFlagKeysLookup[flagKey];
            flags[flagKey] = value;
        }
    });
    const retrieveFlagKeys = Object.keys(retrieveFlagKeysLookup);
    if (retrieveFlagKeys.length > 0) Object.assign(flags, await (0, $1nokx.getFlags)(atlassianAccountId, retrieveFlagKeys));
    if (0, $7UyIQ.default) {
        const now = Date.now();
        retrieveFlagKeys.forEach((flagKey)=>{
            // Not sure whats going wrong here - but i assume `apiGetFlags` may not always return all `retrieveFalgKeys`
            // and so `flags[flagKey]` can be undefined - so we have to guard against it
            if (!flags[flagKey]) return;
            const { status: status } = flags[flagKey];
            const ttlNotSeen = request[flagKey].ttlNotSeen || $2e5c55e74efea073$export$442e3330dfabd1f5;
            const ttlSeen = request[flagKey].ttlSeen || $2e5c55e74efea073$export$4d45fa66d41a8ca9;
            // @ts-expect-error - TS2531: Object is possibly 'null'.
            (0, $7UyIQ.default).set(flagKey, flags[flagKey], now + (status ? ttlSeen : ttlNotSeen));
        });
    }
    return flags;
};
const $2e5c55e74efea073$export$5e165df1e30a1331 = async (flagKey, ttl = $2e5c55e74efea073$export$4d45fa66d41a8ca9)=>{
    const { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    if (!atlassianAccountId || isAnonymous) return;
    if (0, $7UyIQ.default) {
        const value = (0, $7UyIQ.default).get(flagKey);
        if (value && value.status) return;
        const now = new Date();
        (0, $7UyIQ.default).set(flagKey, {
            status: true,
            lastSeenDate: now.toISOString()
        }, now.getTime() + ttl);
    }
    await (0, $1nokx.setFlag)(atlassianAccountId, flagKey);
};

});
parcelRegister("1nokx", function(module, exports) {

$parcel$export(module.exports, "setFlag", () => $4c27c5726c27889e$export$5e165df1e30a1331);
$parcel$export(module.exports, "getFlags", () => $4c27c5726c27889e$export$d5815430bcc75df0);

var $dPSWJ = parcelRequire("dPSWJ");

var $jJZqs = parcelRequire("jJZqs");
const $4c27c5726c27889e$export$c1f083639d344e75 = 'https://have-i-seen-it.us-east-1.prod.public.atl-paas.net';
const $4c27c5726c27889e$export$5e165df1e30a1331 = (userKey, flagKey)=>{
    const data = {
        userKey: userKey,
        flagKey: flagKey
    };
    return fetch(`${$4c27c5726c27889e$export$c1f083639d344e75}/flag`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }).then((response)=>{
        if (!response.ok) throw new (0, $jJZqs.default)(response.status, response.statusText);
        return undefined;
    });
};
const $4c27c5726c27889e$var$convertToDates = (response)=>(0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(response, ({ status: status, lastSeenDate: lastSeenDate })=>({
            status: status,
            lastSeenDate: lastSeenDate ? new Date(lastSeenDate) : null
        }));
const $4c27c5726c27889e$export$d5815430bcc75df0 = (userKey, flagKeys)=>{
    const params = new URLSearchParams();
    flagKeys.forEach((flagKey)=>params.append('flagKey', flagKey));
    params.append('userKey', userKey);
    return fetch(`${$4c27c5726c27889e$export$c1f083639d344e75}/flags?${params.toString()}`).then((response)=>{
        if (!response.ok) throw new (0, $jJZqs.default)(response.status, response.statusText);
        return response.json();
    }).then((response)=>$4c27c5726c27889e$var$convertToDates(response));
};

});

parcelRegister("7UyIQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $158da724691281b4$export$2e2bcd8739ae039);

var $eNf8a = parcelRequire("eNf8a");

var $4Pf62 = parcelRequire("4Pf62");

var $2YZCu = parcelRequire("2YZCu");
/**
 * Return an ExpirableStorage to be used with the "have i seen it" service.
 *
 * If the user is anonymous, return null.
 */ const $158da724691281b4$var$createStorage = ()=>{
    let storage = null;
    try {
        let context;
        try {
            context = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            return storage;
        }
        const { atlassianAccountId: atlassianAccountId } = context;
        if (atlassianAccountId) storage = (0, $eNf8a.createSessionExpirableStorageProvider)(`have-i-seen-it-${atlassianAccountId.replace(/:/g, '_')}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('have-i-seen-it.storage', 'Failed to initialize storage.');
    }
    return storage;
};
var $158da724691281b4$export$2e2bcd8739ae039 = $158da724691281b4$var$createStorage();

});



parcelRegister("gtlfw", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e167f73d4db9857$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8e167f73d4db9857$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    changeboardingMessage: {
        "id": "software-filters.search-filter-changeboarding.changeboarding-message",
        "defaultMessage": "For quick access to search, use {key} on your keyboard anywhere in Jira. It takes you directly to the search field."
    },
    changeboardingUifMessageHeading: {
        "id": "software-filters.search-filter-changeboarding.changeboarding-uif-message-heading",
        "defaultMessage": "Search for an issue"
    },
    changeboardingUifMessage: {
        "id": "software-filters.search-filter-changeboarding.changeboarding-uif-message",
        "defaultMessage": "The backlog loads issues as you scroll to help increase performance. If you struggle to find results using a keyboard shortcut, try entering the keyword here instead."
    },
    hijackingDefaultSearchMessage: {
        "id": "software-filters.search-filter-changeboarding.hijacking-default-search-message",
        "defaultMessage": "{ ctrlKey } + { key } takes you directly to the search field, just like keyboard shortcut { key }. Both shortcuts give you quick access to our optimized search."
    },
    changeboardingConfirmButton: {
        "id": "software-filters.search-filter-changeboarding.changeboarding-confirm-button",
        "defaultMessage": "OK"
    },
    changeboardingUifMessageHeadingIssueTermRefresh: {
        "id": "software-filters.search-filter-changeboarding.changeboarding-uif-message-heading-issue-term-refresh",
        "defaultMessage": "Search for a work item"
    },
    changeboardingUifMessageIssueTermRefresh: {
        "id": "software-filters.search-filter-changeboarding.changeboarding-uif-message-issue-term-refresh",
        "defaultMessage": "The backlog loads work items as you scroll to help increase performance. If you struggle to find results using a keyboard shortcut, try entering the keyword here instead."
    }
});

});


parcelRegister("bBMqL", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf4b1c241e667722$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");
const $cf4b1c241e667722$var$VersionFilterRelayBoundary = ({ fallback: fallback = null, children: children, screenName: screenName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "version-filter-relay-dropdown",
        packageName: "software-filters",
        teamName: "a4t-tanuki",
        fallback: "flag",
        extraEventData: {
            screenName: screenName
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "version-filter-relay-boundary",
        fallback: fallback
    }, children));
var $cf4b1c241e667722$export$2e2bcd8739ae039 = $cf4b1c241e667722$var$VersionFilterRelayBoundary;

});

parcelRegister("l38sT", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c71ac6a8ffa9b82$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4c71ac6a8ffa9b82$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    textFilter: {
        "id": "software-filters.stateless.text-filter",
        "defaultMessage": "Filter issues"
    },
    screenReaderInstruction: {
        "id": "software-filters.stateless.screen-reader-instruction",
        "defaultMessage": "Results will be filtered below as you type to search or apply filters."
    },
    screenReaderInstructionForFilters: {
        "id": "software-filters.stateless.screen-reader-instruction-for-filters",
        "defaultMessage": "Content below has been updated"
    },
    searchCurrentPage: {
        "id": "software-filters.stateless.search-current-page",
        "defaultMessage": "Search on current page"
    },
    goToSection: {
        "id": "software-filters.stateless.go-to-section",
        "defaultMessage": "Go to"
    },
    unassignedAssigneeDisplayName: {
        "id": "software-filters.stateless.unassigned-assignee-display-name",
        "defaultMessage": "Unassigned"
    },
    unassignedVersionLabel: {
        "id": "software-filters.stateless.unassigned-version-label",
        "defaultMessage": "Issues without version"
    },
    unassignedLabelLabel: {
        "id": "software-filters.stateless.unassigned-label-label",
        "defaultMessage": "Issues without label"
    },
    unassignedComponentLabel: {
        "id": "software-filters.stateless.unassigned-component-label",
        "defaultMessage": "Issues without component"
    },
    textFilterIssueTermRefresh: {
        "id": "software-filters.stateless.text-filter-issue-term-refresh",
        "defaultMessage": "Filter work items"
    },
    unassignedVersionLabelIssueTermRefresh: {
        "id": "software-filters.stateless.unassigned-version-label-issue-term-refresh",
        "defaultMessage": "Work items without version"
    },
    unassignedLabelLabelIssueTermRefresh: {
        "id": "software-filters.stateless.unassigned-label-label-issue-term-refresh",
        "defaultMessage": "Work items without label"
    },
    unassignedComponentLabelIssueTermRefresh: {
        "id": "software-filters.stateless.unassigned-component-label-issue-term-refresh",
        "defaultMessage": "Work items without component "
    }
});

});

parcelRegister("649U3", function(module, exports) {

$parcel$export(module.exports, "getManageCustomFiltersUrl", () => $224b64cdfcbfd0e3$export$84a62bf03b005a81);

var $e5wyW = parcelRequire("e5wyW");

var $4R6GH = parcelRequire("4R6GH");
const $224b64cdfcbfd0e3$export$84a62bf03b005a81 = (0, $e5wyW.functionWithCondition)(()=>// This is temporary - cleanup is scheduled for next week:
    // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4R6GH.fg)('blu-7261-change-blu-5799-to-support-nav3') && (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route'), $224b64cdfcbfd0e3$var$getManageCustomFiltersUrlNew, $224b64cdfcbfd0e3$var$getManageCustomFiltersUrlOld);
function $224b64cdfcbfd0e3$var$getManageCustomFiltersUrlNew(projectKey, boardId, isCompanyManaged, isUserBoard, isJSMBoard, // For testing purposes
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
pathname = window.location.pathname) {
    const NEW_SETTINGS_PATH = '/settings/quickFilters';
    if (isJSMBoard) // JSM Boards use their usual URL all the time.
    return `/jira/servicedesk/projects/${projectKey}/boards/${boardId}?config=quickFilters`;
    if (isCompanyManaged) {
        if (isUserBoard) return pathname.endsWith('/backlog') ? `${pathname.replace('/backlog', '')}${NEW_SETTINGS_PATH}?from-backlog=1` : `${pathname}${NEW_SETTINGS_PATH}`;
        return `/jira/software/c/projects/${projectKey}/boards/${boardId}${NEW_SETTINGS_PATH}${pathname.endsWith('backlog') ? '?from-backlog=1' : ''}`;
    }
    return `/jira/software/projects/${projectKey}/settings/boards/${boardId}/custom-filters`;
}
function $224b64cdfcbfd0e3$var$getManageCustomFiltersUrlOld(projectKey, boardId, isCompanyManaged, isUserBoard, isJSMBoard, // For testing purposes
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
pathname = window.location.pathname) {
    if (isJSMBoard) return `/jira/servicedesk/projects/${projectKey}/boards/${boardId}?config=quickFilters`;
    if (isCompanyManaged) {
        if (isUserBoard) return `${pathname}?config=quickFilters`;
        return `/jira/software/c/projects/${projectKey}/boards/${boardId}${pathname.endsWith('backlog') ? '/backlog' : ''}?config=quickFilters`;
    }
    return `/jira/software/projects/${projectKey}/settings/boards/${boardId}/custom-filters`;
}

});


parcelRegister("361on", function(module, exports) {

$parcel$export(module.exports, "getNormalizedFilters", () => $d5949234e82f3596$export$459be3406d78c3a5);
$parcel$export(module.exports, "onFilterChangeStartInteraction", () => $d5949234e82f3596$export$568db3ec08ca631b);

var $7uUwQ = parcelRequire("7uUwQ");

var $gccSB = parcelRequire("gccSB");

const $d5949234e82f3596$export$459be3406d78c3a5 = (filters)=>{
    const chainedFilters = (0, $7uUwQ.chain)({}).setIn([
        (0, $15a528573ccd89ae$export$d597759d33be802e)
    ], filters[0, $15a528573ccd89ae$export$d597759d33be802e] ? filters[0, $15a528573ccd89ae$export$d597759d33be802e] : undefined).setIn([
        (0, $15a528573ccd89ae$export$37aee82a3cb1e8f7)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$37aee82a3cb1e8f7]) ? filters[0, $15a528573ccd89ae$export$37aee82a3cb1e8f7] : undefined).setIn([
        (0, $15a528573ccd89ae$export$2a4f270075a033de)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$2a4f270075a033de]) ? filters[0, $15a528573ccd89ae$export$2a4f270075a033de] : undefined).setIn([
        (0, $15a528573ccd89ae$export$f8f7545d2bb78afb)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$f8f7545d2bb78afb]) ? filters[0, $15a528573ccd89ae$export$f8f7545d2bb78afb] : undefined).setIn([
        (0, $15a528573ccd89ae$export$ebb48b08205007c5)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$ebb48b08205007c5]) ? filters[0, $15a528573ccd89ae$export$ebb48b08205007c5] : undefined).setIn([
        (0, $15a528573ccd89ae$export$a4ad2735b021c132)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$a4ad2735b021c132]) ? filters[0, $15a528573ccd89ae$export$a4ad2735b021c132] : undefined).setIn([
        (0, $15a528573ccd89ae$export$a316570a0dbfd2b0)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$a316570a0dbfd2b0]) ? filters[0, $15a528573ccd89ae$export$a316570a0dbfd2b0] : undefined).setIn([
        (0, $15a528573ccd89ae$export$92ab80c1dc9baf44)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$92ab80c1dc9baf44]) ? filters[0, $15a528573ccd89ae$export$92ab80c1dc9baf44] : undefined).setIn([
        (0, $15a528573ccd89ae$export$e50006273435e7d4)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$e50006273435e7d4]) ? filters[0, $15a528573ccd89ae$export$e50006273435e7d4] : undefined).setIn([
        (0, $15a528573ccd89ae$export$68d693c35a8d8866)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$68d693c35a8d8866]) ? filters[0, $15a528573ccd89ae$export$68d693c35a8d8866] : undefined).setIn([
        (0, $15a528573ccd89ae$export$f863b019d19144f4)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$f863b019d19144f4]) ? filters[0, $15a528573ccd89ae$export$f863b019d19144f4] : undefined).setIn([
        (0, $15a528573ccd89ae$export$401f4b6eda6a369c)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$401f4b6eda6a369c]) ? filters[0, $15a528573ccd89ae$export$401f4b6eda6a369c] : undefined).setIn([
        (0, $15a528573ccd89ae$export$db362e2d293fe52e)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$db362e2d293fe52e]) ? filters[0, $15a528573ccd89ae$export$db362e2d293fe52e] : undefined);
    return chainedFilters.value();
};
const $d5949234e82f3596$export$568db3ec08ca631b = (filterType, onChangeInteractionStart, onCustomFilterChangeInteractionStart)=>{
    if (filterType === (0, $15a528573ccd89ae$export$68d693c35a8d8866)) onCustomFilterChangeInteractionStart();
    else onChangeInteractionStart();
};

});


parcelRegister("eY43C", function(module, exports) {

$parcel$export(module.exports, "setInteractionFeedbackMark", () => $4fd2e97bfd321407$export$2a56340540433ea3);
$parcel$export(module.exports, "setInteractionStartMark", () => $4fd2e97bfd321407$export$1da8f59ae62c0e17);

var $8hVbJ = parcelRequire("8hVbJ");
const $4fd2e97bfd321407$export$2a56340540433ea3 = ()=>{
    (0, $8hVbJ.filterInteraction).mark('feedback');
};
const $4fd2e97bfd321407$export$1da8f59ae62c0e17 = ()=>{
    (0, $8hVbJ.filterInteraction).start();
};

});

parcelRegister("5jOz5", function(module, exports) {

$parcel$export(module.exports, "BacklogCustomFilter", () => $0c38389865ba77d9$export$34fa6a8efdb70dd8);

var $5uXOq = parcelRequire("5uXOq");

var $9vASA = parcelRequire("9vASA");

var $a4XJc = parcelRequire("a4XJc");

var $9pP0g = parcelRequire("9pP0g");

var $iDGXn = parcelRequire("iDGXn");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $l9VFH = parcelRequire("l9VFH");

var $fSgHa = parcelRequire("fSgHa");

var $dGljH = parcelRequire("dGljH");

var $fzMlf = parcelRequire("fzMlf");
const $0c38389865ba77d9$var$BacklogCustomFilterRedux = (props)=>{
    const boardId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getRapidViewId));
    const filters = (0, $c1MAf.useBacklogSelector)((0, $l9VFH.getCMPFilters));
    const showPanelToggle = props.isCompanyManaged;
    const isFilterBarVisible = (0, $iDGXn.useShowQuickFilters)();
    const { toggleViewSetting: toggleViewSetting } = (0, $iDGXn.useViewSettingsActions)();
    const onToggleIsFilterBarVisible = (0, $5uXOq.useCallback)(()=>{
        if (boardId) toggleViewSetting({
            boardId: Number(boardId),
            view: (0, $a4XJc.View).BACKLOG,
            setting: (0, $9pP0g.ViewSetting).QUICK_FILTERS
        });
    }, [
        boardId,
        toggleViewSetting
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9vASA.default), {
        ...props,
        filters: filters,
        isPanelToggleChecked: isFilterBarVisible,
        onTogglePanel: onToggleIsFilterBarVisible,
        showPanelToggle: showPanelToggle
    });
};
const $0c38389865ba77d9$export$34fa6a8efdb70dd8 = (props)=>{
    const isCMPBoard = (0, $fSgHa.useIsCMPBacklog)();
    const cardCount = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCardsCount));
    if (isCMPBoard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0c38389865ba77d9$var$BacklogCustomFilterRedux, {
        ...props,
        isCompanyManaged: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fzMlf.BacklogCustomFilterRelay), {
        ...props,
        isTriggerDisabled: cardCount >= 5000
    });
};

});
parcelRegister("9vASA", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c0f814f674e18a1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $koVbs = parcelRequire("koVbs");

var $14uhY = parcelRequire("14uhY");

var $4R6GH = parcelRequire("4R6GH");

var $96s6B = parcelRequire("96s6B");

var $78uGw = parcelRequire("78uGw");
const $0c0f814f674e18a1$var$MAX_SELECTION_ALLOWED = 10;
const $0c0f814f674e18a1$var$CustomFilter = ({ filters: filters = [], selectedFilters: selectedFilters = [], showLink: showLink = false, manageUrl: manageUrl = '', onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isNested: isNested = false, isCompanyManaged: isCompanyManaged = false, isPanelToggleChecked: isPanelToggleChecked = false, onTogglePanel: onTogglePanel = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), removeOuterPadding: removeOuterPadding = false, showPanelToggle: showPanelToggle = false, shouldReturnFocus: shouldReturnFocus, isTriggerDisabled: isTriggerDisabled = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const values = (0, $5uXOq.useMemo)(()=>filters.map((filter)=>({
                label: filter.name,
                value: filter.id
            })), [
        filters
    ]);
    const onChangeMapValues = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map((entry)=>entry.value), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    const maxSelectionReachedTooltip = formatMessage((0, $78uGw.default).maxSelectionReachedTooltip, {
        maxSelectionAllowed: $0c0f814f674e18a1$var$MAX_SELECTION_ALLOWED
    });
    const onLinkItemClick = (0, $5uXOq.useCallback)(()=>{
        (0, $14uhY.setReturnToProjectUrl)();
    }, []);
    const filterLabel = isCompanyManaged ? (0, $78uGw.default).labelCmp : (0, $78uGw.default).label;
    const manageLinkTitle = isCompanyManaged ? (0, $78uGw.default).manageLinkTitleCmp : (0, $78uGw.default).manageLinkTitle;
    const toggleLabel = isCompanyManaged ? formatMessage((0, $78uGw.default).toggleLabelCmp) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        isTriggerDisabled: isTriggerDisabled && (0, $4R6GH.fg)('tnk_disable_custom_filter_when_there_are_5k_issues'),
        shouldReturnFocus: shouldReturnFocus,
        buttonType: "QuickFilters",
        "data-testid": "filters.ui.filters.custom.assignee-filter",
        label: formatMessage(filterLabel),
        values: values,
        selectedValues: selectedFilters,
        onChange: onChangeMapValues,
        showLink: showLink,
        url: manageUrl,
        useHrefForUrl: isCompanyManaged,
        linkTitle: formatMessage(manageLinkTitle),
        maxSelectionAllowed: isCompanyManaged ? undefined : $0c0f814f674e18a1$var$MAX_SELECTION_ALLOWED,
        maxSelectionReachedTooltip: maxSelectionReachedTooltip,
        isNested: isNested,
        onLinkItemClick: onLinkItemClick,
        showPanelToggle: showPanelToggle,
        onTogglePanel: onTogglePanel,
        isPanelToggleChecked: isPanelToggleChecked,
        toggleLabel: toggleLabel,
        removeOuterPadding: removeOuterPadding,
        placeholder: formatMessage(isCompanyManaged ? (0, $78uGw.default).placeholderCmp : (0, $78uGw.default).placeholder),
        shouldCloseMenuOnTab: showPanelToggle ? false : undefined
    });
};
const $0c0f814f674e18a1$var$CustomFilterComponent = /*#__PURE__*/ (0, $5uXOq.memo)($0c0f814f674e18a1$var$CustomFilter);
$0c0f814f674e18a1$var$CustomFilterComponent.displayName = 'CustomFilter';
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<Props>'.
$0c0f814f674e18a1$var$CustomFilterComponent.whyDidYouRender = true;
var $0c0f814f674e18a1$export$2e2bcd8739ae039 = $0c0f814f674e18a1$var$CustomFilterComponent;

});
parcelRegister("78uGw", function(module, exports) {

$parcel$export(module.exports, "default", () => $cad440f119fd51b3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cad440f119fd51b3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.custom.label",
        "defaultMessage": "Custom filters"
    },
    placeholder: {
        "id": "software-filters.filters.custom.placeholder",
        "defaultMessage": "Search custom filters..."
    },
    labelCmp: {
        "id": "software-filters.filters.custom.label-cmp",
        "defaultMessage": "Quick filters"
    },
    placeholderCmp: {
        "id": "software-filters.filters.custom.placeholder-cmp",
        "defaultMessage": "Search quick filters..."
    },
    manageLinkTitle: {
        "id": "software-filters.filters.custom.manage-link-title",
        "defaultMessage": "Manage custom filters"
    },
    manageLinkTitleCmp: {
        "id": "software-filters.filters.custom.manage-link-title-cmp",
        "defaultMessage": "Manage quick filters"
    },
    maxSelectionReachedTooltip: {
        "id": "software-filters.filters.custom.max-selection-reached-tooltip",
        "defaultMessage": "You can't select more than {maxSelectionAllowed} custom filters"
    },
    toggleLabelCmp: {
        "id": "software-filters.filters.custom.toggle-label-cmp",
        "defaultMessage": "Show quick filters"
    }
});

});


parcelRegister("fzMlf", function(module, exports) {

$parcel$export(module.exports, "BacklogCustomFilterRelay", () => $d6b373cf7fd65a0f$export$bb99cea1633822a7);

var $aYacW = parcelRequire("aYacW");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $3bDjY = parcelRequire("3bDjY");

var $05fhZ = parcelRequire("05fhZ");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $39ypj = parcelRequire("39ypj");
const $d6b373cf7fd65a0f$export$bb99cea1633822a7 = ({ customFiltersQueryRef: customFiltersQueryRef, ...props })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const customFiltersFragmentRef = (0, $8Uumt.usePreloadedQuery)((0, $aYacW.default), customFiltersQueryRef);
    if (props?.isTriggerDisabled && (0, $4R6GH.fg)('tnk_disable_custom_filter_when_there_are_5k_issues')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $39ypj.default).hasReachedLimitLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $05fhZ.default), {
        customFiltersFragmentRef: customFiltersFragmentRef,
        ...props,
        isTriggerDisabled: true
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $05fhZ.default), {
        customFiltersFragmentRef: customFiltersFragmentRef,
        ...props
    });
};

});
parcelRegister("05fhZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $17d2b93146d18158$export$2e2bcd8739ae039);

var $fKrqu = parcelRequire("fKrqu");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $9vASA = parcelRequire("9vASA");

var $5oFIy = parcelRequire("5oFIy");
const $17d2b93146d18158$var$CustomFilterRelay = ({ customFiltersFragmentRef: customFiltersFragmentRef, screenName: screenName, ...props })=>{
    const { boardScope: boardScope } = (0, $8Uumt.useFragment)((0, $fKrqu.default), customFiltersFragmentRef);
    // each item in an array is nullable & an object's keys readonly in relay's generated type
    const filters = (0, $5uXOq.useMemo)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ()=>boardScope?.customFilters.filter(Boolean) || [], [
        boardScope?.customFilters
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9vASA.default), {
        ...props,
        filters: filters
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireOperationalAnalytics), {
        actionSubject: "ui",
        action: "taskSuccess",
        attributes: {
            screenName: screenName,
            task: 'loadCustomFilters',
            customFiltersCount: filters.length
        }
    }));
};
var $17d2b93146d18158$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($17d2b93146d18158$var$CustomFilterRelay);

});
parcelRegister("fKrqu", function(module, exports) {

$parcel$export(module.exports, "default", () => $d300f59e5c1532b6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<27f6e515959b3fa71c98f3b9ea403490>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d300f59e5c1532b6$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }
    ],
    "kind": "Fragment",
    "name": "customFilter_softwareFilters_CustomFilterRelay",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "boardId",
                        "variableName": "boardId"
                    }
                ],
                "concreteType": "BoardScope",
                "kind": "LinkedField",
                "name": "boardScope",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "CustomFilter",
                            "kind": "LinkedField",
                            "name": "customFilters",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "id"
                                    },
                                    "action": "THROW",
                                    "path": "boardScope.customFilters.id"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "name"
                                    },
                                    "action": "THROW",
                                    "path": "boardScope.customFilters.name"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "boardScope.customFilters"
                    }
                ]
            },
            "action": "THROW",
            "path": "boardScope"
        }
    ],
    "type": "Query"
};
$d300f59e5c1532b6$var$node.hash = "ae7389daa2b7626fc0f4f542c785e41f";
var $d300f59e5c1532b6$export$2e2bcd8739ae039 = $d300f59e5c1532b6$var$node;

});


parcelRegister("39ypj", function(module, exports) {

$parcel$export(module.exports, "default", () => $c48f0aac940b0789$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c48f0aac940b0789$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    hasReachedLimitLabel: {
        "id": "software-backlog.header.controls-bar.filter-bar.custom-filters.has-reached-limit-label",
        "defaultMessage": "Custom filters is disabled because you have reached the maximum limit of 5000 work items"
    }
});

});



parcelRegister("37oMw", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0ad209fbaa07e5f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e0ad209fbaa07e5f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    unassigned: {
        "id": "backlog.header.controls-bar.filter-bar.unassigned",
        "defaultMessage": "Issues without {target}"
    },
    textFilter: {
        "id": "backlog.header.controls-bar.filter-bar.text-filter",
        "defaultMessage": "Search"
    },
    filterPlaceholder: {
        "id": "backlog.header.controls-bar.filter-bar.filter-placeholder",
        "defaultMessage": "Search backlog"
    },
    unassignedIssueTermRefresh: {
        "id": "backlog.header.controls-bar.filter-bar.unassigned-issue-term-refresh",
        "defaultMessage": "No {target}"
    }
});

});

parcelRegister("lLAmg", function(module, exports) {

$parcel$export(module.exports, "useIssueTypes", () => $220289fc31d94b44$export$8bbc5cc35915a21b);

var $5uXOq = parcelRequire("5uXOq");

var $g4tDr = parcelRequire("g4tDr");
const $220289fc31d94b44$export$8bbc5cc35915a21b = (issueTypes)=>(0, $5uXOq.useMemo)(()=>{
        if (!issueTypes || !issueTypes.length) return issueTypes;
        return issueTypes.filter((issueType)=>issueType.typeHierarchyLevel !== (0, $g4tDr.EPIC_PARENT_HIERARCHY_TYPE) && issueType.typeHierarchyLevel !== (0, $g4tDr.CHILD_HIERARCHY_TYPE));
    }, [
        issueTypes
    ]);

});



parcelRegister("7ml2y", function(module, exports) {

$parcel$export(module.exports, "ControlsBar", () => $55602d07891954d1$export$9b3bbae461092bf8);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gccSB = parcelRequire("gccSB");

var $c0aEF = parcelRequire("c0aEF");

var $3HwlS = parcelRequire("3HwlS");

var $2ZySJ = parcelRequire("2ZySJ");

var $a4XJc = parcelRequire("a4XJc");

var $iDGXn = parcelRequire("iDGXn");

var $jB6yt = parcelRequire("jB6yt");

var $38RF4 = parcelRequire("38RF4");

var $8vM1G = parcelRequire("8vM1G");

var $k9JTq = parcelRequire("k9JTq");

var $f6RVN = parcelRequire("f6RVN");


var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $9Pc1U = parcelRequire("9Pc1U");

var $le1bQ = parcelRequire("le1bQ");

var $czw5V = parcelRequire("czw5V");

var $c060Z = parcelRequire("c060Z");

var $bONT7 = parcelRequire("bONT7");

var $dvM2i = parcelRequire("dvM2i");
const $55602d07891954d1$export$9b3bbae461092bf8 = (props)=>{
    const { isBacklogWithSprints: isBacklogWithSprints, rapidViewId: rapidViewId, FilterBar: FilterBar, onTogglePanel: onTogglePanel, customFiltersQueryRef: customFiltersQueryRef, versionFilterRelayQueryRef: versionFilterRelayQueryRef, isClassic: isClassic, showEpicAsPanel: showEpicAsPanel, isVersionsEnabled: isVersionsEnabled, onSubtasksExpandAll: onSubtasksExpandAll, onSubtasksCollapseAll: onSubtasksCollapseAll } = props;
    const isCompanyManaged = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
    const config = (0, $c1MAf.useBacklogSelector)((0, $9Pc1U.getConfig));
    const isDataLoaded = (0, $c1MAf.useBacklogSelector)((0, $9Pc1U.isCriticalDataLoaded));
    const epicCustomName = config.hierarchyNomenclature?.firstLevelName;
    const appEditions = (0, $k9JTq.useAppEditions)();
    const handleOnToggle = (0, $5uXOq.useCallback)((panelType)=>{
        onTogglePanel(panelType);
    }, [
        onTogglePanel
    ]);
    const handleViewSettingPanelToggle = (0, $5uXOq.useCallback)(()=>{
        onTogglePanel((0, $c35fd6591a78fffe$export$ba1da943283b9900));
    }, [
        onTogglePanel
    ]);
    const isInsightsOpen = (0, $czw5V.useIsInsightsPanelOpen)();
    const isViewSettingPanelOpen = (0, $c060Z.useIsViewSettingsPanelOpen)();
    const isFilterSelectionBarOpen = (0, $iDGXn.useShowQuickFilters)();
    const showFilterBarToggle = isCompanyManaged;
    const allCardGroups = (0, $le1bQ.useAllCardGroups)();
    const shouldShowSubtasks = (0, $5uXOq.useMemo)(()=>!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(allCardGroups), [
        allCardGroups
    ]);
    const isDueDateEnabled = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasDueDate));
    const hasCardsWithStoryPoint = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasStoryPoints));
    const hasCardsWithEstimate = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasEstimates));
    const hasCardsWithPriority = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasPriority));
    const areAllSubtasksExpanded = (0, $5uXOq.useMemo)(()=>allCardGroups.every((card)=>!card.isCollapsed), [
        allCardGroups
    ]);
    const areAllSubtasksCollapsed = (0, $5uXOq.useMemo)(()=>allCardGroups.every((card)=>card.isCollapsed), [
        allCardGroups
    ]);
    const handleExpandSubtasks = (0, $5uXOq.useCallback)(()=>{
        onSubtasksExpandAll(allCardGroups.map((card)=>card.parentId.toString()));
    }, [
        allCardGroups,
        onSubtasksExpandAll
    ]);
    const handleCollapseSubtasks = (0, $5uXOq.useCallback)(()=>{
        onSubtasksCollapseAll();
    }, [
        onSubtasksCollapseAll
    ]);
    const cardExtraFields = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCardExtraFields));
    if ((0, $3HwlS.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FilterBar, {
        customFiltersQueryRef: customFiltersQueryRef,
        versionFilterRelayQueryRef: versionFilterRelayQueryRef
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($55602d07891954d1$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($55602d07891954d1$var$FilterBarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FilterBar, {
        customFiltersQueryRef: customFiltersQueryRef,
        versionFilterRelayQueryRef: versionFilterRelayQueryRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
        space: "space.100",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2ZySJ.ImportWorkButton), null), isBacklogWithSprints && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dvM2i.InsightsButton), {
        onToggle: handleOnToggle,
        isInsightsPanelOpen: isInsightsOpen,
        boardId: rapidViewId,
        edition: appEditions.software
    }), (0, $f6RVN.isViewSettingAsPanelExpEnabledWithNoExposure)() ? isDataLoaded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38RF4.ViewSettingsSyncFromLocalStorageWrapper), {
        boardId: rapidViewId,
        view: (0, $a4XJc.View).BACKLOG,
        cardExtraFields: cardExtraFields,
        isVersionsEnabled: isVersionsEnabled,
        isEstimateEnabled: hasCardsWithStoryPoint || hasCardsWithEstimate,
        showEpicAsPanel: showEpicAsPanel,
        isDueDateEnabled: isDueDateEnabled,
        isPriorityEnabled: hasCardsWithPriority
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8vM1G.ViewSettingsPanelOnboarding), {
        isViewSettingPanelOpen: isViewSettingPanelOpen,
        onTogglePanel: handleViewSettingPanelToggle
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8vM1G.ViewSettingsPanelButtonSpotlight), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38RF4.ViewSettingsButton), {
        isSelected: isViewSettingPanelOpen,
        onClick: handleViewSettingPanelToggle
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jB6yt.default), {
        view: (0, $a4XJc.View).BACKLOG,
        boardId: rapidViewId,
        isClassic: isClassic,
        areSubtasksEnabled: isCompanyManaged && shouldShowSubtasks,
        onSubtasksExpandAll: handleExpandSubtasks,
        onSubtasksCollapseAll: handleCollapseSubtasks,
        areAllSubtasksExpanded: areAllSubtasksExpanded,
        areAllSubtasksCollapsed: areAllSubtasksCollapsed,
        showEpicAsPanel: showEpicAsPanel,
        epicCustomName: epicCustomName,
        isVersionsEnabled: isVersionsEnabled,
        showFilterBarToggle: showFilterBarToggle
    })))), isFilterSelectionBarOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bONT7.default), null));
};
var $55602d07891954d1$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($55602d07891954d1$export$9b3bbae461092bf8);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $55602d07891954d1$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _19pkx0bf _1bsb1osq _o5721q9c",
            __cmplp.className
        ])
    });
});
const $55602d07891954d1$var$FilterBarWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o _1bah1yb4 _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8vM1G", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsPanelOnboarding", () => $2f6bb1e464f0a6ca$export$215da70478ebbc7);
$parcel$export(module.exports, "ViewSettingsPanelButtonSpotlight", () => $2f6bb1e464f0a6ca$export$67c31a192079fb3c);

var $5uXOq = parcelRequire("5uXOq");

var $vIiRg = parcelRequire("vIiRg");

var $5Fk4Z = parcelRequire("5Fk4Z");
var $1QiBP = parcelRequire("1QiBP");

var $eGLgs = parcelRequire("eGLgs");

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $hchBL = parcelRequire("hchBL");

var $ehdJY = parcelRequire("ehdJY");

var $cYeCp = parcelRequire("cYeCp");


var $jnjYD = parcelRequire("jnjYD");
const $2f6bb1e464f0a6ca$export$83d026e3dd5706d = ({ stop: stop, children: children })=>children(stop);
const $2f6bb1e464f0a6ca$var$ViewSettingsPanelOnboardingBase = ({ onTogglePanel: onTogglePanel, isViewSettingPanelOpen: isViewSettingPanelOpen })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [viewSettingsPanelRef] = (0, $hchBL.useGlobalRef)((0, $3795a016b6403547$export$989661c424340ff8));
    const [addPeopleButtonRef] = (0, $hchBL.useGlobalRef)((0, $3795a016b6403547$export$4a16d41d3ff730bf));
    const [activeSpotlight, setActiveSpotlight] = (0, $5uXOq.useState)(0);
    const next = (0, $5uXOq.useCallback)(()=>setActiveSpotlight((current)=>current !== null ? current + 1 : 0), []);
    const renderSpotlight = (0, $5uXOq.useCallback)((stop)=>{
        const finalStepActions = [
            {
                text: formatMessage((0, $jnjYD.default).doneStepButton),
                onClick: ()=>{
                    isViewSettingPanelOpen && onTogglePanel();
                    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'jswViewSettingsPanelSpotlightDone');
                    setActiveSpotlight(null);
                    stop && stop();
                }
            }
        ];
        const isAddPeopleButtonAvailable = Boolean(addPeopleButtonRef);
        const numberOfSpotlights = isAddPeopleButtonAvailable ? 3 : 2;
        const spotlights = [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
                key: (0, $3795a016b6403547$export$a57856d4380e4bb8),
                target: (0, $3795a016b6403547$export$a57856d4380e4bb8),
                heading: formatMessage((0, $jnjYD.default).viewSettingsButtonStepTitle),
                actionsBeforeElement: `1/${numberOfSpotlights}`,
                actions: [
                    {
                        text: formatMessage((0, $jnjYD.default).nextStepButton),
                        onClick: ()=>{
                            !isViewSettingPanelOpen && onTogglePanel();
                            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'jswViewSettingsPanelSpotlightNext');
                            next();
                        }
                    },
                    {
                        text: formatMessage((0, $jnjYD.default).dismissStepButton),
                        onClick: ()=>{
                            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'jswViewSettingsPanelSpotlightDismiss');
                            setActiveSpotlight(null);
                            stop && stop();
                        }
                    }
                ],
                targetRadius: 3,
                targetBgColor: "var(--ds-surface, #FFFFFF)",
                dialogPlacement: "bottom right",
                messageId: "software-view-settings.ui.view-settings-panel-onboarding.jira-spotlight",
                messageType: "engagement"
            }, formatMessage((0, $jnjYD.default).viewSettingsButtonStepContent)),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
                key: (0, $3795a016b6403547$export$989661c424340ff8),
                targetNode: viewSettingsPanelRef,
                actionsBeforeElement: `2/${numberOfSpotlights}`,
                actions: isAddPeopleButtonAvailable ? [
                    {
                        text: formatMessage((0, $jnjYD.default).nextStepButton),
                        onClick: ()=>{
                            isViewSettingPanelOpen && onTogglePanel();
                            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'jswViewSettingsPanelSpotlightNext');
                            next();
                        }
                    },
                    {
                        text: formatMessage((0, $jnjYD.default).dismissStepButton),
                        onClick: ()=>{
                            isViewSettingPanelOpen && onTogglePanel();
                            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'jswViewSettingsPanelSpotlightDismiss');
                            setActiveSpotlight(null);
                            stop && stop();
                        }
                    }
                ] : finalStepActions,
                targetRadius: 10,
                targetBgColor: "var(--ds-surface, #FFFFFF)",
                dialogPlacement: "left top",
                messageId: "software-view-settings.ui.view-settings-panel-onboarding.jira-spotlight.1",
                messageType: "engagement"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $jnjYD.default).viewSettingsPanelFirstPartContent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $jnjYD.default).viewSettingsPanelSecondPartContentIssueTermRefresh : (0, $jnjYD.default).viewSettingsPanelSecondPartContent)))),
            isAddPeopleButtonAvailable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
                key: (0, $3795a016b6403547$export$4a16d41d3ff730bf),
                targetNode: addPeopleButtonRef,
                heading: formatMessage((0, $jnjYD.default).addPeopleButtonStepTitle),
                actionsBeforeElement: `3/${numberOfSpotlights}`,
                actions: finalStepActions,
                targetRadius: (0, $vIiRg.AVATAR_SIZES).medium,
                targetBgColor: "var(--ds-surface, #FFFFFF)",
                dialogPlacement: "bottom left",
                messageId: "software-view-settings.ui.view-settings-panel-onboarding.jira-spotlight.2",
                messageType: "engagement"
            }, formatMessage((0, $jnjYD.default).addPeopleButtonStepContent)) : null
        ];
        return activeSpotlight != null ? spotlights[activeSpotlight] : null;
    }, [
        activeSpotlight,
        createAnalyticsEvent,
        formatMessage,
        isViewSettingPanelOpen,
        next,
        onTogglePanel,
        viewSettingsPanelRef,
        addPeopleButtonRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eGLgs.default), {
        messageId: (0, $3795a016b6403547$export$8be246eeba922980),
        messageType: "engagement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2f6bb1e464f0a6ca$export$83d026e3dd5706d, null, (stop)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, renderSpotlight(stop))));
};
const $2f6bb1e464f0a6ca$export$215da70478ebbc7 = (0, $7XYc4.componentWithCondition)((0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled), $2f6bb1e464f0a6ca$var$ViewSettingsPanelOnboardingBase, ()=>null);
const $2f6bb1e464f0a6ca$export$67c31a192079fb3c = ({ children: children })=>{
    if ((0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: (0, $3795a016b6403547$export$a57856d4380e4bb8)
    }, children);
    return children;
};

});
parcelRegister("jnjYD", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d14ba5d33834aaf$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6d14ba5d33834aaf$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    viewSettingsButtonStepTitle: {
        "id": "software-view-settings.view-settings-panel-onboarding.view-settings-button-step-title",
        "defaultMessage": "Customize your view"
    },
    viewSettingsButtonStepContent: {
        "id": "software-view-settings.view-settings-panel-onboarding.view-settings-button-step-content",
        "defaultMessage": "Use view settings to simplify the look and feel of your board and backlog."
    },
    viewSettingsPanelFirstPartContent: {
        "id": "software-view-settings.view-settings-panel-onboarding.view-settings-panel-first-part-content",
        "defaultMessage": "Switch on what you need, and switch off what you don\u2019t."
    },
    viewSettingsPanelSecondPartContent: {
        "id": "software-view-settings.view-settings-panel-onboarding.view-settings-panel-second-part-content",
        "defaultMessage": "Choose to show or hide panels, filters, and issue fields, and change the density of your view."
    },
    addPeopleButtonStepTitle: {
        "id": "software-view-settings.view-settings-panel-onboarding.add-people-button-step-title",
        "defaultMessage": "Share your view"
    },
    addPeopleButtonStepContent: {
        "id": "software-view-settings.view-settings-panel-onboarding.add-people-button-step-content",
        "defaultMessage": "Now when you add a new teammate to Jira, you can share your view settings so they see what you see. Includes view settings and filters."
    },
    nextStepButton: {
        "id": "software-view-settings.view-settings-panel-onboarding.next-step-button",
        "defaultMessage": "Next"
    },
    dismissStepButton: {
        "id": "software-view-settings.view-settings-panel-onboarding.dismiss-step-button",
        "defaultMessage": "Dismiss"
    },
    doneStepButton: {
        "id": "software-view-settings.view-settings-panel-onboarding.done-step-button",
        "defaultMessage": "Done"
    },
    viewSettingsPanelSecondPartContentIssueTermRefresh: {
        "id": "software-view-settings.view-settings-panel-onboarding.view-settings-panel-second-part-content-issue-term-refresh",
        "defaultMessage": "Choose to show or hide panels, filters, and fields, and change the density of your view."
    }
});

});


parcelRegister("dvM2i", function(module, exports) {

$parcel$export(module.exports, "InsightsButton", () => $5bcf5abdb1b0ff4e$export$95e4a3c3bc863d9c);

var $5uXOq = parcelRequire("5uXOq");

var $1Klyc = parcelRequire("1Klyc");

var $7BuUr = parcelRequire("7BuUr");

var $cE2Qr = parcelRequire("cE2Qr");


var $3t5QD = parcelRequire("3t5QD");

var $5PP3a = parcelRequire("5PP3a");


var $fSgHa = parcelRequire("fSgHa");
const $5bcf5abdb1b0ff4e$export$95e4a3c3bc863d9c = ({ onToggle: onToggle, isInsightsPanelOpen: isInsightsPanelOpen, boardId: boardId, edition: edition = null })=>{
    const isSupported = (0, $7BuUr.useIsCurrentBrowserSupported)();
    const isCMPBacklog = (0, $fSgHa.useIsCMPBacklog)();
    const [nudgeStep] = (0, $cE2Qr.useNudgeStep)();
    const onToggleHandler = (0, $5uXOq.useCallback)(()=>{
        onToggle((0, $c35fd6591a78fffe$export$29d7f2210b16d662));
    }, [
        onToggle
    ]);
    if (!isSupported) return null;
    if (!edition) return null;
    return !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3t5QD.ConditionalNudgeWrapper), {
        Wrapper: (0, $5PP3a.BacklogInsightsNudgeAsync),
        conditionsToApplyWrapper: nudgeStep === (0, $dbbf68c32d8c4308$export$1c7a80b00ad9619)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Klyc.BacklogInsightsButton), {
        isSimplifiedProject: !isCMPBacklog,
        isOpen: isInsightsPanelOpen,
        isCompact: false,
        boardId: Number(boardId),
        edition: edition,
        onToggle: onToggleHandler
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Klyc.BacklogInsightsButton), {
        isSimplifiedProject: !isCMPBacklog,
        isOpen: isInsightsPanelOpen,
        isCompact: false,
        boardId: Number(boardId),
        edition: edition,
        onToggle: onToggleHandler
    });
};

});



parcelRegister("bmw3d", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6fbf0e6e7fb8e94$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a6fbf0e6e7fb8e94$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    pageTitle: {
        "id": "backlog.header.page-title",
        "defaultMessage": "Backlog"
    },
    beta: {
        "id": "backlog.header.beta",
        "defaultMessage": "Beta"
    }
});

});


parcelRegister("emFUM", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1375abf298c4955$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3Tty1 = parcelRequire("3Tty1");

var $bDZwD = parcelRequire("bDZwD");
const $a1375abf298c4955$var$KeyboardShortcuts = ()=>{
    const keyMap = (0, $bDZwD.useKeyMap)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Tty1.default), {
        keyMap: keyMap,
        location: "software.backlog.keyboard-shortcuts"
    });
};
var $a1375abf298c4955$export$2e2bcd8739ae039 = $a1375abf298c4955$var$KeyboardShortcuts;

});
parcelRegister("bDZwD", function(module, exports) {

$parcel$export(module.exports, "useKeyMap", () => $58eab6421b7d09c0$export$c83661c96ac791c2);

var $hGgHi = parcelRequire("hGgHi");

var $91LZJ = parcelRequire("91LZJ");

var $d68jx = parcelRequire("d68jx");

var $2NMNM = parcelRequire("2NMNM");


var $fUHZ2 = parcelRequire("fUHZ2");

var $a4XJc = parcelRequire("a4XJc");

var $9pP0g = parcelRequire("9pP0g");

var $iDGXn = parcelRequire("iDGXn");

var $doZTA = parcelRequire("doZTA");

var $guzeq = parcelRequire("guzeq");


var $cik5h = parcelRequire("cik5h");

var $g4P00 = parcelRequire("g4P00");

var $6GNN7 = parcelRequire("6GNN7");

var $cscVG = parcelRequire("cscVG");

var $4mqko = parcelRequire("4mqko");

var $38qhf = parcelRequire("38qhf");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $9Pc1U = parcelRequire("9Pc1U");

var $1z1J7 = parcelRequire("1z1J7");

var $9ZuIF = parcelRequire("9ZuIF");

var $fpDLy = parcelRequire("fpDLy");
const $58eab6421b7d09c0$var$bentoShortcutsAnalyticsMap = {
    [(0, $efaa4b99695f90d6$export$e2291655ce717023)]: 'assignIssueKeyboardShortcut',
    [(0, $efaa4b99695f90d6$export$4834da14f7c856f4)]: 'editIssueLabelsKeyboardShortcut',
    [(0, $efaa4b99695f90d6$export$1303babe27c61a83)]: 'commentIssueKeyboardShortcut'
};
const $58eab6421b7d09c0$var$bentoShortcutKeys = [
    (0, $efaa4b99695f90d6$export$e2291655ce717023),
    (0, $efaa4b99695f90d6$export$4834da14f7c856f4),
    (0, $efaa4b99695f90d6$export$1303babe27c61a83)
];
const $58eab6421b7d09c0$export$c8673ee45279f35b = (key)=>{
    switch(key){
        case 0, $efaa4b99695f90d6$export$e2291655ce717023:
            return (0, $d68jx.externalEditFieldAction)((0, $e9be48d6d2c01760$export$e18419056f3d184a));
        case 0, $efaa4b99695f90d6$export$4834da14f7c856f4:
            return (0, $d68jx.externalEditFieldAction)((0, $e9be48d6d2c01760$export$93605f2a09aa8d26));
        case 0, $efaa4b99695f90d6$export$1303babe27c61a83:
            return (0, $d68jx.externalAddCommentAction)();
        default:
            return null;
    }
};
const $58eab6421b7d09c0$export$c83661c96ac791c2 = ()=>{
    const fireShortcutAnalytics = (0, $fUHZ2.useShortcutAnalytics)('backlog');
    const [{ location: location }, { push: push }] = (0, $doZTA.useRouter)();
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const isBulkOperationsInProgress = (0, $91LZJ.useIsBulkOperationsInProgress)();
    const onNextIssue = ()=>{
        if (isBulkOperationsInProgress) return;
        dispatch((0, $cscVG.cardNext)(fireShortcutAnalytics));
    };
    const onPrevIssue = ()=>{
        if (isBulkOperationsInProgress) return;
        dispatch((0, $cscVG.cardPrev)(fireShortcutAnalytics));
    };
    const onAssignToMe = (activeCardId, activeCardAssignee, currentUser)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(activeCardId)) return;
        const assignee = currentUser?.id === activeCardAssignee?.id ? null : currentUser;
        dispatch((0, $g4P00.assignToMeRequestThrottled)(activeCardId, assignee, fireShortcutAnalytics));
    };
    const onOpenFocusedCard = (activeCardId, isBulkOperationsSidebarActive)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(activeCardId) || isBulkOperationsSidebarActive) return;
        dispatch((0, $4mqko.cardClick)(activeCardId, false, false, false));
        fireShortcutAnalytics({
            key: 'o',
            id: 'viewIssueKeyboardShortcut'
        });
    };
    const onToggleBentoViewForFocusedCard = (detailViewData, activeCardId, isBulkOperationsSidebarActive)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(activeCardId) || isBulkOperationsSidebarActive) return;
        const isDetailsViewAlreadyOpen = detailViewData !== null;
        if (detailViewData !== null && detailViewData.cardId === activeCardId) dispatch((0, $38qhf.closeDetailView)());
        else dispatch((0, $38qhf.openDetailView)(activeCardId));
        fireShortcutAnalytics({
            key: 't',
            id: 'toggleDetailsViewKeyboardShortcut',
            attributes: {
                toggled: !isDetailsViewAlreadyOpen ? 'open' : 'closed'
            }
        });
    };
    const onOpenAndFocusBentoField = (key, activeCardId, activeCardKey, isBulkOperationsSidebarActive)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(activeCardId) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(activeCardKey) || isBulkOperationsSidebarActive) return;
        const externalAction = $58eab6421b7d09c0$export$c8673ee45279f35b(key);
        if (!externalAction) return;
        dispatch((0, $38qhf.openDetailView)(activeCardId, externalAction));
        push((0, $cik5h.addSelectedIssueToUrl)(activeCardKey, location));
        if ($58eab6421b7d09c0$var$bentoShortcutsAnalyticsMap[key]) fireShortcutAnalytics({
            key: key,
            id: $58eab6421b7d09c0$var$bentoShortcutsAnalyticsMap[key]
        });
    };
    /*
        Required to create a separate AnalyticsEvent for the cardsMove() action since
        fireShortcutAnalytics is of the wrong type. This analytics event is not used and is simply
        created to satisfy the cardsMove input parameters
    */ const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onMoveToTopOrBottomOfContainer = (selectedCards, originCardListId, placement, canUserEditIssues)=>{
        /*
        Adding logic so that if a user only has viewer permissions then they cannot edit the cards
        */ if (!canUserEditIssues || !selectedCards.length || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(originCardListId)) return;
        const analyticsEvent = createAnalyticsEvent({
            actionSubject: 'keyboardShortcut',
            action: 'pressed'
        });
        dispatch((0, $6GNN7.cardsMove)({
            cardListId: originCardListId,
            placement: placement,
            isBetweenLists: false,
            isFromActiveSprint: false,
            cardIds: selectedCards
        }, analyticsEvent));
        const isTop = placement === (0, $guzeq.TOP_OF_LIST);
        const attributes = {
            key: isTop ? 's t' : 's b',
            id: isTop ? 'sendToTopKeyboardShortcut' : 'sendToBottomKeyboardShortcut',
            attributes: {
                isMultiSelect: selectedCards.length > 1
            }
        };
        fireShortcutAnalytics(attributes);
    };
    const selectedCards = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getSelectedCards));
    const selectedCardId = selectedCards.length !== 0 ? selectedCards[selectedCards.length - 1] : undefined;
    const activeCardId = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getActiveCard));
    const activeCardKey = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getActiveCardKey));
    const detailViewData = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getDetailViewData));
    const activeCardAssignee = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getActiveCardAssignee));
    const currentUserAccount = (0, $c1MAf.useBacklogSelector)((0, $9ZuIF.getCurrentUser));
    const originCardListId = (0, $c1MAf.useBacklogSelector)((state)=>!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(selectedCardId) ? (0, $dGljH.makeGetCardListIdByCardId)(state)(selectedCardId) : undefined);
    const canUserEditIssues = (0, $c1MAf.useBacklogSelector)((0, $1z1J7.canEditIssue));
    const isVersionsEnabled = (0, $c1MAf.useBacklogSelector)((0, $fpDLy.isVersionsFeatureEnabled));
    const isEpicsPanelEnabled = (0, $c1MAf.useBacklogSelector)((0, $9Pc1U.getShowEpicAsPanel));
    const rapidViewId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getRapidViewId));
    const { toggleViewSetting: toggleViewSetting } = (0, $iDGXn.useViewSettingsActions)();
    const onEpicsPanelToggle = ()=>{
        if (!isEpicsPanelEnabled) return;
        toggleViewSetting({
            boardId: Number(rapidViewId),
            setting: (0, $9pP0g.ViewSetting).EPIC_PANEL,
            view: (0, $a4XJc.View).BACKLOG
        });
        fireShortcutAnalytics({
            key: 'e',
            id: 'epicPanelToggleKeyboardShortcut'
        });
    };
    const onVersionsPanelToggle = ()=>{
        if (!isVersionsEnabled) return;
        toggleViewSetting({
            boardId: Number(rapidViewId),
            setting: (0, $9pP0g.ViewSetting).VERSION_PANEL,
            view: (0, $a4XJc.View).BACKLOG
        });
        fireShortcutAnalytics({
            key: 'v',
            id: 'versionPanelToggleKeyboardShortcut'
        });
    };
    const keyMap = {
        o: {
            callback: ()=>{
                onOpenFocusedCard(activeCardId, isBulkOperationsInProgress);
            }
        },
        j: {
            callback: onNextIssue
        },
        k: {
            callback: onPrevIssue
        },
        t: {
            callback: ()=>{
                onToggleBentoViewForFocusedCard(detailViewData, activeCardId, isBulkOperationsInProgress);
            }
        },
        i: {
            callback: ()=>{
                onAssignToMe(activeCardId, activeCardAssignee, currentUserAccount);
            }
        },
        's t': {
            callback: ()=>{
                onMoveToTopOrBottomOfContainer(selectedCards, originCardListId, (0, $guzeq.TOP_OF_LIST), canUserEditIssues);
            }
        },
        's b': {
            callback: ()=>{
                onMoveToTopOrBottomOfContainer(selectedCards, originCardListId, (0, $guzeq.BOTTOM_OF_LIST), canUserEditIssues);
            }
        },
        e: {
            callback: onEpicsPanelToggle
        },
        v: {
            callback: onVersionsPanelToggle
        }
    };
    $58eab6421b7d09c0$var$bentoShortcutKeys.forEach((key)=>{
        keyMap[key] = {
            callback: ()=>{
                onOpenAndFocusBentoField(key, activeCardId, activeCardKey, isBulkOperationsInProgress);
            }
        };
    });
    return keyMap;
};

});
parcelRegister("d68jx", function(module, exports) {

$parcel$export(module.exports, "externalEditFieldAction", () => $9aec05de8de4c511$export$5d020593666779fc);
$parcel$export(module.exports, "externalAddCommentAction", () => $9aec05de8de4c511$export$c70036fd42f0ed99);
$parcel$export(module.exports, "externalAssignToMeAction", () => $9aec05de8de4c511$export$8f1d4f64b4b74146);
$parcel$export(module.exports, "FIELD_EDIT_REQUEST_EXTERNAL", () => $9aec05de8de4c511$export$c72c6bc149df5e02);
$parcel$export(module.exports, "ASSIGN_TO_ME_EXTERNAL", () => $9aec05de8de4c511$export$c60815f29b5cfb6d);
$parcel$export(module.exports, "transformExternalAction", () => $9aec05de8de4c511$export$78aa3108fdac0ac3);

var $akbnA = parcelRequire("akbnA");

var $8dFNe = parcelRequire("8dFNe");
const $9aec05de8de4c511$export$5834f946a995a2ca = 'REFRESH_ISSUE';
const $9aec05de8de4c511$export$316a97ea1161ac5a = (type)=>({
        type: $9aec05de8de4c511$export$5834f946a995a2ca,
        payload: {
            type: type
        }
    });
const $9aec05de8de4c511$export$256eddbefbf4b2ce = 'EDIT_FIELD';
const $9aec05de8de4c511$export$5d020593666779fc = (fieldId)=>({
        type: $9aec05de8de4c511$export$256eddbefbf4b2ce,
        payload: {
            fieldId: fieldId
        }
    });
const $9aec05de8de4c511$export$35aff3ed3a26081d = 'ADD_COMMENT';
const $9aec05de8de4c511$export$c70036fd42f0ed99 = ()=>({
        type: $9aec05de8de4c511$export$35aff3ed3a26081d
    });
const $9aec05de8de4c511$export$ae8a4274289f40bb = 'ASSIGN_TO_ME';
const $9aec05de8de4c511$export$8f1d4f64b4b74146 = ()=>({
        type: $9aec05de8de4c511$export$ae8a4274289f40bb
    });
const $9aec05de8de4c511$export$c72c6bc149df5e02 = 'FIELD_EDIT_REQUEST_EXTERNAL';
const $9aec05de8de4c511$export$c3ca6bc94e6e6b5c = (fieldId)=>({
        type: $9aec05de8de4c511$export$c72c6bc149df5e02,
        payload: {
            fieldId: fieldId
        }
    });
const $9aec05de8de4c511$export$c60815f29b5cfb6d = 'ASSIGN_TO_ME_EXTERNAL';
const $9aec05de8de4c511$export$e3035a7e8a739325 = ()=>({
        type: $9aec05de8de4c511$export$c60815f29b5cfb6d
    });
const $9aec05de8de4c511$export$78aa3108fdac0ac3 = (action)=>{
    switch(action.type){
        case $9aec05de8de4c511$export$35aff3ed3a26081d:
            return (0, $8dFNe.addCommentFormExpand)();
        case $9aec05de8de4c511$export$ae8a4274289f40bb:
            return $9aec05de8de4c511$export$e3035a7e8a739325();
        case $9aec05de8de4c511$export$256eddbefbf4b2ce:
            return $9aec05de8de4c511$export$c3ca6bc94e6e6b5c(action.payload.fieldId);
        case $9aec05de8de4c511$export$5834f946a995a2ca:
            return (0, $akbnA.refreshIssueRequest)({
                // todo: swap between soft reload and hard (aka on-demand)
                reason: 'ON_DEMAND'
            });
        default:
            // @ts-expect-error - TS2339 - Property 'type' does not exist on type 'never'.
            throw new Error(`Unhandled external action type: ${action.type}`);
    }
};

});
parcelRegister("akbnA", function(module, exports) {

$parcel$export(module.exports, "FETCH_ISSUE_REQUEST", () => $96f907481cd25e73$export$afc8565512ebbf99);
$parcel$export(module.exports, "fetchIssueRequest", () => $96f907481cd25e73$export$ff7cd1a46115d8ca);
$parcel$export(module.exports, "FETCH_ISSUE_SUCCESS", () => $96f907481cd25e73$export$c32d0e1f370b7914);
$parcel$export(module.exports, "fetchIssueSuccess", () => $96f907481cd25e73$export$1e39a30e3f37e9d1);
$parcel$export(module.exports, "FETCH_ISSUE_FAILURE", () => $96f907481cd25e73$export$700ca24f76d5bbe6);
$parcel$export(module.exports, "fetchIssueFailure", () => $96f907481cd25e73$export$625e6e61fad65793);
$parcel$export(module.exports, "REFRESH_ISSUE_REQUEST", () => $96f907481cd25e73$export$b48f53bf5b842d57);
$parcel$export(module.exports, "refreshIssueRequest", () => $96f907481cd25e73$export$ccd0db94940d9159);
$parcel$export(module.exports, "CANCEL_REFRESH_ISSUE_REQUEST", () => $96f907481cd25e73$export$6b6ca6acd76420d1);
$parcel$export(module.exports, "cancelRefreshIssueRequest", () => $96f907481cd25e73$export$a7629a657f902cbc);
$parcel$export(module.exports, "REFRESH_ISSUE_SUCCESS", () => $96f907481cd25e73$export$de11c913f06a7952);
$parcel$export(module.exports, "refreshIssueSuccess", () => $96f907481cd25e73$export$cbd1c08fb706639c);
$parcel$export(module.exports, "FETCH_FORGE_REQUEST", () => $96f907481cd25e73$export$36b76b7384d868f3);
$parcel$export(module.exports, "fetchForgeRequest", () => $96f907481cd25e73$export$6ce2430992033a55);
const $96f907481cd25e73$export$afc8565512ebbf99 = 'FETCH_ISSUE_REQUEST';
const $96f907481cd25e73$export$ff7cd1a46115d8ca = ()=>({
        type: $96f907481cd25e73$export$afc8565512ebbf99
    });
const $96f907481cd25e73$export$c32d0e1f370b7914 = 'FETCH_ISSUE_SUCCESS';
const $96f907481cd25e73$export$1e39a30e3f37e9d1 = (entities)=>({
        type: $96f907481cd25e73$export$c32d0e1f370b7914,
        payload: entities
    });
const $96f907481cd25e73$export$700ca24f76d5bbe6 = 'FETCH_ISSUE_FAILURE';
const $96f907481cd25e73$export$625e6e61fad65793 = (failureDescription)=>({
        type: $96f907481cd25e73$export$700ca24f76d5bbe6,
        payload: failureDescription
    });
const $96f907481cd25e73$export$b48f53bf5b842d57 = 'REFRESH_ISSUE_REQUEST';
const $96f907481cd25e73$export$ccd0db94940d9159 = (payload, meta)=>({
        type: $96f907481cd25e73$export$b48f53bf5b842d57,
        payload: payload,
        meta: meta
    });
const $96f907481cd25e73$export$6b6ca6acd76420d1 = 'CANCEL_REFRESH_ISSUE_REQUEST';
const $96f907481cd25e73$export$a7629a657f902cbc = ()=>({
        type: $96f907481cd25e73$export$6b6ca6acd76420d1
    });
const $96f907481cd25e73$export$de11c913f06a7952 = 'REFRESH_ISSUE_SUCCESS';
const $96f907481cd25e73$export$cbd1c08fb706639c = (entities)=>({
        type: $96f907481cd25e73$export$de11c913f06a7952,
        payload: entities
    });
const $96f907481cd25e73$export$36b76b7384d868f3 = 'FETCH_FORGE_REQUEST';
const $96f907481cd25e73$export$6ce2430992033a55 = ()=>({
        type: $96f907481cd25e73$export$36b76b7384d868f3
    });

});

parcelRegister("8dFNe", function(module, exports) {

$parcel$export(module.exports, "ADD_COMMENT_FORM_EXPAND", () => $17d2ae7757c211f3$export$71d398107e783d48);
$parcel$export(module.exports, "addCommentFormExpand", () => $17d2ae7757c211f3$export$2b19aad250b973d);
$parcel$export(module.exports, "ADD_COMMENT_FORM_COLLAPSE", () => $17d2ae7757c211f3$export$85ff14da4a33157b);
$parcel$export(module.exports, "addCommentFormCollapse", () => $17d2ae7757c211f3$export$835c1049633b19d4);
$parcel$export(module.exports, "ADD_COMMENT_FORM_CANCEL", () => $17d2ae7757c211f3$export$2a743018e170b1c5);
$parcel$export(module.exports, "addCommentFormCancel", () => $17d2ae7757c211f3$export$cbb43c6e2782f713);
$parcel$export(module.exports, "SAVE_COMMENT_RETRY", () => $17d2ae7757c211f3$export$f1da94dd8f2d20f8);
$parcel$export(module.exports, "saveCommentRetry", () => $17d2ae7757c211f3$export$8fe4d7a3b02197cb);
$parcel$export(module.exports, "SAVE_COMMENT_EDIT", () => $17d2ae7757c211f3$export$81e9c11b794a58cd);
$parcel$export(module.exports, "saveCommentEdit", () => $17d2ae7757c211f3$export$854252150d2da91c);
$parcel$export(module.exports, "saveCommentSuccessWithPastedContent", () => $17d2ae7757c211f3$export$74f24e144289c0bf);
$parcel$export(module.exports, "SAVE_COMMENT_REQUEST", () => $17d2ae7757c211f3$export$18d19e9df123c7d4);
$parcel$export(module.exports, "saveCommentRequest", () => $17d2ae7757c211f3$export$180890d02f5569ee);
$parcel$export(module.exports, "SAVE_COMMENT_SUCCESS", () => $17d2ae7757c211f3$export$68a9d3a587260864);
$parcel$export(module.exports, "saveCommentSuccess", () => $17d2ae7757c211f3$export$e25b399b9ba134a2);
$parcel$export(module.exports, "SAVE_COMMENT_FAILURE", () => $17d2ae7757c211f3$export$181640cafd83e422);
$parcel$export(module.exports, "saveCommentFailure", () => $17d2ae7757c211f3$export$c9acef2c154290a0);
$parcel$export(module.exports, "SAVE_COMMENT_CANCEL", () => $17d2ae7757c211f3$export$9188109a1be76d1a);
$parcel$export(module.exports, "saveCommentCancel", () => $17d2ae7757c211f3$export$6971a9cf19e7bff0);
$parcel$export(module.exports, "FETCH_OLDER_COMMENTS_REQUEST", () => $17d2ae7757c211f3$export$8759655e9c2c6d63);
$parcel$export(module.exports, "FETCH_NEWER_COMMENTS_REQUEST", () => $17d2ae7757c211f3$export$d55056f931f514de);
$parcel$export(module.exports, "fetchOlderCommentsRequest", () => $17d2ae7757c211f3$export$89824d2d0989262b);
$parcel$export(module.exports, "fetchNewerCommentsRequest", () => $17d2ae7757c211f3$export$ccf1730684d88fc7);
$parcel$export(module.exports, "FETCH_MORE_COMMENTS_SUCCESS", () => $17d2ae7757c211f3$export$1c31d581a6bc6013);
$parcel$export(module.exports, "fetchMoreCommentsSuccess", () => $17d2ae7757c211f3$export$a06e5ade6af52efd);
$parcel$export(module.exports, "FETCH_MORE_COMMENTS_FAILURE", () => $17d2ae7757c211f3$export$b0ac6cc6abb21a3c);
$parcel$export(module.exports, "fetchMoreCommentsFailure", () => $17d2ae7757c211f3$export$c3ffb947d06519d4);
$parcel$export(module.exports, "FETCH_OLDER_CHILD_COMMENTS_REQUEST", () => $17d2ae7757c211f3$export$feb4fdaa519a4bac);
$parcel$export(module.exports, "FETCH_NEWER_CHILD_COMMENTS_REQUEST", () => $17d2ae7757c211f3$export$760810a204a10072);
$parcel$export(module.exports, "fetchOlderChildCommentsRequest", () => $17d2ae7757c211f3$export$1ca8a4c5d1d1794d);
$parcel$export(module.exports, "fetchNewerChildCommentsRequest", () => $17d2ae7757c211f3$export$1f6295e53f67b612);
$parcel$export(module.exports, "FETCH_MORE_CHILD_COMMENTS_SUCCESS", () => $17d2ae7757c211f3$export$85be09e36020cd88);
$parcel$export(module.exports, "fetchMoreChildCommentsSuccess", () => $17d2ae7757c211f3$export$c4a3e9e0909e77e7);
$parcel$export(module.exports, "FETCH_MORE_CHILD_COMMENTS_FAILURE", () => $17d2ae7757c211f3$export$a9baf80ea458ad1b);
$parcel$export(module.exports, "fetchMoreChildCommentsFailure", () => $17d2ae7757c211f3$export$d570cadd6de8a833);
$parcel$export(module.exports, "FETCH_SORTED_COMMENTS_REQUEST", () => $17d2ae7757c211f3$export$47acda4b8d2cc300);
$parcel$export(module.exports, "fetchSortedCommentsRequest", () => $17d2ae7757c211f3$export$4805c80809193e58);
$parcel$export(module.exports, "FETCH_SORTED_COMMENTS_SUCCESS", () => $17d2ae7757c211f3$export$f72e87877cdff1d3);
$parcel$export(module.exports, "fetchSortedCommentsSuccess", () => $17d2ae7757c211f3$export$248225c0816f92b1);
$parcel$export(module.exports, "fetchSortedCommentsFailure", () => $17d2ae7757c211f3$export$2f204bc36c94722d);
$parcel$export(module.exports, "CHANGE_COMMENT_VISIBILITY", () => $17d2ae7757c211f3$export$27e53ffab4bb4105);
$parcel$export(module.exports, "changeCommentVisibility", () => $17d2ae7757c211f3$export$bdd605e26cb557a);
$parcel$export(module.exports, "EDIT_COMMENT_BEGIN", () => $17d2ae7757c211f3$export$52ec13a9878fb210);
$parcel$export(module.exports, "editCommentBegin", () => $17d2ae7757c211f3$export$b59e3ef618f3f5a4);
$parcel$export(module.exports, "EDIT_COMMENT_COLLAPSE", () => $17d2ae7757c211f3$export$ee24a9af79550b9a);
$parcel$export(module.exports, "editCommentCollapse", () => $17d2ae7757c211f3$export$76f4fdc85b3c4983);
$parcel$export(module.exports, "EDIT_COMMENT_CANCEL", () => $17d2ae7757c211f3$export$34cbc41a86b4aebb);
$parcel$export(module.exports, "editCommentCancel", () => $17d2ae7757c211f3$export$b42a5c3d327fad1a);
$parcel$export(module.exports, "EDIT_COMMENT_UPDATE", () => $17d2ae7757c211f3$export$eae8689994a83d11);
$parcel$export(module.exports, "editCommentUpdate", () => $17d2ae7757c211f3$export$ccfcbe3e4607ec26);
$parcel$export(module.exports, "EDIT_COMMENT_VISIBILITY", () => $17d2ae7757c211f3$export$9a3bec84654d3d8b);
$parcel$export(module.exports, "editCommentVisibility", () => $17d2ae7757c211f3$export$2cbe8c5e21dff6d6);
$parcel$export(module.exports, "EDIT_COMMENT_EVENT_OCCURRED_AT", () => $17d2ae7757c211f3$export$f84d12595d214d0e);
$parcel$export(module.exports, "editCommentEventOccurredAt", () => $17d2ae7757c211f3$export$6b71370b88eec9f);
$parcel$export(module.exports, "DELETE_COMMENT_REQUEST", () => $17d2ae7757c211f3$export$32f9b2d50e470721);
$parcel$export(module.exports, "DELETE_COMMENT_SUCCESS", () => $17d2ae7757c211f3$export$ad9d0372e68e413d);
$parcel$export(module.exports, "deleteCommentSuccess", () => $17d2ae7757c211f3$export$88e6cb2a45e9c67b);
$parcel$export(module.exports, "DELETE_COMMENT_FAILURE", () => $17d2ae7757c211f3$export$17bfad3338f45e82);
$parcel$export(module.exports, "deleteCommentFailure", () => $17d2ae7757c211f3$export$f1282c6c2bcc0a44);
$parcel$export(module.exports, "PASTED_INTO_COMMENT_FORM", () => $17d2ae7757c211f3$export$7ef9a590ab69319e);
$parcel$export(module.exports, "pastedIntoCommentForm", () => $17d2ae7757c211f3$export$8ac8e8de3bb0d3);
$parcel$export(module.exports, "SET_COMMENT_ATTACHMENT_IN_PROGRESS", () => $17d2ae7757c211f3$export$ec38bcd617424c64);
$parcel$export(module.exports, "setCommentAttachmentInProgress", () => $17d2ae7757c211f3$export$d7ed3c847a4656f7);
$parcel$export(module.exports, "SET_COMMENT_VALUE", () => $17d2ae7757c211f3$export$66f932c47f92031b);
$parcel$export(module.exports, "setCommentValue", () => $17d2ae7757c211f3$export$ef0e64b81798a6f2);
$parcel$export(module.exports, "SET_COMMENT_SCROLL_STATUS", () => $17d2ae7757c211f3$export$f7592333993e8ac2);
$parcel$export(module.exports, "setCommentScrollStatus", () => $17d2ae7757c211f3$export$1dda1a9962bdad5f);
$parcel$export(module.exports, "SET_COMMENT_SCROLL_STATUS_FOR_REALTIME_UPDATES", () => $17d2ae7757c211f3$export$34b38b5759da4e0f);
$parcel$export(module.exports, "setCommentScrollStatusForRealTimeUpdates", () => $17d2ae7757c211f3$export$854c59860d860f02);
$parcel$export(module.exports, "PIN_COMMENT", () => $17d2ae7757c211f3$export$624446c4400a7b4d);
$parcel$export(module.exports, "pinComment", () => $17d2ae7757c211f3$export$7f88dc81523c62ae);
$parcel$export(module.exports, "UNPIN_COMMENT", () => $17d2ae7757c211f3$export$93b6cc6012c8ff8);
$parcel$export(module.exports, "unpinComment", () => $17d2ae7757c211f3$export$2b27a86fe292e79d);
$parcel$export(module.exports, "pinCommentSuccess", () => $17d2ae7757c211f3$export$2a0a40a9470150cd);
$parcel$export(module.exports, "PIN_COMMENT_SUCCESS", () => $17d2ae7757c211f3$export$40853bc1ddf307b2);
$parcel$export(module.exports, "unpinCommentSuccess", () => $17d2ae7757c211f3$export$57ed4ace9b92b27e);
$parcel$export(module.exports, "UNPIN_COMMENT_SUCCESS", () => $17d2ae7757c211f3$export$784272885db61bd8);
$parcel$export(module.exports, "FETCH_PINNED_COMMENTS_REQUEST", () => $17d2ae7757c211f3$export$80f9fb27b9d31fce);
$parcel$export(module.exports, "fetchPinnedCommentsRequest", () => $17d2ae7757c211f3$export$8dd484af2c8548c9);
$parcel$export(module.exports, "FETCH_PINNED_COMMENTS_SUCCESS", () => $17d2ae7757c211f3$export$e729f042c84b9288);
$parcel$export(module.exports, "fetchPinnedCommentsSuccess", () => $17d2ae7757c211f3$export$eb0f0b445099e3a2);
$parcel$export(module.exports, "REPLY_COMMENT_BEGIN", () => $17d2ae7757c211f3$export$d5ede80029a6397e);
$parcel$export(module.exports, "replyCommentBegin", () => $17d2ae7757c211f3$export$f1a18b29fe2549e9);
$parcel$export(module.exports, "REPLY_COMMENT_UPDATE", () => $17d2ae7757c211f3$export$25a7e12fd2d783a3);
$parcel$export(module.exports, "replyCommentUpdate", () => $17d2ae7757c211f3$export$ecea73f83f50bca0);
$parcel$export(module.exports, "REPLY_COMMENT_CANCEL", () => $17d2ae7757c211f3$export$f87250d72435d6b4);
$parcel$export(module.exports, "replyCommentCancel", () => $17d2ae7757c211f3$export$9dc83707765a3fa8);
$parcel$export(module.exports, "COMMENT_VIEW_INTERACTION_TIME_MARKER", () => $17d2ae7757c211f3$export$5e3e51c84e58e772);
$parcel$export(module.exports, "COMMENTS_VIEWED_EVENT_TRIGGERED", () => $17d2ae7757c211f3$export$d6e7985d27b430af);
$parcel$export(module.exports, "updateCommentViewInteractionTimeMarker", () => $17d2ae7757c211f3$export$3db8138f281d271e);
$parcel$export(module.exports, "updateCommentsViewedEventTriggered", () => $17d2ae7757c211f3$export$a532038d9e5044e0);
$parcel$export(module.exports, "REAL_TIME_COMMENT_UPDATED", () => $17d2ae7757c211f3$export$641829044314d379);

var $fOGZN = parcelRequire("fOGZN");

var $4R6GH = parcelRequire("4R6GH");
const $17d2ae7757c211f3$export$71d398107e783d48 = 'ADD_COMMENT_FORM_EXPAND';
const $17d2ae7757c211f3$export$2b19aad250b973d = ()=>({
        type: $17d2ae7757c211f3$export$71d398107e783d48
    });
const $17d2ae7757c211f3$export$85ff14da4a33157b = 'ADD_COMMENT_FORM_COLLAPSE';
const $17d2ae7757c211f3$export$835c1049633b19d4 = ()=>({
        type: $17d2ae7757c211f3$export$85ff14da4a33157b
    });
const $17d2ae7757c211f3$export$2a743018e170b1c5 = 'ADD_COMMENT_FORM_CANCEL';
const $17d2ae7757c211f3$export$cbb43c6e2782f713 = ()=>({
        type: $17d2ae7757c211f3$export$2a743018e170b1c5
    });
const $17d2ae7757c211f3$export$f1da94dd8f2d20f8 = 'SAVE_COMMENT_RETRY';
const $17d2ae7757c211f3$export$8fe4d7a3b02197cb = (optimisticId, createdDate, isNewComment)=>({
        type: $17d2ae7757c211f3$export$f1da94dd8f2d20f8,
        payload: {
            optimisticId: optimisticId,
            createdDate: createdDate,
            isNewComment: isNewComment
        }
    });
const $17d2ae7757c211f3$export$81e9c11b794a58cd = 'SAVE_COMMENT_EDIT';
const $17d2ae7757c211f3$export$854252150d2da91c = (optimisticId)=>({
        type: $17d2ae7757c211f3$export$81e9c11b794a58cd,
        payload: {
            optimisticId: optimisticId
        }
    });
const $17d2ae7757c211f3$export$eca5dde908b0cf94 = 'SAVE_COMMENT_SUCCESS_WITH_PASTED_CONTENT';
const $17d2ae7757c211f3$export$74f24e144289c0bf = (comment, pastedContent)=>({
        type: $17d2ae7757c211f3$export$eca5dde908b0cf94,
        payload: {
            comment: comment,
            pastedContent: pastedContent
        }
    });
const $17d2ae7757c211f3$export$18d19e9df123c7d4 = 'SAVE_COMMENT_REQUEST';
const $17d2ae7757c211f3$export$180890d02f5569ee = (comment, analyticsEvent, commentSessionId)=>({
        type: $17d2ae7757c211f3$export$18d19e9df123c7d4,
        payload: {
            comment: comment,
            analyticsEvent: analyticsEvent,
            commentSessionId: commentSessionId,
            updatedField: (0, $fOGZN.COMMENT)
        }
    });
const $17d2ae7757c211f3$export$68a9d3a587260864 = 'SAVE_COMMENT_SUCCESS';
const $17d2ae7757c211f3$export$e25b399b9ba134a2 = (comment, optimisticId, isNewComment, analyticsEvent, commentSessionId, meta, eventOccurredAt, jsdIncidentActivityViewHidden, fullIssueUrl, triggerIncidentSaveCommentFlag, parentId)=>({
        type: $17d2ae7757c211f3$export$68a9d3a587260864,
        payload: {
            fieldId: (0, $fOGZN.COMMENT),
            comment: comment,
            optimisticId: optimisticId,
            isNewComment: isNewComment,
            analyticsEvent: analyticsEvent,
            commentSessionId: commentSessionId,
            parentId: parentId,
            eventOccurredAt: eventOccurredAt,
            jsdIncidentActivityViewHidden: jsdIncidentActivityViewHidden,
            ...fullIssueUrl ? {
                fullIssueUrl: fullIssueUrl
            } : {},
            triggerIncidentSaveCommentFlag: triggerIncidentSaveCommentFlag
        },
        meta: meta
    });
const $17d2ae7757c211f3$export$181640cafd83e422 = 'SAVE_COMMENT_FAILURE';
const $17d2ae7757c211f3$export$c9acef2c154290a0 = (payload)=>({
        type: $17d2ae7757c211f3$export$181640cafd83e422,
        payload: payload
    });
const $17d2ae7757c211f3$export$9188109a1be76d1a = 'SAVE_COMMENT_CANCEL';
const $17d2ae7757c211f3$export$6971a9cf19e7bff0 = (optimisticId, isNewComment, parentId)=>({
        type: $17d2ae7757c211f3$export$9188109a1be76d1a,
        payload: {
            optimisticId: optimisticId,
            isNewComment: isNewComment,
            parentId: parentId
        }
    });
const $17d2ae7757c211f3$export$8759655e9c2c6d63 = 'FETCH_OLDER_COMMENTS_REQUEST';
const $17d2ae7757c211f3$export$d55056f931f514de = 'FETCH_NEWER_COMMENTS_REQUEST';
const $17d2ae7757c211f3$export$89824d2d0989262b = ()=>({
        type: $17d2ae7757c211f3$export$8759655e9c2c6d63
    });
const $17d2ae7757c211f3$export$ccf1730684d88fc7 = ()=>({
        type: $17d2ae7757c211f3$export$d55056f931f514de
    });
const $17d2ae7757c211f3$export$1c31d581a6bc6013 = 'FETCH_MORE_COMMENTS_SUCCESS';
const $17d2ae7757c211f3$export$a06e5ade6af52efd = (comments)=>({
        type: $17d2ae7757c211f3$export$1c31d581a6bc6013,
        payload: comments
    });
const $17d2ae7757c211f3$export$b0ac6cc6abb21a3c = 'FETCH_MORE_COMMENTS_FAILURE';
const $17d2ae7757c211f3$export$c3ffb947d06519d4 = ()=>({
        type: $17d2ae7757c211f3$export$b0ac6cc6abb21a3c
    });
const $17d2ae7757c211f3$export$feb4fdaa519a4bac = 'FETCH_OLDER_CHILD_COMMENTS_REQUEST';
const $17d2ae7757c211f3$export$760810a204a10072 = 'FETCH_NEWER_CHILD_COMMENTS_REQUEST';
const $17d2ae7757c211f3$export$1ca8a4c5d1d1794d = (parentId)=>({
        type: $17d2ae7757c211f3$export$feb4fdaa519a4bac,
        payload: {
            parentId: parentId
        }
    });
const $17d2ae7757c211f3$export$1f6295e53f67b612 = (parentId)=>({
        type: $17d2ae7757c211f3$export$760810a204a10072,
        payload: {
            parentId: parentId
        }
    });
const $17d2ae7757c211f3$export$85be09e36020cd88 = 'FETCH_MORE_CHILD_COMMENTS_SUCCESS';
const $17d2ae7757c211f3$export$c4a3e9e0909e77e7 = (comments, parentId)=>({
        type: $17d2ae7757c211f3$export$85be09e36020cd88,
        payload: {
            ...comments,
            parentId: parentId
        }
    });
const $17d2ae7757c211f3$export$a9baf80ea458ad1b = 'FETCH_MORE_CHILD_COMMENTS_FAILURE';
const $17d2ae7757c211f3$export$d570cadd6de8a833 = (parentId)=>({
        type: $17d2ae7757c211f3$export$a9baf80ea458ad1b,
        payload: {
            parentId: parentId
        }
    });
const $17d2ae7757c211f3$export$47acda4b8d2cc300 = 'FETCH_SORTED_COMMENTS_REQUEST';
const $17d2ae7757c211f3$export$4805c80809193e58 = (commentId, bypassLoader)=>({
        type: $17d2ae7757c211f3$export$47acda4b8d2cc300,
        payload: commentId,
        bypassLoader: bypassLoader
    });
const $17d2ae7757c211f3$export$f72e87877cdff1d3 = 'FETCH_SORTED_COMMENTS_SUCCESS';
const $17d2ae7757c211f3$export$248225c0816f92b1 = (comments)=>({
        type: $17d2ae7757c211f3$export$f72e87877cdff1d3,
        payload: comments
    });
const $17d2ae7757c211f3$export$5ae0e03aaca20486 = 'FETCH_SORTED_COMMENTS_FAILURE';
const $17d2ae7757c211f3$export$2f204bc36c94722d = ()=>({
        type: $17d2ae7757c211f3$export$5ae0e03aaca20486
    });
const $17d2ae7757c211f3$export$27e53ffab4bb4105 = 'CHANGE_COMMENT_VISIBILITY';
const $17d2ae7757c211f3$export$bdd605e26cb557a = (id, isInternal)=>({
        type: $17d2ae7757c211f3$export$27e53ffab4bb4105,
        payload: {
            id: id,
            isInternal: isInternal
        }
    });
const $17d2ae7757c211f3$export$52ec13a9878fb210 = 'EDIT_COMMENT_BEGIN';
const $17d2ae7757c211f3$export$b59e3ef618f3f5a4 = (id, isInternal, commentSessionId)=>({
        type: $17d2ae7757c211f3$export$52ec13a9878fb210,
        payload: {
            id: id,
            isInternal: isInternal,
            commentSessionId: commentSessionId
        }
    });
const $17d2ae7757c211f3$export$ee24a9af79550b9a = 'EDIT_COMMENT_COLLAPSE';
const $17d2ae7757c211f3$export$76f4fdc85b3c4983 = (id)=>({
        type: $17d2ae7757c211f3$export$ee24a9af79550b9a,
        payload: {
            id: id,
            fieldId: (0, $fOGZN.COMMENT)
        }
    });
const $17d2ae7757c211f3$export$34cbc41a86b4aebb = 'EDIT_COMMENT_CANCEL';
const $17d2ae7757c211f3$export$b42a5c3d327fad1a = (id)=>({
        type: $17d2ae7757c211f3$export$34cbc41a86b4aebb,
        payload: {
            id: id,
            fieldId: (0, $fOGZN.COMMENT)
        }
    });
const $17d2ae7757c211f3$export$eae8689994a83d11 = 'EDIT_COMMENT_UPDATE';
const $17d2ae7757c211f3$export$ccfcbe3e4607ec26 = (id, value)=>({
        type: $17d2ae7757c211f3$export$eae8689994a83d11,
        payload: {
            id: id,
            value: value,
            fieldId: (0, $fOGZN.COMMENT)
        }
    });
const $17d2ae7757c211f3$export$9a3bec84654d3d8b = 'EDIT_COMMENT_VISIBILITY';
const $17d2ae7757c211f3$export$2cbe8c5e21dff6d6 = (id, visibility)=>({
        type: $17d2ae7757c211f3$export$9a3bec84654d3d8b,
        payload: {
            id: id,
            visibility: visibility
        }
    });
const $17d2ae7757c211f3$export$f84d12595d214d0e = 'EDIT_COMMENT_EVENT_OCCURRED_AT';
const $17d2ae7757c211f3$export$6b71370b88eec9f = (id, eventOccurredAt)=>({
        type: $17d2ae7757c211f3$export$f84d12595d214d0e,
        payload: {
            id: id,
            eventOccurredAt: eventOccurredAt
        }
    });
const $17d2ae7757c211f3$export$32f9b2d50e470721 = 'DELETE_COMMENT_REQUEST';
const $17d2ae7757c211f3$export$ed74b3a5f1c036c2 = (id, analyticsEvent, parentId, hasReplies)=>({
        type: $17d2ae7757c211f3$export$32f9b2d50e470721,
        payload: {
            id: id,
            analyticsEvent: analyticsEvent,
            parentId: parentId,
            hasReplies: hasReplies,
            updatedField: (0, $fOGZN.COMMENT)
        }
    });
const $17d2ae7757c211f3$export$ad9d0372e68e413d = 'DELETE_COMMENT_SUCCESS';
const $17d2ae7757c211f3$export$88e6cb2a45e9c67b = (id, parentId, hasReplies)=>({
        type: $17d2ae7757c211f3$export$ad9d0372e68e413d,
        payload: {
            id: id,
            fieldId: (0, $fOGZN.COMMENT),
            parentId: parentId,
            hasReplies: hasReplies
        }
    });
const $17d2ae7757c211f3$export$17bfad3338f45e82 = 'DELETE_COMMENT_FAILURE';
const $17d2ae7757c211f3$export$f1282c6c2bcc0a44 = (id, errorConfig)=>{
    return {
        type: $17d2ae7757c211f3$export$17bfad3338f45e82,
        payload: {
            id: id,
            ...errorConfig ?? {}
        }
    };
};
const $17d2ae7757c211f3$export$7ef9a590ab69319e = 'PASTED_INTO_COMMENT_FORM';
const $17d2ae7757c211f3$export$8ac8e8de3bb0d3 = (id, pastedContent)=>({
        type: $17d2ae7757c211f3$export$7ef9a590ab69319e,
        payload: {
            id: id,
            pastedContent: pastedContent
        }
    });
const $17d2ae7757c211f3$export$ec38bcd617424c64 = 'SET_COMMENT_ATTACHMENT_IN_PROGRESS';
const $17d2ae7757c211f3$export$d7ed3c847a4656f7 = (id, isInProgress)=>({
        type: $17d2ae7757c211f3$export$ec38bcd617424c64,
        payload: {
            id: id,
            isInProgress: isInProgress
        }
    });
const $17d2ae7757c211f3$export$66f932c47f92031b = 'SET_COMMENT_VALUE';
const $17d2ae7757c211f3$export$ef0e64b81798a6f2 = (id, value)=>({
        type: $17d2ae7757c211f3$export$66f932c47f92031b,
        payload: {
            id: id,
            value: value,
            fieldId: (0, $fOGZN.COMMENT)
        }
    });
const $17d2ae7757c211f3$export$f7592333993e8ac2 = 'SET_COMMENT_SCROLL_STATUS';
const $17d2ae7757c211f3$export$1dda1a9962bdad5f = (status)=>({
        type: $17d2ae7757c211f3$export$f7592333993e8ac2,
        payload: {
            status: status
        }
    });
const $17d2ae7757c211f3$export$34b38b5759da4e0f = 'SET_COMMENT_SCROLL_STATUS_FOR_REALTIME_UPDATES';
const $17d2ae7757c211f3$export$854c59860d860f02 = (commentScrollStatusForRealTimeUpdates)=>({
        type: $17d2ae7757c211f3$export$34b38b5759da4e0f,
        payload: {
            commentScrollStatusForRealTimeUpdates: commentScrollStatusForRealTimeUpdates
        }
    });
const $17d2ae7757c211f3$export$624446c4400a7b4d = 'PIN_COMMENT';
const $17d2ae7757c211f3$export$7f88dc81523c62ae = (commentId)=>({
        type: $17d2ae7757c211f3$export$624446c4400a7b4d,
        payload: {
            commentId: commentId
        }
    });
const $17d2ae7757c211f3$export$93b6cc6012c8ff8 = 'UNPIN_COMMENT';
const $17d2ae7757c211f3$export$2b27a86fe292e79d = (commentId)=>({
        type: $17d2ae7757c211f3$export$93b6cc6012c8ff8,
        payload: {
            commentId: commentId
        }
    });
const $17d2ae7757c211f3$export$2a0a40a9470150cd = (commentId, isPinnedCommentsLimitReached)=>({
        type: $17d2ae7757c211f3$export$40853bc1ddf307b2,
        payload: {
            commentId: commentId,
            isPinnedCommentsLimitReached: isPinnedCommentsLimitReached
        }
    });
const $17d2ae7757c211f3$export$40853bc1ddf307b2 = 'PIN_COMMENT_SUCCESS';
const $17d2ae7757c211f3$export$57ed4ace9b92b27e = (commentId, isPinnedCommentsLimitReached)=>({
        type: $17d2ae7757c211f3$export$784272885db61bd8,
        payload: {
            commentId: commentId,
            isPinnedCommentsLimitReached: isPinnedCommentsLimitReached
        }
    });
const $17d2ae7757c211f3$export$784272885db61bd8 = 'UNPIN_COMMENT_SUCCESS';
const $17d2ae7757c211f3$export$80f9fb27b9d31fce = 'FETCH_PINNED_COMMENTS_REQUEST';
const $17d2ae7757c211f3$export$8dd484af2c8548c9 = ()=>({
        type: $17d2ae7757c211f3$export$80f9fb27b9d31fce
    });
const $17d2ae7757c211f3$export$e729f042c84b9288 = 'FETCH_PINNED_COMMENTS_SUCCESS';
const $17d2ae7757c211f3$export$eb0f0b445099e3a2 = ({ comments: comments, isPinnedCommentsLimitReached: isPinnedCommentsLimitReached })=>({
        type: $17d2ae7757c211f3$export$e729f042c84b9288,
        payload: {
            comments: comments,
            isPinnedCommentsLimitReached: isPinnedCommentsLimitReached
        }
    });
const $17d2ae7757c211f3$export$d5ede80029a6397e = 'REPLY_COMMENT_BEGIN';
const $17d2ae7757c211f3$export$f1a18b29fe2549e9 = (commentId, authorId, authorDisplayName, visibility, commentSessionId, extraCommentContent)=>({
        type: $17d2ae7757c211f3$export$d5ede80029a6397e,
        payload: {
            commentId: commentId,
            authorId: authorId,
            authorDisplayName: authorDisplayName,
            visibility: visibility,
            commentSessionId: commentSessionId,
            ...(0, $4R6GH.fg)('work_item_create_from_comment_and_pin_comment_gate') ? {
                extraCommentContent: extraCommentContent
            } : {}
        }
    });
const $17d2ae7757c211f3$export$25a7e12fd2d783a3 = 'REPLY_COMMENT_UPDATE';
const $17d2ae7757c211f3$export$ecea73f83f50bca0 = (parentId, value)=>({
        type: $17d2ae7757c211f3$export$25a7e12fd2d783a3,
        payload: {
            parentId: parentId,
            value: value
        }
    });
const $17d2ae7757c211f3$export$f87250d72435d6b4 = 'REPLY_COMMENT_CANCEL';
const $17d2ae7757c211f3$export$9dc83707765a3fa8 = (parentId)=>({
        type: $17d2ae7757c211f3$export$f87250d72435d6b4,
        payload: {
            parentId: parentId
        }
    });
const $17d2ae7757c211f3$export$5e3e51c84e58e772 = 'COMMENT_VIEW_INTERACTION_TIME_MARKER';
const $17d2ae7757c211f3$export$d6e7985d27b430af = 'COMMENTS_VIEWED_EVENT_TRIGGERED';
const $17d2ae7757c211f3$export$3db8138f281d271e = (time)=>({
        type: $17d2ae7757c211f3$export$5e3e51c84e58e772,
        payload: {
            latestCommentViewInteractedTime: time
        }
    });
const $17d2ae7757c211f3$export$a532038d9e5044e0 = (value)=>({
        type: $17d2ae7757c211f3$export$d6e7985d27b430af,
        payload: {
            commentsViewedEventTriggered: value
        }
    });
const $17d2ae7757c211f3$export$641829044314d379 = 'REAL_TIME_COMMENT_UPDATED';
const $17d2ae7757c211f3$export$407f50fa80d50d11 = (isRealTimeCommentUpdated)=>({
        type: $17d2ae7757c211f3$export$641829044314d379,
        payload: {
            isRealTimeCommentUpdated: isRealTimeCommentUpdated
        }
    });

});


const $efaa4b99695f90d6$export$e2291655ce717023 = 'a';
const $efaa4b99695f90d6$export$4834da14f7c856f4 = 'l';
const $efaa4b99695f90d6$export$1303babe27c61a83 = 'm';



parcelRegister("h7RbI", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cbf7fd877e1b481$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ldJSL = parcelRequire("ldJSL");
var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $eHJxW = parcelRequire("eHJxW");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $3qXBy = parcelRequire("3qXBy");

var $c1MAf = parcelRequire("c1MAf");

var $7b0Pa = parcelRequire("7b0Pa");

var $1k1Kz = parcelRequire("1k1Kz");
const $7cbf7fd877e1b481$var$BoardIssueMoveDialog = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const isOpen = (0, $c1MAf.useBacklogSelector)((0, $7b0Pa.isDialogOpen)); // Strip arguments from event handlers
    const handleConfirm = (0, $5uXOq.useCallback)(()=>dispatch((0, $3qXBy.boardIssueMoveExecute)()), [
        dispatch
    ]);
    const handleCancel = (0, $5uXOq.useCallback)(()=>dispatch((0, $3qXBy.boardIssueMoveCancel)()), [
        dispatch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7cbf7fd877e1b481$var$AbsolutePosition, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHJxW.JiraInlineDialog), {
        messageId: "software-backlog.modals.board-issue-move-dialog.inline-dialog.software-backlog-board-issue-move-dialog.inline-dialog",
        messageType: "transactional",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7cbf7fd877e1b481$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
            as: "h5",
            size: "xsmall"
        }, formatMessage((0, $1k1Kz.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7cbf7fd877e1b481$var$DescriptionStyle, null, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1k1Kz.default).descriptionIssueTermRefresh : (0, $1k1Kz.default).description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldJSL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            onClick: handleConfirm,
            appearance: "primary"
        }, formatMessage((0, $1k1Kz.default).confirm)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            onClick: handleCancel,
            appearance: "subtle"
        }, formatMessage((0, $1k1Kz.default).cancel)))),
        isOpen: isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null)));
};
var $7cbf7fd877e1b481$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $7cbf7fd877e1b481$var$BoardIssueMoveDialog;
const $7cbf7fd877e1b481$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _o5724jg8 _1bsbr0r7",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7cbf7fd877e1b481$var$DescriptionStyle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyrpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7cbf7fd877e1b481$var$AbsolutePosition = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _w4h2stnw _z2g7xy5q",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1k1Kz", function(module, exports) {

$parcel$export(module.exports, "default", () => $a76b3b21c7d927e2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a76b3b21c7d927e2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "backlog.modals.board-issue-move-dialog.title",
        "defaultMessage": "Fill your backlog with to-do's"
    },
    description: {
        "id": "backlog.modals.board-issue-move-dialog.description",
        "defaultMessage": "Want to move all issues in your board's first column to the backlog?"
    },
    confirm: {
        "id": "backlog.modals.board-issue-move-dialog.confirm",
        "defaultMessage": "Yes, move"
    },
    cancel: {
        "id": "backlog.modals.board-issue-move-dialog.cancel",
        "defaultMessage": "No thanks"
    },
    descriptionIssueTermRefresh: {
        "id": "backlog.modals.board-issue-move-dialog.description-issue-term-refresh",
        "defaultMessage": "Want to move all work items in your board's first column to the backlog?"
    }
});

});


parcelRegister("b75A0", function(module, exports) {

$parcel$export(module.exports, "default", () => $03da30a481e2d472$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $i8Qvm = parcelRequire("i8Qvm");

var $jA0eS = parcelRequire("jA0eS");

var $306J7 = parcelRequire("306J7");

var $gaIrH = parcelRequire("gaIrH");

var $kw5KD = parcelRequire("kw5KD");


var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $74oBv = parcelRequire("74oBv");

var $fC5rN = parcelRequire("fC5rN");

var $8RslB = parcelRequire("8RslB");

var $auGCU = parcelRequire("auGCU");

var $1fF8a = parcelRequire("1fF8a");

var $aVDTD = parcelRequire("aVDTD");

var $cdsQH = parcelRequire("cdsQH");

var $bspMX = parcelRequire("bspMX");

var $8U9FQ = parcelRequire("8U9FQ");

var $jtyx2 = parcelRequire("jtyx2");

var $26tBB = parcelRequire("26tBB");

var $hDscR = parcelRequire("hDscR");

var $e2cKU = parcelRequire("e2cKU");

var $1vE6g = parcelRequire("1vE6g");

var $fLCrV = parcelRequire("fLCrV");
const $03da30a481e2d472$var$Modals = ()=>{
    const isModalOpen = (0, $c1MAf.useBacklogSelector)((0, $fC5rN.makeIsModalOpen));
    const isCompanyManaged = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
    const isCardDeleteModalOpen = isModalOpen((0, $b107c54ec82f76f2$export$87c7cb14aa706e2d));
    const isMoveCardsActiveSprintModalOpen = isModalOpen((0, $b107c54ec82f76f2$export$86a0c18887a92eae));
    const isAssignIssueParentModalOpen = isModalOpen((0, $b107c54ec82f76f2$export$9d5b8103d4fbbb34));
    const isGlobalIssueCreateModal = isModalOpen((0, $b107c54ec82f76f2$export$55cae6fd3c958bc5));
    const isSplitIssueModalOpen = isModalOpen((0, $b107c54ec82f76f2$export$77e94846ed2f57d7));
    const isSelectTransitionsModalOpen = isModalOpen((0, $b107c54ec82f76f2$export$dcb8eb3e585ecde));
    const isFlagWithCommentModalOpen = isModalOpen((0, $b107c54ec82f76f2$export$34f52cb2089ddc40));
    const hasAnyIssueTypeWithRequiredFields = (0, $c1MAf.useBacklogSelector)((0, $74oBv.getHasAnyIssueTypeWithRequireFields));
    const shouldShowScrumOnboardingModal = (0, $306J7.useShouldShowScrumOnboardingModal)();
    const GlobalIssueCreateModalComponent = isCompanyManaged ? (0, $jtyx2.default) : (0, $26tBB.default);
    const shouldShowWelcomeModal = (0, $kw5KD.useShouldShowWelcomeModal)('backlog');
    return(// div is required here, otherwise backlog layout breaks when a modal pops up
    // eslint-disable-next-line jira/react/no-empty-divs
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, shouldShowScrumOnboardingModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jA0eS.AsyncScrumOnboardingModal), null), isCardDeleteModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $auGCU.default), null), isMoveCardsActiveSprintModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e2cKU.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, isAssignIssueParentModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8RslB.default), null)), (hasAnyIssueTypeWithRequiredFields || isGlobalIssueCreateModal) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(GlobalIssueCreateModalComponent, null), isSplitIssueModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fLCrV.default), null), isSelectTransitionsModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1vE6g.SelectTransitionsModal), null), isFlagWithCommentModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8U9FQ.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1fF8a.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aVDTD.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cdsQH.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bspMX.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hDscR.IssueTransitionModal), null), shouldShowWelcomeModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gaIrH.AsyncWelcomeModal), {
        source: "backlog"
    })));
};
var $03da30a481e2d472$export$2e2bcd8739ae039 = $03da30a481e2d472$var$Modals;

});
parcelRegister("jA0eS", function(module, exports) {

$parcel$export(module.exports, "AsyncScrumOnboardingModal", () => $68afb034032af6be$export$744c5f72d1694510);

var $5uXOq = parcelRequire("5uXOq");

var $lkem5 = parcelRequire("lkem5");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $68afb034032af6be$var$LazyScrumOnboardingModal = (0, $kxZPA.lazy)(()=>(parcelRequire("74Pl9")).then(({ ScrumOnboardingModal: ScrumOnboardingModal })=>ScrumOnboardingModal), {
    moduleId: "./src/packages/software/onboarding-modals/src/ui/scrum-onboarding-modal/index.tsx"
});
const $68afb034032af6be$export$744c5f72d1694510 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lkem5.ErrorBoundaryWithChunkErrorLogging), {
        id: "asyncScrumOnboardingModalComponent",
        fallback: "unmount",
        packageName: "jiraSoftwareOnboardingModals",
        teamName: "jlove-makkuro"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-onboarding-modals-scrum-onboarding",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($68afb034032af6be$var$LazyScrumOnboardingModal, null)));

});
parcelRegister("74Pl9", function(module, exports) {

let $5270bb349580ee2d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $5270bb349580ee2d$var$load("ffQaD"),
    $5270bb349580ee2d$var$load("kvRbA"),
    $5270bb349580ee2d$var$load("7HwWd")
]).then(()=>parcelRequire('8aL25'));

});


parcelRegister("306J7", function(module, exports) {

$parcel$export(module.exports, "useShouldShowScrumOnboardingModal", () => $05ee9f68eca484b6$export$b752c215b94b059e);

var $5uXOq = parcelRequire("5uXOq");

var $eNf8a = parcelRequire("eNf8a");


var $cE2Qr = parcelRequire("cE2Qr");
const $05ee9f68eca484b6$var$sessionStorageProvider = (0, $eNf8a.createSessionStorageProvider)('onboarding-core');
const $05ee9f68eca484b6$export$b752c215b94b059e = ()=>{
    const [shouldShowScrumOnBoardingExperience] = (0, $cE2Qr.useShouldShowScrumOnboardingExperience)();
    const sessionStorageVal = (0, $5uXOq.useMemo)(()=>$05ee9f68eca484b6$var$sessionStorageProvider.get((0, $6784cbc7d62e5d7c$export$67abe0a3b8dfe03f)), []);
    return shouldShowScrumOnBoardingExperience !== false && sessionStorageVal !== undefined;
};

});

parcelRegister("gaIrH", function(module, exports) {

$parcel$export(module.exports, "AsyncWelcomeModal", () => $469ada65feba09b1$export$d08881a6c29dfdb2);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");


var $lkem5 = parcelRequire("lkem5");

var $9yQlD = parcelRequire("9yQlD");

var $lfTZh = parcelRequire("lfTZh");

var $l8ruj = parcelRequire("l8ruj");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $469ada65feba09b1$var$LazyWelcomeModal = (0, $kxZPA.lazy)(()=>(parcelRequire("2a73b")).then(({ WelcomeModal: WelcomeModal })=>WelcomeModal), {
    moduleId: "./src/packages/software/onboarding-modals/src/ui/welcome-modal/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $469ada65feba09b1$var$LazyWelcomeModalWizard = (0, $kxZPA.lazy)(()=>(parcelRequire("1DrKT")).then(({ WelcomeModal: WelcomeModal })=>WelcomeModal), {
    moduleId: "./src/packages/software/onboarding-modals/src/ui/welcome-modal/wizard/index.tsx"
});
const $469ada65feba09b1$export$d08881a6c29dfdb2 = ({ source: source })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "async-onboarding-welcome-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lkem5.ErrorBoundaryWithChunkErrorLogging), {
        id: "asyncWelcomeModalComponent",
        fallback: "unmount",
        packageName: "jiraSoftwareOnboardingModals",
        teamName: "jlove-makkuro"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-onboarding-modals-welcome-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4R6GH.fg)('jira_onboarding_wizard_m1_feature_gate') && [
        'list',
        'board'
    ].includes(source) && // our new wizard only needs to render on list/board
    (0, $9yQlD.sessionStorageProvider).get((0, $6784cbc7d62e5d7c$export$c9dc4cb209930823)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($469ada65feba09b1$var$LazyWelcomeModalWizard, {
        source: source
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($469ada65feba09b1$var$LazyWelcomeModal, {
        source: source
    }))));
};

});
parcelRegister("2a73b", function(module, exports) {

let $1931fc010041cfe3$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $1931fc010041cfe3$var$load("ffQaD"),
    $1931fc010041cfe3$var$load("kvRbA"),
    $1931fc010041cfe3$var$load("3kB5A")
]).then(()=>parcelRequire('68yeS'));

});

parcelRegister("1DrKT", function(module, exports) {

let $130ef69c7eb9a918$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $130ef69c7eb9a918$var$load("ffQaD"),
    $130ef69c7eb9a918$var$load("kvRbA"),
    $130ef69c7eb9a918$var$load("chhFU")
]).then(()=>parcelRequire('1l5pF'));

});


parcelRegister("kw5KD", function(module, exports) {

$parcel$export(module.exports, "useShouldShowModalBasedOnSessionStorage", () => $37bcf797fd2f572d$export$b39cbd941f378bec);
$parcel$export(module.exports, "useShouldShowWelcomeModal", () => $37bcf797fd2f572d$export$b01115c2f75a04f8);

var $5uXOq = parcelRequire("5uXOq");


var $9yQlD = parcelRequire("9yQlD");

var $4R6GH = parcelRequire("4R6GH");

var $i4CeP = parcelRequire("i4CeP");
const $37bcf797fd2f572d$export$b39cbd941f378bec = ()=>{
    const shouldShowModalBasedOnSessionStorage = (0, $5uXOq.useMemo)(()=>{
        if ((0, $4R6GH.fg)('jira_project_onboarding_wizard_during_signup_gate') || (0, $4R6GH.fg)('jira_project_wizard_for_scrum_gate') || (0, $4R6GH.fg)('jira_software_kanban_wizard_m2_gate')) {
            const isWizardDuringSignup = (0, $9yQlD.sessionStorageProvider).get((0, $6784cbc7d62e5d7c$export$c45d2ea50af63a85));
            if (isWizardDuringSignup) return false;
        }
        const sessionStorageVal = (0, $9yQlD.sessionStorageProvider).get((0, $6784cbc7d62e5d7c$export$e3884212029f7bef));
        if (sessionStorageVal === undefined) return false;
        return true;
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        // Remove the session storage value to prevent the modal showing again
        (0, $9yQlD.sessionStorageProvider).remove((0, $6784cbc7d62e5d7c$export$e3884212029f7bef));
    }, []);
    return shouldShowModalBasedOnSessionStorage;
};
const $37bcf797fd2f572d$export$b01115c2f75a04f8 = (source)=>{
    const canShowNudgeTour = (0, $i4CeP.useCanShowNudgeTour)();
    const sessionStorageVal = (0, $5uXOq.useMemo)(()=>(0, $9yQlD.sessionStorageProvider).get((0, $6784cbc7d62e5d7c$export$e3884212029f7bef)), []);
    if ((0, $4R6GH.fg)('jira_project_onboarding_wizard_during_signup_gate') || (0, $4R6GH.fg)('jira_project_wizard_for_scrum_gate') || (0, $4R6GH.fg)('jira_software_kanban_wizard_m2_gate')) {
        const isWizardDuringSignup = (0, $9yQlD.sessionStorageProvider).get((0, $6784cbc7d62e5d7c$export$c45d2ea50af63a85));
        if (isWizardDuringSignup) return false;
    }
    if (sessionStorageVal === undefined) return false;
    return canShowNudgeTour(source);
};

});
parcelRegister("i4CeP", function(module, exports) {

$parcel$export(module.exports, "useCanShowNudgeTour", () => $f9e2cd0a6b3c1f13$export$3381da528a252680);

var $4R6GH = parcelRequire("4R6GH");

var $8Bc5A = parcelRequire("8Bc5A");

var $cE2Qr = parcelRequire("cE2Qr");
const $f9e2cd0a6b3c1f13$export$3381da528a252680 = ()=>{
    const [completedTaskList] = (0, $cE2Qr.useCompletedTaskList)();
    const [shouldShowScrumOnboardingExperience] = (0, $cE2Qr.useShouldShowScrumOnboardingExperience)();
    const [shouldShowOnboardingKanbanTour] = (0, $cE2Qr.useShouldShowOnboardingKanbanTour)();
    const shouldShowOnboardingScrumTour = shouldShowScrumOnboardingExperience === true && // edge case for KURO-2088: After welcome modal failed to load, users complete welcome tour by themselves. Welcome modal should be skipped to load on refreshment.
    !completedTaskList.includes((0, $8Bc5A.SCRUM_ONBOARDING_TASK));
    return (source)=>{
        switch(source){
            case 'board':
                return shouldShowOnboardingKanbanTour;
            case 'backlog':
                return shouldShowOnboardingScrumTour;
            case 'timeline':
                // display if eligible for either board/backlog scenarios
                return shouldShowOnboardingKanbanTour || shouldShowOnboardingScrumTour;
            case 'list':
                if ((0, $4R6GH.fg)('jira_onboarding_wizard_m1_feature_gate')) return true;
                return false;
            default:
                return false;
        }
    };
};

});


parcelRegister("8RslB", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc15ceffc4eae2e7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $l4kDS = parcelRequire("l4kDS");

var $kxZPA = parcelRequire("kxZPA");



var $et6P7 = parcelRequire("et6P7");

var $5Eoed = parcelRequire("5Eoed");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $f9Swb = parcelRequire("f9Swb");

var $fmuR9 = parcelRequire("fmuR9");

var $fC5rN = parcelRequire("fC5rN");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $fc15ceffc4eae2e7$var$AssignIssueParentModal = (0, $kxZPA.lazy)(()=>(parcelRequire("1sMV3")), {
    moduleId: "./src/packages/assign-issue-parent-modal/src/index.tsx"
});
function $fc15ceffc4eae2e7$export$2e2bcd8739ae039() {
    const modalData = (0, $c1MAf.useBacklogSelector)((0, $fC5rN.getOpenModalData));
    const issues = (0, $c1MAf.useBacklogSelector)((state)=>modalData && modalData.type === (0, $b107c54ec82f76f2$export$9d5b8103d4fbbb34) ? (0, $dGljH.partialCardsFromCardIdsSelector)(state)(modalData.payload.cardIds) : []);
    const issueParents = (0, $c1MAf.useBacklogSelector)((0, $fmuR9.partialIssueParentSelector));
    const issueParentTypeIds = (0, $c1MAf.useBacklogSelector)((0, $fmuR9.issueParentTypeIdsSelector));
    const issueHierarchyLevel = (0, $c1MAf.useBacklogSelector)((0, $fmuR9.issueHierarchyLevelSelector))();
    const parentIssueTypeName = (0, $c1MAf.useBacklogSelector)((0, $fmuR9.firstParentIssueTypeNameSelector));
    const firstLevelHierarchyName = (0, $c1MAf.useBacklogSelector)((0, $f9Swb.getFirstLevelHierarchyName));
    const baseUrl = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getBaseUrl));
    const currentProjectId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.projectIdSelector));
    const projectIds = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getProjectIds));
    const isCompanyManaged = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const onClose = (0, $c1MAf.useBacklogActionCreator)((0, $5Eoed.closeModal));
    const label = isCompanyManaged ? firstLevelHierarchyName : parentIssueTypeName;
    const onSubmit = (cards, parentId, issueParent, requestPromise)=>{
        dispatch((0, $et6P7.cardsParentSetOptimistic)({
            cards: // @ts-expect-error - TS2322 - Type 'Issue[]' is not assignable to type 'PartialCard[]'.
            cards,
            parentId: // @ts-expect-error - TS2322 - Type 'string | null' is not assignable to type 'number | null'.
            parentId,
            requestPromise: requestPromise
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l4kDS.AssignIssueParentModalBoundary), {
        packageName: (0, $a9c483c0d986286a$export$dfd208682d29484c)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fc15ceffc4eae2e7$var$AssignIssueParentModal, {
        issues: issues,
        issueParents: issueParents,
        issueParentTypeIds: issueParentTypeIds,
        issueHierarchyLevel: issueHierarchyLevel,
        parentIssueTypeName: label,
        baseUrl: baseUrl,
        currentProjectId: currentProjectId,
        projectIds: projectIds,
        onClose: onClose,
        onSubmit: onSubmit,
        isSimplifiedProject: !isCompanyManaged
    }));
}

});
parcelRegister("l4kDS", function(module, exports) {

$parcel$export(module.exports, "AssignIssueParentModalBoundary", () => $965b0f9088163c5f$export$eb6171d83c7b32bb);

var $5uXOq = parcelRequire("5uXOq");

var $gjEtj = parcelRequire("gjEtj");
const $965b0f9088163c5f$export$eb6171d83c7b32bb = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjEtj.ModalBoundary), {
        id: "assign-issue-parent-modal",
        ...props
    }, children);

});

parcelRegister("1sMV3", function(module, exports) {

let $110e5a5341ca4077$var$load = (parcelRequire("28QjX"))(4);
module.exports = $110e5a5341ca4077$var$load("bCKKt").then(()=>parcelRequire('3lI7K'));

});


parcelRegister("auGCU", function(module, exports) {

$parcel$export(module.exports, "default", () => $e338eb9297ead1c3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");

var $hZHze = parcelRequire("hZHze");

var $9fuVs = parcelRequire("9fuVs");

var $6s1PB = parcelRequire("6s1PB");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $1ppIJ = parcelRequire("1ppIJ");

var $dCm1o = parcelRequire("dCm1o");


var $legw4 = parcelRequire("legw4");

var $5Eoed = parcelRequire("5Eoed");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");

var $fC5rN = parcelRequire("fC5rN");

var $hNfht = parcelRequire("hNfht");
function $e338eb9297ead1c3$var$CardDeleteModal() {
    const card = (0, $c1MAf.useBacklogSelector)((state)=>{
        const modalData = (0, $fC5rN.getOpenModalData)(state);
        if (!modalData || modalData.type !== (0, $b107c54ec82f76f2$export$87c7cb14aa706e2d)) return null;
        const { payload: { cardId: cardId } } = modalData;
        return cardId ? (0, $dGljH.getCards)(state)[String(cardId)] : null;
    });
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    /*
       Should only need to create this once since the modal is closed
       by either confirm or cancel
     */ const analyticsEvent = createAnalyticsEvent({
        actionSubject: 'button',
        action: 'clicked'
    });
    const onDelete = ()=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'confirmButton');
        card && dispatch((0, $legw4.cardDeleteRequest)({
            cardId: card.id
        }));
        dispatch((0, $5Eoed.closeModal)());
    };
    const onClose = ()=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'cancelButton');
        dispatch((0, $5Eoed.closeModal)());
    };
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!card) return null;
    const deleteDataPermanentlyWarningMessage = (()=>{
        if ((0, $6s1PB.expVal)('jira-itr-m4-exp-3', 'isEnabled', false)) return formatMessage((0, $hNfht.default).deleteDataPermanentlyWarningIssueTerminologyRefreshM4, {
            workType: card.issueTypeName,
            issueLevel: card.issueTypeName
        });
        return formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $hNfht.default).deleteDataPermanentlyWarningIssueTermRefresh : (0, $hNfht.default).deleteDataPermanentlyWarning);
    })();
    const resolveOrCloseInsteadMessage = (()=>{
        if ((0, $6s1PB.expVal)('jira-itr-m4-exp-3', 'isEnabled', false)) return formatMessage((0, $hNfht.default).resolveOrCloseInsteadIssueTerminologyRefreshM4, {
            workType: card.issueTypeName,
            issueLevel: card.issueTypeName
        });
        return formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $hNfht.default).resolveOrCloseInsteadIssueTermRefresh : (0, $hNfht.default).resolveOrCloseInstead);
    })();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1ppIJ.ModalDialog), {
        messageId: "software-backlog.modals.card-delete-modal.modal-dialog",
        messageType: "transactional",
        width: 400,
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), {
        appearance: "danger"
    }, (0, $6s1PB.expVal)('jira-itr-m4-exp-3', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $hNfht.default).titleIssueTerminologyRefreshM4,
        values: {
            cardKey: card.key,
            workType: card.issueTypeName
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $hNfht.default).title,
        values: {
            cardKey: card.key
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, deleteDataPermanentlyWarningMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, resolveOrCloseInsteadMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZHze.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        onClick: onClose
    }, formatMessage((0, $hNfht.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "danger",
        onClick: onDelete
    }, formatMessage((0, $hNfht.default).delete))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "danger",
        onClick: onDelete
    }, formatMessage((0, $hNfht.default).delete)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        onClick: onClose
    }, formatMessage((0, $hNfht.default).cancel))))));
}
function $e338eb9297ead1c3$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
        sourceName: "deleteCard"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e338eb9297ead1c3$var$CardDeleteModal, null));
}

});
parcelRegister("hNfht", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fbaad05f507ca53$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6fbaad05f507ca53$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    delete: {
        "id": "backlog.modals.card-delete-modal.delete",
        "defaultMessage": "Delete"
    },
    cancel: {
        "id": "backlog.modals.card-delete-modal.cancel",
        "defaultMessage": "Cancel"
    },
    title: {
        "id": "backlog.modals.card-delete-modal.title",
        "defaultMessage": "Delete {cardKey}?"
    },
    titleIssueTerminologyRefreshM4: {
        "id": "backlog.modals.card-delete-modal.title-issue-terminology-refresh-m4",
        "defaultMessage": "Permanently delete {workType} {cardKey}"
    },
    deleteDataPermanentlyWarning: {
        "id": "backlog.modals.card-delete-modal.delete-data-permanently-warning",
        "defaultMessage": "You're about to permanently delete this issue, its comments and attachments, and all of its data."
    },
    deleteDataPermanentlyWarningIssueTerminologyRefreshM4: {
        "id": "backlog.modals.card-delete-modal.delete-data-permanently-warning-issue-terminology-refresh-m4",
        "defaultMessage": "This {workType} and all its subtasks, comments, attachments, and data will be permanently deleted."
    },
    resolveOrCloseInstead: {
        "id": "backlog.modals.card-delete-modal.resolve-or-close-instead",
        "defaultMessage": "If you're not sure, you can resolve or close this issue instead."
    },
    resolveOrCloseInsteadIssueTerminologyRefreshM4: {
        "id": "backlog.modals.card-delete-modal.resolve-or-close-instead-issue-terminology-refresh-m4",
        "defaultMessage": "If you're not sure, you can resolve or close this {workType} instead."
    },
    deleteDataPermanentlyWarningIssueTermRefresh: {
        "id": "backlog.modals.card-delete-modal.delete-data-permanently-warning-issue-term-refresh",
        "defaultMessage": "You're about to permanently delete this work item, its comments and attachments, and all of its data."
    },
    resolveOrCloseInsteadIssueTermRefresh: {
        "id": "backlog.modals.card-delete-modal.resolve-or-close-instead-issue-term-refresh",
        "defaultMessage": "If you're not sure, you can resolve or close this work item instead."
    }
});

});


parcelRegister("1fF8a", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc8489a54e5d3428$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $l25oY = parcelRequire("l25oY");

var $9LoyA = parcelRequire("9LoyA");

var $ivDCs = parcelRequire("ivDCs");

var $4mO32 = parcelRequire("4mO32");
const $cc8489a54e5d3428$var$entryPointParams = {};
function $cc8489a54e5d3428$export$2e2bcd8739ae039() {
    const [state, actions] = (0, $9LoyA.useRetros)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $l25oY.retroCreateModalEntryPoint), $cc8489a54e5d3428$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (state.loadCreateRetroModal) {
            actions.setLoadCreateRetroModal(false);
            entryPointActions.load();
        }
    }, [
        state.loadCreateRetroModal,
        actions,
        entryPointActions
    ]);
    const props = (0, $5uXOq.useMemo)(()=>({}), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ivDCs.ModalEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        entryPointActions: entryPointActions,
        id: "jira-confluence-sprint-retro-create-modal",
        packageName: "jira-confluence-sprint-retro-create-modal",
        teamName: "helios-headcoach",
        runtimeProps: props
    });
}

});
parcelRegister("l25oY", function(module, exports) {

$parcel$export(module.exports, "retroCreateModalEntryPoint", () => $fb012128bdf4d96d$export$5475eb8732086597);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $fb012128bdf4d96d$export$5475eb8732086597 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("bls1q")), {
        moduleId: "5e0982c9"
    }),
    getPreloadProps: (_params)=>({
            queries: {}
        })
});

});
parcelRegister("bls1q", function(module, exports) {

let $84276472fa0b29be$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $84276472fa0b29be$var$load("76n7a"),
    $84276472fa0b29be$var$load("l253H"),
    $84276472fa0b29be$var$load("fBiWA")
]).then(()=>parcelRequire('dh6oC'));

});



parcelRegister("aVDTD", function(module, exports) {

$parcel$export(module.exports, "default", () => $df7708cdab79f2fa$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $kyDyy = parcelRequire("kyDyy");

var $9LoyA = parcelRequire("9LoyA");

var $ivDCs = parcelRequire("ivDCs");

var $4mO32 = parcelRequire("4mO32");


const $df7708cdab79f2fa$var$entryPointParams = {};
function $df7708cdab79f2fa$export$2e2bcd8739ae039() {
    (0, $gKZoD.di)(window);
    const [state, actions] = (0, $9LoyA.useRetros)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $kyDyy.confluenceCrossFlowModalEntryPoint), $df7708cdab79f2fa$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (state.loadCrossFlowModal) {
            actions.setLoadCrossFlowModal(false);
            entryPointActions.load();
        }
    }, [
        state.loadCrossFlowModal,
        entryPointActions,
        actions
    ]);
    const onClose = (0, $5uXOq.useCallback)(()=>{
        actions.resetState();
    }, [
        actions
    ]);
    const onComplete = ({ success: success })=>{
        if (success) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.reload();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ivDCs.ModalEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        entryPointActions: entryPointActions,
        id: "jira-confluence-cross-flow-modal",
        packageName: "jira-confluence-cross-flow-modal",
        teamName: "Confluence - Better Together",
        runtimeProps: {
            onClose: onClose,
            onComplete: onComplete,
            embeddedConfluenceSource: (0, $3ca5d8c2ff27b2b4$export$d7568f1916ebda24),
            crossFlowSource: (0, $1fcd698cd2006024$export$ae844fca2858b7c4)
        }
    }));
}

});
parcelRegister("kyDyy", function(module, exports) {

$parcel$export(module.exports, "confluenceCrossFlowModalEntryPoint", () => $d88c1fbe7cc0c1c3$export$d147ed79220ebf4);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $d88c1fbe7cc0c1c3$export$d147ed79220ebf4 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("gdaNO")), {
        moduleId: "75f5e774"
    }),
    getPreloadProps: (_params)=>({
            queries: {}
        })
});

});
parcelRegister("gdaNO", function(module, exports) {

let $bcd63d5bf7262392$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bcd63d5bf7262392$var$load("WgIeh").then(()=>parcelRequire('6qOOt'));

});


const $1fcd698cd2006024$export$ae844fca2858b7c4 = 'Retro';
const $1fcd698cd2006024$export$bda5d6727c30cf36 = 'JiraIssueCreateContent';

const $3ca5d8c2ff27b2b4$export$f19c4e560a68c416 = 'jiraIssueView';
const $3ca5d8c2ff27b2b4$export$2e6ff5d53a830129 = 'jiraIssueViewLinkedMentionedPage';
const $3ca5d8c2ff27b2b4$export$2d990bc8cd668ca1 = 'jiraIssueViewQuickAddItem';
const $3ca5d8c2ff27b2b4$export$d3566448206b58e = 'jiraIssueViewLinkConfluencePage';
const $3ca5d8c2ff27b2b4$export$c257b3d4e328f4ba = 'jiraIssueViewLengthyDescriptionMessage';
const $3ca5d8c2ff27b2b4$export$d7568f1916ebda24 = 'jiraSoftwareBacklogEndOfSprintRetro';
const $3ca5d8c2ff27b2b4$export$79e2b0aa41c936ad = 'jiraIssueAutoLinkContentOnLinkPaste';


parcelRegister("cdsQH", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7eb28957b2a9cbe$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3zRec = parcelRequire("3zRec");


var $9LoyA = parcelRequire("9LoyA");

var $4mO32 = parcelRequire("4mO32");

var $ivDCs = parcelRequire("ivDCs");
const $b7eb28957b2a9cbe$var$entryPointParams = {};
const $b7eb28957b2a9cbe$var$CROSS_JOIN_SOURCE = 'Retro';
function $b7eb28957b2a9cbe$export$2e2bcd8739ae039() {
    const [state, actions] = (0, $9LoyA.useRetros)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $3zRec.confluenceCrossJoinModalEntryPoint), $b7eb28957b2a9cbe$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (state.loadCrossJoinModal) {
            actions.setLoadCrossJoinModal(false);
            entryPointActions.load();
        }
    }, [
        state.loadCrossJoinModal,
        entryPointActions,
        actions
    ]);
    const onComplete = (0, $5uXOq.useCallback)(({ directJoinSuccess: directJoinSuccess })=>{
        if (directJoinSuccess) actions.setLoadCreateRetroModal(true);
    }, [
        actions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ivDCs.ModalEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        entryPointActions: entryPointActions,
        id: "jira-confluence-cross-join-modal",
        packageName: "jira-confluence-cross-join-modal",
        teamName: "Confluence - Virality",
        runtimeProps: {
            onComplete: onComplete,
            embeddedConfluenceSource: (0, $1e471926441c6303$export$5cdbf483845e61aa),
            crossJoinSource: $b7eb28957b2a9cbe$var$CROSS_JOIN_SOURCE
        }
    });
}

});
parcelRegister("3zRec", function(module, exports) {

$parcel$export(module.exports, "confluenceCrossJoinModalEntryPoint", () => $d64df6cf66d1da31$export$6b94fb5b310ef3e1);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $d64df6cf66d1da31$export$6b94fb5b310ef3e1 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("7l0ks")), {
        moduleId: "8339c23d"
    }),
    getPreloadProps: (_params)=>({
            queries: {}
        })
});

});
parcelRegister("7l0ks", function(module, exports) {

let $557abfe885f9c12b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $557abfe885f9c12b$var$load("2OkRN").then(()=>parcelRequire('6NZ6z'));

});


const $1e471926441c6303$export$5cdbf483845e61aa = 'jiraSprintCompletion';


parcelRegister("bspMX", function(module, exports) {

$parcel$export(module.exports, "default", () => $57a03ba590f4c178$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6W0YL = parcelRequire("6W0YL");

var $9LoyA = parcelRequire("9LoyA");

var $ivDCs = parcelRequire("ivDCs");

var $4mO32 = parcelRequire("4mO32");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");
const $57a03ba590f4c178$var$entryPointParams = {};
function $57a03ba590f4c178$export$2e2bcd8739ae039() {
    const projectKey = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getProjectKey));
    const rapidViewId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getRapidViewId));
    const isCompanyManaged = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
    const [state, actions] = (0, $9LoyA.useRetros)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $6W0YL.retroPublishedModalEntryPoint), $57a03ba590f4c178$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (state.isRetroPublished) {
            entryPointActions.load();
            actions.setIsRetroPublished(false);
        }
    }, [
        state.isRetroPublished,
        entryPointActions,
        actions
    ]);
    const props = (0, $5uXOq.useMemo)(()=>({
            projectKey: projectKey,
            rapidViewId: rapidViewId,
            isCompanyManaged: isCompanyManaged
        }), [
        projectKey,
        rapidViewId,
        isCompanyManaged
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ivDCs.ModalEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        entryPointActions: entryPointActions,
        id: "jira-confluence-sprint-retro-published-modal",
        packageName: "jira-confluence-sprint-retro-published-modal",
        teamName: "helios-headcoach",
        runtimeProps: props
    }));
}

});
parcelRegister("6W0YL", function(module, exports) {

$parcel$export(module.exports, "retroPublishedModalEntryPoint", () => $f42b35e4ddb001d5$export$46f503ee10ceb3cd);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $f42b35e4ddb001d5$export$46f503ee10ceb3cd = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("7SaFb")), {
        moduleId: "250e60a4"
    }),
    getPreloadProps: (_params)=>({
            queries: {}
        })
});

});
parcelRegister("7SaFb", function(module, exports) {

let $5bb5d9081c36bb51$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5bb5d9081c36bb51$var$load("aTWuz").then(()=>parcelRequire('751pC'));

});



parcelRegister("8U9FQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $378eb224ec1a1c3d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $8ikZj = parcelRequire("8ikZj");

var $ctrpc = parcelRequire("ctrpc");

var $5fc53 = parcelRequire("5fc53");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");


var $aKajY = parcelRequire("aKajY");

var $5Eoed = parcelRequire("5Eoed");

var $c1MAf = parcelRequire("c1MAf");

var $fC5rN = parcelRequire("fC5rN");

var $8v1yQ = parcelRequire("8v1yQ");
const $378eb224ec1a1c3d$var$useFlagWithCommentState = ()=>({
        modalData: (0, $c1MAf.useBacklogSelector)((0, $fC5rN.getOpenModalData))
    });
const $378eb224ec1a1c3d$export$7cf2649954047f1d = ()=>{
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    /*
      Should only need to create this once since the modal is closed
      by either confirm or cancel
    */ const modalAnalyticsEvent = createAnalyticsEvent({
        actionSubject: 'button',
        action: 'clicked'
    });
    const onClose = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(modalAnalyticsEvent, 'cancelButton');
        if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) (0, $ctrpc.getUpdateAnalyticsFlowHelper)().endSession((0, $8ikZj.FIELD_TYPE_MAP)[0, $5fc53.FLAGGED_CF_TYPE]);
        dispatch((0, $5Eoed.closeModal)());
    }, [
        dispatch,
        modalAnalyticsEvent
    ]);
    const onFlagWithComment = (0, $5uXOq.useCallback)((cards, flag, comment)=>{
        (0, $8zOmE.fireUIAnalytics)(modalAnalyticsEvent, 'confirmButton');
        const requestAnalyticsEvent = createAnalyticsEvent({
            actionSubject: 'cards',
            action: 'flagged'
        });
        if (cards.length === 1 && (0, $4R6GH.fg)('one_event_rules_them_all_fg')) (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd((0, $8ikZj.FIELD_TYPE_MAP)[0, $5fc53.FLAGGED_CF_TYPE], {
            analytics: createAnalyticsEvent({}),
            attributes: {
                fieldType: (0, $5fc53.FLAGGED_CF_TYPE),
                actionTaken: flag ? 'add' : 'remove'
            }
        });
        dispatch((0, $aKajY.cardsFlagWithCommentRequest)({
            cards: cards,
            flag: flag,
            comment: comment
        }, requestAnalyticsEvent));
        dispatch((0, $5Eoed.closeModal)());
    }, [
        dispatch,
        modalAnalyticsEvent,
        createAnalyticsEvent
    ]);
    return {
        onClose: onClose,
        onFlagWithComment: onFlagWithComment
    };
};
const $378eb224ec1a1c3d$var$FlagWithComment = ()=>{
    const { modalData: modalData } = $378eb224ec1a1c3d$var$useFlagWithCommentState();
    const { onClose: onClose, onFlagWithComment: onFlagWithComment } = $378eb224ec1a1c3d$export$7cf2649954047f1d();
    if (modalData?.type !== (0, $b107c54ec82f76f2$export$34f52cb2089ddc40)) return null;
    const { flagAction: flagAction, cards: cards } = modalData.payload;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8v1yQ.FlagWithCommentRenderer), {
        flagAction: flagAction,
        cards: cards,
        onClose: onClose,
        onFlagWithComment: onFlagWithComment
    });
};
function $378eb224ec1a1c3d$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
        sourceName: "flagCardsWithCommentBacklog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($378eb224ec1a1c3d$var$FlagWithComment, null));
}

});
parcelRegister("8v1yQ", function(module, exports) {

$parcel$export(module.exports, "FlagWithCommentRenderer", () => $77959e071dc6842c$export$5bed0e93a95d2e33);
// eslint-disable-next-line jira/restricted/react-lazy

var $5uXOq = parcelRequire("5uXOq");

var $i8Qvm = parcelRequire("i8Qvm");

var $7hSN4 = parcelRequire("7hSN4");

var $7CMCs = parcelRequire("7CMCs");

const $77959e071dc6842c$var$FlagWithComment = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("i8BuN")), {
    moduleId: "./src/packages/software/add-comment-on-flag-action/src/ui/index.tsx"
});
const $77959e071dc6842c$export$5bed0e93a95d2e33 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "backlog-flag-with-comment-modal",
        packageName: "jira-software-backlog",
        teamName: "a4t-tanuki",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7hSN4.LazySuspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($77959e071dc6842c$var$FlagWithComment, props))));

});
parcelRegister("i8BuN", function(module, exports) {

let $d3460f361cd235a3$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d3460f361cd235a3$var$load("ffQaD"),
    $d3460f361cd235a3$var$load("kvRbA"),
    $d3460f361cd235a3$var$load("fliVL"),
    $d3460f361cd235a3$var$load("eIM7l")
]).then(()=>parcelRequire('dbKJB'));

});



parcelRegister("jtyx2", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bf321c61fc3700a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $8bf321c61fc3700a$var$LazyGICTrigger = (0, $kxZPA.lazy)(()=>(parcelRequire("94PFS")), {
    moduleId: "./src/packages/software/backlog/src/view/modals/global-issue-create-cmp/index.tsx"
});
const $8bf321c61fc3700a$var$AsyncGlobalIssueCreateCMPTrigger = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "async-cmp-gicTrigger",
        packageName: "jira-software-backlog",
        teamName: "a4t-tanuki"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "cmp-gic-trigger",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8bf321c61fc3700a$var$LazyGICTrigger, null)));
var $8bf321c61fc3700a$export$2e2bcd8739ae039 = $8bf321c61fc3700a$var$AsyncGlobalIssueCreateCMPTrigger;

});
parcelRegister("94PFS", function(module, exports) {

let $69bc9239fe0e952c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $69bc9239fe0e952c$var$load("a7RHU").then(()=>parcelRequire('7XJHb'));

});


parcelRegister("26tBB", function(module, exports) {

$parcel$export(module.exports, "default", () => $18f9a0c3535072e5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $a0E5R = parcelRequire("a0E5R");

var $dXq4S = parcelRequire("dXq4S");

var $8zOmE = parcelRequire("8zOmE");

var $2TOwr = parcelRequire("2TOwr");



var $5Eoed = parcelRequire("5Eoed");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $d3kOO = parcelRequire("d3kOO");

var $fC5rN = parcelRequire("fC5rN");
const $18f9a0c3535072e5$var$GlobalIssueCreate = ()=>{
    const data = (0, $c1MAf.useBacklogSelector)((state)=>{
        const modalData = (0, $fC5rN.getOpenModalData)(state);
        if (!modalData || modalData.type !== (0, $b107c54ec82f76f2$export$55cae6fd3c958bc5)) return {
            fields: null,
            disableCreationSuccessFlag: true,
            sourceName: (0, $a9c483c0d986286a$export$840e3848643f7781)
        };
        return {
            fields: (0, $d3kOO.getPrefilledFieldsFromInputs)(state),
            disableCreationSuccessFlag: true,
            sourceName: (0, $a9c483c0d986286a$export$840e3848643f7781),
            submitErrorMessage: (0, $d3kOO.getSubmitErrorMessage)(state),
            sessionId: (0, $d3kOO.getSessionIdFromInputs)(state)
        };
    });
    const cloudId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getCloudId));
    const boardId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getRapidViewId));
    const closeModalAction = (0, $c1MAf.useBacklogActionCreator)((0, $5Eoed.closeModal));
    const onCreateSuccess = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        closeModalAction();
        (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'issueWithRequiredFields created', {
            createdMultipleIssues: analyticsEvent.payload.createdMultipleIssues
        });
    }, [
        closeModalAction
    ]);
    const onCancel = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        closeModalAction();
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'issueWithRequiredFields cancelled', {});
    }, [
        closeModalAction
    ]);
    const [queryReference, loadQuery] = (0, $8Uumt.useQueryLoader)((0, $2TOwr.default));
    (0, $5uXOq.useEffect)(()=>{
        loadQuery({
            boardId: (0, $dXq4S.createAri)({
                resourceOwner: 'jira-software',
                cloudId: cloudId,
                resourceType: 'board',
                resourceId: String(boardId)
            })
        }, {
            fetchPolicy: 'store-or-network'
        });
    }, [
        boardId,
        cloudId,
        loadQuery
    ]);
    return queryReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a0E5R.default), {
        ...data,
        onCancel: onCancel,
        onCreateSuccess: onCreateSuccess,
        queryReference: queryReference
    }) : null;
};
var $18f9a0c3535072e5$export$2e2bcd8739ae039 = $18f9a0c3535072e5$var$GlobalIssueCreate;

});
parcelRegister("a0E5R", function(module, exports) {

$parcel$export(module.exports, "default", () => $9375c4c02f139011$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9375c4c02f139011$var$LazyGICTrigger = (0, $kxZPA.lazy)(()=>(parcelRequire("2bPps")), {
    moduleId: "./src/packages/software/jsw-adapted-global-issue-create-trigger/src/index.tsx"
});
const $9375c4c02f139011$var$AsyncJswAdaptedGlobalIssueCreateTrigger = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "async-gicTrigger",
        teamName: "a4t-pandora",
        packageName: "jiraJswAdaptedGlobalIssueCreateTrigger"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsw-adapted-gic-trigger",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9375c4c02f139011$var$LazyGICTrigger, props)));
var $9375c4c02f139011$export$2e2bcd8739ae039 = $9375c4c02f139011$var$AsyncJswAdaptedGlobalIssueCreateTrigger;

});
parcelRegister("2bPps", function(module, exports) {

let $19847cbbfac5c235$var$load = (parcelRequire("28QjX"))(4);
module.exports = $19847cbbfac5c235$var$load("32IpJ").then(()=>parcelRequire('gwnVZ'));

});


parcelRegister("2TOwr", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3a9e7b7142c7dd8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b7ef3dd78f617ba20e117903caea5f68>>
 * @relayHash dff560da6b44e8698cb7db6cce996d50
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ec8ebec42ce3a627014ff3055a722125ee7a7a44b01f69e101974c5c5fe01543
const $d3a9e7b7142c7dd8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isCMP"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        },
        {
            "kind": "Variable",
            "name": "isCMP",
            "variableName": "isCMP"
        }
    ], v2 = {
        "concreteType": "GlobalCardCreateAdditionalFields",
        "kind": "LinkedField",
        "name": "globalCardCreateAdditionalFields",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "sprintCustomFieldId"
            },
            {
                "kind": "ScalarField",
                "name": "rankCustomFieldId"
            },
            {
                "kind": "ScalarField",
                "name": "boardIssueListKey"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "triggerWithCustomFieldsJSWGlobalIssueCreateQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            v2 /*: any*/ 
                        ]
                    },
                    "action": "THROW",
                    "path": "boardScope"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "triggerWithCustomFieldsJSWGlobalIssueCreateQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ec8ebec42ce3a627014ff3055a722125ee7a7a44b01f69e101974c5c5fe01543",
            "metadata": {},
            "name": "triggerWithCustomFieldsJSWGlobalIssueCreateQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d3a9e7b7142c7dd8$var$node.hash = "96d35f31f30c5edc94e3d721f9444ea0";
var $d3a9e7b7142c7dd8$export$2e2bcd8739ae039 = $d3a9e7b7142c7dd8$var$node;

});

parcelRegister("d3kOO", function(module, exports) {

$parcel$export(module.exports, "getPrefilledFieldsFromInputs", () => $68971c4c7e5dfaa1$export$819256f3c3cb490a);
$parcel$export(module.exports, "getSessionIdFromInputs", () => $68971c4c7e5dfaa1$export$1f4921affea1cade);
$parcel$export(module.exports, "getSubmitErrorMessage", () => $68971c4c7e5dfaa1$export$1facbc353d35a4eb);

var $dGvGJ = parcelRequire("dGvGJ");

var $hGgHi = parcelRequire("hGgHi");

var $4R6GH = parcelRequire("4R6GH");

var $guzeq = parcelRequire("guzeq");


var $jG5HW = parcelRequire("jG5HW");

var $3QmBe = parcelRequire("3QmBe");

var $dGljH = parcelRequire("dGljH");

var $fC5rN = parcelRequire("fC5rN");
const $68971c4c7e5dfaa1$export$819256f3c3cb490a = (0, $dGvGJ.createSelector)([
    (0, $fC5rN.getOpenModalData),
    (0, $dGljH.getCardLists),
    (0, $jG5HW.projectIdSelector),
    (0, $3QmBe.getAppliedLabelFilters),
    (0, $3QmBe.getMostRecentAssigneeFilter)
], (modalData, cardLists, projectId, appliedLabels, assignee)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(modalData) || modalData?.type !== (0, $b107c54ec82f76f2$export$55cae6fd3c958bc5) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(modalData?.payload)) return null;
    const { cardSummary: cardSummary, cardDescription: cardDescription, cardTypeId: cardTypeId, rankBeforeCardId: rankBeforeCardId, cardParentId: cardParentId, cardListId: cardListId, fixVersions: fixVersions } = modalData.payload;
    const parentIssueId = // parentId is 0 when 'issues without epic' filter is selected
    !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(cardParentId) && cardParentId !== 0 ? String(cardParentId) : '';
    const destination = cardLists[cardListId]?.type;
    return {
        projectId: String(projectId),
        issueType: String(cardTypeId),
        summary: cardSummary,
        labels: appliedLabels || [],
        assignee: assignee?.id || '',
        parentIssueId: parentIssueId,
        fixVersions: fixVersions,
        sprintId: destination === (0, $guzeq.SPRINT) ? cardListId : undefined,
        context: {
            rankBeforeCardId: !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(rankBeforeCardId) ? String(rankBeforeCardId) : null,
            destination: destination
        },
        ...cardDescription && (0, $4R6GH.fg)('jira_ai_work_create_from_backlog_card_description') ? {
            description: cardDescription
        } : {}
    };
});
const $68971c4c7e5dfaa1$export$1f4921affea1cade = (0, $dGvGJ.createSelector)([
    (0, $fC5rN.getOpenModalData)
], (modalData)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(modalData) || modalData?.type !== (0, $b107c54ec82f76f2$export$55cae6fd3c958bc5) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(modalData?.payload)) return undefined;
    return modalData?.payload?.sessionId || undefined;
});
const $68971c4c7e5dfaa1$export$1facbc353d35a4eb = (0, $dGvGJ.createSelector)([
    (0, $fC5rN.getOpenModalData)
], (modalData)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(modalData) || modalData?.type !== (0, $b107c54ec82f76f2$export$55cae6fd3c958bc5) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(modalData?.payload)) return undefined;
    return modalData.payload.submitErrorMessage;
});

});


parcelRegister("hDscR", function(module, exports) {

$parcel$export(module.exports, "IssueTransitionModal", () => $2de1547cc4c3b4b7$export$98b2cbb8ec9c06d8);

var $5uXOq = parcelRequire("5uXOq");

var $jpZIw = parcelRequire("jpZIw");

var $dXq4S = parcelRequire("dXq4S");

var $koeKL = parcelRequire("koeKL");

var $6zjUi = parcelRequire("6zjUi");

var $c1MAf = parcelRequire("c1MAf");

var $f7vcs = parcelRequire("f7vcs");
const $2de1547cc4c3b4b7$export$98b2cbb8ec9c06d8 = ()=>{
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const openIssueTransitionModal = (0, $jpZIw.useOpenIssueTransitionModal)();
    const onClose = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $6zjUi.closeIssueTransitionModal)());
    }, [
        dispatch
    ]);
    const isOpen = (0, $c1MAf.useBacklogSelector)((state)=>(0, $f7vcs.isIssueTransitionModalOpen)(state));
    const { issueId: issueId = '', issueKey: issueKey = '', transitionId: transitionId = '' } = (0, $c1MAf.useBacklogSelector)((state)=>(0, $f7vcs.getPayloadForIssueTransitionModal)(state));
    const { onDialogSuccess: onDialogSuccess, onDialogCancel: onDialogCancel, onDialogError: onDialogError } = (0, $c1MAf.useBacklogSelector)((state)=>(0, $f7vcs.getHandlersForIssueTransitionModal)(state));
    const cloudId = (0, $koeKL.useCloudId)();
    const ariIssueId = (0, $dXq4S.createAri)({
        resourceOwner: 'jira',
        resourceType: 'issue',
        cloudId: cloudId,
        resourceId: `${issueId}`
    });
    (0, $5uXOq.useEffect)(()=>{
        if (isOpen) {
            const handleDialogCancel = ()=>{
                onDialogCancel?.();
                onClose();
            };
            const handleDialogError = (error)=>{
                onDialogError?.(error);
                onClose();
            };
            const handleDialogSuccess = ()=>{
                onDialogSuccess?.();
                onClose();
            };
            openIssueTransitionModal({
                payload: {
                    issueId: ariIssueId,
                    issueKey: issueKey,
                    transitionId: transitionId
                },
                triggerPointKey: 'issue-transition-board-card-transition',
                onDialogSuccess: handleDialogSuccess,
                onDialogCancel: handleDialogCancel,
                onDialogError: handleDialogError
            });
        }
    }, [
        ariIssueId,
        isOpen,
        issueKey,
        onClose,
        onDialogCancel,
        onDialogError,
        onDialogSuccess,
        openIssueTransitionModal,
        transitionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
};
var $2de1547cc4c3b4b7$export$2e2bcd8739ae039 = $2de1547cc4c3b4b7$export$98b2cbb8ec9c06d8;

});
parcelRegister("jpZIw", function(module, exports) {

$parcel$export(module.exports, "useOpenIssueTransitionModal", () => $f41d32ebe3d90af0$export$736bd10472c63b49);
$parcel$export(module.exports, "useCloseIssueTransitionModal", () => $f41d32ebe3d90af0$export$4629f18d511ad32e);
$parcel$export(module.exports, "useTriggerIssueTransitionModal", () => $f41d32ebe3d90af0$export$95a1e9702d78f223);
$parcel$export(module.exports, "default", () => $f41d32ebe3d90af0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lTEVZ = parcelRequire("lTEVZ");

var $4R6GH = parcelRequire("4R6GH");

var $6ikhl = parcelRequire("6ikhl");

var $2gCtH = parcelRequire("2gCtH");

var $ct2PA = parcelRequire("ct2PA");

var $3NlyR = parcelRequire("3NlyR");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $9MiT2 = parcelRequire("9MiT2");

var $fNOVA = parcelRequire("fNOVA");

var $1btwe = parcelRequire("1btwe");

var $gjoNn = parcelRequire("gjoNn");

var $ipUU1 = parcelRequire("ipUU1");

var $jHYHS = parcelRequire("jHYHS");
const $f41d32ebe3d90af0$export$736bd10472c63b49 = ()=>{
    const { openIssueTransitionModal: openIssueTransitionModalAction, openIssueTransitionModalNew: openIssueTransitionModalNew } = (0, $gjoNn.useTriggerIssueTransitionModalActions)();
    const { stateGet: { state: { isEnabled: isEnabled = true } = {} } = {} } = (0, $fNOVA.useIssueTransitionLabsOptIn)();
    const publish = (0, $1btwe.usePublishOpenIssueTransitionModalPubSub)();
    const source = (0, $2gCtH.useAnalyticsSource)();
    const { fireUIEvent: fireUIEvent } = (0, $3NlyR.useIssueTransitionUIAnalyticsEvent)();
    const { stateGet: { state: state } } = (0, $9MiT2.useIssueTransitionChangeboardingPreferences)();
    const { fireOperationalAnalyticsTransitionScreenOpened: fireOperationalAnalyticsTransitionScreenOpened } = (0, $ct2PA.useIssueTransitionsOperationalAnalyticsEvent)();
    const benefitsModal = typeof state !== 'number' ? state?.benefitsModal : undefined;
    const { isDisabled: isDisabled, nextDateToShowBenefitsModal: nextDateToShowBenefitsModal } = benefitsModal || {};
    return (0, $5uXOq.useCallback)((nextState)=>{
        try {
            const { triggerPointKey: triggerPointKey } = nextState || {};
            const isNewITSEnabled = (0, $jHYHS.isNewTransitionScreenEnabled)(isEnabled, triggerPointKey);
            if ((0, $4R6GH.fg)('modern_issue_transition_enable_benefits_modal')) {
                fireOperationalAnalyticsTransitionScreenOpened({
                    actionSubject: 'issueTransition triggered',
                    isBenefitsModalFGEneabled: (0, $4R6GH.fg)('modern_issue_transition_enable_benefits_modal'),
                    preferNewIssueTransitionScreen: isEnabled,
                    issueViewAnalyticsSource: source,
                    isBenefitsModalDisabled: isDisabled,
                    dateToShowBenefitsModal: nextDateToShowBenefitsModal || undefined
                });
                openIssueTransitionModalNew({
                    nextState: nextState,
                    preferNewIssueTransitionScreen: isEnabled,
                    issueViewAnalyticsSource: source,
                    publishTriggerToOpenTransitions: publish,
                    isBenefitsModalDisabled: isDisabled,
                    dateToShowBenefitsModal: nextDateToShowBenefitsModal || undefined,
                    fireUIEvent: fireUIEvent
                });
                return;
            }
            if ((0, $4R6GH.fg)('fix-connect-app-not-loading')) {
                if (isNewITSEnabled && source === 'connect-issue') {
                    // fire UI event when issue transition is opened via connect API
                    fireUIEvent({
                        actionSubject: 'issueTransition',
                        actionSubjectId: 'connectIssue',
                        action: 'opened'
                    });
                    publish(nextState, isEnabled);
                } else openIssueTransitionModalAction(nextState, isEnabled);
            } else if (source === 'connect-issue') {
                // fire UI event when issue transition is opened via connect API
                fireUIEvent({
                    actionSubject: 'issueTransition',
                    actionSubjectId: 'connectIssue',
                    action: 'opened'
                });
                publish(nextState, isEnabled);
            } else openIssueTransitionModalAction(nextState, isEnabled);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $lTEVZ.fireIssueTransitionErrorAnalytics)({
                meta: {
                    id: 'transitionIssueTrigger',
                    packageName: 'jiraIssueTransitionTrigger',
                    teamName: 'gryffindor'
                },
                attributes: {
                    transitionModalVersion: 'NEW'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }, [
        fireOperationalAnalyticsTransitionScreenOpened,
        isEnabled,
        source,
        isDisabled,
        nextDateToShowBenefitsModal,
        openIssueTransitionModalNew,
        publish,
        fireUIEvent,
        openIssueTransitionModalAction
    ]);
};
const $f41d32ebe3d90af0$export$4629f18d511ad32e = ()=>{
    const [, { resetState: resetState }] = (0, $6ikhl.useInlineFieldsActions)();
    const { closeIssueTransitionModal: closeIssueTransitionModalAction } = (0, $gjoNn.useTriggerIssueTransitionModalActions)();
    const { payload: { issueKey: issueKey, transitionId: transitionId }, onDialogCancel: onDialogCancel, onDialogError: onDialogError, onDialogSuccess: onDialogSuccess } = (0, $gjoNn.useTriggerIssueTransitionModalState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)((shouldOpenLegacyModal = false)=>{
        closeIssueTransitionModalAction();
        resetState();
        if (shouldOpenLegacyModal) {
            const onOpenDialog = ()=>{
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'legacyTransitionsScreen Switched');
            };
            (0, $ipUU1.openLegacyIssueTransitionModal)({
                issueKey: issueKey,
                isReopenScenario: true,
                transitionId: transitionId,
                onDialogCancel: onDialogCancel,
                onDialogError: onDialogError,
                onDialogSuccess: onDialogSuccess,
                onOpenDialog: onOpenDialog
            });
        }
    }, [
        closeIssueTransitionModalAction,
        createAnalyticsEvent,
        issueKey,
        onDialogCancel,
        onDialogError,
        onDialogSuccess,
        transitionId,
        resetState
    ]);
};
const $f41d32ebe3d90af0$export$95a1e9702d78f223 = ()=>{
    const state = (0, $gjoNn.useTriggerIssueTransitionModalState)();
    const actions = (0, $gjoNn.useTriggerIssueTransitionModalActions)();
    const { openIssueTransitionModalNew: openIssueTransitionModalNew, ...restActions } = actions;
    const openIssueTransitionModal = $f41d32ebe3d90af0$export$736bd10472c63b49();
    return [
        state,
        {
            ...restActions,
            openIssueTransitionModal: openIssueTransitionModal
        }
    ];
};
var $f41d32ebe3d90af0$export$2e2bcd8739ae039 = $f41d32ebe3d90af0$export$95a1e9702d78f223;

});
parcelRegister("lTEVZ", function(module, exports) {

$parcel$export(module.exports, "fireIssueTransitionErrorAnalytics", () => $63e82840dc2f165f$export$3839c9497170b08f);

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $fukJp = parcelRequire("fukJp");
const $63e82840dc2f165f$export$3839c9497170b08f = (payload)=>{
    if (!(0, $4R6GH.fg)('issue-transition-fire-error-analytics-refactor')) return (0, $jcw0u.default)(payload);
    const { attributes: attributes = {}, error: error, ...otherPayload } = payload;
    (0, $fukJp.fireErrorAnalyticsCommon)({
        ...otherPayload,
        attributes: {
            ...attributes
        },
        error: error
    });
};

});
parcelRegister("fukJp", function(module, exports) {

$parcel$export(module.exports, "fireErrorAnalyticsCommon", () => $2a45d398159543ce$export$51f199f6846377f7);

var $jcw0u = parcelRequire("jcw0u");

var $1qgAp = parcelRequire("1qgAp");
const $2a45d398159543ce$export$51f199f6846377f7 = (payload)=>{
    const { skipSentry: skipSentry = true, attributes: attributes, ...otherPayload } = payload;
    (0, $jcw0u.default)({
        ...otherPayload,
        attributes: {
            ...attributes,
            ...(0, $1qgAp.getTenantAttributes)()
        },
        skipSentry: // skiping sentry as true for fireErrorAnalytics
        skipSentry
    });
};

});
parcelRegister("1qgAp", function(module, exports) {

$parcel$export(module.exports, "getTenantAttributes", () => $b69c35ebd4c3a77a$export$bc31ff13a0bbe592);

var $j8DrX = parcelRequire("j8DrX");

var $c04PQ = parcelRequire("c04PQ");
const $b69c35ebd4c3a77a$export$bc31ff13a0bbe592 = ()=>{
    const shard = (0, $j8DrX.default)('ajs-shard');
    const region = (0, $j8DrX.default)('ajs-region');
    return {
        shard: shard,
        region: region,
        isFedRamp: (0, $c04PQ.isFedRamp)()
    };
};

});



parcelRegister("6ikhl", function(module, exports) {

$parcel$export(module.exports, "useInlineFields", () => $d56dd4f138add558$export$71d5b5acb7d7f5ce);
$parcel$export(module.exports, "useInlineField", () => $d56dd4f138add558$export$14c9655e9d9e873c);
$parcel$export(module.exports, "useInlineFieldsActions", () => $d56dd4f138add558$export$cdb4b503c6154b35);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $5rCpD = parcelRequire("5rCpD");
// Inline fields state tracks field states in create issue view as the user interacts with them
// this is particularly needed as we want to save the field's value when the user
// unfocuses the field
const $d56dd4f138add558$var$store = (0, $iXqE5.createStore)({
    name: 'forge.inline-fields-state',
    initialState: {},
    actions: $5rCpD.default
});
const $d56dd4f138add558$export$71d5b5acb7d7f5ce = (0, $3sQ5x.createHook)($d56dd4f138add558$var$store);
const $d56dd4f138add558$export$14c9655e9d9e873c = (0, $3sQ5x.createHook)($d56dd4f138add558$var$store, {
    selector: (state, fieldId)=>state[fieldId]
});
const $d56dd4f138add558$export$cdb4b503c6154b35 = (0, $3sQ5x.createHook)($d56dd4f138add558$var$store, {
    selector: null
});

});
parcelRegister("5rCpD", function(module, exports) {

$parcel$export(module.exports, "default", () => $02373df28193ad93$export$2e2bcd8739ae039);

var $hPhpd = parcelRequire("hPhpd");
const $02373df28193ad93$var$actions = {
    setFieldState: $hPhpd.setFieldState,
    resetState: $hPhpd.resetState,
    dispatchRetryFunction: $hPhpd.dispatchRetryFunction,
    dispatchFormSubmits: $hPhpd.dispatchFormSubmits
};
var $02373df28193ad93$export$2e2bcd8739ae039 = $02373df28193ad93$var$actions;

});
parcelRegister("hPhpd", function(module, exports) {

$parcel$export(module.exports, "setFieldState", () => $9eca433be421af07$export$80fd62d9217dd703);
$parcel$export(module.exports, "resetState", () => $9eca433be421af07$export$8e84bad0b35de9e8);
$parcel$export(module.exports, "dispatchRetryFunction", () => $9eca433be421af07$export$27c59f06a7c1fe26);
$parcel$export(module.exports, "dispatchFormSubmits", () => $9eca433be421af07$export$42fd5e650971333b);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4R6GH = parcelRequire("4R6GH");


var $9J85a = parcelRequire("9J85a");
const $9eca433be421af07$export$80fd62d9217dd703 = (data)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const stateObject = {
            status: data.status !== undefined ? data.status : currentState[data.fieldId]?.status,
            formRef: data.formRef !== undefined ? data.formRef : currentState[data.fieldId]?.formRef,
            retryFunction: data.retryFunction !== undefined ? data.retryFunction : currentState[data.fieldId]?.retryFunction,
            ...(0, $4R6GH.fg)('fcf-new-submit-on-gic-and-tv') ? {
                onFormSubmit: data.onFormSubmit !== undefined ? data.onFormSubmit : currentState[data.fieldId]?.onFormSubmit
            } : {}
        };
        setState({
            ...getState(),
            [data.fieldId]: stateObject
        });
    };
const $9eca433be421af07$export$8e84bad0b35de9e8 = ()=>({ getState: getState, setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const stateToOverride = {};
        Object.getOwnPropertyNames(getState()).forEach((fieldId)=>{
            stateToOverride[fieldId] = {
                status: (0, $3e5c7761c2e3cf02$export$bbf78c43fa5268c8)
            };
        });
        setState(stateToOverride);
    };
const $9eca433be421af07$export$27c59f06a7c1fe26 = (fieldId)=>async ({ getState: getState })=>{
        const currentState = getState();
        const fieldData = currentState[fieldId];
        const retryFunction = fieldData?.retryFunction;
        retryFunction && retryFunction();
    };
const $9eca433be421af07$export$42fd5e650971333b = ()=>async ({ getState: getState })=>{
        const currentState = getState();
        Object.keys(currentState).forEach((fieldId)=>{
            if (currentState[fieldId]?.status === (0, $3e5c7761c2e3cf02$export$32bbcfb76243a487)) {
                if ((0, $4R6GH.fg)('fcf-new-submit-on-gic-and-tv')) currentState[fieldId]?.onFormSubmit?.();
                else {
                    const formRef = currentState[fieldId]?.formRef;
                    (0, $9J85a.dispatchFormSubmitAndBlurElements)(formRef);
                }
            }
        });
    };

});
const $3e5c7761c2e3cf02$export$32bbcfb76243a487 = 'FOCUSED';
const $3e5c7761c2e3cf02$export$f81c1d6b9217380c = 'PENDING';
const $3e5c7761c2e3cf02$export$2ace7d3737836262 = 'RESOLVED';
const $3e5c7761c2e3cf02$export$9956c6a700e724c4 = 'STORED';
const $3e5c7761c2e3cf02$export$742c877aeb0f3dbd = 'FAILED';
const $3e5c7761c2e3cf02$export$bbf78c43fa5268c8 = 'IDLE';
const $3e5c7761c2e3cf02$export$ae7c16bdba5e2e15 = 10000;
const $3e5c7761c2e3cf02$export$30daef8830f2505d = 'WAIT';
const $3e5c7761c2e3cf02$export$f86e250f1a7b07c8 = 'PROCEED';
const $3e5c7761c2e3cf02$export$e784a07a62e2e0e5 = 'TIMEOUT';

parcelRegister("9J85a", function(module, exports) {

$parcel$export(module.exports, "submitForgeFormField", () => $b1c36799aab2b39a$export$7e50fee868362aa2);
$parcel$export(module.exports, "dispatchFormSubmitAndBlurElements", () => $b1c36799aab2b39a$export$4d639a8e0790daf2);
$parcel$export(module.exports, "isBlurEventTriggeredOutsideTheField", () => $b1c36799aab2b39a$export$ee23412a8bea9333);

const $b1c36799aab2b39a$export$7e50fee868362aa2 = (formRef)=>{
    formRef?.current?.requestSubmit();
};
const $b1c36799aab2b39a$export$4d639a8e0790daf2 = (formRef)=>{
    $b1c36799aab2b39a$export$7e50fee868362aa2(formRef);
    if (formRef?.current?.elements) Array.from(formRef.current.elements).forEach((element)=>{
        if ('blur' in element && typeof element.blur === 'function') element?.blur();
    });
};
const $b1c36799aab2b39a$export$ee23412a8bea9333 = (fieldState, event, divRef)=>fieldState?.status === (0, $3e5c7761c2e3cf02$export$32bbcfb76243a487) && !divRef.current?.contains(event.relatedTarget);

});




parcelRegister("ct2PA", function(module, exports) {

$parcel$export(module.exports, "useIssueTransitionsOperationalAnalyticsEvent", () => $539a3126b0b48d6d$export$4d10663856b750d0);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $539a3126b0b48d6d$export$4d10663856b750d0 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireOperationalEventIssueTransitionFieldsCount = (0, $5uXOq.useCallback)(({ actionSubject: actionSubject, fieldCount: fieldCount })=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, $8zOmE.fireOperationalAnalyticsDeferred)(analyticsEvent, actionSubject, {
            fieldCount: fieldCount
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireOperationalAnalyticsPermissionsUnAvailable = (0, $5uXOq.useCallback)(({ actionSubject: actionSubject })=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, $8zOmE.fireOperationalAnalyticsDeferred)(analyticsEvent, actionSubject);
    }, [
        createAnalyticsEvent
    ]);
    const fireOperationalAnalyticsTransitionScreenOpened = (0, $5uXOq.useCallback)(({ actionSubject: actionSubject, isBenefitsModalFGEneabled: isBenefitsModalFGEneabled, preferNewIssueTransitionScreen: preferNewIssueTransitionScreen, issueViewAnalyticsSource: issueViewAnalyticsSource, isBenefitsModalDisabled: isBenefitsModalDisabled, dateToShowBenefitsModal: dateToShowBenefitsModal })=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, $8zOmE.fireOperationalAnalyticsDeferred)(analyticsEvent, actionSubject, {
            isBenefitsModalFGEneabled: isBenefitsModalFGEneabled,
            preferNewIssueTransitionScreen: preferNewIssueTransitionScreen,
            issueViewAnalyticsSource: issueViewAnalyticsSource,
            isBenefitsModalDisabled: isBenefitsModalDisabled,
            dateToShowBenefitsModal: dateToShowBenefitsModal
        });
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireOperationalEventIssueTransitionFieldsCount: fireOperationalEventIssueTransitionFieldsCount,
        fireOperationalAnalyticsPermissionsUnAvailable: fireOperationalAnalyticsPermissionsUnAvailable,
        fireOperationalAnalyticsTransitionScreenOpened: fireOperationalAnalyticsTransitionScreenOpened
    };
};

});

parcelRegister("3NlyR", function(module, exports) {

$parcel$export(module.exports, "useIssueTransitionUIAnalyticsEvent", () => $5656c248adec15f1$export$d0823e3d2e087672);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $5656c248adec15f1$export$d0823e3d2e087672 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireUIEvent = (0, $5uXOq.useCallback)(({ analyticsEvent: analyticsEvent, actionSubjectId: actionSubjectId, action: action = 'clicked', actionSubject: actionSubject, attributes: attributes = {} })=>{
        if (analyticsEvent !== undefined) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, actionSubjectId, attributes);
        else {
            const createdAnalyticsEvent = createAnalyticsEvent({
                action: action,
                actionSubject: actionSubject
            });
            (0, $8zOmE.fireUIAnalytics)(createdAnalyticsEvent, actionSubjectId, attributes);
        }
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireUIEvent: fireUIEvent
    };
};

});

parcelRegister("1btwe", function(module, exports) {

$parcel$export(module.exports, "usePublishOpenIssueTransitionModalPubSub", () => $9796b79be99bbec0$export$76b6328962c9935f);

var $5uXOq = parcelRequire("5uXOq");


var $iXy8e = parcelRequire("iXy8e");
const $9796b79be99bbec0$export$76b6328962c9935f = ()=>(0, $5uXOq.useCallback)((payload, isEnabled)=>{
        (0, $iXy8e.ITSPubSub).publish((0, $10a759732c3f1985$export$283bfc4a4b25707a), {
            payload: payload,
            isEnabled: isEnabled
        });
    }, []);

});
const $10a759732c3f1985$export$283bfc4a4b25707a = 'open-issue-transition-modal';

parcelRegister("iXy8e", function(module, exports) {

$parcel$export(module.exports, "ITSPubSub", () => $c6c4e897a3edd1a2$export$a3877931259d622e);

var $da7iT = parcelRequire("da7iT");
const $c6c4e897a3edd1a2$export$a3877931259d622e = new (0, $da7iT.PubSubHub)();
const $c6c4e897a3edd1a2$export$58b86c4766378620 = ()=>({
        ...$c6c4e897a3edd1a2$export$a3877931259d622e
    });

});
parcelRegister("da7iT", function(module, exports) {

$parcel$export(module.exports, "PubSubHub", () => $4d1dbccbbe967a62$export$e3607828f8f2c01e);
class $4d1dbccbbe967a62$export$e3607828f8f2c01e {
    constructor(){
        this.subscribers = {};
        this.subscribe = (event, subscriber)=>{
            let subs = this.subscribers[event];
            if (!subs) {
                subs = [];
                this.subscribers[event] = subs;
            }
            subs?.push(subscriber);
            return ()=>this.unsubscribe(event, subscriber);
        };
        this.unsubscribe = (event, subscriber)=>{
            const subs = this.subscribers[event];
            if (subs) this.subscribers[event] = subs.filter((subscription)=>subscription !== subscriber);
        };
        this.publish = (event, data)=>{
            const subs = this.subscribers[event];
            if (subs?.length) subs?.forEach((subscriber)=>subscriber(data));
        };
        this.clearAll = ()=>{
            this.subscribers = {};
        };
    }
}

});



parcelRegister("gjoNn", function(module, exports) {

$parcel$export(module.exports, "TriggerIssueTransitionModalContainer", () => $18f6c8628e84d111$export$8ad65e459a406a8a);
$parcel$export(module.exports, "useTriggerIssueTransitionModalActions", () => $18f6c8628e84d111$export$68de001c738e4145);
$parcel$export(module.exports, "useTriggerIssueTransitionModalState", () => $18f6c8628e84d111$export$d3aceeec551eaab5);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $QnL9H = parcelRequire("QnL9H");

var $bpOxh = parcelRequire("bpOxh");
const $18f6c8628e84d111$var$store = (0, $iXqE5.createStore)({
    name: 'issue-transition.issue-transition-form.use-trigger-issue-transition-modal',
    initialState: $QnL9H.initialState,
    actions: $bpOxh
});
const $18f6c8628e84d111$export$8ad65e459a406a8a = (0, $gg7kZ.createContainer)($18f6c8628e84d111$var$store);
const $18f6c8628e84d111$export$68de001c738e4145 = (0, $3sQ5x.createActionsHook)($18f6c8628e84d111$var$store);
const $18f6c8628e84d111$export$d3aceeec551eaab5 = (0, $3sQ5x.createStateHook)($18f6c8628e84d111$var$store);

});
parcelRegister("QnL9H", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $b1651ed43432db50$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "OPEN_MODERN_TRANSITION_MODAL", () => $b1651ed43432db50$export$7320afd6d2c7276d);
$parcel$export(module.exports, "OPEN_LEGACY_TRANSITION_MODAL", () => $b1651ed43432db50$export$8ed7400ca8e89de2);

const $b1651ed43432db50$export$d4c72bab9d6cc13a = {
    isModalOpen: false,
    isBenefitsModalOpen: false,
    isSubsequentLoad: false,
    payload: {
        issueId: '',
        issueKey: '',
        transitionId: ''
    },
    id: 'issue-transition-dialog',
    title: null,
    fetchedIssueId: '',
    triggerPointKey: (0, $b09837015a6d4fc3$export$8d987f6e80b74000),
    openLegacyTransitionsDialog: null,
    onDialogSuccess: null,
    onDialogCancel: null,
    onDialogError: null
};
const $b1651ed43432db50$export$7320afd6d2c7276d = 'OPEN_MODERN_TRANSITION_MODAL';
const $b1651ed43432db50$export$8ed7400ca8e89de2 = 'OPEN_LEGACY_TRANSITION_MODAL';

});
const $b09837015a6d4fc3$export$ef94a84e2990361c = 'issue-transition-issue-view';
const $b09837015a6d4fc3$export$de11f84a7d32933b = 'issue-transition-board-card-transition';
const $b09837015a6d4fc3$export$6c46e4003e7b7e9c = 'issue-transition-advanced-roadmaps-jira-transition';
const $b09837015a6d4fc3$export$e77cd508fbc3b5ba = 'issue-transition-backlog-inline-transition';
const $b09837015a6d4fc3$export$4edf4c3eee5081f6 = 'issue-transition-issue-view-shortcut-dialog';
const $b09837015a6d4fc3$export$27b74e685c26e665 = 'issue-transition-command-palette-status-field-transition';
const $b09837015a6d4fc3$export$290710ac08f770c0 = 'issue-transition-issue-results-shortcut-transition';
const $b09837015a6d4fc3$export$ddade13ad1b89bf0 = 'issue-transition-status-field-trigger';
const $b09837015a6d4fc3$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
const $b09837015a6d4fc3$export$2bf0e335b815a90b = 'comment';
const $b09837015a6d4fc3$export$1b8cc53b37a62399 = 'worklog';
const $b09837015a6d4fc3$export$d624b8367eb730df = 'issuelinks';


parcelRegister("bpOxh", function(module, exports) {

$parcel$export(module.exports, "closeIssueTransitionModal", () => (parcelRequire("3KYVT")).default);
$parcel$export(module.exports, "openIssueTransitionModal", () => (parcelRequire("3cIaS")).default);
$parcel$export(module.exports, "restoreState", () => (parcelRequire("keQtD")).default);
$parcel$export(module.exports, "setFetchedIssueId", () => (parcelRequire("fb5Xn")).default);
$parcel$export(module.exports, "hideBenefitsModal", () => (parcelRequire("bemkp")).default);
$parcel$export(module.exports, "openIssueTransitionModalNew", () => (parcelRequire("bnv5t")).default);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $3KYVT = parcelRequire("3KYVT");

var $3cIaS = parcelRequire("3cIaS");

var $keQtD = parcelRequire("keQtD");

var $fb5Xn = parcelRequire("fb5Xn");

var $bemkp = parcelRequire("bemkp");

var $bnv5t = parcelRequire("bnv5t");

});
parcelRegister("3KYVT", function(module, exports) {

$parcel$export(module.exports, "default", () => $09ddf425c332ed49$export$2e2bcd8739ae039);

var $QnL9H = parcelRequire("QnL9H");
const $09ddf425c332ed49$var$closeIssueTransitionModal = ()=>({ setState: setState })=>{
        setState({
            ...(0, $QnL9H.initialState),
            isModalOpen: false,
            isSubsequentLoad: true
        });
    };
var $09ddf425c332ed49$export$2e2bcd8739ae039 = $09ddf425c332ed49$var$closeIssueTransitionModal;

});

parcelRegister("3cIaS", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc7e957c004b1c31$export$2e2bcd8739ae039);

var $8Rkzz = parcelRequire("8Rkzz");

var $eVcDT = parcelRequire("eVcDT");

var $emTT1 = parcelRequire("emTT1");

var $lTEVZ = parcelRequire("lTEVZ");

var $jtjyW = parcelRequire("jtjyW");

var $jHYHS = parcelRequire("jHYHS");
const $cc7e957c004b1c31$var$openIssueTransitionModal = (nextState, preferNewIssueTransitionScreen = true)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const { payload: { issueKey: issueKey = '', transitionId: transitionId = '' }, onDialogSuccess: onDialogSuccess, onDialogCancel: onDialogCancel, onDialogError: onDialogError, triggerPointKey: triggerPointKey } = nextState || {
            payload: {}
        };
        let transitionModalVersion = '';
        const isNewITSEnabled = (0, $jHYHS.isNewTransitionScreenEnabled)(preferNewIssueTransitionScreen, triggerPointKey);
        try {
            if (isNewITSEnabled) {
                transitionModalVersion = 'NEW';
                (0, $jtjyW.startIssueTransitionMetrics)(currentState.isSubsequentLoad);
                setState({
                    ...currentState,
                    isModalOpen: true,
                    // making fetchedIssueId as blank to ensure we donot end up using stale issueId
                    fetchedIssueId: '',
                    ...nextState
                });
            } else {
                transitionModalVersion = 'OLD';
                (0, $emTT1.timeToRenderTransitionModal).start();
                new (0, $eVcDT.default)({
                    issueKey: issueKey,
                    transitionId: transitionId
                }).onDialogSuccess(onDialogSuccess || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).onDialogCancel(onDialogCancel || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).onDialogError(onDialogError || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).show();
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $lTEVZ.fireIssueTransitionErrorAnalytics)({
                meta: {
                    id: 'transitionIssueTrigger',
                    packageName: 'jiraIssueTransitionTrigger',
                    teamName: 'gryffindor'
                },
                error: error,
                attributes: {
                    transitionModalVersion: transitionModalVersion
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
var $cc7e957c004b1c31$export$2e2bcd8739ae039 = $cc7e957c004b1c31$var$openIssueTransitionModal;

});
parcelRegister("eVcDT", function(module, exports) {

$parcel$export(module.exports, "default", () => $25bfe0b90f22578e$export$2e2bcd8739ae039);

var $8Rkzz = parcelRequire("8Rkzz");

var $6BZYo = parcelRequire("6BZYo");
var $ig88W = parcelRequire("ig88W");
var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");
var $8JNtu = parcelRequire("8JNtu");

var $4tcSU = parcelRequire("4tcSU");

var $4R6GH = parcelRequire("4R6GH");

var $emTT1 = parcelRequire("emTT1");
class $25bfe0b90f22578e$export$2e2bcd8739ae039 {
    constructor({ issueId: issueId, transitionId: transitionId, issueKey: issueKey, issueKeys: issueKeys }){
        this.onDialogSuccessCallback = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
        this.onDialogErrorCallback = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
        this.onDialogCancelCallback = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
        this.issueId = issueId;
        this.transitionId = transitionId;
        this.issueKey = issueKey;
        this.issueKeys = issueKeys;
    }
    static{
        this.onDialogContentReady = ()=>{
            // This event fired by a dialog before the dialog itself is rendered and visible to the user
            // That's why we need to postpone sending the response to the next moment after it became visible
            setTimeout(()=>{
                (0, $emTT1.timeToRenderTransitionModal).stop();
            });
        };
    }
    onDialogSuccess(onDialogSuccessCallback) {
        this.onDialogSuccessCallback = onDialogSuccessCallback;
        return this;
    }
    onDialogError(onDialogErrorCallback) {
        this.onDialogErrorCallback = onDialogErrorCallback;
        return this;
    }
    onDialogCancel(onDialogCancelCallback) {
        this.onDialogCancelCallback = onDialogCancelCallback;
        return this;
    }
    getIssueParam() {
        if (this.issueId != null) return `id=${this.issueId}`;
        if (this.issueKey != null) return `key=${this.issueKey}`;
        return '';
    }
    getUrl() {
        const { issueKeys: issueKeys } = this;
        if (issueKeys != null) // key= is needed to be sent together with keys= because of legacy API
        return `/secure/BulkTransitionIssue!default.jspa?keys=${issueKeys.join(',')}&key=${issueKeys[0]}&action=${this.transitionId}&atl_token=${(0, $4tcSU.default)() || ''}&decorator=dialog&inline=true&returnUrl=`;
        return `/secure/WorkflowUIDispatcher.jspa?${this.getIssueParam()}&action=${this.transitionId}&atl_token=${(0, $4tcSU.default)() || ''}&returnUrl=`;
    }
    async show() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('legacyJiraDialogContentReady', $25bfe0b90f22578e$export$2e2bcd8739ae039.onDialogContentReady);
        let FormDialog;
        /**
		 * Trying out different ways of load the AMD bundle for legacy issue transition dialog
		 */ /* eslint-disable jira/wrm/no-load-bridge */ if ((0, $4R6GH.fg)('legacy-its-modal-load-with-load-bridge-weak')) FormDialog = await (0, $9B86Q.loadBridgeWeak)({
            name: 'jira/dialog/form-dialog'
        });
        else if ((0, $4R6GH.fg)('legacy-its-modal-load-with-load-bridge-strict')) {
            await (0, $cQZXC.waitForHeritage)();
            FormDialog = await (0, $7T84i.loadBridgeStrict)({
                name: 'jira/dialog/form-dialog',
                wrmKeys: [
                    'wrc!jira.webresources:dialogs'
                ]
            });
        } else if ((0, $4R6GH.fg)('legacy-issue-transition-load-bridge')) {
            await (0, $8JNtu.wrmRequire)([
                'wrc!jira.webresources:dialogs'
            ]);
            FormDialog = await (0, $ig88W.loadBridgeRace)({
                name: 'jira/dialog/form-dialog',
                timeout: 2000
            });
        } else FormDialog = await (0, $6BZYo.loadBridge)({
            name: 'jira/dialog/form-dialog',
            wrmKeys: 'wrc!jira.webresources:dialogs'
        });
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const dialog = new FormDialog({
            id: 'edit-issue-dialog',
            ajaxOptions: {
                url: this.getUrl(),
                dataType: 'json'
            },
            autoClose: true,
            widthClass: 'large',
            onDialogFinished: this.onDialogSuccessCallback,
            onUnSuccessfulSubmit: this.onDialogErrorCallback,
            shouldLoadHeritageFormDialogContext: true
        });
        const cancelNativeHandler = (event)=>{
            if (!(event instanceof CustomEvent)) return;
            const dialogElement = event.detail.popup;
            const { reason: reason } = event.detail;
            if (dialogElement.is(dialog.get$popup())) {
                if (reason === 'cancel' || reason === 'esc') this.onDialogCancelCallback(event, dialogElement, reason);
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                document.removeEventListener('legacyJiraDialogBeforeHide', cancelNativeHandler);
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                document.removeEventListener('legacyJiraDialogContentReady', $25bfe0b90f22578e$export$2e2bcd8739ae039.onDialogContentReady);
            }
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('legacyJiraDialogBeforeHide', cancelNativeHandler);
        dialog.show();
    }
}

});
parcelRegister("emTT1", function(module, exports) {

$parcel$export(module.exports, "timeToRenderTransitionModal", () => $4a78c80c71ff3414$export$9d20a86383e90d09);

var $dGrdR = parcelRequire("dGrdR");
const $4a78c80c71ff3414$export$9d20a86383e90d09 = (0, $dGrdR.metrics).interaction({
    key: 'issue.time-to.render-issue-transition-screen',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '500_1000_2500_4000_7000_10000'
    }
});

});


parcelRegister("jtjyW", function(module, exports) {

$parcel$export(module.exports, "startIssueTransitionMetrics", () => $1832266ecf87e128$export$3fc439100e136a52);

var $eTXmK = parcelRequire("eTXmK");

var $lL2Jl = parcelRequire("lL2Jl");

var $lP1Jn = parcelRequire("lP1Jn");

var $fc6nm = parcelRequire("fc6nm");
const $1832266ecf87e128$export$3fc439100e136a52 = (isSubsequentLoad)=>{
    (0, $lL2Jl.IssueTransitionLoadUFOExperience).start();
    (0, $lL2Jl.IssueTransitionUFOExperience).start();
    const issueTransitionModalLoadMetric = isSubsequentLoad ? (0, $lP1Jn.issueTransittionModalLoadSubsequent) : (0, $lP1Jn.issueTransitionModalLoad);
    if (isSubsequentLoad) (0, $eTXmK.default)('issue-transition.transition-modal-subsequent');
    else (0, $eTXmK.default)('issue-transition.transition-modal');
    issueTransitionModalLoadMetric.start();
    (0, $fc6nm.startUimTTI)();
};

});
parcelRegister("lL2Jl", function(module, exports) {

$parcel$export(module.exports, "IssueTransitionLoadUFOExperience", () => $f07939f1a4892f29$export$8fb308d8abecd81a);
$parcel$export(module.exports, "IssueTransitionSubmitUFOExpereince", () => $f07939f1a4892f29$export$bd3bf8b90a131c50);
$parcel$export(module.exports, "IssueTransitionUFOExperience", () => $f07939f1a4892f29$export$2f3b26e8acf79182);

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
const $f07939f1a4892f29$export$8fb308d8abecd81a = new (0, $duUGa.UFOExperience)('issue-transition-screen.transition-load', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
    category: 'issue-transition-screen.transition-load'
});
const $f07939f1a4892f29$export$bd3bf8b90a131c50 = new (0, $duUGa.UFOExperience)('issue-transition-screen.transition-submit', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
    category: 'issue-transition-screen.transition-sumbit'
});
const $f07939f1a4892f29$export$2f3b26e8acf79182 = new (0, $duUGa.UFOExperience)('issue-transition-screen.transition-issue', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
    category: 'issue-transition-screen.transition-issue'
});

});

parcelRegister("lP1Jn", function(module, exports) {

$parcel$export(module.exports, "issueTransitionModalLoad", () => $e48205cb6c384272$export$772fb4a8bd181fd6);
$parcel$export(module.exports, "issueTransittionModalLoadSubsequent", () => $e48205cb6c384272$export$afa89f024c56a00a);

var $dGrdR = parcelRequire("dGrdR");
const $e48205cb6c384272$export$772fb4a8bd181fd6 = (0, $dGrdR.metrics).interaction({
    key: 'issue-transition-modal'
});
const $e48205cb6c384272$export$afa89f024c56a00a = (0, $dGrdR.metrics).interaction({
    key: 'issue-transition-modal-subsequent'
});

});

parcelRegister("fc6nm", function(module, exports) {

$parcel$export(module.exports, "startUimTTI", () => $50f6a9f98192a4eb$export$ae34c17d9cd2c876);
$parcel$export(module.exports, "markIssueTransitionLoaded", () => $50f6a9f98192a4eb$export$7cc1bb35860c7c25);
$parcel$export(module.exports, "stopTTI", () => $50f6a9f98192a4eb$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $50f6a9f98192a4eb$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $50f6a9f98192a4eb$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $50f6a9f98192a4eb$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $50f6a9f98192a4eb$export$d86f4868694f2aa7);
/**
 * For issue view, we moved similar constants to view-specific packages.
 * However, for issue-transition, such a move causes a circular dependency with @atlassian/jira-issue-transition-trigger package,
 * since view-specific/issue-transition imports trigger points related functionality from @atlassian/jira-issue-transition-trigger.
 * Therefore, for now, let's keep it here.
 */ 
var $dGrdR = parcelRequire("dGrdR");
const $50f6a9f98192a4eb$var$uimInIssueTransitionTTI = (0, $dGrdR.metrics).interaction({
    key: 'ui-modifications-in-issue-transition',
    timings: [
        {
            key: 'issue-transition-tti-delta',
            startMark: 'issue-transition-tti'
        },
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        }
    ]
});
const $50f6a9f98192a4eb$export$ae34c17d9cd2c876 = ()=>{
    $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.start();
};
const $50f6a9f98192a4eb$export$7cc1bb35860c7c25 = ()=>$50f6a9f98192a4eb$var$uimInIssueTransitionTTI.mark('issue-transition-tti');
const $50f6a9f98192a4eb$export$30ca4c461fab486c = (customData)=>{
    $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.stop({
        customData: customData
    });
};
const $50f6a9f98192a4eb$export$27f2445288b528c = ()=>{
    $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.cancel();
};
const $50f6a9f98192a4eb$export$7a2709fc1e33401a = ()=>{
    $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.mark('iframe-load');
};
const $50f6a9f98192a4eb$export$cf3893335c93e33b = ()=>{
    $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.mark('fields-registered');
};
const $50f6a9f98192a4eb$export$d86f4868694f2aa7 = ()=>{
    $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.mark('oninit-resolved');
};

});


parcelRegister("jHYHS", function(module, exports) {

$parcel$export(module.exports, "isNewTransitionScreenEnabled", () => $5f3a7dc1f1182e00$export$1f5b72e7dbe0548d);

var $c04PQ = parcelRequire("c04PQ");

var $4R6GH = parcelRequire("4R6GH");
const $5f3a7dc1f1182e00$export$1f5b72e7dbe0548d = (preferNewIssueTransitionScreen, triggerPointKey)=>{
    if ((0, $c04PQ.isFedRamp)()) return true;
    if (!(0, $4R6GH.fg)('render-modern-issue-transition')) return false;
    if (!triggerPointKey) return false;
    return preferNewIssueTransitionScreen || (0, $4R6GH.fg)('issue-transition-customisation-for-srb');
};

});


parcelRegister("keQtD", function(module, exports) {

$parcel$export(module.exports, "default", () => $9984214aecd9b0cd$export$2e2bcd8739ae039);
const $9984214aecd9b0cd$var$restoreState = (stateToRestore)=>({ setState: setState })=>{
        setState(stateToRestore);
    };
var $9984214aecd9b0cd$export$2e2bcd8739ae039 = $9984214aecd9b0cd$var$restoreState;

});

parcelRegister("fb5Xn", function(module, exports) {

$parcel$export(module.exports, "default", () => $58f04f71b4951234$export$2e2bcd8739ae039);
/**
 *
 * @deprecated since we should not be using this in the log run
 * we should not call this method any where and should clean this up as soon as GIC-JIS migration is done
 * @param issueId
 * @returns
 */ const $58f04f71b4951234$var$setFetchedIssueId = (issueId)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const { fetchedIssueId: fetchedIssueId } = currentState;
        if (issueId !== fetchedIssueId) setState({
            ...currentState,
            fetchedIssueId: issueId
        });
    };
var $58f04f71b4951234$export$2e2bcd8739ae039 = $58f04f71b4951234$var$setFetchedIssueId;

});

parcelRegister("bemkp", function(module, exports) {

$parcel$export(module.exports, "default", () => $66c42f9cd1814e06$export$2e2bcd8739ae039);

var $QnL9H = parcelRequire("QnL9H");

var $jtjyW = parcelRequire("jtjyW");
const $66c42f9cd1814e06$var$hideBenefitsModal = (nextAction)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (nextAction === (0, $QnL9H.OPEN_MODERN_TRANSITION_MODAL)) {
            (0, $jtjyW.startIssueTransitionMetrics)(currentState.isSubsequentLoad);
            setState({
                ...currentState,
                isBenefitsModalOpen: false,
                isModalOpen: true
            });
        } else if (nextAction === (0, $QnL9H.OPEN_LEGACY_TRANSITION_MODAL)) {
            const { openLegacyTransitionsDialog: openLegacyTransitionsDialog } = getState();
            setState({
                ...currentState,
                isBenefitsModalOpen: false,
                isModalOpen: false
            });
            openLegacyTransitionsDialog?.();
        }
    };
var $66c42f9cd1814e06$export$2e2bcd8739ae039 = $66c42f9cd1814e06$var$hideBenefitsModal;

});

parcelRegister("bnv5t", function(module, exports) {

$parcel$export(module.exports, "default", () => $0522276a96c69778$export$2e2bcd8739ae039);

var $8Rkzz = parcelRequire("8Rkzz");

var $eVcDT = parcelRequire("eVcDT");

var $emTT1 = parcelRequire("emTT1");

var $lTEVZ = parcelRequire("lTEVZ");

var $4R6GH = parcelRequire("4R6GH");

var $jtjyW = parcelRequire("jtjyW");

var $jHYHS = parcelRequire("jHYHS");
const $0522276a96c69778$var$openIssueTransitionModalNew = ({ nextState: nextState, preferNewIssueTransitionScreen: preferNewIssueTransitionScreen = true, issueViewAnalyticsSource: issueViewAnalyticsSource, publishTriggerToOpenTransitions: publishTriggerToOpenTransitions, isBenefitsModalDisabled: isBenefitsModalDisabled, dateToShowBenefitsModal: dateToShowBenefitsModal, fireUIEvent: fireUIEvent })=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const { payload: { issueKey: issueKey = '', transitionId: transitionId = '' }, onDialogSuccess: onDialogSuccess, onDialogCancel: onDialogCancel, onDialogError: onDialogError, triggerPointKey: triggerPointKey } = nextState || {
            payload: {}
        };
        let transitionModalVersion = '';
        const isNewITSEnabled = (0, $jHYHS.isNewTransitionScreenEnabled)(preferNewIssueTransitionScreen, triggerPointKey);
        try {
            if (isNewITSEnabled) {
                if (issueViewAnalyticsSource === 'connect-issue') {
                    publishTriggerToOpenTransitions?.(nextState, preferNewIssueTransitionScreen);
                    fireUIEvent?.({
                        actionSubject: 'issueTransition',
                        actionSubjectId: 'connectIssue',
                        action: 'opened'
                    });
                    return;
                }
                transitionModalVersion = 'NEW';
                (0, $jtjyW.startIssueTransitionMetrics)(currentState.isSubsequentLoad);
                setState({
                    ...currentState,
                    isModalOpen: true,
                    // making fetchedIssueId as blank to ensure we donot end up using stale issueId
                    fetchedIssueId: '',
                    ...nextState
                });
                return;
            }
            const currentDate = new Date();
            const showBenefitsModalOnDate = dateToShowBenefitsModal && dateToShowBenefitsModal !== 'null' ? new Date(dateToShowBenefitsModal) : new Date(-1);
            const isDateToShowBenefitsModalLessThanCurrentDate = currentDate >= showBenefitsModalOnDate;
            if (!isBenefitsModalDisabled && issueViewAnalyticsSource !== 'connect-issue' && isDateToShowBenefitsModalLessThanCurrentDate && (0, $4R6GH.fg)('render-modern-issue-transition')) {
                // add condition to show BenefitsModal
                transitionModalVersion = 'NEW';
                const callback = ()=>{
                    (0, $emTT1.timeToRenderTransitionModal).start();
                    new (0, $eVcDT.default)({
                        issueKey: issueKey,
                        transitionId: transitionId
                    }).onDialogSuccess(onDialogSuccess || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).onDialogCancel(onDialogCancel || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).onDialogError(onDialogError || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).show();
                };
                setState({
                    ...currentState,
                    isBenefitsModalOpen: true,
                    // making fetchedIssueId as blank to ensure we donot end up using stale issueId
                    fetchedIssueId: '',
                    ...nextState,
                    openLegacyTransitionsDialog: callback
                });
            } else {
                transitionModalVersion = 'OLD';
                (0, $emTT1.timeToRenderTransitionModal).start();
                new (0, $eVcDT.default)({
                    issueKey: issueKey,
                    transitionId: transitionId
                }).onDialogSuccess(onDialogSuccess || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).onDialogCancel(onDialogCancel || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).onDialogError(onDialogError || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).show();
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $lTEVZ.fireIssueTransitionErrorAnalytics)({
                meta: {
                    id: 'transitionIssueTrigger',
                    packageName: 'jiraIssueTransitionTrigger',
                    teamName: 'gryffindor'
                },
                error: error,
                attributes: {
                    transitionModalVersion: transitionModalVersion
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
var $0522276a96c69778$export$2e2bcd8739ae039 = $0522276a96c69778$var$openIssueTransitionModalNew;

});



parcelRegister("ipUU1", function(module, exports) {

$parcel$export(module.exports, "openLegacyIssueTransitionModal", () => $f258fa9a0604f29b$export$6bfef2005bd55204);

var $8Rkzz = parcelRequire("8Rkzz");

var $eVcDT = parcelRequire("eVcDT");

var $emTT1 = parcelRequire("emTT1");

var $lTEVZ = parcelRequire("lTEVZ");
const $f258fa9a0604f29b$export$6bfef2005bd55204 = ({ issueKey: issueKey, transitionId: transitionId, onDialogSuccess: onDialogSuccess, onDialogCancel: onDialogCancel, onDialogError: onDialogError, isReopenScenario: isReopenScenario = false, onOpenDialog: onOpenDialog })=>{
    try {
        (0, $emTT1.timeToRenderTransitionModal).start();
        new (0, $eVcDT.default)({
            issueKey: issueKey,
            transitionId: transitionId
        }).onDialogSuccess(onDialogSuccess || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).onDialogCancel(onDialogCancel || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).onDialogError(onDialogError || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).show();
        onOpenDialog?.();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $lTEVZ.fireIssueTransitionErrorAnalytics)({
            meta: {
                id: 'transitionIssueTrigger',
                packageName: 'jiraIssueTransitionTrigger',
                teamName: 'gryffindor'
            },
            error: error,
            attributes: {
                transitionModalVersion: 'OLD',
                isReopenScenario: isReopenScenario
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});


parcelRegister("f7vcs", function(module, exports) {

$parcel$export(module.exports, "isIssueTransitionModalOpen", () => $36e6d5fee96d6523$export$635dff68cff1d935);
$parcel$export(module.exports, "getPayloadForIssueTransitionModal", () => $36e6d5fee96d6523$export$c7eee86986a78e72);
$parcel$export(module.exports, "getHandlersForIssueTransitionModal", () => $36e6d5fee96d6523$export$514262e3dee62ae2);

var $dGvGJ = parcelRequire("dGvGJ");

var $8Rkzz = parcelRequire("8Rkzz");
const $36e6d5fee96d6523$var$getUiIssueTransitionModal = (state)=>state.ui.issueTransitionModal;
const $36e6d5fee96d6523$export$635dff68cff1d935 = (state)=>Boolean($36e6d5fee96d6523$var$getUiIssueTransitionModal(state)?.isOpen);
const $36e6d5fee96d6523$var$getSelectedIssueActionPayload = (state)=>$36e6d5fee96d6523$var$getUiIssueTransitionModal(state);
const $36e6d5fee96d6523$var$noSelectedIssue = {
    issueId: '',
    issueKey: '',
    transitionId: ''
};
const $36e6d5fee96d6523$export$c7eee86986a78e72 = (0, $dGvGJ.createSelector)([
    $36e6d5fee96d6523$var$getSelectedIssueActionPayload
], (issuePayload)=>{
    if (issuePayload?.isOpen) return {
        issueId: issuePayload.issueId,
        issueKey: issuePayload.issueKey,
        transitionId: issuePayload.transitionId
    };
    return $36e6d5fee96d6523$var$noSelectedIssue;
});
const $36e6d5fee96d6523$var$noHandlers = {
    onDialogCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onDialogError: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onDialogSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
const $36e6d5fee96d6523$export$514262e3dee62ae2 = (0, $dGvGJ.createSelector)([
    $36e6d5fee96d6523$var$getSelectedIssueActionPayload
], (issuePayload)=>{
    if (issuePayload?.isOpen) {
        const { onDialogCancel: onDialogCancel = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onDialogError: onDialogError = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onDialogSuccess: onDialogSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) } = issuePayload;
        return {
            onDialogCancel: onDialogCancel,
            onDialogError: onDialogError,
            onDialogSuccess: onDialogSuccess
        };
    }
    return $36e6d5fee96d6523$var$noHandlers;
});

});


parcelRegister("e2cKU", function(module, exports) {

$parcel$export(module.exports, "default", () => $461c8fb9218d005e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");

var $hZHze = parcelRequire("hZHze");

var $9fuVs = parcelRequire("9fuVs");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $8ikZj = parcelRequire("8ikZj");

var $ctrpc = parcelRequire("ctrpc");

var $5fc53 = parcelRequire("5fc53");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $1ppIJ = parcelRequire("1ppIJ");


var $lReb9 = parcelRequire("lReb9");

var $6GNN7 = parcelRequire("6GNN7");

var $4mqko = parcelRequire("4mqko");

var $5Eoed = parcelRequire("5Eoed");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");

var $fC5rN = parcelRequire("fC5rN");

var $f01qr = parcelRequire("f01qr");

var $831wI = parcelRequire("831wI");
function $461c8fb9218d005e$export$2ddffba95706b42d() {
    const data = (0, $c1MAf.useBacklogSelector)((state)=>{
        const cards = (0, $dGljH.getCards)(state);
        const modalData = (0, $fC5rN.getOpenModalData)(state);
        if (!modalData || modalData.type !== (0, $b107c54ec82f76f2$export$86a0c18887a92eae)) return {};
        return {
            confirmActionPayload: modalData.payload.confirmActionPayload,
            originCardListName: modalData.payload.originCardListName,
            destinationCardListName: modalData.payload.destinationCardListName,
            analyticsEvent: modalData.payload.analyticsEvent,
            cards: modalData.payload.cardIds// Make sure the card exists
            .filter((id)=>cards[String(id)]).map((id)=>cards[String(id)])
        };
    });
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    /*
       Should only need to create this once since the modal is closed
       by either confirm or cancel
     */ const analyticsEvent = createAnalyticsEvent({
        actionSubject: 'button',
        action: 'clicked'
    });
    const onClose = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'cancelButton');
        dispatch((0, $5Eoed.closeModal)());
        if (data.cards?.length === 1 && (0, $4R6GH.fg)('one_event_rules_them_all_fg')) (0, $ctrpc.getUpdateAnalyticsFlowHelper)().endSession((0, $8ikZj.FIELD_TYPE_MAP)[0, $5fc53.SPRINT_TYPE]);
    }, [
        analyticsEvent,
        data.cards?.length,
        dispatch
    ]);
    const onMove = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'confirmButton');
        // Wrapping in an if as confirmActionPayload has the potential to be undefined
        if (data.confirmActionPayload) {
            dispatch((0, $6GNN7.cardsMoveRequest)(data.confirmActionPayload, data.analyticsEvent));
            dispatch((0, $4mqko.cardSingleSelect)(data.cards[0].id));
            dispatch((0, $lReb9.cardFocus)(data.cards[0].id));
        }
        if (data.cards?.length === 1 && (0, $4R6GH.fg)('one_event_rules_them_all_fg')) {
            const sourceCardListId = data.analyticsEvent?.payload?.attributes?.source;
            const destinationCardListId = data.analyticsEvent?.payload?.attributes?.target;
            const actionTaken = destinationCardListId ? (0, $f01qr.getEndAnalyticsSprintActionTaken)(sourceCardListId, destinationCardListId) : undefined;
            const isDragEditing = (0, $ctrpc.eventFlowManager).extraAttributes.get((0, $8ikZj.DRAG_DROP_UNKNOWN_FIELD_ID))?.isDragEditing;
            (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd(isDragEditing ? (0, $8ikZj.DRAG_DROP_UNKNOWN_FIELD_ID) : (0, $8ikZj.FIELD_TYPE_MAP)[0, $5fc53.SPRINT_TYPE], {
                analytics: createAnalyticsEvent({}),
                attributes: {
                    fieldType: (0, $5fc53.SPRINT_TYPE),
                    fieldKey: isDragEditing ? (0, $8ikZj.FIELD_TYPE_MAP)[0, $5fc53.SPRINT_TYPE] : undefined,
                    isDragEditing: isDragEditing,
                    ...isDragEditing && (0, $4R6GH.fg)('one_event_improvements_1') && {
                        issueId: data.cards[0].id
                    },
                    ...(0, $4R6GH.fg)('one_event_iteration_3') && {
                        actionTaken: actionTaken
                    }
                }
            });
        }
        onClose();
    }, [
        analyticsEvent,
        data.confirmActionPayload,
        data.cards,
        data.analyticsEvent,
        onClose,
        dispatch,
        createAnalyticsEvent
    ]);
    const renderMovedIssues = (0, $5uXOq.useCallback)(()=>{
        const cards = data.cards || [];
        if (cards.length <= 0) return null;
        if (cards.length === 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $831wI.default).movedOneCard,
            values: {
                cardName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, cards[0].key),
                originCardListName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, data.originCardListName),
                destinationCardListName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, data.destinationCardListName)
            }
        });
        if (cards.length === 2) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $831wI.default).movedTwoCards,
            values: {
                cardName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, cards[0].key),
                anotherCardName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, cards[1].key),
                originCardListName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, data.originCardListName),
                destinationCardListName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, data.destinationCardListName)
            }
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $831wI.default).movedMoreCardsIssueTermRefresh : (0, $831wI.default).movedMoreCards,
            values: {
                cardName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, cards[0].key),
                anotherCardName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, cards[1].key),
                originCardListName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, data.originCardListName),
                destinationCardListName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, data.destinationCardListName),
                moreCardsCountText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, cards.length - 2),
                moreCardsCount: cards.length - 2
            }
        });
    }, [
        data
    ]);
    const buttonCancel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        onClick: onClose,
        key: "buttonCancel"
    }, formatMessage((0, $831wI.default).cancel));
    const buttonConfirm = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "primary",
        onClick: onMove,
        key: "buttonConfirm"
    }, formatMessage((0, $831wI.default).confirm));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1ppIJ.ModalDialog), {
        messageId: "software-backlog.modals.move-cards-active-sprint-modal.modal-dialog",
        messageType: "transactional",
        width: 400,
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), {
        appearance: "warning"
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $831wI.default).titleIssueTermRefresh : (0, $831wI.default).title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $831wI.default).changedScope)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", {
        "data-testid": "software-backlog.modals.move-cards-active-sprint-modal.content"
    }, renderMovedIssues()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZHze.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, [
        buttonCancel,
        buttonConfirm
    ])));
}
function $461c8fb9218d005e$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
        sourceName: "moveCardsActiveSprint"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($461c8fb9218d005e$export$2ddffba95706b42d, null));
}

});
parcelRegister("831wI", function(module, exports) {

$parcel$export(module.exports, "default", () => $70bca34109ac4c91$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $70bca34109ac4c91$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "backlog.modals.move-cards-active-sprint-modal.title",
        "defaultMessage": "Move issues"
    },
    changedScope: {
        "id": "backlog.modals.move-cards-active-sprint-modal.changed-scope",
        "defaultMessage": "Sprint scope will be affected by this action."
    },
    movedOneCard: {
        "id": "backlog.modals.move-cards-active-sprint-modal.moved-one-card",
        "defaultMessage": "{cardName} will be moved from sprint {originCardListName} to sprint {destinationCardListName}."
    },
    movedTwoCards: {
        "id": "backlog.modals.move-cards-active-sprint-modal.moved-two-cards",
        "defaultMessage": "{cardName} and {anotherCardName} will be moved from sprint {originCardListName} to sprint {destinationCardListName}."
    },
    movedMoreCards: {
        "id": "backlog.modals.move-cards-active-sprint-modal.moved-more-cards",
        "defaultMessage": "{cardName}, {anotherCardName} and {moreCardsCountText} more {moreCardsCount, plural, one {issue} other {issues}} will be moved from sprint {originCardListName} to sprint {destinationCardListName}."
    },
    confirm: {
        "id": "backlog.modals.move-cards-active-sprint-modal.confirm",
        "defaultMessage": "Confirm"
    },
    cancel: {
        "id": "backlog.modals.move-cards-active-sprint-modal.cancel",
        "defaultMessage": "Cancel"
    },
    titleIssueTermRefresh: {
        "id": "backlog.modals.move-cards-active-sprint-modal.title-issue-term-refresh",
        "defaultMessage": "Move work items"
    },
    movedMoreCardsIssueTermRefresh: {
        "id": "backlog.modals.move-cards-active-sprint-modal.moved-more-cards-issue-term-refresh",
        "defaultMessage": "{cardName}, {anotherCardName} and {moreCardsCountText} more {moreCardsCount, plural, one {work item} other {work items}} will be moved from sprint {originCardListName} to sprint {destinationCardListName}."
    }
});

});


parcelRegister("1vE6g", function(module, exports) {

$parcel$export(module.exports, "SelectTransitionsModal", () => $c9f7d4a79e685bda$export$ccd1f82a2bacb02);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");
var $i8Qvm = parcelRequire("i8Qvm");

var $3rLiX = parcelRequire("3rLiX");

var $7NYq5 = parcelRequire("7NYq5");

var $hZHze = parcelRequire("hZHze");

var $9fuVs = parcelRequire("9fuVs");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");


var $6GNN7 = parcelRequire("6GNN7");

var $5Eoed = parcelRequire("5Eoed");

var $c1MAf = parcelRequire("c1MAf");

var $fC5rN = parcelRequire("fC5rN");

var $lSZAF = parcelRequire("lSZAF");
const $c9f7d4a79e685bda$var$getOptions = (transitions)=>transitions.map((transition)=>({
            name: 'transition',
            value: String(transition.id),
            label: transition.name
        }));
function $c9f7d4a79e685bda$export$ccd1f82a2bacb02() {
    const [selectedTransitionId, setSelectedTransitionId] = (0, $5uXOq.useState)(undefined);
    const [isDisabled, setIsDisabled] = (0, $5uXOq.useState)(true);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const modalAnalyticsEvent = createAnalyticsEvent({
        actionSubject: 'button',
        action: 'clicked'
    });
    const modalData = (0, $c1MAf.useBacklogSelector)((state)=>{
        const modal = (0, $fC5rN.getOpenModalData)(state);
        return modal && modal.type === (0, $b107c54ec82f76f2$export$dcb8eb3e585ecde) ? modal.payload : null;
    });
    const onSelectionChange = (0, $5uXOq.useCallback)(({ currentTarget: { value: value } })=>{
        if (value) {
            setSelectedTransitionId(Number(value));
            setIsDisabled(false);
        }
    }, [
        setIsDisabled,
        setSelectedTransitionId
    ]);
    if (!modalData) return null;
    const { cardKeys: cardKeys, transitions: transitions, moveCardsActionPayload: moveCardsActionPayload, optimisticId: optimisticId, analyticsEvent: analyticsEvent } = modalData;
    const onCancel = ()=>{
        (0, $8zOmE.fireUIAnalytics)(modalAnalyticsEvent, 'cancelButton');
        dispatch((0, $6GNN7.cardsMoveCancel)(optimisticId, analyticsEvent));
        dispatch((0, $5Eoed.closeModal)());
    };
    const onChoose = ()=>{
        (0, $8zOmE.fireUIAnalytics)(modalAnalyticsEvent, 'chooseTransitionButton');
        selectedTransitionId && dispatch((0, $6GNN7.cardsMoveNonOptimisticRequest)(optimisticId, {
            ...moveCardsActionPayload,
            selectedTransition: transitions.find((transition)=>transition.id === selectedTransitionId)
        }, analyticsEvent));
        dispatch((0, $5Eoed.closeModal)());
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
        sourceName: "selectTransition"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        messageId: "software-backlog.modals.select-transitions-modal.modal-dialog.software-backlog-select-transitions-modal.modal-dialog",
        messageType: "transactional",
        onClose: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), null, formatMessage((0, $lSZAF.messages).title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lSZAF.messages).descriptionIssueTermRefresh : (0, $lSZAF.messages).description, {
        count: transitions.length,
        cardKeys: cardKeys.join(', ')
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3rLiX.default), {
        onChange: onSelectionChange,
        options: $c9f7d4a79e685bda$var$getOptions(transitions)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZHze.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        onClick: onCancel
    }, formatMessage((0, $lSZAF.messages).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        isDisabled: isDisabled,
        appearance: "primary",
        onClick: onChoose,
        autoFocus: true
    }, formatMessage((0, $lSZAF.messages).choose)))))));
}

});
parcelRegister("3rLiX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ca8b717dad009c8c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");

var $9KnKW = parcelRequire("9KnKW");

var $jouoW = parcelRequire("jouoW");
const $ca8b717dad009c8c$var$noOptions = [];
function $ca8b717dad009c8c$export$2e2bcd8739ae039(props) {
    const { onChange: onChange, options: options = $ca8b717dad009c8c$var$noOptions, value: propValue, defaultValue: defaultValue, id: id, isDisabled: isDisabled, isRequired: isRequired, isInvalid: isInvalid, onInvalid: onInvalid = (0, $eGmKJ.default), name: name, analyticsContext: analyticsContext, ['aria-labelledby']: ariaLabelledBy, testId: testId } = props;
    const uid = (0, $9KnKW.useId)();
    const [selectedValue, setSelectedValue] = (0, $5uXOq.useState)(propValue !== undefined ? propValue : defaultValue);
    const onRadioChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        setSelectedValue(e.currentTarget.value);
        if (onChange) onChange(e, analyticsEvent);
    }, [
        onChange
    ]);
    // If propValue is provided than act as a controlled component
    // If not then act as an uncontrolled component using the value from state
    const value = typeof propValue !== 'undefined' ? propValue : selectedValue;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "radiogroup",
        "aria-labelledby": ariaLabelledBy,
        "data-testid": testId,
        "aria-describedby": isInvalid ? `${id || uid}-error` : undefined,
        id: id || uid,
        children: options.map(({ ...optionProps }, index)=>{
            if (typeof isDisabled !== 'undefined') optionProps.isDisabled = isDisabled;
            const isChecked = value !== null && optionProps.value === value;
            return /*#__PURE__*/ (0, $5uXOq.createElement)((0, $jouoW.default), {
                ...optionProps,
                name: name || optionProps.name,
                key: index,
                onChange: onRadioChange,
                onInvalid: onInvalid,
                isInvalid: isChecked && isInvalid,
                isChecked: isChecked,
                testId: optionProps.testId || testId,
                isRequired: isRequired,
                analyticsContext: analyticsContext
            });
        })
    });
}

});

parcelRegister("lSZAF", function(module, exports) {

$parcel$export(module.exports, "messages", () => $181320bce18912a8$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $181320bce18912a8$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        "id": "backlog.modals.select-transitions-modal.title",
        "defaultMessage": "Choose a transition"
    },
    description: {
        "id": "backlog.modals.select-transitions-modal.description",
        "defaultMessage": "Choose one of {count} available transitions for issue {cardKeys}"
    },
    cancel: {
        "id": "backlog.modals.select-transitions-modal.cancel",
        "defaultMessage": "Cancel"
    },
    choose: {
        "id": "backlog.modals.select-transitions-modal.choose",
        "defaultMessage": "Choose"
    },
    descriptionIssueTermRefresh: {
        "id": "backlog.modals.select-transitions-modal.description-issue-term-refresh",
        "defaultMessage": "Choose one of {count} available transitions for work item {cardKeys}"
    }
});

});


parcelRegister("fLCrV", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ff77b69424f86f6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gUikp = parcelRequire("gUikp");

var $10Ngv = parcelRequire("10Ngv");

var $f01qr = parcelRequire("f01qr");


var $i4Z8q = parcelRequire("i4Z8q");

var $3lZ6i = parcelRequire("3lZ6i");

var $hf5c2 = parcelRequire("hf5c2");

var $5Eoed = parcelRequire("5Eoed");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $45Qwd = parcelRequire("45Qwd");

var $fmuR9 = parcelRequire("fmuR9");

var $fC5rN = parcelRequire("fC5rN");

var $k35me = parcelRequire("k35me");

var $k4laV = parcelRequire("k4laV");
const $6ff77b69424f86f6$var$useSplitIssueState = (cardId)=>{
    const isSprintsEnabled = (0, $c1MAf.useBacklogSelector)((0, $k35me.isBacklogWithSprints));
    const card = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.getCards)(state)[cardId]);
    const cardListId = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.makeGetCardListIdByCardId)(state)(cardId));
    const isCardListActiveSprint = (0, $c1MAf.useBacklogSelector)((state)=>(0, $k35me.makeIsCardListActiveSprint)(state)(String(cardListId)));
    const serviceContext = (0, $c1MAf.useBacklogSelector)((state)=>(0, $i4Z8q.makeServiceContext)(state));
    const cardLists = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCardLists));
    const cardListData = (0, $c1MAf.useBacklogSelector)((state)=>Object.values(cardLists).map(({ id: id, name: name })=>({
                id: id,
                name: name,
                type: (0, $dGljH.makeGetCardListAnalyticsTypeById)(state)(id),
                isActive: (0, $k35me.makeIsCardListActiveSprint)(state)(id)
            })), (0, $f01qr.isObjectArrayEqual));
    const estimationFieldId = (0, $c1MAf.useBacklogSelector)((0, $45Qwd.getEstimationFieldId));
    const estimationType = (0, $c1MAf.useBacklogSelector)((0, $45Qwd.getEstimationType));
    const timeTrackingOptions = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getTimeTrackingOptions));
    const timeTrackingConfig = (0, $k4laV.timeTrackingConfigTransformer)(timeTrackingOptions);
    return {
        card: card,
        originalIssueDestinationId: cardListId,
        cardLists: cardListData,
        estimationFieldId: estimationFieldId,
        estimationType: estimationType,
        isCardListActiveSprint: isCardListActiveSprint,
        isSprintsEnabled: isSprintsEnabled,
        timeTrackingConfig: timeTrackingConfig,
        isCompanyManaged: serviceContext.isCompanyManaged
    };
};
const $6ff77b69424f86f6$export$10af25b190c591c7 = ()=>{
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const issueParents = (0, $c1MAf.useBacklogSelector)((0, $fmuR9.issueParentsSelector));
    const storeFieldsActions = (0, $10Ngv.useStoreFields)({
        issueParents: issueParents
    });
    const onClose = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $5Eoed.closeModal)());
    }, [
        dispatch
    ]);
    const onSplitIssue = (0, $5uXOq.useCallback)((originalIssue, newSplitIssues)=>{
        const newSplitIssueKeys = newSplitIssues?.map((issue)=>issue?.key ?? '');
        dispatch((0, $3lZ6i.loadAppData)({
            storeFieldsActions: storeFieldsActions
        }));
        dispatch((0, $hf5c2.splitIssueCreate)(originalIssue.key, newSplitIssueKeys, originalIssue.issueTypeName));
        dispatch((0, $5Eoed.closeModal)());
    }, [
        dispatch,
        storeFieldsActions
    ]);
    return {
        onClose: onClose,
        onSplitIssue: onSplitIssue
    };
};
const $6ff77b69424f86f6$var$SplitIssueModalView = ({ cardId: cardId })=>{
    const state = $6ff77b69424f86f6$var$useSplitIssueState(cardId);
    const actions = $6ff77b69424f86f6$export$10af25b190c591c7();
    const props = {
        ...state,
        ...actions
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gUikp.default), props);
};
const $6ff77b69424f86f6$var$SplitIssueModalContainer = ()=>{
    const modalData = (0, $c1MAf.useBacklogSelector)((0, $fC5rN.getOpenModalData));
    if (modalData?.type !== (0, $b107c54ec82f76f2$export$77e94846ed2f57d7)) return null;
    const { cardId: cardId } = modalData.payload;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6ff77b69424f86f6$var$SplitIssueModalView, {
        cardId: cardId
    });
};
var $6ff77b69424f86f6$export$2e2bcd8739ae039 = $6ff77b69424f86f6$var$SplitIssueModalContainer;

});
parcelRegister("gUikp", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9c7cb770f484586$export$2e2bcd8739ae039);
/**
 * This async file lives here since it needs to access the generated query, and stricter only allows one level of imports in UI
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $dXq4S = parcelRequire("dXq4S");

var $cg5z5 = parcelRequire("cg5z5");

var $9OXo1 = parcelRequire("9OXo1");

var $kxZPA = parcelRequire("kxZPA");

var $bmKPg = parcelRequire("bmKPg");

var $dnjeJ = parcelRequire("dnjeJ");

var $ilUQh = parcelRequire("ilUQh");

var $9qoqd = parcelRequire("9qoqd");

var $8h8Xu = parcelRequire("8h8Xu");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $e9c7cb770f484586$var$LazySplitIssueModal = (0, $kxZPA.lazy)(()=>(parcelRequire("5WPSE")), {
    moduleId: "./src/packages/software/backlog-split-issue/src/ui/split-issue-modal/index.tsx"
});
const $e9c7cb770f484586$export$5f61d6092ee768bc = (props)=>{
    const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const [boardId = null] = (0, $bmKPg.usePathParam)('boardId');
    const [onViewExperienceStart, onViewExperienceSuccess, onViewExperienceFail] = (0, $8h8Xu.useExperienceTracker)((0, $ilUQh.EXPERIENCES).viewApp, (0, $ilUQh.SOURCE_NAME));
    (0, $dnjeJ.useUFOComponentExperience)((0, $9qoqd.initialLoadSplitIssueModalExperience));
    const [queryReference, loadQuery] = (0, $8Uumt.useQueryLoader)((0, $cg5z5.default));
    const boardARI = (0, $dXq4S.createAri)({
        resourceOwner: 'jira-software',
        cloudId: cloudId,
        resourceType: 'board',
        resourceId: String(boardId)
    });
    const cardARI = (0, $dXq4S.createAri)({
        resourceOwner: 'jira-software',
        cloudId: cloudId,
        resourceType: 'card',
        resourceId: String(props.card.id)
    });
    const onError = (0, $5uXOq.useCallback)((location, error, errorAttributes)=>{
        onViewExperienceFail(location, error, errorAttributes);
        (0, $9qoqd.initialLoadSplitIssueModalExperience).failure();
    }, [
        onViewExperienceFail
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            (0, $9qoqd.initialLoadSplitIssueModalExperience).abort();
        }, []);
    (0, $5uXOq.useEffect)(()=>{
        loadQuery({
            boardId: boardARI,
            cardId: cardARI
        }, {
            fetchPolicy: 'store-or-network'
        });
        onViewExperienceStart();
    }, [
        boardARI,
        cardARI,
        loadQuery,
        onViewExperienceStart
    ]);
    return queryReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: (0, $ilUQh.APP_IDENTIFIER),
        packageName: (0, $ilUQh.PACKAGE_NAME),
        fallback: "flag",
        teamName: "a4t-pandora",
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jira-software-backlog-split-issue-ui",
        fallback: "Loading..."
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e9c7cb770f484586$var$LazySplitIssueModal, {
        queryReference: queryReference,
        ...props,
        onLoadSuccess: onViewExperienceSuccess
    }))) : null;
};
var $e9c7cb770f484586$export$2e2bcd8739ae039 = $e9c7cb770f484586$export$5f61d6092ee768bc;

});
parcelRegister("cg5z5", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ac8a84a70044601$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<900b80199afc9efa03c01e67aea1e3e8>>
 * @relayHash cfcfb33cef7d4219a6d3f24984f7bcb0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 32db338fa9736886f416e43946a8e0a64a7b66d85da678268e01a687db02bc1d
const $3ac8a84a70044601$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cardId"
        }
    ], v1 = {
        "args": [
            {
                "kind": "Variable",
                "name": "boardId",
                "variableName": "boardId"
            },
            {
                "kind": "Variable",
                "name": "cardId",
                "variableName": "cardId"
            }
        ],
        "kind": "ScalarField",
        "name": "canSplitIssue"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "splitIssueModalQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": v1 /*: any*/ ,
                    "action": "THROW",
                    "path": "canSplitIssue"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "splitIssueModalQuery",
            "selections": [
                v1 /*: any*/ 
            ]
        },
        "params": {
            "id": "32db338fa9736886f416e43946a8e0a64a7b66d85da678268e01a687db02bc1d",
            "metadata": {},
            "name": "splitIssueModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3ac8a84a70044601$var$node.hash = "9c5280b41e46526652e1eaef4fc47ef2";
var $3ac8a84a70044601$export$2e2bcd8739ae039 = $3ac8a84a70044601$var$node;

});

parcelRegister("dnjeJ", function(module, exports) {

$parcel$export(module.exports, "useUFOComponentExperience", () => $44448c24118cb590$export$30ab340faaed55d4);

var $5uXOq = parcelRequire("5uXOq");
const $44448c24118cb590$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $5uXOq.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $44448c24118cb590$export$30ab340faaed55d4 = (experience)=>{
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            experience.abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $44448c24118cb590$var$useConstructor(()=>experience.start());
    return null;
};

});

parcelRegister("ilUQh", function(module, exports) {

$parcel$export(module.exports, "PERMISSION_ERROR_FLAG_ID", () => $c45ff6ef6fc3070f$export$6066d6393ad0b789);
$parcel$export(module.exports, "ERROR_FLAG_ID", () => $c45ff6ef6fc3070f$export$f5e4c120ac01b615);
$parcel$export(module.exports, "ISSUE_COUNT", () => $c45ff6ef6fc3070f$export$8775696968c9b13c);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE", () => $c45ff6ef6fc3070f$export$bfb354504bb547a0);
$parcel$export(module.exports, "STORY_POINTS", () => $c45ff6ef6fc3070f$export$405b6d72f2d243a9);
$parcel$export(module.exports, "APP_IDENTIFIER", () => $c45ff6ef6fc3070f$export$2cea7f14750b8c19);
$parcel$export(module.exports, "PACKAGE_NAME", () => $c45ff6ef6fc3070f$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "SOURCE_NAME", () => $c45ff6ef6fc3070f$export$a3821bc63538b210);
$parcel$export(module.exports, "MUTATION_FAILURE", () => $c45ff6ef6fc3070f$export$178c5c429f396aa0);
$parcel$export(module.exports, "EXPERIENCES", () => $c45ff6ef6fc3070f$export$a2008ed3b02411a3);
$parcel$export(module.exports, "SUMMARY_CHAR_LIMIT", () => $c45ff6ef6fc3070f$export$5ff63ab521d3d56c);
$parcel$export(module.exports, "SPLIT_ISSUE_INPUT", () => $c45ff6ef6fc3070f$export$5fd76d6bc878265a);

var $7HGHK = parcelRequire("7HGHK");
const $c45ff6ef6fc3070f$export$6066d6393ad0b789 = (0, $7HGHK.toFlagId)('permission-error-flag');
const $c45ff6ef6fc3070f$export$f5e4c120ac01b615 = (0, $7HGHK.toFlagId)('error-flag');
const $c45ff6ef6fc3070f$export$8775696968c9b13c = 'ISSUE_COUNT';
const $c45ff6ef6fc3070f$export$bfb354504bb547a0 = 'ORIGINAL_ESTIMATE';
const $c45ff6ef6fc3070f$export$405b6d72f2d243a9 = 'STORY_POINTS';
const $c45ff6ef6fc3070f$export$2cea7f14750b8c19 = 'backlog-split-issue';
const $c45ff6ef6fc3070f$export$b8b9d90f9e5bd72b = 'jira-software-backlog-split-issue';
const $c45ff6ef6fc3070f$export$a3821bc63538b210 = 'SplitIssue';
const $c45ff6ef6fc3070f$export$178c5c429f396aa0 = 'mutation failed';
const $c45ff6ef6fc3070f$export$a2008ed3b02411a3 = {
    viewApp: 'viewSplitIssueModal',
    saveApp: 'saveSplitIssue'
};
const $c45ff6ef6fc3070f$export$5ff63ab521d3d56c = 255;
const $c45ff6ef6fc3070f$export$5fd76d6bc878265a = 'split-issue-modal.summary.split-issue-input';

});

parcelRegister("9qoqd", function(module, exports) {

$parcel$export(module.exports, "initialLoadSplitIssueModalExperience", () => $3e5d7a2dd8409315$export$c85e655fc9a5ae13);
$parcel$export(module.exports, "saveSplitIssuesExperience", () => $3e5d7a2dd8409315$export$82dfb3a19169f7bb);

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
const $3e5d7a2dd8409315$export$c85e655fc9a5ae13 = new (0, $duUGa.UFOExperience)('split-issue-modal-load', {
    type: (0, $atdLB.ExperienceTypes).Operation,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageLoad
});
const $3e5d7a2dd8409315$export$82dfb3a19169f7bb = new (0, $duUGa.UFOExperience)('split-issue-save', {
    type: (0, $atdLB.ExperienceTypes).Operation,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("8h8Xu", function(module, exports) {

$parcel$export(module.exports, "useExperienceTracker", () => $17dff8ba77e51a1f$export$cdefb2a8b53f879f);

var $7Jxgt = parcelRequire("7Jxgt");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $4R6GH = parcelRequire("4R6GH");

var $efvDm = parcelRequire("efvDm");

var $9OXo1 = parcelRequire("9OXo1");
const $17dff8ba77e51a1f$export$cdefb2a8b53f879f = (experience, analyticsSource)=>{
    const { appEditions: appEditions } = (0, $9OXo1.useTenantContext)();
    const onExperienceStart = (0, $kaHBi.useExperienceStart)({
        experienceId: (0, $7Jxgt.v4)(),
        experience: experience,
        analyticsSource: analyticsSource,
        edition: appEditions.software,
        application: (0, $efvDm.JIRA_SOFTWARE)
    });
    const onExperienceSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: experience,
        attributes: {
            synthetic: (0, $4R6GH.fg)('is_synthetic_tenant')
        }
    });
    const onExperienceFail = (0, $93jKl.useExperienceFail)({
        experience: experience,
        attributes: {
            synthetic: (0, $4R6GH.fg)('is_synthetic_tenant')
        }
    });
    return [
        onExperienceStart,
        onExperienceSuccess,
        onExperienceFail
    ];
};

});

parcelRegister("5WPSE", function(module, exports) {

let $454a9ceda82ecc57$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $454a9ceda82ecc57$var$load("76n7a"),
    $454a9ceda82ecc57$var$load("l253H"),
    $454a9ceda82ecc57$var$load("5e4Ww")
]).then(()=>parcelRequire('9BoBM'));

});




parcelRegister("9HRx0", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfe8944a06d65b50$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4MFiN = parcelRequire("4MFiN");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bfe8944a06d65b50$export$2e2bcd8739ae039 = ()=>{
    const issueIds = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.getCardIds)(state).map((cardId)=>String(cardId)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4MFiN.default), {
        issueIds: issueIds
    });
};

});
parcelRegister("4MFiN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8c7654d7458abfb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iINXJ = parcelRequire("iINXJ");
function $d8c7654d7458abfb$var$PrefetchClientOnly(props) {
    if (false) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iINXJ.Prefetch), props);
}
var $d8c7654d7458abfb$export$2e2bcd8739ae039 = $d8c7654d7458abfb$var$PrefetchClientOnly;

});
parcelRegister("iINXJ", function(module, exports) {

$parcel$export(module.exports, "Prefetch", () => $29ba10d1bace2883$export$a92e3edabc61a974);

var $5uXOq = parcelRequire("5uXOq");

var $l53am = parcelRequire("l53am");
// eslint-disable-next-line jira/react/no-class-components
class $29ba10d1bace2883$var$Prefetch extends (0, $5uXOq.Component) {
    constructor(props){
        super(props);
        this.fetchIssues(props.issueIds, props.issueKeys);
    }
    componentDidUpdate({ issueIds: prevIssueIds, issueKeys: prevIssueKeys }) {
        const { issueIds: issueIds, issueKeys: issueKeys } = this.props;
        if (prevIssueIds !== issueIds) {
            const newIds = issueIds.filter((issueId)=>{
                const isTemporaryId = Number(issueId) < 0;
                return !prevIssueIds.includes(issueId) && !isTemporaryId;
            });
            this.fetchIssues(newIds);
        }
        if (issueKeys && prevIssueKeys && prevIssueKeys !== issueKeys) this.fetchIssues([], issueKeys);
    }
    fetchIssues(issueIds, issueKeys) {
        if (issueIds.length > 0) this.props.dataProvider.loadIssuesById(issueIds.map((id)=>String(id)));
        if (issueKeys && issueKeys.length > 0) this.props.dataProvider.loadIssues(issueKeys);
    }
    render() {
        return null;
    }
}
// @ts-expect-error - TS2559 - Type 'Props' has no properties in common with type '{ readonly dataProvider?: DataProvider | undefined; }'.
const $29ba10d1bace2883$export$a92e3edabc61a974 = (0, $l53am.WithDataProvider)($29ba10d1bace2883$var$Prefetch);

});
parcelRegister("l53am", function(module, exports) {

$parcel$export(module.exports, "WithDataProvider", () => $02b95a9a182f987c$export$b0017632f1661e1);

var $5uXOq = parcelRequire("5uXOq");

var $3H1wD = parcelRequire("3H1wD");
const $02b95a9a182f987c$export$b0017632f1661e1 = (WrappedComponent)=>// @ts-expect-error - TS2322 - Type '(props: TProps) => JSX.Element' is not assignable to type 'AbstractComponent<TProps, any>'.
    (props)=>{
        const { dataProvider: dataProvider, ...otherProps } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3H1wD.DataProviderContext).Consumer, null, (contextDataProvider)=>// @ts-expect-error - TS2322 - Type 'Omit<TProps, "dataProvider"> & { dataProvider: DataProvider; }' is not assignable to type 'IntrinsicAttributes & PropsWithoutRef<TProps & OwnProps> & RefAttributes<any> & { children?: ReactNode; }'.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...otherProps,
                dataProvider: dataProvider || contextDataProvider()
            }));
    };

});
parcelRegister("3H1wD", function(module, exports) {

$parcel$export(module.exports, "DataProviderContext", () => $0843efd524aaa43a$export$5bce75db3a3f66c4);

var $5uXOq = parcelRequire("5uXOq");

var $7353r = parcelRequire("7353r");
const $0843efd524aaa43a$export$5bce75db3a3f66c4 = /*#__PURE__*/ (0, $5uXOq.createContext)((0, $7353r.getDataProvider));

});
parcelRegister("7353r", function(module, exports) {

$parcel$export(module.exports, "getDataProvider", () => $cd2cb3c904264bdf$export$add6bf8e4261fead);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");

var $g5X3G = parcelRequire("g5X3G");

var $aS73q = parcelRequire("aS73q");
const $cd2cb3c904264bdf$export$33c5e0ba77bb7d8 = ()=>{
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const clearCache = ()=>{};
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const insertSerializedIssue = ()=>{};
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const loadIssues = ()=>{};
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const loadIssuesById = ()=>{};
    // @ts-expect-error - TS2355 - A function whose declared type is neither 'void' nor 'any' must return a value.
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const getIssue = ()=>{};
    const loadIssue$ = ()=>(0, $kVLXA.Observable).empty();
    const getIssue$ = ()=>(0, $kVLXA.Observable).empty();
    const refreshIssue$ = ()=>loadIssue$();
    const getIssueRemoteData$ = (issueKey, cloudId)=>(0, $aS73q.fetchIssueRemoteDataWithWhiteboards$)((0, $g5X3G.toIssueKey)(issueKey), (0, $g5X3G.toCloudId)(cloudId));
    const getIssueWhiteboardData$ = (issueId, cloudId)=>(0, $aS73q.fetchIssueWhiteboards$)(issueId, cloudId);
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const updateIssue = ()=>{};
    const getMetrics = ()=>({
            cacheSize: 0,
            cacheStaleCount: 0,
            cacheAvailableCapacity: 0,
            cacheHit: false,
            staleCacheHit: false
        });
    return {
        clearCache: clearCache,
        loadIssues: loadIssues,
        loadIssuesById: loadIssuesById,
        getIssue: getIssue,
        getIssue$: getIssue$,
        getIssueWhiteboardData$: getIssueWhiteboardData$,
        getIssueRemoteData$: getIssueRemoteData$,
        refreshIssue$: refreshIssue$,
        updateIssue: updateIssue,
        getMetrics: getMetrics,
        insertSerializedIssue: insertSerializedIssue
    };
};
// store it as a singleton
let $cd2cb3c904264bdf$var$dataProvider;
const $cd2cb3c904264bdf$export$add6bf8e4261fead = ()=>{
    if ($cd2cb3c904264bdf$var$dataProvider == null) $cd2cb3c904264bdf$var$dataProvider = $cd2cb3c904264bdf$export$33c5e0ba77bb7d8();
    return $cd2cb3c904264bdf$var$dataProvider;
};

});
parcelRegister("aS73q", function(module, exports) {

$parcel$export(module.exports, "fetchIssueRemoteDataWithWhiteboards$", () => $f482d3f0ea8f2add$export$3aec720cf88c26cd);
$parcel$export(module.exports, "fetchIssueWhiteboards$", () => $f482d3f0ea8f2add$export$63f6bfd48e6bea07);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("d0pqD");
parcelRequire("1oQta");
parcelRequire("c66Ur");
parcelRequire("6hSeW");

var $aq199 = parcelRequire("aq199");

var $e6C7w = parcelRequire("e6C7w");

var $4cJXk = parcelRequire("4cJXk");

var $cVFxd = parcelRequire("cVFxd");

var $jEfnV = parcelRequire("jEfnV");

var $1bLFJ = parcelRequire("1bLFJ");

var $6r7fT = parcelRequire("6r7fT");

var $g5X3G = parcelRequire("g5X3G");

var $hcsJY = parcelRequire("hcsJY");

var $fb243 = parcelRequire("fb243");

const $f482d3f0ea8f2add$var$LOG_LOCATION = 'issue.data-provider.source.issue-express';
const $f482d3f0ea8f2add$var$getIssueKeyFromResponse = (response)=>{
    // @ts-expect-error - TS2339 - Property 'fields' does not exist on type 'ViewIssue | ViewIssueRemoteData'.
    const fields = response.fields || [];
    const issueKeyField = fields.find(// @ts-expect-error - TS7006 - Parameter 'field' implicitly has an 'any' type.
    (field)=>field.__typename === $a620d3896f16afcc$export$40bed7a29c3b629);
    if (!issueKeyField) throw new Error('Issue key field missing in graphql response');
    return (0, $g5X3G.toIssueKey)(issueKeyField.stringValue);
};
const $f482d3f0ea8f2add$var$transformGraphQlIssueRemoteData = (response, issueKey)=>{
    if (!response) return null;
    const key = issueKey || $f482d3f0ea8f2add$var$getIssueKeyFromResponse(response);
    const now = new Date();
    const { issueId: issueId, remoteLinks: remoteLinks } = response;
    return (0, $hcsJY.createIssue)({
        key: key
    }).withMeta({
        newIssueViewLockedIn: response.meta ? response.meta.newIssueViewLockedIn : false,
        dataSource: 'issueExpress',
        fetchTime: now
    }).withId(issueId).withRemoteLinks(remoteLinks).build();
};
const $f482d3f0ea8f2add$var$transformConfluenceWhiteboardData = (response)=>{
    const issueToWhiteboard = response?.graphStore?.issueToWhiteboard ?? {};
    const whiteboards = issueToWhiteboard.edges?.map(({ node: node })=>({
            whiteboardId: node.whiteboardId,
            author: {
                ...node.author
            },
            href: `${node.links?.base}${node.links?.webUi}`,
            type: (0, $1bLFJ.CONFLUENCE_WHITEBOARD),
            id: node.id,
            title: node.title
        }));
    return {
        confluenceWhiteboards: {
            linkedWhiteboards: {
                whiteboardCount: issueToWhiteboard.totalCount,
                whiteboards: whiteboards
            }
        }
    };
};
const $f482d3f0ea8f2add$export$83220ed1a595568a = (baseUrl, issueKey)=>// @ts-expect-error - TS2322 - Type 'Observable<IssueRemoteData | null>' is not assignable to type 'Observable<IssueRemoteData>'.
    (0, $fb243.fetchIssueRemoteData)(baseUrl, issueKey).map((graphQlIssue)=>$f482d3f0ea8f2add$var$transformGraphQlIssueRemoteData(graphQlIssue, issueKey)).filter(Boolean).catch((err)=>{
        (0, $6r7fT.trackOrLogClientError)($f482d3f0ea8f2add$var$LOG_LOCATION, 'fetchIssueRemoteData: Failed to fetch issue remote data from gira', err);
        return (0, $kVLXA.Observable).empty();
    });
const $f482d3f0ea8f2add$export$3aec720cf88c26cd = (issueKey, cloudId)=>// @ts-expect-error - TS2322 - Type 'Observable<IssueRemoteData | null>' is not assignable to type 'Observable<IssueRemoteData>'.
    (0, $fb243.fetchIssueRemoteData)('', issueKey).pipe((0, $jEfnV.switchMap)((remoteDataResponse)=>(0, $fb243.fetchIssueConfluenceWhiteboardData)(remoteDataResponse.issueId, cloudId).pipe((0, $cVFxd.map)((confluenceWhiteboardDataResponse)=>{
            const confluenceWhiteboards = $f482d3f0ea8f2add$var$transformConfluenceWhiteboardData(confluenceWhiteboardDataResponse);
            const combinedRemoteData = {
                ...remoteDataResponse,
                remoteLinks: {
                    ...remoteDataResponse.remoteLinks,
                    ...confluenceWhiteboards
                }
            };
            return combinedRemoteData;
        }), (0, $cVFxd.map)((graphQlIssue)=>$f482d3f0ea8f2add$var$transformGraphQlIssueRemoteData(graphQlIssue, issueKey)), (0, $4cJXk.filter)(Boolean), (0, $e6C7w.catchError)((err)=>{
            (0, $6r7fT.trackOrLogClientError)($f482d3f0ea8f2add$var$LOG_LOCATION, 'fetchIssueConfluenceWhiteboardData: Failed to fetch confluence whiteboards from AGG', err);
            return (0, $aq199.of)($f482d3f0ea8f2add$var$transformGraphQlIssueRemoteData(remoteDataResponse, issueKey));
        }))), (0, $e6C7w.catchError)((err)=>{
        (0, $6r7fT.trackOrLogClientError)($f482d3f0ea8f2add$var$LOG_LOCATION, 'fetchIssueRemoteData: Failed to fetch issue remote data from gira', err);
        return (0, $kVLXA.Observable).empty();
    }));
const $f482d3f0ea8f2add$export$63f6bfd48e6bea07 = (issueId, cloudId)=>// @ts-expect-error - TS2322 - Type 'Observable<IssueRemoteData | null>' is not assignable to type 'Observable<IssueRemoteData>'.
    (0, $fb243.fetchIssueConfluenceWhiteboardData)(issueId, cloudId).pipe((0, $cVFxd.map)((confluenceWhiteboardDataResponse)=>$f482d3f0ea8f2add$var$transformConfluenceWhiteboardData(confluenceWhiteboardDataResponse).confluenceWhiteboards), (0, $4cJXk.filter)(Boolean), (0, $e6C7w.catchError)((err)=>{
        (0, $6r7fT.trackOrLogClientError)($f482d3f0ea8f2add$var$LOG_LOCATION, 'fetchIssueConfluenceWhiteboardData: Failed to fetch confluence whiteboards from AGG', err);
        return (0, $kVLXA.Observable).empty();
    }));

});
parcelRegister("1bLFJ", function(module, exports) {

$parcel$export(module.exports, "CONFLUENCE_BLOGPOST", () => $0864033b77341257$export$b0807d3d613e535);
$parcel$export(module.exports, "CONFLUENCE_PAGE", () => $0864033b77341257$export$353109fb558251b1);
$parcel$export(module.exports, "CONFLUENCE_WHITEBOARD", () => $0864033b77341257$export$489cb2e515fef0c4);
$parcel$export(module.exports, "toConfluencePageType", () => $0864033b77341257$export$a7ae1ae0a3d7d205);
const $0864033b77341257$export$b0807d3d613e535 = 'blogpost';
const $0864033b77341257$export$353109fb558251b1 = 'page';
const $0864033b77341257$export$489cb2e515fef0c4 = 'whiteboard';
const $0864033b77341257$export$a7ae1ae0a3d7d205 = (type)=>type === $0864033b77341257$export$b0807d3d613e535 ? $0864033b77341257$export$b0807d3d613e535 : $0864033b77341257$export$353109fb558251b1;

});

parcelRegister("6r7fT", function(module, exports) {

$parcel$export(module.exports, "trackOrLogClientError", () => $cdae82c8a9c247d5$export$2fc29872103bf255);
$parcel$export(module.exports, "isAbortableError", () => $cdae82c8a9c247d5$export$e05e0fb17c2ab75a);

var $2YZCu = parcelRequire("2YZCu");

var $jcw0u = parcelRequire("jcw0u");

var $fZneA = parcelRequire("fZneA");

var $3vXOY = parcelRequire("3vXOY");

var $jJZqs = parcelRequire("jJZqs");
const $cdae82c8a9c247d5$export$c392d6295c0a29c7 = (location, message, error)=>{
    (0, $jcw0u.default)({
        error: error,
        attributes: {
            message: message
        },
        meta: {
            id: location,
            packageName: 'jiraIssueViewCommonUtils'
        }
    });
};
const $cdae82c8a9c247d5$export$2fc29872103bf255 = (location, message, error)=>{
    if (error instanceof TypeError && (0, $fZneA.isClientFetchError)(error)) $cdae82c8a9c247d5$export$c392d6295c0a29c7(location, message, error);
    else (0, $2YZCu.default).safeErrorWithoutCustomerData(location, message, error);
};
const $cdae82c8a9c247d5$export$e05e0fb17c2ab75a = (error)=>{
    const statusCode = (0, $3vXOY.extractStatusCode)(error);
    if ((0, $fZneA.isHttpClientErrorResponse)(error) || !statusCode && (0, $fZneA.isClientFetchError)(error) || error?.name === (0, $jJZqs.VALIDATION_ERROR_NAME)) return true;
    return false;
};

});

parcelRegister("hcsJY", function(module, exports) {

$parcel$export(module.exports, "createIssue", () => $b09eba4e8be21e93$export$b61347e00e271b8e);
class $b09eba4e8be21e93$var$IssueBuilder {
    constructor({ key: key }){
        this.key = key;
        this.fields = new Map();
    }
    withMeta(meta) {
        this.meta = meta;
        return this;
    }
    // go/jfe-eslint
    withId(id) {
        this.id = id;
        return this;
    }
    // go/jfe-eslint
    withFields(fields) {
        fields.forEach(this.withField, this);
        return this;
    }
    // go/jfe-eslint
    withField(field) {
        if (field) this.fields.set(String(field.key), field);
        return this;
    }
    // go/jfe-eslint
    withRemoteLinks(remoteLinks) {
        this.remoteLinks = remoteLinks;
        return this;
    }
    // go/jfe-eslint
    withPreferences(myPreferences) {
        this.myPreferences = myPreferences;
        return this;
    }
    // go/jfe-eslint
    withComments(commentsData) {
        this.commentsData = commentsData;
        return this;
    }
    // go/jfe-eslint
    withWorkflow(workflow) {
        this.workflow = workflow;
        return this;
    }
    // go/jfe-eslint
    withActivitySortOrder(activitySortOrder) {
        this.activitySortOrder = activitySortOrder;
        return this;
    }
    build() {
        const meta = this.meta !== null && this.meta !== undefined ? this.meta : {
            dataSource: 'unknown',
            newIssueViewLockedIn: false,
            fetchTime: new Date()
        };
        const remoteLinks = this.remoteLinks !== null && this.remoteLinks !== undefined ? this.remoteLinks : {
            confluencePages: {
                linkedPages: {
                    pageCount: 0
                },
                mentionedPages: {
                    pageCount: 0
                }
            },
            confluenceWhiteboards: {
                linkedWhiteboards: {
                    whiteboardCount: 0
                }
            },
            webLinks: {
                linkCount: 0
            },
            remoteLinkedIssues: []
        };
        const myPreferences = this.myPreferences !== null && this.myPreferences !== undefined ? this.myPreferences : {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let users = {};
        let comments = {
            totalCount: 0,
            startIndex: 0,
            comments: {}
        };
        if (this.commentsData !== null && this.commentsData !== undefined) {
            comments = {
                totalCount: this.commentsData.totalCount,
                // @ts-expect-error - TS2322 - Type 'number | undefined' is not assignable to type 'number'.
                startIndex: this.commentsData.startIndex,
                comments: this.commentsData.comments
            };
            users = this.commentsData.users;
        }
        const workflow = this.workflow !== null && this.workflow !== undefined ? this.workflow : undefined;
        const activitySortOrder = this.activitySortOrder;
        const issue = {
            key: this.key,
            fields: this.fields,
            meta: meta,
            remoteLinks: remoteLinks,
            myPreferences: myPreferences,
            comments: comments,
            users: users,
            workflow: workflow,
            activitySortOrder: activitySortOrder,
            ...this.id !== null && this.id !== undefined ? {
                id: this.id
            } : undefined
        };
        return issue;
    }
}
const $b09eba4e8be21e93$export$b61347e00e271b8e = ({ key: key })=>new $b09eba4e8be21e93$var$IssueBuilder({
        key: key
    });

});

parcelRegister("fb243", function(module, exports) {

$parcel$export(module.exports, "fetchIssueRemoteData", () => $0c2e88a5dd27b6f5$export$619c3be06a997564);
$parcel$export(module.exports, "fetchIssueConfluenceWhiteboardData", () => $0c2e88a5dd27b6f5$export$886e1cd5d478fbe5);
parcelRequire("fp4O3");
parcelRequire("3q49N");
parcelRequire("d0pqD");
parcelRequire("fPS7b");

var $487fd = parcelRequire("487fd");

var $fqpdr = parcelRequire("fqpdr");

var $dvijh = parcelRequire("dvijh");

var $fKtck = parcelRequire("fKtck");

var $POnYB = parcelRequire("POnYB");

var $gxWw1 = parcelRequire("gxWw1");

var $gmIuw = parcelRequire("gmIuw");
const $0c2e88a5dd27b6f5$var$NUM_INITIAL_COMMENTS_TO_LOAD = 5;
const $0c2e88a5dd27b6f5$var$CREATED_ORDER_DESCENDING = '-created';
const $0c2e88a5dd27b6f5$var$commentParameter = ()=>{
    const { hasPermalink: hasPermalink, permalinkId: permalinkId } = (0, $fKtck.getPermalinkStatus)((0, $dvijh.COMMENTS));
    return hasPermalink ? `, commentId: ${permalinkId}` : '';
};
const $0c2e88a5dd27b6f5$var$LOG_LOCATION = 'issue.data-provider.source.issue-express.graphql';
const $0c2e88a5dd27b6f5$var$VIEW_ISSUE_ALIAS = 'bentoViewIssue';
const $0c2e88a5dd27b6f5$var$addQueryForRemoteLinks = ()=>`remoteLinks {
       isLinkingEnabled
       confluencePages {
         linkedPages {
            pageCount
         }
         mentionedPages {
            pageCount
         }
       }
     }`;
const $0c2e88a5dd27b6f5$var$getCommentsQuery = ()=>{
    const commentAmountParameter = `, commentAmount: ${Math.floor($0c2e88a5dd27b6f5$var$NUM_INITIAL_COMMENTS_TO_LOAD / 2)}`;
    const orderByParameter = `, orderBy: "${$0c2e88a5dd27b6f5$var$CREATED_ORDER_DESCENDING}"`;
    const query = `comments (first: 0, maxResults: ${$0c2e88a5dd27b6f5$var$NUM_INITIAL_COMMENTS_TO_LOAD}${orderByParameter}, isPreview: true ${$0c2e88a5dd27b6f5$var$commentParameter()}${commentAmountParameter}) {
            nodes{
              id
              author {
                  accountId
                  displayName
                  avatarUrl
              }
              updateAuthor {
                  accountId
                  displayName
                  avatarUrl
              }
              visibility {
                  type
                  value
              }
              created
              updated
              jsdPublic
              bodyAdf
              jsdAuthorCanSeeRequest
            }
            totalCount
            startIndex
          }
        `;
    return query;
};
const $0c2e88a5dd27b6f5$export$895cf5b64d42d88d = ()=>`
        issueId
        fields {
            __typename

            ... on ProjectField {
                fieldKey
                type
                simplified
                name
            }

            ... on TextField {
                fieldKey
                title
                isEditable
                textValue
                adf
                renderer
            }

            ... on IssueTypeField {
              fieldKey
              id
              iconUrl
              name
            }

            ... on StatusField {
              fieldKey
              name
              statusCategoryId
            }

            ... on IssueKeyField {
              fieldKey
              stringValue
            }

            ... on PriorityField {
              fieldKey
              title
              isEditable
              iconUrl
              name
              id
            }

            ... on UserField {
              fieldKey
              title
              isEditable
              userValue {
                displayName
                avatarUrl
                accountId
              }
            }

            ... on VersionsField {
              fieldKey
              title
              isEditable
              versions {
                id
                name
              }
            }

            ... on LabelsField {
              fieldKey
              title
              isEditable
              labels
            }

            ... on ProjectComponentsField {
              fieldKey
              title
              isEditable
              componentValues {
                id
                name
              }
            }

            ... on TimeTrackingField {
              fieldKey
              title
              isEditable
              originalEstimate {
                estimateSeconds
              }
              remainingEstimate {
                estimateSeconds
              }
              timeSpent {
                estimateSeconds
              }
            }

            ... on StoryPointsField {
              fieldKey
              title
              isEditable
              floatValue
            }

            ... on EpicLinkField {
              fieldKey
              title
              isEditable
              epic {
                id
                key
                name
                summary
                colorKey
                done
              }
            }

            ... on EpicNameField {
              fieldKey
              stringValue
              title
              isEditable
            }

            ... on EpicStatusField {
              fieldKey
              title
              isEditable
              selectedValue {
                  optionId
                  value
              }
            }

            ... on SprintCustomField {
              fieldKey
              title
              isEditable
              values {
                id
                name
                goal
                state
                boardId
                startDate
                endDate
                completeDate
              }
            }

            ... on SelectCustomField {
              fieldKey
              title
              isEditable
              selectedValue {
                  optionId
                  value
              }
            }

            ... on CascadingSelectCustomField {
              fieldKey
              title
              isEditable
              selectedValue {
                  optionId
                  value
                  child {
                    optionId
                    value
                  }
              }
            }

            ... on UserPickerCustomField {
              fieldKey
              title
              isEditable
              selectedUser {
                displayName
                avatarUrl
              }
            }

            ... on TextAreaCustomField {
              fieldKey
              title
              isEditable
              wiki
              adf
              renderer
              textValue
            }

            ... on FloatCustomField {
              fieldKey
              title
              isEditable
              floatValue
            }

            ... on DatePickerCustomField {
              fieldKey
              title
              isEditable
              stringValue
            }

            ... on DateTimeCustomField {
              fieldKey
              title
              isEditable
              dateTime
            }

            ... on TextFieldCustomField {
              fieldKey
              title
              isEditable
              wiki
            }

            ... on MultiSelectCustomField {
              fieldKey
              title
              isEditable
              selectedValues {
                  optionId
                  value
              }
            }

            ... on LabelsCustomField {
              fieldKey
              title
              isEditable
              labels
            }

            ... on MultiUserPickerCustomField {
              fieldKey
              title
              isEditable
              selectedUsers {
                accountId
                displayName
                avatarUrl
              }
            }

            ... on UrlCustomField {
              fieldKey
              title
              isEditable
              url
            }

            ... on VersionCustomField {
              fieldKey
              title
              isEditable
              version {
                  id
                  name
              }
            }

            ... on GroupPickerCustomField {
              fieldKey
              title
              isEditable
              group
            }

            ... on MultiVersionCustomField {
              fieldKey
              title
              isEditable
              versions {
                  id
                  name
              }
            }

            ... on MultiGroupPickerCustomField {
              fieldKey
              title
              isEditable
              groups
            }

            ... on DateField {
              fieldKey
              stringValue
              isEditable
              title
            }

            ... on CheckBoxesCustomField {
                fieldKey
                isEditable
                title
                selectedValues {
                    optionId
                    value
                }
            }

            ... on RadioButtonsCustomField {
                fieldKey
                isEditable
                title
                selectedValue {
                    optionId
                    value
                }
            }

            ... on ColorField {
                fieldKey
                isEditable
                title
                stringValue
            }

            ... on EpicColorField {
                fieldKey
                isEditable
                title
                stringValue
            }

            ... on ResolutionField {
                id
                fieldKey
                name
            }

            ... on FlaggedCustomField {
                fieldKey
                title
                isFlagged
                isEditable
                selectedValues {
                    optionId
                    value
                }
            }

            ... on ProjectCustomField {
              fieldKey
              key
              name
              title
              avatarUrl
              isEditable
            }
        }
        ${$0c2e88a5dd27b6f5$var$addQueryForRemoteLinks()}
        ${$0c2e88a5dd27b6f5$var$getCommentsQuery()}
    `;
const $0c2e88a5dd27b6f5$var$getQueryPrefix = ()=>'_all';
const $0c2e88a5dd27b6f5$var$getFieldPinningPreference = (projectKey)=>projectKey != null ? `"jira.user.issue.details.pinned-fields.${projectKey}",` : '';
const $0c2e88a5dd27b6f5$var$getQueryForMyPreferences = (projectKey)=>`
    myPreferences(keys: [
        "jira.user.issue.changeboarding.lastinteracted",
        "jira.user.issue.clickthrough-banner.lastinteracted",
        "jira.user.issue.pinned-fields-banner.lastinteracted",
        ${$0c2e88a5dd27b6f5$var$getFieldPinningPreference(projectKey)}
    ])`;
const $0c2e88a5dd27b6f5$var$getProjectQueryFragment = (projectKey)=>`
    project(projectKey: "${projectKey}") {
        newIssueViewLockedIn
    }
`;
const $0c2e88a5dd27b6f5$export$71eec30d9db46a56 = (projectKey)=>`query issueViewQuery($issueKey: String!) {
    ${$0c2e88a5dd27b6f5$var$getQueryForMyPreferences(projectKey)}
    ${projectKey !== undefined ? $0c2e88a5dd27b6f5$var$getProjectQueryFragment(projectKey) : ''}
    ${$0c2e88a5dd27b6f5$var$VIEW_ISSUE_ALIAS}${$0c2e88a5dd27b6f5$var$getQueryPrefix()}: viewIssue(issueKey: $issueKey) {
        ${$0c2e88a5dd27b6f5$export$895cf5b64d42d88d()}
    }
    activitySortOrder
}
`;
const $0c2e88a5dd27b6f5$var$getFieldDataOptions = (query, variables)=>({
        method: 'POST',
        body: JSON.stringify({
            query: query,
            variables: variables
        }),
        perf: (0, $POnYB.fetchIssueExpressPerf)
    });
const $0c2e88a5dd27b6f5$export$619c3be06a997564 = (baseUrl, issueKey)=>(0, $487fd.default)((0, $fqpdr.getGiraUrl)(baseUrl, 'issueViewRemoteDataQuery'), $0c2e88a5dd27b6f5$var$getFieldDataOptions((0, $gxWw1.getIssueRemoteDataQuery)(), {
        issueKey: issueKey
    }))// @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'GraphqlResponse<ViewIssueGraphqlResponse | ViewMultipleIssueGraphqlResponse>'.
    .map((response)=>(0, $gmIuw.getGraphQlData)($0c2e88a5dd27b6f5$var$LOG_LOCATION, response))// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type '`bentoViewIssue${string}`' can't be used to index type 'ViewIssueGraphqlResponse | ViewMultipleIssueGraphqlResponse'.
    .map((value)=>value[`${$0c2e88a5dd27b6f5$var$VIEW_ISSUE_ALIAS}${(0, $gxWw1.getRemoteDataQueryPrefix)()}`]);
const $0c2e88a5dd27b6f5$export$886e1cd5d478fbe5 = (issueId, cloudId)=>(0, $487fd.default)('/gateway/api/graphql?operation=issueViewRemoteConfluenceWhiteboardQuery', $0c2e88a5dd27b6f5$var$getFieldDataOptions((0, $gxWw1.getIssueRemoteConfluenceWhiteboardQuery)(), {
        id: `ari:cloud:jira:${cloudId}:issue/${issueId}`
    })).map((response)=>(0, $gmIuw.getGraphQlData)($0c2e88a5dd27b6f5$var$LOG_LOCATION, response));

});
parcelRegister("fqpdr", function(module, exports) {

$parcel$export(module.exports, "ISSUE_VIEW_INTERACTIVE_QUERY", () => $3789cf83eed10ddd$export$1780a132c0453fee);
$parcel$export(module.exports, "getGiraUrl", () => $3789cf83eed10ddd$export$aefb19023b2eda55);
$parcel$export(module.exports, "getJiraQueryEcosystemFirstSeenOnIssueView", () => $3789cf83eed10ddd$export$79eba9bf6dc9960d);
$parcel$export(module.exports, "buildIssueQuery", () => $3789cf83eed10ddd$export$222ae9aca08830f0);
$parcel$export(module.exports, "getGiraRequestOptions", () => $3789cf83eed10ddd$export$e1542dc7ff749de8);
/**
 * ╔═══════════════╗
 * ║ !!IMPORTANT!! ║
 * ╚═══════════════╝
 * Please do not use statsig feature gating in this file.
 * Read https://hello.atlassian.net/wiki/spaces/JIE/pages/2858513117/Blockers+for+Statsig+in+the+issue-view
 * for why and to follow the fix.
 */ 
var $96nmc = parcelRequire("96nmc");

var $EJMEI = parcelRequire("EJMEI");

var $8TkIN = parcelRequire("8TkIN");

var $e2Vt6 = parcelRequire("e2Vt6");

var $92ECu = parcelRequire("92ECu");

var $6QL4r = parcelRequire("6QL4r");

var $5Pqa3 = parcelRequire("5Pqa3");

var $b1RJj = parcelRequire("b1RJj");

var $1HCMp = parcelRequire("1HCMp");

var $8JI9I = parcelRequire("8JI9I");

var $kNriQ = parcelRequire("kNriQ");

var $cRP2d = parcelRequire("cRP2d");
const $3789cf83eed10ddd$var$CREATED_ORDER_DESCENDING = '-created';
const $3789cf83eed10ddd$export$1780a132c0453fee = 'issueViewInteractiveQuery';
const $3789cf83eed10ddd$export$aefb19023b2eda55 = (_baseUrl, operation)=>`/rest/gira/1/${(0, $96nmc.appendOperationQuery)(operation)}`;
// JIV-19906: retrieve query string from URL -- only expected to be used by client side code
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $3789cf83eed10ddd$var$getURLFromWindow = ()=>new URL(window.location.href);
const $3789cf83eed10ddd$var$viewIssueQuery = (url = $3789cf83eed10ddd$var$getURLFromWindow())=>`
    viewIssue(issueKey: $issueKey) {
        canCreateSubTask
        canExportIssue
        ${/**
					 * THIS QUERY ONLY FETCHES TOTAL COUNT OF COMMENTS
					 * For all other comment related data, use AGG endpoints
					 * Note: When activity sorting feature is enabled, we do not
					 * want to fetch with sort order passed through; we should defer
					 * to the saved sort order in the backend to return the correct
					 * sort order
					 */ (0, $EJMEI.default)({
        maxResults: (0, $92ECu.NUM_INITIAL_COMMENTS_TO_LOAD),
        startAt: 0,
        orderBy: $3789cf83eed10ddd$var$CREATED_ORDER_DESCENDING,
        commentAmount: Math.floor((0, $92ECu.NUM_INITIAL_COMMENTS_TO_LOAD)),
        url: url
    })}
        ${/**
					 * Note: When activity sorting feature is enabled, we do not
					 * want to fetch with sort order passed through; we should defer
					 * to the saved sort order in the backend to return the correct
					 * sort order
					 */ (0, $cRP2d.default)({
        startAt: 0,
        worklogAmount: Math.floor((0, $92ECu.NUM_INITIAL_WORKLOGS_TO_LOAD)),
        url: url
    })}
        ${(0, $e2Vt6.getEcosystemQuery)()}
        ${(0, $8TkIN.getContentPanelsQuery)()}
        ${(0, $e2Vt6.getLegacyRightWebPanelsQuery)()}
        totalAttachmentsCount
        ${(0, $5Pqa3.getContainersByTypeQuery)()}
        ${(0, $kNriQ.getRemoteLinksQuery)()}
    }
`;
const $3789cf83eed10ddd$export$79eba9bf6dc9960d = ()=>`
    jira {
        ecosystemFirstSeenOnIssueView
    }
`;
const $3789cf83eed10ddd$export$58eaa2ae4a5a410a = ()=>`
    jira {
        ecosystemFirstSeenOnIssueView
        hasAdministerPermission: hasGlobalPermission(key: ADMINISTER)
        hasUserPickerPermission: hasGlobalPermission(key: USER_PICKER)
    }
`;
const $3789cf83eed10ddd$export$222ae9aca08830f0 = (url)=>`
query ${$3789cf83eed10ddd$export$1780a132c0453fee}($issueKey: String!, $projectKey: String)  {
        ${$3789cf83eed10ddd$export$58eaa2ae4a5a410a()}
        ${(0, $b1RJj.default)()}
        ${$3789cf83eed10ddd$var$viewIssueQuery(url)}
        ${(0, $6QL4r.getJiraSettingsQuery)()}
        ${(0, $1HCMp.default)()}
        ${(0, $8JI9I.default)()}
    }

`;
const $3789cf83eed10ddd$export$e1542dc7ff749de8 = (issueKey, projectKey, url)=>{
    const payload = {
        operationName: $3789cf83eed10ddd$export$1780a132c0453fee,
        query: $3789cf83eed10ddd$export$222ae9aca08830f0(url),
        variables: {
            issueKey: issueKey,
            projectKey: projectKey
        }
    };
    return {
        method: 'POST',
        body: JSON.stringify(payload)
    };
};

});
parcelRegister("EJMEI", function(module, exports) {

$parcel$export(module.exports, "default", () => $01ae9b8d951a6992$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");

var $6tI1D = parcelRequire("6tI1D");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$01ae9b8d951a6992$export$2e2bcd8739ae039 = ({ maxResults: maxResults, startAt: startAt, orderBy: orderBy, commentAmount: commentAmount, url: url })=>{
    const commentPermalinkId = url && (0, $4R6GH.fg)('jiv-19906-fix-targered-permalink-on-server') ? (0, $6tI1D.getPermalinkIdFromURL)((0, $6tI1D.COMMENTS), url) : (0, $6tI1D.getPermalinkId)((0, $6tI1D.COMMENTS));
    const orderByParameter = orderBy !== null && orderBy !== undefined ? `, orderBy: "${orderBy}"` : '';
    const commentParameter = commentPermalinkId !== null && commentPermalinkId !== undefined ? `, commentId: ${commentPermalinkId}` : '';
    const commentAmountParameter = commentParameter !== '' && commentAmount !== null && commentAmount !== undefined ? `, commentAmount: ${commentAmount}` : '';
    const maxResultsParameter = commentParameter === '' && maxResults !== null && maxResults !== undefined ? `, maxResults: ${maxResults}` : '';
    return `
        comments (first: ${startAt}${maxResultsParameter}${orderByParameter}${commentParameter}${commentAmountParameter}) {
            totalCount
        }
    `;
};

});
parcelRegister("6tI1D", function(module, exports) {

$parcel$export(module.exports, "PermalinkType", () => $ac458c74e4b12b29$export$b18d061fc042df1a);
$parcel$export(module.exports, "COMMENTS", () => $ac458c74e4b12b29$export$4cab9dfa8fc858f4);
$parcel$export(module.exports, "WORKLOG", () => $ac458c74e4b12b29$export$df36fc05622c402);
$parcel$export(module.exports, "getAllUrlParams", () => $ac458c74e4b12b29$export$dca91ad250f6b082);
$parcel$export(module.exports, "getPermalinkId", () => $ac458c74e4b12b29$export$bf42dbba4c31080e);
$parcel$export(module.exports, "getPermalinkIdFromURL", () => $ac458c74e4b12b29$export$87557f913748dcff);

var $gKZoD = parcelRequire("gKZoD");

var $2YZCu = parcelRequire("2YZCu");
const $ac458c74e4b12b29$export$b18d061fc042df1a = {
    COMMENTS: 'focusedCommentId',
    WORKLOG: 'focusedWorklogId'
};
const $ac458c74e4b12b29$export$4cab9dfa8fc858f4 = 'COMMENTS';
const $ac458c74e4b12b29$export$df36fc05622c402 = 'WORKLOG';
/**
 * @deprecated this function is unsafe for using on server side code due to `window` object usage
 */ const $ac458c74e4b12b29$export$dca91ad250f6b082 = ()=>{
    (0, $gKZoD.di)(window);
    // get query string from  window
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    let queryString = window.location.search.slice(1);
    // we'll store the parameters here
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const obj = {};
    // if query string exists
    if (queryString) {
        // stuff after # is not part of query string, so get rid of it
        queryString = queryString.split('#')[0];
        // split our query string into its component parts
        const arr = queryString.split('&');
        for(let i = 0; i < arr.length; i += 1){
            // separate the keys and the values
            const a = arr[i].split('=');
            // set parameter name and value (use 'true' if empty)
            const paramName = a[0];
            try {
                const paramValue = typeof a[1] === 'undefined' ? true : decodeURIComponent(a[1]);
                obj[paramName] = paramValue;
            } catch (error) {
                (0, $2YZCu.default).safeErrorWithoutCustomerData('getAllUrlParams', `Malformed value was obtained from the query string for ${paramName}`);
            }
        }
    }
    return obj;
};
const $ac458c74e4b12b29$export$bf42dbba4c31080e = (targetPermalinkType)=>{
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly COMMENTS: "focusedCommentId"; readonly WORKLOG: "focusedWorklogId"; }'.
    if (!$ac458c74e4b12b29$export$b18d061fc042df1a[targetPermalinkType]) return null;
    const urlParams = $ac458c74e4b12b29$export$dca91ad250f6b082();
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly COMMENTS: "focusedCommentId"; readonly WORKLOG: "focusedWorklogId"; }'.
    return urlParams[$ac458c74e4b12b29$export$b18d061fc042df1a[targetPermalinkType]];
};
const $ac458c74e4b12b29$export$87557f913748dcff = (targetPermalinkType, url)=>{
    const queryParamKey = $ac458c74e4b12b29$export$b18d061fc042df1a[targetPermalinkType];
    if (!queryParamKey) return null;
    return url.searchParams.get(queryParamKey);
};

});


parcelRegister("8TkIN", function(module, exports) {

$parcel$export(module.exports, "getContentPanelsQuery", () => $09fdc8c72c341092$export$e6f14eac549b679d);
const $09fdc8c72c341092$var$getContentPanelNode = ()=>`
    name
    addonKey
    moduleKey
    options
    iconUrl
    tooltip
    type
    isShownByDefault
    wasManuallyAddedToIssue
`;
const $09fdc8c72c341092$var$getContentPanelsConnectionQuery = ()=>`
    contentPanels {
        edges {
            node {
                ${$09fdc8c72c341092$var$getContentPanelNode()}
            }
        }
    }
`;
const $09fdc8c72c341092$var$getLegacyContentPanelsConnectionQuery = ()=>`
    legacyContentPanels {
        edges {
            node {
                ${$09fdc8c72c341092$var$getContentPanelNode()}
            }
        }
    }
`;
const $09fdc8c72c341092$export$e6f14eac549b679d = ()=>`
    ${$09fdc8c72c341092$var$getContentPanelsConnectionQuery()}
    ${$09fdc8c72c341092$var$getLegacyContentPanelsConnectionQuery()}
    hasCustomisedContentPanels
`;

});

parcelRegister("e2Vt6", function(module, exports) {

$parcel$export(module.exports, "getEcosystemQuery", () => $1771eed42c62eeca$export$edefef8c65e08bd2);
$parcel$export(module.exports, "getLegacyRightWebPanelsQuery", () => $1771eed42c62eeca$export$92c9a3dc7076af51);
const $1771eed42c62eeca$var$getForgeQuery = ()=>`forge {
        panels {
          id
          instances {
            id
            collapsed
            added
          }
        }
      }`;
const $1771eed42c62eeca$export$edefef8c65e08bd2 = ()=>`
    ecosystem {
      activityPanels {
        name
        iframe {
          addonKey
          moduleKey
          options
        }
      }
      contextPanels {
        name
        iframe {
          addonKey
          moduleKey
          options
        }
        icon {
          url
        }
        content
        status
        type
      }
      ${$1771eed42c62eeca$var$getForgeQuery()}
    }
`;
const $1771eed42c62eeca$export$92c9a3dc7076af51 = ()=>`
        legacyRightWebPanels {
          edges {
            node {
              name
              status
              addonKey
              moduleKey
              options
              content
            }
          }
        }
      `;

});

parcelRegister("92ECu", function(module, exports) {

$parcel$export(module.exports, "NUM_INITIAL_COMMENTS_TO_LOAD", () => $9387aa2a419a55f9$export$c46d621c29194aa4);
$parcel$export(module.exports, "NUM_INITIAL_WORKLOGS_TO_LOAD", () => $9387aa2a419a55f9$export$b2e398ce246f55b3);
$parcel$export(module.exports, "gqlTagGira", () => $9387aa2a419a55f9$export$aeae6fc40846cf9f);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports














const $9387aa2a419a55f9$export$c46d621c29194aa4 = 5;
const $9387aa2a419a55f9$export$304a6c004edb30d8 = '-created';
const $9387aa2a419a55f9$export$b2e398ce246f55b3 = 5;
const $9387aa2a419a55f9$export$1c36ecc9afd61c73 = '-started';
const $9387aa2a419a55f9$export$aeae6fc40846cf9f = (literals, ...substitutions)=>{
    let result = '';
    // run the loop only for the substitution count
    substitutions.forEach((key, i)=>{
        result += literals[i];
        result += key.toString();
    });
    // add the last literal
    result += literals[literals.length - 1];
    return result;
};

});

parcelRegister("6QL4r", function(module, exports) {

$parcel$export(module.exports, "getJiraSettingsQuery", () => $10470e592ba8e782$export$191f50c0f86b85ec);
const $10470e592ba8e782$export$e302502f14e3f203 = ()=>`
          timeTracking {
            isTimeTrackingEnabled
            hoursPerDay
            daysPerWeek
            defaultUnit
            format
          }
    `;
const $10470e592ba8e782$export$65e7d3d1915962da = ()=>`
          subtasks {
            enabled
          }
    `;
const $10470e592ba8e782$export$191f50c0f86b85ec = ()=>`
    jiraSettings {
      newIssueViewTransitionSettings {
        shouldDelayChangeboarding
        newIssueViewTransitionLockingStatus
     }
    }
`;

});

parcelRegister("5Pqa3", function(module, exports) {

$parcel$export(module.exports, "getContainersByTypeQuery", () => $85e2f5a62f1697d1$export$63131b2831854cc);

var $e5wyW = parcelRequire("e5wyW");

var $4R6GH = parcelRequire("4R6GH");
const $85e2f5a62f1697d1$export$e30f32dd3fd26efd = ()=>`
containersByType(input:{systemContainerTypes: [CONTENT, PRIMARY, SECONDARY, REQUEST_PORTAL], supportDefaultTab: true}) {
__typename
... on JiraIssueItemContainers {
containers {
  containerType
  items {
    nodes {
      type: __typename
      ... on JiraIssueItemFieldItem {
        fieldItemId        
      }
      ... on JiraIssueItemPanelItem {
        panelItemId
      }
      ... on JiraIssueItemTabContainer {
        name
        tabContainerId              
        items {
          nodes {
            type: __typename
            ... on JiraIssueItemFieldItem {
              fieldItemId
            }
          }
        }
      }
    }
  }
}
}
}
`;
const $85e2f5a62f1697d1$export$842411c0b98baa9c = ()=>`
containersByType(input:{systemContainerTypes: [CONTENT, PRIMARY, SECONDARY, REQUEST_PORTAL, CUSTOMER_CONTEXT], supportDefaultTab: true}) {
__typename
... on JiraIssueItemContainers {
containers {
  containerType
  items {
    nodes {
      type: __typename
      ... on JiraIssueItemFieldItem {
        fieldItemId        
      }
      ... on JiraIssueItemPanelItem {
        panelItemId
      }
      ... on JiraIssueItemTabContainer {
        name
        tabContainerId              
        items {
          nodes {
            type: __typename
            ... on JiraIssueItemFieldItem {
              fieldItemId
            }
          }
        }
      }
    }
  }
}
}
}
`;
const $85e2f5a62f1697d1$export$63131b2831854cc = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('jcs_master_flag'), $85e2f5a62f1697d1$export$842411c0b98baa9c, $85e2f5a62f1697d1$export$e30f32dd3fd26efd);

});

parcelRegister("b1RJj", function(module, exports) {

$parcel$export(module.exports, "default", () => $42429f0fa15c54ae$export$2e2bcd8739ae039);

var $9wuCE = parcelRequire("9wuCE");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$42429f0fa15c54ae$export$2e2bcd8739ae039 = ()=>`mediaContext(issueKey: $issueKey) {
    userToken {
      token
      id
      issueId
      tokenDurationInMins
    }
    uploadToken {
      __typename
      ... on MediaUploadToken {
        endpointUrl
        token
        targetCollection
        tokenDurationInMins
        clientId
      }
      ... on FailedMediaUploadToken {
        error
      }
    }
    readToken(maxTokenLength: ${(0, $9wuCE.getMaxTokenLength)()}) {
      clientId
      endpointUrl
      tokensWithFiles {
        files {
          issueId
          attachmentId
          attachmentMediaApiId
        }
        token
      }
      tokenLifespanInSeconds
    }
  }`;

});
parcelRegister("9wuCE", function(module, exports) {

$parcel$export(module.exports, "getMaxTokenLength", () => $ebb491dcc11e8362$export$e40f2acaf1a50b00);
// Low enough such that it shouldn't cause problems for non-IE11 browsers, and high
// enough such that it shouldn't be encountered in practice very often.
const $ebb491dcc11e8362$var$nonIE11MaxTokenLength = 2 ** 16;
const $ebb491dcc11e8362$export$e40f2acaf1a50b00 = ()=>$ebb491dcc11e8362$var$nonIE11MaxTokenLength;

});


parcelRegister("1HCMp", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ea17df757c74c46$export$2e2bcd8739ae039);
// A list of all keys of permissions that this transformer supports.
const $0ea17df757c74c46$export$9fc40cb6f3529ef = ()=>[
        'ADMINISTER_PROJECTS',
        'ASSIGN_ISSUES',
        'EDIT_ISSUES',
        'SCHEDULE_ISSUES',
        'ADD_COMMENTS',
        'DELETE_ALL_COMMENTS',
        'DELETE_OWN_COMMENTS',
        'EDIT_ALL_COMMENTS',
        'EDIT_OWN_COMMENTS',
        'CREATE_ISSUES',
        'DELETE_ISSUES',
        'MOVE_ISSUES',
        'MODIFY_REPORTER',
        'CREATE_ATTACHMENTS',
        'DELETE_ALL_ATTACHMENTS',
        'DELETE_OWN_ATTACHMENTS',
        'WORK_ON_ISSUES',
        'ASSIGNABLE_USER',
        'LINK_ISSUES',
        'VIEW_VOTERS_AND_WATCHERS',
        'MANAGE_WATCHERS',
        'EDIT_ALL_WORKLOGS',
        'EDIT_OWN_WORKLOGS',
        'DELETE_ALL_WORKLOGS',
        'DELETE_OWN_WORKLOGS',
        'VIEW_DEV_TOOLS',
        'SERVICEDESK_AGENT',
        'RESOLVE_ISSUES',
        'CLONE_ISSUE',
        'ARCHIVE_ISSUES',
        'UNARCHIVE_ISSUES'
    ];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0ea17df757c74c46$export$2e2bcd8739ae039 = ()=>`

    permissions(issueKey:$issueKey, keys:["${$0ea17df757c74c46$export$9fc40cb6f3529ef().join('","')}"]) {
        key
        havePermission
    }
`;

});

parcelRegister("8JI9I", function(module, exports) {

$parcel$export(module.exports, "default", () => $2232e63ddd04bbb1$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $2232e63ddd04bbb1$export$2e2bcd8739ae039 = ()=>`
    project(projectKey: $projectKey) {
        id
        newIssueViewLockedIn
        issueTypes {
            id
            name
            iconUrl
            subtask
        }
    }
`;

});

parcelRegister("kNriQ", function(module, exports) {

$parcel$export(module.exports, "getRemoteLinksQuery", () => $e19ca26272d1dd4d$export$6bbc6b72b0b57f25);

var $4R6GH = parcelRequire("4R6GH");
const $e19ca26272d1dd4d$var$getRemoteLinkedIssuesPreviewFragment = ()=>`
    id
    issueId
    globalId
    href
    applicationType
    applicationName
    relationship
    title
`;
const $e19ca26272d1dd4d$var$getAssociatedIssueFragment = ()=>`
    issueId
    issueKey {
        stringValue
    }
    summary {
        textValue
    }
    status {
        statusCategoryId
        name
        statusId
    }
    priority {
        iconUrl
        name
    }
    issueType {
        iconUrl
        name
    }
    assignee {
        userValue
        {
            displayName
            avatarUrl
        }
    }
   isResolved
`;
const $e19ca26272d1dd4d$var$getRemoteLinkedIssuesDetailsFragment = ()=>`
    ... on AssociatedIssueWrapper {
        associatedIssue {
            ${$e19ca26272d1dd4d$var$getAssociatedIssueFragment()}
        }
    }
    ... on FailedRemoteIssue {
        error
        repairLink { href }
    }
`;
const $e19ca26272d1dd4d$var$getRemoteLinkedIssuesFragment = ()=>`
    remoteLinkedIssues {
        preview {
            ${$e19ca26272d1dd4d$var$getRemoteLinkedIssuesPreviewFragment()}
        }
        details {
            ${$e19ca26272d1dd4d$var$getRemoteLinkedIssuesDetailsFragment()}
        }
    }
`;
const $e19ca26272d1dd4d$var$getWebLinksFragment = ()=>`
    webLinks(allowThirdParties: true, orderBy: "-id") {
        linkCount
        links {
            id
            href
            linkText
            iconUrl
            summary
            resolved
            relationship
            applicationName
            applicationType
        }
    }
`;
const $e19ca26272d1dd4d$var$getRemoteLinksQueryNew = ()=>`
    remoteLinks {
        isLinkingEnabled
        confluencePages {
            linkedPages {
				pageCount
				pages {
					... on ConfluencePage {
						id
						globalId
						href
						title
						type
					}
					... on FailedRemoteLink {
						id
						error
						link {
							id
							globalId
							href
						}
						repairLink { href }
					}
				}
            }
        }
        ${$e19ca26272d1dd4d$var$getWebLinksFragment()}
        ${$e19ca26272d1dd4d$var$getRemoteLinkedIssuesFragment()}
    }
`;
const $e19ca26272d1dd4d$var$getRemoteLinksQueryOld = ()=>`
    remoteLinks {
        isLinkingEnabled
        remoteLinkedIssues {
            preview {
                id
                issueId
                globalId
                href
                applicationType
                applicationName
                relationship
                title
            }
        }
    }
`;
const $e19ca26272d1dd4d$export$6bbc6b72b0b57f25 = ()=>(0, $4R6GH.fg)('jiv-19125-fetch-remote-links-in-interactive-query') ? $e19ca26272d1dd4d$var$getRemoteLinksQueryNew() : $e19ca26272d1dd4d$var$getRemoteLinksQueryOld();

});

parcelRegister("cRP2d", function(module, exports) {

$parcel$export(module.exports, "default", () => $354b7c85b873ab44$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");

var $6tI1D = parcelRequire("6tI1D");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$354b7c85b873ab44$export$2e2bcd8739ae039 = ({ startAt: startAt, orderBy: orderBy, worklogAmount: worklogAmount, url: url })=>{
    const orderByParameter = orderBy !== null && orderBy !== undefined ? `, orderBy: "${orderBy}"` : '';
    const worklogPermalinkId = url && (0, $4R6GH.fg)('jiv-19906-fix-targered-permalink-on-server') ? (0, $6tI1D.getPermalinkIdFromURL)((0, $6tI1D.WORKLOG), url) : (0, $6tI1D.getPermalinkId)((0, $6tI1D.WORKLOG));
    if (worklogPermalinkId === null || worklogPermalinkId === undefined) return '';
    const worklogParameter = `, worklogId: ${worklogPermalinkId}`;
    const worklogAmountParameter = worklogAmount !== null && worklogAmount !== undefined ? `, worklogAmount: ${worklogAmount}` : '';
    return `
        worklogs (startAt: ${startAt}${orderByParameter}${worklogParameter}${worklogAmountParameter}) {
            nodes {
                id
                author {
                    accountId
                    displayName
                    avatarUrl
                }
                updateAuthor {
                    accountId
                    displayName
                    avatarUrl
                }
                created
                started
                updated
                comment
                timeSpent
                timeSpentSeconds
            }
            totalCount
            startIndex
        }
    `;
};

});


parcelRegister("dvijh", function(module, exports) {

$parcel$export(module.exports, "COMMENTS", () => $1403612d0fe1296c$export$4cab9dfa8fc858f4);
$parcel$export(module.exports, "WORKLOG", () => $1403612d0fe1296c$export$df36fc05622c402);
$parcel$export(module.exports, "PermalinkType", () => $1403612d0fe1296c$export$b18d061fc042df1a);
const $1403612d0fe1296c$export$4cab9dfa8fc858f4 = 'Comments';
const $1403612d0fe1296c$export$df36fc05622c402 = 'Worklog';
const $1403612d0fe1296c$export$b18d061fc042df1a = {
    COMMENTS: 'focusedCommentId',
    WORKLOG: 'focusedWorklogId'
};

});

parcelRegister("fKtck", function(module, exports) {

$parcel$export(module.exports, "getPermalinkTypeAndId", () => $11ab2af1eff70e7f$export$f72cac1fa8a03e80);
$parcel$export(module.exports, "getPermalinkStatus", () => $11ab2af1eff70e7f$export$f79ae8c396759c89);
$parcel$export(module.exports, "getUrlPermalinkParameter", () => $11ab2af1eff70e7f$export$b66f3e03c722c21c);
$parcel$export(module.exports, "PermalinkType", () => (parcelRequire("dvijh")).PermalinkType);

var $8QpSo = parcelRequire("8QpSo");

var $ebyGx = parcelRequire("ebyGx");

var $gKZoD = parcelRequire("gKZoD");

var $dvijh = parcelRequire("dvijh");
const $11ab2af1eff70e7f$export$58d3deae755361f = (0, $8QpSo.default)((searchString)=>{
    const params = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parseUrl(searchString).query;
    if (params[(0, $dvijh.PermalinkType).COMMENTS]) return {
        permalinkType: (0, $dvijh.COMMENTS),
        permalinkId: params[(0, $dvijh.PermalinkType).COMMENTS]
    };
    if (params[(0, $dvijh.PermalinkType).WORKLOG]) return {
        permalinkType: (0, $dvijh.WORKLOG),
        permalinkId: params[(0, $dvijh.PermalinkType).WORKLOG]
    };
    return null;
});
const $11ab2af1eff70e7f$export$f72cac1fa8a03e80 = ()=>{
    (0, $gKZoD.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return $11ab2af1eff70e7f$export$58d3deae755361f(window.location.search);
};
const $11ab2af1eff70e7f$export$f79ae8c396759c89 = (targetPermalinkType)=>{
    const { permalinkId: permalinkId, permalinkType: permalinkType } = $11ab2af1eff70e7f$export$f72cac1fa8a03e80() || {};
    const hasPermalink = permalinkType === targetPermalinkType && permalinkId != null;
    return {
        hasPermalink: hasPermalink,
        permalinkId: hasPermalink ? permalinkId : ''
    };
};
const $11ab2af1eff70e7f$export$b66f3e03c722c21c = (id, permalinkType)=>{
    (0, $gKZoD.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const pathName = window.location.pathname;
    let urlQueryParam = `?${permalinkType}=${id}`;
    // in backlogs/modal view, next-gen board view, or jsd queues view
    if (/\/jira\/software\/c\/projects\/[^/]*\/boards\/.*/.test(pathName) || /\/jira\/people\/.*\/boards\/.*/.test(pathName) || pathName === '/secure/RapidBoard.jspa' || pathName.startsWith('/jira/software/projects/') && pathName.split('/')[5] === 'boards' || pathName.startsWith('/jira/servicedesk/projects/') && pathName.split('/')[5] === 'queues') {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const url = new URL(window.location.href);
        // delete the opposite to avoid doubling up param in url
        url.searchParams.delete(permalinkType === (0, $dvijh.PermalinkType).WORKLOG ? (0, $dvijh.PermalinkType).COMMENTS : (0, $dvijh.PermalinkType).WORKLOG);
        url.searchParams.set(permalinkType, id);
        urlQueryParam = url.search;
    }
    return urlQueryParam;
};

});

parcelRegister("POnYB", function(module, exports) {

$parcel$export(module.exports, "fetchIssueExpressPerf", () => $a1e38295f63ccee3$export$9040f8aef1f66451);
const $a1e38295f63ccee3$var$ISSUE_DETAILS_ANALYTICS_PREFIX = 'ISSUE_DETAILS';
const $a1e38295f63ccee3$var$FETCH_ISSUE_EXPRESS_REQUEST = 'FETCH_ISSUE_EXPRESS';
const $a1e38295f63ccee3$export$9040f8aef1f66451 = {
    key: $a1e38295f63ccee3$var$FETCH_ISSUE_EXPRESS_REQUEST,
    prefix: $a1e38295f63ccee3$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};

});

parcelRegister("gxWw1", function(module, exports) {

$parcel$export(module.exports, "getRemoteDataQueryPrefix", () => $12e83d615b5da262$export$1a164444721ce2fb);
$parcel$export(module.exports, "getIssueRemoteDataQuery", () => $12e83d615b5da262$export$65f9808f978ee25);
$parcel$export(module.exports, "getIssueRemoteConfluenceWhiteboardQuery", () => $12e83d615b5da262$export$8ec691b48e552cf4);
const $12e83d615b5da262$var$VIEW_ISSUE_ALIAS = 'bentoViewIssue';
const $12e83d615b5da262$var$getUserQueryFragment = ()=>`
    user {
        key
        accountId
        emailAddress
        avatarUrl
        displayName
        active
    }
`;
const $12e83d615b5da262$var$getConfluencePagesQueryFragment = ()=>`
    pages {
        ... on ConfluencePage {
            id
            globalId
            href
            title
            type
            lastUpdatedContext {
                ${$12e83d615b5da262$var$getUserQueryFragment()}
            }
        }
        ... on FailedRemoteLink {
            id
            error
            link {
                id
                globalId
                href
            }
            repairLink { href }
        }
    }
`;
const $12e83d615b5da262$var$getConfluencePageGroupQueryFragment = ()=>`
    pageCount
    ${$12e83d615b5da262$var$getConfluencePagesQueryFragment()}
`;
const $12e83d615b5da262$var$getRemoteLinkedIssuesPreviewFragment = ()=>`
    id
    issueId
    globalId
    href
    applicationType
    applicationName
    relationship
    title
`;
const $12e83d615b5da262$var$getAssociatedIssueFragment = ()=>`
    issueId
    issueKey {
        stringValue
    }
    summary {
        textValue
    }
    status {
        statusCategoryId
        name
        statusId
    }
    priority {
        iconUrl
        name
    }
    issueType {
        iconUrl
        name
    }
    assignee {
        userValue
        {
            displayName
            avatarUrl
        }
    }
   isResolved
`;
const $12e83d615b5da262$var$getRemoteLinkedIssuesDetailsFragment = ()=>`
    ... on AssociatedIssueWrapper {
        associatedIssue {
            ${$12e83d615b5da262$var$getAssociatedIssueFragment()}
        }
    }
    ... on FailedRemoteIssue {
        error
        repairLink { href }
    }
`;
const $12e83d615b5da262$var$getRemoteLinkedIssuesFragment = ()=>`
    remoteLinkedIssues {
        preview {
            ${$12e83d615b5da262$var$getRemoteLinkedIssuesPreviewFragment()}
        }
        details {
            ${$12e83d615b5da262$var$getRemoteLinkedIssuesDetailsFragment()}
        }
    }
`;
const $12e83d615b5da262$export$761fd517f0dda983 = ()=>`
    webLinks(allowThirdParties: true, orderBy: "-id") {
        linkCount
        links {
            id
            href
            linkText
            iconUrl
            summary
            resolved
            relationship
            applicationName
            applicationType
        }
    }
`;
const $12e83d615b5da262$var$getRemoteDataQueryFragment = ()=>`
    issueId
    remoteLinks {
       isLinkingEnabled
       confluencePages {
            linkedPages {
                ${$12e83d615b5da262$var$getConfluencePageGroupQueryFragment()}
            }
            mentionedPages {
                ${$12e83d615b5da262$var$getConfluencePageGroupQueryFragment()}
            }
        }
        ${$12e83d615b5da262$export$761fd517f0dda983()}
        ${$12e83d615b5da262$var$getRemoteLinkedIssuesFragment()}
    }
`;
const $12e83d615b5da262$export$1a164444721ce2fb = ()=>'_remote_data';
const $12e83d615b5da262$export$65f9808f978ee25 = ()=>`
    query issueViewRemoteDataQuery($issueKey: String!) {
        ${$12e83d615b5da262$var$VIEW_ISSUE_ALIAS}${$12e83d615b5da262$export$1a164444721ce2fb()}: viewIssue(issueKey: $issueKey) {
            ${$12e83d615b5da262$var$getRemoteDataQueryFragment()}
        }
    }
`;
const $12e83d615b5da262$export$8ec691b48e552cf4 = ()=>`
    query issueViewRemoteConfluenceWhiteboardQuery($id: ID!) {
        graphStore @optIn(to: "GraphStore") {
            issueToWhiteboard (id: $id first: 900) @optIn(to: "GraphStoreIssueToWhiteboard") {
                edges {
                    node {
                        ... on ConfluenceWhiteboard {
                            id
                            links {
                                base
                                webUi
                            }
                            author {
                                user {
                                accountId
                                accountStatus
                                name
                                picture
                                }
                            }
                            title
                            whiteboardId
                        }
                    }
                }
                totalCount
            }
        }
    }
`;

});

parcelRegister("gmIuw", function(module, exports) {

$parcel$export(module.exports, "getGraphQlData", () => $cfd7686b41fd6499$export$b30cdd26702abb9d);
$parcel$export(module.exports, "checkEmptyResponse", () => $cfd7686b41fd6499$export$a0603b0ff181c30a);

var $2YZCu = parcelRequire("2YZCu");

var $jJZqs = parcelRequire("jJZqs");

var $g81XS = parcelRequire("g81XS");
const $cfd7686b41fd6499$export$b30cdd26702abb9d = (logLocation, graphQlResponse)=>{
    if (graphQlResponse.errors) {
        const firstError = graphQlResponse.errors[0];
        const validationError = new (0, $jJZqs.ValidationError)(firstError.message);
        (0, $2YZCu.default).safeErrorWithoutCustomerData(logLocation, 'getGraphQlData: Error present in GraphQL response', validationError);
        throw validationError;
    }
    return graphQlResponse.data;
};
const $cfd7686b41fd6499$var$emptyResponseText = 'Response is either not present or has no data.';
const $cfd7686b41fd6499$export$a0603b0ff181c30a = (response)=>{
    if (!response || !Object.prototype.hasOwnProperty.call(response, 'data')) throw new (0, $g81XS.NoDataError)($cfd7686b41fd6499$var$emptyResponseText);
    if (response.data === null) throw new (0, $g81XS.NoDataError)($cfd7686b41fd6499$var$emptyResponseText);
    return response;
};

});
parcelRegister("g81XS", function(module, exports) {

$parcel$export(module.exports, "NoDataError", () => $7410460e4f0e390b$export$5faf0a0592e30f56);
class $7410460e4f0e390b$export$5faf0a0592e30f56 extends Error {
}

});



const $a620d3896f16afcc$export$40bed7a29c3b629 = 'IssueKeyField';








parcelRegister("1UKUc", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3b3b6d5da541e81$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $k12ix = parcelRequire("k12ix");

var $jp5kW = parcelRequire("jp5kW");

var $5rqex = parcelRequire("5rqex");

var $9wkw7 = parcelRequire("9wkw7");


var $b0yad = parcelRequire("b0yad");

var $8hVbJ = parcelRequire("8hVbJ");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $fmuR9 = parcelRequire("fmuR9");

var $fSgHa = parcelRequire("fSgHa");

var $6MzeB = parcelRequire("6MzeB");
// Also fire BM3 metric.mark() for custom timings, on top of performance.mark() invocations
const $f3b3b6d5da541e81$var$SubmitApdexContainer = ({ isCacheHit: isCacheHit })=>{
    const issueNo = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.cardsSelector)(state).length);
    const epicsNo = (0, $c1MAf.useBacklogSelector)((state)=>(0, $fmuR9.issueParentIdsSelector)(state).length);
    const issueChildrenNo = (0, $c1MAf.useBacklogSelector)((0, $dGljH.numTotalIssueChildren));
    const cardListCounts = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCardListStats));
    const backlogSessionId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getSessionId));
    const boardId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getRapidViewId));
    const metric = (0, $6MzeB.usePerformanceMetric)();
    const isClassic = (0, $fSgHa.useIsCMPBacklog)();
    const extra = (0, $5uXOq.useMemo)(()=>({
            ...(0, $k12ix.getNormalisedPerformanceFFs)(),
            isCacheHit: isCacheHit,
            cacheInvalidationReasons: (0, $b0yad.getAndClearInvalidationReasons)((0, $8631d6ce464ccf2e$export$dedbdcc35e955187)).join(','),
            issueNo: issueNo,
            epicsNo: epicsNo,
            issueChildrenNo: issueChildrenNo,
            backlogSessionId: backlogSessionId,
            boardId: boardId,
            ...cardListCounts,
            isSentryEnabled: String(!(0, $jp5kW.default)('fe_platform_error_tracking_enabled_sentry')),
            isPrefetchIssueDataByRankEnabled: false,
            isUIF: true,
            isClassic: isClassic
        }), [
        isCacheHit,
        issueNo,
        epicsNo,
        issueChildrenNo,
        backlogSessionId,
        boardId,
        cardListCounts,
        isClassic
    ]);
    (0, $5uXOq.useEffect)(()=>{
        (0, $9wkw7.pushEarlyMarksToBrowserMetrics)(metric, {
            marks: {
                BACKLOG_FETCH_START: (0, $8hVbJ.JSW_CRITICAL_RESOURCE_START),
                'jira.fe.spa-prefetchApiReady': (0, $8hVbJ.JSW_CRITICAL_RESOURCE_END),
                USE_RESOURCE_START_MARK: (0, $8hVbJ.USE_RESOURCE_START),
                USE_RESOURCE_READY_MARK: (0, $8hVbJ.USE_RESOURCE_READY),
                'render:start': (0, $8hVbJ.RENDER_START),
                'render:end': (0, $8hVbJ.RENDER_END),
                'relay_resource_get_data:NEXTGEN_BACKLOG_RELAY:start': (0, $8hVbJ.CRITICAL_RELAY_RESOURCE_GET_DATA_START),
                'relay_resource_get_data:NEXTGEN_BACKLOG_RELAY:end': (0, $8hVbJ.CRITICAL_RELAY_RESOURCE_GET_DATA_END)
            }
        });
    }, [
        metric
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5rqex.default), {
        extra: extra,
        appName: "software-backlog",
        // @ts-expect-error - TS2322 - Type 'PageLoadMetric' is not assignable to type 'BM3Metric'.
        metric: metric
    });
};
var $f3b3b6d5da541e81$export$2e2bcd8739ae039 = $f3b3b6d5da541e81$var$SubmitApdexContainer;

});
parcelRegister("5rqex", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $ab527e70454bab7e$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $ab527e70454bab7e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $ab527e70454bab7e$export$9b3029ee6188a41f);

var $5uXOq = parcelRequire("5uXOq");

var $99gkn = parcelRequire("99gkn");

var $aOr3t = parcelRequire("aOr3t");

var $1u4q7 = parcelRequire("1u4q7");

var $1AZST = parcelRequire("1AZST");

var $6G6w0 = parcelRequire("6G6w0");

var $3wLoG = parcelRequire("3wLoG");

var $gtdbK = parcelRequire("gtdbK");

var $zbAs4 = parcelRequire("zbAs4");

var $3B7oW = parcelRequire("3B7oW");
const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $zbAs4.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $gtdbK.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $3B7oW.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $99gkn.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOr3t.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3wLoG.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $1u4q7.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6G6w0.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame
        }));
    }
}
const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("aOr3t", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $a3e67858f0c2f8da$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$d93d677ef2f33c5c);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $a3e67858f0c2f8da$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $5uXOq.useContext)((0, $1tcYS.default));
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    (0, $5uXOq.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $a3e67858f0c2f8da$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingsConfig);
        (0, $bFU4G.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("6G6w0", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $84d0d168ebb35c8a$export$575e93c0f9905999);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $21pfT = parcelRequire("21pfT");

var $x9xyg = parcelRequire("x9xyg");

var $7N30e = parcelRequire("7N30e");

var $4dRjY = parcelRequire("4dRjY");

var $2SVPM = parcelRequire("2SVPM");

var $6b6Tk = parcelRequire("6b6Tk");

const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) metric.stop({
        customData: customData,
        stopTime: stopTime
    });
    else metric.stop({
        customData: customData
    });
    if ((0, $6b6Tk.isAutomaticExposureCollectionEnabled)()) (0, $7N30e.stopLowPriorityEventDelay)();
};
class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $21pfT.browserMetrics).getPageLoadMetric()?.getData()?.start || 0;
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_END');
        (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                setTimeout(()=>{
                    $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                }, 500);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("3wLoG", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $bc9c50f4292c4530$export$d91154f099475c5);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1AZST = parcelRequire("1AZST");
class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $1AZST.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("gtdbK", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $9088c71f7c9189f4$export$bf239ac2bfb04967);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("zbAs4", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $30d390cd1767d57f$export$e63862cd888fe05a);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");

var $1AZST = parcelRequire("1AZST");
var $49z18 = parcelRequire("49z18");
async function $30d390cd1767d57f$export$e63862cd888fe05a() {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $1AZST.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $49z18.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("3B7oW", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $afa764d83f81f55e$export$f00f1e874ce869e9);

var $1u4q7 = parcelRequire("1u4q7");

var $y7eb2 = parcelRequire("y7eb2");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $y7eb2.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
            $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});


parcelRegister("9wkw7", function(module, exports) {

$parcel$export(module.exports, "pushEarlyMarksToBrowserMetrics", () => $18c0c41d8db3822c$export$b7c0f32f0c63e86b);
const $18c0c41d8db3822c$export$2f0748f9bcbd5ff0 = {
    'jira.fe-spa.software.early-preload:start': 'EARLY_FETCH_START',
    'jira.fe-spa.software.early-preload:end': 'EARLY_FETCH_END'
};
const $18c0c41d8db3822c$export$b7c0f32f0c63e86b = (metric, options)=>{
    const marks = {
        ...$18c0c41d8db3822c$export$2f0748f9bcbd5ff0,
        ...options?.marks ?? {}
    };
    Object.keys(marks).forEach((mark)=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const startTime = performance.getEntriesByName(mark)[0]?.startTime;
        if (startTime != null) metric.mark(marks[mark], startTime);
    });
};

});


parcelRegister("4MJfo", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d1ef070d9e6909a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $doZTA = parcelRequire("doZTA");

var $4mqko = parcelRequire("4mqko");

var $9g0YE = parcelRequire("9g0YE");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $7xwsz = parcelRequire("7xwsz");
const $0d1ef070d9e6909a$var$SyncWithRoutingContainer = ()=>{
    const lastSelectedCardId = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getLastSelectedCard));
    const setLastSelectedCardKeyAction = (0, $c1MAf.useBacklogActionCreator)((0, $4mqko.setLastSelectedCardKey));
    const setAllPanelsAction = (0, $c1MAf.useBacklogActionCreator)((0, $9g0YE.setAllPanels));
    const [{ action: action, location: location }] = (0, $doZTA.useRouter)();
    const isCompanyManaged = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
    const props = {
        lastSelectedCardId: lastSelectedCardId,
        setLastSelectedCardKey: setLastSelectedCardKeyAction,
        setAllPanels: setAllPanelsAction,
        action: action,
        location: location,
        isCompanyManaged: isCompanyManaged
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7xwsz.SyncWithRouting), props);
};
var $0d1ef070d9e6909a$export$2e2bcd8739ae039 = $0d1ef070d9e6909a$var$SyncWithRoutingContainer;

});
parcelRegister("7xwsz", function(module, exports) {

$parcel$export(module.exports, "SyncWithRouting", () => $afbd9af9da366f4c$export$6cfa8b91c03902d6);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

const $afbd9af9da366f4c$export$6cfa8b91c03902d6 = (props)=>{
    const { action: action, location: location, lastSelectedCardId: lastSelectedCardId, setLastSelectedCardKey: setLastSelectedCardKey, setAllPanels: setAllPanels, isCompanyManaged: isCompanyManaged = false } = props;
    const update = (0, $5uXOq.useCallback)(()=>{
        const { search: search } = location;
        const searchParams = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(search);
        if (!isCompanyManaged) setAllPanels();
        // Update Selected Card Key
        const selectedCardKeyFromParams = searchParams[0, $4f4a02cead13bb5a$export$3a0c4bc79274bbaa];
        if (!lastSelectedCardId && selectedCardKeyFromParams) setLastSelectedCardKey(selectedCardKeyFromParams);
    }, [
        location,
        lastSelectedCardId,
        setLastSelectedCardKey,
        setAllPanels,
        isCompanyManaged
    ]);
    const isMounted = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (!isMounted.current) {
            update();
            isMounted.current = true;
        }
    }, [
        update,
        isMounted
    ]);
    const loc = (0, $5uXOq.useRef)(location);
    (0, $5uXOq.useEffect)(()=>{
        if (action === 'POP' && loc.current !== location) update();
        loc.current = location;
    }, [
        action,
        location,
        update
    ]);
    return null;
};

});





const $25c2ea87c2b04bf9$export$b05303cbde3e8c8c = 'CARD';
const $25c2ea87c2b04bf9$export$57d0ef745f304b91 = 'COLUMN';
const $25c2ea87c2b04bf9$export$2927f4d423091b16 = 'TRANSITION_ZONE';


//# sourceMappingURL=backlog.c2f05ad4.js.map
